/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(923);
	module.exports = __webpack_require__(961);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1003);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(854)();
	}


/***/ },
/* 4 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(846)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(430);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(34);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(72));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 8 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
		if (mix) {
			if (typeof mix === 'object') {
				if (!!mix.push) {
					for (k=0; k < mix.length; k++) {
						if (mix[k] && (y = toVal(mix[k]))) {
							str && (str += ' ');
							str += y;
						}
					}
				} else {
					for (k in mix) {
						if (mix[k] && (y = toVal(k))) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else if (typeof mix !== 'boolean' && !mix.call) {
				str && (str += ' ');
				str += mix;
			}
		}
		return str;
	}
	
	module.exports = function () {
		var i=0, x, str='';
		while (i < arguments.length) {
			if (x = toVal(arguments[i++])) {
				str && (str += ' ');
				str += x
			}
		}
		return str;
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// FETCH DATA
	var FETCH_BATTERY = exports.FETCH_BATTERY = "fetch_battery";
	var FETCH_BATTERY_SOH = exports.FETCH_BATTERY_SOH = "fetch_battery_soh";
	var FETCH_ASSET = exports.FETCH_ASSET = "fetch_asset";
	var FETCH_PSATYPICAL = exports.FETCH_PSATYPICAL = "fetch_ps_atypical";
	var FETCH_PSGENERIC = exports.FETCH_PSGENERIC = "fetch_ps_generic";
	var FETCH_CONTRACT = exports.FETCH_CONTRACT = "fetch_contract";
	var FETCH_METER_WITH_BESS = exports.FETCH_METER_WITH_BESS = "fetch_meter_with";
	var FETCH_METER_WITHOUT_BESS = exports.FETCH_METER_WITHOUT_BESS = "fetch_meter_without";
	var FETCH_STATUS = exports.FETCH_STATUS = "fetch_status";
	var FETCH_STATUS_RANGE = exports.FETCH_STATUS_RANGE = "fetch_status_range";
	var FETCH_UNAVAILABILITIES = exports.FETCH_UNAVAILABILITIES = "fetch_unavailabilities";
	var FETCH_TARIFF = exports.FETCH_TARIFF = "fetch_tariff";
	var HANDLE_ERRORS = exports.HANDLE_ERRORS = "handle_errors";
	var HANDLE_SUCCESS = exports.HANDLE_SUCCESS = "handle_success";
	var FILE_SAVED = exports.FILE_SAVED = "file_saved";
	var FETCH_BATTERY_TABLE = exports.FETCH_BATTERY_TABLE = "fetch_battery_table";
	// AUTH
	var LOGIN_IS_LOADING = exports.LOGIN_IS_LOADING = "login_is_loading";
	var JWT_AUTH_SUCCESS = exports.JWT_AUTH_SUCCESS = "jwt_auth_success";
	var LOGIN_OPERATOR_SUCCESS = exports.LOGIN_OPERATOR_SUCCESS = "login_operator_success";
	var LOGIN_CUSTOMER_SUCCESS = exports.LOGIN_CUSTOMER_SUCCESS = "login_customer_success";
	var LOGIN_FAIL = exports.LOGIN_FAIL = "login_fail";
	var LOGOUT = exports.LOGOUT = "logout";
	var FETCH_PERMISSIONS = exports.FETCH_PERMISSIONS = "fetch_permissions";
	var CHANGE_OP_PWD = exports.CHANGE_OP_PWD = "change_op_pwd";
	var CHANGE_CU_PWD = exports.CHANGE_CU_PWD = "change_cu_pwd";
	//DATE RANGE
	var CHANGE_DATE_RANGE = exports.CHANGE_DATE_RANGE = "change_date_range";
	//  MODE
	var TOGGLE_MODE = exports.TOGGLE_MODE = "toggle_mode";
	var LOADING_MODE = exports.LOADING_MODE = "loading_mode";
	// TABLES
	var SORT_COLUMN = exports.SORT_COLUMN = "sort_column";
	var UPDATE_DATA = exports.UPDATE_DATA = "update_data";
	var FILTER_PS_DATA = exports.FILTER_PS_DATA = "filter_ps_data";
	var UPDATE_DISPLAYED_DATA = exports.UPDATE_DISPLAYED_DATA = "update_displayed_data";
	var CHANGE_TABLE_DATE_RANGE = exports.CHANGE_TABLE_DATE_RANGE = "table_date_change_reducer";
	var SAVE_JSON = exports.SAVE_JSON = "save_json";
	// PLOT
	var FETCH_CHART_DATA = exports.FETCH_CHART_DATA = "fetch_chart_data";
	var FETCH_SITE_DATA = exports.FETCH_SITE_DATA = "fetch_site_data";
	var UPDATE_CHART = exports.UPDATE_CHART = "update_chart";
	var PLOT_LOAD_BESS = exports.PLOT_LOAD_BESS = "plot_load_bess";
	var LATEST_DATA = exports.LATEST_DATA = "latest_data";
	var PLOT_LOAD_NO_BESS = exports.PLOT_LOAD_NO_BESS = "plot_load_no_bess";
	var PLOT_BATTERY_POWER = exports.PLOT_BATTERY_POWER = "plot_battery_power";
	var PLOT_PREF = exports.PLOT_PREF = "plot_pref";
	var PLOT_PMAX = exports.PLOT_PMAX = "plot_pmax";

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.4.0
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(145));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(689));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(690));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(691));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(692));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(693));
	
	var _refType = _interopRequireDefault(__webpack_require__(694));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.createChainedFunction = createChainedFunction;
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (false) {
	    if (typeof string !== 'string') {
	      throw new Error('Material-UI: capitalize(string) expects a string argument.');
	    }
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	
	
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	
	var patterns = {
	  dateTimeDelimeter: /[T ]/,
	  plainTime: /:/,
	
	  // year tokens
	  YY: /^(\d{2})$/,
	  YYY: [/^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	  ],
	  YYYY: /^(\d{4})/,
	  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	  ],
	
	  // date tokens
	  MM: /^-(\d{2})$/,
	  DDD: /^-?(\d{3})$/,
	  MMDD: /^-?(\d{2})-?(\d{2})$/,
	  Www: /^-?W(\d{2})$/,
	  WwwD: /^-?W(\d{2})-?(\d{1})$/,
	
	  HH: /^(\d{2}([.,]\d*)?)$/,
	  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	
	  // timezone tokens
	  timezone: /([Z+-].*)$/,
	  timezoneZ: /^(Z)$/,
	  timezoneHH: /^([+-])(\d{2})$/,
	  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
	};
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument is null, it is treated as an invalid date.
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
	 *
	 * @param {*} argument - the value to convert
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = toDate('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = toDate('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function toDate(argument, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  if (argument === null) {
	    return new Date(NaN);
	  }
	
	  var options = dirtyOptions || {};
	
	  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  // Clone the date
	  if (argument instanceof Date) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument !== 'string') {
	    return new Date(argument);
	  }
	
	  var dateStrings = splitDateString(argument);
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	  var year = parseYearResult.year;
	  var restDateString = parseYearResult.restDateString;
	
	  var date = parseDate(restDateString, year);
	
	  if (date) {
	    var timestamp = date.getTime();
	    var time = 0;
	    var offset;
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time);
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone);
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset();
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
	    }
	
	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE);
	  } else {
	    return new Date(argument);
	  }
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimeter);
	  var timeString;
	
	  if (patterns.plainTime.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var patternYYY = patterns.YYY[additionalDigits];
	  var patternYYYYY = patterns.YYYYY[additionalDigits];
	
	  var token;
	
	  // YYYY or ±YYYYY
	  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
	  if (token) {
	    var yearString = token[1];
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    };
	  }
	
	  // YY or ±YYY
	  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
	  if (token) {
	    var centuryString = token[1];
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    };
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null;
	  }
	
	  var token;
	  var date;
	  var month;
	  var week;
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0);
	    date.setUTCFullYear(year);
	    return date;
	  }
	
	  // YYYY-MM
	  token = patterns.MM.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    date.setUTCFullYear(year, month);
	    return date;
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = patterns.DDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    var dayOfYear = parseInt(token[1], 10);
	    date.setUTCFullYear(year, 0, dayOfYear);
	    return date;
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = patterns.MMDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    var day = parseInt(token[2], 10);
	    date.setUTCFullYear(year, month, day);
	    return date;
	  }
	
	  // YYYY-Www or YYYYWww
	  token = patterns.Www.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    return dayOfISOYear(year, week);
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = patterns.WwwD.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    var dayOfWeek = parseInt(token[2], 10) - 1;
	    return dayOfISOYear(year, week, dayOfWeek);
	  }
	
	  // Invalid ISO-formatted date
	  return null;
	}
	
	function parseTime(timeString) {
	  var token;
	  var hours;
	  var minutes;
	
	  // hh
	  token = patterns.HH.exec(timeString);
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR;
	  }
	
	  // hh:mm or hhmm
	  token = patterns.HHMM.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseFloat(token[2].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
	  }
	
	  // hh:mm:ss or hhmmss
	  token = patterns.HHMMSS.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseInt(token[2], 10);
	    var seconds = parseFloat(token[3].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	  }
	
	  // Invalid ISO-formatted time
	  return null;
	}
	
	function parseTimezone(timezoneString) {
	  var token;
	  var absoluteOffset;
	
	  // Z
	  token = patterns.timezoneZ.exec(timezoneString);
	  if (token) {
	    return 0;
	  }
	
	  // ±hh
	  token = patterns.timezoneHH.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60;
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }
	
	  // ±hh:mm or ±hhmm
	  token = patterns.timezoneHHMM.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }
	
	  return 0;
	}
	
	function dayOfISOYear(isoYear, week, day) {
	  week = week || 0;
	  day = day || 0;
	  var date = new Date(0);
	  date.setUTCFullYear(isoYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMuiElement = isMuiElement;
	exports.setRef = setRef;
	exports.useForkRef = useForkRef;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function isMuiElement(element, muiNames) {
	  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	} // TODO: Make it private only in v5
	
	
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return _react.default.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      setRef(refA, refValue);
	      setRef(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(596));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(713);


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(34);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(72));
	
	function useTheme() {
	  return (0, _styles.useTheme)() || _defaultTheme.default;
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(893);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(903));
	
	exports.Provider = _Provider.default;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(410));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _Context = __webpack_require__(167);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(904));
	
	exports.connect = _connect.default;

/***/ },
/* 19 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(696);

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (token) {
	  return {
	    headers: { Authorization: 'JWT ' + (token || localStorage.getItem('JWT') || sessionStorage.getItem('JWT')) }
	  };
	};
	
	;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BASE_URL =  true ? ("") : process.env.REACT_APP_BASE_URL;
	
	exports.default = BASE_URL;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(543));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  if (value < min) {
	    return min;
	  }
	
	  if (value > max) {
	    return max;
	  }
	
	  return value;
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb(".concat(colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  MuiThemeProvider: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _MuiThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _colorManipulator = __webpack_require__(24);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(224));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(630));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(225));
	
	var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(626));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(633));
	
	var _styled = _interopRequireDefault(__webpack_require__(226));
	
	var _transitions = __webpack_require__(36);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(636));

/***/ },
/* 26 */
/***/ function(module, exports) {

	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	
	  if (obj != null) {
	    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	        if (desc && (desc.get || desc.set)) {
	          Object.defineProperty(newObj, key, desc);
	        } else {
	          newObj[key] = obj[key];
	        }
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(80)(module)))

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(67));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({}, props, {
	      ref: ref
	    }), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(449));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(450));

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(67));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(243);
	var isBuffer = __webpack_require__(712);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(425);
	
	var iterableToArray = __webpack_require__(179);
	
	var nonIterableSpread = __webpack_require__(429);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.4.3
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "withThemeCreator", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.withThemeCreator;
	  }
	});
	
	var _utils = __webpack_require__(10);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(142));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(661));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(234));
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(235));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(143));
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(236));
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(655));
	
	var _styled = _interopRequireDefault(__webpack_require__(670));
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(141));
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(658));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(73));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(673));
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(675));
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAsset = __webpack_require__(928);
	
	Object.keys(_getAsset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getAsset[key];
	    }
	  });
	});
	
	var _getBatterySoh = __webpack_require__(929);
	
	Object.keys(_getBatterySoh).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getBatterySoh[key];
	    }
	  });
	});
	
	var _getContract = __webpack_require__(931);
	
	Object.keys(_getContract).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getContract[key];
	    }
	  });
	});
	
	var _getPSAtypical = __webpack_require__(932);
	
	Object.keys(_getPSAtypical).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getPSAtypical[key];
	    }
	  });
	});
	
	var _getPSGeneric = __webpack_require__(933);
	
	Object.keys(_getPSGeneric).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getPSGeneric[key];
	    }
	  });
	});
	
	var _getStatus = __webpack_require__(935);
	
	Object.keys(_getStatus).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getStatus[key];
	    }
	  });
	});
	
	var _getUnavailabilities = __webpack_require__(938);
	
	Object.keys(_getUnavailabilities).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getUnavailabilities[key];
	    }
	  });
	});
	
	var _auth_actions = __webpack_require__(417);
	
	Object.keys(_auth_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _auth_actions[key];
	    }
	  });
	});
	
	var _changeDateRange = __webpack_require__(924);
	
	Object.keys(_changeDateRange).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _changeDateRange[key];
	    }
	  });
	});
	
	var _mode_actions = __webpack_require__(940);
	
	Object.keys(_mode_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mode_actions[key];
	    }
	  });
	});
	
	var _table_actions = __webpack_require__(944);
	
	Object.keys(_table_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _table_actions[key];
	    }
	  });
	});
	
	var _filterPeakShavingData = __webpack_require__(927);
	
	Object.keys(_filterPeakShavingData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _filterPeakShavingData[key];
	    }
	  });
	});
	
	var _getTariffInfo = __webpack_require__(937);
	
	Object.keys(_getTariffInfo).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getTariffInfo[key];
	    }
	  });
	});
	
	var _handleErrors = __webpack_require__(939);
	
	Object.keys(_handleErrors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _handleErrors[key];
	    }
	  });
	});
	
	var _getChartData = __webpack_require__(930);
	
	Object.keys(_getChartData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getChartData[key];
	    }
	  });
	});
	
	var _getSiteData = __webpack_require__(934);
	
	Object.keys(_getSiteData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getSiteData[key];
	    }
	  });
	});
	
	var _changeTableDateRange = __webpack_require__(925);
	
	Object.keys(_changeTableDateRange).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _changeTableDateRange[key];
	    }
	  });
	});
	
	var _getTableBatteryInfo = __webpack_require__(936);
	
	Object.keys(_getTableBatteryInfo).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getTableBatteryInfo[key];
	    }
	  });
	});
	
	var _saveToJSONFile = __webpack_require__(942);
	
	Object.keys(_saveToJSONFile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _saveToJSONFile[key];
	    }
	  });
	});
	
	var _permissions_actions = __webpack_require__(941);
	
	Object.keys(_permissions_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _permissions_actions[key];
	    }
	  });
	});
	
	var _siteInformations = __webpack_require__(943);
	
	Object.keys(_siteInformations).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _siteInformations[key];
	    }
	  });
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	/* eslint-disable no-restricted-globals */
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	var formatMs = function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	};
	
	exports.formatMs = formatMs;
	
	var isString = function isString(value) {
	  return typeof value === 'string';
	};
	
	exports.isString = isString;
	
	var isNumber = function isNumber(value) {
	  return !isNaN(parseFloat(value));
	};
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	exports.isNumber = isNumber;
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]"));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 37 */
1,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(513));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(238));
	
	var _breakpoints = __webpack_require__(144);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal];
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(255);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(499));

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(94));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = memoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.dependencies = dependencies;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(84));
	
	function useFormControl() {
	  return _react.default.useContext(_FormControlContext.default);
	}

/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	var _default = ownerDocument;
	exports.default = _default;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(744));
	var isInBrowser = _interopDefault(__webpack_require__(245));
	var warning = _interopDefault(__webpack_require__(60));
	var _createClass = _interopDefault(__webpack_require__(743));
	var _inheritsLoose = _interopDefault(__webpack_require__(745));
	var _assertThisInitialized = _interopDefault(__webpack_require__(742));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(746));
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	
	
	function toCssValue(value, ignoreImportant) {
	  if (ignoreImportant === void 0) {
	    ignoreImportant = false;
	  }
	
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	}
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += '\n';
	            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += '\n';
	          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += '\n';
	      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "\n" + result + "\n";
	  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.key = void 0;
	    this.isProcessed = false;
	    this.style = void 0;
	    this.renderer = void 0;
	    this.renderable = void 0;
	    this.options = void 0;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    _this.selectorText = void 0;
	    _this.id = void 0;
	    _this.renderable = void 0;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass(StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(name, style, options) {
	    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(name, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.at = void 0;
	    this.key = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown';
	    this.options = options;
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.key + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.key + " {\n" + children + "\n}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.key = void 0;
	    this.name = void 0;
	    this.id = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "\n" + children + "\n";
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var plugin = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
	    _this.renderable = void 0;
	    return _this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.key, this.style[index]);
	        if (this.style[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return toCss(this.key, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@font-face' ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.key = void 0;
	    this.value = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.options = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(key, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped
	    }, ruleOptions); // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // For e.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Get a rule.
	   */
	  ;
	
	  _proto.get = function get(name) {
	    return this.map[name];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins$$1 = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins$$1.onProcessRule, plugins$$1);
	  }
	  /**
	   * Register a rule in `.map` and `.classes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe
	
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.onUpdate(data, this.get(name), options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.onUpdate(data, this.index[index], options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins$$1 = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var styleRule = rule;
	    var style = styleRule.style;
	    plugins$$1.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== styleRule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins$$1.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
	
	      for (var prop in styleRule.style) {
	        var nextValue = styleRule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          styleRule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = styleRule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          styleRule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += '\n';
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.options = void 0;
	    this.deployed = void 0;
	    this.attached = void 0;
	    this.rules = void 0;
	    this.renderer = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.queue = void 0;
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name.
	   */
	  ;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = this.rules.get(name);
	    if (!rule) return false;
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = void 0;
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      // $FlowFixMe
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += '\n';
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass(SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var sheets = new SheetsRegistry();
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis[ns]++;
	
	var maxRules = 1e10;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	/**
	 * Get a style property value.
	 */
	
	
	function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	/**
	 * Set a style property.
	 */
	
	
	function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      cssRule.style.setProperty(prop, cssValue);
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Remove a style property.
	 */
	
	
	function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	}
	/**
	 * Set the selector.
	 */
	
	
	function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	}
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = sheets.registry;
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    index = maxIndex;
	  }
	
	  try {
	    if ('insertRule' in container) {
	      var c = container;
	      c.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        var _c = container;
	
	        _c.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning(false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.element = void 0;
	    this.sheet = void 0;
	    this.hasInsertedRules = false;
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) sheets.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // browsers remove those rules.
	    // TODO figure out if its a bug and if it is known.
	    // Workaround is to redeploy the sheet.
	
	    if (this.hasInsertedRules && !(this.sheet && !this.sheet.deployed)) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element);
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        // We need to render the container without children first.
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), index);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, index);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    rule.renderable = nativeRule;
	    return nativeRule;
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    var cssRules = this.element.sheet.cssRules;
	
	    for (var index = 0; index < cssRules.length; index++) {
	      if (cssRule === cssRules[index]) return index;
	    }
	
	    return -1;
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   *
	   * Only used for some old browsers because they can't set a selector.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.0.0-alpha.25";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = sheets.index === 0 ? 0 : sheets.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    sheets.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   */
	  ;
	
	  _proto.createRule = function createRule$$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      return this.createRule(undefined, name, style);
	    }
	
	    var ruleOptions = _extends({}, options, {
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins$$1 = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins$$1[_key] = arguments[_key];
	    }
	
	    plugins$$1.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning(false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass(SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	/**
	 * Export a constant indicating if this browser has CSSTOM support.
	 * https://developers.google.com/web/updates/2018/03/cssom
	 */
	var hasCSSTOMSupport = typeof CSS !== 'undefined' && CSS && 'number' in CSS;
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = function create(options) {
	  return new Jss(options);
	};
	/**
	 * A global Jss instance.
	 */
	
	var index = create();
	
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.create = create;
	exports.default = index;
	exports.getDynamicStyles = getDynamicStyles;
	exports.toCssValue = toCssValue;
	exports.createRule = createRule;
	exports.SheetsRegistry = SheetsRegistry;
	exports.SheetsManager = SheetsManager;
	exports.RuleList = RuleList;
	exports.sheets = sheets;
	exports.createGenerateId = createGenerateId;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(767),
	    getValue = __webpack_require__(794);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(997));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(998));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(999));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(422));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(173));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(423));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(521));

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(594));

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = _react.default.useRef(fn);
	
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return _react.default.useCallback(function (event) {
	    return (0, ref.current)(event);
	  }, []);
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(165);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 59 */
[1024, 1001],
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 61 */
/***/ function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(468));

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(516));

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = _react.default.createContext({});
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(522));

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(536));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(200));

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(573));

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var Tablelvl2Context = _react.default.createContext();
	
	var _default = Tablelvl2Context;
	exports.default = _default;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	
	var _TableCell = _interopRequireDefault(__webpack_require__(581));

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(592));

/***/ },
/* 71 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(224));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(672));

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "LOCATION_CHANGE", {
	  enumerable: true,
	  get: function get() {
	    return _actions.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, "CALL_HISTORY_METHOD", {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, "onLocationChanged", {
	  enumerable: true,
	  get: function get() {
	    return _actions.onLocationChanged;
	  }
	});
	Object.defineProperty(exports, "push", {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, "replace", {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, "go", {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, "goBack", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, "goForward", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, "routerActions", {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	Object.defineProperty(exports, "routerMiddleware", {
	  enumerable: true,
	  get: function get() {
	    return _middleware.default;
	  }
	});
	exports.createMatchSelector = exports.getSearch = exports.getHash = exports.getAction = exports.getLocation = exports.connectRouter = exports.ConnectedRouter = void 0;
	
	var _ConnectedRouter = _interopRequireDefault(__webpack_require__(715));
	
	var _reducer = _interopRequireDefault(__webpack_require__(717));
	
	var _selectors = _interopRequireDefault(__webpack_require__(244));
	
	var _plain = _interopRequireDefault(__webpack_require__(719));
	
	var _actions = __webpack_require__(95);
	
	var _middleware = _interopRequireDefault(__webpack_require__(716));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConnectedRouter =
	/*#__PURE__*/
	(0, _ConnectedRouter.default)(_plain.default);
	exports.ConnectedRouter = ConnectedRouter;
	var connectRouter =
	/*#__PURE__*/
	(0, _reducer.default)(_plain.default);
	exports.connectRouter = connectRouter;
	
	var _createSelectors =
	/*#__PURE__*/
	(0, _selectors.default)(_plain.default),
	    getLocation = _createSelectors.getLocation,
	    getAction = _createSelectors.getAction,
	    getHash = _createSelectors.getHash,
	    getSearch = _createSelectors.getSearch,
	    createMatchSelector = _createSelectors.createMatchSelector;
	
	exports.createMatchSelector = createMatchSelector;
	exports.getSearch = getSearch;
	exports.getHash = getHash;
	exports.getAction = getAction;
	exports.getLocation = getLocation;

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}
	
	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}
	
	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(97),
	    getRawTag = __webpack_require__(791),
	    objectToString = __webpack_require__(818);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(913);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 81 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 82 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(435));

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = _react.default.createContext();
	
	function useFormControl() {
	  return _react.default.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(494));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(506));

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(514));

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	
	var _TableRow = _interopRequireDefault(__webpack_require__(586));

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(595));

/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.useIsFocusVisible = useIsFocusVisible;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	
	function handleKeyDown() {
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 * @param {Event} e
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(ownerDocument) {
	  ownerDocument.addEventListener('keydown', handleKeyDown, true);
	  ownerDocument.addEventListener('mousedown', handlePointerDown, true);
	  ownerDocument.addEventListener('pointerdown', handlePointerDown, true);
	  ownerDocument.addEventListener('touchstart', handlePointerDown, true);
	  ownerDocument.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(ownerDocument) {
	  ownerDocument.removeEventListener('keydown', handleKeyDown, true);
	  ownerDocument.removeEventListener('mousedown', handlePointerDown, true);
	  ownerDocument.removeEventListener('pointerdown', handlePointerDown, true);
	  ownerDocument.removeEventListener('touchstart', handlePointerDown, true);
	  ownerDocument.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
	  // we use our own heuristic for those browsers
	  // rethrow might be better if it's not the expected error but do we really
	  // want to crash if focus-visible malfunctioned?
	  // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	    window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = _react.default.useCallback(function (instance) {
	    var node = _reactDom.default.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}
	
	var _default = ownerWindow;
	exports.default = _default;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(75));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _deepmerge.default)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.onLocationChanged = exports.LOCATION_CHANGE = void 0;
	
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	exports.LOCATION_CHANGE = LOCATION_CHANGE;
	
	var onLocationChanged = function onLocationChanged(location, action) {
	  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return {
	    type: LOCATION_CHANGE,
	    payload: {
	      location: location,
	      action: action,
	      isFirstRendering: isFirstRendering
	    }
	  };
	};
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	
	
	exports.onLocationChanged = onLocationChanged;
	var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	exports.CALL_HISTORY_METHOD = CALL_HISTORY_METHOD;
	
	var updateLocation = function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: {
	        method: method,
	        args: args
	      }
	    };
	  };
	};
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	
	
	var push = updateLocation('push');
	exports.push = push;
	var replace = updateLocation('replace');
	exports.replace = replace;
	var go = updateLocation('go');
	exports.go = go;
	var goBack = updateLocation('goBack');
	exports.goBack = goBack;
	var goForward = updateLocation('goForward');
	exports.goForward = goForward;
	var routerActions = {
	  push: push,
	  replace: replace,
	  go: go,
	  goBack: goBack,
	  goForward: goForward
	};
	exports.routerActions = routerActions;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(804),
	    listCacheDelete = __webpack_require__(805),
	    listCacheGet = __webpack_require__(806),
	    listCacheHas = __webpack_require__(807),
	    listCacheSet = __webpack_require__(808);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(40);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(260);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(801);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(77);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(263),
	    isLength = __webpack_require__(153);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rangeShape = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(44);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _endOfDay = __webpack_require__(159);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _isBefore = __webpack_require__(162);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isAfter = __webpack_require__(405);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isSameDay = __webpack_require__(110);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _format = __webpack_require__(161);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _startOfDay = __webpack_require__(78);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-fallthrough */
	
	
	var DayCell = function (_Component) {
	  _inherits(DayCell, _Component);
	
	  function DayCell(props, context) {
	    _classCallCheck(this, DayCell);
	
	    var _this = _possibleConstructorReturn(this, (DayCell.__proto__ || Object.getPrototypeOf(DayCell)).call(this, props, context));
	
	    _this.state = {
	      hover: false,
	      active: false
	    };
	    _this.getClassNames = _this.getClassNames.bind(_this);
	    _this.handleMouseEvent = _this.handleMouseEvent.bind(_this);
	    _this.handleKeyEvent = _this.handleKeyEvent.bind(_this);
	    _this.renderSelectionPlaceholders = _this.renderSelectionPlaceholders.bind(_this);
	    _this.renderPreviewPlaceholder = _this.renderPreviewPlaceholder.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayCell, [{
	    key: 'handleKeyEvent',
	    value: function handleKeyEvent(event) {
	      var day = this.props.day;
	
	      switch (event.keyCode) {
	        case 13: //space
	        case 32:
	          //enter
	          if (event.type === 'keydown') {
	            this.props.onMouseDown(day);
	          } else {
	            this.props.onMouseUp(day);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'handleMouseEvent',
	    value: function handleMouseEvent(event) {
	      var _props = this.props,
	          day = _props.day,
	          disabled = _props.disabled,
	          onPreviewChange = _props.onPreviewChange;
	
	      var stateChanges = {};
	      if (disabled) {
	        onPreviewChange();
	        return;
	      }
	
	      switch (event.type) {
	        case 'mouseenter':
	          this.props.onMouseEnter(day);
	          onPreviewChange(day);
	          stateChanges.hover = true;
	          break;
	        case 'blur':
	        case 'mouseleave':
	          stateChanges.hover = false;
	          break;
	        case 'mousedown':
	          stateChanges.active = true;
	          this.props.onMouseDown(day);
	          break;
	        case 'mouseup':
	          event.stopPropagation();
	          stateChanges.active = false;
	          this.props.onMouseUp(day);
	          break;
	        case 'focus':
	          onPreviewChange(day);
	          break;
	      }
	      if (Object.keys(stateChanges).length) {
	        this.setState(stateChanges);
	      }
	    }
	  }, {
	    key: 'getClassNames',
	    value: function getClassNames() {
	      var _classnames;
	
	      var _props2 = this.props,
	          isPassive = _props2.isPassive,
	          isToday = _props2.isToday,
	          isWeekend = _props2.isWeekend,
	          isStartOfWeek = _props2.isStartOfWeek,
	          isEndOfWeek = _props2.isEndOfWeek,
	          isStartOfMonth = _props2.isStartOfMonth,
	          isEndOfMonth = _props2.isEndOfMonth,
	          disabled = _props2.disabled,
	          styles = _props2.styles;
	
	
	      return (0, _classnames5.default)(styles.day, (_classnames = {}, _defineProperty(_classnames, styles.dayPassive, isPassive), _defineProperty(_classnames, styles.dayDisabled, disabled), _defineProperty(_classnames, styles.dayToday, isToday), _defineProperty(_classnames, styles.dayWeekend, isWeekend), _defineProperty(_classnames, styles.dayStartOfWeek, isStartOfWeek), _defineProperty(_classnames, styles.dayEndOfWeek, isEndOfWeek), _defineProperty(_classnames, styles.dayStartOfMonth, isStartOfMonth), _defineProperty(_classnames, styles.dayEndOfMonth, isEndOfMonth), _defineProperty(_classnames, styles.dayHovered, this.state.hover), _defineProperty(_classnames, styles.dayActive, this.state.active), _classnames));
	    }
	  }, {
	    key: 'renderPreviewPlaceholder',
	    value: function renderPreviewPlaceholder() {
	      var _classnames2;
	
	      var _props3 = this.props,
	          preview = _props3.preview,
	          day = _props3.day,
	          styles = _props3.styles;
	
	      if (!preview) return null;
	      var startDate = preview.startDate ? (0, _endOfDay2.default)(preview.startDate) : null;
	      var endDate = preview.endDate ? (0, _startOfDay2.default)(preview.endDate) : null;
	      var isInRange = (!startDate || (0, _isAfter2.default)(day, startDate)) && (!endDate || (0, _isBefore2.default)(day, endDate));
	      var isStartEdge = !isInRange && (0, _isSameDay2.default)(day, startDate);
	      var isEndEdge = !isInRange && (0, _isSameDay2.default)(day, endDate);
	      return _react2.default.createElement('span', {
	        className: (0, _classnames5.default)((_classnames2 = {}, _defineProperty(_classnames2, styles.dayStartPreview, isStartEdge), _defineProperty(_classnames2, styles.dayInPreview, isInRange), _defineProperty(_classnames2, styles.dayEndPreview, isEndEdge), _classnames2)),
	        style: { color: preview.color }
	      });
	    }
	  }, {
	    key: 'renderSelectionPlaceholders',
	    value: function renderSelectionPlaceholders() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          styles = _props4.styles,
	          ranges = _props4.ranges,
	          day = _props4.day;
	
	      if (this.props.displayMode === 'date') {
	        var isSelected = (0, _isSameDay2.default)(this.props.day, this.props.date);
	        return isSelected ? _react2.default.createElement('span', { className: styles.selected, style: { color: this.props.color } }) : null;
	      }
	
	      var inRanges = ranges.reduce(function (result, range) {
	        var startDate = range.startDate;
	        var endDate = range.endDate;
	        if (startDate && endDate && (0, _isBefore2.default)(endDate, startDate)) {
	          var _ref = [endDate, startDate];
	          startDate = _ref[0];
	          endDate = _ref[1];
	        }
	        startDate = startDate ? (0, _endOfDay2.default)(startDate) : null;
	        endDate = endDate ? (0, _startOfDay2.default)(endDate) : null;
	        var isInRange = (!startDate || (0, _isAfter2.default)(day, startDate)) && (!endDate || (0, _isBefore2.default)(day, endDate));
	        var isStartEdge = !isInRange && (0, _isSameDay2.default)(day, startDate);
	        var isEndEdge = !isInRange && (0, _isSameDay2.default)(day, endDate);
	        if (isInRange || isStartEdge || isEndEdge) {
	          return [].concat(_toConsumableArray(result), [_extends({
	            isStartEdge: isStartEdge,
	            isEndEdge: isEndEdge,
	            isInRange: isInRange
	          }, range)]);
	        }
	        return result;
	      }, []);
	
	      return inRanges.map(function (range, i) {
	        var _classnames3;
	
	        return _react2.default.createElement('span', {
	          key: i,
	          className: (0, _classnames5.default)((_classnames3 = {}, _defineProperty(_classnames3, styles.startEdge, range.isStartEdge), _defineProperty(_classnames3, styles.endEdge, range.isEndEdge), _defineProperty(_classnames3, styles.inRange, range.isInRange), _classnames3)),
	          style: { color: range.color || _this2.props.color }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = this.props.styles;
	
	      return _react2.default.createElement(
	        'button',
	        _extends({
	          type: 'button',
	          onMouseEnter: this.handleMouseEvent,
	          onMouseLeave: this.handleMouseEvent,
	          onFocus: this.handleMouseEvent,
	          onMouseDown: this.handleMouseEvent,
	          onMouseUp: this.handleMouseEvent,
	          onBlur: this.handleMouseEvent,
	          onPauseCapture: this.handleMouseEvent,
	          onKeyDown: this.handleKeyEvent,
	          onKeyUp: this.handleKeyEvent,
	          className: this.getClassNames(styles)
	        }, this.props.disabled || this.props.isPassive ? { tabIndex: -1 } : {}, {
	          style: { color: this.props.color } }),
	        this.renderSelectionPlaceholders(),
	        this.renderPreviewPlaceholder(),
	        _react2.default.createElement(
	          'span',
	          { className: styles.dayNumber },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _format2.default)(this.props.day, 'D')
	          )
	        )
	      );
	    }
	  }]);
	
	  return DayCell;
	}(_react.Component);
	
	DayCell.defaultProps = {};
	
	var rangeShape = exports.rangeShape = _propTypes2.default.shape({
	  startDate: _propTypes2.default.object,
	  endDate: _propTypes2.default.object,
	  color: _propTypes2.default.string,
	  key: _propTypes2.default.string,
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  showDateDisplay: _propTypes2.default.bool
	});
	
	DayCell.propTypes = {
	  day: _propTypes2.default.object.isRequired,
	  date: _propTypes2.default.object,
	  ranges: _propTypes2.default.arrayOf(rangeShape),
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object
	  }),
	  onPreviewChange: _propTypes2.default.func,
	  previewColor: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  isPassive: _propTypes2.default.bool,
	  isToday: _propTypes2.default.bool,
	  isWeekend: _propTypes2.default.bool,
	  isStartOfWeek: _propTypes2.default.bool,
	  isEndOfWeek: _propTypes2.default.bool,
	  isStartOfMonth: _propTypes2.default.bool,
	  isEndOfMonth: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  styles: _propTypes2.default.object,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func
	};
	
	exports.default = DayCell;

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  dateRangeWrapper: 'rdrDateRangeWrapper',
	  calendarWrapper: 'rdrCalendarWrapper',
	  dateDisplay: 'rdrDateDisplay',
	  dateDisplayItem: 'rdrDateDisplayItem',
	  dateDisplayItemActive: 'rdrDateDisplayItemActive',
	  monthAndYearWrapper: 'rdrMonthAndYearWrapper',
	  monthAndYearPickers: 'rdrMonthAndYearPickers',
	  nextPrevButton: 'rdrNextPrevButton',
	  month: 'rdrMonth',
	  weekDays: 'rdrWeekDays',
	  weekDay: 'rdrWeekDay',
	  days: 'rdrDays',
	  day: 'rdrDay',
	  dayNumber: 'rdrDayNumber',
	  dayPassive: 'rdrDayPassive',
	  dayToday: 'rdrDayToday',
	  dayStartOfWeek: 'rdrDayStartOfWeek',
	  dayEndOfWeek: 'rdrDayEndOfWeek',
	  daySelected: 'rdrDaySelected',
	  dayDisabled: 'rdrDayDisabled',
	  dayStartOfMonth: 'rdrDayStartOfMonth',
	  dayEndOfMonth: 'rdrDayEndOfMonth',
	  dayWeekend: 'rdrDayWeekend',
	  dayStartPreview: 'rdrDayStartPreview',
	  dayInPreview: 'rdrDayInPreview',
	  dayEndPreview: 'rdrDayEndPreview',
	  dayHovered: 'rdrDayHovered',
	  dayActive: 'rdrDayActive',
	  inRange: 'rdrInRange',
	  endEdge: 'rdrEndEdge',
	  startEdge: 'rdrStartEdge',
	  prevButton: 'rdrPprevButton',
	  nextButton: 'rdrNextButton',
	  selected: 'rdrSelected',
	  months: 'rdrMonths',
	  monthPicker: 'rdrMonthPicker',
	  yearPicker: 'rdrYearPicker',
	  dateDisplayWrapper: 'rdrDateDisplayWrapper',
	  definedRangesWrapper: 'rdrDefinedRangesWrapper',
	  staticRanges: 'rdrStaticRanges',
	  staticRange: 'rdrStaticRange',
	  inputRanges: 'rdrInputRanges',
	  inputRange: 'rdrInputRange',
	  inputRangeInput: 'rdrInputRangeInput',
	  dateRangePickerWrapper: 'rdrDateRangePickerWrapper',
	  staticRangeLabel: 'rdrStaticRangeLabel',
	  staticRangeSelected: 'rdrStaticRangeSelected',
	  monthName: 'rdrMonthName',
	  infiniteMonths: 'rdrInfiniteMonths',
	  monthsVertical: 'rdrMonthsVertical',
	  monthsHorizontal: 'rdrMonthsHorizontal'
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcFocusDate = calcFocusDate;
	exports.findNextRangeIndex = findNextRangeIndex;
	exports.getMonthDisplayRange = getMonthDisplayRange;
	exports.generateStyles = generateStyles;
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _endOfWeek = __webpack_require__(109);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(111);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _endOfMonth = __webpack_require__(160);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(163);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _areIntervalsOverlapping = __webpack_require__(869);
	
	var _areIntervalsOverlapping2 = _interopRequireDefault(_areIntervalsOverlapping);
	
	var _addMonths = __webpack_require__(108);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcFocusDate(currentFocusedDate, props) {
	  var shownDate = props.shownDate,
	      date = props.date,
	      months = props.months,
	      ranges = props.ranges,
	      focusedRange = props.focusedRange,
	      displayMode = props.displayMode;
	  // find primary date according the props
	
	  var targetInterval = void 0;
	  if (displayMode === 'dateRange') {
	    var range = ranges[focusedRange[0]] || {};
	    targetInterval = {
	      start: range.startDate,
	      end: range.endDate
	    };
	  } else {
	    targetInterval = {
	      start: date,
	      end: date
	    };
	  }
	  targetInterval.start = (0, _startOfMonth2.default)(targetInterval.start || new Date());
	  targetInterval.end = (0, _endOfMonth2.default)(targetInterval.end || targetInterval.start);
	  var targetDate = targetInterval.start || targetInterval.end || shownDate || new Date();
	
	  // initial focus
	  if (!currentFocusedDate) return shownDate || targetDate;
	
	  // // just return targetDate for native scrolled calendars
	  // if (props.scroll.enabled) return targetDate;
	  var currentFocusInterval = {
	    start: (0, _startOfMonth2.default)(currentFocusedDate),
	    end: (0, _endOfMonth2.default)((0, _addMonths2.default)(currentFocusedDate, months - 1))
	  };
	  if ((0, _areIntervalsOverlapping2.default)(targetInterval, currentFocusInterval)) {
	    // don't change focused if new selection in view area
	    return currentFocusedDate;
	  }
	  return targetDate;
	}
	
	function findNextRangeIndex(ranges) {
	  var currentRangeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	  var nextIndex = ranges.findIndex(function (range, i) {
	    return i > currentRangeIndex && range.autoFocus !== false && !range.disabled;
	  });
	  if (nextIndex !== -1) return nextIndex;
	  return ranges.findIndex(function (range) {
	    return range.autoFocus !== false && !range.disabled;
	  });
	}
	
	function getMonthDisplayRange(date, dateOptions) {
	  var startDateOfMonth = (0, _startOfMonth2.default)(date, dateOptions);
	  var endDateOfMonth = (0, _endOfMonth2.default)(date, dateOptions);
	  var startDateOfCalendar = (0, _startOfWeek2.default)(startDateOfMonth, dateOptions);
	  var endDateOfCalendar = (0, _endOfWeek2.default)(endDateOfMonth, dateOptions);
	  return {
	    start: startDateOfCalendar,
	    end: endDateOfCalendar,
	    startDateOfMonth: startDateOfMonth,
	    endDateOfMonth: endDateOfMonth
	  };
	}
	
	function generateStyles(sources) {
	  if (!sources.length) return {};
	  var generatedStyles = sources.filter(function (source) {
	    return Boolean(source);
	  }).reduce(function (styles, styleSource) {
	    Object.keys(styleSource).forEach(function (key) {
	      styles[key] = (0, _classnames2.default)(styles[key], styleSource[key]);
	    });
	    return styles;
	  }, {});
	  return generatedStyles;
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(404);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  var desiredMonth = date.getMonth() + amount;
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index4.default)(dateWithDesiredMonth, dirtyOptions);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = __webpack_require__(78);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 18, 0)
	 * )
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeftStartOfDay = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfDay = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(917);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(1012));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers);
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = createStore;
	exports.combineReducers = combineReducers;
	exports.bindActionCreators = bindActionCreators;
	exports.applyMiddleware = applyMiddleware;
	exports.compose = compose;
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(434));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(436));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(455));

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(460));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(470));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(473));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Modal = _interopRequireDefault(__webpack_require__(66));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(115));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Slide = _interopRequireDefault(__webpack_require__(205));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _helpers = __webpack_require__(11);
	
	var _transitions = __webpack_require__(36);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = _react.default.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      PaperProps = props.PaperProps,
	      SlideProps = props.SlideProps,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = _react.default.useRef(false);
	
	  _react.default.useEffect(function () {
	    mounted.current = true;
	  }, []);
	
	  var anchor = getAnchor(theme, anchorProp);
	
	  var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true,
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))])
	  }, PaperProps), children);
	
	  if (variant === 'permanent') {
	    return _react.default.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return _react.default.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, {}, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	
	 false ? Drawer.propTypes = {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(492));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(493));

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(495));

/***/ },
/* 124 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(528));

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(540));

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(542));

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(544));

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(546));

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(554));

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(561));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(578));

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(579));

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	
	var _TableBody = _interopRequireDefault(__webpack_require__(580));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(591));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.4.3
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createMuiTheme;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createStyles;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.makeStyles;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.MuiThemeProvider;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _styles.responsiveFontSizes;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styles.styled;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _styles.useTheme;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.withStyles;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _styles.withTheme;
	  }
	});
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActionArea", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	Object.defineProperty(exports, "Fab", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "FilledInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	Object.defineProperty(exports, "InputBase", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.ModalManager;
	  }
	});
	Object.defineProperty(exports, "NativeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	Object.defineProperty(exports, "NoSsr", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedInput", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "RootRef", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepConnector", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "TextareaAutosize", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "useMediaQuery", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	Object.defineProperty(exports, "useScrollTrigger", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	exports.colors = void 0;
	
	var colors = _interopRequireWildcard(__webpack_require__(606));
	
	exports.colors = colors;
	
	var _styles = __webpack_require__(25);
	
	var _AppBar = _interopRequireDefault(__webpack_require__(114));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(83));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(115));
	
	var _Badge = _interopRequireDefault(__webpack_require__(438));
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(440));
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(442));
	
	var _Box = _interopRequireDefault(__webpack_require__(444));
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(448));
	
	var _Button = _interopRequireDefault(__webpack_require__(29));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(454));
	
	var _Card = _interopRequireDefault(__webpack_require__(116));
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(457));
	
	var _CardActions = _interopRequireDefault(__webpack_require__(459));
	
	var _CardContent = _interopRequireDefault(__webpack_require__(117));
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(462));
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(464));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(183));
	
	var _Chip = _interopRequireDefault(__webpack_require__(467));
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(62));
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(184));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(118));
	
	var _Container = _interopRequireDefault(__webpack_require__(472));
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(119));
	
	var _Dialog = _interopRequireDefault(__webpack_require__(185));
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(186));
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(187));
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(478));
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(480));
	
	var _Divider = _interopRequireDefault(__webpack_require__(188));
	
	var _Drawer = _interopRequireDefault(__webpack_require__(189));
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(483));
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(485));
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(487));
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(489));
	
	var _Fab = _interopRequireDefault(__webpack_require__(491));
	
	var _Fade = _interopRequireDefault(__webpack_require__(121));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(122));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(85));
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(123));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(190));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(191));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(192));
	
	var _Grid = _interopRequireDefault(__webpack_require__(42));
	
	var _GridList = _interopRequireDefault(__webpack_require__(501));
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(503));
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(505));
	
	var _Grow = _interopRequireDefault(__webpack_require__(86));
	
	var _Hidden = _interopRequireDefault(__webpack_require__(510));
	
	var _Icon = _interopRequireDefault(__webpack_require__(512));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(38));
	
	var _Input = _interopRequireDefault(__webpack_require__(87));
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(193));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(63));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(194));
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(195));
	
	var _Link = _interopRequireDefault(__webpack_require__(520));
	
	var _List = _interopRequireDefault(__webpack_require__(52));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(65));
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(196));
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(525));
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(527));
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(125));
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(530));
	
	var _Menu = _interopRequireDefault(__webpack_require__(531));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(198));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(199));
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(535));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(66));
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(539));
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(126));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(127));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _Popover = _interopRequireDefault(__webpack_require__(128));
	
	var _Popper = _interopRequireDefault(__webpack_require__(203));
	
	var _Portal = _interopRequireDefault(__webpack_require__(129));
	
	var _Radio = _interopRequireDefault(__webpack_require__(549));
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(551));
	
	var _RootRef = _interopRequireDefault(__webpack_require__(553));
	
	var _Select = _interopRequireDefault(__webpack_require__(130));
	
	var _Slide = _interopRequireDefault(__webpack_require__(205));
	
	var _Slider = _interopRequireDefault(__webpack_require__(559));
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(206));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(131));
	
	var _Step = _interopRequireDefault(__webpack_require__(563));
	
	var _StepButton = _interopRequireDefault(__webpack_require__(565));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(207));
	
	var _StepContent = _interopRequireDefault(__webpack_require__(568));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(208));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(209));
	
	var _Stepper = _interopRequireDefault(__webpack_require__(572));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(67));
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(576));
	
	var _Switch = _interopRequireDefault(__webpack_require__(210));
	
	var _Tab = _interopRequireDefault(__webpack_require__(132));
	
	var _Table = _interopRequireDefault(__webpack_require__(133));
	
	var _TableBody = _interopRequireDefault(__webpack_require__(134));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(69));
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(212));
	
	var _TableHead = _interopRequireDefault(__webpack_require__(213));
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(214));
	
	var _TableRow = _interopRequireDefault(__webpack_require__(88));
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(215));
	
	var _Tabs = _interopRequireDefault(__webpack_require__(135));
	
	var _TextField = _interopRequireDefault(__webpack_require__(70));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(216));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(53));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(89));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(228));
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(638));
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(641));
	
	var _withWidth = _interopRequireDefault(__webpack_require__(139));
	
	var _Zoom = _interopRequireDefault(__webpack_require__(598));

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(38));
	
	var styles = {
	  root: {
	    padding: 9
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0,
	    zIndex: 1
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var SwitchBase = _react.default.forwardRef(function SwitchBase(props, ref) {
	  var autoFocus = props.autoFocus,
	      checkedProp = props.checked,
	      checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      classNameProp = props.className,
	      defaultChecked = props.defaultChecked,
	      disabledProp = props.disabled,
	      icon = props.icon,
	      id = props.id,
	      inputProps = props.inputProps,
	      inputRef = props.inputRef,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      readOnly = props.readOnly,
	      required = props.required,
	      tabIndex = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	
	  var _React$useRef = _react.default.useRef(checkedProp != null),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = _react.default.useState(Boolean(defaultChecked)),
	      checkedState = _React$useState[0],
	      setCheckedState = _React$useState[1];
	
	  var muiFormControl = (0, _useFormControl.default)();
	
	  var handleFocus = function handleFocus(event) {
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var checked = event.target.checked;
	
	    if (!isControlled) {
	      setCheckedState(checked);
	    }
	
	    if (onChange) {
	      onChange(event, checked);
	    }
	  };
	
	  var disabled = disabledProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var checked = isControlled ? checkedProp : checkedState;
	  var hasLabelFor = type === 'checkbox' || type === 'radio';
	  return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	    component: "span",
	    className: (0, _clsx.default)(classes.root, classNameProp, checked && classes.checked, disabled && classes.disabled),
	    disabled: disabled,
	    tabIndex: null,
	    role: undefined,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    ref: ref
	  }, other), _react.default.createElement("input", (0, _extends2.default)({
	    autoFocus: autoFocus,
	    checked: checkedProp,
	    defaultChecked: defaultChecked,
	    className: classes.input,
	    disabled: disabled,
	    id: hasLabelFor && id,
	    name: name,
	    onChange: handleInputChange,
	    readOnly: readOnly,
	    ref: inputRef,
	    required: required,
	    tabIndex: tabIndex,
	    type: type,
	    value: value
	  }, inputProps)), checked ? checkedIcon : icon);
	}); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	
	 false ? SwitchBase.propTypes = {
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}
	
	var _default = unsupportedProp;
	exports.default = _default;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(643));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
	}), 'DateRange');
	
	exports.default = _default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(656));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(659));

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(667));

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(61));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _merge = _interopRequireDefault(__webpack_require__(94));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('@material-ui/system: you are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(32);
	var normalizeHeaderName = __webpack_require__(709);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(239);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(239);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(393)))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(730);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = {
		"status": [
			{
				"id": 101,
				"desc": "BCMU #1 state",
				"type": "value",
				"decode": {
					"0": "normal",
					"1": "full",
					"2": "empty",
					"3": "standby",
					"4": "stop"
				}
			},
			{
				"id": 102,
				"desc": "BCMU #2 state",
				"type": "value",
				"decode": {
					"0": "normal",
					"1": "full",
					"2": "empty",
					"3": "standby",
					"4": "stop"
				}
			},
			{
				"id": 103,
				"desc": "BCMU #3 state",
				"type": "value",
				"decode": {
					"0": "normal",
					"1": "full",
					"2": "empty",
					"3": "standby",
					"4": "stop"
				}
			},
			{
				"id": 104,
				"desc": "BCMU #1 BMU states",
				"type": "bitfield",
				"decode": {
					"0": "bmu_1_fault",
					"1": "bmu_2_fault",
					"2": "bmu_3_fault",
					"3": "bmu_4_fault",
					"4": "bmu_5_fault",
					"5": "bmu_6_fault",
					"6": "bmu_7_fault",
					"7": "bmu_8_fault",
					"8": "bmu_9_fault",
					"9": "bmu_10_fault",
					"10": "bmu_11_fault",
					"11": "bmu_12_fault",
					"12": "bmu_13_fault",
					"13": "bmu_14_fault",
					"14": "bmu_15_fault",
					"15": "bmu_16_fault",
					"16": "bmu_17_fault",
					"17": "bmu_18_fault"
				}
			},
			{
				"id": 105,
				"desc": "BCMU #2 BMU states",
				"type": "bitfield",
				"decode": {
					"0": "bmu_1_fault",
					"1": "bmu_2_fault",
					"2": "bmu_3_fault",
					"3": "bmu_4_fault",
					"4": "bmu_5_fault",
					"5": "bmu_6_fault",
					"6": "bmu_7_fault",
					"7": "bmu_8_fault",
					"8": "bmu_9_fault",
					"9": "bmu_10_fault",
					"10": "bmu_11_fault",
					"11": "bmu_12_fault",
					"12": "bmu_13_fault",
					"13": "bmu_14_fault",
					"14": "bmu_15_fault",
					"15": "bmu_16_fault",
					"16": "bmu_17_fault",
					"17": "bmu_18_fault"
				}
			},
			{
				"id": 106,
				"desc": "BCMU #3 BMU states",
				"type": "bitfield",
				"decode": {
					"0": "bmu_1_fault",
					"1": "bmu_2_fault",
					"2": "bmu_3_fault",
					"3": "bmu_4_fault",
					"4": "bmu_5_fault",
					"5": "bmu_6_fault",
					"6": "bmu_7_fault",
					"7": "bmu_8_fault",
					"8": "bmu_9_fault",
					"9": "bmu_10_fault",
					"10": "bmu_11_fault",
					"11": "bmu_12_fault",
					"12": "bmu_13_fault",
					"13": "bmu_14_fault",
					"14": "bmu_15_fault",
					"15": "bmu_16_fault",
					"16": "bmu_17_fault",
					"17": "bmu_18_fault"
				}
			},
			{
				"id": 107,
				"desc": "BCMU #1 alarm level 1",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_warning",
					"1": "totalvol_high_voltage_warning",
					"2": "charge_over_current_warning",
					"3": "cell_low_voltage_warning",
					"4": "totalvol_low_voltage_warning",
					"5": "discharge_over_current_warning",
					"6": "cell_charge_high_temperature_warning",
					"7": "cell_charge_low_temperature_warning",
					"8": "low_soc_warning",
					"12": "system_low_insulation_warning",
					"13": "high_soc_warning",
					"14": "cell_discharge_high_temperature_warning",
					"15": "cell_discharge_low_temperature_warning"
				}
			},
			{
				"id": 108,
				"desc": "BCMU #2 alarm level 1",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_warning",
					"1": "totalvol_high_voltage_warning",
					"2": "charge_over_current_warning",
					"3": "cell_low_voltage_warning",
					"4": "totalvol_low_voltage_warning",
					"5": "discharge_over_current_warning",
					"6": "cell_charge_high_temperature_warning",
					"7": "cell_charge_low_temperature_warning",
					"8": "low_soc_warning",
					"12": "system_low_insulation_warning",
					"13": "high_soc_warning",
					"14": "cell_discharge_high_temperature_warning",
					"15": "cell_discharge_low_temperature_warning"
				}
			},
			{
				"id": 109,
				"desc": "BCMU #3 alarm level 1",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_warning",
					"1": "totalvol_high_voltage_warning",
					"2": "charge_over_current_warning",
					"3": "cell_low_voltage_warning",
					"4": "totalvol_low_voltage_warning",
					"5": "discharge_over_current_warning",
					"6": "cell_charge_high_temperature_warning",
					"7": "cell_charge_low_temperature_warning",
					"8": "low_soc_warning",
					"12": "system_low_insulation_warning",
					"13": "high_soc_warning",
					"14": "cell_discharge_high_temperature_warning",
					"15": "cell_discharge_low_temperature_warning"
				}
			},
			{
				"id": 110,
				"desc": "BCMU #1 alarm level 2",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 111,
				"desc": "BCMU #2 alarm level 2",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 112,
				"desc": "BCMU #3 alarm level 2",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 119,
				"desc": "BCMU #1 alarm level 3",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 120,
				"desc": "BCMU #2 alarm level 3",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 121,
				"desc": "BCMU #3 alarm level 3",
				"type": "bitfield",
				"decode": {
					"0": "cell_high_voltage_alarm",
					"1": "totalvol_high_voltage_alarm",
					"2": "charge_over_current_alarm",
					"3": "cell_low_voltage_alarm",
					"4": "totalvol_low_voltage_alarm",
					"5": "discharge_over_current_alarm",
					"6": "cell_charge_high_temperature_alarm",
					"7": "cell_charge_low_temperature_alarm",
					"8": "low_soc_alarm",
					"12": "system_low_insulation_alarm",
					"13": "high_soc_alarm",
					"14": "cell_discharge_high_temperature_alarm",
					"15": "cell_discharge_low_temperature_alarm"
				}
			},
			{
				"id": 113,
				"desc": "BAU PCS communication",
				"type": "bitfield",
				"decode": {
					"0": "bau_pcs_communication_fault"
				}
			},
			{
				"id": 114,
				"desc": "BAU BCMU communication",
				"type": "bitfield",
				"decode": {
					"0": "bau_bcmu_communication_fault"
				}
			},
			{
				"id": 115,
				"desc": "BAMS state",
				"type": "bitfield",
				"decode": {
					"0": "bams_fault"
				}
			},
			{
				"id": 116,
				"desc": "BCMU #1 contactor state",
				"type": "bitfield",
				"decode": {
					"1": "contactor_open"
				}
			},
			{
				"id": 117,
				"desc": "BCMU #2 contactor state",
				"type": "bitfield",
				"decode": {
					"1": "contactor_open"
				}
			},
			{
				"id": 118,
				"desc": "BCMU #3 contactor state",
				"type": "bitfield",
				"decode": {
					"1": "contactor_open"
				}
			},
			{
				"id": 201,
				"desc": "Inverter #1 alarm code",
				"type": "raw"
			},
			{
				"id": 202,
				"desc": "Inverter #2 alarm code",
				"type": "raw"
			},
			{
				"id": 203,
				"desc": "Inverter #3 alarm code",
				"type": "raw"
			},
			{
				"id": 204,
				"desc": "Inverter #1 fault code",
				"type": "raw"
			},
			{
				"id": 205,
				"desc": "Inverter #2 fault code",
				"type": "raw"
			},
			{
				"id": 206,
				"desc": "Inverter #3 fault code",
				"type": "raw"
			},
			{
				"id": 208,
				"desc": "Inverter #1 state",
				"type": "bitfield",
				"decode": {
					"0": "ready_switch_on",
					"1": "ready",
					"2": "operation_enable",
					"3": "fault_present",
					"4": "alarm_present"
				}
			},
			{
				"id": 209,
				"desc": "Inverter #2 state",
				"type": "bitfield",
				"decode": {
					"0": "ready_switch_on",
					"1": "ready",
					"2": "operation_enable",
					"3": "fault_present",
					"4": "alarm_present"
				}
			},
			{
				"id": 210,
				"desc": "Inverter #3 state",
				"type": "bitfield",
				"decode": {
					"0": "ready_switch_on",
					"1": "ready",
					"2": "operation_enable",
					"3": "fault_present",
					"4": "alarm_present"
				}
			},
			{
				"id": 211,
				"desc": "PLC status word 1",
				"type": "bitfield",
				"decode": {
					"0": "inhibit_inverter3_discharge",
					"3": "pcs_system_starting",
					"4": "pcs_system_start_finish",
					"5": "pcs_system_stopping",
					"6": "pcs_system_stop_finish",
					"7": "ems_heart_beat_signal_fault",
					"8": "system_alarm_or_fault_present",
					"10": "remote_control",
					"11": "inhibit_inverter1_charge",
					"12": "inhibit_inverter1_discharge",
					"13": "inhibit_inverter2_charge",
					"14": "inhibit_inverter2_discharge",
					"15": "inhibit_inverter3_charge"
				}
			},
			{
				"id": 212,
				"desc": "PLC status word 2",
				"type": "bitfield",
				"decode": {
					"8": "pcs_device_ready_for_switch_on",
					"9": "pcs_device_ready_for_operation",
					"10": "pcs_device_operation_enabled",
					"11": "pcs_device_fault_present",
					"12": "pcs_device_alarm_present"
				}
			}
		]
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49),
	    root = __webpack_require__(40);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(809),
	    mapCacheDelete = __webpack_require__(810),
	    mapCacheGet = __webpack_require__(811),
	    mapCacheHas = __webpack_require__(812),
	    mapCacheSet = __webpack_require__(813);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(41),
	    isSymbol = __webpack_require__(77);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(755),
	    baseKeys = __webpack_require__(770),
	    isArrayLike = __webpack_require__(103);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 155 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate, dirtyOptions) {
	  var weekStartsOn = 1;
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = __webpack_require__(78);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	  var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(875);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(406);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(873);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(864);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(863);
	
	var _index12 = _interopRequireDefault(_index11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 * | Long format             | LT    | 05:30 a.m.                       |
	 * |                         | LTS   | 05:30:15 a.m.                    |
	 * |                         | L     | 07/02/1995                       |
	 * |                         | l     | 7/2/1995                         |
	 * |                         | LL    | July 2 1995                      |
	 * |                         | ll    | Jul 2 1995                       |
	 * |                         | LLL   | July 2 1995 05:30 a.m.           |
	 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
	 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
	 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	
	  var locale = options.locale || _index6.default;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var localeFormatters = locale.formatters || {};
	  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
	  var formatLong = locale.formatLong;
	
	  var originalDate = (0, _index2.default)(dirtyDate, options);
	
	  if (!(0, _index4.default)(originalDate, options)) {
	    return 'Invalid Date';
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = originalDate.getTimezoneOffset();
	  var utcDate = (0, _index12.default)(originalDate, -timezoneOffset, options);
	
	  var formatterOptions = (0, _index10.default)(options);
	  formatterOptions.locale = locale;
	  formatterOptions.formatters = _index8.default;
	
	  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
	  // Right now, please don't use it in locales. If you have to use an original date,
	  // please restore it from `date`, adding a timezone offset to it.
	  formatterOptions._originalDate = originalDate;
	
	  var result = formatStr.replace(longFormattingTokensRegExp, function (substring) {
	    if (substring[0] === '[') {
	      return substring;
	    }
	
	    if (substring[0] === '\\') {
	      return cleanEscapedString(substring);
	    }
	
	    return formatLong(substring);
	  }).replace(formattingTokensRegExp, function (substring) {
	    var formatter = localeFormatters[substring] || _index8.default[substring];
	
	    if (formatter) {
	      return formatter(utcDate, formatterOptions);
	    } else {
	      return cleanEscapedString(substring);
	    }
	  });
	
	  return result;
	}
	
	function cleanEscapedString(input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '');
	  }
	  return input.replace(/\\/g, '');
	}
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var dateToCompare = (0, _index2.default)(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ValidatorComponent = __webpack_require__(894);
	
	var _ValidatorComponent2 = _interopRequireDefault(_ValidatorComponent);
	
	var _ValidatorForm = __webpack_require__(409);
	
	var _ValidatorForm2 = _interopRequireDefault(_ValidatorForm);
	
	var _ValidationRules = __webpack_require__(408);
	
	var _ValidationRules2 = _interopRequireDefault(_ValidationRules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ValidatorComponent = _ValidatorComponent2.default;
	exports.ValidatorForm = _ValidatorForm2.default;
	exports.ValidationRules = _ValidationRules2.default;

/***/ },
/* 165 */
[1022, 896],
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactFormValidatorCore = __webpack_require__(164);
	
	var _SelectValidator = __webpack_require__(899);
	
	var _SelectValidator2 = _interopRequireDefault(_SelectValidator);
	
	var _TextValidator = __webpack_require__(900);
	
	var _TextValidator2 = _interopRequireDefault(_TextValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SelectValidator = _SelectValidator2.default;
	exports.TextValidator = _TextValidator2.default;
	exports.ValidatorComponent = _reactFormValidatorCore.ValidatorComponent;
	exports.ValidatorForm = _reactFormValidatorCore.ValidatorForm;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.default = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ReactReduxContext = _react.default.createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	var _default = ReactReduxContext;
	exports.default = _default;

/***/ },
/* 168 */
4,
/* 169 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastPmax = undefined;
	
	var _types = __webpack_require__(9);
	
	var _lodash = __webpack_require__(27);
	
	var INITIAL_STATE = {
	  data: {
	    battery: [{
	      soc: 0,
	      p: 0,
	      state: 0
	    }],
	    newBattery: [{
	      soc: 0,
	      p: 0,
	      state: 0
	    }],
	    pMax: [{ value: 0 }],
	    pMaxOnPeak: [{ value: 0 }],
	    pMaxOffPeak: [{ value: 0 }],
	    meter_with_bess: [{ p: 0 }],
	    meter_without_bess: [{ p: 0 }],
	    pMaxLoadWithoutBess: [{ value: 0 }],
	    pMaxLoad: [{ value: 0 }],
	    setpoint: [{ p: 0 }],
	    batteryBams: []
	  },
	  layout: {
	    tariff: []
	  }
	};
	
	var getLastNotNullValue = function getLastNotNullValue(state, ref) {
	  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var length = state.chartData.data[ref].length;
	
	  var last = (0, _lodash.get)(state.chartData.data[ref], "[" + (length - index) + "].value", null);
	
	  return last === null && index < length ? getLastNotNullValue(state, ref, index + 1) : last;
	};
	
	var getLastPmax = exports.getLastPmax = function getLastPmax(state) {
	  return getLastNotNullValue(state, 'pMax');
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _types.FETCH_CHART_DATA:
	      return Object.assign({}, state, payload);
	
	    case _types.LATEST_DATA:
	      var newState = Object.assign({}, state);
	      var data = Object.assign({}, newState.data);
	
	      data.battery.splice(0, 1);
	      data.newBattery.splice(0, 1);
	      data.pMax.splice(0, 1);
	      data.pMaxOnPeak.splice(0, 1);
	      data.pMaxOffPeak.splice(0, 1);
	      data.meter_with_bess.splice(0, 1);
	      data.meter_without_bess.splice(0, 1);
	      data.pMaxLoadWithoutBess.splice(0, 1);
	      data.pMaxLoad.splice(0, 1);
	      data.setpoint.splice(0, 1);
	
	      data.battery.push(payload.battery);
	      data.newBattery.push(payload.newBattery);
	      data.meter_with_bess.push(payload.meter_with_bess);
	      data.meter_without_bess.push(payload.meter_without_bess);
	      data.pMax.push(payload.pMax);
	      data.pMaxOnPeak.push(payload.pMaxOnPeak);
	      data.pMaxOffPeak.push(payload.pMaxOffPeak);
	      data.pMaxLoadWithoutBess.push(payload.pMaxLoadWithoutBess);
	      data.pMaxLoad.push(payload.pMaxLoad);
	      data.setpoint.push(payload.setpoint);
	
	      newState.data = data;
	      return newState;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getConfigError = exports.getConfigPending = exports.getConfig = undefined;
	exports.configReducer = configReducer;
	
	var _config = __webpack_require__(418);
	
	var initialState = {
	  pending: false,
	  config: {},
	  error: null
	};
	
	function configReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _config.FETCH_CONFIG_PENDING:
	      return Object.assign({}, state, {
	        pending: true
	      });
	    case _config.FETCH_CONFIG_SUCCESS:
	      return Object.assign({}, state, {
	        pending: false,
	        config: action.payload
	      });
	    case _config.FETCH_CONFIG_ERROR:
	      return Object.assign({}, state, {
	        pending: false,
	        error: action.error
	      });
	    default:
	      return state;
	  }
	}
	
	var getConfig = exports.getConfig = function getConfig(state) {
	  return state.config;
	};
	var getConfigPending = exports.getConfigPending = function getConfigPending(state) {
	  return state.pending;
	};
	var getConfigError = exports.getConfigError = function getConfigError(state) {
	  return state.error;
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updatedDataSelector = undefined;
	
	var _reselect = __webpack_require__(45);
	
	var _inRange = __webpack_require__(835);
	
	var _inRange2 = _interopRequireDefault(_inRange);
	
	var _orderBy = __webpack_require__(838);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var updatedDataSelector = exports.updatedDataSelector = function updatedDataSelector(state) {
	  return state.table.updatedData;
	};
	var dateRangeSelector = function dateRangeSelector(state) {
	  return state.tableDateRange;
	};
	var sortingSelector = function sortingSelector(state) {
	  return state.table.sort;
	};
	var filterSelector = function filterSelector(state) {
	  return state.table.filter;
	};
	
	var convertDisplayedOrderBy = function convertDisplayedOrderBy(orderBy) {
	  if (orderBy === 'displayTimestamp') {
	    return 'timestamp';
	  }
	
	  if (orderBy === 'displayStart') {
	    return 'start';
	  }
	
	  if (orderBy === 'displayEnd') {
	    return 'end';
	  }
	  return orderBy;
	};
	
	var getData = function getData(data, selectedDateRange, selectedSorting, selectedFilter) {
	  var startDate = selectedDateRange.startDate,
	      endDate = selectedDateRange.endDate;
	  var maxPkEnergy = selectedFilter.maxPkEnergy;
	
	  var startUnix = startDate.unix() * 1000;
	  var endUnix = endDate.unix() * 1000;
	
	  var dataSet = [].concat(_toConsumableArray(data));
	
	  // handle time range and Pmax filtering
	  var selectedData = dataSet.filter(function (item) {
	    var time = item.timestamp || item.start;
	    if (item.customer_peak_max_kwh) {
	      return item.customer_peak_max_kwh > maxPkEnergy && (0, _inRange2.default)(time, startUnix, endUnix);
	    }
	
	    return (0, _inRange2.default)(time, startUnix, endUnix);
	  });
	
	  // handle sorting
	  return (0, _orderBy2.default)(selectedData, convertDisplayedOrderBy(selectedSorting.orderBy), selectedSorting.order);
	};
	
	exports.default = (0, _reselect.createSelector)(updatedDataSelector, dateRangeSelector, sortingSelector, filterSelector, getData);

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _config = _interopRequireDefault(__webpack_require__(423));
	
	var _PropTypes = __webpack_require__(424);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(174));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the
	   * `<Transition>` component mounts. If you want to transition on the first
	   * mount set `appear` to `true`, and the component will transition in as soon
	   * as the `<Transition>` mounts.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ },
/* 176 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;

/***/ },
/* 177 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(431);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ },
/* 179 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 180 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	module.exports = _nonIterableRest;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(61);
	
	var assertThisInitialized = __webpack_require__(426);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(176);
	
	var iterableToArrayLimit = __webpack_require__(428);
	
	var nonIterableRest = __webpack_require__(180);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(465));

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(469));

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(474));

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(475));

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(476));

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(481));

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(120));

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(496));

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(497));

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(498));

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(515));

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(517));

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(518));

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(523));

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Popover = _interopRequireDefault(__webpack_require__(128));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(199));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	
	var Menu = _react.default.forwardRef(function Menu(props, ref) {
	  var autoFocusProp = props.autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEntering = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocus = (autoFocusProp !== undefined ? autoFocusProp : !disableAutoFocusItem) && open;
	
	  var menuListActionsRef = _react.default.useRef(null);
	
	  var firstValidItemRef = _react.default.useRef(null);
	
	  var firstSelectedItemRef = _react.default.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return firstSelectedItemRef.current || firstValidItemRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	
	  var firstValidElementIndex = null;
	  var firstSelectedIndex = null;
	
	  var items = _react.default.Children.map(children, function (child, index) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (firstValidElementIndex === null) {
	      firstValidElementIndex = index;
	    }
	
	    var newChildProps = null;
	
	    if (variant !== "menu" && firstSelectedIndex === null && child.props.selected && !child.props.disabled) {
	      firstSelectedIndex = index;
	      newChildProps = {};
	
	      if (autoFocus) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined) {
	        newChildProps.tabIndex = 0;
	      }
	
	      newChildProps.ref = function (instance) {
	        // #StrictMode ready
	        firstSelectedItemRef.current = _reactDom.default.findDOMNode(instance);
	        (0, _reactHelpers.setRef)(child.ref, instance);
	      };
	    } else if (index === firstValidElementIndex) {
	      newChildProps = {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          firstValidItemRef.current = _reactDom.default.findDOMNode(instance);
	          (0, _reactHelpers.setRef)(child.ref, instance);
	        }
	      };
	    }
	
	    if (newChildProps !== null) {
	      return _react.default.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	
	  return _react.default.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    onEntering: handleEntering,
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && firstSelectedIndex === null
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	
	 false ? Menu.propTypes = {
	  /**
	   * The DOM element used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true` (default), the menu list (possibly a particular item depending on the menu variant) will receive focus on open.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * Same as `autoFocus=false`.
	   * @deprecated Use `autoFocus` instead.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(532));

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(533));

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(81));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(82));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(229));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(93));
	
	// Do we have a vertical scrollbar?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    var win = (0, _ownerWindow.default)(doc);
	    return win.innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	function isHideable(node) {
	  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
	}
	
	function siblings(container, mount, currentNode, nodesToExclude, callback) {
	  var blacklist = [mount, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  [].forEach.call(container.children, function (node) {
	    if (blacklist.indexOf(node) === -1 && isHideable(node)) {
	      callback(node);
	    }
	  });
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  siblings(container, mountNode, currentNode, nodesToExclude, function (node) {
	    return ariaHidden(node, show);
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = {};
	  var style = {};
	  var restorePaddings = [];
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    restoreStyle.overflow = containerInfo.container.style.overflow;
	    restoreStyle['padding-right'] = containerInfo.container.style.paddingRight;
	    style.overflow = 'hidden';
	
	    if (isOverflowing(containerInfo.container)) {
	      var scrollbarSize = (0, _getScrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      style['padding-right'] = "".concat(getPaddingRight(containerInfo.container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(containerInfo.container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    }
	  }
	
	  Object.keys(style).forEach(function (key) {
	    containerInfo.container.style[key] = style[key];
	  });
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    Object.keys(restoreStyle).forEach(function (key) {
	      if (restoreStyle[key]) {
	        containerInfo.container.style.setProperty(key, restoreStyle[key]);
	      } else {
	        containerInfo.container.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager =
	/*#__PURE__*/
	function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(202));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(220));
	
	var _Input = _interopRequireDefault(__webpack_require__(87));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {},
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      height: 'auto',
	      // Reset
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      color: theme.palette.action.active,
	      pointerEvents: 'none' // Don't block pointer events on the select under the icon.
	
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultInput = _react.default.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	
	var NativeSelect = _react.default.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return _react.default.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    select: true,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, {}, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	
	 false ? NativeSelect.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _helpers = __webpack_require__(11);
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = _react.default.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : _react.default.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _helpers.capitalize)(variant))])
	  }));
	});
	
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(545));

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var RadioGroupContext = _react.default.createContext();
	
	var _default = RadioGroupContext;
	exports.default = _default;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(556));

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(560));

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(566));

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(569));

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(570));

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(577));

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var TableContext = _react.default.createContext();
	
	var _default = TableContext;
	exports.default = _default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(582));

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	
	var _TableHead = _interopRequireDefault(__webpack_require__(583));

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(584));

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(587));

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(593));

/***/ },
/* 217 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end) + 1;
	
	    if (endIndex === keys.length) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(75));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(625));
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(223));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(627));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(628));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(631));
	
	var _shadows = _interopRequireDefault(__webpack_require__(634));
	
	var _shape = _interopRequireDefault(__webpack_require__(635));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(629));
	
	var _transitions = _interopRequireDefault(__webpack_require__(36));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(227));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      shadowsInput = options.shadows,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _extends2.default)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Inject custom props
	    shadows: shadowsInput || _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing
	  }, (0, _deepmerge.default)({
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other, {
	    isMergeableObject: _isPlainObject.default
	  }));
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  if (false) {
	    if (muiTheme.shadows.length !== 25) {
	      console.error('Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.');
	    }
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(34);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(72));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(34);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(72));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(637));

/***/ },
/* 229 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}
	
	var _default = getScrollbarSize;
	exports.default = _default;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
	}), 'InsertDriveFile');
	
	exports.default = _default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _defineProperty = _interopDefault(__webpack_require__(19));
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var PropTypes = __webpack_require__(3);
	var clsx = _interopDefault(__webpack_require__(8));
	var _extends = _interopDefault(__webpack_require__(4));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(6));
	var Typography = _interopDefault(__webpack_require__(14));
	var styles$5 = __webpack_require__(25);
	var Button = _interopDefault(__webpack_require__(29));
	var Toolbar = _interopDefault(__webpack_require__(53));
	var TextField = _interopDefault(__webpack_require__(70));
	var IconButton = _interopDefault(__webpack_require__(38));
	var InputAdornment = _interopDefault(__webpack_require__(193));
	var rifm = __webpack_require__(1007);
	var SvgIcon = _interopDefault(__webpack_require__(67));
	var _slicedToArray = _interopDefault(__webpack_require__(182));
	var _classCallCheck = _interopDefault(__webpack_require__(81));
	var _createClass = _interopDefault(__webpack_require__(82));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(181));
	var _getPrototypeOf = _interopDefault(__webpack_require__(177));
	var _inherits = _interopDefault(__webpack_require__(178));
	var reactTransitionGroup = __webpack_require__(50);
	var CircularProgress = _interopDefault(__webpack_require__(62));
	var DialogActions = _interopDefault(__webpack_require__(186));
	var DialogContent = _interopDefault(__webpack_require__(187));
	var Dialog = _interopDefault(__webpack_require__(185));
	var Popover = _interopDefault(__webpack_require__(128));
	var Grid = _interopDefault(__webpack_require__(42));
	var Tab = _interopDefault(__webpack_require__(132));
	var Tabs = _interopDefault(__webpack_require__(135));
	var Paper = _interopDefault(__webpack_require__(23));
	
	var MuiPickersContext = React.createContext(null);
	var MuiPickersUtilsProvider = function MuiPickersUtilsProvider(_ref) {
	  var Utils = _ref.utils,
	      children = _ref.children,
	      locale = _ref.locale,
	      libInstance = _ref.libInstance;
	  var utils = React.useMemo(function () {
	    return new Utils({
	      locale: locale,
	      instance: libInstance
	    });
	  }, [Utils, libInstance, locale]);
	  return React.createElement(MuiPickersContext.Provider, {
	    value: utils,
	    children: children
	  });
	};
	 false ? MuiPickersUtilsProvider.propTypes = {
	  utils: PropTypes.func.isRequired,
	  locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  children: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired)]).isRequired
	} : void 0;
	
	var checkUtils = function checkUtils(utils) {
	  if (!utils) {
	    // tslint:disable-next-line
	    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
	  }
	};
	function useUtils() {
	  var utils = React.useContext(MuiPickersContext);
	  checkUtils(utils);
	  return utils;
	}
	
	var ClockType;
	
	(function (ClockType) {
	  ClockType["HOURS"] = "hours";
	  ClockType["MINUTES"] = "minutes";
	  ClockType["SECONDS"] = "seconds";
	})(ClockType || (ClockType = {}));
	
	var ClockType$1 = ClockType;
	
	var useStyles = styles$5.makeStyles(function (theme) {
	  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
	  return {
	    toolbarTxt: {
	      color: styles$5.fade(textColor, 0.54)
	    },
	    toolbarBtnSelected: {
	      color: textColor
	    }
	  };
	}, {
	  name: 'MuiPickersToolbarText'
	});
	
	var ToolbarText = function ToolbarText(_ref) {
	  var selected = _ref.selected,
	      label = _ref.label,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? null : _ref$className,
	      other = _objectWithoutProperties(_ref, ["selected", "label", "className"]);
	
	  var classes = useStyles();
	  return React.createElement(Typography, _extends({
	    children: label,
	    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
	  }, other));
	};
	
	var ToolbarButton = function ToolbarButton(_ref) {
	  var classes = _ref.classes,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? null : _ref$className,
	      label = _ref.label,
	      selected = _ref.selected,
	      variant = _ref.variant,
	      align = _ref.align,
	      typographyClassName = _ref.typographyClassName,
	      other = _objectWithoutProperties(_ref, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);
	
	  return React.createElement(Button, _extends({
	    variant: "text",
	    className: clsx(classes.toolbarBtn, className)
	  }, other), React.createElement(ToolbarText, {
	    align: align,
	    className: typographyClassName,
	    variant: variant,
	    label: label,
	    selected: selected
	  }));
	};
	
	 false ? ToolbarButton.propTypes = {
	  selected: PropTypes.bool.isRequired,
	  label: PropTypes.string.isRequired,
	  classes: PropTypes.any.isRequired,
	  className: PropTypes.string,
	  innerRef: PropTypes.any
	} : void 0;
	ToolbarButton.defaultProps = {
	  className: ''
	};
	var styles = styles$5.createStyles({
	  toolbarBtn: {
	    padding: 0,
	    minWidth: '16px',
	    textTransform: 'none'
	  }
	});
	var ToolbarButton$1 = styles$5.withStyles(styles, {
	  name: 'MuiPickersToolbarButton'
	})(ToolbarButton);
	
	var useStyles$1 = styles$5.makeStyles(function (theme) {
	  return {
	    toolbar: {
	      display: 'flex',
	      flexDirection: 'row',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 100,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
	    },
	    toolbarLandscape: {
	      height: 'auto',
	      maxWidth: 150,
	      padding: 8,
	      justifyContent: 'flex-start'
	    }
	  };
	}, {
	  name: 'MuiPickersToolbar'
	});
	
	var PickerToolbar = function PickerToolbar(_ref) {
	  var children = _ref.children,
	      isLandscape = _ref.isLandscape,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? null : _ref$className,
	      other = _objectWithoutProperties(_ref, ["children", "isLandscape", "className"]);
	
	  var classes = useStyles$1();
	  return React.createElement(Toolbar, _extends({
	    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
	  }, other), children);
	};
	
	/** Use it instead of .includes method for IE support */
	function arrayIncludes(array, itemOrItems) {
	  if (Array.isArray(itemOrItems)) {
	    return itemOrItems.every(function (item) {
	      return array.indexOf(item) !== -1;
	    });
	  }
	
	  return array.indexOf(itemOrItems) !== -1;
	}
	
	var center = {
	  x: 260 / 2,
	  y: 260 / 2
	};
	var basePoint = {
	  x: center.x,
	  y: 0
	};
	var cx = basePoint.x - center.x;
	var cy = basePoint.y - center.y;
	
	var rad2deg = function rad2deg(rad) {
	  return rad * 57.29577951308232;
	};
	
	var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
	  var x = offsetX - center.x;
	  var y = offsetY - center.y;
	  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	  var deg = rad2deg(atan);
	  deg = Math.round(deg / step) * step;
	  deg %= 360;
	  var value = Math.floor(deg / step) || 0;
	  var delta = Math.pow(x, 2) + Math.pow(y, 2);
	  var distance = Math.sqrt(delta);
	  return {
	    value: value,
	    distance: distance
	  };
	};
	
	var getHours = function getHours(offsetX, offsetY, ampm) {
	  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
	      value = _getAngleValue.value,
	      distance = _getAngleValue.distance;
	
	  value = value || 12;
	
	  if (!ampm) {
	    if (distance < 90) {
	      value += 12;
	      value %= 24;
	    }
	  } else {
	    value %= 12;
	  }
	
	  return value;
	};
	var getMinutes = function getMinutes(offsetX, offsetY) {
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var angleStep = step * 6;
	
	  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
	      value = _getAngleValue2.value;
	
	  value = value * step % 60;
	  return value;
	};
	var getMeridiem = function getMeridiem(date, utils) {
	  return utils.getHours(date) >= 12 ? 'pm' : 'am';
	};
	var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
	  if (ampm) {
	    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
	
	    if (currentMeridiem !== meridiem) {
	      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
	      return utils.setHours(time, hours);
	    }
	  }
	
	  return time;
	};
	
	var useStyles$2 = styles$5.makeStyles({
	  toolbarLandscape: {
	    flexWrap: 'wrap'
	  },
	  toolbarAmpmLeftPadding: {
	    paddingLeft: 50
	  },
	  separator: {
	    margin: '0 4px 0 2px',
	    cursor: 'default'
	  },
	  hourMinuteLabel: {
	    display: 'flex',
	    justifyContent: 'flex-end',
	    alignItems: 'flex-end'
	  },
	  hourMinuteLabelAmpmLandscape: {
	    marginTop: 'auto'
	  },
	  hourMinuteLabelReverse: {
	    flexDirection: 'row-reverse'
	  },
	  ampmSelection: {
	    marginLeft: 20,
	    marginRight: -20,
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  ampmLandscape: {
	    margin: '4px 0 auto',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    flexBasis: '100%'
	  },
	  ampmSelectionWithSeconds: {
	    marginLeft: 15,
	    marginRight: 10
	  },
	  ampmLabel: {
	    fontSize: 18
	  }
	}, {
	  name: 'MuiPickersTimePickerToolbar'
	});
	function useMeridiemMode(date, ampm, onChange) {
	  var utils = useUtils();
	  var meridiemMode = getMeridiem(date, utils);
	  var handleMeridiemChange = React.useCallback(function (mode) {
	    var timeWithMeridiem = convertToMeridiem(date, mode, Boolean(ampm), utils);
	    onChange(timeWithMeridiem, false);
	  }, [ampm, date, onChange, utils]);
	  return {
	    meridiemMode: meridiemMode,
	    handleMeridiemChange: handleMeridiemChange
	  };
	}
	var TimePickerToolbar = function TimePickerToolbar(_ref) {
	  var date = _ref.date,
	      views = _ref.views,
	      ampm = _ref.ampm,
	      openView = _ref.openView,
	      onChange = _ref.onChange,
	      isLandscape = _ref.isLandscape,
	      setOpenView = _ref.setOpenView;
	  var utils = useUtils();
	  var theme = styles$5.useTheme();
	  var classes = useStyles$2();
	
	  var _useMeridiemMode = useMeridiemMode(date, ampm, onChange),
	      meridiemMode = _useMeridiemMode.meridiemMode,
	      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;
	
	  var clockTypographyVariant = isLandscape ? 'h3' : 'h2';
	  return React.createElement(PickerToolbar, {
	    isLandscape: isLandscape,
	    className: clsx(isLandscape ? classes.toolbarLandscape : ampm && classes.toolbarAmpmLeftPadding)
	  }, React.createElement("div", {
	    className: clsx(classes.hourMinuteLabel, ampm && isLandscape && classes.hourMinuteLabelAmpmLandscape, {
	      rtl: classes.hourMinuteLabelReverse
	    }[theme.direction])
	  }, arrayIncludes(views, 'hours') && React.createElement(ToolbarButton$1, {
	    variant: clockTypographyVariant,
	    onClick: function onClick() {
	      return setOpenView(ClockType$1.HOURS);
	    },
	    selected: openView === ClockType$1.HOURS,
	    label: utils.getHourText(date, Boolean(ampm))
	  }), arrayIncludes(views, ['hours', 'minutes']) && React.createElement(ToolbarText, {
	    label: ":",
	    variant: clockTypographyVariant,
	    selected: false,
	    className: classes.separator
	  }), arrayIncludes(views, 'minutes') && React.createElement(ToolbarButton$1, {
	    variant: clockTypographyVariant,
	    onClick: function onClick() {
	      return setOpenView(ClockType$1.MINUTES);
	    },
	    selected: openView === ClockType$1.MINUTES,
	    label: utils.getMinuteText(date)
	  }), arrayIncludes(views, ['minutes', 'seconds']) && React.createElement(ToolbarText, {
	    variant: "h2",
	    label: ":",
	    selected: false,
	    className: classes.separator
	  }), arrayIncludes(views, 'seconds') && React.createElement(ToolbarButton$1, {
	    variant: "h2",
	    onClick: function onClick() {
	      return setOpenView(ClockType$1.SECONDS);
	    },
	    selected: openView === ClockType$1.SECONDS,
	    label: utils.getSecondText(date)
	  })), ampm && React.createElement("div", {
	    className: clsx(classes.ampmSelection, isLandscape && classes.ampmLandscape, arrayIncludes(views, 'seconds') && classes.ampmSelectionWithSeconds)
	  }, React.createElement(ToolbarButton$1, {
	    disableRipple: true,
	    variant: "subtitle1",
	    selected: meridiemMode === 'am',
	    typographyClassName: classes.ampmLabel,
	    label: utils.getMeridiemText('am'),
	    onClick: function onClick() {
	      return handleMeridiemChange('am');
	    }
	  }), React.createElement(ToolbarButton$1, {
	    disableRipple: true,
	    variant: "subtitle1",
	    selected: meridiemMode === 'pm',
	    typographyClassName: classes.ampmLabel,
	    label: utils.getMeridiemText('pm'),
	    onClick: function onClick() {
	      return handleMeridiemChange('pm');
	    }
	  })));
	};
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var PureDateInput = function PureDateInput(_ref) {
	  var inputValue = _ref.inputValue,
	      inputVariant = _ref.inputVariant,
	      validationError = _ref.validationError,
	      InputProps = _ref.InputProps,
	      onOpen = _ref.openPicker,
	      _ref$TextFieldCompone = _ref.TextFieldComponent,
	      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField : _ref$TextFieldCompone,
	      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]);
	
	  var PureDateInputProps = React.useMemo(function () {
	    return _objectSpread({}, InputProps, {
	      readOnly: true
	    });
	  }, [InputProps]);
	  return React.createElement(TextFieldComponent, _extends({
	    error: Boolean(validationError),
	    helperText: validationError
	  }, other, {
	    // do not overridable
	    onClick: onOpen,
	    value: inputValue,
	    variant: inputVariant,
	    InputProps: PureDateInputProps,
	    onKeyDown: function onKeyDown(e) {
	      // space
	      if (e.keyCode === 32) {
	        e.stopPropagation();
	        onOpen();
	      }
	    }
	  }));
	};
	PureDateInput.displayName = 'PureDateInput';
	
	var KeyboardIcon = function KeyboardIcon(props) {
	  return React__default.createElement(SvgIcon, props, React__default.createElement("path", {
	    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
	  }), React__default.createElement("path", {
	    fill: "none",
	    d: "M0 0h24v24H0z"
	  }));
	};
	
	var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
	  var invalidLabel = _ref.invalidLabel,
	      emptyLabel = _ref.emptyLabel,
	      labelFunc = _ref.labelFunc;
	  var date = utils.date(value);
	
	  if (labelFunc) {
	    return labelFunc(isEmpty ? null : date, invalidLabel);
	  }
	
	  if (isEmpty) {
	    return emptyLabel || '';
	  }
	
	  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
	};
	
	var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
	  if (strictCompareDates) {
	    return date;
	  }
	
	  return utils.endOfDay(date);
	};
	
	var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
	  if (strictCompareDates) {
	    return date;
	  }
	
	  return utils.startOfDay(date);
	};
	
	var validate = function validate(value, utils, _ref2) {
	  var maxDate = _ref2.maxDate,
	      minDate = _ref2.minDate,
	      disablePast = _ref2.disablePast,
	      disableFuture = _ref2.disableFuture,
	      maxDateMessage = _ref2.maxDateMessage,
	      minDateMessage = _ref2.minDateMessage,
	      invalidDateMessage = _ref2.invalidDateMessage,
	      strictCompareDates = _ref2.strictCompareDates;
	  var parsedValue = utils.date(value); // if null - do not show error
	
	  if (value === null) {
	    return '';
	  }
	
	  if (!utils.isValid(value)) {
	    return invalidDateMessage;
	  }
	
	  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
	    return maxDateMessage;
	  }
	
	  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
	    return maxDateMessage;
	  }
	
	  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
	    return minDateMessage;
	  }
	
	  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
	    return minDateMessage;
	  }
	
	  return '';
	};
	function pick12hOr24hFormat(userFormat) {
	  var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var formats = arguments.length > 2 ? arguments[2] : undefined;
	
	  if (userFormat) {
	    return userFormat;
	  }
	
	  return ampm ? formats['12h'] : formats['24h'];
	}
	function makeMaskFromFormat(format, numberMaskChar) {
	  return format.replace(/[a-z]/gi, numberMaskChar);
	}
	var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
	  return function (value) {
	    var result = '';
	    var parsed = value.replace(refuse, '');
	
	    if (parsed === '') {
	      return parsed;
	    }
	
	    var i = 0;
	    var n = 0;
	
	    while (i < mask.length) {
	      var maskChar = mask[i];
	
	      if (maskChar === numberMaskChar && n < parsed.length) {
	        var parsedChar = parsed[n];
	        result += parsedChar;
	        n += 1;
	      } else {
	        result += maskChar;
	      }
	
	      i += 1;
	    }
	
	    return result;
	  };
	};
	
	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var KeyboardDateInput = function KeyboardDateInput(_ref) {
	  var inputValue = _ref.inputValue,
	      inputVariant = _ref.inputVariant,
	      validationError = _ref.validationError,
	      KeyboardButtonProps = _ref.KeyboardButtonProps,
	      InputAdornmentProps = _ref.InputAdornmentProps,
	      onOpen = _ref.openPicker,
	      onChange = _ref.onChange,
	      InputProps = _ref.InputProps,
	      mask = _ref.mask,
	      _ref$maskChar = _ref.maskChar,
	      maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar,
	      _ref$refuse = _ref.refuse,
	      refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse,
	      format = _ref.format,
	      keyboardIcon = _ref.keyboardIcon,
	      disabled = _ref.disabled,
	      rifmFormatter = _ref.rifmFormatter,
	      _ref$TextFieldCompone = _ref.TextFieldComponent,
	      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField : _ref$TextFieldCompone,
	      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]);
	
	  var inputMask = mask || makeMaskFromFormat(format, maskChar); // prettier-ignore
	
	  var formatter = React.useMemo(function () {
	    return maskedDateFormatter(inputMask, maskChar, refuse);
	  }, [inputMask, maskChar, refuse]);
	  var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
	
	  var handleChange = function handleChange(text) {
	    var finalString = text === '' || text === inputMask ? null : text;
	    onChange(finalString);
	  };
	
	  return React.createElement(rifm.Rifm, {
	    key: inputMask,
	    value: inputValue,
	    onChange: handleChange,
	    refuse: refuse,
	    format: rifmFormatter || formatter
	  }, function (_ref2) {
	    var onChange = _ref2.onChange,
	        value = _ref2.value;
	    return React.createElement(TextFieldComponent, _extends({
	      disabled: disabled,
	      error: Boolean(validationError),
	      helperText: validationError
	    }, other, {
	      value: value,
	      onChange: onChange,
	      variant: inputVariant,
	      InputProps: _objectSpread$1({}, InputProps, _defineProperty({}, "".concat(position, "Adornment"), React.createElement(InputAdornment, _extends({
	        position: position
	      }, InputAdornmentProps), React.createElement(IconButton, _extends({
	        disabled: disabled
	      }, KeyboardButtonProps, {
	        onClick: onOpen
	      }), keyboardIcon))))
	    }));
	  });
	};
	KeyboardDateInput.defaultProps = {
	  keyboardIcon: React.createElement(KeyboardIcon, null)
	};
	
	function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var date = PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]);
	var datePickerView = PropTypes.oneOf(['year', 'month', 'day']);
	/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
	
	var timePickerDefaultProps = {
	  ampm: true,
	  invalidDateMessage: 'Invalid Time Format'
	};
	var datePickerDefaultProps = {
	  minDate: new Date('1900-01-01'),
	  maxDate: new Date('2100-01-01'),
	  invalidDateMessage: 'Invalid Date Format',
	  minDateMessage: 'Date should not be before minimal date',
	  maxDateMessage: 'Date should not be after maximal date',
	  allowKeyboardControl: true
	};
	var dateTimePickerDefaultProps = _objectSpread$2({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
	  showTabs: true
	});
	
	function useOpenState(_ref) {
	  var open = _ref.open,
	      onOpen = _ref.onOpen,
	      onClose = _ref.onClose;
	  var setIsOpenState = null;
	
	  if (open === undefined || open === null) {
	    // The component is uncontrolled, so we need to give it its own state.
	    var _useState = React.useState(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    open = _useState2[0];
	    setIsOpenState = _useState2[1];
	  } // prettier-ignore
	
	
	  var setIsOpen = React.useCallback(function (newIsOpen) {
	    setIsOpenState && setIsOpenState(newIsOpen);
	    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
	  }, [onOpen, onClose, setIsOpenState]);
	  return {
	    isOpen: open,
	    setIsOpen: setIsOpen
	  };
	}
	
	var useValueToDate = function useValueToDate(utils, _ref) {
	  var value = _ref.value,
	      initialFocusedDate = _ref.initialFocusedDate;
	  var nowRef = React.useRef(utils.date());
	  var date = utils.date(value || initialFocusedDate || nowRef.current);
	  return date && utils.isValid(date) ? date : nowRef.current;
	};
	
	function useDateValues(props, options) {
	  var utils = useUtils();
	  var date = useValueToDate(utils, props);
	  var format = props.format || options.getDefaultFormat();
	  return {
	    date: date,
	    format: format
	  };
	}
	
	function usePickerState(props, options) {
	  var autoOk = props.autoOk,
	      disabled = props.disabled,
	      readOnly = props.readOnly,
	      onAccept = props.onAccept,
	      _onChange = props.onChange,
	      onError = props.onError,
	      value = props.value,
	      variant = props.variant;
	  var utils = useUtils();
	
	  var _useOpenState = useOpenState(props),
	      isOpen = _useOpenState.isOpen,
	      setIsOpen = _useOpenState.setIsOpen;
	
	  var _useDateValues = useDateValues(props, options),
	      date = _useDateValues.date,
	      format = _useDateValues.format;
	
	  var _useState = React.useState(date),
	      _useState2 = _slicedToArray(_useState, 2),
	      pickerDate = _useState2[0],
	      setPickerDate = _useState2[1];
	
	  React.useEffect(function () {
	    // if value was changed in closed state - treat it as accepted
	    if (!isOpen && !utils.isEqual(pickerDate, date)) {
	      setPickerDate(date);
	    }
	  }, [date, isOpen, pickerDate, utils]);
	  var acceptDate = React.useCallback(function (acceptedDate) {
	    _onChange(acceptedDate);
	
	    if (onAccept) {
	      onAccept(acceptedDate);
	    }
	
	    setIsOpen(false);
	  }, [onAccept, _onChange, setIsOpen]);
	  var wrapperProps = React.useMemo(function () {
	    return {
	      format: format,
	      open: isOpen,
	      onClear: function onClear() {
	        return acceptDate(null);
	      },
	      onAccept: function onAccept() {
	        return acceptDate(pickerDate);
	      },
	      onSetToday: function onSetToday() {
	        return setPickerDate(utils.date());
	      },
	      onDismiss: function onDismiss() {
	        setIsOpen(false);
	      }
	    };
	  }, [acceptDate, format, isOpen, pickerDate, setIsOpen, utils]);
	  var pickerProps = React.useMemo(function () {
	    return {
	      date: pickerDate,
	      onChange: function onChange(newDate) {
	        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	        setPickerDate(newDate);
	
	        if (isFinish && autoOk) {
	          acceptDate(newDate);
	          return;
	        } // simulate autoOk, but do not close the modal
	
	
	        if (variant === 'inline' || variant === 'static') {
	          _onChange(newDate);
	
	          onAccept && onAccept(newDate);
	        }
	      }
	    };
	  }, [acceptDate, autoOk, onAccept, _onChange, pickerDate, variant]);
	  var validationError = validate(value, utils, props);
	  React.useEffect(function () {
	    if (onError) {
	      onError(validationError, value);
	    }
	  }, [onError, validationError, value]);
	  var inputValue = getDisplayDate(date, format, utils, value === null, props);
	  var inputProps = React.useMemo(function () {
	    return {
	      inputValue: inputValue,
	      validationError: validationError,
	      openPicker: function openPicker() {
	        return !readOnly && !disabled && setIsOpen(true);
	      }
	    };
	  }, [disabled, inputValue, readOnly, setIsOpen, validationError]);
	  var pickerState = {
	    pickerProps: pickerProps,
	    inputProps: inputProps,
	    wrapperProps: wrapperProps
	  };
	  React.useDebugValue(pickerState);
	  return pickerState;
	}
	
	function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function parseInputString(value, utils, format) {
	  try {
	    return utils.parse(value, format);
	  } catch (_unused) {
	    return null;
	  }
	}
	
	function useKeyboardPickerState(props, options) {
	  var _props$format = props.format,
	      format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
	      inputValue = props.inputValue,
	      _onChange = props.onChange,
	      value = props.value;
	  var utils = useUtils();
	  var displayDate = getDisplayDate(value, format, utils, value === null, props);
	
	  var _useState = React.useState(displayDate),
	      _useState2 = _slicedToArray(_useState, 2),
	      innerInputValue = _useState2[0],
	      setInnerInputValue = _useState2[1];
	
	  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
	  React.useEffect(function () {
	    if (value === null || utils.isValid(value)) {
	      setInnerInputValue(displayDate);
	    }
	  }, [displayDate, setInnerInputValue, utils, value]);
	  var handleKeyboardChange = React.useCallback(function (date) {
	    _onChange(date, date === null ? null : utils.format(date, format));
	  }, [format, _onChange, utils]);
	
	  var _usePickerState = usePickerState( // Extend props interface
	  _objectSpread$3({}, props, {
	    value: dateValue,
	    onChange: handleKeyboardChange
	  }), options),
	      innerInputProps = _usePickerState.inputProps,
	      wrapperProps = _usePickerState.wrapperProps,
	      pickerProps = _usePickerState.pickerProps;
	
	  var inputProps = React.useMemo(function () {
	    return _objectSpread$3({}, innerInputProps, {
	      // reuse validation and open/close logic
	      format: wrapperProps.format,
	      inputValue: inputValue || innerInputValue,
	      onChange: function onChange(value) {
	        setInnerInputValue(value || '');
	        var date = value === null ? null : utils.parse(value, wrapperProps.format);
	
	        _onChange(date, value);
	      }
	    });
	  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
	  return {
	    inputProps: inputProps,
	    wrapperProps: wrapperProps,
	    pickerProps: pickerProps
	  };
	}
	
	var useStyles$3 = styles$5.makeStyles(function (theme) {
	  return {
	    day: {
	      width: 36,
	      height: 36,
	      fontSize: theme.typography.caption.fontSize,
	      margin: '0 2px',
	      color: theme.palette.text.primary,
	      fontWeight: theme.typography.fontWeightMedium,
	      padding: 0
	    },
	    hidden: {
	      opacity: 0,
	      pointerEvents: 'none'
	    },
	    current: {
	      color: theme.palette.primary.main,
	      fontWeight: 600
	    },
	    daySelected: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      fontWeight: theme.typography.fontWeightMedium,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.main
	      }
	    },
	    dayDisabled: {
	      pointerEvents: 'none',
	      color: theme.palette.text.hint
	    }
	  };
	}, {
	  name: 'MuiPickersDay'
	});
	var Day = function Day(_ref) {
	  var children = _ref.children,
	      disabled = _ref.disabled,
	      hidden = _ref.hidden,
	      current = _ref.current,
	      selected = _ref.selected,
	      other = _objectWithoutProperties(_ref, ["children", "disabled", "hidden", "current", "selected"]);
	
	  var classes = useStyles$3();
	  var className = clsx(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
	  return React.createElement(IconButton, _extends({
	    className: className,
	    tabIndex: hidden || disabled ? -1 : 0
	  }, other), React.createElement(Typography, {
	    variant: "body2",
	    color: "inherit"
	  }, children));
	};
	Day.displayName = 'Day';
	 false ? Day.propTypes = {
	  current: PropTypes.bool,
	  disabled: PropTypes.bool,
	  hidden: PropTypes.bool,
	  selected: PropTypes.bool
	} : void 0;
	Day.defaultProps = {
	  disabled: false,
	  hidden: false,
	  current: false,
	  selected: false
	};
	
	var DayWrapper = function DayWrapper(_ref) {
	  var children = _ref.children,
	      value = _ref.value,
	      disabled = _ref.disabled,
	      onSelect = _ref.onSelect,
	      dayInCurrentMonth = _ref.dayInCurrentMonth,
	      other = _objectWithoutProperties(_ref, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]);
	
	  var handleClick = React.useCallback(function () {
	    return onSelect(value);
	  }, [onSelect, value]);
	  return React.createElement("div", _extends({
	    role: "presentation",
	    onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
	    onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
	  }, other), children);
	};
	
	var animationDuration = 350;
	var useStyles$4 = styles$5.makeStyles(function (theme) {
	  var slideTransition = theme.transitions.create('transform', {
	    duration: animationDuration,
	    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
	  });
	  return {
	    transitionContainer: {
	      display: 'block',
	      position: 'relative',
	      '& > *': {
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        left: 0
	      }
	    },
	    'slideEnter-left': {
	      willChange: 'transform',
	      transform: 'translate(100%)'
	    },
	    'slideEnter-right': {
	      willChange: 'transform',
	      transform: 'translate(-100%)'
	    },
	    slideEnterActive: {
	      transform: 'translate(0%)',
	      transition: slideTransition
	    },
	    slideExit: {
	      transform: 'translate(0%)'
	    },
	    'slideExitActiveLeft-left': {
	      willChange: 'transform',
	      transform: 'translate(-200%)',
	      transition: slideTransition
	    },
	    'slideExitActiveLeft-right': {
	      willChange: 'transform',
	      transform: 'translate(200%)',
	      transition: slideTransition
	    }
	  };
	}, {
	  name: 'MuiPickersSlideTransition'
	});
	
	var SlideTransition = function SlideTransition(_ref) {
	  var children = _ref.children,
	      transKey = _ref.transKey,
	      slideDirection = _ref.slideDirection,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? null : _ref$className;
	  var classes = useStyles$4();
	  var transitionClasses = {
	    exit: classes.slideExit,
	    enterActive: classes.slideEnterActive,
	    // @ts-ignore
	    enter: classes['slideEnter-' + slideDirection],
	    // @ts-ignore
	    exitActive: classes['slideExitActiveLeft-' + slideDirection]
	  };
	  return React.createElement(reactTransitionGroup.TransitionGroup, {
	    className: clsx(classes.transitionContainer, className),
	    childFactory: function childFactory(element) {
	      return React.cloneElement(element, {
	        classNames: transitionClasses
	      });
	    }
	  }, React.createElement(reactTransitionGroup.CSSTransition, {
	    mountOnEnter: true,
	    unmountOnExit: true,
	    key: transKey + slideDirection,
	    timeout: animationDuration,
	    classNames: transitionClasses,
	    children: children
	  }));
	};
	
	var ArrowLeftIcon = function ArrowLeftIcon(props) {
	  return React__default.createElement(SvgIcon, props, React__default.createElement("path", {
	    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	  }), React__default.createElement("path", {
	    fill: "none",
	    d: "M0 0h24v24H0V0z"
	  }));
	};
	
	var ArrowRightIcon = function ArrowRightIcon(props) {
	  return React__default.createElement(SvgIcon, props, React__default.createElement("path", {
	    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	  }), React__default.createElement("path", {
	    fill: "none",
	    d: "M0 0h24v24H0V0z"
	  }));
	};
	
	var useStyles$5 = styles$5.makeStyles(function (theme) {
	  return {
	    switchHeader: {
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      marginTop: theme.spacing(0.5),
	      marginBottom: theme.spacing(1)
	    },
	    transitionContainer: {
	      width: '100%',
	      overflow: 'hidden',
	      height: 23
	    },
	    iconButton: {
	      zIndex: 1,
	      backgroundColor: theme.palette.background.paper
	    },
	    daysHeader: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      maxHeight: 16
	    },
	    dayLabel: {
	      width: 36,
	      margin: '0 2px',
	      textAlign: 'center',
	      color: theme.palette.text.hint
	    }
	  };
	}, {
	  name: 'MuiPickersCalendarHeader'
	});
	var CalendarHeader = function CalendarHeader(_ref) {
	  var currentMonth = _ref.currentMonth,
	      onMonthChange = _ref.onMonthChange,
	      leftArrowIcon = _ref.leftArrowIcon,
	      rightArrowIcon = _ref.rightArrowIcon,
	      leftArrowButtonProps = _ref.leftArrowButtonProps,
	      rightArrowButtonProps = _ref.rightArrowButtonProps,
	      disablePrevMonth = _ref.disablePrevMonth,
	      disableNextMonth = _ref.disableNextMonth,
	      slideDirection = _ref.slideDirection;
	  var utils = useUtils();
	  var classes = useStyles$5();
	  var theme = styles$5.useTheme();
	  var rtl = theme.direction === 'rtl';
	
	  var selectNextMonth = function selectNextMonth() {
	    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
	  };
	
	  var selectPreviousMonth = function selectPreviousMonth() {
	    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
	  };
	
	  return React.createElement("div", null, React.createElement("div", {
	    className: classes.switchHeader
	  }, React.createElement(IconButton, _extends({}, leftArrowButtonProps, {
	    disabled: disablePrevMonth,
	    onClick: selectPreviousMonth,
	    className: classes.iconButton
	  }), rtl ? rightArrowIcon : leftArrowIcon), React.createElement(SlideTransition, {
	    slideDirection: slideDirection,
	    transKey: currentMonth.toString(),
	    className: classes.transitionContainer
	  }, React.createElement(Typography, {
	    align: "center",
	    variant: "body1"
	  }, utils.getCalendarHeaderText(currentMonth))), React.createElement(IconButton, _extends({}, rightArrowButtonProps, {
	    disabled: disableNextMonth,
	    onClick: selectNextMonth,
	    className: classes.iconButton
	  }), rtl ? leftArrowIcon : rightArrowIcon)), React.createElement("div", {
	    className: classes.daysHeader
	  }, utils.getWeekdays().map(function (day, index) {
	    return React.createElement(Typography, {
	      key: index // eslint-disable-line react/no-array-index-key
	      ,
	      variant: "caption",
	      className: classes.dayLabel
	    }, day);
	  })));
	};
	CalendarHeader.displayName = 'CalendarHeader';
	 false ? CalendarHeader.propTypes = {
	  leftArrowIcon: PropTypes.node,
	  rightArrowIcon: PropTypes.node,
	  disablePrevMonth: PropTypes.bool,
	  disableNextMonth: PropTypes.bool
	} : void 0;
	CalendarHeader.defaultProps = {
	  leftArrowIcon: React.createElement(ArrowLeftIcon, null),
	  rightArrowIcon: React.createElement(ArrowRightIcon, null),
	  disablePrevMonth: false,
	  disableNextMonth: false
	};
	
	var DIALOG_WIDTH = 310;
	var DIALOG_WIDTH_WIDER = 325;
	var VIEW_HEIGHT = 305;
	
	var useStyles$6 = styles$5.makeStyles(function (theme) {
	  return {
	    staticWrapperRoot: {
	      overflow: 'hidden',
	      minWidth: DIALOG_WIDTH,
	      display: 'flex',
	      flexDirection: 'column',
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	}, {
	  name: 'MuiPickersStaticWrapper'
	});
	var StaticWrapper = function StaticWrapper(_ref) {
	  var children = _ref.children;
	  var classes = useStyles$6();
	  return React.createElement("div", {
	    className: classes.staticWrapperRoot,
	    children: children
	  });
	};
	
	var ModalDialog = function ModalDialog(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      onAccept = _ref.onAccept,
	      onDismiss = _ref.onDismiss,
	      onClear = _ref.onClear,
	      onSetToday = _ref.onSetToday,
	      okLabel = _ref.okLabel,
	      cancelLabel = _ref.cancelLabel,
	      clearLabel = _ref.clearLabel,
	      todayLabel = _ref.todayLabel,
	      clearable = _ref.clearable,
	      showTodayButton = _ref.showTodayButton,
	      showTabs = _ref.showTabs,
	      wider = _ref.wider,
	      other = _objectWithoutProperties(_ref, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);
	
	  return React.createElement(Dialog, _extends({
	    role: "dialog",
	    onClose: onDismiss,
	    classes: {
	      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
	    }
	  }, other), React.createElement(DialogContent, {
	    children: children,
	    className: classes.dialog
	  }), React.createElement(DialogActions, {
	    classes: {
	      root: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
	    }
	  }, clearable && React.createElement(Button, {
	    color: "primary",
	    onClick: onClear
	  }, clearLabel), showTodayButton && React.createElement(Button, {
	    color: "primary",
	    onClick: onSetToday
	  }, todayLabel), cancelLabel && React.createElement(Button, {
	    color: "primary",
	    onClick: onDismiss
	  }, cancelLabel), okLabel && React.createElement(Button, {
	    color: "primary",
	    onClick: onAccept
	  }, okLabel)));
	};
	ModalDialog.displayName = 'ModalDialog';
	var styles$1 = styles$5.createStyles({
	  dialogRoot: {
	    minWidth: DIALOG_WIDTH
	  },
	  dialogRootWider: {
	    minWidth: DIALOG_WIDTH_WIDER
	  },
	  dialog: {
	    '&:first-child': {
	      padding: 0
	    }
	  },
	  withAdditionalAction: {
	    // set justifyContent to default value to fix IE11 layout bug
	    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
	    justifyContent: 'flex-start',
	    '& > *:first-child': {
	      marginRight: 'auto'
	    }
	  }
	});
	var ModalDialog$1 = styles$5.withStyles(styles$1, {
	  name: 'MuiPickersModal'
	})(ModalDialog);
	
	var useIsomorphicEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	function runKeyHandler(e, keyHandlers) {
	  var handler = keyHandlers[e.key];
	
	  if (handler) {
	    handler(); // if event was handled prevent other side effects (e.g. page scroll)
	
	    e.preventDefault();
	  }
	}
	function useKeyDown(active, keyHandlers) {
	  var keyHandlersRef = React.useRef(keyHandlers);
	  keyHandlersRef.current = keyHandlers;
	  useIsomorphicEffect(function () {
	    if (active) {
	      var handleKeyDown = function handleKeyDown(event) {
	        runKeyHandler(event, keyHandlersRef.current);
	      };
	
	      window.addEventListener('keydown', handleKeyDown);
	      return function () {
	        window.removeEventListener('keydown', handleKeyDown);
	      };
	    }
	  }, [active]);
	}
	
	var ModalWrapper = function ModalWrapper(_ref) {
	  var open = _ref.open,
	      children = _ref.children,
	      okLabel = _ref.okLabel,
	      cancelLabel = _ref.cancelLabel,
	      clearLabel = _ref.clearLabel,
	      todayLabel = _ref.todayLabel,
	      showTodayButton = _ref.showTodayButton,
	      clearable = _ref.clearable,
	      DialogProps = _ref.DialogProps,
	      showTabs = _ref.showTabs,
	      wider = _ref.wider,
	      InputComponent = _ref.InputComponent,
	      DateInputProps = _ref.DateInputProps,
	      onClear = _ref.onClear,
	      onAccept = _ref.onAccept,
	      onDismiss = _ref.onDismiss,
	      onSetToday = _ref.onSetToday,
	      other = _objectWithoutProperties(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);
	
	  useKeyDown(open, {
	    Enter: onAccept
	  });
	  return React.createElement(React.Fragment, null, React.createElement(InputComponent, _extends({}, other, DateInputProps)), React.createElement(ModalDialog$1, _extends({
	    wider: wider,
	    showTabs: showTabs,
	    open: open,
	    onClear: onClear,
	    onAccept: onAccept,
	    onDismiss: onDismiss,
	    onSetToday: onSetToday,
	    clearLabel: clearLabel,
	    todayLabel: todayLabel,
	    okLabel: okLabel,
	    cancelLabel: cancelLabel,
	    clearable: clearable,
	    showTodayButton: showTodayButton,
	    children: children
	  }, DialogProps)));
	};
	 false ? ModalWrapper.propTypes = {
	  okLabel: PropTypes.node,
	  cancelLabel: PropTypes.node,
	  clearLabel: PropTypes.node,
	  clearable: PropTypes.bool,
	  todayLabel: PropTypes.node,
	  showTodayButton: PropTypes.bool,
	  DialogProps: PropTypes.object
	} : void 0;
	ModalWrapper.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel',
	  clearLabel: 'Clear',
	  todayLabel: 'Today',
	  clearable: false,
	  showTodayButton: false
	};
	
	var InlineWrapper = function InlineWrapper(_ref) {
	  var open = _ref.open,
	      wider = _ref.wider,
	      children = _ref.children,
	      PopoverProps = _ref.PopoverProps,
	      onClear = _ref.onClear,
	      onDismiss = _ref.onDismiss,
	      onSetToday = _ref.onSetToday,
	      onAccept = _ref.onAccept,
	      showTabs = _ref.showTabs,
	      DateInputProps = _ref.DateInputProps,
	      InputComponent = _ref.InputComponent,
	      other = _objectWithoutProperties(_ref, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]);
	
	  var ref = React.useRef();
	  useKeyDown(open, {
	    Enter: onAccept
	  });
	  return React.createElement(React.Fragment, null, React.createElement(InputComponent, _extends({}, other, DateInputProps, {
	    inputRef: ref
	  })), React.createElement(Popover, _extends({
	    open: open,
	    onClose: onDismiss,
	    anchorEl: ref.current,
	    anchorOrigin: {
	      vertical: 'bottom',
	      horizontal: 'center'
	    },
	    transformOrigin: {
	      vertical: 'top',
	      horizontal: 'center'
	    },
	    children: children
	  }, PopoverProps)));
	};
	 false ? InlineWrapper.propTypes = {
	  onOpen: PropTypes.func,
	  onClose: PropTypes.func,
	  PopoverProps: PropTypes.object
	} : void 0;
	
	function getWrapperFromVariant(variant) {
	  switch (variant) {
	    case 'inline':
	      return InlineWrapper;
	
	    case 'static':
	      return StaticWrapper;
	
	    default:
	      return ModalWrapper;
	  }
	}
	var VariantContext = React.createContext(null);
	var Wrapper = function Wrapper(_ref) {
	  var variant = _ref.variant,
	      props = _objectWithoutProperties(_ref, ["variant"]);
	
	  var Component = getWrapperFromVariant(variant);
	  return React.createElement(VariantContext.Provider, {
	    value: variant || 'dialog'
	  }, React.createElement(Component, props));
	};
	
	var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
	  var date = _ref.date,
	      utils = _ref.utils,
	      minDate = _ref.minDate,
	      maxDate = _ref.maxDate,
	      disableFuture = _ref.disableFuture,
	      disablePast = _ref.disablePast,
	      shouldDisableDate = _ref.shouldDisableDate;
	  var today = utils.startOfDay(utils.date());
	
	  if (disablePast && utils.isBefore(minDate, today)) {
	    minDate = today;
	  }
	
	  if (disableFuture && utils.isAfter(maxDate, today)) {
	    maxDate = today;
	  }
	
	  var forward = date;
	  var backward = date;
	
	  if (utils.isBefore(date, minDate)) {
	    forward = utils.date(minDate);
	    backward = null;
	  }
	
	  if (utils.isAfter(date, maxDate)) {
	    if (backward) {
	      backward = utils.date(maxDate);
	    }
	
	    forward = null;
	  }
	
	  while (forward || backward) {
	    if (forward && utils.isAfter(forward, maxDate)) {
	      forward = null;
	    }
	
	    if (backward && utils.isBefore(backward, minDate)) {
	      backward = null;
	    }
	
	    if (forward) {
	      if (!shouldDisableDate(forward)) {
	        return forward;
	      }
	
	      forward = utils.addDays(forward, 1);
	    }
	
	    if (backward) {
	      if (!shouldDisableDate(backward)) {
	        return backward;
	      }
	
	      backward = utils.addDays(backward, -1);
	    }
	  }
	
	  return null;
	};
	var isYearOnlyView = function isYearOnlyView(views) {
	  return views.length === 1 && views[0] === 'year';
	};
	var isYearAndMonthViews = function isYearAndMonthViews(views) {
	  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
	};
	var getFormatByViews = function getFormatByViews(views, utils) {
	  if (isYearOnlyView(views)) {
	    return utils.yearFormat;
	  }
	
	  if (isYearAndMonthViews(views)) {
	    return utils.yearMonthFormat;
	  }
	
	  return utils.dateFormat;
	};
	
	var withUtils = function withUtils() {
	  return function (Component) {
	    var WithUtils = function WithUtils(props) {
	      var utils = useUtils();
	      return React.createElement(Component, _extends({
	        utils: utils
	      }, props));
	    };
	
	    WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
	    return WithUtils;
	  };
	};
	
	var KeyDownListener = function KeyDownListener(_ref) {
	  var onKeyDown = _ref.onKeyDown;
	  React.useEffect(function () {
	    window.addEventListener('keydown', onKeyDown);
	    return function () {
	      window.removeEventListener('keydown', onKeyDown);
	    };
	  }, [onKeyDown]);
	  return null;
	};
	
	var Calendar =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  function Calendar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      slideDirection: 'left',
	      currentMonth: _this.props.utils.startOfMonth(_this.props.date),
	      loadingQueue: 0
	    };
	
	    _this.pushToLoadingQueue = function () {
	      var loadingQueue = _this.state.loadingQueue + 1;
	
	      _this.setState({
	        loadingQueue: loadingQueue
	      });
	    };
	
	    _this.popFromLoadingQueue = function () {
	      var loadingQueue = _this.state.loadingQueue;
	      loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
	
	      _this.setState({
	        loadingQueue: loadingQueue
	      });
	    };
	
	    _this.handleChangeMonth = function (newMonth, slideDirection) {
	      _this.setState({
	        currentMonth: newMonth,
	        slideDirection: slideDirection
	      });
	
	      if (_this.props.onMonthChange) {
	        var returnVal = _this.props.onMonthChange(newMonth);
	
	        if (returnVal) {
	          _this.pushToLoadingQueue();
	
	          returnVal.then(function () {
	            _this.popFromLoadingQueue();
	          });
	        }
	      }
	    };
	
	    _this.validateMinMaxDate = function (day) {
	      var _this$props = _this.props,
	          minDate = _this$props.minDate,
	          maxDate = _this$props.maxDate,
	          utils = _this$props.utils,
	          disableFuture = _this$props.disableFuture,
	          disablePast = _this$props.disablePast;
	      var now = utils.date();
	      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
	    };
	
	    _this.shouldDisablePrevMonth = function () {
	      var _this$props2 = _this.props,
	          utils = _this$props2.utils,
	          disablePast = _this$props2.disablePast,
	          minDate = _this$props2.minDate;
	      var now = utils.date();
	      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
	      return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
	    };
	
	    _this.shouldDisableNextMonth = function () {
	      var _this$props3 = _this.props,
	          utils = _this$props3.utils,
	          disableFuture = _this$props3.disableFuture,
	          maxDate = _this$props3.maxDate;
	      var now = utils.date();
	      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
	      return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
	    };
	
	    _this.shouldDisableDate = function (day) {
	      var shouldDisableDate = _this.props.shouldDisableDate;
	      return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
	    };
	
	    _this.handleDaySelect = function (day) {
	      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var _this$props4 = _this.props,
	          date = _this$props4.date,
	          utils = _this$props4.utils;
	
	      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
	    };
	
	    _this.moveToDay = function (day) {
	      var utils = _this.props.utils;
	
	      if (day && !_this.shouldDisableDate(day)) {
	        if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) {
	          _this.handleChangeMonth(utils.startOfMonth(day), 'left');
	        }
	
	        _this.handleDaySelect(day, false);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var _this$props5 = _this.props,
	          theme = _this$props5.theme,
	          date = _this$props5.date,
	          utils = _this$props5.utils;
	      runKeyHandler(event, {
	        ArrowUp: function ArrowUp() {
	          return _this.moveToDay(utils.addDays(date, -7));
	        },
	        ArrowDown: function ArrowDown() {
	          return _this.moveToDay(utils.addDays(date, 7));
	        },
	        ArrowLeft: function ArrowLeft() {
	          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
	        },
	        ArrowRight: function ArrowRight() {
	          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
	        }
	      });
	    };
	
	    _this.renderWeeks = function () {
	      var _this$props6 = _this.props,
	          utils = _this$props6.utils,
	          classes = _this$props6.classes;
	      var weeks = utils.getWeekArray(_this.state.currentMonth);
	      return weeks.map(function (week) {
	        return React.createElement("div", {
	          key: "week-".concat(week[0].toString()),
	          className: classes.week
	        }, _this.renderDays(week));
	      });
	    };
	
	    _this.renderDays = function (week) {
	      var _this$props7 = _this.props,
	          date = _this$props7.date,
	          renderDay = _this$props7.renderDay,
	          utils = _this$props7.utils;
	      var now = utils.date();
	      var selectedDate = utils.startOfDay(date);
	      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
	      return week.map(function (day) {
	        var disabled = _this.shouldDisableDate(day);
	
	        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
	        var dayComponent = React.createElement(Day, {
	          disabled: disabled,
	          current: utils.isSameDay(day, now),
	          hidden: !isDayInCurrentMonth,
	          selected: utils.isSameDay(selectedDate, day)
	        }, utils.getDayText(day));
	
	        if (renderDay) {
	          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
	        }
	
	        return React.createElement(DayWrapper, {
	          value: day,
	          key: day.toString(),
	          disabled: disabled,
	          dayInCurrentMonth: isDayInCurrentMonth,
	          onSelect: _this.handleDaySelect
	        }, dayComponent);
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props8 = this.props,
	          date = _this$props8.date,
	          minDate = _this$props8.minDate,
	          maxDate = _this$props8.maxDate,
	          utils = _this$props8.utils,
	          disablePast = _this$props8.disablePast,
	          disableFuture = _this$props8.disableFuture;
	
	      if (this.shouldDisableDate(date)) {
	        var closestEnabledDate = findClosestEnabledDate({
	          date: date,
	          utils: utils,
	          minDate: utils.date(minDate),
	          maxDate: utils.date(maxDate),
	          disablePast: Boolean(disablePast),
	          disableFuture: Boolean(disableFuture),
	          shouldDisableDate: this.shouldDisableDate
	        });
	        this.handleDaySelect(closestEnabledDate, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state = this.state,
	          currentMonth = _this$state.currentMonth,
	          slideDirection = _this$state.slideDirection;
	      var _this$props9 = this.props,
	          classes = _this$props9.classes,
	          allowKeyboardControl = _this$props9.allowKeyboardControl,
	          leftArrowButtonProps = _this$props9.leftArrowButtonProps,
	          leftArrowIcon = _this$props9.leftArrowIcon,
	          rightArrowButtonProps = _this$props9.rightArrowButtonProps,
	          rightArrowIcon = _this$props9.rightArrowIcon,
	          loadingIndicator = _this$props9.loadingIndicator;
	      var loadingElement = loadingIndicator ? loadingIndicator : React.createElement(CircularProgress, null);
	      return React.createElement(React.Fragment, null, allowKeyboardControl && this.context !== 'static' && React.createElement(KeyDownListener, {
	        onKeyDown: this.handleKeyDown
	      }), React.createElement(CalendarHeader, {
	        currentMonth: currentMonth,
	        slideDirection: slideDirection,
	        onMonthChange: this.handleChangeMonth,
	        leftArrowIcon: leftArrowIcon,
	        leftArrowButtonProps: leftArrowButtonProps,
	        rightArrowIcon: rightArrowIcon,
	        rightArrowButtonProps: rightArrowButtonProps,
	        disablePrevMonth: this.shouldDisablePrevMonth(),
	        disableNextMonth: this.shouldDisableNextMonth()
	      }), React.createElement(SlideTransition, {
	        slideDirection: slideDirection,
	        transKey: currentMonth.toString(),
	        className: classes.transitionContainer
	      }, React.createElement(React.Fragment, null, this.state.loadingQueue > 0 && React.createElement("div", {
	        className: classes.progressContainer
	      }, loadingElement) || React.createElement("div", null, this.renderWeeks()))));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, state) {
	      var utils = nextProps.utils,
	          nextDate = nextProps.date;
	
	      if (!utils.isEqual(nextDate, state.lastDate)) {
	        var nextMonth = utils.getMonth(nextDate);
	        var lastDate = state.lastDate || nextDate;
	        var lastMonth = utils.getMonth(lastDate);
	        return {
	          lastDate: nextDate,
	          currentMonth: nextProps.utils.startOfMonth(nextDate),
	          // prettier-ignore
	          slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Calendar;
	}(React.Component);
	Calendar.contextType = VariantContext;
	 false ? Calendar.propTypes = {
	  renderDay: PropTypes.func,
	  shouldDisableDate: PropTypes.func,
	  allowKeyboardControl: PropTypes.bool
	} : void 0;
	Calendar.defaultProps = {
	  minDate: new Date('1900-01-01'),
	  maxDate: new Date('2100-01-01'),
	  disablePast: false,
	  disableFuture: false,
	  allowKeyboardControl: true
	};
	var styles$2 = function styles(theme) {
	  return {
	    transitionContainer: {
	      minHeight: 36 * 6,
	      marginTop: theme.spacing(1.5)
	    },
	    progressContainer: {
	      width: '100%',
	      height: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    week: {
	      display: 'flex',
	      justifyContent: 'center'
	    }
	  };
	};
	var Calendar$1 = styles$5.withStyles(styles$2, {
	  name: 'MuiPickersCalendar',
	  withTheme: true
	})(withUtils()(Calendar));
	
	function useViews(views, openTo, onChange) {
	  var _React$useState = React.useState(openTo && arrayIncludes(views, openTo) ? openTo : views[0]),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      openView = _React$useState2[0],
	      setOpenView = _React$useState2[1];
	
	  var handleChangeAndOpenNext = React.useCallback(function (date, isFinish) {
	    var nextViewToOpen = views[views.indexOf(openView) + 1];
	
	    if (isFinish && nextViewToOpen) {
	      // do not close picker if needs to show next view
	      onChange(date, false);
	      setOpenView(nextViewToOpen);
	      return;
	    }
	
	    onChange(date, Boolean(isFinish));
	  }, [onChange, openView, views]);
	  return {
	    handleChangeAndOpenNext: handleChangeAndOpenNext,
	    openView: openView,
	    setOpenView: setOpenView
	  };
	}
	
	var ClockPointer =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ClockPointer, _React$Component);
	
	  function ClockPointer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ClockPointer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      toAnimateTransform: false,
	      previousType: undefined
	    };
	
	    _this.getAngleStyle = function () {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          isInner = _this$props.isInner,
	          type = _this$props.type;
	      var max = type === ClockType$1.HOURS ? 12 : 60;
	      var angle = 360 / max * value;
	
	      if (type === ClockType$1.HOURS && value > 12) {
	        angle -= 360; // round up angle to max 360 degrees
	      }
	
	      return {
	        height: isInner ? '26%' : '40%',
	        transform: "rotateZ(".concat(angle, "deg)")
	      };
	    };
	
	    return _this;
	  }
	
	  _createClass(ClockPointer, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          classes = _this$props2.classes,
	          hasSelected = _this$props2.hasSelected;
	      return React.createElement("div", {
	        style: this.getAngleStyle(),
	        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
	      }, React.createElement("div", {
	        className: clsx(classes.thumb, hasSelected && classes.noPoint)
	      }));
	    }
	  }]);
	
	  return ClockPointer;
	}(React.Component);
	
	ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
	  if (nextProps.type !== state.previousType) {
	    return {
	      toAnimateTransform: true,
	      previousType: nextProps.type
	    };
	  }
	
	  return {
	    toAnimateTransform: false,
	    previousType: nextProps.type
	  };
	};
	
	var styles$3 = function styles(theme) {
	  return styles$5.createStyles({
	    pointer: {
	      width: 2,
	      backgroundColor: theme.palette.primary.main,
	      position: 'absolute',
	      left: 'calc(50% - 1px)',
	      bottom: '50%',
	      transformOrigin: 'center bottom 0px'
	    },
	    animateTransform: {
	      transition: theme.transitions.create(['transform', 'height'])
	    },
	    thumb: {
	      width: 4,
	      height: 4,
	      backgroundColor: theme.palette.primary.contrastText,
	      borderRadius: '100%',
	      position: 'absolute',
	      top: -21,
	      left: -15,
	      border: "14px solid ".concat(theme.palette.primary.main),
	      boxSizing: 'content-box'
	    },
	    noPoint: {
	      backgroundColor: theme.palette.primary.main
	    }
	  });
	};
	var ClockPointer$1 = styles$5.withStyles(styles$3, {
	  name: 'MuiPickersClockPointer'
	})(ClockPointer);
	
	var Clock =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Clock, _React$Component);
	
	  function Clock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Clock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.isMoving = false;
	
	    _this.handleTouchMove = function (e) {
	      _this.isMoving = true;
	
	      _this.setTime(e);
	    };
	
	    _this.handleTouchEnd = function (e) {
	      if (_this.isMoving) {
	        _this.setTime(e, true);
	
	        _this.isMoving = false;
	      }
	    };
	
	    _this.handleMove = function (e) {
	      e.preventDefault();
	      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
	
	      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
	
	      if (isButtonPressed) {
	        _this.setTime(e.nativeEvent, false);
	      }
	    };
	
	    _this.handleMouseUp = function (e) {
	      if (_this.isMoving) {
	        _this.isMoving = false;
	      }
	
	      _this.setTime(e.nativeEvent, true);
	    };
	
	    _this.hasSelected = function () {
	      var _this$props = _this.props,
	          type = _this$props.type,
	          value = _this$props.value;
	
	      if (type === ClockType$1.HOURS) {
	        return true;
	      }
	
	      return value % 5 === 0;
	    };
	
	    return _this;
	  }
	
	  _createClass(Clock, [{
	    key: "setTime",
	    value: function setTime(e) {
	      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var offsetX = e.offsetX,
	          offsetY = e.offsetY;
	
	      if (typeof offsetX === 'undefined') {
	        var rect = e.target.getBoundingClientRect();
	        offsetX = e.changedTouches[0].clientX - rect.left;
	        offsetY = e.changedTouches[0].clientY - rect.top;
	      }
	
	      var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
	      this.props.onChange(value, isFinish);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          classes = _this$props2.classes,
	          value = _this$props2.value,
	          children = _this$props2.children,
	          type = _this$props2.type,
	          ampm = _this$props2.ampm;
	      var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
	      return React.createElement("div", {
	        className: classes.container
	      }, React.createElement("div", {
	        className: classes.clock
	      }, React.createElement("div", {
	        role: "menu",
	        tabIndex: -1,
	        className: classes.squareMask,
	        onTouchMove: this.handleTouchMove,
	        onTouchEnd: this.handleTouchEnd,
	        onMouseUp: this.handleMouseUp,
	        onMouseMove: this.handleMove
	      }), React.createElement("div", {
	        className: classes.pin
	      }), React.createElement(ClockPointer$1, {
	        type: type,
	        value: value,
	        isInner: isPointerInner,
	        hasSelected: this.hasSelected()
	      }), children));
	    }
	  }]);
	
	  return Clock;
	}(React.Component);
	 false ? Clock.propTypes = {
	  type: PropTypes.oneOf(Object.keys(ClockType$1).map(function (key) {
	    return ClockType$1[key];
	  })).isRequired,
	  value: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  children: PropTypes.arrayOf(PropTypes.node).isRequired,
	  ampm: PropTypes.bool,
	  minutesStep: PropTypes.number,
	  innerRef: PropTypes.any
	} : void 0;
	Clock.defaultProps = {
	  ampm: false,
	  minutesStep: 1
	};
	var styles$4 = function styles(theme) {
	  return styles$5.createStyles({
	    container: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'flex-end',
	      margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
	    },
	    clock: {
	      backgroundColor: 'rgba(0,0,0,.07)',
	      borderRadius: '50%',
	      height: 260,
	      width: 260,
	      position: 'relative',
	      pointerEvents: 'none',
	      zIndex: 1
	    },
	    squareMask: {
	      width: '100%',
	      height: '100%',
	      position: 'absolute',
	      pointerEvents: 'auto',
	      outline: 'none',
	      touchActions: 'none',
	      userSelect: 'none',
	      '&:active': {
	        cursor: 'move'
	      }
	    },
	    pin: {
	      width: 6,
	      height: 6,
	      borderRadius: '50%',
	      backgroundColor: theme.palette.primary.main,
	      position: 'absolute',
	      top: '50%',
	      left: '50%',
	      transform: 'translate(-50%, -50%)'
	    }
	  });
	};
	var Clock$1 = styles$5.withStyles(styles$4, {
	  name: 'MuiPickersClock'
	})(Clock);
	
	var positions = {
	  0: [0, 40],
	  1: [55, 19.6],
	  2: [94.4, 59.5],
	  3: [109, 114],
	  4: [94.4, 168.5],
	  5: [54.5, 208.4],
	  6: [0, 223],
	  7: [-54.5, 208.4],
	  8: [-94.4, 168.5],
	  9: [-109, 114],
	  10: [-94.4, 59.5],
	  11: [-54.5, 19.6],
	  12: [0, 5],
	  13: [36.9, 49.9],
	  14: [64, 77],
	  15: [74, 114],
	  16: [64, 151],
	  17: [37, 178],
	  18: [0, 188],
	  19: [-37, 178],
	  20: [-64, 151],
	  21: [-74, 114],
	  22: [-64, 77],
	  23: [-37, 50]
	};
	var useStyles$7 = styles$5.makeStyles(function (theme) {
	  var size = theme.spacing(4);
	  return {
	    clockNumber: {
	      width: size,
	      height: 32,
	      userSelect: 'none',
	      position: 'absolute',
	      left: "calc(50% - ".concat(size / 2, "px)"),
	      display: 'inline-flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      borderRadius: '50%',
	      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
	    },
	    clockNumberSelected: {
	      color: theme.palette.primary.contrastText
	    }
	  };
	}, {
	  name: 'MuiPickersClockNumber'
	});
	var ClockNumber = function ClockNumber(_ref) {
	  var selected = _ref.selected,
	      label = _ref.label,
	      index = _ref.index,
	      isInner = _ref.isInner;
	  var classes = useStyles$7();
	  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected);
	  var transformStyle = React.useMemo(function () {
	    var position = positions[index];
	    return {
	      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
	    };
	  }, [index]);
	  return React.createElement(Typography, {
	    component: "span",
	    className: className,
	    variant: isInner ? 'body2' : 'body1',
	    style: transformStyle,
	    children: label
	  });
	};
	
	var getHourNumbers = function getHourNumbers(_ref) {
	  var ampm = _ref.ampm,
	      utils = _ref.utils,
	      date = _ref.date;
	  var currentHours = utils.getHours(date);
	  var hourNumbers = [];
	  var startHour = ampm ? 1 : 0;
	  var endHour = ampm ? 12 : 23;
	
	  var isSelected = function isSelected(hour) {
	    if (ampm) {
	      if (hour === 12) {
	        return currentHours === 12 || currentHours === 0;
	      }
	
	      return currentHours === hour || currentHours - 12 === hour;
	    }
	
	    return currentHours === hour;
	  };
	
	  for (var hour = startHour; hour <= endHour; hour += 1) {
	    var label = hour.toString();
	
	    if (hour === 0) {
	      label = '00';
	    }
	
	    var props = {
	      index: hour,
	      label: utils.formatNumber(label),
	      selected: isSelected(hour),
	      isInner: !ampm && (hour === 0 || hour > 12)
	    };
	    hourNumbers.push(React.createElement(ClockNumber, _extends({
	      key: hour
	    }, props)));
	  }
	
	  return hourNumbers;
	};
	var getMinutesNumbers = function getMinutesNumbers(_ref2) {
	  var value = _ref2.value,
	      utils = _ref2.utils;
	  var f = utils.formatNumber;
	  return [React.createElement(ClockNumber, {
	    label: f('00'),
	    selected: value === 0,
	    index: 12,
	    key: 12
	  }), React.createElement(ClockNumber, {
	    label: f('05'),
	    selected: value === 5,
	    index: 1,
	    key: 1
	  }), React.createElement(ClockNumber, {
	    label: f('10'),
	    selected: value === 10,
	    index: 2,
	    key: 2
	  }), React.createElement(ClockNumber, {
	    label: f('15'),
	    selected: value === 15,
	    index: 3,
	    key: 3
	  }), React.createElement(ClockNumber, {
	    label: f('20'),
	    selected: value === 20,
	    index: 4,
	    key: 4
	  }), React.createElement(ClockNumber, {
	    label: f('25'),
	    selected: value === 25,
	    index: 5,
	    key: 5
	  }), React.createElement(ClockNumber, {
	    label: f('30'),
	    selected: value === 30,
	    index: 6,
	    key: 6
	  }), React.createElement(ClockNumber, {
	    label: f('35'),
	    selected: value === 35,
	    index: 7,
	    key: 7
	  }), React.createElement(ClockNumber, {
	    label: f('40'),
	    selected: value === 40,
	    index: 8,
	    key: 8
	  }), React.createElement(ClockNumber, {
	    label: f('45'),
	    selected: value === 45,
	    index: 9,
	    key: 9
	  }), React.createElement(ClockNumber, {
	    label: f('50'),
	    selected: value === 50,
	    index: 10,
	    key: 10
	  }), React.createElement(ClockNumber, {
	    label: f('55'),
	    selected: value === 55,
	    index: 11,
	    key: 11
	  })];
	};
	
	var ClockView = function ClockView(_ref) {
	  var type = _ref.type,
	      onHourChange = _ref.onHourChange,
	      onMinutesChange = _ref.onMinutesChange,
	      onSecondsChange = _ref.onSecondsChange,
	      ampm = _ref.ampm,
	      date = _ref.date,
	      minutesStep = _ref.minutesStep;
	  var utils = useUtils();
	  var viewProps = React.useMemo(function () {
	    switch (type) {
	      case ClockType$1.HOURS:
	        return {
	          value: utils.getHours(date),
	          children: getHourNumbers({
	            date: date,
	            utils: utils,
	            ampm: Boolean(ampm)
	          }),
	          onChange: function onChange(value, isFinish) {
	            var currentMeridiem = getMeridiem(date, utils);
	            var updatedTimeWithMeridiem = convertToMeridiem(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
	            onHourChange(updatedTimeWithMeridiem, isFinish);
	          }
	        };
	
	      case ClockType$1.MINUTES:
	        var minutesValue = utils.getMinutes(date);
	        return {
	          value: minutesValue,
	          children: getMinutesNumbers({
	            value: minutesValue,
	            utils: utils
	          }),
	          onChange: function onChange(value, isFinish) {
	            var updatedTime = utils.setMinutes(date, value);
	            onMinutesChange(updatedTime, isFinish);
	          }
	        };
	
	      case ClockType$1.SECONDS:
	        var secondsValue = utils.getSeconds(date);
	        return {
	          value: secondsValue,
	          children: getMinutesNumbers({
	            value: secondsValue,
	            utils: utils
	          }),
	          onChange: function onChange(value, isFinish) {
	            var updatedTime = utils.setSeconds(date, value);
	            onSecondsChange(updatedTime, isFinish);
	          }
	        };
	
	      default:
	        throw new Error('You must provide the type for TimePickerView');
	    }
	  }, [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type, utils]);
	  return React.createElement(Clock$1, _extends({
	    type: type,
	    ampm: ampm,
	    minutesStep: minutesStep
	  }, viewProps));
	};
	ClockView.displayName = 'TimePickerView';
	 false ? ClockView.propTypes = {
	  date: PropTypes.object.isRequired,
	  onHourChange: PropTypes.func.isRequired,
	  onMinutesChange: PropTypes.func.isRequired,
	  onSecondsChange: PropTypes.func.isRequired,
	  ampm: PropTypes.bool,
	  minutesStep: PropTypes.number,
	  type: PropTypes.oneOf(Object.keys(ClockType$1).map(function (key) {
	    return ClockType$1[key];
	  })).isRequired
	} : void 0;
	ClockView.defaultProps = {
	  ampm: true,
	  minutesStep: 1
	};
	var ClockView$1 = React.memo(ClockView);
	
	var useStyles$8 = styles$5.makeStyles(function (theme) {
	  return {
	    root: {
	      height: 40,
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      cursor: 'pointer',
	      outline: 'none',
	      '&:focus': {
	        color: theme.palette.primary.main,
	        fontWeight: theme.typography.fontWeightMedium
	      }
	    },
	    yearSelected: {
	      margin: '10px 0',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	    yearDisabled: {
	      pointerEvents: 'none',
	      color: theme.palette.text.hint
	    }
	  };
	}, {
	  name: 'MuiPickersYear'
	});
	var Year = function Year(_ref) {
	  var onSelect = _ref.onSelect,
	      forwardedRef = _ref.forwardedRef,
	      value = _ref.value,
	      selected = _ref.selected,
	      disabled = _ref.disabled,
	      children = _ref.children,
	      other = _objectWithoutProperties(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]);
	
	  var classes = useStyles$8();
	  var handleClick = React.useCallback(function () {
	    return onSelect(value);
	  }, [onSelect, value]);
	  return React.createElement(Typography, _extends({
	    role: "button",
	    component: "div",
	    tabIndex: disabled ? -1 : 0,
	    onClick: handleClick,
	    onKeyPress: handleClick,
	    color: selected ? 'primary' : undefined,
	    variant: selected ? 'h5' : 'subtitle1',
	    children: children,
	    ref: forwardedRef,
	    className: clsx(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
	  }, other));
	};
	Year.displayName = 'Year';
	var Year$1 = React.forwardRef(function (props, ref) {
	  return React.createElement(Year, _extends({}, props, {
	    forwardedRef: ref
	  }));
	});
	
	var useStyles$9 = styles$5.makeStyles({
	  container: {
	    height: 300,
	    overflowY: 'auto'
	  }
	}, {
	  name: 'MuiPickersYearSelection'
	});
	var YearSelection = function YearSelection(_ref) {
	  var date = _ref.date,
	      onChange = _ref.onChange,
	      onYearChange = _ref.onYearChange,
	      minDate = _ref.minDate,
	      maxDate = _ref.maxDate,
	      disablePast = _ref.disablePast,
	      disableFuture = _ref.disableFuture,
	      animateYearScrolling = _ref.animateYearScrolling;
	  var utils = useUtils();
	  var classes = useStyles$9();
	  var currentVariant = React.useContext(VariantContext);
	  var selectedYearRef = React.useRef(null);
	  React.useEffect(function () {
	    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
	      selectedYearRef.current.scrollIntoView({
	        block: currentVariant === 'static' ? 'nearest' : 'center',
	        behavior: animateYearScrolling ? 'smooth' : 'auto'
	      });
	    }
	  }, []); // eslint-disable-line
	
	  var currentYear = utils.getYear(date);
	  var onYearSelect = React.useCallback(function (year) {
	    var newDate = utils.setYear(date, year);
	
	    if (onYearChange) {
	      onYearChange(newDate);
	    }
	
	    onChange(newDate, true);
	  }, [date, onChange, onYearChange, utils]);
	  return React.createElement("div", {
	    className: classes.container
	  }, utils.getYearRange(minDate, maxDate).map(function (year) {
	    var yearNumber = utils.getYear(year);
	    var selected = yearNumber === currentYear;
	    return React.createElement(Year$1, {
	      key: utils.getYearText(year),
	      selected: selected,
	      value: yearNumber,
	      onSelect: onYearSelect,
	      ref: selected ? selectedYearRef : undefined,
	      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
	    }, utils.getYearText(year));
	  }));
	};
	
	var useStyles$a = styles$5.makeStyles(function (theme) {
	  return {
	    root: {
	      flex: '1 0 33.33%',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      cursor: 'pointer',
	      outline: 'none',
	      height: 75,
	      transition: theme.transitions.create('font-size', {
	        duration: '100ms'
	      }),
	      '&:focus': {
	        color: theme.palette.primary.main,
	        fontWeight: theme.typography.fontWeightMedium
	      }
	    },
	    monthSelected: {
	      color: theme.palette.primary.main,
	      fontWeight: theme.typography.fontWeightMedium
	    },
	    monthDisabled: {
	      pointerEvents: 'none',
	      color: theme.palette.text.hint
	    }
	  };
	}, {
	  name: 'MuiPickersMonth'
	});
	var Month = function Month(_ref) {
	  var selected = _ref.selected,
	      onSelect = _ref.onSelect,
	      disabled = _ref.disabled,
	      value = _ref.value,
	      children = _ref.children,
	      other = _objectWithoutProperties(_ref, ["selected", "onSelect", "disabled", "value", "children"]);
	
	  var classes = useStyles$a();
	  var handleSelection = React.useCallback(function () {
	    onSelect(value);
	  }, [onSelect, value]);
	  return React.createElement(Typography, _extends({
	    role: "button",
	    component: "div",
	    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
	    tabIndex: disabled ? -1 : 0,
	    onClick: handleSelection,
	    onKeyPress: handleSelection,
	    color: selected ? 'primary' : undefined,
	    variant: selected ? 'h5' : 'subtitle1',
	    children: children
	  }, other));
	};
	Month.displayName = 'Month';
	
	var useStyles$b = styles$5.makeStyles({
	  container: {
	    width: 310,
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignContent: 'stretch'
	  }
	}, {
	  name: 'MuiPickersMonthSelection'
	});
	var MonthSelection = function MonthSelection(_ref) {
	  var disablePast = _ref.disablePast,
	      disableFuture = _ref.disableFuture,
	      minDate = _ref.minDate,
	      maxDate = _ref.maxDate,
	      date = _ref.date,
	      onMonthChange = _ref.onMonthChange,
	      onChange = _ref.onChange;
	  var utils = useUtils();
	  var classes = useStyles$b();
	  var currentMonth = utils.getMonth(date);
	
	  var shouldDisableMonth = function shouldDisableMonth(month) {
	    var now = utils.date();
	    var utilMinDate = utils.date(minDate);
	    var utilMaxDate = utils.date(maxDate);
	    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
	    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
	    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
	    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
	    return isBeforeFirstEnabled || isAfterLastEnabled;
	  };
	
	  var onMonthSelect = React.useCallback(function (month) {
	    var newDate = utils.setMonth(date, month);
	    onChange(newDate, true);
	
	    if (onMonthChange) {
	      onMonthChange(newDate);
	    }
	  }, [date, onChange, onMonthChange, utils]);
	  return React.createElement("div", {
	    className: classes.container
	  }, utils.getMonthArray(date).map(function (month) {
	    var monthNumber = utils.getMonth(month);
	    var monthText = utils.format(month, 'MMM');
	    return React.createElement(Month, {
	      key: monthText,
	      value: monthNumber,
	      selected: monthNumber === currentMonth,
	      onSelect: onMonthSelect,
	      disabled: shouldDisableMonth(month)
	    }, monthText);
	  }));
	};
	
	var getOrientation = function getOrientation() {
	  if (typeof window === 'undefined') {
	    return 'portrait';
	  }
	
	  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
	    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
	  } // Support IOS safari
	
	
	  if (window.orientation) {
	    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
	  }
	
	  return 'portrait';
	};
	
	function useIsLandscape(customOrientation) {
	  var _React$useState = React.useState(getOrientation()),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      orientation = _React$useState2[0],
	      setOrientation = _React$useState2[1];
	
	  var eventHandler = React.useCallback(function () {
	    return setOrientation(getOrientation());
	  }, []);
	  useIsomorphicEffect(function () {
	    window.addEventListener('orientationchange', eventHandler);
	    return function () {
	      return window.removeEventListener('orientationchange', eventHandler);
	    };
	  }, [eventHandler]);
	  var orientationToUse = customOrientation || orientation;
	  return orientationToUse === 'landscape';
	}
	
	function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var viewsMap = {
	  year: YearSelection,
	  month: MonthSelection,
	  date: Calendar$1,
	  hours: ClockView,
	  minutes: ClockView,
	  seconds: ClockView
	};
	var useStyles$c = styles$5.makeStyles({
	  container: {
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  containerLandscape: {
	    flexDirection: 'row'
	  },
	  pickerView: {
	    overflowX: 'hidden',
	    minHeight: VIEW_HEIGHT,
	    minWidth: DIALOG_WIDTH,
	    maxWidth: DIALOG_WIDTH_WIDER,
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center'
	  },
	  pickerViewLandscape: {
	    padding: '0 8px'
	  }
	}, {
	  name: 'MuiPickersBasePicker'
	});
	var Picker = function Picker(_ref) {
	  var date = _ref.date,
	      views = _ref.views,
	      disableToolbar = _ref.disableToolbar,
	      onChange = _ref.onChange,
	      openTo = _ref.openTo,
	      unparsedMinDate = _ref.minDate,
	      unparsedMaxDate = _ref.maxDate,
	      ToolbarComponent = _ref.ToolbarComponent,
	      orientation = _ref.orientation,
	      rest = _objectWithoutProperties(_ref, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]);
	
	  var utils = useUtils();
	  var classes = useStyles$c();
	  var isLandscape = useIsLandscape(orientation);
	
	  var _useViews = useViews(views, openTo, onChange),
	      openView = _useViews.openView,
	      setOpenView = _useViews.setOpenView,
	      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
	
	  var minDate = React.useMemo(function () {
	    return utils.date(unparsedMinDate);
	  }, [unparsedMinDate, utils]);
	  var maxDate = React.useMemo(function () {
	    return utils.date(unparsedMaxDate);
	  }, [unparsedMaxDate, utils]);
	  return React.createElement("div", {
	    className: clsx(classes.container, isLandscape && classes.containerLandscape)
	  }, !disableToolbar && React.createElement(ToolbarComponent, _extends({}, rest, {
	    views: views,
	    isLandscape: isLandscape,
	    date: date,
	    onChange: onChange,
	    setOpenView: setOpenView,
	    openView: openView
	  })), React.createElement("div", {
	    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
	  }, openView === 'year' && React.createElement(YearSelection, _extends({}, rest, {
	    date: date,
	    onChange: handleChangeAndOpenNext,
	    minDate: minDate,
	    maxDate: maxDate
	  })), openView === 'month' && React.createElement(MonthSelection, _extends({}, rest, {
	    date: date,
	    onChange: handleChangeAndOpenNext,
	    minDate: minDate,
	    maxDate: maxDate
	  })), openView === 'date' && React.createElement(Calendar$1, _extends({}, rest, {
	    date: date,
	    onChange: handleChangeAndOpenNext,
	    minDate: minDate,
	    maxDate: maxDate
	  })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && React.createElement(ClockView, _extends({}, rest, {
	    date: date,
	    type: openView,
	    onHourChange: handleChangeAndOpenNext,
	    onMinutesChange: handleChangeAndOpenNext,
	    onSecondsChange: handleChangeAndOpenNext
	  }))));
	};
	Picker.defaultProps = _objectSpread$4({}, datePickerDefaultProps, {
	  views: Object.keys(viewsMap)
	});
	
	function makePickerWithState(_ref) {
	  var Input = _ref.Input,
	      useState = _ref.useState,
	      useOptions = _ref.useOptions,
	      getCustomProps = _ref.getCustomProps,
	      DefaultToolbarComponent = _ref.DefaultToolbarComponent;
	
	  function PickerWithState(props) {
	    var allowKeyboardControl = props.allowKeyboardControl,
	        ampm = props.ampm,
	        animateYearScrolling = props.animateYearScrolling,
	        autoOk = props.autoOk,
	        dateRangeIcon = props.dateRangeIcon,
	        disableFuture = props.disableFuture,
	        disablePast = props.disablePast,
	        disableToolbar = props.disableToolbar,
	        emptyLabel = props.emptyLabel,
	        format = props.format,
	        forwardedRef = props.forwardedRef,
	        hideTabs = props.hideTabs,
	        initialFocusedDate = props.initialFocusedDate,
	        invalidDateMessage = props.invalidDateMessage,
	        invalidLabel = props.invalidLabel,
	        labelFunc = props.labelFunc,
	        leftArrowButtonProps = props.leftArrowButtonProps,
	        leftArrowIcon = props.leftArrowIcon,
	        loadingIndicator = props.loadingIndicator,
	        maxDate = props.maxDate,
	        maxDateMessage = props.maxDateMessage,
	        minDate = props.minDate,
	        minDateMessage = props.minDateMessage,
	        minutesStep = props.minutesStep,
	        onAccept = props.onAccept,
	        onChange = props.onChange,
	        onClose = props.onClose,
	        onMonthChange = props.onMonthChange,
	        onOpen = props.onOpen,
	        onYearChange = props.onYearChange,
	        openTo = props.openTo,
	        orientation = props.orientation,
	        renderDay = props.renderDay,
	        rightArrowButtonProps = props.rightArrowButtonProps,
	        rightArrowIcon = props.rightArrowIcon,
	        shouldDisableDate = props.shouldDisableDate,
	        strictCompareDates = props.strictCompareDates,
	        timeIcon = props.timeIcon,
	        _props$ToolbarCompone = props.ToolbarComponent,
	        ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone,
	        value = props.value,
	        variant = props.variant,
	        views = props.views,
	        other = _objectWithoutProperties(props, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]);
	
	    var injectedProps = getCustomProps ? getCustomProps(props) : {};
	    var options = useOptions(props);
	
	    var _useState = useState(props, options),
	        pickerProps = _useState.pickerProps,
	        inputProps = _useState.inputProps,
	        wrapperProps = _useState.wrapperProps;
	
	    return React.createElement(Wrapper, _extends({
	      variant: variant,
	      InputComponent: Input,
	      DateInputProps: inputProps
	    }, injectedProps, wrapperProps, other), React.createElement(Picker, _extends({}, pickerProps, {
	      allowKeyboardControl: allowKeyboardControl,
	      ampm: ampm,
	      animateYearScrolling: animateYearScrolling,
	      dateRangeIcon: dateRangeIcon,
	      disableFuture: disableFuture,
	      disablePast: disablePast,
	      disableToolbar: disableToolbar,
	      hideTabs: hideTabs,
	      leftArrowButtonProps: leftArrowButtonProps,
	      leftArrowIcon: leftArrowIcon,
	      loadingIndicator: loadingIndicator,
	      maxDate: maxDate,
	      minDate: minDate,
	      minutesStep: minutesStep,
	      onMonthChange: onMonthChange,
	      onYearChange: onYearChange,
	      openTo: openTo,
	      orientation: orientation,
	      renderDay: renderDay,
	      rightArrowButtonProps: rightArrowButtonProps,
	      rightArrowIcon: rightArrowIcon,
	      shouldDisableDate: shouldDisableDate,
	      strictCompareDates: strictCompareDates,
	      timeIcon: timeIcon,
	      ToolbarComponent: ToolbarComponent,
	      views: views
	    })));
	  }
	
	  return PickerWithState;
	}
	
	function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var defaultProps = _objectSpread$5({}, timePickerDefaultProps, {
	  openTo: 'hours',
	  views: ['hours', 'minutes']
	});
	
	function useOptions(props) {
	  var utils = useUtils();
	  return {
	    getDefaultFormat: function getDefaultFormat() {
	      return pick12hOr24hFormat(props.format, props.ampm, {
	        '12h': utils.time12hFormat,
	        '24h': utils.time24hFormat
	      });
	    }
	  };
	}
	
	var TimePicker = makePickerWithState({
	  useOptions: useOptions,
	  Input: PureDateInput,
	  useState: usePickerState,
	  DefaultToolbarComponent: TimePickerToolbar
	});
	var KeyboardTimePicker = makePickerWithState({
	  useOptions: useOptions,
	  Input: KeyboardDateInput,
	  useState: useKeyboardPickerState,
	  DefaultToolbarComponent: TimePickerToolbar,
	  getCustomProps: function getCustomProps(props) {
	    return {
	      refuse: props.ampm ? /[^\dap]+/gi : /[^\d]+/gi
	    };
	  }
	});
	TimePicker.defaultProps = defaultProps;
	KeyboardTimePicker.defaultProps = defaultProps;
	
	var useStyles$d = styles$5.makeStyles({
	  toolbar: {
	    flexDirection: 'column',
	    alignItems: 'flex-start'
	  },
	  toolbarLandscape: {
	    padding: 16
	  },
	  dateLandscape: {
	    marginRight: 16
	  }
	}, {
	  name: 'MuiPickersDatePickerRoot'
	});
	var DatePickerToolbar = function DatePickerToolbar(_ref) {
	  var date = _ref.date,
	      views = _ref.views,
	      setOpenView = _ref.setOpenView,
	      isLandscape = _ref.isLandscape,
	      openView = _ref.openView;
	  var utils = useUtils();
	  var classes = useStyles$d();
	  var isYearOnly = React.useMemo(function () {
	    return isYearOnlyView(views);
	  }, [views]);
	  var isYearAndMonth = React.useMemo(function () {
	    return isYearAndMonthViews(views);
	  }, [views]);
	  return React.createElement(PickerToolbar, {
	    isLandscape: isLandscape,
	    className: clsx(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
	  }, React.createElement(ToolbarButton$1, {
	    variant: isYearOnly ? 'h3' : 'subtitle1',
	    onClick: function onClick() {
	      return setOpenView('year');
	    },
	    selected: openView === 'year',
	    label: utils.getYearText(date)
	  }), !isYearOnly && !isYearAndMonth && React.createElement(ToolbarButton$1, {
	    variant: "h4",
	    selected: openView === 'date',
	    onClick: function onClick() {
	      return setOpenView('date');
	    },
	    align: isLandscape ? 'left' : 'center',
	    label: utils.getDatePickerHeaderText(date),
	    className: clsx(isLandscape && classes.dateLandscape)
	  }), isYearAndMonth && React.createElement(ToolbarButton$1, {
	    variant: "h4",
	    onClick: function onClick() {
	      return setOpenView('month');
	    },
	    selected: openView === 'month',
	    label: utils.getMonthText(date)
	  }));
	};
	
	function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var defaultProps$1 = _objectSpread$6({}, datePickerDefaultProps, {
	  openTo: 'date',
	  views: ['year', 'date']
	});
	
	function useOptions$1(props) {
	  var utils = useUtils();
	  return {
	    getDefaultFormat: function getDefaultFormat() {
	      return getFormatByViews(props.views, utils);
	    }
	  };
	}
	
	var DatePicker = makePickerWithState({
	  useOptions: useOptions$1,
	  Input: PureDateInput,
	  useState: usePickerState,
	  DefaultToolbarComponent: DatePickerToolbar
	});
	var KeyboardDatePicker = makePickerWithState({
	  useOptions: useOptions$1,
	  Input: KeyboardDateInput,
	  useState: useKeyboardPickerState,
	  DefaultToolbarComponent: DatePickerToolbar
	});
	DatePicker.defaultProps = defaultProps$1;
	KeyboardDatePicker.defaultProps = defaultProps$1;
	
	var TimeIcon = function TimeIcon(props) {
	  return React__default.createElement(SvgIcon, props, React__default.createElement("path", {
	    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	  }), React__default.createElement("path", {
	    fill: "none",
	    d: "M0 0h24v24H0z"
	  }), React__default.createElement("path", {
	    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	  }));
	};
	
	var DateRangeIcon = function DateRangeIcon(props) {
	  return React__default.createElement(SvgIcon, props, React__default.createElement("path", {
	    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
	  }), React__default.createElement("path", {
	    fill: "none",
	    d: "M0 0h24v24H0z"
	  }));
	};
	
	var viewToTabIndex = function viewToTabIndex(openView) {
	  if (openView === 'date' || openView === 'year') {
	    return 'date';
	  }
	
	  return 'time';
	};
	
	var tabIndexToView = function tabIndexToView(tab) {
	  if (tab === 'date') {
	    return 'date';
	  }
	
	  return 'hours';
	};
	
	var useStyles$e = styles$5.makeStyles(function (theme) {
	  // prettier-ignore
	  var tabsBackground = theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"];
	  return {
	    tabs: {
	      color: theme.palette.getContrastText(tabsBackground),
	      backgroundColor: tabsBackground
	    }
	  };
	}, {
	  name: 'MuiPickerDTTabs'
	});
	var DateTimePickerTabs = function DateTimePickerTabs(_ref) {
	  var view = _ref.view,
	      onChange = _ref.onChange,
	      dateRangeIcon = _ref.dateRangeIcon,
	      timeIcon = _ref.timeIcon;
	  var classes = useStyles$e();
	  var theme = styles$5.useTheme();
	  var indicatorColor = theme.palette.type === 'light' ? 'secondary' : 'primary';
	
	  var handleChange = function handleChange(e, value) {
	    if (value !== viewToTabIndex(view)) {
	      onChange(tabIndexToView(value));
	    }
	  };
	
	  return React.createElement(Paper, null, React.createElement(Tabs, {
	    variant: "fullWidth",
	    value: viewToTabIndex(view),
	    onChange: handleChange,
	    className: classes.tabs,
	    indicatorColor: indicatorColor
	  }, React.createElement(Tab, {
	    value: "date",
	    icon: React.createElement(React.Fragment, null, dateRangeIcon)
	  }), React.createElement(Tab, {
	    value: "time",
	    icon: React.createElement(React.Fragment, null, timeIcon)
	  })));
	};
	DateTimePickerTabs.defaultProps = {
	  dateRangeIcon: React.createElement(DateRangeIcon, null),
	  timeIcon: React.createElement(TimeIcon, null)
	};
	
	var useStyles$f = styles$5.makeStyles(function (_) {
	  return {
	    toolbar: {
	      paddingLeft: 16,
	      paddingRight: 16,
	      justifyContent: 'space-around'
	    },
	    separator: {
	      margin: '0 4px 0 2px',
	      cursor: 'default'
	    }
	  };
	}, {
	  name: 'MuiPickerDTToolbar'
	});
	var DateTimePickerToolbar = function DateTimePickerToolbar(_ref) {
	  var date = _ref.date,
	      openView = _ref.openView,
	      setOpenView = _ref.setOpenView,
	      ampm = _ref.ampm,
	      hideTabs = _ref.hideTabs,
	      dateRangeIcon = _ref.dateRangeIcon,
	      timeIcon = _ref.timeIcon,
	      onChange = _ref.onChange;
	  var utils = useUtils();
	  var classes = useStyles$f();
	  var showTabs = !hideTabs && typeof window !== 'undefined' && window.innerHeight > 667;
	
	  var _useMeridiemMode = useMeridiemMode(date, ampm, onChange),
	      meridiemMode = _useMeridiemMode.meridiemMode,
	      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;
	
	  var theme = styles$5.useTheme();
	  var rtl = theme.direction === 'rtl';
	  return React.createElement(React.Fragment, null, React.createElement(PickerToolbar, {
	    isLandscape: false,
	    className: classes.toolbar
	  }, React.createElement(Grid, {
	    container: true,
	    justify: "center",
	    wrap: "nowrap"
	  }, React.createElement(Grid, {
	    item: true,
	    container: true,
	    xs: 5,
	    justify: "flex-start",
	    direction: "column"
	  }, React.createElement("div", null, React.createElement(ToolbarButton$1, {
	    variant: "subtitle1",
	    onClick: function onClick() {
	      return setOpenView('year');
	    },
	    selected: openView === 'year',
	    label: utils.getYearText(date)
	  })), React.createElement("div", null, React.createElement(ToolbarButton$1, {
	    variant: "h4",
	    onClick: function onClick() {
	      return setOpenView('date');
	    },
	    selected: openView === 'date',
	    label: utils.getDateTimePickerHeaderText(date)
	  }))), React.createElement(Grid, {
	    item: true,
	    container: true,
	    xs: 6,
	    justify: "center",
	    alignItems: "flex-end",
	    direction: rtl ? 'row-reverse' : 'row'
	  }, React.createElement(ToolbarButton$1, {
	    variant: "h3",
	    onClick: function onClick() {
	      return setOpenView('hours');
	    },
	    selected: openView === 'hours',
	    label: utils.getHourText(date, ampm)
	  }), React.createElement(ToolbarText, {
	    variant: "h3",
	    label: ":",
	    className: classes.separator
	  }), React.createElement(ToolbarButton$1, {
	    variant: "h3",
	    onClick: function onClick() {
	      return setOpenView('minutes');
	    },
	    selected: openView === 'minutes',
	    label: utils.getMinuteText(date)
	  })), ampm && React.createElement(Grid, {
	    item: true,
	    container: true,
	    xs: 1,
	    direction: "column",
	    justify: "flex-end"
	  }, React.createElement(ToolbarButton$1, {
	    variant: "subtitle1",
	    selected: meridiemMode === 'am',
	    label: utils.getMeridiemText('am'),
	    onClick: function onClick() {
	      return handleMeridiemChange('am');
	    }
	  }), React.createElement(ToolbarButton$1, {
	    variant: "subtitle1",
	    selected: meridiemMode === 'pm',
	    label: utils.getMeridiemText('pm'),
	    onClick: function onClick() {
	      return handleMeridiemChange('pm');
	    }
	  })))), showTabs && React.createElement(DateTimePickerTabs, {
	    dateRangeIcon: dateRangeIcon,
	    timeIcon: timeIcon,
	    view: openView,
	    onChange: setOpenView
	  }));
	};
	
	function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var defaultProps$2 = _objectSpread$7({}, dateTimePickerDefaultProps, {
	  wider: true,
	  orientation: 'portrait',
	  openTo: 'date',
	  views: ['year', 'date', 'hours', 'minutes']
	});
	
	function useOptions$2(props) {
	  var utils = useUtils();
	
	  if (props.orientation !== 'portrait') {
	    throw new Error('We are not supporting custom orientation for DateTimePicker yet :(');
	  }
	
	  return {
	    getDefaultFormat: function getDefaultFormat() {
	      return pick12hOr24hFormat(props.format, props.ampm, {
	        '12h': utils.dateTime12hFormat,
	        '24h': utils.dateTime24hFormat
	      });
	    }
	  };
	}
	
	var DateTimePicker = makePickerWithState({
	  useOptions: useOptions$2,
	  Input: PureDateInput,
	  useState: usePickerState,
	  DefaultToolbarComponent: DateTimePickerToolbar
	});
	var KeyboardDateTimePicker = makePickerWithState({
	  useOptions: useOptions$2,
	  Input: KeyboardDateInput,
	  useState: useKeyboardPickerState,
	  DefaultToolbarComponent: DateTimePickerToolbar,
	  getCustomProps: function getCustomProps(props) {
	    return {
	      refuse: props.ampm ? /[^\dap]+/gi : /[^\d]+/gi
	    };
	  }
	});
	DateTimePicker.defaultProps = defaultProps$2;
	KeyboardDateTimePicker.defaultProps = defaultProps$2;
	
	function useStaticState(_ref) {
	  var value = _ref.value,
	      _ref$autoOk = _ref.autoOk,
	      autoOk = _ref$autoOk === void 0 ? true : _ref$autoOk,
	      onChange = _ref.onChange,
	      defaultFormat = _ref.defaultFormat;
	
	  var _usePickerState = usePickerState({
	    value: value,
	    onChange: onChange,
	    autoOk: autoOk
	  }, {
	    // just a random format, mostly always not needed for users
	    getDefaultFormat: function getDefaultFormat() {
	      return defaultFormat || 'MM/dd/yyyy';
	    }
	  }),
	      pickerProps = _usePickerState.pickerProps,
	      wrapperProps = _usePickerState.wrapperProps,
	      inputProps = _usePickerState.inputProps;
	
	  return {
	    pickerProps: pickerProps,
	    wrapperProps: wrapperProps,
	    inputProps: inputProps
	  };
	}
	
	exports.Calendar = Calendar$1;
	exports.Clock = Clock$1;
	exports.ClockView = ClockView;
	exports.DatePicker = DatePicker;
	exports.DateTimePicker = DateTimePicker;
	exports.Day = Day;
	exports.KeyboardDatePicker = KeyboardDatePicker;
	exports.KeyboardDateTimePicker = KeyboardDateTimePicker;
	exports.KeyboardTimePicker = KeyboardTimePicker;
	exports.MuiPickersContext = MuiPickersContext;
	exports.MuiPickersUtilsProvider = MuiPickersUtilsProvider;
	exports.Picker = Picker;
	exports.TimePicker = TimePicker;
	exports.TimePickerView = ClockView$1;
	exports.makePickerWithState = makePickerWithState;
	exports.useKeyboardPickerState = useKeyboardPickerState;
	exports.usePickerState = usePickerState;
	exports.useStaticState = useStaticState;
	exports.useUtils = useUtils;
	exports.validate = validate;
	//# sourceMappingURL=material-ui-pickers.js.map


/***/ },
/* 232 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(664));

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(665));

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(669));

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext(null);
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	var settle = __webpack_require__(702);
	var buildURL = __webpack_require__(704);
	var parseHeaders = __webpack_require__(710);
	var isURLSameOrigin = __webpack_require__(708);
	var createError = __webpack_require__(242);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(706);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(701);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _reactRouter = __webpack_require__(112);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var createSelectors = function createSelectors(structure) {
	  var getIn = structure.getIn,
	      toJS = structure.toJS;
	
	  var isRouter = function isRouter(value) {
	    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
	  };
	
	  var getRouter = function getRouter(state) {
	    var router = toJS(getIn(state, ['router']));
	
	    if (!isRouter(router)) {
	      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
	    }
	
	    return router;
	  };
	
	  var getLocation = function getLocation(state) {
	    return toJS(getIn(getRouter(state), ['location']));
	  };
	
	  var getAction = function getAction(state) {
	    return toJS(getIn(getRouter(state), ['action']));
	  };
	
	  var getSearch = function getSearch(state) {
	    return toJS(getIn(getRouter(state), ['location', 'search']));
	  };
	
	  var getHash = function getHash(state) {
	    return toJS(getIn(getRouter(state), ['location', 'hash']));
	  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
	  // of the location changes. That's why `createMatchSelector` memoizes
	  // the latest result based on the location's pathname.
	
	
	  var createMatchSelector = function createMatchSelector(path) {
	    var lastPathname = null;
	    var lastMatch = null;
	    return function (state) {
	      var _ref = getLocation(state) || {},
	          pathname = _ref.pathname;
	
	      if (pathname === lastPathname) {
	        return lastMatch;
	      }
	
	      lastPathname = pathname;
	      var match = (0, _reactRouter.matchPath)(pathname, path);
	
	      if (!match || !lastMatch || match.url !== lastMatch.url) {
	        lastMatch = match;
	      }
	
	      return lastMatch;
	    };
	  };
	
	  return {
	    getLocation: getLocation,
	    getAction: getAction,
	    getRouter: getRouter,
	    getSearch: getSearch,
	    getHash: getHash,
	    createMatchSelector: createMatchSelector
	  };
	};
	
	var _default = createSelectors;
	exports.default = _default;

/***/ },
/* 245 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    stackClear = __webpack_require__(826),
	    stackDelete = __webpack_require__(827),
	    stackGet = __webpack_require__(828),
	    stackHas = __webpack_require__(829),
	    stackSet = __webpack_require__(830);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(253),
	    toKey = __webpack_require__(101);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(765),
	    isObjectLike = __webpack_require__(58);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 251 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(41),
	    isKey = __webpack_require__(152),
	    stringToPath = __webpack_require__(831),
	    toString = __webpack_require__(843);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(751),
	    arraySome = __webpack_require__(757),
	    cacheHas = __webpack_require__(780);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 255 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 256 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 258 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 259 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(764),
	    isObjectLike = __webpack_require__(58);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40),
	    stubFalse = __webpack_require__(841);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isObject = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(768),
	    baseUnary = __webpack_require__(252),
	    nodeUtil = __webpack_require__(817);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104),
	    isSymbol = __webpack_require__(77);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	
	/**
	 * @this {Promise}
	 */
	function finallyConstructor(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      return constructor.resolve(callback()).then(function() {
	        return constructor.reject(reason);
	      });
	    }
	  );
	}
	
	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;
	
	function noop() {}
	
	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * @constructor
	 * @param {Function} fn
	 */
	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  /** @type {!number} */
	  this._state = 0;
	  /** @type {!boolean} */
	  this._handled = false;
	  /** @type {Promise|undefined} */
	  this._value = undefined;
	  /** @type {!Array<!Function>} */
	  this._deferreds = [];
	
	  doResolve(fn, this);
	}
	
	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}
	
	function resolve(self, newValue) {
	  try {
	    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}
	
	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}
	
	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }
	
	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}
	
	/**
	 * @constructor
	 */
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}
	
	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  // @ts-ignore
	  var prom = new this.constructor(noop);
	
	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};
	
	Promise.prototype['finally'] = finallyConstructor;
	
	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!arr || typeof arr.length === 'undefined')
	      throw new TypeError('Promise.all accepts an array');
	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	
	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }
	
	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};
	
	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function(values) {
	  return new Promise(function(resolve, reject) {
	    for (var i = 0, len = values.length; i < len; i++) {
	      values[i].then(resolve, reject);
	    }
	  });
	};
	
	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn =
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };
	
	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	  }
	};
	
	module.exports = Promise;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1014).setImmediate))

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(695);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isSafari = exports.isSafari = function isSafari() {
	  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	  );
	};
	
	var isJsons = exports.isJsons = function isJsons(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
	  });
	};
	
	var isArrays = exports.isArrays = function isArrays(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return Array.isArray(row);
	  });
	};
	
	var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
	  return Array.from(array.map(function (json) {
	    return Object.keys(json);
	  }).reduce(function (a, b) {
	    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
	  }, []));
	};
	
	var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
	  headers = headers || jsonsHeaders(jsons);
	
	  var headerLabels = headers;
	  var headerKeys = headers;
	  if (isJsons(headers)) {
	    headerLabels = headers.map(function (header) {
	      return header.label;
	    });
	    headerKeys = headers.map(function (header) {
	      return header.key;
	    });
	  }
	
	  var data = jsons.map(function (object) {
	    return headerKeys.map(function (header) {
	      return getHeaderValue(header, object);
	    });
	  });
	  return [headerLabels].concat(_toConsumableArray(data));
	};
	
	var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
	  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
	    if (o[p] === undefined) {
	      arr.splice(1);
	    } else {
	      return o[p];
	    }
	  }, obj);
	
	  return foundValue === undefined ? '' : foundValue;
	};
	
	var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
	  return element || element === 0 ? element : '';
	};
	
	var joiner = exports.joiner = function joiner(data) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
	
	  return data.filter(function (e) {
	    return e;
	  }).map(function (row) {
	    return row.map(function (element) {
	      return elementOrEmpty(element);
	    }).map(function (column) {
	      return "" + enclosingCharacter + column + enclosingCharacter;
	    }).join(separator);
	  }).join("\n");
	};
	
	var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
	};
	
	var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
	};
	
	var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
	  return headers ? headers.join(separator) + "\n" + data : data;
	};
	
	var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
	  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
	  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
	  if (typeof data === 'string') return string2csv(data, headers, separator);
	  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
	};
	
	var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
	  var csv = toCSV(data, headers, separator, enclosingCharacter);
	  var type = isSafari() ? 'application/csv' : 'text/csv';
	  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
	  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
	
	  var URL = window.URL || window.webkitURL;
	
	  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = exports.propTypes = {
	  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
	  headers: _propTypes.array,
	  target: _propTypes.string,
	  separator: _propTypes.string,
	  filename: _propTypes.string,
	  uFEFF: _propTypes.bool,
	  onClick: _propTypes.func,
	  asyncOnClick: _propTypes.bool
	};
	
	var defaultProps = exports.defaultProps = {
	  separator: ',',
	  filename: 'generatedBy_react-csv.csv',
	  uFEFF: true,
	  asyncOnClick: false
	};
	
	var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DayCell = __webpack_require__(105);
	
	var _Month = __webpack_require__(861);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _utils = __webpack_require__(107);
	
	var _classnames3 = __webpack_require__(44);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _reactList = __webpack_require__(898);
	
	var _reactList2 = _interopRequireDefault(_reactList);
	
	var _max = __webpack_require__(890);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _min = __webpack_require__(407);
	
	var _min2 = _interopRequireDefault(_min);
	
	var _differenceInDays = __webpack_require__(872);
	
	var _differenceInDays2 = _interopRequireDefault(_differenceInDays);
	
	var _isSameMonth = __webpack_require__(874);
	
	var _isSameMonth2 = _interopRequireDefault(_isSameMonth);
	
	var _addDays = __webpack_require__(157);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	var _endOfMonth = __webpack_require__(160);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(163);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _differenceInCalendarMonths = __webpack_require__(871);
	
	var _differenceInCalendarMonths2 = _interopRequireDefault(_differenceInCalendarMonths);
	
	var _setMonth2 = __webpack_require__(891);
	
	var _setMonth3 = _interopRequireDefault(_setMonth2);
	
	var _setYear2 = __webpack_require__(892);
	
	var _setYear3 = _interopRequireDefault(_setYear2);
	
	var _addYears = __webpack_require__(868);
	
	var _addYears2 = _interopRequireDefault(_addYears);
	
	var _isSameDay = __webpack_require__(110);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _endOfWeek = __webpack_require__(109);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(111);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _eachDayOfInterval = __webpack_require__(403);
	
	var _eachDayOfInterval2 = _interopRequireDefault(_eachDayOfInterval);
	
	var _format = __webpack_require__(161);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _addMonths = __webpack_require__(108);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	var _enUS = __webpack_require__(406);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	var _styles = __webpack_require__(106);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = function (_PureComponent) {
	  _inherits(Calendar, _PureComponent);
	
	  function Calendar(props, context) {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props, context));
	
	    _this.changeShownDate = _this.changeShownDate.bind(_this);
	    _this.focusToDate = _this.focusToDate.bind(_this);
	    _this.updateShownDate = _this.updateShownDate.bind(_this);
	    _this.handleRangeFocusChange = _this.handleRangeFocusChange.bind(_this);
	    _this.renderDateDisplay = _this.renderDateDisplay.bind(_this);
	    _this.onDragSelectionStart = _this.onDragSelectionStart.bind(_this);
	    _this.onDragSelectionEnd = _this.onDragSelectionEnd.bind(_this);
	    _this.onDragSelectionMove = _this.onDragSelectionMove.bind(_this);
	    _this.renderMonthAndYear = _this.renderMonthAndYear.bind(_this);
	    _this.updatePreview = _this.updatePreview.bind(_this);
	    _this.estimateMonthSize = _this.estimateMonthSize.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.dateOptions = { locale: props.locale };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    _this.listSizeCache = {};
	    _this.state = {
	      focusedDate: (0, _utils.calcFocusDate)(null, props),
	      drag: {
	        status: false,
	        range: { startDate: null, endDate: null },
	        disablePreview: false
	      },
	      scrollArea: _this.calcScrollArea(props)
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'calcScrollArea',
	    value: function calcScrollArea(props) {
	      var direction = props.direction,
	          months = props.months,
	          scroll = props.scroll;
	
	      if (!scroll.enabled) return { enabled: false };
	
	      var longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
	      if (direction === 'vertical') {
	        return {
	          enabled: true,
	          monthHeight: scroll.monthHeight || 220,
	          longMonthHeight: longMonthHeight || 260,
	          calendarWidth: 'auto',
	          calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
	        };
	      }
	      return {
	        enabled: true,
	        monthWidth: scroll.monthWidth || 332,
	        calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
	        monthHeight: longMonthHeight || 300,
	        calendarHeight: longMonthHeight || 300
	      };
	    }
	  }, {
	    key: 'focusToDate',
	    value: function focusToDate(date) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var preventUnnecessary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (!props.scroll.enabled) {
	        this.setState({ focusedDate: date });
	        return;
	      }
	      var targetMonthIndex = (0, _differenceInCalendarMonths2.default)(date, props.minDate, this.dateOptions);
	      var visibleMonths = this.list.getVisibleRange();
	      if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
	      this.list.scrollTo(targetMonthIndex);
	      this.setState({ focusedDate: date });
	    }
	  }, {
	    key: 'updateShownDate',
	    value: function updateShownDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var newProps = props.scroll.enabled ? _extends({}, props, {
	        months: this.list.getVisibleRange().length
	      }) : props;
	      var newFocus = (0, _utils.calcFocusDate)(this.state.focusedDate, newProps);
	      this.focusToDate(newFocus, newProps);
	    }
	  }, {
	    key: 'updatePreview',
	    value: function updatePreview(val) {
	      if (!val) {
	        this.setState({ preview: null });
	        return;
	      }
	      var preview = {
	        startDate: val,
	        endDate: val,
	        color: this.props.color
	      };
	      this.setState({ preview: preview });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.scroll.enabled) {
	        // prevent react-list's initial render focus problem
	        setTimeout(function () {
	          return _this2.focusToDate(_this2.state.focusedDate);
	        }, 1);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var propMapper = {
	        dateRange: 'ranges',
	        date: 'date'
	      };
	      var targetProp = propMapper[nextProps.displayMode];
	      if (this.props.locale !== nextProps.locale) {
	        this.dateOptions = { locale: nextProps.locale };
	      }
	      if (JSON.stringify(this.props.scroll) !== JSON.stringify(nextProps.scroll)) {
	        this.setState({ scrollArea: this.calcScrollArea(nextProps) });
	      }
	      if (nextProps[targetProp] !== this.props[targetProp]) {
	        this.updateShownDate(nextProps);
	      }
	    }
	  }, {
	    key: 'changeShownDate',
	    value: function changeShownDate(value) {
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set';
	      var focusedDate = this.state.focusedDate;
	      var _props = this.props,
	          onShownDateChange = _props.onShownDateChange,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate;
	
	      var modeMapper = {
	        monthOffset: function monthOffset() {
	          return (0, _addMonths2.default)(focusedDate, value);
	        },
	        setMonth: function setMonth() {
	          return (0, _setMonth3.default)(focusedDate, value);
	        },
	        setYear: function setYear() {
	          return (0, _setYear3.default)(focusedDate, value);
	        },
	        set: function set() {
	          return value;
	        }
	      };
	      var newDate = (0, _min2.default)([(0, _max2.default)([modeMapper[mode](), minDate]), maxDate]);
	      this.focusToDate(newDate, this.props, false);
	      onShownDateChange && onShownDateChange(newDate);
	    }
	  }, {
	    key: 'handleRangeFocusChange',
	    value: function handleRangeFocusChange(rangesIndex, rangeItemIndex) {
	      this.props.onRangeFocusChange && this.props.onRangeFocusChange([rangesIndex, rangeItemIndex]);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _props2 = this.props,
	          onShownDateChange = _props2.onShownDateChange,
	          minDate = _props2.minDate;
	
	      var visibleMonths = this.list.getVisibleRange();
	      // prevent scroll jump with wrong visible value
	      if (visibleMonths[0] === undefined) return;
	      var visibleMonth = (0, _addMonths2.default)(minDate, visibleMonths[0] || 0);
	      var isFocusedToDifferent = !(0, _isSameMonth2.default)(visibleMonth, this.state.focusedDate);
	      if (isFocusedToDifferent) {
	        this.setState({ focusedDate: visibleMonth });
	        onShownDateChange && onShownDateChange(visibleMonth);
	      }
	    }
	  }, {
	    key: 'renderMonthAndYear',
	    value: function renderMonthAndYear(focusedDate, changeShownDate, props) {
	      var showMonthArrow = props.showMonthArrow,
	          locale = props.locale,
	          minDate = props.minDate,
	          maxDate = props.maxDate,
	          showMonthAndYearPickers = props.showMonthAndYearPickers;
	
	      var upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
	      var lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
	      var styles = this.styles;
	      return _react2.default.createElement(
	        'div',
	        { onMouseUp: function onMouseUp(e) {
	            return e.stopPropagation();
	          }, className: styles.monthAndYearWrapper },
	        showMonthArrow ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: (0, _classnames4.default)(styles.nextPrevButton, styles.prevButton),
	            onClick: function onClick() {
	              return changeShownDate(-1, 'monthOffset');
	            } },
	          _react2.default.createElement('i', null)
	        ) : null,
	        showMonthAndYearPickers ? _react2.default.createElement(
	          'span',
	          { className: styles.monthAndYearPickers },
	          _react2.default.createElement(
	            'span',
	            { className: styles.monthPicker },
	            _react2.default.createElement(
	              'select',
	              {
	                value: focusedDate.getMonth(),
	                onChange: function onChange(e) {
	                  return changeShownDate(e.target.value, 'setMonth');
	                } },
	              locale.localize.months().map(function (month, i) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: i, value: i },
	                  month
	                );
	              })
	            )
	          ),
	          _react2.default.createElement('span', { className: styles.monthAndYearDivider }),
	          _react2.default.createElement(
	            'span',
	            { className: styles.yearPicker },
	            _react2.default.createElement(
	              'select',
	              {
	                value: focusedDate.getFullYear(),
	                onChange: function onChange(e) {
	                  return changeShownDate(e.target.value, 'setYear');
	                } },
	              new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function (val, i) {
	                var year = val - i;
	                return _react2.default.createElement(
	                  'option',
	                  { key: year, value: year },
	                  year
	                );
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          'span',
	          { className: styles.monthAndYearPickers },
	          locale.localize.months()[focusedDate.getMonth()],
	          ' ',
	          focusedDate.getFullYear()
	        ),
	        showMonthArrow ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: (0, _classnames4.default)(styles.nextPrevButton, styles.nextButton),
	            onClick: function onClick() {
	              return changeShownDate(+1, 'monthOffset');
	            } },
	          _react2.default.createElement('i', null)
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderWeekdays',
	    value: function renderWeekdays() {
	      var _this3 = this;
	
	      var now = new Date();
	      return _react2.default.createElement(
	        'div',
	        { className: this.styles.weekDays },
	        (0, _eachDayOfInterval2.default)({
	          start: (0, _startOfWeek2.default)(now, this.dateOptions),
	          end: (0, _endOfWeek2.default)(now, this.dateOptions)
	        }).map(function (day, i) {
	          return _react2.default.createElement(
	            'span',
	            { className: _this3.styles.weekDay, key: i },
	            (0, _format2.default)(day, 'ddd', _this3.dateOptions)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderDateDisplay',
	    value: function renderDateDisplay() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          focusedRange = _props3.focusedRange,
	          color = _props3.color,
	          ranges = _props3.ranges,
	          rangeColors = _props3.rangeColors;
	
	      var defaultColor = rangeColors[focusedRange[0]] || color;
	      var styles = this.styles;
	      return _react2.default.createElement(
	        'div',
	        { className: styles.dateDisplayWrapper },
	        ranges.map(function (range, i) {
	          if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
	          return _react2.default.createElement(
	            'div',
	            {
	              className: styles.dateDisplay,
	              key: i,
	              style: { color: range.color || defaultColor } },
	            _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames4.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 0)),
	                onFocus: function onFocus() {
	                  return _this4.handleRangeFocusChange(i, 0);
	                } },
	              _react2.default.createElement('input', {
	                disabled: range.disabled,
	                readOnly: true,
	                value: _this4.formatDateDisplay(range.startDate, 'Early')
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames4.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 1)),
	                onFocus: function onFocus() {
	                  return _this4.handleRangeFocusChange(i, 1);
	                } },
	              _react2.default.createElement('input', {
	                disabled: range.disabled,
	                readOnly: true,
	                value: _this4.formatDateDisplay(range.endDate, 'Continuous')
	              })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'onDragSelectionStart',
	    value: function onDragSelectionStart(date) {
	      var _props4 = this.props,
	          onChange = _props4.onChange,
	          dragSelectionEnabled = _props4.dragSelectionEnabled;
	
	
	      if (dragSelectionEnabled) {
	        this.setState({
	          drag: {
	            status: true,
	            range: { startDate: date, endDate: date },
	            disablePreview: true
	          }
	        });
	      } else {
	        onChange && onChange(date);
	      }
	    }
	  }, {
	    key: 'onDragSelectionEnd',
	    value: function onDragSelectionEnd(date) {
	      var _props5 = this.props,
	          updateRange = _props5.updateRange,
	          displayMode = _props5.displayMode,
	          onChange = _props5.onChange,
	          dragSelectionEnabled = _props5.dragSelectionEnabled;
	
	
	      if (!dragSelectionEnabled) return;
	
	      if (displayMode === 'date' || !this.state.drag.status) {
	        onChange && onChange(date);
	        return;
	      }
	      var newRange = {
	        startDate: this.state.drag.range.startDate,
	        endDate: date
	      };
	      if (displayMode !== 'dateRange' || (0, _isSameDay2.default)(newRange.startDate, date)) {
	        this.setState({ drag: { status: false, range: {} } }, function () {
	          return onChange && onChange(date);
	        });
	      } else {
	        this.setState({ drag: { status: false, range: {} } }, function () {
	          updateRange && updateRange(newRange);
	        });
	      }
	    }
	  }, {
	    key: 'onDragSelectionMove',
	    value: function onDragSelectionMove(date) {
	      var drag = this.state.drag;
	
	      if (!drag.status || !this.props.dragSelectionEnabled) return;
	      this.setState({
	        drag: {
	          status: drag.status,
	          range: { startDate: drag.range.startDate, endDate: date },
	          disablePreview: true
	        }
	      });
	    }
	  }, {
	    key: 'estimateMonthSize',
	    value: function estimateMonthSize(index, cache) {
	      var _props6 = this.props,
	          direction = _props6.direction,
	          minDate = _props6.minDate;
	      var scrollArea = this.state.scrollArea;
	
	      if (cache) {
	        this.listSizeCache = cache;
	        if (cache[index]) return cache[index];
	      }
	      if (direction === 'horizontal') return scrollArea.monthWidth;
	      var monthStep = (0, _addMonths2.default)(minDate, index);
	
	      var _getMonthDisplayRange = (0, _utils.getMonthDisplayRange)(monthStep, this.dateOptions),
	          start = _getMonthDisplayRange.start,
	          end = _getMonthDisplayRange.end;
	
	      var isLongMonth = (0, _differenceInDays2.default)(end, start, this.dateOptions) + 1 > 7 * 5;
	      return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
	    }
	  }, {
	    key: 'formatDateDisplay',
	    value: function formatDateDisplay(date, defaultText) {
	      if (!date) return defaultText;
	      return (0, _format2.default)(date, this.props.dateDisplayFormat, this.dateOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props7 = this.props,
	          showDateDisplay = _props7.showDateDisplay,
	          onPreviewChange = _props7.onPreviewChange,
	          scroll = _props7.scroll,
	          direction = _props7.direction,
	          maxDate = _props7.maxDate,
	          minDate = _props7.minDate,
	          rangeColors = _props7.rangeColors,
	          color = _props7.color;
	      var _state = this.state,
	          scrollArea = _state.scrollArea,
	          focusedDate = _state.focusedDate;
	
	      var isVertical = direction === 'vertical';
	      var navigatorRenderer = this.props.navigatorRenderer || this.renderMonthAndYear;
	
	      var ranges = this.props.ranges.map(function (range, i) {
	        return _extends({}, range, {
	          color: range.color || rangeColors[i] || color
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames4.default)(this.styles.calendarWrapper, this.props.className),
	          onMouseUp: function onMouseUp() {
	            return _this5.setState({ drag: { status: false, range: {} } });
	          },
	          onMouseLeave: function onMouseLeave() {
	            _this5.setState({ drag: { status: false, range: {} } });
	          } },
	        showDateDisplay && this.renderDateDisplay(),
	        navigatorRenderer(focusedDate, this.changeShownDate, this.props),
	        scroll.enabled ? _react2.default.createElement(
	          'div',
	          null,
	          isVertical && this.renderWeekdays(this.dateOptions),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames4.default)(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
	              onMouseLeave: function onMouseLeave() {
	                return onPreviewChange && onPreviewChange();
	              },
	              style: {
	                width: scrollArea.calendarWidth + 11,
	                height: scrollArea.calendarHeight + 11
	              },
	              onScroll: this.handleScroll },
	            _react2.default.createElement(_reactList2.default, {
	              length: (0, _differenceInCalendarMonths2.default)((0, _endOfMonth2.default)(maxDate), (0, _addDays2.default)((0, _startOfMonth2.default)(minDate), -1), this.dateOptions),
	              treshold: 500,
	              type: 'variable',
	              ref: function ref(target) {
	                return _this5.list = target;
	              },
	              itemSizeEstimator: this.estimateMonthSize,
	              axis: isVertical ? 'y' : 'x',
	              itemRenderer: function itemRenderer(index, key) {
	                var monthStep = (0, _addMonths2.default)(minDate, index);
	                return _react2.default.createElement(_Month2.default, _extends({}, _this5.props, {
	                  onPreviewChange: _this5.props.onPreviewChange || _this5.updatePreview,
	                  preview: _this5.props.preview || _this5.state.preview,
	                  ranges: ranges,
	                  key: key,
	                  drag: _this5.state.drag,
	                  dateOptions: _this5.dateOptions,
	                  month: monthStep,
	                  onDragSelectionStart: _this5.onDragSelectionStart,
	                  onDragSelectionEnd: _this5.onDragSelectionEnd,
	                  onDragSelectionMove: _this5.onDragSelectionMove,
	                  onMouseLeave: function onMouseLeave() {
	                    return onPreviewChange && onPreviewChange();
	                  },
	                  styles: _this5.styles,
	                  style: isVertical ? { height: _this5.estimateMonthSize(index) } : { height: scrollArea.monthHeight, width: _this5.estimateMonthSize(index) },
	                  showMonthName: true,
	                  showWeekDays: !isVertical
	                }));
	              }
	            })
	          )
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames4.default)(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal) },
	          new Array(this.props.months).fill(null).map(function (_, i) {
	            var monthStep = (0, _addMonths2.default)(_this5.state.focusedDate, i);
	            return _react2.default.createElement(_Month2.default, _extends({}, _this5.props, {
	              onPreviewChange: _this5.props.onPreviewChange || _this5.updatePreview,
	              preview: _this5.props.preview || _this5.state.preview,
	              ranges: ranges,
	              key: i,
	              drag: _this5.state.drag,
	              dateOptions: _this5.dateOptions,
	              month: monthStep,
	              onDragSelectionStart: _this5.onDragSelectionStart,
	              onDragSelectionEnd: _this5.onDragSelectionEnd,
	              onDragSelectionMove: _this5.onDragSelectionMove,
	              onMouseLeave: function onMouseLeave() {
	                return onPreviewChange && onPreviewChange();
	              },
	              styles: _this5.styles,
	              showWeekDays: !isVertical || i === 0,
	              showMonthName: !isVertical || i > 0
	            }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.PureComponent);
	
	Calendar.defaultProps = {
	  showMonthArrow: true,
	  showMonthAndYearPickers: true,
	  classNames: {},
	  locale: _enUS2.default,
	  ranges: [],
	  focusedRange: [0, 0],
	  dateDisplayFormat: 'MMM D, YYYY',
	  monthDisplayFormat: 'MMM YYYY',
	  showDateDisplay: true,
	  showPreview: true,
	  displayMode: 'date',
	  months: 1,
	  color: '#3d91ff',
	  scroll: {
	    enabled: false
	  },
	  direction: 'vertical',
	  maxDate: (0, _addYears2.default)(new Date(), 20),
	  minDate: (0, _addYears2.default)(new Date(), -100),
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  dragSelectionEnabled: true
	};
	
	Calendar.propTypes = {
	  showMonthArrow: _propTypes2.default.bool,
	  showMonthAndYearPickers: _propTypes2.default.bool,
	  minDate: _propTypes2.default.object,
	  maxDate: _propTypes2.default.object,
	  date: _propTypes2.default.object,
	  onChange: _propTypes2.default.func,
	  onPreviewChange: _propTypes2.default.func,
	  onRangeFocusChange: _propTypes2.default.func,
	  classNames: _propTypes2.default.object,
	  locale: _propTypes2.default.object,
	  shownDate: _propTypes2.default.object,
	  onShownDateChange: _propTypes2.default.func,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object,
	    color: _propTypes2.default.string
	  }),
	  dateDisplayFormat: _propTypes2.default.string,
	  monthDisplayFormat: _propTypes2.default.string,
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  initialFocusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  months: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  showDateDisplay: _propTypes2.default.bool,
	  showPreview: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  color: _propTypes2.default.string,
	  updateRange: _propTypes2.default.func,
	  scroll: _propTypes2.default.shape({
	    enabled: _propTypes2.default.bool,
	    monthHeight: _propTypes2.default.number,
	    longMonthHeight: _propTypes2.default.number,
	    monthWidth: _propTypes2.default.number,
	    calendarWidth: _propTypes2.default.number,
	    calendarHeight: _propTypes2.default.number
	  }),
	  direction: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  navigatorRenderer: _propTypes2.default.func,
	  rangeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  dragSelectionEnabled: _propTypes2.default.bool
	};
	
	exports.default = Calendar;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Calendar = __webpack_require__(398);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DayCell = __webpack_require__(105);
	
	var _utils = __webpack_require__(107);
	
	var _min = __webpack_require__(407);
	
	var _min2 = _interopRequireDefault(_min);
	
	var _addDays = __webpack_require__(157);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	var _differenceInCalendarDays = __webpack_require__(158);
	
	var _differenceInCalendarDays2 = _interopRequireDefault(_differenceInCalendarDays);
	
	var _isBefore = __webpack_require__(162);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(106);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRange = function (_Component) {
	  _inherits(DateRange, _Component);
	
	  function DateRange(props, context) {
	    _classCallCheck(this, DateRange);
	
	    var _this = _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call(this, props, context));
	
	    _this.setSelection = _this.setSelection.bind(_this);
	    _this.handleRangeFocusChange = _this.handleRangeFocusChange.bind(_this);
	    _this.updatePreview = _this.updatePreview.bind(_this);
	    _this.calcNewSelection = _this.calcNewSelection.bind(_this);
	    _this.state = {
	      focusedRange: props.initialFocusedRange || [(0, _utils.findNextRangeIndex)(props.ranges), 0],
	      preview: null
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRange, [{
	    key: 'calcNewSelection',
	    value: function calcNewSelection(value) {
	      var isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var _props = this.props,
	          ranges = _props.ranges,
	          onChange = _props.onChange,
	          maxDate = _props.maxDate,
	          moveRangeOnFirstSelection = _props.moveRangeOnFirstSelection;
	
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange || !onChange) return {};
	
	      var startDate = selectedRange.startDate,
	          endDate = selectedRange.endDate;
	
	      if (!endDate) endDate = new Date(startDate);
	      var nextFocusRange = void 0;
	      if (!isSingleValue) {
	        startDate = value.startDate;
	        endDate = value.endDate;
	      } else if (focusedRange[1] === 0) {
	        // startDate selection
	        var dayOffset = (0, _differenceInCalendarDays2.default)(endDate, startDate);
	        startDate = value;
	        endDate = moveRangeOnFirstSelection ? (0, _addDays2.default)(value, dayOffset) : value;
	        if (maxDate) endDate = (0, _min2.default)([endDate, maxDate]);
	        nextFocusRange = [focusedRange[0], 1];
	      } else {
	        endDate = value;
	      }
	      // reverse dates if startDate before endDate
	      if ((0, _isBefore2.default)(endDate, startDate)) {
	        var _ref = [endDate, startDate];
	        startDate = _ref[0];
	        endDate = _ref[1];
	      }
	
	      if (!nextFocusRange) {
	        var nextFocusRangeIndex = (0, _utils.findNextRangeIndex)(this.props.ranges, focusedRange[0]);
	        nextFocusRange = [nextFocusRangeIndex, 0];
	      }
	      return {
	        range: { startDate: startDate, endDate: endDate },
	        nextFocusRange: nextFocusRange
	      };
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(value, isSingleValue) {
	      var _props2 = this.props,
	          onChange = _props2.onChange,
	          ranges = _props2.ranges,
	          onRangeFocusChange = _props2.onRangeFocusChange;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange) return;
	      var newSelection = this.calcNewSelection(value, isSingleValue);
	      onChange(_defineProperty({}, selectedRange.key || 'range' + (focusedRangeIndex + 1), _extends({}, selectedRange, newSelection.range)));
	      this.setState({
	        focusedRange: newSelection.nextFocusRange,
	        preview: null
	      });
	      onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
	    }
	  }, {
	    key: 'handleRangeFocusChange',
	    value: function handleRangeFocusChange(focusedRange) {
	      this.setState({ focusedRange: focusedRange });
	      this.props.onRangeFocusChange && this.props.onRangeFocusChange(focusedRange);
	    }
	  }, {
	    key: 'updatePreview',
	    value: function updatePreview(val) {
	      if (!val) {
	        this.setState({ preview: null });
	        return;
	      }
	      var _props3 = this.props,
	          rangeColors = _props3.rangeColors,
	          ranges = _props3.ranges;
	
	      var focusedRange = this.props.focusedRange || this.state.focusedRange;
	      var color = ranges[focusedRange[0]].color || rangeColors[focusedRange[0]] || color;
	      this.setState({ preview: _extends({}, val, { color: color }) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_Calendar2.default, _extends({
	        focusedRange: this.state.focusedRange,
	        onRangeFocusChange: this.handleRangeFocusChange,
	        preview: this.state.preview,
	        onPreviewChange: function onPreviewChange(value) {
	          _this2.updatePreview(value ? _this2.calcNewSelection(value).range : null);
	        }
	      }, this.props, {
	        displayMode: 'dateRange',
	        className: (0, _classnames2.default)(this.styles.dateRangeWrapper, this.props.className),
	        onChange: this.setSelection,
	        updateRange: function updateRange(val) {
	          return _this2.setSelection(val, false);
	        },
	        ref: function ref(target) {
	          _this2.calendar = target;
	        }
	      }));
	    }
	  }]);
	
	  return DateRange;
	}(_react.Component);
	
	DateRange.defaultProps = {
	  classNames: {},
	  ranges: [],
	  moveRangeOnFirstSelection: false,
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c']
	};
	
	DateRange.propTypes = _extends({}, _Calendar2.default.propTypes, {
	  onChange: _propTypes2.default.func,
	  onRangeFocusChange: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  moveRangeOnFirstSelection: _propTypes2.default.bool
	});
	
	exports.default = DateRange;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(106);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _defaultRanges = __webpack_require__(401);
	
	var _DayCell = __webpack_require__(105);
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefinedRanges = function (_Component) {
	  _inherits(DefinedRanges, _Component);
	
	  function DefinedRanges(props) {
	    _classCallCheck(this, DefinedRanges);
	
	    var _this = _possibleConstructorReturn(this, (DefinedRanges.__proto__ || Object.getPrototypeOf(DefinedRanges)).call(this, props));
	
	    _this.state = {
	      rangeOffset: 0,
	      focusedInput: -1
	    };
	    _this.handleRangeChange = _this.handleRangeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DefinedRanges, [{
	    key: 'handleRangeChange',
	    value: function handleRangeChange(range) {
	      var _props = this.props,
	          onChange = _props.onChange,
	          ranges = _props.ranges,
	          focusedRange = _props.focusedRange;
	
	      var selectedRange = ranges[focusedRange[0]];
	      if (!onChange || !selectedRange) return;
	      onChange(_defineProperty({}, selectedRange.key || 'range' + (focusedRange[0] + 1), _extends({}, selectedRange, range)));
	    }
	  }, {
	    key: 'getSelectedRange',
	    value: function getSelectedRange(ranges, staticRange) {
	      var focusedRangeIndex = ranges.findIndex(function (range) {
	        if (!range.startDate || !range.endDate || range.disabled) return false;
	        return staticRange.isSelected(range);
	      });
	      var selectedRange = ranges[focusedRangeIndex];
	      return { selectedRange: selectedRange, focusedRangeIndex: focusedRangeIndex };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onPreviewChange = _props2.onPreviewChange,
	          ranges = _props2.ranges,
	          rangeColors = _props2.rangeColors,
	          className = _props2.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.definedRangesWrapper, className) },
	        this.props.headerContent,
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.staticRanges },
	          this.props.staticRanges.map(function (staticRange, i) {
	            var _getSelectedRange = _this2.getSelectedRange(ranges, staticRange),
	                selectedRange = _getSelectedRange.selectedRange,
	                focusedRangeIndex = _getSelectedRange.focusedRangeIndex;
	
	            return _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: (0, _classnames2.default)(_styles2.default.staticRange, _defineProperty({}, _styles2.default.staticRangeSelected, Boolean(selectedRange))),
	                style: {
	                  color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
	                },
	                key: i,
	                onClick: function onClick() {
	                  return _this2.handleRangeChange(staticRange.range(_this2.props));
	                },
	                onFocus: function onFocus() {
	                  return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	                },
	                onMouseOver: function onMouseOver() {
	                  return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	                },
	                onMouseLeave: function onMouseLeave() {
	                  _this2.props.onPreviewChange && _this2.props.onPreviewChange();
	                } },
	              _react2.default.createElement(
	                'span',
	                { tabIndex: -1, className: _styles2.default.staticRangeLabel },
	                staticRange.label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.inputRanges },
	          this.props.inputRanges.map(function (rangeOption, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: _styles2.default.inputRange, key: i },
	              _react2.default.createElement('input', {
	                className: _styles2.default.inputRangeInput,
	                onFocus: function onFocus() {
	                  return _this2.setState({ focusedInput: i, rangeOffset: 0 });
	                },
	                onBlur: function onBlur() {
	                  return _this2.setState({ rangeOffset: 0 });
	                },
	                onChange: function onChange(e) {
	                  var value = parseInt(e.target.value, 10);
	                  value = isNaN(value) ? 0 : Math.max(Math.min(99999, value), 0);
	                  _this2.handleRangeChange(rangeOption.range(value, _this2.props));
	                },
	                min: 0,
	                max: 99999,
	                value: rangeOption.getCurrentValue ? rangeOption.getCurrentValue(ranges[_this2.props.focusedRange[0]] || {}) : '-'
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.inputRangeLabel },
	                rangeOption.label
	              )
	            );
	          })
	        ),
	        this.props.footerContent
	      );
	    }
	  }]);
	
	  return DefinedRanges;
	}(_react.Component);
	
	DefinedRanges.propTypes = {
	  inputRanges: _propTypes2.default.array,
	  staticRanges: _propTypes2.default.array,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  onPreviewChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  footerContent: _propTypes2.default.any,
	  headerContent: _propTypes2.default.any,
	  rangeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  className: _propTypes2.default.string
	};
	
	DefinedRanges.defaultProps = {
	  inputRanges: _defaultRanges.defaultInputRanges,
	  staticRanges: _defaultRanges.defaultStaticRanges,
	  ranges: [],
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  focusedRange: [0, 0]
	};
	
	exports.default = DefinedRanges;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultInputRanges = exports.defaultStaticRanges = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createStaticRanges = createStaticRanges;
	
	var _differenceInCalendarDays = __webpack_require__(158);
	
	var _differenceInCalendarDays2 = _interopRequireDefault(_differenceInCalendarDays);
	
	var _isSameDay = __webpack_require__(110);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _endOfWeek = __webpack_require__(109);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(111);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _addMonths = __webpack_require__(108);
	
	var _addMonths2 = _interopRequireDefault(_addMonths);
	
	var _endOfMonth = __webpack_require__(160);
	
	var _endOfMonth2 = _interopRequireDefault(_endOfMonth);
	
	var _startOfMonth = __webpack_require__(163);
	
	var _startOfMonth2 = _interopRequireDefault(_startOfMonth);
	
	var _startOfDay = __webpack_require__(78);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	var _endOfDay = __webpack_require__(159);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _addDays = __webpack_require__(157);
	
	var _addDays2 = _interopRequireDefault(_addDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defineds = {
	  startOfWeek: (0, _startOfWeek2.default)(new Date()),
	  endOfWeek: (0, _endOfWeek2.default)(new Date()),
	  startOfLastWeek: (0, _startOfWeek2.default)((0, _addDays2.default)(new Date(), -7)),
	  endOfLastWeek: (0, _endOfWeek2.default)((0, _addDays2.default)(new Date(), -7)),
	  startOfToday: (0, _startOfDay2.default)(new Date()),
	  endOfToday: (0, _endOfDay2.default)(new Date()),
	  startOfYesterday: (0, _startOfDay2.default)((0, _addDays2.default)(new Date(), -1)),
	  endOfYesterday: (0, _endOfDay2.default)((0, _addDays2.default)(new Date(), -1)),
	  startOfMonth: (0, _startOfMonth2.default)(new Date()),
	  endOfMonth: (0, _endOfMonth2.default)(new Date()),
	  startOfLastMonth: (0, _startOfMonth2.default)((0, _addMonths2.default)(new Date(), -1)),
	  endOfLastMonth: (0, _endOfMonth2.default)((0, _addMonths2.default)(new Date(), -1))
	};
	
	var staticRangeHandler = {
	  range: {},
	  isSelected: function isSelected(range) {
	    var definedRange = this.range();
	    return (0, _isSameDay2.default)(range.startDate, definedRange.startDate) && (0, _isSameDay2.default)(range.endDate, definedRange.endDate);
	  }
	};
	
	function createStaticRanges(ranges) {
	  return ranges.map(function (range) {
	    return _extends({}, staticRangeHandler, range);
	  });
	}
	
	var defaultStaticRanges = exports.defaultStaticRanges = createStaticRanges([{
	  label: 'Today',
	  range: function range() {
	    return {
	      startDate: defineds.startOfToday,
	      endDate: defineds.endOfToday
	    };
	  }
	}, {
	  label: 'Yesterday',
	  range: function range() {
	    return {
	      startDate: defineds.startOfYesterday,
	      endDate: defineds.endOfYesterday
	    };
	  }
	}, {
	  label: 'This Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfWeek,
	      endDate: defineds.endOfWeek
	    };
	  }
	}, {
	  label: 'Last Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastWeek,
	      endDate: defineds.endOfLastWeek
	    };
	  }
	}, {
	  label: 'This Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfMonth,
	      endDate: defineds.endOfMonth
	    };
	  }
	}, {
	  label: 'Last Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastMonth,
	      endDate: defineds.endOfLastMonth
	    };
	  }
	}]);
	
	var defaultInputRanges = exports.defaultInputRanges = [{
	  label: 'days up to today',
	  range: function range(value) {
	    return {
	      startDate: (0, _addDays2.default)(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
	      endDate: defineds.endOfToday
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _isSameDay2.default)(range.endDate, defineds.endOfToday)) return '-';
	    if (!range.startDate) return '∞';
	    return (0, _differenceInCalendarDays2.default)(defineds.endOfToday, range.startDate) + 1;
	  }
	}, {
	  label: 'days starting today',
	  range: function range(value) {
	    var today = new Date();
	    return {
	      startDate: today,
	      endDate: (0, _addDays2.default)(today, Math.max(Number(value), 1) - 1)
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _isSameDay2.default)(range.startDate, defineds.startOfToday)) return '-';
	    if (!range.endDate) return '∞';
	    return (0, _differenceInCalendarDays2.default)(range.endDate, defineds.startOfToday) + 1;
	  }
	}];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(156);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index4.default)(fourthOfJanuaryOfNextYear, dirtyOptions);
	
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index4.default)(fourthOfJanuaryOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start, dirtyOptions);
	  var endDate = (0, _index2.default)(interval.end, dirtyOptions);
	
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate, dirtyOptions));
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	
	  return dates;
	}
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var dateToCompare = (0, _index2.default)(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports['default'];

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(885);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(886);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(887);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(888);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(889);
	
	var _index10 = _interopRequireDefault(_index9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 */
	var locale = {
	  formatDistance: _index2.default,
	  formatLong: _index4.default,
	  formatRelative: _index6.default,
	  localize: _index8.default,
	  match: _index10.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */
	    , firstWeekContainsDate: 1
	  }
	};
	
	exports.default = locale;
	module.exports = exports['default'];

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min(
	 *  [
	 *    new Date(1989, 6, 10),
	 *    new Date(1987, 1, 11),
	 *    new Date(1995, 6, 2),
	 *    new Date(1990, 0, 1)
	 *  ]
	 * )
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index2.default)(dirtyDate, dirtyOptions);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	
	  return result;
	}
	module.exports = exports['default'];

/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	var isExisty = function isExisty(value) {
	    return value !== null && value !== undefined;
	};
	
	var _isEmpty = function _isEmpty(value) {
	    if (value instanceof Array) {
	        return value.length === 0;
	    }
	    return value === '' || !isExisty(value);
	};
	
	var isEmptyTrimed = function isEmptyTrimed(value) {
	    if (typeof value === 'string') {
	        return value.trim() === '';
	    }
	    return true;
	};
	
	var validations = {
	    matchRegexp: function matchRegexp(value, regexp) {
	        var validationRegexp = regexp instanceof RegExp ? regexp : new RegExp(regexp);
	        return _isEmpty(value) || validationRegexp.test(value);
	    },
	
	    // eslint-disable-next-line
	    isEmail: function isEmail(value) {
	        return validations.matchRegexp(value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
	    },
	
	    isEmpty: function isEmpty(value) {
	        return _isEmpty(value);
	    },
	
	    required: function required(value) {
	        return !_isEmpty(value);
	    },
	
	    trim: function trim(value) {
	        return !isEmptyTrimed(value);
	    },
	
	    isNumber: function isNumber(value) {
	        return validations.matchRegexp(value, /^-?[0-9]\d*(\d+)?$/i);
	    },
	
	    isFloat: function isFloat(value) {
	        return validations.matchRegexp(value, /^(?:-?[1-9]\d*|-?0)?(?:\.\d+)?$/i);
	    },
	
	    isPositive: function isPositive(value) {
	        if (isExisty(value)) {
	            return (validations.isNumber(value) || validations.isFloat(value)) && value >= 0;
	        }
	        return true;
	    },
	
	    maxNumber: function maxNumber(value, max) {
	        return _isEmpty(value) || parseInt(value, 10) <= parseInt(max, 10);
	    },
	
	    minNumber: function minNumber(value, min) {
	        return _isEmpty(value) || parseInt(value, 10) >= parseInt(min, 10);
	    },
	
	    maxFloat: function maxFloat(value, max) {
	        return _isEmpty(value) || parseFloat(value) <= parseFloat(max);
	    },
	
	    minFloat: function minFloat(value, min) {
	        return _isEmpty(value) || parseFloat(value) >= parseFloat(min);
	    },
	
	    isString: function isString(value) {
	        return !_isEmpty(value) || typeof value === 'string' || value instanceof String;
	    },
	    minStringLength: function minStringLength(value, length) {
	        return validations.isString(value) && value.length >= length;
	    },
	    maxStringLength: function maxStringLength(value, length) {
	        return validations.isString(value) && value.length <= length;
	    },
	
	    // eslint-disable-next-line no-undef
	    isFile: function isFile(value) {
	        return value instanceof File;
	    },
	    maxFileSize: function maxFileSize(value, max) {
	        return validations.isFile(value) && value.size <= parseInt(max, 10);
	    },
	    allowedExtensions: function allowedExtensions(value, fileTypes) {
	        return validations.isFile(value) && fileTypes.split(',').indexOf(value.type) !== -1;
	    }
	};
	
	module.exports = validations;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _promisePolyfill = __webpack_require__(394);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	var _ValidationRules = __webpack_require__(408);
	
	var _ValidationRules2 = _interopRequireDefault(_ValidationRules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	/* eslint-enable */
	
	
	var ValidatorForm = function (_React$Component) {
	    _inherits(ValidatorForm, _React$Component);
	
	    function ValidatorForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ValidatorForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidatorForm.__proto__ || Object.getPrototypeOf(ValidatorForm)).call.apply(_ref, [this].concat(args))), _this), _this.getChildContext = function () {
	            return {
	                form: {
	                    attachToForm: _this.attachToForm,
	                    detachFromForm: _this.detachFromForm,
	                    instantValidate: _this.instantValidate,
	                    debounceTime: _this.debounceTime
	                }
	            };
	        }, _this.instantValidate = _this.props.instantValidate !== undefined ? _this.props.instantValidate : true, _this.debounceTime = _this.props.debounceTime, _this.childs = [], _this.errors = [], _this.attachToForm = function (component) {
	            if (_this.childs.indexOf(component) === -1) {
	                _this.childs.push(component);
	            }
	        }, _this.detachFromForm = function (component) {
	            var componentPos = _this.childs.indexOf(component);
	            if (componentPos !== -1) {
	                _this.childs = _this.childs.slice(0, componentPos).concat(_this.childs.slice(componentPos + 1));
	            }
	        }, _this.submit = function (event) {
	            if (event) {
	                event.preventDefault();
	                event.persist();
	            }
	            _this.errors = [];
	            _this.walk(_this.childs).then(function (result) {
	                if (_this.errors.length) {
	                    _this.props.onError(_this.errors);
	                }
	                if (result) {
	                    _this.props.onSubmit(event);
	                }
	                return result;
	            });
	        }, _this.walk = function (children, dryRun) {
	            var self = _this;
	            return new _promisePolyfill2.default(function (resolve) {
	                var result = true;
	                if (Array.isArray(children)) {
	                    _promisePolyfill2.default.all(children.map(function (input) {
	                        return self.checkInput(input, dryRun);
	                    })).then(function (data) {
	                        data.forEach(function (item) {
	                            if (!item) {
	                                result = false;
	                            }
	                        });
	                        resolve(result);
	                    });
	                } else {
	                    self.walk([children], dryRun).then(function (result) {
	                        return resolve(result);
	                    });
	                }
	            });
	        }, _this.checkInput = function (input, dryRun) {
	            return new _promisePolyfill2.default(function (resolve) {
	                var result = true;
	                var validators = input.props.validators;
	                if (validators) {
	                    _this.validate(input, true, dryRun).then(function (data) {
	                        if (!data) {
	                            result = false;
	                        }
	                        resolve(result);
	                    });
	                } else {
	                    resolve(result);
	                }
	            });
	        }, _this.validate = function (input, includeRequired, dryRun) {
	            return new _promisePolyfill2.default(function (resolve) {
	                var _input$props = input.props,
	                    value = _input$props.value,
	                    validators = _input$props.validators;
	
	                var result = [];
	                var valid = true;
	                var validations = _promisePolyfill2.default.all(validators.map(function (validator) {
	                    return _promisePolyfill2.default.all([_this.constructor.getValidator(validator, value, includeRequired)]).then(function (data) {
	                        result.push({ input: input, result: data && data[0] });
	                        input.validate(input.props.value, true, dryRun);
	                    });
	                }));
	                validations.then(function () {
	                    result.forEach(function (item) {
	                        if (!item.result) {
	                            valid = false;
	                            _this.errors.push(item.input);
	                        }
	                    });
	                    resolve(valid);
	                });
	            });
	        }, _this.find = function (collection, fn) {
	            for (var i = 0, l = collection.length; i < l; i++) {
	                var item = collection[i];
	                if (fn(item)) {
	                    return item;
	                }
	            }
	            return null;
	        }, _this.resetValidations = function () {
	            _this.childs.forEach(function (child) {
	                child.validateDebounced.cancel();
	                child.setState({ isValid: true });
	            });
	        }, _this.isFormValid = function () {
	            var dryRun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            return _this.walk(_this.childs, dryRun);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ValidatorForm, [{
	        key: 'render',
	        value: function render() {
	            // eslint-disable-next-line
	            var _props = this.props,
	                onSubmit = _props.onSubmit,
	                instantValidate = _props.instantValidate,
	                onError = _props.onError,
	                debounceTime = _props.debounceTime,
	                children = _props.children,
	                rest = _objectWithoutProperties(_props, ['onSubmit', 'instantValidate', 'onError', 'debounceTime', 'children']);
	
	            return _react2.default.createElement(
	                'form',
	                _extends({}, rest, { onSubmit: this.submit }),
	                children
	            );
	        }
	    }]);
	
	    return ValidatorForm;
	}(_react2.default.Component);
	
	ValidatorForm.getValidator = function (validator, value, includeRequired) {
	    var result = true;
	    var name = validator;
	    if (name !== 'required' || includeRequired) {
	        var extra = void 0;
	        var splitIdx = validator.indexOf(':');
	        if (splitIdx !== -1) {
	            name = validator.substring(0, splitIdx);
	            extra = validator.substring(splitIdx + 1);
	        }
	        result = _ValidationRules2.default[name](value, extra);
	    }
	    return result;
	};
	
	ValidatorForm.addValidationRule = function (name, callback) {
	    _ValidationRules2.default[name] = callback;
	};
	
	ValidatorForm.removeValidationRule = function (name) {
	    delete _ValidationRules2.default[name];
	};
	
	ValidatorForm.childContextTypes = {
	    form: _propTypes2.default.object
	};
	
	ValidatorForm.propTypes = {
	    onSubmit: _propTypes2.default.func.isRequired,
	    instantValidate: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    onError: _propTypes2.default.func,
	    debounceTime: _propTypes2.default.number
	};
	
	ValidatorForm.defaultProps = {
	    onError: function onError() {},
	    debounceTime: 0
	};
	
	exports.default = ValidatorForm;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(415);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(912));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(414));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(168));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(169));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(57));
	
	var _invariant = _interopRequireDefault(__webpack_require__(732));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(165);
	
	var _Context = __webpack_require__(167);
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	  (0, _invariant.default)(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
	  (0, _invariant.default)(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
	  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	  (0, _invariant.default)(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	    var OuterBaseComponent = _react.Component;
	
	    if (pure) {
	      OuterBaseComponent = _react.PureComponent;
	    }
	
	    function makeDerivedPropsSelector() {
	      var lastProps;
	      var lastState;
	      var lastDerivedProps;
	      var lastStore;
	      var lastSelectorFactoryOptions;
	      var sourceSelector;
	      return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
	        if (pure && lastProps === props && lastState === state) {
	          return lastDerivedProps;
	        }
	
	        if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
	          lastStore = store;
	          lastSelectorFactoryOptions = selectorFactoryOptions;
	          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
	        }
	
	        lastProps = props;
	        lastState = state;
	        var nextProps = sourceSelector(state, props);
	        lastDerivedProps = nextProps;
	        return lastDerivedProps;
	      };
	    }
	
	    function makeChildElementSelector() {
	      var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
	      return function selectChildElement(WrappedComponent, childProps, forwardRef) {
	        if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
	          lastChildProps = childProps;
	          lastForwardRef = forwardRef;
	          lastComponent = WrappedComponent;
	          lastChildElement = _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, childProps, {
	            ref: forwardRef
	          }));
	        }
	
	        return lastChildElement;
	      };
	    }
	
	    var Connect =
	    /*#__PURE__*/
	    function (_OuterBaseComponent) {
	      (0, _inheritsLoose2.default)(Connect, _OuterBaseComponent);
	
	      function Connect(props) {
	        var _this;
	
	        _this = _OuterBaseComponent.call(this, props) || this;
	        (0, _invariant.default)(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
	        _this.selectDerivedProps = makeDerivedPropsSelector();
	        _this.selectChildElement = makeChildElementSelector();
	        _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, _assertThisInitialized2.default)(_this));
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
	        // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
	        return this.renderWrappedComponent(value);
	      };
	
	      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
	        (0, _invariant.default)(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	        var storeState = value.storeState,
	            store = value.store;
	        var wrapperProps = this.props;
	        var forwardedRef;
	
	        if (forwardRef) {
	          wrapperProps = this.props.wrapperProps;
	          forwardedRef = this.props.forwardedRef;
	        }
	
	        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
	        return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
	      };
	
	      _proto.render = function render() {
	        var ContextToUse = this.props.context && this.props.context.Consumer && (0, _reactIs.isContextConsumer)(_react.default.createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
	        return _react.default.createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
	      };
	
	      return Connect;
	    }(OuterBaseComponent);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react.default.forwardRef(function forwardConnectRef(props, ref) {
	        return _react.default.createElement(Connect, {
	          wrapperProps: props,
	          forwardedRef: ref
	        });
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics.default)(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(412));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(910));
	
	var _warning = _interopRequireDefault(__webpack_require__(413));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 413 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 414 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 415 */
26,
/* 416 */
[1024, 919],
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logout = exports.gotoSignIn = exports.gotoPathOrDashboard = exports.loginUser = exports.authUser = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _connectedReactRouter = __webpack_require__(74);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _lodash = __webpack_require__(27);
	
	var _types = __webpack_require__(9);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var authUser = exports.authUser = function authUser(token) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch({
	                type: _types.LOGIN_IS_LOADING,
	                payload: true
	              });
	
	              if (!(token == null)) {
	                _context.next = 3;
	                break;
	              }
	
	              return _context.abrupt('return', dispatch({
	                type: _types.LOGIN_IS_LOADING,
	                payload: false
	              }));
	
	            case 3:
	              _context.prev = 3;
	              _context.next = 6;
	              return _axios2.default.get(_baseUrl2.default + '/api/findUser', (0, _authorizeRequest2.default)());
	
	            case 6:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.JWT_AUTH_SUCCESS,
	                payload: {
	                  username: response.data.username,
	                  isOperator: response.data.isOperator
	                }
	              });
	
	              _context.next = 14;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](3);
	
	              console.error((0, _lodash.get)(_context.t0, 'response.data', _context.t0));
	              dispatch({
	                type: _types.LOGOUT,
	                payload: false
	              });
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[3, 10]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var loginUser = exports.loginUser = function loginUser(username, password, rememberMe) {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch) {
	      var _ref3, token, responseUser;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _axios2.default.post(_baseUrl2.default + '/api/login', { username: username, password: password });
	
	            case 3:
	              _ref3 = _context2.sent;
	              token = _ref3.data.token;
	
	              if (!token) {
	                _context2.next = 12;
	                break;
	              }
	
	              _context2.next = 8;
	              return _axios2.default.get(_baseUrl2.default + '/api/findUser', (0, _authorizeRequest2.default)(token));
	
	            case 8:
	              responseUser = _context2.sent;
	
	
	              if (responseUser.data.isOperator) {
	                dispatch({
	                  type: _types.LOGIN_OPERATOR_SUCCESS,
	                  payload: { token: token, rememberMe: rememberMe }
	                });
	              } else {
	                dispatch({
	                  type: _types.LOGIN_CUSTOMER_SUCCESS,
	                  payload: { token: token, rememberMe: rememberMe }
	                });
	              }
	
	              _context2.next = 13;
	              break;
	
	            case 12:
	              dispatch({
	                type: _types.LOGIN_FAIL
	              });
	
	            case 13:
	              _context2.next = 19;
	              break;
	
	            case 15:
	              _context2.prev = 15;
	              _context2.t0 = _context2['catch'](0);
	
	              console.info(_context2.t0);
	              dispatch({
	                type: _types.LOGIN_FAIL
	              });
	
	            case 19:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 15]]);
	    }));
	
	    return function (_x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var gotoPathOrDashboard = exports.gotoPathOrDashboard = function gotoPathOrDashboard(path) {
	  return function (dispatch) {
	    return dispatch((0, _connectedReactRouter.push)(path || '/dashboard'));
	  };
	};
	var gotoSignIn = exports.gotoSignIn = function gotoSignIn(path) {
	  return function (dispatch) {
	    return dispatch((0, _connectedReactRouter.push)('/sign-in', { from: path }));
	  };
	};
	
	var logout = exports.logout = function logout() {
	  return function (dispatch) {
	    dispatch({ type: _types.LOGOUT });
	  };
	};

/***/ },
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchConfigPending = fetchConfigPending;
	exports.fetchConfigSuccess = fetchConfigSuccess;
	exports.fetchConfigError = fetchConfigError;
	var FETCH_CONFIG_PENDING = exports.FETCH_CONFIG_PENDING = 'FETCH_CONFIG_PENDING';
	var FETCH_CONFIG_SUCCESS = exports.FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
	var FETCH_CONFIG_ERROR = exports.FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR';
	
	function fetchConfigPending() {
	  return {
	    type: FETCH_CONFIG_PENDING
	  };
	}
	
	function fetchConfigSuccess(config) {
	  return {
	    type: FETCH_CONFIG_SUCCESS,
	    payload: config
	  };
	}
	
	function fetchConfigError(error) {
	  return {
	    type: FETCH_CONFIG_ERROR,
	    error: error
	  };
	}

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (filePath) {
	  if (!filePath) {
	    return;
	  }
	  var splitted = filePath.split('/');
	  return splitted[splitted.length - 1].split('?')[0];
	};

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBits = exports.isBitfield = undefined;
	exports.formatResults = formatResults;
	
	var _status_reducer = __webpack_require__(421);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isBitfield = exports.isBitfield = function isBitfield(item) {
	  return ((0, _status_reducer.getAlarmById)(item.id) || item).type === 'bitfield';
	};
	var replaceAt = function replaceAt(string, index, value) {
	  return "" + string.substring(0, index) + value + string.substring(index + value.length);
	};
	
	var resetIndex = function resetIndex(i, bits, decode) {
	  var result = !decode[i] ? replaceAt(bits, bits.length - i - 1, '0') : bits;
	
	  return i < bits.length ? resetIndex(i + 1, result, decode) : result;
	};
	
	// Remove 211 endpoint's heartbeat
	var getBits = exports.getBits = function getBits(item) {
	  return resetIndex(0, item.value.toString(2), (0, _status_reducer.getAlarmById)(item.id).decode);
	};
	
	function formatResults(results) {
	  var reworked = [];
	
	  results.forEach(function (items) {
	    var reworkedItems = [];
	
	    items.forEach(function (item) {
	
	      if (isBitfield(item)) {
	        item.bits = getBits(item);
	      }
	
	      var previousItem = reworkedItems[reworkedItems.length - 1];
	
	      if (!reworkedItems.length || previousItem.bits && previousItem.bits !== item.bits || !previousItem.bits && previousItem.value !== item.value) {
	
	        // Convert Alarm and event ID to Human readable strings
	        var readable = (0, _status_reducer.populateAlarmContent)(item);
	        Object.assign(item, readable);
	
	        item.displayTimestamp = (0, _moment2.default)(item.timestamp).format("DD/MM/YYYY, HH:mm");
	
	        reworkedItems.push(item);
	      }
	    });
	
	    reworked.push(reworkedItems);
	  });
	
	  return (0, _lodash.flatten)(reworked);
	}

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAlarmById = getAlarmById;
	exports.populateAlarmContent = populateAlarmContent;
	
	var _types = __webpack_require__(9);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(27);
	
	var _alarms = __webpack_require__(148);
	
	var _alarms2 = _interopRequireDefault(_alarms);
	
	var _getStatus = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = {
	  results: []
	};
	
	function getAlarmById(alarmId) {
	  return (0, _lodash.find)(_alarms2.default.status, function (_ref) {
	    var id = _ref.id;
	
	    return id === alarmId;
	  });
	}
	
	var getIndexRight = function getIndexRight(bits, key, defaultValue) {
	  var targetIndex = bits.length - 1 - key;
	  return (0, _lodash.get)(bits, "[" + targetIndex + "]", defaultValue);
	};
	
	var getBitfieldContent = function getBitfieldContent(_ref2, _ref3) {
	  var decode = _ref2.decode,
	      desc = _ref2.desc;
	  var id = _ref3.id,
	      bits = _ref3.bits;
	  return {
	    alarmName: desc || id,
	    values: (0, _lodash.map)(decode, function (value, key) {
	      return {
	        title: value,
	        value: !!parseInt(getIndexRight(bits, parseInt(key, 10), 0), 10)
	      };
	    })
	  };
	};
	
	function getValueContent(alarm, item) {
	  return {
	    alarmName: alarm && alarm.desc || item.id,
	    alarmValue: alarm && alarm.decode[item.value] || item.value
	  };
	}
	
	function getRawContent(alarm, item) {
	  return {
	    alarmName: alarm && alarm.desc || item.id,
	    alarmValue: item.value
	  };
	}
	
	function populateAlarmContent(item) {
	  var alarm = getAlarmById(item.id) || item;
	
	  switch (alarm.type) {
	    case 'bitfield':
	      return getBitfieldContent(alarm, item);
	    case 'value':
	      return getValueContent(alarm, item);
	    default:
	      return getRawContent(alarm, item);
	  }
	}
	
	function formatResults(originalResults) {
	  // TODO deepClone originalResults
	  var results = [].concat(_toConsumableArray(originalResults));
	  results.forEach(function (item) {
	    item.displayTimestamp = (0, _moment2.default)(item.timestamp).format("DD/MM/YYYY, HH:mm");
	
	    if ((0, _getStatus.isBitfield)(item)) {
	      item.bits = (0, _getStatus.getBits)(item);
	    }
	
	    // Convert Alarm and event ID to Human readable strings
	    Object.assign(item, populateAlarmContent(item));
	  });
	  return results;
	}
	
	var statusReducer = function statusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.results;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_STATUS:
	      return formatResults(payload.data.results);
	    default:
	      return state;
	  }
	};
	
	exports.default = statusReducer;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(174));
	
	var _ChildMapping = __webpack_require__(1000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 423 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 425 */
/***/ function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 426 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 427 */
414,
/* 428 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	    return;
	  }
	
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ },
/* 429 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 430 */
169,
/* 431 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(176);
	
	var iterableToArray = __webpack_require__(179);
	
	var nonIterableRest = __webpack_require__(180);
	
	function _toArray(arr) {
	  return arrayWithHoles(arr) || iterableToArray(arr) || nonIterableRest();
	}
	
	module.exports = _toArray;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var defaultMoment = _interopDefault(__webpack_require__(5));
	
	var MomentUtils = /** @class */ (function () {
	    function MomentUtils(_a) {
	        var _b = _a === void 0 ? {} : _a, locale = _b.locale, instance = _b.instance, moment = _b.moment;
	        this.yearFormat = "YYYY";
	        this.yearMonthFormat = "MMMM YYYY";
	        this.dateTime12hFormat = "MMMM Do hh:mm a";
	        this.dateTime24hFormat = "MMMM Do HH:mm";
	        this.time12hFormat = "hh:mm A";
	        this.time24hFormat = "HH:mm";
	        this.dateFormat = "MMMM Do";
	        this.moment = instance || moment || defaultMoment;
	        this.locale = locale;
	    }
	    MomentUtils.prototype.parse = function (value, format) {
	        if (value === "") {
	            return null;
	        }
	        return this.moment(value, format, true);
	    };
	    MomentUtils.prototype.date = function (value) {
	        if (value === null) {
	            return null;
	        }
	        var moment = this.moment(value);
	        moment.locale(this.locale);
	        return moment;
	    };
	    MomentUtils.prototype.isValid = function (value) {
	        return this.moment(value).isValid();
	    };
	    MomentUtils.prototype.isNull = function (date) {
	        return date === null;
	    };
	    MomentUtils.prototype.getDiff = function (date, comparing) {
	        return date.diff(comparing);
	    };
	    MomentUtils.prototype.isAfter = function (date, value) {
	        return date.isAfter(value);
	    };
	    MomentUtils.prototype.isBefore = function (date, value) {
	        return date.isBefore(value);
	    };
	    MomentUtils.prototype.isAfterDay = function (date, value) {
	        return date.isAfter(value, "day");
	    };
	    MomentUtils.prototype.isBeforeDay = function (date, value) {
	        return date.isBefore(value, "day");
	    };
	    MomentUtils.prototype.isBeforeYear = function (date, value) {
	        return date.isBefore(value, "year");
	    };
	    MomentUtils.prototype.isAfterYear = function (date, value) {
	        return date.isAfter(value, "year");
	    };
	    MomentUtils.prototype.startOfDay = function (date) {
	        return date.clone().startOf("day");
	    };
	    MomentUtils.prototype.endOfDay = function (date) {
	        return date.clone().endOf("day");
	    };
	    MomentUtils.prototype.format = function (date, formatString) {
	        date.locale(this.locale);
	        return date.format(formatString);
	    };
	    MomentUtils.prototype.formatNumber = function (numberToFormat) {
	        return numberToFormat;
	    };
	    MomentUtils.prototype.getHours = function (date) {
	        return date.get("hours");
	    };
	    MomentUtils.prototype.addDays = function (date, count) {
	        return count < 0
	            ? date.clone().subtract(Math.abs(count), "days")
	            : date.clone().add(count, "days");
	    };
	    MomentUtils.prototype.setHours = function (date, count) {
	        return date.clone().hours(count);
	    };
	    MomentUtils.prototype.getMinutes = function (date) {
	        return date.get("minutes");
	    };
	    MomentUtils.prototype.setMinutes = function (date, count) {
	        return date.clone().minutes(count);
	    };
	    MomentUtils.prototype.getSeconds = function (date) {
	        return date.get("seconds");
	    };
	    MomentUtils.prototype.setSeconds = function (date, count) {
	        return date.clone().seconds(count);
	    };
	    MomentUtils.prototype.getMonth = function (date) {
	        return date.get("month");
	    };
	    MomentUtils.prototype.isSameDay = function (date, comparing) {
	        return date.isSame(comparing, "day");
	    };
	    MomentUtils.prototype.setMonth = function (date, count) {
	        return date.clone().month(count);
	    };
	    MomentUtils.prototype.getMeridiemText = function (ampm) {
	        return ampm === "am" ? "AM" : "PM";
	    };
	    MomentUtils.prototype.startOfMonth = function (date) {
	        return date.clone().startOf("month");
	    };
	    MomentUtils.prototype.endOfMonth = function (date) {
	        return date.clone().endOf("month");
	    };
	    MomentUtils.prototype.getNextMonth = function (date) {
	        return date.clone().add(1, "month");
	    };
	    MomentUtils.prototype.getPreviousMonth = function (date) {
	        return date.clone().subtract(1, "month");
	    };
	    MomentUtils.prototype.getMonthArray = function (date) {
	        var firstMonth = date.clone().startOf("year");
	        var monthArray = [firstMonth];
	        while (monthArray.length < 12) {
	            var prevMonth = monthArray[monthArray.length - 1];
	            monthArray.push(this.getNextMonth(prevMonth));
	        }
	        return monthArray;
	    };
	    MomentUtils.prototype.getYear = function (date) {
	        return date.get("year");
	    };
	    MomentUtils.prototype.setYear = function (date, year) {
	        return date.clone().set("year", year);
	    };
	    MomentUtils.prototype.mergeDateAndTime = function (date, time) {
	        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
	    };
	    MomentUtils.prototype.getWeekdays = function () {
	        return this.moment.weekdaysShort(true);
	    };
	    MomentUtils.prototype.isEqual = function (value, comparing) {
	        if (value === null && comparing === null) {
	            return true;
	        }
	        return this.moment(value).isSame(comparing);
	    };
	    MomentUtils.prototype.getWeekArray = function (date) {
	        var start = date
	            .clone()
	            .startOf("month")
	            .startOf("week");
	        var end = date
	            .clone()
	            .endOf("month")
	            .endOf("week");
	        var count = 0;
	        var current = start;
	        var nestedWeeks = [];
	        while (current.isBefore(end)) {
	            var weekNumber = Math.floor(count / 7);
	            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
	            nestedWeeks[weekNumber].push(current);
	            current = current.clone().add(1, "day");
	            count += 1;
	        }
	        return nestedWeeks;
	    };
	    MomentUtils.prototype.getYearRange = function (start, end) {
	        var startDate = this.moment(start).startOf("year");
	        var endDate = this.moment(end).endOf("year");
	        var years = [];
	        var current = startDate;
	        while (current.isBefore(endDate)) {
	            years.push(current);
	            current = current.clone().add(1, "year");
	        }
	        return years;
	    };
	    // displaying methods
	    MomentUtils.prototype.getCalendarHeaderText = function (date) {
	        return this.format(date, this.yearMonthFormat);
	    };
	    MomentUtils.prototype.getYearText = function (date) {
	        return this.format(date, "YYYY");
	    };
	    MomentUtils.prototype.getDatePickerHeaderText = function (date) {
	        return this.format(date, "ddd, MMM D");
	    };
	    MomentUtils.prototype.getDateTimePickerHeaderText = function (date) {
	        return this.format(date, "MMM D");
	    };
	    MomentUtils.prototype.getMonthText = function (date) {
	        return this.format(date, "MMMM");
	    };
	    MomentUtils.prototype.getDayText = function (date) {
	        return this.format(date, "D");
	    };
	    MomentUtils.prototype.getHourText = function (date, ampm) {
	        return this.format(date, ampm ? "hh" : "HH");
	    };
	    MomentUtils.prototype.getMinuteText = function (date) {
	        return this.format(date, "mm");
	    };
	    MomentUtils.prototype.getSecondText = function (date) {
	        return this.format(date, "ss");
	    };
	    return MomentUtils;
	}());
	
	module.exports = MomentUtils;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `position="fixed"`. */
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="absolute"`. */
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="sticky"`. */
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {
	      position: 'static'
	    },
	
	    /* Styles applied to the root element if `position="relative"`. */
	    positionRelative: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	var AppBar = _react.default.forwardRef(function AppBar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'fixed' : _props$position,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "position"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], className, color !== 'inherit' && classes["color".concat((0, _helpers.capitalize)(color))], {
	      fixed: 'mui-fixed'
	    }[position]),
	    ref: ref
	  }, other));
	});
	
	 false ? AppBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if there are children and not `src` or `srcSet`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE 11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Avatar = _react.default.forwardRef(function Avatar(props, ref) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var children = null;
	  var img = src || srcSet;
	
	  if (img) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
	    children = _react.default.cloneElement(childrenProp, {
	      className: (0, _clsx.default)(childrenClassNameProp, childrenProp.props.className)
	    });
	  } else {
	    children = childrenProp;
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes.system, classNameProp, !img && classes.colorDefault),
	    ref: ref
	  }, other), children);
	});
	
	 false ? Avatar.propTypes = {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Attributes applied to the `img` element if the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Fade = _interopRequireDefault(__webpack_require__(121));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    // Disable scroll capabilities.
	    touchAction: 'none'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	
	var Backdrop = _react.default.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var RADIUS_STANDARD = 10;
	var RADIUS_DOT = 3;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the badge `span` element. */
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      boxSizing: 'border-box',
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(12),
	      minWidth: RADIUS_STANDARD * 2,
	      lineHeight: 1,
	      padding: '0 6px',
	      height: RADIUS_STANDARD * 2,
	      borderRadius: RADIUS_STANDARD,
	      backgroundColor: theme.palette.color,
	      color: theme.palette.textColor,
	      zIndex: 1,
	      // Render the badge on top of potential ripples.
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.enteringScreen
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    },
	
	    /* Styles applied to the root element if `variant="dot"`. */
	    dot: {
	      height: RADIUS_DOT * 2,
	      minWidth: RADIUS_DOT * 2,
	      padding: 0
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
	    anchorOriginTopRightRectangle: {
	      top: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
	    anchorOriginBottomRightRectangle: {
	      bottom: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
	    anchorOriginTopLeftRectangle: {
	      top: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
	    anchorOriginBottomLeftRectangle: {
	      bottom: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
	    anchorOriginTopRightCircle: {
	      top: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
	    anchorOriginBottomRightCircle: {
	      bottom: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
	    anchorOriginTopLeftCircle: {
	      top: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
	    anchorOriginBottomLeftCircle: {
	      bottom: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
	    invisible: {
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.leavingScreen
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Badge = _react.default.forwardRef(function Badge(props, ref) {
	  var _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'right'
	  } : _props$anchorOrigin,
	      badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
	      invisibleProp = props.invisible,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 99 : _props$max,
	      _props$overlap = props.overlap,
	      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
	      _props$showZero = props.showZero,
	      showZero = _props$showZero === void 0 ? false : _props$showZero,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
	  var invisible = invisibleProp;
	
	  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
	    invisible = true;
	  }
	
	  var displayValue = '';
	
	  if (variant !== 'dot') {
	    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
	  }
	
	  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), children, _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, _helpers.capitalize)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, _helpers.capitalize)(anchorOrigin.vertical)).concat((0, _helpers.capitalize)(anchorOrigin.horizontal)).concat((0, _helpers.capitalize)(overlap))], color !== 'default' && classes["color".concat((0, _helpers.capitalize)(color))], invisible && classes.invisible, {
	      dot: classes.dot
	    }[variant])
	  }, displayValue));
	});
	
	 false ? Badge.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The anchor of the badge.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the badge will be invisible.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * Max count to show.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * Wrapped shape the badge should overlap.
	   */
	  overlap: _propTypes.default.oneOf(['circle', 'rectangle']),
	
	  /**
	   * Controls whether the badge is hidden when `badgeContent` is zero.
	   */
	  showZero: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dot', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(437));

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	
	var BottomNavigation = _react.default.forwardRef(function BottomNavigation(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      onChange = props.onChange,
	      _props$showLabels = props.showLabels,
	      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), _react.default.Children.map(children, function (child, childIndex) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return _react.default.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  }));
	});
	
	 false ? BottomNavigation.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(439));

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(138));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      padding: '6px 12px 8px',
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: 16
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if selected. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
	    iconOnly: {},
	
	    /* Styles applied to the span element that wraps the icon and label. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the label's span element. */
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var BottomNavigationAction = _react.default.forwardRef(function BottomNavigationAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      icon = props.icon,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      showLabel = props.showLabel,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
	    focusRipple: true,
	    onClick: handleChange
	  }, other), _react.default.createElement("span", {
	    className: classes.wrapper
	  }, icon, _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
	  }, label)));
	});
	
	 false ? BottomNavigationAction.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `BottomNavigationAction` will show its label.
	   * By default, only the selected `BottomNavigationAction`
	   * inside `BottomNavigation` will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(441));

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styleFunction = void 0;
	
	var _system = __webpack_require__(681);
	
	var _styled = _interopRequireDefault(__webpack_require__(226));
	
	var styleFunction = (0, _system.css)((0, _system.compose)(_system.borders, _system.display, _system.flexbox, _system.positions, _system.palette, _system.shadows, _system.sizing, _system.spacing, _system.typography));
	/**
	 * @ignore - do not document.
	 */
	
	exports.styleFunction = styleFunction;
	var Box = (0, _styled.default)('div')(styleFunction, {
	  name: 'MuiBox'
	});
	var _default = Box;
	exports.default = _default;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "styleFunction", {
	  enumerable: true,
	  get: function get() {
	    return _Box.styleFunction;
	  }
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(443));

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(621));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex'
	    },
	    icon: {
	      width: 24,
	      height: 16,
	      backgroundColor: theme.palette.grey[100],
	      color: theme.palette.grey[700],
	      borderRadius: 2,
	      marginLeft: theme.spacing(0.5),
	      marginRight: theme.spacing(0.5),
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: theme.palette.grey[200]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function BreadcrumbCollapsed(props) {
	  var classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
	  return _react.default.createElement("li", (0, _extends2.default)({
	    className: classes.root
	  }, other), _react.default.createElement(_MoreHoriz.default, {
	    className: classes.icon
	  }));
	}
	
	 false ? BreadcrumbCollapsed.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbCollapsed'
	})(BreadcrumbCollapsed);
	
	exports.default = _default;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  root: {
	    display: 'flex',
	    userSelect: 'none',
	    marginLeft: 8,
	    marginRight: 8
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	function BreadcrumbSeparator(props) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return _react.default.createElement("li", (0, _extends2.default)({
	    "aria-hidden": true,
	    className: (0, _clsx.default)(classes.root, className)
	  }, other));
	}
	
	 false ? BreadcrumbSeparator.propTypes = {
	  children: _propTypes.default.node.isRequired,
	  classes: _propTypes.default.object.isRequired,
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbSeparator'
	})(BreadcrumbSeparator);
	
	exports.default = _default;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _BreadcrumbCollapsed = _interopRequireDefault(__webpack_require__(445));
	
	var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(446));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ol element. */
	  ol: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    // Reset
	    margin: 0 // Reset
	
	  },
	
	  /* Styles applied to the li element. */
	  li: {
	    listStyle: 'none'
	  },
	
	  /* Styles applied to the separator element. */
	  separator: {}
	};
	exports.styles = styles;
	
	function insertSeparators(items, className, separator) {
	  return items.reduce(function (acc, current, index) {
	    if (index < items.length - 1) {
	      acc = acc.concat(current, _react.default.createElement(_BreadcrumbSeparator.default, {
	        key: "separator-".concat(index),
	        className: className
	      }, separator));
	    } else {
	      acc.push(current);
	    }
	
	    return acc;
	  }, []);
	}
	
	var Breadcrumbs = _react.default.forwardRef(function Breadcrumbs(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'nav' : _props$component,
	      _props$itemsAfterColl = props.itemsAfterCollapse,
	      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
	      _props$itemsBeforeCol = props.itemsBeforeCollapse,
	      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
	      _props$maxItems = props.maxItems,
	      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
	      _props$separator = props.separator,
	      separator = _props$separator === void 0 ? '/' : _props$separator,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
	
	  var _React$useState = _react.default.useState(false),
	      expanded = _React$useState[0],
	      setExpanded = _React$useState[1];
	
	  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
	    var handleClickExpand = function handleClickExpand() {
	      setExpanded(true);
	    }; // This defends against someone passing weird input, to ensure that if all
	    // items would be shown anyway, we just show all items without the EllipsisItem
	
	
	    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
	      if (false) {
	        console.error(['Material-UI: you have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
	      }
	
	      return allItems;
	    }
	
	    return [].concat((0, _toConsumableArray2.default)(allItems.slice(0, itemsBeforeCollapse)), [_react.default.createElement(_BreadcrumbCollapsed.default, {
	      key: "ellipsis",
	      onClick: handleClickExpand
	    })], (0, _toConsumableArray2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
	  };
	
	  var allItems = _react.default.Children.toArray(children).filter(function (child) {
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return _react.default.isValidElement(child);
	  }).map(function (child, index) {
	    return _react.default.createElement("li", {
	      className: classes.li,
	      key: "child-".concat(index)
	    }, child);
	  });
	
	  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
	    ref: ref,
	    component: Component,
	    color: "textSecondary",
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), _react.default.createElement("ol", {
	    className: classes.ol
	  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
	});
	
	 false ? Breadcrumbs.propTypes = {
	  /**
	   * The breadcrumb children.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If max items is exceeded, the number of items to show after the ellipsis.
	   */
	  itemsAfterCollapse: _propTypes.default.number,
	
	  /**
	   * If max items is exceeded, the number of items to show before the ellipsis.
	   */
	  itemsBeforeCollapse: _propTypes.default.number,
	
	  /**
	   * Specifies the maximum number of breadcrumbs to display. When there are more
	   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	   * will be shown, with an ellipsis in between.
	   */
	  maxItems: _propTypes.default.number,
	
	  /**
	   * Custom separator node.
	   */
	  separator: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBreadcrumbs'
	})(Breadcrumbs);
	
	exports.default = _default;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(447));

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minWidth: 64,
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // Ensure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      padding: '6px 8px'
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      padding: '5px 16px',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit',
	      borderColor: 'currentColor'
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {
	      padding: '8px 24px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Button = _react.default.forwardRef(function Button(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "fullWidth", "size", "type", "variant"]);
	  var text = variant === 'text';
	  var outlined = variant === 'outlined';
	  var contained = variant === 'contained';
	  var primary = color === 'primary';
	  var secondary = color === 'secondary';
	  var className = (0, _clsx.default)(classes.root, classNameProp, text && [classes.text, primary && classes.textPrimary, secondary && classes.textSecondary], outlined && [classes.outlined, primary && classes.outlinedPrimary, secondary && classes.outlinedSecondary], contained && [classes.contained, primary && classes.containedPrimary, secondary && classes.containedSecondary], size !== 'medium' && classes["size".concat((0, _helpers.capitalize)(size))], disabled && classes.disabled, fullWidth && classes.fullWidth, {
	    inherit: classes.colorInherit
	  }[color]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: className,
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref,
	    type: type
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	});
	
	 false ? Button.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(126));
	
	var _focusVisible = __webpack_require__(92);
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(452));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	
	var ButtonBase = _react.default.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	
	  var buttonRef = _react.default.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return _reactDom.default.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = _react.default.useRef(null);
	
	  var _React$useState = _react.default.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _focusVisible.useIsFocusVisible)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  _react.default.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	
	  _react.default.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = event.defaultPrevented || skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    if (disabled) {
	      return;
	    } // Fix for https://github.com/facebook/react/issues/7769
	
	
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	  var keydownRef = _react.default.useRef(false);
	
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	
	    var button = getButtonNode(); // Keyboard accessibility for non interactive elements
	
	    if (event.target === event.currentTarget && component && component !== 'button' && (event.key === ' ' || event.key === 'Enter') && !(button.tagName === 'A' && button.href)) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _reactHelpers.useForkRef)(buttonRefProp, ref);
	  var handleOwnRef = (0, _reactHelpers.useForkRef)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _reactHelpers.useForkRef)(handleUserRef, handleOwnRef);
	  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps))) : null);
	});
	
	 false ? ButtonBase.propTypes = {
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This prop passes the value to the `type` attribute of the native button component.
	   */
	  type: _propTypes.default.oneOf(['submit', 'reset', 'button'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = _react.default.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return _react.default.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, _react.default.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(451));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	}; // TODO v5: Make private
	
	
	exports.styles = styles;
	
	var TouchRipple = _react.default.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = _react.default.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = _react.default.useRef(0);
	
	  var rippleCallback = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	
	  var ignoringMouseDown = _react.default.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	
	  var startTimer = _react.default.useRef(null); // This is the hook called once the previous timeout is ready.
	
	
	  var startTimerCommit = _react.default.useRef(null);
	
	  var container = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	
	  var startCommit = _react.default.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [_react.default.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	
	  var start = _react.default.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	      var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // Prepare the ripple effect.
	      startTimerCommit.current = function () {
	        startCommit({
	          pulsate: pulsate,
	          rippleX: rippleX,
	          rippleY: rippleY,
	          rippleSize: rippleSize,
	          cb: cb
	        });
	      }; // Delay the execution of the ripple effect.
	
	
	      startTimer.current = setTimeout(function () {
	        if (startTimerCommit.current) {
	          startTimerCommit.current();
	          startTimerCommit.current = null;
	        }
	      }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	
	  var pulsate = _react.default.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	
	  var stop = _react.default.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	
	  _react.default.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	}); // TODO cleanup after https://github.com/reactjs/react-docgen/pull/378 is released
	
	
	function withMuiName(Component) {
	  Component.muiName = 'MuiTouchRipple';
	  return Component;
	}
	
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(withMuiName(_react.default.memo(TouchRipple)));
	
	exports.default = _default;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	__webpack_require__(29);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if variant="contained". */
	    contained: {
	      boxShadow: theme.shadows[2]
	    },
	
	    /* Styles applied to the root element if fullWidth={true}. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the children. */
	    grouped: {
	      minWidth: 40,
	      '&:not(:first-child)': {
	        borderTopLeftRadius: 0,
	        borderBottomLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderTopRightRadius: 0,
	        borderBottomRightRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if variant="outlined". */
	    groupedOutlined: {
	      '&:not(:first-child)': {
	        borderLeftColor: 'transparent',
	        marginLeft: -1
	      }
	    },
	
	    /* Styles applied to the children if variant="outlined" & color="primary". */
	    groupedOutlinedPrimary: {
	      '&:hover': {
	        borderColor: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the children if variant="outlined" & color="secondary". */
	    groupedOutlinedSecondary: {
	      '&:hover': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the children if variant="contained". */
	    groupedContained: {
	      boxShadow: 'none',
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderRight: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if variant="contained" & color="primary". */
	    groupedContainedPrimary: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.primary.dark)
	      }
	    },
	
	    /* Styles applied to the children if variant="contained" & color="secondary". */
	    groupedContainedSecondary: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.secondary.dark)
	      }
	    },
	
	    /* Pseudo-class applied to child elements if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	
	var ButtonGroup = _react.default.forwardRef(function ButtonGroup(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "disableRipple", "fullWidth", "size", "variant"]);
	  var outlined = variant === 'outlined';
	  var contained = variant !== "outlined";
	  var primary = color === 'primary';
	  var secondary = color === 'secondary';
	  var buttonClassName = (0, _clsx.default)(classes.grouped, outlined && [classes.groupedOutlined, primary && classes.groupedOutlinedPrimary, secondary && classes.groupedOutlinedSecondary], contained && [classes.groupedContained, primary && classes.groupedContainedPrimary, secondary && classes.groupedContainedSecondary], disabled && classes.disabled);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    role: "group",
	    className: (0, _clsx.default)(classes.root, classNameProp, contained && classes.contained, fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return _react.default.cloneElement(child, {
	      className: (0, _clsx.default)(buttonClassName, child.props.className),
	      disabled: child.props.disabled || disabled,
	      color: child.props.color || color,
	      disableFocusRipple: disableFocusRipple,
	      disableRipple: disableRipple,
	      fullWidth: fullWidth,
	      size: child.props.size || size,
	      variant: child.props.variant || variant
	    });
	  }));
	});
	
	 false ? ButtonGroup.propTypes = {
	  /**
	   * The content of the button group.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the buttons will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the buttons will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonGroup'
	})(ButtonGroup);
	
	exports.default = _default;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(453));

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	
	var Card = _react.default.forwardRef(function Card(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$raised = props.raised,
	      raised = _props$raised === void 0 ? false : _props$raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    elevation: raised ? 8 : 1,
	    ref: ref
	  }, other));
	});
	
	 false ? Card.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      textAlign: 'inherit',
	      width: '100%',
	      '&:hover $focusHighlight': {
	        opacity: theme.palette.action.hoverOpacity
	      },
	      '&$focusVisible $focusHighlight': {
	        opacity: 0.12
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
	    focusHighlight: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit',
	      opacity: 0,
	      backgroundColor: 'currentcolor',
	      transition: theme.transitions.create('opacity', {
	        duration: theme.transitions.duration.short
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	
	var CardActionArea = _react.default.forwardRef(function CardActionArea(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      focusVisibleClassName = props.focusVisibleClassName,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    focusVisibleClassName: (0, _clsx.default)(focusVisibleClassName, classes.focusVisible),
	    ref: ref
	  }, other), children, _react.default.createElement("span", {
	    className: classes.focusHighlight
	  }));
	});
	
	 false ? CardActionArea.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActionArea'
	})(CardActionArea);
	
	exports.default = _default;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(456));

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	__webpack_require__(29);
	
	// So we don't have any override priority issue.
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > * + *': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	
	var CardActions = _react.default.forwardRef(function CardActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	
	 false ? CardActions.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	
	var _CardActions = _interopRequireDefault(__webpack_require__(458));

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    padding: 16,
	    '&:last-child': {
	      paddingBottom: 24
	    }
	  }
	};
	exports.styles = styles;
	
	var CardContent = _react.default.forwardRef(function CardContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	
	 false ? CardContent.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 16
	  },
	
	  /* Styles applied to the avatar element. */
	  avatar: {
	    flex: '0 0 auto',
	    marginRight: 16
	  },
	
	  /* Styles applied to the action element. */
	  action: {
	    flex: '0 0 auto',
	    alignSelf: 'flex-start',
	    marginTop: -8,
	    marginRight: -8
	  },
	
	  /* Styles applied to the content wrapper element. */
	  content: {
	    flex: '1 1 auto'
	  },
	
	  /* Styles applied to the title Typography element. */
	  title: {},
	
	  /* Styles applied to the subheader Typography element. */
	  subheader: {}
	};
	exports.styles = styles;
	
	var CardHeader = _react.default.forwardRef(function CardHeader(props, ref) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      subheaderProp = props.subheader,
	      subheaderTypographyProps = props.subheaderTypographyProps,
	      titleProp = props.title,
	      titleTypographyProps = props.titleTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
	  var title = titleProp;
	
	  if (title != null && title.type !== _Typography.default && !disableTypography) {
	    title = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'h5',
	      className: classes.title,
	      component: "span",
	      display: "block"
	    }, titleTypographyProps), title);
	  }
	
	  var subheader = subheaderProp;
	
	  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
	    subheader = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'body1',
	      className: classes.subheader,
	      color: "textSecondary",
	      component: "span",
	      display: "block"
	    }, subheaderTypographyProps), subheader);
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp),
	    ref: ref
	  }, other), avatar && _react.default.createElement("div", {
	    className: classes.avatar
	  }, avatar), _react.default.createElement("div", {
	    className: classes.content
	  }, title, subheader), action && _react.default.createElement("div", {
	    className: classes.action
	  }, action));
	});
	
	 false ? CardHeader.propTypes = {
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `title` text, and optional `subheader` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the subheader
	   * (as long as disableTypography is not `true`).
	   */
	  subheaderTypographyProps: _propTypes.default.object,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the title
	   * (as long as disableTypography is not `true`).
	   */
	  titleTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(461));

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	
	  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
	  media: {
	    width: '100%',
	    // ⚠️ object-fit is not supported by IE 11.
	    objectFit: 'cover'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	
	var CardMedia = _react.default.forwardRef(function CardMedia(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
	
	  if (false) {
	    if (!children && !image && !src) {
	      console.error('Material-UI: either `children`, `image` or `src` prop must be specified.');
	    }
	  }
	
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, isMediaComponent && classes.media),
	    ref: ref,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other), children);
	});
	
	 false ? CardMedia.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Component for rendering image.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(463));

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(137));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(618));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(617));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(620));
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultCheckedIcon = _react.default.createElement(_CheckBox.default, null);
	
	var defaultIcon = _react.default.createElement(_CheckBoxOutlineBlank.default, null);
	
	var defaultIndeterminateIcon = _react.default.createElement(_IndeterminateCheckBox.default, null);
	
	var Checkbox = _react.default.forwardRef(function Checkbox(props, ref) {
	  var _props$checkedIcon = props.checkedIcon,
	      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$icon = props.icon,
	      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
	      _props$indeterminateI = props.indeterminateIcon,
	      indeterminateIcon = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
	      inputProps = props.inputProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps"]);
	  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], indeterminate && classes.indeterminate),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    color: color,
	    inputProps: (0, _extends2.default)({
	      'data-indeterminate': indeterminate
	    }, inputProps),
	    icon: indeterminate ? indeterminateIcon : icon,
	    ref: ref
	  }, other));
	});
	
	 false ? Checkbox.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   * This does not set the native input element to indeterminate due
	   * to inconsistent behavior across browsers.
	   * However, we set a `data-indeterminate` attribute on the input.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(616));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(138));
	
	var _helpers = __webpack_require__(11);
	
	__webpack_require__(83);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  var height = 32;
	  var smallHeight = 24;
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: height,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: height / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box'
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: smallHeight
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      WebkitTapHighlightColor: 'transparent',
	      // Remove grey highlight
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1],
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      },
	      '&:active': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.12)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      },
	      '&:active': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.12)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: -1
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {
	      marginRight: -4,
	      width: height,
	      height: height,
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      fontSize: theme.typography.pxToRem(16)
	    },
	    avatarSmall: {
	      width: smallHeight,
	      height: smallHeight,
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.dark
	    },
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.dark
	    },
	
	    /* Styles applied to the `avatar` elements children. */
	    avatarChildren: {
	      height: 18
	    },
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -8
	    },
	    iconSmall: {
	      width: 16,
	      marginRight: -5
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element`. */
	    label: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap',
	      cursor: 'inherit'
	    },
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      cursor: 'pointer',
	      height: 'auto',
	      margin: '0 5px 0 -8px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    },
	    deleteIconSmall: {
	      height: 16,
	      margin: '0 1px 0 -9px'
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	exports.styles = styles;
	
	var Chip = _react.default.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      classNameProp = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      deleteIconProp = props.deleteIcon,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	
	  var chipRef = _react.default.useRef(null);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Ignore events from children of `Chip`.
	
	
	    if (event.currentTarget !== event.target) {
	      return;
	    }
	
	    var key = event.key;
	
	    if (key === ' ' || key === 'Enter' || key === 'Backspace' || key === 'Delete' || key === 'Escape') {
	      event.preventDefault();
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Ignore events from children of `Chip`.
	
	
	    if (event.currentTarget !== event.target) {
	      return;
	    }
	
	    var key = event.key;
	
	    if (onClick && (key === ' ' || key === 'Enter')) {
	      onClick(event);
	    } else if (onDelete && (key === 'Backspace' || key === 'Delete')) {
	      onDelete(event);
	    } else if (key === 'Escape' && chipRef.current) {
	      chipRef.current.blur();
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var className = (0, _clsx.default)(classes.root, classNameProp, color !== 'default' && [classes["color".concat((0, _helpers.capitalize)(color))], clickable && classes["clickableColor".concat((0, _helpers.capitalize)(color))], onDelete && classes["deletableColor".concat((0, _helpers.capitalize)(color))]], variant !== "default" && [classes.outlined, {
	    primary: classes.outlinedPrimary,
	    secondary: classes.outlinedSecondary
	  }[color]], small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable);
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _helpers.capitalize)(color))] : classes["deleteIconOutlinedColor".concat((0, _helpers.capitalize)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : _react.default.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && _react.default.isValidElement(avatarProp)) {
	    avatar = _react.default.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _helpers.capitalize)(color))]),
	      childrenClassName: (0, _clsx.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && _react.default.isValidElement(iconProp)) {
	    icon = _react.default.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _helpers.capitalize)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: the Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  var handleRef = (0, _reactHelpers.useForkRef)(chipRef, ref);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: className,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, other), avatar || icon, _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	
	 false ? Chip.propTypes = {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If true, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(466));

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block'
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: '$circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {
	      display: 'block' // Keeps the progress centered
	
	    },
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: '$circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-125px'
	      }
	    },
	
	    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
	    circleDisableShrink: {
	      animation: 'none'
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	var CircularProgress = _react.default.forwardRef(function CircularProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$disableShrink = props.disableShrink,
	      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 40 : _props$size,
	      style = props.style,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _helpers.capitalize)(color))], {
	      indeterminate: classes.indeterminate,
	      static: classes.static
	    }[variant]),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, {}, style),
	    ref: ref,
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _clsx.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
	      indeterminate: classes.circleIndeterminate,
	      static: classes.circleStatic
	    }[variant]),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	});
	
	 false ? CircularProgress.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * If `true`, the shrink animation is disabled.
	   * This only works if variant is `indeterminate`.
	   */
	  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
	      return new Error('Material-UI: you have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The size of the circle.
	   * If using a number, the pixel unit is assumed.
	   * If using a string, you need to provide the CSS unit, e.g '3rem'.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var _utils = __webpack_require__(10);
	
	function useMountedRef() {
	  var mountedRef = _react.default.useRef(false);
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    return function () {
	      mountedRef.current = false;
	    };
	  }, []);
	
	  return mountedRef;
	}
	
	function mapEventPropToEvent(eventProp) {
	  return eventProp.substring(2).toLowerCase();
	}
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	
	
	var ClickAwayListener = _react.default.forwardRef(function ClickAwayListener(props, ref) {
	  var children = props.children,
	      _props$mouseEvent = props.mouseEvent,
	      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
	      _props$touchEvent = props.touchEvent,
	      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent,
	      onClickAway = props.onClickAway;
	  var mountedRef = useMountedRef();
	
	  var movedRef = _react.default.useRef(false);
	
	  var nodeRef = _react.default.useRef(null);
	
	  var handleNodeRef = (0, _reactHelpers.useForkRef)(nodeRef, ref); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _reactHelpers.setRef)(handleNodeRef, _reactDom.default.findDOMNode(instance));
	  }, [handleNodeRef]);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, handleOwnRef);
	  var handleClickAway = (0, _useEventCallback.default)(function (event) {
	    // Ignore events that have been `event.preventDefault()` marked.
	    if (event.defaultPrevented) {
	      return;
	    } // IE 11 support, which trigger the handleClickAway even after the unbind
	
	
	    if (!mountedRef.current) {
	      return;
	    } // Do not act if user performed touchmove
	
	
	    if (movedRef.current) {
	      movedRef.current = false;
	      return;
	    }
	
	    var node = nodeRef.current; // The child might render null.
	
	    if (!node) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(node);
	
	    if (doc.documentElement && doc.documentElement.contains(event.target) && !node.contains(event.target)) {
	      onClickAway(event);
	    }
	  });
	
	  var handleTouchMove = _react.default.useCallback(function () {
	    movedRef.current = true;
	  }, []);
	
	  _react.default.useEffect(function () {
	    if (touchEvent !== false) {
	      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
	      document.addEventListener(mappedTouchEvent, handleClickAway);
	      document.addEventListener('touchmove', handleTouchMove);
	      return function () {
	        document.removeEventListener(mappedTouchEvent, handleClickAway);
	        document.removeEventListener('touchmove', handleTouchMove);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, handleTouchMove, touchEvent]);
	
	  _react.default.useEffect(function () {
	    if (mouseEvent !== false) {
	      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
	      document.addEventListener(mappedMouseEvent, handleClickAway);
	      return function () {
	        document.removeEventListener(mappedMouseEvent, handleClickAway);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, mouseEvent]);
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.cloneElement(children, {
	    ref: handleRef
	  }));
	});
	
	 false ? ClickAwayListener.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  ClickAwayListener['propTypes' + ''] = (0, _utils.exactProp)(ClickAwayListener.propTypes);
	}
	
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _transitions = __webpack_require__(36);
	
	var _utils = __webpack_require__(54);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the container element. */
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	
	    /* Styles applied to the container element when the transition has entered. */
	    entered: {
	      height: 'auto',
	      overflow: 'visible'
	    },
	
	    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
	    hidden: {
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the outer wrapper element. */
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	
	    /* Styles applied to the inner wrapper element. */
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	
	var Collapse = _react.default.forwardRef(function Collapse(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$collapsedHeigh = props.collapsedHeight,
	      collapsedHeight = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? _transitions.duration.standard : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	
	  var timer = _react.default.useRef();
	
	  var wrapperRef = _react.default.useRef(null);
	
	  var autoTransitionDuration = _react.default.useRef();
	
	  _react.default.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    node.style.height = collapsedHeight;
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(node, isAppearing) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleEntered = function handleEntered(node, isAppearing) {
	    node.style.height = 'auto';
	
	    if (onEntered) {
	      onEntered(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExiting = function handleExiting(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = collapsedHeight;
	
	    if (onExiting) {
	      onExiting(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
	    }
	  };
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    in: inProp,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return _react.default.createElement(Component, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, className, {
	        entered: classes.entered,
	        exited: !inProp && collapsedHeight === '0px' && classes.hidden
	      }[state]),
	      style: (0, _extends2.default)({
	        minHeight: collapsedHeight
	      }, style),
	      ref: ref
	    }, childProps), _react.default.createElement("div", {
	      className: classes.wrapper,
	      ref: wrapperRef
	    }, _react.default.createElement("div", {
	      className: classes.wrapperInner
	    }, children)));
	  });
	});
	
	 false ? Collapse.propTypes = {
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : void 0;
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  var _root;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (_root = {
	      width: '100%',
	      marginLeft: 'auto',
	      boxSizing: 'border-box',
	      marginRight: 'auto',
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }), (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
	      paddingLeft: theme.spacing(4),
	      paddingRight: theme.spacing(4)
	    }), _root),
	
	    /* Styles applied to the root element if `fixed={true}`. */
	    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
	      var value = theme.breakpoints.values[breakpoint];
	
	      if (value !== 0) {
	        acc[theme.breakpoints.up(breakpoint)] = {
	          maxWidth: value
	        };
	      }
	
	      return acc;
	    }, {}),
	
	    /* Styles applied to the root element if `maxWidth="xs"`. */
	    maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
	    }),
	
	    /* Styles applied to the root element if `maxWidth="sm"`. */
	    maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
	      maxWidth: theme.breakpoints.values.sm
	    }),
	
	    /* Styles applied to the root element if `maxWidth="md"`. */
	    maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
	      maxWidth: theme.breakpoints.values.md
	    }),
	
	    /* Styles applied to the root element if `maxWidth="lg"`. */
	    maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
	      maxWidth: theme.breakpoints.values.lg
	    }),
	
	    /* Styles applied to the root element if `maxWidth="xl"`. */
	    maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
	      maxWidth: theme.breakpoints.values.xl
	    })
	  };
	};
	
	exports.styles = styles;
	
	var Container = _react.default.forwardRef(function Container(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$fixed = props.fixed,
	      fixed = _props$fixed === void 0 ? false : _props$fixed,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "fixed", "maxWidth"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, fixed && classes.fixed, maxWidth !== false && classes["maxWidth".concat((0, _helpers.capitalize)(String(maxWidth)))]),
	    ref: ref
	  }, other));
	});
	
	 false ? Container.propTypes = {
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Set the max-width to match the min-width of the current breakpoint.
	   * This is useful if you'd prefer to design for a fixed set of sizes
	   * instead of trying to accommodate a fully fluid viewport.
	   * It's fluid by default.
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the container.
	   * The container width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiContainer'
	})(Container);
	
	exports.default = _default;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(471));

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(225));
	
	var _utils = __webpack_require__(10);
	
	var useStyles = (0, _makeStyles.default)(function (theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      'strong, b': {
	        fontWeight: 'bolder'
	      },
	      body: (0, _extends2.default)({
	        margin: 0,
	        // Remove the margin in all browsers.
	        color: theme.palette.text.primary
	      }, theme.typography.body2, {
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        },
	        // Add support for document.body.requestFullScreen().
	        // Other elements, if background transparent, are not supported.
	        '&::backdrop': {
	          backgroundColor: theme.palette.background.default
	        }
	      })
	    }
	  };
	}, {
	  name: 'MuiCssBaseline'
	});
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	function CssBaseline(props) {
	  var _props$children = props.children,
	      children = _props$children === void 0 ? null : _props$children;
	  useStyles();
	  return _react.default.createElement(_react.default.Fragment, null, children);
	}
	
	 false ? CssBaseline.propTypes = {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  CssBaseline['propTypes' + ''] = (0, _utils.exactProp)(CssBaseline.propTypes);
	}
	
	var _default = CssBaseline;
	exports.default = _default;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _Modal = _interopRequireDefault(__webpack_require__(66));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(115));
	
	var _Fade = _interopRequireDefault(__webpack_require__(121));
	
	var _transitions = __webpack_require__(36);
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	/* eslint-disable jsx-a11y/click-events-have-key-events */
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '@media print': {
	        // Use !important to override the Modal inline-style.
	        position: 'absolute !important'
	      }
	    },
	
	    /* Styles applied to the container element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the container element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden',
	      textAlign: 'center',
	      '&:after': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%',
	        width: '0'
	      }
	    },
	
	    /* Styles applied to the container element. */
	    container: {
	      height: '100%',
	      '@media print': {
	        height: 'auto'
	      },
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      margin: 48,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      '@media print': {
	        overflowY: 'visible',
	        boxShadow: 'none'
	      }
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      display: 'flex',
	      flexDirection: 'column',
	      maxHeight: 'calc(100% - 96px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      textAlign: 'left' // 'initial' doesn't work on IE 11
	
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth=false`. */
	    paperWidthFalse: {
	      maxWidth: 'calc(100% - 96px)'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 48 * 2), {
	        maxWidth: 'calc(100% - 96px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
	        maxWidth: 'calc(100% - 96px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
	        maxWidth: 'calc(100% - 96px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
	        maxWidth: 'calc(100% - 96px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
	    paperWidthXl: {
	      maxWidth: theme.breakpoints.values.xl,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 48 * 2), {
	        maxWidth: 'calc(100% - 96px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: 'calc(100% - 96px)'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0,
	        maxWidth: '100%'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	var Dialog = _react.default.forwardRef(function Dialog(props, ref) {
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$fullScreen = props.fullScreen,
	      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$scroll = props.scroll,
	      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  var mouseDownTarget = _react.default.useRef();
	
	  var handleMouseDown = function handleMouseDown(event) {
	    mouseDownTarget.current = event.target;
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    // Ignore the events not coming from the "backdrop"
	    // We don't want to close the dialog when clicking the dialog content.
	    if (event.target !== event.currentTarget) {
	      return;
	    } // Make sure the event starts and ends on the same DOM element.
	
	
	    if (event.target !== mouseDownTarget.current) {
	      return;
	    }
	
	    mouseDownTarget.current = null;
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    BackdropComponent: _Backdrop.default,
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    closeAfterTransition: true,
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    ref: ref
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    role: "none presentation"
	  }, TransitionProps), _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.container, classes["scroll".concat((0, _helpers.capitalize)(scroll))]),
	    onClick: handleBackdropClick,
	    onMouseDown: handleMouseDown
	  }, _react.default.createElement(PaperComponent, (0, _extends2.default)({
	    elevation: 24,
	    role: "dialog"
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], classes["paperWidth".concat((0, _helpers.capitalize)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
	  }), children))));
	});
	
	 false ? Dialog.propTypes = {
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the dialog.
	   * The dialog width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The component used to render the body of the dialog.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * The component used for the transition.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	__webpack_require__(29);
	
	// So we don't have any override priority issue.
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end',
	    flex: '0 0 auto'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > * + *': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	
	var DialogActions = _react.default.forwardRef(function DialogActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	
	 false ? DialogActions.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      overflowY: 'auto',
	      padding: '8px 24px',
	      '&:first-child': {
	        // dialog without title
	        paddingTop: 20
	      }
	    },
	
	    /* Styles applied to the root element if `dividers={true}`. */
	    dividers: {
	      padding: '16px 24px',
	      borderTop: "1px solid ".concat(theme.palette.divider),
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    }
	  };
	};
	
	exports.styles = styles;
	
	var DialogContent = _react.default.forwardRef(function DialogContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$dividers = props.dividers,
	      dividers = _props$dividers === void 0 ? false : _props$dividers,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "dividers"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dividers && classes.dividers),
	    ref: ref
	  }, other));
	});
	
	 false ? DialogContent.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display the top and bottom dividers.
	   */
	  dividers: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    marginBottom: 12
	  }
	};
	exports.styles = styles;
	
	var DialogContentText = _react.default.forwardRef(function DialogContentText(props, ref) {
	  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "body1",
	    color: "textSecondary",
	    ref: ref
	  }, props));
	});
	
	 false ? DialogContentText.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(477));

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '16px 24px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	
	var DialogTitle = _react.default.forwardRef(function DialogTitle(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
	    component: "h2",
	    variant: "h6"
	  }, children));
	});
	
	 false ? DialogTitle.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(479));

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Divider = _react.default.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "light", "orientation", "role", "variant"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, light && classes.light, {
	      vertical: classes.vertical
	    }[orientation]),
	    role: role,
	    ref: ref
	  }, other));
	});
	
	 false ? Divider.propTypes = {
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(432));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(118));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanel = _react.default.forwardRef(function ExpansionPanel(props, ref) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _React$useRef = _react.default.useRef(expandedProp != null),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = _react.default.useState(defaultExpanded),
	      expandedState = _React$useState[0],
	      setExpandedState = _React$useState[1];
	
	  var expanded = isControlled ? expandedProp : expandedState;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (isControlled !== (expandedProp != null)) {
	        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled ExpansionPanel to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled ExpansionPanel ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [expandedProp, isControlled]);
	  }
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      setExpandedState(!expanded);
	    }
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  };
	
	  var _React$Children$toArr = _react.default.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), _react.default.cloneElement(summary, {
	    disabled: disabled,
	    expanded: expanded,
	    onChange: handleChange
	  }), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), _react.default.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	
	 false ? ExpansionPanel.propTypes = {
	  /**
	   * The content of the expansion panel.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = _react.default.Children.toArray(props.children)[0];
	
	    if (summary.type === _react.default.Fragment) {
	      return new Error("Material-UI: the ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (!_react.default.isValidElement(summary)) {
	      return new Error('Material-UI: expected the first child of ExpansionPanel to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the panel.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(482));

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	__webpack_require__(29);
	
	// So we don't have any override priority issue.
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > * + *': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	
	var ExpansionPanelActions = _react.default.forwardRef(function ExpansionPanelActions(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	
	 false ? ExpansionPanelActions.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(484));

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: '8px 24px 24px'
	  }
	};
	exports.styles = styles;
	
	var ExpansionPanelDetails = _react.default.forwardRef(function ExpansionPanelDetails(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	
	 false ? ExpansionPanelDetails.propTypes = {
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(486));

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(38));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: '0 24px 0 24px',
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.grey[300]
	      },
	      '&$disabled': {
	        opacity: 0.38
	      }
	    },
	
	    /* Styles applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root and children wrapper elements when focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanelSummary = _react.default.forwardRef(function ExpansionPanelSummary(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expanded = props.expanded,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onBlur", "onChange", "onClick", "onFocusVisible"]);
	
	  var _React$useState = _react.default.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	    disabled: disabled,
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: -1,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	
	 false ? ExpansionPanelSummary.propTypes = {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * If `true`, the summary will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * If `true`, expands the summary, otherwise collapse it.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(488));

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minHeight: 36,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      },
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        },
	        textDecoration: 'none'
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    primary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    secondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extended"`. */
	    extended: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minHeight: 'auto',
	      minWidth: 48,
	      height: 48,
	      '&$sizeSmall': {
	        width: 'auto',
	        padding: '0 8px',
	        borderRadius: 34 / 2,
	        minWidth: 34,
	        height: 34
	      },
	      '&$sizeMedium': {
	        width: 'auto',
	        padding: '0 16px',
	        borderRadius: 40 / 2,
	        minWidth: 40,
	        height: 40
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="small"``. */
	    sizeSmall: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="medium"``. */
	    sizeMedium: {
	      width: 48,
	      height: 48
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Fab = _react.default.forwardRef(function Fab(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'large' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'round' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat((0, _helpers.capitalize)(size))], disabled && classes.disabled, {
	      primary: classes.primary,
	      secondary: classes.secondary,
	      inherit: classes.colorInherit
	    }[color]),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	});
	
	 false ? Fab.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['round', 'extended'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFab'
	})(Fab);
	
	exports.default = _default;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	
	var _Fab = _interopRequireDefault(__webpack_require__(490));

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _transitions = __webpack_require__(36);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(54);
	
	var _reactHelpers = __webpack_require__(13);
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = _react.default.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	
	 false ? Fade.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(63));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px'
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `select={true}`. */
	    inputSelect: {
	      paddingRight: 24
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	
	var FilledInput = _react.default.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	
	 false ? FilledInput.propTypes = {
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(124);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(84));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	
	var FormControl = _react.default.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "fullWidth", "hiddenLabel", "margin", "required", "variant"]);
	
	  var _React$useState = _react.default.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      _react.default.Children.forEach(children, function (child) {
	        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0];
	
	  var _React$useState2 = _react.default.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      _react.default.Children.forEach(children, function (child) {
	        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState(false),
	      focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = _react.default.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: there are multiple InputBase components inside a FromControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = _react.default.useCallback(function () {
	    setFilled(true);
	  }, []);
	
	  var onEmpty = _react.default.useCallback(function () {
	    setFilled(false);
	  }, []);
	
	  var childContext = {
	    adornedStart: adornedStart,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    hiddenLabel: hiddenLabel,
	    margin: margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return _react.default.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _helpers.capitalize)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	
	 false ? FormControl.propTypes = {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _FormControl = __webpack_require__(85);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -11,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse',
	      marginLeft: 16,
	      // used for row presentation of radio/checkbox
	      marginRight: -11
	    },
	
	    /* Styles applied to the root element if `labelPlacement="top"`. */
	    labelPlacementTop: {
	      flexDirection: 'column-reverse',
	      marginLeft: 16
	    },
	
	    /* Styles applied to the root element if `labelPlacement="bottom"`. */
	    labelPlacementBottom: {
	      flexDirection: 'column',
	      marginLeft: 16
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	
	var FormControlLabel = _react.default.forwardRef(function FormControlLabel(props, ref) {
	  var checked = props.checked,
	      classes = props.classes,
	      classNameProp = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$labelPlacement = props.labelPlacement,
	      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = (0, _FormControl.useFormControl)();
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return _react.default.createElement("label", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp, labelPlacement !== 'end' && classes["labelPlacement".concat((0, _helpers.capitalize)(labelPlacement))], disabled && classes.disabled),
	    ref: ref
	  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _clsx.default)(classes.label, disabled && classes.disabled)
	  }, label));
	});
	
	 false ? FormControlLabel.propTypes = {
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['end', 'start', 'top', 'bottom']),
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	
	var FormGroup = _react.default.forwardRef(function FormGroup(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$row = props.row,
	      row = _props$row === void 0 ? false : _props$row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "row"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, row && classes.row),
	    ref: ref
	  }, other));
	});
	
	 false ? FormGroup.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 8,
	      lineHeight: '1em',
	      minHeight: '1em',
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      margin: '8px 14px 0'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	
	var FormHelperText = _react.default.forwardRef(function FormHelperText(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, classNameProp, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, {
	      dense: classes.marginDense
	    }[fcs.margin]),
	    ref: ref
	  }, other));
	});
	
	 false ? FormHelperText.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var FormLabel = _react.default.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	
	 false ? FormLabel.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(640));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - https://getbootstrap.com/docs/4.3/layout/grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  var styles = {};
	  GRID_SIZES.forEach(function (size) {
	    var key = "grid-".concat(breakpoint, "-").concat(size);
	
	    if (size === true) {
	      // For the auto layouting
	      styles[key] = {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	      return;
	    }
	
	    if (size === 'auto') {
	      styles[key] = {
	        flexBasis: 'auto',
	        flexGrow: 0,
	        maxWidth: 'none'
	      };
	      return;
	    } // Keep 7 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    styles[key] = {
	      flexBasis: width,
	      flexGrow: 0,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function getOffset(val) {
	  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var parse = parseFloat(val);
	  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  SPACINGS.forEach(function (spacing) {
	    var themeSpacing = theme.spacing(spacing);
	
	    if (themeSpacing === 0) {
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: "-".concat(getOffset(themeSpacing, 2)),
	      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
	      '& > $item': {
	        padding: getOffset(themeSpacing, 2)
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _extends2.default)({
	    /* Styles applied to the root element */
	    root: {},
	
	    /* Styles applied to the root element if `container={true}`. */
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `item={true}`. */
	    item: {
	      boxSizing: 'border-box',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	
	    /* Styles applied to the root element if `zeroMinWidth={true}`. */
	    zeroMinWidth: {
	      minWidth: 0
	    },
	
	    /* Styles applied to the root element if `direction="column"`. */
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the root element if `direction="column-reverse"`. */
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	
	    /* Styles applied to the root element if `direction="rwo-reverse"`. */
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `wrap="nowrap"`. */
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `wrap="reverse"`. */
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	
	    /* Styles applied to the root element if `alignItems="center"`. */
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-start"`. */
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-end"`. */
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignItems="baseline"`. */
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	
	    /* Styles applied to the root element if `alignContent="center"`. */
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-start"`. */
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-end"`. */
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-between"`. */
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-around"`. */
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="center"`. */
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the root element if `justify="flex-end"`. */
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `justify="space-between"`. */
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `justify="space-around"`. */
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="space-evenly"`. */
	    'justify-xs-space-evenly': {
	      justifyContent: 'space-evenly'
	    }
	  }, generateGutter(theme, 'xs'), {}, theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	
	var Grid = _react.default.forwardRef(function (props, ref) {
	  var _props$alignContent = props.alignContent,
	      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
	      _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$container = props.container,
	      container = _props$container === void 0 ? false : _props$container,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'row' : _props$direction,
	      _props$item = props.item,
	      item = _props$item === void 0 ? false : _props$item,
	      _props$justify = props.justify,
	      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
	      _props$lg = props.lg,
	      lg = _props$lg === void 0 ? false : _props$lg,
	      _props$md = props.md,
	      md = _props$md === void 0 ? false : _props$md,
	      _props$sm = props.sm,
	      sm = _props$sm === void 0 ? false : _props$sm,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
	      _props$wrap = props.wrap,
	      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
	      _props$xl = props.xl,
	      xl = _props$xl === void 0 ? false : _props$xl,
	      _props$xs = props.xs,
	      xs = _props$xs === void 0 ? false : _props$xs,
	      _props$zeroMinWidth = props.zeroMinWidth,
	      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	
	if (false) {
	  // can't use named function expression since the function body references `Grid`
	  // which would point to the render function instead of the actual component
	  Grid.displayName = 'ForwardRef(Grid)';
	}
	
	 false ? Grid.propTypes = {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(SPACINGS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : void 0;
	var StyledGrid = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(Grid);
	
	if (false) {
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('item')
	  });
	}
	
	var _default = StyledGrid;
	exports.default = _default;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	
	var GridList = _react.default.forwardRef(function GridList(props, ref) {
	  var _props$cellHeight = props.cellHeight,
	      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 2 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp),
	    ref: ref,
	    style: (0, _extends2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childCols = child.props.cols || 1;
	    var childRows = child.props.rows || 1;
	    return _react.default.cloneElement(child, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, child.props.style)
	    });
	  }));
	});
	
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(500));

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _reactHelpers = __webpack_require__(13);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	
	  /* Styles applied to the `div` element that wraps the children. */
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not rendered with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var fit = function fit(imgEl, classes) {
	  if (!imgEl || !imgEl.complete) {
	    return;
	  }
	
	  if (imgEl.width / imgEl.height > imgEl.parentNode.offsetWidth / imgEl.parentNode.offsetHeight) {
	    var _imgEl$classList, _imgEl$classList2;
	
	    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	
	    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	  } else {
	    var _imgEl$classList3, _imgEl$classList4;
	
	    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	
	    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	  }
	};
	
	function ensureImageCover(imgEl, classes) {
	  if (!imgEl) {
	    return;
	  }
	
	  if (imgEl.complete) {
	    fit(imgEl, classes);
	  } else {
	    imgEl.addEventListener('load', function () {
	      fit(imgEl, classes);
	    });
	  }
	}
	
	var GridListTile = _react.default.forwardRef(function GridListTile(props, ref) {
	  // cols rows default values are for docs only
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 1 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$rows = props.rows,
	      rows = _props$rows === void 0 ? 1 : _props$rows,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "cols", "component", "rows"]);
	
	  var imgRef = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    ensureImageCover(imgRef.current, classes);
	  });
	
	  _react.default.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      fit(imgRef.current, classes);
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [classes]);
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), _react.default.createElement("div", {
	    className: classes.tile
	  }, _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (child.type === 'img' || (0, _reactHelpers.isMuiElement)(child, ['Image'])) {
	      return _react.default.cloneElement(child, {
	        ref: imgRef
	      });
	    }
	
	    return child;
	  })));
	});
	
	 false ? GridListTile.propTypes = {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(502));

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.5)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Styles applied to the root element if `titlePosition="bottom"`. */
	    titlePositionBottom: {
	      bottom: 0
	    },
	
	    /* Styles applied to the root element if `titlePosition="top"`. */
	    titlePositionTop: {
	      top: 0
	    },
	
	    /* Styles applied to the root element if a `subtitle` is provided. */
	    rootSubtitle: {
	      height: 68
	    },
	
	    /* Styles applied to the title and subtitle container element. */
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: 16,
	      marginRight: 16,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the container element if `actionPosition="left"`. */
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	
	    /* Styles applied to the container element if `actionPosition="right"`. */
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	
	    /* Styles applied to the title container element. */
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the subtitle container element. */
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the actionIcon if supplied. */
	    actionIcon: {},
	
	    /* Styles applied to the actionIcon if `actionPosition="left"`. */
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	
	var GridListTileBar = _react.default.forwardRef(function GridListTileBar(props, ref) {
	  var actionIcon = props.actionIcon,
	      _props$actionPosition = props.actionPosition,
	      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
	      classes = props.classes,
	      classNameProp = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      _props$titlePosition = props.titlePosition,
	      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  var className = (0, _clsx.default)(classes.root, classNameProp, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle); // Remove the margin between the title / subtitle wrapper, and the Action Icon
	
	  var titleWrapClassName = (0, _clsx.default)(classes.titleWrap, {
	    left: classes.titleWrapActionPosLeft,
	    right: classes.titleWrapActionPosRight
	  }[actionPos]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other), _react.default.createElement("div", {
	    className: titleWrapClassName
	  }, _react.default.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? _react.default.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.actionIcon, {
	      left: classes.actionIconActionPosLeft
	    }[actionPos])
	  }, actionIcon) : null);
	});
	
	 false ? GridListTileBar.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(504));

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(54);
	
	var _reactHelpers = __webpack_require__(13);
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = _react.default.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	
	  var timer = _react.default.useRef();
	
	  var autoTimeout = _react.default.useRef();
	
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, ref);
	  var theme = (0, _useTheme.default)();
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  _react.default.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	
	 false ? Grow.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(509));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(508));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var _props$implementation = props.implementation,
	      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
	      _props$lgDown = props.lgDown,
	      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
	      _props$lgUp = props.lgUp,
	      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
	      _props$mdDown = props.mdDown,
	      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
	      _props$mdUp = props.mdUp,
	      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
	      _props$smDown = props.smDown,
	      smDown = _props$smDown === void 0 ? false : _props$smDown,
	      _props$smUp = props.smUp,
	      smUp = _props$smUp === void 0 ? false : _props$smUp,
	      _props$xlDown = props.xlDown,
	      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
	      _props$xlUp = props.xlUp,
	      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
	      _props$xsDown = props.xsDown,
	      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
	      _props$xsUp = props.xsUp,
	      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	
	  if (implementation === 'js') {
	    return _react.default.createElement(_HiddenJs.default, (0, _extends2.default)({
	      lgDown: lgDown,
	      lgUp: lgUp,
	      mdDown: mdDown,
	      mdUp: mdUp,
	      smDown: smDown,
	      smUp: smUp,
	      xlDown: xlDown,
	      xlUp: xlUp,
	      xsDown: xsDown,
	      xsUp: xsUp
	    }, other));
	  }
	
	  return _react.default.createElement(_HiddenCss.default, (0, _extends2.default)({
	    lgDown: lgDown,
	    lgUp: lgUp,
	    mdDown: mdDown,
	    mdUp: mdUp,
	    smDown: smDown,
	    smUp: smUp,
	    xlDown: xlDown,
	    xlUp: xlUp,
	    xsDown: xsDown,
	    xsUp: xsUp
	  }, other));
	}
	
	 false ? Hidden.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	var _default = Hidden;
	exports.default = _default;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return theme.breakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      lgDown = props.lgDown,
	      lgUp = props.lgUp,
	      mdDown = props.mdDown,
	      mdUp = props.mdUp,
	      only = props.only,
	      smDown = props.smDown,
	      smUp = props.smUp,
	      xlDown = props.xlDown,
	      xlUp = props.xlUp,
	      xsDown = props.xsDown,
	      xsUp = props.xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	  var theme = (0, _useTheme.default)();
	
	  if (false) {
	    if (Object.keys(other).length !== 0 && !(Object.keys(other).length === 1 && other.hasOwnProperty('ref'))) {
	      console.error("Material-UI: unsupported props received ".concat(Object.keys(other).join(', '), " by `<Hidden />`."));
	    }
	  }
	
	  var clsx = [];
	
	  if (className) {
	    clsx.push(className);
	  }
	
	  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
	    var breakpoint = theme.breakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      clsx.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      clsx.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      clsx.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
	    });
	  }
	
	  return _react.default.createElement("div", {
	    className: clsx.join(' ')
	  }, children);
	}
	
	 false ? HiddenCss.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateHiddenCss'
	})(HiddenCss);
	
	exports.default = _default;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(139));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var theme = (0, _useTheme.default)();
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
	      var _breakpoint = theme.breakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	
	if (false) {
	  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
	}
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(507));

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: theme.typography.pxToRem(24),
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(36)
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Icon = _react.default.forwardRef(function Icon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "fontSize"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, _helpers.capitalize)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _helpers.capitalize)(fontSize))]),
	    "aria-hidden": true,
	    ref: ref
	  }, other));
	});
	
	 false ? Icon.propTypes = {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : void 0;
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(511));

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	var IconButton = _react.default.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _helpers.capitalize)(color))], disabled && classes.disabled, {
	      small: classes["size".concat((0, _helpers.capitalize)(size))]
	    }[size], {
	      start: classes.edgeStart,
	      end: classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	});
	
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = _react.default.Children.toArray(props.children).some(function (child) {
	      return _react.default.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(63));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	
	var Input = _react.default.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	
	 false ? Input.propTypes = {
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(84));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    height: '0.01em',
	    // Fix IE 11 flexbox alignment. To remove at some point.
	    maxHeight: '2em',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `variant="filled"`. */
	  filled: {
	    '&$positionStart:not($hiddenLabel)': {
	      marginTop: 16
	    }
	  },
	
	  /* Styles applied to the root element if `position="start"`. */
	  positionStart: {
	    marginRight: 8
	  },
	
	  /* Styles applied to the root element if `position="end"`. */
	  positionEnd: {
	    marginLeft: 8
	  },
	
	  /* Styles applied to the root element if `disablePointerEvents=true`. */
	  disablePointerEvents: {
	    pointerEvents: 'none'
	  },
	
	  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
	  hiddenLabel: {},
	
	  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
	  marginDense: {}
	};
	exports.styles = styles;
	
	var InputAdornment = _react.default.forwardRef(function InputAdornment(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disablePointer = props.disablePointerEvents,
	      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      position = props.position,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
	  var muiFormControl = (0, _FormControlContext.useFormControl)() || {};
	  var variant = variantProp;
	
	  if (variantProp && muiFormControl.variant) {
	    if (false) {
	      if (variantProp === muiFormControl.variant) {
	        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
	      }
	    }
	  }
	
	  if (muiFormControl && !variant) {
	    variant = muiFormControl.variant;
	  }
	
	  return _react.default.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, {
	      filled: classes.filled
	    }[variant], {
	      start: classes.positionStart,
	      end: classes.positionEnd
	    }[position], {
	      dense: classes.marginDense
	    }[muiFormControl.margin]),
	    ref: ref
	  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
	    color: "textSecondary"
	  }, children) : children));
	});
	
	 false ? InputAdornment.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Disable pointer events on the root.
	   * This allows for the content of the adornment to focus the input on click.
	   */
	  disablePointerEvents: _propTypes.default.bool,
	
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  muiFormControl: _propTypes.default.object,
	
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes.default.oneOf(['start', 'end']),
	
	  /**
	   * The variant to use.
	   * Note: If you are using the `TextField` component or the `FormControl` component
	   * you do not have to set this manually.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputAdornment'
	})(InputAdornment);
	
	exports.default = _default;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(84));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(216));
	
	var _utils2 = __webpack_require__(124);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      // Mimics the default input display property used by browsers for an input.
	      fontFamily: theme.typography.fontFamily,
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '1.1875em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1875em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: '$auto-fill'
	      }
	    },
	    '@keyframes auto-fill': {
	      from: {}
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `select={true}`. */
	    inputSelect: {
	      paddingRight: 24
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = _react.default.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      classNameProp = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps;
	  _props$inputProps = _props$inputProps === void 0 ? {} : _props$inputProps;
	  var inputPropsClassName = _props$inputProps.className,
	      inputPropsProp = (0, _objectWithoutProperties2.default)(_props$inputProps, ["className"]),
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "select", "startAdornment", "type", "value"]);
	
	  var _React$useRef = _react.default.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = _react.default.useRef();
	
	  var handleInputRefWarning = _react.default.useCallback(function (instance) {
	    if (false) {
	      if (instance && !(instance instanceof HTMLInputElement) && !instance.focus) {
	        console.error(['Material-UI: you have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	
	  var handleInputPropsRefProp = (0, _reactHelpers.useForkRef)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _reactHelpers.useForkRef)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _reactHelpers.useForkRef)(inputRef, handleInputRefProp);
	
	  var _React$useState = _react.default.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  _react.default.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	
	  var checkDirty = _react.default.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new TypeError('Material-UI: Expected valid input target. ' + 'Did you use a custom `inputComponent` and forget to forward refs? ' + 'See https://material-ui.com/r/input-component-ref-interface for more info.');
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  _react.default.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !rowsMax) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        rows: rows,
	        rowsMax: rowsMax
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill() {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty({
	      value: 'x'
	    });
	  };
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, {
	      dense: classes.marginDense
	    }[fcs.margin]),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, _react.default.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, _react.default.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    className: (0, _clsx.default)(classes.input, inputPropsClassName, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, select && classes.inputSelect, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, {
	      search: classes.inputTypeSearch
	    }[type], {
	      dense: classes.inputMarginDense
	    }[fcs.margin]),
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value
	  }, inputProps))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	
	 false ? InputBase.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Should be `true` when the component hosts a select.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(192));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var InputLabel = _react.default.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, {
	      dense: classes.marginDense
	    }[fcs.margin], {
	      filled: classes.filled,
	      outlined: classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	
	 false ? InputLabel.propTypes = {
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  var getColor = function getColor(color) {
	    return theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(color, 0.62) : (0, _colorManipulator.darken)(color, 0.5);
	  };
	
	  var backgroundPrimary = getColor(theme.palette.primary.main);
	  var backgroundSecondary = getColor(theme.palette.secondary.main);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 4
	    },
	
	    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
	    colorPrimary: {
	      backgroundColor: backgroundPrimary
	    },
	
	    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
	    colorSecondary: {
	      backgroundColor: backgroundSecondary
	    },
	
	    /* Styles applied to the root element if `variant="determinate"`. */
	    determinate: {},
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `variant="buffer"`. */
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	
	    /* Styles applied to the root element if `variant="query"`. */
	    query: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"`. */
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: '$buffer 3s infinite linear'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the layered bar1 & bar2 elements. */
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	
	    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
	    bar1Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	
	    /* Styles applied to the bar1 element if `variant="determinate"`. */
	    bar1Determinate: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar1 element if `variant="buffer"`. */
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
	    bar2Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	
	    /* Styles applied to the bar2 element if `variant="buffer"`. */
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	var LinearProgress = _react.default.forwardRef(function LinearProgress(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      var transform = value - 100;
	
	      if (theme.direction === 'rtl') {
	        transform = -transform;
	      }
	
	      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      var _transform = (valueBuffer || 0) - 100;
	
	      if (theme.direction === 'rtl') {
	        _transform = -_transform;
	      }
	
	      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], classNameProp, {
	      determinate: classes.determinate,
	      indeterminate: classes.indeterminate,
	      buffer: classes.buffer,
	      query: classes.query
	    }[variant]),
	    role: "progressbar"
	  }, rootProps, {
	    ref: ref
	  }, other), variant === 'buffer' ? _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.dashed, classes["dashedColor".concat((0, _helpers.capitalize)(color))])
	  }) : null, _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, classes["barColor".concat((0, _helpers.capitalize)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
	      determinate: classes.bar1Determinate,
	      buffer: classes.bar1Buffer
	    }[variant]),
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat((0, _helpers.capitalize)(color))], classes.bar2Buffer] : classes["barColor".concat((0, _helpers.capitalize)(color))]),
	    style: inlineStyles.bar2
	  }));
	});
	
	 false ? LinearProgress.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate or query when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _focusVisible = __webpack_require__(92);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `underline="none"`. */
	  underlineNone: {
	    textDecoration: 'none'
	  },
	
	  /* Styles applied to the root element if `underline="hover"`. */
	  underlineHover: {
	    textDecoration: 'none',
	    '&:hover': {
	      textDecoration: 'underline'
	    }
	  },
	
	  /* Styles applied to the root element if `underline="always"`. */
	  underlineAlways: {
	    textDecoration: 'underline'
	  },
	  // Same reset as ButtonBase.root
	
	  /* Styles applied to the root element if `component="button"`. */
	  button: {
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$focusVisible': {
	      outline: 'auto'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if the link is keyboard focused. */
	  focusVisible: {}
	};
	exports.styles = styles;
	
	var Link = _react.default.forwardRef(function Link(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'a' : _props$component,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      TypographyClasses = props.TypographyClasses,
	      _props$underline = props.underline,
	      underline = _props$underline === void 0 ? 'hover' : _props$underline,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
	
	  var _useIsFocusVisible = (0, _focusVisible.useIsFocusVisible)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState = _react.default.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  var handlerRef = (0, _reactHelpers.useForkRef)(ref, focusVisibleRef);
	
	  var handleBlur = function handleBlur(event) {
	    if (focusVisible) {
	      onBlurVisible();
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["underline".concat((0, _helpers.capitalize)(underline))], className, focusVisible && classes.focusVisible, {
	      button: classes.button
	    }[component]),
	    classes: TypographyClasses,
	    color: color,
	    component: component,
	    onBlur: handleBlur,
	    onFocus: handleFocus,
	    ref: handlerRef,
	    variant: variant
	  }, other));
	});
	
	 false ? Link.propTypes = {
	  /**
	   * The content of the link.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the link.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * `classes` prop applied to the [`Typography`](/api/typography/) element.
	   */
	  TypographyClasses: _propTypes.default.object,
	
	  /**
	   * Controls when the link should have an underline.
	   */
	  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLink'
	})(Link);
	
	exports.default = _default;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	
	var _Link = _interopRequireDefault(__webpack_require__(519));

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(64));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	
	var List = _react.default.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	
	  var context = _react.default.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	
	  return _react.default.createElement(_ListContext.default.Provider, {
	    value: context
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _ListContext = _interopRequireDefault(__webpack_require__(64));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = _react.default.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      dense = props.dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	
	  var context = _react.default.useContext(_ListContext.default);
	
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	
	  var listItemRef = _react.default.useRef(null);
	
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	
	  var children = _react.default.Children.toArray(childrenProp);
	
	  var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return _react.default.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return _react.default.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = _react.default.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _reactHelpers.isMuiElement)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(64));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    minWidth: 56,
	    flexShrink: 0
	  },
	
	  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	  alignItemsFlexStart: {
	    marginTop: 8
	  }
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Avatar`.
	 */
	
	exports.styles = styles;
	
	var ListItemAvatar = _react.default.forwardRef(function ListItemAvatar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	
	  var context = _react.default.useContext(_ListContext.default);
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	
	 false ? ListItemAvatar.propTypes = {
	  /**
	   * The content of the component – normally `Avatar`.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemAvatar'
	})(ListItemAvatar);
	
	exports.default = _default;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(64));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	
	var ListItemIcon = _react.default.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	
	  var context = _react.default.useContext(_ListContext.default);
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	
	 false ? ListItemIcon.propTypes = {
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(524));

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'absolute',
	    right: 16,
	    top: '50%',
	    transform: 'translateY(-50%)'
	  }
	};
	/**
	 * Must be used as the last child of ListItem to function properly.
	 */
	
	exports.styles = styles;
	
	var ListItemSecondaryAction = _react.default.forwardRef(function ListItemSecondaryAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	
	 false ? ListItemSecondaryAction.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemSecondaryAction'
	})(ListItemSecondaryAction);
	
	exports.default = _default;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(526));

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(64));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	
	var ListItemText = _react.default.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = _react.default.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	
	 false ? ListItemText.propTypes = {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListSubheader = _react.default.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _helpers.capitalize)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(529));

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(197));

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(65));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.subtitle1, {
	      minHeight: 48,
	      paddingTop: 4,
	      paddingBottom: 4,
	      boxSizing: 'border-box',
	      width: 'auto',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    }),
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the root element if dense. */
	    dense: {
	      minHeight: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var MenuItem = _react.default.forwardRef(function MenuItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'menuitem' : _props$role,
	      selected = props.selected,
	      tabIndexProp = props.tabIndex,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "role", "selected", "tabIndex"]);
	  var tabIndex;
	
	  if (!props.disabled) {
	    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
	  }
	
	  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
	    button: true,
	    role: role,
	    tabIndex: tabIndex,
	    component: component,
	    selected: selected,
	    disableGutters: disableGutters,
	    classes: {
	      dense: classes.dense
	    },
	    className: (0, _clsx.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	
	 false ? MenuItem.propTypes = {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _List = _interopRequireDefault(__webpack_require__(52));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(229));
	
	var _reactHelpers = __webpack_require__(13);
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  if (text === undefined) {
	    return false;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return false;
	      }
	
	      wrappedOnce = true;
	    } // Move to the next element.
	
	
	    if (!nextFocus.hasAttribute('tabindex') || nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true' || !textCriteriaMatches(nextFocus, textCriteria)) {
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return true;
	    }
	  }
	
	  return false;
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	
	var MenuList = _react.default.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      className = props.className,
	      onKeyDown = props.onKeyDown,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "className", "onKeyDown", "disableListWrap"]);
	
	  var listRef = _react.default.useRef(null);
	
	  var textCriteriaRef = _react.default.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	
	  _react.default.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(handleOwnRef, ref);
	  return _react.default.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other));
	});
	
	 false ? MenuList.propTypes = {
	  /**
	   * @ignore
	   */
	  actions: _propTypes.default.shape({
	    current: _propTypes.default.object
	  }),
	
	  /**
	   * If `true`, the list will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _helpers = __webpack_require__(11);
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(195));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: 8
	    },
	
	    /* Styles applied to the root element if `position="bottom"`. */
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="top"`. */
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {},
	
	    /* Styles applied to the dots container if `variant="dots"`. */
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	
	    /* Styles applied to each dot if `variant="dots"`. */
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: 8,
	      height: 8,
	      margin: '0 2px'
	    },
	
	    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the Linear Progress component if `variant="progress"`. */
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var MobileStepper = _react.default.forwardRef(function MobileStepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      className = props.className,
	      LinearProgressProps = props.LinearProgressProps,
	      nextButton = props.nextButton,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'bottom' : _props$position,
	      steps = props.steps,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'dots' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], className),
	    ref: ref
	  }, other), backButton, variant === 'text' && _react.default.createElement(_react.default.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && _react.default.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, index) {
	    return _react.default.createElement("div", {
	      key: index,
	      className: (0, _clsx.default)(classes.dot, index === activeStep && classes.dotActive)
	    });
	  })), variant === 'progress' && _react.default.createElement(_LinearProgress.default, (0, _extends2.default)({
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }, LinearProgressProps)), nextButton);
	});
	
	 false ? MobileStepper.propTypes = {
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `LinearProgress` element.
	   */
	  LinearProgressProps: _propTypes.default.object,
	
	  /**
	   * A next button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'top', 'static']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'dots', 'progress'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(534));

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(34);
	
	var _utils = __webpack_require__(10);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _Portal = _interopRequireDefault(__webpack_require__(129));
	
	var _helpers = __webpack_require__(11);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(227));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(200));
	
	var _TrapFocus = _interopRequireDefault(__webpack_require__(538));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(537));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	
	var Modal = _react.default.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = _react.default.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = _react.default.useRef({});
	
	  var mountNodeRef = _react.default.useRef(null);
	
	  var modalRef = _react.default.useRef(null);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	
	  var isTopModal = _react.default.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	
	  var handleClose = _react.default.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	
	  _react.default.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	
	  _react.default.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // We don't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    } // Swallow the event, in case someone is listening for the escape key on the body.
	
	
	    event.stopPropagation();
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown && onClose) {
	      onClose(event, 'escapeKeyDown');
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {}; // FixMe: Always apply document role. Revisit once React Flare is released
	
	  if (children.role === undefined) {
	    childProps.role = children.role || 'document';
	  }
	
	  if (children.tabIndex === undefined) {
	    childProps.tabIndex = children.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _helpers.createChainedFunction)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _helpers.createChainedFunction)(handleExited, children.props.onExited);
	  }
	
	  return _react.default.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, _react.default.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, {}, !open && exited ? inlineStyle.hidden : {}, {}, other.style)
	  }), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), _react.default.createElement(_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, _react.default.cloneElement(children, childProps))));
	});
	
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    // Disable scroll capabilities.
	    touchAction: 'none'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var SimpleBackdrop = _react.default.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? _react.default.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, {}, invisible ? styles.invisible : {}, {}, other.style)
	  })) : null;
	});
	
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _reactHelpers = __webpack_require__(13);
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
	
	/**
	 * @ignore - internal component.
	 */
	function TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	
	  var ignoreNextEnforceFocus = _react.default.useRef();
	
	  var sentinelStart = _react.default.useRef(null);
	
	  var sentinelEnd = _react.default.useRef(null);
	
	  var nodeToRestore = _react.default.useRef();
	
	  var rootRef = _react.default.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, handleOwnRef); // ⚠️ You may rely on React.useMemo as a performance optimization, not as a semantic guarantee.
	  // https://reactjs.org/docs/hooks-reference.html#usememo
	
	  _react.default.useMemo(function () {
	    if (!open || typeof window === 'undefined') {
	      return;
	    }
	
	    nodeToRestore.current = getDoc().activeElement;
	  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
	
	
	  _react.default.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), _react.default.cloneElement(children, {
	    ref: handleRef
	  }), _react.default.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? TrapFocus.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	/*
	
	In the future, we should be able to replace TrapFocus with:
	https://github.com/facebook/react/blob/master/packages/react-events/docs/FocusScope.md
	
	```jsx
	import FocusScope from 'react-dom/FocusScope';
	
	function TrapFocus(props) {
	  const {
	    children
	    disableAutoFocus = false,
	    disableEnforceFocus = false,
	    disableRestoreFocus = false,
	    open,
	  } = props;
	
	  if (!open) {
	    return children;
	  }
	
	  return (
	    <FocusScope
	      autoFocus={!disableAutoFocus}
	      contain={!disableEnforceFocus}
	      restoreFocus={!disableRestoreFocus}
	    >
	      {children}
	    </FocusScope>
	  );
	}
	```
	
	*/
	
	var _default = TrapFocus;
	exports.default = _default;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(201));

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = _react.default.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	
	  _react.default.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	
	  return _react.default.createElement(_react.default.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: 0,
	      pointerEvents: 'none',
	      borderRadius: theme.shape.borderRadius,
	      borderStyle: 'solid',
	      borderWidth: 1,
	      // Match the Input Label
	      transition: theme.transitions.create(["padding-".concat(align), 'border-color', 'border-width'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      transition: theme.transitions.create('width', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var NotchedOutline = _react.default.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0;
	  return _react.default.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _helpers.capitalize)(align)), 8 + (notched ? 0 : labelWidth / 2)), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), _react.default.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, _react.default.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(63));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(541));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px'
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `select={true}`. */
	    inputSelect: {
	      paddingRight: 24
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	
	var OutlinedInput = _react.default.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "labelWidth", "multiline", "notched", "type"]);
	  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return _react.default.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	
	 false ? OutlinedInput.propTypes = {
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	var Paper = _react.default.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
	
	  if (false) {
	    if (elevation < 0 || elevation >= 25) {
	      console.error("Material-UI: this elevation `".concat(elevation, "` is not implemented."));
	    }
	  }
	
	  var className = (0, _clsx.default)(classes.root, classes["elevation".concat(elevation)], classNameProp, !square && classes.rounded);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	
	 false ? Paper.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(93));
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Modal = _interopRequireDefault(__webpack_require__(66));
	
	var _Grow = _interopRequireDefault(__webpack_require__(86));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentNode;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	
	var Popover = _react.default.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      ModalClasses = props.ModalClasses,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  var paperRef = _react.default.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	
	  var getAnchorOffset = _react.default.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: you need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	    var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl instanceof containerWindow.Element ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	
	  var getContentAnchorOffset = _react.default.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	
	  var getTransformOrigin = _react.default.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	
	  var getPositioningStyle = _react.default.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(top, "px"),
	      left: "".concat(left, "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	
	  var setPositioningStyles = _react.default.useCallback(function (element) {
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles(element);
	  };
	
	  var handlePaperRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var updatePosition = _react.default.useMemo(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    return (0, _debounce.default)(function () {
	      setPositioningStyles(paperRef.current);
	    });
	  }, [open, setPositioningStyles]);
	
	  _react.default.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: updatePosition
	    } : null;
	  }, [open, updatePosition]);
	
	  _react.default.useEffect(function () {
	    if (!updatePosition) {
	      return undefined;
	    }
	
	    window.addEventListener('resize', updatePosition);
	    return function () {
	      window.removeEventListener('resize', updatePosition);
	      updatePosition.clear();
	    };
	  }, [updatePosition]);
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    classes: ModalClasses,
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    }
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _helpers.createChainedFunction)(handleEntering, TransitionProps.onEntering)
	  }), _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    // eslint-disable-next-line react/prop-types
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	
	 false ? Popover.propTypes = {
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * This is the DOM element, or a function that returns the DOM element,
	   * that may be used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	      var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl);
	
	      if (resolvedAnchorEl instanceof containerWindow.Element) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /*
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * `classes` prop applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalClasses: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _popper = _interopRequireDefault(__webpack_require__(851));
	
	var _utils = __webpack_require__(10);
	
	var _Portal = _interopRequireDefault(__webpack_require__(129));
	
	var _helpers = __webpack_require__(11);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(93));
	
	/**
	 * Flips placement if in <body dir="rtl" />
	 * @param {string} placement
	 */
	function flipPlacement(placement) {
	  var direction = typeof window !== 'undefined' && document.body.getAttribute('dir') || 'ltr';
	
	  if (direction !== 'rtl') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
	 */
	
	var Popper = _react.default.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"]);
	
	  var tooltipRef = _react.default.useRef(null);
	
	  var ownRef = (0, _reactHelpers.useForkRef)(tooltipRef, ref);
	
	  var popperRef = _react.default.useRef(null);
	
	  var handlePopperRef = (0, _reactHelpers.useForkRef)(popperRef, popperRefProp);
	
	  var handlePopperRefRef = _react.default.useRef(handlePopperRef);
	
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	
	  _react.default.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = _react.default.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var rtlPlacement = flipPlacement(initialPlacement);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = _react.default.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  if (rtlPlacement !== placement) {
	    setPlacement(rtlPlacement);
	  }
	
	  var handleOpen = _react.default.useCallback(function () {
	    var popperNode = tooltipRef.current;
	
	    if (!popperNode || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, {}, modifiers, {}, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onUpdate: (0, _helpers.createChainedFunction)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	
	  var handleRef = _react.default.useCallback(function (node) {
	    (0, _reactHelpers.setRef)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  _react.default.useEffect(function () {
	    // Let's update the popper position.
	    handleOpen();
	  }, [handleOpen]);
	
	  _react.default.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	
	  _react.default.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return _react.default.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, _react.default.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip",
	    style: {
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed'
	    }
	  }, other), typeof children === 'function' ? children(childProps) : children));
	});
	
	 false ? Popper.propTypes = {
	  /**
	   * This is the reference element, or a function that returns the reference element,
	   * that may be used to set the position of the popover.
	   * The return value will passed as the reference object of the Popper
	   * instance.
	   *
	   * The reference element should be an HTML Element instance or a referenceObject:
	   * https://popper.js.org/popper-documentation.html#referenceObject.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	      var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl);
	
	      if (resolvedAnchorEl instanceof containerWindow.Element) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'It should be an HTML Element instance or a referenceObject:', 'https://popper.js.org/popper-documentation.html#referenceObject.'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _reactHelpers = __webpack_require__(13);
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return _reactDom.default.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = _react.default.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = _react.default.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _reactHelpers.setRef)(ref, mountNode);
	      return function () {
	        (0, _reactHelpers.setRef)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    _react.default.Children.only(children);
	
	    return _react.default.cloneElement(children, {
	      ref: handleRef
	    });
	  }
	
	  return mountNode ? _reactDom.default.createPortal(children, mountNode) : mountNode;
	});
	
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.default.Component), _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(137));
	
	var _RadioButtonIcon = _interopRequireDefault(__webpack_require__(548));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _helpers = __webpack_require__(11);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(204));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultCheckedIcon = _react.default.createElement(_RadioButtonIcon.default, {
	  checked: true
	});
	
	var defaultIcon = _react.default.createElement(_RadioButtonIcon.default, null);
	
	var Radio = _react.default.forwardRef(function Radio(props, ref) {
	  var checkedProp = props.checked,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      nameProp = props.name,
	      onChangeProp = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "color", "name", "onChange"]);
	
	  var radioGroup = _react.default.useContext(_RadioGroupContext.default);
	
	  var checked = checkedProp;
	  var onChange = (0, _helpers.createChainedFunction)(onChangeProp, radioGroup && radioGroup.onChange);
	  var name = nameProp;
	
	  if (radioGroup) {
	    if (typeof checked === 'undefined') {
	      checked = radioGroup.value === props.value;
	    }
	
	    if (typeof name === 'undefined') {
	      name = radioGroup.name;
	    }
	  }
	
	  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    color: color,
	    type: "radio",
	    icon: defaultIcon,
	    checkedIcon: defaultCheckedIcon,
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    name: name,
	    checked: checked,
	    onChange: onChange,
	    ref: ref
	  }, other));
	});
	
	 false ? Radio.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(623));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(622));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      '&$checked $layer': {
	        transform: 'scale(1)',
	        transition: theme.transitions.create('transform', {
	          easing: theme.transitions.easing.easeOut,
	          duration: theme.transitions.duration.shortest
	        })
	      }
	    },
	    layer: {
	      left: 0,
	      position: 'absolute',
	      transform: 'scale(0)',
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeIn,
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {}
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);
	
	function RadioButtonIcon(props) {
	  var checked = props.checked,
	      classes = props.classes;
	  return _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.root, checked && classes.checked)
	  }, _ref, _react.default.createElement(_RadioButtonChecked.default, {
	    className: classes.layer
	  }));
	}
	
	 false ? RadioButtonIcon.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateRadioButtonIcon'
	})(RadioButtonIcon);
	
	exports.default = _default;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(547));

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(190));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(204));
	
	var RadioGroup = _react.default.forwardRef(function RadioGroup(props, ref) {
	  var actions = props.actions,
	      children = props.children,
	      name = props.name,
	      valueProp = props.value,
	      onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "children", "name", "value", "onChange"]);
	
	  var rootRef = _react.default.useRef(null);
	
	  var _React$useRef = _react.default.useRef(valueProp != null),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = _react.default.useState(function () {
	    if (!isControlled) {
	      return props.defaultValue;
	    }
	
	    return null;
	  }),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  _react.default.useImperativeHandle(actions, function () {
	    return {
	      focus: function focus() {
	        var input = rootRef.current.querySelector('input:not(:disabled):checked');
	
	        if (!input) {
	          input = rootRef.current.querySelector('input:not(:disabled)');
	        }
	
	        if (input) {
	          input.focus();
	        }
	      }
	    };
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (isControlled !== (valueProp != null)) {
	        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled RadioGroup to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled RadioGroup ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [valueProp, isControlled]);
	  }
	
	  var value = isControlled ? valueProp : valueState;
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      setValue(event.target.value);
	    }
	
	    if (onChange) {
	      onChange(event, event.target.value);
	    }
	  };
	
	  var context = {
	    name: name,
	    onChange: handleChange,
	    value: value
	  };
	  var handleRef = (0, _reactHelpers.useForkRef)(ref, rootRef);
	  return _react.default.createElement(_FormGroup.default, (0, _extends2.default)({
	    role: "radiogroup",
	    ref: handleRef
	  }, other), _react.default.createElement(_RadioGroupContext.default.Provider, {
	    value: context
	  }, children));
	});
	
	 false ? RadioGroup.propTypes = {
	  /**
	   * @ignore
	   */
	  actions: _propTypes.default.shape({
	    current: _propTypes.default.object
	  }),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * The name used to reference the value of the control.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(550));

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(81));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(82));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(181));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(177));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(178));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _reactHelpers = __webpack_require__(13);
	
	/**
	 * ⚠️⚠️⚠️
	 * If you want the DOM element of a Material-UI component check out
	 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
	 * first.
	 *
	 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
	 *
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * function MyComponent() {
	 *   const domRef = React.useRef();
	 *
	 *   React.useEffect(() => {
	 *     console.log(domRef.current); // DOM node
	 *   }, []);
	 *
	 *   return (
	 *     <RootRef rootRef={domRef}>
	 *       <SomeChildComponent />
	 *     </RootRef>
	 *   );
	 * }
	 * ```
	 */
	var RootRef =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = _reactDom.default.findDOMNode(this);
	      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = _reactDom.default.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _reactHelpers.setRef)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(_react.default.Component);
	
	 false ? RootRef.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * A ref that points to the first DOM node of the wrapped element.
	   */
	  rootRef: _utils.refType.isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
	}
	
	var _default = RootRef;
	exports.default = _default;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(552));

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(34);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(555));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(51));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(46));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(220));
	
	var _Input = _interopRequireDefault(__webpack_require__(87));
	
	var _NativeSelect = __webpack_require__(201);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(202));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(122));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(127));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = _react.default.createElement(_Input.default, null);
	
	var _ref2 = _react.default.createElement(_FilledInput.default, null);
	
	var Select = _react.default.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      input = props.input,
	      inputProps = props.inputProps,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant", "labelWidth"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: _react.default.createElement(_OutlinedInput.default, {
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return _react.default.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    select: true,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {} : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: SelectDisplayProps
	    }, {}, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	
	 false ? Select.propTypes = {
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * The label width to be used on OutlinedInput.
	   * This prop is required when the `variant` prop is `outlined`.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {*} value The `value` provided to the component.
	   * @returns {ReactElement}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value.
	   * This prop is required when the `native` prop is `false` (default).
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(61));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _Menu = _interopRequireDefault(__webpack_require__(197));
	
	var _utils2 = __webpack_require__(124);
	
	var _reactHelpers = __webpack_require__(13);
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = _react.default.forwardRef(function SelectInput(props, ref) {
	  var autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      required = props.required,
	      SelectDisplayProps = props.SelectDisplayProps,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var inputRef = _react.default.useRef(null);
	
	  var displayRef = _react.default.useRef(null);
	
	  var ignoreNextBlur = _react.default.useRef(false);
	
	  var _React$useRef = _react.default.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState = _react.default.useState(),
	      menuMinWidthState = _React$useState[0],
	      setMenuMinWidthState = _React$useState[1];
	
	  var _React$useState2 = _react.default.useState(false),
	      openState = _React$useState2[0],
	      setOpenState = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState(0),
	      forceUpdate = _React$useState3[1];
	
	  var handleRef = (0, _reactHelpers.useForkRef)(ref, inputRefProp);
	
	  _react.default.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayRef.current.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [value]);
	
	  _react.default.useEffect(function () {
	    if (isOpenControlled && openProp) {
	      // Focus the display node so the focus is restored on this element once
	      // the menu is closed.
	      displayRef.current.focus(); // Rerender with the resolve `displayRef` reference.
	
	      forceUpdate(function (n) {
	        return !n;
	      });
	    }
	
	    if (autoFocus) {
	      displayRef.current.focus();
	    }
	  }, [autoFocus, isOpenControlled, openProp]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayRef.current.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleClick = function handleClick(event) {
	    // Opening the menu is going to blur the. It will be focused back when closed.
	    ignoreNextBlur.current = true;
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      if (onChange) {
	        var newValue;
	
	        if (multiple) {
	          newValue = Array.isArray(value) ? (0, _toConsumableArray2.default)(value) : [];
	          var itemIndex = value.indexOf(child.props.value);
	
	          if (itemIndex === -1) {
	            newValue.push(child.props.value);
	          } else {
	            newValue.splice(itemIndex, 1);
	          }
	        } else {
	          newValue = child.props.value;
	        }
	
	        event.persist();
	        event.target = {
	          value: newValue,
	          name: name
	        };
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (ignoreNextBlur.current === true) {
	      // The parent components are relying on the bubbling of the event.
	      event.stopPropagation();
	      ignoreNextBlur.current = false;
	      return;
	    }
	
	    if (onBlur) {
	      event.persist();
	      event.target = {
	        value: value,
	        name: name
	      };
	      onBlur(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.
	
	        ignoreNextBlur.current = true;
	        update(true, event);
	      }
	    }
	  };
	
	  var open = isOpenControlled && displayRef.current ? openProp : openState;
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)(props) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error('Material-UI: the `value` prop must be an array ' + 'when using the `Select` component with `multiple`.');
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    return _react.default.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayRef.current) {
	    menuMinWidth = displayRef.current.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: displayRef,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-owns": open ? "menu-".concat(name || '') : undefined,
	    onKeyDown: handleKeyDown,
	    onBlur: handleBlur,
	    onClick: disabled || readOnly ? null : handleClick,
	    onFocus: onFocus // The id can help with end-to-end testing automation.
	    ,
	    id: name ? "select-".concat(name) : undefined
	  }, SelectDisplayProps), isEmpty(display) ? // eslint-disable-next-line react/no-danger
	  _react.default.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), _react.default.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    type: "hidden",
	    autoFocus: autoFocus
	  }, other)), _react.default.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _helpers.capitalize)(variant))])
	  }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayRef.current,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {*} value The `value` provided to the component.
	   * @returns {ReactElement}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _utils = __webpack_require__(10);
	
	var _reactHelpers = __webpack_require__(13);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _transitions = __webpack_require__(36);
	
	var _utils2 = __webpack_require__(54);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(-").concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(-").concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = _react.default.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntering", "onExit", "onExited", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	
	  var childrenRef = _react.default.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRefIntermediary = (0, _reactHelpers.useForkRef)(children.ref, handleOwnRef);
	  var handleRef = (0, _reactHelpers.useForkRef)(handleRefIntermediary, ref);
	
	  var handleEnter = function handleEnter(_, isAppearing) {
	    var node = childrenRef.current;
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(_, isAppearing) {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit() {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExited = function handleExited() {
	    var node = childrenRef.current; // No need for transitions when the component is hidden
	
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  };
	
	  var updatePosition = _react.default.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	
	  _react.default.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (!inProp && direction !== 'down' && direction !== 'right') {
	      var handleResize = (0, _debounce.default)(function () {
	        if (childrenRef.current) {
	          setTranslateValue(direction, childrenRef.current);
	        }
	      });
	      window.addEventListener('resize', handleResize);
	      return function () {
	        handleResize.clear();
	        window.removeEventListener('resize', handleResize);
	      };
	    }
	
	    return undefined;
	  }, [direction, inProp]);
	
	  _react.default.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, {}, children.props.style)
	    }, childProps));
	  });
	});
	
	 false ? Slide.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _focusVisible = __webpack_require__(92);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _helpers = __webpack_require__(11);
	
	var _ValueLabel = _interopRequireDefault(__webpack_require__(558));
	
	function asc(a, b) {
	  return a - b;
	}
	
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	
	  if (value > max) {
	    return max;
	  }
	
	  return value;
	}
	
	function findClosest(values, currentValue) {
	  var _values$reduce = values.reduce(function (acc, value, index) {
	    var distance = Math.abs(currentValue - value);
	
	    if (acc === null || distance < acc.distance || distance === acc.distance) {
	      return {
	        distance: distance,
	        index: index
	      };
	    }
	
	    return acc;
	  }, null),
	      closestIndex = _values$reduce.index;
	
	  return closestIndex;
	}
	
	function trackFinger(event, touchId) {
	  if (touchId.current !== undefined && event.changedTouches) {
	    for (var i = 0; i < event.changedTouches.length; i += 1) {
	      var touch = event.changedTouches[i];
	
	      if (touch.identifier === touchId.current) {
	        return {
	          x: touch.clientX,
	          y: touch.clientY
	        };
	      }
	    }
	
	    return false;
	  }
	
	  return {
	    x: event.clientX,
	    y: event.clientY
	  };
	}
	
	function valueToPercent(value, min, max) {
	  return (value - min) * 100 / (max - min);
	}
	
	function percentToValue(percent, min, max) {
	  return (max - min) * percent + min;
	}
	
	function getDecimalPrecision(num) {
	  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
	  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
	  if (Math.abs(num) < 1) {
	    var parts = num.toExponential().split('e-');
	    var matissaDecimalPart = parts[0].split('.')[1];
	    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
	  }
	
	  var decimalPart = num.toString().split('.')[1];
	  return decimalPart ? decimalPart.length : 0;
	}
	
	function roundValueToStep(value, step) {
	  var nearest = Math.round(value / step) * step;
	  return Number(nearest.toFixed(getDecimalPrecision(step)));
	}
	
	function setValueIndex(_ref) {
	  var values = _ref.values,
	      source = _ref.source,
	      newValue = _ref.newValue,
	      index = _ref.index;
	
	  // Performance shortcut
	  if (values[index] === newValue) {
	    return source;
	  }
	
	  var output = (0, _toConsumableArray2.default)(values);
	  output[index] = newValue;
	  return output;
	}
	
	function focusThumb(_ref2) {
	  var sliderRef = _ref2.sliderRef,
	      activeIndex = _ref2.activeIndex,
	      setActive = _ref2.setActive;
	
	  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
	    sliderRef.current.querySelector("[data-index=\"".concat(activeIndex, "\"]")).focus();
	  }
	
	  if (setActive) {
	    setActive(activeIndex);
	  }
	}
	
	var axisProps = {
	  horizontal: {
	    offset: function offset(percent) {
	      return {
	        left: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  'horizontal-reverse': {
	    offset: function offset(percent) {
	      return {
	        right: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  vertical: {
	    offset: function offset(percent) {
	      return {
	        bottom: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        height: "".concat(percent, "%")
	      };
	    }
	  }
	};
	var defaultMarks = [];
	
	var Identity = function Identity(x) {
	  return x;
	};
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 2,
	      width: '100%',
	      boxSizing: 'content-box',
	      padding: '11px 0',
	      display: 'inline-block',
	      position: 'relative',
	      cursor: 'pointer',
	      touchAction: 'none',
	      color: theme.palette.primary.main,
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      '&$disabled': {
	        cursor: 'default',
	        color: theme.palette.grey[400]
	      },
	      '&$vertical': {
	        width: 2,
	        height: '100%',
	        padding: '0 11px'
	      }
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {// TODO v5, move the style here
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `marks` is provided with at least one label. */
	    marked: {
	      marginBottom: 20,
	      '&$vertical': {
	        marginBottom: 'auto',
	        marginRight: 20
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the rail element. */
	    rail: {
	      display: 'block',
	      position: 'absolute',
	      width: '100%',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      opacity: 0.38,
	      '$vertical &': {
	        height: '100%',
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      display: 'block',
	      position: 'absolute',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      '$vertical &': {
	        width: 2
	      }
	    },
	
	    /* Styles applied to the thumb element. */
	    thumb: {
	      position: 'absolute',
	      width: 12,
	      height: 12,
	      marginLeft: -6,
	      marginTop: -5,
	      boxSizing: 'border-box',
	      borderRadius: '50%',
	      outline: 0,
	      backgroundColor: 'currentColor',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      transition: theme.transitions.create(['box-shadow'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16)),
	        '@media (hover: none)': {
	          boxShadow: 'none'
	        }
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16))
	      },
	      '$disabled &': {
	        pointerEvents: 'none',
	        width: 8,
	        height: 8,
	        marginLeft: -4,
	        marginTop: -3,
	        '&:hover': {
	          boxShadow: 'none'
	        }
	      },
	      '$vertical &': {
	        marginLeft: -5,
	        marginBottom: -6
	      },
	      '$vertical$disabled &': {
	        marginLeft: -3,
	        marginBottom: -4
	      }
	    },
	
	    /* Styles applied to the thumb element if `color="primary"`. */
	    thumbColorPrimary: {// TODO v5, move the style here
	    },
	
	    /* Styles applied to the thumb element if `color="secondary"`. */
	    thumbColorSecondary: {
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      }
	    },
	
	    /* Pseudo-class applied to the thumb element if it's active. */
	    active: {},
	
	    /* Pseudo-class applied to the thumb element if keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the thumb label element. */
	    valueLabel: {},
	
	    /* Styles applied to the mark element. */
	    mark: {
	      position: 'absolute',
	      width: 2,
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the mark element if active (depending on the value). */
	    markActive: {
	      backgroundColor: theme.palette.background.paper,
	      opacity: 0.8
	    },
	
	    /* Styles applied to the mark label element. */
	    markLabel: (0, _extends2.default)({}, theme.typography.body2, {
	      color: theme.palette.text.secondary,
	      position: 'absolute',
	      top: 22,
	      transform: 'translateX(-50%)',
	      whiteSpace: 'nowrap',
	      '$vertical &': {
	        top: 'auto',
	        left: 22,
	        transform: 'translateY(50%)'
	      }
	    }),
	
	    /* Styles applied to the mark label element if active (depending on the value). */
	    markLabelActive: {
	      color: theme.palette.text.primary
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Slider = _react.default.forwardRef(function Slider(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledby = props['aria-labelledby'],
	      ariaValuetext = props['aria-valuetext'],
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      getAriaLabel = props.getAriaLabel,
	      getAriaValueText = props.getAriaValueText,
	      _props$marks = props.marks,
	      marksProp = _props$marks === void 0 ? defaultMarks : _props$marks,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 100 : _props$max,
	      _props$min = props.min,
	      min = _props$min === void 0 ? 0 : _props$min,
	      name = props.name,
	      onChange = props.onChange,
	      onChangeCommitted = props.onChangeCommitted,
	      onMouseDown = props.onMouseDown,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$step = props.step,
	      step = _props$step === void 0 ? 1 : _props$step,
	      _props$ThumbComponent = props.ThumbComponent,
	      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
	      valueProp = props.value,
	      _props$ValueLabelComp = props.ValueLabelComponent,
	      ValueLabelComponent = _props$ValueLabelComp === void 0 ? _ValueLabel.default : _props$ValueLabelComp,
	      _props$valueLabelDisp = props.valueLabelDisplay,
	      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
	      _props$valueLabelForm = props.valueLabelFormat,
	      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "step", "ThumbComponent", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useRef = _react.default.useRef(valueProp != null),
	      isControlled = _React$useRef.current;
	
	  var touchId = _react.default.useRef(); // We can't use the :active browser pseudo-classes.
	  // - The active state isn't triggered when clicking on the rail.
	  // - The active state isn't transfered when inversing a range slider.
	
	
	  var _React$useState = _react.default.useState(-1),
	      active = _React$useState[0],
	      setActive = _React$useState[1];
	
	  var _React$useState2 = _react.default.useState(-1),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState(defaultValue),
	      valueState = _React$useState3[0],
	      setValueState = _React$useState3[1];
	
	  var valueDerived = isControlled ? valueProp : valueState;
	  var range = Array.isArray(valueDerived);
	
	  var instanceRef = _react.default.useRef();
	
	  var values = range ? (0, _toConsumableArray2.default)(valueDerived).sort(asc) : [valueDerived];
	  values = values.map(function (value) {
	    return clamp(value, min, max);
	  });
	  var marks = marksProp === true && step !== null ? (0, _toConsumableArray2.default)(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
	    return {
	      value: min + step * index
	    };
	  }) : marksProp;
	  instanceRef.current = {
	    source: valueDerived // Keep track of the input value to leverage immutable state comparison.
	
	  };
	
	  var _useIsFocusVisible = (0, _focusVisible.useIsFocusVisible)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState4 = _react.default.useState(-1),
	      focusVisible = _React$useState4[0],
	      setFocusVisible = _React$useState4[1];
	
	  var sliderRef = _react.default.useRef();
	
	  var handleFocusRef = (0, _reactHelpers.useForkRef)(focusVisibleRef, sliderRef);
	  var handleRef = (0, _reactHelpers.useForkRef)(ref, handleFocusRef);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(index);
	    }
	
	    setOpen(index);
	  });
	  var handleBlur = (0, _useEventCallback.default)(function () {
	    if (focusVisible !== -1) {
	      setFocusVisible(-1);
	      onBlurVisible();
	    }
	
	    setOpen(-1);
	  });
	  var handleMouseOver = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    setOpen(index);
	  });
	  var handleMouseLeave = (0, _useEventCallback.default)(function () {
	    setOpen(-1);
	  });
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    var value = values[index];
	    var tenPercents = (max - min) / 10;
	    var marksValues = marks.map(function (mark) {
	      return mark.value;
	    });
	    var marksIndex = marksValues.indexOf(value);
	    var newValue;
	
	    switch (event.key) {
	      case 'Home':
	        newValue = min;
	        break;
	
	      case 'End':
	        newValue = max;
	        break;
	
	      case 'PageUp':
	        if (step) {
	          newValue = value + tenPercents;
	        }
	
	        break;
	
	      case 'PageDown':
	        if (step) {
	          newValue = value - tenPercents;
	        }
	
	        break;
	
	      case 'ArrowRight':
	      case 'ArrowUp':
	        if (step) {
	          newValue = value + step;
	        } else {
	          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
	        }
	
	        break;
	
	      case 'ArrowLeft':
	      case 'ArrowDown':
	        if (step) {
	          newValue = value - step;
	        } else {
	          newValue = marksValues[marksIndex - 1] || marksValues[0];
	        }
	
	        break;
	
	      default:
	        return;
	    }
	
	    event.preventDefault();
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step);
	    }
	
	    newValue = clamp(newValue, min, max);
	
	    if (range) {
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values,
	        source: valueDerived,
	        newValue: newValue,
	        index: index
	      }).sort(asc);
	      focusThumb({
	        sliderRef: sliderRef,
	        activeIndex: newValue.indexOf(previousValue)
	      });
	    }
	
	    if (!isControlled) {
	      setValueState(newValue);
	    }
	
	    setFocusVisible(index);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	  });
	
	  var previousIndex = _react.default.useRef();
	
	  var axis = orientation;
	
	  if (theme.direction === 'rtl' && orientation !== "vertical") {
	    axis += '-reverse';
	  }
	
	  var getFingerNewValue = _react.default.useCallback(function (_ref3) {
	    var finger = _ref3.finger,
	        _ref3$move = _ref3.move,
	        move = _ref3$move === void 0 ? false : _ref3$move,
	        values2 = _ref3.values,
	        source = _ref3.source;
	    var slider = sliderRef.current;
	
	    var _slider$getBoundingCl = slider.getBoundingClientRect(),
	        width = _slider$getBoundingCl.width,
	        height = _slider$getBoundingCl.height,
	        bottom = _slider$getBoundingCl.bottom,
	        left = _slider$getBoundingCl.left;
	
	    var percent;
	
	    if (axis.indexOf('vertical') === 0) {
	      percent = (bottom - finger.y) / height;
	    } else {
	      percent = (finger.x - left) / width;
	    }
	
	    if (axis.indexOf('-reverse') !== -1) {
	      percent = 1 - percent;
	    }
	
	    var newValue;
	    newValue = percentToValue(percent, min, max);
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step);
	    } else {
	      var marksValues = marks.map(function (mark) {
	        return mark.value;
	      });
	      var closestIndex = findClosest(marksValues, newValue);
	      newValue = marksValues[closestIndex];
	    }
	
	    newValue = clamp(newValue, min, max);
	    var activeIndex = 0;
	
	    if (range) {
	      if (!move) {
	        activeIndex = findClosest(values2, newValue);
	      } else {
	        activeIndex = previousIndex.current;
	      }
	
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values2,
	        source: source,
	        newValue: newValue,
	        index: activeIndex
	      }).sort(asc);
	      activeIndex = newValue.indexOf(previousValue);
	      previousIndex.current = activeIndex;
	    }
	
	    return {
	      newValue: newValue,
	      activeIndex: activeIndex
	    };
	  }, [max, min, axis, range, step, marks]);
	
	  var handleTouchMove = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue = getFingerNewValue({
	      finger: finger,
	      move: true,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue.newValue,
	        activeIndex = _getFingerNewValue.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	
	    if (!isControlled) {
	      setValueState(newValue);
	    }
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	  });
	  var handleTouchEnd = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue2 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue2.newValue;
	
	    setActive(-1);
	
	    if (event.type === 'touchend') {
	      setOpen(-1);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	
	    touchId.current = undefined;
	    document.body.removeEventListener('mousemove', handleTouchMove);
	    document.body.removeEventListener('mouseup', handleTouchEnd); // eslint-disable-next-line no-use-before-define
	
	    document.body.removeEventListener('mouseenter', handleMouseEnter);
	    document.body.removeEventListener('touchmove', handleTouchMove);
	    document.body.removeEventListener('touchend', handleTouchEnd);
	  });
	  var handleMouseEnter = (0, _useEventCallback.default)(function (event) {
	    // If the slider was being interacted with but the mouse went off the window
	    // and then re-entered while unclicked then end the interaction.
	    //
	    // In Firefox, the event can be triggered when a new DOM node is inserted and hovered.
	    // We need to make sure that the relatedTarget (The EventTarget the pointing device exited from)
	    // is not null (it should be the html element)
	    if (event.buttons === 0 && event.relatedTarget !== null) {
	      handleTouchEnd(event);
	    }
	  });
	  var handleTouchStart = (0, _useEventCallback.default)(function (event) {
	    // Workaround as Safari has partial support for touchAction: 'none'.
	    event.preventDefault();
	    var touch = event.changedTouches[0];
	
	    if (touch != null) {
	      // A number that uniquely identifies the current finger in the touch session.
	      touchId.current = touch.identifier;
	    }
	
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue3 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue3.newValue,
	        activeIndex = _getFingerNewValue3.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	
	    if (!isControlled) {
	      setValueState(newValue);
	    }
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    document.body.addEventListener('touchmove', handleTouchMove);
	    document.body.addEventListener('touchend', handleTouchEnd);
	  });
	
	  _react.default.useEffect(function () {
	    if (disabled) {
	      return function () {};
	    }
	
	    var slider = sliderRef.current;
	    slider.addEventListener('touchstart', handleTouchStart);
	    return function () {
	      slider.removeEventListener('touchstart', handleTouchStart);
	      document.body.removeEventListener('mousemove', handleTouchMove);
	      document.body.removeEventListener('mouseup', handleTouchEnd);
	      document.body.removeEventListener('mouseenter', handleMouseEnter);
	      document.body.removeEventListener('touchmove', handleTouchMove);
	      document.body.removeEventListener('touchend', handleTouchEnd);
	    };
	  }, [disabled, handleMouseEnter, handleTouchEnd, handleTouchMove, handleTouchStart]);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (isControlled !== (valueProp != null)) {
	        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Slider to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Slider ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [valueProp, isControlled]);
	  }
	
	  var handleMouseDown = (0, _useEventCallback.default)(function (event) {
	    if (onMouseDown) {
	      onMouseDown(event);
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    event.preventDefault();
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue4 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue4.newValue,
	        activeIndex = _getFingerNewValue4.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	
	    if (!isControlled) {
	      setValueState(newValue);
	    }
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    document.body.addEventListener('mousemove', handleTouchMove);
	    document.body.addEventListener('mouseenter', handleMouseEnter);
	    document.body.addEventListener('mouseup', handleTouchEnd);
	  });
	  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
	  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
	  var trackStyle = (0, _extends2.default)({}, axisProps[axis].offset(trackOffset), {}, axisProps[axis].leap(trackLeap));
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    ref: handleRef,
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
	      return mark.label;
	    }) && classes.marked, {
	      vertical: classes.vertical
	    }[orientation]),
	    onMouseDown: handleMouseDown
	  }, other), _react.default.createElement("span", {
	    className: classes.rail
	  }), _react.default.createElement("span", {
	    className: classes.track,
	    style: trackStyle
	  }), _react.default.createElement("input", {
	    value: values.join(','),
	    name: name,
	    type: "hidden"
	  }), marks.map(function (mark) {
	    var percent = valueToPercent(mark.value, min, max);
	    var style = axisProps[axis].offset(percent);
	    var markActive = range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0];
	    return _react.default.createElement(_react.default.Fragment, {
	      key: mark.value
	    }, _react.default.createElement("span", {
	      style: style,
	      className: (0, _clsx.default)(classes.mark, markActive && classes.markActive)
	    }), _react.default.createElement("span", {
	      "aria-hidden": true,
	      style: style,
	      className: (0, _clsx.default)(classes.markLabel, markActive && classes.markLabelActive)
	    }, mark.label));
	  }), values.map(function (value, index) {
	    var percent = valueToPercent(value, min, max);
	    var style = axisProps[axis].offset(percent);
	    return _react.default.createElement(ValueLabelComponent, {
	      key: index,
	      valueLabelFormat: valueLabelFormat,
	      valueLabelDisplay: valueLabelDisplay,
	      className: classes.valueLabel,
	      value: value,
	      index: index,
	      open: open === index || active === index,
	      disabled: disabled
	    }, _react.default.createElement(ThumbComponent, {
	      className: (0, _clsx.default)(classes.thumb, classes["thumbColor".concat((0, _helpers.capitalize)(color))], active === index && classes.active, focusVisible === index && classes.focusVisible),
	      tabIndex: disabled ? null : 0,
	      role: "slider",
	      style: style,
	      "data-index": index,
	      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
	      "aria-labelledby": ariaLabelledby,
	      "aria-orientation": orientation,
	      "aria-valuemax": max,
	      "aria-valuemin": min,
	      "aria-valuenow": value,
	      "aria-valuetext": getAriaValueText ? getAriaValueText(value, index) : ariaValuetext,
	      onKeyDown: handleKeyDown,
	      onFocus: handleFocus,
	      onBlur: handleBlur,
	      onMouseOver: handleMouseOver,
	      onMouseLeave: handleMouseLeave
	    }));
	  }));
	});
	
	 false ? Slider.propTypes = {
	  /**
	   * The label of the slider.
	   */
	  'aria-label': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-label'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The id of the element containing a label for the slider.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * A string value that provides a user-friendly name for the current value of the slider.
	   */
	  'aria-valuetext': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-valuetext'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * If `true`, the slider will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
	   *
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaLabel: _propTypes.default.func,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
	   *
	   * @param {number} value The thumb label's value to format.
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaValueText: _propTypes.default.func,
	
	  /**
	   * Marks indicate predetermined values to which the user can move the slider.
	   * If `true` the marks will be spaced according the value of the `step` prop.
	   * If an array, it should contain objects with `value` and an optional `label` keys.
	   */
	  marks: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
	
	  /**
	   * The maximum allowed value of the slider.
	   * Should not be equal to min.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * The minimum allowed value of the slider.
	   * Should not be equal to max.
	   */
	  min: _propTypes.default.number,
	
	  /**
	   * Name attribute of the hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value The new value.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback function that is fired when the `mouseup` is triggered.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value The new value.
	   */
	  onChangeCommitted: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * The slider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The granularity with which the slider can step through values. (A "discrete" slider.)
	   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
	   */
	  step: _propTypes.default.number,
	
	  /**
	   * The component used to display the value label.
	   */
	  ThumbComponent: _propTypes.default.elementType,
	
	  /**
	   * The value of the slider.
	   * For ranged sliders, provide an array with two values.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * The value label component.
	   */
	  ValueLabelComponent: _propTypes.default.elementType,
	
	  /**
	   * Controls when the value label is displayed:
	   *
	   * - `auto` the value label will display when the thumb is hovered or focused.
	   * - `on` will display persistently.
	   * - `off` will never display.
	   */
	  valueLabelDisplay: _propTypes.default.oneOf(['on', 'auto', 'off']),
	
	  /**
	   * The format function the value label's value.
	   *
	   * When a function is provided, it should have the following signature:
	   *
	   * - {number} value The value label's value to format
	   * - {number} index The value label's index to format
	   */
	  valueLabelFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSlider'
	})(Slider);
	
	exports.default = _default;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    thumb: {
	      '&$open': {
	        '& $offset': {
	          transform: 'scale(1) translateY(-10px)'
	        }
	      }
	    },
	    open: {},
	    offset: (0, _extends2.default)({
	      zIndex: 1
	    }, theme.typography.body2, {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.2,
	      transition: theme.transitions.create(['transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      top: -34,
	      left: 'calc(-50% + -4px)',
	      transformOrigin: 'bottom center',
	      transform: 'scale(0)',
	      position: 'absolute'
	    }),
	    circle: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 32,
	      height: 32,
	      borderRadius: '50% 50% 50% 0',
	      backgroundColor: 'currentColor',
	      transform: 'rotate(-45deg)'
	    },
	    label: {
	      color: theme.palette.primary.contrastText,
	      transform: 'rotate(45deg)'
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function ValueLabel(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      index = props.index,
	      open = props.open,
	      value = props.value,
	      valueLabelDisplay = props.valueLabelDisplay,
	      valueLabelFormat = props.valueLabelFormat;
	
	  if (valueLabelDisplay === 'off') {
	    return children;
	  }
	
	  return _react.default.cloneElement(children, {
	    className: (0, _clsx.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
	  }, _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.offset, className)
	  }, _react.default.createElement("span", {
	    className: classes.circle
	  }, _react.default.createElement("span", {
	    className: classes.label
	  }, typeof valueLabelFormat === 'function' ? valueLabelFormat(value, index) : valueLabelFormat))));
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateValueLabel'
	})(ValueLabel);
	
	exports.default = _default;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	
	var _Slider = _interopRequireDefault(__webpack_require__(557));

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends8 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _transitions = __webpack_require__(36);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(184));
	
	var _helpers = __webpack_require__(11);
	
	var _Grow = _interopRequireDefault(__webpack_require__(86));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(131));
	
	var styles = function styles(theme) {
	  var top1 = {
	    top: 8
	  };
	  var bottom1 = {
	    bottom: 8
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var top3 = {
	    top: 24
	  };
	  var bottom3 = {
	    bottom: 24
	  };
	  var right3 = {
	    right: 24
	  };
	  var left3 = {
	    left: 24
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 8,
	      right: 8,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
	    anchorOriginTopCenter: (0, _extends8.default)({}, top1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, top3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
	    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, bottom3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
	    anchorOriginTopRight: (0, _extends8.default)({}, top1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, top3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
	    anchorOriginBottomRight: (0, _extends8.default)({}, bottom1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, bottom3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
	    anchorOriginTopLeft: (0, _extends8.default)({}, top1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, top3, {}, left3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
	    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, bottom3, {}, left3)))
	  };
	};
	
	exports.styles = styles;
	
	var Snackbar = _react.default.forwardRef(function Snackbar(props, ref) {
	  var action = props.action,
	      _props$anchorOrigin = props.anchorOrigin;
	  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'bottom',
	    horizontal: 'center'
	  } : _props$anchorOrigin;
	  var vertical = _props$anchorOrigin.vertical,
	      horizontal = _props$anchorOrigin.horizontal,
	      autoHideDuration = props.autoHideDuration,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      ClickAwayListenerProps = props.ClickAwayListenerProps,
	      ContentProps = props.ContentProps,
	      _props$disableWindowB = props.disableWindowBlurListener,
	      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
	      message = props.message,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      open = props.open,
	      resumeHideDuration = props.resumeHideDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  } : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  var timerAutoHide = _react.default.useRef();
	
	  var _React$useState = _react.default.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1]; // Timer that controls delay before snackbar auto hides
	
	
	  var setAutoHideTimer = _react.default.useCallback(function (autoHideDurationParam) {
	    var autoHideDurationBefore = autoHideDurationParam != null ? autoHideDurationParam : autoHideDuration;
	
	    if (!onClose || autoHideDurationBefore == null) {
	      return;
	    }
	
	    clearTimeout(timerAutoHide.current);
	    timerAutoHide.current = setTimeout(function () {
	      var autoHideDurationAfter = autoHideDurationParam != null ? autoHideDurationParam : autoHideDuration;
	
	      if (!onClose || autoHideDurationAfter == null) {
	        return;
	      }
	
	      onClose(null, 'timeout');
	    }, autoHideDurationBefore);
	  }, [autoHideDuration, onClose]);
	
	  _react.default.useEffect(function () {
	    if (open) {
	      setAutoHideTimer();
	    }
	
	    return function () {
	      clearTimeout(timerAutoHide.current);
	    };
	  }, [open, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
	  // or when the user hide the window.
	
	
	  var handlePause = function handlePause() {
	    clearTimeout(timerAutoHide.current);
	  }; // Restart the timer when the user is no longer interacting with the Snackbar
	  // or when the window is shown back.
	
	
	  var handleResume = _react.default.useCallback(function () {
	    if (autoHideDuration != null) {
	      if (resumeHideDuration != null) {
	        setAutoHideTimer(resumeHideDuration);
	        return;
	      }
	
	      setAutoHideTimer(autoHideDuration * 0.5);
	    }
	  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
	
	  var handleMouseEnter = function handleMouseEnter(event) {
	    if (onMouseEnter) {
	      onMouseEnter(event);
	    }
	
	    handlePause();
	  };
	
	  var handleMouseLeave = function handleMouseLeave(event) {
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	
	    handleResume();
	  };
	
	  var handleClickAway = function handleClickAway(event) {
	    if (onClose) {
	      onClose(event, 'clickaway');
	    }
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	  };
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  _react.default.useEffect(function () {
	    if (!disableWindowBlurListener && open) {
	      window.addEventListener('focus', handleResume);
	      window.addEventListener('blur', handlePause);
	      return function () {
	        window.removeEventListener('focus', handleResume);
	        window.removeEventListener('blur', handlePause);
	      };
	    }
	
	    return undefined;
	  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.
	
	
	  if (!open && exited) {
	    return null;
	  }
	
	  return _react.default.createElement(_ClickAwayListener.default, (0, _extends8.default)({
	    onClickAway: handleClickAway
	  }, ClickAwayListenerProps), _react.default.createElement("div", (0, _extends8.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    ref: ref
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends8.default)({
	    appear: true,
	    in: open,
	    onEnter: (0, _helpers.createChainedFunction)(handleEnter, onEnter),
	    onEntered: onEntered,
	    onEntering: onEntering,
	    onExit: onExit,
	    onExited: (0, _helpers.createChainedFunction)(handleExited, onExited),
	    onExiting: onExiting,
	    timeout: transitionDuration,
	    direction: vertical === 'top' ? 'down' : 'up'
	  }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends8.default)({
	    message: message,
	    action: action
	  }, ContentProps)))));
	});
	
	 false ? Snackbar.propTypes = {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'center', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['top', 'bottom']).isRequired
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * Replace the `SnackbarContent` component.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `ClickAwayListener` element.
	   */
	  ClickAwayListenerProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If true, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` prop isn't specified, it does nothing.
	   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * The component used for the transition.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _colorManipulator = __webpack_require__(24);
	
	var styles = function styles(theme) {
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _defineProperty2.default)({
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      flexGrow: 1
	    }, theme.breakpoints.up('sm'), {
	      flexGrow: 'initial',
	      minWidth: 288
	    }),
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	
	var SnackbarContent = _react.default.forwardRef(function SnackbarContent(props, ref) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    component: _Typography.default,
	    variant: "body2",
	    variantMapping: {
	      body1: 'div',
	      body2: 'div'
	    },
	    role: "alertdialog",
	    square: true,
	    elevation: 6,
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), _react.default.createElement("div", {
	    className: classes.message
	  }, message), action ? _react.default.createElement("div", {
	    className: classes.action
	  }, action) : null);
	});
	
	 false ? SnackbarContent.propTypes = {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {},
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    flex: 1,
	    position: 'relative'
	  },
	
	  /* Pseudo-class applied to the root element if `completed={true}`. */
	  completed: {}
	};
	exports.styles = styles;
	
	var Step = _react.default.forwardRef(function Step(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      connector = props.connector,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);
	  var className = (0, _clsx.default)(classes.root, classes[orientation], classNameProp, alternativeLabel && classes.alternativeLabel, completed && classes.completed);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other), connector && alternativeLabel && index !== 0 && _react.default.cloneElement(connector, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel,
	    index: index,
	    active: active,
	    completed: completed,
	    disabled: disabled
	  }), _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return _react.default.cloneElement(child, (0, _extends2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      last: last,
	      icon: index + 1,
	      orientation: orientation
	    }, child.props));
	  }));
	});
	
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Passed down from Stepper if alternativeLabel is also set.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(562));

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(209));
	
	var _reactHelpers = __webpack_require__(13);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    padding: '24px 16px',
	    margin: '-24px -16px',
	    boxSizing: 'content-box'
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {},
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    justifyContent: 'flex-start',
	    padding: '8px',
	    margin: '-8px'
	  },
	
	  /* Styles applied to the `ButtonBase` touch-ripple. */
	  touchRipple: {
	    color: 'rgba(0, 0, 0, 0.3)'
	  }
	};
	exports.styles = styles;
	
	var StepButton = _react.default.forwardRef(function StepButton(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react.default.cloneElement(children, childProps) : _react.default.createElement(_StepLabel.default, childProps, children);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _clsx.default)(classes.root, classes[orientation], classNameProp),
	    ref: ref
	  }, other), child);
	});
	
	 false ? StepButton.propTypes = {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	
	var _StepButton = _interopRequireDefault(__webpack_require__(564));

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto'
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: '0 0 8px'
	    },
	
	    /* Styles applied to the root element if `alternativeLabel={true}`. */
	    alternativeLabel: {
	      position: 'absolute',
	      top: 8 + 4,
	      left: 'calc(-50% + 20px)',
	      right: 'calc(50% + 20px)'
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the line element. */
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    }
	  };
	};
	
	exports.styles = styles;
	
	var StepConnector = _react.default.forwardRef(function StepConnector(props, ref) {
	  var active = props.active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      index = props.index,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], classNameProp, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
	    ref: ref
	  }, other), _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.line, orientation === 'vertical' ? classes.lineVertical : classes.lineHorizontal)
	  }));
	});
	
	 false ? StepConnector.propTypes = {
	  /**
	   * @ignore
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  index: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepConnector'
	})(StepConnector);
	
	exports.default = _default;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(118));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      marginTop: 8,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: 8 + 12,
	      // margin + half icon
	      paddingRight: 8,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	
	    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
	    last: {
	      borderLeft: 'none'
	    },
	
	    /* Styles applied to the Transition component. */
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	
	var StepContent = _react.default.forwardRef(function StepContent(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  if (false) {
	    if (orientation !== 'vertical') {
	      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
	    }
	  }
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, last && classes.last),
	    ref: ref
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    in: active,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	});
	
	 false ? StepContent.propTypes = {
	  /**
	   * @ignore
	   * Expands the content.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel prop.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the optional prop.
	   */
	  optional: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used for the transition.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a prop to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	
	var _StepContent = _interopRequireDefault(__webpack_require__(567));

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(619));
	
	var _Warning = _interopRequireDefault(__webpack_require__(624));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(67));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      color: theme.palette.text.disabled,
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the SVG text element. */
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	var StepIcon = _react.default.forwardRef(function StepIcon(props, ref) {
	  var _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      icon = props.icon,
	      _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    if (error) {
	      return _react.default.createElement(_Warning.default, {
	        className: (0, _clsx.default)(classes.root, classes.error),
	        ref: ref
	      });
	    }
	
	    if (completed) {
	      return _react.default.createElement(_CheckCircle.default, {
	        className: (0, _clsx.default)(classes.root, classes.completed),
	        ref: ref
	      });
	    }
	
	    return _react.default.createElement(_SvgIcon.default, {
	      className: (0, _clsx.default)(classes.root, active && classes.active),
	      ref: ref
	    }, _ref, _react.default.createElement("text", {
	      className: classes.text,
	      x: "12",
	      y: "16",
	      textAnchor: "middle"
	    }, icon));
	  }
	
	  return icon;
	});
	
	 false ? StepIcon.propTypes = {
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The label displayed in the step icon.
	   */
	  icon: _propTypes.default.node.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(208));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal". */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical". */
	    vertical: {},
	
	    /* Styles applied to the `Typography` component which wraps `children`. */
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: 16
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the `icon` container element. */
	    iconContainer: {
	      flexShrink: 0,
	      // Fix IE 11 issue
	      display: 'flex',
	      paddingRight: 8,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	
	    /* Pseudo-class applied to the root & icon container and `Typography` if `alternativeLabel={true}`. */
	    alternativeLabel: {},
	
	    /* Styles applied to the container element which wraps `Typography` and `optional`. */
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var StepLabel = _react.default.forwardRef(function StepLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      StepIconComponentProp = props.StepIconComponent,
	      StepIconProps = props.StepIconProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
	  var StepIconComponent = StepIconComponentProp;
	
	  if (icon && !StepIconComponent) {
	    StepIconComponent = _StepIcon.default;
	  }
	
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], classNameProp, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
	    ref: ref
	  }, other), icon || StepIconComponent ? _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
	  }, _react.default.createElement(StepIconComponent, (0, _extends2.default)({
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon
	  }, StepIconProps))) : null, _react.default.createElement("span", {
	    className: classes.labelContainer
	  }, _react.default.createElement(_Typography.default, {
	    variant: "body2",
	    component: "span",
	    className: (0, _clsx.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error),
	    display: "block"
	  }, children), optional));
	});
	
	 false ? StepLabel.propTypes = {
	  /**
	   * @ignore
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel prop.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default label of the step icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component to render in place of the [`StepIcon`](/api/step-icon/).
	   */
	  StepIconComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`StepIcon`](/api/step-icon/) element.
	   */
	  StepIconProps: _propTypes.default.object
	} : void 0;
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(207));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: 24
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    flexDirection: 'column'
	  },
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    alignItems: 'flex-start'
	  }
	};
	exports.styles = styles;
	
	var defaultConnector = _react.default.createElement(_StepConnector.default, null);
	
	var Stepper = _react.default.forwardRef(function Stepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$connector = props.connector,
	      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
	      _props$nonLinear = props.nonLinear,
	      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var className = (0, _clsx.default)(classes.root, classes[orientation], classNameProp, alternativeLabel && classes.alternativeLabel);
	  var connector = _react.default.isValidElement(connectorProp) ? _react.default.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	
	  var childrenArray = _react.default.Children.toArray(children);
	
	  var steps = childrenArray.map(function (step, index) {
	    var controlProps = {
	      alternativeLabel: alternativeLabel,
	      connector: connectorProp,
	      last: index + 1 === childrenArray.length,
	      orientation: orientation
	    };
	    var state = {
	      index: index,
	      active: false,
	      completed: false,
	      disabled: false
	    };
	
	    if (activeStep === index) {
	      state.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      state.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      state.disabled = true;
	    }
	
	    return [!alternativeLabel && connector && index !== 0 && _react.default.cloneElement(connector, (0, _extends2.default)({
	      key: index
	    }, state)), _react.default.cloneElement(step, (0, _extends2.default)({}, controlProps, {}, state, {}, step.props))];
	  });
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: className,
	    ref: ref
	  }, other), steps);
	});
	
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index).
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * An element to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(571));

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	
	var SvgIcon = _react.default.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _helpers.capitalize)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _helpers.capitalize)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? 'false' : 'true',
	    role: titleAccess ? 'img' : 'presentation',
	    ref: ref
	  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
	});
	
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _Drawer = __webpack_require__(120);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      zIndex: theme.zIndex.drawer - 1
	    },
	    anchorLeft: {
	      right: 'auto'
	    },
	    anchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    anchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    anchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var SwipeArea = _react.default.forwardRef(function SwipeArea(props, ref) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      className = props.className,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchor".concat((0, _helpers.capitalize)(anchor))], className),
	    ref: ref,
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width)
	  }, other));
	});
	
	 false ? SwipeArea.propTypes = {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  width: _propTypes.default.number.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwipeArea'
	})(SwipeArea);
	
	exports.default = _default;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _utils = __webpack_require__(10);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(120));
	
	var _transitions = __webpack_require__(36);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _utils2 = __webpack_require__(54);
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(126));
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(574));
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	function calculateCurrentX(anchor, touches) {
	  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
	}
	
	function calculateCurrentY(anchor, touches) {
	  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
	}
	
	function getMaxTranslate(horizontalSwipe, paperInstance) {
	  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
	}
	
	function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
	  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
	}
	
	var disableSwipeToOpenDefault = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
	var transitionDurationDefault = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	
	var SwipeableDrawer = _react.default.forwardRef(function SwipeableDrawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
	      _props$disableBackdro = props.disableBackdropTransition,
	      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableDiscove = props.disableDiscovery,
	      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
	      _props$disableSwipeTo = props.disableSwipeToOpen,
	      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? disableSwipeToOpenDefault : _props$disableSwipeTo,
	      hideBackdrop = props.hideBackdrop,
	      _props$hysteresis = props.hysteresis,
	      hysteresis = _props$hysteresis === void 0 ? 0.55 : _props$hysteresis,
	      _props$minFlingVeloci = props.minFlingVelocity,
	      minFlingVelocity = _props$minFlingVeloci === void 0 ? 400 : _props$minFlingVeloci,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropProps = _props$ModalProps.BackdropProps,
	      ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SwipeAreaProps = props.SwipeAreaProps,
	      _props$swipeAreaWidth = props.swipeAreaWidth,
	      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = _react.default.useState(false),
	      maybeSwiping = _React$useState[0],
	      setMaybeSwiping = _React$useState[1];
	
	  var swipeInstance = _react.default.useRef({
	    isSwiping: null
	  });
	
	  var swipeAreaRef = _react.default.useRef();
	
	  var backdropRef = _react.default.useRef();
	
	  var paperRef = _react.default.useRef();
	
	  var touchDetected = _react.default.useRef(false);
	
	  var openRef = _react.default.useRef(open); // Use a ref so the open value used is always up to date inside useCallback.
	
	
	  useEnhancedEffect(function () {
	    openRef.current = open;
	  }, [open]);
	
	  var setPosition = _react.default.useCallback(function (translate) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode = options.mode,
	        mode = _options$mode === void 0 ? null : _options$mode,
	        _options$changeTransi = options.changeTransition,
	        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	    var drawerStyle = paperRef.current.style;
	    drawerStyle.webkitTransform = transform;
	    drawerStyle.transform = transform;
	    var transition = '';
	
	    if (mode) {
	      transition = theme.transitions.create('all', (0, _utils2.getTransitionProps)({
	        timeout: transitionDuration
	      }, {
	        mode: mode
	      }));
	    }
	
	    if (changeTransition) {
	      drawerStyle.webkitTransition = transition;
	      drawerStyle.transition = transition;
	    }
	
	    if (!disableBackdropTransition && !hideBackdrop) {
	      var backdropStyle = backdropRef.current.style;
	      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
	
	      if (changeTransition) {
	        backdropStyle.webkitTransition = transition;
	        backdropStyle.transition = transition;
	      }
	    }
	  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
	
	  var handleBodyTouchEnd = _react.default.useCallback(function (event) {
	    if (!touchDetected.current) {
	      return;
	    }
	
	    nodeThatClaimedTheSwipe = null;
	    touchDetected.current = false;
	    setMaybeSwiping(false); // The swipe wasn't started.
	
	    if (!swipeInstance.current.isSwiping) {
	      swipeInstance.current.isSwiping = null;
	      return;
	    }
	
	    swipeInstance.current.isSwiping = null;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontal = (0, _Drawer.isHorizontal)(anchor);
	    var current;
	
	    if (horizontal) {
	      current = calculateCurrentX(anchorRtl, event.changedTouches);
	    } else {
	      current = calculateCurrentY(anchorRtl, event.changedTouches);
	    }
	
	    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
	    var currentTranslate = getTranslate(current, startLocation, openRef.current, maxTranslate);
	    var translateRatio = currentTranslate / maxTranslate;
	
	    if (openRef.current) {
	      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
	        onClose();
	      } else {
	        // Reset the position, the swipe was aborted.
	        setPosition(0, {
	          mode: 'exit'
	        });
	      }
	
	      return;
	    }
	
	    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
	      onOpen();
	    } else {
	      // Reset the position, the swipe was aborted.
	      setPosition(getMaxTranslate(horizontal, paperRef.current), {
	        mode: 'enter'
	      });
	    }
	  }, [anchor, hysteresis, minFlingVelocity, onClose, onOpen, setPosition, theme]);
	
	  var handleBodyTouchMove = _react.default.useCallback(function (event) {
	    // the ref may be null when a parent component updates while swiping
	    if (!paperRef.current || !touchDetected.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches); // We don't know yet.
	
	    if (swipeInstance.current.isSwiping == null) {
	      var dx = Math.abs(currentX - swipeInstance.current.startX);
	      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	      if (dx > dy) {
	        if (event.cancelable) {
	          event.preventDefault();
	        }
	      }
	
	      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	        swipeInstance.current.isSwiping = definitelySwiping;
	
	        if (!definitelySwiping) {
	          handleBodyTouchEnd(event);
	          return;
	        } // Shift the starting point.
	
	
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	        if (!disableDiscovery && !openRef.current) {
	          if (horizontalSwipe) {
	            swipeInstance.current.startX -= swipeAreaWidth;
	          } else {
	            swipeInstance.current.startY -= swipeAreaWidth;
	          }
	        }
	      }
	    }
	
	    if (!swipeInstance.current.isSwiping) {
	      return;
	    }
	
	    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
	    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, openRef.current, maxTranslate);
	
	    if (swipeInstance.current.lastTranslate === null) {
	      swipeInstance.current.lastTranslate = translate;
	      swipeInstance.current.lastTime = performance.now() + 1;
	    }
	
	    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.
	
	    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
	    swipeInstance.current.lastTranslate = translate;
	    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.
	
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	
	    setPosition(translate);
	  }, [setPosition, handleBodyTouchEnd, anchor, disableDiscovery, swipeAreaWidth, theme]);
	
	  var handleBodyTouchStart = _react.default.useCallback(function (event) {
	    // We are not supposed to handle this touch move.
	    if (nodeThatClaimedTheSwipe !== null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (!openRef.current) {
	      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
	        return;
	      }
	
	      if (horizontalSwipe) {
	        if (currentX > swipeAreaWidth) {
	          return;
	        }
	      } else if (currentY > swipeAreaWidth) {
	        return;
	      }
	    }
	
	    nodeThatClaimedTheSwipe = swipeInstance.current;
	    swipeInstance.current.startX = currentX;
	    swipeInstance.current.startY = currentY;
	    setMaybeSwiping(true);
	
	    if (!openRef.current && paperRef.current) {
	      // The ref may be null when a parent component updates while swiping.
	      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
	        changeTransition: false
	      });
	    }
	
	    swipeInstance.current.velocity = 0;
	    swipeInstance.current.lastTime = null;
	    swipeInstance.current.lastTranslate = null;
	    touchDetected.current = true;
	  }, [setPosition, anchor, disableDiscovery, disableSwipeToOpen, swipeAreaWidth, theme]);
	
	  _react.default.useEffect(function () {
	    if (variant === 'temporary') {
	      document.body.addEventListener('touchstart', handleBodyTouchStart);
	      document.body.addEventListener('touchmove', handleBodyTouchMove, {
	        passive: false
	      });
	      document.body.addEventListener('touchend', handleBodyTouchEnd);
	      return function () {
	        document.body.removeEventListener('touchstart', handleBodyTouchStart);
	        document.body.removeEventListener('touchmove', handleBodyTouchMove, {
	          passive: false
	        });
	        document.body.removeEventListener('touchend', handleBodyTouchEnd);
	      };
	    }
	
	    return undefined;
	  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
	
	  _react.default.useEffect(function () {
	    return function () {
	      // We need to release the lock.
	      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    };
	  }, []);
	
	  _react.default.useEffect(function () {
	    if (!open) {
	      setMaybeSwiping(false);
	    }
	  }, [open]);
	
	  var handleBackdropRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    backdropRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handlePaperRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Drawer.default, (0, _extends2.default)({
	    open: variant === 'temporary' && maybeSwiping ? true : open,
	    variant: variant,
	    ModalProps: (0, _extends2.default)({
	      BackdropProps: (0, _extends2.default)({}, BackdropProps, {
	        ref: handleBackdropRef
	      })
	    }, ModalPropsProp),
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      style: (0, _extends2.default)({
	        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	      }, PaperProps.style),
	      ref: handlePaperRef
	    }),
	    anchor: anchor,
	    transitionDuration: transitionDuration,
	    onClose: onClose,
	    ref: ref
	  }, other)), !disableSwipeToOpen && variant === 'temporary' && _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_SwipeArea.default, (0, _extends2.default)({
	    anchor: anchor,
	    ref: swipeAreaRef,
	    width: swipeAreaWidth
	  }, SwipeAreaProps))));
	});
	
	 false ? SwipeableDrawer.propTypes = {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Affects how far the drawer must be opened/closed to change his state.
	   * Specified as percent (0-1) of the width of the drawer
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * Defines, from which (average) velocity on, the swipe is
	   * defined as complete although hysteresis isn't reached.
	   * Good threshold is between 250 - 1000 px/s
	   */
	  minFlingVelocity: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.shape({
	    BackdropProps: _propTypes.default.shape({
	      component: _utils.elementTypeAcceptingRef
	    })
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef,
	    style: _propTypes.default.object
	  }),
	
	  /**
	   * Props applied to the swipe area element.
	   */
	  SwipeAreaProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	var _default = SwipeableDrawer;
	exports.default = _default;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(575));

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(24);
	
	var _helpers = __webpack_require__(11);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(137));
	
	// @inheritedComponent IconButton
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      width: 34 + 12 * 2,
	      height: 14 + 12 * 2,
	      overflow: 'hidden',
	      padding: 12,
	      boxSizing: 'border-box',
	      position: 'relative',
	      flexShrink: 0,
	      zIndex: 0,
	      // Reset the stacking context.
	      verticalAlign: 'middle' // For correct alignment with the text.
	
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -8
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -8
	    },
	
	    /* Styles applied to the internal `SwitchBase` component's `root` class. */
	    switchBase: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      // Render above the focus ripple.
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create(['left', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$checked': {
	        transform: 'translateX(50%)'
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        opacity: 0.5
	      },
	      '&$disabled + $track': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.primary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.secondary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      width: 40,
	      height: 24,
	      padding: 7,
	      '& $thumb': {
	        width: 16,
	        height: 16
	      },
	      '& $switchBase': {
	        padding: 4
	      }
	    },
	
	    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
	    checked: {},
	
	    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
	    disabled: {},
	
	    /* Styles applied to the internal SwitchBase component's input element. */
	    input: {
	      left: '-100%',
	      width: '300%'
	    },
	
	    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
	    thumb: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      height: '100%',
	      width: '100%',
	      borderRadius: 14 / 2,
	      zIndex: -1,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Switch = _react.default.forwardRef(function Switch(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "edge", "size"]);
	
	  var icon = _react.default.createElement("span", {
	    className: classes.thumb
	  });
	
	  return _react.default.createElement("span", {
	    className: (0, _clsx.default)(classes.root, className, {
	      start: classes.edgeStart,
	      end: classes.edgeEnd
	    }[edge], {
	      small: classes["size".concat((0, _helpers.capitalize)(size))]
	    }[size])
	  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    icon: icon,
	    checkedIcon: icon,
	    classes: {
	      root: (0, _clsx.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
	      input: classes.input,
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    ref: ref
	  }, other)), _react.default.createElement("span", {
	    className: classes.track
	  }));
	});
	
	 false ? Switch.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the switch.
	   * `small` is equivalent to the dense switch styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _helpers = __webpack_require__(11);
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(138));
	
	var styles = function styles(theme) {
	  var _extends2;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.button, (_extends2 = {
	      maxWidth: 264,
	      minWidth: 72,
	      position: 'relative',
	      boxSizing: 'border-box',
	      minHeight: 48,
	      flexShrink: 0,
	      padding: '6px 12px'
	    }, (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      padding: '6px 24px'
	    }), (0, _defineProperty2.default)(_extends2, "overflow", 'hidden'), (0, _defineProperty2.default)(_extends2, "whiteSpace", 'normal'), (0, _defineProperty2.default)(_extends2, "textAlign", 'center'), (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      fontSize: theme.typography.pxToRem(13),
	      minWidth: 160
	    }), _extends2)),
	
	    /* Styles applied to the root element if both `icon` and `label` are provided. */
	    labelIcon: {
	      minHeight: 72,
	      paddingTop: 9,
	      '& $wrapper > *:first-child': {
	        marginBottom: 6
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.4
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
	    fullWidth: {
	      flexShrink: 1,
	      flexGrow: 1,
	      flexBasis: 0,
	      maxWidth: 'none'
	    },
	
	    /* Styles applied to the root element if `wrapped={true}`. */
	    wrapped: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.5
	    },
	
	    /* Styles applied to the `icon` and `label`'s wrapper element. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Tab = _react.default.forwardRef(function Tab(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      indicator = props.indicator,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$wrapped = props.wrapped,
	      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "selected", "textColor", "value", "wrapped"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return _react.default.createElement(_ButtonBase.default, (0, _extends3.default)({
	    focusRipple: !disableFocusRipple,
	    className: (0, _clsx.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
	    ref: ref,
	    role: "tab",
	    "aria-selected": selected,
	    disabled: disabled,
	    onClick: handleChange
	  }, other), _react.default.createElement("span", {
	    className: classes.wrapper
	  }, icon, label), indicator);
	});
	
	 false ? Tab.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server-side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Tab labels appear in a single row.
	   * They can use a second line if needed.
	   */
	  wrapped: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _TableContext = _interopRequireDefault(__webpack_require__(211));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table',
	    width: '100%',
	    borderCollapse: 'collapse',
	    borderSpacing: 0
	  },
	
	  /* Styles applied to the root element if `stickyHeader={true}`. */
	  stickyHeader: {
	    borderCollapse: 'separate'
	  }
	};
	exports.styles = styles;
	
	var Table = _react.default.forwardRef(function Table(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'table' : _props$component,
	      _props$padding = props.padding,
	      padding = _props$padding === void 0 ? 'default' : _props$padding,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$stickyHeader = props.stickyHeader,
	      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
	
	  var table = _react.default.useMemo(function () {
	    return {
	      padding: padding,
	      size: size,
	      stickyHeader: stickyHeader
	    };
	  }, [padding, size, stickyHeader]);
	
	  return _react.default.createElement(_TableContext.default.Provider, {
	    value: table
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, stickyHeader && classes.stickyHeader)
	  }, other)));
	});
	
	 false ? Table.propTypes = {
	  /**
	   * The content of the table, normally `TableHead` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Allows TableCells to inherit padding of the Table.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Allows TableCells to inherit size of the Table.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set the header sticky.
	   *
	   * ⚠️ It doesn't work with IE 11.
	   */
	  stickyHeader: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(68));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-row-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'body'
	};
	
	var TableBody = _react.default.forwardRef(function TableBody(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'tbody' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other)));
	});
	
	 false ? TableBody.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _TableContext = _interopRequireDefault(__webpack_require__(211));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(68));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
	      textAlign: 'left',
	      padding: '14px 40px 14px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      }
	    }),
	
	    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
	    head: {
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: theme.typography.pxToRem(21),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
	    body: {
	      color: theme.palette.text.primary,
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
	    footer: {
	      color: theme.palette.text.secondary,
	      lineHeight: theme.typography.pxToRem(21),
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '6px 24px 6px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      },
	      '&$paddingCheckbox': {
	        width: 24,
	        // prevent the checkbox column from growing
	        padding: '0px 12px 0 16px',
	        '&:last-child': {
	          paddingLeft: 12,
	          paddingRight: 16
	        },
	        '& > *': {
	          padding: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `padding="checkbox"`. */
	    paddingCheckbox: {
	      width: 48,
	      // prevent the checkbox column from growing
	      padding: '0 0 0 4px',
	      '&:last-child': {
	        paddingLeft: 0,
	        paddingRight: 4
	      }
	    },
	
	    /* Styles applied to the root element if `padding="none"`. */
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
	    stickyHeader: {
	      position: 'sticky',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      backgroundColor: theme.palette.background.default
	    }
	  };
	};
	
	exports.styles = styles;
	
	var TableCell = _react.default.forwardRef(function TableCell(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      component = props.component,
	      paddingProp = props.padding,
	      scopeProp = props.scope,
	      sizeProp = props.size,
	      sortDirection = props.sortDirection,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
	
	  var table = _react.default.useContext(_TableContext.default);
	
	  var tablelvl2 = _react.default.useContext(_Tablelvl2Context.default);
	
	  var Component;
	
	  if (component) {
	    Component = component;
	  } else {
	    Component = tablelvl2 && tablelvl2.variant === 'head' ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && tablelvl2 && tablelvl2.variant === 'head') {
	    scope = 'col';
	  }
	
	  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
	  var size = sizeProp || (table && table.size ? table.size : 'medium');
	  var variant = variantProp || tablelvl2 && tablelvl2.variant;
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, align !== 'inherit' && classes["align".concat((0, _helpers.capitalize)(align))], padding !== 'default' && classes["padding".concat((0, _helpers.capitalize)(padding))], size !== 'medium' && classes["size".concat((0, _helpers.capitalize)(size))], {
	      head: [classes.head, table && table.stickyHeader && classes.stickyHeader],
	      body: classes.body,
	      footer: classes.footer
	    }[variant]),
	    "aria-sort": ariaSort,
	    scope: scope
	  }, other));
	});
	
	 false ? TableCell.propTypes = {
	  /**
	   * Set the text-align on the table cell content.
	   *
	   * Monetary or generally number fields **should be right aligned** as that allows
	   * you to add them up quickly in your head without having to worry about decimals.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Sets the padding applied to the cell.
	   * By default, the Table parent component set the value (`default`).
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Specify the size of the cell.
	   * By default, the Table parent component set the value (`medium`).
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(68));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-footer-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'footer'
	};
	
	var TableFooter = _react.default.forwardRef(function TableFooter(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'tfoot' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other)));
	});
	
	 false ? TableFooter.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(68));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-header-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'head'
	};
	
	var TableHead = _react.default.forwardRef(function TableHead(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'thead' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other)));
	});
	
	 false ? TableHead.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(63));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(198));
	
	var _Select = _interopRequireDefault(__webpack_require__(130));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(69));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(53));
	
	var _Typography = _interopRequireDefault(__webpack_require__(14));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(585));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12),
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the Toolbar component. */
	    toolbar: {
	      height: 56,
	      minHeight: 56,
	      paddingRight: 2
	    },
	
	    /* Styles applied to the spacer element. */
	    spacer: {
	      flex: '1 1 100%'
	    },
	
	    /* Styles applied to the caption Typography components if `variant="caption"`. */
	    caption: {
	      flexShrink: 0
	    },
	
	    /* Styles applied to the Select component root element. */
	    selectRoot: {
	      // `.selectRoot` should be merged with `.input` in v5.
	      marginRight: 32,
	      marginLeft: 8
	    },
	
	    /* Styles applied to the Select component `select` class. */
	    select: {
	      paddingLeft: 8,
	      paddingRight: 24,
	      textAlign: 'right',
	      textAlignLast: 'right' // Align <select> on Chrome.
	
	    },
	
	    /* Styles applied to the Select component `icon` class. */
	    selectIcon: {
	      top: 1
	    },
	
	    /* Styles applied to the `InputBase` component. */
	    input: {
	      color: 'inherit',
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the MenuItem component. */
	    menuItem: {},
	
	    /* Styles applied to the internal `TablePaginationActions` component. */
	    actions: {
	      flexShrink: 0,
	      marginLeft: 20
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      count = _ref.count;
	  return "".concat(from, "-").concat(to, " of ").concat(count);
	};
	
	var defaultRowsPerPageOptions = [10, 25, 50, 100];
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = _react.default.forwardRef(function TablePagination(props, ref) {
	  var _props$ActionsCompone = props.ActionsComponent,
	      ActionsComponent = _props$ActionsCompone === void 0 ? _TablePaginationActions.default : _props$ActionsCompone,
	      backIconButtonProps = props.backIconButtonProps,
	      classes = props.classes,
	      className = props.className,
	      colSpanProp = props.colSpan,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? _TableCell.default : _props$component,
	      count = props.count,
	      _props$labelDisplayed = props.labelDisplayedRows,
	      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
	      _props$SelectProps = props.SelectProps,
	      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["ActionsComponent", "backIconButtonProps", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	  var colSpan;
	
	  if (Component === _TableCell.default || Component === 'td') {
	    colSpan = colSpanProp || 1000; // col-span over everything
	  }
	
	  var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    colSpan: colSpan,
	    ref: ref
	  }, other), _react.default.createElement(_Toolbar.default, {
	    className: classes.toolbar
	  }, _react.default.createElement("div", {
	    className: classes.spacer
	  }), rowsPerPageOptions.length > 1 && _react.default.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "caption",
	    className: classes.caption
	  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && _react.default.createElement(_Select.default, (0, _extends2.default)({
	    classes: {
	      select: classes.select,
	      icon: classes.selectIcon
	    },
	    input: _react.default.createElement(_InputBase.default, {
	      className: (0, _clsx.default)(classes.input, classes.selectRoot)
	    }),
	    value: rowsPerPage,
	    onChange: onChangeRowsPerPage
	  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	    return _react.default.createElement(MenuItemComponent, {
	      className: classes.menuItem,
	      key: rowsPerPageOption,
	      value: rowsPerPageOption
	    }, rowsPerPageOption);
	  })), _react.default.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "caption",
	    className: classes.caption
	  }, labelDisplayedRows({
	    from: count === 0 ? 0 : page * rowsPerPage + 1,
	    to: Math.min(count, (page + 1) * rowsPerPage),
	    count: count,
	    page: page
	  })), _react.default.createElement(ActionsComponent, {
	    className: classes.actions,
	    backIconButtonProps: backIconButtonProps,
	    count: count,
	    nextIconButtonProps: nextIconButtonProps,
	    onChangePage: onChangePage,
	    page: page,
	    rowsPerPage: rowsPerPage
	  })));
	});
	
	 false ? TablePagination.propTypes = {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a DOM element or a component.
	   */
	  ActionsComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Customize the displayed rows label.
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
	   * object.
	   */
	  labelRowsPerPage: _propTypes.default.node,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: (0, _utils.chainPropTypes)(_propTypes.default.number.isRequired, function (props) {
	    var count = props.count,
	        page = props.page,
	        rowsPerPage = props.rowsPerPage;
	    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	    if (page < 0 || page > newLastPage) {
	      return new Error('Material-UI: the page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Props applied to the rows per page [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(221));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(222));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(38));
	
	var _ref = _react.default.createElement(_KeyboardArrowRight.default, null);
	
	var _ref2 = _react.default.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref3 = _react.default.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = _react.default.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions = _react.default.forwardRef(function TablePaginationActions(props, ref) {
	  var backIconButtonProps = props.backIconButtonProps,
	      count = props.count,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      other = (0, _objectWithoutProperties2.default)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);
	  var theme = (0, _useTheme.default)();
	
	  var handleBackButtonClick = function handleBackButtonClick(event) {
	    onChangePage(event, page - 1);
	  };
	
	  var handleNextButtonClick = function handleNextButtonClick(event) {
	    onChangePage(event, page + 1);
	  };
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, other), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleBackButtonClick,
	    disabled: page === 0,
	    color: "inherit"
	  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleNextButtonClick,
	    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
	    color: "inherit"
	  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
	});
	
	 false ? TablePaginationActions.propTypes = {
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired
	} : void 0;
	var _default = TablePaginationActions;
	exports.default = _default;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(68));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      '&$selected': {
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
	        : 'rgba(255, 255, 255, 0.08)'
	      },
	      '&$hover:hover': {
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
	        : 'rgba(255, 255, 255, 0.14)'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `hover={true}`. */
	    hover: {},
	
	    /* Styles applied to the root element if table variant="head". */
	    head: {},
	
	    /* Styles applied to the root element if table variant="footer". */
	    footer: {}
	  };
	};
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	
	exports.styles = styles;
	
	var TableRow = _react.default.forwardRef(function TableRow(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'tr' : _props$component,
	      _props$hover = props.hover,
	      hover = _props$hover === void 0 ? false : _props$hover,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	
	  var tablelvl2 = _react.default.useContext(_Tablelvl2Context.default);
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, tablelvl2 && {
	      head: classes.head,
	      footer: classes.footer
	    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected)
	  }, other));
	});
	
	 false ? TableRow.propTypes = {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(615));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:focus': {
	        color: theme.palette.text.primary
	      },
	      '&:hover': {
	        color: theme.palette.text.primary,
	        '& $icon': {
	          opacity: 1,
	          color: theme.palette.text.secondary
	        }
	      },
	      '&$active': {
	        color: theme.palette.text.primary,
	        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
	        '&& $icon': {
	          opacity: 1,
	          color: theme.palette.text.primary
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      height: 18,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none',
	      width: 18
	    },
	
	    /* Styles applied to the icon component if `direction="desc"`. */
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	
	    /* Styles applied to the icon component if `direction="asc"`. */
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	
	var TableSortLabel = _react.default.forwardRef(function TableSortLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'desc' : _props$direction,
	      _props$hideSortIcon = props.hideSortIcon,
	      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDownward.default : _props$IconComponent,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, active && classes.active),
	    component: "span",
	    disableRipple: true,
	    ref: ref
	  }, other), children, hideSortIcon && !active ? null : _react.default.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["iconDirection".concat((0, _helpers.capitalize)(direction))])
	  }));
	});
	
	 false ? TableSortLabel.propTypes = {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc']),
	
	  /**
	   * Hide sort icon when active is false.
	   */
	  hideSortIcon: _propTypes.default.bool,
	
	  /**
	   * Sort icon to use.
	   */
	  IconComponent: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ScrollbarSize;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var styles = {
	  width: 99,
	  height: 99,
	  position: 'absolute',
	  top: -9999,
	  overflow: 'scroll'
	};
	/**
	 * @ignore - internal component.
	 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
	 * It has been moved into the core in order to minimize the bundle size.
	 */
	
	function ScrollbarSize(props) {
	  var onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange"]);
	
	  var scrollbarHeight = _react.default.useRef();
	
	  var nodeRef = _react.default.useRef(null);
	
	  var setMeasurements = function setMeasurements() {
	    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	  };
	
	  _react.default.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      var prevHeight = scrollbarHeight.current;
	      setMeasurements();
	
	      if (prevHeight !== scrollbarHeight.current) {
	        onChange(scrollbarHeight.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [onChange]);
	
	  _react.default.useEffect(function () {
	    setMeasurements();
	    onChange(scrollbarHeight.current);
	  }, [onChange]);
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    style: styles,
	    ref: nodeRef
	  }, other));
	}
	
	 false ? ScrollbarSize.propTypes = {
	  onChange: _propTypes.default.func.isRequired
	} : void 0;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create()
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    vertical: {
	      height: '100%',
	      width: 2,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var TabIndicator = _react.default.forwardRef(function TabIndicator(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "orientation"]);
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className, {
	      vertical: classes.vertical
	    }[orientation]),
	    ref: ref
	  }, other));
	});
	
	 false ? TabIndicator.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabIndicator'
	})(TabIndicator);
	
	exports.default = _default;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(221));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(222));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(30));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = {
	  root: {
	    width: 40,
	    flexShrink: 0
	  },
	  vertical: {
	    width: '100%',
	    height: 40,
	    '& svg': {
	      transform: 'rotate(90deg)'
	    }
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement(_KeyboardArrowLeft.default, {
	  fontSize: "small"
	});
	
	var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, {
	  fontSize: "small"
	});
	
	var TabScrollButton = _react.default.forwardRef(function TabScrollButton(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      orientation = props.orientation,
	      visible = props.visible,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "orientation", "visible"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, {
	    vertical: classes.vertical
	  }[orientation]);
	
	  if (!visible) {
	    return _react.default.createElement("div", {
	      className: className
	    });
	  }
	
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "div",
	    className: className,
	    ref: ref,
	    role: null,
	    tabIndex: null
	  }, other), direction === 'left' ? _ref : _ref2);
	});
	
	 false ? TabScrollButton.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired,
	
	  /**
	   * Should the button be present or just consume space.
	   */
	  visible: _propTypes.default.bool.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(93));
	
	var _normalizeScrollLeft = __webpack_require__(847);
	
	var _animate = _interopRequireDefault(__webpack_require__(614));
	
	var _ScrollbarSize = _interopRequireDefault(__webpack_require__(588));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(589));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(590));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(56));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	/* eslint-disable no-restricted-globals */
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      display: 'flex'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element. */
	    flexContainer: {
	      display: 'flex'
	    },
	
	    /* Styles applied to the flex container element if `orientation="vertical"`. */
	    flexContainerVertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
	    centered: {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the tablist element. */
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the tablist element if `!variant="scrollable"`. */
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	
	    /* Styles applied to the tablist element if `variant="scrollable"`. */
	    scrollable: {
	      overflowX: 'scroll',
	      // Hide dimensionless scrollbar on MacOS
	      scrollbarWidth: 'none',
	      // Firefox
	      '&::-webkit-scrollbar': {
	        display: 'none' // Safari + Chrome
	
	      }
	    },
	
	    /* Styles applied to the `ScrollButtonComponent` component. */
	    scrollButtons: {},
	
	    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
	    scrollButtonsDesktop: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	
	    /* Styles applied to the `TabIndicator` component. */
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	
	var Tabs = _react.default.forwardRef(function Tabs(props, ref) {
	  var action = props.action,
	      _props$centered = props.centered,
	      centered = _props$centered === void 0 ? false : _props$centered,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$indicatorColor = props.indicatorColor,
	      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
	      onChange = props.onChange,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$ScrollButtonCo = props.ScrollButtonComponent,
	      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? _TabScrollButton.default : _props$ScrollButtonCo,
	      _props$scrollButtons = props.scrollButtons,
	      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
	      _props$TabIndicatorPr = props.TabIndicatorProps,
	      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "value", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var scrollable = variant === 'scrollable';
	  var isRtl = theme.direction === 'rtl';
	  var vertical = orientation === 'vertical';
	  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
	  var start = vertical ? 'top' : 'left';
	  var end = vertical ? 'bottom' : 'right';
	  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
	  var size = vertical ? 'height' : 'width';
	
	  if (false) {
	    if (centered && scrollable) {
	      console.error('Material-UI: you can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
	    }
	  }
	
	  var _React$useState = _react.default.useState(false),
	      mounted = _React$useState[0],
	      setMounted = _React$useState[1];
	
	  var _React$useState2 = _react.default.useState({}),
	      indicatorStyle = _React$useState2[0],
	      setIndicatorStyle = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState({
	    start: false,
	    end: false
	  }),
	      displayScroll = _React$useState3[0],
	      setDisplayScroll = _React$useState3[1];
	
	  var _React$useState4 = _react.default.useState({
	    overflow: 'hidden',
	    marginBottom: null
	  }),
	      scrollerStyle = _React$useState4[0],
	      setScrollerStyle = _React$useState4[1];
	
	  var valueToIndex = new Map();
	
	  var tabsRef = _react.default.useRef(null);
	
	  var childrenWrapperRef = _react.default.useRef(null);
	
	  var getTabsMeta = function getTabsMeta() {
	    var tabsNode = tabsRef.current;
	    var tabsMeta;
	
	    if (tabsNode) {
	      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	      tabsMeta = {
	        clientWidth: tabsNode.clientWidth,
	        scrollLeft: tabsNode.scrollLeft,
	        scrollTop: tabsNode.scrollTop,
	        scrollLeftNormalized: (0, _normalizeScrollLeft.getNormalizedScrollLeft)(tabsNode, theme.direction),
	        scrollWidth: tabsNode.scrollWidth,
	        top: rect.top,
	        bottom: rect.bottom,
	        left: rect.left,
	        right: rect.right
	      };
	    }
	
	    var tabMeta;
	
	    if (tabsNode && value !== false) {
	      var _children = childrenWrapperRef.current.children;
	
	      if (_children.length > 0) {
	        var tab = _children[valueToIndex.get(value)];
	
	        if (false) {
	          if (!tab) {
	            console.error(["Material-UI: the value provided `".concat(value, "` to the Tabs component is invalid."), 'None of the Tabs children have this value.', valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
	          }
	        }
	
	        tabMeta = tab ? tab.getBoundingClientRect() : null;
	      }
	    }
	
	    return {
	      tabsMeta: tabsMeta,
	      tabMeta: tabMeta
	    };
	  };
	
	  var updateIndicatorState = (0, _useEventCallback.default)(function () {
	    var _newIndicatorStyle;
	
	    var _getTabsMeta = getTabsMeta(),
	        tabsMeta = _getTabsMeta.tabsMeta,
	        tabMeta = _getTabsMeta.tabMeta;
	
	    var startValue = 0;
	
	    if (tabMeta && tabsMeta) {
	      if (vertical) {
	        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
	      } else {
	        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        startValue = tabMeta.left - tabsMeta.left + correction;
	      }
	    }
	
	    var newIndicatorStyle = (_newIndicatorStyle = {}, (0, _defineProperty2.default)(_newIndicatorStyle, start, startValue), (0, _defineProperty2.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
	
	    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
	      setIndicatorStyle(newIndicatorStyle);
	    } else {
	      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
	      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
	
	      if (dStart >= 1 || dSize >= 1) {
	        setIndicatorStyle(newIndicatorStyle);
	      }
	    }
	  });
	
	  var scroll = function scroll(scrollValue) {
	    (0, _animate.default)(scrollStart, tabsRef.current, scrollValue);
	  };
	
	  var moveTabsScroll = function moveTabsScroll(delta) {
	    var scrollValue = tabsRef.current[scrollStart];
	
	    if (vertical) {
	      scrollValue += delta;
	    } else {
	      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
	
	      scrollValue *= isRtl && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	    }
	
	    scroll(scrollValue);
	  };
	
	  var handleStartScrollClick = function handleStartScrollClick() {
	    moveTabsScroll(-tabsRef.current[clientSize]);
	  };
	
	  var handleEndScrollClick = function handleEndScrollClick() {
	    moveTabsScroll(tabsRef.current[clientSize]);
	  };
	
	  var handleScrollbarSizeChange = _react.default.useCallback(function (scrollbarHeight) {
	    setScrollerStyle({
	      overflow: null,
	      marginBottom: -scrollbarHeight
	    });
	  }, []);
	
	  var getConditionalElements = function getConditionalElements() {
	    var conditionalElements = {};
	    conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_ScrollbarSize.default, {
	      className: classes.scrollable,
	      onChange: handleScrollbarSizeChange
	    }) : null;
	    var scrollButtonsActive = displayScroll.start || displayScroll.end;
	    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
	    conditionalElements.scrollButtonStart = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'right' : 'left',
	      onClick: handleStartScrollClick,
	      visible: displayScroll.start,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    conditionalElements.scrollButtonEnd = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'left' : 'right',
	      onClick: handleEndScrollClick,
	      visible: displayScroll.end,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    return conditionalElements;
	  };
	
	  var scrollSelectedIntoView = (0, _useEventCallback.default)(function () {
	    var _getTabsMeta2 = getTabsMeta(),
	        tabsMeta = _getTabsMeta2.tabsMeta,
	        tabMeta = _getTabsMeta2.tabMeta;
	
	    if (!tabMeta || !tabsMeta) {
	      return;
	    }
	
	    if (tabMeta[start] < tabsMeta[start]) {
	      // left side of button is out of view
	      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
	      scroll(nextScrollStart);
	    } else if (tabMeta[end] > tabsMeta[end]) {
	      // right side of button is out of view
	      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
	
	      scroll(_nextScrollStart);
	    }
	  });
	  var updateScrollButtonState = (0, _useEventCallback.default)(function () {
	    if (scrollable && scrollButtons !== 'off') {
	      var _tabsRef$current = tabsRef.current,
	          scrollTop = _tabsRef$current.scrollTop,
	          scrollHeight = _tabsRef$current.scrollHeight,
	          clientHeight = _tabsRef$current.clientHeight,
	          scrollWidth = _tabsRef$current.scrollWidth,
	          clientWidth = _tabsRef$current.clientWidth;
	      var showStartScroll;
	      var showEndScroll;
	
	      if (vertical) {
	        showStartScroll = scrollTop > 1;
	        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
	      } else {
	        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
	
	        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	      }
	
	      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
	        setDisplayScroll({
	          start: showStartScroll,
	          end: showEndScroll
	        });
	      }
	    }
	  });
	
	  _react.default.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      updateIndicatorState();
	      updateScrollButtonState();
	    });
	    var win = (0, _ownerWindow.default)(tabsRef.current);
	    win.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      win.removeEventListener('resize', handleResize);
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	
	  var handleTabsScroll = _react.default.useCallback((0, _debounce.default)(function () {
	    updateScrollButtonState();
	  }));
	
	  _react.default.useEffect(function () {
	    return function () {
	      handleTabsScroll.clear();
	    };
	  }, [handleTabsScroll]);
	
	  _react.default.useEffect(function () {
	    setMounted(true);
	  }, []);
	
	  _react.default.useEffect(function () {
	    updateIndicatorState();
	    updateScrollButtonState();
	  });
	
	  _react.default.useEffect(function () {
	    scrollSelectedIntoView();
	  }, [scrollSelectedIntoView, indicatorStyle]);
	
	  _react.default.useImperativeHandle(action, function () {
	    return {
	      updateIndicator: updateIndicatorState
	    };
	  }, [updateIndicatorState]);
	
	  var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
	    className: classes.indicator,
	    orientation: orientation,
	    color: indicatorColor
	  }, TabIndicatorProps, {
	    style: (0, _extends2.default)({}, indicatorStyle, {}, TabIndicatorProps.style)
	  }));
	
	  var childIndex = 0;
	
	  var children = _react.default.Children.map(childrenProp, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if (child.type === _react.default.Fragment) {
	        console.error(["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    valueToIndex.set(childValue, childIndex);
	    var selected = childValue === value;
	    childIndex += 1;
	    return _react.default.cloneElement(child, {
	      fullWidth: variant === 'fullWidth',
	      indicator: selected && !mounted && indicator,
	      selected: selected,
	      onChange: onChange,
	      textColor: textColor,
	      value: childValue
	    });
	  });
	
	  var conditionalElements = getConditionalElements();
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, vertical && classes.vertical),
	    ref: ref
	  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
	    style: scrollerStyle,
	    ref: tabsRef,
	    onScroll: handleTabsScroll
	  }, _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
	    ref: childrenWrapperRef,
	    role: "tablist"
	  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
	});
	
	 false ? Tabs.propTypes = {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `updateIndicator()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _utils.refType,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child (number)
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.elementType,
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll:
	   *
	   * - `auto` will only present them when not all the items are visible.
	   * - `desktop` will only present them on medium and larger viewports.
	   * - `on` will always present them.
	   * - `off` will never present them.
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'desktop', 'on', 'off']),
	
	  /**
	   * Props applied to the tab indicator element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   *  Determines additional display behavior of the tabs:
	   *
	   *  - `scrollable` will invoke scrolling properties and allow for horizontally
	   *  scrolling (or swiping) of the tab bar.
	   *  -`fullWidth` will make the tabs grow to use all the available space,
	   *  which should be used for small views, like on mobile.
	   *  - `standard` will render the default state.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'scrollable', 'fullWidth'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs'
	})(Tabs);
	
	exports.default = _default;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _Input = _interopRequireDefault(__webpack_require__(87));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(122));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(127));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(194));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(85));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(191));
	
	var _Select = _interopRequireDefault(__webpack_require__(130));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	
	var TextField = _react.default.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      defaultValue = props.defaultValue,
	      error = props.error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      fullWidth = props.fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      multiline = props.multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "defaultValue", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
	
	  var _React$useState = _react.default.useState(0),
	      labelWidth = _React$useState[0],
	      setLabelWidth = _React$useState[1];
	
	  var labelRef = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    if (variant === 'outlined') {
	      // #StrictMode ready
	      var labelNode = _reactDom.default.findDOMNode(labelRef.current);
	
	      setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
	    }
	  }, [variant, required, label]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    InputMore.labelWidth = labelWidth;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var InputComponent = variantComponent[variant];
	
	  var InputElement = _react.default.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	
	  return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classNameProp),
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    variant: variant
	  }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    ref: labelRef
	  }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	
	 false ? TextField.propTypes = {
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _debounce = _interopRequireDefault(__webpack_require__(55));
	
	var _reactHelpers = __webpack_require__(13);
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0
	  }
	};
	
	var TextareaAutosize = _react.default.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "style", "value"]);
	
	  var _React$useRef = _react.default.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = _react.default.useRef(null);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(ref, inputRef);
	
	  var shadowRef = _react.default.useRef(null);
	
	  var _React$useState = _react.default.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = _react.default.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (rows != null) {
	      outerHeight = Math.max(Number(rows) * singleRowHeight, outerHeight);
	    }
	
	    if (rowsMax != null) {
	      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough different to update the height.
	      // This prevents infinite rendering loop.
	      if (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow) {
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      return prevState;
	    });
	  }, [setState, rows, rowsMax, props.placeholder]);
	
	  _react.default.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: rows || 1,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough different to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), _react.default.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, {}, style)
	  }));
	});
	
	 false ? TextareaAutosize.propTypes = {
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Minimum number of rows to display.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: (0, _defineProperty2.default)({
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `variant="regular"`. */
	    regular: theme.mixins.toolbar,
	
	    /* Styles applied to the root element if `variant="dense"`. */
	    dense: {
	      minHeight: 48
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Toolbar = _react.default.forwardRef(function Toolbar(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'regular' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "variant"]);
	  var className = (0, _clsx.default)(classes.root, classes[variant], classNameProp, !disableGutters && classes.gutters);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	
	 false ? Toolbar.propTypes = {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['regular', 'dense'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(10);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var _Grow = _interopRequireDefault(__webpack_require__(86));
	
	var _Popper = _interopRequireDefault(__webpack_require__(203));
	
	var _reactHelpers = __webpack_require__(13);
	
	var _focusVisible = __webpack_require__(92);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the Popper component. */
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none',
	      flip: false // disable jss-rtl plugin
	
	    },
	
	    /* Styles applied to the Popper component if `interactive={true}`. */
	    popperInteractive: {
	      pointerEvents: 'auto'
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element. */
	    tooltip: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.common.white,
	      fontFamily: theme.typography.fontFamily,
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(round(14 / 10), "em"),
	      maxWidth: 300,
	      wordWrap: 'break-word',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
	    touch: {
	      padding: '8px 16px',
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(round(16 / 14), "em"),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: '0 24px '
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: '0 24px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	
	var Tooltip = _react.default.forwardRef(function Tooltip(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$disableFocusLi = props.disableFocusListener,
	      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
	      _props$disableHoverLi = props.disableHoverListener,
	      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
	      _props$disableTouchLi = props.disableTouchListener,
	      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
	      _props$enterDelay = props.enterDelay,
	      enterDelay = _props$enterDelay === void 0 ? 0 : _props$enterDelay,
	      _props$enterTouchDela = props.enterTouchDelay,
	      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
	      id = props.id,
	      _props$interactive = props.interactive,
	      interactive = _props$interactive === void 0 ? false : _props$interactive,
	      _props$leaveDelay = props.leaveDelay,
	      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
	      _props$leaveTouchDela = props.leaveTouchDelay,
	      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      PopperProps = props.PopperProps,
	      title = props.title,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = _react.default.useState(false),
	      openState = _React$useState[0],
	      setOpenState = _React$useState[1];
	
	  var _React$useState2 = _react.default.useState(0),
	      forceUpdate = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState(),
	      childNode = _React$useState3[0],
	      setChildNode = _React$useState3[1];
	
	  var ignoreNonTouchEvents = _react.default.useRef(false);
	
	  var _React$useRef = _react.default.useRef(openProp != null),
	      isControlled = _React$useRef.current;
	
	  var defaultId = _react.default.useRef();
	
	  var closeTimer = _react.default.useRef();
	
	  var enterTimer = _react.default.useRef();
	
	  var leaveTimer = _react.default.useRef();
	
	  var touchTimer = _react.default.useRef();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
	        console.error(['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n'));
	      }
	    }, [isControlled, title, childNode]);
	  }
	
	  _react.default.useEffect(function () {
	    // Fallback to this default id when possible.
	    // Use the random value for client-side rendering only.
	    // We can't use it server-side.
	    if (!defaultId.current) {
	      defaultId.current = "mui-tooltip-".concat(Math.round(Math.random() * 1e5));
	    } // Rerender with defaultId and childNode.
	
	
	    if (openProp) {
	      forceUpdate(function (n) {
	        return !n;
	      });
	    }
	  }, [openProp]);
	
	  _react.default.useEffect(function () {
	    return function () {
	      clearTimeout(closeTimer.current);
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      clearTimeout(touchTimer.current);
	    };
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useEffect(function () {
	      if (isControlled !== (openProp != null)) {
	        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Tooltip to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Tooltip ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [openProp, isControlled]);
	  }
	
	  var handleOpen = function handleOpen(event) {
	    // The mouseover event will trigger for every nested element in the tooltip.
	    // We can skip rerendering when the tooltip is already open.
	    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
	    if (!isControlled && !openState) {
	      setOpenState(true);
	    }
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleEnter = function handleEnter(event) {
	    var childrenProps = children.props;
	
	    if (event.type === 'mouseover' && childrenProps.onMouseOver) {
	      childrenProps.onMouseOver(event);
	    }
	
	    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
	      return;
	    } // Remove the title ahead of time.
	    // We don't want to wait for the next render commit.
	    // We would risk displaying two tooltips at the same time (native + this one).
	
	
	    if (childNode) {
	      childNode.removeAttribute('title');
	    }
	
	    clearTimeout(enterTimer.current);
	    clearTimeout(leaveTimer.current);
	
	    if (enterDelay) {
	      event.persist();
	      enterTimer.current = setTimeout(function () {
	        handleOpen(event);
	      }, enterDelay);
	    } else {
	      handleOpen(event);
	    }
	  };
	
	  var _useIsFocusVisible = (0, _focusVisible.useIsFocusVisible)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState4 = _react.default.useState(false),
	      childIsFocusVisible = _React$useState4[0],
	      setChildIsFocusVisible = _React$useState4[1];
	
	  var handleBlur = function handleBlur() {
	    if (childIsFocusVisible) {
	      setChildIsFocusVisible(false);
	      onBlurVisible();
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    // Workaround for https://github.com/facebook/react/issues/7769
	    // The autoFocus of React might trigger the event before the componentDidMount.
	    // We need to account for this eventuality.
	    if (!childNode) {
	      setChildNode(event.currentTarget);
	    }
	
	    if (isFocusVisible(event)) {
	      setChildIsFocusVisible(true);
	      handleEnter(event);
	    }
	
	    var childrenProps = children.props;
	
	    if (childrenProps.onFocus) {
	      childrenProps.onFocus(event);
	    }
	  };
	
	  var handleClose = function handleClose(event) {
	    if (!isControlled) {
	      setOpenState(false);
	    }
	
	    if (onClose) {
	      onClose(event);
	    }
	
	    clearTimeout(closeTimer.current);
	    closeTimer.current = setTimeout(function () {
	      ignoreNonTouchEvents.current = false;
	    }, theme.transitions.duration.shortest);
	  };
	
	  var handleLeave = function handleLeave(event) {
	    var childrenProps = children.props;
	
	    if (event.type === 'blur') {
	      if (childrenProps.onBlur) {
	        childrenProps.onBlur(event);
	      }
	
	      handleBlur(event);
	    }
	
	    if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
	      childrenProps.onMouseLeave(event);
	    }
	
	    clearTimeout(enterTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveDelay);
	  };
	
	  var handleTouchStart = function handleTouchStart(event) {
	    ignoreNonTouchEvents.current = true;
	    var childrenProps = children.props;
	
	    if (childrenProps.onTouchStart) {
	      childrenProps.onTouchStart(event);
	    }
	
	    clearTimeout(leaveTimer.current);
	    clearTimeout(closeTimer.current);
	    clearTimeout(touchTimer.current);
	    event.persist();
	    touchTimer.current = setTimeout(function () {
	      handleEnter(event);
	    }, enterTouchDelay);
	  };
	
	  var handleTouchEnd = function handleTouchEnd(event) {
	    if (children.props.onTouchEnd) {
	      children.props.onTouchEnd(event);
	    }
	
	    clearTimeout(touchTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveTouchDelay);
	  };
	
	  var handleUseRef = (0, _reactHelpers.useForkRef)(setChildNode, ref);
	  var handleFocusRef = (0, _reactHelpers.useForkRef)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _reactHelpers.setRef)(handleFocusRef, _reactDom.default.findDOMNode(instance));
	  }, [handleFocusRef]);
	
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, handleOwnRef);
	  var open = isControlled ? openProp : openState; // There is no point in displaying an empty tooltip.
	
	  if (title === '') {
	    open = false;
	  } // For accessibility and SEO concerns, we render the title to the DOM node when
	  // the tooltip is hidden. However, we have made a tradeoff when
	  // `disableHoverListener` is set. This title logic is disabled.
	  // It's allowing us to keep the implementation size minimal.
	  // We are open to change the tradeoff.
	
	
	  var shouldShowNativeTitle = !open && !disableHoverListener;
	  var childrenProps = (0, _extends2.default)({
	    'aria-describedby': open ? id || defaultId.current : null,
	    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
	  }, other, {}, children.props, {
	    className: (0, _clsx.default)(other.className, children.props.className)
	  });
	
	  if (!disableTouchListener) {
	    childrenProps.onTouchStart = handleTouchStart;
	    childrenProps.onTouchEnd = handleTouchEnd;
	  }
	
	  if (!disableHoverListener) {
	    childrenProps.onMouseOver = handleEnter;
	    childrenProps.onMouseLeave = handleLeave;
	  }
	
	  if (!disableFocusListener) {
	    childrenProps.onFocus = handleFocus;
	    childrenProps.onBlur = handleLeave;
	  }
	
	  var interactiveWrapperListeners = interactive ? {
	    onMouseOver: childrenProps.onMouseOver,
	    onMouseLeave: childrenProps.onMouseLeave,
	    onFocus: childrenProps.onFocus,
	    onBlur: childrenProps.onBlur
	  } : {};
	
	  if (false) {
	    if (children.props.title) {
	      console.error(['Material-UI: you have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
	    }
	  }
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.cloneElement(children, (0, _extends2.default)({
	    ref: handleRef
	  }, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.popper, interactive && classes.popperInteractive),
	    placement: placement,
	    anchorEl: childNode,
	    open: childNode ? open : false,
	    id: childrenProps['aria-describedby'],
	    transition: true
	  }, interactiveWrapperListeners, PopperProps), function (_ref) {
	    var placementInner = _ref.placement,
	        TransitionPropsInner = _ref.TransitionProps;
	    return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	      timeout: theme.transitions.duration.shorter
	    }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
	      className: (0, _clsx.default)(classes.tooltip, classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch)
	    }, title));
	  }));
	});
	
	 false ? Tooltip.propTypes = {
	  /**
	   * Tooltip reference element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This prop won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
	   * This prop is used with aria-describedby to solve the accessibility issue.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Makes a tooltip interactive, i.e. will not close when the user
	   * hovers over the tooltip before the `leaveDelay` is expired.
	   */
	  interactive: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be open.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Props applied to the [`Popper`](/api/popper/) element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default.node.isRequired,
	
	  /**
	   * The component used for the transition.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip'
	})(Tooltip);
	
	exports.default = _default;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _helpers = __webpack_require__(11);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	
	var Typography = _react.default.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _helpers.capitalize)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _helpers.capitalize)(align))], display !== 'initial' && classes["display".concat((0, _helpers.capitalize)(display))]),
	    ref: ref
	  }, other));
	});
	
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * We are empirically mapping the variant prop to a range of different DOM element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(50);
	
	var _transitions = __webpack_require__(36);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(54);
	
	var _reactHelpers = __webpack_require__(13);
	
	var styles = {
	  entering: {
	    transform: 'none'
	  },
	  entered: {
	    transform: 'none'
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](/components/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = _react.default.forwardRef(function Zoom(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _reactHelpers.useForkRef)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        transform: 'scale(0)',
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	
	 false ? Zoom.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Zoom;
	exports.default = _default;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	
	var _Zoom = _interopRequireDefault(__webpack_require__(597));

/***/ },
/* 599 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ },
/* 600 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 601 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ },
/* 602 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ },
/* 603 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ },
/* 604 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ },
/* 605 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(217));
	
	var _red = _interopRequireDefault(__webpack_require__(91));
	
	var _pink = _interopRequireDefault(__webpack_require__(219));
	
	var _purple = _interopRequireDefault(__webpack_require__(611));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(605));
	
	var _indigo = _interopRequireDefault(__webpack_require__(218));
	
	var _blue = _interopRequireDefault(__webpack_require__(600));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(607));
	
	var _cyan = _interopRequireDefault(__webpack_require__(603));
	
	var _teal = _interopRequireDefault(__webpack_require__(612));
	
	var _green = _interopRequireDefault(__webpack_require__(71));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(608));
	
	var _lime = _interopRequireDefault(__webpack_require__(609));
	
	var _yellow = _interopRequireDefault(__webpack_require__(613));
	
	var _amber = _interopRequireDefault(__webpack_require__(599));
	
	var _orange = _interopRequireDefault(__webpack_require__(610));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(604));
	
	var _brown = _interopRequireDefault(__webpack_require__(602));
	
	var _grey = _interopRequireDefault(__webpack_require__(90));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(601));

/***/ },
/* 607 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ },
/* 608 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ },
/* 609 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ },
/* 610 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ },
/* 613 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ },
/* 614 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = animate;
	
	function easeInOutSin(time) {
	  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
	}
	
	function animate(property, element, to) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
	  var _options$ease = options.ease,
	      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 300 : _options$duration;
	  var start = null;
	  var from = element[property];
	  var cancelled = false;
	
	  var cancel = function cancel() {
	    cancelled = true;
	  };
	
	  var step = function step(timestamp) {
	    if (cancelled) {
	      cb(new Error('Animation cancelled'));
	      return;
	    }
	
	    if (start === null) {
	      start = timestamp;
	    }
	
	    var time = Math.min(1, (timestamp - start) / duration);
	    element[property] = ease(time) * (to - from) + from;
	
	    if (time >= 1) {
	      requestAnimationFrame(function () {
	        cb(null);
	      });
	      return;
	    }
	
	    requestAnimationFrame(step);
	  };
	
	  if (from === to) {
	    cb(new Error('Element already at target position'));
	    return cancel;
	  }
	
	  requestAnimationFrame(step);
	  return cancel;
	}

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(28));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 625 */
/***/ function(module, exports) {

	'use strict';
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	}
	
	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(34);
	
	/**
	 * @ignore - do not document.
	 */
	var _default = _styles.ThemeProvider;
	exports.default = _default;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(75));
	
	var _indigo = _interopRequireDefault(__webpack_require__(218));
	
	var _pink = _interopRequireDefault(__webpack_require__(219));
	
	var _grey = _interopRequireDefault(__webpack_require__(90));
	
	var _red = _interopRequireDefault(__webpack_require__(91));
	
	var _common = _interopRequireDefault(__webpack_require__(217));
	
	var _colorManipulator = __webpack_require__(24);
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.08)',
	    hoverOpacity: 0.08,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.14)',
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)'
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.1)',
	    hoverOpacity: 0.1,
	    selected: 'rgba(255, 255, 255, 0.2)',
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)'
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    if (false) {
	      if (!background) {
	        console.error("Material-UI: missing background argument in getContrastText(".concat(background, ")."));
	      }
	    }
	
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (process.env.NODE_ENV !== 'production') {
	        if (contrast < 3) {
	          console.error(["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	        }
	      }
	    }
	
	    return contrastText;
	  }
	
	  function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (false) {
	      if (!color.main) {
	        throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
	      }
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  }
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: the palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between the background and
	    // the text.
	    contrastThreshold: contrastThreshold,
	    // Take a background color and return the color of the text to maximize the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other, {
	    clone: false // No need to clone deep
	
	  });
	  return paletteOutput;
	}

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
	  // https://material.io/design/layout/understanding-layout.html#pixel-density
	
	
	  var transform;
	
	  if (typeof spacingInput === 'function') {
	    transform = spacingInput;
	  } else {
	    if (false) {
	      if (typeof spacingInput !== 'number') {
	        console.error(["Material-UI: the `theme.spacing` value (".concat(spacingInput, ") is invalid."), 'It should be a number or a function.'].join('\n'));
	      }
	    }
	
	    transform = function transform(factor) {
	      if (false) {
	        if (typeof factor !== 'number') {
	          console.error("Expected spacing argument to be a number, got ".concat(factor));
	        }
	      }
	
	      return spacingInput * factor;
	    };
	  }
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (factor) {
	      var output = transform(factor);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(34);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(75));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error("Material-UI: 'fontSize' is required to be a number.");
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error("Material-UI: 'htmlFontSize' is required to be a number.");
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, {}, casing, {}, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _deepmerge.default)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO To remove in v5?
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _convertCssLength = _interopRequireDefault(__webpack_require__(720));
	
	var _cssUtils = __webpack_require__(632);
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	}
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _convertCssLength.default)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!isUnitless(lineHeight) && !disableAlign) {
	      throw new Error(["Material-UI: unsupported non-unitless line height with grid alignment.", 'Use unitless line heights instead.'].join('\n'));
	    }
	
	    if (!isUnitless(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, {}, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 634 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	}
	
	var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 635 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(34);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(72));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testReset = testReset;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _styles = __webpack_require__(34);
	
	// This variable will be true once the server-side hydration is completed.
	var hydrationCompleted = false;
	
	function useMediaQuery(queryInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    theme: theme,
	    name: 'MuiUseMediaQuery',
	    props: {}
	  });
	
	  if (false) {
	    if (typeof queryInput === 'function' && theme === null) {
	      console.error(['Material-UI: the `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	    }
	  }
	
	  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
	  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
	  // All the browsers Material-UI support have this built-in.
	  // This defensive check is here for simplicity.
	  // Most of the time, the match media logic isn't central to people tests.
	
	  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
	
	  var _props$options = (0, _extends2.default)({}, props, {}, options),
	      _props$options$defaul = _props$options.defaultMatches,
	      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
	      _props$options$noSsr = _props$options.noSsr,
	      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
	      _props$options$ssrMat = _props$options.ssrMatchMedia,
	      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
	
	  var _React$useState = _react.default.useState(function () {
	    if ((hydrationCompleted || noSsr) && supportMatchMedia) {
	      return window.matchMedia(query).matches;
	    }
	
	    if (ssrMatchMedia) {
	      return ssrMatchMedia(query).matches;
	    } // Once the component is mounted, we rely on the
	    // event listeners to return the correct matches value.
	
	
	    return defaultMatches;
	  }),
	      match = _React$useState[0],
	      setMatch = _React$useState[1];
	
	  _react.default.useEffect(function () {
	    var active = true;
	    hydrationCompleted = true;
	
	    if (!supportMatchMedia) {
	      return undefined;
	    }
	
	    var queryList = window.matchMedia(query);
	
	    var updateMatch = function updateMatch() {
	      // Workaround Safari wrong implementation of matchMedia
	      // TODO can we remove it?
	      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
	      if (active) {
	        setMatch(queryList.matches);
	      }
	    };
	
	    updateMatch();
	    queryList.addListener(updateMatch);
	    return function () {
	      active = false;
	      queryList.removeListener(updateMatch);
	    };
	  }, [query, supportMatchMedia]);
	
	  return match;
	}
	
	function testReset() {
	  hydrationCompleted = false;
	}
	
	var _default = useMediaQuery;
	exports.default = _default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(639));

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useScrollTrigger;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function getScrollY(ref) {
	  return ref.pageYOffset !== undefined ? ref.pageYOffset : ref.scrollTop;
	}
	
	function defaultTrigger(event, store, options) {
	  var _options$disableHyste = options.disableHysteresis,
	      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
	      _options$threshold = options.threshold,
	      threshold = _options$threshold === void 0 ? 100 : _options$threshold;
	  var previous = store.current;
	  store.current = event ? getScrollY(event.currentTarget) : previous;
	
	  if (!disableHysteresis && previous !== undefined) {
	    if (store.current < previous) {
	      return false;
	    }
	  }
	
	  return store.current > threshold;
	}
	
	var defaultTarget = typeof window !== 'undefined' ? window : null;
	
	function useScrollTrigger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$getTrigger = options.getTrigger,
	      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
	      _options$target = options.target,
	      target = _options$target === void 0 ? defaultTarget : _options$target,
	      other = (0, _objectWithoutProperties2.default)(options, ["getTrigger", "target"]);
	
	  var store = _react.default.useRef();
	
	  var _React$useState = _react.default.useState(function () {
	    return getTrigger(null, store, other);
	  }),
	      trigger = _React$useState[0],
	      setTrigger = _React$useState[1];
	
	  _react.default.useEffect(function () {
	    var handleScroll = function handleScroll(event) {
	      setTrigger(getTrigger(event, store, other));
	    };
	
	    handleScroll(null); // Re-evaluate trigger when dependencies change
	
	    target.addEventListener('scroll', handleScroll);
	    return function () {
	      target.removeEventListener('scroll', handleScroll);
	    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [target, getTrigger, JSON.stringify(other)]);
	
	  return trigger;
	}

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}
	
	var _default = requirePropFactory;
	exports.default = _default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(642));

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(139));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server-side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	     false ? WithMobileDialog.propTypes = {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : void 0;
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _styles = __webpack_require__(34);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(57));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(16));
	
	var _createBreakpoints = __webpack_require__(223);
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(228));
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$noSSR = options.noSSR,
	        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
	        initialWidthOption = options.initialWidth;
	
	    function WithWidth(props) {
	      var contextTheme = (0, _useTheme.default)();
	      var theme = props.theme || contextTheme;
	
	      var _getThemeProps = (0, _styles.getThemeProps)({
	        theme: theme,
	        name: 'MuiWithWidth',
	        props: (0, _extends2.default)({}, props)
	      }),
	          initialWidth = _getThemeProps.initialWidth,
	          width = _getThemeProps.width,
	          other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "width"]);
	
	      var _React$useState = _react.default.useState(false),
	          mountedState = _React$useState[0],
	          setMountedState = _React$useState[1];
	
	      useEnhancedEffect(function () {
	        setMountedState(true);
	      }, []);
	      /**
	       * innerWidth |xs      sm      md      lg      xl
	       *            |-------|-------|-------|-------|------>
	       * width      |  xs   |  sm   |  md   |  lg   |  xl
	       */
	
	      var keys = (0, _toConsumableArray2.default)(theme.breakpoints.keys).reverse();
	      var widthComputed = keys.reduce(function (output, key) {
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
	        return !output && matches ? key : output;
	      }, null);
	      var more = (0, _extends2.default)({
	        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
	      }, withThemeOption ? {
	        theme: theme
	      } : {}, {}, other); // When rendering the component on the server,
	      // we have no idea about the client browser screen width.
	      // In order to prevent blinks and help the reconciliation of the React tree
	      // we are not rendering the child component.
	      //
	      // An alternative is to use the `initialWidth` property.
	
	      if (more.width === undefined) {
	        return null;
	      }
	
	      return _react.default.createElement(Component, more);
	    }
	
	     false ? WithWidth.propTypes = {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty component during the first mount.
	       * You might want to use an heuristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * https://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : void 0;
	
	    if (false) {
	      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return WithWidth;
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'CameraAlt');
	
	exports.default = _default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
	}), 'Dashboard');
	
	exports.default = _default;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
	}), 'Edit');
	
	exports.default = _default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'Error');
	
	exports.default = _default;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	}), 'FilterList');
	
	exports.default = _default;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
	}), 'List');
	
	exports.default = _default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'LocationOn');
	
	exports.default = _default;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(31));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
	  fill: "none"
	}, _react.default.createElement("path", {
	  d: "M0 0h24v24H0V0z"
	}), _react.default.createElement("path", {
	  d: "M0 0h24v24H0V0z",
	  opacity: ".87"
	})), _react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	})), 'LockOutlined');
	
	exports.default = _default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(81));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(48);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(141));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(142));
	
	var ServerStyleSheets =
	/*#__PURE__*/
	function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return _react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return _react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	var _default = ServerStyleSheets;
	exports.default = _default;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(654));

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(142));
	
	var _jss = __webpack_require__(48);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(235));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: you need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: you cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: you cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return _react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}
	
	var _default = StylesProvider;
	exports.default = _default;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(237));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(73));
	
	var _nested = _interopRequireDefault(__webpack_require__(232));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: you should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, {}, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: you are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return _react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(657));

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(232));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	  return function (rule, styleSheet) {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(ruleCounter);
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(ruleCounter);
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(ruleCounter); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 660 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(660));

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(61));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(75));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(233));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	// Support for the jss-expand plugin.
	function arrayMerge(destination, source) {
	  return source;
	}
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: the `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: the `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
	          arrayMerge: arrayMerge
	        });
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}
	
	var _default = getStylesCreator;
	exports.default = _default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(662));

/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}
	
	var _default = getThemeProps;
	exports.default = _default;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(740));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(735));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(737));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(733));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(734));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(741));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(739));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}
	
	var _default = jssPreset;
	exports.default = _default;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during at the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(48);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(236));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(668));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(73));
	
	var _StylesProvider = __webpack_require__(141);
	
	var _indexCounter = __webpack_require__(666);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(663));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(233));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, {}, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props).attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), {}, stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    return getClasses(instance.current, props.classes, Component);
	  };
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 668 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(10);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}
	
	var _default = mergeClasses;
	exports.default = _default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(671));

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(10);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(57));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(143));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = _react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return _react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children DOM element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a DOM element or a component.
	       */
	      component: _propTypes.default.elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(237));
	
	function useTheme() {
	  return _react.default.useContext(_ThemeContext.default);
	}

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(674));

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(57));
	
	var _utils = __webpack_require__(10);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(143));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(234));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(73));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = _react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]);
	      var classes = useStyles(props);
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(676));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(57));
	
	var _utils = __webpack_require__(10);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(73));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = _react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(33));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _merge = _interopRequireDefault(__webpack_require__(94));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	function css(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css))), {}, omit(props.css, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    css: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = css;
	exports.default = _default;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.4.3
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  css: true,
	  display: true,
	  flexbox: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "css", {
	  enumerable: true,
	  get: function get() {
	    return _css.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(677));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(144));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var _css = _interopRequireDefault(__webpack_require__(678));
	
	var _display = _interopRequireDefault(__webpack_require__(679));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(680));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(683));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(684));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(685));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(686));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireDefault(__webpack_require__(687));
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _typography = _interopRequireWildcard(__webpack_require__(688));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 682 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(182));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(238));
	
	var _breakpoints = __webpack_require__(144);
	
	var _merge = _interopRequireDefault(__webpack_require__(94));
	
	var _memoize = _interopRequireDefault(__webpack_require__(682));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function getTransformer(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["@material-ui/system: the value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["@material-ui/system: the `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string') {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = getTransformer(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(39));
	
	var _compose = _interopRequireDefault(__webpack_require__(43));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(145));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(26);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(145));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(61));
	
	var _reactIs = __webpack_require__(165);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 693 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.PropTypes.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 695 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	var bind = __webpack_require__(243);
	var Axios = __webpack_require__(698);
	var defaults = __webpack_require__(146);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(240);
	axios.CancelToken = __webpack_require__(697);
	axios.isCancel = __webpack_require__(241);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(711);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(240);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(146);
	var utils = __webpack_require__(32);
	var InterceptorManager = __webpack_require__(699);
	var dispatchRequest = __webpack_require__(700);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	var transformData = __webpack_require__(703);
	var isCancel = __webpack_require__(241);
	var defaults = __webpack_require__(146);
	var isAbsoluteURL = __webpack_require__(707);
	var combineURLs = __webpack_require__(705);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 701 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(242);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 707 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(32);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 711 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 712 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(714);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 714 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouter = __webpack_require__(112);
	
	var _actions = __webpack_require__(95);
	
	var _selectors = _interopRequireDefault(__webpack_require__(244));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var createConnectedRouter = function createConnectedRouter(structure) {
	  var _createSelectors = (0, _selectors.default)(structure),
	      getLocation = _createSelectors.getLocation;
	  /*
	   * ConnectedRouter listens to a history object passed from props.
	   * When history is changed, it dispatches action to redux store.
	   * Then, store will pass props to component to render.
	   * This creates uni-directional flow from history->store->router->components.
	   */
	
	
	  var ConnectedRouter =
	  /*#__PURE__*/
	  function (_PureComponent) {
	    _inherits(ConnectedRouter, _PureComponent);
	
	    function ConnectedRouter(props) {
	      var _this;
	
	      _classCallCheck(this, ConnectedRouter);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectedRouter).call(this, props));
	      var store = props.store,
	          history = props.history,
	          onLocationChanged = props.onLocationChanged;
	      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
	
	      _this.unsubscribe = store.subscribe(function () {
	        // Extract store's location
	        var _getLocation = getLocation(store.getState()),
	            pathnameInStore = _getLocation.pathname,
	            searchInStore = _getLocation.search,
	            hashInStore = _getLocation.hash; // Extract history's location
	
	
	        var _history$location = history.location,
	            pathnameInHistory = _history$location.pathname,
	            searchInHistory = _history$location.search,
	            hashInHistory = _history$location.hash; // If we do time travelling, the location in store is changed but location in history is not changed
	
	        if (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore) {
	          _this.inTimeTravelling = true; // Update history's location to match store's location
	
	          history.push({
	            pathname: pathnameInStore,
	            search: searchInStore,
	            hash: hashInStore
	          });
	        }
	      });
	
	      var handleLocationChange = function handleLocationChange(location, action) {
	        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        // Dispatch onLocationChanged except when we're in time travelling
	        if (!_this.inTimeTravelling) {
	          onLocationChanged(location, action, isFirstRendering);
	        } else {
	          _this.inTimeTravelling = false;
	        }
	      }; // Listen to history changes
	
	
	      _this.unlisten = history.listen(handleLocationChange); // Dispatch a location change action for the initial location.
	      // This makes it backward-compatible with react-router-redux.
	      // But, we add `isFirstRendering` to `true` to prevent double-rendering.
	
	      handleLocationChange(history.location, history.action, true);
	      return _this;
	    }
	
	    _createClass(ConnectedRouter, [{
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.unlisten();
	        this.unsubscribe();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            history = _this$props.history,
	            children = _this$props.children;
	        return _react.default.createElement(_reactRouter.Router, {
	          history: history
	        }, children);
	      }
	    }]);
	
	    return ConnectedRouter;
	  }(_react.PureComponent);
	
	  ConnectedRouter.propTypes = {
	    store: _propTypes.default.shape({
	      getState: _propTypes.default.func.isRequired,
	      subscribe: _propTypes.default.func.isRequired
	    }).isRequired,
	    history: _propTypes.default.shape({
	      action: _propTypes.default.string.isRequired,
	      listen: _propTypes.default.func.isRequired,
	      location: _propTypes.default.object.isRequired,
	      push: _propTypes.default.func.isRequired
	    }).isRequired,
	    basename: _propTypes.default.string,
	    children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
	    onLocationChanged: _propTypes.default.func.isRequired
	  };
	
	  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
	        return dispatch((0, _actions.onLocationChanged)(location, action, isFirstRendering));
	      }
	    };
	  };
	
	  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
	    var Context = props.context || _reactRedux.ReactReduxContext;
	
	    if (Context == null) {
	      throw 'Please upgrade to react-redux v6';
	    }
	
	    return _react.default.createElement(Context.Consumer, null, function (_ref) {
	      var store = _ref.store;
	      return _react.default.createElement(ConnectedRouter, _extends({
	        store: store
	      }, props));
	    });
	  };
	
	  ConnectedRouterWithContext.propTypes = {
	    context: _propTypes.default.object
	  };
	  return (0, _reactRedux.connect)(null, mapDispatchToProps)(ConnectedRouterWithContext);
	};
	
	var _default = createConnectedRouter;
	exports.default = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _actions = __webpack_require__(95);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	var routerMiddleware = function routerMiddleware(history) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        // eslint-disable-line no-unused-vars
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	};
	
	var _default = routerMiddleware;
	exports.default = _default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _actions = __webpack_require__(95);
	
	var createConnectRouter = function createConnectRouter(structure) {
	  var fromJS = structure.fromJS,
	      merge = structure.merge;
	
	  var createRouterReducer = function createRouterReducer(history) {
	    var initialRouterState = fromJS({
	      location: history.location,
	      action: history.action
	    });
	    /*
	    * This reducer will update the state with the most recent location history
	    * has transitioned to.
	    */
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          type = _ref.type,
	          payload = _ref.payload;
	
	      if (type === _actions.LOCATION_CHANGE) {
	        var location = payload.location,
	            action = payload.action,
	            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
	        // to prevent the double-rendering issue on initilization
	
	        return isFirstRendering ? state : merge(state, {
	          location: fromJS(location),
	          action: action
	        });
	      }
	
	      return state;
	    };
	  };
	
	  return createRouterReducer;
	};
	
	var _default = createConnectRouter;
	exports.default = _default;

/***/ },
/* 718 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* Code from github.com/erikras/redux-form by Erik Rasmussen */
	var getIn = function getIn(state, path) {
	  if (!state) {
	    return state;
	  }
	
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports.default = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getIn = _interopRequireDefault(__webpack_require__(718));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var structure = {
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  getIn: _getIn.default,
	  merge: function merge(state, payload) {
	    return _objectSpread({}, state, payload);
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports.default = _default;

/***/ },
/* 720 */
/***/ function(module, exports) {

	var e=function(e){return parseFloat(e)};module.exports=function(r){return null==r&&(r=r),function(n,t,i,l){null==i&&(i=r),null==l&&(l=i);var u=String(n).match(/[\d.\-\+]*\s*(.*)/)[1]||"";if(u===t)return n;var f=e(n);if("px"!==u)if("em"===u)f=e(n)*e(i);else if("rem"===u)f=e(n)*e(r);else{if("ex"!==u)return n;f=e(n)*e(i)*2}var a=f;if("px"!==t)if("em"===t)a=f/e(l);else if("rem"===t)a=f/e(r);else{if("ex"!==t)return n;a=f/e(l)/2}return parseFloat(a.toFixed(5))+t}};
	//# sourceMappingURL=index.js.map


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(245));
	var _toConsumableArray = _interopDefault(__webpack_require__(33));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var propMap = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	var propMap$1 = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	  // Support old flex spec from 2012.
	
	};
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap$1[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  return p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(723));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 723 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 724 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 725 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 726 */
725,
/* 727 */
725,
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bkg-white-logo-reg-vivescia.e8ffeace.svg";

/***/ },
/* 729 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(1006)),valueEqual=_interopDefault(__webpack_require__(1020));__webpack_require__(60);var invariant=_interopDefault(__webpack_require__(175));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 731 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(731));
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate(prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate(prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(48);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 *
	 * @type object
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var _key in obj) {
	    newObj[_key] = obj[_key];
	    newObj[_key.replace(regExp, replace)] = obj[_key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    }
	  } else if (typeof value === 'number') {
	    if (options[prop]) {
	      return "" + value + options[prop];
	    }
	
	    if (units[prop]) {
	      return typeof units[prop] === 'function' ? units[prop](value).toString() : "" + value + units[prop];
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(736));
	var jss = __webpack_require__(48);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.rules = void 0;
	    this.options = void 0;
	    this.key = void 0;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.rules.toString();
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.options = void 0;
	    this.rule = void 0;
	    this.isProcessed = false;
	    this.key = void 0;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 736 */
4,
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(738));
	var warning = _interopDefault(__webpack_require__(60));
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        rule = rule;
	        return rule.selector;
	      }
	
	       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, options) {
	    // Options has been already created, now we only increase index.
	    if (options) return _extends({}, options, {
	      index: options.index + 1
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	    return _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1
	    });
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        container.addRule(selector, style[prop], _extends({}, options, {
	          selector: selector
	        }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
	        // And flow doesn't know this will always be a StyleRule which has the addRule method
	        // $FlowFixMe
	        .addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 738 */
4,
/* 739 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(48);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      } // $FlowFixMe
	
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule;
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	      }
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var prop in fnValues) {
	          styleRule.prop(prop, fnValues[prop](data), options);
	        }
	      }
	    }
	  };
	}
	
	exports.default = functionPlugin;


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(721);
	var jss = __webpack_require__(48);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @api public
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      var value = style[prop];
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 742 */
426,
/* 743 */
82,
/* 744 */
4,
/* 745 */
414,
/* 746 */
169,
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49),
	    root = __webpack_require__(40);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(796),
	    hashDelete = __webpack_require__(797),
	    hashGet = __webpack_require__(798),
	    hashHas = __webpack_require__(799),
	    hashSet = __webpack_require__(800);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49),
	    root = __webpack_require__(40);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49),
	    root = __webpack_require__(40);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(150),
	    setCacheAdd = __webpack_require__(821),
	    setCacheHas = __webpack_require__(822);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(40);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49),
	    root = __webpack_require__(40);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 754 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(251),
	    isArguments = __webpack_require__(261),
	    isArray = __webpack_require__(41),
	    isBuffer = __webpack_require__(262),
	    isIndex = __webpack_require__(256),
	    isTypedArray = __webpack_require__(264);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 756 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 757 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(760),
	    createBaseEach = __webpack_require__(784);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(785);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(759),
	    keys = __webpack_require__(154);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(756),
	    isArray = __webpack_require__(41);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 762 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 763 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.inRange` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to check.
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 */
	function baseInRange(number, start, end) {
	  return number >= nativeMin(start, end) && number < nativeMax(start, end);
	}
	
	module.exports = baseInRange;


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(246),
	    equalArrays = __webpack_require__(254),
	    equalByTag = __webpack_require__(787),
	    equalObjects = __webpack_require__(788),
	    getTag = __webpack_require__(793),
	    isArray = __webpack_require__(41),
	    isBuffer = __webpack_require__(262),
	    isTypedArray = __webpack_require__(264);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(246),
	    baseIsEqual = __webpack_require__(249);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(263),
	    isMasked = __webpack_require__(802),
	    isObject = __webpack_require__(104),
	    toSource = __webpack_require__(259);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isLength = __webpack_require__(153),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(772),
	    baseMatchesProperty = __webpack_require__(773),
	    identity = __webpack_require__(102),
	    isArray = __webpack_require__(41),
	    property = __webpack_require__(839);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(803),
	    nativeKeys = __webpack_require__(816);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(758),
	    isArrayLike = __webpack_require__(103);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(766),
	    getMatchData = __webpack_require__(790),
	    matchesStrictComparable = __webpack_require__(258);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(249),
	    get = __webpack_require__(833),
	    hasIn = __webpack_require__(834),
	    isKey = __webpack_require__(152),
	    isStrictComparable = __webpack_require__(257),
	    matchesStrictComparable = __webpack_require__(258),
	    toKey = __webpack_require__(101);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(151),
	    baseIteratee = __webpack_require__(769),
	    baseMap = __webpack_require__(771),
	    baseSortBy = __webpack_require__(778),
	    baseUnary = __webpack_require__(252),
	    compareMultiple = __webpack_require__(782),
	    identity = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(248);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(102),
	    overRest = __webpack_require__(820),
	    setToString = __webpack_require__(824);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(832),
	    defineProperty = __webpack_require__(786),
	    identity = __webpack_require__(102);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 778 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(97),
	    arrayMap = __webpack_require__(151),
	    isArray = __webpack_require__(41),
	    isSymbol = __webpack_require__(77);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 780 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(77);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(781);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(40);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(103);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 785 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(49);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(97),
	    Uint8Array = __webpack_require__(752),
	    eq = __webpack_require__(260),
	    equalArrays = __webpack_require__(254),
	    mapToArray = __webpack_require__(814),
	    setToArray = __webpack_require__(823);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(789);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(761),
	    getSymbols = __webpack_require__(792),
	    keys = __webpack_require__(154);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(257),
	    keys = __webpack_require__(154);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(97);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(247),
	    stubArray = __webpack_require__(840);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(747),
	    Map = __webpack_require__(149),
	    Promise = __webpack_require__(749),
	    Set = __webpack_require__(750),
	    WeakMap = __webpack_require__(753),
	    baseGetTag = __webpack_require__(76),
	    toSource = __webpack_require__(259);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 794 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(253),
	    isArguments = __webpack_require__(261),
	    isArray = __webpack_require__(41),
	    isIndex = __webpack_require__(256),
	    isLength = __webpack_require__(153),
	    toKey = __webpack_require__(101);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(100);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 797 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(100);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(100);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(100);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 801 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(783);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 803 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 804 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(98);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(98);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(98);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(98);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(748),
	    ListCache = __webpack_require__(96),
	    Map = __webpack_require__(149);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(99);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(99);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(99);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(99);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 814 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(837);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(819);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(255);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ },
/* 818 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 819 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(754);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 821 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 822 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 823 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(777),
	    shortOut = __webpack_require__(825);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 825 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 827 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 828 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 829 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    Map = __webpack_require__(149),
	    MapCache = __webpack_require__(150);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(815);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 832 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(248);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(762),
	    hasPath = __webpack_require__(795);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var baseInRange = __webpack_require__(763),
	    toFinite = __webpack_require__(842),
	    toNumber = __webpack_require__(265);
	
	/**
	 * Checks if `n` is between `start` and up to, but not including, `end`. If
	 * `end` is not specified, it's set to `start` with `start` then set to `0`.
	 * If `start` is greater than `end` the params are swapped to support
	 * negative ranges.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.3.0
	 * @category Number
	 * @param {number} number The number to check.
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 * @see _.range, _.rangeRight
	 * @example
	 *
	 * _.inRange(3, 2, 4);
	 * // => true
	 *
	 * _.inRange(4, 8);
	 * // => true
	 *
	 * _.inRange(4, 2);
	 * // => false
	 *
	 * _.inRange(2, 2);
	 * // => false
	 *
	 * _.inRange(1.2, 2);
	 * // => true
	 *
	 * _.inRange(5.2, 4);
	 * // => false
	 *
	 * _.inRange(-3, -2, -6);
	 * // => true
	 */
	function inRange(number, start, end) {
	  start = toFinite(start);
	  if (end === undefined) {
	    end = start;
	    start = 0;
	  } else {
	    end = toFinite(end);
	  }
	  number = toNumber(number);
	  return baseInRange(number, start, end);
	}
	
	module.exports = inRange;


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(103),
	    isObjectLike = __webpack_require__(58);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(150);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(774),
	    isArray = __webpack_require__(41);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(250),
	    basePropertyDeep = __webpack_require__(775),
	    isKey = __webpack_require__(152),
	    toKey = __webpack_require__(101);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 840 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 841 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(265);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(779);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(247),
	    arrayMap = __webpack_require__(151),
	    baseProperty = __webpack_require__(250),
	    baseTimes = __webpack_require__(251),
	    isArrayLikeObject = __webpack_require__(836);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.zip` except that it accepts an array of grouped
	 * elements and creates an array regrouping the elements to their pre-zip
	 * configuration.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.2.0
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 *
	 * _.unzip(zipped);
	 * // => [['a', 'b'], [1, 2], [true, false]]
	 */
	function unzip(array) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var length = 0;
	  array = arrayFilter(array, function(group) {
	    if (isArrayLikeObject(group)) {
	      length = nativeMax(group.length, length);
	      return true;
	    }
	  });
	  return baseTimes(length, function(index) {
	    return arrayMap(array, baseProperty(index));
	  });
	}
	
	module.exports = unzip;


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(776),
	    unzip = __webpack_require__(844);
	
	/**
	 * Creates an array of grouped elements, the first of which contains the
	 * first elements of the given arrays, the second of which contains the
	 * second elements of the given arrays, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 */
	var zip = baseRest(unzip);
	
	module.exports = zip;


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 266,
		"./af.js": 266,
		"./ar": 273,
		"./ar-dz": 267,
		"./ar-dz.js": 267,
		"./ar-kw": 268,
		"./ar-kw.js": 268,
		"./ar-ly": 269,
		"./ar-ly.js": 269,
		"./ar-ma": 270,
		"./ar-ma.js": 270,
		"./ar-sa": 271,
		"./ar-sa.js": 271,
		"./ar-tn": 272,
		"./ar-tn.js": 272,
		"./ar.js": 273,
		"./az": 274,
		"./az.js": 274,
		"./be": 275,
		"./be.js": 275,
		"./bg": 276,
		"./bg.js": 276,
		"./bm": 277,
		"./bm.js": 277,
		"./bn": 278,
		"./bn.js": 278,
		"./bo": 279,
		"./bo.js": 279,
		"./br": 280,
		"./br.js": 280,
		"./bs": 281,
		"./bs.js": 281,
		"./ca": 282,
		"./ca.js": 282,
		"./cs": 283,
		"./cs.js": 283,
		"./cv": 284,
		"./cv.js": 284,
		"./cy": 285,
		"./cy.js": 285,
		"./da": 286,
		"./da.js": 286,
		"./de": 289,
		"./de-at": 287,
		"./de-at.js": 287,
		"./de-ch": 288,
		"./de-ch.js": 288,
		"./de.js": 289,
		"./dv": 290,
		"./dv.js": 290,
		"./el": 291,
		"./el.js": 291,
		"./en-SG": 292,
		"./en-SG.js": 292,
		"./en-au": 293,
		"./en-au.js": 293,
		"./en-ca": 294,
		"./en-ca.js": 294,
		"./en-gb": 295,
		"./en-gb.js": 295,
		"./en-ie": 296,
		"./en-ie.js": 296,
		"./en-il": 297,
		"./en-il.js": 297,
		"./en-nz": 298,
		"./en-nz.js": 298,
		"./eo": 299,
		"./eo.js": 299,
		"./es": 302,
		"./es-do": 300,
		"./es-do.js": 300,
		"./es-us": 301,
		"./es-us.js": 301,
		"./es.js": 302,
		"./et": 303,
		"./et.js": 303,
		"./eu": 304,
		"./eu.js": 304,
		"./fa": 305,
		"./fa.js": 305,
		"./fi": 306,
		"./fi.js": 306,
		"./fo": 307,
		"./fo.js": 307,
		"./fr": 310,
		"./fr-ca": 308,
		"./fr-ca.js": 308,
		"./fr-ch": 309,
		"./fr-ch.js": 309,
		"./fr.js": 310,
		"./fy": 311,
		"./fy.js": 311,
		"./ga": 312,
		"./ga.js": 312,
		"./gd": 313,
		"./gd.js": 313,
		"./gl": 314,
		"./gl.js": 314,
		"./gom-latn": 315,
		"./gom-latn.js": 315,
		"./gu": 316,
		"./gu.js": 316,
		"./he": 317,
		"./he.js": 317,
		"./hi": 318,
		"./hi.js": 318,
		"./hr": 319,
		"./hr.js": 319,
		"./hu": 320,
		"./hu.js": 320,
		"./hy-am": 321,
		"./hy-am.js": 321,
		"./id": 322,
		"./id.js": 322,
		"./is": 323,
		"./is.js": 323,
		"./it": 325,
		"./it-ch": 324,
		"./it-ch.js": 324,
		"./it.js": 325,
		"./ja": 326,
		"./ja.js": 326,
		"./jv": 327,
		"./jv.js": 327,
		"./ka": 328,
		"./ka.js": 328,
		"./kk": 329,
		"./kk.js": 329,
		"./km": 330,
		"./km.js": 330,
		"./kn": 331,
		"./kn.js": 331,
		"./ko": 332,
		"./ko.js": 332,
		"./ku": 333,
		"./ku.js": 333,
		"./ky": 334,
		"./ky.js": 334,
		"./lb": 335,
		"./lb.js": 335,
		"./lo": 336,
		"./lo.js": 336,
		"./lt": 337,
		"./lt.js": 337,
		"./lv": 338,
		"./lv.js": 338,
		"./me": 339,
		"./me.js": 339,
		"./mi": 340,
		"./mi.js": 340,
		"./mk": 341,
		"./mk.js": 341,
		"./ml": 342,
		"./ml.js": 342,
		"./mn": 343,
		"./mn.js": 343,
		"./mr": 344,
		"./mr.js": 344,
		"./ms": 346,
		"./ms-my": 345,
		"./ms-my.js": 345,
		"./ms.js": 346,
		"./mt": 347,
		"./mt.js": 347,
		"./my": 348,
		"./my.js": 348,
		"./nb": 349,
		"./nb.js": 349,
		"./ne": 350,
		"./ne.js": 350,
		"./nl": 352,
		"./nl-be": 351,
		"./nl-be.js": 351,
		"./nl.js": 352,
		"./nn": 353,
		"./nn.js": 353,
		"./pa-in": 354,
		"./pa-in.js": 354,
		"./pl": 355,
		"./pl.js": 355,
		"./pt": 357,
		"./pt-br": 356,
		"./pt-br.js": 356,
		"./pt.js": 357,
		"./ro": 358,
		"./ro.js": 358,
		"./ru": 359,
		"./ru.js": 359,
		"./sd": 360,
		"./sd.js": 360,
		"./se": 361,
		"./se.js": 361,
		"./si": 362,
		"./si.js": 362,
		"./sk": 363,
		"./sk.js": 363,
		"./sl": 364,
		"./sl.js": 364,
		"./sq": 365,
		"./sq.js": 365,
		"./sr": 367,
		"./sr-cyrl": 366,
		"./sr-cyrl.js": 366,
		"./sr.js": 367,
		"./ss": 368,
		"./ss.js": 368,
		"./sv": 369,
		"./sv.js": 369,
		"./sw": 370,
		"./sw.js": 370,
		"./ta": 371,
		"./ta.js": 371,
		"./te": 372,
		"./te.js": 372,
		"./tet": 373,
		"./tet.js": 373,
		"./tg": 374,
		"./tg.js": 374,
		"./th": 375,
		"./th.js": 375,
		"./tl-ph": 376,
		"./tl-ph.js": 376,
		"./tlh": 377,
		"./tlh.js": 377,
		"./tr": 378,
		"./tr.js": 378,
		"./tzl": 379,
		"./tzl.js": 379,
		"./tzm": 381,
		"./tzm-latn": 380,
		"./tzm-latn.js": 380,
		"./tzm.js": 381,
		"./ug-cn": 382,
		"./ug-cn.js": 382,
		"./uk": 383,
		"./uk.js": 383,
		"./ur": 384,
		"./ur.js": 384,
		"./uz": 386,
		"./uz-latn": 385,
		"./uz-latn.js": 385,
		"./uz.js": 386,
		"./vi": 387,
		"./vi.js": 387,
		"./x-pseudo": 388,
		"./x-pseudo.js": 388,
		"./yo": 389,
		"./yo.js": 389,
		"./zh-cn": 390,
		"./zh-cn.js": 390,
		"./zh-hk": 391,
		"./zh-hk.js": 391,
		"./zh-tw": 392,
		"./zh-tw.js": 392
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 846;


/***/ },
/* 847 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
	var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var cachedType;
	function _setScrollType(type) {
	    cachedType = type;
	}
	exports._setScrollType = _setScrollType;
	// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	function detectScrollType() {
	    if (cachedType) {
	        return cachedType;
	    }
	    if (!inDOM || !window.document.body) {
	        return 'indeterminate';
	    }
	    var dummy = window.document.createElement('div');
	    dummy.appendChild(document.createTextNode('ABCD'));
	    dummy.dir = 'rtl';
	    dummy.style.fontSize = '14px';
	    dummy.style.width = '4px';
	    dummy.style.height = '1px';
	    dummy.style.position = 'absolute';
	    dummy.style.top = '-1000px';
	    dummy.style.overflow = 'scroll';
	    document.body.appendChild(dummy);
	    cachedType = 'reverse';
	    if (dummy.scrollLeft > 0) {
	        cachedType = 'default';
	    }
	    else {
	        dummy.scrollLeft = 1;
	        if (dummy.scrollLeft === 0) {
	            cachedType = 'negative';
	        }
	    }
	    document.body.removeChild(dummy);
	    return cachedType;
	}
	exports.detectScrollType = detectScrollType;
	// Based on https://stackoverflow.com/a/24394376
	function getNormalizedScrollLeft(element, direction) {
	    var scrollLeft = element.scrollLeft;
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        return scrollLeft;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return Number.NaN;
	    }
	    switch (type) {
	        case 'negative':
	            return element.scrollWidth - element.clientWidth + scrollLeft;
	        case 'reverse':
	            return element.scrollWidth - element.clientWidth - scrollLeft;
	    }
	    return scrollLeft;
	}
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	function setNormalizedScrollLeft(element, scrollLeft, direction) {
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        element.scrollLeft = scrollLeft;
	        return;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return;
	    }
	    switch (type) {
	        case 'negative':
	            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
	            break;
	        case 'reverse':
	            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	            break;
	        default:
	            element.scrollLeft = scrollLeft;
	            break;
	    }
	}
	exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(849)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 849 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/**
	* plotly.js v1.51.3
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	* Licensed under the MIT license
	*/
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Plotly = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
	'use strict';
	
	var Lib = _dereq_('../src/lib');
	var rules = {
	    "X,X div": "direction:ltr;font-family:'Open Sans', verdana, arial, sans-serif;margin:0;padding:0;",
	    "X input,X button": "font-family:'Open Sans', verdana, arial, sans-serif;",
	    "X input:focus,X button:focus": "outline:none;",
	    "X a": "text-decoration:none;",
	    "X a:hover": "text-decoration:none;",
	    "X .crisp": "shape-rendering:crispEdges;",
	    "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
	    "X svg": "overflow:hidden;",
	    "X svg a": "fill:#447adb;",
	    "X svg a:hover": "fill:#3c6dc5;",
	    "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
	    "X .main-svg .draglayer": "pointer-events:all;",
	    "X .cursor-default": "cursor:default;",
	    "X .cursor-pointer": "cursor:pointer;",
	    "X .cursor-crosshair": "cursor:crosshair;",
	    "X .cursor-move": "cursor:move;",
	    "X .cursor-col-resize": "cursor:col-resize;",
	    "X .cursor-row-resize": "cursor:row-resize;",
	    "X .cursor-ns-resize": "cursor:ns-resize;",
	    "X .cursor-ew-resize": "cursor:ew-resize;",
	    "X .cursor-sw-resize": "cursor:sw-resize;",
	    "X .cursor-s-resize": "cursor:s-resize;",
	    "X .cursor-se-resize": "cursor:se-resize;",
	    "X .cursor-w-resize": "cursor:w-resize;",
	    "X .cursor-e-resize": "cursor:e-resize;",
	    "X .cursor-nw-resize": "cursor:nw-resize;",
	    "X .cursor-n-resize": "cursor:n-resize;",
	    "X .cursor-ne-resize": "cursor:ne-resize;",
	    "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
	    "X .modebar": "position:absolute;top:2px;right:2px;",
	    "X .ease-bg": "-webkit-transition:background-color 0.3s ease 0s;-moz-transition:background-color 0.3s ease 0s;-ms-transition:background-color 0.3s ease 0s;-o-transition:background-color 0.3s ease 0s;transition:background-color 0.3s ease 0s;",
	    "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity 0.3s ease 0s;-moz-transition:opacity 0.3s ease 0s;-ms-transition:opacity 0.3s ease 0s;-o-transition:opacity 0.3s ease 0s;transition:opacity 0.3s ease 0s;",
	    "X:hover .modebar--hover .modebar-group": "opacity:1;",
	    "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
	    "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
	    "X .modebar-btn svg": "position:relative;top:2px;",
	    "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
	    "X .modebar.vertical svg": "top:-1px;",
	    "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
	    "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
	    "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
	    "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
	    "X [data-title]:before": "content:'';position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;",
	    "X [data-title]:after": "content:attr(data-title);background:#69738a;color:white;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
	    "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
	    "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
	    "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
	    "X .select-outline-1": "stroke:white;",
	    "X .select-outline-2": "stroke:black;stroke-dasharray:2px 2px;",
	    Y: "font-family:'Open Sans';position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;",
	    "Y p": "margin:0;",
	    "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,0.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
	    "Y .notifier-close": "color:#fff;opacity:0.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
	    "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
	};
	
	for(var selector in rules) {
	    var fullSelector = selector.replace(/^,/,' ,')
	        .replace(/X/g, '.js-plotly-plot .plotly')
	        .replace(/Y/g, '.plotly-notifier');
	    Lib.addStyleRule(fullSelector, rules[selector]);
	}
	
	},{"../src/lib":716}],2:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/transforms/aggregate');
	
	},{"../src/transforms/aggregate":1294}],3:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/bar');
	
	},{"../src/traces/bar":863}],4:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/barpolar');
	
	},{"../src/traces/barpolar":875}],5:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/box');
	
	},{"../src/traces/box":885}],6:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/components/calendars');
	
	},{"../src/components/calendars":589}],7:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/candlestick');
	
	},{"../src/traces/candlestick":894}],8:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/carpet');
	
	},{"../src/traces/carpet":913}],9:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/choropleth');
	
	},{"../src/traces/choropleth":927}],10:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/choroplethmapbox');
	
	},{"../src/traces/choroplethmapbox":934}],11:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/cone');
	
	},{"../src/traces/cone":940}],12:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/contour');
	
	},{"../src/traces/contour":955}],13:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/contourcarpet');
	
	},{"../src/traces/contourcarpet":966}],14:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/core');
	
	},{"../src/core":694}],15:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/densitymapbox');
	
	},{"../src/traces/densitymapbox":974}],16:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/transforms/filter');
	
	},{"../src/transforms/filter":1295}],17:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/funnel');
	
	},{"../src/traces/funnel":984}],18:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/funnelarea');
	
	},{"../src/traces/funnelarea":993}],19:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/transforms/groupby');
	
	},{"../src/transforms/groupby":1296}],20:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/heatmap');
	
	},{"../src/traces/heatmap":1006}],21:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/heatmapgl');
	
	},{"../src/traces/heatmapgl":1015}],22:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/histogram');
	
	},{"../src/traces/histogram":1027}],23:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/histogram2d');
	
	},{"../src/traces/histogram2d":1033}],24:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/histogram2dcontour');
	
	},{"../src/traces/histogram2dcontour":1037}],25:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/image');
	
	},{"../src/traces/image":1044}],26:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Plotly = _dereq_('./core');
	
	// traces
	Plotly.register([
	    _dereq_('./bar'),
	    _dereq_('./box'),
	    _dereq_('./heatmap'),
	    _dereq_('./histogram'),
	    _dereq_('./histogram2d'),
	    _dereq_('./histogram2dcontour'),
	    _dereq_('./contour'),
	    _dereq_('./scatterternary'),
	    _dereq_('./violin'),
	    _dereq_('./funnel'),
	    _dereq_('./waterfall'),
	    _dereq_('./image'),
	
	    _dereq_('./pie'),
	    _dereq_('./sunburst'),
	    _dereq_('./treemap'),
	    _dereq_('./funnelarea'),
	
	    _dereq_('./scatter3d'),
	    _dereq_('./surface'),
	    _dereq_('./isosurface'),
	    _dereq_('./volume'),
	    _dereq_('./mesh3d'),
	    _dereq_('./cone'),
	    _dereq_('./streamtube'),
	
	    _dereq_('./scattergeo'),
	    _dereq_('./choropleth'),
	
	    _dereq_('./scattergl'),
	    _dereq_('./splom'),
	
	    _dereq_('./pointcloud'),
	    _dereq_('./heatmapgl'),
	
	    _dereq_('./parcoords'),
	
	    _dereq_('./parcats'),
	
	    _dereq_('./scattermapbox'),
	    _dereq_('./choroplethmapbox'),
	    _dereq_('./densitymapbox'),
	
	    _dereq_('./sankey'),
	    _dereq_('./indicator'),
	
	    _dereq_('./table'),
	
	    _dereq_('./carpet'),
	    _dereq_('./scattercarpet'),
	    _dereq_('./contourcarpet'),
	
	    _dereq_('./ohlc'),
	    _dereq_('./candlestick'),
	
	    _dereq_('./scatterpolar'),
	    _dereq_('./scatterpolargl'),
	    _dereq_('./barpolar')
	]);
	
	// transforms
	//
	// Please note that all *transform* methods are executed before
	// all *calcTransform* methods - which could possibly lead to
	// unexpected results when applying multiple transforms of different types
	// to a given trace.
	//
	// For more info, see:
	// https://github.com/plotly/plotly.js/pull/978#pullrequestreview-2403353
	//
	Plotly.register([
	    _dereq_('./aggregate'),
	    _dereq_('./filter'),
	    _dereq_('./groupby'),
	    _dereq_('./sort')
	]);
	
	// components
	Plotly.register([
	    _dereq_('./calendars')
	]);
	
	module.exports = Plotly;
	
	},{"./aggregate":2,"./bar":3,"./barpolar":4,"./box":5,"./calendars":6,"./candlestick":7,"./carpet":8,"./choropleth":9,"./choroplethmapbox":10,"./cone":11,"./contour":12,"./contourcarpet":13,"./core":14,"./densitymapbox":15,"./filter":16,"./funnel":17,"./funnelarea":18,"./groupby":19,"./heatmap":20,"./heatmapgl":21,"./histogram":22,"./histogram2d":23,"./histogram2dcontour":24,"./image":25,"./indicator":27,"./isosurface":28,"./mesh3d":29,"./ohlc":30,"./parcats":31,"./parcoords":32,"./pie":33,"./pointcloud":34,"./sankey":35,"./scatter3d":36,"./scattercarpet":37,"./scattergeo":38,"./scattergl":39,"./scattermapbox":40,"./scatterpolar":41,"./scatterpolargl":42,"./scatterternary":43,"./sort":44,"./splom":45,"./streamtube":46,"./sunburst":47,"./surface":48,"./table":49,"./treemap":50,"./violin":51,"./volume":52,"./waterfall":53}],27:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/indicator');
	
	},{"../src/traces/indicator":1052}],28:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/isosurface');
	
	},{"../src/traces/isosurface":1058}],29:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/mesh3d');
	
	},{"../src/traces/mesh3d":1063}],30:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/ohlc');
	
	},{"../src/traces/ohlc":1068}],31:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/parcats');
	
	},{"../src/traces/parcats":1077}],32:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/parcoords');
	
	},{"../src/traces/parcoords":1087}],33:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/pie');
	
	},{"../src/traces/pie":1098}],34:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/pointcloud');
	
	},{"../src/traces/pointcloud":1107}],35:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/sankey');
	
	},{"../src/traces/sankey":1113}],36:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scatter3d');
	
	},{"../src/traces/scatter3d":1150}],37:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scattercarpet');
	
	},{"../src/traces/scattercarpet":1157}],38:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scattergeo');
	
	},{"../src/traces/scattergeo":1165}],39:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scattergl');
	
	},{"../src/traces/scattergl":1177}],40:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scattermapbox');
	
	},{"../src/traces/scattermapbox":1187}],41:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scatterpolar');
	
	},{"../src/traces/scatterpolar":1195}],42:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scatterpolargl');
	
	},{"../src/traces/scatterpolargl":1202}],43:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/scatterternary');
	
	},{"../src/traces/scatterternary":1210}],44:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/transforms/sort');
	
	},{"../src/transforms/sort":1298}],45:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/splom');
	
	},{"../src/traces/splom":1219}],46:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/streamtube');
	
	},{"../src/traces/streamtube":1227}],47:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/sunburst');
	
	},{"../src/traces/sunburst":1235}],48:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/surface');
	
	},{"../src/traces/surface":1244}],49:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/table');
	
	},{"../src/traces/table":1252}],50:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/treemap');
	
	},{"../src/traces/treemap":1261}],51:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/violin');
	
	},{"../src/traces/violin":1273}],52:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/volume');
	
	},{"../src/traces/volume":1281}],53:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = _dereq_('../src/traces/waterfall');
	
	},{"../src/traces/waterfall":1289}],54:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createViewController
	
	var createTurntable = _dereq_('turntable-camera-controller')
	var createOrbit     = _dereq_('orbit-camera-controller')
	var createMatrix    = _dereq_('matrix-camera-controller')
	
	function ViewController(controllers, mode) {
	  this._controllerNames = Object.keys(controllers)
	  this._controllerList = this._controllerNames.map(function(n) {
	    return controllers[n]
	  })
	  this._mode   = mode
	  this._active = controllers[mode]
	  if(!this._active) {
	    this._mode   = 'turntable'
	    this._active = controllers.turntable
	  }
	  this.modes = this._controllerNames
	  this.computedMatrix = this._active.computedMatrix
	  this.computedEye    = this._active.computedEye
	  this.computedUp     = this._active.computedUp
	  this.computedCenter = this._active.computedCenter
	  this.computedRadius = this._active.computedRadius
	}
	
	var proto = ViewController.prototype
	
	var COMMON_METHODS = [
	  ['flush', 1],
	  ['idle', 1],
	  ['lookAt', 4],
	  ['rotate', 4],
	  ['pan', 4],
	  ['translate', 4],
	  ['setMatrix', 2],
	  ['setDistanceLimits', 2],
	  ['setDistance', 2]
	]
	
	COMMON_METHODS.forEach(function(method) {
	  var name = method[0]
	  var argNames = []
	  for(var i=0; i<method[1]; ++i) {
	    argNames.push('a'+i)
	  }
	  var code = 'var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].'+method[0]+'('+argNames.join()+')}'
	  proto[name] = Function.apply(null, argNames.concat(code))
	})
	
	proto.recalcMatrix = function(t) {
	  this._active.recalcMatrix(t)
	}
	
	proto.getDistance = function(t) {
	  return this._active.getDistance(t)
	}
	proto.getDistanceLimits = function(out) {
	  return this._active.getDistanceLimits(out)
	}
	
	proto.lastT = function() {
	  return this._active.lastT()
	}
	
	proto.setMode = function(mode) {
	  if(mode === this._mode) {
	    return
	  }
	  var idx = this._controllerNames.indexOf(mode)
	  if(idx < 0) {
	    return
	  }
	  var prev  = this._active
	  var next  = this._controllerList[idx]
	  var lastT = Math.max(prev.lastT(), next.lastT())
	
	  prev.recalcMatrix(lastT)
	  next.setMatrix(lastT, prev.computedMatrix)
	  
	  this._active = next
	  this._mode   = mode
	
	  //Update matrix properties
	  this.computedMatrix = this._active.computedMatrix
	  this.computedEye    = this._active.computedEye
	  this.computedUp     = this._active.computedUp
	  this.computedCenter = this._active.computedCenter
	  this.computedRadius = this._active.computedRadius
	}
	
	proto.getMode = function() {
	  return this._mode
	}
	
	function createViewController(options) {
	  options = options || {}
	
	  var eye       = options.eye    || [0,0,1]
	  var center    = options.center || [0,0,0]
	  var up        = options.up     || [0,1,0]
	  var limits    = options.distanceLimits || [0, Infinity]
	  var mode      = options.mode   || 'turntable'
	
	  var turntable = createTurntable()
	  var orbit     = createOrbit()
	  var matrix    = createMatrix()
	
	  turntable.setDistanceLimits(limits[0], limits[1])
	  turntable.lookAt(0, eye, center, up)
	  orbit.setDistanceLimits(limits[0], limits[1])
	  orbit.lookAt(0, eye, center, up)
	  matrix.setDistanceLimits(limits[0], limits[1])
	  matrix.lookAt(0, eye, center, up)
	
	  return new ViewController({
	    turntable: turntable,
	    orbit: orbit,
	    matrix: matrix
	  }, mode)
	}
	},{"matrix-camera-controller":434,"orbit-camera-controller":457,"turntable-camera-controller":540}],55:[function(_dereq_,module,exports){
	(function (global, factory) {
	  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-array'), _dereq_('d3-collection'), _dereq_('d3-shape'), _dereq_('elementary-circuits-directed-graph')) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape', 'elementary-circuits-directed-graph'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,null));
	}(this, (function (exports,d3Array,d3Collection,d3Shape,findCircuits) { 'use strict';
	
	  findCircuits = findCircuits && findCircuits.hasOwnProperty('default') ? findCircuits['default'] : findCircuits;
	
	  // For a given link, return the target node's depth
	  function targetDepth(d) {
	    return d.target.depth;
	  }
	
	  // The depth of a node when the nodeAlign (align) is set to 'left'
	  function left(node) {
	    return node.depth;
	  }
	
	  // The depth of a node when the nodeAlign (align) is set to 'right'
	  function right(node, n) {
	    return n - 1 - node.height;
	  }
	
	  // The depth of a node when the nodeAlign (align) is set to 'justify'
	  function justify(node, n) {
	    return node.sourceLinks.length ? node.depth : n - 1;
	  }
	
	  // The depth of a node when the nodeAlign (align) is set to 'center'
	  function center(node) {
	    return node.targetLinks.length ? node.depth : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1 : 0;
	  }
	
	  // returns a function, using the parameter given to the sankey setting
	  function constant(x) {
	    return function () {
	      return x;
	    };
	  }
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  /// https://github.com/tomshanley/d3-sankeyCircular-circular
	
	  // sort links' breadth (ie top to bottom in a column), based on their source nodes' breadths
	  function ascendingSourceBreadth(a, b) {
	    return ascendingBreadth(a.source, b.source) || a.index - b.index;
	  }
	
	  // sort links' breadth (ie top to bottom in a column), based on their target nodes' breadths
	  function ascendingTargetBreadth(a, b) {
	    return ascendingBreadth(a.target, b.target) || a.index - b.index;
	  }
	
	  // sort nodes' breadth (ie top to bottom in a column)
	  // if both nodes have circular links, or both don't have circular links, then sort by the top (y0) of the node
	  // else push nodes that have top circular links to the top, and nodes that have bottom circular links to the bottom
	  function ascendingBreadth(a, b) {
	    if (a.partOfCycle === b.partOfCycle) {
	      return a.y0 - b.y0;
	    } else {
	      if (a.circularLinkType === 'top' || b.circularLinkType === 'bottom') {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }
	
	  // return the value of a node or link
	  function value(d) {
	    return d.value;
	  }
	
	  // return the vertical center of a node
	  function nodeCenter(node) {
	    return (node.y0 + node.y1) / 2;
	  }
	
	  // return the vertical center of a link's source node
	  function linkSourceCenter(link) {
	    return nodeCenter(link.source);
	  }
	
	  // return the vertical center of a link's target node
	  function linkTargetCenter(link) {
	    return nodeCenter(link.target);
	  }
	
	  // Return the default value for ID for node, d.index
	  function defaultId(d) {
	    return d.index;
	  }
	
	  // Return the default object the graph's nodes, graph.nodes
	  function defaultNodes(graph) {
	    return graph.nodes;
	  }
	
	  // Return the default object the graph's nodes, graph.links
	  function defaultLinks(graph) {
	    return graph.links;
	  }
	
	  // Return the node from the collection that matches the provided ID, or throw an error if no match
	  function find(nodeById, id) {
	    var node = nodeById.get(id);
	    if (!node) throw new Error('missing: ' + id);
	    return node;
	  }
	
	  function getNodeID(node, id) {
	    return id(node);
	  }
	
	  // The main sankeyCircular functions
	
	  // Some constants for circular link calculations
	  var verticalMargin = 25;
	  var baseRadius = 10;
	  var scale = 0.3; //Possibly let user control this, although anything over 0.5 starts to get too cramped
	
	  function sankeyCircular () {
	    // Set the default values
	    var x0 = 0,
	        y0 = 0,
	        x1 = 1,
	        y1 = 1,
	        // extent
	    dx = 24,
	        // nodeWidth
	    py,
	        // nodePadding, for vertical postioning
	    id = defaultId,
	        align = justify,
	        nodes = defaultNodes,
	        links = defaultLinks,
	        iterations = 32,
	        circularLinkGap = 2,
	        paddingRatio,
	        sortNodes = null;
	
	    function sankeyCircular() {
	      var graph = {
	        nodes: nodes.apply(null, arguments),
	        links: links.apply(null, arguments)
	
	        // Process the graph's nodes and links, setting their positions
	
	        // 1.  Associate the nodes with their respective links, and vice versa
	      };computeNodeLinks(graph);
	
	      // 2.  Determine which links result in a circular path in the graph
	      identifyCircles(graph, id, sortNodes);
	
	      // 4. Calculate the nodes' values, based on the values of the incoming and outgoing links
	      computeNodeValues(graph);
	
	      // 5.  Calculate the nodes' depth based on the incoming and outgoing links
	      //     Sets the nodes':
	      //     - depth:  the depth in the graph
	      //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
	      //     - x0, x1: the x coordinates, as is relates to visual position from left to right
	      computeNodeDepths(graph);
	
	      // 3.  Determine how the circular links will be drawn,
	      //     either travelling back above the main chart ("top")
	      //     or below the main chart ("bottom")
	      selectCircularLinkTypes(graph, id);
	
	      // 6.  Calculate the nodes' and links' vertical position within their respective column
	      //     Also readjusts sankeyCircular size if circular links are needed, and node x's
	      computeNodeBreadths(graph, iterations, id);
	      computeLinkBreadths(graph);
	
	      // 7.  Sort links per node, based on the links' source/target nodes' breadths
	      // 8.  Adjust nodes that overlap links that span 2+ columns
	      var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
	      for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
	
	        sortSourceLinks(graph, y1, id);
	        sortTargetLinks(graph, y1, id);
	        resolveNodeLinkOverlaps(graph, y0, y1, id);
	        sortSourceLinks(graph, y1, id);
	        sortTargetLinks(graph, y1, id);
	      }
	
	      // 8.1  Adjust node and link positions back to fill height of chart area if compressed
	      fillHeight(graph, y0, y1);
	
	      // 9. Calculate visually appealling path for the circular paths, and create the "d" string
	      addCircularPathData(graph, circularLinkGap, y1, id);
	
	      return graph;
	    } // end of sankeyCircular function
	
	
	    // Set the sankeyCircular parameters
	    // nodeID, nodeAlign, nodeWidth, nodePadding, nodes, links, size, extent, iterations, nodePaddingRatio, circularLinkGap
	    sankeyCircular.nodeId = function (_) {
	      return arguments.length ? (id = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : id;
	    };
	
	    sankeyCircular.nodeAlign = function (_) {
	      return arguments.length ? (align = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : align;
	    };
	
	    sankeyCircular.nodeWidth = function (_) {
	      return arguments.length ? (dx = +_, sankeyCircular) : dx;
	    };
	
	    sankeyCircular.nodePadding = function (_) {
	      return arguments.length ? (py = +_, sankeyCircular) : py;
	    };
	
	    sankeyCircular.nodes = function (_) {
	      return arguments.length ? (nodes = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : nodes;
	    };
	
	    sankeyCircular.links = function (_) {
	      return arguments.length ? (links = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : links;
	    };
	
	    sankeyCircular.size = function (_) {
	      return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular) : [x1 - x0, y1 - y0];
	    };
	
	    sankeyCircular.extent = function (_) {
	      return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular) : [[x0, y0], [x1, y1]];
	    };
	
	    sankeyCircular.iterations = function (_) {
	      return arguments.length ? (iterations = +_, sankeyCircular) : iterations;
	    };
	
	    sankeyCircular.circularLinkGap = function (_) {
	      return arguments.length ? (circularLinkGap = +_, sankeyCircular) : circularLinkGap;
	    };
	
	    sankeyCircular.nodePaddingRatio = function (_) {
	      return arguments.length ? (paddingRatio = +_, sankeyCircular) : paddingRatio;
	    };
	
	    sankeyCircular.sortNodes = function (_) {
	      return arguments.length ? (sortNodes = _, sankeyCircular) : sortNodes;
	    };
	
	    sankeyCircular.update = function (graph) {
	      // 5.  Calculate the nodes' depth based on the incoming and outgoing links
	      //     Sets the nodes':
	      //     - depth:  the depth in the graph
	      //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
	      //     - x0, x1: the x coordinates, as is relates to visual position from left to right
	      // computeNodeDepths(graph)
	
	      // 3.  Determine how the circular links will be drawn,
	      //     either travelling back above the main chart ("top")
	      //     or below the main chart ("bottom")
	      selectCircularLinkTypes(graph, id);
	
	      // 6.  Calculate the nodes' and links' vertical position within their respective column
	      //     Also readjusts sankeyCircular size if circular links are needed, and node x's
	      // computeNodeBreadths(graph, iterations, id)
	      computeLinkBreadths(graph);
	
	      // Force position of circular link type based on position
	      graph.links.forEach(function (link) {
	        if (link.circular) {
	          link.circularLinkType = link.y0 + link.y1 < y1 ? 'top' : 'bottom';
	
	          link.source.circularLinkType = link.circularLinkType;
	          link.target.circularLinkType = link.circularLinkType;
	        }
	      });
	
	      sortSourceLinks(graph, y1, id, false); // Sort links but do not move nodes
	      sortTargetLinks(graph, y1, id);
	
	      // 7.  Sort links per node, based on the links' source/target nodes' breadths
	      // 8.  Adjust nodes that overlap links that span 2+ columns
	      // var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
	      // for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
	      //
	      //   sortSourceLinks(graph, y1, id)
	      //   sortTargetLinks(graph, y1, id)
	      //   resolveNodeLinkOverlaps(graph, y0, y1, id)
	      //   sortSourceLinks(graph, y1, id)
	      //   sortTargetLinks(graph, y1, id)
	      //
	      // }
	
	      // 8.1  Adjust node and link positions back to fill height of chart area if compressed
	      // fillHeight(graph, y0, y1)
	
	      // 9. Calculate visually appealling path for the circular paths, and create the "d" string
	      addCircularPathData(graph, circularLinkGap, y1, id);
	      return graph;
	    };
	
	    // Populate the sourceLinks and targetLinks for each node.
	    // Also, if the source and target are not objects, assume they are indices.
	    function computeNodeLinks(graph) {
	      graph.nodes.forEach(function (node, i) {
	        node.index = i;
	        node.sourceLinks = [];
	        node.targetLinks = [];
	      });
	      var nodeById = d3Collection.map(graph.nodes, id);
	      graph.links.forEach(function (link, i) {
	        link.index = i;
	        var source = link.source;
	        var target = link.target;
	        if ((typeof source === "undefined" ? "undefined" : _typeof(source)) !== 'object') {
	          source = link.source = find(nodeById, source);
	        }
	        if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== 'object') {
	          target = link.target = find(nodeById, target);
	        }
	        source.sourceLinks.push(link);
	        target.targetLinks.push(link);
	      });
	      return graph;
	    }
	
	    // Compute the value (size) and cycleness of each node by summing the associated links.
	    function computeNodeValues(graph) {
	      graph.nodes.forEach(function (node) {
	        node.partOfCycle = false;
	        node.value = Math.max(d3Array.sum(node.sourceLinks, value), d3Array.sum(node.targetLinks, value));
	        node.sourceLinks.forEach(function (link) {
	          if (link.circular) {
	            node.partOfCycle = true;
	            node.circularLinkType = link.circularLinkType;
	          }
	        });
	        node.targetLinks.forEach(function (link) {
	          if (link.circular) {
	            node.partOfCycle = true;
	            node.circularLinkType = link.circularLinkType;
	          }
	        });
	      });
	    }
	
	    function getCircleMargins(graph) {
	      var totalTopLinksWidth = 0,
	          totalBottomLinksWidth = 0,
	          totalRightLinksWidth = 0,
	          totalLeftLinksWidth = 0;
	
	      var maxColumn = d3Array.max(graph.nodes, function (node) {
	        return node.column;
	      });
	
	      graph.links.forEach(function (link) {
	        if (link.circular) {
	          if (link.circularLinkType == 'top') {
	            totalTopLinksWidth = totalTopLinksWidth + link.width;
	          } else {
	            totalBottomLinksWidth = totalBottomLinksWidth + link.width;
	          }
	
	          if (link.target.column == 0) {
	            totalLeftLinksWidth = totalLeftLinksWidth + link.width;
	          }
	
	          if (link.source.column == maxColumn) {
	            totalRightLinksWidth = totalRightLinksWidth + link.width;
	          }
	        }
	      });
	
	      //account for radius of curves and padding between links
	      totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
	      totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
	      totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
	      totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;
	
	      return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
	    }
	
	    // Update the x0, y0, x1 and y1 for the sankeyCircular, to allow space for any circular links
	    function scaleSankeySize(graph, margin) {
	
	      var maxColumn = d3Array.max(graph.nodes, function (node) {
	        return node.column;
	      });
	
	      var currentWidth = x1 - x0;
	      var currentHeight = y1 - y0;
	
	      var newWidth = currentWidth + margin.right + margin.left;
	      var newHeight = currentHeight + margin.top + margin.bottom;
	
	      var scaleX = currentWidth / newWidth;
	      var scaleY = currentHeight / newHeight;
	
	      x0 = x0 * scaleX + margin.left;
	      x1 = margin.right == 0 ? x1 : x1 * scaleX;
	      y0 = y0 * scaleY + margin.top;
	      y1 = y1 * scaleY;
	
	      graph.nodes.forEach(function (node) {
	        node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
	        node.x1 = node.x0 + dx;
	      });
	
	      return scaleY;
	    }
	
	    // Iteratively assign the depth for each node.
	    // Nodes are assigned the maximum depth of incoming neighbors plus one;
	    // nodes with no incoming links are assigned depth zero, while
	    // nodes with no outgoing links are assigned the maximum depth.
	    function computeNodeDepths(graph) {
	      var nodes, next, x;
	
	      for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	        nodes.forEach(function (node) {
	          node.depth = x;
	          node.sourceLinks.forEach(function (link) {
	            if (next.indexOf(link.target) < 0 && !link.circular) {
	              next.push(link.target);
	            }
	          });
	        });
	      }
	
	      for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	        nodes.forEach(function (node) {
	          node.height = x;
	          node.targetLinks.forEach(function (link) {
	            if (next.indexOf(link.source) < 0 && !link.circular) {
	              next.push(link.source);
	            }
	          });
	        });
	      }
	
	      // assign column numbers, and get max value
	      graph.nodes.forEach(function (node) {
	        node.column = Math.floor(align.call(null, node, x));
	      });
	    }
	
	    // Assign nodes' breadths, and then shift nodes that overlap (resolveCollisions)
	    function computeNodeBreadths(graph, iterations, id) {
	      var columns = d3Collection.nest().key(function (d) {
	        return d.column;
	      }).sortKeys(d3Array.ascending).entries(graph.nodes).map(function (d) {
	        return d.values;
	      });
	
	      initializeNodeBreadth(id);
	      resolveCollisions();
	
	      for (var alpha = 1, n = iterations; n > 0; --n) {
	        relaxLeftAndRight(alpha *= 0.99, id);
	        resolveCollisions();
	      }
	
	      function initializeNodeBreadth(id) {
	
	        //override py if nodePadding has been set
	        if (paddingRatio) {
	          var padding = Infinity;
	          columns.forEach(function (nodes) {
	            var thisPadding = y1 * paddingRatio / (nodes.length + 1);
	            padding = thisPadding < padding ? thisPadding : padding;
	          });
	          py = padding;
	        }
	
	        var ky = d3Array.min(columns, function (nodes) {
	          return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
	        });
	
	        //calculate the widths of the links
	        ky = ky * scale;
	
	        graph.links.forEach(function (link) {
	          link.width = link.value * ky;
	        });
	
	        //determine how much to scale down the chart, based on circular links
	        var margin = getCircleMargins(graph);
	        var ratio = scaleSankeySize(graph, margin);
	
	        //re-calculate widths
	        ky = ky * ratio;
	
	        graph.links.forEach(function (link) {
	          link.width = link.value * ky;
	        });
	
	        columns.forEach(function (nodes) {
	          var nodesLength = nodes.length;
	          nodes.forEach(function (node, i) {
	            if (node.depth == columns.length - 1 && nodesLength == 1) {
	              node.y0 = y1 / 2 - node.value * ky;
	              node.y1 = node.y0 + node.value * ky;
	            } else if (node.depth == 0 && nodesLength == 1) {
	              node.y0 = y1 / 2 - node.value * ky;
	              node.y1 = node.y0 + node.value * ky;
	            } else if (node.partOfCycle) {
	              if (numberOfNonSelfLinkingCycles(node, id) == 0) {
	                node.y0 = y1 / 2 + i;
	                node.y1 = node.y0 + node.value * ky;
	              } else if (node.circularLinkType == 'top') {
	                node.y0 = y0 + i;
	                node.y1 = node.y0 + node.value * ky;
	              } else {
	                node.y0 = y1 - node.value * ky - i;
	                node.y1 = node.y0 + node.value * ky;
	              }
	            } else {
	              if (margin.top == 0 || margin.bottom == 0) {
	                node.y0 = (y1 - y0) / nodesLength * i;
	                node.y1 = node.y0 + node.value * ky;
	              } else {
	                node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
	                node.y1 = node.y0 + node.value * ky;
	              }
	            }
	          });
	        });
	      }
	
	      // For each node in each column, check the node's vertical position in relation to its targets and sources vertical position
	      // and shift up/down to be closer to the vertical middle of those targets and sources
	      function relaxLeftAndRight(alpha, id) {
	        var columnsLength = columns.length;
	
	        columns.forEach(function (nodes) {
	          var n = nodes.length;
	          var depth = nodes[0].depth;
	
	          nodes.forEach(function (node) {
	            // check the node is not an orphan
	            var nodeHeight;
	            if (node.sourceLinks.length || node.targetLinks.length) {
	              if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id) > 0) ; else if (depth == 0 && n == 1) {
	                nodeHeight = node.y1 - node.y0;
	
	                node.y0 = y1 / 2 - nodeHeight / 2;
	                node.y1 = y1 / 2 + nodeHeight / 2;
	              } else if (depth == columnsLength - 1 && n == 1) {
	                nodeHeight = node.y1 - node.y0;
	
	                node.y0 = y1 / 2 - nodeHeight / 2;
	                node.y1 = y1 / 2 + nodeHeight / 2;
	              } else {
	                var avg = 0;
	
	                var avgTargetY = d3Array.mean(node.sourceLinks, linkTargetCenter);
	                var avgSourceY = d3Array.mean(node.targetLinks, linkSourceCenter);
	
	                if (avgTargetY && avgSourceY) {
	                  avg = (avgTargetY + avgSourceY) / 2;
	                } else {
	                  avg = avgTargetY || avgSourceY;
	                }
	
	                var dy = (avg - nodeCenter(node)) * alpha;
	                // positive if it node needs to move down
	                node.y0 += dy;
	                node.y1 += dy;
	              }
	            }
	          });
	        });
	      }
	
	      // For each column, check if nodes are overlapping, and if so, shift up/down
	      function resolveCollisions() {
	        columns.forEach(function (nodes) {
	          var node,
	              dy,
	              y = y0,
	              n = nodes.length,
	              i;
	
	          // Push any overlapping nodes down.
	          nodes.sort(ascendingBreadth);
	
	          for (i = 0; i < n; ++i) {
	            node = nodes[i];
	            dy = y - node.y0;
	
	            if (dy > 0) {
	              node.y0 += dy;
	              node.y1 += dy;
	            }
	            y = node.y1 + py;
	          }
	
	          // If the bottommost node goes outside the bounds, push it back up.
	          dy = y - py - y1;
	          if (dy > 0) {
	            y = node.y0 -= dy, node.y1 -= dy;
	
	            // Push any overlapping nodes back up.
	            for (i = n - 2; i >= 0; --i) {
	              node = nodes[i];
	              dy = node.y1 + py - y;
	              if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	              y = node.y0;
	            }
	          }
	        });
	      }
	    }
	
	    // Assign the links y0 and y1 based on source/target nodes position,
	    // plus the link's relative position to other links to the same node
	    function computeLinkBreadths(graph) {
	      graph.nodes.forEach(function (node) {
	        node.sourceLinks.sort(ascendingTargetBreadth);
	        node.targetLinks.sort(ascendingSourceBreadth);
	      });
	      graph.nodes.forEach(function (node) {
	        var y0 = node.y0;
	        var y1 = y0;
	
	        // start from the bottom of the node for cycle links
	        var y0cycle = node.y1;
	        var y1cycle = y0cycle;
	
	        node.sourceLinks.forEach(function (link) {
	          if (link.circular) {
	            link.y0 = y0cycle - link.width / 2;
	            y0cycle = y0cycle - link.width;
	          } else {
	            link.y0 = y0 + link.width / 2;
	            y0 += link.width;
	          }
	        });
	        node.targetLinks.forEach(function (link) {
	          if (link.circular) {
	            link.y1 = y1cycle - link.width / 2;
	            y1cycle = y1cycle - link.width;
	          } else {
	            link.y1 = y1 + link.width / 2;
	            y1 += link.width;
	          }
	        });
	      });
	    }
	
	    return sankeyCircular;
	  }
	
	  /// /////////////////////////////////////////////////////////////////////////////////
	  // Cycle functions
	  // portion of code to detect circular links based on Colin Fergus' bl.ock https://gist.github.com/cfergus/3956043
	
	  // Identify circles in the link objects
	  function identifyCircles(graph, id, sortNodes) {
	    var circularLinkID = 0;
	    if (sortNodes === null) {
	
	      // Building adjacency graph
	      var adjList = [];
	      for (var i = 0; i < graph.links.length; i++) {
	        var link = graph.links[i];
	        var source = link.source.index;
	        var target = link.target.index;
	        if (!adjList[source]) adjList[source] = [];
	        if (!adjList[target]) adjList[target] = [];
	
	        // Add links if not already in set
	        if (adjList[source].indexOf(target) === -1) adjList[source].push(target);
	      }
	
	      // Find all elementary circuits
	      var cycles = findCircuits(adjList);
	
	      // Sort by circuits length
	      cycles.sort(function (a, b) {
	        return a.length - b.length;
	      });
	
	      var circularLinks = {};
	      for (i = 0; i < cycles.length; i++) {
	        var cycle = cycles[i];
	        var last = cycle.slice(-2);
	        if (!circularLinks[last[0]]) circularLinks[last[0]] = {};
	        circularLinks[last[0]][last[1]] = true;
	      }
	
	      graph.links.forEach(function (link) {
	        var target = link.target.index;
	        var source = link.source.index;
	        // If self-linking or a back-edge
	        if (target === source || circularLinks[source] && circularLinks[source][target]) {
	          link.circular = true;
	          link.circularLinkID = circularLinkID;
	          circularLinkID = circularLinkID + 1;
	        } else {
	          link.circular = false;
	        }
	      });
	    } else {
	      graph.links.forEach(function (link) {
	        if (link.source[sortNodes] < link.target[sortNodes]) {
	          link.circular = false;
	        } else {
	          link.circular = true;
	          link.circularLinkID = circularLinkID;
	          circularLinkID = circularLinkID + 1;
	        }
	      });
	    }
	  }
	
	  // Assign a circular link type (top or bottom), based on:
	  // - if the source/target node already has circular links, then use the same type
	  // - if not, choose the type with fewer links
	  function selectCircularLinkTypes(graph, id) {
	    var numberOfTops = 0;
	    var numberOfBottoms = 0;
	    graph.links.forEach(function (link) {
	      if (link.circular) {
	        // if either souce or target has type already use that
	        if (link.source.circularLinkType || link.target.circularLinkType) {
	          // default to source type if available
	          link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
	        } else {
	          link.circularLinkType = numberOfTops < numberOfBottoms ? 'top' : 'bottom';
	        }
	
	        if (link.circularLinkType == 'top') {
	          numberOfTops = numberOfTops + 1;
	        } else {
	          numberOfBottoms = numberOfBottoms + 1;
	        }
	
	        graph.nodes.forEach(function (node) {
	          if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
	            node.circularLinkType = link.circularLinkType;
	          }
	        });
	      }
	    });
	
	    //correct self-linking links to be same direction as node
	    graph.links.forEach(function (link) {
	      if (link.circular) {
	        //if both source and target node are same type, then link should have same type
	        if (link.source.circularLinkType == link.target.circularLinkType) {
	          link.circularLinkType = link.source.circularLinkType;
	        }
	        //if link is selflinking, then link should have same type as node
	        if (selfLinking(link, id)) {
	          link.circularLinkType = link.source.circularLinkType;
	        }
	      }
	    });
	  }
	
	  // Return the angle between a straight line between the source and target of the link, and the vertical plane of the node
	  function linkAngle(link) {
	    var adjacent = Math.abs(link.y1 - link.y0);
	    var opposite = Math.abs(link.target.x0 - link.source.x1);
	
	    return Math.atan(opposite / adjacent);
	  }
	
	  // Check if two circular links potentially overlap
	  function circularLinksCross(link1, link2) {
	    if (link1.source.column < link2.target.column) {
	      return false;
	    } else if (link1.target.column > link2.source.column) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	
	  // Return the number of circular links for node, not including self linking links
	  function numberOfNonSelfLinkingCycles(node, id) {
	    var sourceCount = 0;
	    node.sourceLinks.forEach(function (l) {
	      sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
	    });
	
	    var targetCount = 0;
	    node.targetLinks.forEach(function (l) {
	      targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
	    });
	
	    return sourceCount + targetCount;
	  }
	
	  // Check if a circular link is the only circular link for both its source and target node
	  function onlyCircularLink(link) {
	    var nodeSourceLinks = link.source.sourceLinks;
	    var sourceCount = 0;
	    nodeSourceLinks.forEach(function (l) {
	      sourceCount = l.circular ? sourceCount + 1 : sourceCount;
	    });
	
	    var nodeTargetLinks = link.target.targetLinks;
	    var targetCount = 0;
	    nodeTargetLinks.forEach(function (l) {
	      targetCount = l.circular ? targetCount + 1 : targetCount;
	    });
	
	    if (sourceCount > 1 || targetCount > 1) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	
	  // creates vertical buffer values per set of top/bottom links
	  function calcVerticalBuffer(links, circularLinkGap, id) {
	    links.sort(sortLinkColumnAscending);
	    links.forEach(function (link, i) {
	      var buffer = 0;
	
	      if (selfLinking(link, id) && onlyCircularLink(link)) {
	        link.circularPathData.verticalBuffer = buffer + link.width / 2;
	      } else {
	        var j = 0;
	        for (j; j < i; j++) {
	          if (circularLinksCross(links[i], links[j])) {
	            var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
	            buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
	          }
	        }
	
	        link.circularPathData.verticalBuffer = buffer + link.width / 2;
	      }
	    });
	
	    return links;
	  }
	
	  // calculate the optimum path for a link to reduce overlaps
	  function addCircularPathData(graph, circularLinkGap, y1, id) {
	    //var baseRadius = 10
	    var buffer = 5;
	    //var verticalMargin = 25
	
	    var minY = d3Array.min(graph.links, function (link) {
	      return link.source.y0;
	    });
	
	    // create object for circular Path Data
	    graph.links.forEach(function (link) {
	      if (link.circular) {
	        link.circularPathData = {};
	      }
	    });
	
	    // calc vertical offsets per top/bottom links
	    var topLinks = graph.links.filter(function (l) {
	      return l.circularLinkType == 'top';
	    });
	    /* topLinks = */calcVerticalBuffer(topLinks, circularLinkGap, id);
	
	    var bottomLinks = graph.links.filter(function (l) {
	      return l.circularLinkType == 'bottom';
	    });
	    /* bottomLinks = */calcVerticalBuffer(bottomLinks, circularLinkGap, id);
	
	    // add the base data for each link
	    graph.links.forEach(function (link) {
	      if (link.circular) {
	        link.circularPathData.arcRadius = link.width + baseRadius;
	        link.circularPathData.leftNodeBuffer = buffer;
	        link.circularPathData.rightNodeBuffer = buffer;
	        link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
	        link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
	        link.circularPathData.targetX = link.target.x0;
	        link.circularPathData.sourceY = link.y0;
	        link.circularPathData.targetY = link.y1;
	
	        // for self linking paths, and that the only circular link in/out of that node
	        if (selfLinking(link, id) && onlyCircularLink(link)) {
	          link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
	          link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
	          link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
	          link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;
	
	          if (link.circularLinkType == 'bottom') {
	            link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
	            link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
	            link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
	          } else {
	            // top links
	            link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
	            link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
	            link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
	          }
	        } else {
	          // else calculate normally
	          // add left extent coordinates, based on links with same source column and circularLink type
	          var thisColumn = link.source.column;
	          var thisCircularLinkType = link.circularLinkType;
	          var sameColumnLinks = graph.links.filter(function (l) {
	            return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
	          });
	
	          if (link.circularLinkType == 'bottom') {
	            sameColumnLinks.sort(sortLinkSourceYDescending);
	          } else {
	            sameColumnLinks.sort(sortLinkSourceYAscending);
	          }
	
	          var radiusOffset = 0;
	          sameColumnLinks.forEach(function (l, i) {
	            if (l.circularLinkID == link.circularLinkID) {
	              link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
	              link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
	            }
	            radiusOffset = radiusOffset + l.width;
	          });
	
	          // add right extent coordinates, based on links with same target column and circularLink type
	          thisColumn = link.target.column;
	          sameColumnLinks = graph.links.filter(function (l) {
	            return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
	          });
	          if (link.circularLinkType == 'bottom') {
	            sameColumnLinks.sort(sortLinkTargetYDescending);
	          } else {
	            sameColumnLinks.sort(sortLinkTargetYAscending);
	          }
	
	          radiusOffset = 0;
	          sameColumnLinks.forEach(function (l, i) {
	            if (l.circularLinkID == link.circularLinkID) {
	              link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
	              link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
	            }
	            radiusOffset = radiusOffset + l.width;
	          });
	
	          // bottom links
	          if (link.circularLinkType == 'bottom') {
	            link.circularPathData.verticalFullExtent = Math.max(y1, link.source.y1, link.target.y1) + verticalMargin + link.circularPathData.verticalBuffer;
	            link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
	            link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
	          } else {
	            // top links
	            link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
	            link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
	            link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
	          }
	        }
	
	        // all links
	        link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
	        link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
	        link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
	        link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
	      }
	
	      if (link.circular) {
	        link.path = createCircularPathString(link);
	      } else {
	        var normalPath = d3Shape.linkHorizontal().source(function (d) {
	          var x = d.source.x0 + (d.source.x1 - d.source.x0);
	          var y = d.y0;
	          return [x, y];
	        }).target(function (d) {
	          var x = d.target.x0;
	          var y = d.y1;
	          return [x, y];
	        });
	        link.path = normalPath(link);
	      }
	    });
	  }
	
	  // create a d path using the addCircularPathData
	  function createCircularPathString(link) {
	    var pathString = '';
	    // 'pathData' is assigned a value but never used
	    // var pathData = {}
	
	    if (link.circularLinkType == 'top') {
	      pathString =
	      // start at the right of the source node
	      'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
	      // line right to buffer point
	      'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 0 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
	      // line up to buffer point
	      'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 0 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
	      // line left to buffer point
	      'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 0 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
	      // line down
	      'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 0 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
	      // line to end
	      'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
	    } else {
	      // bottom path
	      pathString =
	      // start at the right of the source node
	      'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
	      // line right to buffer point
	      'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 1 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
	      // line down to buffer point
	      'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 1 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
	      // line left to buffer point
	      'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 1 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
	      // line up
	      'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + ' ' +
	      // Arc around: Centre of arc X and  //Centre of arc Y
	      'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 1 ' +
	      // End of arc X //End of arc Y
	      link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
	      // line to end
	      'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
	    }
	
	    return pathString;
	  }
	
	  // sort links based on the distance between the source and tartget node columns
	  // if the same, then use Y position of the source node
	  function sortLinkColumnAscending(link1, link2) {
	    if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
	      return link1.circularLinkType == 'bottom' ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
	    } else {
	      return linkColumnDistance(link2) - linkColumnDistance(link1);
	    }
	  }
	
	  // sort ascending links by their source vertical position, y0
	  function sortLinkSourceYAscending(link1, link2) {
	    return link1.y0 - link2.y0;
	  }
	
	  // sort descending links by their source vertical position, y0
	  function sortLinkSourceYDescending(link1, link2) {
	    return link2.y0 - link1.y0;
	  }
	
	  // sort ascending links by their target vertical position, y1
	  function sortLinkTargetYAscending(link1, link2) {
	    return link1.y1 - link2.y1;
	  }
	
	  // sort descending links by their target vertical position, y1
	  function sortLinkTargetYDescending(link1, link2) {
	    return link2.y1 - link1.y1;
	  }
	
	  // return the distance between the link's target and source node, in terms of the nodes' column
	  function linkColumnDistance(link) {
	    return link.target.column - link.source.column;
	  }
	
	  // return the distance between the link's target and source node, in terms of the nodes' X coordinate
	  function linkXLength(link) {
	    return link.target.x0 - link.source.x1;
	  }
	
	  // Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
	  // * approx, based on a straight line from target to source, when in fact the path is a bezier
	  function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
	    // get the angle for the longer link
	    var angle = linkAngle(longerLink);
	
	    // get the adjacent length to the other link's x position
	    var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
	
	    // add or subtract from longer link1's original y1, depending on the slope
	    var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;
	
	    return yPerpendicular;
	  }
	
	  // Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
	  // * approx, based on a straight line from target to source, when in fact the path is a bezier
	  function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
	    // get the angle for the longer link
	    var angle = linkAngle(longerLink);
	
	    // get the adjacent length to the other link's x position
	    var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
	
	    // add or subtract from longer link's original y1, depending on the slope
	    var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;
	
	    return yPerpendicular;
	  }
	
	  // Move any nodes that overlap links which span 2+ columns
	  function resolveNodeLinkOverlaps(graph, y0, y1, id) {
	
	    graph.links.forEach(function (link) {
	      if (link.circular) {
	        return;
	      }
	
	      if (link.target.column - link.source.column > 1) {
	        var columnToTest = link.source.column + 1;
	        var maxColumnToTest = link.target.column - 1;
	
	        var i = 1;
	        var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;
	
	        for (i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
	          graph.nodes.forEach(function (node) {
	            if (node.column == columnToTest) {
	              var t = i / (numberOfColumnsToTest + 1);
	
	              // Find all the points of a cubic bezier curve in javascript
	              // https://stackoverflow.com/questions/15397596/find-all-the-points-of-a-cubic-bezier-curve-in-javascript
	
	              var B0_t = Math.pow(1 - t, 3);
	              var B1_t = 3 * t * Math.pow(1 - t, 2);
	              var B2_t = 3 * Math.pow(t, 2) * (1 - t);
	              var B3_t = Math.pow(t, 3);
	
	              var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;
	
	              var linkY0AtColumn = py_t - link.width / 2;
	              var linkY1AtColumn = py_t + link.width / 2;
	              var dy;
	
	              // If top of link overlaps node, push node up
	              if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {
	
	                dy = node.y1 - linkY0AtColumn + 10;
	                dy = node.circularLinkType == 'bottom' ? dy : -dy;
	
	                node = adjustNodeHeight(node, dy, y0, y1);
	
	                // check if other nodes need to move up too
	                graph.nodes.forEach(function (otherNode) {
	                  // don't need to check itself or nodes at different columns
	                  if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                    return;
	                  }
	                  if (nodesOverlap(node, otherNode)) {
	                    adjustNodeHeight(otherNode, dy, y0, y1);
	                  }
	                });
	              } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
	                // If bottom of link overlaps node, push node down
	                dy = linkY1AtColumn - node.y0 + 10;
	
	                node = adjustNodeHeight(node, dy, y0, y1);
	
	                // check if other nodes need to move down too
	                graph.nodes.forEach(function (otherNode) {
	                  // don't need to check itself or nodes at different columns
	                  if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                    return;
	                  }
	                  if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
	                    adjustNodeHeight(otherNode, dy, y0, y1);
	                  }
	                });
	              } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
	                // if link completely overlaps node
	                dy = linkY1AtColumn - node.y0 + 10;
	
	                node = adjustNodeHeight(node, dy, y0, y1);
	
	                graph.nodes.forEach(function (otherNode) {
	                  // don't need to check itself or nodes at different columns
	                  if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                    return;
	                  }
	                  if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
	                    adjustNodeHeight(otherNode, dy, y0, y1);
	                  }
	                });
	              }
	            }
	          });
	        }
	      }
	    });
	  }
	
	  // check if two nodes overlap
	  function nodesOverlap(nodeA, nodeB) {
	    // test if nodeA top partially overlaps nodeB
	    if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
	      return true;
	    } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
	      // test if nodeA bottom partially overlaps nodeB
	      return true;
	    } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
	      // test if nodeA covers nodeB
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  // update a node, and its associated links, vertical positions (y0, y1)
	  function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
	    if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
	      node.y0 = node.y0 + dy;
	      node.y1 = node.y1 + dy;
	
	      node.targetLinks.forEach(function (l) {
	        l.y1 = l.y1 + dy;
	      });
	
	      node.sourceLinks.forEach(function (l) {
	        l.y0 = l.y0 + dy;
	      });
	    }
	    return node;
	  }
	
	  // sort and set the links' y0 for each node
	  function sortSourceLinks(graph, y1, id, moveNodes) {
	    graph.nodes.forEach(function (node) {
	      // move any nodes up which are off the bottom
	      if (moveNodes && node.y + (node.y1 - node.y0) > y1) {
	        node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
	      }
	
	      var nodesSourceLinks = graph.links.filter(function (l) {
	        return getNodeID(l.source, id) == getNodeID(node, id);
	      });
	
	      var nodeSourceLinksLength = nodesSourceLinks.length;
	
	      // if more than 1 link then sort
	      if (nodeSourceLinksLength > 1) {
	        nodesSourceLinks.sort(function (link1, link2) {
	          // if both are not circular...
	          if (!link1.circular && !link2.circular) {
	            // if the target nodes are the same column, then sort by the link's target y
	            if (link1.target.column == link2.target.column) {
	              return link1.y1 - link2.y1;
	            } else if (!sameInclines(link1, link2)) {
	              // if the links slope in different directions, then sort by the link's target y
	              return link1.y1 - link2.y1;
	
	              // if the links slope in same directions, then sort by any overlap
	            } else {
	              if (link1.target.column > link2.target.column) {
	                var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
	                return link1.y1 - link2Adj;
	              }
	              if (link2.target.column > link1.target.column) {
	                var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
	                return link1Adj - link2.y1;
	              }
	            }
	          }
	
	          // if only one is circular, the move top links up, or bottom links down
	          if (link1.circular && !link2.circular) {
	            return link1.circularLinkType == 'top' ? -1 : 1;
	          } else if (link2.circular && !link1.circular) {
	            return link2.circularLinkType == 'top' ? 1 : -1;
	          }
	
	          // if both links are circular...
	          if (link1.circular && link2.circular) {
	            // ...and they both loop the same way (both top)
	            if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
	              // ...and they both connect to a target with same column, then sort by the target's y
	              if (link1.target.column === link2.target.column) {
	                return link1.target.y1 - link2.target.y1;
	              } else {
	                // ...and they connect to different column targets, then sort by how far back they
	                return link2.target.column - link1.target.column;
	              }
	            } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
	              // ...and they both loop the same way (both bottom)
	              // ...and they both connect to a target with same column, then sort by the target's y
	              if (link1.target.column === link2.target.column) {
	                return link2.target.y1 - link1.target.y1;
	              } else {
	                // ...and they connect to different column targets, then sort by how far back they
	                return link1.target.column - link2.target.column;
	              }
	            } else {
	              // ...and they loop around different ways, the move top up and bottom down
	              return link1.circularLinkType == 'top' ? -1 : 1;
	            }
	          }
	        });
	      }
	
	      // update y0 for links
	      var ySourceOffset = node.y0;
	
	      nodesSourceLinks.forEach(function (link) {
	        link.y0 = ySourceOffset + link.width / 2;
	        ySourceOffset = ySourceOffset + link.width;
	      });
	
	      // correct any circular bottom links so they are at the bottom of the node
	      nodesSourceLinks.forEach(function (link, i) {
	        if (link.circularLinkType == 'bottom') {
	          var j = i + 1;
	          var offsetFromBottom = 0;
	          // sum the widths of any links that are below this link
	          for (j; j < nodeSourceLinksLength; j++) {
	            offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
	          }
	          link.y0 = node.y1 - offsetFromBottom - link.width / 2;
	        }
	      });
	    });
	  }
	
	  // sort and set the links' y1 for each node
	  function sortTargetLinks(graph, y1, id) {
	    graph.nodes.forEach(function (node) {
	      var nodesTargetLinks = graph.links.filter(function (l) {
	        return getNodeID(l.target, id) == getNodeID(node, id);
	      });
	
	      var nodesTargetLinksLength = nodesTargetLinks.length;
	
	      if (nodesTargetLinksLength > 1) {
	        nodesTargetLinks.sort(function (link1, link2) {
	          // if both are not circular, the base on the source y position
	          if (!link1.circular && !link2.circular) {
	            if (link1.source.column == link2.source.column) {
	              return link1.y0 - link2.y0;
	            } else if (!sameInclines(link1, link2)) {
	              return link1.y0 - link2.y0;
	            } else {
	              // get the angle of the link to the further source node (ie the smaller column)
	              if (link2.source.column < link1.source.column) {
	                var link2Adj = linkPerpendicularYToLinkSource(link2, link1);
	
	                return link1.y0 - link2Adj;
	              }
	              if (link1.source.column < link2.source.column) {
	                var link1Adj = linkPerpendicularYToLinkSource(link1, link2);
	
	                return link1Adj - link2.y0;
	              }
	            }
	          }
	
	          // if only one is circular, the move top links up, or bottom links down
	          if (link1.circular && !link2.circular) {
	            return link1.circularLinkType == 'top' ? -1 : 1;
	          } else if (link2.circular && !link1.circular) {
	            return link2.circularLinkType == 'top' ? 1 : -1;
	          }
	
	          // if both links are circular...
	          if (link1.circular && link2.circular) {
	            // ...and they both loop the same way (both top)
	            if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
	              // ...and they both connect to a target with same column, then sort by the target's y
	              if (link1.source.column === link2.source.column) {
	                return link1.source.y1 - link2.source.y1;
	              } else {
	                // ...and they connect to different column targets, then sort by how far back they
	                return link1.source.column - link2.source.column;
	              }
	            } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
	              // ...and they both loop the same way (both bottom)
	              // ...and they both connect to a target with same column, then sort by the target's y
	              if (link1.source.column === link2.source.column) {
	                return link1.source.y1 - link2.source.y1;
	              } else {
	                // ...and they connect to different column targets, then sort by how far back they
	                return link2.source.column - link1.source.column;
	              }
	            } else {
	              // ...and they loop around different ways, the move top up and bottom down
	              return link1.circularLinkType == 'top' ? -1 : 1;
	            }
	          }
	        });
	      }
	
	      // update y1 for links
	      var yTargetOffset = node.y0;
	
	      nodesTargetLinks.forEach(function (link) {
	        link.y1 = yTargetOffset + link.width / 2;
	        yTargetOffset = yTargetOffset + link.width;
	      });
	
	      // correct any circular bottom links so they are at the bottom of the node
	      nodesTargetLinks.forEach(function (link, i) {
	        if (link.circularLinkType == 'bottom') {
	          var j = i + 1;
	          var offsetFromBottom = 0;
	          // sum the widths of any links that are below this link
	          for (j; j < nodesTargetLinksLength; j++) {
	            offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
	          }
	          link.y1 = node.y1 - offsetFromBottom - link.width / 2;
	        }
	      });
	    });
	  }
	
	  // test if links both slope up, or both slope down
	  function sameInclines(link1, link2) {
	    return incline(link1) == incline(link2);
	  }
	
	  // returns the slope of a link, from source to target
	  // up => slopes up from source to target
	  // down => slopes down from source to target
	  function incline(link) {
	    return link.y0 - link.y1 > 0 ? 'up' : 'down';
	  }
	
	  // check if link is self linking, ie links a node to the same node
	  function selfLinking(link, id) {
	    return getNodeID(link.source, id) == getNodeID(link.target, id);
	  }
	
	  function fillHeight(graph, y0, y1) {
	
	    var nodes = graph.nodes;
	    var links = graph.links;
	
	    var top = false;
	    var bottom = false;
	
	    links.forEach(function (link) {
	      if (link.circularLinkType == "top") {
	        top = true;
	      } else if (link.circularLinkType == "bottom") {
	        bottom = true;
	      }
	    });
	
	    if (top == false || bottom == false) {
	      var minY0 = d3Array.min(nodes, function (node) {
	        return node.y0;
	      });
	      var maxY1 = d3Array.max(nodes, function (node) {
	        return node.y1;
	      });
	      var currentHeight = maxY1 - minY0;
	      var chartHeight = y1 - y0;
	      var ratio = chartHeight / currentHeight;
	
	      nodes.forEach(function (node) {
	        var nodeHeight = (node.y1 - node.y0) * ratio;
	        node.y0 = (node.y0 - minY0) * ratio;
	        node.y1 = node.y0 + nodeHeight;
	      });
	
	      links.forEach(function (link) {
	        link.y0 = (link.y0 - minY0) * ratio;
	        link.y1 = (link.y1 - minY0) * ratio;
	        link.width = link.width * ratio;
	      });
	    }
	  }
	
	  exports.sankeyCircular = sankeyCircular;
	  exports.sankeyCenter = center;
	  exports.sankeyLeft = left;
	  exports.sankeyRight = right;
	  exports.sankeyJustify = justify;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{"d3-array":153,"d3-collection":154,"d3-shape":162,"elementary-circuits-directed-graph":174}],56:[function(_dereq_,module,exports){
	// https://github.com/d3/d3-sankey Version 0.7.2. Copyright 2019 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-array'), _dereq_('d3-collection'), _dereq_('d3-shape')) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Shape) { 'use strict';
	
	function targetDepth(d) {
	  return d.target.depth;
	}
	
	function left(node) {
	  return node.depth;
	}
	
	function right(node, n) {
	  return n - 1 - node.height;
	}
	
	function justify(node, n) {
	  return node.sourceLinks.length ? node.depth : n - 1;
	}
	
	function center(node) {
	  return node.targetLinks.length ? node.depth
	      : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1
	      : 0;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function ascendingSourceBreadth(a, b) {
	  return ascendingBreadth(a.source, b.source) || a.index - b.index;
	}
	
	function ascendingTargetBreadth(a, b) {
	  return ascendingBreadth(a.target, b.target) || a.index - b.index;
	}
	
	function ascendingBreadth(a, b) {
	  return a.y0 - b.y0;
	}
	
	function value(d) {
	  return d.value;
	}
	
	function nodeCenter(node) {
	  return (node.y0 + node.y1) / 2;
	}
	
	function weightedSource(link) {
	  return nodeCenter(link.source) * link.value;
	}
	
	function weightedTarget(link) {
	  return nodeCenter(link.target) * link.value;
	}
	
	function defaultId(d) {
	  return d.index;
	}
	
	function defaultNodes(graph) {
	  return graph.nodes;
	}
	
	function defaultLinks(graph) {
	  return graph.links;
	}
	
	function find(nodeById, id) {
	  var node = nodeById.get(id);
	  if (!node) throw new Error("missing: " + id);
	  return node;
	}
	
	var sankey = function() {
	  var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
	      dx = 24, // nodeWidth
	      py = 8, // nodePadding
	      id = defaultId,
	      align = justify,
	      nodes = defaultNodes,
	      links = defaultLinks,
	      iterations = 32,
	      maxPaddedSpace = 2 / 3; // Defined as a fraction of the total available space
	
	  function sankey() {
	    var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
	    computeNodeLinks(graph);
	    computeNodeValues(graph);
	    computeNodeDepths(graph);
	    computeNodeBreadths(graph, iterations);
	    computeLinkBreadths(graph);
	    return graph;
	  }
	
	  sankey.update = function(graph) {
	    computeLinkBreadths(graph);
	    return graph;
	  };
	
	  sankey.nodeId = function(_) {
	    return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
	  };
	
	  sankey.nodeAlign = function(_) {
	    return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
	  };
	
	  sankey.nodeWidth = function(_) {
	    return arguments.length ? (dx = +_, sankey) : dx;
	  };
	
	  sankey.nodePadding = function(_) {
	    return arguments.length ? (py = +_, sankey) : py;
	  };
	
	  sankey.nodes = function(_) {
	    return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
	  };
	
	  sankey.links = function(_) {
	    return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
	  };
	
	  sankey.size = function(_) {
	    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
	  };
	
	  sankey.extent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
	  };
	
	  sankey.iterations = function(_) {
	    return arguments.length ? (iterations = +_, sankey) : iterations;
	  };
	
	  // Populate the sourceLinks and targetLinks for each node.
	  // Also, if the source and target are not objects, assume they are indices.
	  function computeNodeLinks(graph) {
	    graph.nodes.forEach(function(node, i) {
	      node.index = i;
	      node.sourceLinks = [];
	      node.targetLinks = [];
	    });
	
	    var nodeById = d3Collection.map(graph.nodes, id);
	    graph.links.forEach(function(link, i) {
	      link.index = i;
	      var source = link.source, target = link.target;
	      if (typeof source !== "object") source = link.source = find(nodeById, source);
	      if (typeof target !== "object") target = link.target = find(nodeById, target);
	      source.sourceLinks.push(link);
	      target.targetLinks.push(link);
	    });
	  }
	
	  // Compute the value (size) of each node by summing the associated links.
	  function computeNodeValues(graph) {
	    graph.nodes.forEach(function(node) {
	      node.value = Math.max(
	        d3Array.sum(node.sourceLinks, value),
	        d3Array.sum(node.targetLinks, value)
	      );
	    });
	  }
	
	  // Iteratively assign the depth (x-position) for each node.
	  // Nodes are assigned the maximum depth of incoming neighbors plus one;
	  // nodes with no incoming links are assigned depth zero, while
	  // nodes with no outgoing links are assigned the maximum depth.
	  function computeNodeDepths(graph) {
	    var nodes, next, x;
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.depth = x;
	        node.sourceLinks.forEach(function(link) {
	          if (next.indexOf(link.target) < 0) {
	            next.push(link.target);
	          }
	        });
	      });
	    }
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.height = x;
	        node.targetLinks.forEach(function(link) {
	          if (next.indexOf(link.source) < 0) {
	            next.push(link.source);
	          }
	        });
	      });
	    }
	
	    var kx = (x1 - x0 - dx) / (x - 1);
	    graph.nodes.forEach(function(node) {
	      node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
	    });
	  }
	
	  function computeNodeBreadths(graph) {
	    var columns = d3Collection.nest()
	        .key(function(d) { return d.x0; })
	        .sortKeys(d3Array.ascending)
	        .entries(graph.nodes)
	        .map(function(d) { return d.values; });
	
	    //
	    initializeNodeBreadth();
	    resolveCollisions();
	    for (var alpha = 1, n = iterations; n > 0; --n) {
	      relaxRightToLeft(alpha *= 0.99);
	      resolveCollisions();
	      relaxLeftToRight(alpha);
	      resolveCollisions();
	    }
	
	    function initializeNodeBreadth() {
	      var L = d3Array.max(columns, function(nodes) {
	        return nodes.length;
	      });
	      var maxNodePadding = maxPaddedSpace * (y1 - y0) / (L - 1);
	      if(py > maxNodePadding) py = maxNodePadding;
	      var ky = d3Array.min(columns, function(nodes) {
	        return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
	      });
	
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node, i) {
	          node.y1 = (node.y0 = i) + node.value * ky;
	        });
	      });
	
	      graph.links.forEach(function(link) {
	        link.width = link.value * ky;
	      });
	    }
	
	    function relaxLeftToRight(alpha) {
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.targetLinks.length) {
	            var dy = (d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function relaxRightToLeft(alpha) {
	      columns.slice().reverse().forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.sourceLinks.length) {
	            var dy = (d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function resolveCollisions() {
	      columns.forEach(function(nodes) {
	        var node,
	            dy,
	            y = y0,
	            n = nodes.length,
	            i;
	
	        // Push any overlapping nodes down.
	        nodes.sort(ascendingBreadth);
	        for (i = 0; i < n; ++i) {
	          node = nodes[i];
	          dy = y - node.y0;
	          if (dy > 0) node.y0 += dy, node.y1 += dy;
	          y = node.y1 + py;
	        }
	
	        // If the bottommost node goes outside the bounds, push it back up.
	        dy = y - py - y1;
	        if (dy > 0) {
	          y = (node.y0 -= dy), node.y1 -= dy;
	
	          // Push any overlapping nodes back up.
	          for (i = n - 2; i >= 0; --i) {
	            node = nodes[i];
	            dy = node.y1 + py - y;
	            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	            y = node.y0;
	          }
	        }
	      });
	    }
	  }
	
	  function computeLinkBreadths(graph) {
	    graph.nodes.forEach(function(node) {
	      node.sourceLinks.sort(ascendingTargetBreadth);
	      node.targetLinks.sort(ascendingSourceBreadth);
	    });
	    graph.nodes.forEach(function(node) {
	      var y0 = node.y0, y1 = y0;
	      node.sourceLinks.forEach(function(link) {
	        link.y0 = y0 + link.width / 2, y0 += link.width;
	      });
	      node.targetLinks.forEach(function(link) {
	        link.y1 = y1 + link.width / 2, y1 += link.width;
	      });
	    });
	  }
	
	  return sankey;
	};
	
	function horizontalSource(d) {
	  return [d.source.x1, d.y0];
	}
	
	function horizontalTarget(d) {
	  return [d.target.x0, d.y1];
	}
	
	var sankeyLinkHorizontal = function() {
	  return d3Shape.linkHorizontal()
	      .source(horizontalSource)
	      .target(horizontalTarget);
	};
	
	exports.sankey = sankey;
	exports.sankeyCenter = center;
	exports.sankeyLeft = left;
	exports.sankeyRight = right;
	exports.sankeyJustify = justify;
	exports.sankeyLinkHorizontal = sankeyLinkHorizontal;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{"d3-array":153,"d3-collection":154,"d3-shape":162}],57:[function(_dereq_,module,exports){
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var meta_1 = _dereq_("@turf/meta");
	// Note: change RADIUS => earthRadius
	var RADIUS = 6378137;
	/**
	 * Takes one or more features and returns their area in square meters.
	 *
	 * @name area
	 * @param {GeoJSON} geojson input GeoJSON feature(s)
	 * @returns {number} area in square meters
	 * @example
	 * var polygon = turf.polygon([[[125, -15], [113, -22], [154, -27], [144, -15], [125, -15]]]);
	 *
	 * var area = turf.area(polygon);
	 *
	 * //addToMap
	 * var addToMap = [polygon]
	 * polygon.properties.area = area
	 */
	function area(geojson) {
	    return meta_1.geomReduce(geojson, function (value, geom) {
	        return value + calculateArea(geom);
	    }, 0);
	}
	exports.default = area;
	/**
	 * Calculate Area
	 *
	 * @private
	 * @param {Geometry} geom GeoJSON Geometries
	 * @returns {number} area
	 */
	function calculateArea(geom) {
	    var total = 0;
	    var i;
	    switch (geom.type) {
	        case "Polygon":
	            return polygonArea(geom.coordinates);
	        case "MultiPolygon":
	            for (i = 0; i < geom.coordinates.length; i++) {
	                total += polygonArea(geom.coordinates[i]);
	            }
	            return total;
	        case "Point":
	        case "MultiPoint":
	        case "LineString":
	        case "MultiLineString":
	            return 0;
	    }
	    return 0;
	}
	function polygonArea(coords) {
	    var total = 0;
	    if (coords && coords.length > 0) {
	        total += Math.abs(ringArea(coords[0]));
	        for (var i = 1; i < coords.length; i++) {
	            total -= Math.abs(ringArea(coords[i]));
	        }
	    }
	    return total;
	}
	/**
	 * @private
	 * Calculate the approximate area of the polygon were it projected onto the earth.
	 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
	 *
	 * Reference:
	 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
	 * JPL Publication 07-03, Jet Propulsion
	 * Laboratory, Pasadena, CA, June 2007 http://trs-new.jpl.nasa.gov/dspace/handle/2014/40409
	 *
	 * @param {Array<Array<number>>} coords Ring Coordinates
	 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
	 */
	function ringArea(coords) {
	    var p1;
	    var p2;
	    var p3;
	    var lowerIndex;
	    var middleIndex;
	    var upperIndex;
	    var i;
	    var total = 0;
	    var coordsLength = coords.length;
	    if (coordsLength > 2) {
	        for (i = 0; i < coordsLength; i++) {
	            if (i === coordsLength - 2) {
	                lowerIndex = coordsLength - 2;
	                middleIndex = coordsLength - 1;
	                upperIndex = 0;
	            }
	            else if (i === coordsLength - 1) {
	                lowerIndex = coordsLength - 1;
	                middleIndex = 0;
	                upperIndex = 1;
	            }
	            else {
	                lowerIndex = i;
	                middleIndex = i + 1;
	                upperIndex = i + 2;
	            }
	            p1 = coords[lowerIndex];
	            p2 = coords[middleIndex];
	            p3 = coords[upperIndex];
	            total += (rad(p3[0]) - rad(p1[0])) * Math.sin(rad(p2[1]));
	        }
	        total = total * RADIUS * RADIUS / 2;
	    }
	    return total;
	}
	function rad(num) {
	    return num * Math.PI / 180;
	}
	
	},{"@turf/meta":60}],58:[function(_dereq_,module,exports){
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var meta_1 = _dereq_("@turf/meta");
	var helpers_1 = _dereq_("@turf/helpers");
	/**
	 * Takes one or more features and calculates the centroid using the mean of all vertices.
	 * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
	 *
	 * @name centroid
	 * @param {GeoJSON} geojson GeoJSON to be centered
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
	 * @returns {Feature<Point>} the centroid of the input features
	 * @example
	 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
	 *
	 * var centroid = turf.centroid(polygon);
	 *
	 * //addToMap
	 * var addToMap = [polygon, centroid]
	 */
	function centroid(geojson, options) {
	    if (options === void 0) { options = {}; }
	    var xSum = 0;
	    var ySum = 0;
	    var len = 0;
	    meta_1.coordEach(geojson, function (coord) {
	        xSum += coord[0];
	        ySum += coord[1];
	        len++;
	    });
	    return helpers_1.point([xSum / len, ySum / len], options.properties);
	}
	exports.default = centroid;
	
	},{"@turf/helpers":59,"@turf/meta":60}],59:[function(_dereq_,module,exports){
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @module helpers
	 */
	/**
	 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
	 *
	 * @memberof helpers
	 * @type {number}
	 */
	exports.earthRadius = 6371008.8;
	/**
	 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.factors = {
	    centimeters: exports.earthRadius * 100,
	    centimetres: exports.earthRadius * 100,
	    degrees: exports.earthRadius / 111325,
	    feet: exports.earthRadius * 3.28084,
	    inches: exports.earthRadius * 39.370,
	    kilometers: exports.earthRadius / 1000,
	    kilometres: exports.earthRadius / 1000,
	    meters: exports.earthRadius,
	    metres: exports.earthRadius,
	    miles: exports.earthRadius / 1609.344,
	    millimeters: exports.earthRadius * 1000,
	    millimetres: exports.earthRadius * 1000,
	    nauticalmiles: exports.earthRadius / 1852,
	    radians: 1,
	    yards: exports.earthRadius / 1.0936,
	};
	/**
	 * Units of measurement factors based on 1 meter.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.unitsFactors = {
	    centimeters: 100,
	    centimetres: 100,
	    degrees: 1 / 111325,
	    feet: 3.28084,
	    inches: 39.370,
	    kilometers: 1 / 1000,
	    kilometres: 1 / 1000,
	    meters: 1,
	    metres: 1,
	    miles: 1 / 1609.344,
	    millimeters: 1000,
	    millimetres: 1000,
	    nauticalmiles: 1 / 1852,
	    radians: 1 / exports.earthRadius,
	    yards: 1 / 1.0936,
	};
	/**
	 * Area of measurement factors based on 1 square meter.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.areaFactors = {
	    acres: 0.000247105,
	    centimeters: 10000,
	    centimetres: 10000,
	    feet: 10.763910417,
	    inches: 1550.003100006,
	    kilometers: 0.000001,
	    kilometres: 0.000001,
	    meters: 1,
	    metres: 1,
	    miles: 3.86e-7,
	    millimeters: 1000000,
	    millimetres: 1000000,
	    yards: 1.195990046,
	};
	/**
	 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
	 *
	 * @name feature
	 * @param {Geometry} geometry input geometry
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature} a GeoJSON Feature
	 * @example
	 * var geometry = {
	 *   "type": "Point",
	 *   "coordinates": [110, 50]
	 * };
	 *
	 * var feature = turf.feature(geometry);
	 *
	 * //=feature
	 */
	function feature(geom, properties, options) {
	    if (options === void 0) { options = {}; }
	    var feat = { type: "Feature" };
	    if (options.id === 0 || options.id) {
	        feat.id = options.id;
	    }
	    if (options.bbox) {
	        feat.bbox = options.bbox;
	    }
	    feat.properties = properties || {};
	    feat.geometry = geom;
	    return feat;
	}
	exports.feature = feature;
	/**
	 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
	 * For GeometryCollection type use `helpers.geometryCollection`
	 *
	 * @name geometry
	 * @param {string} type Geometry Type
	 * @param {Array<any>} coordinates Coordinates
	 * @param {Object} [options={}] Optional Parameters
	 * @returns {Geometry} a GeoJSON Geometry
	 * @example
	 * var type = "Point";
	 * var coordinates = [110, 50];
	 * var geometry = turf.geometry(type, coordinates);
	 * // => geometry
	 */
	function geometry(type, coordinates, options) {
	    if (options === void 0) { options = {}; }
	    switch (type) {
	        case "Point": return point(coordinates).geometry;
	        case "LineString": return lineString(coordinates).geometry;
	        case "Polygon": return polygon(coordinates).geometry;
	        case "MultiPoint": return multiPoint(coordinates).geometry;
	        case "MultiLineString": return multiLineString(coordinates).geometry;
	        case "MultiPolygon": return multiPolygon(coordinates).geometry;
	        default: throw new Error(type + " is invalid");
	    }
	}
	exports.geometry = geometry;
	/**
	 * Creates a {@link Point} {@link Feature} from a Position.
	 *
	 * @name point
	 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<Point>} a Point feature
	 * @example
	 * var point = turf.point([-75.343, 39.984]);
	 *
	 * //=point
	 */
	function point(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "Point",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.point = point;
	/**
	 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
	 *
	 * @name points
	 * @param {Array<Array<number>>} coordinates an array of Points
	 * @param {Object} [properties={}] Translate these properties to each Feature
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
	 * associated with the FeatureCollection
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<Point>} Point Feature
	 * @example
	 * var points = turf.points([
	 *   [-75, 39],
	 *   [-80, 45],
	 *   [-78, 50]
	 * ]);
	 *
	 * //=points
	 */
	function points(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return point(coords, properties);
	    }), options);
	}
	exports.points = points;
	/**
	 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
	 *
	 * @name polygon
	 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<Polygon>} Polygon Feature
	 * @example
	 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
	 *
	 * //=polygon
	 */
	function polygon(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
	        var ring = coordinates_1[_i];
	        if (ring.length < 4) {
	            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
	        }
	        for (var j = 0; j < ring[ring.length - 1].length; j++) {
	            // Check if first point of Polygon contains two numbers
	            if (ring[ring.length - 1][j] !== ring[0][j]) {
	                throw new Error("First and last Position are not equivalent.");
	            }
	        }
	    }
	    var geom = {
	        type: "Polygon",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.polygon = polygon;
	/**
	 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
	 *
	 * @name polygons
	 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
	 * @example
	 * var polygons = turf.polygons([
	 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
	 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
	 * ]);
	 *
	 * //=polygons
	 */
	function polygons(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return polygon(coords, properties);
	    }), options);
	}
	exports.polygons = polygons;
	/**
	 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
	 *
	 * @name lineString
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<LineString>} LineString Feature
	 * @example
	 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
	 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
	 *
	 * //=linestring1
	 * //=linestring2
	 */
	function lineString(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    if (coordinates.length < 2) {
	        throw new Error("coordinates must be an array of two or more positions");
	    }
	    var geom = {
	        type: "LineString",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.lineString = lineString;
	/**
	 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
	 *
	 * @name lineStrings
	 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
	 * associated with the FeatureCollection
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
	 * @example
	 * var linestrings = turf.lineStrings([
	 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
	 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
	 * ]);
	 *
	 * //=linestrings
	 */
	function lineStrings(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return lineString(coords, properties);
	    }), options);
	}
	exports.lineStrings = lineStrings;
	/**
	 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
	 *
	 * @name featureCollection
	 * @param {Feature[]} features input features
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {FeatureCollection} FeatureCollection of Features
	 * @example
	 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
	 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
	 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
	 *
	 * var collection = turf.featureCollection([
	 *   locationA,
	 *   locationB,
	 *   locationC
	 * ]);
	 *
	 * //=collection
	 */
	function featureCollection(features, options) {
	    if (options === void 0) { options = {}; }
	    var fc = { type: "FeatureCollection" };
	    if (options.id) {
	        fc.id = options.id;
	    }
	    if (options.bbox) {
	        fc.bbox = options.bbox;
	    }
	    fc.features = features;
	    return fc;
	}
	exports.featureCollection = featureCollection;
	/**
	 * Creates a {@link Feature<MultiLineString>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiLineString
	 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiLineString>} a MultiLineString feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
	 *
	 * //=multiLine
	 */
	function multiLineString(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiLineString",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiLineString = multiLineString;
	/**
	 * Creates a {@link Feature<MultiPoint>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPoint
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiPoint>} a MultiPoint feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
	 *
	 * //=multiPt
	 */
	function multiPoint(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiPoint",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiPoint = multiPoint;
	/**
	 * Creates a {@link Feature<MultiPolygon>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPolygon
	 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiPolygon>} a multipolygon feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
	 *
	 * //=multiPoly
	 *
	 */
	function multiPolygon(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiPolygon",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiPolygon = multiPolygon;
	/**
	 * Creates a {@link Feature<GeometryCollection>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name geometryCollection
	 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
	 * @example
	 * var pt = turf.geometry("Point", [100, 0]);
	 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
	 * var collection = turf.geometryCollection([pt, line]);
	 *
	 * // => collection
	 */
	function geometryCollection(geometries, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "GeometryCollection",
	        geometries: geometries,
	    };
	    return feature(geom, properties, options);
	}
	exports.geometryCollection = geometryCollection;
	/**
	 * Round number to precision
	 *
	 * @param {number} num Number
	 * @param {number} [precision=0] Precision
	 * @returns {number} rounded number
	 * @example
	 * turf.round(120.4321)
	 * //=120
	 *
	 * turf.round(120.4321, 2)
	 * //=120.43
	 */
	function round(num, precision) {
	    if (precision === void 0) { precision = 0; }
	    if (precision && !(precision >= 0)) {
	        throw new Error("precision must be a positive number");
	    }
	    var multiplier = Math.pow(10, precision || 0);
	    return Math.round(num * multiplier) / multiplier;
	}
	exports.round = round;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @name radiansToLength
	 * @param {number} radians in radians across the sphere
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} distance
	 */
	function radiansToLength(radians, units) {
	    if (units === void 0) { units = "kilometers"; }
	    var factor = exports.factors[units];
	    if (!factor) {
	        throw new Error(units + " units is invalid");
	    }
	    return radians * factor;
	}
	exports.radiansToLength = radiansToLength;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @name lengthToRadians
	 * @param {number} distance in real units
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} radians
	 */
	function lengthToRadians(distance, units) {
	    if (units === void 0) { units = "kilometers"; }
	    var factor = exports.factors[units];
	    if (!factor) {
	        throw new Error(units + " units is invalid");
	    }
	    return distance / factor;
	}
	exports.lengthToRadians = lengthToRadians;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
	 *
	 * @name lengthToDegrees
	 * @param {number} distance in real units
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} degrees
	 */
	function lengthToDegrees(distance, units) {
	    return radiansToDegrees(lengthToRadians(distance, units));
	}
	exports.lengthToDegrees = lengthToDegrees;
	/**
	 * Converts any bearing angle from the north line direction (positive clockwise)
	 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
	 *
	 * @name bearingToAzimuth
	 * @param {number} bearing angle, between -180 and +180 degrees
	 * @returns {number} angle between 0 and 360 degrees
	 */
	function bearingToAzimuth(bearing) {
	    var angle = bearing % 360;
	    if (angle < 0) {
	        angle += 360;
	    }
	    return angle;
	}
	exports.bearingToAzimuth = bearingToAzimuth;
	/**
	 * Converts an angle in radians to degrees
	 *
	 * @name radiansToDegrees
	 * @param {number} radians angle in radians
	 * @returns {number} degrees between 0 and 360 degrees
	 */
	function radiansToDegrees(radians) {
	    var degrees = radians % (2 * Math.PI);
	    return degrees * 180 / Math.PI;
	}
	exports.radiansToDegrees = radiansToDegrees;
	/**
	 * Converts an angle in degrees to radians
	 *
	 * @name degreesToRadians
	 * @param {number} degrees angle between 0 and 360 degrees
	 * @returns {number} angle in radians
	 */
	function degreesToRadians(degrees) {
	    var radians = degrees % 360;
	    return radians * Math.PI / 180;
	}
	exports.degreesToRadians = degreesToRadians;
	/**
	 * Converts a length to the requested unit.
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @param {number} length to be converted
	 * @param {Units} [originalUnit="kilometers"] of the length
	 * @param {Units} [finalUnit="kilometers"] returned unit
	 * @returns {number} the converted length
	 */
	function convertLength(length, originalUnit, finalUnit) {
	    if (originalUnit === void 0) { originalUnit = "kilometers"; }
	    if (finalUnit === void 0) { finalUnit = "kilometers"; }
	    if (!(length >= 0)) {
	        throw new Error("length must be a positive number");
	    }
	    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
	}
	exports.convertLength = convertLength;
	/**
	 * Converts a area to the requested unit.
	 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
	 * @param {number} area to be converted
	 * @param {Units} [originalUnit="meters"] of the distance
	 * @param {Units} [finalUnit="kilometers"] returned unit
	 * @returns {number} the converted distance
	 */
	function convertArea(area, originalUnit, finalUnit) {
	    if (originalUnit === void 0) { originalUnit = "meters"; }
	    if (finalUnit === void 0) { finalUnit = "kilometers"; }
	    if (!(area >= 0)) {
	        throw new Error("area must be a positive number");
	    }
	    var startFactor = exports.areaFactors[originalUnit];
	    if (!startFactor) {
	        throw new Error("invalid original units");
	    }
	    var finalFactor = exports.areaFactors[finalUnit];
	    if (!finalFactor) {
	        throw new Error("invalid final units");
	    }
	    return (area / startFactor) * finalFactor;
	}
	exports.convertArea = convertArea;
	/**
	 * isNumber
	 *
	 * @param {*} num Number to validate
	 * @returns {boolean} true/false
	 * @example
	 * turf.isNumber(123)
	 * //=true
	 * turf.isNumber('foo')
	 * //=false
	 */
	function isNumber(num) {
	    return !isNaN(num) && num !== null && !Array.isArray(num) && !/^\s*$/.test(num);
	}
	exports.isNumber = isNumber;
	/**
	 * isObject
	 *
	 * @param {*} input variable to validate
	 * @returns {boolean} true/false
	 * @example
	 * turf.isObject({elevation: 10})
	 * //=true
	 * turf.isObject('foo')
	 * //=false
	 */
	function isObject(input) {
	    return (!!input) && (input.constructor === Object);
	}
	exports.isObject = isObject;
	/**
	 * Validate BBox
	 *
	 * @private
	 * @param {Array<number>} bbox BBox to validate
	 * @returns {void}
	 * @throws Error if BBox is not valid
	 * @example
	 * validateBBox([-180, -40, 110, 50])
	 * //=OK
	 * validateBBox([-180, -40])
	 * //=Error
	 * validateBBox('Foo')
	 * //=Error
	 * validateBBox(5)
	 * //=Error
	 * validateBBox(null)
	 * //=Error
	 * validateBBox(undefined)
	 * //=Error
	 */
	function validateBBox(bbox) {
	    if (!bbox) {
	        throw new Error("bbox is required");
	    }
	    if (!Array.isArray(bbox)) {
	        throw new Error("bbox must be an Array");
	    }
	    if (bbox.length !== 4 && bbox.length !== 6) {
	        throw new Error("bbox must be an Array of 4 or 6 numbers");
	    }
	    bbox.forEach(function (num) {
	        if (!isNumber(num)) {
	            throw new Error("bbox must only contain numbers");
	        }
	    });
	}
	exports.validateBBox = validateBBox;
	/**
	 * Validate Id
	 *
	 * @private
	 * @param {string|number} id Id to validate
	 * @returns {void}
	 * @throws Error if Id is not valid
	 * @example
	 * validateId([-180, -40, 110, 50])
	 * //=Error
	 * validateId([-180, -40])
	 * //=Error
	 * validateId('Foo')
	 * //=OK
	 * validateId(5)
	 * //=OK
	 * validateId(null)
	 * //=Error
	 * validateId(undefined)
	 * //=Error
	 */
	function validateId(id) {
	    if (!id) {
	        throw new Error("id is required");
	    }
	    if (["string", "number"].indexOf(typeof id) === -1) {
	        throw new Error("id must be a number or a string");
	    }
	}
	exports.validateId = validateId;
	// Deprecated methods
	function radians2degrees() {
	    throw new Error("method has been renamed to `radiansToDegrees`");
	}
	exports.radians2degrees = radians2degrees;
	function degrees2radians() {
	    throw new Error("method has been renamed to `degreesToRadians`");
	}
	exports.degrees2radians = degrees2radians;
	function distanceToDegrees() {
	    throw new Error("method has been renamed to `lengthToDegrees`");
	}
	exports.distanceToDegrees = distanceToDegrees;
	function distanceToRadians() {
	    throw new Error("method has been renamed to `lengthToRadians`");
	}
	exports.distanceToRadians = distanceToRadians;
	function radiansToDistance() {
	    throw new Error("method has been renamed to `radiansToLength`");
	}
	exports.radiansToDistance = radiansToDistance;
	function bearingToAngle() {
	    throw new Error("method has been renamed to `bearingToAzimuth`");
	}
	exports.bearingToAngle = bearingToAngle;
	function convertDistance() {
	    throw new Error("method has been renamed to `convertLength`");
	}
	exports.convertDistance = convertDistance;
	
	},{}],60:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var helpers = _dereq_('@turf/helpers');
	
	/**
	 * Callback for coordEach
	 *
	 * @callback coordEachCallback
	 * @param {Array<number>} currentCoord The current coordinate being processed.
	 * @param {number} coordIndex The current index of the coordinate being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 */
	
	/**
	 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name coordEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
	 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=currentCoord
	 *   //=coordIndex
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 * });
	 */
	function coordEach(geojson, callback, excludeWrapCoord) {
	    // Handles null Geometry -- Skips this GeoJSON
	    if (geojson === null) return;
	    var j, k, l, geometry, stopG, coords,
	        geometryMaybeCollection,
	        wrapShrink = 0,
	        coordIndex = 0,
	        isGeometryCollection,
	        type = geojson.type,
	        isFeatureCollection = type === 'FeatureCollection',
	        isFeature = type === 'Feature',
	        stop = isFeatureCollection ? geojson.features.length : 1;
	
	    // This logic may look a little weird. The reason why it is that way
	    // is because it's trying to be fast. GeoJSON supports multiple kinds
	    // of objects at its root: FeatureCollection, Features, Geometries.
	    // This function has the responsibility of handling all of them, and that
	    // means that some of the `for` loops you see below actually just don't apply
	    // to certain inputs. For instance, if you give this just a
	    // Point geometry, then both loops are short-circuited and all we do
	    // is gradually rename the input until it's called 'geometry'.
	    //
	    // This also aims to allocate as few resources as possible: just a
	    // few numbers and booleans, rather than any temporary arrays as would
	    // be required with the normalization approach.
	    for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
	        geometryMaybeCollection = (isFeatureCollection ? geojson.features[featureIndex].geometry :
	            (isFeature ? geojson.geometry : geojson));
	        isGeometryCollection = (geometryMaybeCollection) ? geometryMaybeCollection.type === 'GeometryCollection' : false;
	        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	
	        for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
	            var multiFeatureIndex = 0;
	            var geometryIndex = 0;
	            geometry = isGeometryCollection ?
	                geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
	
	            // Handles null Geometry -- Skips this geometry
	            if (geometry === null) continue;
	            coords = geometry.coordinates;
	            var geomType = geometry.type;
	
	            wrapShrink = (excludeWrapCoord && (geomType === 'Polygon' || geomType === 'MultiPolygon')) ? 1 : 0;
	
	            switch (geomType) {
	            case null:
	                break;
	            case 'Point':
	                if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                coordIndex++;
	                multiFeatureIndex++;
	                break;
	            case 'LineString':
	            case 'MultiPoint':
	                for (j = 0; j < coords.length; j++) {
	                    if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                    coordIndex++;
	                    if (geomType === 'MultiPoint') multiFeatureIndex++;
	                }
	                if (geomType === 'LineString') multiFeatureIndex++;
	                break;
	            case 'Polygon':
	            case 'MultiLineString':
	                for (j = 0; j < coords.length; j++) {
	                    for (k = 0; k < coords[j].length - wrapShrink; k++) {
	                        if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                        coordIndex++;
	                    }
	                    if (geomType === 'MultiLineString') multiFeatureIndex++;
	                    if (geomType === 'Polygon') geometryIndex++;
	                }
	                if (geomType === 'Polygon') multiFeatureIndex++;
	                break;
	            case 'MultiPolygon':
	                for (j = 0; j < coords.length; j++) {
	                    geometryIndex = 0;
	                    for (k = 0; k < coords[j].length; k++) {
	                        for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
	                            if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                            coordIndex++;
	                        }
	                        geometryIndex++;
	                    }
	                    multiFeatureIndex++;
	                }
	                break;
	            case 'GeometryCollection':
	                for (j = 0; j < geometry.geometries.length; j++)
	                    if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
	                break;
	            default:
	                throw new Error('Unknown Geometry Type');
	            }
	        }
	    }
	}
	
	/**
	 * Callback for coordReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback coordReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Array<number>} currentCoord The current coordinate being processed.
	 * @param {number} coordIndex The current index of the coordinate being processed.
	 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 */
	
	/**
	 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
	 *
	 * @name coordReduce
	 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=previousValue
	 *   //=currentCoord
	 *   //=coordIndex
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   return currentCoord;
	 * });
	 */
	function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
	    var previousValue = initialValue;
	    coordEach(geojson, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
	        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
	    }, excludeWrapCoord);
	    return previousValue;
	}
	
	/**
	 * Callback for propEach
	 *
	 * @callback propEachCallback
	 * @param {Object} currentProperties The current Properties being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name propEach
	 * @param {FeatureCollection|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentProperties, featureIndex)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.propEach(features, function (currentProperties, featureIndex) {
	 *   //=currentProperties
	 *   //=featureIndex
	 * });
	 */
	function propEach(geojson, callback) {
	    var i;
	    switch (geojson.type) {
	    case 'FeatureCollection':
	        for (i = 0; i < geojson.features.length; i++) {
	            if (callback(geojson.features[i].properties, i) === false) break;
	        }
	        break;
	    case 'Feature':
	        callback(geojson.properties, 0);
	        break;
	    }
	}
	
	
	/**
	 * Callback for propReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback propReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {*} currentProperties The current Properties being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Reduce properties in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all properties is unnecessary.
	 *
	 * @name propReduce
	 * @param {FeatureCollection|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
	 *   //=previousValue
	 *   //=currentProperties
	 *   //=featureIndex
	 *   return currentProperties
	 * });
	 */
	function propReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    propEach(geojson, function (currentProperties, featureIndex) {
	        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
	        else previousValue = callback(previousValue, currentProperties, featureIndex);
	    });
	    return previousValue;
	}
	
	/**
	 * Callback for featureEach
	 *
	 * @callback featureEachCallback
	 * @param {Feature<any>} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Iterate over features in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @name featureEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentFeature, featureIndex)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {foo: 'bar'}),
	 *   turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.featureEach(features, function (currentFeature, featureIndex) {
	 *   //=currentFeature
	 *   //=featureIndex
	 * });
	 */
	function featureEach(geojson, callback) {
	    if (geojson.type === 'Feature') {
	        callback(geojson, 0);
	    } else if (geojson.type === 'FeatureCollection') {
	        for (var i = 0; i < geojson.features.length; i++) {
	            if (callback(geojson.features[i], i) === false) break;
	        }
	    }
	}
	
	/**
	 * Callback for featureReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback featureReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Reduce features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name featureReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
	 *   //=previousValue
	 *   //=currentFeature
	 *   //=featureIndex
	 *   return currentFeature
	 * });
	 */
	function featureReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    featureEach(geojson, function (currentFeature, featureIndex) {
	        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
	        else previousValue = callback(previousValue, currentFeature, featureIndex);
	    });
	    return previousValue;
	}
	
	/**
	 * Get all coordinates from any GeoJSON object.
	 *
	 * @name coordAll
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @returns {Array<Array<number>>} coordinate position array
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {foo: 'bar'}),
	 *   turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * var coords = turf.coordAll(features);
	 * //= [[26, 37], [36, 53]]
	 */
	function coordAll(geojson) {
	    var coords = [];
	    coordEach(geojson, function (coord) {
	        coords.push(coord);
	    });
	    return coords;
	}
	
	/**
	 * Callback for geomEach
	 *
	 * @callback geomEachCallback
	 * @param {Geometry} currentGeometry The current Geometry being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {Object} featureProperties The current Feature Properties being processed.
	 * @param {Array<number>} featureBBox The current Feature BBox being processed.
	 * @param {number|string} featureId The current Feature Id being processed.
	 */
	
	/**
	 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name geomEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	 *   //=currentGeometry
	 *   //=featureIndex
	 *   //=featureProperties
	 *   //=featureBBox
	 *   //=featureId
	 * });
	 */
	function geomEach(geojson, callback) {
	    var i, j, g, geometry, stopG,
	        geometryMaybeCollection,
	        isGeometryCollection,
	        featureProperties,
	        featureBBox,
	        featureId,
	        featureIndex = 0,
	        isFeatureCollection = geojson.type === 'FeatureCollection',
	        isFeature = geojson.type === 'Feature',
	        stop = isFeatureCollection ? geojson.features.length : 1;
	
	    // This logic may look a little weird. The reason why it is that way
	    // is because it's trying to be fast. GeoJSON supports multiple kinds
	    // of objects at its root: FeatureCollection, Features, Geometries.
	    // This function has the responsibility of handling all of them, and that
	    // means that some of the `for` loops you see below actually just don't apply
	    // to certain inputs. For instance, if you give this just a
	    // Point geometry, then both loops are short-circuited and all we do
	    // is gradually rename the input until it's called 'geometry'.
	    //
	    // This also aims to allocate as few resources as possible: just a
	    // few numbers and booleans, rather than any temporary arrays as would
	    // be required with the normalization approach.
	    for (i = 0; i < stop; i++) {
	
	        geometryMaybeCollection = (isFeatureCollection ? geojson.features[i].geometry :
	            (isFeature ? geojson.geometry : geojson));
	        featureProperties = (isFeatureCollection ? geojson.features[i].properties :
	            (isFeature ? geojson.properties : {}));
	        featureBBox = (isFeatureCollection ? geojson.features[i].bbox :
	            (isFeature ? geojson.bbox : undefined));
	        featureId = (isFeatureCollection ? geojson.features[i].id :
	            (isFeature ? geojson.id : undefined));
	        isGeometryCollection = (geometryMaybeCollection) ? geometryMaybeCollection.type === 'GeometryCollection' : false;
	        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	
	        for (g = 0; g < stopG; g++) {
	            geometry = isGeometryCollection ?
	                geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	
	            // Handle null Geometry
	            if (geometry === null) {
	                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                continue;
	            }
	            switch (geometry.type) {
	            case 'Point':
	            case 'LineString':
	            case 'MultiPoint':
	            case 'Polygon':
	            case 'MultiLineString':
	            case 'MultiPolygon': {
	                if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                break;
	            }
	            case 'GeometryCollection': {
	                for (j = 0; j < geometry.geometries.length; j++) {
	                    if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                }
	                break;
	            }
	            default:
	                throw new Error('Unknown Geometry Type');
	            }
	        }
	        // Only increase `featureIndex` per each feature
	        featureIndex++;
	    }
	}
	
	/**
	 * Callback for geomReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback geomReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Geometry} currentGeometry The current Geometry being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {Object} featureProperties The current Feature Properties being processed.
	 * @param {Array<number>} featureBBox The current Feature BBox being processed.
	 * @param {number|string} featureId The current Feature Id being processed.
	 */
	
	/**
	 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name geomReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	 *   //=previousValue
	 *   //=currentGeometry
	 *   //=featureIndex
	 *   //=featureProperties
	 *   //=featureBBox
	 *   //=featureId
	 *   return currentGeometry
	 * });
	 */
	function geomReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    geomEach(geojson, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
	        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
	    });
	    return previousValue;
	}
	
	/**
	 * Callback for flattenEach
	 *
	 * @callback flattenEachCallback
	 * @param {Feature} currentFeature The current flattened feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 */
	
	/**
	 * Iterate over flattened features in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @name flattenEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
	 * ]);
	 *
	 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
	 *   //=currentFeature
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 * });
	 */
	function flattenEach(geojson, callback) {
	    geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
	        // Callback for single geometry
	        var type = (geometry === null) ? null : geometry.type;
	        switch (type) {
	        case null:
	        case 'Point':
	        case 'LineString':
	        case 'Polygon':
	            if (callback(helpers.feature(geometry, properties, {bbox: bbox, id: id}), featureIndex, 0) === false) return false;
	            return;
	        }
	
	        var geomType;
	
	        // Callback for multi-geometry
	        switch (type) {
	        case 'MultiPoint':
	            geomType = 'Point';
	            break;
	        case 'MultiLineString':
	            geomType = 'LineString';
	            break;
	        case 'MultiPolygon':
	            geomType = 'Polygon';
	            break;
	        }
	
	        for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
	            var coordinate = geometry.coordinates[multiFeatureIndex];
	            var geom = {
	                type: geomType,
	                coordinates: coordinate
	            };
	            if (callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
	        }
	    });
	}
	
	/**
	 * Callback for flattenReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback flattenReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 */
	
	/**
	 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name flattenReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
	 * ]);
	 *
	 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
	 *   //=previousValue
	 *   //=currentFeature
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   return currentFeature
	 * });
	 */
	function flattenReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    flattenEach(geojson, function (currentFeature, featureIndex, multiFeatureIndex) {
	        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
	        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
	    });
	    return previousValue;
	}
	
	/**
	 * Callback for segmentEach
	 *
	 * @callback segmentEachCallback
	 * @param {Feature<LineString>} currentSegment The current Segment being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 * @param {number} segmentIndex The current index of the Segment being processed.
	 * @returns {void}
	 */
	
	/**
	 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
	 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
	 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
	 * @returns {void}
	 * @example
	 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
	 *
	 * // Iterate over GeoJSON by 2-vertex segments
	 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	 *   //=currentSegment
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   //=segmentIndex
	 * });
	 *
	 * // Calculate the total number of segments
	 * var total = 0;
	 * turf.segmentEach(polygon, function () {
	 *     total++;
	 * });
	 */
	function segmentEach(geojson, callback) {
	    flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
	        var segmentIndex = 0;
	
	        // Exclude null Geometries
	        if (!feature.geometry) return;
	        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	        var type = feature.geometry.type;
	        if (type === 'Point' || type === 'MultiPoint') return;
	
	        // Generate 2-vertex line segments
	        var previousCoords;
	        var previousFeatureIndex = 0;
	        var previousMultiIndex = 0;
	        var prevGeomIndex = 0;
	        if (coordEach(feature, function (currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
	            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
	            if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
	                previousCoords = currentCoord;
	                previousFeatureIndex = featureIndex;
	                previousMultiIndex = multiPartIndexCoord;
	                prevGeomIndex = geometryIndex;
	                segmentIndex = 0;
	                return;
	            }
	            var currentSegment = helpers.lineString([previousCoords, currentCoord], feature.properties);
	            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
	            segmentIndex++;
	            previousCoords = currentCoord;
	        }) === false) return false;
	    });
	}
	
	/**
	 * Callback for segmentReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback segmentReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature<LineString>} currentSegment The current Segment being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 * @param {number} segmentIndex The current index of the Segment being processed.
	 */
	
	/**
	 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
	 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
	 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {void}
	 * @example
	 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
	 *
	 * // Iterate over GeoJSON by 2-vertex segments
	 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	 *   //= previousSegment
	 *   //= currentSegment
	 *   //= featureIndex
	 *   //= multiFeatureIndex
	 *   //= geometryIndex
	 *   //= segmentInex
	 *   return currentSegment
	 * });
	 *
	 * // Calculate the total number of segments
	 * var initialValue = 0
	 * var total = turf.segmentReduce(polygon, function (previousValue) {
	 *     previousValue++;
	 *     return previousValue;
	 * }, initialValue);
	 */
	function segmentReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    var started = false;
	    segmentEach(geojson, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	        if (started === false && initialValue === undefined) previousValue = currentSegment;
	        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
	        started = true;
	    });
	    return previousValue;
	}
	
	/**
	 * Callback for lineEach
	 *
	 * @callback lineEachCallback
	 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
	 * @param {number} featureIndex The current index of the Feature being processed
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
	 * @param {number} geometryIndex The current index of the Geometry being processed
	 */
	
	/**
	 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
	 * similar to Array.forEach.
	 *
	 * @name lineEach
	 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
	 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
	 * @example
	 * var multiLine = turf.multiLineString([
	 *   [[26, 37], [35, 45]],
	 *   [[36, 53], [38, 50], [41, 55]]
	 * ]);
	 *
	 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=currentLine
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 * });
	 */
	function lineEach(geojson, callback) {
	    // validation
	    if (!geojson) throw new Error('geojson is required');
	
	    flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
	        if (feature.geometry === null) return;
	        var type = feature.geometry.type;
	        var coords = feature.geometry.coordinates;
	        switch (type) {
	        case 'LineString':
	            if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
	            break;
	        case 'Polygon':
	            for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
	                if (callback(helpers.lineString(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	            }
	            break;
	        }
	    });
	}
	
	/**
	 * Callback for lineReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback lineReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
	 * @param {number} featureIndex The current index of the Feature being processed
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
	 * @param {number} geometryIndex The current index of the Geometry being processed
	 */
	
	/**
	 * Reduce features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name lineReduce
	 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
	 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var multiPoly = turf.multiPolygon([
	 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
	 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
	 * ]);
	 *
	 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=previousValue
	 *   //=currentLine
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   return currentLine
	 * });
	 */
	function lineReduce(geojson, callback, initialValue) {
	    var previousValue = initialValue;
	    lineEach(geojson, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
	        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
	    });
	    return previousValue;
	}
	
	/**
	 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
	 *
	 * Negative indexes are permitted.
	 * Point & MultiPoint will always return null.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
	 * @param {Object} [options={}] Optional parameters
	 * @param {number} [options.featureIndex=0] Feature Index
	 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
	 * @param {number} [options.geometryIndex=0] Geometry Index
	 * @param {number} [options.segmentIndex=0] Segment Index
	 * @param {Object} [options.properties={}] Translate Properties to output LineString
	 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
	 * @param {number|string} [options.id={}] Translate Id to output LineString
	 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
	 * @example
	 * var multiLine = turf.multiLineString([
	 *     [[10, 10], [50, 30], [30, 40]],
	 *     [[-10, -10], [-50, -30], [-30, -40]]
	 * ]);
	 *
	 * // First Segment (defaults are 0)
	 * turf.findSegment(multiLine);
	 * // => Feature<LineString<[[10, 10], [50, 30]]>>
	 *
	 * // First Segment of 2nd Multi Feature
	 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
	 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
	 *
	 * // Last Segment of Last Multi Feature
	 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
	 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
	 */
	function findSegment(geojson, options) {
	    // Optional Parameters
	    options = options || {};
	    if (!helpers.isObject(options)) throw new Error('options is invalid');
	    var featureIndex = options.featureIndex || 0;
	    var multiFeatureIndex = options.multiFeatureIndex || 0;
	    var geometryIndex = options.geometryIndex || 0;
	    var segmentIndex = options.segmentIndex || 0;
	
	    // Find FeatureIndex
	    var properties = options.properties;
	    var geometry;
	
	    switch (geojson.type) {
	    case 'FeatureCollection':
	        if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
	        properties = properties || geojson.features[featureIndex].properties;
	        geometry = geojson.features[featureIndex].geometry;
	        break;
	    case 'Feature':
	        properties = properties || geojson.properties;
	        geometry = geojson.geometry;
	        break;
	    case 'Point':
	    case 'MultiPoint':
	        return null;
	    case 'LineString':
	    case 'Polygon':
	    case 'MultiLineString':
	    case 'MultiPolygon':
	        geometry = geojson;
	        break;
	    default:
	        throw new Error('geojson is invalid');
	    }
	
	    // Find SegmentIndex
	    if (geometry === null) return null;
	    var coords = geometry.coordinates;
	    switch (geometry.type) {
	    case 'Point':
	    case 'MultiPoint':
	        return null;
	    case 'LineString':
	        if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
	        return helpers.lineString([coords[segmentIndex], coords[segmentIndex + 1]], properties, options);
	    case 'Polygon':
	        if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	        if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
	        return helpers.lineString([coords[geometryIndex][segmentIndex], coords[geometryIndex][segmentIndex + 1]], properties, options);
	    case 'MultiLineString':
	        if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	        if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
	        return helpers.lineString([coords[multiFeatureIndex][segmentIndex], coords[multiFeatureIndex][segmentIndex + 1]], properties, options);
	    case 'MultiPolygon':
	        if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	        if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	        if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
	        return helpers.lineString([coords[multiFeatureIndex][geometryIndex][segmentIndex], coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]], properties, options);
	    }
	    throw new Error('geojson is invalid');
	}
	
	/**
	 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
	 *
	 * Negative indexes are permitted.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
	 * @param {Object} [options={}] Optional parameters
	 * @param {number} [options.featureIndex=0] Feature Index
	 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
	 * @param {number} [options.geometryIndex=0] Geometry Index
	 * @param {number} [options.coordIndex=0] Coord Index
	 * @param {Object} [options.properties={}] Translate Properties to output Point
	 * @param {BBox} [options.bbox={}] Translate BBox to output Point
	 * @param {number|string} [options.id={}] Translate Id to output Point
	 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
	 * @example
	 * var multiLine = turf.multiLineString([
	 *     [[10, 10], [50, 30], [30, 40]],
	 *     [[-10, -10], [-50, -30], [-30, -40]]
	 * ]);
	 *
	 * // First Segment (defaults are 0)
	 * turf.findPoint(multiLine);
	 * // => Feature<Point<[10, 10]>>
	 *
	 * // First Segment of the 2nd Multi-Feature
	 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
	 * // => Feature<Point<[-10, -10]>>
	 *
	 * // Last Segment of last Multi-Feature
	 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
	 * // => Feature<Point<[-30, -40]>>
	 */
	function findPoint(geojson, options) {
	    // Optional Parameters
	    options = options || {};
	    if (!helpers.isObject(options)) throw new Error('options is invalid');
	    var featureIndex = options.featureIndex || 0;
	    var multiFeatureIndex = options.multiFeatureIndex || 0;
	    var geometryIndex = options.geometryIndex || 0;
	    var coordIndex = options.coordIndex || 0;
	
	    // Find FeatureIndex
	    var properties = options.properties;
	    var geometry;
	
	    switch (geojson.type) {
	    case 'FeatureCollection':
	        if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
	        properties = properties || geojson.features[featureIndex].properties;
	        geometry = geojson.features[featureIndex].geometry;
	        break;
	    case 'Feature':
	        properties = properties || geojson.properties;
	        geometry = geojson.geometry;
	        break;
	    case 'Point':
	    case 'MultiPoint':
	        return null;
	    case 'LineString':
	    case 'Polygon':
	    case 'MultiLineString':
	    case 'MultiPolygon':
	        geometry = geojson;
	        break;
	    default:
	        throw new Error('geojson is invalid');
	    }
	
	    // Find Coord Index
	    if (geometry === null) return null;
	    var coords = geometry.coordinates;
	    switch (geometry.type) {
	    case 'Point':
	        return helpers.point(coords, properties, options);
	    case 'MultiPoint':
	        if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	        return helpers.point(coords[multiFeatureIndex], properties, options);
	    case 'LineString':
	        if (coordIndex < 0) coordIndex = coords.length + coordIndex;
	        return helpers.point(coords[coordIndex], properties, options);
	    case 'Polygon':
	        if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	        if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
	        return helpers.point(coords[geometryIndex][coordIndex], properties, options);
	    case 'MultiLineString':
	        if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	        if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
	        return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
	    case 'MultiPolygon':
	        if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	        if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	        if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
	        return helpers.point(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
	    }
	    throw new Error('geojson is invalid');
	}
	
	exports.coordEach = coordEach;
	exports.coordReduce = coordReduce;
	exports.propEach = propEach;
	exports.propReduce = propReduce;
	exports.featureEach = featureEach;
	exports.featureReduce = featureReduce;
	exports.coordAll = coordAll;
	exports.geomEach = geomEach;
	exports.geomReduce = geomReduce;
	exports.flattenEach = flattenEach;
	exports.flattenReduce = flattenReduce;
	exports.segmentEach = segmentEach;
	exports.segmentReduce = segmentReduce;
	exports.lineEach = lineEach;
	exports.lineReduce = lineReduce;
	exports.findSegment = findSegment;
	exports.findPoint = findPoint;
	
	},{"@turf/helpers":59}],61:[function(_dereq_,module,exports){
	'use strict'
	
	var weakMap      = typeof WeakMap === 'undefined' ? _dereq_('weak-map') : WeakMap
	var createBuffer = _dereq_('gl-buffer')
	var createVAO    = _dereq_('gl-vao')
	
	var TriangleCache = new weakMap()
	
	function createABigTriangle(gl) {
	
	  var triangleVAO = TriangleCache.get(gl)
	  var handle = triangleVAO && (triangleVAO._triangleBuffer.handle || triangleVAO._triangleBuffer.buffer)
	  if(!handle || !gl.isBuffer(handle)) {
	    var buf = createBuffer(gl, new Float32Array([-1, -1, -1, 4, 4, -1]))
	    triangleVAO = createVAO(gl, [
	      { buffer: buf,
	        type: gl.FLOAT,
	        size: 2
	      }
	    ])
	    triangleVAO._triangleBuffer = buf
	    TriangleCache.set(gl, triangleVAO)
	  }
	  triangleVAO.bind()
	  gl.drawArrays(gl.TRIANGLES, 0, 3)
	  triangleVAO.unbind()
	}
	
	module.exports = createABigTriangle
	
	},{"gl-buffer":243,"gl-vao":328,"weak-map":550}],62:[function(_dereq_,module,exports){
	
	module.exports = absolutize
	
	/**
	 * redefine `path` with absolute coordinates
	 *
	 * @param {Array} path
	 * @return {Array}
	 */
	
	function absolutize(path){
		var startX = 0
		var startY = 0
		var x = 0
		var y = 0
	
		return path.map(function(seg){
			seg = seg.slice()
			var type = seg[0]
			var command = type.toUpperCase()
	
			// is relative
			if (type != command) {
				seg[0] = command
				switch (type) {
					case 'a':
						seg[6] += x
						seg[7] += y
						break
					case 'v':
						seg[1] += y
						break
					case 'h':
						seg[1] += x
						break
					default:
						for (var i = 1; i < seg.length;) {
							seg[i++] += x
							seg[i++] += y
						}
				}
			}
	
			// update cursor state
			switch (command) {
				case 'Z':
					x = startX
					y = startY
					break
				case 'H':
					x = seg[1]
					break
				case 'V':
					y = seg[1]
					break
				case 'M':
					x = startX = seg[1]
					y = startY = seg[2]
					break
				default:
					x = seg[seg.length - 2]
					y = seg[seg.length - 1]
			}
	
			return seg
		})
	}
	
	},{}],63:[function(_dereq_,module,exports){
	var padLeft = _dereq_('pad-left')
	
	module.exports = addLineNumbers
	function addLineNumbers (string, start, delim) {
	  start = typeof start === 'number' ? start : 1
	  delim = delim || ': '
	
	  var lines = string.split(/\r?\n/)
	  var totalDigits = String(lines.length + start - 1).length
	  return lines.map(function (line, i) {
	    var c = i + start
	    var digits = String(c).length
	    var prefix = padLeft(c, totalDigits - digits)
	    return prefix + delim + line
	  }).join('\n')
	}
	
	},{"pad-left":458}],64:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = affineHull
	
	var orient = _dereq_('robust-orientation')
	
	function linearlyIndependent(points, d) {
	  var nhull = new Array(d+1)
	  for(var i=0; i<points.length; ++i) {
	    nhull[i] = points[i]
	  }
	  for(var i=0; i<=points.length; ++i) {
	    for(var j=points.length; j<=d; ++j) {
	      var x = new Array(d)
	      for(var k=0; k<d; ++k) {
	        x[k] = Math.pow(j+1-i, k)
	      }
	      nhull[j] = x
	    }
	    var o = orient.apply(void 0, nhull)
	    if(o) {
	      return true
	    }
	  }
	  return false
	}
	
	function affineHull(points) {
	  var n = points.length
	  if(n === 0) {
	    return []
	  }
	  if(n === 1) {
	    return [0]
	  }
	  var d = points[0].length
	  var frame = [ points[0] ]
	  var index = [ 0 ]
	  for(var i=1; i<n; ++i) {
	    frame.push(points[i])
	    if(!linearlyIndependent(frame, d)) {
	      frame.pop()
	      continue
	    }
	    index.push(i)
	    if(index.length === d+1) {
	      return index
	    }
	  }
	  return index
	}
	},{"robust-orientation":508}],65:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = alphaComplex
	
	var delaunay = _dereq_('delaunay-triangulate')
	var circumradius = _dereq_('circumradius')
	
	function alphaComplex(alpha, points) {
	  return delaunay(points).filter(function(cell) {
	    var simplex = new Array(cell.length)
	    for(var i=0; i<cell.length; ++i) {
	      simplex[i] = points[cell[i]]
	    }
	    return circumradius(simplex) * alpha < 1
	  })
	}
	},{"circumradius":115,"delaunay-triangulate":166}],66:[function(_dereq_,module,exports){
	module.exports = alphaShape
	
	var ac = _dereq_('alpha-complex')
	var bnd = _dereq_('simplicial-complex-boundary')
	
	function alphaShape(alpha, points) {
	  return bnd(ac(alpha, points))
	}
	},{"alpha-complex":65,"simplicial-complex-boundary":515}],67:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = normalize;
	
	function normalize (arr, dim) {
		if (!arr || arr.length == null) throw Error('Argument should be an array')
	
		if (dim == null) dim = 1
		else dim = Math.floor(dim)
	
		var bounds = Array(dim * 2)
	
		for (var offset = 0; offset < dim; offset++) {
			var max = -Infinity, min = Infinity, i = offset, l = arr.length;
	
			for (; i < l; i+=dim) {
				if (arr[i] > max) max = arr[i];
				if (arr[i] < min) min = arr[i];
			}
	
			bounds[offset] = min
			bounds[dim + offset] = max
		}
	
		return bounds;
	}
	
	},{}],68:[function(_dereq_,module,exports){
	
	module.exports = function newArray(start, end) {
	    var n0 = typeof start === 'number',
	        n1 = typeof end === 'number'
	
	    if (n0 && !n1) {
	        end = start
	        start = 0
	    } else if (!n0 && !n1) {
	        start = 0
	        end = 0
	    }
	
	    start = start|0
	    end = end|0
	    var len = end-start
	    if (len<0)
	        throw new Error('array length must be positive')
	    
	    var a = new Array(len)
	    for (var i=0, c=start; i<len; i++, c++)
	        a[i] = c
	    return a
	}
	},{}],69:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	
	var objectAssign = _dereq_('object-assign');
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = _dereq_('util/');
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"object-assign":455,"util/":72}],70:[function(_dereq_,module,exports){
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	
	},{}],71:[function(_dereq_,module,exports){
	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}
	},{}],72:[function(_dereq_,module,exports){
	(function (process,global){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = _dereq_('./support/isBuffer');
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = _dereq_('inherits');
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./support/isBuffer":71,"_process":483,"inherits":70}],73:[function(_dereq_,module,exports){
	module.exports = function _atob(str) {
	  return atob(str)
	}
	
	},{}],74:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = barycentric
	
	var solve = _dereq_('robust-linear-solve')
	
	function reduce(x) {
	  var r = 0
	  for(var i=0; i<x.length; ++i) {
	    r += x[i]
	  }
	  return r
	}
	
	function barycentric(simplex, point) {
	  var d = point.length
	  var A = new Array(d+1)
	  for(var i=0; i<d; ++i) {
	    var row = new Array(d+1)
	    for(var j=0; j<=d; ++j) {
	      row[j] = simplex[j][i]
	    }
	    A[i] = row
	  }
	  A[d] = new Array(d+1)
	  for(var i=0; i<=d; ++i) {
	    A[d][i] = 1
	  }
	
	  var b = new Array(d+1)
	  for(var i=0; i<d; ++i) {
	    b[i] = point[i]
	  }
	  b[d] = 1.0
	
	  var x = solve(A, b)
	  var w = reduce(x[d+1])
	  
	  if(w === 0) {
	    w = 1.0
	  }
	  var y = new Array(d+1)
	  for(var i=0; i<=d; ++i) {
	    y[i] = reduce(x[i]) / w
	  }
	  return y
	}
	},{"robust-linear-solve":507}],75:[function(_dereq_,module,exports){
	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}
	
	},{}],76:[function(_dereq_,module,exports){
	'use strict'
	
	var rationalize = _dereq_('./lib/rationalize')
	
	module.exports = add
	
	function add(a, b) {
	  return rationalize(
	    a[0].mul(b[1]).add(b[0].mul(a[1])),
	    a[1].mul(b[1]))
	}
	
	},{"./lib/rationalize":86}],77:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = cmp
	
	function cmp(a, b) {
	    return a[0].mul(b[1]).cmp(b[0].mul(a[1]))
	}
	
	},{}],78:[function(_dereq_,module,exports){
	'use strict'
	
	var rationalize = _dereq_('./lib/rationalize')
	
	module.exports = div
	
	function div(a, b) {
	  return rationalize(a[0].mul(b[1]), a[1].mul(b[0]))
	}
	
	},{"./lib/rationalize":86}],79:[function(_dereq_,module,exports){
	'use strict'
	
	var isRat = _dereq_('./is-rat')
	var isBN = _dereq_('./lib/is-bn')
	var num2bn = _dereq_('./lib/num-to-bn')
	var str2bn = _dereq_('./lib/str-to-bn')
	var rationalize = _dereq_('./lib/rationalize')
	var div = _dereq_('./div')
	
	module.exports = makeRational
	
	function makeRational(numer, denom) {
	  if(isRat(numer)) {
	    if(denom) {
	      return div(numer, makeRational(denom))
	    }
	    return [numer[0].clone(), numer[1].clone()]
	  }
	  var shift = 0
	  var a, b
	  if(isBN(numer)) {
	    a = numer.clone()
	  } else if(typeof numer === 'string') {
	    a = str2bn(numer)
	  } else if(numer === 0) {
	    return [num2bn(0), num2bn(1)]
	  } else if(numer === Math.floor(numer)) {
	    a = num2bn(numer)
	  } else {
	    while(numer !== Math.floor(numer)) {
	      numer = numer * Math.pow(2, 256)
	      shift -= 256
	    }
	    a = num2bn(numer)
	  }
	  if(isRat(denom)) {
	    a.mul(denom[1])
	    b = denom[0].clone()
	  } else if(isBN(denom)) {
	    b = denom.clone()
	  } else if(typeof denom === 'string') {
	    b = str2bn(denom)
	  } else if(!denom) {
	    b = num2bn(1)
	  } else if(denom === Math.floor(denom)) {
	    b = num2bn(denom)
	  } else {
	    while(denom !== Math.floor(denom)) {
	      denom = denom * Math.pow(2, 256)
	      shift += 256
	    }
	    b = num2bn(denom)
	  }
	  if(shift > 0) {
	    a = a.ushln(shift)
	  } else if(shift < 0) {
	    b = b.ushln(-shift)
	  }
	  return rationalize(a, b)
	}
	
	},{"./div":78,"./is-rat":80,"./lib/is-bn":84,"./lib/num-to-bn":85,"./lib/rationalize":86,"./lib/str-to-bn":87}],80:[function(_dereq_,module,exports){
	'use strict'
	
	var isBN = _dereq_('./lib/is-bn')
	
	module.exports = isRat
	
	function isRat(x) {
	  return Array.isArray(x) && x.length === 2 && isBN(x[0]) && isBN(x[1])
	}
	
	},{"./lib/is-bn":84}],81:[function(_dereq_,module,exports){
	'use strict'
	
	var BN = _dereq_('bn.js')
	
	module.exports = sign
	
	function sign (x) {
	  return x.cmp(new BN(0))
	}
	
	},{"bn.js":95}],82:[function(_dereq_,module,exports){
	'use strict'
	
	var sign = _dereq_('./bn-sign')
	
	module.exports = bn2num
	
	//TODO: Make this better
	function bn2num(b) {
	  var l = b.length
	  var words = b.words
	  var out = 0
	  if (l === 1) {
	    out = words[0]
	  } else if (l === 2) {
	    out = words[0] + (words[1] * 0x4000000)
	  } else {
	    for (var i = 0; i < l; i++) {
	      var w = words[i]
	      out += w * Math.pow(0x4000000, i)
	    }
	  }
	  return sign(b) * out
	}
	
	},{"./bn-sign":81}],83:[function(_dereq_,module,exports){
	'use strict'
	
	var db = _dereq_('double-bits')
	var ctz = _dereq_('bit-twiddle').countTrailingZeros
	
	module.exports = ctzNumber
	
	//Counts the number of trailing zeros
	function ctzNumber(x) {
	  var l = ctz(db.lo(x))
	  if(l < 32) {
	    return l
	  }
	  var h = ctz(db.hi(x))
	  if(h > 20) {
	    return 52
	  }
	  return h + 32
	}
	
	},{"bit-twiddle":93,"double-bits":168}],84:[function(_dereq_,module,exports){
	'use strict'
	
	var BN = _dereq_('bn.js')
	
	module.exports = isBN
	
	//Test if x is a bignumber
	//FIXME: obviously this is the wrong way to do it
	function isBN(x) {
	  return x && typeof x === 'object' && Boolean(x.words)
	}
	
	},{"bn.js":95}],85:[function(_dereq_,module,exports){
	'use strict'
	
	var BN = _dereq_('bn.js')
	var db = _dereq_('double-bits')
	
	module.exports = num2bn
	
	function num2bn(x) {
	  var e = db.exponent(x)
	  if(e < 52) {
	    return new BN(x)
	  } else {
	    return (new BN(x * Math.pow(2, 52-e))).ushln(e-52)
	  }
	}
	
	},{"bn.js":95,"double-bits":168}],86:[function(_dereq_,module,exports){
	'use strict'
	
	var num2bn = _dereq_('./num-to-bn')
	var sign = _dereq_('./bn-sign')
	
	module.exports = rationalize
	
	function rationalize(numer, denom) {
	  var snumer = sign(numer)
	  var sdenom = sign(denom)
	  if(snumer === 0) {
	    return [num2bn(0), num2bn(1)]
	  }
	  if(sdenom === 0) {
	    return [num2bn(0), num2bn(0)]
	  }
	  if(sdenom < 0) {
	    numer = numer.neg()
	    denom = denom.neg()
	  }
	  var d = numer.gcd(denom)
	  if(d.cmpn(1)) {
	    return [ numer.div(d), denom.div(d) ]
	  }
	  return [ numer, denom ]
	}
	
	},{"./bn-sign":81,"./num-to-bn":85}],87:[function(_dereq_,module,exports){
	'use strict'
	
	var BN = _dereq_('bn.js')
	
	module.exports = str2BN
	
	function str2BN(x) {
	  return new BN(x)
	}
	
	},{"bn.js":95}],88:[function(_dereq_,module,exports){
	'use strict'
	
	var rationalize = _dereq_('./lib/rationalize')
	
	module.exports = mul
	
	function mul(a, b) {
	  return rationalize(a[0].mul(b[0]), a[1].mul(b[1]))
	}
	
	},{"./lib/rationalize":86}],89:[function(_dereq_,module,exports){
	'use strict'
	
	var bnsign = _dereq_('./lib/bn-sign')
	
	module.exports = sign
	
	function sign(x) {
	  return bnsign(x[0]) * bnsign(x[1])
	}
	
	},{"./lib/bn-sign":81}],90:[function(_dereq_,module,exports){
	'use strict'
	
	var rationalize = _dereq_('./lib/rationalize')
	
	module.exports = sub
	
	function sub(a, b) {
	  return rationalize(a[0].mul(b[1]).sub(a[1].mul(b[0])), a[1].mul(b[1]))
	}
	
	},{"./lib/rationalize":86}],91:[function(_dereq_,module,exports){
	'use strict'
	
	var bn2num = _dereq_('./lib/bn-to-num')
	var ctz = _dereq_('./lib/ctz')
	
	module.exports = roundRat
	
	// Round a rational to the closest float
	function roundRat (f) {
	  var a = f[0]
	  var b = f[1]
	  if (a.cmpn(0) === 0) {
	    return 0
	  }
	  var h = a.abs().divmod(b.abs())
	  var iv = h.div
	  var x = bn2num(iv)
	  var ir = h.mod
	  var sgn = (a.negative !== b.negative) ? -1 : 1
	  if (ir.cmpn(0) === 0) {
	    return sgn * x
	  }
	  if (x) {
	    var s = ctz(x) + 4
	    var y = bn2num(ir.ushln(s).divRound(b))
	    return sgn * (x + y * Math.pow(2, -s))
	  } else {
	    var ybits = b.bitLength() - ir.bitLength() + 53
	    var y = bn2num(ir.ushln(ybits).divRound(b))
	    if (ybits < 1023) {
	      return sgn * y * Math.pow(2, -ybits)
	    }
	    y *= Math.pow(2, -1023)
	    return sgn * y * Math.pow(2, 1023 - ybits)
	  }
	}
	
	},{"./lib/bn-to-num":82,"./lib/ctz":83}],92:[function(_dereq_,module,exports){
	"use strict"
	
	function compileSearch(funcName, predicate, reversed, extraArgs, useNdarray, earlyOut) {
	  var code = [
	    "function ", funcName, "(a,l,h,", extraArgs.join(","),  "){",
	earlyOut ? "" : "var i=", (reversed ? "l-1" : "h+1"),
	";while(l<=h){\
	var m=(l+h)>>>1,x=a", useNdarray ? ".get(m)" : "[m]"]
	  if(earlyOut) {
	    if(predicate.indexOf("c") < 0) {
	      code.push(";if(x===y){return m}else if(x<=y){")
	    } else {
	      code.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){")
	    }
	  } else {
	    code.push(";if(", predicate, "){i=m;")
	  }
	  if(reversed) {
	    code.push("l=m+1}else{h=m-1}")
	  } else {
	    code.push("h=m-1}else{l=m+1}")
	  }
	  code.push("}")
	  if(earlyOut) {
	    code.push("return -1};")
	  } else {
	    code.push("return i};")
	  }
	  return code.join("")
	}
	
	function compileBoundsSearch(predicate, reversed, suffix, earlyOut) {
	  var result = new Function([
	  compileSearch("A", "x" + predicate + "y", reversed, ["y"], false, earlyOut),
	  compileSearch("B", "x" + predicate + "y", reversed, ["y"], true, earlyOut),
	  compileSearch("P", "c(x,y)" + predicate + "0", reversed, ["y", "c"], false, earlyOut),
	  compileSearch("Q", "c(x,y)" + predicate + "0", reversed, ["y", "c"], true, earlyOut),
	"function dispatchBsearch", suffix, "(a,y,c,l,h){\
	if(a.shape){\
	if(typeof(c)==='function'){\
	return Q(a,(l===undefined)?0:l|0,(h===undefined)?a.shape[0]-1:h|0,y,c)\
	}else{\
	return B(a,(c===undefined)?0:c|0,(l===undefined)?a.shape[0]-1:l|0,y)\
	}}else{\
	if(typeof(c)==='function'){\
	return P(a,(l===undefined)?0:l|0,(h===undefined)?a.length-1:h|0,y,c)\
	}else{\
	return A(a,(c===undefined)?0:c|0,(l===undefined)?a.length-1:l|0,y)\
	}}}\
	return dispatchBsearch", suffix].join(""))
	  return result()
	}
	
	module.exports = {
	  ge: compileBoundsSearch(">=", false, "GE"),
	  gt: compileBoundsSearch(">", false, "GT"),
	  lt: compileBoundsSearch("<", true, "LT"),
	  le: compileBoundsSearch("<=", true, "LE"),
	  eq: compileBoundsSearch("-", true, "EQ", true)
	}
	
	},{}],93:[function(_dereq_,module,exports){
	/**
	 * Bit twiddling hacks for JavaScript.
	 *
	 * Author: Mikola Lysenko
	 *
	 * Ported from Stanford bit twiddling hack library:
	 *    http://graphics.stanford.edu/~seander/bithacks.html
	 */
	
	"use strict"; "use restrict";
	
	//Number of bits in an integer
	var INT_BITS = 32;
	
	//Constants
	exports.INT_BITS  = INT_BITS;
	exports.INT_MAX   =  0x7fffffff;
	exports.INT_MIN   = -1<<(INT_BITS-1);
	
	//Returns -1, 0, +1 depending on sign of x
	exports.sign = function(v) {
	  return (v > 0) - (v < 0);
	}
	
	//Computes absolute value of integer
	exports.abs = function(v) {
	  var mask = v >> (INT_BITS-1);
	  return (v ^ mask) - mask;
	}
	
	//Computes minimum of integers x and y
	exports.min = function(x, y) {
	  return y ^ ((x ^ y) & -(x < y));
	}
	
	//Computes maximum of integers x and y
	exports.max = function(x, y) {
	  return x ^ ((x ^ y) & -(x < y));
	}
	
	//Checks if a number is a power of two
	exports.isPow2 = function(v) {
	  return !(v & (v-1)) && (!!v);
	}
	
	//Computes log base 2 of v
	exports.log2 = function(v) {
	  var r, shift;
	  r =     (v > 0xFFFF) << 4; v >>>= r;
	  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
	  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
	  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
	  return r | (v >> 1);
	}
	
	//Computes log base 10 of v
	exports.log10 = function(v) {
	  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
	          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
	          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
	}
	
	//Counts number of bits
	exports.popCount = function(v) {
	  v = v - ((v >>> 1) & 0x55555555);
	  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
	  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
	}
	
	//Counts number of trailing zeros
	function countTrailingZeros(v) {
	  var c = 32;
	  v &= -v;
	  if (v) c--;
	  if (v & 0x0000FFFF) c -= 16;
	  if (v & 0x00FF00FF) c -= 8;
	  if (v & 0x0F0F0F0F) c -= 4;
	  if (v & 0x33333333) c -= 2;
	  if (v & 0x55555555) c -= 1;
	  return c;
	}
	exports.countTrailingZeros = countTrailingZeros;
	
	//Rounds to next power of 2
	exports.nextPow2 = function(v) {
	  v += v === 0;
	  --v;
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v + 1;
	}
	
	//Rounds down to previous power of 2
	exports.prevPow2 = function(v) {
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v - (v>>>1);
	}
	
	//Computes parity of word
	exports.parity = function(v) {
	  v ^= v >>> 16;
	  v ^= v >>> 8;
	  v ^= v >>> 4;
	  v &= 0xf;
	  return (0x6996 >>> v) & 1;
	}
	
	var REVERSE_TABLE = new Array(256);
	
	(function(tab) {
	  for(var i=0; i<256; ++i) {
	    var v = i, r = i, s = 7;
	    for (v >>>= 1; v; v >>>= 1) {
	      r <<= 1;
	      r |= v & 1;
	      --s;
	    }
	    tab[i] = (r << s) & 0xff;
	  }
	})(REVERSE_TABLE);
	
	//Reverse bits in a 32 bit word
	exports.reverse = function(v) {
	  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
	          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
	          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
	           REVERSE_TABLE[(v >>> 24) & 0xff];
	}
	
	//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
	exports.interleave2 = function(x, y) {
	  x &= 0xFFFF;
	  x = (x | (x << 8)) & 0x00FF00FF;
	  x = (x | (x << 4)) & 0x0F0F0F0F;
	  x = (x | (x << 2)) & 0x33333333;
	  x = (x | (x << 1)) & 0x55555555;
	
	  y &= 0xFFFF;
	  y = (y | (y << 8)) & 0x00FF00FF;
	  y = (y | (y << 4)) & 0x0F0F0F0F;
	  y = (y | (y << 2)) & 0x33333333;
	  y = (y | (y << 1)) & 0x55555555;
	
	  return x | (y << 1);
	}
	
	//Extracts the nth interleaved component
	exports.deinterleave2 = function(v, n) {
	  v = (v >>> n) & 0x55555555;
	  v = (v | (v >>> 1))  & 0x33333333;
	  v = (v | (v >>> 2))  & 0x0F0F0F0F;
	  v = (v | (v >>> 4))  & 0x00FF00FF;
	  v = (v | (v >>> 16)) & 0x000FFFF;
	  return (v << 16) >> 16;
	}
	
	
	//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
	exports.interleave3 = function(x, y, z) {
	  x &= 0x3FF;
	  x  = (x | (x<<16)) & 4278190335;
	  x  = (x | (x<<8))  & 251719695;
	  x  = (x | (x<<4))  & 3272356035;
	  x  = (x | (x<<2))  & 1227133513;
	
	  y &= 0x3FF;
	  y  = (y | (y<<16)) & 4278190335;
	  y  = (y | (y<<8))  & 251719695;
	  y  = (y | (y<<4))  & 3272356035;
	  y  = (y | (y<<2))  & 1227133513;
	  x |= (y << 1);
	  
	  z &= 0x3FF;
	  z  = (z | (z<<16)) & 4278190335;
	  z  = (z | (z<<8))  & 251719695;
	  z  = (z | (z<<4))  & 3272356035;
	  z  = (z | (z<<2))  & 1227133513;
	  
	  return x | (z << 2);
	}
	
	//Extracts nth interleaved component of a 3-tuple
	exports.deinterleave3 = function(v, n) {
	  v = (v >>> n)       & 1227133513;
	  v = (v | (v>>>2))   & 3272356035;
	  v = (v | (v>>>4))   & 251719695;
	  v = (v | (v>>>8))   & 4278190335;
	  v = (v | (v>>>16))  & 0x3FF;
	  return (v<<22)>>22;
	}
	
	//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
	exports.nextCombination = function(v) {
	  var t = v | (v - 1);
	  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
	}
	
	
	},{}],94:[function(_dereq_,module,exports){
	'use strict'
	
	var clamp = _dereq_('clamp')
	
	module.exports = calcSDF
	
	var INF = 1e20;
	
	function calcSDF(src, options) {
	    if (!options) options = {}
	
	    var cutoff = options.cutoff == null ? 0.25 : options.cutoff
	    var radius = options.radius == null ? 8 : options.radius
	    var channel = options.channel || 0
	    var w, h, size, data, intData, stride, ctx, canvas, imgData, i, l
	
	    // handle image container
	    if (ArrayBuffer.isView(src) || Array.isArray(src)) {
	        if (!options.width || !options.height) throw Error('For raw data width and height should be provided by options')
	        w = options.width, h = options.height
	        data = src
	
	        if (!options.stride) stride = Math.floor(src.length / w / h)
	        else stride = options.stride
	    }
	    else {
	        if (window.HTMLCanvasElement && src instanceof window.HTMLCanvasElement) {
	            canvas = src
	            ctx = canvas.getContext('2d')
	            w = canvas.width, h = canvas.height
	            imgData = ctx.getImageData(0, 0, w, h)
	            data = imgData.data
	            stride = 4
	        }
	        else if (window.CanvasRenderingContext2D && src instanceof window.CanvasRenderingContext2D) {
	            canvas = src.canvas
	            ctx = src
	            w = canvas.width, h = canvas.height
	            imgData = ctx.getImageData(0, 0, w, h)
	            data = imgData.data
	            stride = 4
	        }
	        else if (window.ImageData && src instanceof window.ImageData) {
	            imgData = src
	            w = src.width, h = src.height
	            data = imgData.data
	            stride = 4
	        }
	    }
	
	    size = Math.max(w, h)
	
	    //convert int data to floats
	    if ((window.Uint8ClampedArray && data instanceof window.Uint8ClampedArray) || (window.Uint8Array && data instanceof window.Uint8Array)) {
	        intData = data
	        data = Array(w*h)
	
	        for (i = 0, l = intData.length; i < l; i++) {
	            data[i] = intData[i*stride + channel] / 255
	        }
	    }
	    else {
	        if (stride !== 1) throw Error('Raw data can have only 1 value per pixel')
	    }
	
	    // temporary arrays for the distance transform
	    var gridOuter = Array(w * h)
	    var gridInner = Array(w * h)
	    var f = Array(size)
	    var d = Array(size)
	    var z = Array(size + 1)
	    var v = Array(size)
	
	    for (i = 0, l = w * h; i < l; i++) {
	        var a = data[i]
	        gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2)
	        gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2)
	    }
	
	    edt(gridOuter, w, h, f, d, v, z)
	    edt(gridInner, w, h, f, d, v, z)
	
	    var dist = window.Float32Array ? new Float32Array(w * h) : new Array(w * h)
	
	    for (i = 0, l = w*h; i < l; i++) {
	        dist[i] = clamp(1 - ( (gridOuter[i] - gridInner[i]) / radius + cutoff), 0, 1)
	    }
	
	    return dist
	}
	
	// 2D Euclidean distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/dt/
	function edt(data, width, height, f, d, v, z) {
	    for (var x = 0; x < width; x++) {
	        for (var y = 0; y < height; y++) {
	            f[y] = data[y * width + x]
	        }
	        edt1d(f, d, v, z, height)
	        for (y = 0; y < height; y++) {
	            data[y * width + x] = d[y]
	        }
	    }
	    for (y = 0; y < height; y++) {
	        for (x = 0; x < width; x++) {
	            f[x] = data[y * width + x]
	        }
	        edt1d(f, d, v, z, width)
	        for (x = 0; x < width; x++) {
	            data[y * width + x] = Math.sqrt(d[x])
	        }
	    }
	}
	
	// 1D squared distance transform
	function edt1d(f, d, v, z, n) {
	    v[0] = 0;
	    z[0] = -INF
	    z[1] = +INF
	
	    for (var q = 1, k = 0; q < n; q++) {
	        var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
	        while (s <= z[k]) {
	            k--
	            s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
	        }
	        k++
	        v[k] = q
	        z[k] = s
	        z[k + 1] = +INF
	    }
	
	    for (q = 0, k = 0; q < n; q++) {
	        while (z[k + 1] < q) k++
	        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]]
	    }
	}
	
	},{"clamp":116}],95:[function(_dereq_,module,exports){
	(function (module, exports) {
	  'use strict';
	
	  // Utils
	  function assert (val, msg) {
	    if (!val) throw new Error(msg || 'Assertion failed');
	  }
	
	  // Could use `inherits` module, but don't want to move from single file
	  // architecture yet.
	  function inherits (ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  }
	
	  // BN
	
	  function BN (number, base, endian) {
	    if (BN.isBN(number)) {
	      return number;
	    }
	
	    this.negative = 0;
	    this.words = null;
	    this.length = 0;
	
	    // Reduction context
	    this.red = null;
	
	    if (number !== null) {
	      if (base === 'le' || base === 'be') {
	        endian = base;
	        base = 10;
	      }
	
	      this._init(number || 0, base || 10, endian || 'be');
	    }
	  }
	  if (typeof module === 'object') {
	    module.exports = BN;
	  } else {
	    exports.BN = BN;
	  }
	
	  BN.BN = BN;
	  BN.wordSize = 26;
	
	  var Buffer;
	  try {
	    Buffer = _dereq_('buffer').Buffer;
	  } catch (e) {
	  }
	
	  BN.isBN = function isBN (num) {
	    if (num instanceof BN) {
	      return true;
	    }
	
	    return num !== null && typeof num === 'object' &&
	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
	  };
	
	  BN.max = function max (left, right) {
	    if (left.cmp(right) > 0) return left;
	    return right;
	  };
	
	  BN.min = function min (left, right) {
	    if (left.cmp(right) < 0) return left;
	    return right;
	  };
	
	  BN.prototype._init = function init (number, base, endian) {
	    if (typeof number === 'number') {
	      return this._initNumber(number, base, endian);
	    }
	
	    if (typeof number === 'object') {
	      return this._initArray(number, base, endian);
	    }
	
	    if (base === 'hex') {
	      base = 16;
	    }
	    assert(base === (base | 0) && base >= 2 && base <= 36);
	
	    number = number.toString().replace(/\s+/g, '');
	    var start = 0;
	    if (number[0] === '-') {
	      start++;
	    }
	
	    if (base === 16) {
	      this._parseHex(number, start);
	    } else {
	      this._parseBase(number, base, start);
	    }
	
	    if (number[0] === '-') {
	      this.negative = 1;
	    }
	
	    this.strip();
	
	    if (endian !== 'le') return;
	
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
	    if (number < 0) {
	      this.negative = 1;
	      number = -number;
	    }
	    if (number < 0x4000000) {
	      this.words = [ number & 0x3ffffff ];
	      this.length = 1;
	    } else if (number < 0x10000000000000) {
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff
	      ];
	      this.length = 2;
	    } else {
	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff,
	        1
	      ];
	      this.length = 3;
	    }
	
	    if (endian !== 'le') return;
	
	    // Reverse the bytes
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initArray = function _initArray (number, base, endian) {
	    // Perhaps a Uint8Array
	    assert(typeof number.length === 'number');
	    if (number.length <= 0) {
	      this.words = [ 0 ];
	      this.length = 1;
	      return this;
	    }
	
	    this.length = Math.ceil(number.length / 3);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    var off = 0;
	    if (endian === 'be') {
	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    } else if (endian === 'le') {
	      for (i = 0, j = 0; i < number.length; i += 3) {
	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    }
	    return this.strip();
	  };
	
	  function parseHex (str, start, end) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r <<= 4;
	
	      // 'a' - 'f'
	      if (c >= 49 && c <= 54) {
	        r |= c - 49 + 0xa;
	
	      // 'A' - 'F'
	      } else if (c >= 17 && c <= 22) {
	        r |= c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r |= c & 0xf;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseHex = function _parseHex (number, start) {
	    // Create possibly bigger array to ensure that it fits the number
	    this.length = Math.ceil((number.length - start) / 6);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    // Scan 24-bit chunks and add them to the number
	    var off = 0;
	    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
	      w = parseHex(number, i, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	      off += 24;
	      if (off >= 26) {
	        off -= 26;
	        j++;
	      }
	    }
	    if (i + 6 !== start) {
	      w = parseHex(number, start, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	    }
	    this.strip();
	  };
	
	  function parseBase (str, start, end, mul) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r *= mul;
	
	      // 'a'
	      if (c >= 49) {
	        r += c - 49 + 0xa;
	
	      // 'A'
	      } else if (c >= 17) {
	        r += c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r += c;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseBase = function _parseBase (number, base, start) {
	    // Initialize as zero
	    this.words = [ 0 ];
	    this.length = 1;
	
	    // Find length of limb in base
	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
	      limbLen++;
	    }
	    limbLen--;
	    limbPow = (limbPow / base) | 0;
	
	    var total = number.length - start;
	    var mod = total % limbLen;
	    var end = Math.min(total, total - mod) + start;
	
	    var word = 0;
	    for (var i = start; i < end; i += limbLen) {
	      word = parseBase(number, i, i + limbLen, base);
	
	      this.imuln(limbPow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	
	    if (mod !== 0) {
	      var pow = 1;
	      word = parseBase(number, i, number.length, base);
	
	      for (i = 0; i < mod; i++) {
	        pow *= base;
	      }
	
	      this.imuln(pow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	  };
	
	  BN.prototype.copy = function copy (dest) {
	    dest.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      dest.words[i] = this.words[i];
	    }
	    dest.length = this.length;
	    dest.negative = this.negative;
	    dest.red = this.red;
	  };
	
	  BN.prototype.clone = function clone () {
	    var r = new BN(null);
	    this.copy(r);
	    return r;
	  };
	
	  BN.prototype._expand = function _expand (size) {
	    while (this.length < size) {
	      this.words[this.length++] = 0;
	    }
	    return this;
	  };
	
	  // Remove leading `0` from `this`
	  BN.prototype.strip = function strip () {
	    while (this.length > 1 && this.words[this.length - 1] === 0) {
	      this.length--;
	    }
	    return this._normSign();
	  };
	
	  BN.prototype._normSign = function _normSign () {
	    // -0 = 0
	    if (this.length === 1 && this.words[0] === 0) {
	      this.negative = 0;
	    }
	    return this;
	  };
	
	  BN.prototype.inspect = function inspect () {
	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
	  };
	
	  /*
	
	  var zeros = [];
	  var groupSizes = [];
	  var groupBases = [];
	
	  var s = '';
	  var i = -1;
	  while (++i < BN.wordSize) {
	    zeros[i] = s;
	    s += '0';
	  }
	  groupSizes[0] = 0;
	  groupSizes[1] = 0;
	  groupBases[0] = 0;
	  groupBases[1] = 0;
	  var base = 2 - 1;
	  while (++base < 36 + 1) {
	    var groupSize = 0;
	    var groupBase = 1;
	    while (groupBase < (1 << BN.wordSize) / base) {
	      groupBase *= base;
	      groupSize += 1;
	    }
	    groupSizes[base] = groupSize;
	    groupBases[base] = groupBase;
	  }
	
	  */
	
	  var zeros = [
	    '',
	    '0',
	    '00',
	    '000',
	    '0000',
	    '00000',
	    '000000',
	    '0000000',
	    '00000000',
	    '000000000',
	    '0000000000',
	    '00000000000',
	    '000000000000',
	    '0000000000000',
	    '00000000000000',
	    '000000000000000',
	    '0000000000000000',
	    '00000000000000000',
	    '000000000000000000',
	    '0000000000000000000',
	    '00000000000000000000',
	    '000000000000000000000',
	    '0000000000000000000000',
	    '00000000000000000000000',
	    '000000000000000000000000',
	    '0000000000000000000000000'
	  ];
	
	  var groupSizes = [
	    0, 0,
	    25, 16, 12, 11, 10, 9, 8,
	    8, 7, 7, 7, 7, 6, 6,
	    6, 6, 6, 6, 6, 5, 5,
	    5, 5, 5, 5, 5, 5, 5,
	    5, 5, 5, 5, 5, 5, 5
	  ];
	
	  var groupBases = [
	    0, 0,
	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
	  ];
	
	  BN.prototype.toString = function toString (base, padding) {
	    base = base || 10;
	    padding = padding | 0 || 1;
	
	    var out;
	    if (base === 16 || base === 'hex') {
	      out = '';
	      var off = 0;
	      var carry = 0;
	      for (var i = 0; i < this.length; i++) {
	        var w = this.words[i];
	        var word = (((w << off) | carry) & 0xffffff).toString(16);
	        carry = (w >>> (24 - off)) & 0xffffff;
	        if (carry !== 0 || i !== this.length - 1) {
	          out = zeros[6 - word.length] + word + out;
	        } else {
	          out = word + out;
	        }
	        off += 2;
	        if (off >= 26) {
	          off -= 26;
	          i--;
	        }
	      }
	      if (carry !== 0) {
	        out = carry.toString(16) + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    if (base === (base | 0) && base >= 2 && base <= 36) {
	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
	      var groupSize = groupSizes[base];
	      // var groupBase = Math.pow(base, groupSize);
	      var groupBase = groupBases[base];
	      out = '';
	      var c = this.clone();
	      c.negative = 0;
	      while (!c.isZero()) {
	        var r = c.modn(groupBase).toString(base);
	        c = c.idivn(groupBase);
	
	        if (!c.isZero()) {
	          out = zeros[groupSize - r.length] + r + out;
	        } else {
	          out = r + out;
	        }
	      }
	      if (this.isZero()) {
	        out = '0' + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    assert(false, 'Base should be between 2 and 36');
	  };
	
	  BN.prototype.toNumber = function toNumber () {
	    var ret = this.words[0];
	    if (this.length === 2) {
	      ret += this.words[1] * 0x4000000;
	    } else if (this.length === 3 && this.words[2] === 0x01) {
	      // NOTE: at this stage it is known that the top bit is set
	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
	    } else if (this.length > 2) {
	      assert(false, 'Number can only safely store up to 53 bits');
	    }
	    return (this.negative !== 0) ? -ret : ret;
	  };
	
	  BN.prototype.toJSON = function toJSON () {
	    return this.toString(16);
	  };
	
	  BN.prototype.toBuffer = function toBuffer (endian, length) {
	    assert(typeof Buffer !== 'undefined');
	    return this.toArrayLike(Buffer, endian, length);
	  };
	
	  BN.prototype.toArray = function toArray (endian, length) {
	    return this.toArrayLike(Array, endian, length);
	  };
	
	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
	    var byteLength = this.byteLength();
	    var reqLength = length || Math.max(1, byteLength);
	    assert(byteLength <= reqLength, 'byte array longer than desired length');
	    assert(reqLength > 0, 'Requested array length <= 0');
	
	    this.strip();
	    var littleEndian = endian === 'le';
	    var res = new ArrayType(reqLength);
	
	    var b, i;
	    var q = this.clone();
	    if (!littleEndian) {
	      // Assume big-endian
	      for (i = 0; i < reqLength - byteLength; i++) {
	        res[i] = 0;
	      }
	
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[reqLength - i - 1] = b;
	      }
	    } else {
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[i] = b;
	      }
	
	      for (; i < reqLength; i++) {
	        res[i] = 0;
	      }
	    }
	
	    return res;
	  };
	
	  if (Math.clz32) {
	    BN.prototype._countBits = function _countBits (w) {
	      return 32 - Math.clz32(w);
	    };
	  } else {
	    BN.prototype._countBits = function _countBits (w) {
	      var t = w;
	      var r = 0;
	      if (t >= 0x1000) {
	        r += 13;
	        t >>>= 13;
	      }
	      if (t >= 0x40) {
	        r += 7;
	        t >>>= 7;
	      }
	      if (t >= 0x8) {
	        r += 4;
	        t >>>= 4;
	      }
	      if (t >= 0x02) {
	        r += 2;
	        t >>>= 2;
	      }
	      return r + t;
	    };
	  }
	
	  BN.prototype._zeroBits = function _zeroBits (w) {
	    // Short-cut
	    if (w === 0) return 26;
	
	    var t = w;
	    var r = 0;
	    if ((t & 0x1fff) === 0) {
	      r += 13;
	      t >>>= 13;
	    }
	    if ((t & 0x7f) === 0) {
	      r += 7;
	      t >>>= 7;
	    }
	    if ((t & 0xf) === 0) {
	      r += 4;
	      t >>>= 4;
	    }
	    if ((t & 0x3) === 0) {
	      r += 2;
	      t >>>= 2;
	    }
	    if ((t & 0x1) === 0) {
	      r++;
	    }
	    return r;
	  };
	
	  // Return number of used bits in a BN
	  BN.prototype.bitLength = function bitLength () {
	    var w = this.words[this.length - 1];
	    var hi = this._countBits(w);
	    return (this.length - 1) * 26 + hi;
	  };
	
	  function toBitArray (num) {
	    var w = new Array(num.bitLength());
	
	    for (var bit = 0; bit < w.length; bit++) {
	      var off = (bit / 26) | 0;
	      var wbit = bit % 26;
	
	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
	    }
	
	    return w;
	  }
	
	  // Number of trailing zero bits
	  BN.prototype.zeroBits = function zeroBits () {
	    if (this.isZero()) return 0;
	
	    var r = 0;
	    for (var i = 0; i < this.length; i++) {
	      var b = this._zeroBits(this.words[i]);
	      r += b;
	      if (b !== 26) break;
	    }
	    return r;
	  };
	
	  BN.prototype.byteLength = function byteLength () {
	    return Math.ceil(this.bitLength() / 8);
	  };
	
	  BN.prototype.toTwos = function toTwos (width) {
	    if (this.negative !== 0) {
	      return this.abs().inotn(width).iaddn(1);
	    }
	    return this.clone();
	  };
	
	  BN.prototype.fromTwos = function fromTwos (width) {
	    if (this.testn(width - 1)) {
	      return this.notn(width).iaddn(1).ineg();
	    }
	    return this.clone();
	  };
	
	  BN.prototype.isNeg = function isNeg () {
	    return this.negative !== 0;
	  };
	
	  // Return negative clone of `this`
	  BN.prototype.neg = function neg () {
	    return this.clone().ineg();
	  };
	
	  BN.prototype.ineg = function ineg () {
	    if (!this.isZero()) {
	      this.negative ^= 1;
	    }
	
	    return this;
	  };
	
	  // Or `num` with `this` in-place
	  BN.prototype.iuor = function iuor (num) {
	    while (this.length < num.length) {
	      this.words[this.length++] = 0;
	    }
	
	    for (var i = 0; i < num.length; i++) {
	      this.words[i] = this.words[i] | num.words[i];
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ior = function ior (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuor(num);
	  };
	
	  // Or `num` with `this`
	  BN.prototype.or = function or (num) {
	    if (this.length > num.length) return this.clone().ior(num);
	    return num.clone().ior(this);
	  };
	
	  BN.prototype.uor = function uor (num) {
	    if (this.length > num.length) return this.clone().iuor(num);
	    return num.clone().iuor(this);
	  };
	
	  // And `num` with `this` in-place
	  BN.prototype.iuand = function iuand (num) {
	    // b = min-length(num, this)
	    var b;
	    if (this.length > num.length) {
	      b = num;
	    } else {
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = this.words[i] & num.words[i];
	    }
	
	    this.length = b.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.iand = function iand (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuand(num);
	  };
	
	  // And `num` with `this`
	  BN.prototype.and = function and (num) {
	    if (this.length > num.length) return this.clone().iand(num);
	    return num.clone().iand(this);
	  };
	
	  BN.prototype.uand = function uand (num) {
	    if (this.length > num.length) return this.clone().iuand(num);
	    return num.clone().iuand(this);
	  };
	
	  // Xor `num` with `this` in-place
	  BN.prototype.iuxor = function iuxor (num) {
	    // a.length > b.length
	    var a;
	    var b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = a.words[i] ^ b.words[i];
	    }
	
	    if (this !== a) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = a.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.ixor = function ixor (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuxor(num);
	  };
	
	  // Xor `num` with `this`
	  BN.prototype.xor = function xor (num) {
	    if (this.length > num.length) return this.clone().ixor(num);
	    return num.clone().ixor(this);
	  };
	
	  BN.prototype.uxor = function uxor (num) {
	    if (this.length > num.length) return this.clone().iuxor(num);
	    return num.clone().iuxor(this);
	  };
	
	  // Not ``this`` with ``width`` bitwidth
	  BN.prototype.inotn = function inotn (width) {
	    assert(typeof width === 'number' && width >= 0);
	
	    var bytesNeeded = Math.ceil(width / 26) | 0;
	    var bitsLeft = width % 26;
	
	    // Extend the buffer with leading zeroes
	    this._expand(bytesNeeded);
	
	    if (bitsLeft > 0) {
	      bytesNeeded--;
	    }
	
	    // Handle complete words
	    for (var i = 0; i < bytesNeeded; i++) {
	      this.words[i] = ~this.words[i] & 0x3ffffff;
	    }
	
	    // Handle the residue
	    if (bitsLeft > 0) {
	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
	    }
	
	    // And remove leading zeroes
	    return this.strip();
	  };
	
	  BN.prototype.notn = function notn (width) {
	    return this.clone().inotn(width);
	  };
	
	  // Set `bit` of `this`
	  BN.prototype.setn = function setn (bit, val) {
	    assert(typeof bit === 'number' && bit >= 0);
	
	    var off = (bit / 26) | 0;
	    var wbit = bit % 26;
	
	    this._expand(off + 1);
	
	    if (val) {
	      this.words[off] = this.words[off] | (1 << wbit);
	    } else {
	      this.words[off] = this.words[off] & ~(1 << wbit);
	    }
	
	    return this.strip();
	  };
	
	  // Add `num` to `this` in-place
	  BN.prototype.iadd = function iadd (num) {
	    var r;
	
	    // negative + positive
	    if (this.negative !== 0 && num.negative === 0) {
	      this.negative = 0;
	      r = this.isub(num);
	      this.negative ^= 1;
	      return this._normSign();
	
	    // positive + negative
	    } else if (this.negative === 0 && num.negative !== 0) {
	      num.negative = 0;
	      r = this.isub(num);
	      num.negative = 1;
	      return r._normSign();
	    }
	
	    // a.length > b.length
	    var a, b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	
	    this.length = a.length;
	    if (carry !== 0) {
	      this.words[this.length] = carry;
	      this.length++;
	    // Copy the rest of the words
	    } else if (a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    return this;
	  };
	
	  // Add `num` to `this`
	  BN.prototype.add = function add (num) {
	    var res;
	    if (num.negative !== 0 && this.negative === 0) {
	      num.negative = 0;
	      res = this.sub(num);
	      num.negative ^= 1;
	      return res;
	    } else if (num.negative === 0 && this.negative !== 0) {
	      this.negative = 0;
	      res = num.sub(this);
	      this.negative = 1;
	      return res;
	    }
	
	    if (this.length > num.length) return this.clone().iadd(num);
	
	    return num.clone().iadd(this);
	  };
	
	  // Subtract `num` from `this` in-place
	  BN.prototype.isub = function isub (num) {
	    // this - (-num) = this + num
	    if (num.negative !== 0) {
	      num.negative = 0;
	      var r = this.iadd(num);
	      num.negative = 1;
	      return r._normSign();
	
	    // -this - num = -(this + num)
	    } else if (this.negative !== 0) {
	      this.negative = 0;
	      this.iadd(num);
	      this.negative = 1;
	      return this._normSign();
	    }
	
	    // At this point both numbers are positive
	    var cmp = this.cmp(num);
	
	    // Optimization - zeroify
	    if (cmp === 0) {
	      this.negative = 0;
	      this.length = 1;
	      this.words[0] = 0;
	      return this;
	    }
	
	    // a > b
	    var a, b;
	    if (cmp > 0) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	
	    // Copy rest of the words
	    if (carry === 0 && i < a.length && a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = Math.max(this.length, i);
	
	    if (a !== this) {
	      this.negative = 1;
	    }
	
	    return this.strip();
	  };
	
	  // Subtract `num` from `this`
	  BN.prototype.sub = function sub (num) {
	    return this.clone().isub(num);
	  };
	
	  function smallMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    var len = (self.length + num.length) | 0;
	    out.length = len;
	    len = (len - 1) | 0;
	
	    // Peel one iteration (compiler can't do it, because of code complexity)
	    var a = self.words[0] | 0;
	    var b = num.words[0] | 0;
	    var r = a * b;
	
	    var lo = r & 0x3ffffff;
	    var carry = (r / 0x4000000) | 0;
	    out.words[0] = lo;
	
	    for (var k = 1; k < len; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = carry >>> 26;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = (k - j) | 0;
	        a = self.words[i] | 0;
	        b = num.words[j] | 0;
	        r = a * b + rword;
	        ncarry += (r / 0x4000000) | 0;
	        rword = r & 0x3ffffff;
	      }
	      out.words[k] = rword | 0;
	      carry = ncarry | 0;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry | 0;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  // TODO(indutny): it may be reasonable to omit it for users who don't need
	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
	  // multiplication (like elliptic secp256k1).
	  var comb10MulTo = function comb10MulTo (self, num, out) {
	    var a = self.words;
	    var b = num.words;
	    var o = out.words;
	    var c = 0;
	    var lo;
	    var mid;
	    var hi;
	    var a0 = a[0] | 0;
	    var al0 = a0 & 0x1fff;
	    var ah0 = a0 >>> 13;
	    var a1 = a[1] | 0;
	    var al1 = a1 & 0x1fff;
	    var ah1 = a1 >>> 13;
	    var a2 = a[2] | 0;
	    var al2 = a2 & 0x1fff;
	    var ah2 = a2 >>> 13;
	    var a3 = a[3] | 0;
	    var al3 = a3 & 0x1fff;
	    var ah3 = a3 >>> 13;
	    var a4 = a[4] | 0;
	    var al4 = a4 & 0x1fff;
	    var ah4 = a4 >>> 13;
	    var a5 = a[5] | 0;
	    var al5 = a5 & 0x1fff;
	    var ah5 = a5 >>> 13;
	    var a6 = a[6] | 0;
	    var al6 = a6 & 0x1fff;
	    var ah6 = a6 >>> 13;
	    var a7 = a[7] | 0;
	    var al7 = a7 & 0x1fff;
	    var ah7 = a7 >>> 13;
	    var a8 = a[8] | 0;
	    var al8 = a8 & 0x1fff;
	    var ah8 = a8 >>> 13;
	    var a9 = a[9] | 0;
	    var al9 = a9 & 0x1fff;
	    var ah9 = a9 >>> 13;
	    var b0 = b[0] | 0;
	    var bl0 = b0 & 0x1fff;
	    var bh0 = b0 >>> 13;
	    var b1 = b[1] | 0;
	    var bl1 = b1 & 0x1fff;
	    var bh1 = b1 >>> 13;
	    var b2 = b[2] | 0;
	    var bl2 = b2 & 0x1fff;
	    var bh2 = b2 >>> 13;
	    var b3 = b[3] | 0;
	    var bl3 = b3 & 0x1fff;
	    var bh3 = b3 >>> 13;
	    var b4 = b[4] | 0;
	    var bl4 = b4 & 0x1fff;
	    var bh4 = b4 >>> 13;
	    var b5 = b[5] | 0;
	    var bl5 = b5 & 0x1fff;
	    var bh5 = b5 >>> 13;
	    var b6 = b[6] | 0;
	    var bl6 = b6 & 0x1fff;
	    var bh6 = b6 >>> 13;
	    var b7 = b[7] | 0;
	    var bl7 = b7 & 0x1fff;
	    var bh7 = b7 >>> 13;
	    var b8 = b[8] | 0;
	    var bl8 = b8 & 0x1fff;
	    var bh8 = b8 >>> 13;
	    var b9 = b[9] | 0;
	    var bl9 = b9 & 0x1fff;
	    var bh9 = b9 >>> 13;
	
	    out.negative = self.negative ^ num.negative;
	    out.length = 19;
	    /* k = 0 */
	    lo = Math.imul(al0, bl0);
	    mid = Math.imul(al0, bh0);
	    mid = (mid + Math.imul(ah0, bl0)) | 0;
	    hi = Math.imul(ah0, bh0);
	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
	    w0 &= 0x3ffffff;
	    /* k = 1 */
	    lo = Math.imul(al1, bl0);
	    mid = Math.imul(al1, bh0);
	    mid = (mid + Math.imul(ah1, bl0)) | 0;
	    hi = Math.imul(ah1, bh0);
	    lo = (lo + Math.imul(al0, bl1)) | 0;
	    mid = (mid + Math.imul(al0, bh1)) | 0;
	    mid = (mid + Math.imul(ah0, bl1)) | 0;
	    hi = (hi + Math.imul(ah0, bh1)) | 0;
	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
	    w1 &= 0x3ffffff;
	    /* k = 2 */
	    lo = Math.imul(al2, bl0);
	    mid = Math.imul(al2, bh0);
	    mid = (mid + Math.imul(ah2, bl0)) | 0;
	    hi = Math.imul(ah2, bh0);
	    lo = (lo + Math.imul(al1, bl1)) | 0;
	    mid = (mid + Math.imul(al1, bh1)) | 0;
	    mid = (mid + Math.imul(ah1, bl1)) | 0;
	    hi = (hi + Math.imul(ah1, bh1)) | 0;
	    lo = (lo + Math.imul(al0, bl2)) | 0;
	    mid = (mid + Math.imul(al0, bh2)) | 0;
	    mid = (mid + Math.imul(ah0, bl2)) | 0;
	    hi = (hi + Math.imul(ah0, bh2)) | 0;
	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
	    w2 &= 0x3ffffff;
	    /* k = 3 */
	    lo = Math.imul(al3, bl0);
	    mid = Math.imul(al3, bh0);
	    mid = (mid + Math.imul(ah3, bl0)) | 0;
	    hi = Math.imul(ah3, bh0);
	    lo = (lo + Math.imul(al2, bl1)) | 0;
	    mid = (mid + Math.imul(al2, bh1)) | 0;
	    mid = (mid + Math.imul(ah2, bl1)) | 0;
	    hi = (hi + Math.imul(ah2, bh1)) | 0;
	    lo = (lo + Math.imul(al1, bl2)) | 0;
	    mid = (mid + Math.imul(al1, bh2)) | 0;
	    mid = (mid + Math.imul(ah1, bl2)) | 0;
	    hi = (hi + Math.imul(ah1, bh2)) | 0;
	    lo = (lo + Math.imul(al0, bl3)) | 0;
	    mid = (mid + Math.imul(al0, bh3)) | 0;
	    mid = (mid + Math.imul(ah0, bl3)) | 0;
	    hi = (hi + Math.imul(ah0, bh3)) | 0;
	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
	    w3 &= 0x3ffffff;
	    /* k = 4 */
	    lo = Math.imul(al4, bl0);
	    mid = Math.imul(al4, bh0);
	    mid = (mid + Math.imul(ah4, bl0)) | 0;
	    hi = Math.imul(ah4, bh0);
	    lo = (lo + Math.imul(al3, bl1)) | 0;
	    mid = (mid + Math.imul(al3, bh1)) | 0;
	    mid = (mid + Math.imul(ah3, bl1)) | 0;
	    hi = (hi + Math.imul(ah3, bh1)) | 0;
	    lo = (lo + Math.imul(al2, bl2)) | 0;
	    mid = (mid + Math.imul(al2, bh2)) | 0;
	    mid = (mid + Math.imul(ah2, bl2)) | 0;
	    hi = (hi + Math.imul(ah2, bh2)) | 0;
	    lo = (lo + Math.imul(al1, bl3)) | 0;
	    mid = (mid + Math.imul(al1, bh3)) | 0;
	    mid = (mid + Math.imul(ah1, bl3)) | 0;
	    hi = (hi + Math.imul(ah1, bh3)) | 0;
	    lo = (lo + Math.imul(al0, bl4)) | 0;
	    mid = (mid + Math.imul(al0, bh4)) | 0;
	    mid = (mid + Math.imul(ah0, bl4)) | 0;
	    hi = (hi + Math.imul(ah0, bh4)) | 0;
	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
	    w4 &= 0x3ffffff;
	    /* k = 5 */
	    lo = Math.imul(al5, bl0);
	    mid = Math.imul(al5, bh0);
	    mid = (mid + Math.imul(ah5, bl0)) | 0;
	    hi = Math.imul(ah5, bh0);
	    lo = (lo + Math.imul(al4, bl1)) | 0;
	    mid = (mid + Math.imul(al4, bh1)) | 0;
	    mid = (mid + Math.imul(ah4, bl1)) | 0;
	    hi = (hi + Math.imul(ah4, bh1)) | 0;
	    lo = (lo + Math.imul(al3, bl2)) | 0;
	    mid = (mid + Math.imul(al3, bh2)) | 0;
	    mid = (mid + Math.imul(ah3, bl2)) | 0;
	    hi = (hi + Math.imul(ah3, bh2)) | 0;
	    lo = (lo + Math.imul(al2, bl3)) | 0;
	    mid = (mid + Math.imul(al2, bh3)) | 0;
	    mid = (mid + Math.imul(ah2, bl3)) | 0;
	    hi = (hi + Math.imul(ah2, bh3)) | 0;
	    lo = (lo + Math.imul(al1, bl4)) | 0;
	    mid = (mid + Math.imul(al1, bh4)) | 0;
	    mid = (mid + Math.imul(ah1, bl4)) | 0;
	    hi = (hi + Math.imul(ah1, bh4)) | 0;
	    lo = (lo + Math.imul(al0, bl5)) | 0;
	    mid = (mid + Math.imul(al0, bh5)) | 0;
	    mid = (mid + Math.imul(ah0, bl5)) | 0;
	    hi = (hi + Math.imul(ah0, bh5)) | 0;
	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
	    w5 &= 0x3ffffff;
	    /* k = 6 */
	    lo = Math.imul(al6, bl0);
	    mid = Math.imul(al6, bh0);
	    mid = (mid + Math.imul(ah6, bl0)) | 0;
	    hi = Math.imul(ah6, bh0);
	    lo = (lo + Math.imul(al5, bl1)) | 0;
	    mid = (mid + Math.imul(al5, bh1)) | 0;
	    mid = (mid + Math.imul(ah5, bl1)) | 0;
	    hi = (hi + Math.imul(ah5, bh1)) | 0;
	    lo = (lo + Math.imul(al4, bl2)) | 0;
	    mid = (mid + Math.imul(al4, bh2)) | 0;
	    mid = (mid + Math.imul(ah4, bl2)) | 0;
	    hi = (hi + Math.imul(ah4, bh2)) | 0;
	    lo = (lo + Math.imul(al3, bl3)) | 0;
	    mid = (mid + Math.imul(al3, bh3)) | 0;
	    mid = (mid + Math.imul(ah3, bl3)) | 0;
	    hi = (hi + Math.imul(ah3, bh3)) | 0;
	    lo = (lo + Math.imul(al2, bl4)) | 0;
	    mid = (mid + Math.imul(al2, bh4)) | 0;
	    mid = (mid + Math.imul(ah2, bl4)) | 0;
	    hi = (hi + Math.imul(ah2, bh4)) | 0;
	    lo = (lo + Math.imul(al1, bl5)) | 0;
	    mid = (mid + Math.imul(al1, bh5)) | 0;
	    mid = (mid + Math.imul(ah1, bl5)) | 0;
	    hi = (hi + Math.imul(ah1, bh5)) | 0;
	    lo = (lo + Math.imul(al0, bl6)) | 0;
	    mid = (mid + Math.imul(al0, bh6)) | 0;
	    mid = (mid + Math.imul(ah0, bl6)) | 0;
	    hi = (hi + Math.imul(ah0, bh6)) | 0;
	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
	    w6 &= 0x3ffffff;
	    /* k = 7 */
	    lo = Math.imul(al7, bl0);
	    mid = Math.imul(al7, bh0);
	    mid = (mid + Math.imul(ah7, bl0)) | 0;
	    hi = Math.imul(ah7, bh0);
	    lo = (lo + Math.imul(al6, bl1)) | 0;
	    mid = (mid + Math.imul(al6, bh1)) | 0;
	    mid = (mid + Math.imul(ah6, bl1)) | 0;
	    hi = (hi + Math.imul(ah6, bh1)) | 0;
	    lo = (lo + Math.imul(al5, bl2)) | 0;
	    mid = (mid + Math.imul(al5, bh2)) | 0;
	    mid = (mid + Math.imul(ah5, bl2)) | 0;
	    hi = (hi + Math.imul(ah5, bh2)) | 0;
	    lo = (lo + Math.imul(al4, bl3)) | 0;
	    mid = (mid + Math.imul(al4, bh3)) | 0;
	    mid = (mid + Math.imul(ah4, bl3)) | 0;
	    hi = (hi + Math.imul(ah4, bh3)) | 0;
	    lo = (lo + Math.imul(al3, bl4)) | 0;
	    mid = (mid + Math.imul(al3, bh4)) | 0;
	    mid = (mid + Math.imul(ah3, bl4)) | 0;
	    hi = (hi + Math.imul(ah3, bh4)) | 0;
	    lo = (lo + Math.imul(al2, bl5)) | 0;
	    mid = (mid + Math.imul(al2, bh5)) | 0;
	    mid = (mid + Math.imul(ah2, bl5)) | 0;
	    hi = (hi + Math.imul(ah2, bh5)) | 0;
	    lo = (lo + Math.imul(al1, bl6)) | 0;
	    mid = (mid + Math.imul(al1, bh6)) | 0;
	    mid = (mid + Math.imul(ah1, bl6)) | 0;
	    hi = (hi + Math.imul(ah1, bh6)) | 0;
	    lo = (lo + Math.imul(al0, bl7)) | 0;
	    mid = (mid + Math.imul(al0, bh7)) | 0;
	    mid = (mid + Math.imul(ah0, bl7)) | 0;
	    hi = (hi + Math.imul(ah0, bh7)) | 0;
	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
	    w7 &= 0x3ffffff;
	    /* k = 8 */
	    lo = Math.imul(al8, bl0);
	    mid = Math.imul(al8, bh0);
	    mid = (mid + Math.imul(ah8, bl0)) | 0;
	    hi = Math.imul(ah8, bh0);
	    lo = (lo + Math.imul(al7, bl1)) | 0;
	    mid = (mid + Math.imul(al7, bh1)) | 0;
	    mid = (mid + Math.imul(ah7, bl1)) | 0;
	    hi = (hi + Math.imul(ah7, bh1)) | 0;
	    lo = (lo + Math.imul(al6, bl2)) | 0;
	    mid = (mid + Math.imul(al6, bh2)) | 0;
	    mid = (mid + Math.imul(ah6, bl2)) | 0;
	    hi = (hi + Math.imul(ah6, bh2)) | 0;
	    lo = (lo + Math.imul(al5, bl3)) | 0;
	    mid = (mid + Math.imul(al5, bh3)) | 0;
	    mid = (mid + Math.imul(ah5, bl3)) | 0;
	    hi = (hi + Math.imul(ah5, bh3)) | 0;
	    lo = (lo + Math.imul(al4, bl4)) | 0;
	    mid = (mid + Math.imul(al4, bh4)) | 0;
	    mid = (mid + Math.imul(ah4, bl4)) | 0;
	    hi = (hi + Math.imul(ah4, bh4)) | 0;
	    lo = (lo + Math.imul(al3, bl5)) | 0;
	    mid = (mid + Math.imul(al3, bh5)) | 0;
	    mid = (mid + Math.imul(ah3, bl5)) | 0;
	    hi = (hi + Math.imul(ah3, bh5)) | 0;
	    lo = (lo + Math.imul(al2, bl6)) | 0;
	    mid = (mid + Math.imul(al2, bh6)) | 0;
	    mid = (mid + Math.imul(ah2, bl6)) | 0;
	    hi = (hi + Math.imul(ah2, bh6)) | 0;
	    lo = (lo + Math.imul(al1, bl7)) | 0;
	    mid = (mid + Math.imul(al1, bh7)) | 0;
	    mid = (mid + Math.imul(ah1, bl7)) | 0;
	    hi = (hi + Math.imul(ah1, bh7)) | 0;
	    lo = (lo + Math.imul(al0, bl8)) | 0;
	    mid = (mid + Math.imul(al0, bh8)) | 0;
	    mid = (mid + Math.imul(ah0, bl8)) | 0;
	    hi = (hi + Math.imul(ah0, bh8)) | 0;
	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
	    w8 &= 0x3ffffff;
	    /* k = 9 */
	    lo = Math.imul(al9, bl0);
	    mid = Math.imul(al9, bh0);
	    mid = (mid + Math.imul(ah9, bl0)) | 0;
	    hi = Math.imul(ah9, bh0);
	    lo = (lo + Math.imul(al8, bl1)) | 0;
	    mid = (mid + Math.imul(al8, bh1)) | 0;
	    mid = (mid + Math.imul(ah8, bl1)) | 0;
	    hi = (hi + Math.imul(ah8, bh1)) | 0;
	    lo = (lo + Math.imul(al7, bl2)) | 0;
	    mid = (mid + Math.imul(al7, bh2)) | 0;
	    mid = (mid + Math.imul(ah7, bl2)) | 0;
	    hi = (hi + Math.imul(ah7, bh2)) | 0;
	    lo = (lo + Math.imul(al6, bl3)) | 0;
	    mid = (mid + Math.imul(al6, bh3)) | 0;
	    mid = (mid + Math.imul(ah6, bl3)) | 0;
	    hi = (hi + Math.imul(ah6, bh3)) | 0;
	    lo = (lo + Math.imul(al5, bl4)) | 0;
	    mid = (mid + Math.imul(al5, bh4)) | 0;
	    mid = (mid + Math.imul(ah5, bl4)) | 0;
	    hi = (hi + Math.imul(ah5, bh4)) | 0;
	    lo = (lo + Math.imul(al4, bl5)) | 0;
	    mid = (mid + Math.imul(al4, bh5)) | 0;
	    mid = (mid + Math.imul(ah4, bl5)) | 0;
	    hi = (hi + Math.imul(ah4, bh5)) | 0;
	    lo = (lo + Math.imul(al3, bl6)) | 0;
	    mid = (mid + Math.imul(al3, bh6)) | 0;
	    mid = (mid + Math.imul(ah3, bl6)) | 0;
	    hi = (hi + Math.imul(ah3, bh6)) | 0;
	    lo = (lo + Math.imul(al2, bl7)) | 0;
	    mid = (mid + Math.imul(al2, bh7)) | 0;
	    mid = (mid + Math.imul(ah2, bl7)) | 0;
	    hi = (hi + Math.imul(ah2, bh7)) | 0;
	    lo = (lo + Math.imul(al1, bl8)) | 0;
	    mid = (mid + Math.imul(al1, bh8)) | 0;
	    mid = (mid + Math.imul(ah1, bl8)) | 0;
	    hi = (hi + Math.imul(ah1, bh8)) | 0;
	    lo = (lo + Math.imul(al0, bl9)) | 0;
	    mid = (mid + Math.imul(al0, bh9)) | 0;
	    mid = (mid + Math.imul(ah0, bl9)) | 0;
	    hi = (hi + Math.imul(ah0, bh9)) | 0;
	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
	    w9 &= 0x3ffffff;
	    /* k = 10 */
	    lo = Math.imul(al9, bl1);
	    mid = Math.imul(al9, bh1);
	    mid = (mid + Math.imul(ah9, bl1)) | 0;
	    hi = Math.imul(ah9, bh1);
	    lo = (lo + Math.imul(al8, bl2)) | 0;
	    mid = (mid + Math.imul(al8, bh2)) | 0;
	    mid = (mid + Math.imul(ah8, bl2)) | 0;
	    hi = (hi + Math.imul(ah8, bh2)) | 0;
	    lo = (lo + Math.imul(al7, bl3)) | 0;
	    mid = (mid + Math.imul(al7, bh3)) | 0;
	    mid = (mid + Math.imul(ah7, bl3)) | 0;
	    hi = (hi + Math.imul(ah7, bh3)) | 0;
	    lo = (lo + Math.imul(al6, bl4)) | 0;
	    mid = (mid + Math.imul(al6, bh4)) | 0;
	    mid = (mid + Math.imul(ah6, bl4)) | 0;
	    hi = (hi + Math.imul(ah6, bh4)) | 0;
	    lo = (lo + Math.imul(al5, bl5)) | 0;
	    mid = (mid + Math.imul(al5, bh5)) | 0;
	    mid = (mid + Math.imul(ah5, bl5)) | 0;
	    hi = (hi + Math.imul(ah5, bh5)) | 0;
	    lo = (lo + Math.imul(al4, bl6)) | 0;
	    mid = (mid + Math.imul(al4, bh6)) | 0;
	    mid = (mid + Math.imul(ah4, bl6)) | 0;
	    hi = (hi + Math.imul(ah4, bh6)) | 0;
	    lo = (lo + Math.imul(al3, bl7)) | 0;
	    mid = (mid + Math.imul(al3, bh7)) | 0;
	    mid = (mid + Math.imul(ah3, bl7)) | 0;
	    hi = (hi + Math.imul(ah3, bh7)) | 0;
	    lo = (lo + Math.imul(al2, bl8)) | 0;
	    mid = (mid + Math.imul(al2, bh8)) | 0;
	    mid = (mid + Math.imul(ah2, bl8)) | 0;
	    hi = (hi + Math.imul(ah2, bh8)) | 0;
	    lo = (lo + Math.imul(al1, bl9)) | 0;
	    mid = (mid + Math.imul(al1, bh9)) | 0;
	    mid = (mid + Math.imul(ah1, bl9)) | 0;
	    hi = (hi + Math.imul(ah1, bh9)) | 0;
	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
	    w10 &= 0x3ffffff;
	    /* k = 11 */
	    lo = Math.imul(al9, bl2);
	    mid = Math.imul(al9, bh2);
	    mid = (mid + Math.imul(ah9, bl2)) | 0;
	    hi = Math.imul(ah9, bh2);
	    lo = (lo + Math.imul(al8, bl3)) | 0;
	    mid = (mid + Math.imul(al8, bh3)) | 0;
	    mid = (mid + Math.imul(ah8, bl3)) | 0;
	    hi = (hi + Math.imul(ah8, bh3)) | 0;
	    lo = (lo + Math.imul(al7, bl4)) | 0;
	    mid = (mid + Math.imul(al7, bh4)) | 0;
	    mid = (mid + Math.imul(ah7, bl4)) | 0;
	    hi = (hi + Math.imul(ah7, bh4)) | 0;
	    lo = (lo + Math.imul(al6, bl5)) | 0;
	    mid = (mid + Math.imul(al6, bh5)) | 0;
	    mid = (mid + Math.imul(ah6, bl5)) | 0;
	    hi = (hi + Math.imul(ah6, bh5)) | 0;
	    lo = (lo + Math.imul(al5, bl6)) | 0;
	    mid = (mid + Math.imul(al5, bh6)) | 0;
	    mid = (mid + Math.imul(ah5, bl6)) | 0;
	    hi = (hi + Math.imul(ah5, bh6)) | 0;
	    lo = (lo + Math.imul(al4, bl7)) | 0;
	    mid = (mid + Math.imul(al4, bh7)) | 0;
	    mid = (mid + Math.imul(ah4, bl7)) | 0;
	    hi = (hi + Math.imul(ah4, bh7)) | 0;
	    lo = (lo + Math.imul(al3, bl8)) | 0;
	    mid = (mid + Math.imul(al3, bh8)) | 0;
	    mid = (mid + Math.imul(ah3, bl8)) | 0;
	    hi = (hi + Math.imul(ah3, bh8)) | 0;
	    lo = (lo + Math.imul(al2, bl9)) | 0;
	    mid = (mid + Math.imul(al2, bh9)) | 0;
	    mid = (mid + Math.imul(ah2, bl9)) | 0;
	    hi = (hi + Math.imul(ah2, bh9)) | 0;
	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
	    w11 &= 0x3ffffff;
	    /* k = 12 */
	    lo = Math.imul(al9, bl3);
	    mid = Math.imul(al9, bh3);
	    mid = (mid + Math.imul(ah9, bl3)) | 0;
	    hi = Math.imul(ah9, bh3);
	    lo = (lo + Math.imul(al8, bl4)) | 0;
	    mid = (mid + Math.imul(al8, bh4)) | 0;
	    mid = (mid + Math.imul(ah8, bl4)) | 0;
	    hi = (hi + Math.imul(ah8, bh4)) | 0;
	    lo = (lo + Math.imul(al7, bl5)) | 0;
	    mid = (mid + Math.imul(al7, bh5)) | 0;
	    mid = (mid + Math.imul(ah7, bl5)) | 0;
	    hi = (hi + Math.imul(ah7, bh5)) | 0;
	    lo = (lo + Math.imul(al6, bl6)) | 0;
	    mid = (mid + Math.imul(al6, bh6)) | 0;
	    mid = (mid + Math.imul(ah6, bl6)) | 0;
	    hi = (hi + Math.imul(ah6, bh6)) | 0;
	    lo = (lo + Math.imul(al5, bl7)) | 0;
	    mid = (mid + Math.imul(al5, bh7)) | 0;
	    mid = (mid + Math.imul(ah5, bl7)) | 0;
	    hi = (hi + Math.imul(ah5, bh7)) | 0;
	    lo = (lo + Math.imul(al4, bl8)) | 0;
	    mid = (mid + Math.imul(al4, bh8)) | 0;
	    mid = (mid + Math.imul(ah4, bl8)) | 0;
	    hi = (hi + Math.imul(ah4, bh8)) | 0;
	    lo = (lo + Math.imul(al3, bl9)) | 0;
	    mid = (mid + Math.imul(al3, bh9)) | 0;
	    mid = (mid + Math.imul(ah3, bl9)) | 0;
	    hi = (hi + Math.imul(ah3, bh9)) | 0;
	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
	    w12 &= 0x3ffffff;
	    /* k = 13 */
	    lo = Math.imul(al9, bl4);
	    mid = Math.imul(al9, bh4);
	    mid = (mid + Math.imul(ah9, bl4)) | 0;
	    hi = Math.imul(ah9, bh4);
	    lo = (lo + Math.imul(al8, bl5)) | 0;
	    mid = (mid + Math.imul(al8, bh5)) | 0;
	    mid = (mid + Math.imul(ah8, bl5)) | 0;
	    hi = (hi + Math.imul(ah8, bh5)) | 0;
	    lo = (lo + Math.imul(al7, bl6)) | 0;
	    mid = (mid + Math.imul(al7, bh6)) | 0;
	    mid = (mid + Math.imul(ah7, bl6)) | 0;
	    hi = (hi + Math.imul(ah7, bh6)) | 0;
	    lo = (lo + Math.imul(al6, bl7)) | 0;
	    mid = (mid + Math.imul(al6, bh7)) | 0;
	    mid = (mid + Math.imul(ah6, bl7)) | 0;
	    hi = (hi + Math.imul(ah6, bh7)) | 0;
	    lo = (lo + Math.imul(al5, bl8)) | 0;
	    mid = (mid + Math.imul(al5, bh8)) | 0;
	    mid = (mid + Math.imul(ah5, bl8)) | 0;
	    hi = (hi + Math.imul(ah5, bh8)) | 0;
	    lo = (lo + Math.imul(al4, bl9)) | 0;
	    mid = (mid + Math.imul(al4, bh9)) | 0;
	    mid = (mid + Math.imul(ah4, bl9)) | 0;
	    hi = (hi + Math.imul(ah4, bh9)) | 0;
	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
	    w13 &= 0x3ffffff;
	    /* k = 14 */
	    lo = Math.imul(al9, bl5);
	    mid = Math.imul(al9, bh5);
	    mid = (mid + Math.imul(ah9, bl5)) | 0;
	    hi = Math.imul(ah9, bh5);
	    lo = (lo + Math.imul(al8, bl6)) | 0;
	    mid = (mid + Math.imul(al8, bh6)) | 0;
	    mid = (mid + Math.imul(ah8, bl6)) | 0;
	    hi = (hi + Math.imul(ah8, bh6)) | 0;
	    lo = (lo + Math.imul(al7, bl7)) | 0;
	    mid = (mid + Math.imul(al7, bh7)) | 0;
	    mid = (mid + Math.imul(ah7, bl7)) | 0;
	    hi = (hi + Math.imul(ah7, bh7)) | 0;
	    lo = (lo + Math.imul(al6, bl8)) | 0;
	    mid = (mid + Math.imul(al6, bh8)) | 0;
	    mid = (mid + Math.imul(ah6, bl8)) | 0;
	    hi = (hi + Math.imul(ah6, bh8)) | 0;
	    lo = (lo + Math.imul(al5, bl9)) | 0;
	    mid = (mid + Math.imul(al5, bh9)) | 0;
	    mid = (mid + Math.imul(ah5, bl9)) | 0;
	    hi = (hi + Math.imul(ah5, bh9)) | 0;
	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
	    w14 &= 0x3ffffff;
	    /* k = 15 */
	    lo = Math.imul(al9, bl6);
	    mid = Math.imul(al9, bh6);
	    mid = (mid + Math.imul(ah9, bl6)) | 0;
	    hi = Math.imul(ah9, bh6);
	    lo = (lo + Math.imul(al8, bl7)) | 0;
	    mid = (mid + Math.imul(al8, bh7)) | 0;
	    mid = (mid + Math.imul(ah8, bl7)) | 0;
	    hi = (hi + Math.imul(ah8, bh7)) | 0;
	    lo = (lo + Math.imul(al7, bl8)) | 0;
	    mid = (mid + Math.imul(al7, bh8)) | 0;
	    mid = (mid + Math.imul(ah7, bl8)) | 0;
	    hi = (hi + Math.imul(ah7, bh8)) | 0;
	    lo = (lo + Math.imul(al6, bl9)) | 0;
	    mid = (mid + Math.imul(al6, bh9)) | 0;
	    mid = (mid + Math.imul(ah6, bl9)) | 0;
	    hi = (hi + Math.imul(ah6, bh9)) | 0;
	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
	    w15 &= 0x3ffffff;
	    /* k = 16 */
	    lo = Math.imul(al9, bl7);
	    mid = Math.imul(al9, bh7);
	    mid = (mid + Math.imul(ah9, bl7)) | 0;
	    hi = Math.imul(ah9, bh7);
	    lo = (lo + Math.imul(al8, bl8)) | 0;
	    mid = (mid + Math.imul(al8, bh8)) | 0;
	    mid = (mid + Math.imul(ah8, bl8)) | 0;
	    hi = (hi + Math.imul(ah8, bh8)) | 0;
	    lo = (lo + Math.imul(al7, bl9)) | 0;
	    mid = (mid + Math.imul(al7, bh9)) | 0;
	    mid = (mid + Math.imul(ah7, bl9)) | 0;
	    hi = (hi + Math.imul(ah7, bh9)) | 0;
	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
	    w16 &= 0x3ffffff;
	    /* k = 17 */
	    lo = Math.imul(al9, bl8);
	    mid = Math.imul(al9, bh8);
	    mid = (mid + Math.imul(ah9, bl8)) | 0;
	    hi = Math.imul(ah9, bh8);
	    lo = (lo + Math.imul(al8, bl9)) | 0;
	    mid = (mid + Math.imul(al8, bh9)) | 0;
	    mid = (mid + Math.imul(ah8, bl9)) | 0;
	    hi = (hi + Math.imul(ah8, bh9)) | 0;
	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
	    w17 &= 0x3ffffff;
	    /* k = 18 */
	    lo = Math.imul(al9, bl9);
	    mid = Math.imul(al9, bh9);
	    mid = (mid + Math.imul(ah9, bl9)) | 0;
	    hi = Math.imul(ah9, bh9);
	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
	    w18 &= 0x3ffffff;
	    o[0] = w0;
	    o[1] = w1;
	    o[2] = w2;
	    o[3] = w3;
	    o[4] = w4;
	    o[5] = w5;
	    o[6] = w6;
	    o[7] = w7;
	    o[8] = w8;
	    o[9] = w9;
	    o[10] = w10;
	    o[11] = w11;
	    o[12] = w12;
	    o[13] = w13;
	    o[14] = w14;
	    o[15] = w15;
	    o[16] = w16;
	    o[17] = w17;
	    o[18] = w18;
	    if (c !== 0) {
	      o[19] = c;
	      out.length++;
	    }
	    return out;
	  };
	
	  // Polyfill comb
	  if (!Math.imul) {
	    comb10MulTo = smallMulTo;
	  }
	
	  function bigMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    out.length = self.length + num.length;
	
	    var carry = 0;
	    var hncarry = 0;
	    for (var k = 0; k < out.length - 1; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = hncarry;
	      hncarry = 0;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j;
	        var a = self.words[i] | 0;
	        var b = num.words[j] | 0;
	        var r = a * b;
	
	        var lo = r & 0x3ffffff;
	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
	        lo = (lo + rword) | 0;
	        rword = lo & 0x3ffffff;
	        ncarry = (ncarry + (lo >>> 26)) | 0;
	
	        hncarry += ncarry >>> 26;
	        ncarry &= 0x3ffffff;
	      }
	      out.words[k] = rword;
	      carry = ncarry;
	      ncarry = hncarry;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  function jumboMulTo (self, num, out) {
	    var fftm = new FFTM();
	    return fftm.mulp(self, num, out);
	  }
	
	  BN.prototype.mulTo = function mulTo (num, out) {
	    var res;
	    var len = this.length + num.length;
	    if (this.length === 10 && num.length === 10) {
	      res = comb10MulTo(this, num, out);
	    } else if (len < 63) {
	      res = smallMulTo(this, num, out);
	    } else if (len < 1024) {
	      res = bigMulTo(this, num, out);
	    } else {
	      res = jumboMulTo(this, num, out);
	    }
	
	    return res;
	  };
	
	  // Cooley-Tukey algorithm for FFT
	  // slightly revisited to rely on looping instead of recursion
	
	  function FFTM (x, y) {
	    this.x = x;
	    this.y = y;
	  }
	
	  FFTM.prototype.makeRBT = function makeRBT (N) {
	    var t = new Array(N);
	    var l = BN.prototype._countBits(N) - 1;
	    for (var i = 0; i < N; i++) {
	      t[i] = this.revBin(i, l, N);
	    }
	
	    return t;
	  };
	
	  // Returns binary-reversed representation of `x`
	  FFTM.prototype.revBin = function revBin (x, l, N) {
	    if (x === 0 || x === N - 1) return x;
	
	    var rb = 0;
	    for (var i = 0; i < l; i++) {
	      rb |= (x & 1) << (l - i - 1);
	      x >>= 1;
	    }
	
	    return rb;
	  };
	
	  // Performs "tweedling" phase, therefore 'emulating'
	  // behaviour of the recursive algorithm
	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
	    for (var i = 0; i < N; i++) {
	      rtws[i] = rws[rbt[i]];
	      itws[i] = iws[rbt[i]];
	    }
	  };
	
	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
	    this.permute(rbt, rws, iws, rtws, itws, N);
	
	    for (var s = 1; s < N; s <<= 1) {
	      var l = s << 1;
	
	      var rtwdf = Math.cos(2 * Math.PI / l);
	      var itwdf = Math.sin(2 * Math.PI / l);
	
	      for (var p = 0; p < N; p += l) {
	        var rtwdf_ = rtwdf;
	        var itwdf_ = itwdf;
	
	        for (var j = 0; j < s; j++) {
	          var re = rtws[p + j];
	          var ie = itws[p + j];
	
	          var ro = rtws[p + j + s];
	          var io = itws[p + j + s];
	
	          var rx = rtwdf_ * ro - itwdf_ * io;
	
	          io = rtwdf_ * io + itwdf_ * ro;
	          ro = rx;
	
	          rtws[p + j] = re + ro;
	          itws[p + j] = ie + io;
	
	          rtws[p + j + s] = re - ro;
	          itws[p + j + s] = ie - io;
	
	          /* jshint maxdepth : false */
	          if (j !== l) {
	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
	
	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
	            rtwdf_ = rx;
	          }
	        }
	      }
	    }
	  };
	
	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
	    var N = Math.max(m, n) | 1;
	    var odd = N & 1;
	    var i = 0;
	    for (N = N / 2 | 0; N; N = N >>> 1) {
	      i++;
	    }
	
	    return 1 << i + 1 + odd;
	  };
	
	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
	    if (N <= 1) return;
	
	    for (var i = 0; i < N / 2; i++) {
	      var t = rws[i];
	
	      rws[i] = rws[N - i - 1];
	      rws[N - i - 1] = t;
	
	      t = iws[i];
	
	      iws[i] = -iws[N - i - 1];
	      iws[N - i - 1] = -t;
	    }
	  };
	
	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
	    var carry = 0;
	    for (var i = 0; i < N / 2; i++) {
	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
	        Math.round(ws[2 * i] / N) +
	        carry;
	
	      ws[i] = w & 0x3ffffff;
	
	      if (w < 0x4000000) {
	        carry = 0;
	      } else {
	        carry = w / 0x4000000 | 0;
	      }
	    }
	
	    return ws;
	  };
	
	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
	    var carry = 0;
	    for (var i = 0; i < len; i++) {
	      carry = carry + (ws[i] | 0);
	
	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
	    }
	
	    // Pad with zeroes
	    for (i = 2 * len; i < N; ++i) {
	      rws[i] = 0;
	    }
	
	    assert(carry === 0);
	    assert((carry & ~0x1fff) === 0);
	  };
	
	  FFTM.prototype.stub = function stub (N) {
	    var ph = new Array(N);
	    for (var i = 0; i < N; i++) {
	      ph[i] = 0;
	    }
	
	    return ph;
	  };
	
	  FFTM.prototype.mulp = function mulp (x, y, out) {
	    var N = 2 * this.guessLen13b(x.length, y.length);
	
	    var rbt = this.makeRBT(N);
	
	    var _ = this.stub(N);
	
	    var rws = new Array(N);
	    var rwst = new Array(N);
	    var iwst = new Array(N);
	
	    var nrws = new Array(N);
	    var nrwst = new Array(N);
	    var niwst = new Array(N);
	
	    var rmws = out.words;
	    rmws.length = N;
	
	    this.convert13b(x.words, x.length, rws, N);
	    this.convert13b(y.words, y.length, nrws, N);
	
	    this.transform(rws, _, rwst, iwst, N, rbt);
	    this.transform(nrws, _, nrwst, niwst, N, rbt);
	
	    for (var i = 0; i < N; i++) {
	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
	      rwst[i] = rx;
	    }
	
	    this.conjugate(rwst, iwst, N);
	    this.transform(rwst, iwst, rmws, _, N, rbt);
	    this.conjugate(rmws, _, N);
	    this.normalize13b(rmws, N);
	
	    out.negative = x.negative ^ y.negative;
	    out.length = x.length + y.length;
	    return out.strip();
	  };
	
	  // Multiply `this` by `num`
	  BN.prototype.mul = function mul (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return this.mulTo(num, out);
	  };
	
	  // Multiply employing FFT
	  BN.prototype.mulf = function mulf (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return jumboMulTo(this, num, out);
	  };
	
	  // In-place Multiplication
	  BN.prototype.imul = function imul (num) {
	    return this.clone().mulTo(num, this);
	  };
	
	  BN.prototype.imuln = function imuln (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	
	    // Carry
	    var carry = 0;
	    for (var i = 0; i < this.length; i++) {
	      var w = (this.words[i] | 0) * num;
	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
	      carry >>= 26;
	      carry += (w / 0x4000000) | 0;
	      // NOTE: lo is 27bit maximum
	      carry += lo >>> 26;
	      this.words[i] = lo & 0x3ffffff;
	    }
	
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	
	    return this;
	  };
	
	  BN.prototype.muln = function muln (num) {
	    return this.clone().imuln(num);
	  };
	
	  // `this` * `this`
	  BN.prototype.sqr = function sqr () {
	    return this.mul(this);
	  };
	
	  // `this` * `this` in-place
	  BN.prototype.isqr = function isqr () {
	    return this.imul(this.clone());
	  };
	
	  // Math.pow(`this`, `num`)
	  BN.prototype.pow = function pow (num) {
	    var w = toBitArray(num);
	    if (w.length === 0) return new BN(1);
	
	    // Skip leading zeroes
	    var res = this;
	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
	      if (w[i] !== 0) break;
	    }
	
	    if (++i < w.length) {
	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	        if (w[i] === 0) continue;
	
	        res = res.mul(q);
	      }
	    }
	
	    return res;
	  };
	
	  // Shift-left in-place
	  BN.prototype.iushln = function iushln (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
	    var i;
	
	    if (r !== 0) {
	      var carry = 0;
	
	      for (i = 0; i < this.length; i++) {
	        var newCarry = this.words[i] & carryMask;
	        var c = ((this.words[i] | 0) - newCarry) << r;
	        this.words[i] = c | carry;
	        carry = newCarry >>> (26 - r);
	      }
	
	      if (carry) {
	        this.words[i] = carry;
	        this.length++;
	      }
	    }
	
	    if (s !== 0) {
	      for (i = this.length - 1; i >= 0; i--) {
	        this.words[i + s] = this.words[i];
	      }
	
	      for (i = 0; i < s; i++) {
	        this.words[i] = 0;
	      }
	
	      this.length += s;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishln = function ishln (bits) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushln(bits);
	  };
	
	  // Shift-right in-place
	  // NOTE: `hint` is a lowest bit before trailing zeroes
	  // NOTE: if `extended` is present - it will be filled with destroyed bits
	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var h;
	    if (hint) {
	      h = (hint - (hint % 26)) / 26;
	    } else {
	      h = 0;
	    }
	
	    var r = bits % 26;
	    var s = Math.min((bits - r) / 26, this.length);
	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	    var maskedWords = extended;
	
	    h -= s;
	    h = Math.max(0, h);
	
	    // Extended mode, copy masked part
	    if (maskedWords) {
	      for (var i = 0; i < s; i++) {
	        maskedWords.words[i] = this.words[i];
	      }
	      maskedWords.length = s;
	    }
	
	    if (s === 0) {
	      // No-op, we should not move anything at all
	    } else if (this.length > s) {
	      this.length -= s;
	      for (i = 0; i < this.length; i++) {
	        this.words[i] = this.words[i + s];
	      }
	    } else {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    var carry = 0;
	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	      var word = this.words[i] | 0;
	      this.words[i] = (carry << (26 - r)) | (word >>> r);
	      carry = word & mask;
	    }
	
	    // Push carried bits as a mask
	    if (maskedWords && carry !== 0) {
	      maskedWords.words[maskedWords.length++] = carry;
	    }
	
	    if (this.length === 0) {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushrn(bits, hint, extended);
	  };
	
	  // Shift-left
	  BN.prototype.shln = function shln (bits) {
	    return this.clone().ishln(bits);
	  };
	
	  BN.prototype.ushln = function ushln (bits) {
	    return this.clone().iushln(bits);
	  };
	
	  // Shift-right
	  BN.prototype.shrn = function shrn (bits) {
	    return this.clone().ishrn(bits);
	  };
	
	  BN.prototype.ushrn = function ushrn (bits) {
	    return this.clone().iushrn(bits);
	  };
	
	  // Test if n bit is set
	  BN.prototype.testn = function testn (bit) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) return false;
	
	    // Check bit and return
	    var w = this.words[s];
	
	    return !!(w & q);
	  };
	
	  // Return only lowers bits of number (in-place)
	  BN.prototype.imaskn = function imaskn (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	
	    assert(this.negative === 0, 'imaskn works only with positive numbers');
	
	    if (this.length <= s) {
	      return this;
	    }
	
	    if (r !== 0) {
	      s++;
	    }
	    this.length = Math.min(s, this.length);
	
	    if (r !== 0) {
	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	      this.words[this.length - 1] &= mask;
	    }
	
	    return this.strip();
	  };
	
	  // Return only lowers bits of number
	  BN.prototype.maskn = function maskn (bits) {
	    return this.clone().imaskn(bits);
	  };
	
	  // Add plain number `num` to `this`
	  BN.prototype.iaddn = function iaddn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.isubn(-num);
	
	    // Possible sign change
	    if (this.negative !== 0) {
	      if (this.length === 1 && (this.words[0] | 0) < num) {
	        this.words[0] = num - (this.words[0] | 0);
	        this.negative = 0;
	        return this;
	      }
	
	      this.negative = 0;
	      this.isubn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    // Add without checks
	    return this._iaddn(num);
	  };
	
	  BN.prototype._iaddn = function _iaddn (num) {
	    this.words[0] += num;
	
	    // Carry
	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
	      this.words[i] -= 0x4000000;
	      if (i === this.length - 1) {
	        this.words[i + 1] = 1;
	      } else {
	        this.words[i + 1]++;
	      }
	    }
	    this.length = Math.max(this.length, i + 1);
	
	    return this;
	  };
	
	  // Subtract plain number `num` from `this`
	  BN.prototype.isubn = function isubn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.iaddn(-num);
	
	    if (this.negative !== 0) {
	      this.negative = 0;
	      this.iaddn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    this.words[0] -= num;
	
	    if (this.length === 1 && this.words[0] < 0) {
	      this.words[0] = -this.words[0];
	      this.negative = 1;
	    } else {
	      // Carry
	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	        this.words[i] += 0x4000000;
	        this.words[i + 1] -= 1;
	      }
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.addn = function addn (num) {
	    return this.clone().iaddn(num);
	  };
	
	  BN.prototype.subn = function subn (num) {
	    return this.clone().isubn(num);
	  };
	
	  BN.prototype.iabs = function iabs () {
	    this.negative = 0;
	
	    return this;
	  };
	
	  BN.prototype.abs = function abs () {
	    return this.clone().iabs();
	  };
	
	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
	    var len = num.length + shift;
	    var i;
	
	    this._expand(len);
	
	    var w;
	    var carry = 0;
	    for (i = 0; i < num.length; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      var right = (num.words[i] | 0) * mul;
	      w -= right & 0x3ffffff;
	      carry = (w >> 26) - ((right / 0x4000000) | 0);
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	    for (; i < this.length - shift; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      carry = w >> 26;
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	
	    if (carry === 0) return this.strip();
	
	    // Subtraction overflow
	    assert(carry === -1);
	    carry = 0;
	    for (i = 0; i < this.length; i++) {
	      w = -(this.words[i] | 0) + carry;
	      carry = w >> 26;
	      this.words[i] = w & 0x3ffffff;
	    }
	    this.negative = 1;
	
	    return this.strip();
	  };
	
	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
	    var shift = this.length - num.length;
	
	    var a = this.clone();
	    var b = num;
	
	    // Normalize
	    var bhi = b.words[b.length - 1] | 0;
	    var bhiBits = this._countBits(bhi);
	    shift = 26 - bhiBits;
	    if (shift !== 0) {
	      b = b.ushln(shift);
	      a.iushln(shift);
	      bhi = b.words[b.length - 1] | 0;
	    }
	
	    // Initialize quotient
	    var m = a.length - b.length;
	    var q;
	
	    if (mode !== 'mod') {
	      q = new BN(null);
	      q.length = m + 1;
	      q.words = new Array(q.length);
	      for (var i = 0; i < q.length; i++) {
	        q.words[i] = 0;
	      }
	    }
	
	    var diff = a.clone()._ishlnsubmul(b, 1, m);
	    if (diff.negative === 0) {
	      a = diff;
	      if (q) {
	        q.words[m] = 1;
	      }
	    }
	
	    for (var j = m - 1; j >= 0; j--) {
	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
	        (a.words[b.length + j - 1] | 0);
	
	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
	      // (0x7ffffff)
	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);
	
	      a._ishlnsubmul(b, qj, j);
	      while (a.negative !== 0) {
	        qj--;
	        a.negative = 0;
	        a._ishlnsubmul(b, 1, j);
	        if (!a.isZero()) {
	          a.negative ^= 1;
	        }
	      }
	      if (q) {
	        q.words[j] = qj;
	      }
	    }
	    if (q) {
	      q.strip();
	    }
	    a.strip();
	
	    // Denormalize
	    if (mode !== 'div' && shift !== 0) {
	      a.iushrn(shift);
	    }
	
	    return {
	      div: q || null,
	      mod: a
	    };
	  };
	
	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
	  //       to `div` to request div only, or be absent to
	  //       request both div & mod
	  //       2) `positive` is true if unsigned mod is requested
	  BN.prototype.divmod = function divmod (num, mode, positive) {
	    assert(!num.isZero());
	
	    if (this.isZero()) {
	      return {
	        div: new BN(0),
	        mod: new BN(0)
	      };
	    }
	
	    var div, mod, res;
	    if (this.negative !== 0 && num.negative === 0) {
	      res = this.neg().divmod(num, mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.iadd(num);
	        }
	      }
	
	      return {
	        div: div,
	        mod: mod
	      };
	    }
	
	    if (this.negative === 0 && num.negative !== 0) {
	      res = this.divmod(num.neg(), mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      return {
	        div: div,
	        mod: res.mod
	      };
	    }
	
	    if ((this.negative & num.negative) !== 0) {
	      res = this.neg().divmod(num.neg(), mode);
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.isub(num);
	        }
	      }
	
	      return {
	        div: res.div,
	        mod: mod
	      };
	    }
	
	    // Both numbers are positive at this point
	
	    // Strip both numbers to approximate shift value
	    if (num.length > this.length || this.cmp(num) < 0) {
	      return {
	        div: new BN(0),
	        mod: this
	      };
	    }
	
	    // Very short reduction
	    if (num.length === 1) {
	      if (mode === 'div') {
	        return {
	          div: this.divn(num.words[0]),
	          mod: null
	        };
	      }
	
	      if (mode === 'mod') {
	        return {
	          div: null,
	          mod: new BN(this.modn(num.words[0]))
	        };
	      }
	
	      return {
	        div: this.divn(num.words[0]),
	        mod: new BN(this.modn(num.words[0]))
	      };
	    }
	
	    return this._wordDiv(num, mode);
	  };
	
	  // Find `this` / `num`
	  BN.prototype.div = function div (num) {
	    return this.divmod(num, 'div', false).div;
	  };
	
	  // Find `this` % `num`
	  BN.prototype.mod = function mod (num) {
	    return this.divmod(num, 'mod', false).mod;
	  };
	
	  BN.prototype.umod = function umod (num) {
	    return this.divmod(num, 'mod', true).mod;
	  };
	
	  // Find Round(`this` / `num`)
	  BN.prototype.divRound = function divRound (num) {
	    var dm = this.divmod(num);
	
	    // Fast case - exact division
	    if (dm.mod.isZero()) return dm.div;
	
	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
	
	    var half = num.ushrn(1);
	    var r2 = num.andln(1);
	    var cmp = mod.cmp(half);
	
	    // Round down
	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
	
	    // Round up
	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	  };
	
	  BN.prototype.modn = function modn (num) {
	    assert(num <= 0x3ffffff);
	    var p = (1 << 26) % num;
	
	    var acc = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      acc = (p * acc + (this.words[i] | 0)) % num;
	    }
	
	    return acc;
	  };
	
	  // In-place division by number
	  BN.prototype.idivn = function idivn (num) {
	    assert(num <= 0x3ffffff);
	
	    var carry = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var w = (this.words[i] | 0) + carry * 0x4000000;
	      this.words[i] = (w / num) | 0;
	      carry = w % num;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.divn = function divn (num) {
	    return this.clone().idivn(num);
	  };
	
	  BN.prototype.egcd = function egcd (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var x = this;
	    var y = p.clone();
	
	    if (x.negative !== 0) {
	      x = x.umod(p);
	    } else {
	      x = x.clone();
	    }
	
	    // A * x + B * y = x
	    var A = new BN(1);
	    var B = new BN(0);
	
	    // C * x + D * y = y
	    var C = new BN(0);
	    var D = new BN(1);
	
	    var g = 0;
	
	    while (x.isEven() && y.isEven()) {
	      x.iushrn(1);
	      y.iushrn(1);
	      ++g;
	    }
	
	    var yp = y.clone();
	    var xp = x.clone();
	
	    while (!x.isZero()) {
	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        x.iushrn(i);
	        while (i-- > 0) {
	          if (A.isOdd() || B.isOdd()) {
	            A.iadd(yp);
	            B.isub(xp);
	          }
	
	          A.iushrn(1);
	          B.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        y.iushrn(j);
	        while (j-- > 0) {
	          if (C.isOdd() || D.isOdd()) {
	            C.iadd(yp);
	            D.isub(xp);
	          }
	
	          C.iushrn(1);
	          D.iushrn(1);
	        }
	      }
	
	      if (x.cmp(y) >= 0) {
	        x.isub(y);
	        A.isub(C);
	        B.isub(D);
	      } else {
	        y.isub(x);
	        C.isub(A);
	        D.isub(B);
	      }
	    }
	
	    return {
	      a: C,
	      b: D,
	      gcd: y.iushln(g)
	    };
	  };
	
	  // This is reduced incarnation of the binary EEA
	  // above, designated to invert members of the
	  // _prime_ fields F(p) at a maximal speed
	  BN.prototype._invmp = function _invmp (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var a = this;
	    var b = p.clone();
	
	    if (a.negative !== 0) {
	      a = a.umod(p);
	    } else {
	      a = a.clone();
	    }
	
	    var x1 = new BN(1);
	    var x2 = new BN(0);
	
	    var delta = b.clone();
	
	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        a.iushrn(i);
	        while (i-- > 0) {
	          if (x1.isOdd()) {
	            x1.iadd(delta);
	          }
	
	          x1.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        b.iushrn(j);
	        while (j-- > 0) {
	          if (x2.isOdd()) {
	            x2.iadd(delta);
	          }
	
	          x2.iushrn(1);
	        }
	      }
	
	      if (a.cmp(b) >= 0) {
	        a.isub(b);
	        x1.isub(x2);
	      } else {
	        b.isub(a);
	        x2.isub(x1);
	      }
	    }
	
	    var res;
	    if (a.cmpn(1) === 0) {
	      res = x1;
	    } else {
	      res = x2;
	    }
	
	    if (res.cmpn(0) < 0) {
	      res.iadd(p);
	    }
	
	    return res;
	  };
	
	  BN.prototype.gcd = function gcd (num) {
	    if (this.isZero()) return num.abs();
	    if (num.isZero()) return this.abs();
	
	    var a = this.clone();
	    var b = num.clone();
	    a.negative = 0;
	    b.negative = 0;
	
	    // Remove common factor of two
	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	      a.iushrn(1);
	      b.iushrn(1);
	    }
	
	    do {
	      while (a.isEven()) {
	        a.iushrn(1);
	      }
	      while (b.isEven()) {
	        b.iushrn(1);
	      }
	
	      var r = a.cmp(b);
	      if (r < 0) {
	        // Swap `a` and `b` to make `a` always bigger than `b`
	        var t = a;
	        a = b;
	        b = t;
	      } else if (r === 0 || b.cmpn(1) === 0) {
	        break;
	      }
	
	      a.isub(b);
	    } while (true);
	
	    return b.iushln(shift);
	  };
	
	  // Invert number in the field F(num)
	  BN.prototype.invm = function invm (num) {
	    return this.egcd(num).a.umod(num);
	  };
	
	  BN.prototype.isEven = function isEven () {
	    return (this.words[0] & 1) === 0;
	  };
	
	  BN.prototype.isOdd = function isOdd () {
	    return (this.words[0] & 1) === 1;
	  };
	
	  // And first word and num
	  BN.prototype.andln = function andln (num) {
	    return this.words[0] & num;
	  };
	
	  // Increment at the bit position in-line
	  BN.prototype.bincn = function bincn (bit) {
	    assert(typeof bit === 'number');
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) {
	      this._expand(s + 1);
	      this.words[s] |= q;
	      return this;
	    }
	
	    // Add bit and propagate, if needed
	    var carry = q;
	    for (var i = s; carry !== 0 && i < this.length; i++) {
	      var w = this.words[i] | 0;
	      w += carry;
	      carry = w >>> 26;
	      w &= 0x3ffffff;
	      this.words[i] = w;
	    }
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	    return this;
	  };
	
	  BN.prototype.isZero = function isZero () {
	    return this.length === 1 && this.words[0] === 0;
	  };
	
	  BN.prototype.cmpn = function cmpn (num) {
	    var negative = num < 0;
	
	    if (this.negative !== 0 && !negative) return -1;
	    if (this.negative === 0 && negative) return 1;
	
	    this.strip();
	
	    var res;
	    if (this.length > 1) {
	      res = 1;
	    } else {
	      if (negative) {
	        num = -num;
	      }
	
	      assert(num <= 0x3ffffff, 'Number is too big');
	
	      var w = this.words[0] | 0;
	      res = w === num ? 0 : w < num ? -1 : 1;
	    }
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Compare two numbers and return:
	  // 1 - if `this` > `num`
	  // 0 - if `this` == `num`
	  // -1 - if `this` < `num`
	  BN.prototype.cmp = function cmp (num) {
	    if (this.negative !== 0 && num.negative === 0) return -1;
	    if (this.negative === 0 && num.negative !== 0) return 1;
	
	    var res = this.ucmp(num);
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Unsigned comparison
	  BN.prototype.ucmp = function ucmp (num) {
	    // At this point both numbers have the same sign
	    if (this.length > num.length) return 1;
	    if (this.length < num.length) return -1;
	
	    var res = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var a = this.words[i] | 0;
	      var b = num.words[i] | 0;
	
	      if (a === b) continue;
	      if (a < b) {
	        res = -1;
	      } else if (a > b) {
	        res = 1;
	      }
	      break;
	    }
	    return res;
	  };
	
	  BN.prototype.gtn = function gtn (num) {
	    return this.cmpn(num) === 1;
	  };
	
	  BN.prototype.gt = function gt (num) {
	    return this.cmp(num) === 1;
	  };
	
	  BN.prototype.gten = function gten (num) {
	    return this.cmpn(num) >= 0;
	  };
	
	  BN.prototype.gte = function gte (num) {
	    return this.cmp(num) >= 0;
	  };
	
	  BN.prototype.ltn = function ltn (num) {
	    return this.cmpn(num) === -1;
	  };
	
	  BN.prototype.lt = function lt (num) {
	    return this.cmp(num) === -1;
	  };
	
	  BN.prototype.lten = function lten (num) {
	    return this.cmpn(num) <= 0;
	  };
	
	  BN.prototype.lte = function lte (num) {
	    return this.cmp(num) <= 0;
	  };
	
	  BN.prototype.eqn = function eqn (num) {
	    return this.cmpn(num) === 0;
	  };
	
	  BN.prototype.eq = function eq (num) {
	    return this.cmp(num) === 0;
	  };
	
	  //
	  // A reduce context, could be using montgomery or something better, depending
	  // on the `m` itself.
	  //
	  BN.red = function red (num) {
	    return new Red(num);
	  };
	
	  BN.prototype.toRed = function toRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    assert(this.negative === 0, 'red works only with positives');
	    return ctx.convertTo(this)._forceRed(ctx);
	  };
	
	  BN.prototype.fromRed = function fromRed () {
	    assert(this.red, 'fromRed works only with numbers in reduction context');
	    return this.red.convertFrom(this);
	  };
	
	  BN.prototype._forceRed = function _forceRed (ctx) {
	    this.red = ctx;
	    return this;
	  };
	
	  BN.prototype.forceRed = function forceRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    return this._forceRed(ctx);
	  };
	
	  BN.prototype.redAdd = function redAdd (num) {
	    assert(this.red, 'redAdd works only with red numbers');
	    return this.red.add(this, num);
	  };
	
	  BN.prototype.redIAdd = function redIAdd (num) {
	    assert(this.red, 'redIAdd works only with red numbers');
	    return this.red.iadd(this, num);
	  };
	
	  BN.prototype.redSub = function redSub (num) {
	    assert(this.red, 'redSub works only with red numbers');
	    return this.red.sub(this, num);
	  };
	
	  BN.prototype.redISub = function redISub (num) {
	    assert(this.red, 'redISub works only with red numbers');
	    return this.red.isub(this, num);
	  };
	
	  BN.prototype.redShl = function redShl (num) {
	    assert(this.red, 'redShl works only with red numbers');
	    return this.red.shl(this, num);
	  };
	
	  BN.prototype.redMul = function redMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.mul(this, num);
	  };
	
	  BN.prototype.redIMul = function redIMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.imul(this, num);
	  };
	
	  BN.prototype.redSqr = function redSqr () {
	    assert(this.red, 'redSqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqr(this);
	  };
	
	  BN.prototype.redISqr = function redISqr () {
	    assert(this.red, 'redISqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.isqr(this);
	  };
	
	  // Square root over p
	  BN.prototype.redSqrt = function redSqrt () {
	    assert(this.red, 'redSqrt works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqrt(this);
	  };
	
	  BN.prototype.redInvm = function redInvm () {
	    assert(this.red, 'redInvm works only with red numbers');
	    this.red._verify1(this);
	    return this.red.invm(this);
	  };
	
	  // Return negative clone of `this` % `red modulo`
	  BN.prototype.redNeg = function redNeg () {
	    assert(this.red, 'redNeg works only with red numbers');
	    this.red._verify1(this);
	    return this.red.neg(this);
	  };
	
	  BN.prototype.redPow = function redPow (num) {
	    assert(this.red && !num.red, 'redPow(normalNum)');
	    this.red._verify1(this);
	    return this.red.pow(this, num);
	  };
	
	  // Prime numbers with efficient reduction
	  var primes = {
	    k256: null,
	    p224: null,
	    p192: null,
	    p25519: null
	  };
	
	  // Pseudo-Mersenne prime
	  function MPrime (name, p) {
	    // P = 2 ^ N - K
	    this.name = name;
	    this.p = new BN(p, 16);
	    this.n = this.p.bitLength();
	    this.k = new BN(1).iushln(this.n).isub(this.p);
	
	    this.tmp = this._tmp();
	  }
	
	  MPrime.prototype._tmp = function _tmp () {
	    var tmp = new BN(null);
	    tmp.words = new Array(Math.ceil(this.n / 13));
	    return tmp;
	  };
	
	  MPrime.prototype.ireduce = function ireduce (num) {
	    // Assumes that `num` is less than `P^2`
	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
	    var r = num;
	    var rlen;
	
	    do {
	      this.split(r, this.tmp);
	      r = this.imulK(r);
	      r = r.iadd(this.tmp);
	      rlen = r.bitLength();
	    } while (rlen > this.n);
	
	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
	    if (cmp === 0) {
	      r.words[0] = 0;
	      r.length = 1;
	    } else if (cmp > 0) {
	      r.isub(this.p);
	    } else {
	      r.strip();
	    }
	
	    return r;
	  };
	
	  MPrime.prototype.split = function split (input, out) {
	    input.iushrn(this.n, 0, out);
	  };
	
	  MPrime.prototype.imulK = function imulK (num) {
	    return num.imul(this.k);
	  };
	
	  function K256 () {
	    MPrime.call(
	      this,
	      'k256',
	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
	  }
	  inherits(K256, MPrime);
	
	  K256.prototype.split = function split (input, output) {
	    // 256 = 9 * 26 + 22
	    var mask = 0x3fffff;
	
	    var outLen = Math.min(input.length, 9);
	    for (var i = 0; i < outLen; i++) {
	      output.words[i] = input.words[i];
	    }
	    output.length = outLen;
	
	    if (input.length <= 9) {
	      input.words[0] = 0;
	      input.length = 1;
	      return;
	    }
	
	    // Shift by 9 limbs
	    var prev = input.words[9];
	    output.words[output.length++] = prev & mask;
	
	    for (i = 10; i < input.length; i++) {
	      var next = input.words[i] | 0;
	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
	      prev = next;
	    }
	    prev >>>= 22;
	    input.words[i - 10] = prev;
	    if (prev === 0 && input.length > 10) {
	      input.length -= 10;
	    } else {
	      input.length -= 9;
	    }
	  };
	
	  K256.prototype.imulK = function imulK (num) {
	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
	    num.words[num.length] = 0;
	    num.words[num.length + 1] = 0;
	    num.length += 2;
	
	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
	    var lo = 0;
	    for (var i = 0; i < num.length; i++) {
	      var w = num.words[i] | 0;
	      lo += w * 0x3d1;
	      num.words[i] = lo & 0x3ffffff;
	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
	    }
	
	    // Fast length reduction
	    if (num.words[num.length - 1] === 0) {
	      num.length--;
	      if (num.words[num.length - 1] === 0) {
	        num.length--;
	      }
	    }
	    return num;
	  };
	
	  function P224 () {
	    MPrime.call(
	      this,
	      'p224',
	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
	  }
	  inherits(P224, MPrime);
	
	  function P192 () {
	    MPrime.call(
	      this,
	      'p192',
	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
	  }
	  inherits(P192, MPrime);
	
	  function P25519 () {
	    // 2 ^ 255 - 19
	    MPrime.call(
	      this,
	      '25519',
	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
	  }
	  inherits(P25519, MPrime);
	
	  P25519.prototype.imulK = function imulK (num) {
	    // K = 0x13
	    var carry = 0;
	    for (var i = 0; i < num.length; i++) {
	      var hi = (num.words[i] | 0) * 0x13 + carry;
	      var lo = hi & 0x3ffffff;
	      hi >>>= 26;
	
	      num.words[i] = lo;
	      carry = hi;
	    }
	    if (carry !== 0) {
	      num.words[num.length++] = carry;
	    }
	    return num;
	  };
	
	  // Exported mostly for testing purposes, use plain name instead
	  BN._prime = function prime (name) {
	    // Cached version of prime
	    if (primes[name]) return primes[name];
	
	    var prime;
	    if (name === 'k256') {
	      prime = new K256();
	    } else if (name === 'p224') {
	      prime = new P224();
	    } else if (name === 'p192') {
	      prime = new P192();
	    } else if (name === 'p25519') {
	      prime = new P25519();
	    } else {
	      throw new Error('Unknown prime ' + name);
	    }
	    primes[name] = prime;
	
	    return prime;
	  };
	
	  //
	  // Base reduction engine
	  //
	  function Red (m) {
	    if (typeof m === 'string') {
	      var prime = BN._prime(m);
	      this.m = prime.p;
	      this.prime = prime;
	    } else {
	      assert(m.gtn(1), 'modulus must be greater than 1');
	      this.m = m;
	      this.prime = null;
	    }
	  }
	
	  Red.prototype._verify1 = function _verify1 (a) {
	    assert(a.negative === 0, 'red works only with positives');
	    assert(a.red, 'red works only with red numbers');
	  };
	
	  Red.prototype._verify2 = function _verify2 (a, b) {
	    assert((a.negative | b.negative) === 0, 'red works only with positives');
	    assert(a.red && a.red === b.red,
	      'red works only with red numbers');
	  };
	
	  Red.prototype.imod = function imod (a) {
	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
	    return a.umod(this.m)._forceRed(this);
	  };
	
	  Red.prototype.neg = function neg (a) {
	    if (a.isZero()) {
	      return a.clone();
	    }
	
	    return this.m.sub(a)._forceRed(this);
	  };
	
	  Red.prototype.add = function add (a, b) {
	    this._verify2(a, b);
	
	    var res = a.add(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.iadd = function iadd (a, b) {
	    this._verify2(a, b);
	
	    var res = a.iadd(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.sub = function sub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.sub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.isub = function isub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.isub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.shl = function shl (a, num) {
	    this._verify1(a);
	    return this.imod(a.ushln(num));
	  };
	
	  Red.prototype.imul = function imul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.imul(b));
	  };
	
	  Red.prototype.mul = function mul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.mul(b));
	  };
	
	  Red.prototype.isqr = function isqr (a) {
	    return this.imul(a, a.clone());
	  };
	
	  Red.prototype.sqr = function sqr (a) {
	    return this.mul(a, a);
	  };
	
	  Red.prototype.sqrt = function sqrt (a) {
	    if (a.isZero()) return a.clone();
	
	    var mod3 = this.m.andln(3);
	    assert(mod3 % 2 === 1);
	
	    // Fast case
	    if (mod3 === 3) {
	      var pow = this.m.add(new BN(1)).iushrn(2);
	      return this.pow(a, pow);
	    }
	
	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
	    //
	    // Find Q and S, that Q * 2 ^ S = (P - 1)
	    var q = this.m.subn(1);
	    var s = 0;
	    while (!q.isZero() && q.andln(1) === 0) {
	      s++;
	      q.iushrn(1);
	    }
	    assert(!q.isZero());
	
	    var one = new BN(1).toRed(this);
	    var nOne = one.redNeg();
	
	    // Find quadratic non-residue
	    // NOTE: Max is such because of generalized Riemann hypothesis.
	    var lpow = this.m.subn(1).iushrn(1);
	    var z = this.m.bitLength();
	    z = new BN(2 * z * z).toRed(this);
	
	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
	      z.redIAdd(nOne);
	    }
	
	    var c = this.pow(z, q);
	    var r = this.pow(a, q.addn(1).iushrn(1));
	    var t = this.pow(a, q);
	    var m = s;
	    while (t.cmp(one) !== 0) {
	      var tmp = t;
	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
	        tmp = tmp.redSqr();
	      }
	      assert(i < m);
	      var b = this.pow(c, new BN(1).iushln(m - i - 1));
	
	      r = r.redMul(b);
	      c = b.redSqr();
	      t = t.redMul(c);
	      m = i;
	    }
	
	    return r;
	  };
	
	  Red.prototype.invm = function invm (a) {
	    var inv = a._invmp(this.m);
	    if (inv.negative !== 0) {
	      inv.negative = 0;
	      return this.imod(inv).redNeg();
	    } else {
	      return this.imod(inv);
	    }
	  };
	
	  Red.prototype.pow = function pow (a, num) {
	    if (num.isZero()) return new BN(1).toRed(this);
	    if (num.cmpn(1) === 0) return a.clone();
	
	    var windowSize = 4;
	    var wnd = new Array(1 << windowSize);
	    wnd[0] = new BN(1).toRed(this);
	    wnd[1] = a;
	    for (var i = 2; i < wnd.length; i++) {
	      wnd[i] = this.mul(wnd[i - 1], a);
	    }
	
	    var res = wnd[0];
	    var current = 0;
	    var currentLen = 0;
	    var start = num.bitLength() % 26;
	    if (start === 0) {
	      start = 26;
	    }
	
	    for (i = num.length - 1; i >= 0; i--) {
	      var word = num.words[i];
	      for (var j = start - 1; j >= 0; j--) {
	        var bit = (word >> j) & 1;
	        if (res !== wnd[0]) {
	          res = this.sqr(res);
	        }
	
	        if (bit === 0 && current === 0) {
	          currentLen = 0;
	          continue;
	        }
	
	        current <<= 1;
	        current |= bit;
	        currentLen++;
	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
	
	        res = this.mul(res, wnd[current]);
	        currentLen = 0;
	        current = 0;
	      }
	      start = 26;
	    }
	
	    return res;
	  };
	
	  Red.prototype.convertTo = function convertTo (num) {
	    var r = num.umod(this.m);
	
	    return r === num ? r.clone() : r;
	  };
	
	  Red.prototype.convertFrom = function convertFrom (num) {
	    var res = num.clone();
	    res.red = null;
	    return res;
	  };
	
	  //
	  // Montgomery method engine
	  //
	
	  BN.mont = function mont (num) {
	    return new Mont(num);
	  };
	
	  function Mont (m) {
	    Red.call(this, m);
	
	    this.shift = this.m.bitLength();
	    if (this.shift % 26 !== 0) {
	      this.shift += 26 - (this.shift % 26);
	    }
	
	    this.r = new BN(1).iushln(this.shift);
	    this.r2 = this.imod(this.r.sqr());
	    this.rinv = this.r._invmp(this.m);
	
	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	    this.minv = this.minv.umod(this.r);
	    this.minv = this.r.sub(this.minv);
	  }
	  inherits(Mont, Red);
	
	  Mont.prototype.convertTo = function convertTo (num) {
	    return this.imod(num.ushln(this.shift));
	  };
	
	  Mont.prototype.convertFrom = function convertFrom (num) {
	    var r = this.imod(num.mul(this.rinv));
	    r.red = null;
	    return r;
	  };
	
	  Mont.prototype.imul = function imul (a, b) {
	    if (a.isZero() || b.isZero()) {
	      a.words[0] = 0;
	      a.length = 1;
	      return a;
	    }
	
	    var t = a.imul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.mul = function mul (a, b) {
	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
	
	    var t = a.mul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.invm = function invm (a) {
	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
	    var res = this.imod(a._invmp(this.m).mul(this.r2));
	    return res._forceRed(this);
	  };
	})(typeof module === 'undefined' || module, this);
	
	},{"buffer":104}],96:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = boundary
	
	function boundary (cells) {
	  var i, j, k
	  var n = cells.length
	  var sz = 0
	  for (i = 0; i < n; ++i) {
	    sz += cells[i].length
	  }
	  var result = new Array(sz)
	  var ptr = 0
	  for (i = 0; i < n; ++i) {
	    var c = cells[i]
	    var d = c.length
	    for (j = 0; j < d; ++j) {
	      var b = result[ptr++] = new Array(d - 1)
	      var p = 0
	      for (k = 0; k < d; ++k) {
	        if (k === j) {
	          continue
	        }
	        b[p++] = c[k]
	      }
	      if (j & 1) {
	        var tmp = b[1]
	        b[1] = b[0]
	        b[0] = tmp
	      }
	    }
	  }
	  return result
	}
	
	},{}],97:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = boxIntersectWrapper
	
	var pool = _dereq_('typedarray-pool')
	var sweep = _dereq_('./lib/sweep')
	var boxIntersectIter = _dereq_('./lib/intersect')
	
	function boxEmpty(d, box) {
	  for(var j=0; j<d; ++j) {
	    if(!(box[j] <= box[j+d])) {
	      return true
	    }
	  }
	  return false
	}
	
	//Unpack boxes into a flat typed array, remove empty boxes
	function convertBoxes(boxes, d, data, ids) {
	  var ptr = 0
	  var count = 0
	  for(var i=0, n=boxes.length; i<n; ++i) {
	    var b = boxes[i]
	    if(boxEmpty(d, b)) {
	      continue
	    }
	    for(var j=0; j<2*d; ++j) {
	      data[ptr++] = b[j]
	    }
	    ids[count++] = i
	  }
	  return count
	}
	
	//Perform type conversions, check bounds
	function boxIntersect(red, blue, visit, full) {
	  var n = red.length
	  var m = blue.length
	
	  //If either array is empty, then we can skip this whole thing
	  if(n <= 0 || m <= 0) {
	    return
	  }
	
	  //Compute dimension, if it is 0 then we skip
	  var d = (red[0].length)>>>1
	  if(d <= 0) {
	    return
	  }
	
	  var retval
	
	  //Convert red boxes
	  var redList  = pool.mallocDouble(2*d*n)
	  var redIds   = pool.mallocInt32(n)
	  n = convertBoxes(red, d, redList, redIds)
	
	  if(n > 0) {
	    if(d === 1 && full) {
	      //Special case: 1d complete
	      sweep.init(n)
	      retval = sweep.sweepComplete(
	        d, visit, 
	        0, n, redList, redIds,
	        0, n, redList, redIds)
	    } else {
	
	      //Convert blue boxes
	      var blueList = pool.mallocDouble(2*d*m)
	      var blueIds  = pool.mallocInt32(m)
	      m = convertBoxes(blue, d, blueList, blueIds)
	
	      if(m > 0) {
	        sweep.init(n+m)
	
	        if(d === 1) {
	          //Special case: 1d bipartite
	          retval = sweep.sweepBipartite(
	            d, visit, 
	            0, n, redList,  redIds,
	            0, m, blueList, blueIds)
	        } else {
	          //General case:  d>1
	          retval = boxIntersectIter(
	            d, visit,    full,
	            n, redList,  redIds,
	            m, blueList, blueIds)
	        }
	
	        pool.free(blueList)
	        pool.free(blueIds)
	      }
	    }
	
	    pool.free(redList)
	    pool.free(redIds)
	  }
	
	  return retval
	}
	
	
	var RESULT
	
	function appendItem(i,j) {
	  RESULT.push([i,j])
	}
	
	function intersectFullArray(x) {
	  RESULT = []
	  boxIntersect(x, x, appendItem, true)
	  return RESULT
	}
	
	function intersectBipartiteArray(x, y) {
	  RESULT = []
	  boxIntersect(x, y, appendItem, false)
	  return RESULT
	}
	
	//User-friendly wrapper, handle full input and no-visitor cases
	function boxIntersectWrapper(arg0, arg1, arg2) {
	  var result
	  switch(arguments.length) {
	    case 1:
	      return intersectFullArray(arg0)
	    case 2:
	      if(typeof arg1 === 'function') {
	        return boxIntersect(arg0, arg0, arg1, true)
	      } else {
	        return intersectBipartiteArray(arg0, arg1)
	      }
	    case 3:
	      return boxIntersect(arg0, arg1, arg2, false)
	    default:
	      throw new Error('box-intersect: Invalid arguments')
	  }
	}
	},{"./lib/intersect":99,"./lib/sweep":103,"typedarray-pool":543}],98:[function(_dereq_,module,exports){
	'use strict'
	
	var DIMENSION   = 'd'
	var AXIS        = 'ax'
	var VISIT       = 'vv'
	var FLIP        = 'fp'
	
	var ELEM_SIZE   = 'es'
	
	var RED_START   = 'rs'
	var RED_END     = 're'
	var RED_BOXES   = 'rb'
	var RED_INDEX   = 'ri'
	var RED_PTR     = 'rp'
	
	var BLUE_START  = 'bs'
	var BLUE_END    = 'be'
	var BLUE_BOXES  = 'bb'
	var BLUE_INDEX  = 'bi'
	var BLUE_PTR    = 'bp'
	
	var RETVAL      = 'rv'
	
	var INNER_LABEL = 'Q'
	
	var ARGS = [
	  DIMENSION,
	  AXIS,
	  VISIT,
	  RED_START,
	  RED_END,
	  RED_BOXES,
	  RED_INDEX,
	  BLUE_START,
	  BLUE_END,
	  BLUE_BOXES,
	  BLUE_INDEX
	]
	
	function generateBruteForce(redMajor, flip, full) {
	  var funcName = 'bruteForce' + 
	    (redMajor ? 'Red' : 'Blue') + 
	    (flip ? 'Flip' : '') +
	    (full ? 'Full' : '')
	
	  var code = ['function ', funcName, '(', ARGS.join(), '){',
	    'var ', ELEM_SIZE, '=2*', DIMENSION, ';']
	
	  var redLoop = 
	    'for(var i=' + RED_START + ',' + RED_PTR + '=' + ELEM_SIZE + '*' + RED_START + ';' +
	        'i<' + RED_END +';' +
	        '++i,' + RED_PTR + '+=' + ELEM_SIZE + '){' +
	        'var x0=' + RED_BOXES + '[' + AXIS + '+' + RED_PTR + '],' +
	            'x1=' + RED_BOXES + '[' + AXIS + '+' + RED_PTR + '+' + DIMENSION + '],' +
	            'xi=' + RED_INDEX + '[i];'
	
	  var blueLoop = 
	    'for(var j=' + BLUE_START + ',' + BLUE_PTR + '=' + ELEM_SIZE + '*' + BLUE_START + ';' +
	        'j<' + BLUE_END + ';' +
	        '++j,' + BLUE_PTR + '+=' + ELEM_SIZE + '){' +
	        'var y0=' + BLUE_BOXES + '[' + AXIS + '+' + BLUE_PTR + '],' +
	            (full ? 'y1=' + BLUE_BOXES + '[' + AXIS + '+' + BLUE_PTR + '+' + DIMENSION + '],' : '') +
	            'yi=' + BLUE_INDEX + '[j];'
	
	  if(redMajor) {
	    code.push(redLoop, INNER_LABEL, ':', blueLoop)
	  } else {
	    code.push(blueLoop, INNER_LABEL, ':', redLoop)
	  }
	
	  if(full) {
	    code.push('if(y1<x0||x1<y0)continue;')
	  } else if(flip) {
	    code.push('if(y0<=x0||x1<y0)continue;')
	  } else {
	    code.push('if(y0<x0||x1<y0)continue;')
	  }
	
	  code.push('for(var k='+AXIS+'+1;k<'+DIMENSION+';++k){'+
	    'var r0='+RED_BOXES+'[k+'+RED_PTR+'],'+
	        'r1='+RED_BOXES+'[k+'+DIMENSION+'+'+RED_PTR+'],'+
	        'b0='+BLUE_BOXES+'[k+'+BLUE_PTR+'],'+
	        'b1='+BLUE_BOXES+'[k+'+DIMENSION+'+'+BLUE_PTR+'];'+
	      'if(r1<b0||b1<r0)continue ' + INNER_LABEL + ';}' +
	      'var ' + RETVAL + '=' + VISIT + '(')
	
	  if(flip) {
	    code.push('yi,xi')
	  } else {
	    code.push('xi,yi')
	  }
	
	  code.push(');if(' + RETVAL + '!==void 0)return ' + RETVAL + ';}}}')
	
	  return {
	    name: funcName, 
	    code: code.join('')
	  }
	}
	
	function bruteForcePlanner(full) {
	  var funcName = 'bruteForce' + (full ? 'Full' : 'Partial')
	  var prefix = []
	  var fargs = ARGS.slice()
	  if(!full) {
	    fargs.splice(3, 0, FLIP)
	  }
	
	  var code = ['function ' + funcName + '(' + fargs.join() + '){']
	
	  function invoke(redMajor, flip) {
	    var res = generateBruteForce(redMajor, flip, full)
	    prefix.push(res.code)
	    code.push('return ' + res.name + '(' + ARGS.join() + ');')
	  }
	
	  code.push('if(' + RED_END + '-' + RED_START + '>' +
	                    BLUE_END + '-' + BLUE_START + '){')
	
	  if(full) {
	    invoke(true, false)
	    code.push('}else{')
	    invoke(false, false)
	  } else {
	    code.push('if(' + FLIP + '){')
	    invoke(true, true)
	    code.push('}else{')
	    invoke(true, false)
	    code.push('}}else{if(' + FLIP + '){')
	    invoke(false, true)
	    code.push('}else{')
	    invoke(false, false)
	    code.push('}')
	  }
	  code.push('}}return ' + funcName)
	
	  var codeStr = prefix.join('') + code.join('')
	  var proc = new Function(codeStr)
	  return proc()
	}
	
	
	exports.partial = bruteForcePlanner(false)
	exports.full    = bruteForcePlanner(true)
	},{}],99:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = boxIntersectIter
	
	var pool = _dereq_('typedarray-pool')
	var bits = _dereq_('bit-twiddle')
	var bruteForce = _dereq_('./brute')
	var bruteForcePartial = bruteForce.partial
	var bruteForceFull = bruteForce.full
	var sweep = _dereq_('./sweep')
	var findMedian = _dereq_('./median')
	var genPartition = _dereq_('./partition')
	
	//Twiddle parameters
	var BRUTE_FORCE_CUTOFF    = 128       //Cut off for brute force search
	var SCAN_CUTOFF           = (1<<22)   //Cut off for two way scan
	var SCAN_COMPLETE_CUTOFF  = (1<<22)  
	
	//Partition functions
	var partitionInteriorContainsInterval = genPartition(
	  '!(lo>=p0)&&!(p1>=hi)', 
	  ['p0', 'p1'])
	
	var partitionStartEqual = genPartition(
	  'lo===p0',
	  ['p0'])
	
	var partitionStartLessThan = genPartition(
	  'lo<p0',
	  ['p0'])
	
	var partitionEndLessThanEqual = genPartition(
	  'hi<=p0',
	  ['p0'])
	
	var partitionContainsPoint = genPartition(
	  'lo<=p0&&p0<=hi',
	  ['p0'])
	
	var partitionContainsPointProper = genPartition(
	  'lo<p0&&p0<=hi',
	  ['p0'])
	
	//Frame size for iterative loop
	var IFRAME_SIZE = 6
	var DFRAME_SIZE = 2
	
	//Data for box statck
	var INIT_CAPACITY = 1024
	var BOX_ISTACK  = pool.mallocInt32(INIT_CAPACITY)
	var BOX_DSTACK  = pool.mallocDouble(INIT_CAPACITY)
	
	//Initialize iterative loop queue
	function iterInit(d, count) {
	  var levels = (8 * bits.log2(count+1) * (d+1))|0
	  var maxInts = bits.nextPow2(IFRAME_SIZE*levels)
	  if(BOX_ISTACK.length < maxInts) {
	    pool.free(BOX_ISTACK)
	    BOX_ISTACK = pool.mallocInt32(maxInts)
	  }
	  var maxDoubles = bits.nextPow2(DFRAME_SIZE*levels)
	  if(BOX_DSTACK < maxDoubles) {
	    pool.free(BOX_DSTACK)
	    BOX_DSTACK = pool.mallocDouble(maxDoubles)
	  }
	}
	
	//Append item to queue
	function iterPush(ptr,
	  axis, 
	  redStart, redEnd, 
	  blueStart, blueEnd, 
	  state, 
	  lo, hi) {
	
	  var iptr = IFRAME_SIZE * ptr
	  BOX_ISTACK[iptr]   = axis
	  BOX_ISTACK[iptr+1] = redStart
	  BOX_ISTACK[iptr+2] = redEnd
	  BOX_ISTACK[iptr+3] = blueStart
	  BOX_ISTACK[iptr+4] = blueEnd
	  BOX_ISTACK[iptr+5] = state
	
	  var dptr = DFRAME_SIZE * ptr
	  BOX_DSTACK[dptr]   = lo
	  BOX_DSTACK[dptr+1] = hi
	}
	
	//Special case:  Intersect single point with list of intervals
	function onePointPartial(
	  d, axis, visit, flip,
	  redStart, redEnd, red, redIndex,
	  blueOffset, blue, blueId) {
	
	  var elemSize = 2 * d
	  var bluePtr  = blueOffset * elemSize
	  var blueX    = blue[bluePtr + axis]
	
	red_loop:
	  for(var i=redStart, redPtr=redStart*elemSize; i<redEnd; ++i, redPtr+=elemSize) {
	    var r0 = red[redPtr+axis]
	    var r1 = red[redPtr+axis+d]
	    if(blueX < r0 || r1 < blueX) {
	      continue
	    }
	    if(flip && blueX === r0) {
	      continue
	    }
	    var redId = redIndex[i]
	    for(var j=axis+1; j<d; ++j) {
	      var r0 = red[redPtr+j]
	      var r1 = red[redPtr+j+d]
	      var b0 = blue[bluePtr+j]
	      var b1 = blue[bluePtr+j+d]
	      if(r1 < b0 || b1 < r0) {
	        continue red_loop
	      }
	    }
	    var retval
	    if(flip) {
	      retval = visit(blueId, redId)
	    } else {
	      retval = visit(redId, blueId)
	    }
	    if(retval !== void 0) {
	      return retval
	    }
	  }
	}
	
	//Special case:  Intersect one point with list of intervals
	function onePointFull(
	  d, axis, visit,
	  redStart, redEnd, red, redIndex,
	  blueOffset, blue, blueId) {
	
	  var elemSize = 2 * d
	  var bluePtr  = blueOffset * elemSize
	  var blueX    = blue[bluePtr + axis]
	
	red_loop:
	  for(var i=redStart, redPtr=redStart*elemSize; i<redEnd; ++i, redPtr+=elemSize) {
	    var redId = redIndex[i]
	    if(redId === blueId) {
	      continue
	    }
	    var r0 = red[redPtr+axis]
	    var r1 = red[redPtr+axis+d]
	    if(blueX < r0 || r1 < blueX) {
	      continue
	    }
	    for(var j=axis+1; j<d; ++j) {
	      var r0 = red[redPtr+j]
	      var r1 = red[redPtr+j+d]
	      var b0 = blue[bluePtr+j]
	      var b1 = blue[bluePtr+j+d]
	      if(r1 < b0 || b1 < r0) {
	        continue red_loop
	      }
	    }
	    var retval = visit(redId, blueId)
	    if(retval !== void 0) {
	      return retval
	    }
	  }
	}
	
	//The main box intersection routine
	function boxIntersectIter(
	  d, visit, initFull,
	  xSize, xBoxes, xIndex,
	  ySize, yBoxes, yIndex) {
	
	  //Reserve memory for stack
	  iterInit(d, xSize + ySize)
	
	  var top  = 0
	  var elemSize = 2 * d
	  var retval
	
	  iterPush(top++,
	      0,
	      0, xSize,
	      0, ySize,
	      initFull ? 16 : 0, 
	      -Infinity, Infinity)
	  if(!initFull) {
	    iterPush(top++,
	      0,
	      0, ySize,
	      0, xSize,
	      1, 
	      -Infinity, Infinity)
	  }
	
	  while(top > 0) {
	    top  -= 1
	
	    var iptr = top * IFRAME_SIZE
	    var axis      = BOX_ISTACK[iptr]
	    var redStart  = BOX_ISTACK[iptr+1]
	    var redEnd    = BOX_ISTACK[iptr+2]
	    var blueStart = BOX_ISTACK[iptr+3]
	    var blueEnd   = BOX_ISTACK[iptr+4]
	    var state     = BOX_ISTACK[iptr+5]
	
	    var dptr = top * DFRAME_SIZE
	    var lo        = BOX_DSTACK[dptr]
	    var hi        = BOX_DSTACK[dptr+1]
	
	    //Unpack state info
	    var flip      = (state & 1)
	    var full      = !!(state & 16)
	
	    //Unpack indices
	    var red       = xBoxes
	    var redIndex  = xIndex
	    var blue      = yBoxes
	    var blueIndex = yIndex
	    if(flip) {
	      red         = yBoxes
	      redIndex    = yIndex
	      blue        = xBoxes
	      blueIndex   = xIndex
	    }
	
	    if(state & 2) {
	      redEnd = partitionStartLessThan(
	        d, axis,
	        redStart, redEnd, red, redIndex,
	        hi)
	      if(redStart >= redEnd) {
	        continue
	      }
	    }
	    if(state & 4) {
	      redStart = partitionEndLessThanEqual(
	        d, axis,
	        redStart, redEnd, red, redIndex,
	        lo)
	      if(redStart >= redEnd) {
	        continue
	      }
	    }
	    
	    var redCount  = redEnd  - redStart
	    var blueCount = blueEnd - blueStart
	
	    if(full) {
	      if(d * redCount * (redCount + blueCount) < SCAN_COMPLETE_CUTOFF) {
	        retval = sweep.scanComplete(
	          d, axis, visit, 
	          redStart, redEnd, red, redIndex,
	          blueStart, blueEnd, blue, blueIndex)
	        if(retval !== void 0) {
	          return retval
	        }
	        continue
	      }
	    } else {
	      if(d * Math.min(redCount, blueCount) < BRUTE_FORCE_CUTOFF) {
	        //If input small, then use brute force
	        retval = bruteForcePartial(
	            d, axis, visit, flip,
	            redStart,  redEnd,  red,  redIndex,
	            blueStart, blueEnd, blue, blueIndex)
	        if(retval !== void 0) {
	          return retval
	        }
	        continue
	      } else if(d * redCount * blueCount < SCAN_CUTOFF) {
	        //If input medium sized, then use sweep and prune
	        retval = sweep.scanBipartite(
	          d, axis, visit, flip, 
	          redStart, redEnd, red, redIndex,
	          blueStart, blueEnd, blue, blueIndex)
	        if(retval !== void 0) {
	          return retval
	        }
	        continue
	      }
	    }
	    
	    //First, find all red intervals whose interior contains (lo,hi)
	    var red0 = partitionInteriorContainsInterval(
	      d, axis, 
	      redStart, redEnd, red, redIndex,
	      lo, hi)
	
	    //Lower dimensional case
	    if(redStart < red0) {
	
	      if(d * (red0 - redStart) < BRUTE_FORCE_CUTOFF) {
	        //Special case for small inputs: use brute force
	        retval = bruteForceFull(
	          d, axis+1, visit,
	          redStart, red0, red, redIndex,
	          blueStart, blueEnd, blue, blueIndex)
	        if(retval !== void 0) {
	          return retval
	        }
	      } else if(axis === d-2) {
	        if(flip) {
	          retval = sweep.sweepBipartite(
	            d, visit,
	            blueStart, blueEnd, blue, blueIndex,
	            redStart, red0, red, redIndex)
	        } else {
	          retval = sweep.sweepBipartite(
	            d, visit,
	            redStart, red0, red, redIndex,
	            blueStart, blueEnd, blue, blueIndex)
	        }
	        if(retval !== void 0) {
	          return retval
	        }
	      } else {
	        iterPush(top++,
	          axis+1,
	          redStart, red0,
	          blueStart, blueEnd,
	          flip,
	          -Infinity, Infinity)
	        iterPush(top++,
	          axis+1,
	          blueStart, blueEnd,
	          redStart, red0,
	          flip^1,
	          -Infinity, Infinity)
	      }
	    }
	
	    //Divide and conquer phase
	    if(red0 < redEnd) {
	
	      //Cut blue into 3 parts:
	      //
	      //  Points < mid point
	      //  Points = mid point
	      //  Points > mid point
	      //
	      var blue0 = findMedian(
	        d, axis, 
	        blueStart, blueEnd, blue, blueIndex)
	      var mid = blue[elemSize * blue0 + axis]
	      var blue1 = partitionStartEqual(
	        d, axis,
	        blue0, blueEnd, blue, blueIndex,
	        mid)
	
	      //Right case
	      if(blue1 < blueEnd) {
	        iterPush(top++,
	          axis,
	          red0, redEnd,
	          blue1, blueEnd,
	          (flip|4) + (full ? 16 : 0),
	          mid, hi)
	      }
	
	      //Left case
	      if(blueStart < blue0) {
	        iterPush(top++,
	          axis,
	          red0, redEnd,
	          blueStart, blue0,
	          (flip|2) + (full ? 16 : 0),
	          lo, mid)
	      }
	
	      //Center case (the hard part)
	      if(blue0 + 1 === blue1) {
	        //Optimization: Range with exactly 1 point, use a brute force scan
	        if(full) {
	          retval = onePointFull(
	            d, axis, visit,
	            red0, redEnd, red, redIndex,
	            blue0, blue, blueIndex[blue0])
	        } else {
	          retval = onePointPartial(
	            d, axis, visit, flip,
	            red0, redEnd, red, redIndex,
	            blue0, blue, blueIndex[blue0])
	        }
	        if(retval !== void 0) {
	          return retval
	        }
	      } else if(blue0 < blue1) {
	        var red1
	        if(full) {
	          //If full intersection, need to handle special case
	          red1 = partitionContainsPoint(
	            d, axis,
	            red0, redEnd, red, redIndex,
	            mid)
	          if(red0 < red1) {
	            var redX = partitionStartEqual(
	              d, axis,
	              red0, red1, red, redIndex,
	              mid)
	            if(axis === d-2) {
	              //Degenerate sweep intersection:
	              //  [red0, redX] with [blue0, blue1]
	              if(red0 < redX) {
	                retval = sweep.sweepComplete(
	                  d, visit,
	                  red0, redX, red, redIndex,
	                  blue0, blue1, blue, blueIndex)
	                if(retval !== void 0) {
	                  return retval
	                }
	              }
	
	              //Normal sweep intersection:
	              //  [redX, red1] with [blue0, blue1]
	              if(redX < red1) {
	                retval = sweep.sweepBipartite(
	                  d, visit,
	                  redX, red1, red, redIndex,
	                  blue0, blue1, blue, blueIndex)
	                if(retval !== void 0) {
	                  return retval
	                }
	              }
	            } else {
	              if(red0 < redX) {
	                iterPush(top++,
	                  axis+1,
	                  red0, redX,
	                  blue0, blue1,
	                  16,
	                  -Infinity, Infinity)
	              }
	              if(redX < red1) {
	                iterPush(top++,
	                  axis+1,
	                  redX, red1,
	                  blue0, blue1,
	                  0,
	                  -Infinity, Infinity)
	                iterPush(top++,
	                  axis+1,
	                  blue0, blue1,
	                  redX, red1,
	                  1,
	                  -Infinity, Infinity)
	              }
	            }
	          }
	        } else {
	          if(flip) {
	            red1 = partitionContainsPointProper(
	              d, axis,
	              red0, redEnd, red, redIndex,
	              mid)
	          } else {
	            red1 = partitionContainsPoint(
	              d, axis,
	              red0, redEnd, red, redIndex,
	              mid)
	          }
	          if(red0 < red1) {
	            if(axis === d-2) {
	              if(flip) {
	                retval = sweep.sweepBipartite(
	                  d, visit,
	                  blue0, blue1, blue, blueIndex,
	                  red0, red1, red, redIndex)
	              } else {
	                retval = sweep.sweepBipartite(
	                  d, visit,
	                  red0, red1, red, redIndex,
	                  blue0, blue1, blue, blueIndex)
	              }
	            } else {
	              iterPush(top++,
	                axis+1,
	                red0, red1,
	                blue0, blue1,
	                flip,
	                -Infinity, Infinity)
	              iterPush(top++,
	                axis+1,
	                blue0, blue1,
	                red0, red1,
	                flip^1,
	                -Infinity, Infinity)
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{"./brute":98,"./median":100,"./partition":101,"./sweep":103,"bit-twiddle":93,"typedarray-pool":543}],100:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = findMedian
	
	var genPartition = _dereq_('./partition')
	
	var partitionStartLessThan = genPartition('lo<p0', ['p0'])
	
	var PARTITION_THRESHOLD = 8   //Cut off for using insertion sort in findMedian
	
	//Base case for median finding:  Use insertion sort
	function insertionSort(d, axis, start, end, boxes, ids) {
	  var elemSize = 2 * d
	  var boxPtr = elemSize * (start+1) + axis
	  for(var i=start+1; i<end; ++i, boxPtr+=elemSize) {
	    var x = boxes[boxPtr]
	    for(var j=i, ptr=elemSize*(i-1); 
	        j>start && boxes[ptr+axis] > x; 
	        --j, ptr-=elemSize) {
	      //Swap
	      var aPtr = ptr
	      var bPtr = ptr+elemSize
	      for(var k=0; k<elemSize; ++k, ++aPtr, ++bPtr) {
	        var y = boxes[aPtr]
	        boxes[aPtr] = boxes[bPtr]
	        boxes[bPtr] = y
	      }
	      var tmp = ids[j]
	      ids[j] = ids[j-1]
	      ids[j-1] = tmp
	    }
	  }
	}
	
	//Find median using quick select algorithm
	//  takes O(n) time with high probability
	function findMedian(d, axis, start, end, boxes, ids) {
	  if(end <= start+1) {
	    return start
	  }
	
	  var lo       = start
	  var hi       = end
	  var mid      = ((end + start) >>> 1)
	  var elemSize = 2*d
	  var pivot    = mid
	  var value    = boxes[elemSize*mid+axis]
	  
	  while(lo < hi) {
	    if(hi - lo < PARTITION_THRESHOLD) {
	      insertionSort(d, axis, lo, hi, boxes, ids)
	      value = boxes[elemSize*mid+axis]
	      break
	    }
	    
	    //Select pivot using median-of-3
	    var count  = hi - lo
	    var pivot0 = (Math.random()*count+lo)|0
	    var value0 = boxes[elemSize*pivot0 + axis]
	    var pivot1 = (Math.random()*count+lo)|0
	    var value1 = boxes[elemSize*pivot1 + axis]
	    var pivot2 = (Math.random()*count+lo)|0
	    var value2 = boxes[elemSize*pivot2 + axis]
	    if(value0 <= value1) {
	      if(value2 >= value1) {
	        pivot = pivot1
	        value = value1
	      } else if(value0 >= value2) {
	        pivot = pivot0
	        value = value0
	      } else {
	        pivot = pivot2
	        value = value2
	      }
	    } else {
	      if(value1 >= value2) {
	        pivot = pivot1
	        value = value1
	      } else if(value2 >= value0) {
	        pivot = pivot0
	        value = value0
	      } else {
	        pivot = pivot2
	        value = value2
	      }
	    }
	
	    //Swap pivot to end of array
	    var aPtr = elemSize * (hi-1)
	    var bPtr = elemSize * pivot
	    for(var i=0; i<elemSize; ++i, ++aPtr, ++bPtr) {
	      var x = boxes[aPtr]
	      boxes[aPtr] = boxes[bPtr]
	      boxes[bPtr] = x
	    }
	    var y = ids[hi-1]
	    ids[hi-1] = ids[pivot]
	    ids[pivot] = y
	
	    //Partition using pivot
	    pivot = partitionStartLessThan(
	      d, axis, 
	      lo, hi-1, boxes, ids,
	      value)
	
	    //Swap pivot back
	    var aPtr = elemSize * (hi-1)
	    var bPtr = elemSize * pivot
	    for(var i=0; i<elemSize; ++i, ++aPtr, ++bPtr) {
	      var x = boxes[aPtr]
	      boxes[aPtr] = boxes[bPtr]
	      boxes[bPtr] = x
	    }
	    var y = ids[hi-1]
	    ids[hi-1] = ids[pivot]
	    ids[pivot] = y
	
	    //Swap pivot to last pivot
	    if(mid < pivot) {
	      hi = pivot-1
	      while(lo < hi && 
	        boxes[elemSize*(hi-1)+axis] === value) {
	        hi -= 1
	      }
	      hi += 1
	    } else if(pivot < mid) {
	      lo = pivot + 1
	      while(lo < hi &&
	        boxes[elemSize*lo+axis] === value) {
	        lo += 1
	      }
	    } else {
	      break
	    }
	  }
	
	  //Make sure pivot is at start
	  return partitionStartLessThan(
	    d, axis, 
	    start, mid, boxes, ids,
	    boxes[elemSize*mid+axis])
	}
	},{"./partition":101}],101:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = genPartition
	
	var code = 'for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m'
	
	function genPartition(predicate, args) {
	  var fargs ='abcdef'.split('').concat(args)
	  var reads = []
	  if(predicate.indexOf('lo') >= 0) {
	    reads.push('lo=e[k+n]')
	  }
	  if(predicate.indexOf('hi') >= 0) {
	    reads.push('hi=e[k+o]')
	  }
	  fargs.push(
	    code.replace('_', reads.join())
	        .replace('$', predicate))
	  return Function.apply(void 0, fargs)
	}
	},{}],102:[function(_dereq_,module,exports){
	'use strict';
	
	//This code is extracted from ndarray-sort
	//It is inlined here as a temporary workaround
	
	module.exports = wrapper;
	
	var INSERT_SORT_CUTOFF = 32
	
	function wrapper(data, n0) {
	  if (n0 <= 4*INSERT_SORT_CUTOFF) {
	    insertionSort(0, n0 - 1, data);
	  } else {
	    quickSort(0, n0 - 1, data);
	  }
	}
	
	function insertionSort(left, right, data) {
	  var ptr = 2*(left+1)
	  for(var i=left+1; i<=right; ++i) {
	    var a = data[ptr++]
	    var b = data[ptr++]
	    var j = i
	    var jptr = ptr-2
	    while(j-- > left) {
	      var x = data[jptr-2]
	      var y = data[jptr-1]
	      if(x < a) {
	        break
	      } else if(x === a && y < b) {
	        break
	      }
	      data[jptr]   = x
	      data[jptr+1] = y
	      jptr -= 2
	    }
	    data[jptr]   = a
	    data[jptr+1] = b
	  }
	}
	
	function swap(i, j, data) {
	  i *= 2
	  j *= 2
	  var x = data[i]
	  var y = data[i+1]
	  data[i] = data[j]
	  data[i+1] = data[j+1]
	  data[j] = x
	  data[j+1] = y
	}
	
	function move(i, j, data) {
	  i *= 2
	  j *= 2
	  data[i] = data[j]
	  data[i+1] = data[j+1]
	}
	
	function rotate(i, j, k, data) {
	  i *= 2
	  j *= 2
	  k *= 2
	  var x = data[i]
	  var y = data[i+1]
	  data[i] = data[j]
	  data[i+1] = data[j+1]
	  data[j] = data[k]
	  data[j+1] = data[k+1]
	  data[k] = x
	  data[k+1] = y
	}
	
	function shufflePivot(i, j, px, py, data) {
	  i *= 2
	  j *= 2
	  data[i] = data[j]
	  data[j] = px
	  data[i+1] = data[j+1]
	  data[j+1] = py
	}
	
	function compare(i, j, data) {
	  i *= 2
	  j *= 2
	  var x = data[i],
	      y = data[j]
	  if(x < y) {
	    return false
	  } else if(x === y) {
	    return data[i+1] > data[j+1]
	  }
	  return true
	}
	
	function comparePivot(i, y, b, data) {
	  i *= 2
	  var x = data[i]
	  if(x < y) {
	    return true
	  } else if(x === y) {
	    return data[i+1] < b
	  }
	  return false
	}
	
	function quickSort(left, right, data) {
	  var sixth = (right - left + 1) / 6 | 0, 
	      index1 = left + sixth, 
	      index5 = right - sixth, 
	      index3 = left + right >> 1, 
	      index2 = index3 - sixth, 
	      index4 = index3 + sixth, 
	      el1 = index1, 
	      el2 = index2, 
	      el3 = index3, 
	      el4 = index4, 
	      el5 = index5, 
	      less = left + 1, 
	      great = right - 1, 
	      tmp = 0
	  if(compare(el1, el2, data)) {
	    tmp = el1
	    el1 = el2
	    el2 = tmp
	  }
	  if(compare(el4, el5, data)) {
	    tmp = el4
	    el4 = el5
	    el5 = tmp
	  }
	  if(compare(el1, el3, data)) {
	    tmp = el1
	    el1 = el3
	    el3 = tmp
	  }
	  if(compare(el2, el3, data)) {
	    tmp = el2
	    el2 = el3
	    el3 = tmp
	  }
	  if(compare(el1, el4, data)) {
	    tmp = el1
	    el1 = el4
	    el4 = tmp
	  }
	  if(compare(el3, el4, data)) {
	    tmp = el3
	    el3 = el4
	    el4 = tmp
	  }
	  if(compare(el2, el5, data)) {
	    tmp = el2
	    el2 = el5
	    el5 = tmp
	  }
	  if(compare(el2, el3, data)) {
	    tmp = el2
	    el2 = el3
	    el3 = tmp
	  }
	  if(compare(el4, el5, data)) {
	    tmp = el4
	    el4 = el5
	    el5 = tmp
	  }
	
	  var pivot1X = data[2*el2]
	  var pivot1Y = data[2*el2+1]
	  var pivot2X = data[2*el4]
	  var pivot2Y = data[2*el4+1]
	
	  var ptr0 = 2 * el1;
	  var ptr2 = 2 * el3;
	  var ptr4 = 2 * el5;
	  var ptr5 = 2 * index1;
	  var ptr6 = 2 * index3;
	  var ptr7 = 2 * index5;
	  for (var i1 = 0; i1 < 2; ++i1) {
	    var x = data[ptr0+i1];
	    var y = data[ptr2+i1];
	    var z = data[ptr4+i1];
	    data[ptr5+i1] = x;
	    data[ptr6+i1] = y;
	    data[ptr7+i1] = z;
	  }
	
	  move(index2, left, data)
	  move(index4, right, data)
	  for (var k = less; k <= great; ++k) {
	    if (comparePivot(k, pivot1X, pivot1Y, data)) {
	      if (k !== less) {
	        swap(k, less, data)
	      }
	      ++less;
	    } else {
	      if (!comparePivot(k, pivot2X, pivot2Y, data)) {
	        while (true) {
	          if (!comparePivot(great, pivot2X, pivot2Y, data)) {
	            if (--great < k) {
	              break;
	            }
	            continue;
	          } else {
	            if (comparePivot(great, pivot1X, pivot1Y, data)) {
	              rotate(k, less, great, data)
	              ++less;
	              --great;
	            } else {
	              swap(k, great, data)
	              --great;
	            }
	            break;
	          }
	        }
	      }
	    }
	  }
	  shufflePivot(left, less-1, pivot1X, pivot1Y, data)
	  shufflePivot(right, great+1, pivot2X, pivot2Y, data)
	  if (less - 2 - left <= INSERT_SORT_CUTOFF) {
	    insertionSort(left, less - 2, data);
	  } else {
	    quickSort(left, less - 2, data);
	  }
	  if (right - (great + 2) <= INSERT_SORT_CUTOFF) {
	    insertionSort(great + 2, right, data);
	  } else {
	    quickSort(great + 2, right, data);
	  }
	  if (great - less <= INSERT_SORT_CUTOFF) {
	    insertionSort(less, great, data);
	  } else {
	    quickSort(less, great, data);
	  }
	}
	},{}],103:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = {
	  init:           sqInit,
	  sweepBipartite: sweepBipartite,
	  sweepComplete:  sweepComplete,
	  scanBipartite:  scanBipartite,
	  scanComplete:   scanComplete
	}
	
	var pool  = _dereq_('typedarray-pool')
	var bits  = _dereq_('bit-twiddle')
	var isort = _dereq_('./sort')
	
	//Flag for blue
	var BLUE_FLAG = (1<<28)
	
	//1D sweep event queue stuff (use pool to save space)
	var INIT_CAPACITY      = 1024
	var RED_SWEEP_QUEUE    = pool.mallocInt32(INIT_CAPACITY)
	var RED_SWEEP_INDEX    = pool.mallocInt32(INIT_CAPACITY)
	var BLUE_SWEEP_QUEUE   = pool.mallocInt32(INIT_CAPACITY)
	var BLUE_SWEEP_INDEX   = pool.mallocInt32(INIT_CAPACITY)
	var COMMON_SWEEP_QUEUE = pool.mallocInt32(INIT_CAPACITY)
	var COMMON_SWEEP_INDEX = pool.mallocInt32(INIT_CAPACITY)
	var SWEEP_EVENTS       = pool.mallocDouble(INIT_CAPACITY * 8)
	
	//Reserves memory for the 1D sweep data structures
	function sqInit(count) {
	  var rcount = bits.nextPow2(count)
	  if(RED_SWEEP_QUEUE.length < rcount) {
	    pool.free(RED_SWEEP_QUEUE)
	    RED_SWEEP_QUEUE = pool.mallocInt32(rcount)
	  }
	  if(RED_SWEEP_INDEX.length < rcount) {
	    pool.free(RED_SWEEP_INDEX)
	    RED_SWEEP_INDEX = pool.mallocInt32(rcount)
	  }
	  if(BLUE_SWEEP_QUEUE.length < rcount) {
	    pool.free(BLUE_SWEEP_QUEUE)
	    BLUE_SWEEP_QUEUE = pool.mallocInt32(rcount)
	  }
	  if(BLUE_SWEEP_INDEX.length < rcount) {
	    pool.free(BLUE_SWEEP_INDEX)
	    BLUE_SWEEP_INDEX = pool.mallocInt32(rcount)
	  }
	  if(COMMON_SWEEP_QUEUE.length < rcount) {
	    pool.free(COMMON_SWEEP_QUEUE)
	    COMMON_SWEEP_QUEUE = pool.mallocInt32(rcount)
	  }
	  if(COMMON_SWEEP_INDEX.length < rcount) {
	    pool.free(COMMON_SWEEP_INDEX)
	    COMMON_SWEEP_INDEX = pool.mallocInt32(rcount)
	  }
	  var eventLength = 8 * rcount
	  if(SWEEP_EVENTS.length < eventLength) {
	    pool.free(SWEEP_EVENTS)
	    SWEEP_EVENTS = pool.mallocDouble(eventLength)
	  }
	}
	
	//Remove an item from the active queue in O(1)
	function sqPop(queue, index, count, item) {
	  var idx = index[item]
	  var top = queue[count-1]
	  queue[idx] = top
	  index[top] = idx
	}
	
	//Insert an item into the active queue in O(1)
	function sqPush(queue, index, count, item) {
	  queue[count] = item
	  index[item]  = count
	}
	
	//Recursion base case: use 1D sweep algorithm
	function sweepBipartite(
	    d, visit,
	    redStart,  redEnd, red, redIndex,
	    blueStart, blueEnd, blue, blueIndex) {
	
	  //store events as pairs [coordinate, idx]
	  //
	  //  red create:  -(idx+1)
	  //  red destroy: idx
	  //  blue create: -(idx+BLUE_FLAG)
	  //  blue destroy: idx+BLUE_FLAG
	  //
	  var ptr      = 0
	  var elemSize = 2*d
	  var istart   = d-1
	  var iend     = elemSize-1
	
	  for(var i=redStart; i<redEnd; ++i) {
	    var idx = redIndex[i]
	    var redOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = red[redOffset+istart]
	    SWEEP_EVENTS[ptr++] = -(idx+1)
	    SWEEP_EVENTS[ptr++] = red[redOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx
	  }
	
	  for(var i=blueStart; i<blueEnd; ++i) {
	    var idx = blueIndex[i]+BLUE_FLAG
	    var blueOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx
	  }
	
	  //process events from left->right
	  var n = ptr >>> 1
	  isort(SWEEP_EVENTS, n)
	  
	  var redActive  = 0
	  var blueActive = 0
	  for(var i=0; i<n; ++i) {
	    var e = SWEEP_EVENTS[2*i+1]|0
	    if(e >= BLUE_FLAG) {
	      //blue destroy event
	      e = (e-BLUE_FLAG)|0
	      sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, e)
	    } else if(e >= 0) {
	      //red destroy event
	      sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e)
	    } else if(e <= -BLUE_FLAG) {
	      //blue create event
	      e = (-e-BLUE_FLAG)|0
	      for(var j=0; j<redActive; ++j) {
	        var retval = visit(RED_SWEEP_QUEUE[j], e)
	        if(retval !== void 0) {
	          return retval
	        }
	      }
	      sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, e)
	    } else {
	      //red create event
	      e = (-e-1)|0
	      for(var j=0; j<blueActive; ++j) {
	        var retval = visit(e, BLUE_SWEEP_QUEUE[j])
	        if(retval !== void 0) {
	          return retval
	        }
	      }
	      sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, e)
	    }
	  }
	}
	
	//Complete sweep
	function sweepComplete(d, visit, 
	  redStart, redEnd, red, redIndex,
	  blueStart, blueEnd, blue, blueIndex) {
	
	  var ptr      = 0
	  var elemSize = 2*d
	  var istart   = d-1
	  var iend     = elemSize-1
	
	  for(var i=redStart; i<redEnd; ++i) {
	    var idx = (redIndex[i]+1)<<1
	    var redOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = red[redOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	    SWEEP_EVENTS[ptr++] = red[redOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx
	  }
	
	  for(var i=blueStart; i<blueEnd; ++i) {
	    var idx = (blueIndex[i]+1)<<1
	    var blueOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
	    SWEEP_EVENTS[ptr++] = (-idx)|1
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx|1
	  }
	
	  //process events from left->right
	  var n = ptr >>> 1
	  isort(SWEEP_EVENTS, n)
	  
	  var redActive    = 0
	  var blueActive   = 0
	  var commonActive = 0
	  for(var i=0; i<n; ++i) {
	    var e     = SWEEP_EVENTS[2*i+1]|0
	    var color = e&1
	    if(i < n-1 && (e>>1) === (SWEEP_EVENTS[2*i+3]>>1)) {
	      color = 2
	      i += 1
	    }
	    
	    if(e < 0) {
	      //Create event
	      var id = -(e>>1) - 1
	
	      //Intersect with common
	      for(var j=0; j<commonActive; ++j) {
	        var retval = visit(COMMON_SWEEP_QUEUE[j], id)
	        if(retval !== void 0) {
	          return retval
	        }
	      }
	
	      if(color !== 0) {
	        //Intersect with red
	        for(var j=0; j<redActive; ++j) {
	          var retval = visit(RED_SWEEP_QUEUE[j], id)
	          if(retval !== void 0) {
	            return retval
	          }
	        }
	      }
	
	      if(color !== 1) {
	        //Intersect with blue
	        for(var j=0; j<blueActive; ++j) {
	          var retval = visit(BLUE_SWEEP_QUEUE[j], id)
	          if(retval !== void 0) {
	            return retval
	          }
	        }
	      }
	
	      if(color === 0) {
	        //Red
	        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, id)
	      } else if(color === 1) {
	        //Blue
	        sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, id)
	      } else if(color === 2) {
	        //Both
	        sqPush(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive++, id)
	      }
	    } else {
	      //Destroy event
	      var id = (e>>1) - 1
	      if(color === 0) {
	        //Red
	        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, id)
	      } else if(color === 1) {
	        //Blue
	        sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, id)
	      } else if(color === 2) {
	        //Both
	        sqPop(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive--, id)
	      }
	    }
	  }
	}
	
	//Sweep and prune/scanline algorithm:
	//  Scan along axis, detect intersections
	//  Brute force all boxes along axis
	function scanBipartite(
	  d, axis, visit, flip,
	  redStart,  redEnd, red, redIndex,
	  blueStart, blueEnd, blue, blueIndex) {
	  
	  var ptr      = 0
	  var elemSize = 2*d
	  var istart   = axis
	  var iend     = axis+d
	
	  var redShift  = 1
	  var blueShift = 1
	  if(flip) {
	    blueShift = BLUE_FLAG
	  } else {
	    redShift  = BLUE_FLAG
	  }
	
	  for(var i=redStart; i<redEnd; ++i) {
	    var idx = i + redShift
	    var redOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = red[redOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	    SWEEP_EVENTS[ptr++] = red[redOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx
	  }
	  for(var i=blueStart; i<blueEnd; ++i) {
	    var idx = i + blueShift
	    var blueOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	  }
	
	  //process events from left->right
	  var n = ptr >>> 1
	  isort(SWEEP_EVENTS, n)
	  
	  var redActive    = 0
	  for(var i=0; i<n; ++i) {
	    var e = SWEEP_EVENTS[2*i+1]|0
	    if(e < 0) {
	      var idx   = -e
	      var isRed = false
	      if(idx >= BLUE_FLAG) {
	        isRed = !flip
	        idx -= BLUE_FLAG 
	      } else {
	        isRed = !!flip
	        idx -= 1
	      }
	      if(isRed) {
	        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, idx)
	      } else {
	        var blueId  = blueIndex[idx]
	        var bluePtr = elemSize * idx
	        
	        var b0 = blue[bluePtr+axis+1]
	        var b1 = blue[bluePtr+axis+1+d]
	
	red_loop:
	        for(var j=0; j<redActive; ++j) {
	          var oidx   = RED_SWEEP_QUEUE[j]
	          var redPtr = elemSize * oidx
	
	          if(b1 < red[redPtr+axis+1] || 
	             red[redPtr+axis+1+d] < b0) {
	            continue
	          }
	
	          for(var k=axis+2; k<d; ++k) {
	            if(blue[bluePtr + k + d] < red[redPtr + k] || 
	               red[redPtr + k + d] < blue[bluePtr + k]) {
	              continue red_loop
	            }
	          }
	
	          var redId  = redIndex[oidx]
	          var retval
	          if(flip) {
	            retval = visit(blueId, redId)
	          } else {
	            retval = visit(redId, blueId)
	          }
	          if(retval !== void 0) {
	            return retval 
	          }
	        }
	      }
	    } else {
	      sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e - redShift)
	    }
	  }
	}
	
	function scanComplete(
	  d, axis, visit,
	  redStart,  redEnd, red, redIndex,
	  blueStart, blueEnd, blue, blueIndex) {
	
	  var ptr      = 0
	  var elemSize = 2*d
	  var istart   = axis
	  var iend     = axis+d
	
	  for(var i=redStart; i<redEnd; ++i) {
	    var idx = i + BLUE_FLAG
	    var redOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = red[redOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	    SWEEP_EVENTS[ptr++] = red[redOffset+iend]
	    SWEEP_EVENTS[ptr++] = idx
	  }
	  for(var i=blueStart; i<blueEnd; ++i) {
	    var idx = i + 1
	    var blueOffset = elemSize*i
	    SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
	    SWEEP_EVENTS[ptr++] = -idx
	  }
	
	  //process events from left->right
	  var n = ptr >>> 1
	  isort(SWEEP_EVENTS, n)
	  
	  var redActive    = 0
	  for(var i=0; i<n; ++i) {
	    var e = SWEEP_EVENTS[2*i+1]|0
	    if(e < 0) {
	      var idx   = -e
	      if(idx >= BLUE_FLAG) {
	        RED_SWEEP_QUEUE[redActive++] = idx - BLUE_FLAG
	      } else {
	        idx -= 1
	        var blueId  = blueIndex[idx]
	        var bluePtr = elemSize * idx
	
	        var b0 = blue[bluePtr+axis+1]
	        var b1 = blue[bluePtr+axis+1+d]
	
	red_loop:
	        for(var j=0; j<redActive; ++j) {
	          var oidx   = RED_SWEEP_QUEUE[j]
	          var redId  = redIndex[oidx]
	
	          if(redId === blueId) {
	            break
	          }
	
	          var redPtr = elemSize * oidx
	          if(b1 < red[redPtr+axis+1] || 
	            red[redPtr+axis+1+d] < b0) {
	            continue
	          }
	          for(var k=axis+2; k<d; ++k) {
	            if(blue[bluePtr + k + d] < red[redPtr + k] || 
	               red[redPtr + k + d]   < blue[bluePtr + k]) {
	              continue red_loop
	            }
	          }
	
	          var retval = visit(redId, blueId)
	          if(retval !== void 0) {
	            return retval 
	          }
	        }
	      }
	    } else {
	      var idx = e - BLUE_FLAG
	      for(var j=redActive-1; j>=0; --j) {
	        if(RED_SWEEP_QUEUE[j] === idx) {
	          for(var k=j+1; k<redActive; ++k) {
	            RED_SWEEP_QUEUE[k-1] = RED_SWEEP_QUEUE[k]
	          }
	          break
	        }
	      }
	      --redActive
	    }
	  }
	}
	},{"./sort":102,"bit-twiddle":93,"typedarray-pool":543}],104:[function(_dereq_,module,exports){
	
	},{}],105:[function(_dereq_,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var objectCreate = Object.create || objectCreatePolyfill
	var objectKeys = Object.keys || objectKeysPolyfill
	var bind = Function.prototype.bind || functionBindPolyfill
	
	function EventEmitter() {
	  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
	    this._events = objectCreate(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	var hasDefineProperty;
	try {
	  var o = {};
	  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
	  hasDefineProperty = o.x === 0;
	} catch (err) { hasDefineProperty = false }
	if (hasDefineProperty) {
	  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	    enumerable: true,
	    get: function() {
	      return defaultMaxListeners;
	    },
	    set: function(arg) {
	      // check whether the input is a positive number (whose value is zero or
	      // greater and not a NaN).
	      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
	        throw new TypeError('"defaultMaxListeners" must be a positive number');
	      defaultMaxListeners = arg;
	    }
	  });
	} else {
	  EventEmitter.defaultMaxListeners = defaultMaxListeners;
	}
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || isNaN(n))
	    throw new TypeError('"n" argument must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	function $getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return $getMaxListeners(this);
	};
	
	// These standalone emit* functions are used to optimize calling of event
	// handlers for fast cases because emit() itself often has a variable number of
	// arguments and can be deoptimized because of that. These functions always have
	// the same number of arguments and thus do not get deoptimized, so the code
	// inside them can execute faster.
	function emitNone(handler, isFn, self) {
	  if (isFn)
	    handler.call(self);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self);
	  }
	}
	function emitOne(handler, isFn, self, arg1) {
	  if (isFn)
	    handler.call(self, arg1);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1);
	  }
	}
	function emitTwo(handler, isFn, self, arg1, arg2) {
	  if (isFn)
	    handler.call(self, arg1, arg2);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2);
	  }
	}
	function emitThree(handler, isFn, self, arg1, arg2, arg3) {
	  if (isFn)
	    handler.call(self, arg1, arg2, arg3);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2, arg3);
	  }
	}
	
	function emitMany(handler, isFn, self, args) {
	  if (isFn)
	    handler.apply(self, args);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].apply(self, args);
	  }
	}
	
	EventEmitter.prototype.emit = function emit(type) {
	  var er, handler, len, args, i, events;
	  var doError = (type === 'error');
	
	  events = this._events;
	  if (events)
	    doError = (doError && events.error == null);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    if (arguments.length > 1)
	      er = arguments[1];
	    if (er instanceof Error) {
	      throw er; // Unhandled 'error' event
	    } else {
	      // At least give some kind of context to the user
	      var err = new Error('Unhandled "error" event. (' + er + ')');
	      err.context = er;
	      throw err;
	    }
	    return false;
	  }
	
	  handler = events[type];
	
	  if (!handler)
	    return false;
	
	  var isFn = typeof handler === 'function';
	  len = arguments.length;
	  switch (len) {
	      // fast cases
	    case 1:
	      emitNone(handler, isFn, this);
	      break;
	    case 2:
	      emitOne(handler, isFn, this, arguments[1]);
	      break;
	    case 3:
	      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
	      break;
	    case 4:
	      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
	      break;
	      // slower
	    default:
	      args = new Array(len - 1);
	      for (i = 1; i < len; i++)
	        args[i - 1] = arguments[i];
	      emitMany(handler, isFn, this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');
	
	  events = target._events;
	  if (!events) {
	    events = target._events = objectCreate(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener) {
	      target.emit('newListener', type,
	          listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (!existing) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	          prepend ? [listener, existing] : [existing, listener];
	    } else {
	      // If we've already got an array, just append.
	      if (prepend) {
	        existing.unshift(listener);
	      } else {
	        existing.push(listener);
	      }
	    }
	
	    // Check for listener leak
	    if (!existing.warned) {
	      m = $getMaxListeners(target);
	      if (m && m > 0 && existing.length > m) {
	        existing.warned = true;
	        var w = new Error('Possible EventEmitter memory leak detected. ' +
	            existing.length + ' "' + String(type) + '" listeners ' +
	            'added. Use emitter.setMaxListeners() to ' +
	            'increase limit.');
	        w.name = 'MaxListenersExceededWarning';
	        w.emitter = target;
	        w.type = type;
	        w.count = existing.length;
	        if (typeof console === 'object' && console.warn) {
	          console.warn('%s: %s', w.name, w.message);
	        }
	      }
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    switch (arguments.length) {
	      case 0:
	        return this.listener.call(this.target);
	      case 1:
	        return this.listener.call(this.target, arguments[0]);
	      case 2:
	        return this.listener.call(this.target, arguments[0], arguments[1]);
	      case 3:
	        return this.listener.call(this.target, arguments[0], arguments[1],
	            arguments[2]);
	      default:
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i)
	          args[i] = arguments[i];
	        this.listener.apply(this.target, args);
	    }
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = bind.call(onceWrapper, state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');
	
	      events = this._events;
	      if (!events)
	        return this;
	
	      list = events[type];
	      if (!list)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = objectCreate(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else
	          spliceOne(list, position);
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (!events)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (!events.removeListener) {
	        if (arguments.length === 0) {
	          this._events = objectCreate(null);
	          this._eventsCount = 0;
	        } else if (events[type]) {
	          if (--this._eventsCount === 0)
	            this._events = objectCreate(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = objectKeys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = objectCreate(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (!events)
	    return [];
	
	  var evlistener = events[type];
	  if (!evlistener)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
	};
	
	// About 1.5x faster than the two-arg version of Array#splice().
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
	    list[i] = list[k];
	  list.pop();
	}
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function objectCreatePolyfill(proto) {
	  var F = function() {};
	  F.prototype = proto;
	  return new F;
	}
	function objectKeysPolyfill(obj) {
	  var keys = [];
	  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
	    keys.push(k);
	  }
	  return k;
	}
	function functionBindPolyfill(context) {
	  var fn = this;
	  return function () {
	    return fn.apply(context, arguments);
	  };
	}
	
	},{}],106:[function(_dereq_,module,exports){
	(function (Buffer){
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = _dereq_('base64-js')
	var ieee754 = _dereq_('ieee754')
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol.for === 'function')
	    ? Symbol.for('nodejs.util.inspect.custom')
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	if (typeof Symbol !== 'undefined' && Symbol.species != null &&
	    Buffer[Symbol.species] === Buffer) {
	  Object.defineProperty(Buffer, Symbol.species, {
	    value: null,
	    configurable: true,
	    enumerable: false,
	    writable: false
	  })
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayLike(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      buf = Buffer.from(buf)
	    }
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	        : (firstByte > 0xBF) ? 2
	          : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (var i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	}).call(this,_dereq_("buffer").Buffer)
	},{"base64-js":75,"buffer":106,"ieee754":413}],107:[function(_dereq_,module,exports){
	'use strict'
	
	var monotoneTriangulate = _dereq_('./lib/monotone')
	var makeIndex = _dereq_('./lib/triangulation')
	var delaunayFlip = _dereq_('./lib/delaunay')
	var filterTriangulation = _dereq_('./lib/filter')
	
	module.exports = cdt2d
	
	function canonicalizeEdge(e) {
	  return [Math.min(e[0], e[1]), Math.max(e[0], e[1])]
	}
	
	function compareEdge(a, b) {
	  return a[0]-b[0] || a[1]-b[1]
	}
	
	function canonicalizeEdges(edges) {
	  return edges.map(canonicalizeEdge).sort(compareEdge)
	}
	
	function getDefault(options, property, dflt) {
	  if(property in options) {
	    return options[property]
	  }
	  return dflt
	}
	
	function cdt2d(points, edges, options) {
	
	  if(!Array.isArray(edges)) {
	    options = edges || {}
	    edges = []
	  } else {
	    options = options || {}
	    edges = edges || []
	  }
	
	  //Parse out options
	  var delaunay = !!getDefault(options, 'delaunay', true)
	  var interior = !!getDefault(options, 'interior', true)
	  var exterior = !!getDefault(options, 'exterior', true)
	  var infinity = !!getDefault(options, 'infinity', false)
	
	  //Handle trivial case
	  if((!interior && !exterior) || points.length === 0) {
	    return []
	  }
	
	  //Construct initial triangulation
	  var cells = monotoneTriangulate(points, edges)
	
	  //If delaunay refinement needed, then improve quality by edge flipping
	  if(delaunay || interior !== exterior || infinity) {
	
	    //Index all of the cells to support fast neighborhood queries
	    var triangulation = makeIndex(points.length, canonicalizeEdges(edges))
	    for(var i=0; i<cells.length; ++i) {
	      var f = cells[i]
	      triangulation.addTriangle(f[0], f[1], f[2])
	    }
	
	    //Run edge flipping
	    if(delaunay) {
	      delaunayFlip(points, triangulation)
	    }
	
	    //Filter points
	    if(!exterior) {
	      return filterTriangulation(triangulation, -1)
	    } else if(!interior) {
	      return filterTriangulation(triangulation,  1, infinity)
	    } else if(infinity) {
	      return filterTriangulation(triangulation, 0, infinity)
	    } else {
	      return triangulation.cells()
	    }
	    
	  } else {
	    return cells
	  }
	}
	
	},{"./lib/delaunay":108,"./lib/filter":109,"./lib/monotone":110,"./lib/triangulation":111}],108:[function(_dereq_,module,exports){
	'use strict'
	
	var inCircle = _dereq_('robust-in-sphere')[4]
	var bsearch = _dereq_('binary-search-bounds')
	
	module.exports = delaunayRefine
	
	function testFlip(points, triangulation, stack, a, b, x) {
	  var y = triangulation.opposite(a, b)
	
	  //Test boundary edge
	  if(y < 0) {
	    return
	  }
	
	  //Swap edge if order flipped
	  if(b < a) {
	    var tmp = a
	    a = b
	    b = tmp
	    tmp = x
	    x = y
	    y = tmp
	  }
	
	  //Test if edge is constrained
	  if(triangulation.isConstraint(a, b)) {
	    return
	  }
	
	  //Test if edge is delaunay
	  if(inCircle(points[a], points[b], points[x], points[y]) < 0) {
	    stack.push(a, b)
	  }
	}
	
	//Assume edges are sorted lexicographically
	function delaunayRefine(points, triangulation) {
	  var stack = []
	
	  var numPoints = points.length
	  var stars = triangulation.stars
	  for(var a=0; a<numPoints; ++a) {
	    var star = stars[a]
	    for(var j=1; j<star.length; j+=2) {
	      var b = star[j]
	
	      //If order is not consistent, then skip edge
	      if(b < a) {
	        continue
	      }
	
	      //Check if edge is constrained
	      if(triangulation.isConstraint(a, b)) {
	        continue
	      }
	
	      //Find opposite edge
	      var x = star[j-1], y = -1
	      for(var k=1; k<star.length; k+=2) {
	        if(star[k-1] === b) {
	          y = star[k]
	          break
	        }
	      }
	
	      //If this is a boundary edge, don't flip it
	      if(y < 0) {
	        continue
	      }
	
	      //If edge is in circle, flip it
	      if(inCircle(points[a], points[b], points[x], points[y]) < 0) {
	        stack.push(a, b)
	      }
	    }
	  }
	
	  while(stack.length > 0) {
	    var b = stack.pop()
	    var a = stack.pop()
	
	    //Find opposite pairs
	    var x = -1, y = -1
	    var star = stars[a]
	    for(var i=1; i<star.length; i+=2) {
	      var s = star[i-1]
	      var t = star[i]
	      if(s === b) {
	        y = t
	      } else if(t === b) {
	        x = s
	      }
	    }
	
	    //If x/y are both valid then skip edge
	    if(x < 0 || y < 0) {
	      continue
	    }
	
	    //If edge is now delaunay, then don't flip it
	    if(inCircle(points[a], points[b], points[x], points[y]) >= 0) {
	      continue
	    }
	
	    //Flip the edge
	    triangulation.flip(a, b)
	
	    //Test flipping neighboring edges
	    testFlip(points, triangulation, stack, x, a, y)
	    testFlip(points, triangulation, stack, a, y, x)
	    testFlip(points, triangulation, stack, y, b, x)
	    testFlip(points, triangulation, stack, b, x, y)
	  }
	}
	
	},{"binary-search-bounds":112,"robust-in-sphere":506}],109:[function(_dereq_,module,exports){
	'use strict'
	
	var bsearch = _dereq_('binary-search-bounds')
	
	module.exports = classifyFaces
	
	function FaceIndex(cells, neighbor, constraint, flags, active, next, boundary) {
	  this.cells       = cells
	  this.neighbor    = neighbor
	  this.flags       = flags
	  this.constraint  = constraint
	  this.active      = active
	  this.next        = next
	  this.boundary    = boundary
	}
	
	var proto = FaceIndex.prototype
	
	function compareCell(a, b) {
	  return a[0] - b[0] ||
	         a[1] - b[1] ||
	         a[2] - b[2]
	}
	
	proto.locate = (function() {
	  var key = [0,0,0]
	  return function(a, b, c) {
	    var x = a, y = b, z = c
	    if(b < c) {
	      if(b < a) {
	        x = b
	        y = c
	        z = a
	      }
	    } else if(c < a) {
	      x = c
	      y = a
	      z = b
	    }
	    if(x < 0) {
	      return -1
	    }
	    key[0] = x
	    key[1] = y
	    key[2] = z
	    return bsearch.eq(this.cells, key, compareCell)
	  }
	})()
	
	function indexCells(triangulation, infinity) {
	  //First get cells and canonicalize
	  var cells = triangulation.cells()
	  var nc = cells.length
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    var x = c[0], y = c[1], z = c[2]
	    if(y < z) {
	      if(y < x) {
	        c[0] = y
	        c[1] = z
	        c[2] = x
	      }
	    } else if(z < x) {
	      c[0] = z
	      c[1] = x
	      c[2] = y
	    }
	  }
	  cells.sort(compareCell)
	
	  //Initialize flag array
	  var flags = new Array(nc)
	  for(var i=0; i<flags.length; ++i) {
	    flags[i] = 0
	  }
	
	  //Build neighbor index, initialize queues
	  var active = []
	  var next   = []
	  var neighbor = new Array(3*nc)
	  var constraint = new Array(3*nc)
	  var boundary = null
	  if(infinity) {
	    boundary = []
	  }
	  var index = new FaceIndex(
	    cells,
	    neighbor,
	    constraint,
	    flags,
	    active,
	    next,
	    boundary)
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    for(var j=0; j<3; ++j) {
	      var x = c[j], y = c[(j+1)%3]
	      var a = neighbor[3*i+j] = index.locate(y, x, triangulation.opposite(y, x))
	      var b = constraint[3*i+j] = triangulation.isConstraint(x, y)
	      if(a < 0) {
	        if(b) {
	          next.push(i)
	        } else {
	          active.push(i)
	          flags[i] = 1
	        }
	        if(infinity) {
	          boundary.push([y, x, -1])
	        }
	      }
	    }
	  }
	  return index
	}
	
	function filterCells(cells, flags, target) {
	  var ptr = 0
	  for(var i=0; i<cells.length; ++i) {
	    if(flags[i] === target) {
	      cells[ptr++] = cells[i]
	    }
	  }
	  cells.length = ptr
	  return cells
	}
	
	function classifyFaces(triangulation, target, infinity) {
	  var index = indexCells(triangulation, infinity)
	
	  if(target === 0) {
	    if(infinity) {
	      return index.cells.concat(index.boundary)
	    } else {
	      return index.cells
	    }
	  }
	
	  var side = 1
	  var active = index.active
	  var next = index.next
	  var flags = index.flags
	  var cells = index.cells
	  var constraint = index.constraint
	  var neighbor = index.neighbor
	
	  while(active.length > 0 || next.length > 0) {
	    while(active.length > 0) {
	      var t = active.pop()
	      if(flags[t] === -side) {
	        continue
	      }
	      flags[t] = side
	      var c = cells[t]
	      for(var j=0; j<3; ++j) {
	        var f = neighbor[3*t+j]
	        if(f >= 0 && flags[f] === 0) {
	          if(constraint[3*t+j]) {
	            next.push(f)
	          } else {
	            active.push(f)
	            flags[f] = side
	          }
	        }
	      }
	    }
	
	    //Swap arrays and loop
	    var tmp = next
	    next = active
	    active = tmp
	    next.length = 0
	    side = -side
	  }
	
	  var result = filterCells(cells, flags, target)
	  if(infinity) {
	    return result.concat(index.boundary)
	  }
	  return result
	}
	
	},{"binary-search-bounds":112}],110:[function(_dereq_,module,exports){
	'use strict'
	
	var bsearch = _dereq_('binary-search-bounds')
	var orient = _dereq_('robust-orientation')[3]
	
	var EVENT_POINT = 0
	var EVENT_END   = 1
	var EVENT_START = 2
	
	module.exports = monotoneTriangulate
	
	//A partial convex hull fragment, made of two unimonotone polygons
	function PartialHull(a, b, idx, lowerIds, upperIds) {
	  this.a = a
	  this.b = b
	  this.idx = idx
	  this.lowerIds = lowerIds
	  this.upperIds = upperIds
	}
	
	//An event in the sweep line procedure
	function Event(a, b, type, idx) {
	  this.a    = a
	  this.b    = b
	  this.type = type
	  this.idx  = idx
	}
	
	//This is used to compare events for the sweep line procedure
	// Points are:
	//  1. sorted lexicographically
	//  2. sorted by type  (point < end < start)
	//  3. segments sorted by winding order
	//  4. sorted by index
	function compareEvent(a, b) {
	  var d =
	    (a.a[0] - b.a[0]) ||
	    (a.a[1] - b.a[1]) ||
	    (a.type - b.type)
	  if(d) { return d }
	  if(a.type !== EVENT_POINT) {
	    d = orient(a.a, a.b, b.b)
	    if(d) { return d }
	  }
	  return a.idx - b.idx
	}
	
	function testPoint(hull, p) {
	  return orient(hull.a, hull.b, p)
	}
	
	function addPoint(cells, hulls, points, p, idx) {
	  var lo = bsearch.lt(hulls, p, testPoint)
	  var hi = bsearch.gt(hulls, p, testPoint)
	  for(var i=lo; i<hi; ++i) {
	    var hull = hulls[i]
	
	    //Insert p into lower hull
	    var lowerIds = hull.lowerIds
	    var m = lowerIds.length
	    while(m > 1 && orient(
	        points[lowerIds[m-2]],
	        points[lowerIds[m-1]],
	        p) > 0) {
	      cells.push(
	        [lowerIds[m-1],
	         lowerIds[m-2],
	         idx])
	      m -= 1
	    }
	    lowerIds.length = m
	    lowerIds.push(idx)
	
	    //Insert p into upper hull
	    var upperIds = hull.upperIds
	    var m = upperIds.length
	    while(m > 1 && orient(
	        points[upperIds[m-2]],
	        points[upperIds[m-1]],
	        p) < 0) {
	      cells.push(
	        [upperIds[m-2],
	         upperIds[m-1],
	         idx])
	      m -= 1
	    }
	    upperIds.length = m
	    upperIds.push(idx)
	  }
	}
	
	function findSplit(hull, edge) {
	  var d
	  if(hull.a[0] < edge.a[0]) {
	    d = orient(hull.a, hull.b, edge.a)
	  } else {
	    d = orient(edge.b, edge.a, hull.a)
	  }
	  if(d) { return d }
	  if(edge.b[0] < hull.b[0]) {
	    d = orient(hull.a, hull.b, edge.b)
	  } else {
	    d = orient(edge.b, edge.a, hull.b)
	  }
	  return d || hull.idx - edge.idx
	}
	
	function splitHulls(hulls, points, event) {
	  var splitIdx = bsearch.le(hulls, event, findSplit)
	  var hull = hulls[splitIdx]
	  var upperIds = hull.upperIds
	  var x = upperIds[upperIds.length-1]
	  hull.upperIds = [x]
	  hulls.splice(splitIdx+1, 0,
	    new PartialHull(event.a, event.b, event.idx, [x], upperIds))
	}
	
	
	function mergeHulls(hulls, points, event) {
	  //Swap pointers for merge search
	  var tmp = event.a
	  event.a = event.b
	  event.b = tmp
	  var mergeIdx = bsearch.eq(hulls, event, findSplit)
	  var upper = hulls[mergeIdx]
	  var lower = hulls[mergeIdx-1]
	  lower.upperIds = upper.upperIds
	  hulls.splice(mergeIdx, 1)
	}
	
	
	function monotoneTriangulate(points, edges) {
	
	  var numPoints = points.length
	  var numEdges = edges.length
	
	  var events = []
	
	  //Create point events
	  for(var i=0; i<numPoints; ++i) {
	    events.push(new Event(
	      points[i],
	      null,
	      EVENT_POINT,
	      i))
	  }
	
	  //Create edge events
	  for(var i=0; i<numEdges; ++i) {
	    var e = edges[i]
	    var a = points[e[0]]
	    var b = points[e[1]]
	    if(a[0] < b[0]) {
	      events.push(
	        new Event(a, b, EVENT_START, i),
	        new Event(b, a, EVENT_END, i))
	    } else if(a[0] > b[0]) {
	      events.push(
	        new Event(b, a, EVENT_START, i),
	        new Event(a, b, EVENT_END, i))
	    }
	  }
	
	  //Sort events
	  events.sort(compareEvent)
	
	  //Initialize hull
	  var minX = events[0].a[0] - (1 + Math.abs(events[0].a[0])) * Math.pow(2, -52)
	  var hull = [ new PartialHull([minX, 1], [minX, 0], -1, [], [], [], []) ]
	
	  //Process events in order
	  var cells = []
	  for(var i=0, numEvents=events.length; i<numEvents; ++i) {
	    var event = events[i]
	    var type = event.type
	    if(type === EVENT_POINT) {
	      addPoint(cells, hull, points, event.a, event.idx)
	    } else if(type === EVENT_START) {
	      splitHulls(hull, points, event)
	    } else {
	      mergeHulls(hull, points, event)
	    }
	  }
	
	  //Return triangulation
	  return cells
	}
	
	},{"binary-search-bounds":112,"robust-orientation":508}],111:[function(_dereq_,module,exports){
	'use strict'
	
	var bsearch = _dereq_('binary-search-bounds')
	
	module.exports = createTriangulation
	
	function Triangulation(stars, edges) {
	  this.stars = stars
	  this.edges = edges
	}
	
	var proto = Triangulation.prototype
	
	function removePair(list, j, k) {
	  for(var i=1, n=list.length; i<n; i+=2) {
	    if(list[i-1] === j && list[i] === k) {
	      list[i-1] = list[n-2]
	      list[i] = list[n-1]
	      list.length = n - 2
	      return
	    }
	  }
	}
	
	proto.isConstraint = (function() {
	  var e = [0,0]
	  function compareLex(a, b) {
	    return a[0] - b[0] || a[1] - b[1]
	  }
	  return function(i, j) {
	    e[0] = Math.min(i,j)
	    e[1] = Math.max(i,j)
	    return bsearch.eq(this.edges, e, compareLex) >= 0
	  }
	})()
	
	proto.removeTriangle = function(i, j, k) {
	  var stars = this.stars
	  removePair(stars[i], j, k)
	  removePair(stars[j], k, i)
	  removePair(stars[k], i, j)
	}
	
	proto.addTriangle = function(i, j, k) {
	  var stars = this.stars
	  stars[i].push(j, k)
	  stars[j].push(k, i)
	  stars[k].push(i, j)
	}
	
	proto.opposite = function(j, i) {
	  var list = this.stars[i]
	  for(var k=1, n=list.length; k<n; k+=2) {
	    if(list[k] === j) {
	      return list[k-1]
	    }
	  }
	  return -1
	}
	
	proto.flip = function(i, j) {
	  var a = this.opposite(i, j)
	  var b = this.opposite(j, i)
	  this.removeTriangle(i, j, a)
	  this.removeTriangle(j, i, b)
	  this.addTriangle(i, b, a)
	  this.addTriangle(j, a, b)
	}
	
	proto.edges = function() {
	  var stars = this.stars
	  var result = []
	  for(var i=0, n=stars.length; i<n; ++i) {
	    var list = stars[i]
	    for(var j=0, m=list.length; j<m; j+=2) {
	      result.push([list[j], list[j+1]])
	    }
	  }
	  return result
	}
	
	proto.cells = function() {
	  var stars = this.stars
	  var result = []
	  for(var i=0, n=stars.length; i<n; ++i) {
	    var list = stars[i]
	    for(var j=0, m=list.length; j<m; j+=2) {
	      var s = list[j]
	      var t = list[j+1]
	      if(i < Math.min(s, t)) {
	        result.push([i, s, t])
	      }
	    }
	  }
	  return result
	}
	
	function createTriangulation(numVerts, edges) {
	  var stars = new Array(numVerts)
	  for(var i=0; i<numVerts; ++i) {
	    stars[i] = []
	  }
	  return new Triangulation(stars, edges)
	}
	
	},{"binary-search-bounds":112}],112:[function(_dereq_,module,exports){
	"use strict"
	
	function compileSearch(funcName, predicate, reversed, extraArgs, earlyOut) {
	  var code = [
	    "function ", funcName, "(a,l,h,", extraArgs.join(","),  "){",
	    earlyOut ? "" : "var i=", (reversed ? "l-1" : "h+1"),
	    ";while(l<=h){var m=(l+h)>>>1,x=a[m]"]
	  if(earlyOut) {
	    if(predicate.indexOf("c") < 0) {
	      code.push(";if(x===y){return m}else if(x<=y){")
	    } else {
	      code.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){")
	    }
	  } else {
	    code.push(";if(", predicate, "){i=m;")
	  }
	  if(reversed) {
	    code.push("l=m+1}else{h=m-1}")
	  } else {
	    code.push("h=m-1}else{l=m+1}")
	  }
	  code.push("}")
	  if(earlyOut) {
	    code.push("return -1};")
	  } else {
	    code.push("return i};")
	  }
	  return code.join("")
	}
	
	function compileBoundsSearch(predicate, reversed, suffix, earlyOut) {
	  var result = new Function([
	  compileSearch("A", "x" + predicate + "y", reversed, ["y"], earlyOut),
	  compileSearch("P", "c(x,y)" + predicate + "0", reversed, ["y", "c"], earlyOut),
	"function dispatchBsearch", suffix, "(a,y,c,l,h){\
	if(typeof(c)==='function'){\
	return P(a,(l===void 0)?0:l|0,(h===void 0)?a.length-1:h|0,y,c)\
	}else{\
	return A(a,(c===void 0)?0:c|0,(l===void 0)?a.length-1:l|0,y)\
	}}\
	return dispatchBsearch", suffix].join(""))
	  return result()
	}
	
	module.exports = {
	  ge: compileBoundsSearch(">=", false,  "GE"),
	  gt: compileBoundsSearch(">",  false,  "GT"),
	  lt: compileBoundsSearch("<",  true,   "LT"),
	  le: compileBoundsSearch("<=", true,   "LE"),
	  eq: compileBoundsSearch("-",  true,   "EQ", true)
	}
	
	},{}],113:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = orientation
	
	function orientation(s) {
	  var p = 1
	  for(var i=1; i<s.length; ++i) {
	    for(var j=0; j<i; ++j) {
	      if(s[i] < s[j]) {
	        p = -p
	      } else if(s[j] === s[i]) {
	        return 0
	      }
	    }
	  }
	  return p
	}
	
	},{}],114:[function(_dereq_,module,exports){
	"use strict"
	
	var dup = _dereq_("dup")
	var solve = _dereq_("robust-linear-solve")
	
	function dot(a, b) {
	  var s = 0.0
	  var d = a.length
	  for(var i=0; i<d; ++i) {
	    s += a[i] * b[i]
	  }
	  return s
	}
	
	function barycentricCircumcenter(points) {
	  var N = points.length
	  if(N === 0) {
	    return []
	  }
	  
	  var D = points[0].length
	  var A = dup([points.length+1, points.length+1], 1.0)
	  var b = dup([points.length+1], 1.0)
	  A[N][N] = 0.0
	  for(var i=0; i<N; ++i) {
	    for(var j=0; j<=i; ++j) {
	      A[j][i] = A[i][j] = 2.0 * dot(points[i], points[j])
	    }
	    b[i] = dot(points[i], points[i])
	  }
	  var x = solve(A, b)
	
	  var denom = 0.0
	  var h = x[N+1]
	  for(var i=0; i<h.length; ++i) {
	    denom += h[i]
	  }
	
	  var y = new Array(N)
	  for(var i=0; i<N; ++i) {
	    var h = x[i]
	    var numer = 0.0
	    for(var j=0; j<h.length; ++j) {
	      numer += h[j]
	    }
	    y[i] =  numer / denom
	  }
	
	  return y
	}
	
	function circumcenter(points) {
	  if(points.length === 0) {
	    return []
	  }
	  var D = points[0].length
	  var result = dup([D])
	  var weights = barycentricCircumcenter(points)
	  for(var i=0; i<points.length; ++i) {
	    for(var j=0; j<D; ++j) {
	      result[j] += points[i][j] * weights[i]
	    }
	  }
	  return result
	}
	
	circumcenter.barycenetric = barycentricCircumcenter
	module.exports = circumcenter
	},{"dup":171,"robust-linear-solve":507}],115:[function(_dereq_,module,exports){
	module.exports = circumradius
	
	var circumcenter = _dereq_('circumcenter')
	
	function circumradius(points) {
	  var center = circumcenter(points)
	  var avgDist = 0.0
	  for(var i=0; i<points.length; ++i) {
	    var p = points[i]
	    for(var j=0; j<center.length; ++j) {
	      avgDist += Math.pow(p[j] - center[j], 2)
	    }
	  }
	  return Math.sqrt(avgDist / points.length)
	}
	},{"circumcenter":114}],116:[function(_dereq_,module,exports){
	module.exports = clamp
	
	function clamp(value, min, max) {
	  return min < max
	    ? (value < min ? min : value > max ? max : value)
	    : (value < max ? max : value > min ? min : value)
	}
	
	},{}],117:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = cleanPSLG
	
	var UnionFind = _dereq_('union-find')
	var boxIntersect = _dereq_('box-intersect')
	var segseg = _dereq_('robust-segment-intersect')
	var rat = _dereq_('big-rat')
	var ratCmp = _dereq_('big-rat/cmp')
	var ratToFloat = _dereq_('big-rat/to-float')
	var ratVec = _dereq_('rat-vec')
	var nextafter = _dereq_('nextafter')
	
	var solveIntersection = _dereq_('./lib/rat-seg-intersect')
	
	// Bounds on a rational number when rounded to a float
	function boundRat (r) {
	  var f = ratToFloat(r)
	  return [
	    nextafter(f, -Infinity),
	    nextafter(f, Infinity)
	  ]
	}
	
	// Convert a list of edges in a pslg to bounding boxes
	function boundEdges (points, edges) {
	  var bounds = new Array(edges.length)
	  for (var i = 0; i < edges.length; ++i) {
	    var e = edges[i]
	    var a = points[e[0]]
	    var b = points[e[1]]
	    bounds[i] = [
	      nextafter(Math.min(a[0], b[0]), -Infinity),
	      nextafter(Math.min(a[1], b[1]), -Infinity),
	      nextafter(Math.max(a[0], b[0]), Infinity),
	      nextafter(Math.max(a[1], b[1]), Infinity)
	    ]
	  }
	  return bounds
	}
	
	// Convert a list of points into bounding boxes by duplicating coords
	function boundPoints (points) {
	  var bounds = new Array(points.length)
	  for (var i = 0; i < points.length; ++i) {
	    var p = points[i]
	    bounds[i] = [
	      nextafter(p[0], -Infinity),
	      nextafter(p[1], -Infinity),
	      nextafter(p[0], Infinity),
	      nextafter(p[1], Infinity)
	    ]
	  }
	  return bounds
	}
	
	// Find all pairs of crossing edges in a pslg (given edge bounds)
	function getCrossings (points, edges, edgeBounds) {
	  var result = []
	  boxIntersect(edgeBounds, function (i, j) {
	    var e = edges[i]
	    var f = edges[j]
	    if (e[0] === f[0] || e[0] === f[1] ||
	      e[1] === f[0] || e[1] === f[1]) {
	      return
	    }
	    var a = points[e[0]]
	    var b = points[e[1]]
	    var c = points[f[0]]
	    var d = points[f[1]]
	    if (segseg(a, b, c, d)) {
	      result.push([i, j])
	    }
	  })
	  return result
	}
	
	// Find all pairs of crossing vertices in a pslg (given edge/vert bounds)
	function getTJunctions (points, edges, edgeBounds, vertBounds) {
	  var result = []
	  boxIntersect(edgeBounds, vertBounds, function (i, v) {
	    var e = edges[i]
	    if (e[0] === v || e[1] === v) {
	      return
	    }
	    var p = points[v]
	    var a = points[e[0]]
	    var b = points[e[1]]
	    if (segseg(a, b, p, p)) {
	      result.push([i, v])
	    }
	  })
	  return result
	}
	
	// Cut edges along crossings/tjunctions
	function cutEdges (floatPoints, edges, crossings, junctions, useColor) {
	  var i, e
	
	  // Convert crossings into tjunctions by constructing rational points
	  var ratPoints = floatPoints.map(function(p) {
	      return [
	          rat(p[0]),
	          rat(p[1])
	      ]
	  })
	  for (i = 0; i < crossings.length; ++i) {
	    var crossing = crossings[i]
	    e = crossing[0]
	    var f = crossing[1]
	    var ee = edges[e]
	    var ef = edges[f]
	    var x = solveIntersection(
	      ratVec(floatPoints[ee[0]]),
	      ratVec(floatPoints[ee[1]]),
	      ratVec(floatPoints[ef[0]]),
	      ratVec(floatPoints[ef[1]]))
	    if (!x) {
	      // Segments are parallel, should already be handled by t-junctions
	      continue
	    }
	    var idx = floatPoints.length
	    floatPoints.push([ratToFloat(x[0]), ratToFloat(x[1])])
	    ratPoints.push(x)
	    junctions.push([e, idx], [f, idx])
	  }
	
	  // Sort tjunctions
	  junctions.sort(function (a, b) {
	    if (a[0] !== b[0]) {
	      return a[0] - b[0]
	    }
	    var u = ratPoints[a[1]]
	    var v = ratPoints[b[1]]
	    return ratCmp(u[0], v[0]) || ratCmp(u[1], v[1])
	  })
	
	  // Split edges along junctions
	  for (i = junctions.length - 1; i >= 0; --i) {
	    var junction = junctions[i]
	    e = junction[0]
	
	    var edge = edges[e]
	    var s = edge[0]
	    var t = edge[1]
	
	    // Check if edge is not lexicographically sorted
	    var a = floatPoints[s]
	    var b = floatPoints[t]
	    if (((a[0] - b[0]) || (a[1] - b[1])) < 0) {
	      var tmp = s
	      s = t
	      t = tmp
	    }
	
	    // Split leading edge
	    edge[0] = s
	    var last = edge[1] = junction[1]
	
	    // If we are grouping edges by color, remember to track data
	    var color
	    if (useColor) {
	      color = edge[2]
	    }
	
	    // Split other edges
	    while (i > 0 && junctions[i - 1][0] === e) {
	      var junction = junctions[--i]
	      var next = junction[1]
	      if (useColor) {
	        edges.push([last, next, color])
	      } else {
	        edges.push([last, next])
	      }
	      last = next
	    }
	
	    // Add final edge
	    if (useColor) {
	      edges.push([last, t, color])
	    } else {
	      edges.push([last, t])
	    }
	  }
	
	  // Return constructed rational points
	  return ratPoints
	}
	
	// Merge overlapping points
	function dedupPoints (floatPoints, ratPoints, floatBounds) {
	  var numPoints = ratPoints.length
	  var uf = new UnionFind(numPoints)
	
	  // Compute rational bounds
	  var bounds = []
	  for (var i = 0; i < ratPoints.length; ++i) {
	    var p = ratPoints[i]
	    var xb = boundRat(p[0])
	    var yb = boundRat(p[1])
	    bounds.push([
	      nextafter(xb[0], -Infinity),
	      nextafter(yb[0], -Infinity),
	      nextafter(xb[1], Infinity),
	      nextafter(yb[1], Infinity)
	    ])
	  }
	
	  // Link all points with over lapping boxes
	  boxIntersect(bounds, function (i, j) {
	    uf.link(i, j)
	  })
	
	  // Do 1 pass over points to combine points in label sets
	  var noDupes = true
	  var labels = new Array(numPoints)
	  for (var i = 0; i < numPoints; ++i) {
	    var j = uf.find(i)
	    if (j !== i) {
	      // Clear no-dupes flag, zero out label
	      noDupes = false
	      // Make each point the top-left point from its cell
	      floatPoints[j] = [
	        Math.min(floatPoints[i][0], floatPoints[j][0]),
	        Math.min(floatPoints[i][1], floatPoints[j][1])
	      ]
	    }
	  }
	
	  // If no duplicates, return null to signal termination
	  if (noDupes) {
	    return null
	  }
	
	  var ptr = 0
	  for (var i = 0; i < numPoints; ++i) {
	    var j = uf.find(i)
	    if (j === i) {
	      labels[i] = ptr
	      floatPoints[ptr++] = floatPoints[i]
	    } else {
	      labels[i] = -1
	    }
	  }
	
	  floatPoints.length = ptr
	
	  // Do a second pass to fix up missing labels
	  for (var i = 0; i < numPoints; ++i) {
	    if (labels[i] < 0) {
	      labels[i] = labels[uf.find(i)]
	    }
	  }
	
	  // Return resulting union-find data structure
	  return labels
	}
	
	function compareLex2 (a, b) { return (a[0] - b[0]) || (a[1] - b[1]) }
	function compareLex3 (a, b) {
	  var d = (a[0] - b[0]) || (a[1] - b[1])
	  if (d) {
	    return d
	  }
	  if (a[2] < b[2]) {
	    return -1
	  } else if (a[2] > b[2]) {
	    return 1
	  }
	  return 0
	}
	
	// Remove duplicate edge labels
	function dedupEdges (edges, labels, useColor) {
	  if (edges.length === 0) {
	    return
	  }
	  if (labels) {
	    for (var i = 0; i < edges.length; ++i) {
	      var e = edges[i]
	      var a = labels[e[0]]
	      var b = labels[e[1]]
	      e[0] = Math.min(a, b)
	      e[1] = Math.max(a, b)
	    }
	  } else {
	    for (var i = 0; i < edges.length; ++i) {
	      var e = edges[i]
	      var a = e[0]
	      var b = e[1]
	      e[0] = Math.min(a, b)
	      e[1] = Math.max(a, b)
	    }
	  }
	  if (useColor) {
	    edges.sort(compareLex3)
	  } else {
	    edges.sort(compareLex2)
	  }
	  var ptr = 1
	  for (var i = 1; i < edges.length; ++i) {
	    var prev = edges[i - 1]
	    var next = edges[i]
	    if (next[0] === prev[0] && next[1] === prev[1] &&
	      (!useColor || next[2] === prev[2])) {
	      continue
	    }
	    edges[ptr++] = next
	  }
	  edges.length = ptr
	}
	
	function preRound (points, edges, useColor) {
	  var labels = dedupPoints(points, [], boundPoints(points))
	  dedupEdges(edges, labels, useColor)
	  return !!labels
	}
	
	// Repeat until convergence
	function snapRound (points, edges, useColor) {
	  // 1. find edge crossings
	  var edgeBounds = boundEdges(points, edges)
	  var crossings = getCrossings(points, edges, edgeBounds)
	
	  // 2. find t-junctions
	  var vertBounds = boundPoints(points)
	  var tjunctions = getTJunctions(points, edges, edgeBounds, vertBounds)
	
	  // 3. cut edges, construct rational points
	  var ratPoints = cutEdges(points, edges, crossings, tjunctions, useColor)
	
	  // 4. dedupe verts
	  var labels = dedupPoints(points, ratPoints, vertBounds)
	
	  // 5. dedupe edges
	  dedupEdges(edges, labels, useColor)
	
	  // 6. check termination
	  if (!labels) {
	    return (crossings.length > 0 || tjunctions.length > 0)
	  }
	
	  // More iterations necessary
	  return true
	}
	
	// Main loop, runs PSLG clean up until completion
	function cleanPSLG (points, edges, colors) {
	  // If using colors, augment edges with color data
	  var prevEdges
	  if (colors) {
	    prevEdges = edges
	    var augEdges = new Array(edges.length)
	    for (var i = 0; i < edges.length; ++i) {
	      var e = edges[i]
	      augEdges[i] = [e[0], e[1], colors[i]]
	    }
	    edges = augEdges
	  }
	
	  // First round: remove duplicate edges and points
	  var modified = preRound(points, edges, !!colors)
	
	  // Run snap rounding until convergence
	  while (snapRound(points, edges, !!colors)) {
	    modified = true
	  }
	
	  // Strip color tags
	  if (!!colors && modified) {
	    prevEdges.length = 0
	    colors.length = 0
	    for (var i = 0; i < edges.length; ++i) {
	      var e = edges[i]
	      prevEdges.push([e[0], e[1]])
	      colors.push(e[2])
	    }
	  }
	
	  return modified
	}
	
	},{"./lib/rat-seg-intersect":118,"big-rat":79,"big-rat/cmp":77,"big-rat/to-float":91,"box-intersect":97,"nextafter":452,"rat-vec":487,"robust-segment-intersect":511,"union-find":544}],118:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = solveIntersection
	
	var ratMul = _dereq_('big-rat/mul')
	var ratDiv = _dereq_('big-rat/div')
	var ratSub = _dereq_('big-rat/sub')
	var ratSign = _dereq_('big-rat/sign')
	var rvSub = _dereq_('rat-vec/sub')
	var rvAdd = _dereq_('rat-vec/add')
	var rvMuls = _dereq_('rat-vec/muls')
	
	function ratPerp (a, b) {
	  return ratSub(ratMul(a[0], b[1]), ratMul(a[1], b[0]))
	}
	
	// Solve for intersection
	//  x = a + t (b-a)
	//  (x - c) ^ (d-c) = 0
	//  (t * (b-a) + (a-c) ) ^ (d-c) = 0
	//  t * (b-a)^(d-c) = (d-c)^(a-c)
	//  t = (d-c)^(a-c) / (b-a)^(d-c)
	
	function solveIntersection (a, b, c, d) {
	  var ba = rvSub(b, a)
	  var dc = rvSub(d, c)
	
	  var baXdc = ratPerp(ba, dc)
	
	  if (ratSign(baXdc) === 0) {
	    return null
	  }
	
	  var ac = rvSub(a, c)
	  var dcXac = ratPerp(dc, ac)
	
	  var t = ratDiv(dcXac, baXdc)
	  var s = rvMuls(ba, t)
	  var r = rvAdd(a, s)
	
	  return r
	}
	
	},{"big-rat/div":78,"big-rat/mul":88,"big-rat/sign":89,"big-rat/sub":90,"rat-vec/add":486,"rat-vec/muls":488,"rat-vec/sub":489}],119:[function(_dereq_,module,exports){
	/** @module  color-id */
	
	'use strict'
	
	var clamp = _dereq_('clamp')
	
	module.exports = toNumber
	module.exports.to = toNumber
	module.exports.from = fromNumber
	
	function toNumber (rgba, normalized) {
		if(normalized == null) normalized = true
	
		var r = rgba[0], g = rgba[1], b = rgba[2], a = rgba[3]
	
		if (a == null) a = normalized ? 1 : 255
	
		if (normalized) {
			r *= 255
			g *= 255
			b *= 255
			a *= 255
		}
	
		r = clamp(r, 0, 255) & 0xFF
		g = clamp(g, 0, 255) & 0xFF
		b = clamp(b, 0, 255) & 0xFF
		a = clamp(a, 0, 255) & 0xFF
	
		//hi-order shift converts to -1, so we can't use <<24
		var n = (r * 0x01000000) + (g << 16) + (b << 8) + (a)
	
		return n
	}
	
	function fromNumber (n, normalized) {
		n = +n
	
		var r = n >>> 24
		var g = (n & 0x00ff0000) >>> 16
		var b = (n & 0x0000ff00) >>> 8
		var a = n & 0x000000ff
	
		if (normalized === false) return [r, g, b, a]
	
		return [r/255, g/255, b/255, a/255]
	}
	
	},{"clamp":116}],120:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	},{}],121:[function(_dereq_,module,exports){
	/** @module  color-normalize */
	
	'use strict'
	
	var rgba = _dereq_('color-rgba')
	var clamp = _dereq_('clamp')
	var dtype = _dereq_('dtype')
	
	module.exports = function normalize (color, type) {
		if (type === 'float' || !type) type = 'array'
		if (type === 'uint') type = 'uint8'
		if (type === 'uint_clamped') type = 'uint8_clamped'
		var Ctor = dtype(type)
		var output = new Ctor(4)
	
		var normalize = type !== 'uint8' && type !== 'uint8_clamped'
	
		// attempt to parse non-array arguments
		if (!color.length || typeof color === 'string') {
			color = rgba(color)
			color[0] /= 255
			color[1] /= 255
			color[2] /= 255
		}
	
		// 0, 1 are possible contradictory values for Arrays:
		// [1,1,1] input gives [1,1,1] output instead of [1/255,1/255,1/255], which may be collision if input is meant to be uint.
		// converting [1,1,1] to [1/255,1/255,1/255] in case of float input gives larger mistake since [1,1,1] float is frequent edge value, whereas [0,1,1], [1,1,1] etc. uint inputs are relatively rare
		if (isInt(color)) {
			output[0] = color[0]
			output[1] = color[1]
			output[2] = color[2]
			output[3] = color[3] != null ? color[3] : 255
	
			if (normalize) {
				output[0] /= 255
				output[1] /= 255
				output[2] /= 255
				output[3] /= 255
			}
	
			return output
		}
	
		if (!normalize) {
			output[0] = clamp(Math.floor(color[0] * 255), 0, 255)
			output[1] = clamp(Math.floor(color[1] * 255), 0, 255)
			output[2] = clamp(Math.floor(color[2] * 255), 0, 255)
			output[3] = color[3] == null ? 255 : clamp(Math.floor(color[3] * 255), 0, 255)
		} else {
			output[0] = color[0]
			output[1] = color[1]
			output[2] = color[2]
			output[3] = color[3] != null ? color[3] : 1
		}
	
		return output
	}
	
	function isInt(color) {
		if (color instanceof Uint8Array || color instanceof Uint8ClampedArray) return true
	
		if (Array.isArray(color) &&
			(color[0] > 1 || color[0] === 0) &&
			(color[1] > 1 || color[1] === 0) &&
			(color[2] > 1 || color[2] === 0) &&
			(!color[3] || color[3] > 1)
		) return true
	
		return false
	}
	
	},{"clamp":116,"color-rgba":123,"dtype":170}],122:[function(_dereq_,module,exports){
	(function (global){
	/**
	 * @module color-parse
	 */
	
	'use strict'
	
	var names = _dereq_('color-name')
	var isObject = _dereq_('is-plain-obj')
	var defined = _dereq_('defined')
	
	module.exports = parse
	
	/**
	 * Base hues
	 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
	 */
	//FIXME: use external hue detector
	var baseHues = {
		red: 0,
		orange: 60,
		yellow: 120,
		green: 180,
		blue: 240,
		purple: 300
	}
	
	/**
	 * Parse color from the string passed
	 *
	 * @return {Object} A space indicator `space`, an array `values` and `alpha`
	 */
	function parse (cstr) {
		var m, parts = [], alpha = 1, space
	
		if (typeof cstr === 'string') {
			//keyword
			if (names[cstr]) {
				parts = names[cstr].slice()
				space = 'rgb'
			}
	
			//reserved words
			else if (cstr === 'transparent') {
				alpha = 0
				space = 'rgb'
				parts = [0,0,0]
			}
	
			//hex
			else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
				var base = cstr.slice(1)
				var size = base.length
				var isShort = size <= 4
				alpha = 1
	
				if (isShort) {
					parts = [
						parseInt(base[0] + base[0], 16),
						parseInt(base[1] + base[1], 16),
						parseInt(base[2] + base[2], 16)
					]
					if (size === 4) {
						alpha = parseInt(base[3] + base[3], 16) / 255
					}
				}
				else {
					parts = [
						parseInt(base[0] + base[1], 16),
						parseInt(base[2] + base[3], 16),
						parseInt(base[4] + base[5], 16)
					]
					if (size === 8) {
						alpha = parseInt(base[6] + base[7], 16) / 255
					}
				}
	
				if (!parts[0]) parts[0] = 0
				if (!parts[1]) parts[1] = 0
				if (!parts[2]) parts[2] = 0
	
				space = 'rgb'
			}
	
			//color space
			else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
				var name = m[1]
				var isRGB = name === 'rgb'
				var base = name.replace(/a$/, '')
				space = base
				var size = base === 'cmyk' ? 4 : base === 'gray' ? 1 : 3
				parts = m[2].trim()
					.split(/\s*,\s*/)
					.map(function (x, i) {
						//<percentage>
						if (/%$/.test(x)) {
							//alpha
							if (i === size)	return parseFloat(x) / 100
							//rgb
							if (base === 'rgb') return parseFloat(x) * 255 / 100
							return parseFloat(x)
						}
						//hue
						else if (base[i] === 'h') {
							//<deg>
							if (/deg$/.test(x)) {
								return parseFloat(x)
							}
							//<base-hue>
							else if (baseHues[x] !== undefined) {
								return baseHues[x]
							}
						}
						return parseFloat(x)
					})
	
				if (name === base) parts.push(1)
				alpha = (isRGB) ? 1 : (parts[size] === undefined) ? 1 : parts[size]
				parts = parts.slice(0, size)
			}
	
			//named channels case
			else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
				parts = cstr.match(/([0-9]+)/g).map(function (value) {
					return parseFloat(value)
				})
	
				space = cstr.match(/([a-z])/ig).join('').toLowerCase()
			}
		}
	
		//numeric case
		else if (!isNaN(cstr)) {
			space = 'rgb'
			parts = [cstr >>> 16, (cstr & 0x00ff00) >>> 8, cstr & 0x0000ff]
		}
	
		//object case - detects css cases of rgb and hsl
		else if (isObject(cstr)) {
			var r = defined(cstr.r, cstr.red, cstr.R, null)
	
			if (r !== null) {
				space = 'rgb'
				parts = [
					r,
					defined(cstr.g, cstr.green, cstr.G),
					defined(cstr.b, cstr.blue, cstr.B)
				]
			}
			else {
				space = 'hsl'
				parts = [
					defined(cstr.h, cstr.hue, cstr.H),
					defined(cstr.s, cstr.saturation, cstr.S),
					defined(cstr.l, cstr.lightness, cstr.L, cstr.b, cstr.brightness)
				]
			}
	
			alpha = defined(cstr.a, cstr.alpha, cstr.opacity, 1)
	
			if (cstr.opacity != null) alpha /= 100
		}
	
		//array
		else if (Array.isArray(cstr) || global.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(cstr)) {
			parts = [cstr[0], cstr[1], cstr[2]]
			space = 'rgb'
			alpha = cstr.length === 4 ? cstr[3] : 1
		}
	
		return {
			space: space,
			values: parts,
			alpha: alpha
		}
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"color-name":120,"defined":165,"is-plain-obj":423}],123:[function(_dereq_,module,exports){
	/** @module  color-rgba */
	
	'use strict'
	
	var parse = _dereq_('color-parse')
	var hsl = _dereq_('color-space/hsl')
	var clamp = _dereq_('clamp')
	
	module.exports = function rgba (color) {
		var values, i, l
	
		//attempt to parse non-array arguments
		var parsed = parse(color)
	
		if (!parsed.space) return []
	
		values = Array(3)
		values[0] = clamp(parsed.values[0], 0, 255)
		values[1] = clamp(parsed.values[1], 0, 255)
		values[2] = clamp(parsed.values[2], 0, 255)
	
		if (parsed.space[0] === 'h') {
			values = hsl.rgb(values)
		}
	
		values.push(clamp(parsed.alpha, 0, 1))
	
		return values
	}
	
	},{"clamp":116,"color-parse":122,"color-space/hsl":124}],124:[function(_dereq_,module,exports){
	/**
	 * @module color-space/hsl
	 */
	'use strict'
	
	var rgb = _dereq_('./rgb');
	
	module.exports = {
		name: 'hsl',
		min: [0,0,0],
		max: [360,100,100],
		channel: ['hue', 'saturation', 'lightness'],
		alias: ['HSL'],
	
		rgb: function(hsl) {
			var h = hsl[0] / 360,
					s = hsl[1] / 100,
					l = hsl[2] / 100,
					t1, t2, t3, rgb, val;
	
			if (s === 0) {
				val = l * 255;
				return [val, val, val];
			}
	
			if (l < 0.5) {
				t2 = l * (1 + s);
			}
			else {
				t2 = l + s - l * s;
			}
			t1 = 2 * l - t2;
	
			rgb = [0, 0, 0];
			for (var i = 0; i < 3; i++) {
				t3 = h + 1 / 3 * - (i - 1);
				if (t3 < 0) {
					t3++;
				}
				else if (t3 > 1) {
					t3--;
				}
	
				if (6 * t3 < 1) {
					val = t1 + (t2 - t1) * 6 * t3;
				}
				else if (2 * t3 < 1) {
					val = t2;
				}
				else if (3 * t3 < 2) {
					val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
				}
				else {
					val = t1;
				}
	
				rgb[i] = val * 255;
			}
	
			return rgb;
		}
	};
	
	
	//extend rgb
	rgb.hsl = function(rgb) {
		var r = rgb[0]/255,
				g = rgb[1]/255,
				b = rgb[2]/255,
				min = Math.min(r, g, b),
				max = Math.max(r, g, b),
				delta = max - min,
				h, s, l;
	
		if (max === min) {
			h = 0;
		}
		else if (r === max) {
			h = (g - b) / delta;
		}
		else if (g === max) {
			h = 2 + (b - r) / delta;
		}
		else if (b === max) {
			h = 4 + (r - g)/ delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		}
		else if (l <= 0.5) {
			s = delta / (max + min);
		}
		else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	},{"./rgb":125}],125:[function(_dereq_,module,exports){
	/**
	 * RGB space.
	 *
	 * @module  color-space/rgb
	 */
	'use strict'
	
	module.exports = {
		name: 'rgb',
		min: [0,0,0],
		max: [255,255,255],
		channel: ['red', 'green', 'blue'],
		alias: ['RGB']
	};
	
	},{}],126:[function(_dereq_,module,exports){
	module.exports={
		"jet":[{"index":0,"rgb":[0,0,131]},{"index":0.125,"rgb":[0,60,170]},{"index":0.375,"rgb":[5,255,255]},{"index":0.625,"rgb":[255,255,0]},{"index":0.875,"rgb":[250,0,0]},{"index":1,"rgb":[128,0,0]}],
	
		"hsv":[{"index":0,"rgb":[255,0,0]},{"index":0.169,"rgb":[253,255,2]},{"index":0.173,"rgb":[247,255,2]},{"index":0.337,"rgb":[0,252,4]},{"index":0.341,"rgb":[0,252,10]},{"index":0.506,"rgb":[1,249,255]},{"index":0.671,"rgb":[2,0,253]},{"index":0.675,"rgb":[8,0,253]},{"index":0.839,"rgb":[255,0,251]},{"index":0.843,"rgb":[255,0,245]},{"index":1,"rgb":[255,0,6]}],
	
		"hot":[{"index":0,"rgb":[0,0,0]},{"index":0.3,"rgb":[230,0,0]},{"index":0.6,"rgb":[255,210,0]},{"index":1,"rgb":[255,255,255]}],
	
		"cool":[{"index":0,"rgb":[0,255,255]},{"index":1,"rgb":[255,0,255]}],
	
		"spring":[{"index":0,"rgb":[255,0,255]},{"index":1,"rgb":[255,255,0]}],
	
		"summer":[{"index":0,"rgb":[0,128,102]},{"index":1,"rgb":[255,255,102]}],
	
		"autumn":[{"index":0,"rgb":[255,0,0]},{"index":1,"rgb":[255,255,0]}],
	
		"winter":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[0,255,128]}],
	
		"bone":[{"index":0,"rgb":[0,0,0]},{"index":0.376,"rgb":[84,84,116]},{"index":0.753,"rgb":[169,200,200]},{"index":1,"rgb":[255,255,255]}],
	
		"copper":[{"index":0,"rgb":[0,0,0]},{"index":0.804,"rgb":[255,160,102]},{"index":1,"rgb":[255,199,127]}],
	
		"greys":[{"index":0,"rgb":[0,0,0]},{"index":1,"rgb":[255,255,255]}],
	
		"yignbu":[{"index":0,"rgb":[8,29,88]},{"index":0.125,"rgb":[37,52,148]},{"index":0.25,"rgb":[34,94,168]},{"index":0.375,"rgb":[29,145,192]},{"index":0.5,"rgb":[65,182,196]},{"index":0.625,"rgb":[127,205,187]},{"index":0.75,"rgb":[199,233,180]},{"index":0.875,"rgb":[237,248,217]},{"index":1,"rgb":[255,255,217]}],
	
		"greens":[{"index":0,"rgb":[0,68,27]},{"index":0.125,"rgb":[0,109,44]},{"index":0.25,"rgb":[35,139,69]},{"index":0.375,"rgb":[65,171,93]},{"index":0.5,"rgb":[116,196,118]},{"index":0.625,"rgb":[161,217,155]},{"index":0.75,"rgb":[199,233,192]},{"index":0.875,"rgb":[229,245,224]},{"index":1,"rgb":[247,252,245]}],
	
		"yiorrd":[{"index":0,"rgb":[128,0,38]},{"index":0.125,"rgb":[189,0,38]},{"index":0.25,"rgb":[227,26,28]},{"index":0.375,"rgb":[252,78,42]},{"index":0.5,"rgb":[253,141,60]},{"index":0.625,"rgb":[254,178,76]},{"index":0.75,"rgb":[254,217,118]},{"index":0.875,"rgb":[255,237,160]},{"index":1,"rgb":[255,255,204]}],
	
		"bluered":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[255,0,0]}],
	
		"rdbu":[{"index":0,"rgb":[5,10,172]},{"index":0.35,"rgb":[106,137,247]},{"index":0.5,"rgb":[190,190,190]},{"index":0.6,"rgb":[220,170,132]},{"index":0.7,"rgb":[230,145,90]},{"index":1,"rgb":[178,10,28]}],
	
		"picnic":[{"index":0,"rgb":[0,0,255]},{"index":0.1,"rgb":[51,153,255]},{"index":0.2,"rgb":[102,204,255]},{"index":0.3,"rgb":[153,204,255]},{"index":0.4,"rgb":[204,204,255]},{"index":0.5,"rgb":[255,255,255]},{"index":0.6,"rgb":[255,204,255]},{"index":0.7,"rgb":[255,153,255]},{"index":0.8,"rgb":[255,102,204]},{"index":0.9,"rgb":[255,102,102]},{"index":1,"rgb":[255,0,0]}],
	
		"rainbow":[{"index":0,"rgb":[150,0,90]},{"index":0.125,"rgb":[0,0,200]},{"index":0.25,"rgb":[0,25,255]},{"index":0.375,"rgb":[0,152,255]},{"index":0.5,"rgb":[44,255,150]},{"index":0.625,"rgb":[151,255,0]},{"index":0.75,"rgb":[255,234,0]},{"index":0.875,"rgb":[255,111,0]},{"index":1,"rgb":[255,0,0]}],
	
		"portland":[{"index":0,"rgb":[12,51,131]},{"index":0.25,"rgb":[10,136,186]},{"index":0.5,"rgb":[242,211,56]},{"index":0.75,"rgb":[242,143,56]},{"index":1,"rgb":[217,30,30]}],
	
		"blackbody":[{"index":0,"rgb":[0,0,0]},{"index":0.2,"rgb":[230,0,0]},{"index":0.4,"rgb":[230,210,0]},{"index":0.7,"rgb":[255,255,255]},{"index":1,"rgb":[160,200,255]}],
	
		"earth":[{"index":0,"rgb":[0,0,130]},{"index":0.1,"rgb":[0,180,180]},{"index":0.2,"rgb":[40,210,40]},{"index":0.4,"rgb":[230,230,50]},{"index":0.6,"rgb":[120,70,20]},{"index":1,"rgb":[255,255,255]}],
	
		"electric":[{"index":0,"rgb":[0,0,0]},{"index":0.15,"rgb":[30,0,100]},{"index":0.4,"rgb":[120,0,100]},{"index":0.6,"rgb":[160,90,0]},{"index":0.8,"rgb":[230,200,0]},{"index":1,"rgb":[255,250,220]}],
	
		"alpha": [{"index":0, "rgb": [255,255,255,0]},{"index":1, "rgb": [255,255,255,1]}],
	
		"viridis": [{"index":0,"rgb":[68,1,84]},{"index":0.13,"rgb":[71,44,122]},{"index":0.25,"rgb":[59,81,139]},{"index":0.38,"rgb":[44,113,142]},{"index":0.5,"rgb":[33,144,141]},{"index":0.63,"rgb":[39,173,129]},{"index":0.75,"rgb":[92,200,99]},{"index":0.88,"rgb":[170,220,50]},{"index":1,"rgb":[253,231,37]}],
	
		"inferno": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[31,12,72]},{"index":0.25,"rgb":[85,15,109]},{"index":0.38,"rgb":[136,34,106]},{"index":0.5,"rgb":[186,54,85]},{"index":0.63,"rgb":[227,89,51]},{"index":0.75,"rgb":[249,140,10]},{"index":0.88,"rgb":[249,201,50]},{"index":1,"rgb":[252,255,164]}],
	
		"magma": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[28,16,68]},{"index":0.25,"rgb":[79,18,123]},{"index":0.38,"rgb":[129,37,129]},{"index":0.5,"rgb":[181,54,122]},{"index":0.63,"rgb":[229,80,100]},{"index":0.75,"rgb":[251,135,97]},{"index":0.88,"rgb":[254,194,135]},{"index":1,"rgb":[252,253,191]}],
	
		"plasma": [{"index":0,"rgb":[13,8,135]},{"index":0.13,"rgb":[75,3,161]},{"index":0.25,"rgb":[125,3,168]},{"index":0.38,"rgb":[168,34,150]},{"index":0.5,"rgb":[203,70,121]},{"index":0.63,"rgb":[229,107,93]},{"index":0.75,"rgb":[248,148,65]},{"index":0.88,"rgb":[253,195,40]},{"index":1,"rgb":[240,249,33]}],
	
		"warm": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[172,0,187]},{"index":0.25,"rgb":[219,0,170]},{"index":0.38,"rgb":[255,0,130]},{"index":0.5,"rgb":[255,63,74]},{"index":0.63,"rgb":[255,123,0]},{"index":0.75,"rgb":[234,176,0]},{"index":0.88,"rgb":[190,228,0]},{"index":1,"rgb":[147,255,0]}],
	
		"cool": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[116,0,218]},{"index":0.25,"rgb":[98,74,237]},{"index":0.38,"rgb":[68,146,231]},{"index":0.5,"rgb":[0,204,197]},{"index":0.63,"rgb":[0,247,146]},{"index":0.75,"rgb":[0,255,88]},{"index":0.88,"rgb":[40,255,8]},{"index":1,"rgb":[147,255,0]}],
	
		"rainbow-soft": [{"index":0,"rgb":[125,0,179]},{"index":0.1,"rgb":[199,0,180]},{"index":0.2,"rgb":[255,0,121]},{"index":0.3,"rgb":[255,108,0]},{"index":0.4,"rgb":[222,194,0]},{"index":0.5,"rgb":[150,255,0]},{"index":0.6,"rgb":[0,255,55]},{"index":0.7,"rgb":[0,246,150]},{"index":0.8,"rgb":[50,167,222]},{"index":0.9,"rgb":[103,51,235]},{"index":1,"rgb":[124,0,186]}],
	
		"bathymetry": [{"index":0,"rgb":[40,26,44]},{"index":0.13,"rgb":[59,49,90]},{"index":0.25,"rgb":[64,76,139]},{"index":0.38,"rgb":[63,110,151]},{"index":0.5,"rgb":[72,142,158]},{"index":0.63,"rgb":[85,174,163]},{"index":0.75,"rgb":[120,206,163]},{"index":0.88,"rgb":[187,230,172]},{"index":1,"rgb":[253,254,204]}],
	
		"cdom": [{"index":0,"rgb":[47,15,62]},{"index":0.13,"rgb":[87,23,86]},{"index":0.25,"rgb":[130,28,99]},{"index":0.38,"rgb":[171,41,96]},{"index":0.5,"rgb":[206,67,86]},{"index":0.63,"rgb":[230,106,84]},{"index":0.75,"rgb":[242,149,103]},{"index":0.88,"rgb":[249,193,135]},{"index":1,"rgb":[254,237,176]}],
	
		"chlorophyll": [{"index":0,"rgb":[18,36,20]},{"index":0.13,"rgb":[25,63,41]},{"index":0.25,"rgb":[24,91,59]},{"index":0.38,"rgb":[13,119,72]},{"index":0.5,"rgb":[18,148,80]},{"index":0.63,"rgb":[80,173,89]},{"index":0.75,"rgb":[132,196,122]},{"index":0.88,"rgb":[175,221,162]},{"index":1,"rgb":[215,249,208]}],
	
		"density": [{"index":0,"rgb":[54,14,36]},{"index":0.13,"rgb":[89,23,80]},{"index":0.25,"rgb":[110,45,132]},{"index":0.38,"rgb":[120,77,178]},{"index":0.5,"rgb":[120,113,213]},{"index":0.63,"rgb":[115,151,228]},{"index":0.75,"rgb":[134,185,227]},{"index":0.88,"rgb":[177,214,227]},{"index":1,"rgb":[230,241,241]}],
	
		"freesurface-blue": [{"index":0,"rgb":[30,4,110]},{"index":0.13,"rgb":[47,14,176]},{"index":0.25,"rgb":[41,45,236]},{"index":0.38,"rgb":[25,99,212]},{"index":0.5,"rgb":[68,131,200]},{"index":0.63,"rgb":[114,156,197]},{"index":0.75,"rgb":[157,181,203]},{"index":0.88,"rgb":[200,208,216]},{"index":1,"rgb":[241,237,236]}],
	
		"freesurface-red": [{"index":0,"rgb":[60,9,18]},{"index":0.13,"rgb":[100,17,27]},{"index":0.25,"rgb":[142,20,29]},{"index":0.38,"rgb":[177,43,27]},{"index":0.5,"rgb":[192,87,63]},{"index":0.63,"rgb":[205,125,105]},{"index":0.75,"rgb":[216,162,148]},{"index":0.88,"rgb":[227,199,193]},{"index":1,"rgb":[241,237,236]}],
	
		"oxygen": [{"index":0,"rgb":[64,5,5]},{"index":0.13,"rgb":[106,6,15]},{"index":0.25,"rgb":[144,26,7]},{"index":0.38,"rgb":[168,64,3]},{"index":0.5,"rgb":[188,100,4]},{"index":0.63,"rgb":[206,136,11]},{"index":0.75,"rgb":[220,174,25]},{"index":0.88,"rgb":[231,215,44]},{"index":1,"rgb":[248,254,105]}],
	
		"par": [{"index":0,"rgb":[51,20,24]},{"index":0.13,"rgb":[90,32,35]},{"index":0.25,"rgb":[129,44,34]},{"index":0.38,"rgb":[159,68,25]},{"index":0.5,"rgb":[182,99,19]},{"index":0.63,"rgb":[199,134,22]},{"index":0.75,"rgb":[212,171,35]},{"index":0.88,"rgb":[221,210,54]},{"index":1,"rgb":[225,253,75]}],
	
		"phase": [{"index":0,"rgb":[145,105,18]},{"index":0.13,"rgb":[184,71,38]},{"index":0.25,"rgb":[186,58,115]},{"index":0.38,"rgb":[160,71,185]},{"index":0.5,"rgb":[110,97,218]},{"index":0.63,"rgb":[50,123,164]},{"index":0.75,"rgb":[31,131,110]},{"index":0.88,"rgb":[77,129,34]},{"index":1,"rgb":[145,105,18]}],
	
		"salinity": [{"index":0,"rgb":[42,24,108]},{"index":0.13,"rgb":[33,50,162]},{"index":0.25,"rgb":[15,90,145]},{"index":0.38,"rgb":[40,118,137]},{"index":0.5,"rgb":[59,146,135]},{"index":0.63,"rgb":[79,175,126]},{"index":0.75,"rgb":[120,203,104]},{"index":0.88,"rgb":[193,221,100]},{"index":1,"rgb":[253,239,154]}],
	
		"temperature": [{"index":0,"rgb":[4,35,51]},{"index":0.13,"rgb":[23,51,122]},{"index":0.25,"rgb":[85,59,157]},{"index":0.38,"rgb":[129,79,143]},{"index":0.5,"rgb":[175,95,130]},{"index":0.63,"rgb":[222,112,101]},{"index":0.75,"rgb":[249,146,66]},{"index":0.88,"rgb":[249,196,65]},{"index":1,"rgb":[232,250,91]}],
	
		"turbidity": [{"index":0,"rgb":[34,31,27]},{"index":0.13,"rgb":[65,50,41]},{"index":0.25,"rgb":[98,69,52]},{"index":0.38,"rgb":[131,89,57]},{"index":0.5,"rgb":[161,112,59]},{"index":0.63,"rgb":[185,140,66]},{"index":0.75,"rgb":[202,174,88]},{"index":0.88,"rgb":[216,209,126]},{"index":1,"rgb":[233,246,171]}],
	
		"velocity-blue": [{"index":0,"rgb":[17,32,64]},{"index":0.13,"rgb":[35,52,116]},{"index":0.25,"rgb":[29,81,156]},{"index":0.38,"rgb":[31,113,162]},{"index":0.5,"rgb":[50,144,169]},{"index":0.63,"rgb":[87,173,176]},{"index":0.75,"rgb":[149,196,189]},{"index":0.88,"rgb":[203,221,211]},{"index":1,"rgb":[254,251,230]}],
	
		"velocity-green": [{"index":0,"rgb":[23,35,19]},{"index":0.13,"rgb":[24,64,38]},{"index":0.25,"rgb":[11,95,45]},{"index":0.38,"rgb":[39,123,35]},{"index":0.5,"rgb":[95,146,12]},{"index":0.63,"rgb":[152,165,18]},{"index":0.75,"rgb":[201,186,69]},{"index":0.88,"rgb":[233,216,137]},{"index":1,"rgb":[255,253,205]}],
	
		"cubehelix": [{"index":0,"rgb":[0,0,0]},{"index":0.07,"rgb":[22,5,59]},{"index":0.13,"rgb":[60,4,105]},{"index":0.2,"rgb":[109,1,135]},{"index":0.27,"rgb":[161,0,147]},{"index":0.33,"rgb":[210,2,142]},{"index":0.4,"rgb":[251,11,123]},{"index":0.47,"rgb":[255,29,97]},{"index":0.53,"rgb":[255,54,69]},{"index":0.6,"rgb":[255,85,46]},{"index":0.67,"rgb":[255,120,34]},{"index":0.73,"rgb":[255,157,37]},{"index":0.8,"rgb":[241,191,57]},{"index":0.87,"rgb":[224,220,93]},{"index":0.93,"rgb":[218,241,142]},{"index":1,"rgb":[227,253,198]}]
	};
	
	},{}],127:[function(_dereq_,module,exports){
	/*
	 * Ben Postlethwaite
	 * January 2013
	 * License MIT
	 */
	'use strict';
	
	var colorScale = _dereq_('./colorScale');
	var lerp = _dereq_('lerp')
	
	module.exports = createColormap;
	
	function createColormap (spec) {
	    /*
	     * Default Options
	     */
	    var indicies, fromrgba, torgba,
	        nsteps, cmap, colormap, format,
	        nshades, colors, alpha, i;
	
	    if ( !spec ) spec = {};
	
	    nshades = (spec.nshades || 72) - 1;
	    format = spec.format || 'hex';
	
	    colormap = spec.colormap;
	    if (!colormap) colormap = 'jet';
	
	    if (typeof colormap === 'string') {
	        colormap = colormap.toLowerCase();
	
	        if (!colorScale[colormap]) {
	            throw Error(colormap + ' not a supported colorscale');
	        }
	
	        cmap = colorScale[colormap];
	
	    } else if (Array.isArray(colormap)) {
	        cmap = colormap.slice();
	
	    } else {
	        throw Error('unsupported colormap option', colormap);
	    }
	
	    if (cmap.length > nshades + 1) {
	        throw new Error(
	            colormap+' map requires nshades to be at least size '+cmap.length
	        );
	    }
	
	    if (!Array.isArray(spec.alpha)) {
	
	        if (typeof spec.alpha === 'number') {
	            alpha = [spec.alpha, spec.alpha];
	
	        } else {
	            alpha = [1, 1];
	        }
	
	    } else if (spec.alpha.length !== 2) {
	        alpha = [1, 1];
	
	    } else {
	        alpha = spec.alpha.slice();
	    }
	
	    // map index points from 0..1 to 0..n-1
	    indicies = cmap.map(function(c) {
	        return Math.round(c.index * nshades);
	    });
	
	    // Add alpha channel to the map
	    alpha[0] = Math.min(Math.max(alpha[0], 0), 1);
	    alpha[1] = Math.min(Math.max(alpha[1], 0), 1);
	
	    var steps = cmap.map(function(c, i) {
	        var index = cmap[i].index
	
	        var rgba = cmap[i].rgb.slice();
	
	        // if user supplies their own map use it
	        if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) {
	            return rgba
	        }
	        rgba[3] = alpha[0] + (alpha[1] - alpha[0])*index;
	
	        return rgba
	    })
	
	
	    /*
	     * map increasing linear values between indicies to
	     * linear steps in colorvalues
	     */
	    var colors = []
	    for (i = 0; i < indicies.length-1; ++i) {
	        nsteps = indicies[i+1] - indicies[i];
	        fromrgba = steps[i];
	        torgba = steps[i+1];
	
	        for (var j = 0; j < nsteps; j++) {
	            var amt = j / nsteps
	            colors.push([
	                Math.round(lerp(fromrgba[0], torgba[0], amt)),
	                Math.round(lerp(fromrgba[1], torgba[1], amt)),
	                Math.round(lerp(fromrgba[2], torgba[2], amt)),
	                lerp(fromrgba[3], torgba[3], amt)
	            ])
	        }
	    }
	
	    //add 1 step as last value
	    colors.push(cmap[cmap.length - 1].rgb.concat(alpha[1]))
	
	    if (format === 'hex') colors = colors.map( rgb2hex );
	    else if (format === 'rgbaString') colors = colors.map( rgbaStr );
	    else if (format === 'float') colors = colors.map( rgb2float );
	
	    return colors;
	};
	
	function rgb2float (rgba) {
	    return [
	        rgba[0] / 255,
	        rgba[1] / 255,
	        rgba[2] / 255,
	        rgba[3]
	    ]
	}
	
	function rgb2hex (rgba) {
	    var dig, hex = '#';
	    for (var i = 0; i < 3; ++i) {
	        dig = rgba[i];
	        dig = dig.toString(16);
	        hex += ('00' + dig).substr( dig.length );
	    }
	    return hex;
	}
	
	function rgbaStr (rgba) {
	    return 'rgba(' + rgba.join(',') + ')';
	}
	
	},{"./colorScale":126,"lerp":426}],128:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = compareAngle
	
	var orient = _dereq_("robust-orientation")
	var sgn = _dereq_("signum")
	var twoSum = _dereq_("two-sum")
	var robustProduct = _dereq_("robust-product")
	var robustSum = _dereq_("robust-sum")
	
	function testInterior(a, b, c) {
	  var x0 = twoSum(a[0], -b[0])
	  var y0 = twoSum(a[1], -b[1])
	  var x1 = twoSum(c[0], -b[0])
	  var y1 = twoSum(c[1], -b[1])
	
	  var d = robustSum(
	    robustProduct(x0, x1),
	    robustProduct(y0, y1))
	
	  return d[d.length-1] >= 0
	}
	
	function compareAngle(a, b, c, d) {
	  var bcd = orient(b, c, d)
	  if(bcd === 0) {
	    //Handle degenerate cases
	    var sabc = sgn(orient(a, b, c))
	    var sabd = sgn(orient(a, b, d))
	    if(sabc === sabd) {
	      if(sabc === 0) {
	        var ic = testInterior(a, b, c)
	        var id = testInterior(a, b, d)
	        if(ic === id) {
	          return 0
	        } else if(ic) {
	          return 1
	        } else {
	          return -1
	        }
	      }
	      return 0
	    } else if(sabd === 0) {
	      if(sabc > 0) {
	        return -1
	      } else if(testInterior(a, b, d)) {
	        return -1
	      } else {
	        return 1
	      }
	    } else if(sabc === 0) {
	      if(sabd > 0) {
	        return 1
	      } else if(testInterior(a, b, c)) {
	        return 1
	      } else {
	        return -1
	      }
	    }
	    return sgn(sabd - sabc)
	  }
	  var abc = orient(a, b, c)
	  if(abc > 0) {
	    if(bcd > 0 && orient(a, b, d) > 0) {
	      return 1
	    }
	    return -1
	  } else if(abc < 0) {
	    if(bcd > 0 || orient(a, b, d) > 0) {
	      return 1
	    }
	    return -1
	  } else {
	    var abd = orient(a, b, d)
	    if(abd > 0) {
	      return 1
	    } else {
	      if(testInterior(a, b, c)) {
	        return 1
	      } else {
	        return -1
	      }
	    }
	  }
	}
	},{"robust-orientation":508,"robust-product":509,"robust-sum":513,"signum":514,"two-sum":542}],129:[function(_dereq_,module,exports){
	module.exports = compareCells
	
	var min = Math.min
	
	function compareInt(a, b) {
	  return a - b
	}
	
	function compareCells(a, b) {
	  var n = a.length
	    , t = a.length - b.length
	  if(t) {
	    return t
	  }
	  switch(n) {
	    case 0:
	      return 0
	    case 1:
	      return a[0] - b[0]
	    case 2:
	      return (a[0]+a[1]-b[0]-b[1]) ||
	             min(a[0],a[1]) - min(b[0],b[1])
	    case 3:
	      var l1 = a[0]+a[1]
	        , m1 = b[0]+b[1]
	      t = l1+a[2] - (m1+b[2])
	      if(t) {
	        return t
	      }
	      var l0 = min(a[0], a[1])
	        , m0 = min(b[0], b[1])
	      return min(l0, a[2]) - min(m0, b[2]) ||
	             min(l0+a[2], l1) - min(m0+b[2], m1)
	    case 4:
	      var aw=a[0], ax=a[1], ay=a[2], az=a[3]
	        , bw=b[0], bx=b[1], by=b[2], bz=b[3]
	      return (aw+ax+ay+az)-(bw+bx+by+bz) ||
	             min(aw,ax,ay,az)-min(bw,bx,by,bz,bw) ||
	             min(aw+ax,aw+ay,aw+az,ax+ay,ax+az,ay+az) -
	               min(bw+bx,bw+by,bw+bz,bx+by,bx+bz,by+bz) ||
	             min(aw+ax+ay,aw+ax+az,aw+ay+az,ax+ay+az) -
	               min(bw+bx+by,bw+bx+bz,bw+by+bz,bx+by+bz)
	    default:
	      var as = a.slice().sort(compareInt)
	      var bs = b.slice().sort(compareInt)
	      for(var i=0; i<n; ++i) {
	        t = as[i] - bs[i]
	        if(t) {
	          return t
	        }
	      }
	      return 0
	  }
	}
	
	},{}],130:[function(_dereq_,module,exports){
	'use strict'
	
	var compareCells = _dereq_('compare-cell')
	var parity = _dereq_('cell-orientation')
	
	module.exports = compareOrientedCells
	
	function compareOrientedCells(a, b) {
	  return compareCells(a, b) || parity(a) - parity(b)
	}
	
	},{"cell-orientation":113,"compare-cell":129}],131:[function(_dereq_,module,exports){
	"use strict"
	
	var convexHull1d = _dereq_('./lib/ch1d')
	var convexHull2d = _dereq_('./lib/ch2d')
	var convexHullnd = _dereq_('./lib/chnd')
	
	module.exports = convexHull
	
	function convexHull(points) {
	  var n = points.length
	  if(n === 0) {
	    return []
	  } else if(n === 1) {
	    return [[0]]
	  }
	  var d = points[0].length
	  if(d === 0) {
	    return []
	  } else if(d === 1) {
	    return convexHull1d(points)
	  } else if(d === 2) {
	    return convexHull2d(points)
	  }
	  return convexHullnd(points, d)
	}
	},{"./lib/ch1d":132,"./lib/ch2d":133,"./lib/chnd":134}],132:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = convexHull1d
	
	function convexHull1d(points) {
	  var lo = 0
	  var hi = 0
	  for(var i=1; i<points.length; ++i) {
	    if(points[i][0] < points[lo][0]) {
	      lo = i
	    }
	    if(points[i][0] > points[hi][0]) {
	      hi = i
	    }
	  }
	  if(lo < hi) {
	    return [[lo], [hi]]
	  } else if(lo > hi) {
	    return [[hi], [lo]]
	  } else {
	    return [[lo]]
	  }
	}
	},{}],133:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = convexHull2D
	
	var monotoneHull = _dereq_('monotone-convex-hull-2d')
	
	function convexHull2D(points) {
	  var hull = monotoneHull(points)
	  var h = hull.length
	  if(h <= 2) {
	    return []
	  }
	  var edges = new Array(h)
	  var a = hull[h-1]
	  for(var i=0; i<h; ++i) {
	    var b = hull[i]
	    edges[i] = [a,b]
	    a = b
	  }
	  return edges
	}
	
	},{"monotone-convex-hull-2d":435}],134:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = convexHullnD
	
	var ich = _dereq_('incremental-convex-hull')
	var aff = _dereq_('affine-hull')
	
	function permute(points, front) {
	  var n = points.length
	  var npoints = new Array(n)
	  for(var i=0; i<front.length; ++i) {
	    npoints[i] = points[front[i]]
	  }
	  var ptr = front.length
	  for(var i=0; i<n; ++i) {
	    if(front.indexOf(i) < 0) {
	      npoints[ptr++] = points[i]
	    }
	  }
	  return npoints
	}
	
	function invPermute(cells, front) {
	  var nc = cells.length
	  var nf = front.length
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      var x = c[j]
	      if(x < nf) {
	        c[j] = front[x]
	      } else {
	        x = x - nf
	        for(var k=0; k<nf; ++k) {
	          if(x >= front[k]) {
	            x += 1
	          }
	        }
	        c[j] = x
	      }
	    }
	  }
	  return cells
	}
	
	function convexHullnD(points, d) {
	  try {
	    return ich(points, true)
	  } catch(e) {
	    //If point set is degenerate, try to find a basis and rerun it
	    var ah = aff(points)
	    if(ah.length <= d) {
	      //No basis, no try
	      return []
	    }
	    var npoints = permute(points, ah)
	    var nhull   = ich(npoints, true)
	    return invPermute(nhull, ah)
	  }
	}
	},{"affine-hull":64,"incremental-convex-hull":414}],135:[function(_dereq_,module,exports){
	module.exports = {
	  AFG: 'afghan',
	  ALA: '\\b\\wland',
	  ALB: 'albania',
	  DZA: 'algeria',
	  ASM: '^(?=.*americ).*samoa',
	  AND: 'andorra',
	  AGO: 'angola',
	  AIA: 'anguill?a',
	  ATA: 'antarctica',
	  ATG: 'antigua',
	  ARG: 'argentin',
	  ARM: 'armenia',
	  ABW: '^(?!.*bonaire).*\\baruba',
	  AUS: 'australia',
	  AUT: '^(?!.*hungary).*austria|\\baustri.*\\bemp',
	  AZE: 'azerbaijan',
	  BHS: 'bahamas',
	  BHR: 'bahrain',
	  BGD: 'bangladesh|^(?=.*east).*paki?stan',
	  BRB: 'barbados',
	  BLR: 'belarus|byelo',
	  BEL: '^(?!.*luxem).*belgium',
	  BLZ: 'belize|^(?=.*british).*honduras',
	  BEN: 'benin|dahome',
	  BMU: 'bermuda',
	  BTN: 'bhutan',
	  BOL: 'bolivia',
	  BES: '^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands',
	  BIH: 'herzegovina|bosnia',
	  BWA: 'botswana|bechuana',
	  BVT: 'bouvet',
	  BRA: 'brazil',
	  IOT: 'british.?indian.?ocean',
	  BRN: 'brunei',
	  BGR: 'bulgaria',
	  BFA: 'burkina|\\bfaso|upper.?volta',
	  BDI: 'burundi',
	  CPV: 'verde',
	  KHM: 'cambodia|kampuchea|khmer',
	  CMR: 'cameroon',
	  CAN: 'canada',
	  CYM: 'cayman',
	  CAF: '\\bcentral.african.republic',
	  TCD: '\\bchad',
	  CHL: '\\bchile',
	  CHN: '^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china',
	  CXR: 'christmas',
	  CCK: '\\bcocos|keeling',
	  COL: 'colombia',
	  COM: 'comoro',
	  COG: '^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo',
	  COK: '\\bcook',
	  CRI: 'costa.?rica',
	  CIV: 'ivoire|ivory',
	  HRV: 'croatia',
	  CUB: '\\bcuba',
	  CUW: '^(?!.*bonaire).*\\bcura(c|ç)ao',
	  CYP: 'cyprus',
	  CSK: 'czechoslovakia',
	  CZE: '^(?=.*rep).*czech|czechia|bohemia',
	  COD: '\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc',
	  DNK: 'denmark',
	  DJI: 'djibouti',
	  DMA: 'dominica(?!n)',
	  DOM: 'dominican.rep',
	  ECU: 'ecuador',
	  EGY: 'egypt',
	  SLV: 'el.?salvador',
	  GNQ: 'guine.*eq|eq.*guine|^(?=.*span).*guinea',
	  ERI: 'eritrea',
	  EST: 'estonia',
	  ETH: 'ethiopia|abyssinia',
	  FLK: 'falkland|malvinas',
	  FRO: 'faroe|faeroe',
	  FJI: 'fiji',
	  FIN: 'finland',
	  FRA: '^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul',
	  GUF: '^(?=.*french).*guiana',
	  PYF: 'french.?polynesia|tahiti',
	  ATF: 'french.?southern',
	  GAB: 'gabon',
	  GMB: 'gambia',
	  GEO: '^(?!.*south).*georgia',
	  DDR: 'german.?democratic.?republic|democratic.?republic.*germany|east.germany',
	  DEU: '^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german',
	  GHA: 'ghana|gold.?coast',
	  GIB: 'gibraltar',
	  GRC: 'greece|hellenic|hellas',
	  GRL: 'greenland',
	  GRD: 'grenada',
	  GLP: 'guadeloupe',
	  GUM: '\\bguam',
	  GTM: 'guatemala',
	  GGY: 'guernsey',
	  GIN: '^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea',
	  GNB: 'bissau|^(?=.*portu).*guinea',
	  GUY: 'guyana|british.?guiana',
	  HTI: 'haiti',
	  HMD: 'heard.*mcdonald',
	  VAT: 'holy.?see|vatican|papal.?st',
	  HND: '^(?!.*brit).*honduras',
	  HKG: 'hong.?kong',
	  HUN: '^(?!.*austr).*hungary',
	  ISL: 'iceland',
	  IND: 'india(?!.*ocea)',
	  IDN: 'indonesia',
	  IRN: '\\biran|persia',
	  IRQ: '\\biraq|mesopotamia',
	  IRL: '(^ireland)|(^republic.*ireland)',
	  IMN: '^(?=.*isle).*\\bman',
	  ISR: 'israel',
	  ITA: 'italy',
	  JAM: 'jamaica',
	  JPN: 'japan',
	  JEY: 'jersey',
	  JOR: 'jordan',
	  KAZ: 'kazak',
	  KEN: 'kenya|british.?east.?africa|east.?africa.?prot',
	  KIR: 'kiribati',
	  PRK: '^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)',
	  KWT: 'kuwait',
	  KGZ: 'kyrgyz|kirghiz',
	  LAO: '\\blaos?\\b',
	  LVA: 'latvia',
	  LBN: 'lebanon',
	  LSO: 'lesotho|basuto',
	  LBR: 'liberia',
	  LBY: 'libya',
	  LIE: 'liechtenstein',
	  LTU: 'lithuania',
	  LUX: '^(?!.*belg).*luxem',
	  MAC: 'maca(o|u)',
	  MDG: 'madagascar|malagasy',
	  MWI: 'malawi|nyasa',
	  MYS: 'malaysia',
	  MDV: 'maldive',
	  MLI: '\\bmali\\b',
	  MLT: '\\bmalta',
	  MHL: 'marshall',
	  MTQ: 'martinique',
	  MRT: 'mauritania',
	  MUS: 'mauritius',
	  MYT: '\\bmayotte',
	  MEX: '\\bmexic',
	  FSM: 'fed.*micronesia|micronesia.*fed',
	  MCO: 'monaco',
	  MNG: 'mongolia',
	  MNE: '^(?!.*serbia).*montenegro',
	  MSR: 'montserrat',
	  MAR: 'morocco|\\bmaroc',
	  MOZ: 'mozambique',
	  MMR: 'myanmar|burma',
	  NAM: 'namibia',
	  NRU: 'nauru',
	  NPL: 'nepal',
	  NLD: '^(?!.*\\bant)(?!.*\\bcarib).*netherlands',
	  ANT: '^(?=.*\\bant).*(nether|dutch)',
	  NCL: 'new.?caledonia',
	  NZL: 'new.?zealand',
	  NIC: 'nicaragua',
	  NER: '\\bniger(?!ia)',
	  NGA: 'nigeria',
	  NIU: 'niue',
	  NFK: 'norfolk',
	  MNP: 'mariana',
	  NOR: 'norway',
	  OMN: '\\boman|trucial',
	  PAK: '^(?!.*east).*paki?stan',
	  PLW: 'palau',
	  PSE: 'palestin|\\bgaza|west.?bank',
	  PAN: 'panama',
	  PNG: 'papua|new.?guinea',
	  PRY: 'paraguay',
	  PER: 'peru',
	  PHL: 'philippines',
	  PCN: 'pitcairn',
	  POL: 'poland',
	  PRT: 'portugal',
	  PRI: 'puerto.?rico',
	  QAT: 'qatar',
	  KOR: '^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)',
	  MDA: 'moldov|b(a|e)ssarabia',
	  REU: 'r(e|é)union',
	  ROU: 'r(o|u|ou)mania',
	  RUS: '\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics',
	  RWA: 'rwanda',
	  BLM: 'barth(e|é)lemy',
	  SHN: 'helena',
	  KNA: 'kitts|\\bnevis',
	  LCA: '\\blucia',
	  MAF: '^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)',
	  SPM: 'miquelon',
	  VCT: 'vincent',
	  WSM: '^(?!.*amer).*samoa',
	  SMR: 'san.?marino',
	  STP: '\\bs(a|ã)o.?tom(e|é)',
	  SAU: '\\bsa\\w*.?arabia',
	  SEN: 'senegal',
	  SRB: '^(?!.*monte).*serbia',
	  SYC: 'seychell',
	  SLE: 'sierra',
	  SGP: 'singapore',
	  SXM: '^(?!.*martin)(?!.*saba).*maarten',
	  SVK: '^(?!.*cze).*slovak',
	  SVN: 'slovenia',
	  SLB: 'solomon',
	  SOM: 'somali',
	  ZAF: 'south.africa|s\\\\..?africa',
	  SGS: 'south.?georgia|sandwich',
	  SSD: '\\bs\\w*.?sudan',
	  ESP: 'spain',
	  LKA: 'sri.?lanka|ceylon',
	  SDN: '^(?!.*\\bs(?!u)).*sudan',
	  SUR: 'surinam|dutch.?guiana',
	  SJM: 'svalbard',
	  SWZ: 'swaziland',
	  SWE: 'sweden',
	  CHE: 'switz|swiss',
	  SYR: 'syria',
	  TWN: 'taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china',
	  TJK: 'tajik',
	  THA: 'thailand|\\bsiam',
	  MKD: 'macedonia|fyrom',
	  TLS: '^(?=.*leste).*timor|^(?=.*east).*timor',
	  TGO: 'togo',
	  TKL: 'tokelau',
	  TON: 'tonga',
	  TTO: 'trinidad|tobago',
	  TUN: 'tunisia',
	  TUR: 'turkey',
	  TKM: 'turkmen',
	  TCA: 'turks',
	  TUV: 'tuvalu',
	  UGA: 'uganda',
	  UKR: 'ukrain',
	  ARE: 'emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em',
	  GBR: 'united.?kingdom|britain|^u\\.?k\\.?$',
	  TZA: 'tanzania',
	  USA: 'united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)',
	  UMI: 'minor.?outlying.?is',
	  URY: 'uruguay',
	  UZB: 'uzbek',
	  VUT: 'vanuatu|new.?hebrides',
	  VEN: 'venezuela',
	  VNM: '^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam',
	  VGB: '^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin',
	  VIR: '^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin',
	  WLF: 'futuna|wallis',
	  ESH: 'western.sahara',
	  YEM: '^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen',
	  YMD: '^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen',
	  YUG: 'yugoslavia',
	  ZMB: 'zambia|northern.?rhodesia',
	  EAZ: 'zanzibar',
	  ZWE: 'zimbabwe|^(?!.*northern).*rhodesia'
	}
	
	},{}],136:[function(_dereq_,module,exports){
	module.exports=[
		"xx-small",
		"x-small",
		"small",
		"medium",
		"large",
		"x-large",
		"xx-large",
		"larger",
		"smaller"
	]
	
	},{}],137:[function(_dereq_,module,exports){
	module.exports=[
		"normal",
		"condensed",
		"semi-condensed",
		"extra-condensed",
		"ultra-condensed",
		"expanded",
		"semi-expanded",
		"extra-expanded",
		"ultra-expanded"
	]
	
	},{}],138:[function(_dereq_,module,exports){
	module.exports=[
		"normal",
		"italic",
		"oblique"
	]
	
	},{}],139:[function(_dereq_,module,exports){
	module.exports=[
		"normal",
		"bold",
		"bolder",
		"lighter",
		"100",
		"200",
		"300",
		"400",
		"500",
		"600",
		"700",
		"800",
		"900"
	]
	
	},{}],140:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = {
		parse: _dereq_('./parse'),
		stringify: _dereq_('./stringify')
	}
	
	},{"./parse":142,"./stringify":143}],141:[function(_dereq_,module,exports){
	'use strict'
	
	var sizes = _dereq_('css-font-size-keywords')
	
	module.exports = {
		isSize: function isSize(value) {
			return /^[\d\.]/.test(value)
				|| value.indexOf('/') !== -1
				|| sizes.indexOf(value) !== -1
		}
	}
	
	},{"css-font-size-keywords":136}],142:[function(_dereq_,module,exports){
	'use strict'
	
	var unquote = _dereq_('unquote')
	var globalKeywords = _dereq_('css-global-keywords')
	var systemFontKeywords = _dereq_('css-system-font-keywords')
	var fontWeightKeywords = _dereq_('css-font-weight-keywords')
	var fontStyleKeywords = _dereq_('css-font-style-keywords')
	var fontStretchKeywords = _dereq_('css-font-stretch-keywords')
	var splitBy = _dereq_('string-split-by')
	var isSize = _dereq_('./lib/util').isSize
	
	
	module.exports = parseFont
	
	
	var cache = parseFont.cache = {}
	
	
	function parseFont (value) {
		if (typeof value !== 'string') throw new Error('Font argument must be a string.')
	
		if (cache[value]) return cache[value]
	
		if (value === '') {
			throw new Error('Cannot parse an empty string.')
		}
	
		if (systemFontKeywords.indexOf(value) !== -1) {
			return cache[value] = {system: value}
		}
	
		var font = {
			style: 'normal',
			variant: 'normal',
			weight: 'normal',
			stretch: 'normal',
			lineHeight: 'normal',
			size: '1rem',
			family: ['serif']
		}
	
		var tokens = splitBy(value, /\s+/)
		var token
	
		while (token = tokens.shift()) {
			if (globalKeywords.indexOf(token) !== -1) {
				['style', 'variant', 'weight', 'stretch'].forEach(function(prop) {
					font[prop] = token
				})
	
				return cache[value] = font
			}
	
			if (fontStyleKeywords.indexOf(token) !== -1) {
				font.style = token
				continue
			}
	
			if (token === 'normal' || token === 'small-caps') {
				font.variant = token
				continue
			}
	
			if (fontStretchKeywords.indexOf(token) !== -1) {
				font.stretch = token
				continue
			}
	
			if (fontWeightKeywords.indexOf(token) !== -1) {
				font.weight = token
				continue
			}
	
	
			if (isSize(token)) {
				var parts = splitBy(token, '/')
				font.size = parts[0]
				if (parts[1] != null) {
					font.lineHeight = parseLineHeight(parts[1])
				}
				else if (tokens[0] === '/') {
					tokens.shift()
					font.lineHeight = parseLineHeight(tokens.shift())
	 			}
	
				if (!tokens.length) {
					throw new Error('Missing required font-family.')
				}
				font.family = splitBy(tokens.join(' '), /\s*,\s*/).map(unquote)
	
				return cache[value] = font
			}
	
			throw new Error('Unknown or unsupported font token: ' + token)
		}
	
		throw new Error('Missing required font-size.')
	}
	
	
	function parseLineHeight(value) {
		var parsed = parseFloat(value)
		if (parsed.toString() === value) {
			return parsed
		}
		return value
	}
	
	},{"./lib/util":141,"css-font-stretch-keywords":137,"css-font-style-keywords":138,"css-font-weight-keywords":139,"css-global-keywords":144,"css-system-font-keywords":145,"string-split-by":527,"unquote":546}],143:[function(_dereq_,module,exports){
	'use strict'
	
	var pick = _dereq_('pick-by-alias')
	var isSize = _dereq_('./lib/util').isSize
	
	var globals = a2o(_dereq_('css-global-keywords'))
	var systems = a2o(_dereq_('css-system-font-keywords'))
	var weights = a2o(_dereq_('css-font-weight-keywords'))
	var styles = a2o(_dereq_('css-font-style-keywords'))
	var stretches = a2o(_dereq_('css-font-stretch-keywords'))
	
	var variants = {'normal': 1, 'small-caps': 1}
	var fams = {
		'serif': 1,
		'sans-serif': 1,
		'monospace': 1,
		'cursive': 1,
		'fantasy': 1,
		'system-ui': 1
	}
	
	var defaults = {
		style: 'normal',
		variant: 'normal',
		weight: 'normal',
		stretch: 'normal',
		size: '1rem',
		lineHeight: 'normal',
		family: 'serif'
	}
	
	module.exports = function stringifyFont (o) {
		o = pick(o, {
			style: 'style fontstyle fontStyle font-style slope distinction',
			variant: 'variant font-variant fontVariant fontvariant var capitalization',
			weight: 'weight w font-weight fontWeight fontweight',
			stretch: 'stretch font-stretch fontStretch fontstretch width',
			size: 'size s font-size fontSize fontsize height em emSize',
			lineHeight: 'lh line-height lineHeight lineheight leading',
			family: 'font family fontFamily font-family fontfamily type typeface face',
			system: 'system reserved default global',
		})
	
		if (o.system) {
			if (o.system) verify(o.system, systems)
			return o.system
		}
	
		verify(o.style, styles)
		verify(o.variant, variants)
		verify(o.weight, weights)
		verify(o.stretch, stretches)
	
		// default root value is medium, but by default it's inherited
		if (o.size == null) o.size = defaults.size
		if (typeof o.size === 'number') o.size += 'px'
	
		if (!isSize) throw Error('Bad size value `' + o.size + '`')
	
		// many user-agents use serif, we don't detect that for consistency
		if (!o.family) o.family = defaults.family
		if (Array.isArray(o.family)) {
			if (!o.family.length) o.family = [defaults.family]
			o.family = o.family.map(function (f) {
				return fams[f] ? f : '"' + f + '"'
			}).join(', ')
		}
	
		// [ [ <'font-style'> || <font-variant-css21> || <'font-weight'> || <'font-stretch'> ]? <'font-size'> [ / <'line-height'> ]? <'font-family'> ]
		var result = []
	
		result.push(o.style)
		if (o.variant !== o.style) result.push(o.variant)
	
		if (o.weight !== o.variant &&
			o.weight !== o.style) result.push(o.weight)
	
		if (o.stretch !== o.weight &&
			o.stretch !== o.variant &&
			o.stretch !== o.style) result.push(o.stretch)
	
		result.push(o.size + (o.lineHeight == null || o.lineHeight === 'normal' || (o.lineHeight + '' === '1')  ? '' : ('/' + o.lineHeight)))
		result.push(o.family)
	
		return result.filter(Boolean).join(' ')
	}
	
	function verify (value, values) {
		if (value && !values[value] && !globals[value]) throw Error('Unknown keyword `' + value +'`')
	
		return value
	}
	
	
	// ['a', 'b'] -> {a: true, b: true}
	function a2o (a) {
		var o = {}
		for (var i = 0; i < a.length; i++) {
			o[a[i]] = 1
		}
		return o
	}
	
	},{"./lib/util":141,"css-font-stretch-keywords":137,"css-font-style-keywords":138,"css-font-weight-keywords":139,"css-global-keywords":144,"css-system-font-keywords":145,"pick-by-alias":466}],144:[function(_dereq_,module,exports){
	module.exports=[
		"inherit",
		"initial",
		"unset"
	]
	
	},{}],145:[function(_dereq_,module,exports){
	module.exports=[
		"caption",
		"icon",
		"menu",
		"message-box",
		"small-caption",
		"status-bar"
	]
	
	},{}],146:[function(_dereq_,module,exports){
	"use strict"
	
	function dcubicHermite(p0, v0, p1, v1, t, f) {
	  var dh00 = 6*t*t-6*t,
	      dh10 = 3*t*t-4*t + 1,
	      dh01 = -6*t*t+6*t,
	      dh11 = 3*t*t-2*t
	  if(p0.length) {
	    if(!f) {
	      f = new Array(p0.length)
	    }
	    for(var i=p0.length-1; i>=0; --i) {
	      f[i] = dh00*p0[i] + dh10*v0[i] + dh01*p1[i] + dh11*v1[i]
	    }
	    return f
	  }
	  return dh00*p0 + dh10*v0 + dh01*p1[i] + dh11*v1
	}
	
	function cubicHermite(p0, v0, p1, v1, t, f) {
	  var ti  = (t-1), t2 = t*t, ti2 = ti*ti,
	      h00 = (1+2*t)*ti2,
	      h10 = t*ti2,
	      h01 = t2*(3-2*t),
	      h11 = t2*ti
	  if(p0.length) {
	    if(!f) {
	      f = new Array(p0.length)
	    }
	    for(var i=p0.length-1; i>=0; --i) {
	      f[i] = h00*p0[i] + h10*v0[i] + h01*p1[i] + h11*v1[i]
	    }
	    return f
	  }
	  return h00*p0 + h10*v0 + h01*p1 + h11*v1
	}
	
	module.exports = cubicHermite
	module.exports.derivative = dcubicHermite
	},{}],147:[function(_dereq_,module,exports){
	"use strict"
	
	var createThunk = _dereq_("./lib/thunk.js")
	
	function Procedure() {
	  this.argTypes = []
	  this.shimArgs = []
	  this.arrayArgs = []
	  this.arrayBlockIndices = []
	  this.scalarArgs = []
	  this.offsetArgs = []
	  this.offsetArgIndex = []
	  this.indexArgs = []
	  this.shapeArgs = []
	  this.funcName = ""
	  this.pre = null
	  this.body = null
	  this.post = null
	  this.debug = false
	}
	
	function compileCwise(user_args) {
	  //Create procedure
	  var proc = new Procedure()
	  
	  //Parse blocks
	  proc.pre    = user_args.pre
	  proc.body   = user_args.body
	  proc.post   = user_args.post
	
	  //Parse arguments
	  var proc_args = user_args.args.slice(0)
	  proc.argTypes = proc_args
	  for(var i=0; i<proc_args.length; ++i) {
	    var arg_type = proc_args[i]
	    if(arg_type === "array" || (typeof arg_type === "object" && arg_type.blockIndices)) {
	      proc.argTypes[i] = "array"
	      proc.arrayArgs.push(i)
	      proc.arrayBlockIndices.push(arg_type.blockIndices ? arg_type.blockIndices : 0)
	      proc.shimArgs.push("array" + i)
	      if(i < proc.pre.args.length && proc.pre.args[i].count>0) {
	        throw new Error("cwise: pre() block may not reference array args")
	      }
	      if(i < proc.post.args.length && proc.post.args[i].count>0) {
	        throw new Error("cwise: post() block may not reference array args")
	      }
	    } else if(arg_type === "scalar") {
	      proc.scalarArgs.push(i)
	      proc.shimArgs.push("scalar" + i)
	    } else if(arg_type === "index") {
	      proc.indexArgs.push(i)
	      if(i < proc.pre.args.length && proc.pre.args[i].count > 0) {
	        throw new Error("cwise: pre() block may not reference array index")
	      }
	      if(i < proc.body.args.length && proc.body.args[i].lvalue) {
	        throw new Error("cwise: body() block may not write to array index")
	      }
	      if(i < proc.post.args.length && proc.post.args[i].count > 0) {
	        throw new Error("cwise: post() block may not reference array index")
	      }
	    } else if(arg_type === "shape") {
	      proc.shapeArgs.push(i)
	      if(i < proc.pre.args.length && proc.pre.args[i].lvalue) {
	        throw new Error("cwise: pre() block may not write to array shape")
	      }
	      if(i < proc.body.args.length && proc.body.args[i].lvalue) {
	        throw new Error("cwise: body() block may not write to array shape")
	      }
	      if(i < proc.post.args.length && proc.post.args[i].lvalue) {
	        throw new Error("cwise: post() block may not write to array shape")
	      }
	    } else if(typeof arg_type === "object" && arg_type.offset) {
	      proc.argTypes[i] = "offset"
	      proc.offsetArgs.push({ array: arg_type.array, offset:arg_type.offset })
	      proc.offsetArgIndex.push(i)
	    } else {
	      throw new Error("cwise: Unknown argument type " + proc_args[i])
	    }
	  }
	  
	  //Make sure at least one array argument was specified
	  if(proc.arrayArgs.length <= 0) {
	    throw new Error("cwise: No array arguments specified")
	  }
	  
	  //Make sure arguments are correct
	  if(proc.pre.args.length > proc_args.length) {
	    throw new Error("cwise: Too many arguments in pre() block")
	  }
	  if(proc.body.args.length > proc_args.length) {
	    throw new Error("cwise: Too many arguments in body() block")
	  }
	  if(proc.post.args.length > proc_args.length) {
	    throw new Error("cwise: Too many arguments in post() block")
	  }
	
	  //Check debug flag
	  proc.debug = !!user_args.printCode || !!user_args.debug
	  
	  //Retrieve name
	  proc.funcName = user_args.funcName || "cwise"
	  
	  //Read in block size
	  proc.blockSize = user_args.blockSize || 64
	
	  return createThunk(proc)
	}
	
	module.exports = compileCwise
	
	},{"./lib/thunk.js":149}],148:[function(_dereq_,module,exports){
	"use strict"
	
	var uniq = _dereq_("uniq")
	
	// This function generates very simple loops analogous to how you typically traverse arrays (the outermost loop corresponds to the slowest changing index, the innermost loop to the fastest changing index)
	// TODO: If two arrays have the same strides (and offsets) there is potential for decreasing the number of "pointers" and related variables. The drawback is that the type signature would become more specific and that there would thus be less potential for caching, but it might still be worth it, especially when dealing with large numbers of arguments.
	function innerFill(order, proc, body) {
	  var dimension = order.length
	    , nargs = proc.arrayArgs.length
	    , has_index = proc.indexArgs.length>0
	    , code = []
	    , vars = []
	    , idx=0, pidx=0, i, j
	  for(i=0; i<dimension; ++i) { // Iteration variables
	    vars.push(["i",i,"=0"].join(""))
	  }
	  //Compute scan deltas
	  for(j=0; j<nargs; ++j) {
	    for(i=0; i<dimension; ++i) {
	      pidx = idx
	      idx = order[i]
	      if(i === 0) { // The innermost/fastest dimension's delta is simply its stride
	        vars.push(["d",j,"s",i,"=t",j,"p",idx].join(""))
	      } else { // For other dimensions the delta is basically the stride minus something which essentially "rewinds" the previous (more inner) dimension
	        vars.push(["d",j,"s",i,"=(t",j,"p",idx,"-s",pidx,"*t",j,"p",pidx,")"].join(""))
	      }
	    }
	  }
	  if (vars.length > 0) {
	    code.push("var " + vars.join(","))
	  }  
	  //Scan loop
	  for(i=dimension-1; i>=0; --i) { // Start at largest stride and work your way inwards
	    idx = order[i]
	    code.push(["for(i",i,"=0;i",i,"<s",idx,";++i",i,"){"].join(""))
	  }
	  //Push body of inner loop
	  code.push(body)
	  //Advance scan pointers
	  for(i=0; i<dimension; ++i) {
	    pidx = idx
	    idx = order[i]
	    for(j=0; j<nargs; ++j) {
	      code.push(["p",j,"+=d",j,"s",i].join(""))
	    }
	    if(has_index) {
	      if(i > 0) {
	        code.push(["index[",pidx,"]-=s",pidx].join(""))
	      }
	      code.push(["++index[",idx,"]"].join(""))
	    }
	    code.push("}")
	  }
	  return code.join("\n")
	}
	
	// Generate "outer" loops that loop over blocks of data, applying "inner" loops to the blocks by manipulating the local variables in such a way that the inner loop only "sees" the current block.
	// TODO: If this is used, then the previous declaration (done by generateCwiseOp) of s* is essentially unnecessary.
	//       I believe the s* are not used elsewhere (in particular, I don't think they're used in the pre/post parts and "shape" is defined independently), so it would be possible to make defining the s* dependent on what loop method is being used.
	function outerFill(matched, order, proc, body) {
	  var dimension = order.length
	    , nargs = proc.arrayArgs.length
	    , blockSize = proc.blockSize
	    , has_index = proc.indexArgs.length > 0
	    , code = []
	  for(var i=0; i<nargs; ++i) {
	    code.push(["var offset",i,"=p",i].join(""))
	  }
	  //Generate loops for unmatched dimensions
	  // The order in which these dimensions are traversed is fairly arbitrary (from small stride to large stride, for the first argument)
	  // TODO: It would be nice if the order in which these loops are placed would also be somehow "optimal" (at the very least we should check that it really doesn't hurt us if they're not).
	  for(var i=matched; i<dimension; ++i) {
	    code.push(["for(var j"+i+"=SS[", order[i], "]|0;j", i, ">0;){"].join("")) // Iterate back to front
	    code.push(["if(j",i,"<",blockSize,"){"].join("")) // Either decrease j by blockSize (s = blockSize), or set it to zero (after setting s = j).
	    code.push(["s",order[i],"=j",i].join(""))
	    code.push(["j",i,"=0"].join(""))
	    code.push(["}else{s",order[i],"=",blockSize].join(""))
	    code.push(["j",i,"-=",blockSize,"}"].join(""))
	    if(has_index) {
	      code.push(["index[",order[i],"]=j",i].join(""))
	    }
	  }
	  for(var i=0; i<nargs; ++i) {
	    var indexStr = ["offset"+i]
	    for(var j=matched; j<dimension; ++j) {
	      indexStr.push(["j",j,"*t",i,"p",order[j]].join(""))
	    }
	    code.push(["p",i,"=(",indexStr.join("+"),")"].join(""))
	  }
	  code.push(innerFill(order, proc, body))
	  for(var i=matched; i<dimension; ++i) {
	    code.push("}")
	  }
	  return code.join("\n")
	}
	
	//Count the number of compatible inner orders
	// This is the length of the longest common prefix of the arrays in orders.
	// Each array in orders lists the dimensions of the correspond ndarray in order of increasing stride.
	// This is thus the maximum number of dimensions that can be efficiently traversed by simple nested loops for all arrays.
	function countMatches(orders) {
	  var matched = 0, dimension = orders[0].length
	  while(matched < dimension) {
	    for(var j=1; j<orders.length; ++j) {
	      if(orders[j][matched] !== orders[0][matched]) {
	        return matched
	      }
	    }
	    ++matched
	  }
	  return matched
	}
	
	//Processes a block according to the given data types
	// Replaces variable names by different ones, either "local" ones (that are then ferried in and out of the given array) or ones matching the arguments that the function performing the ultimate loop will accept.
	function processBlock(block, proc, dtypes) {
	  var code = block.body
	  var pre = []
	  var post = []
	  for(var i=0; i<block.args.length; ++i) {
	    var carg = block.args[i]
	    if(carg.count <= 0) {
	      continue
	    }
	    var re = new RegExp(carg.name, "g")
	    var ptrStr = ""
	    var arrNum = proc.arrayArgs.indexOf(i)
	    switch(proc.argTypes[i]) {
	      case "offset":
	        var offArgIndex = proc.offsetArgIndex.indexOf(i)
	        var offArg = proc.offsetArgs[offArgIndex]
	        arrNum = offArg.array
	        ptrStr = "+q" + offArgIndex // Adds offset to the "pointer" in the array
	      case "array":
	        ptrStr = "p" + arrNum + ptrStr
	        var localStr = "l" + i
	        var arrStr = "a" + arrNum
	        if (proc.arrayBlockIndices[arrNum] === 0) { // Argument to body is just a single value from this array
	          if(carg.count === 1) { // Argument/array used only once(?)
	            if(dtypes[arrNum] === "generic") {
	              if(carg.lvalue) {
	                pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
	                code = code.replace(re, localStr)
	                post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
	              } else {
	                code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""))
	              }
	            } else {
	              code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""))
	            }
	          } else if(dtypes[arrNum] === "generic") {
	            pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // TODO: Could we optimize by checking for carg.rvalue?
	            code = code.replace(re, localStr)
	            if(carg.lvalue) {
	              post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
	            }
	          } else {
	            pre.push(["var ", localStr, "=", arrStr, "[", ptrStr, "]"].join("")) // TODO: Could we optimize by checking for carg.rvalue?
	            code = code.replace(re, localStr)
	            if(carg.lvalue) {
	              post.push([arrStr, "[", ptrStr, "]=", localStr].join(""))
	            }
	          }
	        } else { // Argument to body is a "block"
	          var reStrArr = [carg.name], ptrStrArr = [ptrStr]
	          for(var j=0; j<Math.abs(proc.arrayBlockIndices[arrNum]); j++) {
	            reStrArr.push("\\s*\\[([^\\]]+)\\]")
	            ptrStrArr.push("$" + (j+1) + "*t" + arrNum + "b" + j) // Matched index times stride
	          }
	          re = new RegExp(reStrArr.join(""), "g")
	          ptrStr = ptrStrArr.join("+")
	          if(dtypes[arrNum] === "generic") {
	            /*if(carg.lvalue) {
	              pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
	              code = code.replace(re, localStr)
	              post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
	            } else {
	              code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""))
	            }*/
	            throw new Error("cwise: Generic arrays not supported in combination with blocks!")
	          } else {
	            // This does not produce any local variables, even if variables are used multiple times. It would be possible to do so, but it would complicate things quite a bit.
	            code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""))
	          }
	        }
	      break
	      case "scalar":
	        code = code.replace(re, "Y" + proc.scalarArgs.indexOf(i))
	      break
	      case "index":
	        code = code.replace(re, "index")
	      break
	      case "shape":
	        code = code.replace(re, "shape")
	      break
	    }
	  }
	  return [pre.join("\n"), code, post.join("\n")].join("\n").trim()
	}
	
	function typeSummary(dtypes) {
	  var summary = new Array(dtypes.length)
	  var allEqual = true
	  for(var i=0; i<dtypes.length; ++i) {
	    var t = dtypes[i]
	    var digits = t.match(/\d+/)
	    if(!digits) {
	      digits = ""
	    } else {
	      digits = digits[0]
	    }
	    if(t.charAt(0) === 0) {
	      summary[i] = "u" + t.charAt(1) + digits
	    } else {
	      summary[i] = t.charAt(0) + digits
	    }
	    if(i > 0) {
	      allEqual = allEqual && summary[i] === summary[i-1]
	    }
	  }
	  if(allEqual) {
	    return summary[0]
	  }
	  return summary.join("")
	}
	
	//Generates a cwise operator
	function generateCWiseOp(proc, typesig) {
	
	  //Compute dimension
	  // Arrays get put first in typesig, and there are two entries per array (dtype and order), so this gets the number of dimensions in the first array arg.
	  var dimension = (typesig[1].length - Math.abs(proc.arrayBlockIndices[0]))|0
	  var orders = new Array(proc.arrayArgs.length)
	  var dtypes = new Array(proc.arrayArgs.length)
	  for(var i=0; i<proc.arrayArgs.length; ++i) {
	    dtypes[i] = typesig[2*i]
	    orders[i] = typesig[2*i+1]
	  }
	  
	  //Determine where block and loop indices start and end
	  var blockBegin = [], blockEnd = [] // These indices are exposed as blocks
	  var loopBegin = [], loopEnd = [] // These indices are iterated over
	  var loopOrders = [] // orders restricted to the loop indices
	  for(var i=0; i<proc.arrayArgs.length; ++i) {
	    if (proc.arrayBlockIndices[i]<0) {
	      loopBegin.push(0)
	      loopEnd.push(dimension)
	      blockBegin.push(dimension)
	      blockEnd.push(dimension+proc.arrayBlockIndices[i])
	    } else {
	      loopBegin.push(proc.arrayBlockIndices[i]) // Non-negative
	      loopEnd.push(proc.arrayBlockIndices[i]+dimension)
	      blockBegin.push(0)
	      blockEnd.push(proc.arrayBlockIndices[i])
	    }
	    var newOrder = []
	    for(var j=0; j<orders[i].length; j++) {
	      if (loopBegin[i]<=orders[i][j] && orders[i][j]<loopEnd[i]) {
	        newOrder.push(orders[i][j]-loopBegin[i]) // If this is a loop index, put it in newOrder, subtracting loopBegin, to make sure that all loopOrders are using a common set of indices.
	      }
	    }
	    loopOrders.push(newOrder)
	  }
	
	  //First create arguments for procedure
	  var arglist = ["SS"] // SS is the overall shape over which we iterate
	  var code = ["'use strict'"]
	  var vars = []
	  
	  for(var j=0; j<dimension; ++j) {
	    vars.push(["s", j, "=SS[", j, "]"].join("")) // The limits for each dimension.
	  }
	  for(var i=0; i<proc.arrayArgs.length; ++i) {
	    arglist.push("a"+i) // Actual data array
	    arglist.push("t"+i) // Strides
	    arglist.push("p"+i) // Offset in the array at which the data starts (also used for iterating over the data)
	    
	    for(var j=0; j<dimension; ++j) { // Unpack the strides into vars for looping
	      vars.push(["t",i,"p",j,"=t",i,"[",loopBegin[i]+j,"]"].join(""))
	    }
	    
	    for(var j=0; j<Math.abs(proc.arrayBlockIndices[i]); ++j) { // Unpack the strides into vars for block iteration
	      vars.push(["t",i,"b",j,"=t",i,"[",blockBegin[i]+j,"]"].join(""))
	    }
	  }
	  for(var i=0; i<proc.scalarArgs.length; ++i) {
	    arglist.push("Y" + i)
	  }
	  if(proc.shapeArgs.length > 0) {
	    vars.push("shape=SS.slice(0)") // Makes the shape over which we iterate available to the user defined functions (so you can use width/height for example)
	  }
	  if(proc.indexArgs.length > 0) {
	    // Prepare an array to keep track of the (logical) indices, initialized to dimension zeroes.
	    var zeros = new Array(dimension)
	    for(var i=0; i<dimension; ++i) {
	      zeros[i] = "0"
	    }
	    vars.push(["index=[", zeros.join(","), "]"].join(""))
	  }
	  for(var i=0; i<proc.offsetArgs.length; ++i) { // Offset arguments used for stencil operations
	    var off_arg = proc.offsetArgs[i]
	    var init_string = []
	    for(var j=0; j<off_arg.offset.length; ++j) {
	      if(off_arg.offset[j] === 0) {
	        continue
	      } else if(off_arg.offset[j] === 1) {
	        init_string.push(["t", off_arg.array, "p", j].join(""))      
	      } else {
	        init_string.push([off_arg.offset[j], "*t", off_arg.array, "p", j].join(""))
	      }
	    }
	    if(init_string.length === 0) {
	      vars.push("q" + i + "=0")
	    } else {
	      vars.push(["q", i, "=", init_string.join("+")].join(""))
	    }
	  }
	
	  //Prepare this variables
	  var thisVars = uniq([].concat(proc.pre.thisVars)
	                      .concat(proc.body.thisVars)
	                      .concat(proc.post.thisVars))
	  vars = vars.concat(thisVars)
	  if (vars.length > 0) {
	    code.push("var " + vars.join(","))
	  }
	  for(var i=0; i<proc.arrayArgs.length; ++i) {
	    code.push("p"+i+"|=0")
	  }
	  
	  //Inline prelude
	  if(proc.pre.body.length > 3) {
	    code.push(processBlock(proc.pre, proc, dtypes))
	  }
	
	  //Process body
	  var body = processBlock(proc.body, proc, dtypes)
	  var matched = countMatches(loopOrders)
	  if(matched < dimension) {
	    code.push(outerFill(matched, loopOrders[0], proc, body)) // TODO: Rather than passing loopOrders[0], it might be interesting to look at passing an order that represents the majority of the arguments for example.
	  } else {
	    code.push(innerFill(loopOrders[0], proc, body))
	  }
	
	  //Inline epilog
	  if(proc.post.body.length > 3) {
	    code.push(processBlock(proc.post, proc, dtypes))
	  }
	  
	  if(proc.debug) {
	    console.log("-----Generated cwise routine for ", typesig, ":\n" + code.join("\n") + "\n----------")
	  }
	  
	  var loopName = [(proc.funcName||"unnamed"), "_cwise_loop_", orders[0].join("s"),"m",matched,typeSummary(dtypes)].join("")
	  var f = new Function(["function ",loopName,"(", arglist.join(","),"){", code.join("\n"),"} return ", loopName].join(""))
	  return f()
	}
	module.exports = generateCWiseOp
	
	},{"uniq":545}],149:[function(_dereq_,module,exports){
	"use strict"
	
	// The function below is called when constructing a cwise function object, and does the following:
	// A function object is constructed which accepts as argument a compilation function and returns another function.
	// It is this other function that is eventually returned by createThunk, and this function is the one that actually
	// checks whether a certain pattern of arguments has already been used before and compiles new loops as needed.
	// The compilation passed to the first function object is used for compiling new functions.
	// Once this function object is created, it is called with compile as argument, where the first argument of compile
	// is bound to "proc" (essentially containing a preprocessed version of the user arguments to cwise).
	// So createThunk roughly works like this:
	// function createThunk(proc) {
	//   var thunk = function(compileBound) {
	//     var CACHED = {}
	//     return function(arrays and scalars) {
	//       if (dtype and order of arrays in CACHED) {
	//         var func = CACHED[dtype and order of arrays]
	//       } else {
	//         var func = CACHED[dtype and order of arrays] = compileBound(dtype and order of arrays)
	//       }
	//       return func(arrays and scalars)
	//     }
	//   }
	//   return thunk(compile.bind1(proc))
	// }
	
	var compile = _dereq_("./compile.js")
	
	function createThunk(proc) {
	  var code = ["'use strict'", "var CACHED={}"]
	  var vars = []
	  var thunkName = proc.funcName + "_cwise_thunk"
	  
	  //Build thunk
	  code.push(["return function ", thunkName, "(", proc.shimArgs.join(","), "){"].join(""))
	  var typesig = []
	  var string_typesig = []
	  var proc_args = [["array",proc.arrayArgs[0],".shape.slice(", // Slice shape so that we only retain the shape over which we iterate (which gets passed to the cwise operator as SS).
	                    Math.max(0,proc.arrayBlockIndices[0]),proc.arrayBlockIndices[0]<0?(","+proc.arrayBlockIndices[0]+")"):")"].join("")]
	  var shapeLengthConditions = [], shapeConditions = []
	  // Process array arguments
	  for(var i=0; i<proc.arrayArgs.length; ++i) {
	    var j = proc.arrayArgs[i]
	    vars.push(["t", j, "=array", j, ".dtype,",
	               "r", j, "=array", j, ".order"].join(""))
	    typesig.push("t" + j)
	    typesig.push("r" + j)
	    string_typesig.push("t"+j)
	    string_typesig.push("r"+j+".join()")
	    proc_args.push("array" + j + ".data")
	    proc_args.push("array" + j + ".stride")
	    proc_args.push("array" + j + ".offset|0")
	    if (i>0) { // Gather conditions to check for shape equality (ignoring block indices)
	      shapeLengthConditions.push("array" + proc.arrayArgs[0] + ".shape.length===array" + j + ".shape.length+" + (Math.abs(proc.arrayBlockIndices[0])-Math.abs(proc.arrayBlockIndices[i])))
	      shapeConditions.push("array" + proc.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0,proc.arrayBlockIndices[0]) + "]===array" + j + ".shape[shapeIndex+" + Math.max(0,proc.arrayBlockIndices[i]) + "]")
	    }
	  }
	  // Check for shape equality
	  if (proc.arrayArgs.length > 1) {
	    code.push("if (!(" + shapeLengthConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')")
	    code.push("for(var shapeIndex=array" + proc.arrayArgs[0] + ".shape.length-" + Math.abs(proc.arrayBlockIndices[0]) + "; shapeIndex-->0;) {")
	    code.push("if (!(" + shapeConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')")
	    code.push("}")
	  }
	  // Process scalar arguments
	  for(var i=0; i<proc.scalarArgs.length; ++i) {
	    proc_args.push("scalar" + proc.scalarArgs[i])
	  }
	  // Check for cached function (and if not present, generate it)
	  vars.push(["type=[", string_typesig.join(","), "].join()"].join(""))
	  vars.push("proc=CACHED[type]")
	  code.push("var " + vars.join(","))
	  
	  code.push(["if(!proc){",
	             "CACHED[type]=proc=compile([", typesig.join(","), "])}",
	             "return proc(", proc_args.join(","), ")}"].join(""))
	
	  if(proc.debug) {
	    console.log("-----Generated thunk:\n" + code.join("\n") + "\n----------")
	  }
	  
	  //Compile thunk
	  var thunk = new Function("compile", code.join("\n"))
	  return thunk(compile.bind(undefined, proc))
	}
	
	module.exports = createThunk
	
	},{"./compile.js":148}],150:[function(_dereq_,module,exports){
	module.exports = _dereq_("cwise-compiler")
	},{"cwise-compiler":147}],151:[function(_dereq_,module,exports){
	'use strict';
	
	var copy             = _dereq_('es5-ext/object/copy')
	  , normalizeOptions = _dereq_('es5-ext/object/normalize-options')
	  , ensureCallable   = _dereq_('es5-ext/object/valid-callable')
	  , map              = _dereq_('es5-ext/object/map')
	  , callable         = _dereq_('es5-ext/object/valid-callable')
	  , validValue       = _dereq_('es5-ext/object/valid-value')
	
	  , bind = Function.prototype.bind, defineProperty = Object.defineProperty
	  , hasOwnProperty = Object.prototype.hasOwnProperty
	  , define;
	
	define = function (name, desc, options) {
		var value = validValue(desc) && callable(desc.value), dgs;
		dgs = copy(desc);
		delete dgs.writable;
		delete dgs.value;
		dgs.get = function () {
			if (!options.overwriteDefinition && hasOwnProperty.call(this, name)) return value;
			desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
			defineProperty(this, name, desc);
			return this[name];
		};
		return dgs;
	};
	
	module.exports = function (props/*, options*/) {
		var options = normalizeOptions(arguments[1]);
		if (options.resolveContext != null) ensureCallable(options.resolveContext);
		return map(props, function (desc, name) { return define(name, desc, options); });
	};
	
	},{"es5-ext/object/copy":191,"es5-ext/object/map":200,"es5-ext/object/normalize-options":201,"es5-ext/object/valid-callable":205,"es5-ext/object/valid-value":207}],152:[function(_dereq_,module,exports){
	'use strict';
	
	var assign        = _dereq_('es5-ext/object/assign')
	  , normalizeOpts = _dereq_('es5-ext/object/normalize-options')
	  , isCallable    = _dereq_('es5-ext/object/is-callable')
	  , contains      = _dereq_('es5-ext/string/#/contains')
	
	  , d;
	
	d = module.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if ((arguments.length < 2) || (typeof dscr !== 'string')) {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (dscr == null) {
			c = w = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
			w = contains.call(dscr, 'w');
		}
	
		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};
	
	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== 'string') {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (get == null) {
			get = undefined;
		} else if (!isCallable(get)) {
			options = get;
			get = set = undefined;
		} else if (set == null) {
			set = undefined;
		} else if (!isCallable(set)) {
			options = set;
			set = undefined;
		}
		if (dscr == null) {
			c = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
		}
	
		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};
	
	},{"es5-ext/object/assign":188,"es5-ext/object/is-callable":194,"es5-ext/object/normalize-options":201,"es5-ext/string/#/contains":208}],153:[function(_dereq_,module,exports){
	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],154:[function(_dereq_,module,exports){
	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],155:[function(_dereq_,module,exports){
	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],156:[function(_dereq_,module,exports){
	// https://d3js.org/d3-dispatch/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	exports.dispatch = dispatch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],157:[function(_dereq_,module,exports){
	// https://d3js.org/d3-force/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-quadtree'), _dereq_('d3-collection'), _dereq_('d3-dispatch'), _dereq_('d3-timer')) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree', 'd3-collection', 'd3-dispatch', 'd3-timer'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Quadtree,d3Collection,d3Dispatch,d3Timer) { 'use strict';
	
	var center = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	};
	
	function x(d) {
	  return d.x + d.vx;
	}
	
	function y(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = d3Quadtree.quadtree(nodes, x, y).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	function index(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	var link = function(links) {
	  var id = index,
	      strength = defaultStrength,
	      strengths,
	      distance = constant(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = d3Collection.map(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	function x$1(d) {
	  return d.x;
	}
	
	function y$1(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = d3Collection.map(),
	      stepper = d3Timer.timer(step),
	      event = d3Dispatch.dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	};
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = d3Quadtree.quadtree(nodes, x$1, y$1).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, weight = 0, x, y, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x = y = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = Math.abs(q.value))) {
	          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
	        }
	      }
	      quad.x = x / weight;
	      quad.y = y / weight;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x = quad.x - node.x,
	        y = quad.y - node.y,
	        w = x2 - x1,
	        l = x * x + y * y;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x === 0) x = jiggle(), l += x * x;
	        if (y === 0) y = jiggle(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x * quad.value * alpha / l;
	        node.vy += y * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x === 0) x = jiggle(), l += x * x;
	      if (y === 0) y = jiggle(), l += y * y;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x * w;
	      node.vy += y * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var radial = function(radius, x, y) {
	  var nodes,
	      strength = constant(0.1),
	      strengths,
	      radiuses;
	
	  if (typeof radius !== "function") radius = constant(+radius);
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length; i < n; ++i) {
	      var node = nodes[i],
	          dx = node.x - x || 1e-6,
	          dy = node.y - y || 1e-6,
	          r = Math.sqrt(dx * dx + dy * dy),
	          k = (radiuses[i] - r) * strengths[i] * alpha / r;
	      node.vx += dx * k;
	      node.vy += dy * k;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    radiuses = new Array(n);
	    for (i = 0; i < n; ++i) {
	      radiuses[i] = +radius(nodes[i], i, nodes);
	      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _, initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var x$2 = function(x) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var y$2 = function(y) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	exports.forceCenter = center;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceRadial = radial;
	exports.forceSimulation = simulation;
	exports.forceX = x$2;
	exports.forceY = y$2;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{"d3-collection":154,"d3-dispatch":156,"d3-quadtree":161,"d3-timer":163}],158:[function(_dereq_,module,exports){
	// https://d3js.org/d3-hierarchy/ v1.1.8 Copyright 2018 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	function cluster() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	}
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	function node_count() {
	  return this.eachAfter(count);
	}
	
	function node_each(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	}
	
	function node_eachBefore(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	}
	
	function node_eachAfter(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	}
	
	function node_sum(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	}
	
	function node_sort(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	}
	
	function node_path(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	}
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	function node_ancestors() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	}
	
	function node_descendants() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	}
	
	function node_leaves() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	}
	
	function node_links() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	}
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	function enclose(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	}
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(b, a, c) {
	  var dx = b.x - a.x, x, a2,
	      dy = b.y - a.y, y, b2,
	      d2 = dx * dx + dy * dy;
	  if (d2) {
	    a2 = a.r + c.r, a2 *= a2;
	    b2 = b.r + c.r, b2 *= b2;
	    if (a2 > b2) {
	      x = (d2 + b2 - a2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	      c.x = b.x - x * dx - y * dy;
	      c.y = b.y - x * dy + y * dx;
	    } else {
	      x = (d2 + a2 - b2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	      c.x = a.x + x * dx - y * dy;
	      c.y = a.y + x * dy + y * dx;
	    }
	  } else {
	    c.x = a.x + c.r;
	    c.y = a.y;
	  }
	}
	
	function intersects(a, b) {
	  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	function siblings(circles) {
	  packEnclose(circles);
	  return circles;
	}
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	function index() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	}
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	function roundNode(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	}
	
	function treemapDice(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	}
	
	function partition() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	}
	
	var keyPrefix = "$", // Protect against keys like “__proto__”.
	    preroot = {depth: -1},
	    ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	function stratify() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	}
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	function tree() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	}
	
	function treemapSlice(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	}
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	function index$1() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	}
	
	function binary(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	}
	
	function sliceDice(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	}
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],159:[function(_dereq_,module,exports){
	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-color')) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{"d3-color":155}],160:[function(_dereq_,module,exports){
	// https://d3js.org/d3-path/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],161:[function(_dereq_,module,exports){
	// https://d3js.org/d3-quadtree/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	};
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	};
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	};
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	};
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	};
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	exports.quadtree = quadtree;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],162:[function(_dereq_,module,exports){
	// https://d3js.org/d3-shape/ v1.3.4 Copyright 2019 Mike Bostock
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-path')) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{"d3-path":160}],163:[function(_dereq_,module,exports){
	// https://d3js.org/d3-timer/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],164:[function(_dereq_,module,exports){
	!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (typeof define === "function" && define.amd) this.d3 = d3, define(d3); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();
	},{}],165:[function(_dereq_,module,exports){
	module.exports = function () {
	    for (var i = 0; i < arguments.length; i++) {
	        if (arguments[i] !== undefined) return arguments[i];
	    }
	};
	
	},{}],166:[function(_dereq_,module,exports){
	"use strict"
	
	var ch = _dereq_("incremental-convex-hull")
	var uniq = _dereq_("uniq")
	
	module.exports = triangulate
	
	function LiftedPoint(p, i) {
	  this.point = p
	  this.index = i
	}
	
	function compareLifted(a, b) {
	  var ap = a.point
	  var bp = b.point
	  var d = ap.length
	  for(var i=0; i<d; ++i) {
	    var s = bp[i] - ap[i]
	    if(s) {
	      return s
	    }
	  }
	  return 0
	}
	
	function triangulate1D(n, points, includePointAtInfinity) {
	  if(n === 1) {
	    if(includePointAtInfinity) {
	      return [ [-1, 0] ]
	    } else {
	      return []
	    }
	  }
	  var lifted = points.map(function(p, i) {
	    return [ p[0], i ]
	  })
	  lifted.sort(function(a,b) {
	    return a[0] - b[0]
	  })
	  var cells = new Array(n - 1)
	  for(var i=1; i<n; ++i) {
	    var a = lifted[i-1]
	    var b = lifted[i]
	    cells[i-1] = [ a[1], b[1] ]
	  }
	  if(includePointAtInfinity) {
	    cells.push(
	      [ -1, cells[0][1], ],
	      [ cells[n-1][1], -1 ])
	  }
	  return cells
	}
	
	function triangulate(points, includePointAtInfinity) {
	  var n = points.length
	  if(n === 0) {
	    return []
	  }
	  
	  var d = points[0].length
	  if(d < 1) {
	    return []
	  }
	
	  //Special case:  For 1D we can just sort the points
	  if(d === 1) {
	    return triangulate1D(n, points, includePointAtInfinity)
	  }
	  
	  //Lift points, sort
	  var lifted = new Array(n)
	  var upper = 1.0
	  for(var i=0; i<n; ++i) {
	    var p = points[i]
	    var x = new Array(d+1)
	    var l = 0.0
	    for(var j=0; j<d; ++j) {
	      var v = p[j]
	      x[j] = v
	      l += v * v
	    }
	    x[d] = l
	    lifted[i] = new LiftedPoint(x, i)
	    upper = Math.max(l, upper)
	  }
	  uniq(lifted, compareLifted)
	  
	  //Double points
	  n = lifted.length
	
	  //Create new list of points
	  var dpoints = new Array(n + d + 1)
	  var dindex = new Array(n + d + 1)
	
	  //Add steiner points at top
	  var u = (d+1) * (d+1) * upper
	  var y = new Array(d+1)
	  for(var i=0; i<=d; ++i) {
	    y[i] = 0.0
	  }
	  y[d] = u
	
	  dpoints[0] = y.slice()
	  dindex[0] = -1
	
	  for(var i=0; i<=d; ++i) {
	    var x = y.slice()
	    x[i] = 1
	    dpoints[i+1] = x
	    dindex[i+1] = -1
	  }
	
	  //Copy rest of the points over
	  for(var i=0; i<n; ++i) {
	    var h = lifted[i]
	    dpoints[i + d + 1] = h.point
	    dindex[i + d + 1] =  h.index
	  }
	
	  //Construct convex hull
	  var hull = ch(dpoints, false)
	  if(includePointAtInfinity) {
	    hull = hull.filter(function(cell) {
	      var count = 0
	      for(var j=0; j<=d; ++j) {
	        var v = dindex[cell[j]]
	        if(v < 0) {
	          if(++count >= 2) {
	            return false
	          }
	        }
	        cell[j] = v
	      }
	      return true
	    })
	  } else {
	    hull = hull.filter(function(cell) {
	      for(var i=0; i<=d; ++i) {
	        var v = dindex[cell[i]]
	        if(v < 0) {
	          return false
	        }
	        cell[i] = v
	      }
	      return true
	    })
	  }
	
	  if(d & 1) {
	    for(var i=0; i<hull.length; ++i) {
	      var h = hull[i]
	      var x = h[0]
	      h[0] = h[1]
	      h[1] = x
	    }
	  }
	
	  return hull
	}
	},{"incremental-convex-hull":414,"uniq":545}],167:[function(_dereq_,module,exports){
	'use strict'
	
	
	module.exports = kerning
	
	
	var canvas = kerning.canvas = document.createElement('canvas')
	var ctx = canvas.getContext('2d')
	var asciiPairs = createPairs([32, 126])
	
	kerning.createPairs = createPairs
	kerning.ascii = asciiPairs
	
	
	function kerning (family, o) {
		if (Array.isArray(family)) family = family.join(', ')
	
		var table = {}, pairs, fs = 16, threshold = .05
	
		if (o) {
			if (o.length === 2 && typeof o[0] === 'number') {
				pairs = createPairs(o)
			}
			else if (Array.isArray(o)) {
				pairs = o
			}
			else {
				if (o.o) pairs = createPairs(o.o)
				else if (o.pairs) pairs = o.pairs
	
				if (o.fontSize) fs = o.fontSize
				if (o.threshold != null) threshold = o.threshold
			}
		}
	
		if (!pairs) pairs = asciiPairs
	
		ctx.font = fs + 'px ' + family
	
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i]
			var width = ctx.measureText(pair[0]).width + ctx.measureText(pair[1]).width
			var kerningWidth = ctx.measureText(pair).width
			if (Math.abs(width - kerningWidth) > fs * threshold) {
				var emWidth = (kerningWidth - width) / fs
				table[pair] = emWidth * 1000
			}
		}
	
		return table
	}
	
	
	function createPairs (range) {
		var pairs = []
	
	    for (var i = range[0]; i <= range[1]; i++) {
			var leftChar = String.fromCharCode(i)
			for (var j = range[0]; j < range[1]; j++) {
				var rightChar = String.fromCharCode(j)
				var pair = leftChar + rightChar
	
				pairs.push(pair)
			}
		}
	
		return pairs
	}
	
	},{}],168:[function(_dereq_,module,exports){
	(function (Buffer){
	var hasTypedArrays = false
	if(typeof Float64Array !== "undefined") {
	  var DOUBLE_VIEW = new Float64Array(1)
	    , UINT_VIEW   = new Uint32Array(DOUBLE_VIEW.buffer)
	  DOUBLE_VIEW[0] = 1.0
	  hasTypedArrays = true
	  if(UINT_VIEW[1] === 0x3ff00000) {
	    //Use little endian
	    module.exports = function doubleBitsLE(n) {
	      DOUBLE_VIEW[0] = n
	      return [ UINT_VIEW[0], UINT_VIEW[1] ]
	    }
	    function toDoubleLE(lo, hi) {
	      UINT_VIEW[0] = lo
	      UINT_VIEW[1] = hi
	      return DOUBLE_VIEW[0]
	    }
	    module.exports.pack = toDoubleLE
	    function lowUintLE(n) {
	      DOUBLE_VIEW[0] = n
	      return UINT_VIEW[0]
	    }
	    module.exports.lo = lowUintLE
	    function highUintLE(n) {
	      DOUBLE_VIEW[0] = n
	      return UINT_VIEW[1]
	    }
	    module.exports.hi = highUintLE
	  } else if(UINT_VIEW[0] === 0x3ff00000) {
	    //Use big endian
	    module.exports = function doubleBitsBE(n) {
	      DOUBLE_VIEW[0] = n
	      return [ UINT_VIEW[1], UINT_VIEW[0] ]
	    }
	    function toDoubleBE(lo, hi) {
	      UINT_VIEW[1] = lo
	      UINT_VIEW[0] = hi
	      return DOUBLE_VIEW[0]
	    }
	    module.exports.pack = toDoubleBE
	    function lowUintBE(n) {
	      DOUBLE_VIEW[0] = n
	      return UINT_VIEW[1]
	    }
	    module.exports.lo = lowUintBE
	    function highUintBE(n) {
	      DOUBLE_VIEW[0] = n
	      return UINT_VIEW[0]
	    }
	    module.exports.hi = highUintBE
	  } else {
	    hasTypedArrays = false
	  }
	}
	if(!hasTypedArrays) {
	  var buffer = new Buffer(8)
	  module.exports = function doubleBits(n) {
	    buffer.writeDoubleLE(n, 0, true)
	    return [ buffer.readUInt32LE(0, true), buffer.readUInt32LE(4, true) ]
	  }
	  function toDouble(lo, hi) {
	    buffer.writeUInt32LE(lo, 0, true)
	    buffer.writeUInt32LE(hi, 4, true)
	    return buffer.readDoubleLE(0, true)
	  }
	  module.exports.pack = toDouble  
	  function lowUint(n) {
	    buffer.writeDoubleLE(n, 0, true)
	    return buffer.readUInt32LE(0, true)
	  }
	  module.exports.lo = lowUint
	  function highUint(n) {
	    buffer.writeDoubleLE(n, 0, true)
	    return buffer.readUInt32LE(4, true)
	  }
	  module.exports.hi = highUint
	}
	
	module.exports.sign = function(n) {
	  return module.exports.hi(n) >>> 31
	}
	
	module.exports.exponent = function(n) {
	  var b = module.exports.hi(n)
	  return ((b<<1) >>> 21) - 1023
	}
	
	module.exports.fraction = function(n) {
	  var lo = module.exports.lo(n)
	  var hi = module.exports.hi(n)
	  var b = hi & ((1<<20) - 1)
	  if(hi & 0x7ff00000) {
	    b += (1<<20)
	  }
	  return [lo, b]
	}
	
	module.exports.denormalized = function(n) {
	  var hi = module.exports.hi(n)
	  return !(hi & 0x7ff00000)
	}
	}).call(this,_dereq_("buffer").Buffer)
	},{"buffer":106}],169:[function(_dereq_,module,exports){
	var abs = _dereq_('abs-svg-path')
	var normalize = _dereq_('normalize-svg-path')
	
	var methods = {
	  'M': 'moveTo',
	  'C': 'bezierCurveTo'
	}
	
	module.exports = function(context, segments) {
	  context.beginPath()
	
	  // Make path easy to reproduce.
	  normalize(abs(segments)).forEach(
	    function(segment) {
	      var command = segment[0]
	      var args = segment.slice(1)
	
	      // Convert the path command to a context method.
	      context[methods[command]].apply(context, args)
	    }
	  )
	
	  context.closePath()
	}
	
	},{"abs-svg-path":62,"normalize-svg-path":453}],170:[function(_dereq_,module,exports){
	module.exports = function(dtype) {
	  switch (dtype) {
	    case 'int8':
	      return Int8Array
	    case 'int16':
	      return Int16Array
	    case 'int32':
	      return Int32Array
	    case 'uint8':
	      return Uint8Array
	    case 'uint16':
	      return Uint16Array
	    case 'uint32':
	      return Uint32Array
	    case 'float32':
	      return Float32Array
	    case 'float64':
	      return Float64Array
	    case 'array':
	      return Array
	    case 'uint8_clamped':
	      return Uint8ClampedArray
	  }
	}
	
	},{}],171:[function(_dereq_,module,exports){
	"use strict"
	
	function dupe_array(count, value, i) {
	  var c = count[i]|0
	  if(c <= 0) {
	    return []
	  }
	  var result = new Array(c), j
	  if(i === count.length-1) {
	    for(j=0; j<c; ++j) {
	      result[j] = value
	    }
	  } else {
	    for(j=0; j<c; ++j) {
	      result[j] = dupe_array(count, value, i+1)
	    }
	  }
	  return result
	}
	
	function dupe_number(count, value) {
	  var result, i
	  result = new Array(count)
	  for(i=0; i<count; ++i) {
	    result[i] = value
	  }
	  return result
	}
	
	function dupe(count, value) {
	  if(typeof value === "undefined") {
	    value = 0
	  }
	  switch(typeof count) {
	    case "number":
	      if(count > 0) {
	        return dupe_number(count|0, value)
	      }
	    break
	    case "object":
	      if(typeof (count.length) === "number") {
	        return dupe_array(count, value, 0)
	      }
	    break
	  }
	  return []
	}
	
	module.exports = dupe
	},{}],172:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = earcut;
	module.exports.default = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, invSize;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) break;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertex leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	
	    var p = ear.prevZ,
	        n = ear.nextZ;
	
	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return filterPoints(p);
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m;
	
	    do {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if (locallyInside(p, hole) &&
	                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    } while (p !== stop);
	
	    return m;
	}
	
	// whether sector in vertex m contains sector in vertex p in the same coordinates
	function sectorContainsSector(m, p) {
	    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
	           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
	            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
	            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    var o1 = sign(area(p1, q1, p2));
	    var o2 = sign(area(p1, q1, q2));
	    var o3 = sign(area(p2, q2, p1));
	    var o4 = sign(area(p2, q2, q1));
	
	    if (o1 !== o2 && o3 !== o4) return true; // general case
	
	    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
	    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
	    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
	    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
	
	    return false;
	}
	
	// for collinear points p, q, r, check if point q lies on segment pr
	function onSegment(p, q, r) {
	    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
	}
	
	function sign(num) {
	    return num > 0 ? 1 : num < 0 ? -1 : 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertex index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertex nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};
	
	},{}],173:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = edgeToAdjacency
	
	var uniq = _dereq_("uniq")
	
	function edgeToAdjacency(edges, numVertices) {
	  var numEdges = edges.length
	  if(typeof numVertices !== "number") {
	    numVertices = 0
	    for(var i=0; i<numEdges; ++i) {
	      var e = edges[i]
	      numVertices = Math.max(numVertices, e[0], e[1])
	    }
	    numVertices = (numVertices|0) + 1
	  }
	  numVertices = numVertices|0
	  var adj = new Array(numVertices)
	  for(var i=0; i<numVertices; ++i) {
	    adj[i] = []
	  }
	  for(var i=0; i<numEdges; ++i) {
	    var e = edges[i]
	    adj[e[0]].push(e[1])
	    adj[e[1]].push(e[0])
	  }
	  for(var j=0; j<numVertices; ++j) {
	    uniq(adj[j], function(a, b) {
	      return a - b
	    })
	  }
	  return adj
	}
	},{"uniq":545}],174:[function(_dereq_,module,exports){
	var tarjan = _dereq_('strongly-connected-components');
	
	module.exports = function findCircuits(edges) {
	    var circuits = []; // Output
	
	    var stack = [];
	    var blocked = [];
	    var B = {};
	    var Ak = [];
	    var s;
	
	    function unblock(u) {
	        blocked[u] = false;
	        if(B.hasOwnProperty(u)) {
	            Object.keys(B[u]).forEach(function(w) {
	                delete B[u][w];
	                if(blocked[w]) {unblock(w);}
	            });
	        }
	    }
	
	    function circuit(v) {
	        var found = false;
	
	        stack.push(v);
	        blocked[v] = true;
	
	        // L1
	        var i;
	        var w;
	        for(i = 0; i < Ak[v].length; i++) {
	            w = Ak[v][i];
	            if(w === s) {
	                output(s, stack);
	                found = true;
	            } else if(!blocked[w]) {
	                found = circuit(w);
	            }
	        }
	
	        // L2
	        if(found) {
	            unblock(v);
	        } else {
	            for(i = 0; i < Ak[v].length; i++) {
	                w = Ak[v][i];
	                var entry = B[w];
	
	                if(!entry) {
	                    entry = {};
	                    B[w] = entry;
	                }
	
	                entry[w] = true;
	            }
	        }
	        stack.pop();
	        return found;
	    }
	
	    function output(start, stack) {
	        var cycle = [].concat(stack).concat(start);
	        circuits.push(cycle);
	    }
	
	    function subgraph(minId) {
	      // Remove edges with indice smaller than minId
	        for(var i = 0; i < edges.length; i++) {
	            if(i < minId) edges[i] = [];
	            edges[i] = edges[i].filter(function(i) {
	                return i >= minId;
	            });
	        }
	    }
	
	    function adjacencyStructureSCC(from) {
	      // Make subgraph starting from vertex minId
	        subgraph(from);
	        var g = edges;
	
	      // Find strongly connected components using Tarjan algorithm
	        var sccs = tarjan(g);
	
	      // Filter out trivial connected components (ie. made of one node)
	        var ccs = sccs.components.filter(function(scc) {
	            return scc.length > 1;
	        });
	
	      // Find least vertex
	        var leastVertex = Infinity;
	        var leastVertexComponent;
	        for(var i = 0; i < ccs.length; i++) {
	            for(var j = 0; j < ccs[i].length; j++) {
	                if(ccs[i][j] < leastVertex) {
	                    leastVertex = ccs[i][j];
	                    leastVertexComponent = i;
	                }
	            }
	        }
	
	        var cc = ccs[leastVertexComponent];
	
	        if(!cc) return false;
	
	      // Return the adjacency list of first component
	        var adjList = edges.map(function(l, index) {
	            if(cc.indexOf(index) === -1) return [];
	            return l.filter(function(i) {
	                return cc.indexOf(i) !== -1;
	            });
	        });
	
	        return {
	            leastVertex: leastVertex,
	            adjList: adjList
	        };
	    }
	
	    s = 0;
	    var n = edges.length;
	    while(s < n) {
	        // find strong component with least vertex in
	        // subgraph starting from vertex `s`
	        var p = adjacencyStructureSCC(s);
	
	        // Its least vertex
	        s = p.leastVertex;
	        // Its adjacency list
	        Ak = p.adjList;
	
	        if(Ak) {
	            for(var i = 0; i < Ak.length; i++) {
	                for(var j = 0; j < Ak[i].length; j++) {
	                    var vertexId = Ak[i][j];
	                    blocked[+vertexId] = false;
	                    B[vertexId] = {};
	                }
	            }
	            circuit(s);
	            s = s + 1;
	        } else {
	            s = n;
	        }
	
	    }
	
	    return circuits;
	};
	
	},{"strongly-connected-components":528}],175:[function(_dereq_,module,exports){
	// Inspired by Google Closure:
	// http://closure-library.googlecode.com/svn/docs/
	// closure_goog_array_array.js.html#goog.array.clear
	
	"use strict";
	
	var value = _dereq_("../../object/valid-value");
	
	module.exports = function () {
		value(this).length = 0;
		return this;
	};
	
	},{"../../object/valid-value":207}],176:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")()
		? Array.from
		: _dereq_("./shim");
	
	},{"./is-implemented":177,"./shim":178}],177:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function () {
		var from = Array.from, arr, result;
		if (typeof from !== "function") return false;
		arr = ["raz", "dwa"];
		result = from(arr);
		return Boolean(result && (result !== arr) && (result[1] === "dwa"));
	};
	
	},{}],178:[function(_dereq_,module,exports){
	"use strict";
	
	var iteratorSymbol = _dereq_("es6-symbol").iterator
	  , isArguments    = _dereq_("../../function/is-arguments")
	  , isFunction     = _dereq_("../../function/is-function")
	  , toPosInt       = _dereq_("../../number/to-pos-integer")
	  , callable       = _dereq_("../../object/valid-callable")
	  , validValue     = _dereq_("../../object/valid-value")
	  , isValue        = _dereq_("../../object/is-value")
	  , isString       = _dereq_("../../string/is-string")
	  , isArray        = Array.isArray
	  , call           = Function.prototype.call
	  , desc           = { configurable: true, enumerable: true, writable: true, value: null }
	  , defineProperty = Object.defineProperty;
	
	// eslint-disable-next-line complexity
	module.exports = function (arrayLike /*, mapFn, thisArg*/) {
		var mapFn = arguments[1]
		  , thisArg = arguments[2]
		  , Context
		  , i
		  , j
		  , arr
		  , length
		  , code
		  , iterator
		  , result
		  , getIterator
		  , value;
	
		arrayLike = Object(validValue(arrayLike));
	
		if (isValue(mapFn)) callable(mapFn);
		if (!this || this === Array || !isFunction(this)) {
			// Result: Plain array
			if (!mapFn) {
				if (isArguments(arrayLike)) {
					// Source: Arguments
					length = arrayLike.length;
					if (length !== 1) return Array.apply(null, arrayLike);
					arr = new Array(1);
					arr[0] = arrayLike[0];
					return arr;
				}
				if (isArray(arrayLike)) {
					// Source: Array
					arr = new Array(length = arrayLike.length);
					for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
					return arr;
				}
			}
			arr = [];
		} else {
			// Result: Non plain array
			Context = this;
		}
	
		if (!isArray(arrayLike)) {
			if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
				// Source: Iterator
				iterator = callable(getIterator).call(arrayLike);
				if (Context) arr = new Context();
				result = iterator.next();
				i = 0;
				while (!result.done) {
					value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
					if (Context) {
						desc.value = value;
						defineProperty(arr, i, desc);
					} else {
						arr[i] = value;
					}
					result = iterator.next();
					++i;
				}
				length = i;
			} else if (isString(arrayLike)) {
				// Source: String
				length = arrayLike.length;
				if (Context) arr = new Context();
				for (i = 0, j = 0; i < length; ++i) {
					value = arrayLike[i];
					if (i + 1 < length) {
						code = value.charCodeAt(0);
						// eslint-disable-next-line max-depth
						if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
					}
					value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
					if (Context) {
						desc.value = value;
						defineProperty(arr, j, desc);
					} else {
						arr[j] = value;
					}
					++j;
				}
				length = j;
			}
		}
		if (length === undefined) {
			// Source: array or array-like
			length = toPosInt(arrayLike.length);
			if (Context) arr = new Context(length);
			for (i = 0; i < length; ++i) {
				value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
				if (Context) {
					desc.value = value;
					defineProperty(arr, i, desc);
				} else {
					arr[i] = value;
				}
			}
		}
		if (Context) {
			desc.value = null;
			arr.length = length;
		}
		return arr;
	};
	
	},{"../../function/is-arguments":179,"../../function/is-function":180,"../../number/to-pos-integer":186,"../../object/is-value":196,"../../object/valid-callable":205,"../../object/valid-value":207,"../../string/is-string":211,"es6-symbol":221}],179:[function(_dereq_,module,exports){
	"use strict";
	
	var objToString = Object.prototype.toString
	  , id = objToString.call(
		(function () {
			return arguments;
		})()
	);
	
	module.exports = function (value) {
		return objToString.call(value) === id;
	};
	
	},{}],180:[function(_dereq_,module,exports){
	"use strict";
	
	var objToString = Object.prototype.toString, id = objToString.call(_dereq_("./noop"));
	
	module.exports = function (value) {
		return typeof value === "function" && objToString.call(value) === id;
	};
	
	},{"./noop":181}],181:[function(_dereq_,module,exports){
	"use strict";
	
	// eslint-disable-next-line no-empty-function
	module.exports = function () {};
	
	},{}],182:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")()
		? Math.sign
		: _dereq_("./shim");
	
	},{"./is-implemented":183,"./shim":184}],183:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function () {
		var sign = Math.sign;
		if (typeof sign !== "function") return false;
		return (sign(10) === 1) && (sign(-20) === -1);
	};
	
	},{}],184:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function (value) {
		value = Number(value);
		if (isNaN(value) || (value === 0)) return value;
		return value > 0 ? 1 : -1;
	};
	
	},{}],185:[function(_dereq_,module,exports){
	"use strict";
	
	var sign = _dereq_("../math/sign")
	
	  , abs = Math.abs, floor = Math.floor;
	
	module.exports = function (value) {
		if (isNaN(value)) return 0;
		value = Number(value);
		if ((value === 0) || !isFinite(value)) return value;
		return sign(value) * floor(abs(value));
	};
	
	},{"../math/sign":182}],186:[function(_dereq_,module,exports){
	"use strict";
	
	var toInteger = _dereq_("./to-integer")
	
	  , max = Math.max;
	
	module.exports = function (value) {
	 return max(0, toInteger(value));
	};
	
	},{"./to-integer":185}],187:[function(_dereq_,module,exports){
	// Internal method, used by iteration functions.
	// Calls a function for each key-value pair found in object
	// Optionally takes compareFn to iterate object in specific order
	
	"use strict";
	
	var callable                = _dereq_("./valid-callable")
	  , value                   = _dereq_("./valid-value")
	  , bind                    = Function.prototype.bind
	  , call                    = Function.prototype.call
	  , keys                    = Object.keys
	  , objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	module.exports = function (method, defVal) {
		return function (obj, cb /*, thisArg, compareFn*/) {
			var list, thisArg = arguments[2], compareFn = arguments[3];
			obj = Object(value(obj));
			callable(cb);
	
			list = keys(obj);
			if (compareFn) {
				list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
			}
			if (typeof method !== "function") method = list[method];
			return call.call(method, list, function (key, index) {
				if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
				return call.call(cb, thisArg, obj[key], key, obj, index);
			});
		};
	};
	
	},{"./valid-callable":205,"./valid-value":207}],188:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")()
		? Object.assign
		: _dereq_("./shim");
	
	},{"./is-implemented":189,"./shim":190}],189:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function () {
		var assign = Object.assign, obj;
		if (typeof assign !== "function") return false;
		obj = { foo: "raz" };
		assign(obj, { bar: "dwa" }, { trzy: "trzy" });
		return (obj.foo + obj.bar + obj.trzy) === "razdwatrzy";
	};
	
	},{}],190:[function(_dereq_,module,exports){
	"use strict";
	
	var keys  = _dereq_("../keys")
	  , value = _dereq_("../valid-value")
	  , max   = Math.max;
	
	module.exports = function (dest, src /*, …srcn*/) {
		var error, i, length = max(arguments.length, 2), assign;
		dest = Object(value(dest));
		assign = function (key) {
			try {
				dest[key] = src[key];
			} catch (e) {
				if (!error) error = e;
			}
		};
		for (i = 1; i < length; ++i) {
			src = arguments[i];
			keys(src).forEach(assign);
		}
		if (error !== undefined) throw error;
		return dest;
	};
	
	},{"../keys":197,"../valid-value":207}],191:[function(_dereq_,module,exports){
	"use strict";
	
	var aFrom  = _dereq_("../array/from")
	  , assign = _dereq_("./assign")
	  , value  = _dereq_("./valid-value");
	
	module.exports = function (obj/*, propertyNames, options*/) {
		var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
		if (copy !== obj && !propertyNames) return copy;
		var result = {};
		if (propertyNames) {
			aFrom(propertyNames, function (propertyName) {
				if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
			});
		} else {
			assign(result, obj);
		}
		return result;
	};
	
	},{"../array/from":176,"./assign":188,"./valid-value":207}],192:[function(_dereq_,module,exports){
	// Workaround for http://code.google.com/p/v8/issues/detail?id=2804
	
	"use strict";
	
	var create = Object.create, shim;
	
	if (!_dereq_("./set-prototype-of/is-implemented")()) {
		shim = _dereq_("./set-prototype-of/shim");
	}
	
	module.exports = (function () {
		var nullObject, polyProps, desc;
		if (!shim) return create;
		if (shim.level !== 1) return create;
	
		nullObject = {};
		polyProps = {};
		desc = {
			configurable: false,
			enumerable: false,
			writable: true,
			value: undefined
		};
		Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
			if (name === "__proto__") {
				polyProps[name] = {
					configurable: true,
					enumerable: false,
					writable: true,
					value: undefined
				};
				return;
			}
			polyProps[name] = desc;
		});
		Object.defineProperties(nullObject, polyProps);
	
		Object.defineProperty(shim, "nullPolyfill", {
			configurable: false,
			enumerable: false,
			writable: false,
			value: nullObject
		});
	
		return function (prototype, props) {
			return create(prototype === null ? nullObject : prototype, props);
		};
	}());
	
	},{"./set-prototype-of/is-implemented":203,"./set-prototype-of/shim":204}],193:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./_iterate")("forEach");
	
	},{"./_iterate":187}],194:[function(_dereq_,module,exports){
	// Deprecated
	
	"use strict";
	
	module.exports = function (obj) {
	 return typeof obj === "function";
	};
	
	},{}],195:[function(_dereq_,module,exports){
	"use strict";
	
	var isValue = _dereq_("./is-value");
	
	var map = { function: true, object: true };
	
	module.exports = function (value) {
		return (isValue(value) && map[typeof value]) || false;
	};
	
	},{"./is-value":196}],196:[function(_dereq_,module,exports){
	"use strict";
	
	var _undefined = _dereq_("../function/noop")(); // Support ES3 engines
	
	module.exports = function (val) {
	 return (val !== _undefined) && (val !== null);
	};
	
	},{"../function/noop":181}],197:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")() ? Object.keys : _dereq_("./shim");
	
	},{"./is-implemented":198,"./shim":199}],198:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function () {
		try {
			Object.keys("primitive");
			return true;
		} catch (e) {
			return false;
		}
	};
	
	},{}],199:[function(_dereq_,module,exports){
	"use strict";
	
	var isValue = _dereq_("../is-value");
	
	var keys = Object.keys;
	
	module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };
	
	},{"../is-value":196}],200:[function(_dereq_,module,exports){
	"use strict";
	
	var callable = _dereq_("./valid-callable")
	  , forEach  = _dereq_("./for-each")
	  , call     = Function.prototype.call;
	
	module.exports = function (obj, cb /*, thisArg*/) {
		var result = {}, thisArg = arguments[2];
		callable(cb);
		forEach(obj, function (value, key, targetObj, index) {
			result[key] = call.call(cb, thisArg, value, key, targetObj, index);
		});
		return result;
	};
	
	},{"./for-each":193,"./valid-callable":205}],201:[function(_dereq_,module,exports){
	"use strict";
	
	var isValue = _dereq_("./is-value");
	
	var forEach = Array.prototype.forEach, create = Object.create;
	
	var process = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function (opts1 /*, …options*/) {
		var result = create(null);
		forEach.call(arguments, function (options) {
			if (!isValue(options)) return;
			process(Object(options), result);
		});
		return result;
	};
	
	},{"./is-value":196}],202:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")()
		? Object.setPrototypeOf
		: _dereq_("./shim");
	
	},{"./is-implemented":203,"./shim":204}],203:[function(_dereq_,module,exports){
	"use strict";
	
	var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};
	
	module.exports = function (/* CustomCreate*/) {
		var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
		if (typeof setPrototypeOf !== "function") return false;
		return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
	};
	
	},{}],204:[function(_dereq_,module,exports){
	/* eslint no-proto: "off" */
	
	// Big thanks to @WebReflection for sorting this out
	// https://gist.github.com/WebReflection/5593554
	
	"use strict";
	
	var isObject        = _dereq_("../is-object")
	  , value           = _dereq_("../valid-value")
	  , objIsPrototypeOf = Object.prototype.isPrototypeOf
	  , defineProperty  = Object.defineProperty
	  , nullDesc        = {
		configurable: true,
		enumerable: false,
		writable: true,
		value: undefined
	}
	  , validate;
	
	validate = function (obj, prototype) {
		value(obj);
		if (prototype === null || isObject(prototype)) return obj;
		throw new TypeError("Prototype must be null or an object");
	};
	
	module.exports = (function (status) {
		var fn, set;
		if (!status) return null;
		if (status.level === 2) {
			if (status.set) {
				set = status.set;
				fn = function (obj, prototype) {
					set.call(validate(obj, prototype), prototype);
					return obj;
				};
			} else {
				fn = function (obj, prototype) {
					validate(obj, prototype).__proto__ = prototype;
					return obj;
				};
			}
		} else {
			fn = function self(obj, prototype) {
				var isNullBase;
				validate(obj, prototype);
				isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
				if (isNullBase) delete self.nullPolyfill.__proto__;
				if (prototype === null) prototype = self.nullPolyfill;
				obj.__proto__ = prototype;
				if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
				return obj;
			};
		}
		return Object.defineProperty(fn, "level", {
			configurable: false,
			enumerable: false,
			writable: false,
			value: status.level
		});
	}(
		(function () {
			var tmpObj1 = Object.create(null)
			  , tmpObj2 = {}
			  , set
			  , desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
	
			if (desc) {
				try {
					set = desc.set; // Opera crashes at this point
					set.call(tmpObj1, tmpObj2);
				} catch (ignore) {}
				if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set: set, level: 2 };
			}
	
			tmpObj1.__proto__ = tmpObj2;
			if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };
	
			tmpObj1 = {};
			tmpObj1.__proto__ = tmpObj2;
			if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };
	
			return false;
		})()
	));
	
	_dereq_("../create");
	
	},{"../create":192,"../is-object":195,"../valid-value":207}],205:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function (fn) {
		if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
		return fn;
	};
	
	},{}],206:[function(_dereq_,module,exports){
	"use strict";
	
	var isObject = _dereq_("./is-object");
	
	module.exports = function (value) {
		if (!isObject(value)) throw new TypeError(value + " is not an Object");
		return value;
	};
	
	},{"./is-object":195}],207:[function(_dereq_,module,exports){
	"use strict";
	
	var isValue = _dereq_("./is-value");
	
	module.exports = function (value) {
		if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
		return value;
	};
	
	},{"./is-value":196}],208:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")()
		? String.prototype.contains
		: _dereq_("./shim");
	
	},{"./is-implemented":209,"./shim":210}],209:[function(_dereq_,module,exports){
	"use strict";
	
	var str = "razdwatrzy";
	
	module.exports = function () {
		if (typeof str.contains !== "function") return false;
		return (str.contains("dwa") === true) && (str.contains("foo") === false);
	};
	
	},{}],210:[function(_dereq_,module,exports){
	"use strict";
	
	var indexOf = String.prototype.indexOf;
	
	module.exports = function (searchString/*, position*/) {
		return indexOf.call(this, searchString, arguments[1]) > -1;
	};
	
	},{}],211:[function(_dereq_,module,exports){
	"use strict";
	
	var objToString = Object.prototype.toString, id = objToString.call("");
	
	module.exports = function (value) {
		return (
			typeof value === "string" ||
			(value &&
				typeof value === "object" &&
				(value instanceof String || objToString.call(value) === id)) ||
			false
		);
	};
	
	},{}],212:[function(_dereq_,module,exports){
	"use strict";
	
	var generated = Object.create(null), random = Math.random;
	
	module.exports = function () {
		var str;
		do {
			str = random()
				.toString(36)
				.slice(2);
		} while (generated[str]);
		return str;
	};
	
	},{}],213:[function(_dereq_,module,exports){
	"use strict";
	
	var setPrototypeOf = _dereq_("es5-ext/object/set-prototype-of")
	  , contains       = _dereq_("es5-ext/string/#/contains")
	  , d              = _dereq_("d")
	  , Symbol         = _dereq_("es6-symbol")
	  , Iterator       = _dereq_("./");
	
	var defineProperty = Object.defineProperty, ArrayIterator;
	
	ArrayIterator = module.exports = function (arr, kind) {
		if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
		Iterator.call(this, arr);
		if (!kind) kind = "value";
		else if (contains.call(kind, "key+value")) kind = "key+value";
		else if (contains.call(kind, "key")) kind = "key";
		else kind = "value";
		defineProperty(this, "__kind__", d("", kind));
	};
	if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);
	
	// Internal %ArrayIteratorPrototype% doesn't expose its constructor
	delete ArrayIterator.prototype.constructor;
	
	ArrayIterator.prototype = Object.create(Iterator.prototype, {
		_resolve: d(function (i) {
			if (this.__kind__ === "value") return this.__list__[i];
			if (this.__kind__ === "key+value") return [i, this.__list__[i]];
			return i;
		})
	});
	defineProperty(ArrayIterator.prototype, Symbol.toStringTag, d("c", "Array Iterator"));
	
	},{"./":216,"d":152,"es5-ext/object/set-prototype-of":202,"es5-ext/string/#/contains":208,"es6-symbol":221}],214:[function(_dereq_,module,exports){
	"use strict";
	
	var isArguments = _dereq_("es5-ext/function/is-arguments")
	  , callable    = _dereq_("es5-ext/object/valid-callable")
	  , isString    = _dereq_("es5-ext/string/is-string")
	  , get         = _dereq_("./get");
	
	var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;
	
	module.exports = function (iterable, cb /*, thisArg*/) {
		var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
		if (isArray(iterable) || isArguments(iterable)) mode = "array";
		else if (isString(iterable)) mode = "string";
		else iterable = get(iterable);
	
		callable(cb);
		doBreak = function () {
			broken = true;
		};
		if (mode === "array") {
			some.call(iterable, function (value) {
				call.call(cb, thisArg, value, doBreak);
				return broken;
			});
			return;
		}
		if (mode === "string") {
			length = iterable.length;
			for (i = 0; i < length; ++i) {
				char = iterable[i];
				if (i + 1 < length) {
					code = char.charCodeAt(0);
					if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
				}
				call.call(cb, thisArg, char, doBreak);
				if (broken) break;
			}
			return;
		}
		result = iterable.next();
	
		while (!result.done) {
			call.call(cb, thisArg, result.value, doBreak);
			if (broken) return;
			result = iterable.next();
		}
	};
	
	},{"./get":215,"es5-ext/function/is-arguments":179,"es5-ext/object/valid-callable":205,"es5-ext/string/is-string":211}],215:[function(_dereq_,module,exports){
	"use strict";
	
	var isArguments    = _dereq_("es5-ext/function/is-arguments")
	  , isString       = _dereq_("es5-ext/string/is-string")
	  , ArrayIterator  = _dereq_("./array")
	  , StringIterator = _dereq_("./string")
	  , iterable       = _dereq_("./valid-iterable")
	  , iteratorSymbol = _dereq_("es6-symbol").iterator;
	
	module.exports = function (obj) {
		if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
		if (isArguments(obj)) return new ArrayIterator(obj);
		if (isString(obj)) return new StringIterator(obj);
		return new ArrayIterator(obj);
	};
	
	},{"./array":213,"./string":218,"./valid-iterable":219,"es5-ext/function/is-arguments":179,"es5-ext/string/is-string":211,"es6-symbol":221}],216:[function(_dereq_,module,exports){
	"use strict";
	
	var clear    = _dereq_("es5-ext/array/#/clear")
	  , assign   = _dereq_("es5-ext/object/assign")
	  , callable = _dereq_("es5-ext/object/valid-callable")
	  , value    = _dereq_("es5-ext/object/valid-value")
	  , d        = _dereq_("d")
	  , autoBind = _dereq_("d/auto-bind")
	  , Symbol   = _dereq_("es6-symbol");
	
	var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;
	
	module.exports = Iterator = function (list, context) {
		if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
		defineProperties(this, {
			__list__: d("w", value(list)),
			__context__: d("w", context),
			__nextIndex__: d("w", 0)
		});
		if (!context) return;
		callable(context.on);
		context.on("_add", this._onAdd);
		context.on("_delete", this._onDelete);
		context.on("_clear", this._onClear);
	};
	
	// Internal %IteratorPrototype% doesn't expose its constructor
	delete Iterator.prototype.constructor;
	
	defineProperties(
		Iterator.prototype,
		assign(
			{
				_next: d(function () {
					var i;
					if (!this.__list__) return undefined;
					if (this.__redo__) {
						i = this.__redo__.shift();
						if (i !== undefined) return i;
					}
					if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
					this._unBind();
					return undefined;
				}),
				next: d(function () {
					return this._createResult(this._next());
				}),
				_createResult: d(function (i) {
					if (i === undefined) return { done: true, value: undefined };
					return { done: false, value: this._resolve(i) };
				}),
				_resolve: d(function (i) {
					return this.__list__[i];
				}),
				_unBind: d(function () {
					this.__list__ = null;
					delete this.__redo__;
					if (!this.__context__) return;
					this.__context__.off("_add", this._onAdd);
					this.__context__.off("_delete", this._onDelete);
					this.__context__.off("_clear", this._onClear);
					this.__context__ = null;
				}),
				toString: d(function () {
					return "[object " + (this[Symbol.toStringTag] || "Object") + "]";
				})
			},
			autoBind({
				_onAdd: d(function (index) {
					if (index >= this.__nextIndex__) return;
					++this.__nextIndex__;
					if (!this.__redo__) {
						defineProperty(this, "__redo__", d("c", [index]));
						return;
					}
					this.__redo__.forEach(function (redo, i) {
						if (redo >= index) this.__redo__[i] = ++redo;
					}, this);
					this.__redo__.push(index);
				}),
				_onDelete: d(function (index) {
					var i;
					if (index >= this.__nextIndex__) return;
					--this.__nextIndex__;
					if (!this.__redo__) return;
					i = this.__redo__.indexOf(index);
					if (i !== -1) this.__redo__.splice(i, 1);
					this.__redo__.forEach(function (redo, j) {
						if (redo > index) this.__redo__[j] = --redo;
					}, this);
				}),
				_onClear: d(function () {
					if (this.__redo__) clear.call(this.__redo__);
					this.__nextIndex__ = 0;
				})
			})
		)
	);
	
	defineProperty(
		Iterator.prototype,
		Symbol.iterator,
		d(function () {
			return this;
		})
	);
	
	},{"d":152,"d/auto-bind":151,"es5-ext/array/#/clear":175,"es5-ext/object/assign":188,"es5-ext/object/valid-callable":205,"es5-ext/object/valid-value":207,"es6-symbol":221}],217:[function(_dereq_,module,exports){
	"use strict";
	
	var isArguments = _dereq_("es5-ext/function/is-arguments")
	  , isValue     = _dereq_("es5-ext/object/is-value")
	  , isString    = _dereq_("es5-ext/string/is-string");
	
	var iteratorSymbol = _dereq_("es6-symbol").iterator
	  , isArray        = Array.isArray;
	
	module.exports = function (value) {
		if (!isValue(value)) return false;
		if (isArray(value)) return true;
		if (isString(value)) return true;
		if (isArguments(value)) return true;
		return typeof value[iteratorSymbol] === "function";
	};
	
	},{"es5-ext/function/is-arguments":179,"es5-ext/object/is-value":196,"es5-ext/string/is-string":211,"es6-symbol":221}],218:[function(_dereq_,module,exports){
	// Thanks @mathiasbynens
	// http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols
	
	"use strict";
	
	var setPrototypeOf = _dereq_("es5-ext/object/set-prototype-of")
	  , d              = _dereq_("d")
	  , Symbol         = _dereq_("es6-symbol")
	  , Iterator       = _dereq_("./");
	
	var defineProperty = Object.defineProperty, StringIterator;
	
	StringIterator = module.exports = function (str) {
		if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
		str = String(str);
		Iterator.call(this, str);
		defineProperty(this, "__length__", d("", str.length));
	};
	if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);
	
	// Internal %ArrayIteratorPrototype% doesn't expose its constructor
	delete StringIterator.prototype.constructor;
	
	StringIterator.prototype = Object.create(Iterator.prototype, {
		_next: d(function () {
			if (!this.__list__) return undefined;
			if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
			this._unBind();
			return undefined;
		}),
		_resolve: d(function (i) {
			var char = this.__list__[i], code;
			if (this.__nextIndex__ === this.__length__) return char;
			code = char.charCodeAt(0);
			if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
			return char;
		})
	});
	defineProperty(StringIterator.prototype, Symbol.toStringTag, d("c", "String Iterator"));
	
	},{"./":216,"d":152,"es5-ext/object/set-prototype-of":202,"es6-symbol":221}],219:[function(_dereq_,module,exports){
	"use strict";
	
	var isIterable = _dereq_("./is-iterable");
	
	module.exports = function (value) {
		if (!isIterable(value)) throw new TypeError(value + " is not iterable");
		return value;
	};
	
	},{"./is-iterable":217}],220:[function(_dereq_,module,exports){
	(function (process,global){
	/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = _dereq_;
	    var vertx = r('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && typeof _dereq_ === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	
	}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"_process":483}],221:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = _dereq_('./is-implemented')() ? Symbol : _dereq_('./polyfill');
	
	},{"./is-implemented":222,"./polyfill":224}],222:[function(_dereq_,module,exports){
	'use strict';
	
	var validTypes = { object: true, symbol: true };
	
	module.exports = function () {
		var symbol;
		if (typeof Symbol !== 'function') return false;
		symbol = Symbol('test symbol');
		try { String(symbol); } catch (e) { return false; }
	
		// Return 'true' also for polyfills
		if (!validTypes[typeof Symbol.iterator]) return false;
		if (!validTypes[typeof Symbol.toPrimitive]) return false;
		if (!validTypes[typeof Symbol.toStringTag]) return false;
	
		return true;
	};
	
	},{}],223:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = function (x) {
		if (!x) return false;
		if (typeof x === 'symbol') return true;
		if (!x.constructor) return false;
		if (x.constructor.name !== 'Symbol') return false;
		return (x[x.constructor.toStringTag] === 'Symbol');
	};
	
	},{}],224:[function(_dereq_,module,exports){
	// ES2015 Symbol polyfill for environments that do not (or partially) support it
	
	'use strict';
	
	var d              = _dereq_('d')
	  , validateSymbol = _dereq_('./validate-symbol')
	
	  , create = Object.create, defineProperties = Object.defineProperties
	  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
	  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null)
	  , isNativeSafe;
	
	if (typeof Symbol === 'function') {
		NativeSymbol = Symbol;
		try {
			String(NativeSymbol());
			isNativeSafe = true;
		} catch (ignore) {}
	}
	
	var generateName = (function () {
		var created = create(null);
		return function (desc) {
			var postfix = 0, name, ie11BugWorkaround;
			while (created[desc + (postfix || '')]) ++postfix;
			desc += (postfix || '');
			created[desc] = true;
			name = '@@' + desc;
			defineProperty(objPrototype, name, d.gs(null, function (value) {
				// For IE11 issue see:
				// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
				//    ie11-broken-getters-on-dom-objects
				// https://github.com/medikoo/es6-symbol/issues/12
				if (ie11BugWorkaround) return;
				ie11BugWorkaround = true;
				defineProperty(this, name, d(value));
				ie11BugWorkaround = false;
			}));
			return name;
		};
	}());
	
	// Internal constructor (not one exposed) for creating Symbol instances.
	// This one is used to ensure that `someSymbol instanceof Symbol` always return false
	HiddenSymbol = function Symbol(description) {
		if (this instanceof HiddenSymbol) throw new TypeError('Symbol is not a constructor');
		return SymbolPolyfill(description);
	};
	
	// Exposed `Symbol` constructor
	// (returns instances of HiddenSymbol)
	module.exports = SymbolPolyfill = function Symbol(description) {
		var symbol;
		if (this instanceof Symbol) throw new TypeError('Symbol is not a constructor');
		if (isNativeSafe) return NativeSymbol(description);
		symbol = create(HiddenSymbol.prototype);
		description = (description === undefined ? '' : String(description));
		return defineProperties(symbol, {
			__description__: d('', description),
			__name__: d('', generateName(description))
		});
	};
	defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (globalSymbols[key]) return globalSymbols[key];
			return (globalSymbols[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (s) {
			var key;
			validateSymbol(s);
			for (key in globalSymbols) if (globalSymbols[key] === s) return key;
		}),
	
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
		isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
			SymbolPolyfill('isConcatSpreadable')),
		iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
		match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
		replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
		search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
		species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
		split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
		toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
		toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
		unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
	});
	
	// Internal tweaks for real symbol producer
	defineProperties(HiddenSymbol.prototype, {
		constructor: d(SymbolPolyfill),
		toString: d('', function () { return this.__name__; })
	});
	
	// Proper implementation of methods exposed on Symbol.prototype
	// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
	defineProperties(SymbolPolyfill.prototype, {
		toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
		valueOf: d(function () { return validateSymbol(this); })
	});
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('', function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === 'symbol') return symbol;
		return symbol.toString();
	}));
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));
	
	// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
	
	// Note: It's important to define `toPrimitive` as last one, as some implementations
	// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
	// And that may invoke error in definition flow:
	// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));
	
	},{"./validate-symbol":225,"d":152}],225:[function(_dereq_,module,exports){
	'use strict';
	
	var isSymbol = _dereq_('./is-symbol');
	
	module.exports = function (value) {
		if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
		return value;
	};
	
	},{"./is-symbol":223}],226:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = extractPlanes
	
	function extractPlanes(M, zNear, zFar) {
	  var z  = zNear || 0.0
	  var zf = zFar || 1.0
	  return [
	    [ M[12] + M[0], M[13] + M[1], M[14] + M[2], M[15] + M[3] ],
	    [ M[12] - M[0], M[13] - M[1], M[14] - M[2], M[15] - M[3] ],
	    [ M[12] + M[4], M[13] + M[5], M[14] + M[6], M[15] + M[7] ],
	    [ M[12] - M[4], M[13] - M[5], M[14] - M[6], M[15] - M[7] ],
	    [ z*M[12] + M[8], z*M[13] + M[9], z*M[14] + M[10], z*M[15] + M[11] ],
	    [ zf*M[12] - M[8], zf*M[13] - M[9], zf*M[14] - M[10], zf*M[15] - M[11] ]
	  ]
	}
	},{}],227:[function(_dereq_,module,exports){
	/**
	 * inspired by is-number <https://github.com/jonschlinkert/is-number>
	 * but significantly simplified and sped up by ignoring number and string constructors
	 * ie these return false:
	 *   new Number(1)
	 *   new String('1')
	 */
	
	'use strict';
	
	var allBlankCharCodes = _dereq_('is-string-blank');
	
	module.exports = function(n) {
	    var type = typeof n;
	    if(type === 'string') {
	        var original = n;
	        n = +n;
	        // whitespace strings cast to zero - filter them out
	        if(n===0 && allBlankCharCodes(original)) return false;
	    }
	    else if(type !== 'number') return false;
	
	    return n - n < 1;
	};
	
	},{"is-string-blank":424}],228:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createFilteredVector
	
	var cubicHermite = _dereq_('cubic-hermite')
	var bsearch = _dereq_('binary-search-bounds')
	
	function clamp(lo, hi, x) {
	  return Math.min(hi, Math.max(lo, x))
	}
	
	function FilteredVector(state0, velocity0, t0) {
	  this.dimension  = state0.length
	  this.bounds     = [ new Array(this.dimension), new Array(this.dimension) ]
	  for(var i=0; i<this.dimension; ++i) {
	    this.bounds[0][i] = -Infinity
	    this.bounds[1][i] = Infinity
	  }
	  this._state     = state0.slice().reverse()
	  this._velocity  = velocity0.slice().reverse()
	  this._time      = [ t0 ]
	  this._scratch   = [ state0.slice(), state0.slice(), state0.slice(), state0.slice(), state0.slice() ]
	}
	
	var proto = FilteredVector.prototype
	
	proto.flush = function(t) {
	  var idx = bsearch.gt(this._time, t) - 1
	  if(idx <= 0) {
	    return
	  }
	  this._time.splice(0, idx)
	  this._state.splice(0, idx * this.dimension)
	  this._velocity.splice(0, idx * this.dimension)
	}
	
	proto.curve = function(t) {
	  var time      = this._time
	  var n         = time.length
	  var idx       = bsearch.le(time, t)
	  var result    = this._scratch[0]
	  var state     = this._state
	  var velocity  = this._velocity
	  var d         = this.dimension
	  var bounds    = this.bounds
	  if(idx < 0) {
	    var ptr = d-1
	    for(var i=0; i<d; ++i, --ptr) {
	      result[i] = state[ptr]
	    }
	  } else if(idx >= n-1) {
	    var ptr = state.length-1
	    var tf = t - time[n-1]
	    for(var i=0; i<d; ++i, --ptr) {
	      result[i] = state[ptr] + tf * velocity[ptr]
	    }
	  } else {
	    var ptr = d * (idx+1) - 1
	    var t0  = time[idx]
	    var t1  = time[idx+1]
	    var dt  = (t1 - t0) || 1.0
	    var x0  = this._scratch[1]
	    var x1  = this._scratch[2]
	    var v0  = this._scratch[3]
	    var v1  = this._scratch[4]
	    var steady = true
	    for(var i=0; i<d; ++i, --ptr) {
	      x0[i] = state[ptr]
	      v0[i] = velocity[ptr] * dt
	      x1[i] = state[ptr+d]
	      v1[i] = velocity[ptr+d] * dt
	      steady = steady && (x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0.0)
	    }
	    if(steady) {
	      for(var i=0; i<d; ++i) {
	        result[i] = x0[i]
	      }
	    } else {
	      cubicHermite(x0, v0, x1, v1, (t-t0)/dt, result)
	    }
	  }
	  var lo = bounds[0]
	  var hi = bounds[1]
	  for(var i=0; i<d; ++i) {
	    result[i] = clamp(lo[i], hi[i], result[i])
	  }
	  return result
	}
	
	proto.dcurve = function(t) {
	  var time     = this._time
	  var n        = time.length
	  var idx      = bsearch.le(time, t)
	  var result   = this._scratch[0]
	  var state    = this._state
	  var velocity = this._velocity
	  var d        = this.dimension
	  if(idx >= n-1) {
	    var ptr = state.length-1
	    var tf = t - time[n-1]
	    for(var i=0; i<d; ++i, --ptr) {
	      result[i] = velocity[ptr]
	    }
	  } else {
	    var ptr = d * (idx+1) - 1
	    var t0 = time[idx]
	    var t1 = time[idx+1]
	    var dt = (t1 - t0) || 1.0
	    var x0 = this._scratch[1]
	    var x1 = this._scratch[2]
	    var v0 = this._scratch[3]
	    var v1 = this._scratch[4]
	    var steady = true
	    for(var i=0; i<d; ++i, --ptr) {
	      x0[i] = state[ptr]
	      v0[i] = velocity[ptr] * dt
	      x1[i] = state[ptr+d]
	      v1[i] = velocity[ptr+d] * dt
	      steady = steady && (x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0.0)
	    }
	    if(steady) {
	      for(var i=0; i<d; ++i) {
	        result[i] = 0.0
	      }
	    } else {
	      cubicHermite.derivative(x0, v0, x1, v1, (t-t0)/dt, result)
	      for(var i=0; i<d; ++i) {
	        result[i] /= dt
	      }
	    }
	  }
	  return result
	}
	
	proto.lastT = function() {
	  var time = this._time
	  return time[time.length-1]
	}
	
	proto.stable = function() {
	  var velocity = this._velocity
	  var ptr = velocity.length
	  for(var i=this.dimension-1; i>=0; --i) {
	    if(velocity[--ptr]) {
	      return false
	    }
	  }
	  return true
	}
	
	proto.jump = function(t) {
	  var t0 = this.lastT()
	  var d  = this.dimension
	  if(t < t0 || arguments.length !== d+1) {
	    return
	  }
	  var state     = this._state
	  var velocity  = this._velocity
	  var ptr       = state.length-this.dimension
	  var bounds    = this.bounds
	  var lo        = bounds[0]
	  var hi        = bounds[1]
	  this._time.push(t0, t)
	  for(var j=0; j<2; ++j) {
	    for(var i=0; i<d; ++i) {
	      state.push(state[ptr++])
	      velocity.push(0)
	    }
	  }
	  this._time.push(t)
	  for(var i=d; i>0; --i) {
	    state.push(clamp(lo[i-1], hi[i-1], arguments[i]))
	    velocity.push(0)
	  }
	}
	
	proto.push = function(t) {
	  var t0 = this.lastT()
	  var d  = this.dimension
	  if(t < t0 || arguments.length !== d+1) {
	    return
	  }
	  var state     = this._state
	  var velocity  = this._velocity
	  var ptr       = state.length-this.dimension
	  var dt        = t - t0
	  var bounds    = this.bounds
	  var lo        = bounds[0]
	  var hi        = bounds[1]
	  var sf        = (dt > 1e-6) ? 1/dt : 0
	  this._time.push(t)
	  for(var i=d; i>0; --i) {
	    var xc = clamp(lo[i-1], hi[i-1], arguments[i])
	    state.push(xc)
	    velocity.push((xc - state[ptr++]) * sf)
	  }
	}
	
	proto.set = function(t) {
	  var d = this.dimension
	  if(t < this.lastT() || arguments.length !== d+1) {
	    return
	  }
	  var state     = this._state
	  var velocity  = this._velocity
	  var bounds    = this.bounds
	  var lo        = bounds[0]
	  var hi        = bounds[1]
	  this._time.push(t)
	  for(var i=d; i>0; --i) {
	    state.push(clamp(lo[i-1], hi[i-1], arguments[i]))
	    velocity.push(0)
	  }
	}
	
	proto.move = function(t) {
	  var t0 = this.lastT()
	  var d  = this.dimension
	  if(t <= t0 || arguments.length !== d+1) {
	    return
	  }
	  var state    = this._state
	  var velocity = this._velocity
	  var statePtr = state.length - this.dimension
	  var bounds   = this.bounds
	  var lo       = bounds[0]
	  var hi       = bounds[1]
	  var dt       = t - t0
	  var sf       = (dt > 1e-6) ? 1/dt : 0.0
	  this._time.push(t)
	  for(var i=d; i>0; --i) {
	    var dx = arguments[i]
	    state.push(clamp(lo[i-1], hi[i-1], state[statePtr++] + dx))
	    velocity.push(dx * sf)
	  }
	}
	
	proto.idle = function(t) {
	  var t0 = this.lastT()
	  if(t < t0) {
	    return
	  }
	  var d        = this.dimension
	  var state    = this._state
	  var velocity = this._velocity
	  var statePtr = state.length-d
	  var bounds   = this.bounds
	  var lo       = bounds[0]
	  var hi       = bounds[1]
	  var dt       = t - t0
	  this._time.push(t)
	  for(var i=d-1; i>=0; --i) {
	    state.push(clamp(lo[i], hi[i], state[statePtr] + dt * velocity[statePtr]))
	    velocity.push(0)
	    statePtr += 1
	  }
	}
	
	function getZero(d) {
	  var result = new Array(d)
	  for(var i=0; i<d; ++i) {
	    result[i] = 0.0
	  }
	  return result
	}
	
	function createFilteredVector(initState, initVelocity, initTime) {
	  switch(arguments.length) {
	    case 0:
	      return new FilteredVector([0], [0], 0)
	    case 1:
	      if(typeof initState === 'number') {
	        var zero = getZero(initState)
	        return new FilteredVector(zero, zero, 0)
	      } else {
	        return new FilteredVector(initState, getZero(initState.length), 0)
	      }
	    case 2:
	      if(typeof initVelocity === 'number') {
	        var zero = getZero(initState.length)
	        return new FilteredVector(initState, zero, +initVelocity)
	      } else {
	        initTime = 0
	      }
	    case 3:
	      if(initState.length !== initVelocity.length) {
	        throw new Error('state and velocity lengths must match')
	      }
	      return new FilteredVector(initState, initVelocity, initTime)
	  }
	}
	
	},{"binary-search-bounds":92,"cubic-hermite":146}],229:[function(_dereq_,module,exports){
	/*eslint new-cap:0*/
	var dtype = _dereq_('dtype')
	
	module.exports = flattenVertexData
	
	function flattenVertexData (data, output, offset) {
	  if (!data) throw new TypeError('must specify data as first parameter')
	  offset = +(offset || 0) | 0
	
	  if (Array.isArray(data) && (data[0] && typeof data[0][0] === 'number')) {
	    var dim = data[0].length
	    var length = data.length * dim
	    var i, j, k, l
	
	    // no output specified, create a new typed array
	    if (!output || typeof output === 'string') {
	      output = new (dtype(output || 'float32'))(length + offset)
	    }
	
	    var dstLength = output.length - offset
	    if (length !== dstLength) {
	      throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' +
	        ' does not match destination length ' + dstLength)
	    }
	
	    for (i = 0, k = offset; i < data.length; i++) {
	      for (j = 0; j < dim; j++) {
	        output[k++] = data[i][j] === null ? NaN : data[i][j]
	      }
	    }
	  } else {
	    if (!output || typeof output === 'string') {
	      // no output, create a new one
	      var Ctor = dtype(output || 'float32')
	
	      // handle arrays separately due to possible nulls
	      if (Array.isArray(data) || output === 'array') {
	        output = new Ctor(data.length + offset)
	        for (i = 0, k = offset, l = output.length; k < l; k++, i++) {
	          output[k] = data[i] === null ? NaN : data[i]
	        }
	      } else {
	        if (offset === 0) {
	          output = new Ctor(data)
	        } else {
	          output = new Ctor(data.length + offset)
	
	          output.set(data, offset)
	        }
	      }
	    } else {
	      // store output in existing array
	      output.set(data, offset)
	    }
	  }
	
	  return output
	}
	
	},{"dtype":170}],230:[function(_dereq_,module,exports){
	'use strict'
	
	var stringifyFont = _dereq_('css-font/stringify')
	var defaultChars = [32, 126]
	
	module.exports = atlas
	
	function atlas(options) {
	  options = options || {}
	
	  var shape  = options.shape ? options.shape : options.canvas ? [options.canvas.width, options.canvas.height] : [512, 512]
	  var canvas = options.canvas || document.createElement('canvas')
	  var font   = options.font
	  var step   = typeof options.step === 'number' ? [options.step, options.step] : options.step || [32, 32]
	  var chars  = options.chars || defaultChars
	
	  if (font && typeof font !== 'string') font = stringifyFont(font)
	
	  if (!Array.isArray(chars)) {
	    chars = String(chars).split('')
	  } else
	  if (chars.length === 2
	    && typeof chars[0] === 'number'
	    && typeof chars[1] === 'number'
	  ) {
	    var newchars = []
	
	    for (var i = chars[0], j = 0; i <= chars[1]; i++) {
	      newchars[j++] = String.fromCharCode(i)
	    }
	
	    chars = newchars
	  }
	
	  shape = shape.slice()
	  canvas.width  = shape[0]
	  canvas.height = shape[1]
	
	  var ctx = canvas.getContext('2d')
	
	  ctx.fillStyle = '#000'
	  ctx.fillRect(0, 0, canvas.width, canvas.height)
	
	  ctx.font = font
	  ctx.textAlign = 'center'
	  ctx.textBaseline = 'middle'
	  ctx.fillStyle = '#fff'
	
	  var x = step[0] / 2
	  var y = step[1] / 2
	  for (var i = 0; i < chars.length; i++) {
	    ctx.fillText(chars[i], x, y)
	    if ((x += step[0]) > shape[0] - step[0]/2) (x = step[0]/2), (y += step[1])
	  }
	
	  return canvas
	}
	
	},{"css-font/stringify":143}],231:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = measure
	
	measure.canvas = document.createElement('canvas')
	measure.cache = {}
	
	function measure (font, o) {
		if (!o) o = {}
	
		if (typeof font === 'string' || Array.isArray(font)) {
			o.family = font
		}
	
		var family = Array.isArray(o.family) ? o.family.join(', ') : o.family
		if (!family) throw Error('`family` must be defined')
	
		var fs = o.size || o.fontSize || o.em || 48
		var weight = o.weight || o.fontWeight || ''
		var style = o.style || o.fontStyle || ''
		var font = [style, weight, fs].join(' ') + 'px ' + family
		var origin = o.origin || 'top'
	
		if (measure.cache[family]) {
			// return more precise values if cache has them
			if (fs <= measure.cache[family].em) {
				return applyOrigin(measure.cache[family], origin)
			}
		}
	
		var canvas = o.canvas || measure.canvas
		var ctx = canvas.getContext('2d')
		var chars = {
			upper: o.upper !== undefined ? o.upper : 'H',
			lower: o.lower !== undefined ? o.lower : 'x',
			descent: o.descent !== undefined ? o.descent : 'p',
			ascent: o.ascent !== undefined ? o.ascent : 'h',
			tittle: o.tittle !== undefined ? o.tittle : 'i',
			overshoot: o.overshoot !== undefined ? o.overshoot : 'O'
		}
		var l = Math.ceil(fs * 1.5)
		canvas.height = l
		canvas.width = l * .5
		ctx.font = font
	
		var char = 'H'
		var result = {
			top: 0
		}
	
		// measure line-height
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillStyle = 'black'
		ctx.fillText(char, 0, 0)
		var topPx = firstTop(ctx.getImageData(0, 0, l, l))
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'bottom'
		ctx.fillText(char, 0, l)
		var bottomPx = firstTop(ctx.getImageData(0, 0, l, l))
		result.lineHeight =
		result.bottom = l - bottomPx + topPx
	
		// measure baseline
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'alphabetic'
		ctx.fillText(char, 0, l)
		var baselinePx = firstTop(ctx.getImageData(0, 0, l, l))
		var baseline = l - baselinePx - 1 + topPx
		result.baseline =
		result.alphabetic = baseline
	
		// measure median
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'middle'
		ctx.fillText(char, 0, l * .5)
		var medianPx = firstTop(ctx.getImageData(0, 0, l, l))
		result.median =
		result.middle = l - medianPx - 1 + topPx - l * .5
	
		// measure hanging
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'hanging'
		ctx.fillText(char, 0, l * .5)
		var hangingPx = firstTop(ctx.getImageData(0, 0, l, l))
		result.hanging = l - hangingPx - 1 + topPx - l * .5
	
		// measure ideographic
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'ideographic'
		ctx.fillText(char, 0, l)
		var ideographicPx = firstTop(ctx.getImageData(0, 0, l, l))
		result.ideographic = l - ideographicPx - 1 + topPx
	
		// measure cap
		if (chars.upper) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.upper, 0, 0)
			result.upper = firstTop(ctx.getImageData(0, 0, l, l))
			result.capHeight = (result.baseline - result.upper)
		}
	
		// measure x
		if (chars.lower) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.lower, 0, 0)
			result.lower = firstTop(ctx.getImageData(0, 0, l, l))
			result.xHeight = (result.baseline - result.lower)
		}
	
		// measure tittle
		if (chars.tittle) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.tittle, 0, 0)
			result.tittle = firstTop(ctx.getImageData(0, 0, l, l))
		}
	
		// measure ascent
		if (chars.ascent) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.ascent, 0, 0)
			result.ascent = firstTop(ctx.getImageData(0, 0, l, l))
		}
	
		// measure descent
		if (chars.descent) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.descent, 0, 0)
			result.descent = firstBottom(ctx.getImageData(0, 0, l, l))
		}
	
		// measure overshoot
		if (chars.overshoot) {
			ctx.clearRect(0, 0, l, l)
			ctx.textBaseline = 'top'
			ctx.fillText(chars.overshoot, 0, 0)
			var overshootPx = firstBottom(ctx.getImageData(0, 0, l, l))
			result.overshoot = overshootPx - baseline
		}
	
		// normalize result
		for (var name in result) {
			result[name] /= fs
		}
	
		result.em = fs
		measure.cache[family] = result
	
		return applyOrigin(result, origin)
	}
	
	function applyOrigin(obj, origin) {
		var res = {}
		if (typeof origin === 'string') origin = obj[origin]
		for (var name in obj) {
			if (name === 'em') continue
			res[name] = obj[name] - origin
		}
		return res
	}
	
	function firstTop(iData) {
		var l = iData.height
		var data = iData.data
		for (var i = 3; i < data.length; i+=4) {
			if (data[i] !== 0) {
				return Math.floor((i - 3) *.25 / l)
			}
		}
	}
	
	function firstBottom(iData) {
		var l = iData.height
		var data = iData.data
		for (var i = data.length - 1; i > 0; i -= 4) {
			if (data[i] !== 0) {
				return Math.floor((i - 3) *.25 / l)
			}
		}
	}
	
	},{}],232:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = createRBTree
	
	var RED   = 0
	var BLACK = 1
	
	function RBNode(color, key, value, left, right, count) {
	  this._color = color
	  this.key = key
	  this.value = value
	  this.left = left
	  this.right = right
	  this._count = count
	}
	
	function cloneNode(node) {
	  return new RBNode(node._color, node.key, node.value, node.left, node.right, node._count)
	}
	
	function repaint(color, node) {
	  return new RBNode(color, node.key, node.value, node.left, node.right, node._count)
	}
	
	function recount(node) {
	  node._count = 1 + (node.left ? node.left._count : 0) + (node.right ? node.right._count : 0)
	}
	
	function RedBlackTree(compare, root) {
	  this._compare = compare
	  this.root = root
	}
	
	var proto = RedBlackTree.prototype
	
	Object.defineProperty(proto, "keys", {
	  get: function() {
	    var result = []
	    this.forEach(function(k,v) {
	      result.push(k)
	    })
	    return result
	  }
	})
	
	Object.defineProperty(proto, "values", {
	  get: function() {
	    var result = []
	    this.forEach(function(k,v) {
	      result.push(v)
	    })
	    return result
	  }
	})
	
	//Returns the number of nodes in the tree
	Object.defineProperty(proto, "length", {
	  get: function() {
	    if(this.root) {
	      return this.root._count
	    }
	    return 0
	  }
	})
	
	//Insert a new item into the tree
	proto.insert = function(key, value) {
	  var cmp = this._compare
	  //Find point to insert new node at
	  var n = this.root
	  var n_stack = []
	  var d_stack = []
	  while(n) {
	    var d = cmp(key, n.key)
	    n_stack.push(n)
	    d_stack.push(d)
	    if(d <= 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  //Rebuild path to leaf node
	  n_stack.push(new RBNode(RED, key, value, null, null, 1))
	  for(var s=n_stack.length-2; s>=0; --s) {
	    var n = n_stack[s]
	    if(d_stack[s] <= 0) {
	      n_stack[s] = new RBNode(n._color, n.key, n.value, n_stack[s+1], n.right, n._count+1)
	    } else {
	      n_stack[s] = new RBNode(n._color, n.key, n.value, n.left, n_stack[s+1], n._count+1)
	    }
	  }
	  //Rebalance tree using rotations
	  //console.log("start insert", key, d_stack)
	  for(var s=n_stack.length-1; s>1; --s) {
	    var p = n_stack[s-1]
	    var n = n_stack[s]
	    if(p._color === BLACK || n._color === BLACK) {
	      break
	    }
	    var pp = n_stack[s-2]
	    if(pp.left === p) {
	      if(p.left === n) {
	        var y = pp.right
	        if(y && y._color === RED) {
	          //console.log("LLr")
	          p._color = BLACK
	          pp.right = repaint(BLACK, y)
	          pp._color = RED
	          s -= 1
	        } else {
	          //console.log("LLb")
	          pp._color = RED
	          pp.left = p.right
	          p._color = BLACK
	          p.right = pp
	          n_stack[s-2] = p
	          n_stack[s-1] = n
	          recount(pp)
	          recount(p)
	          if(s >= 3) {
	            var ppp = n_stack[s-3]
	            if(ppp.left === pp) {
	              ppp.left = p
	            } else {
	              ppp.right = p
	            }
	          }
	          break
	        }
	      } else {
	        var y = pp.right
	        if(y && y._color === RED) {
	          //console.log("LRr")
	          p._color = BLACK
	          pp.right = repaint(BLACK, y)
	          pp._color = RED
	          s -= 1
	        } else {
	          //console.log("LRb")
	          p.right = n.left
	          pp._color = RED
	          pp.left = n.right
	          n._color = BLACK
	          n.left = p
	          n.right = pp
	          n_stack[s-2] = n
	          n_stack[s-1] = p
	          recount(pp)
	          recount(p)
	          recount(n)
	          if(s >= 3) {
	            var ppp = n_stack[s-3]
	            if(ppp.left === pp) {
	              ppp.left = n
	            } else {
	              ppp.right = n
	            }
	          }
	          break
	        }
	      }
	    } else {
	      if(p.right === n) {
	        var y = pp.left
	        if(y && y._color === RED) {
	          //console.log("RRr", y.key)
	          p._color = BLACK
	          pp.left = repaint(BLACK, y)
	          pp._color = RED
	          s -= 1
	        } else {
	          //console.log("RRb")
	          pp._color = RED
	          pp.right = p.left
	          p._color = BLACK
	          p.left = pp
	          n_stack[s-2] = p
	          n_stack[s-1] = n
	          recount(pp)
	          recount(p)
	          if(s >= 3) {
	            var ppp = n_stack[s-3]
	            if(ppp.right === pp) {
	              ppp.right = p
	            } else {
	              ppp.left = p
	            }
	          }
	          break
	        }
	      } else {
	        var y = pp.left
	        if(y && y._color === RED) {
	          //console.log("RLr")
	          p._color = BLACK
	          pp.left = repaint(BLACK, y)
	          pp._color = RED
	          s -= 1
	        } else {
	          //console.log("RLb")
	          p.left = n.right
	          pp._color = RED
	          pp.right = n.left
	          n._color = BLACK
	          n.right = p
	          n.left = pp
	          n_stack[s-2] = n
	          n_stack[s-1] = p
	          recount(pp)
	          recount(p)
	          recount(n)
	          if(s >= 3) {
	            var ppp = n_stack[s-3]
	            if(ppp.right === pp) {
	              ppp.right = n
	            } else {
	              ppp.left = n
	            }
	          }
	          break
	        }
	      }
	    }
	  }
	  //Return new tree
	  n_stack[0]._color = BLACK
	  return new RedBlackTree(cmp, n_stack[0])
	}
	
	
	//Visit all nodes inorder
	function doVisitFull(visit, node) {
	  if(node.left) {
	    var v = doVisitFull(visit, node.left)
	    if(v) { return v }
	  }
	  var v = visit(node.key, node.value)
	  if(v) { return v }
	  if(node.right) {
	    return doVisitFull(visit, node.right)
	  }
	}
	
	//Visit half nodes in order
	function doVisitHalf(lo, compare, visit, node) {
	  var l = compare(lo, node.key)
	  if(l <= 0) {
	    if(node.left) {
	      var v = doVisitHalf(lo, compare, visit, node.left)
	      if(v) { return v }
	    }
	    var v = visit(node.key, node.value)
	    if(v) { return v }
	  }
	  if(node.right) {
	    return doVisitHalf(lo, compare, visit, node.right)
	  }
	}
	
	//Visit all nodes within a range
	function doVisit(lo, hi, compare, visit, node) {
	  var l = compare(lo, node.key)
	  var h = compare(hi, node.key)
	  var v
	  if(l <= 0) {
	    if(node.left) {
	      v = doVisit(lo, hi, compare, visit, node.left)
	      if(v) { return v }
	    }
	    if(h > 0) {
	      v = visit(node.key, node.value)
	      if(v) { return v }
	    }
	  }
	  if(h > 0 && node.right) {
	    return doVisit(lo, hi, compare, visit, node.right)
	  }
	}
	
	
	proto.forEach = function rbTreeForEach(visit, lo, hi) {
	  if(!this.root) {
	    return
	  }
	  switch(arguments.length) {
	    case 1:
	      return doVisitFull(visit, this.root)
	    break
	
	    case 2:
	      return doVisitHalf(lo, this._compare, visit, this.root)
	    break
	
	    case 3:
	      if(this._compare(lo, hi) >= 0) {
	        return
	      }
	      return doVisit(lo, hi, this._compare, visit, this.root)
	    break
	  }
	}
	
	//First item in list
	Object.defineProperty(proto, "begin", {
	  get: function() {
	    var stack = []
	    var n = this.root
	    while(n) {
	      stack.push(n)
	      n = n.left
	    }
	    return new RedBlackTreeIterator(this, stack)
	  }
	})
	
	//Last item in list
	Object.defineProperty(proto, "end", {
	  get: function() {
	    var stack = []
	    var n = this.root
	    while(n) {
	      stack.push(n)
	      n = n.right
	    }
	    return new RedBlackTreeIterator(this, stack)
	  }
	})
	
	//Find the ith item in the tree
	proto.at = function(idx) {
	  if(idx < 0) {
	    return new RedBlackTreeIterator(this, [])
	  }
	  var n = this.root
	  var stack = []
	  while(true) {
	    stack.push(n)
	    if(n.left) {
	      if(idx < n.left._count) {
	        n = n.left
	        continue
	      }
	      idx -= n.left._count
	    }
	    if(!idx) {
	      return new RedBlackTreeIterator(this, stack)
	    }
	    idx -= 1
	    if(n.right) {
	      if(idx >= n.right._count) {
	        break
	      }
	      n = n.right
	    } else {
	      break
	    }
	  }
	  return new RedBlackTreeIterator(this, [])
	}
	
	proto.ge = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  var stack = []
	  var last_ptr = 0
	  while(n) {
	    var d = cmp(key, n.key)
	    stack.push(n)
	    if(d <= 0) {
	      last_ptr = stack.length
	    }
	    if(d <= 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  stack.length = last_ptr
	  return new RedBlackTreeIterator(this, stack)
	}
	
	proto.gt = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  var stack = []
	  var last_ptr = 0
	  while(n) {
	    var d = cmp(key, n.key)
	    stack.push(n)
	    if(d < 0) {
	      last_ptr = stack.length
	    }
	    if(d < 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  stack.length = last_ptr
	  return new RedBlackTreeIterator(this, stack)
	}
	
	proto.lt = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  var stack = []
	  var last_ptr = 0
	  while(n) {
	    var d = cmp(key, n.key)
	    stack.push(n)
	    if(d > 0) {
	      last_ptr = stack.length
	    }
	    if(d <= 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  stack.length = last_ptr
	  return new RedBlackTreeIterator(this, stack)
	}
	
	proto.le = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  var stack = []
	  var last_ptr = 0
	  while(n) {
	    var d = cmp(key, n.key)
	    stack.push(n)
	    if(d >= 0) {
	      last_ptr = stack.length
	    }
	    if(d < 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  stack.length = last_ptr
	  return new RedBlackTreeIterator(this, stack)
	}
	
	//Finds the item with key if it exists
	proto.find = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  var stack = []
	  while(n) {
	    var d = cmp(key, n.key)
	    stack.push(n)
	    if(d === 0) {
	      return new RedBlackTreeIterator(this, stack)
	    }
	    if(d <= 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  return new RedBlackTreeIterator(this, [])
	}
	
	//Removes item with key from tree
	proto.remove = function(key) {
	  var iter = this.find(key)
	  if(iter) {
	    return iter.remove()
	  }
	  return this
	}
	
	//Returns the item at `key`
	proto.get = function(key) {
	  var cmp = this._compare
	  var n = this.root
	  while(n) {
	    var d = cmp(key, n.key)
	    if(d === 0) {
	      return n.value
	    }
	    if(d <= 0) {
	      n = n.left
	    } else {
	      n = n.right
	    }
	  }
	  return
	}
	
	//Iterator for red black tree
	function RedBlackTreeIterator(tree, stack) {
	  this.tree = tree
	  this._stack = stack
	}
	
	var iproto = RedBlackTreeIterator.prototype
	
	//Test if iterator is valid
	Object.defineProperty(iproto, "valid", {
	  get: function() {
	    return this._stack.length > 0
	  }
	})
	
	//Node of the iterator
	Object.defineProperty(iproto, "node", {
	  get: function() {
	    if(this._stack.length > 0) {
	      return this._stack[this._stack.length-1]
	    }
	    return null
	  },
	  enumerable: true
	})
	
	//Makes a copy of an iterator
	iproto.clone = function() {
	  return new RedBlackTreeIterator(this.tree, this._stack.slice())
	}
	
	//Swaps two nodes
	function swapNode(n, v) {
	  n.key = v.key
	  n.value = v.value
	  n.left = v.left
	  n.right = v.right
	  n._color = v._color
	  n._count = v._count
	}
	
	//Fix up a double black node in a tree
	function fixDoubleBlack(stack) {
	  var n, p, s, z
	  for(var i=stack.length-1; i>=0; --i) {
	    n = stack[i]
	    if(i === 0) {
	      n._color = BLACK
	      return
	    }
	    //console.log("visit node:", n.key, i, stack[i].key, stack[i-1].key)
	    p = stack[i-1]
	    if(p.left === n) {
	      //console.log("left child")
	      s = p.right
	      if(s.right && s.right._color === RED) {
	        //console.log("case 1: right sibling child red")
	        s = p.right = cloneNode(s)
	        z = s.right = cloneNode(s.right)
	        p.right = s.left
	        s.left = p
	        s.right = z
	        s._color = p._color
	        n._color = BLACK
	        p._color = BLACK
	        z._color = BLACK
	        recount(p)
	        recount(s)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.left === p) {
	            pp.left = s
	          } else {
	            pp.right = s
	          }
	        }
	        stack[i-1] = s
	        return
	      } else if(s.left && s.left._color === RED) {
	        //console.log("case 1: left sibling child red")
	        s = p.right = cloneNode(s)
	        z = s.left = cloneNode(s.left)
	        p.right = z.left
	        s.left = z.right
	        z.left = p
	        z.right = s
	        z._color = p._color
	        p._color = BLACK
	        s._color = BLACK
	        n._color = BLACK
	        recount(p)
	        recount(s)
	        recount(z)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.left === p) {
	            pp.left = z
	          } else {
	            pp.right = z
	          }
	        }
	        stack[i-1] = z
	        return
	      }
	      if(s._color === BLACK) {
	        if(p._color === RED) {
	          //console.log("case 2: black sibling, red parent", p.right.value)
	          p._color = BLACK
	          p.right = repaint(RED, s)
	          return
	        } else {
	          //console.log("case 2: black sibling, black parent", p.right.value)
	          p.right = repaint(RED, s)
	          continue  
	        }
	      } else {
	        //console.log("case 3: red sibling")
	        s = cloneNode(s)
	        p.right = s.left
	        s.left = p
	        s._color = p._color
	        p._color = RED
	        recount(p)
	        recount(s)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.left === p) {
	            pp.left = s
	          } else {
	            pp.right = s
	          }
	        }
	        stack[i-1] = s
	        stack[i] = p
	        if(i+1 < stack.length) {
	          stack[i+1] = n
	        } else {
	          stack.push(n)
	        }
	        i = i+2
	      }
	    } else {
	      //console.log("right child")
	      s = p.left
	      if(s.left && s.left._color === RED) {
	        //console.log("case 1: left sibling child red", p.value, p._color)
	        s = p.left = cloneNode(s)
	        z = s.left = cloneNode(s.left)
	        p.left = s.right
	        s.right = p
	        s.left = z
	        s._color = p._color
	        n._color = BLACK
	        p._color = BLACK
	        z._color = BLACK
	        recount(p)
	        recount(s)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.right === p) {
	            pp.right = s
	          } else {
	            pp.left = s
	          }
	        }
	        stack[i-1] = s
	        return
	      } else if(s.right && s.right._color === RED) {
	        //console.log("case 1: right sibling child red")
	        s = p.left = cloneNode(s)
	        z = s.right = cloneNode(s.right)
	        p.left = z.right
	        s.right = z.left
	        z.right = p
	        z.left = s
	        z._color = p._color
	        p._color = BLACK
	        s._color = BLACK
	        n._color = BLACK
	        recount(p)
	        recount(s)
	        recount(z)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.right === p) {
	            pp.right = z
	          } else {
	            pp.left = z
	          }
	        }
	        stack[i-1] = z
	        return
	      }
	      if(s._color === BLACK) {
	        if(p._color === RED) {
	          //console.log("case 2: black sibling, red parent")
	          p._color = BLACK
	          p.left = repaint(RED, s)
	          return
	        } else {
	          //console.log("case 2: black sibling, black parent")
	          p.left = repaint(RED, s)
	          continue  
	        }
	      } else {
	        //console.log("case 3: red sibling")
	        s = cloneNode(s)
	        p.left = s.right
	        s.right = p
	        s._color = p._color
	        p._color = RED
	        recount(p)
	        recount(s)
	        if(i > 1) {
	          var pp = stack[i-2]
	          if(pp.right === p) {
	            pp.right = s
	          } else {
	            pp.left = s
	          }
	        }
	        stack[i-1] = s
	        stack[i] = p
	        if(i+1 < stack.length) {
	          stack[i+1] = n
	        } else {
	          stack.push(n)
	        }
	        i = i+2
	      }
	    }
	  }
	}
	
	//Removes item at iterator from tree
	iproto.remove = function() {
	  var stack = this._stack
	  if(stack.length === 0) {
	    return this.tree
	  }
	  //First copy path to node
	  var cstack = new Array(stack.length)
	  var n = stack[stack.length-1]
	  cstack[cstack.length-1] = new RBNode(n._color, n.key, n.value, n.left, n.right, n._count)
	  for(var i=stack.length-2; i>=0; --i) {
	    var n = stack[i]
	    if(n.left === stack[i+1]) {
	      cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count)
	    } else {
	      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
	    }
	  }
	
	  //Get node
	  n = cstack[cstack.length-1]
	  //console.log("start remove: ", n.value)
	
	  //If not leaf, then swap with previous node
	  if(n.left && n.right) {
	    //console.log("moving to leaf")
	
	    //First walk to previous leaf
	    var split = cstack.length
	    n = n.left
	    while(n.right) {
	      cstack.push(n)
	      n = n.right
	    }
	    //Copy path to leaf
	    var v = cstack[split-1]
	    cstack.push(new RBNode(n._color, v.key, v.value, n.left, n.right, n._count))
	    cstack[split-1].key = n.key
	    cstack[split-1].value = n.value
	
	    //Fix up stack
	    for(var i=cstack.length-2; i>=split; --i) {
	      n = cstack[i]
	      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
	    }
	    cstack[split-1].left = cstack[split]
	  }
	  //console.log("stack=", cstack.map(function(v) { return v.value }))
	
	  //Remove leaf node
	  n = cstack[cstack.length-1]
	  if(n._color === RED) {
	    //Easy case: removing red leaf
	    //console.log("RED leaf")
	    var p = cstack[cstack.length-2]
	    if(p.left === n) {
	      p.left = null
	    } else if(p.right === n) {
	      p.right = null
	    }
	    cstack.pop()
	    for(var i=0; i<cstack.length; ++i) {
	      cstack[i]._count--
	    }
	    return new RedBlackTree(this.tree._compare, cstack[0])
	  } else {
	    if(n.left || n.right) {
	      //Second easy case:  Single child black parent
	      //console.log("BLACK single child")
	      if(n.left) {
	        swapNode(n, n.left)
	      } else if(n.right) {
	        swapNode(n, n.right)
	      }
	      //Child must be red, so repaint it black to balance color
	      n._color = BLACK
	      for(var i=0; i<cstack.length-1; ++i) {
	        cstack[i]._count--
	      }
	      return new RedBlackTree(this.tree._compare, cstack[0])
	    } else if(cstack.length === 1) {
	      //Third easy case: root
	      //console.log("ROOT")
	      return new RedBlackTree(this.tree._compare, null)
	    } else {
	      //Hard case: Repaint n, and then do some nasty stuff
	      //console.log("BLACK leaf no children")
	      for(var i=0; i<cstack.length; ++i) {
	        cstack[i]._count--
	      }
	      var parent = cstack[cstack.length-2]
	      fixDoubleBlack(cstack)
	      //Fix up links
	      if(parent.left === n) {
	        parent.left = null
	      } else {
	        parent.right = null
	      }
	    }
	  }
	  return new RedBlackTree(this.tree._compare, cstack[0])
	}
	
	//Returns key
	Object.defineProperty(iproto, "key", {
	  get: function() {
	    if(this._stack.length > 0) {
	      return this._stack[this._stack.length-1].key
	    }
	    return
	  },
	  enumerable: true
	})
	
	//Returns value
	Object.defineProperty(iproto, "value", {
	  get: function() {
	    if(this._stack.length > 0) {
	      return this._stack[this._stack.length-1].value
	    }
	    return
	  },
	  enumerable: true
	})
	
	
	//Returns the position of this iterator in the sorted list
	Object.defineProperty(iproto, "index", {
	  get: function() {
	    var idx = 0
	    var stack = this._stack
	    if(stack.length === 0) {
	      var r = this.tree.root
	      if(r) {
	        return r._count
	      }
	      return 0
	    } else if(stack[stack.length-1].left) {
	      idx = stack[stack.length-1].left._count
	    }
	    for(var s=stack.length-2; s>=0; --s) {
	      if(stack[s+1] === stack[s].right) {
	        ++idx
	        if(stack[s].left) {
	          idx += stack[s].left._count
	        }
	      }
	    }
	    return idx
	  },
	  enumerable: true
	})
	
	//Advances iterator to next element in list
	iproto.next = function() {
	  var stack = this._stack
	  if(stack.length === 0) {
	    return
	  }
	  var n = stack[stack.length-1]
	  if(n.right) {
	    n = n.right
	    while(n) {
	      stack.push(n)
	      n = n.left
	    }
	  } else {
	    stack.pop()
	    while(stack.length > 0 && stack[stack.length-1].right === n) {
	      n = stack[stack.length-1]
	      stack.pop()
	    }
	  }
	}
	
	//Checks if iterator is at end of tree
	Object.defineProperty(iproto, "hasNext", {
	  get: function() {
	    var stack = this._stack
	    if(stack.length === 0) {
	      return false
	    }
	    if(stack[stack.length-1].right) {
	      return true
	    }
	    for(var s=stack.length-1; s>0; --s) {
	      if(stack[s-1].left === stack[s]) {
	        return true
	      }
	    }
	    return false
	  }
	})
	
	//Update value
	iproto.update = function(value) {
	  var stack = this._stack
	  if(stack.length === 0) {
	    throw new Error("Can't update empty node!")
	  }
	  var cstack = new Array(stack.length)
	  var n = stack[stack.length-1]
	  cstack[cstack.length-1] = new RBNode(n._color, n.key, value, n.left, n.right, n._count)
	  for(var i=stack.length-2; i>=0; --i) {
	    n = stack[i]
	    if(n.left === stack[i+1]) {
	      cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count)
	    } else {
	      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
	    }
	  }
	  return new RedBlackTree(this.tree._compare, cstack[0])
	}
	
	//Moves iterator backward one element
	iproto.prev = function() {
	  var stack = this._stack
	  if(stack.length === 0) {
	    return
	  }
	  var n = stack[stack.length-1]
	  if(n.left) {
	    n = n.left
	    while(n) {
	      stack.push(n)
	      n = n.right
	    }
	  } else {
	    stack.pop()
	    while(stack.length > 0 && stack[stack.length-1].left === n) {
	      n = stack[stack.length-1]
	      stack.pop()
	    }
	  }
	}
	
	//Checks if iterator is at start of tree
	Object.defineProperty(iproto, "hasPrev", {
	  get: function() {
	    var stack = this._stack
	    if(stack.length === 0) {
	      return false
	    }
	    if(stack[stack.length-1].left) {
	      return true
	    }
	    for(var s=stack.length-1; s>0; --s) {
	      if(stack[s-1].right === stack[s]) {
	        return true
	      }
	    }
	    return false
	  }
	})
	
	//Default comparison function
	function defaultCompare(a, b) {
	  if(a < b) {
	    return -1
	  }
	  if(a > b) {
	    return 1
	  }
	  return 0
	}
	
	//Build a tree
	function createRBTree(compare) {
	  return new RedBlackTree(compare || defaultCompare, null)
	}
	},{}],233:[function(_dereq_,module,exports){
	// transliterated from the python snippet here:
	// http://en.wikipedia.org/wiki/Lanczos_approximation
	
	var g = 7;
	var p = [
	    0.99999999999980993,
	    676.5203681218851,
	    -1259.1392167224028,
	    771.32342877765313,
	    -176.61502916214059,
	    12.507343278686905,
	    -0.13857109526572012,
	    9.9843695780195716e-6,
	    1.5056327351493116e-7
	];
	
	var g_ln = 607/128;
	var p_ln = [
	    0.99999999999999709182,
	    57.156235665862923517,
	    -59.597960355475491248,
	    14.136097974741747174,
	    -0.49191381609762019978,
	    0.33994649984811888699e-4,
	    0.46523628927048575665e-4,
	    -0.98374475304879564677e-4,
	    0.15808870322491248884e-3,
	    -0.21026444172410488319e-3,
	    0.21743961811521264320e-3,
	    -0.16431810653676389022e-3,
	    0.84418223983852743293e-4,
	    -0.26190838401581408670e-4,
	    0.36899182659531622704e-5
	];
	
	// Spouge approximation (suitable for large arguments)
	function lngamma(z) {
	
	    if(z < 0) return Number('0/0');
	    var x = p_ln[0];
	    for(var i = p_ln.length - 1; i > 0; --i) x += p_ln[i] / (z + i);
	    var t = z + g_ln + 0.5;
	    return .5*Math.log(2*Math.PI)+(z+.5)*Math.log(t)-t+Math.log(x)-Math.log(z);
	}
	
	module.exports = function gamma (z) {
	    if (z < 0.5) {
	        return Math.PI / (Math.sin(Math.PI * z) * gamma(1 - z));
	    }
	    else if(z > 100) return Math.exp(lngamma(z));
	    else {
	        z -= 1;
	        var x = p[0];
	        for (var i = 1; i < g + 2; i++) {
	            x += p[i] / (z + i);
	        }
	        var t = z + g + 0.5;
	
	        return Math.sqrt(2 * Math.PI)
	            * Math.pow(t, z + 0.5)
	            * Math.exp(-t)
	            * x
	        ;
	    }
	};
	
	module.exports.log = lngamma;
	
	},{}],234:[function(_dereq_,module,exports){
	module.exports = getCanvasContext
	function getCanvasContext (type, opts) {
	  if (typeof type !== 'string') {
	    throw new TypeError('must specify type string')
	  }
	
	  opts = opts || {}
	
	  if (typeof document === 'undefined' && !opts.canvas) {
	    return null // check for Node
	  }
	
	  var canvas = opts.canvas || document.createElement('canvas')
	  if (typeof opts.width === 'number') {
	    canvas.width = opts.width
	  }
	  if (typeof opts.height === 'number') {
	    canvas.height = opts.height
	  }
	
	  var attribs = opts
	  var gl
	  try {
	    var names = [ type ]
	    // prefix GL contexts
	    if (type.indexOf('webgl') === 0) {
	      names.push('experimental-' + type)
	    }
	
	    for (var i = 0; i < names.length; i++) {
	      gl = canvas.getContext(names[i], attribs)
	      if (gl) return gl
	    }
	  } catch (e) {
	    gl = null
	  }
	  return (gl || null) // ensure null on fail
	}
	
	},{}],235:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createAxes
	
	var createText        = _dereq_('./lib/text.js')
	var createLines       = _dereq_('./lib/lines.js')
	var createBackground  = _dereq_('./lib/background.js')
	var getCubeProperties = _dereq_('./lib/cube.js')
	var Ticks             = _dereq_('./lib/ticks.js')
	
	var identity = new Float32Array([
	  1, 0, 0, 0,
	  0, 1, 0, 0,
	  0, 0, 1, 0,
	  0, 0, 0, 1])
	
	function copyVec3(a, b) {
	  a[0] = b[0]
	  a[1] = b[1]
	  a[2] = b[2]
	  return a
	}
	
	function Axes(gl) {
	  this.gl             = gl
	
	  this.pixelRatio     = 1
	
	  this.bounds         = [ [-10, -10, -10],
	                          [ 10,  10,  10] ]
	  this.ticks          = [ [], [], [] ]
	  this.autoTicks      = true
	  this.tickSpacing    = [ 1, 1, 1 ]
	
	  this.tickEnable     = [ true, true, true ]
	  this.tickFont       = [ 'sans-serif', 'sans-serif', 'sans-serif' ]
	  this.tickSize       = [ 12, 12, 12 ]
	  this.tickAngle      = [ 0, 0, 0 ]
	  this.tickAlign      = [ 'auto', 'auto', 'auto' ]
	  this.tickColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	  this.tickPad        = [ 10, 10, 10 ]
	
	  this.lastCubeProps  = {
	    cubeEdges: [0,0,0],
	    axis:      [0,0,0]
	  }
	
	  this.labels         = [ 'x', 'y', 'z' ]
	  this.labelEnable    = [ true, true, true ]
	  this.labelFont      = 'sans-serif'
	  this.labelSize      = [ 20, 20, 20 ]
	  this.labelAngle     = [ 0, 0, 0 ]
	  this.labelAlign     = [ 'auto', 'auto', 'auto' ]
	  this.labelColor     = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	  this.labelPad       = [ 10, 10, 10 ]
	
	  this.lineEnable     = [ true, true, true ]
	  this.lineMirror     = [ false, false, false ]
	  this.lineWidth      = [ 1, 1, 1 ]
	  this.lineColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	
	  this.lineTickEnable = [ true, true, true ]
	  this.lineTickMirror = [ false, false, false ]
	  this.lineTickLength = [ 0, 0, 0 ]
	  this.lineTickWidth  = [ 1, 1, 1 ]
	  this.lineTickColor  = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	
	  this.gridEnable     = [ true, true, true ]
	  this.gridWidth      = [ 1, 1, 1 ]
	  this.gridColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	
	  this.zeroEnable     = [ true, true, true ]
	  this.zeroLineColor  = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
	  this.zeroLineWidth  = [ 2, 2, 2 ]
	
	  this.backgroundEnable = [ false, false, false ]
	  this.backgroundColor  = [ [0.8, 0.8, 0.8, 0.5],
	                            [0.8, 0.8, 0.8, 0.5],
	                            [0.8, 0.8, 0.8, 0.5] ]
	
	  this._firstInit = true
	  this._text  = null
	  this._lines = null
	  this._background = createBackground(gl)
	}
	
	var proto = Axes.prototype
	
	proto.update = function(options) {
	  options = options || {}
	
	  //Option parsing helper functions
	  function parseOption(nest, cons, name) {
	    if(name in options) {
	      var opt = options[name]
	      var prev = this[name]
	      var next
	      if(nest ? (Array.isArray(opt) && Array.isArray(opt[0])) :
	                 Array.isArray(opt) ) {
	        this[name] = next = [ cons(opt[0]), cons(opt[1]), cons(opt[2]) ]
	      } else {
	        this[name] = next = [ cons(opt), cons(opt), cons(opt) ]
	      }
	      for(var i=0; i<3; ++i) {
	        if(next[i] !== prev[i]) {
	          return true
	        }
	      }
	    }
	    return false
	  }
	
	  var NUMBER  = parseOption.bind(this, false, Number)
	  var BOOLEAN = parseOption.bind(this, false, Boolean)
	  var STRING  = parseOption.bind(this, false, String)
	  var COLOR   = parseOption.bind(this, true, function(v) {
	    if(Array.isArray(v)) {
	      if(v.length === 3) {
	        return [ +v[0], +v[1], +v[2], 1.0 ]
	      } else if(v.length === 4) {
	        return [ +v[0], +v[1], +v[2], +v[3] ]
	      }
	    }
	    return [ 0, 0, 0, 1 ]
	  })
	
	  //Tick marks and bounds
	  var nextTicks
	  var ticksUpdate   = false
	  var boundsChanged = false
	  if('bounds' in options) {
	    var bounds = options.bounds
	i_loop:
	    for(var i=0; i<2; ++i) {
	      for(var j=0; j<3; ++j) {
	        if(bounds[i][j] !== this.bounds[i][j]) {
	          boundsChanged = true
	        }
	        this.bounds[i][j] = bounds[i][j]
	      }
	    }
	  }
	  if('ticks' in options) {
	    nextTicks      = options.ticks
	    ticksUpdate    = true
	    this.autoTicks = false
	    for(var i=0; i<3; ++i) {
	      this.tickSpacing[i] = 0.0
	    }
	  } else if(NUMBER('tickSpacing')) {
	    this.autoTicks  = true
	    boundsChanged   = true
	  }
	
	  if(this._firstInit) {
	    if(!('ticks' in options || 'tickSpacing' in options)) {
	      this.autoTicks = true
	    }
	
	    //Force tick recomputation on first update
	    boundsChanged   = true
	    ticksUpdate     = true
	    this._firstInit = false
	  }
	
	  if(boundsChanged && this.autoTicks) {
	    nextTicks = Ticks.create(this.bounds, this.tickSpacing)
	    ticksUpdate = true
	  }
	
	  //Compare next ticks to previous ticks, only update if needed
	  if(ticksUpdate) {
	    for(var i=0; i<3; ++i) {
	      nextTicks[i].sort(function(a,b) {
	        return a.x-b.x
	      })
	    }
	    if(Ticks.equal(nextTicks, this.ticks)) {
	      ticksUpdate = false
	    } else {
	      this.ticks = nextTicks
	    }
	  }
	
	  //Parse tick properties
	  BOOLEAN('tickEnable')
	  if(STRING('tickFont')) {
	    ticksUpdate = true  //If font changes, must rebuild vbo
	  }
	  NUMBER('tickSize')
	  NUMBER('tickAngle')
	  NUMBER('tickPad')
	  COLOR('tickColor')
	
	  //Axis labels
	  var labelUpdate = STRING('labels')
	  if(STRING('labelFont')) {
	    labelUpdate = true
	  }
	  BOOLEAN('labelEnable')
	  NUMBER('labelSize')
	  NUMBER('labelPad')
	  COLOR('labelColor')
	
	  //Axis lines
	  BOOLEAN('lineEnable')
	  BOOLEAN('lineMirror')
	  NUMBER('lineWidth')
	  COLOR('lineColor')
	
	  //Axis line ticks
	  BOOLEAN('lineTickEnable')
	  BOOLEAN('lineTickMirror')
	  NUMBER('lineTickLength')
	  NUMBER('lineTickWidth')
	  COLOR('lineTickColor')
	
	  //Grid lines
	  BOOLEAN('gridEnable')
	  NUMBER('gridWidth')
	  COLOR('gridColor')
	
	  //Zero line
	  BOOLEAN('zeroEnable')
	  COLOR('zeroLineColor')
	  NUMBER('zeroLineWidth')
	
	  //Background
	  BOOLEAN('backgroundEnable')
	  COLOR('backgroundColor')
	
	  //Update text if necessary
	  if(!this._text) {
	    this._text = createText(
	      this.gl,
	      this.bounds,
	      this.labels,
	      this.labelFont,
	      this.ticks,
	      this.tickFont)
	  } else if(this._text && (labelUpdate || ticksUpdate)) {
	    this._text.update(
	      this.bounds,
	      this.labels,
	      this.labelFont,
	      this.ticks,
	      this.tickFont)
	  }
	
	  //Update lines if necessary
	  if(this._lines && ticksUpdate) {
	    this._lines.dispose()
	    this._lines = null
	  }
	  if(!this._lines) {
	    this._lines = createLines(this.gl, this.bounds, this.ticks)
	  }
	}
	
	function OffsetInfo() {
	  this.primalOffset = [0,0,0]
	  this.primalMinor  = [0,0,0]
	  this.mirrorOffset = [0,0,0]
	  this.mirrorMinor  = [0,0,0]
	}
	
	var LINE_OFFSET = [ new OffsetInfo(), new OffsetInfo(), new OffsetInfo() ]
	
	function computeLineOffset(result, i, bounds, cubeEdges, cubeAxis) {
	  var primalOffset = result.primalOffset
	  var primalMinor  = result.primalMinor
	  var dualOffset   = result.mirrorOffset
	  var dualMinor    = result.mirrorMinor
	  var e = cubeEdges[i]
	
	  //Calculate offsets
	  for(var j=0; j<3; ++j) {
	    if(i === j) {
	      continue
	    }
	    var a = primalOffset,
	        b = dualOffset,
	        c = primalMinor,
	        d = dualMinor
	    if(e & (1<<j)) {
	      a = dualOffset
	      b = primalOffset
	      c = dualMinor
	      d = primalMinor
	    }
	    a[j] = bounds[0][j]
	    b[j] = bounds[1][j]
	    if(cubeAxis[j] > 0) {
	      c[j] = -1
	      d[j] = 0
	    } else {
	      c[j] = 0
	      d[j] = +1
	    }
	  }
	}
	
	var CUBE_ENABLE = [0,0,0]
	var DEFAULT_PARAMS = {
	  model:      identity,
	  view:       identity,
	  projection: identity,
	  _ortho:      false
	}
	
	proto.isOpaque = function() {
	  return true
	}
	
	proto.isTransparent = function() {
	  return false
	}
	
	proto.drawTransparent = function(params) {}
	
	var ALIGN_OPTION_AUTO = 0 // i.e. as defined in the shader the text would rotate to stay upwards range: [-90,90]
	
	var PRIMAL_MINOR  = [0,0,0]
	var MIRROR_MINOR  = [0,0,0]
	var PRIMAL_OFFSET = [0,0,0]
	
	proto.draw = function(params) {
	  params = params || DEFAULT_PARAMS
	
	  var gl = this.gl
	
	  //Geometry for camera and axes
	  var model       = params.model || identity
	  var view        = params.view || identity
	  var projection  = params.projection || identity
	  var bounds      = this.bounds
	  var isOrtho     = params._ortho || false
	
	  //Unpack axis info
	  var cubeParams  = getCubeProperties(model, view, projection, bounds, isOrtho)
	  var cubeEdges   = cubeParams.cubeEdges
	  var cubeAxis    = cubeParams.axis
	
	  var cx = view[12]
	  var cy = view[13]
	  var cz = view[14]
	  var cw = view[15]
	
	  var orthoFix = (isOrtho) ? 2 : 1 // double up padding for orthographic ticks & labels
	  var pixelScaleF = orthoFix * this.pixelRatio * (projection[3]*cx + projection[7]*cy + projection[11]*cz + projection[15]*cw) / gl.drawingBufferHeight
	
	  for(var i=0; i<3; ++i) {
	    this.lastCubeProps.cubeEdges[i] = cubeEdges[i]
	    this.lastCubeProps.axis[i] = cubeAxis[i]
	  }
	
	  //Compute axis info
	  var lineOffset  = LINE_OFFSET
	  for(var i=0; i<3; ++i) {
	    computeLineOffset(
	      LINE_OFFSET[i],
	      i,
	      this.bounds,
	      cubeEdges,
	      cubeAxis)
	  }
	
	  //Set up state parameters
	  var gl = this.gl
	
	  //Draw background first
	  var cubeEnable = CUBE_ENABLE
	  for(var i=0; i<3; ++i) {
	    if(this.backgroundEnable[i]) {
	      cubeEnable[i] = cubeAxis[i]
	    } else {
	      cubeEnable[i] = 0
	    }
	  }
	
	  this._background.draw(
	    model,
	    view,
	    projection,
	    bounds,
	    cubeEnable,
	    this.backgroundColor)
	
	  //Draw lines
	  this._lines.bind(
	    model,
	    view,
	    projection,
	    this)
	
	  //First draw grid lines and zero lines
	  for(var i=0; i<3; ++i) {
	    var x = [0,0,0]
	    if(cubeAxis[i] > 0) {
	      x[i] = bounds[1][i]
	    } else {
	      x[i] = bounds[0][i]
	    }
	
	    //Draw grid lines
	    for(var j=0; j<2; ++j) {
	      var u = (i + 1 + j) % 3
	      var v = (i + 1 + (j^1)) % 3
	      if(this.gridEnable[u]) {
	        this._lines.drawGrid(u, v, this.bounds, x, this.gridColor[u], this.gridWidth[u]*this.pixelRatio)
	      }
	    }
	
	    //Draw zero lines (need to do this AFTER all grid lines are drawn)
	    for(var j=0; j<2; ++j) {
	      var u = (i + 1 + j) % 3
	      var v = (i + 1 + (j^1)) % 3
	      if(this.zeroEnable[v]) {
	        //Check if zero line in bounds
	        if(Math.min(bounds[0][v], bounds[1][v]) <= 0 && Math.max(bounds[0][v], bounds[1][v]) >= 0) {
	          this._lines.drawZero(u, v, this.bounds, x, this.zeroLineColor[v], this.zeroLineWidth[v]*this.pixelRatio)
	        }
	      }
	    }
	  }
	
	  //Then draw axis lines and tick marks
	  for(var i=0; i<3; ++i) {
	
	    //Draw axis lines
	    if(this.lineEnable[i]) {
	      this._lines.drawAxisLine(i, this.bounds, lineOffset[i].primalOffset, this.lineColor[i], this.lineWidth[i]*this.pixelRatio)
	    }
	    if(this.lineMirror[i]) {
	      this._lines.drawAxisLine(i, this.bounds, lineOffset[i].mirrorOffset, this.lineColor[i], this.lineWidth[i]*this.pixelRatio)
	    }
	
	    //Compute minor axes
	    var primalMinor = copyVec3(PRIMAL_MINOR, lineOffset[i].primalMinor)
	    var mirrorMinor = copyVec3(MIRROR_MINOR, lineOffset[i].mirrorMinor)
	    var tickLength  = this.lineTickLength
	    for(var j=0; j<3; ++j) {
	      var scaleFactor = pixelScaleF / model[5*j]
	      primalMinor[j] *= tickLength[j] * scaleFactor
	      mirrorMinor[j] *= tickLength[j] * scaleFactor
	    }
	
	
	
	    //Draw axis line ticks
	    if(this.lineTickEnable[i]) {
	      this._lines.drawAxisTicks(i, lineOffset[i].primalOffset, primalMinor, this.lineTickColor[i], this.lineTickWidth[i]*this.pixelRatio)
	    }
	    if(this.lineTickMirror[i]) {
	      this._lines.drawAxisTicks(i, lineOffset[i].mirrorOffset, mirrorMinor, this.lineTickColor[i], this.lineTickWidth[i]*this.pixelRatio)
	    }
	  }
	  this._lines.unbind()
	
	  //Draw text sprites
	  this._text.bind(
	    model,
	    view,
	    projection,
	    this.pixelRatio)
	
	  var alignOpt // options in shader are from this list {-1, 0, 1, 2, 3, ..., n}
	  // -1: backward compatible
	  //  0: raw data
	  //  1: auto align, free angles
	  //  2: auto align, horizontal or vertical
	  //3-n: auto align, round to n directions e.g. 12 -> round to angles with 30-degree steps
	
	  var hv_ratio = 0.5 // can have an effect on the ratio between horizontals and verticals when using option 2
	
	  var enableAlign
	  var alignDir
	
	  function alignTo(i) {
	    alignDir = [0,0,0]
	    alignDir[i] = 1
	  }
	
	  function solveTickAlignments(i, minor, major) {
	
	    var i1 = (i + 1) % 3
	    var i2 = (i + 2) % 3
	
	    var A = minor[i1]
	    var B = minor[i2]
	    var C = major[i1]
	    var D = major[i2]
	
	         if ((A > 0) && (D > 0)) { alignTo(i1); return; }
	    else if ((A > 0) && (D < 0)) { alignTo(i1); return; }
	    else if ((A < 0) && (D > 0)) { alignTo(i1); return; }
	    else if ((A < 0) && (D < 0)) { alignTo(i1); return; }
	    else if ((B > 0) && (C > 0)) { alignTo(i2); return; }
	    else if ((B > 0) && (C < 0)) { alignTo(i2); return; }
	    else if ((B < 0) && (C > 0)) { alignTo(i2); return; }
	    else if ((B < 0) && (C < 0)) { alignTo(i2); return; }
	  }
	
	  for(var i=0; i<3; ++i) {
	
	    var minor      = lineOffset[i].primalMinor
	    var major      = lineOffset[i].mirrorMinor
	
	    var offset     = copyVec3(PRIMAL_OFFSET, lineOffset[i].primalOffset)
	
	    for(var j=0; j<3; ++j) {
	      if(this.lineTickEnable[i]) {
	        offset[j] += pixelScaleF * minor[j] * Math.max(this.lineTickLength[j], 0)  / model[5*j]
	      }
	    }
	
	    var axis = [0,0,0]
	    axis[i] = 1
	
	    //Draw tick text
	    if(this.tickEnable[i]) {
	
	      if(this.tickAngle[i] === -3600) {
	        this.tickAngle[i] = 0
	        this.tickAlign[i] = 'auto'
	      } else {
	        this.tickAlign[i] = -1
	      }
	
	      enableAlign = 1;
	
	      alignOpt = [this.tickAlign[i], hv_ratio, enableAlign]
	      if(alignOpt[0] === 'auto') alignOpt[0] = ALIGN_OPTION_AUTO
	      else alignOpt[0] = parseInt('' + alignOpt[0])
	
	      alignDir = [0,0,0]
	      solveTickAlignments(i, minor, major)
	
	      //Add tick padding
	      for(var j=0; j<3; ++j) {
	        offset[j] += pixelScaleF * minor[j] * this.tickPad[j] / model[5*j]
	      }
	
	      //Draw axis
	      this._text.drawTicks(
	        i,
	        this.tickSize[i],
	        this.tickAngle[i],
	        offset,
	        this.tickColor[i],
	        axis,
	        alignDir,
	        alignOpt)
	    }
	
	    //Draw labels
	    if(this.labelEnable[i]) {
	
	      enableAlign = 0
	      alignDir = [0,0,0]
	      if(this.labels[i].length > 4) { // for large label axis enable alignDir to axis
	        alignTo(i)
	        enableAlign = 1
	      }
	
	      alignOpt = [this.labelAlign[i], hv_ratio, enableAlign]
	      if(alignOpt[0] === 'auto') alignOpt[0] = ALIGN_OPTION_AUTO
	      else alignOpt[0] = parseInt('' + alignOpt[0])
	
	      //Add label padding
	      for(var j=0; j<3; ++j) {
	        offset[j] += pixelScaleF * minor[j] * this.labelPad[j] / model[5*j]
	      }
	      offset[i] += 0.5 * (bounds[0][i] + bounds[1][i])
	
	      //Draw axis
	      this._text.drawLabel(
	        i,
	        this.labelSize[i],
	        this.labelAngle[i],
	        offset,
	        this.labelColor[i],
	        [0,0,0],
	        alignDir,
	        alignOpt)
	    }
	  }
	
	  this._text.unbind()
	}
	
	proto.dispose = function() {
	  this._text.dispose()
	  this._lines.dispose()
	  this._background.dispose()
	  this._lines = null
	  this._text = null
	  this._background = null
	  this.gl = null
	}
	
	function createAxes(gl, options) {
	  var axes = new Axes(gl)
	  axes.update(options)
	  return axes
	}
	
	},{"./lib/background.js":236,"./lib/cube.js":237,"./lib/lines.js":238,"./lib/text.js":240,"./lib/ticks.js":241}],236:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createBackgroundCube
	
	var createBuffer = _dereq_('gl-buffer')
	var createVAO    = _dereq_('gl-vao')
	var createShader = _dereq_('./shaders').bg
	
	function BackgroundCube(gl, buffer, vao, shader) {
	  this.gl = gl
	  this.buffer = buffer
	  this.vao = vao
	  this.shader = shader
	}
	
	var proto = BackgroundCube.prototype
	
	proto.draw = function(model, view, projection, bounds, enable, colors) {
	  var needsBG = false
	  for(var i=0; i<3; ++i) {
	    needsBG = needsBG || enable[i]
	  }
	  if(!needsBG) {
	    return
	  }
	
	  var gl = this.gl
	
	  gl.enable(gl.POLYGON_OFFSET_FILL)
	  gl.polygonOffset(1, 2)
	
	  this.shader.bind()
	  this.shader.uniforms = {
	    model: model,
	    view: view,
	    projection: projection,
	    bounds: bounds,
	    enable: enable,
	    colors: colors
	  }
	  this.vao.bind()
	  this.vao.draw(this.gl.TRIANGLES, 36)
	  this.vao.unbind()
	
	  gl.disable(gl.POLYGON_OFFSET_FILL)
	}
	
	proto.dispose = function() {
	  this.vao.dispose()
	  this.buffer.dispose()
	  this.shader.dispose()
	}
	
	function createBackgroundCube(gl) {
	  //Create cube vertices
	  var vertices = []
	  var indices  = []
	  var ptr = 0
	  for(var d=0; d<3; ++d) {
	    var u = (d+1) % 3
	    var v = (d+2) % 3
	    var x = [0,0,0]
	    var c = [0,0,0]
	    for(var s=-1; s<=1; s+=2) {
	      indices.push(ptr,   ptr+2, ptr+1,
	                   ptr+1, ptr+2, ptr+3)
	      x[d] = s
	      c[d] = s
	      for(var i=-1; i<=1; i+=2) {
	        x[u] = i
	        for(var j=-1; j<=1; j+=2) {
	          x[v] = j
	          vertices.push(x[0], x[1], x[2],
	                        c[0], c[1], c[2])
	          ptr += 1
	        }
	      }
	      //Swap u and v
	      var tt = u
	      u = v
	      v = tt
	    }
	  }
	
	  //Allocate buffer and vertex array
	  var buffer = createBuffer(gl, new Float32Array(vertices))
	  var elements = createBuffer(gl, new Uint16Array(indices), gl.ELEMENT_ARRAY_BUFFER)
	  var vao = createVAO(gl, [
	      {
	        buffer: buffer,
	        type: gl.FLOAT,
	        size: 3,
	        offset: 0,
	        stride: 24
	      },
	      {
	        buffer: buffer,
	        type: gl.FLOAT,
	        size: 3,
	        offset: 12,
	        stride: 24
	      }
	    ], elements)
	
	  //Create shader object
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	  shader.attributes.normal.location = 1
	
	  return new BackgroundCube(gl, buffer, vao, shader)
	}
	
	},{"./shaders":239,"gl-buffer":243,"gl-vao":328}],237:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = getCubeEdges
	
	var bits      = _dereq_('bit-twiddle')
	var multiply  = _dereq_('gl-mat4/multiply')
	var splitPoly = _dereq_('split-polygon')
	var orient    = _dereq_('robust-orientation')
	
	var mvp        = new Array(16)
	var pCubeVerts = new Array(8)
	var cubeVerts  = new Array(8)
	var x          = new Array(3)
	var zero3      = [0,0,0]
	
	;(function() {
	  for(var i=0; i<8; ++i) {
	    pCubeVerts[i] =[1,1,1,1]
	    cubeVerts[i] = [1,1,1]
	  }
	})()
	
	
	function transformHg(result, x, mat) {
	  for(var i=0; i<4; ++i) {
	    result[i] = mat[12+i]
	    for(var j=0; j<3; ++j) {
	      result[i] += x[j]*mat[4*j+i]
	    }
	  }
	}
	
	var FRUSTUM_PLANES = [
	  [ 0, 0, 1, 0, 0],
	  [ 0, 0,-1, 1, 0],
	  [ 0,-1, 0, 1, 0],
	  [ 0, 1, 0, 1, 0],
	  [-1, 0, 0, 1, 0],
	  [ 1, 0, 0, 1, 0]
	]
	
	function polygonArea(p) {
	  for(var i=0; i<FRUSTUM_PLANES.length; ++i) {
	    p = splitPoly.positive(p, FRUSTUM_PLANES[i])
	    if(p.length < 3) {
	      return 0
	    }
	  }
	
	  var base = p[0]
	  var ax = base[0] / base[3]
	  var ay = base[1] / base[3]
	  var area = 0.0
	  for(var i=1; i+1<p.length; ++i) {
	    var b = p[i]
	    var c = p[i+1]
	
	    var bx = b[0]/b[3]
	    var by = b[1]/b[3]
	    var cx = c[0]/c[3]
	    var cy = c[1]/c[3]
	
	    var ux = bx - ax
	    var uy = by - ay
	
	    var vx = cx - ax
	    var vy = cy - ay
	
	    area += Math.abs(ux * vy - uy * vx)
	  }
	
	  return area
	}
	
	var CUBE_EDGES = [1,1,1]
	var CUBE_AXIS  = [0,0,0]
	var CUBE_RESULT = {
	  cubeEdges: CUBE_EDGES,
	  axis: CUBE_AXIS
	}
	
	function getCubeEdges(model, view, projection, bounds, ortho) {
	
	  //Concatenate matrices
	  multiply(mvp, view, model)
	  multiply(mvp, projection, mvp)
	
	  //First project cube vertices
	  var ptr = 0
	  for(var i=0; i<2; ++i) {
	    x[2] = bounds[i][2]
	    for(var j=0; j<2; ++j) {
	      x[1] = bounds[j][1]
	      for(var k=0; k<2; ++k) {
	        x[0] = bounds[k][0]
	        transformHg(pCubeVerts[ptr], x, mvp)
	        ptr += 1
	      }
	    }
	  }
	
	  //Classify camera against cube faces
	  var closest = -1
	
	  for(var i=0; i<8; ++i) {
	    var w = pCubeVerts[i][3]
	    for(var l=0; l<3; ++l) {
	      cubeVerts[i][l] = pCubeVerts[i][l] / w
	    }
	
	    if(ortho) cubeVerts[i][2] *= -1;
	
	    if(w < 0) {
	      if(closest < 0) {
	        closest = i
	      } else if(cubeVerts[i][2] < cubeVerts[closest][2]) {
	        closest = i
	      }
	    }
	  }
	
	  if(closest < 0) {
	    closest = 0
	    for(var d=0; d<3; ++d) {
	      var u = (d+2) % 3
	      var v = (d+1) % 3
	      var o0 = -1
	      var o1 = -1
	      for(var s=0; s<2; ++s) {
	        var f0 = (s<<d)
	        var f1 = f0 + (s << u) + ((1-s) << v)
	        var f2 = f0 + ((1-s) << u) + (s << v)
	        if(orient(cubeVerts[f0], cubeVerts[f1], cubeVerts[f2], zero3) < 0) {
	          continue
	        }
	        if(s) {
	          o0 = 1
	        } else {
	          o1 = 1
	        }
	      }
	      if(o0 < 0 || o1 < 0) {
	        if(o1 > o0) {
	          closest |= 1<<d
	        }
	        continue
	      }
	      for(var s=0; s<2; ++s) {
	        var f0 = (s<<d)
	        var f1 = f0 + (s << u) + ((1-s) << v)
	        var f2 = f0 + ((1-s) << u) + (s << v)
	        var o = polygonArea([
	            pCubeVerts[f0],
	            pCubeVerts[f1],
	            pCubeVerts[f2],
	            pCubeVerts[f0+(1<<u)+(1<<v)]])
	        if(s) {
	          o0 = o
	        } else {
	          o1 = o
	        }
	      }
	      if(o1 > o0) {
	        closest |= 1<<d
	        continue
	      }
	    }
	  }
	
	  var farthest = 7^closest
	
	  //Find lowest vertex which is not closest closest
	  var bottom = -1
	  for(var i=0; i<8; ++i) {
	    if(i === closest || i === farthest) {
	      continue
	    }
	    if(bottom < 0) {
	      bottom = i
	    } else if(cubeVerts[bottom][1] > cubeVerts[i][1]) {
	      bottom = i
	    }
	  }
	
	  //Find left/right neighbors of bottom vertex
	  var left = -1
	  for(var i=0; i<3; ++i) {
	    var idx = bottom ^ (1<<i)
	    if(idx === closest || idx === farthest) {
	      continue
	    }
	    if(left < 0) {
	      left = idx
	    }
	    var v = cubeVerts[idx]
	    if(v[0] < cubeVerts[left][0]) {
	      left = idx
	    }
	  }
	  var right = -1
	  for(var i=0; i<3; ++i) {
	    var idx = bottom ^ (1<<i)
	    if(idx === closest || idx === farthest || idx === left) {
	      continue
	    }
	    if(right < 0) {
	      right = idx
	    }
	    var v = cubeVerts[idx]
	    if(v[0] > cubeVerts[right][0]) {
	      right = idx
	    }
	  }
	
	  //Determine edge axis coordinates
	  var cubeEdges = CUBE_EDGES
	  cubeEdges[0] = cubeEdges[1] = cubeEdges[2] = 0
	  cubeEdges[bits.log2(left^bottom)] = bottom&left
	  cubeEdges[bits.log2(bottom^right)] = bottom&right
	  var top = right ^ 7
	  if(top === closest || top === farthest) {
	    top = left ^ 7
	    cubeEdges[bits.log2(right^top)] = top&right
	  } else {
	    cubeEdges[bits.log2(left^top)] = top&left
	  }
	
	  //Determine visible faces
	  var axis = CUBE_AXIS
	  var cutCorner = closest
	  for(var d=0; d<3; ++d) {
	    if(cutCorner & (1<<d)) {
	      axis[d] = -1
	    } else {
	      axis[d] = 1
	    }
	  }
	
	  //Return result
	  return CUBE_RESULT
	}
	},{"bit-twiddle":93,"gl-mat4/multiply":269,"robust-orientation":508,"split-polygon":525}],238:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports    = createLines
	
	var createBuffer  = _dereq_('gl-buffer')
	var createVAO     = _dereq_('gl-vao')
	var createShader  = _dereq_('./shaders').line
	
	var MAJOR_AXIS = [0,0,0]
	var MINOR_AXIS = [0,0,0]
	var SCREEN_AXIS = [0,0,0]
	var OFFSET_VEC = [0,0,0]
	var SHAPE = [1,1]
	
	function zeroVec(a) {
	  a[0] = a[1] = a[2] = 0
	  return a
	}
	
	function copyVec(a,b) {
	  a[0] = b[0]
	  a[1] = b[1]
	  a[2] = b[2]
	  return a
	}
	
	function Lines(gl, vertBuffer, vao, shader, tickCount, tickOffset, gridCount, gridOffset) {
	  this.gl         = gl
	  this.vertBuffer = vertBuffer
	  this.vao        = vao
	  this.shader     = shader
	  this.tickCount  = tickCount
	  this.tickOffset = tickOffset
	  this.gridCount  = gridCount
	  this.gridOffset = gridOffset
	}
	
	var proto = Lines.prototype
	
	proto.bind = function(model, view, projection) {
	  this.shader.bind()
	  this.shader.uniforms.model = model
	  this.shader.uniforms.view = view
	  this.shader.uniforms.projection = projection
	
	  SHAPE[0] = this.gl.drawingBufferWidth
	  SHAPE[1] = this.gl.drawingBufferHeight
	
	  this.shader.uniforms.screenShape = SHAPE
	  this.vao.bind()
	}
	
	proto.unbind = function() {
	  this.vao.unbind()
	}
	
	proto.drawAxisLine = function(j, bounds, offset, color, lineWidth) {
	  var minorAxis = zeroVec(MINOR_AXIS)
	  this.shader.uniforms.majorAxis = MINOR_AXIS
	
	  minorAxis[j] = bounds[1][j] - bounds[0][j]
	  this.shader.uniforms.minorAxis = minorAxis
	
	  var noffset = copyVec(OFFSET_VEC, offset)
	  noffset[j] += bounds[0][j]
	  this.shader.uniforms.offset = noffset
	
	  this.shader.uniforms.lineWidth = lineWidth
	
	  this.shader.uniforms.color = color
	
	  var screenAxis = zeroVec(SCREEN_AXIS)
	  screenAxis[(j+2)%3] = 1
	  this.shader.uniforms.screenAxis = screenAxis
	  this.vao.draw(this.gl.TRIANGLES, 6)
	
	  var screenAxis = zeroVec(SCREEN_AXIS)
	  screenAxis[(j+1)%3] = 1
	  this.shader.uniforms.screenAxis = screenAxis
	  this.vao.draw(this.gl.TRIANGLES, 6)
	}
	
	proto.drawAxisTicks = function(j, offset, minorAxis, color, lineWidth) {
	  if(!this.tickCount[j]) {
	    return
	  }
	
	  var majorAxis = zeroVec(MAJOR_AXIS)
	  majorAxis[j]  = 1
	  this.shader.uniforms.majorAxis = majorAxis
	  this.shader.uniforms.offset    = offset
	  this.shader.uniforms.minorAxis = minorAxis
	  this.shader.uniforms.color     = color
	  this.shader.uniforms.lineWidth = lineWidth
	
	  var screenAxis = zeroVec(SCREEN_AXIS)
	  screenAxis[j] = 1
	  this.shader.uniforms.screenAxis = screenAxis
	  this.vao.draw(this.gl.TRIANGLES, this.tickCount[j], this.tickOffset[j])
	}
	
	
	proto.drawGrid = function(i, j, bounds, offset, color, lineWidth) {
	  if(!this.gridCount[i]) {
	    return
	  }
	
	  var minorAxis = zeroVec(MINOR_AXIS)
	  minorAxis[j]  = bounds[1][j] - bounds[0][j]
	  this.shader.uniforms.minorAxis = minorAxis
	
	  var noffset = copyVec(OFFSET_VEC, offset)
	  noffset[j] += bounds[0][j]
	  this.shader.uniforms.offset = noffset
	
	  var majorAxis = zeroVec(MAJOR_AXIS)
	  majorAxis[i]  = 1
	  this.shader.uniforms.majorAxis = majorAxis
	
	  var screenAxis = zeroVec(SCREEN_AXIS)
	  screenAxis[i] = 1
	  this.shader.uniforms.screenAxis = screenAxis
	  this.shader.uniforms.lineWidth = lineWidth
	
	  this.shader.uniforms.color = color
	  this.vao.draw(this.gl.TRIANGLES, this.gridCount[i], this.gridOffset[i])
	}
	
	proto.drawZero = function(j, i, bounds, offset, color, lineWidth) {
	  var minorAxis = zeroVec(MINOR_AXIS)
	  this.shader.uniforms.majorAxis = minorAxis
	
	  minorAxis[j] = bounds[1][j] - bounds[0][j]
	  this.shader.uniforms.minorAxis = minorAxis
	
	  var noffset = copyVec(OFFSET_VEC, offset)
	  noffset[j] += bounds[0][j]
	  this.shader.uniforms.offset = noffset
	
	  var screenAxis = zeroVec(SCREEN_AXIS)
	  screenAxis[i] = 1
	  this.shader.uniforms.screenAxis = screenAxis
	  this.shader.uniforms.lineWidth = lineWidth
	
	  this.shader.uniforms.color = color
	  this.vao.draw(this.gl.TRIANGLES, 6)
	}
	
	proto.dispose = function() {
	  this.vao.dispose()
	  this.vertBuffer.dispose()
	  this.shader.dispose()
	}
	
	function createLines(gl, bounds, ticks) {
	  var vertices    = []
	  var tickOffset  = [0,0,0]
	  var tickCount   = [0,0,0]
	
	  //Create grid lines for each axis/direction
	  var gridOffset = [0,0,0]
	  var gridCount  = [0,0,0]
	
	  //Add zero line
	  vertices.push(
	    0,0,1,   0,1,1,   0,0,-1,
	    0,0,-1,  0,1,1,   0,1,-1)
	
	  for(var i=0; i<3; ++i) {
	    //Axis tick marks
	    var start = ((vertices.length / 3)|0)
	    for(var j=0; j<ticks[i].length; ++j) {
	      var x = +ticks[i][j].x
	      vertices.push(
	        x,0,1,   x,1,1,   x,0,-1,
	        x,0,-1,  x,1,1,   x,1,-1)
	    }
	    var end = ((vertices.length / 3)|0)
	    tickOffset[i] = start
	    tickCount[i]  = end - start
	
	    //Grid lines
	    var start = ((vertices.length / 3)|0)
	    for(var k=0; k<ticks[i].length; ++k) {
	      var x = +ticks[i][k].x
	      vertices.push(
	        x,0,1,   x,1,1,   x,0,-1,
	        x,0,-1,  x,1,1,   x,1,-1)
	    }
	    var end = ((vertices.length / 3)|0)
	    gridOffset[i] = start
	    gridCount[i]  = end - start
	  }
	
	  //Create cube VAO
	  var vertBuf = createBuffer(gl, new Float32Array(vertices))
	  var vao = createVAO(gl, [
	    { "buffer": vertBuf,
	      "type": gl.FLOAT,
	      "size": 3,
	      "stride": 0,
	      "offset": 0
	    }
	  ])
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	  return new Lines(gl, vertBuf, vao, shader, tickCount, tickOffset, gridCount, gridOffset)
	}
	
	},{"./shaders":239,"gl-buffer":243,"gl-vao":328}],239:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify = _dereq_('glslify')
	var createShader = _dereq_('gl-shader')
	
	var lineVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"])
	var lineFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"])
	exports.line = function(gl) {
	  return createShader(gl, lineVert, lineFrag, null, [
	    {name: 'position', type: 'vec3'}
	  ])
	}
	
	var textVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"])
	var textFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"])
	exports.text = function(gl) {
	  return createShader(gl, textVert, textFrag, null, [
	    {name: 'position', type: 'vec3'}
	  ])
	}
	
	var bgVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"])
	var bgFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"])
	exports.bg = function(gl) {
	  return createShader(gl, bgVert, bgFrag, null, [
	    {name: 'position', type: 'vec3'},
	    {name: 'normal', type: 'vec3'}
	  ])
	}
	
	},{"gl-shader":303,"glslify":410}],240:[function(_dereq_,module,exports){
	(function (process){
	"use strict"
	
	module.exports = createTextSprites
	
	var createBuffer  = _dereq_('gl-buffer')
	var createVAO     = _dereq_('gl-vao')
	var vectorizeText = _dereq_('vectorize-text')
	var createShader  = _dereq_('./shaders').text
	
	var globals = window || process.global || {}
	var __TEXT_CACHE  = globals.__TEXT_CACHE || {}
	globals.__TEXT_CACHE = {}
	
	//Vertex buffer format for text is:
	//
	/// [x,y,z] = Spatial coordinate
	//
	
	var VERTEX_SIZE = 3
	
	function TextSprites(
	  gl,
	  shader,
	  buffer,
	  vao) {
	  this.gl           = gl
	  this.shader       = shader
	  this.buffer       = buffer
	  this.vao          = vao
	  this.tickOffset   =
	  this.tickCount    =
	  this.labelOffset  =
	  this.labelCount   = null
	}
	
	var proto = TextSprites.prototype
	
	//Bind textures for rendering
	var SHAPE = [0,0]
	proto.bind = function(model, view, projection, pixelScale) {
	  this.vao.bind()
	  this.shader.bind()
	  var uniforms = this.shader.uniforms
	  uniforms.model = model
	  uniforms.view = view
	  uniforms.projection = projection
	  uniforms.pixelScale = pixelScale
	  SHAPE[0] = this.gl.drawingBufferWidth
	  SHAPE[1] = this.gl.drawingBufferHeight
	  this.shader.uniforms.resolution = SHAPE
	}
	
	proto.unbind = function() {
	  this.vao.unbind()
	}
	
	proto.update = function(bounds, labels, labelFont, ticks, tickFont) {
	  var data = []
	
	  function addItem(t, text, font, size, lineSpacing, styletags) {
	    var fontcache = __TEXT_CACHE[font]
	    if(!fontcache) {
	      fontcache = __TEXT_CACHE[font] = {}
	    }
	    var mesh = fontcache[text]
	    if(!mesh) {
	      mesh = fontcache[text] = tryVectorizeText(text, {
	        triangles: true,
	        font: font,
	        textAlign: 'center',
	        textBaseline: 'middle',
	        lineSpacing: lineSpacing,
	        styletags: styletags
	      })
	    }
	    var scale = (size || 12) / 12
	    var positions = mesh.positions
	    var cells = mesh.cells
	    for(var i=0, nc=cells.length; i<nc; ++i) {
	      var c = cells[i]
	      for(var j=2; j>=0; --j) {
	        var p = positions[c[j]]
	        data.push(scale*p[0], -scale*p[1], t)
	      }
	    }
	  }
	
	  //Generate sprites for all 3 axes, store data in texture atlases
	  var tickOffset  = [0,0,0]
	  var tickCount   = [0,0,0]
	  var labelOffset = [0,0,0]
	  var labelCount  = [0,0,0]
	  var lineSpacing = 1.25
	  var styletags = {
	    breaklines:true,
	    bolds: true,
	    italics: true,
	    subscripts:true,
	    superscripts:true
	  }
	  for(var d=0; d<3; ++d) {
	
	    //Generate label
	    labelOffset[d] = (data.length/VERTEX_SIZE)|0
	    addItem(
	      0.5*(bounds[0][d]+bounds[1][d]),
	      labels[d],
	      labelFont[d],
	      12, // labelFontSize
	      lineSpacing,
	      styletags
	    )
	    labelCount[d] = ((data.length/VERTEX_SIZE)|0) - labelOffset[d]
	
	    //Generate sprites for tick marks
	    tickOffset[d] = (data.length/VERTEX_SIZE)|0
	    for(var i=0; i<ticks[d].length; ++i) {
	      if(!ticks[d][i].text) {
	        continue
	      }
	      addItem(
	        ticks[d][i].x,
	        ticks[d][i].text,
	        ticks[d][i].font || tickFont,
	        ticks[d][i].fontSize || 12,
	        lineSpacing,
	        styletags
	      )
	    }
	    tickCount[d] = ((data.length/VERTEX_SIZE)|0) - tickOffset[d]
	  }
	
	  this.buffer.update(data)
	  this.tickOffset = tickOffset
	  this.tickCount = tickCount
	  this.labelOffset = labelOffset
	  this.labelCount = labelCount
	}
	
	//Draws the tick marks for an axis
	proto.drawTicks = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
	  if(!this.tickCount[d]) {
	    return
	  }
	
	  this.shader.uniforms.axis = axis
	  this.shader.uniforms.color = color
	  this.shader.uniforms.angle = angle
	  this.shader.uniforms.scale = scale
	  this.shader.uniforms.offset = offset
	  this.shader.uniforms.alignDir = alignDir
	  this.shader.uniforms.alignOpt = alignOpt
	  this.vao.draw(this.gl.TRIANGLES, this.tickCount[d], this.tickOffset[d])
	}
	
	//Draws the text label for an axis
	proto.drawLabel = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
	  if(!this.labelCount[d]) {
	    return
	  }
	
	  this.shader.uniforms.axis = axis
	  this.shader.uniforms.color = color
	  this.shader.uniforms.angle = angle
	  this.shader.uniforms.scale = scale
	  this.shader.uniforms.offset = offset
	  this.shader.uniforms.alignDir = alignDir
	  this.shader.uniforms.alignOpt = alignOpt
	  this.vao.draw(this.gl.TRIANGLES, this.labelCount[d], this.labelOffset[d])
	}
	
	//Releases all resources attached to this object
	proto.dispose = function() {
	  this.shader.dispose()
	  this.vao.dispose()
	  this.buffer.dispose()
	}
	
	function tryVectorizeText(text, options) {
	  try {
	    return vectorizeText(text, options)
	  } catch(e) {
	    console.warn('error vectorizing text:"' + text + '" error:', e)
	    return {
	      cells: [],
	      positions: []
	    }
	  }
	}
	
	function createTextSprites(
	    gl,
	    bounds,
	    labels,
	    labelFont,
	    ticks,
	    tickFont) {
	
	  var buffer = createBuffer(gl)
	  var vao = createVAO(gl, [
	    { "buffer": buffer,
	      "size": 3
	    }
	  ])
	
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	
	  var result = new TextSprites(
	    gl,
	    shader,
	    buffer,
	    vao)
	
	  result.update(bounds, labels, labelFont, ticks, tickFont)
	
	  return result
	}
	
	}).call(this,_dereq_('_process'))
	},{"./shaders":239,"_process":483,"gl-buffer":243,"gl-vao":328,"vectorize-text":548}],241:[function(_dereq_,module,exports){
	'use strict'
	
	exports.create   = defaultTicks
	exports.equal    = ticksEqual
	
	function prettyPrint(spacing, i) {
	  var stepStr = spacing + ""
	  var u = stepStr.indexOf(".")
	  var sigFigs = 0
	  if(u >= 0) {
	    sigFigs = stepStr.length - u - 1
	  }
	  var shift = Math.pow(10, sigFigs)
	  var x = Math.round(spacing * i * shift)
	  var xstr = x + ""
	  if(xstr.indexOf("e") >= 0) {
	    return xstr
	  }
	  var xi = x / shift, xf = x % shift
	  if(x < 0) {
	    xi = -Math.ceil(xi)|0
	    xf = (-xf)|0
	  } else {
	    xi = Math.floor(xi)|0
	    xf = xf|0
	  }
	  var xis = "" + xi 
	  if(x < 0) {
	    xis = "-" + xis
	  }
	  if(sigFigs) {
	    var xs = "" + xf
	    while(xs.length < sigFigs) {
	      xs = "0" + xs
	    }
	    return xis + "." + xs
	  } else {
	    return xis
	  }
	}
	
	function defaultTicks(bounds, tickSpacing) {
	  var array = []
	  for(var d=0; d<3; ++d) {
	    var ticks = []
	    var m = 0.5*(bounds[0][d]+bounds[1][d])
	    for(var t=0; t*tickSpacing[d]<=bounds[1][d]; ++t) {
	      ticks.push({x: t*tickSpacing[d], text: prettyPrint(tickSpacing[d], t)})
	    }
	    for(var t=-1; t*tickSpacing[d]>=bounds[0][d]; --t) {
	      ticks.push({x: t*tickSpacing[d], text: prettyPrint(tickSpacing[d], t)})
	    }
	    array.push(ticks)
	  }
	  return array
	}
	
	function ticksEqual(ticksA, ticksB) {
	  for(var i=0; i<3; ++i) {
	    if(ticksA[i].length !== ticksB[i].length) {
	      return false
	    }
	    for(var j=0; j<ticksA[i].length; ++j) {
	      var a = ticksA[i][j]
	      var b = ticksB[i][j]
	      if(
	        a.x !== b.x ||
	        a.text !== b.text ||
	        a.font !== b.font ||
	        a.fontColor !== b.fontColor ||
	        a.fontSize !== b.fontSize ||
	        a.dx !== b.dx ||
	        a.dy !== b.dy
	      ) {
	        return false
	      }
	    }
	  }
	  return true
	}
	},{}],242:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = axesProperties
	
	var getPlanes   = _dereq_("extract-frustum-planes")
	var splitPoly   = _dereq_("split-polygon")
	var cubeParams  = _dereq_("./lib/cube.js")
	var m4mul       = _dereq_("gl-mat4/multiply")
	var m4transpose = _dereq_("gl-mat4/transpose")
	var v4transformMat4 = _dereq_("gl-vec4/transformMat4")
	
	var identity    = new Float32Array([
	    1, 0, 0, 0,
	    0, 1, 0, 0,
	    0, 0, 1, 0,
	    0, 0, 0, 1
	  ])
	
	var mvp         = new Float32Array(16)
	
	function AxesRange3D(lo, hi, pixelsPerDataUnit) {
	  this.lo = lo
	  this.hi = hi
	  this.pixelsPerDataUnit = pixelsPerDataUnit
	}
	
	var SCRATCH_P = [0,0,0,1]
	var SCRATCH_Q = [0,0,0,1]
	
	function gradient(result, M, v, width, height) {
	  for(var i=0; i<3; ++i) {
	    var p = SCRATCH_P
	    var q = SCRATCH_Q
	    for(var j=0; j<3; ++j) {
	      q[j] = p[j] = v[j]
	    }
	    q[3] = p[3] = 1
	
	    q[i] += 1
	    v4transformMat4(q, q, M)
	    if(q[3] < 0) {
	      result[i] = Infinity
	    }
	
	    p[i] -= 1
	    v4transformMat4(p, p, M)
	    if(p[3] < 0) {
	      result[i] = Infinity
	    }
	
	    var dx = (p[0]/p[3] - q[0]/q[3]) * width
	    var dy = (p[1]/p[3] - q[1]/q[3]) * height
	
	    result[i] = 0.25 * Math.sqrt(dx*dx + dy*dy)
	  }
	  return result
	}
	
	var RANGES = [
	  new AxesRange3D(Infinity, -Infinity, Infinity),
	  new AxesRange3D(Infinity, -Infinity, Infinity),
	  new AxesRange3D(Infinity, -Infinity, Infinity)
	]
	
	var SCRATCH_X = [0,0,0]
	
	function axesProperties(axes, camera, width, height, params) {
	  var model       = camera.model || identity
	  var view        = camera.view || identity
	  var projection  = camera.projection || identity
	  var isOrtho     = camera._ortho || false
	  var bounds      = axes.bounds
	  var params      = params || cubeParams(model, view, projection, bounds, isOrtho)
	  var axis        = params.axis
	
	  m4mul(mvp, view, model)
	  m4mul(mvp, projection, mvp)
	
	  //Calculate the following properties for each axis:
	  //
	  // * lo - start of visible range for each axis in tick coordinates
	  // * hi - end of visible range for each axis in tick coordinates
	  // * ticksPerPixel - pixel density of tick marks for the axis
	  //
	  var ranges = RANGES
	  for(var i=0; i<3; ++i) {
	    ranges[i].lo = Infinity
	    ranges[i].hi = -Infinity
	    ranges[i].pixelsPerDataUnit = Infinity
	  }
	
	  //Compute frustum planes, intersect with box
	  var frustum = getPlanes(m4transpose(mvp, mvp))
	  m4transpose(mvp, mvp)
	
	  //Loop over vertices of viewable box
	  for(var d=0; d<3; ++d) {
	    var u = (d+1)%3
	    var v = (d+2)%3
	    var x = SCRATCH_X
	i_loop:
	    for(var i=0; i<2; ++i) {
	      var poly = []
	
	      if((axis[d] < 0) === !!i) {
	        continue
	      }
	
	      x[d] = bounds[i][d]
	      for(var j=0; j<2; ++j) {
	        x[u] = bounds[j^i][u]
	        for(var k=0; k<2; ++k) {
	          x[v] = bounds[k^j^i][v]
	          poly.push(x.slice())
	        }
	      }
	
	      var Q = (isOrtho) ? 5 : 4
	      for(var j=Q; j===Q; ++j) { // Note: using only near plane here (& for orthographic projection we use the far).
	        if(poly.length === 0) {
	          continue i_loop
	        }
	        poly = splitPoly.positive(poly, frustum[j])
	      }
	
	      //Loop over vertices of polygon to find extremal points
	      for(var j=0; j<poly.length; ++j) {
	        var v = poly[j]
	        var grad = gradient(SCRATCH_X, mvp, v, width, height)
	        for(var k=0; k<3; ++k) {
	          ranges[k].lo = Math.min(ranges[k].lo, v[k])
	          ranges[k].hi = Math.max(ranges[k].hi, v[k])
	          if(k !== d) {
	            ranges[k].pixelsPerDataUnit = Math.min(ranges[k].pixelsPerDataUnit, Math.abs(grad[k]))
	          }
	        }
	      }
	    }
	  }
	
	  return ranges
	}
	
	},{"./lib/cube.js":237,"extract-frustum-planes":226,"gl-mat4/multiply":269,"gl-mat4/transpose":278,"gl-vec4/transformMat4":399,"split-polygon":525}],243:[function(_dereq_,module,exports){
	"use strict"
	
	var pool = _dereq_("typedarray-pool")
	var ops = _dereq_("ndarray-ops")
	var ndarray = _dereq_("ndarray")
	
	var SUPPORTED_TYPES = [
	  "uint8",
	  "uint8_clamped",
	  "uint16",
	  "uint32",
	  "int8",
	  "int16",
	  "int32",
	  "float32" ]
	
	function GLBuffer(gl, type, handle, length, usage) {
	  this.gl = gl
	  this.type = type
	  this.handle = handle
	  this.length = length
	  this.usage = usage
	}
	
	var proto = GLBuffer.prototype
	
	proto.bind = function() {
	  this.gl.bindBuffer(this.type, this.handle)
	}
	
	proto.unbind = function() {
	  this.gl.bindBuffer(this.type, null)
	}
	
	proto.dispose = function() {
	  this.gl.deleteBuffer(this.handle)
	}
	
	function updateTypeArray(gl, type, len, usage, data, offset) {
	  var dataLen = data.length * data.BYTES_PER_ELEMENT
	  if(offset < 0) {
	    gl.bufferData(type, data, usage)
	    return dataLen
	  }
	  if(dataLen + offset > len) {
	    throw new Error("gl-buffer: If resizing buffer, must not specify offset")
	  }
	  gl.bufferSubData(type, offset, data)
	  return len
	}
	
	function makeScratchTypeArray(array, dtype) {
	  var res = pool.malloc(array.length, dtype)
	  var n = array.length
	  for(var i=0; i<n; ++i) {
	    res[i] = array[i]
	  }
	  return res
	}
	
	function isPacked(shape, stride) {
	  var n = 1
	  for(var i=stride.length-1; i>=0; --i) {
	    if(stride[i] !== n) {
	      return false
	    }
	    n *= shape[i]
	  }
	  return true
	}
	
	proto.update = function(array, offset) {
	  if(typeof offset !== "number") {
	    offset = -1
	  }
	  this.bind()
	  if(typeof array === "object" && typeof array.shape !== "undefined") { //ndarray
	    var dtype = array.dtype
	    if(SUPPORTED_TYPES.indexOf(dtype) < 0) {
	      dtype = "float32"
	    }
	    if(this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
	      var ext = gl.getExtension('OES_element_index_uint')
	      if(ext && dtype !== "uint16") {
	        dtype = "uint32"
	      } else {
	        dtype = "uint16"
	      }
	    }
	    if(dtype === array.dtype && isPacked(array.shape, array.stride)) {
	      if(array.offset === 0 && array.data.length === array.shape[0]) {
	        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data, offset)
	      } else {
	        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data.subarray(array.offset, array.shape[0]), offset)
	      }
	    } else {
	      var tmp = pool.malloc(array.size, dtype)
	      var ndt = ndarray(tmp, array.shape)
	      ops.assign(ndt, array)
	      if(offset < 0) {
	        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp, offset)
	      } else {
	        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp.subarray(0, array.size), offset)
	      }
	      pool.free(tmp)
	    }
	  } else if(Array.isArray(array)) { //Vanilla array
	    var t
	    if(this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
	      t = makeScratchTypeArray(array, "uint16")
	    } else {
	      t = makeScratchTypeArray(array, "float32")
	    }
	    if(offset < 0) {
	      this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t, offset)
	    } else {
	      this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t.subarray(0, array.length), offset)
	    }
	    pool.free(t)
	  } else if(typeof array === "object" && typeof array.length === "number") { //Typed array
	    this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array, offset)
	  } else if(typeof array === "number" || array === undefined) { //Number/default
	    if(offset >= 0) {
	      throw new Error("gl-buffer: Cannot specify offset when resizing buffer")
	    }
	    array = array | 0
	    if(array <= 0) {
	      array = 1
	    }
	    this.gl.bufferData(this.type, array|0, this.usage)
	    this.length = array
	  } else { //Error, case should not happen
	    throw new Error("gl-buffer: Invalid data type")
	  }
	}
	
	function createBuffer(gl, data, type, usage) {
	  type = type || gl.ARRAY_BUFFER
	  usage = usage || gl.DYNAMIC_DRAW
	  if(type !== gl.ARRAY_BUFFER && type !== gl.ELEMENT_ARRAY_BUFFER) {
	    throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER")
	  }
	  if(usage !== gl.DYNAMIC_DRAW && usage !== gl.STATIC_DRAW && usage !== gl.STREAM_DRAW) {
	    throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW")
	  }
	  var handle = gl.createBuffer()
	  var result = new GLBuffer(gl, type, handle, 0, usage)
	  result.update(data)
	  return result
	}
	
	module.exports = createBuffer
	
	},{"ndarray":451,"ndarray-ops":445,"typedarray-pool":543}],244:[function(_dereq_,module,exports){
	"use strict";
	
	var vec3 = _dereq_('gl-vec3');
	
	module.exports = function(vectorfield, bounds) {
		var positions = vectorfield.positions;
		var vectors = vectorfield.vectors;
		var geo = {
			positions: [],
			vertexIntensity: [],
			vertexIntensityBounds: vectorfield.vertexIntensityBounds,
			vectors: [],
			cells: [],
			coneOffset: vectorfield.coneOffset,
			colormap: vectorfield.colormap
		};
	
		if (vectorfield.positions.length === 0) {
			if (bounds) {
				bounds[0] = [0,0,0];
				bounds[1] = [0,0,0];
			}
			return geo;
		}
	
		// Compute bounding box for the dataset.
		// Compute maximum velocity for the dataset to use for scaling the cones.
		var maxNorm = 0;
		var minX = Infinity, maxX = -Infinity;
		var minY = Infinity, maxY = -Infinity;
		var minZ = Infinity, maxZ = -Infinity;
		var p2 = null;
		var u2 = null;
		var positionVectors = [];
		var vectorScale = Infinity;
		var skipIt = false;
		for (var i = 0; i < positions.length; i++) {
			var p = positions[i];
			minX = Math.min(p[0], minX);
			maxX = Math.max(p[0], maxX);
			minY = Math.min(p[1], minY);
			maxY = Math.max(p[1], maxY);
			minZ = Math.min(p[2], minZ);
			maxZ = Math.max(p[2], maxZ);
			var u = vectors[i];
	
			if (vec3.length(u) > maxNorm) {
				maxNorm = vec3.length(u);
			}
			if (i) {
				// Find vector scale [w/ units of time] using "successive" positions
				// (not "adjacent" with would be O(n^2)),
				//
				// The vector scale corresponds to the minimum "time" to travel across two
				// two adjacent positions at the average velocity of those two adjacent positions
	
				var q = (2 * vec3.distance(p2, p) / (vec3.length(u2) + vec3.length(u)));
				if(q) {
					vectorScale = Math.min(vectorScale, q);
					skipIt = false;
				} else {
					skipIt = true;
				}
			}
			if(!skipIt) {
				p2 = p;
				u2 = u;
			}
			positionVectors.push(u);
		}
		var minV = [minX, minY, minZ];
		var maxV = [maxX, maxY, maxZ];
		if (bounds) {
			bounds[0] = minV;
			bounds[1] = maxV;
		}
		if (maxNorm === 0) {
			maxNorm = 1;
		}
	
		// Inverted max norm would map vector with norm maxNorm to 1 coord space units in length
		var invertedMaxNorm = 1 / maxNorm;
	
		if (!isFinite(vectorScale)) {
			vectorScale = 1.0;
		}
		geo.vectorScale = vectorScale;
	
		var coneScale = vectorfield.coneSize || 0.5;
	
		if (vectorfield.absoluteConeSize) {
			coneScale = vectorfield.absoluteConeSize * invertedMaxNorm;
		}
	
		geo.coneScale = coneScale;
	
		// Build the cone model.
		for (var i = 0, j = 0; i < positions.length; i++) {
			var p = positions[i];
			var x = p[0], y = p[1], z = p[2];
			var d = positionVectors[i];
			var intensity = vec3.length(d) * invertedMaxNorm;
			for (var k = 0, l = 8; k < l; k++) {
				geo.positions.push([x, y, z, j++]);
				geo.positions.push([x, y, z, j++]);
				geo.positions.push([x, y, z, j++]);
				geo.positions.push([x, y, z, j++]);
				geo.positions.push([x, y, z, j++]);
				geo.positions.push([x, y, z, j++]);
	
				geo.vectors.push(d);
				geo.vectors.push(d);
				geo.vectors.push(d);
				geo.vectors.push(d);
				geo.vectors.push(d);
				geo.vectors.push(d);
	
				geo.vertexIntensity.push(intensity, intensity, intensity);
				geo.vertexIntensity.push(intensity, intensity, intensity);
	
				var m = geo.positions.length;
				geo.cells.push([m-6, m-5, m-4], [m-3, m-2, m-1]);
			}
		}
	
		return geo;
	};
	
	var shaders = _dereq_('./lib/shaders');
	module.exports.createMesh = _dereq_('./create_mesh');
	module.exports.createConeMesh = function(gl, params) {
		return module.exports.createMesh(gl, params, {
			shaders: shaders,
			traceType: 'cone'
		});
	}
	
	},{"./create_mesh":245,"./lib/shaders":246,"gl-vec3":347}],245:[function(_dereq_,module,exports){
	'use strict'
	
	var createShader  = _dereq_('gl-shader')
	var createBuffer  = _dereq_('gl-buffer')
	var createVAO     = _dereq_('gl-vao')
	var createTexture = _dereq_('gl-texture2d')
	var multiply      = _dereq_('gl-mat4/multiply')
	var invert        = _dereq_('gl-mat4/invert')
	var ndarray       = _dereq_('ndarray')
	var colormap      = _dereq_('colormap')
	
	var IDENTITY = [
	  1,0,0,0,
	  0,1,0,0,
	  0,0,1,0,
	  0,0,0,1]
	
	function VectorMesh(gl
	  , texture
	  , triShader
	  , pickShader
	  , trianglePositions
	  , triangleVectors
	  , triangleIds
	  , triangleColors
	  , triangleUVs
	  , triangleVAO
	  , traceType) {
	
	  this.gl                = gl
	  this.pixelRatio         = 1
	  this.cells             = []
	  this.positions         = []
	  this.intensity         = []
	  this.texture           = texture
	  this.dirty             = true
	
	  this.triShader         = triShader
	  this.pickShader        = pickShader
	
	  this.trianglePositions = trianglePositions
	  this.triangleVectors   = triangleVectors
	  this.triangleColors    = triangleColors
	  this.triangleUVs       = triangleUVs
	  this.triangleIds       = triangleIds
	  this.triangleVAO       = triangleVAO
	  this.triangleCount     = 0
	
	  this.pickId            = 1
	  this.bounds            = [
	    [ Infinity, Infinity, Infinity],
	    [-Infinity,-Infinity,-Infinity] ]
	  this.clipBounds        = [
	    [-Infinity,-Infinity,-Infinity],
	    [ Infinity, Infinity, Infinity] ]
	
	  this.lightPosition = [1e5, 1e5, 0]
	  this.ambientLight  = 0.8
	  this.diffuseLight  = 0.8
	  this.specularLight = 2.0
	  this.roughness     = 0.5
	  this.fresnel       = 1.5
	
	  this.opacity       = 1
	
	  this.traceType     = traceType
	  this.tubeScale     = 1 // used in streamtube
	  this.coneScale     = 2 // used in cone
	  this.vectorScale   = 1 // used in cone
	  this.coneOffset    = 0.25 // used in cone
	
	  this._model       = IDENTITY
	  this._view        = IDENTITY
	  this._projection  = IDENTITY
	  this._resolution  = [1,1]
	}
	
	var proto = VectorMesh.prototype
	
	proto.isOpaque = function() {
	  return this.opacity >= 1
	}
	
	proto.isTransparent = function() {
	  return this.opacity < 1
	}
	
	proto.pickSlots = 1
	
	proto.setPickBase = function(id) {
	  this.pickId = id
	}
	
	function genColormap(param) {
	  var colors = colormap({
	      colormap: param
	    , nshades:  256
	    , format:  'rgba'
	  })
	
	  var result = new Uint8Array(256*4)
	  for(var i=0; i<256; ++i) {
	    var c = colors[i]
	    for(var j=0; j<3; ++j) {
	      result[4*i+j] = c[j]
	    }
	    result[4*i+3] = c[3]*255
	  }
	
	  return ndarray(result, [256,256,4], [4,0,1])
	}
	
	function takeZComponent(array) {
	  var n = array.length
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = array[i][2]
	  }
	  return result
	}
	
	proto.update = function(params) {
	  params = params || {}
	  var gl = this.gl
	
	  this.dirty = true
	
	  if('lightPosition' in params) {
	    this.lightPosition = params.lightPosition
	  }
	  if('opacity' in params) {
	    this.opacity = params.opacity
	  }
	  if('ambient' in params) {
	    this.ambientLight  = params.ambient
	  }
	  if('diffuse' in params) {
	    this.diffuseLight = params.diffuse
	  }
	  if('specular' in params) {
	    this.specularLight = params.specular
	  }
	  if('roughness' in params) {
	    this.roughness = params.roughness
	  }
	  if('fresnel' in params) {
	    this.fresnel = params.fresnel
	  }
	
	  // use in streamtube
	  if (params.tubeScale !== undefined) {
	    this.tubeScale = params.tubeScale
	  }
	
	  // used in cone
	  if (params.vectorScale !== undefined) {
	    this.vectorScale = params.vectorScale
	  }
	  if (params.coneScale !== undefined) {
	    this.coneScale = params.coneScale
	  }
	  if (params.coneOffset !== undefined) {
	    this.coneOffset = params.coneOffset
	  }
	
	  if (params.colormap) {
	    this.texture.shape = [256,256]
	    this.texture.minFilter = gl.LINEAR_MIPMAP_LINEAR
	    this.texture.magFilter = gl.LINEAR
	    this.texture.setPixels(genColormap(params.colormap))
	    this.texture.generateMipmap()
	  }
	
	  var cells = params.cells
	  var positions = params.positions
	  var vectors = params.vectors
	
	  if(!positions || !cells || !vectors) {
	    return
	  }
	
	  var tPos = []
	  var tVec = []
	  var tCol = []
	  var tUVs = []
	  var tIds = []
	
	  //Save geometry data for picking calculations
	  this.cells     = cells
	  this.positions = positions
	  this.vectors   = vectors
	
	  //Compute colors
	  var meshColor       = params.meshColor || [1,1,1,1]
	
	  //UVs
	  var vertexIntensity = params.vertexIntensity
	
	  var intensityLo     = Infinity
	  var intensityHi     = -Infinity
	
	  if(vertexIntensity) {
	    if(params.vertexIntensityBounds) {
	      intensityLo = +params.vertexIntensityBounds[0]
	      intensityHi = +params.vertexIntensityBounds[1]
	    } else {
	      for(var i=0; i<vertexIntensity.length; ++i) {
	        var f = vertexIntensity[i]
	        intensityLo = Math.min(intensityLo, f)
	        intensityHi = Math.max(intensityHi, f)
	      }
	    }
	  } else {
	    for(var i=0; i<positions.length; ++i) {
	      var f = positions[i][2]
	      intensityLo = Math.min(intensityLo, f)
	      intensityHi = Math.max(intensityHi, f)
	    }
	  }
	
	  if(vertexIntensity) {
	    this.intensity = vertexIntensity
	  } else {
	    this.intensity = takeZComponent(positions)
	  }
	
	  //Update bounds
	  this.bounds       = [[Infinity,Infinity,Infinity], [-Infinity,-Infinity,-Infinity]]
	  for(var i=0; i<positions.length; ++i) {
	    var p = positions[i]
	    for(var j=0; j<3; ++j) {
	      if(isNaN(p[j]) || !isFinite(p[j])) {
	        continue
	      }
	      this.bounds[0][j] = Math.min(this.bounds[0][j], p[j])
	      this.bounds[1][j] = Math.max(this.bounds[1][j], p[j])
	    }
	  }
	
	  //Pack cells into buffers
	  var triangleCount = 0
	
	fill_loop:
	  for(var i=0; i<cells.length; ++i) {
	    var cell = cells[i]
	    switch(cell.length) {
	      case 3:
	        //Check NaNs
	        for(var j=0; j<3; ++j) {
	          var v = cell[j]
	          var p = positions[v]
	          for(var k=0; k<3; ++k) {
	            if(isNaN(p[k]) || !isFinite(p[k])) {
	              continue fill_loop
	            }
	          }
	        }
	
	        for(var j=0; j<3; ++j) {
	          var v = cell[2 - j]
	
	          var p = positions[v]
	          tPos.push(p[0], p[1], p[2], p[3])
	
	          var w = vectors[v]
	          tVec.push(w[0], w[1], w[2], w[3] || 0)
	
	          var c = meshColor
	          if(c.length === 3) {
	            tCol.push(c[0], c[1], c[2], 1)
	          } else {
	            tCol.push(c[0], c[1], c[2], c[3])
	          }
	
	          var uv
	          if(vertexIntensity) {
	            uv = [
	              (vertexIntensity[v] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          } else {
	            uv = [
	              (p[2] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          }
	          tUVs.push(uv[0], uv[1])
	
	          tIds.push(i)
	        }
	        triangleCount += 1
	      break
	
	      default:
	      break
	    }
	  }
	
	  this.triangleCount  = triangleCount
	
	  this.trianglePositions.update(tPos)
	  this.triangleVectors.update(tVec)
	  this.triangleColors.update(tCol)
	  this.triangleUVs.update(tUVs)
	  this.triangleIds.update(new Uint32Array(tIds))
	}
	
	proto.drawTransparent = proto.draw = function(params) {
	  params = params || {}
	  var gl          = this.gl
	  var model       = params.model      || IDENTITY
	  var view        = params.view       || IDENTITY
	  var projection  = params.projection || IDENTITY
	
	  var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
	  for(var i=0; i<3; ++i) {
	    clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
	    clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
	  }
	
	  var uniforms = {
	    model:      model,
	    view:       view,
	    projection: projection,
	    inverseModel: IDENTITY.slice(),
	
	    clipBounds: clipBounds,
	
	    kambient:   this.ambientLight,
	    kdiffuse:   this.diffuseLight,
	    kspecular:  this.specularLight,
	    roughness:  this.roughness,
	    fresnel:    this.fresnel,
	
	    eyePosition:   [0,0,0],
	    lightPosition: [0,0,0],
	
	    opacity:  this.opacity,
	
	    tubeScale: this.tubeScale,
	
	    vectorScale: this.vectorScale,
	    coneScale: this.coneScale,
	    coneOffset: this.coneOffset,
	
	    texture:    0
	  }
	
	  uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
	
	  gl.disable(gl.CULL_FACE)
	
	  this.texture.bind(0)
	
	  var invCameraMatrix = new Array(16)
	  multiply(invCameraMatrix, uniforms.view, uniforms.model)
	  multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
	  invert(invCameraMatrix, invCameraMatrix)
	
	  for(var i=0; i<3; ++i) {
	    uniforms.eyePosition[i] = invCameraMatrix[12+i] / invCameraMatrix[15]
	  }
	
	  var w = invCameraMatrix[15]
	  for(var i=0; i<3; ++i) {
	    w += this.lightPosition[i] * invCameraMatrix[4*i+3]
	  }
	  for(var i=0; i<3; ++i) {
	    var s = invCameraMatrix[12+i]
	    for(var j=0; j<3; ++j) {
	      s += invCameraMatrix[4*j+i] * this.lightPosition[j]
	    }
	    uniforms.lightPosition[i] = s / w
	  }
	
	  if(this.triangleCount > 0) {
	    var shader = this.triShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.triangleVAO.bind()
	    gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
	    this.triangleVAO.unbind()
	  }
	}
	
	proto.drawPick = function(params) {
	  params = params || {}
	
	  var gl         = this.gl
	
	  var model      = params.model      || IDENTITY
	  var view       = params.view       || IDENTITY
	  var projection = params.projection || IDENTITY
	
	  var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
	  for(var i=0; i<3; ++i) {
	    clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
	    clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
	  }
	
	  //Save camera parameters
	  this._model      = [].slice.call(model)
	  this._view       = [].slice.call(view)
	  this._projection = [].slice.call(projection)
	  this._resolution = [gl.drawingBufferWidth, gl.drawingBufferHeight]
	
	  var uniforms = {
	    model:      model,
	    view:       view,
	    projection: projection,
	    clipBounds: clipBounds,
	
	    tubeScale: this.tubeScale,
	    vectorScale: this.vectorScale,
	    coneScale: this.coneScale,
	    coneOffset: this.coneOffset,
	
	    pickId:     this.pickId / 255.0,
	  }
	
	  var shader = this.pickShader
	  shader.bind()
	  shader.uniforms = uniforms
	
	  if(this.triangleCount > 0) {
	    this.triangleVAO.bind()
	    gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
	    this.triangleVAO.unbind()
	  }
	}
	
	
	proto.pick = function(pickData) {
	  if(!pickData) {
	    return null
	  }
	  if(pickData.id !== this.pickId) {
	    return null
	  }
	
	  var cellId    = pickData.value[0] + 256*pickData.value[1] + 65536*pickData.value[2]
	  var cell      = this.cells[cellId]
	  var pos =     this.positions[cell[1]].slice(0, 3)
	
	  var result = {
	    position: pos,
	    dataCoordinate: pos,
	    index: Math.floor(cell[1] / 48)
	  }
	
	
	  if(this.traceType === 'cone') {
	    result.index = Math.floor(cell[1] / 48)
	  } else if(this.traceType === 'streamtube') {
	    result.intensity = this.intensity[cell[1]]
	    result.velocity = this.vectors[cell[1]].slice(0, 3)
	    result.divergence = this.vectors[cell[1]][3]
	    result.index = cellId
	  }
	
	  return result
	}
	
	
	proto.dispose = function() {
	  this.texture.dispose()
	
	  this.triShader.dispose()
	  this.pickShader.dispose()
	
	  this.triangleVAO.dispose()
	  this.trianglePositions.dispose()
	  this.triangleVectors.dispose()
	  this.triangleColors.dispose()
	  this.triangleUVs.dispose()
	  this.triangleIds.dispose()
	}
	
	function createMeshShader(gl, shaders) {
	  var shader = createShader(gl,
	    shaders.meshShader.vertex,
	    shaders.meshShader.fragment,
	    null,
	    shaders.meshShader.attributes
	  )
	
	  shader.attributes.position.location = 0
	  shader.attributes.color.location    = 2
	  shader.attributes.uv.location       = 3
	  shader.attributes.vector.location   = 4
	  return shader
	}
	
	
	function createPickShader(gl, shaders) {
	  var shader = createShader(gl,
	    shaders.pickShader.vertex,
	    shaders.pickShader.fragment,
	    null,
	    shaders.pickShader.attributes
	  )
	
	  shader.attributes.position.location = 0
	  shader.attributes.id.location       = 1
	  shader.attributes.vector.location   = 4
	  return shader
	}
	
	
	function createVectorMesh(gl, params, opts) {
	  var shaders = opts.shaders
	
	  if (arguments.length === 1) {
	    params = gl
	    gl = params.gl
	  }
	
	
	  var triShader       = createMeshShader(gl, shaders)
	  var pickShader      = createPickShader(gl, shaders)
	  var meshTexture       = createTexture(gl,
	    ndarray(new Uint8Array([255,255,255,255]), [1,1,4]))
	  meshTexture.generateMipmap()
	  meshTexture.minFilter = gl.LINEAR_MIPMAP_LINEAR
	  meshTexture.magFilter = gl.LINEAR
	
	  var trianglePositions = createBuffer(gl)
	  var triangleVectors   = createBuffer(gl)
	  var triangleColors    = createBuffer(gl)
	  var triangleUVs       = createBuffer(gl)
	  var triangleIds       = createBuffer(gl)
	  var triangleVAO       = createVAO(gl, [
	    { buffer: trianglePositions,
	      type: gl.FLOAT,
	      size: 4
	    },
	    { buffer: triangleIds,
	      type: gl.UNSIGNED_BYTE,
	      size: 4,
	      normalized: true
	    },
	    { buffer: triangleColors,
	      type: gl.FLOAT,
	      size: 4
	    },
	    { buffer: triangleUVs,
	      type: gl.FLOAT,
	      size: 2
	    },
	    { buffer: triangleVectors,
	      type: gl.FLOAT,
	      size: 4
	    }
	  ])
	
	  var mesh = new VectorMesh(gl
	    , meshTexture
	    , triShader
	    , pickShader
	    , trianglePositions
	    , triangleVectors
	    , triangleIds
	    , triangleColors
	    , triangleUVs
	    , triangleVAO
	    , opts.traceType || 'cone'
	  )
	
	  mesh.update(params)
	
	  return mesh
	}
	
	module.exports = createVectorMesh
	
	},{"colormap":127,"gl-buffer":243,"gl-mat4/invert":267,"gl-mat4/multiply":269,"gl-shader":303,"gl-texture2d":323,"gl-vao":328,"ndarray":451}],246:[function(_dereq_,module,exports){
	var glslify       = _dereq_('glslify')
	
	var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"])
	var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"])
	var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"])
	var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
	
	exports.meshShader = {
	  vertex:   triVertSrc,
	  fragment: triFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec4'},
	    {name: 'color', type: 'vec4'},
	    {name: 'uv', type: 'vec2'},
	    {name: 'vector', type: 'vec3'}
	  ]
	}
	exports.pickShader = {
	  vertex:   pickVertSrc,
	  fragment: pickFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec4'},
	    {name: 'id', type: 'vec4'},
	    {name: 'vector', type: 'vec3'}
	  ]
	}
	
	},{"glslify":410}],247:[function(_dereq_,module,exports){
	module.exports = {
	  0: 'NONE',
	  1: 'ONE',
	  2: 'LINE_LOOP',
	  3: 'LINE_STRIP',
	  4: 'TRIANGLES',
	  5: 'TRIANGLE_STRIP',
	  6: 'TRIANGLE_FAN',
	  256: 'DEPTH_BUFFER_BIT',
	  512: 'NEVER',
	  513: 'LESS',
	  514: 'EQUAL',
	  515: 'LEQUAL',
	  516: 'GREATER',
	  517: 'NOTEQUAL',
	  518: 'GEQUAL',
	  519: 'ALWAYS',
	  768: 'SRC_COLOR',
	  769: 'ONE_MINUS_SRC_COLOR',
	  770: 'SRC_ALPHA',
	  771: 'ONE_MINUS_SRC_ALPHA',
	  772: 'DST_ALPHA',
	  773: 'ONE_MINUS_DST_ALPHA',
	  774: 'DST_COLOR',
	  775: 'ONE_MINUS_DST_COLOR',
	  776: 'SRC_ALPHA_SATURATE',
	  1024: 'STENCIL_BUFFER_BIT',
	  1028: 'FRONT',
	  1029: 'BACK',
	  1032: 'FRONT_AND_BACK',
	  1280: 'INVALID_ENUM',
	  1281: 'INVALID_VALUE',
	  1282: 'INVALID_OPERATION',
	  1285: 'OUT_OF_MEMORY',
	  1286: 'INVALID_FRAMEBUFFER_OPERATION',
	  2304: 'CW',
	  2305: 'CCW',
	  2849: 'LINE_WIDTH',
	  2884: 'CULL_FACE',
	  2885: 'CULL_FACE_MODE',
	  2886: 'FRONT_FACE',
	  2928: 'DEPTH_RANGE',
	  2929: 'DEPTH_TEST',
	  2930: 'DEPTH_WRITEMASK',
	  2931: 'DEPTH_CLEAR_VALUE',
	  2932: 'DEPTH_FUNC',
	  2960: 'STENCIL_TEST',
	  2961: 'STENCIL_CLEAR_VALUE',
	  2962: 'STENCIL_FUNC',
	  2963: 'STENCIL_VALUE_MASK',
	  2964: 'STENCIL_FAIL',
	  2965: 'STENCIL_PASS_DEPTH_FAIL',
	  2966: 'STENCIL_PASS_DEPTH_PASS',
	  2967: 'STENCIL_REF',
	  2968: 'STENCIL_WRITEMASK',
	  2978: 'VIEWPORT',
	  3024: 'DITHER',
	  3042: 'BLEND',
	  3088: 'SCISSOR_BOX',
	  3089: 'SCISSOR_TEST',
	  3106: 'COLOR_CLEAR_VALUE',
	  3107: 'COLOR_WRITEMASK',
	  3317: 'UNPACK_ALIGNMENT',
	  3333: 'PACK_ALIGNMENT',
	  3379: 'MAX_TEXTURE_SIZE',
	  3386: 'MAX_VIEWPORT_DIMS',
	  3408: 'SUBPIXEL_BITS',
	  3410: 'RED_BITS',
	  3411: 'GREEN_BITS',
	  3412: 'BLUE_BITS',
	  3413: 'ALPHA_BITS',
	  3414: 'DEPTH_BITS',
	  3415: 'STENCIL_BITS',
	  3553: 'TEXTURE_2D',
	  4352: 'DONT_CARE',
	  4353: 'FASTEST',
	  4354: 'NICEST',
	  5120: 'BYTE',
	  5121: 'UNSIGNED_BYTE',
	  5122: 'SHORT',
	  5123: 'UNSIGNED_SHORT',
	  5124: 'INT',
	  5125: 'UNSIGNED_INT',
	  5126: 'FLOAT',
	  5386: 'INVERT',
	  5890: 'TEXTURE',
	  6401: 'STENCIL_INDEX',
	  6402: 'DEPTH_COMPONENT',
	  6406: 'ALPHA',
	  6407: 'RGB',
	  6408: 'RGBA',
	  6409: 'LUMINANCE',
	  6410: 'LUMINANCE_ALPHA',
	  7680: 'KEEP',
	  7681: 'REPLACE',
	  7682: 'INCR',
	  7683: 'DECR',
	  7936: 'VENDOR',
	  7937: 'RENDERER',
	  7938: 'VERSION',
	  9728: 'NEAREST',
	  9729: 'LINEAR',
	  9984: 'NEAREST_MIPMAP_NEAREST',
	  9985: 'LINEAR_MIPMAP_NEAREST',
	  9986: 'NEAREST_MIPMAP_LINEAR',
	  9987: 'LINEAR_MIPMAP_LINEAR',
	  10240: 'TEXTURE_MAG_FILTER',
	  10241: 'TEXTURE_MIN_FILTER',
	  10242: 'TEXTURE_WRAP_S',
	  10243: 'TEXTURE_WRAP_T',
	  10497: 'REPEAT',
	  10752: 'POLYGON_OFFSET_UNITS',
	  16384: 'COLOR_BUFFER_BIT',
	  32769: 'CONSTANT_COLOR',
	  32770: 'ONE_MINUS_CONSTANT_COLOR',
	  32771: 'CONSTANT_ALPHA',
	  32772: 'ONE_MINUS_CONSTANT_ALPHA',
	  32773: 'BLEND_COLOR',
	  32774: 'FUNC_ADD',
	  32777: 'BLEND_EQUATION_RGB',
	  32778: 'FUNC_SUBTRACT',
	  32779: 'FUNC_REVERSE_SUBTRACT',
	  32819: 'UNSIGNED_SHORT_4_4_4_4',
	  32820: 'UNSIGNED_SHORT_5_5_5_1',
	  32823: 'POLYGON_OFFSET_FILL',
	  32824: 'POLYGON_OFFSET_FACTOR',
	  32854: 'RGBA4',
	  32855: 'RGB5_A1',
	  32873: 'TEXTURE_BINDING_2D',
	  32926: 'SAMPLE_ALPHA_TO_COVERAGE',
	  32928: 'SAMPLE_COVERAGE',
	  32936: 'SAMPLE_BUFFERS',
	  32937: 'SAMPLES',
	  32938: 'SAMPLE_COVERAGE_VALUE',
	  32939: 'SAMPLE_COVERAGE_INVERT',
	  32968: 'BLEND_DST_RGB',
	  32969: 'BLEND_SRC_RGB',
	  32970: 'BLEND_DST_ALPHA',
	  32971: 'BLEND_SRC_ALPHA',
	  33071: 'CLAMP_TO_EDGE',
	  33170: 'GENERATE_MIPMAP_HINT',
	  33189: 'DEPTH_COMPONENT16',
	  33306: 'DEPTH_STENCIL_ATTACHMENT',
	  33635: 'UNSIGNED_SHORT_5_6_5',
	  33648: 'MIRRORED_REPEAT',
	  33901: 'ALIASED_POINT_SIZE_RANGE',
	  33902: 'ALIASED_LINE_WIDTH_RANGE',
	  33984: 'TEXTURE0',
	  33985: 'TEXTURE1',
	  33986: 'TEXTURE2',
	  33987: 'TEXTURE3',
	  33988: 'TEXTURE4',
	  33989: 'TEXTURE5',
	  33990: 'TEXTURE6',
	  33991: 'TEXTURE7',
	  33992: 'TEXTURE8',
	  33993: 'TEXTURE9',
	  33994: 'TEXTURE10',
	  33995: 'TEXTURE11',
	  33996: 'TEXTURE12',
	  33997: 'TEXTURE13',
	  33998: 'TEXTURE14',
	  33999: 'TEXTURE15',
	  34000: 'TEXTURE16',
	  34001: 'TEXTURE17',
	  34002: 'TEXTURE18',
	  34003: 'TEXTURE19',
	  34004: 'TEXTURE20',
	  34005: 'TEXTURE21',
	  34006: 'TEXTURE22',
	  34007: 'TEXTURE23',
	  34008: 'TEXTURE24',
	  34009: 'TEXTURE25',
	  34010: 'TEXTURE26',
	  34011: 'TEXTURE27',
	  34012: 'TEXTURE28',
	  34013: 'TEXTURE29',
	  34014: 'TEXTURE30',
	  34015: 'TEXTURE31',
	  34016: 'ACTIVE_TEXTURE',
	  34024: 'MAX_RENDERBUFFER_SIZE',
	  34041: 'DEPTH_STENCIL',
	  34055: 'INCR_WRAP',
	  34056: 'DECR_WRAP',
	  34067: 'TEXTURE_CUBE_MAP',
	  34068: 'TEXTURE_BINDING_CUBE_MAP',
	  34069: 'TEXTURE_CUBE_MAP_POSITIVE_X',
	  34070: 'TEXTURE_CUBE_MAP_NEGATIVE_X',
	  34071: 'TEXTURE_CUBE_MAP_POSITIVE_Y',
	  34072: 'TEXTURE_CUBE_MAP_NEGATIVE_Y',
	  34073: 'TEXTURE_CUBE_MAP_POSITIVE_Z',
	  34074: 'TEXTURE_CUBE_MAP_NEGATIVE_Z',
	  34076: 'MAX_CUBE_MAP_TEXTURE_SIZE',
	  34338: 'VERTEX_ATTRIB_ARRAY_ENABLED',
	  34339: 'VERTEX_ATTRIB_ARRAY_SIZE',
	  34340: 'VERTEX_ATTRIB_ARRAY_STRIDE',
	  34341: 'VERTEX_ATTRIB_ARRAY_TYPE',
	  34342: 'CURRENT_VERTEX_ATTRIB',
	  34373: 'VERTEX_ATTRIB_ARRAY_POINTER',
	  34466: 'NUM_COMPRESSED_TEXTURE_FORMATS',
	  34467: 'COMPRESSED_TEXTURE_FORMATS',
	  34660: 'BUFFER_SIZE',
	  34661: 'BUFFER_USAGE',
	  34816: 'STENCIL_BACK_FUNC',
	  34817: 'STENCIL_BACK_FAIL',
	  34818: 'STENCIL_BACK_PASS_DEPTH_FAIL',
	  34819: 'STENCIL_BACK_PASS_DEPTH_PASS',
	  34877: 'BLEND_EQUATION_ALPHA',
	  34921: 'MAX_VERTEX_ATTRIBS',
	  34922: 'VERTEX_ATTRIB_ARRAY_NORMALIZED',
	  34930: 'MAX_TEXTURE_IMAGE_UNITS',
	  34962: 'ARRAY_BUFFER',
	  34963: 'ELEMENT_ARRAY_BUFFER',
	  34964: 'ARRAY_BUFFER_BINDING',
	  34965: 'ELEMENT_ARRAY_BUFFER_BINDING',
	  34975: 'VERTEX_ATTRIB_ARRAY_BUFFER_BINDING',
	  35040: 'STREAM_DRAW',
	  35044: 'STATIC_DRAW',
	  35048: 'DYNAMIC_DRAW',
	  35632: 'FRAGMENT_SHADER',
	  35633: 'VERTEX_SHADER',
	  35660: 'MAX_VERTEX_TEXTURE_IMAGE_UNITS',
	  35661: 'MAX_COMBINED_TEXTURE_IMAGE_UNITS',
	  35663: 'SHADER_TYPE',
	  35664: 'FLOAT_VEC2',
	  35665: 'FLOAT_VEC3',
	  35666: 'FLOAT_VEC4',
	  35667: 'INT_VEC2',
	  35668: 'INT_VEC3',
	  35669: 'INT_VEC4',
	  35670: 'BOOL',
	  35671: 'BOOL_VEC2',
	  35672: 'BOOL_VEC3',
	  35673: 'BOOL_VEC4',
	  35674: 'FLOAT_MAT2',
	  35675: 'FLOAT_MAT3',
	  35676: 'FLOAT_MAT4',
	  35678: 'SAMPLER_2D',
	  35680: 'SAMPLER_CUBE',
	  35712: 'DELETE_STATUS',
	  35713: 'COMPILE_STATUS',
	  35714: 'LINK_STATUS',
	  35715: 'VALIDATE_STATUS',
	  35716: 'INFO_LOG_LENGTH',
	  35717: 'ATTACHED_SHADERS',
	  35718: 'ACTIVE_UNIFORMS',
	  35719: 'ACTIVE_UNIFORM_MAX_LENGTH',
	  35720: 'SHADER_SOURCE_LENGTH',
	  35721: 'ACTIVE_ATTRIBUTES',
	  35722: 'ACTIVE_ATTRIBUTE_MAX_LENGTH',
	  35724: 'SHADING_LANGUAGE_VERSION',
	  35725: 'CURRENT_PROGRAM',
	  36003: 'STENCIL_BACK_REF',
	  36004: 'STENCIL_BACK_VALUE_MASK',
	  36005: 'STENCIL_BACK_WRITEMASK',
	  36006: 'FRAMEBUFFER_BINDING',
	  36007: 'RENDERBUFFER_BINDING',
	  36048: 'FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE',
	  36049: 'FRAMEBUFFER_ATTACHMENT_OBJECT_NAME',
	  36050: 'FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL',
	  36051: 'FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE',
	  36053: 'FRAMEBUFFER_COMPLETE',
	  36054: 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT',
	  36055: 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT',
	  36057: 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS',
	  36061: 'FRAMEBUFFER_UNSUPPORTED',
	  36064: 'COLOR_ATTACHMENT0',
	  36096: 'DEPTH_ATTACHMENT',
	  36128: 'STENCIL_ATTACHMENT',
	  36160: 'FRAMEBUFFER',
	  36161: 'RENDERBUFFER',
	  36162: 'RENDERBUFFER_WIDTH',
	  36163: 'RENDERBUFFER_HEIGHT',
	  36164: 'RENDERBUFFER_INTERNAL_FORMAT',
	  36168: 'STENCIL_INDEX8',
	  36176: 'RENDERBUFFER_RED_SIZE',
	  36177: 'RENDERBUFFER_GREEN_SIZE',
	  36178: 'RENDERBUFFER_BLUE_SIZE',
	  36179: 'RENDERBUFFER_ALPHA_SIZE',
	  36180: 'RENDERBUFFER_DEPTH_SIZE',
	  36181: 'RENDERBUFFER_STENCIL_SIZE',
	  36194: 'RGB565',
	  36336: 'LOW_FLOAT',
	  36337: 'MEDIUM_FLOAT',
	  36338: 'HIGH_FLOAT',
	  36339: 'LOW_INT',
	  36340: 'MEDIUM_INT',
	  36341: 'HIGH_INT',
	  36346: 'SHADER_COMPILER',
	  36347: 'MAX_VERTEX_UNIFORM_VECTORS',
	  36348: 'MAX_VARYING_VECTORS',
	  36349: 'MAX_FRAGMENT_UNIFORM_VECTORS',
	  37440: 'UNPACK_FLIP_Y_WEBGL',
	  37441: 'UNPACK_PREMULTIPLY_ALPHA_WEBGL',
	  37442: 'CONTEXT_LOST_WEBGL',
	  37443: 'UNPACK_COLORSPACE_CONVERSION_WEBGL',
	  37444: 'BROWSER_DEFAULT_WEBGL'
	}
	
	},{}],248:[function(_dereq_,module,exports){
	var gl10 = _dereq_('./1.0/numbers')
	
	module.exports = function lookupConstant (number) {
	  return gl10[number]
	}
	
	},{"./1.0/numbers":247}],249:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createErrorBars
	
	var createBuffer  = _dereq_('gl-buffer')
	var createVAO     = _dereq_('gl-vao')
	var createShader  = _dereq_('./shaders/index')
	
	var IDENTITY = [1,0,0,0,
	                0,1,0,0,
	                0,0,1,0,
	                0,0,0,1]
	
	function ErrorBars(gl, buffer, vao, shader) {
	  this.gl           = gl
	  this.shader       = shader
	  this.buffer       = buffer
	  this.vao          = vao
	  this.pixelRatio   = 1
	  this.bounds       = [[ Infinity, Infinity, Infinity], [-Infinity,-Infinity,-Infinity]]
	  this.clipBounds   = [[-Infinity,-Infinity,-Infinity], [ Infinity, Infinity, Infinity]]
	  this.lineWidth    = [1,1,1]
	  this.capSize      = [10,10,10]
	  this.lineCount    = [0,0,0]
	  this.lineOffset   = [0,0,0]
	  this.opacity      = 1
	  this.hasAlpha     = false
	}
	
	var proto = ErrorBars.prototype
	
	proto.isOpaque = function() {
	  return !this.hasAlpha
	}
	
	proto.isTransparent = function() {
	  return this.hasAlpha
	}
	
	proto.drawTransparent = proto.draw = function(cameraParams) {
	  var gl = this.gl
	  var uniforms        = this.shader.uniforms
	
	  this.shader.bind()
	  var view       = uniforms.view       = cameraParams.view       || IDENTITY
	  var projection = uniforms.projection = cameraParams.projection || IDENTITY
	  uniforms.model      = cameraParams.model      || IDENTITY
	  uniforms.clipBounds = this.clipBounds
	  uniforms.opacity    = this.opacity
	
	
	  var cx = view[12]
	  var cy = view[13]
	  var cz = view[14]
	  var cw = view[15]
	
	  var isOrtho = cameraParams._ortho || false
	  var orthoFix = (isOrtho) ? 2 : 1 // double up padding for orthographic ticks & labels
	  var pixelScaleF = orthoFix * this.pixelRatio * (projection[3]*cx + projection[7]*cy + projection[11]*cz + projection[15]*cw) / gl.drawingBufferHeight
	
	  this.vao.bind()
	  for(var i=0; i<3; ++i) {
	    gl.lineWidth(this.lineWidth[i] * this.pixelRatio)
	    uniforms.capSize = this.capSize[i] * pixelScaleF
	    if (this.lineCount[i]) {
	      gl.drawArrays(gl.LINES, this.lineOffset[i], this.lineCount[i])
	    }
	  }
	  this.vao.unbind()
	}
	
	function updateBounds(bounds, point) {
	  for(var i=0; i<3; ++i) {
	    bounds[0][i] = Math.min(bounds[0][i], point[i])
	    bounds[1][i] = Math.max(bounds[1][i], point[i])
	  }
	}
	
	var FACE_TABLE = (function(){
	  var table = new Array(3)
	  for(var d=0; d<3; ++d) {
	    var row = []
	    for(var j=1; j<=2; ++j) {
	      for(var s=-1; s<=1; s+=2) {
	        var u = (j+d) % 3
	        var y = [0,0,0]
	        y[u] = s
	        row.push(y)
	      }
	    }
	    table[d] = row
	  }
	  return table
	})()
	
	
	function emitFace(verts, x, c, d) {
	  var offsets = FACE_TABLE[d]
	  for(var i=0; i<offsets.length; ++i) {
	    var o = offsets[i]
	    verts.push(x[0], x[1], x[2],
	               c[0], c[1], c[2], c[3],
	               o[0], o[1], o[2])
	  }
	  return offsets.length
	}
	
	proto.update = function(options) {
	  options = options || {}
	
	  if('lineWidth' in options) {
	    this.lineWidth = options.lineWidth
	    if(!Array.isArray(this.lineWidth)) {
	      this.lineWidth = [this.lineWidth, this.lineWidth, this.lineWidth]
	    }
	  }
	  if('capSize' in options) {
	    this.capSize = options.capSize
	    if(!Array.isArray(this.capSize)) {
	      this.capSize = [this.capSize, this.capSize, this.capSize]
	    }
	  }
	
	  this.hasAlpha = false // default to no transparent draw
	  if('opacity' in options) {
	    this.opacity = +options.opacity
	    if(this.opacity < 1) {
	      this.hasAlpha = true;
	    }
	  }
	
	  var color    = options.color || [[0,0,0],[0,0,0],[0,0,0]]
	  var position = options.position
	  var error    = options.error
	  if(!Array.isArray(color[0])) {
	    color = [color,color,color]
	  }
	
	  if(position && error) {
	
	    var verts       = []
	    var n           = position.length
	    var vertexCount = 0
	    this.bounds     = [[ Infinity, Infinity, Infinity],
	                       [-Infinity,-Infinity,-Infinity]]
	    this.lineCount  = [0,0,0]
	
	    //Build geometry for lines
	    for(var j=0; j<3; ++j) {
	      this.lineOffset[j] = vertexCount
	
	i_loop:
	      for(var i=0; i<n; ++i) {
	        var p = position[i]
	
	        for(var k=0; k<3; ++k) {
	          if(isNaN(p[k]) || !isFinite(p[k])) {
	            continue i_loop
	          }
	        }
	
	        var e = error[i]
	        var c = color[j]
	        if(Array.isArray(c[0])) {
	          c = color[i]
	        }
	        if(c.length === 3) {
	          c = [c[0], c[1], c[2], 1]
	        } else if(c.length === 4) {
	          c = [c[0], c[1], c[2], c[3]]
	          if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
	        }
	
	        if(isNaN(e[0][j]) || isNaN(e[1][j])) {
	          continue
	        }
	        if(e[0][j] < 0) {
	          var x = p.slice()
	          x[j] += e[0][j]
	          verts.push(p[0], p[1], p[2],
	                     c[0], c[1], c[2], c[3],
	                        0,    0,    0,
	                     x[0], x[1], x[2],
	                     c[0], c[1], c[2], c[3],
	                        0,    0,    0)
	          updateBounds(this.bounds, x)
	          vertexCount += 2 + emitFace(verts, x, c, j)
	        }
	        if(e[1][j] > 0) {
	          var x = p.slice()
	          x[j] += e[1][j]
	          verts.push(p[0], p[1], p[2],
	                     c[0], c[1], c[2], c[3],
	                        0,    0,    0,
	                     x[0], x[1], x[2],
	                     c[0], c[1], c[2], c[3],
	                        0,    0,    0)
	          updateBounds(this.bounds, x)
	          vertexCount += 2 + emitFace(verts, x, c, j)
	        }
	      }
	      this.lineCount[j] = vertexCount - this.lineOffset[j]
	    }
	    this.buffer.update(verts)
	  }
	}
	
	proto.dispose = function() {
	  this.shader.dispose()
	  this.buffer.dispose()
	  this.vao.dispose()
	}
	
	function createErrorBars(options) {
	  var gl = options.gl
	  var buffer = createBuffer(gl)
	  var vao = createVAO(gl, [
	      {
	        buffer: buffer,
	        type:   gl.FLOAT,
	        size:   3,
	        offset: 0,
	        stride: 40
	      },
	      {
	        buffer: buffer,
	        type:   gl.FLOAT,
	        size:   4,
	        offset: 12,
	        stride: 40
	      },
	      {
	        buffer: buffer,
	        type:   gl.FLOAT,
	        size:   3,
	        offset: 28,
	        stride: 40
	      }
	    ])
	
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	  shader.attributes.color.location    = 1
	  shader.attributes.offset.location   = 2
	
	  var result = new ErrorBars(gl, buffer, vao, shader)
	  result.update(options)
	  return result
	}
	
	},{"./shaders/index":250,"gl-buffer":243,"gl-vao":328}],250:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify = _dereq_('glslify')
	var createShader = _dereq_('gl-shader')
	
	var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"])
	var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"])
	
	module.exports = function(gl) {
	  return createShader(gl, vertSrc, fragSrc, null, [
	    {name: 'position', type: 'vec3'},
	    {name: 'color', type: 'vec4'},
	    {name: 'offset', type: 'vec3'}
	  ])
	}
	
	},{"gl-shader":303,"glslify":410}],251:[function(_dereq_,module,exports){
	'use strict'
	
	var createTexture = _dereq_('gl-texture2d')
	
	module.exports = createFBO
	
	var colorAttachmentArrays = null
	var FRAMEBUFFER_UNSUPPORTED
	var FRAMEBUFFER_INCOMPLETE_ATTACHMENT
	var FRAMEBUFFER_INCOMPLETE_DIMENSIONS
	var FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT
	
	function saveFBOState(gl) {
	  var fbo = gl.getParameter(gl.FRAMEBUFFER_BINDING)
	  var rbo = gl.getParameter(gl.RENDERBUFFER_BINDING)
	  var tex = gl.getParameter(gl.TEXTURE_BINDING_2D)
	  return [fbo, rbo, tex]
	}
	
	function restoreFBOState(gl, data) {
	  gl.bindFramebuffer(gl.FRAMEBUFFER, data[0])
	  gl.bindRenderbuffer(gl.RENDERBUFFER, data[1])
	  gl.bindTexture(gl.TEXTURE_2D, data[2])
	}
	
	function lazyInitColorAttachments(gl, ext) {
	  var maxColorAttachments = gl.getParameter(ext.MAX_COLOR_ATTACHMENTS_WEBGL)
	  colorAttachmentArrays = new Array(maxColorAttachments + 1)
	  for(var i=0; i<=maxColorAttachments; ++i) {
	    var x = new Array(maxColorAttachments)
	    for(var j=0; j<i; ++j) {
	      x[j] = gl.COLOR_ATTACHMENT0 + j
	    }
	    for(var j=i; j<maxColorAttachments; ++j) {
	      x[j] = gl.NONE
	    }
	    colorAttachmentArrays[i] = x
	  }
	}
	
	//Throw an appropriate error
	function throwFBOError(status) {
	  switch(status){
	    case FRAMEBUFFER_UNSUPPORTED:
	      throw new Error('gl-fbo: Framebuffer unsupported')
	    case FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
	      throw new Error('gl-fbo: Framebuffer incomplete attachment')
	    case FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
	      throw new Error('gl-fbo: Framebuffer incomplete dimensions')
	    case FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
	      throw new Error('gl-fbo: Framebuffer incomplete missing attachment')
	    default:
	      throw new Error('gl-fbo: Framebuffer failed for unspecified reason')
	  }
	}
	
	//Initialize a texture object
	function initTexture(gl, width, height, type, format, attachment) {
	  if(!type) {
	    return null
	  }
	  var result = createTexture(gl, width, height, format, type)
	  result.magFilter = gl.NEAREST
	  result.minFilter = gl.NEAREST
	  result.mipSamples = 1
	  result.bind()
	  gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, result.handle, 0)
	  return result
	}
	
	//Initialize a render buffer object
	function initRenderBuffer(gl, width, height, component, attachment) {
	  var result = gl.createRenderbuffer()
	  gl.bindRenderbuffer(gl.RENDERBUFFER, result)
	  gl.renderbufferStorage(gl.RENDERBUFFER, component, width, height)
	  gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, result)
	  return result
	}
	
	//Rebuild the frame buffer
	function rebuildFBO(fbo) {
	
	  //Save FBO state
	  var state = saveFBOState(fbo.gl)
	
	  var gl = fbo.gl
	  var handle = fbo.handle = gl.createFramebuffer()
	  var width = fbo._shape[0]
	  var height = fbo._shape[1]
	  var numColors = fbo.color.length
	  var ext = fbo._ext
	  var useStencil = fbo._useStencil
	  var useDepth = fbo._useDepth
	  var colorType = fbo._colorType
	
	  //Bind the fbo
	  gl.bindFramebuffer(gl.FRAMEBUFFER, handle)
	
	  //Allocate color buffers
	  for(var i=0; i<numColors; ++i) {
	    fbo.color[i] = initTexture(gl, width, height, colorType, gl.RGBA, gl.COLOR_ATTACHMENT0 + i)
	  }
	  if(numColors === 0) {
	    fbo._color_rb = initRenderBuffer(gl, width, height, gl.RGBA4, gl.COLOR_ATTACHMENT0)
	    if(ext) {
	      ext.drawBuffersWEBGL(colorAttachmentArrays[0])
	    }
	  } else if(numColors > 1) {
	    ext.drawBuffersWEBGL(colorAttachmentArrays[numColors])
	  }
	
	  //Allocate depth/stencil buffers
	  var WEBGL_depth_texture = gl.getExtension('WEBGL_depth_texture')
	  if(WEBGL_depth_texture) {
	    if(useStencil) {
	      fbo.depth = initTexture(gl, width, height,
	                          WEBGL_depth_texture.UNSIGNED_INT_24_8_WEBGL,
	                          gl.DEPTH_STENCIL,
	                          gl.DEPTH_STENCIL_ATTACHMENT)
	    } else if(useDepth) {
	      fbo.depth = initTexture(gl, width, height,
	                          gl.UNSIGNED_SHORT,
	                          gl.DEPTH_COMPONENT,
	                          gl.DEPTH_ATTACHMENT)
	    }
	  } else {
	    if(useDepth && useStencil) {
	      fbo._depth_rb = initRenderBuffer(gl, width, height, gl.DEPTH_STENCIL, gl.DEPTH_STENCIL_ATTACHMENT)
	    } else if(useDepth) {
	      fbo._depth_rb = initRenderBuffer(gl, width, height, gl.DEPTH_COMPONENT16, gl.DEPTH_ATTACHMENT)
	    } else if(useStencil) {
	      fbo._depth_rb = initRenderBuffer(gl, width, height, gl.STENCIL_INDEX, gl.STENCIL_ATTACHMENT)
	    }
	  }
	
	  //Check frame buffer state
	  var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER)
	  if(status !== gl.FRAMEBUFFER_COMPLETE) {
	
	    //Release all partially allocated resources
	    fbo._destroyed = true
	
	    //Release all resources
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null)
	    gl.deleteFramebuffer(fbo.handle)
	    fbo.handle = null
	    if(fbo.depth) {
	      fbo.depth.dispose()
	      fbo.depth = null
	    }
	    if(fbo._depth_rb) {
	      gl.deleteRenderbuffer(fbo._depth_rb)
	      fbo._depth_rb = null
	    }
	    for(var i=0; i<fbo.color.length; ++i) {
	      fbo.color[i].dispose()
	      fbo.color[i] = null
	    }
	    if(fbo._color_rb) {
	      gl.deleteRenderbuffer(fbo._color_rb)
	      fbo._color_rb = null
	    }
	
	    restoreFBOState(gl, state)
	
	    //Throw the frame buffer error
	    throwFBOError(status)
	  }
	
	  //Everything ok, let's get on with life
	  restoreFBOState(gl, state)
	}
	
	function Framebuffer(gl, width, height, colorType, numColors, useDepth, useStencil, ext) {
	
	  //Handle and set properties
	  this.gl = gl
	  this._shape = [width|0, height|0]
	  this._destroyed = false
	  this._ext = ext
	
	  //Allocate buffers
	  this.color = new Array(numColors)
	  for(var i=0; i<numColors; ++i) {
	    this.color[i] = null
	  }
	  this._color_rb = null
	  this.depth = null
	  this._depth_rb = null
	
	  //Save depth and stencil flags
	  this._colorType = colorType
	  this._useDepth = useDepth
	  this._useStencil = useStencil
	
	  //Shape vector for resizing
	  var parent = this
	  var shapeVector = [width|0, height|0]
	  Object.defineProperties(shapeVector, {
	    0: {
	      get: function() {
	        return parent._shape[0]
	      },
	      set: function(w) {
	        return parent.width = w
	      }
	    },
	    1: {
	      get: function() {
	        return parent._shape[1]
	      },
	      set: function(h) {
	        return parent.height = h
	      }
	    }
	  })
	  this._shapeVector = shapeVector
	
	  //Initialize all attachments
	  rebuildFBO(this)
	}
	
	var proto = Framebuffer.prototype
	
	function reshapeFBO(fbo, w, h) {
	  //If fbo is invalid, just skip this
	  if(fbo._destroyed) {
	    throw new Error('gl-fbo: Can\'t resize destroyed FBO')
	  }
	
	  //Don't resize if no change in shape
	  if( (fbo._shape[0] === w) &&
	      (fbo._shape[1] === h) ) {
	    return
	  }
	
	  var gl = fbo.gl
	
	  //Check parameter ranges
	  var maxFBOSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE)
	  if( w < 0 || w > maxFBOSize ||
	      h < 0 || h > maxFBOSize) {
	    throw new Error('gl-fbo: Can\'t resize FBO, invalid dimensions')
	  }
	
	  //Update shape
	  fbo._shape[0] = w
	  fbo._shape[1] = h
	
	  //Save framebuffer state
	  var state = saveFBOState(gl)
	
	  //Resize framebuffer attachments
	  for(var i=0; i<fbo.color.length; ++i) {
	    fbo.color[i].shape = fbo._shape
	  }
	  if(fbo._color_rb) {
	    gl.bindRenderbuffer(gl.RENDERBUFFER, fbo._color_rb)
	    gl.renderbufferStorage(gl.RENDERBUFFER, gl.RGBA4, fbo._shape[0], fbo._shape[1])
	  }
	  if(fbo.depth) {
	    fbo.depth.shape = fbo._shape
	  }
	  if(fbo._depth_rb) {
	    gl.bindRenderbuffer(gl.RENDERBUFFER, fbo._depth_rb)
	    if(fbo._useDepth && fbo._useStencil) {
	      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, fbo._shape[0], fbo._shape[1])
	    } else if(fbo._useDepth) {
	      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, fbo._shape[0], fbo._shape[1])
	    } else if(fbo._useStencil) {
	      gl.renderbufferStorage(gl.RENDERBUFFER, gl.STENCIL_INDEX, fbo._shape[0], fbo._shape[1])
	    }
	  }
	
	  //Check FBO status after resize, if something broke then die in a fire
	  gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.handle)
	  var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER)
	  if(status !== gl.FRAMEBUFFER_COMPLETE) {
	    fbo.dispose()
	    restoreFBOState(gl, state)
	    throwFBOError(status)
	  }
	
	  //Restore framebuffer state
	  restoreFBOState(gl, state)
	}
	
	Object.defineProperties(proto, {
	  'shape': {
	    get: function() {
	      if(this._destroyed) {
	        return [0,0]
	      }
	      return this._shapeVector
	    },
	    set: function(x) {
	      if(!Array.isArray(x)) {
	        x = [x|0, x|0]
	      }
	      if(x.length !== 2) {
	        throw new Error('gl-fbo: Shape vector must be length 2')
	      }
	
	      var w = x[0]|0
	      var h = x[1]|0
	      reshapeFBO(this, w, h)
	
	      return [w, h]
	    },
	    enumerable: false
	  },
	  'width': {
	    get: function() {
	      if(this._destroyed) {
	        return 0
	      }
	      return this._shape[0]
	    },
	    set: function(w) {
	      w = w|0
	      reshapeFBO(this, w, this._shape[1])
	      return w
	    },
	    enumerable: false
	  },
	  'height': {
	    get: function() {
	      if(this._destroyed) {
	        return 0
	      }
	      return this._shape[1]
	    },
	    set: function(h) {
	      h = h|0
	      reshapeFBO(this, this._shape[0], h)
	      return h
	    },
	    enumerable: false
	  }
	})
	
	proto.bind = function() {
	  if(this._destroyed) {
	    return
	  }
	  var gl = this.gl
	  gl.bindFramebuffer(gl.FRAMEBUFFER, this.handle)
	  gl.viewport(0, 0, this._shape[0], this._shape[1])
	}
	
	proto.dispose = function() {
	  if(this._destroyed) {
	    return
	  }
	  this._destroyed = true
	  var gl = this.gl
	  gl.deleteFramebuffer(this.handle)
	  this.handle = null
	  if(this.depth) {
	    this.depth.dispose()
	    this.depth = null
	  }
	  if(this._depth_rb) {
	    gl.deleteRenderbuffer(this._depth_rb)
	    this._depth_rb = null
	  }
	  for(var i=0; i<this.color.length; ++i) {
	    this.color[i].dispose()
	    this.color[i] = null
	  }
	  if(this._color_rb) {
	    gl.deleteRenderbuffer(this._color_rb)
	    this._color_rb = null
	  }
	}
	
	function createFBO(gl, width, height, options) {
	
	  //Update frame buffer error code values
	  if(!FRAMEBUFFER_UNSUPPORTED) {
	    FRAMEBUFFER_UNSUPPORTED = gl.FRAMEBUFFER_UNSUPPORTED
	    FRAMEBUFFER_INCOMPLETE_ATTACHMENT = gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT
	    FRAMEBUFFER_INCOMPLETE_DIMENSIONS = gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS
	    FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT
	  }
	
	  //Lazily initialize color attachment arrays
	  var WEBGL_draw_buffers = gl.getExtension('WEBGL_draw_buffers')
	  if(!colorAttachmentArrays && WEBGL_draw_buffers) {
	    lazyInitColorAttachments(gl, WEBGL_draw_buffers)
	  }
	
	  //Special case: Can accept an array as argument
	  if(Array.isArray(width)) {
	    options = height
	    height = width[1]|0
	    width = width[0]|0
	  }
	
	  if(typeof width !== 'number') {
	    throw new Error('gl-fbo: Missing shape parameter')
	  }
	
	  //Validate width/height properties
	  var maxFBOSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE)
	  if(width < 0 || width > maxFBOSize || height < 0 || height > maxFBOSize) {
	    throw new Error('gl-fbo: Parameters are too large for FBO')
	  }
	
	  //Handle each option type
	  options = options || {}
	
	  //Figure out number of color buffers to use
	  var numColors = 1
	  if('color' in options) {
	    numColors = Math.max(options.color|0, 0)
	    if(numColors < 0) {
	      throw new Error('gl-fbo: Must specify a nonnegative number of colors')
	    }
	    if(numColors > 1) {
	      //Check if multiple render targets supported
	      if(!WEBGL_draw_buffers) {
	        throw new Error('gl-fbo: Multiple draw buffer extension not supported')
	      } else if(numColors > gl.getParameter(WEBGL_draw_buffers.MAX_COLOR_ATTACHMENTS_WEBGL)) {
	        throw new Error('gl-fbo: Context does not support ' + numColors + ' draw buffers')
	      }
	    }
	  }
	
	  //Determine whether to use floating point textures
	  var colorType = gl.UNSIGNED_BYTE
	  var OES_texture_float = gl.getExtension('OES_texture_float')
	  if(options.float && numColors > 0) {
	    if(!OES_texture_float) {
	      throw new Error('gl-fbo: Context does not support floating point textures')
	    }
	    colorType = gl.FLOAT
	  } else if(options.preferFloat && numColors > 0) {
	    if(OES_texture_float) {
	      colorType = gl.FLOAT
	    }
	  }
	
	  //Check if we should use depth buffer
	  var useDepth = true
	  if('depth' in options) {
	    useDepth = !!options.depth
	  }
	
	  //Check if we should use a stencil buffer
	  var useStencil = false
	  if('stencil' in options) {
	    useStencil = !!options.stencil
	  }
	
	  return new Framebuffer(
	    gl,
	    width,
	    height,
	    colorType,
	    numColors,
	    useDepth,
	    useStencil,
	    WEBGL_draw_buffers)
	}
	
	},{"gl-texture2d":323}],252:[function(_dereq_,module,exports){
	
	var sprintf = _dereq_('sprintf-js').sprintf;
	var glConstants = _dereq_('gl-constants/lookup');
	var shaderName = _dereq_('glsl-shader-name');
	var addLineNumbers = _dereq_('add-line-numbers');
	
	module.exports = formatCompilerError;
	
	function formatCompilerError(errLog, src, type) {
	    "use strict";
	
	    var name = shaderName(src) || 'of unknown name (see npm glsl-shader-name)';
	
	    var typeName = 'unknown type';
	    if (type !== undefined) {
	        typeName = type === glConstants.FRAGMENT_SHADER ? 'fragment' : 'vertex'
	    }
	
	    var longForm = sprintf('Error compiling %s shader %s:\n', typeName, name);
	    var shortForm = sprintf("%s%s", longForm, errLog);
	
	    var errorStrings = errLog.split('\n');
	    var errors = {};
	
	    for (var i = 0; i < errorStrings.length; i++) {
	        var errorString = errorStrings[i];
	        if (errorString === '' || errorString === "\0") continue;
	        var lineNo = parseInt(errorString.split(':')[2]);
	        if (isNaN(lineNo)) {
	            throw new Error(sprintf('Could not parse error: %s', errorString));
	        }
	        errors[lineNo] = errorString;
	    }
	
	    var lines = addLineNumbers(src).split('\n');
	
	    for (var i = 0; i < lines.length; i++) {
	        if (!errors[i+3] && !errors[i+2] && !errors[i+1]) continue;
	        var line = lines[i];
	        longForm += line + '\n';
	        if (errors[i+1]) {
	            var e = errors[i+1];
	            e = e.substr(e.split(':', 3).join(':').length + 1).trim();
	            longForm += sprintf('^^^ %s\n\n', e);
	        }
	    }
	
	    return {
	        long: longForm.trim(),
	        short: shortForm.trim()
	    };
	}
	
	
	},{"add-line-numbers":63,"gl-constants/lookup":248,"glsl-shader-name":402,"sprintf-js":526}],253:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createHeatmap2D
	
	var bsearch = _dereq_('binary-search-bounds')
	var iota = _dereq_('iota-array')
	var pool = _dereq_('typedarray-pool')
	var createShader = _dereq_('gl-shader')
	var createBuffer = _dereq_('gl-buffer')
	
	var shaders = _dereq_('./lib/shaders')
	
	function GLHeatmap2D (
	  plot,
	  shader,
	  pickShader,
	  positionBuffer,
	  weightBuffer,
	  colorBuffer,
	  idBuffer) {
	  this.plot = plot
	  this.shader = shader
	  this.pickShader = pickShader
	  this.positionBuffer = positionBuffer
	  this.weightBuffer = weightBuffer
	  this.colorBuffer = colorBuffer
	  this.idBuffer = idBuffer
	  this.xData = []
	  this.yData = []
	  this.shape = [0, 0]
	  this.bounds = [Infinity, Infinity, -Infinity, -Infinity]
	  this.pickOffset = 0
	}
	
	var proto = GLHeatmap2D.prototype
	
	var WEIGHTS = [
	  0, 0,
	  1, 0,
	  0, 1,
	  1, 0,
	  1, 1,
	  0, 1
	]
	
	proto.draw = (function () {
	  var MATRIX = [
	    1, 0, 0,
	    0, 1, 0,
	    0, 0, 1
	  ]
	
	  return function () {
	    var plot = this.plot
	    var shader = this.shader
	    var bounds = this.bounds
	    var numVertices = this.numVertices
	
	    if (numVertices <= 0) {
	      return
	    }
	
	    var gl = plot.gl
	    var dataBox = plot.dataBox
	
	    var boundX = bounds[2] - bounds[0]
	    var boundY = bounds[3] - bounds[1]
	    var dataX = dataBox[2] - dataBox[0]
	    var dataY = dataBox[3] - dataBox[1]
	
	    MATRIX[0] = 2.0 * boundX / dataX
	    MATRIX[4] = 2.0 * boundY / dataY
	    MATRIX[6] = 2.0 * (bounds[0] - dataBox[0]) / dataX - 1.0
	    MATRIX[7] = 2.0 * (bounds[1] - dataBox[1]) / dataY - 1.0
	
	    shader.bind()
	
	    var uniforms = shader.uniforms
	    uniforms.viewTransform = MATRIX
	
	    uniforms.shape = this.shape
	
	    var attributes = shader.attributes
	    this.positionBuffer.bind()
	    attributes.position.pointer()
	
	    this.weightBuffer.bind()
	    attributes.weight.pointer(gl.UNSIGNED_BYTE, false)
	
	    this.colorBuffer.bind()
	    attributes.color.pointer(gl.UNSIGNED_BYTE, true)
	
	    gl.drawArrays(gl.TRIANGLES, 0, numVertices)
	  }
	})()
	
	proto.drawPick = (function () {
	  var MATRIX = [
	    1, 0, 0,
	    0, 1, 0,
	    0, 0, 1
	  ]
	
	  var PICK_VECTOR = [0, 0, 0, 0]
	
	  return function (pickOffset) {
	    var plot = this.plot
	    var shader = this.pickShader
	    var bounds = this.bounds
	    var numVertices = this.numVertices
	
	    if (numVertices <= 0) {
	      return
	    }
	
	    var gl = plot.gl
	    var dataBox = plot.dataBox
	
	    var boundX = bounds[2] - bounds[0]
	    var boundY = bounds[3] - bounds[1]
	    var dataX = dataBox[2] - dataBox[0]
	    var dataY = dataBox[3] - dataBox[1]
	
	    MATRIX[0] = 2.0 * boundX / dataX
	    MATRIX[4] = 2.0 * boundY / dataY
	    MATRIX[6] = 2.0 * (bounds[0] - dataBox[0]) / dataX - 1.0
	    MATRIX[7] = 2.0 * (bounds[1] - dataBox[1]) / dataY - 1.0
	
	    for (var i = 0; i < 4; ++i) {
	      PICK_VECTOR[i] = (pickOffset >> (i * 8)) & 0xff
	    }
	
	    this.pickOffset = pickOffset
	
	    shader.bind()
	
	    var uniforms = shader.uniforms
	    uniforms.viewTransform = MATRIX
	    uniforms.pickOffset = PICK_VECTOR
	    uniforms.shape = this.shape
	
	    var attributes = shader.attributes
	    this.positionBuffer.bind()
	    attributes.position.pointer()
	
	    this.weightBuffer.bind()
	    attributes.weight.pointer(gl.UNSIGNED_BYTE, false)
	
	    this.idBuffer.bind()
	    attributes.pickId.pointer(gl.UNSIGNED_BYTE, false)
	
	    gl.drawArrays(gl.TRIANGLES, 0, numVertices)
	
	    return pickOffset + this.shape[0] * this.shape[1]
	  }
	})()
	
	proto.pick = function (x, y, value) {
	  var pickOffset = this.pickOffset
	  var pointCount = this.shape[0] * this.shape[1]
	  if (value < pickOffset || value >= pickOffset + pointCount) {
	    return null
	  }
	  var pointId = value - pickOffset
	  var xData = this.xData
	  var yData = this.yData
	  return {
	    object: this,
	    pointId: pointId,
	    dataCoord: [
	      xData[pointId % this.shape[0]],
	      yData[(pointId / this.shape[0]) | 0]]
	  }
	}
	
	proto.update = function (options) {
	  options = options || {}
	
	  var shape = options.shape || [0, 0]
	
	  var x = options.x || iota(shape[0])
	  var y = options.y || iota(shape[1])
	  var z = options.z || new Float32Array(shape[0] * shape[1])
	
	  this.xData = x
	  this.yData = y
	
	  var colorLevels = options.colorLevels || [0]
	  var colorValues = options.colorValues || [0, 0, 0, 1]
	  var colorCount = colorLevels.length
	
	  var bounds = this.bounds
	  var lox = bounds[0] = x[0]
	  var loy = bounds[1] = y[0]
	  var hix = bounds[2] = x[x.length - 1]
	  var hiy = bounds[3] = y[y.length - 1]
	
	  var xs = 1.0 / (hix - lox)
	  var ys = 1.0 / (hiy - loy)
	
	  var numX = shape[0]
	  var numY = shape[1]
	
	  this.shape = [numX, numY]
	
	  var numVerts = (numX - 1) * (numY - 1) * (WEIGHTS.length >>> 1)
	
	  this.numVertices = numVerts
	
	  var colors = pool.mallocUint8(numVerts * 4)
	  var positions = pool.mallocFloat32(numVerts * 2)
	  var weights   = pool.mallocUint8 (numVerts * 2)
	  var ids = pool.mallocUint32(numVerts)
	
	  var ptr = 0
	
	  for (var j = 0; j < numY - 1; ++j) {
	    var yc0 = ys * (y[j] - loy)
	    var yc1 = ys * (y[j + 1] - loy)
	    for (var i = 0; i < numX - 1; ++i) {
	      var xc0 = xs * (x[i] - lox)
	      var xc1 = xs * (x[i + 1] - lox)
	
	      for (var dd = 0; dd < WEIGHTS.length; dd += 2) {
	        var dx = WEIGHTS[dd]
	        var dy = WEIGHTS[dd + 1]
	        var offset = (j + dy) * numX + (i + dx)
	        var zc = z[offset]
	        var colorIdx = bsearch.le(colorLevels, zc)
	        var r, g, b, a
	        if (colorIdx < 0) {
	          r = colorValues[0]
	          g = colorValues[1]
	          b = colorValues[2]
	          a = colorValues[3]
	        } else if (colorIdx === colorCount - 1) {
	          r = colorValues[4 * colorCount - 4]
	          g = colorValues[4 * colorCount - 3]
	          b = colorValues[4 * colorCount - 2]
	          a = colorValues[4 * colorCount - 1]
	        } else {
	          var t = (zc - colorLevels[colorIdx]) /
	            (colorLevels[colorIdx + 1] - colorLevels[colorIdx])
	          var ti = 1.0 - t
	          var i0 = 4 * colorIdx
	          var i1 = 4 * (colorIdx + 1)
	          r = ti * colorValues[i0] + t * colorValues[i1]
	          g = ti * colorValues[i0 + 1] + t * colorValues[i1 + 1]
	          b = ti * colorValues[i0 + 2] + t * colorValues[i1 + 2]
	          a = ti * colorValues[i0 + 3] + t * colorValues[i1 + 3]
	        }
	
	        colors[4 * ptr] = 255 * r
	        colors[4 * ptr + 1] = 255 * g
	        colors[4 * ptr + 2] = 255 * b
	        colors[4 * ptr + 3] = 255 * a
	
	        positions[2*ptr] = xc0*.5 + xc1*.5;
	        positions[2*ptr+1] = yc0*.5 + yc1*.5;
	
	        weights[2*ptr] = dx;
	        weights[2*ptr+1] = dy;
	
	        ids[ptr] = j * numX + i
	
	        ptr += 1
	      }
	    }
	  }
	
	  this.positionBuffer.update(positions)
	  this.weightBuffer.update(weights)
	  this.colorBuffer.update(colors)
	  this.idBuffer.update(ids)
	
	  pool.free(positions)
	  pool.free(colors)
	  pool.free(weights)
	  pool.free(ids)
	}
	
	proto.dispose = function () {
	  this.shader.dispose()
	  this.pickShader.dispose()
	  this.positionBuffer.dispose()
	  this.weightBuffer.dispose()
	  this.colorBuffer.dispose()
	  this.idBuffer.dispose()
	  this.plot.removeObject(this)
	}
	
	function createHeatmap2D (plot, options) {
	  var gl = plot.gl
	
	  var shader = createShader(gl, shaders.vertex, shaders.fragment)
	  var pickShader = createShader(gl, shaders.pickVertex, shaders.pickFragment)
	
	  var positionBuffer = createBuffer(gl)
	  var weightBuffer   = createBuffer(gl)
	  var colorBuffer = createBuffer(gl)
	  var idBuffer = createBuffer(gl)
	
	  var heatmap = new GLHeatmap2D(
	    plot,
	    shader,
	    pickShader,
	    positionBuffer,
	    weightBuffer,
	    colorBuffer,
	    idBuffer)
	
	  heatmap.update(options)
	  plot.addObject(heatmap)
	
	  return heatmap
	}
	
	},{"./lib/shaders":254,"binary-search-bounds":255,"gl-buffer":243,"gl-shader":303,"iota-array":417,"typedarray-pool":543}],254:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify = _dereq_('glslify')
	
	module.exports = {
	  fragment:     glslify(["precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"]),
	  vertex:       glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]),
	  pickFragment: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"]),
	  pickVertex:   glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"])
	}
	
	},{"glslify":410}],255:[function(_dereq_,module,exports){
	arguments[4][112][0].apply(exports,arguments)
	},{"dup":112}],256:[function(_dereq_,module,exports){
	var glslify       = _dereq_('glslify')
	var createShader  = _dereq_('gl-shader')
	
	var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"])
	var forwardFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"])
	var pickFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\nlowp vec4 encode_float_1540259130(highp float v) {\n  highp float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  highp vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  highp float e = floor(log2(av));\n  highp float m = av * pow(2.0, -e) - 1.0;\n  \n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n  \n  //Unpack exponent\n  highp float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0; \n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, encode_float_1540259130(pixelArcLength).xyz);\n}"])
	
	var ATTRIBUTES = [
	  {name: 'position', type: 'vec3'},
	  {name: 'nextPosition', type: 'vec3'},
	  {name: 'arcLength', type: 'float'},
	  {name: 'lineWidth', type: 'float'},
	  {name: 'color', type: 'vec4'}
	]
	
	exports.createShader = function(gl) {
	  return createShader(gl, vertSrc, forwardFrag, null, ATTRIBUTES)
	}
	
	exports.createPickShader = function(gl) {
	  return createShader(gl, vertSrc, pickFrag, null, ATTRIBUTES)
	}
	
	},{"gl-shader":303,"glslify":410}],257:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createLinePlot
	
	var createBuffer = _dereq_('gl-buffer')
	var createVAO = _dereq_('gl-vao')
	var createTexture = _dereq_('gl-texture2d')
	var unpackFloat = _dereq_('glsl-read-float')
	var bsearch = _dereq_('binary-search-bounds')
	var ndarray = _dereq_('ndarray')
	var shaders = _dereq_('./lib/shaders')
	
	var createShader = shaders.createShader
	var createPickShader = shaders.createPickShader
	
	var identity = [1, 0, 0, 0,
	  0, 1, 0, 0,
	  0, 0, 1, 0,
	  0, 0, 0, 1]
	
	function distance (a, b) {
	  var s = 0.0
	  for (var i = 0; i < 3; ++i) {
	    var d = a[i] - b[i]
	    s += d * d
	  }
	  return Math.sqrt(s)
	}
	
	function filterClipBounds (bounds) {
	  var result = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]]
	  for (var i = 0; i < 3; ++i) {
	    result[0][i] = Math.max(bounds[0][i], result[0][i])
	    result[1][i] = Math.min(bounds[1][i], result[1][i])
	  }
	  return result
	}
	
	function PickResult (tau, position, index, dataCoordinate) {
	  this.arcLength = tau
	  this.position = position
	  this.index = index
	  this.dataCoordinate = dataCoordinate
	}
	
	function LinePlot (gl, shader, pickShader, buffer, vao, texture) {
	  this.gl = gl
	  this.shader = shader
	  this.pickShader = pickShader
	  this.buffer = buffer
	  this.vao = vao
	  this.clipBounds = [
	    [ -Infinity, -Infinity, -Infinity ],
	    [ Infinity, Infinity, Infinity ]]
	  this.points = []
	  this.arcLength = []
	  this.vertexCount = 0
	  this.bounds = [[0, 0, 0], [0, 0, 0]]
	  this.pickId = 0
	  this.lineWidth = 1
	  this.texture = texture
	  this.dashScale = 1
	  this.opacity = 1
	  this.hasAlpha = false
	  this.dirty = true
	  this.pixelRatio = 1
	}
	
	var proto = LinePlot.prototype
	
	proto.isTransparent = function () {
	  return this.hasAlpha
	}
	
	proto.isOpaque = function () {
	  return !this.hasAlpha
	}
	
	proto.pickSlots = 1
	
	proto.setPickBase = function (id) {
	  this.pickId = id
	}
	
	proto.drawTransparent = proto.draw = function (camera) {
	  if (!this.vertexCount) return
	  var gl = this.gl
	  var shader = this.shader
	  var vao = this.vao
	  shader.bind()
	  shader.uniforms = {
	    model: camera.model || identity,
	    view: camera.view || identity,
	    projection: camera.projection || identity,
	    clipBounds: filterClipBounds(this.clipBounds),
	    dashTexture: this.texture.bind(),
	    dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
	    opacity: this.opacity,
	    screenShape: [gl.drawingBufferWidth, gl.drawingBufferHeight],
	    pixelRatio: this.pixelRatio
	  }
	  vao.bind()
	  vao.draw(gl.TRIANGLE_STRIP, this.vertexCount)
	  vao.unbind()
	}
	
	proto.drawPick = function (camera) {
	  if (!this.vertexCount) return
	  var gl = this.gl
	  var shader = this.pickShader
	  var vao = this.vao
	  shader.bind()
	  shader.uniforms = {
	    model: camera.model || identity,
	    view: camera.view || identity,
	    projection: camera.projection || identity,
	    pickId: this.pickId,
	    clipBounds: filterClipBounds(this.clipBounds),
	    screenShape: [gl.drawingBufferWidth, gl.drawingBufferHeight],
	    pixelRatio: this.pixelRatio
	  }
	  vao.bind()
	  vao.draw(gl.TRIANGLE_STRIP, this.vertexCount)
	  vao.unbind()
	}
	
	proto.update = function (options) {
	  var i, j
	
	  this.dirty = true
	
	  var connectGaps = !!options.connectGaps
	
	  if ('dashScale' in options) {
	    this.dashScale = options.dashScale
	  }
	
	  this.hasAlpha = false // default to no transparent draw
	  if ('opacity' in options) {
	    this.opacity = +options.opacity
	    if(this.opacity < 1) {
	      this.hasAlpha = true;
	    }
	  }
	
	  // Recalculate buffer data
	  var buffer = []
	  var arcLengthArray = []
	  var pointArray = []
	  var arcLength = 0.0
	  var vertexCount = 0
	  var bounds = [
	    [ Infinity, Infinity, Infinity ],
	    [ -Infinity, -Infinity, -Infinity ]]
	
	  var positions = options.position || options.positions
	  if (positions) {
	
	    // Default color
	    var colors = options.color || options.colors || [0, 0, 0, 1]
	
	    var lineWidth = options.lineWidth || 1
	
	    var hadGap = false
	
	    fill_loop:
	    for (i = 1; i < positions.length; ++i) {
	      var a = positions[i - 1]
	      var b = positions[i]
	
	      arcLengthArray.push(arcLength)
	      pointArray.push(a.slice())
	
	      for (j = 0; j < 3; ++j) {
	        if (isNaN(a[j]) || isNaN(b[j]) ||
	          !isFinite(a[j]) || !isFinite(b[j])) {
	
	          if (!connectGaps && buffer.length > 0) {
	            for (var k = 0; k < 24; ++k) {
	              buffer.push(buffer[buffer.length - 12])
	            }
	            vertexCount += 2
	            hadGap = true
	          }
	
	          continue fill_loop
	        }
	        bounds[0][j] = Math.min(bounds[0][j], a[j], b[j])
	        bounds[1][j] = Math.max(bounds[1][j], a[j], b[j])
	      }
	
	      var acolor, bcolor
	      if (Array.isArray(colors[0])) {
	        acolor = (colors.length > i - 1) ? colors[i - 1] :             // using index value
	                 (colors.length > 0)     ? colors[colors.length - 1] : // using last item
	                                           [0, 0, 0, 1];               // using black
	
	        bcolor = (colors.length > i) ? colors[i] :                 // using index value
	                 (colors.length > 0) ? colors[colors.length - 1] : // using last item
	                                       [0, 0, 0, 1];               // using black
	      } else {
	        acolor = bcolor = colors
	      }
	
	      if (acolor.length === 3) {
	        acolor = [acolor[0], acolor[1], acolor[2], 1]
	      }
	      if (bcolor.length === 3) {
	        bcolor = [bcolor[0], bcolor[1], bcolor[2], 1]
	      }
	
	      if(!this.hasAlpha && acolor[3] < 1) this.hasAlpha = true
	
	      var w0
	      if (Array.isArray(lineWidth)) {
	        w0 = (lineWidth.length > i - 1) ? lineWidth[i - 1] :                // using index value
	             (lineWidth.length > 0)     ? lineWidth[lineWidth.length - 1] : // using last item
	                                          [0, 0, 0, 1];                     // using black
	      } else {
	        w0 = lineWidth
	      }
	
	      var t0 = arcLength
	      arcLength += distance(a, b)
	
	      if (hadGap) {
	        for (j = 0; j < 2; ++j) {
	          buffer.push(
	            a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3])
	        }
	        vertexCount += 2
	        hadGap = false
	      }
	
	      buffer.push(
	        a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3],
	        a[0], a[1], a[2], b[0], b[1], b[2], t0, -w0, acolor[0], acolor[1], acolor[2], acolor[3],
	        b[0], b[1], b[2], a[0], a[1], a[2], arcLength, -w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3],
	        b[0], b[1], b[2], a[0], a[1], a[2], arcLength, w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3])
	
	      vertexCount += 4
	    }
	  }
	  this.buffer.update(buffer)
	
	  arcLengthArray.push(arcLength)
	  pointArray.push(positions[positions.length - 1].slice())
	
	  this.bounds = bounds
	
	  this.vertexCount = vertexCount
	
	  this.points = pointArray
	  this.arcLength = arcLengthArray
	
	  if ('dashes' in options) {
	    var dashArray = options.dashes
	
	    // Calculate prefix sum
	    var prefixSum = dashArray.slice()
	    prefixSum.unshift(0)
	    for (i = 1; i < prefixSum.length; ++i) {
	      prefixSum[i] = prefixSum[i - 1] + prefixSum[i]
	    }
	
	    var dashTexture = ndarray(new Array(256 * 4), [256, 1, 4])
	    for (i = 0; i < 256; ++i) {
	      for (j = 0; j < 4; ++j) {
	        dashTexture.set(i, 0, j, 0)
	      }
	      if (bsearch.le(prefixSum, prefixSum[prefixSum.length - 1] * i / 255.0) & 1) {
	        dashTexture.set(i, 0, 0, 0)
	      } else {
	        dashTexture.set(i, 0, 0, 255)
	      }
	    }
	
	    this.texture.setPixels(dashTexture)
	  }
	}
	
	proto.dispose = function () {
	  this.shader.dispose()
	  this.vao.dispose()
	  this.buffer.dispose()
	}
	
	proto.pick = function (selection) {
	  if (!selection) {
	    return null
	  }
	  if (selection.id !== this.pickId) {
	    return null
	  }
	  var tau = unpackFloat(
	    selection.value[0],
	    selection.value[1],
	    selection.value[2],
	    0)
	  var index = bsearch.le(this.arcLength, tau)
	  if (index < 0) {
	    return null
	  }
	  if (index === this.arcLength.length - 1) {
	    return new PickResult(
	      this.arcLength[this.arcLength.length - 1],
	      this.points[this.points.length - 1].slice(),
	      index)
	  }
	  var a = this.points[index]
	  var b = this.points[Math.min(index + 1, this.points.length - 1)]
	  var t = (tau - this.arcLength[index]) / (this.arcLength[index + 1] - this.arcLength[index])
	  var ti = 1.0 - t
	  var x = [0, 0, 0]
	  for (var i = 0; i < 3; ++i) {
	    x[i] = ti * a[i] + t * b[i]
	  }
	  var dataIndex = Math.min((t < 0.5) ? index : (index + 1), this.points.length - 1)
	  return new PickResult(
	    tau,
	    x,
	    dataIndex,
	    this.points[dataIndex])
	}
	
	function createLinePlot (options) {
	  var gl = options.gl || (options.scene && options.scene.gl)
	
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	  shader.attributes.nextPosition.location = 1
	  shader.attributes.arcLength.location = 2
	  shader.attributes.lineWidth.location = 3
	  shader.attributes.color.location = 4
	
	  var pickShader = createPickShader(gl)
	  pickShader.attributes.position.location = 0
	  pickShader.attributes.nextPosition.location = 1
	  pickShader.attributes.arcLength.location = 2
	  pickShader.attributes.lineWidth.location = 3
	  pickShader.attributes.color.location = 4
	
	  var buffer = createBuffer(gl)
	  var vao = createVAO(gl, [
	    {
	      'buffer': buffer,
	      'size': 3,
	      'offset': 0,
	      'stride': 48
	    },
	    {
	      'buffer': buffer,
	      'size': 3,
	      'offset': 12,
	      'stride': 48
	    },
	    {
	      'buffer': buffer,
	      'size': 1,
	      'offset': 24,
	      'stride': 48
	    },
	    {
	      'buffer': buffer,
	      'size': 1,
	      'offset': 28,
	      'stride': 48
	    },
	    {
	      'buffer': buffer,
	      'size': 4,
	      'offset': 32,
	      'stride': 48
	    }
	  ])
	
	  // Create texture for dash pattern
	  var defaultTexture = ndarray(new Array(256 * 4), [256, 1, 4])
	  for (var i = 0; i < 256 * 4; ++i) {
	    defaultTexture.data[i] = 255
	  }
	  var texture = createTexture(gl, defaultTexture)
	  texture.wrap = gl.REPEAT
	
	  var linePlot = new LinePlot(gl, shader, pickShader, buffer, vao, texture)
	  linePlot.update(options)
	  return linePlot
	}
	
	},{"./lib/shaders":256,"binary-search-bounds":258,"gl-buffer":243,"gl-texture2d":323,"gl-vao":328,"glsl-read-float":401,"ndarray":451}],258:[function(_dereq_,module,exports){
	arguments[4][112][0].apply(exports,arguments)
	},{"dup":112}],259:[function(_dereq_,module,exports){
	module.exports = invert
	
	/**
	 * Inverts a mat2
	 *
	 * @alias mat2.invert
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the source matrix
	 * @returns {mat2} out
	 */
	function invert(out, a) {
	  var a0 = a[0]
	  var a1 = a[1]
	  var a2 = a[2]
	  var a3 = a[3]
	  var det = a0 * a3 - a2 * a1
	
	  if (!det) return null
	  det = 1.0 / det
	
	  out[0] =  a3 * det
	  out[1] = -a1 * det
	  out[2] = -a2 * det
	  out[3] =  a0 * det
	
	  return out
	}
	
	},{}],260:[function(_dereq_,module,exports){
	module.exports = invert
	
	/**
	 * Inverts a mat3
	 *
	 * @alias mat3.invert
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the source matrix
	 * @returns {mat3} out
	 */
	function invert(out, a) {
	  var a00 = a[0], a01 = a[1], a02 = a[2]
	  var a10 = a[3], a11 = a[4], a12 = a[5]
	  var a20 = a[6], a21 = a[7], a22 = a[8]
	
	  var b01 = a22 * a11 - a12 * a21
	  var b11 = -a22 * a10 + a12 * a20
	  var b21 = a21 * a10 - a11 * a20
	
	  // Calculate the determinant
	  var det = a00 * b01 + a01 * b11 + a02 * b21
	
	  if (!det) return null
	  det = 1.0 / det
	
	  out[0] = b01 * det
	  out[1] = (-a22 * a01 + a02 * a21) * det
	  out[2] = (a12 * a01 - a02 * a11) * det
	  out[3] = b11 * det
	  out[4] = (a22 * a00 - a02 * a20) * det
	  out[5] = (-a12 * a00 + a02 * a10) * det
	  out[6] = b21 * det
	  out[7] = (-a21 * a00 + a01 * a20) * det
	  out[8] = (a11 * a00 - a01 * a10) * det
	
	  return out
	}
	
	},{}],261:[function(_dereq_,module,exports){
	module.exports = clone;
	
	/**
	 * Creates a new mat4 initialized with values from an existing matrix
	 *
	 * @param {mat4} a matrix to clone
	 * @returns {mat4} a new 4x4 matrix
	 */
	function clone(a) {
	    var out = new Float32Array(16);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    out[9] = a[9];
	    out[10] = a[10];
	    out[11] = a[11];
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	},{}],262:[function(_dereq_,module,exports){
	module.exports = create;
	
	/**
	 * Creates a new identity mat4
	 *
	 * @returns {mat4} a new 4x4 matrix
	 */
	function create() {
	    var out = new Float32Array(16);
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	};
	},{}],263:[function(_dereq_,module,exports){
	module.exports = determinant;
	
	/**
	 * Calculates the determinant of a mat4
	 *
	 * @param {mat4} a the source matrix
	 * @returns {Number} determinant of a
	 */
	function determinant(a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
	
	        b00 = a00 * a11 - a01 * a10,
	        b01 = a00 * a12 - a02 * a10,
	        b02 = a00 * a13 - a03 * a10,
	        b03 = a01 * a12 - a02 * a11,
	        b04 = a01 * a13 - a03 * a11,
	        b05 = a02 * a13 - a03 * a12,
	        b06 = a20 * a31 - a21 * a30,
	        b07 = a20 * a32 - a22 * a30,
	        b08 = a20 * a33 - a23 * a30,
	        b09 = a21 * a32 - a22 * a31,
	        b10 = a21 * a33 - a23 * a31,
	        b11 = a22 * a33 - a23 * a32;
	
	    // Calculate the determinant
	    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	};
	},{}],264:[function(_dereq_,module,exports){
	module.exports = fromQuat;
	
	/**
	 * Creates a matrix from a quaternion rotation.
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat4} q Rotation quaternion
	 * @returns {mat4} out
	 */
	function fromQuat(out, q) {
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        yx = y * x2,
	        yy = y * y2,
	        zx = z * x2,
	        zy = z * y2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2;
	
	    out[0] = 1 - yy - zz;
	    out[1] = yx + wz;
	    out[2] = zx - wy;
	    out[3] = 0;
	
	    out[4] = yx - wz;
	    out[5] = 1 - xx - zz;
	    out[6] = zy + wx;
	    out[7] = 0;
	
	    out[8] = zx + wy;
	    out[9] = zy - wx;
	    out[10] = 1 - xx - yy;
	    out[11] = 0;
	
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	
	    return out;
	};
	},{}],265:[function(_dereq_,module,exports){
	module.exports = fromRotationTranslation;
	
	/**
	 * Creates a matrix from a quaternion rotation and vector translation
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.translate(dest, vec);
	 *     var quatMat = mat4.create();
	 *     quat4.toMat4(quat, quatMat);
	 *     mat4.multiply(dest, quatMat);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat4} q Rotation quaternion
	 * @param {vec3} v Translation vector
	 * @returns {mat4} out
	 */
	function fromRotationTranslation(out, q, v) {
	    // Quaternion math
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        xy = x * y2,
	        xz = x * z2,
	        yy = y * y2,
	        yz = y * z2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2;
	
	    out[0] = 1 - (yy + zz);
	    out[1] = xy + wz;
	    out[2] = xz - wy;
	    out[3] = 0;
	    out[4] = xy - wz;
	    out[5] = 1 - (xx + zz);
	    out[6] = yz + wx;
	    out[7] = 0;
	    out[8] = xz + wy;
	    out[9] = yz - wx;
	    out[10] = 1 - (xx + yy);
	    out[11] = 0;
	    out[12] = v[0];
	    out[13] = v[1];
	    out[14] = v[2];
	    out[15] = 1;
	    
	    return out;
	};
	},{}],266:[function(_dereq_,module,exports){
	module.exports = identity;
	
	/**
	 * Set a mat4 to the identity matrix
	 *
	 * @param {mat4} out the receiving matrix
	 * @returns {mat4} out
	 */
	function identity(out) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	};
	},{}],267:[function(_dereq_,module,exports){
	module.exports = invert;
	
	/**
	 * Inverts a mat4
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	function invert(out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
	
	        b00 = a00 * a11 - a01 * a10,
	        b01 = a00 * a12 - a02 * a10,
	        b02 = a00 * a13 - a03 * a10,
	        b03 = a01 * a12 - a02 * a11,
	        b04 = a01 * a13 - a03 * a11,
	        b05 = a02 * a13 - a03 * a12,
	        b06 = a20 * a31 - a21 * a30,
	        b07 = a20 * a32 - a22 * a30,
	        b08 = a20 * a33 - a23 * a30,
	        b09 = a21 * a32 - a22 * a31,
	        b10 = a21 * a33 - a23 * a31,
	        b11 = a22 * a33 - a23 * a32,
	
	        // Calculate the determinant
	        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	
	    if (!det) { 
	        return null; 
	    }
	    det = 1.0 / det;
	
	    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	
	    return out;
	};
	},{}],268:[function(_dereq_,module,exports){
	var identity = _dereq_('./identity');
	
	module.exports = lookAt;
	
	/**
	 * Generates a look-at matrix with the given eye position, focal point, and up axis
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {vec3} eye Position of the viewer
	 * @param {vec3} center Point the viewer is looking at
	 * @param {vec3} up vec3 pointing up
	 * @returns {mat4} out
	 */
	function lookAt(out, eye, center, up) {
	    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len,
	        eyex = eye[0],
	        eyey = eye[1],
	        eyez = eye[2],
	        upx = up[0],
	        upy = up[1],
	        upz = up[2],
	        centerx = center[0],
	        centery = center[1],
	        centerz = center[2];
	
	    if (Math.abs(eyex - centerx) < 0.000001 &&
	        Math.abs(eyey - centery) < 0.000001 &&
	        Math.abs(eyez - centerz) < 0.000001) {
	        return identity(out);
	    }
	
	    z0 = eyex - centerx;
	    z1 = eyey - centery;
	    z2 = eyez - centerz;
	
	    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
	    z0 *= len;
	    z1 *= len;
	    z2 *= len;
	
	    x0 = upy * z2 - upz * z1;
	    x1 = upz * z0 - upx * z2;
	    x2 = upx * z1 - upy * z0;
	    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
	    if (!len) {
	        x0 = 0;
	        x1 = 0;
	        x2 = 0;
	    } else {
	        len = 1 / len;
	        x0 *= len;
	        x1 *= len;
	        x2 *= len;
	    }
	
	    y0 = z1 * x2 - z2 * x1;
	    y1 = z2 * x0 - z0 * x2;
	    y2 = z0 * x1 - z1 * x0;
	
	    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
	    if (!len) {
	        y0 = 0;
	        y1 = 0;
	        y2 = 0;
	    } else {
	        len = 1 / len;
	        y0 *= len;
	        y1 *= len;
	        y2 *= len;
	    }
	
	    out[0] = x0;
	    out[1] = y0;
	    out[2] = z0;
	    out[3] = 0;
	    out[4] = x1;
	    out[5] = y1;
	    out[6] = z1;
	    out[7] = 0;
	    out[8] = x2;
	    out[9] = y2;
	    out[10] = z2;
	    out[11] = 0;
	    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
	    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
	    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
	    out[15] = 1;
	
	    return out;
	};
	},{"./identity":266}],269:[function(_dereq_,module,exports){
	module.exports = multiply;
	
	/**
	 * Multiplies two mat4's
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @returns {mat4} out
	 */
	function multiply(out, a, b) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	
	    // Cache only the current line of the second matrix
	    var b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];  
	    out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
	    out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
	    out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
	    out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	    return out;
	};
	},{}],270:[function(_dereq_,module,exports){
	module.exports = ortho;
	
	/**
	 * Generates a orthogonal projection matrix with the given bounds
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {number} left Left bound of the frustum
	 * @param {number} right Right bound of the frustum
	 * @param {number} bottom Bottom bound of the frustum
	 * @param {number} top Top bound of the frustum
	 * @param {number} near Near bound of the frustum
	 * @param {number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	function ortho(out, left, right, bottom, top, near, far) {
	    var lr = 1 / (left - right),
	        bt = 1 / (bottom - top),
	        nf = 1 / (near - far);
	    out[0] = -2 * lr;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = -2 * bt;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 2 * nf;
	    out[11] = 0;
	    out[12] = (left + right) * lr;
	    out[13] = (top + bottom) * bt;
	    out[14] = (far + near) * nf;
	    out[15] = 1;
	    return out;
	};
	},{}],271:[function(_dereq_,module,exports){
	module.exports = perspective;
	
	/**
	 * Generates a perspective projection matrix with the given bounds
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {number} fovy Vertical field of view in radians
	 * @param {number} aspect Aspect ratio. typically viewport width/height
	 * @param {number} near Near bound of the frustum
	 * @param {number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	function perspective(out, fovy, aspect, near, far) {
	    var f = 1.0 / Math.tan(fovy / 2),
	        nf = 1 / (near - far);
	    out[0] = f / aspect;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = f;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = (far + near) * nf;
	    out[11] = -1;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = (2 * far * near) * nf;
	    out[15] = 0;
	    return out;
	};
	},{}],272:[function(_dereq_,module,exports){
	module.exports = rotate;
	
	/**
	 * Rotates a mat4 by the given angle
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @param {vec3} axis the axis to rotate around
	 * @returns {mat4} out
	 */
	function rotate(out, a, rad, axis) {
	    var x = axis[0], y = axis[1], z = axis[2],
	        len = Math.sqrt(x * x + y * y + z * z),
	        s, c, t,
	        a00, a01, a02, a03,
	        a10, a11, a12, a13,
	        a20, a21, a22, a23,
	        b00, b01, b02,
	        b10, b11, b12,
	        b20, b21, b22;
	
	    if (Math.abs(len) < 0.000001) { return null; }
	    
	    len = 1 / len;
	    x *= len;
	    y *= len;
	    z *= len;
	
	    s = Math.sin(rad);
	    c = Math.cos(rad);
	    t = 1 - c;
	
	    a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
	    a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
	    a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
	
	    // Construct the elements of the rotation matrix
	    b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
	    b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
	    b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;
	
	    // Perform rotation-specific matrix multiplication
	    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
	    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
	    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
	    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
	    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
	    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
	    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
	    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
	    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
	    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
	    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
	    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged last row
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	    return out;
	};
	},{}],273:[function(_dereq_,module,exports){
	module.exports = rotateX;
	
	/**
	 * Rotates a matrix by the given angle around the X axis
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	function rotateX(out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a10 = a[4],
	        a11 = a[5],
	        a12 = a[6],
	        a13 = a[7],
	        a20 = a[8],
	        a21 = a[9],
	        a22 = a[10],
	        a23 = a[11];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	        out[0]  = a[0];
	        out[1]  = a[1];
	        out[2]  = a[2];
	        out[3]  = a[3];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[4] = a10 * c + a20 * s;
	    out[5] = a11 * c + a21 * s;
	    out[6] = a12 * c + a22 * s;
	    out[7] = a13 * c + a23 * s;
	    out[8] = a20 * c - a10 * s;
	    out[9] = a21 * c - a11 * s;
	    out[10] = a22 * c - a12 * s;
	    out[11] = a23 * c - a13 * s;
	    return out;
	};
	},{}],274:[function(_dereq_,module,exports){
	module.exports = rotateY;
	
	/**
	 * Rotates a matrix by the given angle around the Y axis
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	function rotateY(out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a00 = a[0],
	        a01 = a[1],
	        a02 = a[2],
	        a03 = a[3],
	        a20 = a[8],
	        a21 = a[9],
	        a22 = a[10],
	        a23 = a[11];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	        out[4]  = a[4];
	        out[5]  = a[5];
	        out[6]  = a[6];
	        out[7]  = a[7];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[0] = a00 * c - a20 * s;
	    out[1] = a01 * c - a21 * s;
	    out[2] = a02 * c - a22 * s;
	    out[3] = a03 * c - a23 * s;
	    out[8] = a00 * s + a20 * c;
	    out[9] = a01 * s + a21 * c;
	    out[10] = a02 * s + a22 * c;
	    out[11] = a03 * s + a23 * c;
	    return out;
	};
	},{}],275:[function(_dereq_,module,exports){
	module.exports = rotateZ;
	
	/**
	 * Rotates a matrix by the given angle around the Z axis
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	function rotateZ(out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a00 = a[0],
	        a01 = a[1],
	        a02 = a[2],
	        a03 = a[3],
	        a10 = a[4],
	        a11 = a[5],
	        a12 = a[6],
	        a13 = a[7];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged last row
	        out[8]  = a[8];
	        out[9]  = a[9];
	        out[10] = a[10];
	        out[11] = a[11];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[0] = a00 * c + a10 * s;
	    out[1] = a01 * c + a11 * s;
	    out[2] = a02 * c + a12 * s;
	    out[3] = a03 * c + a13 * s;
	    out[4] = a10 * c - a00 * s;
	    out[5] = a11 * c - a01 * s;
	    out[6] = a12 * c - a02 * s;
	    out[7] = a13 * c - a03 * s;
	    return out;
	};
	},{}],276:[function(_dereq_,module,exports){
	module.exports = scale;
	
	/**
	 * Scales the mat4 by the dimensions in the given vec3
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to scale
	 * @param {vec3} v the vec3 to scale the matrix by
	 * @returns {mat4} out
	 **/
	function scale(out, a, v) {
	    var x = v[0], y = v[1], z = v[2];
	
	    out[0] = a[0] * x;
	    out[1] = a[1] * x;
	    out[2] = a[2] * x;
	    out[3] = a[3] * x;
	    out[4] = a[4] * y;
	    out[5] = a[5] * y;
	    out[6] = a[6] * y;
	    out[7] = a[7] * y;
	    out[8] = a[8] * z;
	    out[9] = a[9] * z;
	    out[10] = a[10] * z;
	    out[11] = a[11] * z;
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	},{}],277:[function(_dereq_,module,exports){
	module.exports = translate;
	
	/**
	 * Translate a mat4 by the given vector
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to translate
	 * @param {vec3} v vector to translate by
	 * @returns {mat4} out
	 */
	function translate(out, a, v) {
	    var x = v[0], y = v[1], z = v[2],
	        a00, a01, a02, a03,
	        a10, a11, a12, a13,
	        a20, a21, a22, a23;
	
	    if (a === out) {
	        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	    } else {
	        a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
	        a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
	        a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
	
	        out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
	        out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
	        out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;
	
	        out[12] = a00 * x + a10 * y + a20 * z + a[12];
	        out[13] = a01 * x + a11 * y + a21 * z + a[13];
	        out[14] = a02 * x + a12 * y + a22 * z + a[14];
	        out[15] = a03 * x + a13 * y + a23 * z + a[15];
	    }
	
	    return out;
	};
	},{}],278:[function(_dereq_,module,exports){
	module.exports = transpose;
	
	/**
	 * Transpose the values of a mat4
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	function transpose(out, a) {
	    // If we are transposing ourselves we can skip a few steps but have to cache some values
	    if (out === a) {
	        var a01 = a[1], a02 = a[2], a03 = a[3],
	            a12 = a[6], a13 = a[7],
	            a23 = a[11];
	
	        out[1] = a[4];
	        out[2] = a[8];
	        out[3] = a[12];
	        out[4] = a01;
	        out[6] = a[9];
	        out[7] = a[13];
	        out[8] = a02;
	        out[9] = a12;
	        out[11] = a[14];
	        out[12] = a03;
	        out[13] = a13;
	        out[14] = a23;
	    } else {
	        out[0] = a[0];
	        out[1] = a[4];
	        out[2] = a[8];
	        out[3] = a[12];
	        out[4] = a[1];
	        out[5] = a[5];
	        out[6] = a[9];
	        out[7] = a[13];
	        out[8] = a[2];
	        out[9] = a[6];
	        out[10] = a[10];
	        out[11] = a[14];
	        out[12] = a[3];
	        out[13] = a[7];
	        out[14] = a[11];
	        out[15] = a[15];
	    }
	    
	    return out;
	};
	},{}],279:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = invert
	
	var invert2 = _dereq_('gl-mat2/invert')
	var invert3 = _dereq_('gl-mat3/invert')
	var invert4 = _dereq_('gl-mat4/invert')
	
	function invert(out, M) {
	  switch(M.length) {
	    case 0:
	    break
	    case 1:
	      out[0] = 1.0 / M[0]
	    break
	    case 4:
	      invert2(out, M)
	    break
	    case 9:
	      invert3(out, M)
	    break
	    case 16:
	      invert4(out, M)
	    break
	    default:
	      throw new Error('currently supports matrices up to 4x4')
	    break
	  }
	  return out
	}
	},{"gl-mat2/invert":259,"gl-mat3/invert":260,"gl-mat4/invert":267}],280:[function(_dereq_,module,exports){
	'use strict'
	
	var barycentric            = _dereq_('barycentric')
	var closestPointToTriangle = _dereq_('polytope-closest-point/lib/closest_point_2d.js')
	
	module.exports = closestPointToPickLocation
	
	function xformMatrix(m, v) {
	  var out = [0,0,0,0]
	  for(var i=0; i<4; ++i) {
	    for(var j=0; j<4; ++j) {
	      out[j] += m[4*i + j] * v[i]
	    }
	  }
	  return out
	}
	
	function projectVertex(v, model, view, projection, resolution) {
	  var p = xformMatrix(projection,
	            xformMatrix(view,
	              xformMatrix(model, [v[0], v[1], v[2], 1])))
	  for(var i=0; i<3; ++i) {
	    p[i] /= p[3]
	  }
	  return [ 0.5 * resolution[0] * (1.0+p[0]), 0.5 * resolution[1] * (1.0-p[1]) ]
	}
	
	function barycentricCoord(simplex, point) {
	  if(simplex.length === 2) {
	    var d0 = 0.0
	    var d1 = 0.0
	    for(var i=0; i<2; ++i) {
	      d0 += Math.pow(point[i] - simplex[0][i], 2)
	      d1 += Math.pow(point[i] - simplex[1][i], 2)
	    }
	    d0 = Math.sqrt(d0)
	    d1 = Math.sqrt(d1)
	    if(d0+d1 < 1e-6) {
	      return [1,0]
	    }
	    return [d1/(d0+d1),d0/(d1+d0)]
	  } else if(simplex.length === 3) {
	    var closestPoint = [0,0]
	    closestPointToTriangle(simplex[0], simplex[1], simplex[2], point, closestPoint)
	    return barycentric(simplex, closestPoint)
	  }
	  return []
	}
	
	function interpolate(simplex, weights) {
	  var result = [0,0,0]
	  for(var i=0; i<simplex.length; ++i) {
	    var p = simplex[i]
	    var w = weights[i]
	    for(var j=0; j<3; ++j) {
	      result[j] += w * p[j]
	    }
	  }
	  return result
	}
	
	function closestPointToPickLocation(simplex, pixelCoord, model, view, projection, resolution) {
	  if(simplex.length === 1) {
	    return [0, simplex[0].slice()]
	  }
	  var simplex2D = new Array(simplex.length)
	  for(var i=0; i<simplex.length; ++i) {
	    simplex2D[i] = projectVertex(simplex[i], model, view, projection, resolution);
	  }
	
	  var closestIndex = 0
	  var closestDist  = Infinity
	  for(var i=0; i<simplex2D.length; ++i) {
	    var d2 = 0.0
	    for(var j=0; j<2; ++j) {
	      d2 += Math.pow(simplex2D[i][j] - pixelCoord[j], 2)
	    }
	    if(d2 < closestDist) {
	      closestDist  = d2
	      closestIndex = i
	    }
	  }
	
	  var weights = barycentricCoord(simplex2D, pixelCoord)
	  var s = 0.0
	  for(var i=0; i<3; ++i) {
	    if(weights[i] < -0.001 ||
	       weights[i] > 1.0001) {
	      return null
	    }
	    s += weights[i]
	  }
	  if(Math.abs(s - 1.0) > 0.001) {
	    return null
	  }
	  return [closestIndex, interpolate(simplex, weights), weights]
	}
	},{"barycentric":74,"polytope-closest-point/lib/closest_point_2d.js":482}],281:[function(_dereq_,module,exports){
	var glslify       = _dereq_('glslify')
	
	var triVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"])
	var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"])
	var edgeVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"])
	var edgeFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"])
	var pointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"])
	var pointFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"])
	var pickVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"])
	var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
	var pickPointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"])
	var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"])
	var contourFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"])
	
	exports.meshShader = {
	  vertex:   triVertSrc,
	  fragment: triFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'},
	    {name: 'normal', type: 'vec3'},
	    {name: 'color', type: 'vec4'},
	    {name: 'uv', type: 'vec2'}
	  ]
	}
	exports.wireShader = {
	  vertex:   edgeVertSrc,
	  fragment: edgeFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'},
	    {name: 'color', type: 'vec4'},
	    {name: 'uv', type: 'vec2'}
	  ]
	}
	exports.pointShader = {
	  vertex:   pointVertSrc,
	  fragment: pointFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'},
	    {name: 'color', type: 'vec4'},
	    {name: 'uv', type: 'vec2'},
	    {name: 'pointSize', type: 'float'}
	  ]
	}
	exports.pickShader = {
	  vertex:   pickVertSrc,
	  fragment: pickFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'},
	    {name: 'id', type: 'vec4'}
	  ]
	}
	exports.pointPickShader = {
	  vertex:   pickPointVertSrc,
	  fragment: pickFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'},
	    {name: 'pointSize', type: 'float'},
	    {name: 'id', type: 'vec4'}
	  ]
	}
	exports.contourShader = {
	  vertex:   contourVertSrc,
	  fragment: contourFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec3'}
	  ]
	}
	
	},{"glslify":410}],282:[function(_dereq_,module,exports){
	'use strict'
	
	var DEFAULT_VERTEX_NORMALS_EPSILON = 1e-6; // may be too large if triangles are very small
	var DEFAULT_FACE_NORMALS_EPSILON = 1e-6;
	
	var createShader  = _dereq_('gl-shader')
	var createBuffer  = _dereq_('gl-buffer')
	var createVAO     = _dereq_('gl-vao')
	var createTexture = _dereq_('gl-texture2d')
	var normals       = _dereq_('normals')
	var multiply      = _dereq_('gl-mat4/multiply')
	var invert        = _dereq_('gl-mat4/invert')
	var ndarray       = _dereq_('ndarray')
	var colormap      = _dereq_('colormap')
	var getContour    = _dereq_('simplicial-complex-contour')
	var pool          = _dereq_('typedarray-pool')
	var shaders       = _dereq_('./lib/shaders')
	var closestPoint  = _dereq_('./lib/closest-point')
	
	var meshShader    = shaders.meshShader
	var wireShader    = shaders.wireShader
	var pointShader   = shaders.pointShader
	var pickShader    = shaders.pickShader
	var pointPickShader = shaders.pointPickShader
	var contourShader = shaders.contourShader
	
	var IDENTITY = [
	  1,0,0,0,
	  0,1,0,0,
	  0,0,1,0,
	  0,0,0,1]
	
	
	function SimplicialMesh(gl
	  , texture
	  , triShader
	  , lineShader
	  , pointShader
	  , pickShader
	  , pointPickShader
	  , contourShader
	  , trianglePositions
	  , triangleIds
	  , triangleColors
	  , triangleUVs
	  , triangleNormals
	  , triangleVAO
	  , edgePositions
	  , edgeIds
	  , edgeColors
	  , edgeUVs
	  , edgeVAO
	  , pointPositions
	  , pointIds
	  , pointColors
	  , pointUVs
	  , pointSizes
	  , pointVAO
	  , contourPositions
	  , contourVAO) {
	
	  this.gl                = gl
	  this.pixelRatio         = 1
	  this.cells             = []
	  this.positions         = []
	  this.intensity         = []
	  this.texture           = texture
	  this.dirty             = true
	
	  this.triShader         = triShader
	  this.lineShader        = lineShader
	  this.pointShader       = pointShader
	  this.pickShader        = pickShader
	  this.pointPickShader   = pointPickShader
	  this.contourShader     = contourShader
	
	  this.trianglePositions = trianglePositions
	  this.triangleColors    = triangleColors
	  this.triangleNormals   = triangleNormals
	  this.triangleUVs       = triangleUVs
	  this.triangleIds       = triangleIds
	  this.triangleVAO       = triangleVAO
	  this.triangleCount     = 0
	
	  this.lineWidth         = 1
	  this.edgePositions     = edgePositions
	  this.edgeColors        = edgeColors
	  this.edgeUVs           = edgeUVs
	  this.edgeIds           = edgeIds
	  this.edgeVAO           = edgeVAO
	  this.edgeCount         = 0
	
	  this.pointPositions    = pointPositions
	  this.pointColors       = pointColors
	  this.pointUVs          = pointUVs
	  this.pointSizes        = pointSizes
	  this.pointIds          = pointIds
	  this.pointVAO          = pointVAO
	  this.pointCount        = 0
	
	  this.contourLineWidth  = 1
	  this.contourPositions  = contourPositions
	  this.contourVAO        = contourVAO
	  this.contourCount      = 0
	  this.contourColor      = [0,0,0]
	  this.contourEnable     = true
	
	  this.pickId            = 1
	  this.bounds            = [
	    [ Infinity, Infinity, Infinity],
	    [-Infinity,-Infinity,-Infinity] ]
	  this.clipBounds        = [
	    [-Infinity,-Infinity,-Infinity],
	    [ Infinity, Infinity, Infinity] ]
	
	  this.lightPosition = [1e5, 1e5, 0]
	  this.ambientLight  = 0.8
	  this.diffuseLight  = 0.8
	  this.specularLight = 2.0
	  this.roughness     = 0.5
	  this.fresnel       = 1.5
	
	  this.opacity       = 1.0
	  this.hasAlpha      = false
	  this.opacityscale  = false
	
	  this._model       = IDENTITY
	  this._view        = IDENTITY
	  this._projection  = IDENTITY
	  this._resolution  = [1,1]
	}
	
	var proto = SimplicialMesh.prototype
	
	proto.isOpaque = function() {
	  return !this.hasAlpha
	}
	
	proto.isTransparent = function() {
	  return this.hasAlpha
	}
	
	proto.pickSlots = 1
	
	proto.setPickBase = function(id) {
	  this.pickId = id
	}
	
	function getOpacityFromScale(ratio, opacityscale) {
	
	  if(!opacityscale) return 1
	  if(!opacityscale.length) return 1
	
	  for(var i = 0; i < opacityscale.length; ++i) {
	    if(opacityscale.length < 2) return 1
	    if(opacityscale[i][0] === ratio) return opacityscale[i][1]
	    if(opacityscale[i][0] > ratio && i > 0) {
	      var d = (opacityscale[i][0] - ratio) / (opacityscale[i][0] - opacityscale[i - 1][0])
	      return opacityscale[i][1] * (1 - d) + d * opacityscale[i - 1][1]
	    }
	  }
	
	  return 1
	}
	
	function genColormap(param, opacityscale) {
	  var colors = colormap({
	      colormap: param
	    , nshades:  256
	    , format:  'rgba'
	  })
	
	  var result = new Uint8Array(256*4)
	  for(var i=0; i<256; ++i) {
	    var c = colors[i]
	    for(var j=0; j<3; ++j) {
	      result[4*i+j] = c[j]
	    }
	    if(!opacityscale) {
	      result[4*i+3] = 255 * c[3]
	    } else {
	      result[4*i+3] = 255 * getOpacityFromScale(i / 255.0, opacityscale)
	    }
	  }
	
	  return ndarray(result, [256,256,4], [4,0,1])
	}
	
	function unpackIntensity(cells, numVerts, cellIntensity) {
	  var result = new Array(numVerts)
	  for(var i=0; i<numVerts; ++i) {
	    result[i] = 0
	  }
	  var numCells = cells.length
	  for(var i=0; i<numCells; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      result[c[j]] = cellIntensity[i]
	    }
	  }
	  return result
	}
	
	function takeZComponent(array) {
	  var n = array.length
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = array[i][2]
	  }
	  return result
	}
	
	proto.highlight = function(selection) {
	  if(!selection || !this.contourEnable) {
	    this.contourCount = 0
	    return
	  }
	  var level = getContour(this.cells, this.intensity, selection.intensity)
	  var cells         = level.cells
	  var vertexIds     = level.vertexIds
	  var vertexWeights = level.vertexWeights
	  var numCells = cells.length
	  var result = pool.mallocFloat32(2 * 3 * numCells)
	  var ptr = 0
	  for(var i=0; i<numCells; ++i) {
	    var c = cells[i]
	    for(var j=0; j<2; ++j) {
	      var v = c[0]
	      if(c.length === 2) {
	        v = c[j]
	      }
	      var a = vertexIds[v][0]
	      var b = vertexIds[v][1]
	      var w = vertexWeights[v]
	      var wi = 1.0 - w
	      var pa = this.positions[a]
	      var pb = this.positions[b]
	      for(var k=0; k<3; ++k) {
	        result[ptr++] = w * pa[k] + wi * pb[k]
	      }
	    }
	  }
	  this.contourCount = (ptr / 3)|0
	  this.contourPositions.update(result.subarray(0, ptr))
	  pool.free(result)
	}
	
	proto.update = function(params) {
	  params = params || {}
	  var gl = this.gl
	
	  this.dirty = true
	
	  if('contourEnable' in params) {
	    this.contourEnable = params.contourEnable
	  }
	  if('contourColor' in params) {
	    this.contourColor = params.contourColor
	  }
	  if('lineWidth' in params) {
	    this.lineWidth = params.lineWidth
	  }
	  if('lightPosition' in params) {
	    this.lightPosition = params.lightPosition
	  }
	
	  this.hasAlpha = false // default to no transparent draw
	  if('opacity' in params) {
	    this.opacity = params.opacity
	    if(this.opacity < 1) {
	      this.hasAlpha = true;
	    }
	  }
	  if('opacityscale' in params) {
	    this.opacityscale = params.opacityscale
	    this.hasAlpha = true;
	  }
	
	  if('ambient' in params) {
	    this.ambientLight  = params.ambient
	  }
	  if('diffuse' in params) {
	    this.diffuseLight = params.diffuse
	  }
	  if('specular' in params) {
	    this.specularLight = params.specular
	  }
	  if('roughness' in params) {
	    this.roughness = params.roughness
	  }
	  if('fresnel' in params) {
	    this.fresnel = params.fresnel
	  }
	
	  if(params.texture) {
	    this.texture.dispose()
	    this.texture = createTexture(gl, params.texture)
	  } else if (params.colormap) {
	    this.texture.shape = [256,256]
	    this.texture.minFilter = gl.LINEAR_MIPMAP_LINEAR
	    this.texture.magFilter = gl.LINEAR
	    this.texture.setPixels(genColormap(params.colormap, this.opacityscale))
	    this.texture.generateMipmap()
	  }
	
	  var cells = params.cells
	  var positions = params.positions
	
	  if(!positions || !cells) {
	    return
	  }
	
	  var tPos = []
	  var tCol = []
	  var tNor = []
	  var tUVs = []
	  var tIds = []
	
	  var ePos = []
	  var eCol = []
	  var eUVs = []
	  var eIds = []
	
	  var pPos = []
	  var pCol = []
	  var pUVs = []
	  var pSiz = []
	  var pIds = []
	
	  //Save geometry data for picking calculations
	  this.cells     = cells
	  this.positions = positions
	
	  //Compute normals
	  var vertexNormals = params.vertexNormals
	  var cellNormals   = params.cellNormals
	  var vertexNormalsEpsilon = params.vertexNormalsEpsilon === void(0) ? DEFAULT_VERTEX_NORMALS_EPSILON : params.vertexNormalsEpsilon
	  var faceNormalsEpsilon = params.faceNormalsEpsilon === void(0) ? DEFAULT_FACE_NORMALS_EPSILON : params.faceNormalsEpsilon
	  if(params.useFacetNormals && !cellNormals) {
	    cellNormals = normals.faceNormals(cells, positions, faceNormalsEpsilon)
	  }
	  if(!cellNormals && !vertexNormals) {
	    vertexNormals = normals.vertexNormals(cells, positions, vertexNormalsEpsilon)
	  }
	
	  //Compute colors
	  var vertexColors    = params.vertexColors
	  var cellColors      = params.cellColors
	  var meshColor       = params.meshColor || [1,1,1,1]
	
	  //UVs
	  var vertexUVs       = params.vertexUVs
	  var vertexIntensity = params.vertexIntensity
	  var cellUVs         = params.cellUVs
	  var cellIntensity   = params.cellIntensity
	
	  var intensityLo     = Infinity
	  var intensityHi     = -Infinity
	  if(!vertexUVs && !cellUVs) {
	    if(vertexIntensity) {
	      if(params.vertexIntensityBounds) {
	        intensityLo = +params.vertexIntensityBounds[0]
	        intensityHi = +params.vertexIntensityBounds[1]
	      } else {
	        for(var i=0; i<vertexIntensity.length; ++i) {
	          var f = vertexIntensity[i]
	          intensityLo = Math.min(intensityLo, f)
	          intensityHi = Math.max(intensityHi, f)
	        }
	      }
	    } else if(cellIntensity) {
	      for(var i=0; i<cellIntensity.length; ++i) {
	        var f = cellIntensity[i]
	        intensityLo = Math.min(intensityLo, f)
	        intensityHi = Math.max(intensityHi, f)
	      }
	    } else {
	      for(var i=0; i<positions.length; ++i) {
	        var f = positions[i][2]
	        intensityLo = Math.min(intensityLo, f)
	        intensityHi = Math.max(intensityHi, f)
	      }
	    }
	  }
	
	  if(vertexIntensity) {
	    this.intensity = vertexIntensity
	  } else if(cellIntensity) {
	    this.intensity = unpackIntensity(cells, positions.length, cellIntensity)
	  } else {
	    this.intensity = takeZComponent(positions)
	  }
	
	  //Point size
	  var pointSizes      = params.pointSizes
	  var meshPointSize   = params.pointSize || 1.0
	
	  //Update bounds
	  this.bounds       = [[Infinity,Infinity,Infinity], [-Infinity,-Infinity,-Infinity]]
	  for(var i=0; i<positions.length; ++i) {
	    var p = positions[i]
	    for(var j=0; j<3; ++j) {
	      if(isNaN(p[j]) || !isFinite(p[j])) {
	        continue
	      }
	      this.bounds[0][j] = Math.min(this.bounds[0][j], p[j])
	      this.bounds[1][j] = Math.max(this.bounds[1][j], p[j])
	    }
	  }
	
	  //Pack cells into buffers
	  var triangleCount = 0
	  var edgeCount = 0
	  var pointCount = 0
	
	fill_loop:
	  for(var i=0; i<cells.length; ++i) {
	    var cell = cells[i]
	    switch(cell.length) {
	      case 1:
	
	        var v = cell[0]
	        var p = positions[v]
	
	        //Check NaNs
	        for(var j=0; j<3; ++j) {
	          if(isNaN(p[j]) || !isFinite(p[j])) {
	            continue fill_loop
	          }
	        }
	
	        pPos.push(p[0], p[1], p[2])
	
	        var c
	        if(vertexColors) {
	          c = vertexColors[v]
	        } else if(cellColors) {
	          c = cellColors[i]
	        } else {
	          c = meshColor
	        }
	        if(this.opacityscale && vertexIntensity) {
	          tCol.push(c[0], c[1], c[2],
	            this.opacity * getOpacityFromScale(
	              (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
	              this.opacityscale
	            )
	          )
	        } else if(c.length === 3) {
	          pCol.push(c[0], c[1], c[2], this.opacity)
	        } else {
	          pCol.push(c[0], c[1], c[2], c[3] * this.opacity)
	          if(c[3] < 1) this.hasAlpha = true
	        }
	
	        var uv
	        if(vertexUVs) {
	          uv = vertexUVs[v]
	        } else if(vertexIntensity) {
	          uv = [
	            (vertexIntensity[v] - intensityLo) /
	            (intensityHi - intensityLo), 0]
	        } else if(cellUVs) {
	          uv = cellUVs[i]
	        } else if(cellIntensity) {
	          uv = [
	            (cellIntensity[i] - intensityLo) /
	            (intensityHi - intensityLo), 0]
	        } else {
	          uv = [
	            (p[2] - intensityLo) /
	            (intensityHi - intensityLo), 0]
	        }
	        pUVs.push(uv[0], uv[1])
	
	        if(pointSizes) {
	          pSiz.push(pointSizes[v])
	        } else {
	          pSiz.push(meshPointSize)
	        }
	
	        pIds.push(i)
	
	        pointCount += 1
	      break
	
	      case 2:
	
	        //Check NaNs
	        for(var j=0; j<2; ++j) {
	          var v = cell[j]
	          var p = positions[v]
	          for(var k=0; k<3; ++k) {
	            if(isNaN(p[k]) || !isFinite(p[k])) {
	              continue fill_loop
	            }
	          }
	        }
	
	        for(var j=0; j<2; ++j) {
	          var v = cell[j]
	          var p = positions[v]
	
	          ePos.push(p[0], p[1], p[2])
	
	          var c
	          if(vertexColors) {
	            c = vertexColors[v]
	          } else if(cellColors) {
	            c = cellColors[i]
	          } else {
	            c = meshColor
	          }
	          if(this.opacityscale && vertexIntensity) {
	            tCol.push(c[0], c[1], c[2],
	              this.opacity * getOpacityFromScale(
	                (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
	                this.opacityscale
	              )
	            )
	          } else if(c.length === 3) {
	            eCol.push(c[0], c[1], c[2], this.opacity)
	          } else {
	            eCol.push(c[0], c[1], c[2], c[3] * this.opacity)
	            if(c[3] < 1) this.hasAlpha = true
	          }
	
	          var uv
	          if(vertexUVs) {
	            uv = vertexUVs[v]
	          } else if(vertexIntensity) {
	            uv = [
	              (vertexIntensity[v] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          } else if(cellUVs) {
	            uv = cellUVs[i]
	          } else if(cellIntensity) {
	            uv = [
	              (cellIntensity[i] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          } else {
	            uv = [
	              (p[2] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          }
	          eUVs.push(uv[0], uv[1])
	
	          eIds.push(i)
	        }
	        edgeCount += 1
	      break
	
	      case 3:
	        //Check NaNs
	        for(var j=0; j<3; ++j) {
	          var v = cell[j]
	          var p = positions[v]
	          for(var k=0; k<3; ++k) {
	            if(isNaN(p[k]) || !isFinite(p[k])) {
	              continue fill_loop
	            }
	          }
	        }
	
	        for(var j=0; j<3; ++j) {
	          var v = cell[2 - j]
	
	          var p = positions[v]
	          tPos.push(p[0], p[1], p[2])
	
	          var c
	          if(vertexColors) {
	            c = vertexColors[v]
	          } else if(cellColors) {
	            c = cellColors[i]
	          } else {
	            c = meshColor
	          }
	
	          if(!c) {
	            tCol.push(0.5,0.5,0.5,1)
	          } else if(this.opacityscale && vertexIntensity) {
	            tCol.push(c[0], c[1], c[2],
	              this.opacity * getOpacityFromScale(
	                (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
	                this.opacityscale
	              )
	            )
	          } else if(c.length === 3) {
	            tCol.push(c[0], c[1], c[2], this.opacity)
	          } else {
	            tCol.push(c[0], c[1], c[2], c[3] * this.opacity)
	            if(c[3] < 1) this.hasAlpha = true
	          }
	
	          var uv
	          if(vertexUVs) {
	            uv = vertexUVs[v]
	          } else if(vertexIntensity) {
	            uv = [
	              (vertexIntensity[v] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          } else if(cellUVs) {
	            uv = cellUVs[i]
	          } else if(cellIntensity) {
	            uv = [
	              (cellIntensity[i] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          } else {
	            uv = [
	              (p[2] - intensityLo) /
	              (intensityHi - intensityLo), 0]
	          }
	          tUVs.push(uv[0], uv[1])
	
	          var q
	          if(vertexNormals) {
	            q = vertexNormals[v]
	          } else {
	            q = cellNormals[i]
	          }
	          tNor.push(q[0], q[1], q[2])
	
	          tIds.push(i)
	        }
	        triangleCount += 1
	      break
	
	      default:
	      break
	    }
	  }
	
	  this.pointCount     = pointCount
	  this.edgeCount      = edgeCount
	  this.triangleCount  = triangleCount
	
	  this.pointPositions.update(pPos)
	  this.pointColors.update(pCol)
	  this.pointUVs.update(pUVs)
	  this.pointSizes.update(pSiz)
	  this.pointIds.update(new Uint32Array(pIds))
	
	  this.edgePositions.update(ePos)
	  this.edgeColors.update(eCol)
	  this.edgeUVs.update(eUVs)
	  this.edgeIds.update(new Uint32Array(eIds))
	
	  this.trianglePositions.update(tPos)
	  this.triangleColors.update(tCol)
	  this.triangleUVs.update(tUVs)
	  this.triangleNormals.update(tNor)
	  this.triangleIds.update(new Uint32Array(tIds))
	}
	
	proto.drawTransparent = proto.draw = function(params) {
	  params = params || {}
	  var gl          = this.gl
	  var model       = params.model      || IDENTITY
	  var view        = params.view       || IDENTITY
	  var projection  = params.projection || IDENTITY
	
	  var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
	  for(var i=0; i<3; ++i) {
	    clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
	    clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
	  }
	
	  var uniforms = {
	    model:      model,
	    view:       view,
	    projection: projection,
	    inverseModel: IDENTITY.slice(),
	
	    clipBounds: clipBounds,
	
	    kambient:   this.ambientLight,
	    kdiffuse:   this.diffuseLight,
	    kspecular:  this.specularLight,
	    roughness:  this.roughness,
	    fresnel:    this.fresnel,
	
	    eyePosition:   [0,0,0],
	    lightPosition: [0,0,0],
	
	    contourColor: this.contourColor,
	
	    texture:    0
	  }
	
	  uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
	
	  gl.disable(gl.CULL_FACE)
	
	  this.texture.bind(0)
	
	  var invCameraMatrix = new Array(16)
	  multiply(invCameraMatrix, uniforms.view, uniforms.model)
	  multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
	  invert(invCameraMatrix, invCameraMatrix)
	
	  for(var i=0; i<3; ++i) {
	    uniforms.eyePosition[i] = invCameraMatrix[12+i] / invCameraMatrix[15]
	  }
	
	  var w = invCameraMatrix[15]
	  for(var i=0; i<3; ++i) {
	    w += this.lightPosition[i] * invCameraMatrix[4*i+3]
	  }
	  for(var i=0; i<3; ++i) {
	    var s = invCameraMatrix[12+i]
	    for(var j=0; j<3; ++j) {
	      s += invCameraMatrix[4*j+i] * this.lightPosition[j]
	    }
	    uniforms.lightPosition[i] = s / w
	  }
	
	  if(this.triangleCount > 0) {
	    var shader = this.triShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.triangleVAO.bind()
	    gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
	    this.triangleVAO.unbind()
	  }
	
	  if(this.edgeCount > 0 && this.lineWidth > 0) {
	    var shader = this.lineShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.edgeVAO.bind()
	    gl.lineWidth(this.lineWidth * this.pixelRatio)
	    gl.drawArrays(gl.LINES, 0, this.edgeCount*2)
	    this.edgeVAO.unbind()
	  }
	
	  if(this.pointCount > 0) {
	    var shader = this.pointShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.pointVAO.bind()
	    gl.drawArrays(gl.POINTS, 0, this.pointCount)
	    this.pointVAO.unbind()
	  }
	
	  if(this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0) {
	    var shader = this.contourShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.contourVAO.bind()
	    gl.drawArrays(gl.LINES, 0, this.contourCount)
	    this.contourVAO.unbind()
	  }
	}
	
	proto.drawPick = function(params) {
	  params = params || {}
	
	  var gl         = this.gl
	
	  var model      = params.model      || IDENTITY
	  var view       = params.view       || IDENTITY
	  var projection = params.projection || IDENTITY
	
	  var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
	  for(var i=0; i<3; ++i) {
	    clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
	    clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
	  }
	
	  //Save camera parameters
	  this._model      = [].slice.call(model)
	  this._view       = [].slice.call(view)
	  this._projection = [].slice.call(projection)
	  this._resolution = [gl.drawingBufferWidth, gl.drawingBufferHeight]
	
	  var uniforms = {
	    model:      model,
	    view:       view,
	    projection: projection,
	    clipBounds: clipBounds,
	    pickId:     this.pickId / 255.0,
	  }
	
	  var shader = this.pickShader
	  shader.bind()
	  shader.uniforms = uniforms
	
	  if(this.triangleCount > 0) {
	    this.triangleVAO.bind()
	    gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
	    this.triangleVAO.unbind()
	  }
	
	  if(this.edgeCount > 0) {
	    this.edgeVAO.bind()
	    gl.lineWidth(this.lineWidth * this.pixelRatio)
	    gl.drawArrays(gl.LINES, 0, this.edgeCount*2)
	    this.edgeVAO.unbind()
	  }
	
	  if(this.pointCount > 0) {
	    var shader = this.pointPickShader
	    shader.bind()
	    shader.uniforms = uniforms
	
	    this.pointVAO.bind()
	    gl.drawArrays(gl.POINTS, 0, this.pointCount)
	    this.pointVAO.unbind()
	  }
	}
	
	
	proto.pick = function(pickData) {
	  if(!pickData) {
	    return null
	  }
	  if(pickData.id !== this.pickId) {
	    return null
	  }
	
	  var cellId    = pickData.value[0] + 256*pickData.value[1] + 65536*pickData.value[2]
	  var cell      = this.cells[cellId]
	  var positions = this.positions
	
	  var simplex   = new Array(cell.length)
	  for(var i=0; i<cell.length; ++i) {
	    simplex[i] = positions[cell[i]]
	  }
	
	  var data = closestPoint(
	    simplex,
	    [pickData.coord[0], this._resolution[1]-pickData.coord[1]],
	    this._model,
	    this._view,
	    this._projection,
	    this._resolution)
	
	  if(!data) {
	    return null
	  }
	
	  var weights = data[2]
	  var interpIntensity = 0.0
	  for(var i=0; i<cell.length; ++i) {
	    interpIntensity += weights[i] * this.intensity[cell[i]]
	  }
	
	  return {
	    position: data[1],
	    index:    cell[data[0]],
	    cell:     cell,
	    cellId:   cellId,
	    intensity:  interpIntensity,
	    dataCoordinate: this.positions[cell[data[0]]]
	  }
	}
	
	
	proto.dispose = function() {
	  this.texture.dispose()
	
	  this.triShader.dispose()
	  this.lineShader.dispose()
	  this.pointShader.dispose()
	  this.pickShader.dispose()
	  this.pointPickShader.dispose()
	
	  this.triangleVAO.dispose()
	  this.trianglePositions.dispose()
	  this.triangleColors.dispose()
	  this.triangleUVs.dispose()
	  this.triangleNormals.dispose()
	  this.triangleIds.dispose()
	
	  this.edgeVAO.dispose()
	  this.edgePositions.dispose()
	  this.edgeColors.dispose()
	  this.edgeUVs.dispose()
	  this.edgeIds.dispose()
	
	  this.pointVAO.dispose()
	  this.pointPositions.dispose()
	  this.pointColors.dispose()
	  this.pointUVs.dispose()
	  this.pointSizes.dispose()
	  this.pointIds.dispose()
	
	  this.contourVAO.dispose()
	  this.contourPositions.dispose()
	  this.contourShader.dispose()
	}
	
	function createMeshShader(gl) {
	  var shader = createShader(gl, meshShader.vertex, meshShader.fragment)
	  shader.attributes.position.location = 0
	  shader.attributes.color.location    = 2
	  shader.attributes.uv.location       = 3
	  shader.attributes.normal.location   = 4
	  return shader
	}
	
	function createWireShader(gl) {
	  var shader = createShader(gl, wireShader.vertex, wireShader.fragment)
	  shader.attributes.position.location = 0
	  shader.attributes.color.location    = 2
	  shader.attributes.uv.location       = 3
	  return shader
	}
	
	function createPointShader(gl) {
	  var shader = createShader(gl, pointShader.vertex, pointShader.fragment)
	  shader.attributes.position.location  = 0
	  shader.attributes.color.location     = 2
	  shader.attributes.uv.location        = 3
	  shader.attributes.pointSize.location = 4
	  return shader
	}
	
	function createPickShader(gl) {
	  var shader = createShader(gl, pickShader.vertex, pickShader.fragment)
	  shader.attributes.position.location = 0
	  shader.attributes.id.location       = 1
	  return shader
	}
	
	function createPointPickShader(gl) {
	  var shader = createShader(gl, pointPickShader.vertex, pointPickShader.fragment)
	  shader.attributes.position.location  = 0
	  shader.attributes.id.location        = 1
	  shader.attributes.pointSize.location = 4
	  return shader
	}
	
	function createContourShader(gl) {
	  var shader = createShader(gl, contourShader.vertex, contourShader.fragment)
	  shader.attributes.position.location = 0
	  return shader
	}
	
	function createSimplicialMesh(gl, params) {
	  if (arguments.length === 1) {
	    params = gl;
	    gl = params.gl;
	  }
	
	  //enable derivatives for face normals
	  var ext = gl.getExtension('OES_standard_derivatives') || gl.getExtension('MOZ_OES_standard_derivatives') || gl.getExtension('WEBKIT_OES_standard_derivatives')
	  if (!ext)
	    throw new Error('derivatives not supported')
	
	  var triShader       = createMeshShader(gl)
	  var lineShader      = createWireShader(gl)
	  var pointShader     = createPointShader(gl)
	  var pickShader      = createPickShader(gl)
	  var pointPickShader = createPointPickShader(gl)
	  var contourShader   = createContourShader(gl)
	
	  var meshTexture       = createTexture(gl,
	    ndarray(new Uint8Array([255,255,255,255]), [1,1,4]))
	  meshTexture.generateMipmap()
	  meshTexture.minFilter = gl.LINEAR_MIPMAP_LINEAR
	  meshTexture.magFilter = gl.LINEAR
	
	  var trianglePositions = createBuffer(gl)
	  var triangleColors    = createBuffer(gl)
	  var triangleUVs       = createBuffer(gl)
	  var triangleNormals   = createBuffer(gl)
	  var triangleIds       = createBuffer(gl)
	  var triangleVAO       = createVAO(gl, [
	    { buffer: trianglePositions,
	      type: gl.FLOAT,
	      size: 3
	    },
	    { buffer: triangleIds,
	      type: gl.UNSIGNED_BYTE,
	      size: 4,
	      normalized: true
	    },
	    { buffer: triangleColors,
	      type: gl.FLOAT,
	      size: 4
	    },
	    { buffer: triangleUVs,
	      type: gl.FLOAT,
	      size: 2
	    },
	    { buffer: triangleNormals,
	      type: gl.FLOAT,
	      size: 3
	    }
	  ])
	
	  var edgePositions = createBuffer(gl)
	  var edgeColors    = createBuffer(gl)
	  var edgeUVs       = createBuffer(gl)
	  var edgeIds       = createBuffer(gl)
	  var edgeVAO       = createVAO(gl, [
	    { buffer: edgePositions,
	      type: gl.FLOAT,
	      size: 3
	    },
	    { buffer: edgeIds,
	      type: gl.UNSIGNED_BYTE,
	      size: 4,
	      normalized: true
	    },
	    { buffer: edgeColors,
	      type: gl.FLOAT,
	      size: 4
	    },
	    { buffer: edgeUVs,
	      type: gl.FLOAT,
	      size: 2
	    }
	  ])
	
	  var pointPositions  = createBuffer(gl)
	  var pointColors     = createBuffer(gl)
	  var pointUVs        = createBuffer(gl)
	  var pointSizes      = createBuffer(gl)
	  var pointIds        = createBuffer(gl)
	  var pointVAO        = createVAO(gl, [
	    { buffer: pointPositions,
	      type: gl.FLOAT,
	      size: 3
	    },
	    { buffer: pointIds,
	      type: gl.UNSIGNED_BYTE,
	      size: 4,
	      normalized: true
	    },
	    { buffer: pointColors,
	      type: gl.FLOAT,
	      size: 4
	    },
	    { buffer: pointUVs,
	      type: gl.FLOAT,
	      size: 2
	    },
	    { buffer: pointSizes,
	      type: gl.FLOAT,
	      size: 1
	    }
	  ])
	
	  var contourPositions = createBuffer(gl)
	  var contourVAO       = createVAO(gl, [
	    { buffer: contourPositions,
	      type:   gl.FLOAT,
	      size:   3
	    }])
	
	  var mesh = new SimplicialMesh(gl
	    , meshTexture
	    , triShader
	    , lineShader
	    , pointShader
	    , pickShader
	    , pointPickShader
	    , contourShader
	    , trianglePositions
	    , triangleIds
	    , triangleColors
	    , triangleUVs
	    , triangleNormals
	    , triangleVAO
	    , edgePositions
	    , edgeIds
	    , edgeColors
	    , edgeUVs
	    , edgeVAO
	    , pointPositions
	    , pointIds
	    , pointColors
	    , pointUVs
	    , pointSizes
	    , pointVAO
	    , contourPositions
	    , contourVAO)
	
	  mesh.update(params)
	
	  return mesh
	}
	
	module.exports = createSimplicialMesh
	
	},{"./lib/closest-point":280,"./lib/shaders":281,"colormap":127,"gl-buffer":243,"gl-mat4/invert":267,"gl-mat4/multiply":269,"gl-shader":303,"gl-texture2d":323,"gl-vao":328,"ndarray":451,"normals":454,"simplicial-complex-contour":516,"typedarray-pool":543}],283:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createBoxes
	
	var createBuffer = _dereq_('gl-buffer')
	var createShader = _dereq_('gl-shader')
	
	var shaders = _dereq_('./shaders')
	
	function Boxes(plot, vbo, shader) {
	  this.plot   = plot
	  this.vbo    = vbo
	  this.shader = shader
	}
	
	var proto = Boxes.prototype
	
	proto.bind = function() {
	  var shader = this.shader
	  this.vbo.bind()
	  this.shader.bind()
	  shader.attributes.coord.pointer()
	  shader.uniforms.screenBox = this.plot.screenBox
	}
	
	proto.drawBox = (function() {
	  var lo = [0,0]
	  var hi = [0,0]
	  return function(loX, loY, hiX, hiY, color) {
	    var plot       = this.plot
	    var shader     = this.shader
	    var gl         = plot.gl
	
	    lo[0] = loX
	    lo[1] = loY
	    hi[0] = hiX
	    hi[1] = hiY
	
	    shader.uniforms.lo     = lo
	    shader.uniforms.hi     = hi
	    shader.uniforms.color  = color
	
	    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
	  }
	}())
	
	proto.dispose = function() {
	  this.vbo.dispose()
	  this.shader.dispose()
	}
	
	function createBoxes(plot) {
	  var gl  = plot.gl
	  var vbo = createBuffer(gl, [
	    0,0,
	    0,1,
	    1,0,
	    1,1])
	  var shader  = createShader(gl, shaders.boxVert, shaders.lineFrag)
	  return new Boxes(plot, vbo, shader)
	}
	
	},{"./shaders":286,"gl-buffer":243,"gl-shader":303}],284:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createGrid
	
	var createBuffer  = _dereq_('gl-buffer')
	var createShader  = _dereq_('gl-shader')
	var bsearch       = _dereq_('binary-search-bounds')
	var shaders       = _dereq_('./shaders')
	
	function Grid(plot, vbo, shader, tickShader) {
	  this.plot   = plot
	  this.vbo    = vbo
	  this.shader = shader
	  this.tickShader = tickShader
	  this.ticks  = [[], []]
	}
	
	function compareTickNum(a, b) {
	  return a - b
	}
	
	var proto = Grid.prototype
	
	proto.draw = (function() {
	
	  var DATA_SHIFT = [0,0]
	  var DATA_SCALE = [0,0]
	  var DATA_AXIS  = [0,0]
	
	  return function() {
	    var plot       = this.plot
	    var vbo        = this.vbo
	    var shader     = this.shader
	    var ticks      = this.ticks
	    var gl         = plot.gl
	    var bounds     = plot._tickBounds
	    var dataBox    = plot.dataBox
	    var viewPixels = plot.viewBox
	    var lineWidth  = plot.gridLineWidth
	    var gridColor  = plot.gridLineColor
	    var gridEnable = plot.gridLineEnable
	    var pixelRatio = plot.pixelRatio
	
	    for(var i=0; i<2; ++i) {
	      var lo = bounds[i]
	      var hi = bounds[i+2]
	      var boundScale = hi - lo
	      var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
	      var dataWidth   = dataBox[i+2] - dataBox[i]
	      DATA_SCALE[i] = 2.0 * boundScale / dataWidth
	      DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth
	    }
	
	    shader.bind()
	    vbo.bind()
	    shader.attributes.dataCoord.pointer()
	    shader.uniforms.dataShift = DATA_SHIFT
	    shader.uniforms.dataScale = DATA_SCALE
	
	    var offset = 0
	    for(var i=0; i<2; ++i) {
	      DATA_AXIS[0] = DATA_AXIS[1] = 0
	      DATA_AXIS[i] = 1
	      shader.uniforms.dataAxis  = DATA_AXIS
	      shader.uniforms.lineWidth = lineWidth[i] / (viewPixels[i+2] - viewPixels[i]) * pixelRatio
	      shader.uniforms.color     = gridColor[i]
	
	      var size = ticks[i].length * 6
	      if(gridEnable[i] && size) {
	        gl.drawArrays(gl.TRIANGLES, offset, size)
	      }
	      offset += size
	    }
	  }
	})()
	
	proto.drawTickMarks = (function() {
	  var DATA_SHIFT = [0,0]
	  var DATA_SCALE = [0,0]
	  var X_AXIS     = [1,0]
	  var Y_AXIS     = [0,1]
	  var SCR_OFFSET = [0,0]
	  var TICK_SCALE = [0,0]
	
	  return function() {
	    var plot       = this.plot
	    var vbo        = this.vbo
	    var shader     = this.tickShader
	    var ticks      = this.ticks
	    var gl         = plot.gl
	    var bounds     = plot._tickBounds
	    var dataBox    = plot.dataBox
	    var viewBox    = plot.viewBox
	    var pixelRatio = plot.pixelRatio
	    var screenBox  = plot.screenBox
	
	    var screenWidth  = screenBox[2] - screenBox[0]
	    var screenHeight = screenBox[3] - screenBox[1]
	    var viewWidth    = viewBox[2]   - viewBox[0]
	    var viewHeight   = viewBox[3]   - viewBox[1]
	
	    for(var i=0; i<2; ++i) {
	      var lo = bounds[i]
	      var hi = bounds[i+2]
	      var boundScale = hi - lo
	      var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
	      var dataWidth   = (dataBox[i+2] - dataBox[i])
	      DATA_SCALE[i] = 2.0 * boundScale / dataWidth
	      DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth
	    }
	
	    DATA_SCALE[0] *= viewWidth / screenWidth
	    DATA_SHIFT[0] *= viewWidth / screenWidth
	
	    DATA_SCALE[1] *= viewHeight / screenHeight
	    DATA_SHIFT[1] *= viewHeight / screenHeight
	
	    shader.bind()
	    vbo.bind()
	
	    shader.attributes.dataCoord.pointer()
	
	    var uniforms = shader.uniforms
	    uniforms.dataShift = DATA_SHIFT
	    uniforms.dataScale = DATA_SCALE
	
	    var tickMarkLength = plot.tickMarkLength
	    var tickMarkWidth  = plot.tickMarkWidth
	    var tickMarkColor  = plot.tickMarkColor
	
	    var xTicksOffset = 0
	    var yTicksOffset = ticks[0].length * 6
	
	    var xStart = Math.min(bsearch.ge(ticks[0], (dataBox[0] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length)
	    var xEnd   = Math.min(bsearch.gt(ticks[0], (dataBox[2] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length)
	    var xOffset = xTicksOffset + 6 * xStart
	    var xCount  = 6 * Math.max(0, xEnd - xStart)
	
	    var yStart = Math.min(bsearch.ge(ticks[1], (dataBox[1] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length)
	    var yEnd   = Math.min(bsearch.gt(ticks[1], (dataBox[3] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length)
	    var yOffset = yTicksOffset + 6 * yStart
	    var yCount  = 6 * Math.max(0, yEnd - yStart)
	
	    SCR_OFFSET[0]         = 2.0 * (viewBox[0] - tickMarkLength[1]) / screenWidth - 1.0
	    SCR_OFFSET[1]         = (viewBox[3] + viewBox[1]) / screenHeight - 1.0
	    TICK_SCALE[0]         = tickMarkLength[1] * pixelRatio / screenWidth
	    TICK_SCALE[1]         = tickMarkWidth[1]  * pixelRatio / screenHeight
	
	    if(yCount) {
	      uniforms.color        = tickMarkColor[1]
	      uniforms.tickScale    = TICK_SCALE
	      uniforms.dataAxis     = Y_AXIS
	      uniforms.screenOffset = SCR_OFFSET
	      gl.drawArrays(gl.TRIANGLES, yOffset, yCount)
	    }
	
	    SCR_OFFSET[0]         = (viewBox[2] + viewBox[0]) / screenWidth - 1.0
	    SCR_OFFSET[1]         = 2.0 * (viewBox[1] - tickMarkLength[0]) / screenHeight - 1.0
	    TICK_SCALE[0]         = tickMarkWidth[0]  * pixelRatio / screenWidth
	    TICK_SCALE[1]         = tickMarkLength[0] * pixelRatio / screenHeight
	
	    if(xCount) {
	      uniforms.color        = tickMarkColor[0]
	      uniforms.tickScale    = TICK_SCALE
	      uniforms.dataAxis     = X_AXIS
	      uniforms.screenOffset = SCR_OFFSET
	      gl.drawArrays(gl.TRIANGLES, xOffset, xCount)
	    }
	
	    SCR_OFFSET[0]         = 2.0 * (viewBox[2] + tickMarkLength[3]) / screenWidth - 1.0
	    SCR_OFFSET[1]         = (viewBox[3] + viewBox[1]) / screenHeight - 1.0
	    TICK_SCALE[0]         = tickMarkLength[3] * pixelRatio / screenWidth
	    TICK_SCALE[1]         = tickMarkWidth[3]  * pixelRatio / screenHeight
	
	    if(yCount) {
	      uniforms.color        = tickMarkColor[3]
	      uniforms.tickScale    = TICK_SCALE
	      uniforms.dataAxis     = Y_AXIS
	      uniforms.screenOffset = SCR_OFFSET
	      gl.drawArrays(gl.TRIANGLES, yOffset, yCount)
	    }
	
	    SCR_OFFSET[0]         = (viewBox[2] + viewBox[0]) / screenWidth - 1.0
	    SCR_OFFSET[1]         = 2.0 * (viewBox[3] + tickMarkLength[2]) / screenHeight - 1.0
	    TICK_SCALE[0]         = tickMarkWidth[2]  * pixelRatio / screenWidth
	    TICK_SCALE[1]         = tickMarkLength[2] * pixelRatio / screenHeight
	
	    if(xCount) {
	      uniforms.color        = tickMarkColor[2]
	      uniforms.tickScale    = TICK_SCALE
	      uniforms.dataAxis     = X_AXIS
	      uniforms.screenOffset = SCR_OFFSET
	      gl.drawArrays(gl.TRIANGLES, xOffset, xCount)
	    }
	  }
	})()
	
	proto.update = (function() {
	  var OFFSET_X = [1,  1, -1, -1,  1, -1]
	  var OFFSET_Y = [1, -1,  1,  1, -1, -1]
	
	  return function(options) {
	    var ticks  = options.ticks
	    var bounds = options.bounds
	    var data   = new Float32Array(6 * 3 * (ticks[0].length + ticks[1].length))
	
	    var zeroLineEnable = this.plot.zeroLineEnable
	
	    var ptr    = 0
	    var gridTicks = [[], []]
	    for(var dim=0; dim<2; ++dim) {
	      var localTicks = gridTicks[dim]
	      var axisTicks = ticks[dim]
	      var lo = bounds[dim]
	      var hi = bounds[dim+2]
	      for(var i=0; i<axisTicks.length; ++i) {
	        var x = (axisTicks[i].x - lo) / (hi - lo)
	        localTicks.push(x)
	        for(var j=0; j<6; ++j) {
	          data[ptr++] = x
	          data[ptr++] = OFFSET_X[j]
	          data[ptr++] = OFFSET_Y[j]
	        }
	      }
	    }
	
	    this.ticks = gridTicks
	    this.vbo.update(data)
	  }
	})()
	
	proto.dispose = function() {
	  this.vbo.dispose()
	  this.shader.dispose()
	  this.tickShader.dispose()
	}
	
	function createGrid(plot) {
	  var gl     = plot.gl
	  var vbo    = createBuffer(gl)
	  var shader = createShader(gl, shaders.gridVert, shaders.gridFrag)
	  var tickShader = createShader(gl, shaders.tickVert, shaders.gridFrag)
	  var grid   = new Grid(plot, vbo, shader, tickShader)
	  return grid
	}
	
	},{"./shaders":286,"binary-search-bounds":288,"gl-buffer":243,"gl-shader":303}],285:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createLines
	
	var createBuffer = _dereq_('gl-buffer')
	var createShader = _dereq_('gl-shader')
	
	var shaders = _dereq_('./shaders')
	
	function Lines(plot, vbo, shader) {
	  this.plot   = plot
	  this.vbo    = vbo
	  this.shader = shader
	}
	
	var proto = Lines.prototype
	
	proto.bind = function() {
	  var shader = this.shader
	  this.vbo.bind()
	  this.shader.bind()
	  shader.attributes.coord.pointer()
	  shader.uniforms.screenBox = this.plot.screenBox
	}
	
	proto.drawLine = (function() {
	  var start = [0,0]
	  var end   = [0,0]
	  return function(startX, startY, endX, endY, width, color) {
	    var plot       = this.plot
	    var shader     = this.shader
	    var gl         = plot.gl
	
	    start[0] = startX
	    start[1] = startY
	    end[0]   = endX
	    end[1]   = endY
	
	    shader.uniforms.start  = start
	    shader.uniforms.end    = end
	    shader.uniforms.width  = width * plot.pixelRatio
	    shader.uniforms.color  = color
	
	    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
	  }
	}())
	
	proto.dispose = function() {
	  this.vbo.dispose()
	  this.shader.dispose()
	}
	
	function createLines(plot) {
	  var gl  = plot.gl
	  var vbo = createBuffer(gl, [
	    -1,-1,
	    -1,1,
	    1,-1,
	    1,1])
	  var shader  = createShader(gl, shaders.lineVert, shaders.lineFrag)
	  var lines   = new Lines(plot, vbo, shader)
	  return lines
	}
	
	},{"./shaders":286,"gl-buffer":243,"gl-shader":303}],286:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify = _dereq_('glslify')
	
	var FRAGMENT = glslify(["precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"])
	
	module.exports = {
	  lineVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"]),
	  lineFrag: FRAGMENT,
	  textVert: glslify(["#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"]),
	  textFrag: FRAGMENT,
	  gridVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"]),
	  gridFrag: FRAGMENT,
	  boxVert:  glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"]),
	  tickVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"])
	}
	
	},{"glslify":410}],287:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createTextElements
	
	var createBuffer = _dereq_('gl-buffer')
	var createShader = _dereq_('gl-shader')
	var getText      = _dereq_('text-cache')
	var bsearch      = _dereq_('binary-search-bounds')
	var shaders      = _dereq_('./shaders')
	
	function TextElements(plot, vbo, shader) {
	  this.plot         = plot
	  this.vbo          = vbo
	  this.shader       = shader
	  this.tickOffset   = [[],[]]
	  this.tickX        = [[],[]]
	  this.labelOffset  = [0,0]
	  this.labelCount   = [0,0]
	}
	
	var proto = TextElements.prototype
	
	proto.drawTicks = (function() {
	  var DATA_AXIS = [0,0]
	  var SCREEN_OFFSET = [0,0]
	  var ZERO_2 = [0,0]
	
	  return function(axis) {
	    var plot        = this.plot
	    var shader      = this.shader
	    var tickX       = this.tickX[axis]
	    var tickOffset  = this.tickOffset[axis]
	    var gl          = plot.gl
	    var viewBox     = plot.viewBox
	    var dataBox     = plot.dataBox
	    var screenBox   = plot.screenBox
	    var pixelRatio  = plot.pixelRatio
	    var tickEnable  = plot.tickEnable
	    var tickPad     = plot.tickPad
	    var textColor   = plot.tickColor
	    var textAngle   = plot.tickAngle
	    // todo check if this should be used (now unused)
	    // var tickLength  = plot.tickMarkLength
	
	    var labelEnable = plot.labelEnable
	    var labelPad    = plot.labelPad
	    var labelColor  = plot.labelColor
	    var labelAngle  = plot.labelAngle
	    var labelOffset = this.labelOffset[axis]
	    var labelCount  = this.labelCount[axis]
	
	    var start = bsearch.lt(tickX, dataBox[axis])
	    var end   = bsearch.le(tickX, dataBox[axis+2])
	
	    DATA_AXIS[0]    = DATA_AXIS[1] = 0
	    DATA_AXIS[axis] = 1
	
	    SCREEN_OFFSET[axis] = (viewBox[2+axis] + viewBox[axis]) / (screenBox[2+axis] - screenBox[axis]) - 1.0
	
	    var screenScale = 2.0 / screenBox[2+(axis^1)] - screenBox[axis^1]
	
	    SCREEN_OFFSET[axis^1] = screenScale * viewBox[axis^1] - 1.0
	    if(tickEnable[axis]) {
	      SCREEN_OFFSET[axis^1] -= screenScale * pixelRatio * tickPad[axis]
	      if(start < end && tickOffset[end] > tickOffset[start]) {
	        shader.uniforms.dataAxis     = DATA_AXIS
	        shader.uniforms.screenOffset = SCREEN_OFFSET
	        shader.uniforms.color        = textColor[axis]
	        shader.uniforms.angle        = textAngle[axis]
	        gl.drawArrays(
	          gl.TRIANGLES,
	          tickOffset[start],
	          tickOffset[end] - tickOffset[start])
	      }
	    }
	    if(labelEnable[axis] && labelCount) {
	      SCREEN_OFFSET[axis^1] -= screenScale * pixelRatio * labelPad[axis]
	      shader.uniforms.dataAxis     = ZERO_2
	      shader.uniforms.screenOffset = SCREEN_OFFSET
	      shader.uniforms.color        = labelColor[axis]
	      shader.uniforms.angle        = labelAngle[axis]
	      gl.drawArrays(
	        gl.TRIANGLES,
	        labelOffset,
	        labelCount)
	    }
	
	    SCREEN_OFFSET[axis^1] = screenScale * viewBox[2+(axis^1)] - 1.0
	    if(tickEnable[axis+2]) {
	      SCREEN_OFFSET[axis^1] += screenScale * pixelRatio * tickPad[axis+2]
	      if(start < end && tickOffset[end] > tickOffset[start]) {
	        shader.uniforms.dataAxis     = DATA_AXIS
	        shader.uniforms.screenOffset = SCREEN_OFFSET
	        shader.uniforms.color        = textColor[axis+2]
	        shader.uniforms.angle        = textAngle[axis+2]
	        gl.drawArrays(
	          gl.TRIANGLES,
	          tickOffset[start],
	          tickOffset[end] - tickOffset[start])
	      }
	    }
	    if(labelEnable[axis+2] && labelCount) {
	      SCREEN_OFFSET[axis^1] += screenScale * pixelRatio * labelPad[axis+2]
	      shader.uniforms.dataAxis     = ZERO_2
	      shader.uniforms.screenOffset = SCREEN_OFFSET
	      shader.uniforms.color        = labelColor[axis+2]
	      shader.uniforms.angle        = labelAngle[axis+2]
	      gl.drawArrays(
	        gl.TRIANGLES,
	        labelOffset,
	        labelCount)
	    }
	
	  }
	})()
	
	proto.drawTitle = (function() {
	  var DATA_AXIS = [0,0]
	  var SCREEN_OFFSET = [0,0]
	
	  return function() {
	    var plot        = this.plot
	    var shader      = this.shader
	    var gl          = plot.gl
	    var screenBox   = plot.screenBox
	    var titleCenter = plot.titleCenter
	    var titleAngle  = plot.titleAngle
	    var titleColor  = plot.titleColor
	    var pixelRatio  = plot.pixelRatio
	
	    if(!this.titleCount) {
	      return
	    }
	
	    for(var i=0; i<2; ++i) {
	      SCREEN_OFFSET[i] = 2.0 * (titleCenter[i]*pixelRatio - screenBox[i]) /
	        (screenBox[2+i] - screenBox[i]) - 1
	    }
	
	    shader.bind()
	    shader.uniforms.dataAxis      = DATA_AXIS
	    shader.uniforms.screenOffset  = SCREEN_OFFSET
	    shader.uniforms.angle         = titleAngle
	    shader.uniforms.color         = titleColor
	
	    gl.drawArrays(gl.TRIANGLES, this.titleOffset, this.titleCount)
	  }
	})()
	
	proto.bind = (function() {
	  var DATA_SHIFT = [0,0]
	  var DATA_SCALE = [0,0]
	  var TEXT_SCALE = [0,0]
	
	  return function() {
	    var plot      = this.plot
	    var shader    = this.shader
	    var bounds    = plot._tickBounds
	    var dataBox   = plot.dataBox
	    var screenBox = plot.screenBox
	    var viewBox   = plot.viewBox
	
	    shader.bind()
	
	    //Set up coordinate scaling uniforms
	    for(var i=0; i<2; ++i) {
	
	      var lo = bounds[i]
	      var hi = bounds[i+2]
	      var boundScale = hi - lo
	      var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
	      var dataWidth   = (dataBox[i+2] - dataBox[i])
	
	      var viewLo = viewBox[i]
	      var viewHi = viewBox[i+2]
	      var viewScale = viewHi - viewLo
	      var screenLo = screenBox[i]
	      var screenHi = screenBox[i+2]
	      var screenScale = screenHi - screenLo
	
	      DATA_SCALE[i] = 2.0 * boundScale / dataWidth * viewScale / screenScale
	      DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth * viewScale / screenScale
	    }
	
	    TEXT_SCALE[1] = 2.0 * plot.pixelRatio / (screenBox[3] - screenBox[1])
	    TEXT_SCALE[0] = TEXT_SCALE[1] * (screenBox[3] - screenBox[1]) / (screenBox[2] - screenBox[0])
	
	    shader.uniforms.dataScale = DATA_SCALE
	    shader.uniforms.dataShift = DATA_SHIFT
	    shader.uniforms.textScale = TEXT_SCALE
	
	    //Set attributes
	    this.vbo.bind()
	    shader.attributes.textCoordinate.pointer()
	  }
	})()
	
	proto.update = function(options) {
	  var vertices  = []
	  var axesTicks = options.ticks
	  var bounds    = options.bounds
	  var i, j, k, data, scale, dimension
	
	  for(dimension=0; dimension<2; ++dimension) {
	    var offsets = [Math.floor(vertices.length/3)], tickX = [-Infinity]
	
	    //Copy vertices over to buffer
	    var ticks = axesTicks[dimension]
	    for(i=0; i<ticks.length; ++i) {
	      var tick  = ticks[i]
	      var x     = tick.x
	      var text  = tick.text
	      var font  = tick.font || 'sans-serif'
	      scale = (tick.fontSize || 12)
	
	      var coordScale = 1.0 / (bounds[dimension+2] - bounds[dimension])
	      var coordShift = bounds[dimension]
	
	      var rows = text.split('\n')
	      for(var r = 0; r < rows.length; r++) {
	        data = getText(font, rows[r]).data
	        for (j = 0; j < data.length; j += 2) {
	          vertices.push(
	              data[j] * scale,
	              -data[j + 1] * scale - r * scale * 1.2,
	              (x - coordShift) * coordScale)
	        }
	      }
	
	      offsets.push(Math.floor(vertices.length/3))
	      tickX.push(x)
	    }
	
	    this.tickOffset[dimension] = offsets
	    this.tickX[dimension] = tickX
	  }
	
	  //Add labels
	  for(dimension=0; dimension<2; ++dimension) {
	    this.labelOffset[dimension] = Math.floor(vertices.length/3)
	
	    data  = getText(options.labelFont[dimension], options.labels[dimension], { textAlign: 'center' }).data
	    scale = options.labelSize[dimension]
	    for(i=0; i<data.length; i+=2) {
	      vertices.push(data[i]*scale, -data[i+1]*scale, 0)
	    }
	
	    this.labelCount[dimension] =
	      Math.floor(vertices.length/3) - this.labelOffset[dimension]
	  }
	
	  //Add title
	  this.titleOffset = Math.floor(vertices.length/3)
	  data = getText(options.titleFont, options.title).data
	  scale = options.titleSize
	  for(i=0; i<data.length; i+=2) {
	    vertices.push(data[i]*scale, -data[i+1]*scale, 0)
	  }
	  this.titleCount = Math.floor(vertices.length/3) - this.titleOffset
	
	  //Upload new vertices
	  this.vbo.update(vertices)
	}
	
	proto.dispose = function() {
	  this.vbo.dispose()
	  this.shader.dispose()
	}
	
	function createTextElements(plot) {
	  var gl = plot.gl
	  var vbo = createBuffer(gl)
	  var shader = createShader(gl, shaders.textVert, shaders.textFrag)
	  var text = new TextElements(plot, vbo, shader)
	  return text
	}
	
	},{"./shaders":286,"binary-search-bounds":288,"gl-buffer":243,"gl-shader":303,"text-cache":534}],288:[function(_dereq_,module,exports){
	arguments[4][112][0].apply(exports,arguments)
	},{"dup":112}],289:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createGLPlot2D
	
	var createPick = _dereq_('gl-select-static')
	
	var createGrid = _dereq_('./lib/grid')
	var createText = _dereq_('./lib/text')
	var createLine = _dereq_('./lib/line')
	var createBox  = _dereq_('./lib/box')
	
	function GLPlot2D(gl, pickBuffer) {
	  this.gl               = gl
	  this.pickBuffer       = pickBuffer
	
	  this.screenBox        = [0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight]
	  this.viewBox          = [0, 0, 0, 0]
	  this.dataBox          = [-10, -10, 10, 10]
	
	  this.gridLineEnable   = [true,true]
	  this.gridLineWidth    = [1,1]
	  this.gridLineColor    = [[0,0,0,1],
	                           [0,0,0,1]]
	
	  this.pixelRatio       = 1
	
	  this.tickMarkLength   = [0,0,0,0]
	  this.tickMarkWidth    = [0,0,0,0]
	  this.tickMarkColor    = [[0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1]]
	
	  this.tickPad          = [15,15,15,15]
	  this.tickAngle        = [0,0,0,0]
	  this.tickEnable       = [true,true,true,true]
	  this.tickColor        = [[0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1]]
	
	  this.labelPad         = [15,15,15,15]
	  this.labelAngle       = [0,Math.PI/2,0,3.0*Math.PI/2]
	  this.labelEnable      = [true,true,true,true]
	  this.labelColor       = [[0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1]]
	
	  this.titleCenter      = [0,0]
	  this.titleEnable      = true
	  this.titleAngle       = 0
	  this.titleColor       = [0,0,0,1]
	
	  this.borderColor      = [0,0,0,0]
	  this.backgroundColor  = [0,0,0,0]
	
	  this.zeroLineEnable   = [true, true]
	  this.zeroLineWidth    = [4, 4]
	  this.zeroLineColor    = [[0, 0, 0, 1],[0, 0, 0, 1]]
	
	  this.borderLineEnable = [true,true,true,true]
	  this.borderLineWidth  = [2,2,2,2]
	  this.borderLineColor  = [[0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1]]
	
	  //Drawing parameters
	  this.grid             = null
	  this.text             = null
	  this.line             = null
	  this.box              = null
	  this.objects          = []
	  this.overlays         = []
	
	  this._tickBounds      = [Infinity, Infinity, -Infinity, -Infinity]
	
	  this.static = false
	
	  this.dirty        = false
	  this.pickDirty    = false
	  this.pickDelay    = 120
	  this.pickRadius   = 10
	  this._pickTimeout = null
	  this._drawPick    = this.drawPick.bind(this)
	
	  this._depthCounter = 0
	}
	
	var proto = GLPlot2D.prototype
	
	proto.setDirty = function() {
	  this.dirty = this.pickDirty = true
	}
	
	proto.setOverlayDirty = function() {
	  this.dirty = true
	}
	
	proto.nextDepthValue = function() {
	  return (this._depthCounter++) / 65536.0
	}
	
	function lerp(a, b, t) {
	  var s = 0.5 * (t + 1.0)
	  return Math.floor((1.0-s)*a + s*b)|0
	}
	
	proto.draw = (function() {
	var TICK_MARK_BOX = [0,0,0,0]
	return function() {
	  var gl         = this.gl
	  var screenBox  = this.screenBox
	  var viewPixels = this.viewBox
	  var dataBox    = this.dataBox
	  var pixelRatio = this.pixelRatio
	  var grid       = this.grid
	  var line       = this.line
	  var text       = this.text
	  var objects    = this.objects
	
	  this._depthCounter = 0
	
	  if(this.pickDirty) {
	    if(this._pickTimeout) {
	      clearTimeout(this._pickTimeout)
	    }
	    this.pickDirty = false
	    this._pickTimeout = setTimeout(this._drawPick, this.pickDelay)
	  }
	
	  if(!this.dirty) {
	    return
	  }
	  this.dirty = false
	
	  gl.bindFramebuffer(gl.FRAMEBUFFER, null)
	
	  //Turn on scissor
	  gl.enable(gl.SCISSOR_TEST)
	
	  //Turn off depth buffer
	  gl.disable(gl.DEPTH_TEST)
	  gl.depthFunc(gl.LESS)
	  gl.depthMask(false)
	
	  //Configure premultiplied alpha blending
	  gl.enable(gl.BLEND)
	  gl.blendEquation(gl.FUNC_ADD, gl.FUNC_ADD);
	  gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	
	  //Draw border
	  if (this.borderColor) {
	    gl.scissor(
	      screenBox[0],
	      screenBox[1],
	      screenBox[2]-screenBox[0],
	      screenBox[3]-screenBox[1])
	    var borderColor = this.borderColor
	    gl.clearColor(
	      borderColor[0]*borderColor[3],
	      borderColor[1]*borderColor[3],
	      borderColor[2]*borderColor[3],
	      borderColor[3])
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
	  }
	
	  //Draw center pane
	  gl.scissor(
	    viewPixels[0],
	    viewPixels[1],
	    viewPixels[2]-viewPixels[0],
	    viewPixels[3]-viewPixels[1])
	  gl.viewport(
	    viewPixels[0],
	    viewPixels[1],
	    viewPixels[2]-viewPixels[0],
	    viewPixels[3]-viewPixels[1])
	  var backgroundColor = this.backgroundColor
	  gl.clearColor(
	    backgroundColor[0]*backgroundColor[3],
	    backgroundColor[1]*backgroundColor[3],
	    backgroundColor[2]*backgroundColor[3],
	    backgroundColor[3])
	  gl.clear(gl.COLOR_BUFFER_BIT)
	
	  //Draw grid
	  grid.draw()
	
	  //Draw zero lines separately
	  var zeroLineEnable = this.zeroLineEnable
	  var zeroLineColor  = this.zeroLineColor
	  var zeroLineWidth  = this.zeroLineWidth
	  if(zeroLineEnable[0] || zeroLineEnable[1]) {
	    line.bind()
	    for(var i=0; i<2; ++i) {
	      if(!zeroLineEnable[i] ||
	        !(dataBox[i] <= 0 && dataBox[i+2] >= 0)) {
	        continue
	      }
	
	      var zeroIntercept = screenBox[i] -
	        dataBox[i] * (screenBox[i+2] - screenBox[i]) / (dataBox[i+2] - dataBox[i])
	
	      if(i === 0) {
	        line.drawLine(
	          zeroIntercept, screenBox[1], zeroIntercept, screenBox[3],
	          zeroLineWidth[i],
	          zeroLineColor[i])
	      } else {
	        line.drawLine(
	          screenBox[0], zeroIntercept, screenBox[2], zeroIntercept,
	          zeroLineWidth[i],
	          zeroLineColor[i])
	      }
	    }
	  }
	
	  //Draw traces
	  for(var i=0; i<objects.length; ++i) {
	    objects[i].draw()
	  }
	
	  //Return viewport to default
	  gl.viewport(
	    screenBox[0],
	    screenBox[1],
	    screenBox[2]-screenBox[0],
	    screenBox[3]-screenBox[1])
	  gl.scissor(
	    screenBox[0],
	    screenBox[1],
	    screenBox[2]-screenBox[0],
	    screenBox[3]-screenBox[1])
	
	  //Draw tick marks
	  this.grid.drawTickMarks()
	
	  //Draw line elements
	  line.bind()
	
	  //Draw border lines
	  var borderLineEnable = this.borderLineEnable
	  var borderLineWidth  = this.borderLineWidth
	  var borderLineColor  = this.borderLineColor
	  if(borderLineEnable[1]) {
	    line.drawLine(
	      viewPixels[0], viewPixels[1] - 0.5*borderLineWidth[1]*pixelRatio,
	      viewPixels[0], viewPixels[3] + 0.5*borderLineWidth[3]*pixelRatio,
	      borderLineWidth[1], borderLineColor[1])
	  }
	  if(borderLineEnable[0]) {
	    line.drawLine(
	      viewPixels[0] - 0.5*borderLineWidth[0]*pixelRatio, viewPixels[1],
	      viewPixels[2] + 0.5*borderLineWidth[2]*pixelRatio, viewPixels[1],
	      borderLineWidth[0], borderLineColor[0])
	  }
	  if(borderLineEnable[3]) {
	    line.drawLine(
	      viewPixels[2], viewPixels[1] - 0.5*borderLineWidth[1]*pixelRatio,
	      viewPixels[2], viewPixels[3] + 0.5*borderLineWidth[3]*pixelRatio,
	      borderLineWidth[3], borderLineColor[3])
	  }
	  if(borderLineEnable[2]) {
	    line.drawLine(
	      viewPixels[0] - 0.5*borderLineWidth[0]*pixelRatio, viewPixels[3],
	      viewPixels[2] + 0.5*borderLineWidth[2]*pixelRatio, viewPixels[3],
	      borderLineWidth[2], borderLineColor[2])
	  }
	
	  //Draw text elements
	  text.bind()
	  for(var i=0; i<2; ++i) {
	    text.drawTicks(i)
	  }
	  if(this.titleEnable) {
	    text.drawTitle()
	  }
	
	  //Draw other overlay elements (select boxes, etc.)
	  var overlays = this.overlays
	  for(var i=0; i<overlays.length; ++i) {
	    overlays[i].draw()
	  }
	
	  //Turn off scissor test
	  gl.disable(gl.SCISSOR_TEST)
	  gl.disable(gl.BLEND)
	  gl.depthMask(true)
	}
	})()
	
	proto.drawPick = (function() {
	
	return function() {
	  if (this.static) return;
	
	  var pickBuffer = this.pickBuffer
	  var gl = this.gl
	
	  this._pickTimeout = null
	  pickBuffer.begin()
	
	  var pickOffset = 1
	  var objects = this.objects
	  for(var i=0; i<objects.length; ++i) {
	    pickOffset = objects[i].drawPick(pickOffset)
	  }
	
	  pickBuffer.end()
	}
	})()
	
	proto.pick = (function() {
	return function(x, y) {
	  if (this.static) return;
	
	  var pixelRatio     = this.pixelRatio
	  var pickPixelRatio = this.pickPixelRatio
	  var viewBox        = this.viewBox
	
	  var scrX = Math.round((x - viewBox[0] / pixelRatio) * pickPixelRatio)|0
	  var scrY = Math.round((y - viewBox[1] / pixelRatio) * pickPixelRatio)|0
	
	  var pickResult = this.pickBuffer.query(scrX, scrY, this.pickRadius)
	  if(!pickResult) {
	    return null
	  }
	
	  var pickValue = pickResult.id +
	    (pickResult.value[0]<<8)  +
	    (pickResult.value[1]<<16) +
	    (pickResult.value[2]<<24)
	
	  var objects = this.objects
	  for(var i=0; i<objects.length; ++i) {
	    var result = objects[i].pick(scrX, scrY, pickValue)
	    if(result) {
	      return result
	    }
	  }
	
	  return null
	}
	})()
	
	function deepClone(array) {
	  var result = array.slice()
	  for(var i=0; i<result.length; ++i) {
	    result[i] = result[i].slice()
	  }
	  return result
	}
	
	function compareTicks(a, b) {
	  return a.x - b.x
	}
	
	proto.setScreenBox = function(nbox) {
	  var screenBox = this.screenBox
	  var pixelRatio = this.pixelRatio
	
	  screenBox[0] = Math.round(nbox[0] * pixelRatio) | 0
	  screenBox[1] = Math.round(nbox[1] * pixelRatio) | 0
	  screenBox[2] = Math.round(nbox[2] * pixelRatio) | 0
	  screenBox[3] = Math.round(nbox[3] * pixelRatio) | 0
	
	  this.setDirty()
	}
	
	proto.setDataBox = function(nbox) {
	  var dataBox = this.dataBox
	
	  var different =
	    dataBox[0] !== nbox[0] ||
	    dataBox[1] !== nbox[1] ||
	    dataBox[2] !== nbox[2] ||
	    dataBox[3] !== nbox[3]
	
	  if(different) {
	    dataBox[0] = nbox[0]
	    dataBox[1] = nbox[1]
	    dataBox[2] = nbox[2]
	    dataBox[3] = nbox[3]
	
	    this.setDirty()
	  }
	}
	
	proto.setViewBox = function(nbox) {
	  var pixelRatio = this.pixelRatio
	  var viewBox = this.viewBox
	
	  viewBox[0] = Math.round(nbox[0] * pixelRatio)|0
	  viewBox[1] = Math.round(nbox[1] * pixelRatio)|0
	  viewBox[2] = Math.round(nbox[2] * pixelRatio)|0
	  viewBox[3] = Math.round(nbox[3] * pixelRatio)|0
	
	  var pickPixelRatio = this.pickPixelRatio
	  this.pickBuffer.shape = [
	    Math.round((nbox[2] - nbox[0]) * pickPixelRatio)|0,
	    Math.round((nbox[3] - nbox[1]) * pickPixelRatio)|0 ]
	
	  this.setDirty()
	}
	
	proto.update = function(options) {
	  options = options || {}
	
	  var gl = this.gl
	
	  this.pixelRatio      = options.pixelRatio || 1
	
	  var pixelRatio       = this.pixelRatio
	  this.pickPixelRatio  = Math.max(pixelRatio, 1)
	
	  this.setScreenBox(options.screenBox ||
	    [0, 0, gl.drawingBufferWidth/pixelRatio, gl.drawingBufferHeight/pixelRatio])
	
	  var screenBox = this.screenBox
	  this.setViewBox(options.viewBox ||
	    [0.125*(this.screenBox[2]-this.screenBox[0])/pixelRatio,
	     0.125*(this.screenBox[3]-this.screenBox[1])/pixelRatio,
	     0.875*(this.screenBox[2]-this.screenBox[0])/pixelRatio,
	     0.875*(this.screenBox[3]-this.screenBox[1])/pixelRatio])
	
	  var viewBox = this.viewBox
	  var aspectRatio = (viewBox[2] - viewBox[0]) / (viewBox[3] - viewBox[1])
	  this.setDataBox(options.dataBox || [-10, -10/aspectRatio, 10, 10/aspectRatio])
	
	  this.borderColor     = options.borderColor !== false ? (options.borderColor || [0,0,0,0]).slice() : false
	  this.backgroundColor = (options.backgroundColor || [0,0,0,0]).slice()
	
	  this.gridLineEnable  = (options.gridLineEnable || [true,true]).slice()
	  this.gridLineWidth   = (options.gridLineWidth || [1,1]).slice()
	  this.gridLineColor   = deepClone(options.gridLineColor ||
	    [[0.5,0.5,0.5,1],[0.5,0.5,0.5,1]])
	
	  this.zeroLineEnable   = (options.zeroLineEnable || [true, true]).slice()
	  this.zeroLineWidth    = (options.zeroLineWidth || [4, 4]).slice()
	  this.zeroLineColor    = deepClone(options.zeroLineColor ||
	    [[0, 0, 0, 1],[0, 0, 0, 1]])
	
	  this.tickMarkLength   = (options.tickMarkLength || [0,0,0,0]).slice()
	  this.tickMarkWidth    = (options.tickMarkWidth || [0,0,0,0]).slice()
	  this.tickMarkColor    = deepClone(options.tickMarkColor ||
	    [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
	
	  this.titleCenter      = (options.titleCenter || [
	    0.5*(viewBox[0]+viewBox[2])/pixelRatio,(viewBox[3]+120)/pixelRatio]).slice()
	  this.titleEnable      = !('titleEnable' in options) || !!options.titleEnable
	  this.titleAngle       = options.titleAngle || 0
	  this.titleColor       = (options.titleColor || [0,0,0,1]).slice()
	
	  this.labelPad         = (options.labelPad || [15,15,15,15]).slice()
	  this.labelAngle       = (options.labelAngle ||
	    [0,Math.PI/2,0,3.0*Math.PI/2]).slice()
	  this.labelEnable      = (options.labelEnable || [true,true,true,true]).slice()
	  this.labelColor       = deepClone(options.labelColor ||
	    [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
	
	  this.tickPad         = (options.tickPad || [15,15,15,15]).slice()
	  this.tickAngle       = (options.tickAngle || [0,0,0,0]).slice()
	  this.tickEnable      = (options.tickEnable || [true,true,true,true]).slice()
	  this.tickColor       = deepClone(options.tickColor ||
	    [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
	
	  this.borderLineEnable = (options.borderLineEnable ||
	                            [true,true,true,true]).slice()
	  this.borderLineWidth  = (options.borderLineWidth || [2,2,2,2]).slice()
	  this.borderLineColor  = deepClone(options.borderLineColor ||
	                          [[0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1],
	                           [0,0,0,1]])
	
	  var ticks = options.ticks || [ [], [] ]
	
	  //Compute bounds on ticks
	  var bounds = this._tickBounds
	  bounds[0] = bounds[1] =  Infinity
	  bounds[2] = bounds[3] = -Infinity
	  for(var i=0; i<2; ++i) {
	    var axisTicks = ticks[i].slice(0)
	    if(axisTicks.length === 0) {
	      continue
	    }
	    axisTicks.sort(compareTicks)
	    bounds[i]   = Math.min(bounds[i], axisTicks[0].x)
	    bounds[i+2] = Math.max(bounds[i+2], axisTicks[axisTicks.length-1].x)
	  }
	
	  //Update grid
	  this.grid.update({
	    bounds: bounds,
	    ticks:  ticks
	  })
	
	  //Update text
	  this.text.update({
	    bounds:     bounds,
	    ticks:      ticks,
	    labels:     options.labels    || ['x', 'y'],
	    labelSize:  options.labelSize || [12,12],
	    labelFont:  options.labelFont || ['sans-serif', 'sans-serif'],
	    title:      options.title     || '',
	    titleSize:  options.titleSize || 18,
	    titleFont:  options.titleFont || 'sans-serif'
	  })
	
	  this.static = !!options.static;
	
	  this.setDirty()
	}
	
	proto.dispose = function() {
	  this.box.dispose()
	  this.grid.dispose()
	  this.text.dispose()
	  this.line.dispose()
	  for(var i=this.objects.length-1; i>=0; --i) {
	    this.objects[i].dispose()
	  }
	  this.objects.length = 0
	  for(var i=this.overlays.length-1; i>=0; --i) {
	    this.overlays[i].dispose()
	  }
	  this.overlays.length = 0
	
	  this.gl = null
	}
	
	proto.addObject = function(object) {
	  if(this.objects.indexOf(object) < 0) {
	    this.objects.push(object)
	    this.setDirty()
	  }
	}
	
	proto.removeObject = function(object) {
	  var objects = this.objects
	  for(var i=0; i<objects.length; ++i) {
	    if(objects[i] === object) {
	      objects.splice(i,1)
	      this.setDirty()
	      break
	    }
	  }
	}
	
	proto.addOverlay = function(object) {
	  if(this.overlays.indexOf(object) < 0) {
	    this.overlays.push(object)
	    this.setOverlayDirty()
	  }
	}
	
	proto.removeOverlay = function(object) {
	  var objects = this.overlays
	  for(var i=0; i<objects.length; ++i) {
	    if(objects[i] === object) {
	      objects.splice(i,1)
	      this.setOverlayDirty()
	      break
	    }
	  }
	}
	
	function createGLPlot2D(options) {
	  var gl = options.gl
	  var pickBuffer = createPick(gl, [
	    gl.drawingBufferWidth, gl.drawingBufferHeight])
	  var plot = new GLPlot2D(gl, pickBuffer)
	  plot.grid = createGrid(plot)
	  plot.text = createText(plot)
	  plot.line = createLine(plot)
	  plot.box  = createBox(plot)
	  plot.update(options)
	  return plot
	}
	
	},{"./lib/box":283,"./lib/grid":284,"./lib/line":285,"./lib/text":287,"gl-select-static":302}],290:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createCamera
	
	var now         = _dereq_('right-now')
	var createView  = _dereq_('3d-view')
	var mouseChange = _dereq_('mouse-change')
	var mouseWheel  = _dereq_('mouse-wheel')
	var mouseOffset = _dereq_('mouse-event-offset')
	var hasPassive  = _dereq_('has-passive-events')
	
	function createCamera(element, options) {
	  element = element || document.body
	  options = options || {}
	
	  var limits  = [ 0.01, Infinity ]
	  if('distanceLimits' in options) {
	    limits[0] = options.distanceLimits[0]
	    limits[1] = options.distanceLimits[1]
	  }
	  if('zoomMin' in options) {
	    limits[0] = options.zoomMin
	  }
	  if('zoomMax' in options) {
	    limits[1] = options.zoomMax
	  }
	
	  var view = createView({
	    center: options.center || [0,0,0],
	    up:     options.up     || [0,1,0],
	    eye:    options.eye    || [0,0,10],
	    mode:   options.mode   || 'orbit',
	    distanceLimits: limits
	  })
	
	  var pmatrix = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
	  var distance = 0.0
	  var width   = element.clientWidth
	  var height  = element.clientHeight
	
	  var camera = {
	    keyBindingMode: 'rotate',
	    enableWheel: true,
	    view:               view,
	    element:            element,
	    delay:              options.delay          || 16,
	    rotateSpeed:        options.rotateSpeed    || 1,
	    zoomSpeed:          options.zoomSpeed      || 1,
	    translateSpeed:     options.translateSpeed || 1,
	    flipX:              !!options.flipX,
	    flipY:              !!options.flipY,
	    modes:              view.modes,
	    _ortho: options._ortho || (options.projection && options.projection.type === 'orthographic') || false,
	    tick: function() {
	      var t = now()
	      var delay = this.delay
	      var ctime = t - 2 * delay
	      view.idle(t-delay)
	      view.recalcMatrix(ctime)
	      view.flush(t-(100+delay*2))
	      var allEqual = true
	      var matrix = view.computedMatrix
	      for(var i=0; i<16; ++i) {
	        allEqual = allEqual && (pmatrix[i] === matrix[i])
	        pmatrix[i] = matrix[i]
	      }
	      var sizeChanged =
	          element.clientWidth === width &&
	          element.clientHeight === height
	      width  = element.clientWidth
	      height = element.clientHeight
	      if(allEqual) {
	        return !sizeChanged
	      }
	      distance = Math.exp(view.computedRadius[0])
	      return true
	    },
	    lookAt: function(eye, center, up) {
	      view.lookAt(view.lastT(), eye, center, up)
	    },
	    rotate: function(pitch, yaw, roll) {
	      view.rotate(view.lastT(), pitch, yaw, roll)
	    },
	    pan: function(dx, dy, dz) {
	      view.pan(view.lastT(), dx, dy, dz)
	    },
	    translate: function(dx, dy, dz) {
	      view.translate(view.lastT(), dx, dy, dz)
	    }
	  }
	
	  Object.defineProperties(camera, {
	    matrix: {
	      get: function() {
	        return view.computedMatrix
	      },
	      set: function(mat) {
	        view.setMatrix(view.lastT(), mat)
	        return view.computedMatrix
	      },
	      enumerable: true
	    },
	    mode: {
	      get: function() {
	        return view.getMode()
	      },
	      set: function(mode) {
	        var curUp = view.computedUp.slice()
	        var curEye = view.computedEye.slice()
	        var curCenter = view.computedCenter.slice()
	        view.setMode(mode)
	        if(mode === 'turntable') {
	          // Hacky time warping stuff to generate smooth animation
	          var t0 = now()
	          view._active.lookAt(t0, curEye, curCenter, curUp)
	          view._active.lookAt(t0 + 500, curEye, curCenter, [0, 0, 1])
	          view._active.flush(t0)
	        }
	        return view.getMode()
	      },
	      enumerable: true
	    },
	    center: {
	      get: function() {
	        return view.computedCenter
	      },
	      set: function(ncenter) {
	        view.lookAt(view.lastT(), null, ncenter)
	        return view.computedCenter
	      },
	      enumerable: true
	    },
	    eye: {
	      get: function() {
	        return view.computedEye
	      },
	      set: function(neye) {
	        view.lookAt(view.lastT(), neye)
	        return view.computedEye
	      },
	      enumerable: true
	    },
	    up: {
	      get: function() {
	        return view.computedUp
	      },
	      set: function(nup) {
	        view.lookAt(view.lastT(), null, null, nup)
	        return view.computedUp
	      },
	      enumerable: true
	    },
	    distance: {
	      get: function() {
	        return distance
	      },
	      set: function(d) {
	        view.setDistance(view.lastT(), d)
	        return d
	      },
	      enumerable: true
	    },
	    distanceLimits: {
	      get: function() {
	        return view.getDistanceLimits(limits)
	      },
	      set: function(v) {
	        view.setDistanceLimits(v)
	        return v
	      },
	      enumerable: true
	    }
	  })
	
	  element.addEventListener('contextmenu', function(ev) {
	    ev.preventDefault()
	    return false
	  })
	
	  camera._lastX = -1
	  camera._lastY = -1
	  camera._lastMods = {shift: false, control: false, alt: false, meta: false}
	
	  camera.enableMouseListeners = function() {
	
	    camera.mouseListener = mouseChange(element, handleInteraction)
	
	    //enable simple touch interactions
	    element.addEventListener('touchstart', function (ev) {
	      var xy = mouseOffset(ev.changedTouches[0], element)
	      handleInteraction(0, xy[0], xy[1], camera._lastMods)
	      handleInteraction(1, xy[0], xy[1], camera._lastMods)
	
	      ev.preventDefault()
	    }, hasPassive ? {passive: false} : false)
	
	    element.addEventListener('touchmove', function (ev) {
	      var xy = mouseOffset(ev.changedTouches[0], element)
	      handleInteraction(1, xy[0], xy[1], camera._lastMods)
	
	      ev.preventDefault()
	    }, hasPassive ? {passive: false} : false)
	
	    element.addEventListener('touchend', function (ev) {
	
	      handleInteraction(0, camera._lastX, camera._lastY, camera._lastMods)
	
	      ev.preventDefault()
	    }, hasPassive ? {passive: false} : false)
	
	    function handleInteraction (buttons, x, y, mods) {
	      var keyBindingMode = camera.keyBindingMode
	
	      if(keyBindingMode === false) return
	
	      var rotate = keyBindingMode === 'rotate'
	      var pan = keyBindingMode === 'pan'
	      var zoom = keyBindingMode === 'zoom'
	
	      var ctrl = !!mods.control
	      var alt = !!mods.alt
	      var shift = !!mods.shift
	      var left = !!(buttons & 1)
	      var right = !!(buttons & 2)
	      var middle = !!(buttons & 4)
	
	      var scale = 1.0 / element.clientHeight
	      var dx    = scale * (x - camera._lastX)
	      var dy    = scale * (y - camera._lastY)
	
	      var flipX = camera.flipX ? 1 : -1
	      var flipY = camera.flipY ? 1 : -1
	
	      var drot  = Math.PI * camera.rotateSpeed
	
	      var t = now()
	
	      if(camera._lastX !== -1 && camera._lastY !== -1) {
	        if((rotate && left && !ctrl && !alt && !shift) || (left && !ctrl && !alt && shift)) {
	          // Rotate
	          view.rotate(t, flipX * drot * dx, -flipY * drot * dy, 0)
	        }
	
	        if((pan && left && !ctrl && !alt && !shift) || right || (left && ctrl && !alt && !shift)) {
	          // Pan
	          view.pan(t, -camera.translateSpeed * dx * distance, camera.translateSpeed * dy * distance, 0)
	        }
	
	        if((zoom && left && !ctrl && !alt && !shift) || middle || (left && !ctrl && alt && !shift)) {
	          // Zoom
	          var kzoom = -camera.zoomSpeed * dy / window.innerHeight * (t - view.lastT()) * 100
	          view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1))
	        }
	      }
	
	      camera._lastX = x
	      camera._lastY = y
	      camera._lastMods = mods
	
	      return true
	    }
	
	    camera.wheelListener = mouseWheel(element, function(dx, dy) {
	      // TODO remove now that we can disable scroll via scrollZoom?
	      if(camera.keyBindingMode === false) return
	      if(!camera.enableWheel) return
	
	      var flipX = camera.flipX ? 1 : -1
	      var flipY = camera.flipY ? 1 : -1
	      var t = now()
	      if(Math.abs(dx) > Math.abs(dy)) {
	        view.rotate(t, 0, 0, -dx * flipX * Math.PI * camera.rotateSpeed / window.innerWidth)
	      } else {
	        if(!camera._ortho) {
	          var kzoom = -camera.zoomSpeed * flipY * dy / window.innerHeight * (t - view.lastT()) / 20.0
	          view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1))
	        }
	      }
	    }, true)
	  }
	
	  camera.enableMouseListeners()
	
	  return camera
	}
	
	},{"3d-view":54,"has-passive-events":412,"mouse-change":436,"mouse-event-offset":437,"mouse-wheel":439,"right-now":502}],291:[function(_dereq_,module,exports){
	var glslify      = _dereq_('glslify')
	var createShader = _dereq_('gl-shader')
	
	var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"])
	var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"])
	
	module.exports = function(gl) {
	  return createShader(gl, vertSrc, fragSrc, null, [ { name: 'position', type: 'vec2'}])
	}
	
	},{"gl-shader":303,"glslify":410}],292:[function(_dereq_,module,exports){
	'use strict'
	
	var createCamera = _dereq_('./camera.js')
	var createAxes   = _dereq_('gl-axes3d')
	var axesRanges   = _dereq_('gl-axes3d/properties')
	var createSpikes = _dereq_('gl-spikes3d')
	var createSelect = _dereq_('gl-select-static')
	var createFBO    = _dereq_('gl-fbo')
	var drawTriangle = _dereq_('a-big-triangle')
	var mouseChange  = _dereq_('mouse-change')
	var perspective  = _dereq_('gl-mat4/perspective')
	var ortho        = _dereq_('gl-mat4/ortho')
	var createShader = _dereq_('./lib/shader')
	var isMobile = _dereq_('is-mobile')({ tablet: true })
	
	module.exports = {
	  createScene: createScene,
	  createCamera: createCamera
	}
	
	function MouseSelect() {
	  this.mouse          = [-1,-1]
	  this.screen         = null
	  this.distance       = Infinity
	  this.index          = null
	  this.dataCoordinate = null
	  this.dataPosition   = null
	  this.object         = null
	  this.data           = null
	}
	
	function getContext(canvas, options) {
	  var gl = null
	  try {
	    gl = canvas.getContext('webgl', options)
	    if(!gl) {
	      gl = canvas.getContext('experimental-webgl', options)
	    }
	  } catch(e) {
	    return null
	  }
	  return gl
	}
	
	function roundUpPow10(x) {
	  var y = Math.round(Math.log(Math.abs(x)) / Math.log(10))
	  if(y < 0) {
	    var base = Math.round(Math.pow(10, -y))
	    return Math.ceil(x*base) / base
	  } else if(y > 0) {
	    var base = Math.round(Math.pow(10, y))
	    return Math.ceil(x/base) * base
	  }
	  return Math.ceil(x)
	}
	
	function defaultBool(x) {
	  if(typeof x === 'boolean') {
	    return x
	  }
	  return true
	}
	
	function createScene(options) {
	  options = options || {}
	  options.camera = options.camera || {}
	
	  var canvas = options.canvas
	  if(!canvas) {
	    canvas = document.createElement('canvas')
	    if(options.container) {
	      var container = options.container
	      container.appendChild(canvas)
	    } else {
	      document.body.appendChild(canvas)
	    }
	  }
	
	  var gl = options.gl
	  if(!gl) {
	    gl = getContext(canvas,
	      options.glOptions || {
	        premultipliedAlpha: true,
	        antialias: true,
	        preserveDrawingBuffer: isMobile
	      })
	  }
	  if(!gl) {
	    throw new Error('webgl not supported')
	  }
	
	  //Initial bounds
	  var bounds = options.bounds || [[-10,-10,-10], [10,10,10]]
	
	  //Create selection
	  var selection = new MouseSelect()
	
	  //Accumulation buffer
	  var accumBuffer = createFBO(gl,
	    [gl.drawingBufferWidth, gl.drawingBufferHeight], {
	      preferFloat: !isMobile
	    })
	
	  var accumShader = createShader(gl)
	
	  var isOrtho =
	    (options.cameraObject && options.cameraObject._ortho === true) ||
	    (options.camera.projection && options.camera.projection.type === 'orthographic') ||
	    false
	
	  //Create a camera
	  var cameraOptions = {
	    eye:     options.camera.eye     || [2,0,0],
	    center:  options.camera.center  || [0,0,0],
	    up:      options.camera.up      || [0,1,0],
	    zoomMin: options.camera.zoomMax || 0.1,
	    zoomMax: options.camera.zoomMin || 100,
	    mode:    options.camera.mode    || 'turntable',
	    _ortho:  isOrtho
	  }
	
	  //Create axes
	  var axesOptions = options.axes || {}
	  var axes = createAxes(gl, axesOptions)
	  axes.enable = !axesOptions.disable
	
	  //Create spikes
	  var spikeOptions = options.spikes || {}
	  var spikes = createSpikes(gl, spikeOptions)
	
	  //Object list is empty initially
	  var objects         = []
	  var pickBufferIds   = []
	  var pickBufferCount = []
	  var pickBuffers     = []
	
	  //Dirty flag, skip redraw if scene static
	  var dirty       = true
	  var pickDirty   = true
	
	  var projection     = new Array(16)
	  var model          = new Array(16)
	
	  var cameraParams = {
	    view:         null,
	    projection:   projection,
	    model:        model,
	    _ortho:        false
	  }
	
	  var pickDirty = true
	
	  var viewShape = [ gl.drawingBufferWidth, gl.drawingBufferHeight ]
	
	  var camera = options.cameraObject || createCamera(canvas, cameraOptions)
	
	  //Create scene object
	  var scene = {
	    gl:           gl,
	    contextLost:  false,
	    pixelRatio:   options.pixelRatio || 1,
	    canvas:       canvas,
	    selection:    selection,
	    camera:       camera,
	    axes:         axes,
	    axesPixels:   null,
	    spikes:       spikes,
	    bounds:       bounds,
	    objects:      objects,
	    shape:        viewShape,
	    aspect:       options.aspectRatio || [1,1,1],
	    pickRadius:   options.pickRadius || 10,
	    zNear:        options.zNear || 0.01,
	    zFar:         options.zFar  || 1000,
	    fovy:         options.fovy  || Math.PI/4,
	    clearColor:   options.clearColor || [0,0,0,0],
	    autoResize:   defaultBool(options.autoResize),
	    autoBounds:   defaultBool(options.autoBounds),
	    autoScale:    !!options.autoScale,
	    autoCenter:   defaultBool(options.autoCenter),
	    clipToBounds: defaultBool(options.clipToBounds),
	    snapToData:   !!options.snapToData,
	    onselect:     options.onselect || null,
	    onrender:     options.onrender || null,
	    onclick:      options.onclick  || null,
	    cameraParams: cameraParams,
	    oncontextloss: null,
	    mouseListener: null,
	    _stopped: false,
	
	    getAspectratio: function() {
	      return {
	        x: this.aspect[0],
	        y: this.aspect[1],
	        z: this.aspect[2]
	      }
	    },
	
	    setAspectratio: function(aspectratio) {
	      this.aspect[0] = aspectratio.x
	      this.aspect[1] = aspectratio.y
	      this.aspect[2] = aspectratio.z
	    }
	  }
	
	  var pickShape = [ (gl.drawingBufferWidth/scene.pixelRatio)|0, (gl.drawingBufferHeight/scene.pixelRatio)|0 ]
	
	  function resizeListener() {
	    if(scene._stopped) {
	      return
	    }
	    if(!scene.autoResize) {
	      return
	    }
	    var parent = canvas.parentNode
	    var width  = 1
	    var height = 1
	    if(parent && parent !== document.body) {
	      width  = parent.clientWidth
	      height = parent.clientHeight
	    } else {
	      width  = window.innerWidth
	      height = window.innerHeight
	    }
	    var nextWidth  = Math.ceil(width  * scene.pixelRatio)|0
	    var nextHeight = Math.ceil(height * scene.pixelRatio)|0
	    if(nextWidth !== canvas.width || nextHeight !== canvas.height) {
	      canvas.width   = nextWidth
	      canvas.height  = nextHeight
	      var style = canvas.style
	      style.position = style.position || 'absolute'
	      style.left     = '0px'
	      style.top      = '0px'
	      style.width    = width  + 'px'
	      style.height   = height + 'px'
	      dirty = true
	    }
	  }
	  if(scene.autoResize) {
	    resizeListener()
	  }
	  window.addEventListener('resize', resizeListener)
	
	  function reallocPickIds() {
	    var numObjs = objects.length
	    var numPick = pickBuffers.length
	    for(var i=0; i<numPick; ++i) {
	      pickBufferCount[i] = 0
	    }
	    obj_loop:
	    for(var i=0; i<numObjs; ++i) {
	      var obj = objects[i]
	      var pickCount = obj.pickSlots
	      if(!pickCount) {
	        pickBufferIds[i] = -1
	        continue
	      }
	      for(var j=0; j<numPick; ++j) {
	        if(pickBufferCount[j] + pickCount < 255) {
	          pickBufferIds[i] = j
	          obj.setPickBase(pickBufferCount[j]+1)
	          pickBufferCount[j] += pickCount
	          continue obj_loop
	        }
	      }
	      //Create new pick buffer
	      var nbuffer = createSelect(gl, viewShape)
	      pickBufferIds[i] = numPick
	      pickBuffers.push(nbuffer)
	      pickBufferCount.push(pickCount)
	      obj.setPickBase(1)
	      numPick += 1
	    }
	    while(numPick > 0 && pickBufferCount[numPick-1] === 0) {
	      pickBufferCount.pop()
	      pickBuffers.pop().dispose()
	    }
	  }
	
	  scene.update = function(options) {
	
	    if(scene._stopped) {
	      return
	    }
	    options = options || {}
	    dirty = true
	    pickDirty = true
	  }
	
	  scene.add = function(obj) {
	    if(scene._stopped) {
	      return
	    }
	    obj.axes = axes
	    objects.push(obj)
	    pickBufferIds.push(-1)
	    dirty = true
	    pickDirty = true
	    reallocPickIds()
	  }
	
	  scene.remove = function(obj) {
	    if(scene._stopped) {
	      return
	    }
	    var idx = objects.indexOf(obj)
	    if(idx < 0) {
	      return
	    }
	    objects.splice(idx, 1)
	    pickBufferIds.pop()
	    dirty = true
	    pickDirty = true
	    reallocPickIds()
	  }
	
	  scene.dispose = function() {
	    if(scene._stopped) {
	      return
	    }
	
	    scene._stopped = true
	
	    window.removeEventListener('resize', resizeListener)
	    canvas.removeEventListener('webglcontextlost', checkContextLoss)
	    scene.mouseListener.enabled = false
	
	    if(scene.contextLost) {
	      return
	    }
	
	    //Destroy objects
	    axes.dispose()
	    spikes.dispose()
	    for(var i=0; i<objects.length; ++i) {
	      objects[i].dispose()
	    }
	
	    //Clean up buffers
	    accumBuffer.dispose()
	    for(var i=0; i<pickBuffers.length; ++i) {
	      pickBuffers[i].dispose()
	    }
	
	    //Clean up shaders
	    accumShader.dispose()
	
	    //Release all references
	    gl = null
	    axes = null
	    spikes = null
	    objects = []
	  }
	
	  //Update mouse position
	  scene._mouseRotating = false
	  scene._prevButtons = 0
	
	  scene.enableMouseListeners = function() {
	
	    scene.mouseListener = mouseChange(canvas, function(buttons, x, y) {
	      if(scene._stopped) {
	        return
	      }
	
	      var numPick = pickBuffers.length
	      var numObjs = objects.length
	      var prevObj = selection.object
	
	      selection.distance = Infinity
	      selection.mouse[0] = x
	      selection.mouse[1] = y
	      selection.object = null
	      selection.screen = null
	      selection.dataCoordinate = selection.dataPosition = null
	
	      var change = false
	
	      if(buttons && scene._prevButtons) {
	        scene._mouseRotating = true
	      } else {
	        if(scene._mouseRotating) {
	          pickDirty = true
	        }
	        scene._mouseRotating = false
	
	        for(var i=0; i<numPick; ++i) {
	          var result = pickBuffers[i].query(x, pickShape[1] - y - 1, scene.pickRadius)
	          if(result) {
	            if(result.distance > selection.distance) {
	              continue
	            }
	            for(var j=0; j<numObjs; ++j) {
	              var obj = objects[j]
	              if(pickBufferIds[j] !== i) {
	                continue
	              }
	              var objPick = obj.pick(result)
	              if(objPick) {
	                selection.buttons        = buttons
	                selection.screen         = result.coord
	                selection.distance       = result.distance
	                selection.object         = obj
	                selection.index          = objPick.distance
	                selection.dataPosition   = objPick.position
	                selection.dataCoordinate = objPick.dataCoordinate
	                selection.data           = objPick
	                change = true
	              }
	            }
	          }
	        }
	      }
	
	      if(prevObj && prevObj !== selection.object) {
	        if(prevObj.highlight) {
	          prevObj.highlight(null)
	        }
	        dirty = true
	      }
	      if(selection.object) {
	        if(selection.object.highlight) {
	          selection.object.highlight(selection.data)
	        }
	        dirty = true
	      }
	
	      change = change || (selection.object !== prevObj)
	      if(change && scene.onselect) {
	        scene.onselect(selection)
	      }
	
	      if((buttons & 1) && !(scene._prevButtons & 1) && scene.onclick) {
	        scene.onclick(selection)
	      }
	      scene._prevButtons = buttons
	    })
	  }
	
	  function checkContextLoss() {
	    if(scene.contextLost) {
	      return true
	    }
	    if(gl.isContextLost()) {
	      scene.contextLost = true
	      scene.mouseListener.enabled = false
	      scene.selection.object = null
	      if(scene.oncontextloss) {
	        scene.oncontextloss()
	      }
	    }
	  }
	
	  canvas.addEventListener('webglcontextlost', checkContextLoss)
	
	  //Render the scene for mouse picking
	  function renderPick() {
	    if(checkContextLoss()) {
	      return
	    }
	
	    gl.colorMask(true, true, true, true)
	    gl.depthMask(true)
	    gl.disable(gl.BLEND)
	    gl.enable(gl.DEPTH_TEST)
	    gl.depthFunc(gl.LEQUAL)
	
	    var numObjs = objects.length
	    var numPick = pickBuffers.length
	    for(var j=0; j<numPick; ++j) {
	      var buf = pickBuffers[j]
	      buf.shape = pickShape
	      buf.begin()
	      for(var i=0; i<numObjs; ++i) {
	        if(pickBufferIds[i] !== j) {
	          continue
	        }
	        var obj = objects[i]
	        if(obj.drawPick) {
	          obj.pixelRatio = 1
	          obj.drawPick(cameraParams)
	        }
	      }
	      buf.end()
	    }
	  }
	
	  var nBounds = [
	    [ Infinity, Infinity, Infinity],
	    [-Infinity,-Infinity,-Infinity]]
	
	  var prevBounds = [nBounds[0].slice(), nBounds[1].slice()]
	
	  function redraw() {
	    if(checkContextLoss()) {
	      return
	    }
	
	    resizeListener()
	
	    //Tick camera
	    var cameraMoved = scene.camera.tick()
	    cameraParams.view = scene.camera.matrix
	    dirty     = dirty || cameraMoved
	    pickDirty = pickDirty || cameraMoved
	
	      //Set pixel ratio
	    axes.pixelRatio   = scene.pixelRatio
	    spikes.pixelRatio = scene.pixelRatio
	
	    //Check if any objects changed, recalculate bounds
	    var numObjs = objects.length
	    var lo = nBounds[0]
	    var hi = nBounds[1]
	    lo[0] = lo[1] = lo[2] =  Infinity
	    hi[0] = hi[1] = hi[2] = -Infinity
	    for(var i=0; i<numObjs; ++i) {
	      var obj = objects[i]
	
	      //Set the axes properties for each object
	      obj.pixelRatio = scene.pixelRatio
	      obj.axes = scene.axes
	
	      dirty = dirty || !!obj.dirty
	      pickDirty = pickDirty || !!obj.dirty
	      var obb = obj.bounds
	      if(obb) {
	        var olo = obb[0]
	        var ohi = obb[1]
	        for(var j=0; j<3; ++j) {
	          lo[j] = Math.min(lo[j], olo[j])
	          hi[j] = Math.max(hi[j], ohi[j])
	        }
	      }
	    }
	
	    //Recalculate bounds
	    var bounds = scene.bounds
	    if(scene.autoBounds) {
	      for(var j=0; j<3; ++j) {
	        if(hi[j] < lo[j]) {
	          lo[j] = -1
	          hi[j] = 1
	        } else {
	          if(lo[j] === hi[j]) {
	            lo[j] -= 1
	            hi[j] += 1
	          }
	          var padding = 0.05 * (hi[j] - lo[j])
	          lo[j] = lo[j] - padding
	          hi[j] = hi[j] + padding
	        }
	        bounds[0][j] = lo[j]
	        bounds[1][j] = hi[j]
	      }
	    }
	
	    var boundsChanged = false
	    for(var j=0; j<3; ++j) {
	        boundsChanged = boundsChanged ||
	            (prevBounds[0][j] !== bounds[0][j])  ||
	            (prevBounds[1][j] !== bounds[1][j])
	        prevBounds[0][j] = bounds[0][j]
	        prevBounds[1][j] = bounds[1][j]
	    }
	
	    //Recalculate bounds
	    pickDirty = pickDirty || boundsChanged
	    dirty = dirty || boundsChanged
	
	    if(!dirty) {
	      return
	    }
	
	    if(boundsChanged) {
	      var tickSpacing = [0,0,0]
	      for(var i=0; i<3; ++i) {
	        tickSpacing[i] = roundUpPow10((bounds[1][i]-bounds[0][i]) / 10.0)
	      }
	      if(axes.autoTicks) {
	        axes.update({
	          bounds: bounds,
	          tickSpacing: tickSpacing
	        })
	      } else {
	        axes.update({
	          bounds: bounds
	        })
	      }
	    }
	
	    //Get scene
	    var width  = gl.drawingBufferWidth
	    var height = gl.drawingBufferHeight
	    viewShape[0] = width
	    viewShape[1] = height
	    pickShape[0] = Math.max(width/scene.pixelRatio, 1)|0
	    pickShape[1] = Math.max(height/scene.pixelRatio, 1)|0
	
	    //Compute camera parameters
	
	    if(isOrtho) {
	      ortho(projection,
	        -width/height,
	        width/height,
	        -1,
	        1,
	        scene.zNear,
	        scene.zFar
	      )
	      cameraParams._ortho = true
	    } else {
	      perspective(projection,
	        scene.fovy,
	        width/height,
	        scene.zNear,
	        scene.zFar
	      )
	      cameraParams._ortho = false
	    }
	
	    //Compute model matrix
	    for(var i=0; i<16; ++i) {
	      model[i] = 0
	    }
	    model[15] = 1
	
	    var maxS = 0
	    for(var i=0; i<3; ++i) {
	      maxS = Math.max(maxS, bounds[1][i] - bounds[0][i])
	    }
	
	    for(var i=0; i<3; ++i) {
	      if(scene.autoScale) {
	        model[5*i] = scene.aspect[i] / (bounds[1][i] - bounds[0][i])
	      } else {
	        model[5*i] = 1  / maxS
	      }
	      if(scene.autoCenter) {
	        model[12+i] = -model[5*i] * 0.5 * (bounds[0][i] + bounds[1][i])
	      }
	    }
	
	    //Apply axes/clip bounds
	    for(var i=0; i<numObjs; ++i) {
	      var obj = objects[i]
	
	      //Set axes bounds
	      obj.axesBounds = bounds
	
	      //Set clip bounds
	      if(scene.clipToBounds) {
	        obj.clipBounds = bounds
	      }
	    }
	    //Set spike parameters
	    if(selection.object) {
	      if(scene.snapToData) {
	        spikes.position = selection.dataCoordinate
	      } else {
	        spikes.position = selection.dataPosition
	      }
	      spikes.bounds = bounds
	    }
	
	    //If state changed, then redraw pick buffers
	    if(pickDirty) {
	      pickDirty = false
	      renderPick()
	    }
	
	    //Recalculate pixel data
	    scene.axesPixels = axesRanges(scene.axes, cameraParams, width, height)
	
	    //Call render callback
	    if(scene.onrender) {
	      scene.onrender()
	    }
	
	    //Read value
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null)
	    gl.viewport(0, 0, width, height)
	
	    //General strategy: 3 steps
	    //  1. render non-transparent objects
	    //  2. accumulate transparent objects into separate fbo
	    //  3. composite final scene
	
	    //Clear FBO
	    var clearColor = scene.clearColor
	    gl.clearColor(clearColor[0], clearColor[1], clearColor[2], clearColor[3])
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
	    gl.depthMask(true)
	    gl.colorMask(true, true, true, true)
	    gl.enable(gl.DEPTH_TEST)
	    gl.depthFunc(gl.LEQUAL)
	    gl.disable(gl.BLEND)
	    gl.disable(gl.CULL_FACE)  //most visualization surfaces are 2 sided
	
	    //Render opaque pass
	    var hasTransparent = false
	    if(axes.enable) {
	      hasTransparent = hasTransparent || axes.isTransparent()
	      axes.draw(cameraParams)
	    }
	    spikes.axes = axes
	    if(selection.object) {
	      spikes.draw(cameraParams)
	    }
	
	    gl.disable(gl.CULL_FACE)  //most visualization surfaces are 2 sided
	
	    for(var i=0; i<numObjs; ++i) {
	      var obj = objects[i]
	      obj.axes = axes
	      obj.pixelRatio = scene.pixelRatio
	      if(obj.isOpaque && obj.isOpaque()) {
	        obj.draw(cameraParams)
	      }
	      if(obj.isTransparent && obj.isTransparent()) {
	        hasTransparent = true
	      }
	    }
	
	    if(hasTransparent) {
	      //Render transparent pass
	      accumBuffer.shape = viewShape
	      accumBuffer.bind()
	      gl.clear(gl.DEPTH_BUFFER_BIT)
	      gl.colorMask(false, false, false, false)
	      gl.depthMask(true)
	      gl.depthFunc(gl.LESS)
	
	      //Render forward facing objects
	      if(axes.enable && axes.isTransparent()) {
	        axes.drawTransparent(cameraParams)
	      }
	      for(var i=0; i<numObjs; ++i) {
	        var obj = objects[i]
	        if(obj.isOpaque && obj.isOpaque()) {
	          obj.draw(cameraParams)
	        }
	      }
	
	      //Render transparent pass
	      gl.enable(gl.BLEND)
	      gl.blendEquation(gl.FUNC_ADD)
	      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
	      gl.colorMask(true, true, true, true)
	      gl.depthMask(false)
	      gl.clearColor(0,0,0,0)
	      gl.clear(gl.COLOR_BUFFER_BIT)
	
	      if(axes.isTransparent()) {
	        axes.drawTransparent(cameraParams)
	      }
	
	      for(var i=0; i<numObjs; ++i) {
	        var obj = objects[i]
	        if(obj.isTransparent && obj.isTransparent()) {
	          obj.drawTransparent(cameraParams)
	        }
	      }
	
	      //Unbind framebuffer
	      gl.bindFramebuffer(gl.FRAMEBUFFER, null)
	
	      //Draw composite pass
	      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
	      gl.disable(gl.DEPTH_TEST)
	      accumShader.bind()
	      accumBuffer.color[0].bind(0)
	      accumShader.uniforms.accumBuffer = 0
	      drawTriangle(gl)
	
	      //Turn off blending
	      gl.disable(gl.BLEND)
	    }
	
	    //Clear dirty flags
	    dirty = false
	    for(var i=0; i<numObjs; ++i) {
	      objects[i].dirty = false
	    }
	  }
	
	  //Draw the whole scene
	  function render() {
	    if(scene._stopped || scene.contextLost) {
	      return
	    }
	    // this order is important: ios safari sometimes has sync raf
	    redraw()
	    requestAnimationFrame(render)
	  }
	
	  scene.enableMouseListeners()
	  render()
	
	  //Force redraw of whole scene
	  scene.redraw = function() {
	    if(scene._stopped) {
	      return
	    }
	    dirty = true
	    redraw()
	  }
	
	  return scene
	}
	
	},{"./camera.js":290,"./lib/shader":291,"a-big-triangle":61,"gl-axes3d":235,"gl-axes3d/properties":242,"gl-fbo":251,"gl-mat4/ortho":270,"gl-mat4/perspective":271,"gl-select-static":302,"gl-spikes3d":312,"is-mobile":421,"mouse-change":436}],293:[function(_dereq_,module,exports){
	var glslify = _dereq_('glslify')
	
	exports.pointVertex       = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"])
	exports.pointFragment     = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"])
	exports.pickVertex        = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"])
	exports.pickFragment      = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"])
	
	},{"glslify":410}],294:[function(_dereq_,module,exports){
	'use strict'
	
	var createShader = _dereq_('gl-shader')
	var createBuffer = _dereq_('gl-buffer')
	
	var pool = _dereq_('typedarray-pool')
	
	var SHADERS = _dereq_('./lib/shader')
	
	module.exports = createPointcloud2D
	
	function Pointcloud2D(plot, offsetBuffer, pickBuffer, shader, pickShader) {
	  this.plot           = plot
	  this.offsetBuffer   = offsetBuffer
	  this.pickBuffer     = pickBuffer
	  this.shader         = shader
	  this.pickShader     = pickShader
	  this.sizeMin        = 0.5
	  this.sizeMinCap     = 2
	  this.sizeMax        = 20
	  this.areaRatio      = 1.0
	  this.pointCount     = 0
	  this.color          = [1, 0, 0, 1]
	  this.borderColor    = [0, 0, 0, 1]
	  this.blend          = false
	  this.pickOffset     = 0
	  this.points         = null
	}
	
	var proto = Pointcloud2D.prototype
	
	proto.dispose = function() {
	  this.shader.dispose()
	  this.pickShader.dispose()
	  this.offsetBuffer.dispose()
	  this.pickBuffer.dispose()
	  this.plot.removeObject(this)
	}
	
	proto.update = function(options) {
	
	  var i
	
	  options = options || {}
	
	  function dflt(opt, value) {
	    if(opt in options) {
	      return options[opt]
	    }
	    return value
	  }
	
	  this.sizeMin      = dflt('sizeMin', 0.5)
	  // this.sizeMinCap      = dflt('sizeMinCap', 2)
	  this.sizeMax      = dflt('sizeMax', 20)
	  this.color        = dflt('color', [1, 0, 0, 1]).slice()
	  this.areaRatio    = dflt('areaRatio', 1)
	  this.borderColor  = dflt('borderColor', [0, 0, 0, 1]).slice()
	  this.blend        = dflt('blend', false)
	
	  //Update point data
	
	  // Attempt straight-through processing (STP) to avoid allocation and copy
	  // TODO eventually abstract out STP logic, maybe into `pool` or a layer above
	  var pointCount = options.positions.length >>> 1
	  var dataStraightThrough = options.positions instanceof Float32Array
	  var idStraightThrough = options.idToIndex instanceof Int32Array && options.idToIndex.length >= pointCount // permit larger to help reuse
	
	  var data          = options.positions
	  var packed        = dataStraightThrough ? data : pool.mallocFloat32(data.length)
	  var packedId      = idStraightThrough ? options.idToIndex : pool.mallocInt32(pointCount)
	
	  if(!dataStraightThrough) {
	    packed.set(data)
	  }
	
	  if(!idStraightThrough) {
	    packed.set(data)
	    for(i = 0; i < pointCount; i++) {
	      packedId[i] = i
	    }
	  }
	
	  this.points       = data
	
	  this.offsetBuffer.update(packed)
	  this.pickBuffer.update(packedId)
	
	  if(!dataStraightThrough) {
	    pool.free(packed)
	  }
	
	  if(!idStraightThrough) {
	    pool.free(packedId)
	  }
	
	  this.pointCount = pointCount
	  this.pickOffset = 0
	}
	
	function count(points, dataBox) {
	  var visiblePointCountEstimate = 0
	  var length = points.length >>> 1
	  var i
	  for(i = 0; i < length; i++) {
	    var x = points[i * 2]
	    var y = points[i * 2 + 1]
	    if(x >= dataBox[0] && x <= dataBox[2] && y >= dataBox[1] && y <= dataBox[3])
	      visiblePointCountEstimate++
	  }
	  return visiblePointCountEstimate
	}
	
	proto.unifiedDraw = (function() {
	  var MATRIX = [1, 0, 0,
	                0, 1, 0,
	                0, 0, 1]
	  var PICK_VEC4 = [0, 0, 0, 0]
	return function(pickOffset) {
	  var pick = pickOffset !== void(0)
	
	  var shader        = pick ? this.pickShader : this.shader
	  var gl            = this.plot.gl
	  var dataBox       = this.plot.dataBox
	
	  if(this.pointCount === 0) {
	    return pickOffset
	  }
	
	  var dataX   = dataBox[2] - dataBox[0]
	  var dataY   = dataBox[3] - dataBox[1]
	
	  var visiblePointCountEstimate = count(this.points, dataBox)
	  var basicPointSize =  this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(visiblePointCountEstimate, 0.33333)))
	
	  MATRIX[0] = 2.0 / dataX
	  MATRIX[4] = 2.0 / dataY
	  MATRIX[6] = -2.0 * dataBox[0] / dataX - 1.0
	  MATRIX[7] = -2.0 * dataBox[1] / dataY - 1.0
	
	  this.offsetBuffer.bind()
	
	  shader.bind()
	  shader.attributes.position.pointer()
	  shader.uniforms.matrix      = MATRIX
	  shader.uniforms.color       = this.color
	  shader.uniforms.borderColor = this.borderColor
	  shader.uniforms.pointCloud = basicPointSize < 5
	  shader.uniforms.pointSize = basicPointSize
	  shader.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio)))
	
	  if(pick) {
	
	    PICK_VEC4[0] = ( pickOffset        & 0xff)
	    PICK_VEC4[1] = ((pickOffset >> 8)  & 0xff)
	    PICK_VEC4[2] = ((pickOffset >> 16) & 0xff)
	    PICK_VEC4[3] = ((pickOffset >> 24) & 0xff)
	
	    this.pickBuffer.bind()
	    shader.attributes.pickId.pointer(gl.UNSIGNED_BYTE)
	    shader.uniforms.pickOffset = PICK_VEC4
	    this.pickOffset = pickOffset
	  }
	
	  // Worth switching these off, but we can't make assumptions about other
	  // renderers, so let's restore it after each draw
	  var blend = gl.getParameter(gl.BLEND)
	  var dither = gl.getParameter(gl.DITHER)
	
	  if(blend && !this.blend)
	    gl.disable(gl.BLEND)
	  if(dither)
	    gl.disable(gl.DITHER)
	
	  gl.drawArrays(gl.POINTS, 0, this.pointCount)
	
	  if(blend && !this.blend)
	    gl.enable(gl.BLEND)
	  if(dither)
	    gl.enable(gl.DITHER)
	
	  return pickOffset + this.pointCount
	}
	})()
	
	proto.draw = proto.unifiedDraw
	proto.drawPick = proto.unifiedDraw
	
	proto.pick = function(x, y, value) {
	  var pickOffset = this.pickOffset
	  var pointCount = this.pointCount
	  if(value < pickOffset || value >= pickOffset + pointCount) {
	    return null
	  }
	  var pointId = value - pickOffset
	  var points = this.points
	  return {
	    object: this,
	    pointId: pointId,
	    dataCoord: [points[2 * pointId], points[2 * pointId + 1] ]
	  }
	}
	
	function createPointcloud2D(plot, options) {
	  var gl = plot.gl
	  var buffer = createBuffer(gl)
	  var pickBuffer = createBuffer(gl)
	  var shader = createShader(gl, SHADERS.pointVertex, SHADERS.pointFragment)
	  var pickShader = createShader(gl, SHADERS.pickVertex, SHADERS.pickFragment)
	
	  var result = new Pointcloud2D(plot, buffer, pickBuffer, shader, pickShader)
	  result.update(options)
	
	  //Register with plot
	  plot.addObject(result)
	
	  return result
	}
	
	},{"./lib/shader":293,"gl-buffer":243,"gl-shader":303,"typedarray-pool":543}],295:[function(_dereq_,module,exports){
	module.exports = slerp
	
	/**
	 * Performs a spherical linear interpolation between two quat
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {quat} out
	 */
	function slerp (out, a, b, t) {
	  // benchmarks:
	  //    http://jsperf.com/quaternion-slerp-implementations
	
	  var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	    bx = b[0], by = b[1], bz = b[2], bw = b[3]
	
	  var omega, cosom, sinom, scale0, scale1
	
	  // calc cosine
	  cosom = ax * bx + ay * by + az * bz + aw * bw
	  // adjust signs (if necessary)
	  if (cosom < 0.0) {
	    cosom = -cosom
	    bx = -bx
	    by = -by
	    bz = -bz
	    bw = -bw
	  }
	  // calculate coefficients
	  if ((1.0 - cosom) > 0.000001) {
	    // standard case (slerp)
	    omega = Math.acos(cosom)
	    sinom = Math.sin(omega)
	    scale0 = Math.sin((1.0 - t) * omega) / sinom
	    scale1 = Math.sin(t * omega) / sinom
	  } else {
	    // "from" and "to" quaternions are very close
	    //  ... so we can do a linear interpolation
	    scale0 = 1.0 - t
	    scale1 = t
	  }
	  // calculate final values
	  out[0] = scale0 * ax + scale1 * bx
	  out[1] = scale0 * ay + scale1 * by
	  out[2] = scale0 * az + scale1 * bz
	  out[3] = scale0 * aw + scale1 * bw
	
	  return out
	}
	
	},{}],296:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = function(a){
	  return (!a && a !== 0) ? '' : a.toString();
	}
	
	},{}],297:[function(_dereq_,module,exports){
	"use strict"
	
	var vectorizeText = _dereq_("vectorize-text")
	
	module.exports = getGlyph
	
	var GLYPH_CACHE = {}
	
	function getGlyph(symbol, font, pixelRatio) {
	  var fontCache = GLYPH_CACHE[font]
	  if(!fontCache) {
	    fontCache = GLYPH_CACHE[font] = {}
	  }
	  if(symbol in fontCache) {
	    return fontCache[symbol]
	  }
	
	  var config = {
	    textAlign: "center",
	    textBaseline: "middle",
	    lineHeight: 1.0,
	    font: font,
	    lineSpacing: 1.25,
	    styletags: {
	      breaklines:true,
	      bolds: true,
	      italics: true,
	      subscripts:true,
	      superscripts:true
	    }
	  }
	
	  //Get line and triangle meshes for glyph
	  config.triangles = true
	  var triSymbol = vectorizeText(symbol, config)
	  config.triangles = false
	  var lineSymbol = vectorizeText(symbol, config)
	
	  var i, j
	
	  if(pixelRatio && pixelRatio !== 1) {
	    for(i = 0; i < triSymbol.positions.length; ++i){
	      for(j = 0; j < triSymbol.positions[i].length; ++j){
	        triSymbol.positions[i][j] /= pixelRatio;
	      }
	    }
	
	    for(i = 0; i < lineSymbol.positions.length; ++i){
	      for(j = 0; j < lineSymbol.positions[i].length; ++j){
	        lineSymbol.positions[i][j] /= pixelRatio;
	      }
	    }
	  }
	
	  //Calculate bounding box
	  var bounds = [[Infinity,Infinity], [-Infinity,-Infinity]]
	  var n = lineSymbol.positions.length
	  for(i = 0; i < n; ++i) {
	    var p = lineSymbol.positions[i]
	    for(j=0; j<2; ++j) {
	      bounds[0][j] = Math.min(bounds[0][j], p[j])
	      bounds[1][j] = Math.max(bounds[1][j], p[j])
	    }
	  }
	
	  //Save cached symbol
	  return fontCache[symbol] = [triSymbol, lineSymbol, bounds]
	}
	},{"vectorize-text":548}],298:[function(_dereq_,module,exports){
	var createShaderWrapper = _dereq_('gl-shader')
	var glslify = _dereq_('glslify')
	
	var perspectiveVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"])
	var orthographicVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"])
	var projectionVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"])
	var drawFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"])
	var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"])
	
	var ATTRIBUTES = [
	  {name: 'position', type: 'vec3'},
	  {name: 'color', type: 'vec4'},
	  {name: 'glyph', type: 'vec2'},
	  {name: 'id', type: 'vec4'}
	]
	
	var perspective = {
	    vertex: perspectiveVertSrc,
	    fragment: drawFragSrc,
	    attributes: ATTRIBUTES
	  },
	  ortho = {
	    vertex: orthographicVertSrc,
	    fragment: drawFragSrc,
	    attributes: ATTRIBUTES
	  },
	  project = {
	    vertex: projectionVertSrc,
	    fragment: drawFragSrc,
	    attributes: ATTRIBUTES
	  },
	  pickPerspective = {
	    vertex: perspectiveVertSrc,
	    fragment: pickFragSrc,
	    attributes: ATTRIBUTES
	  },
	  pickOrtho = {
	    vertex: orthographicVertSrc,
	    fragment: pickFragSrc,
	    attributes: ATTRIBUTES
	  },
	  pickProject = {
	    vertex: projectionVertSrc,
	    fragment: pickFragSrc,
	    attributes: ATTRIBUTES
	  }
	
	function createShader(gl, src) {
	  var shader = createShaderWrapper(gl, src)
	  var attr = shader.attributes
	  attr.position.location = 0
	  attr.color.location = 1
	  attr.glyph.location = 2
	  attr.id.location = 3
	  return shader
	}
	
	exports.createPerspective = function(gl) {
	  return createShader(gl, perspective)
	}
	exports.createOrtho = function(gl) {
	  return createShader(gl, ortho)
	}
	exports.createProject = function(gl) {
	  return createShader(gl, project)
	}
	exports.createPickPerspective = function(gl) {
	  return createShader(gl, pickPerspective)
	}
	exports.createPickOrtho = function(gl) {
	  return createShader(gl, pickOrtho)
	}
	exports.createPickProject = function(gl) {
	  return createShader(gl, pickProject)
	}
	
	},{"gl-shader":303,"glslify":410}],299:[function(_dereq_,module,exports){
	'use strict'
	
	var isAllBlank      = _dereq_('is-string-blank')
	var createBuffer    = _dereq_('gl-buffer')
	var createVAO       = _dereq_('gl-vao')
	var pool            = _dereq_('typedarray-pool')
	var mat4mult        = _dereq_('gl-mat4/multiply')
	var shaders         = _dereq_('./lib/shaders')
	var getGlyph        = _dereq_('./lib/glyphs')
	var getSimpleString = _dereq_('./lib/get-simple-string')
	
	var IDENTITY = [1,0,0,0,
	                0,1,0,0,
	                0,0,1,0,
	                0,0,0,1]
	
	module.exports = createPointCloud
	
	function transformMat4(x, m) {
	  var x0 = x[0]
	  var x1 = x[1]
	  var x2 = x[2]
	  var x3 = x[3]
	  x[0] = m[0] * x0 + m[4] * x1 + m[8]  * x2 + m[12] * x3
	  x[1] = m[1] * x0 + m[5] * x1 + m[9]  * x2 + m[13] * x3
	  x[2] = m[2] * x0 + m[6] * x1 + m[10] * x2 + m[14] * x3
	  x[3] = m[3] * x0 + m[7] * x1 + m[11] * x2 + m[15] * x3
	  return x
	}
	
	function project(p, v, m, x) {
	  transformMat4(x, x, m)
	  transformMat4(x, x, v)
	  return transformMat4(x, x, p)
	}
	
	function ScatterPlotPickResult(index, position) {
	  this.index = index
	  this.dataCoordinate = this.position = position
	}
	
	function fixOpacity(a) {
	  if(a === true) return 1
	  if(a > 1) return 1
	  return a
	}
	
	function PointCloud(
	  gl,
	  shader,
	  orthoShader,
	  projectShader,
	  pointBuffer,
	  colorBuffer,
	  glyphBuffer,
	  idBuffer,
	  vao,
	  pickPerspectiveShader,
	  pickOrthoShader,
	  pickProjectShader) {
	
	  this.gl              = gl
	
	  this.pixelRatio      = 1
	
	  this.shader          = shader
	  this.orthoShader     = orthoShader
	  this.projectShader   = projectShader
	
	  this.pointBuffer     = pointBuffer
	  this.colorBuffer     = colorBuffer
	  this.glyphBuffer     = glyphBuffer
	  this.idBuffer        = idBuffer
	  this.vao             = vao
	  this.vertexCount     = 0
	  this.lineVertexCount = 0
	
	  this.opacity         = 1
	  this.hasAlpha        = false
	
	  this.lineWidth       = 0
	  this.projectScale    = [2.0/3.0, 2.0/3.0, 2.0/3.0]
	  this.projectOpacity  = [1, 1, 1]
	  this.projectHasAlpha  = false
	
	  this.pickId                = 0
	  this.pickPerspectiveShader = pickPerspectiveShader
	  this.pickOrthoShader       = pickOrthoShader
	  this.pickProjectShader     = pickProjectShader
	  this.points                = []
	
	  this._selectResult = new ScatterPlotPickResult(0, [0,0,0])
	
	  this.useOrtho = true
	  this.bounds   = [[ Infinity,Infinity,Infinity],
	                   [-Infinity,-Infinity,-Infinity]]
	
	  //Axes projections
	  this.axesProject = [ true, true, true ]
	  this.axesBounds = [[-Infinity,-Infinity,-Infinity],
	                     [ Infinity, Infinity, Infinity]]
	
	  this.highlightId    = [1,1,1,1]
	  this.highlightScale = 2
	
	  this.clipBounds = [[-Infinity,-Infinity,-Infinity],
	                     [ Infinity, Infinity, Infinity]]
	
	  this.dirty = true
	}
	
	var proto = PointCloud.prototype
	
	proto.pickSlots = 1
	
	proto.setPickBase = function(pickBase) {
	  this.pickId = pickBase
	}
	
	proto.isTransparent = function() {
	  if(this.hasAlpha)  {
	    return true
	  }
	  for(var i=0; i<3; ++i) {
	    if(this.axesProject[i] && this.projectHasAlpha) {
	      return true
	    }
	  }
	  return false
	}
	
	proto.isOpaque = function() {
	  if(!this.hasAlpha)  {
	    return true
	  }
	  for(var i=0; i<3; ++i) {
	    if(this.axesProject[i] && !this.projectHasAlpha) {
	      return true
	    }
	  }
	  return false
	}
	
	var VIEW_SHAPE = [0,0]
	var U_VEC = [0,0,0]
	var V_VEC = [0,0,0]
	var MU_VEC = [0,0,0,1]
	var MV_VEC = [0,0,0,1]
	var SCRATCH_MATRIX = IDENTITY.slice()
	var SCRATCH_VEC = [0,0,0]
	var CLIP_BOUNDS = [[0,0,0], [0,0,0]]
	
	function zeroVec(a) {
	  a[0] = a[1] = a[2] = 0
	  return a
	}
	
	function augment(hg, af) {
	  hg[0] = af[0]
	  hg[1] = af[1]
	  hg[2] = af[2]
	  hg[3] = 1
	  return hg
	}
	
	function setComponent(out, v, i, x) {
	  out[0] = v[0]
	  out[1] = v[1]
	  out[2] = v[2]
	  out[i] = x
	  return out
	}
	
	function getClipBounds(bounds) {
	  var result = CLIP_BOUNDS
	  for(var i=0; i<2; ++i) {
	    for(var j=0; j<3; ++j) {
	      result[i][j] = Math.max(Math.min(bounds[i][j], 1e8), -1e8)
	    }
	  }
	  return result
	}
	
	function drawProject(shader, points, camera, pixelRatio) {
	  var axesProject = points.axesProject
	
	  var gl         = points.gl
	  var uniforms   = shader.uniforms
	  var model      = camera.model      || IDENTITY
	  var view       = camera.view       || IDENTITY
	  var projection = camera.projection || IDENTITY
	  var bounds     = points.axesBounds
	  var clipBounds = getClipBounds(points.clipBounds)
	
	  var cubeAxis
	  if(points.axes && points.axes.lastCubeProps) {
	    cubeAxis = points.axes.lastCubeProps.axis
	  } else {
	    cubeAxis = [1,1,1]
	  }
	
	  VIEW_SHAPE[0] = 2.0/gl.drawingBufferWidth
	  VIEW_SHAPE[1] = 2.0/gl.drawingBufferHeight
	
	  shader.bind()
	  uniforms.view           = view
	  uniforms.projection     = projection
	  uniforms.screenSize     = VIEW_SHAPE
	  uniforms.highlightId    = points.highlightId
	  uniforms.highlightScale = points.highlightScale
	  uniforms.clipBounds     = clipBounds
	  uniforms.pickGroup      = points.pickId / 255.0
	  uniforms.pixelRatio     = pixelRatio
	
	  for(var i=0; i<3; ++i) {
	    if(!axesProject[i]) {
	      continue
	    }
	
	    uniforms.scale          = points.projectScale[i]
	    uniforms.opacity        = points.projectOpacity[i]
	
	    //Project model matrix
	    var pmodel = SCRATCH_MATRIX
	    for(var j=0; j<16; ++j) {
	      pmodel[j] = 0
	    }
	    for(var j=0; j<4; ++j) {
	      pmodel[5*j] = 1
	    }
	    pmodel[5*i] = 0
	    if(cubeAxis[i] < 0) {
	      pmodel[12+i] = bounds[0][i]
	    } else {
	      pmodel[12+i] = bounds[1][i]
	    }
	    mat4mult(pmodel, model, pmodel)
	    uniforms.model = pmodel
	
	    //Compute initial axes
	    var u = (i+1)%3
	    var v = (i+2)%3
	    var du = zeroVec(U_VEC)
	    var dv = zeroVec(V_VEC)
	    du[u] = 1
	    dv[v] = 1
	
	    //Align orientation relative to viewer
	    var mdu = project(projection, view, model, augment(MU_VEC, du))
	    var mdv = project(projection, view, model, augment(MV_VEC, dv))
	    if(Math.abs(mdu[1]) > Math.abs(mdv[1])) {
	      var tmp = mdu
	      mdu = mdv
	      mdv = tmp
	      tmp = du
	      du = dv
	      dv = tmp
	      var t = u
	      u = v
	      v = t
	    }
	    if(mdu[0] < 0) {
	      du[u] = -1
	    }
	    if(mdv[1] > 0) {
	      dv[v] = -1
	    }
	    var su = 0.0
	    var sv = 0.0
	    for(var j=0; j<4; ++j) {
	      su += Math.pow(model[4*u+j], 2)
	      sv += Math.pow(model[4*v+j], 2)
	    }
	    du[u] /= Math.sqrt(su)
	    dv[v] /= Math.sqrt(sv)
	    uniforms.axes[0] = du
	    uniforms.axes[1] = dv
	
	    //Update fragment clip bounds
	    uniforms.fragClipBounds[0] = setComponent(SCRATCH_VEC, clipBounds[0], i, -1e8)
	    uniforms.fragClipBounds[1] = setComponent(SCRATCH_VEC, clipBounds[1], i, 1e8)
	
	    points.vao.bind()
	
	    //Draw interior
	    points.vao.draw(gl.TRIANGLES, points.vertexCount)
	
	    //Draw edges
	    if(points.lineWidth > 0) {
	      gl.lineWidth(points.lineWidth * pixelRatio)
	      points.vao.draw(gl.LINES, points.lineVertexCount, points.vertexCount)
	    }
	
	    points.vao.unbind()
	  }
	}
	
	
	var NEG_INFINITY3 = [-1e8, -1e8, -1e8]
	var POS_INFINITY3 = [1e8, 1e8, 1e8]
	var CLIP_GROUP    = [NEG_INFINITY3, POS_INFINITY3]
	
	function drawFull(shader, pshader, points, camera, pixelRatio, transparent, forceDraw) {
	  var gl = points.gl
	
	  if(transparent === points.projectHasAlpha || forceDraw) {
	    drawProject(pshader, points, camera, pixelRatio)
	  }
	
	  if(transparent === points.hasAlpha || forceDraw) {
	
	    shader.bind()
	    var uniforms = shader.uniforms
	
	    uniforms.model      = camera.model      || IDENTITY
	    uniforms.view       = camera.view       || IDENTITY
	    uniforms.projection = camera.projection || IDENTITY
	
	    VIEW_SHAPE[0]       = 2.0/gl.drawingBufferWidth
	    VIEW_SHAPE[1]       = 2.0/gl.drawingBufferHeight
	    uniforms.screenSize = VIEW_SHAPE
	
	    uniforms.highlightId    = points.highlightId
	    uniforms.highlightScale = points.highlightScale
	
	    uniforms.fragClipBounds = CLIP_GROUP
	    uniforms.clipBounds     = points.axes.bounds
	
	    uniforms.opacity    = points.opacity
	    uniforms.pickGroup  = points.pickId / 255.0
	
	    uniforms.pixelRatio = pixelRatio
	
	    points.vao.bind()
	
	    //Draw interior
	    points.vao.draw(gl.TRIANGLES, points.vertexCount)
	
	    //Draw edges
	    if(points.lineWidth > 0) {
	      gl.lineWidth(points.lineWidth * pixelRatio)
	      points.vao.draw(gl.LINES, points.lineVertexCount, points.vertexCount)
	    }
	
	    points.vao.unbind()
	  }
	
	
	}
	
	proto.draw = function(camera) {
	  var shader = this.useOrtho ? this.orthoShader : this.shader
	  drawFull(shader, this.projectShader, this, camera, this.pixelRatio, false, false)
	}
	
	proto.drawTransparent = function(camera) {
	  var shader = this.useOrtho ? this.orthoShader : this.shader
	  drawFull(shader, this.projectShader, this, camera, this.pixelRatio, true, false)
	}
	
	proto.drawPick = function(camera) {
	  var shader = this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader
	  drawFull(shader, this.pickProjectShader, this, camera, 1, true, true)
	}
	
	proto.pick = function(selected) {
	  if(!selected) {
	    return null
	  }
	  if(selected.id !== this.pickId) {
	    return null
	  }
	  var x = selected.value[2] + (selected.value[1]<<8) + (selected.value[0]<<16)
	  if(x >= this.pointCount || x < 0) {
	    return null
	  }
	
	  //Unpack result
	  var coord = this.points[x]
	  var result = this._selectResult
	  result.index = x
	  for(var i=0; i<3; ++i) {
	    result.position[i] = result.dataCoordinate[i] = coord[i]
	  }
	  return result
	}
	
	proto.highlight = function(selection) {
	  if(!selection) {
	    this.highlightId = [1,1,1,1]
	  } else {
	    var pointId = selection.index
	    var a0 =  pointId     &0xff
	    var a1 = (pointId>>8) &0xff
	    var a2 = (pointId>>16)&0xff
	    this.highlightId = [a0/255.0, a1/255.0, a2/255.0, 0]
	  }
	}
	
	function get_glyphData(glyphs, index, font, pixelRatio) {
	  var str
	
	  // use the data if presented in an array
	  if(Array.isArray(glyphs)) {
	    if(index < glyphs.length) {
	      str = glyphs[index]
	    } else {
	      str = undefined
	    }
	  } else {
	    str = glyphs
	  }
	
	  str = getSimpleString(str) // this would handle undefined cases
	
	  var visible = true
	  if(isAllBlank(str)) {
	    str = '▼' // Note: this special character may have minimum number of surfaces
	    visible = false
	  }
	
	  var glyph = getGlyph(str, font, pixelRatio)
	
	  return { mesh:glyph[0],
	          lines:glyph[1],
	         bounds:glyph[2],
	        visible:visible };
	}
	
	
	
	proto.update = function(options) {
	
	  options = options || {}
	
	  if('perspective' in options) {
	    this.useOrtho = !options.perspective
	  }
	  if('orthographic' in options) {
	    this.useOrtho = !!options.orthographic
	  }
	  if('lineWidth' in options) {
	    this.lineWidth = options.lineWidth
	  }
	  if('project' in options) {
	    if(Array.isArray(options.project)) {
	      this.axesProject = options.project
	    } else {
	      var v = !!options.project
	      this.axesProject = [v,v,v]
	    }
	  }
	  if('projectScale' in options) {
	    if(Array.isArray(options.projectScale)) {
	      this.projectScale = options.projectScale.slice()
	    } else {
	      var s = +options.projectScale
	      this.projectScale = [s,s,s]
	    }
	  }
	
	  this.projectHasAlpha = false // default to no transparent draw
	  if('projectOpacity' in options) {
	    if(Array.isArray(options.projectOpacity)) {
	      this.projectOpacity = options.projectOpacity.slice()
	    } else {
	      var s = +options.projectOpacity
	      this.projectOpacity = [s,s,s]
	    }
	    for(var i=0; i<3; ++i) {
	      this.projectOpacity[i] = fixOpacity(this.projectOpacity[i]);
	      if(this.projectOpacity[i] < 1) {
	        this.projectHasAlpha = true;
	      }
	    }
	  }
	
	  this.hasAlpha = false // default to no transparent draw
	  if('opacity' in options) {
	    this.opacity = fixOpacity(options.opacity)
	    if(this.opacity < 1) {
	      this.hasAlpha = true;
	    }
	  }
	
	  //Set dirty flag
	  this.dirty = true
	
	  //Create new buffers
	  var points = options.position
	
	  //Text font
	  var font      = options.font      || 'normal'
	  var alignment = options.alignment || [0,0]
	
	  var alignmentX;
	  var alignmentY;
	  if (alignment.length === 2) {
	    alignmentX = alignment[0]
	    alignmentY = alignment[1]
	  } else {
	    alignmentX = []
	    alignmentY = []
	    for (var i = 0; i < alignment.length; ++i) {
	      alignmentX[i] = alignment[i][0]
	      alignmentY[i] = alignment[i][1]
	    }
	  }
	
	  //Bounds
	  var lowerBound = [ Infinity, Infinity, Infinity]
	  var upperBound = [-Infinity,-Infinity,-Infinity]
	
	  //Unpack options
	  var glyphs     = options.glyph
	  var colors     = options.color
	  var sizes      = options.size
	  var angles     = options.angle
	  var lineColors = options.lineColor
	
	  //Picking geometry
	  var pickCounter = -1
	
	  //First do pass to compute buffer sizes
	  var triVertexCount  = 0
	  var lineVertexCount = 0
	
	  var numPoints = 0;
	
	  if(points.length) {
	
	    //Count number of points and buffer size
	    numPoints = points.length
	
	  count_loop:
	    for(var i=0; i<numPoints; ++i) {
	      var x = points[i]
	      for(var j=0; j<3; ++j) {
	        if(isNaN(x[j]) || !isFinite(x[j])) {
	          continue count_loop
	        }
	      }
	
	      var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio)
	
	      var glyphMesh   = glyphData.mesh
	      var glyphLines  = glyphData.lines
	      var glyphBounds = glyphData.bounds
	
	      triVertexCount  += glyphMesh.cells.length * 3
	      lineVertexCount += glyphLines.edges.length * 2
	    }
	  }
	
	  var vertexCount   = triVertexCount + lineVertexCount
	
	  //Preallocate data
	  var positionArray = pool.mallocFloat(3*vertexCount)
	  var colorArray    = pool.mallocFloat(4*vertexCount)
	  var glyphArray    = pool.mallocFloat(2*vertexCount)
	  var idArray       = pool.mallocUint32(vertexCount)
	
	  if(vertexCount > 0) {
	    var triOffset  = 0
	    var lineOffset = triVertexCount
	    var color      = [0,0,0,1]
	    var lineColor  = [0,0,0,1]
	
	    var isColorArray      = Array.isArray(colors)     && Array.isArray(colors[0])
	    var isLineColorArray  = Array.isArray(lineColors) && Array.isArray(lineColors[0])
	
	  fill_loop:
	    for(var i=0; i<numPoints; ++i) {
	      //Increment pickCounter
	      pickCounter += 1
	
	      var x = points[i]
	      for(var j=0; j<3; ++j) {
	        if(isNaN(x[j]) || !isFinite(x[j])) {
	          continue fill_loop
	        }
	
	        upperBound[j] = Math.max(upperBound[j], x[j])
	        lowerBound[j] = Math.min(lowerBound[j], x[j])
	      }
	
	      var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio)
	
	      var glyphMesh   = glyphData.mesh
	      var glyphLines  = glyphData.lines
	      var glyphBounds = glyphData.bounds
	      var glyphVisible = glyphData.visible
	
	      //Get color
	      if(!glyphVisible) color = [1,1,1,0]
	      else if(Array.isArray(colors)) {
	        var c
	        if(isColorArray) {
	          if(i < colors.length) {
	            c = colors[i]
	          } else {
	            c = [0,0,0,0]
	          }
	        } else {
	          c = colors
	        }
	
	        if(c.length === 3) {
	          for(var j=0; j<3; ++j) {
	            color[j] = c[j]
	          }
	          color[3] = 1
	        } else if(c.length === 4) {
	          for(var j=0; j<4; ++j) {
	            color[j] = c[j]
	          }
	          if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
	        }
	      } else {
	        color[0] = color[1] = color[2] = 0
	        color[3] = 1
	      }
	
	
	      //Get lineColor
	      if(!glyphVisible) lineColor = [1,1,1,0]
	      else if(Array.isArray(lineColors)) {
	        var c
	        if(isLineColorArray) {
	          if(i < lineColors.length) {
	            c = lineColors[i]
	          } else {
	            c = [0,0,0,0]
	          }
	        } else {
	          c = lineColors
	        }
	
	        if(c.length === 3) {
	          for(var j=0; j<3; ++j) {
	            lineColor[j] = c[j]
	          }
	          lineColor[j] = 1
	        } else if(c.length === 4) {
	          for(var j=0; j<4; ++j) {
	            lineColor[j] = c[j]
	          }
	          if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
	        }
	      } else {
	        lineColor[0] = lineColor[1] = lineColor[2] = 0
	        lineColor[3] = 1
	      }
	
	
	      var size = 0.5
	      if(!glyphVisible) size = 0.0
	      else if(Array.isArray(sizes)) {
	        if(i < sizes.length) {
	          size = +sizes[i]
	        } else {
	          size = 12
	        }
	      } else if(sizes) {
	        size = +sizes
	      } else if(this.useOrtho) {
	        size = 12
	      }
	
	
	      var angle = 0
	      if(Array.isArray(angles)) {
	        if(i < angles.length) {
	          angle = +angles[i]
	        } else {
	          angle = 0
	        }
	      } else if(angles) {
	        angle = +angles
	      }
	
	      //Loop through markers and append to buffers
	      var cos = Math.cos(angle)
	      var sin = Math.sin(angle)
	
	      var x = points[i]
	      for(var j=0; j<3; ++j) {
	        upperBound[j] = Math.max(upperBound[j], x[j])
	        lowerBound[j] = Math.min(lowerBound[j], x[j])
	      }
	
	      //Calculate text offset
	      var textOffsetX = alignmentX
	      var textOffsetY = alignmentY
	
	      var textOffsetX = 0
	      if(Array.isArray(alignmentX)) {
	        if(i < alignmentX.length) {
	          textOffsetX = alignmentX[i]
	        } else {
	          textOffsetX = 0
	        }
	      } else if(alignmentX) {
	        textOffsetX = alignmentX
	      }
	
	      var textOffsetY = 0
	      if(Array.isArray(alignmentY)) {
	        if(i < alignmentY.length) {
	          textOffsetY = alignmentY[i]
	        } else {
	          textOffsetY = 0
	        }
	      } else if(alignmentY) {
	        textOffsetY = alignmentY
	      }
	
	      textOffsetX *= (textOffsetX > 0) ? (1 - glyphBounds[0][0]) :
	                     (textOffsetX < 0) ? (1 + glyphBounds[1][0]) : 1;
	
	      textOffsetY *= (textOffsetY > 0) ? (1 - glyphBounds[0][1]) :
	                     (textOffsetY < 0) ? (1 + glyphBounds[1][1]) : 1;
	
	      var textOffset = [textOffsetX, textOffsetY]
	
	      //Write out inner marker
	      var cells = glyphMesh.cells || []
	      var verts = glyphMesh.positions || []
	
	      for(var j=0; j<cells.length; ++j) {
	        var cell = cells[j]
	        for(var k=0; k<3; ++k) {
	          for(var l=0; l<3; ++l) {
	            positionArray[3*triOffset+l] = x[l]
	          }
	          for(var l=0; l<4; ++l) {
	            colorArray[4*triOffset+l] = color[l]
	          }
	          idArray[triOffset] = pickCounter
	          var p = verts[cell[k]]
	          glyphArray[2*triOffset]   = size * (cos*p[0] - sin*p[1] + textOffset[0])
	          glyphArray[2*triOffset+1] = size * (sin*p[0] + cos*p[1] + textOffset[1])
	          triOffset += 1
	        }
	      }
	
	      var cells = glyphLines.edges
	      var verts = glyphLines.positions
	
	      for(var j=0; j<cells.length; ++j) {
	        var cell = cells[j]
	        for(var k=0; k<2; ++k) {
	          for(var l=0; l<3; ++l) {
	            positionArray[3*lineOffset+l] = x[l]
	          }
	          for(var l=0; l<4; ++l) {
	            colorArray[4*lineOffset+l] = lineColor[l]
	          }
	          idArray[lineOffset] = pickCounter
	          var p = verts[cell[k]]
	          glyphArray[2*lineOffset]   = size * (cos*p[0] - sin*p[1] + textOffset[0])
	          glyphArray[2*lineOffset+1] = size * (sin*p[0] + cos*p[1] + textOffset[1])
	          lineOffset += 1
	        }
	      }
	
	    }
	
	
	
	  }
	
	  //Update bounds
	  this.bounds = [lowerBound, upperBound]
	
	  //Save points
	  this.points = points
	
	  //Save number of points
	  this.pointCount = points.length
	
	  //Update vertex counts
	  this.vertexCount      = triVertexCount
	  this.lineVertexCount  = lineVertexCount
	
	  this.pointBuffer.update(positionArray)
	  this.colorBuffer.update(colorArray)
	  this.glyphBuffer.update(glyphArray)
	  //this.idBuffer.update(new Uint32Array(idArray))
	  this.idBuffer.update(idArray)
	
	  pool.free(positionArray)
	  pool.free(colorArray)
	  pool.free(glyphArray)
	  pool.free(idArray)
	}
	
	proto.dispose = function() {
	  //Shaders
	  this.shader.dispose()
	  this.orthoShader.dispose()
	  this.pickPerspectiveShader.dispose()
	  this.pickOrthoShader.dispose()
	
	  //Vertex array
	  this.vao.dispose()
	
	  //Buffers
	  this.pointBuffer.dispose()
	  this.colorBuffer.dispose()
	  this.glyphBuffer.dispose()
	  this.idBuffer.dispose()
	}
	
	function createPointCloud(options) {
	  var gl = options.gl
	
	  var shader                = shaders.createPerspective(gl)
	  var orthoShader           = shaders.createOrtho(gl)
	  var projectShader         = shaders.createProject(gl)
	  var pickPerspectiveShader = shaders.createPickPerspective(gl)
	  var pickOrthoShader       = shaders.createPickOrtho(gl)
	  var pickProjectShader     = shaders.createPickProject(gl)
	
	  var pointBuffer = createBuffer(gl)
	  var colorBuffer = createBuffer(gl)
	  var glyphBuffer = createBuffer(gl)
	  var idBuffer    = createBuffer(gl)
	  var vao = createVAO(gl, [
	    {
	      buffer: pointBuffer,
	      size: 3,
	      type: gl.FLOAT
	    },
	    {
	      buffer: colorBuffer,
	      size: 4,
	      type: gl.FLOAT
	    },
	    {
	      buffer: glyphBuffer,
	      size: 2,
	      type: gl.FLOAT
	    },
	    {
	      buffer: idBuffer,
	      size: 4,
	      type: gl.UNSIGNED_BYTE,
	      normalized: true
	    }
	  ])
	
	  var pointCloud = new PointCloud(
	    gl,
	    shader,
	    orthoShader,
	    projectShader,
	    pointBuffer,
	    colorBuffer,
	    glyphBuffer,
	    idBuffer,
	    vao,
	    pickPerspectiveShader,
	    pickOrthoShader,
	    pickProjectShader)
	
	  pointCloud.update(options)
	
	  return pointCloud
	}
	
	},{"./lib/get-simple-string":296,"./lib/glyphs":297,"./lib/shaders":298,"gl-buffer":243,"gl-mat4/multiply":269,"gl-vao":328,"is-string-blank":424,"typedarray-pool":543}],300:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify = _dereq_('glslify')
	
	exports.boxVertex = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"])
	exports.boxFragment = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"])
	
	},{"glslify":410}],301:[function(_dereq_,module,exports){
	'use strict'
	
	var createShader = _dereq_('gl-shader')
	var createBuffer = _dereq_('gl-buffer')
	
	var SHADERS = _dereq_('./lib/shaders')
	
	module.exports = createSelectBox
	
	function SelectBox(plot, boxBuffer, boxShader) {
	  this.plot = plot
	  this.boxBuffer = boxBuffer
	  this.boxShader = boxShader
	
	  this.enabled = true
	
	  this.selectBox = [Infinity,Infinity,-Infinity,-Infinity]
	
	  this.borderColor = [0,0,0,1]
	  this.innerFill   = false
	  this.innerColor  = [0,0,0,0.25]
	  this.outerFill   = true
	  this.outerColor  = [0,0,0,0.5]
	  this.borderWidth = 10
	}
	
	var proto = SelectBox.prototype
	
	proto.draw = function() {
	  if(!this.enabled) {
	    return
	  }
	
	  var plot         = this.plot
	  var selectBox    = this.selectBox
	  var lineWidth    = this.borderWidth
	
	  var innerFill    = this.innerFill
	  var innerColor   = this.innerColor
	  var outerFill    = this.outerFill
	  var outerColor   = this.outerColor
	  var borderColor  = this.borderColor
	
	  var boxes        = plot.box
	  var screenBox    = plot.screenBox
	  var dataBox      = plot.dataBox
	  var viewBox      = plot.viewBox
	  var pixelRatio   = plot.pixelRatio
	
	  //Map select box into pixel coordinates
	  var loX = (selectBox[0]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0]
	  var loY = (selectBox[1]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1]
	  var hiX = (selectBox[2]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0]
	  var hiY = (selectBox[3]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1]
	
	  loX = Math.max(loX, viewBox[0])
	  loY = Math.max(loY, viewBox[1])
	  hiX = Math.min(hiX, viewBox[2])
	  hiY = Math.min(hiY, viewBox[3])
	
	  if(hiX < loX || hiY < loY) {
	    return
	  }
	
	  boxes.bind()
	
	  //Draw box
	  var screenWidth  = screenBox[2] - screenBox[0]
	  var screenHeight = screenBox[3] - screenBox[1]
	
	  if(this.outerFill) {
	    boxes.drawBox(0, 0, screenWidth, loY, outerColor)
	    boxes.drawBox(0, loY, loX, hiY, outerColor)
	    boxes.drawBox(0, hiY, screenWidth, screenHeight, outerColor)
	    boxes.drawBox(hiX, loY, screenWidth, hiY, outerColor)
	  }
	
	  if(this.innerFill) {
	    boxes.drawBox(loX, loY, hiX, hiY, innerColor)
	  }
	
	  //Draw border
	  if(lineWidth > 0) {
	
	    //Draw border
	    var w = lineWidth * pixelRatio
	    boxes.drawBox(loX-w, loY-w, hiX+w, loY+w, borderColor)
	    boxes.drawBox(loX-w, hiY-w, hiX+w, hiY+w, borderColor)
	    boxes.drawBox(loX-w, loY-w, loX+w, hiY+w, borderColor)
	    boxes.drawBox(hiX-w, loY-w, hiX+w, hiY+w, borderColor)
	  }
	}
	
	proto.update = function(options) {
	  options = options || {}
	
	  this.innerFill    = !!options.innerFill
	  this.outerFill    = !!options.outerFill
	  this.innerColor   = (options.innerColor   || [0,0,0,0.5]).slice()
	  this.outerColor   = (options.outerColor   || [0,0,0,0.5]).slice()
	  this.borderColor  = (options.borderColor || [0,0,0,1]).slice()
	  this.borderWidth  = options.borderWidth || 0
	  this.selectBox    = (options.selectBox || this.selectBox).slice()
	}
	
	proto.dispose = function() {
	  this.boxBuffer.dispose()
	  this.boxShader.dispose()
	  this.plot.removeOverlay(this)
	}
	
	function createSelectBox(plot, options) {
	  var gl = plot.gl
	  var buffer = createBuffer(gl, [
	    0, 0,
	    0, 1,
	    1, 0,
	    1, 1 ])
	  var shader = createShader(gl, SHADERS.boxVertex, SHADERS.boxFragment)
	  var selectBox = new SelectBox(plot, buffer, shader)
	  selectBox.update(options)
	  plot.addOverlay(selectBox)
	  return selectBox
	}
	
	},{"./lib/shaders":300,"gl-buffer":243,"gl-shader":303}],302:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createSelectBuffer
	
	var createFBO = _dereq_('gl-fbo')
	var pool      = _dereq_('typedarray-pool')
	var ndarray   = _dereq_('ndarray')
	
	var nextPow2  = _dereq_('bit-twiddle').nextPow2
	
	var selectRange = _dereq_('cwise/lib/wrapper')({"args":["array",{"offset":[0,0,1],"array":0},{"offset":[0,0,2],"array":0},{"offset":[0,0,3],"array":0},"scalar","scalar","index"],"pre":{"body":"{this_closestD2=1e8,this_closestX=-1,this_closestY=-1}","args":[],"thisVars":["this_closestD2","this_closestX","this_closestY"],"localVars":[]},"body":{"body":"{if(_inline_16_arg0_<255||_inline_16_arg1_<255||_inline_16_arg2_<255||_inline_16_arg3_<255){var _inline_16_l=_inline_16_arg4_-_inline_16_arg6_[0],_inline_16_a=_inline_16_arg5_-_inline_16_arg6_[1],_inline_16_f=_inline_16_l*_inline_16_l+_inline_16_a*_inline_16_a;_inline_16_f<this_closestD2&&(this_closestD2=_inline_16_f,this_closestX=_inline_16_arg6_[0],this_closestY=_inline_16_arg6_[1])}}","args":[{"name":"_inline_16_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg1_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg2_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg3_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg4_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg5_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_16_arg6_","lvalue":false,"rvalue":true,"count":4}],"thisVars":["this_closestD2","this_closestX","this_closestY"],"localVars":["_inline_16_a","_inline_16_f","_inline_16_l"]},"post":{"body":"{return[this_closestX,this_closestY,this_closestD2]}","args":[],"thisVars":["this_closestD2","this_closestX","this_closestY"],"localVars":[]},"debug":false,"funcName":"cwise","blockSize":64})
	
	function SelectResult(x, y, id, value, distance) {
	  this.coord = [x, y]
	  this.id = id
	  this.value = value
	  this.distance = distance
	}
	
	function SelectBuffer(gl, fbo, buffer) {
	  this.gl     = gl
	  this.fbo    = fbo
	  this.buffer = buffer
	  this._readTimeout = null
	  var self = this
	
	  this._readCallback = function() {
	    if(!self.gl) {
	      return
	    }
	    fbo.bind()
	    gl.readPixels(0,0,fbo.shape[0],fbo.shape[1],gl.RGBA,gl.UNSIGNED_BYTE,self.buffer)
	    self._readTimeout = null
	  }
	}
	
	var proto = SelectBuffer.prototype
	
	Object.defineProperty(proto, 'shape', {
	  get: function() {
	    if(!this.gl) {
	      return [0,0]
	    }
	    return this.fbo.shape.slice()
	  },
	  set: function(v) {
	    if(!this.gl) {
	      return
	    }
	    this.fbo.shape = v
	    var c = this.fbo.shape[0]
	    var r = this.fbo.shape[1]
	    if(r*c*4 > this.buffer.length) {
	      pool.free(this.buffer)
	      var buffer = this.buffer = pool.mallocUint8(nextPow2(r*c*4))
	      for(var i=0; i<r*c*4; ++i) {
	        buffer[i] = 0xff
	      }
	    }
	    return v
	  }
	})
	
	proto.begin = function() {
	  var gl = this.gl
	  var shape = this.shape
	  if(!gl) {
	    return
	  }
	
	  this.fbo.bind()
	  gl.clearColor(1,1,1,1)
	  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
	}
	
	proto.end = function() {
	  var gl = this.gl
	  if(!gl) {
	    return
	  }
	  gl.bindFramebuffer(gl.FRAMEBUFFER, null)
	  if(!this._readTimeout) {
	    clearTimeout(this._readTimeout)
	  }
	  this._readTimeout = setTimeout(this._readCallback, 1)
	}
	
	proto.query = function(x, y, radius) {
	  if(!this.gl) {
	    return null
	  }
	
	  var shape = this.fbo.shape.slice()
	
	  x = x|0
	  y = y|0
	  if(typeof radius !== 'number') {
	    radius = 1.0
	  }
	
	  var x0 = Math.min(Math.max(x - radius, 0), shape[0])|0
	  var x1 = Math.min(Math.max(x + radius, 0), shape[0])|0
	  var y0 = Math.min(Math.max(y - radius, 0), shape[1])|0
	  var y1 = Math.min(Math.max(y + radius, 0), shape[1])|0
	
	  if(x1 <= x0 || y1 <= y0) {
	    return null
	  }
	
	  var dims   = [x1-x0,y1-y0]
	  var region = ndarray(
	    this.buffer,
	    [dims[0], dims[1], 4],
	    [4, shape[0]*4, 1],
	    4*(x0 + shape[0]*y0));
	
	  var closest = selectRange(region.hi(dims[0],dims[1],1), radius, radius)
	  var dx = closest[0]
	  var dy = closest[1]
	  if(dx < 0 || Math.pow(this.radius, 2) < closest[2]) {
	    return null
	  }
	
	  var c0 = region.get(dx, dy, 0)
	  var c1 = region.get(dx, dy, 1)
	  var c2 = region.get(dx, dy, 2)
	  var c3 = region.get(dx, dy, 3)
	
	  return new SelectResult(
	     (dx + x0)|0,
	     (dy + y0)|0,
	     c0,
	     [c1, c2, c3],
	     Math.sqrt(closest[2]))
	}
	
	proto.dispose = function() {
	  if(!this.gl) {
	    return
	  }
	  this.fbo.dispose()
	  pool.free(this.buffer)
	  this.gl = null
	  if(this._readTimeout) {
	    clearTimeout(this._readTimeout)
	  }
	}
	
	function createSelectBuffer(gl, shape) {
	  var fbo = createFBO(gl, shape)
	  var buffer = pool.mallocUint8(shape[0]*shape[1]*4)
	  return new SelectBuffer(gl, fbo, buffer)
	}
	
	},{"bit-twiddle":93,"cwise/lib/wrapper":150,"gl-fbo":251,"ndarray":451,"typedarray-pool":543}],303:[function(_dereq_,module,exports){
	'use strict'
	
	var createUniformWrapper   = _dereq_('./lib/create-uniforms')
	var createAttributeWrapper = _dereq_('./lib/create-attributes')
	var makeReflect            = _dereq_('./lib/reflect')
	var shaderCache            = _dereq_('./lib/shader-cache')
	var runtime                = _dereq_('./lib/runtime-reflect')
	var GLError                = _dereq_("./lib/GLError")
	
	//Shader object
	function Shader(gl) {
	  this.gl         = gl
	  this.gl.lastAttribCount = 0  // fixme where else should we store info, safe but not nice on the gl object
	
	  //Default initialize these to null
	  this._vref      =
	  this._fref      =
	  this._relink    =
	  this.vertShader =
	  this.fragShader =
	  this.program    =
	  this.attributes =
	  this.uniforms   =
	  this.types      = null
	}
	
	var proto = Shader.prototype
	
	proto.bind = function() {
	  if(!this.program) {
	    this._relink()
	  }
	
	  // ensuring that we have the right number of enabled vertex attributes
	  var i
	  var newAttribCount = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES) // more robust approach
	  //var newAttribCount = Object.keys(this.attributes).length // avoids the probably immaterial introspection slowdown
	  var oldAttribCount = this.gl.lastAttribCount
	  if(newAttribCount > oldAttribCount) {
	    for(i = oldAttribCount; i < newAttribCount; i++) {
	      this.gl.enableVertexAttribArray(i)
	    }
	  } else if(oldAttribCount > newAttribCount) {
	    for(i = newAttribCount; i < oldAttribCount; i++) {
	      this.gl.disableVertexAttribArray(i)
	    }
	  }
	
	  this.gl.lastAttribCount = newAttribCount
	
	  this.gl.useProgram(this.program)
	}
	
	proto.dispose = function() {
	
	  // disabling vertex attributes so new shader starts with zero
	  // and it's also useful if all shaders are disposed but the
	  // gl context is reused for subsequent replotting
	  var oldAttribCount = this.gl.lastAttribCount
	  for (var i = 0; i < oldAttribCount; i++) {
	    this.gl.disableVertexAttribArray(i)
	  }
	  this.gl.lastAttribCount = 0
	
	  if(this._fref) {
	    this._fref.dispose()
	  }
	  if(this._vref) {
	    this._vref.dispose()
	  }
	  this.attributes =
	  this.types      =
	  this.vertShader =
	  this.fragShader =
	  this.program    =
	  this._relink    =
	  this._fref      =
	  this._vref      = null
	}
	
	function compareAttributes(a, b) {
	  if(a.name < b.name) {
	    return -1
	  }
	  return 1
	}
	
	//Update export hook for glslify-live
	proto.update = function(
	    vertSource
	  , fragSource
	  , uniforms
	  , attributes) {
	
	  //If only one object passed, assume glslify style output
	  if(!fragSource || arguments.length === 1) {
	    var obj = vertSource
	    vertSource = obj.vertex
	    fragSource = obj.fragment
	    uniforms   = obj.uniforms
	    attributes = obj.attributes
	  }
	
	  var wrapper = this
	  var gl      = wrapper.gl
	
	  //Compile vertex and fragment shaders
	  var pvref = wrapper._vref
	  wrapper._vref = shaderCache.shader(gl, gl.VERTEX_SHADER, vertSource)
	  if(pvref) {
	    pvref.dispose()
	  }
	  wrapper.vertShader = wrapper._vref.shader
	  var pfref = this._fref
	  wrapper._fref = shaderCache.shader(gl, gl.FRAGMENT_SHADER, fragSource)
	  if(pfref) {
	    pfref.dispose()
	  }
	  wrapper.fragShader = wrapper._fref.shader
	
	  //If uniforms/attributes is not specified, use RT reflection
	  if(!uniforms || !attributes) {
	
	    //Create initial test program
	    var testProgram = gl.createProgram()
	    gl.attachShader(testProgram, wrapper.fragShader)
	    gl.attachShader(testProgram, wrapper.vertShader)
	    gl.linkProgram(testProgram)
	    if(!gl.getProgramParameter(testProgram, gl.LINK_STATUS)) {
	      var errLog = gl.getProgramInfoLog(testProgram)
	      throw new GLError(errLog, 'Error linking program:' + errLog)
	    }
	
	    //Load data from runtime
	    uniforms   = uniforms   || runtime.uniforms(gl, testProgram)
	    attributes = attributes || runtime.attributes(gl, testProgram)
	
	    //Release test program
	    gl.deleteProgram(testProgram)
	  }
	
	  //Sort attributes lexicographically
	  // overrides undefined WebGL behavior for attribute locations
	  attributes = attributes.slice()
	  attributes.sort(compareAttributes)
	
	  //Convert attribute types, read out locations
	  var attributeUnpacked  = []
	  var attributeNames     = []
	  var attributeLocations = []
	  var i
	  for(i=0; i<attributes.length; ++i) {
	    var attr = attributes[i]
	    if(attr.type.indexOf('mat') >= 0) {
	      var size = attr.type.charAt(attr.type.length-1)|0
	      var locVector = new Array(size)
	      for(var j=0; j<size; ++j) {
	        locVector[j] = attributeLocations.length
	        attributeNames.push(attr.name + '[' + j + ']')
	        if(typeof attr.location === 'number') {
	          attributeLocations.push(attr.location + j)
	        } else if(Array.isArray(attr.location) &&
	                  attr.location.length === size &&
	                  typeof attr.location[j] === 'number') {
	          attributeLocations.push(attr.location[j]|0)
	        } else {
	          attributeLocations.push(-1)
	        }
	      }
	      attributeUnpacked.push({
	        name: attr.name,
	        type: attr.type,
	        locations: locVector
	      })
	    } else {
	      attributeUnpacked.push({
	        name: attr.name,
	        type: attr.type,
	        locations: [ attributeLocations.length ]
	      })
	      attributeNames.push(attr.name)
	      if(typeof attr.location === 'number') {
	        attributeLocations.push(attr.location|0)
	      } else {
	        attributeLocations.push(-1)
	      }
	    }
	  }
	
	  //For all unspecified attributes, assign them lexicographically min attribute
	  var curLocation = 0
	  for(i=0; i<attributeLocations.length; ++i) {
	    if(attributeLocations[i] < 0) {
	      while(attributeLocations.indexOf(curLocation) >= 0) {
	        curLocation += 1
	      }
	      attributeLocations[i] = curLocation
	    }
	  }
	
	  //Rebuild program and recompute all uniform locations
	  var uniformLocations = new Array(uniforms.length)
	  function relink() {
	    wrapper.program = shaderCache.program(
	        gl
	      , wrapper._vref
	      , wrapper._fref
	      , attributeNames
	      , attributeLocations)
	
	    for(var i=0; i<uniforms.length; ++i) {
	      uniformLocations[i] = gl.getUniformLocation(
	          wrapper.program
	        , uniforms[i].name)
	    }
	  }
	
	  //Perform initial linking, reuse program used for reflection
	  relink()
	
	  //Save relinking procedure, defer until runtime
	  wrapper._relink = relink
	
	  //Generate type info
	  wrapper.types = {
	    uniforms:   makeReflect(uniforms),
	    attributes: makeReflect(attributes)
	  }
	
	  //Generate attribute wrappers
	  wrapper.attributes = createAttributeWrapper(
	      gl
	    , wrapper
	    , attributeUnpacked
	    , attributeLocations)
	
	  //Generate uniform wrappers
	  Object.defineProperty(wrapper, 'uniforms', createUniformWrapper(
	      gl
	    , wrapper
	    , uniforms
	    , uniformLocations))
	}
	
	//Compiles and links a shader program with the given attribute and vertex list
	function createShader(
	    gl
	  , vertSource
	  , fragSource
	  , uniforms
	  , attributes) {
	
	  var shader = new Shader(gl)
	
	  shader.update(
	      vertSource
	    , fragSource
	    , uniforms
	    , attributes)
	
	  return shader
	}
	
	module.exports = createShader
	
	},{"./lib/GLError":304,"./lib/create-attributes":305,"./lib/create-uniforms":306,"./lib/reflect":307,"./lib/runtime-reflect":308,"./lib/shader-cache":309}],304:[function(_dereq_,module,exports){
	function GLError (rawError, shortMessage, longMessage) {
	    this.shortMessage = shortMessage || ''
	    this.longMessage = longMessage || ''
	    this.rawError = rawError || ''
	    this.message =
	      'gl-shader: ' + (shortMessage || rawError || '') +
	      (longMessage ? '\n'+longMessage : '')
	    this.stack = (new Error()).stack
	}
	GLError.prototype = new Error
	GLError.prototype.name = 'GLError'
	GLError.prototype.constructor = GLError
	module.exports = GLError
	
	},{}],305:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createAttributeWrapper
	
	var GLError = _dereq_("./GLError")
	
	function ShaderAttribute(
	    gl
	  , wrapper
	  , index
	  , locations
	  , dimension
	  , constFunc) {
	  this._gl        = gl
	  this._wrapper   = wrapper
	  this._index     = index
	  this._locations = locations
	  this._dimension = dimension
	  this._constFunc = constFunc
	}
	
	var proto = ShaderAttribute.prototype
	
	proto.pointer = function setAttribPointer(
	    type
	  , normalized
	  , stride
	  , offset) {
	
	  var self      = this
	  var gl        = self._gl
	  var location  = self._locations[self._index]
	
	  gl.vertexAttribPointer(
	      location
	    , self._dimension
	    , type || gl.FLOAT
	    , !!normalized
	    , stride || 0
	    , offset || 0)
	  gl.enableVertexAttribArray(location)
	}
	
	proto.set = function(x0, x1, x2, x3) {
	  return this._constFunc(this._locations[this._index], x0, x1, x2, x3)
	}
	
	Object.defineProperty(proto, 'location', {
	  get: function() {
	    return this._locations[this._index]
	  }
	  , set: function(v) {
	    if(v !== this._locations[this._index]) {
	      this._locations[this._index] = v|0
	      this._wrapper.program = null
	    }
	    return v|0
	  }
	})
	
	//Adds a vector attribute to obj
	function addVectorAttribute(
	    gl
	  , wrapper
	  , index
	  , locations
	  , dimension
	  , obj
	  , name) {
	
	  //Construct constant function
	  var constFuncArgs = [ 'gl', 'v' ]
	  var varNames = []
	  for(var i=0; i<dimension; ++i) {
	    constFuncArgs.push('x'+i)
	    varNames.push('x'+i)
	  }
	  constFuncArgs.push(
	    'if(x0.length===void 0){return gl.vertexAttrib' +
	    dimension + 'f(v,' +
	    varNames.join() +
	    ')}else{return gl.vertexAttrib' +
	    dimension +
	    'fv(v,x0)}')
	  var constFunc = Function.apply(null, constFuncArgs)
	
	  //Create attribute wrapper
	  var attr = new ShaderAttribute(
	      gl
	    , wrapper
	    , index
	    , locations
	    , dimension
	    , constFunc)
	
	  //Create accessor
	  Object.defineProperty(obj, name, {
	    set: function(x) {
	      gl.disableVertexAttribArray(locations[index])
	      constFunc(gl, locations[index], x)
	      return x
	    }
	    , get: function() {
	      return attr
	    }
	    , enumerable: true
	  })
	}
	
	function addMatrixAttribute(
	    gl
	  , wrapper
	  , index
	  , locations
	  , dimension
	  , obj
	  , name) {
	
	  var parts = new Array(dimension)
	  var attrs = new Array(dimension)
	  for(var i=0; i<dimension; ++i) {
	    addVectorAttribute(
	        gl
	      , wrapper
	      , index[i]
	      , locations
	      , dimension
	      , parts
	      , i)
	    attrs[i] = parts[i]
	  }
	
	  Object.defineProperty(parts, 'location', {
	    set: function(v) {
	      if(Array.isArray(v)) {
	        for(var i=0; i<dimension; ++i) {
	          attrs[i].location = v[i]
	        }
	      } else {
	        for(var i=0; i<dimension; ++i) {
	          attrs[i].location = v + i
	        }
	      }
	      return v
	    }
	    , get: function() {
	      var result = new Array(dimension)
	      for(var i=0; i<dimension; ++i) {
	        result[i] = locations[index[i]]
	      }
	      return result
	    }
	    , enumerable: true
	  })
	
	  parts.pointer = function(type, normalized, stride, offset) {
	    type       = type || gl.FLOAT
	    normalized = !!normalized
	    stride     = stride || (dimension * dimension)
	    offset     = offset || 0
	    for(var i=0; i<dimension; ++i) {
	      var location = locations[index[i]]
	      gl.vertexAttribPointer(
	            location
	          , dimension
	          , type
	          , normalized
	          , stride
	          , offset + i * dimension)
	      gl.enableVertexAttribArray(location)
	    }
	  }
	
	  var scratch = new Array(dimension)
	  var vertexAttrib = gl['vertexAttrib' + dimension + 'fv']
	
	  Object.defineProperty(obj, name, {
	    set: function(x) {
	      for(var i=0; i<dimension; ++i) {
	        var loc = locations[index[i]]
	        gl.disableVertexAttribArray(loc)
	        if(Array.isArray(x[0])) {
	          vertexAttrib.call(gl, loc, x[i])
	        } else {
	          for(var j=0; j<dimension; ++j) {
	            scratch[j] = x[dimension*i + j]
	          }
	          vertexAttrib.call(gl, loc, scratch)
	        }
	      }
	      return x
	    }
	    , get: function() {
	      return parts
	    }
	    , enumerable: true
	  })
	}
	
	//Create shims for attributes
	function createAttributeWrapper(
	    gl
	  , wrapper
	  , attributes
	  , locations) {
	
	  var obj = {}
	  for(var i=0, n=attributes.length; i<n; ++i) {
	
	    var a = attributes[i]
	    var name = a.name
	    var type = a.type
	    var locs = a.locations
	
	    switch(type) {
	      case 'bool':
	      case 'int':
	      case 'float':
	        addVectorAttribute(
	            gl
	          , wrapper
	          , locs[0]
	          , locations
	          , 1
	          , obj
	          , name)
	      break
	
	      default:
	        if(type.indexOf('vec') >= 0) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid data type for attribute ' + name + ': ' + type)
	          }
	          addVectorAttribute(
	              gl
	            , wrapper
	            , locs[0]
	            , locations
	            , d
	            , obj
	            , name)
	        } else if(type.indexOf('mat') >= 0) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid data type for attribute ' + name + ': ' + type)
	          }
	          addMatrixAttribute(
	              gl
	            , wrapper
	            , locs
	            , locations
	            , d
	            , obj
	            , name)
	        } else {
	          throw new GLError('', 'Unknown data type for attribute ' + name + ': ' + type)
	        }
	      break
	    }
	  }
	  return obj
	}
	
	},{"./GLError":304}],306:[function(_dereq_,module,exports){
	'use strict'
	
	var coallesceUniforms = _dereq_('./reflect')
	var GLError = _dereq_("./GLError")
	
	module.exports = createUniformWrapper
	
	//Binds a function and returns a value
	function identity(x) {
	  var c = new Function('y', 'return function(){return y}')
	  return c(x)
	}
	
	function makeVector(length, fill) {
	  var result = new Array(length)
	  for(var i=0; i<length; ++i) {
	    result[i] = fill
	  }
	  return result
	}
	
	//Create shims for uniforms
	function createUniformWrapper(gl, wrapper, uniforms, locations) {
	
	  function makeGetter(index) {
	    var proc = new Function(
	        'gl'
	      , 'wrapper'
	      , 'locations'
	      , 'return function(){return gl.getUniform(wrapper.program,locations[' + index + '])}')
	    return proc(gl, wrapper, locations)
	  }
	
	  function makePropSetter(path, index, type) {
	    switch(type) {
	      case 'bool':
	      case 'int':
	      case 'sampler2D':
	      case 'samplerCube':
	        return 'gl.uniform1i(locations[' + index + '],obj' + path + ')'
	      case 'float':
	        return 'gl.uniform1f(locations[' + index + '],obj' + path + ')'
	      default:
	        var vidx = type.indexOf('vec')
	        if(0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid data type')
	          }
	          switch(type.charAt(0)) {
	            case 'b':
	            case 'i':
	              return 'gl.uniform' + d + 'iv(locations[' + index + '],obj' + path + ')'
	            case 'v':
	              return 'gl.uniform' + d + 'fv(locations[' + index + '],obj' + path + ')'
	            default:
	              throw new GLError('', 'Unrecognized data type for vector ' + name + ': ' + type)
	          }
	        } else if(type.indexOf('mat') === 0 && type.length === 4) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid uniform dimension type for matrix ' + name + ': ' + type)
	          }
	          return 'gl.uniformMatrix' + d + 'fv(locations[' + index + '],false,obj' + path + ')'
	        } else {
	          throw new GLError('', 'Unknown uniform data type for ' + name + ': ' + type)
	        }
	      break
	    }
	  }
	
	  function enumerateIndices(prefix, type) {
	    if(typeof type !== 'object') {
	      return [ [prefix, type] ]
	    }
	    var indices = []
	    for(var id in type) {
	      var prop = type[id]
	      var tprefix = prefix
	      if(parseInt(id) + '' === id) {
	        tprefix += '[' + id + ']'
	      } else {
	        tprefix += '.' + id
	      }
	      if(typeof prop === 'object') {
	        indices.push.apply(indices, enumerateIndices(tprefix, prop))
	      } else {
	        indices.push([tprefix, prop])
	      }
	    }
	    return indices
	  }
	
	  function makeSetter(type) {
	    var code = [ 'return function updateProperty(obj){' ]
	    var indices = enumerateIndices('', type)
	    for(var i=0; i<indices.length; ++i) {
	      var item = indices[i]
	      var path = item[0]
	      var idx  = item[1]
	      if(locations[idx]) {
	        code.push(makePropSetter(path, idx, uniforms[idx].type))
	      }
	    }
	    code.push('return obj}')
	    var proc = new Function('gl', 'locations', code.join('\n'))
	    return proc(gl, locations)
	  }
	
	  function defaultValue(type) {
	    switch(type) {
	      case 'bool':
	        return false
	      case 'int':
	      case 'sampler2D':
	      case 'samplerCube':
	        return 0
	      case 'float':
	        return 0.0
	      default:
	        var vidx = type.indexOf('vec')
	        if(0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid data type')
	          }
	          if(type.charAt(0) === 'b') {
	            return makeVector(d, false)
	          }
	          return makeVector(d, 0)
	        } else if(type.indexOf('mat') === 0 && type.length === 4) {
	          var d = type.charCodeAt(type.length-1) - 48
	          if(d < 2 || d > 4) {
	            throw new GLError('', 'Invalid uniform dimension type for matrix ' + name + ': ' + type)
	          }
	          return makeVector(d*d, 0)
	        } else {
	          throw new GLError('', 'Unknown uniform data type for ' + name + ': ' + type)
	        }
	      break
	    }
	  }
	
	  function storeProperty(obj, prop, type) {
	    if(typeof type === 'object') {
	      var child = processObject(type)
	      Object.defineProperty(obj, prop, {
	        get: identity(child),
	        set: makeSetter(type),
	        enumerable: true,
	        configurable: false
	      })
	    } else {
	      if(locations[type]) {
	        Object.defineProperty(obj, prop, {
	          get: makeGetter(type),
	          set: makeSetter(type),
	          enumerable: true,
	          configurable: false
	        })
	      } else {
	        obj[prop] = defaultValue(uniforms[type].type)
	      }
	    }
	  }
	
	  function processObject(obj) {
	    var result
	    if(Array.isArray(obj)) {
	      result = new Array(obj.length)
	      for(var i=0; i<obj.length; ++i) {
	        storeProperty(result, i, obj[i])
	      }
	    } else {
	      result = {}
	      for(var id in obj) {
	        storeProperty(result, id, obj[id])
	      }
	    }
	    return result
	  }
	
	  //Return data
	  var coallesced = coallesceUniforms(uniforms, true)
	  return {
	    get: identity(processObject(coallesced)),
	    set: makeSetter(coallesced),
	    enumerable: true,
	    configurable: true
	  }
	}
	
	},{"./GLError":304,"./reflect":307}],307:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = makeReflectTypes
	
	//Construct type info for reflection.
	//
	// This iterates over the flattened list of uniform type values and smashes them into a JSON object.
	//
	// The leaves of the resulting object are either indices or type strings representing primitive glslify types
	function makeReflectTypes(uniforms, useIndex) {
	  var obj = {}
	  for(var i=0; i<uniforms.length; ++i) {
	    var n = uniforms[i].name
	    var parts = n.split(".")
	    var o = obj
	    for(var j=0; j<parts.length; ++j) {
	      var x = parts[j].split("[")
	      if(x.length > 1) {
	        if(!(x[0] in o)) {
	          o[x[0]] = []
	        }
	        o = o[x[0]]
	        for(var k=1; k<x.length; ++k) {
	          var y = parseInt(x[k])
	          if(k<x.length-1 || j<parts.length-1) {
	            if(!(y in o)) {
	              if(k < x.length-1) {
	                o[y] = []
	              } else {
	                o[y] = {}
	              }
	            }
	            o = o[y]
	          } else {
	            if(useIndex) {
	              o[y] = i
	            } else {
	              o[y] = uniforms[i].type
	            }
	          }
	        }
	      } else if(j < parts.length-1) {
	        if(!(x[0] in o)) {
	          o[x[0]] = {}
	        }
	        o = o[x[0]]
	      } else {
	        if(useIndex) {
	          o[x[0]] = i
	        } else {
	          o[x[0]] = uniforms[i].type
	        }
	      }
	    }
	  }
	  return obj
	}
	},{}],308:[function(_dereq_,module,exports){
	'use strict'
	
	exports.uniforms    = runtimeUniforms
	exports.attributes  = runtimeAttributes
	
	var GL_TO_GLSL_TYPES = {
	  'FLOAT':       'float',
	  'FLOAT_VEC2':  'vec2',
	  'FLOAT_VEC3':  'vec3',
	  'FLOAT_VEC4':  'vec4',
	  'INT':         'int',
	  'INT_VEC2':    'ivec2',
	  'INT_VEC3':    'ivec3',
	  'INT_VEC4':    'ivec4',
	  'BOOL':        'bool',
	  'BOOL_VEC2':   'bvec2',
	  'BOOL_VEC3':   'bvec3',
	  'BOOL_VEC4':   'bvec4',
	  'FLOAT_MAT2':  'mat2',
	  'FLOAT_MAT3':  'mat3',
	  'FLOAT_MAT4':  'mat4',
	  'SAMPLER_2D':  'sampler2D',
	  'SAMPLER_CUBE':'samplerCube'
	}
	
	var GL_TABLE = null
	
	function getType(gl, type) {
	  if(!GL_TABLE) {
	    var typeNames = Object.keys(GL_TO_GLSL_TYPES)
	    GL_TABLE = {}
	    for(var i=0; i<typeNames.length; ++i) {
	      var tn = typeNames[i]
	      GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn]
	    }
	  }
	  return GL_TABLE[type]
	}
	
	function runtimeUniforms(gl, program) {
	  var numUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS)
	  var result = []
	  for(var i=0; i<numUniforms; ++i) {
	    var info = gl.getActiveUniform(program, i)
	    if(info) {
	      var type = getType(gl, info.type)
	      if(info.size > 1) {
	        for(var j=0; j<info.size; ++j) {
	          result.push({
	            name: info.name.replace('[0]', '[' + j + ']'),
	            type: type
	          })
	        }
	      } else {
	        result.push({
	          name: info.name,
	          type: type
	        })
	      }
	    }
	  }
	  return result
	}
	
	function runtimeAttributes(gl, program) {
	  var numAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES)
	  var result = []
	  for(var i=0; i<numAttributes; ++i) {
	    var info = gl.getActiveAttrib(program, i)
	    if(info) {
	      result.push({
	        name: info.name,
	        type: getType(gl, info.type)
	      })
	    }
	  }
	  return result
	}
	
	},{}],309:[function(_dereq_,module,exports){
	'use strict'
	
	exports.shader   = getShaderReference
	exports.program  = createProgram
	
	var GLError = _dereq_("./GLError")
	var formatCompilerError = _dereq_('gl-format-compiler-error');
	
	var weakMap = typeof WeakMap === 'undefined' ? _dereq_('weakmap-shim') : WeakMap
	var CACHE = new weakMap()
	
	var SHADER_COUNTER = 0
	
	function ShaderReference(id, src, type, shader, programs, count, cache) {
	  this.id       = id
	  this.src      = src
	  this.type     = type
	  this.shader   = shader
	  this.count    = count
	  this.programs = []
	  this.cache    = cache
	}
	
	ShaderReference.prototype.dispose = function() {
	  if(--this.count === 0) {
	    var cache    = this.cache
	    var gl       = cache.gl
	
	    //Remove program references
	    var programs = this.programs
	    for(var i=0, n=programs.length; i<n; ++i) {
	      var p = cache.programs[programs[i]]
	      if(p) {
	        delete cache.programs[i]
	        gl.deleteProgram(p)
	      }
	    }
	
	    //Remove shader reference
	    gl.deleteShader(this.shader)
	    delete cache.shaders[(this.type === gl.FRAGMENT_SHADER)|0][this.src]
	  }
	}
	
	function ContextCache(gl) {
	  this.gl       = gl
	  this.shaders  = [{}, {}]
	  this.programs = {}
	}
	
	var proto = ContextCache.prototype
	
	function compileShader(gl, type, src) {
	  var shader = gl.createShader(type)
	  gl.shaderSource(shader, src)
	  gl.compileShader(shader)
	  if(!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	    var errLog = gl.getShaderInfoLog(shader)
	    try {
	        var fmt = formatCompilerError(errLog, src, type);
	    } catch (e){
	        console.warn('Failed to format compiler error: ' + e);
	        throw new GLError(errLog, 'Error compiling shader:\n' + errLog)
	    }
	    throw new GLError(errLog, fmt.short, fmt.long)
	  }
	  return shader
	}
	
	proto.getShaderReference = function(type, src) {
	  var gl      = this.gl
	  var shaders = this.shaders[(type === gl.FRAGMENT_SHADER)|0]
	  var shader  = shaders[src]
	  if(!shader || !gl.isShader(shader.shader)) {
	    var shaderObj = compileShader(gl, type, src)
	    shader = shaders[src] = new ShaderReference(
	      SHADER_COUNTER++,
	      src,
	      type,
	      shaderObj,
	      [],
	      1,
	      this)
	  } else {
	    shader.count += 1
	  }
	  return shader
	}
	
	function linkProgram(gl, vshader, fshader, attribs, locations) {
	  var program = gl.createProgram()
	  gl.attachShader(program, vshader)
	  gl.attachShader(program, fshader)
	  for(var i=0; i<attribs.length; ++i) {
	    gl.bindAttribLocation(program, locations[i], attribs[i])
	  }
	  gl.linkProgram(program)
	  if(!gl.getProgramParameter(program, gl.LINK_STATUS)) {
	    var errLog = gl.getProgramInfoLog(program)
	    throw new GLError(errLog, 'Error linking program: ' + errLog)
	  }
	  return program
	}
	
	proto.getProgram = function(vref, fref, attribs, locations) {
	  var token = [vref.id, fref.id, attribs.join(':'), locations.join(':')].join('@')
	  var prog  = this.programs[token]
	  if(!prog || !this.gl.isProgram(prog)) {
	    this.programs[token] = prog = linkProgram(
	      this.gl,
	      vref.shader,
	      fref.shader,
	      attribs,
	      locations)
	    vref.programs.push(token)
	    fref.programs.push(token)
	  }
	  return prog
	}
	
	function getCache(gl) {
	  var ctxCache = CACHE.get(gl)
	  if(!ctxCache) {
	    ctxCache = new ContextCache(gl)
	    CACHE.set(gl, ctxCache)
	  }
	  return ctxCache
	}
	
	function getShaderReference(gl, type, src) {
	  return getCache(gl).getShaderReference(type, src)
	}
	
	function createProgram(gl, vref, fref, attribs, locations) {
	  return getCache(gl).getProgram(vref, fref, attribs, locations)
	}
	
	},{"./GLError":304,"gl-format-compiler-error":252,"weakmap-shim":553}],310:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createSpikes2D
	
	function GLSpikes2D(plot) {
	  this.plot = plot
	  this.enable = [true, true, false, false]
	  this.width  = [1, 1, 1, 1]
	  this.color  = [[0,0,0,1],
	                 [0,0,0,1],
	                 [0,0,0,1],
	                 [0,0,0,1]]
	  this.center = [Infinity, Infinity]
	}
	
	var proto = GLSpikes2D.prototype
	
	proto.update = function(options) {
	  options = options || {}
	  this.enable = (options.enable || [true,true,false,false]).slice()
	  this.width  = (options.width || [1,1,1,1]).slice()
	  this.color  = (options.color || [
	                  [0,0,0,1],
	                  [0,0,0,1],
	                  [0,0,0,1],
	                  [0,0,0,1]]).map(function(x) { return x.slice() })
	  this.center = (options.center || [Infinity,Infinity]).slice()
	  this.plot.setOverlayDirty()
	}
	
	proto.draw = function() {
	  var spikeEnable = this.enable
	  var spikeWidth  = this.width
	  var spikeColor  = this.color
	  var spikeCenter = this.center
	  var plot        = this.plot
	  var line        = plot.line
	
	  var dataBox     = plot.dataBox
	  var viewPixels  = plot.viewBox
	
	  line.bind()
	
	  if(dataBox[0] <= spikeCenter[0] && spikeCenter[0] <= dataBox[2] &&
	     dataBox[1] <= spikeCenter[1] && spikeCenter[1] <= dataBox[3]) {
	
	    var centerX = viewPixels[0] + (spikeCenter[0] - dataBox[0]) / (dataBox[2] - dataBox[0]) * (viewPixels[2] - viewPixels[0])
	    var centerY = viewPixels[1] + (spikeCenter[1] - dataBox[1]) / (dataBox[3] - dataBox[1]) * (viewPixels[3] - viewPixels[1])
	
	    if(spikeEnable[0]) {
	     line.drawLine(
	       centerX, centerY,
	       viewPixels[0], centerY,
	       spikeWidth[0], spikeColor[0])
	    }
	    if(spikeEnable[1]) {
	     line.drawLine(
	       centerX, centerY,
	       centerX, viewPixels[1],
	       spikeWidth[1], spikeColor[1])
	    }
	    if(spikeEnable[2]) {
	      line.drawLine(
	        centerX, centerY,
	        viewPixels[2], centerY,
	        spikeWidth[2], spikeColor[2])
	    }
	    if(spikeEnable[3]) {
	      line.drawLine(
	        centerX, centerY,
	        centerX, viewPixels[3],
	        spikeWidth[3], spikeColor[3])
	    }
	  }
	}
	
	proto.dispose = function() {
	  this.plot.removeOverlay(this)
	}
	
	function createSpikes2D(plot, options) {
	  var spikes = new GLSpikes2D(plot)
	  spikes.update(options)
	  plot.addOverlay(spikes)
	  return spikes
	}
	
	},{}],311:[function(_dereq_,module,exports){
	'use strict'
	
	var glslify      = _dereq_('glslify')
	var createShader = _dereq_('gl-shader')
	
	var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"])
	var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"])
	
	module.exports = function(gl) {
	  return createShader(gl, vertSrc, fragSrc, null, [
	    {name: 'position', type: 'vec3'},
	    {name: 'color', type: 'vec3'},
	    {name: 'weight', type: 'float'}
	  ])
	}
	
	},{"gl-shader":303,"glslify":410}],312:[function(_dereq_,module,exports){
	'use strict'
	
	var createBuffer = _dereq_('gl-buffer')
	var createVAO = _dereq_('gl-vao')
	var createShader = _dereq_('./shaders/index')
	
	module.exports = createSpikes
	
	var identity = [1,0,0,0,
	                0,1,0,0,
	                0,0,1,0,
	                0,0,0,1]
	
	function AxisSpikes(gl, buffer, vao, shader) {
	  this.gl         = gl
	  this.buffer     = buffer
	  this.vao        = vao
	  this.shader     = shader
	  this.pixelRatio = 1
	  this.bounds     = [[-1000,-1000,-1000], [1000,1000,1000]]
	  this.position   = [0,0,0]
	  this.lineWidth  = [2,2,2]
	  this.colors     = [[0,0,0,1], [0,0,0,1], [0,0,0,1]]
	  this.enabled    = [true,true,true]
	  this.drawSides  = [true,true,true]
	  this.axes       = null
	}
	
	var proto = AxisSpikes.prototype
	
	var OUTER_FACE = [0,0,0]
	var INNER_FACE = [0,0,0]
	
	var SHAPE = [0,0]
	
	proto.isTransparent = function() {
	  return false
	}
	
	proto.drawTransparent = function(camera) {}
	
	proto.draw = function(camera) {
	  var gl = this.gl
	  var vao = this.vao
	  var shader = this.shader
	
	  vao.bind()
	  shader.bind()
	
	  var model      = camera.model || identity
	  var view       = camera.view || identity
	  var projection = camera.projection || identity
	
	  var axis
	  if(this.axes) {
	    axis = this.axes.lastCubeProps.axis
	  }
	
	  var outerFace = OUTER_FACE
	  var innerFace = INNER_FACE
	  for(var i=0; i<3; ++i) {
	    if(axis && axis[i] < 0) {
	      outerFace[i] = this.bounds[0][i]
	      innerFace[i] = this.bounds[1][i]
	    } else {
	      outerFace[i] = this.bounds[1][i]
	      innerFace[i] = this.bounds[0][i]
	    }
	  }
	
	  SHAPE[0] = gl.drawingBufferWidth
	  SHAPE[1] = gl.drawingBufferHeight
	
	  shader.uniforms.model       = model
	  shader.uniforms.view        = view
	  shader.uniforms.projection  = projection
	  shader.uniforms.coordinates = [this.position, outerFace, innerFace]
	  shader.uniforms.colors      = this.colors
	  shader.uniforms.screenShape = SHAPE
	
	  for(var i=0; i<3; ++i) {
	    shader.uniforms.lineWidth = this.lineWidth[i] * this.pixelRatio
	    if(this.enabled[i]) {
	      vao.draw(gl.TRIANGLES, 6, 6*i)
	      if(this.drawSides[i]) {
	        vao.draw(gl.TRIANGLES, 12, 18+12*i)
	      }
	    }
	  }
	
	  vao.unbind()
	}
	
	proto.update = function(options) {
	  if(!options) {
	    return
	  }
	  if("bounds" in options) {
	    this.bounds = options.bounds
	  }
	  if("position" in options) {
	    this.position = options.position
	  }
	  if("lineWidth" in options) {
	    this.lineWidth = options.lineWidth
	  }
	  if("colors" in options) {
	    this.colors = options.colors
	  }
	  if("enabled" in options) {
	    this.enabled = options.enabled
	  }
	  if("drawSides" in options) {
	    this.drawSides = options.drawSides
	  }
	}
	
	proto.dispose = function() {
	  this.vao.dispose()
	  this.buffer.dispose()
	  this.shader.dispose()
	}
	
	
	
	function createSpikes(gl, options) {
	  //Create buffers
	  var data = [ ]
	
	  function line(x,y,z,i,l,h) {
	    var row = [x,y,z,  0,0,0,  1]
	    row[i+3] = 1
	    row[i] = l
	    data.push.apply(data, row)
	    row[6] = -1
	    data.push.apply(data, row)
	    row[i] = h
	    data.push.apply(data, row)
	    data.push.apply(data, row)
	    row[6] = 1
	    data.push.apply(data, row)
	    row[i] = l
	    data.push.apply(data, row)
	  }
	
	  line(0,0,0, 0, 0, 1)
	  line(0,0,0, 1, 0, 1)
	  line(0,0,0, 2, 0, 1)
	
	  line(1,0,0,  1,  -1,1)
	  line(1,0,0,  2,  -1,1)
	
	  line(0,1,0,  0,  -1,1)
	  line(0,1,0,  2,  -1,1)
	
	  line(0,0,1,  0,  -1,1)
	  line(0,0,1,  1,  -1,1)
	
	  var buffer = createBuffer(gl, data)
	  var vao = createVAO(gl, [{
	    type: gl.FLOAT,
	    buffer: buffer,
	    size: 3,
	    offset: 0,
	    stride: 28
	  }, {
	    type: gl.FLOAT,
	    buffer: buffer,
	    size: 3,
	    offset: 12,
	    stride: 28
	  }, {
	    type: gl.FLOAT,
	    buffer: buffer,
	    size: 1,
	    offset: 24,
	    stride: 28
	  }])
	
	  //Create shader
	  var shader = createShader(gl)
	  shader.attributes.position.location = 0
	  shader.attributes.color.location = 1
	  shader.attributes.weight.location = 2
	
	  //Create spike object
	  var spikes = new AxisSpikes(gl, buffer, vao, shader)
	
	  //Set parameters
	  spikes.update(options)
	
	  //Return resulting object
	  return spikes
	}
	
	},{"./shaders/index":311,"gl-buffer":243,"gl-vao":328}],313:[function(_dereq_,module,exports){
	var glslify       = _dereq_('glslify')
	
	var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"])
	var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"])
	var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"])
	var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
	
	exports.meshShader = {
	  vertex:   triVertSrc,
	  fragment: triFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec4'},
	    {name: 'color', type: 'vec4'},
	    {name: 'uv', type: 'vec2'},
	    {name: 'vector', type: 'vec4'}
	  ]
	}
	exports.pickShader = {
	  vertex:   pickVertSrc,
	  fragment: pickFragSrc,
	  attributes: [
	    {name: 'position', type: 'vec4'},
	    {name: 'id', type: 'vec4'},
	    {name: 'vector', type: 'vec4'}
	  ]
	}
	
	},{"glslify":410}],314:[function(_dereq_,module,exports){
	"use strict";
	
	var vec3 = _dereq_('gl-vec3');
	var vec4 = _dereq_('gl-vec4');
	var GRID_TYPES = ['xyz', 'xzy', 'yxz', 'yzx', 'zxy', 'zyx'];
	
	var streamToTube = function(stream, maxDivergence, minDistance, maxNorm) {
		var points = stream.points;
		var velocities = stream.velocities;
		var divergences = stream.divergences;
	
		var verts = [];
		var faces = [];
		var vectors = [];
		var previousVerts = [];
		var currentVerts = [];
		var intensities = [];
		var previousIntensity = 0;
		var currentIntensity = 0;
		var currentVector = vec4.create();
		var previousVector = vec4.create();
	
		var facets = 8;
	
		for (var i = 0; i < points.length; i++) {
			var p = points[i];
			var fwd = velocities[i];
			var r = divergences[i];
			if (maxDivergence === 0) {
				r = minDistance * 0.05;
			}
			currentIntensity = vec3.length(fwd) / maxNorm;
	
			currentVector = vec4.create();
			vec3.copy(currentVector, fwd);
			currentVector[3] = r;
	
			for (var a = 0; a < facets; a++) {
				currentVerts[a] = [p[0], p[1], p[2], a];
			}
			if (previousVerts.length > 0) {
				for (var a = 0; a < facets; a++) {
					var a1 = (a+1) % facets;
					verts.push(
						previousVerts[a],
						currentVerts[a],
						currentVerts[a1],
	
						currentVerts[a1],
						previousVerts[a1],
						previousVerts[a]
					);
					vectors.push(
						previousVector,
						currentVector,
						currentVector,
	
						currentVector,
						previousVector,
						previousVector
					);
					intensities.push(
						previousIntensity,
						currentIntensity,
						currentIntensity,
	
						currentIntensity,
						previousIntensity,
						previousIntensity
					);
	
					var len = verts.length;
					faces.push(
						[len-6, len-5, len-4],
						[len-3, len-2, len-1]
					);
				}
			}
			var tmp1 = previousVerts;
			previousVerts = currentVerts;
			currentVerts = tmp1;
	
			var tmp2 = previousVector;
			previousVector = currentVector;
			currentVector = tmp2;
	
			var tmp3 = previousIntensity;
			previousIntensity = currentIntensity;
			currentIntensity = tmp3;
		}
		return {
			positions: verts,
			cells: faces,
			vectors: vectors,
			vertexIntensity: intensities
		};
	};
	
	var createTubes = function(streams, colormap, maxDivergence, minDistance) {
	
		var maxNorm = 0;
		for (var i=0; i<streams.length; i++) {
			var velocities = streams[i].velocities;
			for (var j=0; j<velocities.length; j++) {
				maxNorm = Math.max(maxNorm,
					vec3.length(velocities[j])
				);
			}
		}
	
		var tubes = streams.map(function(s) {
			return streamToTube(s, maxDivergence, minDistance, maxNorm);
		});
	
		var positions = [];
		var cells = [];
		var vectors = [];
		var vertexIntensity = [];
		for (var i=0; i < tubes.length; i++) {
			var tube = tubes[i];
			var offset = positions.length;
			positions = positions.concat(tube.positions);
			vectors = vectors.concat(tube.vectors);
			vertexIntensity = vertexIntensity.concat(tube.vertexIntensity);
			for (var j=0; j<tube.cells.length; j++) {
				var cell = tube.cells[j];
				var newCell = [];
				cells.push(newCell);
				for (var k=0; k<cell.length; k++) {
					newCell.push(cell[k] + offset);
				}
			}
		}
		return {
			positions: positions,
			cells: cells,
			vectors: vectors,
			vertexIntensity: vertexIntensity,
			colormap: colormap
		};
	};
	
	var findLastSmallerIndex = function(points, v) {
	  var len = points.length;
	  var i;
	  for (i=0; i<len; i++) {
	  	var p = points[i];
	  	if (p === v) return i;
	    else if (p > v) return i-1;
	  }
	  return i;
	};
	
	var clamp = function(v, min, max) {
		return v < min ? min : (v > max ? max : v);
	};
	
	var sampleMeshgrid = function(point, vectorField, gridInfo) {
		var vectors = vectorField.vectors;
		var meshgrid = vectorField.meshgrid;
	
		var x = point[0];
		var y = point[1];
		var z = point[2];
	
		var w = meshgrid[0].length;
		var h = meshgrid[1].length;
		var d = meshgrid[2].length;
	
		// Find the index of the nearest smaller value in the meshgrid for each coordinate of (x,y,z).
		// The nearest smaller value index for x is the index x0 such that
		// meshgrid[0][x0] < x and for all x1 > x0, meshgrid[0][x1] >= x.
		var x0 = findLastSmallerIndex(meshgrid[0], x);
		var y0 = findLastSmallerIndex(meshgrid[1], y);
		var z0 = findLastSmallerIndex(meshgrid[2], z);
	
		// Get the nearest larger meshgrid value indices.
		// From the above "nearest smaller value", we know that
		//   meshgrid[0][x0] < x
		//   meshgrid[0][x0+1] >= x
		var x1 = x0 + 1;
		var y1 = y0 + 1;
		var z1 = z0 + 1;
	
		x0 = clamp(x0, 0, w-1);
		x1 = clamp(x1, 0, w-1);
		y0 = clamp(y0, 0, h-1);
		y1 = clamp(y1, 0, h-1);
		z0 = clamp(z0, 0, d-1);
		z1 = clamp(z1, 0, d-1);
	
		// Reject points outside the meshgrid, return a zero vector.
		if (x0 < 0 || y0 < 0 || z0 < 0 || x1 > w-1 || y1 > h-1 || z1 > d-1) {
			return vec3.create();
		}
	
		// Normalize point coordinates to 0..1 scaling factor between x0 and x1.
		var mX0 = meshgrid[0][x0];
		var mX1 = meshgrid[0][x1];
		var mY0 = meshgrid[1][y0];
		var mY1 = meshgrid[1][y1];
		var mZ0 = meshgrid[2][z0];
		var mZ1 = meshgrid[2][z1];
		var xf = (x - mX0) / (mX1 - mX0);
		var yf = (y - mY0) / (mY1 - mY0);
		var zf = (z - mZ0) / (mZ1 - mZ0);
	
		if (!isFinite(xf)) xf = 0.5;
		if (!isFinite(yf)) yf = 0.5;
		if (!isFinite(zf)) zf = 0.5;
	
		var x0off;
		var x1off;
		var y0off;
		var y1off;
		var z0off;
		var z1off;
	
		if(gridInfo.reversedX) {
			x0 = w - 1 - x0;
			x1 = w - 1 - x1;
		}
	
		if(gridInfo.reversedY) {
			y0 = h - 1 - y0;
			y1 = h - 1 - y1;
		}
	
		if(gridInfo.reversedZ) {
			z0 = d - 1 - z0;
			z1 = d - 1 - z1;
		}
	
		switch(gridInfo.filled) {
			case 5: // 'zyx'
				z0off = z0;
				z1off = z1;
				y0off = y0*d;
				y1off = y1*d;
				x0off = x0*d*h;
				x1off = x1*d*h;
				break;
	
			case 4: // 'zxy'
				z0off = z0;
				z1off = z1;
				x0off = x0*d;
				x1off = x1*d;
				y0off = y0*d*w;
				y1off = y1*d*w;
				break;
	
			case 3: // 'yzx'
				y0off = y0;
				y1off = y1;
				z0off = z0*h;
				z1off = z1*h;
				x0off = x0*h*d;
				x1off = x1*h*d;
				break;
	
			case 2: // 'yxz'
				y0off = y0;
				y1off = y1;
				x0off = x0*h;
				x1off = x1*h;
				z0off = z0*h*w;
				z1off = z1*h*w;
				break;
	
			case 1: // 'xzy'
				x0off = x0;
				x1off = x1;
				z0off = z0*w;
				z1off = z1*w;
				y0off = y0*w*d;
				y1off = y1*w*d;
				break;
	
			default: // case 0: // 'xyz'
				x0off = x0;
				x1off = x1;
				y0off = y0*w;
				y1off = y1*w;
				z0off = z0*w*h;
				z1off = z1*w*h;
				break;
		}
	
		// Sample data vectors around the (x,y,z) point.
		var v000 = vectors[x0off + y0off + z0off];
		var v001 = vectors[x0off + y0off + z1off];
		var v010 = vectors[x0off + y1off + z0off];
		var v011 = vectors[x0off + y1off + z1off];
		var v100 = vectors[x1off + y0off + z0off];
		var v101 = vectors[x1off + y0off + z1off];
		var v110 = vectors[x1off + y1off + z0off];
		var v111 = vectors[x1off + y1off + z1off];
	
		var c00 = vec3.create();
		var c01 = vec3.create();
		var c10 = vec3.create();
		var c11 = vec3.create();
	
		vec3.lerp(c00, v000, v100, xf);
		vec3.lerp(c01, v001, v101, xf);
		vec3.lerp(c10, v010, v110, xf);
		vec3.lerp(c11, v011, v111, xf);
	
		var c0 = vec3.create();
		var c1 = vec3.create();
	
		vec3.lerp(c0, c00, c10, yf);
		vec3.lerp(c1, c01, c11, yf);
	
		var c = vec3.create();
	
		vec3.lerp(c, c0, c1, zf);
	
		return c;
	};
	
	
	var vabs = function(dst, v) {
		var x = v[0];
		var y = v[1];
		var z = v[2];
		dst[0] = x < 0 ? -x : x;
		dst[1] = y < 0 ? -y : y;
		dst[2] = z < 0 ? -z : z;
		return dst;
	};
	
	var findMinSeparation = function(xs) {
		var minSeparation = Infinity;
		xs.sort(function(a, b) { return a - b; });
		var len = xs.length;
		for (var i=1; i<len; i++) {
			var d = Math.abs(xs[i] - xs[i-1]);
			if (d < minSeparation) {
				minSeparation = d;
			}
		}
		return minSeparation;
	};
	
	// Finds the minimum per-component distance in positions.
	//
	var calculateMinPositionDistance = function(positions) {
		var xs = [], ys = [], zs = [];
		var xi = {}, yi = {}, zi = {};
		var len = positions.length;
		for (var i=0; i<len; i++) {
			var p = positions[i];
			var x = p[0], y = p[1], z = p[2];
	
			// Split the positions array into arrays of unique component values.
			//
			// Why go through the trouble of using a uniqueness hash table vs
			// sort and uniq:
			//
			// Suppose you've got a million positions in a 100x100x100 grid.
			//
			// Using a uniqueness hash table, you're doing 1M array reads,
			// 3M hash table lookups from 100-element hashes, 300 hash table inserts, then
			// sorting three 100-element arrays and iterating over them.
			// Roughly, 1M + 3M * ln(100) + 300 * ln(100/2) + 3 * 100 * ln(100) + 3 * 100 =
			//          1M + 13.8M + 0.0012M +  0.0014M + 0.0003M
			//          =~ 15M
			//
			// Sort and uniq solution would do 1M array reads, 3M array inserts,
			// sort three 1M-element arrays and iterate over them.
			// Roughly, 1M + 3M + 3 * 1M * ln(1M) + 3 * 1M =
			//          1M + 3M + 41.4M + 3M
			//          =~ 48.4M
			//
			// Guessing that a hard-coded sort & uniq would be faster due to not having
			// to run a hashing function on everything. More memory usage though
			// (bunch of small hash tables vs. duplicating the input array.)
			//
			// In JS-land, who knows. Maybe xi[x] casts x to string and destroys perf,
			// maybe numeric keys get special-cased, maybe the object lookups run at near O(1)-speeds.
			// Maybe the sorting comparison function is expensive to call, maybe it gets inlined or special-cased.
			//
			// ... You're probably not going to call this with more than 10k positions anyhow, so this is very academic.
			//
			if (!xi[x]) {
				xs.push(x);
				xi[x] = true;
			}
			if (!yi[y]) {
				ys.push(y);
				yi[y] = true;
			}
			if (!zi[z]) {
				zs.push(z);
				zi[z] = true;
			}
		}
		var xSep = findMinSeparation(xs);
		var ySep = findMinSeparation(ys);
		var zSep = findMinSeparation(zs);
		var minSeparation = Math.min(xSep, ySep, zSep);
	
		return isFinite(minSeparation) ? minSeparation : 1;
	};
	
	module.exports = function(vectorField, bounds) {
		var positions = vectorField.startingPositions;
		var maxLength = vectorField.maxLength || 1000;
		var tubeSize = vectorField.tubeSize || 1;
		var absoluteTubeSize = vectorField.absoluteTubeSize;
		var gridFill = vectorField.gridFill || '+x+y+z';
	
		var gridInfo = {};
		if(gridFill.indexOf('-x') !== -1) { gridInfo.reversedX = true; }
		if(gridFill.indexOf('-y') !== -1) { gridInfo.reversedY = true; }
		if(gridFill.indexOf('-z') !== -1) { gridInfo.reversedZ = true; }
		gridInfo.filled = GRID_TYPES.indexOf(gridFill.replace(/-/g, '').replace(/\+/g, ''));
	
		var getVelocity = vectorField.getVelocity || function(p) {
			return sampleMeshgrid(p, vectorField, gridInfo);
		};
	
		var getDivergence = vectorField.getDivergence || function(p, v0) {
			var dp = vec3.create();
			var e = 0.0001;
	
			vec3.add(dp, p, [e, 0, 0]);
			var vx = getVelocity(dp);
			vec3.subtract(vx, vx, v0);
			vec3.scale(vx, vx, 1/e);
	
			vec3.add(dp, p, [0, e, 0]);
			var vy = getVelocity(dp);
			vec3.subtract(vy, vy, v0);
			vec3.scale(vy, vy, 1/e);
	
			vec3.add(dp, p, [0, 0, e]);
			var vz = getVelocity(dp);
			vec3.subtract(vz, vz, v0);
			vec3.scale(vz, vz, 1/e);
	
			vec3.add(dp, vx, vy);
			vec3.add(dp, dp, vz);
			return dp;
		};
	
		var streams = [];
	
		var minX = bounds[0][0], minY = bounds[0][1], minZ = bounds[0][2];
		var maxX = bounds[1][0], maxY = bounds[1][1], maxZ = bounds[1][2];
	
		var inBounds = function(p) {
			var x = p[0];
			var y = p[1];
			var z = p[2];
			return !(
				x < minX || x > maxX ||
				y < minY || y > maxY ||
				z < minZ || z > maxZ
			);
		};
	
		var boundsSize = vec3.distance(bounds[0], bounds[1]);
		var maxStepSize = 10 * boundsSize / maxLength;
		var maxStepSizeSq = maxStepSize * maxStepSize;
	
		var minDistance = 1;
		var maxDivergence = 0; // For component-wise divergence vec3.create();
	
		// In case we need to do component-wise divergence visualization
		// var tmp = vec3.create();
	
		var len = positions.length;
		if (len > 1) {
			minDistance = calculateMinPositionDistance(positions);
		}
	
		for (var i = 0; i < len; i++) {
			var p = vec3.create();
			vec3.copy(p, positions[i]);
	
			var stream = [p];
			var velocities = [];
			var v = getVelocity(p);
			var op = p;
			velocities.push(v);
	
			var divergences = [];
	
			var dv = getDivergence(p, v);
			var dvLength = vec3.length(dv);
			if (isFinite(dvLength) && dvLength > maxDivergence) {
				maxDivergence = dvLength;
			}
			// In case we need to do component-wise divergence visualization
			// vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
			divergences.push(dvLength);
	
			streams.push({points: stream, velocities: velocities, divergences: divergences});
	
			var j = 0;
	
			while (j < maxLength * 100 && stream.length < maxLength && inBounds(p)) {
				j++;
				var np = vec3.clone(v);
				var sqLen = vec3.squaredLength(np);
				if (sqLen === 0) {
					break;
				} else if (sqLen > maxStepSizeSq) {
					vec3.scale(np, np, maxStepSize / Math.sqrt(sqLen));
				}
				vec3.add(np, np, p);
	
				v = getVelocity(np);
	
				if (vec3.squaredDistance(op, np) - maxStepSizeSq > -0.0001 * maxStepSizeSq) {
					stream.push(np);
					op = np;
					velocities.push(v);
					var dv = getDivergence(np, v);
					var dvLength = vec3.length(dv);
					if (isFinite(dvLength) && dvLength > maxDivergence) {
						maxDivergence = dvLength;
					}
					// In case we need to do component-wise divergence visualization
					//vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
					divergences.push(dvLength);
				}
	
				p = np;
			}
		}
	
		var tubes = createTubes(streams, vectorField.colormap, maxDivergence, minDistance);
	
		if (absoluteTubeSize) {
			tubes.tubeScale = absoluteTubeSize;
		} else {
			// Avoid division by zero.
			if (maxDivergence === 0) {
				maxDivergence = 1;
			}
			tubes.tubeScale = tubeSize * 0.5 * minDistance / maxDivergence;
		}
	
		return tubes;
	};
	
	var shaders = _dereq_('./lib/shaders');
	var createMesh = _dereq_('gl-cone3d').createMesh;
	module.exports.createTubeMesh = function(gl, params) {
		return createMesh(gl, params, {
			shaders: shaders,
			traceType: 'streamtube'
		});
	}
	
	},{"./lib/shaders":313,"gl-cone3d":244,"gl-vec3":347,"gl-vec4":383}],315:[function(_dereq_,module,exports){
	var createShader = _dereq_('gl-shader')
	var glslify = _dereq_('glslify')
	
	var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"])
	var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color — in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"])
	var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"])
	var pickSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"])
	
	exports.createShader = function (gl) {
	  var shader = createShader(gl, vertSrc, fragSrc, null, [
	    {name: 'uv', type: 'vec4'},
	    {name: 'f', type: 'vec3'},
	    {name: 'normal', type: 'vec3'}
	  ])
	  shader.attributes.uv.location = 0
	  shader.attributes.f.location = 1
	  shader.attributes.normal.location = 2
	  return shader
	}
	exports.createPickShader = function (gl) {
	  var shader = createShader(gl, vertSrc, pickSrc, null, [
	    {name: 'uv', type: 'vec4'},
	    {name: 'f', type: 'vec3'},
	    {name: 'normal', type: 'vec3'}
	  ])
	  shader.attributes.uv.location = 0
	  shader.attributes.f.location = 1
	  shader.attributes.normal.location = 2
	  return shader
	}
	exports.createContourShader = function (gl) {
	  var shader = createShader(gl, contourVertSrc, fragSrc, null, [
	    {name: 'uv', type: 'vec4'},
	    {name: 'f', type: 'float'}
	  ])
	  shader.attributes.uv.location = 0
	  shader.attributes.f.location = 1
	  return shader
	}
	exports.createPickContourShader = function (gl) {
	  var shader = createShader(gl, contourVertSrc, pickSrc, null, [
	    {name: 'uv', type: 'vec4'},
	    {name: 'f', type: 'float'}
	  ])
	  shader.attributes.uv.location = 0
	  shader.attributes.f.location = 1
	  return shader
	}
	
	},{"gl-shader":303,"glslify":410}],316:[function(_dereq_,module,exports){
	arguments[4][112][0].apply(exports,arguments)
	},{"dup":112}],317:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createSurfacePlot
	
	var bits = _dereq_('bit-twiddle')
	var createBuffer = _dereq_('gl-buffer')
	var createVAO = _dereq_('gl-vao')
	var createTexture = _dereq_('gl-texture2d')
	var pool = _dereq_('typedarray-pool')
	var colormap = _dereq_('colormap')
	var ops = _dereq_('ndarray-ops')
	var pack = _dereq_('ndarray-pack')
	var ndarray = _dereq_('ndarray')
	var surfaceNets = _dereq_('surface-nets')
	var multiply = _dereq_('gl-mat4/multiply')
	var invert = _dereq_('gl-mat4/invert')
	var bsearch = _dereq_('binary-search-bounds')
	var gradient = _dereq_('ndarray-gradient')
	var shaders = _dereq_('./lib/shaders')
	
	var createShader = shaders.createShader
	var createContourShader = shaders.createContourShader
	var createPickShader = shaders.createPickShader
	var createPickContourShader = shaders.createPickContourShader
	
	var SURFACE_VERTEX_SIZE = 4 * (4 + 3 + 3)
	
	var IDENTITY = [
	  1, 0, 0, 0,
	  0, 1, 0, 0,
	  0, 0, 1, 0,
	  0, 0, 0, 1 ]
	
	var QUAD = [
	  [0, 0],
	  [0, 1],
	  [1, 0],
	  [1, 1],
	  [1, 0],
	  [0, 1]
	]
	
	var PERMUTATIONS = [
	  [0, 0, 0, 0, 0, 0, 0, 0, 0],
	  [0, 0, 0, 0, 0, 0, 0, 0, 0],
	  [0, 0, 0, 0, 0, 0, 0, 0, 0]
	]
	
	;(function () {
	  for (var i = 0; i < 3; ++i) {
	    var p = PERMUTATIONS[i]
	    var u = (i + 1) % 3
	    var v = (i + 2) % 3
	    p[u + 0] = 1
	    p[v + 3] = 1
	    p[i + 6] = 1
	  }
	})()
	
	function SurfacePickResult (position, index, uv, level, dataCoordinate) {
	  this.position = position
	  this.index = index
	  this.uv = uv
	  this.level = level
	  this.dataCoordinate = dataCoordinate
	}
	
	var N_COLORS = 256
	
	function genColormap (name) {
	  var x = pack([colormap({
	    colormap: name,
	    nshades: N_COLORS,
	    format: 'rgba'
	  }).map(function (c) {
	    return [c[0], c[1], c[2], 255 * c[3]]
	  })])
	  ops.divseq(x, 255.0)
	  return x
	}
	
	function SurfacePlot (
	  gl,
	  shape,
	  bounds,
	  shader,
	  pickShader,
	  coordinates,
	  vao,
	  colorMap,
	  contourShader,
	  contourPickShader,
	  contourBuffer,
	  contourVAO,
	  dynamicBuffer,
	  dynamicVAO,
	  objectOffset) {
	  this.gl = gl
	  this.shape = shape
	  this.bounds = bounds
	  this.objectOffset = objectOffset
	  this.intensityBounds = []
	
	  this._shader = shader
	  this._pickShader = pickShader
	  this._coordinateBuffer = coordinates
	  this._vao = vao
	  this._colorMap = colorMap
	
	  this._contourShader = contourShader
	  this._contourPickShader = contourPickShader
	  this._contourBuffer = contourBuffer
	  this._contourVAO = contourVAO
	  this._contourOffsets = [[], [], []]
	  this._contourCounts = [[], [], []]
	  this._vertexCount = 0
	
	  this._pickResult = new SurfacePickResult([0, 0, 0], [0, 0], [0, 0], [0, 0, 0], [0, 0, 0])
	
	  this._dynamicBuffer = dynamicBuffer
	  this._dynamicVAO = dynamicVAO
	  this._dynamicOffsets = [0, 0, 0]
	  this._dynamicCounts = [0, 0, 0]
	
	  this.contourWidth = [ 1, 1, 1 ]
	  this.contourLevels = [[1], [1], [1]]
	  this.contourTint = [0, 0, 0]
	  this.contourColor = [[0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1]]
	
	  this.showContour = true
	  this.showSurface = true
	
	  this.enableHighlight = [true, true, true]
	  this.highlightColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]
	  this.highlightTint = [ 1, 1, 1 ]
	  this.highlightLevel = [-1, -1, -1]
	
	  // Dynamic contour options
	  this.enableDynamic = [ true, true, true ]
	  this.dynamicLevel = [ NaN, NaN, NaN ]
	  this.dynamicColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ]
	  this.dynamicTint = [ 1, 1, 1 ]
	  this.dynamicWidth = [ 1, 1, 1 ]
	
	  this.axesBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]]
	  this.surfaceProject = [ false, false, false ]
	  this.contourProject = [[ false, false, false ],
	    [ false, false, false ],
	    [ false, false, false ]]
	
	  this.colorBounds = [ false, false ]
	
	  // Store xyz fields, need this for picking
	  this._field = [
	    ndarray(pool.mallocFloat(1024), [0, 0]),
	    ndarray(pool.mallocFloat(1024), [0, 0]),
	    ndarray(pool.mallocFloat(1024), [0, 0]) ]
	
	  this.pickId = 1
	  this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]]
	
	  this.snapToData = false
	
	  this.pixelRatio = 1
	
	  this.opacity = 1.0
	
	  this.lightPosition = [10, 10000, 0]
	  this.ambientLight = 0.8
	  this.diffuseLight = 0.8
	  this.specularLight = 2.0
	  this.roughness = 0.5
	  this.fresnel = 1.5
	  this.vertexColor = 0
	
	  this.dirty = true
	}
	
	var proto = SurfacePlot.prototype
	
	proto.isTransparent = function () {
	  return this.opacity < 1
	}
	
	proto.isOpaque = function () {
	  if (this.opacity >= 1) {
	    return true
	  }
	  for (var i = 0; i < 3; ++i) {
	    if (this._contourCounts[i].length > 0 || this._dynamicCounts[i] > 0) {
	      return true
	    }
	  }
	  return false
	}
	
	proto.pickSlots = 1
	
	proto.setPickBase = function (id) {
	  this.pickId = id
	}
	
	var ZERO_VEC = [0, 0, 0]
	
	var PROJECT_DATA = {
	  showSurface: false,
	  showContour: false,
	  projections: [IDENTITY.slice(), IDENTITY.slice(), IDENTITY.slice()],
	  clipBounds: [
	    [[0, 0, 0], [0, 0, 0]],
	    [[0, 0, 0], [0, 0, 0]],
	    [[0, 0, 0], [0, 0, 0]]]
	}
	
	function computeProjectionData (camera, obj) {
	  var i, j, k
	
	  // Compute cube properties
	  var cubeAxis = (obj.axes && obj.axes.lastCubeProps.axis) || ZERO_VEC
	
	  var showSurface = obj.showSurface
	  var showContour = obj.showContour
	
	  for (i = 0; i < 3; ++i) {
	    showSurface = showSurface || obj.surfaceProject[i]
	    for (j = 0; j < 3; ++j) {
	      showContour = showContour || obj.contourProject[i][j]
	    }
	  }
	
	  for (i = 0; i < 3; ++i) {
	    // Construct projection onto axis
	    var axisSquish = PROJECT_DATA.projections[i]
	    for (j = 0; j < 16; ++j) {
	      axisSquish[j] = 0
	    }
	    for (j = 0; j < 4; ++j) {
	      axisSquish[5 * j] = 1
	    }
	    axisSquish[5 * i] = 0
	    axisSquish[12 + i] = obj.axesBounds[+(cubeAxis[i] > 0)][i]
	    multiply(axisSquish, camera.model, axisSquish)
	
	    var nclipBounds = PROJECT_DATA.clipBounds[i]
	    for (k = 0; k < 2; ++k) {
	      for (j = 0; j < 3; ++j) {
	        nclipBounds[k][j] = camera.clipBounds[k][j]
	      }
	    }
	    nclipBounds[0][i] = -1e8
	    nclipBounds[1][i] = 1e8
	  }
	
	  PROJECT_DATA.showSurface = showSurface
	  PROJECT_DATA.showContour = showContour
	
	  return PROJECT_DATA
	}
	
	var UNIFORMS = {
	  model: IDENTITY,
	  view: IDENTITY,
	  projection: IDENTITY,
	  inverseModel: IDENTITY.slice(),
	  lowerBound: [0, 0, 0],
	  upperBound: [0, 0, 0],
	  colorMap: 0,
	  clipBounds: [[0, 0, 0], [0, 0, 0]],
	  height: 0.0,
	  contourTint: 0,
	  contourColor: [0, 0, 0, 1],
	  permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
	  zOffset: -1e-4,
	  objectOffset: [0, 0, 0],
	  kambient: 1,
	  kdiffuse: 1,
	  kspecular: 1,
	  lightPosition: [1000, 1000, 1000],
	  eyePosition: [0, 0, 0],
	  roughness: 1,
	  fresnel: 1,
	  opacity: 1,
	  vertexColor: 0
	}
	
	var MATRIX_INVERSE = IDENTITY.slice()
	var DEFAULT_PERM = [1, 0, 0, 0, 1, 0, 0, 0, 1]
	
	function drawCore (params, transparent) {
	  params = params || {}
	  var gl = this.gl
	
	  gl.disable(gl.CULL_FACE)
	
	  this._colorMap.bind(0)
	
	  var uniforms = UNIFORMS
	  uniforms.model = params.model || IDENTITY
	  uniforms.view = params.view || IDENTITY
	  uniforms.projection = params.projection || IDENTITY
	  uniforms.lowerBound = [this.bounds[0][0], this.bounds[0][1], this.colorBounds[0] || this.bounds[0][2]]
	  uniforms.upperBound = [this.bounds[1][0], this.bounds[1][1], this.colorBounds[1] || this.bounds[1][2]]
	  uniforms.objectOffset = this.objectOffset
	  uniforms.contourColor = this.contourColor[0]
	
	  uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
	
	  for (var i = 0; i < 2; ++i) {
	    var clipClamped = uniforms.clipBounds[i]
	    for (var j = 0; j < 3; ++j) {
	      clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8)
	    }
	  }
	
	  uniforms.kambient = this.ambientLight
	  uniforms.kdiffuse = this.diffuseLight
	  uniforms.kspecular = this.specularLight
	
	  uniforms.roughness = this.roughness
	  uniforms.fresnel = this.fresnel
	  uniforms.opacity = this.opacity
	
	  uniforms.height = 0.0
	  uniforms.permutation = DEFAULT_PERM
	
	  uniforms.vertexColor = this.vertexColor
	
	  // Compute camera matrix inverse
	  var invCameraMatrix = MATRIX_INVERSE
	  multiply(invCameraMatrix, uniforms.view, uniforms.model)
	  multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
	  invert(invCameraMatrix, invCameraMatrix)
	
	  for (i = 0; i < 3; ++i) {
	    uniforms.eyePosition[i] = invCameraMatrix[12 + i] / invCameraMatrix[15]
	  }
	
	  var w = invCameraMatrix[15]
	  for (i = 0; i < 3; ++i) {
	    w += this.lightPosition[i] * invCameraMatrix[4 * i + 3]
	  }
	  for (i = 0; i < 3; ++i) {
	    var s = invCameraMatrix[12 + i]
	    for (j = 0; j < 3; ++j) {
	      s += invCameraMatrix[4 * j + i] * this.lightPosition[j]
	    }
	    uniforms.lightPosition[i] = s / w
	  }
	
	  var projectData = computeProjectionData(uniforms, this)
	
	  if (projectData.showSurface && (transparent === (this.opacity < 1))) {
	    // Set up uniforms
	    this._shader.bind()
	    this._shader.uniforms = uniforms
	
	    // Draw it
	    this._vao.bind()
	
	    if (this.showSurface && this._vertexCount) {
	      this._vao.draw(gl.TRIANGLES, this._vertexCount)
	    }
	
	    // Draw projections of surface
	    for (i = 0; i < 3; ++i) {
	      if (!this.surfaceProject[i] || !this.vertexCount) {
	        continue
	      }
	      this._shader.uniforms.model = projectData.projections[i]
	      this._shader.uniforms.clipBounds = projectData.clipBounds[i]
	      this._vao.draw(gl.TRIANGLES, this._vertexCount)
	    }
	
	    this._vao.unbind()
	  }
	
	  if (projectData.showContour && !transparent) {
	    var shader = this._contourShader
	
	    // Don't apply lighting to contours
	    uniforms.kambient = 1.0
	    uniforms.kdiffuse = 0.0
	    uniforms.kspecular = 0.0
	    uniforms.opacity = 1.0
	
	    shader.bind()
	    shader.uniforms = uniforms
	
	    // Draw contour lines
	    var vao = this._contourVAO
	    vao.bind()
	
	    // Draw contour levels
	    for (i = 0; i < 3; ++i) {
	      shader.uniforms.permutation = PERMUTATIONS[i]
	      gl.lineWidth(this.contourWidth[i] * this.pixelRatio)
	
	      for (j = 0; j < this.contourLevels[i].length; ++j) {
	        if (j === this.highlightLevel[i]) {
	          shader.uniforms.contourColor = this.highlightColor[i]
	          shader.uniforms.contourTint = this.highlightTint[i]
	        } else if (j === 0 || (j - 1) === this.highlightLevel[i]) {
	          shader.uniforms.contourColor = this.contourColor[i]
	          shader.uniforms.contourTint = this.contourTint[i]
	        }
	        if (!this._contourCounts[i][j]) {
	          continue
	        }
	
	        shader.uniforms.height = this.contourLevels[i][j]
	        vao.draw(gl.LINES, this._contourCounts[i][j], this._contourOffsets[i][j])
	      }
	    }
	
	    // Draw projections of surface
	    for (i = 0; i < 3; ++i) {
	      shader.uniforms.model = projectData.projections[i]
	      shader.uniforms.clipBounds = projectData.clipBounds[i]
	      for (j = 0; j < 3; ++j) {
	        if (!this.contourProject[i][j]) {
	          continue
	        }
	        shader.uniforms.permutation = PERMUTATIONS[j]
	        gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
	        for (var k = 0; k < this.contourLevels[j].length; ++k) {
	          if (k === this.highlightLevel[j]) {
	            shader.uniforms.contourColor = this.highlightColor[j]
	            shader.uniforms.contourTint = this.highlightTint[j]
	          } else if (k === 0 || (k - 1) === this.highlightLevel[j]) {
	            shader.uniforms.contourColor = this.contourColor[j]
	            shader.uniforms.contourTint = this.contourTint[j]
	          }
	          if (!this._contourCounts[j][k]) {
	            continue
	          }
	
	          shader.uniforms.height = this.contourLevels[j][k]
	          vao.draw(gl.LINES, this._contourCounts[j][k], this._contourOffsets[j][k])
	        }
	      }
	    }
	
	    vao.unbind()
	
	    // Draw dynamic contours
	    vao = this._dynamicVAO
	    vao.bind()
	
	    // Draw contour levels
	    for (i = 0; i < 3; ++i) {
	      if (this._dynamicCounts[i] === 0) {
	        continue
	      }
	
	      shader.uniforms.model = uniforms.model
	      shader.uniforms.clipBounds = uniforms.clipBounds
	      shader.uniforms.permutation = PERMUTATIONS[i]
	      gl.lineWidth(this.dynamicWidth[i] * this.pixelRatio)
	
	      shader.uniforms.contourColor = this.dynamicColor[i]
	      shader.uniforms.contourTint = this.dynamicTint[i]
	      shader.uniforms.height = this.dynamicLevel[i]
	      vao.draw(gl.LINES, this._dynamicCounts[i], this._dynamicOffsets[i])
	
	      for (j = 0; j < 3; ++j) {
	        if (!this.contourProject[j][i]) {
	          continue
	        }
	
	        shader.uniforms.model = projectData.projections[j]
	        shader.uniforms.clipBounds = projectData.clipBounds[j]
	        vao.draw(gl.LINES, this._dynamicCounts[i], this._dynamicOffsets[i])
	      }
	    }
	
	    vao.unbind()
	  }
	}
	
	proto.draw = function (params) {
	  return drawCore.call(this, params, false)
	}
	
	proto.drawTransparent = function (params) {
	  return drawCore.call(this, params, true)
	}
	
	var PICK_UNIFORMS = {
	  model: IDENTITY,
	  view: IDENTITY,
	  projection: IDENTITY,
	  inverseModel: IDENTITY,
	  clipBounds: [[0, 0, 0], [0, 0, 0]],
	  height: 0.0,
	  shape: [0, 0],
	  pickId: 0,
	  lowerBound: [0, 0, 0],
	  upperBound: [0, 0, 0],
	  zOffset: 0.0,
	  objectOffset: [0, 0, 0],
	  permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
	  lightPosition: [0, 0, 0],
	  eyePosition: [0, 0, 0]
	}
	
	proto.drawPick = function (params) {
	  params = params || {}
	  var gl = this.gl
	  gl.disable(gl.CULL_FACE)
	
	  var uniforms = PICK_UNIFORMS
	  uniforms.model = params.model || IDENTITY
	  uniforms.view = params.view || IDENTITY
	  uniforms.projection = params.projection || IDENTITY
	  uniforms.shape = this._field[2].shape
	  uniforms.pickId = this.pickId / 255.0
	  uniforms.lowerBound = this.bounds[0]
	  uniforms.upperBound = this.bounds[1]
	  uniforms.objectOffset = this.objectOffset
	  uniforms.permutation = DEFAULT_PERM
	
	  for (var i = 0; i < 2; ++i) {
	    var clipClamped = uniforms.clipBounds[i]
	    for (var j = 0; j < 3; ++j) {
	      clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8)
	    }
	  }
	
	  var projectData = computeProjectionData(uniforms, this)
	
	  if (projectData.showSurface) {
	    // Set up uniforms
	    this._pickShader.bind()
	    this._pickShader.uniforms = uniforms
	
	    // Draw it
	    this._vao.bind()
	    this._vao.draw(gl.TRIANGLES, this._vertexCount)
	
	    // Draw projections of surface
	    for (i = 0; i < 3; ++i) {
	      if (!this.surfaceProject[i]) {
	        continue
	      }
	      this._pickShader.uniforms.model = projectData.projections[i]
	      this._pickShader.uniforms.clipBounds = projectData.clipBounds[i]
	      this._vao.draw(gl.TRIANGLES, this._vertexCount)
	    }
	
	    this._vao.unbind()
	  }
	
	  if (projectData.showContour) {
	    var shader = this._contourPickShader
	
	    shader.bind()
	    shader.uniforms = uniforms
	
	    var vao = this._contourVAO
	    vao.bind()
	
	    for (j = 0; j < 3; ++j) {
	      gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
	      shader.uniforms.permutation = PERMUTATIONS[j]
	      for (i = 0; i < this.contourLevels[j].length; ++i) {
	        if (this._contourCounts[j][i]) {
	          shader.uniforms.height = this.contourLevels[j][i]
	          vao.draw(gl.LINES, this._contourCounts[j][i], this._contourOffsets[j][i])
	        }
	      }
	    }
	
	    // Draw projections of surface
	    for (i = 0; i < 3; ++i) {
	      shader.uniforms.model = projectData.projections[i]
	      shader.uniforms.clipBounds = projectData.clipBounds[i]
	
	      for (j = 0; j < 3; ++j) {
	        if (!this.contourProject[i][j]) {
	          continue
	        }
	
	        shader.uniforms.permutation = PERMUTATIONS[j]
	        gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
	        for (var k = 0; k < this.contourLevels[j].length; ++k) {
	          if (this._contourCounts[j][k]) {
	            shader.uniforms.height = this.contourLevels[j][k]
	            vao.draw(gl.LINES, this._contourCounts[j][k], this._contourOffsets[j][k])
	          }
	        }
	      }
	    }
	
	    vao.unbind()
	  }
	}
	
	proto.pick = function (selection) {
	  if (!selection) {
	    return null
	  }
	
	  if (selection.id !== this.pickId) {
	    return null
	  }
	
	  var shape = this._field[2].shape
	
	  var result = this._pickResult
	
	  // Compute uv coordinate
	  var x = shape[0] * (selection.value[0] + (selection.value[2] >> 4) / 16.0) / 255.0
	  var ix = Math.floor(x)
	  var fx = x - ix
	
	  var y = shape[1] * (selection.value[1] + (selection.value[2] & 15) / 16.0) / 255.0
	  var iy = Math.floor(y)
	  var fy = y - iy
	
	  ix += 1
	  iy += 1
	
	  // Compute xyz coordinate
	  var pos = result.position
	  pos[0] = pos[1] = pos[2] = 0
	  for (var dx = 0; dx < 2; ++dx) {
	    var s = dx ? fx : 1.0 - fx
	    for (var dy = 0; dy < 2; ++dy) {
	      var t = dy ? fy : 1.0 - fy
	
	      var r = ix + dx
	      var c = iy + dy
	      var w = s * t
	
	      for (var i = 0; i < 3; ++i) {
	        pos[i] += this._field[i].get(r, c) * w
	      }
	    }
	  }
	
	  // Find closest level
	  var levelIndex = this._pickResult.level
	  for (var j = 0; j < 3; ++j) {
	    levelIndex[j] = bsearch.le(this.contourLevels[j], pos[j])
	    if (levelIndex[j] < 0) {
	      if (this.contourLevels[j].length > 0) {
	        levelIndex[j] = 0
	      }
	    } else if (levelIndex[j] < this.contourLevels[j].length - 1) {
	      var a = this.contourLevels[j][levelIndex[j]]
	      var b = this.contourLevels[j][levelIndex[j] + 1]
	      if (Math.abs(a - pos[j]) > Math.abs(b - pos[j])) {
	        levelIndex[j] += 1
	      }
	    }
	  }
	
	  result.index[0] = fx < 0.5 ? ix : (ix + 1)
	  result.index[1] = fy < 0.5 ? iy : (iy + 1)
	
	  result.uv[0] = x / shape[0]
	  result.uv[1] = y / shape[1]
	
	  for (i = 0; i < 3; ++i) {
	    result.dataCoordinate[i] = this._field[i].get(result.index[0], result.index[1])
	  }
	
	  return result
	}
	
	proto.padField = function(dstField, srcField) {
	  var srcShape = srcField.shape.slice()
	  var dstShape = dstField.shape.slice()
	
	  // Center
	  ops.assign(dstField.lo(1, 1).hi(srcShape[0], srcShape[1]), srcField)
	
	  // Edges
	  ops.assign(dstField.lo(1).hi(srcShape[0], 1),
	    srcField.hi(srcShape[0], 1))
	  ops.assign(dstField.lo(1, dstShape[1] - 1).hi(srcShape[0], 1),
	    srcField.lo(0, srcShape[1] - 1).hi(srcShape[0], 1))
	  ops.assign(dstField.lo(0, 1).hi(1, srcShape[1]),
	    srcField.hi(1))
	  ops.assign(dstField.lo(dstShape[0] - 1, 1).hi(1, srcShape[1]),
	    srcField.lo(srcShape[0] - 1))
	  // Corners
	  dstField.set(0, 0, srcField.get(0, 0))
	  dstField.set(0, dstShape[1] - 1, srcField.get(0, srcShape[1] - 1))
	  dstField.set(dstShape[0] - 1, 0, srcField.get(srcShape[0] - 1, 0))
	  dstField.set(dstShape[0] - 1, dstShape[1] - 1, srcField.get(srcShape[0] - 1, srcShape[1] - 1))
	}
	
	function handleArray (param, ctor) {
	  if (Array.isArray(param)) {
	    return [ ctor(param[0]), ctor(param[1]), ctor(param[2]) ]
	  }
	  return [ ctor(param), ctor(param), ctor(param) ]
	}
	
	function toColor (x) {
	  if (Array.isArray(x)) {
	    if (x.length === 3) {
	      return [x[0], x[1], x[2], 1]
	    }
	    return [x[0], x[1], x[2], x[3]]
	  }
	  return [0, 0, 0, 1]
	}
	
	function handleColor (param) {
	  if (Array.isArray(param)) {
	    if (Array.isArray(param)) {
	      return [
	        toColor(param[0]),
	        toColor(param[1]),
	        toColor(param[2]) ]
	    } else {
	      var c = toColor(param)
	      return [
	        c.slice(),
	        c.slice(),
	        c.slice() ]
	    }
	  }
	}
	
	proto.update = function (params) {
	  params = params || {}
	
	  this.objectOffset = params.objectOffset || this.objectOffset
	
	  this.dirty = true
	
	  if ('contourWidth' in params) {
	    this.contourWidth = handleArray(params.contourWidth, Number)
	  }
	  if ('showContour' in params) {
	    this.showContour = handleArray(params.showContour, Boolean)
	  }
	  if ('showSurface' in params) {
	    this.showSurface = !!params.showSurface
	  }
	  if ('contourTint' in params) {
	    this.contourTint = handleArray(params.contourTint, Boolean)
	  }
	  if ('contourColor' in params) {
	    this.contourColor = handleColor(params.contourColor)
	  }
	  if ('contourProject' in params) {
	    this.contourProject = handleArray(params.contourProject, function (x) {
	      return handleArray(x, Boolean)
	    })
	  }
	  if ('surfaceProject' in params) {
	    this.surfaceProject = params.surfaceProject
	  }
	  if ('dynamicColor' in params) {
	    this.dynamicColor = handleColor(params.dynamicColor)
	  }
	  if ('dynamicTint' in params) {
	    this.dynamicTint = handleArray(params.dynamicTint, Number)
	  }
	  if ('dynamicWidth' in params) {
	    this.dynamicWidth = handleArray(params.dynamicWidth, Number)
	  }
	  if ('opacity' in params) {
	    this.opacity = params.opacity
	  }
	  if ('colorBounds' in params) {
	    this.colorBounds = params.colorBounds
	  }
	  if ('vertexColor' in params) {
	    this.vertexColor = params.vertexColor ? 1 : 0;
	  }
	
	  var field = params.field || (params.coords && params.coords[2]) || null
	  var levelsChanged = false
	
	  if (!field) {
	    if (this._field[2].shape[0] || this._field[2].shape[2]) {
	      field = this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2)
	    } else {
	      field = this._field[2].hi(0, 0)
	    }
	  }
	
	  // Update field
	  if ('field' in params || 'coords' in params) {
	    var fsize = (field.shape[0] + 2) * (field.shape[1] + 2)
	
	    // Resize if necessary
	    if (fsize > this._field[2].data.length) {
	      pool.freeFloat(this._field[2].data)
	      this._field[2].data = pool.mallocFloat(bits.nextPow2(fsize))
	    }
	
	    // Pad field
	    this._field[2] = ndarray(this._field[2].data, [field.shape[0] + 2, field.shape[1] + 2])
	    this.padField(this._field[2], field)
	
	    // Save shape of field
	    this.shape = field.shape.slice()
	    var shape = this.shape
	
	    // Resize coordinate fields if necessary
	    for (var i = 0; i < 2; ++i) {
	      if (this._field[2].size > this._field[i].data.length) {
	        pool.freeFloat(this._field[i].data)
	        this._field[i].data = pool.mallocFloat(this._field[2].size)
	      }
	      this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2])
	    }
	
	    // Generate x/y coordinates
	    if (params.coords) {
	      var coords = params.coords
	      if (!Array.isArray(coords) || coords.length !== 3) {
	        throw new Error('gl-surface: invalid coordinates for x/y')
	      }
	      for (i = 0; i < 2; ++i) {
	        var coord = coords[i]
	        for (j = 0; j < 2; ++j) {
	          if (coord.shape[j] !== shape[j]) {
	            throw new Error('gl-surface: coords have incorrect shape')
	          }
	        }
	        this.padField(this._field[i], coord)
	      }
	    } else if (params.ticks) {
	      var ticks = params.ticks
	      if (!Array.isArray(ticks) || ticks.length !== 2) {
	        throw new Error('gl-surface: invalid ticks')
	      }
	      for (i = 0; i < 2; ++i) {
	        var tick = ticks[i]
	        if (Array.isArray(tick) || tick.length) {
	          tick = ndarray(tick)
	        }
	        if (tick.shape[0] !== shape[i]) {
	          throw new Error('gl-surface: invalid tick length')
	        }
	        // Make a copy view of the tick array
	        var tick2 = ndarray(tick.data, shape)
	        tick2.stride[i] = tick.stride[0]
	        tick2.stride[i ^ 1] = 0
	
	        // Fill in field array
	        this.padField(this._field[i], tick2)
	      }
	    } else {
	      for (i = 0; i < 2; ++i) {
	        var offset = [0, 0]
	        offset[i] = 1
	        this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2], offset, 0)
	      }
	      this._field[0].set(0, 0, 0)
	      for (var j = 0; j < shape[0]; ++j) {
	        this._field[0].set(j + 1, 0, j)
	      }
	      this._field[0].set(shape[0] + 1, 0, shape[0] - 1)
	      this._field[1].set(0, 0, 0)
	      for (j = 0; j < shape[1]; ++j) {
	        this._field[1].set(0, j + 1, j)
	      }
	      this._field[1].set(0, shape[1] + 1, shape[1] - 1)
	    }
	
	    // Save shape
	    var fields = this._field
	
	    // Compute surface normals
	    var dfields = ndarray(pool.mallocFloat(fields[2].size * 3 * 2), [3, shape[0] + 2, shape[1] + 2, 2])
	    for (i = 0; i < 3; ++i) {
	      gradient(dfields.pick(i), fields[i], 'mirror')
	    }
	    var normals = ndarray(pool.mallocFloat(fields[2].size * 3), [shape[0] + 2, shape[1] + 2, 3])
	    for (i = 0; i < shape[0] + 2; ++i) {
	      for (j = 0; j < shape[1] + 2; ++j) {
	        var dxdu = dfields.get(0, i, j, 0)
	        var dxdv = dfields.get(0, i, j, 1)
	        var dydu = dfields.get(1, i, j, 0)
	        var dydv = dfields.get(1, i, j, 1)
	        var dzdu = dfields.get(2, i, j, 0)
	        var dzdv = dfields.get(2, i, j, 1)
	
	        var nx = dydu * dzdv - dydv * dzdu
	        var ny = dzdu * dxdv - dzdv * dxdu
	        var nz = dxdu * dydv - dxdv * dydu
	
	        var nl = Math.sqrt(nx * nx + ny * ny + nz * nz)
	        if (nl < 1e-8) {
	          nl = Math.max(Math.abs(nx), Math.abs(ny), Math.abs(nz))
	          if (nl < 1e-8) {
	            nz = 1.0
	            ny = nx = 0.0
	            nl = 1.0
	          } else {
	            nl = 1.0 / nl
	          }
	        } else {
	          nl = 1.0 / Math.sqrt(nl)
	        }
	
	        normals.set(i, j, 0, nx * nl)
	        normals.set(i, j, 1, ny * nl)
	        normals.set(i, j, 2, nz * nl)
	      }
	    }
	    pool.free(dfields.data)
	
	    // Initialize surface
	    var lo = [ Infinity, Infinity, Infinity ]
	    var hi = [ -Infinity, -Infinity, -Infinity ]
	    var lo_intensity = Infinity
	    var hi_intensity = -Infinity
	    var count = (shape[0] - 1) * (shape[1] - 1) * 6
	    var tverts = pool.mallocFloat(bits.nextPow2(10 * count))
	    var tptr = 0
	    var vertexCount = 0
	    for (i = 0; i < shape[0] - 1; ++i) {
	      j_loop:
	      for (j = 0; j < shape[1] - 1; ++j) {
	        // Test for NaNs
	        for (var dx = 0; dx < 2; ++dx) {
	          for (var dy = 0; dy < 2; ++dy) {
	            for (var k = 0; k < 3; ++k) {
	              var f = this._field[k].get(1 + i + dx, 1 + j + dy)
	              if (isNaN(f) || !isFinite(f)) {
	                continue j_loop
	              }
	            }
	          }
	        }
	        for (k = 0; k < 6; ++k) {
	          var r = i + QUAD[k][0]
	          var c = j + QUAD[k][1]
	
	          var tx = this._field[0].get(r + 1, c + 1)
	          var ty = this._field[1].get(r + 1, c + 1)
	          f =      this._field[2].get(r + 1, c + 1)
	
	          nx = normals.get(r + 1, c + 1, 0)
	          ny = normals.get(r + 1, c + 1, 1)
	          nz = normals.get(r + 1, c + 1, 2)
	
	          if (params.intensity) {
	            vf = params.intensity.get(r, c)
	          }
	
	          var vf = (params.intensity) ?
	            params.intensity.get(r, c) :
	            f + this.objectOffset[2];
	
	          tverts[tptr++] = r
	          tverts[tptr++] = c
	          tverts[tptr++] = tx
	          tverts[tptr++] = ty
	          tverts[tptr++] = f
	          tverts[tptr++] = 0
	          tverts[tptr++] = vf
	          tverts[tptr++] = nx
	          tverts[tptr++] = ny
	          tverts[tptr++] = nz
	
	          lo[0] = Math.min(lo[0], tx + this.objectOffset[0])
	          lo[1] = Math.min(lo[1], ty + this.objectOffset[1])
	          lo[2] = Math.min(lo[2], f  + this.objectOffset[2])
	          lo_intensity = Math.min(lo_intensity, vf)
	
	          hi[0] = Math.max(hi[0], tx + this.objectOffset[0])
	          hi[1] = Math.max(hi[1], ty + this.objectOffset[1])
	          hi[2] = Math.max(hi[2], f  + this.objectOffset[2])
	          hi_intensity = Math.max(hi_intensity, vf)
	
	          vertexCount += 1
	        }
	      }
	    }
	
	    if (params.intensityBounds) {
	      lo_intensity = +params.intensityBounds[0]
	      hi_intensity = +params.intensityBounds[1]
	    }
	
	    // Scale all vertex intensities
	    for (i = 6; i < tptr; i += 10) {
	      tverts[i] = (tverts[i] - lo_intensity) / (hi_intensity - lo_intensity)
	    }
	
	    this._vertexCount = vertexCount
	    this._coordinateBuffer.update(tverts.subarray(0, tptr))
	    pool.freeFloat(tverts)
	    pool.free(normals.data)
	
	    // Update bounds
	    this.bounds = [lo, hi]
	
	    // Save intensity
	    this.intensity = params.intensity || this._field[2]
	
	    if(this.intensityBounds[0] !== lo_intensity || this.intensityBounds[1] !== hi_intensity) {
	        levelsChanged = true
	    }
	
	    // Save intensity bound
	    this.intensityBounds = [lo_intensity, hi_intensity]
	  }
	
	  // Update level crossings
	  if ('levels' in params) {
	    var levels = params.levels
	    if (!Array.isArray(levels[0])) {
	      levels = [ [], [], levels ]
	    } else {
	      levels = levels.slice()
	    }
	    for (i = 0; i < 3; ++i) {
	      levels[i] = levels[i].slice()
	      levels[i].sort(function (a, b) {
	        return a - b
	      })
	    }
	    for (i = 0; i < 3; ++i) {
	      for (j = 0; j < levels[i].length; ++j) {
	        levels[i][j] -= this.objectOffset[i]
	      }
	    }
	    change_test:
	    for (i = 0; i < 3; ++i) {
	      if (levels[i].length !== this.contourLevels[i].length) {
	        levelsChanged = true
	        break
	      }
	      for (j = 0; j < levels[i].length; ++j) {
	        if (levels[i][j] !== this.contourLevels[i][j]) {
	          levelsChanged = true
	          break change_test
	        }
	      }
	    }
	    this.contourLevels = levels
	  }
	
	  if (levelsChanged) {
	    fields = this._field
	    shape = this.shape
	
	    // Update contour lines
	    var contourVerts = []
	
	    for (var dim = 0; dim < 3; ++dim) {
	      var contourLevel = this.contourLevels[dim]
	
	      var levelOffsets = []
	      var levelCounts = []
	
	      var parts = [0, 0, 0]
	
	      for (i = 0; i < contourLevel.length; ++i) {
	        var graph = surfaceNets(this._field[dim], contourLevel[i])
	
	        levelOffsets.push((contourVerts.length / 5) | 0)
	        vertexCount = 0
	
	        edge_loop:
	        for (j = 0; j < graph.cells.length; ++j) {
	          var e = graph.cells[j]
	          for (k = 0; k < 2; ++k) {
	            var p = graph.positions[e[k]]
	
	            var x = p[0]
	            var ix = Math.floor(x) | 0
	            var fx = x - ix
	
	            var y = p[1]
	            var iy = Math.floor(y) | 0
	            var fy = y - iy
	
	            var hole = false
	            axis_loop:
	            for (var axis = 0; axis < 3; ++axis) {
	              parts[axis] = 0.0
	              var iu = (dim + axis + 1) % 3
	              for (dx = 0; dx < 2; ++dx) {
	                var s = dx ? fx : 1.0 - fx
	                r = Math.min(Math.max(ix + dx, 0), shape[0]) | 0
	                for (dy = 0; dy < 2; ++dy) {
	                  var t = dy ? fy : 1.0 - fy
	                  c = Math.min(Math.max(iy + dy, 0), shape[1]) | 0
	
	                  if (axis < 2) {
	                    f = this._field[iu].get(r, c)
	                  } else {
	                    f = (this.intensity.get(r, c) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0])
	                  }
	                  if (!isFinite(f) || isNaN(f)) {
	                    hole = true
	                    break axis_loop
	                  }
	
	                  var w = s * t
	                  parts[axis] += w * f
	                }
	              }
	            }
	
	            if (!hole) {
	              contourVerts.push(
	                parts[0],
	                parts[1],
	                p[0],
	                p[1],
	                parts[2]
	              )
	              vertexCount += 1
	            } else {
	              if (k > 0) {
	                // If we already added first edge, pop off verts
	                for (var l = 0; l < 5; ++l) {
	                  contourVerts.pop()
	                }
	                vertexCount -= 1
	              }
	              continue edge_loop
	            }
	          }
	        }
	        levelCounts.push(vertexCount)
	      }
	
	      // Store results
	      this._contourOffsets[dim] = levelOffsets
	      this._contourCounts[dim] = levelCounts
	
	    }
	
	    var floatBuffer = pool.mallocFloat(contourVerts.length)
	    for (i = 0; i < contourVerts.length; ++i) {
	      floatBuffer[i] = contourVerts[i]
	    }
	    this._contourBuffer.update(floatBuffer)
	    pool.freeFloat(floatBuffer)
	  }
	
	  if (params.colormap) {
	    this._colorMap.setPixels(genColormap(params.colormap))
	  }
	}
	
	proto.dispose = function () {
	  this._shader.dispose()
	  this._vao.dispose()
	  this._coordinateBuffer.dispose()
	  this._colorMap.dispose()
	  this._contourBuffer.dispose()
	  this._contourVAO.dispose()
	  this._contourShader.dispose()
	  this._contourPickShader.dispose()
	  this._dynamicBuffer.dispose()
	  this._dynamicVAO.dispose()
	  for (var i = 0; i < 3; ++i) {
	    pool.freeFloat(this._field[i].data)
	  }
	}
	
	proto.highlight = function (selection) {
	  var i
	
	  if (!selection) {
	    this._dynamicCounts = [0, 0, 0]
	    this.dyanamicLevel = [NaN, NaN, NaN]
	    this.highlightLevel = [-1, -1, -1]
	    return
	  }
	
	  for (i = 0; i < 3; ++i) {
	    if (this.enableHighlight[i]) {
	      this.highlightLevel[i] = selection.level[i]
	    } else {
	      this.highlightLevel[i] = -1
	    }
	  }
	
	  var levels
	  if (this.snapToData) {
	    levels = selection.dataCoordinate
	  } else {
	    levels = selection.position
	  }
	  for (i = 0; i < 3; ++i) {
	    levels[i] -= this.objectOffset[i]
	  }
	  if ((!this.enableDynamic[0] || levels[0] === this.dynamicLevel[0]) &&
	    (!this.enableDynamic[1] || levels[1] === this.dynamicLevel[1]) &&
	    (!this.enableDynamic[2] || levels[2] === this.dynamicLevel[2])) {
	    return
	  }
	
	  var vertexCount = 0
	  var shape = this.shape
	  var scratchBuffer = pool.mallocFloat(12 * shape[0] * shape[1])
	
	  for (var d = 0; d < 3; ++d) {
	    if (!this.enableDynamic[d]) {
	      this.dynamicLevel[d] = NaN
	      this._dynamicCounts[d] = 0
	      continue
	    }
	
	    this.dynamicLevel[d] = levels[d]
	
	    var u = (d + 1) % 3
	    var v = (d + 2) % 3
	
	    var f = this._field[d]
	    var g = this._field[u]
	    var h = this._field[v]
	
	    var graph = surfaceNets(f, levels[d])
	    var edges = graph.cells
	    var positions = graph.positions
	
	    this._dynamicOffsets[d] = vertexCount
	
	    for (i = 0; i < edges.length; ++i) {
	      var e = edges[i]
	      for (var j = 0; j < 2; ++j) {
	        var p = positions[e[j]]
	
	        var x = +p[0]
	        var ix = x | 0
	        var jx = Math.min(ix + 1, shape[0]) | 0
	        var fx = x - ix
	        var hx = 1.0 - fx
	
	        var y = +p[1]
	        var iy = y | 0
	        var jy = Math.min(iy + 1, shape[1]) | 0
	        var fy = y - iy
	        var hy = 1.0 - fy
	
	        var w00 = hx * hy
	        var w01 = hx * fy
	        var w10 = fx * hy
	        var w11 = fx * fy
	
	        var cu = w00 * g.get(ix, iy) +
	          w01 * g.get(ix, jy) +
	          w10 * g.get(jx, iy) +
	          w11 * g.get(jx, jy)
	
	        var cv = w00 * h.get(ix, iy) +
	          w01 * h.get(ix, jy) +
	          w10 * h.get(jx, iy) +
	          w11 * h.get(jx, jy)
	
	        if (isNaN(cu) || isNaN(cv)) {
	          if (j) {
	            vertexCount -= 1
	          }
	          break
	        }
	
	        scratchBuffer[2 * vertexCount + 0] = cu
	        scratchBuffer[2 * vertexCount + 1] = cv
	
	        vertexCount += 1
	      }
	    }
	
	    this._dynamicCounts[d] = vertexCount - this._dynamicOffsets[d]
	  }
	
	  this._dynamicBuffer.update(scratchBuffer.subarray(0, 2 * vertexCount))
	  pool.freeFloat(scratchBuffer)
	}
	
	function createSurfacePlot (params) {
	  var gl = params.gl
	
	  var shader = createShader(gl)
	  var pickShader = createPickShader(gl)
	  var contourShader = createContourShader(gl)
	  var contourPickShader = createPickContourShader(gl)
	
	  var coordinateBuffer = createBuffer(gl)
	  var vao = createVAO(gl, [
	    { buffer: coordinateBuffer,
	      size: 4,
	      stride: SURFACE_VERTEX_SIZE,
	      offset: 0
	    },
	    { buffer: coordinateBuffer,
	      size: 3,
	      stride: SURFACE_VERTEX_SIZE,
	      offset: 16
	    },
	    {
	      buffer: coordinateBuffer,
	      size: 3,
	      stride: SURFACE_VERTEX_SIZE,
	      offset: 28
	    }
	  ])
	
	  var contourBuffer = createBuffer(gl)
	  var contourVAO = createVAO(gl, [
	    {
	      buffer: contourBuffer,
	      size: 4,
	      stride: 20,
	      offset: 0
	    },
	    {
	      buffer: contourBuffer,
	      size: 1,
	      stride: 20,
	      offset: 16
	    }
	  ])
	
	  var dynamicBuffer = createBuffer(gl)
	  var dynamicVAO = createVAO(gl, [
	    {
	      buffer: dynamicBuffer,
	      size: 2,
	      type: gl.FLOAT
	    }])
	
	  var cmap = createTexture(gl, 1, N_COLORS, gl.RGBA, gl.UNSIGNED_BYTE)
	  cmap.minFilter = gl.LINEAR
	  cmap.magFilter = gl.LINEAR
	
	  var surface = new SurfacePlot(
	    gl,
	    [0, 0], // shape
	    [[0, 0, 0], [0, 0, 0]], // bounds
	    shader,
	    pickShader,
	    coordinateBuffer,
	    vao,
	    cmap,
	    contourShader,
	    contourPickShader,
	    contourBuffer,
	    contourVAO,
	    dynamicBuffer,
	    dynamicVAO,
	    [0, 0, 0] // objectOffset
	  )
	
	  var nparams = {
	    levels: [[], [], []]
	  }
	  for (var id in params) {
	    nparams[id] = params[id]
	  }
	  nparams.colormap = nparams.colormap || 'jet'
	
	  surface.update(nparams)
	
	  return surface
	}
	
	},{"./lib/shaders":315,"binary-search-bounds":316,"bit-twiddle":93,"colormap":127,"gl-buffer":243,"gl-mat4/invert":267,"gl-mat4/multiply":269,"gl-texture2d":323,"gl-vao":328,"ndarray":451,"ndarray-gradient":442,"ndarray-ops":445,"ndarray-pack":446,"surface-nets":529,"typedarray-pool":543}],318:[function(_dereq_,module,exports){
	'use strict'
	
	var Font = _dereq_('css-font')
	var pick = _dereq_('pick-by-alias')
	var createRegl = _dereq_('regl')
	var createGl = _dereq_('gl-util/context')
	var WeakMap = _dereq_('es6-weak-map')
	var rgba = _dereq_('color-normalize')
	var fontAtlas = _dereq_('font-atlas')
	var pool = _dereq_('typedarray-pool')
	var parseRect = _dereq_('parse-rect')
	var isObj = _dereq_('is-plain-obj')
	var parseUnit = _dereq_('parse-unit')
	var px = _dereq_('to-px')
	var kerning = _dereq_('detect-kerning')
	var extend = _dereq_('object-assign')
	var metrics = _dereq_('font-measure')
	var flatten = _dereq_('flatten-vertex-data')
	var ref = _dereq_('bit-twiddle');
	var nextPow2 = ref.nextPow2;
	
	var shaderCache = new WeakMap
	
	
	// Safari does not support font-stretch
	var isStretchSupported = false
	if (document.body) {
	    var el = document.body.appendChild(document.createElement('div'))
	    el.style.font = 'italic small-caps bold condensed 16px/2 cursive'
	    if (getComputedStyle(el).fontStretch) {
	        isStretchSupported = true
	    }
	    document.body.removeChild(el)
	}
	
	var GlText = function GlText (o) {
		if (isRegl(o)) {
			o = {regl: o}
			this.gl = o.regl._gl
		}
		else {
			this.gl = createGl(o)
		}
	
		this.shader = shaderCache.get(this.gl)
	
		if (!this.shader) {
			this.regl = o.regl || createRegl({ gl: this.gl })
		}
		else {
			this.regl = this.shader.regl
		}
	
		this.charBuffer = this.regl.buffer({ type: 'uint8', usage: 'stream' })
		this.sizeBuffer = this.regl.buffer({ type: 'float', usage: 'stream' })
	
		if (!this.shader) {
			this.shader = this.createShader()
			shaderCache.set(this.gl, this.shader)
		}
	
		this.batch = []
	
		// multiple options initial state
		this.fontSize = []
		this.font = []
		this.fontAtlas = []
	
		this.draw = this.shader.draw.bind(this)
		this.render = function () {
			// FIXME: add Safari regl report here:
			// charBuffer and width just do not trigger
			this.regl._refresh()
			this.draw(this.batch)
		}
		this.canvas = this.gl.canvas
	
		this.update(isObj(o) ? o : {})
	};
	
	GlText.prototype.createShader = function createShader () {
		var regl = this.regl
	
		// FIXME: store 2 shader versions: with normal viewport and without
		// draw texture method
		var draw = regl({
			blend: {
				enable: true,
				color: [0,0,0,1],
	
				func: {
					srcRGB: 'src alpha',
					dstRGB: 'one minus src alpha',
					srcAlpha: 'one minus dst alpha',
					dstAlpha: 'one'
				}
			},
			stencil: {enable: false},
			depth: {enable: false},
	
			count: regl.prop('count'),
			offset: regl.prop('offset'),
			attributes: {
				charOffset: {
					offset: 4,
					stride: 8,
					buffer: regl.this('sizeBuffer')
				},
				width: {
					offset: 0,
					stride: 8,
					buffer: regl.this('sizeBuffer')
				},
				char: regl.this('charBuffer'),
				position: regl.this('position')
			},
			uniforms: {
				atlasSize: function (c, p) { return [p.atlas.width, p.atlas.height]; },
				atlasDim: function (c, p) { return [p.atlas.cols, p.atlas.rows]; },
				atlas: function (c, p) { return p.atlas.texture; },
				charStep: function (c, p) { return p.atlas.step; },
				em: function (c, p) { return p.atlas.em; },
				color: regl.prop('color'),
				opacity: regl.prop('opacity'),
				viewport: regl.this('viewportArray'),
				scale: regl.this('scale'),
				align: regl.prop('align'),
				baseline: regl.prop('baseline'),
				translate: regl.this('translate'),
				positionOffset: regl.prop('positionOffset')
			},
			primitive: 'points',
			viewport: regl.this('viewport'),
	
			vert: ("\n\t\t\tprecision highp float;\n\t\t\tattribute float width, charOffset, char;\n\t\t\tattribute vec2 position;\n\t\t\tuniform float fontSize, charStep, em, align, baseline;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform vec4 color;\n\t\t\tuniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvoid main () {\n\t\t\t\t" + (!GlText.normalViewport ? 'vec2 positionOffset = vec2(positionOffset.x,- positionOffset.y);' : '') + "\n\n\t\t\t\tvec2 offset = floor(em * (vec2(align + charOffset, baseline)\n\t\t\t\t\t+ positionOffset))\n\t\t\t\t\t/ (viewport.zw * scale.xy);\n\n\t\t\t\tvec2 position = (position + translate) * scale;\n\t\t\t\tposition += offset * scale;\n\n\t\t\t\t" + (GlText.normalViewport ? 'position.y = 1. - position.y;' : '') + "\n\n\t\t\t\tcharCoord = position * viewport.zw + viewport.xy;\n\n\t\t\t\tgl_Position = vec4(position * 2. - 1., 0, 1);\n\n\t\t\t\tgl_PointSize = charStep;\n\n\t\t\t\tcharId.x = mod(char, atlasDim.x);\n\t\t\t\tcharId.y = floor(char / atlasDim.x);\n\n\t\t\t\tcharWidth = width * em;\n\n\t\t\t\tfontColor = color / 255.;\n\t\t\t}"),
	
			frag: "\n\t\t\tprecision highp float;\n\t\t\tuniform sampler2D atlas;\n\t\t\tuniform float fontSize, charStep, opacity;\n\t\t\tuniform vec2 atlasSize;\n\t\t\tuniform vec4 viewport;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\n\t\t\tfloat lightness(vec4 color) {\n\t\t\t\treturn color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n\t\t\t}\n\n\t\t\tvoid main () {\n\t\t\t\tvec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n\t\t\t\tfloat halfCharStep = floor(charStep * .5 + .5);\n\n\t\t\t\t// invert y and shift by 1px (FF expecially needs that)\n\t\t\t\tuv.y = charStep - uv.y;\n\n\t\t\t\t// ignore points outside of character bounding box\n\t\t\t\tfloat halfCharWidth = ceil(charWidth * .5);\n\t\t\t\tif (floor(uv.x) > halfCharStep + halfCharWidth ||\n\t\t\t\t\tfloor(uv.x) < halfCharStep - halfCharWidth) return;\n\n\t\t\t\tuv += charId * charStep;\n\t\t\t\tuv = uv / atlasSize;\n\n\t\t\t\tvec4 color = fontColor;\n\t\t\t\tvec4 mask = texture2D(atlas, uv);\n\n\t\t\t\tfloat maskY = lightness(mask);\n\t\t\t\t// float colorY = lightness(color);\n\t\t\t\tcolor.a *= maskY;\n\t\t\t\tcolor.a *= opacity;\n\n\t\t\t\t// color.a += .1;\n\n\t\t\t\t// antialiasing, see yiq color space y-channel formula\n\t\t\t\t// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}"
		})
	
		// per font-size atlas
		var atlas = {}
	
		return { regl: regl, draw: draw, atlas: atlas }
	};
	
	GlText.prototype.update = function update (o) {
			var this$1 = this;
	
		if (typeof o === 'string') { o = { text: o } }
		else if (!o) { return }
	
		// FIXME: make this a static transform or more general approact
		o = pick(o, {
			position: 'position positions coord coords coordinates',
			font: 'font fontFace fontface typeface cssFont css-font family fontFamily',
			fontSize: 'fontSize fontsize size font-size',
			text: 'text texts chars characters value values symbols',
			align: 'align alignment textAlign textbaseline',
			baseline: 'baseline textBaseline textbaseline',
			direction: 'dir direction textDirection',
			color: 'color colour fill fill-color fillColor textColor textcolor',
			kerning: 'kerning kern',
			range: 'range dataBox',
			viewport: 'vp viewport viewBox viewbox viewPort',
			opacity: 'opacity alpha transparency visible visibility opaque',
			offset: 'offset positionOffset padding shift indent indentation'
		}, true)
	
	
		if (o.opacity != null) {
			if (Array.isArray(o.opacity)) {
				this.opacity = o.opacity.map(function (o) { return parseFloat(o); })
			}
			else {
				this.opacity = parseFloat(o.opacity)
			}
		}
	
		if (o.viewport != null) {
			this.viewport = parseRect(o.viewport)
	
			if (GlText.normalViewport) {
				this.viewport.y = this.canvas.height - this.viewport.y - this.viewport.height
			}
	
			this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]
	
		}
		if (this.viewport == null) {
			this.viewport = {
				x: 0, y: 0,
				width: this.gl.drawingBufferWidth,
				height: this.gl.drawingBufferHeight
			}
			this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]
		}
	
		if (o.kerning != null) { this.kerning = o.kerning }
	
		if (o.offset != null) {
			if (typeof o.offset === 'number') { o.offset = [o.offset, 0] }
	
			this.positionOffset = flatten(o.offset)
		}
	
		if (o.direction) { this.direction = o.direction }
	
		if (o.range) {
			this.range = o.range
			this.scale = [1 / (o.range[2] - o.range[0]), 1 / (o.range[3] - o.range[1])]
			this.translate = [-o.range[0], -o.range[1]]
		}
		if (o.scale) { this.scale = o.scale }
		if (o.translate) { this.translate = o.translate }
	
		// default scale corresponds to viewport
		if (!this.scale) { this.scale = [1 / this.viewport.width, 1 / this.viewport.height] }
	
		if (!this.translate) { this.translate = [0, 0] }
	
		if (!this.font.length && !o.font) { o.font = GlText.baseFontSize + 'px sans-serif' }
	
		// normalize font caching string
		var newFont = false, newFontSize = false
	
		// obtain new font data
		if (o.font) {
			(Array.isArray(o.font) ? o.font : [o.font]).forEach(function (font, i) {
				// normalize font
				if (typeof font === 'string') {
					try {
						font = Font.parse(font)
					} catch (e) {
						font = Font.parse(GlText.baseFontSize + 'px ' + font)
					}
				}
				else { font = Font.parse(Font.stringify(font)) }
	
				var baseString = Font.stringify({
					size: GlText.baseFontSize,
					family: font.family,
					stretch: isStretchSupported ? font.stretch : undefined,
					variant: font.variant,
					weight: font.weight,
					style: font.style
				})
	
				var unit = parseUnit(font.size)
				var fs = Math.round(unit[0] * px(unit[1]))
				if (fs !== this$1.fontSize[i]) {
					newFontSize = true
					this$1.fontSize[i] = fs
				}
	
				// calc new font metrics/atlas
				if (!this$1.font[i] || baseString != this$1.font[i].baseString) {
					newFont = true
	
					// obtain font cache or create one
					this$1.font[i] = GlText.fonts[baseString]
					if (!this$1.font[i]) {
						var family = font.family.join(', ')
						var style = [font.style]
						if (font.style != font.variant) { style.push(font.variant) }
						if (font.variant != font.weight) { style.push(font.weight) }
						if (isStretchSupported && font.weight != font.stretch) { style.push(font.stretch) }
	
						this$1.font[i] = {
							baseString: baseString,
	
							// typeface
							family: family,
							weight: font.weight,
							stretch: font.stretch,
							style: font.style,
							variant: font.variant,
	
							// widths of characters
							width: {},
	
							// kernin pairs offsets
							kerning: {},
	
							metrics: metrics(family, {
								origin: 'top',
								fontSize: GlText.baseFontSize,
								fontStyle: style.join(' ')
							})
						}
	
						GlText.fonts[baseString] = this$1.font[i]
					}
				}
			})
		}
	
		// FIXME: make independend font-size
		// if (o.fontSize) {
		// let unit = parseUnit(o.fontSize)
		// let fs = Math.round(unit[0] * px(unit[1]))
	
		// if (fs != this.fontSize) {
		// 	newFontSize = true
		// 	this.fontSize = fs
		// }
		// }
	
		if (newFont || newFontSize) {
			this.font.forEach(function (font, i) {
				var fontString = Font.stringify({
					size: this$1.fontSize[i],
					family: font.family,
					stretch: isStretchSupported ? font.stretch : undefined,
					variant: font.variant,
					weight: font.weight,
					style: font.style
				})
	
				// calc new font size atlas
				this$1.fontAtlas[i] = this$1.shader.atlas[fontString]
	
				if (!this$1.fontAtlas[i]) {
					var metrics = font.metrics
	
					this$1.shader.atlas[fontString] =
					this$1.fontAtlas[i] = {
						fontString: fontString,
						// even step is better for rendered characters
						step: Math.ceil(this$1.fontSize[i] * metrics.bottom * .5) * 2,
						em: this$1.fontSize[i],
						cols: 0,
						rows: 0,
						height: 0,
						width: 0,
						chars: [],
						ids: {},
						texture: this$1.regl.texture()
					}
				}
	
				// bump atlas characters
				if (o.text == null) { o.text = this$1.text }
			})
		}
	
		// if multiple positions - duplicate text arguments
		// FIXME: this possibly can be done better to avoid array spawn
		if (typeof o.text === 'string' && o.position && o.position.length > 2) {
			var textArray = Array(o.position.length * .5)
			for (var i = 0; i < textArray.length; i++) {
				textArray[i] = o.text
			}
			o.text = textArray
		}
	
		// calculate offsets for the new font/text
		var newAtlasChars
		if (o.text != null || newFont) {
			// FIXME: ignore spaces
			// text offsets within the text buffer
			this.textOffsets = [0]
	
			if (Array.isArray(o.text)) {
				this.count = o.text[0].length
				this.counts = [this.count]
				for (var i$1 = 1; i$1 < o.text.length; i$1++) {
					this.textOffsets[i$1] = this.textOffsets[i$1 - 1] + o.text[i$1 - 1].length
					this.count += o.text[i$1].length
					this.counts.push(o.text[i$1].length)
				}
				this.text = o.text.join('')
			}
			else {
				this.text = o.text
				this.count = this.text.length
				this.counts = [this.count]
			}
	
			newAtlasChars = []
	
			// detect & measure new characters
			this.font.forEach(function (font, idx) {
				GlText.atlasContext.font = font.baseString
	
				var atlas = this$1.fontAtlas[idx]
	
				for (var i = 0; i < this$1.text.length; i++) {
					var char = this$1.text.charAt(i)
	
					if (atlas.ids[char] == null) {
						atlas.ids[char] = atlas.chars.length
						atlas.chars.push(char)
						newAtlasChars.push(char)
					}
	
					if (font.width[char] == null) {
						font.width[char] = GlText.atlasContext.measureText(char).width / GlText.baseFontSize
	
						// measure kerning pairs for the new character
						if (this$1.kerning) {
							var pairs = []
							for (var baseChar in font.width) {
								pairs.push(baseChar + char, char + baseChar)
							}
							extend(font.kerning, kerning(font.family, {
								pairs: pairs
							}))
						}
					}
				}
			})
		}
	
		// create single position buffer (faster than batch or multiple separate instances)
		if (o.position) {
			if (o.position.length > 2) {
				var flat = !o.position[0].length
				var positionData = pool.mallocFloat(this.count * 2)
				for (var i$2 = 0, ptr = 0; i$2 < this.counts.length; i$2++) {
					var count = this.counts[i$2]
					if (flat) {
						for (var j = 0; j < count; j++) {
							positionData[ptr++] = o.position[i$2 * 2]
							positionData[ptr++] = o.position[i$2 * 2 + 1]
						}
					}
					else {
						for (var j$1 = 0; j$1 < count; j$1++) {
							positionData[ptr++] = o.position[i$2][0]
							positionData[ptr++] = o.position[i$2][1]
						}
					}
				}
				if (this.position.call) {
					this.position({
						type: 'float',
						data: positionData
					})
				} else {
					this.position = this.regl.buffer({
						type: 'float',
						data: positionData
					})
				}
				pool.freeFloat(positionData)
			}
			else {
				if (this.position.destroy) { this.position.destroy() }
				this.position = {
					constant: o.position
				}
			}
		}
	
		// populate text/offset buffers if font/text has changed
		// as [charWidth, offset, charWidth, offset...]
		// that is in em units since font-size can change often
		if (o.text || newFont) {
			var charIds = pool.mallocUint8(this.count)
			var sizeData = pool.mallocFloat(this.count * 2)
			this.textWidth = []
	
			for (var i$3 = 0, ptr$1 = 0; i$3 < this.counts.length; i$3++) {
				var count$1 = this.counts[i$3]
				var font = this.font[i$3] || this.font[0]
				var atlas = this.fontAtlas[i$3] || this.fontAtlas[0]
	
				for (var j$2 = 0; j$2 < count$1; j$2++) {
					var char = this.text.charAt(ptr$1)
					var prevChar = this.text.charAt(ptr$1 - 1)
	
					charIds[ptr$1] = atlas.ids[char]
					sizeData[ptr$1 * 2] = font.width[char]
	
					if (j$2) {
						var prevWidth = sizeData[ptr$1 * 2 - 2]
						var currWidth = sizeData[ptr$1 * 2]
						var prevOffset = sizeData[ptr$1 * 2 - 1]
						var offset = prevOffset + prevWidth * .5 + currWidth * .5;
	
						if (this.kerning) {
							var kerning$1 = font.kerning[prevChar + char]
							if (kerning$1) {
								offset += kerning$1 * 1e-3
							}
						}
	
						sizeData[ptr$1 * 2 + 1] = offset
					}
					else {
						sizeData[ptr$1 * 2 + 1] = sizeData[ptr$1 * 2] * .5
					}
	
					ptr$1++
				}
				this.textWidth.push(
					!sizeData.length ? 0 :
					// last offset + half last width
					sizeData[ptr$1 * 2 - 2] * .5 + sizeData[ptr$1 * 2 - 1]
				)
			}
	
	
			// bump recalc align offset
			if (!o.align) { o.align = this.align }
			this.charBuffer({data: charIds, type: 'uint8', usage: 'stream'})
			this.sizeBuffer({data: sizeData, type: 'float', usage: 'stream'})
			pool.freeUint8(charIds)
			pool.freeFloat(sizeData)
	
			// udpate font atlas and texture
			if (newAtlasChars.length) {
				this.font.forEach(function (font, i) {
					var atlas = this$1.fontAtlas[i]
	
					// FIXME: insert metrics-based ratio here
					var step = atlas.step
	
					var maxCols = Math.floor(GlText.maxAtlasSize / step)
					var cols = Math.min(maxCols, atlas.chars.length)
					var rows = Math.ceil(atlas.chars.length / cols)
	
					var atlasWidth = nextPow2( cols * step )
					// let atlasHeight = Math.min(rows * step + step * .5, GlText.maxAtlasSize);
					var atlasHeight = nextPow2( rows * step );
	
					atlas.width = atlasWidth
					atlas.height = atlasHeight;
					atlas.rows = rows
					atlas.cols = cols
	
					if (!atlas.em) { return }
	
					atlas.texture({
						data: fontAtlas({
							canvas: GlText.atlasCanvas,
							font: atlas.fontString,
							chars: atlas.chars,
							shape: [atlasWidth, atlasHeight],
							step: [step, step]
						})
					})
	
				})
			}
		}
	
		if (o.align) {
			this.align = o.align
			this.alignOffset = this.textWidth.map(function (textWidth, i) {
				var align = !Array.isArray(this$1.align) ? this$1.align : this$1.align.length > 1 ? this$1.align[i] : this$1.align[0]
	
				if (typeof align === 'number') { return align }
				switch (align) {
					case 'right':
					case 'end':
						return -textWidth
					case 'center':
					case 'centre':
					case 'middle':
						return -textWidth * .5
				}
	
				return 0
			})
		}
	
		if (this.baseline == null && o.baseline == null) {
			o.baseline = 0
		}
		if (o.baseline != null) {
			this.baseline = o.baseline
			if (!Array.isArray(this.baseline)) { this.baseline = [this.baseline] }
			this.baselineOffset = this.baseline.map(function (baseline, i) {
				var m = (this$1.font[i] || this$1.font[0]).metrics
				var base = 0
	
				base += m.bottom * .5
	
				if (typeof baseline === 'number') {
					base += (baseline - m.baseline)
				}
				else {
					base += -m[baseline]
				}
	
				if (!GlText.normalViewport) { base *= -1 }
				return base
			})
		}
	
		// flatten colors to a single uint8 array
		if (o.color != null) {
			if (!o.color) { o.color = 'transparent' }
	
			// single color
			if (typeof o.color === 'string' || !isNaN(o.color)) {
				this.color = rgba(o.color, 'uint8')
			}
			// array
			else {
				var colorData
	
				// flat array
				if (typeof o.color[0] === 'number' && o.color.length > this.counts.length) {
					var l = o.color.length
					colorData = pool.mallocUint8(l)
					var sub = (o.color.subarray || o.color.slice).bind(o.color)
					for (var i$4 = 0; i$4 < l; i$4 += 4) {
						colorData.set(rgba(sub(i$4, i$4 + 4), 'uint8'), i$4)
					}
				}
				// nested array
				else {
					var l$1 = o.color.length
					colorData = pool.mallocUint8(l$1 * 4)
					for (var i$5 = 0; i$5 < l$1; i$5++) {
						colorData.set(rgba(o.color[i$5] || 0, 'uint8'), i$5 * 4)
					}
				}
	
				this.color = colorData
			}
		}
	
		// update render batch
		if (o.position || o.text || o.color || o.baseline || o.align || o.font || o.offset || o.opacity) {
			var isBatch = (this.color.length > 4)
				|| (this.baselineOffset.length > 1)
				|| (this.align && this.align.length > 1)
				|| (this.fontAtlas.length > 1)
				|| (this.positionOffset.length > 2)
			if (isBatch) {
				var length = Math.max(
					this.position.length * .5 || 0,
					this.color.length * .25 || 0,
					this.baselineOffset.length || 0,
					this.alignOffset.length || 0,
					this.font.length || 0,
					this.opacity.length || 0,
					this.positionOffset.length * .5 || 0
				)
				this.batch = Array(length)
				for (var i$6 = 0; i$6 < this.batch.length; i$6++) {
					this.batch[i$6] = {
						count: this.counts.length > 1 ? this.counts[i$6] : this.counts[0],
						offset: this.textOffsets.length > 1 ? this.textOffsets[i$6] : this.textOffsets[0],
						color: !this.color ? [0,0,0,255] : this.color.length <= 4 ? this.color : this.color.subarray(i$6 * 4, i$6 * 4 + 4),
						opacity: Array.isArray(this.opacity) ? this.opacity[i$6] : this.opacity,
						baseline: this.baselineOffset[i$6] != null ? this.baselineOffset[i$6] : this.baselineOffset[0],
						align: !this.align ? 0 : this.alignOffset[i$6] != null ? this.alignOffset[i$6] : this.alignOffset[0],
						atlas: this.fontAtlas[i$6] || this.fontAtlas[0],
						positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(i$6 * 2, i$6 * 2 + 2) : this.positionOffset
					}
				}
			}
			// single-color, single-baseline, single-align batch is faster to render
			else {
				if (this.count) {
					this.batch = [{
						count: this.count,
						offset: 0,
						color: this.color || [0,0,0,255],
						opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
						baseline: this.baselineOffset[0],
						align: this.alignOffset ? this.alignOffset[0] : 0,
						atlas: this.fontAtlas[0],
						positionOffset: this.positionOffset
					}]
				}
				else {
					this.batch = []
				}
			}
		}
	};
	
	GlText.prototype.destroy = function destroy () {
		// TODO: count instances of atlases and destroy all on null
	};
	
	
	// defaults
	GlText.prototype.kerning = true
	GlText.prototype.position = { constant: new Float32Array(2) }
	GlText.prototype.translate = null
	GlText.prototype.scale = null
	GlText.prototype.font = null
	GlText.prototype.text = ''
	GlText.prototype.positionOffset = [0, 0]
	GlText.prototype.opacity = 1
	GlText.prototype.color = new Uint8Array([0, 0, 0, 255])
	GlText.prototype.alignOffset = [0, 0]
	
	
	// whether viewport should be top↓bottom 2d one (true) or webgl one (false)
	GlText.normalViewport = false
	
	// size of an atlas
	GlText.maxAtlasSize = 1024
	
	// font atlas canvas is singleton
	GlText.atlasCanvas = document.createElement('canvas')
	GlText.atlasContext = GlText.atlasCanvas.getContext('2d', {alpha: false})
	
	// font-size used for metrics, atlas step calculation
	GlText.baseFontSize = 64
	
	// fonts storage
	GlText.fonts = {}
	
	// max number of different font atlases/textures cached
	// FIXME: enable atlas size limitation via LRU
	// GlText.atlasCacheSize = 64
	
	function isRegl (o) {
		return typeof o === 'function' &&
		o._gl &&
		o.prop &&
		o.texture &&
		o.buffer
	}
	
	
	module.exports = GlText
	
	
	},{"bit-twiddle":93,"color-normalize":121,"css-font":140,"detect-kerning":167,"es6-weak-map":319,"flatten-vertex-data":229,"font-atlas":230,"font-measure":231,"gl-util/context":324,"is-plain-obj":423,"object-assign":455,"parse-rect":460,"parse-unit":462,"pick-by-alias":466,"regl":500,"to-px":537,"typedarray-pool":543}],319:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = _dereq_("./is-implemented")() ? WeakMap : _dereq_("./polyfill");
	
	},{"./is-implemented":320,"./polyfill":322}],320:[function(_dereq_,module,exports){
	"use strict";
	
	module.exports = function () {
		var weakMap, obj;
	
		if (typeof WeakMap !== "function") return false;
		try {
			// WebKit doesn't support arguments and crashes
			weakMap = new WeakMap([[obj = {}, "one"], [{}, "two"], [{}, "three"]]);
		} catch (e) {
			return false;
		}
		if (String(weakMap) !== "[object WeakMap]") return false;
		if (typeof weakMap.set !== "function") return false;
		if (weakMap.set({}, 1) !== weakMap) return false;
		if (typeof weakMap.delete !== "function") return false;
		if (typeof weakMap.has !== "function") return false;
		if (weakMap.get(obj) !== "one") return false;
	
		return true;
	};
	
	},{}],321:[function(_dereq_,module,exports){
	// Exports true if environment provides native `WeakMap` implementation, whatever that is.
	
	"use strict";
	
	module.exports = (function () {
		if (typeof WeakMap !== "function") return false;
		return Object.prototype.toString.call(new WeakMap()) === "[object WeakMap]";
	}());
	
	},{}],322:[function(_dereq_,module,exports){
	"use strict";
	
	var isValue           = _dereq_("es5-ext/object/is-value")
	  , setPrototypeOf    = _dereq_("es5-ext/object/set-prototype-of")
	  , object            = _dereq_("es5-ext/object/valid-object")
	  , ensureValue       = _dereq_("es5-ext/object/valid-value")
	  , randomUniq        = _dereq_("es5-ext/string/random-uniq")
	  , d                 = _dereq_("d")
	  , getIterator       = _dereq_("es6-iterator/get")
	  , forOf             = _dereq_("es6-iterator/for-of")
	  , toStringTagSymbol = _dereq_("es6-symbol").toStringTag
	  , isNative          = _dereq_("./is-native-implemented")
	
	  , isArray = Array.isArray, defineProperty = Object.defineProperty
	  , objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf
	  , WeakMapPoly;
	
	module.exports = WeakMapPoly = function (/* Iterable*/) {
		var iterable = arguments[0], self;
	
		if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
		self = isNative && setPrototypeOf && (WeakMap !== WeakMapPoly)
			? setPrototypeOf(new WeakMap(), getPrototypeOf(this)) : this;
	
		if (isValue(iterable)) {
			if (!isArray(iterable)) iterable = getIterator(iterable);
		}
		defineProperty(self, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
		if (!iterable) return self;
		forOf(iterable, function (val) {
			ensureValue(val);
			self.set(val[0], val[1]);
		});
		return self;
	};
	
	if (isNative) {
		if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
		WeakMapPoly.prototype = Object.create(WeakMap.prototype, { constructor: d(WeakMapPoly) });
	}
	
	Object.defineProperties(WeakMapPoly.prototype, {
		delete: d(function (key) {
			if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
				delete key[this.__weakMapData__];
				return true;
			}
			return false;
		}),
		get: d(function (key) {
			if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
			return key[this.__weakMapData__];
		}),
		has: d(function (key) {
			return objHasOwnProperty.call(object(key), this.__weakMapData__);
		}),
		set: d(function (key, value) {
			defineProperty(object(key), this.__weakMapData__, d("c", value));
			return this;
		}),
		toString: d(function () {
			return "[object WeakMap]";
		})
	});
	defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));
	
	},{"./is-native-implemented":321,"d":152,"es5-ext/object/is-value":196,"es5-ext/object/set-prototype-of":202,"es5-ext/object/valid-object":206,"es5-ext/object/valid-value":207,"es5-ext/string/random-uniq":212,"es6-iterator/for-of":214,"es6-iterator/get":215,"es6-symbol":221}],323:[function(_dereq_,module,exports){
	'use strict'
	
	var ndarray = _dereq_('ndarray')
	var ops     = _dereq_('ndarray-ops')
	var pool    = _dereq_('typedarray-pool')
	
	module.exports = createTexture2D
	
	var linearTypes = null
	var filterTypes = null
	var wrapTypes   = null
	
	function lazyInitLinearTypes(gl) {
	  linearTypes = [
	    gl.LINEAR,
	    gl.NEAREST_MIPMAP_LINEAR,
	    gl.LINEAR_MIPMAP_NEAREST,
	    gl.LINEAR_MIPMAP_NEAREST
	  ]
	  filterTypes = [
	    gl.NEAREST,
	    gl.LINEAR,
	    gl.NEAREST_MIPMAP_NEAREST,
	    gl.NEAREST_MIPMAP_LINEAR,
	    gl.LINEAR_MIPMAP_NEAREST,
	    gl.LINEAR_MIPMAP_LINEAR
	  ]
	  wrapTypes = [
	    gl.REPEAT,
	    gl.CLAMP_TO_EDGE,
	    gl.MIRRORED_REPEAT
	  ]
	}
	
	function acceptTextureDOM (obj) {
	  return (
	    ('undefined' != typeof HTMLCanvasElement && obj instanceof HTMLCanvasElement) ||
	    ('undefined' != typeof HTMLImageElement && obj instanceof HTMLImageElement) ||
	    ('undefined' != typeof HTMLVideoElement && obj instanceof HTMLVideoElement) ||
	    ('undefined' != typeof ImageData && obj instanceof ImageData))
	}
	
	var convertFloatToUint8 = function(out, inp) {
	  ops.muls(out, inp, 255.0)
	}
	
	function reshapeTexture(tex, w, h) {
	  var gl = tex.gl
	  var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
	  if(w < 0 || w > maxSize || h < 0 || h > maxSize) {
	    throw new Error('gl-texture2d: Invalid texture size')
	  }
	  tex._shape = [w, h]
	  tex.bind()
	  gl.texImage2D(gl.TEXTURE_2D, 0, tex.format, w, h, 0, tex.format, tex.type, null)
	  tex._mipLevels = [0]
	  return tex
	}
	
	function Texture2D(gl, handle, width, height, format, type) {
	  this.gl = gl
	  this.handle = handle
	  this.format = format
	  this.type = type
	  this._shape = [width, height]
	  this._mipLevels = [0]
	  this._magFilter = gl.NEAREST
	  this._minFilter = gl.NEAREST
	  this._wrapS = gl.CLAMP_TO_EDGE
	  this._wrapT = gl.CLAMP_TO_EDGE
	  this._anisoSamples = 1
	
	  var parent = this
	  var wrapVector = [this._wrapS, this._wrapT]
	  Object.defineProperties(wrapVector, [
	    {
	      get: function() {
	        return parent._wrapS
	      },
	      set: function(v) {
	        return parent.wrapS = v
	      }
	    },
	    {
	      get: function() {
	        return parent._wrapT
	      },
	      set: function(v) {
	        return parent.wrapT = v
	      }
	    }
	  ])
	  this._wrapVector = wrapVector
	
	  var shapeVector = [this._shape[0], this._shape[1]]
	  Object.defineProperties(shapeVector, [
	    {
	      get: function() {
	        return parent._shape[0]
	      },
	      set: function(v) {
	        return parent.width = v
	      }
	    },
	    {
	      get: function() {
	        return parent._shape[1]
	      },
	      set: function(v) {
	        return parent.height = v
	      }
	    }
	  ])
	  this._shapeVector = shapeVector
	}
	
	var proto = Texture2D.prototype
	
	Object.defineProperties(proto, {
	  minFilter: {
	    get: function() {
	      return this._minFilter
	    },
	    set: function(v) {
	      this.bind()
	      var gl = this.gl
	      if(this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
	        if(!gl.getExtension('OES_texture_float_linear')) {
	          v = gl.NEAREST
	        }
	      }
	      if(filterTypes.indexOf(v) < 0) {
	        throw new Error('gl-texture2d: Unknown filter mode ' + v)
	      }
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, v)
	      return this._minFilter = v
	    }
	  },
	  magFilter: {
	    get: function() {
	      return this._magFilter
	    },
	    set: function(v) {
	      this.bind()
	      var gl = this.gl
	      if(this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
	        if(!gl.getExtension('OES_texture_float_linear')) {
	          v = gl.NEAREST
	        }
	      }
	      if(filterTypes.indexOf(v) < 0) {
	        throw new Error('gl-texture2d: Unknown filter mode ' + v)
	      }
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, v)
	      return this._magFilter = v
	    }
	  },
	  mipSamples: {
	    get: function() {
	      return this._anisoSamples
	    },
	    set: function(i) {
	      var psamples = this._anisoSamples
	      this._anisoSamples = Math.max(i, 1)|0
	      if(psamples !== this._anisoSamples) {
	        var ext = this.gl.getExtension('EXT_texture_filter_anisotropic')
	        if(ext) {
	          this.gl.texParameterf(this.gl.TEXTURE_2D, ext.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples)
	        }
	      }
	      return this._anisoSamples
	    }
	  },
	  wrapS: {
	    get: function() {
	      return this._wrapS
	    },
	    set: function(v) {
	      this.bind()
	      if(wrapTypes.indexOf(v) < 0) {
	        throw new Error('gl-texture2d: Unknown wrap mode ' + v)
	      }
	      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, v)
	      return this._wrapS = v
	    }
	  },
	  wrapT: {
	    get: function() {
	      return this._wrapT
	    },
	    set: function(v) {
	      this.bind()
	      if(wrapTypes.indexOf(v) < 0) {
	        throw new Error('gl-texture2d: Unknown wrap mode ' + v)
	      }
	      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, v)
	      return this._wrapT = v
	    }
	  },
	  wrap: {
	    get: function() {
	      return this._wrapVector
	    },
	    set: function(v) {
	      if(!Array.isArray(v)) {
	        v = [v,v]
	      }
	      if(v.length !== 2) {
	        throw new Error('gl-texture2d: Must specify wrap mode for rows and columns')
	      }
	      for(var i=0; i<2; ++i) {
	        if(wrapTypes.indexOf(v[i]) < 0) {
	          throw new Error('gl-texture2d: Unknown wrap mode ' + v)
	        }
	      }
	      this._wrapS = v[0]
	      this._wrapT = v[1]
	
	      var gl = this.gl
	      this.bind()
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this._wrapS)
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this._wrapT)
	
	      return v
	    }
	  },
	  shape: {
	    get: function() {
	      return this._shapeVector
	    },
	    set: function(x) {
	      if(!Array.isArray(x)) {
	        x = [x|0,x|0]
	      } else {
	        if(x.length !== 2) {
	          throw new Error('gl-texture2d: Invalid texture shape')
	        }
	      }
	      reshapeTexture(this, x[0]|0, x[1]|0)
	      return [x[0]|0, x[1]|0]
	    }
	  },
	  width: {
	    get: function() {
	      return this._shape[0]
	    },
	    set: function(w) {
	      w = w|0
	      reshapeTexture(this, w, this._shape[1])
	      return w
	    }
	  },
	  height: {
	    get: function() {
	      return this._shape[1]
	    },
	    set: function(h) {
	      h = h|0
	      reshapeTexture(this, this._shape[0], h)
	      return h
	    }
	  }
	})
	
	proto.bind = function(unit) {
	  var gl = this.gl
	  if(unit !== undefined) {
	    gl.activeTexture(gl.TEXTURE0 + (unit|0))
	  }
	  gl.bindTexture(gl.TEXTURE_2D, this.handle)
	  if(unit !== undefined) {
	    return (unit|0)
	  }
	  return gl.getParameter(gl.ACTIVE_TEXTURE) - gl.TEXTURE0
	}
	
	proto.dispose = function() {
	  this.gl.deleteTexture(this.handle)
	}
	
	proto.generateMipmap = function() {
	  this.bind()
	  this.gl.generateMipmap(this.gl.TEXTURE_2D)
	
	  //Update mip levels
	  var l = Math.min(this._shape[0], this._shape[1])
	  for(var i=0; l>0; ++i, l>>>=1) {
	    if(this._mipLevels.indexOf(i) < 0) {
	      this._mipLevels.push(i)
	    }
	  }
	}
	
	proto.setPixels = function(data, x_off, y_off, mip_level) {
	  var gl = this.gl
	  this.bind()
	  if(Array.isArray(x_off)) {
	    mip_level = y_off
	    y_off = x_off[1]|0
	    x_off = x_off[0]|0
	  } else {
	    x_off = x_off || 0
	    y_off = y_off || 0
	  }
	  mip_level = mip_level || 0
	  var directData = acceptTextureDOM(data) ? data : data.raw
	  if(directData) {
	    var needsMip = this._mipLevels.indexOf(mip_level) < 0
	    if(needsMip) {
	      gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, directData)
	      this._mipLevels.push(mip_level)
	    } else {
	      gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, this.format, this.type, directData)
	    }
	  } else if(data.shape && data.stride && data.data) {
	    if(data.shape.length < 2 ||
	       x_off + data.shape[1] > this._shape[1]>>>mip_level ||
	       y_off + data.shape[0] > this._shape[0]>>>mip_level ||
	       x_off < 0 ||
	       y_off < 0) {
	      throw new Error('gl-texture2d: Texture dimensions are out of bounds')
	    }
	    texSubImageArray(gl, x_off, y_off, mip_level, this.format, this.type, this._mipLevels, data)
	  } else {
	    throw new Error('gl-texture2d: Unsupported data type')
	  }
	}
	
	
	function isPacked(shape, stride) {
	  if(shape.length === 3) {
	    return  (stride[2] === 1) &&
	            (stride[1] === shape[0]*shape[2]) &&
	            (stride[0] === shape[2])
	  }
	  return  (stride[0] === 1) &&
	          (stride[1] === shape[0])
	}
	
	function texSubImageArray(gl, x_off, y_off, mip_level, cformat, ctype, mipLevels, array) {
	  var dtype = array.dtype
	  var shape = array.shape.slice()
	  if(shape.length < 2 || shape.length > 3) {
	    throw new Error('gl-texture2d: Invalid ndarray, must be 2d or 3d')
	  }
	  var type = 0, format = 0
	  var packed = isPacked(shape, array.stride.slice())
	  if(dtype === 'float32') {
	    type = gl.FLOAT
	  } else if(dtype === 'float64') {
	    type = gl.FLOAT
	    packed = false
	    dtype = 'float32'
	  } else if(dtype === 'uint8') {
	    type = gl.UNSIGNED_BYTE
	  } else {
	    type = gl.UNSIGNED_BYTE
	    packed = false
	    dtype = 'uint8'
	  }
	  var channels = 1
	  if(shape.length === 2) {
	    format = gl.LUMINANCE
	    shape = [shape[0], shape[1], 1]
	    array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset)
	  } else if(shape.length === 3) {
	    if(shape[2] === 1) {
	      format = gl.ALPHA
	    } else if(shape[2] === 2) {
	      format = gl.LUMINANCE_ALPHA
	    } else if(shape[2] === 3) {
	      format = gl.RGB
	    } else if(shape[2] === 4) {
	      format = gl.RGBA
	    } else {
	      throw new Error('gl-texture2d: Invalid shape for pixel coords')
	    }
	    channels = shape[2]
	  } else {
	    throw new Error('gl-texture2d: Invalid shape for texture')
	  }
	  //For 1-channel textures allow conversion between formats
	  if((format  === gl.LUMINANCE || format  === gl.ALPHA) &&
	     (cformat === gl.LUMINANCE || cformat === gl.ALPHA)) {
	    format = cformat
	  }
	  if(format !== cformat) {
	    throw new Error('gl-texture2d: Incompatible texture format for setPixels')
	  }
	  var size = array.size
	  var needsMip = mipLevels.indexOf(mip_level) < 0
	  if(needsMip) {
	    mipLevels.push(mip_level)
	  }
	  if(type === ctype && packed) {
	    //Array data types are compatible, can directly copy into texture
	    if(array.offset === 0 && array.data.length === size) {
	      if(needsMip) {
	        gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data)
	      } else {
	        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data)
	      }
	    } else {
	      if(needsMip) {
	        gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data.subarray(array.offset, array.offset+size))
	      } else {
	        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data.subarray(array.offset, array.offset+size))
	      }
	    }
	  } else {
	    //Need to do type conversion to pack data into buffer
	    var pack_buffer
	    if(ctype === gl.FLOAT) {
	      pack_buffer = pool.mallocFloat32(size)
	    } else {
	      pack_buffer = pool.mallocUint8(size)
	    }
	    var pack_view = ndarray(pack_buffer, shape, [shape[2], shape[2]*shape[0], 1])
	    if(type === gl.FLOAT && ctype === gl.UNSIGNED_BYTE) {
	      convertFloatToUint8(pack_view, array)
	    } else {
	      ops.assign(pack_view, array)
	    }
	    if(needsMip) {
	      gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, pack_buffer.subarray(0, size))
	    } else {
	      gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, pack_buffer.subarray(0, size))
	    }
	    if(ctype === gl.FLOAT) {
	      pool.freeFloat32(pack_buffer)
	    } else {
	      pool.freeUint8(pack_buffer)
	    }
	  }
	}
	
	function initTexture(gl) {
	  var tex = gl.createTexture()
	  gl.bindTexture(gl.TEXTURE_2D, tex)
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST)
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST)
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
	  return tex
	}
	
	function createTextureShape(gl, width, height, format, type) {
	  var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
	  if(width < 0 || width > maxTextureSize || height < 0 || height  > maxTextureSize) {
	    throw new Error('gl-texture2d: Invalid texture shape')
	  }
	  if(type === gl.FLOAT && !gl.getExtension('OES_texture_float')) {
	    throw new Error('gl-texture2d: Floating point textures not supported on this platform')
	  }
	  var tex = initTexture(gl)
	  gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, 0, format, type, null)
	  return new Texture2D(gl, tex, width, height, format, type)
	}
	
	function createTextureDOM(gl, directData, width, height, format, type) {
	  var tex = initTexture(gl)
	  gl.texImage2D(gl.TEXTURE_2D, 0, format, format, type, directData)
	  return new Texture2D(gl, tex, width, height, format, type)
	}
	
	//Creates a texture from an ndarray
	function createTextureArray(gl, array) {
	  var dtype = array.dtype
	  var shape = array.shape.slice()
	  var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
	  if(shape[0] < 0 || shape[0] > maxSize || shape[1] < 0 || shape[1] > maxSize) {
	    throw new Error('gl-texture2d: Invalid texture size')
	  }
	  var packed = isPacked(shape, array.stride.slice())
	  var type = 0
	  if(dtype === 'float32') {
	    type = gl.FLOAT
	  } else if(dtype === 'float64') {
	    type = gl.FLOAT
	    packed = false
	    dtype = 'float32'
	  } else if(dtype === 'uint8') {
	    type = gl.UNSIGNED_BYTE
	  } else {
	    type = gl.UNSIGNED_BYTE
	    packed = false
	    dtype = 'uint8'
	  }
	  var format = 0
	  if(shape.length === 2) {
	    format = gl.LUMINANCE
	    shape = [shape[0], shape[1], 1]
	    array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset)
	  } else if(shape.length === 3) {
	    if(shape[2] === 1) {
	      format = gl.ALPHA
	    } else if(shape[2] === 2) {
	      format = gl.LUMINANCE_ALPHA
	    } else if(shape[2] === 3) {
	      format = gl.RGB
	    } else if(shape[2] === 4) {
	      format = gl.RGBA
	    } else {
	      throw new Error('gl-texture2d: Invalid shape for pixel coords')
	    }
	  } else {
	    throw new Error('gl-texture2d: Invalid shape for texture')
	  }
	  if(type === gl.FLOAT && !gl.getExtension('OES_texture_float')) {
	    type = gl.UNSIGNED_BYTE
	    packed = false
	  }
	  var buffer, buf_store
	  var size = array.size
	  if(!packed) {
	    var stride = [shape[2], shape[2]*shape[0], 1]
	    buf_store = pool.malloc(size, dtype)
	    var buf_array = ndarray(buf_store, shape, stride, 0)
	    if((dtype === 'float32' || dtype === 'float64') && type === gl.UNSIGNED_BYTE) {
	      convertFloatToUint8(buf_array, array)
	    } else {
	      ops.assign(buf_array, array)
	    }
	    buffer = buf_store.subarray(0, size)
	  } else if (array.offset === 0 && array.data.length === size) {
	    buffer = array.data
	  } else {
	    buffer = array.data.subarray(array.offset, array.offset + size)
	  }
	  var tex = initTexture(gl)
	  gl.texImage2D(gl.TEXTURE_2D, 0, format, shape[0], shape[1], 0, format, type, buffer)
	  if(!packed) {
	    pool.free(buf_store)
	  }
	  return new Texture2D(gl, tex, shape[0], shape[1], format, type)
	}
	
	function createTexture2D(gl) {
	  if(arguments.length <= 1) {
	    throw new Error('gl-texture2d: Missing arguments for texture2d constructor')
	  }
	  if(!linearTypes) {
	    lazyInitLinearTypes(gl)
	  }
	  if(typeof arguments[1] === 'number') {
	    return createTextureShape(gl, arguments[1], arguments[2], arguments[3]||gl.RGBA, arguments[4]||gl.UNSIGNED_BYTE)
	  }
	  if(Array.isArray(arguments[1])) {
	    return createTextureShape(gl, arguments[1][0]|0, arguments[1][1]|0, arguments[2]||gl.RGBA, arguments[3]||gl.UNSIGNED_BYTE)
	  }
	  if(typeof arguments[1] === 'object') {
	    var obj = arguments[1]
	    var directData = acceptTextureDOM(obj) ? obj : obj.raw
	    if (directData) {
	      return createTextureDOM(gl, directData, obj.width|0, obj.height|0, arguments[2]||gl.RGBA, arguments[3]||gl.UNSIGNED_BYTE)
	    } else if(obj.shape && obj.data && obj.stride) {
	      return createTextureArray(gl, obj)
	    }
	  }
	  throw new Error('gl-texture2d: Invalid arguments for texture2d constructor')
	}
	
	},{"ndarray":451,"ndarray-ops":445,"typedarray-pool":543}],324:[function(_dereq_,module,exports){
	(function (global){
	/** @module  gl-util/context */
	'use strict'
	
	var pick = _dereq_('pick-by-alias')
	
	module.exports = function setContext (o) {
		if (!o) o = {}
		else if (typeof o === 'string') o = {container: o}
	
		// HTMLCanvasElement
		if (isCanvas(o)) {
			o = {container: o}
		}
		// HTMLElement
		else if (isElement(o)) {
			o = {container: o}
		}
		// WebGLContext
		else if (isContext(o)) {
			o = {gl: o}
		}
		// options object
		else {
			o = pick(o, {
				container: 'container target element el canvas holder parent parentNode wrapper use ref root node',
				gl: 'gl context webgl glContext',
				attrs: 'attributes attrs contextAttributes',
				pixelRatio: 'pixelRatio pxRatio px ratio pxratio pixelratio',
				width: 'w width',
				height: 'h height'
			}, true)
		}
	
		if (!o.pixelRatio) o.pixelRatio = global.pixelRatio || 1
	
		// make sure there is container and canvas
		if (o.gl) {
			return o.gl
		}
		if (o.canvas) {
			o.container = o.canvas.parentNode
		}
		if (o.container) {
			if (typeof o.container === 'string') {
				var c = document.querySelector(o.container)
				if (!c) throw Error('Element ' + o.container + ' is not found')
				o.container = c
			}
			if (isCanvas(o.container)) {
				o.canvas = o.container
				o.container = o.canvas.parentNode
			}
			else if (!o.canvas) {
				o.canvas = createCanvas()
				o.container.appendChild(o.canvas)
				resize(o)
			}
		}
		// blank new canvas
		else if (!o.canvas) {
			if (typeof document !== 'undefined') {
				o.container = document.body || document.documentElement
				o.canvas = createCanvas()
				o.container.appendChild(o.canvas)
				resize(o)
			}
			else {
				throw Error('Not DOM environment. Use headless-gl.')
			}
		}
	
		// make sure there is context
		if (!o.gl) {
			try {
				o.gl = o.canvas.getContext('webgl', o.attrs)
			} catch (e) {
				try {
					o.gl = o.canvas.getContext('experimental-webgl', o.attrs)
				}
				catch (e) {
					o.gl = o.canvas.getContext('webgl-experimental', o.attrs)
				}
			}
		}
	
		return o.gl
	}
	
	
	function resize (o) {
		if (o.container) {
			if (o.container == document.body) {
				if (!document.body.style.width) o.canvas.width = o.width || (o.pixelRatio * global.innerWidth)
				if (!document.body.style.height) o.canvas.height = o.height || (o.pixelRatio * global.innerHeight)
			}
			else {
				var bounds = o.container.getBoundingClientRect()
				o.canvas.width = o.width || (bounds.right - bounds.left)
				o.canvas.height = o.height || (bounds.bottom - bounds.top)
			}
		}
	}
	
	function isCanvas (e) {
		return typeof e.getContext === 'function'
			&& 'width' in e
			&& 'height' in e
	}
	
	function isElement (e) {
		return typeof e.nodeName === 'string' &&
			typeof e.appendChild === 'function' &&
			typeof e.getBoundingClientRect === 'function'
	}
	
	function isContext (e) {
		return typeof e.drawArrays === 'function' ||
			typeof e.drawElements === 'function'
	}
	
	function createCanvas () {
		var canvas = document.createElement('canvas')
		canvas.style.position = 'absolute'
		canvas.style.top = 0
		canvas.style.left = 0
	
		return canvas
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"pick-by-alias":466}],325:[function(_dereq_,module,exports){
	"use strict"
	
	function doBind(gl, elements, attributes) {
	  if(elements) {
	    elements.bind()
	  } else {
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)
	  }
	  var nattribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS)|0
	  if(attributes) {
	    if(attributes.length > nattribs) {
	      throw new Error("gl-vao: Too many vertex attributes")
	    }
	    for(var i=0; i<attributes.length; ++i) {
	      var attrib = attributes[i]
	      if(attrib.buffer) {
	        var buffer = attrib.buffer
	        var size = attrib.size || 4
	        var type = attrib.type || gl.FLOAT
	        var normalized = !!attrib.normalized
	        var stride = attrib.stride || 0
	        var offset = attrib.offset || 0
	        buffer.bind()
	        gl.enableVertexAttribArray(i)
	        gl.vertexAttribPointer(i, size, type, normalized, stride, offset)
	      } else {
	        if(typeof attrib === "number") {
	          gl.vertexAttrib1f(i, attrib)
	        } else if(attrib.length === 1) {
	          gl.vertexAttrib1f(i, attrib[0])
	        } else if(attrib.length === 2) {
	          gl.vertexAttrib2f(i, attrib[0], attrib[1])
	        } else if(attrib.length === 3) {
	          gl.vertexAttrib3f(i, attrib[0], attrib[1], attrib[2])
	        } else if(attrib.length === 4) {
	          gl.vertexAttrib4f(i, attrib[0], attrib[1], attrib[2], attrib[3])
	        } else {
	          throw new Error("gl-vao: Invalid vertex attribute")
	        }
	        gl.disableVertexAttribArray(i)
	      }
	    }
	    for(; i<nattribs; ++i) {
	      gl.disableVertexAttribArray(i)
	    }
	  } else {
	    gl.bindBuffer(gl.ARRAY_BUFFER, null)
	    for(var i=0; i<nattribs; ++i) {
	      gl.disableVertexAttribArray(i)
	    }
	  }
	}
	
	module.exports = doBind
	},{}],326:[function(_dereq_,module,exports){
	"use strict"
	
	var bindAttribs = _dereq_("./do-bind.js")
	
	function VAOEmulated(gl) {
	  this.gl = gl
	  this._elements = null
	  this._attributes = null
	  this._elementsType = gl.UNSIGNED_SHORT
	}
	
	VAOEmulated.prototype.bind = function() {
	  bindAttribs(this.gl, this._elements, this._attributes)
	}
	
	VAOEmulated.prototype.update = function(attributes, elements, elementsType) {
	  this._elements = elements
	  this._attributes = attributes
	  this._elementsType = elementsType || this.gl.UNSIGNED_SHORT
	}
	
	VAOEmulated.prototype.dispose = function() { }
	VAOEmulated.prototype.unbind = function() { }
	
	VAOEmulated.prototype.draw = function(mode, count, offset) {
	  offset = offset || 0
	  var gl = this.gl
	  if(this._elements) {
	    gl.drawElements(mode, count, this._elementsType, offset)
	  } else {
	    gl.drawArrays(mode, offset, count)
	  }
	}
	
	function createVAOEmulated(gl) {
	  return new VAOEmulated(gl)
	}
	
	module.exports = createVAOEmulated
	},{"./do-bind.js":325}],327:[function(_dereq_,module,exports){
	"use strict"
	
	var bindAttribs = _dereq_("./do-bind.js")
	
	function VertexAttribute(location, dimension, a, b, c, d) {
	  this.location = location
	  this.dimension = dimension
	  this.a = a
	  this.b = b
	  this.c = c
	  this.d = d
	}
	
	VertexAttribute.prototype.bind = function(gl) {
	  switch(this.dimension) {
	    case 1:
	      gl.vertexAttrib1f(this.location, this.a)
	    break
	    case 2:
	      gl.vertexAttrib2f(this.location, this.a, this.b)
	    break
	    case 3:
	      gl.vertexAttrib3f(this.location, this.a, this.b, this.c)
	    break
	    case 4:
	      gl.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d)
	    break
	  }
	}
	
	function VAONative(gl, ext, handle) {
	  this.gl = gl
	  this._ext = ext
	  this.handle = handle
	  this._attribs = []
	  this._useElements = false
	  this._elementsType = gl.UNSIGNED_SHORT
	}
	
	VAONative.prototype.bind = function() {
	  this._ext.bindVertexArrayOES(this.handle)
	  for(var i=0; i<this._attribs.length; ++i) {
	    this._attribs[i].bind(this.gl)
	  }
	}
	
	VAONative.prototype.unbind = function() {
	  this._ext.bindVertexArrayOES(null)
	}
	
	VAONative.prototype.dispose = function() {
	  this._ext.deleteVertexArrayOES(this.handle)
	}
	
	VAONative.prototype.update = function(attributes, elements, elementsType) {
	  this.bind()
	  bindAttribs(this.gl, elements, attributes)
	  this.unbind()
	  this._attribs.length = 0
	  if(attributes)
	  for(var i=0; i<attributes.length; ++i) {
	    var a = attributes[i]
	    if(typeof a === "number") {
	      this._attribs.push(new VertexAttribute(i, 1, a))
	    } else if(Array.isArray(a)) {
	      this._attribs.push(new VertexAttribute(i, a.length, a[0], a[1], a[2], a[3]))
	    }
	  }
	  this._useElements = !!elements
	  this._elementsType = elementsType || this.gl.UNSIGNED_SHORT
	}
	
	VAONative.prototype.draw = function(mode, count, offset) {
	  offset = offset || 0
	  var gl = this.gl
	  if(this._useElements) {
	    gl.drawElements(mode, count, this._elementsType, offset)
	  } else {
	    gl.drawArrays(mode, offset, count)
	  }
	}
	
	function createVAONative(gl, ext) {
	  return new VAONative(gl, ext, ext.createVertexArrayOES())
	}
	
	module.exports = createVAONative
	},{"./do-bind.js":325}],328:[function(_dereq_,module,exports){
	"use strict"
	
	var createVAONative = _dereq_("./lib/vao-native.js")
	var createVAOEmulated = _dereq_("./lib/vao-emulated.js")
	
	function ExtensionShim (gl) {
	  this.bindVertexArrayOES = gl.bindVertexArray.bind(gl)
	  this.createVertexArrayOES = gl.createVertexArray.bind(gl)
	  this.deleteVertexArrayOES = gl.deleteVertexArray.bind(gl)
	}
	
	function createVAO(gl, attributes, elements, elementsType) {
	  var ext = gl.createVertexArray
	    ? new ExtensionShim(gl)
	    : gl.getExtension('OES_vertex_array_object')
	  var vao
	
	  if(ext) {
	    vao = createVAONative(gl, ext)
	  } else {
	    vao = createVAOEmulated(gl)
	  }
	  vao.update(attributes, elements, elementsType)
	  return vao
	}
	
	module.exports = createVAO
	
	},{"./lib/vao-emulated.js":326,"./lib/vao-native.js":327}],329:[function(_dereq_,module,exports){
	module.exports = add;
	
	/**
	 * Adds two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function add(out, a, b) {
	    out[0] = a[0] + b[0]
	    out[1] = a[1] + b[1]
	    out[2] = a[2] + b[2]
	    return out
	}
	},{}],330:[function(_dereq_,module,exports){
	module.exports = angle
	
	var fromValues = _dereq_('./fromValues')
	var normalize = _dereq_('./normalize')
	var dot = _dereq_('./dot')
	
	/**
	 * Get the angle between two 3D vectors
	 * @param {vec3} a The first operand
	 * @param {vec3} b The second operand
	 * @returns {Number} The angle in radians
	 */
	function angle(a, b) {
	    var tempA = fromValues(a[0], a[1], a[2])
	    var tempB = fromValues(b[0], b[1], b[2])
	 
	    normalize(tempA, tempA)
	    normalize(tempB, tempB)
	 
	    var cosine = dot(tempA, tempB)
	
	    if(cosine > 1.0){
	        return 0
	    } else {
	        return Math.acos(cosine)
	    }     
	}
	
	},{"./dot":340,"./fromValues":346,"./normalize":357}],331:[function(_dereq_,module,exports){
	module.exports = ceil
	
	/**
	 * Math.ceil the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to ceil
	 * @returns {vec3} out
	 */
	function ceil(out, a) {
	  out[0] = Math.ceil(a[0])
	  out[1] = Math.ceil(a[1])
	  out[2] = Math.ceil(a[2])
	  return out
	}
	
	},{}],332:[function(_dereq_,module,exports){
	module.exports = clone;
	
	/**
	 * Creates a new vec3 initialized with values from an existing vector
	 *
	 * @param {vec3} a vector to clone
	 * @returns {vec3} a new 3D vector
	 */
	function clone(a) {
	    var out = new Float32Array(3)
	    out[0] = a[0]
	    out[1] = a[1]
	    out[2] = a[2]
	    return out
	}
	},{}],333:[function(_dereq_,module,exports){
	module.exports = copy;
	
	/**
	 * Copy the values from one vec3 to another
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the source vector
	 * @returns {vec3} out
	 */
	function copy(out, a) {
	    out[0] = a[0]
	    out[1] = a[1]
	    out[2] = a[2]
	    return out
	}
	},{}],334:[function(_dereq_,module,exports){
	module.exports = create;
	
	/**
	 * Creates a new, empty vec3
	 *
	 * @returns {vec3} a new 3D vector
	 */
	function create() {
	    var out = new Float32Array(3)
	    out[0] = 0
	    out[1] = 0
	    out[2] = 0
	    return out
	}
	},{}],335:[function(_dereq_,module,exports){
	module.exports = cross;
	
	/**
	 * Computes the cross product of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function cross(out, a, b) {
	    var ax = a[0], ay = a[1], az = a[2],
	        bx = b[0], by = b[1], bz = b[2]
	
	    out[0] = ay * bz - az * by
	    out[1] = az * bx - ax * bz
	    out[2] = ax * by - ay * bx
	    return out
	}
	},{}],336:[function(_dereq_,module,exports){
	module.exports = _dereq_('./distance')
	
	},{"./distance":337}],337:[function(_dereq_,module,exports){
	module.exports = distance;
	
	/**
	 * Calculates the euclidian distance between two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} distance between a and b
	 */
	function distance(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2]
	    return Math.sqrt(x*x + y*y + z*z)
	}
	},{}],338:[function(_dereq_,module,exports){
	module.exports = _dereq_('./divide')
	
	},{"./divide":339}],339:[function(_dereq_,module,exports){
	module.exports = divide;
	
	/**
	 * Divides two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function divide(out, a, b) {
	    out[0] = a[0] / b[0]
	    out[1] = a[1] / b[1]
	    out[2] = a[2] / b[2]
	    return out
	}
	},{}],340:[function(_dereq_,module,exports){
	module.exports = dot;
	
	/**
	 * Calculates the dot product of two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} dot product of a and b
	 */
	function dot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]
	}
	},{}],341:[function(_dereq_,module,exports){
	module.exports = 0.000001
	
	},{}],342:[function(_dereq_,module,exports){
	module.exports = equals
	
	var EPSILON = _dereq_('./epsilon')
	
	/**
	 * Returns whether or not the vectors have approximately the same elements in the same position.
	 *
	 * @param {vec3} a The first vector.
	 * @param {vec3} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	function equals(a, b) {
	  var a0 = a[0]
	  var a1 = a[1]
	  var a2 = a[2]
	  var b0 = b[0]
	  var b1 = b[1]
	  var b2 = b[2]
	  return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	          Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	          Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)))
	}
	
	},{"./epsilon":341}],343:[function(_dereq_,module,exports){
	module.exports = exactEquals
	
	/**
	 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
	 *
	 * @param {vec3} a The first vector.
	 * @param {vec3} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	function exactEquals(a, b) {
	  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2]
	}
	
	},{}],344:[function(_dereq_,module,exports){
	module.exports = floor
	
	/**
	 * Math.floor the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to floor
	 * @returns {vec3} out
	 */
	function floor(out, a) {
	  out[0] = Math.floor(a[0])
	  out[1] = Math.floor(a[1])
	  out[2] = Math.floor(a[2])
	  return out
	}
	
	},{}],345:[function(_dereq_,module,exports){
	module.exports = forEach;
	
	var vec = _dereq_('./create')()
	
	/**
	 * Perform some operation over an array of vec3s.
	 *
	 * @param {Array} a the array of vectors to iterate over
	 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
	 * @param {Number} offset Number of elements to skip at the beginning of the array
	 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
	 * @param {Function} fn Function to call for each vector in the array
	 * @param {Object} [arg] additional argument to pass to fn
	 * @returns {Array} a
	 * @function
	 */
	function forEach(a, stride, offset, count, fn, arg) {
	        var i, l
	        if(!stride) {
	            stride = 3
	        }
	
	        if(!offset) {
	            offset = 0
	        }
	        
	        if(count) {
	            l = Math.min((count * stride) + offset, a.length)
	        } else {
	            l = a.length
	        }
	
	        for(i = offset; i < l; i += stride) {
	            vec[0] = a[i] 
	            vec[1] = a[i+1] 
	            vec[2] = a[i+2]
	            fn(vec, vec, arg)
	            a[i] = vec[0] 
	            a[i+1] = vec[1] 
	            a[i+2] = vec[2]
	        }
	        
	        return a
	}
	},{"./create":334}],346:[function(_dereq_,module,exports){
	module.exports = fromValues;
	
	/**
	 * Creates a new vec3 initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @returns {vec3} a new 3D vector
	 */
	function fromValues(x, y, z) {
	    var out = new Float32Array(3)
	    out[0] = x
	    out[1] = y
	    out[2] = z
	    return out
	}
	},{}],347:[function(_dereq_,module,exports){
	module.exports = {
	  EPSILON: _dereq_('./epsilon')
	  , create: _dereq_('./create')
	  , clone: _dereq_('./clone')
	  , angle: _dereq_('./angle')
	  , fromValues: _dereq_('./fromValues')
	  , copy: _dereq_('./copy')
	  , set: _dereq_('./set')
	  , equals: _dereq_('./equals')
	  , exactEquals: _dereq_('./exactEquals')
	  , add: _dereq_('./add')
	  , subtract: _dereq_('./subtract')
	  , sub: _dereq_('./sub')
	  , multiply: _dereq_('./multiply')
	  , mul: _dereq_('./mul')
	  , divide: _dereq_('./divide')
	  , div: _dereq_('./div')
	  , min: _dereq_('./min')
	  , max: _dereq_('./max')
	  , floor: _dereq_('./floor')
	  , ceil: _dereq_('./ceil')
	  , round: _dereq_('./round')
	  , scale: _dereq_('./scale')
	  , scaleAndAdd: _dereq_('./scaleAndAdd')
	  , distance: _dereq_('./distance')
	  , dist: _dereq_('./dist')
	  , squaredDistance: _dereq_('./squaredDistance')
	  , sqrDist: _dereq_('./sqrDist')
	  , length: _dereq_('./length')
	  , len: _dereq_('./len')
	  , squaredLength: _dereq_('./squaredLength')
	  , sqrLen: _dereq_('./sqrLen')
	  , negate: _dereq_('./negate')
	  , inverse: _dereq_('./inverse')
	  , normalize: _dereq_('./normalize')
	  , dot: _dereq_('./dot')
	  , cross: _dereq_('./cross')
	  , lerp: _dereq_('./lerp')
	  , random: _dereq_('./random')
	  , transformMat4: _dereq_('./transformMat4')
	  , transformMat3: _dereq_('./transformMat3')
	  , transformQuat: _dereq_('./transformQuat')
	  , rotateX: _dereq_('./rotateX')
	  , rotateY: _dereq_('./rotateY')
	  , rotateZ: _dereq_('./rotateZ')
	  , forEach: _dereq_('./forEach')
	}
	
	},{"./add":329,"./angle":330,"./ceil":331,"./clone":332,"./copy":333,"./create":334,"./cross":335,"./dist":336,"./distance":337,"./div":338,"./divide":339,"./dot":340,"./epsilon":341,"./equals":342,"./exactEquals":343,"./floor":344,"./forEach":345,"./fromValues":346,"./inverse":348,"./len":349,"./length":350,"./lerp":351,"./max":352,"./min":353,"./mul":354,"./multiply":355,"./negate":356,"./normalize":357,"./random":358,"./rotateX":359,"./rotateY":360,"./rotateZ":361,"./round":362,"./scale":363,"./scaleAndAdd":364,"./set":365,"./sqrDist":366,"./sqrLen":367,"./squaredDistance":368,"./squaredLength":369,"./sub":370,"./subtract":371,"./transformMat3":372,"./transformMat4":373,"./transformQuat":374}],348:[function(_dereq_,module,exports){
	module.exports = inverse;
	
	/**
	 * Returns the inverse of the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to invert
	 * @returns {vec3} out
	 */
	function inverse(out, a) {
	  out[0] = 1.0 / a[0]
	  out[1] = 1.0 / a[1]
	  out[2] = 1.0 / a[2]
	  return out
	}
	},{}],349:[function(_dereq_,module,exports){
	module.exports = _dereq_('./length')
	
	},{"./length":350}],350:[function(_dereq_,module,exports){
	module.exports = length;
	
	/**
	 * Calculates the length of a vec3
	 *
	 * @param {vec3} a vector to calculate length of
	 * @returns {Number} length of a
	 */
	function length(a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2]
	    return Math.sqrt(x*x + y*y + z*z)
	}
	},{}],351:[function(_dereq_,module,exports){
	module.exports = lerp;
	
	/**
	 * Performs a linear interpolation between two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec3} out
	 */
	function lerp(out, a, b, t) {
	    var ax = a[0],
	        ay = a[1],
	        az = a[2]
	    out[0] = ax + t * (b[0] - ax)
	    out[1] = ay + t * (b[1] - ay)
	    out[2] = az + t * (b[2] - az)
	    return out
	}
	},{}],352:[function(_dereq_,module,exports){
	module.exports = max;
	
	/**
	 * Returns the maximum of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function max(out, a, b) {
	    out[0] = Math.max(a[0], b[0])
	    out[1] = Math.max(a[1], b[1])
	    out[2] = Math.max(a[2], b[2])
	    return out
	}
	},{}],353:[function(_dereq_,module,exports){
	module.exports = min;
	
	/**
	 * Returns the minimum of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function min(out, a, b) {
	    out[0] = Math.min(a[0], b[0])
	    out[1] = Math.min(a[1], b[1])
	    out[2] = Math.min(a[2], b[2])
	    return out
	}
	},{}],354:[function(_dereq_,module,exports){
	module.exports = _dereq_('./multiply')
	
	},{"./multiply":355}],355:[function(_dereq_,module,exports){
	module.exports = multiply;
	
	/**
	 * Multiplies two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function multiply(out, a, b) {
	    out[0] = a[0] * b[0]
	    out[1] = a[1] * b[1]
	    out[2] = a[2] * b[2]
	    return out
	}
	},{}],356:[function(_dereq_,module,exports){
	module.exports = negate;
	
	/**
	 * Negates the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to negate
	 * @returns {vec3} out
	 */
	function negate(out, a) {
	    out[0] = -a[0]
	    out[1] = -a[1]
	    out[2] = -a[2]
	    return out
	}
	},{}],357:[function(_dereq_,module,exports){
	module.exports = normalize;
	
	/**
	 * Normalize a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to normalize
	 * @returns {vec3} out
	 */
	function normalize(out, a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2]
	    var len = x*x + y*y + z*z
	    if (len > 0) {
	        //TODO: evaluate use of glm_invsqrt here?
	        len = 1 / Math.sqrt(len)
	        out[0] = a[0] * len
	        out[1] = a[1] * len
	        out[2] = a[2] * len
	    }
	    return out
	}
	},{}],358:[function(_dereq_,module,exports){
	module.exports = random;
	
	/**
	 * Generates a random vector with the given scale
	 *
	 * @param {vec3} out the receiving vector
	 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
	 * @returns {vec3} out
	 */
	function random(out, scale) {
	    scale = scale || 1.0
	
	    var r = Math.random() * 2.0 * Math.PI
	    var z = (Math.random() * 2.0) - 1.0
	    var zScale = Math.sqrt(1.0-z*z) * scale
	
	    out[0] = Math.cos(r) * zScale
	    out[1] = Math.sin(r) * zScale
	    out[2] = z * scale
	    return out
	}
	},{}],359:[function(_dereq_,module,exports){
	module.exports = rotateX;
	
	/**
	 * Rotate a 3D vector around the x-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	function rotateX(out, a, b, c){
	    var by = b[1]
	    var bz = b[2]
	
	    // Translate point to the origin
	    var py = a[1] - by
	    var pz = a[2] - bz
	
	    var sc = Math.sin(c)
	    var cc = Math.cos(c)
	
	    // perform rotation and translate to correct position
	    out[0] = a[0]
	    out[1] = by + py * cc - pz * sc
	    out[2] = bz + py * sc + pz * cc
	
	    return out
	}
	
	},{}],360:[function(_dereq_,module,exports){
	module.exports = rotateY;
	
	/**
	 * Rotate a 3D vector around the y-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	function rotateY(out, a, b, c){
	    var bx = b[0]
	    var bz = b[2]
	
	    // translate point to the origin
	    var px = a[0] - bx
	    var pz = a[2] - bz
	    
	    var sc = Math.sin(c)
	    var cc = Math.cos(c)
	  
	    // perform rotation and translate to correct position
	    out[0] = bx + pz * sc + px * cc
	    out[1] = a[1]
	    out[2] = bz + pz * cc - px * sc
	  
	    return out
	}
	
	},{}],361:[function(_dereq_,module,exports){
	module.exports = rotateZ;
	
	/**
	 * Rotate a 3D vector around the z-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	function rotateZ(out, a, b, c){
	    var bx = b[0]
	    var by = b[1]
	
	    //Translate point to the origin
	    var px = a[0] - bx
	    var py = a[1] - by
	  
	    var sc = Math.sin(c)
	    var cc = Math.cos(c)
	
	    // perform rotation and translate to correct position
	    out[0] = bx + px * cc - py * sc
	    out[1] = by + px * sc + py * cc
	    out[2] = a[2]
	  
	    return out
	}
	
	},{}],362:[function(_dereq_,module,exports){
	module.exports = round
	
	/**
	 * Math.round the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to round
	 * @returns {vec3} out
	 */
	function round(out, a) {
	  out[0] = Math.round(a[0])
	  out[1] = Math.round(a[1])
	  out[2] = Math.round(a[2])
	  return out
	}
	
	},{}],363:[function(_dereq_,module,exports){
	module.exports = scale;
	
	/**
	 * Scales a vec3 by a scalar number
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {vec3} out
	 */
	function scale(out, a, b) {
	    out[0] = a[0] * b
	    out[1] = a[1] * b
	    out[2] = a[2] * b
	    return out
	}
	},{}],364:[function(_dereq_,module,exports){
	module.exports = scaleAndAdd;
	
	/**
	 * Adds two vec3's after scaling the second operand by a scalar value
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {Number} scale the amount to scale b by before adding
	 * @returns {vec3} out
	 */
	function scaleAndAdd(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale)
	    out[1] = a[1] + (b[1] * scale)
	    out[2] = a[2] + (b[2] * scale)
	    return out
	}
	},{}],365:[function(_dereq_,module,exports){
	module.exports = set;
	
	/**
	 * Set the components of a vec3 to the given values
	 *
	 * @param {vec3} out the receiving vector
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @returns {vec3} out
	 */
	function set(out, x, y, z) {
	    out[0] = x
	    out[1] = y
	    out[2] = z
	    return out
	}
	},{}],366:[function(_dereq_,module,exports){
	module.exports = _dereq_('./squaredDistance')
	
	},{"./squaredDistance":368}],367:[function(_dereq_,module,exports){
	module.exports = _dereq_('./squaredLength')
	
	},{"./squaredLength":369}],368:[function(_dereq_,module,exports){
	module.exports = squaredDistance;
	
	/**
	 * Calculates the squared euclidian distance between two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} squared distance between a and b
	 */
	function squaredDistance(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2]
	    return x*x + y*y + z*z
	}
	},{}],369:[function(_dereq_,module,exports){
	module.exports = squaredLength;
	
	/**
	 * Calculates the squared length of a vec3
	 *
	 * @param {vec3} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 */
	function squaredLength(a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2]
	    return x*x + y*y + z*z
	}
	},{}],370:[function(_dereq_,module,exports){
	module.exports = _dereq_('./subtract')
	
	},{"./subtract":371}],371:[function(_dereq_,module,exports){
	module.exports = subtract;
	
	/**
	 * Subtracts vector b from vector a
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	function subtract(out, a, b) {
	    out[0] = a[0] - b[0]
	    out[1] = a[1] - b[1]
	    out[2] = a[2] - b[2]
	    return out
	}
	},{}],372:[function(_dereq_,module,exports){
	module.exports = transformMat3;
	
	/**
	 * Transforms the vec3 with a mat3.
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {mat4} m the 3x3 matrix to transform with
	 * @returns {vec3} out
	 */
	function transformMat3(out, a, m) {
	    var x = a[0], y = a[1], z = a[2]
	    out[0] = x * m[0] + y * m[3] + z * m[6]
	    out[1] = x * m[1] + y * m[4] + z * m[7]
	    out[2] = x * m[2] + y * m[5] + z * m[8]
	    return out
	}
	},{}],373:[function(_dereq_,module,exports){
	module.exports = transformMat4;
	
	/**
	 * Transforms the vec3 with a mat4.
	 * 4th vector component is implicitly '1'
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {mat4} m matrix to transform with
	 * @returns {vec3} out
	 */
	function transformMat4(out, a, m) {
	    var x = a[0], y = a[1], z = a[2],
	        w = m[3] * x + m[7] * y + m[11] * z + m[15]
	    w = w || 1.0
	    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w
	    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w
	    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w
	    return out
	}
	},{}],374:[function(_dereq_,module,exports){
	module.exports = transformQuat;
	
	/**
	 * Transforms the vec3 with a quat
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {quat} q quaternion to transform with
	 * @returns {vec3} out
	 */
	function transformQuat(out, a, q) {
	    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
	
	    var x = a[0], y = a[1], z = a[2],
	        qx = q[0], qy = q[1], qz = q[2], qw = q[3],
	
	        // calculate quat * vec
	        ix = qw * x + qy * z - qz * y,
	        iy = qw * y + qz * x - qx * z,
	        iz = qw * z + qx * y - qy * x,
	        iw = -qx * x - qy * y - qz * z
	
	    // calculate result * inverse quat
	    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy
	    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz
	    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx
	    return out
	}
	},{}],375:[function(_dereq_,module,exports){
	module.exports = add
	
	/**
	 * Adds two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function add (out, a, b) {
	  out[0] = a[0] + b[0]
	  out[1] = a[1] + b[1]
	  out[2] = a[2] + b[2]
	  out[3] = a[3] + b[3]
	  return out
	}
	
	},{}],376:[function(_dereq_,module,exports){
	module.exports = clone
	
	/**
	 * Creates a new vec4 initialized with values from an existing vector
	 *
	 * @param {vec4} a vector to clone
	 * @returns {vec4} a new 4D vector
	 */
	function clone (a) {
	  var out = new Float32Array(4)
	  out[0] = a[0]
	  out[1] = a[1]
	  out[2] = a[2]
	  out[3] = a[3]
	  return out
	}
	
	},{}],377:[function(_dereq_,module,exports){
	module.exports = copy
	
	/**
	 * Copy the values from one vec4 to another
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the source vector
	 * @returns {vec4} out
	 */
	function copy (out, a) {
	  out[0] = a[0]
	  out[1] = a[1]
	  out[2] = a[2]
	  out[3] = a[3]
	  return out
	}
	
	},{}],378:[function(_dereq_,module,exports){
	module.exports = create
	
	/**
	 * Creates a new, empty vec4
	 *
	 * @returns {vec4} a new 4D vector
	 */
	function create () {
	  var out = new Float32Array(4)
	  out[0] = 0
	  out[1] = 0
	  out[2] = 0
	  out[3] = 0
	  return out
	}
	
	},{}],379:[function(_dereq_,module,exports){
	module.exports = distance
	
	/**
	 * Calculates the euclidian distance between two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} distance between a and b
	 */
	function distance (a, b) {
	  var x = b[0] - a[0],
	    y = b[1] - a[1],
	    z = b[2] - a[2],
	    w = b[3] - a[3]
	  return Math.sqrt(x * x + y * y + z * z + w * w)
	}
	
	},{}],380:[function(_dereq_,module,exports){
	module.exports = divide
	
	/**
	 * Divides two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function divide (out, a, b) {
	  out[0] = a[0] / b[0]
	  out[1] = a[1] / b[1]
	  out[2] = a[2] / b[2]
	  out[3] = a[3] / b[3]
	  return out
	}
	
	},{}],381:[function(_dereq_,module,exports){
	module.exports = dot
	
	/**
	 * Calculates the dot product of two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} dot product of a and b
	 */
	function dot (a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3]
	}
	
	},{}],382:[function(_dereq_,module,exports){
	module.exports = fromValues
	
	/**
	 * Creates a new vec4 initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {vec4} a new 4D vector
	 */
	function fromValues (x, y, z, w) {
	  var out = new Float32Array(4)
	  out[0] = x
	  out[1] = y
	  out[2] = z
	  out[3] = w
	  return out
	}
	
	},{}],383:[function(_dereq_,module,exports){
	module.exports = {
	  create: _dereq_('./create'),
	  clone: _dereq_('./clone'),
	  fromValues: _dereq_('./fromValues'),
	  copy: _dereq_('./copy'),
	  set: _dereq_('./set'),
	  add: _dereq_('./add'),
	  subtract: _dereq_('./subtract'),
	  multiply: _dereq_('./multiply'),
	  divide: _dereq_('./divide'),
	  min: _dereq_('./min'),
	  max: _dereq_('./max'),
	  scale: _dereq_('./scale'),
	  scaleAndAdd: _dereq_('./scaleAndAdd'),
	  distance: _dereq_('./distance'),
	  squaredDistance: _dereq_('./squaredDistance'),
	  length: _dereq_('./length'),
	  squaredLength: _dereq_('./squaredLength'),
	  negate: _dereq_('./negate'),
	  inverse: _dereq_('./inverse'),
	  normalize: _dereq_('./normalize'),
	  dot: _dereq_('./dot'),
	  lerp: _dereq_('./lerp'),
	  random: _dereq_('./random'),
	  transformMat4: _dereq_('./transformMat4'),
	  transformQuat: _dereq_('./transformQuat')
	}
	
	},{"./add":375,"./clone":376,"./copy":377,"./create":378,"./distance":379,"./divide":380,"./dot":381,"./fromValues":382,"./inverse":384,"./length":385,"./lerp":386,"./max":387,"./min":388,"./multiply":389,"./negate":390,"./normalize":391,"./random":392,"./scale":393,"./scaleAndAdd":394,"./set":395,"./squaredDistance":396,"./squaredLength":397,"./subtract":398,"./transformMat4":399,"./transformQuat":400}],384:[function(_dereq_,module,exports){
	module.exports = inverse
	
	/**
	 * Returns the inverse of the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to invert
	 * @returns {vec4} out
	 */
	function inverse (out, a) {
	  out[0] = 1.0 / a[0]
	  out[1] = 1.0 / a[1]
	  out[2] = 1.0 / a[2]
	  out[3] = 1.0 / a[3]
	  return out
	}
	
	},{}],385:[function(_dereq_,module,exports){
	module.exports = length
	
	/**
	 * Calculates the length of a vec4
	 *
	 * @param {vec4} a vector to calculate length of
	 * @returns {Number} length of a
	 */
	function length (a) {
	  var x = a[0],
	    y = a[1],
	    z = a[2],
	    w = a[3]
	  return Math.sqrt(x * x + y * y + z * z + w * w)
	}
	
	},{}],386:[function(_dereq_,module,exports){
	module.exports = lerp
	
	/**
	 * Performs a linear interpolation between two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec4} out
	 */
	function lerp (out, a, b, t) {
	  var ax = a[0],
	    ay = a[1],
	    az = a[2],
	    aw = a[3]
	  out[0] = ax + t * (b[0] - ax)
	  out[1] = ay + t * (b[1] - ay)
	  out[2] = az + t * (b[2] - az)
	  out[3] = aw + t * (b[3] - aw)
	  return out
	}
	
	},{}],387:[function(_dereq_,module,exports){
	module.exports = max
	
	/**
	 * Returns the maximum of two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function max (out, a, b) {
	  out[0] = Math.max(a[0], b[0])
	  out[1] = Math.max(a[1], b[1])
	  out[2] = Math.max(a[2], b[2])
	  out[3] = Math.max(a[3], b[3])
	  return out
	}
	
	},{}],388:[function(_dereq_,module,exports){
	module.exports = min
	
	/**
	 * Returns the minimum of two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function min (out, a, b) {
	  out[0] = Math.min(a[0], b[0])
	  out[1] = Math.min(a[1], b[1])
	  out[2] = Math.min(a[2], b[2])
	  out[3] = Math.min(a[3], b[3])
	  return out
	}
	
	},{}],389:[function(_dereq_,module,exports){
	module.exports = multiply
	
	/**
	 * Multiplies two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function multiply (out, a, b) {
	  out[0] = a[0] * b[0]
	  out[1] = a[1] * b[1]
	  out[2] = a[2] * b[2]
	  out[3] = a[3] * b[3]
	  return out
	}
	
	},{}],390:[function(_dereq_,module,exports){
	module.exports = negate
	
	/**
	 * Negates the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to negate
	 * @returns {vec4} out
	 */
	function negate (out, a) {
	  out[0] = -a[0]
	  out[1] = -a[1]
	  out[2] = -a[2]
	  out[3] = -a[3]
	  return out
	}
	
	},{}],391:[function(_dereq_,module,exports){
	module.exports = normalize
	
	/**
	 * Normalize a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to normalize
	 * @returns {vec4} out
	 */
	function normalize (out, a) {
	  var x = a[0],
	    y = a[1],
	    z = a[2],
	    w = a[3]
	  var len = x * x + y * y + z * z + w * w
	  if (len > 0) {
	    len = 1 / Math.sqrt(len)
	    out[0] = x * len
	    out[1] = y * len
	    out[2] = z * len
	    out[3] = w * len
	  }
	  return out
	}
	
	},{}],392:[function(_dereq_,module,exports){
	var vecNormalize = _dereq_('./normalize')
	var vecScale = _dereq_('./scale')
	
	module.exports = random
	
	/**
	 * Generates a random vector with the given scale
	 *
	 * @param {vec4} out the receiving vector
	 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
	 * @returns {vec4} out
	 */
	function random (out, scale) {
	  scale = scale || 1.0
	
	  // TODO: This is a pretty awful way of doing this. Find something better.
	  out[0] = Math.random()
	  out[1] = Math.random()
	  out[2] = Math.random()
	  out[3] = Math.random()
	  vecNormalize(out, out)
	  vecScale(out, out, scale)
	  return out
	}
	
	},{"./normalize":391,"./scale":393}],393:[function(_dereq_,module,exports){
	module.exports = scale
	
	/**
	 * Scales a vec4 by a scalar number
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {vec4} out
	 */
	function scale (out, a, b) {
	  out[0] = a[0] * b
	  out[1] = a[1] * b
	  out[2] = a[2] * b
	  out[3] = a[3] * b
	  return out
	}
	
	},{}],394:[function(_dereq_,module,exports){
	module.exports = scaleAndAdd
	
	/**
	 * Adds two vec4's after scaling the second operand by a scalar value
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @param {Number} scale the amount to scale b by before adding
	 * @returns {vec4} out
	 */
	function scaleAndAdd (out, a, b, scale) {
	  out[0] = a[0] + (b[0] * scale)
	  out[1] = a[1] + (b[1] * scale)
	  out[2] = a[2] + (b[2] * scale)
	  out[3] = a[3] + (b[3] * scale)
	  return out
	}
	
	},{}],395:[function(_dereq_,module,exports){
	module.exports = set
	
	/**
	 * Set the components of a vec4 to the given values
	 *
	 * @param {vec4} out the receiving vector
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {vec4} out
	 */
	function set (out, x, y, z, w) {
	  out[0] = x
	  out[1] = y
	  out[2] = z
	  out[3] = w
	  return out
	}
	
	},{}],396:[function(_dereq_,module,exports){
	module.exports = squaredDistance
	
	/**
	 * Calculates the squared euclidian distance between two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} squared distance between a and b
	 */
	function squaredDistance (a, b) {
	  var x = b[0] - a[0],
	    y = b[1] - a[1],
	    z = b[2] - a[2],
	    w = b[3] - a[3]
	  return x * x + y * y + z * z + w * w
	}
	
	},{}],397:[function(_dereq_,module,exports){
	module.exports = squaredLength
	
	/**
	 * Calculates the squared length of a vec4
	 *
	 * @param {vec4} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 */
	function squaredLength (a) {
	  var x = a[0],
	    y = a[1],
	    z = a[2],
	    w = a[3]
	  return x * x + y * y + z * z + w * w
	}
	
	},{}],398:[function(_dereq_,module,exports){
	module.exports = subtract
	
	/**
	 * Subtracts vector b from vector a
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	function subtract (out, a, b) {
	  out[0] = a[0] - b[0]
	  out[1] = a[1] - b[1]
	  out[2] = a[2] - b[2]
	  out[3] = a[3] - b[3]
	  return out
	}
	
	},{}],399:[function(_dereq_,module,exports){
	module.exports = transformMat4
	
	/**
	 * Transforms the vec4 with a mat4.
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to transform
	 * @param {mat4} m matrix to transform with
	 * @returns {vec4} out
	 */
	function transformMat4 (out, a, m) {
	  var x = a[0], y = a[1], z = a[2], w = a[3]
	  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w
	  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w
	  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w
	  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w
	  return out
	}
	
	},{}],400:[function(_dereq_,module,exports){
	module.exports = transformQuat
	
	/**
	 * Transforms the vec4 with a quat
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to transform
	 * @param {quat} q quaternion to transform with
	 * @returns {vec4} out
	 */
	function transformQuat (out, a, q) {
	  var x = a[0], y = a[1], z = a[2],
	    qx = q[0], qy = q[1], qz = q[2], qw = q[3],
	
	    // calculate quat * vec
	    ix = qw * x + qy * z - qz * y,
	    iy = qw * y + qz * x - qx * z,
	    iz = qw * z + qx * y - qy * x,
	    iw = -qx * x - qy * y - qz * z
	
	  // calculate result * inverse quat
	  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy
	  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz
	  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx
	  out[3] = a[3]
	  return out
	}
	
	},{}],401:[function(_dereq_,module,exports){
	module.exports = decodeFloat
	
	var UINT8_VIEW = new Uint8Array(4)
	var FLOAT_VIEW = new Float32Array(UINT8_VIEW.buffer)
	
	function decodeFloat(x, y, z, w) {
	  UINT8_VIEW[0] = w
	  UINT8_VIEW[1] = z
	  UINT8_VIEW[2] = y
	  UINT8_VIEW[3] = x
	  return FLOAT_VIEW[0]
	}
	
	},{}],402:[function(_dereq_,module,exports){
	var tokenize = _dereq_('glsl-tokenizer')
	var atob     = _dereq_('atob-lite')
	
	module.exports = getName
	
	function getName(src) {
	  var tokens = Array.isArray(src)
	    ? src
	    : tokenize(src)
	
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	    if (token.type !== 'preprocessor') continue
	    var match = token.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/)
	    if (!match) continue
	    if (!match[2]) continue
	
	    var b64  = match[1]
	    var name = match[2]
	
	    return (b64 ? atob(name) : name).trim()
	  }
	}
	
	},{"atob-lite":73,"glsl-tokenizer":409}],403:[function(_dereq_,module,exports){
	module.exports = tokenize
	
	var literals100 = _dereq_('./lib/literals')
	  , operators = _dereq_('./lib/operators')
	  , builtins100 = _dereq_('./lib/builtins')
	  , literals300es = _dereq_('./lib/literals-300es')
	  , builtins300es = _dereq_('./lib/builtins-300es')
	
	var NORMAL = 999          // <-- never emitted
	  , TOKEN = 9999          // <-- never emitted
	  , BLOCK_COMMENT = 0
	  , LINE_COMMENT = 1
	  , PREPROCESSOR = 2
	  , OPERATOR = 3
	  , INTEGER = 4
	  , FLOAT = 5
	  , IDENT = 6
	  , BUILTIN = 7
	  , KEYWORD = 8
	  , WHITESPACE = 9
	  , EOF = 10
	  , HEX = 11
	
	var map = [
	    'block-comment'
	  , 'line-comment'
	  , 'preprocessor'
	  , 'operator'
	  , 'integer'
	  , 'float'
	  , 'ident'
	  , 'builtin'
	  , 'keyword'
	  , 'whitespace'
	  , 'eof'
	  , 'integer'
	]
	
	function tokenize(opt) {
	  var i = 0
	    , total = 0
	    , mode = NORMAL
	    , c
	    , last
	    , content = []
	    , tokens = []
	    , token_idx = 0
	    , token_offs = 0
	    , line = 1
	    , col = 0
	    , start = 0
	    , isnum = false
	    , isoperator = false
	    , input = ''
	    , len
	
	  opt = opt || {}
	  var allBuiltins = builtins100
	  var allLiterals = literals100
	  if (opt.version === '300 es') {
	    allBuiltins = builtins300es
	    allLiterals = literals300es
	  }
	
	  return function(data) {
	    tokens = []
	    if (data !== null) return write(data.replace ? data.replace(/\r\n/g, '\n') : data)
	    return end()
	  }
	
	  function token(data) {
	    if (data.length) {
	      tokens.push({
	        type: map[mode]
	      , data: data
	      , position: start
	      , line: line
	      , column: col
	      })
	    }
	  }
	
	  function write(chunk) {
	    i = 0
	    input += chunk
	    len = input.length
	
	    var last
	
	    while(c = input[i], i < len) {
	      last = i
	
	      switch(mode) {
	        case BLOCK_COMMENT: i = block_comment(); break
	        case LINE_COMMENT: i = line_comment(); break
	        case PREPROCESSOR: i = preprocessor(); break
	        case OPERATOR: i = operator(); break
	        case INTEGER: i = integer(); break
	        case HEX: i = hex(); break
	        case FLOAT: i = decimal(); break
	        case TOKEN: i = readtoken(); break
	        case WHITESPACE: i = whitespace(); break
	        case NORMAL: i = normal(); break
	      }
	
	      if(last !== i) {
	        switch(input[last]) {
	          case '\n': col = 0; ++line; break
	          default: ++col; break
	        }
	      }
	    }
	
	    total += i
	    input = input.slice(i)
	    return tokens
	  }
	
	  function end(chunk) {
	    if(content.length) {
	      token(content.join(''))
	    }
	
	    mode = EOF
	    token('(eof)')
	    return tokens
	  }
	
	  function normal() {
	    content = content.length ? [] : content
	
	    if(last === '/' && c === '*') {
	      start = total + i - 1
	      mode = BLOCK_COMMENT
	      last = c
	      return i + 1
	    }
	
	    if(last === '/' && c === '/') {
	      start = total + i - 1
	      mode = LINE_COMMENT
	      last = c
	      return i + 1
	    }
	
	    if(c === '#') {
	      mode = PREPROCESSOR
	      start = total + i
	      return i
	    }
	
	    if(/\s/.test(c)) {
	      mode = WHITESPACE
	      start = total + i
	      return i
	    }
	
	    isnum = /\d/.test(c)
	    isoperator = /[^\w_]/.test(c)
	
	    start = total + i
	    mode = isnum ? INTEGER : isoperator ? OPERATOR : TOKEN
	    return i
	  }
	
	  function whitespace() {
	    if(/[^\s]/g.test(c)) {
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function preprocessor() {
	    if((c === '\r' || c === '\n') && last !== '\\') {
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function line_comment() {
	    return preprocessor()
	  }
	
	  function block_comment() {
	    if(c === '/' && last === '*') {
	      content.push(c)
	      token(content.join(''))
	      mode = NORMAL
	      return i + 1
	    }
	
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function operator() {
	    if(last === '.' && /\d/.test(c)) {
	      mode = FLOAT
	      return i
	    }
	
	    if(last === '/' && c === '*') {
	      mode = BLOCK_COMMENT
	      return i
	    }
	
	    if(last === '/' && c === '/') {
	      mode = LINE_COMMENT
	      return i
	    }
	
	    if(c === '.' && content.length) {
	      while(determine_operator(content));
	
	      mode = FLOAT
	      return i
	    }
	
	    if(c === ';' || c === ')' || c === '(') {
	      if(content.length) while(determine_operator(content));
	      token(c)
	      mode = NORMAL
	      return i + 1
	    }
	
	    var is_composite_operator = content.length === 2 && c !== '='
	    if(/[\w_\d\s]/.test(c) || is_composite_operator) {
	      while(determine_operator(content));
	      mode = NORMAL
	      return i
	    }
	
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function determine_operator(buf) {
	    var j = 0
	      , idx
	      , res
	
	    do {
	      idx = operators.indexOf(buf.slice(0, buf.length + j).join(''))
	      res = operators[idx]
	
	      if(idx === -1) {
	        if(j-- + buf.length > 0) continue
	        res = buf.slice(0, 1).join('')
	      }
	
	      token(res)
	
	      start += res.length
	      content = content.slice(res.length)
	      return content.length
	    } while(1)
	  }
	
	  function hex() {
	    if(/[^a-fA-F0-9]/.test(c)) {
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function integer() {
	    if(c === '.') {
	      content.push(c)
	      mode = FLOAT
	      last = c
	      return i + 1
	    }
	
	    if(/[eE]/.test(c)) {
	      content.push(c)
	      mode = FLOAT
	      last = c
	      return i + 1
	    }
	
	    if(c === 'x' && content.length === 1 && content[0] === '0') {
	      mode = HEX
	      content.push(c)
	      last = c
	      return i + 1
	    }
	
	    if(/[^\d]/.test(c)) {
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function decimal() {
	    if(c === 'f') {
	      content.push(c)
	      last = c
	      i += 1
	    }
	
	    if(/[eE]/.test(c)) {
	      content.push(c)
	      last = c
	      return i + 1
	    }
	
	    if (c === '-' && /[eE]/.test(last)) {
	      content.push(c)
	      last = c
	      return i + 1
	    }
	
	    if(/[^\d]/.test(c)) {
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	
	    content.push(c)
	    last = c
	    return i + 1
	  }
	
	  function readtoken() {
	    if(/[^\d\w_]/.test(c)) {
	      var contentstr = content.join('')
	      if(allLiterals.indexOf(contentstr) > -1) {
	        mode = KEYWORD
	      } else if(allBuiltins.indexOf(contentstr) > -1) {
	        mode = BUILTIN
	      } else {
	        mode = IDENT
	      }
	      token(content.join(''))
	      mode = NORMAL
	      return i
	    }
	    content.push(c)
	    last = c
	    return i + 1
	  }
	}
	
	},{"./lib/builtins":405,"./lib/builtins-300es":404,"./lib/literals":407,"./lib/literals-300es":406,"./lib/operators":408}],404:[function(_dereq_,module,exports){
	// 300es builtins/reserved words that were previously valid in v100
	var v100 = _dereq_('./builtins')
	
	// The texture2D|Cube functions have been removed
	// And the gl_ features are updated
	v100 = v100.slice().filter(function (b) {
	  return !/^(gl\_|texture)/.test(b)
	})
	
	module.exports = v100.concat([
	  // the updated gl_ constants
	    'gl_VertexID'
	  , 'gl_InstanceID'
	  , 'gl_Position'
	  , 'gl_PointSize'
	  , 'gl_FragCoord'
	  , 'gl_FrontFacing'
	  , 'gl_FragDepth'
	  , 'gl_PointCoord'
	  , 'gl_MaxVertexAttribs'
	  , 'gl_MaxVertexUniformVectors'
	  , 'gl_MaxVertexOutputVectors'
	  , 'gl_MaxFragmentInputVectors'
	  , 'gl_MaxVertexTextureImageUnits'
	  , 'gl_MaxCombinedTextureImageUnits'
	  , 'gl_MaxTextureImageUnits'
	  , 'gl_MaxFragmentUniformVectors'
	  , 'gl_MaxDrawBuffers'
	  , 'gl_MinProgramTexelOffset'
	  , 'gl_MaxProgramTexelOffset'
	  , 'gl_DepthRangeParameters'
	  , 'gl_DepthRange'
	
	  // other builtins
	  , 'trunc'
	  , 'round'
	  , 'roundEven'
	  , 'isnan'
	  , 'isinf'
	  , 'floatBitsToInt'
	  , 'floatBitsToUint'
	  , 'intBitsToFloat'
	  , 'uintBitsToFloat'
	  , 'packSnorm2x16'
	  , 'unpackSnorm2x16'
	  , 'packUnorm2x16'
	  , 'unpackUnorm2x16'
	  , 'packHalf2x16'
	  , 'unpackHalf2x16'
	  , 'outerProduct'
	  , 'transpose'
	  , 'determinant'
	  , 'inverse'
	  , 'texture'
	  , 'textureSize'
	  , 'textureProj'
	  , 'textureLod'
	  , 'textureOffset'
	  , 'texelFetch'
	  , 'texelFetchOffset'
	  , 'textureProjOffset'
	  , 'textureLodOffset'
	  , 'textureProjLod'
	  , 'textureProjLodOffset'
	  , 'textureGrad'
	  , 'textureGradOffset'
	  , 'textureProjGrad'
	  , 'textureProjGradOffset'
	])
	
	},{"./builtins":405}],405:[function(_dereq_,module,exports){
	module.exports = [
	  // Keep this list sorted
	  'abs'
	  , 'acos'
	  , 'all'
	  , 'any'
	  , 'asin'
	  , 'atan'
	  , 'ceil'
	  , 'clamp'
	  , 'cos'
	  , 'cross'
	  , 'dFdx'
	  , 'dFdy'
	  , 'degrees'
	  , 'distance'
	  , 'dot'
	  , 'equal'
	  , 'exp'
	  , 'exp2'
	  , 'faceforward'
	  , 'floor'
	  , 'fract'
	  , 'gl_BackColor'
	  , 'gl_BackLightModelProduct'
	  , 'gl_BackLightProduct'
	  , 'gl_BackMaterial'
	  , 'gl_BackSecondaryColor'
	  , 'gl_ClipPlane'
	  , 'gl_ClipVertex'
	  , 'gl_Color'
	  , 'gl_DepthRange'
	  , 'gl_DepthRangeParameters'
	  , 'gl_EyePlaneQ'
	  , 'gl_EyePlaneR'
	  , 'gl_EyePlaneS'
	  , 'gl_EyePlaneT'
	  , 'gl_Fog'
	  , 'gl_FogCoord'
	  , 'gl_FogFragCoord'
	  , 'gl_FogParameters'
	  , 'gl_FragColor'
	  , 'gl_FragCoord'
	  , 'gl_FragData'
	  , 'gl_FragDepth'
	  , 'gl_FragDepthEXT'
	  , 'gl_FrontColor'
	  , 'gl_FrontFacing'
	  , 'gl_FrontLightModelProduct'
	  , 'gl_FrontLightProduct'
	  , 'gl_FrontMaterial'
	  , 'gl_FrontSecondaryColor'
	  , 'gl_LightModel'
	  , 'gl_LightModelParameters'
	  , 'gl_LightModelProducts'
	  , 'gl_LightProducts'
	  , 'gl_LightSource'
	  , 'gl_LightSourceParameters'
	  , 'gl_MaterialParameters'
	  , 'gl_MaxClipPlanes'
	  , 'gl_MaxCombinedTextureImageUnits'
	  , 'gl_MaxDrawBuffers'
	  , 'gl_MaxFragmentUniformComponents'
	  , 'gl_MaxLights'
	  , 'gl_MaxTextureCoords'
	  , 'gl_MaxTextureImageUnits'
	  , 'gl_MaxTextureUnits'
	  , 'gl_MaxVaryingFloats'
	  , 'gl_MaxVertexAttribs'
	  , 'gl_MaxVertexTextureImageUnits'
	  , 'gl_MaxVertexUniformComponents'
	  , 'gl_ModelViewMatrix'
	  , 'gl_ModelViewMatrixInverse'
	  , 'gl_ModelViewMatrixInverseTranspose'
	  , 'gl_ModelViewMatrixTranspose'
	  , 'gl_ModelViewProjectionMatrix'
	  , 'gl_ModelViewProjectionMatrixInverse'
	  , 'gl_ModelViewProjectionMatrixInverseTranspose'
	  , 'gl_ModelViewProjectionMatrixTranspose'
	  , 'gl_MultiTexCoord0'
	  , 'gl_MultiTexCoord1'
	  , 'gl_MultiTexCoord2'
	  , 'gl_MultiTexCoord3'
	  , 'gl_MultiTexCoord4'
	  , 'gl_MultiTexCoord5'
	  , 'gl_MultiTexCoord6'
	  , 'gl_MultiTexCoord7'
	  , 'gl_Normal'
	  , 'gl_NormalMatrix'
	  , 'gl_NormalScale'
	  , 'gl_ObjectPlaneQ'
	  , 'gl_ObjectPlaneR'
	  , 'gl_ObjectPlaneS'
	  , 'gl_ObjectPlaneT'
	  , 'gl_Point'
	  , 'gl_PointCoord'
	  , 'gl_PointParameters'
	  , 'gl_PointSize'
	  , 'gl_Position'
	  , 'gl_ProjectionMatrix'
	  , 'gl_ProjectionMatrixInverse'
	  , 'gl_ProjectionMatrixInverseTranspose'
	  , 'gl_ProjectionMatrixTranspose'
	  , 'gl_SecondaryColor'
	  , 'gl_TexCoord'
	  , 'gl_TextureEnvColor'
	  , 'gl_TextureMatrix'
	  , 'gl_TextureMatrixInverse'
	  , 'gl_TextureMatrixInverseTranspose'
	  , 'gl_TextureMatrixTranspose'
	  , 'gl_Vertex'
	  , 'greaterThan'
	  , 'greaterThanEqual'
	  , 'inversesqrt'
	  , 'length'
	  , 'lessThan'
	  , 'lessThanEqual'
	  , 'log'
	  , 'log2'
	  , 'matrixCompMult'
	  , 'max'
	  , 'min'
	  , 'mix'
	  , 'mod'
	  , 'normalize'
	  , 'not'
	  , 'notEqual'
	  , 'pow'
	  , 'radians'
	  , 'reflect'
	  , 'refract'
	  , 'sign'
	  , 'sin'
	  , 'smoothstep'
	  , 'sqrt'
	  , 'step'
	  , 'tan'
	  , 'texture2D'
	  , 'texture2DLod'
	  , 'texture2DProj'
	  , 'texture2DProjLod'
	  , 'textureCube'
	  , 'textureCubeLod'
	  , 'texture2DLodEXT'
	  , 'texture2DProjLodEXT'
	  , 'textureCubeLodEXT'
	  , 'texture2DGradEXT'
	  , 'texture2DProjGradEXT'
	  , 'textureCubeGradEXT'
	]
	
	},{}],406:[function(_dereq_,module,exports){
	var v100 = _dereq_('./literals')
	
	module.exports = v100.slice().concat([
	   'layout'
	  , 'centroid'
	  , 'smooth'
	  , 'case'
	  , 'mat2x2'
	  , 'mat2x3'
	  , 'mat2x4'
	  , 'mat3x2'
	  , 'mat3x3'
	  , 'mat3x4'
	  , 'mat4x2'
	  , 'mat4x3'
	  , 'mat4x4'
	  , 'uint'
	  , 'uvec2'
	  , 'uvec3'
	  , 'uvec4'
	  , 'samplerCubeShadow'
	  , 'sampler2DArray'
	  , 'sampler2DArrayShadow'
	  , 'isampler2D'
	  , 'isampler3D'
	  , 'isamplerCube'
	  , 'isampler2DArray'
	  , 'usampler2D'
	  , 'usampler3D'
	  , 'usamplerCube'
	  , 'usampler2DArray'
	  , 'coherent'
	  , 'restrict'
	  , 'readonly'
	  , 'writeonly'
	  , 'resource'
	  , 'atomic_uint'
	  , 'noperspective'
	  , 'patch'
	  , 'sample'
	  , 'subroutine'
	  , 'common'
	  , 'partition'
	  , 'active'
	  , 'filter'
	  , 'image1D'
	  , 'image2D'
	  , 'image3D'
	  , 'imageCube'
	  , 'iimage1D'
	  , 'iimage2D'
	  , 'iimage3D'
	  , 'iimageCube'
	  , 'uimage1D'
	  , 'uimage2D'
	  , 'uimage3D'
	  , 'uimageCube'
	  , 'image1DArray'
	  , 'image2DArray'
	  , 'iimage1DArray'
	  , 'iimage2DArray'
	  , 'uimage1DArray'
	  , 'uimage2DArray'
	  , 'image1DShadow'
	  , 'image2DShadow'
	  , 'image1DArrayShadow'
	  , 'image2DArrayShadow'
	  , 'imageBuffer'
	  , 'iimageBuffer'
	  , 'uimageBuffer'
	  , 'sampler1DArray'
	  , 'sampler1DArrayShadow'
	  , 'isampler1D'
	  , 'isampler1DArray'
	  , 'usampler1D'
	  , 'usampler1DArray'
	  , 'isampler2DRect'
	  , 'usampler2DRect'
	  , 'samplerBuffer'
	  , 'isamplerBuffer'
	  , 'usamplerBuffer'
	  , 'sampler2DMS'
	  , 'isampler2DMS'
	  , 'usampler2DMS'
	  , 'sampler2DMSArray'
	  , 'isampler2DMSArray'
	  , 'usampler2DMSArray'
	])
	
	},{"./literals":407}],407:[function(_dereq_,module,exports){
	module.exports = [
	  // current
	    'precision'
	  , 'highp'
	  , 'mediump'
	  , 'lowp'
	  , 'attribute'
	  , 'const'
	  , 'uniform'
	  , 'varying'
	  , 'break'
	  , 'continue'
	  , 'do'
	  , 'for'
	  , 'while'
	  , 'if'
	  , 'else'
	  , 'in'
	  , 'out'
	  , 'inout'
	  , 'float'
	  , 'int'
	  , 'void'
	  , 'bool'
	  , 'true'
	  , 'false'
	  , 'discard'
	  , 'return'
	  , 'mat2'
	  , 'mat3'
	  , 'mat4'
	  , 'vec2'
	  , 'vec3'
	  , 'vec4'
	  , 'ivec2'
	  , 'ivec3'
	  , 'ivec4'
	  , 'bvec2'
	  , 'bvec3'
	  , 'bvec4'
	  , 'sampler1D'
	  , 'sampler2D'
	  , 'sampler3D'
	  , 'samplerCube'
	  , 'sampler1DShadow'
	  , 'sampler2DShadow'
	  , 'struct'
	
	  // future
	  , 'asm'
	  , 'class'
	  , 'union'
	  , 'enum'
	  , 'typedef'
	  , 'template'
	  , 'this'
	  , 'packed'
	  , 'goto'
	  , 'switch'
	  , 'default'
	  , 'inline'
	  , 'noinline'
	  , 'volatile'
	  , 'public'
	  , 'static'
	  , 'extern'
	  , 'external'
	  , 'interface'
	  , 'long'
	  , 'short'
	  , 'double'
	  , 'half'
	  , 'fixed'
	  , 'unsigned'
	  , 'input'
	  , 'output'
	  , 'hvec2'
	  , 'hvec3'
	  , 'hvec4'
	  , 'dvec2'
	  , 'dvec3'
	  , 'dvec4'
	  , 'fvec2'
	  , 'fvec3'
	  , 'fvec4'
	  , 'sampler2DRect'
	  , 'sampler3DRect'
	  , 'sampler2DRectShadow'
	  , 'sizeof'
	  , 'cast'
	  , 'namespace'
	  , 'using'
	]
	
	},{}],408:[function(_dereq_,module,exports){
	module.exports = [
	    '<<='
	  , '>>='
	  , '++'
	  , '--'
	  , '<<'
	  , '>>'
	  , '<='
	  , '>='
	  , '=='
	  , '!='
	  , '&&'
	  , '||'
	  , '+='
	  , '-='
	  , '*='
	  , '/='
	  , '%='
	  , '&='
	  , '^^'
	  , '^='
	  , '|='
	  , '('
	  , ')'
	  , '['
	  , ']'
	  , '.'
	  , '!'
	  , '~'
	  , '*'
	  , '/'
	  , '%'
	  , '+'
	  , '-'
	  , '<'
	  , '>'
	  , '&'
	  , '^'
	  , '|'
	  , '?'
	  , ':'
	  , '='
	  , ','
	  , ';'
	  , '{'
	  , '}'
	]
	
	},{}],409:[function(_dereq_,module,exports){
	var tokenize = _dereq_('./index')
	
	module.exports = tokenizeString
	
	function tokenizeString(str, opt) {
	  var generator = tokenize(opt)
	  var tokens = []
	
	  tokens = tokens.concat(generator(str))
	  tokens = tokens.concat(generator(null))
	
	  return tokens
	}
	
	},{"./index":403}],410:[function(_dereq_,module,exports){
	module.exports = function(strings) {
	  if (typeof strings === 'string') strings = [strings]
	  var exprs = [].slice.call(arguments,1)
	  var parts = []
	  for (var i = 0; i < strings.length-1; i++) {
	    parts.push(strings[i], exprs[i] || '')
	  }
	  parts.push(strings[i])
	  return parts.join('')
	}
	
	},{}],411:[function(_dereq_,module,exports){
	(function (global){
	'use strict'
	
	var isBrowser = _dereq_('is-browser')
	var hasHover
	
	if (typeof global.matchMedia === 'function') {
		hasHover = !global.matchMedia('(hover: none)').matches
	}
	else {
		hasHover = isBrowser
	}
	
	module.exports = hasHover
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"is-browser":418}],412:[function(_dereq_,module,exports){
	'use strict'
	
	var isBrowser = _dereq_('is-browser')
	
	function detect() {
		var supported = false
	
		try {
			var opts = Object.defineProperty({}, 'passive', {
				get: function() {
					supported = true
				}
			})
	
			window.addEventListener('test', null, opts)
			window.removeEventListener('test', null, opts)
		} catch(e) {
			supported = false
		}
	
		return supported
	}
	
	module.exports = isBrowser && detect()
	
	},{"is-browser":418}],413:[function(_dereq_,module,exports){
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}
	
	},{}],414:[function(_dereq_,module,exports){
	"use strict"
	
	//High level idea:
	// 1. Use Clarkson's incremental construction to find convex hull
	// 2. Point location in triangulation by jump and walk
	
	module.exports = incrementalConvexHull
	
	var orient = _dereq_("robust-orientation")
	var compareCell = _dereq_("simplicial-complex").compareCells
	
	function compareInt(a, b) {
	  return a - b
	}
	
	function Simplex(vertices, adjacent, boundary) {
	  this.vertices = vertices
	  this.adjacent = adjacent
	  this.boundary = boundary
	  this.lastVisited = -1
	}
	
	Simplex.prototype.flip = function() {
	  var t = this.vertices[0]
	  this.vertices[0] = this.vertices[1]
	  this.vertices[1] = t
	  var u = this.adjacent[0]
	  this.adjacent[0] = this.adjacent[1]
	  this.adjacent[1] = u
	}
	
	function GlueFacet(vertices, cell, index) {
	  this.vertices = vertices
	  this.cell = cell
	  this.index = index
	}
	
	function compareGlue(a, b) {
	  return compareCell(a.vertices, b.vertices)
	}
	
	function bakeOrient(d) {
	  var code = ["function orient(){var tuple=this.tuple;return test("]
	  for(var i=0; i<=d; ++i) {
	    if(i > 0) {
	      code.push(",")
	    }
	    code.push("tuple[", i, "]")
	  }
	  code.push(")}return orient")
	  var proc = new Function("test", code.join(""))
	  var test = orient[d+1]
	  if(!test) {
	    test = orient
	  }
	  return proc(test)
	}
	
	var BAKED = []
	
	function Triangulation(dimension, vertices, simplices) {
	  this.dimension = dimension
	  this.vertices = vertices
	  this.simplices = simplices
	  this.interior = simplices.filter(function(c) {
	    return !c.boundary
	  })
	
	  this.tuple = new Array(dimension+1)
	  for(var i=0; i<=dimension; ++i) {
	    this.tuple[i] = this.vertices[i]
	  }
	
	  var o = BAKED[dimension]
	  if(!o) {
	    o = BAKED[dimension] = bakeOrient(dimension)
	  }
	  this.orient = o
	}
	
	var proto = Triangulation.prototype
	
	//Degenerate situation where we are on boundary, but coplanar to face
	proto.handleBoundaryDegeneracy = function(cell, point) {
	  var d = this.dimension
	  var n = this.vertices.length - 1
	  var tuple = this.tuple
	  var verts = this.vertices
	
	  //Dumb solution: Just do dfs from boundary cell until we find any peak, or terminate
	  var toVisit = [ cell ]
	  cell.lastVisited = -n
	  while(toVisit.length > 0) {
	    cell = toVisit.pop()
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	    for(var i=0; i<=d; ++i) {
	      var neighbor = cellAdj[i]
	      if(!neighbor.boundary || neighbor.lastVisited <= -n) {
	        continue
	      }
	      var nv = neighbor.vertices
	      for(var j=0; j<=d; ++j) {
	        var vv = nv[j]
	        if(vv < 0) {
	          tuple[j] = point
	        } else {
	          tuple[j] = verts[vv]
	        }
	      }
	      var o = this.orient()
	      if(o > 0) {
	        return neighbor
	      }
	      neighbor.lastVisited = -n
	      if(o === 0) {
	        toVisit.push(neighbor)
	      }
	    }
	  }
	  return null
	}
	
	proto.walk = function(point, random) {
	  //Alias local properties
	  var n = this.vertices.length - 1
	  var d = this.dimension
	  var verts = this.vertices
	  var tuple = this.tuple
	
	  //Compute initial jump cell
	  var initIndex = random ? (this.interior.length * Math.random())|0 : (this.interior.length-1)
	  var cell = this.interior[ initIndex ]
	
	  //Start walking
	outerLoop:
	  while(!cell.boundary) {
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	
	    for(var i=0; i<=d; ++i) {
	      tuple[i] = verts[cellVerts[i]]
	    }
	    cell.lastVisited = n
	
	    //Find farthest adjacent cell
	    for(var i=0; i<=d; ++i) {
	      var neighbor = cellAdj[i]
	      if(neighbor.lastVisited >= n) {
	        continue
	      }
	      var prev = tuple[i]
	      tuple[i] = point
	      var o = this.orient()
	      tuple[i] = prev
	      if(o < 0) {
	        cell = neighbor
	        continue outerLoop
	      } else {
	        if(!neighbor.boundary) {
	          neighbor.lastVisited = n
	        } else {
	          neighbor.lastVisited = -n
	        }
	      }
	    }
	    return
	  }
	
	  return cell
	}
	
	proto.addPeaks = function(point, cell) {
	  var n = this.vertices.length - 1
	  var d = this.dimension
	  var verts = this.vertices
	  var tuple = this.tuple
	  var interior = this.interior
	  var simplices = this.simplices
	
	  //Walking finished at boundary, time to add peaks
	  var tovisit = [ cell ]
	
	  //Stretch initial boundary cell into a peak
	  cell.lastVisited = n
	  cell.vertices[cell.vertices.indexOf(-1)] = n
	  cell.boundary = false
	  interior.push(cell)
	
	  //Record a list of all new boundaries created by added peaks so we can glue them together when we are all done
	  var glueFacets = []
	
	  //Do a traversal of the boundary walking outward from starting peak
	  while(tovisit.length > 0) {
	    //Pop off peak and walk over adjacent cells
	    var cell = tovisit.pop()
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	    var indexOfN = cellVerts.indexOf(n)
	    if(indexOfN < 0) {
	      continue
	    }
	
	    for(var i=0; i<=d; ++i) {
	      if(i === indexOfN) {
	        continue
	      }
	
	      //For each boundary neighbor of the cell
	      var neighbor = cellAdj[i]
	      if(!neighbor.boundary || neighbor.lastVisited >= n) {
	        continue
	      }
	
	      var nv = neighbor.vertices
	
	      //Test if neighbor is a peak
	      if(neighbor.lastVisited !== -n) {      
	        //Compute orientation of p relative to each boundary peak
	        var indexOfNeg1 = 0
	        for(var j=0; j<=d; ++j) {
	          if(nv[j] < 0) {
	            indexOfNeg1 = j
	            tuple[j] = point
	          } else {
	            tuple[j] = verts[nv[j]]
	          }
	        }
	        var o = this.orient()
	
	        //Test if neighbor cell is also a peak
	        if(o > 0) {
	          nv[indexOfNeg1] = n
	          neighbor.boundary = false
	          interior.push(neighbor)
	          tovisit.push(neighbor)
	          neighbor.lastVisited = n
	          continue
	        } else {
	          neighbor.lastVisited = -n
	        }
	      }
	
	      var na = neighbor.adjacent
	
	      //Otherwise, replace neighbor with new face
	      var vverts = cellVerts.slice()
	      var vadj = cellAdj.slice()
	      var ncell = new Simplex(vverts, vadj, true)
	      simplices.push(ncell)
	
	      //Connect to neighbor
	      var opposite = na.indexOf(cell)
	      if(opposite < 0) {
	        continue
	      }
	      na[opposite] = ncell
	      vadj[indexOfN] = neighbor
	
	      //Connect to cell
	      vverts[i] = -1
	      vadj[i] = cell
	      cellAdj[i] = ncell
	
	      //Flip facet
	      ncell.flip()
	
	      //Add to glue list
	      for(var j=0; j<=d; ++j) {
	        var uu = vverts[j]
	        if(uu < 0 || uu === n) {
	          continue
	        }
	        var nface = new Array(d-1)
	        var nptr = 0
	        for(var k=0; k<=d; ++k) {
	          var vv = vverts[k]
	          if(vv < 0 || k === j) {
	            continue
	          }
	          nface[nptr++] = vv
	        }
	        glueFacets.push(new GlueFacet(nface, ncell, j))
	      }
	    }
	  }
	
	  //Glue boundary facets together
	  glueFacets.sort(compareGlue)
	
	  for(var i=0; i+1<glueFacets.length; i+=2) {
	    var a = glueFacets[i]
	    var b = glueFacets[i+1]
	    var ai = a.index
	    var bi = b.index
	    if(ai < 0 || bi < 0) {
	      continue
	    }
	    a.cell.adjacent[a.index] = b.cell
	    b.cell.adjacent[b.index] = a.cell
	  }
	}
	
	proto.insert = function(point, random) {
	  //Add point
	  var verts = this.vertices
	  verts.push(point)
	
	  var cell = this.walk(point, random)
	  if(!cell) {
	    return
	  }
	
	  //Alias local properties
	  var d = this.dimension
	  var tuple = this.tuple
	
	  //Degenerate case: If point is coplanar to cell, then walk until we find a non-degenerate boundary
	  for(var i=0; i<=d; ++i) {
	    var vv = cell.vertices[i]
	    if(vv < 0) {
	      tuple[i] = point
	    } else {
	      tuple[i] = verts[vv]
	    }
	  }
	  var o = this.orient(tuple)
	  if(o < 0) {
	    return
	  } else if(o === 0) {
	    cell = this.handleBoundaryDegeneracy(cell, point)
	    if(!cell) {
	      return
	    }
	  }
	
	  //Add peaks
	  this.addPeaks(point, cell)
	}
	
	//Extract all boundary cells
	proto.boundary = function() {
	  var d = this.dimension
	  var boundary = []
	  var cells = this.simplices
	  var nc = cells.length
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    if(c.boundary) {
	      var bcell = new Array(d)
	      var cv = c.vertices
	      var ptr = 0
	      var parity = 0
	      for(var j=0; j<=d; ++j) {
	        if(cv[j] >= 0) {
	          bcell[ptr++] = cv[j]
	        } else {
	          parity = j&1
	        }
	      }
	      if(parity === (d&1)) {
	        var t = bcell[0]
	        bcell[0] = bcell[1]
	        bcell[1] = t
	      }
	      boundary.push(bcell)
	    }
	  }
	  return boundary
	}
	
	function incrementalConvexHull(points, randomSearch) {
	  var n = points.length
	  if(n === 0) {
	    throw new Error("Must have at least d+1 points")
	  }
	  var d = points[0].length
	  if(n <= d) {
	    throw new Error("Must input at least d+1 points")
	  }
	
	  //FIXME: This could be degenerate, but need to select d+1 non-coplanar points to bootstrap process
	  var initialSimplex = points.slice(0, d+1)
	
	  //Make sure initial simplex is positively oriented
	  var o = orient.apply(void 0, initialSimplex)
	  if(o === 0) {
	    throw new Error("Input not in general position")
	  }
	  var initialCoords = new Array(d+1)
	  for(var i=0; i<=d; ++i) {
	    initialCoords[i] = i
	  }
	  if(o < 0) {
	    initialCoords[0] = 1
	    initialCoords[1] = 0
	  }
	
	  //Create initial topological index, glue pointers together (kind of messy)
	  var initialCell = new Simplex(initialCoords, new Array(d+1), false)
	  var boundary = initialCell.adjacent
	  var list = new Array(d+2)
	  for(var i=0; i<=d; ++i) {
	    var verts = initialCoords.slice()
	    for(var j=0; j<=d; ++j) {
	      if(j === i) {
	        verts[j] = -1
	      }
	    }
	    var t = verts[0]
	    verts[0] = verts[1]
	    verts[1] = t
	    var cell = new Simplex(verts, new Array(d+1), true)
	    boundary[i] = cell
	    list[i] = cell
	  }
	  list[d+1] = initialCell
	  for(var i=0; i<=d; ++i) {
	    var verts = boundary[i].vertices
	    var adj = boundary[i].adjacent
	    for(var j=0; j<=d; ++j) {
	      var v = verts[j]
	      if(v < 0) {
	        adj[j] = initialCell
	        continue
	      }
	      for(var k=0; k<=d; ++k) {
	        if(boundary[k].vertices.indexOf(v) < 0) {
	          adj[j] = boundary[k]
	        }
	      }
	    }
	  }
	
	  //Initialize triangles
	  var triangles = new Triangulation(d, initialSimplex, list)
	
	  //Insert remaining points
	  var useRandom = !!randomSearch
	  for(var i=d+1; i<n; ++i) {
	    triangles.insert(points[i], useRandom)
	  }
	  
	  //Extract boundary cells
	  return triangles.boundary()
	}
	},{"robust-orientation":508,"simplicial-complex":518}],415:[function(_dereq_,module,exports){
	"use strict"
	
	var bounds = _dereq_("binary-search-bounds")
	
	var NOT_FOUND = 0
	var SUCCESS = 1
	var EMPTY = 2
	
	module.exports = createWrapper
	
	function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
	  this.mid = mid
	  this.left = left
	  this.right = right
	  this.leftPoints = leftPoints
	  this.rightPoints = rightPoints
	  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length
	}
	
	var proto = IntervalTreeNode.prototype
	
	function copy(a, b) {
	  a.mid = b.mid
	  a.left = b.left
	  a.right = b.right
	  a.leftPoints = b.leftPoints
	  a.rightPoints = b.rightPoints
	  a.count = b.count
	}
	
	function rebuild(node, intervals) {
	  var ntree = createIntervalTree(intervals)
	  node.mid = ntree.mid
	  node.left = ntree.left
	  node.right = ntree.right
	  node.leftPoints = ntree.leftPoints
	  node.rightPoints = ntree.rightPoints
	  node.count = ntree.count
	}
	
	function rebuildWithInterval(node, interval) {
	  var intervals = node.intervals([])
	  intervals.push(interval)
	  rebuild(node, intervals)    
	}
	
	function rebuildWithoutInterval(node, interval) {
	  var intervals = node.intervals([])
	  var idx = intervals.indexOf(interval)
	  if(idx < 0) {
	    return NOT_FOUND
	  }
	  intervals.splice(idx, 1)
	  rebuild(node, intervals)
	  return SUCCESS
	}
	
	proto.intervals = function(result) {
	  result.push.apply(result, this.leftPoints)
	  if(this.left) {
	    this.left.intervals(result)
	  }
	  if(this.right) {
	    this.right.intervals(result)
	  }
	  return result
	}
	
	proto.insert = function(interval) {
	  var weight = this.count - this.leftPoints.length
	  this.count += 1
	  if(interval[1] < this.mid) {
	    if(this.left) {
	      if(4*(this.left.count+1) > 3*(weight+1)) {
	        rebuildWithInterval(this, interval)
	      } else {
	        this.left.insert(interval)
	      }
	    } else {
	      this.left = createIntervalTree([interval])
	    }
	  } else if(interval[0] > this.mid) {
	    if(this.right) {
	      if(4*(this.right.count+1) > 3*(weight+1)) {
	        rebuildWithInterval(this, interval)
	      } else {
	        this.right.insert(interval)
	      }
	    } else {
	      this.right = createIntervalTree([interval])
	    }
	  } else {
	    var l = bounds.ge(this.leftPoints, interval, compareBegin)
	    var r = bounds.ge(this.rightPoints, interval, compareEnd)
	    this.leftPoints.splice(l, 0, interval)
	    this.rightPoints.splice(r, 0, interval)
	  }
	}
	
	proto.remove = function(interval) {
	  var weight = this.count - this.leftPoints
	  if(interval[1] < this.mid) {
	    if(!this.left) {
	      return NOT_FOUND
	    }
	    var rw = this.right ? this.right.count : 0
	    if(4 * rw > 3 * (weight-1)) {
	      return rebuildWithoutInterval(this, interval)
	    }
	    var r = this.left.remove(interval)
	    if(r === EMPTY) {
	      this.left = null
	      this.count -= 1
	      return SUCCESS
	    } else if(r === SUCCESS) {
	      this.count -= 1
	    }
	    return r
	  } else if(interval[0] > this.mid) {
	    if(!this.right) {
	      return NOT_FOUND
	    }
	    var lw = this.left ? this.left.count : 0
	    if(4 * lw > 3 * (weight-1)) {
	      return rebuildWithoutInterval(this, interval)
	    }
	    var r = this.right.remove(interval)
	    if(r === EMPTY) {
	      this.right = null
	      this.count -= 1
	      return SUCCESS
	    } else if(r === SUCCESS) {
	      this.count -= 1
	    }
	    return r
	  } else {
	    if(this.count === 1) {
	      if(this.leftPoints[0] === interval) {
	        return EMPTY
	      } else {
	        return NOT_FOUND
	      }
	    }
	    if(this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
	      if(this.left && this.right) {
	        var p = this
	        var n = this.left
	        while(n.right) {
	          p = n
	          n = n.right
	        }
	        if(p === this) {
	          n.right = this.right
	        } else {
	          var l = this.left
	          var r = this.right
	          p.count -= n.count
	          p.right = n.left
	          n.left = l
	          n.right = r
	        }
	        copy(this, n)
	        this.count = (this.left?this.left.count:0) + (this.right?this.right.count:0) + this.leftPoints.length
	      } else if(this.left) {
	        copy(this, this.left)
	      } else {
	        copy(this, this.right)
	      }
	      return SUCCESS
	    }
	    for(var l = bounds.ge(this.leftPoints, interval, compareBegin); l<this.leftPoints.length; ++l) {
	      if(this.leftPoints[l][0] !== interval[0]) {
	        break
	      }
	      if(this.leftPoints[l] === interval) {
	        this.count -= 1
	        this.leftPoints.splice(l, 1)
	        for(var r = bounds.ge(this.rightPoints, interval, compareEnd); r<this.rightPoints.length; ++r) {
	          if(this.rightPoints[r][1] !== interval[1]) {
	            break
	          } else if(this.rightPoints[r] === interval) {
	            this.rightPoints.splice(r, 1)
	            return SUCCESS
	          }
	        }
	      }
	    }
	    return NOT_FOUND
	  }
	}
	
	function reportLeftRange(arr, hi, cb) {
	  for(var i=0; i<arr.length && arr[i][0] <= hi; ++i) {
	    var r = cb(arr[i])
	    if(r) { return r }
	  }
	}
	
	function reportRightRange(arr, lo, cb) {
	  for(var i=arr.length-1; i>=0 && arr[i][1] >= lo; --i) {
	    var r = cb(arr[i])
	    if(r) { return r }
	  }
	}
	
	function reportRange(arr, cb) {
	  for(var i=0; i<arr.length; ++i) {
	    var r = cb(arr[i])
	    if(r) { return r }
	  }
	}
	
	proto.queryPoint = function(x, cb) {
	  if(x < this.mid) {
	    if(this.left) {
	      var r = this.left.queryPoint(x, cb)
	      if(r) { return r }
	    }
	    return reportLeftRange(this.leftPoints, x, cb)
	  } else if(x > this.mid) {
	    if(this.right) {
	      var r = this.right.queryPoint(x, cb)
	      if(r) { return r }
	    }
	    return reportRightRange(this.rightPoints, x, cb)
	  } else {
	    return reportRange(this.leftPoints, cb)
	  }
	}
	
	proto.queryInterval = function(lo, hi, cb) {
	  if(lo < this.mid && this.left) {
	    var r = this.left.queryInterval(lo, hi, cb)
	    if(r) { return r }
	  }
	  if(hi > this.mid && this.right) {
	    var r = this.right.queryInterval(lo, hi, cb)
	    if(r) { return r }
	  }
	  if(hi < this.mid) {
	    return reportLeftRange(this.leftPoints, hi, cb)
	  } else if(lo > this.mid) {
	    return reportRightRange(this.rightPoints, lo, cb)
	  } else {
	    return reportRange(this.leftPoints, cb)
	  }
	}
	
	function compareNumbers(a, b) {
	  return a - b
	}
	
	function compareBegin(a, b) {
	  var d = a[0] - b[0]
	  if(d) { return d }
	  return a[1] - b[1]
	}
	
	function compareEnd(a, b) {
	  var d = a[1] - b[1]
	  if(d) { return d }
	  return a[0] - b[0]
	}
	
	function createIntervalTree(intervals) {
	  if(intervals.length === 0) {
	    return null
	  }
	  var pts = []
	  for(var i=0; i<intervals.length; ++i) {
	    pts.push(intervals[i][0], intervals[i][1])
	  }
	  pts.sort(compareNumbers)
	
	  var mid = pts[pts.length>>1]
	
	  var leftIntervals = []
	  var rightIntervals = []
	  var centerIntervals = []
	  for(var i=0; i<intervals.length; ++i) {
	    var s = intervals[i]
	    if(s[1] < mid) {
	      leftIntervals.push(s)
	    } else if(mid < s[0]) {
	      rightIntervals.push(s)
	    } else {
	      centerIntervals.push(s)
	    }
	  }
	
	  //Split center intervals
	  var leftPoints = centerIntervals
	  var rightPoints = centerIntervals.slice()
	  leftPoints.sort(compareBegin)
	  rightPoints.sort(compareEnd)
	
	  return new IntervalTreeNode(mid, 
	    createIntervalTree(leftIntervals),
	    createIntervalTree(rightIntervals),
	    leftPoints,
	    rightPoints)
	}
	
	//User friendly wrapper that makes it possible to support empty trees
	function IntervalTree(root) {
	  this.root = root
	}
	
	var tproto = IntervalTree.prototype
	
	tproto.insert = function(interval) {
	  if(this.root) {
	    this.root.insert(interval)
	  } else {
	    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval])
	  }
	}
	
	tproto.remove = function(interval) {
	  if(this.root) {
	    var r = this.root.remove(interval)
	    if(r === EMPTY) {
	      this.root = null
	    }
	    return r !== NOT_FOUND
	  }
	  return false
	}
	
	tproto.queryPoint = function(p, cb) {
	  if(this.root) {
	    return this.root.queryPoint(p, cb)
	  }
	}
	
	tproto.queryInterval = function(lo, hi, cb) {
	  if(lo <= hi && this.root) {
	    return this.root.queryInterval(lo, hi, cb)
	  }
	}
	
	Object.defineProperty(tproto, "count", {
	  get: function() {
	    if(this.root) {
	      return this.root.count
	    }
	    return 0
	  }
	})
	
	Object.defineProperty(tproto, "intervals", {
	  get: function() {
	    if(this.root) {
	      return this.root.intervals([])
	    }
	    return []
	  }
	})
	
	function createWrapper(intervals) {
	  if(!intervals || intervals.length === 0) {
	    return new IntervalTree(null)
	  }
	  return new IntervalTree(createIntervalTree(intervals))
	}
	
	},{"binary-search-bounds":92}],416:[function(_dereq_,module,exports){
	"use strict"
	
	function invertPermutation(pi, result) {
	  result = result || new Array(pi.length)
	  for(var i=0; i<pi.length; ++i) {
	    result[pi[i]] = i
	  }
	  return result
	}
	
	module.exports = invertPermutation
	},{}],417:[function(_dereq_,module,exports){
	"use strict"
	
	function iota(n) {
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = i
	  }
	  return result
	}
	
	module.exports = iota
	},{}],418:[function(_dereq_,module,exports){
	module.exports = true;
	},{}],419:[function(_dereq_,module,exports){
	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}
	
	},{}],420:[function(_dereq_,module,exports){
	'use strict';
	module.exports = typeof navigator !== 'undefined' &&
		(/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
	
	},{}],421:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = isMobile
	module.exports.isMobile = isMobile
	module.exports.default = isMobile
	
	var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
	
	var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
	
	function isMobile (opts) {
	  if (!opts) opts = {}
	  var ua = opts.ua
	  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
	  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
	    ua = ua.headers['user-agent']
	  }
	  if (typeof ua !== 'string') return false
	
	  return opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
	}
	
	},{}],422:[function(_dereq_,module,exports){
	'use strict';
	module.exports = function (x) {
		var type = typeof x;
		return x !== null && (type === 'object' || type === 'function');
	};
	
	},{}],423:[function(_dereq_,module,exports){
	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};
	
	},{}],424:[function(_dereq_,module,exports){
	'use strict';
	
	/**
	 * Is this string all whitespace?
	 * This solution kind of makes my brain hurt, but it's significantly faster
	 * than !str.trim() or any other solution I could find.
	 *
	 * whitespace codes from: http://en.wikipedia.org/wiki/Whitespace_character
	 * and verified with:
	 *
	 *  for(var i = 0; i < 65536; i++) {
	 *      var s = String.fromCharCode(i);
	 *      if(+s===0 && !s.trim()) console.log(i, s);
	 *  }
	 *
	 * which counts a couple of these as *not* whitespace, but finds nothing else
	 * that *is* whitespace. Note that charCodeAt stops at 16 bits, but it appears
	 * that there are no whitespace characters above this, and code points above
	 * this do not map onto white space characters.
	 */
	
	module.exports = function(str){
	    var l = str.length,
	        a;
	    for(var i = 0; i < l; i++) {
	        a = str.charCodeAt(i);
	        if((a < 9 || a > 13) && (a !== 32) && (a !== 133) && (a !== 160) &&
	            (a !== 5760) && (a !== 6158) && (a < 8192 || a > 8205) &&
	            (a !== 8232) && (a !== 8233) && (a !== 8239) && (a !== 8287) &&
	            (a !== 8288) && (a !== 12288) && (a !== 65279)) {
	                return false;
	        }
	    }
	    return true;
	}
	
	},{}],425:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = function isPath(str) {
		if (typeof str !== 'string') return false
	
		str = str.trim()
	
		// https://www.w3.org/TR/SVG/paths.html#PathDataBNF
		if (/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(str) && /[\dz]$/i.test(str) && str.length > 4) return true
	
		return false
	}
	
	},{}],426:[function(_dereq_,module,exports){
	function lerp(v0, v1, t) {
	    return v0*(1-t)+v1*t
	}
	module.exports = lerp
	},{}],427:[function(_dereq_,module,exports){
	/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.3.2/LICENSE.txt */
	(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.mapboxgl = factory());
	}(this, function () { 'use strict';
	
	/* eslint-disable */
	
	var shared, worker, mapboxgl;
	// define gets called three times: one for each chunk. we rely on the order
	// they're imported to know which is which
	function define(_, chunk) {
	if (!shared) {
	    shared = chunk;
	} else if (!worker) {
	    worker = chunk;
	} else {
	    var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'
	
	    var sharedChunk = {};
	    shared(sharedChunk);
	    mapboxgl = chunk(sharedChunk);
	    mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
	}
	}
	
	
	define(["exports"],(function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=a;function a(t,e){this.x=t,this.y=e;}function o(t,e){if(Array.isArray(t)){if(!Array.isArray(e)||t.length!==e.length)return !1;for(var r=0;r<t.length;r++)if(!o(t[r],e[r]))return !1;return !0}if("object"==typeof t&&null!==t&&null!==e){if("object"!=typeof e)return !1;if(Object.keys(t).length!==Object.keys(e).length)return !1;for(var n in t)if(!o(t[n],e[n]))return !1;return !0}return t===e}function s(t,e,n,i){var a=new r(t,e,n,i);return function(t){return a.solve(t)}}a.prototype={clone:function(){return new a(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,r=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=r,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=e*this.x-r*this.y,i=r*this.x+e*this.y;return this.x=n,this.y=i,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.x+r*(this.x-e.x)-n*(this.y-e.y),a=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=i,this.y=a,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},a.convert=function(t){return t instanceof a?t:Array.isArray(t)?new a(t[0],t[1]):t};var u=s(.25,.1,.25,1);function l(t,e,r){return Math.min(r,Math.max(e,t))}function p(t,e,r){var n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function c(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}var h=1;function f(){return h++}function y(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function d(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function m(t,e){t.forEach((function(t){e[t]&&(e[t]=e[t].bind(e));}));}function v(t,e){return -1!==t.indexOf(e,t.length-e.length)}function g(t,e,r){var n={};for(var i in t)n[i]=e.call(r||this,t[i],i,t);return n}function x(t,e,r){var n={};for(var i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function b(t){return Array.isArray(t)?t.map(b):"object"==typeof t&&t?g(t,b):t}var _={};function w(t){_[t]||("undefined"!=typeof console&&console.warn(t),_[t]=!0);}function A(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function k(t){for(var e=0,r=0,n=t.length,i=n-1,a=void 0,o=void 0;r<n;i=r++)a=t[r],e+=((o=t[i]).x-a.x)*(a.y+o.y);return e}function S(t){var e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,(function(t,r,n,i){var a=n||i;return e[r]=!a||a.toLowerCase(),""})),e["max-age"]){var r=parseInt(e["max-age"],10);isNaN(r)?delete e["max-age"]:e["max-age"]=r;}return e}function z(t){try{var e=self[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return !1}}var I,C,B,E,M=self.performance&&self.performance.now?self.performance.now.bind(self.performance):Date.now.bind(Date),P=self.requestAnimationFrame||self.mozRequestAnimationFrame||self.webkitRequestAnimationFrame||self.msRequestAnimationFrame,T=self.cancelAnimationFrame||self.mozCancelAnimationFrame||self.webkitCancelAnimationFrame||self.msCancelAnimationFrame,V={now:M,frame:function(t){var e=P(t);return {cancel:function(){return T(e)}}},getImageData:function(t){var e=self.document.createElement("canvas"),r=e.getContext("2d");if(!r)throw new Error("failed to create canvas 2d context");return e.width=t.width,e.height=t.height,r.drawImage(t,0,0,t.width,t.height),r.getImageData(0,0,t.width,t.height)},resolveURL:function(t){return I||(I=self.document.createElement("a")),I.href=t,I.href},hardwareConcurrency:self.navigator.hardwareConcurrency||4,get devicePixelRatio(){return self.devicePixelRatio},get prefersReducedMotion(){return !!self.matchMedia&&(null==C&&(C=self.matchMedia("(prefers-reduced-motion: reduce)")),C.matches)}},F={API_URL:"https://api.mapbox.com",get EVENTS_URL(){return this.API_URL?0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":0===this.API_URL.indexOf("https://api.mapbox.com")?"https://events.mapbox.com/events/v2":null:null},FEEDBACK_URL:"https://apps.mapbox.com/feedback",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},O={supported:!1,testSupport:function(t){if(L||!E)return;D?U(t):B=t;}},L=!1,D=!1;function U(t){var e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,E),t.isContextLost())return;O.supported=!0;}catch(t){}t.deleteTexture(e),L=!0;}self.document&&((E=self.document.createElement("img")).onload=function(){B&&U(B),B=null,D=!0;},E.onerror=function(){L=!0,B=null;},E.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");var R="01";var j=function(t,e){this._transformRequestFn=t,this._customAccessToken=e,this._createSkuToken();};function q(t){return 0===t.indexOf("mapbox:")}j.prototype._createSkuToken=function(){var t=function(){for(var t="",e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return {token:["1",R,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt;},j.prototype._isSkuTokenExpired=function(){return Date.now()>this._skuTokenExpiresAt},j.prototype.transformRequest=function(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}},j.prototype.normalizeStyleURL=function(t,e){if(!q(t))return t;var r=X(t);return r.path="/styles/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},j.prototype.normalizeGlyphsURL=function(t,e){if(!q(t))return t;var r=X(t);return r.path="/fonts/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},j.prototype.normalizeSourceURL=function(t,e){if(!q(t))return t;var r=X(t);return r.path="/v4/"+r.authority+".json",r.params.push("secure"),this._makeAPIURL(r,this._customAccessToken||e)},j.prototype.normalizeSpriteURL=function(t,e,r,n){var i=X(t);return q(t)?(i.path="/styles/v1"+i.path+"/sprite"+e+r,this._makeAPIURL(i,this._customAccessToken||n)):(i.path+=""+e+r,G(i))},j.prototype.normalizeTileURL=function(t,e,r){if(this._isSkuTokenExpired()&&this._createSkuToken(),!e||!q(e))return t;var n=X(t),i=V.devicePixelRatio>=2||512===r?"@2x":"",a=O.supported?".webp":"$1";return n.path=n.path.replace(/(\.(png|jpg)\d*)(?=$)/,""+i+a),n.path=n.path.replace(/^.+\/v4\//,"/"),n.path="/v4"+n.path,F.REQUIRE_ACCESS_TOKEN&&(F.ACCESS_TOKEN||this._customAccessToken)&&this._skuToken&&n.params.push("sku="+this._skuToken),this._makeAPIURL(n,this._customAccessToken)},j.prototype.canonicalizeTileURL=function(t){var e=X(t);if(!e.path.match(/(^\/v4\/)/)||!e.path.match(/\.[\w]+$/))return t;var r="mapbox://tiles/";r+=e.path.replace("/v4/","");var n=e.params.filter((function(t){return !t.match(/^access_token=/)}));return n.length&&(r+="?"+n.join("&")),r},j.prototype.canonicalizeTileset=function(t,e){if(!q(e))return t.tiles||[];for(var r=[],n=0,i=t.tiles;n<i.length;n+=1){var a=i[n],o=this.canonicalizeTileURL(a);r.push(o);}return r},j.prototype._makeAPIURL=function(t,e){var r="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",n=X(F.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"/"!==n.path&&(t.path=""+n.path+t.path),!F.REQUIRE_ACCESS_TOKEN)return G(t);if(!(e=e||F.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+r);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+r);return t.params=t.params.filter((function(t){return -1===t.indexOf("access_token")})),t.params.push("access_token="+e),G(t)};var N=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;function K(t){return N.test(t)}var Z=/^(\w+):\/\/([^\/?]*)(\/[^?]+)?\??(.+)?/;function X(t){var e=t.match(Z);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function G(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}function J(t){if(!t)return null;var e,r=t.split(".");if(!r||3!==r.length)return null;try{return JSON.parse((e=r[1],decodeURIComponent(self.atob(e).split("").map((function(t){return "%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)})).join(""))))}catch(t){return null}}var H=function(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;};H.prototype.getStorageKey=function(t){var e,r=J(F.ACCESS_TOKEN),n="";return r&&r.u?(e=r.u,n=self.btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,(function(t,e){return String.fromCharCode(Number("0x"+e))})))):n=F.ACCESS_TOKEN||"",t?"mapbox.eventData."+t+":"+n:"mapbox.eventData:"+n},H.prototype.fetchEventData=function(){var t=z("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{var n=self.localStorage.getItem(e);n&&(this.eventData=JSON.parse(n));var i=self.localStorage.getItem(r);i&&(this.anonId=i);}catch(t){w("Unable to read from LocalStorage");}},H.prototype.saveEventData=function(){var t=z("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{self.localStorage.setItem(r,this.anonId),Object.keys(this.eventData).length>=1&&self.localStorage.setItem(e,JSON.stringify(this.eventData));}catch(t){w("Unable to write to LocalStorage");}},H.prototype.processRequests=function(t){},H.prototype.postEvent=function(t,e,r,n){var i=this;if(F.EVENTS_URL){var a=X(F.EVENTS_URL);a.params.push("access_token="+(n||F.ACCESS_TOKEN||""));var o={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:"1.3.2",skuId:R,userId:this.anonId},s=e?c(o,e):o,u={url:G(a),headers:{"Content-Type":"text/plain"},body:JSON.stringify([s])};this.pendingRequest=vt(u,(function(t){i.pendingRequest=null,r(t),i.saveEventData(),i.processRequests(n);}));}},H.prototype.queueRequest=function(t,e){this.queue.push(t),this.processRequests(e);};var Y,$=function(t){function e(){t.call(this,"map.load"),this.success={},this.skuToken="";}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postMapLoadEvent=function(t,e,r,n){this.skuToken=r,(F.EVENTS_URL&&n||F.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return q(t)||K(t)})))&&this.queueRequest({id:e,timestamp:Date.now()},n);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){var r=this.queue.shift(),n=r.id,i=r.timestamp;n&&this.success[n]||(this.anonId||this.fetchEventData(),d(this.anonId)||(this.anonId=y()),this.postEvent(i,{skuToken:this.skuToken},(function(t){t||n&&(e.success[n]=!0);}),t));}},e}(H),W=new(function(t){function e(e){t.call(this,"appUserTurnstile"),this._customAccessToken=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postTurnstileEvent=function(t,e){F.EVENTS_URL&&F.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return q(t)||K(t)}))&&this.queueRequest(Date.now(),e);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();var r=J(F.ACCESS_TOKEN),n=r?r.u:F.ACCESS_TOKEN,i=n!==this.eventData.tokenU;d(this.anonId)||(this.anonId=y(),i=!0);var a=this.queue.shift();if(this.eventData.lastSuccess){var o=new Date(this.eventData.lastSuccess),s=new Date(a),u=(a-this.eventData.lastSuccess)/864e5;i=i||u>=1||u<-1||o.getDate()!==s.getDate();}else i=!0;if(!i)return this.processRequests();this.postEvent(a,{"enabled.telemetry":!1},(function(t){t||(e.eventData.lastSuccess=a,e.eventData.tokenU=n);}),t);}},e}(H)),Q=W.postTurnstileEvent.bind(W),tt=new $,et=tt.postMapLoadEvent.bind(tt),rt="mapbox-tiles",nt=500,it=50,at=42e4;function ot(t,e,r){if(self.caches){var n={status:e.status,statusText:e.statusText,headers:new self.Headers};e.headers.forEach((function(t,e){return n.headers.set(e,t)}));var i=S(e.headers.get("Cache-Control")||"");if(!i["no-store"])i["max-age"]&&n.headers.set("Expires",new Date(r+1e3*i["max-age"]).toUTCString()),new Date(n.headers.get("Expires")).getTime()-r<at||function(t,e){if(void 0===Y)try{new Response(new ReadableStream),Y=!0;}catch(t){Y=!1;}Y?e(t.body):t.blob().then(e);}(e,(function(e){var r=new self.Response(e,n);self.caches.open(rt).then((function(e){return e.put(st(t.url),r)})).catch((function(t){return w(t.message)}));}));}}function st(t){var e=t.indexOf("?");return e<0?t:t.slice(0,e)}function ut(t,e){if(!self.caches)return e(null);var r=st(t.url);self.caches.open(rt).then((function(t){t.match(r).then((function(n){var i=function(t){if(!t)return !1;var e=new Date(t.headers.get("Expires")),r=S(t.headers.get("Cache-Control")||"");return e>Date.now()&&!r["no-cache"]}(n);t.delete(r),i&&t.put(r,n.clone()),e(null,n,i);})).catch(e);})).catch(e);}var lt=1/0;var pt={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(pt);var ct=function(t){function e(e,r,n){401===r&&K(n)&&(e+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),t.call(this,e),this.status=r,this.url=n,this.name=this.constructor.name,this.message=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},e}(Error);function ht(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}var ft=ht()?function(){return self.worker&&self.worker.referrer}:function(){return ("blob:"===self.location.protocol?self.parent:self).location.href};function yt(t,e){var r,n=new self.AbortController,i=new self.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:ft(),signal:n.signal}),a=!1,o=!1,s=(r=i.url).indexOf("sku=")>0&&K(r);"json"===t.type&&i.headers.set("Accept","application/json");var u=function(r,n,a){if(!o){if(r&&"SecurityError"!==r.message&&w(r),n&&a)return l(n);var u=Date.now();self.fetch(i).then((function(r){if(r.ok){var n=s?r.clone():null;return l(r,n,u)}return e(new ct(r.statusText,r.status,t.url))})).catch((function(t){20!==t.code&&e(new Error(t.message));}));}},l=function(r,n,s){("arrayBuffer"===t.type?r.arrayBuffer():"json"===t.type?r.json():r.text()).then((function(t){o||(n&&s&&ot(i,n,s),a=!0,e(null,t,r.headers.get("Cache-Control"),r.headers.get("Expires")));})).catch((function(t){return e(new Error(t.message))}));};return s?ut(i,u):u(null,null),{cancel:function(){o=!0,a||n.abort();}}}var dt=function(t,e){if(r=t.url,!(/^file:/.test(r)||/^file:/.test(ft())&&!/^\w+:/.test(r))){if(self.fetch&&self.Request&&self.AbortController&&self.Request.prototype.hasOwnProperty("signal"))return yt(t,e);if(ht()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,e)}var r;return function(t,e){var r=new self.XMLHttpRequest;for(var n in r.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(r.responseType="arraybuffer"),t.headers)r.setRequestHeader(n,t.headers[n]);return "json"===t.type&&(r.responseType="text",r.setRequestHeader("Accept","application/json")),r.withCredentials="include"===t.credentials,r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){if((r.status>=200&&r.status<300||0===r.status)&&null!==r.response){var n=r.response;if("json"===t.type)try{n=JSON.parse(r.response);}catch(t){return e(t)}e(null,n,r.getResponseHeader("Cache-Control"),r.getResponseHeader("Expires"));}else e(new ct(r.statusText,r.status,t.url));},r.send(t.body),{cancel:function(){return r.abort()}}}(t,e)},mt=function(t,e){return dt(c(t,{type:"arrayBuffer"}),e)},vt=function(t,e){return dt(c(t,{method:"POST"}),e)};var gt,xt;gt=[],xt=0;var bt=function(t,e){if(xt>=F.MAX_PARALLEL_IMAGE_REQUESTS){var r={requestParameters:t,callback:e,cancelled:!1,cancel:function(){this.cancelled=!0;}};return gt.push(r),r}xt++;var n=!1,i=function(){if(!n)for(n=!0,xt--;gt.length&&xt<F.MAX_PARALLEL_IMAGE_REQUESTS;){var t=gt.shift(),e=t.requestParameters,r=t.callback;t.cancelled||(t.cancel=bt(e,r).cancel);}},a=mt(t,(function(t,r,n,a){if(i(),t)e(t);else if(r){var o=new self.Image,s=self.URL||self.webkitURL;o.onload=function(){e(null,o),s.revokeObjectURL(o.src);},o.onerror=function(){return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))};var u=new self.Blob([new Uint8Array(r)],{type:"image/png"});o.cacheControl=n,o.expires=a,o.src=r.byteLength?s.createObjectURL(u):"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";}}));return {cancel:function(){a.cancel(),i();}}};function _t(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function wt(t,e,r){if(r&&r[t]){var n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}var At=function(t,e){void 0===e&&(e={}),c(this,e),this.type=t;},kt=function(t){function e(e,r){void 0===r&&(r={}),t.call(this,"error",c({error:e},r));}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(At),St=function(){};St.prototype.on=function(t,e){return this._listeners=this._listeners||{},_t(t,e,this._listeners),this},St.prototype.off=function(t,e){return wt(t,e,this._listeners),wt(t,e,this._oneTimeListeners),this},St.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},_t(t,e,this._oneTimeListeners),this},St.prototype.fire=function(t,e){"string"==typeof t&&(t=new At(t,e||{}));var r=t.type;if(this.listens(r)){t.target=this;for(var n=0,i=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];n<i.length;n+=1){i[n].call(this,t);}for(var a=0,o=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];a<o.length;a+=1){var s=o[a];wt(r,s,this._oneTimeListeners),s.call(this,t);}var u=this._eventedParent;u&&(c(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),u.fire(t));}else t instanceof kt&&console.error(t.error);return this},St.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t)},St.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this};var zt={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},clusterProperties:{type:"*"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{"fill-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{"circle-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{},"viewport-y":{},source:{}},default:"auto",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"string",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{auto:{},left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{type:"number",units:"ems",default:0,requires:["text-field"],"property-type":"data-driven",expression:{interpolated:!0,parameters:["zoom","feature"]}},"text-variable-anchor":{type:"array",value:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field",{"!":"text-variable-anchor"}],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-writing-mode":{type:"array",value:"enum",values:{horizontal:{},vertical:{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field",{"!":"text-radial-offset"},{"!":"text-variable-anchor"}],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},function_stop:{type:"array",minimum:0,maximum:22,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},expression_name:{type:"enum",values:{let:{group:"Variable binding"},var:{group:"Variable binding"},literal:{group:"Types"},array:{group:"Types"},at:{group:"Lookup"},case:{group:"Decision"},match:{group:"Decision"},coalesce:{group:"Decision"},step:{group:"Ramps, scales, curves"},interpolate:{group:"Ramps, scales, curves"},"interpolate-hcl":{group:"Ramps, scales, curves"},"interpolate-lab":{group:"Ramps, scales, curves"},ln2:{group:"Math"},pi:{group:"Math"},e:{group:"Math"},typeof:{group:"Types"},string:{group:"Types"},number:{group:"Types"},boolean:{group:"Types"},object:{group:"Types"},collator:{group:"Types"},format:{group:"Types"},"number-format":{group:"Types"},"to-string":{group:"Types"},"to-number":{group:"Types"},"to-boolean":{group:"Types"},"to-rgba":{group:"Color"},"to-color":{group:"Types"},rgb:{group:"Color"},rgba:{group:"Color"},get:{group:"Lookup"},has:{group:"Lookup"},length:{group:"Lookup"},properties:{group:"Feature data"},"feature-state":{group:"Feature data"},"geometry-type":{group:"Feature data"},id:{group:"Feature data"},zoom:{group:"Zoom"},"heatmap-density":{group:"Heatmap"},"line-progress":{group:"Feature data"},accumulated:{group:"Feature data"},"+":{group:"Math"},"*":{group:"Math"},"-":{group:"Math"},"/":{group:"Math"},"%":{group:"Math"},"^":{group:"Math"},sqrt:{group:"Math"},log10:{group:"Math"},ln:{group:"Math"},log2:{group:"Math"},sin:{group:"Math"},cos:{group:"Math"},tan:{group:"Math"},asin:{group:"Math"},acos:{group:"Math"},atan:{group:"Math"},min:{group:"Math"},max:{group:"Math"},round:{group:"Math"},abs:{group:"Math"},ceil:{group:"Math"},floor:{group:"Math"},"==":{group:"Decision"},"!=":{group:"Decision"},">":{group:"Decision"},"<":{group:"Decision"},">=":{group:"Decision"},"<=":{group:"Decision"},all:{group:"Decision"},any:{group:"Decision"},"!":{group:"Decision"},"is-supported-script":{group:"String"},upcase:{group:"String"},downcase:{group:"String"},concat:{group:"String"},"resolved-locale":{group:"String"}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,transition:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,overridable:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}}},It=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);};function Ct(t){var e=t.key,r=t.value;return r?[new It(e,r,"constants have been deprecated as of v8")]:[]}function Bt(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}function Et(t){return t instanceof Number||t instanceof String||t instanceof Boolean}function Mt(t){return Et(t)?t.valueOf():t}function Pt(t){if(Array.isArray(t))return t.map(Pt);if(t instanceof Object&&!Et(t)){var e={};for(var r in t)e[r]=Pt(t[r]);return e}return Mt(t)}var Tt=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),Vt=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r],a=i[0],o=i[1];this.bindings[a]=o;}};Vt.prototype.concat=function(t){return new Vt(this,t)},Vt.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Vt.prototype.has=function(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)};var Ft={kind:"null"},Ot={kind:"number"},Lt={kind:"string"},Dt={kind:"boolean"},Ut={kind:"color"},Rt={kind:"object"},jt={kind:"value"},qt={kind:"collator"},Nt={kind:"formatted"};function Kt(t,e){return {kind:"array",itemType:t,N:e}}function Zt(t){if("array"===t.kind){var e=Zt(t.itemType);return "number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var Xt=[Ft,Ot,Lt,Dt,Ut,Nt,Rt,Kt(jt)];function Gt(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!Gt(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=Xt;r<n.length;r+=1){if(!Gt(n[r],e))return null}}return "Expected "+Zt(t)+" but found "+Zt(e)+" instead."}var Jt=e((function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return t<0?0:t>1?1:t}function a(t){return "%"===t[t.length-1]?n(parseFloat(t)/100*255):n(parseInt(t))}function o(t){return "%"===t[t.length-1]?i(parseFloat(t)/100):i(parseFloat(t))}function s(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,i=t.replace(/ /g,"").toLowerCase();if(i in r)return r[i].slice();if("#"===i[0])return 4===i.length?(e=parseInt(i.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===i.length&&(e=parseInt(i.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=i.indexOf("("),l=i.indexOf(")");if(-1!==u&&l+1===i.length){var p=i.substr(0,u),c=i.substr(u+1,l-(u+1)).split(","),h=1;switch(p){case"rgba":if(4!==c.length)return null;h=o(c.pop());case"rgb":return 3!==c.length?null:[a(c[0]),a(c[1]),a(c[2]),h];case"hsla":if(4!==c.length)return null;h=o(c.pop());case"hsl":if(3!==c.length)return null;var f=(parseFloat(c[0])%360+360)%360/360,y=o(c[1]),d=o(c[2]),m=d<=.5?d*(y+1):d+y-d*y,v=2*d-m;return [n(255*s(v,m,f+1/3)),n(255*s(v,m,f)),n(255*s(v,m,f-1/3)),h];default:return null}}return null};}catch(t){}})).parseCSSColor,Ht=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n;};Ht.parse=function(t){if(t){if(t instanceof Ht)return t;if("string"==typeof t){var e=Jt(t);if(e)return new Ht(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},Ht.prototype.toString=function(){var t=this.toArray(),e=t[0],r=t[1],n=t[2],i=t[3];return "rgba("+Math.round(e)+","+Math.round(r)+","+Math.round(n)+","+i+")"},Ht.prototype.toArray=function(){var t=this.r,e=this.g,r=this.b,n=this.a;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]},Ht.black=new Ht(0,0,0,1),Ht.white=new Ht(1,1,1,1),Ht.transparent=new Ht(0,0,0,0),Ht.red=new Ht(1,0,0,1);var Yt=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});};Yt.prototype.compare=function(t,e){return this.collator.compare(t,e)},Yt.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var $t=function(t,e,r,n){this.text=t,this.scale=e,this.fontStack=r,this.textColor=n;},Wt=function(t){this.sections=t;};function Qt(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function te(t){if(null===t)return Ft;if("string"==typeof t)return Lt;if("boolean"==typeof t)return Dt;if("number"==typeof t)return Ot;if(t instanceof Ht)return Ut;if(t instanceof Yt)return qt;if(t instanceof Wt)return Nt;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var a=te(i[n]);if(e){if(e===a)continue;e=jt;break}e=a;}return Kt(e||jt,r)}return Rt}function ee(t){var e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof Ht||t instanceof Wt?t.toString():JSON.stringify(t)}Wt.fromString=function(t){return new Wt([new $t(t,null,null,null)])},Wt.prototype.toString=function(){return this.sections.map((function(t){return t.text})).join("")},Wt.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text);var i={};n.fontStack&&(i["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(i["font-scale"]=n.scale),n.textColor&&(i["text-color"]=["rgba"].concat(n.textColor.toArray())),t.push(i);}return t};var re=function(t,e){this.type=t,this.value=e;};re.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!function t(e){if(null===e)return !0;if("string"==typeof e)return !0;if("boolean"==typeof e)return !0;if("number"==typeof e)return !0;if(e instanceof Ht)return !0;if(e instanceof Yt)return !0;if(e instanceof Wt)return !0;if(Array.isArray(e)){for(var r=0,n=e;r<n.length;r+=1){if(!t(n[r]))return !1}return !0}if("object"==typeof e){for(var i in e)if(!t(e[i]))return !1;return !0}return !1}(t[1]))return e.error("invalid value");var r=t[1],n=te(r),i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new re(n,r)},re.prototype.evaluate=function(){return this.value},re.prototype.eachChild=function(){},re.prototype.possibleOutputs=function(){return [this.value]},re.prototype.serialize=function(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof Ht?["rgba"].concat(this.value.toArray()):this.value instanceof Wt?this.value.serialize():this.value};var ne=function(t){this.name="ExpressionEvaluationError",this.message=t;};ne.prototype.toJSON=function(){return this.message};var ie={string:Lt,number:Ot,boolean:Dt,object:Rt},ae=function(t,e){this.type=t,this.args=e;};ae.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r,n=1,i=t[0];if("array"===i){var a,o;if(t.length>2){var s=t[1];if("string"!=typeof s||!(s in ie)||"object"===s)return e.error('The item type argument of "array" must be one of string, number, boolean',1);a=ie[s],n++;}else a=jt;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);o=t[2],n++;}r=Kt(a,o);}else r=ie[i];for(var u=[];n<t.length;n++){var l=e.parse(t[n],n,jt);if(!l)return null;u.push(l);}return new ae(r,u)},ae.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!Gt(this.type,te(r)))return r;if(e===this.args.length-1)throw new ne("Expected value to be of type "+Zt(this.type)+", but found "+Zt(te(r))+" instead.")}return null},ae.prototype.eachChild=function(t){this.args.forEach(t);},ae.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},ae.prototype.serialize=function(){var t=this.type,e=[t.kind];if("array"===t.kind){var r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);var n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map((function(t){return t.serialize()})))};var oe=function(t){this.type=Nt,this.sections=t;};oe.parse=function(t,e){if(t.length<3)return e.error("Expected at least two arguments.");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");for(var r=[],n=1;n<t.length-1;n+=2){var i=e.parse(t[n],1,jt);if(!i)return null;var a=i.type.kind;if("string"!==a&&"value"!==a&&"null"!==a)return e.error("Formatted text type must be 'string', 'value', or 'null'.");var o=t[n+1];if("object"!=typeof o||Array.isArray(o))return e.error("Format options argument must be an object.");var s=null;if(o["font-scale"]&&!(s=e.parse(o["font-scale"],1,Ot)))return null;var u=null;if(o["text-font"]&&!(u=e.parse(o["text-font"],1,Kt(Lt))))return null;var l=null;if(o["text-color"]&&!(l=e.parse(o["text-color"],1,Ut)))return null;r.push({text:i,scale:s,font:u,textColor:l});}return new oe(r)},oe.prototype.evaluate=function(t){return new Wt(this.sections.map((function(e){return new $t(ee(e.text.evaluate(t)),e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))},oe.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.text),n.scale&&t(n.scale),n.font&&t(n.font),n.textColor&&t(n.textColor);}},oe.prototype.possibleOutputs=function(){return [void 0]},oe.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),n.textColor&&(i["text-color"]=n.textColor.serialize()),t.push(i);}return t};var se={"to-boolean":Dt,"to-color":Ut,"to-number":Ot,"to-string":Lt},ue=function(t,e){this.type=t,this.args=e;};ue.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");for(var n=se[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,jt);if(!o)return null;i.push(o);}return new ue(n,i)},ue.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,(e=i[n].evaluate(t))instanceof Ht)return e;if("string"==typeof e){var a=t.parseColor(e);if(a)return a}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":Qt(e[0],e[1],e[2],e[3])))return new Ht(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new ne(r||"Could not parse color from value '"+("string"==typeof e?e:String(JSON.stringify(e)))+"'")}if("number"===this.type.kind){for(var o=null,s=0,u=this.args;s<u.length;s+=1){if(null===(o=u[s].evaluate(t)))return 0;var l=Number(o);if(!isNaN(l))return l}throw new ne("Could not convert "+JSON.stringify(o)+" to number.")}return "formatted"===this.type.kind?Wt.fromString(ee(this.args[0].evaluate(t))):ee(this.args[0].evaluate(t))},ue.prototype.eachChild=function(t){this.args.forEach(t);},ue.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},ue.prototype.serialize=function(){if("formatted"===this.type.kind)return new oe([{text:this.args[0],scale:null,font:null,textColor:null}]).serialize();var t=["to-"+this.type.kind];return this.eachChild((function(e){t.push(e.serialize());})),t};var le=["Unknown","Point","LineString","Polygon"],pe=function(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={};};pe.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},pe.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?le[this.feature.type]:this.feature.type:null},pe.prototype.properties=function(){return this.feature&&this.feature.properties||{}},pe.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=Ht.parse(t)),e};var ce=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;};ce.prototype.evaluate=function(t){return this._evaluate(t,this.args)},ce.prototype.eachChild=function(t){this.args.forEach(t);},ce.prototype.possibleOutputs=function(){return [void 0]},ce.prototype.serialize=function(){return [this.name].concat(this.args.map((function(t){return t.serialize()})))},ce.parse=function(t,e){var r,n=t[0],i=ce.definitions[n];if(!i)return e.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0);for(var a=Array.isArray(i)?i[0]:i.type,o=Array.isArray(i)?[[i[1],i[2]]]:i.overloads,s=o.filter((function(e){var r=e[0];return !Array.isArray(r)||r.length===t.length-1})),u=null,l=0,p=s;l<p.length;l+=1){var c=p[l],h=c[0],f=c[1];u=new ve(e.registry,e.path,null,e.scope);for(var y=[],d=!1,m=1;m<t.length;m++){var v=t[m],g=Array.isArray(h)?h[m-1]:h.type,x=u.parse(v,1+y.length,g);if(!x){d=!0;break}y.push(x);}if(!d)if(Array.isArray(h)&&h.length!==y.length)u.error("Expected "+h.length+" arguments, but found "+y.length+" instead.");else{for(var b=0;b<y.length;b++){var _=Array.isArray(h)?h[b]:h.type,w=y[b];u.concat(b+1).checkSubtype(_,w.type);}if(0===u.errors.length)return new ce(n,a,f,y)}}if(1===s.length)(r=e.errors).push.apply(r,u.errors);else{for(var A=(s.length?s:o).map((function(t){var e,r=t[0];return e=r,Array.isArray(e)?"("+e.map(Zt).join(", ")+")":"("+Zt(e.type)+"...)"})).join(" | "),k=[],S=1;S<t.length;S++){var z=e.parse(t[S],1+k.length);if(!z)return null;k.push(Zt(z.type));}e.error("Expected arguments of type "+A+", but found ("+k.join(", ")+") instead.");}return null},ce.register=function(t,e){for(var r in ce.definitions=e,e)t[r]=ce;};var he=function(t,e,r){this.type=qt,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;};function fe(t){if(t instanceof ce){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}var e=!0;return t.eachChild((function(t){e&&!fe(t)&&(e=!1);})),e}function ye(t){if(t instanceof ce&&"feature-state"===t.name)return !1;var e=!0;return t.eachChild((function(t){e&&!ye(t)&&(e=!1);})),e}function de(t,e){if(t instanceof ce&&e.indexOf(t.name)>=0)return !1;var r=!0;return t.eachChild((function(t){r&&!de(t,e)&&(r=!1);})),r}he.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,Dt);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,Dt);if(!i)return null;var a=null;return r.locale&&!(a=e.parse(r.locale,1,Lt))?null:new he(n,i,a)},he.prototype.evaluate=function(t){return new Yt(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},he.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);},he.prototype.possibleOutputs=function(){return [void 0]},he.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var me=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e;};me.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new me(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},me.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},me.prototype.eachChild=function(){},me.prototype.possibleOutputs=function(){return [void 0]},me.prototype.serialize=function(){return ["var",this.name]};var ve=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new Vt),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map((function(t){return "["+t+"]"})).join(""),this.scope=n,this.errors=i,this.expectedType=r;};function ge(t,e){for(var r,n,i=t.length-1,a=0,o=i,s=0;a<=o;)if(r=t[s=Math.floor((a+o)/2)],n=t[s+1],r<=e){if(s===i||e<n)return s;a=s+1;}else{if(!(r>e))throw new ne("Input is not a number.");o=s-1;}return 0}ve.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},ve.prototype._parse=function(t,e){function r(t,e,r){return "assert"===r?new ae(e,[t]):"coerce"===r?new ue(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var n=t[0];if("string"!=typeof n)return this.error("Expression name must be a string, but found "+typeof n+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var i=this.registry[n];if(i){var a=i.parse(t,this);if(!a)return null;if(this.expectedType){var o=this.expectedType,s=a.type;if("string"!==o.kind&&"number"!==o.kind&&"boolean"!==o.kind&&"object"!==o.kind&&"array"!==o.kind||"value"!==s.kind)if("color"!==o.kind&&"formatted"!==o.kind||"value"!==s.kind&&"string"!==s.kind){if(this.checkSubtype(o,s))return null}else a=r(a,o,e.typeAnnotation||"coerce");else a=r(a,o,e.typeAnnotation||"assert");}if(!(a instanceof re)&&function t(e){if(e instanceof me)return t(e.boundExpression);if(e instanceof ce&&"error"===e.name)return !1;if(e instanceof he)return !1;var r=e instanceof ue||e instanceof ae;var n=!0;e.eachChild((function(e){n=r?n&&t(e):n&&e instanceof re;}));if(!n)return !1;return fe(e)&&de(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"])}(a)){var u=new pe;try{a=new re(a.type,a.evaluate(u));}catch(t){return this.error(t.message),null}}return a}return this.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},ve.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new ve(this.registry,n,e||null,i,this.errors)},ve.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map((function(t){return "["+t+"]"})).join("");this.errors.push(new Tt(n,t));},ve.prototype.checkSubtype=function(t,e){var r=Gt(t,e);return r&&this.error(r),r};var xe=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var a=i[n],o=a[0],s=a[1];this.labels.push(o),this.outputs.push(s);}};function be(t,e,r){return t*(1-r)+e*r}xe.parse=function(t,e){if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");var r=e.parse(t[1],1,Ot);if(!r)return null;var n=[],i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(var a=1;a<t.length;a+=2){var o=1===a?-1/0:t[a],s=t[a+1],u=a,l=a+1;if("number"!=typeof o)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',u);if(n.length&&n[n.length-1][0]>=o)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',u);var p=e.parse(s,l,i);if(!p)return null;i=i||p.type,n.push([o,p]);}return new xe(i,r,n)},xe.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[ge(e,n)].evaluate(t)},xe.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},xe.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()})))},xe.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var _e=Object.freeze({number:be,color:function(t,e,r){return new Ht(be(t.r,e.r,r),be(t.g,e.g,r),be(t.b,e.b,r),be(t.a,e.a,r))},array:function(t,e,r){return t.map((function(t,n){return be(t,e[n],r)}))}}),we=.95047,Ae=1,ke=1.08883,Se=4/29,ze=6/29,Ie=3*ze*ze,Ce=ze*ze*ze,Be=Math.PI/180,Ee=180/Math.PI;function Me(t){return t>Ce?Math.pow(t,1/3):t/Ie+Se}function Pe(t){return t>ze?t*t*t:Ie*(t-Se)}function Te(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function Ve(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Fe(t){var e=Ve(t.r),r=Ve(t.g),n=Ve(t.b),i=Me((.4124564*e+.3575761*r+.1804375*n)/we),a=Me((.2126729*e+.7151522*r+.072175*n)/Ae);return {l:116*a-16,a:500*(i-a),b:200*(a-Me((.0193339*e+.119192*r+.9503041*n)/ke)),alpha:t.a}}function Oe(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=Ae*Pe(e),r=we*Pe(r),n=ke*Pe(n),new Ht(Te(3.2404542*r-1.5371385*e-.4985314*n),Te(-.969266*r+1.8760108*e+.041556*n),Te(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function Le(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}var De={forward:Fe,reverse:Oe,interpolate:function(t,e,r){return {l:be(t.l,e.l,r),a:be(t.a,e.a,r),b:be(t.b,e.b,r),alpha:be(t.alpha,e.alpha,r)}}},Ue={forward:function(t){var e=Fe(t),r=e.l,n=e.a,i=e.b,a=Math.atan2(i,n)*Ee;return {h:a<0?a+360:a,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*Be,r=t.c;return Oe({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:Le(t.h,e.h,r),c:be(t.c,e.c,r),l:be(t.l,e.l,r),alpha:be(t.alpha,e.alpha,r)}}},Re=Object.freeze({lab:De,hcl:Ue}),je=function(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(var a=0,o=i;a<o.length;a+=1){var s=o[a],u=s[0],l=s[1];this.labels.push(u),this.outputs.push(l);}};function qe(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}je.interpolationFactor=function(t,e,n,i){var a=0;if("exponential"===t.name)a=qe(e,t.base,n,i);else if("linear"===t.name)a=qe(e,1,n,i);else if("cubic-bezier"===t.name){var o=t.controlPoints;a=new r(o[0],o[1],o[2],o[3]).solve(qe(e,1,n,i));}return a},je.parse=function(t,e){var r=t[0],n=t[1],i=t[2],a=t.slice(3);if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){var o=n[1];if("number"!=typeof o)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:o};}else{if("cubic-bezier"!==n[0])return e.error("Unknown interpolation type "+String(n[0]),1,0);var s=n.slice(1);if(4!==s.length||s.some((function(t){return "number"!=typeof t||t<0||t>1})))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:s};}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(i=e.parse(i,2,Ot)))return null;var u=[],l=null;"interpolate-hcl"===r||"interpolate-lab"===r?l=Ut:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var p=0;p<a.length;p+=2){var c=a[p],h=a[p+1],f=p+3,y=p+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',f);if(u.length&&u[u.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',f);var d=e.parse(h,y,l);if(!d)return null;l=l||d.type,u.push([c,d]);}return "number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new je(l,r,n,i,u):e.error("Type "+Zt(l)+" is not interpolatable.")},je.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var a=ge(e,n),o=e[a],s=e[a+1],u=je.interpolationFactor(this.interpolation,n,o,s),l=r[a].evaluate(t),p=r[a+1].evaluate(t);return "interpolate"===this.operator?_e[this.type.kind.toLowerCase()](l,p,u):"interpolate-hcl"===this.operator?Ue.reverse(Ue.interpolate(Ue.forward(l),Ue.forward(p),u)):De.reverse(De.interpolate(De.forward(l),De.forward(p),u))},je.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},je.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()})))},je.prototype.serialize=function(){var t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);for(var e=[this.operator,t,this.input.serialize()],r=0;r<this.labels.length;r++)e.push(this.labels[r],this.outputs[r].serialize());return e};var Ne=function(t,e){this.type=t,this.args=e;};Ne.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],a=0,o=t.slice(1);a<o.length;a+=1){var s=o[a],u=e.parse(s,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!u)return null;r=r||u.type,i.push(u);}var l=n&&i.some((function(t){return Gt(n,t.type)}));return new Ne(l?jt:r,i)},Ne.prototype.evaluate=function(t){for(var e=null,r=0,n=this.args;r<n.length;r+=1){if(null!==(e=n[r].evaluate(t)))break}return e},Ne.prototype.eachChild=function(t){this.args.forEach(t);},Ne.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},Ne.prototype.serialize=function(){var t=["coalesce"];return this.eachChild((function(e){t.push(e.serialize());})),t};var Ke=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;};Ke.prototype.evaluate=function(t){return this.result.evaluate(t)},Ke.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1){t(r[e][1]);}t(this.result);},Ke.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var a=e.parse(t[n+1],n+1);if(!a)return null;r.push([i,a]);}var o=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return o?new Ke(r,o):null},Ke.prototype.possibleOutputs=function(){return this.result.possibleOutputs()},Ke.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t.push(i,a.serialize());}return t.push(this.result.serialize()),t};var Ze=function(t,e,r){this.type=t,this.index=e,this.input=r;};Ze.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,Ot),n=e.parse(t[2],2,Kt(e.expectedType||jt));if(!r||!n)return null;var i=n.type;return new Ze(i.itemType,r,n)},Ze.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new ne("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new ne("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new ne("Array index must be an integer, but found "+e+" instead.");return r[e]},Ze.prototype.eachChild=function(t){t(this.index),t(this.input);},Ze.prototype.possibleOutputs=function(){return [void 0]},Ze.prototype.serialize=function(){return ["at",this.index.serialize(),this.input.serialize()]};var Xe=function(t,e,r,n,i,a){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=a;};Xe.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},a=[],o=2;o<t.length-1;o+=2){var s=t[o],u=t[o+1];Array.isArray(s)||(s=[s]);var l=e.concat(o);if(0===s.length)return l.error("Expected at least one branch label.");for(var p=0,c=s;p<c.length;p+=1){var h=c[p];if("number"!=typeof h&&"string"!=typeof h)return l.error("Branch labels must be numbers or strings.");if("number"==typeof h&&Math.abs(h)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof h&&Math.floor(h)!==h)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,te(h)))return null}else r=te(h);if(void 0!==i[String(h)])return l.error("Branch labels must be unique.");i[String(h)]=a.length;}var f=e.parse(u,o,n);if(!f)return null;n=n||f.type,a.push(f);}var y=e.parse(t[1],1,jt);if(!y)return null;var d=e.parse(t[t.length-1],t.length-1,n);return d?"value"!==y.type.kind&&e.concat(1).checkSubtype(r,y.type)?null:new Xe(r,n,y,i,a,d):null},Xe.prototype.evaluate=function(t){var e=this.input.evaluate(t);return (te(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},Xe.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);},Xe.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()}))).concat(this.otherwise.possibleOutputs())},Xe.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,a=Object.keys(this.cases).sort();i<a.length;i+=1){var o=a[i];void 0===(c=n[this.cases[o]])?(n[this.cases[o]]=r.length,r.push([this.cases[o],[o]])):r[c][1].push(o);}for(var s=function(e){return "number"===t.inputType.kind?Number(e):e},u=0,l=r;u<l.length;u+=1){var p=l[u],c=p[0],h=p[1];1===h.length?e.push(s(h[0])):e.push(h.map(s)),e.push(this.outputs[outputIndex$1].serialize());}return e.push(this.otherwise.serialize()),e};var Ge=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r;};function Je(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function He(t,e,r,n){return 0===n.compare(e,r)}function Ye(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=Dt,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],a=e.parse(t[1],1,jt);if(!a)return null;if(!Je(r,a.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+Zt(a.type)+"'.");var o=e.parse(t[2],2,jt);if(!o)return null;if(!Je(r,o.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+Zt(o.type)+"'.");if(a.type.kind!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot compare types '"+Zt(a.type)+"' and '"+Zt(o.type)+"'.");n&&("value"===a.type.kind&&"value"!==o.type.kind?a=new ae(o.type,[a]):"value"!==a.type.kind&&"value"===o.type.kind&&(o=new ae(a.type,[o])));var s=null;if(4===t.length){if("string"!==a.type.kind&&"string"!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,qt)))return null}return new i(a,o,s)},i.prototype.evaluate=function(i){var a=this.lhs.evaluate(i),o=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=te(a),u=te(o);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new ne('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=te(a),p=te(o);if("string"!==l.kind||"string"!==p.kind)return e(i,a,o)}return this.collator?r(i,a,o,this.collator.evaluate(i)):e(i,a,o)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);},i.prototype.possibleOutputs=function(){return [!0,!1]},i.prototype.serialize=function(){var e=[t];return this.eachChild((function(t){e.push(t.serialize());})),e},i}()}Ge.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var a=e.parse(t[i],i,Dt);if(!a)return null;var o=e.parse(t[i+1],i+1,r);if(!o)return null;n.push([a,o]),r=r||o.type;}var s=e.parse(t[t.length-1],t.length-1,r);return s?new Ge(r,n,s):null},Ge.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];if(i.evaluate(t))return a.evaluate(t)}return this.otherwise.evaluate(t)},Ge.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t(i),t(a);}t(this.otherwise);},Ge.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.branches.map((function(t){t[0];return t[1].possibleOutputs()}))).concat(this.otherwise.possibleOutputs())},Ge.prototype.serialize=function(){var t=["case"];return this.eachChild((function(e){t.push(e.serialize());})),t};var $e=Ye("==",(function(t,e,r){return e===r}),He),We=Ye("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return !He(0,e,r,n)})),Qe=Ye("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),tr=Ye(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),er=Ye("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),rr=Ye(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0})),nr=function(t,e,r,n,i){this.type=Lt,this.number=t,this.locale=e,this.currency=r,this.minFractionDigits=n,this.maxFractionDigits=i;};nr.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,Ot);if(!r)return null;var n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");var i=null;if(n.locale&&!(i=e.parse(n.locale,1,Lt)))return null;var a=null;if(n.currency&&!(a=e.parse(n.currency,1,Lt)))return null;var o=null;if(n["min-fraction-digits"]&&!(o=e.parse(n["min-fraction-digits"],1,Ot)))return null;var s=null;return n["max-fraction-digits"]&&!(s=e.parse(n["max-fraction-digits"],1,Ot))?null:new nr(r,i,a,o,s)},nr.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},nr.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);},nr.prototype.possibleOutputs=function(){return [void 0]},nr.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]};var ir=function(t){this.type=Ot,this.input=t;};ir.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+Zt(r.type)+" instead."):new ir(r):null},ir.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new ne("Expected value to be of type string or array, but found "+Zt(te(e))+" instead.")},ir.prototype.eachChild=function(t){t(this.input);},ir.prototype.possibleOutputs=function(){return [void 0]},ir.prototype.serialize=function(){var t=["length"];return this.eachChild((function(e){t.push(e.serialize());})),t};var ar={"==":$e,"!=":We,">":tr,"<":Qe,">=":rr,"<=":er,array:ae,at:Ze,boolean:ae,case:Ge,coalesce:Ne,collator:he,format:oe,interpolate:je,"interpolate-hcl":je,"interpolate-lab":je,length:ir,let:Ke,literal:re,match:Xe,number:ae,"number-format":nr,object:ae,step:xe,string:ae,"to-boolean":ue,"to-color":ue,"to-number":ue,"to-string":ue,var:me};function or(t,e){var r=e[0],n=e[1],i=e[2],a=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var o=a?a.evaluate(t):1,s=Qt(r,n,i,o);if(s)throw new ne(s);return new Ht(r/255*o,n/255*o,i/255*o,o)}function sr(t,e){return t in e}function ur(t,e){var r=e[t];return void 0===r?null:r}function lr(t){return {type:t}}function pr(t){return {result:"success",value:t}}function cr(t){return {result:"error",value:t}}function hr(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function fr(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function yr(t){return !!t.expression&&t.expression.interpolated}function dr(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function mr(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function vr(t){return t}function gr(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function xr(t,e,r,n,i){return gr(typeof r===i?n[r]:void 0,t.default,e.default)}function br(t,e,r){if("number"!==dr(r))return gr(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=ge(t.stops.map((function(t){return t[0]})),r);return t.stops[i][1]}function _r(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==dr(r))return gr(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var a=ge(t.stops.map((function(t){return t[0]})),r),o=function(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[a][0],t.stops[a+1][0]),s=t.stops[a][1],u=t.stops[a+1][1],l=_e[e.type]||vr;if(t.colorSpace&&"rgb"!==t.colorSpace){var p=Re[t.colorSpace];l=function(t,e){return p.reverse(p.interpolate(p.forward(t),p.forward(e),o))};}return "function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,o)}}:l(s,u,o)}function wr(t,e,r){return "color"===e.type?r=Ht.parse(r):"formatted"===e.type?r=Wt.fromString(r.toString()):dr(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),gr(r,t.default,e.default)}ce.register(ar,{error:[{kind:"error"},[Lt],function(t,e){var r=e[0];throw new ne(r.evaluate(t))}],typeof:[Lt,[jt],function(t,e){return Zt(te(e[0].evaluate(t)))}],"to-rgba":[Kt(Ot,4),[Ut],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[Ut,[Ot,Ot,Ot],or],rgba:[Ut,[Ot,Ot,Ot,Ot],or],has:{type:Dt,overloads:[[[Lt],function(t,e){return sr(e[0].evaluate(t),t.properties())}],[[Lt,Rt],function(t,e){var r=e[0],n=e[1];return sr(r.evaluate(t),n.evaluate(t))}]]},get:{type:jt,overloads:[[[Lt],function(t,e){return ur(e[0].evaluate(t),t.properties())}],[[Lt,Rt],function(t,e){var r=e[0],n=e[1];return ur(r.evaluate(t),n.evaluate(t))}]]},"feature-state":[jt,[Lt],function(t,e){return ur(e[0].evaluate(t),t.featureState||{})}],properties:[Rt,[],function(t){return t.properties()}],"geometry-type":[Lt,[],function(t){return t.geometryType()}],id:[jt,[],function(t){return t.id()}],zoom:[Ot,[],function(t){return t.globals.zoom}],"heatmap-density":[Ot,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[Ot,[],function(t){return t.globals.lineProgress||0}],accumulated:[jt,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[Ot,lr(Ot),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1){r+=i[n].evaluate(t);}return r}],"*":[Ot,lr(Ot),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1){r*=i[n].evaluate(t);}return r}],"-":{type:Ot,overloads:[[[Ot,Ot],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)-n.evaluate(t)}],[[Ot],function(t,e){return -e[0].evaluate(t)}]]},"/":[Ot,[Ot,Ot],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)/n.evaluate(t)}],"%":[Ot,[Ot,Ot],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)%n.evaluate(t)}],ln2:[Ot,[],function(){return Math.LN2}],pi:[Ot,[],function(){return Math.PI}],e:[Ot,[],function(){return Math.E}],"^":[Ot,[Ot,Ot],function(t,e){var r=e[0],n=e[1];return Math.pow(r.evaluate(t),n.evaluate(t))}],sqrt:[Ot,[Ot],function(t,e){var r=e[0];return Math.sqrt(r.evaluate(t))}],log10:[Ot,[Ot],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN10}],ln:[Ot,[Ot],function(t,e){var r=e[0];return Math.log(r.evaluate(t))}],log2:[Ot,[Ot],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN2}],sin:[Ot,[Ot],function(t,e){var r=e[0];return Math.sin(r.evaluate(t))}],cos:[Ot,[Ot],function(t,e){var r=e[0];return Math.cos(r.evaluate(t))}],tan:[Ot,[Ot],function(t,e){var r=e[0];return Math.tan(r.evaluate(t))}],asin:[Ot,[Ot],function(t,e){var r=e[0];return Math.asin(r.evaluate(t))}],acos:[Ot,[Ot],function(t,e){var r=e[0];return Math.acos(r.evaluate(t))}],atan:[Ot,[Ot],function(t,e){var r=e[0];return Math.atan(r.evaluate(t))}],min:[Ot,lr(Ot),function(t,e){return Math.min.apply(Math,e.map((function(e){return e.evaluate(t)})))}],max:[Ot,lr(Ot),function(t,e){return Math.max.apply(Math,e.map((function(e){return e.evaluate(t)})))}],abs:[Ot,[Ot],function(t,e){var r=e[0];return Math.abs(r.evaluate(t))}],round:[Ot,[Ot],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[Ot,[Ot],function(t,e){var r=e[0];return Math.floor(r.evaluate(t))}],ceil:[Ot,[Ot],function(t,e){var r=e[0];return Math.ceil(r.evaluate(t))}],"filter-==":[Dt,[Lt,jt],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[Dt,[jt],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[Dt,[Lt],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[Dt,[Lt,jt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<a}],"filter-id-<":[Dt,[jt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[Dt,[Lt,jt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>a}],"filter-id->":[Dt,[jt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[Dt,[Lt,jt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<=a}],"filter-id-<=":[Dt,[jt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[Dt,[Lt,jt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>=a}],"filter-id->=":[Dt,[jt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[Dt,[jt],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[Dt,[],function(t){return null!==t.id()}],"filter-type-in":[Dt,[Kt(Lt)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[Dt,[Kt(jt)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[Dt,[Lt,Kt(jt)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[Dt,[Lt,Kt(jt)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:Dt,overloads:[[[Dt,Dt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)&&n.evaluate(t)}],[lr(Dt),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(!n[r].evaluate(t))return !1}return !0}]]},any:{type:Dt,overloads:[[[Dt,Dt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)||n.evaluate(t)}],[lr(Dt),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(n[r].evaluate(t))return !0}return !1}]]},"!":[Dt,[Dt],function(t,e){return !e[0].evaluate(t)}],"is-supported-script":[Dt,[Lt],function(t,e){var r=e[0],n=t.globals&&t.globals.isSupportedScript;return !n||n(r.evaluate(t))}],upcase:[Lt,[Lt],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[Lt,[Lt],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[Lt,lr(jt),function(t,e){return e.map((function(e){return ee(e.evaluate(t))})).join("")}],"resolved-locale":[Lt,[qt],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var Ar=function(t,e){this.expression=t,this._warningHistory={},this._evaluator=new pe,this._defaultValue=e?function(t){return "color"===t.type&&mr(t.default)?new Ht(0,0,0,0):"color"===t.type?Ht.parse(t.default)||null:void 0===t.default?null:t.default}(e):null,this._enumValues=e&&"enum"===e.type?e.values:null;};function kr(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in ar}function Sr(t,e){var r=new ve(ar,[],e?function(t){var e={color:Ut,string:Lt,number:Ot,enum:Lt,boolean:Dt,formatted:Nt};if("array"===t.type)return Kt(e[t.value]||jt,t.length);return e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?pr(new Ar(n,e)):cr(r.errors)}Ar.prototype.evaluateWithoutErrorHandling=function(t,e,r,n){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.formattedSection=n,this.expression.evaluate(this._evaluator)},Ar.prototype.evaluate=function(t,e,r,n){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.formattedSection=n||null;try{var i=this.expression.evaluate(this._evaluator);if(null==i)return this._defaultValue;if(this._enumValues&&!(i in this._enumValues))throw new ne("Expected value to be one of "+Object.keys(this._enumValues).map((function(t){return JSON.stringify(t)})).join(", ")+", but found "+JSON.stringify(i)+" instead.");return i}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var zr=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!ye(e.expression);};zr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n)},zr.prototype.evaluate=function(t,e,r,n){return this._styleExpression.evaluate(t,e,r,n)};var Ir=function(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!ye(e.expression),this.interpolationType=n;};function Cr(t,e){if("error"===(t=Sr(t,e)).result)return t;var r=t.value.expression,n=fe(r);if(!n&&!hr(e))return cr([new Tt("","data expressions not supported")]);var i=de(r,["zoom"]);if(!i&&!fr(e))return cr([new Tt("","zoom expressions not supported")]);var a=function t(e){var r=null;if(e instanceof Ke)r=t(e.result);else if(e instanceof Ne)for(var n=0,i=e.args;n<i.length;n+=1){var a=i[n];if(r=t(a))break}else(e instanceof xe||e instanceof je)&&e.input instanceof ce&&"zoom"===e.input.name&&(r=e);if(r instanceof Tt)return r;e.eachChild((function(e){var n=t(e);n instanceof Tt?r=n:!r&&n?r=new Tt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new Tt("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));}));return r}(r);if(!a&&!i)return cr([new Tt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);if(a instanceof Tt)return cr([a]);if(a instanceof je&&!yr(e))return cr([new Tt("",'"interpolate" expressions cannot be used with this property')]);if(!a)return pr(new zr(n?"constant":"source",t.value));var o=a instanceof je?a.interpolation:void 0;return pr(new Ir(n?"camera":"composite",t.value,a.labels,o))}Ir.prototype.evaluateWithoutErrorHandling=function(t,e,r,n){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n)},Ir.prototype.evaluate=function(t,e,r,n){return this._styleExpression.evaluate(t,e,r,n)},Ir.prototype.interpolationFactor=function(t,e,r){return this.interpolationType?je.interpolationFactor(this.interpolationType,t,e,r):0};var Br=function(t,e){this._parameters=t,this._specification=e,Bt(this,function t(e,r){var n,i,a,o="color"===r.type,s=e.stops&&"object"==typeof e.stops[0][0],u=s||void 0!==e.property,l=s||!u,p=e.type||(yr(r)?"exponential":"interval");if(o&&((e=Bt({},e)).stops&&(e.stops=e.stops.map((function(t){return [t[0],Ht.parse(t[1])]}))),e.default?e.default=Ht.parse(e.default):e.default=Ht.parse(r.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!Re[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===p)n=_r;else if("interval"===p)n=br;else if("categorical"===p){n=xr,i=Object.create(null);for(var c=0,h=e.stops;c<h.length;c+=1){var f=h[c];i[f[0]]=f[1];}a=typeof e.stops[0][0];}else{if("identity"!==p)throw new Error('Unknown function type "'+p+'"');n=wr;}if(s){for(var y={},d=[],m=0;m<e.stops.length;m++){var v=e.stops[m],g=v[0].zoom;void 0===y[g]&&(y[g]={zoom:g,type:e.type,property:e.property,default:e.default,stops:[]},d.push(g)),y[g].stops.push([v[0].value,v[1]]);}for(var x=[],b=0,_=d;b<_.length;b+=1){var w=_[b];x.push([y[w].zoom,t(y[w],r)]);}var A={name:"linear"};return {kind:"composite",interpolationType:A,interpolationFactor:je.interpolationFactor.bind(void 0,A),zoomStops:x.map((function(t){return t[0]})),evaluate:function(t,n){var i=t.zoom;return _r({stops:x,base:e.base},r,i).evaluate(i,n)}}}if(l){var k="exponential"===p?{name:"exponential",base:void 0!==e.base?e.base:1}:null;return {kind:"camera",interpolationType:k,interpolationFactor:je.interpolationFactor.bind(void 0,k),zoomStops:e.stops.map((function(t){return t[0]})),evaluate:function(t){var o=t.zoom;return n(e,r,o,i,a)}}}return {kind:"source",evaluate:function(t,o){var s=o&&o.properties?o.properties[e.property]:void 0;return void 0===s?gr(e.default,r.default):n(e,r,s,i,a)}}}(this._parameters,this._specification));};function Er(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},a=t.style,o=t.styleSpec,s=[],u=dr(r);if("object"!==u)return [new It(e,r,"object expected, "+u+" found")];for(var l in r){var p=l.split(".")[0],c=n[p]||n["*"],h=void 0;if(i[p])h=i[p];else if(n[p])h=tn;else if(i["*"])h=i["*"];else{if(!n["*"]){s.push(new It(e,r[l],'unknown property "'+l+'"'));continue}h=tn;}s=s.concat(h({key:(e?e+".":e)+l,value:r[l],valueSpec:c,style:a,styleSpec:o,object:r,objectKey:l},r));}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new It(e,r,'missing required property "'+f+'"'));return s}function Mr(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,a=t.key,o=t.arrayElementValidator||tn;if("array"!==dr(e))return [new It(a,e,"array expected, "+dr(e)+" found")];if(r.length&&e.length!==r.length)return [new It(a,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return [new It(a,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value,values:r.values};i.$version<7&&(s.function=r.function),"object"===dr(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(o({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:a+"["+l+"]"}));return u}function Pr(t){var e=t.key,r=t.value,n=t.valueSpec,i=dr(r);return "number"!==i?[new It(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new It(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new It(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function Tr(t){var e,r,n,i=t.valueSpec,a=Mt(t.value.type),o={},s="categorical"!==a&&void 0===t.value.property,u=!s,l="array"===dr(t.value.stops)&&"array"===dr(t.value.stops[0])&&"object"===dr(t.value.stops[0][0]),p=Er({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===a)return [new It(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;e=e.concat(Mr({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:c})),"array"===dr(r)&&0===r.length&&e.push(new It(t.key,r,"array must have at least one stop"));return e},default:function(t){return tn({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===a&&s&&p.push(new It(t.key,t.value,'missing required property "property"')),"identity"===a||t.value.stops||p.push(new It(t.key,t.value,'missing required property "stops"')),"exponential"===a&&t.valueSpec.expression&&!yr(t.valueSpec)&&p.push(new It(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!hr(t.valueSpec)?p.push(new It(t.key,t.value,"property functions not supported")):s&&!fr(t.valueSpec)&&p.push(new It(t.key,t.value,"zoom functions not supported"))),"categorical"!==a&&!l||void 0!==t.value.property||p.push(new It(t.key,t.value,'"property" property is required')),p;function c(t){var e=[],a=t.value,s=t.key;if("array"!==dr(a))return [new It(s,a,"array expected, "+dr(a)+" found")];if(2!==a.length)return [new It(s,a,"array length 2 expected, length "+a.length+" found")];if(l){if("object"!==dr(a[0]))return [new It(s,a,"object expected, "+dr(a[0])+" found")];if(void 0===a[0].zoom)return [new It(s,a,"object stop key must have zoom")];if(void 0===a[0].value)return [new It(s,a,"object stop key must have value")];if(n&&n>Mt(a[0].zoom))return [new It(s,a[0].zoom,"stop zoom values must appear in ascending order")];Mt(a[0].zoom)!==n&&(n=Mt(a[0].zoom),r=void 0,o={}),e=e.concat(Er({key:s+"[0]",value:a[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Pr,value:h}}));}else e=e.concat(h({key:s+"[0]",value:a[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},a));return kr(Pt(a[1]))?e.concat([new It(s+"[1]",a[1],"expressions are not allowed in function stops.")]):e.concat(tn({key:s+"[1]",value:a[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function h(t,n){var s=dr(t.value),u=Mt(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return [new It(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return [new It(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==a){var p="number expected, "+s+" found";return hr(i)&&void 0===a&&(p+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new It(t.key,l,p)]}return "categorical"!==a||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==a&&"number"===s&&void 0!==r&&u<r?[new It(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===a&&u in o?[new It(t.key,l,"stop domain values must be unique")]:(o[u]=!0,[])):[new It(t.key,l,"integer expected, found "+u)]}}function Vr(t){var e=("property"===t.expressionContext?Cr:Sr)(Pt(t.value),t.valueSpec);if("error"===e.result)return e.value.map((function(e){return new It(""+t.key+e.key,t.value,e.message)}));var r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&-1!==r.possibleOutputs().indexOf(void 0))return [new It(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!ye(r))return [new It(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!ye(r))return [new It(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!de(r,["zoom","feature-state"]))return [new It(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!fe(r))return [new It(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function Fr(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(Mt(r))&&i.push(new It(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(Mt(r))&&i.push(new It(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function Or(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!Or(n)&&"boolean"!=typeof n)return !1}return !0;default:return !0}}Br.deserialize=function(t){return new Br(t._parameters,t._specification)},Br.serialize=function(t){return {_parameters:t._parameters,_specification:t._specification}};var Lr={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function Dr(t){if(null==t)return function(){return !0};Or(t)||(t=Rr(t));var e=Sr(t,Lr);if("error"===e.result)throw new Error(e.value.map((function(t){return t.key+": "+t.message})).join(", "));return function(t,r){return e.value.evaluate(t,r)}}function Ur(t,e){return t<e?-1:t>e?1:0}function Rr(t){if(!t)return !0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?jr(t[1],t[2],"=="):"!="===r?Kr(jr(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?jr(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(Rr))):"all"===r?["all"].concat(t.slice(1).map(Rr)):"none"===r?["all"].concat(t.slice(1).map(Rr).map(Kr)):"in"===r?qr(t[1],t.slice(2)):"!in"===r?Kr(qr(t[1],t.slice(2))):"has"===r?Nr(t[1]):"!has"!==r||Kr(Nr(t[1]))}function jr(t,e,r){switch(t){case"$type":return ["filter-type-"+r,e];case"$id":return ["filter-id-"+r,e];default:return ["filter-"+r,t,e]}}function qr(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((function(t){return typeof t!=typeof e[0]}))?["filter-in-large",t,["literal",e.sort(Ur)]]:["filter-in-small",t,["literal",e]]}}function Nr(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function Kr(t){return ["!",t]}function Zr(t){return Or(Pt(t.value))?Vr(Bt({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value;var n=e.key;if("array"!==dr(r))return [new It(n,r,"array expected, "+dr(r)+" found")];var i=e.styleSpec;var a;var o=[];if(r.length<1)return [new It(n,r,"filter array must have at least 1 element")];o=o.concat(Fr({key:n+"[0]",value:r[0],valueSpec:i.filter_operator,style:e.style,styleSpec:e.styleSpec}));switch(Mt(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===Mt(r[1])&&o.push(new It(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&o.push(new It(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(a=dr(r[1]))&&o.push(new It(n+"[1]",r[1],"string expected, "+a+" found"));for(var s=2;s<r.length;s++)a=dr(r[s]),"$type"===Mt(r[1])?o=o.concat(Fr({key:n+"["+s+"]",value:r[s],valueSpec:i.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==a&&"number"!==a&&"boolean"!==a&&o.push(new It(n+"["+s+"]",r[s],"string, number, or boolean expected, "+a+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)o=o.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":a=dr(r[1]),2!==r.length?o.push(new It(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==a&&o.push(new It(n+"[1]",r[1],"string expected, "+a+" found"));}return o}(t)}function Xr(t,e){var r=t.key,n=t.style,i=t.styleSpec,a=t.value,o=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return [];var u=o.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return tn({key:r,value:a,valueSpec:i.transition,style:n,styleSpec:i});var l,p=t.valueSpec||s[o];if(!p)return [new It(r,a,'unknown property "'+o+'"')];if("string"===dr(a)&&hr(p)&&!p.tokens&&(l=/^{([^}]+)}$/.exec(a)))return [new It(r,a,'"'+o+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var c=[];return "symbol"===t.layerType&&("text-field"===o&&n&&!n.glyphs&&c.push(new It(r,a,'use of "text-field" requires a style "glyphs" property')),"text-font"===o&&mr(Pt(a))&&"identity"===Mt(a.type)&&c.push(new It(r,a,'"text-font" does not support identity functions'))),c.concat(tn({key:t.key,value:a,valueSpec:p,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:o}))}function Gr(t){return Xr(t,"paint")}function Jr(t){return Xr(t,"layout")}function Hr(t){var e=[],r=t.value,n=t.key,i=t.style,a=t.styleSpec;r.type||r.ref||e.push(new It(n,r,'either "type" or "ref" is required'));var o,s=Mt(r.type),u=Mt(r.ref);if(r.id)for(var l=Mt(r.id),p=0;p<t.arrayIndex;p++){var c=i.layers[p];Mt(c.id)===l&&e.push(new It(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+c.id.__line__));}if("ref"in r)["type","source","source-layer","filter","layout"].forEach((function(t){t in r&&e.push(new It(n,r[t],'"'+t+'" is prohibited for ref layers'));})),i.layers.forEach((function(t){Mt(t.id)===u&&(o=t);})),o?o.ref?e.push(new It(n,r.ref,"ref cannot reference another ref layer")):s=Mt(o.type):e.push(new It(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var h=i.sources&&i.sources[r.source],f=h&&Mt(h.type);h?"vector"===f&&"raster"===s?e.push(new It(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new It(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new It(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&h.lineMetrics||e.push(new It(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new It(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new It(n,r.source,'source "'+r.source+'" not found'));}else e.push(new It(n,r,'missing required property "source"'));return e=e.concat(Er({key:n,value:r,valueSpec:a.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return []},type:function(){return tn({key:n+".type",value:r.type,valueSpec:a.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:Zr,layout:function(t){return Er({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Jr(Bt({layerType:s},t))}}})},paint:function(t){return Er({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Gr(Bt({layerType:s},t))}}})}}}))}function Yr(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new It(r,e,'"type" is required')];var a,o=Mt(e.type);switch(o){case"vector":case"raster":case"raster-dem":return a=Er({key:r,value:e,valueSpec:n["source_"+o.replace("-","_")],style:t.style,styleSpec:n});case"geojson":if(a=Er({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n}),e.cluster)for(var s in e.clusterProperties){var u=e.clusterProperties[s],l=u[0],p=u[1],c="string"==typeof l?[l,["accumulated"],["get",s]]:l;a.push.apply(a,Vr({key:r+"."+s+".map",value:p,expressionContext:"cluster-map"})),a.push.apply(a,Vr({key:r+"."+s+".reduce",value:c,expressionContext:"cluster-reduce"}));}return a;case"video":return Er({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Er({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new It(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return Fr({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function $r(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,a=[],o=dr(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new It("light",e,"object expected, "+o+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);a=u&&n[u[1]]&&n[u[1]].transition?a.concat(tn({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r})):n[s]?a.concat(tn({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r})):a.concat([new It(s,e[s],'unknown property "'+s+'"')]);}return a}function Wr(t){var e=t.value,r=t.key,n=dr(e);return "string"!==n?[new It(r,e,"string expected, "+n+" found")]:[]}var Qr={"*":function(){return []},array:Mr,boolean:function(t){var e=t.value,r=t.key,n=dr(e);return "boolean"!==n?[new It(r,e,"boolean expected, "+n+" found")]:[]},number:Pr,color:function(t){var e=t.key,r=t.value,n=dr(r);return "string"!==n?[new It(e,r,"color expected, "+n+" found")]:null===Jt(r)?[new It(e,r,'color expected, "'+r+'" found')]:[]},constants:Ct,enum:Fr,filter:Zr,function:Tr,layer:Hr,object:Er,source:Yr,light:$r,string:Wr,formatted:function(t){return 0===Wr(t).length?[]:Vr(t)}};function tn(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&mr(Mt(e))?Tr(t):r.expression&&kr(Pt(e))?Vr(t):r.type&&Qr[r.type]?Qr[r.type](t):Er(Bt({},t,{valueSpec:r.type?n[r.type]:r}))}function en(t){var e=t.value,r=t.key,n=Wr(t);return n.length?n:(-1===e.indexOf("{fontstack}")&&n.push(new It(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new It(r,e,'"glyphs" url must include a "{range}" token')),n)}function rn(t,e){e=e||zt;var r=[];return r=r.concat(tn({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:en,"*":function(){return []}}})),t.constants&&(r=r.concat(Ct({key:"constants",value:t.constants,style:t,styleSpec:e}))),nn(r)}function nn(t){return [].concat(t).sort((function(t,e){return t.line-e.line}))}function an(t){return function(){for(var e=[],r=arguments.length;r--;)e[r]=arguments[r];return nn(t.apply(this,e))}}rn.source=an(Yr),rn.light=an($r),rn.layer=an(Hr),rn.filter=an(Zr),rn.paintProperty=an(Gr),rn.layoutProperty=an(Jr);var on=rn,sn=on.light,un=on.paintProperty,ln=on.layoutProperty;function pn(t,e){var r=!1;if(e&&e.length)for(var n=0,i=e;n<i.length;n+=1){var a=i[n];t.fire(new kt(new Error(a.message))),r=!0;}return r}var cn=fn,hn=3;function fn(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],e=i[1],r=i[2],this.d=e+2*r;for(var a=0;a<this.d*this.d;a++){var o=i[hn+a],s=i[hn+a+1];n.push(o===s?null:i.subarray(o,s));}var u=i[hn+n.length],l=i[hn+n.length+1];this.keys=i.subarray(u,l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else{this.d=e+2*r;for(var p=0;p<this.d*this.d;p++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var c=r/e*t;this.min=-c,this.max=t+c;}fn.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},fn.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},fn.prototype._insertCell=function(t,e,r,n,i,a){this.cells[i].push(a);},fn.prototype.query=function(t,e,r,n,i){var a=this.min,o=this.max;if(t<=a&&e<=a&&o<=r&&o<=n&&!i)return Array.prototype.slice.call(this.keys);var s=[];return this._forEachCell(t,e,r,n,this._queryCell,s,{},i),s},fn.prototype._queryCell=function(t,e,r,n,i,a,o,s){var u=this.cells[i];if(null!==u)for(var l=this.keys,p=this.bboxes,c=0;c<u.length;c++){var h=u[c];if(void 0===o[h]){var f=4*h;(s?s(p[f+0],p[f+1],p[f+2],p[f+3]):t<=p[f+2]&&e<=p[f+3]&&r>=p[f+0]&&n>=p[f+1])?(o[h]=!0,a.push(l[h])):o[h]=!1;}}},fn.prototype._forEachCell=function(t,e,r,n,i,a,o,s){for(var u=this._convertToCellCoord(t),l=this._convertToCellCoord(e),p=this._convertToCellCoord(r),c=this._convertToCellCoord(n),h=u;h<=p;h++)for(var f=l;f<=c;f++){var y=this.d*f+h;if((!s||s(this._convertFromCellCoord(h),this._convertFromCellCoord(f),this._convertFromCellCoord(h+1),this._convertFromCellCoord(f+1)))&&i.call(this,t,e,r,n,y,a,o,s))return}},fn.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},fn.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},fn.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=hn+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var a=e,o=0;o<t.length;o++){var s=t[o];i[hn+o]=a,i.set(s,a),a+=s.length;}return i[hn+t.length]=a,i.set(this.keys,a),a+=this.keys.length,i[hn+t.length+1]=a,i.set(this.bboxes,a),a+=this.bboxes.length,i.buffer};var yn=self.ImageData,dn={};function mn(t,e,r){void 0===r&&(r={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),dn[t]={klass:e,omit:r.omit||[],shallow:r.shallow||[]};}for(var vn in mn("Object",Object),cn.serialize=function(t,e){var r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},cn.deserialize=function(t){return new cn(t.buffer)},mn("Grid",cn),mn("Color",Ht),mn("Error",Error),mn("StylePropertyFunction",Br),mn("StyleExpression",Ar,{omit:["_evaluator"]}),mn("ZoomDependentExpression",Ir),mn("ZoomConstantExpression",zr),mn("CompoundExpression",ce,{omit:["_evaluate"]}),ar)ar[vn]._classRegistryKey||mn("Expression_"+vn,ar[vn]);function gn(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(t instanceof ArrayBuffer)return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var r=t;return e&&e.push(r.buffer),r}if(t instanceof yn)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var n=[],i=0,a=t;i<a.length;i+=1){var o=a[i];n.push(gn(o,e));}return n}if("object"==typeof t){var s=t.constructor,u=s._classRegistryKey;if(!u)throw new Error("can't serialize object of unregistered class");var l=s.serialize?s.serialize(t,e):{};if(!s.serialize){for(var p in t)if(t.hasOwnProperty(p)&&!(dn[u].omit.indexOf(p)>=0)){var c=t[p];l[p]=dn[u].shallow.indexOf(p)>=0?c:gn(c,e);}t instanceof Error&&(l.message=t.message);}if(l.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==u&&(l.$name=u),l}throw new Error("can't serialize object of type "+typeof t)}function xn(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||t instanceof ArrayBuffer||ArrayBuffer.isView(t)||t instanceof yn)return t;if(Array.isArray(t))return t.map(xn);if("object"==typeof t){var e=t.$name||"Object",r=dn[e].klass;if(!r)throw new Error("can't deserialize unregistered class "+e);if(r.deserialize)return r.deserialize(t);for(var n=Object.create(r.prototype),i=0,a=Object.keys(t);i<a.length;i+=1){var o=a[i];if("$name"!==o){var s=t[o];n[o]=dn[e].shallow.indexOf(o)>=0?s:xn(s);}}return n}throw new Error("can't deserialize object of type "+typeof t)}var bn=function(){this.first=!0;};bn.prototype.update=function(t,e){var r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))};var _n={"Latin-1 Supplement":function(t){return t>=128&&t<=255},Arabic:function(t){return t>=1536&&t<=1791},"Arabic Supplement":function(t){return t>=1872&&t<=1919},"Arabic Extended-A":function(t){return t>=2208&&t<=2303},"Hangul Jamo":function(t){return t>=4352&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return t>=5120&&t<=5759},Khmer:function(t){return t>=6016&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return t>=6320&&t<=6399},"General Punctuation":function(t){return t>=8192&&t<=8303},"Letterlike Symbols":function(t){return t>=8448&&t<=8527},"Number Forms":function(t){return t>=8528&&t<=8591},"Miscellaneous Technical":function(t){return t>=8960&&t<=9215},"Control Pictures":function(t){return t>=9216&&t<=9279},"Optical Character Recognition":function(t){return t>=9280&&t<=9311},"Enclosed Alphanumerics":function(t){return t>=9312&&t<=9471},"Geometric Shapes":function(t){return t>=9632&&t<=9727},"Miscellaneous Symbols":function(t){return t>=9728&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return t>=11008&&t<=11263},"CJK Radicals Supplement":function(t){return t>=11904&&t<=12031},"Kangxi Radicals":function(t){return t>=12032&&t<=12255},"Ideographic Description Characters":function(t){return t>=12272&&t<=12287},"CJK Symbols and Punctuation":function(t){return t>=12288&&t<=12351},Hiragana:function(t){return t>=12352&&t<=12447},Katakana:function(t){return t>=12448&&t<=12543},Bopomofo:function(t){return t>=12544&&t<=12591},"Hangul Compatibility Jamo":function(t){return t>=12592&&t<=12687},Kanbun:function(t){return t>=12688&&t<=12703},"Bopomofo Extended":function(t){return t>=12704&&t<=12735},"CJK Strokes":function(t){return t>=12736&&t<=12783},"Katakana Phonetic Extensions":function(t){return t>=12784&&t<=12799},"Enclosed CJK Letters and Months":function(t){return t>=12800&&t<=13055},"CJK Compatibility":function(t){return t>=13056&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return t>=13312&&t<=19903},"Yijing Hexagram Symbols":function(t){return t>=19904&&t<=19967},"CJK Unified Ideographs":function(t){return t>=19968&&t<=40959},"Yi Syllables":function(t){return t>=40960&&t<=42127},"Yi Radicals":function(t){return t>=42128&&t<=42191},"Hangul Jamo Extended-A":function(t){return t>=43360&&t<=43391},"Hangul Syllables":function(t){return t>=44032&&t<=55215},"Hangul Jamo Extended-B":function(t){return t>=55216&&t<=55295},"Private Use Area":function(t){return t>=57344&&t<=63743},"CJK Compatibility Ideographs":function(t){return t>=63744&&t<=64255},"Arabic Presentation Forms-A":function(t){return t>=64336&&t<=65023},"Vertical Forms":function(t){return t>=65040&&t<=65055},"CJK Compatibility Forms":function(t){return t>=65072&&t<=65103},"Small Form Variants":function(t){return t>=65104&&t<=65135},"Arabic Presentation Forms-B":function(t){return t>=65136&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return t>=65280&&t<=65519}};function wn(t){for(var e=0,r=t;e<r.length;e+=1){if(kn(r[e].charCodeAt(0)))return !0}return !1}function An(t){return !_n.Arabic(t)&&(!_n["Arabic Supplement"](t)&&(!_n["Arabic Extended-A"](t)&&(!_n["Arabic Presentation Forms-A"](t)&&!_n["Arabic Presentation Forms-B"](t))))}function kn(t){return 746===t||747===t||!(t<4352)&&(!!_n["Bopomofo Extended"](t)||(!!_n.Bopomofo(t)||(!(!_n["CJK Compatibility Forms"](t)||t>=65097&&t<=65103)||(!!_n["CJK Compatibility Ideographs"](t)||(!!_n["CJK Compatibility"](t)||(!!_n["CJK Radicals Supplement"](t)||(!!_n["CJK Strokes"](t)||(!(!_n["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||(!!_n["CJK Unified Ideographs Extension A"](t)||(!!_n["CJK Unified Ideographs"](t)||(!!_n["Enclosed CJK Letters and Months"](t)||(!!_n["Hangul Compatibility Jamo"](t)||(!!_n["Hangul Jamo Extended-A"](t)||(!!_n["Hangul Jamo Extended-B"](t)||(!!_n["Hangul Jamo"](t)||(!!_n["Hangul Syllables"](t)||(!!_n.Hiragana(t)||(!!_n["Ideographic Description Characters"](t)||(!!_n.Kanbun(t)||(!!_n["Kangxi Radicals"](t)||(!!_n["Katakana Phonetic Extensions"](t)||(!(!_n.Katakana(t)||12540===t)||(!(!_n["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||(!(!_n["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||(!!_n["Unified Canadian Aboriginal Syllabics"](t)||(!!_n["Unified Canadian Aboriginal Syllabics Extended"](t)||(!!_n["Vertical Forms"](t)||(!!_n["Yijing Hexagram Symbols"](t)||(!!_n["Yi Syllables"](t)||!!_n["Yi Radicals"](t))))))))))))))))))))))))))))))}function Sn(t){return !(kn(t)||function(t){return !(!_n["Latin-1 Supplement"](t)||167!==t&&169!==t&&174!==t&&177!==t&&188!==t&&189!==t&&190!==t&&215!==t&&247!==t)||(!(!_n["General Punctuation"](t)||8214!==t&&8224!==t&&8225!==t&&8240!==t&&8241!==t&&8251!==t&&8252!==t&&8258!==t&&8263!==t&&8264!==t&&8265!==t&&8273!==t)||(!!_n["Letterlike Symbols"](t)||(!!_n["Number Forms"](t)||(!(!_n["Miscellaneous Technical"](t)||!(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215))||(!(!_n["Control Pictures"](t)||9251===t)||(!!_n["Optical Character Recognition"](t)||(!!_n["Enclosed Alphanumerics"](t)||(!!_n["Geometric Shapes"](t)||(!(!_n["Miscellaneous Symbols"](t)||t>=9754&&t<=9759)||(!(!_n["Miscellaneous Symbols and Arrows"](t)||!(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243))||(!!_n["CJK Symbols and Punctuation"](t)||(!!_n.Katakana(t)||(!!_n["Private Use Area"](t)||(!!_n["CJK Compatibility Forms"](t)||(!!_n["Small Form Variants"](t)||(!!_n["Halfwidth and Fullwidth Forms"](t)||(8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)))))))))))))))))}(t))}function zn(t,e){return !(!e&&(t>=1424&&t<=2303||_n["Arabic Presentation Forms-A"](t)||_n["Arabic Presentation Forms-B"](t)))&&!(t>=2304&&t<=3583||t>=3840&&t<=4255||_n.Khmer(t))}var In,Cn=!1,Bn=null,En=!1,Mn=new St,Pn={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return En||null!=Pn.applyArabicShaping}},Tn=function(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new bn,this.transition={});};Tn.prototype.isSupportedScript=function(t){return function(t,e){for(var r=0,n=t;r<n.length;r+=1){if(!zn(n[r].charCodeAt(0),e))return !1}return !0}(t,Pn.isLoaded())},Tn.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},Tn.prototype.getCrossfadeParameters=function(){var t=this.zoom,e=t-Math.floor(t),r=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*r}:{fromScale:.5,toScale:1,t:1-(1-r)*e}};var Vn=function(t,e){this.property=t,this.value=e,this.expression=function(t,e){if(mr(t))return new Br(t,e);if(kr(t)){var r=Cr(t,e);if("error"===r.result)throw new Error(r.value.map((function(t){return t.key+": "+t.message})).join(", "));return r.value}var n=t;return "string"==typeof t&&"color"===e.type&&(n=Ht.parse(t)),{kind:"constant",evaluate:function(){return n}}}(void 0===e?t.specification.default:e,t.specification);};Vn.prototype.isDataDriven=function(){return "source"===this.expression.kind||"composite"===this.expression.kind},Vn.prototype.possiblyEvaluate=function(t){return this.property.possiblyEvaluate(this,t)};var Fn=function(t){this.property=t,this.value=new Vn(t,void 0);};Fn.prototype.transitioned=function(t,e){return new Ln(this.property,this.value,e,c({},t.transition,this.transition),t.now)},Fn.prototype.untransitioned=function(){return new Ln(this.property,this.value,null,{},0)};var On=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);};On.prototype.getValue=function(t){return b(this._values[t].value.value)},On.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Fn(this._values[t].property)),this._values[t].value=new Vn(this._values[t].property,null===e?void 0:b(e));},On.prototype.getTransition=function(t){return b(this._values[t].transition)},On.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Fn(this._values[t].property)),this._values[t].transition=b(e)||void 0;},On.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);var a=this.getTransition(n);void 0!==a&&(t[n+"-transition"]=a);}return t},On.prototype.transitioned=function(t,e){for(var r=new Dn(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].transitioned(t,e._values[a]);}return r},On.prototype.untransitioned=function(){for(var t=new Dn(this._properties),e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e];t._values[n]=this._values[n].untransitioned();}return t};var Ln=function(t,e,r,n,i){this.property=t,this.value=e,this.begin=i+n.delay||0,this.end=this.begin+n.duration||0,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);};Ln.prototype.possiblyEvaluate=function(t){var e=t.now||0,r=this.value.possiblyEvaluate(t),n=this.prior;if(n){if(e>this.end)return this.prior=null,r;if(this.value.isDataDriven())return this.prior=null,r;if(e<this.begin)return n.possiblyEvaluate(t);var i=(e-this.begin)/(this.end-this.begin);return this.property.interpolate(n.possiblyEvaluate(t),r,function(t){if(t<=0)return 0;if(t>=1)return 1;var e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}(i))}return r};var Dn=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);};Dn.prototype.possiblyEvaluate=function(t){for(var e=new jn(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e},Dn.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1){var r=e[t];if(this._values[r].prior)return !0}return !1};var Un=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);};Un.prototype.getValue=function(t){return b(this._values[t].value)},Un.prototype.setValue=function(t,e){this._values[t]=new Vn(this._values[t].property,null===e?void 0:b(e));},Un.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);}return t},Un.prototype.possiblyEvaluate=function(t){for(var e=new jn(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e};var Rn=function(t,e,r){this.property=t,this.value=e,this.parameters=r;};Rn.prototype.isConstant=function(){return "constant"===this.value.kind},Rn.prototype.constantOr=function(t){return "constant"===this.value.kind?this.value.value:t},Rn.prototype.evaluate=function(t,e){return this.property.evaluate(this.value,this.parameters,t,e)};var jn=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);};jn.prototype.get=function(t){return this._values[t]};var qn=function(t){this.specification=t;};qn.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},qn.prototype.interpolate=function(t,e,r){var n=_e[this.specification.type];return n?n(t,e,r):t};var Nn=function(t,e){this.specification=t,this.overrides=e;};Nn.prototype.possiblyEvaluate=function(t,e){return "constant"===t.expression.kind||"camera"===t.expression.kind?new Rn(this,{kind:"constant",value:t.expression.evaluate(e)},e):new Rn(this,t.expression,e)},Nn.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new Rn(this,{kind:"constant",value:void 0},t.parameters);var n=_e[this.specification.type];return n?new Rn(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t},Nn.prototype.evaluate=function(t,e,r,n){return "constant"===t.kind?t.value:t.evaluate(e,r,n)};var Kn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(t,e){if(void 0===t.value)return new Rn(this,{kind:"constant",value:void 0},e);if("constant"===t.expression.kind){var r=t.expression.evaluate(e),n=this._calculate(r,r,r,e);return new Rn(this,{kind:"constant",value:n},e)}if("camera"===t.expression.kind){var i=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e);return new Rn(this,{kind:"constant",value:i},e)}return new Rn(this,t.expression,e)},e.prototype.evaluate=function(t,e,r,n){if("source"===t.kind){var i=t.evaluate(e,r,n);return this._calculate(i,i,i,e)}return "composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},r,n),t.evaluate({zoom:Math.floor(e.zoom)},r,n),t.evaluate({zoom:Math.floor(e.zoom)+1},r,n),e):t.value},e.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},e.prototype.interpolate=function(t){return t},e}(Nn),Zn=function(t){this.specification=t;};Zn.prototype.possiblyEvaluate=function(t,e){if(void 0!==t.value){if("constant"===t.expression.kind){var r=t.expression.evaluate(e);return this._calculate(r,r,r,e)}return this._calculate(t.expression.evaluate(new Tn(Math.floor(e.zoom-1),e)),t.expression.evaluate(new Tn(Math.floor(e.zoom),e)),t.expression.evaluate(new Tn(Math.floor(e.zoom+1),e)),e)}},Zn.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},Zn.prototype.interpolate=function(t){return t};var Xn=function(t){this.specification=t;};Xn.prototype.possiblyEvaluate=function(t,e){return !!t.expression.evaluate(e)},Xn.prototype.interpolate=function(){return !1};var Gn=function(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[],t){var r=t[e];r.specification.overridable&&this.overridableProperties.push(e);var n=this.defaultPropertyValues[e]=new Vn(r,void 0),i=this.defaultTransitionablePropertyValues[e]=new Fn(r);this.defaultTransitioningPropertyValues[e]=i.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=n.possiblyEvaluate({});}};mn("DataDrivenProperty",Nn),mn("DataConstantProperty",qn),mn("CrossFadedDataDrivenProperty",Kn),mn("CrossFadedProperty",Zn),mn("ColorRampProperty",Xn);var Jn=function(t){function e(e,r){if(t.call(this),this.id=e.id,this.type=e.type,this._featureFilter=function(){return !0},"custom"!==e.type&&(e=e,this.metadata=e.metadata,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,"background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),r.layout&&(this._unevaluatedLayout=new Un(r.layout)),r.paint)){for(var n in this._transitionablePaint=new On(r.paint),e.paint)this.setPaintProperty(n,e.paint[n],{validate:!1});for(var i in e.layout)this.setLayoutProperty(i,e.layout[i],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned();}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCrossfadeParameters=function(){return this._crossfadeParameters},e.prototype.getLayoutProperty=function(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".layout."+t;if(this._validate(ln,n,t,e,r))return}"visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e;},e.prototype.getPaintProperty=function(t){return v(t,"-transition")?this._transitionablePaint.getTransition(t.slice(0,-"-transition".length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".paint."+t;if(this._validate(un,n,t,e,r))return !1}if(v(t,"-transition"))return this._transitionablePaint.setTransition(t.slice(0,-"-transition".length),e||void 0),!1;var i=this._transitionablePaint._values[t],a="cross-faded-data-driven"===i.property.specification["property-type"],o=i.value.isDataDriven(),s=i.value;this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t);var u=this._transitionablePaint._values[t].value;return u.isDataDriven()||o||a||this._handleOverridablePaintPropertyUpdate(t,s,u)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){},e.prototype._handleOverridablePaintPropertyUpdate=function(t,e,r){return !1},e.prototype.isHidden=function(t){return !!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility)},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t)),this.paint=this._transitioningPaint.possiblyEvaluate(t);},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),x(t,(function(t,e){return !(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)}))},e.prototype._validate=function(t,e,r,n,i){return void 0===i&&(i={}),(!i||!1!==i.validate)&&pn(this,t.call(on,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:zt,style:{glyphs:!0,sprite:!0}}))},e.prototype.is3D=function(){return !1},e.prototype.isTileClipped=function(){return !1},e.prototype.hasOffscreenPass=function(){return !1},e.prototype.resize=function(){},e.prototype.isStateDependent=function(){for(var t in this.paint._values){var e=this.paint.get(t);if(e instanceof Rn&&hr(e.property.specification)&&(("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent))return !0}return !1},e}(St),Hn={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},Yn=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;},$n=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0);};function Wn(t,e){void 0===e&&(e=1);var r=0,n=0;return {members:t.map((function(t){var i,a=(i=t.type,Hn[i].BYTES_PER_ELEMENT),o=r=Qn(r,Math.max(e,a)),s=t.components||1;return n=Math.max(n,a),r+=a*s,{name:t.name,type:t.type,components:s,offset:o}})),size:Qn(r,Math.max(n,e)),alignment:e}}function Qn(t,e){return Math.ceil(t/e)*e}$n.serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},$n.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},$n.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());},$n.prototype.clear=function(){this.length=0;},$n.prototype.resize=function(t){this.reserve(t),this.length=t;},$n.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}},$n.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var ti=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t},e}($n);ti.prototype.bytesPerElement=4,mn("StructArrayLayout2i4",ti);var ei=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.int16[a+0]=e,this.int16[a+1]=r,this.int16[a+2]=n,this.int16[a+3]=i,t},e}($n);ei.prototype.bytesPerElement=8,mn("StructArrayLayout4i8",ei);var ri=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}($n);ri.prototype.bytesPerElement=12,mn("StructArrayLayout2i4i12",ri);var ni=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=4*t,u=8*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.uint8[u+4]=n,this.uint8[u+5]=i,this.uint8[u+6]=a,this.uint8[u+7]=o,t},e}($n);ni.prototype.bytesPerElement=8,mn("StructArrayLayout2i4ub8",ni);var ii=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.uint16[l+0]=e,this.uint16[l+1]=r,this.uint16[l+2]=n,this.uint16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}($n);ii.prototype.bytesPerElement=16,mn("StructArrayLayout8ui16",ii);var ai=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}($n);ai.prototype.bytesPerElement=16,mn("StructArrayLayout4i4ui16",ai);var oi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t},e}($n);oi.prototype.bytesPerElement=12,mn("StructArrayLayout3f12",oi);var si=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint32[r+0]=e,t},e}($n);si.prototype.bytesPerElement=4,mn("StructArrayLayout1ul4",si);var ui=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p){var c=this.length;return this.resize(c+1),this.emplace(c,t,e,r,n,i,a,o,s,u,l,p)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c){var h=12*t,f=6*t;return this.int16[h+0]=e,this.int16[h+1]=r,this.int16[h+2]=n,this.int16[h+3]=i,this.int16[h+4]=a,this.int16[h+5]=o,this.uint32[f+3]=s,this.uint16[h+8]=u,this.uint16[h+9]=l,this.int16[h+10]=p,this.int16[h+11]=c,t},e}($n);ui.prototype.bytesPerElement=24,mn("StructArrayLayout6i1ul2ui2i24",ui);var li=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}($n);li.prototype.bytesPerElement=12,mn("StructArrayLayout2i2i2i12",li);var pi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=12*t,o=3*t;return this.uint8[a+0]=e,this.uint8[a+1]=r,this.float32[o+1]=n,this.float32[o+2]=i,t},e}($n);pi.prototype.bytesPerElement=12,mn("StructArrayLayout2ub2f12",pi);var ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d){var m=this.length;return this.resize(m+1),this.emplace(m,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m){var v=22*t,g=11*t,x=44*t;return this.int16[v+0]=e,this.int16[v+1]=r,this.uint16[v+2]=n,this.uint16[v+3]=i,this.uint32[g+2]=a,this.uint32[g+3]=o,this.uint32[g+4]=s,this.uint16[v+10]=u,this.uint16[v+11]=l,this.uint16[v+12]=p,this.float32[g+7]=c,this.float32[g+8]=h,this.uint8[x+36]=f,this.uint8[x+37]=y,this.uint8[x+38]=d,this.uint32[g+10]=m,t},e}($n);ci.prototype.bytesPerElement=44,mn("StructArrayLayout2i2ui3ul3ui2f3ub1ul44",ci);var hi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x){var b=this.length;return this.resize(b+1),this.emplace(b,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b){var _=24*t,w=12*t;return this.int16[_+0]=e,this.int16[_+1]=r,this.int16[_+2]=n,this.int16[_+3]=i,this.int16[_+4]=a,this.int16[_+5]=o,this.uint16[_+6]=s,this.uint16[_+7]=u,this.uint16[_+8]=l,this.uint16[_+9]=p,this.uint16[_+10]=c,this.uint16[_+11]=h,this.uint16[_+12]=f,this.uint16[_+13]=y,this.uint16[_+14]=d,this.uint16[_+15]=m,this.uint16[_+16]=v,this.uint32[w+9]=g,this.float32[w+10]=x,this.float32[w+11]=b,t},e}($n);hi.prototype.bytesPerElement=48,mn("StructArrayLayout6i11ui1ul2f48",hi);var fi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.float32[r+0]=e,t},e}($n);fi.prototype.bytesPerElement=4,mn("StructArrayLayout1f4",fi);var yi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t},e}($n);yi.prototype.bytesPerElement=6,mn("StructArrayLayout3i6",yi);var di=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=2*t,a=4*t;return this.uint32[i+0]=e,this.uint16[a+2]=r,this.uint16[a+3]=n,t},e}($n);di.prototype.bytesPerElement=8,mn("StructArrayLayout1ul2ui8",di);var mi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t},e}($n);mi.prototype.bytesPerElement=6,mn("StructArrayLayout3ui6",mi);var vi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t},e}($n);vi.prototype.bytesPerElement=4,mn("StructArrayLayout2ui4",vi);var gi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint16[r+0]=e,t},e}($n);gi.prototype.bytesPerElement=2,mn("StructArrayLayout1ui2",gi);var xi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t},e}($n);xi.prototype.bytesPerElement=8,mn("StructArrayLayout2f8",xi);var bi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,t},e}($n);bi.prototype.bytesPerElement=16,mn("StructArrayLayout4f16",bi);var _i=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},radius:{configurable:!0},signedDistanceFromAnchor:{configurable:!0},anchorPoint:{configurable:!0}};return r.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorPointX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorPointY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.x1.get=function(){return this._structArray.int16[this._pos2+2]},r.x1.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.y1.get=function(){return this._structArray.int16[this._pos2+3]},r.y1.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.x2.get=function(){return this._structArray.int16[this._pos2+4]},r.x2.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.y2.get=function(){return this._structArray.int16[this._pos2+5]},r.y2.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.radius.get=function(){return this._structArray.int16[this._pos2+10]},r.radius.set=function(t){this._structArray.int16[this._pos2+10]=t;},r.signedDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+11]},r.signedDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+11]=t;},r.anchorPoint.get=function(){return new i(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,r),e}(Yn);_i.prototype.size=24;var wi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new _i(this,t)},e}(ui);mn("CollisionBoxArray",wi);var Ai=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},placedOrientation:{configurable:!0},hidden:{configurable:!0},crossTileID:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.glyphStartIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},r.numGlyphs.set=function(t){this._structArray.uint16[this._pos2+3]=t;},r.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},r.vertexStartIndex.set=function(t){this._structArray.uint32[this._pos4+2]=t;},r.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.lineStartIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},r.lineLength.set=function(t){this._structArray.uint32[this._pos4+4]=t;},r.segment.get=function(){return this._structArray.uint16[this._pos2+10]},r.segment.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},r.lowerSize.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},r.upperSize.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},r.lineOffsetX.set=function(t){this._structArray.float32[this._pos4+7]=t;},r.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},r.lineOffsetY.set=function(t){this._structArray.float32[this._pos4+8]=t;},r.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},r.writingMode.set=function(t){this._structArray.uint8[this._pos1+36]=t;},r.placedOrientation.get=function(){return this._structArray.uint8[this._pos1+37]},r.placedOrientation.set=function(t){this._structArray.uint8[this._pos1+37]=t;},r.hidden.get=function(){return this._structArray.uint8[this._pos1+38]},r.hidden.set=function(t){this._structArray.uint8[this._pos1+38]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+10]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+10]=t;},Object.defineProperties(e.prototype,r),e}(Yn);Ai.prototype.size=44;var ki=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Ai(this,t)},e}(ci);mn("PlacedSymbolArray",ki);var Si=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},rightJustifiedTextSymbolIndex:{configurable:!0},centerJustifiedTextSymbolIndex:{configurable:!0},leftJustifiedTextSymbolIndex:{configurable:!0},verticalPlacedTextSymbolIndex:{configurable:!0},key:{configurable:!0},textBoxStartIndex:{configurable:!0},textBoxEndIndex:{configurable:!0},verticalTextBoxStartIndex:{configurable:!0},verticalTextBoxEndIndex:{configurable:!0},iconBoxStartIndex:{configurable:!0},iconBoxEndIndex:{configurable:!0},featureIndex:{configurable:!0},numHorizontalGlyphVertices:{configurable:!0},numVerticalGlyphVertices:{configurable:!0},numIconVertices:{configurable:!0},crossTileID:{configurable:!0},textBoxScale:{configurable:!0},radialTextOffset:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.rightJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+2]},r.rightJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.centerJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+3]},r.centerJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.leftJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+4]},r.leftJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.verticalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+5]},r.verticalPlacedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.key.get=function(){return this._structArray.uint16[this._pos2+6]},r.key.set=function(t){this._structArray.uint16[this._pos2+6]=t;},r.textBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+7]},r.textBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+7]=t;},r.textBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.textBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.verticalTextBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.verticalTextBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.verticalTextBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+10]},r.verticalTextBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.iconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+11]},r.iconBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.iconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+12]},r.iconBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.featureIndex.get=function(){return this._structArray.uint16[this._pos2+13]},r.featureIndex.set=function(t){this._structArray.uint16[this._pos2+13]=t;},r.numHorizontalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+14]},r.numHorizontalGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+14]=t;},r.numVerticalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+15]},r.numVerticalGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+15]=t;},r.numIconVertices.get=function(){return this._structArray.uint16[this._pos2+16]},r.numIconVertices.set=function(t){this._structArray.uint16[this._pos2+16]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+9]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+9]=t;},r.textBoxScale.get=function(){return this._structArray.float32[this._pos4+10]},r.textBoxScale.set=function(t){this._structArray.float32[this._pos4+10]=t;},r.radialTextOffset.get=function(){return this._structArray.float32[this._pos4+11]},r.radialTextOffset.set=function(t){this._structArray.float32[this._pos4+11]=t;},Object.defineProperties(e.prototype,r),e}(Yn);Si.prototype.size=48;var zi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Si(this,t)},e}(hi);mn("SymbolInstanceArray",zi);var Ii=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={offsetX:{configurable:!0}};return r.offsetX.get=function(){return this._structArray.float32[this._pos4+0]},r.offsetX.set=function(t){this._structArray.float32[this._pos4+0]=t;},Object.defineProperties(e.prototype,r),e}(Yn);Ii.prototype.size=4;var Ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getoffsetX=function(t){return this.float32[1*t+0]},e.prototype.get=function(t){return new Ii(this,t)},e}(fi);mn("GlyphOffsetArray",Ci);var Bi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={x:{configurable:!0},y:{configurable:!0},tileUnitDistanceFromAnchor:{configurable:!0}};return r.x.get=function(){return this._structArray.int16[this._pos2+0]},r.x.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.y.get=function(){return this._structArray.int16[this._pos2+1]},r.y.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.tileUnitDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+2]},r.tileUnitDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+2]=t;},Object.defineProperties(e.prototype,r),e}(Yn);Bi.prototype.size=6;var Ei=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getx=function(t){return this.int16[3*t+0]},e.prototype.gety=function(t){return this.int16[3*t+1]},e.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},e.prototype.get=function(t){return new Bi(this,t)},e}(yi);mn("SymbolLineVertexArray",Ei);var Mi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+0]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+3]=t;},Object.defineProperties(e.prototype,r),e}(Yn);Mi.prototype.size=8;var Pi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Mi(this,t)},e}(di);mn("FeatureIndexArray",Pi);var Ti=Wn([{name:"a_pos",components:2,type:"Int16"}],4).members,Vi=function(t){void 0===t&&(t=[]),this.segments=t;};function Fi(t,e){return 256*(t=l(Math.floor(t),0,255))+(e=l(Math.floor(e),0,255))}Vi.prototype.prepareSegment=function(t,e,r,n){var i=this.segments[this.segments.length-1];return t>Vi.MAX_VERTEX_ARRAY_LENGTH&&w("Max vertices per segment is "+Vi.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!i||i.vertexLength+t>Vi.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i},Vi.prototype.get=function(){return this.segments},Vi.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var r=e[t];for(var n in r.vaos)r.vaos[n].destroy();}},Vi.simpleSegment=function(t,e,r,n){return new Vi([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])},Vi.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,mn("SegmentVector",Vi);var Oi=function(){this.ids=[],this.positions=[],this.indexed=!1;};function Li(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}Oi.prototype.add=function(t,e,r,n){this.ids.push(t),this.positions.push(e,r,n);},Oi.prototype.getPositions=function(t){for(var e=0,r=this.ids.length-1;e<r;){var n=e+r>>1;this.ids[n]>=t?r=n:e=n+1;}for(var i=[];this.ids[e]===t;){var a=this.positions[3*e],o=this.positions[3*e+1],s=this.positions[3*e+2];i.push({index:a,start:o,end:s}),e++;}return i},Oi.serialize=function(t,e){var r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return function t(e,r,n,i){if(n>=i)return;var a=e[n+i>>1];var o=n-1;var s=i+1;for(;;){do{o++;}while(e[o]<a);do{s--;}while(e[s]>a);if(o>=s)break;Li(e,o,s),Li(r,3*o,3*s),Li(r,3*o+1,3*s+1),Li(r,3*o+2,3*s+2);}t(e,r,n,s);t(e,r,s+1,i);}(r,n,0,r.length-1),e.push(r.buffer,n.buffer),{ids:r,positions:n}},Oi.deserialize=function(t){var e=new Oi;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e},mn("FeaturePositionMap",Oi);var Di=function(t,e){this.gl=t.gl,this.location=e;},Ui=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1i(this.location,t));},e}(Di),Ri=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1f(this.location,t));},e}(Di),ji=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]||(this.current=t,this.gl.uniform2f(this.location,t[0],t[1]));},e}(Di),qi=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]||(this.current=t,this.gl.uniform3f(this.location,t[0],t[1],t[2]));},e}(Di),Ni=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]&&t[3]===this.current[3]||(this.current=t,this.gl.uniform4f(this.location,t[0],t[1],t[2],t[3]));},e}(Di),Ki=function(t){function e(e,r){t.call(this,e,r),this.current=Ht.transparent;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t.r===this.current.r&&t.g===this.current.g&&t.b===this.current.b&&t.a===this.current.a||(this.current=t,this.gl.uniform4f(this.location,t.r,t.g,t.b,t.a));},e}(Di),Zi=new Float32Array(16),Xi=function(t){function e(e,r){t.call(this,e,r),this.current=Zi;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t[12]!==this.current[12]||t[0]!==this.current[0])return this.current=t,void this.gl.uniformMatrix4fv(this.location,!1,t);for(var e=1;e<16;e++)if(t[e]!==this.current[e]){this.current=t,this.gl.uniformMatrix4fv(this.location,!1,t);break}},e}(Di);function Gi(t){return [Fi(255*t.r,255*t.g),Fi(255*t.b,255*t.a)]}var Ji=function(t,e,r){this.value=t,this.names=e,this.uniformNames=this.names.map((function(t){return "u_"+t})),this.type=r,this.maxValue=-1/0;};Ji.prototype.defines=function(){return this.names.map((function(t){return "#define HAS_UNIFORM_u_"+t}))},Ji.prototype.setConstantPatternPositions=function(){},Ji.prototype.populatePaintArray=function(){},Ji.prototype.updatePaintArray=function(){},Ji.prototype.upload=function(){},Ji.prototype.destroy=function(){},Ji.prototype.setUniforms=function(t,e,r,n){e.set(n.constantOr(this.value));},Ji.prototype.getBinding=function(t,e){return "color"===this.type?new Ki(t,e):new Ri(t,e)},Ji.serialize=function(t){var e=t.value,r=t.names,n=t.type;return {value:gn(e),names:r,type:n}},Ji.deserialize=function(t){var e=t.value,r=t.names,n=t.type;return new Ji(xn(e),r,n)};var Hi=function(t,e,r){this.value=t,this.names=e,this.uniformNames=this.names.map((function(t){return "u_"+t})),this.type=r,this.maxValue=-1/0,this.patternPositions={patternTo:null,patternFrom:null};};Hi.prototype.defines=function(){return this.names.map((function(t){return "#define HAS_UNIFORM_u_"+t}))},Hi.prototype.populatePaintArray=function(){},Hi.prototype.updatePaintArray=function(){},Hi.prototype.upload=function(){},Hi.prototype.destroy=function(){},Hi.prototype.setConstantPatternPositions=function(t,e){this.patternPositions.patternTo=t.tlbr,this.patternPositions.patternFrom=e.tlbr;},Hi.prototype.setUniforms=function(t,e,r,n,i){var a=this.patternPositions;"u_pattern_to"===i&&a.patternTo&&e.set(a.patternTo),"u_pattern_from"===i&&a.patternFrom&&e.set(a.patternFrom);},Hi.prototype.getBinding=function(t,e){return new Ni(t,e)};var Yi=function(t,e,r,n){this.expression=t,this.names=e,this.type=r,this.uniformNames=this.names.map((function(t){return "a_"+t})),this.maxValue=-1/0,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?2:1,offset:0}})),this.paintVertexArray=new n;};Yi.prototype.defines=function(){return []},Yi.prototype.setConstantPatternPositions=function(){},Yi.prototype.populatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=i.length;i.reserve(t);var o=this.expression.evaluate(new Tn(0),e,{},n);if("color"===this.type)for(var s=Gi(o),u=a;u<t;u++)i.emplaceBack(s[0],s[1]);else{for(var l=a;l<t;l++)i.emplaceBack(o);this.maxValue=Math.max(this.maxValue,o);}},Yi.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:0},r,n);if("color"===this.type)for(var o=Gi(a),s=t;s<e;s++)i.emplace(s,o[0],o[1]);else{for(var u=t;u<e;u++)i.emplace(u,a);this.maxValue=Math.max(this.maxValue,a);}},Yi.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Yi.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Yi.prototype.setUniforms=function(t,e){e.set(0);},Yi.prototype.getBinding=function(t,e){return new Ri(t,e)};var $i=function(t,e,r,n,i,a){this.expression=t,this.names=e,this.uniformNames=this.names.map((function(t){return "u_"+t+"_t"})),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=-1/0;var o=a;this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?4:2,offset:0}})),this.paintVertexArray=new o;};$i.prototype.defines=function(){return []},$i.prototype.setConstantPatternPositions=function(){},$i.prototype.populatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=i.length;i.reserve(t);var o=this.expression.evaluate(new Tn(this.zoom),e,{},n),s=this.expression.evaluate(new Tn(this.zoom+1),e,{},n);if("color"===this.type)for(var u=Gi(o),l=Gi(s),p=a;p<t;p++)i.emplaceBack(u[0],u[1],l[0],l[1]);else{for(var c=a;c<t;c++)i.emplaceBack(o,s);this.maxValue=Math.max(this.maxValue,o,s);}},$i.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:this.zoom},r,n),o=this.expression.evaluate({zoom:this.zoom+1},r,n);if("color"===this.type)for(var s=Gi(a),u=Gi(o),l=t;l<e;l++)i.emplace(l,s[0],s[1],u[0],u[1]);else{for(var p=t;p<e;p++)i.emplace(p,a,o);this.maxValue=Math.max(this.maxValue,a,o);}},$i.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},$i.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},$i.prototype.interpolationFactor=function(t){return this.useIntegerZoom?this.expression.interpolationFactor(Math.floor(t),this.zoom,this.zoom+1):this.expression.interpolationFactor(t,this.zoom,this.zoom+1)},$i.prototype.setUniforms=function(t,e,r){e.set(this.interpolationFactor(r.zoom));},$i.prototype.getBinding=function(t,e){return new Ri(t,e)};var Wi=function(t,e,r,n,i,a,o){this.expression=t,this.names=e,this.type=r,this.uniformNames=this.names.map((function(t){return "u_"+t+"_t"})),this.useIntegerZoom=n,this.zoom=i,this.maxValue=-1/0,this.layerId=o,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Uint16",components:4,offset:0}})),this.zoomInPaintVertexArray=new a,this.zoomOutPaintVertexArray=new a;};Wi.prototype.defines=function(){return []},Wi.prototype.setConstantPatternPositions=function(){},Wi.prototype.populatePaintArray=function(t,e,r){var n=this.zoomInPaintVertexArray,i=this.zoomOutPaintVertexArray,a=this.layerId,o=n.length;if(n.reserve(t),i.reserve(t),r&&e.patterns&&e.patterns[a]){var s=e.patterns[a],u=s.min,l=s.mid,p=s.max,c=r[u],h=r[l],f=r[p];if(!c||!h||!f)return;for(var y=o;y<t;y++)n.emplaceBack(h.tl[0],h.tl[1],h.br[0],h.br[1],c.tl[0],c.tl[1],c.br[0],c.br[1]),i.emplaceBack(h.tl[0],h.tl[1],h.br[0],h.br[1],f.tl[0],f.tl[1],f.br[0],f.br[1]);}},Wi.prototype.updatePaintArray=function(t,e,r,n,i){var a=this.zoomInPaintVertexArray,o=this.zoomOutPaintVertexArray,s=this.layerId;if(i&&r.patterns&&r.patterns[s]){var u=r.patterns[s],l=u.min,p=u.mid,c=u.max,h=i[l],f=i[p],y=i[c];if(!h||!f||!y)return;for(var d=t;d<e;d++)a.emplace(d,f.tl[0],f.tl[1],f.br[0],f.br[1],h.tl[0],h.tl[1],h.br[0],h.br[1]),o.emplace(d,f.tl[0],f.tl[1],f.br[0],f.br[1],y.tl[0],y.tl[1],y.br[0],y.br[1]);}},Wi.prototype.upload=function(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Wi.prototype.destroy=function(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy();},Wi.prototype.setUniforms=function(t,e){e.set(0);},Wi.prototype.getBinding=function(t,e){return new Ri(t,e)};var Qi=function(){this.binders={},this.cacheKey="",this._buffers=[],this._featureMap=new Oi,this._bufferOffset=0;};Qi.createDynamic=function(t,e,r){var n=new Qi,i=[];for(var a in t.paint._values)if(r(a)){var o=t.paint.get(a);if(o instanceof Rn&&hr(o.property.specification)){var s=ea(a,t.type),u=o.property.specification.type,l=o.property.useIntegerZoom;if("cross-faded"===o.property.specification["property-type"]||"cross-faded-data-driven"===o.property.specification["property-type"])if("constant"===o.value.kind)n.binders[a]=new Hi(o.value.value,s,u),i.push("/u_"+a);else{var p=ra(a,u,"source");n.binders[a]=new Wi(o.value,s,u,l,e,p,t.id),i.push("/a_"+a);}else if("constant"===o.value.kind)n.binders[a]=new Ji(o.value.value,s,u),i.push("/u_"+a);else if("source"===o.value.kind){var c=ra(a,u,"source");n.binders[a]=new Yi(o.value,s,u,c),i.push("/a_"+a);}else{var h=ra(a,u,"composite");n.binders[a]=new $i(o.value,s,u,l,e,h),i.push("/z_"+a);}}}return n.cacheKey=i.sort().join(""),n},Qi.prototype.populatePaintArrays=function(t,e,r,n,i){for(var a in this.binders){this.binders[a].populatePaintArray(t,e,n,i);}void 0!==e.id&&this._featureMap.add(+e.id,r,this._bufferOffset,t),this._bufferOffset=t;},Qi.prototype.setConstantPatternPositions=function(t,e){for(var r in this.binders){this.binders[r].setConstantPatternPositions(t,e);}},Qi.prototype.updatePaintArrays=function(t,e,r,n){var i=!1;for(var a in t)for(var o=0,s=this._featureMap.getPositions(+a);o<s.length;o+=1){var u=s[o],l=e.feature(u.index);for(var p in this.binders){var c=this.binders[p];if(!(c instanceof Ji||c instanceof Hi)&&!0===c.expression.isStateDependent){var h=r.paint.get(p);c.expression=h.value,c.updatePaintArray(u.start,u.end,l,t[a],n),i=!0;}}}return i},Qi.prototype.defines=function(){var t=[];for(var e in this.binders)t.push.apply(t,this.binders[e].defines());return t},Qi.prototype.getPaintVertexBuffers=function(){return this._buffers},Qi.prototype.getUniforms=function(t,e){var r=[];for(var n in this.binders)for(var i=this.binders[n],a=0,o=i.uniformNames;a<o.length;a+=1){var s=o[a];if(e[s]){var u=i.getBinding(t,e[s]);r.push({name:s,property:n,binding:u});}}return r},Qi.prototype.setUniforms=function(t,e,r,n){for(var i=0,a=e;i<a.length;i+=1){var o=a[i],s=o.name,u=o.property,l=o.binding;this.binders[u].setUniforms(t,l,n,r.get(u),s);}},Qi.prototype.updatePatternPaintBuffers=function(t){var e=[];for(var r in this.binders){var n=this.binders[r];if(n instanceof Wi){var i=2===t.fromScale?n.zoomInPaintVertexBuffer:n.zoomOutPaintVertexBuffer;i&&e.push(i);}else(n instanceof Yi||n instanceof $i)&&n.paintVertexBuffer&&e.push(n.paintVertexBuffer);}this._buffers=e;},Qi.prototype.upload=function(t){for(var e in this.binders)this.binders[e].upload(t);var r=[];for(var n in this.binders){var i=this.binders[n];(i instanceof Yi||i instanceof $i)&&i.paintVertexBuffer&&r.push(i.paintVertexBuffer);}this._buffers=r;},Qi.prototype.destroy=function(){for(var t in this.binders)this.binders[t].destroy();};var ta=function(t,e,r,n){void 0===n&&(n=function(){return !0}),this.programConfigurations={};for(var i=0,a=e;i<a.length;i+=1){var o=a[i];this.programConfigurations[o.id]=Qi.createDynamic(o,r,n),this.programConfigurations[o.id].layoutAttributes=t;}this.needsUpload=!1;};function ea(t,e){return {"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from"],"fill-pattern":["pattern_to","pattern_from"],"fill-extrusion-pattern":["pattern_to","pattern_from"]}[t]||[t.replace(e+"-","").replace(/-/g,"_")]}function ra(t,e,r){var n={color:{source:xi,composite:bi},number:{source:fi,composite:xi}},i=function(t){return {"line-pattern":{source:ii,composite:ii},"fill-pattern":{source:ii,composite:ii},"fill-extrusion-pattern":{source:ii,composite:ii}}[t]}(t);return i&&i[r]||n[e][r]}ta.prototype.populatePaintArrays=function(t,e,r,n,i){for(var a in this.programConfigurations)this.programConfigurations[a].populatePaintArrays(t,e,r,n,i);this.needsUpload=!0;},ta.prototype.updatePaintArrays=function(t,e,r,n){for(var i=0,a=r;i<a.length;i+=1){var o=a[i];this.needsUpload=this.programConfigurations[o.id].updatePaintArrays(t,e,o,n)||this.needsUpload;}},ta.prototype.get=function(t){return this.programConfigurations[t]},ta.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}},ta.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy();},mn("ConstantBinder",Ji),mn("CrossFadedConstantBinder",Hi),mn("SourceExpressionBinder",Yi),mn("CrossFadedCompositeBinder",Wi),mn("CompositeExpressionBinder",$i),mn("ProgramConfiguration",Qi,{omit:["_buffers"]}),mn("ProgramConfigurationSet",ta);var na=8192;var ia,aa=(ia=15,{min:-1*Math.pow(2,ia-1),max:Math.pow(2,ia-1)-1});function oa(t){for(var e=na/t.extent,r=t.loadGeometry(),n=0;n<r.length;n++)for(var i=r[n],a=0;a<i.length;a++){var o=i[a];o.x=Math.round(o.x*e),o.y=Math.round(o.y*e),(o.x<aa.min||o.x>aa.max||o.y<aa.min||o.y>aa.max)&&(w("Geometry exceeds allowed extent, reduce your vector tile buffer size"),o.x=l(o.x,aa.min,aa.max),o.y=l(o.y,aa.min,aa.max));}return r}function sa(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}var ua=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new ti,this.indexArray=new mi,this.segments=new Vi,this.programConfigurations=new ta(Ti,t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function la(t,e){for(var r=0;r<t.length;r++)if(ga(e,t[r]))return !0;for(var n=0;n<e.length;n++)if(ga(t,e[n]))return !0;return !!fa(t,e)}function pa(t,e,r){return !!ga(t,e)||!!da(e,t,r)}function ca(t,e){if(1===t.length)return va(e,t[0]);for(var r=0;r<e.length;r++)for(var n=e[r],i=0;i<n.length;i++)if(ga(t,n[i]))return !0;for(var a=0;a<t.length;a++)if(va(e,t[a]))return !0;for(var o=0;o<e.length;o++)if(fa(t,e[o]))return !0;return !1}function ha(t,e,r){if(t.length>1){if(fa(t,e))return !0;for(var n=0;n<e.length;n++)if(da(e[n],t,r))return !0}for(var i=0;i<t.length;i++)if(da(t[i],e,r))return !0;return !1}function fa(t,e){if(0===t.length||0===e.length)return !1;for(var r=0;r<t.length-1;r++)for(var n=t[r],i=t[r+1],a=0;a<e.length-1;a++){if(ya(n,i,e[a],e[a+1]))return !0}return !1}function ya(t,e,r,n){return A(t,r,n)!==A(e,r,n)&&A(t,e,r)!==A(t,e,n)}function da(t,e,r){var n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(var i=1;i<e.length;i++){if(ma(t,e[i-1],e[i])<n)return !0}return !1}function ma(t,e,r){var n=e.distSqr(r);if(0===n)return t.distSqr(e);var i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return i<0?t.distSqr(e):i>1?t.distSqr(r):t.distSqr(r.sub(e)._mult(i)._add(e))}function va(t,e){for(var r,n,i,a=!1,o=0;o<t.length;o++)for(var s=0,u=(r=t[o]).length-1;s<r.length;u=s++)n=r[s],i=r[u],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(a=!a);return a}function ga(t,e){for(var r=!1,n=0,i=t.length-1;n<t.length;i=n++){var a=t[n],o=t[i];a.y>e.y!=o.y>e.y&&e.x<(o.x-a.x)*(e.y-a.y)/(o.y-a.y)+a.x&&(r=!r);}return r}function xa(t,e,r){var n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;var a=A(t,e,r[0]);return a!==A(t,e,r[1])||a!==A(t,e,r[2])||a!==A(t,e,r[3])}function ba(t,e,r){var n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).binders[t].maxValue}function _a(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function wa(t,e,r,n,a){if(!e[0]&&!e[1])return t;var o=i.convert(e)._mult(a);"viewport"===r&&o._rotate(-n);for(var s=[],u=0;u<t.length;u++){var l=t[u];s.push(l.sub(o));}return s}ua.prototype.populate=function(t,e){var r=this.layers[0],n=[],i=null;"circle"===r.type&&(i=r.layout.get("circle-sort-key"));for(var a=0,o=t;a<o.length;a+=1){var s=o[a],u=s.feature,l=s.index,p=s.sourceLayerIndex;if(this.layers[0]._featureFilter(new Tn(this.zoom),u)){var c=oa(u),h=i?i.evaluate(u,{}):void 0,f={id:u.id,properties:u.properties,type:u.type,sourceLayerIndex:p,index:l,geometry:c,patterns:{},sortKey:h};n.push(f);}}i&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var y=0,d=n;y<d.length;y+=1){var m=d[y],v=m,g=v.geometry,x=v.index,b=v.sourceLayerIndex,_=t[x].feature;this.addFeature(m,g,x),e.featureIndex.insert(_,g,x,b,this.index);}},ua.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},ua.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},ua.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},ua.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Ti),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},ua.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},ua.prototype.addFeature=function(t,e,r){for(var n=0,i=e;n<i.length;n+=1)for(var a=0,o=i[n];a<o.length;a+=1){var s=o[a],u=s.x,l=s.y;if(!(u<0||u>=na||l<0||l>=na)){var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey),c=p.vertexLength;sa(this.layoutVertexArray,u,l,-1,-1),sa(this.layoutVertexArray,u,l,1,-1),sa(this.layoutVertexArray,u,l,1,1),sa(this.layoutVertexArray,u,l,-1,1),this.indexArray.emplaceBack(c,c+1,c+2),this.indexArray.emplaceBack(c,c+3,c+2),p.vertexLength+=4,p.primitiveLength+=2;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{});},mn("CircleBucket",ua,{omit:["layers"]});var Aa=new Gn({"circle-sort-key":new Nn(zt.layout_circle["circle-sort-key"])}),ka={paint:new Gn({"circle-radius":new Nn(zt.paint_circle["circle-radius"]),"circle-color":new Nn(zt.paint_circle["circle-color"]),"circle-blur":new Nn(zt.paint_circle["circle-blur"]),"circle-opacity":new Nn(zt.paint_circle["circle-opacity"]),"circle-translate":new qn(zt.paint_circle["circle-translate"]),"circle-translate-anchor":new qn(zt.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new qn(zt.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new qn(zt.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new Nn(zt.paint_circle["circle-stroke-width"]),"circle-stroke-color":new Nn(zt.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new Nn(zt.paint_circle["circle-stroke-opacity"])}),layout:Aa},Sa="undefined"!=typeof Float32Array?Float32Array:Array;Math.hypot||(Math.hypot=function(){for(var t=arguments,e=0,r=arguments.length;r--;)e+=t[r]*t[r];return Math.sqrt(e)});var za,Ia;za=new Sa(3),Sa!=Float32Array&&(za[0]=0,za[1]=0,za[2]=0),Ia=za;function Ca(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*a+r[12]*o,t[1]=r[1]*n+r[5]*i+r[9]*a+r[13]*o,t[2]=r[2]*n+r[6]*i+r[10]*a+r[14]*o,t[3]=r[3]*n+r[7]*i+r[11]*a+r[15]*o,t}!function(){var t=function(){var t=new Sa(4);return Sa!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t}();}();var Ba=function(t){function e(e){t.call(this,e,ka);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new ua(t)},e.prototype.queryRadius=function(t){var e=t;return ba("circle-radius",this,e)+ba("circle-stroke-width",this,e)+_a(this.paint.get("circle-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o,s){for(var u=wa(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a.angle,o),l=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r),p="map"===this.paint.get("circle-pitch-alignment"),c=p?u:function(t,e){return t.map((function(t){return Ea(t,e)}))}(u,s),h=p?l*o:l,f=0,y=n;f<y.length;f+=1)for(var d=0,m=y[f];d<m.length;d+=1){var v=m[d],g=p?v:Ea(v,s),x=h,b=Ca([],[v.x,v.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?x*=b[3]/a.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(x*=a.cameraToCenterDistance/b[3]),pa(c,g,x))return !0}return !1},e}(Jn);function Ea(t,e){var r=Ca([],[t.x,t.y,0,1],e);return new i(r[0]/r[3],r[1]/r[3])}var Ma=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(ua);function Pa(t,e,r,n){var i=e.width,a=e.height;if(n){if(n instanceof Uint8ClampedArray)n=new Uint8Array(n.buffer);else if(n.length!==i*a*r)throw new RangeError("mismatched image size")}else n=new Uint8Array(i*a*r);return t.width=i,t.height=a,t.data=n,t}function Ta(t,e,r){var n=e.width,i=e.height;if(n!==t.width||i!==t.height){var a=Pa({},{width:n,height:i},r);Va(t,a,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=a.data;}}function Va(t,e,r,n,i,a){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");for(var o=t.data,s=e.data,u=0;u<i.height;u++)for(var l=((r.y+u)*t.width+r.x)*a,p=((n.y+u)*e.width+n.x)*a,c=0;c<i.width*a;c++)s[p+c]=o[l+c];return e}mn("HeatmapBucket",Ma,{omit:["layers"]});var Fa=function(t,e){Pa(this,t,1,e);};Fa.prototype.resize=function(t){Ta(this,t,1);},Fa.prototype.clone=function(){return new Fa({width:this.width,height:this.height},new Uint8Array(this.data))},Fa.copy=function(t,e,r,n,i){Va(t,e,r,n,i,1);};var Oa=function(t,e){Pa(this,t,4,e);};Oa.prototype.resize=function(t){Ta(this,t,4);},Oa.prototype.replace=function(t,e){e?this.data.set(t):t instanceof Uint8ClampedArray?this.data=new Uint8Array(t.buffer):this.data=t;},Oa.prototype.clone=function(){return new Oa({width:this.width,height:this.height},new Uint8Array(this.data))},Oa.copy=function(t,e,r,n,i){Va(t,e,r,n,i,4);},mn("AlphaImage",Fa),mn("RGBAImage",Oa);var La={paint:new Gn({"heatmap-radius":new Nn(zt.paint_heatmap["heatmap-radius"]),"heatmap-weight":new Nn(zt.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new qn(zt.paint_heatmap["heatmap-intensity"]),"heatmap-color":new Xn(zt.paint_heatmap["heatmap-color"]),"heatmap-opacity":new qn(zt.paint_heatmap["heatmap-opacity"])})};function Da(t,e){for(var r=new Uint8Array(1024),n={},i=0,a=0;i<256;i++,a+=4){n[e]=i/255;var o=t.evaluate(n);r[a+0]=Math.floor(255*o.r/o.a),r[a+1]=Math.floor(255*o.g/o.a),r[a+2]=Math.floor(255*o.b/o.a),r[a+3]=Math.floor(255*o.a);}return new Oa({width:256,height:1},r)}var Ua=function(t){function e(e){t.call(this,e,La),this._updateColorRamp();}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new Ma(t)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp();},e.prototype._updateColorRamp=function(){var t=this._transitionablePaint._values["heatmap-color"].value.expression;this.colorRamp=Da(t,"heatmapDensity"),this.colorRampTexture=null;},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(Jn),Ra={paint:new Gn({"hillshade-illumination-direction":new qn(zt.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new qn(zt.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new qn(zt.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new qn(zt.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new qn(zt.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new qn(zt.paint_hillshade["hillshade-accent-color"])})},ja=function(t){function e(e){t.call(this,e,Ra);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},e}(Jn),qa=Wn([{name:"a_pos",components:2,type:"Int16"}],4).members,Na=Za,Ka=Za;function Za(t,e,r){r=r||2;var n,i,a,o,s,u,l,p=e&&e.length,c=p?e[0]*r:t.length,h=Xa(t,0,c,r,!0),f=[];if(!h||h.next===h.prev)return f;if(p&&(h=function(t,e,r,n){var i,a,o,s,u,l=[];for(i=0,a=e.length;i<a;i++)o=e[i]*n,s=i<a-1?e[i+1]*n:t.length,(u=Xa(t,o,s,n,!1))===u.next&&(u.steiner=!0),l.push(no(u));for(l.sort(Qa),i=0;i<l.length;i++)to(l[i],r),r=Ga(r,r.next);return r}(t,e,h,r)),t.length>80*r){n=a=t[0],i=o=t[1];for(var y=r;y<c;y+=r)(s=t[y])<n&&(n=s),(u=t[y+1])<i&&(i=u),s>a&&(a=s),u>o&&(o=u);l=0!==(l=Math.max(a-n,o-i))?1/l:0;}return Ja(h,f,r,n,i,l),f}function Xa(t,e,r,n,i){var a,o;if(i===vo(t,e,r,n)>0)for(a=e;a<r;a+=n)o=fo(a,t[a],t[a+1],o);else for(a=r-n;a>=e;a-=n)o=fo(a,t[a],t[a+1],o);return o&&so(o,o.next)&&(yo(o),o=o.next),o}function Ga(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!so(n,n.next)&&0!==oo(n.prev,n,n.next))n=n.next;else{if(yo(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function Ja(t,e,r,n,i,a,o){if(t){!o&&a&&function(t,e,r,n){var i=t;do{null===i.z&&(i.z=ro(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,a,o,s,u,l=1;do{for(r=t,t=null,a=null,o=0;r;){for(o++,n=r,s=0,e=0;e<l&&(s++,n=n.nextZ);e++);for(u=l;s>0||u>0&&n;)0!==s&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,s--):(i=n,n=n.nextZ,u--),a?a.nextZ=i:t=i,i.prevZ=a,a=i;r=n;}a.nextZ=null,l*=2;}while(o>1)}(i);}(t,n,i,a);for(var s,u,l=t;t.prev!==t.next;)if(s=t.prev,u=t.next,a?Ya(t,n,i,a):Ha(t))e.push(s.i/r),e.push(t.i/r),e.push(u.i/r),yo(t),t=u.next,l=u.next;else if((t=u)===l){o?1===o?Ja(t=$a(Ga(t),e,r),e,r,n,i,a,2):2===o&&Wa(t,e,r,n,i,a):Ja(Ga(t),e,r,n,i,a,1);break}}}function Ha(t){var e=t.prev,r=t,n=t.next;if(oo(e,r,n)>=0)return !1;for(var i=t.next.next;i!==t.prev;){if(io(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&oo(i.prev,i,i.next)>=0)return !1;i=i.next;}return !0}function Ya(t,e,r,n){var i=t.prev,a=t,o=t.next;if(oo(i,a,o)>=0)return !1;for(var s=i.x<a.x?i.x<o.x?i.x:o.x:a.x<o.x?a.x:o.x,u=i.y<a.y?i.y<o.y?i.y:o.y:a.y<o.y?a.y:o.y,l=i.x>a.x?i.x>o.x?i.x:o.x:a.x>o.x?a.x:o.x,p=i.y>a.y?i.y>o.y?i.y:o.y:a.y>o.y?a.y:o.y,c=ro(s,u,e,r,n),h=ro(l,p,e,r,n),f=t.prevZ,y=t.nextZ;f&&f.z>=c&&y&&y.z<=h;){if(f!==t.prev&&f!==t.next&&io(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&oo(f.prev,f,f.next)>=0)return !1;if(f=f.prevZ,y!==t.prev&&y!==t.next&&io(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&oo(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}for(;f&&f.z>=c;){if(f!==t.prev&&f!==t.next&&io(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&oo(f.prev,f,f.next)>=0)return !1;f=f.prevZ;}for(;y&&y.z<=h;){if(y!==t.prev&&y!==t.next&&io(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&oo(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}return !0}function $a(t,e,r){var n=t;do{var i=n.prev,a=n.next.next;!so(i,a)&&uo(i,n,n.next,a)&&co(i,a)&&co(a,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(a.i/r),yo(n),yo(n.next),n=t=a),n=n.next;}while(n!==t);return Ga(n)}function Wa(t,e,r,n,i,a){var o=t;do{for(var s=o.next.next;s!==o.prev;){if(o.i!==s.i&&ao(o,s)){var u=ho(o,s);return o=Ga(o,o.next),u=Ga(u,u.next),Ja(o,e,r,n,i,a),void Ja(u,e,r,n,i,a)}s=s.next;}o=o.next;}while(o!==t)}function Qa(t,e){return t.x-e.x}function to(t,e){if(e=function(t,e){var r,n=e,i=t.x,a=t.y,o=-1/0;do{if(a<=n.y&&a>=n.next.y&&n.next.y!==n.y){var s=n.x+(a-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(s<=i&&s>o){if(o=s,s===i){if(a===n.y)return n;if(a===n.next.y)return n.next}r=n.x<n.next.x?n:n.next;}}n=n.next;}while(n!==e);if(!r)return null;if(i===o)return r;var u,l=r,p=r.x,c=r.y,h=1/0;n=r;do{i>=n.x&&n.x>=p&&i!==n.x&&io(a<c?i:o,a,p,c,a<c?o:i,a,n.x,n.y)&&(u=Math.abs(a-n.y)/(i-n.x),co(n,t)&&(u<h||u===h&&(n.x>r.x||n.x===r.x&&eo(r,n)))&&(r=n,h=u)),n=n.next;}while(n!==l);return r}(t,e)){var r=ho(e,t);Ga(r,r.next);}}function eo(t,e){return oo(t.prev,t,e.prev)<0&&oo(e.next,t,t.next)<0}function ro(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-r)*i)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-n)*i)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function no(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function io(t,e,r,n,i,a,o,s){return (i-o)*(e-s)-(t-o)*(a-s)>=0&&(t-o)*(n-s)-(r-o)*(e-s)>=0&&(r-o)*(a-s)-(i-o)*(n-s)>=0}function ao(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&uo(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&(co(t,e)&&co(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,a=(t.y+e.y)/2;do{r.y>a!=r.next.y>a&&r.next.y!==r.y&&i<(r.next.x-r.x)*(a-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)&&(oo(t.prev,t,e.prev)||oo(t,e.prev,e))||so(t,e)&&oo(t.prev,t,t.next)>0&&oo(e.prev,e,e.next)>0)}function oo(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function so(t,e){return t.x===e.x&&t.y===e.y}function uo(t,e,r,n){var i=po(oo(t,e,r)),a=po(oo(t,e,n)),o=po(oo(r,n,t)),s=po(oo(r,n,e));return i!==a&&o!==s||(!(0!==i||!lo(t,r,e))||(!(0!==a||!lo(t,n,e))||(!(0!==o||!lo(r,t,n))||!(0!==s||!lo(r,e,n)))))}function lo(t,e,r){return e.x<=Math.max(t.x,r.x)&&e.x>=Math.min(t.x,r.x)&&e.y<=Math.max(t.y,r.y)&&e.y>=Math.min(t.y,r.y)}function po(t){return t>0?1:t<0?-1:0}function co(t,e){return oo(t.prev,t,t.next)<0?oo(t,e,t.next)>=0&&oo(t,t.prev,e)>=0:oo(t,e,t.prev)<0||oo(t,t.next,e)<0}function ho(t,e){var r=new mo(t.i,t.x,t.y),n=new mo(e.i,e.x,e.y),i=t.next,a=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,a.next=n,n.prev=a,n}function fo(t,e,r,n){var i=new mo(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function yo(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function mo(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function vo(t,e,r,n){for(var i=0,a=e,o=r-n;a<r;a+=n)i+=(t[o]-t[a])*(t[a+1]+t[o+1]),o=a;return i}function go(t,e,r,n,i){!function t(e,r,n,i,a){for(;i>n;){if(i-n>600){var o=i-n+1,s=r-n+1,u=Math.log(o),l=.5*Math.exp(2*u/3),p=.5*Math.sqrt(u*l*(o-l)/o)*(s-o/2<0?-1:1),c=Math.max(n,Math.floor(r-s*l/o+p)),h=Math.min(i,Math.floor(r+(o-s)*l/o+p));t(e,r,c,h,a);}var f=e[r],y=n,d=i;for(xo(e,n,r),a(e[i],f)>0&&xo(e,n,i);y<d;){for(xo(e,y,d),y++,d--;a(e[y],f)<0;)y++;for(;a(e[d],f)>0;)d--;}0===a(e[n],f)?xo(e,n,d):xo(e,++d,i),d<=r&&(n=d+1),r<=d&&(i=d-1);}}(t,e,r||0,n||t.length-1,i||bo);}function xo(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function bo(t,e){return t<e?-1:t>e?1:0}function _o(t,e){var r=t.length;if(r<=1)return [t];for(var n,i,a=[],o=0;o<r;o++){var s=k(t[o]);0!==s&&(t[o].area=Math.abs(s),void 0===i&&(i=s<0),i===s<0?(n&&a.push(n),n=[t[o]]):n.push(t[o]));}if(n&&a.push(n),e>1)for(var u=0;u<a.length;u++)a[u].length<=e||(go(a[u],e,1,a[u].length-1,wo),a[u]=a[u].slice(0,e));return a}function wo(t,e){return e.area-t.area}function Ao(t,e,r){for(var n=r.patternDependencies,i=!1,a=0,o=e;a<o.length;a+=1){var s=o[a].paint.get(t+"-pattern");s.isConstant()||(i=!0);var u=s.constantOr(null);u&&(i=!0,n[u.to]=!0,n[u.from]=!0);}return i}function ko(t,e,r,n,i){for(var a=i.patternDependencies,o=0,s=e;o<s.length;o+=1){var u=s[o],l=u.paint.get(t+"-pattern").value;if("constant"!==l.kind){var p=l.evaluate({zoom:n-1},r,{}),c=l.evaluate({zoom:n},r,{}),h=l.evaluate({zoom:n+1},r,{});a[p]=!0,a[c]=!0,a[h]=!0,r.patterns[u.id]={min:p,mid:c,max:h};}}return r}Za.deviation=function(t,e,r,n){var i=e&&e.length,a=i?e[0]*r:t.length,o=Math.abs(vo(t,0,a,r));if(i)for(var s=0,u=e.length;s<u;s++){var l=e[s]*r,p=s<u-1?e[s+1]*r:t.length;o-=Math.abs(vo(t,l,p,r));}var c=0;for(s=0;s<n.length;s+=3){var h=n[s]*r,f=n[s+1]*r,y=n[s+2]*r;c+=Math.abs((t[h]-t[y])*(t[f+1]-t[h+1])-(t[h]-t[f])*(t[y+1]-t[h+1]));}return 0===o&&0===c?0:Math.abs((c-o)/o)},Za.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var a=0;a<t[i].length;a++)for(var o=0;o<e;o++)r.vertices.push(t[i][a][o]);i>0&&(n+=t[i-1].length,r.holes.push(n));}return r},Na.default=Ka;var So=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new ti,this.indexArray=new mi,this.indexArray2=new vi,this.programConfigurations=new ta(qa,t.layers,t.zoom),this.segments=new Vi,this.segments2=new Vi,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};So.prototype.populate=function(t,e){this.hasPattern=Ao("fill",this.layers,e);for(var r=this.layers[0].layout.get("fill-sort-key"),n=[],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o.feature,u=o.index,l=o.sourceLayerIndex;if(this.layers[0]._featureFilter(new Tn(this.zoom),s)){var p=oa(s),c=r?r.evaluate(s,{}):void 0,h={id:s.id,properties:s.properties,type:s.type,sourceLayerIndex:l,index:u,geometry:p,patterns:{},sortKey:c};n.push(h);}}r&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var f=0,y=n;f<y.length;f+=1){var d=y[f],m=d,v=m.geometry,g=m.index,x=m.sourceLayerIndex;if(this.hasPattern){var b=ko("fill",this.layers,d,this.zoom,e);this.patternFeatures.push(b);}else this.addFeature(d,v,g,{});var _=t[g].feature;e.featureIndex.insert(_,v,g,x,this.index);}},So.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},So.prototype.addFeatures=function(t,e){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var i=n[r];this.addFeature(i,i.geometry,i.index,e);}},So.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},So.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},So.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,qa),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;},So.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());},So.prototype.addFeature=function(t,e,r,n){for(var i=0,a=_o(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray),c=p.vertexLength,h=[],f=[],y=0,d=o;y<d.length;y+=1){var m=d[y];if(0!==m.length){m!==o[0]&&f.push(h.length/2);var v=this.segments2.prepareSegment(m.length,this.layoutVertexArray,this.indexArray2),g=v.vertexLength;this.layoutVertexArray.emplaceBack(m[0].x,m[0].y),this.indexArray2.emplaceBack(g+m.length-1,g),h.push(m[0].x),h.push(m[0].y);for(var x=1;x<m.length;x++)this.layoutVertexArray.emplaceBack(m[x].x,m[x].y),this.indexArray2.emplaceBack(g+x-1,g+x),h.push(m[x].x),h.push(m[x].y);v.vertexLength+=m.length,v.primitiveLength+=m.length;}}for(var b=Na(h,f),_=0;_<b.length;_+=3)this.indexArray.emplaceBack(c+b[_],c+b[_+1],c+b[_+2]);p.vertexLength+=s,p.primitiveLength+=b.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},mn("FillBucket",So,{omit:["layers","patternFeatures"]});var zo=new Gn({"fill-sort-key":new Nn(zt.layout_fill["fill-sort-key"])}),Io={paint:new Gn({"fill-antialias":new qn(zt.paint_fill["fill-antialias"]),"fill-opacity":new Nn(zt.paint_fill["fill-opacity"]),"fill-color":new Nn(zt.paint_fill["fill-color"]),"fill-outline-color":new Nn(zt.paint_fill["fill-outline-color"]),"fill-translate":new qn(zt.paint_fill["fill-translate"]),"fill-translate-anchor":new qn(zt.paint_fill["fill-translate-anchor"]),"fill-pattern":new Kn(zt.paint_fill["fill-pattern"])}),layout:zo},Co=function(t){function e(e){t.call(this,e,Io);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e);var r=this.paint._values["fill-outline-color"];"constant"===r.value.kind&&void 0===r.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);},e.prototype.createBucket=function(t){return new So(t)},e.prototype.queryRadius=function(){return _a(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return ca(wa(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),a.angle,o),n)},e.prototype.isTileClipped=function(){return !0},e}(Jn),Bo=Wn([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4).members,Eo=Mo;function Mo(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(Po,this,e);}function Po(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){var r=t.readVarint()+t.pos;for(;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function To(t){for(var e,r,n=0,i=0,a=t.length,o=a-1;i<a;o=i++)e=t[i],n+=((r=t[o]).x-e.x)*(e.y+r.y);return n}Mo.types=["Unknown","Point","LineString","Polygon"],Mo.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,a=0,o=0,s=0,u=[];t.pos<r;){if(a<=0){var l=t.readVarint();n=7&l,a=l>>3;}if(a--,1===n||2===n)o+=t.readSVarint(),s+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new i(o,s));else{if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&u.push(e),u},Mo.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,a=0,o=1/0,s=-1/0,u=1/0,l=-1/0;t.pos<e;){if(n<=0){var p=t.readVarint();r=7&p,n=p>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<o&&(o=i),i>s&&(s=i),(a+=t.readSVarint())<u&&(u=a),a>l&&(l=a);else if(7!==r)throw new Error("unknown command "+r)}return [o,u,s,l]},Mo.prototype.toGeoJSON=function(t,e,r){var n,i,a=this.extent*Math.pow(2,r),o=this.extent*t,s=this.extent*e,u=this.loadGeometry(),l=Mo.types[this.type];function p(t){for(var e=0;e<t.length;e++){var r=t[e],n=180-360*(r.y+s)/a;t[e]=[360*(r.x+o)/a-180,360/Math.PI*Math.atan(Math.exp(n*Math.PI/180))-90];}}switch(this.type){case 1:var c=[];for(n=0;n<u.length;n++)c[n]=u[n][0];p(u=c);break;case 2:for(n=0;n<u.length;n++)p(u[n]);break;case 3:for(u=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],a=0;a<e;a++){var o=To(t[a]);0!==o&&(void 0===n&&(n=o<0),n===o<0?(r&&i.push(r),r=[t[a]]):r.push(t[a]));}r&&i.push(r);return i}(u),n=0;n<u.length;n++)for(i=0;i<u[n].length;i++)p(u[n][i]);}1===u.length?u=u[0]:l="Multi"+l;var h={type:"Feature",geometry:{type:l,coordinates:u},properties:this.properties};return "id"in this&&(h.id=this.id),h};var Vo=Fo;function Fo(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(Oo,this,e),this.length=this._features.length;}function Oo(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){var e=null,r=t.readVarint()+t.pos;for(;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function Lo(t,e,r){if(3===t){var n=new Vo(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}Fo.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new Eo(this._pbf,e,this.extent,this._keys,this._values)};var Do={VectorTile:function(t,e){this.layers=t.readFields(Lo,{},e);},VectorTileFeature:Eo,VectorTileLayer:Vo},Uo=Do.VectorTileFeature.types,Ro=Math.pow(2,13);function jo(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,2*Math.floor(n*Ro)+o,i*Ro*2,a*Ro*2,Math.round(s));}var qo=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new ri,this.indexArray=new mi,this.programConfigurations=new ta(Bo,t.layers,t.zoom),this.segments=new Vi,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function No(t,e){return t.x===e.x&&(t.x<0||t.x>na)||t.y===e.y&&(t.y<0||t.y>na)}function Ko(t){return t.every((function(t){return t.x<0}))||t.every((function(t){return t.x>na}))||t.every((function(t){return t.y<0}))||t.every((function(t){return t.y>na}))}qo.prototype.populate=function(t,e){this.features=[],this.hasPattern=Ao("fill-extrusion",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Tn(this.zoom),a)){var u=oa(a),l={sourceLayerIndex:s,index:o,geometry:u,properties:a.properties,type:a.type,patterns:{}};void 0!==a.id&&(l.id=a.id),this.hasPattern?this.features.push(ko("fill-extrusion",this.layers,l,this.zoom,e)):this.addFeature(l,u,o,{}),e.featureIndex.insert(a,u,o,s,this.index,!0);}}},qo.prototype.addFeatures=function(t,e){for(var r=0,n=this.features;r<n.length;r+=1){var i=n[r],a=i.geometry;this.addFeature(i,a,i.index,e);}},qo.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},qo.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},qo.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},qo.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Bo),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},qo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},qo.prototype.addFeature=function(t,e,r,n){for(var i=0,a=_o(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),c=0,h=o;c<h.length;c+=1){var f=h[c];if(0!==f.length&&!Ko(f))for(var y=0,d=0;d<f.length;d++){var m=f[d];if(d>=1){var v=f[d-1];if(!No(m,v)){p.vertexLength+4>Vi.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray));var g=m.sub(v)._perp()._unit(),x=v.dist(m);y+x>32768&&(y=0),jo(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,0,y),jo(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,1,y),y+=x,jo(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,0,y),jo(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,1,y);var b=p.vertexLength;this.indexArray.emplaceBack(b,b+2,b+1),this.indexArray.emplaceBack(b+1,b+2,b+3),p.vertexLength+=4,p.primitiveLength+=2;}}}}if(p.vertexLength+s>Vi.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray)),"Polygon"===Uo[t.type]){for(var _=[],w=[],A=p.vertexLength,k=0,S=o;k<S.length;k+=1){var z=S[k];if(0!==z.length){z!==o[0]&&w.push(_.length/2);for(var I=0;I<z.length;I++){var C=z[I];jo(this.layoutVertexArray,C.x,C.y,0,0,1,1,0),_.push(C.x),_.push(C.y);}}}for(var B=Na(_,w),E=0;E<B.length;E+=3)this.indexArray.emplaceBack(A+B[E],A+B[E+2],A+B[E+1]);p.primitiveLength+=B.length/3,p.vertexLength+=s;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},mn("FillExtrusionBucket",qo,{omit:["layers","features"]});var Zo={paint:new Gn({"fill-extrusion-opacity":new qn(zt["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new Nn(zt["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new qn(zt["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new qn(zt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new Kn(zt["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new Nn(zt["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new Nn(zt["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new qn(zt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])})},Xo=function(t){function e(e){t.call(this,e,Zo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new qo(t)},e.prototype.queryRadius=function(){return _a(this.paint.get("fill-extrusion-translate"))},e.prototype.is3D=function(){return !0},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s,u){var l=wa(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),o.angle,s),p=this.paint.get("fill-extrusion-height").evaluate(e,r),c=this.paint.get("fill-extrusion-base").evaluate(e,r),h=function(t,e,r,n){for(var a=[],o=0,s=t;o<s.length;o+=1){var u=s[o],l=[u.x,u.y,n,1];Ca(l,l,e),a.push(new i(l[0]/l[3],l[1]/l[3]));}return a}(l,u,0,0),f=function(t,e,r,n){for(var a=[],o=[],s=n[8]*e,u=n[9]*e,l=n[10]*e,p=n[11]*e,c=n[8]*r,h=n[9]*r,f=n[10]*r,y=n[11]*r,d=0,m=t;d<m.length;d+=1){for(var v=m[d],g=[],x=[],b=0,_=v;b<_.length;b+=1){var w=_[b],A=w.x,k=w.y,S=n[0]*A+n[4]*k+n[12],z=n[1]*A+n[5]*k+n[13],I=n[2]*A+n[6]*k+n[14],C=n[3]*A+n[7]*k+n[15],B=I+l,E=C+p,M=S+c,P=z+h,T=I+f,V=C+y,F=new i((S+s)/E,(z+u)/E);F.z=B/E,g.push(F);var O=new i(M/V,P/V);O.z=T/V,x.push(O);}a.push(g),o.push(x);}return [a,o]}(n,c,p,u);return function(t,e,r){var n=1/0;ca(r,e)&&(n=Jo(r,e[0]));for(var i=0;i<e.length;i++)for(var a=e[i],o=t[i],s=0;s<a.length-1;s++){var u=a[s],l=a[s+1],p=o[s],c=o[s+1],h=[u,l,c,p,u];la(r,h)&&(n=Math.min(n,Jo(r,h)));}return n!==1/0&&n}(f[0],f[1],h)},e}(Jn);function Go(t,e){return t.x*e.x+t.y*e.y}function Jo(t,e){if(1===t.length){var r=e[0],n=e[1],i=e[3],a=t[0],o=n.sub(r),s=i.sub(r),u=a.sub(r),l=Go(o,o),p=Go(o,s),c=Go(s,s),h=Go(u,o),f=Go(u,s),y=l*c-p*p,d=(c*h-p*f)/y,m=(l*f-p*h)/y,v=1-d-m;return r.z*v+n.z*d+i.z*m}for(var g=1/0,x=0,b=e;x<b.length;x+=1){var _=b[x];g=Math.min(g,_.z);}return g}var Ho=Wn([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4).members,Yo=Do.VectorTileFeature.types,$o=Math.cos(Math.PI/180*37.5),Wo=Math.pow(2,14)/.5,Qo=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new ni,this.indexArray=new mi,this.programConfigurations=new ta(Ho,t.layers,t.zoom),this.segments=new Vi,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};Qo.prototype.populate=function(t,e){this.hasPattern=Ao("line",this.layers,e);for(var r=this.layers[0].layout.get("line-sort-key"),n=[],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o.feature,u=o.index,l=o.sourceLayerIndex;if(this.layers[0]._featureFilter(new Tn(this.zoom),s)){var p=oa(s),c=r?r.evaluate(s,{}):void 0,h={id:s.id,properties:s.properties,type:s.type,sourceLayerIndex:l,index:u,geometry:p,patterns:{},sortKey:c};n.push(h);}}r&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var f=0,y=n;f<y.length;f+=1){var d=y[f],m=d,v=m.geometry,g=m.index,x=m.sourceLayerIndex;if(this.hasPattern){var b=ko("line",this.layers,d,this.zoom,e);this.patternFeatures.push(b);}else this.addFeature(d,v,g,{});var _=t[g].feature;e.featureIndex.insert(_,v,g,x,this.index);}},Qo.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},Qo.prototype.addFeatures=function(t,e){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var i=n[r];this.addFeature(i,i.geometry,i.index,e);}},Qo.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Qo.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Qo.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Ho),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},Qo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},Qo.prototype.addFeature=function(t,e,r,n){for(var i=this.layers[0].layout,a=i.get("line-join").evaluate(t,{}),o=i.get("line-cap"),s=i.get("line-miter-limit"),u=i.get("line-round-limit"),l=0,p=e;l<p.length;l+=1){var c=p[l];this.addLine(c,t,a,o,s,u,r,n);}},Qo.prototype.addLine=function(t,e,r,n,i,a,o,s){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,e.properties&&e.properties.hasOwnProperty("mapbox_clip_start")&&e.properties.hasOwnProperty("mapbox_clip_end")){this.clipStart=+e.properties.mapbox_clip_start,this.clipEnd=+e.properties.mapbox_clip_end;for(var u=0;u<t.length-1;u++)this.totalDistance+=t[u].dist(t[u+1]);}for(var l="Polygon"===Yo[e.type],p=t.length;p>=2&&t[p-1].equals(t[p-2]);)p--;for(var c=0;c<p-1&&t[c].equals(t[c+1]);)c++;if(!(p<(l?3:2))){"bevel"===r&&(i=1.05);var h,f=na/(512*this.overscaling)*15,y=this.segments.prepareSegment(10*p,this.layoutVertexArray,this.indexArray),d=void 0,m=void 0,v=void 0,g=void 0;this.e1=this.e2=-1,l&&(h=t[p-2],g=t[c].sub(h)._unit()._perp());for(var x=c;x<p;x++)if(!(m=l&&x===p-1?t[c+1]:t[x+1])||!t[x].equals(m)){g&&(v=g),h&&(d=h),h=t[x],g=m?m.sub(h)._unit()._perp():v;var b=(v=v||g).add(g);0===b.x&&0===b.y||b._unit();var _=v.x*g.x+v.y*g.y,w=b.x*g.x+b.y*g.y,A=0!==w?1/w:1/0,k=2*Math.sqrt(2-2*w),S=w<$o&&d&&m,z=v.x*g.y-v.y*g.x>0;if(S&&x>c){var I=h.dist(d);if(I>2*f){var C=h.sub(h.sub(d)._mult(f/I)._round());this.updateDistance(d,C),this.addCurrentVertex(C,v,0,0,y),d=C;}}var B=d&&m,E=B?r:l?"butt":n;if(B&&"round"===E&&(A<a?E="miter":A<=2&&(E="fakeround")),"miter"===E&&A>i&&(E="bevel"),"bevel"===E&&(A>2&&(E="flipbevel"),A<i&&(E="miter")),d&&this.updateDistance(d,h),"miter"===E)b._mult(A),this.addCurrentVertex(h,b,0,0,y);else if("flipbevel"===E){if(A>100)b=g.mult(-1);else{var M=A*v.add(g).mag()/v.sub(g).mag();b._perp()._mult(M*(z?-1:1));}this.addCurrentVertex(h,b,0,0,y),this.addCurrentVertex(h,b.mult(-1),0,0,y);}else if("bevel"===E||"fakeround"===E){var P=-Math.sqrt(A*A-1),T=z?P:0,V=z?0:P;if(d&&this.addCurrentVertex(h,v,T,V,y),"fakeround"===E)for(var F=Math.round(180*k/Math.PI/20),O=1;O<F;O++){var L=O/F;if(.5!==L){var D=L-.5;L+=L*D*(L-1)*((1.0904+_*(_*(3.55645-1.43519*_)-3.2452))*D*D+(.848013+_*(.215638*_-1.06021)));}var U=g.sub(v)._mult(L)._add(v)._unit()._mult(z?-1:1);this.addHalfVertex(h,U.x,U.y,!1,z,0,y);}m&&this.addCurrentVertex(h,g,-T,-V,y);}else if("butt"===E)this.addCurrentVertex(h,b,0,0,y);else if("square"===E){var R=d?1:-1;this.addCurrentVertex(h,b,R,R,y);}else"round"===E&&(d&&(this.addCurrentVertex(h,v,0,0,y),this.addCurrentVertex(h,v,1,1,y,!0)),m&&(this.addCurrentVertex(h,g,-1,-1,y,!0),this.addCurrentVertex(h,g,0,0,y)));if(S&&x<p-1){var j=h.dist(m);if(j>2*f){var q=h.add(m.sub(h)._mult(f/j)._round());this.updateDistance(h,q),this.addCurrentVertex(q,g,0,0,y),h=q;}}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e,o,s);}},Qo.prototype.addCurrentVertex=function(t,e,r,n,i,a){void 0===a&&(a=!1);var o=e.x+e.y*r,s=e.y-e.x*r,u=-e.x+e.y*n,l=-e.y-e.x*n;this.addHalfVertex(t,o,s,a,!1,r,i),this.addHalfVertex(t,u,l,a,!0,-n,i),this.distance>Wo/2&&0===this.totalDistance&&(this.distance=0,this.addCurrentVertex(t,e,r,n,i,a));},Qo.prototype.addHalfVertex=function(t,e,r,n,i,a,o){var s=t.x,u=t.y,l=.5*this.scaledDistance;this.layoutVertexArray.emplaceBack((s<<1)+(n?1:0),(u<<1)+(i?1:0),Math.round(63*e)+128,Math.round(63*r)+128,1+(0===a?0:a<0?-1:1)|(63&l)<<2,l>>6);var p=o.vertexLength++;this.e1>=0&&this.e2>=0&&(this.indexArray.emplaceBack(this.e1,this.e2,p),o.primitiveLength++),i?this.e2=p:this.e1=p;},Qo.prototype.updateDistance=function(t,e){this.distance+=t.dist(e),this.scaledDistance=this.totalDistance>0?(this.clipStart+(this.clipEnd-this.clipStart)*this.distance/this.totalDistance)*(Wo-1):this.distance;},mn("LineBucket",Qo,{omit:["layers","patternFeatures"]});var ts=new Gn({"line-cap":new qn(zt.layout_line["line-cap"]),"line-join":new Nn(zt.layout_line["line-join"]),"line-miter-limit":new qn(zt.layout_line["line-miter-limit"]),"line-round-limit":new qn(zt.layout_line["line-round-limit"]),"line-sort-key":new Nn(zt.layout_line["line-sort-key"])}),es={paint:new Gn({"line-opacity":new Nn(zt.paint_line["line-opacity"]),"line-color":new Nn(zt.paint_line["line-color"]),"line-translate":new qn(zt.paint_line["line-translate"]),"line-translate-anchor":new qn(zt.paint_line["line-translate-anchor"]),"line-width":new Nn(zt.paint_line["line-width"]),"line-gap-width":new Nn(zt.paint_line["line-gap-width"]),"line-offset":new Nn(zt.paint_line["line-offset"]),"line-blur":new Nn(zt.paint_line["line-blur"]),"line-dasharray":new Zn(zt.paint_line["line-dasharray"]),"line-pattern":new Kn(zt.paint_line["line-pattern"]),"line-gradient":new Xn(zt.paint_line["line-gradient"])}),layout:ts},rs=new(function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new Tn(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,n,i){return r=c({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,n,i)},e}(Nn))(es.paint.properties["line-width"].specification);rs.useIntegerZoom=!0;var ns=function(t){function e(e){t.call(this,e,es);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&this._updateGradient();},e.prototype._updateGradient=function(){var t=this._transitionablePaint._values["line-gradient"].value.expression;this.gradient=Da(t,"lineProgress"),this.gradientTexture=null;},e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),this.paint._values["line-floorwidth"]=rs.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e);},e.prototype.createBucket=function(t){return new Qo(t)},e.prototype.queryRadius=function(t){var e=t,r=is(ba("line-width",this,e),ba("line-gap-width",this,e)),n=ba("line-offset",this,e);return r/2+Math.abs(n)+_a(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s){var u=wa(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),o.angle,s),l=s/2*is(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),p=this.paint.get("line-offset").evaluate(e,r);return p&&(n=function(t,e){for(var r=[],n=new i(0,0),a=0;a<t.length;a++){for(var o=t[a],s=[],u=0;u<o.length;u++){var l=o[u-1],p=o[u],c=o[u+1],h=0===u?n:p.sub(l)._unit()._perp(),f=u===o.length-1?n:c.sub(p)._unit()._perp(),y=h._add(f)._unit(),d=y.x*f.x+y.y*f.y;y._mult(1/d),s.push(y._mult(e)._add(p));}r.push(s);}return r}(n,p*s)),function(t,e,r){for(var n=0;n<e.length;n++){var i=e[n];if(t.length>=3)for(var a=0;a<i.length;a++)if(ga(t,i[a]))return !0;if(ha(t,i,r))return !0}return !1}(u,n,l)},e.prototype.isTileClipped=function(){return !0},e}(Jn);function is(t,e){return e>0?e+2*t:t}var as=Wn([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"}]),os=Wn([{name:"a_projected_pos",components:3,type:"Float32"}],4),ss=(Wn([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),Wn([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}])),us=(Wn([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"radius"},{type:"Int16",name:"signedDistanceFromAnchor"}]),Wn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4)),ls=Wn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4);Wn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"}]),Wn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint32",name:"crossTileID"},{type:"Float32",name:"textBoxScale"},{type:"Float32",name:"radialTextOffset"}]),Wn([{type:"Float32",name:"offsetX"}]),Wn([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);function ps(t,e,r){return t.sections.forEach((function(t){t.text=function(t,e,r){var n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),Pn.applyArabicShaping&&(t=Pn.applyArabicShaping(t)),t}(t.text,e,r);})),t}var cs={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};var hs=24,fs={horizontal:1,vertical:2,horizontalOnly:3},ys=function(){this.text="",this.sectionIndex=[],this.sections=[];};function ds(t,e,r,n,i,a,o,s,u,l,p){var c,h=ys.fromFeature(t,r);l===fs.vertical&&h.verticalizePunctuation();var f=Pn.processBidirectionalText,y=Pn.processStyledBidirectionalText;if(f&&1===h.sections.length){c=[];for(var d=0,m=f(h.toString(),_s(h,s,n,e));d<m.length;d+=1){var v=m[d],g=new ys;g.text=v,g.sections=h.sections;for(var x=0;x<v.length;x++)g.sectionIndex.push(0);c.push(g);}}else if(y){c=[];for(var b=0,_=y(h.text,h.sectionIndex,_s(h,s,n,e));b<_.length;b+=1){var w=_[b],A=new ys;A.text=w[0],A.sectionIndex=w[1],A.sections=h.sections,c.push(A);}}else c=function(t,e){for(var r=[],n=t.text,i=0,a=0,o=e;a<o.length;a+=1){var s=o[a];r.push(t.substring(i,s)),i=s;}return i<n.length&&r.push(t.substring(i,n.length)),r}(h,_s(h,s,n,e));var k=[],S={positionedGlyphs:k,text:h.toString(),top:u[1],bottom:u[1],left:u[0],right:u[0],writingMode:l,lineCount:c.length,yOffset:-17};return function(t,e,r,n,i,a,o,s,u){for(var l=0,p=t.yOffset,c=0,h=t.positionedGlyphs,f="right"===a?1:"left"===a?0:.5,y=0,d=r;y<d.length;y+=1){var m=d[y];m.trim();var v=m.getMaxScale();if(m.length()){for(var g=h.length,x=0;x<m.length();x++){var b=m.getSection(x),_=m.getSectionIndex(x),w=m.getCharCode(x),A=24*(v-b.scale),k=e[b.fontStack],S=k&&k[w];S&&(o===fs.horizontal||!u&&!kn(w)||u&&(ms[w]||(I=w,_n.Arabic(I)||_n["Arabic Supplement"](I)||_n["Arabic Extended-A"](I)||_n["Arabic Presentation Forms-A"](I)||_n["Arabic Presentation Forms-B"](I)))?(h.push({glyph:w,x:l,y:p+A,vertical:!1,scale:b.scale,fontStack:b.fontStack,sectionIndex:_}),l+=S.metrics.advance*b.scale+s):(h.push({glyph:w,x:l,y:p+A,vertical:!0,scale:b.scale,fontStack:b.fontStack,sectionIndex:_}),l+=hs*b.scale+s));}if(h.length!==g){var z=l-s;c=Math.max(z,c),As(h,e,g,h.length-1,f);}l=0,p+=n*v;}else p+=n;}var I;var C=ws(i),B=C.horizontalAlign,E=C.verticalAlign;!function(t,e,r,n,i,a,o){for(var s=(e-r)*i,u=(-n*o+.5)*a,l=0;l<t.length;l++)t[l].x+=s,t[l].y+=u;}(h,f,B,E,c,n,r.length);var M=p-t.yOffset;t.top+=-E*M,t.bottom=t.top+M,t.left+=-B*c,t.right=t.left+c;}(S,e,c,i,a,o,l,s,p),!!k.length&&S}ys.fromFeature=function(t,e){for(var r=new ys,n=0;n<t.sections.length;n++){var i=t.sections[n];r.sections.push({scale:i.scale||1,fontStack:i.fontStack||e}),r.text+=i.text;for(var a=0;a<i.text.length;a++)r.sectionIndex.push(n);}return r},ys.prototype.length=function(){return this.text.length},ys.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},ys.prototype.getSectionIndex=function(t){return this.sectionIndex[t]},ys.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},ys.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",r=0;r<t.length;r++){var n=t.charCodeAt(r+1)||null,i=t.charCodeAt(r-1)||null;(!n||!Sn(n)||cs[t[r+1]])&&(!i||!Sn(i)||cs[t[r-1]])&&cs[t[r]]?e+=cs[t[r]]:e+=t[r];}return e}(this.text);},ys.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&ms[this.text.charCodeAt(e)];e++)t++;for(var r=this.text.length,n=this.text.length-1;n>=0&&n>=t&&ms[this.text.charCodeAt(n)];n--)r--;this.text=this.text.substring(t,r),this.sectionIndex=this.sectionIndex.slice(t,r);},ys.prototype.substring=function(t,e){var r=new ys;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r},ys.prototype.toString=function(){return this.text},ys.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce((function(e,r){return Math.max(e,t.sections[r].scale)}),0)};var ms={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},vs={};function gs(t,e,r,n){var i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function xs(t,e,r){var n=0;return 10===t&&(n-=1e4),r&&(n+=150),40!==t&&65288!==t||(n+=50),41!==e&&65289!==e||(n+=50),n}function bs(t,e,r,n,i,a){for(var o=null,s=gs(e,r,i,a),u=0,l=n;u<l.length;u+=1){var p=l[u],c=gs(e-p.x,r,i,a)+p.badness;c<=s&&(o=p,s=c);}return {index:t,x:e,priorBreak:o,badness:s}}function _s(t,e,r,n){if(!r)return [];if(!t)return [];for(var i,a=[],o=function(t,e,r,n){for(var i=0,a=0;a<t.length();a++){var o=t.getSection(a),s=n[o.fontStack],u=s&&s[t.getCharCode(a)];u&&(i+=u.metrics.advance*o.scale+e);}return i/Math.max(1,Math.ceil(i/r))}(t,e,r,n),s=t.text.indexOf("​")>=0,u=0,l=0;l<t.length();l++){var p=t.getSection(l),c=t.getCharCode(l),h=n[p.fontStack],f=h&&h[c];if(f&&!ms[c]&&(u+=f.metrics.advance*p.scale+e),l<t.length()-1){var y=!!(!((i=c)<11904)&&(_n["Bopomofo Extended"](i)||_n.Bopomofo(i)||_n["CJK Compatibility Forms"](i)||_n["CJK Compatibility Ideographs"](i)||_n["CJK Compatibility"](i)||_n["CJK Radicals Supplement"](i)||_n["CJK Strokes"](i)||_n["CJK Symbols and Punctuation"](i)||_n["CJK Unified Ideographs Extension A"](i)||_n["CJK Unified Ideographs"](i)||_n["Enclosed CJK Letters and Months"](i)||_n["Halfwidth and Fullwidth Forms"](i)||_n.Hiragana(i)||_n["Ideographic Description Characters"](i)||_n["Kangxi Radicals"](i)||_n["Katakana Phonetic Extensions"](i)||_n.Katakana(i)||_n["Vertical Forms"](i)||_n["Yi Radicals"](i)||_n["Yi Syllables"](i)));(vs[c]||y)&&a.push(bs(l+1,u,o,a,xs(c,t.getCharCode(l+1),y&&s),!1));}}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(bs(t.length(),u,o,a,0,!0))}function ws(t){var e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function As(t,e,r,n,i){if(i){var a=t[n],o=e[a.fontStack],s=o&&o[a.glyph];if(s)for(var u=s.metrics.advance*a.scale,l=(t[n].x+u)*i,p=r;p<=n;p++)t[p].x-=l;}}vs[10]=!0,vs[32]=!0,vs[38]=!0,vs[40]=!0,vs[41]=!0,vs[43]=!0,vs[45]=!0,vs[47]=!0,vs[173]=!0,vs[183]=!0,vs[8203]=!0,vs[8208]=!0,vs[8211]=!0,vs[8231]=!0;var ks=function(t){function e(e,r,n,i){t.call(this,e,r),this.angle=n,void 0!==i&&(this.segment=i);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(i);mn("Anchor",ks);var Ss=256;function zs(t,e){var r=e.expression;if("constant"===r.kind)return {kind:"constant",layoutSize:r.evaluate(new Tn(t+1))};if("source"===r.kind)return {kind:"source"};for(var n=r.zoomStops,i=r.interpolationType,a=0;a<n.length&&n[a]<=t;)a++;for(var o=a=Math.max(0,a-1);o<n.length&&n[o]<t+1;)o++;o=Math.min(n.length-1,o);var s=n[a],u=n[o];return "composite"===r.kind?{kind:"composite",minZoom:s,maxZoom:u,interpolationType:i}:{kind:"camera",minZoom:s,maxZoom:u,minSize:r.evaluate(new Tn(s)),maxSize:r.evaluate(new Tn(u)),interpolationType:i}}function Is(t,e,r){var n=e.uSize,i=e.uSizeT,a=r.lowerSize,o=r.upperSize;return "source"===t.kind?a/Ss:"composite"===t.kind?be(a/Ss,o/Ss,i):n}function Cs(t,e){var r=0,n=0;if("constant"===t.kind)n=t.layoutSize;else if("source"!==t.kind){var i=t.interpolationType,a=t.minZoom,o=t.maxZoom,s=i?l(je.interpolationFactor(i,e,a,o),0,1):0;"camera"===t.kind?n=be(t.minSize,t.maxSize,s):r=s;}return {uSizeT:r,uSize:n}}var Bs=Object.freeze({getSizeData:zs,evaluateSizeForFeature:Is,evaluateSizeForZoom:Cs,SIZE_PACK_FACTOR:Ss}),Es=Do.VectorTileFeature.types,Ms=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function Ps(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),a,o,s?s[0]:0,s?s[1]:0);}function Ts(t,e,r){t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r);}var Vs=function(t){this.layoutVertexArray=new ai,this.indexArray=new mi,this.programConfigurations=t,this.segments=new Vi,this.dynamicLayoutVertexArray=new oi,this.opacityVertexArray=new si,this.placedSymbolArray=new ki;};Vs.prototype.upload=function(t,e,r,n){r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,as.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,os.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,Ms,!0),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t);},Vs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy());},mn("SymbolBuffers",Vs);var Fs=function(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new Vi,this.collisionVertexArray=new pi;};Fs.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,ss.members,!0);},Fs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy());},mn("CollisionBuffers",Fs);var Os=function(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasPaintOverrides=!1;var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=zs(this.zoom,e["text-size"]),this.iconSizeData=zs(this.zoom,e["icon-size"]);var r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1);var a="viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey;this.sortFeaturesByY=a&&(r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement")),"point"===r.get("symbol-placement")&&(this.writingModes=r.get("text-writing-mode").map((function(t){return fs[t]}))),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id})),this.sourceID=t.sourceID;};Os.prototype.createArrays=function(){var t=this.layers[0].layout;this.hasPaintOverrides=Rs.hasPaintOverrides(t),this.text=new Vs(new ta(as.members,this.layers,this.zoom,(function(t){return /^text/.test(t)}))),this.icon=new Vs(new ta(as.members,this.layers,this.zoom,(function(t){return /^icon/.test(t)}))),this.collisionBox=new Fs(li,us.members,vi),this.collisionCircle=new Fs(li,ls.members,mi),this.glyphOffsetArray=new Ci,this.lineVertexArray=new Ei,this.symbolInstances=new zi;},Os.prototype.calculateGlyphDependencies=function(t,e,r,n,i){for(var a=0;a<t.length;a++)if(e[t.charCodeAt(a)]=!0,(r||n)&&i){var o=cs[t.charAt(a)];o&&(e[o.charCodeAt(0)]=!0);}},Os.prototype.populate=function(t,e){var r=this.layers[0],n=r.layout,i=n.get("text-font"),a=n.get("text-field"),o=n.get("icon-image"),s=("constant"!==a.value.kind||a.value.value.toString().length>0)&&("constant"!==i.value.kind||i.value.value.length>0),u="constant"!==o.value.kind||o.value.value&&o.value.value.length>0,l=n.get("symbol-sort-key");if(this.features=[],s||u){for(var p=e.iconDependencies,c=e.glyphDependencies,h=new Tn(this.zoom),f=0,y=t;f<y.length;f+=1){var d=y[f],m=d.feature,v=d.index,g=d.sourceLayerIndex;if(r._featureFilter(h,m)){var x=void 0;if(s){var b=r.getValueAndResolveTokens("text-field",m);x=ps(b instanceof Wt?b:Wt.fromString(b),r,m);}var _=void 0;if(u&&(_=r.getValueAndResolveTokens("icon-image",m)),x||_){var w=this.sortFeaturesByKey?l.evaluate(m,{}):void 0,A={text:x,icon:_,index:v,sourceLayerIndex:g,geometry:oa(m),properties:m.properties,type:Es[m.type],sortKey:w};if(void 0!==m.id&&(A.id=m.id),this.features.push(A),_&&(p[_]=!0),x){var k=i.evaluate(m,{}).join(","),S="map"===n.get("text-rotation-alignment")&&"point"!==n.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&this.writingModes.indexOf(fs.vertical)>=0;for(var z=0,I=x.sections;z<I.length;z+=1){var C=I[z],B=wn(x.toString()),E=C.fontStack||k,M=c[E]=c[E]||{};this.calculateGlyphDependencies(C.text,M,S,this.allowVerticalPlacement,B);}}}}}"line"===n.get("symbol-placement")&&(this.features=function(t){var e={},r={},n=[],i=0;function a(e){n.push(t[e]),i++;}function o(t,e,i){var a=r[t];return delete r[t],r[e]=a,n[a].geometry[0].pop(),n[a].geometry[0]=n[a].geometry[0].concat(i[0]),a}function s(t,r,i){var a=e[r];return delete e[r],e[t]=a,n[a].geometry[0].shift(),n[a].geometry[0]=i[0].concat(n[a].geometry[0]),a}function u(t,e,r){var n=r?e[0][e[0].length-1]:e[0][0];return t+":"+n.x+":"+n.y}for(var l=0;l<t.length;l++){var p=t[l],c=p.geometry,h=p.text?p.text.toString():null;if(h){var f=u(h,c),y=u(h,c,!0);if(f in r&&y in e&&r[f]!==e[y]){var d=s(f,y,c),m=o(f,y,n[d].geometry);delete e[f],delete r[y],r[u(h,n[m].geometry,!0)]=m,n[d].geometry=null;}else f in r?o(f,y,c):y in e?s(f,y,c):(a(l),e[f]=i-1,r[y]=i-1);}else a(l);}return n.filter((function(t){return t.geometry}))}(this.features)),this.sortFeaturesByKey&&this.features.sort((function(t,e){return t.sortKey-e.sortKey}));}},Os.prototype.update=function(t,e,r){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r));},Os.prototype.isEmpty=function(){return 0===this.symbolInstances.length},Os.prototype.uploadPending=function(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},Os.prototype.upload=function(t){this.uploaded||(this.collisionBox.upload(t),this.collisionCircle.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;},Os.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.collisionBox.destroy(),this.collisionCircle.destroy();},Os.prototype.addToLineVertexArray=function(t,e){var r=this.lineVertexArray.length;if(void 0!==t.segment){for(var n=t.dist(e[t.segment+1]),i=t.dist(e[t.segment]),a={},o=t.segment+1;o<e.length;o++)a[o]={x:e[o].x,y:e[o].y,tileUnitDistanceFromAnchor:n},o<e.length-1&&(n+=e[o+1].dist(e[o]));for(var s=t.segment||0;s>=0;s--)a[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:i},s>0&&(i+=e[s-1].dist(e[s]));for(var u=0;u<e.length;u++){var l=a[u];this.lineVertexArray.emplaceBack(l.x,l.y,l.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}},Os.prototype.addSymbols=function(t,e,r,n,i,a,o,s,u,l){var p=this,c=t.indexArray,h=t.layoutVertexArray,f=t.dynamicLayoutVertexArray,y=t.segments.prepareSegment(4*e.length,t.layoutVertexArray,t.indexArray,a.sortKey),d=this.glyphOffsetArray.length,m=y.vertexLength,v=this.allowVerticalPlacement&&o===fs.vertical?Math.PI/2:0,g=function(t){var e=t.tl,n=t.tr,i=t.bl,a=t.br,o=t.tex,u=y.vertexLength,l=t.glyphOffset[1];Ps(h,s.x,s.y,e.x,l+e.y,o.x,o.y,r),Ps(h,s.x,s.y,n.x,l+n.y,o.x+o.w,o.y,r),Ps(h,s.x,s.y,i.x,l+i.y,o.x,o.y+o.h,r),Ps(h,s.x,s.y,a.x,l+a.y,o.x+o.w,o.y+o.h,r),Ts(f,s,v),c.emplaceBack(u,u+1,u+2),c.emplaceBack(u+1,u+2,u+3),y.vertexLength+=4,y.primitiveLength+=2,p.glyphOffsetArray.emplaceBack(t.glyphOffset[0]);};if(a.text&&a.text.sections){var x=a.text.sections;if(this.hasPaintOverrides){for(var b,_=function(e,r){void 0===b||b===e&&!r||t.programConfigurations.populatePaintArrays(t.layoutVertexArray.length,a,a.index,{},x[b]),b=e;},w=0,A=e;w<A.length;w+=1){var k=A[w];_(k.sectionIndex,!1),g(k);}_(b,!0);}else{for(var S=0,z=e;S<z.length;S+=1){g(z[S]);}t.programConfigurations.populatePaintArrays(t.layoutVertexArray.length,a,a.index,{},x[0]);}}else{for(var I=0,C=e;I<C.length;I+=1){g(C[I]);}t.programConfigurations.populatePaintArrays(t.layoutVertexArray.length,a,a.index,{});}t.placedSymbolArray.emplaceBack(s.x,s.y,d,this.glyphOffsetArray.length-d,m,u,l,s.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],o,0,!1,0);},Os.prototype._addCollisionDebugVertex=function(t,e,r,n,i,a){return e.emplaceBack(0,0),t.emplaceBack(r.x,r.y,n,i,Math.round(a.x),Math.round(a.y))},Os.prototype.addCollisionDebugVertices=function(t,e,r,n,a,o,s,u){var l=a.segments.prepareSegment(4,a.layoutVertexArray,a.indexArray),p=l.vertexLength,c=a.layoutVertexArray,h=a.collisionVertexArray,f=s.anchorX,y=s.anchorY;if(this._addCollisionDebugVertex(c,h,o,f,y,new i(t,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,n)),this._addCollisionDebugVertex(c,h,o,f,y,new i(t,n)),l.vertexLength+=4,u){var d=a.indexArray;d.emplaceBack(p,p+1,p+2),d.emplaceBack(p,p+2,p+3),l.primitiveLength+=2;}else{var m=a.indexArray;m.emplaceBack(p,p+1),m.emplaceBack(p+1,p+2),m.emplaceBack(p+2,p+3),m.emplaceBack(p+3,p),l.primitiveLength+=4;}},Os.prototype.addDebugCollisionBoxes=function(t,e,r){for(var n=t;n<e;n++){var i=this.collisionBoxArray.get(n),a=i.x1,o=i.y1,s=i.x2,u=i.y2,l=i.radius>0;this.addCollisionDebugVertices(a,o,s,u,l?this.collisionCircle:this.collisionBox,i.anchorPoint,r,l);}},Os.prototype.generateCollisionDebugBuffers=function(){for(var t=0;t<this.symbolInstances.length;t++){var e=this.symbolInstances.get(t);this.addDebugCollisionBoxes(e.textBoxStartIndex,e.textBoxEndIndex,e),this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex,e.verticalTextBoxEndIndex,e),this.addDebugCollisionBoxes(e.iconBoxStartIndex,e.iconBoxEndIndex,e);}},Os.prototype._deserializeCollisionBoxesForSymbol=function(t,e,r,n,i,a,o){for(var s={},u=e;u<r;u++){var l=t.get(u);if(0===l.radius){s.textBox={x1:l.x1,y1:l.y1,x2:l.x2,y2:l.y2,anchorPointX:l.anchorPointX,anchorPointY:l.anchorPointY},s.textFeatureIndex=l.featureIndex;break}s.textCircles||(s.textCircles=[],s.textFeatureIndex=l.featureIndex);s.textCircles.push(l.anchorPointX,l.anchorPointY,l.radius,l.signedDistanceFromAnchor,1);}for(var p=n;p<i;p++){var c=t.get(p);if(0===c.radius){s.verticalTextBox={x1:c.x1,y1:c.y1,x2:c.x2,y2:c.y2,anchorPointX:c.anchorPointX,anchorPointY:c.anchorPointY},s.verticalTextFeatureIndex=c.featureIndex;break}}for(var h=a;h<o;h++){var f=t.get(h);if(0===f.radius){s.iconBox={x1:f.x1,y1:f.y1,x2:f.x2,y2:f.y2,anchorPointX:f.anchorPointX,anchorPointY:f.anchorPointY},s.iconFeatureIndex=f.featureIndex;break}}return s},Os.prototype.deserializeCollisionBoxes=function(t){this.collisionArrays=[];for(var e=0;e<this.symbolInstances.length;e++){var r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.verticalTextBoxStartIndex,r.verticalTextBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex));}},Os.prototype.hasTextData=function(){return this.text.segments.get().length>0},Os.prototype.hasIconData=function(){return this.icon.segments.get().length>0},Os.prototype.hasCollisionBoxData=function(){return this.collisionBox.segments.get().length>0},Os.prototype.hasCollisionCircleData=function(){return this.collisionCircle.segments.get().length>0},Os.prototype.addIndicesForPlacedTextSymbol=function(t){for(var e=this.text.placedSymbolArray.get(t),r=e.vertexStartIndex+4*e.numGlyphs,n=e.vertexStartIndex;n<r;n+=4)this.text.indexArray.emplaceBack(n,n+1,n+2),this.text.indexArray.emplaceBack(n+1,n+2,n+3);},Os.prototype.getSortedSymbolIndexes=function(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;for(var e=Math.sin(t),r=Math.cos(t),n=[],i=[],a=[],o=0;o<this.symbolInstances.length;++o){a.push(o);var s=this.symbolInstances.get(o);n.push(0|Math.round(e*s.anchorX+r*s.anchorY)),i.push(s.featureIndex);}return a.sort((function(t,e){return n[t]-n[e]||i[e]-i[t]})),a},Os.prototype.sortFeatures=function(t){var e=this;if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(this.text.segments.get().length>1||this.icon.segments.get().length>1)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var r=0,n=this.symbolInstanceIndexes;r<n.length;r+=1){var i=n[r],a=this.symbolInstances.get(i);this.featureSortOrder.push(a.featureIndex),[a.rightJustifiedTextSymbolIndex,a.centerJustifiedTextSymbolIndex,a.leftJustifiedTextSymbolIndex].forEach((function(t,r,n){t>=0&&n.indexOf(t)===r&&e.addIndicesForPlacedTextSymbol(t);})),a.verticalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedTextSymbol(a.verticalPlacedTextSymbolIndex);var o=this.icon.placedSymbolArray.get(i);if(o.numGlyphs){var s=o.vertexStartIndex;this.icon.indexArray.emplaceBack(s,s+1,s+2),this.icon.indexArray.emplaceBack(s+1,s+2,s+3);}}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}},mn("SymbolBucket",Os,{omit:["layers","collisionBoxArray","features","compareText"]}),Os.MAX_GLYPHS=65535,Os.addDynamicAttributes=Ts;var Ls=new Gn({"symbol-placement":new qn(zt.layout_symbol["symbol-placement"]),"symbol-spacing":new qn(zt.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new qn(zt.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new Nn(zt.layout_symbol["symbol-sort-key"]),"symbol-z-order":new qn(zt.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new qn(zt.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new qn(zt.layout_symbol["icon-ignore-placement"]),"icon-optional":new qn(zt.layout_symbol["icon-optional"]),"icon-rotation-alignment":new qn(zt.layout_symbol["icon-rotation-alignment"]),"icon-size":new Nn(zt.layout_symbol["icon-size"]),"icon-text-fit":new qn(zt.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new qn(zt.layout_symbol["icon-text-fit-padding"]),"icon-image":new Nn(zt.layout_symbol["icon-image"]),"icon-rotate":new Nn(zt.layout_symbol["icon-rotate"]),"icon-padding":new qn(zt.layout_symbol["icon-padding"]),"icon-keep-upright":new qn(zt.layout_symbol["icon-keep-upright"]),"icon-offset":new Nn(zt.layout_symbol["icon-offset"]),"icon-anchor":new Nn(zt.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new qn(zt.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new qn(zt.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new qn(zt.layout_symbol["text-rotation-alignment"]),"text-field":new Nn(zt.layout_symbol["text-field"]),"text-font":new Nn(zt.layout_symbol["text-font"]),"text-size":new Nn(zt.layout_symbol["text-size"]),"text-max-width":new Nn(zt.layout_symbol["text-max-width"]),"text-line-height":new qn(zt.layout_symbol["text-line-height"]),"text-letter-spacing":new Nn(zt.layout_symbol["text-letter-spacing"]),"text-justify":new Nn(zt.layout_symbol["text-justify"]),"text-radial-offset":new Nn(zt.layout_symbol["text-radial-offset"]),"text-variable-anchor":new qn(zt.layout_symbol["text-variable-anchor"]),"text-anchor":new Nn(zt.layout_symbol["text-anchor"]),"text-max-angle":new qn(zt.layout_symbol["text-max-angle"]),"text-writing-mode":new qn(zt.layout_symbol["text-writing-mode"]),"text-rotate":new Nn(zt.layout_symbol["text-rotate"]),"text-padding":new qn(zt.layout_symbol["text-padding"]),"text-keep-upright":new qn(zt.layout_symbol["text-keep-upright"]),"text-transform":new Nn(zt.layout_symbol["text-transform"]),"text-offset":new Nn(zt.layout_symbol["text-offset"]),"text-allow-overlap":new qn(zt.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new qn(zt.layout_symbol["text-ignore-placement"]),"text-optional":new qn(zt.layout_symbol["text-optional"])}),Ds={paint:new Gn({"icon-opacity":new Nn(zt.paint_symbol["icon-opacity"]),"icon-color":new Nn(zt.paint_symbol["icon-color"]),"icon-halo-color":new Nn(zt.paint_symbol["icon-halo-color"]),"icon-halo-width":new Nn(zt.paint_symbol["icon-halo-width"]),"icon-halo-blur":new Nn(zt.paint_symbol["icon-halo-blur"]),"icon-translate":new qn(zt.paint_symbol["icon-translate"]),"icon-translate-anchor":new qn(zt.paint_symbol["icon-translate-anchor"]),"text-opacity":new Nn(zt.paint_symbol["text-opacity"]),"text-color":new Nn(zt.paint_symbol["text-color"],{runtimeType:Ut,getOverride:function(t){return t.textColor},hasOverride:function(t){return !!t.textColor}}),"text-halo-color":new Nn(zt.paint_symbol["text-halo-color"]),"text-halo-width":new Nn(zt.paint_symbol["text-halo-width"]),"text-halo-blur":new Nn(zt.paint_symbol["text-halo-blur"]),"text-translate":new qn(zt.paint_symbol["text-translate"]),"text-translate-anchor":new qn(zt.paint_symbol["text-translate-anchor"])}),layout:Ls},Us=function(t){this.type=t.property.overrides?t.property.overrides.runtimeType:Ft,this.defaultValue=t;};Us.prototype.evaluate=function(t){if(t.formattedSection){var e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default},Us.prototype.eachChild=function(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression);},Us.prototype.possibleOutputs=function(){return [void 0]},Us.prototype.serialize=function(){return null},mn("FormatSectionOverride",Us,{omit:["defaultValue"]});var Rs=function(t){function e(e){t.call(this,e,Ds);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){if(t.prototype.recalculate.call(this,e),"auto"===this.layout.get("icon-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment")),"point"===this.layout.get("symbol-placement")){var r=this.layout.get("text-writing-mode");if(r){for(var n=[],i=0,a=r;i<a.length;i+=1){var o=a[i];n.indexOf(o)<0&&n.push(o);}this.layout._values["text-writing-mode"]=n;}else this.layout._values["text-writing-mode"]=["horizontal"];}this._setPaintOverrides();},e.prototype.getValueAndResolveTokens=function(t,e){var r=this.layout.get(t).evaluate(e,{}),n=this._unevaluatedLayout._values[t];return n.isDataDriven()||kr(n.value)?r:function(t,e){return e.replace(/{([^{}]+)}/g,(function(e,r){return r in t?String(t[r]):""}))}(e.properties,r)},e.prototype.createBucket=function(t){return new Os(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype._setPaintOverrides=function(){for(var t=0,r=Ds.paint.overridableProperties;t<r.length;t+=1){var n=r[t];if(e.hasPaintOverride(this.layout,n)){var i=this.paint.get(n),a=new Us(i),o=new Ar(a,i.property.specification),s=null;s="constant"===i.value.kind||"source"===i.value.kind?new zr("source",o):new Ir("composite",o,i.value.zoomStops,i.value._interpolationType),this.paint._values[n]=new Rn(i.property,s,i.parameters);}}},e.prototype._handleOverridablePaintPropertyUpdate=function(t,r,n){return !(!this.layout||r.isDataDriven()||n.isDataDriven())&&e.hasPaintOverride(this.layout,t)},e.hasPaintOverride=function(t,e){var r=t.get("text-field"),n=Ds.paint.properties[e],i=!1,a=function(t){for(var e=0,r=t;e<r.length;e+=1){var a=r[e];if(n.overrides&&n.overrides.hasOverride(a))return void(i=!0)}};if("constant"===r.value.kind&&r.value.value instanceof Wt)a(r.value.value.sections);else if("source"===r.value.kind){var o=function(t){if(!i)if(t instanceof re&&te(t.value)===Nt){var e=t.value;a(e.sections);}else t instanceof oe?a(t.sections):t.eachChild(o);},s=r.value;s._styleExpression&&o(s._styleExpression.expression);}return i},e.hasPaintOverrides=function(t){for(var r=0,n=Ds.paint.overridableProperties;r<n.length;r+=1){var i=n[r];if(e.hasPaintOverride(t,i))return !0}return !1},e}(Jn),js={paint:new Gn({"background-color":new qn(zt.paint_background["background-color"]),"background-pattern":new Zn(zt.paint_background["background-pattern"]),"background-opacity":new qn(zt.paint_background["background-opacity"])})},qs=function(t){function e(e){t.call(this,e,js);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Jn),Ns={paint:new Gn({"raster-opacity":new qn(zt.paint_raster["raster-opacity"]),"raster-hue-rotate":new qn(zt.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new qn(zt.paint_raster["raster-brightness-min"]),"raster-brightness-max":new qn(zt.paint_raster["raster-brightness-max"]),"raster-saturation":new qn(zt.paint_raster["raster-saturation"]),"raster-contrast":new qn(zt.paint_raster["raster-contrast"]),"raster-resampling":new qn(zt.paint_raster["raster-resampling"]),"raster-fade-duration":new qn(zt.paint_raster["raster-fade-duration"])})},Ks=function(t){function e(e){t.call(this,e,Ns);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Jn);var Zs=function(t){function e(e){t.call(this,e,{}),this.implementation=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.is3D=function(){return "3d"===this.implementation.renderingMode},e.prototype.hasOffscreenPass=function(){return void 0!==this.implementation.prerender},e.prototype.recalculate=function(){},e.prototype.updateTransitions=function(){},e.prototype.hasTransition=function(){},e.prototype.serialize=function(){},e.prototype.onAdd=function(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);},e.prototype.onRemove=function(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl);},e}(Jn),Xs={circle:Ba,heatmap:Ua,hillshade:ja,fill:Co,"fill-extrusion":Xo,line:ns,symbol:Rs,background:qs,raster:Ks};function Gs(t){for(var e=0,r=0,n=0,i=t;n<i.length;n+=1){var a=i[n];e+=a.w*a.h,r=Math.max(r,a.w);}t.sort((function(t,e){return e.h-t.h}));for(var o=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}],s=0,u=0,l=0,p=t;l<p.length;l+=1)for(var c=p[l],h=o.length-1;h>=0;h--){var f=o[h];if(!(c.w>f.w||c.h>f.h)){if(c.x=f.x,c.y=f.y,u=Math.max(u,c.y+c.h),s=Math.max(s,c.x+c.w),c.w===f.w&&c.h===f.h){var y=o.pop();h<o.length&&(o[h]=y);}else c.h===f.h?(f.x+=c.w,f.w-=c.w):c.w===f.w?(f.y+=c.h,f.h-=c.h):(o.push({x:f.x+c.w,y:f.y,w:f.w-c.w,h:c.h}),f.y+=c.h,f.h-=c.h);break}}return {w:s,h:u,fill:e/(s*u)||0}}var Js=function(t,e){var r=e.pixelRatio,n=e.version;this.paddedRect=t,this.pixelRatio=r,this.version=n;},Hs={tl:{configurable:!0},br:{configurable:!0},tlbr:{configurable:!0},displaySize:{configurable:!0}};Hs.tl.get=function(){return [this.paddedRect.x+1,this.paddedRect.y+1]},Hs.br.get=function(){return [this.paddedRect.x+this.paddedRect.w-1,this.paddedRect.y+this.paddedRect.h-1]},Hs.tlbr.get=function(){return this.tl.concat(this.br)},Hs.displaySize.get=function(){return [(this.paddedRect.w-2)/this.pixelRatio,(this.paddedRect.h-2)/this.pixelRatio]},Object.defineProperties(Js.prototype,Hs);var Ys=function(t,e){var r={},n={};this.haveRenderCallbacks=[];var i=[];this.addImages(t,r,i),this.addImages(e,n,i);var a=Gs(i),o=a.w,s=a.h,u=new Oa({width:o||1,height:s||1});for(var l in t){var p=t[l],c=r[l].paddedRect;Oa.copy(p.data,u,{x:0,y:0},{x:c.x+1,y:c.y+1},p.data);}for(var h in e){var f=e[h],y=n[h].paddedRect,d=y.x+1,m=y.y+1,v=f.data.width,g=f.data.height;Oa.copy(f.data,u,{x:0,y:0},{x:d,y:m},f.data),Oa.copy(f.data,u,{x:0,y:g-1},{x:d,y:m-1},{width:v,height:1}),Oa.copy(f.data,u,{x:0,y:0},{x:d,y:m+g},{width:v,height:1}),Oa.copy(f.data,u,{x:v-1,y:0},{x:d-1,y:m},{width:1,height:g}),Oa.copy(f.data,u,{x:0,y:0},{x:d+v,y:m},{width:1,height:g});}this.image=u,this.iconPositions=r,this.patternPositions=n;};Ys.prototype.addImages=function(t,e,r){for(var n in t){var i=t[n],a={x:0,y:0,w:i.data.width+2,h:i.data.height+2};r.push(a),e[n]=new Js(a,i),i.hasRenderCallback&&this.haveRenderCallbacks.push(n);}},Ys.prototype.patchUpdatedImages=function(t,e){for(var r in t.dispatchRenderCallbacks(this.haveRenderCallbacks),t.updatedImages)this.patchUpdatedImage(this.iconPositions[r],t.getImage(r),e),this.patchUpdatedImage(this.patternPositions[r],t.getImage(r),e);},Ys.prototype.patchUpdatedImage=function(t,e,r){if(t&&e&&t.version!==e.version){t.version=e.version;var n=t.tl,i=n[0],a=n[1];r.update(e.data,void 0,{x:i,y:a});}},mn("ImagePosition",Js),mn("ImageAtlas",Ys);var $s=self.HTMLImageElement,Ws=self.HTMLCanvasElement,Qs=self.HTMLVideoElement,tu=self.ImageData,eu=function(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);};eu.prototype.update=function(t,e,r){var n=t.width,i=t.height,a=!(this.size&&this.size[0]===n&&this.size[1]===i||r),o=this.context,s=o.gl;if(this.useMipmap=Boolean(e&&e.useMipmap),s.bindTexture(s.TEXTURE_2D,this.texture),o.pixelStoreUnpackFlipY.set(!1),o.pixelStoreUnpack.set(1),o.pixelStoreUnpackPremultiplyAlpha.set(this.format===s.RGBA&&(!e||!1!==e.premultiply)),a)this.size=[n,i],t instanceof $s||t instanceof Ws||t instanceof Qs||t instanceof tu?s.texImage2D(s.TEXTURE_2D,0,this.format,this.format,s.UNSIGNED_BYTE,t):s.texImage2D(s.TEXTURE_2D,0,this.format,n,i,0,this.format,s.UNSIGNED_BYTE,t.data);else{var u=r||{x:0,y:0},l=u.x,p=u.y;t instanceof $s||t instanceof Ws||t instanceof Qs||t instanceof tu?s.texSubImage2D(s.TEXTURE_2D,0,l,p,s.RGBA,s.UNSIGNED_BYTE,t):s.texSubImage2D(s.TEXTURE_2D,0,l,p,n,i,s.RGBA,s.UNSIGNED_BYTE,t.data);}this.useMipmap&&this.isSizePowerOfTwo()&&s.generateMipmap(s.TEXTURE_2D);},eu.prototype.bind=function(t,e,r){var n=this.context.gl;n.bindTexture(n.TEXTURE_2D,this.texture),r!==n.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(r=n.LINEAR),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,r||t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);},eu.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},eu.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null;};var ru=function(t,e,r,n,i){var a,o,s=8*i-n-1,u=(1<<s)-1,l=u>>1,p=-7,c=r?i-1:0,h=r?-1:1,f=t[e+c];for(c+=h,a=f&(1<<-p)-1,f>>=-p,p+=s;p>0;a=256*a+t[e+c],c+=h,p-=8);for(o=a&(1<<-p)-1,a>>=-p,p+=n;p>0;o=256*o+t[e+c],c+=h,p-=8);if(0===a)a=1-l;else{if(a===u)return o?NaN:1/0*(f?-1:1);o+=Math.pow(2,n),a-=l;}return (f?-1:1)*o*Math.pow(2,a-n)},nu=function(t,e,r,n,i,a){var o,s,u,l=8*a-i-1,p=(1<<l)-1,c=p>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:a-1,y=n?1:-1,d=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=p):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),(e+=o+c>=1?h/u:h*Math.pow(2,1-c))*u>=2&&(o++,u/=2),o+c>=p?(s=0,o=p):o+c>=1?(s=(e*u-1)*Math.pow(2,i),o+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,i),o=0));i>=8;t[r+f]=255&s,f+=y,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;t[r+f]=255&o,f+=y,o/=256,l-=8);t[r+f-y]|=128*d;},iu=au;function au(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}au.Varint=0,au.Fixed64=1,au.Bytes=2,au.Fixed32=5;function ou(t){return t.type===au.Bytes?t.readVarint()+t.pos:t.pos+1}function su(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function uu(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function lu(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function pu(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function cu(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function hu(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function fu(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function yu(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function du(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function mu(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function vu(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function gu(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function xu(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function bu(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}au.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,a=this.pos;this.type=7&n,t(i,e,this),this.pos===a&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=gu(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=bu(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=gu(this.buf,this.pos)+4294967296*gu(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=gu(this.buf,this.pos)+4294967296*bu(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=ru(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=ru(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,a=r.buf;if(i=a[r.pos++],n=(112&i)>>4,i<128)return su(t,n,e);if(i=a[r.pos++],n|=(127&i)<<3,i<128)return su(t,n,e);if(i=a[r.pos++],n|=(127&i)<<10,i<128)return su(t,n,e);if(i=a[r.pos++],n|=(127&i)<<17,i<128)return su(t,n,e);if(i=a[r.pos++],n|=(127&i)<<24,i<128)return su(t,n,e);if(i=a[r.pos++],n|=(1&i)<<31,i<128)return su(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=function(t,e,r){var n="",i=e;for(;i<r;){var a,o,s,u=t[i],l=null,p=u>239?4:u>223?3:u>191?2:1;if(i+p>r)break;1===p?u<128&&(l=u):2===p?128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)<=127&&(l=null):3===p?(a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&((l=(15&u)<<12|(63&a)<<6|63&o)<=2047||l>=55296&&l<=57343)&&(l=null)):4===p&&(a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&((l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,p=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=p;}return n}(this.buf,this.pos,t);return this.pos=t,e},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==au.Bytes)return t.push(this.readVarint(e));var r=ou(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==au.Bytes)return t.push(this.readSVarint());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==au.Bytes)return t.push(this.readBoolean());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==au.Bytes)return t.push(this.readFloat());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==au.Bytes)return t.push(this.readDouble());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==au.Bytes)return t.push(this.readFixed32());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==au.Bytes)return t.push(this.readSFixed32());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==au.Bytes)return t.push(this.readFixed64());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==au.Bytes)return t.push(this.readSFixed64());var e=ou(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===au.Varint)for(;this.buf[this.pos++]>127;);else if(e===au.Bytes)this.pos=this.readVarint()+this.pos;else if(e===au.Fixed32)this.pos+=4;else{if(e!==au.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),xu(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),xu(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),xu(this.buf,-1&t,this.pos),xu(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),xu(this.buf,-1&t,this.pos),xu(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos]=127&t;}(r,0,e),function(t,e){var r=(7&t)<<4;if(e.buf[e.pos++]|=r|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t;}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,a=0;a<e.length;a++){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){n>56319||a+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&uu(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),nu(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),nu(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&uu(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,au.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,lu,e);},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,pu,e);},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,fu,e);},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,cu,e);},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,hu,e);},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,yu,e);},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,du,e);},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,mu,e);},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,vu,e);},writeBytesField:function(t,e){this.writeTag(t,au.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,au.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,au.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,au.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,au.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,au.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,au.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,au.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,au.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,au.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var _u=3;function wu(t,e,r){1===t&&r.readMessage(Au,e);}function Au(t,e,r){if(3===t){var n=r.readMessage(ku,{}),i=n.id,a=n.bitmap,o=n.width,s=n.height,u=n.left,l=n.top,p=n.advance;e.push({id:i,bitmap:new Fa({width:o+2*_u,height:s+2*_u},a),metrics:{width:o,height:s,left:u,top:l,advance:p}});}}function ku(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}var Su=_u,zu=function(t){var e=this;this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=function(){e._triggered=!1,e._callback();});};zu.prototype.trigger=function(){var t=this;this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout((function(){t._triggered=!1,t._callback();}),0));};var Iu=function(t,e,r){this.target=t,this.parent=e,this.mapId=r,this.callbacks={},this.tasks={},this.taskQueue=[],this.cancelCallbacks={},m(["receive","process"],this),this.invoker=new zu(this.process),this.target.addEventListener("message",this.receive,!1);};function Cu(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}Iu.prototype.send=function(t,e,r,n){var i=this,a=Math.round(1e18*Math.random()).toString(36).substring(0,10);r&&(this.callbacks[a]=r);var o=[];return this.target.postMessage({id:a,type:t,hasCallback:!!r,targetMapId:n,sourceMapId:this.mapId,data:gn(e,o)},o),{cancel:function(){r&&delete i.callbacks[a],i.target.postMessage({id:a,type:"<cancel>",targetMapId:n,sourceMapId:i.mapId});}}},Iu.prototype.receive=function(t){var e=t.data,r=e.id;if(r&&(!e.targetMapId||this.mapId===e.targetMapId))if("<cancel>"===e.type){delete this.tasks[r];var n=this.cancelCallbacks[r];delete this.cancelCallbacks[r],n&&n();}else this.tasks[r]=e,this.taskQueue.push(r),this.invoker.trigger();},Iu.prototype.process=function(){var t=this;if(this.taskQueue.length){var e=this.taskQueue.shift(),r=this.tasks[e];if(delete this.tasks[e],this.taskQueue.length&&this.invoker.trigger(),r)if("<response>"===r.type){var n=this.callbacks[e];delete this.callbacks[e],n&&(r.error?n(xn(r.error)):n(null,xn(r.data)));}else{var i=!1,a=r.hasCallback?function(r,n){i=!0,delete t.cancelCallbacks[e];var a=[];t.target.postMessage({id:e,type:"<response>",sourceMapId:t.mapId,error:r?gn(r):null,data:gn(n,a)},a);}:function(t){i=!0;},o=null,s=xn(r.data);if(this.parent[r.type])o=this.parent[r.type](r.sourceMapId,s,a);else if(this.parent.getWorkerSource){var u=r.type.split(".");o=this.parent.getWorkerSource(r.sourceMapId,u[0],s.source)[u[1]](s,a);}else a(new Error("Could not find function "+r.type));!i&&o&&o.cancel&&(this.cancelCallbacks[e]=o.cancel);}}},Iu.prototype.remove=function(){this.target.removeEventListener("message",this.receive,!1);};var Bu=function(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));};Bu.prototype.setNorthEast=function(t){return this._ne=t instanceof Eu?new Eu(t.lng,t.lat):Eu.convert(t),this},Bu.prototype.setSouthWest=function(t){return this._sw=t instanceof Eu?new Eu(t.lng,t.lat):Eu.convert(t),this},Bu.prototype.extend=function(t){var e,r,n=this._sw,i=this._ne;if(t instanceof Eu)e=t,r=t;else{if(!(t instanceof Bu))return Array.isArray(t)?t.every(Array.isArray)?this.extend(Bu.convert(t)):this.extend(Eu.convert(t)):this;if(e=t._sw,r=t._ne,!e||!r)return this}return n||i?(n.lng=Math.min(e.lng,n.lng),n.lat=Math.min(e.lat,n.lat),i.lng=Math.max(r.lng,i.lng),i.lat=Math.max(r.lat,i.lat)):(this._sw=new Eu(e.lng,e.lat),this._ne=new Eu(r.lng,r.lat)),this},Bu.prototype.getCenter=function(){return new Eu((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},Bu.prototype.getSouthWest=function(){return this._sw},Bu.prototype.getNorthEast=function(){return this._ne},Bu.prototype.getNorthWest=function(){return new Eu(this.getWest(),this.getNorth())},Bu.prototype.getSouthEast=function(){return new Eu(this.getEast(),this.getSouth())},Bu.prototype.getWest=function(){return this._sw.lng},Bu.prototype.getSouth=function(){return this._sw.lat},Bu.prototype.getEast=function(){return this._ne.lng},Bu.prototype.getNorth=function(){return this._ne.lat},Bu.prototype.toArray=function(){return [this._sw.toArray(),this._ne.toArray()]},Bu.prototype.toString=function(){return "LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},Bu.prototype.isEmpty=function(){return !(this._sw&&this._ne)},Bu.convert=function(t){return !t||t instanceof Bu?t:new Bu(t)};var Eu=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};Eu.prototype.wrap=function(){return new Eu(p(this.lng,-180,180),this.lat)},Eu.prototype.toArray=function(){return [this.lng,this.lat]},Eu.prototype.toString=function(){return "LngLat("+this.lng+", "+this.lat+")"},Eu.prototype.toBounds=function(t){void 0===t&&(t=0);var e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new Bu(new Eu(this.lng-r,this.lat-e),new Eu(this.lng+r,this.lat+e))},Eu.convert=function(t){if(t instanceof Eu)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new Eu(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new Eu(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var Mu=2*Math.PI*6378137;function Pu(t){return Mu*Math.cos(t*Math.PI/180)}function Tu(t){return (180+t)/360}function Vu(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Fu(t,e){return t/Pu(e)}function Ou(t){var e=180-360*t;return 360/Math.PI*Math.atan(Math.exp(e*Math.PI/180))-90}var Lu=function(t,e,r){void 0===r&&(r=0),this.x=+t,this.y=+e,this.z=+r;};Lu.fromLngLat=function(t,e){void 0===e&&(e=0);var r=Eu.convert(t);return new Lu(Tu(r.lng),Vu(r.lat),Fu(e,r.lat))},Lu.prototype.toLngLat=function(){return new Eu(360*this.x-180,Ou(this.y))},Lu.prototype.toAltitude=function(){return t=this.z,e=this.y,t*Pu(Ou(e));var t,e;},Lu.prototype.meterInMercatorCoordinateUnits=function(){return 1/Mu*(t=Ou(this.y),1/Math.cos(t*Math.PI/180));var t;};var Du=function(t,e,r){this.z=t,this.x=e,this.y=r,this.key=ju(0,t,e,r);};Du.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},Du.prototype.url=function(t,e){var r,n,i,a,o,s=(r=this.x,n=this.y,i=this.z,a=Cu(256*r,256*(n=Math.pow(2,i)-n-1),i),o=Cu(256*(r+1),256*(n+1),i),a[0]+","+a[1]+","+o[0]+","+o[1]),u=function(t,e,r){for(var n,i="",a=t;a>0;a--)i+=(e&(n=1<<a-1)?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",u).replace("{bbox-epsg-3857}",s)},Du.prototype.getTilePoint=function(t){var e=Math.pow(2,this.z);return new i((t.x*e-this.x)*na,(t.y*e-this.y)*na)};var Uu=function(t,e){this.wrap=t,this.canonical=e,this.key=ju(t,e.z,e.x,e.y);},Ru=function(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new Du(r,+n,+i),this.key=ju(e,t,n,i);};function ju(t,e,r,n){(t*=2)<0&&(t=-1*t-1);var i=1<<e;return 32*(i*i*t+i*n+r)+e}Ru.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},Ru.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new Ru(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new Ru(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},Ru.prototype.isChildOf=function(t){if(t.wrap!==this.wrap)return !1;var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},Ru.prototype.children=function(t){if(this.overscaledZ>=t)return [new Ru(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new Ru(e,this.wrap,e,r,n),new Ru(e,this.wrap,e,r+1,n),new Ru(e,this.wrap,e,r,n+1),new Ru(e,this.wrap,e,r+1,n+1)]},Ru.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},Ru.prototype.wrapped=function(){return new Ru(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},Ru.prototype.unwrapTo=function(t){return new Ru(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},Ru.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},Ru.prototype.toUnwrapped=function(){return new Uu(this.wrap,this.canonical)},Ru.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},Ru.prototype.getTilePoint=function(t){return this.canonical.getTilePoint(new Lu(t.x-this.wrap,t.y))},mn("CanonicalTileID",Du),mn("OverscaledTileID",Ru,{omit:["posMatrix"]});var qu=function(t,e,r){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return w('"'+r+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');var n=this.dim=e.height;this.stride=this.dim+2,this.data=new Int32Array(this.stride*this.stride);for(var i=e.data,a="terrarium"===r?this._unpackTerrarium:this._unpackMapbox,o=0;o<n;o++)for(var s=0;s<n;s++){var u=4*(o*n+s);this.set(s,o,a(i[u],i[u+1],i[u+2]));}for(var l=0;l<n;l++)this.set(-1,l,this.get(0,l)),this.set(n,l,this.get(n-1,l)),this.set(l,-1,this.get(l,0)),this.set(l,n,this.get(l,n-1));this.set(-1,-1,this.get(0,0)),this.set(n,-1,this.get(n-1,0)),this.set(-1,n,this.get(0,n-1)),this.set(n,n,this.get(n-1,n-1));};qu.prototype.set=function(t,e,r){this.data[this._idx(t,e)]=r+65536;},qu.prototype.get=function(t,e){return this.data[this._idx(t,e)]-65536},qu.prototype._idx=function(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)},qu.prototype._unpackMapbox=function(t,e,r){return (256*t*256+256*e+r)/10-1e4},qu.prototype._unpackTerrarium=function(t,e,r){return 256*t+e+r/256-32768},qu.prototype.getPixels=function(){return new Oa({width:this.stride,height:this.stride},new Uint8Array(this.data.buffer))},qu.prototype.backfillBorder=function(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var n=e*this.dim,i=e*this.dim+this.dim,a=r*this.dim,o=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:a=o-1;break;case 1:o=a+1;}for(var s=-e*this.dim,u=-r*this.dim,l=a;l<o;l++)for(var p=n;p<i;p++)this.set(p,l,t.get(p+s,l+u));},mn("DEMData",qu);var Nu=Wn([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);var Ku=function(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}};Ku.prototype.encode=function(t){return this._stringToNumber[t]},Ku.prototype.decode=function(t){return this._numberToString[t]};var Zu=function(t,e,r,n){this.type="Feature",this._vectorTileFeature=t,t._z=e,t._x=r,t._y=n,this.properties=t.properties,null!=t.id&&(this.id=t.id);},Xu={geometry:{configurable:!0}};Xu.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},Xu.geometry.set=function(t){this._geometry=t;},Zu.prototype.toJSON=function(){var t={geometry:this.geometry};for(var e in this)"_geometry"!==e&&"_vectorTileFeature"!==e&&(t[e]=this[e]);return t},Object.defineProperties(Zu.prototype,Xu);var Gu=function(){this.state={},this.stateChanges={},this.deletedStates={};};Gu.prototype.updateState=function(t,e,r){var n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},c(this.stateChanges[t][n],r),null===this.deletedStates[t])for(var i in this.deletedStates[t]={},this.state[t])i!==n&&(this.deletedStates[t][i]=null);else if(this.deletedStates[t]&&null===this.deletedStates[t][n])for(var a in this.deletedStates[t][n]={},this.state[t][n])r[a]||(this.deletedStates[t][n][a]=null);else for(var o in r){this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][o]&&delete this.deletedStates[t][n][o];}},Gu.prototype.removeFeatureState=function(t,e,r){if(!(null===this.deletedStates[t])){var n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&void 0!==e&&e>=0)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(void 0!==e&&e>=0){if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;}else this.deletedStates[t]=null;}},Gu.prototype.getState=function(t,e){var r=String(e),n=this.state[t]||{},i=this.stateChanges[t]||{},a=c({},n[r],i[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){var o=this.deletedStates[t][e];if(null===o)return {};for(var s in o)delete a[s];}return a},Gu.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e);},Gu.prototype.coalesceChanges=function(t,e){var r={};for(var n in this.stateChanges){this.state[n]=this.state[n]||{};var i={};for(var a in this.stateChanges[n])this.state[n][a]||(this.state[n][a]={}),c(this.state[n][a],this.stateChanges[n][a]),i[a]=this.state[n][a];r[n]=i;}for(var o in this.deletedStates){this.state[o]=this.state[o]||{};var s={};if(null===this.deletedStates[o])for(var u in this.state[o])s[u]={},this.state[o][u]={};else for(var l in this.deletedStates[o]){if(null===this.deletedStates[o][l])this.state[o][l]={};else for(var p=0,h=Object.keys(this.deletedStates[o][l]);p<h.length;p+=1){var f=h[p];delete this.state[o][l][f];}s[l]=this.state[o][l];}r[o]=r[o]||{},c(r[o],s);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(var y in t){t[y].setFeatureState(r,e);}};var Ju=function(t,e,r){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=e||new cn(na,16,0),this.grid3D=new cn(na,16,0),this.featureIndexArray=r||new Pi;};function Hu(t){for(var e=1/0,r=1/0,n=-1/0,i=-1/0,a=0,o=t;a<o.length;a+=1){var s=o[a];e=Math.min(e,s.x),r=Math.min(r,s.y),n=Math.max(n,s.x),i=Math.max(i,s.y);}return {minX:e,minY:r,maxX:n,maxY:i}}function Yu(t,e){return e-t}Ju.prototype.insert=function(t,e,r,n,i,a){var o=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i);for(var s=a?this.grid3D:this.grid,u=0;u<e.length;u++){for(var l=e[u],p=[1/0,1/0,-1/0,-1/0],c=0;c<l.length;c++){var h=l[c];p[0]=Math.min(p[0],h.x),p[1]=Math.min(p[1],h.y),p[2]=Math.max(p[2],h.x),p[3]=Math.max(p[3],h.y);}p[0]<na&&p[1]<na&&p[2]>=0&&p[3]>=0&&s.insert(o,p[0],p[1],p[2],p[3]);}},Ju.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new Do.VectorTile(new iu(this.rawTileData)).layers,this.sourceLayerCoder=new Ku(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},Ju.prototype.query=function(t,e,r){var n=this;this.loadVTLayers();for(var a=t.params||{},o=na/t.tileSize/t.scale,s=Dr(a.filter),u=t.queryGeometry,l=t.queryPadding*o,p=Hu(u),c=this.grid.query(p.minX-l,p.minY-l,p.maxX+l,p.maxY+l),h=Hu(t.cameraQueryGeometry),f=this.grid3D.query(h.minX-l,h.minY-l,h.maxX+l,h.maxY+l,(function(e,r,n,a){return function(t,e,r,n,a){for(var o=0,s=t;o<s.length;o+=1){var u=s[o];if(e<=u.x&&r<=u.y&&n>=u.x&&a>=u.y)return !0}var l=[new i(e,r),new i(e,a),new i(n,a),new i(n,r)];if(t.length>2)for(var p=0,c=l;p<c.length;p+=1){if(ga(t,c[p]))return !0}for(var h=0;h<t.length-1;h++){if(xa(t[h],t[h+1],l))return !0}return !1}(t.cameraQueryGeometry,e-l,r-l,n+l,a+l)})),y=0,d=f;y<d.length;y+=1){var m=d[y];c.push(m);}c.sort(Yu);for(var v,g={},x=function(i){var l=c[i];if(l!==v){v=l;var p=n.featureIndexArray.get(l),h=null;n.loadMatchingFeature(g,p.bucketIndex,p.sourceLayerIndex,p.featureIndex,s,a.layers,e,(function(e,i){h||(h=oa(e));var a={};return e.id&&(a=r.getState(i.sourceLayer||"_geojsonTileLayer",e.id)),i.queryIntersectsFeature(u,e,a,h,n.z,t.transform,o,t.pixelPosMatrix)}));}},b=0;b<c.length;b++)x(b);return g},Ju.prototype.loadMatchingFeature=function(t,e,r,n,i,a,o,s){var u=this.bucketLayerIDs[e];if(!a||function(t,e){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(a,u)){var l=this.sourceLayerCoder.decode(r),p=this.vtLayers[l].feature(n);if(i(new Tn(this.tileID.overscaledZ),p))for(var c=0;c<u.length;c++){var h=u[c];if(!(a&&a.indexOf(h)<0)){var f=o[h];if(f){var y=!s||s(p,f);if(y){var d=new Zu(p,this.z,this.x,this.y);d.layer=f.serialize();var m=t[h];void 0===m&&(m=t[h]=[]),m.push({featureIndex:n,feature:d,intersectionZ:y});}}}}}},Ju.prototype.lookupSymbolFeatures=function(t,e,r,n,i,a){var o={};this.loadVTLayers();for(var s=Dr(n),u=0,l=t;u<l.length;u+=1){var p=l[u];this.loadMatchingFeature(o,e,r,p,s,i,a);}return o},Ju.prototype.hasLayer=function(t){for(var e=0,r=this.bucketLayerIDs;e<r.length;e+=1)for(var n=0,i=r[e];n<i.length;n+=1){if(t===i[n])return !0}return !1},mn("FeatureIndex",Ju,{omit:["rawTileData","sourceLayerCoder"]});var $u=function(t,e){this.tileID=t,this.uid=f(),this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.expiredRequestCount=0,this.state="loading";};$u.prototype.registerFadeDuration=function(t){var e=t+this.timeAdded;e<V.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);},$u.prototype.wasRequested=function(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state},$u.prototype.loadVectorData=function(t,e,r){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var n in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var r={};if(!e)return r;for(var n=function(){var t=a[i],n=t.layerIds.map((function(t){return e.getLayer(t)})).filter(Boolean);if(0!==n.length){t.layers=n,t.stateDependentLayerIds&&(t.stateDependentLayers=t.stateDependentLayerIds.map((function(t){return n.filter((function(e){return e.id===t}))[0]})));for(var o=0,s=n;o<s.length;o+=1){var u=s[o];r[u.id]=t;}}},i=0,a=t;i<a.length;i+=1)n();return r}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets){var i=this.buckets[n];if(i instanceof Os){if(this.hasSymbolBuckets=!0,!r)break;i.justReloaded=!0;}}for(var a in this.queryPadding=0,this.buckets){var o=this.buckets[a];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(a).queryRadius(o));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage);}else this.collisionBoxArray=new wi;},$u.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.imageAtlas&&(this.imageAtlas=null),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded";},$u.prototype.unloadDEMData=function(){this.dem=null,this.neighboringTiles=null,this.state="unloaded";},$u.prototype.getBucket=function(t){return this.buckets[t.id]},$u.prototype.upload=function(t){for(var e in this.buckets){var r=this.buckets[e];r.uploadPending()&&r.upload(t);}var n=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new eu(t,this.imageAtlas.image,n.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new eu(t,this.glyphAtlasImage,n.ALPHA),this.glyphAtlasImage=null);},$u.prototype.prepare=function(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture);},$u.prototype.queryRenderedFeatures=function(t,e,r,n,i,a,o,s,u){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:r,cameraQueryGeometry:n,scale:i,tileSize:this.tileSize,pixelPosMatrix:u,transform:o,params:a,queryPadding:this.queryPadding*s},t,e):{}},$u.prototype.querySourceFeatures=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData){var r=this.latestFeatureIndex.loadVTLayers(),n=e?e.sourceLayer:"",i=r._geojsonTileLayer||r[n];if(i)for(var a=Dr(e&&e.filter),o=this.tileID.canonical,s=o.z,u=o.x,l=o.y,p={z:s,x:u,y:l},c=0;c<i.length;c++){var h=i.feature(c);if(a(new Tn(this.tileID.overscaledZ),h)){var f=new Zu(h,s,u,l);f.tile=p,t.push(f);}}}},$u.prototype.clearMask=function(){this.segments&&(this.segments.destroy(),delete this.segments),this.maskedBoundsBuffer&&(this.maskedBoundsBuffer.destroy(),delete this.maskedBoundsBuffer),this.maskedIndexBuffer&&(this.maskedIndexBuffer.destroy(),delete this.maskedIndexBuffer);},$u.prototype.setMask=function(t,e){if(!o(this.mask,t)&&(this.mask=t,this.clearMask(),!o(t,{0:!0}))){var r=new ei,n=new mi;this.segments=new Vi,this.segments.prepareSegment(0,r,n);for(var a=Object.keys(t),s=0;s<a.length;s++){var u=t[+a[s]],l=na>>u.z,p=new i(u.x*l,u.y*l),c=new i(p.x+l,p.y+l),h=this.segments.prepareSegment(4,r,n);r.emplaceBack(p.x,p.y,p.x,p.y),r.emplaceBack(c.x,p.y,c.x,p.y),r.emplaceBack(p.x,c.y,p.x,c.y),r.emplaceBack(c.x,c.y,c.x,c.y);var f=h.vertexLength;n.emplaceBack(f,f+1,f+2),n.emplaceBack(f+1,f+2,f+3),h.vertexLength+=4,h.primitiveLength+=2;}this.maskedBoundsBuffer=e.createVertexBuffer(r,Nu.members),this.maskedIndexBuffer=e.createIndexBuffer(n);}},$u.prototype.hasData=function(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state},$u.prototype.patternsLoaded=function(){return this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length},$u.prototype.setExpiryData=function(t){var e=this.expirationTime;if(t.cacheControl){var r=S(t.cacheControl);r["max-age"]&&(this.expirationTime=Date.now()+1e3*r["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){var n=Date.now(),i=!1;if(this.expirationTime>n)i=!1;else if(e)if(this.expirationTime<e)i=!0;else{var a=this.expirationTime-e;a?this.expirationTime=n+Math.max(a,3e4):i=!0;}else i=!0;i?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}},$u.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},$u.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var r=this.latestFeatureIndex.loadVTLayers();for(var n in this.buckets){var i=this.buckets[n],a=i.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],s=t[a];o&&s&&0!==Object.keys(s).length&&(i.update(s,o,this.imageAtlas&&this.imageAtlas.patternPositions||{}),e&&e.style&&(this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(n).queryRadius(i))));}}},$u.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},$u.prototype.symbolFadeFinished=function(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<V.now()},$u.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0;},$u.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=V.now()+t;};function Wu(t,e,r,n,i){if(void 0===e.segment)return !0;for(var a=e,o=e.segment+1,s=0;s>-r/2;){if(--o<0)return !1;s-=t[o].dist(a),a=t[o];}s+=t[o].dist(t[o+1]),o++;for(var u=[],l=0;s<r/2;){var p=t[o-1],c=t[o],h=t[o+1];if(!h)return !1;var f=p.angleTo(c)-c.angleTo(h);for(f=Math.abs((f+3*Math.PI)%(2*Math.PI)-Math.PI),u.push({distance:s,angleDelta:f}),l+=f;s-u[0].distance>n;)l-=u.shift().angleDelta;if(l>i)return !1;o++,s+=c.dist(h);}return !0}function Qu(t){for(var e=0,r=0;r<t.length-1;r++)e+=t[r].dist(t[r+1]);return e}function tl(t,e,r){return t?.6*e*r:0}function el(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function rl(t,e,r,n,i,a){for(var o=tl(r,i,a),s=el(r,n)*a,u=0,l=Qu(t)/2,p=0;p<t.length-1;p++){var c=t[p],h=t[p+1],f=c.dist(h);if(u+f>l){var y=(l-u)/f,d=be(c.x,h.x,y),m=be(c.y,h.y,y),v=new ks(d,m,h.angleTo(c),p);return v._round(),!o||Wu(t,v,s,o,e)?v:void 0}u+=f;}}function nl(t,e,r,n,i,a,o,s,u){var l=tl(n,a,o),p=el(n,i),c=p*o,h=0===t[0].x||t[0].x===u||0===t[0].y||t[0].y===u;return e-c<e/4&&(e=c+e/4),function t(e,r,n,i,a,o,s,u,l){var p=o/2;var c=Qu(e);var h=0,f=r-n;var y=[];for(var d=0;d<e.length-1;d++){for(var m=e[d],v=e[d+1],g=m.dist(v),x=v.angleTo(m);f+n<h+g;){var b=((f+=n)-h)/g,_=be(m.x,v.x,b),w=be(m.y,v.y,b);if(_>=0&&_<l&&w>=0&&w<l&&f-p>=0&&f+p<=c){var A=new ks(_,w,x,d);A._round(),i&&!Wu(e,A,o,i,a)||y.push(A);}}h+=g;}u||y.length||s||(y=t(e,h/2,n,i,a,o,s,!0,l));return y}(t,h?e/2*s%e:(p/2+2*a)*o*s%e,e,l,r,c,h,!1,u)}var il=function(t,e,r,n,a,o,s,u,l,p,c,h){var f=s.top*u-l,y=s.bottom*u+l,d=s.left*u-l,m=s.right*u+l;if(this.boxStartIndex=t.length,p){var v=y-f,g=m-d;v>0&&(v=Math.max(10*u,v),this._addLineCollisionCircles(t,e,r,r.segment,g,v,n,a,o,c));}else{if(h){var x=new i(d,f),b=new i(m,f),_=new i(d,y),w=new i(m,y),A=h*Math.PI/180;x._rotate(A),b._rotate(A),_._rotate(A),w._rotate(A),d=Math.min(x.x,b.x,_.x,w.x),m=Math.max(x.x,b.x,_.x,w.x),f=Math.min(x.y,b.y,_.y,w.y),y=Math.max(x.y,b.y,_.y,w.y);}t.emplaceBack(r.x,r.y,d,f,m,y,n,a,o,0,0);}this.boxEndIndex=t.length;};il.prototype._addLineCollisionCircles=function(t,e,r,n,i,a,o,s,u,l){var p=a/2,c=Math.floor(i/p)||1,h=1+.4*Math.log(l)/Math.LN2,f=Math.floor(c*h/2),y=-a/2,d=r,m=n+1,v=y,g=-i/2,x=g-i/4;do{if(--m<0){if(v>g)return;m=0;break}v-=e[m].dist(d),d=e[m];}while(v>x);for(var b=e[m].dist(e[m+1]),_=-f;_<c+f;_++){var w=_*p,A=g+w;if(w<0&&(A+=w),w>i&&(A+=w-i),!(A<v)){for(;v+b<A;){if(v+=b,++m+1>=e.length)return;b=e[m].dist(e[m+1]);}var k=A-v,S=e[m],z=e[m+1].sub(S)._unit()._mult(k)._add(S)._round(),I=Math.abs(A-y)<p?0:.8*(A-y);t.emplaceBack(z.x,z.y,-a/2,-a/2,a/2,a/2,o,s,u,a/2,I);}}};var al=function(t,e){if(void 0===t&&(t=[]),void 0===e&&(e=ol),this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(var r=(this.length>>1)-1;r>=0;r--)this._down(r);};function ol(t,e){return t<e?-1:t>e?1:0}function sl(t,e,r){void 0===e&&(e=1),void 0===r&&(r=!1);for(var n=1/0,a=1/0,o=-1/0,s=-1/0,u=t[0],l=0;l<u.length;l++){var p=u[l];(!l||p.x<n)&&(n=p.x),(!l||p.y<a)&&(a=p.y),(!l||p.x>o)&&(o=p.x),(!l||p.y>s)&&(s=p.y);}var c=o-n,h=s-a,f=Math.min(c,h),y=f/2,d=new al([],ul);if(0===f)return new i(n,a);for(var m=n;m<o;m+=f)for(var v=a;v<s;v+=f)d.push(new ll(m+y,v+y,y,t));for(var g=function(t){for(var e=0,r=0,n=0,i=t[0],a=0,o=i.length,s=o-1;a<o;s=a++){var u=i[a],l=i[s],p=u.x*l.y-l.x*u.y;r+=(u.x+l.x)*p,n+=(u.y+l.y)*p,e+=3*p;}return new ll(r/e,n/e,0,t)}(t),x=d.length;d.length;){var b=d.pop();(b.d>g.d||!g.d)&&(g=b,r&&console.log("found best %d after %d probes",Math.round(1e4*b.d)/1e4,x)),b.max-g.d<=e||(y=b.h/2,d.push(new ll(b.p.x-y,b.p.y-y,y,t)),d.push(new ll(b.p.x+y,b.p.y-y,y,t)),d.push(new ll(b.p.x-y,b.p.y+y,y,t)),d.push(new ll(b.p.x+y,b.p.y+y,y,t)),x+=4);}return r&&(console.log("num probes: "+x),console.log("best distance: "+g.d)),g.p}function ul(t,e){return e.max-t.max}function ll(t,e,r,n){this.p=new i(t,e),this.h=r,this.d=function(t,e){for(var r=!1,n=1/0,i=0;i<e.length;i++)for(var a=e[i],o=0,s=a.length,u=s-1;o<s;u=o++){var l=a[o],p=a[u];l.y>t.y!=p.y>t.y&&t.x<(p.x-l.x)*(t.y-l.y)/(p.y-l.y)+l.x&&(r=!r),n=Math.min(n,ma(t,l,p));}return (r?1:-1)*Math.sqrt(n)}(this.p,n),this.max=this.d+this.h*Math.SQRT2;}al.prototype.push=function(t){this.data.push(t),this.length++,this._up(this.length-1);},al.prototype.pop=function(){if(0!==this.length){var t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}},al.prototype.peek=function(){return this.data[0]},al.prototype._up=function(t){for(var e=this.data,r=this.compare,n=e[t];t>0;){var i=t-1>>1,a=e[i];if(r(n,a)>=0)break;e[t]=a,t=i;}e[t]=n;},al.prototype._down=function(t){for(var e=this.data,r=this.compare,n=this.length>>1,i=e[t];t<n;){var a=1+(t<<1),o=e[a],s=a+1;if(s<this.length&&r(e[s],o)<0&&(a=s,o=e[s]),r(o,i)>=0)break;e[t]=o,t=a;}e[t]=i;};var pl=e((function(t){t.exports=function(t,e){var r,n,i,a,o,s,u,l;for(r=3&t.length,n=t.length-r,i=e,o=3432918353,s=461845907,l=0;l<n;)u=255&t.charCodeAt(l)|(255&t.charCodeAt(++l))<<8|(255&t.charCodeAt(++l))<<16|(255&t.charCodeAt(++l))<<24,++l,i=27492+(65535&(a=5*(65535&(i=(i^=u=(65535&(u=(u=(65535&u)*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295)<<13|i>>>19))+((5*(i>>>16)&65535)<<16)&4294967295))+((58964+(a>>>16)&65535)<<16);switch(u=0,r){case 3:u^=(255&t.charCodeAt(l+2))<<16;case 2:u^=(255&t.charCodeAt(l+1))<<8;case 1:i^=u=(65535&(u=(u=(65535&(u^=255&t.charCodeAt(l)))*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295;}return i^=t.length,i=2246822507*(65535&(i^=i>>>16))+((2246822507*(i>>>16)&65535)<<16)&4294967295,i=3266489909*(65535&(i^=i>>>13))+((3266489909*(i>>>16)&65535)<<16)&4294967295,(i^=i>>>16)>>>0};})),cl=e((function(t){t.exports=function(t,e){for(var r,n=t.length,i=e^n,a=0;n>=4;)r=1540483477*(65535&(r=255&t.charCodeAt(a)|(255&t.charCodeAt(++a))<<8|(255&t.charCodeAt(++a))<<16|(255&t.charCodeAt(++a))<<24))+((1540483477*(r>>>16)&65535)<<16),i=1540483477*(65535&i)+((1540483477*(i>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++a;switch(n){case 3:i^=(255&t.charCodeAt(a+2))<<16;case 2:i^=(255&t.charCodeAt(a+1))<<8;case 1:i=1540483477*(65535&(i^=255&t.charCodeAt(a)))+((1540483477*(i>>>16)&65535)<<16);}return i=1540483477*(65535&(i^=i>>>13))+((1540483477*(i>>>16)&65535)<<16),(i^=i>>>15)>>>0};})),hl=pl,fl=pl,yl=cl;hl.murmur3=fl,hl.murmur2=yl;var dl=7;function ml(t,e){var r=0,n=0,i=e/Math.sqrt(2);switch(t){case"top-right":case"top-left":n=i-dl;break;case"bottom-right":case"bottom-left":n=-i+dl;break;case"bottom":n=-e+dl;break;case"top":n=e-dl;}switch(t){case"top-right":case"bottom-right":r=-i;break;case"top-left":case"bottom-left":r=i;break;case"left":r=e;break;case"right":r=-e;}return [r,n]}function vl(t){switch(t){case"right":case"top-right":case"bottom-right":return "right";case"left":case"top-left":case"bottom-left":return "left"}return "center"}var gl=65535;function xl(t,e,r,n,a,o,s,u,l,p,c,h,f){var y=function(t,e,r,n,a,o,s,u){for(var l=n.layout.get("text-rotate").evaluate(o,{})*Math.PI/180,p=e.positionedGlyphs,c=[],h=0;h<p.length;h++){var f=p[h],y=s[f.fontStack],d=y&&y[f.glyph];if(d){var m=d.rect;if(m){var v=Su+1,g=d.metrics.advance*f.scale/2,x=a?[f.x+g,f.y]:[0,0],b=a?[0,0]:[f.x+g+r[0],f.y+r[1]],_=(a||u)&&f.vertical,w=[0,0];_&&(w=b,b=[0,0]);var A=(d.metrics.left-v)*f.scale-g+b[0],k=(-d.metrics.top-v)*f.scale+b[1],S=A+m.w*f.scale,z=k+m.h*f.scale,I=new i(A,k),C=new i(S,k),B=new i(A,z),E=new i(S,z);if(_){var M=new i(-g,g-e.yOffset),P=-Math.PI/2,T=hs/2-g,V=new i(5-e.yOffset-T,0),F=new(Function.prototype.bind.apply(i,[null].concat(w)));I._rotateAround(P,M)._add(V)._add(F),C._rotateAround(P,M)._add(V)._add(F),B._rotateAround(P,M)._add(V)._add(F),E._rotateAround(P,M)._add(V)._add(F);}if(l){var O=Math.sin(l),L=Math.cos(l),D=[L,-O,O,L];I._matMult(D),C._matMult(D),B._matMult(D),E._matMult(D);}c.push({tl:I,tr:C,bl:B,br:E,tex:m,writingMode:e.writingMode,glyphOffset:x,sectionIndex:f.sectionIndex});}}}return c}(0,r,s,n,a,o,h,t.allowVerticalPlacement),d=t.textSizeData,m=null;"source"===d.kind?(m=[Ss*n.layout.get("text-size").evaluate(o,{})])[0]>gl&&w(t.layerIds[0]+': Value for "text-size" is >= 256. Reduce your "text-size".'):"composite"===d.kind&&((m=[Ss*f.compositeTextSizes[0].evaluate(o,{}),Ss*f.compositeTextSizes[1].evaluate(o,{})])[0]>gl||m[1]>gl)&&w(t.layerIds[0]+': Value for "text-size" is >= 256. Reduce your "text-size".'),t.addSymbols(t.text,y,m,s,a,o,l,e,u.lineStartIndex,u.lineLength);for(var v=0,g=p;v<g.length;v+=1){c[g[v]]=t.text.placedSymbolArray.length-1;}return 4*y.length}function bl(t){for(var e in t)return t[e];return null}function _l(t,e,r,n){var i=t.compareText;if(e in i){for(var a=i[e],o=a.length-1;o>=0;o--)if(n.dist(a[o])<r)return !0}else i[e]=[];return i[e].push(n),!1}t.Actor=Iu,t.AlphaImage=Fa,t.CanonicalTileID=Du,t.CollisionBoxArray=wi,t.Color=Ht,t.DEMData=qu,t.DataConstantProperty=qn,t.DictionaryCoder=Ku,t.EXTENT=na,t.ErrorEvent=kt,t.EvaluationParameters=Tn,t.Event=At,t.Evented=St,t.FeatureIndex=Ju,t.FillBucket=So,t.FillExtrusionBucket=qo,t.ImageAtlas=Ys,t.ImagePosition=Js,t.LineBucket=Qo,t.LngLat=Eu,t.LngLatBounds=Bu,t.MercatorCoordinate=Lu,t.ONE_EM=hs,t.OverscaledTileID=Ru,t.Point=i,t.Point$1=i,t.ProgramConfiguration=Qi,t.Properties=Gn,t.Protobuf=iu,t.RGBAImage=Oa,t.RequestManager=j,t.ResourceType=pt,t.SegmentVector=Vi,t.SourceFeatureState=Gu,t.StructArrayLayout1ui2=gi,t.StructArrayLayout2i4=ti,t.StructArrayLayout2ui4=vi,t.StructArrayLayout3ui6=mi,t.StructArrayLayout4i8=ei,t.SymbolBucket=Os,t.Texture=eu,t.Tile=$u,t.Transitionable=On,t.Uniform1f=Ri,t.Uniform1i=Ui,t.Uniform2f=ji,t.Uniform3f=qi,t.Uniform4f=Ni,t.UniformColor=Ki,t.UniformMatrix4f=Xi,t.UnwrappedTileID=Uu,t.ValidationError=It,t.WritingMode=fs,t.ZoomHistory=bn,t.addDynamicAttributes=Ts,t.asyncAll=function(t,e,r){if(!t.length)return r(null,[]);var n=t.length,i=new Array(t.length),a=null;t.forEach((function(t,o){e(t,(function(t,e){t&&(a=t),i[o]=e,0==--n&&r(a,i);}));}));},t.bezier=s,t.bindAll=m,t.browser=V,t.cacheEntryPossiblyAdded=function(t){++lt>it&&(t.getActor().send("enforceCacheSizeLimit",nt),lt=0);},t.clamp=l,t.clearTileCache=function(t){var e=self.caches.delete(rt);t&&e.catch(t).then((function(){return t()}));},t.clone=function(t){var e=new Sa(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=b,t.config=F,t.create=function(){var t=new Sa(16);return Sa!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=function(){var t=new Sa(9);return Sa!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t},t.create$2=function(){var t=new Sa(4);return Sa!=Float32Array&&(t[1]=0,t[2]=0),t[0]=1,t[3]=1,t},t.createCommonjsModule=e,t.createExpression=Sr,t.createLayout=Wn,t.createStyleLayer=function(t){return "custom"===t.type?new Zs(t):new Xs[t.type](t)},t.deepEqual=o,t.ease=u,t.emitValidationErrors=pn,t.endsWith=v,t.enforceCacheSizeLimit=function(t){self.caches&&self.caches.open(rt).then((function(e){e.keys().then((function(r){for(var n=0;n<r.length-t;n++)e.delete(r[n]);}));}));},t.evaluateRadialOffset=ml,t.evaluateSizeForFeature=Is,t.evaluateSizeForZoom=Cs,t.evented=Mn,t.extend=c,t.featureFilter=Dr,t.filterObject=x,t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.getAnchorAlignment=ws,t.getAnchorJustification=vl,t.getArrayBuffer=mt,t.getImage=bt,t.getJSON=function(t,e){return dt(c(t,{type:"json"}),e)},t.getReferrer=ft,t.getVideo=function(t,e){var r,n,i=self.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i);};for(var a=0;a<t.length;a++){var o=self.document.createElement("source");r=t[a],n=void 0,(n=self.document.createElement("a")).href=r,(n.protocol!==self.document.location.protocol||n.host!==self.document.location.host)&&(i.crossOrigin="Anonymous"),o.src=t[a],i.appendChild(o);}return {cancel:function(){}}},t.identity=function(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.invert=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=e[4],s=e[5],u=e[6],l=e[7],p=e[8],c=e[9],h=e[10],f=e[11],y=e[12],d=e[13],m=e[14],v=e[15],g=r*s-n*o,x=r*u-i*o,b=r*l-a*o,_=n*u-i*s,w=n*l-a*s,A=i*l-a*u,k=p*d-c*y,S=p*m-h*y,z=p*v-f*y,I=c*m-h*d,C=c*v-f*d,B=h*v-f*m,E=g*B-x*C+b*I+_*z-w*S+A*k;return E?(E=1/E,t[0]=(s*B-u*C+l*I)*E,t[1]=(i*C-n*B-a*I)*E,t[2]=(d*A-m*w+v*_)*E,t[3]=(h*w-c*A-f*_)*E,t[4]=(u*z-o*B-l*S)*E,t[5]=(r*B-i*z+a*S)*E,t[6]=(m*b-y*A-v*x)*E,t[7]=(p*A-h*b+f*x)*E,t[8]=(o*C-s*z+l*k)*E,t[9]=(n*z-r*C-a*k)*E,t[10]=(y*w-d*b+v*g)*E,t[11]=(c*b-p*w-f*g)*E,t[12]=(s*S-o*I-u*k)*E,t[13]=(r*I-n*S+i*k)*E,t[14]=(d*x-y*_-m*g)*E,t[15]=(p*_-c*x+h*g)*E,t):null},t.isChar=_n,t.isMapboxURL=q,t.keysDifference=function(t,e){var r=[];for(var n in t)n in e||r.push(n);return r},t.makeRequest=dt,t.mapObject=g,t.mercatorXfromLng=Tu,t.mercatorYfromLat=Vu,t.mercatorZfromAltitude=Fu,t.multiply=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],d=e[12],m=e[13],v=e[14],g=e[15],x=r[0],b=r[1],_=r[2],w=r[3];return t[0]=x*n+b*s+_*c+w*d,t[1]=x*i+b*u+_*h+w*m,t[2]=x*a+b*l+_*f+w*v,t[3]=x*o+b*p+_*y+w*g,x=r[4],b=r[5],_=r[6],w=r[7],t[4]=x*n+b*s+_*c+w*d,t[5]=x*i+b*u+_*h+w*m,t[6]=x*a+b*l+_*f+w*v,t[7]=x*o+b*p+_*y+w*g,x=r[8],b=r[9],_=r[10],w=r[11],t[8]=x*n+b*s+_*c+w*d,t[9]=x*i+b*u+_*h+w*m,t[10]=x*a+b*l+_*f+w*v,t[11]=x*o+b*p+_*y+w*g,x=r[12],b=r[13],_=r[14],w=r[15],t[12]=x*n+b*s+_*c+w*d,t[13]=x*i+b*u+_*h+w*m,t[14]=x*a+b*l+_*f+w*v,t[15]=x*o+b*p+_*y+w*g,t},t.mvt=Do,t.number=be,t.ortho=function(t,e,r,n,i,a,o){var s=1/(e-r),u=1/(n-i),l=1/(a-o);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*u,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*l,t[11]=0,t[12]=(e+r)*s,t[13]=(i+n)*u,t[14]=(o+a)*l,t[15]=1,t},t.parseGlyphPBF=function(t){return new iu(t).readFields(wu,[])},t.pbf=iu,t.performSymbolLayout=function(t,e,r,n,a,o){t.createArrays();var s=512*t.overscaling;t.tilePixelRatio=na/s,t.compareText={},t.iconsNeedLinear=!1;var u=t.layers[0].layout,l=t.layers[0]._unevaluatedLayout._values,p={};if("composite"===t.textSizeData.kind){var c=t.textSizeData,h=c.minZoom,f=c.maxZoom;p.compositeTextSizes=[l["text-size"].possiblyEvaluate(new Tn(h)),l["text-size"].possiblyEvaluate(new Tn(f))];}if("composite"===t.iconSizeData.kind){var y=t.iconSizeData,d=y.minZoom,m=y.maxZoom;p.compositeIconSizes=[l["icon-size"].possiblyEvaluate(new Tn(d)),l["icon-size"].possiblyEvaluate(new Tn(m))];}p.layoutTextSize=l["text-size"].possiblyEvaluate(new Tn(t.zoom+1)),p.layoutIconSize=l["icon-size"].possiblyEvaluate(new Tn(t.zoom+1)),p.textMaxSize=l["text-size"].possiblyEvaluate(new Tn(18));for(var v=u.get("text-line-height")*hs,g="map"===u.get("text-rotation-alignment")&&"point"!==u.get("symbol-placement"),x=u.get("text-keep-upright"),b=function(){var o=A[_],s=u.get("text-font").evaluate(o,{}).join(","),l=r,c={horizontal:{},vertical:void 0},h=o.text,f=[0,0];if(h){var y=h.toString(),d=u.get("text-letter-spacing").evaluate(o,{})*hs,m=function(t){for(var e=0,r=t;e<r.length;e+=1){if(!An(r[e].charCodeAt(0)))return !1}return !0}(y)?d:0,b=u.get("text-anchor").evaluate(o,{}),k=u.get("text-variable-anchor"),S=u.get("text-radial-offset").evaluate(o,{});k||(f=S?ml(b,S*hs):u.get("text-offset").evaluate(o,{}).map((function(t){return t*hs})));var z=g?"center":u.get("text-justify").evaluate(o,{}),I="point"===u.get("symbol-placement")?u.get("text-max-width").evaluate(o,{})*hs:0,C=function(){t.allowVerticalPlacement&&wn(y)&&(c.vertical=ds(h,e,s,I,v,b,"left",m,f,fs.vertical,!0));};if(!g&&k){for(var B="auto"===z?k.map((function(t){return vl(t)})):[z],E=!1,M=0;M<B.length;M++){var P=B[M];if(!c.horizontal[P])if(E)c.horizontal[P]=c.horizontal[0];else{var T=ds(h,e,s,I,v,"center",P,m,f,fs.horizontal,!1);T&&(c.horizontal[P]=T,E=1===T.lineCount);}}C();}else{"auto"===z&&(z=vl(b));var V=ds(h,e,s,I,v,b,z,m,f,fs.horizontal,!1);V&&(c.horizontal[z]=V),C(),wn(y)&&g&&x&&(c.vertical=ds(h,e,s,I,v,b,z,m,f,fs.vertical,!1));}}var F=void 0;if(o.icon){var O=n[o.icon];O&&(F=function(t,e,r){var n=ws(r),i=n.horizontalAlign,a=n.verticalAlign,o=e[0],s=e[1],u=o-t.displaySize[0]*i,l=u+t.displaySize[0],p=s-t.displaySize[1]*a;return {image:t,top:p,bottom:p+t.displaySize[1],left:u,right:l}}(a[o.icon],u.get("icon-offset").evaluate(o,{}),u.get("icon-anchor").evaluate(o,{})),void 0===t.sdfIcons?t.sdfIcons=O.sdf:t.sdfIcons!==O.sdf&&w("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),O.pixelRatio!==t.pixelRatio?t.iconsNeedLinear=!0:0!==u.get("icon-rotate").constantOr(1)&&(t.iconsNeedLinear=!0));}(Object.keys(c.horizontal).length||F)&&function(t,e,r,n,a,o,s){var u=o.layoutTextSize.evaluate(e,{}),l=o.layoutIconSize.evaluate(e,{}),p=o.textMaxSize.evaluate(e,{});void 0===p&&(p=u);var c=t.layers[0].layout,h=c.get("icon-offset").evaluate(e,{}),f=bl(r.horizontal),y=u/24,d=t.tilePixelRatio*y,m=t.tilePixelRatio*p/24,v=t.tilePixelRatio*l,g=t.tilePixelRatio*c.get("symbol-spacing"),x=c.get("text-padding")*t.tilePixelRatio,b=c.get("icon-padding")*t.tilePixelRatio,_=c.get("text-max-angle")/180*Math.PI,A="map"===c.get("text-rotation-alignment")&&"point"!==c.get("symbol-placement"),k="map"===c.get("icon-rotation-alignment")&&"point"!==c.get("symbol-placement"),S=c.get("symbol-placement"),z=g/2,I=function(u,l){l.x<0||l.x>=na||l.y<0||l.y>=na||function(t,e,r,n,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,_){var A,k,S,z=t.addToLineVertexArray(e,r),I=0,C=0,B=0,E={},M=hl(""),P=(o.layout.get("text-radial-offset").evaluate(x,{})||0)*hs;if(t.allowVerticalPlacement&&n.vertical){var T=o.layout.get("text-rotate").evaluate(x,{})+90,V=n.vertical;S=new il(s,r,e,u,l,p,V,c,h,f,t.overscaling,T);}for(var F in n.horizontal){var O=n.horizontal[F];if(!A){M=hl(O.text);var L=o.layout.get("text-rotate").evaluate(x,{});A=new il(s,r,e,u,l,p,O,c,h,f,t.overscaling,L);}var D=1===O.lineCount;if(C+=xl(t,e,O,o,f,x,y,z,n.vertical?fs.horizontal:fs.horizontalOnly,D?Object.keys(n.horizontal):[F],E,b,_),D)break}n.vertical&&(B+=xl(t,e,n.vertical,o,f,x,y,z,fs.vertical,["vertical"],E,b,_));var U=A?A.boxStartIndex:t.collisionBoxArray.length,R=A?A.boxEndIndex:t.collisionBoxArray.length,j=S?S.boxStartIndex:t.collisionBoxArray.length,q=S?S.boxEndIndex:t.collisionBoxArray.length;if(a){var N=function(t,e,r,n,a,o){var s,u,l,p,c=e.image,h=r.layout,f=e.top-1/c.pixelRatio,y=e.left-1/c.pixelRatio,d=e.bottom+1/c.pixelRatio,m=e.right+1/c.pixelRatio;if("none"!==h.get("icon-text-fit")&&a){var v=m-y,g=d-f,x=h.get("text-size").evaluate(o,{})/24,b=a.left*x,_=a.right*x,w=a.top*x,A=_-b,k=a.bottom*x-w,S=h.get("icon-text-fit-padding")[0],z=h.get("icon-text-fit-padding")[1],I=h.get("icon-text-fit-padding")[2],C=h.get("icon-text-fit-padding")[3],B="width"===h.get("icon-text-fit")?.5*(k-g):0,E="height"===h.get("icon-text-fit")?.5*(A-v):0,M="width"===h.get("icon-text-fit")||"both"===h.get("icon-text-fit")?A:v,P="height"===h.get("icon-text-fit")||"both"===h.get("icon-text-fit")?k:g;s=new i(b+E-C,w+B-S),u=new i(b+E+z+M,w+B-S),l=new i(b+E+z+M,w+B+I+P),p=new i(b+E-C,w+B+I+P);}else s=new i(y,f),u=new i(m,f),l=new i(m,d),p=new i(y,d);var T=r.layout.get("icon-rotate").evaluate(o,{})*Math.PI/180;if(T){var V=Math.sin(T),F=Math.cos(T),O=[F,-V,V,F];s._matMult(O),u._matMult(O),p._matMult(O),l._matMult(O);}return [{tl:s,tr:u,bl:p,br:l,tex:c.paddedRect,writingMode:void 0,glyphOffset:[0,0],sectionIndex:0}]}(0,a,o,0,bl(n.horizontal),x),K=o.layout.get("icon-rotate").evaluate(x,{});k=new il(s,r,e,u,l,p,a,d,m,!1,t.overscaling,K),I=4*N.length;var Z=t.iconSizeData,X=null;"source"===Z.kind?(X=[Ss*o.layout.get("icon-size").evaluate(x,{})])[0]>gl&&w(t.layerIds[0]+': Value for "icon-size" is >= 256. Reduce your "icon-size".'):"composite"===Z.kind&&((X=[Ss*_.compositeIconSizes[0].evaluate(x,{}),Ss*_.compositeIconSizes[1].evaluate(x,{})])[0]>gl||X[1]>gl)&&w(t.layerIds[0]+': Value for "icon-size" is >= 256. Reduce your "icon-size".'),t.addSymbols(t.icon,N,X,g,v,x,!1,e,z.lineStartIndex,z.lineLength);}var G=k?k.boxStartIndex:t.collisionBoxArray.length,J=k?k.boxEndIndex:t.collisionBoxArray.length;t.glyphOffsetArray.length>=Os.MAX_GLYPHS&&w("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");t.symbolInstances.emplaceBack(e.x,e.y,E.right>=0?E.right:-1,E.center>=0?E.center:-1,E.left>=0?E.left:-1,E.vertical||-1,M,U,R,j,q,G,J,u,C,B,I,0,c,P);}(t,l,u,r,n,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,d,x,A,s,v,b,k,h,e,a,o);};if("line"===S)for(var C=0,B=function(t,e,r,n,a){for(var o=[],s=0;s<t.length;s++)for(var u=t[s],l=void 0,p=0;p<u.length-1;p++){var c=u[p],h=u[p+1];c.x<e&&h.x<e||(c.x<e?c=new i(e,c.y+(h.y-c.y)*((e-c.x)/(h.x-c.x)))._round():h.x<e&&(h=new i(e,c.y+(h.y-c.y)*((e-c.x)/(h.x-c.x)))._round()),c.y<r&&h.y<r||(c.y<r?c=new i(c.x+(h.x-c.x)*((r-c.y)/(h.y-c.y)),r)._round():h.y<r&&(h=new i(c.x+(h.x-c.x)*((r-c.y)/(h.y-c.y)),r)._round()),c.x>=n&&h.x>=n||(c.x>=n?c=new i(n,c.y+(h.y-c.y)*((n-c.x)/(h.x-c.x)))._round():h.x>=n&&(h=new i(n,c.y+(h.y-c.y)*((n-c.x)/(h.x-c.x)))._round()),c.y>=a&&h.y>=a||(c.y>=a?c=new i(c.x+(h.x-c.x)*((a-c.y)/(h.y-c.y)),a)._round():h.y>=a&&(h=new i(c.x+(h.x-c.x)*((a-c.y)/(h.y-c.y)),a)._round()),l&&c.equals(l[l.length-1])||(l=[c],o.push(l)),l.push(h)))));}return o}(e.geometry,0,0,na,na);C<B.length;C+=1)for(var E=B[C],M=nl(E,g,_,r.vertical||f,n,24,m,t.overscaling,na),P=0,T=M;P<T.length;P+=1){var V=T[P],F=f;F&&_l(t,F.text,z,V)||I(E,V);}else if("line-center"===S)for(var O=0,L=e.geometry;O<L.length;O+=1){var D=L[O];if(D.length>1){var U=rl(D,_,r.vertical||f,n,24,m);U&&I(D,U);}}else if("Polygon"===e.type)for(var R=0,j=_o(e.geometry,0);R<j.length;R+=1){var q=j[R],N=sl(q,16);I(q[0],new ks(N.x,N.y,0));}else if("LineString"===e.type)for(var K=0,Z=e.geometry;K<Z.length;K+=1){var X=Z[K];I(X,new ks(X[0].x,X[0].y,0));}else if("Point"===e.type)for(var G=0,J=e.geometry;G<J.length;G+=1)for(var H=J[G],Y=0,$=H;Y<$.length;Y+=1){var W=$[Y];I([W],new ks(W.x,W.y,0));}}(t,o,c,F,l,p,f);},_=0,A=t.features;_<A.length;_+=1)b();o&&t.generateCollisionDebugBuffers();},t.perspective=function(t,e,r,n,i){var a,o=1/Math.tan(e/2);return t[0]=o/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(a=1/(n-i),t[10]=(i+n)*a,t[14]=2*i*n*a):(t[10]=-1,t[14]=-2*n),t},t.pick=function(t,e){for(var r={},n=0;n<e.length;n++){var i=e[n];i in t&&(r[i]=t[i]);}return r},t.plugin=Pn,t.polygonIntersectsPolygon=la,t.postMapLoadEvent=et,t.postTurnstileEvent=Q,t.potpack=Gs,t.rasterBoundsAttributes=Nu,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.register=mn,t.registerForPluginAvailability=function(t){return Bn?t({pluginURL:Bn,completionCallback:In}):Mn.once("pluginAvailable",t),t},t.rotate=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=Math.sin(r),u=Math.cos(r);return t[0]=n*u+a*s,t[1]=i*u+o*s,t[2]=n*-s+a*u,t[3]=i*-s+o*u,t},t.rotateX=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[4],o=e[5],s=e[6],u=e[7],l=e[8],p=e[9],c=e[10],h=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=a*i+l*n,t[5]=o*i+p*n,t[6]=s*i+c*n,t[7]=u*i+h*n,t[8]=l*i-a*n,t[9]=p*i-o*n,t[10]=c*i-s*n,t[11]=h*i-u*n,t},t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[0],o=e[1],s=e[2],u=e[3],l=e[4],p=e[5],c=e[6],h=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=a*i+l*n,t[1]=o*i+p*n,t[2]=s*i+c*n,t[3]=u*i+h*n,t[4]=l*i-a*n,t[5]=p*i-o*n,t[6]=c*i-s*n,t[7]=h*i-u*n,t},t.scale=function(t,e,r){var n=r[0],i=r[1],a=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*a,t[9]=e[9]*a,t[10]=e[10]*a,t[11]=e[11]*a,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.setCacheLimits=function(t,e){nt=t,it=e;},t.setRTLTextPlugin=function(t,e){if(Cn)throw new Error("setRTLTextPlugin cannot be called multiple times.");Cn=!0,Bn=V.resolveURL(t),In=function(t){t?(Cn=!1,Bn=null,e&&e(t)):En=!0;},Mn.fire(new At("pluginAvailable",{pluginURL:Bn,completionCallback:In}));},t.sphericalToCartesian=function(t){var e=t[0],r=t[1],n=t[2];return r+=90,r*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(r)*Math.sin(n),y:e*Math.sin(r)*Math.sin(n),z:e*Math.cos(n)}},t.styleSpec=zt,t.symbolSize=Bs,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],a=e[2];return t[0]=n*r[0]+i*r[3]+a*r[6],t[1]=n*r[1]+i*r[4]+a*r[7],t[2]=n*r[2]+i*r[5]+a*r[8],t},t.transformMat4=Ca,t.translate=function(t,e,r){var n,i,a,o,s,u,l,p,c,h,f,y,d=r[0],m=r[1],v=r[2];return e===t?(t[12]=e[0]*d+e[4]*m+e[8]*v+e[12],t[13]=e[1]*d+e[5]*m+e[9]*v+e[13],t[14]=e[2]*d+e[6]*m+e[10]*v+e[14],t[15]=e[3]*d+e[7]*m+e[11]*v+e[15]):(n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],t[0]=n,t[1]=i,t[2]=a,t[3]=o,t[4]=s,t[5]=u,t[6]=l,t[7]=p,t[8]=c,t[9]=h,t[10]=f,t[11]=y,t[12]=n*d+s*m+c*v+e[12],t[13]=i*d+u*m+h*v+e[13],t[14]=a*d+l*m+f*v+e[14],t[15]=o*d+p*m+y*v+e[15]),t},t.uniqueId=f,t.validateCustomStyleLayer=function(t){var e=[],r=t.id;return void 0===r&&e.push({message:"layers."+r+': missing required property "id"'}),void 0===t.render&&e.push({message:"layers."+r+': missing required method "render"'}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:"layers."+r+': property "renderingMode" must be either "2d" or "3d"'}),e},t.validateLight=sn,t.validateStyle=on,t.values=function(t){var e=[];for(var r in t)e.push(t[r]);return e},t.vectorTile=Do,t.version="1.3.2",t.warnOnce=w,t.webpSupported=O,t.window=self,t.wrap=p;}));
	
	define(["./shared"],(function(e){"use strict";function t(e){var r=typeof e;if("number"===r||"boolean"===r||"string"===r||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var o="[",i=0,n=e;i<n.length;i+=1){o+=t(n[i])+",";}return o+"]"}for(var a=Object.keys(e).sort(),s="{",u=0;u<a.length;u++)s+=JSON.stringify(a[u])+":"+t(e[a[u]])+",";return s+"}"}function r(r){for(var o="",i=0,n=e.refProperties;i<n.length;i+=1){o+="/"+t(r[n[i]]);}return o}var o=function(e){this.keyCache={},e&&this.replace(e);};o.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[]);},o.prototype.update=function(t,o){for(var i=this,n=0,a=t;n<a.length;n+=1){var s=a[n];this._layerConfigs[s.id]=s;var u=this._layers[s.id]=e.createStyleLayer(s);u._featureFilter=e.featureFilter(u.filter),this.keyCache[s.id]&&delete this.keyCache[s.id];}for(var l=0,h=o;l<h.length;l+=1){var c=h[l];delete this.keyCache[c],delete this._layerConfigs[c],delete this._layers[c];}this.familiesBySource={};for(var p=0,f=function(e,t){for(var o={},i=0;i<e.length;i++){var n=t&&t[e[i].id]||r(e[i]);t&&(t[e[i].id]=n);var a=o[n];a||(a=o[n]=[]),a.push(e[i]);}var s=[];for(var u in o)s.push(o[u]);return s}(e.values(this._layerConfigs),this.keyCache);p<f.length;p+=1){var d=f[p].map((function(e){return i._layers[e.id]})),g=d[0];if("none"!==g.visibility){var m=g.source||"",v=this.familiesBySource[m];v||(v=this.familiesBySource[m]={});var y=g.sourceLayer||"_geojsonTileLayer",x=v[y];x||(x=v[y]=[]),x.push(d);}}};var i=function(t){var r={},o=[];for(var i in t){var n=t[i],a=r[i]={};for(var s in n){var u=n[+s];if(u&&0!==u.bitmap.width&&0!==u.bitmap.height){var l={x:0,y:0,w:u.bitmap.width+2,h:u.bitmap.height+2};o.push(l),a[s]={rect:l,metrics:u.metrics};}}}var h=e.potpack(o),c=h.w,p=h.h,f=new e.AlphaImage({width:c||1,height:p||1});for(var d in t){var g=t[d];for(var m in g){var v=g[+m];if(v&&0!==v.bitmap.width&&0!==v.bitmap.height){var y=r[d][m].rect;e.AlphaImage.copy(v.bitmap,f,{x:0,y:0},{x:y.x+1,y:y.y+1},v.bitmap);}}}this.image=f,this.positions=r;};e.register("GlyphAtlas",i);var n=function(t){this.tileID=new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.uid=t.uid,this.zoom=t.zoom,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies;};function a(t,r){for(var o=new e.EvaluationParameters(r),i=0,n=t;i<n.length;i+=1){n[i].recalculate(o);}}n.prototype.parse=function(t,r,o,n){var s=this;this.status="parsing",this.data=t,this.collisionBoxArray=new e.CollisionBoxArray;var u=new e.DictionaryCoder(Object.keys(t.layers).sort()),l=new e.FeatureIndex(this.tileID);l.bucketLayerIDs=[];var h,c,p,f,d={},g={featureIndex:l,iconDependencies:{},patternDependencies:{},glyphDependencies:{}},m=r.familiesBySource[this.source];for(var v in m){var y=t.layers[v];if(y){1===y.version&&e.warnOnce('Vector tile source "'+this.source+'" layer "'+v+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var x=u.encode(v),w=[],S=0;S<y.length;S++){var M=y.feature(S);w.push({feature:M,index:S,sourceLayerIndex:x});}for(var k=0,b=m[v];k<b.length;k+=1){var _=b[k],P=_[0];if(!(P.minzoom&&this.zoom<Math.floor(P.minzoom)))if(!(P.maxzoom&&this.zoom>=P.maxzoom))if("none"!==P.visibility)a(_,this.zoom),(d[P.id]=P.createBucket({index:l.bucketLayerIDs.length,layers:_,zoom:this.zoom,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:x,sourceID:this.source})).populate(w,g),l.bucketLayerIDs.push(_.map((function(e){return e.id})));}}}var I=e.mapObject(g.glyphDependencies,(function(e){return Object.keys(e).map(Number)}));Object.keys(I).length?o.send("getGlyphs",{uid:this.uid,stacks:I},(function(e,t){h||(h=e,c=t,D.call(s));})):c={};var T=Object.keys(g.iconDependencies);T.length?o.send("getImages",{icons:T},(function(e,t){h||(h=e,p=t,D.call(s));})):p={};var L=Object.keys(g.patternDependencies);function D(){if(h)return n(h);if(c&&p&&f){var t=new i(c),r=new e.ImageAtlas(p,f);for(var o in d){var s=d[o];s instanceof e.SymbolBucket?(a(s.layers,this.zoom),e.performSymbolLayout(s,c,t.positions,p,r.iconPositions,this.showCollisionBoxes)):s.hasPattern&&(s instanceof e.LineBucket||s instanceof e.FillBucket||s instanceof e.FillExtrusionBucket)&&(a(s.layers,this.zoom),s.addFeatures(g,r.patternPositions));}this.status="done",n(null,{buckets:e.values(d).filter((function(e){return !e.isEmpty()})),featureIndex:l,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,imageAtlas:r,glyphMap:this.returnDependencies?c:null,iconMap:this.returnDependencies?p:null,glyphPositions:this.returnDependencies?t.positions:null});}}L.length?o.send("getImages",{icons:L},(function(e,t){h||(h=e,f=t,D.call(s));})):f={},D.call(this);};var s="undefined"!=typeof performance,u={getEntriesByName:function(e){return !!(s&&performance&&performance.getEntriesByName)&&performance.getEntriesByName(e)},mark:function(e){return !!(s&&performance&&performance.mark)&&performance.mark(e)},measure:function(e,t,r){return !!(s&&performance&&performance.measure)&&performance.measure(e,t,r)},clearMarks:function(e){return !!(s&&performance&&performance.clearMarks)&&performance.clearMarks(e)},clearMeasures:function(e){return !!(s&&performance&&performance.clearMeasures)&&performance.clearMeasures(e)}},l=function(e){this._marks={start:[e.url,"start"].join("#"),end:[e.url,"end"].join("#"),measure:e.url.toString()},u.mark(this._marks.start);};function h(t,r){var o=e.getArrayBuffer(t.request,(function(t,o,i,n){t?r(t):o&&r(null,{vectorTile:new e.vectorTile.VectorTile(new e.pbf(o)),rawData:o,cacheControl:i,expires:n});}));return function(){o.cancel(),r();}}l.prototype.finish=function(){u.mark(this._marks.end);var e=u.getEntriesByName(this._marks.measure);return 0===e.length&&(u.measure(this._marks.measure,this._marks.start,this._marks.end),e=u.getEntriesByName(this._marks.measure),u.clearMarks(this._marks.start),u.clearMarks(this._marks.end),u.clearMeasures(this._marks.measure)),e},u.Performance=l;var c=function(e,t,r){this.actor=e,this.layerIndex=t,this.loadVectorData=r||h,this.loading={},this.loaded={};};c.prototype.loadTile=function(t,r){var o=this,i=t.uid;this.loading||(this.loading={});var a=!!(t&&t.request&&t.request.collectResourceTiming)&&new u.Performance(t.request),s=this.loading[i]=new n(t);s.abort=this.loadVectorData(t,(function(t,n){if(delete o.loading[i],t||!n)return s.status="done",o.loaded[i]=s,r(t);var u=n.rawData,l={};n.expires&&(l.expires=n.expires),n.cacheControl&&(l.cacheControl=n.cacheControl);var h={};if(a){var c=a.finish();c&&(h.resourceTiming=JSON.parse(JSON.stringify(c)));}s.vectorTile=n.vectorTile,s.parse(n.vectorTile,o.layerIndex,o.actor,(function(t,o){if(t||!o)return r(t);r(null,e.extend({rawTileData:u.slice(0)},o,l,h));})),o.loaded=o.loaded||{},o.loaded[i]=s;}));},c.prototype.reloadTile=function(e,t){var r=this.loaded,o=e.uid,i=this;if(r&&r[o]){var n=r[o];n.showCollisionBoxes=e.showCollisionBoxes;var a=function(e,r){var o=n.reloadCallback;o&&(delete n.reloadCallback,n.parse(n.vectorTile,i.layerIndex,i.actor,o)),t(e,r);};"parsing"===n.status?n.reloadCallback=a:"done"===n.status&&(n.vectorTile?n.parse(n.vectorTile,this.layerIndex,this.actor,a):a());}},c.prototype.abortTile=function(e,t){var r=this.loading,o=e.uid;r&&r[o]&&r[o].abort&&(r[o].abort(),delete r[o]),t();},c.prototype.removeTile=function(e,t){var r=this.loaded,o=e.uid;r&&r[o]&&delete r[o],t();};var p=function(){this.loaded={};};p.prototype.loadTile=function(t,r){var o=t.uid,i=t.encoding,n=t.rawImageData,a=new e.DEMData(o,n,i);this.loaded=this.loaded||{},this.loaded[o]=a,r(null,a);},p.prototype.removeTile=function(e){var t=this.loaded,r=e.uid;t&&t[r]&&delete t[r];};var f={RADIUS:6378137,FLATTENING:1/298.257223563,POLAR_RADIUS:6356752.3142};function d(e){var t=0;if(e&&e.length>0){t+=Math.abs(g(e[0]));for(var r=1;r<e.length;r++)t-=Math.abs(g(e[r]));}return t}function g(e){var t,r,o,i,n,a,s=0,u=e.length;if(u>2){for(a=0;a<u;a++)a===u-2?(o=u-2,i=u-1,n=0):a===u-1?(o=u-1,i=0,n=1):(o=a,i=a+1,n=a+2),t=e[o],r=e[i],s+=(m(e[n][0])-m(t[0]))*Math.sin(m(r[1]));s=s*f.RADIUS*f.RADIUS/2;}return s}function m(e){return e*Math.PI/180}var v={geometry:function e(t){var r,o=0;switch(t.type){case"Polygon":return d(t.coordinates);case"MultiPolygon":for(r=0;r<t.coordinates.length;r++)o+=d(t.coordinates[r]);return o;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(r=0;r<t.geometries.length;r++)o+=e(t.geometries[r]);return o}},ring:g},y=function e(t,r){switch(t&&t.type||null){case"FeatureCollection":return t.features=t.features.map(x(e,r)),t;case"GeometryCollection":return t.geometries=t.geometries.map(x(e,r)),t;case"Feature":return t.geometry=e(t.geometry,r),t;case"Polygon":case"MultiPolygon":return function(e,t){"Polygon"===e.type?e.coordinates=w(e.coordinates,t):"MultiPolygon"===e.type&&(e.coordinates=e.coordinates.map(x(w,t)));return e}(t,r);default:return t}};function x(e,t){return function(r){return e(r,t)}}function w(e,t){t=!!t,e[0]=S(e[0],t);for(var r=1;r<e.length;r++)e[r]=S(e[r],!t);return e}function S(e,t){return function(e){return v.ring(e)>=0}(e)===t?e:e.reverse()}var M=e.vectorTile.VectorTileFeature.prototype.toGeoJSON,k=function(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));};k.prototype.loadGeometry=function(){if(1===this._feature.type){for(var t=[],r=0,o=this._feature.geometry;r<o.length;r+=1){var i=o[r];t.push([new e.Point$1(i[0],i[1])]);}return t}for(var n=[],a=0,s=this._feature.geometry;a<s.length;a+=1){for(var u=[],l=0,h=s[a];l<h.length;l+=1){var c=h[l];u.push(new e.Point$1(c[0],c[1]));}n.push(u);}return n},k.prototype.toGeoJSON=function(e,t,r){return M.call(this,e,t,r)};var b=function(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;};b.prototype.feature=function(e){return new k(this._features[e])};var _=e.vectorTile.VectorTileFeature,P=I;function I(e,t){this.options=t||{},this.features=e,this.length=e.length;}function T(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}I.prototype.feature=function(e){return new T(this.features[e],this.options.extent)},T.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var o=t[r],i=[],n=0;n<o.length;n++)i.push(new e.Point$1(o[n][0],o[n][1]));this.geometry.push(i);}return this.geometry},T.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,o=1/0,i=-1/0,n=0;n<e.length;n++)for(var a=e[n],s=0;s<a.length;s++){var u=a[s];t=Math.min(t,u.x),r=Math.max(r,u.x),o=Math.min(o,u.y),i=Math.max(i,u.y);}return [t,o,r,i]},T.prototype.toGeoJSON=_.prototype.toGeoJSON;var L=O,D=O,C=function(e,t){t=t||{};var r={};for(var o in e)r[o]=new P(e[o].features,t),r[o].name=o,r[o].version=t.version,r[o].extent=t.extent;return O({layers:r})},z=P;function O(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,E,e.layers[r]);}(t,r),r.finish()}function E(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var o={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)o.feature=e.feature(r),t.writeMessage(2,N,o);var i=o.keys;for(r=0;r<i.length;r++)t.writeStringField(3,i[r]);var n=o.values;for(r=0;r<n.length;r++)t.writeMessage(4,G,n[r]);}function N(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,F,e),t.writeVarintField(3,r.type),t.writeMessage(4,J,r);}function F(e,t){var r=e.feature,o=e.keys,i=e.values,n=e.keycache,a=e.valuecache;for(var s in r.properties){var u=n[s];void 0===u&&(o.push(s),u=o.length-1,n[s]=u),t.writeVarint(u);var l=r.properties[s],h=typeof l;"string"!==h&&"boolean"!==h&&"number"!==h&&(l=JSON.stringify(l));var c=h+":"+l,p=a[c];void 0===p&&(i.push(l),p=i.length-1,a[c]=p),t.writeVarint(p);}}function A(e,t){return (t<<3)+(7&e)}function B(e){return e<<1^e>>31}function J(e,t){for(var r=e.loadGeometry(),o=e.type,i=0,n=0,a=r.length,s=0;s<a;s++){var u=r[s],l=1;1===o&&(l=u.length),t.writeVarint(A(1,l));for(var h=3===o?u.length-1:u.length,c=0;c<h;c++){1===c&&1!==o&&t.writeVarint(A(2,h-1));var p=u[c].x-i,f=u[c].y-n;t.writeVarint(B(p)),t.writeVarint(B(f)),i+=p,n+=f;}3===o&&t.writeVarint(A(7,1));}}function G(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function Z(e,t,r,o,i,n){if(!(i-o<=r)){var a=o+i>>1;!function e(t,r,o,i,n,a){for(;n>i;){if(n-i>600){var s=n-i+1,u=o-i+1,l=Math.log(s),h=.5*Math.exp(2*l/3),c=.5*Math.sqrt(l*h*(s-h)/s)*(u-s/2<0?-1:1),p=Math.max(i,Math.floor(o-u*h/s+c)),f=Math.min(n,Math.floor(o+(s-u)*h/s+c));e(t,r,o,p,f,a);}var d=r[2*o+a],g=i,m=n;for(j(t,r,i,o),r[2*n+a]>d&&j(t,r,i,n);g<m;){for(j(t,r,g,m),g++,m--;r[2*g+a]<d;)g++;for(;r[2*m+a]>d;)m--;}r[2*i+a]===d?j(t,r,i,m):j(t,r,++m,n),m<=o&&(i=m+1),o<=m&&(n=m-1);}}(e,t,a,o,i,n%2),Z(e,t,r,o,a-1,n+1),Z(e,t,r,a+1,i,n+1);}}function j(e,t,r,o){Y(e,r,o),Y(t,2*r,2*o),Y(t,2*r+1,2*o+1);}function Y(e,t,r){var o=e[t];e[t]=e[r],e[r]=o;}function V(e,t,r,o){var i=e-r,n=t-o;return i*i+n*n}L.fromVectorTileJs=D,L.fromGeojsonVt=C,L.GeoJSONWrapper=z;var X=function(e){return e[0]},W=function(e){return e[1]},R=function(e,t,r,o,i){void 0===t&&(t=X),void 0===r&&(r=W),void 0===o&&(o=64),void 0===i&&(i=Float64Array),this.nodeSize=o,this.points=e;for(var n=e.length<65536?Uint16Array:Uint32Array,a=this.ids=new n(e.length),s=this.coords=new i(2*e.length),u=0;u<e.length;u++)a[u]=u,s[2*u]=t(e[u]),s[2*u+1]=r(e[u]);Z(a,s,o,0,a.length-1,0);};R.prototype.range=function(e,t,r,o){return function(e,t,r,o,i,n,a){for(var s,u,l=[0,e.length-1,0],h=[];l.length;){var c=l.pop(),p=l.pop(),f=l.pop();if(p-f<=a)for(var d=f;d<=p;d++)s=t[2*d],u=t[2*d+1],s>=r&&s<=i&&u>=o&&u<=n&&h.push(e[d]);else{var g=Math.floor((f+p)/2);s=t[2*g],u=t[2*g+1],s>=r&&s<=i&&u>=o&&u<=n&&h.push(e[g]);var m=(c+1)%2;(0===c?r<=s:o<=u)&&(l.push(f),l.push(g-1),l.push(m)),(0===c?i>=s:n>=u)&&(l.push(g+1),l.push(p),l.push(m));}}return h}(this.ids,this.coords,e,t,r,o,this.nodeSize)},R.prototype.within=function(e,t,r){return function(e,t,r,o,i,n){for(var a=[0,e.length-1,0],s=[],u=i*i;a.length;){var l=a.pop(),h=a.pop(),c=a.pop();if(h-c<=n)for(var p=c;p<=h;p++)V(t[2*p],t[2*p+1],r,o)<=u&&s.push(e[p]);else{var f=Math.floor((c+h)/2),d=t[2*f],g=t[2*f+1];V(d,g,r,o)<=u&&s.push(e[f]);var m=(l+1)%2;(0===l?r-i<=d:o-i<=g)&&(a.push(c),a.push(f-1),a.push(m)),(0===l?r+i>=d:o+i>=g)&&(a.push(f+1),a.push(h),a.push(m));}}return s}(this.ids,this.coords,e,t,r,this.nodeSize)};var q={minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,reduce:null,map:function(e){return e}},U=function(e){this.options=re(Object.create(q),e),this.trees=new Array(this.options.maxZoom+1);};function $(e,t,r,o,i){return {x:e,y:t,zoom:1/0,id:r,parentId:-1,numPoints:o,properties:i}}function H(e,t){var r=e.geometry.coordinates,o=r[0],i=r[1];return {x:ee(o),y:te(i),zoom:1/0,index:t,parentId:-1}}function K(e){return {type:"Feature",id:e.id,properties:Q(e),geometry:{type:"Point",coordinates:[(o=e.x,360*(o-.5)),(t=e.y,r=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(r))/Math.PI-90)]}};var t,r,o;}function Q(e){var t=e.numPoints,r=t>=1e4?Math.round(t/1e3)+"k":t>=1e3?Math.round(t/100)/10+"k":t;return re(re({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function ee(e){return e/360+.5}function te(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function re(e,t){for(var r in t)e[r]=t[r];return e}function oe(e){return e.x}function ie(e){return e.y}function ne(e,t,r,o,i,n){var a=i-r,s=n-o;if(0!==a||0!==s){var u=((e-r)*a+(t-o)*s)/(a*a+s*s);u>1?(r=i,o=n):u>0&&(r+=a*u,o+=s*u);}return (a=e-r)*a+(s=t-o)*s}function ae(e,t,r,o){var i={id:void 0===e?null:e,type:t,geometry:r,tags:o,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)se(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var o=0;o<t.length;o++)se(e,t[o]);else if("MultiPolygon"===r)for(o=0;o<t.length;o++)for(var i=0;i<t[o].length;i++)se(e,t[o][i]);}(i),i}function se(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function ue(e,t,r,o){if(t.geometry){var i=t.geometry.coordinates,n=t.geometry.type,a=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),s=[],u=t.id;if(r.promoteId?u=t.properties[r.promoteId]:r.generateId&&(u=o||0),"Point"===n)le(i,s);else if("MultiPoint"===n)for(var l=0;l<i.length;l++)le(i[l],s);else if("LineString"===n)he(i,s,a,!1);else if("MultiLineString"===n){if(r.lineMetrics){for(l=0;l<i.length;l++)s=[],he(i[l],s,a,!1),e.push(ae(u,"LineString",s,t.properties));return}ce(i,s,a,!1);}else if("Polygon"===n)ce(i,s,a,!0);else{if("MultiPolygon"!==n){if("GeometryCollection"===n){for(l=0;l<t.geometry.geometries.length;l++)ue(e,{id:u,geometry:t.geometry.geometries[l],properties:t.properties},r,o);return}throw new Error("Input data is not a valid GeoJSON object.")}for(l=0;l<i.length;l++){var h=[];ce(i[l],h,a,!0),s.push(h);}}e.push(ae(u,n,s,t.properties));}}function le(e,t){t.push(pe(e[0])),t.push(fe(e[1])),t.push(0);}function he(e,t,r,o){for(var i,n,a=0,s=0;s<e.length;s++){var u=pe(e[s][0]),l=fe(e[s][1]);t.push(u),t.push(l),t.push(0),s>0&&(a+=o?(i*l-u*n)/2:Math.sqrt(Math.pow(u-i,2)+Math.pow(l-n,2))),i=u,n=l;}var h=t.length-3;t[2]=1,function e(t,r,o,i){for(var n,a=i,s=o-r>>1,u=o-r,l=t[r],h=t[r+1],c=t[o],p=t[o+1],f=r+3;f<o;f+=3){var d=ne(t[f],t[f+1],l,h,c,p);if(d>a)n=f,a=d;else if(d===a){var g=Math.abs(f-s);g<u&&(n=f,u=g);}}a>i&&(n-r>3&&e(t,r,n,i),t[n+2]=a,o-n>3&&e(t,n,o,i));}(t,0,h,r),t[h+2]=1,t.size=Math.abs(a),t.start=0,t.end=t.size;}function ce(e,t,r,o){for(var i=0;i<e.length;i++){var n=[];he(e[i],n,r,o),t.push(n);}}function pe(e){return e/360+.5}function fe(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function de(e,t,r,o,i,n,a,s){if(o/=t,n>=(r/=t)&&a<o)return e;if(a<r||n>=o)return null;for(var u=[],l=0;l<e.length;l++){var h=e[l],c=h.geometry,p=h.type,f=0===i?h.minX:h.minY,d=0===i?h.maxX:h.maxY;if(f>=r&&d<o)u.push(h);else if(!(d<r||f>=o)){var g=[];if("Point"===p||"MultiPoint"===p)ge(c,g,r,o,i);else if("LineString"===p)me(c,g,r,o,i,!1,s.lineMetrics);else if("MultiLineString"===p)ye(c,g,r,o,i,!1);else if("Polygon"===p)ye(c,g,r,o,i,!0);else if("MultiPolygon"===p)for(var m=0;m<c.length;m++){var v=[];ye(c[m],v,r,o,i,!0),v.length&&g.push(v);}if(g.length){if(s.lineMetrics&&"LineString"===p){for(m=0;m<g.length;m++)u.push(ae(h.id,p,g[m],h.tags));continue}"LineString"!==p&&"MultiLineString"!==p||(1===g.length?(p="LineString",g=g[0]):p="MultiLineString"),"Point"!==p&&"MultiPoint"!==p||(p=3===g.length?"Point":"MultiPoint"),u.push(ae(h.id,p,g,h.tags));}}}return u.length?u:null}function ge(e,t,r,o,i){for(var n=0;n<e.length;n+=3){var a=e[n+i];a>=r&&a<=o&&(t.push(e[n]),t.push(e[n+1]),t.push(e[n+2]));}}function me(e,t,r,o,i,n,a){for(var s,u,l=ve(e),h=0===i?we:Se,c=e.start,p=0;p<e.length-3;p+=3){var f=e[p],d=e[p+1],g=e[p+2],m=e[p+3],v=e[p+4],y=0===i?f:d,x=0===i?m:v,w=!1;a&&(s=Math.sqrt(Math.pow(f-m,2)+Math.pow(d-v,2))),y<r?x>r&&(u=h(l,f,d,m,v,r),a&&(l.start=c+s*u)):y>o?x<o&&(u=h(l,f,d,m,v,o),a&&(l.start=c+s*u)):xe(l,f,d,g),x<r&&y>=r&&(u=h(l,f,d,m,v,r),w=!0),x>o&&y<=o&&(u=h(l,f,d,m,v,o),w=!0),!n&&w&&(a&&(l.end=c+s*u),t.push(l),l=ve(e)),a&&(c+=s);}var S=e.length-3;f=e[S],d=e[S+1],g=e[S+2],(y=0===i?f:d)>=r&&y<=o&&xe(l,f,d,g),S=l.length-3,n&&S>=3&&(l[S]!==l[0]||l[S+1]!==l[1])&&xe(l,l[0],l[1],l[2]),l.length&&t.push(l);}function ve(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function ye(e,t,r,o,i,n){for(var a=0;a<e.length;a++)me(e[a],t,r,o,i,n,!1);}function xe(e,t,r,o){e.push(t),e.push(r),e.push(o);}function we(e,t,r,o,i,n){var a=(n-t)/(o-t);return e.push(n),e.push(r+(i-r)*a),e.push(1),a}function Se(e,t,r,o,i,n){var a=(n-r)/(i-r);return e.push(t+(o-t)*a),e.push(n),e.push(1),a}function Me(e,t){for(var r=[],o=0;o<e.length;o++){var i,n=e[o],a=n.type;if("Point"===a||"MultiPoint"===a||"LineString"===a)i=ke(n.geometry,t);else if("MultiLineString"===a||"Polygon"===a){i=[];for(var s=0;s<n.geometry.length;s++)i.push(ke(n.geometry[s],t));}else if("MultiPolygon"===a)for(i=[],s=0;s<n.geometry.length;s++){for(var u=[],l=0;l<n.geometry[s].length;l++)u.push(ke(n.geometry[s][l],t));i.push(u);}r.push(ae(n.id,a,i,n.tags));}return r}function ke(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var o=0;o<e.length;o+=3)r.push(e[o]+t,e[o+1],e[o+2]);return r}function be(e,t){if(e.transformed)return e;var r,o,i,n=1<<e.z,a=e.x,s=e.y;for(r=0;r<e.features.length;r++){var u=e.features[r],l=u.geometry,h=u.type;if(u.geometry=[],1===h)for(o=0;o<l.length;o+=2)u.geometry.push(_e(l[o],l[o+1],t,n,a,s));else for(o=0;o<l.length;o++){var c=[];for(i=0;i<l[o].length;i+=2)c.push(_e(l[o][i],l[o][i+1],t,n,a,s));u.geometry.push(c);}}return e.transformed=!0,e}function _e(e,t,r,o,i,n){return [Math.round(r*(e*o-i)),Math.round(r*(t*o-n))]}function Pe(e,t,r,o,i){for(var n=t===i.maxZoom?0:i.tolerance/((1<<t)*i.extent),a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:o,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},s=0;s<e.length;s++){a.numFeatures++,Ie(a,e[s],n,i);var u=e[s].minX,l=e[s].minY,h=e[s].maxX,c=e[s].maxY;u<a.minX&&(a.minX=u),l<a.minY&&(a.minY=l),h>a.maxX&&(a.maxX=h),c>a.maxY&&(a.maxY=c);}return a}function Ie(e,t,r,o){var i=t.geometry,n=t.type,a=[];if("Point"===n||"MultiPoint"===n)for(var s=0;s<i.length;s+=3)a.push(i[s]),a.push(i[s+1]),e.numPoints++,e.numSimplified++;else if("LineString"===n)Te(a,i,e,r,!1,!1);else if("MultiLineString"===n||"Polygon"===n)for(s=0;s<i.length;s++)Te(a,i[s],e,r,"Polygon"===n,0===s);else if("MultiPolygon"===n)for(var u=0;u<i.length;u++){var l=i[u];for(s=0;s<l.length;s++)Te(a,l[s],e,r,!0,0===s);}if(a.length){var h=t.tags||null;if("LineString"===n&&o.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=i.start/i.size,h.mapbox_clip_end=i.end/i.size;}var p={geometry:a,type:"Polygon"===n||"MultiPolygon"===n?3:"LineString"===n||"MultiLineString"===n?2:1,tags:h};null!==t.id&&(p.id=t.id),e.features.push(p);}}function Te(e,t,r,o,i,n){var a=o*o;if(o>0&&t.size<(i?a:o))r.numPoints+=t.length/3;else{for(var s=[],u=0;u<t.length;u+=3)(0===o||t[u+2]>a)&&(r.numSimplified++,s.push(t[u]),s.push(t[u+1])),r.numPoints++;i&&function(e,t){for(var r=0,o=0,i=e.length,n=i-2;o<i;n=o,o+=2)r+=(e[o]-e[n])*(e[o+1]+e[n+1]);if(r>0===t)for(o=0,i=e.length;o<i/2;o+=2){var a=e[o],s=e[o+1];e[o]=e[i-2-o],e[o+1]=e[i-1-o],e[i-2-o]=a,e[i-1-o]=s;}}(s,n),e.push(s);}}function Le(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var o=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var o=0;o<e.features.length;o++)ue(r,e.features[o],t,o);else"Feature"===e.type?ue(r,e,t):ue(r,{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(o=function(e,t){var r=t.buffer/t.extent,o=e,i=de(e,1,-1-r,r,0,-1,2,t),n=de(e,1,1-r,2+r,0,-1,2,t);return (i||n)&&(o=de(e,1,-r,1+r,0,-1,2,t)||[],i&&(o=Me(i,1).concat(o)),n&&(o=o.concat(Me(n,-1)))),o}(o,t)).length&&this.splitTile(o,0,0,0),r&&(o.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function De(e,t,r){return 32*((1<<e)*r+t)+e}function Ce(e,t){var r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);var o=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!o)return t(null,null);var i=new b(o.features),n=L(i);0===n.byteOffset&&n.byteLength===n.buffer.byteLength||(n=new Uint8Array(n)),t(null,{vectorTile:i,rawData:n.buffer});}U.prototype.load=function(e){var t=this.options,r=t.log,o=t.minZoom,i=t.maxZoom,n=t.nodeSize;r&&console.time("total time");var a="prepare "+e.length+" points";r&&console.time(a),this.points=e;for(var s=[],u=0;u<e.length;u++)e[u].geometry&&s.push(H(e[u],u));this.trees[i+1]=new R(s,oe,ie,n,Float32Array),r&&console.timeEnd(a);for(var l=i;l>=o;l--){var h=+Date.now();s=this._cluster(s,l),this.trees[l]=new R(s,oe,ie,n,Float32Array),r&&console.log("z%d: %d clusters in %dms",l,s.length,+Date.now()-h);}return r&&console.timeEnd("total time"),this},U.prototype.getClusters=function(e,t){var r=((e[0]+180)%360+360)%360-180,o=Math.max(-90,Math.min(90,e[1])),i=180===e[2]?180:((e[2]+180)%360+360)%360-180,n=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,i=180;else if(r>i){var a=this.getClusters([r,o,180,n],t),s=this.getClusters([-180,o,i,n],t);return a.concat(s)}for(var u=this.trees[this._limitZoom(t)],l=[],h=0,c=u.range(ee(r),te(n),ee(i),te(o));h<c.length;h+=1){var p=c[h],f=u.points[p];l.push(f.numPoints?K(f):this.points[f.index]);}return l},U.prototype.getChildren=function(e){var t=e>>5,r=e%32,o="No cluster with the specified id.",i=this.trees[r];if(!i)throw new Error(o);var n=i.points[t];if(!n)throw new Error(o);for(var a=this.options.radius/(this.options.extent*Math.pow(2,r-1)),s=[],u=0,l=i.within(n.x,n.y,a);u<l.length;u+=1){var h=l[u],c=i.points[h];c.parentId===e&&s.push(c.numPoints?K(c):this.points[c.index]);}if(0===s.length)throw new Error(o);return s},U.prototype.getLeaves=function(e,t,r){t=t||10,r=r||0;var o=[];return this._appendLeaves(o,e,t,r,0),o},U.prototype.getTile=function(e,t,r){var o=this.trees[this._limitZoom(e)],i=Math.pow(2,e),n=this.options,a=n.extent,s=n.radius/a,u=(r-s)/i,l=(r+1+s)/i,h={features:[]};return this._addTileFeatures(o.range((t-s)/i,u,(t+1+s)/i,l),o.points,t,r,i,h),0===t&&this._addTileFeatures(o.range(1-s/i,u,1,l),o.points,i,r,i,h),t===i-1&&this._addTileFeatures(o.range(0,u,s/i,l),o.points,-1,r,i,h),h.features.length?h:null},U.prototype.getClusterExpansionZoom=function(e){for(var t=e%32-1;t<=this.options.maxZoom;){var r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t},U.prototype._appendLeaves=function(e,t,r,o,i){for(var n=0,a=this.getChildren(t);n<a.length;n+=1){var s=a[n],u=s.properties;if(u&&u.cluster?i+u.point_count<=o?i+=u.point_count:i=this._appendLeaves(e,u.cluster_id,r,o,i):i<o?i++:e.push(s),e.length===r)break}return i},U.prototype._addTileFeatures=function(e,t,r,o,i,n){for(var a=0,s=e;a<s.length;a+=1){var u=t[s[a]],l={type:1,geometry:[[Math.round(this.options.extent*(u.x*i-r)),Math.round(this.options.extent*(u.y*i-o))]],tags:u.numPoints?Q(u):this.points[u.index].properties},h=u.numPoints?u.id:this.points[u.index].id;void 0!==h&&(l.id=h),n.features.push(l);}},U.prototype._limitZoom=function(e){return Math.max(this.options.minZoom,Math.min(e,this.options.maxZoom+1))},U.prototype._cluster=function(e,t){for(var r=[],o=this.options,i=o.radius,n=o.extent,a=o.reduce,s=i/(n*Math.pow(2,t)),u=0;u<e.length;u++){var l=e[u];if(!(l.zoom<=t)){l.zoom=t;for(var h=this.trees[t+1],c=h.within(l.x,l.y,s),p=l.numPoints||1,f=l.x*p,d=l.y*p,g=a&&p>1?this._map(l,!0):null,m=(u<<5)+(t+1),v=0,y=c;v<y.length;v+=1){var x=y[v],w=h.points[x];if(!(w.zoom<=t)){w.zoom=t;var S=w.numPoints||1;f+=w.x*S,d+=w.y*S,p+=S,w.parentId=m,a&&(g||(g=this._map(l,!0)),a(g,this._map(w)));}}1===p?r.push(l):(l.parentId=m,r.push($(f/p,d/p,m,p,g)));}}return r},U.prototype._map=function(e,t){if(e.numPoints)return t?re({},e.properties):e.properties;var r=this.points[e.index].properties,o=this.options.map(r);return t&&o===r?re({},o):o},Le.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},Le.prototype.splitTile=function(e,t,r,o,i,n,a){for(var s=[e,t,r,o],u=this.options,l=u.debug;s.length;){o=s.pop(),r=s.pop(),t=s.pop(),e=s.pop();var h=1<<t,c=De(t,r,o),p=this.tiles[c];if(!p&&(l>1&&console.time("creation"),p=this.tiles[c]=Pe(e,t,r,o,u),this.tileCoords.push({z:t,x:r,y:o}),l)){l>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,o,p.numFeatures,p.numPoints,p.numSimplified),console.timeEnd("creation"));var f="z"+t;this.stats[f]=(this.stats[f]||0)+1,this.total++;}if(p.source=e,i){if(t===u.maxZoom||t===i)continue;var d=1<<i-t;if(r!==Math.floor(n/d)||o!==Math.floor(a/d))continue}else if(t===u.indexMaxZoom||p.numPoints<=u.indexMaxPoints)continue;if(p.source=null,0!==e.length){l>1&&console.time("clipping");var g,m,v,y,x,w,S=.5*u.buffer/u.extent,M=.5-S,k=.5+S,b=1+S;g=m=v=y=null,x=de(e,h,r-S,r+k,0,p.minX,p.maxX,u),w=de(e,h,r+M,r+b,0,p.minX,p.maxX,u),e=null,x&&(g=de(x,h,o-S,o+k,1,p.minY,p.maxY,u),m=de(x,h,o+M,o+b,1,p.minY,p.maxY,u),x=null),w&&(v=de(w,h,o-S,o+k,1,p.minY,p.maxY,u),y=de(w,h,o+M,o+b,1,p.minY,p.maxY,u),w=null),l>1&&console.timeEnd("clipping"),s.push(g||[],t+1,2*r,2*o),s.push(m||[],t+1,2*r,2*o+1),s.push(v||[],t+1,2*r+1,2*o),s.push(y||[],t+1,2*r+1,2*o+1);}}},Le.prototype.getTile=function(e,t,r){var o=this.options,i=o.extent,n=o.debug;if(e<0||e>24)return null;var a=1<<e,s=De(e,t=(t%a+a)%a,r);if(this.tiles[s])return be(this.tiles[s],i);n>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var u,l=e,h=t,c=r;!u&&l>0;)l--,h=Math.floor(h/2),c=Math.floor(c/2),u=this.tiles[De(l,h,c)];return u&&u.source?(n>1&&console.log("found parent tile z%d-%d-%d",l,h,c),n>1&&console.time("drilling down"),this.splitTile(u.source,l,h,c,e,t,r),n>1&&console.timeEnd("drilling down"),this.tiles[s]?be(this.tiles[s],i):null):null};var ze=function(t){function r(e,r,o){t.call(this,e,r,Ce),o&&(this.loadGeoJSON=o);}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.loadData=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=t,this._pendingLoadDataParams=e,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData());},r.prototype._loadData=function(){var t=this;if(this._pendingCallback&&this._pendingLoadDataParams){var r=this._pendingCallback,o=this._pendingLoadDataParams;delete this._pendingCallback,delete this._pendingLoadDataParams;var i=!!(o&&o.request&&o.request.collectResourceTiming)&&new u.Performance(o.request);this.loadGeoJSON(o,(function(n,a){if(n||!a)return r(n);if("object"!=typeof a)return r(new Error("Input data given to '"+o.source+"' is not a valid GeoJSON object."));y(a,!0);try{t._geoJSONIndex=o.cluster?new U(function(t){var r=t.superclusterOptions,o=t.clusterProperties;if(!o||!r)return r;for(var i={},n={},a={accumulated:null,zoom:0},s={properties:null},u=Object.keys(o),l=0,h=u;l<h.length;l+=1){var c=h[l],p=o[c],f=p[0],d=p[1],g=e.createExpression(d),m=e.createExpression("string"==typeof f?[f,["accumulated"],["get",c]]:f);i[c]=g.value,n[c]=m.value;}return r.map=function(e){s.properties=e;for(var t={},r=0,o=u;r<o.length;r+=1){var n=o[r];t[n]=i[n].evaluate(a,s);}return t},r.reduce=function(e,t){s.properties=t;for(var r=0,o=u;r<o.length;r+=1){var i=o[r];a.accumulated=e[i],e[i]=n[i].evaluate(a,s);}},r}(o)).load(a.features):function(e,t){return new Le(e,t)}(a,o.geojsonVtOptions);}catch(n){return r(n)}t.loaded={};var s={};if(i){var u=i.finish();u&&(s.resourceTiming={},s.resourceTiming[o.source]=JSON.parse(JSON.stringify(u)));}r(null,s);}));}},r.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData());},r.prototype.reloadTile=function(e,r){var o=this.loaded,i=e.uid;return o&&o[i]?t.prototype.reloadTile.call(this,e,r):this.loadTile(e,r)},r.prototype.loadGeoJSON=function(t,r){if(t.request)e.getJSON(t.request,r);else{if("string"!=typeof t.data)return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),t();},r.prototype.getClusterExpansionZoom=function(e,t){t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));},r.prototype.getClusterChildren=function(e,t){t(null,this._geoJSONIndex.getChildren(e.clusterId));},r.prototype.getClusterLeaves=function(e,t){t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));},r}(c);var Oe=function(t){var r=this;this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.workerSourceTypes={vector:c,geojson:ze},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,t){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=function(t){if(e.plugin.isLoaded())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};};return Oe.prototype.setReferrer=function(e,t){this.referrer=t;},Oe.prototype.setLayers=function(e,t,r){this.getLayerIndex(e).replace(t),r();},Oe.prototype.updateLayers=function(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();},Oe.prototype.loadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).loadTile(t,r);},Oe.prototype.loadDEMTile=function(e,t,r){this.getDEMWorkerSource(e,t.source).loadTile(t,r);},Oe.prototype.reloadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).reloadTile(t,r);},Oe.prototype.abortTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);},Oe.prototype.removeTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);},Oe.prototype.removeDEMTile=function(e,t){this.getDEMWorkerSource(e,t.source).removeTile(t);},Oe.prototype.removeSource=function(e,t,r){if(this.workerSources[e]&&this.workerSources[e][t.type]&&this.workerSources[e][t.type][t.source]){var o=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==o.removeSource?o.removeSource(t,r):r();}},Oe.prototype.loadWorkerSource=function(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}},Oe.prototype.loadRTLTextPlugin=function(t,r,o){try{e.plugin.isLoaded()||(this.self.importScripts(r),o(e.plugin.isLoaded()?null:new Error("RTL Text Plugin failed to import scripts from "+r)));}catch(e){o(e.toString());}},Oe.prototype.getLayerIndex=function(e){var t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new o),t},Oe.prototype.getWorkerSource=function(e,t,r){var o=this;if(this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),!this.workerSources[e][t][r]){var i={send:function(t,r,i){o.actor.send(t,r,i,e);}};this.workerSources[e][t][r]=new this.workerSourceTypes[t](i,this.getLayerIndex(e));}return this.workerSources[e][t][r]},Oe.prototype.getDEMWorkerSource=function(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new p),this.demWorkerSources[e][t]},Oe.prototype.enforceCacheSizeLimit=function(t,r){e.enforceCacheSizeLimit(r);},"undefined"!=typeof WorkerGlobalScope&&void 0!==e.window&&e.window instanceof WorkerGlobalScope&&(e.window.worker=new Oe(e.window)),Oe}));
	
	define(["./shared"],(function(t){"use strict";var e=t.createCommonjsModule((function(t){function e(t){return !!("undefined"!=typeof window&&"undefined"!=typeof document&&Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray&&Function.prototype&&Function.prototype.bind&&Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions&&"JSON"in window&&"parse"in JSON&&"stringify"in JSON&&function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var t,e,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{e=new Worker(o),t=!0;}catch(e){t=!1;}e&&e.terminate();return URL.revokeObjectURL(o),t}()&&"Uint8ClampedArray"in window&&ArrayBuffer.isView&&function(t){void 0===i[t]&&(i[t]=function(t){var i=document.createElement("canvas"),o=Object.create(e.webGLContextAttributes);return o.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",o)||i.probablySupportsContext("experimental-webgl",o):i.supportsContext?i.supportsContext("webgl",o)||i.supportsContext("experimental-webgl",o):i.getContext("webgl",o)||i.getContext("experimental-webgl",o)}(t));return i[t]}(t&&t.failIfMajorPerformanceCaveat))}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e);var i={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};})),i={create:function(e,i,o){var r=t.window.document.createElement(e);return void 0!==i&&(r.className=i),o&&o.appendChild(r),r},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},o=t.window.document.documentElement.style;function r(t){if(!o)return t[0];for(var e=0;e<t.length;e++)if(t[e]in o)return t[e];return t[0]}var a,n=r(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){o&&n&&(a=o[n],o[n]="none");},i.enableDrag=function(){o&&n&&(o[n]=a);};var s=r(["transform","WebkitTransform"]);i.setTransform=function(t,e){t.style[s]=e;};var l=!1;try{var c=Object.defineProperty({},"passive",{get:function(){l=!0;}});t.window.addEventListener("test",c,c),t.window.removeEventListener("test",c,c);}catch(t){l=!1;}i.addEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.addEventListener(e,i,o):t.addEventListener(e,i,o.capture);},i.removeEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.removeEventListener(e,i,o):t.removeEventListener(e,i,o.capture);};var u=function(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",u,!0);};function h(t){var e=t.userImage;if(e&&e.render&&e.render())return t.data.replace(new Uint8Array(e.data.buffer)),!0;return !1}i.suppressClick=function(){t.window.addEventListener("click",u,!0),t.window.setTimeout((function(){t.window.removeEventListener("click",u,!0);}),0);},i.mousePos=function(e,i){var o=e.getBoundingClientRect(),r=t.window.TouchEvent&&i instanceof t.window.TouchEvent?i.touches[0]:i;return new t.Point(r.clientX-o.left-e.clientLeft,r.clientY-o.top-e.clientTop)},i.touchPos=function(e,i){for(var o=e.getBoundingClientRect(),r=[],a="touchend"===i.type?i.changedTouches:i.touches,n=0;n<a.length;n++)r.push(new t.Point(a[n].clientX-o.left-e.clientLeft,a[n].clientY-o.top-e.clientTop));return r},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&t.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t);};var p=function(e){function i(){e.call(this),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new t.RGBAImage({width:1,height:1}),this.dirty=!0;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.isLoaded=function(){return this.loaded},i.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t,t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var o=i[e],r=o.ids,a=o.callback;this._notify(r,a);}this.requestors=[];}},i.prototype.getImage=function(t){return this.images[t]},i.prototype.addImage=function(t,e){this.images[t]=e;},i.prototype.updateImage=function(t,e){var i=this.images[t];e.version=i.version+1,this.images[t]=e,this.updatedImages[t]=!0;},i.prototype.removeImage=function(t){var e=this.images[t];delete this.images[t],delete this.patterns[t],e.userImage&&e.userImage.onRemove&&e.userImage.onRemove();},i.prototype.listImages=function(){return Object.keys(this.images)},i.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var o=0,r=t;o<r.length;o+=1){var a=r[o];this.images[a]||(i=!1);}this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e});},i.prototype._notify=function(e,i){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r];this.images[n]||this.fire(new t.Event("styleimagemissing",{id:n}));var s=this.images[n];s?o[n]={data:s.data.clone(),pixelRatio:s.pixelRatio,sdf:s.sdf,version:s.version,hasRenderCallback:Boolean(s.userImage&&s.userImage.render)}:t.warnOnce('Image "'+n+'" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');}i(null,o);},i.prototype.getPixelSize=function(){var t=this.atlasImage;return {width:t.width,height:t.height}},i.prototype.getPattern=function(e){var i=this.patterns[e],o=this.getImage(e);if(!o)return null;if(i&&i.position.version===o.version)return i.position;if(i)i.position.version=o.version;else{var r={w:o.data.width+2,h:o.data.height+2,x:0,y:0},a=new t.ImagePosition(r,o);this.patterns[e]={bin:r,position:a};}return this._updatePatternAtlas(),this.patterns[e].position},i.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);},i.prototype._updatePatternAtlas=function(){var e=[];for(var i in this.patterns)e.push(this.patterns[i].bin);var o=t.potpack(e),r=o.w,a=o.h,n=this.atlasImage;for(var s in n.resize({width:r||1,height:a||1}),this.patterns){var l=this.patterns[s].bin,c=l.x+1,u=l.y+1,h=this.images[s].data,p=h.width,d=h.height;t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u},{width:p,height:d}),t.RGBAImage.copy(h,n,{x:0,y:d-1},{x:c,y:u-1},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u+d},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:p-1,y:0},{x:c-1,y:u},{width:1,height:d}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c+p,y:u},{width:1,height:d});}this.dirty=!0;},i.prototype.beginFrame=function(){this.callbackDispatchedThisFrame={};},i.prototype.dispatchRenderCallbacks=function(t){for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!this.callbackDispatchedThisFrame[o]){this.callbackDispatchedThisFrame[o]=!0;var r=this.images[o];h(r)&&this.updateImage(o,r);}}},i}(t.Evented);var d=m,_=m,f=1e20;function m(t,e,i,o,r,a){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=o||.25,this.fontFamily=r||"sans-serif",this.fontWeight=a||"normal",this.radius=i||8;var n=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=n,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(n*n),this.gridInner=new Float64Array(n*n),this.f=new Float64Array(n),this.d=new Float64Array(n),this.z=new Float64Array(n+1),this.v=new Int16Array(n),this.middle=Math.round(n/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1));}function g(t,e,i,o,r,a,n){for(var s=0;s<e;s++){for(var l=0;l<i;l++)o[l]=t[l*e+s];for(v(o,r,a,n,i),l=0;l<i;l++)t[l*e+s]=r[l];}for(l=0;l<i;l++){for(s=0;s<e;s++)o[s]=t[l*e+s];for(v(o,r,a,n,e),s=0;s<e;s++)t[l*e+s]=Math.sqrt(r[s]);}}function v(t,e,i,o,r){i[0]=0,o[0]=-f,o[1]=+f;for(var a=1,n=0;a<r;a++){for(var s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);s<=o[n];)n--,s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);i[++n]=a,o[n]=s,o[n+1]=+f;}for(a=0,n=0;a<r;a++){for(;o[n+1]<a;)n++;e[a]=(a-i[n])*(a-i[n])+t[i[n]];}}m.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var e=this.ctx.getImageData(0,0,this.size,this.size),i=new Uint8ClampedArray(this.size*this.size),o=0;o<this.size*this.size;o++){var r=e.data[4*o+3]/255;this.gridOuter[o]=1===r?0:0===r?f:Math.pow(Math.max(0,.5-r),2),this.gridInner[o]=1===r?f:0===r?0:Math.pow(Math.max(0,r-.5),2);}for(g(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),g(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),o=0;o<this.size*this.size;o++){var a=this.gridOuter[o]-this.gridInner[o];i[o]=Math.max(0,Math.min(255,Math.round(255-255*(a/this.radius+this.cutoff))));}return i},d.default=_;var y=function(t,e){this.requestManager=t,this.localIdeographFontFamily=e,this.entries={};};y.prototype.setURL=function(t){this.url=t;},y.prototype.getGlyphs=function(e,i){var o=this,r=[];for(var a in e)for(var n=0,s=e[a];n<s.length;n+=1){var l=s[n];r.push({stack:a,id:l});}t.asyncAll(r,(function(t,e){var i=t.stack,r=t.id,a=o.entries[i];a||(a=o.entries[i]={glyphs:{},requests:{}});var n=a.glyphs[r];if(void 0===n){if(n=o._tinySDF(a,i,r))return a.glyphs[r]=n,void e(null,{stack:i,id:r,glyph:n});var s=Math.floor(r/256);if(256*s>65535)e(new Error("glyphs > 65535 not supported"));else{var l=a.requests[s];l||(l=a.requests[s]=[],y.loadGlyphRange(i,s,o.url,o.requestManager,(function(t,e){if(e)for(var i in e)o._doesCharSupportLocalGlyph(+i)||(a.glyphs[+i]=e[+i]);for(var r=0,n=l;r<n.length;r+=1){(0,n[r])(t,e);}delete a.requests[s];}))),l.push((function(t,o){t?e(t):o&&e(null,{stack:i,id:r,glyph:o[r]||null});}));}}else e(null,{stack:i,id:r,glyph:n});}),(function(t,e){if(t)i(t);else if(e){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r],s=n.stack,l=n.id,c=n.glyph;(o[s]||(o[s]={}))[l]=c&&{id:c.id,bitmap:c.bitmap.clone(),metrics:c.metrics};}i(null,o);}}));},y.prototype._doesCharSupportLocalGlyph=function(e){return !!this.localIdeographFontFamily&&(t.isChar["CJK Unified Ideographs"](e)||t.isChar["Hangul Syllables"](e)||t.isChar.Hiragana(e)||t.isChar.Katakana(e))},y.prototype._tinySDF=function(e,i,o){var r=this.localIdeographFontFamily;if(r&&this._doesCharSupportLocalGlyph(o)){var a=e.tinySDF;if(!a){var n="400";/bold/i.test(i)?n="900":/medium/i.test(i)?n="500":/light/i.test(i)&&(n="200"),a=e.tinySDF=new y.TinySDF(24,3,8,.25,r,n);}return {id:o,bitmap:new t.AlphaImage({width:30,height:30},a.draw(String.fromCharCode(o))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},y.loadGlyphRange=function(e,i,o,r,a){var n=256*i,s=n+255,l=r.transformRequest(r.normalizeGlyphsURL(o).replace("{fontstack}",e).replace("{range}",n+"-"+s),t.ResourceType.Glyphs);t.getArrayBuffer(l,(function(e,i){if(e)a(e);else if(i){for(var o={},r=0,n=t.parseGlyphPBF(i);r<n.length;r+=1){var s=n[r];o[s.id]=s;}a(null,o);}}));},y.TinySDF=d;var x=function(){this.specification=t.styleSpec.light.position;};x.prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},x.prototype.interpolate=function(e,i,o){return {x:t.number(e.x,i.x,o),y:t.number(e.y,i.y,o),z:t.number(e.z,i.z,o)}};var b=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new x,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),w=function(e){function i(i){e.call(this),this._transitionable=new t.Transitionable(b),this.setLight(i),this._transitioning=this._transitionable.untransitioned();}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getLight=function(){return this._transitionable.serialize()},i.prototype.setLight=function(e,i){if(void 0===i&&(i={}),!this._validate(t.validateLight,e,i))for(var o in e){var r=e[o];t.endsWith(o,"-transition")?this._transitionable.setTransition(o.slice(0,-"-transition".length),r):this._transitionable.setValue(o,r);}},i.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning);},i.prototype.hasTransition=function(){return this._transitioning.hasTransition()},i.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t);},i.prototype._validate=function(e,i,o){return (!o||!1!==o.validate)&&t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},i}(t.Evented),E=function(t,e){this.width=t,this.height=e,this.nextRow=0,this.bytes=4,this.data=new Uint8Array(this.width*this.height*this.bytes),this.positions={};};E.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.positions[i]||(this.positions[i]=this.addDash(t,e)),this.positions[i]},E.prototype.addDash=function(e,i){var o=i?7:0,r=2*o+1;if(this.nextRow+r>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var a=0,n=0;n<e.length;n++)a+=e[n];for(var s=this.width/a,l=s/2,c=e.length%2==1,u=-o;u<=o;u++)for(var h=this.nextRow+o+u,p=this.width*h,d=c?-e[e.length-1]:0,_=e[0],f=1,m=0;m<this.width;m++){for(;_<m/s;)d=_,_+=e[f],c&&f===e.length-1&&(_+=e[0]),f++;var g=Math.abs(m-d*s),v=Math.abs(m-_*s),y=Math.min(g,v),x=f%2==1,b=void 0;if(i){var w=o?u/o*(l+1):0;if(x){var E=l-Math.abs(w);b=Math.sqrt(y*y+E*E);}else b=l-Math.sqrt(y*y+w*w);}else b=(x?1:-1)*y;this.data[3+4*(p+m)]=Math.max(0,Math.min(255,b+128));}var T={y:(this.nextRow+o+.5)/this.height,height:2*o/this.height,width:a};return this.nextRow+=r,this.dirty=!0,T},E.prototype.bind=function(t){var e=t.gl;this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.width,this.height,e.RGBA,e.UNSIGNED_BYTE,this.data))):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,this.width,this.height,0,e.RGBA,e.UNSIGNED_BYTE,this.data));};var T=function e(i,o){this.workerPool=i,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var r=this.workerPool.acquire(this.id),a=0;a<r.length;a++){var n=r[a],s=new e.Actor(n,o,this.id);s.name="Worker "+a,this.actors.push(s);}};function I(e,i,o){var r=function(r,a){if(r)return o(r);if(a){var n=t.pick(t.extend(a,e),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]);a.vector_layers&&(n.vectorLayers=a.vector_layers,n.vectorLayerIds=n.vectorLayers.map((function(t){return t.id}))),e.url&&(n.tiles=i.canonicalizeTileset(n,e.url)),o(null,n);}};return e.url?t.getJSON(i.transformRequest(i.normalizeSourceURL(e.url),t.ResourceType.Source),r):t.browser.frame((function(){return r(null,e)}))}T.prototype.broadcast=function(e,i,o){o=o||function(){},t.asyncAll(this.actors,(function(t,o){t.send(e,i,o);}),o);},T.prototype.getActor=function(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]},T.prototype.remove=function(){this.actors.forEach((function(t){t.remove();})),this.actors=[],this.workerPool.release(this.id);},T.Actor=t.Actor;var S=function(e,i,o){this.bounds=t.LngLatBounds.convert(this.validateBounds(e)),this.minzoom=i||0,this.maxzoom=o||24;};S.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},S.prototype.contains=function(e){var i=Math.pow(2,e.z),o=Math.floor(t.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(t.mercatorYfromLat(this.bounds.getNorth())*i),a=Math.ceil(t.mercatorXfromLng(this.bounds.getEast())*i),n=Math.ceil(t.mercatorYfromLat(this.bounds.getSouth())*i);return e.x>=o&&e.x<a&&e.y>=r&&e.y<n};var C=function(e){function i(i,o,r,a){if(e.call(this),this.id=i,this.dispatcher=r,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,t.extend(this,t.pick(o,["url","scheme","tileSize"])),this._options=t.extend({type:"vector"},o),this._collectResourceTiming=o.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(a);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new S(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles,e.map._requestManager._customAccessToken),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken,e.map._requestManager._customAccessToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,null),r={request:this.map._requestManager.transformRequest(o,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};function a(o,r){return delete e.request,e.aborted?i(null):o&&404!==o.status?i(o):(r&&r.resourceTiming&&(e.resourceTiming=r.resourceTiming),this.map._refreshExpiredTiles&&r&&e.setExpiryData(r),e.loadVectorData(r,this.map.painter),t.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}r.request.collectResourceTiming=this._collectResourceTiming,e.actor&&"expired"!==e.state?"loading"===e.state?e.reloadCallback=i:e.request=e.actor.send("reloadTile",r,a.bind(this)):(e.actor=this.dispatcher.getActor(),e.request=e.actor.send("loadTile",r,a.bind(this)));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.actor&&t.actor.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.unloadTile=function(t){t.unloadVectorData(),t.actor&&t.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.hasTransition=function(){return !1},i}(t.Evented),P=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.dispatcher=r,this.setEventedParent(a),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({type:"raster"},o),t.extend(this,t.pick(o,["url","scheme","tileSize"]));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new S(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.loadTile=function(e,i){var o=this,r=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=t.getImage(this.map._requestManager.transformRequest(r,t.ResourceType.Tile),(function(r,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(r)e.state="errored",i(r);else if(a){o.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=o.map.painter.context,s=n.gl;e.texture=o.map.painter.getTileTexture(a.width),e.texture?e.texture.update(a,{useMipmap:!0}):(e.texture=new t.Texture(n,a,s.RGBA,{useMipmap:!0}),e.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),n.extTextureFilterAnisotropic&&s.texParameterf(s.TEXTURE_2D,n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,n.extTextureFilterAnisotropicMax)),e.state="loaded",t.cacheEntryPossiblyAdded(o.dispatcher),i(null);}}));},i.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e();},i.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e();},i.prototype.hasTransition=function(){return !1},i}(t.Evented),z=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({type:"raster-dem"},o),this.encoding=o.encoding||"mapbox";}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.serialize=function(){return {type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);function r(t,o){t&&(e.state="errored",i(t)),o&&(e.dem=o,e.needsHillshadePrepare=!0,e.state="loaded",i(null));}e.request=t.getImage(this.map._requestManager.transformRequest(o,t.ResourceType.Tile),function(o,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(o)e.state="errored",i(o);else if(a){this.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=t.browser.getImageData(a),s={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:n,encoding:this.encoding};e.actor&&"expired"!==e.state||(e.actor=this.dispatcher.getActor(),e.actor.send("loadDEMTile",s,r.bind(this)));}}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID);},i.prototype._getNeighboringTiles=function(e){var i=e.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,a=0===i.x?e.wrap-1:e.wrap,n=(i.x+1+o)%o,s=i.x+1===o?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y).key]={backfilled:!1},i.y>0&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y+1).key]={backfilled:!1}),l},i.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",t.actor&&t.actor.send("removeDEMTile",{uid:t.uid,source:this.id});},i}(P),L=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this._loaded=!1,this.actor=r.getActor(),this.setEventedParent(a),this._data=o.data,this._options=t.extend({},o),this._collectResourceTiming=o.collectResourceTiming,this._resourceTiming=[],void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type),o.attribution&&(this.attribution=o.attribution);var n=t.EXTENT/this.tileSize;this.workerOptions=t.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*n,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*n,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:o.lineMetrics||!1,generateId:o.generateId||!1},superclusterOptions:{maxZoom:void 0!==o.clusterMaxZoom?Math.min(o.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:t.EXTENT,radius:(o.clusterRadius||50)*n,log:!1},clusterProperties:o.clusterProperties},o.workerOptions);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(i){if(i)e.fire(new t.ErrorEvent(i));else{var o={dataType:"source",sourceDataType:"metadata"};e._collectResourceTiming&&e._resourceTiming&&e._resourceTiming.length>0&&(o.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",o));}}));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(e){if(e)i.fire(new t.ErrorEvent(e));else{var o={dataType:"source",sourceDataType:"content"};i._collectResourceTiming&&i._resourceTiming&&i._resourceTiming.length>0&&(o.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",o));}})),this},i.prototype.getClusterExpansionZoom=function(t,e){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e),this},i.prototype.getClusterChildren=function(t,e){return this.actor.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e),this},i.prototype.getClusterLeaves=function(t,e,i,o){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},o),this},i.prototype._updateWorkerData=function(e){var i=this;this._loaded=!1;var o=t.extend({},this.workerOptions),r=this._data;"string"==typeof r?(o.request=this.map._requestManager.transformRequest(t.browser.resolveURL(r),t.ResourceType.Source),o.request.collectResourceTiming=this._collectResourceTiming):o.data=JSON.stringify(r),this.actor.send(this.type+".loadData",o,(function(t,r){i._removed||r&&r.abandoned||(i._loaded=!0,r&&r.resourceTiming&&r.resourceTiming[i.id]&&(i._resourceTiming=r.resourceTiming[i.id].slice(0)),i.actor.send(i.type+".coalesce",{source:o.source},null),e(t));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.loadTile=function(e,i){var o=this,r=e.actor?"reloadTile":"loadTile";e.actor=this.actor;var a={type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};e.request=this.actor.send(r,a,(function(t,a){return delete e.request,e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(a,o.map.painter,"reloadTile"===r),i(null))}));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.aborted=!0;},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id});},i.prototype.onRemove=function(){this._removed=!0,this.actor.send("removeSource",{type:this.type,source:this.id});},i.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},i.prototype.hasTransition=function(){return !1},i}(t.Evented),M=function(e){function i(t,i,o,r){e.call(this),this.id=t,this.dispatcher=o,this.coordinates=i.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(r),this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(e,i){var o=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._requestManager.transformRequest(this.url,t.ResourceType.Image),(function(r,a){o._loaded=!0,r?o.fire(new t.ErrorEvent(r)):a&&(o.image=a,e&&(o.coordinates=e),i&&i(),o._finishLoading());}));},i.prototype.loaded=function(){return this._loaded},i.prototype.updateImage=function(t){var e=this;return this.image&&t.url?(this.options.url=t.url,this.load(t.coordinates,(function(){e.texture=null;})),this):this},i.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setCoordinates=function(e){var i=this;this.coordinates=e;var o=e.map(t.MercatorCoordinate.fromLngLat);this.tileID=function(e){for(var i=1/0,o=1/0,r=-1/0,a=-1/0,n=0,s=e;n<s.length;n+=1){var l=s[n];i=Math.min(i,l.x),o=Math.min(o,l.y),r=Math.max(r,l.x),a=Math.max(a,l.y);}var c=r-i,u=a-o,h=Math.max(c,u),p=Math.max(0,Math.floor(-Math.log(h)/Math.LN2)),d=Math.pow(2,p);return new t.CanonicalTileID(p,Math.floor((i+r)/2*d),Math.floor((o+a)/2*d))}(o),this.minzoom=this.maxzoom=this.tileID.z;var r=o.map((function(t){return i.tileID.getTilePoint(t)._round()}));return this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(r[0].x,r[0].y,0,0),this._boundsArray.emplaceBack(r[1].x,r[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(r[3].x,r[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(r[2].x,r[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},i.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture||(this.texture=new t.Texture(e,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null));},i.prototype.serialize=function(){return {type:"image",url:this.options.url,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return !1},i}(t.Evented);var D=function(e){function i(t,i,o,r){e.call(this,t,i,o,r),this.roundZoom=!0,this.type="video",this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1;var i=this.options;this.urls=[];for(var o=0,r=i.urls;o<r.length;o+=1){var a=r[o];this.urls.push(this.map._requestManager.transformRequest(a,t.ResourceType.Source).url);}t.getVideo(this.urls,(function(i,o){e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(e.video=o,e.video.loop=!0,e.video.addEventListener("playing",(function(){e.map.triggerRepaint();})),e.map&&e.video.play(),e._finishLoading());}));},i.prototype.pause=function(){this.video&&this.video.pause();},i.prototype.play=function(){this.video&&this.video.play();},i.prototype.seek=function(e){if(this.video){var i=this.video.seekable;e<i.start(0)||e>i.end(0)?this.fire(new t.ErrorEvent(new t.ValidationError("Playback for this video can be set only between the "+i.start(0)+" and "+i.end(0)+"-second mark."))):this.video.currentTime=e;}},i.prototype.getVideo=function(){return this.video},i.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));},i.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(e,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"video",urls:this.urls,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this.video&&!this.video.paused},i}(M),R=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),o.coordinates?Array.isArray(o.coordinates)&&4===o.coordinates.length&&!o.coordinates.some((function(t){return !Array.isArray(t)||2!==t.length||t.some((function(t){return "number"!=typeof t}))}))||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "coordinates"'))),o.animate&&"boolean"!=typeof o.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'optional "animate" property must be a boolean value'))),o.canvas?"string"==typeof o.canvas||o.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "canvas"'))),this.options=o,this.animate=void 0===o.animate||o.animate;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1);},this._finishLoading());},i.prototype.getCanvas=function(){return this.canvas},i.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play();},i.prototype.onRemove=function(){this.pause();},i.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,o=i.gl;for(var r in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?(e||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new t.Texture(i,this.canvas,o.RGBA,{premultiply:!0}),this.tiles){var a=this.tiles[r];"loaded"!==a.state&&(a.state="loaded",a.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"canvas",coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this._playing},i.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return !0}return !1},i}(M),A={vector:C,raster:P,"raster-dem":z,geojson:L,video:D,image:M,canvas:R},k=function(e,i,o,r){var a=new A[i.type](e,i,o,r);if(a.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+a.id);return t.bindAll(["load","abort","unload","serialize","prepare"],a),a};function B(e,i){var o=t.identity([]);return t.translate(o,o,[1,1,0]),t.scale(o,o,[.5*e.width,.5*e.height,1]),t.multiply(o,o,e.calculatePosMatrix(i.toUnwrapped()))}function O(t,e,i,o,r){var a=function(t,e,i){if(t)for(var o=0,r=t;o<r.length;o+=1){var a=e[r[o]];if(a&&a.source===i&&"fill-extrusion"===a.type)return !0}else for(var n in e){var s=e[n];if(s.source===i&&"fill-extrusion"===s.type)return !0}return !1}(o&&o.layers,e,t.id),n=r.maxPitchScaleFactor(),s=t.tilesIn(i,n,a);s.sort(F);for(var l=[],c=0,u=s;c<u.length;c+=1){var h=u[c];l.push({wrappedTileID:h.tileID.wrapped().key,queryResults:h.tile.queryRenderedFeatures(e,t._state,h.queryGeometry,h.cameraQueryGeometry,h.scale,o,r,n,B(t.transform,h.tileID))});}var p=function(t){for(var e={},i={},o=0,r=t;o<r.length;o+=1){var a=r[o],n=a.queryResults,s=a.wrappedTileID,l=i[s]=i[s]||{};for(var c in n)for(var u=n[c],h=l[c]=l[c]||{},p=e[c]=e[c]||[],d=0,_=u;d<_.length;d+=1){var f=_[d];h[f.featureIndex]||(h[f.featureIndex]=!0,p.push(f));}}return e}(l);for(var d in p)p[d].forEach((function(e){var i=e.feature,o=t.getFeatureState(i.layer["source-layer"],i.id);i.source=i.layer.source,i.layer["source-layer"]&&(i.sourceLayer=i.layer["source-layer"]),i.state=o;}));return p}function F(t,e){var i=t.tileID,o=e.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}var U=function(t,e){this.max=t,this.onRemove=e,this.reset();};U.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var o=i[e];o.timeout&&clearTimeout(o.timeout),this.onRemove(o.value);}return this.data={},this.order=[],this},U.prototype.add=function(t,e,i){var o=this,r=t.wrapped().key;void 0===this.data[r]&&(this.data[r]=[]);var a={value:e,timeout:void 0};if(void 0!==i&&(a.timeout=setTimeout((function(){o.remove(t,a);}),i)),this.data[r].push(a),this.order.push(r),this.order.length>this.max){var n=this._getAndRemoveByKey(this.order[0]);n&&this.onRemove(n);}return this},U.prototype.has=function(t){return t.wrapped().key in this.data},U.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},U.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},U.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},U.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key,o=void 0===e?0:this.data[i].indexOf(e),r=this.data[i][o];return this.data[i].splice(o,1),r.timeout&&clearTimeout(r.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(r.value),this.order.splice(this.order.indexOf(i),1),this},U.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e);}return this};var N=function(t,e,i){this.context=t;var o=t.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),t.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};N.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer);},N.prototype.updateData=function(t){var e=this.context.gl;this.context.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer);},N.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var Z={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},q=function(t,e,i,o){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=o,this.context=t;var r=t.gl;this.buffer=r.createBuffer(),t.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};q.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer);},q.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer);},q.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var o=this.attributes[i],r=e.attributes[o.name];void 0!==r&&t.enableVertexAttribArray(r);}},q.prototype.setVertexAttribPointers=function(t,e,i){for(var o=0;o<this.attributes.length;o++){var r=this.attributes[o],a=e.attributes[r.name];void 0!==a&&t.vertexAttribPointer(a,r.components,t[Z[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}},q.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var j=function(t){this.gl=t.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;};j.prototype.get=function(){return this.current},j.prototype.set=function(t){},j.prototype.getDefault=function(){return this.default},j.prototype.setDefault=function(){this.set(this.default);};var V=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(j),G=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 1},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearDepth(t),this.current=t,this.dirty=!1);},e}(j),W=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearStencil(t),this.current=t,this.dirty=!1);},e}(j),X=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [!0,!0,!0,!0]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(j),H=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthMask(t),this.current=t,this.dirty=!1);},e}(j),K=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 255},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.stencilMask(t),this.current=t,this.dirty=!1);},e}(j),J=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return {func:this.gl.ALWAYS,ref:0,mask:255}},e.prototype.set=function(t){var e=this.current;(t.func!==e.func||t.ref!==e.ref||t.mask!==e.mask||this.dirty)&&(this.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t,this.dirty=!1);},e}(j),Y=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.KEEP,t.KEEP,t.KEEP]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||this.dirty)&&(this.gl.stencilOp(t[0],t[1],t[2]),this.current=t,this.dirty=!1);},e}(j),Q=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t,this.dirty=!1;}},e}(j),$=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [0,1]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.depthRange(t[0],t[1]),this.current=t,this.dirty=!1);},e}(j),tt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t,this.dirty=!1;}},e}(j),et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.LESS},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthFunc(t),this.current=t,this.dirty=!1);},e}(j),it=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t,this.dirty=!1;}},e}(j),ot=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.ONE,t.ZERO]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.blendFunc(t[0],t[1]),this.current=t,this.dirty=!1);},e}(j),rt=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(j),at=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.FUNC_ADD},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.blendEquation(t),this.current=t,this.dirty=!1);},e}(j),nt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.CULL_FACE):e.disable(e.CULL_FACE),this.current=t,this.dirty=!1;}},e}(j),st=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.BACK},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.cullFace(t),this.current=t,this.dirty=!1);},e}(j),lt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.CCW},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.frontFace(t),this.current=t,this.dirty=!1);},e}(j),ct=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.useProgram(t),this.current=t,this.dirty=!1);},e}(j),ut=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.TEXTURE0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.activeTexture(t),this.current=t,this.dirty=!1);},e}(j),ht=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [0,0,t.drawingBufferWidth,t.drawingBufferHeight]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(j),pt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t,this.dirty=!1;}},e}(j),dt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(j),_t=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t,this.dirty=!1;}},e}(j),ft=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t,this.dirty=!1;}},e}(j),mt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){var e=this.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t,this.dirty=!1;},e}(j),gt=function(t){function e(e){t.call(this,e),this.vao=e.extVertexArrayObject;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){this.vao&&(t!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(t),this.current=t,this.dirty=!1);},e}(j),vt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 4},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t,this.dirty=!1;}},e}(j),yt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t,this.dirty=!1;}},e}(j),xt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,t),this.current=t,this.dirty=!1;}},e}(j),bt=function(t){function e(e,i){t.call(this,e),this.context=e,this.parent=i;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e}(j),wt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.setDirty=function(){this.dirty=!0;},e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1;}},e}(bt),Et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(bt),Tt=function(t,e,i){this.context=t,this.width=e,this.height=i;var o=t.gl,r=this.framebuffer=o.createFramebuffer();this.colorAttachment=new wt(t,r),this.depthAttachment=new Et(t,r);};Tt.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e);var i=this.depthAttachment.get();i&&t.deleteRenderbuffer(i),t.deleteFramebuffer(this.framebuffer);};var It=function(t,e,i){this.func=t,this.mask=e,this.range=i;};It.ReadOnly=!1,It.ReadWrite=!0,It.disabled=new It(519,It.ReadOnly,[0,1]);var St=function(t,e,i,o,r,a){this.test=t,this.ref=e,this.mask=i,this.fail=o,this.depthFail=r,this.pass=a;};St.disabled=new St({func:519,mask:0},0,0,7680,7680,7680);var Ct=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i;};Ct.Replace=[1,0],Ct.disabled=new Ct(Ct.Replace,t.Color.transparent,[!1,!1,!1,!1]),Ct.unblended=new Ct(Ct.Replace,t.Color.transparent,[!0,!0,!0,!0]),Ct.alphaBlended=new Ct([1,771],t.Color.transparent,[!0,!0,!0,!0]);var Pt=function(t,e,i){this.enable=t,this.mode=e,this.frontFace=i;};Pt.disabled=new Pt(!1,1029,2305),Pt.backCCW=new Pt(!0,1029,2305);var zt=function(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new V(this),this.clearDepth=new G(this),this.clearStencil=new W(this),this.colorMask=new X(this),this.depthMask=new H(this),this.stencilMask=new K(this),this.stencilFunc=new J(this),this.stencilOp=new Y(this),this.stencilTest=new Q(this),this.depthRange=new $(this),this.depthTest=new tt(this),this.depthFunc=new et(this),this.blend=new it(this),this.blendFunc=new ot(this),this.blendColor=new rt(this),this.blendEquation=new at(this),this.cullFace=new nt(this),this.cullFaceSide=new st(this),this.frontFace=new lt(this),this.program=new ct(this),this.activeTexture=new ut(this),this.viewport=new ht(this),this.bindFramebuffer=new pt(this),this.bindRenderbuffer=new dt(this),this.bindTexture=new _t(this),this.bindVertexBuffer=new ft(this),this.bindElementBuffer=new mt(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new gt(this),this.pixelStoreUnpack=new vt(this),this.pixelStoreUnpackPremultiplyAlpha=new yt(this),this.pixelStoreUnpackFlipY=new xt(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&t.getExtension("OES_texture_half_float_linear");};zt.prototype.setDefault=function(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault();},zt.prototype.setDirty=function(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;},zt.prototype.createIndexBuffer=function(t,e){return new N(this,t,e)},zt.prototype.createVertexBuffer=function(t,e,i){return new q(this,t,e,i)},zt.prototype.createRenderbuffer=function(t,e,i){var o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),r},zt.prototype.createFramebuffer=function(t,e){return new Tt(this,t,e)},zt.prototype.clear=function(t){var e=t.color,i=t.depth,o=this.gl,r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(i),this.depthMask.set(!0)),o.clear(r);},zt.prototype.setCullFace=function(t){!1===t.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(t.mode),this.frontFace.set(t.frontFace));},zt.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1);},zt.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1);},zt.prototype.setColorMode=function(e){t.deepEqual(e.blendFunction,Ct.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask);},zt.prototype.unbindVAO=function(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);};var Lt=function(e){function i(i,o,r){var a=this;e.call(this),this.id=i,this.dispatcher=r,this.on("data",(function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(a._sourceLoaded=!0),a._sourceLoaded&&!a._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(a.reload(),a.transform&&a.update(a.transform));})),this.on("error",(function(){a._sourceErrored=!0;})),this._source=k(i,o,r,this),this._tiles={},this._cache=new U(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._coveredTiles={},this._state=new t.SourceFeatureState;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t);},i.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t);},i.prototype.loaded=function(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;if(!this._source.loaded())return !1;for(var t in this._tiles){var e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0},i.prototype.getSource=function(){return this._source},i.prototype.pause=function(){this._paused=!0;},i.prototype.resume=function(){if(this._paused){var t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}},i.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},i.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,(function(){}))},i.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,(function(){}))},i.prototype.serialize=function(){return this._source.serialize()},i.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles){var i=this._tiles[e];i.upload(t),i.prepare(this.map.style.imageManager);}},i.prototype.getIds=function(){return Object.keys(this._tiles).map(Number).sort(Mt)},i.prototype.getRenderableIds=function(e){var i=this,o=[];for(var r in this._tiles)this._isIdRenderable(+r,e)&&o.push(+r);return e?o.sort((function(e,o){var r=i._tiles[e].tileID,a=i._tiles[o].tileID,n=new t.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle),s=new t.Point(a.canonical.x,a.canonical.y)._rotate(i.transform.angle);return r.overscaledZ-a.overscaledZ||s.y-n.y||s.x-n.x})):o.sort(Mt)},i.prototype.hasRenderableParent=function(t){var e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)},i.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},i.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading");},i.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)));},i.prototype._tileLoaded=function(e,i,o,r){if(r)return e.state="errored",void(404!==r.status?this._source.fire(new t.ErrorEvent(r,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===o&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID}));},i.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var o=e[i];if(t.neighboringTiles&&t.neighboringTiles[o]){var r=this.getTileByID(o);a(t,r),a(r,t);}}function a(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,o=e.tileID.canonical.y-t.tileID.canonical.y,r=Math.pow(2,t.tileID.canonical.z),a=e.tileID.key;0===i&&0===o||Math.abs(o)>1||(Math.abs(i)>1&&(1===Math.abs(i+r)?i+=r:1===Math.abs(i-r)&&(i-=r)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,o),t.neighboringTiles&&t.neighboringTiles[a]&&(t.neighboringTiles[a].backfilled=!0)));}},i.prototype.getTile=function(t){return this.getTileByID(t.key)},i.prototype.getTileByID=function(t){return this._tiles[t]},i.prototype.getZoom=function(t){return t.zoom+t.scaleZoom(t.tileSize/this._source.tileSize)},i.prototype._retainLoadedChildren=function(t,e,i,o){for(var r in this._tiles){var a=this._tiles[r];if(!(o[r]||!a.hasData()||a.tileID.overscaledZ<=e||a.tileID.overscaledZ>i)){for(var n=a.tileID;a&&a.tileID.overscaledZ>e+1;){var s=a.tileID.scaledTo(a.tileID.overscaledZ-1);(a=this._tiles[s.key])&&a.hasData()&&(n=s);}for(var l=n;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){o[n.key]=n;break}}}},i.prototype.findLoadedParent=function(t,e){for(var i=t.overscaledZ-1;i>=e;i--){var o=t.scaledTo(i);if(!o)return;var r=String(o.key),a=this._tiles[r];if(a&&a.hasData())return a;if(this._cache.has(o))return this._cache.get(o)}},i.prototype.updateCacheSize=function(t){var e=(Math.ceil(t.width/this._source.tileSize)+1)*(Math.ceil(t.height/this._source.tileSize)+1),i=Math.floor(5*e),o="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,i):i;this._cache.setMaxSize(o);},i.prototype.handleWrapJump=function(t){var e=(t-(void 0===this._prevLng?t:this._prevLng))/360,i=Math.round(e);if(this._prevLng=t,i){var o={};for(var r in this._tiles){var a=this._tiles[r];a.tileID=a.tileID.unwrapTo(a.tileID.wrap+i),o[a.tileID.key]=a;}for(var n in this._tiles=o,this._timers)clearTimeout(this._timers[n]),delete this._timers[n];for(var s in this._tiles){var l=this._tiles[s];this._setTileReloadTimer(s,l);}}},i.prototype.update=function(e){var o=this;if(this.transform=e,this._sourceLoaded&&!this._paused){var r;this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?r=e.getVisibleUnwrappedCoordinates(this._source.tileID).map((function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)})):(r=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(r=r.filter((function(t){return o._source.hasTile(t)})))):r=[];var a=(this._source.roundZoom?Math.round:Math.floor)(this.getZoom(e)),n=Math.max(a-i.maxOverzooming,this._source.minzoom),s=Math.max(a+i.maxUnderzooming,this._source.minzoom),l=this._updateRetainedTiles(r,a);if(Dt(this._source.type)){for(var c={},u={},h=0,p=Object.keys(l);h<p.length;h+=1){var d=p[h],_=l[d],f=this._tiles[d];if(f&&!(f.fadeEndTime&&f.fadeEndTime<=t.browser.now())){var m=this.findLoadedParent(_,n);m&&(this._addTile(m.tileID),c[m.tileID.key]=m.tileID),u[d]=_;}}for(var g in this._retainLoadedChildren(u,a,s,l),c)l[g]||(this._coveredTiles[g]=!0,l[g]=c[g]);}for(var v in l)this._tiles[v].clearFadeHold();for(var y=0,x=t.keysDifference(this._tiles,l);y<x.length;y+=1){var b=x[y],w=this._tiles[b];w.hasSymbolBuckets&&!w.holdingForFade()?w.setHoldDuration(this.map._fadeDuration):w.hasSymbolBuckets&&!w.symbolFadeFinished()||this._removeTile(b);}}},i.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t);},i.prototype._updateRetainedTiles=function(t,e){for(var o={},r={},a=Math.max(e-i.maxOverzooming,this._source.minzoom),n=Math.max(e+i.maxUnderzooming,this._source.minzoom),s={},l=0,c=t;l<c.length;l+=1){var u=c[l],h=this._addTile(u);o[u.key]=u,h.hasData()||e<this._source.maxzoom&&(s[u.key]=u);}this._retainLoadedChildren(s,e,n,o);for(var p=0,d=t;p<d.length;p+=1){var _=d[p],f=this._tiles[_.key];if(!f.hasData()){if(e+1>this._source.maxzoom){var m=_.children(this._source.maxzoom)[0],g=this.getTile(m);if(g&&g.hasData()){o[m.key]=m;continue}}else{var v=_.children(this._source.maxzoom);if(o[v[0].key]&&o[v[1].key]&&o[v[2].key]&&o[v[3].key])continue}for(var y=f.wasRequested(),x=_.overscaledZ-1;x>=a;--x){var b=_.scaledTo(x);if(r[b.key])break;if(r[b.key]=!0,!(f=this.getTile(b))&&y&&(f=this._addTile(b)),f&&(o[b.key]=b,y=f.wasRequested(),f.hasData()))break}}}return o},i.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var o=Boolean(i);return o||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,o||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},i.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);var o=e.getExpiryTimeout();o&&(this._timers[t]=setTimeout((function(){i._reloadTile(t,"expired"),delete i._timers[t];}),o));},i.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));},i.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset();},i.prototype.tilesIn=function(e,i,o){var r=this,a=[],n=this.transform;if(!n)return a;for(var s=o?n.getCameraQueryGeometry(e):e,l=e.map((function(t){return n.pointCoordinate(t)})),c=s.map((function(t){return n.pointCoordinate(t)})),u=this.getIds(),h=1/0,p=1/0,d=-1/0,_=-1/0,f=0,m=c;f<m.length;f+=1){var g=m[f];h=Math.min(h,g.x),p=Math.min(p,g.y),d=Math.max(d,g.x),_=Math.max(_,g.y);}for(var v=function(e){var o=r._tiles[u[e]];if(!o.holdingForFade()){var s=o.tileID,f=Math.pow(2,n.zoom-o.tileID.overscaledZ),m=i*o.queryPadding*t.EXTENT/o.tileSize/f,g=[s.getTilePoint(new t.MercatorCoordinate(h,p)),s.getTilePoint(new t.MercatorCoordinate(d,_))];if(g[0].x-m<t.EXTENT&&g[0].y-m<t.EXTENT&&g[1].x+m>=0&&g[1].y+m>=0){var v=l.map((function(t){return s.getTilePoint(t)})),y=c.map((function(t){return s.getTilePoint(t)}));a.push({tile:o,tileID:s,queryGeometry:v,cameraQueryGeometry:y,scale:f});}}},y=0;y<u.length;y++)v(y);return a},i.prototype.getVisibleCoordinates=function(t){for(var e=this,i=this.getRenderableIds(t).map((function(t){return e._tiles[t].tileID})),o=0,r=i;o<r.length;o+=1){var a=r[o];a.posMatrix=this.transform.calculatePosMatrix(a.toUnwrapped());}return i},i.prototype.hasTransition=function(){if(this._source.hasTransition())return !0;if(Dt(this._source.type))for(var e in this._tiles){var i=this._tiles[e];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=t.browser.now())return !0}return !1},i.prototype.setFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.updateState(t,e,i);},i.prototype.removeFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.removeFeatureState(t,e,i);},i.prototype.getFeatureState=function(t,e){return t=t||"_geojsonTileLayer",this._state.getState(t,e)},i}(t.Evented);function Mt(t,e){return t%32-e%32||e-t}function Dt(t){return "raster"===t||"image"===t||"video"===t}function Rt(){return new t.window.Worker(er.workerUrl)}Lt.maxOverzooming=10,Lt.maxUnderzooming=3;var At=function(){this.active={};};At.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<At.workerCount;)this.workers.push(new Rt);return this.active[t]=!0,this.workers.slice()},At.prototype.release=function(t){delete this.active[t],0===Object.keys(this.active).length&&(this.workers.forEach((function(t){t.terminate();})),this.workers=null);};var kt,Bt=Math.floor(t.browser.hardwareConcurrency/2);function Ot(e,i){var o={};for(var r in e)"ref"!==r&&(o[r]=e[r]);return t.refProperties.forEach((function(t){t in i&&(o[t]=i[t]);})),o}function Ft(t){t=t.slice();for(var e=Object.create(null),i=0;i<t.length;i++)e[t[i].id]=t[i];for(var o=0;o<t.length;o++)"ref"in t[o]&&(t[o]=Ot(t[o],e[t[o].ref]));return t}At.workerCount=Math.max(Math.min(Bt,6),1);var Ut={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function Nt(t,e,i){i.push({command:Ut.addSource,args:[t,e[t]]});}function Zt(t,e,i){e.push({command:Ut.removeSource,args:[t]}),i[t]=!0;}function qt(t,e,i,o){Zt(t,i,o),Nt(t,e,i);}function jt(e,i,o){var r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;return !0}function Vt(e,i,o,r,a,n){var s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));}function Gt(t){return t.id}function Wt(t,e){return t[e.id]=e,t}function Xt(e,i){if(!e)return [{command:Ut.setStyle,args:[i]}];var o=[];try{if(!t.deepEqual(e.version,i.version))return [{command:Ut.setStyle,args:[i]}];t.deepEqual(e.center,i.center)||o.push({command:Ut.setCenter,args:[i.center]}),t.deepEqual(e.zoom,i.zoom)||o.push({command:Ut.setZoom,args:[i.zoom]}),t.deepEqual(e.bearing,i.bearing)||o.push({command:Ut.setBearing,args:[i.bearing]}),t.deepEqual(e.pitch,i.pitch)||o.push({command:Ut.setPitch,args:[i.pitch]}),t.deepEqual(e.sprite,i.sprite)||o.push({command:Ut.setSprite,args:[i.sprite]}),t.deepEqual(e.glyphs,i.glyphs)||o.push({command:Ut.setGlyphs,args:[i.glyphs]}),t.deepEqual(e.transition,i.transition)||o.push({command:Ut.setTransition,args:[i.transition]}),t.deepEqual(e.light,i.light)||o.push({command:Ut.setLight,args:[i.light]});var r={},a=[];!function(e,i,o,r){var a;for(a in i=i||{},e=e||{})e.hasOwnProperty(a)&&(i.hasOwnProperty(a)||Zt(a,o,r));for(a in i)i.hasOwnProperty(a)&&(e.hasOwnProperty(a)?t.deepEqual(e[a],i[a])||("geojson"===e[a].type&&"geojson"===i[a].type&&jt(e,i,a)?o.push({command:Ut.setGeoJSONSourceData,args:[a,i[a].data]}):qt(a,i,o,r)):Nt(a,i,o));}(e.sources,i.sources,a,r);var n=[];e.layers&&e.layers.forEach((function(t){r[t.source]?o.push({command:Ut.removeLayer,args:[t.id]}):n.push(t);})),o=o.concat(a),function(e,i,o){i=i||[];var r,a,n,s,l,c,u,h=(e=e||[]).map(Gt),p=i.map(Gt),d=e.reduce(Wt,{}),_=i.reduce(Wt,{}),f=h.slice(),m=Object.create(null);for(r=0,a=0;r<h.length;r++)n=h[r],_.hasOwnProperty(n)?a++:(o.push({command:Ut.removeLayer,args:[n]}),f.splice(f.indexOf(n,a),1));for(r=0,a=0;r<p.length;r++)n=p[p.length-1-r],f[f.length-1-r]!==n&&(d.hasOwnProperty(n)?(o.push({command:Ut.removeLayer,args:[n]}),f.splice(f.lastIndexOf(n,f.length-a),1)):a++,c=f[f.length-r],o.push({command:Ut.addLayer,args:[_[n],c]}),f.splice(f.length-r,0,n),m[n]=!0);for(r=0;r<p.length;r++)if(s=d[n=p[r]],l=_[n],!m[n]&&!t.deepEqual(s,l))if(t.deepEqual(s.source,l.source)&&t.deepEqual(s["source-layer"],l["source-layer"])&&t.deepEqual(s.type,l.type)){for(u in Vt(s.layout,l.layout,o,n,null,Ut.setLayoutProperty),Vt(s.paint,l.paint,o,n,null,Ut.setPaintProperty),t.deepEqual(s.filter,l.filter)||o.push({command:Ut.setFilter,args:[n,l.filter]}),t.deepEqual(s.minzoom,l.minzoom)&&t.deepEqual(s.maxzoom,l.maxzoom)||o.push({command:Ut.setLayerZoomRange,args:[n,l.minzoom,l.maxzoom]}),s)s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Vt(s[u],l[u],o,n,u.slice(6),Ut.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Ut.setLayerProperty,args:[n,u,l[u]]}));for(u in l)l.hasOwnProperty(u)&&!s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Vt(s[u],l[u],o,n,u.slice(6),Ut.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Ut.setLayerProperty,args:[n,u,l[u]]}));}else o.push({command:Ut.removeLayer,args:[n]}),c=f[f.lastIndexOf(n)+1],o.push({command:Ut.addLayer,args:[l,c]});}(n,i.layers,o);}catch(t){console.warn("Unable to compute style diff:",t),o=[{command:Ut.setStyle,args:[i]}];}return o}var Ht=function(t,e,i){var o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var a=0;a<this.xCellCount*this.yCellCount;a++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0;};function Kt(e,i,o,r,a){var n=t.create();return i?(t.scale(n,n,[1/a,1/a,1]),o||t.rotateZ(n,n,r.angle)):t.multiply(n,r.labelPlaneMatrix,e),n}function Jt(e,i,o,r,a){if(i){var n=t.clone(e);return t.scale(n,n,[a,a,1]),o||t.rotateZ(n,n,-r.angle),n}return r.glCoordMatrix}function Yt(e,i){var o=[e.x,e.y,0,1];se(o,o,i);var r=o[3];return {point:new t.Point(o[0]/r,o[1]/r),signedDistanceFromCamera:r}}function Qt(t,e){var i=t[0]/t[3],o=t[1]/t[3];return i>=-e[0]&&i<=e[0]&&o>=-e[1]&&o<=e[1]}function $t(e,i,o,r,a,n,s,l){var c=r?e.textSizeData:e.iconSizeData,u=t.evaluateSizeForZoom(c,o.transform.zoom),h=[256/o.width*2+1,256/o.height*2+1],p=r?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;p.clear();for(var d=e.lineVertexArray,_=r?e.text.placedSymbolArray:e.icon.placedSymbolArray,f=o.transform.width/o.transform.height,m=!1,g=0;g<_.length;g++){var v=_.get(g);if(v.hidden||v.writingMode===t.WritingMode.vertical&&!m)ne(v.numGlyphs,p);else{m=!1;var y=[v.anchorX,v.anchorY,0,1];if(t.transformMat4(y,y,i),Qt(y,h)){var x=.5+y[3]/o.transform.cameraToCenterDistance*.5,b=t.evaluateSizeForFeature(c,u,v),w=s?b*x:b/x,E=new t.Point(v.anchorX,v.anchorY),T=Yt(E,a).point,I={},S=ie(v,w,!1,l,i,a,n,e.glyphOffsetArray,d,p,T,E,I,f);m=S.useVertical,(S.notEnoughRoom||m||S.needsFlipping&&ie(v,w,!0,l,i,a,n,e.glyphOffsetArray,d,p,T,E,I,f).notEnoughRoom)&&ne(v.numGlyphs,p);}else ne(v.numGlyphs,p);}}r?e.text.dynamicLayoutVertexBuffer.updateData(p):e.icon.dynamicLayoutVertexBuffer.updateData(p);}function te(t,e,i,o,r,a,n,s,l,c,u,h){var p=s.glyphStartIndex+s.numGlyphs,d=s.lineStartIndex,_=s.lineStartIndex+s.lineLength,f=e.getoffsetX(s.glyphStartIndex),m=e.getoffsetX(p-1),g=re(t*f,i,o,r,a,n,s.segment,d,_,l,c,u,h);if(!g)return null;var v=re(t*m,i,o,r,a,n,s.segment,d,_,l,c,u,h);return v?{first:g,last:v}:null}function ee(e,i,o,r){if(e===t.WritingMode.horizontal&&Math.abs(o.y-i.y)>Math.abs(o.x-i.x)*r)return {useVertical:!0};return (e===t.WritingMode.vertical?i.y<o.y:i.x>o.x)?{needsFlipping:!0}:null}function ie(e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=i/24,g=e.lineOffsetX*m,v=e.lineOffsetY*m;if(e.numGlyphs>1){var y=e.glyphStartIndex+e.numGlyphs,x=e.lineStartIndex,b=e.lineStartIndex+e.lineLength,w=te(m,l,g,v,o,h,p,e,c,n,d,!1);if(!w)return {notEnoughRoom:!0};var E=Yt(w.first.point,s).point,T=Yt(w.last.point,s).point;if(r&&!o){var I=ee(e.writingMode,E,T,_);if(I)return I}f=[w.first];for(var S=e.glyphStartIndex+1;S<y-1;S++)f.push(re(m*l.getoffsetX(S),g,v,o,h,p,e.segment,x,b,c,n,d,!1));f.push(w.last);}else{if(r&&!o){var C=Yt(p,a).point,P=e.lineStartIndex+e.segment+1,z=new t.Point(c.getx(P),c.gety(P)),L=Yt(z,a),M=L.signedDistanceFromCamera>0?L.point:oe(p,z,C,1,a),D=ee(e.writingMode,C,M,_);if(D)return D}var R=re(m*l.getoffsetX(e.glyphStartIndex),g,v,o,h,p,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,c,n,d,!1);if(!R)return {notEnoughRoom:!0};f=[R];}for(var A=0,k=f;A<k.length;A+=1){var B=k[A];t.addDynamicAttributes(u,B.point,B.angle);}return {}}function oe(t,e,i,o,r){var a=Yt(t.add(t.sub(e)._unit()),r).point,n=i.sub(a);return i.add(n._mult(o/n.mag()))}function re(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=r?e-i:e+i,f=_>0?1:-1,m=0;r&&(f*=-1,m=Math.PI),f<0&&(m+=Math.PI);for(var g=f>0?l+s:l+s+1,v=g,y=a,x=a,b=0,w=0,E=Math.abs(_);b+w<=E;){if((g+=f)<l||g>=c)return null;if(x=y,void 0===(y=p[g])){var T=new t.Point(u.getx(g),u.gety(g)),I=Yt(T,h);if(I.signedDistanceFromCamera>0)y=p[g]=I.point;else{var S=g-f;y=oe(0===b?n:new t.Point(u.getx(S),u.gety(S)),T,x,E-b+1,h);}}b+=w,w=x.dist(y);}var C=(E-b)/w,P=y.sub(x),z=P.mult(C)._add(x);return z._add(P._unit()._perp()._mult(o*f)),{point:z,angle:m+Math.atan2(y.y-x.y,y.x-x.x),tileDistance:d?{prevTileDistance:g-f===v?0:u.gettileUnitDistanceFromAnchor(g-f),lastSegmentViewportDistance:E-b}:null}}Ht.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},Ht.prototype.insert=function(t,e,i,o,r){this._forEachCell(e,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);},Ht.prototype.insertCircle=function(t,e,i,o){this._forEachCell(e-o,i-o,e+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(o);},Ht.prototype._insertBoxCell=function(t,e,i,o,r,a){this.boxCells[r].push(a);},Ht.prototype._insertCircleCell=function(t,e,i,o,r,a){this.circleCells[r].push(a);},Ht.prototype._query=function(t,e,i,o,r,a){if(i<0||t>this.width||o<0||e>this.height)return !r&&[];var n=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(var s=0;s<this.boxKeys.length;s++)n.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var c=this.circles[3*l],u=this.circles[3*l+1],h=this.circles[3*l+2];n.push({key:this.circleKeys[l],x1:c-h,y1:u-h,x2:c+h,y2:u+h});}return a?n.filter(a):n}var p={hitTest:r,seenUids:{box:{},circle:{}}};return this._forEachCell(t,e,i,o,this._queryCell,n,p,a),r?n.length>0:n},Ht.prototype._queryCircle=function(t,e,i,o,r){var a=t-i,n=t+i,s=e-i,l=e+i;if(n<0||a>this.width||l<0||s>this.height)return !o&&[];var c=[],u={hitTest:o,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}};return this._forEachCell(a,s,n,l,this._queryCellCircle,c,u,r),o?c.length>0:c},Ht.prototype.query=function(t,e,i,o,r){return this._query(t,e,i,o,!1,r)},Ht.prototype.hitTest=function(t,e,i,o,r){return this._query(t,e,i,o,!0,r)},Ht.prototype.hitTestCircle=function(t,e,i,o){return this._queryCircle(t,e,i,!0,o)},Ht.prototype._queryCell=function(t,e,i,o,r,a,n,s){var l=n.seenUids,c=this.boxCells[r];if(null!==c)for(var u=this.bboxes,h=0,p=c;h<p.length;h+=1){var d=p[h];if(!l.box[d]){l.box[d]=!0;var _=4*d;if(t<=u[_+2]&&e<=u[_+3]&&i>=u[_+0]&&o>=u[_+1]&&(!s||s(this.boxKeys[d]))){if(n.hitTest)return a.push(!0),!0;a.push({key:this.boxKeys[d],x1:u[_],y1:u[_+1],x2:u[_+2],y2:u[_+3]});}}}var f=this.circleCells[r];if(null!==f)for(var m=this.circles,g=0,v=f;g<v.length;g+=1){var y=v[g];if(!l.circle[y]){l.circle[y]=!0;var x=3*y;if(this._circleAndRectCollide(m[x],m[x+1],m[x+2],t,e,i,o)&&(!s||s(this.circleKeys[y]))){if(n.hitTest)return a.push(!0),!0;var b=m[x],w=m[x+1],E=m[x+2];a.push({key:this.circleKeys[y],x1:b-E,y1:w-E,x2:b+E,y2:w+E});}}}},Ht.prototype._queryCellCircle=function(t,e,i,o,r,a,n,s){var l=n.circle,c=n.seenUids,u=this.boxCells[r];if(null!==u)for(var h=this.bboxes,p=0,d=u;p<d.length;p+=1){var _=d[p];if(!c.box[_]){c.box[_]=!0;var f=4*_;if(this._circleAndRectCollide(l.x,l.y,l.radius,h[f+0],h[f+1],h[f+2],h[f+3])&&(!s||s(this.boxKeys[_])))return a.push(!0),!0}}var m=this.circleCells[r];if(null!==m)for(var g=this.circles,v=0,y=m;v<y.length;v+=1){var x=y[v];if(!c.circle[x]){c.circle[x]=!0;var b=3*x;if(this._circlesCollide(g[b],g[b+1],g[b+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[x])))return a.push(!0),!0}}},Ht.prototype._forEachCell=function(t,e,i,o,r,a,n,s){for(var l=this._convertToXCellCoord(t),c=this._convertToYCellCoord(e),u=this._convertToXCellCoord(i),h=this._convertToYCellCoord(o),p=l;p<=u;p++)for(var d=c;d<=h;d++){var _=this.xCellCount*d+p;if(r.call(this,t,e,i,o,_,a,n,s))return}},Ht.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},Ht.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},Ht.prototype._circlesCollide=function(t,e,i,o,r,a){var n=o-t,s=r-e,l=i+a;return l*l>n*n+s*s},Ht.prototype._circleAndRectCollide=function(t,e,i,o,r,a,n){var s=(a-o)/2,l=Math.abs(t-(o+s));if(l>s+i)return !1;var c=(n-r)/2,u=Math.abs(e-(r+c));if(u>c+i)return !1;if(l<=s||u<=c)return !0;var h=l-s,p=u-c;return h*h+p*p<=i*i};var ae=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function ne(t,e){for(var i=0;i<t;i++){var o=e.length;e.resize(o+4),e.float32.set(ae,3*o);}}function se(t,e,i){var o=e[0],r=e[1];return t[0]=i[0]*o+i[4]*r+i[12],t[1]=i[1]*o+i[5]*r+i[13],t[3]=i[3]*o+i[7]*r+i[15],t}var le=function(t,e,i){void 0===e&&(e=new Ht(t.width+200,t.height+200,25)),void 0===i&&(i=new Ht(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200;};function ce(t,e,i){t[e+4]=i?1:0;}function ue(e,i,o){return i*(t.EXTENT/(e.tileSize*Math.pow(2,o-e.tileID.overscaledZ)))}le.prototype.placeCollisionBox=function(t,e,i,o,r){var a=this.projectAndGetPerspectiveRatio(o,t.anchorPointX,t.anchorPointY),n=i*a.perspectiveRatio,s=t.x1*n+a.point.x,l=t.y1*n+a.point.y,c=t.x2*n+a.point.x,u=t.y2*n+a.point.y;return !this.isInsideGrid(s,l,c,u)||!e&&this.grid.hitTest(s,l,c,u,r)?{box:[],offscreen:!1}:{box:[s,l,c,u],offscreen:this.isOffscreen(s,l,c,u)}},le.prototype.approximateTileDistance=function(t,e,i,o,r){var a=r?1:o/this.pitchfactor,n=t.lastSegmentViewportDistance*i;return t.prevTileDistance+n+(a-1)*n*Math.abs(Math.sin(e))},le.prototype.placeCollisionCircles=function(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=[],f=this.projectAnchor(c,a.anchorX,a.anchorY),m=l/24,g=a.lineOffsetX*l,v=a.lineOffsetY*l,y=new t.Point(a.anchorX,a.anchorY),x=te(m,s,g,v,!1,Yt(y,u).point,y,a,n,u,{},!0),b=!1,w=!1,E=!0,T=f.perspectiveRatio*r,I=1/(r*o),S=0,C=0;x&&(S=this.approximateTileDistance(x.first.tileDistance,x.first.angle,I,f.cameraDistance,p),C=this.approximateTileDistance(x.last.tileDistance,x.last.angle,I,f.cameraDistance,p));for(var P=0;P<e.length;P+=5){var z=e[P],L=e[P+1],M=e[P+2],D=e[P+3];if(!x||D<-S||D>C)ce(e,P,!1);else{var R=this.projectPoint(c,z,L),A=M*T;if(_.length>0){var k=R.x-_[_.length-4],B=R.y-_[_.length-3];if(A*A*2>k*k+B*B)if(P+8<e.length){var O=e[P+8];if(O>-S&&O<C){ce(e,P,!1);continue}}}var F=P/5;_.push(R.x,R.y,A,F),ce(e,P,!0);var U=R.x-A,N=R.y-A,Z=R.x+A,q=R.y+A;if(E=E&&this.isOffscreen(U,N,Z,q),w=w||this.isInsideGrid(U,N,Z,q),!i&&this.grid.hitTestCircle(R.x,R.y,A,d)){if(!h)return {circles:[],offscreen:!1};b=!0;}}}return {circles:b||!w?[]:_,offscreen:E}},le.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};for(var i=[],o=1/0,r=1/0,a=-1/0,n=-1/0,s=0,l=e;s<l.length;s+=1){var c=l[s],u=new t.Point(c.x+100,c.y+100);o=Math.min(o,u.x),r=Math.min(r,u.y),a=Math.max(a,u.x),n=Math.max(n,u.y),i.push(u);}for(var h={},p={},d=0,_=this.grid.query(o,r,a,n).concat(this.ignoredGrid.query(o,r,a,n));d<_.length;d+=1){var f=_[d],m=f.key;if(void 0===h[m.bucketInstanceId]&&(h[m.bucketInstanceId]={}),!h[m.bucketInstanceId][m.featureIndex]){var g=[new t.Point(f.x1,f.y1),new t.Point(f.x2,f.y1),new t.Point(f.x2,f.y2),new t.Point(f.x1,f.y2)];t.polygonIntersectsPolygon(i,g)&&(h[m.bucketInstanceId][m.featureIndex]=!0,void 0===p[m.bucketInstanceId]&&(p[m.bucketInstanceId]=[]),p[m.bucketInstanceId].push(m.featureIndex));}}return p},le.prototype.insertCollisionBox=function(t,e,i,o,r){var a={bucketInstanceId:i,featureIndex:o,collisionGroupID:r};(e?this.ignoredGrid:this.grid).insert(a,t[0],t[1],t[2],t[3]);},le.prototype.insertCollisionCircles=function(t,e,i,o,r){for(var a=e?this.ignoredGrid:this.grid,n={bucketInstanceId:i,featureIndex:o,collisionGroupID:r},s=0;s<t.length;s+=4)a.insertCircle(n,t[s],t[s+1],t[s+2]);},le.prototype.projectAnchor=function(t,e,i){var o=[e,i,0,1];return se(o,o,t),{perspectiveRatio:.5+this.transform.cameraToCenterDistance/o[3]*.5,cameraDistance:o[3]}},le.prototype.projectPoint=function(e,i,o){var r=[i,o,0,1];return se(r,r,e),new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100)},le.prototype.projectAndGetPerspectiveRatio=function(e,i,o){var r=[i,o,0,1];return se(r,r,e),{point:new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/r[3]*.5}},le.prototype.isOffscreen=function(t,e,i,o){return i<100||t>=this.screenRightBoundary||o<100||e>this.screenBottomBoundary},le.prototype.isInsideGrid=function(t,e,i,o){return i>=0&&t<this.gridRightBoundary&&o>=0&&e<this.gridBottomBoundary};var he=function(t,e,i,o){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):o&&i?1:0,this.placed=i;};he.prototype.isHidden=function(){return 0===this.opacity&&!this.placed};var pe=function(t,e,i,o,r){this.text=new he(t?t.text:null,e,i,r),this.icon=new he(t?t.icon:null,e,o,r);};pe.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()};var de=function(t,e,i){this.text=t,this.icon=e,this.skipFade=i;},_e=function(t,e,i,o,r){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;},fe=function(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={};};function me(e,i,o,r,a){var n=t.getAnchorAlignment(e),s=-(n.horizontalAlign-.5)*i,l=-(n.verticalAlign-.5)*o,c=t.evaluateRadialOffset(e,r);return new t.Point(s+c[0]*a,l+c[1]*a)}fe.prototype.get=function(t){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[t]){var e=++this.maxGroupID;this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}};}return this.collisionGroups[t]};var ge=function(t,e,i,o){this.transform=t.clone(),this.collisionIndex=new le(this.transform),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new fe(i),this.prevPlacement=o,o&&(o.prevPlacement=void 0),this.placedOrientations={};};function ve(t,e,i,o,r){t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0);}ge.prototype.placeLayerTile=function(e,i,o,r){var a=i.getBucket(e),n=i.latestFeatureIndex;if(a&&n&&e.id===a.layerIds[0]){var s=i.collisionBoxArray,l=a.layers[0].layout,c=Math.pow(2,this.transform.zoom-i.tileID.overscaledZ),u=i.tileSize/t.EXTENT,h=this.transform.calculatePosMatrix(i.tileID.toUnwrapped()),p=Kt(h,"map"===l.get("text-pitch-alignment"),"map"===l.get("text-rotation-alignment"),this.transform,ue(i,1,this.transform.zoom)),d=Kt(h,"map"===l.get("icon-pitch-alignment"),"map"===l.get("icon-rotation-alignment"),this.transform,ue(i,1,this.transform.zoom));this.retainedQueryData[a.bucketInstanceId]=new _e(a.bucketInstanceId,n,a.sourceLayerIndex,a.index,i.tileID),this.placeLayerBucket(a,h,p,d,c,u,o,i.holdingForFade(),r,s);}},ge.prototype.attemptAnchorPlacement=function(e,i,o,r,a,n,s,l,c,u,h,p,d,_,f){var m,g=me(e,o,r,a,n),v=this.collisionIndex.placeCollisionBox(function(e,i,o,r,a,n){var s=e.x1,l=e.x2,c=e.y1,u=e.y2,h=e.anchorPointX,p=e.anchorPointY,d=new t.Point(i,o);return r&&d._rotate(a?n:-n),{x1:s+d.x,y1:c+d.y,x2:l+d.x,y2:u+d.y,anchorPointX:h,anchorPointY:p}}(i,g.x,g.y,s,l,this.transform.angle),p,c,u,h.predicate);if(v.box.length>0)return this.prevPlacement&&this.prevPlacement.variableOffsets[d.crossTileID]&&this.prevPlacement.placements[d.crossTileID]&&this.prevPlacement.placements[d.crossTileID].text&&(m=this.prevPlacement.variableOffsets[d.crossTileID].anchor),this.variableOffsets[d.crossTileID]={radialOffset:a,width:o,height:r,anchor:e,textBoxScale:n,prevAnchor:m},this.markUsedJustification(_,e,d,f),_.allowVerticalPlacement&&(this.markUsedOrientation(_,f,d),this.placedOrientations[d.crossTileID]=f),v},ge.prototype.placeLayerBucket=function(e,i,o,r,a,n,s,l,c,u){var h=this,p=e.layers[0].layout,d=t.evaluateSizeForZoom(e.textSizeData,this.transform.zoom),_=p.get("text-optional"),f=p.get("icon-optional"),m=p.get("text-allow-overlap"),g=p.get("icon-allow-overlap"),v=m&&(g||!e.hasIconData()||f),y=g&&(m||!e.hasTextData()||_),x=this.collisionGroups.get(e.sourceID),b="map"===p.get("text-rotation-alignment"),w="map"===p.get("text-pitch-alignment"),E="viewport-y"===p.get("symbol-z-order");!e.collisionArrays&&u&&e.deserializeCollisionBoxes(u);var T=function(r,u){if(!c[r.crossTileID])if(l)h.placements[r.crossTileID]=new de(!1,!1,!1);else{var g,E=!1,T=!1,I=!0,S={box:null,offscreen:null},C={box:null,offscreen:null},P=null,z=null,L=0,M=0,D=0;u.textFeatureIndex&&(L=u.textFeatureIndex),u.verticalTextFeatureIndex&&(M=u.verticalTextFeatureIndex);var R=u.textBox;if(R){var A=function(i){var o=t.WritingMode.horizontal;if(e.allowVerticalPlacement&&!i&&h.prevPlacement){var a=h.prevPlacement.placedOrientations[r.crossTileID];a&&(h.placedOrientations[r.crossTileID]=a,o=a,h.markUsedOrientation(e,o,r));}return o},k=function(i,o){if(e.allowVerticalPlacement&&r.numVerticalGlyphVertices>0&&u.verticalTextBox)for(var a=0,n=e.writingModes;a<n.length;a+=1){if(n[a]===t.WritingMode.vertical?(S=o(),C=S):S=i(),S&&S.box&&S.box.length)break}else S=i();};if(p.get("text-variable-anchor")){var B=p.get("text-variable-anchor");if(h.prevPlacement&&h.prevPlacement.variableOffsets[r.crossTileID]){var O=h.prevPlacement.variableOffsets[r.crossTileID];B.indexOf(O.anchor)>0&&(B=B.filter((function(t){return t!==O.anchor}))).unshift(O.anchor);}var F=function(t,o){for(var a=t.x2-t.x1,s=t.y2-t.y1,l=r.textBoxScale,c={box:[],offscreen:!1},u=m?2*B.length:B.length,p=0;p<u;++p){var d=B[p%B.length],_=p>=B.length;if((c=h.attemptAnchorPlacement(d,t,a,s,r.radialTextOffset,l,b,w,n,i,x,_,r,e,o))&&c.box&&c.box.length){E=!0;break}}return c};k((function(){return F(R,t.WritingMode.horizontal)}),(function(){var i=u.verticalTextBox,o=S&&S.box&&S.box.length;return e.allowVerticalPlacement&&!o&&r.numVerticalGlyphVertices>0&&i?F(i,t.WritingMode.vertical):{box:null,offscreen:null}})),S&&(E=S.box,I=S.offscreen);var U=A(S&&S.box);if(!E&&h.prevPlacement){var N=h.prevPlacement.variableOffsets[r.crossTileID];N&&(h.variableOffsets[r.crossTileID]=N,h.markUsedJustification(e,N.anchor,r,U));}}else{var Z=function(t,o){var a=h.collisionIndex.placeCollisionBox(t,p.get("text-allow-overlap"),n,i,x.predicate);return a&&a.box&&a.box.length&&(h.markUsedOrientation(e,o,r),h.placedOrientations[r.crossTileID]=o),a};k((function(){return Z(R,t.WritingMode.horizontal)}),(function(){var i=u.verticalTextBox;return e.allowVerticalPlacement&&r.numVerticalGlyphVertices>0&&i?Z(i,t.WritingMode.vertical):{box:null,offscreen:null}})),A(S&&S.box&&S.box.length);}}E=(g=S)&&g.box&&g.box.length>0,I=g&&g.offscreen;var q=u.textCircles;if(q){var j=e.text.placedSymbolArray.get(r.centerJustifiedTextSymbolIndex),V=t.evaluateSizeForFeature(e.textSizeData,d,j);P=h.collisionIndex.placeCollisionCircles(q,p.get("text-allow-overlap"),a,n,j,e.lineVertexArray,e.glyphOffsetArray,V,i,o,s,w,x.predicate),E=p.get("text-allow-overlap")||P.circles.length>0,I=I&&P.offscreen;}u.iconFeatureIndex&&(D=u.iconFeatureIndex),u.iconBox&&(T=(z=h.collisionIndex.placeCollisionBox(u.iconBox,p.get("icon-allow-overlap"),n,i,x.predicate)).box.length>0,I=I&&z.offscreen);var G=_||0===r.numHorizontalGlyphVertices&&0===r.numVerticalGlyphVertices,W=f||0===r.numIconVertices;G||W?W?G||(T=T&&E):E=T&&E:T=E=T&&E,E&&g&&g.box&&(C&&C.box&&M?h.collisionIndex.insertCollisionBox(g.box,p.get("text-ignore-placement"),e.bucketInstanceId,M,x.ID):h.collisionIndex.insertCollisionBox(g.box,p.get("text-ignore-placement"),e.bucketInstanceId,L,x.ID)),T&&z&&h.collisionIndex.insertCollisionBox(z.box,p.get("icon-ignore-placement"),e.bucketInstanceId,D,x.ID),E&&P&&h.collisionIndex.insertCollisionCircles(P.circles,p.get("text-ignore-placement"),e.bucketInstanceId,L,x.ID),h.placements[r.crossTileID]=new de(E||v,T||y,I||e.justReloaded),c[r.crossTileID]=!0;}};if(E)for(var I=e.getSortedSymbolIndexes(this.transform.angle),S=I.length-1;S>=0;--S){var C=I[S];T(e.symbolInstances.get(C),e.collisionArrays[C]);}else for(var P=0;P<e.symbolInstances.length;++P)T(e.symbolInstances.get(P),e.collisionArrays[P]);e.justReloaded=!1;},ge.prototype.markUsedJustification=function(e,i,o,r){var a,n={left:o.leftJustifiedTextSymbolIndex,center:o.centerJustifiedTextSymbolIndex,right:o.rightJustifiedTextSymbolIndex};a=r===t.WritingMode.vertical?o.verticalPlacedTextSymbolIndex:n[t.getAnchorJustification(i)];for(var s=0,l=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex,o.verticalPlacedTextSymbolIndex];s<l.length;s+=1){var c=l[s];c>=0&&(e.text.placedSymbolArray.get(c).crossTileID=a>=0&&c!==a?0:o.crossTileID);}},ge.prototype.markUsedOrientation=function(e,i,o){for(var r=i===t.WritingMode.horizontal||i===t.WritingMode.horizontalOnly?i:0,a=i===t.WritingMode.vertical?i:0,n=0,s=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex];n<s.length;n+=1){var l=s[n];e.text.placedSymbolArray.get(l).placedOrientation=r;}o.verticalPlacedTextSymbolIndex&&(e.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation=a);},ge.prototype.commit=function(t){this.commitTime=t;var e=this.prevPlacement,i=!1,o=e&&0!==this.fadeDuration?(this.commitTime-e.commitTime)/this.fadeDuration:1,r=e?e.opacities:{},a=e?e.variableOffsets:{},n=e?e.placedOrientations:{};for(var s in this.placements){var l=this.placements[s],c=r[s];c?(this.opacities[s]=new pe(c,o,l.text,l.icon),i=i||l.text!==c.text.placed||l.icon!==c.icon.placed):(this.opacities[s]=new pe(null,o,l.text,l.icon,l.skipFade),i=i||l.text||l.icon);}for(var u in r){var h=r[u];if(!this.opacities[u]){var p=new pe(h,o,!1,!1);p.isHidden()||(this.opacities[u]=p,i=i||h.text.placed||h.icon.placed);}}for(var d in a)this.variableOffsets[d]||!this.opacities[d]||this.opacities[d].isHidden()||(this.variableOffsets[d]=a[d]);for(var _ in n)this.placedOrientations[_]||!this.opacities[_]||this.opacities[_].isHidden()||(this.placedOrientations[_]=n[_]);i?this.lastPlacementChangeTime=t:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=e?e.lastPlacementChangeTime:t);},ge.prototype.updateLayerOpacities=function(t,e){for(var i={},o=0,r=e;o<r.length;o+=1){var a=r[o],n=a.getBucket(t);n&&a.latestFeatureIndex&&t.id===n.layerIds[0]&&this.updateBucketOpacities(n,i,a.collisionBoxArray);}},ge.prototype.updateBucketOpacities=function(e,i,o){e.hasTextData()&&e.text.opacityVertexArray.clear(),e.hasIconData()&&e.icon.opacityVertexArray.clear(),e.hasCollisionBoxData()&&e.collisionBox.collisionVertexArray.clear(),e.hasCollisionCircleData()&&e.collisionCircle.collisionVertexArray.clear();var r=e.layers[0].layout,a=new pe(null,0,!1,!1,!0),n=r.get("text-allow-overlap"),s=r.get("icon-allow-overlap"),l=r.get("text-variable-anchor"),c="map"===r.get("text-rotation-alignment"),u="map"===r.get("text-pitch-alignment"),h=new pe(null,0,n&&(s||!e.hasIconData()||r.get("icon-optional")),s&&(n||!e.hasTextData()||r.get("text-optional")),!0);!e.collisionArrays&&o&&(e.hasCollisionBoxData()||e.hasCollisionCircleData())&&e.deserializeCollisionBoxes(o);for(var p=0;p<e.symbolInstances.length;p++){var d=e.symbolInstances.get(p),_=d.numHorizontalGlyphVertices,f=d.numVerticalGlyphVertices,m=d.crossTileID,g=i[m],v=this.opacities[m];g?v=a:v||(v=h,this.opacities[m]=v),i[m]=!0;var y=_>0||f>0,x=d.numIconVertices>0;if(y){for(var b=Se(v.text),w=(_+f)/4,E=0;E<w;E++)e.text.opacityVertexArray.emplaceBack(b);var T=v.text.isHidden()?1:0,I=this.placedOrientations[d.crossTileID],S=I===t.WritingMode.horizontal||I===t.WritingMode.horizontalOnly?1:0,C=I===t.WritingMode.vertical?1:0;[d.rightJustifiedTextSymbolIndex,d.centerJustifiedTextSymbolIndex,d.leftJustifiedTextSymbolIndex].forEach((function(t){t>=0&&(e.text.placedSymbolArray.get(t).hidden=T||C);})),d.verticalPlacedTextSymbolIndex>=0&&(e.text.placedSymbolArray.get(d.verticalPlacedTextSymbolIndex).hidden=T||S);var P=this.variableOffsets[d.crossTileID];P&&this.markUsedJustification(e,P.anchor,d,I);var z=this.placedOrientations[d.crossTileID];z&&(this.markUsedJustification(e,"left",d,z),this.markUsedOrientation(e,z,d));}if(x){for(var L=Se(v.icon),M=0;M<d.numIconVertices/4;M++)e.icon.opacityVertexArray.emplaceBack(L);e.icon.placedSymbolArray.get(p).hidden=v.icon.isHidden();}if(e.hasCollisionBoxData()||e.hasCollisionCircleData()){var D=e.collisionArrays[p];if(D){if(D.textBox){var R=new t.Point(0,0),A=!0;if(l){var k=this.variableOffsets[m];k?(R=me(k.anchor,k.width,k.height,k.radialOffset,k.textBoxScale),c&&R._rotate(u?this.transform.angle:-this.transform.angle)):A=!1;}ve(e.collisionBox.collisionVertexArray,v.text.placed,!A,R.x,R.y);}D.iconBox&&ve(e.collisionBox.collisionVertexArray,v.icon.placed,!1);var B=D.textCircles;if(B&&e.hasCollisionCircleData())for(var O=0;O<B.length;O+=5){var F=g||0===B[O+4];ve(e.collisionCircle.collisionVertexArray,v.text.placed,F);}}}}e.sortFeatures(this.transform.angle),this.retainedQueryData[e.bucketInstanceId]&&(this.retainedQueryData[e.bucketInstanceId].featureSortOrder=e.featureSortOrder),e.hasTextData()&&e.text.opacityVertexBuffer&&e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray),e.hasIconData()&&e.icon.opacityVertexBuffer&&e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray),e.hasCollisionBoxData()&&e.collisionBox.collisionVertexBuffer&&e.collisionBox.collisionVertexBuffer.updateData(e.collisionBox.collisionVertexArray),e.hasCollisionCircleData()&&e.collisionCircle.collisionVertexBuffer&&e.collisionCircle.collisionVertexBuffer.updateData(e.collisionCircle.collisionVertexArray);},ge.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration},ge.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},ge.prototype.stillRecent=function(t){return this.commitTime+this.fadeDuration>t},ge.prototype.setStale=function(){this.stale=!0;};var ye=Math.pow(2,25),xe=Math.pow(2,24),be=Math.pow(2,17),we=Math.pow(2,16),Ee=Math.pow(2,9),Te=Math.pow(2,8),Ie=Math.pow(2,1);function Se(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0,i=Math.floor(127*t.opacity);return i*ye+e*xe+i*be+e*we+i*Ee+e*Te+i*Ie+e}var Ce=function(){this._currentTileIndex=0,this._seenCrossTileIDs={};};Ce.prototype.continuePlacement=function(t,e,i,o,r){for(;this._currentTileIndex<t.length;){var a=t[this._currentTileIndex];if(e.placeLayerTile(o,a,i,this._seenCrossTileIDs),this._currentTileIndex++,r())return !0}};var Pe=function(t,e,i,o,r,a,n){this.placement=new ge(t,r,a,n),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;};Pe.prototype.isDone=function(){return this._done},Pe.prototype.continuePlacement=function(e,i,o){for(var r=this,a=t.browser.now(),n=function(){var e=t.browser.now()-a;return !r._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=i[e[this._currentPlacementIndex]],l=this.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(this._inProgressLayer||(this._inProgressLayer=new Ce),this._inProgressLayer.continuePlacement(o[s.source],this.placement,this._showCollisionBoxes,s,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;},Pe.prototype.commit=function(t){return this.placement.commit(t),this.placement};var ze=512/t.EXTENT/2,Le=function(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var o=0;o<e.length;o++){var r=e.get(o),a=r.key;this.indexedSymbolInstances[a]||(this.indexedSymbolInstances[a]=[]),this.indexedSymbolInstances[a].push({crossTileID:r.crossTileID,coord:this.getScaledCoordinates(r,t)});}};Le.prototype.getScaledCoordinates=function(e,i){var o=i.canonical.z-this.tileID.canonical.z,r=ze/Math.pow(2,o);return {x:Math.floor((i.canonical.x*t.EXTENT+e.anchorX)*r),y:Math.floor((i.canonical.y*t.EXTENT+e.anchorY)*r)}},Le.prototype.findMatches=function(t,e,i){for(var o=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),r=0;r<t.length;r++){var a=t.get(r);if(!a.crossTileID){var n=this.indexedSymbolInstances[a.key];if(n)for(var s=this.getScaledCoordinates(a,e),l=0,c=n;l<c.length;l+=1){var u=c[l];if(Math.abs(u.coord.x-s.x)<=o&&Math.abs(u.coord.y-s.y)<=o&&!i[u.crossTileID]){i[u.crossTileID]=!0,a.crossTileID=u.crossTileID;break}}}}};var Me=function(){this.maxCrossTileID=0;};Me.prototype.generate=function(){return ++this.maxCrossTileID};var De=function(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;};De.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var o=this.indexes[i],r={};for(var a in o){var n=o[a];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),r[n.tileID.key]=n;}this.indexes[i]=r;}this.lng=t;},De.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key]);}for(var o=0;o<e.symbolInstances.length;o++){e.symbolInstances.get(o).crossTileID=0;}this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var r=this.usedCrossTileIDs[t.overscaledZ];for(var a in this.indexes){var n=this.indexes[a];if(Number(a)>t.overscaledZ)for(var s in n){var l=n[s];l.tileID.isChildOf(t)&&l.findMatches(e.symbolInstances,t,r);}else{var c=n[t.scaledTo(Number(a)).key];c&&c.findMatches(e.symbolInstances,t,r);}}for(var u=0;u<e.symbolInstances.length;u++){var h=e.symbolInstances.get(u);h.crossTileID||(h.crossTileID=i.generate(),r[h.crossTileID]=!0);}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new Le(t,e.symbolInstances,e.bucketInstanceId),!0},De.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var o=0,r=e.indexedSymbolInstances[i];o<r.length;o+=1){var a=r[o];delete this.usedCrossTileIDs[t][a.crossTileID];}},De.prototype.removeStaleBuckets=function(t){var e=!1;for(var i in this.indexes){var o=this.indexes[i];for(var r in o)t[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],e=!0);}return e};var Re=function(){this.layerIndexes={},this.crossTileIDs=new Me,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};};Re.prototype.addLayer=function(t,e,i){var o=this.layerIndexes[t.id];void 0===o&&(o=this.layerIndexes[t.id]=new De);var r=!1,a={};o.handleWrapJump(i);for(var n=0,s=e;n<s.length;n+=1){var l=s[n],c=l.getBucket(t);c&&t.id===c.layerIds[0]&&(c.bucketInstanceId||(c.bucketInstanceId=++this.maxBucketInstanceId),o.addBucket(l.tileID,c,this.crossTileIDs)&&(r=!0),a[c.bucketInstanceId]=!0);}return o.removeStaleBuckets(a)&&(r=!0),r},Re.prototype.pruneUnusedLayers=function(t){var e={};for(var i in t.forEach((function(t){e[t]=!0;})),this.layerIndexes)e[i]||delete this.layerIndexes[i];};var Ae=function(e,i){return t.emitValidationErrors(e,i&&i.filter((function(t){return "source.canvas"!==t.identifier})))},ke=t.pick(Ut,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),Be=t.pick(Ut,["setCenter","setZoom","setBearing","setPitch"]),Oe=function(e){function i(o,r){var a=this;void 0===r&&(r={}),e.call(this),this.map=o,this.dispatcher=new T((kt||(kt=new At),kt),this),this.imageManager=new p,this.imageManager.setEventedParent(this),this.glyphManager=new y(o._requestManager,r.localIdeographFontFamily),this.lineAtlas=new E(256,512),this.crossTileSymbolIndex=new Re,this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._resetUpdates(),this.dispatcher.broadcast("setReferrer",t.getReferrer());var n=this;this._rtlTextPluginCallback=i.registerForPluginAvailability((function(t){for(var e in n.dispatcher.broadcast("loadRTLTextPlugin",t.pluginURL,t.completionCallback),n.sourceCaches)n.sourceCaches[e].reload();})),this.on("data",(function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType){var e=a.sourceCaches[t.sourceId];if(e){var i=e.getSource();if(i&&i.vectorLayerIds)for(var o in a._layers){var r=a._layers[o];r.source===i.id&&a._validateLayer(r);}}}}));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.loadURL=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"}));var r="boolean"==typeof i.validate?i.validate:!t.isMapboxURL(e);e=this.map._requestManager.normalizeStyleURL(e,i.accessToken);var a=this.map._requestManager.transformRequest(e,t.ResourceType.Style);this._request=t.getJSON(a,(function(e,i){o._request=null,e?o.fire(new t.ErrorEvent(e)):i&&o._load(i,r);}));},i.prototype.loadJSON=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame((function(){o._request=null,o._load(e,!1!==i.validate);}));},i.prototype._load=function(e,i){var o=this;if(!i||!Ae(this,t.validateStyle(e))){for(var r in this._loaded=!0,this.stylesheet=e,e.sources)this.addSource(r,e.sources[r],{validate:!1});e.sprite?this._spriteRequest=function(e,i,o){var r,a,n,s=t.browser.devicePixelRatio>1?"@2x":"",l=t.getJSON(i.transformRequest(i.normalizeSpriteURL(e,s,".json"),t.ResourceType.SpriteJSON),(function(t,e){l=null,n||(n=t,r=e,u());})),c=t.getImage(i.transformRequest(i.normalizeSpriteURL(e,s,".png"),t.ResourceType.SpriteImage),(function(t,e){c=null,n||(n=t,a=e,u());}));function u(){if(n)o(n);else if(r&&a){var e=t.browser.getImageData(a),i={};for(var s in r){var l=r[s],c=l.width,u=l.height,h=l.x,p=l.y,d=l.sdf,_=l.pixelRatio,f=new t.RGBAImage({width:c,height:u});t.RGBAImage.copy(e,f,{x:h,y:p},{x:0,y:0},{width:c,height:u}),i[s]={data:f,pixelRatio:_,sdf:d};}o(null,i);}}return {cancel:function(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(e.sprite,this.map._requestManager,(function(e,i){if(o._spriteRequest=null,e)o.fire(new t.ErrorEvent(e));else if(i)for(var r in i)o.imageManager.addImage(r,i[r]);o.imageManager.setLoaded(!0),o.fire(new t.Event("data",{dataType:"style"}));})):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var a=Ft(this.stylesheet.layers);this._order=a.map((function(t){return t.id})),this._layers={};for(var n=0,s=a;n<s.length;n+=1){var l=s[n];(l=t.createStyleLayer(l)).setEventedParent(this,{layer:{id:l.id}}),this._layers[l.id]=l;}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new w(this.stylesheet.light),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"));}},i.prototype._validateLayer=function(e){var i=this.sourceCaches[e.source];if(i){var o=e.sourceLayer;if(o){var r=i.getSource();("geojson"===r.type||r.vectorLayerIds&&-1===r.vectorLayerIds.indexOf(o))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+o+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"')));}}},i.prototype.loaded=function(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return !1;return !!this.imageManager.isLoaded()},i.prototype._serializeLayers=function(t){for(var e=[],i=0,o=t;i<o.length;i+=1){var r=o[i],a=this._layers[r];"custom"!==a.type&&e.push(a.serialize());}return e},i.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return !0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return !0;for(var e in this._layers)if(this._layers[e].hasTransition())return !0;return !1},i.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},i.prototype.update=function(e){if(this._loaded){var i=this._changed;if(this._changed){var o=Object.keys(this._updatedLayers),r=Object.keys(this._removedLayers);for(var a in(o.length||r.length)&&this._updateWorkerLayers(o,r),this._updatedSources){var n=this._updatedSources[a];"reload"===n?this._reloadSource(a):"clear"===n&&this._clearSource(a);}for(var s in this._updatedPaintProps)this._layers[s].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates();}for(var l in this.sourceCaches)this.sourceCaches[l].used=!1;for(var c=0,u=this._order;c<u.length;c+=1){var h=u[c],p=this._layers[h];p.recalculate(e),!p.isHidden(e.zoom)&&p.source&&(this.sourceCaches[p.source].used=!0);}this.light.recalculate(e),this.z=e.zoom,i&&this.fire(new t.Event("data",{dataType:"style"}));}},i.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e});},i.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={};},i.prototype.setState=function(e){var i=this;if(this._checkLoaded(),Ae(this,t.validateStyle(e)))return !1;(e=t.clone$1(e)).layers=Ft(e.layers);var o=Xt(this.serialize(),e).filter((function(t){return !(t.command in Be)}));if(0===o.length)return !1;var r=o.filter((function(t){return !(t.command in ke)}));if(r.length>0)throw new Error("Unimplemented: "+r.map((function(t){return t.command})).join(", ")+".");return o.forEach((function(t){"setTransition"!==t.command&&i[t.command].apply(i,t.args);})),this.stylesheet=e,!0},i.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.updateImage=function(t,e){this.imageManager.updateImage(t,e);},i.prototype.getImage=function(t){return this.imageManager.getImage(t)},i.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},i.prototype.addSource=function(e,i,o){var r=this;if(void 0===o&&(o={}),this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(i).join(", ")+".");if(!(["vector","raster","geojson","video","image"].indexOf(i.type)>=0)||!this._validate(t.validateStyle.source,"sources."+e,i,null,o)){this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);var a=this.sourceCaches[e]=new Lt(e,i,this.dispatcher);a.style=this,a.setEventedParent(this,(function(){return {isSourceLoaded:r.loaded(),source:a.serialize(),sourceId:e}})),a.onAdd(this.map),this._changed=!0;}},i.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var o=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],o.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),o.setEventedParent(null),o.clearTiles(),o.onRemove&&o.onRemove(this.map),this._changed=!0;},i.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0;},i.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},i.prototype.addLayer=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=e.id;if(this.getLayer(r))this.fire(new t.ErrorEvent(new Error('Layer with id "'+r+'" already exists on this map')));else{var a;if("custom"===e.type){if(Ae(this,t.validateCustomStyleLayer(e)))return;a=t.createStyleLayer(e);}else{if("object"==typeof e.source&&(this.addSource(r,e.source),e=t.clone$1(e),e=t.extend(e,{source:r})),this._validate(t.validateStyle.layer,"layers."+r,e,{arrayIndex:-1},o))return;a=t.createStyleLayer(e),this._validateLayer(a),a.setEventedParent(this,{layer:{id:r}});}var n=i?this._order.indexOf(i):this._order.length;if(i&&-1===n)this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.')));else{if(this._order.splice(n,0,r),this._layerOrderChanged=!0,this._layers[r]=a,this._removedLayers[r]&&a.source&&"custom"!==a.type){var s=this._removedLayers[r];delete this._removedLayers[r],s.type!==a.type?this._updatedSources[a.source]="clear":(this._updatedSources[a.source]="reload",this.sourceCaches[a.source].pause());}this._updateLayer(a),a.onAdd&&a.onAdd(this.map);}}},i.prototype.moveLayer=function(e,i){if(this._checkLoaded(),this._changed=!0,this._layers[e]){if(e!==i){var o=this._order.indexOf(e);this._order.splice(o,1);var r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(r,0,e),this._layerOrderChanged=!0);}}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")));},i.prototype.removeLayer=function(e){this._checkLoaded();var i=this._layers[e];if(i){i.setEventedParent(null);var o=this._order.indexOf(e);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=i,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e],i.onRemove&&i.onRemove(this.map);}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")));},i.prototype.getLayer=function(t){return this._layers[t]},i.prototype.setLayerZoomRange=function(e,i,o){this._checkLoaded();var r=this.getLayer(e);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")));},i.prototype.setFilter=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=this.getLayer(e);if(r){if(!t.deepEqual(r.filter,i))return null==i?(r.filter=void 0,void this._updateLayer(r)):void(this._validate(t.validateStyle.filter,"layers."+r.id+".filter",i,null,o)||(r.filter=t.clone$1(i),this._updateLayer(r)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")));},i.prototype.getFilter=function(e){return t.clone$1(this.getLayer(e).filter)},i.prototype.setLayoutProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getLayoutProperty(i),o)||(a.setLayoutProperty(i,o,r),this._updateLayer(a)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getLayoutProperty=function(e,i){var o=this.getLayer(e);if(o)return o.getLayoutProperty(i);this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style.")));},i.prototype.setPaintProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getPaintProperty(i),o)||(a.setPaintProperty(i,o,r)&&this._updateLayer(a),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},i.prototype.setFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=e.sourceLayer,a=this.sourceCaches[o],n=parseInt(e.id,10);if(void 0!==a){var s=a.getSource().type;"geojson"===s&&r?this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))):"vector"!==s||r?isNaN(n)||n<0?this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided and non-negative."))):a.setFeatureState(r,n,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.removeFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=this.sourceCaches[o];if(void 0!==r){var a=r.getSource().type,n="vector"===a?e.sourceLayer:void 0,s=parseInt(e.id,10);"vector"!==a||n?void 0!==e.id&&isNaN(s)||s<0?this.fire(new t.ErrorEvent(new Error("The feature id parameter must be non-negative."))):i&&"string"!=typeof e.id&&"number"!=typeof e.id?this.fire(new t.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))):r.removeFeatureState(n,s,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,o=e.sourceLayer,r=this.sourceCaches[i],a=parseInt(e.id,10);if(void 0!==r)if("vector"!==r.getSource().type||o){if(!(isNaN(a)||a<0))return r.getFeatureState(o,a);this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided and non-negative.")));}else this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")));},i.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},i.prototype.serialize=function(){return t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,(function(t){return t.serialize()})),layers:this._serializeLayers(this._order)},(function(t){return void 0!==t}))},i.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0;},i.prototype._flattenAndSortRenderedFeatures=function(t){for(var e=this,i=function(t){return "fill-extrusion"===e._layers[t].type},o={},r=[],a=this._order.length-1;a>=0;a--){var n=this._order[a];if(i(n)){o[n]=a;for(var s=0,l=t;s<l.length;s+=1){var c=l[s][n];if(c)for(var u=0,h=c;u<h.length;u+=1){var p=h[u];r.push(p);}}}}r.sort((function(t,e){return e.intersectionZ-t.intersectionZ}));for(var d=[],_=this._order.length-1;_>=0;_--){var f=this._order[_];if(i(f))for(var m=r.length-1;m>=0;m--){var g=r[m].feature;if(o[g.layer.id]<_)break;d.push(g),r.pop();}else for(var v=0,y=t;v<y.length;v+=1){var x=y[v][f];if(x)for(var b=0,w=x;b<w.length;b+=1){var E=w[b];d.push(E.feature);}}}return d},i.prototype.queryRenderedFeatures=function(e,i,o){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter,null,i);var r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var a=0,n=i.layers;a<n.length;a+=1){var s=n[a],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];r[l.source]=!0;}}var c=[];for(var u in this.sourceCaches)i.layers&&!r[u]||c.push(O(this.sourceCaches[u],this._layers,e,i,o));return this.placement&&c.push(function(t,e,i,o,r,a){for(var n={},s=r.queryRenderedSymbols(i),l=[],c=0,u=Object.keys(s).map(Number);c<u.length;c+=1){var h=u[c];l.push(a[h]);}l.sort(F);for(var p=function(){var e=_[d],i=e.featureIndex.lookupSymbolFeatures(s[e.bucketInstanceId],e.bucketIndex,e.sourceLayerIndex,o.filter,o.layers,t);for(var r in i){var a=n[r]=n[r]||[],l=i[r];l.sort((function(t,i){var o=e.featureSortOrder;if(o){var r=o.indexOf(t.featureIndex);return o.indexOf(i.featureIndex)-r}return i.featureIndex-t.featureIndex}));for(var c=0,u=l;c<u.length;c+=1){var h=u[c];a.push(h);}}},d=0,_=l;d<_.length;d+=1)p();var f=function(i){n[i].forEach((function(o){var r=o.feature,a=t[i],n=e[a.source].getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=n;}));};for(var m in n)f(m);return n}(this._layers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(c)},i.prototype.querySourceFeatures=function(e,i){i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter,null,i);var o=this.sourceCaches[e];return o?function(t,e){for(var i=t.getRenderableIds().map((function(e){return t.getTileByID(e)})),o=[],r={},a=0;a<i.length;a++){var n=i[a],s=n.tileID.canonical.key;r[s]||(r[s]=!0,n.querySourceFeatures(o,e));}return o}(o,i):[]},i.prototype.addSourceType=function(t,e,o){return i.getSourceType(t)?o(new Error('A source type called "'+t+'" already exists.')):(i.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},o):o(null,null))},i.prototype.getLight=function(){return this.light.getLight()},i.prototype.setLight=function(e,i){void 0===i&&(i={}),this._checkLoaded();var o=this.light.getLight(),r=!1;for(var a in e)if(!t.deepEqual(e[a],o[a])){r=!0;break}if(r){var n={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)};this.light.setLight(e,i),this.light.updateTransitions(n);}},i.prototype._validate=function(e,i,o,r,a){return void 0===a&&(a={}),(!a||!1!==a.validate)&&Ae(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:o,styleSpec:t.styleSpec},r)))},i.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginAvailable",this._rtlTextPluginCallback),this.sourceCaches)this.sourceCaches[e].clearTiles();this.dispatcher.remove();},i.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles();},i.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload();},i.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t);},i.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t);},i.prototype._updatePlacement=function(e,i,o,r){for(var a=!1,n=!1,s={},l=0,c=this._order;l<c.length;l+=1){var u=c[l],h=this._layers[u];if("symbol"===h.type){if(!s[h.source]){var p=this.sourceCaches[h.source];s[h.source]=p.getRenderableIds(!0).map((function(t){return p.getTileByID(t)})).sort((function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)}));}var d=this.crossTileSymbolIndex.addLayer(h,s[h.source],e.center.lng);a=a||d;}}this.crossTileSymbolIndex.pruneUnusedLayers(this._order);var _=this._layerOrderChanged||0===o;if((_||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now()))&&(this.pauseablePlacement=new Pe(e,this._order,_,i,o,r,this.placement),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,s),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(t.browser.now()),n=!0),a&&this.pauseablePlacement.placement.setStale()),n||a)for(var f=0,m=this._order;f<m.length;f+=1){var g=m[f],v=this._layers[g];"symbol"===v.type&&this.placement.updateLayerOpacities(v,s[v.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},i.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();},i.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i);},i.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i);},i.prototype.getResource=function(e,i,o){return t.makeRequest(i,o)},i}(t.Evented);Oe.getSourceType=function(t){return A[t]},Oe.setSourceType=function(t,e){A[t]=e;},Oe.registerForPluginAvailability=t.registerForPluginAvailability;var Fe=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),Ue=ui("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif","#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),Ne=ui("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ze=ui("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),qe=ui("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),je=ui("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ve=ui("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),Ge=ui("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),We=ui("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),Xe=ui("uniform float u_overscale_factor;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {float alpha=0.5;vec4 color=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {color=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {color*=.2;}float extrude_scale_length=length(v_extrude_scale);float extrude_length=length(v_extrude)*extrude_scale_length;float stroke_width=15.0*extrude_scale_length/u_overscale_factor;float radius=v_radius*extrude_scale_length;float distance_to_edge=abs(extrude_length-radius);float opacity_t=smoothstep(-stroke_width,0.0,-distance_to_edge);gl_FragColor=opacity_t*color;}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);highp float padding_factor=1.2;gl_Position.xy+=a_extrude*u_extrude_scale*padding_factor*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;v_radius=abs(a_extrude.y);v_extrude=a_extrude*padding_factor;v_extrude_scale=u_extrude_scale*u_camera_to_center_distance*collision_perspective_ratio;}"),He=ui("uniform highp vec4 u_color;void main() {gl_FragColor=u_color;}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ke=ui("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),Je=ui("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),Ye=ui("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),Qe=ui("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),$e=ui("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),ti=ui("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec4 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),ei=ui("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;return (data.r+data.g*256.0+data.b*256.0*256.0)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),ii=ui("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),oi=ui("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ri=ui("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ai=ui("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec4 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x,1.0);float x_b=mod(v_linesofar/pattern_size_b.x,1.0);float y_a=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_a.y+2.0)/2.0)/pattern_size_a.y);float y_b=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_b.y+2.0)/2.0)/pattern_size_b.y);vec2 pos_a=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,vec2(x_a,y_a));vec2 pos_b=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,vec2(x_b,y_b));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);}"),ni=ui("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),si=ui("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),li=ui("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"),ci=ui("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=vec2(tex.x,tex.y);v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}");function ui(t,e){var i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o={};return {fragmentSource:t=t.replace(i,(function(t,e,i,r,a){return o[a]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"})),vertexSource:e=e.replace(i,(function(t,e,i,r,a){var n="float"===r?"vec2":"vec4",s=a.match(/color/)?"color":n;return o[a]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"}))}}var hi=Object.freeze({prelude:Ue,background:Ne,backgroundPattern:Ze,circle:qe,clippingMask:je,heatmap:Ve,heatmapTexture:Ge,collisionBox:We,collisionCircle:Xe,debug:He,fill:Ke,fillOutline:Je,fillOutlinePattern:Ye,fillPattern:Qe,fillExtrusion:$e,fillExtrusionPattern:ti,hillshadePrepare:ei,hillshade:ii,line:oi,lineGradient:ri,linePattern:ai,lineSDF:ni,raster:si,symbolIcon:li,symbolSDF:ci}),pi=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null;};pi.prototype.bind=function(t,e,i,o,r,a,n,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==o.length,c=0;!l&&c<o.length;c++)this.boundPaintVertexBuffers[c]!==o[c]&&(l=!0);var u=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==i||l||this.boundIndexBuffer!==r||this.boundVertexOffset!==a||this.boundDynamicVertexBuffer!==n||this.boundDynamicVertexBuffer2!==s;!t.extVertexArrayObject||u?this.freshBind(e,i,o,r,a,n,s):(t.bindVertexArrayOES.set(this.vao),n&&n.bind(),r&&r.dynamicDraw&&r.bind(),s&&s.bind());},pi.prototype.freshBind=function(t,e,i,o,r,a,n){var s,l=t.numAttributes,c=this.context,u=c.gl;if(c.extVertexArrayObject)this.vao&&this.destroy(),this.vao=c.extVertexArrayObject.createVertexArrayOES(),c.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffer=a,this.boundDynamicVertexBuffer2=n;else{s=c.currentNumAttributes||0;for(var h=l;h<s;h++)u.disableVertexAttribArray(h);}e.enableAttributes(u,t);for(var p=0,d=i;p<d.length;p+=1){d[p].enableAttributes(u,t);}a&&a.enableAttributes(u,t),n&&n.enableAttributes(u,t),e.bind(),e.setVertexAttribPointers(u,t,r);for(var _=0,f=i;_<f.length;_+=1){var m=f[_];m.bind(),m.setVertexAttribPointers(u,t,r);}a&&(a.bind(),a.setVertexAttribPointers(u,t,r)),o&&o.bind(),n&&(n.bind(),n.setVertexAttribPointers(u,t,r)),c.currentNumAttributes=l;},pi.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);};var di=function(t,e,i,o,r){var a=t.gl;this.program=a.createProgram();var n=i.defines();r&&n.push("#define OVERDRAW_INSPECTOR;");var s=n.concat(Ue.fragmentSource,e.fragmentSource).join("\n"),l=n.concat(Ue.vertexSource,e.vertexSource).join("\n"),c=a.createShader(a.FRAGMENT_SHADER);a.shaderSource(c,s),a.compileShader(c),a.attachShader(this.program,c);var u=a.createShader(a.VERTEX_SHADER);a.shaderSource(u,l),a.compileShader(u),a.attachShader(this.program,u);for(var h=i.layoutAttributes||[],p=0;p<h.length;p++)a.bindAttribLocation(this.program,p,h[p].name);a.linkProgram(this.program),this.numAttributes=a.getProgramParameter(this.program,a.ACTIVE_ATTRIBUTES),this.attributes={};for(var d={},_=0;_<this.numAttributes;_++){var f=a.getActiveAttrib(this.program,_);f&&(this.attributes[f.name]=a.getAttribLocation(this.program,f.name));}for(var m=a.getProgramParameter(this.program,a.ACTIVE_UNIFORMS),g=0;g<m;g++){var v=a.getActiveUniform(this.program,g);v&&(d[v.name]=a.getUniformLocation(this.program,v.name));}this.fixedUniforms=o(t,d),this.binderUniforms=i.getUniforms(t,d);};function _i(e,i,o){var r=1/ue(o,1,i.transform.tileZoom),a=Math.pow(2,o.tileID.overscaledZ),n=o.tileSize*Math.pow(2,i.transform.tileZoom)/a,s=n*(o.tileID.canonical.x+o.tileID.wrap*a),l=n*o.tileID.canonical.y;return {u_image:0,u_texsize:o.imageAtlasTexture.size,u_scale:[t.browser.devicePixelRatio,r,e.fromScale,e.toScale],u_fade:e.t,u_pixel_coord_upper:[s>>16,l>>16],u_pixel_coord_lower:[65535&s,65535&l]}}di.prototype.draw=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_,f){var m,g=t.gl;for(var v in t.program.set(this.program),t.setDepthMode(i),t.setStencilMode(o),t.setColorMode(r),t.setCullFace(a),this.fixedUniforms)this.fixedUniforms[v].set(n[v]);d&&d.setUniforms(t,this.binderUniforms,h,{zoom:p});for(var y=(m={},m[g.LINES]=2,m[g.TRIANGLES]=3,m[g.LINE_STRIP]=1,m)[e],x=0,b=u.get();x<b.length;x+=1){var w=b[x],E=w.vaos||(w.vaos={});(E[s]||(E[s]=new pi)).bind(t,this,l,d?d.getPaintVertexBuffers():[],c,w.vertexOffset,_,f),g.drawElements(e,w.primitiveLength*y,g.UNSIGNED_SHORT,w.primitiveOffset*y*2);}};var fi=function(e,i,o,r){var a=i.style.light,n=a.properties.get("position"),s=[n.x,n.y,n.z],l=t.create$1();"viewport"===a.properties.get("anchor")&&t.fromRotation(l,-i.transform.angle),t.transformMat3(s,s,l);var c=a.properties.get("color");return {u_matrix:e,u_lightpos:s,u_lightintensity:a.properties.get("intensity"),u_lightcolor:[c.r,c.g,c.b],u_vertical_gradient:+o,u_opacity:r}},mi=function(e,i,o,r,a,n,s){return t.extend(fi(e,i,o,r),_i(n,i,s),{u_height_factor:-Math.pow(2,a.overscaledZ)/s.tileSize/8})},gi=function(t){return {u_matrix:t}},vi=function(e,i,o,r){return t.extend(gi(e),_i(o,i,r))},yi=function(t,e){return {u_matrix:t,u_world:e}},xi=function(e,i,o,r,a){return t.extend(vi(e,i,o,r),{u_world:a})},bi=function(e,i,o,r){var a,n,s=e.transform;if("map"===r.paint.get("circle-pitch-alignment")){var l=ue(o,1,s.zoom);a=!0,n=[l,l];}else a=!1,n=s.pixelsToGLUnits;return {u_camera_to_center_distance:s.cameraToCenterDistance,u_scale_with_map:+("map"===r.paint.get("circle-pitch-scale")),u_matrix:e.translatePosMatrix(i.posMatrix,o,r.paint.get("circle-translate"),r.paint.get("circle-translate-anchor")),u_pitch_with_map:+a,u_device_pixel_ratio:t.browser.devicePixelRatio,u_extrude_scale:n}},wi=function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pixels_to_tile_units:new t.Uniform1f(e,i.u_pixels_to_tile_units),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_overscale_factor:new t.Uniform1f(e,i.u_overscale_factor)}},Ei=function(t,e,i){var o=ue(i,1,e.zoom),r=Math.pow(2,e.zoom-i.tileID.overscaledZ),a=i.tileID.overscaleFactor();return {u_matrix:t,u_camera_to_center_distance:e.cameraToCenterDistance,u_pixels_to_tile_units:o,u_extrude_scale:[e.pixelsToGLUnits[0]/(o*r),e.pixelsToGLUnits[1]/(o*r)],u_overscale_factor:a}},Ti=function(t,e){return {u_matrix:t,u_color:e}},Ii=function(t){return {u_matrix:t}},Si=function(t,e,i,o){return {u_matrix:t,u_extrude_scale:ue(e,1,i),u_intensity:o}},Ci=function(e,i,o,r){var a=t.create();t.ortho(a,0,e.width,e.height,0,0,1);var n=e.context.gl;return {u_matrix:a,u_world:[n.drawingBufferWidth,n.drawingBufferHeight],u_image:o,u_color_ramp:r,u_opacity:i.paint.get("heatmap-opacity")}},Pi=function(t,e,i){var o=i.paint.get("hillshade-shadow-color"),r=i.paint.get("hillshade-highlight-color"),a=i.paint.get("hillshade-accent-color"),n=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(n-=t.transform.angle);var s=!t.options.moving;return {u_matrix:t.transform.calculatePosMatrix(e.tileID.toUnwrapped(),s),u_image:0,u_latrange:Li(t,e.tileID),u_light:[i.paint.get("hillshade-exaggeration"),n],u_shadow:o,u_highlight:r,u_accent:a}},zi=function(e,i){var o=e.dem.stride,r=t.create();return t.ortho(r,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(r,r,[0,-t.EXTENT,0]),{u_matrix:r,u_image:1,u_dimension:[o,o],u_zoom:e.tileID.overscaledZ,u_maxzoom:i}};function Li(e,i){var o=Math.pow(2,i.canonical.z),r=i.canonical.y;return [new t.MercatorCoordinate(0,r/o).toLngLat().lat,new t.MercatorCoordinate(0,(r+1)/o).toLngLat().lat]}var Mi=function(e,i,o){var r=e.transform;return {u_matrix:Bi(e,i,o),u_ratio:1/ue(i,1,r.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_units_to_pixels:[1/r.pixelsToGLUnits[0],1/r.pixelsToGLUnits[1]]}},Di=function(e,i,o){return t.extend(Mi(e,i,o),{u_image:0})},Ri=function(e,i,o,r){var a=e.transform,n=ki(i,a);return {u_matrix:Bi(e,i,o),u_texsize:i.imageAtlasTexture.size,u_ratio:1/ue(i,1,a.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_image:0,u_scale:[t.browser.devicePixelRatio,n,r.fromScale,r.toScale],u_fade:r.t,u_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]]}},Ai=function(e,i,o,r,a){var n=e.transform,s=e.lineAtlas,l=ki(i,n),c="round"===o.layout.get("line-cap"),u=s.getDash(r.from,c),h=s.getDash(r.to,c),p=u.width*a.fromScale,d=h.width*a.toScale;return t.extend(Mi(e,i,o),{u_patternscale_a:[l/p,-u.height/2],u_patternscale_b:[l/d,-h.height/2],u_sdfgamma:s.width/(256*Math.min(p,d)*t.browser.devicePixelRatio)/2,u_image:0,u_tex_y_a:u.y,u_tex_y_b:h.y,u_mix:a.t})};function ki(t,e){return 1/ue(t,1,e.tileZoom)}function Bi(t,e,i){return t.translatePosMatrix(e.tileID.posMatrix,e,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}var Oi=function(t,e,i,o,r){return {u_matrix:t,u_tl_parent:e,u_scale_parent:i,u_buffer_scale:1,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(n=r.paint.get("raster-saturation"),n>0?1-1/(1.001-n):-n),u_contrast_factor:(a=r.paint.get("raster-contrast"),a>0?1/(1-a):1+a),u_spin_weights:Fi(r.paint.get("raster-hue-rotate"))};var a,n;};function Fi(t){t*=Math.PI/180;var e=Math.sin(t),i=Math.cos(t);return [(2*i+1)/3,(-Math.sqrt(3)*e-i+1)/3,(Math.sqrt(3)*e-i+1)/3]}var Ui=function(t,e,i,o,r,a,n,s,l,c){var u=r.transform;return {u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:e?e.uSizeT:0,u_size:e?e.uSize:0,u_camera_to_center_distance:u.cameraToCenterDistance,u_pitch:u.pitch/360*2*Math.PI,u_rotate_symbol:+i,u_aspect_ratio:u.width/u.height,u_fade_change:r.options.fadeDuration?r.symbolFadeChange:1,u_matrix:a,u_label_plane_matrix:n,u_coord_matrix:s,u_is_text:+l,u_pitch_with_map:+o,u_texsize:c,u_texture:0}},Ni=function(e,i,o,r,a,n,s,l,c,u,h){var p=a.transform;return t.extend(Ui(e,i,o,r,a,n,s,l,c,u),{u_gamma_scale:r?Math.cos(p._pitch)*p.cameraToCenterDistance:1,u_device_pixel_ratio:t.browser.devicePixelRatio,u_is_halo:+h})},Zi=function(t,e,i){return {u_matrix:t,u_opacity:e,u_color:i}},qi=function(e,i,o,r,a,n){return t.extend(function(t,e,i,o){var r=i.imageManager.getPattern(t.from),a=i.imageManager.getPattern(t.to),n=i.imageManager.getPixelSize(),s=n.width,l=n.height,c=Math.pow(2,o.tileID.overscaledZ),u=o.tileSize*Math.pow(2,i.transform.tileZoom)/c,h=u*(o.tileID.canonical.x+o.tileID.wrap*c),p=u*o.tileID.canonical.y;return {u_image:0,u_pattern_tl_a:r.tl,u_pattern_br_a:r.br,u_pattern_tl_b:a.tl,u_pattern_br_b:a.br,u_texsize:[s,l],u_mix:e.t,u_pattern_size_a:r.displaySize,u_pattern_size_b:a.displaySize,u_scale_a:e.fromScale,u_scale_b:e.toScale,u_tile_units_to_pixels:1/ue(o,1,i.transform.tileZoom),u_pixel_coord_upper:[h>>16,p>>16],u_pixel_coord_lower:[65535&h,65535&p]}}(r,n,o,a),{u_matrix:e,u_opacity:i})},ji={fillExtrusion:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fillExtrusionPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_height_factor:new t.Uniform1f(e,i.u_height_factor),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fill:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},fillPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},fillOutline:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world)}},fillOutlinePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},circle:function(e,i){return {u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_scale_with_map:new t.Uniform1i(e,i.u_scale_with_map),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},collisionBox:wi,collisionCircle:wi,debug:function(e,i){return {u_color:new t.UniformColor(e,i.u_color),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},clippingMask:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmap:function(e,i){return {u_extrude_scale:new t.Uniform1f(e,i.u_extrude_scale),u_intensity:new t.Uniform1f(e,i.u_intensity),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmapTexture:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_color_ramp:new t.Uniform1i(e,i.u_color_ramp),u_opacity:new t.Uniform1f(e,i.u_opacity)}},hillshade:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_latrange:new t.Uniform2f(e,i.u_latrange),u_light:new t.Uniform2f(e,i.u_light),u_shadow:new t.UniformColor(e,i.u_shadow),u_highlight:new t.UniformColor(e,i.u_highlight),u_accent:new t.UniformColor(e,i.u_accent)}},hillshadePrepare:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_dimension:new t.Uniform2f(e,i.u_dimension),u_zoom:new t.Uniform1f(e,i.u_zoom),u_maxzoom:new t.Uniform1f(e,i.u_maxzoom)}},line:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels)}},lineGradient:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_image:new t.Uniform1i(e,i.u_image)}},linePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_texsize:new t.Uniform2f(e,i.u_texsize),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_image:new t.Uniform1i(e,i.u_image),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},lineSDF:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_patternscale_a:new t.Uniform2f(e,i.u_patternscale_a),u_patternscale_b:new t.Uniform2f(e,i.u_patternscale_b),u_sdfgamma:new t.Uniform1f(e,i.u_sdfgamma),u_image:new t.Uniform1i(e,i.u_image),u_tex_y_a:new t.Uniform1f(e,i.u_tex_y_a),u_tex_y_b:new t.Uniform1f(e,i.u_tex_y_b),u_mix:new t.Uniform1f(e,i.u_mix)}},raster:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_tl_parent:new t.Uniform2f(e,i.u_tl_parent),u_scale_parent:new t.Uniform1f(e,i.u_scale_parent),u_buffer_scale:new t.Uniform1f(e,i.u_buffer_scale),u_fade_t:new t.Uniform1f(e,i.u_fade_t),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image0:new t.Uniform1i(e,i.u_image0),u_image1:new t.Uniform1i(e,i.u_image1),u_brightness_low:new t.Uniform1f(e,i.u_brightness_low),u_brightness_high:new t.Uniform1f(e,i.u_brightness_high),u_saturation_factor:new t.Uniform1f(e,i.u_saturation_factor),u_contrast_factor:new t.Uniform1f(e,i.u_contrast_factor),u_spin_weights:new t.Uniform3f(e,i.u_spin_weights)}},symbolIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture)}},symbolSDF:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1f(e,i.u_is_halo)}},background:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_color:new t.UniformColor(e,i.u_color)}},backgroundPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image:new t.Uniform1i(e,i.u_image),u_pattern_tl_a:new t.Uniform2f(e,i.u_pattern_tl_a),u_pattern_br_a:new t.Uniform2f(e,i.u_pattern_br_a),u_pattern_tl_b:new t.Uniform2f(e,i.u_pattern_tl_b),u_pattern_br_b:new t.Uniform2f(e,i.u_pattern_br_b),u_texsize:new t.Uniform2f(e,i.u_texsize),u_mix:new t.Uniform1f(e,i.u_mix),u_pattern_size_a:new t.Uniform2f(e,i.u_pattern_size_a),u_pattern_size_b:new t.Uniform2f(e,i.u_pattern_size_b),u_scale_a:new t.Uniform1f(e,i.u_scale_a),u_scale_b:new t.Uniform1f(e,i.u_scale_b),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_tile_units_to_pixels:new t.Uniform1f(e,i.u_tile_units_to_pixels)}}};function Vi(e,i){for(var o=e.sort((function(t,e){return t.tileID.isLessThan(e.tileID)?-1:e.tileID.isLessThan(t.tileID)?1:0})),r=0;r<o.length;r++){var a={},n=o[r],s=o.slice(r+1);Gi(n.tileID.wrapped(),n.tileID,s,new t.OverscaledTileID(0,n.tileID.wrap+1,0,0,0),a),n.setMask(a,i);}}function Gi(e,i,o,r,a){for(var n=0;n<o.length;n++){var s=o[n];if(r.isLessThan(s.tileID))break;if(i.key===s.tileID.key)return;if(s.tileID.isChildOf(i)){for(var l=i.children(1/0),c=0;c<l.length;c++){Gi(e,l[c],o.slice(n),r,a);}return}}var u=i.overscaledZ-e.overscaledZ,h=new t.CanonicalTileID(u,i.canonical.x-(e.canonical.x<<u),i.canonical.y-(e.canonical.y<<u));a[h.key]=a[h.key]||h;}function Wi(t,e,i,o,r){for(var a=t.context,n=a.gl,s=r?t.useProgram("collisionCircle"):t.useProgram("collisionBox"),l=0;l<o.length;l++){var c=o[l],u=e.getTile(c),h=u.getBucket(i);if(h){var p=r?h.collisionCircle:h.collisionBox;p&&s.draw(a,r?n.TRIANGLES:n.LINES,It.disabled,St.disabled,t.colorModeForRenderPass(),Pt.disabled,Ei(c.posMatrix,t.transform,u),i.id,p.layoutVertexBuffer,p.indexBuffer,p.segments,null,t.transform.zoom,null,null,p.collisionVertexBuffer);}}}var Xi=t.identity(new Float32Array(16));function Hi(e,i,o,r,a,n){var s=t.getAnchorAlignment(e),l=-(s.horizontalAlign-.5)*i,c=-(s.verticalAlign-.5)*o,u=t.evaluateRadialOffset(e,r);return new t.Point((l/a+u[0])*n,(c/a+u[1])*n)}function Ki(e,i,o,r,a,n,s,l,c,u){var h=e.text.placedSymbolArray,p=e.text.dynamicLayoutVertexArray;p.clear();for(var d=0;d<h.length;d++){var _=h.get(d),f=e.allowVerticalPlacement&&!_.placedOrientation,m=_.hidden||!_.crossTileID||f?null:r[_.crossTileID];if(m){var g=new t.Point(_.anchorX,_.anchorY),v=Yt(g,o?l:s),y=.5+n.cameraToCenterDistance/v.signedDistanceFromCamera*.5,x=a.evaluateSizeForFeature(e.textSizeData,u,_)*y/t.ONE_EM;o&&(x*=e.tilePixelRatio/c);for(var b=m.width,w=m.height,E=m.radialOffset,T=m.textBoxScale,I=Hi(m.anchor,b,w,E,T,x),S=o?Yt(g.add(I),s).point:v.point.add(i?I.rotate(-n.angle):I),C=e.allowVerticalPlacement&&_.placedOrientation===t.WritingMode.vertical?Math.PI/2:0,P=0;P<_.numGlyphs;P++)t.addDynamicAttributes(p,S,C);}else ne(_.numGlyphs,p);}e.text.dynamicLayoutVertexBuffer.updateData(p);}function Ji(e){var i=e.text.placedSymbolArray,o=e.text.dynamicLayoutVertexArray;o.clear();for(var r=0;r<i.length;r++){var a=i.get(r);if(a.hidden||!a.placedOrientation)ne(a.numGlyphs,o);else for(var n=new t.Point(a.anchorX,a.anchorY),s=e.allowVerticalPlacement&&a.placedOrientation===t.WritingMode.vertical?Math.PI/2:0,l=0;l<a.numGlyphs;l++)t.addDynamicAttributes(o,n,s);}e.text.dynamicLayoutVertexBuffer.updateData(o);}function Yi(e,i,o,r,a,n,s,l,c,u,h,p,d){for(var _,f,m=e.context,g=m.gl,v=e.transform,y="map"===l,x="map"===c,b=y&&"point"!==o.layout.get("symbol-placement"),w=y&&!x&&!b,E=void 0!==o.layout.get("symbol-sort-key").constantOr(1),T=e.depthModeForSublayer(0,It.ReadOnly),I=o.layout.get("text-variable-anchor"),S=[],C=0,P=r;C<P.length;C+=1){var z=P[C],L=i.getTile(z),M=L.getBucket(o);if(M){var D=a?M.text:M.icon;if(D&&D.segments.get().length){var R=D.programConfigurations.get(o.id),A=a||M.sdfIcons,k=a?M.textSizeData:M.iconSizeData;_||(_=e.useProgram(A?"symbolSDF":"symbolIcon",R),f=t.evaluateSizeForZoom(k,v.zoom)),m.activeTexture.set(g.TEXTURE0);var B=void 0,O=void 0,F=void 0;if(a)O=L.glyphAtlasTexture,F=g.LINEAR,B=L.glyphAtlasTexture.size;else{var U=1!==o.layout.get("icon-size").constantOr(0)||M.iconsNeedLinear,N=x||0!==v.pitch;O=L.imageAtlasTexture,F=A||e.options.rotating||e.options.zooming||U||N?g.LINEAR:g.NEAREST,B=L.imageAtlasTexture.size;}var Z=ue(L,1,e.transform.zoom),q=Kt(z.posMatrix,x,y,e.transform,Z),j=Jt(z.posMatrix,x,y,e.transform,Z);if(b)$t(M,z.posMatrix,e,a,q,j,x,u);else if(a&&f&&I){var V=Math.pow(2,v.zoom-L.tileID.overscaledZ);Ki(M,y,x,d,t.symbolSize,v,q,z.posMatrix,V,f);}else a&&f&&M.allowVerticalPlacement&&Ji(M);var G=e.translatePosMatrix(z.posMatrix,L,n,s),W=b||a&&I?Xi:q,X=e.translatePosMatrix(j,L,n,s,!0),H=A&&0!==o.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),K={program:_,buffers:D,uniformValues:A?Ni(k.kind,f,w,x,e,G,W,X,a,B,!0):Ui(k.kind,f,w,x,e,G,W,X,a,B),atlasTexture:O,atlasInterpolation:F,isSDF:A,hasHalo:H};if(E)for(var J=0,Y=D.segments.get();J<Y.length;J+=1){var Q=Y[J];S.push({segments:new t.SegmentVector([Q]),sortKey:Q.sortKey,state:K});}else S.push({segments:D.segments,sortKey:0,state:K});}}}E&&S.sort((function(t,e){return t.sortKey-e.sortKey}));for(var $=0,tt=S;$<tt.length;$+=1){var et=tt[$],it=et.state;if(it.atlasTexture.bind(it.atlasInterpolation,g.CLAMP_TO_EDGE),it.isSDF){var ot=it.uniformValues;it.hasHalo&&(ot.u_is_halo=1,Qi(it.buffers,et.segments,o,e,it.program,T,h,p,ot)),ot.u_is_halo=0;}Qi(it.buffers,et.segments,o,e,it.program,T,h,p,it.uniformValues);}}function Qi(t,e,i,o,r,a,n,s,l){var c=o.context,u=c.gl;r.draw(c,u.TRIANGLES,a,n,s,Pt.disabled,l,i.id,t.layoutVertexBuffer,t.indexBuffer,e,i.paint,o.transform.zoom,t.programConfigurations.get(i.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer);}function $i(t,e,i,o,r,a,n){var s,l,c,u,h,p=t.context.gl,d=i.paint.get("fill-pattern"),_=d&&d.constantOr(1),f=i.getCrossfadeParameters();n?(l=_&&!i.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",s=p.LINES):(l=_?"fillPattern":"fill",s=p.TRIANGLES);for(var m=0,g=o;m<g.length;m+=1){var v=g[m],y=e.getTile(v);if(!_||y.patternsLoaded()){var x=y.getBucket(i);if(x){var b=x.programConfigurations.get(i.id),w=t.useProgram(l,b);_&&(t.context.activeTexture.set(p.TEXTURE0),y.imageAtlasTexture.bind(p.LINEAR,p.CLAMP_TO_EDGE),b.updatePatternPaintBuffers(f));var E=d.constantOr(null);if(E&&y.imageAtlas){var T=y.imageAtlas.patternPositions[E.to],I=y.imageAtlas.patternPositions[E.from];T&&I&&b.setConstantPatternPositions(T,I);}var S=t.translatePosMatrix(v.posMatrix,y,i.paint.get("fill-translate"),i.paint.get("fill-translate-anchor"));if(n){u=x.indexBuffer2,h=x.segments2;var C=[p.drawingBufferWidth,p.drawingBufferHeight];c="fillOutlinePattern"===l&&_?xi(S,t,f,y,C):yi(S,C);}else u=x.indexBuffer,h=x.segments,c=_?vi(S,t,f,y):gi(S);w.draw(t.context,s,r,t.stencilModeForClipping(v),a,Pt.disabled,c,i.id,x.layoutVertexBuffer,u,h,i.paint,t.transform.zoom,b);}}}}function to(t,e,i,o,r,a,n){for(var s=t.context,l=s.gl,c=i.paint.get("fill-extrusion-pattern"),u=c.constantOr(1),h=i.getCrossfadeParameters(),p=i.paint.get("fill-extrusion-opacity"),d=0,_=o;d<_.length;d+=1){var f=_[d],m=e.getTile(f),g=m.getBucket(i);if(g){var v=g.programConfigurations.get(i.id),y=t.useProgram(u?"fillExtrusionPattern":"fillExtrusion",v);u&&(t.context.activeTexture.set(l.TEXTURE0),m.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),v.updatePatternPaintBuffers(h));var x=c.constantOr(null);if(x&&m.imageAtlas){var b=m.imageAtlas.patternPositions[x.to],w=m.imageAtlas.patternPositions[x.from];b&&w&&v.setConstantPatternPositions(b,w);}var E=t.translatePosMatrix(f.posMatrix,m,i.paint.get("fill-extrusion-translate"),i.paint.get("fill-extrusion-translate-anchor")),T=i.paint.get("fill-extrusion-vertical-gradient"),I=u?mi(E,t,T,p,f,h,m):fi(E,t,T,p);y.draw(s,s.gl.TRIANGLES,r,a,n,Pt.backCCW,I,i.id,g.layoutVertexBuffer,g.indexBuffer,g.segments,i.paint,t.transform.zoom,v);}}}function eo(t,e,i,o,r,a){var n=t.context,s=n.gl,l=e.fbo;if(l){var c=t.useProgram("hillshade");n.activeTexture.set(s.TEXTURE0),s.bindTexture(s.TEXTURE_2D,l.colorAttachment.get());var u=Pi(t,e,i);e.maskedBoundsBuffer&&e.maskedIndexBuffer&&e.segments?c.draw(n,s.TRIANGLES,o,r,a,Pt.disabled,u,i.id,e.maskedBoundsBuffer,e.maskedIndexBuffer,e.segments):c.draw(n,s.TRIANGLES,o,r,a,Pt.disabled,u,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}}function io(e,i,o,r,a,n,s){var l=e.context,c=l.gl;if(i.dem&&i.dem.data){var u=i.dem.dim,h=i.dem.stride,p=i.dem.getPixels();if(l.activeTexture.set(c.TEXTURE1),l.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(h),i.demTexture){var d=i.demTexture;d.update(p,{premultiply:!1}),d.bind(c.NEAREST,c.CLAMP_TO_EDGE);}else i.demTexture=new t.Texture(l,p,c.RGBA,{premultiply:!1}),i.demTexture.bind(c.NEAREST,c.CLAMP_TO_EDGE);l.activeTexture.set(c.TEXTURE0);var _=i.fbo;if(!_){var f=new t.Texture(l,{width:u,height:u,data:null},c.RGBA);f.bind(c.LINEAR,c.CLAMP_TO_EDGE),(_=i.fbo=l.createFramebuffer(u,u)).colorAttachment.set(f.texture);}l.bindFramebuffer.set(_.framebuffer),l.viewport.set([0,0,u,u]),e.useProgram("hillshadePrepare").draw(l,c.TRIANGLES,a,n,s,Pt.disabled,zi(i,r),o.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments),i.needsHillshadePrepare=!1;}}function oo(e,i,o,r,a){var n=r.paint.get("raster-fade-duration");if(n>0){var s=t.browser.now(),l=(s-e.timeAdded)/n,c=i?(s-i.timeAdded)/n:-1,u=o.getSource(),h=a.coveringZoomLevel({tileSize:u.tileSize,roundZoom:u.roundZoom}),p=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(e.tileID.overscaledZ-h),d=p&&e.refreshedUponExpiration?1:t.clamp(p?l:1-c,0,1);return e.refreshedUponExpiration&&l>=1&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-d}:{opacity:d,mix:0}}return {opacity:1,mix:0}}function ro(e,i,o){var r=e.context,a=r.gl,n=o.posMatrix,s=e.useProgram("debug"),l=It.disabled,c=St.disabled,u=e.colorModeForRenderPass(),h="$debug";s.draw(r,a.LINE_STRIP,l,c,u,Pt.disabled,Ti(n,t.Color.red),h,e.debugBuffer,e.tileBorderIndexBuffer,e.debugSegments);for(var p=i.getTileByID(o.key).latestRawTileData,d=p&&p.byteLength||0,_=Math.floor(d/1024),f=i.getTile(o).tileSize,m=512/Math.min(f,512),g=function(t,e,i,o){o=o||1;var r,a,n,s,l,c,u,h,p=[];for(r=0,a=t.length;r<a;r++)if(l=ao[t[r]]){for(h=null,n=0,s=l[1].length;n<s;n+=2)-1===l[1][n]&&-1===l[1][n+1]?h=null:(c=e+l[1][n]*o,u=i-l[1][n+1]*o,h&&p.push(h.x,h.y,c,u),h={x:c,y:u});e+=l[0]*o;}return p}(o.toString()+" "+_+"kb",50,200*m,5*m),v=new t.StructArrayLayout2i4,y=new t.StructArrayLayout2ui4,x=0;x<g.length;x+=2)v.emplaceBack(g[x],g[x+1]),y.emplaceBack(x,x+1);for(var b=r.createVertexBuffer(v,Fe.members),w=r.createIndexBuffer(y),E=t.SegmentVector.simpleSegment(0,0,v.length/2,v.length/2),T=t.EXTENT/(Math.pow(2,e.transform.zoom-o.overscaledZ)*f*m),I=[],S=-1;S<=1;S++)for(var C=-1;C<=1&&(0!==S||0!==C);C++)I.push([S,C]);for(var P=0;P<I.length;P++){var z=I[P];s.draw(r,a.LINES,l,c,u,Pt.disabled,Ti(t.translate([],n,[T*z[0],T*z[1],0]),t.Color.white),h,b,w,E);}s.draw(r,a.LINES,l,c,u,Pt.disabled,Ti(n,t.Color.black),h,b,w,E);}var ao={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};var no={symbol:function(t,e,i,o,r){if("translucent"===t.renderPass){var a=St.disabled,n=t.colorModeForRenderPass();0!==i.paint.get("icon-opacity").constantOr(1)&&Yi(t,e,i,o,!1,i.paint.get("icon-translate"),i.paint.get("icon-translate-anchor"),i.layout.get("icon-rotation-alignment"),i.layout.get("icon-pitch-alignment"),i.layout.get("icon-keep-upright"),a,n,r),0!==i.paint.get("text-opacity").constantOr(1)&&Yi(t,e,i,o,!0,i.paint.get("text-translate"),i.paint.get("text-translate-anchor"),i.layout.get("text-rotation-alignment"),i.layout.get("text-pitch-alignment"),i.layout.get("text-keep-upright"),a,n,r),e.map.showCollisionBoxes&&function(t,e,i,o){Wi(t,e,i,o,!1),Wi(t,e,i,o,!0);}(t,e,i,o);}},circle:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("circle-opacity"),n=o.paint.get("circle-stroke-width"),s=o.paint.get("circle-stroke-opacity"),l=void 0!==o.layout.get("circle-sort-key").constantOr(1);if(0!==a.constantOr(1)||0!==n.constantOr(1)&&0!==s.constantOr(1)){for(var c=e.context,u=c.gl,h=e.depthModeForSublayer(0,It.ReadOnly),p=St.disabled,d=e.colorModeForRenderPass(),_=[],f=0;f<r.length;f++){var m=r[f],g=i.getTile(m),v=g.getBucket(o);if(v){var y=v.programConfigurations.get(o.id),x={programConfiguration:y,program:e.useProgram("circle",y),layoutVertexBuffer:v.layoutVertexBuffer,indexBuffer:v.indexBuffer,uniformValues:bi(e,m,g,o)};if(l)for(var b=0,w=v.segments.get();b<w.length;b+=1){var E=w[b];_.push({segments:new t.SegmentVector([E]),sortKey:E.sortKey,state:x});}else _.push({segments:v.segments,sortKey:0,state:x});}}l&&_.sort((function(t,e){return t.sortKey-e.sortKey}));for(var T=0,I=_;T<I.length;T+=1){var S=I[T],C=S.state,P=C.programConfiguration,z=C.program,L=C.layoutVertexBuffer,M=C.indexBuffer,D=C.uniformValues,R=S.segments;z.draw(c,u.TRIANGLES,h,p,d,Pt.disabled,D,o.id,L,M,R,o.paint,e.transform.zoom,P);}}}},heatmap:function(e,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var a=e.context,n=a.gl,s=e.depthModeForSublayer(0,It.ReadOnly),l=St.disabled,c=new Ct([n.ONE,n.ONE],t.Color.transparent,[!0,!0,!0,!0]);!function(t,e,i){var o=t.gl;t.activeTexture.set(o.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var r=i.heatmapFbo;if(r)o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),t.bindFramebuffer.set(r.framebuffer);else{var a=o.createTexture();o.bindTexture(o.TEXTURE_2D,a),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_S,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_T,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MIN_FILTER,o.LINEAR),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MAG_FILTER,o.LINEAR),r=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4),function t(e,i,o,r){var a=e.gl;a.texImage2D(a.TEXTURE_2D,0,a.RGBA,i.width/4,i.height/4,0,a.RGBA,e.extTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:a.UNSIGNED_BYTE,null);r.colorAttachment.set(o);e.extTextureHalfFloat&&a.checkFramebufferStatus(a.FRAMEBUFFER)!==a.FRAMEBUFFER_COMPLETE&&(e.extTextureHalfFloat=null,r.colorAttachment.setDirty(),t(e,i,o,r));}(t,e,a,r);}}(a,e,o),a.clear({color:t.Color.transparent});for(var u=0;u<r.length;u++){var h=r[u];if(!i.hasRenderableParent(h)){var p=i.getTile(h),d=p.getBucket(o);if(d){var _=d.programConfigurations.get(o.id),f=e.useProgram("heatmap",_),m=e.transform.zoom;f.draw(a,n.TRIANGLES,s,l,c,Pt.disabled,Si(h.posMatrix,p,m,o.paint.get("heatmap-intensity")),o.id,d.layoutVertexBuffer,d.indexBuffer,d.segments,o.paint,e.transform.zoom,_);}}}a.viewport.set([0,0,e.width,e.height]);}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),function(e,i){var o=e.context,r=o.gl,a=i.heatmapFbo;if(!a)return;o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);var n=i.colorRampTexture;n||(n=i.colorRampTexture=new t.Texture(o,i.colorRamp,r.RGBA));n.bind(r.LINEAR,r.CLAMP_TO_EDGE),e.useProgram("heatmapTexture").draw(o,r.TRIANGLES,It.disabled,St.disabled,e.colorModeForRenderPass(),Pt.disabled,Ci(e,i,0,1),i.id,e.viewportBuffer,e.quadTriangleIndexBuffer,e.viewportSegments,i.paint,e.transform.zoom);}(e,o));},line:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("line-opacity"),n=o.paint.get("line-width");if(0!==a.constantOr(1)&&0!==n.constantOr(1)){var s=e.depthModeForSublayer(0,It.ReadOnly),l=e.colorModeForRenderPass(),c=o.paint.get("line-dasharray"),u=o.paint.get("line-pattern"),h=u.constantOr(1),p=o.paint.get("line-gradient"),d=o.getCrossfadeParameters(),_=c?"lineSDF":h?"linePattern":p?"lineGradient":"line",f=e.context,m=f.gl,g=!0;if(p){f.activeTexture.set(m.TEXTURE0);var v=o.gradientTexture;if(!o.gradient)return;v||(v=o.gradientTexture=new t.Texture(f,o.gradient,m.RGBA)),v.bind(m.LINEAR,m.CLAMP_TO_EDGE);}for(var y=0,x=r;y<x.length;y+=1){var b=x[y],w=i.getTile(b);if(!h||w.patternsLoaded()){var E=w.getBucket(o);if(E){var T=E.programConfigurations.get(o.id),I=e.context.program.get(),S=e.useProgram(_,T),C=g||S.program!==I,P=u.constantOr(null);if(P&&w.imageAtlas){var z=w.imageAtlas.patternPositions[P.to],L=w.imageAtlas.patternPositions[P.from];z&&L&&T.setConstantPatternPositions(z,L);}var M=c?Ai(e,w,o,c,d):h?Ri(e,w,o,d):p?Di(e,w,o):Mi(e,w,o);c&&(C||e.lineAtlas.dirty)?(f.activeTexture.set(m.TEXTURE0),e.lineAtlas.bind(f)):h&&(f.activeTexture.set(m.TEXTURE0),w.imageAtlasTexture.bind(m.LINEAR,m.CLAMP_TO_EDGE),T.updatePatternPaintBuffers(d)),S.draw(f,m.TRIANGLES,s,e.stencilModeForClipping(b),l,Pt.disabled,M,o.id,E.layoutVertexBuffer,E.indexBuffer,E.segments,o.paint,e.transform.zoom,T),g=!1;}}}}}},fill:function(e,i,o,r){var a=o.paint.get("fill-color"),n=o.paint.get("fill-opacity");if(0!==n.constantOr(1)){var s=e.colorModeForRenderPass(),l=o.paint.get("fill-pattern"),c=e.opaquePassEnabledForLayer()&&!l.constantOr(1)&&1===a.constantOr(t.Color.transparent).a&&1===n.constantOr(0)?"opaque":"translucent";if(e.renderPass===c){var u=e.depthModeForSublayer(1,"opaque"===e.renderPass?It.ReadWrite:It.ReadOnly);$i(e,i,o,r,u,s,!1);}if("translucent"===e.renderPass&&o.paint.get("fill-antialias")){var h=e.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,It.ReadOnly);$i(e,i,o,r,h,s,!0);}}},"fill-extrusion":function(t,e,i,o){var r=i.paint.get("fill-extrusion-opacity");if(0!==r&&"translucent"===t.renderPass){var a=new It(t.context.gl.LEQUAL,It.ReadWrite,t.depthRangeFor3D);if(1!==r||i.paint.get("fill-extrusion-pattern").constantOr(1))to(t,e,i,o,a,St.disabled,Ct.disabled),to(t,e,i,o,a,t.stencilModeFor3D(),t.colorModeForRenderPass());else{var n=t.colorModeForRenderPass();to(t,e,i,o,a,St.disabled,n);}}},hillshade:function(t,e,i,o){if("offscreen"===t.renderPass||"translucent"===t.renderPass){for(var r=t.context,a=e.getSource().maxzoom,n=t.depthModeForSublayer(0,It.ReadOnly),s=St.disabled,l=t.colorModeForRenderPass(),c=0,u=o;c<u.length;c+=1){var h=u[c],p=e.getTile(h);p.needsHillshadePrepare&&"offscreen"===t.renderPass?io(t,p,i,a,n,s,l):"translucent"===t.renderPass&&eo(t,p,i,n,s,l);}r.viewport.set([0,0,t.width,t.height]);}},raster:function(t,e,i,o){if("translucent"===t.renderPass&&0!==i.paint.get("raster-opacity"))for(var r=t.context,a=r.gl,n=e.getSource(),s=t.useProgram("raster"),l=St.disabled,c=t.colorModeForRenderPass(),u=o.length&&o[0].overscaledZ,h=!t.options.moving,p=0,d=o;p<d.length;p+=1){var _=d[p],f=t.depthModeForSublayer(_.overscaledZ-u,1===i.paint.get("raster-opacity")?It.ReadWrite:It.ReadOnly,a.LESS),m=e.getTile(_),g=t.transform.calculatePosMatrix(_.toUnwrapped(),h);m.registerFadeDuration(i.paint.get("raster-fade-duration"));var v=e.findLoadedParent(_,0),y=oo(m,v,e,i,t.transform),x=void 0,b=void 0,w="nearest"===i.paint.get("raster-resampling")?a.NEAREST:a.LINEAR;r.activeTexture.set(a.TEXTURE0),m.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),r.activeTexture.set(a.TEXTURE1),v?(v.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),x=Math.pow(2,v.tileID.overscaledZ-m.tileID.overscaledZ),b=[m.tileID.canonical.x*x%1,m.tileID.canonical.y*x%1]):m.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST);var E=Oi(g,b||[0,0],x||1,y,i);n instanceof M?s.draw(r,a.TRIANGLES,f,l,c,Pt.disabled,E,i.id,n.boundsBuffer,t.quadTriangleIndexBuffer,n.boundsSegments):m.maskedBoundsBuffer&&m.maskedIndexBuffer&&m.segments?s.draw(r,a.TRIANGLES,f,l,c,Pt.disabled,E,i.id,m.maskedBoundsBuffer,m.maskedIndexBuffer,m.segments,i.paint,t.transform.zoom):s.draw(r,a.TRIANGLES,f,l,c,Pt.disabled,E,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}},background:function(t,e,i){var o=i.paint.get("background-color"),r=i.paint.get("background-opacity");if(0!==r){var a=t.context,n=a.gl,s=t.transform,l=s.tileSize,c=i.paint.get("background-pattern");if(!t.isPatternMissing(c)){var u=!c&&1===o.a&&1===r&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass===u){var h=St.disabled,p=t.depthModeForSublayer(0,"opaque"===u?It.ReadWrite:It.ReadOnly),d=t.colorModeForRenderPass(),_=t.useProgram(c?"backgroundPattern":"background"),f=s.coveringTiles({tileSize:l});c&&(a.activeTexture.set(n.TEXTURE0),t.imageManager.bind(t.context));for(var m=i.getCrossfadeParameters(),g=0,v=f;g<v.length;g+=1){var y=v[g],x=t.transform.calculatePosMatrix(y.toUnwrapped()),b=c?qi(x,r,t,c,{tileID:y,tileSize:l},m):Zi(x,r,o);_.draw(a,n.TRIANGLES,p,h,d,Pt.disabled,b,i.id,t.tileExtentBuffer,t.quadTriangleIndexBuffer,t.tileExtentSegments);}}}}},debug:function(t,e,i){for(var o=0;o<i.length;o++)ro(t,e,i[o]);},custom:function(t,e,i){var o=t.context,r=i.implementation;if("offscreen"===t.renderPass){var a=r.prerender;a&&(t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),a.call(r,o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState());}else if("translucent"===t.renderPass){t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),o.setStencilMode(St.disabled);var n="3d"===r.renderingMode?new It(t.context.gl.LEQUAL,It.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,It.ReadOnly);o.setDepthMode(n),r.render(o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState(),o.bindFramebuffer.set(null);}}},so=function(e,i){this.context=new zt(e),this.transform=i,this._tileTextures={},this.setup(),this.numSublayers=Lt.maxUnderzooming+Lt.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.depthRboNeedsClear=!0,this.emptyProgramConfiguration=new t.ProgramConfiguration,this.crossTileSymbolIndex=new Re;};function lo(t,e){if(t.y>e.y){var i=t;t=e,e=i;}return {x0:t.x,y0:t.y,x1:e.x,y1:e.y,dx:e.x-t.x,dy:e.y-t.y}}function co(t,e,i,o,r){var a=Math.max(i,Math.floor(e.y0)),n=Math.min(o,Math.ceil(e.y1));if(t.x0===e.x0&&t.y0===e.y0?t.x0+e.dy/t.dy*t.dx<e.x1:t.x1-e.dy/t.dy*t.dx<e.x0){var s=t;t=e,e=s;}for(var l=t.dx/t.dy,c=e.dx/e.dy,u=t.dx>0,h=e.dx<0,p=a;p<n;p++){var d=l*Math.max(0,Math.min(t.dy,p+u-t.y0))+t.x0,_=c*Math.max(0,Math.min(e.dy,p+h-e.y0))+e.x0;r(Math.floor(_),Math.ceil(d),p);}}function uo(t,e,i,o,r,a){var n,s=lo(t,e),l=lo(e,i),c=lo(i,t);s.dy>l.dy&&(n=s,s=l,l=n),s.dy>c.dy&&(n=s,s=c,c=n),l.dy>c.dy&&(n=l,l=c,c=n),s.dy&&co(c,s,o,r,a),l.dy&&co(c,l,o,r,a);}so.prototype.resize=function(e,i){var o=this.context.gl;if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var r=0,a=this.style._order;r<a.length;r+=1){var n=a[r];this.style._layers[n].resize();}this.depthRbo&&(o.deleteRenderbuffer(this.depthRbo),this.depthRbo=null);},so.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,Fe.members),this.tileExtentSegments=t.SegmentVector.simpleSegment(0,0,4,2);var o=new t.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(t.EXTENT,0),o.emplaceBack(0,t.EXTENT),o.emplaceBack(t.EXTENT,t.EXTENT),this.debugBuffer=e.createVertexBuffer(o,Fe.members),this.debugSegments=t.SegmentVector.simpleSegment(0,0,4,5);var r=new t.StructArrayLayout4i8;r.emplaceBack(0,0,0,0),r.emplaceBack(t.EXTENT,0,t.EXTENT,0),r.emplaceBack(0,t.EXTENT,0,t.EXTENT),r.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(r,t.rasterBoundsAttributes.members),this.rasterBoundsSegments=t.SegmentVector.simpleSegment(0,0,4,2);var a=new t.StructArrayLayout2i4;a.emplaceBack(0,0),a.emplaceBack(1,0),a.emplaceBack(0,1),a.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(a,Fe.members),this.viewportSegments=t.SegmentVector.simpleSegment(0,0,4,2);var n=new t.StructArrayLayout1ui2;n.emplaceBack(0),n.emplaceBack(1),n.emplaceBack(3),n.emplaceBack(2),n.emplaceBack(0),this.tileBorderIndexBuffer=e.createIndexBuffer(n);var s=new t.StructArrayLayout3ui6;s.emplaceBack(0,1,2),s.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=e.createIndexBuffer(s);var l=this.context.gl;this.stencilClearMode=new St({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO);},so.prototype.clearStencil=function(){var e=this.context,i=e.gl;this.nextStencilID=1,this.currentStencilSource=void 0;var o=t.create();t.ortho(o,0,this.width,this.height,0,0,1),t.scale(o,o,[i.drawingBufferWidth,i.drawingBufferHeight,0]),this.useProgram("clippingMask").draw(e,i.TRIANGLES,It.disabled,this.stencilClearMode,Ct.disabled,Pt.disabled,Ii(o),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);},so.prototype._renderTileClippingMasks=function(t,e){if(this.currentStencilSource!==t.source&&t.isTileClipped()&&e&&e.length){this.currentStencilSource=t.source;var i=this.context,o=i.gl;this.nextStencilID+e.length>256&&this.clearStencil(),i.setColorMode(Ct.disabled),i.setDepthMode(It.disabled);var r=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(var a=0,n=e;a<n.length;a+=1){var s=n[a],l=this._tileClippingMaskIDs[s.key]=this.nextStencilID++;r.draw(i,o.TRIANGLES,It.disabled,new St({func:o.ALWAYS,mask:0},l,255,o.KEEP,o.KEEP,o.REPLACE),Ct.disabled,Pt.disabled,Ii(s.posMatrix),"$clipping",this.tileExtentBuffer,this.quadTriangleIndexBuffer,this.tileExtentSegments);}}},so.prototype.stencilModeFor3D=function(){this.currentStencilSource=void 0,this.nextStencilID+1>256&&this.clearStencil();var t=this.nextStencilID++,e=this.context.gl;return new St({func:e.NOTEQUAL,mask:255},t,255,e.KEEP,e.KEEP,e.REPLACE)},so.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new St({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},so.prototype.colorModeForRenderPass=function(){var e=this.context.gl;if(this._showOverdrawInspector){return new Ct([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?Ct.unblended:Ct.alphaBlended},so.prototype.depthModeForSublayer=function(t,e,i){if(!this.opaquePassEnabledForLayer())return It.disabled;var o=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new It(i||this.context.gl.LEQUAL,e,[o,o])},so.prototype.opaquePassEnabledForLayer=function(){return this.currentLayer<this.opaquePassCutoff},so.prototype.render=function(e,i){this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now()),this.imageManager.beginFrame();var o=this.style._order,r=this.style.sourceCaches;for(var a in r){var n=r[a];n.used&&n.prepare(this.context);}var s={},l={},c={};for(var u in r){var h=r[u];s[u]=h.getVisibleCoordinates(),l[u]=s[u].slice().reverse(),c[u]=h.getVisibleCoordinates(!0).reverse();}for(var p in r){var d=r[p],_=d.getSource();if("raster"===_.type||"raster-dem"===_.type){for(var f=[],m=0,g=s[p];m<g.length;m+=1){var v=g[m];f.push(d.getTile(v));}Vi(f,this.context);}}this.opaquePassCutoff=1/0;for(var y=0;y<o.length;y++){var x=o[y];if(this.style._layers[x].is3D()){this.opaquePassCutoff=y;break}}this.renderPass="offscreen",this.depthRboNeedsClear=!0;for(var b=0,w=o;b<w.length;b+=1){var E=w[b],T=this.style._layers[E];if(T.hasOffscreenPass()&&!T.isHidden(this.transform.zoom)){var I=l[T.source];("custom"===T.type||I.length)&&this.renderLayer(this,r[T.source],T,I);}}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRangeFor3D=[0,1-(e._order.length+2)*this.numSublayers*this.depthEpsilon],this.renderPass="opaque",this.currentLayer=o.length-1;this.currentLayer>=0;this.currentLayer--){var S=this.style._layers[o[this.currentLayer]],C=r[S.source],P=s[S.source];this._renderTileClippingMasks(S,P),this.renderLayer(this,C,S,P);}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<o.length;this.currentLayer++){var z=this.style._layers[o[this.currentLayer]],L=r[z.source],M=("symbol"===z.type?c:l)[z.source];this._renderTileClippingMasks(z,s[z.source]),this.renderLayer(this,L,z,M);}if(this.options.showTileBoundaries)for(var D in r){no.debug(this,r[D],s[D]);break}this.context.setDefault();},so.prototype.setupOffscreenDepthRenderbuffer=function(){var t=this.context;this.depthRbo||(this.depthRbo=t.createRenderbuffer(t.gl.DEPTH_COMPONENT16,this.width,this.height));},so.prototype.renderLayer=function(t,e,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"custom"===i.type||o.length)&&(this.id=i.id,no[i.type](t,e,i,o,this.style.placement.variableOffsets));},so.prototype.translatePosMatrix=function(e,i,o,r,a){if(!o[0]&&!o[1])return e;var n=a?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(n){var s=Math.sin(n),l=Math.cos(n);o=[o[0]*l-o[1]*s,o[0]*s+o[1]*l];}var c=[a?o[0]:ue(i,o[0],this.transform.zoom),a?o[1]:ue(i,o[1],this.transform.zoom),0],u=new Float32Array(16);return t.translate(u,e,c),u},so.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t];},so.prototype.getTileTexture=function(t){var e=this._tileTextures[t];return e&&e.length>0?e.pop():null},so.prototype.isPatternMissing=function(t){if(!t)return !1;var e=this.imageManager.getPattern(t.from),i=this.imageManager.getPattern(t.to);return !e||!i},so.prototype.useProgram=function(t,e){void 0===e&&(e=this.emptyProgramConfiguration),this.cache=this.cache||{};var i=""+t+(e.cacheKey||"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new di(this.context,hi[t],e,ji[t],this._showOverdrawInspector)),this.cache[i]},so.prototype.setCustomLayerDefaults=function(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();},so.prototype.setBaseState=function(){var t=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(t.FUNC_ADD);};var ho=function(e,i,o){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===o||o,this._minZoom=e||0,this._maxZoom=i||22,this.setMaxBounds(),this.width=0,this.height=0,this._center=new t.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._posMatrixCache={},this._alignedPosMatrixCache={};},po={minZoom:{configurable:!0},maxZoom:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerPoint:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},unmodified:{configurable:!0},point:{configurable:!0}};ho.prototype.clone=function(){var t=new ho(this._minZoom,this._maxZoom,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._calcMatrices(),t},po.minZoom.get=function(){return this._minZoom},po.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t));},po.maxZoom.get=function(){return this._maxZoom},po.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t));},po.renderWorldCopies.get=function(){return this._renderWorldCopies},po.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t;},po.worldSize.get=function(){return this.tileSize*this.scale},po.centerPoint.get=function(){return this.size._div(2)},po.size.get=function(){return new t.Point(this.width,this.height)},po.bearing.get=function(){return -this.angle/Math.PI*180},po.bearing.set=function(e){var i=-t.wrap(e,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=t.create$2(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle));},po.pitch.get=function(){return this._pitch/Math.PI*180},po.pitch.set=function(e){var i=t.clamp(e,0,60)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());},po.fov.get=function(){return this._fov/Math.PI*180},po.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices());},po.zoom.get=function(){return this._zoom},po.zoom.set=function(t){var e=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==e&&(this._unmodified=!1,this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom,this._constrain(),this._calcMatrices());},po.center.get=function(){return this._center},po.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices());},ho.prototype.coveringZoomLevel=function(t){return (t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize))},ho.prototype.getVisibleUnwrappedCoordinates=function(e){var i=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var o=this.pointCoordinate(new t.Point(0,0)),r=this.pointCoordinate(new t.Point(this.width,0)),a=this.pointCoordinate(new t.Point(this.width,this.height)),n=this.pointCoordinate(new t.Point(0,this.height)),s=Math.floor(Math.min(o.x,r.x,a.x,n.x)),l=Math.floor(Math.max(o.x,r.x,a.x,n.x)),c=s-1;c<=l+1;c++)0!==c&&i.push(new t.UnwrappedTileID(c,e));return i},ho.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),o=i;if(void 0!==e.minzoom&&i<e.minzoom)return [];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var r=t.MercatorCoordinate.fromLngLat(this.center),a=Math.pow(2,i),n=new t.Point(a*r.x-.5,a*r.y-.5);return function(e,i,o,r){void 0===r&&(r=!0);var a=1<<e,n={};function s(i,s,l){var c,u,h,p;if(l>=0&&l<=a)for(c=i;c<s;c++)u=Math.floor(c/a),h=(c%a+a)%a,0!==u&&!0!==r||(p=new t.OverscaledTileID(o,u,e,h,l),n[p.key]=p);}var l=i.map((function(e){return new t.Point(e.x,e.y)._mult(a)}));return uo(l[0],l[1],l[2],0,a,s),uo(l[2],l[3],l[0],0,a,s),Object.keys(n).map((function(t){return n[t]}))}(i,[this.pointCoordinate(new t.Point(0,0)),this.pointCoordinate(new t.Point(this.width,0)),this.pointCoordinate(new t.Point(this.width,this.height)),this.pointCoordinate(new t.Point(0,this.height))],e.reparseOverscaled?o:i,this._renderWorldCopies).sort((function(t,e){return n.dist(t.canonical)-n.dist(e.canonical)}))},ho.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices();},po.unmodified.get=function(){return this._unmodified},ho.prototype.zoomScale=function(t){return Math.pow(2,t)},ho.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},ho.prototype.project=function(e){var i=t.clamp(e.lat,-this.maxValidLatitude,this.maxValidLatitude);return new t.Point(t.mercatorXfromLng(e.lng)*this.worldSize,t.mercatorYfromLat(i)*this.worldSize)},ho.prototype.unproject=function(e){return new t.MercatorCoordinate(e.x/this.worldSize,e.y/this.worldSize).toLngLat()},po.point.get=function(){return this.project(this.center)},ho.prototype.setLocationAtPoint=function(e,i){var o=this.pointCoordinate(i),r=this.pointCoordinate(this.centerPoint),a=this.locationCoordinate(e),n=new t.MercatorCoordinate(a.x-(o.x-r.x),a.y-(o.y-r.y));this.center=this.coordinateLocation(n),this._renderWorldCopies&&(this.center=this.center.wrap());},ho.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},ho.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},ho.prototype.locationCoordinate=function(e){return t.MercatorCoordinate.fromLngLat(e)},ho.prototype.coordinateLocation=function(t){return t.toLngLat()},ho.prototype.pointCoordinate=function(e){var i=[e.x,e.y,0,1],o=[e.x,e.y,1,1];t.transformMat4(i,i,this.pixelMatrixInverse),t.transformMat4(o,o,this.pixelMatrixInverse);var r=i[3],a=o[3],n=i[0]/r,s=o[0]/a,l=i[1]/r,c=o[1]/a,u=i[2]/r,h=o[2]/a,p=u===h?0:(0-u)/(h-u);return new t.MercatorCoordinate(t.number(n,s,p)/this.worldSize,t.number(l,c,p)/this.worldSize)},ho.prototype.coordinatePoint=function(e){var i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix),new t.Point(i[0]/i[3],i[1]/i[3])},ho.prototype.getBounds=function(){return (new t.LngLatBounds).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},ho.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new t.LngLatBounds([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},ho.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude]);},ho.prototype.calculatePosMatrix=function(e,i){void 0===i&&(i=!1);var o=e.key,r=i?this._alignedPosMatrixCache:this._posMatrixCache;if(r[o])return r[o];var a=e.canonical,n=this.worldSize/this.zoomScale(a.z),s=a.x+Math.pow(2,a.z)*e.wrap,l=t.identity(new Float64Array(16));return t.translate(l,l,[s*n,a.y*n,0]),t.scale(l,l,[n/t.EXTENT,n/t.EXTENT,1]),t.multiply(l,i?this.alignedProjMatrix:this.projMatrix,l),r[o]=new Float32Array(l),r[o]},ho.prototype.customLayerMatrix=function(){return this.mercatorMatrix.slice()},ho.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,o,r,a=-90,n=90,s=-180,l=180,c=this.size,u=this._unmodified;if(this.latRange){var h=this.latRange;a=t.mercatorYfromLat(h[1])*this.worldSize,e=(n=t.mercatorYfromLat(h[0])*this.worldSize)-a<c.y?c.y/(n-a):0;}if(this.lngRange){var p=this.lngRange;s=t.mercatorXfromLng(p[0])*this.worldSize,i=(l=t.mercatorXfromLng(p[1])*this.worldSize)-s<c.x?c.x/(l-s):0;}var d=this.point,_=Math.max(i||0,e||0);if(_)return this.center=this.unproject(new t.Point(i?(l+s)/2:d.x,e?(n+a)/2:d.y)),this.zoom+=this.scaleZoom(_),this._unmodified=u,void(this._constraining=!1);if(this.latRange){var f=d.y,m=c.y/2;f-m<a&&(r=a+m),f+m>n&&(r=n-m);}if(this.lngRange){var g=d.x,v=c.x/2;g-v<s&&(o=s+v),g+v>l&&(o=l-v);}void 0===o&&void 0===r||(this.center=this.unproject(new t.Point(void 0!==o?o:d.x,void 0!==r?r:d.y))),this._unmodified=u,this._constraining=!1;}},ho.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var e=this._fov/2,i=Math.PI/2+this._pitch,o=Math.sin(e)*this.cameraToCenterDistance/Math.sin(Math.PI-i-e),r=this.point,a=r.x,n=r.y,s=1.01*(Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance),l=this.height/50,c=new Float64Array(16);t.perspective(c,this._fov,this.width/this.height,l,s),t.scale(c,c,[1,-1,1]),t.translate(c,c,[0,0,-this.cameraToCenterDistance]),t.rotateX(c,c,this._pitch),t.rotateZ(c,c,this.angle),t.translate(c,c,[-a,-n,0]),this.mercatorMatrix=t.scale([],c,[this.worldSize,this.worldSize,this.worldSize]),t.scale(c,c,[1,1,t.mercatorZfromAltitude(1,this.center.lat)*this.worldSize,1]),this.projMatrix=c;var u=this.width%2/2,h=this.height%2/2,p=Math.cos(this.angle),d=Math.sin(this.angle),_=a-Math.round(a)+p*u+d*h,f=n-Math.round(n)+p*h+d*u,m=new Float64Array(c);if(t.translate(m,m,[_>.5?_-1:_,f>.5?f-1:f,0]),this.alignedProjMatrix=m,c=t.create(),t.scale(c,c,[this.width/2,-this.height/2,1]),t.translate(c,c,[1,-1,0]),this.labelPlaneMatrix=c,c=t.create(),t.scale(c,c,[1,-1,1]),t.translate(c,c,[-1,-1,0]),t.scale(c,c,[2/this.width,2/this.height,1]),this.glCoordMatrix=c,this.pixelMatrix=t.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),!(c=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=c,this._posMatrixCache={},this._alignedPosMatrixCache={};}},ho.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=this.pointCoordinate(new t.Point(0,0)),i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix)[3]/this.cameraToCenterDistance},ho.prototype.getCameraPoint=function(){var e=this._pitch,i=Math.tan(e)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new t.Point(0,i))},ho.prototype.getCameraQueryGeometry=function(e){var i=this.getCameraPoint();if(1===e.length)return [e[0],i];for(var o=i.x,r=i.y,a=i.x,n=i.y,s=0,l=e;s<l.length;s+=1){var c=l[s];o=Math.min(o,c.x),r=Math.min(r,c.y),a=Math.max(a,c.x),n=Math.max(n,c.y);}return [new t.Point(o,r),new t.Point(a,r),new t.Point(a,n),new t.Point(o,n),new t.Point(o,r)]},Object.defineProperties(ho.prototype,po);var _o=function(){var e,i,o,r,a;t.bindAll(["_onHashChange","_updateHash"],this),this._updateHash=(e=this._updateHashUnthrottled.bind(this),i=300,o=!1,r=null,a=function(){r=null,o&&(e(),r=setTimeout(a,i),o=!1);},function(){return o=!0,r||a(),r});};_o.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},_o.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},_o.prototype.getHashString=function(t){var e=this._map.getCenter(),i=Math.round(100*this._map.getZoom())/100,o=Math.ceil((i*Math.LN2+Math.log(512/360/.5))/Math.LN10),r=Math.pow(10,o),a=Math.round(e.lng*r)/r,n=Math.round(e.lat*r)/r,s=this._map.getBearing(),l=this._map.getPitch(),c="";return c+=t?"#/"+a+"/"+n+"/"+i:"#"+i+"/"+n+"/"+a,(s||l)&&(c+="/"+Math.round(10*s)/10),l&&(c+="/"+Math.round(l)),c},_o.prototype._onHashChange=function(){var e=t.window.location.hash.replace("#","").split("/");return e.length>=3&&(this._map.jumpTo({center:[+e[2],+e[1]],zoom:+e[0],bearing:+(e[3]||0),pitch:+(e[4]||0)}),!0)},_o.prototype._updateHashUnthrottled=function(){var e=this.getHashString();try{t.window.history.replaceState(t.window.history.state,"",e);}catch(t){}};var fo=function(e){function o(o,r,a,n){void 0===n&&(n={});var s=i.mousePos(r.getCanvasContainer(),a),l=r.unproject(s);e.call(this,o,t.extend({point:s,lngLat:l,originalEvent:a},n)),this._defaultPrevented=!1,this.target=r;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),mo=function(e){function o(o,r,a){var n=i.touchPos(r.getCanvasContainer(),a),s=n.map((function(t){return r.unproject(t)})),l=n.reduce((function(t,e,i,o){return t.add(e.div(o.length))}),new t.Point(0,0)),c=r.unproject(l);e.call(this,o,{points:n,point:l,lngLats:s,lngLat:c,originalEvent:a}),this._defaultPrevented=!1;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),go=function(t){function e(e,i,o){t.call(this,e,{originalEvent:o}),this._defaultPrevented=!1;}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var i={defaultPrevented:{configurable:!0}};return e.prototype.preventDefault=function(){this._defaultPrevented=!0;},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event),vo=function(e){this._map=e,this._el=e.getCanvasContainer(),this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=1/450,t.bindAll(["_onWheel","_onTimeout","_onScrollFrame","_onScrollFinished"],this);};vo.prototype.setZoomRate=function(t){this._defaultZoomRate=t;},vo.prototype.setWheelZoomRate=function(t){this._wheelZoomRate=t;},vo.prototype.isEnabled=function(){return !!this._enabled},vo.prototype.isActive=function(){return !!this._active},vo.prototype.isZooming=function(){return !!this._zooming},vo.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around);},vo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},vo.prototype.onWheel=function(e){if(this.isEnabled()){var i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,o=t.browser.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%4.000244140625==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this.isActive()||this._start(e)),e.preventDefault();}},vo.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this.isActive()||this._start(t);},vo.prototype._start=function(e){if(this._delta){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0,this._map.fire(new t.Event("movestart",{originalEvent:e})),this._map.fire(new t.Event("zoomstart",{originalEvent:e}))),this._finishTimeout&&clearTimeout(this._finishTimeout);var o=i.mousePos(this._el,e);this._around=t.LngLat.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(o)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame));}},vo.prototype._onScrollFrame=function(){var e=this;if(this._frameId=null,this.isActive()){var i=this._map.transform;if(0!==this._delta){var o="wheel"===this._type&&Math.abs(this._delta)>4.000244140625?this._wheelZoomRate:this._defaultZoomRate,r=2/(1+Math.exp(-Math.abs(this._delta*o)));this._delta<0&&0!==r&&(r=1/r);var a="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale;this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(a*r))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0;}var n="number"==typeof this._targetZoom?this._targetZoom:i.zoom,s=this._startZoom,l=this._easing,c=!1;if("wheel"===this._type&&s&&l){var u=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1),h=l(u);i.zoom=t.number(s,n,h),u<1?this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame)):c=!0;}else i.zoom=n,c=!0;i.setLocationAtPoint(this._around,this._aroundPoint),this._map.fire(new t.Event("move",{originalEvent:this._lastWheelEvent})),this._map.fire(new t.Event("zoom",{originalEvent:this._lastWheelEvent})),c&&(this._active=!1,this._finishTimeout=setTimeout((function(){e._zooming=!1,e._map.fire(new t.Event("zoomend",{originalEvent:e._lastWheelEvent})),e._map.fire(new t.Event("moveend",{originalEvent:e._lastWheelEvent})),delete e._targetZoom;}),200));}},vo.prototype._smoothOutEasing=function(e){var i=t.ease;if(this._prevEase){var o=this._prevEase,r=(t.browser.now()-o.start)/o.duration,a=o.easing(r+.01)-o.easing(r),n=.27/Math.sqrt(a*a+1e-4)*.01,s=Math.sqrt(.0729-n*n);i=t.bezier(n,s,.25,1);}return this._prevEase={start:t.browser.now(),duration:e,easing:i},i};var yo=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMouseMove","_onMouseUp","_onKeyDown"],this);};yo.prototype.isEnabled=function(){return !!this._enabled},yo.prototype.isActive=function(){return !!this._active},yo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},yo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},yo.prototype.onMouseDown=function(e){this.isEnabled()&&e.shiftKey&&0===e.button&&(t.window.document.addEventListener("mousemove",this._onMouseMove,!1),t.window.document.addEventListener("keydown",this._onKeyDown,!1),t.window.document.addEventListener("mouseup",this._onMouseUp,!1),i.disableDrag(),this._startPos=this._lastPos=i.mousePos(this._el,e),this._active=!0);},yo.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);if(!(this._lastPos.equals(e)||!this._box&&e.dist(this._startPos)<this._clickTolerance)){var o=this._startPos;this._lastPos=e,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t));var r=Math.min(o.x,e.x),a=Math.max(o.x,e.x),n=Math.min(o.y,e.y),s=Math.max(o.y,e.y);i.setTransform(this._box,"translate("+r+"px,"+n+"px)"),this._box.style.width=a-r+"px",this._box.style.height=s-n+"px";}},yo.prototype._onMouseUp=function(e){if(0===e.button){var o=this._startPos,r=i.mousePos(this._el,e);this._finish(),i.suppressClick(),o.x===r.x&&o.y===r.y?this._fireEvent("boxzoomcancel",e):this._map.fitScreenCoordinates(o,r,this._map.getBearing(),{linear:!0}).fire(new t.Event("boxzoomend",{originalEvent:e}));}},yo.prototype._onKeyDown=function(t){27===t.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",t));},yo.prototype._finish=function(){this._active=!1,t.window.document.removeEventListener("mousemove",this._onMouseMove,!1),t.window.document.removeEventListener("keydown",this._onKeyDown,!1),t.window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos;},yo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))};var xo=t.bezier(0,0,.25,1),bo=function(e,i){this._map=e,this._el=i.element||e.getCanvasContainer(),this._state="disabled",this._button=i.button||"right",this._bearingSnap=i.bearingSnap||0,this._pitchWithRotate=!1!==i.pitchWithRotate,t.bindAll(["onMouseDown","_onMouseMove","_onMouseUp","_onBlur","_onDragFrame"],this);};bo.prototype.isEnabled=function(){return "disabled"!==this._state},bo.prototype.isActive=function(){return "active"===this._state},bo.prototype.enable=function(){this.isEnabled()||(this._state="enabled");},bo.prototype.disable=function(){if(this.isEnabled())switch(this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend"),this._pitchWithRotate&&this._fireEvent("pitchend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},bo.prototype.onMouseDown=function(e){if("enabled"===this._state){var o="touchstart"===e.type;if(o)this._startTime=Date.now();else if("right"===this._button){if(this._eventButton=i.mouseButton(e),this._eventButton!==(e.ctrlKey?0:2))return}else{if(e.ctrlKey||0!==i.mouseButton(e))return;this._eventButton=0;}i.disableDrag(),o?(t.window.document.addEventListener("touchmove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("touchend",this._onMouseUp)):(t.window.document.addEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("mouseup",this._onMouseUp)),t.window.addEventListener("blur",this._onBlur),this._state="pending",this._inertia=[[t.browser.now(),this._map.getBearing()]],this._startPos=this._prevPos=this._lastPos=i.mousePos(this._el,e),this._center=this._map.transform.centerPoint,e.preventDefault();}},bo.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);this._lastPos.equals(e)||(this._lastMoveEvent=t,this._lastPos=e,"pending"===this._state&&(this._state="active",this._fireEvent("rotatestart",t),this._fireEvent("movestart",t),this._pitchWithRotate&&this._fireEvent("pitchstart",t)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},bo.prototype._onDragFrame=function(){this._frameId=null;var e=this._lastMoveEvent;if(e){var i=this._map.transform,o=this._prevPos,r=this._lastPos,a=.8*(o.x-r.x),n=-.5*(o.y-r.y),s=i.bearing-a,l=i.pitch-n,c=this._inertia,u=c[c.length-1];this._drainInertiaBuffer(),c.push([t.browser.now(),this._map._normalizeBearing(s,u[1])]),i.bearing=s,this._pitchWithRotate&&(this._fireEvent("pitch",e),i.pitch=l),this._fireEvent("rotate",e),this._fireEvent("move",e),delete this._lastMoveEvent,this._prevPos=this._lastPos;}},bo.prototype._onMouseUp=function(t){if("touchend"===t.type&&this._startPos===this._lastPos&&Date.now()-this._startTime<300&&this._el.click(),i.mouseButton(t)===this._eventButton)switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialRotate(t);break;case"pending":this._state="enabled",this._unbind();}},bo.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend",t),this._pitchWithRotate&&this._fireEvent("pitchend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},bo.prototype._unbind=function(){t.window.document.removeEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("mouseup",this._onMouseUp),t.window.document.removeEventListener("touchmove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("touchend",this._onMouseUp),t.window.removeEventListener("blur",this._onBlur),i.enableDrag();},bo.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._prevPos,delete this._lastPos;},bo.prototype._inertialRotate=function(t){var e=this;this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,o=i.getBearing(),r=this._inertia,a=function(){Math.abs(o)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):e._fireEvent("moveend",t),e._pitchWithRotate&&e._fireEvent("pitchend",t);};if(r.length<2)a();else{var n=r[0],s=r[r.length-1],l=r[r.length-2],c=i._normalizeBearing(o,l[1]),u=s[1]-n[1],h=u<0?-1:1,p=(s[0]-n[0])/1e3;if(0!==u&&0!==p){var d=Math.abs(u*(.25/p));d>180&&(d=180);var _=d/180;c+=h*d*(_/2),Math.abs(i._normalizeBearing(c,0))<this._bearingSnap&&(c=i._normalizeBearing(0,c)),i.rotateTo(c,{duration:1e3*_,easing:xo,noMoveStart:!0},{originalEvent:t});}else a();}},bo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},bo.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var wo=t.bezier(0,0,.3,1),Eo=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._state="disabled",this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMove","_onMouseUp","_onTouchEnd","_onBlur","_onDragFrame"],this);};Eo.prototype.isEnabled=function(){return "disabled"!==this._state},Eo.prototype.isActive=function(){return "active"===this._state},Eo.prototype.enable=function(){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-drag-pan"),this._state="enabled");},Eo.prototype.disable=function(){if(this.isEnabled())switch(this._el.classList.remove("mapboxgl-touch-drag-pan"),this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("dragend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},Eo.prototype.onMouseDown=function(e){"enabled"===this._state&&(e.ctrlKey||0!==i.mouseButton(e)||(i.addEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.addEventListener(t.window.document,"mouseup",this._onMouseUp),this._start(e)));},Eo.prototype.onTouchStart=function(e){"enabled"===this._state&&(e.touches.length>1||(i.addEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.addEventListener(t.window.document,"touchend",this._onTouchEnd),this._start(e)));},Eo.prototype._start=function(e){t.window.addEventListener("blur",this._onBlur),this._state="pending",this._startPos=this._mouseDownPos=this._prevPos=this._lastPos=i.mousePos(this._el,e),this._inertia=[[t.browser.now(),this._startPos]];},Eo.prototype._onMove=function(e){e.preventDefault();var o=i.mousePos(this._el,e);this._lastPos.equals(o)||"pending"===this._state&&o.dist(this._mouseDownPos)<this._clickTolerance||(this._lastMoveEvent=e,this._lastPos=o,this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),this._lastPos]),"pending"===this._state&&(this._state="active",this._fireEvent("dragstart",e),this._fireEvent("movestart",e)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},Eo.prototype._onDragFrame=function(){this._frameId=null;var t=this._lastMoveEvent;if(t){var e=this._map.transform;e.setLocationAtPoint(e.pointLocation(this._prevPos),this._lastPos),this._fireEvent("drag",t),this._fireEvent("move",t),this._prevPos=this._lastPos,delete this._lastMoveEvent;}},Eo.prototype._onMouseUp=function(t){if(0===i.mouseButton(t))switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},Eo.prototype._onTouchEnd=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},Eo.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("dragend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},Eo.prototype._unbind=function(){i.removeEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onTouchEnd),i.removeEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.removeEventListener(t.window.document,"mouseup",this._onMouseUp),i.removeEventListener(t.window,"blur",this._onBlur);},Eo.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._prevPos,delete this._mouseDownPos,delete this._lastPos;},Eo.prototype._inertialPan=function(t){this._fireEvent("dragend",t),this._drainInertiaBuffer();var e=this._inertia;if(e.length<2)this._fireEvent("moveend",t);else{var i=e[e.length-1],o=e[0],r=i[1].sub(o[1]),a=(i[0]-o[0])/1e3;if(0===a||i[1].equals(o[1]))this._fireEvent("moveend",t);else{var n=r.mult(.3/a),s=n.mag();s>1400&&(s=1400,n._unit()._mult(s));var l=s/750,c=n.mult(-l/2);this._map.panBy(c,{duration:1e3*l,easing:wo,noMoveStart:!0},{originalEvent:t});}}},Eo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},Eo.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var To=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onKeyDown"],this);};function Io(t){return t*(2-t)}To.prototype.isEnabled=function(){return !!this._enabled},To.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0);},To.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1);},To.prototype._onKeyDown=function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e=0,i=0,o=0,r=0,a=0;switch(t.keyCode){case 61:case 107:case 171:case 187:e=1;break;case 189:case 109:case 173:e=-1;break;case 37:t.shiftKey?i=-1:(t.preventDefault(),r=-1);break;case 39:t.shiftKey?i=1:(t.preventDefault(),r=1);break;case 38:t.shiftKey?o=1:(t.preventDefault(),a=-1);break;case 40:t.shiftKey?o=-1:(a=1,t.preventDefault());break;default:return}var n=this._map,s=n.getZoom(),l={duration:300,delayEndEvents:500,easing:Io,zoom:e?Math.round(s)+e*(t.shiftKey?2:1):s,bearing:n.getBearing()+15*i,pitch:n.getPitch()+10*o,offset:[100*-r,100*-a],center:n.getCenter()};n.easeTo(l,{originalEvent:t});}};var So=function(e){this._map=e,t.bindAll(["_onDblClick","_onZoomEnd"],this);};So.prototype.isEnabled=function(){return !!this._enabled},So.prototype.isActive=function(){return !!this._active},So.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},So.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},So.prototype.onTouchStart=function(t){var e=this;if(this.isEnabled()&&!(t.points.length>1))if(this._tapped){var i=t.points[0],o=this._tappedPoint;if(o&&o.dist(i)<=30){t.originalEvent.preventDefault();var r=function(){e._tapped&&e._zoom(t),e._map.off("touchcancel",a),e._resetTapped();},a=function(){e._map.off("touchend",r),e._resetTapped();};this._map.once("touchend",r),this._map.once("touchcancel",a);}else this._resetTapped();}else this._tappedPoint=t.points[0],this._tapped=setTimeout((function(){e._tapped=null,e._tappedPoint=null;}),300);},So.prototype._resetTapped=function(){clearTimeout(this._tapped),this._tapped=null,this._tappedPoint=null;},So.prototype.onDblClick=function(t){this.isEnabled()&&(t.originalEvent.preventDefault(),this._zoom(t));},So.prototype._zoom=function(t){this._active=!0,this._map.on("zoomend",this._onZoomEnd),this._map.zoomTo(this._map.getZoom()+(t.originalEvent.shiftKey?-1:1),{around:t.lngLat},t);},So.prototype._onZoomEnd=function(){this._active=!1,this._map.off("zoomend",this._onZoomEnd);};var Co=t.bezier(0,0,.15,1),Po=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onMove","_onEnd","_onTouchFrame"],this);};Po.prototype.isEnabled=function(){return !!this._enabled},Po.prototype.enable=function(t){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-zoom-rotate"),this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around);},Po.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-zoom-rotate"),this._enabled=!1);},Po.prototype.disableRotation=function(){this._rotationDisabled=!0;},Po.prototype.enableRotation=function(){this._rotationDisabled=!1;},Po.prototype.onStart=function(e){if(this.isEnabled()&&2===e.touches.length){var o=i.mousePos(this._el,e.touches[0]),r=i.mousePos(this._el,e.touches[1]),a=o.add(r).div(2);this._startVec=o.sub(r),this._startAround=this._map.transform.pointLocation(a),this._gestureIntent=void 0,this._inertia=[],i.addEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.addEventListener(t.window.document,"touchend",this._onEnd);}},Po.prototype._getTouchEventData=function(t){var e=i.mousePos(this._el,t.touches[0]),o=i.mousePos(this._el,t.touches[1]),r=e.sub(o);return {vec:r,center:e.add(o).div(2),scale:r.mag()/this._startVec.mag(),bearing:this._rotationDisabled?0:180*r.angleWith(this._startVec)/Math.PI}},Po.prototype._onMove=function(e){if(2===e.touches.length){var i=this._getTouchEventData(e),o=i.vec,r=i.scale,a=i.bearing;if(!this._gestureIntent){var n=this._rotationDisabled&&1!==r||Math.abs(1-r)>.15;Math.abs(a)>10?this._gestureIntent="rotate":n&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._map.fire(new t.Event(this._gestureIntent+"start",{originalEvent:e})),this._map.fire(new t.Event("movestart",{originalEvent:e})),this._startVec=o);}this._lastTouchEvent=e,this._frameId||(this._frameId=this._map._requestRenderFrame(this._onTouchFrame)),e.preventDefault();}},Po.prototype._onTouchFrame=function(){this._frameId=null;var e=this._gestureIntent;if(e){var i=this._map.transform;this._startScale||(this._startScale=i.scale,this._startBearing=i.bearing);var o=this._getTouchEventData(this._lastTouchEvent),r=o.center,a=o.bearing,n=o.scale,s=i.pointLocation(r),l=i.locationPoint(s);"rotate"===e&&(i.bearing=this._startBearing+a),i.zoom=i.scaleZoom(this._startScale*n),i.setLocationAtPoint(this._startAround,l),this._map.fire(new t.Event(e,{originalEvent:this._lastTouchEvent})),this._map.fire(new t.Event("move",{originalEvent:this._lastTouchEvent})),this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),n,r]);}},Po.prototype._onEnd=function(e){i.removeEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onEnd);var o=this._gestureIntent,r=this._startScale;if(this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._gestureIntent,delete this._startScale,delete this._startBearing,delete this._lastTouchEvent,o){this._map.fire(new t.Event(o+"end",{originalEvent:e})),this._drainInertiaBuffer();var a=this._inertia,n=this._map;if(a.length<2)n.snapToNorth({},{originalEvent:e});else{var s=a[a.length-1],l=a[0],c=n.transform.scaleZoom(r*s[1]),u=n.transform.scaleZoom(r*l[1]),h=c-u,p=(s[0]-l[0])/1e3,d=s[2];if(0!==p&&c!==u){var _=.15*h/p;Math.abs(_)>2.5&&(_=_>0?2.5:-2.5);var f=1e3*Math.abs(_/(12*.15)),m=c+_*f/2e3;m<0&&(m=0),n.easeTo({zoom:m,duration:f,easing:Co,around:this._aroundCenter?n.getCenter():n.unproject(d),noMoveStart:!0},{originalEvent:e});}else n.snapToNorth({},{originalEvent:e});}}},Po.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>2&&i-e[0][0]>160;)e.shift();};var zo={scrollZoom:vo,boxZoom:yo,dragRotate:bo,dragPan:Eo,keyboard:To,doubleClickZoom:So,touchZoomRotate:Po};var Lo=function(e){function i(i,o){e.call(this),this._moving=!1,this._zooming=!1,this.transform=i,this._bearingSnap=o.bearingSnap,t.bindAll(["_renderFrameCallback"],this);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getCenter=function(){return new t.LngLat(this.transform.center.lng,this.transform.center.lat)},i.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},i.prototype.panBy=function(e,i,o){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),o)},i.prototype.panTo=function(e,i,o){return this.easeTo(t.extend({center:e},i),o)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},i.prototype.zoomTo=function(e,i,o){return this.easeTo(t.extend({zoom:e},i),o)},i.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},i.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},i.prototype.rotateTo=function(e,i,o){return this.easeTo(t.extend({bearing:e},i),o)},i.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},i.prototype.resetNorthPitch=function(e,i){return this.easeTo(t.extend({bearing:0,pitch:0,duration:1e3},e),i),this},i.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},i.prototype.cameraForBounds=function(e,i){return e=t.LngLatBounds.convert(e),this._cameraForBoxAndBearing(e.getNorthWest(),e.getSouthEast(),0,i)},i.prototype._cameraForBoxAndBearing=function(e,i,o,r){if("number"==typeof(r=t.extend({padding:{top:0,bottom:0,right:0,left:0},offset:[0,0],maxZoom:this.transform.maxZoom},r)).padding){var a=r.padding;r.padding={top:a,bottom:a,right:a,left:a};}if(t.deepEqual(Object.keys(r.padding).sort((function(t,e){return t<e?-1:t>e?1:0})),["bottom","left","right","top"])){var n=this.transform,s=n.project(t.LngLat.convert(e)),l=n.project(t.LngLat.convert(i)),c=s.rotate(-o*Math.PI/180),u=l.rotate(-o*Math.PI/180),h=new t.Point(Math.max(c.x,u.x),Math.max(c.y,u.y)),p=new t.Point(Math.min(c.x,u.x),Math.min(c.y,u.y)),d=h.sub(p),_=(n.width-r.padding.left-r.padding.right)/d.x,f=(n.height-r.padding.top-r.padding.bottom)/d.y;if(!(f<0||_<0)){var m=Math.min(n.scaleZoom(n.scale*Math.min(_,f)),r.maxZoom),g=t.Point.convert(r.offset),v=(r.padding.left-r.padding.right)/2,y=(r.padding.top-r.padding.bottom)/2,x=new t.Point(g.x+v,g.y+y).mult(n.scale/n.zoomScale(m));return {center:n.unproject(s.add(l).div(2).sub(x)),zoom:m,bearing:o}}t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");}else t.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'");},i.prototype.fitBounds=function(t,e,i){return this._fitInternal(this.cameraForBounds(t,e),e,i)},i.prototype.fitScreenCoordinates=function(e,i,o,r,a){return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)),this.transform.pointLocation(t.Point.convert(i)),o,r),r,a)},i.prototype._fitInternal=function(e,i,o){return e?(i=t.extend(e,i)).linear?this.easeTo(i,o):this.flyTo(i,o):this},i.prototype.jumpTo=function(e,i){this.stop();var o=this.transform,r=!1,a=!1,n=!1;return "zoom"in e&&o.zoom!==+e.zoom&&(r=!0,o.zoom=+e.zoom),void 0!==e.center&&(o.center=t.LngLat.convert(e.center)),"bearing"in e&&o.bearing!==+e.bearing&&(a=!0,o.bearing=+e.bearing),"pitch"in e&&o.pitch!==+e.pitch&&(n=!0,o.pitch=+e.pitch),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),r&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),a&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),n&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},i.prototype.easeTo=function(e,i){var o=this;this.stop(),(!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate||t.browser.prefersReducedMotion)&&(e.duration=0);var r=this.transform,a=this.getZoom(),n=this.getBearing(),s=this.getPitch(),l="zoom"in e?+e.zoom:a,c="bearing"in e?this._normalizeBearing(e.bearing,n):n,u="pitch"in e?+e.pitch:s,h=r.centerPoint.add(t.Point.convert(e.offset)),p=r.pointLocation(h),d=t.LngLat.convert(e.center||p);this._normalizeCenter(d);var _,f,m=r.project(p),g=r.project(d).sub(m),v=r.zoomScale(l-a);return e.around&&(_=t.LngLat.convert(e.around),f=r.locationPoint(_)),this._zooming=l!==a,this._rotating=n!==c,this._pitching=u!==s,this._prepareEase(i,e.noMoveStart),clearTimeout(this._easeEndTimeoutID),this._ease((function(e){if(o._zooming&&(r.zoom=t.number(a,l,e)),o._rotating&&(r.bearing=t.number(n,c,e)),o._pitching&&(r.pitch=t.number(s,u,e)),_)r.setLocationAtPoint(_,f);else{var p=r.zoomScale(r.zoom-a),d=l>a?Math.min(2,v):Math.max(.5,v),y=Math.pow(d,1-e),x=r.unproject(m.add(g.mult(e*y)).mult(p));r.setLocationAtPoint(r.renderWorldCopies?x.wrap():x,h);}o._fireMoveEvents(i);}),(function(){e.delayEndEvents?o._easeEndTimeoutID=setTimeout((function(){return o._afterEase(i)}),e.delayEndEvents):o._afterEase(i);}),e),this},i.prototype._prepareEase=function(e,i){this._moving=!0,i||this.fire(new t.Event("movestart",e)),this._zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&this.fire(new t.Event("pitchstart",e));},i.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e));},i.prototype._afterEase=function(e){var i=this._zooming,o=this._rotating,r=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,i&&this.fire(new t.Event("zoomend",e)),o&&this.fire(new t.Event("rotateend",e)),r&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e));},i.prototype.flyTo=function(e,i){var o=this;if(t.browser.prefersReducedMotion){var r=t.pick(e,["center","zoom","bearing","pitch","around"]);return this.jumpTo(r,i)}this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var a=this.transform,n=this.getZoom(),s=this.getBearing(),l=this.getPitch(),c="zoom"in e?t.clamp(+e.zoom,a.minZoom,a.maxZoom):n,u="bearing"in e?this._normalizeBearing(e.bearing,s):s,h="pitch"in e?+e.pitch:l,p=a.zoomScale(c-n),d=a.centerPoint.add(t.Point.convert(e.offset)),_=a.pointLocation(d),f=t.LngLat.convert(e.center||_);this._normalizeCenter(f);var m=a.project(_),g=a.project(f).sub(m),v=e.curve,y=Math.max(a.width,a.height),x=y/p,b=g.mag();if("minZoom"in e){var w=t.clamp(Math.min(e.minZoom,n,c),a.minZoom,a.maxZoom),E=y/a.zoomScale(w-n);v=Math.sqrt(E/b*2);}var T=v*v;function I(t){var e=(x*x-y*y+(t?-1:1)*T*T*b*b)/(2*(t?x:y)*T*b);return Math.log(Math.sqrt(e*e+1)-e)}function S(t){return (Math.exp(t)-Math.exp(-t))/2}function C(t){return (Math.exp(t)+Math.exp(-t))/2}var P=I(0),z=function(t){return C(P)/C(P+v*t)},L=function(t){return y*((C(P)*(S(e=P+v*t)/C(e))-S(P))/T)/b;var e;},M=(I(1)-P)/v;if(Math.abs(b)<1e-6||!isFinite(M)){if(Math.abs(y-x)<1e-6)return this.easeTo(e,i);var D=x<y?-1:1;M=Math.abs(Math.log(x/y))/v,L=function(){return 0},z=function(t){return Math.exp(D*v*t)};}if("duration"in e)e.duration=+e.duration;else{var R="screenSpeed"in e?+e.screenSpeed/v:+e.speed;e.duration=1e3*M/R;}return e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=s!==u,this._pitching=h!==l,this._prepareEase(i,!1),this._ease((function(e){var r=e*M,p=1/z(r);a.zoom=1===e?c:n+a.scaleZoom(p),o._rotating&&(a.bearing=t.number(s,u,e)),o._pitching&&(a.pitch=t.number(l,h,e));var _=1===e?f:a.unproject(m.add(g.mult(L(r))).mult(p));a.setLocationAtPoint(a.renderWorldCopies?_.wrap():_,d),o._fireMoveEvents(i);}),(function(){return o._afterEase(i)}),e),this},i.prototype.isEasing=function(){return !!this._easeFrameId},i.prototype.stop=function(){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd){var t=this._onEaseEnd;delete this._onEaseEnd,t.call(this);}return this},i.prototype._ease=function(e,i,o){!1===o.animate||0===o.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=o,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));},i.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();},i.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var o=Math.abs(e-i);return Math.abs(e-360-i)<o&&(e-=360),Math.abs(e+360-i)<o&&(e+=360),e},i.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0;}},i}(t.Evented),Mo=function(e){void 0===e&&(e={}),this.options=e,t.bindAll(["_updateEditLink","_updateData","_updateCompact"],this);};Mo.prototype.getDefaultPosition=function(){return "bottom-right"},Mo.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._innerContainer=i.create("div","mapboxgl-ctrl-attrib-inner",this._container),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},Mo.prototype.onRemove=function(){i.remove(this._container),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0;},Mo.prototype._updateEditLink=function(){var e=this._editLink;e||(e=this._editLink=this._container.querySelector(".mapbox-improve-map"));var i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||t.config.ACCESS_TOKEN}];if(e){var o=i.reduce((function(t,e,o){return e.value&&(t+=e.key+"="+e.value+(o<i.length-1?"&":"")),t}),"?");e.href=t.config.FEEDBACK_URL+"/"+o+(this._map._hash?this._map._hash.getHashString(!0):""),e.rel="noopener nofollow";}},Mo.prototype._updateData=function(t){!t||"metadata"!==t.sourceDataType&&"style"!==t.dataType||(this._updateAttributions(),this._updateEditLink());},Mo.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution.map((function(t){return "string"!=typeof t?"":t}))):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet){var e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}var i=this._map.style.sourceCaches;for(var o in i){var r=i[o];if(r.used){var a=r.getSource();a.attribution&&t.indexOf(a.attribution)<0&&t.push(a.attribution);}}t.sort((function(t,e){return t.length-e.length}));var n=(t=t.filter((function(e,i){for(var o=i+1;o<t.length;o++)if(t[o].indexOf(e)>=0)return !1;return !0}))).join(" | ");n!==this._attribHTML&&(this._attribHTML=n,t.length?(this._innerContainer.innerHTML=n,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null);}},Mo.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact");};var Do=function(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this);};Do.prototype.onAdd=function(t){this._map=t,this._container=i.create("div","mapboxgl-ctrl");var e=i.create("a","mapboxgl-ctrl-logo");return e.target="_blank",e.rel="noopener nofollow",e.href="https://www.mapbox.com/",e.setAttribute("aria-label","Mapbox logo"),e.setAttribute("rel","noopener nofollow"),this._container.appendChild(e),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},Do.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);},Do.prototype.getDefaultPosition=function(){return "bottom-left"},Do.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");},Do.prototype._logoRequired=function(){if(this._map.style){var t=this._map.style.sourceCaches;for(var e in t){if(t[e].getSource().mapbox_logo)return !0}return !1}},Do.prototype._updateCompact=function(){var t=this._container.children;if(t.length){var e=t[0];this._map.getCanvasContainer().offsetWidth<250?e.classList.add("mapboxgl-compact"):e.classList.remove("mapboxgl-compact");}};var Ro=function(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;};Ro.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},Ro.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,o=e?this._queue.concat(e):this._queue;i<o.length;i+=1){var r=o[i];if(r.id===t)return void(r.cancelled=!0)}},Ro.prototype.run=function(){var t=this._currentlyRunning=this._queue;this._queue=[];for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!o.cancelled&&(o.callback(),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1;},Ro.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];};var Ao=t.window.HTMLImageElement,ko=t.window.HTMLElement,Bo={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:0,maxZoom:22,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,clickTolerance:3,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",transformRequest:null,accessToken:null,fadeDuration:300,crossSourceCollisions:!0},Oo=function(o){function r(e){var r=this;if(null!=(e=t.extend({},Bo,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than minZoom");var a=new ho(e.minZoom,e.maxZoom,e.renderWorldCopies);if(o.call(this,a,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._antialias=e.antialias,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new Ro,this._controls=[],this._mapId=t.uniqueId(),this._requestManager=new t.RequestManager(e.transformRequest,e.accessToken),"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else{if(!(e.container instanceof ko))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container;}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",(function(){return r._update(!1)})),this.on("moveend",(function(){return r._update(!1)})),this.on("zoom",(function(){return r._update(!0)})),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1)),function(t,e){var o=t.getCanvasContainer(),r=null,a=!1,n=null;for(var s in zo)t[s]=new zo[s](t,e),e.interactive&&e[s]&&t[s].enable(e[s]);i.addEventListener(o,"mouseout",(function(e){t.fire(new fo("mouseout",t,e));})),i.addEventListener(o,"mousedown",(function(r){a=!0,n=i.mousePos(o,r);var s=new fo("mousedown",t,r);if(t.fire(s),s.defaultPrevented)return;e.interactive&&!t.doubleClickZoom.isActive()&&t.stop();t.boxZoom.onMouseDown(r),t.boxZoom.isActive()||t.dragPan.isActive()||t.dragRotate.onMouseDown(r);t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onMouseDown(r);})),i.addEventListener(o,"mouseup",(function(e){var i=t.dragRotate.isActive();r&&!i&&t.fire(new fo("contextmenu",t,r));r=null,a=!1,t.fire(new fo("mouseup",t,e));})),i.addEventListener(o,"mousemove",(function(e){if(t.dragPan.isActive())return;if(t.dragRotate.isActive())return;var i=e.target;for(;i&&i!==o;)i=i.parentNode;if(i!==o)return;t.fire(new fo("mousemove",t,e));})),i.addEventListener(o,"mouseover",(function(e){var i=e.target;for(;i&&i!==o;)i=i.parentNode;if(i!==o)return;t.fire(new fo("mouseover",t,e));})),i.addEventListener(o,"touchstart",(function(i){var o=new mo("touchstart",t,i);if(t.fire(o),o.defaultPrevented)return;e.interactive&&t.stop();t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onTouchStart(i);t.touchZoomRotate.onStart(i),t.doubleClickZoom.onTouchStart(o);}),{passive:!1}),i.addEventListener(o,"touchmove",(function(e){t.fire(new mo("touchmove",t,e));}),{passive:!1}),i.addEventListener(o,"touchend",(function(e){t.fire(new mo("touchend",t,e));})),i.addEventListener(o,"touchcancel",(function(e){t.fire(new mo("touchcancel",t,e));})),i.addEventListener(o,"click",(function(r){var a=i.mousePos(o,r);(!n||a.equals(n)||a.dist(n)<e.clickTolerance)&&t.fire(new fo("click",t,r));})),i.addEventListener(o,"dblclick",(function(e){var i=new fo("dblclick",t,e);if(t.fire(i),i.defaultPrevented)return;t.doubleClickZoom.onDblClick(i);})),i.addEventListener(o,"contextmenu",(function(e){var i=t.dragRotate.isActive();a||i?a&&(r=e):t.fire(new fo("contextmenu",t,e));(t.dragRotate.isEnabled()||t.listens("contextmenu"))&&e.preventDefault();})),i.addEventListener(o,"wheel",(function(i){e.interactive&&t.stop();var o=new go("wheel",t,i);if(t.fire(o),o.defaultPrevented)return;t.scrollZoom.onWheel(i);}),{passive:!1});}(this,e),this._hash=e.hash&&(new _o).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),e.bounds&&(this.resize(),this.fitBounds(e.bounds,t.extend({},e.fitBoundsOptions,{duration:0})))),this.resize(),this._localIdeographFontFamily=e.localIdeographFontFamily,e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new Mo({customAttribution:e.customAttribution})),this.addControl(new Do,e.logoPosition),this.on("style.load",(function(){r.transform.unmodified&&r.jumpTo(r.style.stylesheet);})),this.on("data",(function(e){r._update("style"===e.dataType),r.fire(new t.Event(e.dataType+"data",e));})),this.on("dataloading",(function(e){r.fire(new t.Event(e.dataType+"dataloading",e));}));}o&&(r.__proto__=o),r.prototype=Object.create(o&&o.prototype),r.prototype.constructor=r;var a={showTileBoundaries:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0},version:{configurable:!0}};return r.prototype._getMapId=function(){return this._mapId},r.prototype.addControl=function(e,i){if(void 0===i&&e.getDefaultPosition&&(i=e.getDefaultPosition()),void 0===i&&(i="top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var o=e.onAdd(this);this._controls.push(e);var r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this},r.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return i>-1&&this._controls.splice(i,1),e.onRemove(this),this},r.prototype.resize=function(e){var i=this._containerDimensions(),o=i[0],r=i[1];return this._resizeCanvas(o,r),this.transform.resize(o,r),this.painter.resize(o,r),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e)).fire(new t.Event("resize",e)).fire(new t.Event("moveend",e)),this},r.prototype.getBounds=function(){return this.transform.getBounds()},r.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},r.prototype.setMaxBounds=function(e){return this.transform.setMaxBounds(t.LngLatBounds.convert(e)),this._update()},r.prototype.setMinZoom=function(t){if((t=null==t?0:t)>=0&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between 0 and the current maxZoom, inclusive")},r.prototype.getMinZoom=function(){return this.transform.minZoom},r.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},r.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},r.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},r.prototype.getMaxZoom=function(){return this.transform.maxZoom},r.prototype.project=function(e){return this.transform.locationPoint(t.LngLat.convert(e))},r.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},r.prototype.isMoving=function(){return this._moving||this.dragPan.isActive()||this.dragRotate.isActive()||this.scrollZoom.isActive()},r.prototype.isZooming=function(){return this._zooming||this.scrollZoom.isZooming()},r.prototype.isRotating=function(){return this._rotating||this.dragRotate.isActive()},r.prototype.on=function(t,e,i){var r=this;if(void 0===i)return o.prototype.on.call(this,t,e);var a=function(){var o;if("mouseenter"===t||"mouseover"===t){var a=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){var n=r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[];n.length?a||(a=!0,i.call(r,new fo(t,r,o.originalEvent,{features:n}))):a=!1;},mouseout:function(){a=!1;}}}}if("mouseleave"===t||"mouseout"===t){var n=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){(r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[]).length?n=!0:n&&(n=!1,i.call(r,new fo(t,r,o.originalEvent)));},mouseout:function(e){n&&(n=!1,i.call(r,new fo(t,r,e.originalEvent)));}}}}return {layer:e,listener:i,delegates:(o={},o[t]=function(t){var o=r.getLayer(e)?r.queryRenderedFeatures(t.point,{layers:[e]}):[];o.length&&(t.features=o,i.call(r,t),delete t.features);},o)}}();for(var n in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(a),a.delegates)this.on(n,a.delegates[n]);return this},r.prototype.off=function(t,e,i){if(void 0===i)return o.prototype.off.call(this,t,e);if(this._delegatedListeners&&this._delegatedListeners[t])for(var r=this._delegatedListeners[t],a=0;a<r.length;a++){var n=r[a];if(n.layer===e&&n.listener===i){for(var s in n.delegates)this.off(s,n.delegates[s]);return r.splice(a,1),this}}return this},r.prototype.queryRenderedFeatures=function(e,i){if(!this.style)return [];var o;if(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0])o=[t.Point.convert(e)];else{var r=t.Point.convert(e[0]),a=t.Point.convert(e[1]);o=[r,new t.Point(a.x,r.y),a,new t.Point(r.x,a.y),r];}return this.style.queryRenderedFeatures(o,i,this.transform)},r.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},r.prototype.setStyle=function(e,i){return !1!==(i=t.extend({},{localIdeographFontFamily:this._localIdeographFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&this.style&&e?(this._diffStyle(e,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._updateStyle(e,i))},r.prototype._updateStyle=function(t,e){return this.style&&(this.style.setEventedParent(null),this.style._remove()),t?(this.style=new Oe(this,e||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof t?this.style.loadURL(t):this.style.loadJSON(t),this):(delete this.style,this)},r.prototype._diffStyle=function(e,i){var o=this;if("string"==typeof e){var r=this._requestManager.normalizeStyleURL(e),a=this._requestManager.transformRequest(r,t.ResourceType.Style);t.getJSON(a,(function(e,r){e?o.fire(new t.ErrorEvent(e)):r&&o._updateDiff(r,i);}));}else"object"==typeof e&&this._updateDiff(e,i);},r.prototype._updateDiff=function(e,i){try{this.style.setState(e)&&this._update(!0);}catch(o){t.warnOnce("Unable to perform style diff: "+(o.message||o.error||o)+".  Rebuilding the style from scratch."),this._updateStyle(e,i);}},r.prototype.getStyle=function(){if(this.style)return this.style.serialize()},r.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},r.prototype.addSource=function(t,e){return this.style.addSource(t,e),this._update(!0)},r.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")));},r.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var i=t[e]._tiles;for(var o in i){var r=i[o];if("loaded"!==r.state&&"errored"!==r.state)return !1}}return !0},r.prototype.addSourceType=function(t,e,i){return this.style.addSourceType(t,e,i)},r.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},r.prototype.getSource=function(t){return this.style.getSource(t)},r.prototype.addImage=function(e,i,o){void 0===o&&(o={});var r=o.pixelRatio;void 0===r&&(r=1);var a=o.sdf;void 0===a&&(a=!1);if(i instanceof Ao){var n=t.browser.getImageData(i),s=n.width,l=n.height,c=n.data;this.style.addImage(e,{data:new t.RGBAImage({width:s,height:l},c),pixelRatio:r,sdf:a,version:0});}else{if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));var u=i.width,h=i.height,p=i.data,d=i;this.style.addImage(e,{data:new t.RGBAImage({width:u,height:h},new Uint8Array(p)),pixelRatio:r,sdf:a,version:0,userImage:d}),d.onAdd&&d.onAdd(this,e);}},r.prototype.updateImage=function(e,i){var o=this.style.getImage(e);if(!o)return this.fire(new t.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));var r=i instanceof Ao?t.browser.getImageData(i):i,a=r.width,n=r.height,s=r.data;if(void 0===a||void 0===n)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));if(a!==o.data.width||n!==o.data.height)return this.fire(new t.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));var l=!(i instanceof Ao);o.data.replace(s,l),this.style.updateImage(e,o);},r.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},r.prototype.removeImage=function(t){this.style.removeImage(t);},r.prototype.loadImage=function(e,i){t.getImage(this._requestManager.transformRequest(e,t.ResourceType.Image),i);},r.prototype.listImages=function(){return this.style.listImages()},r.prototype.addLayer=function(t,e){return this.style.addLayer(t,e),this._update(!0)},r.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},r.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},r.prototype.getLayer=function(t){return this.style.getLayer(t)},r.prototype.setFilter=function(t,e,i){return void 0===i&&(i={}),this.style.setFilter(t,e,i),this._update(!0)},r.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},r.prototype.getFilter=function(t){return this.style.getFilter(t)},r.prototype.setPaintProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setPaintProperty(t,e,i,o),this._update(!0)},r.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},r.prototype.setLayoutProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setLayoutProperty(t,e,i,o),this._update(!0)},r.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},r.prototype.setLight=function(t,e){return void 0===e&&(e={}),this.style.setLight(t,e),this._update(!0)},r.prototype.getLight=function(){return this.style.getLight()},r.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},r.prototype.removeFeatureState=function(t,e){return this.style.removeFeatureState(t,e),this._update()},r.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},r.prototype.getContainer=function(){return this._container},r.prototype.getCanvasContainer=function(){return this._canvasContainer},r.prototype.getCanvas=function(){return this._canvas},r.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.clientWidth||400,e=this._container.clientHeight||300),[t,e]},r.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");},r.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var o=this._containerDimensions();this._resizeCanvas(o[0],o[1]);var r=this._controlContainer=i.create("div","mapboxgl-control-container",t),a=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach((function(t){a[t]=i.create("div","mapboxgl-ctrl-"+t,r);}));},r.prototype._resizeCanvas=function(e,i){var o=t.window.devicePixelRatio||1;this._canvas.width=o*e,this._canvas.height=o*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px";},r.prototype._setupPainter=function(){var i=t.extend({},e.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1}),o=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i);o?(this.painter=new so(o,this.transform),t.webpSupported.testSupport(o)):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));},r.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}));},r.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}));},r.prototype.loaded=function(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},r.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this.triggerRepaint(),this):this},r.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},r.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t);},r.prototype._render=function(){this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run();var e=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var i=this.transform.zoom,o=t.browser.now();this.style.zoomHistory.update(i,o);var r=new t.EvaluationParameters(i,{now:o,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),a=r.crossFadingFactor();1===a&&a===this._crossFadingFactor||(e=!0,this._crossFadingFactor=a),this.style.update(r);}return this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:this._fadeDuration}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||e)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),this._sourcesDirty||this._repaint||this._styleDirty||this._placementDirty?this.triggerRepaint():!this.isMoving()&&this.loaded()&&this.fire(new t.Event("idle")),this},r.prototype.remove=function(){this._hash&&this._hash.remove();for(var e=0,i=this._controls;e<i.length;e+=1){i[e].onRemove(this);}this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));var o=this.painter.context.gl.getExtension("WEBGL_lose_context");o&&o.loseContext(),Fo(this._canvasContainer),Fo(this._controlContainer),Fo(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this.fire(new t.Event("remove"));},r.prototype.triggerRepaint=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame((function(){e._frame=null,e._render();})));},r.prototype._onWindowOnline=function(){this._update();},r.prototype._onWindowResize=function(){this._trackResize&&this.resize()._update();},a.showTileBoundaries.get=function(){return !!this._showTileBoundaries},a.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update());},a.showCollisionBoxes.get=function(){return !!this._showCollisionBoxes},a.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update());},a.showOverdrawInspector.get=function(){return !!this._showOverdrawInspector},a.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update());},a.repaint.get=function(){return !!this._repaint},a.repaint.set=function(t){this._repaint!==t&&(this._repaint=t,this.triggerRepaint());},a.vertices.get=function(){return !!this._vertices},a.vertices.set=function(t){this._vertices=t,this._update();},r.prototype._setCacheLimits=function(e,i){t.setCacheLimits(e,i);},a.version.get=function(){return t.version},Object.defineProperties(r.prototype,a),r}(Lo);function Fo(t){t.parentNode&&t.parentNode.removeChild(t);}var Uo={showCompass:!0,showZoom:!0,visualizePitch:!1},No=function(e){var o=this;this.options=t.extend({},Uo,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this.options.showZoom&&(t.bindAll(["_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in","Zoom in",(function(){return o._map.zoomIn()})),this._zoomOutButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out","Zoom out",(function(){return o._map.zoomOut()}))),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-compass","Reset bearing to north",(function(){o.options.visualizePitch?o._map.resetNorthPitch():o._map.resetNorth();})),this._compassArrow=i.create("span","mapboxgl-ctrl-compass-arrow",this._compass));};function Zo(e,i,o){if(e=new t.LngLat(e.lng,e.lat),i){var r=new t.LngLat(e.lng-360,e.lat),a=new t.LngLat(e.lng+360,e.lat),n=o.locationPoint(e).distSqr(i);o.locationPoint(r).distSqr(i)<n?e=r:o.locationPoint(a).distSqr(i)<n&&(e=a);}for(;Math.abs(e.lng-o.center.lng)>180;){var s=o.locationPoint(e);if(s.x>=0&&s.y>=0&&s.x<=o.width&&s.y<=o.height)break;e.lng>o.center.lng?e.lng-=360:e.lng+=360;}return e}No.prototype._updateZoomButtons=function(){var t=this._map.getZoom();t===this._map.getMaxZoom()?this._zoomInButton.classList.add("mapboxgl-ctrl-icon-disabled"):this._zoomInButton.classList.remove("mapboxgl-ctrl-icon-disabled"),t===this._map.getMinZoom()?this._zoomOutButton.classList.add("mapboxgl-ctrl-icon-disabled"):this._zoomOutButton.classList.remove("mapboxgl-ctrl-icon-disabled");},No.prototype._rotateCompassArrow=function(){var t=this.options.visualizePitch?"scale("+1/Math.pow(Math.cos(this._map.transform.pitch*(Math.PI/180)),.5)+") rotateX("+this._map.transform.pitch+"deg) rotateZ("+this._map.transform.angle*(180/Math.PI)+"deg)":"rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassArrow.style.transform=t;},No.prototype.onAdd=function(t){return this._map=t,this.options.showZoom&&(this._map.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this.options.visualizePitch&&this._map.on("pitch",this._rotateCompassArrow),this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new bo(t,{button:"left",element:this._compass}),i.addEventListener(this._compass,"mousedown",this._handler.onMouseDown),i.addEventListener(this._compass,"touchstart",this._handler.onMouseDown,{passive:!1}),this._handler.enable()),this._container},No.prototype.onRemove=function(){i.remove(this._container),this.options.showZoom&&this._map.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&this._map.off("pitch",this._rotateCompassArrow),this._map.off("rotate",this._rotateCompassArrow),i.removeEventListener(this._compass,"mousedown",this._handler.onMouseDown),i.removeEventListener(this._compass,"touchstart",this._handler.onMouseDown,{passive:!1}),this._handler.disable(),delete this._handler),delete this._map;},No.prototype._createButton=function(t,e,o){var r=i.create("button",t,this._container);return r.type="button",r.title=e,r.setAttribute("aria-label",e),r.addEventListener("click",o),r};var qo={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function jo(t,e,i){var o=t.classList;for(var r in qo)o.remove("mapboxgl-"+i+"-anchor-"+r);o.add("mapboxgl-"+i+"-anchor-"+e);}var Vo,Go=function(e){function o(o,r){if(e.call(this),(o instanceof t.window.HTMLElement||r)&&(o=t.extend({element:o},r)),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick"],this),this._anchor=o&&o.anchor||"center",this._color=o&&o.color||"#3FB1CE",this._draggable=o&&o.draggable||!1,this._state="inactive",o&&o.element)this._element=o.element,this._offset=t.Point.convert(o&&o.offset||[0,0]);else{this._defaultMarker=!0,this._element=i.create("div");var a=i.createNS("http://www.w3.org/2000/svg","svg");a.setAttributeNS(null,"display","block"),a.setAttributeNS(null,"height","41px"),a.setAttributeNS(null,"width","27px"),a.setAttributeNS(null,"viewBox","0 0 27 41");var n=i.createNS("http://www.w3.org/2000/svg","g");n.setAttributeNS(null,"stroke","none"),n.setAttributeNS(null,"stroke-width","1"),n.setAttributeNS(null,"fill","none"),n.setAttributeNS(null,"fill-rule","evenodd");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"fill-rule","nonzero");var l=i.createNS("http://www.w3.org/2000/svg","g");l.setAttributeNS(null,"transform","translate(3.0, 29.0)"),l.setAttributeNS(null,"fill","#000000");for(var c=0,u=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];c<u.length;c+=1){var h=u[c],p=i.createNS("http://www.w3.org/2000/svg","ellipse");p.setAttributeNS(null,"opacity","0.04"),p.setAttributeNS(null,"cx","10.5"),p.setAttributeNS(null,"cy","5.80029008"),p.setAttributeNS(null,"rx",h.rx),p.setAttributeNS(null,"ry",h.ry),l.appendChild(p);}var d=i.createNS("http://www.w3.org/2000/svg","g");d.setAttributeNS(null,"fill",this._color);var _=i.createNS("http://www.w3.org/2000/svg","path");_.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),d.appendChild(_);var f=i.createNS("http://www.w3.org/2000/svg","g");f.setAttributeNS(null,"opacity","0.25"),f.setAttributeNS(null,"fill","#000000");var m=i.createNS("http://www.w3.org/2000/svg","path");m.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),f.appendChild(m);var g=i.createNS("http://www.w3.org/2000/svg","g");g.setAttributeNS(null,"transform","translate(6.0, 7.0)"),g.setAttributeNS(null,"fill","#FFFFFF");var v=i.createNS("http://www.w3.org/2000/svg","g");v.setAttributeNS(null,"transform","translate(8.0, 8.0)");var y=i.createNS("http://www.w3.org/2000/svg","circle");y.setAttributeNS(null,"fill","#000000"),y.setAttributeNS(null,"opacity","0.25"),y.setAttributeNS(null,"cx","5.5"),y.setAttributeNS(null,"cy","5.5"),y.setAttributeNS(null,"r","5.4999962");var x=i.createNS("http://www.w3.org/2000/svg","circle");x.setAttributeNS(null,"fill","#FFFFFF"),x.setAttributeNS(null,"cx","5.5"),x.setAttributeNS(null,"cy","5.5"),x.setAttributeNS(null,"r","5.4999962"),v.appendChild(y),v.appendChild(x),s.appendChild(l),s.appendChild(d),s.appendChild(f),s.appendChild(g),s.appendChild(v),a.appendChild(s),this._element.appendChild(a),this._offset=t.Point.convert(o&&o.offset||[0,-14]);}this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",(function(t){t.preventDefault();})),jo(this._element,this._anchor,"marker"),this._popup=null;}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},o.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),this._map.off("mouseup",this._onUp),this._map.off("touchend",this._onUp),this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},o.prototype.getElement=function(){return this._element},o.prototype.setPopup=function(t){if(this._popup&&(this._popup.remove(),this._popup=null),t){if(!("offset"in t.options)){var e=Math.sqrt(Math.pow(13.5,2)/2);t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset;}this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat);}return this},o.prototype._onMapClick=function(t){var e=t.originalEvent.target,i=this._element;this._popup&&(e===i||i.contains(e))&&this.togglePopup();},o.prototype.getPopup=function(){return this._popup},o.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},o.prototype._update=function(t){this._map&&(this._map.transform.renderWorldCopies&&(this._lngLat=Zo(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,qo[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px)"));},o.prototype.getOffset=function(){return this._offset},o.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},o.prototype._onMove=function(e){this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag"));},o.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive";},o.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp));},o.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},o.prototype.isDraggable=function(){return this._draggable},o}(t.Evented),Wo={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showUserLocation:!0};var Xo=function(e){function o(i){e.call(this),this.options=t.extend({},Wo,i),t.bindAll(["_onSuccess","_onError","_finish","_setupUI","_updateCamera","_updateMarker"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(e){var o;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),o=this._setupUI,void 0!==Vo?o(Vo):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then((function(t){Vo="denied"!==t.state,o(Vo);})):(Vo=!!t.window.navigator.geolocation,o(Vo)),this._container},o.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),i.remove(this._container),this._map=void 0;},o.prototype._onSuccess=function(e){if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish();},o.prototype._updateCamera=function(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude),o=e.coords.accuracy,r=this._map.getBearing(),a=t.extend({bearing:r},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(o),a,{geolocateSource:!0});},o.prototype._updateMarker=function(t){t?this._userLocationDotMarker.setLngLat([t.coords.longitude,t.coords.latitude]).addTo(this._map):this._userLocationDotMarker.remove();},o.prototype._onError=function(e){if(this.options.trackUserLocation)if(1===e.code)this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),void 0!==this._geolocationWatchID&&this._clearWatch();else switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish();},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;},o.prototype._setupUI=function(e){var o=this;!1!==e?(this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this._geolocateButton=i.create("button","mapboxgl-ctrl-icon mapboxgl-ctrl-geolocate",this._container),this._geolocateButton.type="button",this._geolocateButton.setAttribute("aria-label","Geolocate"),this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new Go(this._dotElement),this.options.trackUserLocation&&(this._watchState="OFF")),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",(function(e){e.geolocateSource||"ACTIVE_LOCK"!==o._watchState||(o._watchState="BACKGROUND",o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),o.fire(new t.Event("trackuserlocationend")));}))):t.warnOnce("Geolocation support is not available, the GeolocateControl will not be visible.");},o.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}"OFF"===this._watchState&&void 0!==this._geolocationWatchID?this._clearWatch():void 0===this._geolocationWatchID&&(this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,this.options.positionOptions));}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0},o.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);},o}(t.Evented),Ho={maxWidth:100,unit:"metric"},Ko=function(e){this.options=t.extend({},Ho,e),t.bindAll(["_onMove","setUnit"],this);};function Jo(t,e,i){var o,r,a,n,s,l,c=i&&i.maxWidth||100,u=t._container.clientHeight/2,h=(o=t.unproject([0,u]),r=t.unproject([c,u]),a=Math.PI/180,n=o.lat*a,s=r.lat*a,l=Math.sin(n)*Math.sin(s)+Math.cos(n)*Math.cos(s)*Math.cos((r.lng-o.lng)*a),6371e3*Math.acos(Math.min(l,1)));if(i&&"imperial"===i.unit){var p=3.2808*h;if(p>5280)Yo(e,c,p/5280,"mi");else Yo(e,c,p,"ft");}else if(i&&"nautical"===i.unit){Yo(e,c,h/1852,"nm");}else Yo(e,c,h,"m");}function Yo(t,e,i,o){var r,a,n,s=(r=i,a=Math.pow(10,(""+Math.floor(r)).length-1),n=(n=r/a)>=10?10:n>=5?5:n>=3?3:n>=2?2:n>=1?1:function(t){var e=Math.pow(10,Math.ceil(-Math.log(t)/Math.LN10));return Math.round(t*e)/e}(n),a*n),l=s/i;"m"===o&&s>=1e3&&(s/=1e3,o="km"),t.style.width=e*l+"px",t.innerHTML=s+o;}Ko.prototype.getDefaultPosition=function(){return "bottom-left"},Ko.prototype._onMove=function(){Jo(this._map,this._container,this.options);},Ko.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},Ko.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0;},Ko.prototype.setUnit=function(t){this.options.unit=t,Jo(this._map,this._container,this.options);};var Qo=function(e){this._fullscreen=!1,e&&e.container&&(e.container instanceof t.window.HTMLElement?this._container=e.container:t.warnOnce("Full screen control 'container' must be a DOM element.")),t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange"),this._className="mapboxgl-ctrl";};Qo.prototype.onAdd=function(e){return this._map=e,this._container||(this._container=this._map.getContainer()),this._controlContainer=i.create("div",this._className+" mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._controlContainer},Qo.prototype.onRemove=function(){i.remove(this._controlContainer),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);},Qo.prototype._checkFullscreenSupport=function(){return !!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},Qo.prototype._setupUI=function(){(this._fullscreenButton=i.create("button",this._className+"-icon "+this._className+"-fullscreen",this._controlContainer)).type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon);},Qo.prototype._updateTitle=function(){var t=this._isFullscreen()?"Exit fullscreen":"Enter fullscreen";this._fullscreenButton.setAttribute("aria-label",t),this._fullscreenButton.title=t;},Qo.prototype._isFullscreen=function(){return this._fullscreen},Qo.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle(this._className+"-shrink"),this._fullscreenButton.classList.toggle(this._className+"-fullscreen"),this._updateTitle());},Qo.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.mozRequestFullScreen?this._container.mozRequestFullScreen():this._container.msRequestFullscreen?this._container.msRequestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();};var $o={closeButton:!0,closeOnClick:!0,className:"",maxWidth:"240px"},tr=function(e){function o(i){e.call(this),this.options=t.extend(Object.create($o),i),t.bindAll(["_update","_onClickClose","remove"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(e){var i=this;return this._map=e,this.options.closeOnClick&&this._map.on("click",this._onClickClose),this._map.on("remove",this.remove),this._update(),this._trackPointer?(this._map.on("mousemove",(function(t){i._update(t.point);})),this._map.on("mouseup",(function(t){i._update(t.point);})),this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")):this._map.on("move",this._update),this.fire(new t.Event("open")),this},o.prototype.isOpen=function(){return !!this._map},o.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("click",this._onClickClose),this._map.off("remove",this.remove),this._map.off("mousemove"),delete this._map),this.fire(new t.Event("close")),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._trackPointer=!1,this._update(),this._map&&(this._map.on("move",this._update),this._map.off("mousemove"),this._container.classList.remove("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")),this},o.prototype.trackPointer=function(){var t=this;return this._trackPointer=!0,this._pos=null,this._map&&(this._map.off("move",this._update),this._map.on("mousemove",(function(e){t._update(e.point);})),this._map.on("drag",(function(e){t._update(e.point);})),this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")),this},o.prototype.getElement=function(){return this._container},o.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},o.prototype.setHTML=function(e){var i,o=t.window.document.createDocumentFragment(),r=t.window.document.createElement("body");for(r.innerHTML=e;i=r.firstChild;)o.appendChild(i);return this.setDOMContent(o)},o.prototype.getMaxWidth=function(){return this._container.style.maxWidth},o.prototype.setMaxWidth=function(t){return this.options.maxWidth=t,this._update(),this},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype._createContent=function(){this._content&&i.remove(this._content),this._content=i.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClickClose));},o.prototype._update=function(e){var o=this,r=this._lngLat||this._trackPointer;if(this._map&&r&&this._content&&(this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach((function(t){return o._container.classList.add(t)}))),this.options.maxWidth&&this._container.style.maxWidth!==this.options.maxWidth&&(this._container.style.maxWidth=this.options.maxWidth),this._map.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=Zo(this._lngLat,this._pos,this._map.transform)),!this._trackPointer||e)){var a=this._pos=this._trackPointer&&e?e:this._map.project(this._lngLat),n=this.options.anchor,s=function e(i){if(i){if("number"==typeof i){var o=Math.round(Math.sqrt(.5*Math.pow(i,2)));return {center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(o,o),"top-right":new t.Point(-o,o),bottom:new t.Point(0,-i),"bottom-left":new t.Point(o,-o),"bottom-right":new t.Point(-o,-o),left:new t.Point(i,0),right:new t.Point(-i,0)}}if(i instanceof t.Point||Array.isArray(i)){var r=t.Point.convert(i);return {center:r,top:r,"top-left":r,"top-right":r,bottom:r,"bottom-left":r,"bottom-right":r,left:r,right:r}}return {center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset);if(!n){var l,c=this._container.offsetWidth,u=this._container.offsetHeight;l=a.y+s.bottom.y<u?["top"]:a.y>this._map.transform.height-u?["bottom"]:[],a.x<c/2?l.push("left"):a.x>this._map.transform.width-c/2&&l.push("right"),n=0===l.length?"bottom":l.join("-");}var h=a.add(s[n]).round();i.setTransform(this._container,qo[n]+" translate("+h.x+"px,"+h.y+"px)"),jo(this._container,n,"popup");}},o.prototype._onClickClose=function(){this.remove();},o}(t.Evented);var er={version:t.version,supported:e,setRTLTextPlugin:t.setRTLTextPlugin,Map:Oo,NavigationControl:No,GeolocateControl:Xo,AttributionControl:Mo,ScaleControl:Ko,FullscreenControl:Qo,Popup:tr,Marker:Go,Style:Oe,LngLat:t.LngLat,LngLatBounds:t.LngLatBounds,Point:t.Point,MercatorCoordinate:t.MercatorCoordinate,Evented:t.Evented,config:t.config,get accessToken(){return t.config.ACCESS_TOKEN},set accessToken(e){t.config.ACCESS_TOKEN=e;},get baseApiUrl(){return t.config.API_URL},set baseApiUrl(e){t.config.API_URL=e;},get workerCount(){return At.workerCount},set workerCount(t){At.workerCount=t;},get maxParallelImageRequests(){return t.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(e){t.config.MAX_PARALLEL_IMAGE_REQUESTS=e;},clearStorage:function(e){t.clearTileCache(e);},workerUrl:""};return er}));
	
	//
	
	return mapboxgl;
	
	}));
	
	
	},{}],428:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createTable
	
	var chull = _dereq_('convex-hull')
	
	function constructVertex(d, a, b) {
	  var x = new Array(d)
	  for(var i=0; i<d; ++i) {
	    x[i] = 0.0
	    if(i === a) {
	      x[i] += 0.5
	    }
	    if(i === b) {
	      x[i] += 0.5
	    }
	  }
	  return x
	}
	
	function constructCell(dimension, mask) {
	  if(mask === 0 || mask === (1<<(dimension+1))-1) {
	    return []
	  }
	  var points = []
	  var index  = []
	  for(var i=0; i<=dimension; ++i) {
	    if(mask & (1<<i)) {
	      points.push(constructVertex(dimension, i-1, i-1))
	      index.push(null)
	      for(var j=0; j<=dimension; ++j) {
	        if(~mask & (1<<j)) {
	          points.push(constructVertex(dimension, i-1, j-1))
	          index.push([i,j])
	        }
	      }
	    }
	  }
	  
	  //Preprocess points so first d+1 points are linearly independent
	  var hull = chull(points)
	  var faces = []
	i_loop:
	  for(var i=0; i<hull.length; ++i) {
	    var face = hull[i]
	    var nface = []
	    for(var j=0; j<face.length; ++j) {
	      if(!index[face[j]]) {
	        continue i_loop
	      }
	      nface.push(index[face[j]].slice())
	    }
	    faces.push(nface)
	  }
	  return faces
	}
	
	function createTable(dimension) {
	  var numCells = 1<<(dimension+1)
	  var result = new Array(numCells)
	  for(var i=0; i<numCells; ++i) {
	    result[i] = constructCell(dimension, i)
	  }
	  return result
	}
	},{"convex-hull":131}],429:[function(_dereq_,module,exports){
	/*jshint unused:true*/
	/*
	Input:  matrix      ; a 4x4 matrix
	Output: translation ; a 3 component vector
	        scale       ; a 3 component vector
	        skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
	        perspective ; a 4 component vector
	        quaternion  ; a 4 component vector
	Returns false if the matrix cannot be decomposed, true if it can
	
	
	References:
	https://github.com/kamicane/matrix3d/blob/master/lib/Matrix3d.js
	https://github.com/ChromiumWebApps/chromium/blob/master/ui/gfx/transform_util.cc
	http://www.w3.org/TR/css3-transforms/#decomposing-a-3d-matrix
	*/
	
	var normalize = _dereq_('./normalize')
	
	var create = _dereq_('gl-mat4/create')
	var clone = _dereq_('gl-mat4/clone')
	var determinant = _dereq_('gl-mat4/determinant')
	var invert = _dereq_('gl-mat4/invert')
	var transpose = _dereq_('gl-mat4/transpose')
	var vec3 = {
	    length: _dereq_('gl-vec3/length'),
	    normalize: _dereq_('gl-vec3/normalize'),
	    dot: _dereq_('gl-vec3/dot'),
	    cross: _dereq_('gl-vec3/cross')
	}
	
	var tmp = create()
	var perspectiveMatrix = create()
	var tmpVec4 = [0, 0, 0, 0]
	var row = [ [0,0,0], [0,0,0], [0,0,0] ]
	var pdum3 = [0,0,0]
	
	module.exports = function decomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
	    if (!translation) translation = [0,0,0]
	    if (!scale) scale = [0,0,0]
	    if (!skew) skew = [0,0,0]
	    if (!perspective) perspective = [0,0,0,1]
	    if (!quaternion) quaternion = [0,0,0,1]
	
	    //normalize, if not possible then bail out early
	    if (!normalize(tmp, matrix))
	        return false
	
	    // perspectiveMatrix is used to solve for perspective, but it also provides
	    // an easy way to test for singularity of the upper 3x3 component.
	    clone(perspectiveMatrix, tmp)
	
	    perspectiveMatrix[3] = 0
	    perspectiveMatrix[7] = 0
	    perspectiveMatrix[11] = 0
	    perspectiveMatrix[15] = 1
	
	    // If the perspectiveMatrix is not invertible, we are also unable to
	    // decompose, so we'll bail early. Constant taken from SkMatrix44::invert.
	    if (Math.abs(determinant(perspectiveMatrix) < 1e-8))
	        return false
	
	    var a03 = tmp[3], a13 = tmp[7], a23 = tmp[11],
	            a30 = tmp[12], a31 = tmp[13], a32 = tmp[14], a33 = tmp[15]
	
	    // First, isolate perspective.
	    if (a03 !== 0 || a13 !== 0 || a23 !== 0) {
	        tmpVec4[0] = a03
	        tmpVec4[1] = a13
	        tmpVec4[2] = a23
	        tmpVec4[3] = a33
	
	        // Solve the equation by inverting perspectiveMatrix and multiplying
	        // rightHandSide by the inverse.
	        // resuing the perspectiveMatrix here since it's no longer needed
	        var ret = invert(perspectiveMatrix, perspectiveMatrix)
	        if (!ret) return false
	        transpose(perspectiveMatrix, perspectiveMatrix)
	
	        //multiply by transposed inverse perspective matrix, into perspective vec4
	        vec4multMat4(perspective, tmpVec4, perspectiveMatrix)
	    } else { 
	        //no perspective
	        perspective[0] = perspective[1] = perspective[2] = 0
	        perspective[3] = 1
	    }
	
	    // Next take care of translation
	    translation[0] = a30
	    translation[1] = a31
	    translation[2] = a32
	
	    // Now get scale and shear. 'row' is a 3 element array of 3 component vectors
	    mat3from4(row, tmp)
	
	    // Compute X scale factor and normalize first row.
	    scale[0] = vec3.length(row[0])
	    vec3.normalize(row[0], row[0])
	
	    // Compute XY shear factor and make 2nd row orthogonal to 1st.
	    skew[0] = vec3.dot(row[0], row[1])
	    combine(row[1], row[1], row[0], 1.0, -skew[0])
	
	    // Now, compute Y scale and normalize 2nd row.
	    scale[1] = vec3.length(row[1])
	    vec3.normalize(row[1], row[1])
	    skew[0] /= scale[1]
	
	    // Compute XZ and YZ shears, orthogonalize 3rd row
	    skew[1] = vec3.dot(row[0], row[2])
	    combine(row[2], row[2], row[0], 1.0, -skew[1])
	    skew[2] = vec3.dot(row[1], row[2])
	    combine(row[2], row[2], row[1], 1.0, -skew[2])
	
	    // Next, get Z scale and normalize 3rd row.
	    scale[2] = vec3.length(row[2])
	    vec3.normalize(row[2], row[2])
	    skew[1] /= scale[2]
	    skew[2] /= scale[2]
	
	
	    // At this point, the matrix (in rows) is orthonormal.
	    // Check for a coordinate system flip.  If the determinant
	    // is -1, then negate the matrix and the scaling factors.
	    vec3.cross(pdum3, row[1], row[2])
	    if (vec3.dot(row[0], pdum3) < 0) {
	        for (var i = 0; i < 3; i++) {
	            scale[i] *= -1;
	            row[i][0] *= -1
	            row[i][1] *= -1
	            row[i][2] *= -1
	        }
	    }
	
	    // Now, get the rotations out
	    quaternion[0] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] - row[1][1] - row[2][2], 0))
	    quaternion[1] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] + row[1][1] - row[2][2], 0))
	    quaternion[2] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] - row[1][1] + row[2][2], 0))
	    quaternion[3] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] + row[1][1] + row[2][2], 0))
	
	    if (row[2][1] > row[1][2])
	        quaternion[0] = -quaternion[0]
	    if (row[0][2] > row[2][0])
	        quaternion[1] = -quaternion[1]
	    if (row[1][0] > row[0][1])
	        quaternion[2] = -quaternion[2]
	    return true
	}
	
	//will be replaced by gl-vec4 eventually
	function vec4multMat4(out, a, m) {
	    var x = a[0], y = a[1], z = a[2], w = a[3];
	    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	    return out;
	}
	
	//gets upper-left of a 4x4 matrix into a 3x3 of vectors
	function mat3from4(out, mat4x4) {
	    out[0][0] = mat4x4[0]
	    out[0][1] = mat4x4[1]
	    out[0][2] = mat4x4[2]
	    
	    out[1][0] = mat4x4[4]
	    out[1][1] = mat4x4[5]
	    out[1][2] = mat4x4[6]
	
	    out[2][0] = mat4x4[8]
	    out[2][1] = mat4x4[9]
	    out[2][2] = mat4x4[10]
	}
	
	function combine(out, a, b, scale1, scale2) {
	    out[0] = a[0] * scale1 + b[0] * scale2
	    out[1] = a[1] * scale1 + b[1] * scale2
	    out[2] = a[2] * scale1 + b[2] * scale2
	}
	},{"./normalize":430,"gl-mat4/clone":261,"gl-mat4/create":262,"gl-mat4/determinant":263,"gl-mat4/invert":267,"gl-mat4/transpose":278,"gl-vec3/cross":335,"gl-vec3/dot":340,"gl-vec3/length":350,"gl-vec3/normalize":357}],430:[function(_dereq_,module,exports){
	module.exports = function normalize(out, mat) {
	    var m44 = mat[15]
	    // Cannot normalize.
	    if (m44 === 0) 
	        return false
	    var scale = 1 / m44
	    for (var i=0; i<16; i++)
	        out[i] = mat[i] * scale
	    return true
	}
	},{}],431:[function(_dereq_,module,exports){
	var lerp = _dereq_('gl-vec3/lerp')
	
	var recompose = _dereq_('mat4-recompose')
	var decompose = _dereq_('mat4-decompose')
	var determinant = _dereq_('gl-mat4/determinant')
	var slerp = _dereq_('quat-slerp')
	
	var state0 = state()
	var state1 = state()
	var tmp = state()
	
	module.exports = interpolate
	function interpolate(out, start, end, alpha) {
	    if (determinant(start) === 0 || determinant(end) === 0)
	        return false
	
	    //decompose the start and end matrices into individual components
	    var r0 = decompose(start, state0.translate, state0.scale, state0.skew, state0.perspective, state0.quaternion)
	    var r1 = decompose(end, state1.translate, state1.scale, state1.skew, state1.perspective, state1.quaternion)
	    if (!r0 || !r1)
	        return false    
	
	
	    //now lerp/slerp the start and end components into a temporary     lerp(tmptranslate, state0.translate, state1.translate, alpha)
	    lerp(tmp.translate, state0.translate, state1.translate, alpha)
	    lerp(tmp.skew, state0.skew, state1.skew, alpha)
	    lerp(tmp.scale, state0.scale, state1.scale, alpha)
	    lerp(tmp.perspective, state0.perspective, state1.perspective, alpha)
	    slerp(tmp.quaternion, state0.quaternion, state1.quaternion, alpha)
	
	    //and recompose into our 'out' matrix
	    recompose(out, tmp.translate, tmp.scale, tmp.skew, tmp.perspective, tmp.quaternion)
	    return true
	}
	
	function state() {
	    return {
	        translate: vec3(),
	        scale: vec3(1),
	        skew: vec3(),
	        perspective: vec4(),
	        quaternion: vec4()
	    }
	}
	
	function vec3(n) {
	    return [n||0,n||0,n||0]
	}
	
	function vec4() {
	    return [0,0,0,1]
	}
	},{"gl-mat4/determinant":263,"gl-vec3/lerp":351,"mat4-decompose":429,"mat4-recompose":432,"quat-slerp":484}],432:[function(_dereq_,module,exports){
	/*
	Input:  translation ; a 3 component vector
	        scale       ; a 3 component vector
	        skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
	        perspective ; a 4 component vector
	        quaternion  ; a 4 component vector
	Output: matrix      ; a 4x4 matrix
	
	From: http://www.w3.org/TR/css3-transforms/#recomposing-to-a-3d-matrix
	*/
	
	var mat4 = {
	    identity: _dereq_('gl-mat4/identity'),
	    translate: _dereq_('gl-mat4/translate'),
	    multiply: _dereq_('gl-mat4/multiply'),
	    create: _dereq_('gl-mat4/create'),
	    scale: _dereq_('gl-mat4/scale'),
	    fromRotationTranslation: _dereq_('gl-mat4/fromRotationTranslation')
	}
	
	var rotationMatrix = mat4.create()
	var temp = mat4.create()
	
	module.exports = function recomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
	    mat4.identity(matrix)
	
	    //apply translation & rotation
	    mat4.fromRotationTranslation(matrix, quaternion, translation)
	
	    //apply perspective
	    matrix[3] = perspective[0]
	    matrix[7] = perspective[1]
	    matrix[11] = perspective[2]
	    matrix[15] = perspective[3]
	        
	    // apply skew
	    // temp is a identity 4x4 matrix initially
	    mat4.identity(temp)
	
	    if (skew[2] !== 0) {
	        temp[9] = skew[2]
	        mat4.multiply(matrix, matrix, temp)
	    }
	
	    if (skew[1] !== 0) {
	        temp[9] = 0
	        temp[8] = skew[1]
	        mat4.multiply(matrix, matrix, temp)
	    }
	
	    if (skew[0] !== 0) {
	        temp[8] = 0
	        temp[4] = skew[0]
	        mat4.multiply(matrix, matrix, temp)
	    }
	
	    //apply scale
	    mat4.scale(matrix, matrix, scale)
	    return matrix
	}
	},{"gl-mat4/create":262,"gl-mat4/fromRotationTranslation":265,"gl-mat4/identity":266,"gl-mat4/multiply":269,"gl-mat4/scale":276,"gl-mat4/translate":277}],433:[function(_dereq_,module,exports){
	'use strict';
	module.exports = Math.log2 || function (x) {
		return Math.log(x) * Math.LOG2E;
	};
	
	},{}],434:[function(_dereq_,module,exports){
	'use strict'
	
	var bsearch   = _dereq_('binary-search-bounds')
	var m4interp  = _dereq_('mat4-interpolate')
	var invert44  = _dereq_('gl-mat4/invert')
	var rotateX   = _dereq_('gl-mat4/rotateX')
	var rotateY   = _dereq_('gl-mat4/rotateY')
	var rotateZ   = _dereq_('gl-mat4/rotateZ')
	var lookAt    = _dereq_('gl-mat4/lookAt')
	var translate = _dereq_('gl-mat4/translate')
	var scale     = _dereq_('gl-mat4/scale')
	var normalize = _dereq_('gl-vec3/normalize')
	
	var DEFAULT_CENTER = [0,0,0]
	
	module.exports = createMatrixCameraController
	
	function MatrixCameraController(initialMatrix) {
	  this._components    = initialMatrix.slice()
	  this._time          = [0]
	  this.prevMatrix     = initialMatrix.slice()
	  this.nextMatrix     = initialMatrix.slice()
	  this.computedMatrix = initialMatrix.slice()
	  this.computedInverse = initialMatrix.slice()
	  this.computedEye    = [0,0,0]
	  this.computedUp     = [0,0,0]
	  this.computedCenter = [0,0,0]
	  this.computedRadius = [0]
	  this._limits        = [-Infinity, Infinity]
	}
	
	var proto = MatrixCameraController.prototype
	
	proto.recalcMatrix = function(t) {
	  var time = this._time
	  var tidx = bsearch.le(time, t)
	  var mat = this.computedMatrix
	  if(tidx < 0) {
	    return
	  }
	  var comps = this._components
	  if(tidx === time.length-1) {
	    var ptr = 16*tidx
	    for(var i=0; i<16; ++i) {
	      mat[i] = comps[ptr++]
	    }
	  } else {
	    var dt = (time[tidx+1] - time[tidx])
	    var ptr = 16*tidx
	    var prev = this.prevMatrix
	    var allEqual = true
	    for(var i=0; i<16; ++i) {
	      prev[i] = comps[ptr++]
	    }
	    var next = this.nextMatrix
	    for(var i=0; i<16; ++i) {
	      next[i] = comps[ptr++]
	      allEqual = allEqual && (prev[i] === next[i])
	    }
	    if(dt < 1e-6 || allEqual) {
	      for(var i=0; i<16; ++i) {
	        mat[i] = prev[i]
	      }
	    } else {
	      m4interp(mat, prev, next, (t - time[tidx])/dt)
	    }
	  }
	
	  var up = this.computedUp
	  up[0] = mat[1]
	  up[1] = mat[5]
	  up[2] = mat[9]
	  normalize(up, up)
	
	  var imat = this.computedInverse
	  invert44(imat, mat)
	  var eye = this.computedEye
	  var w = imat[15]
	  eye[0] = imat[12]/w
	  eye[1] = imat[13]/w
	  eye[2] = imat[14]/w
	
	  var center = this.computedCenter
	  var radius = Math.exp(this.computedRadius[0])
	  for(var i=0; i<3; ++i) {
	    center[i] = eye[i] - mat[2+4*i] * radius
	  }
	}
	
	proto.idle = function(t) {
	  if(t < this.lastT()) {
	    return
	  }
	  var mc = this._components
	  var ptr = mc.length-16
	  for(var i=0; i<16; ++i) {
	    mc.push(mc[ptr++])
	  }
	  this._time.push(t)
	}
	
	proto.flush = function(t) {
	  var idx = bsearch.gt(this._time, t) - 2
	  if(idx < 0) {
	    return
	  }
	  this._time.splice(0, idx)
	  this._components.splice(0, 16*idx)
	}
	
	proto.lastT = function() {
	  return this._time[this._time.length-1]
	}
	
	proto.lookAt = function(t, eye, center, up) {
	  this.recalcMatrix(t)
	  eye    = eye || this.computedEye
	  center = center || DEFAULT_CENTER
	  up     = up || this.computedUp
	  this.setMatrix(t, lookAt(this.computedMatrix, eye, center, up))
	  var d2 = 0.0
	  for(var i=0; i<3; ++i) {
	    d2 += Math.pow(center[i] - eye[i], 2)
	  }
	  d2 = Math.log(Math.sqrt(d2))
	  this.computedRadius[0] = d2
	}
	
	proto.rotate = function(t, yaw, pitch, roll) {
	  this.recalcMatrix(t)
	  var mat = this.computedInverse
	  if(yaw)   rotateY(mat, mat, yaw)
	  if(pitch) rotateX(mat, mat, pitch)
	  if(roll)  rotateZ(mat, mat, roll)
	  this.setMatrix(t, invert44(this.computedMatrix, mat))
	}
	
	var tvec = [0,0,0]
	
	proto.pan = function(t, dx, dy, dz) {
	  tvec[0] = -(dx || 0.0)
	  tvec[1] = -(dy || 0.0)
	  tvec[2] = -(dz || 0.0)
	  this.recalcMatrix(t)
	  var mat = this.computedInverse
	  translate(mat, mat, tvec)
	  this.setMatrix(t, invert44(mat, mat))
	}
	
	proto.translate = function(t, dx, dy, dz) {
	  tvec[0] = dx || 0.0
	  tvec[1] = dy || 0.0
	  tvec[2] = dz || 0.0
	  this.recalcMatrix(t)
	  var mat = this.computedMatrix
	  translate(mat, mat, tvec)
	  this.setMatrix(t, mat)
	}
	
	proto.setMatrix = function(t, mat) {
	  if(t < this.lastT()) {
	    return
	  }
	  this._time.push(t)
	  for(var i=0; i<16; ++i) {
	    this._components.push(mat[i])
	  }
	}
	
	proto.setDistance = function(t, d) {
	  this.computedRadius[0] = d
	}
	
	proto.setDistanceLimits = function(a,b) {
	  var lim = this._limits
	  lim[0] = a
	  lim[1] = b
	}
	
	proto.getDistanceLimits = function(out) {
	  var lim = this._limits
	  if(out) {
	    out[0] = lim[0]
	    out[1] = lim[1]
	    return out
	  }
	  return lim
	}
	
	function createMatrixCameraController(options) {
	  options = options || {}
	  var matrix = options.matrix || 
	              [1,0,0,0,
	               0,1,0,0,
	               0,0,1,0,
	               0,0,0,1]
	  return new MatrixCameraController(matrix)
	}
	
	},{"binary-search-bounds":92,"gl-mat4/invert":267,"gl-mat4/lookAt":268,"gl-mat4/rotateX":273,"gl-mat4/rotateY":274,"gl-mat4/rotateZ":275,"gl-mat4/scale":276,"gl-mat4/translate":277,"gl-vec3/normalize":357,"mat4-interpolate":431}],435:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = monotoneConvexHull2D
	
	var orient = _dereq_('robust-orientation')[3]
	
	function monotoneConvexHull2D(points) {
	  var n = points.length
	
	  if(n < 3) {
	    var result = new Array(n)
	    for(var i=0; i<n; ++i) {
	      result[i] = i
	    }
	
	    if(n === 2 &&
	       points[0][0] === points[1][0] &&
	       points[0][1] === points[1][1]) {
	      return [0]
	    }
	
	    return result
	  }
	
	  //Sort point indices along x-axis
	  var sorted = new Array(n)
	  for(var i=0; i<n; ++i) {
	    sorted[i] = i
	  }
	  sorted.sort(function(a,b) {
	    var d = points[a][0]-points[b][0]
	    if(d) {
	      return d
	    }
	    return points[a][1] - points[b][1]
	  })
	
	  //Construct upper and lower hulls
	  var lower = [sorted[0], sorted[1]]
	  var upper = [sorted[0], sorted[1]]
	
	  for(var i=2; i<n; ++i) {
	    var idx = sorted[i]
	    var p   = points[idx]
	
	    //Insert into lower list
	    var m = lower.length
	    while(m > 1 && orient(
	        points[lower[m-2]], 
	        points[lower[m-1]], 
	        p) <= 0) {
	      m -= 1
	      lower.pop()
	    }
	    lower.push(idx)
	
	    //Insert into upper list
	    m = upper.length
	    while(m > 1 && orient(
	        points[upper[m-2]], 
	        points[upper[m-1]], 
	        p) >= 0) {
	      m -= 1
	      upper.pop()
	    }
	    upper.push(idx)
	  }
	
	  //Merge lists together
	  var result = new Array(upper.length + lower.length - 2)
	  var ptr    = 0
	  for(var i=0, nl=lower.length; i<nl; ++i) {
	    result[ptr++] = lower[i]
	  }
	  for(var j=upper.length-2; j>0; --j) {
	    result[ptr++] = upper[j]
	  }
	
	  //Return result
	  return result
	}
	},{"robust-orientation":508}],436:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = mouseListen
	
	var mouse = _dereq_('mouse-event')
	
	function mouseListen (element, callback) {
	  if (!callback) {
	    callback = element
	    element = window
	  }
	
	  var buttonState = 0
	  var x = 0
	  var y = 0
	  var mods = {
	    shift: false,
	    alt: false,
	    control: false,
	    meta: false
	  }
	  var attached = false
	
	  function updateMods (ev) {
	    var changed = false
	    if ('altKey' in ev) {
	      changed = changed || ev.altKey !== mods.alt
	      mods.alt = !!ev.altKey
	    }
	    if ('shiftKey' in ev) {
	      changed = changed || ev.shiftKey !== mods.shift
	      mods.shift = !!ev.shiftKey
	    }
	    if ('ctrlKey' in ev) {
	      changed = changed || ev.ctrlKey !== mods.control
	      mods.control = !!ev.ctrlKey
	    }
	    if ('metaKey' in ev) {
	      changed = changed || ev.metaKey !== mods.meta
	      mods.meta = !!ev.metaKey
	    }
	    return changed
	  }
	
	  function handleEvent (nextButtons, ev) {
	    var nextX = mouse.x(ev)
	    var nextY = mouse.y(ev)
	    if ('buttons' in ev) {
	      nextButtons = ev.buttons | 0
	    }
	    if (nextButtons !== buttonState ||
	      nextX !== x ||
	      nextY !== y ||
	      updateMods(ev)) {
	      buttonState = nextButtons | 0
	      x = nextX || 0
	      y = nextY || 0
	      callback && callback(buttonState, x, y, mods)
	    }
	  }
	
	  function clearState (ev) {
	    handleEvent(0, ev)
	  }
	
	  function handleBlur () {
	    if (buttonState ||
	      x ||
	      y ||
	      mods.shift ||
	      mods.alt ||
	      mods.meta ||
	      mods.control) {
	      x = y = 0
	      buttonState = 0
	      mods.shift = mods.alt = mods.control = mods.meta = false
	      callback && callback(0, 0, 0, mods)
	    }
	  }
	
	  function handleMods (ev) {
	    if (updateMods(ev)) {
	      callback && callback(buttonState, x, y, mods)
	    }
	  }
	
	  function handleMouseMove (ev) {
	    if (mouse.buttons(ev) === 0) {
	      handleEvent(0, ev)
	    } else {
	      handleEvent(buttonState, ev)
	    }
	  }
	
	  function handleMouseDown (ev) {
	    handleEvent(buttonState | mouse.buttons(ev), ev)
	  }
	
	  function handleMouseUp (ev) {
	    handleEvent(buttonState & ~mouse.buttons(ev), ev)
	  }
	
	  function attachListeners () {
	    if (attached) {
	      return
	    }
	    attached = true
	
	    element.addEventListener('mousemove', handleMouseMove)
	
	    element.addEventListener('mousedown', handleMouseDown)
	
	    element.addEventListener('mouseup', handleMouseUp)
	
	    element.addEventListener('mouseleave', clearState)
	    element.addEventListener('mouseenter', clearState)
	    element.addEventListener('mouseout', clearState)
	    element.addEventListener('mouseover', clearState)
	
	    element.addEventListener('blur', handleBlur)
	
	    element.addEventListener('keyup', handleMods)
	    element.addEventListener('keydown', handleMods)
	    element.addEventListener('keypress', handleMods)
	
	    if (element !== window) {
	      window.addEventListener('blur', handleBlur)
	
	      window.addEventListener('keyup', handleMods)
	      window.addEventListener('keydown', handleMods)
	      window.addEventListener('keypress', handleMods)
	    }
	  }
	
	  function detachListeners () {
	    if (!attached) {
	      return
	    }
	    attached = false
	
	    element.removeEventListener('mousemove', handleMouseMove)
	
	    element.removeEventListener('mousedown', handleMouseDown)
	
	    element.removeEventListener('mouseup', handleMouseUp)
	
	    element.removeEventListener('mouseleave', clearState)
	    element.removeEventListener('mouseenter', clearState)
	    element.removeEventListener('mouseout', clearState)
	    element.removeEventListener('mouseover', clearState)
	
	    element.removeEventListener('blur', handleBlur)
	
	    element.removeEventListener('keyup', handleMods)
	    element.removeEventListener('keydown', handleMods)
	    element.removeEventListener('keypress', handleMods)
	
	    if (element !== window) {
	      window.removeEventListener('blur', handleBlur)
	
	      window.removeEventListener('keyup', handleMods)
	      window.removeEventListener('keydown', handleMods)
	      window.removeEventListener('keypress', handleMods)
	    }
	  }
	
	  // Attach listeners
	  attachListeners()
	
	  var result = {
	    element: element
	  }
	
	  Object.defineProperties(result, {
	    enabled: {
	      get: function () { return attached },
	      set: function (f) {
	        if (f) {
	          attachListeners()
	        } else {
	          detachListeners()
	        }
	      },
	      enumerable: true
	    },
	    buttons: {
	      get: function () { return buttonState },
	      enumerable: true
	    },
	    x: {
	      get: function () { return x },
	      enumerable: true
	    },
	    y: {
	      get: function () { return y },
	      enumerable: true
	    },
	    mods: {
	      get: function () { return mods },
	      enumerable: true
	    }
	  })
	
	  return result
	}
	
	},{"mouse-event":438}],437:[function(_dereq_,module,exports){
	var rootPosition = { left: 0, top: 0 }
	
	module.exports = mouseEventOffset
	function mouseEventOffset (ev, target, out) {
	  target = target || ev.currentTarget || ev.srcElement
	  if (!Array.isArray(out)) {
	    out = [ 0, 0 ]
	  }
	  var cx = ev.clientX || 0
	  var cy = ev.clientY || 0
	  var rect = getBoundingClientOffset(target)
	  out[0] = cx - rect.left
	  out[1] = cy - rect.top
	  return out
	}
	
	function getBoundingClientOffset (element) {
	  if (element === window ||
	      element === document ||
	      element === document.body) {
	    return rootPosition
	  } else {
	    return element.getBoundingClientRect()
	  }
	}
	
	},{}],438:[function(_dereq_,module,exports){
	'use strict'
	
	function mouseButtons(ev) {
	  if(typeof ev === 'object') {
	    if('buttons' in ev) {
	      return ev.buttons
	    } else if('which' in ev) {
	      var b = ev.which
	      if(b === 2) {
	        return 4
	      } else if(b === 3) {
	        return 2
	      } else if(b > 0) {
	        return 1<<(b-1)
	      }
	    } else if('button' in ev) {
	      var b = ev.button
	      if(b === 1) {
	        return 4
	      } else if(b === 2) {
	        return 2
	      } else if(b >= 0) {
	        return 1<<b
	      }
	    }
	  }
	  return 0
	}
	exports.buttons = mouseButtons
	
	function mouseElement(ev) {
	  return ev.target || ev.srcElement || window
	}
	exports.element = mouseElement
	
	function mouseRelativeX(ev) {
	  if(typeof ev === 'object') {
	    if('offsetX' in ev) {
	      return ev.offsetX
	    }
	    var target = mouseElement(ev)
	    var bounds = target.getBoundingClientRect()
	    return ev.clientX - bounds.left
	  }
	  return 0
	}
	exports.x = mouseRelativeX
	
	function mouseRelativeY(ev) {
	  if(typeof ev === 'object') {
	    if('offsetY' in ev) {
	      return ev.offsetY
	    }
	    var target = mouseElement(ev)
	    var bounds = target.getBoundingClientRect()
	    return ev.clientY - bounds.top
	  }
	  return 0
	}
	exports.y = mouseRelativeY
	
	},{}],439:[function(_dereq_,module,exports){
	'use strict'
	
	var toPX = _dereq_('to-px')
	
	module.exports = mouseWheelListen
	
	function mouseWheelListen(element, callback, noScroll) {
	  if(typeof element === 'function') {
	    noScroll = !!callback
	    callback = element
	    element = window
	  }
	  var lineHeight = toPX('ex', element)
	  var listener = function(ev) {
	    if(noScroll) {
	      ev.preventDefault()
	    }
	    var dx = ev.deltaX || 0
	    var dy = ev.deltaY || 0
	    var dz = ev.deltaZ || 0
	    var mode = ev.deltaMode
	    var scale = 1
	    switch(mode) {
	      case 1:
	        scale = lineHeight
	      break
	      case 2:
	        scale = window.innerHeight
	      break
	    }
	    dx *= scale
	    dy *= scale
	    dz *= scale
	    if(dx || dy || dz) {
	      return callback(dx, dy, dz, ev)
	    }
	  }
	  element.addEventListener('wheel', listener)
	  return listener
	}
	
	},{"to-px":537}],440:[function(_dereq_,module,exports){
	"use strict"
	
	var pool = _dereq_("typedarray-pool")
	
	module.exports = createSurfaceExtractor
	
	//Helper macros
	function array(i) {
	  return "a" + i
	}
	function data(i) {
	  return "d" + i
	}
	function cube(i,bitmask) {
	  return "c" + i + "_" + bitmask
	}
	function shape(i) {
	  return "s" + i
	}
	function stride(i,j) {
	  return "t" + i + "_" + j
	}
	function offset(i) {
	  return "o" + i
	}
	function scalar(i) {
	  return "x" + i
	}
	function pointer(i) {
	  return "p" + i
	}
	function delta(i,bitmask) {
	  return "d" + i + "_" + bitmask
	}
	function index(i) {
	  return "i" + i
	}
	function step(i,j) {
	  return "u" + i + "_" + j
	}
	function pcube(bitmask) {
	  return "b" + bitmask
	}
	function qcube(bitmask) {
	  return "y" + bitmask
	}
	function pdelta(bitmask) {
	  return "e" + bitmask
	}
	function vert(i) {
	  return "v" + i
	}
	var VERTEX_IDS = "V"
	var PHASES = "P"
	var VERTEX_COUNT = "N"
	var POOL_SIZE = "Q"
	var POINTER = "X"
	var TEMPORARY = "T"
	
	function permBitmask(dimension, mask, order) {
	  var r = 0
	  for(var i=0; i<dimension; ++i) {
	    if(mask & (1<<i)) {
	      r |= (1<<order[i])
	    }
	  }
	  return r
	}
	
	//Generates the surface procedure
	function compileSurfaceProcedure(vertexFunc, faceFunc, phaseFunc, scalarArgs, order, typesig) {
	  var arrayArgs = typesig.length
	  var dimension = order.length
	
	  if(dimension < 2) {
	    throw new Error("ndarray-extract-contour: Dimension must be at least 2")
	  }
	
	  var funcName = "extractContour" + order.join("_")
	  var code = []
	  var vars = []
	  var args = []
	
	  //Assemble arguments
	  for(var i=0; i<arrayArgs; ++i) {
	    args.push(array(i))  
	  }
	  for(var i=0; i<scalarArgs; ++i) {
	    args.push(scalar(i))
	  }
	
	  //Shape
	  for(var i=0; i<dimension; ++i) {
	    vars.push(shape(i) + "=" + array(0) + ".shape[" + i + "]|0")
	  }
	  //Data, stride, offset pointers
	  for(var i=0; i<arrayArgs; ++i) {
	    vars.push(data(i) + "=" + array(i) + ".data",
	              offset(i) + "=" + array(i) + ".offset|0")
	    for(var j=0; j<dimension; ++j) {
	      vars.push(stride(i,j) + "=" + array(i) + ".stride[" + j + "]|0")
	    }
	  }
	  //Pointer, delta and cube variables
	  for(var i=0; i<arrayArgs; ++i) {
	    vars.push(pointer(i) + "=" + offset(i))
	    vars.push(cube(i,0))
	    for(var j=1; j<(1<<dimension); ++j) {
	      var ptrStr = []
	      for(var k=0; k<dimension; ++k) {
	        if(j & (1<<k)) {
	          ptrStr.push("-" + stride(i,k))
	        }
	      }
	      vars.push(delta(i,j) + "=(" + ptrStr.join("") + ")|0")
	      vars.push(cube(i,j) + "=0")
	    }
	  }
	  //Create step variables
	  for(var i=0; i<arrayArgs; ++i) {
	    for(var j=0; j<dimension; ++j) {
	      var stepVal = [ stride(i,order[j]) ]
	      if(j > 0) {
	        stepVal.push(stride(i, order[j-1]) + "*" + shape(order[j-1]) )
	      }
	      vars.push(step(i,order[j]) + "=(" + stepVal.join("-") + ")|0")
	    }
	  }
	  //Create index variables
	  for(var i=0; i<dimension; ++i) {
	    vars.push(index(i) + "=0")
	  }
	  //Vertex count
	  vars.push(VERTEX_COUNT + "=0")
	  //Compute pool size, initialize pool step
	  var sizeVariable = ["2"]
	  for(var i=dimension-2; i>=0; --i) {
	    sizeVariable.push(shape(order[i]))
	  }
	  //Previous phases and vertex_ids
	  vars.push(POOL_SIZE + "=(" + sizeVariable.join("*") + ")|0",
	            PHASES + "=mallocUint32(" + POOL_SIZE + ")",
	            VERTEX_IDS + "=mallocUint32(" + POOL_SIZE + ")",
	            POINTER + "=0")
	  //Create cube variables for phases
	  vars.push(pcube(0) + "=0")
	  for(var j=1; j<(1<<dimension); ++j) {
	    var cubeDelta = []
	    var cubeStep = [ ]
	    for(var k=0; k<dimension; ++k) {
	      if(j & (1<<k)) {
	        if(cubeStep.length === 0) {
	          cubeDelta.push("1")
	        } else {
	          cubeDelta.unshift(cubeStep.join("*"))
	        }
	      }
	      cubeStep.push(shape(order[k]))
	    }
	    var signFlag = ""
	    if(cubeDelta[0].indexOf(shape(order[dimension-2])) < 0) {
	      signFlag = "-"
	    }
	    var jperm = permBitmask(dimension, j, order)
	    vars.push(pdelta(jperm) + "=(-" + cubeDelta.join("-") + ")|0",
	              qcube(jperm) + "=(" + signFlag + cubeDelta.join("-") + ")|0",
	              pcube(jperm) + "=0")
	  }
	  vars.push(vert(0) + "=0", TEMPORARY + "=0")
	
	  function forLoopBegin(i, start) {
	    code.push("for(", index(order[i]), "=", start, ";",
	      index(order[i]), "<", shape(order[i]), ";",
	      "++", index(order[i]), "){")
	  }
	
	  function forLoopEnd(i) {
	    for(var j=0; j<arrayArgs; ++j) {
	      code.push(pointer(j), "+=", step(j,order[i]), ";")
	    }
	    code.push("}")
	  }
	
	  function fillEmptySlice(k) {
	    for(var i=k-1; i>=0; --i) {
	      forLoopBegin(i, 0) 
	    }
	    var phaseFuncArgs = []
	    for(var i=0; i<arrayArgs; ++i) {
	      if(typesig[i]) {
	        phaseFuncArgs.push(data(i) + ".get(" + pointer(i) + ")")
	      } else {
	        phaseFuncArgs.push(data(i) + "[" + pointer(i) + "]")
	      }
	    }
	    for(var i=0; i<scalarArgs; ++i) {
	      phaseFuncArgs.push(scalar(i))
	    }
	    code.push(PHASES, "[", POINTER, "++]=phase(", phaseFuncArgs.join(), ");")
	    for(var i=0; i<k; ++i) {
	      forLoopEnd(i)
	    }
	    for(var j=0; j<arrayArgs; ++j) {
	      code.push(pointer(j), "+=", step(j,order[k]), ";")
	    }
	  }
	
	  function processGridCell(mask) {
	    //Read in local data
	    for(var i=0; i<arrayArgs; ++i) {
	      if(typesig[i]) {
	        code.push(cube(i,0), "=", data(i), ".get(", pointer(i), ");")
	      } else {
	        code.push(cube(i,0), "=", data(i), "[", pointer(i), "];")
	      }
	    }
	
	    //Read in phase
	    var phaseFuncArgs = []
	    for(var i=0; i<arrayArgs; ++i) {
	      phaseFuncArgs.push(cube(i,0))
	    }
	    for(var i=0; i<scalarArgs; ++i) {
	      phaseFuncArgs.push(scalar(i))
	    }
	    
	    code.push(pcube(0), "=", PHASES, "[", POINTER, "]=phase(", phaseFuncArgs.join(), ");")
	    
	    //Read in other cube data
	    for(var j=1; j<(1<<dimension); ++j) {
	      code.push(pcube(j), "=", PHASES, "[", POINTER, "+", pdelta(j), "];")
	    }
	
	    //Check for boundary crossing
	    var vertexPredicate = []
	    for(var j=1; j<(1<<dimension); ++j) {
	      vertexPredicate.push("(" + pcube(0) + "!==" + pcube(j) + ")")
	    }
	    code.push("if(", vertexPredicate.join("||"), "){")
	
	    //Read in boundary data
	    var vertexArgs = []
	    for(var i=0; i<dimension; ++i) {
	      vertexArgs.push(index(i))
	    }
	    for(var i=0; i<arrayArgs; ++i) {
	      vertexArgs.push(cube(i,0))
	      for(var j=1; j<(1<<dimension); ++j) {
	        if(typesig[i]) {
	          code.push(cube(i,j), "=", data(i), ".get(", pointer(i), "+", delta(i,j), ");")
	        } else {
	          code.push(cube(i,j), "=", data(i), "[", pointer(i), "+", delta(i,j), "];")
	        }
	        vertexArgs.push(cube(i,j))
	      }
	    }
	    for(var i=0; i<(1<<dimension); ++i) {
	      vertexArgs.push(pcube(i))
	    }
	    for(var i=0; i<scalarArgs; ++i) {
	      vertexArgs.push(scalar(i))
	    }
	
	    //Generate vertex
	    code.push("vertex(", vertexArgs.join(), ");",
	      vert(0), "=", VERTEX_IDS, "[", POINTER, "]=", VERTEX_COUNT, "++;")
	
	    //Check for face crossings
	    var base = (1<<dimension)-1
	    var corner = pcube(base)
	    for(var j=0; j<dimension; ++j) {
	      if((mask & ~(1<<j))===0) {
	        //Check face
	        var subset = base^(1<<j)
	        var edge = pcube(subset)
	        var faceArgs = [ ]
	        for(var k=subset; k>0; k=(k-1)&subset) {
	          faceArgs.push(VERTEX_IDS + "[" + POINTER + "+" + pdelta(k) + "]")
	        }
	        faceArgs.push(vert(0))
	        for(var k=0; k<arrayArgs; ++k) {
	          if(j&1) {
	            faceArgs.push(cube(k,base), cube(k,subset))
	          } else {
	            faceArgs.push(cube(k,subset), cube(k,base))
	          }
	        }
	        if(j&1) {
	          faceArgs.push(corner, edge)
	        } else {
	          faceArgs.push(edge, corner)
	        }
	        for(var k=0; k<scalarArgs; ++k) {
	          faceArgs.push(scalar(k))
	        }
	        code.push("if(", corner, "!==", edge, "){",
	          "face(", faceArgs.join(), ")}")
	      }
	    }
	    
	    //Increment pointer, close off if statement
	    code.push("}",
	      POINTER, "+=1;")
	  }
	
	  function flip() {
	    for(var j=1; j<(1<<dimension); ++j) {
	      code.push(TEMPORARY, "=", pdelta(j), ";",
	                pdelta(j), "=", qcube(j), ";",
	                qcube(j), "=", TEMPORARY, ";")
	    }
	  }
	
	  function createLoop(i, mask) {
	    if(i < 0) {
	      processGridCell(mask)
	      return
	    }
	    fillEmptySlice(i)
	    code.push("if(", shape(order[i]), ">0){",
	      index(order[i]), "=1;")
	    createLoop(i-1, mask|(1<<order[i]))
	
	    for(var j=0; j<arrayArgs; ++j) {
	      code.push(pointer(j), "+=", step(j,order[i]), ";")
	    }
	    if(i === dimension-1) {
	      code.push(POINTER, "=0;")
	      flip()
	    }
	    forLoopBegin(i, 2)
	    createLoop(i-1, mask)
	    if(i === dimension-1) {
	      code.push("if(", index(order[dimension-1]), "&1){",
	        POINTER, "=0;}")
	      flip()
	    }
	    forLoopEnd(i)
	    code.push("}")
	  }
	
	  createLoop(dimension-1, 0)
	
	  //Release scratch memory
	  code.push("freeUint32(", VERTEX_IDS, ");freeUint32(", PHASES, ");")
	
	  //Compile and link procedure
	  var procedureCode = [
	    "'use strict';",
	    "function ", funcName, "(", args.join(), "){",
	      "var ", vars.join(), ";",
	      code.join(""),
	    "}",
	    "return ", funcName ].join("")
	
	  var proc = new Function(
	    "vertex", 
	    "face", 
	    "phase", 
	    "mallocUint32", 
	    "freeUint32",
	    procedureCode)
	  return proc(
	    vertexFunc, 
	    faceFunc, 
	    phaseFunc, 
	    pool.mallocUint32, 
	    pool.freeUint32)
	}
	
	function createSurfaceExtractor(args) {
	  function error(msg) {
	    throw new Error("ndarray-extract-contour: " + msg)
	  }
	  if(typeof args !== "object") {
	    error("Must specify arguments")
	  }
	  var order = args.order
	  if(!Array.isArray(order)) {
	    error("Must specify order")
	  }
	  var arrays = args.arrayArguments||1
	  if(arrays < 1) {
	    error("Must have at least one array argument")
	  }
	  var scalars = args.scalarArguments||0
	  if(scalars < 0) {
	    error("Scalar arg count must be > 0")
	  }
	  if(typeof args.vertex !== "function") {
	    error("Must specify vertex creation function")
	  }
	  if(typeof args.cell !== "function") {
	    error("Must specify cell creation function")
	  }
	  if(typeof args.phase !== "function") {
	    error("Must specify phase function")
	  }
	  var getters = args.getters || []
	  var typesig = new Array(arrays)
	  for(var i=0; i<arrays; ++i) {
	    if(getters.indexOf(i) >= 0) {
	      typesig[i] = true
	    } else {
	      typesig[i] = false
	    }
	  }
	  return compileSurfaceProcedure(
	    args.vertex,
	    args.cell,
	    args.phase,
	    scalars,
	    order,
	    typesig)
	}
	},{"typedarray-pool":543}],441:[function(_dereq_,module,exports){
	"use strict"
	
	
	
	var fill = _dereq_('cwise/lib/wrapper')({"args":["index","array","scalar"],"pre":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"body":{"body":"{_inline_1_arg1_=_inline_1_arg2_.apply(void 0,_inline_1_arg0_)}","args":[{"name":"_inline_1_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_1_arg1_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_1_arg2_","lvalue":false,"rvalue":true,"count":1}],"thisVars":[],"localVars":[]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"debug":false,"funcName":"cwise","blockSize":64})
	
	module.exports = function(array, f) {
	  fill(array, f)
	  return array
	}
	
	},{"cwise/lib/wrapper":150}],442:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports      = gradient
	
	var dup             = _dereq_('dup')
	var cwiseCompiler   = _dereq_('cwise-compiler')
	
	var TEMPLATE_CACHE  = {}
	var GRADIENT_CACHE  = {}
	
	var EmptyProc = {
	  body: "",
	  args: [],
	  thisVars: [],
	  localVars: []
	}
	
	var centralDiff = cwiseCompiler({
	  args: [ 'array', 'array', 'array' ],
	  pre: EmptyProc,
	  post: EmptyProc,
	  body: {
	    args: [ {
	      name: 'out', 
	      lvalue: true,
	      rvalue: false,
	      count: 1
	    }, {
	      name: 'left', 
	      lvalue: false,
	      rvalue: true,
	      count: 1
	    }, {
	      name: 'right', 
	      lvalue: false,
	      rvalue: true,
	      count: 1
	    }],
	    body: "out=0.5*(left-right)",
	    thisVars: [],
	    localVars: []
	  },
	  funcName: 'cdiff'
	})
	
	var zeroOut = cwiseCompiler({
	  args: [ 'array' ],
	  pre: EmptyProc,
	  post: EmptyProc,
	  body: {
	    args: [ {
	      name: 'out', 
	      lvalue: true,
	      rvalue: false,
	      count: 1
	    }],
	    body: "out=0",
	    thisVars: [],
	    localVars: []
	  },
	  funcName: 'zero'
	})
	
	function generateTemplate(d) {
	  if(d in TEMPLATE_CACHE) {
	    return TEMPLATE_CACHE[d]
	  }
	  var code = []
	  for(var i=0; i<d; ++i) {
	    code.push('out', i, 's=0.5*(inp', i, 'l-inp', i, 'r);')
	  }
	  var args = [ 'array' ]
	  var names = ['junk']
	  for(var i=0; i<d; ++i) {
	    args.push('array')
	    names.push('out' + i + 's')
	    var o = dup(d)
	    o[i] = -1
	    args.push({
	      array: 0,
	      offset: o.slice()
	    })
	    o[i] = 1
	    args.push({
	      array: 0,
	      offset: o.slice()
	    })
	    names.push('inp' + i + 'l', 'inp' + i + 'r')
	  }
	  return TEMPLATE_CACHE[d] = cwiseCompiler({
	    args: args,
	    pre:  EmptyProc,
	    post: EmptyProc,
	    body: {
	      body: code.join(''),
	      args: names.map(function(n) {
	        return {
	          name: n,
	          lvalue: n.indexOf('out') === 0,
	          rvalue: n.indexOf('inp') === 0,
	          count: (n!=='junk')|0
	        }
	      }),
	      thisVars: [],
	      localVars: []
	    },
	    funcName: 'fdTemplate' + d
	  })
	}
	
	function generateGradient(boundaryConditions) {
	  var token = boundaryConditions.join()
	  var proc = GRADIENT_CACHE[token]
	  if(proc) {
	    return proc
	  }
	
	  var d = boundaryConditions.length
	  var code = ['function gradient(dst,src){var s=src.shape.slice();' ]
	  
	  function handleBoundary(facet) {
	    var cod = d - facet.length
	
	    var loStr = []
	    var hiStr = []
	    var pickStr = []
	    for(var i=0; i<d; ++i) {
	      if(facet.indexOf(i+1) >= 0) {
	        pickStr.push('0')
	      } else if(facet.indexOf(-(i+1)) >= 0) {
	        pickStr.push('s['+i+']-1')
	      } else {
	        pickStr.push('-1')
	        loStr.push('1')
	        hiStr.push('s['+i+']-2')
	      }
	    }
	    var boundStr = '.lo(' + loStr.join() + ').hi(' + hiStr.join() + ')'
	    if(loStr.length === 0) {
	      boundStr = ''
	    }
	        
	    if(cod > 0) {
	      code.push('if(1') 
	      for(var i=0; i<d; ++i) {
	        if(facet.indexOf(i+1) >= 0 || facet.indexOf(-(i+1)) >= 0) {
	          continue
	        }
	        code.push('&&s[', i, ']>2')
	      }
	      code.push('){grad', cod, '(src.pick(', pickStr.join(), ')', boundStr)
	      for(var i=0; i<d; ++i) {
	        if(facet.indexOf(i+1) >= 0 || facet.indexOf(-(i+1)) >= 0) {
	          continue
	        }
	        code.push(',dst.pick(', pickStr.join(), ',', i, ')', boundStr)
	      }
	      code.push(');')
	    }
	
	    for(var i=0; i<facet.length; ++i) {
	      var bnd = Math.abs(facet[i])-1
	      var outStr = 'dst.pick(' + pickStr.join() + ',' + bnd + ')' + boundStr
	      switch(boundaryConditions[bnd]) {
	
	        case 'clamp':
	          var cPickStr = pickStr.slice()
	          var dPickStr = pickStr.slice()
	          if(facet[i] < 0) {
	            cPickStr[bnd] = 's[' + bnd + ']-2'
	          } else {
	            dPickStr[bnd] = '1'
	          }
	          if(cod === 0) {
	            code.push('if(s[', bnd, ']>1){dst.set(',
	              pickStr.join(), ',', bnd, ',0.5*(src.get(',
	                cPickStr.join(), ')-src.get(',
	                dPickStr.join(), ')))}else{dst.set(',
	              pickStr.join(), ',', bnd, ',0)};')
	          } else {
	            code.push('if(s[', bnd, ']>1){diff(', outStr, 
	                ',src.pick(', cPickStr.join(), ')', boundStr, 
	                ',src.pick(', dPickStr.join(), ')', boundStr, 
	                ');}else{zero(', outStr, ');};')
	          }
	        break
	
	        case 'mirror':
	          if(cod === 0) {
	            code.push('dst.set(', pickStr.join(), ',', bnd, ',0);')
	          } else {
	            code.push('zero(', outStr, ');')
	          }
	        break
	
	        case 'wrap':
	          var aPickStr = pickStr.slice()
	          var bPickStr = pickStr.slice()
	          if(facet[i] < 0) {
	            aPickStr[bnd] = 's[' + bnd + ']-2'
	            bPickStr[bnd] = '0'
	            
	          } else {
	            aPickStr[bnd] = 's[' + bnd + ']-1'
	            bPickStr[bnd] = '1'
	          }
	          if(cod === 0) {
	            code.push('if(s[', bnd, ']>2){dst.set(',
	              pickStr.join(), ',', bnd, ',0.5*(src.get(',
	                aPickStr.join(), ')-src.get(',
	                bPickStr.join(), ')))}else{dst.set(',
	              pickStr.join(), ',', bnd, ',0)};')
	          } else {
	            code.push('if(s[', bnd, ']>2){diff(', outStr, 
	                ',src.pick(', aPickStr.join(), ')', boundStr, 
	                ',src.pick(', bPickStr.join(), ')', boundStr, 
	                ');}else{zero(', outStr, ');};')
	          }
	        break
	
	        default:
	          throw new Error('ndarray-gradient: Invalid boundary condition')
	      }
	    }
	
	    if(cod > 0) {
	      code.push('};')
	    }
	  }
	
	  //Enumerate ridges, facets, etc. of hypercube
	  for(var i=0; i<(1<<d); ++i) {
	    var faces = []
	    for(var j=0; j<d; ++j) {
	      if(i & (1<<j)) {
	        faces.push(j+1)
	      }
	    }
	    for(var k=0; k<(1<<faces.length); ++k) {
	      var sfaces = faces.slice()
	      for(var j=0; j<faces.length; ++j) {
	        if(k & (1<<j)) {
	          sfaces[j] = -sfaces[j]
	        }
	      }
	      handleBoundary(sfaces)
	    }
	  }
	
	  code.push('return dst;};return gradient')
	
	  //Compile and link routine, save cached procedure
	  var linkNames = [ 'diff', 'zero' ]
	  var linkArgs  = [ centralDiff, zeroOut ]
	  for(var i=1; i<=d; ++i) {
	    linkNames.push('grad' + i)
	    linkArgs.push(generateTemplate(i))
	  }
	  linkNames.push(code.join(''))
	
	  var link = Function.apply(void 0, linkNames)
	  var proc = link.apply(void 0, linkArgs)
	  TEMPLATE_CACHE[token] = proc
	  return proc
	}
	
	function gradient(out, inp, bc) {
	  if(Array.isArray(bc)) {
	    if(bc.length !== inp.dimension) {
	      throw new Error('ndarray-gradient: invalid boundary conditions')
	    }
	  } else if(typeof bc === 'string') {
	    bc = dup(inp.dimension, bc)
	  } else {
	    bc = dup(inp.dimension, 'clamp')
	  }
	  if(out.dimension !== inp.dimension + 1) {
	    throw new Error('ndarray-gradient: output dimension must be +1 input dimension')
	  }
	  if(out.shape[inp.dimension] !== inp.dimension) {
	    throw new Error('ndarray-gradient: output shape must match input shape')
	  }
	  for(var i=0; i<inp.dimension; ++i) {
	    if(out.shape[i] !== inp.shape[i]) {
	      throw new Error('ndarray-gradient: shape mismatch')
	    }
	  }
	  if(inp.size === 0) {
	    return out
	  }
	  if(inp.dimension <= 0) {
	    out.set(0)
	    return out
	  }
	  var cached = generateGradient(bc)
	  return cached(out, inp)
	}
	},{"cwise-compiler":147,"dup":171}],443:[function(_dereq_,module,exports){
	'use strict'
	
	var warp = _dereq_('ndarray-warp')
	var invert = _dereq_('gl-matrix-invert')
	
	module.exports = applyHomography
	
	function applyHomography(dest, src, Xi) {
	  var n = src.dimension
	  var X = invert([], Xi)
	  warp(dest, src, function(out_c, inp_c) {
	    for(var i=0; i<n; ++i) {
	      out_c[i] = X[(n+1)*n + i]
	      for(var j=0; j<n; ++j) {
	        out_c[i] += X[(n+1)*j+i] * inp_c[j]
	      }
	    }
	    var w = X[(n+1)*(n+1)-1]
	    for(var j=0; j<n; ++j) {
	      w += X[(n+1)*j+n] * inp_c[j]
	    }
	    var wr = 1.0 / w
	    for(var i=0; i<n; ++i) {
	      out_c[i] *= wr
	    }
	    return out_c
	  })
	  return dest
	}
	},{"gl-matrix-invert":279,"ndarray-warp":450}],444:[function(_dereq_,module,exports){
	"use strict"
	
	function interp1d(arr, x) {
	  var ix = Math.floor(x)
	    , fx = x - ix
	    , s0 = 0 <= ix   && ix   < arr.shape[0]
	    , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
	    , w0 = s0 ? +arr.get(ix)   : 0.0
	    , w1 = s1 ? +arr.get(ix+1) : 0.0
	  return (1.0-fx)*w0 + fx*w1
	}
	
	function interp2d(arr, x, y) {
	  var ix = Math.floor(x)
	    , fx = x - ix
	    , s0 = 0 <= ix   && ix   < arr.shape[0]
	    , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
	    , iy = Math.floor(y)
	    , fy = y - iy
	    , t0 = 0 <= iy   && iy   < arr.shape[1]
	    , t1 = 0 <= iy+1 && iy+1 < arr.shape[1]
	    , w00 = s0&&t0 ? arr.get(ix  ,iy  ) : 0.0
	    , w01 = s0&&t1 ? arr.get(ix  ,iy+1) : 0.0
	    , w10 = s1&&t0 ? arr.get(ix+1,iy  ) : 0.0
	    , w11 = s1&&t1 ? arr.get(ix+1,iy+1) : 0.0
	  return (1.0-fy) * ((1.0-fx)*w00 + fx*w10) + fy * ((1.0-fx)*w01 + fx*w11)
	}
	
	function interp3d(arr, x, y, z) {
	  var ix = Math.floor(x)
	    , fx = x - ix
	    , s0 = 0 <= ix   && ix   < arr.shape[0]
	    , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
	    , iy = Math.floor(y)
	    , fy = y - iy
	    , t0 = 0 <= iy   && iy   < arr.shape[1]
	    , t1 = 0 <= iy+1 && iy+1 < arr.shape[1]
	    , iz = Math.floor(z)
	    , fz = z - iz
	    , u0 = 0 <= iz   && iz   < arr.shape[2]
	    , u1 = 0 <= iz+1 && iz+1 < arr.shape[2]
	    , w000 = s0&&t0&&u0 ? arr.get(ix,iy,iz)       : 0.0
	    , w010 = s0&&t1&&u0 ? arr.get(ix,iy+1,iz)     : 0.0
	    , w100 = s1&&t0&&u0 ? arr.get(ix+1,iy,iz)     : 0.0
	    , w110 = s1&&t1&&u0 ? arr.get(ix+1,iy+1,iz)   : 0.0
	    , w001 = s0&&t0&&u1 ? arr.get(ix,iy,iz+1)     : 0.0
	    , w011 = s0&&t1&&u1 ? arr.get(ix,iy+1,iz+1)   : 0.0
	    , w101 = s1&&t0&&u1 ? arr.get(ix+1,iy,iz+1)   : 0.0
	    , w111 = s1&&t1&&u1 ? arr.get(ix+1,iy+1,iz+1) : 0.0
	  return (1.0-fz) * ((1.0-fy) * ((1.0-fx)*w000 + fx*w100) + fy * ((1.0-fx)*w010 + fx*w110)) + fz * ((1.0-fy) * ((1.0-fx)*w001 + fx*w101) + fy * ((1.0-fx)*w011 + fx*w111))
	}
	
	function interpNd(arr) {
	  var d = arr.shape.length|0
	    , ix = new Array(d)
	    , fx = new Array(d)
	    , s0 = new Array(d)
	    , s1 = new Array(d)
	    , i, t
	  for(i=0; i<d; ++i) {
	    t = +arguments[i+1]
	    ix[i] = Math.floor(t)
	    fx[i] = t - ix[i]
	    s0[i] = (0 <= ix[i]   && ix[i]   < arr.shape[i])
	    s1[i] = (0 <= ix[i]+1 && ix[i]+1 < arr.shape[i])
	  }
	  var r = 0.0, j, w, idx
	i_loop:
	  for(i=0; i<(1<<d); ++i) {
	    w = 1.0
	    idx = arr.offset
	    for(j=0; j<d; ++j) {
	      if(i & (1<<j)) {
	        if(!s1[j]) {
	          continue i_loop
	        }
	        w *= fx[j]
	        idx += arr.stride[j] * (ix[j] + 1)
	      } else {
	        if(!s0[j]) {
	          continue i_loop
	        }
	        w *= 1.0 - fx[j]
	        idx += arr.stride[j] * ix[j]
	      }
	    }
	    r += w * arr.data[idx]
	  }
	  return r
	}
	
	function interpolate(arr, x, y, z) {
	  switch(arr.shape.length) {
	    case 0:
	      return 0.0
	    case 1:
	      return interp1d(arr, x)
	    case 2:
	      return interp2d(arr, x, y)
	    case 3:
	      return interp3d(arr, x, y, z)
	    default:
	      return interpNd.apply(undefined, arguments)
	  }
	}
	module.exports = interpolate
	module.exports.d1 = interp1d
	module.exports.d2 = interp2d
	module.exports.d3 = interp3d
	
	},{}],445:[function(_dereq_,module,exports){
	"use strict"
	
	var compile = _dereq_("cwise-compiler")
	
	var EmptyProc = {
	  body: "",
	  args: [],
	  thisVars: [],
	  localVars: []
	}
	
	function fixup(x) {
	  if(!x) {
	    return EmptyProc
	  }
	  for(var i=0; i<x.args.length; ++i) {
	    var a = x.args[i]
	    if(i === 0) {
	      x.args[i] = {name: a, lvalue:true, rvalue: !!x.rvalue, count:x.count||1 }
	    } else {
	      x.args[i] = {name: a, lvalue:false, rvalue:true, count: 1}
	    }
	  }
	  if(!x.thisVars) {
	    x.thisVars = []
	  }
	  if(!x.localVars) {
	    x.localVars = []
	  }
	  return x
	}
	
	function pcompile(user_args) {
	  return compile({
	    args:     user_args.args,
	    pre:      fixup(user_args.pre),
	    body:     fixup(user_args.body),
	    post:     fixup(user_args.proc),
	    funcName: user_args.funcName
	  })
	}
	
	function makeOp(user_args) {
	  var args = []
	  for(var i=0; i<user_args.args.length; ++i) {
	    args.push("a"+i)
	  }
	  var wrapper = new Function("P", [
	    "return function ", user_args.funcName, "_ndarrayops(", args.join(","), ") {P(", args.join(","), ");return a0}"
	  ].join(""))
	  return wrapper(pcompile(user_args))
	}
	
	var assign_ops = {
	  add:  "+",
	  sub:  "-",
	  mul:  "*",
	  div:  "/",
	  mod:  "%",
	  band: "&",
	  bor:  "|",
	  bxor: "^",
	  lshift: "<<",
	  rshift: ">>",
	  rrshift: ">>>"
	}
	;(function(){
	  for(var id in assign_ops) {
	    var op = assign_ops[id]
	    exports[id] = makeOp({
	      args: ["array","array","array"],
	      body: {args:["a","b","c"],
	             body: "a=b"+op+"c"},
	      funcName: id
	    })
	    exports[id+"eq"] = makeOp({
	      args: ["array","array"],
	      body: {args:["a","b"],
	             body:"a"+op+"=b"},
	      rvalue: true,
	      funcName: id+"eq"
	    })
	    exports[id+"s"] = makeOp({
	      args: ["array", "array", "scalar"],
	      body: {args:["a","b","s"],
	             body:"a=b"+op+"s"},
	      funcName: id+"s"
	    })
	    exports[id+"seq"] = makeOp({
	      args: ["array","scalar"],
	      body: {args:["a","s"],
	             body:"a"+op+"=s"},
	      rvalue: true,
	      funcName: id+"seq"
	    })
	  }
	})();
	
	var unary_ops = {
	  not: "!",
	  bnot: "~",
	  neg: "-",
	  recip: "1.0/"
	}
	;(function(){
	  for(var id in unary_ops) {
	    var op = unary_ops[id]
	    exports[id] = makeOp({
	      args: ["array", "array"],
	      body: {args:["a","b"],
	             body:"a="+op+"b"},
	      funcName: id
	    })
	    exports[id+"eq"] = makeOp({
	      args: ["array"],
	      body: {args:["a"],
	             body:"a="+op+"a"},
	      rvalue: true,
	      count: 2,
	      funcName: id+"eq"
	    })
	  }
	})();
	
	var binary_ops = {
	  and: "&&",
	  or: "||",
	  eq: "===",
	  neq: "!==",
	  lt: "<",
	  gt: ">",
	  leq: "<=",
	  geq: ">="
	}
	;(function() {
	  for(var id in binary_ops) {
	    var op = binary_ops[id]
	    exports[id] = makeOp({
	      args: ["array","array","array"],
	      body: {args:["a", "b", "c"],
	             body:"a=b"+op+"c"},
	      funcName: id
	    })
	    exports[id+"s"] = makeOp({
	      args: ["array","array","scalar"],
	      body: {args:["a", "b", "s"],
	             body:"a=b"+op+"s"},
	      funcName: id+"s"
	    })
	    exports[id+"eq"] = makeOp({
	      args: ["array", "array"],
	      body: {args:["a", "b"],
	             body:"a=a"+op+"b"},
	      rvalue:true,
	      count:2,
	      funcName: id+"eq"
	    })
	    exports[id+"seq"] = makeOp({
	      args: ["array", "scalar"],
	      body: {args:["a","s"],
	             body:"a=a"+op+"s"},
	      rvalue:true,
	      count:2,
	      funcName: id+"seq"
	    })
	  }
	})();
	
	var math_unary = [
	  "abs",
	  "acos",
	  "asin",
	  "atan",
	  "ceil",
	  "cos",
	  "exp",
	  "floor",
	  "log",
	  "round",
	  "sin",
	  "sqrt",
	  "tan"
	]
	;(function() {
	  for(var i=0; i<math_unary.length; ++i) {
	    var f = math_unary[i]
	    exports[f] = makeOp({
	                    args: ["array", "array"],
	                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                    body: {args:["a","b"], body:"a=this_f(b)", thisVars:["this_f"]},
	                    funcName: f
	                  })
	    exports[f+"eq"] = makeOp({
	                      args: ["array"],
	                      pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                      body: {args: ["a"], body:"a=this_f(a)", thisVars:["this_f"]},
	                      rvalue: true,
	                      count: 2,
	                      funcName: f+"eq"
	                    })
	  }
	})();
	
	var math_comm = [
	  "max",
	  "min",
	  "atan2",
	  "pow"
	]
	;(function(){
	  for(var i=0; i<math_comm.length; ++i) {
	    var f= math_comm[i]
	    exports[f] = makeOp({
	                  args:["array", "array", "array"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b","c"], body:"a=this_f(b,c)", thisVars:["this_f"]},
	                  funcName: f
	                })
	    exports[f+"s"] = makeOp({
	                  args:["array", "array", "scalar"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b","c"], body:"a=this_f(b,c)", thisVars:["this_f"]},
	                  funcName: f+"s"
	                  })
	    exports[f+"eq"] = makeOp({ args:["array", "array"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b"], body:"a=this_f(a,b)", thisVars:["this_f"]},
	                  rvalue: true,
	                  count: 2,
	                  funcName: f+"eq"
	                  })
	    exports[f+"seq"] = makeOp({ args:["array", "scalar"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b"], body:"a=this_f(a,b)", thisVars:["this_f"]},
	                  rvalue:true,
	                  count:2,
	                  funcName: f+"seq"
	                  })
	  }
	})();
	
	var math_noncomm = [
	  "atan2",
	  "pow"
	]
	;(function(){
	  for(var i=0; i<math_noncomm.length; ++i) {
	    var f= math_noncomm[i]
	    exports[f+"op"] = makeOp({
	                  args:["array", "array", "array"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b","c"], body:"a=this_f(c,b)", thisVars:["this_f"]},
	                  funcName: f+"op"
	                })
	    exports[f+"ops"] = makeOp({
	                  args:["array", "array", "scalar"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b","c"], body:"a=this_f(c,b)", thisVars:["this_f"]},
	                  funcName: f+"ops"
	                  })
	    exports[f+"opeq"] = makeOp({ args:["array", "array"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b"], body:"a=this_f(b,a)", thisVars:["this_f"]},
	                  rvalue: true,
	                  count: 2,
	                  funcName: f+"opeq"
	                  })
	    exports[f+"opseq"] = makeOp({ args:["array", "scalar"],
	                  pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
	                  body: {args:["a","b"], body:"a=this_f(b,a)", thisVars:["this_f"]},
	                  rvalue:true,
	                  count:2,
	                  funcName: f+"opseq"
	                  })
	  }
	})();
	
	exports.any = compile({
	  args:["array"],
	  pre: EmptyProc,
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "if(a){return true}", localVars: [], thisVars: []},
	  post: {args:[], localVars:[], thisVars:[], body:"return false"},
	  funcName: "any"
	})
	
	exports.all = compile({
	  args:["array"],
	  pre: EmptyProc,
	  body: {args:[{name:"x", lvalue:false, rvalue:true, count:1}], body: "if(!x){return false}", localVars: [], thisVars: []},
	  post: {args:[], localVars:[], thisVars:[], body:"return true"},
	  funcName: "all"
	})
	
	exports.sum = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "this_s+=a", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
	  funcName: "sum"
	})
	
	exports.prod = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=1"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "this_s*=a", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
	  funcName: "prod"
	})
	
	exports.norm2squared = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:2}], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
	  funcName: "norm2squared"
	})
	  
	exports.norm2 = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:2}], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return Math.sqrt(this_s)"},
	  funcName: "norm2"
	})
	  
	
	exports.norminf = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:4}], body:"if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
	  funcName: "norminf"
	})
	
	exports.norm1 = compile({
	  args:["array"],
	  pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
	  body: {args:[{name:"a", lvalue:false, rvalue:true, count:3}], body: "this_s+=a<0?-a:a", localVars: [], thisVars: ["this_s"]},
	  post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
	  funcName: "norm1"
	})
	
	exports.sup = compile({
	  args: [ "array" ],
	  pre:
	   { body: "this_h=-Infinity",
	     args: [],
	     thisVars: [ "this_h" ],
	     localVars: [] },
	  body:
	   { body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
	     args: [{"name":"_inline_1_arg0_","lvalue":false,"rvalue":true,"count":2} ],
	     thisVars: [ "this_h" ],
	     localVars: [] },
	  post:
	   { body: "return this_h",
	     args: [],
	     thisVars: [ "this_h" ],
	     localVars: [] }
	 })
	
	exports.inf = compile({
	  args: [ "array" ],
	  pre:
	   { body: "this_h=Infinity",
	     args: [],
	     thisVars: [ "this_h" ],
	     localVars: [] },
	  body:
	   { body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
	     args: [{"name":"_inline_1_arg0_","lvalue":false,"rvalue":true,"count":2} ],
	     thisVars: [ "this_h" ],
	     localVars: [] },
	  post:
	   { body: "return this_h",
	     args: [],
	     thisVars: [ "this_h" ],
	     localVars: [] }
	 })
	
	exports.argmin = compile({
	  args:["index","array","shape"],
	  pre:{
	    body:"{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
	    args:[
	      {name:"_inline_0_arg0_",lvalue:false,rvalue:false,count:0},
	      {name:"_inline_0_arg1_",lvalue:false,rvalue:false,count:0},
	      {name:"_inline_0_arg2_",lvalue:false,rvalue:true,count:1}
	      ],
	    thisVars:["this_i","this_v"],
	    localVars:[]},
	  body:{
	    body:"{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
	    args:[
	      {name:"_inline_1_arg0_",lvalue:false,rvalue:true,count:2},
	      {name:"_inline_1_arg1_",lvalue:false,rvalue:true,count:2}],
	    thisVars:["this_i","this_v"],
	    localVars:["_inline_1_k"]},
	  post:{
	    body:"{return this_i}",
	    args:[],
	    thisVars:["this_i"],
	    localVars:[]}
	})
	
	exports.argmax = compile({
	  args:["index","array","shape"],
	  pre:{
	    body:"{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
	    args:[
	      {name:"_inline_0_arg0_",lvalue:false,rvalue:false,count:0},
	      {name:"_inline_0_arg1_",lvalue:false,rvalue:false,count:0},
	      {name:"_inline_0_arg2_",lvalue:false,rvalue:true,count:1}
	      ],
	    thisVars:["this_i","this_v"],
	    localVars:[]},
	  body:{
	    body:"{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
	    args:[
	      {name:"_inline_1_arg0_",lvalue:false,rvalue:true,count:2},
	      {name:"_inline_1_arg1_",lvalue:false,rvalue:true,count:2}],
	    thisVars:["this_i","this_v"],
	    localVars:["_inline_1_k"]},
	  post:{
	    body:"{return this_i}",
	    args:[],
	    thisVars:["this_i"],
	    localVars:[]}
	})  
	
	exports.random = makeOp({
	  args: ["array"],
	  pre: {args:[], body:"this_f=Math.random", thisVars:["this_f"]},
	  body: {args: ["a"], body:"a=this_f()", thisVars:["this_f"]},
	  funcName: "random"
	})
	
	exports.assign = makeOp({
	  args:["array", "array"],
	  body: {args:["a", "b"], body:"a=b"},
	  funcName: "assign" })
	
	exports.assigns = makeOp({
	  args:["array", "scalar"],
	  body: {args:["a", "b"], body:"a=b"},
	  funcName: "assigns" })
	
	
	exports.equals = compile({
	  args:["array", "array"],
	  pre: EmptyProc,
	  body: {args:[{name:"x", lvalue:false, rvalue:true, count:1},
	               {name:"y", lvalue:false, rvalue:true, count:1}], 
	        body: "if(x!==y){return false}", 
	        localVars: [], 
	        thisVars: []},
	  post: {args:[], localVars:[], thisVars:[], body:"return true"},
	  funcName: "equals"
	})
	
	
	
	},{"cwise-compiler":147}],446:[function(_dereq_,module,exports){
	"use strict"
	
	var ndarray = _dereq_("ndarray")
	var do_convert = _dereq_("./doConvert.js")
	
	module.exports = function convert(arr, result) {
	  var shape = [], c = arr, sz = 1
	  while(Array.isArray(c)) {
	    shape.push(c.length)
	    sz *= c.length
	    c = c[0]
	  }
	  if(shape.length === 0) {
	    return ndarray()
	  }
	  if(!result) {
	    result = ndarray(new Float64Array(sz), shape)
	  }
	  do_convert(result, arr)
	  return result
	}
	
	},{"./doConvert.js":447,"ndarray":451}],447:[function(_dereq_,module,exports){
	module.exports=_dereq_('cwise-compiler')({"args":["array","scalar","index"],"pre":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"body":{"body":"{\nvar _inline_1_v=_inline_1_arg1_,_inline_1_i\nfor(_inline_1_i=0;_inline_1_i<_inline_1_arg2_.length-1;++_inline_1_i) {\n_inline_1_v=_inline_1_v[_inline_1_arg2_[_inline_1_i]]\n}\n_inline_1_arg0_=_inline_1_v[_inline_1_arg2_[_inline_1_arg2_.length-1]]\n}","args":[{"name":"_inline_1_arg0_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_1_arg1_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_1_arg2_","lvalue":false,"rvalue":true,"count":4}],"thisVars":[],"localVars":["_inline_1_i","_inline_1_v"]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"funcName":"convert","blockSize":64})
	
	},{"cwise-compiler":147}],448:[function(_dereq_,module,exports){
	"use strict"
	
	var pool = _dereq_("typedarray-pool")
	
	var INSERTION_SORT_THRESHOLD = 32
	
	function getMallocFree(dtype) {
	  switch(dtype) {
	    case "uint8":
	      return [pool.mallocUint8, pool.freeUint8]
	    case "uint16":
	      return [pool.mallocUint16, pool.freeUint16]
	    case "uint32":
	      return [pool.mallocUint32, pool.freeUint32]
	    case "int8":
	      return [pool.mallocInt8, pool.freeInt8]
	    case "int16":
	      return [pool.mallocInt16, pool.freeInt16]
	    case "int32":
	      return [pool.mallocInt32, pool.freeInt32]
	    case "float32":
	      return [pool.mallocFloat, pool.freeFloat]
	    case "float64":
	      return [pool.mallocDouble, pool.freeDouble]
	    default:
	      return null
	  }
	}
	
	function shapeArgs(dimension) {
	  var args = []
	  for(var i=0; i<dimension; ++i) {
	    args.push("s"+i)
	  }
	  for(var i=0; i<dimension; ++i) {
	    args.push("n"+i)
	  }
	  for(var i=1; i<dimension; ++i) {
	    args.push("d"+i)
	  }
	  for(var i=1; i<dimension; ++i) {
	    args.push("e"+i)
	  }
	  for(var i=1; i<dimension; ++i) {
	    args.push("f"+i)
	  }
	  return args
	}
	
	function createInsertionSort(order, dtype) {
	
	  var code = ["'use strict'"]
	  var funcName = ["ndarrayInsertionSort", order.join("d"), dtype].join("")
	  var funcArgs = ["left", "right", "data", "offset" ].concat(shapeArgs(order.length))
	  var allocator = getMallocFree(dtype)
	  
	  var vars = [ "i,j,cptr,ptr=left*s0+offset" ]
	  
	  if(order.length > 1) {
	    var scratch_shape = []
	    for(var i=1; i<order.length; ++i) {
	      vars.push("i"+i)
	      scratch_shape.push("n"+i)
	    }
	    if(allocator) {
	      vars.push("scratch=malloc(" + scratch_shape.join("*") + ")")
	    } else {
	      vars.push("scratch=new Array("+scratch_shape.join("*") + ")")
	    }
	    vars.push("dptr","sptr","a","b")
	  } else {
	    vars.push("scratch")
	  }
	  
	  function dataRead(ptr) {
	    if(dtype === "generic") {
	      return ["data.get(", ptr, ")"].join("")
	    }
	    return ["data[",ptr,"]"].join("")
	  }
	  
	  function dataWrite(ptr, v) {
	    if(dtype === "generic") {
	      return ["data.set(", ptr, ",", v, ")"].join("")
	    }
	    return ["data[",ptr,"]=",v].join("")
	  }
	  
	  //Create function header
	  code.push(
	    ["function ", funcName, "(", funcArgs.join(","), "){var ", vars.join(",")].join(""),
	      "for(i=left+1;i<=right;++i){",
	        "j=i;ptr+=s0",
	        "cptr=ptr")
	  
	  
	  if(order.length > 1) {
	  
	    //Copy data into scratch
	    code.push("dptr=0;sptr=ptr")
	    for(var i=order.length-1; i>=0; --i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
	    }
	    code.push("scratch[dptr++]=",dataRead("sptr"))
	    for(var i=0; i<order.length; ++i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push("sptr+=d"+j,"}")
	    }
	
	    
	    //Compare items in outer loop
	    code.push("__g:while(j-->left){",
	              "dptr=0",
	              "sptr=cptr-s0")
	    for(var i=1; i<order.length; ++i) {
	      if(i === 1) {
	        code.push("__l:")
	      }
	      code.push(["for(i",i,"=0;i",i,"<n",i,";++i",i,"){"].join(""))
	    }
	    code.push(["a=", dataRead("sptr"),"\nb=scratch[dptr]\nif(a<b){break __g}\nif(a>b){break __l}"].join(""))
	    for(var i=order.length-1; i>=1; --i) {
	      code.push(
	        "sptr+=e"+i,
	        "dptr+=f"+i,
	        "}")
	    }
	    
	    //Copy data back
	    code.push("dptr=cptr;sptr=cptr-s0")
	    for(var i=order.length-1; i>=0; --i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
	    }
	    code.push(dataWrite("dptr", dataRead("sptr")))
	    for(var i=0; i<order.length; ++i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push(["dptr+=d",j,";sptr+=d",j].join(""),"}")
	    }
	    
	    //Close while loop
	    code.push("cptr-=s0\n}")
	
	    //Copy scratch into cptr
	    code.push("dptr=cptr;sptr=0")
	    for(var i=order.length-1; i>=0; --i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
	    }
	    code.push(dataWrite("dptr", "scratch[sptr++]"))
	    for(var i=0; i<order.length; ++i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push("dptr+=d"+j,"}")
	    }
	  } else {
	    code.push("scratch=" + dataRead("ptr"),
	              "while((j-->left)&&("+dataRead("cptr-s0")+">scratch)){",
	                dataWrite("cptr", dataRead("cptr-s0")),
	                "cptr-=s0",
	              "}",
	              dataWrite("cptr", "scratch"))
	  }
	  
	  //Close outer loop body
	  code.push("}")
	  if(order.length > 1 && allocator) {
	    code.push("free(scratch)")
	  }
	  code.push("} return " + funcName)
	  
	  //Compile and link function
	  if(allocator) {
	    var result = new Function("malloc", "free", code.join("\n"))
	    return result(allocator[0], allocator[1])
	  } else {
	    var result = new Function(code.join("\n"))
	    return result()
	  }
	}
	
	function createQuickSort(order, dtype, insertionSort) {
	  var code = [ "'use strict'" ]
	  var funcName = ["ndarrayQuickSort", order.join("d"), dtype].join("")
	  var funcArgs = ["left", "right", "data", "offset" ].concat(shapeArgs(order.length))
	  var allocator = getMallocFree(dtype)
	  var labelCounter=0
	  
	  code.push(["function ", funcName, "(", funcArgs.join(","), "){"].join(""))
	  
	  var vars = [
	    "sixth=((right-left+1)/6)|0",
	    "index1=left+sixth",
	    "index5=right-sixth",
	    "index3=(left+right)>>1",
	    "index2=index3-sixth",
	    "index4=index3+sixth",
	    "el1=index1",
	    "el2=index2",
	    "el3=index3",
	    "el4=index4",
	    "el5=index5",
	    "less=left+1",
	    "great=right-1",
	    "pivots_are_equal=true",
	    "tmp",
	    "tmp0",
	    "x",
	    "y",
	    "z",
	    "k",
	    "ptr0",
	    "ptr1",
	    "ptr2",
	    "comp_pivot1=0",
	    "comp_pivot2=0",
	    "comp=0"
	  ]
	  
	  if(order.length > 1) {
	    var ele_size = []
	    for(var i=1; i<order.length; ++i) {
	      ele_size.push("n"+i)
	      vars.push("i"+i)
	    }
	    for(var i=0; i<8; ++i) {
	      vars.push("b_ptr"+i)
	    }
	    vars.push(
	      "ptr3",
	      "ptr4",
	      "ptr5",
	      "ptr6",
	      "ptr7",
	      "pivot_ptr",
	      "ptr_shift",
	      "elementSize="+ele_size.join("*"))
	    if(allocator) {
	      vars.push("pivot1=malloc(elementSize)",
	                "pivot2=malloc(elementSize)")
	    } else {
	      vars.push("pivot1=new Array(elementSize),pivot2=new Array(elementSize)")
	    }
	  } else {
	    vars.push("pivot1", "pivot2")
	  }
	  
	  //Initialize local variables
	  code.push("var " + vars.join(","))
	  
	  function toPointer(v) {
	    return ["(offset+",v,"*s0)"].join("")
	  }
	  
	  function dataRead(ptr) {
	    if(dtype === "generic") {
	      return ["data.get(", ptr, ")"].join("")
	    }
	    return ["data[",ptr,"]"].join("")
	  }
	  
	  function dataWrite(ptr, v) {
	    if(dtype === "generic") {
	      return ["data.set(", ptr, ",", v, ")"].join("")
	    }
	    return ["data[",ptr,"]=",v].join("")
	  }
	  
	  function cacheLoop(ptrs, usePivot, body) {
	    if(ptrs.length === 1) {
	      code.push("ptr0="+toPointer(ptrs[0]))
	    } else {
	      for(var i=0; i<ptrs.length; ++i) {
	        code.push(["b_ptr",i,"=s0*",ptrs[i]].join(""))
	      }
	    }
	    if(usePivot) {
	      code.push("pivot_ptr=0")
	    }
	    code.push("ptr_shift=offset")
	    for(var i=order.length-1; i>=0; --i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
	    }
	    if(ptrs.length > 1) {
	      for(var i=0; i<ptrs.length; ++i) {
	        code.push(["ptr",i,"=b_ptr",i,"+ptr_shift"].join(""))
	      }
	    }
	    code.push(body)
	    if(usePivot) {
	      code.push("++pivot_ptr")
	    }
	    for(var i=0; i<order.length; ++i) {
	      var j = order[i]
	      if(j === 0) {
	        continue
	      }
	      if(ptrs.length>1) {
	        code.push("ptr_shift+=d"+j)
	      } else {
	        code.push("ptr0+=d"+j)
	      }
	      code.push("}")
	    }
	  }
	  
	  function lexicoLoop(label, ptrs, usePivot, body) {
	    if(ptrs.length === 1) {
	      code.push("ptr0="+toPointer(ptrs[0]))
	    } else {
	      for(var i=0; i<ptrs.length; ++i) {
	        code.push(["b_ptr",i,"=s0*",ptrs[i]].join(""))
	      }
	      code.push("ptr_shift=offset")
	    }
	    if(usePivot) {
	      code.push("pivot_ptr=0")
	    }
	    if(label) {
	      code.push(label+":")
	    }
	    for(var i=1; i<order.length; ++i) {
	      code.push(["for(i",i,"=0;i",i,"<n",i,";++i",i,"){"].join(""))
	    }
	    if(ptrs.length > 1) {
	      for(var i=0; i<ptrs.length; ++i) {
	        code.push(["ptr",i,"=b_ptr",i,"+ptr_shift"].join(""))
	      }
	    }
	    code.push(body)
	    for(var i=order.length-1; i>=1; --i) {
	      if(usePivot) {
	        code.push("pivot_ptr+=f"+i)
	      }
	      if(ptrs.length > 1) {
	        code.push("ptr_shift+=e"+i)
	      } else {
	        code.push("ptr0+=e"+i)
	      }
	      code.push("}")
	    }
	  }
	  
	  function cleanUp() {
	    if(order.length > 1 && allocator) {
	      code.push("free(pivot1)", "free(pivot2)")
	    }
	  }
	  
	  function compareSwap(a_id, b_id) {
	    var a = "el"+a_id
	    var b = "el"+b_id
	    if(order.length > 1) {
	      var lbl = "__l" + (++labelCounter)
	      lexicoLoop(lbl, [a, b], false, [
	        "comp=",dataRead("ptr0"),"-",dataRead("ptr1"),"\n",
	        "if(comp>0){tmp0=", a, ";",a,"=",b,";", b,"=tmp0;break ", lbl,"}\n",
	        "if(comp<0){break ", lbl, "}"
	      ].join(""))
	    } else {
	      code.push(["if(", dataRead(toPointer(a)), ">", dataRead(toPointer(b)), "){tmp0=", a, ";",a,"=",b,";", b,"=tmp0}"].join(""))
	    }
	  }
	  
	  compareSwap(1, 2)
	  compareSwap(4, 5)
	  compareSwap(1, 3)
	  compareSwap(2, 3)
	  compareSwap(1, 4)
	  compareSwap(3, 4)
	  compareSwap(2, 5)
	  compareSwap(2, 3)
	  compareSwap(4, 5)
	  
	  if(order.length > 1) {
	    cacheLoop(["el1", "el2", "el3", "el4", "el5", "index1", "index3", "index5"], true, [
	      "pivot1[pivot_ptr]=",dataRead("ptr1"),"\n",
	      "pivot2[pivot_ptr]=",dataRead("ptr3"),"\n",
	      "pivots_are_equal=pivots_are_equal&&(pivot1[pivot_ptr]===pivot2[pivot_ptr])\n",
	      "x=",dataRead("ptr0"),"\n",
	      "y=",dataRead("ptr2"),"\n",
	      "z=",dataRead("ptr4"),"\n",
	      dataWrite("ptr5", "x"),"\n",
	      dataWrite("ptr6", "y"),"\n",
	      dataWrite("ptr7", "z")
	    ].join(""))
	  } else {
	    code.push([
	      "pivot1=", dataRead(toPointer("el2")), "\n",
	      "pivot2=", dataRead(toPointer("el4")), "\n",
	      "pivots_are_equal=pivot1===pivot2\n",
	      "x=", dataRead(toPointer("el1")), "\n",
	      "y=", dataRead(toPointer("el3")), "\n",
	      "z=", dataRead(toPointer("el5")), "\n",
	      dataWrite(toPointer("index1"), "x"), "\n",
	      dataWrite(toPointer("index3"), "y"), "\n",
	      dataWrite(toPointer("index5"), "z")
	    ].join(""))
	  }
	  
	
	  function moveElement(dst, src) {
	    if(order.length > 1) {
	      cacheLoop([dst, src], false,
	        dataWrite("ptr0", dataRead("ptr1"))
	      )
	    } else {
	      code.push(dataWrite(toPointer(dst), dataRead(toPointer(src))))
	    }
	  }
	  
	  moveElement("index2", "left")
	  moveElement("index4", "right")
	  
	  function comparePivot(result, ptr, n) {
	    if(order.length > 1) {
	      var lbl = "__l" + (++labelCounter)
	      lexicoLoop(lbl, [ptr], true, [
	        result,"=",dataRead("ptr0"),"-pivot",n,"[pivot_ptr]\n",
	        "if(",result,"!==0){break ", lbl, "}"
	      ].join(""))
	    } else {
	      code.push([result,"=", dataRead(toPointer(ptr)), "-pivot", n].join(""))
	    }
	  }
	  
	  function swapElements(a, b) {
	    if(order.length > 1) {
	      cacheLoop([a,b],false,[
	        "tmp=",dataRead("ptr0"),"\n",
	        dataWrite("ptr0", dataRead("ptr1")),"\n",
	        dataWrite("ptr1", "tmp")
	      ].join(""))
	    } else {
	      code.push([
	        "ptr0=",toPointer(a),"\n",
	        "ptr1=",toPointer(b),"\n",
	        "tmp=",dataRead("ptr0"),"\n",
	        dataWrite("ptr0", dataRead("ptr1")),"\n",
	        dataWrite("ptr1", "tmp")
	      ].join(""))
	    }
	  }
	  
	  function tripleSwap(k, less, great) {
	    if(order.length > 1) {
	      cacheLoop([k,less,great], false, [
	        "tmp=",dataRead("ptr0"),"\n",
	        dataWrite("ptr0", dataRead("ptr1")),"\n",
	        dataWrite("ptr1", dataRead("ptr2")),"\n",
	        dataWrite("ptr2", "tmp")
	      ].join(""))
	      code.push("++"+less, "--"+great)
	    } else {
	      code.push([
	        "ptr0=",toPointer(k),"\n",
	        "ptr1=",toPointer(less),"\n",
	        "ptr2=",toPointer(great),"\n",
	        "++",less,"\n",
	        "--",great,"\n",
	        "tmp=", dataRead("ptr0"), "\n",
	        dataWrite("ptr0", dataRead("ptr1")), "\n",
	        dataWrite("ptr1", dataRead("ptr2")), "\n",
	        dataWrite("ptr2", "tmp")
	      ].join(""))
	    }
	  }
	  
	  function swapAndDecrement(k, great) {
	    swapElements(k, great)
	    code.push("--"+great)
	  }
	    
	  code.push("if(pivots_are_equal){")
	    //Pivots are equal case
	    code.push("for(k=less;k<=great;++k){")
	      comparePivot("comp", "k", 1)
	      code.push("if(comp===0){continue}")
	      code.push("if(comp<0){")
	        code.push("if(k!==less){")
	          swapElements("k", "less")
	        code.push("}")
	        code.push("++less")
	      code.push("}else{")
	        code.push("while(true){")
	          comparePivot("comp", "great", 1)
	          code.push("if(comp>0){")
	            code.push("great--")
	          code.push("}else if(comp<0){")
	            tripleSwap("k", "less", "great")
	            code.push("break")
	          code.push("}else{")
	            swapAndDecrement("k", "great")
	            code.push("break")
	          code.push("}")
	        code.push("}")
	      code.push("}")
	    code.push("}")
	  code.push("}else{")
	    //Pivots not equal case
	    code.push("for(k=less;k<=great;++k){")
	      comparePivot("comp_pivot1", "k", 1)
	      code.push("if(comp_pivot1<0){")
	        code.push("if(k!==less){")
	          swapElements("k", "less")
	        code.push("}")
	        code.push("++less")
	      code.push("}else{")
	        comparePivot("comp_pivot2", "k", 2)
	        code.push("if(comp_pivot2>0){")
	          code.push("while(true){")
	            comparePivot("comp", "great", 2)
	            code.push("if(comp>0){")
	              code.push("if(--great<k){break}")
	              code.push("continue")
	            code.push("}else{")
	              comparePivot("comp", "great", 1)
	              code.push("if(comp<0){")
	                tripleSwap("k", "less", "great")
	              code.push("}else{")
	                swapAndDecrement("k", "great")
	              code.push("}")
	              code.push("break")
	            code.push("}")
	          code.push("}")
	        code.push("}")
	      code.push("}")
	    code.push("}")
	  code.push("}")
	  
	  //Move pivots to correct place
	  function storePivot(mem_dest, pivot_dest, pivot) {
	    if(order.length>1) {
	      cacheLoop([mem_dest, pivot_dest], true, [
	        dataWrite("ptr0", dataRead("ptr1")), "\n",
	        dataWrite("ptr1", ["pivot",pivot,"[pivot_ptr]"].join(""))
	      ].join(""))
	    } else {
	      code.push(
	          dataWrite(toPointer(mem_dest), dataRead(toPointer(pivot_dest))),
	          dataWrite(toPointer(pivot_dest), "pivot"+pivot))
	    }
	  }
	  
	  storePivot("left", "(less-1)", 1)
	  storePivot("right", "(great+1)", 2)
	
	  //Recursive sort call
	  function doSort(left, right) {
	    code.push([
	      "if((",right,"-",left,")<=",INSERTION_SORT_THRESHOLD,"){\n",
	        "insertionSort(", left, ",", right, ",data,offset,", shapeArgs(order.length).join(","), ")\n",
	      "}else{\n",
	        funcName, "(", left, ",", right, ",data,offset,", shapeArgs(order.length).join(","), ")\n",
	      "}"
	    ].join(""))
	  }
	  doSort("left", "(less-2)")
	  doSort("(great+2)", "right")
	  
	  //If pivots are equal, then early out
	  code.push("if(pivots_are_equal){")
	    cleanUp()
	    code.push("return")
	  code.push("}")
	  
	  function walkPointer(ptr, pivot, body) {
	    if(order.length > 1) {
	      code.push(["__l",++labelCounter,":while(true){"].join(""))
	      cacheLoop([ptr], true, [
	        "if(", dataRead("ptr0"), "!==pivot", pivot, "[pivot_ptr]){break __l", labelCounter, "}"
	      ].join(""))
	      code.push(body, "}")
	    } else {
	      code.push(["while(", dataRead(toPointer(ptr)), "===pivot", pivot, "){", body, "}"].join(""))
	    }
	  }
	  
	  //Check bounds
	  code.push("if(less<index1&&great>index5){")
	  
	    walkPointer("less", 1, "++less")
	    walkPointer("great", 2, "--great")
	  
	    code.push("for(k=less;k<=great;++k){")
	      comparePivot("comp_pivot1", "k", 1)
	      code.push("if(comp_pivot1===0){")
	        code.push("if(k!==less){")
	          swapElements("k", "less")
	        code.push("}")
	        code.push("++less")
	      code.push("}else{")
	        comparePivot("comp_pivot2", "k", 2)
	        code.push("if(comp_pivot2===0){")
	          code.push("while(true){")
	            comparePivot("comp", "great", 2)
	            code.push("if(comp===0){")
	              code.push("if(--great<k){break}")
	              code.push("continue")
	            code.push("}else{")
	              comparePivot("comp", "great", 1)
	              code.push("if(comp<0){")
	                tripleSwap("k", "less", "great")
	              code.push("}else{")
	                swapAndDecrement("k", "great")
	              code.push("}")
	              code.push("break")
	            code.push("}")
	          code.push("}")
	        code.push("}")
	      code.push("}")
	    code.push("}")
	  code.push("}")
	  
	  //Clean up and do a final sorting pass
	  cleanUp()
	  doSort("less", "great")
	 
	  //Close off main loop
	  code.push("}return " + funcName)
	  
	  //Compile and link
	  if(order.length > 1 && allocator) {
	    var compiled = new Function("insertionSort", "malloc", "free", code.join("\n"))
	    return compiled(insertionSort, allocator[0], allocator[1])
	  }
	  var compiled = new Function("insertionSort", code.join("\n"))
	  return compiled(insertionSort)
	}
	
	function compileSort(order, dtype) {
	  var code = ["'use strict'"]
	  var funcName = ["ndarraySortWrapper", order.join("d"), dtype].join("")
	  var funcArgs = [ "array" ]
	  
	  code.push(["function ", funcName, "(", funcArgs.join(","), "){"].join(""))
	  
	  //Unpack local variables from array
	  var vars = ["data=array.data,offset=array.offset|0,shape=array.shape,stride=array.stride"]
	  for(var i=0; i<order.length; ++i) {
	    vars.push(["s",i,"=stride[",i,"]|0,n",i,"=shape[",i,"]|0"].join(""))
	  }
	  
	  var scratch_stride = new Array(order.length)
	  var nprod = []
	  for(var i=0; i<order.length; ++i) {
	    var k = order[i]
	    if(k === 0) {
	      continue
	    }
	    if(nprod.length === 0) {
	      scratch_stride[k] = "1"
	    } else {
	      scratch_stride[k] = nprod.join("*")
	    }
	    nprod.push("n"+k)
	  }
	  
	  var p = -1, q = -1
	  for(var i=0; i<order.length; ++i) {
	    var j = order[i]
	    if(j !== 0) {
	      if(p > 0) {
	        vars.push(["d",j,"=s",j,"-d",p,"*n",p].join(""))
	      } else {
	        vars.push(["d",j,"=s",j].join(""))
	      }
	      p = j
	    }
	    var k = order.length-1-i
	    if(k !== 0) {
	      if(q > 0) {
	        vars.push(["e",k,"=s",k,"-e",q,"*n",q,
	                  ",f",k,"=",scratch_stride[k],"-f",q,"*n",q].join(""))
	      } else {
	        vars.push(["e",k,"=s",k,",f",k,"=",scratch_stride[k]].join(""))
	      }
	      q = k
	    }
	  }
	  
	  //Declare local variables
	  code.push("var " + vars.join(","))
	  
	  //Create arguments for subroutine
	  var sortArgs = ["0", "n0-1", "data", "offset"].concat(shapeArgs(order.length))
	  
	  //Call main sorting routine
	  code.push([
	    "if(n0<=",INSERTION_SORT_THRESHOLD,"){",
	      "insertionSort(", sortArgs.join(","), ")}else{",
	      "quickSort(", sortArgs.join(","),
	    ")}"
	  ].join(""))
	  
	  //Return
	  code.push("}return " + funcName)
	  
	  //Link everything together
	  var result = new Function("insertionSort", "quickSort", code.join("\n"))
	  var insertionSort = createInsertionSort(order, dtype)
	  var quickSort = createQuickSort(order, dtype, insertionSort)
	  return result(insertionSort, quickSort)
	}
	
	module.exports = compileSort
	},{"typedarray-pool":543}],449:[function(_dereq_,module,exports){
	"use strict"
	
	var compile = _dereq_("./lib/compile_sort.js")
	var CACHE = {}
	
	function sort(array) {
	  var order = array.order
	  var dtype = array.dtype
	  var typeSig = [order, dtype ]
	  var typeName = typeSig.join(":")
	  var compiled = CACHE[typeName]
	  if(!compiled) {
	    CACHE[typeName] = compiled = compile(order, dtype)
	  }
	  compiled(array)
	  return array
	}
	
	module.exports = sort
	},{"./lib/compile_sort.js":448}],450:[function(_dereq_,module,exports){
	'use strict'
	
	var interp  = _dereq_('ndarray-linear-interpolate')
	
	
	var do_warp = _dereq_('cwise/lib/wrapper')({"args":["index","array","scalar","scalar","scalar"],"pre":{"body":"{this_warped=new Array(_inline_3_arg4_)}","args":[{"name":"_inline_3_arg0_","lvalue":false,"rvalue":false,"count":0},{"name":"_inline_3_arg1_","lvalue":false,"rvalue":false,"count":0},{"name":"_inline_3_arg2_","lvalue":false,"rvalue":false,"count":0},{"name":"_inline_3_arg3_","lvalue":false,"rvalue":false,"count":0},{"name":"_inline_3_arg4_","lvalue":false,"rvalue":true,"count":1}],"thisVars":["this_warped"],"localVars":[]},"body":{"body":"{_inline_4_arg2_(this_warped,_inline_4_arg0_),_inline_4_arg1_=_inline_4_arg3_.apply(void 0,this_warped)}","args":[{"name":"_inline_4_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_4_arg1_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_4_arg2_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_4_arg3_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_4_arg4_","lvalue":false,"rvalue":false,"count":0}],"thisVars":["this_warped"],"localVars":[]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"debug":false,"funcName":"warpND","blockSize":64})
	
	var do_warp_1 = _dereq_('cwise/lib/wrapper')({"args":["index","array","scalar","scalar","scalar"],"pre":{"body":"{this_warped=[0]}","args":[],"thisVars":["this_warped"],"localVars":[]},"body":{"body":"{_inline_7_arg2_(this_warped,_inline_7_arg0_),_inline_7_arg1_=_inline_7_arg3_(_inline_7_arg4_,this_warped[0])}","args":[{"name":"_inline_7_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_7_arg1_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_7_arg2_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_7_arg3_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_7_arg4_","lvalue":false,"rvalue":true,"count":1}],"thisVars":["this_warped"],"localVars":[]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"debug":false,"funcName":"warp1D","blockSize":64})
	
	var do_warp_2 = _dereq_('cwise/lib/wrapper')({"args":["index","array","scalar","scalar","scalar"],"pre":{"body":"{this_warped=[0,0]}","args":[],"thisVars":["this_warped"],"localVars":[]},"body":{"body":"{_inline_10_arg2_(this_warped,_inline_10_arg0_),_inline_10_arg1_=_inline_10_arg3_(_inline_10_arg4_,this_warped[0],this_warped[1])}","args":[{"name":"_inline_10_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_10_arg1_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_10_arg2_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_10_arg3_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_10_arg4_","lvalue":false,"rvalue":true,"count":1}],"thisVars":["this_warped"],"localVars":[]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"debug":false,"funcName":"warp2D","blockSize":64})
	
	var do_warp_3 = _dereq_('cwise/lib/wrapper')({"args":["index","array","scalar","scalar","scalar"],"pre":{"body":"{this_warped=[0,0,0]}","args":[],"thisVars":["this_warped"],"localVars":[]},"body":{"body":"{_inline_13_arg2_(this_warped,_inline_13_arg0_),_inline_13_arg1_=_inline_13_arg3_(_inline_13_arg4_,this_warped[0],this_warped[1],this_warped[2])}","args":[{"name":"_inline_13_arg0_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_13_arg1_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_13_arg2_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_13_arg3_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_13_arg4_","lvalue":false,"rvalue":true,"count":1}],"thisVars":["this_warped"],"localVars":[]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"debug":false,"funcName":"warp3D","blockSize":64})
	
	module.exports = function warp(dest, src, func) {
	  switch(src.shape.length) {
	    case 1:
	      do_warp_1(dest, func, interp.d1, src)
	      break
	    case 2:
	      do_warp_2(dest, func, interp.d2, src)
	      break
	    case 3:
	      do_warp_3(dest, func, interp.d3, src)
	      break
	    default:
	      do_warp(dest, func, interp.bind(undefined, src), src.shape.length)
	      break
	  }
	  return dest
	}
	
	},{"cwise/lib/wrapper":150,"ndarray-linear-interpolate":444}],451:[function(_dereq_,module,exports){
	var iota = _dereq_("iota-array")
	var isBuffer = _dereq_("is-buffer")
	
	var hasTypedArrays  = ((typeof Float64Array) !== "undefined")
	
	function compare1st(a, b) {
	  return a[0] - b[0]
	}
	
	function order() {
	  var stride = this.stride
	  var terms = new Array(stride.length)
	  var i
	  for(i=0; i<terms.length; ++i) {
	    terms[i] = [Math.abs(stride[i]), i]
	  }
	  terms.sort(compare1st)
	  var result = new Array(terms.length)
	  for(i=0; i<result.length; ++i) {
	    result[i] = terms[i][1]
	  }
	  return result
	}
	
	function compileConstructor(dtype, dimension) {
	  var className = ["View", dimension, "d", dtype].join("")
	  if(dimension < 0) {
	    className = "View_Nil" + dtype
	  }
	  var useGetters = (dtype === "generic")
	
	  if(dimension === -1) {
	    //Special case for trivial arrays
	    var code =
	      "function "+className+"(a){this.data=a;};\
	var proto="+className+".prototype;\
	proto.dtype='"+dtype+"';\
	proto.index=function(){return -1};\
	proto.size=0;\
	proto.dimension=-1;\
	proto.shape=proto.stride=proto.order=[];\
	proto.lo=proto.hi=proto.transpose=proto.step=\
	function(){return new "+className+"(this.data);};\
	proto.get=proto.set=function(){};\
	proto.pick=function(){return null};\
	return function construct_"+className+"(a){return new "+className+"(a);}"
	    var procedure = new Function(code)
	    return procedure()
	  } else if(dimension === 0) {
	    //Special case for 0d arrays
	    var code =
	      "function "+className+"(a,d) {\
	this.data = a;\
	this.offset = d\
	};\
	var proto="+className+".prototype;\
	proto.dtype='"+dtype+"';\
	proto.index=function(){return this.offset};\
	proto.dimension=0;\
	proto.size=1;\
	proto.shape=\
	proto.stride=\
	proto.order=[];\
	proto.lo=\
	proto.hi=\
	proto.transpose=\
	proto.step=function "+className+"_copy() {\
	return new "+className+"(this.data,this.offset)\
	};\
	proto.pick=function "+className+"_pick(){\
	return TrivialArray(this.data);\
	};\
	proto.valueOf=proto.get=function "+className+"_get(){\
	return "+(useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]")+
	"};\
	proto.set=function "+className+"_set(v){\
	return "+(useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v")+"\
	};\
	return function construct_"+className+"(a,b,c,d){return new "+className+"(a,d)}"
	    var procedure = new Function("TrivialArray", code)
	    return procedure(CACHED_CONSTRUCTORS[dtype][0])
	  }
	
	  var code = ["'use strict'"]
	
	  //Create constructor for view
	  var indices = iota(dimension)
	  var args = indices.map(function(i) { return "i"+i })
	  var index_str = "this.offset+" + indices.map(function(i) {
	        return "this.stride[" + i + "]*i" + i
	      }).join("+")
	  var shapeArg = indices.map(function(i) {
	      return "b"+i
	    }).join(",")
	  var strideArg = indices.map(function(i) {
	      return "c"+i
	    }).join(",")
	  code.push(
	    "function "+className+"(a," + shapeArg + "," + strideArg + ",d){this.data=a",
	      "this.shape=[" + shapeArg + "]",
	      "this.stride=[" + strideArg + "]",
	      "this.offset=d|0}",
	    "var proto="+className+".prototype",
	    "proto.dtype='"+dtype+"'",
	    "proto.dimension="+dimension)
	
	  //view.size:
	  code.push("Object.defineProperty(proto,'size',{get:function "+className+"_size(){\
	return "+indices.map(function(i) { return "this.shape["+i+"]" }).join("*"),
	"}})")
	
	  //view.order:
	  if(dimension === 1) {
	    code.push("proto.order=[0]")
	  } else {
	    code.push("Object.defineProperty(proto,'order',{get:")
	    if(dimension < 4) {
	      code.push("function "+className+"_order(){")
	      if(dimension === 2) {
	        code.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})")
	      } else if(dimension === 3) {
	        code.push(
	"var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);\
	if(s0>s1){\
	if(s1>s2){\
	return [2,1,0];\
	}else if(s0>s2){\
	return [1,2,0];\
	}else{\
	return [1,0,2];\
	}\
	}else if(s0>s2){\
	return [2,0,1];\
	}else if(s2>s1){\
	return [0,1,2];\
	}else{\
	return [0,2,1];\
	}}})")
	      }
	    } else {
	      code.push("ORDER})")
	    }
	  }
	
	  //view.set(i0, ..., v):
	  code.push(
	"proto.set=function "+className+"_set("+args.join(",")+",v){")
	  if(useGetters) {
	    code.push("return this.data.set("+index_str+",v)}")
	  } else {
	    code.push("return this.data["+index_str+"]=v}")
	  }
	
	  //view.get(i0, ...):
	  code.push("proto.get=function "+className+"_get("+args.join(",")+"){")
	  if(useGetters) {
	    code.push("return this.data.get("+index_str+")}")
	  } else {
	    code.push("return this.data["+index_str+"]}")
	  }
	
	  //view.index:
	  code.push(
	    "proto.index=function "+className+"_index(", args.join(), "){return "+index_str+"}")
	
	  //view.hi():
	  code.push("proto.hi=function "+className+"_hi("+args.join(",")+"){return new "+className+"(this.data,"+
	    indices.map(function(i) {
	      return ["(typeof i",i,"!=='number'||i",i,"<0)?this.shape[", i, "]:i", i,"|0"].join("")
	    }).join(",")+","+
	    indices.map(function(i) {
	      return "this.stride["+i + "]"
	    }).join(",")+",this.offset)}")
	
	  //view.lo():
	  var a_vars = indices.map(function(i) { return "a"+i+"=this.shape["+i+"]" })
	  var c_vars = indices.map(function(i) { return "c"+i+"=this.stride["+i+"]" })
	  code.push("proto.lo=function "+className+"_lo("+args.join(",")+"){var b=this.offset,d=0,"+a_vars.join(",")+","+c_vars.join(","))
	  for(var i=0; i<dimension; ++i) {
	    code.push(
	"if(typeof i"+i+"==='number'&&i"+i+">=0){\
	d=i"+i+"|0;\
	b+=c"+i+"*d;\
	a"+i+"-=d}")
	  }
	  code.push("return new "+className+"(this.data,"+
	    indices.map(function(i) {
	      return "a"+i
	    }).join(",")+","+
	    indices.map(function(i) {
	      return "c"+i
	    }).join(",")+",b)}")
	
	  //view.step():
	  code.push("proto.step=function "+className+"_step("+args.join(",")+"){var "+
	    indices.map(function(i) {
	      return "a"+i+"=this.shape["+i+"]"
	    }).join(",")+","+
	    indices.map(function(i) {
	      return "b"+i+"=this.stride["+i+"]"
	    }).join(",")+",c=this.offset,d=0,ceil=Math.ceil")
	  for(var i=0; i<dimension; ++i) {
	    code.push(
	"if(typeof i"+i+"==='number'){\
	d=i"+i+"|0;\
	if(d<0){\
	c+=b"+i+"*(a"+i+"-1);\
	a"+i+"=ceil(-a"+i+"/d)\
	}else{\
	a"+i+"=ceil(a"+i+"/d)\
	}\
	b"+i+"*=d\
	}")
	  }
	  code.push("return new "+className+"(this.data,"+
	    indices.map(function(i) {
	      return "a" + i
	    }).join(",")+","+
	    indices.map(function(i) {
	      return "b" + i
	    }).join(",")+",c)}")
	
	  //view.transpose():
	  var tShape = new Array(dimension)
	  var tStride = new Array(dimension)
	  for(var i=0; i<dimension; ++i) {
	    tShape[i] = "a[i"+i+"]"
	    tStride[i] = "b[i"+i+"]"
	  }
	  code.push("proto.transpose=function "+className+"_transpose("+args+"){"+
	    args.map(function(n,idx) { return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)"}).join(";"),
	    "var a=this.shape,b=this.stride;return new "+className+"(this.data,"+tShape.join(",")+","+tStride.join(",")+",this.offset)}")
	
	  //view.pick():
	  code.push("proto.pick=function "+className+"_pick("+args+"){var a=[],b=[],c=this.offset")
	  for(var i=0; i<dimension; ++i) {
	    code.push("if(typeof i"+i+"==='number'&&i"+i+">=0){c=(c+this.stride["+i+"]*i"+i+")|0}else{a.push(this.shape["+i+"]);b.push(this.stride["+i+"])}")
	  }
	  code.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}")
	
	  //Add return statement
	  code.push("return function construct_"+className+"(data,shape,stride,offset){return new "+className+"(data,"+
	    indices.map(function(i) {
	      return "shape["+i+"]"
	    }).join(",")+","+
	    indices.map(function(i) {
	      return "stride["+i+"]"
	    }).join(",")+",offset)}")
	
	  //Compile procedure
	  var procedure = new Function("CTOR_LIST", "ORDER", code.join("\n"))
	  return procedure(CACHED_CONSTRUCTORS[dtype], order)
	}
	
	function arrayDType(data) {
	  if(isBuffer(data)) {
	    return "buffer"
	  }
	  if(hasTypedArrays) {
	    switch(Object.prototype.toString.call(data)) {
	      case "[object Float64Array]":
	        return "float64"
	      case "[object Float32Array]":
	        return "float32"
	      case "[object Int8Array]":
	        return "int8"
	      case "[object Int16Array]":
	        return "int16"
	      case "[object Int32Array]":
	        return "int32"
	      case "[object Uint8Array]":
	        return "uint8"
	      case "[object Uint16Array]":
	        return "uint16"
	      case "[object Uint32Array]":
	        return "uint32"
	      case "[object Uint8ClampedArray]":
	        return "uint8_clamped"
	    }
	  }
	  if(Array.isArray(data)) {
	    return "array"
	  }
	  return "generic"
	}
	
	var CACHED_CONSTRUCTORS = {
	  "float32":[],
	  "float64":[],
	  "int8":[],
	  "int16":[],
	  "int32":[],
	  "uint8":[],
	  "uint16":[],
	  "uint32":[],
	  "array":[],
	  "uint8_clamped":[],
	  "buffer":[],
	  "generic":[]
	}
	
	;(function() {
	  for(var id in CACHED_CONSTRUCTORS) {
	    CACHED_CONSTRUCTORS[id].push(compileConstructor(id, -1))
	  }
	});
	
	function wrappedNDArrayCtor(data, shape, stride, offset) {
	  if(data === undefined) {
	    var ctor = CACHED_CONSTRUCTORS.array[0]
	    return ctor([])
	  } else if(typeof data === "number") {
	    data = [data]
	  }
	  if(shape === undefined) {
	    shape = [ data.length ]
	  }
	  var d = shape.length
	  if(stride === undefined) {
	    stride = new Array(d)
	    for(var i=d-1, sz=1; i>=0; --i) {
	      stride[i] = sz
	      sz *= shape[i]
	    }
	  }
	  if(offset === undefined) {
	    offset = 0
	    for(var i=0; i<d; ++i) {
	      if(stride[i] < 0) {
	        offset -= (shape[i]-1)*stride[i]
	      }
	    }
	  }
	  var dtype = arrayDType(data)
	  var ctor_list = CACHED_CONSTRUCTORS[dtype]
	  while(ctor_list.length <= d+1) {
	    ctor_list.push(compileConstructor(dtype, ctor_list.length-1))
	  }
	  var ctor = ctor_list[d+1]
	  return ctor(data, shape, stride, offset)
	}
	
	module.exports = wrappedNDArrayCtor
	
	},{"iota-array":417,"is-buffer":419}],452:[function(_dereq_,module,exports){
	"use strict"
	
	var doubleBits = _dereq_("double-bits")
	
	var SMALLEST_DENORM = Math.pow(2, -1074)
	var UINT_MAX = (-1)>>>0
	
	module.exports = nextafter
	
	function nextafter(x, y) {
	  if(isNaN(x) || isNaN(y)) {
	    return NaN
	  }
	  if(x === y) {
	    return x
	  }
	  if(x === 0) {
	    if(y < 0) {
	      return -SMALLEST_DENORM
	    } else {
	      return SMALLEST_DENORM
	    }
	  }
	  var hi = doubleBits.hi(x)
	  var lo = doubleBits.lo(x)
	  if((y > x) === (x > 0)) {
	    if(lo === UINT_MAX) {
	      hi += 1
	      lo = 0
	    } else {
	      lo += 1
	    }
	  } else {
	    if(lo === 0) {
	      lo = UINT_MAX
	      hi -= 1
	    } else {
	      lo -= 1
	    }
	  }
	  return doubleBits.pack(lo, hi)
	}
	},{"double-bits":168}],453:[function(_dereq_,module,exports){
	
	var π = Math.PI
	var _120 = radians(120)
	
	module.exports = normalize
	
	/**
	 * describe `path` in terms of cubic bézier 
	 * curves and move commands
	 *
	 * @param {Array} path
	 * @return {Array}
	 */
	
	function normalize(path){
		// init state
		var prev
		var result = []
		var bezierX = 0
		var bezierY = 0
		var startX = 0
		var startY = 0
		var quadX = null
		var quadY = null
		var x = 0
		var y = 0
	
		for (var i = 0, len = path.length; i < len; i++) {
			var seg = path[i]
			var command = seg[0]
			switch (command) {
				case 'M':
					startX = seg[1]
					startY = seg[2]
					break
				case 'A':
					seg = arc(x, y,seg[1],seg[2],radians(seg[3]),seg[4],seg[5],seg[6],seg[7])
					// split multi part
					seg.unshift('C')
					if (seg.length > 7) {
						result.push(seg.splice(0, 7))
						seg.unshift('C')
					}
					break
				case 'S':
					// default control point
					var cx = x
					var cy = y
					if (prev == 'C' || prev == 'S') {
						cx += cx - bezierX // reflect the previous command's control
						cy += cy - bezierY // point relative to the current point
					}
					seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
					break
				case 'T':
					if (prev == 'Q' || prev == 'T') {
						quadX = x * 2 - quadX // as with 'S' reflect previous control point
						quadY = y * 2 - quadY
					} else {
						quadX = x
						quadY = y
					}
					seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
					break
				case 'Q':
					quadX = seg[1]
					quadY = seg[2]
					seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
					break
				case 'L':
					seg = line(x, y, seg[1], seg[2])
					break
				case 'H':
					seg = line(x, y, seg[1], y)
					break
				case 'V':
					seg = line(x, y, x, seg[1])
					break
				case 'Z':
					seg = line(x, y, startX, startY)
					break
			}
	
			// update state
			prev = command
			x = seg[seg.length - 2]
			y = seg[seg.length - 1]
			if (seg.length > 4) {
				bezierX = seg[seg.length - 4]
				bezierY = seg[seg.length - 3]
			} else {
				bezierX = x
				bezierY = y
			}
			result.push(seg)
		}
	
		return result
	}
	
	function line(x1, y1, x2, y2){
		return ['C', x1, y1, x2, y2, x2, y2]
	}
	
	function quadratic(x1, y1, cx, cy, x2, y2){
		return [
			'C',
			x1/3 + (2/3) * cx,
			y1/3 + (2/3) * cy,
			x2/3 + (2/3) * cx,
			y2/3 + (2/3) * cy,
			x2,
			y2
		]
	}
	
	// This function is ripped from 
	// github.com/DmitryBaranovskiy/raphael/blob/4d97d4/raphael.js#L2216-L2304 
	// which references w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	// TODO: make it human readable
	
	function arc(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
		if (!recursive) {
			var xy = rotate(x1, y1, -angle)
			x1 = xy.x
			y1 = xy.y
			xy = rotate(x2, y2, -angle)
			x2 = xy.x
			y2 = xy.y
			var x = (x1 - x2) / 2
			var y = (y1 - y2) / 2
			var h = (x * x) / (rx * rx) + (y * y) / (ry * ry)
			if (h > 1) {
				h = Math.sqrt(h)
				rx = h * rx
				ry = h * ry
			}
			var rx2 = rx * rx
			var ry2 = ry * ry
			var k = (large_arc_flag == sweep_flag ? -1 : 1)
				* Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)))
			if (k == Infinity) k = 1 // neutralize
			var cx = k * rx * y / ry + (x1 + x2) / 2
			var cy = k * -ry * x / rx + (y1 + y2) / 2
			var f1 = Math.asin(((y1 - cy) / ry).toFixed(9))
			var f2 = Math.asin(((y2 - cy) / ry).toFixed(9))
	
			f1 = x1 < cx ? π - f1 : f1
			f2 = x2 < cx ? π - f2 : f2
			if (f1 < 0) f1 = π * 2 + f1
			if (f2 < 0) f2 = π * 2 + f2
			if (sweep_flag && f1 > f2) f1 = f1 - π * 2
			if (!sweep_flag && f2 > f1) f2 = f2 - π * 2
		} else {
			f1 = recursive[0]
			f2 = recursive[1]
			cx = recursive[2]
			cy = recursive[3]
		}
		// greater than 120 degrees requires multiple segments
		if (Math.abs(f2 - f1) > _120) {
			var f2old = f2
			var x2old = x2
			var y2old = y2
			f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1)
			x2 = cx + rx * Math.cos(f2)
			y2 = cy + ry * Math.sin(f2)
			var res = arc(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy])
		}
		var t = Math.tan((f2 - f1) / 4)
		var hx = 4 / 3 * rx * t
		var hy = 4 / 3 * ry * t
		var curve = [
			2 * x1 - (x1 + hx * Math.sin(f1)),
			2 * y1 - (y1 - hy * Math.cos(f1)),
			x2 + hx * Math.sin(f2),
			y2 - hy * Math.cos(f2),
			x2,
			y2
		]
		if (recursive) return curve
		if (res) curve = curve.concat(res)
		for (var i = 0; i < curve.length;) {
			var rot = rotate(curve[i], curve[i+1], angle)
			curve[i++] = rot.x
			curve[i++] = rot.y
		}
		return curve
	}
	
	function rotate(x, y, rad){
		return {
			x: x * Math.cos(rad) - y * Math.sin(rad),
			y: x * Math.sin(rad) + y * Math.cos(rad)
		}
	}
	
	function radians(degress){
		return degress * (π / 180)
	}
	
	},{}],454:[function(_dereq_,module,exports){
	var DEFAULT_NORMALS_EPSILON = 1e-6;
	var DEFAULT_FACE_EPSILON = 1e-6;
	
	//Estimate the vertex normals of a mesh
	exports.vertexNormals = function(faces, positions, specifiedEpsilon) {
	
	  var N         = positions.length;
	  var normals   = new Array(N);
	  var epsilon   = specifiedEpsilon === void(0) ? DEFAULT_NORMALS_EPSILON : specifiedEpsilon;
	
	  //Initialize normal array
	  for(var i=0; i<N; ++i) {
	    normals[i] = [0.0, 0.0, 0.0];
	  }
	
	  //Walk over all the faces and add per-vertex contribution to normal weights
	  for(var i=0; i<faces.length; ++i) {
	    var f = faces[i];
	    var p = 0;
	    var c = f[f.length-1];
	    var n = f[0];
	    for(var j=0; j<f.length; ++j) {
	
	      //Shift indices back
	      p = c;
	      c = n;
	      n = f[(j+1) % f.length];
	
	      var v0 = positions[p];
	      var v1 = positions[c];
	      var v2 = positions[n];
	
	      //Compute infineteismal arcs
	      var d01 = new Array(3);
	      var m01 = 0.0;
	      var d21 = new Array(3);
	      var m21 = 0.0;
	      for(var k=0; k<3; ++k) {
	        d01[k] = v0[k]  - v1[k];
	        m01   += d01[k] * d01[k];
	        d21[k] = v2[k]  - v1[k];
	        m21   += d21[k] * d21[k];
	      }
	
	      //Accumulate values in normal
	      if(m01 * m21 > epsilon) {
	        var norm = normals[c];
	        var w = 1.0 / Math.sqrt(m01 * m21);
	        for(var k=0; k<3; ++k) {
	          var u = (k+1)%3;
	          var v = (k+2)%3;
	          norm[k] += w * (d21[u] * d01[v] - d21[v] * d01[u]);
	        }
	      }
	    }
	  }
	
	  //Scale all normals to unit length
	  for(var i=0; i<N; ++i) {
	    var norm = normals[i];
	    var m = 0.0;
	    for(var k=0; k<3; ++k) {
	      m += norm[k] * norm[k];
	    }
	    if(m > epsilon) {
	      var w = 1.0 / Math.sqrt(m);
	      for(var k=0; k<3; ++k) {
	        norm[k] *= w;
	      }
	    } else {
	      for(var k=0; k<3; ++k) {
	        norm[k] = 0.0;
	      }
	    }
	  }
	
	  //Return the resulting set of patches
	  return normals;
	}
	
	//Compute face normals of a mesh
	exports.faceNormals = function(faces, positions, specifiedEpsilon) {
	
	  var N         = faces.length;
	  var normals   = new Array(N);
	  var epsilon   = specifiedEpsilon === void(0) ? DEFAULT_FACE_EPSILON : specifiedEpsilon;
	
	  for(var i=0; i<N; ++i) {
	    var f = faces[i];
	    var pos = new Array(3);
	    for(var j=0; j<3; ++j) {
	      pos[j] = positions[f[j]];
	    }
	
	    var d01 = new Array(3);
	    var d21 = new Array(3);
	    for(var j=0; j<3; ++j) {
	      d01[j] = pos[1][j] - pos[0][j];
	      d21[j] = pos[2][j] - pos[0][j];
	    }
	
	    var n = new Array(3);
	    var l = 0.0;
	    for(var j=0; j<3; ++j) {
	      var u = (j+1)%3;
	      var v = (j+2)%3;
	      n[j] = d01[u] * d21[v] - d01[v] * d21[u];
	      l += n[j] * n[j];
	    }
	    if(l > epsilon) {
	      l = 1.0 / Math.sqrt(l);
	    } else {
	      l = 0.0;
	    }
	    for(var j=0; j<3; ++j) {
	      n[j] *= l;
	    }
	    normals[i] = n;
	  }
	  return normals;
	}
	
	
	
	},{}],455:[function(_dereq_,module,exports){
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	},{}],456:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = quatFromFrame
	
	function quatFromFrame(
	  out,
	  rx, ry, rz,
	  ux, uy, uz,
	  fx, fy, fz) {
	  var tr = rx + uy + fz
	  if(l > 0) {
	    var l = Math.sqrt(tr + 1.0)
	    out[0] = 0.5 * (uz - fy) / l
	    out[1] = 0.5 * (fx - rz) / l
	    out[2] = 0.5 * (ry - uy) / l
	    out[3] = 0.5 * l
	  } else {
	    var tf = Math.max(rx, uy, fz)
	    var l = Math.sqrt(2 * tf - tr + 1.0)
	    if(rx >= tf) {
	      //x y z  order
	      out[0] = 0.5 * l
	      out[1] = 0.5 * (ux + ry) / l
	      out[2] = 0.5 * (fx + rz) / l
	      out[3] = 0.5 * (uz - fy) / l
	    } else if(uy >= tf) {
	      //y z x  order
	      out[0] = 0.5 * (ry + ux) / l
	      out[1] = 0.5 * l
	      out[2] = 0.5 * (fy + uz) / l
	      out[3] = 0.5 * (fx - rz) / l
	    } else {
	      //z x y  order
	      out[0] = 0.5 * (rz + fx) / l
	      out[1] = 0.5 * (uz + fy) / l
	      out[2] = 0.5 * l
	      out[3] = 0.5 * (ry - ux) / l
	    }
	  }
	  return out
	}
	},{}],457:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createOrbitController
	
	var filterVector  = _dereq_('filtered-vector')
	var lookAt        = _dereq_('gl-mat4/lookAt')
	var mat4FromQuat  = _dereq_('gl-mat4/fromQuat')
	var invert44      = _dereq_('gl-mat4/invert')
	var quatFromFrame = _dereq_('./lib/quatFromFrame')
	
	function len3(x,y,z) {
	  return Math.sqrt(Math.pow(x,2) + Math.pow(y,2) + Math.pow(z,2))
	}
	
	function len4(w,x,y,z) {
	  return Math.sqrt(Math.pow(w,2) + Math.pow(x,2) + Math.pow(y,2) + Math.pow(z,2))
	}
	
	function normalize4(out, a) {
	  var ax = a[0]
	  var ay = a[1]
	  var az = a[2]
	  var aw = a[3]
	  var al = len4(ax, ay, az, aw)
	  if(al > 1e-6) {
	    out[0] = ax/al
	    out[1] = ay/al
	    out[2] = az/al
	    out[3] = aw/al
	  } else {
	    out[0] = out[1] = out[2] = 0.0
	    out[3] = 1.0
	  }
	}
	
	function OrbitCameraController(initQuat, initCenter, initRadius) {
	  this.radius    = filterVector([initRadius])
	  this.center    = filterVector(initCenter)
	  this.rotation  = filterVector(initQuat)
	
	  this.computedRadius   = this.radius.curve(0)
	  this.computedCenter   = this.center.curve(0)
	  this.computedRotation = this.rotation.curve(0)
	  this.computedUp       = [0.1,0,0]
	  this.computedEye      = [0.1,0,0]
	  this.computedMatrix   = [0.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
	
	  this.recalcMatrix(0)
	}
	
	var proto = OrbitCameraController.prototype
	
	proto.lastT = function() {
	  return Math.max(
	    this.radius.lastT(),
	    this.center.lastT(),
	    this.rotation.lastT())
	}
	
	proto.recalcMatrix = function(t) {
	  this.radius.curve(t)
	  this.center.curve(t)
	  this.rotation.curve(t)
	
	  var quat = this.computedRotation
	  normalize4(quat, quat)
	
	  var mat = this.computedMatrix
	  mat4FromQuat(mat, quat)
	
	  var center = this.computedCenter
	  var eye    = this.computedEye
	  var up     = this.computedUp
	  var radius = Math.exp(this.computedRadius[0])
	
	  eye[0] = center[0] + radius * mat[2]
	  eye[1] = center[1] + radius * mat[6]
	  eye[2] = center[2] + radius * mat[10]
	  up[0] = mat[1]
	  up[1] = mat[5]
	  up[2] = mat[9]
	
	  for(var i=0; i<3; ++i) {
	    var rr = 0.0
	    for(var j=0; j<3; ++j) {
	      rr += mat[i+4*j] * eye[j]
	    }
	    mat[12+i] = -rr
	  }
	}
	
	proto.getMatrix = function(t, result) {
	  this.recalcMatrix(t)
	  var m = this.computedMatrix
	  if(result) {
	    for(var i=0; i<16; ++i) {
	      result[i] = m[i]
	    }
	    return result
	  }
	  return m
	}
	
	proto.idle = function(t) {
	  this.center.idle(t)
	  this.radius.idle(t)
	  this.rotation.idle(t)
	}
	
	proto.flush = function(t) {
	  this.center.flush(t)
	  this.radius.flush(t)
	  this.rotation.flush(t)
	}
	
	proto.pan = function(t, dx, dy, dz) {
	  dx = dx || 0.0
	  dy = dy || 0.0
	  dz = dz || 0.0
	
	  this.recalcMatrix(t)
	  var mat = this.computedMatrix
	
	  var ux = mat[1]
	  var uy = mat[5]
	  var uz = mat[9]
	  var ul = len3(ux, uy, uz)
	  ux /= ul
	  uy /= ul
	  uz /= ul
	
	  var rx = mat[0]
	  var ry = mat[4]
	  var rz = mat[8]
	  var ru = rx * ux + ry * uy + rz * uz
	  rx -= ux * ru
	  ry -= uy * ru
	  rz -= uz * ru
	  var rl = len3(rx, ry, rz)
	  rx /= rl
	  ry /= rl
	  rz /= rl
	
	  var fx = mat[2]
	  var fy = mat[6]
	  var fz = mat[10]
	  var fu = fx * ux + fy * uy + fz * uz
	  var fr = fx * rx + fy * ry + fz * rz
	  fx -= fu * ux + fr * rx
	  fy -= fu * uy + fr * ry
	  fz -= fu * uz + fr * rz
	  var fl = len3(fx, fy, fz)
	  fx /= fl
	  fy /= fl
	  fz /= fl
	
	  var vx = rx * dx + ux * dy
	  var vy = ry * dx + uy * dy
	  var vz = rz * dx + uz * dy
	
	  this.center.move(t, vx, vy, vz)
	
	  //Update z-component of radius
	  var radius = Math.exp(this.computedRadius[0])
	  radius = Math.max(1e-4, radius + dz)
	  this.radius.set(t, Math.log(radius))
	}
	
	proto.rotate = function(t, dx, dy, dz) {
	  this.recalcMatrix(t)
	
	  dx = dx||0.0
	  dy = dy||0.0
	
	  var mat = this.computedMatrix
	
	  var rx = mat[0]
	  var ry = mat[4]
	  var rz = mat[8]
	
	  var ux = mat[1]
	  var uy = mat[5]
	  var uz = mat[9]
	
	  var fx = mat[2]
	  var fy = mat[6]
	  var fz = mat[10]
	
	  var qx = dx * rx + dy * ux
	  var qy = dx * ry + dy * uy
	  var qz = dx * rz + dy * uz
	
	  var bx = -(fy * qz - fz * qy)
	  var by = -(fz * qx - fx * qz)
	  var bz = -(fx * qy - fy * qx)  
	  var bw = Math.sqrt(Math.max(0.0, 1.0 - Math.pow(bx,2) - Math.pow(by,2) - Math.pow(bz,2)))
	  var bl = len4(bx, by, bz, bw)
	  if(bl > 1e-6) {
	    bx /= bl
	    by /= bl
	    bz /= bl
	    bw /= bl
	  } else {
	    bx = by = bz = 0.0
	    bw = 1.0
	  }
	
	  var rotation = this.computedRotation
	  var ax = rotation[0]
	  var ay = rotation[1]
	  var az = rotation[2]
	  var aw = rotation[3]
	
	  var cx = ax*bw + aw*bx + ay*bz - az*by
	  var cy = ay*bw + aw*by + az*bx - ax*bz
	  var cz = az*bw + aw*bz + ax*by - ay*bx
	  var cw = aw*bw - ax*bx - ay*by - az*bz
	  
	  //Apply roll
	  if(dz) {
	    bx = fx
	    by = fy
	    bz = fz
	    var s = Math.sin(dz) / len3(bx, by, bz)
	    bx *= s
	    by *= s
	    bz *= s
	    bw = Math.cos(dx)
	    cx = cx*bw + cw*bx + cy*bz - cz*by
	    cy = cy*bw + cw*by + cz*bx - cx*bz
	    cz = cz*bw + cw*bz + cx*by - cy*bx
	    cw = cw*bw - cx*bx - cy*by - cz*bz
	  }
	
	  var cl = len4(cx, cy, cz, cw)
	  if(cl > 1e-6) {
	    cx /= cl
	    cy /= cl
	    cz /= cl
	    cw /= cl
	  } else {
	    cx = cy = cz = 0.0
	    cw = 1.0
	  }
	
	  this.rotation.set(t, cx, cy, cz, cw)
	}
	
	proto.lookAt = function(t, eye, center, up) {
	  this.recalcMatrix(t)
	
	  center = center || this.computedCenter
	  eye    = eye    || this.computedEye
	  up     = up     || this.computedUp
	
	  var mat = this.computedMatrix
	  lookAt(mat, eye, center, up)
	
	  var rotation = this.computedRotation
	  quatFromFrame(rotation,
	    mat[0], mat[1], mat[2],
	    mat[4], mat[5], mat[6],
	    mat[8], mat[9], mat[10])
	  normalize4(rotation, rotation)
	  this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3])
	
	  var fl = 0.0
	  for(var i=0; i<3; ++i) {
	    fl += Math.pow(center[i] - eye[i], 2)
	  }
	  this.radius.set(t, 0.5 * Math.log(Math.max(fl, 1e-6)))
	
	  this.center.set(t, center[0], center[1], center[2])
	}
	
	proto.translate = function(t, dx, dy, dz) {
	  this.center.move(t,
	    dx||0.0,
	    dy||0.0,
	    dz||0.0)
	}
	
	proto.setMatrix = function(t, matrix) {
	
	  var rotation = this.computedRotation
	  quatFromFrame(rotation,
	    matrix[0], matrix[1], matrix[2],
	    matrix[4], matrix[5], matrix[6],
	    matrix[8], matrix[9], matrix[10])
	  normalize4(rotation, rotation)
	  this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3])
	
	  var mat = this.computedMatrix
	  invert44(mat, matrix)
	  var w = mat[15]
	  if(Math.abs(w) > 1e-6) {
	    var cx = mat[12]/w
	    var cy = mat[13]/w
	    var cz = mat[14]/w
	
	    this.recalcMatrix(t)  
	    var r = Math.exp(this.computedRadius[0])
	    this.center.set(t, cx-mat[2]*r, cy-mat[6]*r, cz-mat[10]*r)
	    this.radius.idle(t)
	  } else {
	    this.center.idle(t)
	    this.radius.idle(t)
	  }
	}
	
	proto.setDistance = function(t, d) {
	  if(d > 0) {
	    this.radius.set(t, Math.log(d))
	  }
	}
	
	proto.setDistanceLimits = function(lo, hi) {
	  if(lo > 0) {
	    lo = Math.log(lo)
	  } else {
	    lo = -Infinity    
	  }
	  if(hi > 0) {
	    hi = Math.log(hi)
	  } else {
	    hi = Infinity
	  }
	  hi = Math.max(hi, lo)
	  this.radius.bounds[0][0] = lo
	  this.radius.bounds[1][0] = hi
	}
	
	proto.getDistanceLimits = function(out) {
	  var bounds = this.radius.bounds
	  if(out) {
	    out[0] = Math.exp(bounds[0][0])
	    out[1] = Math.exp(bounds[1][0])
	    return out
	  }
	  return [ Math.exp(bounds[0][0]), Math.exp(bounds[1][0]) ]
	}
	
	proto.toJSON = function() {
	  this.recalcMatrix(this.lastT())
	  return {
	    center:   this.computedCenter.slice(),
	    rotation: this.computedRotation.slice(),
	    distance: Math.log(this.computedRadius[0]),
	    zoomMin:  this.radius.bounds[0][0],
	    zoomMax:  this.radius.bounds[1][0]
	  }
	}
	
	proto.fromJSON = function(options) {
	  var t = this.lastT()
	  var c = options.center
	  if(c) {
	    this.center.set(t, c[0], c[1], c[2])
	  }
	  var r = options.rotation
	  if(r) {
	    this.rotation.set(t, r[0], r[1], r[2], r[3])
	  }
	  var d = options.distance
	  if(d && d > 0) {
	    this.radius.set(t, Math.log(d))
	  }
	  this.setDistanceLimits(options.zoomMin, options.zoomMax)
	}
	
	function createOrbitController(options) {
	  options = options || {}
	  var center   = options.center   || [0,0,0]
	  var rotation = options.rotation || [0,0,0,1]
	  var radius   = options.radius   || 1.0
	
	  center = [].slice.call(center, 0, 3)
	  rotation = [].slice.call(rotation, 0, 4)
	  normalize4(rotation, rotation)
	
	  var result = new OrbitCameraController(
	    rotation,
	    center,
	    Math.log(radius))
	
	  result.setDistanceLimits(options.zoomMin, options.zoomMax)
	
	  if('eye' in options || 'up' in options) {
	    result.lookAt(0, options.eye, options.center, options.up)
	  }
	
	  return result
	}
	},{"./lib/quatFromFrame":456,"filtered-vector":228,"gl-mat4/fromQuat":264,"gl-mat4/invert":267,"gl-mat4/lookAt":268}],458:[function(_dereq_,module,exports){
	/*!
	 * pad-left <https://github.com/jonschlinkert/pad-left>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT license.
	 */
	
	'use strict';
	
	var repeat = _dereq_('repeat-string');
	
	module.exports = function padLeft(str, num, ch) {
	  ch = typeof ch !== 'undefined' ? (ch + '') : ' ';
	  return repeat(ch, num) + str;
	};
	},{"repeat-string":501}],459:[function(_dereq_,module,exports){
	'use strict'
	
	/**
	 * @module parenthesis
	 */
	
	function parse (str, opts) {
		// pretend non-string parsed per-se
		if (typeof str !== 'string') return [str]
	
		var res = [str]
	
		if (typeof opts === 'string' || Array.isArray(opts)) {
			opts = {brackets: opts}
		}
		else if (!opts) opts = {}
	
		var brackets = opts.brackets ? (Array.isArray(opts.brackets) ? opts.brackets : [opts.brackets]) : ['{}', '[]', '()']
	
		var escape = opts.escape || '___'
	
		var flat = !!opts.flat
	
		brackets.forEach(function (bracket) {
			// create parenthesis regex
			var pRE = new RegExp(['\\', bracket[0], '[^\\', bracket[0], '\\', bracket[1], ']*\\', bracket[1]].join(''))
	
			var ids = []
	
			function replaceToken(token, idx, str){
				// save token to res
				var refId = res.push(token.slice(bracket[0].length, -bracket[1].length)) - 1
	
				ids.push(refId)
	
				return escape + refId + escape
			}
	
			res.forEach(function (str, i) {
				var prevStr
	
				// replace paren tokens till there’s none
				var a = 0
				while (str != prevStr) {
					prevStr = str
					str = str.replace(pRE, replaceToken)
					if (a++ > 10e3) throw Error('References have circular dependency. Please, check them.')
				}
	
				res[i] = str
			})
	
			// wrap found refs to brackets
			ids = ids.reverse()
			res = res.map(function (str) {
				ids.forEach(function (id) {
					str = str.replace(new RegExp('(\\' + escape + id + '\\' + escape + ')', 'g'), bracket[0] + '$1' + bracket[1])
				})
				return str
			})
		})
	
		var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)
	
		// transform references to tree
		function nest (str, refs, escape) {
			var res = [], match
	
			var a = 0
			while (match = re.exec(str)) {
				if (a++ > 10e3) throw Error('Circular references in parenthesis')
	
				res.push(str.slice(0, match.index))
	
				res.push(nest(refs[match[1]], refs))
	
				str = str.slice(match.index + match[0].length)
			}
	
			res.push(str)
	
			return res
		}
	
		return flat ? res : nest(res[0], res)
	}
	
	function stringify (arg, opts) {
		if (opts && opts.flat) {
			var escape = opts && opts.escape || '___'
	
			var str = arg[0], prevStr
	
			// pretend bad string stringified with no parentheses
			if (!str) return ''
	
	
			var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)
	
			var a = 0
			while (str != prevStr) {
				if (a++ > 10e3) throw Error('Circular references in ' + arg)
				prevStr = str
				str = str.replace(re, replaceRef)
			}
	
			return str
		}
	
		return arg.reduce(function f (prev, curr) {
			if (Array.isArray(curr)) {
				curr = curr.reduce(f, '')
			}
			return prev + curr
		}, '')
	
		function replaceRef(match, idx){
			if (arg[idx] == null) throw Error('Reference ' + idx + 'is undefined')
			return arg[idx]
		}
	}
	
	function parenthesis (arg, opts) {
		if (Array.isArray(arg)) {
			return stringify(arg, opts)
		}
		else {
			return parse(arg, opts)
		}
	}
	
	parenthesis.parse = parse
	parenthesis.stringify = stringify
	
	module.exports = parenthesis
	
	},{}],460:[function(_dereq_,module,exports){
	'use strict'
	
	var pick = _dereq_('pick-by-alias')
	
	module.exports = parseRect
	
	function parseRect (arg) {
	  var rect
	
	  // direct arguments sequence
	  if (arguments.length > 1) {
	    arg = arguments
	  }
	
	  // svg viewbox
	  if (typeof arg === 'string') {
	    arg = arg.split(/\s/).map(parseFloat)
	  }
	  else if (typeof arg === 'number') {
	    arg = [arg]
	  }
	
	  // 0, 0, 100, 100 - array-like
	  if (arg.length && typeof arg[0] === 'number') {
	    // [w, w]
	    if (arg.length === 1) {
	      rect = {
	        width: arg[0],
	        height: arg[0],
	        x: 0, y: 0
	      }
	    }
	    // [w, h]
	    else if (arg.length === 2) {
	      rect = {
	        width: arg[0],
	        height: arg[1],
	        x: 0, y: 0
	      }
	    }
	    // [l, t, r, b]
	    else {
	      rect = {
	        x: arg[0],
	        y: arg[1],
	        width: (arg[2] - arg[0]) || 0,
	        height: (arg[3] - arg[1]) || 0
	      }
	    }
	  }
	  // {x, y, w, h} or {l, t, b, r}
	  else if (arg) {
	    arg = pick(arg, {
	      left: 'x l left Left',
	      top: 'y t top Top',
	      width: 'w width W Width',
	      height: 'h height W Width',
	      bottom: 'b bottom Bottom',
	      right: 'r right Right'
	    })
	
	    rect = {
	      x: arg.left || 0,
	      y: arg.top || 0
	    }
	
	    if (arg.width == null) {
	      if (arg.right) rect.width = arg.right - rect.x
	      else rect.width = 0
	    }
	    else {
	      rect.width = arg.width
	    }
	
	    if (arg.height == null) {
	      if (arg.bottom) rect.height = arg.bottom - rect.y
	      else rect.height = 0
	    }
	    else {
	      rect.height = arg.height
	    }
	  }
	
	  return rect
	}
	
	},{"pick-by-alias":466}],461:[function(_dereq_,module,exports){
	
	module.exports = parse
	
	/**
	 * expected argument lengths
	 * @type {Object}
	 */
	
	var length = {a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0}
	
	/**
	 * segment pattern
	 * @type {RegExp}
	 */
	
	var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig
	
	/**
	 * parse an svg path data string. Generates an Array
	 * of commands where each command is an Array of the
	 * form `[command, arg1, arg2, ...]`
	 *
	 * @param {String} path
	 * @return {Array}
	 */
	
	function parse(path) {
		var data = []
		path.replace(segment, function(_, command, args){
			var type = command.toLowerCase()
			args = parseValues(args)
	
			// overloaded moveTo
			if (type == 'm' && args.length > 2) {
				data.push([command].concat(args.splice(0, 2)))
				type = 'l'
				command = command == 'm' ? 'l' : 'L'
			}
	
			while (true) {
				if (args.length == length[type]) {
					args.unshift(command)
					return data.push(args)
				}
				if (args.length < length[type]) throw new Error('malformed path data')
				data.push([command].concat(args.splice(0, length[type])))
			}
		})
		return data
	}
	
	var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig
	
	function parseValues(args) {
		var numbers = args.match(number)
		return numbers ? numbers.map(Number) : []
	}
	
	},{}],462:[function(_dereq_,module,exports){
	module.exports = function parseUnit(str, out) {
	    if (!out)
	        out = [ 0, '' ]
	
	    str = String(str)
	    var num = parseFloat(str, 10)
	    out[0] = num
	    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
	    return out
	}
	},{}],463:[function(_dereq_,module,exports){
	(function (process){
	// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	
	
	}).call(this,_dereq_('_process'))
	},{"_process":483}],464:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = permutationSign
	
	var BRUTE_FORCE_CUTOFF = 32
	
	var pool = _dereq_("typedarray-pool")
	
	function permutationSign(p) {
	  var n = p.length
	  if(n < BRUTE_FORCE_CUTOFF) {
	    //Use quadratic algorithm for small n
	    var sgn = 1
	    for(var i=0; i<n; ++i) {
	      for(var j=0; j<i; ++j) {
	        if(p[i] < p[j]) {
	          sgn = -sgn
	        } else if(p[i] === p[j]) {
	          return 0
	        }
	      }
	    }
	    return sgn
	  } else {
	    //Otherwise use linear time algorithm
	    var visited = pool.mallocUint8(n)
	    for(var i=0; i<n; ++i) {
	      visited[i] = 0
	    }
	    var sgn = 1
	    for(var i=0; i<n; ++i) {
	      if(!visited[i]) {
	        var count = 1
	        visited[i] = 1
	        for(var j=p[i]; j!==i; j=p[j]) {
	          if(visited[j]) {
	            pool.freeUint8(visited)
	            return 0
	          }
	          count += 1
	          visited[j] = 1
	        }
	        if(!(count & 1)) {
	          sgn = -sgn
	        }
	      }
	    }
	    pool.freeUint8(visited)
	    return sgn
	  }
	}
	},{"typedarray-pool":543}],465:[function(_dereq_,module,exports){
	"use strict"
	
	var pool = _dereq_("typedarray-pool")
	var inverse = _dereq_("invert-permutation")
	
	function rank(permutation) {
	  var n = permutation.length
	  switch(n) {
	    case 0:
	    case 1:
	      return 0
	    case 2:
	      return permutation[1]
	    default:
	      break
	  }
	  var p = pool.mallocUint32(n)
	  var pinv = pool.mallocUint32(n)
	  var r = 0, s, t, i
	  inverse(permutation, pinv)
	  for(i=0; i<n; ++i) {
	    p[i] = permutation[i]
	  }
	  for(i=n-1; i>0; --i) {
	    t = pinv[i]
	    s = p[i]
	    p[i] = p[t]
	    p[t] = s
	    pinv[i] = pinv[s]
	    pinv[s] = t
	    r = (r + s) * i
	  }
	  pool.freeUint32(pinv)
	  pool.freeUint32(p)
	  return r
	}
	
	function unrank(n, r, p) {
	  switch(n) {
	    case 0:
	      if(p) { return p }
	      return []
	    case 1:
	      if(p) {
	        p[0] = 0
	        return p
	      } else {
	        return [0]
	      }
	    case 2:
	      if(p) {
	        if(r) {
	          p[0] = 0
	          p[1] = 1
	        } else {
	          p[0] = 1
	          p[1] = 0
	        }
	        return p
	      } else {
	        return r ? [0,1] : [1,0]
	      }
	    default:
	      break
	  }
	  p = p || new Array(n)
	  var s, t, i, nf=1
	  p[0] = 0
	  for(i=1; i<n; ++i) {
	    p[i] = i
	    nf = (nf*i)|0
	  }
	  for(i=n-1; i>0; --i) {
	    s = (r / nf)|0
	    r = (r - s * nf)|0
	    nf = (nf / i)|0
	    t = p[i]|0
	    p[i] = p[s]|0
	    p[s] = t|0
	  }
	  return p
	}
	
	exports.rank = rank
	exports.unrank = unrank
	
	},{"invert-permutation":416,"typedarray-pool":543}],466:[function(_dereq_,module,exports){
	'use strict'
	
	
	module.exports = function pick (src, props, keepRest) {
		var result = {}, prop, i
	
		if (typeof props === 'string') props = toList(props)
		if (Array.isArray(props)) {
			var res = {}
			for (i = 0; i < props.length; i++) {
				res[props[i]] = true
			}
			props = res
		}
	
		// convert strings to lists
		for (prop in props) {
			props[prop] = toList(props[prop])
		}
	
		// keep-rest strategy requires unmatched props to be preserved
		var occupied = {}
	
		for (prop in props) {
			var aliases = props[prop]
	
			if (Array.isArray(aliases)) {
				for (i = 0; i < aliases.length; i++) {
					var alias = aliases[i]
	
					if (keepRest) {
						occupied[alias] = true
					}
	
					if (alias in src) {
						result[prop] = src[alias]
	
						if (keepRest) {
							for (var j = i; j < aliases.length; j++) {
								occupied[aliases[j]] = true
							}
						}
	
						break
					}
				}
			}
			else if (prop in src) {
				if (props[prop]) {
					result[prop] = src[prop]
				}
	
				if (keepRest) {
					occupied[prop] = true
				}
			}
		}
	
		if (keepRest) {
			for (prop in src) {
				if (occupied[prop]) continue
				result[prop] = src[prop]
			}
		}
	
		return result
	}
	
	var CACHE = {}
	
	function toList(arg) {
		if (CACHE[arg]) return CACHE[arg]
		if (typeof arg === 'string') {
			arg = CACHE[arg] = arg.split(/\s*,\s*|\s+/)
		}
		return arg
	}
	
	},{}],467:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = planarDual
	
	var compareAngle = _dereq_("compare-angle")
	
	function planarDual(cells, positions) {
	
	  var numVertices = positions.length|0
	  var numEdges = cells.length
	  var adj = [new Array(numVertices), new Array(numVertices)]
	  for(var i=0; i<numVertices; ++i) {
	    adj[0][i] = []
	    adj[1][i] = []
	  }
	  for(var i=0; i<numEdges; ++i) {
	    var c = cells[i]
	    adj[0][c[0]].push(c)
	    adj[1][c[1]].push(c)
	  }
	
	  var cycles = []
	
	  //Add isolated vertices as trivial case
	  for(var i=0; i<numVertices; ++i) {
	    if(adj[0][i].length + adj[1][i].length === 0) {
	      cycles.push( [i] )
	    }
	  }
	
	  //Remove a half edge
	  function cut(c, i) {
	    var a = adj[i][c[i]]
	    a.splice(a.indexOf(c), 1)
	  }
	
	  //Find next vertex and cut edge
	  function next(a, b, noCut) {
	    var nextCell, nextVertex, nextDir
	    for(var i=0; i<2; ++i) {
	      if(adj[i][b].length > 0) {
	        nextCell = adj[i][b][0]
	        nextDir = i
	        break
	      }
	    }
	    nextVertex = nextCell[nextDir^1]
	
	    for(var dir=0; dir<2; ++dir) {
	      var nbhd = adj[dir][b]
	      for(var k=0; k<nbhd.length; ++k) {
	        var e = nbhd[k]
	        var p = e[dir^1]
	        var cmp = compareAngle(
	            positions[a], 
	            positions[b], 
	            positions[nextVertex],
	            positions[p])
	        if(cmp > 0) {
	          nextCell = e
	          nextVertex = p
	          nextDir = dir
	        }
	      }
	    }
	    if(noCut) {
	      return nextVertex
	    }
	    if(nextCell) {
	      cut(nextCell, nextDir)
	    }
	    return nextVertex
	  }
	
	  function extractCycle(v, dir) {
	    var e0 = adj[dir][v][0]
	    var cycle = [v]
	    cut(e0, dir)
	    var u = e0[dir^1]
	    var d0 = dir
	    while(true) {
	      while(u !== v) {
	        cycle.push(u)
	        u = next(cycle[cycle.length-2], u, false)
	      }
	      if(adj[0][v].length + adj[1][v].length === 0) {
	        break
	      }
	      var a = cycle[cycle.length-1]
	      var b = v
	      var c = cycle[1]
	      var d = next(a, b, true)
	      if(compareAngle(positions[a], positions[b], positions[c], positions[d]) < 0) {
	        break
	      }
	      cycle.push(v)
	      u = next(a, b)
	    }
	    return cycle
	  }
	
	  function shouldGlue(pcycle, ncycle) {
	    return (ncycle[1] === ncycle[ncycle.length-1])
	  }
	
	  for(var i=0; i<numVertices; ++i) {
	    for(var j=0; j<2; ++j) {
	      var pcycle = []
	      while(adj[j][i].length > 0) {
	        var ni = adj[0][i].length
	        var ncycle = extractCycle(i,j)
	        if(shouldGlue(pcycle, ncycle)) {
	          //Glue together trivial cycles
	          pcycle.push.apply(pcycle, ncycle)
	        } else {
	          if(pcycle.length > 0) {
	            cycles.push(pcycle)
	          }
	          pcycle = ncycle
	        }
	      }
	      if(pcycle.length > 0) {
	        cycles.push(pcycle)
	      }
	    }
	  }
	
	  //Combine paths and loops together
	  return cycles
	}
	},{"compare-angle":128}],468:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = trimLeaves
	
	var e2a = _dereq_('edges-to-adjacency-list')
	
	function trimLeaves(edges, positions) {
	  var adj = e2a(edges, positions.length)
	  var live = new Array(positions.length)
	  var nbhd = new Array(positions.length)
	
	  var dead = []
	  for(var i=0; i<positions.length; ++i) {
	    var count = adj[i].length
	    nbhd[i] = count
	    live[i] = true
	    if(count <= 1) {
	      dead.push(i)
	    }
	  }
	
	  while(dead.length > 0) {
	    var v = dead.pop()
	    live[v] = false
	    var n = adj[v]
	    for(var i=0; i<n.length; ++i) {
	      var u = n[i]
	      if(--nbhd[u] === 0) {
	        dead.push(u)
	      }
	    }
	  }
	
	  var newIndex = new Array(positions.length)
	  var npositions = []
	  for(var i=0; i<positions.length; ++i) {
	    if(live[i]) {
	      var v = npositions.length
	      newIndex[i] = v
	      npositions.push(positions[i])
	    } else {
	      newIndex[i] = -1
	    }
	  }
	
	  var nedges = []
	  for(var i=0; i<edges.length; ++i) {
	    var e = edges[i]
	    if(live[e[0]] && live[e[1]]) {
	      nedges.push([ newIndex[e[0]], newIndex[e[1]] ])
	    }
	  }
	  
	  return [ nedges, npositions ]
	}
	},{"edges-to-adjacency-list":173}],469:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = planarGraphToPolyline
	
	var e2a = _dereq_('edges-to-adjacency-list')
	var planarDual = _dereq_('planar-dual')
	var preprocessPolygon = _dereq_('point-in-big-polygon')
	var twoProduct = _dereq_('two-product')
	var robustSum = _dereq_('robust-sum')
	var uniq = _dereq_('uniq')
	var trimLeaves = _dereq_('./lib/trim-leaves')
	
	function makeArray(length, fill) {
	  var result = new Array(length)
	  for(var i=0; i<length; ++i) {
	    result[i] = fill
	  }
	  return result
	}
	
	function makeArrayOfArrays(length) {
	  var result = new Array(length)
	  for(var i=0; i<length; ++i) {
	    result[i] = []
	  }
	  return result
	}
	
	
	function planarGraphToPolyline(edges, positions) {
	
	  //Trim leaves
	  var result = trimLeaves(edges, positions)
	  edges = result[0]
	  positions = result[1]
	
	  var numVertices = positions.length
	  var numEdges = edges.length
	
	  //Calculate adjacency list, check manifold
	  var adj = e2a(edges, positions.length)
	  for(var i=0; i<numVertices; ++i) {
	    if(adj[i].length % 2 === 1) {
	      throw new Error('planar-graph-to-polyline: graph must be manifold')
	    }
	  }
	
	  //Get faces
	  var faces = planarDual(edges, positions)
	
	  //Check orientation of a polygon using exact arithmetic
	  function ccw(c) {
	    var n = c.length
	    var area = [0]
	    for(var j=0; j<n; ++j) {
	      var a = positions[c[j]]
	      var b = positions[c[(j+1)%n]]
	      var t00 = twoProduct(-a[0], a[1])
	      var t01 = twoProduct(-a[0], b[1])
	      var t10 = twoProduct( b[0], a[1])
	      var t11 = twoProduct( b[0], b[1])
	      area = robustSum(area, robustSum(robustSum(t00, t01), robustSum(t10, t11)))
	    }
	    return area[area.length-1] > 0
	  }
	
	  //Extract all clockwise faces
	  faces = faces.filter(ccw)
	
	  //Detect which loops are contained in one another to handle parent-of relation
	  var numFaces = faces.length
	  var parent = new Array(numFaces)
	  var containment = new Array(numFaces)
	  for(var i=0; i<numFaces; ++i) {
	    parent[i] = i
	    var row = new Array(numFaces)
	    var loopVertices = faces[i].map(function(v) {
	      return positions[v]
	    })
	    var pmc = preprocessPolygon([loopVertices])
	    var count = 0
	    outer:
	    for(var j=0; j<numFaces; ++j) {
	      row[j] = 0
	      if(i === j) {
	        continue
	      }
	      var c = faces[j]
	      var n = c.length
	      for(var k=0; k<n; ++k) {
	        var d = pmc(positions[c[k]])
	        if(d !== 0) {
	          if(d < 0) {
	            row[j] = 1
	            count += 1
	          }
	          continue outer
	        }
	      }
	      row[j] = 1
	      count += 1
	    }
	    containment[i] = [count, i, row]
	  }
	  containment.sort(function(a,b) {
	    return b[0] - a[0]
	  })
	  for(var i=0; i<numFaces; ++i) {
	    var row = containment[i]
	    var idx = row[1]
	    var children = row[2]
	    for(var j=0; j<numFaces; ++j) {
	      if(children[j]) {
	        parent[j] = idx
	      }
	    }
	  }
	
	  //Initialize face adjacency list
	  var fadj = makeArrayOfArrays(numFaces)
	  for(var i=0; i<numFaces; ++i) {
	    fadj[i].push(parent[i])
	    fadj[parent[i]].push(i)
	  }
	
	  //Build adjacency matrix for edges
	  var edgeAdjacency = {}
	  var internalVertices = makeArray(numVertices, false)
	  for(var i=0; i<numFaces; ++i) {
	    var c = faces[i]
	    var n = c.length
	    for(var j=0; j<n; ++j) {
	      var a = c[j]
	      var b = c[(j+1)%n]
	      var key = Math.min(a,b) + ":" + Math.max(a,b)
	      if(key in edgeAdjacency) {
	        var neighbor = edgeAdjacency[key]
	        fadj[neighbor].push(i)
	        fadj[i].push(neighbor)
	        internalVertices[a] = internalVertices[b] = true
	      } else {
	        edgeAdjacency[key] = i
	      }
	    }
	  }
	
	  function sharedBoundary(c) {
	    var n = c.length
	    for(var i=0; i<n; ++i) {
	      if(!internalVertices[c[i]]) {
	        return false
	      }
	    }
	    return true
	  }
	
	  var toVisit = []
	  var parity = makeArray(numFaces, -1)
	  for(var i=0; i<numFaces; ++i) {
	    if(parent[i] === i && !sharedBoundary(faces[i])) {
	      toVisit.push(i)
	      parity[i] = 0
	    } else {
	      parity[i] = -1
	    }
	  }
	
	  //Using face adjacency, classify faces as in/out
	  var result = []
	  while(toVisit.length > 0) {
	    var top = toVisit.pop()
	    var nbhd = fadj[top]
	    uniq(nbhd, function(a,b) {
	      return a-b
	    })
	    var nnbhr = nbhd.length
	    var p = parity[top]
	    var polyline
	    if(p === 0) {
	      var c = faces[top]
	      polyline = [c]
	    }
	    for(var i=0; i<nnbhr; ++i) {
	      var f = nbhd[i]
	      if(parity[f] >= 0) {
	        continue
	      }
	      parity[f] = p^1
	      toVisit.push(f)
	      if(p === 0) {
	        var c = faces[f]
	        if(!sharedBoundary(c)) {
	          c.reverse()
	          polyline.push(c)
	        }
	      }
	    }
	    if(p === 0) {
	      result.push(polyline)
	    }
	  }
	
	  return result
	}
	},{"./lib/trim-leaves":468,"edges-to-adjacency-list":173,"planar-dual":467,"point-in-big-polygon":473,"robust-sum":513,"two-product":541,"uniq":545}],470:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = _dereq_('./quad')
	
	},{"./quad":472}],471:[function(_dereq_,module,exports){
	arguments[4][112][0].apply(exports,arguments)
	},{"dup":112}],472:[function(_dereq_,module,exports){
	/**
	 * @module  point-cluster/quad
	 *
	 * Bucket based quad tree clustering
	 */
	
	'use strict'
	
	var search = _dereq_('binary-search-bounds')
	var clamp = _dereq_('clamp')
	var rect = _dereq_('parse-rect')
	var getBounds = _dereq_('array-bounds')
	var pick = _dereq_('pick-by-alias')
	var defined = _dereq_('defined')
	var flatten = _dereq_('flatten-vertex-data')
	var isObj = _dereq_('is-obj')
	var dtype = _dereq_('dtype')
	var log2 = _dereq_('math-log2')
	
	var MAX_GROUP_ID = 1073741824
	
	module.exports = function cluster (srcPoints, options) {
		if (!options) { options = {} }
	
		srcPoints = flatten(srcPoints, 'float64')
	
		options = pick(options, {
			bounds: 'range bounds dataBox databox',
			maxDepth: 'depth maxDepth maxdepth level maxLevel maxlevel levels',
			dtype: 'type dtype format out dst output destination'
			// sort: 'sortBy sortby sort',
			// pick: 'pick levelPoint',
			// nodeSize: 'node nodeSize minNodeSize minSize size'
		})
	
		// let nodeSize = defined(options.nodeSize, 1)
		var maxDepth = defined(options.maxDepth, 255)
		var bounds = defined(options.bounds, getBounds(srcPoints, 2))
		if (bounds[0] === bounds[2]) { bounds[2]++ }
		if (bounds[1] === bounds[3]) { bounds[3]++ }
	
		var points = normalize(srcPoints, bounds)
	
		// init variables
		var n = srcPoints.length >>> 1
		var ids
		if (!options.dtype) { options.dtype = 'array' }
	
		if (typeof options.dtype === 'string') {
			ids = new (dtype(options.dtype))(n)
		}
		else if (options.dtype) {
			ids = options.dtype
			if (Array.isArray(ids)) { ids.length = n }
		}
		for (var i = 0; i < n; ++i) {
			ids[i] = i
		}
	
		// representative point indexes for levels
		var levels = []
	
		// starting indexes of subranges in sub levels, levels.length * 4
		var sublevels = []
	
		// unique group ids, sorted in z-curve fashion within levels by shifting bits
		var groups = []
	
		// level offsets in `ids`
		var offsets = []
	
	
		// sort points
		sort(0, 0, 1, ids, 0, 1)
	
	
		// return reordered ids with provided methods
		// save level offsets in output buffer
		var offset = 0
		for (var level = 0; level < levels.length; level++) {
			var levelItems = levels[level]
			if (ids.set) { ids.set(levelItems, offset) }
			else {
				for (var i$1 = 0, l = levelItems.length; i$1 < l; i$1++) {
					ids[i$1 + offset] = levelItems[i$1]
				}
			}
			var nextOffset = offset + levels[level].length
			offsets[level] = [offset, nextOffset]
			offset = nextOffset
		}
	
		ids.range = range
	
		return ids
	
	
	
		// FIXME: it is possible to create one typed array heap and reuse that to avoid memory blow
		function sort (x, y, diam, ids, level, group) {
			if (!ids.length) { return null }
	
			// save first point as level representative
			var levelItems = levels[level] || (levels[level] = [])
			var levelGroups = groups[level] || (groups[level] = [])
			var sublevel = sublevels[level] || (sublevels[level] = [])
			var offset = levelItems.length
	
			level++
	
			// max depth reached - put all items into a first group
			// alternatively - if group id overflow - avoid proceeding
			if (level > maxDepth || group > MAX_GROUP_ID) {
				for (var i = 0; i < ids.length; i++) {
					levelItems.push(ids[i])
					levelGroups.push(group)
					sublevel.push(null, null, null, null)
				}
	
				return offset
			}
	
			levelItems.push(ids[0])
			levelGroups.push(group)
	
			if (ids.length <= 1) {
				sublevel.push(null, null, null, null)
				return offset
			}
	
	
			var d2 = diam * .5
			var cx = x + d2, cy = y + d2
	
			// distribute points by 4 buckets
			var lolo = [], lohi = [], hilo = [], hihi = []
	
			for (var i$1 = 1, l = ids.length; i$1 < l; i$1++) {
				var idx = ids[i$1],
					x$1 = points[idx * 2],
					y$1 = points[idx * 2 + 1]
				x$1 < cx ? (y$1 < cy ? lolo.push(idx) : lohi.push(idx)) : (y$1 < cy ? hilo.push(idx) : hihi.push(idx))
			}
	
			group <<= 2
	
			sublevel.push(
				sort(x, y, d2, lolo, level, group),
				sort(x, cy, d2, lohi, level, group + 1),
				sort(cx, y, d2, hilo, level, group + 2),
				sort(cx, cy, d2, hihi, level, group + 3)
			)
	
			return offset
		}
	
		// get all points within the passed range
		function range () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];
	
			var options
	
			if (isObj(args[args.length - 1])) {
				var arg = args.pop()
	
				// detect if that was a rect object
				if (!args.length && (arg.x != null || arg.l != null || arg.left != null)) {
					args = [arg]
					options = {}
				}
	
				options = pick(arg, {
					level: 'level maxLevel',
					d: 'd diam diameter r radius px pxSize pixel pixelSize maxD size minSize',
					lod: 'lod details ranges offsets'
				})
			}
			else {
				options = {}
			}
	
			if (!args.length) { args = bounds }
	
			var box = rect.apply( void 0, args )
	
			var ref = [
				Math.min(box.x, box.x + box.width),
				Math.min(box.y, box.y + box.height),
				Math.max(box.x, box.x + box.width),
				Math.max(box.y, box.y + box.height)
			];
			var minX = ref[0];
			var minY = ref[1];
			var maxX = ref[2];
			var maxY = ref[3];
	
			var ref$1 = normalize([minX, minY, maxX, maxY], bounds );
			var nminX = ref$1[0];
			var nminY = ref$1[1];
			var nmaxX = ref$1[2];
			var nmaxY = ref$1[3];
	
			var maxLevel = defined(options.level, levels.length)
	
			// limit maxLevel by px size
			if (options.d != null) {
				var d
				if (typeof options.d === 'number') { d = [options.d, options.d] }
				else if (options.d.length) { d = options.d }
	
				maxLevel = Math.min(
					Math.max(
						Math.ceil(-log2(Math.abs(d[0]) / (bounds[2] - bounds[0]))),
						Math.ceil(-log2(Math.abs(d[1]) / (bounds[3] - bounds[1])))
					),
					maxLevel
				)
			}
			maxLevel = Math.min(maxLevel, levels.length)
	
			// return levels of details
			if (options.lod) {
				return lod(nminX, nminY, nmaxX, nmaxY, maxLevel)
			}
	
	
	
			// do selection ids
			var selection = []
	
			// FIXME: probably we can do LOD here beforehead
			select( 0, 0, 1, 0, 0, 1)
	
			function select ( lox, loy, d, level, from, to ) {
				if (from === null || to === null) { return }
	
				var hix = lox + d
				var hiy = loy + d
	
				// if box does not intersect level - ignore
				if ( nminX > hix || nminY > hiy || nmaxX < lox || nmaxY < loy ) { return }
				if ( level >= maxLevel ) { return }
				if ( from === to ) { return }
	
				// if points fall into box range - take it
				var levelItems = levels[level]
	
				if (to === undefined) { to = levelItems.length }
	
				for (var i = from; i < to; i++) {
					var id = levelItems[i]
	
					var px = srcPoints[ id * 2 ]
					var py = srcPoints[ id * 2 + 1 ]
	
					if ( px >= minX && px <= maxX && py >= minY && py <= maxY ) {selection.push(id)
					}
				}
	
				// for every subsection do select
				var offsets = sublevels[ level ]
				var off0 = offsets[ from * 4 + 0 ]
				var off1 = offsets[ from * 4 + 1 ]
				var off2 = offsets[ from * 4 + 2 ]
				var off3 = offsets[ from * 4 + 3 ]
				var end = nextOffset(offsets, from + 1)
	
				var d2 = d * .5
				var nextLevel = level + 1
				select( lox, loy, d2, nextLevel, off0, off1 || off2 || off3 || end)
				select( lox, loy + d2, d2, nextLevel, off1, off2 || off3 || end)
				select( lox + d2, loy, d2, nextLevel, off2, off3 || end)
				select( lox + d2, loy + d2, d2, nextLevel, off3, end)
			}
	
			function nextOffset(offsets, from) {
				var offset = null, i = 0
				while(offset === null) {
					offset = offsets[ from * 4 + i ]
					i++
					if (i > offsets.length) { return null }
				}
				return offset
			}
	
			return selection
		}
	
		// get range offsets within levels to render lods appropriate for zoom level
		// TODO: it is possible to store minSize of a point to optimize neede level calc
		function lod (lox, loy, hix, hiy, maxLevel) {
			var ranges = []
	
			for (var level = 0; level < maxLevel; level++) {
				var levelGroups = groups[level]
				var from = offsets[level][0]
	
				var levelGroupStart = group(lox, loy, level)
				var levelGroupEnd = group(hix, hiy, level)
	
				// FIXME: utilize sublevels to speed up search range here
				var startOffset = search.ge(levelGroups, levelGroupStart)
				var endOffset = search.gt(levelGroups, levelGroupEnd, startOffset, levelGroups.length - 1)
	
				ranges[level] = [startOffset + from, endOffset + from]
			}
	
			return ranges
		}
	
		// get group id closest to the x,y coordinate, corresponding to a level
		function group (x, y, level) {
			var group = 1
	
			var cx = .5, cy = .5
			var diam = .5
	
			for (var i = 0; i < level; i++) {
				group <<= 2
	
				group += x < cx ? (y < cy ? 0 : 1) : (y < cy ? 2 : 3)
	
				diam *= .5
	
				cx += x < cx ? -diam : diam
				cy += y < cy ? -diam : diam
			}
	
			return group
		}
	}
	
	
	// normalize points by bounds
	function normalize (pts, bounds) {
		var lox = bounds[0];
		var loy = bounds[1];
		var hix = bounds[2];
		var hiy = bounds[3];
		var scaleX = 1.0 / (hix - lox)
		var scaleY = 1.0 / (hiy - loy)
		var result = new Array(pts.length)
	
		for (var i = 0, n = pts.length / 2; i < n; i++) {
			result[2*i] = clamp((pts[2*i] - lox) * scaleX, 0, 1)
			result[2*i+1] = clamp((pts[2*i+1] - loy) * scaleY, 0, 1)
		}
	
		return result
	}
	
	},{"array-bounds":67,"binary-search-bounds":471,"clamp":116,"defined":165,"dtype":170,"flatten-vertex-data":229,"is-obj":422,"math-log2":433,"parse-rect":460,"pick-by-alias":466}],473:[function(_dereq_,module,exports){
	module.exports = preprocessPolygon
	
	var orient = _dereq_('robust-orientation')[3]
	var makeSlabs = _dereq_('slab-decomposition')
	var makeIntervalTree = _dereq_('interval-tree-1d')
	var bsearch = _dereq_('binary-search-bounds')
	
	function visitInterval() {
	  return true
	}
	
	function intervalSearch(table) {
	  return function(x, y) {
	    var tree = table[x]
	    if(tree) {
	      return !!tree.queryPoint(y, visitInterval)
	    }
	    return false
	  }
	}
	
	function buildVerticalIndex(segments) {
	  var table = {}
	  for(var i=0; i<segments.length; ++i) {
	    var s = segments[i]
	    var x = s[0][0]
	    var y0 = s[0][1]
	    var y1 = s[1][1]
	    var p = [ Math.min(y0, y1), Math.max(y0, y1) ]
	    if(x in table) {
	      table[x].push(p)
	    } else {
	      table[x] = [ p ]
	    }
	  }
	  var intervalTable = {}
	  var keys = Object.keys(table)
	  for(var i=0; i<keys.length; ++i) {
	    var segs = table[keys[i]]
	    intervalTable[keys[i]] = makeIntervalTree(segs)
	  }
	  return intervalSearch(intervalTable)
	}
	
	function buildSlabSearch(slabs, coordinates) {
	  return function(p) {
	    var bucket = bsearch.le(coordinates, p[0])
	    if(bucket < 0) {
	      return 1
	    }
	    var root = slabs[bucket]
	    if(!root) {
	      if(bucket > 0 && coordinates[bucket] === p[0]) {
	        root = slabs[bucket-1]
	      } else {
	        return 1
	      }
	    }
	    var lastOrientation = 1
	    while(root) {
	      var s = root.key
	      var o = orient(p, s[0], s[1])
	      if(s[0][0] < s[1][0]) {
	        if(o < 0) {
	          root = root.left
	        } else if(o > 0) {
	          lastOrientation = -1
	          root = root.right
	        } else {
	          return 0
	        }
	      } else {
	        if(o > 0) {
	          root = root.left
	        } else if(o < 0) {
	          lastOrientation = 1
	          root = root.right
	        } else {
	          return 0
	        }
	      }
	    }
	    return lastOrientation
	  }
	}
	
	function classifyEmpty(p) {
	  return 1
	}
	
	function createClassifyVertical(testVertical) {
	  return function classify(p) {
	    if(testVertical(p[0], p[1])) {
	      return 0
	    }
	    return 1
	  }
	}
	
	function createClassifyPointDegen(testVertical, testNormal) {
	  return function classify(p) {
	    if(testVertical(p[0], p[1])) {
	      return 0
	    }
	    return testNormal(p)
	  }
	}
	
	function preprocessPolygon(loops) {
	  //Compute number of loops
	  var numLoops = loops.length
	
	  //Unpack segments
	  var segments = []
	  var vsegments = []
	  var ptr = 0
	  for(var i=0; i<numLoops; ++i) {
	    var loop = loops[i]
	    var numVertices = loop.length
	    for(var s=numVertices-1,t=0; t<numVertices; s=(t++)) {
	      var a = loop[s]
	      var b = loop[t]
	      if(a[0] === b[0]) {
	        vsegments.push([a,b])
	      } else {
	        segments.push([a,b])
	      }
	    }
	  }
	
	  //Degenerate case: All loops are empty
	  if(segments.length === 0) {
	    if(vsegments.length === 0) {
	      return classifyEmpty
	    } else {
	      return createClassifyVertical(buildVerticalIndex(vsegments))
	    }
	  }
	
	  //Build slab decomposition
	  var slabs = makeSlabs(segments)
	  var testSlab = buildSlabSearch(slabs.slabs, slabs.coordinates)
	
	  if(vsegments.length === 0) {
	    return testSlab
	  } else {
	    return createClassifyPointDegen(
	      buildVerticalIndex(vsegments),
	      testSlab)
	  }
	}
	},{"binary-search-bounds":92,"interval-tree-1d":415,"robust-orientation":508,"slab-decomposition":524}],474:[function(_dereq_,module,exports){
	/*
	 * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
	 * @license MIT
	 * @preserve Project Home: https://github.com/voidqk/polybooljs
	 */
	
	var BuildLog = _dereq_('./lib/build-log');
	var Epsilon = _dereq_('./lib/epsilon');
	var Intersecter = _dereq_('./lib/intersecter');
	var SegmentChainer = _dereq_('./lib/segment-chainer');
	var SegmentSelector = _dereq_('./lib/segment-selector');
	var GeoJSON = _dereq_('./lib/geojson');
	
	var buildLog = false;
	var epsilon = Epsilon();
	
	var PolyBool;
	PolyBool = {
		// getter/setter for buildLog
		buildLog: function(bl){
			if (bl === true)
				buildLog = BuildLog();
			else if (bl === false)
				buildLog = false;
			return buildLog === false ? false : buildLog.list;
		},
		// getter/setter for epsilon
		epsilon: function(v){
			return epsilon.epsilon(v);
		},
	
		// core API
		segments: function(poly){
			var i = Intersecter(true, epsilon, buildLog);
			poly.regions.forEach(i.addRegion);
			return {
				segments: i.calculate(poly.inverted),
				inverted: poly.inverted
			};
		},
		combine: function(segments1, segments2){
			var i3 = Intersecter(false, epsilon, buildLog);
			return {
				combined: i3.calculate(
					segments1.segments, segments1.inverted,
					segments2.segments, segments2.inverted
				),
				inverted1: segments1.inverted,
				inverted2: segments2.inverted
			};
		},
		selectUnion: function(combined){
			return {
				segments: SegmentSelector.union(combined.combined, buildLog),
				inverted: combined.inverted1 || combined.inverted2
			}
		},
		selectIntersect: function(combined){
			return {
				segments: SegmentSelector.intersect(combined.combined, buildLog),
				inverted: combined.inverted1 && combined.inverted2
			}
		},
		selectDifference: function(combined){
			return {
				segments: SegmentSelector.difference(combined.combined, buildLog),
				inverted: combined.inverted1 && !combined.inverted2
			}
		},
		selectDifferenceRev: function(combined){
			return {
				segments: SegmentSelector.differenceRev(combined.combined, buildLog),
				inverted: !combined.inverted1 && combined.inverted2
			}
		},
		selectXor: function(combined){
			return {
				segments: SegmentSelector.xor(combined.combined, buildLog),
				inverted: combined.inverted1 !== combined.inverted2
			}
		},
		polygon: function(segments){
			return {
				regions: SegmentChainer(segments.segments, epsilon, buildLog),
				inverted: segments.inverted
			};
		},
	
		// GeoJSON converters
		polygonFromGeoJSON: function(geojson){
			return GeoJSON.toPolygon(PolyBool, geojson);
		},
		polygonToGeoJSON: function(poly){
			return GeoJSON.fromPolygon(PolyBool, epsilon, poly);
		},
	
		// helper functions for common operations
		union: function(poly1, poly2){
			return operate(poly1, poly2, PolyBool.selectUnion);
		},
		intersect: function(poly1, poly2){
			return operate(poly1, poly2, PolyBool.selectIntersect);
		},
		difference: function(poly1, poly2){
			return operate(poly1, poly2, PolyBool.selectDifference);
		},
		differenceRev: function(poly1, poly2){
			return operate(poly1, poly2, PolyBool.selectDifferenceRev);
		},
		xor: function(poly1, poly2){
			return operate(poly1, poly2, PolyBool.selectXor);
		}
	};
	
	function operate(poly1, poly2, selector){
		var seg1 = PolyBool.segments(poly1);
		var seg2 = PolyBool.segments(poly2);
		var comb = PolyBool.combine(seg1, seg2);
		var seg3 = selector(comb);
		return PolyBool.polygon(seg3);
	}
	
	if (typeof window === 'object')
		window.PolyBool = PolyBool;
	
	module.exports = PolyBool;
	
	},{"./lib/build-log":475,"./lib/epsilon":476,"./lib/geojson":477,"./lib/intersecter":478,"./lib/segment-chainer":480,"./lib/segment-selector":481}],475:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// used strictly for logging the processing of the algorithm... only useful if you intend on
	// looking under the covers (for pretty UI's or debugging)
	//
	
	function BuildLog(){
		var my;
		var nextSegmentId = 0;
		var curVert = false;
	
		function push(type, data){
			my.list.push({
				type: type,
				data: data ? JSON.parse(JSON.stringify(data)) : void 0
			});
			return my;
		}
	
		my = {
			list: [],
			segmentId: function(){
				return nextSegmentId++;
			},
			checkIntersection: function(seg1, seg2){
				return push('check', { seg1: seg1, seg2: seg2 });
			},
			segmentChop: function(seg, end){
				push('div_seg', { seg: seg, pt: end });
				return push('chop', { seg: seg, pt: end });
			},
			statusRemove: function(seg){
				return push('pop_seg', { seg: seg });
			},
			segmentUpdate: function(seg){
				return push('seg_update', { seg: seg });
			},
			segmentNew: function(seg, primary){
				return push('new_seg', { seg: seg, primary: primary });
			},
			segmentRemove: function(seg){
				return push('rem_seg', { seg: seg });
			},
			tempStatus: function(seg, above, below){
				return push('temp_status', { seg: seg, above: above, below: below });
			},
			rewind: function(seg){
				return push('rewind', { seg: seg });
			},
			status: function(seg, above, below){
				return push('status', { seg: seg, above: above, below: below });
			},
			vert: function(x){
				if (x === curVert)
					return my;
				curVert = x;
				return push('vert', { x: x });
			},
			log: function(data){
				if (typeof data !== 'string')
					data = JSON.stringify(data, false, '  ');
				return push('log', { txt: data });
			},
			reset: function(){
				return push('reset');
			},
			selected: function(segs){
				return push('selected', { segs: segs });
			},
			chainStart: function(seg){
				return push('chain_start', { seg: seg });
			},
			chainRemoveHead: function(index, pt){
				return push('chain_rem_head', { index: index, pt: pt });
			},
			chainRemoveTail: function(index, pt){
				return push('chain_rem_tail', { index: index, pt: pt });
			},
			chainNew: function(pt1, pt2){
				return push('chain_new', { pt1: pt1, pt2: pt2 });
			},
			chainMatch: function(index){
				return push('chain_match', { index: index });
			},
			chainClose: function(index){
				return push('chain_close', { index: index });
			},
			chainAddHead: function(index, pt){
				return push('chain_add_head', { index: index, pt: pt });
			},
			chainAddTail: function(index, pt){
				return push('chain_add_tail', { index: index, pt: pt, });
			},
			chainConnect: function(index1, index2){
				return push('chain_con', { index1: index1, index2: index2 });
			},
			chainReverse: function(index){
				return push('chain_rev', { index: index });
			},
			chainJoin: function(index1, index2){
				return push('chain_join', { index1: index1, index2: index2 });
			},
			done: function(){
				return push('done');
			}
		};
		return my;
	}
	
	module.exports = BuildLog;
	
	},{}],476:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// provides the raw computation functions that takes epsilon into account
	//
	// zero is defined to be between (-epsilon, epsilon) exclusive
	//
	
	function Epsilon(eps){
		if (typeof eps !== 'number')
			eps = 0.0000000001; // sane default? sure why not
		var my = {
			epsilon: function(v){
				if (typeof v === 'number')
					eps = v;
				return eps;
			},
			pointAboveOrOnLine: function(pt, left, right){
				var Ax = left[0];
				var Ay = left[1];
				var Bx = right[0];
				var By = right[1];
				var Cx = pt[0];
				var Cy = pt[1];
				return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -eps;
			},
			pointBetween: function(p, left, right){
				// p must be collinear with left->right
				// returns false if p == left, p == right, or left == right
				var d_py_ly = p[1] - left[1];
				var d_rx_lx = right[0] - left[0];
				var d_px_lx = p[0] - left[0];
				var d_ry_ly = right[1] - left[1];
	
				var dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
				// if `dot` is 0, then `p` == `left` or `left` == `right` (reject)
				// if `dot` is less than 0, then `p` is to the left of `left` (reject)
				if (dot < eps)
					return false;
	
				var sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
				// if `dot` > `sqlen`, then `p` is to the right of `right` (reject)
				// therefore, if `dot - sqlen` is greater than 0, then `p` is to the right of `right` (reject)
				if (dot - sqlen > -eps)
					return false;
	
				return true;
			},
			pointsSameX: function(p1, p2){
				return Math.abs(p1[0] - p2[0]) < eps;
			},
			pointsSameY: function(p1, p2){
				return Math.abs(p1[1] - p2[1]) < eps;
			},
			pointsSame: function(p1, p2){
				return my.pointsSameX(p1, p2) && my.pointsSameY(p1, p2);
			},
			pointsCompare: function(p1, p2){
				// returns -1 if p1 is smaller, 1 if p2 is smaller, 0 if equal
				if (my.pointsSameX(p1, p2))
					return my.pointsSameY(p1, p2) ? 0 : (p1[1] < p2[1] ? -1 : 1);
				return p1[0] < p2[0] ? -1 : 1;
			},
			pointsCollinear: function(pt1, pt2, pt3){
				// does pt1->pt2->pt3 make a straight line?
				// essentially this is just checking to see if the slope(pt1->pt2) === slope(pt2->pt3)
				// if slopes are equal, then they must be collinear, because they share pt2
				var dx1 = pt1[0] - pt2[0];
				var dy1 = pt1[1] - pt2[1];
				var dx2 = pt2[0] - pt3[0];
				var dy2 = pt2[1] - pt3[1];
				return Math.abs(dx1 * dy2 - dx2 * dy1) < eps;
			},
			linesIntersect: function(a0, a1, b0, b1){
				// returns false if the lines are coincident (e.g., parallel or on top of each other)
				//
				// returns an object if the lines intersect:
				//   {
				//     pt: [x, y],    where the intersection point is at
				//     alongA: where intersection point is along A,
				//     alongB: where intersection point is along B
				//   }
				//
				//  alongA and alongB will each be one of: -2, -1, 0, 1, 2
				//
				//  with the following meaning:
				//
				//    -2   intersection point is before segment's first point
				//    -1   intersection point is directly on segment's first point
				//     0   intersection point is between segment's first and second points (exclusive)
				//     1   intersection point is directly on segment's second point
				//     2   intersection point is after segment's second point
				var adx = a1[0] - a0[0];
				var ady = a1[1] - a0[1];
				var bdx = b1[0] - b0[0];
				var bdy = b1[1] - b0[1];
	
				var axb = adx * bdy - ady * bdx;
				if (Math.abs(axb) < eps)
					return false; // lines are coincident
	
				var dx = a0[0] - b0[0];
				var dy = a0[1] - b0[1];
	
				var A = (bdx * dy - bdy * dx) / axb;
				var B = (adx * dy - ady * dx) / axb;
	
				var ret = {
					alongA: 0,
					alongB: 0,
					pt: [
						a0[0] + A * adx,
						a0[1] + A * ady
					]
				};
	
				// categorize where intersection point is along A and B
	
				if (A <= -eps)
					ret.alongA = -2;
				else if (A < eps)
					ret.alongA = -1;
				else if (A - 1 <= -eps)
					ret.alongA = 0;
				else if (A - 1 < eps)
					ret.alongA = 1;
				else
					ret.alongA = 2;
	
				if (B <= -eps)
					ret.alongB = -2;
				else if (B < eps)
					ret.alongB = -1;
				else if (B - 1 <= -eps)
					ret.alongB = 0;
				else if (B - 1 < eps)
					ret.alongB = 1;
				else
					ret.alongB = 2;
	
				return ret;
			},
			pointInsideRegion: function(pt, region){
				var x = pt[0];
				var y = pt[1];
				var last_x = region[region.length - 1][0];
				var last_y = region[region.length - 1][1];
				var inside = false;
				for (var i = 0; i < region.length; i++){
					var curr_x = region[i][0];
					var curr_y = region[i][1];
	
					// if y is between curr_y and last_y, and
					// x is to the right of the boundary created by the line
					if ((curr_y - y > eps) != (last_y - y > eps) &&
						(last_x - curr_x) * (y - curr_y) / (last_y - curr_y) + curr_x - x > eps)
						inside = !inside
	
					last_x = curr_x;
					last_y = curr_y;
				}
				return inside;
			}
		};
		return my;
	}
	
	module.exports = Epsilon;
	
	},{}],477:[function(_dereq_,module,exports){
	// (c) Copyright 2017, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// convert between PolyBool polygon format and GeoJSON formats (Polygon and MultiPolygon)
	//
	
	var GeoJSON = {
		// convert a GeoJSON object to a PolyBool polygon
		toPolygon: function(PolyBool, geojson){
	
			// converts list of LineString's to segments
			function GeoPoly(coords){
				// check for empty coords
				if (coords.length <= 0)
					return PolyBool.segments({ inverted: false, regions: [] });
	
				// convert LineString to segments
				function LineString(ls){
					// remove tail which should be the same as head
					var reg = ls.slice(0, ls.length - 1);
					return PolyBool.segments({ inverted: false, regions: [reg] });
				}
	
				// the first LineString is considered the outside
				var out = LineString(coords[0]);
	
				// the rest of the LineStrings are considered interior holes, so subtract them from the
				// current result
				for (var i = 1; i < coords.length; i++)
					out = PolyBool.selectDifference(PolyBool.combine(out, LineString(coords[i])));
	
				return out;
			}
	
			if (geojson.type === 'Polygon'){
				// single polygon, so just convert it and we're done
				return PolyBool.polygon(GeoPoly(geojson.coordinates));
			}
			else if (geojson.type === 'MultiPolygon'){
				// multiple polygons, so union all the polygons together
				var out = PolyBool.segments({ inverted: false, regions: [] });
				for (var i = 0; i < geojson.coordinates.length; i++)
					out = PolyBool.selectUnion(PolyBool.combine(out, GeoPoly(geojson.coordinates[i])));
				return PolyBool.polygon(out);
			}
			throw new Error('PolyBool: Cannot convert GeoJSON object to PolyBool polygon');
		},
	
		// convert a PolyBool polygon to a GeoJSON object
		fromPolygon: function(PolyBool, eps, poly){
			// make sure out polygon is clean
			poly = PolyBool.polygon(PolyBool.segments(poly));
	
			// test if r1 is inside r2
			function regionInsideRegion(r1, r2){
				// we're guaranteed no lines intersect (because the polygon is clean), but a vertex
				// could be on the edge -- so we just average pt[0] and pt[1] to produce a point on the
				// edge of the first line, which cannot be on an edge
				return eps.pointInsideRegion([
					(r1[0][0] + r1[1][0]) * 0.5,
					(r1[0][1] + r1[1][1]) * 0.5
				], r2);
			}
	
			// calculate inside heirarchy
			//
			//  _____________________   _______    roots -> A       -> F
			// |          A          | |   F   |            |          |
			// |  _______   _______  | |  ___  |            +-- B      +-- G
			// | |   B   | |   C   | | | |   | |            |   |
			// | |  ___  | |  ___  | | | |   | |            |   +-- D
			// | | | D | | | | E | | | | | G | |            |
			// | | |___| | | |___| | | | |   | |            +-- C
			// | |_______| |_______| | | |___| |                |
			// |_____________________| |_______|                +-- E
	
			function newNode(region){
				return {
					region: region,
					children: []
				};
			}
	
			var roots = newNode(null);
	
			function addChild(root, region){
				// first check if we're inside any children
				for (var i = 0; i < root.children.length; i++){
					var child = root.children[i];
					if (regionInsideRegion(region, child.region)){
						// we are, so insert inside them instead
						addChild(child, region);
						return;
					}
				}
	
				// not inside any children, so check to see if any children are inside us
				var node = newNode(region);
				for (var i = 0; i < root.children.length; i++){
					var child = root.children[i];
					if (regionInsideRegion(child.region, region)){
						// oops... move the child beneath us, and remove them from root
						node.children.push(child);
						root.children.splice(i, 1);
						i--;
					}
				}
	
				// now we can add ourselves
				root.children.push(node);
			}
	
			// add all regions to the root
			for (var i = 0; i < poly.regions.length; i++){
				var region = poly.regions[i];
				if (region.length < 3) // regions must have at least 3 points (sanity check)
					continue;
				addChild(roots, region);
			}
	
			// with our heirarchy, we can distinguish between exterior borders, and interior holes
			// the root nodes are exterior, children are interior, children's children are exterior,
			// children's children's children are interior, etc
	
			// while we're at it, exteriors are counter-clockwise, and interiors are clockwise
	
			function forceWinding(region, clockwise){
				// first, see if we're clockwise or counter-clockwise
				// https://en.wikipedia.org/wiki/Shoelace_formula
				var winding = 0;
				var last_x = region[region.length - 1][0];
				var last_y = region[region.length - 1][1];
				var copy = [];
				for (var i = 0; i < region.length; i++){
					var curr_x = region[i][0];
					var curr_y = region[i][1];
					copy.push([curr_x, curr_y]); // create a copy while we're at it
					winding += curr_y * last_x - curr_x * last_y;
					last_x = curr_x;
					last_y = curr_y;
				}
				// this assumes Cartesian coordinates (Y is positive going up)
				var isclockwise = winding < 0;
				if (isclockwise !== clockwise)
					copy.reverse();
				// while we're here, the last point must be the first point...
				copy.push([copy[0][0], copy[0][1]]);
				return copy;
			}
	
			var geopolys = [];
	
			function addExterior(node){
				var poly = [forceWinding(node.region, false)];
				geopolys.push(poly);
				// children of exteriors are interior
				for (var i = 0; i < node.children.length; i++)
					poly.push(getInterior(node.children[i]));
			}
	
			function getInterior(node){
				// children of interiors are exterior
				for (var i = 0; i < node.children.length; i++)
					addExterior(node.children[i]);
				// return the clockwise interior
				return forceWinding(node.region, true);
			}
	
			// root nodes are exterior
			for (var i = 0; i < roots.children.length; i++)
				addExterior(roots.children[i]);
	
			// lastly, construct the approrpriate GeoJSON object
	
			if (geopolys.length <= 0) // empty GeoJSON Polygon
				return { type: 'Polygon', coordinates: [] };
			if (geopolys.length == 1) // use a GeoJSON Polygon
				return { type: 'Polygon', coordinates: geopolys[0] };
			return { // otherwise, use a GeoJSON MultiPolygon
				type: 'MultiPolygon',
				coordinates: geopolys
			};
		}
	};
	
	module.exports = GeoJSON;
	
	},{}],478:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// this is the core work-horse
	//
	
	var LinkedList = _dereq_('./linked-list');
	
	function Intersecter(selfIntersection, eps, buildLog){
		// selfIntersection is true/false depending on the phase of the overall algorithm
	
		//
		// segment creation
		//
	
		function segmentNew(start, end){
			return {
				id: buildLog ? buildLog.segmentId() : -1,
				start: start,
				end: end,
				myFill: {
					above: null, // is there fill above us?
					below: null  // is there fill below us?
				},
				otherFill: null
			};
		}
	
		function segmentCopy(start, end, seg){
			return {
				id: buildLog ? buildLog.segmentId() : -1,
				start: start,
				end: end,
				myFill: {
					above: seg.myFill.above,
					below: seg.myFill.below
				},
				otherFill: null
			};
		}
	
		//
		// event logic
		//
	
		var event_root = LinkedList.create();
	
		function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2){
			// compare the selected points first
			var comp = eps.pointsCompare(p1_1, p2_1);
			if (comp !== 0)
				return comp;
			// the selected points are the same
	
			if (eps.pointsSame(p1_2, p2_2)) // if the non-selected points are the same too...
				return 0; // then the segments are equal
	
			if (p1_isStart !== p2_isStart) // if one is a start and the other isn't...
				return p1_isStart ? 1 : -1; // favor the one that isn't the start
	
			// otherwise, we'll have to calculate which one is below the other manually
			return eps.pointAboveOrOnLine(p1_2,
				p2_isStart ? p2_1 : p2_2, // order matters
				p2_isStart ? p2_2 : p2_1
			) ? 1 : -1;
		}
	
		function eventAdd(ev, other_pt){
			event_root.insertBefore(ev, function(here){
				// should ev be inserted before here?
				var comp = eventCompare(
					ev  .isStart, ev  .pt,      other_pt,
					here.isStart, here.pt, here.other.pt
				);
				return comp < 0;
			});
		}
	
		function eventAddSegmentStart(seg, primary){
			var ev_start = LinkedList.node({
				isStart: true,
				pt: seg.start,
				seg: seg,
				primary: primary,
				other: null,
				status: null
			});
			eventAdd(ev_start, seg.end);
			return ev_start;
		}
	
		function eventAddSegmentEnd(ev_start, seg, primary){
			var ev_end = LinkedList.node({
				isStart: false,
				pt: seg.end,
				seg: seg,
				primary: primary,
				other: ev_start,
				status: null
			});
			ev_start.other = ev_end;
			eventAdd(ev_end, ev_start.pt);
		}
	
		function eventAddSegment(seg, primary){
			var ev_start = eventAddSegmentStart(seg, primary);
			eventAddSegmentEnd(ev_start, seg, primary);
			return ev_start;
		}
	
		function eventUpdateEnd(ev, end){
			// slides an end backwards
			//   (start)------------(end)    to:
			//   (start)---(end)
	
			if (buildLog)
				buildLog.segmentChop(ev.seg, end);
	
			ev.other.remove();
			ev.seg.end = end;
			ev.other.pt = end;
			eventAdd(ev.other, ev.pt);
		}
	
		function eventDivide(ev, pt){
			var ns = segmentCopy(pt, ev.seg.end, ev.seg);
			eventUpdateEnd(ev, pt);
			return eventAddSegment(ns, ev.primary);
		}
	
		function calculate(primaryPolyInverted, secondaryPolyInverted){
			// if selfIntersection is true then there is no secondary polygon, so that isn't used
	
			//
			// status logic
			//
	
			var status_root = LinkedList.create();
	
			function statusCompare(ev1, ev2){
				var a1 = ev1.seg.start;
				var a2 = ev1.seg.end;
				var b1 = ev2.seg.start;
				var b2 = ev2.seg.end;
	
				if (eps.pointsCollinear(a1, b1, b2)){
					if (eps.pointsCollinear(a2, b1, b2))
						return 1;//eventCompare(true, a1, a2, true, b1, b2);
					return eps.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
				}
				return eps.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
			}
	
			function statusFindSurrounding(ev){
				return status_root.findTransition(function(here){
					var comp = statusCompare(ev, here.ev);
					return comp > 0;
				});
			}
	
			function checkIntersection(ev1, ev2){
				// returns the segment equal to ev1, or false if nothing equal
	
				var seg1 = ev1.seg;
				var seg2 = ev2.seg;
				var a1 = seg1.start;
				var a2 = seg1.end;
				var b1 = seg2.start;
				var b2 = seg2.end;
	
				if (buildLog)
					buildLog.checkIntersection(seg1, seg2);
	
				var i = eps.linesIntersect(a1, a2, b1, b2);
	
				if (i === false){
					// segments are parallel or coincident
	
					// if points aren't collinear, then the segments are parallel, so no intersections
					if (!eps.pointsCollinear(a1, a2, b1))
						return false;
					// otherwise, segments are on top of each other somehow (aka coincident)
	
					if (eps.pointsSame(a1, b2) || eps.pointsSame(a2, b1))
						return false; // segments touch at endpoints... no intersection
	
					var a1_equ_b1 = eps.pointsSame(a1, b1);
					var a2_equ_b2 = eps.pointsSame(a2, b2);
	
					if (a1_equ_b1 && a2_equ_b2)
						return ev2; // segments are exactly equal
	
					var a1_between = !a1_equ_b1 && eps.pointBetween(a1, b1, b2);
					var a2_between = !a2_equ_b2 && eps.pointBetween(a2, b1, b2);
	
					// handy for debugging:
					// buildLog.log({
					//	a1_equ_b1: a1_equ_b1,
					//	a2_equ_b2: a2_equ_b2,
					//	a1_between: a1_between,
					//	a2_between: a2_between
					// });
	
					if (a1_equ_b1){
						if (a2_between){
							//  (a1)---(a2)
							//  (b1)----------(b2)
							eventDivide(ev2, a2);
						}
						else{
							//  (a1)----------(a2)
							//  (b1)---(b2)
							eventDivide(ev1, b2);
						}
						return ev2;
					}
					else if (a1_between){
						if (!a2_equ_b2){
							// make a2 equal to b2
							if (a2_between){
								//         (a1)---(a2)
								//  (b1)-----------------(b2)
								eventDivide(ev2, a2);
							}
							else{
								//         (a1)----------(a2)
								//  (b1)----------(b2)
								eventDivide(ev1, b2);
							}
						}
	
						//         (a1)---(a2)
						//  (b1)----------(b2)
						eventDivide(ev2, a1);
					}
				}
				else{
					// otherwise, lines intersect at i.pt, which may or may not be between the endpoints
	
					// is A divided between its endpoints? (exclusive)
					if (i.alongA === 0){
						if (i.alongB === -1) // yes, at exactly b1
							eventDivide(ev1, b1);
						else if (i.alongB === 0) // yes, somewhere between B's endpoints
							eventDivide(ev1, i.pt);
						else if (i.alongB === 1) // yes, at exactly b2
							eventDivide(ev1, b2);
					}
	
					// is B divided between its endpoints? (exclusive)
					if (i.alongB === 0){
						if (i.alongA === -1) // yes, at exactly a1
							eventDivide(ev2, a1);
						else if (i.alongA === 0) // yes, somewhere between A's endpoints (exclusive)
							eventDivide(ev2, i.pt);
						else if (i.alongA === 1) // yes, at exactly a2
							eventDivide(ev2, a2);
					}
				}
				return false;
			}
	
			//
			// main event loop
			//
			var segments = [];
			while (!event_root.isEmpty()){
				var ev = event_root.getHead();
	
				if (buildLog)
					buildLog.vert(ev.pt[0]);
	
				if (ev.isStart){
	
					if (buildLog)
						buildLog.segmentNew(ev.seg, ev.primary);
	
					var surrounding = statusFindSurrounding(ev);
					var above = surrounding.before ? surrounding.before.ev : null;
					var below = surrounding.after ? surrounding.after.ev : null;
	
					if (buildLog){
						buildLog.tempStatus(
							ev.seg,
							above ? above.seg : false,
							below ? below.seg : false
						);
					}
	
					function checkBothIntersections(){
						if (above){
							var eve = checkIntersection(ev, above);
							if (eve)
								return eve;
						}
						if (below)
							return checkIntersection(ev, below);
						return false;
					}
	
					var eve = checkBothIntersections();
					if (eve){
						// ev and eve are equal
						// we'll keep eve and throw away ev
	
						// merge ev.seg's fill information into eve.seg
	
						if (selfIntersection){
							var toggle; // are we a toggling edge?
							if (ev.seg.myFill.below === null)
								toggle = true;
							else
								toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
	
							// merge two segments that belong to the same polygon
							// think of this as sandwiching two segments together, where `eve.seg` is
							// the bottom -- this will cause the above fill flag to toggle
							if (toggle)
								eve.seg.myFill.above = !eve.seg.myFill.above;
						}
						else{
							// merge two segments that belong to different polygons
							// each segment has distinct knowledge, so no special logic is needed
							// note that this can only happen once per segment in this phase, because we
							// are guaranteed that all self-intersections are gone
							eve.seg.otherFill = ev.seg.myFill;
						}
	
						if (buildLog)
							buildLog.segmentUpdate(eve.seg);
	
						ev.other.remove();
						ev.remove();
					}
	
					if (event_root.getHead() !== ev){
						// something was inserted before us in the event queue, so loop back around and
						// process it before continuing
						if (buildLog)
							buildLog.rewind(ev.seg);
						continue;
					}
	
					//
					// calculate fill flags
					//
					if (selfIntersection){
						var toggle; // are we a toggling edge?
						if (ev.seg.myFill.below === null) // if we are a new segment...
							toggle = true; // then we toggle
						else // we are a segment that has previous knowledge from a division
							toggle = ev.seg.myFill.above !== ev.seg.myFill.below; // calculate toggle
	
						// next, calculate whether we are filled below us
						if (!below){ // if nothing is below us...
							// we are filled below us if the polygon is inverted
							ev.seg.myFill.below = primaryPolyInverted;
						}
						else{
							// otherwise, we know the answer -- it's the same if whatever is below
							// us is filled above it
							ev.seg.myFill.below = below.seg.myFill.above;
						}
	
						// since now we know if we're filled below us, we can calculate whether
						// we're filled above us by applying toggle to whatever is below us
						if (toggle)
							ev.seg.myFill.above = !ev.seg.myFill.below;
						else
							ev.seg.myFill.above = ev.seg.myFill.below;
					}
					else{
						// now we fill in any missing transition information, since we are all-knowing
						// at this point
	
						if (ev.seg.otherFill === null){
							// if we don't have other information, then we need to figure out if we're
							// inside the other polygon
							var inside;
							if (!below){
								// if nothing is below us, then we're inside if the other polygon is
								// inverted
								inside =
									ev.primary ? secondaryPolyInverted : primaryPolyInverted;
							}
							else{ // otherwise, something is below us
								// so copy the below segment's other polygon's above
								if (ev.primary === below.primary)
									inside = below.seg.otherFill.above;
								else
									inside = below.seg.myFill.above;
							}
							ev.seg.otherFill = {
								above: inside,
								below: inside
							};
						}
					}
	
					if (buildLog){
						buildLog.status(
							ev.seg,
							above ? above.seg : false,
							below ? below.seg : false
						);
					}
	
					// insert the status and remember it for later removal
					ev.other.status = surrounding.insert(LinkedList.node({ ev: ev }));
				}
				else{
					var st = ev.status;
	
					if (st === null){
						throw new Error('PolyBool: Zero-length segment detected; your epsilon is ' +
							'probably too small or too large');
					}
	
					// removing the status will create two new adjacent edges, so we'll need to check
					// for those
					if (status_root.exists(st.prev) && status_root.exists(st.next))
						checkIntersection(st.prev.ev, st.next.ev);
	
					if (buildLog)
						buildLog.statusRemove(st.ev.seg);
	
					// remove the status
					st.remove();
	
					// if we've reached this point, we've calculated everything there is to know, so
					// save the segment for reporting
					if (!ev.primary){
						// make sure `seg.myFill` actually points to the primary polygon though
						var s = ev.seg.myFill;
						ev.seg.myFill = ev.seg.otherFill;
						ev.seg.otherFill = s;
					}
					segments.push(ev.seg);
				}
	
				// remove the event and continue
				event_root.getHead().remove();
			}
	
			if (buildLog)
				buildLog.done();
	
			return segments;
		}
	
		// return the appropriate API depending on what we're doing
		if (!selfIntersection){
			// performing combination of polygons, so only deal with already-processed segments
			return {
				calculate: function(segments1, inverted1, segments2, inverted2){
					// segmentsX come from the self-intersection API, or this API
					// invertedX is whether we treat that list of segments as an inverted polygon or not
					// returns segments that can be used for further operations
					segments1.forEach(function(seg){
						eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
					});
					segments2.forEach(function(seg){
						eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
					});
					return calculate(inverted1, inverted2);
				}
			};
		}
	
		// otherwise, performing self-intersection, so deal with regions
		return {
			addRegion: function(region){
				// regions are a list of points:
				//  [ [0, 0], [100, 0], [50, 100] ]
				// you can add multiple regions before running calculate
				var pt1;
				var pt2 = region[region.length - 1];
				for (var i = 0; i < region.length; i++){
					pt1 = pt2;
					pt2 = region[i];
	
					var forward = eps.pointsCompare(pt1, pt2);
					if (forward === 0) // points are equal, so we have a zero-length segment
						continue; // just skip it
	
					eventAddSegment(
						segmentNew(
							forward < 0 ? pt1 : pt2,
							forward < 0 ? pt2 : pt1
						),
						true
					);
				}
			},
			calculate: function(inverted){
				// is the polygon inverted?
				// returns segments
				return calculate(inverted, false);
			}
		};
	}
	
	module.exports = Intersecter;
	
	},{"./linked-list":479}],479:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// simple linked list implementation that allows you to traverse down nodes and save positions
	//
	
	var LinkedList = {
		create: function(){
			var my = {
				root: { root: true, next: null },
				exists: function(node){
					if (node === null || node === my.root)
						return false;
					return true;
				},
				isEmpty: function(){
					return my.root.next === null;
				},
				getHead: function(){
					return my.root.next;
				},
				insertBefore: function(node, check){
					var last = my.root;
					var here = my.root.next;
					while (here !== null){
						if (check(here)){
							node.prev = here.prev;
							node.next = here;
							here.prev.next = node;
							here.prev = node;
							return;
						}
						last = here;
						here = here.next;
					}
					last.next = node;
					node.prev = last;
					node.next = null;
				},
				findTransition: function(check){
					var prev = my.root;
					var here = my.root.next;
					while (here !== null){
						if (check(here))
							break;
						prev = here;
						here = here.next;
					}
					return {
						before: prev === my.root ? null : prev,
						after: here,
						insert: function(node){
							node.prev = prev;
							node.next = here;
							prev.next = node;
							if (here !== null)
								here.prev = node;
							return node;
						}
					};
				}
			};
			return my;
		},
		node: function(data){
			data.prev = null;
			data.next = null;
			data.remove = function(){
				data.prev.next = data.next;
				if (data.next)
					data.next.prev = data.prev;
				data.prev = null;
				data.next = null;
			};
			return data;
		}
	};
	
	module.exports = LinkedList;
	
	},{}],480:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// converts a list of segments into a list of regions, while also removing unnecessary verticies
	//
	
	function SegmentChainer(segments, eps, buildLog){
		var chains = [];
		var regions = [];
	
		segments.forEach(function(seg){
			var pt1 = seg.start;
			var pt2 = seg.end;
			if (eps.pointsSame(pt1, pt2)){
				console.warn('PolyBool: Warning: Zero-length segment detected; your epsilon is ' +
					'probably too small or too large');
				return;
			}
	
			if (buildLog)
				buildLog.chainStart(seg);
	
			// search for two chains that this segment matches
			var first_match = {
				index: 0,
				matches_head: false,
				matches_pt1: false
			};
			var second_match = {
				index: 0,
				matches_head: false,
				matches_pt1: false
			};
			var next_match = first_match;
			function setMatch(index, matches_head, matches_pt1){
				// return true if we've matched twice
				next_match.index = index;
				next_match.matches_head = matches_head;
				next_match.matches_pt1 = matches_pt1;
				if (next_match === first_match){
					next_match = second_match;
					return false;
				}
				next_match = null;
				return true; // we've matched twice, we're done here
			}
			for (var i = 0; i < chains.length; i++){
				var chain = chains[i];
				var head  = chain[0];
				var head2 = chain[1];
				var tail  = chain[chain.length - 1];
				var tail2 = chain[chain.length - 2];
				if (eps.pointsSame(head, pt1)){
					if (setMatch(i, true, true))
						break;
				}
				else if (eps.pointsSame(head, pt2)){
					if (setMatch(i, true, false))
						break;
				}
				else if (eps.pointsSame(tail, pt1)){
					if (setMatch(i, false, true))
						break;
				}
				else if (eps.pointsSame(tail, pt2)){
					if (setMatch(i, false, false))
						break;
				}
			}
	
			if (next_match === first_match){
				// we didn't match anything, so create a new chain
				chains.push([ pt1, pt2 ]);
				if (buildLog)
					buildLog.chainNew(pt1, pt2);
				return;
			}
	
			if (next_match === second_match){
				// we matched a single chain
	
				if (buildLog)
					buildLog.chainMatch(first_match.index);
	
				// add the other point to the apporpriate end, and check to see if we've closed the
				// chain into a loop
	
				var index = first_match.index;
				var pt = first_match.matches_pt1 ? pt2 : pt1; // if we matched pt1, then we add pt2, etc
				var addToHead = first_match.matches_head; // if we matched at head, then add to the head
	
				var chain = chains[index];
				var grow  = addToHead ? chain[0] : chain[chain.length - 1];
				var grow2 = addToHead ? chain[1] : chain[chain.length - 2];
				var oppo  = addToHead ? chain[chain.length - 1] : chain[0];
				var oppo2 = addToHead ? chain[chain.length - 2] : chain[1];
	
				if (eps.pointsCollinear(grow2, grow, pt)){
					// grow isn't needed because it's directly between grow2 and pt:
					// grow2 ---grow---> pt
					if (addToHead){
						if (buildLog)
							buildLog.chainRemoveHead(first_match.index, pt);
						chain.shift();
					}
					else{
						if (buildLog)
							buildLog.chainRemoveTail(first_match.index, pt);
						chain.pop();
					}
					grow = grow2; // old grow is gone... new grow is what grow2 was
				}
	
				if (eps.pointsSame(oppo, pt)){
					// we're closing the loop, so remove chain from chains
					chains.splice(index, 1);
	
					if (eps.pointsCollinear(oppo2, oppo, grow)){
						// oppo isn't needed because it's directly between oppo2 and grow:
						// oppo2 ---oppo--->grow
						if (addToHead){
							if (buildLog)
								buildLog.chainRemoveTail(first_match.index, grow);
							chain.pop();
						}
						else{
							if (buildLog)
								buildLog.chainRemoveHead(first_match.index, grow);
							chain.shift();
						}
					}
	
					if (buildLog)
						buildLog.chainClose(first_match.index);
	
					// we have a closed chain!
					regions.push(chain);
					return;
				}
	
				// not closing a loop, so just add it to the apporpriate side
				if (addToHead){
					if (buildLog)
						buildLog.chainAddHead(first_match.index, pt);
					chain.unshift(pt);
				}
				else{
					if (buildLog)
						buildLog.chainAddTail(first_match.index, pt);
					chain.push(pt);
				}
				return;
			}
	
			// otherwise, we matched two chains, so we need to combine those chains together
	
			function reverseChain(index){
				if (buildLog)
					buildLog.chainReverse(index);
				chains[index].reverse(); // gee, that's easy
			}
	
			function appendChain(index1, index2){
				// index1 gets index2 appended to it, and index2 is removed
				var chain1 = chains[index1];
				var chain2 = chains[index2];
				var tail  = chain1[chain1.length - 1];
				var tail2 = chain1[chain1.length - 2];
				var head  = chain2[0];
				var head2 = chain2[1];
	
				if (eps.pointsCollinear(tail2, tail, head)){
					// tail isn't needed because it's directly between tail2 and head
					// tail2 ---tail---> head
					if (buildLog)
						buildLog.chainRemoveTail(index1, tail);
					chain1.pop();
					tail = tail2; // old tail is gone... new tail is what tail2 was
				}
	
				if (eps.pointsCollinear(tail, head, head2)){
					// head isn't needed because it's directly between tail and head2
					// tail ---head---> head2
					if (buildLog)
						buildLog.chainRemoveHead(index2, head);
					chain2.shift();
				}
	
				if (buildLog)
					buildLog.chainJoin(index1, index2);
				chains[index1] = chain1.concat(chain2);
				chains.splice(index2, 1);
			}
	
			var F = first_match.index;
			var S = second_match.index;
	
			if (buildLog)
				buildLog.chainConnect(F, S);
	
			var reverseF = chains[F].length < chains[S].length; // reverse the shorter chain, if needed
			if (first_match.matches_head){
				if (second_match.matches_head){
					if (reverseF){
						// <<<< F <<<< --- >>>> S >>>>
						reverseChain(F);
						// >>>> F >>>> --- >>>> S >>>>
						appendChain(F, S);
					}
					else{
						// <<<< F <<<< --- >>>> S >>>>
						reverseChain(S);
						// <<<< F <<<< --- <<<< S <<<<   logically same as:
						// >>>> S >>>> --- >>>> F >>>>
						appendChain(S, F);
					}
				}
				else{
					// <<<< F <<<< --- <<<< S <<<<   logically same as:
					// >>>> S >>>> --- >>>> F >>>>
					appendChain(S, F);
				}
			}
			else{
				if (second_match.matches_head){
					// >>>> F >>>> --- >>>> S >>>>
					appendChain(F, S);
				}
				else{
					if (reverseF){
						// >>>> F >>>> --- <<<< S <<<<
						reverseChain(F);
						// <<<< F <<<< --- <<<< S <<<<   logically same as:
						// >>>> S >>>> --- >>>> F >>>>
						appendChain(S, F);
					}
					else{
						// >>>> F >>>> --- <<<< S <<<<
						reverseChain(S);
						// >>>> F >>>> --- >>>> S >>>>
						appendChain(F, S);
					}
				}
			}
		});
	
		return regions;
	}
	
	module.exports = SegmentChainer;
	
	},{}],481:[function(_dereq_,module,exports){
	// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
	// MIT License
	// Project Home: https://github.com/voidqk/polybooljs
	
	//
	// filter a list of segments based on boolean operations
	//
	
	function select(segments, selection, buildLog){
		var result = [];
		segments.forEach(function(seg){
			var index =
				(seg.myFill.above ? 8 : 0) +
				(seg.myFill.below ? 4 : 0) +
				((seg.otherFill && seg.otherFill.above) ? 2 : 0) +
				((seg.otherFill && seg.otherFill.below) ? 1 : 0);
			if (selection[index] !== 0){
				// copy the segment to the results, while also calculating the fill status
				result.push({
					id: buildLog ? buildLog.segmentId() : -1,
					start: seg.start,
					end: seg.end,
					myFill: {
						above: selection[index] === 1, // 1 if filled above
						below: selection[index] === 2  // 2 if filled below
					},
					otherFill: null
				});
			}
		});
	
		if (buildLog)
			buildLog.selected(result);
	
		return result;
	}
	
	var SegmentSelector = {
		union: function(segments, buildLog){ // primary | secondary
			// above1 below1 above2 below2    Keep?               Value
			//    0      0      0      0   =>   no                  0
			//    0      0      0      1   =>   yes filled below    2
			//    0      0      1      0   =>   yes filled above    1
			//    0      0      1      1   =>   no                  0
			//    0      1      0      0   =>   yes filled below    2
			//    0      1      0      1   =>   yes filled below    2
			//    0      1      1      0   =>   no                  0
			//    0      1      1      1   =>   no                  0
			//    1      0      0      0   =>   yes filled above    1
			//    1      0      0      1   =>   no                  0
			//    1      0      1      0   =>   yes filled above    1
			//    1      0      1      1   =>   no                  0
			//    1      1      0      0   =>   no                  0
			//    1      1      0      1   =>   no                  0
			//    1      1      1      0   =>   no                  0
			//    1      1      1      1   =>   no                  0
			return select(segments, [
				0, 2, 1, 0,
				2, 2, 0, 0,
				1, 0, 1, 0,
				0, 0, 0, 0
			], buildLog);
		},
		intersect: function(segments, buildLog){ // primary & secondary
			// above1 below1 above2 below2    Keep?               Value
			//    0      0      0      0   =>   no                  0
			//    0      0      0      1   =>   no                  0
			//    0      0      1      0   =>   no                  0
			//    0      0      1      1   =>   no                  0
			//    0      1      0      0   =>   no                  0
			//    0      1      0      1   =>   yes filled below    2
			//    0      1      1      0   =>   no                  0
			//    0      1      1      1   =>   yes filled below    2
			//    1      0      0      0   =>   no                  0
			//    1      0      0      1   =>   no                  0
			//    1      0      1      0   =>   yes filled above    1
			//    1      0      1      1   =>   yes filled above    1
			//    1      1      0      0   =>   no                  0
			//    1      1      0      1   =>   yes filled below    2
			//    1      1      1      0   =>   yes filled above    1
			//    1      1      1      1   =>   no                  0
			return select(segments, [
				0, 0, 0, 0,
				0, 2, 0, 2,
				0, 0, 1, 1,
				0, 2, 1, 0
			], buildLog);
		},
		difference: function(segments, buildLog){ // primary - secondary
			// above1 below1 above2 below2    Keep?               Value
			//    0      0      0      0   =>   no                  0
			//    0      0      0      1   =>   no                  0
			//    0      0      1      0   =>   no                  0
			//    0      0      1      1   =>   no                  0
			//    0      1      0      0   =>   yes filled below    2
			//    0      1      0      1   =>   no                  0
			//    0      1      1      0   =>   yes filled below    2
			//    0      1      1      1   =>   no                  0
			//    1      0      0      0   =>   yes filled above    1
			//    1      0      0      1   =>   yes filled above    1
			//    1      0      1      0   =>   no                  0
			//    1      0      1      1   =>   no                  0
			//    1      1      0      0   =>   no                  0
			//    1      1      0      1   =>   yes filled above    1
			//    1      1      1      0   =>   yes filled below    2
			//    1      1      1      1   =>   no                  0
			return select(segments, [
				0, 0, 0, 0,
				2, 0, 2, 0,
				1, 1, 0, 0,
				0, 1, 2, 0
			], buildLog);
		},
		differenceRev: function(segments, buildLog){ // secondary - primary
			// above1 below1 above2 below2    Keep?               Value
			//    0      0      0      0   =>   no                  0
			//    0      0      0      1   =>   yes filled below    2
			//    0      0      1      0   =>   yes filled above    1
			//    0      0      1      1   =>   no                  0
			//    0      1      0      0   =>   no                  0
			//    0      1      0      1   =>   no                  0
			//    0      1      1      0   =>   yes filled above    1
			//    0      1      1      1   =>   yes filled above    1
			//    1      0      0      0   =>   no                  0
			//    1      0      0      1   =>   yes filled below    2
			//    1      0      1      0   =>   no                  0
			//    1      0      1      1   =>   yes filled below    2
			//    1      1      0      0   =>   no                  0
			//    1      1      0      1   =>   no                  0
			//    1      1      1      0   =>   no                  0
			//    1      1      1      1   =>   no                  0
			return select(segments, [
				0, 2, 1, 0,
				0, 0, 1, 1,
				0, 2, 0, 2,
				0, 0, 0, 0
			], buildLog);
		},
		xor: function(segments, buildLog){ // primary ^ secondary
			// above1 below1 above2 below2    Keep?               Value
			//    0      0      0      0   =>   no                  0
			//    0      0      0      1   =>   yes filled below    2
			//    0      0      1      0   =>   yes filled above    1
			//    0      0      1      1   =>   no                  0
			//    0      1      0      0   =>   yes filled below    2
			//    0      1      0      1   =>   no                  0
			//    0      1      1      0   =>   no                  0
			//    0      1      1      1   =>   yes filled above    1
			//    1      0      0      0   =>   yes filled above    1
			//    1      0      0      1   =>   no                  0
			//    1      0      1      0   =>   no                  0
			//    1      0      1      1   =>   yes filled below    2
			//    1      1      0      0   =>   no                  0
			//    1      1      0      1   =>   yes filled above    1
			//    1      1      1      0   =>   yes filled below    2
			//    1      1      1      1   =>   no                  0
			return select(segments, [
				0, 2, 1, 0,
				2, 0, 0, 1,
				1, 0, 0, 2,
				0, 1, 2, 0
			], buildLog);
		}
	};
	
	module.exports = SegmentSelector;
	
	},{}],482:[function(_dereq_,module,exports){
	//Optimized version for triangle closest point
	// Based on Eberly's WildMagick codes
	// http://www.geometrictools.com/LibMathematics/Distance/Distance.html
	"use strict";
	
	var diff = new Float64Array(4);
	var edge0 = new Float64Array(4);
	var edge1 = new Float64Array(4);
	
	function closestPoint2d(V0, V1, V2, point, result) {
	  //Reallocate buffers if necessary
	  if(diff.length < point.length) {
	    diff = new Float64Array(point.length);
	    edge0 = new Float64Array(point.length);
	    edge1 = new Float64Array(point.length);
	  }
	  //Compute edges
	  for(var i=0; i<point.length; ++i) {
	    diff[i]  = V0[i] - point[i];
	    edge0[i] = V1[i] - V0[i];
	    edge1[i] = V2[i] - V0[i];
	  }
	  //Compute coefficients for quadratic func
	  var a00 = 0.0
	    , a01 = 0.0
	    , a11 = 0.0
	    , b0  = 0.0
	    , b1  = 0.0
	    , c   = 0.0;
	  for(var i=0; i<point.length; ++i) {
	    var e0 = edge0[i]
	      , e1 = edge1[i]
	      , d  = diff[i];
	    a00 += e0 * e0;
	    a01 += e0 * e1;
	    a11 += e1 * e1;
	    b0  += d * e0;
	    b1  += d * e1;
	    c   += d * d;
	  }
	  //Compute determinant/coeffs
	  var det = Math.abs(a00*a11 - a01*a01);
	  var s   = a01*b1 - a11*b0;
	  var t   = a01*b0 - a00*b1;
	  var sqrDistance;
	  //Hardcoded Voronoi diagram classification
	  if (s + t <= det) {
	    if (s < 0) {
	      if (t < 0) { // region 4
	        if (b0 < 0) {
	          t = 0;
	          if (-b0 >= a00) {
	            s = 1.0;
	            sqrDistance = a00 + 2.0*b0 + c;
	          } else {
	            s = -b0/a00;
	            sqrDistance = b0*s + c;
	          }
	        } else {
	          s = 0;
	          if (b1 >= 0) {
	            t = 0;
	            sqrDistance = c;
	          } else if (-b1 >= a11) {
	            t = 1;
	            sqrDistance = a11 + 2.0*b1 + c;
	          } else {
	            t = -b1/a11;
	            sqrDistance = b1*t + c;
	          }
	        }
	      } else {  // region 3
	        s = 0;
	        if (b1 >= 0) {
	          t = 0;
	          sqrDistance = c;
	        } else if (-b1 >= a11) {
	          t = 1;
	          sqrDistance = a11 + 2.0*b1 + c;
	        } else {
	          t = -b1/a11;
	          sqrDistance = b1*t + c;
	        }
	      }
	    } else if (t < 0) { // region 5
	      t = 0;
	      if (b0 >= 0) {
	        s = 0;
	        sqrDistance = c;
	      } else if (-b0 >= a00) {
	        s = 1;
	        sqrDistance = a00 + 2.0*b0 + c;
	      } else {
	        s = -b0/a00;
	        sqrDistance = b0*s + c;
	      }
	    } else {  // region 0
	      // minimum at interior point
	      var invDet = 1.0 / det;
	      s *= invDet;
	      t *= invDet;
	      sqrDistance = s*(a00*s + a01*t + 2.0*b0) + t*(a01*s + a11*t + 2.0*b1) + c;
	    }
	  } else {
	    var tmp0, tmp1, numer, denom;
	    
	    if (s < 0) {  // region 2
	      tmp0 = a01 + b0;
	      tmp1 = a11 + b1;
	      if (tmp1 > tmp0) {
	        numer = tmp1 - tmp0;
	        denom = a00 - 2.0*a01 + a11;
	        if (numer >= denom) {
	          s = 1;
	          t = 0;
	          sqrDistance = a00 + 2.0*b0 + c;
	        } else {
	          s = numer/denom;
	          t = 1 - s;
	          sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
	          t*(a01*s + a11*t + 2.0*b1) + c;
	        }
	      } else {
	        s = 0;
	        if (tmp1 <= 0) {
	          t = 1;
	          sqrDistance = a11 + 2.0*b1 + c;
	        } else if (b1 >= 0) {
	          t = 0;
	          sqrDistance = c;
	        } else {
	          t = -b1/a11;
	          sqrDistance = b1*t + c;
	        }
	      }
	    } else if (t < 0) {  // region 6
	      tmp0 = a01 + b1;
	      tmp1 = a00 + b0;
	      if (tmp1 > tmp0) {
	        numer = tmp1 - tmp0;
	        denom = a00 - 2.0*a01 + a11;
	        if (numer >= denom) {
	          t = 1;
	          s = 0;
	          sqrDistance = a11 + 2.0*b1 + c;
	        } else {
	          t = numer/denom;
	          s = 1 - t;
	          sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
	          t*(a01*s + a11*t + 2.0*b1) + c;
	        }
	      } else {
	        t = 0;
	        if (tmp1 <= 0) {
	          s = 1;
	          sqrDistance = a00 + 2.0*b0 + c;
	        } else if (b0 >= 0) {
	          s = 0;
	          sqrDistance = c;
	        } else {
	          s = -b0/a00;
	          sqrDistance = b0*s + c;
	        }
	      }
	    } else {  // region 1
	      numer = a11 + b1 - a01 - b0;
	      if (numer <= 0) {
	        s = 0;
	        t = 1;
	        sqrDistance = a11 + 2.0*b1 + c;
	      } else {
	        denom = a00 - 2.0*a01 + a11;
	        if (numer >= denom) {
	          s = 1;
	          t = 0;
	          sqrDistance = a00 + 2.0*b0 + c;
	        } else {
	          s = numer/denom;
	          t = 1 - s;
	          sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
	          t*(a01*s + a11*t + 2.0*b1) + c;
	        }
	      }
	    }
	  }
	  var u = 1.0 - s - t;
	  for(var i=0; i<point.length; ++i) {
	    result[i] = u * V0[i] + s * V1[i] + t * V2[i];
	  }
	  if(sqrDistance < 0) {
	    return 0;
	  }
	  return sqrDistance;
	}
	
	module.exports = closestPoint2d;
	
	},{}],483:[function(_dereq_,module,exports){
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	},{}],484:[function(_dereq_,module,exports){
	module.exports = _dereq_('gl-quat/slerp')
	},{"gl-quat/slerp":295}],485:[function(_dereq_,module,exports){
	(function (global){
	var now = _dereq_('performance-now')
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"performance-now":463}],486:[function(_dereq_,module,exports){
	'use strict'
	
	var bnadd = _dereq_('big-rat/add')
	
	module.exports = add
	
	function add (a, b) {
	  var n = a.length
	  var r = new Array(n)
	  for (var i=0; i<n; ++i) {
	    r[i] = bnadd(a[i], b[i])
	  }
	  return r
	}
	
	},{"big-rat/add":76}],487:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = float2rat
	
	var rat = _dereq_('big-rat')
	
	function float2rat(v) {
	  var result = new Array(v.length)
	  for(var i=0; i<v.length; ++i) {
	    result[i] = rat(v[i])
	  }
	  return result
	}
	
	},{"big-rat":79}],488:[function(_dereq_,module,exports){
	'use strict'
	
	var rat = _dereq_('big-rat')
	var mul = _dereq_('big-rat/mul')
	
	module.exports = muls
	
	function muls(a, x) {
	  var s = rat(x)
	  var n = a.length
	  var r = new Array(n)
	  for(var i=0; i<n; ++i) {
	    r[i] = mul(a[i], s)
	  }
	  return r
	}
	
	},{"big-rat":79,"big-rat/mul":88}],489:[function(_dereq_,module,exports){
	'use strict'
	
	var bnsub = _dereq_('big-rat/sub')
	
	module.exports = sub
	
	function sub(a, b) {
	  var n = a.length
	  var r = new Array(n)
	    for(var i=0; i<n; ++i) {
	    r[i] = bnsub(a[i], b[i])
	  }
	  return r
	}
	
	},{"big-rat/sub":90}],490:[function(_dereq_,module,exports){
	'use strict'
	
	var compareCell = _dereq_('compare-cell')
	var compareOrientedCell = _dereq_('compare-oriented-cell')
	var orientation = _dereq_('cell-orientation')
	
	module.exports = reduceCellComplex
	
	function reduceCellComplex(cells) {
	  cells.sort(compareOrientedCell)
	  var n = cells.length
	  var ptr = 0
	  for(var i=0; i<n; ++i) {
	    var c = cells[i]
	    var o = orientation(c)
	    if(o === 0) {
	      continue
	    }
	    if(ptr > 0) {
	      var f = cells[ptr-1]
	      if(compareCell(c, f) === 0 &&
	         orientation(f)    !== o) {
	        ptr -= 1
	        continue
	      }
	    }
	    cells[ptr++] = c
	  }
	  cells.length = ptr
	  return cells
	}
	
	},{"cell-orientation":113,"compare-cell":129,"compare-oriented-cell":130}],491:[function(_dereq_,module,exports){
	'use strict'
	
	var getBounds = _dereq_('array-bounds')
	var rgba = _dereq_('color-normalize')
	var updateDiff = _dereq_('update-diff')
	var pick = _dereq_('pick-by-alias')
	var extend = _dereq_('object-assign')
	var flatten = _dereq_('flatten-vertex-data')
	var ref = _dereq_('to-float32');
	var float32 = ref.float32;
	var fract32 = ref.fract32;
	
	module.exports = Error2D
	
	var WEIGHTS = [
		//direction, lineWidth shift, capSize shift
	
		// x-error bar
		[1, 0, 0, 1, 0, 0],
		[1, 0, 0, -1, 0, 0],
		[-1, 0, 0, -1, 0, 0],
	
		[-1, 0, 0, -1, 0, 0],
		[-1, 0, 0, 1, 0, 0],
		[1, 0, 0, 1, 0, 0],
	
		// x-error right cap
		[1, 0, -1, 0, 0, 1],
		[1, 0, -1, 0, 0, -1],
		[1, 0, 1, 0, 0, -1],
	
		[1, 0, 1, 0, 0, -1],
		[1, 0, 1, 0, 0, 1],
		[1, 0, -1, 0, 0, 1],
	
		// x-error left cap
		[-1, 0, -1, 0, 0, 1],
		[-1, 0, -1, 0, 0, -1],
		[-1, 0, 1, 0, 0, -1],
	
		[-1, 0, 1, 0, 0, -1],
		[-1, 0, 1, 0, 0, 1],
		[-1, 0, -1, 0, 0, 1],
	
		// y-error bar
		[0, 1, 1, 0, 0, 0],
		[0, 1, -1, 0, 0, 0],
		[0, -1, -1, 0, 0, 0],
	
		[0, -1, -1, 0, 0, 0],
		[0, 1, 1, 0, 0, 0],
		[0, -1, 1, 0, 0, 0],
	
		// y-error top cap
		[0, 1, 0, -1, 1, 0],
		[0, 1, 0, -1, -1, 0],
		[0, 1, 0, 1, -1, 0],
	
		[0, 1, 0, 1, 1, 0],
		[0, 1, 0, -1, 1, 0],
		[0, 1, 0, 1, -1, 0],
	
		// y-error bottom cap
		[0, -1, 0, -1, 1, 0],
		[0, -1, 0, -1, -1, 0],
		[0, -1, 0, 1, -1, 0],
	
		[0, -1, 0, 1, 1, 0],
		[0, -1, 0, -1, 1, 0],
		[0, -1, 0, 1, -1, 0]
	]
	
	
	function Error2D (regl, options) {
		if (typeof regl === 'function') {
			if (!options) { options = {} }
			options.regl = regl
		}
		else {
			options = regl
		}
		if (options.length) { options.positions = options }
		regl = options.regl
	
		if (!regl.hasExtension('ANGLE_instanced_arrays')) {
			throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
		}
	
		// persistent variables
		var gl = regl._gl, drawErrors, positionBuffer, positionFractBuffer, colorBuffer, errorBuffer, meshBuffer,
				defaults = {
					color: 'black',
					capSize: 5,
					lineWidth: 1,
					opacity: 1,
					viewport: null,
					range: null,
					offset: 0,
					count: 0,
					bounds: null,
					positions: [],
					errors: []
				}, groups = []
	
		//color per-point
		colorBuffer = regl.buffer({
			usage: 'dynamic',
			type: 'uint8',
			data: new Uint8Array(0)
		})
		//xy-position per-point
		positionBuffer = regl.buffer({
			usage: 'dynamic',
			type: 'float',
			data: new Uint8Array(0)
		})
		//xy-position float32-fraction
		positionFractBuffer = regl.buffer({
			usage: 'dynamic',
			type: 'float',
			data: new Uint8Array(0)
		})
		//4 errors per-point
		errorBuffer = regl.buffer({
			usage: 'dynamic',
			type: 'float',
			data: new Uint8Array(0)
		})
		//error bar mesh
		meshBuffer = regl.buffer({
			usage: 'static',
			type: 'float',
			data: WEIGHTS
		})
	
		update(options)
	
		//drawing method
		drawErrors = regl({
			vert: "\n\t\tprecision highp float;\n\n\t\tattribute vec2 position, positionFract;\n\t\tattribute vec4 error;\n\t\tattribute vec4 color;\n\n\t\tattribute vec2 direction, lineOffset, capOffset;\n\n\t\tuniform vec4 viewport;\n\t\tuniform float lineWidth, capSize;\n\t\tuniform vec2 scale, scaleFract, translate, translateFract;\n\n\t\tvarying vec4 fragColor;\n\n\t\tvoid main() {\n\t\t\tfragColor = color / 255.;\n\n\t\t\tvec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n\t\t\tvec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n\t\t\tvec2 position = position + dxy;\n\n\t\t\tvec2 pos = (position + translate) * scale\n\t\t\t\t+ (positionFract + translateFract) * scale\n\t\t\t\t+ (position + translate) * scaleFract\n\t\t\t\t+ (positionFract + translateFract) * scaleFract;\n\n\t\t\tpos += pixelOffset / viewport.zw;\n\n\t\t\tgl_Position = vec4(pos * 2. - 1., 0, 1);\n\t\t}\n\t\t",
	
			frag: "\n\t\tprecision highp float;\n\n\t\tvarying vec4 fragColor;\n\n\t\tuniform float opacity;\n\n\t\tvoid main() {\n\t\t\tgl_FragColor = fragColor;\n\t\t\tgl_FragColor.a *= opacity;\n\t\t}\n\t\t",
	
			uniforms: {
				range: regl.prop('range'),
				lineWidth: regl.prop('lineWidth'),
				capSize: regl.prop('capSize'),
				opacity: regl.prop('opacity'),
				scale: regl.prop('scale'),
				translate: regl.prop('translate'),
				scaleFract: regl.prop('scaleFract'),
				translateFract: regl.prop('translateFract'),
				viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
			},
	
			attributes: {
				//dynamic attributes
				color: {
					buffer: colorBuffer,
					offset: function (ctx, prop) { return prop.offset * 4; },
					divisor: 1,
				},
				position: {
					buffer: positionBuffer,
					offset: function (ctx, prop) { return prop.offset * 8; },
					divisor: 1
				},
				positionFract: {
					buffer: positionFractBuffer,
					offset: function (ctx, prop) { return prop.offset * 8; },
					divisor: 1
				},
				error: {
					buffer: errorBuffer,
					offset: function (ctx, prop) { return prop.offset * 16; },
					divisor: 1
				},
	
				//static attributes
				direction: {
					buffer: meshBuffer,
					stride: 24,
					offset: 0
				},
				lineOffset: {
					buffer: meshBuffer,
					stride: 24,
					offset: 8
				},
				capOffset: {
					buffer: meshBuffer,
					stride: 24,
					offset: 16
				}
			},
	
			primitive: 'triangles',
	
			blend: {
				enable: true,
				color: [0,0,0,0],
				equation: {
					rgb: 'add',
					alpha: 'add'
				},
				func: {
					srcRGB: 'src alpha',
					dstRGB: 'one minus src alpha',
					srcAlpha: 'one minus dst alpha',
					dstAlpha: 'one'
				}
			},
	
			depth: {
				enable: false
			},
	
			scissor: {
				enable: true,
				box: regl.prop('viewport')
			},
			viewport: regl.prop('viewport'),
			stencil: false,
	
			instances: regl.prop('count'),
			count: WEIGHTS.length
		})
	
		//expose API
		extend(error2d, {
			update: update,
			draw: draw,
			destroy: destroy,
			regl: regl,
			gl: gl,
			canvas: gl.canvas,
			groups: groups
		})
	
		return error2d
	
		function error2d (opts) {
			//update
			if (opts) {
				update(opts)
			}
	
			//destroy
			else if (opts === null) {
				destroy()
			}
	
			draw()
		}
	
	
		//main draw method
		function draw (options) {
			if (typeof options === 'number') { return drawGroup(options) }
	
			//make options a batch
			if (options && !Array.isArray(options)) { options = [options] }
	
	
			regl._refresh()
	
			//render multiple polylines via regl batch
			groups.forEach(function (s, i) {
				if (!s) { return }
	
				if (options) {
					if (!options[i]) { s.draw = false }
					else { s.draw = true }
				}
	
				//ignore draw flag for one pass
				if (!s.draw) {
					s.draw = true;
					return
				}
	
				drawGroup(i)
			})
		}
	
		//draw single error group by id
		function drawGroup (s) {
			if (typeof s === 'number') { s = groups[s] }
			if (s == null) { return }
	
			if (!(s && s.count && s.color && s.opacity && s.positions && s.positions.length > 1)) { return }
	
			s.scaleRatio = [
				s.scale[0] * s.viewport.width,
				s.scale[1] * s.viewport.height
			]
	
			drawErrors(s)
	
			if (s.after) { s.after(s) }
		}
	
		function update (options) {
			if (!options) { return }
	
			//direct points argument
			if (options.length != null) {
				if (typeof options[0] === 'number') { options = [{positions: options}] }
			}
	
			//make options a batch
			else if (!Array.isArray(options)) { options = [options] }
	
			//global count of points
			var pointCount = 0, errorCount = 0
	
			error2d.groups = groups = options.map(function (options, i) {
				var group = groups[i]
	
				if (!options) { return group }
				else if (typeof options === 'function') { options = {after: options} }
				else if (typeof options[0] === 'number') { options = {positions: options} }
	
				//copy options to avoid mutation & handle aliases
				options = pick(options, {
					color: 'color colors fill',
					capSize: 'capSize cap capsize cap-size',
					lineWidth: 'lineWidth line-width width line thickness',
					opacity: 'opacity alpha',
					range: 'range dataBox',
					viewport: 'viewport viewBox',
					errors: 'errors error',
					positions: 'positions position data points'
				})
	
				if (!group) {
					groups[i] = group = {
						id: i,
						scale: null,
						translate: null,
						scaleFract: null,
						translateFract: null,
						draw: true
					}
					options = extend({}, defaults, options)
				}
	
				updateDiff(group, options, [{
					lineWidth: function (v) { return +v * .5; },
					capSize: function (v) { return +v * .5; },
					opacity: parseFloat,
					errors: function (errors) {
						errors = flatten(errors)
	
						errorCount += errors.length
						return errors
					},
					positions: function (positions, state) {
						positions = flatten(positions, 'float64')
						state.count = Math.floor(positions.length / 2)
						state.bounds = getBounds(positions, 2)
						state.offset = pointCount
	
						pointCount += state.count
	
						return positions
					}
				}, {
					color: function (colors, state) {
						var count = state.count
	
						if (!colors) { colors = 'transparent' }
	
						// 'black' or [0,0,0,0] case
						if (!Array.isArray(colors) || typeof colors[0] === 'number') {
							var color = colors
							colors = Array(count)
							for (var i = 0; i < count; i++) {
								colors[i] = color
							}
						}
	
						if (colors.length < count) { throw Error('Not enough colors') }
	
						var colorData = new Uint8Array(count * 4)
	
						//convert colors to float arrays
						for (var i$1 = 0; i$1 < count; i$1++) {
							var c = rgba(colors[i$1], 'uint8')
							colorData.set(c, i$1 * 4)
						}
	
						return colorData
					},
	
					range: function (range, state, options) {
						var bounds = state.bounds
						if (!range) { range = bounds }
	
						state.scale = [1 / (range[2] - range[0]), 1 / (range[3] - range[1])]
						state.translate = [-range[0], -range[1]]
	
						state.scaleFract = fract32(state.scale)
						state.translateFract = fract32(state.translate)
	
						return range
					},
	
					viewport: function (vp) {
						var viewport
	
						if (Array.isArray(vp)) {
							viewport = {
								x: vp[0],
								y: vp[1],
								width: vp[2] - vp[0],
								height: vp[3] - vp[1]
							}
						}
						else if (vp) {
							viewport = {
								x: vp.x || vp.left || 0,
								y: vp.y || vp.top || 0
							}
	
							if (vp.right) { viewport.width = vp.right - viewport.x }
							else { viewport.width = vp.w || vp.width || 0 }
	
							if (vp.bottom) { viewport.height = vp.bottom - viewport.y }
							else { viewport.height = vp.h || vp.height || 0 }
						}
						else {
							viewport = {
								x: 0, y: 0,
								width: gl.drawingBufferWidth,
								height: gl.drawingBufferHeight
							}
						}
	
						return viewport
					}
				}])
	
				return group
			})
	
			if (pointCount || errorCount) {
				var len = groups.reduce(function (acc, group, i) {
					return acc + (group ? group.count : 0)
				}, 0)
	
				var positionData = new Float64Array(len * 2)
				var colorData = new Uint8Array(len * 4)
				var errorData = new Float32Array(len * 4)
	
				groups.forEach(function (group, i) {
					if (!group) { return }
					var positions = group.positions;
					var count = group.count;
					var offset = group.offset;
					var color = group.color;
					var errors = group.errors;
					if (!count) { return }
	
					colorData.set(color, offset * 4)
					errorData.set(errors, offset * 4)
					positionData.set(positions, offset * 2)
				})
	
				positionBuffer(float32(positionData))
				positionFractBuffer(fract32(positionData))
				colorBuffer(colorData)
				errorBuffer(errorData)
			}
	
		}
	
		function destroy () {
			positionBuffer.destroy()
			positionFractBuffer.destroy()
			colorBuffer.destroy()
			errorBuffer.destroy()
			meshBuffer.destroy()
		}
	}
	
	},{"array-bounds":67,"color-normalize":121,"flatten-vertex-data":229,"object-assign":455,"pick-by-alias":466,"to-float32":536,"update-diff":547}],492:[function(_dereq_,module,exports){
	'use strict'
	
	
	var rgba = _dereq_('color-normalize')
	var getBounds = _dereq_('array-bounds')
	var extend = _dereq_('object-assign')
	var glslify = _dereq_('glslify')
	var pick = _dereq_('pick-by-alias')
	var flatten = _dereq_('flatten-vertex-data')
	var triangulate = _dereq_('earcut')
	var normalize = _dereq_('array-normalize')
	var ref = _dereq_('to-float32');
	var float32 = ref.float32;
	var fract32 = ref.fract32;
	var WeakMap = _dereq_('es6-weak-map')
	var parseRect = _dereq_('parse-rect')
	
	
	module.exports = Line2D
	
	
	/** @constructor */
	function Line2D (regl, options) {
		if (!(this instanceof Line2D)) { return new Line2D(regl, options) }
	
		if (typeof regl === 'function') {
			if (!options) { options = {} }
			options.regl = regl
		}
		else {
			options = regl
		}
		if (options.length) { options.positions = options }
		regl = options.regl
	
		if (!regl.hasExtension('ANGLE_instanced_arrays')) {
			throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
		}
	
		// persistent variables
		this.gl = regl._gl
		this.regl = regl
	
		// list of options for lines
		this.passes = []
	
		// cached shaders instance
		this.shaders = Line2D.shaders.has(regl) ? Line2D.shaders.get(regl) : Line2D.shaders.set(regl, Line2D.createShaders(regl)).get(regl)
	
	
		// init defaults
		this.update(options)
	}
	
	
	Line2D.dashMult = 2
	Line2D.maxPatternLength = 256
	Line2D.precisionThreshold = 3e6
	Line2D.maxPoints = 1e4
	Line2D.maxLines = 2048
	
	
	// cache of created draw calls per-regl instance
	Line2D.shaders = new WeakMap()
	
	
	// create static shaders once
	Line2D.createShaders = function (regl) {
		var offsetBuffer = regl.buffer({
			usage: 'static',
			type: 'float',
			data: [0,1, 0,0, 1,1, 1,0]
		})
	
		var shaderOptions = {
			primitive: 'triangle strip',
			instances: regl.prop('count'),
			count: 4,
			offset: 0,
	
			uniforms: {
				miterMode: function (ctx, prop) { return prop.join === 'round' ? 2 : 1; },
				miterLimit: regl.prop('miterLimit'),
				scale: regl.prop('scale'),
				scaleFract: regl.prop('scaleFract'),
				translateFract: regl.prop('translateFract'),
				translate: regl.prop('translate'),
				thickness: regl.prop('thickness'),
				dashPattern: regl.prop('dashTexture'),
				opacity: regl.prop('opacity'),
				pixelRatio: regl.context('pixelRatio'),
				id: regl.prop('id'),
				dashSize: regl.prop('dashLength'),
				viewport: function (c, p) { return [p.viewport.x, p.viewport.y, c.viewportWidth, c.viewportHeight]; },
				depth: regl.prop('depth')
			},
	
			blend: {
				enable: true,
				color: [0,0,0,0],
				equation: {
					rgb: 'add',
					alpha: 'add'
				},
				func: {
					srcRGB: 'src alpha',
					dstRGB: 'one minus src alpha',
					srcAlpha: 'one minus dst alpha',
					dstAlpha: 'one'
				}
			},
			depth: {
				enable: function (c, p) {
					return !p.overlay
				}
			},
			stencil: {enable: false},
			scissor: {
				enable: true,
				box: regl.prop('viewport')
			},
			viewport: regl.prop('viewport')
		}
	
	
		// simplified rectangular line shader
		var drawRectLine = regl(extend({
			vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n\t// the order is important\n\treturn position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineOffset = lineTop * 2. - 1.;\n\n\tvec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n\ttangent = normalize(diff * scale * viewport.zw);\n\tvec2 normal = vec2(-tangent.y, tangent.x);\n\n\tvec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n\t\t+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n\t\t+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n}\n"]),
			frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\n\nuniform float dashSize, pixelRatio, thickness, opacity, id;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n\tfloat alpha = 1.;\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
	
			attributes: {
				// if point is at the end of segment
				lineEnd: {
					buffer: offsetBuffer,
					divisor: 0,
					stride: 8,
					offset: 0
				},
				// if point is at the top of segment
				lineTop: {
					buffer: offsetBuffer,
					divisor: 0,
					stride: 8,
					offset: 4
				},
				// beginning of line coordinate
				aCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 8,
					divisor: 1
				},
				// end of line coordinate
				bCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 16,
					divisor: 1
				},
				aCoordFract: {
					buffer: regl.prop('positionFractBuffer'),
					stride: 8,
					offset: 8,
					divisor: 1
				},
				bCoordFract: {
					buffer: regl.prop('positionFractBuffer'),
					stride: 8,
					offset: 16,
					divisor: 1
				},
				color: {
					buffer: regl.prop('colorBuffer'),
					stride: 4,
					offset: 0,
					divisor: 1
				}
			}
		}, shaderOptions))
	
		// create regl draw
		var drawMiterLine
	
		try {
			drawMiterLine = regl(extend({
				// culling removes polygon creasing
				cull: {
					enable: true,
					face: 'back'
				},
	
				vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n\tvec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n\tvec2 normalWidth = thickness / scaleRatio;\n\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineBot = 1. - lineTop;\n\n\tfragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n\tif (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n\tif (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n\tif (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\tvec2 prevDiff = aCoord - prevCoord;\n\tvec2 currDiff = bCoord - aCoord;\n\tvec2 nextDiff = nextCoord - bCoord;\n\n\tvec2 prevTangent = normalize(prevDiff * scaleRatio);\n\tvec2 currTangent = normalize(currDiff * scaleRatio);\n\tvec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n\tvec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n\tvec2 currNormal = vec2(-currTangent.y, currTangent.x);\n\tvec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n\tvec2 startJoinDirection = normalize(prevTangent - currTangent);\n\tvec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n\t// collapsed/unidirectional segment cases\n\t// FIXME: there should be more elegant solution\n\tvec2 prevTanDiff = abs(prevTangent - currTangent);\n\tvec2 nextTanDiff = abs(nextTangent - currTangent);\n\tif (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n\t\tstartJoinDirection = currNormal;\n\t}\n\tif (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n\t\tendJoinDirection = currNormal;\n\t}\n\tif (aCoord == bCoord) {\n\t\tendJoinDirection = startJoinDirection;\n\t\tcurrNormal = prevNormal;\n\t\tcurrTangent = prevTangent;\n\t}\n\n\ttangent = currTangent;\n\n\t//calculate join shifts relative to normals\n\tfloat startJoinShift = dot(currNormal, startJoinDirection);\n\tfloat endJoinShift = dot(currNormal, endJoinDirection);\n\n\tfloat startMiterRatio = abs(1. / startJoinShift);\n\tfloat endMiterRatio = abs(1. / endJoinShift);\n\n\tvec2 startJoin = startJoinDirection * startMiterRatio;\n\tvec2 endJoin = endJoinDirection * endMiterRatio;\n\n\tvec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n\tstartTopJoin = sign(startJoinShift) * startJoin * .5;\n\tstartBotJoin = -startTopJoin;\n\n\tendTopJoin = sign(endJoinShift) * endJoin * .5;\n\tendBotJoin = -endTopJoin;\n\n\tvec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n\tvec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n\tvec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n\tvec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n\t//miter anti-clipping\n\tfloat baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n\tfloat abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n\t//prevent close to reverse direction switch\n\tbool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\tbool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n\tif (prevReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n\t\taBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\taTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n\t\t//handle miter clipping\n\t\tbTopCoord -= normalWidth * endTopJoin;\n\t\tbTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n\t}\n\n\tif (nextReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n\t\tbBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\tbTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n\t\t//handle miter clipping\n\t\taBotCoord -= normalWidth * startBotJoin;\n\t\taBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n\t}\n\n\tvec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n\tvec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n\tvec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n\tvec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n\t//position is normalized 0..1 coord on the screen\n\tvec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n\tstartCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\tendCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n\tgl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n\tenableStartMiter = step(dot(currTangent, prevTangent), .5);\n\tenableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n\t//bevel miter cutoffs\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n\n\t//round miter cutoffs\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n}\n"]),
				frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\nuniform float dashSize, pixelRatio, thickness, opacity, id, miterMode;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nvoid main() {\n\tfloat alpha = 1., distToStart, distToEnd;\n\tfloat cutoff = thickness * .5;\n\n\t//bevel miter\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToStart + 1., 0.), 1.);\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToEnd + 1., 0.), 1.);\n\t\t}\n\t}\n\n\t// round miter\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - startCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - endCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\t}\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
	
				attributes: {
					// is line end
					lineEnd: {
						buffer: offsetBuffer,
						divisor: 0,
						stride: 8,
						offset: 0
					},
					// is line top
					lineTop: {
						buffer: offsetBuffer,
						divisor: 0,
						stride: 8,
						offset: 4
					},
					// left color
					aColor: {
						buffer: regl.prop('colorBuffer'),
						stride: 4,
						offset: 0,
						divisor: 1
					},
					// right color
					bColor: {
						buffer: regl.prop('colorBuffer'),
						stride: 4,
						offset: 4,
						divisor: 1
					},
					prevCoord: {
						buffer: regl.prop('positionBuffer'),
						stride: 8,
						offset: 0,
						divisor: 1
					},
					aCoord: {
						buffer: regl.prop('positionBuffer'),
						stride: 8,
						offset: 8,
						divisor: 1
					},
					bCoord: {
						buffer: regl.prop('positionBuffer'),
						stride: 8,
						offset: 16,
						divisor: 1
					},
					nextCoord: {
						buffer: regl.prop('positionBuffer'),
						stride: 8,
						offset: 24,
						divisor: 1
					}
				}
			}, shaderOptions))
		} catch (e) {
			// IE/bad Webkit fallback
			drawMiterLine = drawRectLine
		}
	
		// fill shader
		var drawFill = regl({
			primitive: 'triangle',
			elements: function (ctx, prop) { return prop.triangles; },
			offset: 0,
	
			vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n\tfloat depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n\tvec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n\tfragColor.a *= opacity;\n}\n"]),
			frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n\tgl_FragColor = fragColor;\n}\n"]),
	
			uniforms: {
				scale: regl.prop('scale'),
				color: regl.prop('fill'),
				scaleFract: regl.prop('scaleFract'),
				translateFract: regl.prop('translateFract'),
				translate: regl.prop('translate'),
				opacity: regl.prop('opacity'),
				pixelRatio: regl.context('pixelRatio'),
				id: regl.prop('id'),
				viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
			},
	
			attributes: {
				position: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 8
				},
				positionFract: {
					buffer: regl.prop('positionFractBuffer'),
					stride: 8,
					offset: 8
				}
			},
	
			blend: shaderOptions.blend,
	
			depth: { enable: false },
			scissor: shaderOptions.scissor,
			stencil: shaderOptions.stencil,
			viewport: shaderOptions.viewport
		})
	
		return {
			fill: drawFill, rect: drawRectLine, miter: drawMiterLine
		}
	}
	
	
	// used to for new lines instances
	Line2D.defaults = {
		dashes: null,
		join: 'miter',
		miterLimit: 1,
		thickness: 10,
		cap: 'square',
		color: 'black',
		opacity: 1,
		overlay: false,
		viewport: null,
		range: null,
		close: false,
		fill: null
	}
	
	
	Line2D.prototype.render = function () {
		var ref;
	
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		if (args.length) {
			(ref = this).update.apply(ref, args)
		}
	
		this.draw()
	}
	
	
	Line2D.prototype.draw = function () {
		var this$1 = this;
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
	
		// render multiple polylines via regl batch
		(args.length ? args : this.passes).forEach(function (s, i) {
			var ref;
	
			// render array pass as a list of passes
			if (s && Array.isArray(s)) { return (ref = this$1).draw.apply(ref, s) }
	
			if (typeof s === 'number') { s = this$1.passes[s] }
	
			if (!(s && s.count > 1 && s.opacity)) { return }
	
			this$1.regl._refresh()
	
			if (s.fill && s.triangles && s.triangles.length > 2) {
				this$1.shaders.fill(s)
			}
	
			if (!s.thickness) { return }
	
			// high scale is only available for rect mode with precision
			if (s.scale[0] * s.viewport.width > Line2D.precisionThreshold || s.scale[1] * s.viewport.height > Line2D.precisionThreshold) {
				this$1.shaders.rect(s)
			}
	
			// thin this.passes or too many points are rendered as simplified rect shader
			else if (s.join === 'rect' || (!s.join && (s.thickness <= 2 || s.count >= Line2D.maxPoints))) {
				this$1.shaders.rect(s)
			}
			else {
				this$1.shaders.miter(s)
			}
		})
	
		return this
	}
	
	Line2D.prototype.update = function (options) {
		var this$1 = this;
	
		if (!options) { return }
	
		if (options.length != null) {
			if (typeof options[0] === 'number') { options = [{positions: options}] }
		}
	
		// make options a batch
		else if (!Array.isArray(options)) { options = [options] }
	
		var ref = this;
		var regl = ref.regl;
		var gl = ref.gl;
	
		// process per-line settings
		options.forEach(function (o, i) {
			var state = this$1.passes[i]
	
			if (o === undefined) { return }
	
			// null-argument removes pass
			if (o === null) {
				this$1.passes[i] = null
				return
			}
	
			if (typeof o[0] === 'number') { o = {positions: o} }
	
			// handle aliases
			o = pick(o, {
				positions: 'positions points data coords',
				thickness: 'thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth',
				join: 'lineJoin linejoin join type mode',
				miterLimit: 'miterlimit miterLimit',
				dashes: 'dash dashes dasharray dash-array dashArray',
				color: 'color colour stroke colors colours stroke-color strokeColor',
				fill: 'fill fill-color fillColor',
				opacity: 'alpha opacity',
				overlay: 'overlay crease overlap intersect',
				close: 'closed close closed-path closePath',
				range: 'range dataBox',
				viewport: 'viewport viewBox',
				hole: 'holes hole hollow'
			})
	
			// init state
			if (!state) {
				this$1.passes[i] = state = {
					id: i,
					scale: null,
					scaleFract: null,
					translate: null,
					translateFract: null,
					count: 0,
					hole: [],
					depth: 0,
	
					dashLength: 1,
					dashTexture: regl.texture({
						channels: 1,
						data: new Uint8Array([255]),
						width: 1,
						height: 1,
						mag: 'linear',
						min: 'linear'
					}),
	
					colorBuffer: regl.buffer({
						usage: 'dynamic',
						type: 'uint8',
						data: new Uint8Array()
					}),
					positionBuffer: regl.buffer({
						usage: 'dynamic',
						type: 'float',
						data: new Uint8Array()
					}),
					positionFractBuffer: regl.buffer({
						usage: 'dynamic',
						type: 'float',
						data: new Uint8Array()
					})
				}
	
				o = extend({}, Line2D.defaults, o)
			}
			if (o.thickness != null) { state.thickness = parseFloat(o.thickness) }
			if (o.opacity != null) { state.opacity = parseFloat(o.opacity) }
			if (o.miterLimit != null) { state.miterLimit = parseFloat(o.miterLimit) }
			if (o.overlay != null) {
				state.overlay = !!o.overlay
				if (i < Line2D.maxLines) {
					state.depth = 2 * (Line2D.maxLines - 1 - i % Line2D.maxLines) / Line2D.maxLines - 1.;
				}
			}
			if (o.join != null) { state.join = o.join }
			if (o.hole != null) { state.hole = o.hole }
			if (o.fill != null) { state.fill = !o.fill ? null : rgba(o.fill, 'uint8') }
			if (o.viewport != null) { state.viewport = parseRect(o.viewport) }
	
			if (!state.viewport) {
				state.viewport = parseRect([
					gl.drawingBufferWidth,
					gl.drawingBufferHeight
				])
			}
	
			if (o.close != null) { state.close = o.close }
	
			// reset positions
			if (o.positions === null) { o.positions = [] }
			if (o.positions) {
				var positions, count
	
				// if positions are an object with x/y
				if (o.positions.x && o.positions.y) {
					var xPos = o.positions.x
					var yPos = o.positions.y
					count = state.count = Math.max(
						xPos.length,
						yPos.length
					)
					positions = new Float64Array(count * 2)
					for (var i$1 = 0; i$1 < count; i$1++) {
						positions[i$1 * 2] = xPos[i$1]
						positions[i$1 * 2 + 1] = yPos[i$1]
					}
				}
				else {
					positions = flatten(o.positions, 'float64')
					count = state.count = Math.floor(positions.length / 2)
				}
	
				var bounds = state.bounds = getBounds(positions, 2)
	
				// create fill positions
				// FIXME: fill positions can be set only along with positions
				if (state.fill) {
					var pos = []
	
					// filter bad vertices and remap triangles to ensure shape
					var ids = {}
					var lastId = 0
	
					for (var i$2 = 0, ptr = 0, l = state.count; i$2 < l; i$2++) {
						var x = positions[i$2*2]
						var y = positions[i$2*2 + 1]
						if (isNaN(x) || isNaN(y) || x == null || y == null) {
							x = positions[lastId*2]
							y = positions[lastId*2 + 1]
							ids[i$2] = lastId
						}
						else {
							lastId = i$2
						}
						pos[ptr++] = x
						pos[ptr++] = y
					}
	
					var triangles = triangulate(pos, state.hole || [])
	
					for (var i$3 = 0, l$1 = triangles.length; i$3 < l$1; i$3++) {
						if (ids[triangles[i$3]] != null) { triangles[i$3] = ids[triangles[i$3]] }
					}
	
					state.triangles = triangles
				}
	
				// update position buffers
				var npos = new Float64Array(positions)
				normalize(npos, 2, bounds)
	
				var positionData = new Float64Array(count * 2 + 6)
	
				// rotate first segment join
				if (state.close) {
					if (positions[0] === positions[count*2 - 2] &&
						positions[1] === positions[count*2 - 1]) {
						positionData[0] = npos[count*2 - 4]
						positionData[1] = npos[count*2 - 3]
					}
					else {
						positionData[0] = npos[count*2 - 2]
						positionData[1] = npos[count*2 - 1]
					}
				}
				else {
					positionData[0] = npos[0]
					positionData[1] = npos[1]
				}
	
				positionData.set(npos, 2)
	
				// add last segment
				if (state.close) {
					// ignore coinciding start/end
					if (positions[0] === positions[count*2 - 2] &&
						positions[1] === positions[count*2 - 1]) {
						positionData[count*2 + 2] = npos[2]
						positionData[count*2 + 3] = npos[3]
						state.count -= 1
					}
					else {
						positionData[count*2 + 2] = npos[0]
						positionData[count*2 + 3] = npos[1]
						positionData[count*2 + 4] = npos[2]
						positionData[count*2 + 5] = npos[3]
					}
				}
				// add stub
				else {
					positionData[count*2 + 2] = npos[count*2 - 2]
					positionData[count*2 + 3] = npos[count*2 - 1]
					positionData[count*2 + 4] = npos[count*2 - 2]
					positionData[count*2 + 5] = npos[count*2 - 1]
				}
	
				state.positionBuffer(float32(positionData))
				state.positionFractBuffer(fract32(positionData))
			}
	
			if (o.range) {
				state.range = o.range
			} else if (!state.range) {
				state.range = state.bounds
			}
	
			if ((o.range || o.positions) && state.count) {
				var bounds$1 = state.bounds
	
				var boundsW = bounds$1[2] - bounds$1[0],
					boundsH = bounds$1[3] - bounds$1[1]
	
				var rangeW = state.range[2] - state.range[0],
					rangeH = state.range[3] - state.range[1]
	
				state.scale = [
					boundsW / rangeW,
					boundsH / rangeH
				]
				state.translate = [
					-state.range[0] / rangeW + bounds$1[0] / rangeW || 0,
					-state.range[1] / rangeH + bounds$1[1] / rangeH || 0
				]
	
				state.scaleFract = fract32(state.scale)
				state.translateFract = fract32(state.translate)
			}
	
			if (o.dashes) {
				var dashLength = 0., dashData
	
				if (!o.dashes || o.dashes.length < 2) {
					dashLength = 1.
					dashData = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255])
				}
	
				else {
					dashLength = 0.;
					for(var i$4 = 0; i$4 < o.dashes.length; ++i$4) {
						dashLength += o.dashes[i$4]
					}
					dashData = new Uint8Array(dashLength * Line2D.dashMult)
					var ptr$1 = 0
					var fillColor = 255
	
					// repeat texture two times to provide smooth 0-step
					for (var k = 0; k < 2; k++) {
						for(var i$5 = 0; i$5 < o.dashes.length; ++i$5) {
							for(var j = 0, l$2 = o.dashes[i$5] * Line2D.dashMult * .5; j < l$2; ++j) {
								dashData[ptr$1++] = fillColor
							}
							fillColor ^= 255
						}
					}
				}
	
				state.dashLength = dashLength
				state.dashTexture({
					channels: 1,
					data: dashData,
					width: dashData.length,
					height: 1,
					mag: 'linear',
					min: 'linear'
				}, 0, 0)
			}
	
			if (o.color) {
				var count$1 = state.count
				var colors = o.color
	
				if (!colors) { colors = 'transparent' }
	
				var colorData = new Uint8Array(count$1 * 4 + 4)
	
				// convert colors to typed arrays
				if (!Array.isArray(colors) || typeof colors[0] === 'number') {
					var c = rgba(colors, 'uint8')
	
					for (var i$6 = 0; i$6 < count$1 + 1; i$6++) {
						colorData.set(c, i$6 * 4)
					}
				} else {
					for (var i$7 = 0; i$7 < count$1; i$7++) {
						var c$1 = rgba(colors[i$7], 'uint8')
						colorData.set(c$1, i$7 * 4)
					}
					colorData.set(rgba(colors[0], 'uint8'), count$1 * 4)
				}
	
				state.colorBuffer({
					usage: 'dynamic',
					type: 'uint8',
					data: colorData
				})
			}
		})
	
		// remove unmentioned passes
		if (options.length < this.passes.length) {
			for (var i = options.length; i < this.passes.length; i++) {
				var pass = this$1.passes[i]
				if (!pass) { continue }
				pass.colorBuffer.destroy()
				pass.positionBuffer.destroy()
				pass.dashTexture.destroy()
			}
			this.passes.length = options.length
		}
	
		// remove null items
		var passes = []
		for (var i$1 = 0; i$1 < this.passes.length; i$1++) {
			if (this$1.passes[i$1] !== null) { passes.push(this$1.passes[i$1]) }
		}
		this.passes = passes
	
		return this
	}
	
	Line2D.prototype.destroy = function () {
		this.passes.forEach(function (pass) {
			pass.colorBuffer.destroy()
			pass.positionBuffer.destroy()
			pass.dashTexture.destroy()
		})
	
		this.passes.length = 0
	
		return this
	}
	
	},{"array-bounds":67,"array-normalize":493,"color-normalize":121,"earcut":172,"es6-weak-map":494,"flatten-vertex-data":229,"glslify":410,"object-assign":455,"parse-rect":460,"pick-by-alias":466,"to-float32":536}],493:[function(_dereq_,module,exports){
	'use strict'
	
	var getBounds = _dereq_('array-bounds')
	
	module.exports = normalize;
	
	function normalize (arr, dim, bounds) {
		if (!arr || arr.length == null) throw Error('Argument should be an array')
	
		if (dim == null) dim = 1
		if (bounds == null) bounds = getBounds(arr, dim)
	
		for (var offset = 0; offset < dim; offset++) {
			var max = bounds[dim + offset], min = bounds[offset], i = offset, l = arr.length;
	
			if (max === Infinity && min === -Infinity) {
				for (i = offset; i < l; i+=dim) {
					arr[i] = arr[i] === max ? 1 : arr[i] === min ? 0 : .5
				}
			}
			else if (max === Infinity) {
				for (i = offset; i < l; i+=dim) {
					arr[i] = arr[i] === max ? 1 : 0
				}
			}
			else if (min === -Infinity) {
				for (i = offset; i < l; i+=dim) {
					arr[i] = arr[i] === min ? 0 : 1
				}
			}
			else {
				var range = max - min
				for (i = offset; i < l; i+=dim) {
					if (!isNaN(arr[i])) {
						arr[i] = range === 0 ? .5 : (arr[i] - min) / range
					}
				}
			}
		}
	
		return arr;
	}
	
	},{"array-bounds":67}],494:[function(_dereq_,module,exports){
	arguments[4][319][0].apply(exports,arguments)
	},{"./is-implemented":495,"./polyfill":497,"dup":319}],495:[function(_dereq_,module,exports){
	arguments[4][320][0].apply(exports,arguments)
	},{"dup":320}],496:[function(_dereq_,module,exports){
	arguments[4][321][0].apply(exports,arguments)
	},{"dup":321}],497:[function(_dereq_,module,exports){
	arguments[4][322][0].apply(exports,arguments)
	},{"./is-native-implemented":496,"d":152,"dup":322,"es5-ext/object/is-value":196,"es5-ext/object/set-prototype-of":202,"es5-ext/object/valid-object":206,"es5-ext/object/valid-value":207,"es5-ext/string/random-uniq":212,"es6-iterator/for-of":214,"es6-iterator/get":215,"es6-symbol":221}],498:[function(_dereq_,module,exports){
	'use strict';
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	function _iterableToArrayLimit(arr, i) {
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	var rgba = _dereq_('color-normalize');
	
	var getBounds = _dereq_('array-bounds');
	
	var colorId = _dereq_('color-id');
	
	var cluster = _dereq_('point-cluster');
	
	var extend = _dereq_('object-assign');
	
	var glslify = _dereq_('glslify');
	
	var pick = _dereq_('pick-by-alias');
	
	var updateDiff = _dereq_('update-diff');
	
	var flatten = _dereq_('flatten-vertex-data');
	
	var ie = _dereq_('is-iexplorer');
	
	var f32 = _dereq_('to-float32');
	
	var parseRect = _dereq_('parse-rect');
	
	var scatter = Scatter;
	
	function Scatter(regl, options) {
	  var _this = this;
	
	  if (!(this instanceof Scatter)) return new Scatter(regl, options);
	
	  if (typeof regl === 'function') {
	    if (!options) options = {};
	    options.regl = regl;
	  } else {
	    options = regl;
	    regl = null;
	  }
	
	  if (options && options.length) options.positions = options;
	  regl = options.regl; // persistent variables
	
	  var gl = regl._gl,
	      paletteTexture,
	      palette = [],
	      paletteIds = {},
	      // state
	  groups = [],
	      // textures for marker keys
	  markerTextures = [null],
	      markerCache = [null];
	  var maxColors = 255,
	      maxSize = 100; // direct color buffer mode
	  // IE does not support palette anyways
	
	  this.tooManyColors = ie; // texture with color palette
	
	  paletteTexture = regl.texture({
	    data: new Uint8Array(maxColors * 4),
	    width: maxColors,
	    height: 1,
	    type: 'uint8',
	    format: 'rgba',
	    wrapS: 'clamp',
	    wrapT: 'clamp',
	    mag: 'nearest',
	    min: 'nearest'
	  });
	  extend(this, {
	    regl: regl,
	    gl: gl,
	    groups: groups,
	    markerCache: markerCache,
	    markerTextures: markerTextures,
	    palette: palette,
	    paletteIds: paletteIds,
	    paletteTexture: paletteTexture,
	    maxColors: maxColors,
	    maxSize: maxSize,
	    canvas: gl.canvas
	  });
	  this.update(options); // common shader options
	
	  var shaderOptions = {
	    uniforms: {
	      pixelRatio: regl.context('pixelRatio'),
	      palette: paletteTexture,
	      paletteSize: function paletteSize(ctx, prop) {
	        return [_this.tooManyColors ? 0 : maxColors, paletteTexture.height];
	      },
	      scale: regl.prop('scale'),
	      scaleFract: regl.prop('scaleFract'),
	      translate: regl.prop('translate'),
	      translateFract: regl.prop('translateFract'),
	      opacity: regl.prop('opacity'),
	      marker: regl.prop('markerTexture')
	    },
	    attributes: {
	      // FIXME: optimize these parts
	      x: function x(ctx, prop) {
	        return prop.xAttr || {
	          buffer: prop.positionBuffer,
	          stride: 8,
	          offset: 0
	        };
	      },
	      y: function y(ctx, prop) {
	        return prop.yAttr || {
	          buffer: prop.positionBuffer,
	          stride: 8,
	          offset: 4
	        };
	      },
	      xFract: function xFract(ctx, prop) {
	        return prop.xAttr ? {
	          constant: [0, 0]
	        } : {
	          buffer: prop.positionFractBuffer,
	          stride: 8,
	          offset: 0
	        };
	      },
	      yFract: function yFract(ctx, prop) {
	        return prop.yAttr ? {
	          constant: [0, 0]
	        } : {
	          buffer: prop.positionFractBuffer,
	          stride: 8,
	          offset: 4
	        };
	      },
	      size: function size(ctx, prop) {
	        return prop.size.length ? {
	          buffer: prop.sizeBuffer,
	          stride: 2,
	          offset: 0
	        } : {
	          constant: [Math.round(prop.size * 255 / _this.maxSize)]
	        };
	      },
	      borderSize: function borderSize(ctx, prop) {
	        return prop.borderSize.length ? {
	          buffer: prop.sizeBuffer,
	          stride: 2,
	          offset: 1
	        } : {
	          constant: [Math.round(prop.borderSize * 255 / _this.maxSize)]
	        };
	      },
	      colorId: function colorId(ctx, prop) {
	        return prop.color.length ? {
	          buffer: prop.colorBuffer,
	          stride: _this.tooManyColors ? 8 : 4,
	          offset: 0
	        } : {
	          constant: _this.tooManyColors ? palette.slice(prop.color * 4, prop.color * 4 + 4) : [prop.color]
	        };
	      },
	      borderColorId: function borderColorId(ctx, prop) {
	        return prop.borderColor.length ? {
	          buffer: prop.colorBuffer,
	          stride: _this.tooManyColors ? 8 : 4,
	          offset: _this.tooManyColors ? 4 : 2
	        } : {
	          constant: _this.tooManyColors ? palette.slice(prop.borderColor * 4, prop.borderColor * 4 + 4) : [prop.borderColor]
	        };
	      },
	      isActive: function isActive(ctx, prop) {
	        return prop.activation === true ? {
	          constant: [1]
	        } : prop.activation ? prop.activation : {
	          constant: [0]
	        };
	      }
	    },
	    blend: {
	      enable: true,
	      color: [0, 0, 0, 1],
	      // photoshop blending
	      func: {
	        srcRGB: 'src alpha',
	        dstRGB: 'one minus src alpha',
	        srcAlpha: 'one minus dst alpha',
	        dstAlpha: 'one'
	      }
	    },
	    scissor: {
	      enable: true,
	      box: regl.prop('viewport')
	    },
	    viewport: regl.prop('viewport'),
	    stencil: {
	      enable: false
	    },
	    depth: {
	      enable: false
	    },
	    elements: regl.prop('elements'),
	    count: regl.prop('count'),
	    offset: regl.prop('offset'),
	    primitive: 'points' // draw sdf-marker
	
	  };
	  var markerOptions = extend({}, shaderOptions);
	  markerOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nuniform sampler2D marker;\nuniform float pixelRatio, opacity;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(marker, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"]);
	  markerOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform float pixelRatio;\nuniform sampler2D palette;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pixelRatio;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0, 1);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}"]);
	  this.drawMarker = regl(markerOptions); // draw circle
	
	  var circleOptions = extend({}, shaderOptions);
	  circleOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\n\nuniform float opacity;\nvarying float fragBorderRadius, fragWidth;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n\tfloat t;\n\tt = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n\treturn t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n\tfloat radius, alpha = 1.0, delta = fragWidth;\n\n\tradius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n\tif (radius > 1.0 + delta) {\n\t\tdiscard;\n\t}\n\n\talpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n\tfloat borderRadius = fragBorderRadius;\n\tfloat ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n\tvec4 color = mix(fragColor, fragBorderColor, ratio);\n\tcolor.a *= alpha * opacity;\n\tgl_FragColor = color;\n}\n"]);
	  circleOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio;\nuniform sampler2D palette;\nuniform vec2 paletteSize;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0, 1);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"]); // polyfill IE
	
	  if (ie) {
	    circleOptions.frag = circleOptions.frag.replace('smoothstep', 'smoothStep');
	    markerOptions.frag = markerOptions.frag.replace('smoothstep', 'smoothStep');
	  }
	
	  this.drawCircle = regl(circleOptions);
	} // single pass defaults
	
	
	Scatter.defaults = {
	  color: 'black',
	  borderColor: 'transparent',
	  borderSize: 0,
	  size: 12,
	  opacity: 1,
	  marker: undefined,
	  viewport: null,
	  range: null,
	  pixelSize: null,
	  count: 0,
	  offset: 0,
	  bounds: null,
	  positions: [],
	  snap: 1e4 // update & redraw
	
	};
	
	Scatter.prototype.render = function () {
	  if (arguments.length) {
	    this.update.apply(this, arguments);
	  }
	
	  this.draw();
	  return this;
	}; // draw all groups or only indicated ones
	
	
	Scatter.prototype.draw = function () {
	  var _this2 = this;
	
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var groups = this.groups; // if directly array passed - treat as passes
	
	  if (args.length === 1 && Array.isArray(args[0]) && (args[0][0] === null || Array.isArray(args[0][0]))) {
	    args = args[0];
	  } // FIXME: remove once https://github.com/regl-project/regl/issues/474 resolved
	
	
	  this.regl._refresh();
	
	  if (args.length) {
	    for (var i = 0; i < args.length; i++) {
	      this.drawItem(i, args[i]);
	    }
	  } // draw all passes
	  else {
	      groups.forEach(function (group, i) {
	        _this2.drawItem(i);
	      });
	    }
	
	  return this;
	}; // draw specific scatter group
	
	
	Scatter.prototype.drawItem = function (id, els) {
	  var groups = this.groups;
	  var group = groups[id]; // debug viewport
	  // let { viewport } = group
	  // gl.enable(gl.SCISSOR_TEST);
	  // gl.scissor(viewport.x, viewport.y, viewport.width, viewport.height);
	  // gl.clearColor(0, 0, 0, .5);
	  // gl.clear(gl.COLOR_BUFFER_BIT);
	
	  if (typeof els === 'number') {
	    id = els;
	    group = groups[els];
	    els = null;
	  }
	
	  if (!(group && group.count && group.opacity)) return; // draw circles
	
	  if (group.activation[0]) {
	    // TODO: optimize this performance by making groups and regl.this props
	    this.drawCircle(this.getMarkerDrawOptions(0, group, els));
	  } // draw all other available markers
	
	
	  var batch = [];
	
	  for (var i = 1; i < group.activation.length; i++) {
	    if (!group.activation[i] || group.activation[i] !== true && !group.activation[i].data.length) continue;
	    batch.push.apply(batch, _toConsumableArray(this.getMarkerDrawOptions(i, group, els)));
	  }
	
	  if (batch.length) {
	    this.drawMarker(batch);
	  }
	}; // get options for the marker ids
	
	
	Scatter.prototype.getMarkerDrawOptions = function (markerId, group, elements) {
	  var range = group.range,
	      tree = group.tree,
	      viewport = group.viewport,
	      activation = group.activation,
	      selectionBuffer = group.selectionBuffer,
	      count = group.count;
	  var regl = this.regl; // direct points
	
	  if (!tree) {
	    // if elements array - draw unclustered points
	    if (elements) {
	      return [extend({}, group, {
	        markerTexture: this.markerTextures[markerId],
	        activation: activation[markerId],
	        count: elements.length,
	        elements: elements,
	        offset: 0
	      })];
	    }
	
	    return [extend({}, group, {
	      markerTexture: this.markerTextures[markerId],
	      activation: activation[markerId],
	      offset: 0
	    })];
	  } // clustered points
	
	
	  var batch = [];
	  var lod = tree.range(range, {
	    lod: true,
	    px: [(range[2] - range[0]) / viewport.width, (range[3] - range[1]) / viewport.height]
	  }); // enable elements by using selection buffer
	
	  if (elements) {
	    var markerActivation = activation[markerId];
	    var mask = markerActivation.data;
	    var data = new Uint8Array(count);
	
	    for (var i = 0; i < elements.length; i++) {
	      var id = elements[i];
	      data[id] = mask ? mask[id] : 1;
	    }
	
	    selectionBuffer.subdata(data);
	  }
	
	  for (var l = lod.length; l--;) {
	    var _lod$l = _slicedToArray(lod[l], 2),
	        from = _lod$l[0],
	        to = _lod$l[1];
	
	    batch.push(extend({}, group, {
	      markerTexture: this.markerTextures[markerId],
	      activation: elements ? selectionBuffer : activation[markerId],
	      offset: from,
	      count: to - from
	    }));
	  }
	
	  return batch;
	}; // update groups options
	
	
	Scatter.prototype.update = function () {
	  var _this3 = this;
	
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) return; // passes are as single array
	
	  if (args.length === 1 && Array.isArray(args[0])) args = args[0];
	  var groups = this.groups,
	      gl = this.gl,
	      regl = this.regl,
	      maxSize = this.maxSize,
	      maxColors = this.maxColors,
	      palette = this.palette;
	  this.groups = groups = args.map(function (options, i) {
	    var group = groups[i];
	    if (options === undefined) return group;
	    if (options === null) options = {
	      positions: null
	    };else if (typeof options === 'function') options = {
	      ondraw: options
	    };else if (typeof options[0] === 'number') options = {
	      positions: options // copy options to avoid mutation & handle aliases
	
	    };
	    options = pick(options, {
	      positions: 'positions data points',
	      snap: 'snap cluster lod tree',
	      size: 'sizes size radius',
	      borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
	      color: 'colors color fill fill-color fillColor',
	      borderColor: 'borderColors borderColor stroke stroke-color strokeColor',
	      marker: 'markers marker shape',
	      range: 'range dataBox databox',
	      viewport: 'viewport viewPort viewBox viewbox',
	      opacity: 'opacity alpha transparency',
	      bounds: 'bound bounds boundaries limits',
	      tooManyColors: 'tooManyColors palette paletteMode optimizePalette enablePalette'
	    });
	    if (options.positions === null) options.positions = [];
	    if (options.tooManyColors != null) _this3.tooManyColors = options.tooManyColors;
	
	    if (!group) {
	      groups[i] = group = {
	        id: i,
	        scale: null,
	        translate: null,
	        scaleFract: null,
	        translateFract: null,
	        // buffers for active markers
	        activation: [],
	        // buffer for filtered markers
	        selectionBuffer: regl.buffer({
	          data: new Uint8Array(0),
	          usage: 'stream',
	          type: 'uint8'
	        }),
	        // buffers with data: it is faster to switch them per-pass
	        // than provide one congregate buffer
	        sizeBuffer: regl.buffer({
	          data: new Uint8Array(0),
	          usage: 'dynamic',
	          type: 'uint8'
	        }),
	        colorBuffer: regl.buffer({
	          data: new Uint8Array(0),
	          usage: 'dynamic',
	          type: 'uint8'
	        }),
	        positionBuffer: regl.buffer({
	          data: new Uint8Array(0),
	          usage: 'dynamic',
	          type: 'float'
	        }),
	        positionFractBuffer: regl.buffer({
	          data: new Uint8Array(0),
	          usage: 'dynamic',
	          type: 'float'
	        })
	      };
	      options = extend({}, Scatter.defaults, options);
	    } // force update triggers
	
	
	    if (options.positions && !('marker' in options)) {
	      options.marker = group.marker;
	      delete group.marker;
	    } // updating markers cause recalculating snapping
	
	
	    if (options.marker && !('positions' in options)) {
	      options.positions = group.positions;
	      delete group.positions;
	    } // global count of points
	
	
	    var hasSize = 0,
	        hasColor = 0;
	    updateDiff(group, options, [{
	      snap: true,
	      size: function size(s, group) {
	        if (s == null) s = Scatter.defaults.size;
	        hasSize += s && s.length ? 1 : 0;
	        return s;
	      },
	      borderSize: function borderSize(s, group) {
	        if (s == null) s = Scatter.defaults.borderSize;
	        hasSize += s && s.length ? 1 : 0;
	        return s;
	      },
	      opacity: parseFloat,
	      // add colors to palette, save references
	      color: function color(c, group) {
	        if (c == null) c = Scatter.defaults.color;
	        c = _this3.updateColor(c);
	        hasColor++;
	        return c;
	      },
	      borderColor: function borderColor(c, group) {
	        if (c == null) c = Scatter.defaults.borderColor;
	        c = _this3.updateColor(c);
	        hasColor++;
	        return c;
	      },
	      bounds: function bounds(_bounds, group, options) {
	        if (!('range' in options)) options.range = null;
	        return _bounds;
	      },
	      positions: function positions(_positions, group, options) {
	        var snap = group.snap;
	        var positionBuffer = group.positionBuffer,
	            positionFractBuffer = group.positionFractBuffer,
	            selectionBuffer = group.selectionBuffer; // separate buffers for x/y coordinates
	
	        if (_positions.x || _positions.y) {
	          if (_positions.x.length) {
	            group.xAttr = {
	              buffer: regl.buffer(_positions.x),
	              offset: 0,
	              stride: 4,
	              count: _positions.x.length
	            };
	          } else {
	            group.xAttr = {
	              buffer: _positions.x.buffer,
	              offset: _positions.x.offset * 4 || 0,
	              stride: (_positions.x.stride || 1) * 4,
	              count: _positions.x.count
	            };
	          }
	
	          if (_positions.y.length) {
	            group.yAttr = {
	              buffer: regl.buffer(_positions.y),
	              offset: 0,
	              stride: 4,
	              count: _positions.y.length
	            };
	          } else {
	            group.yAttr = {
	              buffer: _positions.y.buffer,
	              offset: _positions.y.offset * 4 || 0,
	              stride: (_positions.y.stride || 1) * 4,
	              count: _positions.y.count
	            };
	          }
	
	          group.count = Math.max(group.xAttr.count, group.yAttr.count);
	          return _positions;
	        }
	
	        _positions = flatten(_positions, 'float64');
	        var count = group.count = Math.floor(_positions.length / 2);
	        var bounds = group.bounds = count ? getBounds(_positions, 2) : null; // if range is not provided updated - recalc it
	
	        if (!options.range && !group.range) {
	          delete group.range;
	          options.range = bounds;
	        } // reset marker
	
	
	        if (!options.marker && !group.marker) {
	          delete group.marker;
	          options.marker = null;
	        } // build cluster tree if required
	
	
	        if (snap && (snap === true || count > snap)) {
	          group.tree = cluster(_positions, {
	            bounds: bounds
	          });
	        } // existing tree instance
	        else if (snap && snap.length) {
	            group.tree = snap;
	          }
	
	        if (group.tree) {
	          var opts = {
	            primitive: 'points',
	            usage: 'static',
	            data: group.tree,
	            type: 'uint32'
	          };
	          if (group.elements) group.elements(opts);else group.elements = regl.elements(opts);
	        } // update position buffers
	
	
	        positionBuffer({
	          data: f32.float(_positions),
	          usage: 'dynamic'
	        });
	        positionFractBuffer({
	          data: f32.fract(_positions),
	          usage: 'dynamic'
	        }); // expand selectionBuffer
	
	        selectionBuffer({
	          data: new Uint8Array(count),
	          type: 'uint8',
	          usage: 'stream'
	        });
	        return _positions;
	      }
	    }, {
	      // create marker ids corresponding to known marker textures
	      marker: function marker(markers, group, options) {
	        var activation = group.activation; // reset marker elements
	
	        activation.forEach(function (buffer) {
	          return buffer && buffer.destroy && buffer.destroy();
	        });
	        activation.length = 0; // single sdf marker
	
	        if (!markers || typeof markers[0] === 'number') {
	          var id = _this3.addMarker(markers);
	
	          activation[id] = true;
	        } // per-point markers use mask buffers to enable markers in vert shader
	        else {
	            var markerMasks = [];
	
	            for (var _i = 0, l = Math.min(markers.length, group.count); _i < l; _i++) {
	              var _id = _this3.addMarker(markers[_i]);
	
	              if (!markerMasks[_id]) markerMasks[_id] = new Uint8Array(group.count); // enable marker by default
	
	              markerMasks[_id][_i] = 1;
	            }
	
	            for (var _id2 = 0; _id2 < markerMasks.length; _id2++) {
	              if (!markerMasks[_id2]) continue;
	              var opts = {
	                data: markerMasks[_id2],
	                type: 'uint8',
	                usage: 'static'
	              };
	
	              if (!activation[_id2]) {
	                activation[_id2] = regl.buffer(opts);
	              } else {
	                activation[_id2](opts);
	              }
	
	              activation[_id2].data = markerMasks[_id2];
	            }
	          }
	
	        return markers;
	      },
	      range: function range(_range, group, options) {
	        var bounds = group.bounds; // FIXME: why do we need this?
	
	        if (!bounds) return;
	        if (!_range) _range = bounds;
	        group.scale = [1 / (_range[2] - _range[0]), 1 / (_range[3] - _range[1])];
	        group.translate = [-_range[0], -_range[1]];
	        group.scaleFract = f32.fract(group.scale);
	        group.translateFract = f32.fract(group.translate);
	        return _range;
	      },
	      viewport: function viewport(vp) {
	        var rect = parseRect(vp || [gl.drawingBufferWidth, gl.drawingBufferHeight]); // normalize viewport to the canvas coordinates
	        // rect.y = gl.drawingBufferHeight - rect.height - rect.y
	
	        return rect;
	      }
	    }]); // update size buffer, if needed
	
	    if (hasSize) {
	      var _group = group,
	          count = _group.count,
	          size = _group.size,
	          borderSize = _group.borderSize,
	          sizeBuffer = _group.sizeBuffer;
	      var sizes = new Uint8Array(count * 2);
	
	      if (size.length || borderSize.length) {
	        for (var _i2 = 0; _i2 < count; _i2++) {
	          // we downscale size to allow for fractions
	          sizes[_i2 * 2] = Math.round((size[_i2] == null ? size : size[_i2]) * 255 / maxSize);
	          sizes[_i2 * 2 + 1] = Math.round((borderSize[_i2] == null ? borderSize : borderSize[_i2]) * 255 / maxSize);
	        }
	      }
	
	      sizeBuffer({
	        data: sizes,
	        usage: 'dynamic'
	      });
	    } // update color buffer if needed
	
	
	    if (hasColor) {
	      var _group2 = group,
	          _count = _group2.count,
	          color = _group2.color,
	          borderColor = _group2.borderColor,
	          colorBuffer = _group2.colorBuffer;
	      var colors; // if too many colors - put colors to buffer directly
	
	      if (_this3.tooManyColors) {
	        if (color.length || borderColor.length) {
	          colors = new Uint8Array(_count * 8);
	
	          for (var _i3 = 0; _i3 < _count; _i3++) {
	            var _colorId = color[_i3];
	            colors[_i3 * 8] = palette[_colorId * 4];
	            colors[_i3 * 8 + 1] = palette[_colorId * 4 + 1];
	            colors[_i3 * 8 + 2] = palette[_colorId * 4 + 2];
	            colors[_i3 * 8 + 3] = palette[_colorId * 4 + 3];
	            var borderColorId = borderColor[_i3];
	            colors[_i3 * 8 + 4] = palette[borderColorId * 4];
	            colors[_i3 * 8 + 5] = palette[borderColorId * 4 + 1];
	            colors[_i3 * 8 + 6] = palette[borderColorId * 4 + 2];
	            colors[_i3 * 8 + 7] = palette[borderColorId * 4 + 3];
	          }
	        }
	      } // if limited amount of colors - keep palette color picking
	      // that saves significant memory
	      else {
	          if (color.length || borderColor.length) {
	            // we need slight data increase by 2 due to vec4 borderId in shader
	            colors = new Uint8Array(_count * 4 + 2);
	
	            for (var _i4 = 0; _i4 < _count; _i4++) {
	              // put color coords in palette texture
	              if (color[_i4] != null) {
	                colors[_i4 * 4] = color[_i4] % maxColors;
	                colors[_i4 * 4 + 1] = Math.floor(color[_i4] / maxColors);
	              }
	
	              if (borderColor[_i4] != null) {
	                colors[_i4 * 4 + 2] = borderColor[_i4] % maxColors;
	                colors[_i4 * 4 + 3] = Math.floor(borderColor[_i4] / maxColors);
	              }
	            }
	          }
	        }
	
	      colorBuffer({
	        data: colors || new Uint8Array(0),
	        type: 'uint8',
	        usage: 'dynamic'
	      });
	    }
	
	    return group;
	  });
	}; // get (and create) marker texture id
	
	
	Scatter.prototype.addMarker = function (sdf) {
	  var markerTextures = this.markerTextures,
	      regl = this.regl,
	      markerCache = this.markerCache;
	  var pos = sdf == null ? 0 : markerCache.indexOf(sdf);
	  if (pos >= 0) return pos; // convert sdf to 0..255 range
	
	  var distArr;
	
	  if (sdf instanceof Uint8Array || sdf instanceof Uint8ClampedArray) {
	    distArr = sdf;
	  } else {
	    distArr = new Uint8Array(sdf.length);
	
	    for (var i = 0, l = sdf.length; i < l; i++) {
	      distArr[i] = sdf[i] * 255;
	    }
	  }
	
	  var radius = Math.floor(Math.sqrt(distArr.length));
	  pos = markerTextures.length;
	  markerCache.push(sdf);
	  markerTextures.push(regl.texture({
	    channels: 1,
	    data: distArr,
	    radius: radius,
	    mag: 'linear',
	    min: 'linear'
	  }));
	  return pos;
	}; // register color to palette, return it's index or list of indexes
	
	
	Scatter.prototype.updateColor = function (colors) {
	  var paletteIds = this.paletteIds,
	      palette = this.palette,
	      maxColors = this.maxColors;
	
	  if (!Array.isArray(colors)) {
	    colors = [colors];
	  }
	
	  var idx = []; // if color groups - flatten them
	
	  if (typeof colors[0] === 'number') {
	    var grouped = [];
	
	    if (Array.isArray(colors)) {
	      for (var i = 0; i < colors.length; i += 4) {
	        grouped.push(colors.slice(i, i + 4));
	      }
	    } else {
	      for (var _i5 = 0; _i5 < colors.length; _i5 += 4) {
	        grouped.push(colors.subarray(_i5, _i5 + 4));
	      }
	    }
	
	    colors = grouped;
	  }
	
	  for (var _i6 = 0; _i6 < colors.length; _i6++) {
	    var color = colors[_i6];
	    color = rgba(color, 'uint8');
	    var id = colorId(color, false); // if new color - save it
	
	    if (paletteIds[id] == null) {
	      var pos = palette.length;
	      paletteIds[id] = Math.floor(pos / 4);
	      palette[pos] = color[0];
	      palette[pos + 1] = color[1];
	      palette[pos + 2] = color[2];
	      palette[pos + 3] = color[3];
	    }
	
	    idx[_i6] = paletteIds[id];
	  } // detect if too many colors in palette
	
	
	  if (!this.tooManyColors && palette.length > maxColors * 4) this.tooManyColors = true; // limit max color
	
	  this.updatePalette(palette); // keep static index for single-color property
	
	  return idx.length === 1 ? idx[0] : idx;
	};
	
	Scatter.prototype.updatePalette = function (palette) {
	  if (this.tooManyColors) return;
	  var maxColors = this.maxColors,
	      paletteTexture = this.paletteTexture;
	  var requiredHeight = Math.ceil(palette.length * .25 / maxColors); // pad data
	
	  if (requiredHeight > 1) {
	    palette = palette.slice();
	
	    for (var i = palette.length * .25 % maxColors; i < requiredHeight * maxColors; i++) {
	      palette.push(0, 0, 0, 0);
	    }
	  } // ensure height
	
	
	  if (paletteTexture.height < requiredHeight) {
	    paletteTexture.resize(maxColors, requiredHeight);
	  } // update full data
	
	
	  paletteTexture.subimage({
	    width: Math.min(palette.length * .25, maxColors),
	    height: requiredHeight,
	    data: palette
	  }, 0, 0);
	}; // remove unused stuff
	
	
	Scatter.prototype.destroy = function () {
	  this.groups.forEach(function (group) {
	    group.sizeBuffer.destroy();
	    group.positionBuffer.destroy();
	    group.positionFractBuffer.destroy();
	    group.colorBuffer.destroy();
	    group.activation.forEach(function (b) {
	      return b && b.destroy && b.destroy();
	    });
	    group.selectionBuffer.destroy();
	    if (group.elements) group.elements.destroy();
	  });
	  this.groups.length = 0;
	  this.paletteTexture.destroy();
	  this.markerTextures.forEach(function (txt) {
	    return txt && txt.destroy && txt.destroy();
	  });
	  return this;
	};
	
	var extend$1 = _dereq_('object-assign');
	
	var reglScatter2d = function reglScatter2d(regl, options) {
	  var scatter$$1 = new scatter(regl, options);
	  var render = scatter$$1.render.bind(scatter$$1); // expose API
	
	  extend$1(render, {
	    render: render,
	    update: scatter$$1.update.bind(scatter$$1),
	    draw: scatter$$1.draw.bind(scatter$$1),
	    destroy: scatter$$1.destroy.bind(scatter$$1),
	    regl: scatter$$1.regl,
	    gl: scatter$$1.gl,
	    canvas: scatter$$1.gl.canvas,
	    groups: scatter$$1.groups,
	    markers: scatter$$1.markerCache,
	    palette: scatter$$1.palette
	  });
	  return render;
	};
	
	module.exports = reglScatter2d;
	
	},{"array-bounds":67,"color-id":119,"color-normalize":121,"flatten-vertex-data":229,"glslify":410,"is-iexplorer":420,"object-assign":455,"parse-rect":460,"pick-by-alias":466,"point-cluster":470,"to-float32":536,"update-diff":547}],499:[function(_dereq_,module,exports){
	'use strict'
	
	
	var createScatter = _dereq_('regl-scatter2d')
	var pick = _dereq_('pick-by-alias')
	var getBounds = _dereq_('array-bounds')
	var raf = _dereq_('raf')
	var arrRange = _dereq_('array-range')
	var rect = _dereq_('parse-rect')
	var flatten = _dereq_('flatten-vertex-data')
	
	
	module.exports = SPLOM
	
	
	// @constructor
	function SPLOM (regl, options) {
		if (!(this instanceof SPLOM)) { return new SPLOM(regl, options) }
	
		// render passes
		this.traces = []
	
		// passes for scatter, combined across traces
		this.passes = {}
	
		this.regl = regl
	
		// main scatter drawing instance
		this.scatter = createScatter(regl)
	
		this.canvas = this.scatter.canvas
	}
	
	
	// update & draw passes once per frame
	SPLOM.prototype.render = function () {
		var this$1 = this;
		var ref;
	
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		if (args.length) {
			(ref = this).update.apply(ref, args)
		}
	
		if (this.regl.attributes.preserveDrawingBuffer) { return this.draw() }
	
		// make sure draw is not called more often than once a frame
		if (this.dirty) {
			if (this.planned == null) {
				this.planned = raf(function () {
					this$1.draw()
					this$1.dirty = true
					this$1.planned = null
				})
			}
		}
		else {
			this.draw()
			this.dirty = true
			raf(function () {
				this$1.dirty = false
			})
		}
	
		return this
	}
	
	
	// update passes
	SPLOM.prototype.update = function () {
		var this$1 = this;
		var ref;
	
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		if (!args.length) { return }
	
		for (var i = 0; i < args.length; i++) {
			this$1.updateItem(i, args[i])
		}
	
		// remove nulled passes
		this.traces = this.traces.filter(Boolean)
	
		// FIXME: update passes independently
		var passes = []
		var offset = 0
		for (var i$1 = 0; i$1 < this.traces.length; i$1++) {
			var trace = this$1.traces[i$1]
			var tracePasses = this$1.traces[i$1].passes
			for (var j = 0; j < tracePasses.length; j++) {
				passes.push(this$1.passes[tracePasses[j]])
			}
			// save offset of passes
			trace.passOffset = offset
			offset += trace.passes.length
		}
	
		(ref = this.scatter).update.apply(ref, passes)
	
		return this
	}
	
	
	// update trace by index, not supposed to be called directly
	SPLOM.prototype.updateItem = function (i, options) {
		var this$1 = this;
	
		var ref = this;
		var regl = ref.regl;
	
		// remove pass if null
		if (options === null) {
			this.traces[i] = null
			return this
		}
	
		if (!options) { return this }
	
		var o = pick(options, {
			data: 'data items columns rows values dimensions samples x',
			snap: 'snap cluster',
			size: 'sizes size radius',
			color: 'colors color fill fill-color fillColor',
			opacity: 'opacity alpha transparency opaque',
			borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
			borderColor: 'borderColors borderColor bordercolor stroke stroke-color strokeColor',
			marker: 'markers marker shape',
			range: 'range ranges databox dataBox',
			viewport: 'viewport viewBox viewbox',
			domain: 'domain domains area areas',
			padding: 'pad padding paddings pads margin margins',
			transpose: 'transpose transposed',
			diagonal: 'diagonal diag showDiagonal',
			upper: 'upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf',
			lower: 'lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower'
		})
	
		// we provide regl buffer per-trace, since trace data can be changed
		var trace = (this.traces[i] || (this.traces[i] = {
			id: i,
			buffer: regl.buffer({
				usage: 'dynamic',
				type: 'float',
				data: new Uint8Array()
			}),
			color: 'black',
			marker: null,
			size: 12,
			borderColor: 'transparent',
			borderSize: 1,
			viewport:  rect([regl._gl.drawingBufferWidth, regl._gl.drawingBufferHeight]),
			padding: [0, 0, 0, 0],
			opacity: 1,
			diagonal: true,
			upper: true,
			lower: true
		}))
	
	
		// save styles
		if (o.color != null) {
			trace.color = o.color
		}
		if (o.size != null) {
			trace.size = o.size
		}
		if (o.marker != null) {
			trace.marker = o.marker
		}
		if (o.borderColor != null) {
			trace.borderColor = o.borderColor
		}
		if (o.borderSize != null) {
			trace.borderSize = o.borderSize
		}
		if (o.opacity != null) {
			trace.opacity = o.opacity
		}
		if (o.viewport) {
			trace.viewport = rect(o.viewport)
		}
		if (o.diagonal != null) { trace.diagonal = o.diagonal }
		if (o.upper != null) { trace.upper = o.upper }
		if (o.lower != null) { trace.lower = o.lower }
	
		// put flattened data into buffer
		if (o.data) {
			trace.buffer(flatten(o.data))
			trace.columns = o.data.length
			trace.count = o.data[0].length
	
			// detect bounds per-column
			trace.bounds = []
	
			for (var i$1 = 0; i$1 < trace.columns; i$1++) {
				trace.bounds[i$1] = getBounds(o.data[i$1], 1)
			}
		}
	
		// add proper range updating markers
		var multirange
		if (o.range) {
			trace.range = o.range
			multirange = trace.range && typeof trace.range[0] !== 'number'
		}
	
		if (o.domain) {
			trace.domain = o.domain
		}
		var multipadding = false
		if (o.padding != null) {
			// multiple paddings
			if (Array.isArray(o.padding) && o.padding.length === trace.columns && typeof o.padding[o.padding.length - 1] === 'number') {
				trace.padding = o.padding.map(getPad)
				multipadding = true
			}
			// single padding
			else {
				trace.padding = getPad(o.padding)
			}
		}
	
		// create passes
		var m = trace.columns
		var n = trace.count
	
		var w = trace.viewport.width
		var h = trace.viewport.height
		var left = trace.viewport.x
		var top = trace.viewport.y
		var iw = w / m
		var ih = h / m
	
		trace.passes = []
	
		for (var i$2 = 0; i$2 < m; i$2++) {
			for (var j = 0; j < m; j++) {
				if (!trace.diagonal && j === i$2) { continue }
				if (!trace.upper && i$2 > j) { continue }
				if (!trace.lower && i$2 < j) { continue }
	
				var key = passId(trace.id, i$2, j)
	
				var pass = this$1.passes[key] || (this$1.passes[key] = {})
	
				if (o.data) {
					if (o.transpose) {
						pass.positions = {
							x: {buffer: trace.buffer, offset: j, count: n, stride: m},
							y: {buffer: trace.buffer, offset: i$2, count: n, stride: m}
						}
					}
					else {
						pass.positions = {
							x: {buffer: trace.buffer, offset: j * n, count: n},
							y: {buffer: trace.buffer, offset: i$2 * n, count: n}
						}
					}
	
					pass.bounds = getBox(trace.bounds, i$2, j)
				}
	
				if (o.domain || o.viewport || o.data) {
					var pad = multipadding ? getBox(trace.padding, i$2, j) : trace.padding
					if (trace.domain) {
						var ref$1 = getBox(trace.domain, i$2, j);
						var lox = ref$1[0];
						var loy = ref$1[1];
						var hix = ref$1[2];
						var hiy = ref$1[3];
	
						pass.viewport = [
							left + lox * w + pad[0],
							top + loy * h + pad[1],
							left + hix * w - pad[2],
							top + hiy * h - pad[3]
						]
					}
					// consider auto-domain equipartial
					else {
						pass.viewport = [
							left + j * iw + iw * pad[0],
							top + i$2 * ih + ih * pad[1],
							left + (j + 1) * iw - iw * pad[2],
							top + (i$2 + 1) * ih - ih * pad[3]
						]
					}
				}
	
				if (o.color) { pass.color = trace.color }
				if (o.size) { pass.size = trace.size }
				if (o.marker) { pass.marker = trace.marker }
				if (o.borderSize) { pass.borderSize = trace.borderSize }
				if (o.borderColor) { pass.borderColor = trace.borderColor }
				if (o.opacity) { pass.opacity = trace.opacity }
	
				if (o.range) {
					pass.range = multirange ? getBox(trace.range, i$2, j) : trace.range || pass.bounds
				}
	
				trace.passes.push(key)
			}
		}
	
		return this
	}
	
	
	// draw all or passed passes
	SPLOM.prototype.draw = function () {
		var this$1 = this;
		var ref$2;
	
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		if (!args.length) {
			this.scatter.draw()
		}
		else {
			var idx = []
			for (var i = 0; i < args.length; i++) {
				// draw(0, 2, 5) - draw traces
				if (typeof args[i] === 'number' ) {
					var ref = this$1.traces[args[i]];
					var passes = ref.passes;
					var passOffset = ref.passOffset;
					idx.push.apply(idx, arrRange(passOffset, passOffset + passes.length))
				}
				// draw([0, 1, 2 ...], [3, 4, 5]) - draw points
				else if (args[i].length) {
					var els = args[i]
					var ref$1 = this$1.traces[i];
					var passes$1 = ref$1.passes;
					var passOffset$1 = ref$1.passOffset;
					passes$1 = passes$1.map(function (passId, i) {
						idx[passOffset$1 + i] = els
					})
				}
			}
			(ref$2 = this.scatter).draw.apply(ref$2, idx)
		}
	
		return this
	}
	
	
	// dispose resources
	SPLOM.prototype.destroy = function () {
		this.traces.forEach(function (trace) {
			if (trace.buffer && trace.buffer.destroy) { trace.buffer.destroy() }
		})
		this.traces = null
		this.passes = null
	
		this.scatter.destroy()
	
		return this
	}
	
	
	// return pass corresponding to trace i- j- square
	function passId (trace, i, j) {
		var id = (trace.id != null ? trace.id : trace)
		var n = i
		var m = j
		var key = id << 16 | (n & 0xff) << 8 | m & 0xff
	
		return key
	}
	
	
	// return bounding box corresponding to a pass
	function getBox (items, i, j) {
		var ilox, iloy, ihix, ihiy, jlox, jloy, jhix, jhiy
		var iitem = items[i], jitem = items[j]
	
		if (iitem.length > 2) {
			ilox = iitem[0]
			ihix = iitem[2]
			iloy = iitem[1]
			ihiy = iitem[3]
		}
		else if (iitem.length) {
			ilox = iloy = iitem[0]
			ihix = ihiy = iitem[1]
		}
		else {
			ilox = iitem.x
			iloy = iitem.y
			ihix = iitem.x + iitem.width
			ihiy = iitem.y + iitem.height
		}
	
		if (jitem.length > 2) {
			jlox = jitem[0]
			jhix = jitem[2]
			jloy = jitem[1]
			jhiy = jitem[3]
		}
		else if (jitem.length) {
			jlox = jloy = jitem[0]
			jhix = jhiy = jitem[1]
		}
		else {
			jlox = jitem.x
			jloy = jitem.y
			jhix = jitem.x + jitem.width
			jhiy = jitem.y + jitem.height
		}
	
		return [ jlox, iloy, jhix, ihiy ]
	}
	
	
	function getPad (arg) {
		if (typeof arg === 'number') { return [arg, arg, arg, arg] }
		else if (arg.length === 2) { return [arg[0], arg[1], arg[0], arg[1]] }
		else {
			var box = rect(arg)
			return [box.x, box.y, box.x + box.width, box.y + box.height]
		}
	}
	},{"array-bounds":67,"array-range":68,"flatten-vertex-data":229,"parse-rect":460,"pick-by-alias":466,"raf":485,"regl-scatter2d":498}],500:[function(_dereq_,module,exports){
	(function(aa,ia){"object"===typeof exports&&"undefined"!==typeof module?module.exports=ia():"function"===typeof define&&define.amd?define(ia):aa.createREGL=ia()})(this,function(){function aa(a,b){this.id=Ab++;this.type=a;this.data=b}function ia(a){if(0===a.length)return[];var b=a.charAt(0),c=a.charAt(a.length-1);if(1<a.length&&b===c&&('"'===b||"'"===b))return['"'+a.substr(1,a.length-2).replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];if(b=/\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(a))return ia(a.substr(0,
	b.index)).concat(ia(b[1])).concat(ia(a.substr(b.index+b[0].length)));b=a.split(".");if(1===b.length)return['"'+a.replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];a=[];for(c=0;c<b.length;++c)a=a.concat(ia(b[c]));return a}function Za(a){return"["+ia(a).join("][")+"]"}function Bb(){var a={"":0},b=[""];return{id:function(c){var e=a[c];if(e)return e;e=a[c]=b.length;b.push(c);return e},str:function(a){return b[a]}}}function Cb(a,b,c){function e(){var b=window.innerWidth,e=window.innerHeight;a!==document.body&&
	(e=a.getBoundingClientRect(),b=e.right-e.left,e=e.bottom-e.top);g.width=c*b;g.height=c*e;E(g.style,{width:b+"px",height:e+"px"})}var g=document.createElement("canvas");E(g.style,{border:0,margin:0,padding:0,top:0,left:0});a.appendChild(g);a===document.body&&(g.style.position="absolute",E(a.style,{margin:0,padding:0}));window.addEventListener("resize",e,!1);e();return{canvas:g,onDestroy:function(){window.removeEventListener("resize",e);a.removeChild(g)}}}function Db(a,b){function c(c){try{return a.getContext(c,
	b)}catch(g){return null}}return c("webgl")||c("experimental-webgl")||c("webgl-experimental")}function $a(a){return"string"===typeof a?a.split():a}function ab(a){return"string"===typeof a?document.querySelector(a):a}function Eb(a){var b=a||{},c,e,g,d;a={};var n=[],f=[],r="undefined"===typeof window?1:window.devicePixelRatio,q=!1,t=function(a){},m=function(){};"string"===typeof b?c=document.querySelector(b):"object"===typeof b&&("string"===typeof b.nodeName&&"function"===typeof b.appendChild&&"function"===
	typeof b.getBoundingClientRect?c=b:"function"===typeof b.drawArrays||"function"===typeof b.drawElements?(d=b,g=d.canvas):("gl"in b?d=b.gl:"canvas"in b?g=ab(b.canvas):"container"in b&&(e=ab(b.container)),"attributes"in b&&(a=b.attributes),"extensions"in b&&(n=$a(b.extensions)),"optionalExtensions"in b&&(f=$a(b.optionalExtensions)),"onDone"in b&&(t=b.onDone),"profile"in b&&(q=!!b.profile),"pixelRatio"in b&&(r=+b.pixelRatio)));c&&("canvas"===c.nodeName.toLowerCase()?g=c:e=c);if(!d){if(!g){c=Cb(e||document.body,
	t,r);if(!c)return null;g=c.canvas;m=c.onDestroy}d=Db(g,a)}return d?{gl:d,canvas:g,container:e,extensions:n,optionalExtensions:f,pixelRatio:r,profile:q,onDone:t,onDestroy:m}:(m(),t("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"),null)}function Fb(a,b){function c(b){b=b.toLowerCase();var c;try{c=e[b]=a.getExtension(b)}catch(g){}return!!c}for(var e={},g=0;g<b.extensions.length;++g){var d=b.extensions[g];if(!c(d))return b.onDestroy(),b.onDone('"'+d+'" extension is not supported by the current WebGL context, try upgrading your system or a different browser'),
	null}b.optionalExtensions.forEach(c);return{extensions:e,restore:function(){Object.keys(e).forEach(function(a){if(e[a]&&!c(a))throw Error("(regl): error restoring extension "+a);})}}}function J(a,b){for(var c=Array(a),e=0;e<a;++e)c[e]=b(e);return c}function bb(a){var b,c;b=(65535<a)<<4;a>>>=b;c=(255<a)<<3;a>>>=c;b|=c;c=(15<a)<<2;a>>>=c;b|=c;c=(3<a)<<1;return b|c|a>>>c>>1}function cb(){function a(a){a:{for(var b=16;268435456>=b;b*=16)if(a<=b){a=b;break a}a=0}b=c[bb(a)>>2];return 0<b.length?b.pop():
	new ArrayBuffer(a)}function b(a){c[bb(a.byteLength)>>2].push(a)}var c=J(8,function(){return[]});return{alloc:a,free:b,allocType:function(b,c){var d=null;switch(b){case 5120:d=new Int8Array(a(c),0,c);break;case 5121:d=new Uint8Array(a(c),0,c);break;case 5122:d=new Int16Array(a(2*c),0,c);break;case 5123:d=new Uint16Array(a(2*c),0,c);break;case 5124:d=new Int32Array(a(4*c),0,c);break;case 5125:d=new Uint32Array(a(4*c),0,c);break;case 5126:d=new Float32Array(a(4*c),0,c);break;default:return null}return d.length!==
	c?d.subarray(0,c):d},freeType:function(a){b(a.buffer)}}}function ma(a){return!!a&&"object"===typeof a&&Array.isArray(a.shape)&&Array.isArray(a.stride)&&"number"===typeof a.offset&&a.shape.length===a.stride.length&&(Array.isArray(a.data)||M(a.data))}function db(a,b,c,e,g,d){for(var n=0;n<b;++n)for(var f=a[n],r=0;r<c;++r)for(var q=f[r],t=0;t<e;++t)g[d++]=q[t]}function eb(a,b,c,e,g){for(var d=1,n=c+1;n<b.length;++n)d*=b[n];var f=b[c];if(4===b.length-c){var r=b[c+1],q=b[c+2];b=b[c+3];for(n=0;n<f;++n)db(a[n],
	r,q,b,e,g),g+=d}else for(n=0;n<f;++n)eb(a[n],b,c+1,e,g),g+=d}function Ha(a){return Ia[Object.prototype.toString.call(a)]|0}function fb(a,b){for(var c=0;c<b.length;++c)a[c]=b[c]}function gb(a,b,c,e,g,d,n){for(var f=0,r=0;r<c;++r)for(var q=0;q<e;++q)a[f++]=b[g*r+d*q+n]}function Gb(a,b,c,e){function g(b){this.id=r++;this.buffer=a.createBuffer();this.type=b;this.usage=35044;this.byteLength=0;this.dimension=1;this.dtype=5121;this.persistentData=null;c.profile&&(this.stats={size:0})}function d(b,c,k){b.byteLength=
	c.byteLength;a.bufferData(b.type,c,k)}function n(a,b,c,h,l,e){a.usage=c;if(Array.isArray(b)){if(a.dtype=h||5126,0<b.length)if(Array.isArray(b[0])){l=hb(b);for(var v=h=1;v<l.length;++v)h*=l[v];a.dimension=h;b=Qa(b,l,a.dtype);d(a,b,c);e?a.persistentData=b:x.freeType(b)}else"number"===typeof b[0]?(a.dimension=l,l=x.allocType(a.dtype,b.length),fb(l,b),d(a,l,c),e?a.persistentData=l:x.freeType(l)):M(b[0])&&(a.dimension=b[0].length,a.dtype=h||Ha(b[0])||5126,b=Qa(b,[b.length,b[0].length],a.dtype),d(a,b,c),
	e?a.persistentData=b:x.freeType(b))}else if(M(b))a.dtype=h||Ha(b),a.dimension=l,d(a,b,c),e&&(a.persistentData=new Uint8Array(new Uint8Array(b.buffer)));else if(ma(b)){l=b.shape;var g=b.stride,v=b.offset,f=0,q=0,r=0,t=0;1===l.length?(f=l[0],q=1,r=g[0],t=0):2===l.length&&(f=l[0],q=l[1],r=g[0],t=g[1]);a.dtype=h||Ha(b.data)||5126;a.dimension=q;l=x.allocType(a.dtype,f*q);gb(l,b.data,f,q,r,t,v);d(a,l,c);e?a.persistentData=l:x.freeType(l)}}function f(c){b.bufferCount--;for(var d=0;d<e.state.length;++d){var k=
	e.state[d];k.buffer===c&&(a.disableVertexAttribArray(d),k.buffer=null)}a.deleteBuffer(c.buffer);c.buffer=null;delete q[c.id]}var r=0,q={};g.prototype.bind=function(){a.bindBuffer(this.type,this.buffer)};g.prototype.destroy=function(){f(this)};var t=[];c.profile&&(b.getTotalBufferSize=function(){var a=0;Object.keys(q).forEach(function(b){a+=q[b].stats.size});return a});return{create:function(m,e,d,h){function l(b){var m=35044,e=null,d=0,k=0,g=1;Array.isArray(b)||M(b)||ma(b)?e=b:"number"===typeof b?
	d=b|0:b&&("data"in b&&(e=b.data),"usage"in b&&(m=jb[b.usage]),"type"in b&&(k=Ra[b.type]),"dimension"in b&&(g=b.dimension|0),"length"in b&&(d=b.length|0));u.bind();e?n(u,e,m,k,g,h):(d&&a.bufferData(u.type,d,m),u.dtype=k||5121,u.usage=m,u.dimension=g,u.byteLength=d);c.profile&&(u.stats.size=u.byteLength*ja[u.dtype]);return l}b.bufferCount++;var u=new g(e);q[u.id]=u;d||l(m);l._reglType="buffer";l._buffer=u;l.subdata=function(b,c){var m=(c||0)|0,e;u.bind();if(M(b))a.bufferSubData(u.type,m,b);else if(Array.isArray(b)){if(0<
	b.length)if("number"===typeof b[0]){var d=x.allocType(u.dtype,b.length);fb(d,b);a.bufferSubData(u.type,m,d);x.freeType(d)}else if(Array.isArray(b[0])||M(b[0]))e=hb(b),d=Qa(b,e,u.dtype),a.bufferSubData(u.type,m,d),x.freeType(d)}else if(ma(b)){e=b.shape;var h=b.stride,k=d=0,g=0,F=0;1===e.length?(d=e[0],k=1,g=h[0],F=0):2===e.length&&(d=e[0],k=e[1],g=h[0],F=h[1]);e=Array.isArray(b.data)?u.dtype:Ha(b.data);e=x.allocType(e,d*k);gb(e,b.data,d,k,g,F,b.offset);a.bufferSubData(u.type,m,e);x.freeType(e)}return l};
	c.profile&&(l.stats=u.stats);l.destroy=function(){f(u)};return l},createStream:function(a,b){var c=t.pop();c||(c=new g(a));c.bind();n(c,b,35040,0,1,!1);return c},destroyStream:function(a){t.push(a)},clear:function(){S(q).forEach(f);t.forEach(f)},getBuffer:function(a){return a&&a._buffer instanceof g?a._buffer:null},restore:function(){S(q).forEach(function(b){b.buffer=a.createBuffer();a.bindBuffer(b.type,b.buffer);a.bufferData(b.type,b.persistentData||b.byteLength,b.usage)})},_initBuffer:n}}function Hb(a,
	b,c,e){function g(a){this.id=r++;f[this.id]=this;this.buffer=a;this.primType=4;this.type=this.vertCount=0}function d(e,d,g,h,l,u,v){e.buffer.bind();if(d){var f=v;v||M(d)&&(!ma(d)||M(d.data))||(f=b.oes_element_index_uint?5125:5123);c._initBuffer(e.buffer,d,g,f,3)}else a.bufferData(34963,u,g),e.buffer.dtype=f||5121,e.buffer.usage=g,e.buffer.dimension=3,e.buffer.byteLength=u;f=v;if(!v){switch(e.buffer.dtype){case 5121:case 5120:f=5121;break;case 5123:case 5122:f=5123;break;case 5125:case 5124:f=5125}e.buffer.dtype=
	f}e.type=f;d=l;0>d&&(d=e.buffer.byteLength,5123===f?d>>=1:5125===f&&(d>>=2));e.vertCount=d;d=h;0>h&&(d=4,h=e.buffer.dimension,1===h&&(d=0),2===h&&(d=1),3===h&&(d=4));e.primType=d}function n(a){e.elementsCount--;delete f[a.id];a.buffer.destroy();a.buffer=null}var f={},r=0,q={uint8:5121,uint16:5123};b.oes_element_index_uint&&(q.uint32=5125);g.prototype.bind=function(){this.buffer.bind()};var t=[];return{create:function(a,b){function k(a){if(a)if("number"===typeof a)h(a),l.primType=4,l.vertCount=a|0,
	l.type=5121;else{var b=null,c=35044,e=-1,g=-1,f=0,m=0;if(Array.isArray(a)||M(a)||ma(a))b=a;else if("data"in a&&(b=a.data),"usage"in a&&(c=jb[a.usage]),"primitive"in a&&(e=Sa[a.primitive]),"count"in a&&(g=a.count|0),"type"in a&&(m=q[a.type]),"length"in a)f=a.length|0;else if(f=g,5123===m||5122===m)f*=2;else if(5125===m||5124===m)f*=4;d(l,b,c,e,g,f,m)}else h(),l.primType=4,l.vertCount=0,l.type=5121;return k}var h=c.create(null,34963,!0),l=new g(h._buffer);e.elementsCount++;k(a);k._reglType="elements";
	k._elements=l;k.subdata=function(a,b){h.subdata(a,b);return k};k.destroy=function(){n(l)};return k},createStream:function(a){var b=t.pop();b||(b=new g(c.create(null,34963,!0,!1)._buffer));d(b,a,35040,-1,-1,0,0);return b},destroyStream:function(a){t.push(a)},getElements:function(a){return"function"===typeof a&&a._elements instanceof g?a._elements:null},clear:function(){S(f).forEach(n)}}}function kb(a){for(var b=x.allocType(5123,a.length),c=0;c<a.length;++c)if(isNaN(a[c]))b[c]=65535;else if(Infinity===
	a[c])b[c]=31744;else if(-Infinity===a[c])b[c]=64512;else{lb[0]=a[c];var e=Ib[0],g=e>>>31<<15,d=(e<<1>>>24)-127,e=e>>13&1023;b[c]=-24>d?g:-14>d?g+(e+1024>>-14-d):15<d?g+31744:g+(d+15<<10)+e}return b}function pa(a){return Array.isArray(a)||M(a)}function Ea(a){return"[object "+a+"]"}function mb(a){return Array.isArray(a)&&(0===a.length||"number"===typeof a[0])}function nb(a){return Array.isArray(a)&&0!==a.length&&pa(a[0])?!0:!1}function na(a){return Object.prototype.toString.call(a)}function Ta(a){if(!a)return!1;
	var b=na(a);return 0<=Jb.indexOf(b)?!0:mb(a)||nb(a)||ma(a)}function ob(a,b){36193===a.type?(a.data=kb(b),x.freeType(b)):a.data=b}function Ja(a,b,c,e,g,d){a="undefined"!==typeof y[a]?y[a]:L[a]*qa[b];d&&(a*=6);if(g){for(e=0;1<=c;)e+=a*c*c,c/=2;return e}return a*c*e}function Kb(a,b,c,e,g,d,n){function f(){this.format=this.internalformat=6408;this.type=5121;this.flipY=this.premultiplyAlpha=this.compressed=!1;this.unpackAlignment=1;this.colorSpace=37444;this.channels=this.height=this.width=0}function r(a,
	b){a.internalformat=b.internalformat;a.format=b.format;a.type=b.type;a.compressed=b.compressed;a.premultiplyAlpha=b.premultiplyAlpha;a.flipY=b.flipY;a.unpackAlignment=b.unpackAlignment;a.colorSpace=b.colorSpace;a.width=b.width;a.height=b.height;a.channels=b.channels}function q(a,b){if("object"===typeof b&&b){"premultiplyAlpha"in b&&(a.premultiplyAlpha=b.premultiplyAlpha);"flipY"in b&&(a.flipY=b.flipY);"alignment"in b&&(a.unpackAlignment=b.alignment);"colorSpace"in b&&(a.colorSpace=wa[b.colorSpace]);
	"type"in b&&(a.type=G[b.type]);var c=a.width,e=a.height,d=a.channels,h=!1;"shape"in b?(c=b.shape[0],e=b.shape[1],3===b.shape.length&&(d=b.shape[2],h=!0)):("radius"in b&&(c=e=b.radius),"width"in b&&(c=b.width),"height"in b&&(e=b.height),"channels"in b&&(d=b.channels,h=!0));a.width=c|0;a.height=e|0;a.channels=d|0;c=!1;"format"in b&&(c=b.format,e=a.internalformat=U[c],a.format=Lb[e],c in G&&!("type"in b)&&(a.type=G[c]),c in W&&(a.compressed=!0),c=!0);!h&&c?a.channels=L[a.format]:h&&!c&&a.channels!==
	La[a.format]&&(a.format=a.internalformat=La[a.channels])}}function t(b){a.pixelStorei(37440,b.flipY);a.pixelStorei(37441,b.premultiplyAlpha);a.pixelStorei(37443,b.colorSpace);a.pixelStorei(3317,b.unpackAlignment)}function m(){f.call(this);this.yOffset=this.xOffset=0;this.data=null;this.needsFree=!1;this.element=null;this.needsCopy=!1}function C(a,b){var c=null;Ta(b)?c=b:b&&(q(a,b),"x"in b&&(a.xOffset=b.x|0),"y"in b&&(a.yOffset=b.y|0),Ta(b.data)&&(c=b.data));if(b.copy){var e=g.viewportWidth,d=g.viewportHeight;
	a.width=a.width||e-a.xOffset;a.height=a.height||d-a.yOffset;a.needsCopy=!0}else if(!c)a.width=a.width||1,a.height=a.height||1,a.channels=a.channels||4;else if(M(c))a.channels=a.channels||4,a.data=c,"type"in b||5121!==a.type||(a.type=Ia[Object.prototype.toString.call(c)]|0);else if(mb(c)){a.channels=a.channels||4;e=c;d=e.length;switch(a.type){case 5121:case 5123:case 5125:case 5126:d=x.allocType(a.type,d);d.set(e);a.data=d;break;case 36193:a.data=kb(e)}a.alignment=1;a.needsFree=!0}else if(ma(c)){e=
	c.data;Array.isArray(e)||5121!==a.type||(a.type=Ia[Object.prototype.toString.call(e)]|0);var d=c.shape,h=c.stride,f,l,p,w;3===d.length?(p=d[2],w=h[2]):w=p=1;f=d[0];l=d[1];d=h[0];h=h[1];a.alignment=1;a.width=f;a.height=l;a.channels=p;a.format=a.internalformat=La[p];a.needsFree=!0;f=w;c=c.offset;p=a.width;w=a.height;l=a.channels;for(var z=x.allocType(36193===a.type?5126:a.type,p*w*l),I=0,fa=0;fa<w;++fa)for(var ga=0;ga<p;++ga)for(var xa=0;xa<l;++xa)z[I++]=e[d*ga+h*fa+f*xa+c];ob(a,z)}else if(na(c)===
	Ua||na(c)===pb)na(c)===Ua?a.element=c:a.element=c.canvas,a.width=a.element.width,a.height=a.element.height,a.channels=4;else if(na(c)===qb)a.element=c,a.width=c.width,a.height=c.height,a.channels=4;else if(na(c)===rb)a.element=c,a.width=c.naturalWidth,a.height=c.naturalHeight,a.channels=4;else if(na(c)===sb)a.element=c,a.width=c.videoWidth,a.height=c.videoHeight,a.channels=4;else if(nb(c)){e=a.width||c[0].length;d=a.height||c.length;h=a.channels;h=pa(c[0][0])?h||c[0][0].length:h||1;f=Ma.shape(c);
	p=1;for(w=0;w<f.length;++w)p*=f[w];p=x.allocType(36193===a.type?5126:a.type,p);Ma.flatten(c,f,"",p);ob(a,p);a.alignment=1;a.width=e;a.height=d;a.channels=h;a.format=a.internalformat=La[h];a.needsFree=!0}}function k(b,c,d,h,f){var g=b.element,l=b.data,k=b.internalformat,p=b.format,w=b.type,z=b.width,I=b.height;t(b);g?a.texSubImage2D(c,f,d,h,p,w,g):b.compressed?a.compressedTexSubImage2D(c,f,d,h,k,z,I,l):b.needsCopy?(e(),a.copyTexSubImage2D(c,f,d,h,b.xOffset,b.yOffset,z,I)):a.texSubImage2D(c,f,d,h,z,
	I,p,w,l)}function h(){return P.pop()||new m}function l(a){a.needsFree&&x.freeType(a.data);m.call(a);P.push(a)}function u(){f.call(this);this.genMipmaps=!1;this.mipmapHint=4352;this.mipmask=0;this.images=Array(16)}function v(a,b,c){var d=a.images[0]=h();a.mipmask=1;d.width=a.width=b;d.height=a.height=c;d.channels=a.channels=4}function N(a,b){var c=null;if(Ta(b))c=a.images[0]=h(),r(c,a),C(c,b),a.mipmask=1;else if(q(a,b),Array.isArray(b.mipmap))for(var d=b.mipmap,e=0;e<d.length;++e)c=a.images[e]=h(),
	r(c,a),c.width>>=e,c.height>>=e,C(c,d[e]),a.mipmask|=1<<e;else c=a.images[0]=h(),r(c,a),C(c,b),a.mipmask=1;r(a,a.images[0])}function B(b,c){for(var d=b.images,h=0;h<d.length&&d[h];++h){var f=d[h],g=c,l=h,k=f.element,p=f.data,w=f.internalformat,z=f.format,I=f.type,fa=f.width,ga=f.height,xa=f.channels;t(f);k?a.texImage2D(g,l,z,z,I,k):f.compressed?a.compressedTexImage2D(g,l,w,fa,ga,0,p):f.needsCopy?(e(),a.copyTexImage2D(g,l,z,f.xOffset,f.yOffset,fa,ga,0)):((f=!p)&&(p=x.zero.allocType(I,fa*ga*xa)),a.texImage2D(g,
	l,z,fa,ga,0,z,I,p),f&&p&&x.zero.freeType(p))}}function D(){var a=tb.pop()||new u;f.call(a);for(var b=a.mipmask=0;16>b;++b)a.images[b]=null;return a}function ib(a){for(var b=a.images,c=0;c<b.length;++c)b[c]&&l(b[c]),b[c]=null;tb.push(a)}function y(){this.magFilter=this.minFilter=9728;this.wrapT=this.wrapS=33071;this.anisotropic=1;this.genMipmaps=!1;this.mipmapHint=4352}function O(a,b){"min"in b&&(a.minFilter=Va[b.min],0<=Mb.indexOf(a.minFilter)&&!("faces"in b)&&(a.genMipmaps=!0));"mag"in b&&(a.magFilter=
	V[b.mag]);var c=a.wrapS,d=a.wrapT;if("wrap"in b){var e=b.wrap;"string"===typeof e?c=d=K[e]:Array.isArray(e)&&(c=K[e[0]],d=K[e[1]])}else"wrapS"in b&&(c=K[b.wrapS]),"wrapT"in b&&(d=K[b.wrapT]);a.wrapS=c;a.wrapT=d;"anisotropic"in b&&(a.anisotropic=b.anisotropic);if("mipmap"in b){c=!1;switch(typeof b.mipmap){case "string":a.mipmapHint=ua[b.mipmap];c=a.genMipmaps=!0;break;case "boolean":c=a.genMipmaps=b.mipmap;break;case "object":a.genMipmaps=!1,c=!0}!c||"min"in b||(a.minFilter=9984)}}function R(c,d){a.texParameteri(d,
	10241,c.minFilter);a.texParameteri(d,10240,c.magFilter);a.texParameteri(d,10242,c.wrapS);a.texParameteri(d,10243,c.wrapT);b.ext_texture_filter_anisotropic&&a.texParameteri(d,34046,c.anisotropic);c.genMipmaps&&(a.hint(33170,c.mipmapHint),a.generateMipmap(d))}function F(b){f.call(this);this.mipmask=0;this.internalformat=6408;this.id=ya++;this.refCount=1;this.target=b;this.texture=a.createTexture();this.unit=-1;this.bindCount=0;this.texInfo=new y;n.profile&&(this.stats={size:0})}function T(b){a.activeTexture(33984);
	a.bindTexture(b.target,b.texture)}function Aa(){var b=ha[0];b?a.bindTexture(b.target,b.texture):a.bindTexture(3553,null)}function A(b){var c=b.texture,e=b.unit,h=b.target;0<=e&&(a.activeTexture(33984+e),a.bindTexture(h,null),ha[e]=null);a.deleteTexture(c);b.texture=null;b.params=null;b.pixels=null;b.refCount=0;delete X[b.id];d.textureCount--}var ua={"don't care":4352,"dont care":4352,nice:4354,fast:4353},K={repeat:10497,clamp:33071,mirror:33648},V={nearest:9728,linear:9729},Va=E({mipmap:9987,"nearest mipmap nearest":9984,
	"linear mipmap nearest":9985,"nearest mipmap linear":9986,"linear mipmap linear":9987},V),wa={none:0,browser:37444},G={uint8:5121,rgba4:32819,rgb565:33635,"rgb5 a1":32820},U={alpha:6406,luminance:6409,"luminance alpha":6410,rgb:6407,rgba:6408,rgba4:32854,"rgb5 a1":32855,rgb565:36194},W={};b.ext_srgb&&(U.srgb=35904,U.srgba=35906);b.oes_texture_float&&(G.float32=G["float"]=5126);b.oes_texture_half_float&&(G.float16=G["half float"]=36193);b.webgl_depth_texture&&(E(U,{depth:6402,"depth stencil":34041}),
	E(G,{uint16:5123,uint32:5125,"depth stencil":34042}));b.webgl_compressed_texture_s3tc&&E(W,{"rgb s3tc dxt1":33776,"rgba s3tc dxt1":33777,"rgba s3tc dxt3":33778,"rgba s3tc dxt5":33779});b.webgl_compressed_texture_atc&&E(W,{"rgb atc":35986,"rgba atc explicit alpha":35987,"rgba atc interpolated alpha":34798});b.webgl_compressed_texture_pvrtc&&E(W,{"rgb pvrtc 4bppv1":35840,"rgb pvrtc 2bppv1":35841,"rgba pvrtc 4bppv1":35842,"rgba pvrtc 2bppv1":35843});b.webgl_compressed_texture_etc1&&(W["rgb etc1"]=36196);
	var Nb=Array.prototype.slice.call(a.getParameter(34467));Object.keys(W).forEach(function(a){var b=W[a];0<=Nb.indexOf(b)&&(U[a]=b)});var ca=Object.keys(U);c.textureFormats=ca;var J=[];Object.keys(U).forEach(function(a){J[U[a]]=a});var da=[];Object.keys(G).forEach(function(a){da[G[a]]=a});var oa=[];Object.keys(V).forEach(function(a){oa[V[a]]=a});var za=[];Object.keys(Va).forEach(function(a){za[Va[a]]=a});var ka=[];Object.keys(K).forEach(function(a){ka[K[a]]=a});var Lb=ca.reduce(function(a,b){var c=
	U[b];6409===c||6406===c||6409===c||6410===c||6402===c||34041===c?a[c]=c:32855===c||0<=b.indexOf("rgba")?a[c]=6408:a[c]=6407;return a},{}),P=[],tb=[],ya=0,X={},ea=c.maxTextureUnits,ha=Array(ea).map(function(){return null});E(F.prototype,{bind:function(){this.bindCount+=1;var b=this.unit;if(0>b){for(var c=0;c<ea;++c){var e=ha[c];if(e){if(0<e.bindCount)continue;e.unit=-1}ha[c]=this;b=c;break}n.profile&&d.maxTextureUnits<b+1&&(d.maxTextureUnits=b+1);this.unit=b;a.activeTexture(33984+b);a.bindTexture(this.target,
	this.texture)}return b},unbind:function(){--this.bindCount},decRef:function(){0>=--this.refCount&&A(this)}});n.profile&&(d.getTotalTextureSize=function(){var a=0;Object.keys(X).forEach(function(b){a+=X[b].stats.size});return a});return{create2D:function(b,c){function e(a,b){var c=f.texInfo;y.call(c);var d=D();"number"===typeof a?"number"===typeof b?v(d,a|0,b|0):v(d,a|0,a|0):a?(O(c,a),N(d,a)):v(d,1,1);c.genMipmaps&&(d.mipmask=(d.width<<1)-1);f.mipmask=d.mipmask;r(f,d);f.internalformat=d.internalformat;
	e.width=d.width;e.height=d.height;T(f);B(d,3553);R(c,3553);Aa();ib(d);n.profile&&(f.stats.size=Ja(f.internalformat,f.type,d.width,d.height,c.genMipmaps,!1));e.format=J[f.internalformat];e.type=da[f.type];e.mag=oa[c.magFilter];e.min=za[c.minFilter];e.wrapS=ka[c.wrapS];e.wrapT=ka[c.wrapT];return e}var f=new F(3553);X[f.id]=f;d.textureCount++;e(b,c);e.subimage=function(a,b,c,d){b|=0;c|=0;d|=0;var p=h();r(p,f);p.width=0;p.height=0;C(p,a);p.width=p.width||(f.width>>d)-b;p.height=p.height||(f.height>>d)-
	c;T(f);k(p,3553,b,c,d);Aa();l(p);return e};e.resize=function(b,c){var d=b|0,h=c|0||d;if(d===f.width&&h===f.height)return e;e.width=f.width=d;e.height=f.height=h;T(f);for(var p,w=f.channels,z=f.type,I=0;f.mipmask>>I;++I){var fa=d>>I,ga=h>>I;if(!fa||!ga)break;p=x.zero.allocType(z,fa*ga*w);a.texImage2D(3553,I,f.format,fa,ga,0,f.format,f.type,p);p&&x.zero.freeType(p)}Aa();n.profile&&(f.stats.size=Ja(f.internalformat,f.type,d,h,!1,!1));return e};e._reglType="texture2d";e._texture=f;n.profile&&(e.stats=
	f.stats);e.destroy=function(){f.decRef()};return e},createCube:function(b,c,e,f,g,ua){function A(a,b,c,d,e,f){var H,Y=m.texInfo;y.call(Y);for(H=0;6>H;++H)p[H]=D();if("number"===typeof a||!a)for(a=a|0||1,H=0;6>H;++H)v(p[H],a,a);else if("object"===typeof a)if(b)N(p[0],a),N(p[1],b),N(p[2],c),N(p[3],d),N(p[4],e),N(p[5],f);else if(O(Y,a),q(m,a),"faces"in a)for(a=a.faces,H=0;6>H;++H)r(p[H],m),N(p[H],a[H]);else for(H=0;6>H;++H)N(p[H],a);r(m,p[0]);m.mipmask=Y.genMipmaps?(p[0].width<<1)-1:p[0].mipmask;m.internalformat=
	p[0].internalformat;A.width=p[0].width;A.height=p[0].height;T(m);for(H=0;6>H;++H)B(p[H],34069+H);R(Y,34067);Aa();n.profile&&(m.stats.size=Ja(m.internalformat,m.type,A.width,A.height,Y.genMipmaps,!0));A.format=J[m.internalformat];A.type=da[m.type];A.mag=oa[Y.magFilter];A.min=za[Y.minFilter];A.wrapS=ka[Y.wrapS];A.wrapT=ka[Y.wrapT];for(H=0;6>H;++H)ib(p[H]);return A}var m=new F(34067);X[m.id]=m;d.cubeCount++;var p=Array(6);A(b,c,e,f,g,ua);A.subimage=function(a,b,c,p,d){c|=0;p|=0;d|=0;var e=h();r(e,m);
	e.width=0;e.height=0;C(e,b);e.width=e.width||(m.width>>d)-c;e.height=e.height||(m.height>>d)-p;T(m);k(e,34069+a,c,p,d);Aa();l(e);return A};A.resize=function(b){b|=0;if(b!==m.width){A.width=m.width=b;A.height=m.height=b;T(m);for(var c=0;6>c;++c)for(var p=0;m.mipmask>>p;++p)a.texImage2D(34069+c,p,m.format,b>>p,b>>p,0,m.format,m.type,null);Aa();n.profile&&(m.stats.size=Ja(m.internalformat,m.type,A.width,A.height,!1,!0));return A}};A._reglType="textureCube";A._texture=m;n.profile&&(A.stats=m.stats);A.destroy=
	function(){m.decRef()};return A},clear:function(){for(var b=0;b<ea;++b)a.activeTexture(33984+b),a.bindTexture(3553,null),ha[b]=null;S(X).forEach(A);d.cubeCount=0;d.textureCount=0},getTexture:function(a){return null},restore:function(){for(var b=0;b<ea;++b){var c=ha[b];c&&(c.bindCount=0,c.unit=-1,ha[b]=null)}S(X).forEach(function(b){b.texture=a.createTexture();a.bindTexture(b.target,b.texture);for(var c=0;32>c;++c)if(0!==(b.mipmask&1<<c))if(3553===b.target)a.texImage2D(3553,c,b.internalformat,b.width>>
	c,b.height>>c,0,b.internalformat,b.type,null);else for(var d=0;6>d;++d)a.texImage2D(34069+d,c,b.internalformat,b.width>>c,b.height>>c,0,b.internalformat,b.type,null);R(b.texInfo,b.target)})}}}function Ob(a,b,c,e,g,d){function n(a,b,c){this.target=a;this.texture=b;this.renderbuffer=c;var d=a=0;b?(a=b.width,d=b.height):c&&(a=c.width,d=c.height);this.width=a;this.height=d}function f(a){a&&(a.texture&&a.texture._texture.decRef(),a.renderbuffer&&a.renderbuffer._renderbuffer.decRef())}function r(a,b,c){a&&
	(a.texture?a.texture._texture.refCount+=1:a.renderbuffer._renderbuffer.refCount+=1)}function q(b,c){c&&(c.texture?a.framebufferTexture2D(36160,b,c.target,c.texture._texture.texture,0):a.framebufferRenderbuffer(36160,b,36161,c.renderbuffer._renderbuffer.renderbuffer))}function t(a){var b=3553,c=null,d=null,e=a;"object"===typeof a&&(e=a.data,"target"in a&&(b=a.target|0));a=e._reglType;"texture2d"===a?c=e:"textureCube"===a?c=e:"renderbuffer"===a&&(d=e,b=36161);return new n(b,c,d)}function m(a,b,c,d,
	f){if(c)return a=e.create2D({width:a,height:b,format:d,type:f}),a._texture.refCount=0,new n(3553,a,null);a=g.create({width:a,height:b,format:d});a._renderbuffer.refCount=0;return new n(36161,null,a)}function C(a){return a&&(a.texture||a.renderbuffer)}function k(a,b,c){a&&(a.texture?a.texture.resize(b,c):a.renderbuffer&&a.renderbuffer.resize(b,c),a.width=b,a.height=c)}function h(){this.id=O++;R[this.id]=this;this.framebuffer=a.createFramebuffer();this.height=this.width=0;this.colorAttachments=[];this.depthStencilAttachment=
	this.stencilAttachment=this.depthAttachment=null}function l(a){a.colorAttachments.forEach(f);f(a.depthAttachment);f(a.stencilAttachment);f(a.depthStencilAttachment)}function u(b){a.deleteFramebuffer(b.framebuffer);b.framebuffer=null;d.framebufferCount--;delete R[b.id]}function v(b){var d;a.bindFramebuffer(36160,b.framebuffer);var e=b.colorAttachments;for(d=0;d<e.length;++d)q(36064+d,e[d]);for(d=e.length;d<c.maxColorAttachments;++d)a.framebufferTexture2D(36160,36064+d,3553,null,0);a.framebufferTexture2D(36160,
	33306,3553,null,0);a.framebufferTexture2D(36160,36096,3553,null,0);a.framebufferTexture2D(36160,36128,3553,null,0);q(36096,b.depthAttachment);q(36128,b.stencilAttachment);q(33306,b.depthStencilAttachment);a.checkFramebufferStatus(36160);a.isContextLost();a.bindFramebuffer(36160,B.next?B.next.framebuffer:null);B.cur=B.next;a.getError()}function N(a,b){function c(a,b){var d,f=0,h=0,g=!0,k=!0;d=null;var q=!0,u="rgba",n="uint8",N=1,da=null,oa=null,B=null,ka=!1;if("number"===typeof a)f=a|0,h=b|0||f;else if(a){"shape"in
	a?(h=a.shape,f=h[0],h=h[1]):("radius"in a&&(f=h=a.radius),"width"in a&&(f=a.width),"height"in a&&(h=a.height));if("color"in a||"colors"in a)d=a.color||a.colors,Array.isArray(d);if(!d){"colorCount"in a&&(N=a.colorCount|0);"colorTexture"in a&&(q=!!a.colorTexture,u="rgba4");if("colorType"in a&&(n=a.colorType,!q))if("half float"===n||"float16"===n)u="rgba16f";else if("float"===n||"float32"===n)u="rgba32f";"colorFormat"in a&&(u=a.colorFormat,0<=x.indexOf(u)?q=!0:0<=D.indexOf(u)&&(q=!1))}if("depthTexture"in
	a||"depthStencilTexture"in a)ka=!(!a.depthTexture&&!a.depthStencilTexture);"depth"in a&&("boolean"===typeof a.depth?g=a.depth:(da=a.depth,k=!1));"stencil"in a&&("boolean"===typeof a.stencil?k=a.stencil:(oa=a.stencil,g=!1));"depthStencil"in a&&("boolean"===typeof a.depthStencil?g=k=a.depthStencil:(B=a.depthStencil,k=g=!1))}else f=h=1;var F=null,y=null,E=null,T=null;if(Array.isArray(d))F=d.map(t);else if(d)F=[t(d)];else for(F=Array(N),d=0;d<N;++d)F[d]=m(f,h,q,u,n);f=f||F[0].width;h=h||F[0].height;da?
	y=t(da):g&&!k&&(y=m(f,h,ka,"depth","uint32"));oa?E=t(oa):k&&!g&&(E=m(f,h,!1,"stencil","uint8"));B?T=t(B):!da&&!oa&&k&&g&&(T=m(f,h,ka,"depth stencil","depth stencil"));g=null;for(d=0;d<F.length;++d)r(F[d],f,h),F[d]&&F[d].texture&&(k=Wa[F[d].texture._texture.format]*Na[F[d].texture._texture.type],null===g&&(g=k));r(y,f,h);r(E,f,h);r(T,f,h);l(e);e.width=f;e.height=h;e.colorAttachments=F;e.depthAttachment=y;e.stencilAttachment=E;e.depthStencilAttachment=T;c.color=F.map(C);c.depth=C(y);c.stencil=C(E);
	c.depthStencil=C(T);c.width=e.width;c.height=e.height;v(e);return c}var e=new h;d.framebufferCount++;c(a,b);return E(c,{resize:function(a,b){var d=Math.max(a|0,1),f=Math.max(b|0||d,1);if(d===e.width&&f===e.height)return c;for(var h=e.colorAttachments,g=0;g<h.length;++g)k(h[g],d,f);k(e.depthAttachment,d,f);k(e.stencilAttachment,d,f);k(e.depthStencilAttachment,d,f);e.width=c.width=d;e.height=c.height=f;v(e);return c},_reglType:"framebuffer",_framebuffer:e,destroy:function(){u(e);l(e)},use:function(a){B.setFBO({framebuffer:c},
	a)}})}var B={cur:null,next:null,dirty:!1,setFBO:null},x=["rgba"],D=["rgba4","rgb565","rgb5 a1"];b.ext_srgb&&D.push("srgba");b.ext_color_buffer_half_float&&D.push("rgba16f","rgb16f");b.webgl_color_buffer_float&&D.push("rgba32f");var y=["uint8"];b.oes_texture_half_float&&y.push("half float","float16");b.oes_texture_float&&y.push("float","float32");var O=0,R={};return E(B,{getFramebuffer:function(a){return"function"===typeof a&&"framebuffer"===a._reglType&&(a=a._framebuffer,a instanceof h)?a:null},create:N,
	createCube:function(a){function b(a){var d,f={color:null},h=0,g=null;d="rgba";var l="uint8",m=1;if("number"===typeof a)h=a|0;else if(a){"shape"in a?h=a.shape[0]:("radius"in a&&(h=a.radius|0),"width"in a?h=a.width|0:"height"in a&&(h=a.height|0));if("color"in a||"colors"in a)g=a.color||a.colors,Array.isArray(g);g||("colorCount"in a&&(m=a.colorCount|0),"colorType"in a&&(l=a.colorType),"colorFormat"in a&&(d=a.colorFormat));"depth"in a&&(f.depth=a.depth);"stencil"in a&&(f.stencil=a.stencil);"depthStencil"in
	a&&(f.depthStencil=a.depthStencil)}else h=1;if(g)if(Array.isArray(g))for(a=[],d=0;d<g.length;++d)a[d]=g[d];else a=[g];else for(a=Array(m),g={radius:h,format:d,type:l},d=0;d<m;++d)a[d]=e.createCube(g);f.color=Array(a.length);for(d=0;d<a.length;++d)m=a[d],h=h||m.width,f.color[d]={target:34069,data:a[d]};for(d=0;6>d;++d){for(m=0;m<a.length;++m)f.color[m].target=34069+d;0<d&&(f.depth=c[0].depth,f.stencil=c[0].stencil,f.depthStencil=c[0].depthStencil);if(c[d])c[d](f);else c[d]=N(f)}return E(b,{width:h,
	height:h,color:a})}var c=Array(6);b(a);return E(b,{faces:c,resize:function(a){var d=a|0;if(d===b.width)return b;var e=b.color;for(a=0;a<e.length;++a)e[a].resize(d);for(a=0;6>a;++a)c[a].resize(d);b.width=b.height=d;return b},_reglType:"framebufferCube",destroy:function(){c.forEach(function(a){a.destroy()})}})},clear:function(){S(R).forEach(u)},restore:function(){B.cur=null;B.next=null;B.dirty=!0;S(R).forEach(function(b){b.framebuffer=a.createFramebuffer();v(b)})}})}function ub(){this.w=this.z=this.y=
	this.x=this.state=0;this.buffer=null;this.size=0;this.normalized=!1;this.type=5126;this.divisor=this.stride=this.offset=0}function Pb(a,b,c,e){a=c.maxAttributes;b=Array(a);for(c=0;c<a;++c)b[c]=new ub;return{Record:ub,scope:{},state:b}}function Qb(a,b,c,e){function g(a,b,c,d){this.name=a;this.id=b;this.location=c;this.info=d}function d(a,b){for(var c=0;c<a.length;++c)if(a[c].id===b.id){a[c].location=b.location;return}a.push(b)}function n(c,d,e){e=35632===c?q:t;var f=e[d];if(!f){var g=b.str(d),f=a.createShader(c);
	a.shaderSource(f,g);a.compileShader(f);e[d]=f}return f}function f(a,b){this.id=k++;this.fragId=a;this.vertId=b;this.program=null;this.uniforms=[];this.attributes=[];e.profile&&(this.stats={uniformsCount:0,attributesCount:0})}function r(c,f){var m,k;m=n(35632,c.fragId);k=n(35633,c.vertId);var q=c.program=a.createProgram();a.attachShader(q,m);a.attachShader(q,k);a.linkProgram(q);var r=a.getProgramParameter(q,35718);e.profile&&(c.stats.uniformsCount=r);var t=c.uniforms;for(m=0;m<r;++m)if(k=a.getActiveUniform(q,
	m))if(1<k.size)for(var C=0;C<k.size;++C){var y=k.name.replace("[0]","["+C+"]");d(t,new g(y,b.id(y),a.getUniformLocation(q,y),k))}else d(t,new g(k.name,b.id(k.name),a.getUniformLocation(q,k.name),k));r=a.getProgramParameter(q,35721);e.profile&&(c.stats.attributesCount=r);t=c.attributes;for(m=0;m<r;++m)(k=a.getActiveAttrib(q,m))&&d(t,new g(k.name,b.id(k.name),a.getAttribLocation(q,k.name),k))}var q={},t={},m={},C=[],k=0;e.profile&&(c.getMaxUniformsCount=function(){var a=0;C.forEach(function(b){b.stats.uniformsCount>
	a&&(a=b.stats.uniformsCount)});return a},c.getMaxAttributesCount=function(){var a=0;C.forEach(function(b){b.stats.attributesCount>a&&(a=b.stats.attributesCount)});return a});return{clear:function(){var b=a.deleteShader.bind(a);S(q).forEach(b);q={};S(t).forEach(b);t={};C.forEach(function(b){a.deleteProgram(b.program)});C.length=0;m={};c.shaderCount=0},program:function(a,b,d){var e=m[b];e||(e=m[b]={});var g=e[a];g||(g=new f(b,a),c.shaderCount++,r(g,d),e[a]=g,C.push(g));return g},restore:function(){q=
	{};t={};for(var a=0;a<C.length;++a)r(C[a])},shader:n,frag:-1,vert:-1}}function Rb(a,b,c,e,g,d,n){function f(d){var f;f=null===b.next?5121:b.next.colorAttachments[0].texture._texture.type;var g=0,r=0,k=e.framebufferWidth,h=e.framebufferHeight,l=null;M(d)?l=d:d&&(g=d.x|0,r=d.y|0,k=(d.width||e.framebufferWidth-g)|0,h=(d.height||e.framebufferHeight-r)|0,l=d.data||null);c();d=k*h*4;l||(5121===f?l=new Uint8Array(d):5126===f&&(l=l||new Float32Array(d)));a.pixelStorei(3333,4);a.readPixels(g,r,k,h,6408,f,
	l);return l}function r(a){var c;b.setFBO({framebuffer:a.framebuffer},function(){c=f(a)});return c}return function(a){return a&&"framebuffer"in a?r(a):f(a)}}function Ba(a){return Array.prototype.slice.call(a)}function Ca(a){return Ba(a).join("")}function Sb(){function a(){var a=[],b=[];return E(function(){a.push.apply(a,Ba(arguments))},{def:function(){var d="v"+c++;b.push(d);0<arguments.length&&(a.push(d,"="),a.push.apply(a,Ba(arguments)),a.push(";"));return d},toString:function(){return Ca([0<b.length?
	"var "+b+";":"",Ca(a)])}})}function b(){function b(a,e){d(a,e,"=",c.def(a,e),";")}var c=a(),d=a(),e=c.toString,g=d.toString;return E(function(){c.apply(c,Ba(arguments))},{def:c.def,entry:c,exit:d,save:b,set:function(a,d,e){b(a,d);c(a,d,"=",e,";")},toString:function(){return e()+g()}})}var c=0,e=[],g=[],d=a(),n={};return{global:d,link:function(a){for(var b=0;b<g.length;++b)if(g[b]===a)return e[b];b="g"+c++;e.push(b);g.push(a);return b},block:a,proc:function(a,c){function d(){var a="a"+e.length;e.push(a);
	return a}var e=[];c=c||0;for(var g=0;g<c;++g)d();var g=b(),C=g.toString;return n[a]=E(g,{arg:d,toString:function(){return Ca(["function(",e.join(),"){",C(),"}"])}})},scope:b,cond:function(){var a=Ca(arguments),c=b(),d=b(),e=c.toString,g=d.toString;return E(c,{then:function(){c.apply(c,Ba(arguments));return this},"else":function(){d.apply(d,Ba(arguments));return this},toString:function(){var b=g();b&&(b="else{"+b+"}");return Ca(["if(",a,"){",e(),"}",b])}})},compile:function(){var a=['"use strict";',
	d,"return {"];Object.keys(n).forEach(function(b){a.push('"',b,'":',n[b].toString(),",")});a.push("}");var b=Ca(a).replace(/;/g,";\n").replace(/}/g,"}\n").replace(/{/g,"{\n");return Function.apply(null,e.concat(b)).apply(null,g)}}}function Oa(a){return Array.isArray(a)||M(a)||ma(a)}function vb(a){return a.sort(function(a,c){return"viewport"===a?-1:"viewport"===c?1:a<c?-1:1})}function Z(a,b,c,e){this.thisDep=a;this.contextDep=b;this.propDep=c;this.append=e}function va(a){return a&&!(a.thisDep||a.contextDep||
	a.propDep)}function D(a){return new Z(!1,!1,!1,a)}function P(a,b){var c=a.type;return 0===c?(c=a.data.length,new Z(!0,1<=c,2<=c,b)):4===c?(c=a.data,new Z(c.thisDep,c.contextDep,c.propDep,b)):new Z(3===c,2===c,1===c,b)}function Tb(a,b,c,e,g,d,n,f,r,q,t,m,C,k,h){function l(a){return a.replace(".","_")}function u(a,b,c){var d=l(a);Ka.push(a);Fa[d]=ra[d]=!!c;sa[d]=b}function v(a,b,c){var d=l(a);Ka.push(a);Array.isArray(c)?(ra[d]=c.slice(),Fa[d]=c.slice()):ra[d]=Fa[d]=c;ta[d]=b}function N(){var a=Sb(),
	c=a.link,d=a.global;a.id=qa++;a.batchId="0";var e=c(na),f=a.shared={props:"a0"};Object.keys(na).forEach(function(a){f[a]=d.def(e,".",a)});var g=a.next={},xa=a.current={};Object.keys(ta).forEach(function(a){Array.isArray(ra[a])&&(g[a]=d.def(f.next,".",a),xa[a]=d.def(f.current,".",a))});var H=a.constants={};Object.keys(aa).forEach(function(a){H[a]=d.def(JSON.stringify(aa[a]))});a.invoke=function(b,d){switch(d.type){case 0:var e=["this",f.context,f.props,a.batchId];return b.def(c(d.data),".call(",e.slice(0,
	Math.max(d.data.length+1,4)),")");case 1:return b.def(f.props,d.data);case 2:return b.def(f.context,d.data);case 3:return b.def("this",d.data);case 4:return d.data.append(a,b),d.data.ref}};a.attribCache={};var Y={};a.scopeAttrib=function(a){a=b.id(a);if(a in Y)return Y[a];var d=q.scope[a];d||(d=q.scope[a]=new ya);return Y[a]=c(d)};return a}function B(a){var b=a["static"];a=a.dynamic;var c;if("profile"in b){var d=!!b.profile;c=D(function(a,b){return d});c.enable=d}else if("profile"in a){var e=a.profile;
	c=P(e,function(a,b){return a.invoke(b,e)})}return c}function y(a,b){var c=a["static"],d=a.dynamic;if("framebuffer"in c){var e=c.framebuffer;return e?(e=f.getFramebuffer(e),D(function(a,b){var c=a.link(e),d=a.shared;b.set(d.framebuffer,".next",c);d=d.context;b.set(d,".framebufferWidth",c+".width");b.set(d,".framebufferHeight",c+".height");return c})):D(function(a,b){var c=a.shared;b.set(c.framebuffer,".next","null");c=c.context;b.set(c,".framebufferWidth",c+".drawingBufferWidth");b.set(c,".framebufferHeight",
	c+".drawingBufferHeight");return"null"})}if("framebuffer"in d){var g=d.framebuffer;return P(g,function(a,b){var c=a.invoke(b,g),d=a.shared,e=d.framebuffer,c=b.def(e,".getFramebuffer(",c,")");b.set(e,".next",c);d=d.context;b.set(d,".framebufferWidth",c+"?"+c+".width:"+d+".drawingBufferWidth");b.set(d,".framebufferHeight",c+"?"+c+".height:"+d+".drawingBufferHeight");return c})}return null}function x(a,b,c){function d(a){if(a in e){var c=e[a];a=!0;var p=c.x|0,ba=c.y|0,g,h;"width"in c?g=c.width|0:a=!1;
	"height"in c?h=c.height|0:a=!1;return new Z(!a&&b&&b.thisDep,!a&&b&&b.contextDep,!a&&b&&b.propDep,function(a,b){var d=a.shared.context,e=g;"width"in c||(e=b.def(d,".","framebufferWidth","-",p));var f=h;"height"in c||(f=b.def(d,".","framebufferHeight","-",ba));return[p,ba,e,f]})}if(a in f){var z=f[a];a=P(z,function(a,b){var c=a.invoke(b,z),d=a.shared.context,e=b.def(c,".x|0"),p=b.def(c,".y|0"),Y=b.def('"width" in ',c,"?",c,".width|0:","(",d,".","framebufferWidth","-",e,")"),c=b.def('"height" in ',
	c,"?",c,".height|0:","(",d,".","framebufferHeight","-",p,")");return[e,p,Y,c]});b&&(a.thisDep=a.thisDep||b.thisDep,a.contextDep=a.contextDep||b.contextDep,a.propDep=a.propDep||b.propDep);return a}return b?new Z(b.thisDep,b.contextDep,b.propDep,function(a,b){var c=a.shared.context;return[0,0,b.def(c,".","framebufferWidth"),b.def(c,".","framebufferHeight")]}):null}var e=a["static"],f=a.dynamic;if(a=d("viewport")){var g=a;a=new Z(a.thisDep,a.contextDep,a.propDep,function(a,b){var c=g.append(a,b),d=a.shared.context;
	b.set(d,".viewportWidth",c[2]);b.set(d,".viewportHeight",c[3]);return c})}return{viewport:a,scissor_box:d("scissor.box")}}function E(a){function c(a){if(a in d){var p=b.id(d[a]);a=D(function(){return p});a.id=p;return a}if(a in e){var f=e[a];return P(f,function(a,b){var c=a.invoke(b,f);return b.def(a.shared.strings,".id(",c,")")})}return null}var d=a["static"],e=a.dynamic,f=c("frag"),g=c("vert"),h=null;va(f)&&va(g)?(h=t.program(g.id,f.id),a=D(function(a,b){return a.link(h)})):a=new Z(f&&f.thisDep||
	g&&g.thisDep,f&&f.contextDep||g&&g.contextDep,f&&f.propDep||g&&g.propDep,function(a,b){var c=a.shared.shader,d;d=f?f.append(a,b):b.def(c,".","frag");var e;e=g?g.append(a,b):b.def(c,".","vert");return b.def(c+".program("+e+","+d+")")});return{frag:f,vert:g,progVar:a,program:h}}function O(a,b){function c(a,b){if(a in e){var d=e[a]|0;return D(function(a,c){b&&(a.OFFSET=d);return d})}if(a in f){var p=f[a];return P(p,function(a,c){var d=a.invoke(c,p);b&&(a.OFFSET=d);return d})}return b&&g?D(function(a,
	b){a.OFFSET="0";return 0}):null}var e=a["static"],f=a.dynamic,g=function(){if("elements"in e){var a=e.elements;Oa(a)?a=d.getElements(d.create(a,!0)):a&&(a=d.getElements(a));var b=D(function(b,c){if(a){var d=b.link(a);return b.ELEMENTS=d}return b.ELEMENTS=null});b.value=a;return b}if("elements"in f){var c=f.elements;return P(c,function(a,b){var d=a.shared,e=d.isBufferArgs,d=d.elements,p=a.invoke(b,c),f=b.def("null"),e=b.def(e,"(",p,")"),p=a.cond(e).then(f,"=",d,".createStream(",p,");")["else"](f,"=",
	d,".getElements(",p,");");b.entry(p);b.exit(a.cond(e).then(d,".destroyStream(",f,");"));return a.ELEMENTS=f})}return null}(),h=c("offset",!0);return{elements:g,primitive:function(){if("primitive"in e){var a=e.primitive;return D(function(b,c){return Sa[a]})}if("primitive"in f){var b=f.primitive;return P(b,function(a,c){var d=a.constants.primTypes,e=a.invoke(c,b);return c.def(d,"[",e,"]")})}return g?va(g)?g.value?D(function(a,b){return b.def(a.ELEMENTS,".primType")}):D(function(){return 4}):new Z(g.thisDep,
	g.contextDep,g.propDep,function(a,b){var c=a.ELEMENTS;return b.def(c,"?",c,".primType:",4)}):null}(),count:function(){if("count"in e){var a=e.count|0;return D(function(){return a})}if("count"in f){var b=f.count;return P(b,function(a,c){return a.invoke(c,b)})}return g?va(g)?g?h?new Z(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.ELEMENTS,".vertCount-",a.OFFSET)}):D(function(a,b){return b.def(a.ELEMENTS,".vertCount")}):D(function(){return-1}):new Z(g.thisDep||h.thisDep,g.contextDep||
	h.contextDep,g.propDep||h.propDep,function(a,b){var c=a.ELEMENTS;return a.OFFSET?b.def(c,"?",c,".vertCount-",a.OFFSET,":-1"):b.def(c,"?",c,".vertCount:-1")}):null}(),instances:c("instances",!1),offset:h}}function R(a,b){var c=a["static"],d=a.dynamic,e={};Ka.forEach(function(a){function b(f,g){if(a in c){var w=f(c[a]);e[p]=D(function(){return w})}else if(a in d){var h=d[a];e[p]=P(h,function(a,b){return g(a,b,a.invoke(b,h))})}}var p=l(a);switch(a){case "cull.enable":case "blend.enable":case "dither":case "stencil.enable":case "depth.enable":case "scissor.enable":case "polygonOffset.enable":case "sample.alpha":case "sample.enable":case "depth.mask":return b(function(a){return a},
	function(a,b,c){return c});case "depth.func":return b(function(a){return Xa[a]},function(a,b,c){return b.def(a.constants.compareFuncs,"[",c,"]")});case "depth.range":return b(function(a){return a},function(a,b,c){a=b.def("+",c,"[0]");b=b.def("+",c,"[1]");return[a,b]});case "blend.func":return b(function(a){return[Ga["srcRGB"in a?a.srcRGB:a.src],Ga["dstRGB"in a?a.dstRGB:a.dst],Ga["srcAlpha"in a?a.srcAlpha:a.src],Ga["dstAlpha"in a?a.dstAlpha:a.dst]]},function(a,b,c){function d(a,e){return b.def('"',
	a,e,'" in ',c,"?",c,".",a,e,":",c,".",a)}a=a.constants.blendFuncs;var e=d("src","RGB"),p=d("dst","RGB"),e=b.def(a,"[",e,"]"),f=b.def(a,"[",d("src","Alpha"),"]"),p=b.def(a,"[",p,"]");a=b.def(a,"[",d("dst","Alpha"),"]");return[e,p,f,a]});case "blend.equation":return b(function(a){if("string"===typeof a)return[X[a],X[a]];if("object"===typeof a)return[X[a.rgb],X[a.alpha]]},function(a,b,c){var d=a.constants.blendEquations,e=b.def(),p=b.def();a=a.cond("typeof ",c,'==="string"');a.then(e,"=",p,"=",d,"[",
	c,"];");a["else"](e,"=",d,"[",c,".rgb];",p,"=",d,"[",c,".alpha];");b(a);return[e,p]});case "blend.color":return b(function(a){return J(4,function(b){return+a[b]})},function(a,b,c){return J(4,function(a){return b.def("+",c,"[",a,"]")})});case "stencil.mask":return b(function(a){return a|0},function(a,b,c){return b.def(c,"|0")});case "stencil.func":return b(function(a){return[Xa[a.cmp||"keep"],a.ref||0,"mask"in a?a.mask:-1]},function(a,b,c){a=b.def('"cmp" in ',c,"?",a.constants.compareFuncs,"[",c,".cmp]",
	":",7680);var d=b.def(c,".ref|0");b=b.def('"mask" in ',c,"?",c,".mask|0:-1");return[a,d,b]});case "stencil.opFront":case "stencil.opBack":return b(function(b){return["stencil.opBack"===a?1029:1028,Pa[b.fail||"keep"],Pa[b.zfail||"keep"],Pa[b.zpass||"keep"]]},function(b,c,d){function e(a){return c.def('"',a,'" in ',d,"?",p,"[",d,".",a,"]:",7680)}var p=b.constants.stencilOps;return["stencil.opBack"===a?1029:1028,e("fail"),e("zfail"),e("zpass")]});case "polygonOffset.offset":return b(function(a){return[a.factor|
	0,a.units|0]},function(a,b,c){a=b.def(c,".factor|0");b=b.def(c,".units|0");return[a,b]});case "cull.face":return b(function(a){var b=0;"front"===a?b=1028:"back"===a&&(b=1029);return b},function(a,b,c){return b.def(c,'==="front"?',1028,":",1029)});case "lineWidth":return b(function(a){return a},function(a,b,c){return c});case "frontFace":return b(function(a){return wb[a]},function(a,b,c){return b.def(c+'==="cw"?2304:2305')});case "colorMask":return b(function(a){return a.map(function(a){return!!a})},
	function(a,b,c){return J(4,function(a){return"!!"+c+"["+a+"]"})});case "sample.coverage":return b(function(a){return["value"in a?a.value:1,!!a.invert]},function(a,b,c){a=b.def('"value" in ',c,"?+",c,".value:1");b=b.def("!!",c,".invert");return[a,b]})}});return e}function F(a,b){var c=a["static"],d=a.dynamic,e={};Object.keys(c).forEach(function(a){var b=c[a],d;if("number"===typeof b||"boolean"===typeof b)d=D(function(){return b});else if("function"===typeof b){var p=b._reglType;if("texture2d"===p||
	"textureCube"===p)d=D(function(a){return a.link(b)});else if("framebuffer"===p||"framebufferCube"===p)d=D(function(a){return a.link(b.color[0])})}else pa(b)&&(d=D(function(a){return a.global.def("[",J(b.length,function(a){return b[a]}),"]")}));d.value=b;e[a]=d});Object.keys(d).forEach(function(a){var b=d[a];e[a]=P(b,function(a,c){return a.invoke(c,b)})});return e}function T(a,c){var d=a["static"],e=a.dynamic,f={};Object.keys(d).forEach(function(a){var c=d[a],e=b.id(a),p=new ya;if(Oa(c))p.state=1,
	p.buffer=g.getBuffer(g.create(c,34962,!1,!0)),p.type=0;else{var w=g.getBuffer(c);if(w)p.state=1,p.buffer=w,p.type=0;else if("constant"in c){var h=c.constant;p.buffer="null";p.state=2;"number"===typeof h?p.x=h:Da.forEach(function(a,b){b<h.length&&(p[a]=h[b])})}else{var w=Oa(c.buffer)?g.getBuffer(g.create(c.buffer,34962,!1,!0)):g.getBuffer(c.buffer),k=c.offset|0,m=c.stride|0,I=c.size|0,l=!!c.normalized,n=0;"type"in c&&(n=Ra[c.type]);c=c.divisor|0;p.buffer=w;p.state=1;p.size=I;p.normalized=l;p.type=
	n||w.dtype;p.offset=k;p.stride=m;p.divisor=c}}f[a]=D(function(a,b){var c=a.attribCache;if(e in c)return c[e];var d={isStream:!1};Object.keys(p).forEach(function(a){d[a]=p[a]});p.buffer&&(d.buffer=a.link(p.buffer),d.type=d.type||d.buffer+".dtype");return c[e]=d})});Object.keys(e).forEach(function(a){var b=e[a];f[a]=P(b,function(a,c){function d(a){c(w[a],"=",e,".",a,"|0;")}var e=a.invoke(c,b),p=a.shared,f=p.isBufferArgs,g=p.buffer,w={isStream:c.def(!1)},h=new ya;h.state=1;Object.keys(h).forEach(function(a){w[a]=
	c.def(""+h[a])});var z=w.buffer,k=w.type;c("if(",f,"(",e,")){",w.isStream,"=true;",z,"=",g,".createStream(",34962,",",e,");",k,"=",z,".dtype;","}else{",z,"=",g,".getBuffer(",e,");","if(",z,"){",k,"=",z,".dtype;",'}else if("constant" in ',e,"){",w.state,"=",2,";","if(typeof "+e+'.constant === "number"){',w[Da[0]],"=",e,".constant;",Da.slice(1).map(function(a){return w[a]}).join("="),"=0;","}else{",Da.map(function(a,b){return w[a]+"="+e+".constant.length>"+b+"?"+e+".constant["+b+"]:0;"}).join(""),"}}else{",
	"if(",f,"(",e,".buffer)){",z,"=",g,".createStream(",34962,",",e,".buffer);","}else{",z,"=",g,".getBuffer(",e,".buffer);","}",k,'="type" in ',e,"?",p.glTypes,"[",e,".type]:",z,".dtype;",w.normalized,"=!!",e,".normalized;");d("size");d("offset");d("stride");d("divisor");c("}}");c.exit("if(",w.isStream,"){",g,".destroyStream(",z,");","}");return w})});return f}function M(a){var b=a["static"],c=a.dynamic,d={};Object.keys(b).forEach(function(a){var c=b[a];d[a]=D(function(a,b){return"number"===typeof c||
	"boolean"===typeof c?""+c:a.link(c)})});Object.keys(c).forEach(function(a){var b=c[a];d[a]=P(b,function(a,c){return a.invoke(c,b)})});return d}function A(a,b,c,d,e){var f=y(a,e),g=x(a,f,e),h=O(a,e),k=R(a,e),m=E(a,e),ba=g.viewport;ba&&(k.viewport=ba);ba=l("scissor.box");(g=g[ba])&&(k[ba]=g);g=0<Object.keys(k).length;f={framebuffer:f,draw:h,shader:m,state:k,dirty:g};f.profile=B(a,e);f.uniforms=F(c,e);f.attributes=T(b,e);f.context=M(d,e);return f}function ua(a,b,c){var d=a.shared.context,e=a.scope();
	Object.keys(c).forEach(function(f){b.save(d,"."+f);e(d,".",f,"=",c[f].append(a,b),";")});b(e)}function K(a,b,c,d){var e=a.shared,f=e.gl,g=e.framebuffer,h;ha&&(h=b.def(e.extensions,".webgl_draw_buffers"));var k=a.constants,e=k.drawBuffer,k=k.backBuffer;a=c?c.append(a,b):b.def(g,".next");d||b("if(",a,"!==",g,".cur){");b("if(",a,"){",f,".bindFramebuffer(",36160,",",a,".framebuffer);");ha&&b(h,".drawBuffersWEBGL(",e,"[",a,".colorAttachments.length]);");b("}else{",f,".bindFramebuffer(",36160,",null);");
	ha&&b(h,".drawBuffersWEBGL(",k,");");b("}",g,".cur=",a,";");d||b("}")}function V(a,b,c){var d=a.shared,e=d.gl,f=a.current,g=a.next,h=d.current,k=d.next,m=a.cond(h,".dirty");Ka.forEach(function(b){b=l(b);if(!(b in c.state)){var d,w;if(b in g){d=g[b];w=f[b];var I=J(ra[b].length,function(a){return m.def(d,"[",a,"]")});m(a.cond(I.map(function(a,b){return a+"!=="+w+"["+b+"]"}).join("||")).then(e,".",ta[b],"(",I,");",I.map(function(a,b){return w+"["+b+"]="+a}).join(";"),";"))}else d=m.def(k,".",b),I=a.cond(d,
	"!==",h,".",b),m(I),b in sa?I(a.cond(d).then(e,".enable(",sa[b],");")["else"](e,".disable(",sa[b],");"),h,".",b,"=",d,";"):I(e,".",ta[b],"(",d,");",h,".",b,"=",d,";")}});0===Object.keys(c.state).length&&m(h,".dirty=false;");b(m)}function Q(a,b,c,d){var e=a.shared,f=a.current,g=e.current,h=e.gl;vb(Object.keys(c)).forEach(function(e){var k=c[e];if(!d||d(k)){var m=k.append(a,b);if(sa[e]){var l=sa[e];va(k)?m?b(h,".enable(",l,");"):b(h,".disable(",l,");"):b(a.cond(m).then(h,".enable(",l,");")["else"](h,
	".disable(",l,");"));b(g,".",e,"=",m,";")}else if(pa(m)){var n=f[e];b(h,".",ta[e],"(",m,");",m.map(function(a,b){return n+"["+b+"]="+a}).join(";"),";")}else b(h,".",ta[e],"(",m,");",g,".",e,"=",m,";")}})}function wa(a,b){ea&&(a.instancing=b.def(a.shared.extensions,".angle_instanced_arrays"))}function G(a,b,c,d,e){function f(){return"undefined"===typeof performance?"Date.now()":"performance.now()"}function g(a){t=b.def();a(t,"=",f(),";");"string"===typeof e?a(ba,".count+=",e,";"):a(ba,".count++;");
	k&&(d?(r=b.def(),a(r,"=",q,".getNumPendingQueries();")):a(q,".beginQuery(",ba,");"))}function h(a){a(ba,".cpuTime+=",f(),"-",t,";");k&&(d?a(q,".pushScopeStats(",r,",",q,".getNumPendingQueries(),",ba,");"):a(q,".endQuery();"))}function m(a){var c=b.def(n,".profile");b(n,".profile=",a,";");b.exit(n,".profile=",c,";")}var l=a.shared,ba=a.stats,n=l.current,q=l.timer;c=c.profile;var t,r;if(c){if(va(c)){c.enable?(g(b),h(b.exit),m("true")):m("false");return}c=c.append(a,b);m(c)}else c=b.def(n,".profile");
	l=a.block();g(l);b("if(",c,"){",l,"}");a=a.block();h(a);b.exit("if(",c,"){",a,"}")}function U(a,b,c,d,e){function f(a){switch(a){case 35664:case 35667:case 35671:return 2;case 35665:case 35668:case 35672:return 3;case 35666:case 35669:case 35673:return 4;default:return 1}}function g(c,d,e){function f(){b("if(!",z,".buffer){",k,".enableVertexAttribArray(",l,");}");var c=e.type,g;g=e.size?b.def(e.size,"||",d):d;b("if(",z,".type!==",c,"||",z,".size!==",g,"||",q.map(function(a){return z+"."+a+"!=="+e[a]}).join("||"),
	"){",k,".bindBuffer(",34962,",",I,".buffer);",k,".vertexAttribPointer(",[l,g,c,e.normalized,e.stride,e.offset],");",z,".type=",c,";",z,".size=",g,";",q.map(function(a){return z+"."+a+"="+e[a]+";"}).join(""),"}");ea&&(c=e.divisor,b("if(",z,".divisor!==",c,"){",a.instancing,".vertexAttribDivisorANGLE(",[l,c],");",z,".divisor=",c,";}"))}function m(){b("if(",z,".buffer){",k,".disableVertexAttribArray(",l,");","}if(",Da.map(function(a,b){return z+"."+a+"!=="+n[b]}).join("||"),"){",k,".vertexAttrib4f(",
	l,",",n,");",Da.map(function(a,b){return z+"."+a+"="+n[b]+";"}).join(""),"}")}var k=h.gl,l=b.def(c,".location"),z=b.def(h.attributes,"[",l,"]");c=e.state;var I=e.buffer,n=[e.x,e.y,e.z,e.w],q=["buffer","normalized","offset","stride"];1===c?f():2===c?m():(b("if(",c,"===",1,"){"),f(),b("}else{"),m(),b("}"))}var h=a.shared;d.forEach(function(d){var h=d.name,k=c.attributes[h],m;if(k){if(!e(k))return;m=k.append(a,b)}else{if(!e(xb))return;var l=a.scopeAttrib(h);m={};Object.keys(new ya).forEach(function(a){m[a]=
	b.def(l,".",a)})}g(a.link(d),f(d.info.type),m)})}function W(a,c,d,e,f){for(var g=a.shared,h=g.gl,k,m=0;m<e.length;++m){var l=e[m],n=l.name,q=l.info.type,t=d.uniforms[n],l=a.link(l)+".location",r;if(t){if(!f(t))continue;if(va(t)){n=t.value;if(35678===q||35680===q)q=a.link(n._texture||n.color[0]._texture),c(h,".uniform1i(",l,",",q+".bind());"),c.exit(q,".unbind();");else if(35674===q||35675===q||35676===q)n=a.global.def("new Float32Array(["+Array.prototype.slice.call(n)+"])"),t=2,35675===q?t=3:35676===
	q&&(t=4),c(h,".uniformMatrix",t,"fv(",l,",false,",n,");");else{switch(q){case 5126:k="1f";break;case 35664:k="2f";break;case 35665:k="3f";break;case 35666:k="4f";break;case 35670:k="1i";break;case 5124:k="1i";break;case 35671:k="2i";break;case 35667:k="2i";break;case 35672:k="3i";break;case 35668:k="3i";break;case 35673:k="4i";break;case 35669:k="4i"}c(h,".uniform",k,"(",l,",",pa(n)?Array.prototype.slice.call(n):n,");")}continue}else r=t.append(a,c)}else{if(!f(xb))continue;r=c.def(g.uniforms,"[",
	b.id(n),"]")}35678===q?c("if(",r,"&&",r,'._reglType==="framebuffer"){',r,"=",r,".color[0];","}"):35680===q&&c("if(",r,"&&",r,'._reglType==="framebufferCube"){',r,"=",r,".color[0];","}");n=1;switch(q){case 35678:case 35680:q=c.def(r,"._texture");c(h,".uniform1i(",l,",",q,".bind());");c.exit(q,".unbind();");continue;case 5124:case 35670:k="1i";break;case 35667:case 35671:k="2i";n=2;break;case 35668:case 35672:k="3i";n=3;break;case 35669:case 35673:k="4i";n=4;break;case 5126:k="1f";break;case 35664:k=
	"2f";n=2;break;case 35665:k="3f";n=3;break;case 35666:k="4f";n=4;break;case 35674:k="Matrix2fv";break;case 35675:k="Matrix3fv";break;case 35676:k="Matrix4fv"}c(h,".uniform",k,"(",l,",");if("M"===k.charAt(0)){var l=Math.pow(q-35674+2,2),v=a.global.def("new Float32Array(",l,")");c("false,(Array.isArray(",r,")||",r," instanceof Float32Array)?",r,":(",J(l,function(a){return v+"["+a+"]="+r+"["+a+"]"}),",",v,")")}else 1<n?c(J(n,function(a){return r+"["+a+"]"})):c(r);c(");")}}function S(a,b,c,d){function e(f){var g=
	l[f];return g?g.contextDep&&d.contextDynamic||g.propDep?g.append(a,c):g.append(a,b):b.def(m,".",f)}function f(){function a(){c(u,".drawElementsInstancedANGLE(",[q,t,C,r+"<<(("+C+"-5121)>>1)",v],");")}function b(){c(u,".drawArraysInstancedANGLE(",[q,r,t,v],");")}n?da?a():(c("if(",n,"){"),a(),c("}else{"),b(),c("}")):b()}function g(){function a(){c(k+".drawElements("+[q,t,C,r+"<<(("+C+"-5121)>>1)"]+");")}function b(){c(k+".drawArrays("+[q,r,t]+");")}n?da?a():(c("if(",n,"){"),a(),c("}else{"),b(),c("}")):
	b()}var h=a.shared,k=h.gl,m=h.draw,l=d.draw,n=function(){var e=l.elements,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f)}else e=f.def(m,".","elements");e&&f("if("+e+")"+k+".bindBuffer(34963,"+e+".buffer.buffer);");return e}(),q=e("primitive"),r=e("offset"),t=function(){var e=l.count,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f)}else e=f.def(m,".","count");return e}();if("number"===typeof t){if(0===t)return}else c("if(",t,"){"),c.exit("}");var v,
	u;ea&&(v=e("instances"),u=a.instancing);var C=n+".type",da=l.elements&&va(l.elements);ea&&("number"!==typeof v||0<=v)?"string"===typeof v?(c("if(",v,">0){"),f(),c("}else if(",v,"<0){"),g(),c("}")):f():g()}function ca(a,b,c,d,e){b=N();e=b.proc("body",e);ea&&(b.instancing=e.def(b.shared.extensions,".angle_instanced_arrays"));a(b,e,c,d);return b.compile().body}function L(a,b,c,d){wa(a,b);U(a,b,c,d.attributes,function(){return!0});W(a,b,c,d.uniforms,function(){return!0});S(a,b,b,c)}function da(a,b){var c=
	a.proc("draw",1);wa(a,c);ua(a,c,b.context);K(a,c,b.framebuffer);V(a,c,b);Q(a,c,b.state);G(a,c,b,!1,!0);var d=b.shader.progVar.append(a,c);c(a.shared.gl,".useProgram(",d,".program);");if(b.shader.program)L(a,c,b,b.shader.program);else{var e=a.global.def("{}"),f=c.def(d,".id"),g=c.def(e,"[",f,"]");c(a.cond(g).then(g,".call(this,a0);")["else"](g,"=",e,"[",f,"]=",a.link(function(c){return ca(L,a,b,c,1)}),"(",d,");",g,".call(this,a0);"))}0<Object.keys(b.state).length&&c(a.shared.current,".dirty=true;")}
	function oa(a,b,c,d){function e(){return!0}a.batchId="a1";wa(a,b);U(a,b,c,d.attributes,e);W(a,b,c,d.uniforms,e);S(a,b,b,c)}function za(a,b,c,d){function e(a){return a.contextDep&&g||a.propDep}function f(a){return!e(a)}wa(a,b);var g=c.contextDep,h=b.def(),k=b.def();a.shared.props=k;a.batchId=h;var m=a.scope(),l=a.scope();b(m.entry,"for(",h,"=0;",h,"<","a1",";++",h,"){",k,"=","a0","[",h,"];",l,"}",m.exit);c.needsContext&&ua(a,l,c.context);c.needsFramebuffer&&K(a,l,c.framebuffer);Q(a,l,c.state,e);c.profile&&
	e(c.profile)&&G(a,l,c,!1,!0);d?(U(a,m,c,d.attributes,f),U(a,l,c,d.attributes,e),W(a,m,c,d.uniforms,f),W(a,l,c,d.uniforms,e),S(a,m,l,c)):(b=a.global.def("{}"),d=c.shader.progVar.append(a,l),k=l.def(d,".id"),m=l.def(b,"[",k,"]"),l(a.shared.gl,".useProgram(",d,".program);","if(!",m,"){",m,"=",b,"[",k,"]=",a.link(function(b){return ca(oa,a,c,b,2)}),"(",d,");}",m,".call(this,a0[",h,"],",h,");"))}function ka(a,b){function c(a){return a.contextDep&&e||a.propDep}var d=a.proc("batch",2);a.batchId="0";wa(a,
	d);var e=!1,f=!0;Object.keys(b.context).forEach(function(a){e=e||b.context[a].propDep});e||(ua(a,d,b.context),f=!1);var g=b.framebuffer,h=!1;g?(g.propDep?e=h=!0:g.contextDep&&e&&(h=!0),h||K(a,d,g)):K(a,d,null);b.state.viewport&&b.state.viewport.propDep&&(e=!0);V(a,d,b);Q(a,d,b.state,function(a){return!c(a)});b.profile&&c(b.profile)||G(a,d,b,!1,"a1");b.contextDep=e;b.needsContext=f;b.needsFramebuffer=h;f=b.shader.progVar;if(f.contextDep&&e||f.propDep)za(a,d,b,null);else if(f=f.append(a,d),d(a.shared.gl,
	".useProgram(",f,".program);"),b.shader.program)za(a,d,b,b.shader.program);else{var g=a.global.def("{}"),h=d.def(f,".id"),k=d.def(g,"[",h,"]");d(a.cond(k).then(k,".call(this,a0,a1);")["else"](k,"=",g,"[",h,"]=",a.link(function(c){return ca(za,a,b,c,2)}),"(",f,");",k,".call(this,a0,a1);"))}0<Object.keys(b.state).length&&d(a.shared.current,".dirty=true;")}function ia(a,c){function d(b){var g=c.shader[b];g&&e.set(f.shader,"."+b,g.append(a,e))}var e=a.proc("scope",3);a.batchId="a2";var f=a.shared,g=f.current;
	ua(a,e,c.context);c.framebuffer&&c.framebuffer.append(a,e);vb(Object.keys(c.state)).forEach(function(b){var d=c.state[b].append(a,e);pa(d)?d.forEach(function(c,d){e.set(a.next[b],"["+d+"]",c)}):e.set(f.next,"."+b,d)});G(a,e,c,!0,!0);["elements","offset","count","instances","primitive"].forEach(function(b){var d=c.draw[b];d&&e.set(f.draw,"."+b,""+d.append(a,e))});Object.keys(c.uniforms).forEach(function(d){e.set(f.uniforms,"["+b.id(d)+"]",c.uniforms[d].append(a,e))});Object.keys(c.attributes).forEach(function(b){var d=
	c.attributes[b].append(a,e),f=a.scopeAttrib(b);Object.keys(new ya).forEach(function(a){e.set(f,"."+a,d[a])})});d("vert");d("frag");0<Object.keys(c.state).length&&(e(g,".dirty=true;"),e.exit(g,".dirty=true;"));e("a1(",a.shared.context,",a0,",a.batchId,");")}function ma(a){if("object"===typeof a&&!pa(a)){for(var b=Object.keys(a),c=0;c<b.length;++c)if(la.isDynamic(a[b[c]]))return!0;return!1}}function ja(a,b,c){function d(a,b){g.forEach(function(c){var d=e[c];la.isDynamic(d)&&(d=a.invoke(b,d),b(l,".",
	c,"=",d,";"))})}var e=b["static"][c];if(e&&ma(e)){var f=a.global,g=Object.keys(e),h=!1,k=!1,m=!1,l=a.global.def("{}");g.forEach(function(b){var c=e[b];if(la.isDynamic(c))"function"===typeof c&&(c=e[b]=la.unbox(c)),b=P(c,null),h=h||b.thisDep,m=m||b.propDep,k=k||b.contextDep;else{f(l,".",b,"=");switch(typeof c){case "number":f(c);break;case "string":f('"',c,'"');break;case "object":Array.isArray(c)&&f("[",c.join(),"]");break;default:f(a.link(c))}f(";")}});b.dynamic[c]=new la.DynamicVariable(4,{thisDep:h,
	contextDep:k,propDep:m,ref:l,append:d});delete b["static"][c]}}var ya=q.Record,X={add:32774,subtract:32778,"reverse subtract":32779};c.ext_blend_minmax&&(X.min=32775,X.max=32776);var ea=c.angle_instanced_arrays,ha=c.webgl_draw_buffers,ra={dirty:!0,profile:h.profile},Fa={},Ka=[],sa={},ta={};u("dither",3024);u("blend.enable",3042);v("blend.color","blendColor",[0,0,0,0]);v("blend.equation","blendEquationSeparate",[32774,32774]);v("blend.func","blendFuncSeparate",[1,0,1,0]);u("depth.enable",2929,!0);
	v("depth.func","depthFunc",513);v("depth.range","depthRange",[0,1]);v("depth.mask","depthMask",!0);v("colorMask","colorMask",[!0,!0,!0,!0]);u("cull.enable",2884);v("cull.face","cullFace",1029);v("frontFace","frontFace",2305);v("lineWidth","lineWidth",1);u("polygonOffset.enable",32823);v("polygonOffset.offset","polygonOffset",[0,0]);u("sample.alpha",32926);u("sample.enable",32928);v("sample.coverage","sampleCoverage",[1,!1]);u("stencil.enable",2960);v("stencil.mask","stencilMask",-1);v("stencil.func",
	"stencilFunc",[519,0,-1]);v("stencil.opFront","stencilOpSeparate",[1028,7680,7680,7680]);v("stencil.opBack","stencilOpSeparate",[1029,7680,7680,7680]);u("scissor.enable",3089);v("scissor.box","scissor",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);v("viewport","viewport",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);var na={gl:a,context:C,strings:b,next:Fa,current:ra,draw:m,elements:d,buffer:g,shader:t,attributes:q.state,uniforms:r,framebuffer:f,extensions:c,timer:k,isBufferArgs:Oa},aa={primTypes:Sa,
	compareFuncs:Xa,blendFuncs:Ga,blendEquations:X,stencilOps:Pa,glTypes:Ra,orientationType:wb};ha&&(aa.backBuffer=[1029],aa.drawBuffer=J(e.maxDrawbuffers,function(a){return 0===a?[0]:J(a,function(a){return 36064+a})}));var qa=0;return{next:Fa,current:ra,procs:function(){var a=N(),b=a.proc("poll"),c=a.proc("refresh"),d=a.block();b(d);c(d);var f=a.shared,g=f.gl,h=f.next,k=f.current;d(k,".dirty=false;");K(a,b);K(a,c,null,!0);var m;ea&&(m=a.link(ea));for(var l=0;l<e.maxAttributes;++l){var n=c.def(f.attributes,
	"[",l,"]"),q=a.cond(n,".buffer");q.then(g,".enableVertexAttribArray(",l,");",g,".bindBuffer(",34962,",",n,".buffer.buffer);",g,".vertexAttribPointer(",l,",",n,".size,",n,".type,",n,".normalized,",n,".stride,",n,".offset);")["else"](g,".disableVertexAttribArray(",l,");",g,".vertexAttrib4f(",l,",",n,".x,",n,".y,",n,".z,",n,".w);",n,".buffer=null;");c(q);ea&&c(m,".vertexAttribDivisorANGLE(",l,",",n,".divisor);")}Object.keys(sa).forEach(function(e){var f=sa[e],m=d.def(h,".",e),l=a.block();l("if(",m,"){",
	g,".enable(",f,")}else{",g,".disable(",f,")}",k,".",e,"=",m,";");c(l);b("if(",m,"!==",k,".",e,"){",l,"}")});Object.keys(ta).forEach(function(e){var f=ta[e],m=ra[e],l,n,q=a.block();q(g,".",f,"(");pa(m)?(f=m.length,l=a.global.def(h,".",e),n=a.global.def(k,".",e),q(J(f,function(a){return l+"["+a+"]"}),");",J(f,function(a){return n+"["+a+"]="+l+"["+a+"];"}).join("")),b("if(",J(f,function(a){return l+"["+a+"]!=="+n+"["+a+"]"}).join("||"),"){",q,"}")):(l=d.def(h,".",e),n=d.def(k,".",e),q(l,");",k,".",e,
	"=",l,";"),b("if(",l,"!==",n,"){",q,"}"));c(q)});return a.compile()}(),compile:function(a,b,c,d,e){var f=N();f.stats=f.link(e);Object.keys(b["static"]).forEach(function(a){ja(f,b,a)});Ub.forEach(function(b){ja(f,a,b)});c=A(a,b,c,d,f);da(f,c);ia(f,c);ka(f,c);return f.compile()}}}function yb(a,b){for(var c=0;c<a.length;++c)if(a[c]===b)return c;return-1}var E=function(a,b){for(var c=Object.keys(b),e=0;e<c.length;++e)a[c[e]]=b[c[e]];return a},Ab=0,la={DynamicVariable:aa,define:function(a,b){return new aa(a,
	Za(b+""))},isDynamic:function(a){return"function"===typeof a&&!a._reglType||a instanceof aa},unbox:function(a,b){return"function"===typeof a?new aa(0,a):a},accessor:Za},Ya={next:"function"===typeof requestAnimationFrame?function(a){return requestAnimationFrame(a)}:function(a){return setTimeout(a,16)},cancel:"function"===typeof cancelAnimationFrame?function(a){return cancelAnimationFrame(a)}:clearTimeout},zb="undefined"!==typeof performance&&performance.now?function(){return performance.now()}:function(){return+new Date},
	x=cb();x.zero=cb();var Vb=function(a,b){var c=1;b.ext_texture_filter_anisotropic&&(c=a.getParameter(34047));var e=1,g=1;b.webgl_draw_buffers&&(e=a.getParameter(34852),g=a.getParameter(36063));var d=!!b.oes_texture_float;if(d){d=a.createTexture();a.bindTexture(3553,d);a.texImage2D(3553,0,6408,1,1,0,6408,5126,null);var n=a.createFramebuffer();a.bindFramebuffer(36160,n);a.framebufferTexture2D(36160,36064,3553,d,0);a.bindTexture(3553,null);if(36053!==a.checkFramebufferStatus(36160))d=!1;else{a.viewport(0,
	0,1,1);a.clearColor(1,0,0,1);a.clear(16384);var f=x.allocType(5126,4);a.readPixels(0,0,1,1,6408,5126,f);a.getError()?d=!1:(a.deleteFramebuffer(n),a.deleteTexture(d),d=1===f[0]);x.freeType(f)}}f=!0;"undefined"!==typeof navigator&&(/MSIE/.test(navigator.userAgent)||/Trident\//.test(navigator.appVersion)||/Edge/.test(navigator.userAgent))||(f=a.createTexture(),n=x.allocType(5121,36),a.activeTexture(33984),a.bindTexture(34067,f),a.texImage2D(34069,0,6408,3,3,0,6408,5121,n),x.freeType(n),a.bindTexture(34067,
	null),a.deleteTexture(f),f=!a.getError());return{colorBits:[a.getParameter(3410),a.getParameter(3411),a.getParameter(3412),a.getParameter(3413)],depthBits:a.getParameter(3414),stencilBits:a.getParameter(3415),subpixelBits:a.getParameter(3408),extensions:Object.keys(b).filter(function(a){return!!b[a]}),maxAnisotropic:c,maxDrawbuffers:e,maxColorAttachments:g,pointSizeDims:a.getParameter(33901),lineWidthDims:a.getParameter(33902),maxViewportDims:a.getParameter(3386),maxCombinedTextureUnits:a.getParameter(35661),
	maxCubeMapSize:a.getParameter(34076),maxRenderbufferSize:a.getParameter(34024),maxTextureUnits:a.getParameter(34930),maxTextureSize:a.getParameter(3379),maxAttributes:a.getParameter(34921),maxVertexUniforms:a.getParameter(36347),maxVertexTextureUnits:a.getParameter(35660),maxVaryingVectors:a.getParameter(36348),maxFragmentUniforms:a.getParameter(36349),glsl:a.getParameter(35724),renderer:a.getParameter(7937),vendor:a.getParameter(7936),version:a.getParameter(7938),readFloat:d,npotTextureCube:f}},
	M=function(a){return a instanceof Uint8Array||a instanceof Uint16Array||a instanceof Uint32Array||a instanceof Int8Array||a instanceof Int16Array||a instanceof Int32Array||a instanceof Float32Array||a instanceof Float64Array||a instanceof Uint8ClampedArray},S=function(a){return Object.keys(a).map(function(b){return a[b]})},Ma={shape:function(a){for(var b=[];a.length;a=a[0])b.push(a.length);return b},flatten:function(a,b,c,e){var g=1;if(b.length)for(var d=0;d<b.length;++d)g*=b[d];else g=0;c=e||x.allocType(c,
	g);switch(b.length){case 0:break;case 1:e=b[0];for(b=0;b<e;++b)c[b]=a[b];break;case 2:e=b[0];b=b[1];for(d=g=0;d<e;++d)for(var n=a[d],f=0;f<b;++f)c[g++]=n[f];break;case 3:db(a,b[0],b[1],b[2],c,0);break;default:eb(a,b,0,c,0)}return c}},Ia={"[object Int8Array]":5120,"[object Int16Array]":5122,"[object Int32Array]":5124,"[object Uint8Array]":5121,"[object Uint8ClampedArray]":5121,"[object Uint16Array]":5123,"[object Uint32Array]":5125,"[object Float32Array]":5126,"[object Float64Array]":5121,"[object ArrayBuffer]":5121},
	Ra={int8:5120,int16:5122,int32:5124,uint8:5121,uint16:5123,uint32:5125,"float":5126,float32:5126},jb={dynamic:35048,stream:35040,"static":35044},Qa=Ma.flatten,hb=Ma.shape,ja=[];ja[5120]=1;ja[5122]=2;ja[5124]=4;ja[5121]=1;ja[5123]=2;ja[5125]=4;ja[5126]=4;var Sa={points:0,point:0,lines:1,line:1,triangles:4,triangle:4,"line loop":2,"line strip":3,"triangle strip":5,"triangle fan":6},lb=new Float32Array(1),Ib=new Uint32Array(lb.buffer),Mb=[9984,9986,9985,9987],La=[0,6409,6410,6407,6408],L={};L[6409]=
	L[6406]=L[6402]=1;L[34041]=L[6410]=2;L[6407]=L[35904]=3;L[6408]=L[35906]=4;var Ua=Ea("HTMLCanvasElement"),pb=Ea("CanvasRenderingContext2D"),qb=Ea("ImageBitmap"),rb=Ea("HTMLImageElement"),sb=Ea("HTMLVideoElement"),Jb=Object.keys(Ia).concat([Ua,pb,qb,rb,sb]),qa=[];qa[5121]=1;qa[5126]=4;qa[36193]=2;qa[5123]=2;qa[5125]=4;var y=[];y[32854]=2;y[32855]=2;y[36194]=2;y[34041]=4;y[33776]=.5;y[33777]=.5;y[33778]=1;y[33779]=1;y[35986]=.5;y[35987]=1;y[34798]=1;y[35840]=.5;y[35841]=.25;y[35842]=.5;y[35843]=.25;
	y[36196]=.5;var Q=[];Q[32854]=2;Q[32855]=2;Q[36194]=2;Q[33189]=2;Q[36168]=1;Q[34041]=4;Q[35907]=4;Q[34836]=16;Q[34842]=8;Q[34843]=6;var Wb=function(a,b,c,e,g){function d(a){this.id=q++;this.refCount=1;this.renderbuffer=a;this.format=32854;this.height=this.width=0;g.profile&&(this.stats={size:0})}function n(b){var c=b.renderbuffer;a.bindRenderbuffer(36161,null);a.deleteRenderbuffer(c);b.renderbuffer=null;b.refCount=0;delete t[b.id];e.renderbufferCount--}var f={rgba4:32854,rgb565:36194,"rgb5 a1":32855,
	depth:33189,stencil:36168,"depth stencil":34041};b.ext_srgb&&(f.srgba=35907);b.ext_color_buffer_half_float&&(f.rgba16f=34842,f.rgb16f=34843);b.webgl_color_buffer_float&&(f.rgba32f=34836);var r=[];Object.keys(f).forEach(function(a){r[f[a]]=a});var q=0,t={};d.prototype.decRef=function(){0>=--this.refCount&&n(this)};g.profile&&(e.getTotalRenderbufferSize=function(){var a=0;Object.keys(t).forEach(function(b){a+=t[b].stats.size});return a});return{create:function(b,c){function k(b,c){var d=0,e=0,m=32854;
	"object"===typeof b&&b?("shape"in b?(e=b.shape,d=e[0]|0,e=e[1]|0):("radius"in b&&(d=e=b.radius|0),"width"in b&&(d=b.width|0),"height"in b&&(e=b.height|0)),"format"in b&&(m=f[b.format])):"number"===typeof b?(d=b|0,e="number"===typeof c?c|0:d):b||(d=e=1);if(d!==h.width||e!==h.height||m!==h.format)return k.width=h.width=d,k.height=h.height=e,h.format=m,a.bindRenderbuffer(36161,h.renderbuffer),a.renderbufferStorage(36161,m,d,e),g.profile&&(h.stats.size=Q[h.format]*h.width*h.height),k.format=r[h.format],
	k}var h=new d(a.createRenderbuffer());t[h.id]=h;e.renderbufferCount++;k(b,c);k.resize=function(b,c){var d=b|0,e=c|0||d;if(d===h.width&&e===h.height)return k;k.width=h.width=d;k.height=h.height=e;a.bindRenderbuffer(36161,h.renderbuffer);a.renderbufferStorage(36161,h.format,d,e);g.profile&&(h.stats.size=Q[h.format]*h.width*h.height);return k};k._reglType="renderbuffer";k._renderbuffer=h;g.profile&&(k.stats=h.stats);k.destroy=function(){h.decRef()};return k},clear:function(){S(t).forEach(n)},restore:function(){S(t).forEach(function(b){b.renderbuffer=
	a.createRenderbuffer();a.bindRenderbuffer(36161,b.renderbuffer);a.renderbufferStorage(36161,b.format,b.width,b.height)});a.bindRenderbuffer(36161,null)}}},Wa=[];Wa[6408]=4;Wa[6407]=3;var Na=[];Na[5121]=1;Na[5126]=4;Na[36193]=2;var Da=["x","y","z","w"],Ub="blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "),Ga={0:0,1:1,zero:0,one:1,"src color":768,"one minus src color":769,"src alpha":770,"one minus src alpha":771,
	"dst color":774,"one minus dst color":775,"dst alpha":772,"one minus dst alpha":773,"constant color":32769,"one minus constant color":32770,"constant alpha":32771,"one minus constant alpha":32772,"src alpha saturate":776},Xa={never:512,less:513,"<":513,equal:514,"=":514,"==":514,"===":514,lequal:515,"<=":515,greater:516,">":516,notequal:517,"!=":517,"!==":517,gequal:518,">=":518,always:519},Pa={0:0,zero:0,keep:7680,replace:7681,increment:7682,decrement:7683,"increment wrap":34055,"decrement wrap":34056,
	invert:5386},wb={cw:2304,ccw:2305},xb=new Z(!1,!1,!1,function(){}),Xb=function(a,b){function c(){this.endQueryIndex=this.startQueryIndex=-1;this.sum=0;this.stats=null}function e(a,b,d){var e=n.pop()||new c;e.startQueryIndex=a;e.endQueryIndex=b;e.sum=0;e.stats=d;f.push(e)}if(!b.ext_disjoint_timer_query)return null;var g=[],d=[],n=[],f=[],r=[],q=[];return{beginQuery:function(a){var c=g.pop()||b.ext_disjoint_timer_query.createQueryEXT();b.ext_disjoint_timer_query.beginQueryEXT(35007,c);d.push(c);e(d.length-
	1,d.length,a)},endQuery:function(){b.ext_disjoint_timer_query.endQueryEXT(35007)},pushScopeStats:e,update:function(){var a,c;a=d.length;if(0!==a){q.length=Math.max(q.length,a+1);r.length=Math.max(r.length,a+1);r[0]=0;var e=q[0]=0;for(c=a=0;c<d.length;++c){var k=d[c];b.ext_disjoint_timer_query.getQueryObjectEXT(k,34919)?(e+=b.ext_disjoint_timer_query.getQueryObjectEXT(k,34918),g.push(k)):d[a++]=k;r[c+1]=e;q[c+1]=a}d.length=a;for(c=a=0;c<f.length;++c){var e=f[c],h=e.startQueryIndex,k=e.endQueryIndex;
	e.sum+=r[k]-r[h];h=q[h];k=q[k];k===h?(e.stats.gpuTime+=e.sum/1E6,n.push(e)):(e.startQueryIndex=h,e.endQueryIndex=k,f[a++]=e)}f.length=a}},getNumPendingQueries:function(){return d.length},clear:function(){g.push.apply(g,d);for(var a=0;a<g.length;a++)b.ext_disjoint_timer_query.deleteQueryEXT(g[a]);d.length=0;g.length=0},restore:function(){d.length=0;g.length=0}}};return function(a){function b(){if(0===G.length)B&&B.update(),ca=null;else{ca=Ya.next(b);t();for(var a=G.length-1;0<=a;--a){var c=G[a];c&&
	c(O,null,0)}k.flush();B&&B.update()}}function c(){!ca&&0<G.length&&(ca=Ya.next(b))}function e(){ca&&(Ya.cancel(b),ca=null)}function g(a){a.preventDefault();e();U.forEach(function(a){a()})}function d(a){k.getError();l.restore();Q.restore();F.restore();A.restore();M.restore();K.restore();B&&B.restore();V.procs.refresh();c();W.forEach(function(a){a()})}function n(a){function b(a){var c={},d={};Object.keys(a).forEach(function(b){var e=a[b];la.isDynamic(e)?d[b]=la.unbox(e,b):c[b]=e});return{dynamic:d,
	"static":c}}function c(a){for(;m.length<a;)m.push(null);return m}var d=b(a.context||{}),e=b(a.uniforms||{}),f=b(a.attributes||{}),g=b(function(a){function b(a){if(a in c){var d=c[a];delete c[a];Object.keys(d).forEach(function(b){c[a+"."+b]=d[b]})}}var c=E({},a);delete c.uniforms;delete c.attributes;delete c.context;"stencil"in c&&c.stencil.op&&(c.stencil.opBack=c.stencil.opFront=c.stencil.op,delete c.stencil.op);b("blend");b("depth");b("cull");b("stencil");b("polygonOffset");b("scissor");b("sample");
	return c}(a));a={gpuTime:0,cpuTime:0,count:0};var d=V.compile(g,f,e,d,a),h=d.draw,k=d.batch,l=d.scope,m=[];return E(function(a,b){var d;if("function"===typeof a)return l.call(this,null,a,0);if("function"===typeof b)if("number"===typeof a)for(d=0;d<a;++d)l.call(this,null,b,d);else if(Array.isArray(a))for(d=0;d<a.length;++d)l.call(this,a[d],b,d);else return l.call(this,a,b,0);else if("number"===typeof a){if(0<a)return k.call(this,c(a|0),a|0)}else if(Array.isArray(a)){if(a.length)return k.call(this,
	a,a.length)}else return h.call(this,a)},{stats:a})}function f(a,b){var c=0;V.procs.poll();var d=b.color;d&&(k.clearColor(+d[0]||0,+d[1]||0,+d[2]||0,+d[3]||0),c|=16384);"depth"in b&&(k.clearDepth(+b.depth),c|=256);"stencil"in b&&(k.clearStencil(b.stencil|0),c|=1024);k.clear(c)}function r(a){G.push(a);c();return{cancel:function(){function b(){var a=yb(G,b);G[a]=G[G.length-1];--G.length;0>=G.length&&e()}var c=yb(G,a);G[c]=b}}}function q(){var a=S.viewport,b=S.scissor_box;a[0]=a[1]=b[0]=b[1]=0;O.viewportWidth=
	O.framebufferWidth=O.drawingBufferWidth=a[2]=b[2]=k.drawingBufferWidth;O.viewportHeight=O.framebufferHeight=O.drawingBufferHeight=a[3]=b[3]=k.drawingBufferHeight}function t(){O.tick+=1;O.time=y();q();V.procs.poll()}function m(){q();V.procs.refresh();B&&B.update()}function y(){return(zb()-D)/1E3}a=Eb(a);if(!a)return null;var k=a.gl,h=k.getContextAttributes();k.isContextLost();var l=Fb(k,a);if(!l)return null;var u=Bb(),v={bufferCount:0,elementsCount:0,framebufferCount:0,shaderCount:0,textureCount:0,
	cubeCount:0,renderbufferCount:0,maxTextureUnits:0},x=l.extensions,B=Xb(k,x),D=zb(),J=k.drawingBufferWidth,P=k.drawingBufferHeight,O={tick:0,time:0,viewportWidth:J,viewportHeight:P,framebufferWidth:J,framebufferHeight:P,drawingBufferWidth:J,drawingBufferHeight:P,pixelRatio:a.pixelRatio},R=Vb(k,x),J=Pb(k,x,R,u),F=Gb(k,v,a,J),T=Hb(k,x,F,v),Q=Qb(k,u,v,a),A=Kb(k,x,R,function(){V.procs.poll()},O,v,a),M=Wb(k,x,R,v,a),K=Ob(k,x,R,A,M,v),V=Tb(k,u,x,R,F,T,A,K,{},J,Q,{elements:null,primitive:4,count:-1,offset:0,
	instances:-1},O,B,a),u=Rb(k,K,V.procs.poll,O,h,x,R),S=V.next,L=k.canvas,G=[],U=[],W=[],Z=[a.onDestroy],ca=null;L&&(L.addEventListener("webglcontextlost",g,!1),L.addEventListener("webglcontextrestored",d,!1));var aa=K.setFBO=n({framebuffer:la.define.call(null,1,"framebuffer")});m();h=E(n,{clear:function(a){if("framebuffer"in a)if(a.framebuffer&&"framebufferCube"===a.framebuffer_reglType)for(var b=0;6>b;++b)aa(E({framebuffer:a.framebuffer.faces[b]},a),f);else aa(a,f);else f(null,a)},prop:la.define.bind(null,
	1),context:la.define.bind(null,2),"this":la.define.bind(null,3),draw:n({}),buffer:function(a){return F.create(a,34962,!1,!1)},elements:function(a){return T.create(a,!1)},texture:A.create2D,cube:A.createCube,renderbuffer:M.create,framebuffer:K.create,framebufferCube:K.createCube,attributes:h,frame:r,on:function(a,b){var c;switch(a){case "frame":return r(b);case "lost":c=U;break;case "restore":c=W;break;case "destroy":c=Z}c.push(b);return{cancel:function(){for(var a=0;a<c.length;++a)if(c[a]===b){c[a]=
	c[c.length-1];c.pop();break}}}},limits:R,hasExtension:function(a){return 0<=R.extensions.indexOf(a.toLowerCase())},read:u,destroy:function(){G.length=0;e();L&&(L.removeEventListener("webglcontextlost",g),L.removeEventListener("webglcontextrestored",d));Q.clear();K.clear();M.clear();A.clear();T.clear();F.clear();B&&B.clear();Z.forEach(function(a){a()})},_gl:k,_refresh:m,poll:function(){t();B&&B.update()},now:y,stats:v});a.onDone(null,h);return h}});
	
	},{}],501:[function(_dereq_,module,exports){
	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}
	
	},{}],502:[function(_dereq_,module,exports){
	(function (global){
	module.exports =
	  global.performance &&
	  global.performance.now ? function now() {
	    return performance.now()
	  } : Date.now || function now() {
	    return +new Date
	  }
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],503:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = compressExpansion
	
	function compressExpansion(e) {
	  var m = e.length
	  var Q = e[e.length-1]
	  var bottom = m
	  for(var i=m-2; i>=0; --i) {
	    var a = Q
	    var b = e[i]
	    Q = a + b
	    var bv = Q - a
	    var q = b - bv
	    if(q) {
	      e[--bottom] = Q
	      Q = q
	    }
	  }
	  var top = 0
	  for(var i=bottom; i<m; ++i) {
	    var a = e[i]
	    var b = Q
	    Q = a + b
	    var bv = Q - a
	    var q = b - bv
	    if(q) {
	      e[top++] = q
	    }
	  }
	  e[top++] = Q
	  e.length = top
	  return e
	}
	},{}],504:[function(_dereq_,module,exports){
	"use strict"
	
	var twoProduct = _dereq_("two-product")
	var robustSum = _dereq_("robust-sum")
	var robustScale = _dereq_("robust-scale")
	var compress = _dereq_("robust-compress")
	
	var NUM_EXPANDED = 6
	
	function cofactor(m, c) {
	  var result = new Array(m.length-1)
	  for(var i=1; i<m.length; ++i) {
	    var r = result[i-1] = new Array(m.length-1)
	    for(var j=0,k=0; j<m.length; ++j) {
	      if(j === c) {
	        continue
	      }
	      r[k++] = m[i][j]
	    }
	  }
	  return result
	}
	
	function matrix(n) {
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = new Array(n)
	    for(var j=0; j<n; ++j) {
	      result[i][j] = ["m[", i, "][", j, "]"].join("")
	    }
	  }
	  return result
	}
	
	function sign(n) {
	  if(n & 1) {
	    return "-"
	  }
	  return ""
	}
	
	function generateSum(expr) {
	  if(expr.length === 1) {
	    return expr[0]
	  } else if(expr.length === 2) {
	    return ["sum(", expr[0], ",", expr[1], ")"].join("")
	  } else {
	    var m = expr.length>>1
	    return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
	  }
	}
	
	function determinant(m) {
	  if(m.length === 2) {
	    return ["sum(prod(", m[0][0], ",", m[1][1], "),prod(-", m[0][1], ",", m[1][0], "))"].join("")
	  } else {
	    var expr = []
	    for(var i=0; i<m.length; ++i) {
	      expr.push(["scale(", determinant(cofactor(m, i)), ",", sign(i), m[0][i], ")"].join(""))
	    }
	    return generateSum(expr)
	  }
	}
	
	function compileDeterminant(n) {
	  var proc = new Function("sum", "scale", "prod", "compress", [
	    "function robustDeterminant",n, "(m){return compress(", 
	      determinant(matrix(n)),
	    ")};return robustDeterminant", n].join(""))
	  return proc(robustSum, robustScale, twoProduct, compress)
	}
	
	var CACHE = [
	  function robustDeterminant0() { return [0] },
	  function robustDeterminant1(m) { return [m[0][0]] }
	]
	
	function generateDispatch() {
	  while(CACHE.length < NUM_EXPANDED) {
	    CACHE.push(compileDeterminant(CACHE.length))
	  }
	  var procArgs = []
	  var code = ["function robustDeterminant(m){switch(m.length){"]
	  for(var i=0; i<NUM_EXPANDED; ++i) {
	    procArgs.push("det" + i)
	    code.push("case ", i, ":return det", i, "(m);")
	  }
	  code.push("}\
	var det=CACHE[m.length];\
	if(!det)\
	det=CACHE[m.length]=gen(m.length);\
	return det(m);\
	}\
	return robustDeterminant")
	  procArgs.push("CACHE", "gen", code.join(""))
	  var proc = Function.apply(undefined, procArgs)
	  module.exports = proc.apply(undefined, CACHE.concat([CACHE, compileDeterminant]))
	  for(var i=0; i<CACHE.length; ++i) {
	    module.exports[i] = CACHE[i]
	  }
	}
	
	generateDispatch()
	},{"robust-compress":503,"robust-scale":510,"robust-sum":513,"two-product":541}],505:[function(_dereq_,module,exports){
	"use strict"
	
	var twoProduct = _dereq_("two-product")
	var robustSum = _dereq_("robust-sum")
	
	module.exports = robustDotProduct
	
	function robustDotProduct(a, b) {
	  var r = twoProduct(a[0], b[0])
	  for(var i=1; i<a.length; ++i) {
	    r = robustSum(r, twoProduct(a[i], b[i]))
	  }
	  return r
	}
	},{"robust-sum":513,"two-product":541}],506:[function(_dereq_,module,exports){
	"use strict"
	
	var twoProduct = _dereq_("two-product")
	var robustSum = _dereq_("robust-sum")
	var robustDiff = _dereq_("robust-subtract")
	var robustScale = _dereq_("robust-scale")
	
	var NUM_EXPAND = 6
	
	function cofactor(m, c) {
	  var result = new Array(m.length-1)
	  for(var i=1; i<m.length; ++i) {
	    var r = result[i-1] = new Array(m.length-1)
	    for(var j=0,k=0; j<m.length; ++j) {
	      if(j === c) {
	        continue
	      }
	      r[k++] = m[i][j]
	    }
	  }
	  return result
	}
	
	function matrix(n) {
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = new Array(n)
	    for(var j=0; j<n; ++j) {
	      result[i][j] = ["m", j, "[", (n-i-2), "]"].join("")
	    }
	  }
	  return result
	}
	
	function generateSum(expr) {
	  if(expr.length === 1) {
	    return expr[0]
	  } else if(expr.length === 2) {
	    return ["sum(", expr[0], ",", expr[1], ")"].join("")
	  } else {
	    var m = expr.length>>1
	    return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
	  }
	}
	
	function makeProduct(a, b) {
	  if(a.charAt(0) === "m") {
	    if(b.charAt(0) === "w") {
	      var toks = a.split("[")
	      return ["w", b.substr(1), "m", toks[0].substr(1)].join("")
	    } else {
	      return ["prod(", a, ",", b, ")"].join("")
	    }
	  } else {
	    return makeProduct(b, a)
	  }
	}
	
	function sign(s) {
	  if(s & 1 !== 0) {
	    return "-"
	  }
	  return ""
	}
	
	function determinant(m) {
	  if(m.length === 2) {
	    return [["diff(", makeProduct(m[0][0], m[1][1]), ",", makeProduct(m[1][0], m[0][1]), ")"].join("")]
	  } else {
	    var expr = []
	    for(var i=0; i<m.length; ++i) {
	      expr.push(["scale(", generateSum(determinant(cofactor(m, i))), ",", sign(i), m[0][i], ")"].join(""))
	    }
	    return expr
	  }
	}
	
	function makeSquare(d, n) {
	  var terms = []
	  for(var i=0; i<n-2; ++i) {
	    terms.push(["prod(m", d, "[", i, "],m", d, "[", i, "])"].join(""))
	  }
	  return generateSum(terms)
	}
	
	function orientation(n) {
	  var pos = []
	  var neg = []
	  var m = matrix(n)
	  for(var i=0; i<n; ++i) {
	    m[0][i] = "1"
	    m[n-1][i] = "w"+i
	  } 
	  for(var i=0; i<n; ++i) {
	    if((i&1)===0) {
	      pos.push.apply(pos,determinant(cofactor(m, i)))
	    } else {
	      neg.push.apply(neg,determinant(cofactor(m, i)))
	    }
	  }
	  var posExpr = generateSum(pos)
	  var negExpr = generateSum(neg)
	  var funcName = "exactInSphere" + n
	  var funcArgs = []
	  for(var i=0; i<n; ++i) {
	    funcArgs.push("m" + i)
	  }
	  var code = ["function ", funcName, "(", funcArgs.join(), "){"]
	  for(var i=0; i<n; ++i) {
	    code.push("var w",i,"=",makeSquare(i,n),";")
	    for(var j=0; j<n; ++j) {
	      if(j !== i) {
	        code.push("var w",i,"m",j,"=scale(w",i,",m",j,"[0]);")
	      }
	    }
	  }
	  code.push("var p=", posExpr, ",n=", negExpr, ",d=diff(p,n);return d[d.length-1];}return ", funcName)
	  var proc = new Function("sum", "diff", "prod", "scale", code.join(""))
	  return proc(robustSum, robustDiff, twoProduct, robustScale)
	}
	
	function inSphere0() { return 0 }
	function inSphere1() { return 0 }
	function inSphere2() { return 0 }
	
	var CACHED = [
	  inSphere0,
	  inSphere1,
	  inSphere2
	]
	
	function slowInSphere(args) {
	  var proc = CACHED[args.length]
	  if(!proc) {
	    proc = CACHED[args.length] = orientation(args.length)
	  }
	  return proc.apply(undefined, args)
	}
	
	function generateInSphereTest() {
	  while(CACHED.length <= NUM_EXPAND) {
	    CACHED.push(orientation(CACHED.length))
	  }
	  var args = []
	  var procArgs = ["slow"]
	  for(var i=0; i<=NUM_EXPAND; ++i) {
	    args.push("a" + i)
	    procArgs.push("o" + i)
	  }
	  var code = [
	    "function testInSphere(", args.join(), "){switch(arguments.length){case 0:case 1:return 0;"
	  ]
	  for(var i=2; i<=NUM_EXPAND; ++i) {
	    code.push("case ", i, ":return o", i, "(", args.slice(0, i).join(), ");")
	  }
	  code.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return testInSphere")
	  procArgs.push(code.join(""))
	
	  var proc = Function.apply(undefined, procArgs)
	
	  module.exports = proc.apply(undefined, [slowInSphere].concat(CACHED))
	  for(var i=0; i<=NUM_EXPAND; ++i) {
	    module.exports[i] = CACHED[i]
	  }
	}
	
	generateInSphereTest()
	},{"robust-scale":510,"robust-subtract":512,"robust-sum":513,"two-product":541}],507:[function(_dereq_,module,exports){
	"use strict"
	
	var determinant = _dereq_("robust-determinant")
	
	var NUM_EXPAND = 6
	
	function generateSolver(n) {
	  var funcName = "robustLinearSolve" + n + "d"
	  var code = ["function ", funcName, "(A,b){return ["]
	  for(var i=0; i<n; ++i) {
	    code.push("det([")
	    for(var j=0; j<n; ++j) {
	      if(j > 0) {
	        code.push(",")
	      }
	      code.push("[")
	      for(var k=0; k<n; ++k) {
	        if(k > 0) {
	          code.push(",")
	        }
	        if(k === i) {
	          code.push("+b[", j, "]")
	        } else {
	          code.push("+A[", j, "][", k, "]")
	        }
	      }
	      code.push("]")
	    }
	    code.push("]),")
	  }
	  code.push("det(A)]}return ", funcName)
	  var proc = new Function("det", code.join(""))
	  if(n < 6) {
	    return proc(determinant[n])
	  }
	  return proc(determinant)
	}
	
	function robustLinearSolve0d() {
	  return [ 0 ]
	}
	
	function robustLinearSolve1d(A, b) {
	  return [ [ b[0] ], [ A[0][0] ] ]
	}
	
	var CACHE = [
	  robustLinearSolve0d,
	  robustLinearSolve1d
	]
	
	function generateDispatch() {
	  while(CACHE.length < NUM_EXPAND) {
	    CACHE.push(generateSolver(CACHE.length))
	  }
	  var procArgs = []
	  var code = ["function dispatchLinearSolve(A,b){switch(A.length){"]
	  for(var i=0; i<NUM_EXPAND; ++i) {
	    procArgs.push("s" + i)
	    code.push("case ", i, ":return s", i, "(A,b);")
	  }
	  code.push("}var s=CACHE[A.length];if(!s)s=CACHE[A.length]=g(A.length);return s(A,b)}return dispatchLinearSolve")
	  procArgs.push("CACHE", "g", code.join(""))
	  var proc = Function.apply(undefined, procArgs)
	  module.exports = proc.apply(undefined, CACHE.concat([CACHE, generateSolver]))
	  for(var i=0; i<NUM_EXPAND; ++i) {
	    module.exports[i] = CACHE[i]
	  }
	}
	
	generateDispatch()
	},{"robust-determinant":504}],508:[function(_dereq_,module,exports){
	"use strict"
	
	var twoProduct = _dereq_("two-product")
	var robustSum = _dereq_("robust-sum")
	var robustScale = _dereq_("robust-scale")
	var robustSubtract = _dereq_("robust-subtract")
	
	var NUM_EXPAND = 5
	
	var EPSILON     = 1.1102230246251565e-16
	var ERRBOUND3   = (3.0 + 16.0 * EPSILON) * EPSILON
	var ERRBOUND4   = (7.0 + 56.0 * EPSILON) * EPSILON
	
	function cofactor(m, c) {
	  var result = new Array(m.length-1)
	  for(var i=1; i<m.length; ++i) {
	    var r = result[i-1] = new Array(m.length-1)
	    for(var j=0,k=0; j<m.length; ++j) {
	      if(j === c) {
	        continue
	      }
	      r[k++] = m[i][j]
	    }
	  }
	  return result
	}
	
	function matrix(n) {
	  var result = new Array(n)
	  for(var i=0; i<n; ++i) {
	    result[i] = new Array(n)
	    for(var j=0; j<n; ++j) {
	      result[i][j] = ["m", j, "[", (n-i-1), "]"].join("")
	    }
	  }
	  return result
	}
	
	function sign(n) {
	  if(n & 1) {
	    return "-"
	  }
	  return ""
	}
	
	function generateSum(expr) {
	  if(expr.length === 1) {
	    return expr[0]
	  } else if(expr.length === 2) {
	    return ["sum(", expr[0], ",", expr[1], ")"].join("")
	  } else {
	    var m = expr.length>>1
	    return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
	  }
	}
	
	function determinant(m) {
	  if(m.length === 2) {
	    return [["sum(prod(", m[0][0], ",", m[1][1], "),prod(-", m[0][1], ",", m[1][0], "))"].join("")]
	  } else {
	    var expr = []
	    for(var i=0; i<m.length; ++i) {
	      expr.push(["scale(", generateSum(determinant(cofactor(m, i))), ",", sign(i), m[0][i], ")"].join(""))
	    }
	    return expr
	  }
	}
	
	function orientation(n) {
	  var pos = []
	  var neg = []
	  var m = matrix(n)
	  var args = []
	  for(var i=0; i<n; ++i) {
	    if((i&1)===0) {
	      pos.push.apply(pos, determinant(cofactor(m, i)))
	    } else {
	      neg.push.apply(neg, determinant(cofactor(m, i)))
	    }
	    args.push("m" + i)
	  }
	  var posExpr = generateSum(pos)
	  var negExpr = generateSum(neg)
	  var funcName = "orientation" + n + "Exact"
	  var code = ["function ", funcName, "(", args.join(), "){var p=", posExpr, ",n=", negExpr, ",d=sub(p,n);\
	return d[d.length-1];};return ", funcName].join("")
	  var proc = new Function("sum", "prod", "scale", "sub", code)
	  return proc(robustSum, twoProduct, robustScale, robustSubtract)
	}
	
	var orientation3Exact = orientation(3)
	var orientation4Exact = orientation(4)
	
	var CACHED = [
	  function orientation0() { return 0 },
	  function orientation1() { return 0 },
	  function orientation2(a, b) { 
	    return b[0] - a[0]
	  },
	  function orientation3(a, b, c) {
	    var l = (a[1] - c[1]) * (b[0] - c[0])
	    var r = (a[0] - c[0]) * (b[1] - c[1])
	    var det = l - r
	    var s
	    if(l > 0) {
	      if(r <= 0) {
	        return det
	      } else {
	        s = l + r
	      }
	    } else if(l < 0) {
	      if(r >= 0) {
	        return det
	      } else {
	        s = -(l + r)
	      }
	    } else {
	      return det
	    }
	    var tol = ERRBOUND3 * s
	    if(det >= tol || det <= -tol) {
	      return det
	    }
	    return orientation3Exact(a, b, c)
	  },
	  function orientation4(a,b,c,d) {
	    var adx = a[0] - d[0]
	    var bdx = b[0] - d[0]
	    var cdx = c[0] - d[0]
	    var ady = a[1] - d[1]
	    var bdy = b[1] - d[1]
	    var cdy = c[1] - d[1]
	    var adz = a[2] - d[2]
	    var bdz = b[2] - d[2]
	    var cdz = c[2] - d[2]
	    var bdxcdy = bdx * cdy
	    var cdxbdy = cdx * bdy
	    var cdxady = cdx * ady
	    var adxcdy = adx * cdy
	    var adxbdy = adx * bdy
	    var bdxady = bdx * ady
	    var det = adz * (bdxcdy - cdxbdy) 
	            + bdz * (cdxady - adxcdy)
	            + cdz * (adxbdy - bdxady)
	    var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz)
	                  + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz)
	                  + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz)
	    var tol = ERRBOUND4 * permanent
	    if ((det > tol) || (-det > tol)) {
	      return det
	    }
	    return orientation4Exact(a,b,c,d)
	  }
	]
	
	function slowOrient(args) {
	  var proc = CACHED[args.length]
	  if(!proc) {
	    proc = CACHED[args.length] = orientation(args.length)
	  }
	  return proc.apply(undefined, args)
	}
	
	function generateOrientationProc() {
	  while(CACHED.length <= NUM_EXPAND) {
	    CACHED.push(orientation(CACHED.length))
	  }
	  var args = []
	  var procArgs = ["slow"]
	  for(var i=0; i<=NUM_EXPAND; ++i) {
	    args.push("a" + i)
	    procArgs.push("o" + i)
	  }
	  var code = [
	    "function getOrientation(", args.join(), "){switch(arguments.length){case 0:case 1:return 0;"
	  ]
	  for(var i=2; i<=NUM_EXPAND; ++i) {
	    code.push("case ", i, ":return o", i, "(", args.slice(0, i).join(), ");")
	  }
	  code.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation")
	  procArgs.push(code.join(""))
	
	  var proc = Function.apply(undefined, procArgs)
	  module.exports = proc.apply(undefined, [slowOrient].concat(CACHED))
	  for(var i=0; i<=NUM_EXPAND; ++i) {
	    module.exports[i] = CACHED[i]
	  }
	}
	
	generateOrientationProc()
	},{"robust-scale":510,"robust-subtract":512,"robust-sum":513,"two-product":541}],509:[function(_dereq_,module,exports){
	"use strict"
	
	var robustSum = _dereq_("robust-sum")
	var robustScale = _dereq_("robust-scale")
	
	module.exports = robustProduct
	
	function robustProduct(a, b) {
	  if(a.length === 1) {
	    return robustScale(b, a[0])
	  }
	  if(b.length === 1) {
	    return robustScale(a, b[0])
	  }
	  if(a.length === 0 || b.length === 0) {
	    return [0]
	  }
	  var r = [0]
	  if(a.length < b.length) {
	    for(var i=0; i<a.length; ++i) {
	      r = robustSum(r, robustScale(b, a[i]))
	    }
	  } else {
	    for(var i=0; i<b.length; ++i) {
	      r = robustSum(r, robustScale(a, b[i]))
	    }    
	  }
	  return r
	}
	},{"robust-scale":510,"robust-sum":513}],510:[function(_dereq_,module,exports){
	"use strict"
	
	var twoProduct = _dereq_("two-product")
	var twoSum = _dereq_("two-sum")
	
	module.exports = scaleLinearExpansion
	
	function scaleLinearExpansion(e, scale) {
	  var n = e.length
	  if(n === 1) {
	    var ts = twoProduct(e[0], scale)
	    if(ts[0]) {
	      return ts
	    }
	    return [ ts[1] ]
	  }
	  var g = new Array(2 * n)
	  var q = [0.1, 0.1]
	  var t = [0.1, 0.1]
	  var count = 0
	  twoProduct(e[0], scale, q)
	  if(q[0]) {
	    g[count++] = q[0]
	  }
	  for(var i=1; i<n; ++i) {
	    twoProduct(e[i], scale, t)
	    var pq = q[1]
	    twoSum(pq, t[0], q)
	    if(q[0]) {
	      g[count++] = q[0]
	    }
	    var a = t[1]
	    var b = q[1]
	    var x = a + b
	    var bv = x - a
	    var y = b - bv
	    q[1] = x
	    if(y) {
	      g[count++] = y
	    }
	  }
	  if(q[1]) {
	    g[count++] = q[1]
	  }
	  if(count === 0) {
	    g[count++] = 0.0
	  }
	  g.length = count
	  return g
	}
	},{"two-product":541,"two-sum":542}],511:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = segmentsIntersect
	
	var orient = _dereq_("robust-orientation")[3]
	
	function checkCollinear(a0, a1, b0, b1) {
	
	  for(var d=0; d<2; ++d) {
	    var x0 = a0[d]
	    var y0 = a1[d]
	    var l0 = Math.min(x0, y0)
	    var h0 = Math.max(x0, y0)    
	
	    var x1 = b0[d]
	    var y1 = b1[d]
	    var l1 = Math.min(x1, y1)
	    var h1 = Math.max(x1, y1)    
	
	    if(h1 < l0 || h0 < l1) {
	      return false
	    }
	  }
	
	  return true
	}
	
	function segmentsIntersect(a0, a1, b0, b1) {
	  var x0 = orient(a0, b0, b1)
	  var y0 = orient(a1, b0, b1)
	  if((x0 > 0 && y0 > 0) || (x0 < 0 && y0 < 0)) {
	    return false
	  }
	
	  var x1 = orient(b0, a0, a1)
	  var y1 = orient(b1, a0, a1)
	  if((x1 > 0 && y1 > 0) || (x1 < 0 && y1 < 0)) {
	    return false
	  }
	
	  //Check for degenerate collinear case
	  if(x0 === 0 && y0 === 0 && x1 === 0 && y1 === 0) {
	    return checkCollinear(a0, a1, b0, b1)
	  }
	
	  return true
	}
	},{"robust-orientation":508}],512:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = robustSubtract
	
	//Easy case: Add two scalars
	function scalarScalar(a, b) {
	  var x = a + b
	  var bv = x - a
	  var av = x - bv
	  var br = b - bv
	  var ar = a - av
	  var y = ar + br
	  if(y) {
	    return [y, x]
	  }
	  return [x]
	}
	
	function robustSubtract(e, f) {
	  var ne = e.length|0
	  var nf = f.length|0
	  if(ne === 1 && nf === 1) {
	    return scalarScalar(e[0], -f[0])
	  }
	  var n = ne + nf
	  var g = new Array(n)
	  var count = 0
	  var eptr = 0
	  var fptr = 0
	  var abs = Math.abs
	  var ei = e[eptr]
	  var ea = abs(ei)
	  var fi = -f[fptr]
	  var fa = abs(fi)
	  var a, b
	  if(ea < fa) {
	    b = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    b = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	      fa = abs(fi)
	    }
	  }
	  if((eptr < ne && ea < fa) || (fptr >= nf)) {
	    a = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    a = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	      fa = abs(fi)
	    }
	  }
	  var x = a + b
	  var bv = x - a
	  var y = b - bv
	  var q0 = y
	  var q1 = x
	  var _x, _bv, _av, _br, _ar
	  while(eptr < ne && fptr < nf) {
	    if(ea < fa) {
	      a = ei
	      eptr += 1
	      if(eptr < ne) {
	        ei = e[eptr]
	        ea = abs(ei)
	      }
	    } else {
	      a = fi
	      fptr += 1
	      if(fptr < nf) {
	        fi = -f[fptr]
	        fa = abs(fi)
	      }
	    }
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	  }
	  while(eptr < ne) {
	    a = ei
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	    }
	  }
	  while(fptr < nf) {
	    a = fi
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    } 
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	    }
	  }
	  if(q0) {
	    g[count++] = q0
	  }
	  if(q1) {
	    g[count++] = q1
	  }
	  if(!count) {
	    g[count++] = 0.0  
	  }
	  g.length = count
	  return g
	}
	},{}],513:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = linearExpansionSum
	
	//Easy case: Add two scalars
	function scalarScalar(a, b) {
	  var x = a + b
	  var bv = x - a
	  var av = x - bv
	  var br = b - bv
	  var ar = a - av
	  var y = ar + br
	  if(y) {
	    return [y, x]
	  }
	  return [x]
	}
	
	function linearExpansionSum(e, f) {
	  var ne = e.length|0
	  var nf = f.length|0
	  if(ne === 1 && nf === 1) {
	    return scalarScalar(e[0], f[0])
	  }
	  var n = ne + nf
	  var g = new Array(n)
	  var count = 0
	  var eptr = 0
	  var fptr = 0
	  var abs = Math.abs
	  var ei = e[eptr]
	  var ea = abs(ei)
	  var fi = f[fptr]
	  var fa = abs(fi)
	  var a, b
	  if(ea < fa) {
	    b = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    b = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	      fa = abs(fi)
	    }
	  }
	  if((eptr < ne && ea < fa) || (fptr >= nf)) {
	    a = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    a = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	      fa = abs(fi)
	    }
	  }
	  var x = a + b
	  var bv = x - a
	  var y = b - bv
	  var q0 = y
	  var q1 = x
	  var _x, _bv, _av, _br, _ar
	  while(eptr < ne && fptr < nf) {
	    if(ea < fa) {
	      a = ei
	      eptr += 1
	      if(eptr < ne) {
	        ei = e[eptr]
	        ea = abs(ei)
	      }
	    } else {
	      a = fi
	      fptr += 1
	      if(fptr < nf) {
	        fi = f[fptr]
	        fa = abs(fi)
	      }
	    }
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	  }
	  while(eptr < ne) {
	    a = ei
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	    }
	  }
	  while(fptr < nf) {
	    a = fi
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    } 
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	    }
	  }
	  if(q0) {
	    g[count++] = q0
	  }
	  if(q1) {
	    g[count++] = q1
	  }
	  if(!count) {
	    g[count++] = 0.0  
	  }
	  g.length = count
	  return g
	}
	},{}],514:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = function signum(x) {
	  if(x < 0) { return -1 }
	  if(x > 0) { return 1 }
	  return 0.0
	}
	},{}],515:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = boundary
	
	var bnd = _dereq_('boundary-cells')
	var reduce = _dereq_('reduce-simplicial-complex')
	
	function boundary(cells) {
	  return reduce(bnd(cells))
	}
	
	},{"boundary-cells":96,"reduce-simplicial-complex":490}],516:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = extractContour
	
	var ndarray = _dereq_('ndarray')
	var pool    = _dereq_('typedarray-pool')
	var ndsort  = _dereq_('ndarray-sort')
	
	var contourAlgorithm = _dereq_('./lib/codegen')
	
	function getDimension(cells) {
	  var numCells = cells.length
	  var d = 0
	  for(var i=0; i<numCells; ++i) {
	    d = Math.max(d, cells[i].length)|0
	  }
	  return d-1
	}
	
	function getSigns(values, level) {
	  var numVerts    = values.length
	  var vertexSigns = pool.mallocUint8(numVerts)
	  for(var i=0; i<numVerts; ++i) {
	    vertexSigns[i] = (values[i] < level)|0
	  }
	  return vertexSigns
	}
	
	function getEdges(cells, d) {
	  var numCells = cells.length
	  var maxEdges = ((d * (d+1)/2) * numCells)|0
	  var edges    = pool.mallocUint32(maxEdges*2)
	  var ePtr     = 0
	  for(var i=0; i<numCells; ++i) {
	    var c = cells[i]
	    var d = c.length
	    for(var j=0; j<d; ++j) {
	      for(var k=0; k<j; ++k) {
	        var a = c[k]
	        var b = c[j]
	        edges[ePtr++] = Math.min(a,b)|0
	        edges[ePtr++] = Math.max(a,b)|0
	      }
	    }
	  }
	  var nedges = (ePtr/2)|0
	  ndsort(ndarray(edges, [nedges,2])) 
	  var ptr = 2
	  for(var i=2; i<ePtr; i+=2) {
	    if(edges[i-2] === edges[i] &&
	       edges[i-1] === edges[i+1]) {
	      continue
	    }
	    edges[ptr++] = edges[i]
	    edges[ptr++] = edges[i+1]
	  }
	
	  return ndarray(edges, [(ptr/2)|0, 2])
	}
	
	function getCrossingWeights(edges, values, signs, level) {
	  var edata     = edges.data
	  var numEdges  = edges.shape[0]
	  var weights   = pool.mallocDouble(numEdges)
	  var ptr       = 0
	  for(var i=0; i<numEdges; ++i) {
	    var a  = edata[2*i]
	    var b  = edata[2*i+1]
	    if(signs[a] === signs[b]) {
	      continue
	    }
	    var va = values[a]
	    var vb = values[b]
	    edata[2*ptr]     = a
	    edata[2*ptr+1]   = b
	    weights[ptr++]   = (vb - level) / (vb - va)
	  }
	  edges.shape[0] = ptr
	  return ndarray(weights, [ptr])
	}
	
	function getCascade(edges, numVerts) {
	  var result   = pool.mallocInt32(numVerts*2)
	  var numEdges = edges.shape[0]
	  var edata    = edges.data
	  result[0]    = 0
	  var lastV    = 0
	  for(var i=0; i<numEdges; ++i) {
	    var a = edata[2*i]
	    if(a !== lastV) {
	      result[2*lastV+1] = i
	      while(++lastV < a) {
	        result[2*lastV] = i
	        result[2*lastV+1] = i
	      }
	      result[2*lastV] = i
	    }
	  }
	  result[2*lastV+1] = numEdges
	  while(++lastV < numVerts) {
	    result[2*lastV] = result[2*lastV+1] = numEdges
	  }
	  return result
	}
	
	function unpackEdges(edges) {
	  var ne = edges.shape[0]|0
	  var edata = edges.data
	  var result = new Array(ne)
	  for(var i=0; i<ne; ++i) {
	    result[i] = [edata[2*i], edata[2*i+1]]
	  }
	  return result
	}
	
	function extractContour(cells, values, level, d) {
	  level = level||0.0
	
	  //If user didn't specify `d`, use brute force scan
	  if(typeof d === 'undefined') {
	    d = getDimension(cells)
	  }
	
	  //Count number of cells
	  var numCells = cells.length
	  if(numCells === 0 || d < 1) {
	    return {
	      cells:         [],
	      vertexIds:     [],
	      vertexWeights: []
	    }
	  }
	
	  //Read in vertex signs
	  var vertexSigns = getSigns(values, +level)
	
	  //First get 1-skeleton, find all crossings
	  var edges   = getEdges(cells, d)
	  var weights = getCrossingWeights(edges, values, vertexSigns, +level)
	
	  //Build vertex cascade to speed up binary search
	  var vcascade = getCascade(edges, values.length|0)
	
	  //Then construct cells
	  var faces = contourAlgorithm(d)(cells, edges.data, vcascade, vertexSigns)
	
	  //Unpack data into pretty format
	  var uedges   = unpackEdges(edges)
	  var uweights = [].slice.call(weights.data, 0, weights.shape[0])
	
	  //Release data
	  pool.free(vertexSigns)
	  pool.free(edges.data)
	  pool.free(weights.data)
	  pool.free(vcascade)
	  
	  return {
	    cells:         faces,
	    vertexIds:     uedges,
	    vertexWeights: uweights
	  }
	}
	},{"./lib/codegen":517,"ndarray":451,"ndarray-sort":449,"typedarray-pool":543}],517:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = getPolygonizer
	
	var pool = _dereq_('typedarray-pool')
	var createMSTable = _dereq_('marching-simplex-table')
	
	var CACHE = {}
	
	function createCellPolygonizer(d) {
	  var maxCellSize = 0
	  var tables = new Array(d+1)
	  tables[0] = [ [] ]
	  for(var i=1; i<=d; ++i) {
	    var tab = tables[i] = createMSTable(i)
	    for(var j=0; j<tab.length; ++j) {
	      maxCellSize = Math.max(maxCellSize, tab[i].length)
	    }
	  }
	
	  var code  = [
	  'function B(C,E,i,j){',
	    'var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];',
	    'while(l<h){',
	      'var m=(l+h)>>1,v=E[2*m+1];',
	      'if(v===b){return m}',
	      'if(b<v){h=m}else{l=m+1}',
	    '}',
	    'return l;',
	  '};',
	  'function getContour', d, 'd(F,E,C,S){',
	    'var n=F.length,R=[];',
	    'for(var i=0;i<n;++i){var c=F[i],l=c.length;'
	  ]
	
	  function generateCase(facets) {
	    if(facets.length <= 0) {
	      return
	    }
	    code.push('R.push(')
	    for(var i=0; i<facets.length; ++i) {
	      var facet = facets[i]
	      if(i > 0) {
	        code.push(',')
	      }
	      code.push('[')
	      for(var j=0; j<facet.length; ++j) {
	        var f = facet[j]
	        if(j > 0) {
	          code.push(',')
	        }
	        code.push('B(C,E,c[', f[0], '],c[', f[1], '])')
	      }
	      code.push(']')
	    }
	    code.push(');')
	  }
	
	  for(var i=d+1; i>1; --i) {
	    if(i < d+1) {
	      code.push('else ')
	    }
	    code.push('if(l===', i, '){')
	
	    //Generate mask
	    var maskStr = []
	    for(var j=0; j<i; ++j) {
	      maskStr.push('(S[c['+j+']]<<'+j+')')
	    }
	
	    //Perform table look up
	    code.push('var M=', maskStr.join('+'), 
	      ';if(M===0||M===', (1<<i)-1, 
	        '){continue}switch(M){')
	
	    var tab = tables[i-1]
	    for(var j=0; j<tab.length; ++j) {
	      code.push('case ', j, ':')
	      generateCase(tab[j])
	      code.push('break;')
	    }
	    code.push('}}')
	  }
	  code.push('}return R;};return getContour', d, 'd')
	
	  var proc = new Function('pool', code.join(''))
	  return proc(pool)
	}
	
	function getPolygonizer(d) {
	  var alg = CACHE[d]
	  if(!alg) {
	    alg = CACHE[d] = createCellPolygonizer(d) 
	  }
	  return alg
	}
	},{"marching-simplex-table":428,"typedarray-pool":543}],518:[function(_dereq_,module,exports){
	"use strict"; "use restrict";
	
	var bits      = _dereq_("bit-twiddle")
	  , UnionFind = _dereq_("union-find")
	
	//Returns the dimension of a cell complex
	function dimension(cells) {
	  var d = 0
	    , max = Math.max
	  for(var i=0, il=cells.length; i<il; ++i) {
	    d = max(d, cells[i].length)
	  }
	  return d-1
	}
	exports.dimension = dimension
	
	//Counts the number of vertices in faces
	function countVertices(cells) {
	  var vc = -1
	    , max = Math.max
	  for(var i=0, il=cells.length; i<il; ++i) {
	    var c = cells[i]
	    for(var j=0, jl=c.length; j<jl; ++j) {
	      vc = max(vc, c[j])
	    }
	  }
	  return vc+1
	}
	exports.countVertices = countVertices
	
	//Returns a deep copy of cells
	function cloneCells(cells) {
	  var ncells = new Array(cells.length)
	  for(var i=0, il=cells.length; i<il; ++i) {
	    ncells[i] = cells[i].slice(0)
	  }
	  return ncells
	}
	exports.cloneCells = cloneCells
	
	//Ranks a pair of cells up to permutation
	function compareCells(a, b) {
	  var n = a.length
	    , t = a.length - b.length
	    , min = Math.min
	  if(t) {
	    return t
	  }
	  switch(n) {
	    case 0:
	      return 0;
	    case 1:
	      return a[0] - b[0];
	    case 2:
	      var d = a[0]+a[1]-b[0]-b[1]
	      if(d) {
	        return d
	      }
	      return min(a[0],a[1]) - min(b[0],b[1])
	    case 3:
	      var l1 = a[0]+a[1]
	        , m1 = b[0]+b[1]
	      d = l1+a[2] - (m1+b[2])
	      if(d) {
	        return d
	      }
	      var l0 = min(a[0], a[1])
	        , m0 = min(b[0], b[1])
	        , d  = min(l0, a[2]) - min(m0, b[2])
	      if(d) {
	        return d
	      }
	      return min(l0+a[2], l1) - min(m0+b[2], m1)
	    
	    //TODO: Maybe optimize n=4 as well?
	    
	    default:
	      var as = a.slice(0)
	      as.sort()
	      var bs = b.slice(0)
	      bs.sort()
	      for(var i=0; i<n; ++i) {
	        t = as[i] - bs[i]
	        if(t) {
	          return t
	        }
	      }
	      return 0
	  }
	}
	exports.compareCells = compareCells
	
	function compareZipped(a, b) {
	  return compareCells(a[0], b[0])
	}
	
	//Puts a cell complex into normal order for the purposes of findCell queries
	function normalize(cells, attr) {
	  if(attr) {
	    var len = cells.length
	    var zipped = new Array(len)
	    for(var i=0; i<len; ++i) {
	      zipped[i] = [cells[i], attr[i]]
	    }
	    zipped.sort(compareZipped)
	    for(var i=0; i<len; ++i) {
	      cells[i] = zipped[i][0]
	      attr[i] = zipped[i][1]
	    }
	    return cells
	  } else {
	    cells.sort(compareCells)
	    return cells
	  }
	}
	exports.normalize = normalize
	
	//Removes all duplicate cells in the complex
	function unique(cells) {
	  if(cells.length === 0) {
	    return []
	  }
	  var ptr = 1
	    , len = cells.length
	  for(var i=1; i<len; ++i) {
	    var a = cells[i]
	    if(compareCells(a, cells[i-1])) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      cells[ptr++] = a
	    }
	  }
	  cells.length = ptr
	  return cells
	}
	exports.unique = unique;
	
	//Finds a cell in a normalized cell complex
	function findCell(cells, c) {
	  var lo = 0
	    , hi = cells.length-1
	    , r  = -1
	  while (lo <= hi) {
	    var mid = (lo + hi) >> 1
	      , s   = compareCells(cells[mid], c)
	    if(s <= 0) {
	      if(s === 0) {
	        r = mid
	      }
	      lo = mid + 1
	    } else if(s > 0) {
	      hi = mid - 1
	    }
	  }
	  return r
	}
	exports.findCell = findCell;
	
	//Builds an index for an n-cell.  This is more general than dual, but less efficient
	function incidence(from_cells, to_cells) {
	  var index = new Array(from_cells.length)
	  for(var i=0, il=index.length; i<il; ++i) {
	    index[i] = []
	  }
	  var b = []
	  for(var i=0, n=to_cells.length; i<n; ++i) {
	    var c = to_cells[i]
	    var cl = c.length
	    for(var k=1, kn=(1<<cl); k<kn; ++k) {
	      b.length = bits.popCount(k)
	      var l = 0
	      for(var j=0; j<cl; ++j) {
	        if(k & (1<<j)) {
	          b[l++] = c[j]
	        }
	      }
	      var idx=findCell(from_cells, b)
	      if(idx < 0) {
	        continue
	      }
	      while(true) {
	        index[idx++].push(i)
	        if(idx >= from_cells.length || compareCells(from_cells[idx], b) !== 0) {
	          break
	        }
	      }
	    }
	  }
	  return index
	}
	exports.incidence = incidence
	
	//Computes the dual of the mesh.  This is basically an optimized version of buildIndex for the situation where from_cells is just the list of vertices
	function dual(cells, vertex_count) {
	  if(!vertex_count) {
	    return incidence(unique(skeleton(cells, 0)), cells, 0)
	  }
	  var res = new Array(vertex_count)
	  for(var i=0; i<vertex_count; ++i) {
	    res[i] = []
	  }
	  for(var i=0, len=cells.length; i<len; ++i) {
	    var c = cells[i]
	    for(var j=0, cl=c.length; j<cl; ++j) {
	      res[c[j]].push(i)
	    }
	  }
	  return res
	}
	exports.dual = dual
	
	//Enumerates all cells in the complex
	function explode(cells) {
	  var result = []
	  for(var i=0, il=cells.length; i<il; ++i) {
	    var c = cells[i]
	      , cl = c.length|0
	    for(var j=1, jl=(1<<cl); j<jl; ++j) {
	      var b = []
	      for(var k=0; k<cl; ++k) {
	        if((j >>> k) & 1) {
	          b.push(c[k])
	        }
	      }
	      result.push(b)
	    }
	  }
	  return normalize(result)
	}
	exports.explode = explode
	
	//Enumerates all of the n-cells of a cell complex
	function skeleton(cells, n) {
	  if(n < 0) {
	    return []
	  }
	  var result = []
	    , k0     = (1<<(n+1))-1
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var k=k0; k<(1<<c.length); k=bits.nextCombination(k)) {
	      var b = new Array(n+1)
	        , l = 0
	      for(var j=0; j<c.length; ++j) {
	        if(k & (1<<j)) {
	          b[l++] = c[j]
	        }
	      }
	      result.push(b)
	    }
	  }
	  return normalize(result)
	}
	exports.skeleton = skeleton;
	
	//Computes the boundary of all cells, does not remove duplicates
	function boundary(cells) {
	  var res = []
	  for(var i=0,il=cells.length; i<il; ++i) {
	    var c = cells[i]
	    for(var j=0,cl=c.length; j<cl; ++j) {
	      var b = new Array(c.length-1)
	      for(var k=0, l=0; k<cl; ++k) {
	        if(k !== j) {
	          b[l++] = c[k]
	        }
	      }
	      res.push(b)
	    }
	  }
	  return normalize(res)
	}
	exports.boundary = boundary;
	
	//Computes connected components for a dense cell complex
	function connectedComponents_dense(cells, vertex_count) {
	  var labels = new UnionFind(vertex_count)
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      for(var k=j+1; k<c.length; ++k) {
	        labels.link(c[j], c[k])
	      }
	    }
	  }
	  var components = []
	    , component_labels = labels.ranks
	  for(var i=0; i<component_labels.length; ++i) {
	    component_labels[i] = -1
	  }
	  for(var i=0; i<cells.length; ++i) {
	    var l = labels.find(cells[i][0])
	    if(component_labels[l] < 0) {
	      component_labels[l] = components.length
	      components.push([cells[i].slice(0)])
	    } else {
	      components[component_labels[l]].push(cells[i].slice(0))
	    }
	  }
	  return components
	}
	
	//Computes connected components for a sparse graph
	function connectedComponents_sparse(cells) {
	  var vertices  = unique(normalize(skeleton(cells, 0)))
	    , labels    = new UnionFind(vertices.length)
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      var vj = findCell(vertices, [c[j]])
	      for(var k=j+1; k<c.length; ++k) {
	        labels.link(vj, findCell(vertices, [c[k]]))
	      }
	    }
	  }
	  var components        = []
	    , component_labels  = labels.ranks
	  for(var i=0; i<component_labels.length; ++i) {
	    component_labels[i] = -1
	  }
	  for(var i=0; i<cells.length; ++i) {
	    var l = labels.find(findCell(vertices, [cells[i][0]]));
	    if(component_labels[l] < 0) {
	      component_labels[l] = components.length
	      components.push([cells[i].slice(0)])
	    } else {
	      components[component_labels[l]].push(cells[i].slice(0))
	    }
	  }
	  return components
	}
	
	//Computes connected components for a cell complex
	function connectedComponents(cells, vertex_count) {
	  if(vertex_count) {
	    return connectedComponents_dense(cells, vertex_count)
	  }
	  return connectedComponents_sparse(cells)
	}
	exports.connectedComponents = connectedComponents
	
	},{"bit-twiddle":93,"union-find":544}],519:[function(_dereq_,module,exports){
	arguments[4][93][0].apply(exports,arguments)
	},{"dup":93}],520:[function(_dereq_,module,exports){
	arguments[4][518][0].apply(exports,arguments)
	},{"bit-twiddle":519,"dup":518,"union-find":521}],521:[function(_dereq_,module,exports){
	"use strict"; "use restrict";
	
	module.exports = UnionFind;
	
	function UnionFind(count) {
	  this.roots = new Array(count);
	  this.ranks = new Array(count);
	  
	  for(var i=0; i<count; ++i) {
	    this.roots[i] = i;
	    this.ranks[i] = 0;
	  }
	}
	
	UnionFind.prototype.length = function() {
	  return this.roots.length;
	}
	
	UnionFind.prototype.makeSet = function() {
	  var n = this.roots.length;
	  this.roots.push(n);
	  this.ranks.push(0);
	  return n;
	}
	
	UnionFind.prototype.find = function(x) {
	  var roots = this.roots;
	  while(roots[x] !== x) {
	    var y = roots[x];
	    roots[x] = roots[y];
	    x = y;
	  }
	  return x;
	}
	
	UnionFind.prototype.link = function(x, y) {
	  var xr = this.find(x)
	    , yr = this.find(y);
	  if(xr === yr) {
	    return;
	  }
	  var ranks = this.ranks
	    , roots = this.roots
	    , xd    = ranks[xr]
	    , yd    = ranks[yr];
	  if(xd < yd) {
	    roots[xr] = yr;
	  } else if(yd < xd) {
	    roots[yr] = xr;
	  } else {
	    roots[yr] = xr;
	    ++ranks[xr];
	  }
	}
	
	
	},{}],522:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = simplifyPolygon
	
	var orient = _dereq_("robust-orientation")
	var sc = _dereq_("simplicial-complex")
	
	function errorWeight(base, a, b) {
	  var area = Math.abs(orient(base, a, b))
	  var perim = Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1]-b[1], 2))
	  return area / perim
	}
	
	function simplifyPolygon(cells, positions, minArea) {
	
	  var n = positions.length
	  var nc = cells.length
	  var inv = new Array(n)
	  var outv = new Array(n)
	  var weights = new Array(n)
	  var dead = new Array(n)
	  
	  //Initialize tables
	  for(var i=0; i<n; ++i) {
	    inv[i] = outv[i] = -1
	    weights[i] = Infinity
	    dead[i] = false
	  }
	
	  //Compute neighbors
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    if(c.length !== 2) {
	      throw new Error("Input must be a graph")
	    }
	    var s = c[1]
	    var t = c[0]
	    if(outv[t] !== -1) {
	      outv[t] = -2
	    } else {
	      outv[t] = s
	    }
	    if(inv[s] !== -1) {
	      inv[s] = -2
	    } else {
	      inv[s] = t
	    }
	  }
	
	  //Updates the weight for vertex i
	  function computeWeight(i) {
	    if(dead[i]) {
	      return Infinity
	    }
	    //TODO: Check that the line segment doesn't cross once simplified
	    var s = inv[i]
	    var t = outv[i]
	    if((s<0) || (t<0)) {
	      return Infinity
	    } else {
	      return errorWeight(positions[i], positions[s], positions[t])
	    }
	  }
	
	  //Swaps two nodes on the heap (i,j) are the index of the nodes
	  function heapSwap(i,j) {
	    var a = heap[i]
	    var b = heap[j]
	    heap[i] = b
	    heap[j] = a
	    index[a] = j
	    index[b] = i
	  }
	
	  //Returns the weight of node i on the heap
	  function heapWeight(i) {
	    return weights[heap[i]]
	  }
	
	  function heapParent(i) {
	    if(i & 1) {
	      return (i - 1) >> 1
	    }
	    return (i >> 1) - 1
	  }
	
	  //Bubble element i down the heap
	  function heapDown(i) {
	    var w = heapWeight(i)
	    while(true) {
	      var tw = w
	      var left  = 2*i + 1
	      var right = 2*(i + 1)
	      var next = i
	      if(left < heapCount) {
	        var lw = heapWeight(left)
	        if(lw < tw) {
	          next = left
	          tw = lw
	        }
	      }
	      if(right < heapCount) {
	        var rw = heapWeight(right)
	        if(rw < tw) {
	          next = right
	        }
	      }
	      if(next === i) {
	        return i
	      }
	      heapSwap(i, next)
	      i = next      
	    }
	  }
	
	  //Bubbles element i up the heap
	  function heapUp(i) {
	    var w = heapWeight(i)
	    while(i > 0) {
	      var parent = heapParent(i)
	      if(parent >= 0) {
	        var pw = heapWeight(parent)
	        if(w < pw) {
	          heapSwap(i, parent)
	          i = parent
	          continue
	        }
	      }
	      return i
	    }
	  }
	
	  //Pop minimum element
	  function heapPop() {
	    if(heapCount > 0) {
	      var head = heap[0]
	      heapSwap(0, heapCount-1)
	      heapCount -= 1
	      heapDown(0)
	      return head
	    }
	    return -1
	  }
	
	  //Update heap item i
	  function heapUpdate(i, w) {
	    var a = heap[i]
	    if(weights[a] === w) {
	      return i
	    }
	    weights[a] = -Infinity
	    heapUp(i)
	    heapPop()
	    weights[a] = w
	    heapCount += 1
	    return heapUp(heapCount-1)
	  }
	
	  //Kills a vertex (assume vertex already removed from heap)
	  function kill(i) {
	    if(dead[i]) {
	      return
	    }
	    //Kill vertex
	    dead[i] = true
	    //Fixup topology
	    var s = inv[i]
	    var t = outv[i]
	    if(inv[t] >= 0) {
	      inv[t] = s
	    }
	    if(outv[s] >= 0) {
	      outv[s] = t
	    }
	
	    //Update weights on s and t
	    if(index[s] >= 0) {
	      heapUpdate(index[s], computeWeight(s))
	    }
	    if(index[t] >= 0) {
	      heapUpdate(index[t], computeWeight(t))
	    }
	  }
	
	  //Initialize weights and heap
	  var heap = []
	  var index = new Array(n)
	  for(var i=0; i<n; ++i) {
	    var w = weights[i] = computeWeight(i)
	    if(w < Infinity) {
	      index[i] = heap.length
	      heap.push(i)
	    } else {
	      index[i] = -1
	    }
	  }
	  var heapCount = heap.length
	  for(var i=heapCount>>1; i>=0; --i) {
	    heapDown(i)
	  }
	  
	  //Kill vertices
	  while(true) {
	    var hmin = heapPop()
	    if((hmin < 0) || (weights[hmin] > minArea)) {
	      break
	    }
	    kill(hmin)
	  }
	
	  //Build collapsed vertex table
	  var npositions = []
	  for(var i=0; i<n; ++i) {
	    if(!dead[i]) {
	      index[i] = npositions.length
	      npositions.push(positions[i].slice())
	    }
	  }
	  var nv = npositions.length
	
	  function tortoiseHare(seq, start) {
	    if(seq[start] < 0) {
	      return start
	    }
	    var t = start
	    var h = start
	    do {
	      //Walk two steps with h
	      var nh = seq[h]
	      if(!dead[h] || nh < 0 || nh === h) {
	        break
	      }
	      h = nh
	      nh = seq[h]
	      if(!dead[h] || nh < 0 || nh === h) {
	        break
	      }
	      h = nh
	
	      //Walk one step with t
	      t = seq[t]
	    } while(t !== h)
	    //Compress cycles
	    for(var v=start; v!==h; v = seq[v]) {
	      seq[v] = h
	    }
	    return h
	  }
	
	  var ncells = []
	  cells.forEach(function(c) {
	    var tin = tortoiseHare(inv, c[0])
	    var tout = tortoiseHare(outv, c[1])
	    if(tin >= 0 && tout >= 0 && tin !== tout) {
	      var cin = index[tin]
	      var cout = index[tout]
	      if(cin !== cout) {
	        ncells.push([ cin, cout ])
	      }
	    }
	  })
	
	  //Normalize result
	  sc.unique(sc.normalize(ncells))
	
	  //Return final list of cells
	  return {
	    positions: npositions,
	    edges: ncells
	  }
	}
	},{"robust-orientation":508,"simplicial-complex":520}],523:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = orderSegments
	
	var orient = _dereq_("robust-orientation")
	
	function horizontalOrder(a, b) {
	  var bl, br
	  if(b[0][0] < b[1][0]) {
	    bl = b[0]
	    br = b[1]
	  } else if(b[0][0] > b[1][0]) {
	    bl = b[1]
	    br = b[0]
	  } else {
	    var alo = Math.min(a[0][1], a[1][1])
	    var ahi = Math.max(a[0][1], a[1][1])
	    var blo = Math.min(b[0][1], b[1][1])
	    var bhi = Math.max(b[0][1], b[1][1])
	    if(ahi < blo) {
	      return ahi - blo
	    }
	    if(alo > bhi) {
	      return alo - bhi
	    }
	    return ahi - bhi
	  }
	  var al, ar
	  if(a[0][1] < a[1][1]) {
	    al = a[0]
	    ar = a[1]
	  } else {
	    al = a[1]
	    ar = a[0]
	  }
	  var d = orient(br, bl, al)
	  if(d) {
	    return d
	  }
	  d = orient(br, bl, ar)
	  if(d) {
	    return d
	  }
	  return ar - br
	}
	
	function orderSegments(b, a) {
	  var al, ar
	  if(a[0][0] < a[1][0]) {
	    al = a[0]
	    ar = a[1]
	  } else if(a[0][0] > a[1][0]) {
	    al = a[1]
	    ar = a[0]
	  } else {
	    return horizontalOrder(a, b)
	  }
	  var bl, br
	  if(b[0][0] < b[1][0]) {
	    bl = b[0]
	    br = b[1]
	  } else if(b[0][0] > b[1][0]) {
	    bl = b[1]
	    br = b[0]
	  } else {
	    return -horizontalOrder(b, a)
	  }
	  var d1 = orient(al, ar, br)
	  var d2 = orient(al, ar, bl)
	  if(d1 < 0) {
	    if(d2 <= 0) {
	      return d1
	    }
	  } else if(d1 > 0) {
	    if(d2 >= 0) {
	      return d1
	    }
	  } else if(d2) {
	    return d2
	  }
	  d1 = orient(br, bl, ar)
	  d2 = orient(br, bl, al)
	  if(d1 < 0) {
	    if(d2 <= 0) {
	      return d1
	    }
	  } else if(d1 > 0) {
	    if(d2 >= 0) {
	      return d1
	    }
	  } else if(d2) {
	    return d2
	  }
	  return ar[0] - br[0]
	}
	},{"robust-orientation":508}],524:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = createSlabDecomposition
	
	var bounds = _dereq_("binary-search-bounds")
	var createRBTree = _dereq_("functional-red-black-tree")
	var orient = _dereq_("robust-orientation")
	var orderSegments = _dereq_("./lib/order-segments")
	
	function SlabDecomposition(slabs, coordinates, horizontal) {
	  this.slabs = slabs
	  this.coordinates = coordinates
	  this.horizontal = horizontal
	}
	
	var proto = SlabDecomposition.prototype
	
	function compareHorizontal(e, y) {
	  return e.y - y
	}
	
	function searchBucket(root, p) {
	  var lastNode = null
	  while(root) {
	    var seg = root.key
	    var l, r
	    if(seg[0][0] < seg[1][0]) {
	      l = seg[0]
	      r = seg[1]
	    } else {
	      l = seg[1]
	      r = seg[0]
	    }
	    var o = orient(l, r, p)
	    if(o < 0) {
	      root = root.left
	    } else if(o > 0) {
	      if(p[0] !== seg[1][0]) {
	        lastNode = root
	        root = root.right
	      } else {
	        var val = searchBucket(root.right, p)
	        if(val) {
	          return val
	        }
	        root = root.left
	      }
	    } else {
	      if(p[0] !== seg[1][0]) {
	        return root
	      } else {
	        var val = searchBucket(root.right, p)
	        if(val) {
	          return val
	        }
	        root = root.left
	      }
	    }
	  }
	  return lastNode
	}
	
	proto.castUp = function(p) {
	  var bucket = bounds.le(this.coordinates, p[0])
	  if(bucket < 0) {
	    return -1
	  }
	  var root = this.slabs[bucket]
	  var hitNode = searchBucket(this.slabs[bucket], p)
	  var lastHit = -1
	  if(hitNode) {
	    lastHit = hitNode.value
	  }
	  //Edge case: need to handle horizontal segments (sucks)
	  if(this.coordinates[bucket] === p[0]) {
	    var lastSegment = null
	    if(hitNode) {
	      lastSegment = hitNode.key
	    }
	    if(bucket > 0) {
	      var otherHitNode = searchBucket(this.slabs[bucket-1], p)
	      if(otherHitNode) {
	        if(lastSegment) {
	          if(orderSegments(otherHitNode.key, lastSegment) > 0) {
	            lastSegment = otherHitNode.key
	            lastHit = otherHitNode.value
	          }
	        } else {
	          lastHit = otherHitNode.value
	          lastSegment = otherHitNode.key
	        }
	      }
	    }
	    var horiz = this.horizontal[bucket]
	    if(horiz.length > 0) {
	      var hbucket = bounds.ge(horiz, p[1], compareHorizontal)
	      if(hbucket < horiz.length) {
	        var e = horiz[hbucket]
	        if(p[1] === e.y) {
	          if(e.closed) {
	            return e.index
	          } else {
	            while(hbucket < horiz.length-1 && horiz[hbucket+1].y === p[1]) {
	              hbucket = hbucket+1
	              e = horiz[hbucket]
	              if(e.closed) {
	                return e.index
	              }
	            }
	            if(e.y === p[1] && !e.start) {
	              hbucket = hbucket+1
	              if(hbucket >= horiz.length) {
	                return lastHit
	              }
	              e = horiz[hbucket]
	            }
	          }
	        }
	        //Check if e is above/below last segment
	        if(e.start) {
	          if(lastSegment) {
	            var o = orient(lastSegment[0], lastSegment[1], [p[0], e.y])
	            if(lastSegment[0][0] > lastSegment[1][0]) {
	              o = -o
	            }
	            if(o > 0) {
	              lastHit = e.index
	            }
	          } else {
	            lastHit = e.index
	          }
	        } else if(e.y !== p[1]) {
	          lastHit = e.index
	        }
	      }
	    }
	  }
	  return lastHit
	}
	
	function IntervalSegment(y, index, start, closed) {
	  this.y = y
	  this.index = index
	  this.start = start
	  this.closed = closed
	}
	
	function Event(x, segment, create, index) {
	  this.x = x
	  this.segment = segment
	  this.create = create
	  this.index = index
	}
	
	
	function createSlabDecomposition(segments) {
	  var numSegments = segments.length
	  var numEvents = 2 * numSegments
	  var events = new Array(numEvents)
	  for(var i=0; i<numSegments; ++i) {
	    var s = segments[i]
	    var f = s[0][0] < s[1][0]
	    events[2*i] = new Event(s[0][0], s, f, i)
	    events[2*i+1] = new Event(s[1][0], s, !f, i)
	  }
	  events.sort(function(a,b) {
	    var d = a.x - b.x
	    if(d) {
	      return d
	    }
	    d = a.create - b.create
	    if(d) {
	      return d
	    }
	    return Math.min(a.segment[0][1], a.segment[1][1]) - Math.min(b.segment[0][1], b.segment[1][1])
	  })
	  var tree = createRBTree(orderSegments)
	  var slabs = []
	  var lines = []
	  var horizontal = []
	  var lastX = -Infinity
	  for(var i=0; i<numEvents; ) {
	    var x = events[i].x
	    var horiz = []
	    while(i < numEvents) {
	      var e = events[i]
	      if(e.x !== x) {
	        break
	      }
	      i += 1
	      if(e.segment[0][0] === e.x && e.segment[1][0] === e.x) {
	        if(e.create) {
	          if(e.segment[0][1] < e.segment[1][1]) {
	            horiz.push(new IntervalSegment(
	                e.segment[0][1],
	                e.index,
	                true,
	                true))
	            horiz.push(new IntervalSegment(
	                e.segment[1][1],
	                e.index,
	                false,
	                false))
	          } else {
	            horiz.push(new IntervalSegment(
	                e.segment[1][1],
	                e.index,
	                true,
	                false))
	            horiz.push(new IntervalSegment(
	                e.segment[0][1],
	                e.index,
	                false,
	                true))
	          }
	        }
	      } else {
	        if(e.create) {
	          tree = tree.insert(e.segment, e.index)
	        } else {
	          tree = tree.remove(e.segment)
	        }
	      }
	    }
	    slabs.push(tree.root)
	    lines.push(x)
	    horizontal.push(horiz)
	  }
	  return new SlabDecomposition(slabs, lines, horizontal)
	}
	},{"./lib/order-segments":523,"binary-search-bounds":92,"functional-red-black-tree":232,"robust-orientation":508}],525:[function(_dereq_,module,exports){
	"use strict"
	
	var robustDot = _dereq_("robust-dot-product")
	var robustSum = _dereq_("robust-sum")
	
	module.exports = splitPolygon
	module.exports.positive = positive
	module.exports.negative = negative
	
	function planeT(p, plane) {
	  var r = robustSum(robustDot(p, plane), [plane[plane.length-1]])
	  return r[r.length-1]
	}
	
	
	//Can't do this exactly and emit a floating point result
	function lerpW(a, wa, b, wb) {
	  var d = wb - wa
	  var t = -wa / d
	  if(t < 0.0) {
	    t = 0.0
	  } else if(t > 1.0) {
	    t = 1.0
	  }
	  var ti = 1.0 - t
	  var n = a.length
	  var r = new Array(n)
	  for(var i=0; i<n; ++i) {
	    r[i] = t * a[i] + ti * b[i]
	  }
	  return r
	}
	
	function splitPolygon(points, plane) {
	  var pos = []
	  var neg = []
	  var a = planeT(points[points.length-1], plane)
	  for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
	    t = points[i]
	    var b = planeT(t, plane)
	    if((a < 0 && b > 0) || (a > 0 && b < 0)) {
	      var p = lerpW(s, b, t, a)
	      pos.push(p)
	      neg.push(p.slice())
	    }
	    if(b < 0) {
	      neg.push(t.slice())
	    } else if(b > 0) {
	      pos.push(t.slice())
	    } else {
	      pos.push(t.slice())
	      neg.push(t.slice())
	    }
	    a = b
	  }
	  return { positive: pos, negative: neg }
	}
	
	function positive(points, plane) {
	  var pos = []
	  var a = planeT(points[points.length-1], plane)
	  for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
	    t = points[i]
	    var b = planeT(t, plane)
	    if((a < 0 && b > 0) || (a > 0 && b < 0)) {
	      pos.push(lerpW(s, b, t, a))
	    }
	    if(b >= 0) {
	      pos.push(t.slice())
	    }
	    a = b
	  }
	  return pos
	}
	
	function negative(points, plane) {
	  var neg = []
	  var a = planeT(points[points.length-1], plane)
	  for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
	    t = points[i]
	    var b = planeT(t, plane)
	    if((a < 0 && b > 0) || (a > 0 && b < 0)) {
	      neg.push(lerpW(s, b, t, a))
	    }
	    if(b <= 0) {
	      neg.push(t.slice())
	    }
	    a = b
	  }
	  return neg
	}
	},{"robust-dot-product":505,"robust-sum":513}],526:[function(_dereq_,module,exports){
	/* global window, exports, define */
	
	!function() {
	    'use strict'
	
	    var re = {
	        not_string: /[^s]/,
	        not_bool: /[^t]/,
	        not_type: /[^T]/,
	        not_primitive: /[^v]/,
	        number: /[diefg]/,
	        numeric_arg: /[bcdiefguxX]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[+-]/
	    }
	
	    function sprintf(key) {
	        // `arguments` is not an array, but should be fine for this call
	        return sprintf_format(sprintf_parse(key), arguments)
	    }
	
	    function vsprintf(fmt, argv) {
	        return sprintf.apply(null, [fmt].concat(argv || []))
	    }
	
	    function sprintf_format(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
	        for (i = 0; i < tree_length; i++) {
	            if (typeof parse_tree[i] === 'string') {
	                output += parse_tree[i]
	            }
	            else if (typeof parse_tree[i] === 'object') {
	                ph = parse_tree[i] // convenience purposes only
	                if (ph.keys) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < ph.keys.length; k++) {
	                        if (arg == undefined) {
	                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
	                        }
	                        arg = arg[ph.keys[k]]
	                    }
	                }
	                else if (ph.param_no) { // positional argument (explicit)
	                    arg = argv[ph.param_no]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
	                    arg = arg()
	                }
	
	                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
	                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
	                }
	
	                if (re.number.test(ph.type)) {
	                    is_positive = arg >= 0
	                }
	
	                switch (ph.type) {
	                    case 'b':
	                        arg = parseInt(arg, 10).toString(2)
	                        break
	                    case 'c':
	                        arg = String.fromCharCode(parseInt(arg, 10))
	                        break
	                    case 'd':
	                    case 'i':
	                        arg = parseInt(arg, 10)
	                        break
	                    case 'j':
	                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
	                        break
	                    case 'e':
	                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
	                        break
	                    case 'f':
	                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
	                        break
	                    case 'g':
	                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
	                        break
	                    case 'o':
	                        arg = (parseInt(arg, 10) >>> 0).toString(8)
	                        break
	                    case 's':
	                        arg = String(arg)
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 't':
	                        arg = String(!!arg)
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'T':
	                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'u':
	                        arg = parseInt(arg, 10) >>> 0
	                        break
	                    case 'v':
	                        arg = arg.valueOf()
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'x':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16)
	                        break
	                    case 'X':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
	                        break
	                }
	                if (re.json.test(ph.type)) {
	                    output += arg
	                }
	                else {
	                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
	                        sign = is_positive ? '+' : '-'
	                        arg = arg.toString().replace(re.sign, '')
	                    }
	                    else {
	                        sign = ''
	                    }
	                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
	                    pad_length = ph.width - (sign + arg).length
	                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
	                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output
	    }
	
	    var sprintf_cache = Object.create(null)
	
	    function sprintf_parse(fmt) {
	        if (sprintf_cache[fmt]) {
	            return sprintf_cache[fmt]
	        }
	
	        var _fmt = fmt, match, parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree.push(match[0])
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree.push('%')
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list.push(field_match[1])
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else {
	                                throw new SyntaxError('[sprintf] failed to parse named argument key')
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError('[sprintf] failed to parse named argument key')
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
	                }
	
	                parse_tree.push(
	                    {
	                        placeholder: match[0],
	                        param_no:    match[1],
	                        keys:        match[2],
	                        sign:        match[3],
	                        pad_char:    match[4],
	                        align:       match[5],
	                        width:       match[6],
	                        precision:   match[7],
	                        type:        match[8]
	                    }
	                )
	            }
	            else {
	                throw new SyntaxError('[sprintf] unexpected placeholder')
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return sprintf_cache[fmt] = parse_tree
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    /* eslint-disable quote-props */
	    if (typeof exports !== 'undefined') {
	        exports['sprintf'] = sprintf
	        exports['vsprintf'] = vsprintf
	    }
	    if (typeof window !== 'undefined') {
	        window['sprintf'] = sprintf
	        window['vsprintf'] = vsprintf
	
	        if (typeof define === 'function' && define['amd']) {
	            define(function() {
	                return {
	                    'sprintf': sprintf,
	                    'vsprintf': vsprintf
	                }
	            })
	        }
	    }
	    /* eslint-enable quote-props */
	}(); // eslint-disable-line
	
	},{}],527:[function(_dereq_,module,exports){
	'use strict'
	
	var paren = _dereq_('parenthesis')
	
	module.exports = function splitBy (string, separator, o) {
		if (string == null) throw Error('First argument should be a string')
		if (separator == null) throw Error('Separator should be a string or a RegExp')
	
		if (!o) o = {}
		else if (typeof o === 'string' || Array.isArray(o)) {
			o = {ignore: o}
		}
	
		if (o.escape == null) o.escape = true
		if (o.ignore == null) o.ignore = ['[]', '()', '{}', '<>', '""', "''", '``', '“”', '«»']
		else {
			if (typeof o.ignore === 'string') {o.ignore = [o.ignore]}
	
			o.ignore = o.ignore.map(function (pair) {
				// '"' → '""'
				if (pair.length === 1) pair = pair + pair
				return pair
			})
		}
	
		var tokens = paren.parse(string, {flat: true, brackets: o.ignore})
		var str = tokens[0]
	
		var parts = str.split(separator)
	
		// join parts separated by escape
		if (o.escape) {
			var cleanParts = []
			for (var i = 0; i < parts.length; i++) {
				var prev = parts[i]
				var part = parts[i + 1]
	
				if (prev[prev.length - 1] === '\\' && prev[prev.length - 2] !== '\\') {
					cleanParts.push(prev + separator + part)
					i++
				}
				else {
					cleanParts.push(prev)
				}
			}
			parts = cleanParts
		}
	
		// open parens pack & apply unquotes, if any
		for (var i = 0; i < parts.length; i++) {
			tokens[0] = parts[i]
			parts[i] = paren.stringify(tokens, {flat: true})
		}
	
		return parts
	}
	
	},{"parenthesis":459}],528:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = stronglyConnectedComponents
	
	function stronglyConnectedComponents(adjList) {
	  var numVertices = adjList.length;
	  var index = new Array(numVertices)
	  var lowValue = new Array(numVertices)
	  var active = new Array(numVertices)
	  var child = new Array(numVertices)
	  var scc = new Array(numVertices)
	  var sccLinks = new Array(numVertices)
	  
	  //Initialize tables
	  for(var i=0; i<numVertices; ++i) {
	    index[i] = -1
	    lowValue[i] = 0
	    active[i] = false
	    child[i] = 0
	    scc[i] = -1
	    sccLinks[i] = []
	  }
	
	  // The strongConnect function
	  var count = 0
	  var components = []
	  var sccAdjList = []
	
	  function strongConnect(v) {
	    // To avoid running out of stack space, this emulates the recursive behaviour of the normal algorithm, effectively using T as the call stack.
	    var S = [v], T = [v]
	    index[v] = lowValue[v] = count
	    active[v] = true
	    count += 1
	    while(T.length > 0) {
	      v = T[T.length-1]
	      var e = adjList[v]
	      if (child[v] < e.length) { // If we're not done iterating over the children, first try finishing that.
	        for(var i=child[v]; i<e.length; ++i) { // Start where we left off.
	          var u = e[i]
	          if(index[u] < 0) {
	            index[u] = lowValue[u] = count
	            active[u] = true
	            count += 1
	            S.push(u)
	            T.push(u)
	            break // First recurse, then continue here (with the same child!).
	            // There is a slight change to Tarjan's algorithm here.
	            // Normally, after having recursed, we set lowValue like we do for an active child (although some variants of the algorithm do it slightly differently).
	            // Here, we only do so if the child we recursed on is still active.
	            // The reasoning is that if it is no longer active, it must have had a lowValue equal to its own index, which means that it is necessarily higher than our lowValue.
	          } else if (active[u]) {
	            lowValue[v] = Math.min(lowValue[v], lowValue[u])|0
	          }
	          if (scc[u] >= 0) {
	            // Node v is not yet assigned an scc, but once it is that scc can apparently reach scc[u].
	            sccLinks[v].push(scc[u])
	          }
	        }
	        child[v] = i // Remember where we left off.
	      } else { // If we're done iterating over the children, check whether we have an scc.
	        if(lowValue[v] === index[v]) { // TODO: It /might/ be true that T is always a prefix of S (at this point!!!), and if so, this could be used here.
	          var component = []
	          var links = [], linkCount = 0
	          for(var i=S.length-1; i>=0; --i) {
	            var w = S[i]
	            active[w] = false
	            component.push(w)
	            links.push(sccLinks[w])
	            linkCount += sccLinks[w].length
	            scc[w] = components.length
	            if(w === v) {
	              S.length = i
	              break
	            }
	          }
	          components.push(component)
	          var allLinks = new Array(linkCount)
	          for(var i=0; i<links.length; i++) {
	            for(var j=0; j<links[i].length; j++) {
	              allLinks[--linkCount] = links[i][j]
	            }
	          }
	          sccAdjList.push(allLinks)
	        }
	        T.pop() // Now we're finished exploring this particular node (normally corresponds to the return statement)
	      }
	    }
	  }
	
	  //Run strong connect starting from each vertex
	  for(var i=0; i<numVertices; ++i) {
	    if(index[i] < 0) {
	      strongConnect(i)
	    }
	  }
	  
	  // Compact sccAdjList
	  var newE
	  for(var i=0; i<sccAdjList.length; i++) {
	    var e = sccAdjList[i]
	    if (e.length === 0) continue
	    e.sort(function (a,b) { return a-b; })
	    newE = [e[0]]
	    for(var j=1; j<e.length; j++) {
	      if (e[j] !== e[j-1]) {
	        newE.push(e[j])
	      }
	    }
	    sccAdjList[i] = newE
	  }  
	
	  return {components: components, adjacencyList: sccAdjList}
	}
	
	},{}],529:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = surfaceNets
	
	var generateContourExtractor = _dereq_("ndarray-extract-contour")
	var triangulateCube = _dereq_("triangulate-hypercube")
	var zeroCrossings = _dereq_("zero-crossings")
	
	function buildSurfaceNets(order, dtype) {
	  var dimension = order.length
	  var code = ["'use strict';"]
	  var funcName = "surfaceNets" + order.join("_") + "d" + dtype
	
	  //Contour extraction function
	  code.push(
	    "var contour=genContour({",
	      "order:[", order.join(), "],",
	      "scalarArguments: 3,",
	      "phase:function phaseFunc(p,a,b,c) { return (p > c)|0 },")
	  if(dtype === "generic") {
	    code.push("getters:[0],")
	  }
	
	  //Generate vertex function
	  var cubeArgs = []
	  var extraArgs = []
	  for(var i=0; i<dimension; ++i) {
	    cubeArgs.push("d" + i)
	    extraArgs.push("d" + i)
	  }
	  for(var i=0; i<(1<<dimension); ++i) {
	    cubeArgs.push("v" + i)
	    extraArgs.push("v" + i)
	  }
	  for(var i=0; i<(1<<dimension); ++i) {
	    cubeArgs.push("p" + i)
	    extraArgs.push("p" + i)
	  }
	  cubeArgs.push("a", "b", "c")
	  extraArgs.push("a", "c")
	  code.push("vertex:function vertexFunc(", cubeArgs.join(), "){")
	  //Mask args together
	  var maskStr = []
	  for(var i=0; i<(1<<dimension); ++i) {
	    maskStr.push("(p" + i + "<<" + i + ")")
	  }
	  //Generate variables and giganto switch statement
	  code.push("var m=(", maskStr.join("+"), ")|0;if(m===0||m===", (1<<(1<<dimension))-1, "){return}")
	  var extraFuncs = []
	  var currentFunc = []
	  if(1<<(1<<dimension) <= 128) {
	    code.push("switch(m){")
	    currentFunc = code
	  } else {
	    code.push("switch(m>>>7){")
	  }
	  for(var i=0; i<1<<(1<<dimension); ++i) {
	    if(1<<(1<<dimension) > 128) {
	      if((i%128)===0) {
	        if(extraFuncs.length > 0) {
	          currentFunc.push("}}")
	        }
	        var efName = "vExtra" + extraFuncs.length
	        code.push("case ", (i>>>7), ":", efName, "(m&0x7f,", extraArgs.join(), ");break;")
	        currentFunc = [
	          "function ", efName, "(m,", extraArgs.join(), "){switch(m){"
	        ]
	        extraFuncs.push(currentFunc)
	      }  
	    }
	    currentFunc.push("case ", (i&0x7f), ":")
	    var crossings = new Array(dimension)
	    var denoms = new Array(dimension)
	    var crossingCount = new Array(dimension)
	    var bias = new Array(dimension)
	    var totalCrossings = 0
	    for(var j=0; j<dimension; ++j) {
	      crossings[j] = []
	      denoms[j] = []
	      crossingCount[j] = 0
	      bias[j] = 0
	    }
	    for(var j=0; j<(1<<dimension); ++j) {
	      for(var k=0; k<dimension; ++k) {
	        var u = j ^ (1<<k)
	        if(u > j) {
	          continue
	        }
	        if(!(i&(1<<u)) !== !(i&(1<<j))) {
	          var sign = 1
	          if(i&(1<<u)) {
	            denoms[k].push("v" + u + "-v" + j)
	          } else {
	            denoms[k].push("v" + j + "-v" + u)
	            sign = -sign
	          }
	          if(sign < 0) {
	            crossings[k].push("-v" + j + "-v" + u)
	            crossingCount[k] += 2
	          } else {
	            crossings[k].push("v" + j + "+v" + u)
	            crossingCount[k] -= 2            
	          }
	          totalCrossings += 1
	          for(var l=0; l<dimension; ++l) {
	            if(l === k) {
	              continue
	            }
	            if(u&(1<<l)) {
	              bias[l] += 1
	            } else {
	              bias[l] -= 1
	            }
	          }
	        }
	      }
	    }
	    var vertexStr = []
	    for(var k=0; k<dimension; ++k) {
	      if(crossings[k].length === 0) {
	        vertexStr.push("d" + k + "-0.5")
	      } else {
	        var cStr = ""
	        if(crossingCount[k] < 0) {
	          cStr = crossingCount[k] + "*c"
	        } else if(crossingCount[k] > 0) {
	          cStr = "+" + crossingCount[k] + "*c"
	        }
	        var weight = 0.5 * (crossings[k].length / totalCrossings)
	        var shift = 0.5 + 0.5 * (bias[k] / totalCrossings)
	        vertexStr.push("d" + k + "-" + shift + "-" + weight + "*(" + crossings[k].join("+") + cStr + ")/(" + denoms[k].join("+") + ")")
	        
	      }
	    }
	    currentFunc.push("a.push([", vertexStr.join(), "]);",
	      "break;")
	  }
	  code.push("}},")
	  if(extraFuncs.length > 0) {
	    currentFunc.push("}}")
	  }
	
	  //Create face function
	  var faceArgs = []
	  for(var i=0; i<(1<<(dimension-1)); ++i) {
	    faceArgs.push("v" + i)
	  }
	  faceArgs.push("c0", "c1", "p0", "p1", "a", "b", "c")
	  code.push("cell:function cellFunc(", faceArgs.join(), "){")
	
	  var facets = triangulateCube(dimension-1)
	  code.push("if(p0){b.push(",
	    facets.map(function(f) {
	      return "[" + f.map(function(v) {
	        return "v" + v
	      }) + "]"
	    }).join(), ")}else{b.push(",
	    facets.map(function(f) {
	      var e = f.slice()
	      e.reverse()
	      return "[" + e.map(function(v) {
	        return "v" + v
	      }) + "]"
	    }).join(),
	    ")}}});function ", funcName, "(array,level){var verts=[],cells=[];contour(array,verts,cells,level);return {positions:verts,cells:cells};} return ", funcName, ";")
	
	  for(var i=0; i<extraFuncs.length; ++i) {
	    code.push(extraFuncs[i].join(""))
	  }
	
	  //Compile and link
	  var proc = new Function("genContour", code.join(""))
	  return proc(generateContourExtractor)
	}
	
	//1D case: Need to handle specially
	function mesh1D(array, level) {
	  var zc = zeroCrossings(array, level)
	  var n = zc.length
	  var npos = new Array(n)
	  var ncel = new Array(n)
	  for(var i=0; i<n; ++i) {
	    npos[i] = [ zc[i] ]
	    ncel[i] = [ i ]
	  }
	  return {
	    positions: npos,
	    cells: ncel
	  }
	}
	
	var CACHE = {}
	
	function surfaceNets(array,level) {
	  if(array.dimension <= 0) {
	    return { positions: [], cells: [] }
	  } else if(array.dimension === 1) {
	    return mesh1D(array, level)
	  }
	  var typesig = array.order.join() + "-" + array.dtype
	  var proc = CACHE[typesig]
	  var level = (+level) || 0.0
	  if(!proc) {
	    proc = CACHE[typesig] = buildSurfaceNets(array.order, array.dtype)
	  }
	  return proc(array,level)
	}
	},{"ndarray-extract-contour":440,"triangulate-hypercube":539,"zero-crossings":572}],530:[function(_dereq_,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var TAU = Math.PI * 2;
	
	var mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
	  var x = _ref.x,
	      y = _ref.y;
	
	  x *= rx;
	  y *= ry;
	
	  var xp = cosphi * x - sinphi * y;
	  var yp = sinphi * x + cosphi * y;
	
	  return {
	    x: xp + centerx,
	    y: yp + centery
	  };
	};
	
	var approxUnitArc = function approxUnitArc(ang1, ang2) {
	  // See http://spencermortensen.com/articles/bezier-circle/ for the derivation
	  // of this constant.
	  // Note: We need to keep the sign of ang2, because this determines the
	  //       direction of the arc using the sweep-flag parameter.
	  var c = 0.551915024494 * (ang2 < 0 ? -1 : 1);
	
	  var x1 = Math.cos(ang1);
	  var y1 = Math.sin(ang1);
	  var x2 = Math.cos(ang1 + ang2);
	  var y2 = Math.sin(ang1 + ang2);
	
	  return [{
	    x: x1 - y1 * c,
	    y: y1 + x1 * c
	  }, {
	    x: x2 + y2 * c,
	    y: y2 - x2 * c
	  }, {
	    x: x2,
	    y: y2
	  }];
	};
	
	var vectorAngle = function vectorAngle(ux, uy, vx, vy) {
	  var sign = ux * vy - uy * vx < 0 ? -1 : 1;
	  var umag = Math.sqrt(ux * ux + uy * uy);
	  var vmag = Math.sqrt(ux * ux + uy * uy);
	  var dot = ux * vx + uy * vy;
	
	  var div = dot / (umag * vmag);
	
	  if (div > 1) {
	    div = 1;
	  }
	
	  if (div < -1) {
	    div = -1;
	  }
	
	  return sign * Math.acos(div);
	};
	
	var getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
	  var rxsq = Math.pow(rx, 2);
	  var rysq = Math.pow(ry, 2);
	  var pxpsq = Math.pow(pxp, 2);
	  var pypsq = Math.pow(pyp, 2);
	
	  var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
	
	  if (radicant < 0) {
	    radicant = 0;
	  }
	
	  radicant /= rxsq * pypsq + rysq * pxpsq;
	  radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
	
	  var centerxp = radicant * rx / ry * pyp;
	  var centeryp = radicant * -ry / rx * pxp;
	
	  var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
	  var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
	
	  var vx1 = (pxp - centerxp) / rx;
	  var vy1 = (pyp - centeryp) / ry;
	  var vx2 = (-pxp - centerxp) / rx;
	  var vy2 = (-pyp - centeryp) / ry;
	
	  var ang1 = vectorAngle(1, 0, vx1, vy1);
	  var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
	
	  if (sweepFlag === 0 && ang2 > 0) {
	    ang2 -= TAU;
	  }
	
	  if (sweepFlag === 1 && ang2 < 0) {
	    ang2 += TAU;
	  }
	
	  return [centerx, centery, ang1, ang2];
	};
	
	var arcToBezier = function arcToBezier(_ref2) {
	  var px = _ref2.px,
	      py = _ref2.py,
	      cx = _ref2.cx,
	      cy = _ref2.cy,
	      rx = _ref2.rx,
	      ry = _ref2.ry,
	      _ref2$xAxisRotation = _ref2.xAxisRotation,
	      xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation,
	      _ref2$largeArcFlag = _ref2.largeArcFlag,
	      largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag,
	      _ref2$sweepFlag = _ref2.sweepFlag,
	      sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
	
	  var curves = [];
	
	  if (rx === 0 || ry === 0) {
	    return [];
	  }
	
	  var sinphi = Math.sin(xAxisRotation * TAU / 360);
	  var cosphi = Math.cos(xAxisRotation * TAU / 360);
	
	  var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
	  var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
	
	  if (pxp === 0 && pyp === 0) {
	    return [];
	  }
	
	  rx = Math.abs(rx);
	  ry = Math.abs(ry);
	
	  var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
	
	  if (lambda > 1) {
	    rx *= Math.sqrt(lambda);
	    ry *= Math.sqrt(lambda);
	  }
	
	  var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp),
	      _getArcCenter2 = _slicedToArray(_getArcCenter, 4),
	      centerx = _getArcCenter2[0],
	      centery = _getArcCenter2[1],
	      ang1 = _getArcCenter2[2],
	      ang2 = _getArcCenter2[3];
	
	  // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
	  // 1.0000000001. This causes `segments` to be greater than one, which is an
	  // unecessary split, and adds extra points to the bezier curve. To alleviate
	  // this issue, we round to 1.0 when the ratio is close to 1.0.
	
	
	  var ratio = Math.abs(ang2) / (TAU / 4);
	  if (Math.abs(1.0 - ratio) < 0.0000001) {
	    ratio = 1.0;
	  }
	
	  var segments = Math.max(Math.ceil(ratio), 1);
	
	  ang2 /= segments;
	
	  for (var i = 0; i < segments; i++) {
	    curves.push(approxUnitArc(ang1, ang2));
	    ang1 += ang2;
	  }
	
	  return curves.map(function (curve) {
	    var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery),
	        x1 = _mapToEllipse.x,
	        y1 = _mapToEllipse.y;
	
	    var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery),
	        x2 = _mapToEllipse2.x,
	        y2 = _mapToEllipse2.y;
	
	    var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery),
	        x = _mapToEllipse3.x,
	        y = _mapToEllipse3.y;
	
	    return { x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y };
	  });
	};
	
	exports.default = arcToBezier;
	module.exports = exports.default;
	},{}],531:[function(_dereq_,module,exports){
	'use strict'
	
	var parse = _dereq_('parse-svg-path')
	var abs = _dereq_('abs-svg-path')
	var normalize = _dereq_('normalize-svg-path')
	var isSvgPath = _dereq_('is-svg-path')
	var assert = _dereq_('assert')
	
	module.exports = pathBounds
	
	
	function pathBounds(path) {
	  // ES6 string tpl call
	  if (Array.isArray(path) && path.length === 1 && typeof path[0] === 'string') path = path[0]
	
	  // svg path string
	  if (typeof path === 'string') {
	    assert(isSvgPath(path), 'String is not an SVG path.')
	    path = parse(path)
	  }
	
	  assert(Array.isArray(path), 'Argument should be a string or an array of path segments.')
	
	  path = abs(path)
	  path = normalize(path)
	
	  if (!path.length) return [0, 0, 0, 0]
	
	  var bounds = [Infinity, Infinity, -Infinity, -Infinity]
	
	  for (var i = 0, l = path.length; i < l; i++) {
	    var points = path[i].slice(1)
	
	    for (var j = 0; j < points.length; j += 2) {
	      if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0]
	      if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1]
	      if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0]
	      if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1]
	    }
	  }
	
	  return bounds
	}
	
	},{"abs-svg-path":62,"assert":69,"is-svg-path":425,"normalize-svg-path":532,"parse-svg-path":461}],532:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = normalize
	
	var arcToCurve = _dereq_('svg-arc-to-cubic-bezier')
	
	function normalize(path){
	  // init state
	  var prev
	  var result = []
	  var bezierX = 0
	  var bezierY = 0
	  var startX = 0
	  var startY = 0
	  var quadX = null
	  var quadY = null
	  var x = 0
	  var y = 0
	
	  for (var i = 0, len = path.length; i < len; i++) {
	    var seg = path[i]
	    var command = seg[0]
	
	    switch (command) {
	      case 'M':
	        startX = seg[1]
	        startY = seg[2]
	        break
	      case 'A':
	        var curves = arcToCurve({
	          px: x,
	          py: y,
	          cx: seg[6],
	          cy:  seg[7],
	          rx: seg[1],
	          ry: seg[2],
	          xAxisRotation: seg[3],
	          largeArcFlag: seg[4],
	          sweepFlag: seg[5]
	        })
	
	        // null-curves
	        if (!curves.length) continue
	
	        for (var j = 0, c; j < curves.length; j++) {
	          c = curves[j]
	          seg = ['C', c.x1, c.y1, c.x2, c.y2, c.x, c.y]
	          if (j < curves.length - 1) result.push(seg)
	        }
	
	        break
	      case 'S':
	        // default control point
	        var cx = x
	        var cy = y
	        if (prev == 'C' || prev == 'S') {
	          cx += cx - bezierX // reflect the previous command's control
	          cy += cy - bezierY // point relative to the current point
	        }
	        seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
	        break
	      case 'T':
	        if (prev == 'Q' || prev == 'T') {
	          quadX = x * 2 - quadX // as with 'S' reflect previous control point
	          quadY = y * 2 - quadY
	        } else {
	          quadX = x
	          quadY = y
	        }
	        seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
	        break
	      case 'Q':
	        quadX = seg[1]
	        quadY = seg[2]
	        seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
	        break
	      case 'L':
	        seg = line(x, y, seg[1], seg[2])
	        break
	      case 'H':
	        seg = line(x, y, seg[1], y)
	        break
	      case 'V':
	        seg = line(x, y, x, seg[1])
	        break
	      case 'Z':
	        seg = line(x, y, startX, startY)
	        break
	    }
	
	    // update state
	    prev = command
	    x = seg[seg.length - 2]
	    y = seg[seg.length - 1]
	    if (seg.length > 4) {
	      bezierX = seg[seg.length - 4]
	      bezierY = seg[seg.length - 3]
	    } else {
	      bezierX = x
	      bezierY = y
	    }
	    result.push(seg)
	  }
	
	  return result
	}
	
	function line(x1, y1, x2, y2){
	  return ['C', x1, y1, x2, y2, x2, y2]
	}
	
	function quadratic(x1, y1, cx, cy, x2, y2){
	  return [
	    'C',
	    x1/3 + (2/3) * cx,
	    y1/3 + (2/3) * cy,
	    x2/3 + (2/3) * cx,
	    y2/3 + (2/3) * cy,
	    x2,
	    y2
	  ]
	}
	
	},{"svg-arc-to-cubic-bezier":530}],533:[function(_dereq_,module,exports){
	'use strict'
	
	var pathBounds = _dereq_('svg-path-bounds')
	var parsePath = _dereq_('parse-svg-path')
	var drawPath = _dereq_('draw-svg-path')
	var isSvgPath = _dereq_('is-svg-path')
	var bitmapSdf = _dereq_('bitmap-sdf')
	
	var canvas = document.createElement('canvas')
	var ctx = canvas.getContext('2d')
	
	
	module.exports = pathSdf
	
	
	function pathSdf (path, options) {
		if (!isSvgPath(path)) throw Error('Argument should be valid svg path string')
	
		if (!options) options = {}
	
		var w, h
		if (options.shape) {
			w = options.shape[0]
			h = options.shape[1]
		}
		else {
			w = canvas.width = options.w || options.width || 200
			h = canvas.height = options.h || options.height || 200
		}
		var size = Math.min(w, h)
	
		var stroke = options.stroke || 0
	
		var viewbox = options.viewbox || options.viewBox || pathBounds(path)
		var scale = [w / (viewbox[2] - viewbox[0]), h / (viewbox[3] - viewbox[1])]
		var maxScale = Math.min(scale[0] || 0, scale[1] || 0) / 2
	
		//clear ctx
		ctx.fillStyle = 'black'
		ctx.fillRect(0, 0, w, h)
	
		ctx.fillStyle = 'white'
	
		if (stroke)	{
			if (typeof stroke != 'number') stroke = 1
			if (stroke > 0) {
				ctx.strokeStyle = 'white'
			}
			else {
				ctx.strokeStyle = 'black'
			}
	
			ctx.lineWidth = Math.abs(stroke)
		}
	
		ctx.translate(w * .5, h * .5)
		ctx.scale(maxScale, maxScale)
	
		//if canvas svg paths api is available
		if (isPath2DSupported()) {
			var path2d = new Path2D(path)
			ctx.fill(path2d)
			stroke && ctx.stroke(path2d)
		}
		//fallback to bezier-curves
		else {
			var segments = parsePath(path)
			drawPath(ctx, segments)
			ctx.fill()
			stroke && ctx.stroke()
		}
	
		ctx.setTransform(1, 0, 0, 1, 0, 0);
	
		var data = bitmapSdf(ctx, {
			cutoff: options.cutoff != null ? options.cutoff : .5,
			radius: options.radius != null ? options.radius : size * .5
		})
	
		return data
	}
	
	var path2DSupported
	
	function isPath2DSupported () {
		if (path2DSupported != null) return path2DSupported
	
		var ctx = document.createElement('canvas').getContext('2d')
		ctx.canvas.width = ctx.canvas.height = 1
	
		if (!window.Path2D) return path2DSupported = false
	
		var path = new Path2D('M0,0h1v1h-1v-1Z')
	
		ctx.fillStyle = 'black'
		ctx.fill(path)
	
		var idata = ctx.getImageData(0,0,1,1)
	
		return path2DSupported = idata && idata.data && idata.data[3] === 255
	}
	
	},{"bitmap-sdf":94,"draw-svg-path":169,"is-svg-path":425,"parse-svg-path":461,"svg-path-bounds":531}],534:[function(_dereq_,module,exports){
	(function (process){
	'use strict'
	
	module.exports = textGet
	
	var vectorizeText = _dereq_('vectorize-text')
	
	var globals = window || process.global || {}
	var __TEXT_CACHE  = globals.__TEXT_CACHE || {}
	globals.__TEXT_CACHE = {}
	
	function unwrap(mesh) {
	  var cells     = mesh.cells
	  var positions = mesh.positions
	  var data      = new Float32Array(cells.length * 6)
	  var ptr       = 0
	  var shapeX    = 0
	  for(var i=0; i<cells.length; ++i) {
	    var tri = cells[i]
	    for(var j=0; j<3; ++j) {
	      var point = positions[tri[j]]
	      data[ptr++] = point[0]
	      data[ptr++] = point[1] + 1.4
	      shapeX      = Math.max(point[0], shapeX)
	    }
	  }
	  return {
	    data:  data,
	    shape: shapeX
	  }
	}
	
	function textGet(font, text, opts) {
	  var opts = opts || {}
	  var fontcache = __TEXT_CACHE[font]
	  if(!fontcache) {
	    fontcache = __TEXT_CACHE[font] = {
	      ' ': {
	        data:   new Float32Array(0),
	        shape: 0.2
	      }
	    }
	  }
	  var mesh = fontcache[text]
	  if(!mesh) {
	    if(text.length <= 1 || !/\d/.test(text)) {
	      mesh = fontcache[text] = unwrap(vectorizeText(text, {
	        triangles:     true,
	        font:          font,
	        textAlign:     opts.textAlign || 'left',
	        textBaseline:  'alphabetic',
	        styletags: {
	            breaklines: true,
	                 bolds: true,
	               italics: true,
	            subscripts: true,
	          superscripts: true
	        }
	      }))
	    } else {
	      var parts = text.split(/(\d|\s)/)
	      var buffer = new Array(parts.length)
	      var bufferSize = 0
	      var shapeX = 0
	      for(var i=0; i<parts.length; ++i) {
	        buffer[i] = textGet(font, parts[i])
	        bufferSize += buffer[i].data.length
	        shapeX += buffer[i].shape
	        if(i>0) {
	          shapeX += 0.02
	        }
	      }
	
	      var data = new Float32Array(bufferSize)
	      var ptr     = 0
	      var xOffset = -0.5 * shapeX
	      for(var i=0; i<buffer.length; ++i) {
	        var bdata = buffer[i].data
	        for(var j=0; j<bdata.length; j+=2) {
	          data[ptr++] = bdata[j] + xOffset
	          data[ptr++] = bdata[j+1]
	        }
	        xOffset += buffer[i].shape + 0.02
	      }
	
	      mesh = fontcache[text] = {
	        data:  data,
	        shape: shapeX
	      }
	    }
	  }
	
	   return mesh
	}
	
	}).call(this,_dereq_('_process'))
	},{"_process":483,"vectorize-text":548}],535:[function(_dereq_,module,exports){
	// TinyColor v1.4.1
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (typeof define === 'function' && define.amd) {
	    define(function () {return tinycolor;});
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);
	
	},{}],536:[function(_dereq_,module,exports){
	/* @module to-float32 */
	
	'use strict'
	
	module.exports = float32
	module.exports.float32 =
	module.exports.float = float32
	module.exports.fract32 =
	module.exports.fract = fract32
	
	var narr = new Float32Array(1)
	
	// return fractional part of float32 array
	function fract32 (arr) {
		if (arr.length) {
			var fract = float32(arr)
			for (var i = 0, l = fract.length; i < l; i++) {
				fract[i] = arr[i] - fract[i]
			}
			return fract
		}
	
		// number
		return float32(arr - float32(arr))
	}
	
	// make sure data is float32 array
	function float32 (arr) {
		if (arr.length) {
			if (arr instanceof Float32Array) return arr
			var float = new Float32Array(arr)
			float.set(arr)
			return float
		}
	
		// number
		narr[0] = arr
		return narr[0]
	}
	
	},{}],537:[function(_dereq_,module,exports){
	'use strict'
	
	var parseUnit = _dereq_('parse-unit')
	
	module.exports = toPX
	
	var PIXELS_PER_INCH = 96
	
	function getPropertyInPX(element, prop) {
	  var parts = parseUnit(getComputedStyle(element).getPropertyValue(prop))
	  return parts[0] * toPX(parts[1], element)
	}
	
	//This brutal hack is needed
	function getSizeBrutal(unit, element) {
	  var testDIV = document.createElement('div')
	  testDIV.style['font-size'] = '128' + unit
	  element.appendChild(testDIV)
	  var size = getPropertyInPX(testDIV, 'font-size') / 128
	  element.removeChild(testDIV)
	  return size
	}
	
	function toPX(str, element) {
	  element = element || document.body
	  str = (str || 'px').trim().toLowerCase()
	  if(element === window || element === document) {
	    element = document.body 
	  }
	  switch(str) {
	    case '%':  //Ambiguous, not sure if we should use width or height
	      return element.clientHeight / 100.0
	    case 'ch':
	    case 'ex':
	      return getSizeBrutal(str, element)
	    case 'em':
	      return getPropertyInPX(element, 'font-size')
	    case 'rem':
	      return getPropertyInPX(document.body, 'font-size')
	    case 'vw':
	      return window.innerWidth/100
	    case 'vh':
	      return window.innerHeight/100
	    case 'vmin':
	      return Math.min(window.innerWidth, window.innerHeight) / 100
	    case 'vmax':
	      return Math.max(window.innerWidth, window.innerHeight) / 100
	    case 'in':
	      return PIXELS_PER_INCH
	    case 'cm':
	      return PIXELS_PER_INCH / 2.54
	    case 'mm':
	      return PIXELS_PER_INCH / 25.4
	    case 'pt':
	      return PIXELS_PER_INCH / 72
	    case 'pc':
	      return PIXELS_PER_INCH / 6
	  }
	  return 1
	}
	},{"parse-unit":462}],538:[function(_dereq_,module,exports){
	// https://github.com/topojson/topojson-client Version 2.1.0. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	var identity = function(x) {
	  return x;
	};
	
	var transform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    point[0] = (x0 += point[0]) * kx + dx;
	    point[1] = (y0 += point[1]) * ky + dy;
	    return point;
	  };
	};
	
	var bbox = function(topology) {
	  var bbox = topology.bbox;
	
	  function bboxPoint(p0) {
	    p1[0] = p0[0], p1[1] = p0[1], t(p1);
	    if (p1[0] < x0) x0 = p1[0];
	    if (p1[0] > x1) x1 = p1[0];
	    if (p1[1] < y0) y0 = p1[1];
	    if (p1[1] > y1) y1 = p1[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  if (!bbox) {
	    var t = transform(topology), p0, p1 = new Array(2), name,
	        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	    topology.arcs.forEach(function(arc) {
	      var i = -1, n = arc.length;
	      while (++i < n) {
	        p0 = arc[i], p1[0] = p0[0], p1[1] = p0[1], t(p1, i);
	        if (p1[0] < x0) x0 = p1[0];
	        if (p1[0] > x1) x1 = p1[0];
	        if (p1[1] < y0) y0 = p1[1];
	        if (p1[1] > y1) y1 = p1[1];
	      }
	    });
	
	    for (name in topology.objects) {
	      bboxGeometry(topology.objects[name]);
	    }
	
	    bbox = topology.bbox = [x0, y0, x1, y1];
	  }
	
	  return bbox;
	};
	
	var reverse = function(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	};
	
	var feature = function(topology, o) {
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	};
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k].slice(), k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p.slice());
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0].slice());
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0].slice());
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	var stitch = function(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	};
	
	var mesh = function(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	};
	
	function meshArcs(topology, object$$1, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object$$1, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object$$1, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object$$1);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	var merge = function(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	};
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	var bisect = function(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	};
	
	var neighbors = function(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	};
	
	var quantize = function(topology, n) {
	  if (!((n = Math.floor(n)) >= 2)) throw new Error("n must be ≥2");
	  if (topology.transform) throw new Error("already quantized");
	  var bb = bbox(topology), name,
	      dx = bb[0], kx = (bb[2] - dx) / (n - 1) || 1,
	      dy = bb[1], ky = (bb[3] - dy) / (n - 1) || 1;
	
	  function quantizePoint(p) {
	    p[0] = Math.round((p[0] - dx) / kx);
	    p[1] = Math.round((p[1] - dy) / ky);
	  }
	
	  function quantizeGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
	      case "Point": quantizePoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(quantizePoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = 1,
	        j = 1,
	        n = arc.length,
	        pi = arc[0],
	        x0 = pi[0] = Math.round((pi[0] - dx) / kx),
	        y0 = pi[1] = Math.round((pi[1] - dy) / ky),
	        pj,
	        x1,
	        y1;
	
	    for (; i < n; ++i) {
	      pi = arc[i];
	      x1 = Math.round((pi[0] - dx) / kx);
	      y1 = Math.round((pi[1] - dy) / ky);
	      if (x1 !== x0 || y1 !== y0) {
	        pj = arc[j++];
	        pj[0] = x1 - x0, x0 = x1;
	        pj[1] = y1 - y0, y0 = y1;
	      }
	    }
	
	    if (j < 2) {
	      pj = arc[j++];
	      pj[0] = 0;
	      pj[1] = 0;
	    }
	
	    arc.length = j;
	  });
	
	  for (name in topology.objects) {
	    quantizeGeometry(topology.objects[name]);
	  }
	
	  topology.transform = {
	    scale: [kx, ky],
	    translate: [dx, dy]
	  };
	
	  return topology;
	};
	
	var untransform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    var x1 = Math.round((point[0] - dx) / kx),
	        y1 = Math.round((point[1] - dy) / ky);
	    point[0] = x1 - x0, x0 = x1;
	    point[1] = y1 - y0, y0 = y1;
	    return point;
	  };
	};
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	},{}],539:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = triangulateCube
	
	var perm = _dereq_("permutation-rank")
	var sgn = _dereq_("permutation-parity")
	var gamma = _dereq_("gamma")
	
	function triangulateCube(dimension) {
	  if(dimension < 0) {
	    return [ ]
	  }
	  if(dimension === 0) {
	    return [ [0] ]
	  }
	  var dfactorial = Math.round(gamma(dimension+1))|0
	  var result = []
	  for(var i=0; i<dfactorial; ++i) {
	    var p = perm.unrank(dimension, i)
	    var cell = [ 0 ]
	    var v = 0
	    for(var j=0; j<p.length; ++j) {
	      v += (1<<p[j])
	      cell.push(v)
	    }
	    if(sgn(p) < 1) {
	      cell[0] = v
	      cell[dimension] = 0
	    }
	    result.push(cell)
	  }
	  return result
	}
	},{"gamma":233,"permutation-parity":464,"permutation-rank":465}],540:[function(_dereq_,module,exports){
	'use strict'
	
	module.exports = createTurntableController
	
	var filterVector = _dereq_('filtered-vector')
	var invert44     = _dereq_('gl-mat4/invert')
	var rotateM      = _dereq_('gl-mat4/rotate')
	var cross        = _dereq_('gl-vec3/cross')
	var normalize3   = _dereq_('gl-vec3/normalize')
	var dot3         = _dereq_('gl-vec3/dot')
	
	function len3(x, y, z) {
	  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2))
	}
	
	function clamp1(x) {
	  return Math.min(1.0, Math.max(-1.0, x))
	}
	
	function findOrthoPair(v) {
	  var vx = Math.abs(v[0])
	  var vy = Math.abs(v[1])
	  var vz = Math.abs(v[2])
	
	  var u = [0,0,0]
	  if(vx > Math.max(vy, vz)) {
	    u[2] = 1
	  } else if(vy > Math.max(vx, vz)) {
	    u[0] = 1
	  } else {
	    u[1] = 1
	  }
	
	  var vv = 0
	  var uv = 0
	  for(var i=0; i<3; ++i ) {
	    vv += v[i] * v[i]
	    uv += u[i] * v[i]
	  }
	  for(var i=0; i<3; ++i) {
	    u[i] -= (uv / vv) *  v[i]
	  }
	  normalize3(u, u)
	  return u
	}
	
	function TurntableController(zoomMin, zoomMax, center, up, right, radius, theta, phi) {
	  this.center = filterVector(center)
	  this.up     = filterVector(up)
	  this.right  = filterVector(right)
	  this.radius = filterVector([radius])
	  this.angle  = filterVector([theta, phi])
	  this.angle.bounds = [[-Infinity,-Math.PI/2], [Infinity,Math.PI/2]]
	  this.setDistanceLimits(zoomMin, zoomMax)
	
	  this.computedCenter = this.center.curve(0)
	  this.computedUp     = this.up.curve(0)
	  this.computedRight  = this.right.curve(0)
	  this.computedRadius = this.radius.curve(0)
	  this.computedAngle  = this.angle.curve(0)
	  this.computedToward = [0,0,0]
	  this.computedEye    = [0,0,0]
	  this.computedMatrix = new Array(16)
	  for(var i=0; i<16; ++i) {
	    this.computedMatrix[i] = 0.5
	  }
	
	  this.recalcMatrix(0)
	}
	
	var proto = TurntableController.prototype
	
	proto.setDistanceLimits = function(minDist, maxDist) {
	  if(minDist > 0) {
	    minDist = Math.log(minDist)
	  } else {
	    minDist = -Infinity
	  }
	  if(maxDist > 0) {
	    maxDist = Math.log(maxDist)
	  } else {
	    maxDist = Infinity
	  }
	  maxDist = Math.max(maxDist, minDist)
	  this.radius.bounds[0][0] = minDist
	  this.radius.bounds[1][0] = maxDist
	}
	
	proto.getDistanceLimits = function(out) {
	  var bounds = this.radius.bounds[0]
	  if(out) {
	    out[0] = Math.exp(bounds[0][0])
	    out[1] = Math.exp(bounds[1][0])
	    return out
	  }
	  return [ Math.exp(bounds[0][0]), Math.exp(bounds[1][0]) ]
	}
	
	proto.recalcMatrix = function(t) {
	  //Recompute curves
	  this.center.curve(t)
	  this.up.curve(t)
	  this.right.curve(t)
	  this.radius.curve(t)
	  this.angle.curve(t)
	
	  //Compute frame for camera matrix
	  var up     = this.computedUp
	  var right  = this.computedRight
	  var uu = 0.0
	  var ur = 0.0
	  for(var i=0; i<3; ++i) {
	    ur += up[i] * right[i]
	    uu += up[i] * up[i]
	  }
	  var ul = Math.sqrt(uu)
	  var rr = 0.0
	  for(var i=0; i<3; ++i) {
	    right[i] -= up[i] * ur / uu
	    rr       += right[i] * right[i]
	    up[i]    /= ul
	  }
	  var rl = Math.sqrt(rr)
	  for(var i=0; i<3; ++i) {
	    right[i] /= rl
	  }
	
	  //Compute toward vector
	  var toward = this.computedToward
	  cross(toward, up, right)
	  normalize3(toward, toward)
	
	  //Compute angular parameters
	  var radius = Math.exp(this.computedRadius[0])
	  var theta  = this.computedAngle[0]
	  var phi    = this.computedAngle[1]
	
	  var ctheta = Math.cos(theta)
	  var stheta = Math.sin(theta)
	  var cphi   = Math.cos(phi)
	  var sphi   = Math.sin(phi)
	
	  var center = this.computedCenter
	
	  var wx = ctheta * cphi 
	  var wy = stheta * cphi
	  var wz = sphi
	
	  var sx = -ctheta * sphi
	  var sy = -stheta * sphi
	  var sz = cphi
	
	  var eye = this.computedEye
	  var mat = this.computedMatrix
	  for(var i=0; i<3; ++i) {
	    var x      = wx * right[i] + wy * toward[i] + wz * up[i]
	    mat[4*i+1] = sx * right[i] + sy * toward[i] + sz * up[i]
	    mat[4*i+2] = x
	    mat[4*i+3] = 0.0
	  }
	
	  var ax = mat[1]
	  var ay = mat[5]
	  var az = mat[9]
	  var bx = mat[2]
	  var by = mat[6]
	  var bz = mat[10]
	  var cx = ay * bz - az * by
	  var cy = az * bx - ax * bz
	  var cz = ax * by - ay * bx
	  var cl = len3(cx, cy, cz)
	  cx /= cl
	  cy /= cl
	  cz /= cl
	  mat[0] = cx
	  mat[4] = cy
	  mat[8] = cz
	
	  for(var i=0; i<3; ++i) {
	    eye[i] = center[i] + mat[2+4*i]*radius
	  }
	
	  for(var i=0; i<3; ++i) {
	    var rr = 0.0
	    for(var j=0; j<3; ++j) {
	      rr += mat[i+4*j] * eye[j]
	    }
	    mat[12+i] = -rr
	  }
	  mat[15] = 1.0
	}
	
	proto.getMatrix = function(t, result) {
	  this.recalcMatrix(t)
	  var mat = this.computedMatrix
	  if(result) {
	    for(var i=0; i<16; ++i) {
	      result[i] = mat[i]
	    }
	    return result
	  }
	  return mat
	}
	
	var zAxis = [0,0,0]
	proto.rotate = function(t, dtheta, dphi, droll) {
	  this.angle.move(t, dtheta, dphi)
	  if(droll) {
	    this.recalcMatrix(t)
	
	    var mat = this.computedMatrix
	    zAxis[0] = mat[2]
	    zAxis[1] = mat[6]
	    zAxis[2] = mat[10]
	
	    var up     = this.computedUp
	    var right  = this.computedRight
	    var toward = this.computedToward
	
	    for(var i=0; i<3; ++i) {
	      mat[4*i]   = up[i]
	      mat[4*i+1] = right[i]
	      mat[4*i+2] = toward[i]
	    }
	    rotateM(mat, mat, droll, zAxis)
	    for(var i=0; i<3; ++i) {
	      up[i] =    mat[4*i]
	      right[i] = mat[4*i+1]
	    }
	
	    this.up.set(t, up[0], up[1], up[2])
	    this.right.set(t, right[0], right[1], right[2])
	  }
	}
	
	proto.pan = function(t, dx, dy, dz) {
	  dx = dx || 0.0
	  dy = dy || 0.0
	  dz = dz || 0.0
	
	  this.recalcMatrix(t)
	  var mat = this.computedMatrix
	
	  var dist = Math.exp(this.computedRadius[0])
	
	  var ux = mat[1]
	  var uy = mat[5]
	  var uz = mat[9]
	  var ul = len3(ux, uy, uz)
	  ux /= ul
	  uy /= ul
	  uz /= ul
	
	  var rx = mat[0]
	  var ry = mat[4]
	  var rz = mat[8]
	  var ru = rx * ux + ry * uy + rz * uz
	  rx -= ux * ru
	  ry -= uy * ru
	  rz -= uz * ru
	  var rl = len3(rx, ry, rz)
	  rx /= rl
	  ry /= rl
	  rz /= rl
	
	  var vx = rx * dx + ux * dy
	  var vy = ry * dx + uy * dy
	  var vz = rz * dx + uz * dy
	  this.center.move(t, vx, vy, vz)
	
	  //Update z-component of radius
	  var radius = Math.exp(this.computedRadius[0])
	  radius = Math.max(1e-4, radius + dz)
	  this.radius.set(t, Math.log(radius))
	}
	
	proto.translate = function(t, dx, dy, dz) {
	  this.center.move(t,
	    dx||0.0,
	    dy||0.0,
	    dz||0.0)
	}
	
	//Recenters the coordinate axes
	proto.setMatrix = function(t, mat, axes, noSnap) {
	  
	  //Get the axes for tare
	  var ushift = 1
	  if(typeof axes === 'number') {
	    ushift = (axes)|0
	  } 
	  if(ushift < 0 || ushift > 3) {
	    ushift = 1
	  }
	  var vshift = (ushift + 2) % 3
	  var fshift = (ushift + 1) % 3
	
	  //Recompute state for new t value
	  if(!mat) { 
	    this.recalcMatrix(t)
	    mat = this.computedMatrix
	  }
	
	  //Get right and up vectors
	  var ux = mat[ushift]
	  var uy = mat[ushift+4]
	  var uz = mat[ushift+8]
	  if(!noSnap) {
	    var ul = len3(ux, uy, uz)
	    ux /= ul
	    uy /= ul
	    uz /= ul
	  } else {
	    var ax = Math.abs(ux)
	    var ay = Math.abs(uy)
	    var az = Math.abs(uz)
	    var am = Math.max(ax,ay,az)
	    if(ax === am) {
	      ux = (ux < 0) ? -1 : 1
	      uy = uz = 0
	    } else if(az === am) {
	      uz = (uz < 0) ? -1 : 1
	      ux = uy = 0
	    } else {
	      uy = (uy < 0) ? -1 : 1
	      ux = uz = 0
	    }
	  }
	
	  var rx = mat[vshift]
	  var ry = mat[vshift+4]
	  var rz = mat[vshift+8]
	  var ru = rx * ux + ry * uy + rz * uz
	  rx -= ux * ru
	  ry -= uy * ru
	  rz -= uz * ru
	  var rl = len3(rx, ry, rz)
	  rx /= rl
	  ry /= rl
	  rz /= rl
	  
	  var fx = uy * rz - uz * ry
	  var fy = uz * rx - ux * rz
	  var fz = ux * ry - uy * rx
	  var fl = len3(fx, fy, fz)
	  fx /= fl
	  fy /= fl
	  fz /= fl
	
	  this.center.jump(t, ex, ey, ez)
	  this.radius.idle(t)
	  this.up.jump(t, ux, uy, uz)
	  this.right.jump(t, rx, ry, rz)
	
	  var phi, theta
	  if(ushift === 2) {
	    var cx = mat[1]
	    var cy = mat[5]
	    var cz = mat[9]
	    var cr = cx * rx + cy * ry + cz * rz
	    var cf = cx * fx + cy * fy + cz * fz
	    if(tu < 0) {
	      phi = -Math.PI/2
	    } else {
	      phi = Math.PI/2
	    }
	    theta = Math.atan2(cf, cr)
	  } else {
	    var tx = mat[2]
	    var ty = mat[6]
	    var tz = mat[10]
	    var tu = tx * ux + ty * uy + tz * uz
	    var tr = tx * rx + ty * ry + tz * rz
	    var tf = tx * fx + ty * fy + tz * fz
	
	    phi = Math.asin(clamp1(tu))
	    theta = Math.atan2(tf, tr)
	  }
	
	  this.angle.jump(t, theta, phi)
	
	  this.recalcMatrix(t)
	  var dx = mat[2]
	  var dy = mat[6]
	  var dz = mat[10]
	
	  var imat = this.computedMatrix
	  invert44(imat, mat)
	  var w  = imat[15]
	  var ex = imat[12] / w
	  var ey = imat[13] / w
	  var ez = imat[14] / w
	
	  var gs = Math.exp(this.computedRadius[0])
	  this.center.jump(t, ex-dx*gs, ey-dy*gs, ez-dz*gs)
	}
	
	proto.lastT = function() {
	  return Math.max(
	    this.center.lastT(),
	    this.up.lastT(),
	    this.right.lastT(),
	    this.radius.lastT(),
	    this.angle.lastT())
	}
	
	proto.idle = function(t) {
	  this.center.idle(t)
	  this.up.idle(t)
	  this.right.idle(t)
	  this.radius.idle(t)
	  this.angle.idle(t)
	}
	
	proto.flush = function(t) {
	  this.center.flush(t)
	  this.up.flush(t)
	  this.right.flush(t)
	  this.radius.flush(t)
	  this.angle.flush(t)
	}
	
	proto.setDistance = function(t, d) {
	  if(d > 0) {
	    this.radius.set(t, Math.log(d))
	  }
	}
	
	proto.lookAt = function(t, eye, center, up) {
	  this.recalcMatrix(t)
	
	  eye    = eye    || this.computedEye
	  center = center || this.computedCenter
	  up     = up     || this.computedUp
	
	  var ux = up[0]
	  var uy = up[1]
	  var uz = up[2]
	  var ul = len3(ux, uy, uz)
	  if(ul < 1e-6) {
	    return
	  }
	  ux /= ul
	  uy /= ul
	  uz /= ul
	
	  var tx = eye[0] - center[0]
	  var ty = eye[1] - center[1]
	  var tz = eye[2] - center[2]
	  var tl = len3(tx, ty, tz)
	  if(tl < 1e-6) {
	    return
	  }
	  tx /= tl
	  ty /= tl
	  tz /= tl
	
	  var right = this.computedRight
	  var rx = right[0]
	  var ry = right[1]
	  var rz = right[2]
	  var ru = ux*rx + uy*ry + uz*rz
	  rx -= ru * ux
	  ry -= ru * uy
	  rz -= ru * uz
	  var rl = len3(rx, ry, rz)
	
	  if(rl < 0.01) {
	    rx = uy * tz - uz * ty
	    ry = uz * tx - ux * tz
	    rz = ux * ty - uy * tx
	    rl = len3(rx, ry, rz)
	    if(rl < 1e-6) {
	      return
	    }
	  }
	  rx /= rl
	  ry /= rl
	  rz /= rl
	
	  this.up.set(t, ux, uy, uz)
	  this.right.set(t, rx, ry, rz)
	  this.center.set(t, center[0], center[1], center[2])
	  this.radius.set(t, Math.log(tl))
	
	  var fx = uy * rz - uz * ry
	  var fy = uz * rx - ux * rz
	  var fz = ux * ry - uy * rx
	  var fl = len3(fx, fy, fz)
	  fx /= fl
	  fy /= fl
	  fz /= fl
	
	  var tu = ux*tx + uy*ty + uz*tz
	  var tr = rx*tx + ry*ty + rz*tz
	  var tf = fx*tx + fy*ty + fz*tz
	
	  var phi   = Math.asin(clamp1(tu))
	  var theta = Math.atan2(tf, tr)
	
	  var angleState = this.angle._state
	  var lastTheta  = angleState[angleState.length-1]
	  var lastPhi    = angleState[angleState.length-2]
	  lastTheta      = lastTheta % (2.0 * Math.PI)
	  var dp = Math.abs(lastTheta + 2.0 * Math.PI - theta)
	  var d0 = Math.abs(lastTheta - theta)
	  var dn = Math.abs(lastTheta - 2.0 * Math.PI - theta)
	  if(dp < d0) {
	    lastTheta += 2.0 * Math.PI
	  }
	  if(dn < d0) {
	    lastTheta -= 2.0 * Math.PI
	  }
	
	  this.angle.jump(this.angle.lastT(), lastTheta, lastPhi)
	  this.angle.set(t, theta, phi)
	}
	
	function createTurntableController(options) {
	  options = options || {}
	
	  var center = options.center || [0,0,0]
	  var up     = options.up     || [0,1,0]
	  var right  = options.right  || findOrthoPair(up)
	  var radius = options.radius || 1.0
	  var theta  = options.theta  || 0.0
	  var phi    = options.phi    || 0.0
	
	  center = [].slice.call(center, 0, 3)
	
	  up = [].slice.call(up, 0, 3)
	  normalize3(up, up)
	
	  right = [].slice.call(right, 0, 3)
	  normalize3(right, right)
	
	  if('eye' in options) {
	    var eye = options.eye
	    var toward = [
	      eye[0]-center[0],
	      eye[1]-center[1],
	      eye[2]-center[2]
	    ]
	    cross(right, toward, up)
	    if(len3(right[0], right[1], right[2]) < 1e-6) {
	      right = findOrthoPair(up)
	    } else {
	      normalize3(right, right)
	    }
	
	    radius = len3(toward[0], toward[1], toward[2])
	
	    var ut = dot3(up, toward) / radius
	    var rt = dot3(right, toward) / radius
	    phi    = Math.acos(ut)
	    theta  = Math.acos(rt)
	  }
	
	  //Use logarithmic coordinates for radius
	  radius = Math.log(radius)
	
	  //Return the controller
	  return new TurntableController(
	    options.zoomMin,
	    options.zoomMax,
	    center,
	    up,
	    right,
	    radius,
	    theta,
	    phi)
	}
	},{"filtered-vector":228,"gl-mat4/invert":267,"gl-mat4/rotate":272,"gl-vec3/cross":335,"gl-vec3/dot":340,"gl-vec3/normalize":357}],541:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = twoProduct
	
	var SPLITTER = +(Math.pow(2, 27) + 1.0)
	
	function twoProduct(a, b, result) {
	  var x = a * b
	
	  var c = SPLITTER * a
	  var abig = c - a
	  var ahi = c - abig
	  var alo = a - ahi
	
	  var d = SPLITTER * b
	  var bbig = d - b
	  var bhi = d - bbig
	  var blo = b - bhi
	
	  var err1 = x - (ahi * bhi)
	  var err2 = err1 - (alo * bhi)
	  var err3 = err2 - (ahi * blo)
	
	  var y = alo * blo - err3
	
	  if(result) {
	    result[0] = y
	    result[1] = x
	    return result
	  }
	
	  return [ y, x ]
	}
	},{}],542:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = fastTwoSum
	
	function fastTwoSum(a, b, result) {
		var x = a + b
		var bv = x - a
		var av = x - bv
		var br = b - bv
		var ar = a - av
		if(result) {
			result[0] = ar + br
			result[1] = x
			return result
		}
		return [ar+br, x]
	}
	},{}],543:[function(_dereq_,module,exports){
	(function (global,Buffer){
	'use strict'
	
	var bits = _dereq_('bit-twiddle')
	var dup = _dereq_('dup')
	
	//Legacy pool support
	if(!global.__TYPEDARRAY_POOL) {
	  global.__TYPEDARRAY_POOL = {
	      UINT8   : dup([32, 0])
	    , UINT16  : dup([32, 0])
	    , UINT32  : dup([32, 0])
	    , INT8    : dup([32, 0])
	    , INT16   : dup([32, 0])
	    , INT32   : dup([32, 0])
	    , FLOAT   : dup([32, 0])
	    , DOUBLE  : dup([32, 0])
	    , DATA    : dup([32, 0])
	    , UINT8C  : dup([32, 0])
	    , BUFFER  : dup([32, 0])
	  }
	}
	
	var hasUint8C = (typeof Uint8ClampedArray) !== 'undefined'
	var POOL = global.__TYPEDARRAY_POOL
	
	//Upgrade pool
	if(!POOL.UINT8C) {
	  POOL.UINT8C = dup([32, 0])
	}
	if(!POOL.BUFFER) {
	  POOL.BUFFER = dup([32, 0])
	}
	
	//New technique: Only allocate from ArrayBufferView and Buffer
	var DATA    = POOL.DATA
	  , BUFFER  = POOL.BUFFER
	
	exports.free = function free(array) {
	  if(Buffer.isBuffer(array)) {
	    BUFFER[bits.log2(array.length)].push(array)
	  } else {
	    if(Object.prototype.toString.call(array) !== '[object ArrayBuffer]') {
	      array = array.buffer
	    }
	    if(!array) {
	      return
	    }
	    var n = array.length || array.byteLength
	    var log_n = bits.log2(n)|0
	    DATA[log_n].push(array)
	  }
	}
	
	function freeArrayBuffer(buffer) {
	  if(!buffer) {
	    return
	  }
	  var n = buffer.length || buffer.byteLength
	  var log_n = bits.log2(n)
	  DATA[log_n].push(buffer)
	}
	
	function freeTypedArray(array) {
	  freeArrayBuffer(array.buffer)
	}
	
	exports.freeUint8 =
	exports.freeUint16 =
	exports.freeUint32 =
	exports.freeInt8 =
	exports.freeInt16 =
	exports.freeInt32 =
	exports.freeFloat32 = 
	exports.freeFloat =
	exports.freeFloat64 = 
	exports.freeDouble = 
	exports.freeUint8Clamped = 
	exports.freeDataView = freeTypedArray
	
	exports.freeArrayBuffer = freeArrayBuffer
	
	exports.freeBuffer = function freeBuffer(array) {
	  BUFFER[bits.log2(array.length)].push(array)
	}
	
	exports.malloc = function malloc(n, dtype) {
	  if(dtype === undefined || dtype === 'arraybuffer') {
	    return mallocArrayBuffer(n)
	  } else {
	    switch(dtype) {
	      case 'uint8':
	        return mallocUint8(n)
	      case 'uint16':
	        return mallocUint16(n)
	      case 'uint32':
	        return mallocUint32(n)
	      case 'int8':
	        return mallocInt8(n)
	      case 'int16':
	        return mallocInt16(n)
	      case 'int32':
	        return mallocInt32(n)
	      case 'float':
	      case 'float32':
	        return mallocFloat(n)
	      case 'double':
	      case 'float64':
	        return mallocDouble(n)
	      case 'uint8_clamped':
	        return mallocUint8Clamped(n)
	      case 'buffer':
	        return mallocBuffer(n)
	      case 'data':
	      case 'dataview':
	        return mallocDataView(n)
	
	      default:
	        return null
	    }
	  }
	  return null
	}
	
	function mallocArrayBuffer(n) {
	  var n = bits.nextPow2(n)
	  var log_n = bits.log2(n)
	  var d = DATA[log_n]
	  if(d.length > 0) {
	    return d.pop()
	  }
	  return new ArrayBuffer(n)
	}
	exports.mallocArrayBuffer = mallocArrayBuffer
	
	function mallocUint8(n) {
	  return new Uint8Array(mallocArrayBuffer(n), 0, n)
	}
	exports.mallocUint8 = mallocUint8
	
	function mallocUint16(n) {
	  return new Uint16Array(mallocArrayBuffer(2*n), 0, n)
	}
	exports.mallocUint16 = mallocUint16
	
	function mallocUint32(n) {
	  return new Uint32Array(mallocArrayBuffer(4*n), 0, n)
	}
	exports.mallocUint32 = mallocUint32
	
	function mallocInt8(n) {
	  return new Int8Array(mallocArrayBuffer(n), 0, n)
	}
	exports.mallocInt8 = mallocInt8
	
	function mallocInt16(n) {
	  return new Int16Array(mallocArrayBuffer(2*n), 0, n)
	}
	exports.mallocInt16 = mallocInt16
	
	function mallocInt32(n) {
	  return new Int32Array(mallocArrayBuffer(4*n), 0, n)
	}
	exports.mallocInt32 = mallocInt32
	
	function mallocFloat(n) {
	  return new Float32Array(mallocArrayBuffer(4*n), 0, n)
	}
	exports.mallocFloat32 = exports.mallocFloat = mallocFloat
	
	function mallocDouble(n) {
	  return new Float64Array(mallocArrayBuffer(8*n), 0, n)
	}
	exports.mallocFloat64 = exports.mallocDouble = mallocDouble
	
	function mallocUint8Clamped(n) {
	  if(hasUint8C) {
	    return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n)
	  } else {
	    return mallocUint8(n)
	  }
	}
	exports.mallocUint8Clamped = mallocUint8Clamped
	
	function mallocDataView(n) {
	  return new DataView(mallocArrayBuffer(n), 0, n)
	}
	exports.mallocDataView = mallocDataView
	
	function mallocBuffer(n) {
	  n = bits.nextPow2(n)
	  var log_n = bits.log2(n)
	  var cache = BUFFER[log_n]
	  if(cache.length > 0) {
	    return cache.pop()
	  }
	  return new Buffer(n)
	}
	exports.mallocBuffer = mallocBuffer
	
	exports.clearCache = function clearCache() {
	  for(var i=0; i<32; ++i) {
	    POOL.UINT8[i].length = 0
	    POOL.UINT16[i].length = 0
	    POOL.UINT32[i].length = 0
	    POOL.INT8[i].length = 0
	    POOL.INT16[i].length = 0
	    POOL.INT32[i].length = 0
	    POOL.FLOAT[i].length = 0
	    POOL.DOUBLE[i].length = 0
	    POOL.UINT8C[i].length = 0
	    DATA[i].length = 0
	    BUFFER[i].length = 0
	  }
	}
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},_dereq_("buffer").Buffer)
	},{"bit-twiddle":93,"buffer":106,"dup":171}],544:[function(_dereq_,module,exports){
	"use strict"; "use restrict";
	
	module.exports = UnionFind;
	
	function UnionFind(count) {
	  this.roots = new Array(count);
	  this.ranks = new Array(count);
	  
	  for(var i=0; i<count; ++i) {
	    this.roots[i] = i;
	    this.ranks[i] = 0;
	  }
	}
	
	var proto = UnionFind.prototype
	
	Object.defineProperty(proto, "length", {
	  "get": function() {
	    return this.roots.length
	  }
	})
	
	proto.makeSet = function() {
	  var n = this.roots.length;
	  this.roots.push(n);
	  this.ranks.push(0);
	  return n;
	}
	
	proto.find = function(x) {
	  var x0 = x
	  var roots = this.roots;
	  while(roots[x] !== x) {
	    x = roots[x]
	  }
	  while(roots[x0] !== x) {
	    var y = roots[x0]
	    roots[x0] = x
	    x0 = y
	  }
	  return x;
	}
	
	proto.link = function(x, y) {
	  var xr = this.find(x)
	    , yr = this.find(y);
	  if(xr === yr) {
	    return;
	  }
	  var ranks = this.ranks
	    , roots = this.roots
	    , xd    = ranks[xr]
	    , yd    = ranks[yr];
	  if(xd < yd) {
	    roots[xr] = yr;
	  } else if(yd < xd) {
	    roots[yr] = xr;
	  } else {
	    roots[yr] = xr;
	    ++ranks[xr];
	  }
	}
	},{}],545:[function(_dereq_,module,exports){
	"use strict"
	
	function unique_pred(list, compare) {
	  var ptr = 1
	    , len = list.length
	    , a=list[0], b=list[0]
	  for(var i=1; i<len; ++i) {
	    b = a
	    a = list[i]
	    if(compare(a, b)) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      list[ptr++] = a
	    }
	  }
	  list.length = ptr
	  return list
	}
	
	function unique_eq(list) {
	  var ptr = 1
	    , len = list.length
	    , a=list[0], b = list[0]
	  for(var i=1; i<len; ++i, b=a) {
	    b = a
	    a = list[i]
	    if(a !== b) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      list[ptr++] = a
	    }
	  }
	  list.length = ptr
	  return list
	}
	
	function unique(list, compare, sorted) {
	  if(list.length === 0) {
	    return list
	  }
	  if(compare) {
	    if(!sorted) {
	      list.sort(compare)
	    }
	    return unique_pred(list, compare)
	  }
	  if(!sorted) {
	    list.sort()
	  }
	  return unique_eq(list)
	}
	
	module.exports = unique
	
	},{}],546:[function(_dereq_,module,exports){
	var reg = /[\'\"]/
	
	module.exports = function unquote(str) {
	  if (!str) {
	    return ''
	  }
	  if (reg.test(str.charAt(0))) {
	    str = str.substr(1)
	  }
	  if (reg.test(str.charAt(str.length - 1))) {
	    str = str.substr(0, str.length - 1)
	  }
	  return str
	}
	
	},{}],547:[function(_dereq_,module,exports){
	/**
	 * @module update-diff
	 */
	
	'use strict'
	
	module.exports = function updateDiff (obj, diff, mappers) {
		if (!Array.isArray(mappers)) mappers = [].slice.call(arguments, 2)
	
		for (var i = 0, l = mappers.length; i < l; i++) {
			var dict = mappers[i]
			for (var prop in dict) {
				if (diff[prop] !== undefined && !Array.isArray(diff[prop]) && obj[prop] === diff[prop]) continue
	
				if (prop in diff) {
					var result
	
					if (dict[prop] === true) result = diff[prop]
					else if (dict[prop] === false) continue
					else if (typeof dict[prop] === 'function') {
						result = dict[prop](diff[prop], obj, diff)
						if (result === undefined) continue
					}
	
					obj[prop] = result
				}
			}
		}
	
		return obj
	}
	
	},{}],548:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = createText
	
	var vectorizeText = _dereq_("./lib/vtext")
	var defaultCanvas = null
	var defaultContext = null
	
	if(typeof document !== 'undefined') {
	  defaultCanvas = document.createElement('canvas')
	  defaultCanvas.width = 8192
	  defaultCanvas.height = 1024
	  defaultContext = defaultCanvas.getContext("2d")
	}
	
	function createText(str, options) {
	  if((typeof options !== "object") || (options === null)) {
	    options = {}
	  }
	  return vectorizeText(
	    str,
	    options.canvas || defaultCanvas,
	    options.context || defaultContext,
	    options)
	}
	
	},{"./lib/vtext":549}],549:[function(_dereq_,module,exports){
	module.exports = vectorizeText
	module.exports.processPixels = processPixels
	
	var surfaceNets = _dereq_('surface-nets')
	var ndarray = _dereq_('ndarray')
	var simplify = _dereq_('simplify-planar-graph')
	var cleanPSLG = _dereq_('clean-pslg')
	var cdt2d = _dereq_('cdt2d')
	var toPolygonCrappy = _dereq_('planar-graph-to-polyline')
	
	var TAG_bold = "b"
	var CHR_bold = 'b|'
	
	var TAG_italic = "i"
	var CHR_italic = 'i|'
	
	var TAG_super = "sup"
	var CHR_super0 = '+'
	var CHR_super = '+1'
	
	var TAG_sub = "sub"
	var CHR_sub0 = '-'
	var CHR_sub = '-1'
	
	function parseTag(tag, TAG_CHR, str, map) {
	
	  var opnTag =  "<"  + tag + ">"
	  var clsTag =  "</" + tag + ">"
	
	  var nOPN = opnTag.length
	  var nCLS = clsTag.length
	
	  var isRecursive = (TAG_CHR[0] === CHR_super0) ||
	                    (TAG_CHR[0] === CHR_sub0);
	
	  var a = 0
	  var b = -nCLS
	  while (a > -1) {
	    a = str.indexOf(opnTag, a)
	    if(a === -1) break
	
	    b = str.indexOf(clsTag, a + nOPN)
	    if(b === -1) break
	
	    if(b <= a) break
	
	    for(var i = a; i < b + nCLS; ++i){
	      if((i < a + nOPN) || (i >= b)) {
	        map[i] = null
	        str = str.substr(0, i) + " " + str.substr(i + 1)
	      } else {
	        if(map[i] !== null) {
	          var pos = map[i].indexOf(TAG_CHR[0])
	          if(pos === -1) {
	            map[i] += TAG_CHR
	          } else { // i.e. to handle multiple sub/super-scripts
	            if(isRecursive) {
	              // i.e to increase the sub/sup number
	              map[i] = map[i].substr(0, pos + 1) + (1 + parseInt(map[i][pos + 1])) + map[i].substr(pos + 2)
	            }
	          }
	        }
	      }
	    }
	
	    var start = a + nOPN
	    var remainingStr = str.substr(start, b - start)
	
	    var c = remainingStr.indexOf(opnTag)
	    if(c !== -1) a = c
	    else a = b + nCLS
	  }
	
	  return map
	}
	
	function transformPositions(positions, options, size) {
	  var align = options.textAlign || "start"
	  var baseline = options.textBaseline || "alphabetic"
	
	  var lo = [1<<30, 1<<30]
	  var hi = [0,0]
	  var n = positions.length
	  for(var i=0; i<n; ++i) {
	    var p = positions[i]
	    for(var j=0; j<2; ++j) {
	      lo[j] = Math.min(lo[j], p[j])|0
	      hi[j] = Math.max(hi[j], p[j])|0
	    }
	  }
	
	  var xShift = 0
	  switch(align) {
	    case "center":
	      xShift = -0.5 * (lo[0] + hi[0])
	    break
	
	    case "right":
	    case "end":
	      xShift = -hi[0]
	    break
	
	    case "left":
	    case "start":
	      xShift = -lo[0]
	    break
	
	    default:
	      throw new Error("vectorize-text: Unrecognized textAlign: '" + align + "'")
	  }
	
	  var yShift = 0
	  switch(baseline) {
	    case "hanging":
	    case "top":
	      yShift = -lo[1]
	    break
	
	    case "middle":
	      yShift = -0.5 * (lo[1] + hi[1])
	    break
	
	    case "alphabetic":
	    case "ideographic":
	      yShift = -3 * size
	    break
	
	    case "bottom":
	      yShift = -hi[1]
	    break
	
	    default:
	      throw new Error("vectorize-text: Unrecoginized textBaseline: '" + baseline + "'")
	  }
	
	  var scale = 1.0 / size
	  if("lineHeight" in options) {
	    scale *= +options.lineHeight
	  } else if("width" in options) {
	    scale = options.width / (hi[0] - lo[0])
	  } else if("height" in options) {
	    scale = options.height / (hi[1] - lo[1])
	  }
	
	  return positions.map(function(p) {
	    return [ scale * (p[0] + xShift), scale * (p[1] + yShift) ]
	  })
	}
	
	function getPixels(canvas, context, rawString, fontSize, lineSpacing, styletags) {
	
	  rawString = rawString.replace(/\n/g, '') // don't accept \n in the input
	
	  if(styletags.breaklines === true) {
	    rawString = rawString.replace(/\<br\>/g, '\n') // replace <br> tags with \n in the string
	  } else {
	    rawString = rawString.replace(/\<br\>/g, ' ') // don't accept <br> tags in the input and replace with space in this case
	  }
	
	  var activeStyle = ""
	  var map = []
	  for(j = 0; j < rawString.length; ++j) {
	    map[j] = activeStyle
	  }
	
	  if(styletags.bolds === true) map = parseTag(TAG_bold, CHR_bold, rawString, map)
	  if(styletags.italics === true) map = parseTag(TAG_italic, CHR_italic, rawString, map)
	  if(styletags.superscripts === true) map = parseTag(TAG_super, CHR_super, rawString, map)
	  if(styletags.subscripts === true) map = parseTag(TAG_sub, CHR_sub, rawString, map)
	
	  var allStyles = []
	  var plainText = ""
	  for(j = 0; j < rawString.length; ++j) {
	    if(map[j] !== null) {
	      plainText += rawString[j]
	      allStyles.push(map[j])
	    }
	  }
	
	  var allTexts = plainText.split('\n')
	
	  var numberOfLines = allTexts.length
	  var lineHeight = Math.round(lineSpacing * fontSize)
	  var offsetX = fontSize
	  var offsetY = fontSize * 2
	  var maxWidth = 0
	  var minHeight = numberOfLines * lineHeight + offsetY
	
	  if(canvas.height < minHeight) {
	    canvas.height = minHeight
	  }
	
	  context.fillStyle = "#000"
	  context.fillRect(0, 0, canvas.width, canvas.height)
	
	  context.fillStyle = "#fff"
	  var i, j, xPos, yPos, zPos
	  var nDone = 0
	
	  var buffer = ""
	  function writeBuffer() {
	    if(buffer !== "") {
	      var delta = context.measureText(buffer).width
	
	      context.fillText(buffer, offsetX + xPos, offsetY + yPos)
	      xPos += delta
	    }
	  }
	
	  function getTextFontSize() {
	    return "" + Math.round(zPos) + "px ";
	  }
	
	  function changeStyle(oldStyle, newStyle) {
	    var ctxFont = "" + context.font;
	
	    if(styletags.subscripts === true) {
	      var oldIndex_Sub = oldStyle.indexOf(CHR_sub0);
	      var newIndex_Sub = newStyle.indexOf(CHR_sub0);
	
	      var oldSub = (oldIndex_Sub > -1) ? parseInt(oldStyle[1 + oldIndex_Sub]) : 0;
	      var newSub = (newIndex_Sub > -1) ? parseInt(newStyle[1 + newIndex_Sub]) : 0;
	
	      if(oldSub !== newSub) {
	        ctxFont = ctxFont.replace(getTextFontSize(), "?px ")
	        zPos *= Math.pow(0.75, (newSub - oldSub))
	        ctxFont = ctxFont.replace("?px ", getTextFontSize())
	      }
	      yPos += 0.25 * lineHeight * (newSub - oldSub);
	    }
	
	    if(styletags.superscripts === true) {
	      var oldIndex_Super = oldStyle.indexOf(CHR_super0);
	      var newIndex_Super = newStyle.indexOf(CHR_super0);
	
	      var oldSuper = (oldIndex_Super > -1) ? parseInt(oldStyle[1 + oldIndex_Super]) : 0;
	      var newSuper = (newIndex_Super > -1) ? parseInt(newStyle[1 + newIndex_Super]) : 0;
	
	      if(oldSuper !== newSuper) {
	        ctxFont = ctxFont.replace(getTextFontSize(), "?px ")
	        zPos *= Math.pow(0.75, (newSuper - oldSuper))
	        ctxFont = ctxFont.replace("?px ", getTextFontSize())
	      }
	      yPos -= 0.25 * lineHeight * (newSuper - oldSuper);
	    }
	
	    if(styletags.bolds === true) {
	      var wasBold = (oldStyle.indexOf(CHR_bold) > -1)
	      var is_Bold = (newStyle.indexOf(CHR_bold) > -1)
	
	      if(!wasBold && is_Bold) {
	        if(wasItalic) {
	          ctxFont = ctxFont.replace("italic ", "italic bold ")
	        } else {
	          ctxFont = "bold " + ctxFont
	        }
	      }
	      if(wasBold && !is_Bold) {
	        ctxFont = ctxFont.replace("bold ", '')
	      }
	    }
	
	    if(styletags.italics === true) {
	      var wasItalic = (oldStyle.indexOf(CHR_italic) > -1)
	      var is_Italic = (newStyle.indexOf(CHR_italic) > -1)
	
	      if(!wasItalic && is_Italic) {
	        ctxFont = "italic " + ctxFont
	      }
	      if(wasItalic && !is_Italic) {
	        ctxFont = ctxFont.replace("italic ", '')
	      }
	    }
	    context.font = ctxFont
	  }
	
	  for(i = 0; i < numberOfLines; ++i) {
	    var txt = allTexts[i] + '\n'
	    xPos = 0
	    yPos = i * lineHeight
	    zPos = fontSize
	
	    buffer = ""
	    
	    for(j = 0; j < txt.length; ++j) {
	      var style = (j + nDone < allStyles.length) ? allStyles[j + nDone] : allStyles[allStyles.length - 1]
	      if(activeStyle === style) {
	        buffer += txt[j]
	      } else {
	        writeBuffer()
	        buffer = txt[j]
	
	        if(style !== undefined) {
	          changeStyle(activeStyle, style)
	          activeStyle = style
	        }
	      }
	    }
	    writeBuffer()
	
	    nDone += txt.length
	
	    var width = Math.round(xPos + 2 * offsetX) | 0
	    if(maxWidth < width) maxWidth = width
	  }
	
	  //Cut pixels from image
	  var xCut = maxWidth
	  var yCut = offsetY + lineHeight * numberOfLines
	  var pixels = ndarray(context.getImageData(0, 0, xCut, yCut).data, [yCut, xCut, 4])
	  return pixels.pick(-1, -1, 0).transpose(1, 0)
	}
	
	function getContour(pixels, doSimplify) {
	  var contour = surfaceNets(pixels, 128)
	  if(doSimplify) {
	    return simplify(contour.cells, contour.positions, 0.25)
	  }
	  return {
	    edges: contour.cells,
	    positions: contour.positions
	  }
	}
	
	function processPixelsImpl(pixels, options, size, simplify) {
	  //Extract contour
	  var contour = getContour(pixels, simplify)
	
	  //Apply warp to positions
	  var positions = transformPositions(contour.positions, options, size)
	  var edges     = contour.edges
	  var flip = "ccw" === options.orientation
	
	  //Clean up the PSLG, resolve self intersections, etc.
	  cleanPSLG(positions, edges)
	
	  //If triangulate flag passed, triangulate the result
	  if(options.polygons || options.polygon || options.polyline) {
	    var result = toPolygonCrappy(edges, positions)
	    var nresult = new Array(result.length)
	    for(var i=0; i<result.length; ++i) {
	      var loops = result[i]
	      var nloops = new Array(loops.length)
	      for(var j=0; j<loops.length; ++j) {
	        var loop = loops[j]
	        var nloop = new Array(loop.length)
	        for(var k=0; k<loop.length; ++k) {
	          nloop[k] = positions[loop[k]].slice()
	        }
	        if(flip) {
	          nloop.reverse()
	        }
	        nloops[j] = nloop
	      }
	      nresult[i] = nloops
	    }
	    return nresult
	  } else if(options.triangles || options.triangulate || options.triangle) {
	    return {
	      cells: cdt2d(positions, edges, {
	        delaunay: false,
	        exterior: false,
	        interior: true
	      }),
	      positions: positions
	    }
	  } else {
	    return {
	      edges:     edges,
	      positions: positions
	    }
	  }
	}
	
	function processPixels(pixels, options, size) {
	  try {
	    return processPixelsImpl(pixels, options, size, true)
	  } catch(e) {}
	  try {
	    return processPixelsImpl(pixels, options, size, false)
	  } catch(e) {}
	  if(options.polygons || options.polyline || options.polygon) {
	    return []
	  }
	  if(options.triangles || options.triangulate || options.triangle) {
	    return {
	      cells: [],
	      positions: []
	    }
	  }
	  return {
	    edges: [],
	    positions: []
	  }
	}
	
	function vectorizeText(str, canvas, context, options) {
	  var size = 64
	  var lineSpacing = 1.25
	  var styletags = {
	    breaklines: false,
	    bolds: false,
	    italics: false,
	    subscripts: false,
	    superscripts: false
	  }
	
	  if(options) {
	
	    if(options.size &&
	       options.size > 0) size =
	       options.size
	
	    if(options.lineSpacing &&
	       options.lineSpacing > 0) lineSpacing =
	       options.lineSpacing
	
	    if(options.styletags &&
	       options.styletags.breaklines) styletags.breaklines =
	       options.styletags.breaklines ? true : false
	
	    if(options.styletags &&
	       options.styletags.bolds) styletags.bolds =
	       options.styletags.bolds ? true : false
	
	    if(options.styletags &&
	       options.styletags.italics) styletags.italics =
	       options.styletags.italics ? true : false
	
	    if(options.styletags &&
	       options.styletags.subscripts) styletags.subscripts =
	       options.styletags.subscripts ? true : false
	
	    if(options.styletags &&
	       options.styletags.superscripts) styletags.superscripts =
	       options.styletags.superscripts ? true : false
	  }
	
	  context.font = [
	    options.fontStyle,
	    options.fontVariant,
	    options.fontWeight,
	    size + "px",
	    options.font
	  ].filter(function(d) {return d}).join(" ")
	  context.textAlign = "start"
	  context.textBaseline = "alphabetic"
	  context.direction = "ltr"
	
	  var pixels = getPixels(canvas, context, str, size, lineSpacing, styletags)
	
	  return processPixels(pixels, options, size)
	}
	
	},{"cdt2d":107,"clean-pslg":117,"ndarray":451,"planar-graph-to-polyline":469,"simplify-planar-graph":522,"surface-nets":529}],550:[function(_dereq_,module,exports){
	// Copyright (C) 2011 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	/**
	 * @fileoverview Install a leaky WeakMap emulation on platforms that
	 * don't provide a built-in one.
	 *
	 * <p>Assumes that an ES5 platform where, if {@code WeakMap} is
	 * already present, then it conforms to the anticipated ES6
	 * specification. To run this file on an ES5 or almost ES5
	 * implementation where the {@code WeakMap} specification does not
	 * quite conform, run <code>repairES5.js</code> first.
	 *
	 * <p>Even though WeakMapModule is not global, the linter thinks it
	 * is, which is why it is in the overrides list below.
	 *
	 * <p>NOTE: Before using this WeakMap emulation in a non-SES
	 * environment, see the note below about hiddenRecord.
	 *
	 * @author Mark S. Miller
	 * @requires crypto, ArrayBuffer, Uint8Array, navigator, console
	 * @overrides WeakMap, ses, Proxy
	 * @overrides WeakMapModule
	 */
	
	/**
	 * This {@code WeakMap} emulation is observably equivalent to the
	 * ES-Harmony WeakMap, but with leakier garbage collection properties.
	 *
	 * <p>As with true WeakMaps, in this emulation, a key does not
	 * retain maps indexed by that key and (crucially) a map does not
	 * retain the keys it indexes. A map by itself also does not retain
	 * the values associated with that map.
	 *
	 * <p>However, the values associated with a key in some map are
	 * retained so long as that key is retained and those associations are
	 * not overridden. For example, when used to support membranes, all
	 * values exported from a given membrane will live for the lifetime
	 * they would have had in the absence of an interposed membrane. Even
	 * when the membrane is revoked, all objects that would have been
	 * reachable in the absence of revocation will still be reachable, as
	 * far as the GC can tell, even though they will no longer be relevant
	 * to ongoing computation.
	 *
	 * <p>The API implemented here is approximately the API as implemented
	 * in FF6.0a1 and agreed to by MarkM, Andreas Gal, and Dave Herman,
	 * rather than the offially approved proposal page. TODO(erights):
	 * upgrade the ecmascript WeakMap proposal page to explain this API
	 * change and present to EcmaScript committee for their approval.
	 *
	 * <p>The first difference between the emulation here and that in
	 * FF6.0a1 is the presence of non enumerable {@code get___, has___,
	 * set___, and delete___} methods on WeakMap instances to represent
	 * what would be the hidden internal properties of a primitive
	 * implementation. Whereas the FF6.0a1 WeakMap.prototype methods
	 * require their {@code this} to be a genuine WeakMap instance (i.e.,
	 * an object of {@code [[Class]]} "WeakMap}), since there is nothing
	 * unforgeable about the pseudo-internal method names used here,
	 * nothing prevents these emulated prototype methods from being
	 * applied to non-WeakMaps with pseudo-internal methods of the same
	 * names.
	 *
	 * <p>Another difference is that our emulated {@code
	 * WeakMap.prototype} is not itself a WeakMap. A problem with the
	 * current FF6.0a1 API is that WeakMap.prototype is itself a WeakMap
	 * providing ambient mutability and an ambient communications
	 * channel. Thus, if a WeakMap is already present and has this
	 * problem, repairES5.js wraps it in a safe wrappper in order to
	 * prevent access to this channel. (See
	 * PATCH_MUTABLE_FROZEN_WEAKMAP_PROTO in repairES5.js).
	 */
	
	/**
	 * If this is a full <a href=
	 * "http://code.google.com/p/es-lab/wiki/SecureableES5"
	 * >secureable ES5</a> platform and the ES-Harmony {@code WeakMap} is
	 * absent, install an approximate emulation.
	 *
	 * <p>If WeakMap is present but cannot store some objects, use our approximate
	 * emulation as a wrapper.
	 *
	 * <p>If this is almost a secureable ES5 platform, then WeakMap.js
	 * should be run after repairES5.js.
	 *
	 * <p>See {@code WeakMap} for documentation of the garbage collection
	 * properties of this WeakMap emulation.
	 */
	(function WeakMapModule() {
	  "use strict";
	
	  if (typeof ses !== 'undefined' && ses.ok && !ses.ok()) {
	    // already too broken, so give up
	    return;
	  }
	
	  /**
	   * In some cases (current Firefox), we must make a choice betweeen a
	   * WeakMap which is capable of using all varieties of host objects as
	   * keys and one which is capable of safely using proxies as keys. See
	   * comments below about HostWeakMap and DoubleWeakMap for details.
	   *
	   * This function (which is a global, not exposed to guests) marks a
	   * WeakMap as permitted to do what is necessary to index all host
	   * objects, at the cost of making it unsafe for proxies.
	   *
	   * Do not apply this function to anything which is not a genuine
	   * fresh WeakMap.
	   */
	  function weakMapPermitHostObjects(map) {
	    // identity of function used as a secret -- good enough and cheap
	    if (map.permitHostObjects___) {
	      map.permitHostObjects___(weakMapPermitHostObjects);
	    }
	  }
	  if (typeof ses !== 'undefined') {
	    ses.weakMapPermitHostObjects = weakMapPermitHostObjects;
	  }
	
	  // IE 11 has no Proxy but has a broken WeakMap such that we need to patch
	  // it using DoubleWeakMap; this flag tells DoubleWeakMap so.
	  var doubleWeakMapCheckSilentFailure = false;
	
	  // Check if there is already a good-enough WeakMap implementation, and if so
	  // exit without replacing it.
	  if (typeof WeakMap === 'function') {
	    var HostWeakMap = WeakMap;
	    // There is a WeakMap -- is it good enough?
	    if (typeof navigator !== 'undefined' &&
	        /Firefox/.test(navigator.userAgent)) {
	      // We're now *assuming not*, because as of this writing (2013-05-06)
	      // Firefox's WeakMaps have a miscellany of objects they won't accept, and
	      // we don't want to make an exhaustive list, and testing for just one
	      // will be a problem if that one is fixed alone (as they did for Event).
	
	      // If there is a platform that we *can* reliably test on, here's how to
	      // do it:
	      //  var problematic = ... ;
	      //  var testHostMap = new HostWeakMap();
	      //  try {
	      //    testHostMap.set(problematic, 1);  // Firefox 20 will throw here
	      //    if (testHostMap.get(problematic) === 1) {
	      //      return;
	      //    }
	      //  } catch (e) {}
	
	    } else {
	      // IE 11 bug: WeakMaps silently fail to store frozen objects.
	      var testMap = new HostWeakMap();
	      var testObject = Object.freeze({});
	      testMap.set(testObject, 1);
	      if (testMap.get(testObject) !== 1) {
	        doubleWeakMapCheckSilentFailure = true;
	        // Fall through to installing our WeakMap.
	      } else {
	        module.exports = WeakMap;
	        return;
	      }
	    }
	  }
	
	  var hop = Object.prototype.hasOwnProperty;
	  var gopn = Object.getOwnPropertyNames;
	  var defProp = Object.defineProperty;
	  var isExtensible = Object.isExtensible;
	
	  /**
	   * Security depends on HIDDEN_NAME being both <i>unguessable</i> and
	   * <i>undiscoverable</i> by untrusted code.
	   *
	   * <p>Given the known weaknesses of Math.random() on existing
	   * browsers, it does not generate unguessability we can be confident
	   * of.
	   *
	   * <p>It is the monkey patching logic in this file that is intended
	   * to ensure undiscoverability. The basic idea is that there are
	   * three fundamental means of discovering properties of an object:
	   * The for/in loop, Object.keys(), and Object.getOwnPropertyNames(),
	   * as well as some proposed ES6 extensions that appear on our
	   * whitelist. The first two only discover enumerable properties, and
	   * we only use HIDDEN_NAME to name a non-enumerable property, so the
	   * only remaining threat should be getOwnPropertyNames and some
	   * proposed ES6 extensions that appear on our whitelist. We monkey
	   * patch them to remove HIDDEN_NAME from the list of properties they
	   * returns.
	   *
	   * <p>TODO(erights): On a platform with built-in Proxies, proxies
	   * could be used to trap and thereby discover the HIDDEN_NAME, so we
	   * need to monkey patch Proxy.create, Proxy.createFunction, etc, in
	   * order to wrap the provided handler with the real handler which
	   * filters out all traps using HIDDEN_NAME.
	   *
	   * <p>TODO(erights): Revisit Mike Stay's suggestion that we use an
	   * encapsulated function at a not-necessarily-secret name, which
	   * uses the Stiegler shared-state rights amplification pattern to
	   * reveal the associated value only to the WeakMap in which this key
	   * is associated with that value. Since only the key retains the
	   * function, the function can also remember the key without causing
	   * leakage of the key, so this doesn't violate our general gc
	   * goals. In addition, because the name need not be a guarded
	   * secret, we could efficiently handle cross-frame frozen keys.
	   */
	  var HIDDEN_NAME_PREFIX = 'weakmap:';
	  var HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'ident:' + Math.random() + '___';
	
	  if (typeof crypto !== 'undefined' &&
	      typeof crypto.getRandomValues === 'function' &&
	      typeof ArrayBuffer === 'function' &&
	      typeof Uint8Array === 'function') {
	    var ab = new ArrayBuffer(25);
	    var u8s = new Uint8Array(ab);
	    crypto.getRandomValues(u8s);
	    HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'rand:' +
	      Array.prototype.map.call(u8s, function(u8) {
	        return (u8 % 36).toString(36);
	      }).join('') + '___';
	  }
	
	  function isNotHiddenName(name) {
	    return !(
	        name.substr(0, HIDDEN_NAME_PREFIX.length) == HIDDEN_NAME_PREFIX &&
	        name.substr(name.length - 3) === '___');
	  }
	
	  /**
	   * Monkey patch getOwnPropertyNames to avoid revealing the
	   * HIDDEN_NAME.
	   *
	   * <p>The ES5.1 spec requires each name to appear only once, but as
	   * of this writing, this requirement is controversial for ES6, so we
	   * made this code robust against this case. If the resulting extra
	   * search turns out to be expensive, we can probably relax this once
	   * ES6 is adequately supported on all major browsers, iff no browser
	   * versions we support at that time have relaxed this constraint
	   * without providing built-in ES6 WeakMaps.
	   */
	  defProp(Object, 'getOwnPropertyNames', {
	    value: function fakeGetOwnPropertyNames(obj) {
	      return gopn(obj).filter(isNotHiddenName);
	    }
	  });
	
	  /**
	   * getPropertyNames is not in ES5 but it is proposed for ES6 and
	   * does appear in our whitelist, so we need to clean it too.
	   */
	  if ('getPropertyNames' in Object) {
	    var originalGetPropertyNames = Object.getPropertyNames;
	    defProp(Object, 'getPropertyNames', {
	      value: function fakeGetPropertyNames(obj) {
	        return originalGetPropertyNames(obj).filter(isNotHiddenName);
	      }
	    });
	  }
	
	  /**
	   * <p>To treat objects as identity-keys with reasonable efficiency
	   * on ES5 by itself (i.e., without any object-keyed collections), we
	   * need to add a hidden property to such key objects when we
	   * can. This raises several issues:
	   * <ul>
	   * <li>Arranging to add this property to objects before we lose the
	   *     chance, and
	   * <li>Hiding the existence of this new property from most
	   *     JavaScript code.
	   * <li>Preventing <i>certification theft</i>, where one object is
	   *     created falsely claiming to be the key of an association
	   *     actually keyed by another object.
	   * <li>Preventing <i>value theft</i>, where untrusted code with
	   *     access to a key object but not a weak map nevertheless
	   *     obtains access to the value associated with that key in that
	   *     weak map.
	   * </ul>
	   * We do so by
	   * <ul>
	   * <li>Making the name of the hidden property unguessable, so "[]"
	   *     indexing, which we cannot intercept, cannot be used to access
	   *     a property without knowing the name.
	   * <li>Making the hidden property non-enumerable, so we need not
	   *     worry about for-in loops or {@code Object.keys},
	   * <li>monkey patching those reflective methods that would
	   *     prevent extensions, to add this hidden property first,
	   * <li>monkey patching those methods that would reveal this
	   *     hidden property.
	   * </ul>
	   * Unfortunately, because of same-origin iframes, we cannot reliably
	   * add this hidden property before an object becomes
	   * non-extensible. Instead, if we encounter a non-extensible object
	   * without a hidden record that we can detect (whether or not it has
	   * a hidden record stored under a name secret to us), then we just
	   * use the key object itself to represent its identity in a brute
	   * force leaky map stored in the weak map, losing all the advantages
	   * of weakness for these.
	   */
	  function getHiddenRecord(key) {
	    if (key !== Object(key)) {
	      throw new TypeError('Not an object: ' + key);
	    }
	    var hiddenRecord = key[HIDDEN_NAME];
	    if (hiddenRecord && hiddenRecord.key === key) { return hiddenRecord; }
	    if (!isExtensible(key)) {
	      // Weak map must brute force, as explained in doc-comment above.
	      return void 0;
	    }
	
	    // The hiddenRecord and the key point directly at each other, via
	    // the "key" and HIDDEN_NAME properties respectively. The key
	    // field is for quickly verifying that this hidden record is an
	    // own property, not a hidden record from up the prototype chain.
	    //
	    // NOTE: Because this WeakMap emulation is meant only for systems like
	    // SES where Object.prototype is frozen without any numeric
	    // properties, it is ok to use an object literal for the hiddenRecord.
	    // This has two advantages:
	    // * It is much faster in a performance critical place
	    // * It avoids relying on Object.create(null), which had been
	    //   problematic on Chrome 28.0.1480.0. See
	    //   https://code.google.com/p/google-caja/issues/detail?id=1687
	    hiddenRecord = { key: key };
	
	    // When using this WeakMap emulation on platforms where
	    // Object.prototype might not be frozen and Object.create(null) is
	    // reliable, use the following two commented out lines instead.
	    // hiddenRecord = Object.create(null);
	    // hiddenRecord.key = key;
	
	    // Please contact us if you need this to work on platforms where
	    // Object.prototype might not be frozen and
	    // Object.create(null) might not be reliable.
	
	    try {
	      defProp(key, HIDDEN_NAME, {
	        value: hiddenRecord,
	        writable: false,
	        enumerable: false,
	        configurable: false
	      });
	      return hiddenRecord;
	    } catch (error) {
	      // Under some circumstances, isExtensible seems to misreport whether
	      // the HIDDEN_NAME can be defined.
	      // The circumstances have not been isolated, but at least affect
	      // Node.js v0.10.26 on TravisCI / Linux, but not the same version of
	      // Node.js on OS X.
	      return void 0;
	    }
	  }
	
	  /**
	   * Monkey patch operations that would make their argument
	   * non-extensible.
	   *
	   * <p>The monkey patched versions throw a TypeError if their
	   * argument is not an object, so it should only be done to functions
	   * that should throw a TypeError anyway if their argument is not an
	   * object.
	   */
	  (function(){
	    var oldFreeze = Object.freeze;
	    defProp(Object, 'freeze', {
	      value: function identifyingFreeze(obj) {
	        getHiddenRecord(obj);
	        return oldFreeze(obj);
	      }
	    });
	    var oldSeal = Object.seal;
	    defProp(Object, 'seal', {
	      value: function identifyingSeal(obj) {
	        getHiddenRecord(obj);
	        return oldSeal(obj);
	      }
	    });
	    var oldPreventExtensions = Object.preventExtensions;
	    defProp(Object, 'preventExtensions', {
	      value: function identifyingPreventExtensions(obj) {
	        getHiddenRecord(obj);
	        return oldPreventExtensions(obj);
	      }
	    });
	  })();
	
	  function constFunc(func) {
	    func.prototype = null;
	    return Object.freeze(func);
	  }
	
	  var calledAsFunctionWarningDone = false;
	  function calledAsFunctionWarning() {
	    // Future ES6 WeakMap is currently (2013-09-10) expected to reject WeakMap()
	    // but we used to permit it and do it ourselves, so warn only.
	    if (!calledAsFunctionWarningDone && typeof console !== 'undefined') {
	      calledAsFunctionWarningDone = true;
	      console.warn('WeakMap should be invoked as new WeakMap(), not ' +
	          'WeakMap(). This will be an error in the future.');
	    }
	  }
	
	  var nextId = 0;
	
	  var OurWeakMap = function() {
	    if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
	      calledAsFunctionWarning();
	    }
	
	    // We are currently (12/25/2012) never encountering any prematurely
	    // non-extensible keys.
	    var keys = []; // brute force for prematurely non-extensible keys.
	    var values = []; // brute force for corresponding values.
	    var id = nextId++;
	
	    function get___(key, opt_default) {
	      var index;
	      var hiddenRecord = getHiddenRecord(key);
	      if (hiddenRecord) {
	        return id in hiddenRecord ? hiddenRecord[id] : opt_default;
	      } else {
	        index = keys.indexOf(key);
	        return index >= 0 ? values[index] : opt_default;
	      }
	    }
	
	    function has___(key) {
	      var hiddenRecord = getHiddenRecord(key);
	      if (hiddenRecord) {
	        return id in hiddenRecord;
	      } else {
	        return keys.indexOf(key) >= 0;
	      }
	    }
	
	    function set___(key, value) {
	      var index;
	      var hiddenRecord = getHiddenRecord(key);
	      if (hiddenRecord) {
	        hiddenRecord[id] = value;
	      } else {
	        index = keys.indexOf(key);
	        if (index >= 0) {
	          values[index] = value;
	        } else {
	          // Since some browsers preemptively terminate slow turns but
	          // then continue computing with presumably corrupted heap
	          // state, we here defensively get keys.length first and then
	          // use it to update both the values and keys arrays, keeping
	          // them in sync.
	          index = keys.length;
	          values[index] = value;
	          // If we crash here, values will be one longer than keys.
	          keys[index] = key;
	        }
	      }
	      return this;
	    }
	
	    function delete___(key) {
	      var hiddenRecord = getHiddenRecord(key);
	      var index, lastIndex;
	      if (hiddenRecord) {
	        return id in hiddenRecord && delete hiddenRecord[id];
	      } else {
	        index = keys.indexOf(key);
	        if (index < 0) {
	          return false;
	        }
	        // Since some browsers preemptively terminate slow turns but
	        // then continue computing with potentially corrupted heap
	        // state, we here defensively get keys.length first and then use
	        // it to update both the keys and the values array, keeping
	        // them in sync. We update the two with an order of assignments,
	        // such that any prefix of these assignments will preserve the
	        // key/value correspondence, either before or after the delete.
	        // Note that this needs to work correctly when index === lastIndex.
	        lastIndex = keys.length - 1;
	        keys[index] = void 0;
	        // If we crash here, there's a void 0 in the keys array, but
	        // no operation will cause a "keys.indexOf(void 0)", since
	        // getHiddenRecord(void 0) will always throw an error first.
	        values[index] = values[lastIndex];
	        // If we crash here, values[index] cannot be found here,
	        // because keys[index] is void 0.
	        keys[index] = keys[lastIndex];
	        // If index === lastIndex and we crash here, then keys[index]
	        // is still void 0, since the aliasing killed the previous key.
	        keys.length = lastIndex;
	        // If we crash here, keys will be one shorter than values.
	        values.length = lastIndex;
	        return true;
	      }
	    }
	
	    return Object.create(OurWeakMap.prototype, {
	      get___:    { value: constFunc(get___) },
	      has___:    { value: constFunc(has___) },
	      set___:    { value: constFunc(set___) },
	      delete___: { value: constFunc(delete___) }
	    });
	  };
	
	  OurWeakMap.prototype = Object.create(Object.prototype, {
	    get: {
	      /**
	       * Return the value most recently associated with key, or
	       * opt_default if none.
	       */
	      value: function get(key, opt_default) {
	        return this.get___(key, opt_default);
	      },
	      writable: true,
	      configurable: true
	    },
	
	    has: {
	      /**
	       * Is there a value associated with key in this WeakMap?
	       */
	      value: function has(key) {
	        return this.has___(key);
	      },
	      writable: true,
	      configurable: true
	    },
	
	    set: {
	      /**
	       * Associate value with key in this WeakMap, overwriting any
	       * previous association if present.
	       */
	      value: function set(key, value) {
	        return this.set___(key, value);
	      },
	      writable: true,
	      configurable: true
	    },
	
	    'delete': {
	      /**
	       * Remove any association for key in this WeakMap, returning
	       * whether there was one.
	       *
	       * <p>Note that the boolean return here does not work like the
	       * {@code delete} operator. The {@code delete} operator returns
	       * whether the deletion succeeds at bringing about a state in
	       * which the deleted property is absent. The {@code delete}
	       * operator therefore returns true if the property was already
	       * absent, whereas this {@code delete} method returns false if
	       * the association was already absent.
	       */
	      value: function remove(key) {
	        return this.delete___(key);
	      },
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (typeof HostWeakMap === 'function') {
	    (function() {
	      // If we got here, then the platform has a WeakMap but we are concerned
	      // that it may refuse to store some key types. Therefore, make a map
	      // implementation which makes use of both as possible.
	
	      // In this mode we are always using double maps, so we are not proxy-safe.
	      // This combination does not occur in any known browser, but we had best
	      // be safe.
	      if (doubleWeakMapCheckSilentFailure && typeof Proxy !== 'undefined') {
	        Proxy = undefined;
	      }
	
	      function DoubleWeakMap() {
	        if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
	          calledAsFunctionWarning();
	        }
	
	        // Preferable, truly weak map.
	        var hmap = new HostWeakMap();
	
	        // Our hidden-property-based pseudo-weak-map. Lazily initialized in the
	        // 'set' implementation; thus we can avoid performing extra lookups if
	        // we know all entries actually stored are entered in 'hmap'.
	        var omap = undefined;
	
	        // Hidden-property maps are not compatible with proxies because proxies
	        // can observe the hidden name and either accidentally expose it or fail
	        // to allow the hidden property to be set. Therefore, we do not allow
	        // arbitrary WeakMaps to switch to using hidden properties, but only
	        // those which need the ability, and unprivileged code is not allowed
	        // to set the flag.
	        //
	        // (Except in doubleWeakMapCheckSilentFailure mode in which case we
	        // disable proxies.)
	        var enableSwitching = false;
	
	        function dget(key, opt_default) {
	          if (omap) {
	            return hmap.has(key) ? hmap.get(key)
	                : omap.get___(key, opt_default);
	          } else {
	            return hmap.get(key, opt_default);
	          }
	        }
	
	        function dhas(key) {
	          return hmap.has(key) || (omap ? omap.has___(key) : false);
	        }
	
	        var dset;
	        if (doubleWeakMapCheckSilentFailure) {
	          dset = function(key, value) {
	            hmap.set(key, value);
	            if (!hmap.has(key)) {
	              if (!omap) { omap = new OurWeakMap(); }
	              omap.set(key, value);
	            }
	            return this;
	          };
	        } else {
	          dset = function(key, value) {
	            if (enableSwitching) {
	              try {
	                hmap.set(key, value);
	              } catch (e) {
	                if (!omap) { omap = new OurWeakMap(); }
	                omap.set___(key, value);
	              }
	            } else {
	              hmap.set(key, value);
	            }
	            return this;
	          };
	        }
	
	        function ddelete(key) {
	          var result = !!hmap['delete'](key);
	          if (omap) { return omap.delete___(key) || result; }
	          return result;
	        }
	
	        return Object.create(OurWeakMap.prototype, {
	          get___:    { value: constFunc(dget) },
	          has___:    { value: constFunc(dhas) },
	          set___:    { value: constFunc(dset) },
	          delete___: { value: constFunc(ddelete) },
	          permitHostObjects___: { value: constFunc(function(token) {
	            if (token === weakMapPermitHostObjects) {
	              enableSwitching = true;
	            } else {
	              throw new Error('bogus call to permitHostObjects___');
	            }
	          })}
	        });
	      }
	      DoubleWeakMap.prototype = OurWeakMap.prototype;
	      module.exports = DoubleWeakMap;
	
	      // define .constructor to hide OurWeakMap ctor
	      Object.defineProperty(WeakMap.prototype, 'constructor', {
	        value: WeakMap,
	        enumerable: false,  // as default .constructor is
	        configurable: true,
	        writable: true
	      });
	    })();
	  } else {
	    // There is no host WeakMap, so we must use the emulation.
	
	    // Emulated WeakMaps are incompatible with native proxies (because proxies
	    // can observe the hidden name), so we must disable Proxy usage (in
	    // ArrayLike and Domado, currently).
	    if (typeof Proxy !== 'undefined') {
	      Proxy = undefined;
	    }
	
	    module.exports = OurWeakMap;
	  }
	})();
	
	},{}],551:[function(_dereq_,module,exports){
	var hiddenStore = _dereq_('./hidden-store.js');
	
	module.exports = createStore;
	
	function createStore() {
	    var key = {};
	
	    return function (obj) {
	        if ((typeof obj !== 'object' || obj === null) &&
	            typeof obj !== 'function'
	        ) {
	            throw new Error('Weakmap-shim: Key must be object')
	        }
	
	        var store = obj.valueOf(key);
	        return store && store.identity === key ?
	            store : hiddenStore(obj, key);
	    };
	}
	
	},{"./hidden-store.js":552}],552:[function(_dereq_,module,exports){
	module.exports = hiddenStore;
	
	function hiddenStore(obj, key) {
	    var store = { identity: key };
	    var valueOf = obj.valueOf;
	
	    Object.defineProperty(obj, "valueOf", {
	        value: function (value) {
	            return value !== key ?
	                valueOf.apply(this, arguments) : store;
	        },
	        writable: true
	    });
	
	    return store;
	}
	
	},{}],553:[function(_dereq_,module,exports){
	// Original - @Gozola.
	// https://gist.github.com/Gozala/1269991
	// This is a reimplemented version (with a few bug fixes).
	
	var createStore = _dereq_('./create-store.js');
	
	module.exports = weakMap;
	
	function weakMap() {
	    var privates = createStore();
	
	    return {
	        'get': function (key, fallback) {
	            var store = privates(key)
	            return store.hasOwnProperty('value') ?
	                store.value : fallback
	        },
	        'set': function (key, value) {
	            privates(key).value = value;
	            return this;
	        },
	        'has': function(key) {
	            return 'value' in privates(key);
	        },
	        'delete': function (key) {
	            return delete privates(key).value;
	        }
	    }
	}
	
	},{"./create-store.js":551}],554:[function(_dereq_,module,exports){
	var getContext = _dereq_('get-canvas-context')
	
	module.exports = function getWebGLContext (opt) {
	  return getContext('webgl', opt)
	}
	
	},{"get-canvas-context":234}],555:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Traditional Chinese calendar for jQuery v2.0.2.
	   Written by Nicolas Riesco (enquiries@nicolasriesco.net) December 2016.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	var gregorianCalendar = main.instance();
	
	/** Implementation of the traditional Chinese calendar.
	    Source of calendar tables https://github.com/isee15/Lunar-Solar-Calendar-Converter .
	    @class ChineseCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function ChineseCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	ChineseCalendar.prototype = new main.baseCalendar;
	
	assign(ChineseCalendar.prototype, {
	    /** The calendar name.
	        @memberof ChineseCalendar */
	    name: 'Chinese',
	     /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
	        @memberof GregorianCalendar */
	    jdEpoch: 1721425.5,
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof ChineseCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        This calendar uses month indices to account for intercalary months. 
	        @memberof ChineseCalendar */
	    minMonth: 0,
	    /** The first month in the year.
	        This calendar uses month indices to account for intercalary months. 
	        @memberof ChineseCalendar */
	    firstMonth: 0,
	    /** The minimum day number.
	        @memberof ChineseCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof ChineseCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Chinese',
	            epochs: ['BEC', 'EC'],
	            monthNumbers: function(date, padded) {
	                if (typeof date === 'string') {
	                    var match = date.match(MONTH_NUMBER_REGEXP);
	                    return (match) ? match[0] : '';
	                }
	
	                var year = this._validateYear(date);
	                var monthIndex = date.month();
	
	                var month = '' + this.toChineseMonth(year, monthIndex);
	
	                if (padded && month.length < 2) {
	                    month = "0" + month;
	                }
	
	                if (this.isIntercalaryMonth(year, monthIndex)) {
	                    month += 'i';
	                }
	
	                return month;
	            },
	            monthNames: function(date) {
	                if (typeof date === 'string') {
	                    var match = date.match(MONTH_NAME_REGEXP);
	                    return (match) ? match[0] : '';
	                }
	
	                var year = this._validateYear(date);
	                var monthIndex = date.month();
	
	                var month = this.toChineseMonth(year, monthIndex);
	
	                var monthName = ['一月','二月','三月','四月','五月','六月',
	                    '七月','八月','九月','十月','十一月','十二月'][month - 1];
	
	                if (this.isIntercalaryMonth(year, monthIndex)) {
	                    monthName = '闰' + monthName;
	                }
	
	                return monthName;
	            },
	            monthNamesShort: function(date) {
	                if (typeof date === 'string') {
	                    var match = date.match(MONTH_SHORT_NAME_REGEXP);
	                    return (match) ? match[0] : '';
	                }
	
	                var year = this._validateYear(date);
	                var monthIndex = date.month();
	
	                var month = this.toChineseMonth(year, monthIndex);
	
	                var monthName = ['一','二','三','四','五','六',
	                    '七','八','九','十','十一','十二'][month - 1];
	
	                if (this.isIntercalaryMonth(year, monthIndex)) {
	                    monthName = '闰' + monthName;
	                }
	
	                return monthName;
	            },
	            parseMonth: function(year, monthString) {
	                year = this._validateYear(year);
	                var month = parseInt(monthString);
	                var isIntercalary;
	
	                if (!isNaN(month)) {
	                    var i = monthString[monthString.length - 1];
	                    isIntercalary = (i === 'i' || i === 'I');
	                } else {
	                    if (monthString[0] === '闰') {
	                        isIntercalary = true;
	                        monthString = monthString.substring(1);
	                    }
	                    if (monthString[monthString.length - 1] === '月') {
	                        monthString = monthString.substring(0, monthString.length - 1);
	                    }
	                    month = 1 +
	                        ['一','二','三','四','五','六',
	                        '七','八','九','十','十一','十二'].indexOf(monthString);
	                }
	
	                var monthIndex = this.toMonthIndex(year, month, isIntercalary);
	                return monthIndex;
	            },
	            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 1,
	            isRTL: false
	        }
	    },
	
	    /** Check that a candidate date is from the same calendar and is valid.
	        @memberof BaseCalendar
	        @private
	        @param year {CDate|number} The date or the year to validate.
	        @param error {string} Error message if invalid.
	        @return {number} The year.
	        @throws Error if year out of range. */
	    _validateYear: function(year, error) {
	        if (year.year) {
	            year = year.year();
	        }
	
	        if (typeof year !== 'number' || year < 1888 || year > 2111) {
	            throw error.replace(/\{0\}/, this.local.name);
	        }
	
	        return year;
	    },
	
	    /** Retrieve the month index (i.e. accounting for intercalary months).
	        @memberof ChineseCalendar
	        @param year {number} The year.
	        @param month {number} The month (1 for first month).
	        @param [isIntercalary=false] {boolean} If month is intercalary.
	        @return {number} The month index (0 for first month).
	        @throws Error if an invalid month/year or a different calendar used. */
	    toMonthIndex: function(year, month, isIntercalary) {
	        // compute intercalary month in the year (0 if none)
	        var intercalaryMonth = this.intercalaryMonth(year);
	
	        // validate month
	        var invalidIntercalaryMonth = 
	            (isIntercalary && month !== intercalaryMonth);
	        if (invalidIntercalaryMonth || month < 1 || month > 12) {
	            throw main.local.invalidMonth
	                .replace(/\{0\}/, this.local.name);
	        }
	
	        // compute month index
	        var monthIndex;
	
	        if (!intercalaryMonth) {
	            monthIndex = month - 1;
	        } else if(!isIntercalary && month <= intercalaryMonth) {
	            monthIndex = month - 1;
	        } else {
	            monthIndex = month;
	        }
	
	        return monthIndex;
	    },
	
	    /** Retrieve the month (i.e. accounting for intercalary months).
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date or the year to examine.
	        @param monthIndex {number} The month index (0 for first month).
	        @return {number} The month (1 for first month).
	        @throws Error if an invalid month/year or a different calendar used. */
	    toChineseMonth: function(year, monthIndex) {
	        if (year.year) {
	            year = year.year();
	            monthIndex = year.month();
	        }
	
	        // compute intercalary month in the year (0 if none)
	        var intercalaryMonth = this.intercalaryMonth(year);
	
	        // validate month
	        var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
	        if (monthIndex < 0 || monthIndex > maxMonthIndex) {
	            throw main.local.invalidMonth
	                .replace(/\{0\}/, this.local.name);
	        }
	
	        // compute Chinese month
	        var month;
	
	        if (!intercalaryMonth) {
	            month = monthIndex + 1;
	        } else if(monthIndex < intercalaryMonth) {
	            month = monthIndex + 1;
	        } else {
	            month = monthIndex;
	        }
	
	        return month;
	    },
	
	    /** Determine the intercalary month of a year (if any).
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The intercalary month number, or 0 if none.
	        @throws Error if an invalid year or a different calendar used. */
	    intercalaryMonth: function(year) {
	        year = this._validateYear(year);
	
	        var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
	        var intercalaryMonth = monthDaysTable >> 13;
	
	        return intercalaryMonth;
	    },
	
	    /** Determine whether this date is an intercalary month.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [monthIndex] {number} The month index to examine.
	        @return {boolean} <code>true</code> if this is an intercalary month, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    isIntercalaryMonth: function(year, monthIndex) {
	        if (year.year) {
	            year = year.year();
	            monthIndex = year.month();
	        }
	
	        var intercalaryMonth = this.intercalaryMonth(year);
	
	        return !!intercalaryMonth && intercalaryMonth === monthIndex;
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        return (this.intercalaryMonth(year) !== 0);
	    },
	
	    /** Determine the week of the year for a date - ISO 8601.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [monthIndex] {number} The month index to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, monthIndex, day) {
	        // compute Chinese new year
	        var validatedYear =
	            this._validateYear(year, main.local.invalidyear);
	        var packedDate =
	            CHINESE_NEW_YEAR[validatedYear - CHINESE_NEW_YEAR[0]];
	
	        var y = (packedDate >> 9) & 0xFFF;
	        var m = (packedDate >> 5) & 0x0F;
	        var d = packedDate & 0x1F;
	        
	        // find first Thrusday of the year
	        var firstThursday;
	        firstThursday = gregorianCalendar.newDate(y, m, d);
	        firstThursday.add(4 - (firstThursday.dayOfWeek() || 7), 'd');
	
	        // compute days from first Thursday
	        var offset =
	            this.toJD(year, monthIndex, day) - firstThursday.toJD();
	        return 1 + Math.floor(offset / 7);
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        return (this.leapYear(year)) ? 13 : 12;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [monthIndex] {number} The month index.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, monthIndex) {
	        if (year.year) {
	            monthIndex = year.month();
	            year = year.year();
	        }
	
	        year = this._validateYear(year);
	
	        var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
	
	        var intercalaryMonth = monthDaysTable >> 13;
	        var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
	        if (monthIndex > maxMonthIndex) {
	            throw main.local.invalidMonth
	                .replace(/\{0\}/, this.local.name);
	        }
	
	        var daysInMonth = (monthDaysTable & (1 << (12 - monthIndex))) ?
	            30 : 29;
	
	        return daysInMonth;
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [monthIndex] {number} The month index to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, monthIndex, day) {
	        return (this.dayOfWeek(year, monthIndex, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof ChineseCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [monthIndex] {number} The month index to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, monthIndex, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = this._validateYear(date.year());
	        monthIndex = date.month();
	        day = date.day();
	
	        var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
	        var month = this.toChineseMonth(year, monthIndex);
	
	        var solar = toSolar(year, month, day, isIntercalary);
	
	        return gregorianCalendar.toJD(solar.year, solar.month, solar.day);
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof ChineseCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        var date = gregorianCalendar.fromJD(jd);
	        var lunar = toLunar(date.year(), date.month(), date.day());
	        var monthIndex = this.toMonthIndex(
	            lunar.year, lunar.month, lunar.isIntercalary);
	        return this.newDate(lunar.year, monthIndex, lunar.day);
	    },
	
	    /** Create a new date from a string.
	        @memberof ChineseCalendar
	        @param dateString {string} String representing a Chinese date
	        @return {CDate} The new date.
	        @throws Error if an invalid date. */
	    fromString: function(dateString) {
	        var match = dateString.match(DATE_REGEXP);
	
	        var year = this._validateYear(+match[1]);
	
	        var month = +match[2];
	        var isIntercalary = !!match[3];
	        var monthIndex = this.toMonthIndex(year, month, isIntercalary);
	
	        var day = +match[4];
	
	        return this.newDate(year, monthIndex, day);
	    },
	
	    /** Add period(s) to a date.
	        Cater for no year zero.
	        @memberof ChineseCalendar
	        @param date {CDate} The starting date.
	        @param offset {number} The number of periods to adjust by.
	        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	        @return {CDate} The updated date.
	        @throws Error if a different calendar used. */
	    add: function(date, offset, period) {
	        var year = date.year();
	        var monthIndex = date.month();
	        var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
	        var month = this.toChineseMonth(year, monthIndex);
	
	        var cdate = Object.getPrototypeOf(ChineseCalendar.prototype)
	            .add.call(this, date, offset, period);
	
	        if (period === 'y') {
	            // Resync month
	            var resultYear = cdate.year();
	            var resultMonthIndex = cdate.month();
	
	            // Using the fact the month index of an intercalary month
	            // equals its month number:
	            var resultCanBeIntercalaryMonth =
	                this.isIntercalaryMonth(resultYear, month);
	
	            var correctedMonthIndex =
	                (isIntercalary && resultCanBeIntercalaryMonth) ?
	                this.toMonthIndex(resultYear, month, true) :
	                this.toMonthIndex(resultYear, month, false);
	
	            if (correctedMonthIndex !== resultMonthIndex) {
	                cdate.month(correctedMonthIndex);
	            }
	        }
	
	        return cdate;
	    },
	});
	
	// Used by ChineseCalendar.prototype.fromString
	var DATE_REGEXP = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m;
	var MONTH_NUMBER_REGEXP = /^\d?\d[iI]?/m;
	var MONTH_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?月/m;
	var MONTH_SHORT_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?/m;
	
	// Chinese calendar implementation
	main.calendars.chinese = ChineseCalendar;
	
	// Chinese calendar tables from year 1888 to 2111
	//
	// Source:
	// https://github.com/isee15/Lunar-Solar-Calendar-Converter.git
	
	// Table of intercalary months and days per month from year 1888 to 2111
	//
	// bit (12 - i):        days in the i^th month
	//                      (= 0 if i^th lunar month has 29 days)
	//                      (= 1 if i^th lunar month has 30 days)
	//                      (first month in lunar year is i = 0)
	// bits (13,14,15,16):  intercalary month
	//                      (= 0 if lunar year has no intercalary month)
	var LUNAR_MONTH_DAYS = [1887, 0x1694, 0x16aa, 0x4ad5,
	    0xab6, 0xc4b7, 0x4ae, 0xa56, 0xb52a, 0x1d2a, 0xd54, 0x75aa, 0x156a,
	    0x1096d, 0x95c, 0x14ae, 0xaa4d, 0x1a4c, 0x1b2a, 0x8d55, 0xad4,
	    0x135a, 0x495d, 0x95c, 0xd49b, 0x149a, 0x1a4a, 0xbaa5, 0x16a8,
	    0x1ad4, 0x52da, 0x12b6, 0xe937, 0x92e, 0x1496, 0xb64b, 0xd4a,
	    0xda8, 0x95b5, 0x56c, 0x12ae, 0x492f, 0x92e, 0xcc96, 0x1a94,
	    0x1d4a, 0xada9, 0xb5a, 0x56c, 0x726e, 0x125c, 0xf92d, 0x192a,
	    0x1a94, 0xdb4a, 0x16aa, 0xad4, 0x955b, 0x4ba, 0x125a, 0x592b,
	    0x152a, 0xf695, 0xd94, 0x16aa, 0xaab5, 0x9b4, 0x14b6, 0x6a57,
	    0xa56, 0x1152a, 0x1d2a, 0xd54, 0xd5aa, 0x156a, 0x96c, 0x94ae,
	    0x14ae, 0xa4c, 0x7d26, 0x1b2a, 0xeb55, 0xad4, 0x12da, 0xa95d,
	    0x95a, 0x149a, 0x9a4d, 0x1a4a, 0x11aa5, 0x16a8, 0x16d4, 0xd2da,
	    0x12b6, 0x936, 0x9497, 0x1496, 0x1564b, 0xd4a, 0xda8, 0xd5b4,
	    0x156c, 0x12ae, 0xa92f, 0x92e, 0xc96, 0x6d4a, 0x1d4a, 0x10d65,
	    0xb58, 0x156c, 0xb26d, 0x125c, 0x192c, 0x9a95, 0x1a94, 0x1b4a,
	    0x4b55, 0xad4, 0xf55b, 0x4ba, 0x125a, 0xb92b, 0x152a, 0x1694,
	    0x96aa, 0x15aa, 0x12ab5, 0x974, 0x14b6, 0xca57, 0xa56, 0x1526,
	    0x8e95, 0xd54, 0x15aa, 0x49b5, 0x96c, 0xd4ae, 0x149c, 0x1a4c,
	    0xbd26, 0x1aa6, 0xb54, 0x6d6a, 0x12da, 0x1695d, 0x95a, 0x149a,
	    0xda4b, 0x1a4a, 0x1aa4, 0xbb54, 0x16b4, 0xada, 0x495b, 0x936,
	    0xf497, 0x1496, 0x154a, 0xb6a5, 0xda4, 0x15b4, 0x6ab6, 0x126e,
	    0x1092f, 0x92e, 0xc96, 0xcd4a, 0x1d4a, 0xd64, 0x956c, 0x155c,
	    0x125c, 0x792e, 0x192c, 0xfa95, 0x1a94, 0x1b4a, 0xab55, 0xad4,
	    0x14da, 0x8a5d, 0xa5a, 0x1152b, 0x152a, 0x1694, 0xd6aa, 0x15aa,
	    0xab4, 0x94ba, 0x14b6, 0xa56, 0x7527, 0xd26, 0xee53, 0xd54, 0x15aa,
	    0xa9b5, 0x96c, 0x14ae, 0x8a4e, 0x1a4c, 0x11d26, 0x1aa4, 0x1b54,
	    0xcd6a, 0xada, 0x95c, 0x949d, 0x149a, 0x1a2a, 0x5b25, 0x1aa4,
	    0xfb52, 0x16b4, 0xaba, 0xa95b, 0x936, 0x1496, 0x9a4b, 0x154a,
	    0x136a5, 0xda4, 0x15ac];
	
	// Table of Chinese New Years from year 1888 to 2111
	// 
	// bits (0 to 4):   solar day
	// bits (5 to 8):   solar month
	// bits (9 to 20):  solar year
	var CHINESE_NEW_YEAR = [1887, 0xec04c, 0xec23f, 0xec435, 0xec649,
	    0xec83e, 0xeca51, 0xecc46, 0xece3a, 0xed04d, 0xed242, 0xed436,
	    0xed64a, 0xed83f, 0xeda53, 0xedc48, 0xede3d, 0xee050, 0xee244,
	    0xee439, 0xee64d, 0xee842, 0xeea36, 0xeec4a, 0xeee3e, 0xef052,
	    0xef246, 0xef43a, 0xef64e, 0xef843, 0xefa37, 0xefc4b, 0xefe41,
	    0xf0054, 0xf0248, 0xf043c, 0xf0650, 0xf0845, 0xf0a38, 0xf0c4d,
	    0xf0e42, 0xf1037, 0xf124a, 0xf143e, 0xf1651, 0xf1846, 0xf1a3a,
	    0xf1c4e, 0xf1e44, 0xf2038, 0xf224b, 0xf243f, 0xf2653, 0xf2848,
	    0xf2a3b, 0xf2c4f, 0xf2e45, 0xf3039, 0xf324d, 0xf3442, 0xf3636,
	    0xf384a, 0xf3a3d, 0xf3c51, 0xf3e46, 0xf403b, 0xf424e, 0xf4443,
	    0xf4638, 0xf484c, 0xf4a3f, 0xf4c52, 0xf4e48, 0xf503c, 0xf524f,
	    0xf5445, 0xf5639, 0xf584d, 0xf5a42, 0xf5c35, 0xf5e49, 0xf603e,
	    0xf6251, 0xf6446, 0xf663b, 0xf684f, 0xf6a43, 0xf6c37, 0xf6e4b,
	    0xf703f, 0xf7252, 0xf7447, 0xf763c, 0xf7850, 0xf7a45, 0xf7c39,
	    0xf7e4d, 0xf8042, 0xf8254, 0xf8449, 0xf863d, 0xf8851, 0xf8a46,
	    0xf8c3b, 0xf8e4f, 0xf9044, 0xf9237, 0xf944a, 0xf963f, 0xf9853,
	    0xf9a47, 0xf9c3c, 0xf9e50, 0xfa045, 0xfa238, 0xfa44c, 0xfa641,
	    0xfa836, 0xfaa49, 0xfac3d, 0xfae52, 0xfb047, 0xfb23a, 0xfb44e,
	    0xfb643, 0xfb837, 0xfba4a, 0xfbc3f, 0xfbe53, 0xfc048, 0xfc23c,
	    0xfc450, 0xfc645, 0xfc839, 0xfca4c, 0xfcc41, 0xfce36, 0xfd04a,
	    0xfd23d, 0xfd451, 0xfd646, 0xfd83a, 0xfda4d, 0xfdc43, 0xfde37,
	    0xfe04b, 0xfe23f, 0xfe453, 0xfe648, 0xfe83c, 0xfea4f, 0xfec44,
	    0xfee38, 0xff04c, 0xff241, 0xff436, 0xff64a, 0xff83e, 0xffa51,
	    0xffc46, 0xffe3a, 0x10004e, 0x100242, 0x100437, 0x10064b, 0x100841,
	    0x100a53, 0x100c48, 0x100e3c, 0x10104f, 0x101244, 0x101438,
	    0x10164c, 0x101842, 0x101a35, 0x101c49, 0x101e3d, 0x102051,
	    0x102245, 0x10243a, 0x10264e, 0x102843, 0x102a37, 0x102c4b,
	    0x102e3f, 0x103053, 0x103247, 0x10343b, 0x10364f, 0x103845,
	    0x103a38, 0x103c4c, 0x103e42, 0x104036, 0x104249, 0x10443d,
	    0x104651, 0x104846, 0x104a3a, 0x104c4e, 0x104e43, 0x105038,
	    0x10524a, 0x10543e, 0x105652, 0x105847, 0x105a3b, 0x105c4f,
	    0x105e45, 0x106039, 0x10624c, 0x106441, 0x106635, 0x106849,
	    0x106a3d, 0x106c51, 0x106e47, 0x10703c, 0x10724f, 0x107444,
	    0x107638, 0x10784c, 0x107a3f, 0x107c53, 0x107e48];
	
	function toLunar(yearOrDate, monthOrResult, day, result) {
	    var solarDate;
	    var lunarDate;
	
	    if(typeof yearOrDate === 'object') {
	        solarDate = yearOrDate;
	        lunarDate = monthOrResult || {};
	
	    } else {
	        var isValidYear = (typeof yearOrDate === 'number') &&
	            (yearOrDate >= 1888) && (yearOrDate <= 2111);
	        if(!isValidYear)
	            throw new Error("Solar year outside range 1888-2111");
	
	        var isValidMonth = (typeof monthOrResult === 'number') &&
	            (monthOrResult >= 1) && (monthOrResult <= 12);
	        if(!isValidMonth)
	            throw new Error("Solar month outside range 1 - 12");
	
	        var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 31);
	        if(!isValidDay)
	            throw new Error("Solar day outside range 1 - 31");
	
	        solarDate = {
	            year: yearOrDate,
	            month: monthOrResult,
	            day: day,
	        };
	        lunarDate = result || {};
	    }
	
	    // Compute Chinese new year and lunar year
	    var chineseNewYearPackedDate =
	        CHINESE_NEW_YEAR[solarDate.year - CHINESE_NEW_YEAR[0]];
	
	    var packedDate = (solarDate.year << 9) | (solarDate.month << 5)
	        | solarDate.day;
	
	    lunarDate.year = (packedDate >= chineseNewYearPackedDate) ?
	        solarDate.year :
	        solarDate.year - 1;
	
	    chineseNewYearPackedDate =
	        CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
	
	    var y = (chineseNewYearPackedDate >> 9) & 0xFFF;
	    var m = (chineseNewYearPackedDate >> 5) & 0x0F;
	    var d = chineseNewYearPackedDate & 0x1F;
	
	    // Compute days from new year
	    var daysFromNewYear;
	
	    var chineseNewYearJSDate = new Date(y, m -1, d);
	    var jsDate = new Date(solarDate.year, solarDate.month - 1, solarDate.day);
	
	    daysFromNewYear = Math.round(
	        (jsDate - chineseNewYearJSDate) / (24 * 3600 * 1000));
	
	    // Compute lunar month and day
	    var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
	
	    var i;
	    for(i = 0; i < 13; i++) {
	        var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;
	
	        if (daysFromNewYear < daysInMonth) {
	            break;
	        }
	
	        daysFromNewYear -= daysInMonth;
	    }
	
	    var intercalaryMonth = monthDaysTable >> 13;
	    if (!intercalaryMonth || i < intercalaryMonth) {
	        lunarDate.isIntercalary = false;
	        lunarDate.month = 1 + i;
	    } else if (i === intercalaryMonth) {
	        lunarDate.isIntercalary = true;
	        lunarDate.month = i;
	    } else {
	        lunarDate.isIntercalary = false;
	        lunarDate.month = i;
	    }
	
	    lunarDate.day = 1 + daysFromNewYear;
	
	    return lunarDate;
	}
	
	function toSolar(yearOrDate, monthOrResult, day, isIntercalaryOrResult, result) {
	    var solarDate;
	    var lunarDate;
	
	    if(typeof yearOrDate === 'object') {
	        lunarDate = yearOrDate;
	        solarDate = monthOrResult || {};
	
	    } else {
	        var isValidYear = (typeof yearOrDate === 'number') &&
	            (yearOrDate >= 1888) && (yearOrDate <= 2111);
	        if(!isValidYear)
	            throw new Error("Lunar year outside range 1888-2111");
	
	        var isValidMonth = (typeof monthOrResult === 'number') &&
	            (monthOrResult >= 1) && (monthOrResult <= 12);
	        if(!isValidMonth)
	            throw new Error("Lunar month outside range 1 - 12");
	
	        var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 30);
	        if(!isValidDay)
	            throw new Error("Lunar day outside range 1 - 30");
	
	        var isIntercalary;
	        if(typeof isIntercalaryOrResult === 'object') {
	            isIntercalary = false;
	            solarDate = isIntercalaryOrResult;
	        } else {
	            isIntercalary = !!isIntercalaryOrResult;
	            solarDate = result || {};
	        }
	
	        lunarDate = {
	            year: yearOrDate,
	            month: monthOrResult,
	            day: day,
	            isIntercalary: isIntercalary,
	        };
	    }
	
	    // Compute days from new year
	    var daysFromNewYear;
	
	    daysFromNewYear = lunarDate.day - 1;
	
	    var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
	    var intercalaryMonth = monthDaysTable >> 13;
	
	    var monthsFromNewYear;
	    if (!intercalaryMonth) {
	        monthsFromNewYear = lunarDate.month - 1;
	    } else if (lunarDate.month > intercalaryMonth) {
	        monthsFromNewYear = lunarDate.month;
	    } else if (lunarDate.isIntercalary) {
	        monthsFromNewYear = lunarDate.month;
	    } else {
	        monthsFromNewYear = lunarDate.month - 1;
	    }
	
	    for(var i = 0; i < monthsFromNewYear; i++) {
	        var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;
	        daysFromNewYear += daysInMonth;
	    }
	
	    // Compute Chinese new year
	    var packedDate = CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
	
	    var y = (packedDate >> 9) & 0xFFF;
	    var m = (packedDate >> 5) & 0x0F;
	    var d = packedDate & 0x1F;
	
	    // Compute solar date
	    var jsDate = new Date(y, m - 1, d + daysFromNewYear);
	
	    solarDate.year = jsDate.getFullYear();
	    solarDate.month = 1 + jsDate.getMonth();
	    solarDate.day = jsDate.getDate();
	
	    return solarDate;
	}
	
	
	},{"../main":569,"object-assign":455}],556:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Coptic calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Coptic calendar.
	    See <a href="http://en.wikipedia.org/wiki/Coptic_calendar">http://en.wikipedia.org/wiki/Coptic_calendar</a>.
	    See also Calendrical Calculations: The Millennium Edition
	    (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
	    @class CopticCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function CopticCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	CopticCalendar.prototype = new main.baseCalendar;
	
	assign(CopticCalendar.prototype, {
	    /** The calendar name.
	        @memberof CopticCalendar */
	    name: 'Coptic',
	    /** Julian date of start of Coptic epoch: 29 August 284 CE (Gregorian).
	        @memberof CopticCalendar */
	    jdEpoch: 1825029.5,
	    /** Days per month in a common year.
	        @memberof CopticCalendar */
	    daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof CopticCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof CopticCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof CopticCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof CopticCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof CopticCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Coptic',
	            epochs: ['BAM', 'AM'],
	            monthNames: ['Thout', 'Paopi', 'Hathor', 'Koiak', 'Tobi', 'Meshir',
	            'Paremhat', 'Paremoude', 'Pashons', 'Paoni', 'Epip', 'Mesori', 'Pi Kogi Enavot'],
	            monthNamesShort: ['Tho', 'Pao', 'Hath', 'Koi', 'Tob', 'Mesh',
	            'Pat', 'Pad', 'Pash', 'Pao', 'Epi', 'Meso', 'PiK'],
	            dayNames: ['Tkyriaka', 'Pesnau', 'Pshoment', 'Peftoou', 'Ptiou', 'Psoou', 'Psabbaton'],
	            dayNamesShort: ['Tky', 'Pes', 'Psh', 'Pef', 'Pti', 'Pso', 'Psa'],
	            dayNamesMin: ['Tk', 'Pes', 'Psh', 'Pef', 'Pt', 'Pso', 'Psa'],
	            digits: null,
	            dateFormat: 'dd/mm/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
	        return year % 4 === 3 || year % 4 === -1;
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay,
	            main.local.invalidYear || main.regionalOptions[''].invalidYear);
	        return 13;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number) the month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param month {number} The month to examine.
	        @param day {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof CopticCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number) the month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        if (year < 0) { year++; } // No year zero
	        return date.day() + (date.month() - 1) * 30 +
	            (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof CopticCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        var c = Math.floor(jd) + 0.5 - this.jdEpoch;
	        var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
	        if (year <= 0) { year--; } // No year zero
	        c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
	        var month = Math.floor(c / 30) + 1;
	        var day = c - (month - 1) * 30 + 1;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Coptic calendar implementation
	main.calendars.coptic = CopticCalendar;
	
	
	},{"../main":569,"object-assign":455}],557:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Discworld calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Discworld calendar - Unseen University version.
	    See also <a href="http://wiki.lspace.org/mediawiki/Discworld_calendar">http://wiki.lspace.org/mediawiki/Discworld_calendar</a>
	    and <a href="http://discworld.wikia.com/wiki/Discworld_calendar">http://discworld.wikia.com/wiki/Discworld_calendar</a>.
	    @class DiscworldCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function DiscworldCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	DiscworldCalendar.prototype = new main.baseCalendar;
	
	assign(DiscworldCalendar.prototype, {
	    /** The calendar name.
	        @memberof DiscworldCalendar */
	    name: 'Discworld',
	    /** Julian date of start of Discworld epoch: 1 January 0001 CE.
	        @memberof DiscworldCalendar */
	    jdEpoch: 1721425.5,
	    /** Days per month in a common year.
	        @memberof DiscworldCalendar */
	    daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof DiscworldCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof DiscworldCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof DiscworldCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof DiscworldCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof DiscworldCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Discworld',
	            epochs: ['BUC', 'UC'],
	            monthNames: ['Ick', 'Offle', 'February', 'March', 'April', 'May', 'June',
	            'Grune', 'August', 'Spune', 'Sektober', 'Ember', 'December'],
	            monthNamesShort: ['Ick', 'Off', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Gru', 'Aug', 'Spu', 'Sek', 'Emb', 'Dec'],
	            dayNames: ['Sunday', 'Octeday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Oct', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Oc', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 2,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return false;
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return 13;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return 400;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 8) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1];
	    },
	
	    /** Retrieve the number of days in a week.
	        @memberof DiscworldCalendar
	        @return {number} The number of days. */
	    daysInWeek: function() {
	        return 8;
	    },
	
	    /** Retrieve the day of the week for a date.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The day of the week: 0 to number of days - 1.
	        @throws Error if an invalid date or a different calendar used. */
	    dayOfWeek: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        return (date.day() + 1) % 8;
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        var dow = this.dayOfWeek(year, month, day);
	        return (dow >= 2 && dow <= 6);
	    },
	
	    /** Retrieve additional information about a date.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {object} Additional information - contents depends on calendar.
	        @throws Error if an invalid date or a different calendar used. */
	    extraInfo: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        return {century: centuries[Math.floor((date.year() - 1) / 100) + 1] || ''};
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof DiscworldCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year() + (date.year() < 0 ? 1 : 0);
	        month = date.month();
	        day = date.day();
	        return day + (month > 1 ? 16 : 0) + (month > 2 ? (month - 2) * 32 : 0) +
	            (year - 1) * 400 + this.jdEpoch - 1;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof DiscworldCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd + 0.5) - Math.floor(this.jdEpoch) - 1;
	        var year = Math.floor(jd / 400) + 1;
	        jd -= (year - 1) * 400;
	        jd += (jd > 15 ? 16 : 0);
	        var month = Math.floor(jd / 32) + 1;
	        var day = jd - (month - 1) * 32 + 1;
	        return this.newDate(year <= 0 ? year - 1 : year, month, day);
	    }
	});
	
	// Names of the centuries
	var centuries = {
	    20: 'Fruitbat',
	    21: 'Anchovy'
	};
	
	// Discworld calendar implementation
	main.calendars.discworld = DiscworldCalendar;
	
	
	},{"../main":569,"object-assign":455}],558:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Ethiopian calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Ethiopian calendar.
	    See <a href="http://en.wikipedia.org/wiki/Ethiopian_calendar">http://en.wikipedia.org/wiki/Ethiopian_calendar</a>.
	    See also Calendrical Calculations: The Millennium Edition
	    (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
	    @class EthiopianCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function EthiopianCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	EthiopianCalendar.prototype = new main.baseCalendar;
	
	assign(EthiopianCalendar.prototype, {
	    /** The calendar name.
	        @memberof EthiopianCalendar */
	    name: 'Ethiopian',
	    /** Julian date of start of Ethiopian epoch: 27 August 8 CE (Gregorian).
	        @memberof EthiopianCalendar */
	    jdEpoch: 1724220.5,
	    /** Days per month in a common year.
	        @memberof EthiopianCalendar */
	    daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof EthiopianCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof EthiopianCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof EthiopianCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof EthiopianCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof EthiopianCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Ethiopian',
	            epochs: ['BEE', 'EE'],
	            monthNames: ['Meskerem', 'Tikemet', 'Hidar', 'Tahesas', 'Tir', 'Yekatit',
	            'Megabit', 'Miazia', 'Genbot', 'Sene', 'Hamle', 'Nehase', 'Pagume'],
	            monthNamesShort: ['Mes', 'Tik', 'Hid', 'Tah', 'Tir', 'Yek',
	            'Meg', 'Mia', 'Gen', 'Sen', 'Ham', 'Neh', 'Pag'],
	            dayNames: ['Ehud', 'Segno', 'Maksegno', 'Irob', 'Hamus', 'Arb', 'Kidame'],
	            dayNamesShort: ['Ehu', 'Seg', 'Mak', 'Iro', 'Ham', 'Arb', 'Kid'],
	            dayNamesMin: ['Eh', 'Se', 'Ma', 'Ir', 'Ha', 'Ar', 'Ki'],
	            digits: null,
	            dateFormat: 'dd/mm/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
	        return year % 4 === 3 || year % 4 === -1;
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay,
	            main.local.invalidYear || main.regionalOptions[''].invalidYear);
	        return 13;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof EthiopianCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        if (year < 0) { year++; } // No year zero
	        return date.day() + (date.month() - 1) * 30 +
	            (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof EthiopianCalendar
	        @param jd {number} the Julian date to convert.
	        @return {CDate} the equivalent date. */
	    fromJD: function(jd) {
	        var c = Math.floor(jd) + 0.5 - this.jdEpoch;
	        var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
	        if (year <= 0) { year--; } // No year zero
	        c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
	        var month = Math.floor(c / 30) + 1;
	        var day = c - (month - 1) * 30 + 1;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Ethiopian calendar implementation
	main.calendars.ethiopian = EthiopianCalendar;
	
	
	},{"../main":569,"object-assign":455}],559:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Hebrew calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Hebrew civil calendar.
	    Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
	    See also <a href="http://en.wikipedia.org/wiki/Hebrew_calendar">http://en.wikipedia.org/wiki/Hebrew_calendar</a>.
	    @class HebrewCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function HebrewCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	HebrewCalendar.prototype = new main.baseCalendar;
	
	assign(HebrewCalendar.prototype, {
	    /** The calendar name.
	        @memberof HebrewCalendar */
	    name: 'Hebrew',
	    /** Julian date of start of Hebrew epoch: 7 October 3761 BCE.
	        @memberof HebrewCalendar */
	    jdEpoch: 347995.5,
	    /** Days per month in a common year.
	        @memberof HebrewCalendar */
	    daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof HebrewCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof HebrewCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof HebrewCalendar */
	    firstMonth: 7,
	    /** The minimum day number.
	        @memberof HebrewCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof HebrewCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Hebrew',
	            epochs: ['BAM', 'AM'],
	            monthNames: ['Nisan', 'Iyar', 'Sivan', 'Tammuz', 'Av', 'Elul',
	            'Tishrei', 'Cheshvan', 'Kislev', 'Tevet', 'Shevat', 'Adar', 'Adar II'],
	            monthNamesShort: ['Nis', 'Iya', 'Siv', 'Tam', 'Av', 'Elu', 'Tis', 'Che', 'Kis', 'Tev', 'She', 'Ada', 'Ad2'],
	            dayNames: ['Yom Rishon', 'Yom Sheni', 'Yom Shlishi', 'Yom Revi\'i', 'Yom Chamishi', 'Yom Shishi', 'Yom Shabbat'],
	            dayNamesShort: ['Ris', 'She', 'Shl', 'Rev', 'Cha', 'Shi', 'Sha'],
	            dayNamesMin: ['Ri','She','Shl','Re','Ch','Shi','Sha'],
	            digits: null,
	            dateFormat: 'dd/mm/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return this._leapYear(date.year());
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof HebrewCalendar
	        @private
	        @param year {number} The year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    _leapYear: function(year) {
	        year = (year < 0 ? year + 1 : year);
	        return mod(year * 7 + 1, 19) < 7;
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return this._leapYear(year.year ? year.year() : year) ? 13 : 12;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        year = date.year();
	        return this.toJD((year === -1 ? +1 : year + 1), 7, 1) - this.toJD(year, 7, 1);
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        if (year.year) {
	            month = year.month();
	            year = year.year();
	        }
	        this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return (month === 12 && this.leapYear(year) ? 30 : // Adar I
	                (month === 8 && mod(this.daysInYear(year), 10) === 5 ? 30 : // Cheshvan in shlemah year
	                (month === 9 && mod(this.daysInYear(year), 10) === 3 ? 29 : // Kislev in chaserah year
	                this.daysPerMonth[month - 1])));
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return this.dayOfWeek(year, month, day) !== 6;
	    },
	
	    /** Retrieve additional information about a date - year type.
	        @memberof HebrewCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {object} Additional information - contents depends on calendar.
	        @throws Error if an invalid date or a different calendar used. */
	    extraInfo: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        return {yearType: (this.leapYear(date) ? 'embolismic' : 'common') + ' ' +
	            ['deficient', 'regular', 'complete'][this.daysInYear(date) % 10 - 3]};
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof HebrewCalendar
	        @param year {CDate)|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        month = date.month();
	        day = date.day();
	        var adjYear = (year <= 0 ? year + 1 : year);
	        var jd = this.jdEpoch + this._delay1(adjYear) +
	            this._delay2(adjYear) + day + 1;
	        if (month < 7) {
	            for (var m = 7; m <= this.monthsInYear(year); m++) {
	                jd += this.daysInMonth(year, m);
	            }
	            for (var m = 1; m < month; m++) {
	                jd += this.daysInMonth(year, m);
	            }
	        }
	        else {
	            for (var m = 7; m < month; m++) {
	                jd += this.daysInMonth(year, m);
	            }
	        }
	        return jd;
	    },
	
	    /** Test for delay of start of new year and to avoid
	        Sunday, Wednesday, or Friday as start of the new year.
	        @memberof HebrewCalendar
	        @private
	        @param year {number} The year to examine.
	        @return {number} The days to offset by. */
	    _delay1: function(year) {
	        var months = Math.floor((235 * year - 234) / 19);
	        var parts = 12084 + 13753 * months;
	        var day = months * 29 + Math.floor(parts / 25920);
	        if (mod(3 * (day + 1), 7) < 3) {
	            day++;
	        }
	        return day;
	    },
	
	    /** Check for delay in start of new year due to length of adjacent years.
	        @memberof HebrewCalendar
	        @private
	        @param year {number} The year to examine.
	        @return {number} The days to offset by. */
	    _delay2: function(year) {
	        var last = this._delay1(year - 1);
	        var present = this._delay1(year);
	        var next = this._delay1(year + 1);
	        return ((next - present) === 356 ? 2 : ((present - last) === 382 ? 1 : 0));
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof HebrewCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd) + 0.5;
	        var year = Math.floor(((jd - this.jdEpoch) * 98496.0) / 35975351.0) - 1;
	        while (jd >= this.toJD((year === -1 ? +1 : year + 1), 7, 1)) {
	            year++;
	        }
	        var month = (jd < this.toJD(year, 1, 1)) ? 7 : 1;
	        while (jd > this.toJD(year, month, this.daysInMonth(year, month))) {
	            month++;
	        }
	        var day = jd - this.toJD(year, month, 1) + 1;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Modulus function which works for non-integers.
	function mod(a, b) {
	    return a - (b * Math.floor(a / b));
	}
	
	// Hebrew calendar implementation
	main.calendars.hebrew = HebrewCalendar;
	
	
	},{"../main":569,"object-assign":455}],560:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Islamic calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Islamic or '16 civil' calendar.
	    Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
	    See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar">http://en.wikipedia.org/wiki/Islamic_calendar</a>.
	    @class IslamicCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function IslamicCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	IslamicCalendar.prototype = new main.baseCalendar;
	
	assign(IslamicCalendar.prototype, {
	    /** The calendar name.
	        @memberof IslamicCalendar */
	    name: 'Islamic',
	    /** Julian date of start of Islamic epoch: 16 July 622 CE.
	        @memberof IslamicCalendar */
	    jdEpoch: 1948439.5,
	    /** Days per month in a common year.
	        @memberof IslamicCalendar */
	    daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof IslamicCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof IslamicCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof IslamicCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof IslamicCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof IslamicCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Islamic',
	            epochs: ['BH', 'AH'],
	            monthNames: ['Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' al-thani', 'Jumada al-awwal', 'Jumada al-thani',
	            'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
	            monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
	            dayNames: ['Yawm al-ahad', 'Yawm al-ithnayn', 'Yawm ath-thulaathaa\'',
	            'Yawm al-arbi\'aa\'', 'Yawm al-khamīs', 'Yawm al-jum\'a', 'Yawm as-sabt'],
	            dayNamesShort: ['Aha', 'Ith', 'Thu', 'Arb', 'Kha', 'Jum', 'Sab'],
	            dayNamesMin: ['Ah','It','Th','Ar','Kh','Ju','Sa'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 6,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return (date.year() * 11 + 14) % 30 < 11;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        return (this.leapYear(year) ? 355 : 354);
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return this.dayOfWeek(year, month, day) !== 5;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof IslamicCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        month = date.month();
	        day = date.day();
	        year = (year <= 0 ? year + 1 : year);
	        return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 +
	            Math.floor((3 + (11 * year)) / 30) + this.jdEpoch - 1;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof IslamicCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd) + 0.5;
	        var year = Math.floor((30 * (jd - this.jdEpoch) + 10646) / 10631);
	        year = (year <= 0 ? year - 1 : year);
	        var month = Math.min(12, Math.ceil((jd - 29 - this.toJD(year, 1, 1)) / 29.5) + 1);
	        var day = jd - this.toJD(year, month, 1) + 1;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Islamic (16 civil) calendar implementation
	main.calendars.islamic = IslamicCalendar;
	
	
	},{"../main":569,"object-assign":455}],561:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Julian calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Julian calendar.
	    Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
	    See also <a href="http://en.wikipedia.org/wiki/Julian_calendar">http://en.wikipedia.org/wiki/Julian_calendar</a>.
	    @class JulianCalendar
	    @augments BaseCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function JulianCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	JulianCalendar.prototype = new main.baseCalendar;
	
	assign(JulianCalendar.prototype, {
	    /** The calendar name.
	        @memberof JulianCalendar */
	    name: 'Julian',
	    /** Julian date of start of Julian epoch: 1 January 0001 AD = 30 December 0001 BCE.
	        @memberof JulianCalendar */
	    jdEpoch: 1721423.5,
	    /** Days per month in a common year.
	        @memberof JulianCalendar */
	    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof JulianCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof JulianCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof JulianCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof JulianCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof JulianCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Julian',
	            epochs: ['BC', 'AD'],
	            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
	            'July', 'August', 'September', 'October', 'November', 'December'],
	            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'mm/dd/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof JulianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = (date.year() < 0 ? date.year() + 1 : date.year()); // No year zero
	        return (year % 4) === 0;
	    },
	
	    /** Determine the week of the year for a date - ISO 8601.
	        @memberof JulianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Thursday of this week starting on Monday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof JulianCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof JulianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} True if a week day, false if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof JulianCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        month = date.month();
	        day = date.day();
	        if (year < 0) { year++; } // No year zero
	        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
	        if (month <= 2) {
	            year--;
	            month += 12;
	        }
	        return Math.floor(365.25 * (year + 4716)) +
	            Math.floor(30.6001 * (month + 1)) + day - 1524.5;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof JulianCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
	        var a = Math.floor(jd + 0.5);
	        var b = a + 1524;
	        var c = Math.floor((b - 122.1) / 365.25);
	        var d = Math.floor(365.25 * c);
	        var e = Math.floor((b - d) / 30.6001);
	        var month = e - Math.floor(e < 14 ? 1 : 13);
	        var year = c - Math.floor(month > 2 ? 4716 : 4715);
	        var day = b - d - Math.floor(30.6001 * e);
	        if (year <= 0) { year--; } // No year zero
	        return this.newDate(year, month, day);
	    }
	});
	
	// Julian calendar implementation
	main.calendars.julian = JulianCalendar;
	
	
	},{"../main":569,"object-assign":455}],562:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Mayan calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Mayan Long Count calendar.
	    See also <a href="http://en.wikipedia.org/wiki/Mayan_calendar">http://en.wikipedia.org/wiki/Mayan_calendar</a>.
	    @class MayanCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function MayanCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	MayanCalendar.prototype = new main.baseCalendar;
	
	assign(MayanCalendar.prototype, {
	    /** The calendar name.
	        @memberof MayanCalendar */
	    name: 'Mayan',
	    /** Julian date of start of Mayan epoch: 11 August 3114 BCE.
	        @memberof MayanCalendar */
	    jdEpoch: 584282.5,
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof MayanCalendar */
	    hasYearZero: true,
	    /** The minimum month number.
	        @memberof MayanCalendar */
	    minMonth: 0,
	    /** The first month in the year.
	        @memberof MayanCalendar */
	    firstMonth: 0,
	    /** The minimum day number.
	        @memberof MayanCalendar */
	    minDay: 0,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof MayanCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left.
	        @property haabMonths {string[]} The names of the Haab months.
	        @property tzolkinMonths {string[]} The names of the Tzolkin months. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Mayan',
	            epochs: ['', ''],
	            monthNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	            '10', '11', '12', '13', '14', '15', '16', '17'],
	            monthNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	            '10', '11', '12', '13', '14', '15', '16', '17'],
	            dayNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
	            dayNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
	            dayNamesMin: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
	            digits: null,
	            dateFormat: 'YYYY.m.d',
	            firstDay: 0,
	            isRTL: false,
	            haabMonths: ['Pop', 'Uo', 'Zip', 'Zotz', 'Tzec', 'Xul', 'Yaxkin', 'Mol', 'Chen', 'Yax',
	            'Zac', 'Ceh', 'Mac', 'Kankin', 'Muan', 'Pax', 'Kayab', 'Cumku', 'Uayeb'],
	            tzolkinMonths: ['Imix', 'Ik', 'Akbal', 'Kan', 'Chicchan', 'Cimi', 'Manik', 'Lamat', 'Muluc', 'Oc',
	            'Chuen', 'Eb', 'Ben', 'Ix', 'Men', 'Cib', 'Caban', 'Etznab', 'Cauac', 'Ahau']
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return false;
	    },
	
	    /** Format the year, if not a simple sequential number.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to format or the year to format.
	        @return {string} The formatted year.
	        @throws Error if an invalid year or a different calendar used. */
	    formatYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        year = date.year();
	        var baktun = Math.floor(year / 400);
	        year = year % 400;
	        year += (year < 0 ? 400 : 0);
	        var katun = Math.floor(year / 20);
	        return baktun + '.' + katun + '.' + (year % 20);
	    },
	
	    /** Convert from the formatted year back to a single number.
	        @memberof MayanCalendar
	        @param years {string} The year as n.n.n.
	        @return {number} The sequential year.
	        @throws Error if an invalid value is supplied. */
	    forYear: function(years) {
	        years = years.split('.');
	        if (years.length < 3) {
	            throw 'Invalid Mayan year';
	        }
	        var year = 0;
	        for (var i = 0; i < years.length; i++) {
	            var y = parseInt(years[i], 10);
	            if (Math.abs(y) > 19 || (i > 0 && y < 0)) {
	                throw 'Invalid Mayan year';
	            }
	            year = year * 20 + y;
	        }
	        return year;
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return 18;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        this._validate(year, month, day, main.local.invalidDate);
	        return 0;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return 360;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return 20;
	    },
	
	    /** Retrieve the number of days in a week.
	        @memberof MayanCalendar
	        @return {number} The number of days. */
	    daysInWeek: function() {
	        return 5; // Just for formatting
	    },
	
	    /** Retrieve the day of the week for a date.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The day of the week: 0 to number of days - 1.
	        @throws Error if an invalid date or a different calendar used. */
	    dayOfWeek: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        return date.day();
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        this._validate(year, month, day, main.local.invalidDate);
	        return true;
	    },
	
	    /** Retrieve additional information about a date - Haab and Tzolkin equivalents.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {object} Additional information - contents depends on calendar.
	        @throws Error if an invalid date or a different calendar used. */
	    extraInfo: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        var jd = date.toJD();
	        var haab = this._toHaab(jd);
	        var tzolkin = this._toTzolkin(jd);
	        return {haabMonthName: this.local.haabMonths[haab[0] - 1],
	            haabMonth: haab[0], haabDay: haab[1],
	            tzolkinDayName: this.local.tzolkinMonths[tzolkin[0] - 1],
	            tzolkinDay: tzolkin[0], tzolkinTrecena: tzolkin[1]};
	    },
	
	    /** Retrieve Haab date from a Julian date.
	        @memberof MayanCalendar
	        @private
	        @param jd  {number} The Julian date.
	        @return {number[]} Corresponding Haab month and day. */
	    _toHaab: function(jd) {
	        jd -= this.jdEpoch;
	        var day = mod(jd + 8 + ((18 - 1) * 20), 365);
	        return [Math.floor(day / 20) + 1, mod(day, 20)];
	    },
	
	    /** Retrieve Tzolkin date from a Julian date.
	        @memberof MayanCalendar
	        @private
	        @param jd {number} The Julian date.
	        @return {number[]} Corresponding Tzolkin day and trecena. */
	    _toTzolkin: function(jd) {
	        jd -= this.jdEpoch;
	        return [amod(jd + 20, 20), amod(jd + 4, 13)];
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof MayanCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        return date.day() + (date.month() * 20) + (date.year() * 360) + this.jdEpoch;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof MayanCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd) + 0.5 - this.jdEpoch;
	        var year = Math.floor(jd / 360);
	        jd = jd % 360;
	        jd += (jd < 0 ? 360 : 0);
	        var month = Math.floor(jd / 20);
	        var day = jd % 20;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Modulus function which works for non-integers.
	function mod(a, b) {
	    return a - (b * Math.floor(a / b));
	}
	
	// Modulus function which returns numerator if modulus is zero.
	function amod(a, b) {
	    return mod(a - 1, b) + 1;
	}
	
	// Mayan calendar implementation
	main.calendars.mayan = MayanCalendar;
	
	
	},{"../main":569,"object-assign":455}],563:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/* http://keith-wood.name/calendars.html
	   Nanakshahi calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Nanakshahi calendar.
	    See also <a href="https://en.wikipedia.org/wiki/Nanakshahi_calendar">https://en.wikipedia.org/wiki/Nanakshahi_calendar</a>.
	    @class NanakshahiCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function NanakshahiCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	NanakshahiCalendar.prototype = new main.baseCalendar;
	
	var gregorian = main.instance('gregorian');
	
	assign(NanakshahiCalendar.prototype, {
	    /** The calendar name.
	        @memberof NanakshahiCalendar */
	    name: 'Nanakshahi',
	    /** Julian date of start of Nanakshahi epoch: 14 March 1469 CE.
	        @memberof NanakshahiCalendar */
	    jdEpoch: 2257673.5,
	    /** Days per month in a common year.
	        @memberof NanakshahiCalendar */
	    daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof NanakshahiCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof NanakshahiCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof NanakshahiCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof NanakshahiCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof NanakshahiCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Nanakshahi',
	            epochs: ['BN', 'AN'],
	            monthNames: ['Chet', 'Vaisakh', 'Jeth', 'Harh', 'Sawan', 'Bhadon',
	            'Assu', 'Katak', 'Maghar', 'Poh', 'Magh', 'Phagun'],
	            monthNamesShort: ['Che', 'Vai', 'Jet', 'Har', 'Saw', 'Bha', 'Ass', 'Kat', 'Mgr', 'Poh', 'Mgh', 'Pha'],
	            dayNames: ['Somvaar', 'Mangalvar', 'Budhvaar', 'Veervaar', 'Shukarvaar', 'Sanicharvaar', 'Etvaar'],
	            dayNamesShort: ['Som', 'Mangal', 'Budh', 'Veer', 'Shukar', 'Sanichar', 'Et'],
	            dayNamesMin: ['So', 'Ma', 'Bu', 'Ve', 'Sh', 'Sa', 'Et'],
	            digits: null,
	            dateFormat: 'dd-mm-yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof NanakshahiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay,
	            main.local.invalidYear || main.regionalOptions[''].invalidYear);
	        return gregorian.leapYear(date.year() + (date.year() < 1 ? 1 : 0) + 1469);
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof NanakshahiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Monday of this week starting on Monday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(1 - (checkDate.dayOfWeek() || 7), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof NanakshahiCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof NanakshahiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof NanakshahiCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidMonth);
	        var year = date.year();
	        if (year < 0) { year++; } // No year zero
	        var doy = date.day();
	        for (var m = 1; m < date.month(); m++) {
	            doy += this.daysPerMonth[m - 1];
	        }
	        return doy + gregorian.toJD(year + 1468, 3, 13);
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof NanakshahiCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd + 0.5);
	        var year = Math.floor((jd - (this.jdEpoch - 1)) / 366);
	        while (jd >= this.toJD(year + 1, 1, 1)) {
	            year++;
	        }
	        var day = jd - Math.floor(this.toJD(year, 1, 1) + 0.5) + 1;
	        var month = 1;
	        while (day > this.daysInMonth(year, month)) {
	            day -= this.daysInMonth(year, month);
	            month++;
	        }
	        return this.newDate(year, month, day);
	    }
	});
	
	// Nanakshahi calendar implementation
	main.calendars.nanakshahi = NanakshahiCalendar;
	
	
	},{"../main":569,"object-assign":455}],564:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Nepali calendar for jQuery v2.0.2.
	   Written by Artur Neumann (ict.projects{at}nepal.inf.org) April 2013.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Nepali civil calendar.
	    Based on the ideas from 
	    <a href="http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net">http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net</a>
	    and <a href="http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html">http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html</a>
	    See also <a href="http://en.wikipedia.org/wiki/Nepali_calendar">http://en.wikipedia.org/wiki/Nepali_calendar</a>
	    and <a href="https://en.wikipedia.org/wiki/Bikram_Samwat">https://en.wikipedia.org/wiki/Bikram_Samwat</a>.
	    @class NepaliCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function NepaliCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	NepaliCalendar.prototype = new main.baseCalendar;
	
	assign(NepaliCalendar.prototype, {
	    /** The calendar name.
	        @memberof NepaliCalendar */
	    name: 'Nepali',
	    /** Julian date of start of Nepali epoch: 14 April 57 BCE.
	        @memberof NepaliCalendar */
	    jdEpoch: 1700709.5,
	    /** Days per month in a common year.
	        @memberof NepaliCalendar */
	    daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof NepaliCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof NepaliCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof NepaliCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof NepaliCalendar */
	    minDay: 1, 
	    /** The number of days in the year.
	        @memberof NepaliCalendar */
	    daysPerYear: 365,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof NepaliCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Nepali',
	            epochs: ['BBS', 'ABS'],
	            monthNames: ['Baisakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin',
	            'Kartik', 'Mangsir', 'Paush', 'Mangh', 'Falgun', 'Chaitra'],
	            monthNamesShort: ['Bai', 'Je', 'As', 'Shra', 'Bha', 'Ash', 'Kar', 'Mang', 'Pau', 'Ma', 'Fal', 'Chai'],
	            dayNames: ['Aaitabaar', 'Sombaar', 'Manglbaar', 'Budhabaar', 'Bihibaar', 'Shukrabaar', 'Shanibaar'],
	            dayNamesShort: ['Aaita', 'Som', 'Mangl', 'Budha', 'Bihi', 'Shukra', 'Shani'],
	            dayNamesMin: ['Aai', 'So', 'Man', 'Bu', 'Bi', 'Shu', 'Sha'],
	            digits: null,
	            dateFormat: 'dd/mm/yyyy',
	            firstDay: 1,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof NepaliCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        return this.daysInYear(year) !== this.daysPerYear;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof NepaliCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof NepaliCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        year = date.year();
	        if (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined') {
	            return this.daysPerYear;
	        }
	        var daysPerYear = 0;
	        for (var month_number = this.minMonth; month_number <= 12; month_number++) {
	            daysPerYear += this.NEPALI_CALENDAR_DATA[year][month_number];
	        }
	        return daysPerYear;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof NepaliCalendar
	        @param year {CDate|number| The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        if (year.year) {
	            month = year.month();
	            year = year.year();
	        }
	        this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined' ?
	            this.daysPerMonth[month - 1] : this.NEPALI_CALENDAR_DATA[year][month]);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof NepaliCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return this.dayOfWeek(year, month, day) !== 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof NepaliCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(nepaliYear, nepaliMonth, nepaliDay) {
	        var date = this._validate(nepaliYear, nepaliMonth, nepaliDay, main.local.invalidDate);
	        nepaliYear = date.year();
	        nepaliMonth = date.month();
	        nepaliDay = date.day();
	        var gregorianCalendar = main.instance();
	        var gregorianDayOfYear = 0; // We will add all the days that went by since
	        // the 1st. January and then we can get the Gregorian Date
	        var nepaliMonthToCheck = nepaliMonth;
	        var nepaliYearToCheck = nepaliYear;
	        this._createMissingCalendarData(nepaliYear);
	        // Get the correct year
	        var gregorianYear = nepaliYear - (nepaliMonthToCheck > 9 || (nepaliMonthToCheck === 9 &&
	            nepaliDay >= this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0]) ? 56 : 57);
	        // First we add the amount of days in the actual Nepali month as the day of year in the
	        // Gregorian one because at least this days are gone since the 1st. Jan. 
	        if (nepaliMonth !== 9) {
	            gregorianDayOfYear = nepaliDay;
	            nepaliMonthToCheck--;
	        }
	        // Now we loop throw all Nepali month and add the amount of days to gregorianDayOfYear 
	        // we do this till we reach Paush (9th month). 1st. January always falls in this month  
	        while (nepaliMonthToCheck !== 9) {
	            if (nepaliMonthToCheck <= 0) {
	                nepaliMonthToCheck = 12;
	                nepaliYearToCheck--;
	            }                
	            gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][nepaliMonthToCheck];
	            nepaliMonthToCheck--;
	        }        
	        // If the date that has to be converted is in Paush (month no. 9) we have to do some other calculation
	        if (nepaliMonth === 9) {
	            // Add the days that are passed since the first day of Paush and substract the
	            // amount of days that lie between 1st. Jan and 1st Paush
	            gregorianDayOfYear += nepaliDay - this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
	            // For the first days of Paush we are now in negative values,
	            // because in the end of the gregorian year we substract
	            // 365 / 366 days (P.S. remember math in school + - gives -)
	            if (gregorianDayOfYear < 0) {
	                gregorianDayOfYear += gregorianCalendar.daysInYear(gregorianYear);
	            }
	        }
	        else {
	            gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][9] -
	                this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
	        }        
	        return gregorianCalendar.newDate(gregorianYear, 1 ,1).add(gregorianDayOfYear, 'd').toJD();
	    },
	    
	    /** Create a new date from a Julian date.
	        @memberof NepaliCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        var gregorianCalendar =  main.instance();
	        var gregorianDate = gregorianCalendar.fromJD(jd);
	        var gregorianYear = gregorianDate.year();
	        var gregorianDayOfYear = gregorianDate.dayOfYear();
	        var nepaliYear = gregorianYear + 56; //this is not final, it could be also +57 but +56 is always true for 1st Jan.
	        this._createMissingCalendarData(nepaliYear);
	        var nepaliMonth = 9; // Jan 1 always fall in Nepali month Paush which is the 9th month of Nepali calendar.
	        // Get the Nepali day in Paush (month 9) of 1st January 
	        var dayOfFirstJanInPaush = this.NEPALI_CALENDAR_DATA[nepaliYear][0];
	        // Check how many days are left of Paush .
	        // Days calculated from 1st Jan till the end of the actual Nepali month, 
	        // we use this value to check if the gregorian Date is in the actual Nepali month.
	        var daysSinceJanFirstToEndOfNepaliMonth =
	            this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] - dayOfFirstJanInPaush + 1;
	        // If the gregorian day-of-year is smaller o equal than the sum of days between the 1st January and 
	        // the end of the actual nepali month we found the correct nepali month.
	        // Example: 
	        // The 4th February 2011 is the gregorianDayOfYear 35 (31 days of January + 4)
	        // 1st January 2011 is in the nepali year 2067, where 1st. January is in the 17th day of Paush (9th month)
	        // In 2067 Paush has 30days, This means (30-17+1=14) there are 14days between 1st January and end of Paush 
	        // (including 17th January)
	        // The gregorianDayOfYear (35) is bigger than 14, so we check the next month
	        // The next nepali month (Mangh) has 29 days 
	        // 29+14=43, this is bigger than gregorianDayOfYear(35) so, we found the correct nepali month
	        while (gregorianDayOfYear > daysSinceJanFirstToEndOfNepaliMonth) {
	            nepaliMonth++;
	            if (nepaliMonth > 12) {
	                nepaliMonth = 1;
	                nepaliYear++;
	            }    
	            daysSinceJanFirstToEndOfNepaliMonth += this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth];
	        }
	        // The last step is to calculate the nepali day-of-month
	        // to continue our example from before:
	        // we calculated there are 43 days from 1st. January (17 Paush) till end of Mangh (29 days)
	        // when we subtract from this 43 days the day-of-year of the the Gregorian date (35),
	        // we know how far the searched day is away from the end of the Nepali month.
	        // So we simply subtract this number from the amount of days in this month (30) 
	        var nepaliDayOfMonth = this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] -
	            (daysSinceJanFirstToEndOfNepaliMonth - gregorianDayOfYear);        
	        return this.newDate(nepaliYear, nepaliMonth, nepaliDayOfMonth);
	    },
	    
	    /** Creates missing data in the NEPALI_CALENDAR_DATA table.
	        This data will not be correct but just give an estimated result. Mostly -/+ 1 day
	        @private
	        @param nepaliYear {number} The missing year number. */
	    _createMissingCalendarData: function(nepaliYear) {
	        var tmp_calendar_data = this.daysPerMonth.slice(0);
	        tmp_calendar_data.unshift(17);
	        for (var nepaliYearToCreate = (nepaliYear - 1); nepaliYearToCreate < (nepaliYear + 2); nepaliYearToCreate++) {
	            if (typeof this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] === 'undefined') {
	                this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] = tmp_calendar_data;
	            }
	        }
	    },
	    
	    NEPALI_CALENDAR_DATA:  {
	        // These data are from http://www.ashesh.com.np
	        1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	        1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
	        1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
	        1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
	        1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],    
	        // These data are from http://nepalicalendar.rat32.com/index.php
	        1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2000: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	        2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	        2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
	        2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
	        2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
	        2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	        2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
	        2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	        2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
	        2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	        2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	        2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	        2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	        2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	        2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	        2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	        // These data are from http://www.ashesh.com.np/nepali-calendar/
	        2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	        2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	        2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
	        2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
	        2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
	        2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
	        2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	        2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
	        2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	        2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	        2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
	        2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
	        2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]    
	    }
	});    
	
	// Nepali calendar implementation
	main.calendars.nepali = NepaliCalendar;
	
	
	},{"../main":569,"object-assign":455}],565:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Persian calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the Persian or Jalali calendar.
	    Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
	    See also <a href="http://en.wikipedia.org/wiki/Iranian_calendar">http://en.wikipedia.org/wiki/Iranian_calendar</a>.
	    @class PersianCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function PersianCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	PersianCalendar.prototype = new main.baseCalendar;
	
	assign(PersianCalendar.prototype, {
	    /** The calendar name.
	        @memberof PersianCalendar */
	    name: 'Persian',
	    /** Julian date of start of Persian epoch: 19 March 622 CE.
	        @memberof PersianCalendar */
	    jdEpoch: 1948320.5,
	    /** Days per month in a common year.
	        @memberof PersianCalendar */
	    daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof PersianCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof PersianCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof PersianCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof PersianCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof PersianCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Persian',
	            epochs: ['BP', 'AP'],
	            monthNames: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar',
	            'Mehr', 'Aban', 'Azar', 'Day', 'Bahman', 'Esfand'],
	            monthNamesShort: ['Far', 'Ord', 'Kho', 'Tir', 'Mor', 'Sha', 'Meh', 'Aba', 'Aza', 'Day', 'Bah', 'Esf'],
	            dayNames: ['Yekshambe', 'Doshambe', 'Seshambe', 'Chæharshambe', 'Panjshambe', 'Jom\'e', 'Shambe'],
	            dayNamesShort: ['Yek', 'Do', 'Se', 'Chæ', 'Panj', 'Jom', 'Sha'],
	            dayNamesMin: ['Ye','Do','Se','Ch','Pa','Jo','Sh'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 6,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof PersianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return (((((date.year() - (date.year() > 0 ? 474 : 473)) % 2820) +
	            474 + 38) * 682) % 2816) < 682;
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof PersianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Saturday of this week starting on Saturday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-((checkDate.dayOfWeek() + 1) % 7), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof PersianCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof PersianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return this.dayOfWeek(year, month, day) !== 5;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof PersianCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        year = date.year();
	        month = date.month();
	        day = date.day();
	        var epBase = year - (year >= 0 ? 474 : 473);
	        var epYear = 474 + mod(epBase, 2820);
	        return day + (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) +
	            Math.floor((epYear * 682 - 110) / 2816) + (epYear - 1) * 365 +
	            Math.floor(epBase / 2820) * 1029983 + this.jdEpoch - 1;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof PersianCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        jd = Math.floor(jd) + 0.5;
	        var depoch = jd - this.toJD(475, 1, 1);
	        var cycle = Math.floor(depoch / 1029983);
	        var cyear = mod(depoch, 1029983);
	        var ycycle = 2820;
	        if (cyear !== 1029982) {
	            var aux1 = Math.floor(cyear / 366);
	            var aux2 = mod(cyear, 366);
	            ycycle = Math.floor(((2134 * aux1) + (2816 * aux2) + 2815) / 1028522) + aux1 + 1;
	        }
	        var year = ycycle + (2820 * cycle) + 474;
	        year = (year <= 0 ? year - 1 : year);
	        var yday = jd - this.toJD(year, 1, 1) + 1;
	        var month = (yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30));
	        var day = jd - this.toJD(year, month, 1) + 1;
	        return this.newDate(year, month, day);
	    }
	});
	
	// Modulus function which works for non-integers.
	function mod(a, b) {
	    return a - (b * Math.floor(a / b));
	}
	
	// Persian (Jalali) calendar implementation
	main.calendars.persian = PersianCalendar;
	main.calendars.jalali = PersianCalendar;
	
	
	},{"../main":569,"object-assign":455}],566:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Taiwanese (Minguo) calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	var gregorianCalendar = main.instance();
	
	/** Implementation of the Taiwanese calendar.
	    See http://en.wikipedia.org/wiki/Minguo_calendar.
	    @class TaiwanCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function TaiwanCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	TaiwanCalendar.prototype = new main.baseCalendar;
	
	assign(TaiwanCalendar.prototype, {
	    /** The calendar name.
	        @memberof TaiwanCalendar */
	    name: 'Taiwan',
	    /** Julian date of start of Taiwan epoch: 1 January 1912 CE (Gregorian).
	        @memberof TaiwanCalendar */
	    jdEpoch: 2419402.5,
	    /** Difference in years between Taiwan and Gregorian calendars.
	        @memberof TaiwanCalendar */
	    yearsOffset: 1911,
	    /** Days per month in a common year.
	        @memberof TaiwanCalendar */
	    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof TaiwanCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof TaiwanCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof TaiwanCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof TaiwanCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof TaiwanCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Taiwan',
	            epochs: ['BROC', 'ROC'],
	            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
	            'July', 'August', 'September', 'October', 'November', 'December'],
	            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 1,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof TaiwanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.leapYear(year);
	    },
	
	    /** Determine the week of the year for a date - ISO 8601.
	        @memberof TaiwanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.weekOfYear(year, date.month(), date.day());
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof TaiwanCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof TaiwanCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof TaiwanCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.toJD(year, date.month(), date.day());
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof TaiwanCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        var date = gregorianCalendar.fromJD(jd);
	        var year = this._g2tYear(date.year());
	        return this.newDate(year, date.month(), date.day());
	    },
	
	    /** Convert Taiwanese to Gregorian year.
	        @memberof TaiwanCalendar
	        @private
	        @param year {number} The Taiwanese year.
	        @return {number} The corresponding Gregorian year. */
	    _t2gYear: function(year) {
	        return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
	    },
	
	    /** Convert Gregorian to Taiwanese year.
	        @memberof TaiwanCalendar
	        @private
	        @param year {number} The Gregorian year.
	        @return {number} The corresponding Taiwanese year. */
	    _g2tYear: function(year) {
	        return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
	    }
	});
	
	// Taiwan calendar implementation
	main.calendars.taiwan = TaiwanCalendar;
	
	
	},{"../main":569,"object-assign":455}],567:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Thai calendar for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	var gregorianCalendar = main.instance();
	
	/** Implementation of the Thai calendar.
	    See http://en.wikipedia.org/wiki/Thai_calendar.
	    @class ThaiCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function ThaiCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	ThaiCalendar.prototype = new main.baseCalendar;
	
	assign(ThaiCalendar.prototype, {
	    /** The calendar name.
	        @memberof ThaiCalendar */
	    name: 'Thai',
	    /** Julian date of start of Thai epoch: 1 January 543 BCE (Gregorian).
	        @memberof ThaiCalendar */
	    jdEpoch: 1523098.5,
	    /** Difference in years between Thai and Gregorian calendars.
	        @memberof ThaiCalendar */
	    yearsOffset: 543, 
	    /** Days per month in a common year.
	        @memberof ThaiCalendar */
	    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof ThaiCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof ThaiCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof ThaiCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof ThaiCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof ThaiCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Thai',
	            epochs: ['BBE', 'BE'],
	            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
	            'July', 'August', 'September', 'October', 'November', 'December'],
	            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'dd/mm/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof ThaiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.leapYear(year);
	    },
	
	    /** Determine the week of the year for a date - ISO 8601.
	        @memberof ThaiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.weekOfYear(year, date.month(), date.day());
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof ThaiCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof ThaiCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof ThaiCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        var year = this._t2gYear(date.year());
	        return gregorianCalendar.toJD(year, date.month(), date.day());
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof ThaiCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        var date = gregorianCalendar.fromJD(jd);
	        var year = this._g2tYear(date.year());
	        return this.newDate(year, date.month(), date.day());
	    },
	
	    /** Convert Thai to Gregorian year.
	        @memberof ThaiCalendar
	        @private
	        @param year {number} The Thai year.
	        @return {number} The corresponding Gregorian year. */
	    _t2gYear: function(year) {
	        return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
	    },
	
	    /** Convert Gregorian to Thai year.
	        @memberof ThaiCalendar
	        @private
	        @param year {number} The Gregorian year.
	        @return {number} The corresponding Thai year. */
	    _g2tYear: function(year) {
	        return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
	    }
	});
	
	// Thai calendar implementation
	main.calendars.thai = ThaiCalendar;
	
	
	},{"../main":569,"object-assign":455}],568:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   UmmAlQura calendar for jQuery v2.0.2.
	   Written by Amro Osama March 2013.
	   Modified by Binnooh.com & www.elm.sa - 2014 - Added dates back to 1276 Hijri year.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var main = _dereq_('../main');
	var assign = _dereq_('object-assign');
	
	
	/** Implementation of the UmmAlQura or 'saudi' calendar.
	    See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar">http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar</a>.
	    <a href="http://www.ummulqura.org.sa/About.aspx">http://www.ummulqura.org.sa/About.aspx</a>
	    <a href="http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm">http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm</a>
	    @class UmmAlQuraCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function UmmAlQuraCalendar(language) {
	    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
	}
	
	UmmAlQuraCalendar.prototype = new main.baseCalendar;
	
	assign(UmmAlQuraCalendar.prototype, {
	    /** The calendar name.
	        @memberof UmmAlQuraCalendar */
	    name: 'UmmAlQura',
	    //jdEpoch: 1948440, // Julian date of start of UmmAlQura epoch: 14 March 1937 CE
	    //daysPerMonth: // Days per month in a common year, replaced by a method.
	    /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof UmmAlQuraCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof UmmAlQuraCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof UmmAlQuraCalendar */
	    firstMonth: 1,
	    /** The minimum day number.
	        @memberof UmmAlQuraCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof UmmAlQuraCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Umm al-Qura',
	            epochs: ['BH', 'AH'],
	            monthNames: ['Al-Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' Al-Thani', 'Jumada Al-Awwal', 'Jumada Al-Thani',
	            'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
	            monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
	            dayNames: ['Yawm al-Ahad', 'Yawm al-Ithnain', 'Yawm al-Thalāthā’', 'Yawm al-Arba‘ā’', 'Yawm al-Khamīs', 'Yawm al-Jum‘a', 'Yawm al-Sabt'],
	            dayNamesMin: ['Ah', 'Ith', 'Th', 'Ar', 'Kh', 'Ju', 'Sa'],
	            digits: null,
	            dateFormat: 'yyyy/mm/dd',
	            firstDay: 6,
	            isRTL: true
	        }
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function (year) {
	        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	        return (this.daysInYear(date.year()) === 355);
	    },
	
	    /** Determine the week of the year for a date.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function (year, month, day) {
	        // Find Sunday of this week starting on Sunday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(-checkDate.dayOfWeek(), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function (year) {
	        var daysCount = 0;
	        for (var i = 1; i <= 12; i++) {
	            daysCount += this.daysInMonth(year, i);
	        }
	        return daysCount;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function (year, month) {
	        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	        var mcjdn = date.toJD() - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
	        // the MCJDN's of the start of the lunations in the Umm al-Qura calendar are stored in the 'ummalqura_dat' array
	        var index = 0;
	        for (var i = 0; i < ummalqura_dat.length; i++) {
	            if (ummalqura_dat[i] > mcjdn) {
	                return (ummalqura_dat[index] - ummalqura_dat[index - 1]);
	            }
	            index++;
	        }
	        return 30; // Unknown outside
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function (year, month, day) {
	        return this.dayOfWeek(year, month, day) !== 5;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof UmmAlQuraCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function (year, month, day) {
	        var date = this._validate(year, month, day, main.local.invalidDate);
	        var index = (12 * (date.year() - 1)) + date.month() - 15292;
	        var mcjdn = date.day() + ummalqura_dat[index - 1] - 1;
	        return mcjdn + 2400000 - 0.5; // Modified Chronological Julian Day Number (MCJDN)
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof UmmAlQuraCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function (jd) {
	        var mcjdn = jd - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
	        // the MCJDN's of the start of the lunations in the Umm al-Qura calendar 
	        // are stored in the 'ummalqura_dat' array
	        var index = 0;
	        for (var i = 0; i < ummalqura_dat.length; i++) {
	            if (ummalqura_dat[i] > mcjdn) break;
	            index++;
	        }
	        var lunation = index + 15292; //UmmAlQura Lunation Number
	        var ii = Math.floor((lunation - 1) / 12);
	        var year = ii + 1;
	        var month = lunation - 12 * ii;
	        var day = mcjdn - ummalqura_dat[index - 1] + 1;
	        return this.newDate(year, month, day);
	    },
	
	    /** Determine whether a date is valid for this calendar.
	        @memberof UmmAlQuraCalendar
	        @param year {number} The year to examine.
	        @param month {number} The month to examine.
	        @param day {number} The day to examine.
	        @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
	    isValid: function(year, month, day) {
	        var valid = main.baseCalendar.prototype.isValid.apply(this, arguments);
	        if (valid) {
	            year = (year.year != null ? year.year : year);
	            valid = (year >= 1276 && year <= 1500);
	        }
	        return valid;
	    },
	
	    /** Check that a candidate date is from the same calendar and is valid.
	        @memberof UmmAlQuraCalendar
	        @private
	        @param year {CDate|number} The date to validate or the year to validate.
	        @param month {number} The month to validate.
	        @param day {number} The day to validate.
	        @param error {string} Error message if invalid.
	        @throws Error if different calendars used or invalid date. */
	    _validate: function(year, month, day, error) {
	        var date = main.baseCalendar.prototype._validate.apply(this, arguments);
	        if (date.year < 1276 || date.year > 1500) {
	            throw error.replace(/\{0\}/, this.local.name);
	        }
	        return date;
	    }
	});
	
	// UmmAlQura calendar implementation
	main.calendars.ummalqura = UmmAlQuraCalendar;
	
	var ummalqura_dat = [
	    20,    50,    79,    109,   138,   168,   197,   227,   256,   286,   315,   345,   374,   404,   433,   463,   492,   522,   551,   581, 
	    611,   641,   670,   700,   729,   759,   788,   818,   847,   877,   906,   936,   965,   995,   1024,  1054,  1083,  1113,  1142,  1172,
	    1201,  1231,  1260,  1290,  1320,  1350,  1379,  1409,  1438,  1468,  1497,  1527,  1556,  1586,  1615,  1645,  1674,  1704,  1733,  1763,
	    1792,  1822,  1851,  1881,  1910,  1940,  1969,  1999,  2028,  2058,  2087,  2117,  2146,  2176,  2205,  2235,  2264,  2294,  2323,  2353,
	    2383,  2413,  2442,  2472,  2501,  2531,  2560,  2590,  2619,  2649,  2678,  2708,  2737,  2767,  2796,  2826,  2855,  2885,  2914,  2944,
	    2973,  3003,  3032,  3062,  3091,  3121,  3150,  3180,  3209,  3239,  3268,  3298,  3327,  3357,  3386,  3416,  3446,  3476,  3505,  3535,
	    3564,  3594,  3623,  3653,  3682,  3712,  3741,  3771,  3800,  3830,  3859,  3889,  3918,  3948,  3977,  4007,  4036,  4066,  4095,  4125,
	    4155,  4185,  4214,  4244,  4273,  4303,  4332,  4362,  4391,  4421,  4450,  4480,  4509,  4539,  4568,  4598,  4627,  4657,  4686,  4716,
	    4745,  4775,  4804,  4834,  4863,  4893,  4922,  4952,  4981,  5011,  5040,  5070,  5099,  5129,  5158,  5188,  5218,  5248,  5277,  5307,
	    5336,  5366,  5395,  5425,  5454,  5484,  5513,  5543,  5572,  5602,  5631,  5661,  5690,  5720,  5749,  5779,  5808,  5838,  5867,  5897,
	    5926,  5956,  5985,  6015,  6044,  6074,  6103,  6133,  6162,  6192,  6221,  6251,  6281,  6311,  6340,  6370,  6399,  6429,  6458,  6488,
	    6517,  6547,  6576,  6606,  6635,  6665,  6694,  6724,  6753,  6783,  6812,  6842,  6871,  6901,  6930,  6960,  6989,  7019,  7048,  7078,
	    7107,  7137,  7166,  7196,  7225,  7255,  7284,  7314,  7344,  7374,  7403,  7433,  7462,  7492,  7521,  7551,  7580,  7610,  7639,  7669,
	    7698,  7728,  7757,  7787,  7816,  7846,  7875,  7905,  7934,  7964,  7993,  8023,  8053,  8083,  8112,  8142,  8171,  8201,  8230,  8260,
	    8289,  8319,  8348,  8378,  8407,  8437,  8466,  8496,  8525,  8555,  8584,  8614,  8643,  8673,  8702,  8732,  8761,  8791,  8821,  8850,
	    8880,  8909,  8938,  8968,  8997,  9027,  9056,  9086,  9115,  9145,  9175,  9205,  9234,  9264,  9293,  9322,  9352,  9381,  9410,  9440,
	    9470,  9499,  9529,  9559,  9589,  9618,  9648,  9677,  9706,  9736,  9765,  9794,  9824,  9853,  9883,  9913,  9943,  9972,  10002, 10032,
	    10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621,
	    10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213,
	    11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803,
	    11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393,
	    12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984,
	    13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574,
	    13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166,
	    14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756,
	    14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347,
	    15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937,
	    15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528,
	    16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118,
	    17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709,
	    17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300,
	    18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890,
	    18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481,
	    19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071,
	    20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662,
	    20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253,
	    21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843,
	    21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434,
	    22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024,
	    23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616,
	    23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206,
	    24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796,
	    24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387,
	    25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977,
	    26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568,
	    26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159,
	    27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750,
	    27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340,
	    28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577,
	    // From 1356
	    28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167,
	    29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759,
	    29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348,
	    30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939,
	    30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530,
	    31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120,
	    32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711,
	    32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302,
	    33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893,
	    33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483,
	    34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074,
	    35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665,
	    35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254,
	    36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845,
	    36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436,
	    37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027,
	    38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617,
	    38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208,
	    39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798,
	    39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389,
	    40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980,
	    41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570,
	    41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161,
	    42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751,
	    42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342,
	    43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932,
	    43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523,
	    44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114,
	    45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704,
	    45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295,
	    46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885,
	    46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476,
	    47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066,
	    48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657,
	    48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248,
	    49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838,
	    49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429,
	    50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019,
	    51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611,
	    51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200,
	    52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792,
	    52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383,
	    53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973,
	    54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564,
	    54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154,
	    55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745,
	    55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335,
	    56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926,
	    56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517,
	    57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107,
	    58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698,
	    58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288,
	    59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879,
	    59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469,
	    60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061,
	    61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651,
	    61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242,
	    62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832,
	    62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423,
	    63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014,
	    64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603,
	    64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195,
	    65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785,
	    65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376,
	    66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967,
	    66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557,
	    67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68000, 68030, 68060, 68089, 68119, 68148,
	    68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738,
	    68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330,
	    69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919,
	    69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510,
	    70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101,
	    71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691,
	    71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282,
	    72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872,
	    72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464,
	    73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053,
	    74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645,
	    74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235,
	    75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826,
	    75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416,
	    76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007,
	    77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598,
	    77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188,
	    78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779,
	    78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369,
	    79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960,
	    79990];
	
	
	},{"../main":569,"object-assign":455}],569:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Calendars for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var assign = _dereq_('object-assign');
	
	
	function Calendars() {
	    this.regionalOptions = [];
	    this.regionalOptions[''] = {
	        invalidCalendar: 'Calendar {0} not found',
	        invalidDate: 'Invalid {0} date',
	        invalidMonth: 'Invalid {0} month',
	        invalidYear: 'Invalid {0} year',
	        differentCalendars: 'Cannot mix {0} and {1} dates'
	    };
	    this.local = this.regionalOptions[''];
	    this.calendars = {};
	    this._localCals = {};
	}
	
	/** Create the calendars plugin.
	    <p>Provides support for various world calendars in a consistent manner.</p>
	     @class Calendars
	    @example _exports.instance('julian').newDate(2014, 12, 25) */
	assign(Calendars.prototype, {
	
	    /** Obtain a calendar implementation and localisation.
	        @memberof Calendars
	        @param [name='gregorian'] {string} The name of the calendar, e.g. 'gregorian', 'persian', 'islamic'.
	        @param [language=''] {string} The language code to use for localisation (default is English).
	        @return {Calendar} The calendar and localisation.
	        @throws Error if calendar not found. */
	    instance: function(name, language) {
	        name = (name || 'gregorian').toLowerCase();
	        language = language || '';
	        var cal = this._localCals[name + '-' + language];
	        if (!cal && this.calendars[name]) {
	            cal = new this.calendars[name](language);
	            this._localCals[name + '-' + language] = cal;
	        }
	        if (!cal) {
	            throw (this.local.invalidCalendar || this.regionalOptions[''].invalidCalendar).
	                replace(/\{0\}/, name);
	        }
	        return cal;
	    },
	
	    /** Create a new date - for today if no other parameters given.
	        @memberof Calendars
	        @param year {CDate|number} The date to copy or the year for the date.
	        @param [month] {number} The month for the date.
	        @param [day] {number} The day for the date.
	        @param [calendar='gregorian'] {BaseCalendar|string} The underlying calendar or the name of the calendar.
	        @param [language=''] {string} The language to use for localisation (default English).
	        @return {CDate} The new date.
	        @throws Error if an invalid date. */
	    newDate: function(year, month, day, calendar, language) {
	        calendar = (year != null && year.year ? year.calendar() : (typeof calendar === 'string' ?
	            this.instance(calendar, language) : calendar)) || this.instance();
	        return calendar.newDate(year, month, day);
	    },
	    
	    /** A simple digit substitution function for localising numbers via the Calendar digits option.
	        @member Calendars
	        @param digits {string[]} The substitute digits, for 0 through 9.
	        @return {function} The substitution function. */
	    substituteDigits: function(digits) {
	        return function(value) {
	            return (value + '').replace(/[0-9]/g, function(digit) {
	                return digits[digit];
	            });
	        }
	    },
	    
	    /** Digit substitution function for localising Chinese style numbers via the Calendar digits option.
	        @member Calendars
	        @param digits {string[]} The substitute digits, for 0 through 9.
	        @param powers {string[]} The characters denoting powers of 10, i.e. 1, 10, 100, 1000.
	        @return {function} The substitution function. */
	    substituteChineseDigits: function(digits, powers) {
	        return function(value) {
	            var localNumber = '';
	            var power = 0;
	            while (value > 0) {
	                var units = value % 10;
	                localNumber = (units === 0 ? '' : digits[units] + powers[power]) + localNumber;
	                power++;
	                value = Math.floor(value / 10);
	            }
	            if (localNumber.indexOf(digits[1] + powers[1]) === 0) {
	                localNumber = localNumber.substr(1);
	            }
	            return localNumber || digits[0];
	        }
	    }
	});
	
	/** Generic date, based on a particular calendar.
	    @class CDate
	    @param calendar {BaseCalendar} The underlying calendar implementation.
	    @param year {number} The year for this date.
	    @param month {number} The month for this date.
	    @param day {number} The day for this date.
	    @return {CDate} The date object.
	    @throws Error if an invalid date. */
	function CDate(calendar, year, month, day) {
	    this._calendar = calendar;
	    this._year = year;
	    this._month = month;
	    this._day = day;
	    if (this._calendar._validateLevel === 0 &&
	            !this._calendar.isValid(this._year, this._month, this._day)) {
	        throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
	            replace(/\{0\}/, this._calendar.local.name);
	    }
	}
	
	/** Pad a numeric value with leading zeroes.
	    @private
	    @param value {number} The number to format.
	    @param length {number} The minimum length.
	    @return {string} The formatted number. */
	function pad(value, length) {
	    value = '' + value;
	    return '000000'.substring(0, length - value.length) + value;
	}
	
	assign(CDate.prototype, {
	
	    /** Create a new date.
	        @memberof CDate
	        @param [year] {CDate|number} The date to copy or the year for the date (default this date).
	        @param [month] {number} The month for the date.
	        @param [day] {number} The day for the date.
	        @return {CDate} The new date.
	        @throws Error if an invalid date. */
	    newDate: function(year, month, day) {
	        return this._calendar.newDate((year == null ? this : year), month, day);
	    },
	
	    /** Set or retrieve the year for this date.
	        @memberof CDate
	        @param [year] {number} The year for the date.
	        @return {number|CDate} The date's year (if no parameter) or the updated date.
	        @throws Error if an invalid date. */
	    year: function(year) {
	        return (arguments.length === 0 ? this._year : this.set(year, 'y'));
	    },
	
	    /** Set or retrieve the month for this date.
	        @memberof CDate
	        @param [month] {number} The month for the date.
	        @return {number|CDate} The date's month (if no parameter) or the updated date.
	        @throws Error if an invalid date. */
	    month: function(month) {
	        return (arguments.length === 0 ? this._month : this.set(month, 'm'));
	    },
	
	    /** Set or retrieve the day for this date.
	        @memberof CDate
	        @param [day] {number} The day for the date.
	        @return {number|CData} The date's day (if no parameter) or the updated date.
	        @throws Error if an invalid date. */
	    day: function(day) {
	        return (arguments.length === 0 ? this._day : this.set(day, 'd'));
	    },
	
	    /** Set new values for this date.
	        @memberof CDate
	        @param year {number} The year for the date.
	        @param month {number} The month for the date.
	        @param day {number} The day for the date.
	        @return {CDate} The updated date.
	        @throws Error if an invalid date. */
	    date: function(year, month, day) {
	        if (!this._calendar.isValid(year, month, day)) {
	            throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
	                replace(/\{0\}/, this._calendar.local.name);
	        }
	        this._year = year;
	        this._month = month;
	        this._day = day;
	        return this;
	    },
	
	    /** Determine whether this date is in a leap year.
	        @memberof CDate
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not. */
	    leapYear: function() {
	        return this._calendar.leapYear(this);
	    },
	
	    /** Retrieve the epoch designator for this date, e.g. BCE or CE.
	        @memberof CDate
	        @return {string} The current epoch. */
	    epoch: function() {
	        return this._calendar.epoch(this);
	    },
	
	    /** Format the year, if not a simple sequential number.
	        @memberof CDate
	        @return {string} The formatted year. */
	    formatYear: function() {
	        return this._calendar.formatYear(this);
	    },
	
	    /** Retrieve the month of the year for this date,
	        i.e. the month's position within a numbered year.
	        @memberof CDate
	        @return {number} The month of the year: <code>minMonth</code> to months per year. */
	    monthOfYear: function() {
	        return this._calendar.monthOfYear(this);
	    },
	
	    /** Retrieve the week of the year for this date.
	        @memberof CDate
	        @return {number} The week of the year: 1 to weeks per year. */
	    weekOfYear: function() {
	        return this._calendar.weekOfYear(this);
	    },
	
	    /** Retrieve the number of days in the year for this date.
	        @memberof CDate
	        @return {number} The number of days in this year. */
	    daysInYear: function() {
	        return this._calendar.daysInYear(this);
	    },
	
	    /** Retrieve the day of the year for this date.
	        @memberof CDate
	        @return {number} The day of the year: 1 to days per year. */
	    dayOfYear: function() {
	        return this._calendar.dayOfYear(this);
	    },
	
	    /** Retrieve the number of days in the month for this date.
	        @memberof CDate
	        @return {number} The number of days. */
	    daysInMonth: function() {
	        return this._calendar.daysInMonth(this);
	    },
	
	    /** Retrieve the day of the week for this date.
	        @memberof CDate
	        @return {number} The day of the week: 0 to number of days - 1. */
	    dayOfWeek: function() {
	        return this._calendar.dayOfWeek(this);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof CDate
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not. */
	    weekDay: function() {
	        return this._calendar.weekDay(this);
	    },
	
	    /** Retrieve additional information about this date.
	        @memberof CDate
	        @return {object} Additional information - contents depends on calendar. */
	    extraInfo: function() {
	        return this._calendar.extraInfo(this);
	    },
	
	    /** Add period(s) to a date.
	        @memberof CDate
	        @param offset {number} The number of periods to adjust by.
	        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	        @return {CDate} The updated date. */
	    add: function(offset, period) {
	        return this._calendar.add(this, offset, period);
	    },
	
	    /** Set a portion of the date.
	        @memberof CDate
	        @param value {number} The new value for the period.
	        @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
	        @return {CDate} The updated date.
	        @throws Error if not a valid date. */
	    set: function(value, period) {
	        return this._calendar.set(this, value, period);
	    },
	
	    /** Compare this date to another date.
	        @memberof CDate
	        @param date {CDate} The other date.
	        @return {number} -1 if this date is before the other date,
	                0 if they are equal, or +1 if this date is after the other date. */
	    compareTo: function(date) {
	        if (this._calendar.name !== date._calendar.name) {
	            throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
	                replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, date._calendar.local.name);
	        }
	        var c = (this._year !== date._year ? this._year - date._year :
	            this._month !== date._month ? this.monthOfYear() - date.monthOfYear() :
	            this._day - date._day);
	        return (c === 0 ? 0 : (c < 0 ? -1 : +1));
	    },
	
	    /** Retrieve the calendar backing this date.
	        @memberof CDate
	        @return {BaseCalendar} The calendar implementation. */
	    calendar: function() {
	        return this._calendar;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof CDate
	        @return {number} The equivalent Julian date. */
	    toJD: function() {
	        return this._calendar.toJD(this);
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof CDate
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        return this._calendar.fromJD(jd);
	    },
	
	    /** Convert this date to a standard (Gregorian) JavaScript Date.
	        @memberof CDate
	        @return {Date} The equivalent JavaScript date. */
	    toJSDate: function() {
	        return this._calendar.toJSDate(this);
	    },
	
	    /** Create a new date from a standard (Gregorian) JavaScript Date.
	        @memberof CDate
	        @param jsd {Date} The JavaScript date to convert.
	        @return {CDate} The equivalent date. */
	    fromJSDate: function(jsd) {
	        return this._calendar.fromJSDate(jsd);
	    },
	
	    /** Convert to a string for display.
	        @memberof CDate
	        @return {string} This date as a string. */
	    toString: function() {
	        return (this.year() < 0 ? '-' : '') + pad(Math.abs(this.year()), 4) +
	            '-' + pad(this.month(), 2) + '-' + pad(this.day(), 2);
	    }
	});
	
	/** Basic functionality for all calendars.
	    Other calendars should extend this:
	    <pre>OtherCalendar.prototype = new BaseCalendar;</pre>
	    @class BaseCalendar */
	function BaseCalendar() {
	    this.shortYearCutoff = '+10';
	}
	
	assign(BaseCalendar.prototype, {
	    _validateLevel: 0, // "Stack" to turn validation on/off
	
	    /** Create a new date within this calendar - today if no parameters given.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to duplicate or the year for the date.
	        @param [month] {number} The month for the date.
	        @param [day] {number} The day for the date.
	        @return {CDate} The new date.
	        @throws Error if not a valid date or a different calendar used. */
	    newDate: function(year, month, day) {
	        if (year == null) {
	            return this.today();
	        }
	        if (year.year) {
	            this._validate(year, month, day,
	                _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	            day = year.day();
	            month = year.month();
	            year = year.year();
	        }
	        return new CDate(this, year, month, day);
	    },
	
	    /** Create a new date for today.
	        @memberof BaseCalendar
	        @return {CDate} Today's date. */
	    today: function() {
	        return this.fromJSDate(new Date());
	    },
	
	    /** Retrieve the epoch designator for this date.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {string} The current epoch.
	        @throws Error if an invalid year or a different calendar used. */
	    epoch: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay,
	            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
	        return (date.year() < 0 ? this.local.epochs[0] : this.local.epochs[1]);
	    },
	
	    /** Format the year, if not a simple sequential number
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to format or the year to format.
	        @return {string} The formatted year.
	        @throws Error if an invalid year or a different calendar used. */
	    formatYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay,
	            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
	        return (date.year() < 0 ? '-' : '') + pad(Math.abs(date.year()), 4)
	    },
	
	    /** Retrieve the number of months in a year.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of months.
	        @throws Error if an invalid year or a different calendar used. */
	    monthsInYear: function(year) {
	        this._validate(year, this.minMonth, this.minDay,
	            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
	        return 12;
	    },
	
	    /** Calculate the month's ordinal position within the year -
	        for those calendars that don't start at month 1!
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param month {number} The month to examine.
	        @return {number} The ordinal position, starting from <code>minMonth</code>.
	        @throws Error if an invalid year/month or a different calendar used. */
	    monthOfYear: function(year, month) {
	        var date = this._validate(year, month, this.minDay,
	            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
	        return (date.month() + this.monthsInYear(date) - this.firstMonth) %
	            this.monthsInYear(date) + this.minMonth;
	    },
	
	    /** Calculate actual month from ordinal position, starting from minMonth.
	        @memberof BaseCalendar
	        @param year {number} The year to examine.
	        @param ord {number} The month's ordinal position.
	        @return {number} The month's number.
	        @throws Error if an invalid year/month. */
	    fromMonthOfYear: function(year, ord) {
	        var m = (ord + this.firstMonth - 2 * this.minMonth) %
	            this.monthsInYear(year) + this.minMonth;
	        this._validate(year, m, this.minDay,
	            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
	        return m;
	    },
	
	    /** Retrieve the number of days in a year.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {number} The number of days.
	        @throws Error if an invalid year or a different calendar used. */
	    daysInYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay,
	            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
	        return (this.leapYear(date) ? 366 : 365);
	    },
	
	    /** Retrieve the day of the year for a date.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The day of the year.
	        @throws Error if an invalid date or a different calendar used. */
	    dayOfYear: function(year, month, day) {
	        var date = this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        return date.toJD() - this.newDate(date.year(),
	            this.fromMonthOfYear(date.year(), this.minMonth), this.minDay).toJD() + 1;
	    },
	
	    /** Retrieve the number of days in a week.
	        @memberof BaseCalendar
	        @return {number} The number of days. */
	    daysInWeek: function() {
	        return 7;
	    },
	
	    /** Retrieve the day of the week for a date.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The day of the week: 0 to number of days - 1.
	        @throws Error if an invalid date or a different calendar used. */
	    dayOfWeek: function(year, month, day) {
	        var date = this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        return (Math.floor(this.toJD(date)) + 2) % this.daysInWeek();
	    },
	
	    /** Retrieve additional information about a date.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {object} Additional information - contents depends on calendar.
	        @throws Error if an invalid date or a different calendar used. */
	    extraInfo: function(year, month, day) {
	        this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        return {};
	    },
	
	    /** Add period(s) to a date.
	        Cater for no year zero.
	        @memberof BaseCalendar
	        @param date {CDate} The starting date.
	        @param offset {number} The number of periods to adjust by.
	        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	        @return {CDate} The updated date.
	        @throws Error if a different calendar used. */
	    add: function(date, offset, period) {
	        this._validate(date, this.minMonth, this.minDay,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        return this._correctAdd(date, this._add(date, offset, period), offset, period);
	    },
	
	    /** Add period(s) to a date.
	        @memberof BaseCalendar
	        @private
	        @param date {CDate} The starting date.
	        @param offset {number} The number of periods to adjust by.
	        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	        @return {CDate} The updated date. */
	    _add: function(date, offset, period) {
	        this._validateLevel++;
	        if (period === 'd' || period === 'w') {
	            var jd = date.toJD() + offset * (period === 'w' ? this.daysInWeek() : 1);
	            var d = date.calendar().fromJD(jd);
	            this._validateLevel--;
	            return [d.year(), d.month(), d.day()];
	        }
	        try {
	            var y = date.year() + (period === 'y' ? offset : 0);
	            var m = date.monthOfYear() + (period === 'm' ? offset : 0);
	            var d = date.day();// + (period === 'd' ? offset : 0) +
	                //(period === 'w' ? offset * this.daysInWeek() : 0);
	            var resyncYearMonth = function(calendar) {
	                while (m < calendar.minMonth) {
	                    y--;
	                    m += calendar.monthsInYear(y);
	                }
	                var yearMonths = calendar.monthsInYear(y);
	                while (m > yearMonths - 1 + calendar.minMonth) {
	                    y++;
	                    m -= yearMonths;
	                    yearMonths = calendar.monthsInYear(y);
	                }
	            };
	            if (period === 'y') {
	                if (date.month() !== this.fromMonthOfYear(y, m)) { // Hebrew
	                    m = this.newDate(y, date.month(), this.minDay).monthOfYear();
	                }
	                m = Math.min(m, this.monthsInYear(y));
	                d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
	            }
	            else if (period === 'm') {
	                resyncYearMonth(this);
	                d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
	            }
	            var ymd = [y, this.fromMonthOfYear(y, m), d];
	            this._validateLevel--;
	            return ymd;
	        }
	        catch (e) {
	            this._validateLevel--;
	            throw e;
	        }
	    },
	
	    /** Correct a candidate date after adding period(s) to a date.
	        Handle no year zero if necessary.
	        @memberof BaseCalendar
	        @private
	        @param date {CDate} The starting date.
	        @param ymd {number[]} The added date.
	        @param offset {number} The number of periods to adjust by.
	        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	        @return {CDate} The updated date. */
	    _correctAdd: function(date, ymd, offset, period) {
	        if (!this.hasYearZero && (period === 'y' || period === 'm')) {
	            if (ymd[0] === 0 || // In year zero
	                    (date.year() > 0) !== (ymd[0] > 0)) { // Crossed year zero
	                var adj = {y: [1, 1, 'y'], m: [1, this.monthsInYear(-1), 'm'],
	                    w: [this.daysInWeek(), this.daysInYear(-1), 'd'],
	                    d: [1, this.daysInYear(-1), 'd']}[period];
	                var dir = (offset < 0 ? -1 : +1);
	                ymd = this._add(date, offset * adj[0] + dir * adj[1], adj[2]);
	            }
	        }
	        return date.date(ymd[0], ymd[1], ymd[2]);
	    },
	
	    /** Set a portion of the date.
	        @memberof BaseCalendar
	        @param date {CDate} The starting date.
	        @param value {number} The new value for the period.
	        @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
	        @return {CDate} The updated date.
	        @throws Error if an invalid date or a different calendar used. */
	    set: function(date, value, period) {
	        this._validate(date, this.minMonth, this.minDay,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        var y = (period === 'y' ? value : date.year());
	        var m = (period === 'm' ? value : date.month());
	        var d = (period === 'd' ? value : date.day());
	        if (period === 'y' || period === 'm') {
	            d = Math.min(d, this.daysInMonth(y, m));
	        }
	        return date.date(y, m, d);
	    },
	
	    /** Determine whether a date is valid for this calendar.
	        @memberof BaseCalendar
	        @param year {number} The year to examine.
	        @param month {number} The month to examine.
	        @param day {number} The day to examine.
	        @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
	    isValid: function(year, month, day) {
	        this._validateLevel++;
	        var valid = (this.hasYearZero || year !== 0);
	        if (valid) {
	            var date = this.newDate(year, month, this.minDay);
	            valid = (month >= this.minMonth && month - this.minMonth < this.monthsInYear(date)) &&
	                (day >= this.minDay && day - this.minDay < this.daysInMonth(date));
	        }
	        this._validateLevel--;
	        return valid;
	    },
	
	    /** Convert the date to a standard (Gregorian) JavaScript Date.
	        @memberof BaseCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {Date} The equivalent JavaScript date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJSDate: function(year, month, day) {
	        var date = this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        return _exports.instance().fromJD(this.toJD(date)).toJSDate();
	    },
	
	    /** Convert the date from a standard (Gregorian) JavaScript Date.
	        @memberof BaseCalendar
	        @param jsd {Date} The JavaScript date.
	        @return {CDate} The equivalent calendar date. */
	    fromJSDate: function(jsd) {
	        return this.fromJD(_exports.instance().fromJSDate(jsd).toJD());
	    },
	
	    /** Check that a candidate date is from the same calendar and is valid.
	        @memberof BaseCalendar
	        @private
	        @param year {CDate|number} The date to validate or the year to validate.
	        @param [month] {number} The month to validate.
	        @param [day] {number} The day to validate.
	        @param error {string} Rrror message if invalid.
	        @throws Error if different calendars used or invalid date. */
	    _validate: function(year, month, day, error) {
	        if (year.year) {
	            if (this._validateLevel === 0 && this.name !== year.calendar().name) {
	                throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
	                    replace(/\{0\}/, this.local.name).replace(/\{1\}/, year.calendar().local.name);
	            }
	            return year;
	        }
	        try {
	            this._validateLevel++;
	            if (this._validateLevel === 1 && !this.isValid(year, month, day)) {
	                throw error.replace(/\{0\}/, this.local.name);
	            }
	            var date = this.newDate(year, month, day);
	            this._validateLevel--;
	            return date;
	        }
	        catch (e) {
	            this._validateLevel--;
	            throw e;
	        }
	    }
	});
	
	/** Implementation of the Proleptic Gregorian Calendar.
	    See <a href=":http://en.wikipedia.org/wiki/Gregorian_calendar">http://en.wikipedia.org/wiki/Gregorian_calendar</a>
	    and <a href="http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar">http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar</a>.
	    @class GregorianCalendar
	    @augments BaseCalendar
	    @param [language=''] {string} The language code (default English) for localisation. */
	function GregorianCalendar(language) {
	    this.local = this.regionalOptions[language] || this.regionalOptions[''];
	}
	
	GregorianCalendar.prototype = new BaseCalendar;
	
	assign(GregorianCalendar.prototype, {
	    /** The calendar name.
	        @memberof GregorianCalendar */
	    name: 'Gregorian',
	     /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
	        @memberof GregorianCalendar */
	    jdEpoch: 1721425.5,
	     /** Days per month in a common year.
	        @memberof GregorianCalendar */
	    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	     /** <code>true</code> if has a year zero, <code>false</code> if not.
	        @memberof GregorianCalendar */
	    hasYearZero: false,
	    /** The minimum month number.
	        @memberof GregorianCalendar */
	    minMonth: 1,
	    /** The first month in the year.
	        @memberof GregorianCalendar */
	    firstMonth: 1,
	     /** The minimum day number.
	        @memberof GregorianCalendar */
	    minDay: 1,
	
	    /** Localisations for the plugin.
	        Entries are objects indexed by the language code ('' being the default US/English).
	        Each object has the following attributes.
	        @memberof GregorianCalendar
	        @property name {string} The calendar name.
	        @property epochs {string[]} The epoch names.
	        @property monthNames {string[]} The long names of the months of the year.
	        @property monthNamesShort {string[]} The short names of the months of the year.
	        @property dayNames {string[]} The long names of the days of the week.
	        @property dayNamesShort {string[]} The short names of the days of the week.
	        @property dayNamesMin {string[]} The minimal names of the days of the week.
	        @property dateFormat {string} The date format for this calendar.
	                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	        @property firstDay {number} The number of the first day of the week, starting at 0.
	        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	    regionalOptions: { // Localisations
	        '': {
	            name: 'Gregorian',
	            epochs: ['BCE', 'CE'],
	            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
	            'July', 'August', 'September', 'October', 'November', 'December'],
	            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	            digits: null,
	            dateFormat: 'mm/dd/yyyy',
	            firstDay: 0,
	            isRTL: false
	        }
	    },
	    
	    /** Determine whether this date is in a leap year.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	        @throws Error if an invalid year or a different calendar used. */
	    leapYear: function(year) {
	        var date = this._validate(year, this.minMonth, this.minDay,
	            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
	        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
	        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	    },
	
	    /** Determine the week of the year for a date - ISO 8601.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {number} The week of the year, starting from 1.
	        @throws Error if an invalid date or a different calendar used. */
	    weekOfYear: function(year, month, day) {
	        // Find Thursday of this week starting on Monday
	        var checkDate = this.newDate(year, month, day);
	        checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
	        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	    },
	
	    /** Retrieve the number of days in a month.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to examine or the year of the month.
	        @param [month] {number} The month.
	        @return {number} The number of days in this month.
	        @throws Error if an invalid month/year or a different calendar used. */
	    daysInMonth: function(year, month) {
	        var date = this._validate(year, month, this.minDay,
	            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
	        return this.daysPerMonth[date.month() - 1] +
	            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	    },
	
	    /** Determine whether this date is a week day.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to examine or the year to examine.
	        @param [month] {number} The month to examine.
	        @param [day] {number} The day to examine.
	        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	        @throws Error if an invalid date or a different calendar used. */
	    weekDay: function(year, month, day) {
	        return (this.dayOfWeek(year, month, day) || 7) < 6;
	    },
	
	    /** Retrieve the Julian date equivalent for this date,
	        i.e. days since January 1, 4713 BCE Greenwich noon.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {number} The equivalent Julian date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJD: function(year, month, day) {
	        var date = this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        year = date.year();
	        month = date.month();
	        day = date.day();
	        if (year < 0) { year++; } // No year zero
	        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
	        if (month < 3) {
	            month += 12;
	            year--;
	        }
	        var a = Math.floor(year / 100);
	        var b = 2 - a + Math.floor(a / 4);
	        return Math.floor(365.25 * (year + 4716)) +
	            Math.floor(30.6001 * (month + 1)) + day + b - 1524.5;
	    },
	
	    /** Create a new date from a Julian date.
	        @memberof GregorianCalendar
	        @param jd {number} The Julian date to convert.
	        @return {CDate} The equivalent date. */
	    fromJD: function(jd) {
	        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
	        var z = Math.floor(jd + 0.5);
	        var a = Math.floor((z - 1867216.25) / 36524.25);
	        a = z + 1 + a - Math.floor(a / 4);
	        var b = a + 1524;
	        var c = Math.floor((b - 122.1) / 365.25);
	        var d = Math.floor(365.25 * c);
	        var e = Math.floor((b - d) / 30.6001);
	        var day = b - d - Math.floor(e * 30.6001);
	        var month = e - (e > 13.5 ? 13 : 1);
	        var year = c - (month > 2.5 ? 4716 : 4715);
	        if (year <= 0) { year--; } // No year zero
	        return this.newDate(year, month, day);
	    },
	
	    /** Convert this date to a standard (Gregorian) JavaScript Date.
	        @memberof GregorianCalendar
	        @param year {CDate|number} The date to convert or the year to convert.
	        @param [month] {number} The month to convert.
	        @param [day] {number} The day to convert.
	        @return {Date} The equivalent JavaScript date.
	        @throws Error if an invalid date or a different calendar used. */
	    toJSDate: function(year, month, day) {
	        var date = this._validate(year, month, day,
	            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
	        var jsd = new Date(date.year(), date.month() - 1, date.day());
	        jsd.setHours(0);
	        jsd.setMinutes(0);
	        jsd.setSeconds(0);
	        jsd.setMilliseconds(0);
	        // Hours may be non-zero on daylight saving cut-over:
	        // > 12 when midnight changeover, but then cannot generate
	        // midnight datetime, so jump to 1AM, otherwise reset.
	        jsd.setHours(jsd.getHours() > 12 ? jsd.getHours() + 2 : 0);
	        return jsd;
	    },
	
	    /** Create a new date from a standard (Gregorian) JavaScript Date.
	        @memberof GregorianCalendar
	        @param jsd {Date} The JavaScript date to convert.
	        @return {CDate} The equivalent date. */
	    fromJSDate: function(jsd) {
	        return this.newDate(jsd.getFullYear(), jsd.getMonth() + 1, jsd.getDate());
	    }
	});
	
	// Singleton manager
	var _exports = module.exports = new Calendars();
	
	// Date template
	_exports.cdate = CDate;
	
	// Base calendar template
	_exports.baseCalendar = BaseCalendar;
	
	// Gregorian calendar implementation
	_exports.calendars.gregorian = GregorianCalendar;
	
	
	},{"object-assign":455}],570:[function(_dereq_,module,exports){
	/*
	 * World Calendars
	 * https://github.com/alexcjohnson/world-calendars
	 *
	 * Batch-converted from kbwood/calendars
	 * Many thanks to Keith Wood and all of the contributors to the original project!
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	﻿/* http://keith-wood.name/calendars.html
	   Calendars extras for jQuery v2.0.2.
	   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
	   Available under the MIT (http://keith-wood.name/licence.html) license. 
	   Please attribute the author if you use it. */
	
	var assign = _dereq_('object-assign');
	var main = _dereq_('./main');
	
	
	assign(main.regionalOptions[''], {
	    invalidArguments: 'Invalid arguments',
	    invalidFormat: 'Cannot format a date from another calendar',
	    missingNumberAt: 'Missing number at position {0}',
	    unknownNameAt: 'Unknown name at position {0}',
	    unexpectedLiteralAt: 'Unexpected literal at position {0}',
	    unexpectedText: 'Additional text found at end'
	});
	main.local = main.regionalOptions[''];
	
	assign(main.cdate.prototype, {
	
	    /** Format this date.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof CDate
	        @param [format] {string} The date format to use (see <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a>).
	        @param [settings] {object} Options for the <code>formatDate</code> function.
	        @return {string} The formatted date. */
	    formatDate: function(format, settings) {
	        if (typeof format !== 'string') {
	            settings = format;
	            format = '';
	        }
	        return this._calendar.formatDate(format || '', this, settings);
	    }
	});
	
	assign(main.baseCalendar.prototype, {
	
	    UNIX_EPOCH: main.instance().newDate(1970, 1, 1).toJD(),
	    SECS_PER_DAY: 24 * 60 * 60,
	    TICKS_EPOCH: main.instance().jdEpoch, // 1 January 0001 CE
	    TICKS_PER_DAY: 24 * 60 * 60 * 10000000,
	
	    /** Date form for ATOM (RFC 3339/ISO 8601).
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    ATOM: 'yyyy-mm-dd',
	    /** Date form for cookies.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    COOKIE: 'D, dd M yyyy',
	    /** Date form for full date.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    FULL: 'DD, MM d, yyyy',
	    /** Date form for ISO 8601.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    ISO_8601: 'yyyy-mm-dd',
	    /** Date form for Julian date.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    JULIAN: 'J',
	    /** Date form for RFC 822.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RFC_822: 'D, d M yy',
	    /** Date form for RFC 850.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RFC_850: 'DD, dd-M-yy',
	    /** Date form for RFC 1036.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RFC_1036: 'D, d M yy',
	    /** Date form for RFC 1123.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RFC_1123: 'D, d M yyyy',
	    /** Date form for RFC 2822.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RFC_2822: 'D, d M yyyy',
	    /** Date form for RSS (RFC 822).
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    RSS: 'D, d M yy',
	    /** Date form for Windows ticks.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    TICKS: '!',
	    /** Date form for Unix timestamp.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    TIMESTAMP: '@',
	    /** Date form for W3c (ISO 8601).
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar */
	    W3C: 'yyyy-mm-dd',
	
	    /** Format a date object into a string value.
	        The format can be combinations of the following:
	        <ul>
	        <li>d  - day of month (no leading zero)</li>
	        <li>dd - day of month (two digit)</li>
	        <li>o  - day of year (no leading zeros)</li>
	        <li>oo - day of year (three digit)</li>
	        <li>D  - day name short</li>
	        <li>DD - day name long</li>
	        <li>w  - week of year (no leading zero)</li>
	        <li>ww - week of year (two digit)</li>
	        <li>m  - month of year (no leading zero)</li>
	        <li>mm - month of year (two digit)</li>
	        <li>M  - month name short</li>
	        <li>MM - month name long</li>
	        <li>yy - year (two digit)</li>
	        <li>yyyy - year (four digit)</li>
	        <li>YYYY - formatted year</li>
	        <li>J  - Julian date (days since January 1, 4713 BCE Greenwich noon)</li>
	        <li>@  - Unix timestamp (s since 01/01/1970)</li>
	        <li>!  - Windows ticks (100ns since 01/01/0001)</li>
	        <li>'...' - literal text</li>
	        <li>'' - single quote</li>
	        </ul>
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar
	        @param [format] {string} The desired format of the date (defaults to calendar format).
	        @param date {CDate} The date value to format.
	        @param [settings] {object} Addition options, whose attributes include:
	        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	        @property [dayNames] {string[]} Names of the days from Sunday.
	        @property [monthNamesShort] {string[]} Abbreviated names of the months.
	        @property [monthNames] {string[]} Names of the months.
	        @property [calculateWeek] {CalendarsPickerCalculateWeek} Function that determines week of the year.
	        @property [localNumbers=false] {boolean} <code>true</code> to localise numbers (if available),
	                  <code>false</code> to use normal Arabic numerals.
	        @return {string} The date in the above format.
	        @throws Errors if the date is from a different calendar. */
	    formatDate: function(format, date, settings) {
	        if (typeof format !== 'string') {
	            settings = date;
	            date = format;
	            format = '';
	        }
	        if (!date) {
	            return '';
	        }
	        if (date.calendar() !== this) {
	            throw main.local.invalidFormat || main.regionalOptions[''].invalidFormat;
	        }
	        format = format || this.local.dateFormat;
	        settings = settings || {};
	        var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
	        var dayNames = settings.dayNames || this.local.dayNames;
	        var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
	        var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
	        var monthNames = settings.monthNames || this.local.monthNames;
	        var calculateWeek = settings.calculateWeek || this.local.calculateWeek;
	        // Check whether a format character is doubled
	        var doubled = function(match, step) {
	            var matches = 1;
	            while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
	                matches++;
	            }
	            iFormat += matches - 1;
	            return Math.floor(matches / (step || 1)) > 1;
	        };
	        // Format a number, with leading zeroes if necessary
	        var formatNumber = function(match, value, len, step) {
	            var num = '' + value;
	            if (doubled(match, step)) {
	                while (num.length < len) {
	                    num = '0' + num;
	                }
	            }
	            return num;
	        };
	        // Format a name, short or long as requested
	        var formatName = function(match, value, shortNames, longNames) {
	            return (doubled(match) ? longNames[value] : shortNames[value]);
	        };
	        // Format month number
	        // (e.g. Chinese calendar needs to account for intercalary months)
	        var calendar = this;
	        var formatMonth = function(date) {
	            return (typeof monthNumbers === 'function') ?
	                monthNumbers.call(calendar, date, doubled('m')) :
	                localiseNumbers(formatNumber('m', date.month(), 2));
	        };
	        // Format a month name, short or long as requested
	        var formatMonthName = function(date, useLongName) {
	            if (useLongName) {
	                return (typeof monthNames === 'function') ?
	                    monthNames.call(calendar, date) :
	                    monthNames[date.month() - calendar.minMonth];
	            } else {
	                return (typeof monthNamesShort === 'function') ?
	                    monthNamesShort.call(calendar, date) :
	                    monthNamesShort[date.month() - calendar.minMonth];
	            }
	        };
	        // Localise numbers if requested and available
	        var digits = this.local.digits;
	        var localiseNumbers = function(value) {
	            return (settings.localNumbers && digits ? digits(value) : value);
	        };
	        var output = '';
	        var literal = false;
	        for (var iFormat = 0; iFormat < format.length; iFormat++) {
	            if (literal) {
	                if (format.charAt(iFormat) === "'" && !doubled("'")) {
	                    literal = false;
	                }
	                else {
	                    output += format.charAt(iFormat);
	                }
	            }
	            else {
	                switch (format.charAt(iFormat)) {
	                    case 'd': output += localiseNumbers(formatNumber('d', date.day(), 2)); break;
	                    case 'D': output += formatName('D', date.dayOfWeek(),
	                        dayNamesShort, dayNames); break;
	                    case 'o': output += formatNumber('o', date.dayOfYear(), 3); break;
	                    case 'w': output += formatNumber('w', date.weekOfYear(), 2); break;
	                    case 'm': output += formatMonth(date); break;
	                    case 'M': output += formatMonthName(date, doubled('M')); break;
	                    case 'y':
	                        output += (doubled('y', 2) ? date.year() :
	                            (date.year() % 100 < 10 ? '0' : '') + date.year() % 100);
	                        break;
	                    case 'Y':
	                        doubled('Y', 2);
	                        output += date.formatYear();
	                        break;
	                    case 'J': output += date.toJD(); break;
	                    case '@': output += (date.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY; break;
	                    case '!': output += (date.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY; break;
	                    case "'":
	                        if (doubled("'")) {
	                            output += "'";
	                        }
	                        else {
	                            literal = true;
	                        }
	                        break;
	                    default:
	                        output += format.charAt(iFormat);
	                }
	            }
	        }
	        return output;
	    },
	
	    /** Parse a string value into a date object.
	        See <a href="#formatDate"><code>formatDate</code></a> for the possible formats, plus:
	        <ul>
	        <li>* - ignore rest of string</li>
	        </ul>
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar
	        @param format {string} The expected format of the date ('' for default calendar format).
	        @param value {string} The date in the above format.
	        @param [settings] {object} Additional options whose attributes include:
	        @property [shortYearCutoff] {number} The cutoff year for determining the century.
	        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	        @property [dayNames] {string[]} Names of the days from Sunday.
	        @property [monthNamesShort] {string[]} Abbreviated names of the months.
	        @property [monthNames] {string[]} Names of the months.
	        @return {CDate} The extracted date value or <code>null</code> if value is blank.
	        @throws Errors if the format and/or value are missing,
	                if the value doesn't match the format, or if the date is invalid. */
	    parseDate: function(format, value, settings) {
	        if (value == null) {
	            throw main.local.invalidArguments || main.regionalOptions[''].invalidArguments;
	        }
	        value = (typeof value === 'object' ? value.toString() : value + '');
	        if (value === '') {
	            return null;
	        }
	        format = format || this.local.dateFormat;
	        settings = settings || {};
	        var shortYearCutoff = settings.shortYearCutoff || this.shortYearCutoff;
	        shortYearCutoff = (typeof shortYearCutoff !== 'string' ? shortYearCutoff :
	            this.today().year() % 100 + parseInt(shortYearCutoff, 10));
	        var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
	        var dayNames = settings.dayNames || this.local.dayNames;
	        var parseMonth = settings.parseMonth || this.local.parseMonth;
	        var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
	        var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
	        var monthNames = settings.monthNames || this.local.monthNames;
	        var jd = -1;
	        var year = -1;
	        var month = -1;
	        var day = -1;
	        var doy = -1;
	        var shortYear = false;
	        var literal = false;
	        // Check whether a format character is doubled
	        var doubled = function(match, step) {
	            var matches = 1;
	            while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
	                matches++;
	            }
	            iFormat += matches - 1;
	            return Math.floor(matches / (step || 1)) > 1;
	        };
	        // Extract a number from the string value
	        var getNumber = function(match, step) {
	            var isDoubled = doubled(match, step);
	            var size = [2, 3, isDoubled ? 4 : 2, isDoubled ? 4 : 2, 10, 11, 20]['oyYJ@!'.indexOf(match) + 1];
	            var digits = new RegExp('^-?\\d{1,' + size + '}');
	            var num = value.substring(iValue).match(digits);
	            if (!num) {
	                throw (main.local.missingNumberAt || main.regionalOptions[''].missingNumberAt).
	                    replace(/\{0\}/, iValue);
	            }
	            iValue += num[0].length;
	            return parseInt(num[0], 10);
	        };
	        // Extract a month number from the string value
	        var calendar = this;
	        var getMonthNumber = function() {
	            if (typeof monthNumbers === 'function') {
	                doubled('m');  // update iFormat
	                var month = monthNumbers.call(calendar, value.substring(iValue));
	                iValue += month.length;
	                return month;
	            }
	
	            return getNumber('m');
	        };
	        // Extract a name from the string value and convert to an index
	        var getName = function(match, shortNames, longNames, step) {
	            var names = (doubled(match, step) ? longNames : shortNames);
	            for (var i = 0; i < names.length; i++) {
	                if (value.substr(iValue, names[i].length).toLowerCase() === names[i].toLowerCase()) {
	                    iValue += names[i].length;
	                    return i + calendar.minMonth;
	                }
	            }
	            throw (main.local.unknownNameAt || main.regionalOptions[''].unknownNameAt).
	                replace(/\{0\}/, iValue);
	        };
	        // Extract a month number from the string value
	        var getMonthName = function() {
	            if (typeof monthNames === 'function') {
	                var month = doubled('M') ?
	                    monthNames.call(calendar, value.substring(iValue)) :
	                    monthNamesShort.call(calendar, value.substring(iValue));
	                iValue += month.length;
	                return month;
	            }
	
	            return getName('M', monthNamesShort, monthNames);
	        };
	        // Confirm that a literal character matches the string value
	        var checkLiteral = function() {
	            if (value.charAt(iValue) !== format.charAt(iFormat)) {
	                throw (main.local.unexpectedLiteralAt ||
	                    main.regionalOptions[''].unexpectedLiteralAt).replace(/\{0\}/, iValue);
	            }
	            iValue++;
	        };
	        var iValue = 0;
	        for (var iFormat = 0; iFormat < format.length; iFormat++) {
	            if (literal) {
	                if (format.charAt(iFormat) === "'" && !doubled("'")) {
	                    literal = false;
	                }
	                else {
	                    checkLiteral();
	                }
	            }
	            else {
	                switch (format.charAt(iFormat)) {
	                    case 'd': day = getNumber('d'); break;
	                    case 'D': getName('D', dayNamesShort, dayNames); break;
	                    case 'o': doy = getNumber('o'); break;
	                    case 'w': getNumber('w'); break;
	                    case 'm': month = getMonthNumber(); break;
	                    case 'M': month = getMonthName(); break;
	                    case 'y':
	                        var iSave = iFormat;
	                        shortYear = !doubled('y', 2);
	                        iFormat = iSave;
	                        year = getNumber('y', 2);
	                        break;
	                    case 'Y': year = getNumber('Y', 2); break;
	                    case 'J':
	                        jd = getNumber('J') + 0.5;
	                        if (value.charAt(iValue) === '.') {
	                            iValue++;
	                            getNumber('J');
	                        }
	                        break;
	                    case '@': jd = getNumber('@') / this.SECS_PER_DAY + this.UNIX_EPOCH; break;
	                    case '!': jd = getNumber('!') / this.TICKS_PER_DAY + this.TICKS_EPOCH; break;
	                    case '*': iValue = value.length; break;
	                    case "'":
	                        if (doubled("'")) {
	                            checkLiteral();
	                        }
	                        else {
	                            literal = true;
	                        }
	                        break;
	                    default: checkLiteral();
	                }
	            }
	        }
	        if (iValue < value.length) {
	            throw main.local.unexpectedText || main.regionalOptions[''].unexpectedText;
	        }
	        if (year === -1) {
	            year = this.today().year();
	        }
	        else if (year < 100 && shortYear) {
	            year += (shortYearCutoff === -1 ? 1900 : this.today().year() -
	                this.today().year() % 100 - (year <= shortYearCutoff ? 0 : 100));
	        }
	        if (typeof month === 'string') {
	            month = parseMonth.call(this, year, month);
	        }
	        if (doy > -1) {
	            month = 1;
	            day = doy;
	            for (var dim = this.daysInMonth(year, month); day > dim; dim = this.daysInMonth(year, month)) {
	                month++;
	                day -= dim;
	            }
	        }
	        return (jd > -1 ? this.fromJD(jd) : this.newDate(year, month, day));
	    },
	
	    /** A date may be specified as an exact value or a relative one.
	        Found in the <code>jquery.calendars.plus.js</code> module.
	        @memberof BaseCalendar
	        @param dateSpec {CDate|number|string} The date as an object or string in the given format or
	                an offset - numeric days from today, or string amounts and periods, e.g. '+1m +2w'.
	        @param defaultDate {CDate} The date to use if no other supplied, may be <code>null</code>.
	        @param currentDate {CDate} The current date as a possible basis for relative dates,
	                if <code>null</code> today is used (optional)
	        @param [dateFormat] {string} The expected date format - see <a href="#formatDate"><code>formatDate</code></a>.
	        @param [settings] {object} Additional options whose attributes include:
	        @property [shortYearCutoff] {number} The cutoff year for determining the century.
	        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	        @property [dayNames] {string[]} Names of the days from Sunday.
	        @property [monthNamesShort] {string[]} Abbreviated names of the months.
	        @property [monthNames] {string[]} Names of the months.
	        @return {CDate} The decoded date. */
	    determineDate: function(dateSpec, defaultDate, currentDate, dateFormat, settings) {
	        if (currentDate && typeof currentDate !== 'object') {
	            settings = dateFormat;
	            dateFormat = currentDate;
	            currentDate = null;
	        }
	        if (typeof dateFormat !== 'string') {
	            settings = dateFormat;
	            dateFormat = '';
	        }
	        var calendar = this;
	        var offsetString = function(offset) {
	            try {
	                return calendar.parseDate(dateFormat, offset, settings);
	            }
	            catch (e) {
	                // Ignore
	            }
	            offset = offset.toLowerCase();
	            var date = (offset.match(/^c/) && currentDate ?
	                currentDate.newDate() : null) || calendar.today();
	            var pattern = /([+-]?[0-9]+)\s*(d|w|m|y)?/g;
	            var matches = pattern.exec(offset);
	            while (matches) {
	                date.add(parseInt(matches[1], 10), matches[2] || 'd');
	                matches = pattern.exec(offset);
	            }
	            return date;
	        };
	        defaultDate = (defaultDate ? defaultDate.newDate() : null);
	        dateSpec = (dateSpec == null ? defaultDate :
	            (typeof dateSpec === 'string' ? offsetString(dateSpec) : (typeof dateSpec === 'number' ?
	            (isNaN(dateSpec) || dateSpec === Infinity || dateSpec === -Infinity ? defaultDate :
	            calendar.today().add(dateSpec, 'd')) : calendar.newDate(dateSpec))));
	        return dateSpec;
	    }
	});
	
	
	},{"./main":569,"object-assign":455}],571:[function(_dereq_,module,exports){
	module.exports = _dereq_('cwise-compiler')({
	    args: ['array', {
	        offset: [1],
	        array: 0
	    }, 'scalar', 'scalar', 'index'],
	    pre: {
	        "body": "{}",
	        "args": [],
	        "thisVars": [],
	        "localVars": []
	    },
	    post: {
	        "body": "{}",
	        "args": [],
	        "thisVars": [],
	        "localVars": []
	    },
	    body: {
	        "body": "{\n        var _inline_1_da = _inline_1_arg0_ - _inline_1_arg3_\n        var _inline_1_db = _inline_1_arg1_ - _inline_1_arg3_\n        if((_inline_1_da >= 0) !== (_inline_1_db >= 0)) {\n          _inline_1_arg2_.push(_inline_1_arg4_[0] + 0.5 + 0.5 * (_inline_1_da + _inline_1_db) / (_inline_1_da - _inline_1_db))\n        }\n      }",
	        "args": [{
	            "name": "_inline_1_arg0_",
	            "lvalue": false,
	            "rvalue": true,
	            "count": 1
	        }, {
	            "name": "_inline_1_arg1_",
	            "lvalue": false,
	            "rvalue": true,
	            "count": 1
	        }, {
	            "name": "_inline_1_arg2_",
	            "lvalue": false,
	            "rvalue": true,
	            "count": 1
	        }, {
	            "name": "_inline_1_arg3_",
	            "lvalue": false,
	            "rvalue": true,
	            "count": 2
	        }, {
	            "name": "_inline_1_arg4_",
	            "lvalue": false,
	            "rvalue": true,
	            "count": 1
	        }],
	        "thisVars": [],
	        "localVars": ["_inline_1_da", "_inline_1_db"]
	    },
	    funcName: 'zeroCrossings'
	})
	
	},{"cwise-compiler":147}],572:[function(_dereq_,module,exports){
	"use strict"
	
	module.exports = findZeroCrossings
	
	var core = _dereq_("./lib/zc-core")
	
	function findZeroCrossings(array, level) {
	  var cross = []
	  level = +level || 0.0
	  core(array.hi(array.shape[0]-1), cross, level)
	  return cross
	}
	},{"./lib/zc-core":571}],573:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * All paths are tuned for maximum scalability of the arrowhead,
	 * ie throughout arrowwidth=0.3..3 the head is joined smoothly
	 * to the line, with the line coming from the left and ending at (0, 0).
	 *
	 * `backoff` is the distance to move the arrowhead and the end of the line,
	 * in order that the arrowhead points to the desired place, either at
	 * the tip of the arrow or (in the case of circle or square)
	 * the center of the symbol.
	 *
	 * `noRotate`, if truthy, says that this arrowhead should not rotate with the
	 * arrow. That's the case for squares, which should always be straight, and
	 * circles, for which it's irrelevant.
	 */
	
	module.exports = [
	    // no arrow
	    {
	        path: '',
	        backoff: 0
	    },
	    // wide with flat back
	    {
	        path: 'M-2.4,-3V3L0.6,0Z',
	        backoff: 0.6
	    },
	    // narrower with flat back
	    {
	        path: 'M-3.7,-2.5V2.5L1.3,0Z',
	        backoff: 1.3
	    },
	    // barbed
	    {
	        path: 'M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z',
	        backoff: 1.55
	    },
	    // wide line-drawn
	    {
	        path: 'M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z',
	        backoff: 1.6
	    },
	    // narrower line-drawn
	    {
	        path: 'M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z',
	        backoff: 2
	    },
	    // circle
	    {
	        path: 'M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z',
	        backoff: 0,
	        noRotate: true
	    },
	    // square
	    {
	        path: 'M2,2V-2H-2V2Z',
	        backoff: 0,
	        noRotate: true
	    }
	];
	
	},{}],574:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var ARROWPATHS = _dereq_('./arrow_paths');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var cartesianConstants = _dereq_('../../plots/cartesian/constants');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	
	module.exports = templatedArray('annotation', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc+arraydraw',
	        
	    },
	
	    text: {
	        valType: 'string',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    textangle: {
	        valType: 'angle',
	        dflt: 0,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    font: fontAttrs({
	        editType: 'calc+arraydraw',
	        colorEditType: 'arraydraw',
	        
	    }),
	    width: {
	        valType: 'number',
	        min: 1,
	        dflt: null,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    height: {
	        valType: 'number',
	        min: 1,
	        dflt: null,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    opacity: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 1,
	        
	        editType: 'arraydraw',
	        
	    },
	    align: {
	        valType: 'enumerated',
	        values: ['left', 'center', 'right'],
	        dflt: 'center',
	        
	        editType: 'arraydraw',
	        
	    },
	    valign: {
	        valType: 'enumerated',
	        values: ['top', 'middle', 'bottom'],
	        dflt: 'middle',
	        
	        editType: 'arraydraw',
	        
	    },
	    bgcolor: {
	        valType: 'color',
	        dflt: 'rgba(0,0,0,0)',
	        
	        editType: 'arraydraw',
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: 'rgba(0,0,0,0)',
	        
	        editType: 'arraydraw',
	        
	    },
	    borderpad: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    borderwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    // arrow
	    showarrow: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    arrowcolor: {
	        valType: 'color',
	        
	        editType: 'arraydraw',
	        
	    },
	    arrowhead: {
	        valType: 'integer',
	        min: 0,
	        max: ARROWPATHS.length,
	        dflt: 1,
	        
	        editType: 'arraydraw',
	        
	    },
	    startarrowhead: {
	        valType: 'integer',
	        min: 0,
	        max: ARROWPATHS.length,
	        dflt: 1,
	        
	        editType: 'arraydraw',
	        
	    },
	    arrowside: {
	        valType: 'flaglist',
	        flags: ['end', 'start'],
	        extras: ['none'],
	        dflt: 'end',
	        
	        editType: 'arraydraw',
	        
	    },
	    arrowsize: {
	        valType: 'number',
	        min: 0.3,
	        dflt: 1,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    startarrowsize: {
	        valType: 'number',
	        min: 0.3,
	        dflt: 1,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    arrowwidth: {
	        valType: 'number',
	        min: 0.1,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    standoff: {
	        valType: 'number',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    startstandoff: {
	        valType: 'number',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    ax: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    ay: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    axref: {
	        valType: 'enumerated',
	        dflt: 'pixel',
	        values: [
	            'pixel',
	            cartesianConstants.idRegex.x.toString()
	        ],
	        
	        editType: 'calc',
	        
	    },
	    ayref: {
	        valType: 'enumerated',
	        dflt: 'pixel',
	        values: [
	            'pixel',
	            cartesianConstants.idRegex.y.toString()
	        ],
	        
	        editType: 'calc',
	        
	    },
	    // positioning
	    xref: {
	        valType: 'enumerated',
	        values: [
	            'paper',
	            cartesianConstants.idRegex.x.toString()
	        ],
	        
	        editType: 'calc',
	        
	    },
	    x: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    xanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'left', 'center', 'right'],
	        dflt: 'auto',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    xshift: {
	        valType: 'number',
	        dflt: 0,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    yref: {
	        valType: 'enumerated',
	        values: [
	            'paper',
	            cartesianConstants.idRegex.y.toString()
	        ],
	        
	        editType: 'calc',
	        
	    },
	    y: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'top', 'middle', 'bottom'],
	        dflt: 'auto',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    yshift: {
	        valType: 'number',
	        dflt: 0,
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    clicktoshow: {
	        valType: 'enumerated',
	        values: [false, 'onoff', 'onout'],
	        dflt: false,
	        
	        editType: 'arraydraw',
	        
	    },
	    xclick: {
	        valType: 'any',
	        
	        editType: 'arraydraw',
	        
	    },
	    yclick: {
	        valType: 'any',
	        
	        editType: 'arraydraw',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        editType: 'arraydraw',
	        
	    },
	    hoverlabel: {
	        bgcolor: {
	            valType: 'color',
	            
	            editType: 'arraydraw',
	            
	        },
	        bordercolor: {
	            valType: 'color',
	            
	            editType: 'arraydraw',
	            
	        },
	        font: fontAttrs({
	            editType: 'arraydraw',
	            
	        }),
	        editType: 'arraydraw'
	    },
	    captureevents: {
	        valType: 'boolean',
	        
	        editType: 'arraydraw',
	        
	    },
	    editType: 'calc',
	
	    _deprecated: {
	        ref: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        }
	    }
	});
	
	},{"../../plot_api/plot_template":754,"../../plots/cartesian/constants":770,"../../plots/font_attributes":790,"./arrow_paths":573}],575:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var draw = _dereq_('./draw').draw;
	
	
	module.exports = function calcAutorange(gd) {
	    var fullLayout = gd._fullLayout;
	    var annotationList = Lib.filterVisible(fullLayout.annotations);
	
	    if(annotationList.length && gd._fullData.length) {
	        return Lib.syncOrAsync([draw, annAutorange], gd);
	    }
	};
	
	function annAutorange(gd) {
	    var fullLayout = gd._fullLayout;
	
	    // find the bounding boxes for each of these annotations'
	    // relative to their anchor points
	    // use the arrow and the text bg rectangle,
	    // as the whole anno may include hidden text in its bbox
	    Lib.filterVisible(fullLayout.annotations).forEach(function(ann) {
	        var xa = Axes.getFromId(gd, ann.xref);
	        var ya = Axes.getFromId(gd, ann.yref);
	
	        ann._extremes = {};
	        if(xa) calcAxisExpansion(ann, xa);
	        if(ya) calcAxisExpansion(ann, ya);
	    });
	}
	
	function calcAxisExpansion(ann, ax) {
	    var axId = ax._id;
	    var letter = axId.charAt(0);
	    var pos = ann[letter];
	    var apos = ann['a' + letter];
	    var ref = ann[letter + 'ref'];
	    var aref = ann['a' + letter + 'ref'];
	    var padplus = ann['_' + letter + 'padplus'];
	    var padminus = ann['_' + letter + 'padminus'];
	    var shift = {x: 1, y: -1}[letter] * ann[letter + 'shift'];
	    var headSize = 3 * ann.arrowsize * ann.arrowwidth || 0;
	    var headPlus = headSize + shift;
	    var headMinus = headSize - shift;
	    var startHeadSize = 3 * ann.startarrowsize * ann.arrowwidth || 0;
	    var startHeadPlus = startHeadSize + shift;
	    var startHeadMinus = startHeadSize - shift;
	    var extremes;
	
	    if(aref === ref) {
	        // expand for the arrowhead (padded by arrowhead)
	        var extremeArrowHead = Axes.findExtremes(ax, [ax.r2c(pos)], {
	            ppadplus: headPlus,
	            ppadminus: headMinus
	        });
	        // again for the textbox (padded by textbox)
	        var extremeText = Axes.findExtremes(ax, [ax.r2c(apos)], {
	            ppadplus: Math.max(padplus, startHeadPlus),
	            ppadminus: Math.max(padminus, startHeadMinus)
	        });
	        extremes = {
	            min: [extremeArrowHead.min[0], extremeText.min[0]],
	            max: [extremeArrowHead.max[0], extremeText.max[0]]
	        };
	    } else {
	        startHeadPlus = apos ? startHeadPlus + apos : startHeadPlus;
	        startHeadMinus = apos ? startHeadMinus - apos : startHeadMinus;
	        extremes = Axes.findExtremes(ax, [ax.r2c(pos)], {
	            ppadplus: Math.max(padplus, headPlus, startHeadPlus),
	            ppadminus: Math.max(padminus, headMinus, startHeadMinus)
	        });
	    }
	
	    ann._extremes[axId] = extremes;
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"./draw":580}],576:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
	
	module.exports = {
	    hasClickToShow: hasClickToShow,
	    onClick: onClick
	};
	
	/*
	 * hasClickToShow: does the given hoverData have ANY annotations which will
	 * turn ON if we click here? (used by hover events to set cursor)
	 *
	 * gd: graphDiv
	 * hoverData: a hoverData array, as included with the *plotly_hover* or
	 *     *plotly_click* events in the `points` attribute
	 *
	 * returns: boolean
	 */
	function hasClickToShow(gd, hoverData) {
	    var sets = getToggleSets(gd, hoverData);
	    return sets.on.length > 0 || sets.explicitOff.length > 0;
	}
	
	/*
	 * onClick: perform the toggling (via Plotly.update) implied by clicking
	 * at this hoverData
	 *
	 * gd: graphDiv
	 * hoverData: a hoverData array, as included with the *plotly_hover* or
	 *     *plotly_click* events in the `points` attribute
	 *
	 * returns: Promise that the update is complete
	 */
	function onClick(gd, hoverData) {
	    var toggleSets = getToggleSets(gd, hoverData);
	    var onSet = toggleSets.on;
	    var offSet = toggleSets.off.concat(toggleSets.explicitOff);
	    var update = {};
	    var annotationsOut = gd._fullLayout.annotations;
	    var i, editHelpers;
	
	    if(!(onSet.length || offSet.length)) return;
	
	    for(i = 0; i < onSet.length; i++) {
	        editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[onSet[i]]);
	        editHelpers.modifyItem('visible', true);
	        Lib.extendFlat(update, editHelpers.getUpdateObj());
	    }
	
	    for(i = 0; i < offSet.length; i++) {
	        editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[offSet[i]]);
	        editHelpers.modifyItem('visible', false);
	        Lib.extendFlat(update, editHelpers.getUpdateObj());
	    }
	
	    return Registry.call('update', gd, {}, update);
	}
	
	/*
	 * getToggleSets: find the annotations which will turn on or off at this
	 * hoverData
	 *
	 * gd: graphDiv
	 * hoverData: a hoverData array, as included with the *plotly_hover* or
	 *     *plotly_click* events in the `points` attribute
	 *
	 * returns: {
	 *   on: Array (indices of annotations to turn on),
	 *   off: Array (indices to turn off because you're not hovering on them),
	 *   explicitOff: Array (indices to turn off because you *are* hovering on them)
	 * }
	 */
	function getToggleSets(gd, hoverData) {
	    var annotations = gd._fullLayout.annotations;
	    var onSet = [];
	    var offSet = [];
	    var explicitOffSet = [];
	    var hoverLen = (hoverData || []).length;
	
	    var i, j, anni, showMode, pointj, xa, ya, toggleType;
	
	    for(i = 0; i < annotations.length; i++) {
	        anni = annotations[i];
	        showMode = anni.clicktoshow;
	
	        if(showMode) {
	            for(j = 0; j < hoverLen; j++) {
	                pointj = hoverData[j];
	                xa = pointj.xaxis;
	                ya = pointj.yaxis;
	
	                if(xa._id === anni.xref &&
	                    ya._id === anni.yref &&
	                    xa.d2r(pointj.x) === clickData2r(anni._xclick, xa) &&
	                    ya.d2r(pointj.y) === clickData2r(anni._yclick, ya)
	                ) {
	                    // match! toggle this annotation
	                    // regardless of its clicktoshow mode
	                    // but if it's onout mode, off is implicit
	                    if(anni.visible) {
	                        if(showMode === 'onout') toggleType = offSet;
	                        else toggleType = explicitOffSet;
	                    } else {
	                        toggleType = onSet;
	                    }
	                    toggleType.push(i);
	                    break;
	                }
	            }
	
	            if(j === hoverLen) {
	                // no match - only turn this annotation OFF, and only if
	                // showmode is 'onout'
	                if(anni.visible && showMode === 'onout') offSet.push(i);
	            }
	        }
	    }
	
	    return {on: onSet, off: offSet, explicitOff: explicitOffSet};
	}
	
	// to handle log axes until v2
	function clickData2r(d, ax) {
	    return ax.type === 'log' ? ax.l2r(d) : ax.d2r(d);
	}
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../registry":845}],577:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../color');
	
	// defaults common to 'annotations' and 'annotations3d'
	module.exports = function handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce) {
	    coerce('opacity');
	    var bgColor = coerce('bgcolor');
	
	    var borderColor = coerce('bordercolor');
	    var borderOpacity = Color.opacity(borderColor);
	
	    coerce('borderpad');
	
	    var borderWidth = coerce('borderwidth');
	    var showArrow = coerce('showarrow');
	
	    coerce('text', showArrow ? ' ' : fullLayout._dfltTitle.annotation);
	    coerce('textangle');
	    Lib.coerceFont(coerce, 'font', fullLayout.font);
	
	    coerce('width');
	    coerce('align');
	
	    var h = coerce('height');
	    if(h) coerce('valign');
	
	    if(showArrow) {
	        var arrowside = coerce('arrowside');
	        var arrowhead;
	        var arrowsize;
	
	        if(arrowside.indexOf('end') !== -1) {
	            arrowhead = coerce('arrowhead');
	            arrowsize = coerce('arrowsize');
	        }
	
	        if(arrowside.indexOf('start') !== -1) {
	            coerce('startarrowhead', arrowhead);
	            coerce('startarrowsize', arrowsize);
	        }
	        coerce('arrowcolor', borderOpacity ? annOut.bordercolor : Color.defaultLine);
	        coerce('arrowwidth', ((borderOpacity && borderWidth) || 1) * 2);
	        coerce('standoff');
	        coerce('startstandoff');
	    }
	
	    var hoverText = coerce('hovertext');
	    var globalHoverLabel = fullLayout.hoverlabel || {};
	
	    if(hoverText) {
	        var hoverBG = coerce('hoverlabel.bgcolor', globalHoverLabel.bgcolor ||
	            (Color.opacity(bgColor) ? Color.rgb(bgColor) : Color.defaultLine)
	        );
	
	        var hoverBorder = coerce('hoverlabel.bordercolor', globalHoverLabel.bordercolor ||
	            Color.contrast(hoverBG)
	        );
	
	        Lib.coerceFont(coerce, 'hoverlabel.font', {
	            family: globalHoverLabel.font.family,
	            size: globalHoverLabel.font.size,
	            color: globalHoverLabel.font.color || hoverBorder
	        });
	    }
	
	    coerce('captureevents', !!hoverText);
	};
	
	},{"../../lib":716,"../color":591}],578:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var toLogRange = _dereq_('../../lib/to_log_range');
	
	/*
	 * convertCoords: when converting an axis between log and linear
	 * you need to alter any annotations on that axis to keep them
	 * pointing at the same data point.
	 * In v2.0 this will become obsolete
	 *
	 * gd: the plot div
	 * ax: the axis being changed
	 * newType: the type it's getting
	 * doExtra: function(attr, val) from inside relayout that sets the attribute.
	 *     Use this to make the changes as it's aware if any other changes in the
	 *     same relayout call should override this conversion.
	 */
	module.exports = function convertCoords(gd, ax, newType, doExtra) {
	    ax = ax || {};
	
	    var toLog = (newType === 'log') && (ax.type === 'linear');
	    var fromLog = (newType === 'linear') && (ax.type === 'log');
	
	    if(!(toLog || fromLog)) return;
	
	    var annotations = gd._fullLayout.annotations;
	    var axLetter = ax._id.charAt(0);
	    var ann;
	    var attrPrefix;
	
	    function convert(attr) {
	        var currentVal = ann[attr];
	        var newVal = null;
	
	        if(toLog) newVal = toLogRange(currentVal, ax.range);
	        else newVal = Math.pow(10, currentVal);
	
	        // if conversion failed, delete the value so it gets a default value
	        if(!isNumeric(newVal)) newVal = null;
	
	        doExtra(attrPrefix + attr, newVal);
	    }
	
	    for(var i = 0; i < annotations.length; i++) {
	        ann = annotations[i];
	        attrPrefix = 'annotations[' + i + '].';
	
	        if(ann[axLetter + 'ref'] === ax._id) convert(axLetter);
	        if(ann['a' + axLetter + 'ref'] === ax._id) convert('a' + axLetter);
	    }
	};
	
	},{"../../lib/to_log_range":742,"fast-isnumeric":227}],579:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var handleAnnotationCommonDefaults = _dereq_('./common_defaults');
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    handleArrayContainerDefaults(layoutIn, layoutOut, {
	        name: 'annotations',
	        handleItemDefaults: handleAnnotationDefaults
	    });
	};
	
	function handleAnnotationDefaults(annIn, annOut, fullLayout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(annIn, annOut, attributes, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	    var clickToShow = coerce('clicktoshow');
	
	    if(!(visible || clickToShow)) return;
	
	    handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce);
	
	    var showArrow = annOut.showarrow;
	
	    // positioning
	    var axLetters = ['x', 'y'];
	    var arrowPosDflt = [-10, -30];
	    var gdMock = {_fullLayout: fullLayout};
	
	    for(var i = 0; i < 2; i++) {
	        var axLetter = axLetters[i];
	
	        // xref, yref
	        var axRef = Axes.coerceRef(annIn, annOut, gdMock, axLetter, '', 'paper');
	
	        if(axRef !== 'paper') {
	            var ax = Axes.getFromId(gdMock, axRef);
	            ax._annIndices.push(annOut._index);
	        }
	
	        // x, y
	        Axes.coercePosition(annOut, gdMock, coerce, axRef, axLetter, 0.5);
	
	        if(showArrow) {
	            var arrowPosAttr = 'a' + axLetter;
	            // axref, ayref
	            var aaxRef = Axes.coerceRef(annIn, annOut, gdMock, arrowPosAttr, 'pixel');
	
	            // for now the arrow can only be on the same axis or specified as pixels
	            // TODO: sometime it might be interesting to allow it to be on *any* axis
	            // but that would require updates to drawing & autorange code and maybe more
	            if(aaxRef !== 'pixel' && aaxRef !== axRef) {
	                aaxRef = annOut[arrowPosAttr] = 'pixel';
	            }
	
	            // ax, ay
	            var aDflt = (aaxRef === 'pixel') ? arrowPosDflt[i] : 0.4;
	            Axes.coercePosition(annOut, gdMock, coerce, aaxRef, arrowPosAttr, aDflt);
	        }
	
	        // xanchor, yanchor
	        coerce(axLetter + 'anchor');
	
	        // xshift, yshift
	        coerce(axLetter + 'shift');
	    }
	
	    // if you have one coordinate you should have both
	    Lib.noneOrAll(annIn, annOut, ['x', 'y']);
	
	    // if you have one part of arrow length you should have both
	    if(showArrow) {
	        Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
	    }
	
	    if(clickToShow) {
	        var xClick = coerce('xclick');
	        var yClick = coerce('yclick');
	
	        // put the actual click data to bind to into private attributes
	        // so we don't have to do this little bit of logic on every hover event
	        annOut._xclick = (xClick === undefined) ?
	            annOut.x :
	            Axes.cleanPosition(xClick, gdMock, annOut.xref);
	        annOut._yclick = (yClick === undefined) ?
	            annOut.y :
	            Axes.cleanPosition(yClick, gdMock, annOut.yref);
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/cartesian/axes":764,"./attributes":574,"./common_defaults":577}],580:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Plots = _dereq_('../../plots/plots');
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	var Fx = _dereq_('../fx');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var setCursor = _dereq_('../../lib/setcursor');
	var dragElement = _dereq_('../dragelement');
	var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
	
	var drawArrowHead = _dereq_('./draw_arrow_head');
	
	// Annotations are stored in gd.layout.annotations, an array of objects
	// index can point to one item in this array,
	//  or non-numeric to simply add a new one
	//  or -1 to modify all existing
	// opt can be the full options object, or one key (to be set to value)
	//  or undefined to simply redraw
	// if opt is blank, val can be 'add' or a full options object to add a new
	//  annotation at that point in the array, or 'remove' to delete this one
	
	module.exports = {
	    draw: draw,
	    drawOne: drawOne,
	    drawRaw: drawRaw
	};
	
	/*
	 * draw: draw all annotations without any new modifications
	 */
	function draw(gd) {
	    var fullLayout = gd._fullLayout;
	
	    fullLayout._infolayer.selectAll('.annotation').remove();
	
	    for(var i = 0; i < fullLayout.annotations.length; i++) {
	        if(fullLayout.annotations[i].visible) {
	            drawOne(gd, i);
	        }
	    }
	
	    return Plots.previousPromises(gd);
	}
	
	/*
	 * drawOne: draw a single cartesian or paper-ref annotation, potentially with modifications
	 *
	 * index (int): the annotation to draw
	 */
	function drawOne(gd, index) {
	    var fullLayout = gd._fullLayout;
	    var options = fullLayout.annotations[index] || {};
	    var xa = Axes.getFromId(gd, options.xref);
	    var ya = Axes.getFromId(gd, options.yref);
	
	    if(xa) xa.setScale();
	    if(ya) ya.setScale();
	
	    drawRaw(gd, options, index, false, xa, ya);
	}
	
	/**
	 * drawRaw: draw a single annotation, potentially with modifications
	 *
	 * @param {DOM element} gd
	 * @param {object} options : this annotation's fullLayout options
	 * @param {integer} index : index in 'annotations' container of the annotation to draw
	 * @param {string} subplotId : id of the annotation's subplot
	 *  - use false for 2d (i.e. cartesian or paper-ref) annotations
	 * @param {object | undefined} xa : full x-axis object to compute subplot pos-to-px
	 * @param {object | undefined} ya : ... y-axis
	 */
	function drawRaw(gd, options, index, subplotId, xa, ya) {
	    var fullLayout = gd._fullLayout;
	    var gs = gd._fullLayout._size;
	    var edits = gd._context.edits;
	
	    var className, containerStr;
	
	    if(subplotId) {
	        className = 'annotation-' + subplotId;
	        containerStr = subplotId + '.annotations';
	    } else {
	        className = 'annotation';
	        containerStr = 'annotations';
	    }
	
	    var editHelpers = arrayEditor(gd.layout, containerStr, options);
	    var modifyBase = editHelpers.modifyBase;
	    var modifyItem = editHelpers.modifyItem;
	    var getUpdateObj = editHelpers.getUpdateObj;
	
	    // remove the existing annotation if there is one
	    fullLayout._infolayer
	        .selectAll('.' + className + '[data-index="' + index + '"]')
	        .remove();
	
	    var annClipID = 'clip' + fullLayout._uid + '_ann' + index;
	
	    // this annotation is gone - quit now after deleting it
	    // TODO: use d3 idioms instead of deleting and redrawing every time
	    if(!options._input || options.visible === false) {
	        d3.selectAll('#' + annClipID).remove();
	        return;
	    }
	
	    // calculated pixel positions
	    // x & y each will get text, head, and tail as appropriate
	    var annPosPx = {x: {}, y: {}};
	    var textangle = +options.textangle || 0;
	
	    // create the components
	    // made a single group to contain all, so opacity can work right
	    // with border/arrow together this could handle a whole bunch of
	    // cleanup at this point, but works for now
	    var annGroup = fullLayout._infolayer.append('g')
	        .classed(className, true)
	        .attr('data-index', String(index))
	        .style('opacity', options.opacity);
	
	    // another group for text+background so that they can rotate together
	    var annTextGroup = annGroup.append('g')
	        .classed('annotation-text-g', true);
	
	    var editTextPosition = edits[options.showarrow ? 'annotationTail' : 'annotationPosition'];
	    var textEvents = options.captureevents || edits.annotationText || editTextPosition;
	
	    function makeEventData(initialEvent) {
	        var eventData = {
	            index: index,
	            annotation: options._input,
	            fullAnnotation: options,
	            event: initialEvent
	        };
	        if(subplotId) {
	            eventData.subplotId = subplotId;
	        }
	        return eventData;
	    }
	
	    var annTextGroupInner = annTextGroup.append('g')
	        .style('pointer-events', textEvents ? 'all' : null)
	        .call(setCursor, 'pointer')
	        .on('click', function() {
	            gd._dragging = false;
	            gd.emit('plotly_clickannotation', makeEventData(d3.event));
	        });
	
	    if(options.hovertext) {
	        annTextGroupInner
	        .on('mouseover', function() {
	            var hoverOptions = options.hoverlabel;
	            var hoverFont = hoverOptions.font;
	            var bBox = this.getBoundingClientRect();
	            var bBoxRef = gd.getBoundingClientRect();
	
	            Fx.loneHover({
	                x0: bBox.left - bBoxRef.left,
	                x1: bBox.right - bBoxRef.left,
	                y: (bBox.top + bBox.bottom) / 2 - bBoxRef.top,
	                text: options.hovertext,
	                color: hoverOptions.bgcolor,
	                borderColor: hoverOptions.bordercolor,
	                fontFamily: hoverFont.family,
	                fontSize: hoverFont.size,
	                fontColor: hoverFont.color
	            }, {
	                container: fullLayout._hoverlayer.node(),
	                outerContainer: fullLayout._paper.node(),
	                gd: gd
	            });
	        })
	        .on('mouseout', function() {
	            Fx.loneUnhover(fullLayout._hoverlayer.node());
	        });
	    }
	
	    var borderwidth = options.borderwidth;
	    var borderpad = options.borderpad;
	    var borderfull = borderwidth + borderpad;
	
	    var annTextBG = annTextGroupInner.append('rect')
	        .attr('class', 'bg')
	        .style('stroke-width', borderwidth + 'px')
	        .call(Color.stroke, options.bordercolor)
	        .call(Color.fill, options.bgcolor);
	
	    var isSizeConstrained = options.width || options.height;
	
	    var annTextClip = fullLayout._topclips
	        .selectAll('#' + annClipID)
	        .data(isSizeConstrained ? [0] : []);
	
	    annTextClip.enter().append('clipPath')
	        .classed('annclip', true)
	        .attr('id', annClipID)
	      .append('rect');
	    annTextClip.exit().remove();
	
	    var font = options.font;
	
	    var text = fullLayout._meta ?
	        Lib.templateString(options.text, fullLayout._meta) :
	        options.text;
	
	    var annText = annTextGroupInner.append('text')
	        .classed('annotation-text', true)
	        .text(text);
	
	    function textLayout(s) {
	        s.call(Drawing.font, font)
	        .attr({
	            'text-anchor': {
	                left: 'start',
	                right: 'end'
	            }[options.align] || 'middle'
	        });
	
	        svgTextUtils.convertToTspans(s, gd, drawGraphicalElements);
	        return s;
	    }
	
	    function drawGraphicalElements() {
	        // if the text has *only* a link, make the whole box into a link
	        var anchor3 = annText.selectAll('a');
	        if(anchor3.size() === 1 && anchor3.text() === annText.text()) {
	            var wholeLink = annTextGroupInner.insert('a', ':first-child').attr({
	                'xlink:xlink:href': anchor3.attr('xlink:href'),
	                'xlink:xlink:show': anchor3.attr('xlink:show')
	            })
	            .style({cursor: 'pointer'});
	
	            wholeLink.node().appendChild(annTextBG.node());
	        }
	
	        var mathjaxGroup = annTextGroupInner.select('.annotation-text-math-group');
	        var hasMathjax = !mathjaxGroup.empty();
	        var anntextBB = Drawing.bBox(
	                (hasMathjax ? mathjaxGroup : annText).node());
	        var textWidth = anntextBB.width;
	        var textHeight = anntextBB.height;
	        var annWidth = options.width || textWidth;
	        var annHeight = options.height || textHeight;
	        var outerWidth = Math.round(annWidth + 2 * borderfull);
	        var outerHeight = Math.round(annHeight + 2 * borderfull);
	
	        function shiftFraction(v, anchor) {
	            if(anchor === 'auto') {
	                if(v < 1 / 3) anchor = 'left';
	                else if(v > 2 / 3) anchor = 'right';
	                else anchor = 'center';
	            }
	            return {
	                center: 0,
	                middle: 0,
	                left: 0.5,
	                bottom: -0.5,
	                right: -0.5,
	                top: 0.5
	            }[anchor];
	        }
	
	        var annotationIsOffscreen = false;
	        var letters = ['x', 'y'];
	
	        for(var i = 0; i < letters.length; i++) {
	            var axLetter = letters[i];
	            var axRef = options[axLetter + 'ref'] || axLetter;
	            var tailRef = options['a' + axLetter + 'ref'];
	            var ax = {x: xa, y: ya}[axLetter];
	            var dimAngle = (textangle + (axLetter === 'x' ? 0 : -90)) * Math.PI / 180;
	            // note that these two can be either positive or negative
	            var annSizeFromWidth = outerWidth * Math.cos(dimAngle);
	            var annSizeFromHeight = outerHeight * Math.sin(dimAngle);
	            // but this one is the positive total size
	            var annSize = Math.abs(annSizeFromWidth) + Math.abs(annSizeFromHeight);
	            var anchor = options[axLetter + 'anchor'];
	            var overallShift = options[axLetter + 'shift'] * (axLetter === 'x' ? 1 : -1);
	            var posPx = annPosPx[axLetter];
	            var basePx;
	            var textPadShift;
	            var alignPosition;
	            var autoAlignFraction;
	            var textShift;
	
	            /*
	             * calculate the *primary* pixel position
	             * which is the arrowhead if there is one,
	             * otherwise the text anchor point
	             */
	            if(ax) {
	                // check if annotation is off screen, to bypass DOM manipulations
	                var posFraction = ax.r2fraction(options[axLetter]);
	                if(posFraction < 0 || posFraction > 1) {
	                    if(tailRef === axRef) {
	                        posFraction = ax.r2fraction(options['a' + axLetter]);
	                        if(posFraction < 0 || posFraction > 1) {
	                            annotationIsOffscreen = true;
	                        }
	                    } else {
	                        annotationIsOffscreen = true;
	                    }
	                }
	                basePx = ax._offset + ax.r2p(options[axLetter]);
	                autoAlignFraction = 0.5;
	            } else {
	                if(axLetter === 'x') {
	                    alignPosition = options[axLetter];
	                    basePx = gs.l + gs.w * alignPosition;
	                } else {
	                    alignPosition = 1 - options[axLetter];
	                    basePx = gs.t + gs.h * alignPosition;
	                }
	                autoAlignFraction = options.showarrow ? 0.5 : alignPosition;
	            }
	
	            // now translate this into pixel positions of head, tail, and text
	            // as well as paddings for autorange
	            if(options.showarrow) {
	                posPx.head = basePx;
	
	                var arrowLength = options['a' + axLetter];
	
	                // with an arrow, the text rotates around the anchor point
	                textShift = annSizeFromWidth * shiftFraction(0.5, options.xanchor) -
	                    annSizeFromHeight * shiftFraction(0.5, options.yanchor);
	
	                if(tailRef === axRef) {
	                    posPx.tail = ax._offset + ax.r2p(arrowLength);
	                    // tail is data-referenced: autorange pads the text in px from the tail
	                    textPadShift = textShift;
	                } else {
	                    posPx.tail = basePx + arrowLength;
	                    // tail is specified in px from head, so autorange also pads vs head
	                    textPadShift = textShift + arrowLength;
	                }
	
	                posPx.text = posPx.tail + textShift;
	
	                // constrain pixel/paper referenced so the draggers are at least
	                // partially visible
	                var maxPx = fullLayout[(axLetter === 'x') ? 'width' : 'height'];
	                if(axRef === 'paper') {
	                    posPx.head = Lib.constrain(posPx.head, 1, maxPx - 1);
	                }
	                if(tailRef === 'pixel') {
	                    var shiftPlus = -Math.max(posPx.tail - 3, posPx.text);
	                    var shiftMinus = Math.min(posPx.tail + 3, posPx.text) - maxPx;
	                    if(shiftPlus > 0) {
	                        posPx.tail += shiftPlus;
	                        posPx.text += shiftPlus;
	                    } else if(shiftMinus > 0) {
	                        posPx.tail -= shiftMinus;
	                        posPx.text -= shiftMinus;
	                    }
	                }
	
	                posPx.tail += overallShift;
	                posPx.head += overallShift;
	            } else {
	                // with no arrow, the text rotates and *then* we put the anchor
	                // relative to the new bounding box
	                textShift = annSize * shiftFraction(autoAlignFraction, anchor);
	                textPadShift = textShift;
	                posPx.text = basePx + textShift;
	            }
	
	            posPx.text += overallShift;
	            textShift += overallShift;
	            textPadShift += overallShift;
	
	            // padplus/minus are used by autorange
	            options['_' + axLetter + 'padplus'] = (annSize / 2) + textPadShift;
	            options['_' + axLetter + 'padminus'] = (annSize / 2) - textPadShift;
	
	            // size/shift are used during dragging
	            options['_' + axLetter + 'size'] = annSize;
	            options['_' + axLetter + 'shift'] = textShift;
	        }
	
	        if(annotationIsOffscreen) {
	            annTextGroupInner.remove();
	            return;
	        }
	
	        var xShift = 0;
	        var yShift = 0;
	
	        if(options.align !== 'left') {
	            xShift = (annWidth - textWidth) * (options.align === 'center' ? 0.5 : 1);
	        }
	        if(options.valign !== 'top') {
	            yShift = (annHeight - textHeight) * (options.valign === 'middle' ? 0.5 : 1);
	        }
	
	        if(hasMathjax) {
	            mathjaxGroup.select('svg').attr({
	                x: borderfull + xShift - 1,
	                y: borderfull + yShift
	            })
	            .call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
	        } else {
	            var texty = borderfull + yShift - anntextBB.top;
	            var textx = borderfull + xShift - anntextBB.left;
	
	            annText.call(svgTextUtils.positionText, textx, texty)
	                .call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
	        }
	
	        annTextClip.select('rect').call(Drawing.setRect, borderfull, borderfull,
	            annWidth, annHeight);
	
	        annTextBG.call(Drawing.setRect, borderwidth / 2, borderwidth / 2,
	            outerWidth - borderwidth, outerHeight - borderwidth);
	
	        annTextGroupInner.call(Drawing.setTranslate,
	            Math.round(annPosPx.x.text - outerWidth / 2),
	            Math.round(annPosPx.y.text - outerHeight / 2));
	
	        /*
	         * rotate text and background
	         * we already calculated the text center position *as rotated*
	         * because we needed that for autoranging anyway, so now whether
	         * we have an arrow or not, we rotate about the text center.
	         */
	        annTextGroup.attr({transform: 'rotate(' + textangle + ',' +
	                            annPosPx.x.text + ',' + annPosPx.y.text + ')'});
	
	        /*
	         * add the arrow
	         * uses options[arrowwidth,arrowcolor,arrowhead] for styling
	         * dx and dy are normally zero, but when you are dragging the textbox
	         * while the head stays put, dx and dy are the pixel offsets
	         */
	        var drawArrow = function(dx, dy) {
	            annGroup
	                .selectAll('.annotation-arrow-g')
	                .remove();
	
	            var headX = annPosPx.x.head;
	            var headY = annPosPx.y.head;
	            var tailX = annPosPx.x.tail + dx;
	            var tailY = annPosPx.y.tail + dy;
	            var textX = annPosPx.x.text + dx;
	            var textY = annPosPx.y.text + dy;
	
	            // find the edge of the text box, where we'll start the arrow:
	            // create transform matrix to rotate the text box corners
	            var transform = Lib.rotationXYMatrix(textangle, textX, textY);
	            var applyTransform = Lib.apply2DTransform(transform);
	            var applyTransform2 = Lib.apply2DTransform2(transform);
	
	            // calculate and transform bounding box
	            var width = +annTextBG.attr('width');
	            var height = +annTextBG.attr('height');
	            var xLeft = textX - 0.5 * width;
	            var xRight = xLeft + width;
	            var yTop = textY - 0.5 * height;
	            var yBottom = yTop + height;
	            var edges = [
	                [xLeft, yTop, xLeft, yBottom],
	                [xLeft, yBottom, xRight, yBottom],
	                [xRight, yBottom, xRight, yTop],
	                [xRight, yTop, xLeft, yTop]
	            ].map(applyTransform2);
	
	            // Remove the line if it ends inside the box.  Use ray
	            // casting for rotated boxes: see which edges intersect a
	            // line from the arrowhead to far away and reduce with xor
	            // to get the parity of the number of intersections.
	            if(edges.reduce(function(a, x) {
	                return a ^
	                    !!Lib.segmentsIntersect(headX, headY, headX + 1e6, headY + 1e6,
	                            x[0], x[1], x[2], x[3]);
	            }, false)) {
	                // no line or arrow - so quit drawArrow now
	                return;
	            }
	
	            edges.forEach(function(x) {
	                var p = Lib.segmentsIntersect(tailX, tailY, headX, headY,
	                            x[0], x[1], x[2], x[3]);
	                if(p) {
	                    tailX = p.x;
	                    tailY = p.y;
	                }
	            });
	
	            var strokewidth = options.arrowwidth;
	            var arrowColor = options.arrowcolor;
	            var arrowSide = options.arrowside;
	
	            var arrowGroup = annGroup.append('g')
	                .style({opacity: Color.opacity(arrowColor)})
	                .classed('annotation-arrow-g', true);
	
	            var arrow = arrowGroup.append('path')
	                .attr('d', 'M' + tailX + ',' + tailY + 'L' + headX + ',' + headY)
	                .style('stroke-width', strokewidth + 'px')
	                .call(Color.stroke, Color.rgb(arrowColor));
	
	            drawArrowHead(arrow, arrowSide, options);
	
	            // the arrow dragger is a small square right at the head, then a line to the tail,
	            // all expanded by a stroke width of 6px plus the arrow line width
	            if(edits.annotationPosition && arrow.node().parentNode && !subplotId) {
	                var arrowDragHeadX = headX;
	                var arrowDragHeadY = headY;
	                if(options.standoff) {
	                    var arrowLength = Math.sqrt(Math.pow(headX - tailX, 2) + Math.pow(headY - tailY, 2));
	                    arrowDragHeadX += options.standoff * (tailX - headX) / arrowLength;
	                    arrowDragHeadY += options.standoff * (tailY - headY) / arrowLength;
	                }
	                var arrowDrag = arrowGroup.append('path')
	                    .classed('annotation-arrow', true)
	                    .classed('anndrag', true)
	                    .classed('cursor-move', true)
	                    .attr({
	                        d: 'M3,3H-3V-3H3ZM0,0L' + (tailX - arrowDragHeadX) + ',' + (tailY - arrowDragHeadY),
	                        transform: 'translate(' + arrowDragHeadX + ',' + arrowDragHeadY + ')'
	                    })
	                    .style('stroke-width', (strokewidth + 6) + 'px')
	                    .call(Color.stroke, 'rgba(0,0,0,0)')
	                    .call(Color.fill, 'rgba(0,0,0,0)');
	
	                var annx0, anny0;
	
	                // dragger for the arrow & head: translates the whole thing
	                // (head/tail/text) all together
	                dragElement.init({
	                    element: arrowDrag.node(),
	                    gd: gd,
	                    prepFn: function() {
	                        var pos = Drawing.getTranslate(annTextGroupInner);
	
	                        annx0 = pos.x;
	                        anny0 = pos.y;
	                        if(xa && xa.autorange) {
	                            modifyBase(xa._name + '.autorange', true);
	                        }
	                        if(ya && ya.autorange) {
	                            modifyBase(ya._name + '.autorange', true);
	                        }
	                    },
	                    moveFn: function(dx, dy) {
	                        var annxy0 = applyTransform(annx0, anny0);
	                        var xcenter = annxy0[0] + dx;
	                        var ycenter = annxy0[1] + dy;
	                        annTextGroupInner.call(Drawing.setTranslate, xcenter, ycenter);
	
	                        modifyItem('x', xa ?
	                            xa.p2r(xa.r2p(options.x) + dx) :
	                            (options.x + (dx / gs.w)));
	                        modifyItem('y', ya ?
	                            ya.p2r(ya.r2p(options.y) + dy) :
	                            (options.y - (dy / gs.h)));
	
	                        if(options.axref === options.xref) {
	                            modifyItem('ax', xa.p2r(xa.r2p(options.ax) + dx));
	                        }
	
	                        if(options.ayref === options.yref) {
	                            modifyItem('ay', ya.p2r(ya.r2p(options.ay) + dy));
	                        }
	
	                        arrowGroup.attr('transform', 'translate(' + dx + ',' + dy + ')');
	                        annTextGroup.attr({
	                            transform: 'rotate(' + textangle + ',' +
	                                   xcenter + ',' + ycenter + ')'
	                        });
	                    },
	                    doneFn: function() {
	                        Registry.call('_guiRelayout', gd, getUpdateObj());
	                        var notesBox = document.querySelector('.js-notes-box-panel');
	                        if(notesBox) notesBox.redraw(notesBox.selectedObj);
	                    }
	                });
	            }
	        };
	
	        if(options.showarrow) drawArrow(0, 0);
	
	        // user dragging the annotation (text, not arrow)
	        if(editTextPosition) {
	            var baseTextTransform;
	
	            // dragger for the textbox: if there's an arrow, just drag the
	            // textbox and tail, leave the head untouched
	            dragElement.init({
	                element: annTextGroupInner.node(),
	                gd: gd,
	                prepFn: function() {
	                    baseTextTransform = annTextGroup.attr('transform');
	                },
	                moveFn: function(dx, dy) {
	                    var csr = 'pointer';
	                    if(options.showarrow) {
	                        if(options.axref === options.xref) {
	                            modifyItem('ax', xa.p2r(xa.r2p(options.ax) + dx));
	                        } else {
	                            modifyItem('ax', options.ax + dx);
	                        }
	
	                        if(options.ayref === options.yref) {
	                            modifyItem('ay', ya.p2r(ya.r2p(options.ay) + dy));
	                        } else {
	                            modifyItem('ay', options.ay + dy);
	                        }
	
	                        drawArrow(dx, dy);
	                    } else if(!subplotId) {
	                        var xUpdate, yUpdate;
	                        if(xa) {
	                            xUpdate = xa.p2r(xa.r2p(options.x) + dx);
	                        } else {
	                            var widthFraction = options._xsize / gs.w;
	                            var xLeft = options.x + (options._xshift - options.xshift) / gs.w - widthFraction / 2;
	
	                            xUpdate = dragElement.align(xLeft + dx / gs.w,
	                                widthFraction, 0, 1, options.xanchor);
	                        }
	
	                        if(ya) {
	                            yUpdate = ya.p2r(ya.r2p(options.y) + dy);
	                        } else {
	                            var heightFraction = options._ysize / gs.h;
	                            var yBottom = options.y - (options._yshift + options.yshift) / gs.h - heightFraction / 2;
	
	                            yUpdate = dragElement.align(yBottom - dy / gs.h,
	                                heightFraction, 0, 1, options.yanchor);
	                        }
	                        modifyItem('x', xUpdate);
	                        modifyItem('y', yUpdate);
	                        if(!xa || !ya) {
	                            csr = dragElement.getCursor(
	                                xa ? 0.5 : xUpdate,
	                                ya ? 0.5 : yUpdate,
	                                options.xanchor, options.yanchor
	                            );
	                        }
	                    } else return;
	
	                    annTextGroup.attr({
	                        transform: 'translate(' + dx + ',' + dy + ')' + baseTextTransform
	                    });
	
	                    setCursor(annTextGroupInner, csr);
	                },
	                clickFn: function(_, initialEvent) {
	                    if(options.captureevents) {
	                        gd.emit('plotly_clickannotation', makeEventData(initialEvent));
	                    }
	                },
	                doneFn: function() {
	                    setCursor(annTextGroupInner);
	                    Registry.call('_guiRelayout', gd, getUpdateObj());
	                    var notesBox = document.querySelector('.js-notes-box-panel');
	                    if(notesBox) notesBox.redraw(notesBox.selectedObj);
	                }
	            });
	        }
	    }
	
	    if(edits.annotationText) {
	        annText.call(svgTextUtils.makeEditable, {delegate: annTextGroupInner, gd: gd})
	            .call(textLayout)
	            .on('edit', function(_text) {
	                options.text = _text;
	
	                this.call(textLayout);
	
	                modifyItem('text', _text);
	
	                if(xa && xa.autorange) {
	                    modifyBase(xa._name + '.autorange', true);
	                }
	                if(ya && ya.autorange) {
	                    modifyBase(ya._name + '.autorange', true);
	                }
	
	                Registry.call('_guiRelayout', gd, getUpdateObj());
	            });
	    } else annText.call(textLayout);
	}
	
	},{"../../lib":716,"../../lib/setcursor":736,"../../lib/svg_text_utils":740,"../../plot_api/plot_template":754,"../../plots/cartesian/axes":764,"../../plots/plots":825,"../../registry":845,"../color":591,"../dragelement":609,"../drawing":612,"../fx":629,"./draw_arrow_head":581,"d3":164}],581:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Color = _dereq_('../color');
	
	var ARROWPATHS = _dereq_('./arrow_paths');
	
	/**
	 * Add arrowhead(s) to a path or line element
	 *
	 * @param {d3.selection} el3: a d3-selected line or path element
	 *
	 * @param {string} ends: 'none', 'start', 'end', or 'start+end' for which ends get arrowheads
	 *
	 * @param {object} options: style information. Must have all the following:
	 * @param {number} options.arrowhead: end head style - see ./arrow_paths
	 * @param {number} options.startarrowhead: start head style - see ./arrow_paths
	 * @param {number} options.arrowsize: relative size of the end head vs line width
	 * @param {number} options.startarrowsize: relative size of the start head vs line width
	 * @param {number} options.standoff: distance in px to move the end arrow point from its target
	 * @param {number} options.startstandoff: distance in px to move the start arrow point from its target
	 * @param {number} options.arrowwidth: width of the arrow line
	 * @param {string} options.arrowcolor: color of the arrow line, for the head to match
	 *     Note that the opacity of this color is ignored, as it's assumed the container
	 *     of both the line and head has opacity applied to it so there isn't greater opacity
	 *     where they overlap.
	 */
	module.exports = function drawArrowHead(el3, ends, options) {
	    var el = el3.node();
	    var headStyle = ARROWPATHS[options.arrowhead || 0];
	    var startHeadStyle = ARROWPATHS[options.startarrowhead || 0];
	    var scale = (options.arrowwidth || 1) * (options.arrowsize || 1);
	    var startScale = (options.arrowwidth || 1) * (options.startarrowsize || 1);
	    var doStart = ends.indexOf('start') >= 0;
	    var doEnd = ends.indexOf('end') >= 0;
	    var backOff = headStyle.backoff * scale + options.standoff;
	    var startBackOff = startHeadStyle.backoff * startScale + options.startstandoff;
	
	    var start, end, startRot, endRot;
	
	    if(el.nodeName === 'line') {
	        start = {x: +el3.attr('x1'), y: +el3.attr('y1')};
	        end = {x: +el3.attr('x2'), y: +el3.attr('y2')};
	
	        var dx = start.x - end.x;
	        var dy = start.y - end.y;
	
	        startRot = Math.atan2(dy, dx);
	        endRot = startRot + Math.PI;
	        if(backOff && startBackOff) {
	            if(backOff + startBackOff > Math.sqrt(dx * dx + dy * dy)) {
	                hideLine();
	                return;
	            }
	        }
	
	        if(backOff) {
	            if(backOff * backOff > dx * dx + dy * dy) {
	                hideLine();
	                return;
	            }
	            var backOffX = backOff * Math.cos(startRot);
	            var backOffY = backOff * Math.sin(startRot);
	
	            end.x += backOffX;
	            end.y += backOffY;
	            el3.attr({x2: end.x, y2: end.y});
	        }
	
	        if(startBackOff) {
	            if(startBackOff * startBackOff > dx * dx + dy * dy) {
	                hideLine();
	                return;
	            }
	            var startBackOffX = startBackOff * Math.cos(startRot);
	            var startbackOffY = startBackOff * Math.sin(startRot);
	
	            start.x -= startBackOffX;
	            start.y -= startbackOffY;
	            el3.attr({x1: start.x, y1: start.y});
	        }
	    } else if(el.nodeName === 'path') {
	        var pathlen = el.getTotalLength();
	        // using dash to hide the backOff region of the path.
	        // if we ever allow dash for the arrow we'll have to
	        // do better than this hack... maybe just manually
	        // combine the two
	        var dashArray = '';
	
	        if(pathlen < backOff + startBackOff) {
	            hideLine();
	            return;
	        }
	
	
	        var start0 = el.getPointAtLength(0);
	        var dstart = el.getPointAtLength(0.1);
	
	        startRot = Math.atan2(start0.y - dstart.y, start0.x - dstart.x);
	        start = el.getPointAtLength(Math.min(startBackOff, pathlen));
	
	        dashArray = '0px,' + startBackOff + 'px,';
	
	        var end0 = el.getPointAtLength(pathlen);
	        var dend = el.getPointAtLength(pathlen - 0.1);
	
	        endRot = Math.atan2(end0.y - dend.y, end0.x - dend.x);
	        end = el.getPointAtLength(Math.max(0, pathlen - backOff));
	
	        var shortening = dashArray ? startBackOff + backOff : backOff;
	        dashArray += (pathlen - shortening) + 'px,' + pathlen + 'px';
	
	        el3.style('stroke-dasharray', dashArray);
	    }
	
	    function hideLine() { el3.style('stroke-dasharray', '0px,100px'); }
	
	    function drawhead(arrowHeadStyle, p, rot, arrowScale) {
	        if(!arrowHeadStyle.path) return;
	        if(arrowHeadStyle.noRotate) rot = 0;
	
	        d3.select(el.parentNode).append('path')
	            .attr({
	                'class': el3.attr('class'),
	                d: arrowHeadStyle.path,
	                transform:
	                    'translate(' + p.x + ',' + p.y + ')' +
	                    (rot ? 'rotate(' + (rot * 180 / Math.PI) + ')' : '') +
	                    'scale(' + arrowScale + ')'
	            })
	            .style({
	                fill: Color.rgb(options.arrowcolor),
	                'stroke-width': 0
	            });
	    }
	
	    if(doStart) drawhead(startHeadStyle, start, startRot, startScale);
	    if(doEnd) drawhead(headStyle, end, endRot, scale);
	};
	
	},{"../color":591,"./arrow_paths":573,"d3":164}],582:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var drawModule = _dereq_('./draw');
	var clickModule = _dereq_('./click');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'annotations',
	
	    layoutAttributes: _dereq_('./attributes'),
	    supplyLayoutDefaults: _dereq_('./defaults'),
	    includeBasePlot: _dereq_('../../plots/cartesian/include_components')('annotations'),
	
	    calcAutorange: _dereq_('./calc_autorange'),
	    draw: drawModule.draw,
	    drawOne: drawModule.drawOne,
	    drawRaw: drawModule.drawRaw,
	
	    hasClickToShow: clickModule.hasClickToShow,
	    onClick: clickModule.onClick,
	
	    convertCoords: _dereq_('./convert_coords')
	};
	
	},{"../../plots/cartesian/include_components":774,"./attributes":574,"./calc_autorange":575,"./click":576,"./convert_coords":578,"./defaults":579,"./draw":580}],583:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var annAttrs = _dereq_('../annotations/attributes');
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	module.exports = overrideAll(templatedArray('annotation', {
	    visible: annAttrs.visible,
	    x: {
	        valType: 'any',
	        
	        
	    },
	    y: {
	        valType: 'any',
	        
	        
	    },
	    z: {
	        valType: 'any',
	        
	        
	    },
	    ax: {
	        valType: 'number',
	        
	        
	    },
	    ay: {
	        valType: 'number',
	        
	        
	    },
	
	    xanchor: annAttrs.xanchor,
	    xshift: annAttrs.xshift,
	    yanchor: annAttrs.yanchor,
	    yshift: annAttrs.yshift,
	
	    text: annAttrs.text,
	    textangle: annAttrs.textangle,
	    font: annAttrs.font,
	    width: annAttrs.width,
	    height: annAttrs.height,
	    opacity: annAttrs.opacity,
	    align: annAttrs.align,
	    valign: annAttrs.valign,
	    bgcolor: annAttrs.bgcolor,
	    bordercolor: annAttrs.bordercolor,
	    borderpad: annAttrs.borderpad,
	    borderwidth: annAttrs.borderwidth,
	    showarrow: annAttrs.showarrow,
	    arrowcolor: annAttrs.arrowcolor,
	    arrowhead: annAttrs.arrowhead,
	    startarrowhead: annAttrs.startarrowhead,
	    arrowside: annAttrs.arrowside,
	    arrowsize: annAttrs.arrowsize,
	    startarrowsize: annAttrs.startarrowsize,
	    arrowwidth: annAttrs.arrowwidth,
	    standoff: annAttrs.standoff,
	    startstandoff: annAttrs.startstandoff,
	    hovertext: annAttrs.hovertext,
	    hoverlabel: annAttrs.hoverlabel,
	    captureevents: annAttrs.captureevents,
	
	    // maybes later?
	    // clicktoshow: annAttrs.clicktoshow,
	    // xclick: annAttrs.xclick,
	    // yclick: annAttrs.yclick,
	
	    // not needed!
	    // axref: 'pixel'
	    // ayref: 'pixel'
	    // xref: 'x'
	    // yref: 'y
	    // zref: 'z'
	}), 'calc', 'from-root');
	
	},{"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../annotations/attributes":574}],584:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function convert(scene) {
	    var fullSceneLayout = scene.fullSceneLayout;
	    var anns = fullSceneLayout.annotations;
	
	    for(var i = 0; i < anns.length; i++) {
	        mockAnnAxes(anns[i], scene);
	    }
	
	    scene.fullLayout._infolayer
	        .selectAll('.annotation-' + scene.id)
	        .remove();
	};
	
	function mockAnnAxes(ann, scene) {
	    var fullSceneLayout = scene.fullSceneLayout;
	    var domain = fullSceneLayout.domain;
	    var size = scene.fullLayout._size;
	
	    var base = {
	        // this gets fill in on render
	        pdata: null,
	
	        // to get setConvert to not execute cleanly
	        type: 'linear',
	
	        // don't try to update them on `editable: true`
	        autorange: false,
	
	        // set infinite range so that annotation draw routine
	        // does not try to remove 'outside-range' annotations,
	        // this case is handled in the render loop
	        range: [-Infinity, Infinity]
	    };
	
	    ann._xa = {};
	    Lib.extendFlat(ann._xa, base);
	    Axes.setConvert(ann._xa);
	    ann._xa._offset = size.l + domain.x[0] * size.w;
	    ann._xa.l2p = function() {
	        return 0.5 * (1 + ann._pdata[0] / ann._pdata[3]) * size.w * (domain.x[1] - domain.x[0]);
	    };
	
	    ann._ya = {};
	    Lib.extendFlat(ann._ya, base);
	    Axes.setConvert(ann._ya);
	    ann._ya._offset = size.t + (1 - domain.y[1]) * size.h;
	    ann._ya.l2p = function() {
	        return 0.5 * (1 - ann._pdata[1] / ann._pdata[3]) * size.h * (domain.y[1] - domain.y[0]);
	    };
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764}],585:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	var handleAnnotationCommonDefaults = _dereq_('../annotations/common_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function handleDefaults(sceneLayoutIn, sceneLayoutOut, opts) {
	    handleArrayContainerDefaults(sceneLayoutIn, sceneLayoutOut, {
	        name: 'annotations',
	        handleItemDefaults: handleAnnotationDefaults,
	        fullLayout: opts.fullLayout
	    });
	};
	
	function handleAnnotationDefaults(annIn, annOut, sceneLayout, opts) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(annIn, annOut, attributes, attr, dflt);
	    }
	
	    function coercePosition(axLetter) {
	        var axName = axLetter + 'axis';
	
	        // mock in such way that getFromId grabs correct 3D axis
	        var gdMock = { _fullLayout: {} };
	        gdMock._fullLayout[axName] = sceneLayout[axName];
	
	        return Axes.coercePosition(annOut, gdMock, coerce, axLetter, axLetter, 0.5);
	    }
	
	
	    var visible = coerce('visible');
	    if(!visible) return;
	
	    handleAnnotationCommonDefaults(annIn, annOut, opts.fullLayout, coerce);
	
	    coercePosition('x');
	    coercePosition('y');
	    coercePosition('z');
	
	    // if you have one coordinate you should all three
	    Lib.noneOrAll(annIn, annOut, ['x', 'y', 'z']);
	
	    // hard-set here for completeness
	    annOut.xref = 'x';
	    annOut.yref = 'y';
	    annOut.zref = 'z';
	
	    coerce('xanchor');
	    coerce('yanchor');
	    coerce('xshift');
	    coerce('yshift');
	
	    if(annOut.showarrow) {
	        annOut.axref = 'pixel';
	        annOut.ayref = 'pixel';
	
	        // TODO maybe default values should be bigger than the 2D case?
	        coerce('ax', -10);
	        coerce('ay', -30);
	
	        // if you have one part of arrow length you should have both
	        Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/cartesian/axes":764,"../annotations/common_defaults":577,"./attributes":583}],586:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var drawRaw = _dereq_('../annotations/draw').drawRaw;
	var project = _dereq_('../../plots/gl3d/project');
	var axLetters = ['x', 'y', 'z'];
	
	module.exports = function draw(scene) {
	    var fullSceneLayout = scene.fullSceneLayout;
	    var dataScale = scene.dataScale;
	    var anns = fullSceneLayout.annotations;
	
	    for(var i = 0; i < anns.length; i++) {
	        var ann = anns[i];
	        var annotationIsOffscreen = false;
	
	        for(var j = 0; j < 3; j++) {
	            var axLetter = axLetters[j];
	            var pos = ann[axLetter];
	            var ax = fullSceneLayout[axLetter + 'axis'];
	            var posFraction = ax.r2fraction(pos);
	
	            if(posFraction < 0 || posFraction > 1) {
	                annotationIsOffscreen = true;
	                break;
	            }
	        }
	
	        if(annotationIsOffscreen) {
	            scene.fullLayout._infolayer
	                .select('.annotation-' + scene.id + '[data-index="' + i + '"]')
	                .remove();
	        } else {
	            ann._pdata = project(scene.glplot.cameraParams, [
	                fullSceneLayout.xaxis.r2l(ann.x) * dataScale[0],
	                fullSceneLayout.yaxis.r2l(ann.y) * dataScale[1],
	                fullSceneLayout.zaxis.r2l(ann.z) * dataScale[2]
	            ]);
	
	            drawRaw(scene.graphDiv, ann, i, scene.id, ann._xa, ann._ya);
	        }
	    }
	};
	
	},{"../../plots/gl3d/project":813,"../annotations/draw":580}],587:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'annotations3d',
	
	    schema: {
	        subplots: {
	            scene: {annotations: _dereq_('./attributes')}
	        }
	    },
	
	    layoutAttributes: _dereq_('./attributes'),
	    handleDefaults: _dereq_('./defaults'),
	    includeBasePlot: includeGL3D,
	
	    convert: _dereq_('./convert'),
	    draw: _dereq_('./draw')
	};
	
	function includeGL3D(layoutIn, layoutOut) {
	    var GL3D = Registry.subplotsRegistry.gl3d;
	    if(!GL3D) return;
	
	    var attrRegex = GL3D.attrRegex;
	
	    var keys = Object.keys(layoutIn);
	    for(var i = 0; i < keys.length; i++) {
	        var k = keys[i];
	        if(attrRegex.test(k) && (layoutIn[k].annotations || []).length) {
	            Lib.pushUnique(layoutOut._basePlotModules, GL3D);
	            Lib.pushUnique(layoutOut._subplots.gl3d, k);
	        }
	    }
	}
	
	},{"../../lib":716,"../../registry":845,"./attributes":583,"./convert":584,"./defaults":585,"./draw":586}],588:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// a trimmed down version of:
	// https://github.com/alexcjohnson/world-calendars/blob/master/dist/index.js
	
	module.exports = _dereq_('world-calendars/dist/main');
	
	_dereq_('world-calendars/dist/plus');
	
	_dereq_('world-calendars/dist/calendars/chinese');
	_dereq_('world-calendars/dist/calendars/coptic');
	_dereq_('world-calendars/dist/calendars/discworld');
	_dereq_('world-calendars/dist/calendars/ethiopian');
	_dereq_('world-calendars/dist/calendars/hebrew');
	_dereq_('world-calendars/dist/calendars/islamic');
	_dereq_('world-calendars/dist/calendars/julian');
	_dereq_('world-calendars/dist/calendars/mayan');
	_dereq_('world-calendars/dist/calendars/nanakshahi');
	_dereq_('world-calendars/dist/calendars/nepali');
	_dereq_('world-calendars/dist/calendars/persian');
	_dereq_('world-calendars/dist/calendars/taiwan');
	_dereq_('world-calendars/dist/calendars/thai');
	_dereq_('world-calendars/dist/calendars/ummalqura');
	
	},{"world-calendars/dist/calendars/chinese":555,"world-calendars/dist/calendars/coptic":556,"world-calendars/dist/calendars/discworld":557,"world-calendars/dist/calendars/ethiopian":558,"world-calendars/dist/calendars/hebrew":559,"world-calendars/dist/calendars/islamic":560,"world-calendars/dist/calendars/julian":561,"world-calendars/dist/calendars/mayan":562,"world-calendars/dist/calendars/nanakshahi":563,"world-calendars/dist/calendars/nepali":564,"world-calendars/dist/calendars/persian":565,"world-calendars/dist/calendars/taiwan":566,"world-calendars/dist/calendars/thai":567,"world-calendars/dist/calendars/ummalqura":568,"world-calendars/dist/main":569,"world-calendars/dist/plus":570}],589:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var calendars = _dereq_('./calendars');
	
	var Lib = _dereq_('../../lib');
	var constants = _dereq_('../../constants/numerical');
	
	var EPOCHJD = constants.EPOCHJD;
	var ONEDAY = constants.ONEDAY;
	
	var attributes = {
	    valType: 'enumerated',
	    values: Object.keys(calendars.calendars),
	    
	    editType: 'calc',
	    dflt: 'gregorian'
	};
	
	var handleDefaults = function(contIn, contOut, attr, dflt) {
	    var attrs = {};
	    attrs[attr] = attributes;
	
	    return Lib.coerce(contIn, contOut, attrs, attr, dflt);
	};
	
	var handleTraceDefaults = function(traceIn, traceOut, coords, layout) {
	    for(var i = 0; i < coords.length; i++) {
	        handleDefaults(traceIn, traceOut, coords[i] + 'calendar', layout.calendar);
	    }
	};
	
	// each calendar needs its own default canonical tick. I would love to use
	// 2000-01-01 (or even 0000-01-01) for them all but they don't necessarily
	// all support either of those dates. Instead I'll use the most significant
	// number they *do* support, biased toward the present day.
	var CANONICAL_TICK = {
	    chinese: '2000-01-01',
	    coptic: '2000-01-01',
	    discworld: '2000-01-01',
	    ethiopian: '2000-01-01',
	    hebrew: '5000-01-01',
	    islamic: '1000-01-01',
	    julian: '2000-01-01',
	    mayan: '5000-01-01',
	    nanakshahi: '1000-01-01',
	    nepali: '2000-01-01',
	    persian: '1000-01-01',
	    jalali: '1000-01-01',
	    taiwan: '1000-01-01',
	    thai: '2000-01-01',
	    ummalqura: '1400-01-01'
	};
	
	// Start on a Sunday - for week ticks
	// Discworld and Mayan calendars don't have 7-day weeks but we're going to give them
	// 7-day week ticks so start on our Sundays.
	// If anyone really cares we can customize the auto tick spacings for these calendars.
	var CANONICAL_SUNDAY = {
	    chinese: '2000-01-02',
	    coptic: '2000-01-03',
	    discworld: '2000-01-03',
	    ethiopian: '2000-01-05',
	    hebrew: '5000-01-01',
	    islamic: '1000-01-02',
	    julian: '2000-01-03',
	    mayan: '5000-01-01',
	    nanakshahi: '1000-01-05',
	    nepali: '2000-01-05',
	    persian: '1000-01-01',
	    jalali: '1000-01-01',
	    taiwan: '1000-01-04',
	    thai: '2000-01-04',
	    ummalqura: '1400-01-06'
	};
	
	var DFLTRANGE = {
	    chinese: ['2000-01-01', '2001-01-01'],
	    coptic: ['1700-01-01', '1701-01-01'],
	    discworld: ['1800-01-01', '1801-01-01'],
	    ethiopian: ['2000-01-01', '2001-01-01'],
	    hebrew: ['5700-01-01', '5701-01-01'],
	    islamic: ['1400-01-01', '1401-01-01'],
	    julian: ['2000-01-01', '2001-01-01'],
	    mayan: ['5200-01-01', '5201-01-01'],
	    nanakshahi: ['0500-01-01', '0501-01-01'],
	    nepali: ['2000-01-01', '2001-01-01'],
	    persian: ['1400-01-01', '1401-01-01'],
	    jalali: ['1400-01-01', '1401-01-01'],
	    taiwan: ['0100-01-01', '0101-01-01'],
	    thai: ['2500-01-01', '2501-01-01'],
	    ummalqura: ['1400-01-01', '1401-01-01']
	};
	
	/*
	 * convert d3 templates to world-calendars templates, so our users only need
	 * to know d3's specifiers. Map space padding to no padding, and unknown fields
	 * to an ugly placeholder
	 */
	var UNKNOWN = '##';
	var d3ToWorldCalendars = {
	    'd': {'0': 'dd', '-': 'd'}, // 2-digit or unpadded day of month
	    'e': {'0': 'd', '-': 'd'}, // alternate, always unpadded day of month
	    'a': {'0': 'D', '-': 'D'}, // short weekday name
	    'A': {'0': 'DD', '-': 'DD'}, // full weekday name
	    'j': {'0': 'oo', '-': 'o'}, // 3-digit or unpadded day of the year
	    'W': {'0': 'ww', '-': 'w'}, // 2-digit or unpadded week of the year (Monday first)
	    'm': {'0': 'mm', '-': 'm'}, // 2-digit or unpadded month number
	    'b': {'0': 'M', '-': 'M'}, // short month name
	    'B': {'0': 'MM', '-': 'MM'}, // full month name
	    'y': {'0': 'yy', '-': 'yy'}, // 2-digit year (map unpadded to zero-padded)
	    'Y': {'0': 'yyyy', '-': 'yyyy'}, // 4-digit year (map unpadded to zero-padded)
	    'U': UNKNOWN, // Sunday-first week of the year
	    'w': UNKNOWN, // day of the week [0(sunday),6]
	    // combined format, we replace the date part with the world-calendar version
	    // and the %X stays there for d3 to handle with time parts
	    'c': {'0': 'D M d %X yyyy', '-': 'D M d %X yyyy'},
	    'x': {'0': 'mm/dd/yyyy', '-': 'mm/dd/yyyy'}
	};
	
	function worldCalFmt(fmt, x, calendar) {
	    var dateJD = Math.floor((x + 0.05) / ONEDAY) + EPOCHJD;
	    var cDate = getCal(calendar).fromJD(dateJD);
	    var i = 0;
	    var modifier, directive, directiveLen, directiveObj, replacementPart;
	
	    while((i = fmt.indexOf('%', i)) !== -1) {
	        modifier = fmt.charAt(i + 1);
	        if(modifier === '0' || modifier === '-' || modifier === '_') {
	            directiveLen = 3;
	            directive = fmt.charAt(i + 2);
	            if(modifier === '_') modifier = '-';
	        } else {
	            directive = modifier;
	            modifier = '0';
	            directiveLen = 2;
	        }
	        directiveObj = d3ToWorldCalendars[directive];
	        if(!directiveObj) {
	            i += directiveLen;
	        } else {
	            // code is recognized as a date part but world-calendars doesn't support it
	            if(directiveObj === UNKNOWN) replacementPart = UNKNOWN;
	
	            // format the cDate according to the translated directive
	            else replacementPart = cDate.formatDate(directiveObj[modifier]);
	
	            fmt = fmt.substr(0, i) + replacementPart + fmt.substr(i + directiveLen);
	            i += replacementPart.length;
	        }
	    }
	    return fmt;
	}
	
	// cache world calendars, so we don't have to reinstantiate
	// during each date-time conversion
	var allCals = {};
	function getCal(calendar) {
	    var calendarObj = allCals[calendar];
	    if(calendarObj) return calendarObj;
	
	    calendarObj = allCals[calendar] = calendars.instance(calendar);
	    return calendarObj;
	}
	
	function makeAttrs(description) {
	    return Lib.extendFlat({}, attributes, { description: description });
	}
	
	function makeTraceAttrsDescription(coord) {
	    return 'Sets the calendar system to use with `' + coord + '` date data.';
	}
	
	var xAttrs = {
	    xcalendar: makeAttrs(makeTraceAttrsDescription('x'))
	};
	
	var xyAttrs = Lib.extendFlat({}, xAttrs, {
	    ycalendar: makeAttrs(makeTraceAttrsDescription('y'))
	});
	
	var xyzAttrs = Lib.extendFlat({}, xyAttrs, {
	    zcalendar: makeAttrs(makeTraceAttrsDescription('z'))
	});
	
	var axisAttrs = makeAttrs([
	    'Sets the calendar system to use for `range` and `tick0`',
	    'if this is a date axis. This does not set the calendar for',
	    'interpreting data on this axis, that\'s specified in the trace',
	    'or via the global `layout.calendar`'
	].join(' '));
	
	module.exports = {
	    moduleType: 'component',
	    name: 'calendars',
	
	    schema: {
	        traces: {
	            scatter: xyAttrs,
	            bar: xyAttrs,
	            box: xyAttrs,
	            heatmap: xyAttrs,
	            contour: xyAttrs,
	            histogram: xyAttrs,
	            histogram2d: xyAttrs,
	            histogram2dcontour: xyAttrs,
	            scatter3d: xyzAttrs,
	            surface: xyzAttrs,
	            mesh3d: xyzAttrs,
	            scattergl: xyAttrs,
	            ohlc: xAttrs,
	            candlestick: xAttrs
	        },
	        layout: {
	            calendar: makeAttrs([
	                'Sets the default calendar system to use for interpreting and',
	                'displaying dates throughout the plot.'
	            ].join(' '))
	        },
	        subplots: {
	            xaxis: {calendar: axisAttrs},
	            yaxis: {calendar: axisAttrs},
	            scene: {
	                xaxis: {calendar: axisAttrs},
	                // TODO: it's actually redundant to include yaxis and zaxis here
	                // because in the scene attributes these are the same object so merging
	                // into one merges into them all. However, I left them in for parity with
	                // cartesian, where yaxis is unused until we Plotschema.get() when we
	                // use its presence or absence to determine whether to delete attributes
	                // from yaxis if they only apply to x (rangeselector/rangeslider)
	                yaxis: {calendar: axisAttrs},
	                zaxis: {calendar: axisAttrs}
	            },
	            polar: {
	                radialaxis: {calendar: axisAttrs}
	            }
	        },
	        transforms: {
	            filter: {
	                valuecalendar: makeAttrs([
	                    'Sets the calendar system to use for `value`, if it is a date.'
	                ].join(' ')),
	                targetcalendar: makeAttrs([
	                    'Sets the calendar system to use for `target`, if it is an',
	                    'array of dates. If `target` is a string (eg *x*) we use the',
	                    'corresponding trace attribute (eg `xcalendar`) if it exists,',
	                    'even if `targetcalendar` is provided.'
	                ].join(' '))
	            }
	        }
	    },
	
	    layoutAttributes: attributes,
	
	    handleDefaults: handleDefaults,
	    handleTraceDefaults: handleTraceDefaults,
	
	    CANONICAL_SUNDAY: CANONICAL_SUNDAY,
	    CANONICAL_TICK: CANONICAL_TICK,
	    DFLTRANGE: DFLTRANGE,
	
	    getCal: getCal,
	    worldCalFmt: worldCalFmt
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"./calendars":588}],590:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	// IMPORTANT - default colors should be in hex for compatibility
	exports.defaults = [
	    '#1f77b4',  // muted blue
	    '#ff7f0e',  // safety orange
	    '#2ca02c',  // cooked asparagus green
	    '#d62728',  // brick red
	    '#9467bd',  // muted purple
	    '#8c564b',  // chestnut brown
	    '#e377c2',  // raspberry yogurt pink
	    '#7f7f7f',  // middle gray
	    '#bcbd22',  // curry yellow-green
	    '#17becf'   // blue-teal
	];
	
	exports.defaultLine = '#444';
	
	exports.lightLine = '#eee';
	
	exports.background = '#fff';
	
	exports.borderLine = '#BEC8D9';
	
	// with axis.color and Color.interp we aren't using lightLine
	// itself anymore, instead interpolating between axis.color
	// and the background color using tinycolor.mix. lightFraction
	// gives back exactly lightLine if the other colors are defaults.
	exports.lightFraction = 100 * (0xe - 0x4) / (0xf - 0x4);
	
	},{}],591:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var tinycolor = _dereq_('tinycolor2');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var color = module.exports = {};
	
	var colorAttrs = _dereq_('./attributes');
	color.defaults = colorAttrs.defaults;
	var defaultLine = color.defaultLine = colorAttrs.defaultLine;
	color.lightLine = colorAttrs.lightLine;
	var background = color.background = colorAttrs.background;
	
	/*
	 * tinyRGB: turn a tinycolor into an rgb string, but
	 * unlike the built-in tinycolor.toRgbString this never includes alpha
	 */
	color.tinyRGB = function(tc) {
	    var c = tc.toRgb();
	    return 'rgb(' + Math.round(c.r) + ', ' +
	        Math.round(c.g) + ', ' + Math.round(c.b) + ')';
	};
	
	color.rgb = function(cstr) { return color.tinyRGB(tinycolor(cstr)); };
	
	color.opacity = function(cstr) { return cstr ? tinycolor(cstr).getAlpha() : 0; };
	
	color.addOpacity = function(cstr, op) {
	    var c = tinycolor(cstr).toRgb();
	    return 'rgba(' + Math.round(c.r) + ', ' +
	        Math.round(c.g) + ', ' + Math.round(c.b) + ', ' + op + ')';
	};
	
	// combine two colors into one apparent color
	// if back has transparency or is missing,
	// color.background is assumed behind it
	color.combine = function(front, back) {
	    var fc = tinycolor(front).toRgb();
	    if(fc.a === 1) return tinycolor(front).toRgbString();
	
	    var bc = tinycolor(back || background).toRgb();
	    var bcflat = bc.a === 1 ? bc : {
	        r: 255 * (1 - bc.a) + bc.r * bc.a,
	        g: 255 * (1 - bc.a) + bc.g * bc.a,
	        b: 255 * (1 - bc.a) + bc.b * bc.a
	    };
	    var fcflat = {
	        r: bcflat.r * (1 - fc.a) + fc.r * fc.a,
	        g: bcflat.g * (1 - fc.a) + fc.g * fc.a,
	        b: bcflat.b * (1 - fc.a) + fc.b * fc.a
	    };
	    return tinycolor(fcflat).toRgbString();
	};
	
	/*
	 * Create a color that contrasts with cstr.
	 *
	 * If cstr is a dark color, we lighten it; if it's light, we darken.
	 *
	 * If lightAmount / darkAmount are used, we adjust by these percentages,
	 * otherwise we go all the way to white or black.
	 */
	color.contrast = function(cstr, lightAmount, darkAmount) {
	    var tc = tinycolor(cstr);
	
	    if(tc.getAlpha() !== 1) tc = tinycolor(color.combine(cstr, background));
	
	    var newColor = tc.isDark() ?
	        (lightAmount ? tc.lighten(lightAmount) : background) :
	        (darkAmount ? tc.darken(darkAmount) : defaultLine);
	
	    return newColor.toString();
	};
	
	color.stroke = function(s, c) {
	    var tc = tinycolor(c);
	    s.style({'stroke': color.tinyRGB(tc), 'stroke-opacity': tc.getAlpha()});
	};
	
	color.fill = function(s, c) {
	    var tc = tinycolor(c);
	    s.style({
	        'fill': color.tinyRGB(tc),
	        'fill-opacity': tc.getAlpha()
	    });
	};
	
	// search container for colors with the deprecated rgb(fractions) format
	// and convert them to rgb(0-255 values)
	color.clean = function(container) {
	    if(!container || typeof container !== 'object') return;
	
	    var keys = Object.keys(container);
	    var i, j, key, val;
	
	    for(i = 0; i < keys.length; i++) {
	        key = keys[i];
	        val = container[key];
	
	        if(key.substr(key.length - 5) === 'color') {
	            // only sanitize keys that end in "color" or "colorscale"
	
	            if(Array.isArray(val)) {
	                for(j = 0; j < val.length; j++) val[j] = cleanOne(val[j]);
	            } else container[key] = cleanOne(val);
	        } else if(key.substr(key.length - 10) === 'colorscale' && Array.isArray(val)) {
	            // colorscales have the format [[0, color1], [frac, color2], ... [1, colorN]]
	
	            for(j = 0; j < val.length; j++) {
	                if(Array.isArray(val[j])) val[j][1] = cleanOne(val[j][1]);
	            }
	        } else if(Array.isArray(val)) {
	            // recurse into arrays of objects, and plain objects
	
	            var el0 = val[0];
	            if(!Array.isArray(el0) && el0 && typeof el0 === 'object') {
	                for(j = 0; j < val.length; j++) color.clean(val[j]);
	            }
	        } else if(val && typeof val === 'object') color.clean(val);
	    }
	};
	
	function cleanOne(val) {
	    if(isNumeric(val) || typeof val !== 'string') return val;
	
	    var valTrim = val.trim();
	    if(valTrim.substr(0, 3) !== 'rgb') return val;
	
	    var match = valTrim.match(/^rgba?\s*\(([^()]*)\)$/);
	    if(!match) return val;
	
	    var parts = match[1].trim().split(/\s*[\s,]\s*/);
	    var rgba = valTrim.charAt(3) === 'a' && parts.length === 4;
	    if(!rgba && parts.length !== 3) return val;
	
	    for(var i = 0; i < parts.length; i++) {
	        if(!parts[i].length) return val;
	        parts[i] = Number(parts[i]);
	
	        if(!(parts[i] >= 0)) {
	            // all parts must be non-negative numbers
	
	            return val;
	        }
	
	        if(i === 3) {
	            // alpha>1 gets clipped to 1
	
	            if(parts[i] > 1) parts[i] = 1;
	        } else if(parts[i] >= 1) {
	            // r, g, b must be < 1 (ie 1 itself is not allowed)
	
	            return val;
	        }
	    }
	
	    var rgbStr = Math.round(parts[0] * 255) + ', ' +
	        Math.round(parts[1] * 255) + ', ' +
	        Math.round(parts[2] * 255);
	
	    if(rgba) return 'rgba(' + rgbStr + ', ' + parts[3] + ')';
	    return 'rgb(' + rgbStr + ')';
	}
	
	},{"./attributes":590,"fast-isnumeric":227,"tinycolor2":535}],592:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	
	module.exports = overrideAll({
	// TODO: only right is supported currently
	//     orient: {
	//         valType: 'enumerated',
	//         
	//         values: ['left', 'right', 'top', 'bottom'],
	//         dflt: 'right',
	//         
	//     },
	    thicknessmode: {
	        valType: 'enumerated',
	        values: ['fraction', 'pixels'],
	        
	        dflt: 'pixels',
	        
	    },
	    thickness: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 30,
	        
	    },
	    lenmode: {
	        valType: 'enumerated',
	        values: ['fraction', 'pixels'],
	        
	        dflt: 'fraction',
	        
	    },
	    len: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        
	    },
	    x: {
	        valType: 'number',
	        dflt: 1.02,
	        min: -2,
	        max: 3,
	        
	        
	    },
	    xanchor: {
	        valType: 'enumerated',
	        values: ['left', 'center', 'right'],
	        dflt: 'left',
	        
	        
	    },
	    xpad: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 10,
	        
	    },
	    y: {
	        valType: 'number',
	        
	        dflt: 0.5,
	        min: -2,
	        max: 3,
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['top', 'middle', 'bottom'],
	        
	        dflt: 'middle',
	        
	    },
	    ypad: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 10,
	        
	    },
	    // a possible line around the bar itself
	    outlinecolor: axesAttrs.linecolor,
	    outlinewidth: axesAttrs.linewidth,
	    // Should outlinewidth have {dflt: 0} ?
	    // another possible line outside the padding and tick labels
	    bordercolor: axesAttrs.linecolor,
	    borderwidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 0,
	        
	    },
	    bgcolor: {
	        valType: 'color',
	        
	        dflt: 'rgba(0,0,0,0)',
	        
	    },
	    // tick and title properties named and function exactly as in axes
	    tickmode: axesAttrs.tickmode,
	    nticks: axesAttrs.nticks,
	    tick0: axesAttrs.tick0,
	    dtick: axesAttrs.dtick,
	    tickvals: axesAttrs.tickvals,
	    ticktext: axesAttrs.ticktext,
	    ticks: extendFlat({}, axesAttrs.ticks, {dflt: ''}),
	    ticklen: axesAttrs.ticklen,
	    tickwidth: axesAttrs.tickwidth,
	    tickcolor: axesAttrs.tickcolor,
	    showticklabels: axesAttrs.showticklabels,
	    tickfont: fontAttrs({
	        
	    }),
	    tickangle: axesAttrs.tickangle,
	    tickformat: axesAttrs.tickformat,
	    tickformatstops: axesAttrs.tickformatstops,
	    tickprefix: axesAttrs.tickprefix,
	    showtickprefix: axesAttrs.showtickprefix,
	    ticksuffix: axesAttrs.ticksuffix,
	    showticksuffix: axesAttrs.showticksuffix,
	    separatethousands: axesAttrs.separatethousands,
	    exponentformat: axesAttrs.exponentformat,
	    showexponent: axesAttrs.showexponent,
	    title: {
	        text: {
	            valType: 'string',
	            
	            
	        },
	        font: fontAttrs({
	            
	        }),
	        side: {
	            valType: 'enumerated',
	            values: ['right', 'top', 'bottom'],
	            
	            dflt: 'top',
	            
	        }
	    },
	
	    _deprecated: {
	        title: {
	            valType: 'string',
	            
	            
	        },
	        titlefont: fontAttrs({
	            
	        }),
	        titleside: {
	            valType: 'enumerated',
	            values: ['right', 'top', 'bottom'],
	            
	            dflt: 'top',
	            
	        }
	    }
	}, 'colorbars', 'from-root');
	
	},{"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/cartesian/layout_attributes":776,"../../plots/font_attributes":790}],593:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    cn: {
	        colorbar: 'colorbar',
	        cbbg: 'cbbg',
	        cbfill: 'cbfill',
	        cbfills: 'cbfills',
	        cbline: 'cbline',
	        cblines: 'cblines',
	        cbaxis: 'cbaxis',
	        cbtitleunshift: 'cbtitleunshift',
	        cbtitle: 'cbtitle',
	        cboutline: 'cboutline',
	        crisp: 'crisp',
	        jsPlaceholder: 'js-placeholder'
	    }
	};
	
	},{}],594:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Template = _dereq_('../../plot_api/plot_template');
	
	var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
	var handleTickMarkDefaults = _dereq_('../../plots/cartesian/tick_mark_defaults');
	var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
	
	var attributes = _dereq_('./attributes');
	
	module.exports = function colorbarDefaults(containerIn, containerOut, layout) {
	    var colorbarOut = Template.newContainer(containerOut, 'colorbar');
	    var colorbarIn = containerIn.colorbar || {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(colorbarIn, colorbarOut, attributes, attr, dflt);
	    }
	
	    var thicknessmode = coerce('thicknessmode');
	    coerce('thickness', (thicknessmode === 'fraction') ?
	        30 / (layout.width - layout.margin.l - layout.margin.r) :
	        30
	    );
	
	    var lenmode = coerce('lenmode');
	    coerce('len', (lenmode === 'fraction') ?
	        1 :
	        layout.height - layout.margin.t - layout.margin.b
	    );
	
	    coerce('x');
	    coerce('xanchor');
	    coerce('xpad');
	    coerce('y');
	    coerce('yanchor');
	    coerce('ypad');
	    Lib.noneOrAll(colorbarIn, colorbarOut, ['x', 'y']);
	
	    coerce('outlinecolor');
	    coerce('outlinewidth');
	    coerce('bordercolor');
	    coerce('borderwidth');
	    coerce('bgcolor');
	
	    handleTickValueDefaults(colorbarIn, colorbarOut, coerce, 'linear');
	
	    var opts = {outerTicks: false, font: layout.font};
	    handleTickLabelDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
	    handleTickMarkDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
	
	    coerce('title.text', layout._dfltTitle.colorbar);
	    Lib.coerceFont(coerce, 'title.font', layout.font);
	    coerce('title.side');
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../plots/cartesian/tick_label_defaults":783,"../../plots/cartesian/tick_mark_defaults":784,"../../plots/cartesian/tick_value_defaults":785,"./attributes":592}],595:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	
	var Plots = _dereq_('../../plots/plots');
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var dragElement = _dereq_('../dragelement');
	var Lib = _dereq_('../../lib');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var setCursor = _dereq_('../../lib/setcursor');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var Titles = _dereq_('../titles');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var flipScale = _dereq_('../colorscale/helpers').flipScale;
	
	var handleAxisDefaults = _dereq_('../../plots/cartesian/axis_defaults');
	var handleAxisPositionDefaults = _dereq_('../../plots/cartesian/position_defaults');
	var axisLayoutAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	
	var alignmentConstants = _dereq_('../../constants/alignment');
	var LINE_SPACING = alignmentConstants.LINE_SPACING;
	var FROM_TL = alignmentConstants.FROM_TL;
	var FROM_BR = alignmentConstants.FROM_BR;
	
	var cn = _dereq_('./constants').cn;
	
	function draw(gd) {
	    var fullLayout = gd._fullLayout;
	
	    var colorBars = fullLayout._infolayer
	        .selectAll('g.' + cn.colorbar)
	        .data(makeColorBarData(gd), function(opts) { return opts._id; });
	
	    colorBars.enter().append('g')
	        .attr('class', function(opts) { return opts._id; })
	        .classed(cn.colorbar, true);
	
	    colorBars.each(function(opts) {
	        var g = d3.select(this);
	
	        Lib.ensureSingle(g, 'rect', cn.cbbg);
	        Lib.ensureSingle(g, 'g', cn.cbfills);
	        Lib.ensureSingle(g, 'g', cn.cblines);
	        Lib.ensureSingle(g, 'g', cn.cbaxis, function(s) { s.classed(cn.crisp, true); });
	        Lib.ensureSingle(g, 'g', cn.cbtitleunshift, function(s) { s.append('g').classed(cn.cbtitle, true); });
	        Lib.ensureSingle(g, 'rect', cn.cboutline);
	
	        var done = drawColorBar(g, opts, gd);
	        if(done && done.then) (gd._promises || []).push(done);
	
	        if(gd._context.edits.colorbarPosition) {
	            makeEditable(g, opts, gd);
	        }
	    });
	
	    colorBars.exit()
	        .each(function(opts) { Plots.autoMargin(gd, opts._id); })
	        .remove();
	
	    colorBars.order();
	}
	
	function makeColorBarData(gd) {
	    var fullLayout = gd._fullLayout;
	    var calcdata = gd.calcdata;
	    var out = [];
	
	    // single out item
	    var opts;
	    // colorbar attr parent container
	    var cont;
	    // trace attr container
	    var trace;
	    // colorbar options
	    var cbOpt;
	
	    function initOpts(opts) {
	        return extendFlat(opts, {
	            // fillcolor can be a d3 scale, domain is z values, range is colors
	            // or leave it out for no fill,
	            // or set to a string constant for single-color fill
	            _fillcolor: null,
	            // line.color has the same options as fillcolor
	            _line: {color: null, width: null, dash: null},
	            // levels of lines to draw.
	            // note that this DOES NOT determine the extent of the bar
	            // that's given by the domain of fillcolor
	            // (or line.color if no fillcolor domain)
	            _levels: {start: null, end: null, size: null},
	            // separate fill levels (for example, heatmap coloring of a
	            // contour map) if this is omitted, fillcolors will be
	            // evaluated halfway between levels
	            _filllevels: null,
	            // for continuous colorscales: fill with a gradient instead of explicit levels
	            // value should be the colorscale [[0, c0], [v1, c1], ..., [1, cEnd]]
	            _fillgradient: null,
	            // when using a gradient, we need the data range specified separately
	            _zrange: null
	        });
	    }
	
	    function calcOpts() {
	        if(typeof cbOpt.calc === 'function') {
	            cbOpt.calc(gd, trace, opts);
	        } else {
	            opts._fillgradient = cont.reversescale ?
	                flipScale(cont.colorscale) :
	                cont.colorscale;
	            opts._zrange = [cont[cbOpt.min], cont[cbOpt.max]];
	        }
	    }
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        trace = cd[0].trace;
	        var moduleOpts = trace._module.colorbar;
	
	        if(trace.visible === true && moduleOpts) {
	            var allowsMultiplotCbs = Array.isArray(moduleOpts);
	            var cbOpts = allowsMultiplotCbs ? moduleOpts : [moduleOpts];
	
	            for(var j = 0; j < cbOpts.length; j++) {
	                cbOpt = cbOpts[j];
	                var contName = cbOpt.container;
	                cont = contName ? trace[contName] : trace;
	
	                if(cont && cont.showscale) {
	                    opts = initOpts(cont.colorbar);
	                    opts._id = 'cb' + trace.uid + (allowsMultiplotCbs && contName ? '-' + contName : '');
	                    opts._traceIndex = trace.index;
	                    opts._propPrefix = (contName ? contName + '.' : '') + 'colorbar.';
	                    opts._meta = trace._meta;
	                    calcOpts();
	                    out.push(opts);
	                }
	            }
	        }
	    }
	
	    for(var k in fullLayout._colorAxes) {
	        cont = fullLayout[k];
	
	        if(cont.showscale) {
	            var colorAxOpts = fullLayout._colorAxes[k];
	
	            opts = initOpts(cont.colorbar);
	            opts._id = 'cb' + k;
	            opts._propPrefix = k + '.colorbar.';
	            opts._meta = fullLayout._meta;
	
	            cbOpt = {min: 'cmin', max: 'cmax'};
	            if(colorAxOpts[0] !== 'heatmap') {
	                trace = colorAxOpts[1];
	                cbOpt.calc = trace._module.colorbar.calc;
	            }
	
	            calcOpts();
	            out.push(opts);
	        }
	    }
	
	    return out;
	}
	
	function drawColorBar(g, opts, gd) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	
	    var fillColor = opts._fillcolor;
	    var line = opts._line;
	    var title = opts.title;
	    var titleSide = title.side;
	
	    var zrange = opts._zrange ||
	        d3.extent((typeof fillColor === 'function' ? fillColor : line.color).domain());
	
	    var lineColormap = typeof line.color === 'function' ?
	        line.color :
	        function() { return line.color; };
	    var fillColormap = typeof fillColor === 'function' ?
	        fillColor :
	        function() { return fillColor; };
	
	    var levelsIn = opts._levels;
	    var levelsOut = calcLevels(gd, opts, zrange);
	    var fillLevels = levelsOut.fill;
	    var lineLevels = levelsOut.line;
	
	    // we calculate pixel sizes based on the specified graph size,
	    // not the actual (in case something pushed the margins around)
	    // which is a little odd but avoids an odd iterative effect
	    // when the colorbar itself is pushing the margins.
	    // but then the fractional size is calculated based on the
	    // actual graph size, so that the axes will size correctly.
	    var thickPx = Math.round(opts.thickness * (opts.thicknessmode === 'fraction' ? gs.w : 1));
	    var thickFrac = thickPx / gs.w;
	    var lenPx = Math.round(opts.len * (opts.lenmode === 'fraction' ? gs.h : 1));
	    var lenFrac = lenPx / gs.h;
	    var xpadFrac = opts.xpad / gs.w;
	    var yExtraPx = (opts.borderwidth + opts.outlinewidth) / 2;
	    var ypadFrac = opts.ypad / gs.h;
	
	    // x positioning: do it initially just for left anchor,
	    // then fix at the end (since we don't know the width yet)
	    var xLeft = Math.round(opts.x * gs.w + opts.xpad);
	    // for dragging... this is getting a little muddled...
	    var xLeftFrac = opts.x - thickFrac * ({middle: 0.5, right: 1}[opts.xanchor] || 0);
	
	    // y positioning we can do correctly from the start
	    var yBottomFrac = opts.y + lenFrac * (({top: -0.5, bottom: 0.5}[opts.yanchor] || 0) - 0.5);
	    var yBottomPx = Math.round(gs.h * (1 - yBottomFrac));
	    var yTopPx = yBottomPx - lenPx;
	
	    // stash a few things for makeEditable
	    opts._lenFrac = lenFrac;
	    opts._thickFrac = thickFrac;
	    opts._xLeftFrac = xLeftFrac;
	    opts._yBottomFrac = yBottomFrac;
	
	    // stash mocked axis for contour label formatting
	    var ax = opts._axis = mockColorBarAxis(gd, opts, zrange);
	
	    // position can't go in through supplyDefaults
	    // because that restricts it to [0,1]
	    ax.position = opts.x + xpadFrac + thickFrac;
	
	    if(['top', 'bottom'].indexOf(titleSide) !== -1) {
	        ax.title.side = titleSide;
	        ax.titlex = opts.x + xpadFrac;
	        ax.titley = yBottomFrac + (title.side === 'top' ? lenFrac - ypadFrac : ypadFrac);
	    }
	
	    if(line.color && opts.tickmode === 'auto') {
	        ax.tickmode = 'linear';
	        ax.tick0 = levelsIn.start;
	        var dtick = levelsIn.size;
	        // expand if too many contours, so we don't get too many ticks
	        var autoNtick = Lib.constrain((yBottomPx - yTopPx) / 50, 4, 15) + 1;
	        var dtFactor = (zrange[1] - zrange[0]) / ((opts.nticks || autoNtick) * dtick);
	        if(dtFactor > 1) {
	            var dtexp = Math.pow(10, Math.floor(Math.log(dtFactor) / Math.LN10));
	            dtick *= dtexp * Lib.roundUp(dtFactor / dtexp, [2, 5, 10]);
	            // if the contours are at round multiples, reset tick0
	            // so they're still at round multiples. Otherwise,
	            // keep the first label on the first contour level
	            if((Math.abs(levelsIn.start) / levelsIn.size + 1e-6) % 1 < 2e-6) {
	                ax.tick0 = 0;
	            }
	        }
	        ax.dtick = dtick;
	    }
	
	    // set domain after init, because we may want to
	    // allow it outside [0,1]
	    ax.domain = [
	        yBottomFrac + ypadFrac,
	        yBottomFrac + lenFrac - ypadFrac
	    ];
	
	    ax.setScale();
	
	    g.attr('transform', 'translate(' + Math.round(gs.l) + ',' + Math.round(gs.t) + ')');
	
	    var titleCont = g.select('.' + cn.cbtitleunshift)
	        .attr('transform', 'translate(-' + Math.round(gs.l) + ',-' + Math.round(gs.t) + ')');
	
	    var axLayer = g.select('.' + cn.cbaxis);
	    var titleEl;
	    var titleHeight = 0;
	
	    function drawTitle(titleClass, titleOpts) {
	        var dfltTitleOpts = {
	            propContainer: ax,
	            propName: opts._propPrefix + 'title',
	            traceIndex: opts._traceIndex,
	            _meta: opts._meta,
	            placeholder: fullLayout._dfltTitle.colorbar,
	            containerGroup: g.select('.' + cn.cbtitle)
	        };
	
	        // this class-to-rotate thing with convertToTspans is
	        // getting hackier and hackier... delete groups with the
	        // wrong class (in case earlier the colorbar was drawn on
	        // a different side, I think?)
	        var otherClass = titleClass.charAt(0) === 'h' ?
	            titleClass.substr(1) :
	            'h' + titleClass;
	        g.selectAll('.' + otherClass + ',.' + otherClass + '-math-group').remove();
	
	        Titles.draw(gd, titleClass, extendFlat(dfltTitleOpts, titleOpts || {}));
	    }
	
	    function drawDummyTitle() {
	        if(['top', 'bottom'].indexOf(titleSide) !== -1) {
	            // draw the title so we know how much room it needs
	            // when we squish the axis. This one only applies to
	            // top or bottom titles, not right side.
	            var x = gs.l + (opts.x + xpadFrac) * gs.w;
	            var fontSize = ax.title.font.size;
	            var y;
	
	            if(titleSide === 'top') {
	                y = (1 - (yBottomFrac + lenFrac - ypadFrac)) * gs.h +
	                    gs.t + 3 + fontSize * 0.75;
	            } else {
	                y = (1 - (yBottomFrac + ypadFrac)) * gs.h +
	                    gs.t - 3 - fontSize * 0.25;
	            }
	            drawTitle(ax._id + 'title', {
	                attributes: {x: x, y: y, 'text-anchor': 'start'}
	            });
	        }
	    }
	
	    function drawCbTitle() {
	        if(['top', 'bottom'].indexOf(titleSide) === -1) {
	            var fontSize = ax.title.font.size;
	            var y = ax._offset + ax._length / 2;
	            var x = gs.l + (ax.position || 0) * gs.w + ((ax.side === 'right') ?
	                10 + fontSize * ((ax.showticklabels ? 1 : 0.5)) :
	                -10 - fontSize * ((ax.showticklabels ? 0.5 : 0)));
	
	            // the 'h' + is a hack to get around the fact that
	            // convertToTspans rotates any 'y...' class by 90 degrees.
	            // TODO: find a better way to control this.
	            drawTitle('h' + ax._id + 'title', {
	                avoid: {
	                    selection: d3.select(gd).selectAll('g.' + ax._id + 'tick'),
	                    side: titleSide,
	                    offsetLeft: gs.l,
	                    offsetTop: 0,
	                    maxShift: fullLayout.width
	                },
	                attributes: {x: x, y: y, 'text-anchor': 'middle'},
	                transform: {rotate: '-90', offset: 0}
	            });
	        }
	    }
	
	    function drawAxis() {
	        if(['top', 'bottom'].indexOf(titleSide) !== -1) {
	            // squish the axis top to make room for the title
	            var titleGroup = g.select('.' + cn.cbtitle);
	            var titleText = titleGroup.select('text');
	            var titleTrans = [-opts.outlinewidth / 2, opts.outlinewidth / 2];
	            var mathJaxNode = titleGroup
	                .select('.h' + ax._id + 'title-math-group')
	                .node();
	            var lineSize = 15.6;
	            if(titleText.node()) {
	                lineSize = parseInt(titleText.node().style.fontSize, 10) * LINE_SPACING;
	            }
	            if(mathJaxNode) {
	                titleHeight = Drawing.bBox(mathJaxNode).height;
	                if(titleHeight > lineSize) {
	                    // not entirely sure how mathjax is doing
	                    // vertical alignment, but this seems to work.
	                    titleTrans[1] -= (titleHeight - lineSize) / 2;
	                }
	            } else if(titleText.node() && !titleText.classed(cn.jsPlaceholder)) {
	                titleHeight = Drawing.bBox(titleText.node()).height;
	            }
	            if(titleHeight) {
	                // buffer btwn colorbar and title
	                // TODO: configurable
	                titleHeight += 5;
	
	                if(titleSide === 'top') {
	                    ax.domain[1] -= titleHeight / gs.h;
	                    titleTrans[1] *= -1;
	                } else {
	                    ax.domain[0] += titleHeight / gs.h;
	                    var nlines = svgTextUtils.lineCount(titleText);
	                    titleTrans[1] += (1 - nlines) * lineSize;
	                }
	
	                titleGroup.attr('transform', 'translate(' + titleTrans + ')');
	                ax.setScale();
	            }
	        }
	
	        g.selectAll('.' + cn.cbfills + ',.' + cn.cblines)
	            .attr('transform', 'translate(0,' + Math.round(gs.h * (1 - ax.domain[1])) + ')');
	
	        axLayer.attr('transform', 'translate(0,' + Math.round(-gs.t) + ')');
	
	        var fills = g.select('.' + cn.cbfills)
	            .selectAll('rect.' + cn.cbfill)
	            .data(fillLevels);
	        fills.enter().append('rect')
	            .classed(cn.cbfill, true)
	            .style('stroke', 'none');
	        fills.exit().remove();
	
	        var zBounds = zrange
	            .map(ax.c2p)
	            .map(Math.round)
	            .sort(function(a, b) { return a - b; });
	
	        fills.each(function(d, i) {
	            var z = [
	                (i === 0) ? zrange[0] : (fillLevels[i] + fillLevels[i - 1]) / 2,
	                (i === fillLevels.length - 1) ? zrange[1] : (fillLevels[i] + fillLevels[i + 1]) / 2
	            ]
	            .map(ax.c2p)
	            .map(Math.round);
	
	            // offset the side adjoining the next rectangle so they
	            // overlap, to prevent antialiasing gaps
	            z[1] = Lib.constrain(z[1] + (z[1] > z[0]) ? 1 : -1, zBounds[0], zBounds[1]);
	
	
	            // Colorbar cannot currently support opacities so we
	            // use an opaque fill even when alpha channels present
	            var fillEl = d3.select(this).attr({
	                x: xLeft,
	                width: Math.max(thickPx, 2),
	                y: d3.min(z),
	                height: Math.max(d3.max(z) - d3.min(z), 2),
	            });
	
	            if(opts._fillgradient) {
	                Drawing.gradient(fillEl, gd, opts._id, 'vertical', opts._fillgradient, 'fill');
	            } else {
	                // tinycolor can't handle exponents and
	                // at this scale, removing it makes no difference.
	                var colorString = fillColormap(d).replace('e-', '');
	                fillEl.attr('fill', tinycolor(colorString).toHexString());
	            }
	        });
	
	        var lines = g.select('.' + cn.cblines)
	            .selectAll('path.' + cn.cbline)
	            .data(line.color && line.width ? lineLevels : []);
	        lines.enter().append('path')
	            .classed(cn.cbline, true);
	        lines.exit().remove();
	        lines.each(function(d) {
	            d3.select(this)
	                .attr('d', 'M' + xLeft + ',' +
	                    (Math.round(ax.c2p(d)) + (line.width / 2) % 1) + 'h' + thickPx)
	                .call(Drawing.lineGroupStyle, line.width, lineColormap(d), line.dash);
	        });
	
	        // force full redraw of labels and ticks
	        axLayer.selectAll('g.' + ax._id + 'tick,path').remove();
	
	        var shift = xLeft + thickPx +
	            (opts.outlinewidth || 0) / 2 - (opts.ticks === 'outside' ? 1 : 0);
	
	        var vals = Axes.calcTicks(ax);
	        var transFn = Axes.makeTransFn(ax);
	        var tickSign = Axes.getTickSigns(ax)[2];
	
	        Axes.drawTicks(gd, ax, {
	            vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
	            layer: axLayer,
	            path: Axes.makeTickPath(ax, shift, tickSign),
	            transFn: transFn
	        });
	
	        return Axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: axLayer,
	            transFn: transFn,
	            labelFns: Axes.makeLabelFns(ax, shift)
	        });
	    }
	
	    // wait for the axis & title to finish rendering before
	    // continuing positioning
	    // TODO: why are we redrawing multiple times now with this?
	    // I guess autoMargin doesn't like being post-promise?
	    function positionCB() {
	        var innerWidth = thickPx + opts.outlinewidth / 2 + Drawing.bBox(axLayer.node()).width;
	        titleEl = titleCont.select('text');
	
	        if(titleEl.node() && !titleEl.classed(cn.jsPlaceholder)) {
	            var mathJaxNode = titleCont.select('.h' + ax._id + 'title-math-group').node();
	            var titleWidth;
	            if(mathJaxNode && ['top', 'bottom'].indexOf(titleSide) !== -1) {
	                titleWidth = Drawing.bBox(mathJaxNode).width;
	            } else {
	                // note: the formula below works for all title sides,
	                // (except for top/bottom mathjax, above)
	                // but the weird gs.l is because the titleunshift
	                // transform gets removed by Drawing.bBox
	                titleWidth = Drawing.bBox(titleCont.node()).right - xLeft - gs.l;
	            }
	            innerWidth = Math.max(innerWidth, titleWidth);
	        }
	
	        var outerwidth = 2 * opts.xpad + innerWidth + opts.borderwidth + opts.outlinewidth / 2;
	        var outerheight = yBottomPx - yTopPx;
	
	        g.select('.' + cn.cbbg).attr({
	            x: xLeft - opts.xpad - (opts.borderwidth + opts.outlinewidth) / 2,
	            y: yTopPx - yExtraPx,
	            width: Math.max(outerwidth, 2),
	            height: Math.max(outerheight + 2 * yExtraPx, 2)
	        })
	        .call(Color.fill, opts.bgcolor)
	        .call(Color.stroke, opts.bordercolor)
	        .style('stroke-width', opts.borderwidth);
	
	        g.selectAll('.' + cn.cboutline).attr({
	            x: xLeft,
	            y: yTopPx + opts.ypad + (titleSide === 'top' ? titleHeight : 0),
	            width: Math.max(thickPx, 2),
	            height: Math.max(outerheight - 2 * opts.ypad - titleHeight, 2)
	        })
	        .call(Color.stroke, opts.outlinecolor)
	        .style({
	            fill: 'none',
	            'stroke-width': opts.outlinewidth
	        });
	
	        // fix positioning for xanchor!='left'
	        var xoffset = ({center: 0.5, right: 1}[opts.xanchor] || 0) * outerwidth;
	        g.attr('transform', 'translate(' + (gs.l - xoffset) + ',' + gs.t + ')');
	
	        // auto margin adjustment
	        var marginOpts = {};
	        var tFrac = FROM_TL[opts.yanchor];
	        var bFrac = FROM_BR[opts.yanchor];
	        if(opts.lenmode === 'pixels') {
	            marginOpts.y = opts.y;
	            marginOpts.t = outerheight * tFrac;
	            marginOpts.b = outerheight * bFrac;
	        } else {
	            marginOpts.t = marginOpts.b = 0;
	            marginOpts.yt = opts.y + opts.len * tFrac;
	            marginOpts.yb = opts.y - opts.len * bFrac;
	        }
	
	        var lFrac = FROM_TL[opts.xanchor];
	        var rFrac = FROM_BR[opts.xanchor];
	        if(opts.thicknessmode === 'pixels') {
	            marginOpts.x = opts.x;
	            marginOpts.l = outerwidth * lFrac;
	            marginOpts.r = outerwidth * rFrac;
	        } else {
	            var extraThickness = outerwidth - thickPx;
	            marginOpts.l = extraThickness * lFrac;
	            marginOpts.r = extraThickness * rFrac;
	            marginOpts.xl = opts.x - opts.thickness * lFrac;
	            marginOpts.xr = opts.x + opts.thickness * rFrac;
	        }
	
	        Plots.autoMargin(gd, opts._id, marginOpts);
	    }
	
	    return Lib.syncOrAsync([
	        Plots.previousPromises,
	        drawDummyTitle,
	        drawAxis,
	        drawCbTitle,
	        Plots.previousPromises,
	        positionCB
	    ], gd);
	}
	
	function makeEditable(g, opts, gd) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	    var t0, xf, yf;
	
	    dragElement.init({
	        element: g.node(),
	        gd: gd,
	        prepFn: function() {
	            t0 = g.attr('transform');
	            setCursor(g);
	        },
	        moveFn: function(dx, dy) {
	            g.attr('transform', t0 + ' ' + 'translate(' + dx + ',' + dy + ')');
	
	            xf = dragElement.align(opts._xLeftFrac + (dx / gs.w), opts._thickFrac,
	                0, 1, opts.xanchor);
	            yf = dragElement.align(opts._yBottomFrac - (dy / gs.h), opts._lenFrac,
	                0, 1, opts.yanchor);
	
	            var csr = dragElement.getCursor(xf, yf, opts.xanchor, opts.yanchor);
	            setCursor(g, csr);
	        },
	        doneFn: function() {
	            setCursor(g);
	
	            if(xf !== undefined && yf !== undefined) {
	                var update = {};
	                update[opts._propPrefix + 'x'] = xf;
	                update[opts._propPrefix + 'y'] = yf;
	                if(opts._traceIndex !== undefined) {
	                    Registry.call('_guiRestyle', gd, update, opts._traceIndex);
	                } else {
	                    Registry.call('_guiRelayout', gd, update);
	                }
	            }
	        }
	    });
	}
	
	function calcLevels(gd, opts, zrange) {
	    var levelsIn = opts._levels;
	    var lineLevels = [];
	    var fillLevels = [];
	    var l;
	    var i;
	
	    var l0 = levelsIn.end + levelsIn.size / 100;
	    var ls = levelsIn.size;
	    var zr0 = (1.001 * zrange[0] - 0.001 * zrange[1]);
	    var zr1 = (1.001 * zrange[1] - 0.001 * zrange[0]);
	
	    for(i = 0; i < 1e5; i++) {
	        l = levelsIn.start + i * ls;
	        if(ls > 0 ? (l >= l0) : (l <= l0)) break;
	        if(l > zr0 && l < zr1) lineLevels.push(l);
	    }
	
	    if(opts._fillgradient) {
	        fillLevels = [0];
	    } else if(typeof opts._fillcolor === 'function') {
	        var fillLevelsIn = opts._filllevels;
	
	        if(fillLevelsIn) {
	            l0 = fillLevelsIn.end + fillLevelsIn.size / 100;
	            ls = fillLevelsIn.size;
	            for(i = 0; i < 1e5; i++) {
	                l = fillLevelsIn.start + i * ls;
	                if(ls > 0 ? (l >= l0) : (l <= l0)) break;
	                if(l > zrange[0] && l < zrange[1]) fillLevels.push(l);
	            }
	        } else {
	            fillLevels = lineLevels.map(function(v) {
	                return v - levelsIn.size / 2;
	            });
	            fillLevels.push(fillLevels[fillLevels.length - 1] + levelsIn.size);
	        }
	    } else if(opts._fillcolor && typeof opts._fillcolor === 'string') {
	        // doesn't matter what this value is, with a single value
	        // we'll make a single fill rect covering the whole bar
	        fillLevels = [0];
	    }
	
	    if(levelsIn.size < 0) {
	        lineLevels.reverse();
	        fillLevels.reverse();
	    }
	
	    return {line: lineLevels, fill: fillLevels};
	}
	
	function mockColorBarAxis(gd, opts, zrange) {
	    var fullLayout = gd._fullLayout;
	
	    var cbAxisIn = {
	        type: 'linear',
	        range: zrange,
	        tickmode: opts.tickmode,
	        nticks: opts.nticks,
	        tick0: opts.tick0,
	        dtick: opts.dtick,
	        tickvals: opts.tickvals,
	        ticktext: opts.ticktext,
	        ticks: opts.ticks,
	        ticklen: opts.ticklen,
	        tickwidth: opts.tickwidth,
	        tickcolor: opts.tickcolor,
	        showticklabels: opts.showticklabels,
	        tickfont: opts.tickfont,
	        tickangle: opts.tickangle,
	        tickformat: opts.tickformat,
	        exponentformat: opts.exponentformat,
	        separatethousands: opts.separatethousands,
	        showexponent: opts.showexponent,
	        showtickprefix: opts.showtickprefix,
	        tickprefix: opts.tickprefix,
	        showticksuffix: opts.showticksuffix,
	        ticksuffix: opts.ticksuffix,
	        title: opts.title,
	        showline: true,
	        anchor: 'free',
	        side: 'right',
	        position: 1
	    };
	
	    var cbAxisOut = {
	        type: 'linear',
	        _id: 'y' + opts._id
	    };
	
	    var axisOptions = {
	        letter: 'y',
	        font: fullLayout.font,
	        noHover: true,
	        noTickson: true,
	        calendar: fullLayout.calendar  // not really necessary (yet?)
	    };
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(cbAxisIn, cbAxisOut, axisLayoutAttrs, attr, dflt);
	    }
	
	    handleAxisDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions, fullLayout);
	    handleAxisPositionDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions);
	
	    return cbAxisOut;
	}
	
	module.exports = {
	    draw: draw
	};
	
	},{"../../constants/alignment":685,"../../lib":716,"../../lib/extend":707,"../../lib/setcursor":736,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"../../plots/cartesian/axis_defaults":766,"../../plots/cartesian/layout_attributes":776,"../../plots/cartesian/position_defaults":779,"../../plots/plots":825,"../../registry":845,"../color":591,"../colorscale/helpers":602,"../dragelement":609,"../drawing":612,"../titles":678,"./constants":593,"d3":164,"tinycolor2":535}],596:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	
	module.exports = function hasColorbar(container) {
	    return Lib.isPlainObject(container.colorbar);
	};
	
	},{"../../lib":716}],597:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'component',
	    name: 'colorbar',
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	
	    draw: _dereq_('./draw').draw,
	    hasColorbar: _dereq_('./has_colorbar')
	};
	
	},{"./attributes":592,"./defaults":594,"./draw":595,"./has_colorbar":596}],598:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorbarAttrs = _dereq_('../colorbar/attributes');
	var counterRegex = _dereq_('../../lib/regex').counter;
	
	var palettes = _dereq_('./scales.js').scales;
	var paletteStr = Object.keys(palettes);
	
	function code(s) {
	    return '`' + s + '`';
	}
	
	/**
	 * Make colorscale attribute declarations for
	 *
	 * - colorscale,
	 * - (c|z)auto, (c|z)min, (c|z)max,
	 * - autocolorscale, reversescale,
	 * - showscale (optionally)
	 * - color (optionally)
	 *
	 * @param {string} context (dflt: '', i.e. from trace root):
	 *     the container this is in ('', *marker*, *marker.line* etc)
	 *
	 * @param {object} opts:
	 *   - cLetter {string} (dflt: 'c'):
	 *     leading letter for 'min', 'max and 'auto' attribute (either 'z' or 'c')
	 *
	 *   - colorAttr {string} (dflt: 'z' if `cLetter: 'z'`, 'color' if `cLetter: 'c'`):
	 *     (for descriptions) sets the name of the color attribute that maps to the colorscale.
	 *
	 *     N.B. if `colorAttr: 'color'`, we include the `color` declaration here.
	 *
	 *   - onlyIfNumerical {string} (dflt: false' if `cLetter: 'z'`, true if `cLetter: 'c'`):
	 *     (for descriptions) set to true if colorscale attribute only
	 *
	 *   - colorscaleDflt {string}:
	 *     overrides the colorscale dflt
	 *
	 *   - autoColorDflt {boolean} (dflt true):
	 *     normally autocolorscale.dflt is `true`, but pass `false` to override
	 *
	 *   - noScale {boolean} (dflt: true if `context: 'marker.line'`, false otherwise):
	 *     set to `false` to not include showscale attribute (e.g. for 'marker.line')
	 *
	 *   - showScaleDflt {boolean} (dflt: true if `cLetter: 'z'`, false otherwise)
	 *
	 *   - editTypeOverride {boolean} (dflt: ''):
	 *     most of these attributes already require a recalc, but the ones that do not
	 *     have editType *style* or *plot* unless you override (presumably with *calc*)
	 *
	 *   - anim {boolean) (dflt: undefined): is 'color' animatable?
	 *
	 * @return {object}
	 */
	module.exports = function colorScaleAttrs(context, opts) {
	    context = context || '';
	    opts = opts || {};
	
	    var cLetter = opts.cLetter || 'c';
	    var onlyIfNumerical = ('onlyIfNumerical' in opts) ? opts.onlyIfNumerical : Boolean(context);
	    var noScale = ('noScale' in opts) ? opts.noScale : context === 'marker.line';
	    var showScaleDflt = ('showScaleDflt' in opts) ? opts.showScaleDflt : cLetter === 'z';
	    var colorscaleDflt = typeof opts.colorscaleDflt === 'string' ? palettes[opts.colorscaleDflt] : null;
	    var editTypeOverride = opts.editTypeOverride || '';
	    var contextHead = context ? (context + '.') : '';
	
	    var colorAttr, colorAttrFull;
	
	    if('colorAttr' in opts) {
	        colorAttr = opts.colorAttr;
	        colorAttrFull = opts.colorAttr;
	    } else {
	        colorAttr = {z: 'z', c: 'color'}[cLetter];
	        colorAttrFull = 'in ' + code(contextHead + colorAttr);
	    }
	
	    var effectDesc = onlyIfNumerical ?
	        ' Has an effect only if ' + colorAttrFull + 'is set to a numerical array.' :
	        '';
	
	    var auto = cLetter + 'auto';
	    var min = cLetter + 'min';
	    var max = cLetter + 'max';
	    var mid = cLetter + 'mid';
	    var autoFull = code(contextHead + auto);
	    var minFull = code(contextHead + min);
	    var maxFull = code(contextHead + max);
	    var minmaxFull = minFull + ' and ' + maxFull;
	    var autoImpliedEdits = {};
	    autoImpliedEdits[min] = autoImpliedEdits[max] = undefined;
	    var minmaxImpliedEdits = {};
	    minmaxImpliedEdits[auto] = false;
	
	    var attrs = {};
	
	    if(colorAttr === 'color') {
	        attrs.color = {
	            valType: 'color',
	            arrayOk: true,
	            
	            editType: editTypeOverride || 'style',
	            
	        };
	
	        if(opts.anim) {
	            attrs.color.anim = true;
	        }
	    }
	
	    attrs[auto] = {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc',
	        impliedEdits: autoImpliedEdits,
	        
	    };
	
	    attrs[min] = {
	        valType: 'number',
	        
	        dflt: null,
	        editType: editTypeOverride || 'plot',
	        impliedEdits: minmaxImpliedEdits,
	        
	    };
	
	    attrs[max] = {
	        valType: 'number',
	        
	        dflt: null,
	        editType: editTypeOverride || 'plot',
	        impliedEdits: minmaxImpliedEdits,
	        
	    };
	
	    attrs[mid] = {
	        valType: 'number',
	        
	        dflt: null,
	        editType: 'calc',
	        impliedEdits: autoImpliedEdits,
	        
	    };
	
	    attrs.colorscale = {
	        valType: 'colorscale',
	        
	        editType: 'calc',
	        dflt: colorscaleDflt,
	        impliedEdits: {autocolorscale: false},
	        
	    };
	
	    attrs.autocolorscale = {
	        valType: 'boolean',
	        
	        // gets overrode in 'heatmap' & 'surface' for backwards comp.
	        dflt: opts.autoColorDflt === false ? false : true,
	        editType: 'calc',
	        impliedEdits: {colorscale: undefined},
	        
	    };
	
	    attrs.reversescale = {
	        valType: 'boolean',
	        
	        dflt: false,
	        editType: 'plot',
	        
	    };
	
	    if(!noScale) {
	        attrs.showscale = {
	            valType: 'boolean',
	            
	            dflt: showScaleDflt,
	            editType: 'calc',
	            
	        };
	
	        attrs.colorbar = colorbarAttrs;
	    }
	
	    if(!opts.noColorAxis) {
	        attrs.coloraxis = {
	            valType: 'subplotid',
	            
	            regex: counterRegex('coloraxis'),
	            dflt: null,
	            editType: 'calc',
	            
	        };
	    }
	
	    return attrs;
	};
	
	},{"../../lib/regex":732,"../colorbar/attributes":592,"./scales.js":606}],599:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var extractOpts = _dereq_('./helpers').extractOpts;
	
	module.exports = function calc(gd, trace, opts) {
	    var fullLayout = gd._fullLayout;
	    var vals = opts.vals;
	    var containerStr = opts.containerStr;
	
	    var container = containerStr ?
	        Lib.nestedProperty(trace, containerStr).get() :
	        trace;
	
	    var cOpts = extractOpts(container);
	    var auto = cOpts.auto !== false;
	    var min = cOpts.min;
	    var max = cOpts.max;
	    var mid = cOpts.mid;
	
	    var minVal = function() { return Lib.aggNums(Math.min, null, vals); };
	    var maxVal = function() { return Lib.aggNums(Math.max, null, vals); };
	
	    if(min === undefined) {
	        min = minVal();
	    } else if(auto) {
	        if(container._colorAx && isNumeric(min)) {
	            min = Math.min(min, minVal());
	        } else {
	            min = minVal();
	        }
	    }
	
	    if(max === undefined) {
	        max = maxVal();
	    } else if(auto) {
	        if(container._colorAx && isNumeric(max)) {
	            max = Math.max(max, maxVal());
	        } else {
	            max = maxVal();
	        }
	    }
	
	    if(auto && mid !== undefined) {
	        if(max - mid > mid - min) {
	            min = mid - (max - mid);
	        } else if(max - mid < mid - min) {
	            max = mid + (mid - min);
	        }
	    }
	
	    if(min === max) {
	        min -= 0.5;
	        max += 0.5;
	    }
	
	    cOpts._sync('min', min);
	    cOpts._sync('max', max);
	
	    if(cOpts.autocolorscale) {
	        var scl;
	        if(min * max < 0) scl = fullLayout.colorscale.diverging;
	        else if(min >= 0) scl = fullLayout.colorscale.sequential;
	        else scl = fullLayout.colorscale.sequentialminus;
	        cOpts._sync('colorscale', scl);
	    }
	};
	
	},{"../../lib":716,"./helpers":602,"fast-isnumeric":227}],600:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var hasColorscale = _dereq_('./helpers').hasColorscale;
	var extractOpts = _dereq_('./helpers').extractOpts;
	
	module.exports = function crossTraceDefaults(fullData, fullLayout) {
	    function replace(cont, k) {
	        var val = cont['_' + k];
	        if(val !== undefined) {
	            cont[k] = val;
	        }
	    }
	
	    function relinkColorAttrs(outerCont, cbOpt) {
	        var cont = cbOpt.container ?
	            Lib.nestedProperty(outerCont, cbOpt.container).get() :
	            outerCont;
	
	        if(cont) {
	            if(cont.coloraxis) {
	                // stash ref to color axis
	                cont._colorAx = fullLayout[cont.coloraxis];
	            } else {
	                var cOpts = extractOpts(cont);
	                var isAuto = cOpts.auto;
	
	                if(isAuto || cOpts.min === undefined) {
	                    replace(cont, cbOpt.min);
	                }
	                if(isAuto || cOpts.max === undefined) {
	                    replace(cont, cbOpt.max);
	                }
	                if(cOpts.autocolorscale) {
	                    replace(cont, 'colorscale');
	                }
	            }
	        }
	    }
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	        var cbOpts = trace._module.colorbar;
	
	        if(cbOpts) {
	            if(Array.isArray(cbOpts)) {
	                for(var j = 0; j < cbOpts.length; j++) {
	                    relinkColorAttrs(trace, cbOpts[j]);
	                }
	            } else {
	                relinkColorAttrs(trace, cbOpts);
	            }
	        }
	
	        if(hasColorscale(trace, 'marker.line')) {
	            relinkColorAttrs(trace, {
	                container: 'marker.line',
	                min: 'cmin',
	                max: 'cmax'
	            });
	        }
	    }
	
	    for(var k in fullLayout._colorAxes) {
	        relinkColorAttrs(fullLayout[k], {min: 'cmin', max: 'cmax'});
	    }
	};
	
	},{"../../lib":716,"./helpers":602}],601:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var hasColorbar = _dereq_('../colorbar/has_colorbar');
	var colorbarDefaults = _dereq_('../colorbar/defaults');
	
	var isValidScale = _dereq_('./scales').isValid;
	var traceIs = _dereq_('../../registry').traceIs;
	
	function npMaybe(parentCont, prefix) {
	    var containerStr = prefix.slice(0, prefix.length - 1);
	    return prefix ?
	        Lib.nestedProperty(parentCont, containerStr).get() || {} :
	        parentCont;
	}
	
	/**
	 * Colorscale / colorbar default handler
	 *
	 * @param {object} parentContIn : user (input) parent container (e.g. trace or layout coloraxis object)
	 * @param {object} parentContOut : full parent container
	 * @param {object} layout : (full) layout object
	 * @param {fn} coerce : Lib.coerce wrapper
	 * @param {object} opts :
	 * - prefix {string} : attr string prefix to colorscale container from parent root
	 * - cLetter {string} : 'c or 'z' color letter
	 */
	module.exports = function colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts) {
	    var prefix = opts.prefix;
	    var cLetter = opts.cLetter;
	    var inTrace = '_module' in parentContOut;
	    var containerIn = npMaybe(parentContIn, prefix);
	    var containerOut = npMaybe(parentContOut, prefix);
	    var template = npMaybe(parentContOut._template || {}, prefix) || {};
	
	    // colorScaleDefaults wrapper called if-ever we need to reset the colorscale
	    // attributes for containers that were linked to invalid color axes
	    var thisFn = function() {
	        delete parentContIn.coloraxis;
	        delete parentContOut.coloraxis;
	        return colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts);
	    };
	
	    if(inTrace) {
	        var colorAxes = layout._colorAxes || {};
	        var colorAx = coerce(prefix + 'coloraxis');
	
	        if(colorAx) {
	            var colorbarVisuals = (
	                traceIs(parentContOut, 'contour') &&
	                Lib.nestedProperty(parentContOut, 'contours.coloring').get()
	            ) || 'heatmap';
	
	            var stash = colorAxes[colorAx];
	
	            if(stash) {
	                stash[2].push(thisFn);
	
	                if(stash[0] !== colorbarVisuals) {
	                    stash[0] = false;
	                    Lib.warn([
	                        'Ignoring coloraxis:', colorAx, 'setting',
	                        'as it is linked to incompatible colorscales.'
	                    ].join(' '));
	                }
	            } else {
	                // stash:
	                // - colorbar visual 'type'
	                // - colorbar options to help in Colorbar.draw
	                // - list of colorScaleDefaults wrapper functions
	                colorAxes[colorAx] = [colorbarVisuals, parentContOut, [thisFn]];
	            }
	            return;
	        }
	    }
	
	    var minIn = containerIn[cLetter + 'min'];
	    var maxIn = containerIn[cLetter + 'max'];
	    var validMinMax = isNumeric(minIn) && isNumeric(maxIn) && (minIn < maxIn);
	    var auto = coerce(prefix + cLetter + 'auto', !validMinMax);
	
	    if(auto) {
	        coerce(prefix + cLetter + 'mid');
	    } else {
	        coerce(prefix + cLetter + 'min');
	        coerce(prefix + cLetter + 'max');
	    }
	
	    // handles both the trace case (autocolorscale is false by default) and
	    // the marker and marker.line case (autocolorscale is true by default)
	    var sclIn = containerIn.colorscale;
	    var sclTemplate = template.colorscale;
	    var autoColorscaleDflt;
	    if(sclIn !== undefined) autoColorscaleDflt = !isValidScale(sclIn);
	    if(sclTemplate !== undefined) autoColorscaleDflt = !isValidScale(sclTemplate);
	    coerce(prefix + 'autocolorscale', autoColorscaleDflt);
	
	    coerce(prefix + 'colorscale');
	    coerce(prefix + 'reversescale');
	
	    if(prefix !== 'marker.line.') {
	        // handles both the trace case where the dflt is listed in attributes and
	        // the marker case where the dflt is determined by hasColorbar
	        var showScaleDflt;
	        if(prefix && inTrace) showScaleDflt = hasColorbar(containerIn);
	
	        var showScale = coerce(prefix + 'showscale', showScaleDflt);
	        if(showScale) colorbarDefaults(containerIn, containerOut, layout);
	    }
	};
	
	},{"../../lib":716,"../../registry":845,"../colorbar/defaults":594,"../colorbar/has_colorbar":596,"./scales":606,"fast-isnumeric":227}],602:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../color');
	
	var isValidScale = _dereq_('./scales').isValid;
	
	function hasColorscale(trace, containerStr, colorKey) {
	    var container = containerStr ?
	        Lib.nestedProperty(trace, containerStr).get() || {} :
	        trace;
	    var color = container[colorKey || 'color'];
	
	    var isArrayWithOneNumber = false;
	    if(Lib.isArrayOrTypedArray(color)) {
	        for(var i = 0; i < color.length; i++) {
	            if(isNumeric(color[i])) {
	                isArrayWithOneNumber = true;
	                break;
	            }
	        }
	    }
	
	    return (
	        Lib.isPlainObject(container) && (
	            isArrayWithOneNumber ||
	            container.showscale === true ||
	            (isNumeric(container.cmin) && isNumeric(container.cmax)) ||
	            isValidScale(container.colorscale) ||
	            Lib.isPlainObject(container.colorbar)
	        )
	    );
	}
	
	var constantAttrs = ['showscale', 'autocolorscale', 'colorscale', 'reversescale', 'colorbar'];
	var letterAttrs = ['min', 'max', 'mid', 'auto'];
	
	/**
	 * Extract 'c' / 'z', trace / color axis colorscale options
	 *
	 * Note that it would be nice to replace all z* with c* equivalents in v2
	 *
	 * @param {object} cont : attribute container
	 * @return {object}:
	 *  - min: cmin or zmin
	 *  - max: cmax or zmax
	 *  - mid: cmid or zmid
	 *  - auto: cauto or zauto
	 *  - *scale: *scale attrs
	 *  - colorbar: colorbar
	 *  - _sync: function syncing attr and underscore dual (useful when calc'ing min/max)
	 */
	function extractOpts(cont) {
	    var colorAx = cont._colorAx;
	    var cont2 = colorAx ? colorAx : cont;
	    var out = {};
	    var cLetter;
	    var i, k;
	
	    for(i = 0; i < constantAttrs.length; i++) {
	        k = constantAttrs[i];
	        out[k] = cont2[k];
	    }
	
	    if(colorAx) {
	        cLetter = 'c';
	        for(i = 0; i < letterAttrs.length; i++) {
	            k = letterAttrs[i];
	            out[k] = cont2['c' + k];
	        }
	    } else {
	        var k2;
	        for(i = 0; i < letterAttrs.length; i++) {
	            k = letterAttrs[i];
	            k2 = 'c' + k;
	            if(k2 in cont2) {
	                out[k] = cont2[k2];
	                continue;
	            }
	            k2 = 'z' + k;
	            if(k2 in cont2) {
	                out[k] = cont2[k2];
	            }
	        }
	        cLetter = k2.charAt(0);
	    }
	
	    out._sync = function(k, v) {
	        var k2 = letterAttrs.indexOf(k) !== -1 ? cLetter + k : k;
	        cont2[k2] = cont2['_' + k2] = v;
	    };
	
	    return out;
	}
	
	/**
	 * Extract colorscale into numeric domain and color range.
	 *
	 * @param {object} cont colorscale container (e.g. trace, marker)
	 *  - colorscale {array of arrays}
	 *  - cmin/zmin {number}
	 *  - cmax/zmax {number}
	 *  - reversescale {boolean}
	 *
	 * @return {object}
	 *  - domain {array}
	 *  - range {array}
	 */
	function extractScale(cont) {
	    var cOpts = extractOpts(cont);
	    var cmin = cOpts.min;
	    var cmax = cOpts.max;
	
	    var scl = cOpts.reversescale ?
	        flipScale(cOpts.colorscale) :
	        cOpts.colorscale;
	
	    var N = scl.length;
	    var domain = new Array(N);
	    var range = new Array(N);
	
	    for(var i = 0; i < N; i++) {
	        var si = scl[i];
	        domain[i] = cmin + si[0] * (cmax - cmin);
	        range[i] = si[1];
	    }
	
	    return {domain: domain, range: range};
	}
	
	function flipScale(scl) {
	    var N = scl.length;
	    var sclNew = new Array(N);
	
	    for(var i = N - 1, j = 0; i >= 0; i--, j++) {
	        var si = scl[i];
	        sclNew[j] = [1 - si[0], si[1]];
	    }
	    return sclNew;
	}
	
	/**
	 * General colorscale function generator.
	 *
	 * @param {object} specs output of Colorscale.extractScale or precomputed domain, range.
	 *  - domain {array}
	 *  - range {array}
	 *
	 * @param {object} opts
	 *  - noNumericCheck {boolean} if true, scale func bypasses numeric checks
	 *  - returnArray {boolean} if true, scale func return 4-item array instead of color strings
	 *
	 * @return {function}
	 */
	function makeColorScaleFunc(specs, opts) {
	    opts = opts || {};
	
	    var domain = specs.domain;
	    var range = specs.range;
	    var N = range.length;
	    var _range = new Array(N);
	
	    for(var i = 0; i < N; i++) {
	        var rgba = tinycolor(range[i]).toRgb();
	        _range[i] = [rgba.r, rgba.g, rgba.b, rgba.a];
	    }
	
	    var _sclFunc = d3.scale.linear()
	        .domain(domain)
	        .range(_range)
	        .clamp(true);
	
	    var noNumericCheck = opts.noNumericCheck;
	    var returnArray = opts.returnArray;
	    var sclFunc;
	
	    if(noNumericCheck && returnArray) {
	        sclFunc = _sclFunc;
	    } else if(noNumericCheck) {
	        sclFunc = function(v) {
	            return colorArray2rbga(_sclFunc(v));
	        };
	    } else if(returnArray) {
	        sclFunc = function(v) {
	            if(isNumeric(v)) return _sclFunc(v);
	            else if(tinycolor(v).isValid()) return v;
	            else return Color.defaultLine;
	        };
	    } else {
	        sclFunc = function(v) {
	            if(isNumeric(v)) return colorArray2rbga(_sclFunc(v));
	            else if(tinycolor(v).isValid()) return v;
	            else return Color.defaultLine;
	        };
	    }
	
	    // colorbar draw looks into the d3 scale closure for domain and range
	    sclFunc.domain = _sclFunc.domain;
	    sclFunc.range = function() { return range; };
	
	    return sclFunc;
	}
	
	function makeColorScaleFuncFromTrace(trace, opts) {
	    return makeColorScaleFunc(extractScale(trace), opts);
	}
	
	function colorArray2rbga(colorArray) {
	    var colorObj = {
	        r: colorArray[0],
	        g: colorArray[1],
	        b: colorArray[2],
	        a: colorArray[3]
	    };
	
	    return tinycolor(colorObj).toRgbString();
	}
	
	module.exports = {
	    hasColorscale: hasColorscale,
	    extractOpts: extractOpts,
	    extractScale: extractScale,
	    flipScale: flipScale,
	    makeColorScaleFunc: makeColorScaleFunc,
	    makeColorScaleFuncFromTrace: makeColorScaleFuncFromTrace
	};
	
	},{"../../lib":716,"../color":591,"./scales":606,"d3":164,"fast-isnumeric":227,"tinycolor2":535}],603:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scales = _dereq_('./scales');
	var helpers = _dereq_('./helpers');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'colorscale',
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    handleDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('./cross_trace_defaults'),
	
	    calc: _dereq_('./calc'),
	
	    // ./scales.js is required in lib/coerce.js ;
	    // it needs to be a seperate module to avoid circular a dependency
	    scales: scales.scales,
	    defaultScale: scales.defaultScale,
	    getScale: scales.get,
	    isValidScale: scales.isValid,
	
	    hasColorscale: helpers.hasColorscale,
	    extractOpts: helpers.extractOpts,
	    extractScale: helpers.extractScale,
	    flipScale: helpers.flipScale,
	    makeColorScaleFunc: helpers.makeColorScaleFunc,
	    makeColorScaleFuncFromTrace: helpers.makeColorScaleFuncFromTrace
	};
	
	},{"./attributes":598,"./calc":599,"./cross_trace_defaults":600,"./defaults":601,"./helpers":602,"./layout_attributes":604,"./layout_defaults":605,"./scales":606}],604:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var colorScaleAttrs = _dereq_('./attributes');
	var scales = _dereq_('./scales').scales;
	
	var msg = 'Note that `autocolorscale` must be true for this attribute to work.';
	
	module.exports = {
	    editType: 'calc',
	
	    colorscale: {
	        editType: 'calc',
	
	        sequential: {
	            valType: 'colorscale',
	            dflt: scales.Reds,
	            
	            editType: 'calc',
	            
	        },
	        sequentialminus: {
	            valType: 'colorscale',
	            dflt: scales.Blues,
	            
	            editType: 'calc',
	            
	        },
	        diverging: {
	            valType: 'colorscale',
	            dflt: scales.RdBu,
	            
	            editType: 'calc',
	            
	        }
	    },
	
	    coloraxis: extendFlat({
	        // not really a 'subplot' attribute container,
	        // but this is the flag we use to denote attributes that
	        // support yaxis, yaxis2, yaxis3, ... counters
	        _isSubplotObj: true,
	        editType: 'calc',
	        
	    }, colorScaleAttrs('', {
	        colorAttr: 'corresponding trace color array(s)',
	        noColorAxis: true,
	        showScaleDflt: true
	    }))
	};
	
	},{"../../lib/extend":707,"./attributes":598,"./scales":606}],605:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Template = _dereq_('../../plot_api/plot_template');
	
	var colorScaleAttrs = _dereq_('./layout_attributes');
	var colorScaleDefaults = _dereq_('./defaults');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, colorScaleAttrs, attr, dflt);
	    }
	
	    coerce('colorscale.sequential');
	    coerce('colorscale.sequentialminus');
	    coerce('colorscale.diverging');
	
	    var colorAxes = layoutOut._colorAxes;
	    var colorAxIn, colorAxOut;
	
	    function coerceAx(attr, dflt) {
	        return Lib.coerce(colorAxIn, colorAxOut, colorScaleAttrs.coloraxis, attr, dflt);
	    }
	
	    for(var k in colorAxes) {
	        var stash = colorAxes[k];
	
	        if(stash[0]) {
	            colorAxIn = layoutIn[k] || {};
	            colorAxOut = Template.newContainer(layoutOut, k, 'coloraxis');
	            colorAxOut._name = k;
	            colorScaleDefaults(colorAxIn, colorAxOut, layoutOut, coerceAx, {prefix: '', cLetter: 'c'});
	        } else {
	            // re-coerce colorscale attributes w/o coloraxis
	            for(var i = 0; i < stash[2].length; i++) {
	                stash[2][i]();
	            }
	            delete layoutOut._colorAxes[k];
	        }
	    }
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"./defaults":601,"./layout_attributes":604}],606:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var tinycolor = _dereq_('tinycolor2');
	
	var scales = {
	    'Greys': [
	        [0, 'rgb(0,0,0)'], [1, 'rgb(255,255,255)']
	    ],
	
	    'YlGnBu': [
	        [0, 'rgb(8,29,88)'], [0.125, 'rgb(37,52,148)'],
	        [0.25, 'rgb(34,94,168)'], [0.375, 'rgb(29,145,192)'],
	        [0.5, 'rgb(65,182,196)'], [0.625, 'rgb(127,205,187)'],
	        [0.75, 'rgb(199,233,180)'], [0.875, 'rgb(237,248,217)'],
	        [1, 'rgb(255,255,217)']
	    ],
	
	    'Greens': [
	        [0, 'rgb(0,68,27)'], [0.125, 'rgb(0,109,44)'],
	        [0.25, 'rgb(35,139,69)'], [0.375, 'rgb(65,171,93)'],
	        [0.5, 'rgb(116,196,118)'], [0.625, 'rgb(161,217,155)'],
	        [0.75, 'rgb(199,233,192)'], [0.875, 'rgb(229,245,224)'],
	        [1, 'rgb(247,252,245)']
	    ],
	
	    'YlOrRd': [
	        [0, 'rgb(128,0,38)'], [0.125, 'rgb(189,0,38)'],
	        [0.25, 'rgb(227,26,28)'], [0.375, 'rgb(252,78,42)'],
	        [0.5, 'rgb(253,141,60)'], [0.625, 'rgb(254,178,76)'],
	        [0.75, 'rgb(254,217,118)'], [0.875, 'rgb(255,237,160)'],
	        [1, 'rgb(255,255,204)']
	    ],
	
	    'Bluered': [
	        [0, 'rgb(0,0,255)'], [1, 'rgb(255,0,0)']
	    ],
	
	    // modified RdBu based on
	    // http://www.kennethmoreland.com/color-maps/
	    'RdBu': [
	        [0, 'rgb(5,10,172)'], [0.35, 'rgb(106,137,247)'],
	        [0.5, 'rgb(190,190,190)'], [0.6, 'rgb(220,170,132)'],
	        [0.7, 'rgb(230,145,90)'], [1, 'rgb(178,10,28)']
	    ],
	
	    // Scale for non-negative numeric values
	    'Reds': [
	        [0, 'rgb(220,220,220)'], [0.2, 'rgb(245,195,157)'],
	        [0.4, 'rgb(245,160,105)'], [1, 'rgb(178,10,28)']
	    ],
	
	    // Scale for non-positive numeric values
	    'Blues': [
	        [0, 'rgb(5,10,172)'], [0.35, 'rgb(40,60,190)'],
	        [0.5, 'rgb(70,100,245)'], [0.6, 'rgb(90,120,245)'],
	        [0.7, 'rgb(106,137,247)'], [1, 'rgb(220,220,220)']
	    ],
	
	    'Picnic': [
	        [0, 'rgb(0,0,255)'], [0.1, 'rgb(51,153,255)'],
	        [0.2, 'rgb(102,204,255)'], [0.3, 'rgb(153,204,255)'],
	        [0.4, 'rgb(204,204,255)'], [0.5, 'rgb(255,255,255)'],
	        [0.6, 'rgb(255,204,255)'], [0.7, 'rgb(255,153,255)'],
	        [0.8, 'rgb(255,102,204)'], [0.9, 'rgb(255,102,102)'],
	        [1, 'rgb(255,0,0)']
	    ],
	
	    'Rainbow': [
	        [0, 'rgb(150,0,90)'], [0.125, 'rgb(0,0,200)'],
	        [0.25, 'rgb(0,25,255)'], [0.375, 'rgb(0,152,255)'],
	        [0.5, 'rgb(44,255,150)'], [0.625, 'rgb(151,255,0)'],
	        [0.75, 'rgb(255,234,0)'], [0.875, 'rgb(255,111,0)'],
	        [1, 'rgb(255,0,0)']
	    ],
	
	    'Portland': [
	        [0, 'rgb(12,51,131)'], [0.25, 'rgb(10,136,186)'],
	        [0.5, 'rgb(242,211,56)'], [0.75, 'rgb(242,143,56)'],
	        [1, 'rgb(217,30,30)']
	    ],
	
	    'Jet': [
	        [0, 'rgb(0,0,131)'], [0.125, 'rgb(0,60,170)'],
	        [0.375, 'rgb(5,255,255)'], [0.625, 'rgb(255,255,0)'],
	        [0.875, 'rgb(250,0,0)'], [1, 'rgb(128,0,0)']
	    ],
	
	    'Hot': [
	        [0, 'rgb(0,0,0)'], [0.3, 'rgb(230,0,0)'],
	        [0.6, 'rgb(255,210,0)'], [1, 'rgb(255,255,255)']
	    ],
	
	    'Blackbody': [
	        [0, 'rgb(0,0,0)'], [0.2, 'rgb(230,0,0)'],
	        [0.4, 'rgb(230,210,0)'], [0.7, 'rgb(255,255,255)'],
	        [1, 'rgb(160,200,255)']
	    ],
	
	    'Earth': [
	        [0, 'rgb(0,0,130)'], [0.1, 'rgb(0,180,180)'],
	        [0.2, 'rgb(40,210,40)'], [0.4, 'rgb(230,230,50)'],
	        [0.6, 'rgb(120,70,20)'], [1, 'rgb(255,255,255)']
	    ],
	
	    'Electric': [
	        [0, 'rgb(0,0,0)'], [0.15, 'rgb(30,0,100)'],
	        [0.4, 'rgb(120,0,100)'], [0.6, 'rgb(160,90,0)'],
	        [0.8, 'rgb(230,200,0)'], [1, 'rgb(255,250,220)']
	    ],
	
	    'Viridis': [
	        [0, '#440154'], [0.06274509803921569, '#48186a'],
	        [0.12549019607843137, '#472d7b'], [0.18823529411764706, '#424086'],
	        [0.25098039215686274, '#3b528b'], [0.3137254901960784, '#33638d'],
	        [0.3764705882352941, '#2c728e'], [0.4392156862745098, '#26828e'],
	        [0.5019607843137255, '#21918c'], [0.5647058823529412, '#1fa088'],
	        [0.6274509803921569, '#28ae80'], [0.6901960784313725, '#3fbc73'],
	        [0.7529411764705882, '#5ec962'], [0.8156862745098039, '#84d44b'],
	        [0.8784313725490196, '#addc30'], [0.9411764705882353, '#d8e219'],
	        [1, '#fde725']
	    ],
	
	    'Cividis': [
	        [0.000000, 'rgb(0,32,76)'], [0.058824, 'rgb(0,42,102)'],
	        [0.117647, 'rgb(0,52,110)'], [0.176471, 'rgb(39,63,108)'],
	        [0.235294, 'rgb(60,74,107)'], [0.294118, 'rgb(76,85,107)'],
	        [0.352941, 'rgb(91,95,109)'], [0.411765, 'rgb(104,106,112)'],
	        [0.470588, 'rgb(117,117,117)'], [0.529412, 'rgb(131,129,120)'],
	        [0.588235, 'rgb(146,140,120)'], [0.647059, 'rgb(161,152,118)'],
	        [0.705882, 'rgb(176,165,114)'], [0.764706, 'rgb(192,177,109)'],
	        [0.823529, 'rgb(209,191,102)'], [0.882353, 'rgb(225,204,92)'],
	        [0.941176, 'rgb(243,219,79)'], [1.000000, 'rgb(255,233,69)']
	    ]
	};
	
	var defaultScale = scales.RdBu;
	
	function getScale(scl, dflt) {
	    if(!dflt) dflt = defaultScale;
	    if(!scl) return dflt;
	
	    function parseScale() {
	        try {
	            scl = scales[scl] || JSON.parse(scl);
	        } catch(e) {
	            scl = dflt;
	        }
	    }
	
	    if(typeof scl === 'string') {
	        parseScale();
	        // occasionally scl is double-JSON encoded...
	        if(typeof scl === 'string') parseScale();
	    }
	
	    if(!isValidScaleArray(scl)) return dflt;
	    return scl;
	}
	
	
	function isValidScaleArray(scl) {
	    var highestVal = 0;
	
	    if(!Array.isArray(scl) || scl.length < 2) return false;
	
	    if(!scl[0] || !scl[scl.length - 1]) return false;
	
	    if(+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
	
	    for(var i = 0; i < scl.length; i++) {
	        var si = scl[i];
	
	        if(si.length !== 2 || +si[0] < highestVal || !tinycolor(si[1]).isValid()) {
	            return false;
	        }
	
	        highestVal = +si[0];
	    }
	
	    return true;
	}
	
	function isValidScale(scl) {
	    if(scales[scl] !== undefined) return true;
	    else return isValidScaleArray(scl);
	}
	
	module.exports = {
	    scales: scales,
	    defaultScale: defaultScale,
	
	    get: getScale,
	    isValid: isValidScale
	};
	
	},{"tinycolor2":535}],607:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	// for automatic alignment on dragging, <1/3 means left align,
	// >2/3 means right, and between is center. Pick the right fraction
	// based on where you are, and return the fraction corresponding to
	// that position on the object
	module.exports = function align(v, dv, v0, v1, anchor) {
	    var vmin = (v - v0) / (v1 - v0);
	    var vmax = vmin + dv / (v1 - v0);
	    var vc = (vmin + vmax) / 2;
	
	    // explicitly specified anchor
	    if(anchor === 'left' || anchor === 'bottom') return vmin;
	    if(anchor === 'center' || anchor === 'middle') return vc;
	    if(anchor === 'right' || anchor === 'top') return vmax;
	
	    // automatic based on position
	    if(vmin < (2 / 3) - vc) return vmin;
	    if(vmax > (4 / 3) - vc) return vmax;
	    return vc;
	};
	
	},{}],608:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	
	// set cursors pointing toward the closest corner/side,
	// to indicate alignment
	// x and y are 0-1, fractions of the plot area
	var cursorset = [
	    ['sw-resize', 's-resize', 'se-resize'],
	    ['w-resize', 'move', 'e-resize'],
	    ['nw-resize', 'n-resize', 'ne-resize']
	];
	
	module.exports = function getCursor(x, y, xanchor, yanchor) {
	    if(xanchor === 'left') x = 0;
	    else if(xanchor === 'center') x = 1;
	    else if(xanchor === 'right') x = 2;
	    else x = Lib.constrain(Math.floor(x * 3), 0, 2);
	
	    if(yanchor === 'bottom') y = 0;
	    else if(yanchor === 'middle') y = 1;
	    else if(yanchor === 'top') y = 2;
	    else y = Lib.constrain(Math.floor(y * 3), 0, 2);
	
	    return cursorset[y][x];
	};
	
	},{"../../lib":716}],609:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var mouseOffset = _dereq_('mouse-event-offset');
	var hasHover = _dereq_('has-hover');
	var supportsPassive = _dereq_('has-passive-events');
	
	var removeElement = _dereq_('../../lib').removeElement;
	var constants = _dereq_('../../plots/cartesian/constants');
	
	var dragElement = module.exports = {};
	
	dragElement.align = _dereq_('./align');
	dragElement.getCursor = _dereq_('./cursor');
	
	var unhover = _dereq_('./unhover');
	dragElement.unhover = unhover.wrapped;
	dragElement.unhoverRaw = unhover.raw;
	
	/**
	 * Abstracts click & drag interactions
	 *
	 * During the interaction, a "coverSlip" element - a transparent
	 * div covering the whole page - is created, which has two key effects:
	 * - Lets you drag beyond the boundaries of the plot itself without
	 *   dropping (but if you drag all the way out of the browser window the
	 *   interaction will end)
	 * - Freezes the cursor: whatever mouse cursor the drag element had when the
	 *   interaction started gets copied to the coverSlip for use until mouseup
	 *
	 * If the user executes a drag bigger than MINDRAG, callbacks will fire as:
	 *      prepFn, moveFn (1 or more times), doneFn
	 * If the user does not drag enough, prepFn and clickFn will fire.
	 *
	 * Note: If you cancel contextmenu, clickFn will fire even with a right click
	 * (unlike native events) so you'll get a `plotly_click` event. Cancel context eg:
	 *    gd.addEventListener('contextmenu', function(e) { e.preventDefault(); });
	 * TODO: we should probably turn this into a `config` parameter, so we can fix it
	 * such that if you *don't* cancel contextmenu, we can prevent partial drags, which
	 * put you in a weird state.
	 *
	 * If the user clicks multiple times quickly, clickFn will fire each time
	 * but numClicks will increase to help you recognize doubleclicks.
	 *
	 * @param {object} options with keys:
	 *      element (required) the DOM element to drag
	 *      prepFn (optional) function(event, startX, startY)
	 *          executed on mousedown
	 *          startX and startY are the clientX and clientY pixel position
	 *          of the mousedown event
	 *      moveFn (optional) function(dx, dy)
	 *          executed on move, ONLY after we've exceeded MINDRAG
	 *          (we keep executing moveFn if you move back to where you started)
	 *          dx and dy are the net pixel offset of the drag,
	 *          dragged is true/false, has the mouse moved enough to
	 *          constitute a drag
	 *      doneFn (optional) function(e)
	 *          executed on mouseup, ONLY if we exceeded MINDRAG (so you can be
	 *          sure that moveFn has been called at least once)
	 *          numClicks is how many clicks we've registered within
	 *          a doubleclick time
	 *          e is the original mouseup event
	 *      clickFn (optional) function(numClicks, e)
	 *          executed on mouseup if we have NOT exceeded MINDRAG (ie moveFn
	 *          has not been called at all)
	 *          numClicks is how many clicks we've registered within
	 *          a doubleclick time
	 *          e is the original mousedown event
	 *      clampFn (optional, function(dx, dy) return [dx2, dy2])
	 *          Provide custom clamping function for small displacements.
	 *          By default, clamping is done using `minDrag` to x and y displacements
	 *          independently.
	 */
	dragElement.init = function init(options) {
	    var gd = options.gd;
	    var numClicks = 1;
	    var doubleClickDelay = gd._context.doubleClickDelay;
	    var element = options.element;
	
	    var startX,
	        startY,
	        newMouseDownTime,
	        cursor,
	        dragCover,
	        initialEvent,
	        initialTarget,
	        rightClick;
	
	    if(!gd._mouseDownTime) gd._mouseDownTime = 0;
	
	    element.style.pointerEvents = 'all';
	
	    element.onmousedown = onStart;
	
	    if(!supportsPassive) {
	        element.ontouchstart = onStart;
	    } else {
	        if(element._ontouchstart) {
	            element.removeEventListener('touchstart', element._ontouchstart);
	        }
	        element._ontouchstart = onStart;
	        element.addEventListener('touchstart', onStart, {passive: false});
	    }
	
	    function _clampFn(dx, dy, minDrag) {
	        if(Math.abs(dx) < minDrag) dx = 0;
	        if(Math.abs(dy) < minDrag) dy = 0;
	        return [dx, dy];
	    }
	
	    var clampFn = options.clampFn || _clampFn;
	
	    function onStart(e) {
	        // make dragging and dragged into properties of gd
	        // so that others can look at and modify them
	        gd._dragged = false;
	        gd._dragging = true;
	        var offset = pointerOffset(e);
	        startX = offset[0];
	        startY = offset[1];
	        initialTarget = e.target;
	        initialEvent = e;
	        rightClick = e.buttons === 2 || e.ctrlKey;
	
	        // fix Fx.hover for touch events
	        if(typeof e.clientX === 'undefined' && typeof e.clientY === 'undefined') {
	            e.clientX = startX;
	            e.clientY = startY;
	        }
	
	        newMouseDownTime = (new Date()).getTime();
	        if(newMouseDownTime - gd._mouseDownTime < doubleClickDelay) {
	            // in a click train
	            numClicks += 1;
	        } else {
	            // new click train
	            numClicks = 1;
	            gd._mouseDownTime = newMouseDownTime;
	        }
	
	        if(options.prepFn) options.prepFn(e, startX, startY);
	
	        if(hasHover && !rightClick) {
	            dragCover = coverSlip();
	            dragCover.style.cursor = window.getComputedStyle(element).cursor;
	        } else if(!hasHover) {
	            // document acts as a dragcover for mobile, bc we can't create dragcover dynamically
	            dragCover = document;
	            cursor = window.getComputedStyle(document.documentElement).cursor;
	            document.documentElement.style.cursor = window.getComputedStyle(element).cursor;
	        }
	
	        document.addEventListener('mouseup', onDone);
	        document.addEventListener('touchend', onDone);
	
	        if(options.dragmode !== false) {
	            e.preventDefault();
	            document.addEventListener('mousemove', onMove);
	            document.addEventListener('touchmove', onMove, {passive: false});
	        }
	
	        return;
	    }
	
	    function onMove(e) {
	        e.preventDefault();
	
	        var offset = pointerOffset(e);
	        var minDrag = options.minDrag || constants.MINDRAG;
	        var dxdy = clampFn(offset[0] - startX, offset[1] - startY, minDrag);
	        var dx = dxdy[0];
	        var dy = dxdy[1];
	
	        if(dx || dy) {
	            gd._dragged = true;
	            dragElement.unhover(gd);
	        }
	
	        if(gd._dragged && options.moveFn && !rightClick) {
	            gd._dragdata = {
	                element: element,
	                dx: dx,
	                dy: dy
	            };
	            options.moveFn(dx, dy);
	        }
	
	        return;
	    }
	
	    function onDone(e) {
	        delete gd._dragdata;
	
	        if(options.dragmode !== false) {
	            e.preventDefault();
	            document.removeEventListener('mousemove', onMove);
	            document.removeEventListener('touchmove', onMove);
	        }
	
	        document.removeEventListener('mouseup', onDone);
	        document.removeEventListener('touchend', onDone);
	
	        if(hasHover) {
	            removeElement(dragCover);
	        } else if(cursor) {
	            dragCover.documentElement.style.cursor = cursor;
	            cursor = null;
	        }
	
	        if(!gd._dragging) {
	            gd._dragged = false;
	            return;
	        }
	        gd._dragging = false;
	
	        // don't count as a dblClick unless the mouseUp is also within
	        // the dblclick delay
	        if((new Date()).getTime() - gd._mouseDownTime > doubleClickDelay) {
	            numClicks = Math.max(numClicks - 1, 1);
	        }
	
	        if(gd._dragged) {
	            if(options.doneFn) options.doneFn();
	        } else {
	            if(options.clickFn) options.clickFn(numClicks, initialEvent);
	
	            // If we haven't dragged, this should be a click. But because of the
	            // coverSlip changing the element, the natural system might not generate one,
	            // so we need to make our own. But right clicks don't normally generate
	            // click events, only contextmenu events, which happen on mousedown.
	            if(!rightClick) {
	                var e2;
	
	                try {
	                    e2 = new MouseEvent('click', e);
	                } catch(err) {
	                    var offset = pointerOffset(e);
	                    e2 = document.createEvent('MouseEvents');
	                    e2.initMouseEvent('click',
	                        e.bubbles, e.cancelable,
	                        e.view, e.detail,
	                        e.screenX, e.screenY,
	                        offset[0], offset[1],
	                        e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
	                        e.button, e.relatedTarget);
	                }
	
	                initialTarget.dispatchEvent(e2);
	            }
	        }
	
	        gd._dragging = false;
	        gd._dragged = false;
	        return;
	    }
	};
	
	function coverSlip() {
	    var cover = document.createElement('div');
	
	    cover.className = 'dragcover';
	    var cStyle = cover.style;
	    cStyle.position = 'fixed';
	    cStyle.left = 0;
	    cStyle.right = 0;
	    cStyle.top = 0;
	    cStyle.bottom = 0;
	    cStyle.zIndex = 999999999;
	    cStyle.background = 'none';
	
	    document.body.appendChild(cover);
	
	    return cover;
	}
	
	dragElement.coverSlip = coverSlip;
	
	function pointerOffset(e) {
	    return mouseOffset(
	        e.changedTouches ? e.changedTouches[0] : e,
	        document.body
	    );
	}
	
	},{"../../lib":716,"../../plots/cartesian/constants":770,"./align":607,"./cursor":608,"./unhover":610,"has-hover":411,"has-passive-events":412,"mouse-event-offset":437}],610:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Events = _dereq_('../../lib/events');
	var throttle = _dereq_('../../lib/throttle');
	var getGraphDiv = _dereq_('../../lib/dom').getGraphDiv;
	
	var hoverConstants = _dereq_('../fx/constants');
	
	var unhover = module.exports = {};
	
	unhover.wrapped = function(gd, evt, subplot) {
	    gd = getGraphDiv(gd);
	
	    // Important, clear any queued hovers
	    if(gd._fullLayout) {
	        throttle.clear(gd._fullLayout._uid + hoverConstants.HOVERID);
	    }
	
	    unhover.raw(gd, evt, subplot);
	};
	
	
	// remove hover effects on mouse out, and emit unhover event
	unhover.raw = function raw(gd, evt) {
	    var fullLayout = gd._fullLayout;
	    var oldhoverdata = gd._hoverdata;
	
	    if(!evt) evt = {};
	    if(evt.target &&
	       Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
	        return;
	    }
	
	    fullLayout._hoverlayer.selectAll('g').remove();
	    fullLayout._hoverlayer.selectAll('line').remove();
	    fullLayout._hoverlayer.selectAll('circle').remove();
	    gd._hoverdata = undefined;
	
	    if(evt.target && oldhoverdata) {
	        gd.emit('plotly_unhover', {
	            event: evt,
	            points: oldhoverdata
	        });
	    }
	};
	
	},{"../../lib/dom":705,"../../lib/events":706,"../../lib/throttle":741,"../fx/constants":624}],611:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	exports.dash = {
	    valType: 'string',
	    // string type usually doesn't take values... this one should really be
	    // a special type or at least a special coercion function, from the GUI
	    // you only get these values but elsewhere the user can supply a list of
	    // dash lengths in px, and it will be honored
	    values: ['solid', 'dot', 'dash', 'longdash', 'dashdot', 'longdashdot'],
	    dflt: 'solid',
	    
	    editType: 'style',
	    
	};
	
	},{}],612:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	var tinycolor = _dereq_('tinycolor2');
	
	var Registry = _dereq_('../../registry');
	var Color = _dereq_('../color');
	var Colorscale = _dereq_('../colorscale');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	var alignment = _dereq_('../../constants/alignment');
	var LINE_SPACING = alignment.LINE_SPACING;
	var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
	
	var subTypes = _dereq_('../../traces/scatter/subtypes');
	var makeBubbleSizeFn = _dereq_('../../traces/scatter/make_bubble_size_func');
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	
	var drawing = module.exports = {};
	
	// -----------------------------------------------------
	// styling functions for plot elements
	// -----------------------------------------------------
	
	drawing.font = function(s, family, size, color) {
	    // also allow the form font(s, {family, size, color})
	    if(Lib.isPlainObject(family)) {
	        color = family.color;
	        size = family.size;
	        family = family.family;
	    }
	    if(family) s.style('font-family', family);
	    if(size + 1) s.style('font-size', size + 'px');
	    if(color) s.call(Color.fill, color);
	};
	
	/*
	 * Positioning helpers
	 * Note: do not use `setPosition` with <text> nodes modified by
	 * `svgTextUtils.convertToTspans`. Use `svgTextUtils.positionText`
	 * instead, so that <tspan.line> elements get updated to match.
	 */
	drawing.setPosition = function(s, x, y) { s.attr('x', x).attr('y', y); };
	drawing.setSize = function(s, w, h) { s.attr('width', w).attr('height', h); };
	drawing.setRect = function(s, x, y, w, h) {
	    s.call(drawing.setPosition, x, y).call(drawing.setSize, w, h);
	};
	
	/** Translate node
	 *
	 * @param {object} d : calcdata point item
	 * @param {sel} sel : d3 selction of node to translate
	 * @param {object} xa : corresponding full xaxis object
	 * @param {object} ya : corresponding full yaxis object
	 *
	 * @return {boolean} :
	 *  true if selection got translated
	 *  false if selection could not get translated
	 */
	drawing.translatePoint = function(d, sel, xa, ya) {
	    var x = xa.c2p(d.x);
	    var y = ya.c2p(d.y);
	
	    if(isNumeric(x) && isNumeric(y) && sel.node()) {
	        // for multiline text this works better
	        if(sel.node().nodeName === 'text') {
	            sel.attr('x', x).attr('y', y);
	        } else {
	            sel.attr('transform', 'translate(' + x + ',' + y + ')');
	        }
	    } else {
	        return false;
	    }
	
	    return true;
	};
	
	drawing.translatePoints = function(s, xa, ya) {
	    s.each(function(d) {
	        var sel = d3.select(this);
	        drawing.translatePoint(d, sel, xa, ya);
	    });
	};
	
	drawing.hideOutsideRangePoint = function(d, sel, xa, ya, xcalendar, ycalendar) {
	    sel.attr(
	        'display',
	        (xa.isPtWithinRange(d, xcalendar) && ya.isPtWithinRange(d, ycalendar)) ? null : 'none'
	    );
	};
	
	drawing.hideOutsideRangePoints = function(traceGroups, subplot) {
	    if(!subplot._hasClipOnAxisFalse) return;
	
	    var xa = subplot.xaxis;
	    var ya = subplot.yaxis;
	
	    traceGroups.each(function(d) {
	        var trace = d[0].trace;
	        var xcalendar = trace.xcalendar;
	        var ycalendar = trace.ycalendar;
	        var selector = Registry.traceIs(trace, 'bar-like') ? '.bartext' : '.point,.textpoint';
	
	        traceGroups.selectAll(selector).each(function(d) {
	            drawing.hideOutsideRangePoint(d, d3.select(this), xa, ya, xcalendar, ycalendar);
	        });
	    });
	};
	
	drawing.crispRound = function(gd, lineWidth, dflt) {
	    // for lines that disable antialiasing we want to
	    // make sure the width is an integer, and at least 1 if it's nonzero
	
	    if(!lineWidth || !isNumeric(lineWidth)) return dflt || 0;
	
	    // but not for static plots - these don't get antialiased anyway.
	    if(gd._context.staticPlot) return lineWidth;
	
	    if(lineWidth < 1) return 1;
	    return Math.round(lineWidth);
	};
	
	drawing.singleLineStyle = function(d, s, lw, lc, ld) {
	    s.style('fill', 'none');
	    var line = (((d || [])[0] || {}).trace || {}).line || {};
	    var lw1 = lw || line.width || 0;
	    var dash = ld || line.dash || '';
	
	    Color.stroke(s, lc || line.color);
	    drawing.dashLine(s, dash, lw1);
	};
	
	drawing.lineGroupStyle = function(s, lw, lc, ld) {
	    s.style('fill', 'none')
	    .each(function(d) {
	        var line = (((d || [])[0] || {}).trace || {}).line || {};
	        var lw1 = lw || line.width || 0;
	        var dash = ld || line.dash || '';
	
	        d3.select(this)
	            .call(Color.stroke, lc || line.color)
	            .call(drawing.dashLine, dash, lw1);
	    });
	};
	
	drawing.dashLine = function(s, dash, lineWidth) {
	    lineWidth = +lineWidth || 0;
	
	    dash = drawing.dashStyle(dash, lineWidth);
	
	    s.style({
	        'stroke-dasharray': dash,
	        'stroke-width': lineWidth + 'px'
	    });
	};
	
	drawing.dashStyle = function(dash, lineWidth) {
	    lineWidth = +lineWidth || 1;
	    var dlw = Math.max(lineWidth, 3);
	
	    if(dash === 'solid') dash = '';
	    else if(dash === 'dot') dash = dlw + 'px,' + dlw + 'px';
	    else if(dash === 'dash') dash = (3 * dlw) + 'px,' + (3 * dlw) + 'px';
	    else if(dash === 'longdash') dash = (5 * dlw) + 'px,' + (5 * dlw) + 'px';
	    else if(dash === 'dashdot') {
	        dash = (3 * dlw) + 'px,' + dlw + 'px,' + dlw + 'px,' + dlw + 'px';
	    } else if(dash === 'longdashdot') {
	        dash = (5 * dlw) + 'px,' + (2 * dlw) + 'px,' + dlw + 'px,' + (2 * dlw) + 'px';
	    }
	    // otherwise user wrote the dasharray themselves - leave it be
	
	    return dash;
	};
	
	// Same as fillGroupStyle, except in this case the selection may be a transition
	drawing.singleFillStyle = function(sel) {
	    var node = d3.select(sel.node());
	    var data = node.data();
	    var fillcolor = (((data[0] || [])[0] || {}).trace || {}).fillcolor;
	    if(fillcolor) {
	        sel.call(Color.fill, fillcolor);
	    }
	};
	
	drawing.fillGroupStyle = function(s) {
	    s.style('stroke-width', 0)
	    .each(function(d) {
	        var shape = d3.select(this);
	        // N.B. 'd' won't be a calcdata item when
	        // fill !== 'none' on a segment-less and marker-less trace
	        if(d[0].trace) {
	            shape.call(Color.fill, d[0].trace.fillcolor);
	        }
	    });
	};
	
	var SYMBOLDEFS = _dereq_('./symbol_defs');
	
	drawing.symbolNames = [];
	drawing.symbolFuncs = [];
	drawing.symbolNeedLines = {};
	drawing.symbolNoDot = {};
	drawing.symbolNoFill = {};
	drawing.symbolList = [];
	
	Object.keys(SYMBOLDEFS).forEach(function(k) {
	    var symDef = SYMBOLDEFS[k];
	    drawing.symbolList = drawing.symbolList.concat(
	        [symDef.n, k, symDef.n + 100, k + '-open']);
	    drawing.symbolNames[symDef.n] = k;
	    drawing.symbolFuncs[symDef.n] = symDef.f;
	    if(symDef.needLine) {
	        drawing.symbolNeedLines[symDef.n] = true;
	    }
	    if(symDef.noDot) {
	        drawing.symbolNoDot[symDef.n] = true;
	    } else {
	        drawing.symbolList = drawing.symbolList.concat(
	            [symDef.n + 200, k + '-dot', symDef.n + 300, k + '-open-dot']);
	    }
	    if(symDef.noFill) {
	        drawing.symbolNoFill[symDef.n] = true;
	    }
	});
	
	var MAXSYMBOL = drawing.symbolNames.length;
	// add a dot in the middle of the symbol
	var DOTPATH = 'M0,0.5L0.5,0L0,-0.5L-0.5,0Z';
	
	drawing.symbolNumber = function(v) {
	    if(typeof v === 'string') {
	        var vbase = 0;
	        if(v.indexOf('-open') > 0) {
	            vbase = 100;
	            v = v.replace('-open', '');
	        }
	        if(v.indexOf('-dot') > 0) {
	            vbase += 200;
	            v = v.replace('-dot', '');
	        }
	        v = drawing.symbolNames.indexOf(v);
	        if(v >= 0) { v += vbase; }
	    }
	    if((v % 100 >= MAXSYMBOL) || v >= 400) { return 0; }
	    return Math.floor(Math.max(v, 0));
	};
	
	function makePointPath(symbolNumber, r) {
	    var base = symbolNumber % 100;
	    return drawing.symbolFuncs[base](r) + (symbolNumber >= 200 ? DOTPATH : '');
	}
	
	var HORZGRADIENT = {x1: 1, x2: 0, y1: 0, y2: 0};
	var VERTGRADIENT = {x1: 0, x2: 0, y1: 1, y2: 0};
	var stopFormatter = d3.format('~.1f');
	var gradientInfo = {
	    radial: {node: 'radialGradient'},
	    radialreversed: {node: 'radialGradient', reversed: true},
	    horizontal: {node: 'linearGradient', attrs: HORZGRADIENT},
	    horizontalreversed: {node: 'linearGradient', attrs: HORZGRADIENT, reversed: true},
	    vertical: {node: 'linearGradient', attrs: VERTGRADIENT},
	    verticalreversed: {node: 'linearGradient', attrs: VERTGRADIENT, reversed: true}
	};
	
	/**
	 * gradient: create and apply a gradient fill
	 *
	 * @param {object} sel: d3 selection to apply this gradient to
	 *     You can use `selection.call(Drawing.gradient, ...)`
	 * @param {DOM element} gd: the graph div `sel` is part of
	 * @param {string} gradientID: a unique (within this plot) identifier
	 *     for this gradient, so that we don't create unnecessary definitions
	 * @param {string} type: 'radial', 'horizontal', or 'vertical', optionally with
	 *     'reversed' at the end. Normally radial goes center to edge,
	 *     horizontal goes right to left, and vertical goes bottom to top
	 * @param {array} colorscale: as in attribute values, [[fraction, color], ...]
	 * @param {string} prop: the property to apply to, 'fill' or 'stroke'
	 */
	drawing.gradient = function(sel, gd, gradientID, type, colorscale, prop) {
	    var len = colorscale.length;
	    var info = gradientInfo[type];
	    var colorStops = new Array(len);
	    for(var i = 0; i < len; i++) {
	        if(info.reversed) {
	            colorStops[len - 1 - i] = [stopFormatter((1 - colorscale[i][0]) * 100), colorscale[i][1]];
	        } else {
	            colorStops[i] = [stopFormatter(colorscale[i][0] * 100), colorscale[i][1]];
	        }
	    }
	
	    var fullID = 'g' + gd._fullLayout._uid + '-' + gradientID;
	
	    var gradient = gd._fullLayout._defs.select('.gradients')
	        .selectAll('#' + fullID)
	        .data([type + colorStops.join(';')], Lib.identity);
	
	    gradient.exit().remove();
	
	    gradient.enter()
	        .append(info.node)
	        .each(function() {
	            var el = d3.select(this);
	            if(info.attrs) el.attr(info.attrs);
	
	            el.attr('id', fullID);
	
	            var stops = el.selectAll('stop')
	                .data(colorStops);
	            stops.exit().remove();
	            stops.enter().append('stop');
	
	            stops.each(function(d) {
	                var tc = tinycolor(d[1]);
	                d3.select(this).attr({
	                    offset: d[0] + '%',
	                    'stop-color': Color.tinyRGB(tc),
	                    'stop-opacity': tc.getAlpha()
	                });
	            });
	        });
	
	    sel.style(prop, getFullUrl(fullID, gd))
	        .style(prop + '-opacity', null);
	};
	
	/*
	 * Make the gradients container and clear out any previous gradients.
	 * We never collect all the gradients we need in one place,
	 * so we can't ever remove gradients that have stopped being useful,
	 * except all at once before a full redraw.
	 * The upside of this is arbitrary points can share gradient defs
	 */
	drawing.initGradients = function(gd) {
	    var gradientsGroup = Lib.ensureSingle(gd._fullLayout._defs, 'g', 'gradients');
	    gradientsGroup.selectAll('linearGradient,radialGradient').remove();
	};
	
	
	drawing.pointStyle = function(s, trace, gd) {
	    if(!s.size()) return;
	
	    var fns = drawing.makePointStyleFns(trace);
	
	    s.each(function(d) {
	        drawing.singlePointStyle(d, d3.select(this), trace, fns, gd);
	    });
	};
	
	drawing.singlePointStyle = function(d, sel, trace, fns, gd) {
	    var marker = trace.marker;
	    var markerLine = marker.line;
	
	    sel.style('opacity',
	        fns.selectedOpacityFn ? fns.selectedOpacityFn(d) :
	            (d.mo === undefined ? marker.opacity : d.mo)
	    );
	
	    if(fns.ms2mrc) {
	        var r;
	
	        // handle multi-trace graph edit case
	        if(d.ms === 'various' || marker.size === 'various') {
	            r = 3;
	        } else {
	            r = fns.ms2mrc(d.ms);
	        }
	
	        // store the calculated size so hover can use it
	        d.mrc = r;
	
	        if(fns.selectedSizeFn) {
	            r = d.mrc = fns.selectedSizeFn(d);
	        }
	
	        // turn the symbol into a sanitized number
	        var x = drawing.symbolNumber(d.mx || marker.symbol) || 0;
	
	        // save if this marker is open
	        // because that impacts how to handle colors
	        d.om = x % 200 >= 100;
	
	        sel.attr('d', makePointPath(x, r));
	    }
	
	    var perPointGradient = false;
	    var fillColor, lineColor, lineWidth;
	
	    // 'so' is suspected outliers, for box plots
	    if(d.so) {
	        lineWidth = markerLine.outlierwidth;
	        lineColor = markerLine.outliercolor;
	        fillColor = marker.outliercolor;
	    } else {
	        var markerLineWidth = (markerLine || {}).width;
	
	        lineWidth = (
	            d.mlw + 1 ||
	            markerLineWidth + 1 ||
	            // TODO: we need the latter for legends... can we get rid of it?
	            (d.trace ? (d.trace.marker.line || {}).width : 0) + 1
	        ) - 1 || 0;
	
	        if('mlc' in d) lineColor = d.mlcc = fns.lineScale(d.mlc);
	        // weird case: array wasn't long enough to apply to every point
	        else if(Lib.isArrayOrTypedArray(markerLine.color)) lineColor = Color.defaultLine;
	        else lineColor = markerLine.color;
	
	        if(Lib.isArrayOrTypedArray(marker.color)) {
	            fillColor = Color.defaultLine;
	            perPointGradient = true;
	        }
	
	        if('mc' in d) {
	            fillColor = d.mcc = fns.markerScale(d.mc);
	        } else {
	            fillColor = marker.color || 'rgba(0,0,0,0)';
	        }
	
	        if(fns.selectedColorFn) {
	            fillColor = fns.selectedColorFn(d);
	        }
	    }
	
	    if(d.om) {
	        // open markers can't have zero linewidth, default to 1px,
	        // and use fill color as stroke color
	        sel.call(Color.stroke, fillColor)
	            .style({
	                'stroke-width': (lineWidth || 1) + 'px',
	                fill: 'none'
	            });
	    } else {
	        sel.style('stroke-width', (d.isBlank ? 0 : lineWidth) + 'px');
	
	        var markerGradient = marker.gradient;
	
	        var gradientType = d.mgt;
	        if(gradientType) perPointGradient = true;
	        else gradientType = markerGradient && markerGradient.type;
	
	        // for legend - arrays will propagate through here, but we don't need
	        // to treat it as per-point.
	        if(Array.isArray(gradientType)) {
	            gradientType = gradientType[0];
	            if(!gradientInfo[gradientType]) gradientType = 0;
	        }
	
	        if(gradientType && gradientType !== 'none') {
	            var gradientColor = d.mgc;
	            if(gradientColor) perPointGradient = true;
	            else gradientColor = markerGradient.color;
	
	            var gradientID = trace.uid;
	            if(perPointGradient) gradientID += '-' + d.i;
	
	            drawing.gradient(sel, gd, gradientID, gradientType,
	                [[0, gradientColor], [1, fillColor]], 'fill');
	        } else {
	            Color.fill(sel, fillColor);
	        }
	
	        if(lineWidth) {
	            Color.stroke(sel, lineColor);
	        }
	    }
	};
	
	drawing.makePointStyleFns = function(trace) {
	    var out = {};
	    var marker = trace.marker;
	
	    // allow array marker and marker line colors to be
	    // scaled by given max and min to colorscales
	    out.markerScale = drawing.tryColorscale(marker, '');
	    out.lineScale = drawing.tryColorscale(marker, 'line');
	
	    if(Registry.traceIs(trace, 'symbols')) {
	        out.ms2mrc = subTypes.isBubble(trace) ?
	            makeBubbleSizeFn(trace) :
	            function() { return (marker.size || 6) / 2; };
	    }
	
	    if(trace.selectedpoints) {
	        Lib.extendFlat(out, drawing.makeSelectedPointStyleFns(trace));
	    }
	
	    return out;
	};
	
	drawing.makeSelectedPointStyleFns = function(trace) {
	    var out = {};
	
	    var selectedAttrs = trace.selected || {};
	    var unselectedAttrs = trace.unselected || {};
	
	    var marker = trace.marker || {};
	    var selectedMarker = selectedAttrs.marker || {};
	    var unselectedMarker = unselectedAttrs.marker || {};
	
	    var mo = marker.opacity;
	    var smo = selectedMarker.opacity;
	    var usmo = unselectedMarker.opacity;
	    var smoIsDefined = smo !== undefined;
	    var usmoIsDefined = usmo !== undefined;
	
	    if(Lib.isArrayOrTypedArray(mo) || smoIsDefined || usmoIsDefined) {
	        out.selectedOpacityFn = function(d) {
	            var base = d.mo === undefined ? marker.opacity : d.mo;
	
	            if(d.selected) {
	                return smoIsDefined ? smo : base;
	            } else {
	                return usmoIsDefined ? usmo : DESELECTDIM * base;
	            }
	        };
	    }
	
	    var mc = marker.color;
	    var smc = selectedMarker.color;
	    var usmc = unselectedMarker.color;
	
	    if(smc || usmc) {
	        out.selectedColorFn = function(d) {
	            var base = d.mcc || mc;
	
	            if(d.selected) {
	                return smc || base;
	            } else {
	                return usmc || base;
	            }
	        };
	    }
	
	    var ms = marker.size;
	    var sms = selectedMarker.size;
	    var usms = unselectedMarker.size;
	    var smsIsDefined = sms !== undefined;
	    var usmsIsDefined = usms !== undefined;
	
	    if(Registry.traceIs(trace, 'symbols') && (smsIsDefined || usmsIsDefined)) {
	        out.selectedSizeFn = function(d) {
	            var base = d.mrc || ms / 2;
	
	            if(d.selected) {
	                return smsIsDefined ? sms / 2 : base;
	            } else {
	                return usmsIsDefined ? usms / 2 : base;
	            }
	        };
	    }
	
	    return out;
	};
	
	drawing.makeSelectedTextStyleFns = function(trace) {
	    var out = {};
	
	    var selectedAttrs = trace.selected || {};
	    var unselectedAttrs = trace.unselected || {};
	
	    var textFont = trace.textfont || {};
	    var selectedTextFont = selectedAttrs.textfont || {};
	    var unselectedTextFont = unselectedAttrs.textfont || {};
	
	    var tc = textFont.color;
	    var stc = selectedTextFont.color;
	    var utc = unselectedTextFont.color;
	
	    out.selectedTextColorFn = function(d) {
	        var base = d.tc || tc;
	
	        if(d.selected) {
	            return stc || base;
	        } else {
	            if(utc) return utc;
	            else return stc ? base : Color.addOpacity(base, DESELECTDIM);
	        }
	    };
	
	    return out;
	};
	
	drawing.selectedPointStyle = function(s, trace) {
	    if(!s.size() || !trace.selectedpoints) return;
	
	    var fns = drawing.makeSelectedPointStyleFns(trace);
	    var marker = trace.marker || {};
	    var seq = [];
	
	    if(fns.selectedOpacityFn) {
	        seq.push(function(pt, d) {
	            pt.style('opacity', fns.selectedOpacityFn(d));
	        });
	    }
	
	    if(fns.selectedColorFn) {
	        seq.push(function(pt, d) {
	            Color.fill(pt, fns.selectedColorFn(d));
	        });
	    }
	
	    if(fns.selectedSizeFn) {
	        seq.push(function(pt, d) {
	            var mx = d.mx || marker.symbol || 0;
	            var mrc2 = fns.selectedSizeFn(d);
	
	            pt.attr('d', makePointPath(drawing.symbolNumber(mx), mrc2));
	
	            // save for Drawing.selectedTextStyle
	            d.mrc2 = mrc2;
	        });
	    }
	
	    if(seq.length) {
	        s.each(function(d) {
	            var pt = d3.select(this);
	            for(var i = 0; i < seq.length; i++) {
	                seq[i](pt, d);
	            }
	        });
	    }
	};
	
	drawing.tryColorscale = function(marker, prefix) {
	    var cont = prefix ? Lib.nestedProperty(marker, prefix).get() : marker;
	
	    if(cont) {
	        var colorArray = cont.color;
	        if((cont.colorscale || cont._colorAx) && Lib.isArrayOrTypedArray(colorArray)) {
	            return Colorscale.makeColorScaleFuncFromTrace(cont);
	        }
	    }
	    return Lib.identity;
	};
	
	var TEXTOFFSETSIGN = {
	    start: 1, end: -1, middle: 0, bottom: 1, top: -1
	};
	
	function textPointPosition(s, textPosition, fontSize, markerRadius) {
	    var group = d3.select(s.node().parentNode);
	
	    var v = textPosition.indexOf('top') !== -1 ?
	        'top' :
	        textPosition.indexOf('bottom') !== -1 ? 'bottom' : 'middle';
	    var h = textPosition.indexOf('left') !== -1 ?
	        'end' :
	        textPosition.indexOf('right') !== -1 ? 'start' : 'middle';
	
	    // if markers are shown, offset a little more than
	    // the nominal marker size
	    // ie 2/1.6 * nominal, bcs some markers are a bit bigger
	    var r = markerRadius ? markerRadius / 0.8 + 1 : 0;
	
	    var numLines = (svgTextUtils.lineCount(s) - 1) * LINE_SPACING + 1;
	    var dx = TEXTOFFSETSIGN[h] * r;
	    var dy = fontSize * 0.75 + TEXTOFFSETSIGN[v] * r +
	        (TEXTOFFSETSIGN[v] - 1) * numLines * fontSize / 2;
	
	    // fix the overall text group position
	    s.attr('text-anchor', h);
	    group.attr('transform', 'translate(' + dx + ',' + dy + ')');
	}
	
	function extracTextFontSize(d, trace) {
	    var fontSize = d.ts || trace.textfont.size;
	    return (isNumeric(fontSize) && fontSize > 0) ? fontSize : 0;
	}
	
	// draw text at points
	drawing.textPointStyle = function(s, trace, gd) {
	    if(!s.size()) return;
	
	    var selectedTextColorFn;
	    if(trace.selectedpoints) {
	        var fns = drawing.makeSelectedTextStyleFns(trace);
	        selectedTextColorFn = fns.selectedTextColorFn;
	    }
	
	    var texttemplate = trace.texttemplate;
	    var fullLayout = gd._fullLayout;
	
	    s.each(function(d) {
	        var p = d3.select(this);
	
	        var text = texttemplate ?
	            Lib.extractOption(d, trace, 'txt', 'texttemplate') :
	            Lib.extractOption(d, trace, 'tx', 'text');
	
	        if(!text && text !== 0) {
	            p.remove();
	            return;
	        }
	
	        if(texttemplate) {
	            var labels = trace._module.formatLabels ? trace._module.formatLabels(d, trace, fullLayout) : {};
	            var pointValues = {};
	            appendArrayPointValue(pointValues, trace, d.i);
	            var meta = trace._meta || {};
	            text = Lib.texttemplateString(text, labels, fullLayout._d3locale, pointValues, d, meta);
	        }
	
	        var pos = d.tp || trace.textposition;
	        var fontSize = extracTextFontSize(d, trace);
	        var fontColor = selectedTextColorFn ?
	            selectedTextColorFn(d) :
	            (d.tc || trace.textfont.color);
	
	        p.call(drawing.font,
	                d.tf || trace.textfont.family,
	                fontSize,
	                fontColor)
	            .text(text)
	            .call(svgTextUtils.convertToTspans, gd)
	            .call(textPointPosition, pos, fontSize, d.mrc);
	    });
	};
	
	drawing.selectedTextStyle = function(s, trace) {
	    if(!s.size() || !trace.selectedpoints) return;
	
	    var fns = drawing.makeSelectedTextStyleFns(trace);
	
	    s.each(function(d) {
	        var tx = d3.select(this);
	        var tc = fns.selectedTextColorFn(d);
	        var tp = d.tp || trace.textposition;
	        var fontSize = extracTextFontSize(d, trace);
	
	        Color.fill(tx, tc);
	        textPointPosition(tx, tp, fontSize, d.mrc2 || d.mrc);
	    });
	};
	
	// generalized Catmull-Rom splines, per
	// http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	var CatmullRomExp = 0.5;
	drawing.smoothopen = function(pts, smoothness) {
	    if(pts.length < 3) { return 'M' + pts.join('L');}
	    var path = 'M' + pts[0];
	    var tangents = [];
	    var i;
	    for(i = 1; i < pts.length - 1; i++) {
	        tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
	    }
	    path += 'Q' + tangents[0][0] + ' ' + pts[1];
	    for(i = 2; i < pts.length - 1; i++) {
	        path += 'C' + tangents[i - 2][1] + ' ' + tangents[i - 1][0] + ' ' + pts[i];
	    }
	    path += 'Q' + tangents[pts.length - 3][1] + ' ' + pts[pts.length - 1];
	    return path;
	};
	
	drawing.smoothclosed = function(pts, smoothness) {
	    if(pts.length < 3) { return 'M' + pts.join('L') + 'Z'; }
	    var path = 'M' + pts[0];
	    var pLast = pts.length - 1;
	    var tangents = [makeTangent(pts[pLast], pts[0], pts[1], smoothness)];
	    var i;
	    for(i = 1; i < pLast; i++) {
	        tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
	    }
	    tangents.push(
	        makeTangent(pts[pLast - 1], pts[pLast], pts[0], smoothness)
	    );
	
	    for(i = 1; i <= pLast; i++) {
	        path += 'C' + tangents[i - 1][1] + ' ' + tangents[i][0] + ' ' + pts[i];
	    }
	    path += 'C' + tangents[pLast][1] + ' ' + tangents[0][0] + ' ' + pts[0] + 'Z';
	    return path;
	};
	
	function makeTangent(prevpt, thispt, nextpt, smoothness) {
	    var d1x = prevpt[0] - thispt[0];
	    var d1y = prevpt[1] - thispt[1];
	    var d2x = nextpt[0] - thispt[0];
	    var d2y = nextpt[1] - thispt[1];
	    var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
	    var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
	    var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
	    var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
	    var denom1 = 3 * d2a * (d1a + d2a);
	    var denom2 = 3 * d1a * (d1a + d2a);
	    return [
	        [
	            d3.round(thispt[0] + (denom1 && numx / denom1), 2),
	            d3.round(thispt[1] + (denom1 && numy / denom1), 2)
	        ], [
	            d3.round(thispt[0] - (denom2 && numx / denom2), 2),
	            d3.round(thispt[1] - (denom2 && numy / denom2), 2)
	        ]
	    ];
	}
	
	// step paths - returns a generator function for paths
	// with the given step shape
	var STEPPATH = {
	    hv: function(p0, p1) {
	        return 'H' + d3.round(p1[0], 2) + 'V' + d3.round(p1[1], 2);
	    },
	    vh: function(p0, p1) {
	        return 'V' + d3.round(p1[1], 2) + 'H' + d3.round(p1[0], 2);
	    },
	    hvh: function(p0, p1) {
	        return 'H' + d3.round((p0[0] + p1[0]) / 2, 2) + 'V' +
	            d3.round(p1[1], 2) + 'H' + d3.round(p1[0], 2);
	    },
	    vhv: function(p0, p1) {
	        return 'V' + d3.round((p0[1] + p1[1]) / 2, 2) + 'H' +
	            d3.round(p1[0], 2) + 'V' + d3.round(p1[1], 2);
	    }
	};
	var STEPLINEAR = function(p0, p1) {
	    return 'L' + d3.round(p1[0], 2) + ',' + d3.round(p1[1], 2);
	};
	drawing.steps = function(shape) {
	    var onestep = STEPPATH[shape] || STEPLINEAR;
	    return function(pts) {
	        var path = 'M' + d3.round(pts[0][0], 2) + ',' + d3.round(pts[0][1], 2);
	        for(var i = 1; i < pts.length; i++) {
	            path += onestep(pts[i - 1], pts[i]);
	        }
	        return path;
	    };
	};
	
	// off-screen svg render testing element, shared by the whole page
	// uses the id 'js-plotly-tester' and stores it in drawing.tester
	drawing.makeTester = function() {
	    var tester = Lib.ensureSingleById(d3.select('body'), 'svg', 'js-plotly-tester', function(s) {
	        s.attr(xmlnsNamespaces.svgAttrs)
	            .style({
	                position: 'absolute',
	                left: '-10000px',
	                top: '-10000px',
	                width: '9000px',
	                height: '9000px',
	                'z-index': '1'
	            });
	    });
	
	    // browsers differ on how they describe the bounding rect of
	    // the svg if its contents spill over... so make a 1x1px
	    // reference point we can measure off of.
	    var testref = Lib.ensureSingle(tester, 'path', 'js-reference-point', function(s) {
	        s.attr('d', 'M0,0H1V1H0Z')
	            .style({
	                'stroke-width': 0,
	                fill: 'black'
	            });
	    });
	
	    drawing.tester = tester;
	    drawing.testref = testref;
	};
	
	/*
	 * use our offscreen tester to get a clientRect for an element,
	 * in a reference frame where it isn't translated (or transformed) and
	 * its anchor point is at (0,0)
	 * always returns a copy of the bbox, so the caller can modify it safely
	 *
	 * @param {SVGElement} node: the element to measure. If possible this should be
	 *   a <text> or MathJax <g> element that's already passed through
	 *   `convertToTspans` because in that case we can cache the results, but it's
	 *   possible to pass in any svg element.
	 *
	 * @param {boolean} inTester: is this element already in `drawing.tester`?
	 *   If you are measuring a dummy element, rather than one you really intend
	 *   to use on the plot, making it in `drawing.tester` in the first place
	 *   allows us to test faster because it cuts out cloning and appending it.
	 *
	 * @param {string} hash: for internal use only, if we already know the cache key
	 *   for this element beforehand.
	 *
	 * @return {object}: a plain object containing the width, height, left, right,
	 *   top, and bottom of `node`
	 */
	drawing.savedBBoxes = {};
	var savedBBoxesCount = 0;
	var maxSavedBBoxes = 10000;
	
	drawing.bBox = function(node, inTester, hash) {
	    /*
	     * Cache elements we've already measured so we don't have to
	     * remeasure the same thing many times
	     * We have a few bBox callers though who pass a node larger than
	     * a <text> or a MathJax <g>, such as an axis group containing many labels.
	     * These will not generate a hash (unless we figure out an appropriate
	     * hash key for them) and thus we will not hash them.
	     */
	    if(!hash) hash = nodeHash(node);
	    var out;
	    if(hash) {
	        out = drawing.savedBBoxes[hash];
	        if(out) return Lib.extendFlat({}, out);
	    } else if(node.childNodes.length === 1) {
	        /*
	         * If we have only one child element, which is itself hashable, make
	         * a new hash from this element plus its x,y,transform
	         * These bounding boxes *include* x,y,transform - mostly for use by
	         * callers trying to avoid overlaps (ie titles)
	         */
	        var innerNode = node.childNodes[0];
	
	        hash = nodeHash(innerNode);
	        if(hash) {
	            var x = +innerNode.getAttribute('x') || 0;
	            var y = +innerNode.getAttribute('y') || 0;
	            var transform = innerNode.getAttribute('transform');
	
	            if(!transform) {
	                // in this case, just varying x and y, don't bother caching
	                // the final bBox because the alteration is quick.
	                var innerBB = drawing.bBox(innerNode, false, hash);
	                if(x) {
	                    innerBB.left += x;
	                    innerBB.right += x;
	                }
	                if(y) {
	                    innerBB.top += y;
	                    innerBB.bottom += y;
	                }
	                return innerBB;
	            }
	            /*
	             * else we have a transform - rather than make a complicated
	             * (and error-prone and probably slow) transform parser/calculator,
	             * just continue on calculating the boundingClientRect of the group
	             * and use the new composite hash to cache it.
	             * That said, `innerNode.transform.baseVal` is an array of
	             * `SVGTransform` objects, that *do* seem to have a nice matrix
	             * multiplication interface that we could use to avoid making
	             * another getBoundingClientRect call...
	             */
	            hash += '~' + x + '~' + y + '~' + transform;
	
	            out = drawing.savedBBoxes[hash];
	            if(out) return Lib.extendFlat({}, out);
	        }
	    }
	    var testNode, tester;
	    if(inTester) {
	        testNode = node;
	    } else {
	        tester = drawing.tester.node();
	
	        // copy the node to test into the tester
	        testNode = node.cloneNode(true);
	        tester.appendChild(testNode);
	    }
	
	    // standardize its position (and newline tspans if any)
	    d3.select(testNode)
	        .attr('transform', null)
	        .call(svgTextUtils.positionText, 0, 0);
	
	    var testRect = testNode.getBoundingClientRect();
	    var refRect = drawing.testref
	        .node()
	        .getBoundingClientRect();
	
	    if(!inTester) tester.removeChild(testNode);
	
	    var bb = {
	        height: testRect.height,
	        width: testRect.width,
	        left: testRect.left - refRect.left,
	        top: testRect.top - refRect.top,
	        right: testRect.right - refRect.left,
	        bottom: testRect.bottom - refRect.top
	    };
	
	    // make sure we don't have too many saved boxes,
	    // or a long session could overload on memory
	    // by saving boxes for long-gone elements
	    if(savedBBoxesCount >= maxSavedBBoxes) {
	        drawing.savedBBoxes = {};
	        savedBBoxesCount = 0;
	    }
	
	    // cache this bbox
	    if(hash) drawing.savedBBoxes[hash] = bb;
	    savedBBoxesCount++;
	
	    return Lib.extendFlat({}, bb);
	};
	
	// capture everything about a node (at least in our usage) that
	// impacts its bounding box, given that bBox clears x, y, and transform
	function nodeHash(node) {
	    var inputText = node.getAttribute('data-unformatted');
	    if(inputText === null) return;
	    return inputText +
	        node.getAttribute('data-math') +
	        node.getAttribute('text-anchor') +
	        node.getAttribute('style');
	}
	
	/**
	 * Set clipPath URL in a way that work for all situations.
	 *
	 * In details, graphs on pages with <base> HTML tags need to prepend
	 * the clip path ids with the page's base url EXCEPT during toImage exports.
	 *
	 * @param {d3 selection} s : node to add clip-path attribute
	 * @param {string} localId : local clip-path (w/o base url) id
	 * @param {DOM element || object} gd
	 * - context._baseUrl {string}
	 * - context._exportedPlot {boolean}
	 */
	drawing.setClipUrl = function(s, localId, gd) {
	    s.attr('clip-path', getFullUrl(localId, gd));
	};
	
	function getFullUrl(localId, gd) {
	    if(!localId) return null;
	
	    var context = gd._context;
	    var baseUrl = context._exportedPlot ? '' : (context._baseUrl || '');
	    return 'url(\'' + baseUrl + '#' + localId + '\')';
	}
	
	drawing.getTranslate = function(element) {
	    // Note the separator [^\d] between x and y in this regex
	    // We generally use ',' but IE will convert it to ' '
	    var re = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/;
	    var getter = element.attr ? 'attr' : 'getAttribute';
	    var transform = element[getter]('transform') || '';
	
	    var translate = transform.replace(re, function(match, p1, p2) {
	        return [p1, p2].join(' ');
	    })
	    .split(' ');
	
	    return {
	        x: +translate[0] || 0,
	        y: +translate[1] || 0
	    };
	};
	
	drawing.setTranslate = function(element, x, y) {
	    var re = /(\btranslate\(.*?\);?)/;
	    var getter = element.attr ? 'attr' : 'getAttribute';
	    var setter = element.attr ? 'attr' : 'setAttribute';
	    var transform = element[getter]('transform') || '';
	
	    x = x || 0;
	    y = y || 0;
	
	    transform = transform.replace(re, '').trim();
	    transform += ' translate(' + x + ', ' + y + ')';
	    transform = transform.trim();
	
	    element[setter]('transform', transform);
	
	    return transform;
	};
	
	drawing.getScale = function(element) {
	    var re = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/;
	    var getter = element.attr ? 'attr' : 'getAttribute';
	    var transform = element[getter]('transform') || '';
	
	    var translate = transform.replace(re, function(match, p1, p2) {
	        return [p1, p2].join(' ');
	    })
	    .split(' ');
	
	    return {
	        x: +translate[0] || 1,
	        y: +translate[1] || 1
	    };
	};
	
	drawing.setScale = function(element, x, y) {
	    var re = /(\bscale\(.*?\);?)/;
	    var getter = element.attr ? 'attr' : 'getAttribute';
	    var setter = element.attr ? 'attr' : 'setAttribute';
	    var transform = element[getter]('transform') || '';
	
	    x = x || 1;
	    y = y || 1;
	
	    transform = transform.replace(re, '').trim();
	    transform += ' scale(' + x + ', ' + y + ')';
	    transform = transform.trim();
	
	    element[setter]('transform', transform);
	
	    return transform;
	};
	
	var SCALE_RE = /\s*sc.*/;
	
	drawing.setPointGroupScale = function(selection, xScale, yScale) {
	    xScale = xScale || 1;
	    yScale = yScale || 1;
	
	    if(!selection) return;
	
	    // The same scale transform for every point:
	    var scale = (xScale === 1 && yScale === 1) ?
	        '' :
	        ' scale(' + xScale + ',' + yScale + ')';
	
	    selection.each(function() {
	        var t = (this.getAttribute('transform') || '').replace(SCALE_RE, '');
	        t += scale;
	        t = t.trim();
	        this.setAttribute('transform', t);
	    });
	};
	
	var TEXT_POINT_LAST_TRANSLATION_RE = /translate\([^)]*\)\s*$/;
	
	drawing.setTextPointsScale = function(selection, xScale, yScale) {
	    if(!selection) return;
	
	    selection.each(function() {
	        var transforms;
	        var el = d3.select(this);
	        var text = el.select('text');
	
	        if(!text.node()) return;
	
	        var x = parseFloat(text.attr('x') || 0);
	        var y = parseFloat(text.attr('y') || 0);
	
	        var existingTransform = (el.attr('transform') || '').match(TEXT_POINT_LAST_TRANSLATION_RE);
	
	        if(xScale === 1 && yScale === 1) {
	            transforms = [];
	        } else {
	            transforms = [
	                'translate(' + x + ',' + y + ')',
	                'scale(' + xScale + ',' + yScale + ')',
	                'translate(' + (-x) + ',' + (-y) + ')',
	            ];
	        }
	
	        if(existingTransform) {
	            transforms.push(existingTransform);
	        }
	
	        el.attr('transform', transforms.join(' '));
	    });
	};
	
	},{"../../components/fx/helpers":626,"../../constants/alignment":685,"../../constants/interactions":691,"../../constants/xmlns_namespaces":693,"../../lib":716,"../../lib/svg_text_utils":740,"../../registry":845,"../../traces/scatter/make_bubble_size_func":1135,"../../traces/scatter/subtypes":1142,"../color":591,"../colorscale":603,"./symbol_defs":613,"d3":164,"fast-isnumeric":227,"tinycolor2":535}],613:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	/** Marker symbol definitions
	 * users can specify markers either by number or name
	 * add 100 (or '-open') and you get an open marker
	 *  open markers have no fill and use line color as the stroke color
	 * add 200 (or '-dot') and you get a dot in the middle
	 * add both and you get both
	 */
	
	module.exports = {
	    circle: {
	        n: 0,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
	                'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
	        }
	    },
	    square: {
	        n: 1,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
	        }
	    },
	    diamond: {
	        n: 2,
	        f: function(r) {
	            var rd = d3.round(r * 1.3, 2);
	            return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z';
	        }
	    },
	    cross: {
	        n: 3,
	        f: function(r) {
	            var rc = d3.round(r * 0.4, 2);
	            var rc2 = d3.round(r * 1.2, 2);
	            return 'M' + rc2 + ',' + rc + 'H' + rc + 'V' + rc2 + 'H-' + rc +
	                'V' + rc + 'H-' + rc2 + 'V-' + rc + 'H-' + rc + 'V-' + rc2 +
	                'H' + rc + 'V-' + rc + 'H' + rc2 + 'Z';
	        }
	    },
	    x: {
	        n: 4,
	        f: function(r) {
	            var rx = d3.round(r * 0.8 / Math.sqrt(2), 2);
	            var ne = 'l' + rx + ',' + rx;
	            var se = 'l' + rx + ',-' + rx;
	            var sw = 'l-' + rx + ',-' + rx;
	            var nw = 'l-' + rx + ',' + rx;
	            return 'M0,' + rx + ne + se + sw + se + sw + nw + sw + nw + ne + nw + ne + 'Z';
	        }
	    },
	    'triangle-up': {
	        n: 5,
	        f: function(r) {
	            var rt = d3.round(r * 2 / Math.sqrt(3), 2);
	            var r2 = d3.round(r / 2, 2);
	            var rs = d3.round(r, 2);
	            return 'M-' + rt + ',' + r2 + 'H' + rt + 'L0,-' + rs + 'Z';
	        }
	    },
	    'triangle-down': {
	        n: 6,
	        f: function(r) {
	            var rt = d3.round(r * 2 / Math.sqrt(3), 2);
	            var r2 = d3.round(r / 2, 2);
	            var rs = d3.round(r, 2);
	            return 'M-' + rt + ',-' + r2 + 'H' + rt + 'L0,' + rs + 'Z';
	        }
	    },
	    'triangle-left': {
	        n: 7,
	        f: function(r) {
	            var rt = d3.round(r * 2 / Math.sqrt(3), 2);
	            var r2 = d3.round(r / 2, 2);
	            var rs = d3.round(r, 2);
	            return 'M' + r2 + ',-' + rt + 'V' + rt + 'L-' + rs + ',0Z';
	        }
	    },
	    'triangle-right': {
	        n: 8,
	        f: function(r) {
	            var rt = d3.round(r * 2 / Math.sqrt(3), 2);
	            var r2 = d3.round(r / 2, 2);
	            var rs = d3.round(r, 2);
	            return 'M-' + r2 + ',-' + rt + 'V' + rt + 'L' + rs + ',0Z';
	        }
	    },
	    'triangle-ne': {
	        n: 9,
	        f: function(r) {
	            var r1 = d3.round(r * 0.6, 2);
	            var r2 = d3.round(r * 1.2, 2);
	            return 'M-' + r2 + ',-' + r1 + 'H' + r1 + 'V' + r2 + 'Z';
	        }
	    },
	    'triangle-se': {
	        n: 10,
	        f: function(r) {
	            var r1 = d3.round(r * 0.6, 2);
	            var r2 = d3.round(r * 1.2, 2);
	            return 'M' + r1 + ',-' + r2 + 'V' + r1 + 'H-' + r2 + 'Z';
	        }
	    },
	    'triangle-sw': {
	        n: 11,
	        f: function(r) {
	            var r1 = d3.round(r * 0.6, 2);
	            var r2 = d3.round(r * 1.2, 2);
	            return 'M' + r2 + ',' + r1 + 'H-' + r1 + 'V-' + r2 + 'Z';
	        }
	    },
	    'triangle-nw': {
	        n: 12,
	        f: function(r) {
	            var r1 = d3.round(r * 0.6, 2);
	            var r2 = d3.round(r * 1.2, 2);
	            return 'M-' + r1 + ',' + r2 + 'V-' + r1 + 'H' + r2 + 'Z';
	        }
	    },
	    pentagon: {
	        n: 13,
	        f: function(r) {
	            var x1 = d3.round(r * 0.951, 2);
	            var x2 = d3.round(r * 0.588, 2);
	            var y0 = d3.round(-r, 2);
	            var y1 = d3.round(r * -0.309, 2);
	            var y2 = d3.round(r * 0.809, 2);
	            return 'M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2 + 'H-' + x2 +
	                'L-' + x1 + ',' + y1 + 'L0,' + y0 + 'Z';
	        }
	    },
	    hexagon: {
	        n: 14,
	        f: function(r) {
	            var y0 = d3.round(r, 2);
	            var y1 = d3.round(r / 2, 2);
	            var x = d3.round(r * Math.sqrt(3) / 2, 2);
	            return 'M' + x + ',-' + y1 + 'V' + y1 + 'L0,' + y0 +
	                'L-' + x + ',' + y1 + 'V-' + y1 + 'L0,-' + y0 + 'Z';
	        }
	    },
	    hexagon2: {
	        n: 15,
	        f: function(r) {
	            var x0 = d3.round(r, 2);
	            var x1 = d3.round(r / 2, 2);
	            var y = d3.round(r * Math.sqrt(3) / 2, 2);
	            return 'M-' + x1 + ',' + y + 'H' + x1 + 'L' + x0 +
	                ',0L' + x1 + ',-' + y + 'H-' + x1 + 'L-' + x0 + ',0Z';
	        }
	    },
	    octagon: {
	        n: 16,
	        f: function(r) {
	            var a = d3.round(r * 0.924, 2);
	            var b = d3.round(r * 0.383, 2);
	            return 'M-' + b + ',-' + a + 'H' + b + 'L' + a + ',-' + b + 'V' + b +
	                'L' + b + ',' + a + 'H-' + b + 'L-' + a + ',' + b + 'V-' + b + 'Z';
	        }
	    },
	    star: {
	        n: 17,
	        f: function(r) {
	            var rs = r * 1.4;
	            var x1 = d3.round(rs * 0.225, 2);
	            var x2 = d3.round(rs * 0.951, 2);
	            var x3 = d3.round(rs * 0.363, 2);
	            var x4 = d3.round(rs * 0.588, 2);
	            var y0 = d3.round(-rs, 2);
	            var y1 = d3.round(rs * -0.309, 2);
	            var y3 = d3.round(rs * 0.118, 2);
	            var y4 = d3.round(rs * 0.809, 2);
	            var y5 = d3.round(rs * 0.382, 2);
	            return 'M' + x1 + ',' + y1 + 'H' + x2 + 'L' + x3 + ',' + y3 +
	                'L' + x4 + ',' + y4 + 'L0,' + y5 + 'L-' + x4 + ',' + y4 +
	                'L-' + x3 + ',' + y3 + 'L-' + x2 + ',' + y1 + 'H-' + x1 +
	                'L0,' + y0 + 'Z';
	        }
	    },
	    hexagram: {
	        n: 18,
	        f: function(r) {
	            var y = d3.round(r * 0.66, 2);
	            var x1 = d3.round(r * 0.38, 2);
	            var x2 = d3.round(r * 0.76, 2);
	            return 'M-' + x2 + ',0l-' + x1 + ',-' + y + 'h' + x2 +
	                'l' + x1 + ',-' + y + 'l' + x1 + ',' + y + 'h' + x2 +
	                'l-' + x1 + ',' + y + 'l' + x1 + ',' + y + 'h-' + x2 +
	                'l-' + x1 + ',' + y + 'l-' + x1 + ',-' + y + 'h-' + x2 + 'Z';
	        }
	    },
	    'star-triangle-up': {
	        n: 19,
	        f: function(r) {
	            var x = d3.round(r * Math.sqrt(3) * 0.8, 2);
	            var y1 = d3.round(r * 0.8, 2);
	            var y2 = d3.round(r * 1.6, 2);
	            var rc = d3.round(r * 4, 2);
	            var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
	            return 'M-' + x + ',' + y1 + aPart + x + ',' + y1 +
	                aPart + '0,-' + y2 + aPart + '-' + x + ',' + y1 + 'Z';
	        }
	    },
	    'star-triangle-down': {
	        n: 20,
	        f: function(r) {
	            var x = d3.round(r * Math.sqrt(3) * 0.8, 2);
	            var y1 = d3.round(r * 0.8, 2);
	            var y2 = d3.round(r * 1.6, 2);
	            var rc = d3.round(r * 4, 2);
	            var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
	            return 'M' + x + ',-' + y1 + aPart + '-' + x + ',-' + y1 +
	                aPart + '0,' + y2 + aPart + x + ',-' + y1 + 'Z';
	        }
	    },
	    'star-square': {
	        n: 21,
	        f: function(r) {
	            var rp = d3.round(r * 1.1, 2);
	            var rc = d3.round(r * 2, 2);
	            var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
	            return 'M-' + rp + ',-' + rp + aPart + '-' + rp + ',' + rp +
	                aPart + rp + ',' + rp + aPart + rp + ',-' + rp +
	                aPart + '-' + rp + ',-' + rp + 'Z';
	        }
	    },
	    'star-diamond': {
	        n: 22,
	        f: function(r) {
	            var rp = d3.round(r * 1.4, 2);
	            var rc = d3.round(r * 1.9, 2);
	            var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
	            return 'M-' + rp + ',0' + aPart + '0,' + rp +
	                aPart + rp + ',0' + aPart + '0,-' + rp +
	                aPart + '-' + rp + ',0' + 'Z';
	        }
	    },
	    'diamond-tall': {
	        n: 23,
	        f: function(r) {
	            var x = d3.round(r * 0.7, 2);
	            var y = d3.round(r * 1.4, 2);
	            return 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z';
	        }
	    },
	    'diamond-wide': {
	        n: 24,
	        f: function(r) {
	            var x = d3.round(r * 1.4, 2);
	            var y = d3.round(r * 0.7, 2);
	            return 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z';
	        }
	    },
	    hourglass: {
	        n: 25,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M' + rs + ',' + rs + 'H-' + rs + 'L' + rs + ',-' + rs + 'H-' + rs + 'Z';
	        },
	        noDot: true
	    },
	    bowtie: {
	        n: 26,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M' + rs + ',' + rs + 'V-' + rs + 'L-' + rs + ',' + rs + 'V-' + rs + 'Z';
	        },
	        noDot: true
	    },
	    'circle-cross': {
	        n: 27,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs +
	                'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
	                'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
	        },
	        needLine: true,
	        noDot: true
	    },
	    'circle-x': {
	        n: 28,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            var rc = d3.round(r / Math.sqrt(2), 2);
	            return 'M' + rc + ',' + rc + 'L-' + rc + ',-' + rc +
	                'M' + rc + ',-' + rc + 'L-' + rc + ',' + rc +
	                'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
	                'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
	        },
	        needLine: true,
	        noDot: true
	    },
	    'square-cross': {
	        n: 29,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs +
	                'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
	        },
	        needLine: true,
	        noDot: true
	    },
	    'square-x': {
	        n: 30,
	        f: function(r) {
	            var rs = d3.round(r, 2);
	            return 'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs +
	                'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs +
	                'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
	        },
	        needLine: true,
	        noDot: true
	    },
	    'diamond-cross': {
	        n: 31,
	        f: function(r) {
	            var rd = d3.round(r * 1.3, 2);
	            return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' +
	                'M0,-' + rd + 'V' + rd + 'M-' + rd + ',0H' + rd;
	        },
	        needLine: true,
	        noDot: true
	    },
	    'diamond-x': {
	        n: 32,
	        f: function(r) {
	            var rd = d3.round(r * 1.3, 2);
	            var r2 = d3.round(r * 0.65, 2);
	            return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' +
	                'M-' + r2 + ',-' + r2 + 'L' + r2 + ',' + r2 +
	                'M-' + r2 + ',' + r2 + 'L' + r2 + ',-' + r2;
	        },
	        needLine: true,
	        noDot: true
	    },
	    'cross-thin': {
	        n: 33,
	        f: function(r) {
	            var rc = d3.round(r * 1.4, 2);
	            return 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'x-thin': {
	        n: 34,
	        f: function(r) {
	            var rx = d3.round(r, 2);
	            return 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx +
	                'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    asterisk: {
	        n: 35,
	        f: function(r) {
	            var rc = d3.round(r * 1.2, 2);
	            var rs = d3.round(r * 0.85, 2);
	            return 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc +
	                'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs +
	                'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    hash: {
	        n: 36,
	        f: function(r) {
	            var r1 = d3.round(r / 2, 2);
	            var r2 = d3.round(r, 2);
	            return 'M' + r1 + ',' + r2 + 'V-' + r2 +
	                'm-' + r2 + ',0V' + r2 +
	                'M' + r2 + ',' + r1 + 'H-' + r2 +
	                'm0,-' + r2 + 'H' + r2;
	        },
	        needLine: true,
	        noFill: true
	    },
	    'y-up': {
	        n: 37,
	        f: function(r) {
	            var x = d3.round(r * 1.2, 2);
	            var y0 = d3.round(r * 1.6, 2);
	            var y1 = d3.round(r * 0.8, 2);
	            return 'M-' + x + ',' + y1 + 'L0,0M' + x + ',' + y1 + 'L0,0M0,-' + y0 + 'L0,0';
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'y-down': {
	        n: 38,
	        f: function(r) {
	            var x = d3.round(r * 1.2, 2);
	            var y0 = d3.round(r * 1.6, 2);
	            var y1 = d3.round(r * 0.8, 2);
	            return 'M-' + x + ',-' + y1 + 'L0,0M' + x + ',-' + y1 + 'L0,0M0,' + y0 + 'L0,0';
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'y-left': {
	        n: 39,
	        f: function(r) {
	            var y = d3.round(r * 1.2, 2);
	            var x0 = d3.round(r * 1.6, 2);
	            var x1 = d3.round(r * 0.8, 2);
	            return 'M' + x1 + ',' + y + 'L0,0M' + x1 + ',-' + y + 'L0,0M-' + x0 + ',0L0,0';
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'y-right': {
	        n: 40,
	        f: function(r) {
	            var y = d3.round(r * 1.2, 2);
	            var x0 = d3.round(r * 1.6, 2);
	            var x1 = d3.round(r * 0.8, 2);
	            return 'M-' + x1 + ',' + y + 'L0,0M-' + x1 + ',-' + y + 'L0,0M' + x0 + ',0L0,0';
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'line-ew': {
	        n: 41,
	        f: function(r) {
	            var rc = d3.round(r * 1.4, 2);
	            return 'M' + rc + ',0H-' + rc;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'line-ns': {
	        n: 42,
	        f: function(r) {
	            var rc = d3.round(r * 1.4, 2);
	            return 'M0,' + rc + 'V-' + rc;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'line-ne': {
	        n: 43,
	        f: function(r) {
	            var rx = d3.round(r, 2);
	            return 'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    },
	    'line-nw': {
	        n: 44,
	        f: function(r) {
	            var rx = d3.round(r, 2);
	            return 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx;
	        },
	        needLine: true,
	        noDot: true,
	        noFill: true
	    }
	};
	
	},{"d3":164}],614:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    visible: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    type: {
	        valType: 'enumerated',
	        values: ['percent', 'constant', 'sqrt', 'data'],
	        
	        editType: 'calc',
	        
	    },
	    symmetric: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    array: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    arrayminus: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    value: {
	        valType: 'number',
	        min: 0,
	        dflt: 10,
	        
	        editType: 'calc',
	        
	    },
	    valueminus: {
	        valType: 'number',
	        min: 0,
	        dflt: 10,
	        
	        editType: 'calc',
	        
	    },
	    traceref: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'style'
	    },
	    tracerefminus: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'style'
	    },
	    copy_ystyle: {
	        valType: 'boolean',
	        
	        editType: 'plot'
	    },
	    copy_zstyle: {
	        valType: 'boolean',
	        
	        editType: 'style'
	    },
	    color: {
	        valType: 'color',
	        
	        editType: 'style',
	        
	    },
	    thickness: {
	        valType: 'number',
	        min: 0,
	        dflt: 2,
	        
	        editType: 'style',
	        
	    },
	    width: {
	        valType: 'number',
	        min: 0,
	        
	        editType: 'plot',
	        
	    },
	    editType: 'calc',
	
	    _deprecated: {
	        opacity: {
	            valType: 'number',
	            
	            editType: 'style',
	            
	        }
	    }
	};
	
	},{}],615:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	
	var makeComputeError = _dereq_('./compute_error');
	
	module.exports = function calc(gd) {
	    var calcdata = gd.calcdata;
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var calcTrace = calcdata[i];
	        var trace = calcTrace[0].trace;
	
	        if(trace.visible === true && Registry.traceIs(trace, 'errorBarsOK')) {
	            var xa = Axes.getFromId(gd, trace.xaxis);
	            var ya = Axes.getFromId(gd, trace.yaxis);
	            calcOneAxis(calcTrace, trace, xa, 'x');
	            calcOneAxis(calcTrace, trace, ya, 'y');
	        }
	    }
	};
	
	function calcOneAxis(calcTrace, trace, axis, coord) {
	    var opts = trace['error_' + coord] || {};
	    var isVisible = (opts.visible && ['linear', 'log'].indexOf(axis.type) !== -1);
	    var vals = [];
	
	    if(!isVisible) return;
	
	    var computeError = makeComputeError(opts);
	
	    for(var i = 0; i < calcTrace.length; i++) {
	        var calcPt = calcTrace[i];
	
	        var iIn = calcPt.i;
	
	        // for types that don't include `i` in each calcdata point
	        if(iIn === undefined) iIn = i;
	
	        // for stacked area inserted points
	        // TODO: errorbars have been tested cursorily with stacked area,
	        // but not thoroughly. It's not even really clear what you want to do:
	        // Should it just be calculated based on that trace's size data?
	        // Should you add errors from below in quadrature?
	        // And what about normalization, where in principle the errors shrink
	        // again when you get up to the top end?
	        // One option would be to forbid errorbars with stacking until we
	        // decide how to handle these questions.
	        else if(iIn === null) continue;
	
	        var calcCoord = calcPt[coord];
	
	        if(!isNumeric(axis.c2l(calcCoord))) continue;
	
	        var errors = computeError(calcCoord, iIn);
	        if(isNumeric(errors[0]) && isNumeric(errors[1])) {
	            var shoe = calcPt[coord + 's'] = calcCoord - errors[0];
	            var hat = calcPt[coord + 'h'] = calcCoord + errors[1];
	            vals.push(shoe, hat);
	        }
	    }
	
	    var axId = axis._id;
	    var baseExtremes = trace._extremes[axId];
	    var extremes = Axes.findExtremes(
	        axis,
	        vals,
	        Lib.extendFlat({tozero: baseExtremes.opts.tozero}, {padded: true})
	    );
	    baseExtremes.min = baseExtremes.min.concat(extremes.min);
	    baseExtremes.max = baseExtremes.max.concat(extremes.max);
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../../registry":845,"./compute_error":616,"fast-isnumeric":227}],616:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	/**
	 * Error bar computing function generator
	 *
	 * N.B. The generated function does not clean the dataPt entries. Non-numeric
	 * entries result in undefined error magnitudes.
	 *
	 * @param {object} opts error bar attributes
	 *
	 * @return {function} :
	 *      @param {numeric} dataPt data point from where to compute the error magnitude
	 *      @param {number} index index of dataPt in its corresponding data array
	 *      @return {array}
	 *        - error[0] : error magnitude in the negative direction
	 *        - error[1] : " " " " positive "
	 */
	module.exports = function makeComputeError(opts) {
	    var type = opts.type;
	    var symmetric = opts.symmetric;
	
	    if(type === 'data') {
	        var array = opts.array || [];
	
	        if(symmetric) {
	            return function computeError(dataPt, index) {
	                var val = +(array[index]);
	                return [val, val];
	            };
	        } else {
	            var arrayminus = opts.arrayminus || [];
	            return function computeError(dataPt, index) {
	                var val = +array[index];
	                var valMinus = +arrayminus[index];
	                // in case one is present and the other is missing, fill in 0
	                // so we still see the present one. Mostly useful during manual
	                // data entry.
	                if(!isNaN(val) || !isNaN(valMinus)) {
	                    return [valMinus || 0, val || 0];
	                }
	                return [NaN, NaN];
	            };
	        }
	    } else {
	        var computeErrorValue = makeComputeErrorValue(type, opts.value);
	        var computeErrorValueMinus = makeComputeErrorValue(type, opts.valueminus);
	
	        if(symmetric || opts.valueminus === undefined) {
	            return function computeError(dataPt) {
	                var val = computeErrorValue(dataPt);
	                return [val, val];
	            };
	        } else {
	            return function computeError(dataPt) {
	                return [
	                    computeErrorValueMinus(dataPt),
	                    computeErrorValue(dataPt)
	                ];
	            };
	        }
	    }
	};
	
	/**
	 * Compute error bar magnitude (for all types except data)
	 *
	 * @param {string} type error bar type
	 * @param {numeric} value error bar value
	 *
	 * @return {function} :
	 *      @param {numeric} dataPt
	 */
	function makeComputeErrorValue(type, value) {
	    if(type === 'percent') {
	        return function(dataPt) {
	            return Math.abs(dataPt * value / 100);
	        };
	    }
	    if(type === 'constant') {
	        return function() {
	            return Math.abs(value);
	        };
	    }
	    if(type === 'sqrt') {
	        return function(dataPt) {
	            return Math.sqrt(Math.abs(dataPt));
	        };
	    }
	}
	
	},{}],617:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Template = _dereq_('../../plot_api/plot_template');
	
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function(traceIn, traceOut, defaultColor, opts) {
	    var objName = 'error_' + opts.axis;
	    var containerOut = Template.newContainer(traceOut, objName);
	    var containerIn = traceIn[objName] || {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	    }
	
	    var hasErrorBars = (
	        containerIn.array !== undefined ||
	        containerIn.value !== undefined ||
	        containerIn.type === 'sqrt'
	    );
	
	    var visible = coerce('visible', hasErrorBars);
	
	    if(visible === false) return;
	
	    var type = coerce('type', 'array' in containerIn ? 'data' : 'percent');
	    var symmetric = true;
	
	    if(type !== 'sqrt') {
	        symmetric = coerce('symmetric',
	            !((type === 'data' ? 'arrayminus' : 'valueminus') in containerIn));
	    }
	
	    if(type === 'data') {
	        coerce('array');
	        coerce('traceref');
	        if(!symmetric) {
	            coerce('arrayminus');
	            coerce('tracerefminus');
	        }
	    } else if(type === 'percent' || type === 'constant') {
	        coerce('value');
	        if(!symmetric) coerce('valueminus');
	    }
	
	    var copyAttr = 'copy_' + opts.inherit + 'style';
	    if(opts.inherit) {
	        var inheritObj = traceOut['error_' + opts.inherit];
	        if((inheritObj || {}).visible) {
	            coerce(copyAttr, !(containerIn.color ||
	                               isNumeric(containerIn.thickness) ||
	                               isNumeric(containerIn.width)));
	        }
	    }
	    if(!opts.inherit || !containerOut[copyAttr]) {
	        coerce('color', defaultColor);
	        coerce('thickness');
	        coerce('width', Registry.traceIs(traceOut, 'gl3d') ? 0 : 4);
	    }
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../registry":845,"./attributes":614,"fast-isnumeric":227}],618:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var attributes = _dereq_('./attributes');
	
	var xyAttrs = {
	    error_x: Lib.extendFlat({}, attributes),
	    error_y: Lib.extendFlat({}, attributes)
	};
	delete xyAttrs.error_x.copy_zstyle;
	delete xyAttrs.error_y.copy_zstyle;
	delete xyAttrs.error_y.copy_ystyle;
	
	var xyzAttrs = {
	    error_x: Lib.extendFlat({}, attributes),
	    error_y: Lib.extendFlat({}, attributes),
	    error_z: Lib.extendFlat({}, attributes)
	};
	delete xyzAttrs.error_x.copy_ystyle;
	delete xyzAttrs.error_y.copy_ystyle;
	delete xyzAttrs.error_z.copy_ystyle;
	delete xyzAttrs.error_z.copy_zstyle;
	
	module.exports = {
	    moduleType: 'component',
	    name: 'errorbars',
	
	    schema: {
	        traces: {
	            scatter: xyAttrs,
	            bar: xyAttrs,
	            histogram: xyAttrs,
	            scatter3d: overrideAll(xyzAttrs, 'calc', 'nested'),
	            scattergl: overrideAll(xyAttrs, 'calc', 'nested')
	        }
	    },
	
	    supplyDefaults: _dereq_('./defaults'),
	
	    calc: _dereq_('./calc'),
	    makeComputeError: _dereq_('./compute_error'),
	
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    hoverInfo: hoverInfo
	};
	
	function hoverInfo(calcPoint, trace, hoverPoint) {
	    if((trace.error_y || {}).visible) {
	        hoverPoint.yerr = calcPoint.yh - calcPoint.y;
	        if(!trace.error_y.symmetric) hoverPoint.yerrneg = calcPoint.y - calcPoint.ys;
	    }
	    if((trace.error_x || {}).visible) {
	        hoverPoint.xerr = calcPoint.xh - calcPoint.x;
	        if(!trace.error_x.symmetric) hoverPoint.xerrneg = calcPoint.x - calcPoint.xs;
	    }
	}
	
	},{"../../lib":716,"../../plot_api/edit_types":747,"./attributes":614,"./calc":615,"./compute_error":616,"./defaults":617,"./plot":619,"./style":620}],619:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Drawing = _dereq_('../drawing');
	var subTypes = _dereq_('../../traces/scatter/subtypes');
	
	module.exports = function plot(gd, traces, plotinfo, transitionOpts) {
	    var isNew;
	
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    var hasAnimation = transitionOpts && transitionOpts.duration > 0;
	
	    traces.each(function(d) {
	        var trace = d[0].trace;
	        // || {} is in case the trace (specifically scatterternary)
	        // doesn't support error bars at all, but does go through
	        // the scatter.plot mechanics, which calls ErrorBars.plot
	        // internally
	        var xObj = trace.error_x || {};
	        var yObj = trace.error_y || {};
	
	        var keyFunc;
	
	        if(trace.ids) {
	            keyFunc = function(d) {return d.id;};
	        }
	
	        var sparse = (
	            subTypes.hasMarkers(trace) &&
	            trace.marker.maxdisplayed > 0
	        );
	
	        if(!yObj.visible && !xObj.visible) d = [];
	
	        var errorbars = d3.select(this).selectAll('g.errorbar')
	            .data(d, keyFunc);
	
	        errorbars.exit().remove();
	
	        if(!d.length) return;
	
	        if(!xObj.visible) errorbars.selectAll('path.xerror').remove();
	        if(!yObj.visible) errorbars.selectAll('path.yerror').remove();
	
	        errorbars.style('opacity', 1);
	
	        var enter = errorbars.enter().append('g')
	            .classed('errorbar', true);
	
	        if(hasAnimation) {
	            enter.style('opacity', 0).transition()
	                .duration(transitionOpts.duration)
	                .style('opacity', 1);
	        }
	
	        Drawing.setClipUrl(errorbars, plotinfo.layerClipId, gd);
	
	        errorbars.each(function(d) {
	            var errorbar = d3.select(this);
	            var coords = errorCoords(d, xa, ya);
	
	            if(sparse && !d.vis) return;
	
	            var path;
	
	            var yerror = errorbar.select('path.yerror');
	            if(yObj.visible && isNumeric(coords.x) &&
	                    isNumeric(coords.yh) &&
	                    isNumeric(coords.ys)) {
	                var yw = yObj.width;
	
	                path = 'M' + (coords.x - yw) + ',' +
	                    coords.yh + 'h' + (2 * yw) + // hat
	                    'm-' + yw + ',0V' + coords.ys; // bar
	
	
	                if(!coords.noYS) path += 'm-' + yw + ',0h' + (2 * yw); // shoe
	
	                isNew = !yerror.size();
	
	                if(isNew) {
	                    yerror = errorbar.append('path')
	                        .style('vector-effect', 'non-scaling-stroke')
	                        .classed('yerror', true);
	                } else if(hasAnimation) {
	                    yerror = yerror
	                        .transition()
	                            .duration(transitionOpts.duration)
	                            .ease(transitionOpts.easing);
	                }
	
	                yerror.attr('d', path);
	            } else yerror.remove();
	
	            var xerror = errorbar.select('path.xerror');
	            if(xObj.visible && isNumeric(coords.y) &&
	                    isNumeric(coords.xh) &&
	                    isNumeric(coords.xs)) {
	                var xw = (xObj.copy_ystyle ? yObj : xObj).width;
	
	                path = 'M' + coords.xh + ',' +
	                    (coords.y - xw) + 'v' + (2 * xw) + // hat
	                    'm0,-' + xw + 'H' + coords.xs; // bar
	
	                if(!coords.noXS) path += 'm0,-' + xw + 'v' + (2 * xw); // shoe
	
	                isNew = !xerror.size();
	
	                if(isNew) {
	                    xerror = errorbar.append('path')
	                        .style('vector-effect', 'non-scaling-stroke')
	                        .classed('xerror', true);
	                } else if(hasAnimation) {
	                    xerror = xerror
	                        .transition()
	                            .duration(transitionOpts.duration)
	                            .ease(transitionOpts.easing);
	                }
	
	                xerror.attr('d', path);
	            } else xerror.remove();
	        });
	    });
	};
	
	// compute the coordinates of the error-bar objects
	function errorCoords(d, xa, ya) {
	    var out = {
	        x: xa.c2p(d.x),
	        y: ya.c2p(d.y)
	    };
	
	    // calculate the error bar size and hat and shoe locations
	    if(d.yh !== undefined) {
	        out.yh = ya.c2p(d.yh);
	        out.ys = ya.c2p(d.ys);
	
	        // if the shoes go off-scale (ie log scale, error bars past zero)
	        // clip the bar and hide the shoes
	        if(!isNumeric(out.ys)) {
	            out.noYS = true;
	            out.ys = ya.c2p(d.ys, true);
	        }
	    }
	
	    if(d.xh !== undefined) {
	        out.xh = xa.c2p(d.xh);
	        out.xs = xa.c2p(d.xs);
	
	        if(!isNumeric(out.xs)) {
	            out.noXS = true;
	            out.xs = xa.c2p(d.xs, true);
	        }
	    }
	
	    return out;
	}
	
	},{"../../traces/scatter/subtypes":1142,"../drawing":612,"d3":164,"fast-isnumeric":227}],620:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Color = _dereq_('../color');
	
	
	module.exports = function style(traces) {
	    traces.each(function(d) {
	        var trace = d[0].trace;
	        var yObj = trace.error_y || {};
	        var xObj = trace.error_x || {};
	
	        var s = d3.select(this);
	
	        s.selectAll('path.yerror')
	            .style('stroke-width', yObj.thickness + 'px')
	            .call(Color.stroke, yObj.color);
	
	        if(xObj.copy_ystyle) xObj = yObj;
	
	        s.selectAll('path.xerror')
	            .style('stroke-width', xObj.thickness + 'px')
	            .call(Color.stroke, xObj.color);
	    });
	};
	
	},{"../color":591,"d3":164}],621:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var hoverLabelAttrs = _dereq_('./layout_attributes').hoverlabel;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    hoverlabel: {
	        bgcolor: extendFlat({}, hoverLabelAttrs.bgcolor, {
	            arrayOk: true,
	            
	        }),
	        bordercolor: extendFlat({}, hoverLabelAttrs.bordercolor, {
	            arrayOk: true,
	            
	        }),
	        font: fontAttrs({
	            arrayOk: true,
	            editType: 'none',
	            
	        }),
	        align: extendFlat({}, hoverLabelAttrs.align, {arrayOk: true}),
	        namelength: extendFlat({}, hoverLabelAttrs.namelength, {arrayOk: true}),
	        editType: 'none'
	    }
	};
	
	},{"../../lib/extend":707,"../../plots/font_attributes":790,"./layout_attributes":630}],622:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	module.exports = function calc(gd) {
	    var calcdata = gd.calcdata;
	    var fullLayout = gd._fullLayout;
	
	    function makeCoerceHoverInfo(trace) {
	        return function(val) {
	            return Lib.coerceHoverinfo({hoverinfo: val}, {_module: trace._module}, fullLayout);
	        };
	    }
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var trace = cd[0].trace;
	
	        // don't include hover calc fields for pie traces
	        // as calcdata items might be sorted by value and
	        // won't match the data array order.
	        if(Registry.traceIs(trace, 'pie-like')) continue;
	
	        var fillFn = Registry.traceIs(trace, '2dMap') ? paste : Lib.fillArray;
	
	        fillFn(trace.hoverinfo, cd, 'hi', makeCoerceHoverInfo(trace));
	
	        if(trace.hovertemplate) fillFn(trace.hovertemplate, cd, 'ht');
	
	        if(!trace.hoverlabel) continue;
	
	        fillFn(trace.hoverlabel.bgcolor, cd, 'hbg');
	        fillFn(trace.hoverlabel.bordercolor, cd, 'hbc');
	        fillFn(trace.hoverlabel.font.size, cd, 'hts');
	        fillFn(trace.hoverlabel.font.color, cd, 'htc');
	        fillFn(trace.hoverlabel.font.family, cd, 'htf');
	        fillFn(trace.hoverlabel.namelength, cd, 'hnl');
	        fillFn(trace.hoverlabel.align, cd, 'hta');
	    }
	};
	
	function paste(traceAttr, cd, cdAttr, fn) {
	    fn = fn || Lib.identity;
	
	    if(Array.isArray(traceAttr)) {
	        cd[0][cdAttr] = fn(traceAttr);
	    }
	}
	
	},{"../../lib":716,"../../registry":845}],623:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var hover = _dereq_('./hover').hover;
	
	module.exports = function click(gd, evt, subplot) {
	    var annotationsDone = Registry.getComponentMethod('annotations', 'onClick')(gd, gd._hoverdata);
	
	    // fallback to fail-safe in case the plot type's hover method doesn't pass the subplot.
	    // Ternary, for example, didn't, but it was caught because tested.
	    if(subplot !== undefined) {
	        // The true flag at the end causes it to re-run the hover computation to figure out *which*
	        // point is being clicked. Without this, clicking is somewhat unreliable.
	        hover(gd, evt, subplot, true);
	    }
	
	    function emitClick() { gd.emit('plotly_click', {points: gd._hoverdata, event: evt}); }
	
	    if(gd._hoverdata && evt && evt.target) {
	        if(annotationsDone && annotationsDone.then) {
	            annotationsDone.then(emitClick);
	        } else emitClick();
	
	        // why do we get a double event without this???
	        if(evt.stopImmediatePropagation) evt.stopImmediatePropagation();
	    }
	};
	
	},{"../../registry":845,"./hover":627}],624:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    // hover labels for multiple horizontal bars get tilted by this angle
	    YANGLE: 60,
	
	    // size and display constants for hover text
	
	    // pixel size of hover arrows
	    HOVERARROWSIZE: 6,
	    // pixels padding around text
	    HOVERTEXTPAD: 3,
	    // hover font
	    HOVERFONTSIZE: 13,
	    HOVERFONT: 'Arial, sans-serif',
	
	    // minimum time (msec) between hover calls
	    HOVERMINTIME: 50,
	
	    // ID suffix (with fullLayout._uid) for hover events in the throttle cache
	    HOVERID: '-hover'
	};
	
	},{}],625:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleHoverLabelDefaults = _dereq_('./hoverlabel_defaults');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var opts = Lib.extendFlat({}, layout.hoverlabel);
	    if(traceOut.hovertemplate) opts.namelength = -1;
	
	    handleHoverLabelDefaults(traceIn, traceOut, coerce, opts);
	};
	
	},{"../../lib":716,"./attributes":621,"./hoverlabel_defaults":628}],626:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// look for either subplot or xaxis and yaxis attributes
	// does not handle splom case
	exports.getSubplot = function getSubplot(trace) {
	    return trace.subplot || (trace.xaxis + trace.yaxis) || trace.geo;
	};
	
	// is trace in given list of subplots?
	// does handle splom case
	exports.isTraceInSubplots = function isTraceInSubplots(trace, subplots) {
	    if(trace.type === 'splom') {
	        var xaxes = trace.xaxes || [];
	        var yaxes = trace.yaxes || [];
	        for(var i = 0; i < xaxes.length; i++) {
	            for(var j = 0; j < yaxes.length; j++) {
	                if(subplots.indexOf(xaxes[i] + yaxes[j]) !== -1) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	
	    return subplots.indexOf(exports.getSubplot(trace)) !== -1;
	};
	
	// convenience functions for mapping all relevant axes
	exports.flat = function flat(subplots, v) {
	    var out = new Array(subplots.length);
	    for(var i = 0; i < subplots.length; i++) {
	        out[i] = v;
	    }
	    return out;
	};
	
	exports.p2c = function p2c(axArray, v) {
	    var out = new Array(axArray.length);
	    for(var i = 0; i < axArray.length; i++) {
	        out[i] = axArray[i].p2c(v);
	    }
	    return out;
	};
	
	exports.getDistanceFunction = function getDistanceFunction(mode, dx, dy, dxy) {
	    if(mode === 'closest') return dxy || exports.quadrature(dx, dy);
	    return mode === 'x' ? dx : dy;
	};
	
	exports.getClosest = function getClosest(cd, distfn, pointData) {
	    // do we already have a point number? (array mode only)
	    if(pointData.index !== false) {
	        if(pointData.index >= 0 && pointData.index < cd.length) {
	            pointData.distance = 0;
	        } else pointData.index = false;
	    } else {
	        // apply the distance function to each data point
	        // this is the longest loop... if this bogs down, we may need
	        // to create pre-sorted data (by x or y), not sure how to
	        // do this for 'closest'
	        for(var i = 0; i < cd.length; i++) {
	            var newDistance = distfn(cd[i]);
	            if(newDistance <= pointData.distance) {
	                pointData.index = i;
	                pointData.distance = newDistance;
	            }
	        }
	    }
	    return pointData;
	};
	
	/*
	 * pseudo-distance function for hover effects on areas: inside the region
	 * distance is finite (`passVal`), outside it's Infinity.
	 *
	 * @param {number} v0: signed difference between the current position and the left edge
	 * @param {number} v1: signed difference between the current position and the right edge
	 * @param {number} passVal: the value to return on success
	 */
	exports.inbox = function inbox(v0, v1, passVal) {
	    return (v0 * v1 < 0 || v0 === 0) ? passVal : Infinity;
	};
	
	exports.quadrature = function quadrature(dx, dy) {
	    return function(di) {
	        var x = dx(di);
	        var y = dy(di);
	        return Math.sqrt(x * x + y * y);
	    };
	};
	
	/** Fill event data point object for hover and selection.
	 *  Invokes _module.eventData if present.
	 *
	 * N.B. note that point 'index' corresponds to input data array index
	 *  whereas 'number' is its post-transform version.
	 *
	 * If the hovered/selected pt corresponds to an multiple input points
	 * (e.g. for histogram and transformed traces), 'pointNumbers` and 'pointIndices'
	 * are include in the event data.
	 *
	 * @param {object} pt
	 * @param {object} trace
	 * @param {object} cd
	 * @return {object}
	 */
	exports.makeEventData = function makeEventData(pt, trace, cd) {
	    // hover uses 'index', select uses 'pointNumber'
	    var pointNumber = 'index' in pt ? pt.index : pt.pointNumber;
	
	    var out = {
	        data: trace._input,
	        fullData: trace,
	        curveNumber: trace.index,
	        pointNumber: pointNumber
	    };
	
	    if(trace._indexToPoints) {
	        var pointIndices = trace._indexToPoints[pointNumber];
	
	        if(pointIndices.length === 1) {
	            out.pointIndex = pointIndices[0];
	        } else {
	            out.pointIndices = pointIndices;
	        }
	    } else {
	        out.pointIndex = pointNumber;
	    }
	
	    if(trace._module.eventData) {
	        out = trace._module.eventData(out, pt, trace, cd, pointNumber);
	    } else {
	        if('xVal' in pt) out.x = pt.xVal;
	        else if('x' in pt) out.x = pt.x;
	
	        if('yVal' in pt) out.y = pt.yVal;
	        else if('y' in pt) out.y = pt.y;
	
	        if(pt.xa) out.xaxis = pt.xa;
	        if(pt.ya) out.yaxis = pt.ya;
	        if(pt.zLabelVal !== undefined) out.z = pt.zLabelVal;
	    }
	
	    exports.appendArrayPointValue(out, trace, pointNumber);
	
	    return out;
	};
	
	/** Appends values inside array attributes corresponding to given point number
	 *
	 * @param {object} pointData : point data object (gets mutated here)
	 * @param {object} trace : full trace object
	 * @param {number|Array(number)} pointNumber : point number. May be a length-2 array
	 *     [row, col] to dig into 2D arrays
	 */
	exports.appendArrayPointValue = function(pointData, trace, pointNumber) {
	    var arrayAttrs = trace._arrayAttrs;
	
	    if(!arrayAttrs) {
	        return;
	    }
	
	    for(var i = 0; i < arrayAttrs.length; i++) {
	        var astr = arrayAttrs[i];
	        var key = getPointKey(astr);
	
	        if(pointData[key] === undefined) {
	            var val = Lib.nestedProperty(trace, astr).get();
	            var pointVal = getPointData(val, pointNumber);
	
	            if(pointVal !== undefined) pointData[key] = pointVal;
	        }
	    }
	};
	
	/**
	 * Appends values inside array attributes corresponding to given point number array
	 * For use when pointData references a plot entity that arose (or potentially arose)
	 * from multiple points in the input data
	 *
	 * @param {object} pointData : point data object (gets mutated here)
	 * @param {object} trace : full trace object
	 * @param {Array(number)|Array(Array(number))} pointNumbers : Array of point numbers.
	 *     Each entry in the array may itself be a length-2 array [row, col] to dig into 2D arrays
	 */
	exports.appendArrayMultiPointValues = function(pointData, trace, pointNumbers) {
	    var arrayAttrs = trace._arrayAttrs;
	
	    if(!arrayAttrs) {
	        return;
	    }
	
	    for(var i = 0; i < arrayAttrs.length; i++) {
	        var astr = arrayAttrs[i];
	        var key = getPointKey(astr);
	
	        if(pointData[key] === undefined) {
	            var val = Lib.nestedProperty(trace, astr).get();
	            var keyVal = new Array(pointNumbers.length);
	
	            for(var j = 0; j < pointNumbers.length; j++) {
	                keyVal[j] = getPointData(val, pointNumbers[j]);
	            }
	            pointData[key] = keyVal;
	        }
	    }
	};
	
	var pointKeyMap = {
	    ids: 'id',
	    locations: 'location',
	    labels: 'label',
	    values: 'value',
	    'marker.colors': 'color',
	    parents: 'parent'
	};
	
	function getPointKey(astr) {
	    return pointKeyMap[astr] || astr;
	}
	
	function getPointData(val, pointNumber) {
	    if(Array.isArray(pointNumber)) {
	        if(Array.isArray(val) && Array.isArray(val[pointNumber[0]])) {
	            return val[pointNumber[0]][pointNumber[1]];
	        }
	    } else {
	        return val[pointNumber];
	    }
	}
	
	},{"../../lib":716}],627:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	var tinycolor = _dereq_('tinycolor2');
	
	var Lib = _dereq_('../../lib');
	var Events = _dereq_('../../lib/events');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var overrideCursor = _dereq_('../../lib/override_cursor');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var dragElement = _dereq_('../dragelement');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Registry = _dereq_('../../registry');
	
	var helpers = _dereq_('./helpers');
	var constants = _dereq_('./constants');
	
	// hover labels for multiple horizontal bars get tilted by some angle,
	// then need to be offset differently if they overlap
	var YANGLE = constants.YANGLE;
	var YA_RADIANS = Math.PI * YANGLE / 180;
	
	// expansion of projected height
	var YFACTOR = 1 / Math.sin(YA_RADIANS);
	
	// to make the appropriate post-rotation x offset,
	// you need both x and y offsets
	var YSHIFTX = Math.cos(YA_RADIANS);
	var YSHIFTY = Math.sin(YA_RADIANS);
	
	// size and display constants for hover text
	var HOVERARROWSIZE = constants.HOVERARROWSIZE;
	var HOVERTEXTPAD = constants.HOVERTEXTPAD;
	
	// fx.hover: highlight data on hover
	// evt can be a mousemove event, or an object with data about what points
	//   to hover on
	//      {xpx,ypx[,hovermode]} - pixel locations from top left
	//          (with optional overriding hovermode)
	//      {xval,yval[,hovermode]} - data values
	//      [{curveNumber,(pointNumber|xval and/or yval)}] -
	//              array of specific points to highlight
	//          pointNumber is a single integer if gd.data[curveNumber] is 1D,
	//              or a two-element array if it's 2D
	//          xval and yval are data values,
	//              1D data may specify either or both,
	//              2D data must specify both
	// subplot is an id string (default "xy")
	// makes use of gl.hovermode, which can be:
	//      x (find the points with the closest x values, ie a column),
	//      closest (find the single closest point)
	//    internally there are two more that occasionally get used:
	//      y (pick out a row - only used for multiple horizontal bar charts)
	//      array (used when the user specifies an explicit
	//          array of points to hover on)
	//
	// We wrap the hovers in a timer, to limit their frequency.
	// The actual rendering is done by private function _hover.
	exports.hover = function hover(gd, evt, subplot, noHoverEvent) {
	    gd = Lib.getGraphDiv(gd);
	
	    Lib.throttle(
	        gd._fullLayout._uid + constants.HOVERID,
	        constants.HOVERMINTIME,
	        function() { _hover(gd, evt, subplot, noHoverEvent); }
	    );
	};
	
	/*
	 * Draw a single hover item or an array of hover item in a pre-existing svg container somewhere
	 * hoverItem should have keys:
	 *    - x and y (or x0, x1, y0, and y1):
	 *      the pixel position to mark, relative to opts.container
	 *    - xLabel, yLabel, zLabel, text, and name:
	 *      info to go in the label
	 *    - color:
	 *      the background color for the label.
	 *    - idealAlign (optional):
	 *      'left' or 'right' for which side of the x/y box to try to put this on first
	 *    - borderColor (optional):
	 *      color for the border, defaults to strongest contrast with color
	 *    - fontFamily (optional):
	 *      string, the font for this label, defaults to constants.HOVERFONT
	 *    - fontSize (optional):
	 *      the label font size, defaults to constants.HOVERFONTSIZE
	 *    - fontColor (optional):
	 *      defaults to borderColor
	 * opts should have keys:
	 *    - bgColor:
	 *      the background color this is against, used if the trace is
	 *      non-opaque, and for the name, which goes outside the box
	 *    - container:
	 *      a <svg> or <g> element to add the hover label to
	 *    - outerContainer:
	 *      normally a parent of `container`, sets the bounding box to use to
	 *      constrain the hover label and determine whether to show it on the left or right
	 * opts can have optional keys:
	 *    - anchorIndex:
	        the index of the hover item used as an anchor for positioning.
	        The other hover items will be pushed up or down to prevent overlap.
	 */
	exports.loneHover = function loneHover(hoverItems, opts) {
	    var multiHover = true;
	    if(!Array.isArray(hoverItems)) {
	        multiHover = false;
	        hoverItems = [hoverItems];
	    }
	
	    var pointsData = hoverItems.map(function(hoverItem) {
	        return {
	            color: hoverItem.color || Color.defaultLine,
	            x0: hoverItem.x0 || hoverItem.x || 0,
	            x1: hoverItem.x1 || hoverItem.x || 0,
	            y0: hoverItem.y0 || hoverItem.y || 0,
	            y1: hoverItem.y1 || hoverItem.y || 0,
	            xLabel: hoverItem.xLabel,
	            yLabel: hoverItem.yLabel,
	            zLabel: hoverItem.zLabel,
	            text: hoverItem.text,
	            name: hoverItem.name,
	            idealAlign: hoverItem.idealAlign,
	
	            // optional extra bits of styling
	            borderColor: hoverItem.borderColor,
	            fontFamily: hoverItem.fontFamily,
	            fontSize: hoverItem.fontSize,
	            fontColor: hoverItem.fontColor,
	            nameLength: hoverItem.nameLength,
	            textAlign: hoverItem.textAlign,
	
	            // filler to make createHoverText happy
	            trace: hoverItem.trace || {
	                index: 0,
	                hoverinfo: ''
	            },
	            xa: {_offset: 0},
	            ya: {_offset: 0},
	            index: 0,
	
	            hovertemplate: hoverItem.hovertemplate || false,
	            eventData: hoverItem.eventData || false,
	            hovertemplateLabels: hoverItem.hovertemplateLabels || false,
	        };
	    });
	
	    var container3 = d3.select(opts.container);
	    var outerContainer3 = opts.outerContainer ? d3.select(opts.outerContainer) : container3;
	
	    var fullOpts = {
	        hovermode: 'closest',
	        rotateLabels: false,
	        bgColor: opts.bgColor || Color.background,
	        container: container3,
	        outerContainer: outerContainer3
	    };
	
	    var hoverLabel = createHoverText(pointsData, fullOpts, opts.gd);
	
	    // Fix vertical overlap
	    var tooltipSpacing = 5;
	    var lastBottomY = 0;
	    var anchor = 0;
	    hoverLabel
	        .sort(function(a, b) {return a.y0 - b.y0;})
	        .each(function(d, i) {
	            var topY = d.y0 - d.by / 2;
	
	            if((topY - tooltipSpacing) < lastBottomY) {
	                d.offset = (lastBottomY - topY) + tooltipSpacing;
	            } else {
	                d.offset = 0;
	            }
	
	            lastBottomY = topY + d.by + d.offset;
	
	            if(i === opts.anchorIndex || 0) anchor = d.offset;
	        })
	        .each(function(d) {
	            d.offset -= anchor;
	        });
	
	    alignHoverText(hoverLabel, fullOpts.rotateLabels);
	
	    return multiHover ? hoverLabel : hoverLabel.node();
	};
	
	// The actual implementation is here:
	function _hover(gd, evt, subplot, noHoverEvent) {
	    if(!subplot) subplot = 'xy';
	
	    // if the user passed in an array of subplots,
	    // use those instead of finding overlayed plots
	    var subplots = Array.isArray(subplot) ? subplot : [subplot];
	
	    var fullLayout = gd._fullLayout;
	    var plots = fullLayout._plots || [];
	    var plotinfo = plots[subplot];
	    var hasCartesian = fullLayout._has('cartesian');
	
	    // list of all overlaid subplots to look at
	    if(plotinfo) {
	        var overlayedSubplots = plotinfo.overlays.map(function(pi) {
	            return pi.id;
	        });
	
	        subplots = subplots.concat(overlayedSubplots);
	    }
	
	    var len = subplots.length;
	    var xaArray = new Array(len);
	    var yaArray = new Array(len);
	    var supportsCompare = false;
	
	    for(var i = 0; i < len; i++) {
	        var spId = subplots[i];
	
	        if(plots[spId]) {
	            // 'cartesian' case
	            supportsCompare = true;
	            xaArray[i] = plots[spId].xaxis;
	            yaArray[i] = plots[spId].yaxis;
	        } else if(fullLayout[spId] && fullLayout[spId]._subplot) {
	            // other subplot types
	            var _subplot = fullLayout[spId]._subplot;
	            xaArray[i] = _subplot.xaxis;
	            yaArray[i] = _subplot.yaxis;
	        } else {
	            Lib.warn('Unrecognized subplot: ' + spId);
	            return;
	        }
	    }
	
	    var hovermode = evt.hovermode || fullLayout.hovermode;
	
	    if(hovermode && !supportsCompare) hovermode = 'closest';
	
	    if(['x', 'y', 'closest'].indexOf(hovermode) === -1 || !gd.calcdata ||
	            gd.querySelector('.zoombox') || gd._dragging) {
	        return dragElement.unhoverRaw(gd, evt);
	    }
	
	    var hoverdistance = fullLayout.hoverdistance === -1 ? Infinity : fullLayout.hoverdistance;
	    var spikedistance = fullLayout.spikedistance === -1 ? Infinity : fullLayout.spikedistance;
	
	    // hoverData: the set of candidate points we've found to highlight
	    var hoverData = [];
	
	    // searchData: the data to search in. Mostly this is just a copy of
	    // gd.calcdata, filtered to the subplot and overlays we're on
	    // but if a point array is supplied it will be a mapping
	    // of indicated curves
	    var searchData = [];
	
	    // [x|y]valArray: the axis values of the hover event
	    // mapped onto each of the currently selected overlaid subplots
	    var xvalArray, yvalArray;
	
	    var itemnum, curvenum, cd, trace, subplotId, subploti, mode,
	        xval, yval, pointData, closedataPreviousLength;
	
	    // spikePoints: the set of candidate points we've found to draw spikes to
	    var spikePoints = {
	        hLinePoint: null,
	        vLinePoint: null
	    };
	
	    // does subplot have one (or more) horizontal traces?
	    // This is used to determine whether we rotate the labels or not
	    var hasOneHorizontalTrace = false;
	
	    // Figure out what we're hovering on:
	    // mouse location or user-supplied data
	
	    if(Array.isArray(evt)) {
	        // user specified an array of points to highlight
	        hovermode = 'array';
	        for(itemnum = 0; itemnum < evt.length; itemnum++) {
	            cd = gd.calcdata[evt[itemnum].curveNumber || 0];
	            if(cd) {
	                trace = cd[0].trace;
	                if(cd[0].trace.hoverinfo !== 'skip') {
	                    searchData.push(cd);
	                    if(trace.orientation === 'h') {
	                        hasOneHorizontalTrace = true;
	                    }
	                }
	            }
	        }
	    } else {
	        for(curvenum = 0; curvenum < gd.calcdata.length; curvenum++) {
	            cd = gd.calcdata[curvenum];
	            trace = cd[0].trace;
	            if(trace.hoverinfo !== 'skip' && helpers.isTraceInSubplots(trace, subplots)) {
	                searchData.push(cd);
	                if(trace.orientation === 'h') {
	                    hasOneHorizontalTrace = true;
	                }
	            }
	        }
	
	        // [x|y]px: the pixels (from top left) of the mouse location
	        // on the currently selected plot area
	        // add pointerX|Y property for drawing the spikes in spikesnap 'cursor' situation
	        var hasUserCalledHover = !evt.target;
	        var xpx, ypx;
	
	        if(hasUserCalledHover) {
	            if('xpx' in evt) xpx = evt.xpx;
	            else xpx = xaArray[0]._length / 2;
	
	            if('ypx' in evt) ypx = evt.ypx;
	            else ypx = yaArray[0]._length / 2;
	        } else {
	            // fire the beforehover event and quit if it returns false
	            // note that we're only calling this on real mouse events, so
	            // manual calls to fx.hover will always run.
	            if(Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
	                return;
	            }
	
	            var dbb = evt.target.getBoundingClientRect();
	
	            xpx = evt.clientX - dbb.left;
	            ypx = evt.clientY - dbb.top;
	
	            // in case hover was called from mouseout into hovertext,
	            // it's possible you're not actually over the plot anymore
	            if(xpx < 0 || xpx > xaArray[0]._length || ypx < 0 || ypx > yaArray[0]._length) {
	                return dragElement.unhoverRaw(gd, evt);
	            }
	        }
	
	        evt.pointerX = xpx + xaArray[0]._offset;
	        evt.pointerY = ypx + yaArray[0]._offset;
	
	        if('xval' in evt) xvalArray = helpers.flat(subplots, evt.xval);
	        else xvalArray = helpers.p2c(xaArray, xpx);
	
	        if('yval' in evt) yvalArray = helpers.flat(subplots, evt.yval);
	        else yvalArray = helpers.p2c(yaArray, ypx);
	
	        if(!isNumeric(xvalArray[0]) || !isNumeric(yvalArray[0])) {
	            Lib.warn('Fx.hover failed', evt, gd);
	            return dragElement.unhoverRaw(gd, evt);
	        }
	    }
	
	    // the pixel distance to beat as a matching point
	    // in 'x' or 'y' mode this resets for each trace
	    var distance = Infinity;
	
	    // find the closest point in each trace
	    // this is minimum dx and/or dy, depending on mode
	    // and the pixel position for the label (labelXpx, labelYpx)
	    for(curvenum = 0; curvenum < searchData.length; curvenum++) {
	        cd = searchData[curvenum];
	
	        // filter out invisible or broken data
	        if(!cd || !cd[0] || !cd[0].trace) continue;
	
	        trace = cd[0].trace;
	
	        if(trace.visible !== true || trace._length === 0) continue;
	
	        // Explicitly bail out for these two. I don't know how to otherwise prevent
	        // the rest of this function from running and failing
	        if(['carpet', 'contourcarpet'].indexOf(trace._module.name) !== -1) continue;
	
	        if(trace.type === 'splom') {
	            // splom traces do not generate overlay subplots,
	            // it is safe to assume here splom traces correspond to the 0th subplot
	            subploti = 0;
	            subplotId = subplots[subploti];
	        } else {
	            subplotId = helpers.getSubplot(trace);
	            subploti = subplots.indexOf(subplotId);
	        }
	
	        // within one trace mode can sometimes be overridden
	        mode = hovermode;
	
	        // container for new point, also used to pass info into module.hoverPoints
	        pointData = {
	            // trace properties
	            cd: cd,
	            trace: trace,
	            xa: xaArray[subploti],
	            ya: yaArray[subploti],
	
	            // max distances for hover and spikes - for points that want to show but do not
	            // want to override other points, set distance/spikeDistance equal to max*Distance
	            // and it will not get filtered out but it will be guaranteed to have a greater
	            // distance than any point that calculated a real distance.
	            maxHoverDistance: hoverdistance,
	            maxSpikeDistance: spikedistance,
	
	            // point properties - override all of these
	            index: false, // point index in trace - only used by plotly.js hoverdata consumers
	            distance: Math.min(distance, hoverdistance), // pixel distance or pseudo-distance
	
	            // distance/pseudo-distance for spikes. This distance should always be calculated
	            // as if in "closest" mode, and should only be set if this point should
	            // generate a spike.
	            spikeDistance: Infinity,
	
	            // in some cases the spikes have different positioning from the hover label
	            // they don't need x0/x1, just one position
	            xSpike: undefined,
	            ySpike: undefined,
	
	            // where and how to display the hover label
	            color: Color.defaultLine, // trace color
	            name: trace.name,
	            x0: undefined,
	            x1: undefined,
	            y0: undefined,
	            y1: undefined,
	            xLabelVal: undefined,
	            yLabelVal: undefined,
	            zLabelVal: undefined,
	            text: undefined
	        };
	
	        // add ref to subplot object (non-cartesian case)
	        if(fullLayout[subplotId]) {
	            pointData.subplot = fullLayout[subplotId]._subplot;
	        }
	        // add ref to splom scene
	        if(fullLayout._splomScenes && fullLayout._splomScenes[trace.uid]) {
	            pointData.scene = fullLayout._splomScenes[trace.uid];
	        }
	
	        closedataPreviousLength = hoverData.length;
	
	        // for a highlighting array, figure out what
	        // we're searching for with this element
	        if(mode === 'array') {
	            var selection = evt[curvenum];
	            if('pointNumber' in selection) {
	                pointData.index = selection.pointNumber;
	                mode = 'closest';
	            } else {
	                mode = '';
	                if('xval' in selection) {
	                    xval = selection.xval;
	                    mode = 'x';
	                }
	                if('yval' in selection) {
	                    yval = selection.yval;
	                    mode = mode ? 'closest' : 'y';
	                }
	            }
	        } else {
	            xval = xvalArray[subploti];
	            yval = yvalArray[subploti];
	        }
	
	        // Now if there is range to look in, find the points to hover.
	        if(hoverdistance !== 0) {
	            if(trace._module && trace._module.hoverPoints) {
	                var newPoints = trace._module.hoverPoints(pointData, xval, yval, mode, fullLayout._hoverlayer);
	                if(newPoints) {
	                    var newPoint;
	                    for(var newPointNum = 0; newPointNum < newPoints.length; newPointNum++) {
	                        newPoint = newPoints[newPointNum];
	                        if(isNumeric(newPoint.x0) && isNumeric(newPoint.y0)) {
	                            hoverData.push(cleanPoint(newPoint, hovermode));
	                        }
	                    }
	                }
	            } else {
	                Lib.log('Unrecognized trace type in hover:', trace);
	            }
	        }
	
	        // in closest mode, remove any existing (farther) points
	        // and don't look any farther than this latest point (or points, some
	        // traces like box & violin make multiple hover labels at once)
	        if(hovermode === 'closest' && hoverData.length > closedataPreviousLength) {
	            hoverData.splice(0, closedataPreviousLength);
	            distance = hoverData[0].distance;
	        }
	
	        // Now if there is range to look in, find the points to draw the spikelines
	        // Do it only if there is no hoverData
	        if(hasCartesian && (spikedistance !== 0)) {
	            if(hoverData.length === 0) {
	                pointData.distance = spikedistance;
	                pointData.index = false;
	                var closestPoints = trace._module.hoverPoints(pointData, xval, yval, 'closest', fullLayout._hoverlayer);
	                if(closestPoints) {
	                    closestPoints = closestPoints.filter(function(point) {
	                        // some hover points, like scatter fills, do not allow spikes,
	                        // so will generate a hover point but without a valid spikeDistance
	                        return point.spikeDistance <= spikedistance;
	                    });
	                }
	                if(closestPoints && closestPoints.length) {
	                    var tmpPoint;
	                    var closestVPoints = closestPoints.filter(function(point) {
	                        return point.xa.showspikes;
	                    });
	                    if(closestVPoints.length) {
	                        var closestVPt = closestVPoints[0];
	                        if(isNumeric(closestVPt.x0) && isNumeric(closestVPt.y0)) {
	                            tmpPoint = fillSpikePoint(closestVPt);
	                            if(!spikePoints.vLinePoint || (spikePoints.vLinePoint.spikeDistance > tmpPoint.spikeDistance)) {
	                                spikePoints.vLinePoint = tmpPoint;
	                            }
	                        }
	                    }
	
	                    var closestHPoints = closestPoints.filter(function(point) {
	                        return point.ya.showspikes;
	                    });
	                    if(closestHPoints.length) {
	                        var closestHPt = closestHPoints[0];
	                        if(isNumeric(closestHPt.x0) && isNumeric(closestHPt.y0)) {
	                            tmpPoint = fillSpikePoint(closestHPt);
	                            if(!spikePoints.hLinePoint || (spikePoints.hLinePoint.spikeDistance > tmpPoint.spikeDistance)) {
	                                spikePoints.hLinePoint = tmpPoint;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    function selectClosestPoint(pointsData, spikedistance) {
	        var resultPoint = null;
	        var minDistance = Infinity;
	        var thisSpikeDistance;
	        for(var i = 0; i < pointsData.length; i++) {
	            thisSpikeDistance = pointsData[i].spikeDistance;
	            if(thisSpikeDistance < minDistance && thisSpikeDistance <= spikedistance) {
	                resultPoint = pointsData[i];
	                minDistance = thisSpikeDistance;
	            }
	        }
	        return resultPoint;
	    }
	
	    function fillSpikePoint(point) {
	        if(!point) return null;
	        return {
	            xa: point.xa,
	            ya: point.ya,
	            x: point.xSpike !== undefined ? point.xSpike : (point.x0 + point.x1) / 2,
	            y: point.ySpike !== undefined ? point.ySpike : (point.y0 + point.y1) / 2,
	            distance: point.distance,
	            spikeDistance: point.spikeDistance,
	            curveNumber: point.trace.index,
	            color: point.color,
	            pointNumber: point.index
	        };
	    }
	
	    var spikelineOpts = {
	        fullLayout: fullLayout,
	        container: fullLayout._hoverlayer,
	        outerContainer: fullLayout._paperdiv,
	        event: evt
	    };
	    var oldspikepoints = gd._spikepoints;
	    var newspikepoints = {
	        vLinePoint: spikePoints.vLinePoint,
	        hLinePoint: spikePoints.hLinePoint
	    };
	    gd._spikepoints = newspikepoints;
	
	    // Now if it is not restricted by spikedistance option, set the points to draw the spikelines
	    if(hasCartesian && (spikedistance !== 0)) {
	        if(hoverData.length !== 0) {
	            var tmpHPointData = hoverData.filter(function(point) {
	                return point.ya.showspikes;
	            });
	            var tmpHPoint = selectClosestPoint(tmpHPointData, spikedistance);
	            spikePoints.hLinePoint = fillSpikePoint(tmpHPoint);
	
	            var tmpVPointData = hoverData.filter(function(point) {
	                return point.xa.showspikes;
	            });
	            var tmpVPoint = selectClosestPoint(tmpVPointData, spikedistance);
	            spikePoints.vLinePoint = fillSpikePoint(tmpVPoint);
	        }
	    }
	
	    // if hoverData is empty check for the spikes to draw and quit if there are none
	    if(hoverData.length === 0) {
	        var result = dragElement.unhoverRaw(gd, evt);
	        if(hasCartesian && ((spikePoints.hLinePoint !== null) || (spikePoints.vLinePoint !== null))) {
	            if(spikesChanged(oldspikepoints)) {
	                createSpikelines(gd, spikePoints, spikelineOpts);
	            }
	        }
	        return result;
	    }
	
	    if(hasCartesian) {
	        if(spikesChanged(oldspikepoints)) {
	            createSpikelines(gd, spikePoints, spikelineOpts);
	        }
	    }
	
	    hoverData.sort(function(d1, d2) { return d1.distance - d2.distance; });
	
	    // lastly, emit custom hover/unhover events
	    var oldhoverdata = gd._hoverdata;
	    var newhoverdata = [];
	
	    // pull out just the data that's useful to
	    // other people and send it to the event
	    for(itemnum = 0; itemnum < hoverData.length; itemnum++) {
	        var pt = hoverData[itemnum];
	        var eventData = helpers.makeEventData(pt, pt.trace, pt.cd);
	
	        if(pt.hovertemplate !== false) {
	            var ht = false;
	            if(pt.cd[pt.index] && pt.cd[pt.index].ht) {
	                ht = pt.cd[pt.index].ht;
	            }
	            pt.hovertemplate = ht || pt.trace.hovertemplate || false;
	        }
	
	        pt.eventData = [eventData];
	        newhoverdata.push(eventData);
	    }
	
	    gd._hoverdata = newhoverdata;
	
	    var rotateLabels = (
	        (hovermode === 'y' && (searchData.length > 1 || hoverData.length > 1)) ||
	        (hovermode === 'closest' && hasOneHorizontalTrace && hoverData.length > 1)
	    );
	
	    var bgColor = Color.combine(
	        fullLayout.plot_bgcolor || Color.background,
	        fullLayout.paper_bgcolor
	    );
	
	    var labelOpts = {
	        hovermode: hovermode,
	        rotateLabels: rotateLabels,
	        bgColor: bgColor,
	        container: fullLayout._hoverlayer,
	        outerContainer: fullLayout._paperdiv,
	        commonLabelOpts: fullLayout.hoverlabel,
	        hoverdistance: fullLayout.hoverdistance
	    };
	
	    var hoverLabels = createHoverText(hoverData, labelOpts, gd);
	
	    hoverAvoidOverlaps(hoverLabels, rotateLabels ? 'xa' : 'ya', fullLayout);
	
	    alignHoverText(hoverLabels, rotateLabels);
	
	    // TODO: tagName hack is needed to appease geo.js's hack of using evt.target=true
	    // we should improve the "fx" API so other plots can use it without these hack.
	    if(evt.target && evt.target.tagName) {
	        var hasClickToShow = Registry.getComponentMethod('annotations', 'hasClickToShow')(gd, newhoverdata);
	        overrideCursor(d3.select(evt.target), hasClickToShow ? 'pointer' : '');
	    }
	
	    // don't emit events if called manually
	    if(!evt.target || noHoverEvent || !hoverChanged(gd, evt, oldhoverdata)) return;
	
	    if(oldhoverdata) {
	        gd.emit('plotly_unhover', {
	            event: evt,
	            points: oldhoverdata
	        });
	    }
	
	    gd.emit('plotly_hover', {
	        event: evt,
	        points: gd._hoverdata,
	        xaxes: xaArray,
	        yaxes: yaArray,
	        xvals: xvalArray,
	        yvals: yvalArray
	    });
	}
	
	var EXTRA_STRING_REGEX = /<extra>([\s\S]*)<\/extra>/;
	
	function createHoverText(hoverData, opts, gd) {
	    var fullLayout = gd._fullLayout;
	    var hovermode = opts.hovermode;
	    var rotateLabels = opts.rotateLabels;
	    var bgColor = opts.bgColor;
	    var container = opts.container;
	    var outerContainer = opts.outerContainer;
	    var commonLabelOpts = opts.commonLabelOpts || {};
	
	    // opts.fontFamily/Size are used for the common label
	    // and as defaults for each hover label, though the individual labels
	    // can override this.
	    var fontFamily = opts.fontFamily || constants.HOVERFONT;
	    var fontSize = opts.fontSize || constants.HOVERFONTSIZE;
	
	    var c0 = hoverData[0];
	    var xa = c0.xa;
	    var ya = c0.ya;
	    var commonAttr = hovermode === 'y' ? 'yLabel' : 'xLabel';
	    var t0 = c0[commonAttr];
	    var t00 = (String(t0) || '').split(' ')[0];
	    var outerContainerBB = outerContainer.node().getBoundingClientRect();
	    var outerTop = outerContainerBB.top;
	    var outerWidth = outerContainerBB.width;
	    var outerHeight = outerContainerBB.height;
	
	    // show the common label, if any, on the axis
	    // never show a common label in array mode,
	    // even if sometimes there could be one
	    var showCommonLabel = (
	        (t0 !== undefined) &&
	        (c0.distance <= opts.hoverdistance) &&
	        (hovermode === 'x' || hovermode === 'y')
	    );
	
	    // all hover traces hoverinfo must contain the hovermode
	    // to have common labels
	    if(showCommonLabel) {
	        var allHaveZ = true;
	        var i, traceHoverinfo;
	        for(i = 0; i < hoverData.length; i++) {
	            if(allHaveZ && hoverData[i].zLabel === undefined) allHaveZ = false;
	
	            traceHoverinfo = hoverData[i].hoverinfo || hoverData[i].trace.hoverinfo;
	            if(traceHoverinfo) {
	                var parts = Array.isArray(traceHoverinfo) ? traceHoverinfo : traceHoverinfo.split('+');
	                if(parts.indexOf('all') === -1 &&
	                    parts.indexOf(hovermode) === -1) {
	                    showCommonLabel = false;
	                    break;
	                }
	            }
	        }
	
	        // xyz labels put all info in their main label, so have no need of a common label
	        if(allHaveZ) showCommonLabel = false;
	    }
	
	    var commonLabel = container.selectAll('g.axistext')
	        .data(showCommonLabel ? [0] : []);
	    commonLabel.enter().append('g')
	        .classed('axistext', true);
	    commonLabel.exit().remove();
	
	    commonLabel.each(function() {
	        var label = d3.select(this);
	        var lpath = Lib.ensureSingle(label, 'path', '', function(s) {
	            s.style({'stroke-width': '1px'});
	        });
	        var ltext = Lib.ensureSingle(label, 'text', '', function(s) {
	            // prohibit tex interpretation until we can handle
	            // tex and regular text together
	            s.attr('data-notex', 1);
	        });
	
	        var commonBgColor = commonLabelOpts.bgcolor || Color.defaultLine;
	        var commonStroke = commonLabelOpts.bordercolor || Color.contrast(commonBgColor);
	        var contrastColor = Color.contrast(commonBgColor);
	        var commonLabelFont = {
	            family: commonLabelOpts.font.family || fontFamily,
	            size: commonLabelOpts.font.size || fontSize,
	            color: commonLabelOpts.font.color || contrastColor
	        };
	
	        lpath.style({
	            fill: commonBgColor,
	            stroke: commonStroke
	        });
	
	        ltext.text(t0)
	            .call(Drawing.font, commonLabelFont)
	            .call(svgTextUtils.positionText, 0, 0)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        label.attr('transform', '');
	
	        var tbb = ltext.node().getBoundingClientRect();
	        var lx, ly;
	
	        if(hovermode === 'x') {
	            var topsign = xa.side === 'top' ? '-' : '';
	
	            ltext.attr('text-anchor', 'middle')
	                .call(svgTextUtils.positionText, 0, (xa.side === 'top' ?
	                    (outerTop - tbb.bottom - HOVERARROWSIZE - HOVERTEXTPAD) :
	                    (outerTop - tbb.top + HOVERARROWSIZE + HOVERTEXTPAD)));
	
	            lx = xa._offset + (c0.x0 + c0.x1) / 2;
	            ly = ya._offset + (xa.side === 'top' ? 0 : ya._length);
	
	            var halfWidth = tbb.width / 2 + HOVERTEXTPAD;
	
	            if(lx < halfWidth) {
	                lx = halfWidth;
	
	                lpath.attr('d', 'M-' + (halfWidth - HOVERARROWSIZE) + ',0' +
	                    'L-' + (halfWidth - HOVERARROWSIZE * 2) + ',' + topsign + HOVERARROWSIZE +
	                    'H' + (HOVERTEXTPAD + tbb.width / 2) +
	                    'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
	                    'H-' + halfWidth +
	                    'V' + topsign + HOVERARROWSIZE +
	                    'Z');
	            } else if(lx > (fullLayout.width - halfWidth)) {
	                lx = fullLayout.width - halfWidth;
	
	                lpath.attr('d', 'M' + (halfWidth - HOVERARROWSIZE) + ',0' +
	                    'L' + halfWidth + ',' + topsign + HOVERARROWSIZE +
	                    'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
	                    'H-' + halfWidth +
	                    'V' + topsign + HOVERARROWSIZE +
	                    'H' + (halfWidth - HOVERARROWSIZE * 2) + 'Z');
	            } else {
	                lpath.attr('d', 'M0,0' +
	                    'L' + HOVERARROWSIZE + ',' + topsign + HOVERARROWSIZE +
	                    'H' + (HOVERTEXTPAD + tbb.width / 2) +
	                    'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
	                    'H-' + (HOVERTEXTPAD + tbb.width / 2) +
	                    'V' + topsign + HOVERARROWSIZE +
	                    'H-' + HOVERARROWSIZE + 'Z');
	            }
	        } else {
	            var anchor;
	            var sgn;
	            var leftsign;
	            if(ya.side === 'right') {
	                anchor = 'start';
	                sgn = 1;
	                leftsign = '';
	                lx = xa._offset + xa._length;
	            } else {
	                anchor = 'end';
	                sgn = -1;
	                leftsign = '-';
	                lx = xa._offset;
	            }
	
	            ly = ya._offset + (c0.y0 + c0.y1) / 2;
	
	            ltext.attr('text-anchor', anchor);
	
	            lpath.attr('d', 'M0,0' +
	                'L' + leftsign + HOVERARROWSIZE + ',' + HOVERARROWSIZE +
	                'V' + (HOVERTEXTPAD + tbb.height / 2) +
	                'h' + leftsign + (HOVERTEXTPAD * 2 + tbb.width) +
	                'V-' + (HOVERTEXTPAD + tbb.height / 2) +
	                'H' + leftsign + HOVERARROWSIZE + 'V-' + HOVERARROWSIZE + 'Z');
	
	            var halfHeight = tbb.height / 2;
	            var lty = outerTop - tbb.top - halfHeight;
	            var clipId = 'clip' + fullLayout._uid + 'commonlabel' + ya._id;
	            var clipPath;
	
	            if(lx < (tbb.width + 2 * HOVERTEXTPAD + HOVERARROWSIZE)) {
	                clipPath = 'M-' + (HOVERARROWSIZE + HOVERTEXTPAD) + '-' + halfHeight +
	                    'h-' + (tbb.width - HOVERTEXTPAD) +
	                    'V' + halfHeight +
	                    'h' + (tbb.width - HOVERTEXTPAD) + 'Z';
	
	                var ltx = tbb.width - lx + HOVERTEXTPAD;
	                svgTextUtils.positionText(ltext, ltx, lty);
	
	                // shift each line (except the longest) so that start-of-line
	                // is always visible
	                if(anchor === 'end') {
	                    ltext.selectAll('tspan').each(function() {
	                        var s = d3.select(this);
	                        var dummy = Drawing.tester.append('text')
	                            .text(s.text())
	                            .call(Drawing.font, commonLabelFont);
	                        var dummyBB = dummy.node().getBoundingClientRect();
	                        if(Math.round(dummyBB.width) < Math.round(tbb.width)) {
	                            s.attr('x', ltx - dummyBB.width);
	                        }
	                        dummy.remove();
	                    });
	                }
	            } else {
	                svgTextUtils.positionText(ltext, sgn * (HOVERTEXTPAD + HOVERARROWSIZE), lty);
	                clipPath = null;
	            }
	
	            var textClip = fullLayout._topclips.selectAll('#' + clipId).data(clipPath ? [0] : []);
	            textClip.enter().append('clipPath').attr('id', clipId).append('path');
	            textClip.exit().remove();
	            textClip.select('path').attr('d', clipPath);
	            Drawing.setClipUrl(ltext, clipPath ? clipId : null, gd);
	        }
	
	        label.attr('transform', 'translate(' + lx + ',' + ly + ')');
	
	        // remove the "close but not quite" points
	        // because of error bars, only take up to a space
	        hoverData = hoverData.filter(function(d) {
	            return (d.zLabelVal !== undefined) ||
	                (d[commonAttr] || '').split(' ')[0] === t00;
	        });
	    });
	
	    // show all the individual labels
	
	    // first create the objects
	    var hoverLabels = container.selectAll('g.hovertext')
	        .data(hoverData, function(d) {
	            // N.B. when multiple items have the same result key-function value,
	            // only the first of those items in hoverData gets rendered
	            return [d.trace.index, d.index, d.x0, d.y0, d.name, d.attr, d.xa, d.ya || ''].join(',');
	        });
	    hoverLabels.enter().append('g')
	        .classed('hovertext', true)
	        .each(function() {
	            var g = d3.select(this);
	            // trace name label (rect and text.name)
	            g.append('rect')
	                .call(Color.fill, Color.addOpacity(bgColor, 0.8));
	            g.append('text').classed('name', true);
	            // trace data label (path and text.nums)
	            g.append('path')
	                .style('stroke-width', '1px');
	            g.append('text').classed('nums', true)
	                .call(Drawing.font, fontFamily, fontSize);
	        });
	    hoverLabels.exit().remove();
	
	    // then put the text in, position the pointer to the data,
	    // and figure out sizes
	    hoverLabels.each(function(d) {
	        var g = d3.select(this).attr('transform', '');
	        var name = '';
	        var text = '';
	
	        // combine possible non-opaque trace color with bgColor
	        var color0 = d.bgcolor || d.color;
	        // color for 'nums' part of the label
	        var numsColor = Color.combine(
	            Color.opacity(color0) ? color0 : Color.defaultLine,
	            bgColor
	        );
	        // color for 'name' part of the label
	        var nameColor = Color.combine(
	            Color.opacity(d.color) ? d.color : Color.defaultLine,
	            bgColor
	        );
	        // find a contrasting color for border and text
	        var contrastColor = d.borderColor || Color.contrast(numsColor);
	
	        // to get custom 'name' labels pass cleanPoint
	        if(d.nameOverride !== undefined) d.name = d.nameOverride;
	
	        if(d.name) {
	            if(d.trace._meta) {
	                d.name = Lib.templateString(d.name, d.trace._meta);
	            }
	            name = plainText(d.name, d.nameLength);
	        }
	
	        if(d.zLabel !== undefined) {
	            if(d.xLabel !== undefined) text += 'x: ' + d.xLabel + '<br>';
	            if(d.yLabel !== undefined) text += 'y: ' + d.yLabel + '<br>';
	            if(d.trace.type !== 'choropleth' && d.trace.type !== 'choroplethmapbox') {
	                text += (text ? 'z: ' : '') + d.zLabel;
	            }
	        } else if(showCommonLabel && d[hovermode + 'Label'] === t0) {
	            text = d[(hovermode === 'x' ? 'y' : 'x') + 'Label'] || '';
	        } else if(d.xLabel === undefined) {
	            if(d.yLabel !== undefined && d.trace.type !== 'scattercarpet') {
	                text = d.yLabel;
	            }
	        } else if(d.yLabel === undefined) text = d.xLabel;
	        else text = '(' + d.xLabel + ', ' + d.yLabel + ')';
	
	        if((d.text || d.text === 0) && !Array.isArray(d.text)) {
	            text += (text ? '<br>' : '') + d.text;
	        }
	
	        // used by other modules (initially just ternary) that
	        // manage their own hoverinfo independent of cleanPoint
	        // the rest of this will still apply, so such modules
	        // can still put things in (x|y|z)Label, text, and name
	        // and hoverinfo will still determine their visibility
	        if(d.extraText !== undefined) text += (text ? '<br>' : '') + d.extraText;
	
	        // if 'text' is empty at this point,
	        // and hovertemplate is not defined,
	        // put 'name' in main label and don't show secondary label
	        if(text === '' && !d.hovertemplate) {
	            // if 'name' is also empty, remove entire label
	            if(name === '') g.remove();
	            text = name;
	        }
	
	        // hovertemplate
	        var d3locale = fullLayout._d3locale;
	        var hovertemplate = d.hovertemplate || false;
	        var hovertemplateLabels = d.hovertemplateLabels || d;
	        var eventData = d.eventData[0] || {};
	        if(hovertemplate) {
	            text = Lib.hovertemplateString(
	                hovertemplate,
	                hovertemplateLabels,
	                d3locale,
	                eventData,
	                d.trace._meta
	            );
	
	            text = text.replace(EXTRA_STRING_REGEX, function(match, extra) {
	                // assign name for secondary text label
	                name = plainText(extra, d.nameLength);
	                // remove from main text label
	                return '';
	            });
	        }
	
	        // main label
	        var tx = g.select('text.nums')
	            .call(Drawing.font,
	                d.fontFamily || fontFamily,
	                d.fontSize || fontSize,
	                d.fontColor || contrastColor)
	            .text(text)
	            .attr('data-notex', 1)
	            .call(svgTextUtils.positionText, 0, 0)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        var tx2 = g.select('text.name');
	        var tx2width = 0;
	        var tx2height = 0;
	
	        // secondary label for non-empty 'name'
	        if(name && name !== text) {
	            tx2.call(Drawing.font,
	                    d.fontFamily || fontFamily,
	                    d.fontSize || fontSize,
	                    nameColor)
	                .text(name)
	                .attr('data-notex', 1)
	                .call(svgTextUtils.positionText, 0, 0)
	                .call(svgTextUtils.convertToTspans, gd);
	
	            var t2bb = tx2.node().getBoundingClientRect();
	            tx2width = t2bb.width + 2 * HOVERTEXTPAD;
	            tx2height = t2bb.height + 2 * HOVERTEXTPAD;
	        } else {
	            tx2.remove();
	            g.select('rect').remove();
	        }
	
	        g.select('path').style({
	            fill: numsColor,
	            stroke: contrastColor
	        });
	
	        var tbb = tx.node().getBoundingClientRect();
	        var htx = d.xa._offset + (d.x0 + d.x1) / 2;
	        var hty = d.ya._offset + (d.y0 + d.y1) / 2;
	        var dx = Math.abs(d.x1 - d.x0);
	        var dy = Math.abs(d.y1 - d.y0);
	        var txTotalWidth = tbb.width + HOVERARROWSIZE + HOVERTEXTPAD + tx2width;
	        var anchorStartOK, anchorEndOK;
	
	        d.ty0 = outerTop - tbb.top;
	        d.bx = tbb.width + 2 * HOVERTEXTPAD;
	        d.by = Math.max(tbb.height + 2 * HOVERTEXTPAD, tx2height);
	        d.anchor = 'start';
	        d.txwidth = tbb.width;
	        d.tx2width = tx2width;
	        d.offset = 0;
	
	        if(rotateLabels) {
	            d.pos = htx;
	            anchorStartOK = hty + dy / 2 + txTotalWidth <= outerHeight;
	            anchorEndOK = hty - dy / 2 - txTotalWidth >= 0;
	            if((d.idealAlign === 'top' || !anchorStartOK) && anchorEndOK) {
	                hty -= dy / 2;
	                d.anchor = 'end';
	            } else if(anchorStartOK) {
	                hty += dy / 2;
	                d.anchor = 'start';
	            } else d.anchor = 'middle';
	        } else {
	            d.pos = hty;
	            anchorStartOK = htx + dx / 2 + txTotalWidth <= outerWidth;
	            anchorEndOK = htx - dx / 2 - txTotalWidth >= 0;
	
	            if((d.idealAlign === 'left' || !anchorStartOK) && anchorEndOK) {
	                htx -= dx / 2;
	                d.anchor = 'end';
	            } else if(anchorStartOK) {
	                htx += dx / 2;
	                d.anchor = 'start';
	            } else {
	                d.anchor = 'middle';
	
	                var txHalfWidth = txTotalWidth / 2;
	                var overflowR = htx + txHalfWidth - outerWidth;
	                var overflowL = htx - txHalfWidth;
	                if(overflowR > 0) htx -= overflowR;
	                if(overflowL < 0) htx += -overflowL;
	            }
	        }
	
	        tx.attr('text-anchor', d.anchor);
	        if(tx2width) tx2.attr('text-anchor', d.anchor);
	        g.attr('transform', 'translate(' + htx + ',' + hty + ')' +
	            (rotateLabels ? 'rotate(' + YANGLE + ')' : ''));
	    });
	
	    return hoverLabels;
	}
	
	// Make groups of touching points, and within each group
	// move each point so that no labels overlap, but the average
	// label position is the same as it was before moving. Indicentally,
	// this is equivalent to saying all the labels are on equal linear
	// springs about their initial position. Initially, each point is
	// its own group, but as we find overlaps we will clump the points.
	//
	// Also, there are hard constraints at the edges of the graphs,
	// that push all groups to the middle so they are visible. I don't
	// know what happens if the group spans all the way from one edge to
	// the other, though it hardly matters - there's just too much
	// information then.
	function hoverAvoidOverlaps(hoverLabels, axKey, fullLayout) {
	    var nummoves = 0;
	    var axSign = 1;
	    var nLabels = hoverLabels.size();
	
	    // make groups of touching points
	    var pointgroups = new Array(nLabels);
	    var k = 0;
	
	    hoverLabels.each(function(d) {
	        var ax = d[axKey];
	        var axIsX = ax._id.charAt(0) === 'x';
	        var rng = ax.range;
	
	        if(k === 0 && rng && ((rng[0] > rng[1]) !== axIsX)) {
	            axSign = -1;
	        }
	        pointgroups[k++] = [{
	            datum: d,
	            traceIndex: d.trace.index,
	            dp: 0,
	            pos: d.pos,
	            posref: d.posref,
	            size: d.by * (axIsX ? YFACTOR : 1) / 2,
	            pmin: 0,
	            pmax: (axIsX ? fullLayout.width : fullLayout.height)
	        }];
	    });
	
	    pointgroups.sort(function(a, b) {
	        return (a[0].posref - b[0].posref) ||
	            // for equal positions, sort trace indices increasing or decreasing
	            // depending on whether the axis is reversed or not... so stacked
	            // traces will generally keep their order even if one trace adds
	            // nothing to the stack.
	            (axSign * (b[0].traceIndex - a[0].traceIndex));
	    });
	
	    var donepositioning, topOverlap, bottomOverlap, i, j, pti, sumdp;
	
	    function constrainGroup(grp) {
	        var minPt = grp[0];
	        var maxPt = grp[grp.length - 1];
	
	        // overlap with the top - positive vals are overlaps
	        topOverlap = minPt.pmin - minPt.pos - minPt.dp + minPt.size;
	
	        // overlap with the bottom - positive vals are overlaps
	        bottomOverlap = maxPt.pos + maxPt.dp + maxPt.size - minPt.pmax;
	
	        // check for min overlap first, so that we always
	        // see the largest labels
	        // allow for .01px overlap, so we don't get an
	        // infinite loop from rounding errors
	        if(topOverlap > 0.01) {
	            for(j = grp.length - 1; j >= 0; j--) grp[j].dp += topOverlap;
	            donepositioning = false;
	        }
	        if(bottomOverlap < 0.01) return;
	        if(topOverlap < -0.01) {
	            // make sure we're not pushing back and forth
	            for(j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
	            donepositioning = false;
	        }
	        if(!donepositioning) return;
	
	        // no room to fix positioning, delete off-screen points
	
	        // first see how many points we need to delete
	        var deleteCount = 0;
	        for(i = 0; i < grp.length; i++) {
	            pti = grp[i];
	            if(pti.pos + pti.dp + pti.size > minPt.pmax) deleteCount++;
	        }
	
	        // start by deleting points whose data is off screen
	        for(i = grp.length - 1; i >= 0; i--) {
	            if(deleteCount <= 0) break;
	            pti = grp[i];
	
	            // pos has already been constrained to [pmin,pmax]
	            // so look for points close to that to delete
	            if(pti.pos > minPt.pmax - 1) {
	                pti.del = true;
	                deleteCount--;
	            }
	        }
	        for(i = 0; i < grp.length; i++) {
	            if(deleteCount <= 0) break;
	            pti = grp[i];
	
	            // pos has already been constrained to [pmin,pmax]
	            // so look for points close to that to delete
	            if(pti.pos < minPt.pmin + 1) {
	                pti.del = true;
	                deleteCount--;
	
	                // shift the whole group minus into this new space
	                bottomOverlap = pti.size * 2;
	                for(j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
	            }
	        }
	        // then delete points that go off the bottom
	        for(i = grp.length - 1; i >= 0; i--) {
	            if(deleteCount <= 0) break;
	            pti = grp[i];
	            if(pti.pos + pti.dp + pti.size > minPt.pmax) {
	                pti.del = true;
	                deleteCount--;
	            }
	        }
	    }
	
	    // loop through groups, combining them if they overlap,
	    // until nothing moves
	    while(!donepositioning && nummoves <= nLabels) {
	        // to avoid infinite loops, don't move more times
	        // than there are traces
	        nummoves++;
	
	        // assume nothing will move in this iteration,
	        // reverse this if it does
	        donepositioning = true;
	        i = 0;
	        while(i < pointgroups.length - 1) {
	            // the higher (g0) and lower (g1) point group
	            var g0 = pointgroups[i];
	            var g1 = pointgroups[i + 1];
	
	            // the lowest point in the higher group (p0)
	            // the highest point in the lower group (p1)
	            var p0 = g0[g0.length - 1];
	            var p1 = g1[0];
	            topOverlap = p0.pos + p0.dp + p0.size - p1.pos - p1.dp + p1.size;
	
	            // Only group points that lie on the same axes
	            if(topOverlap > 0.01 && (p0.pmin === p1.pmin) && (p0.pmax === p1.pmax)) {
	                // push the new point(s) added to this group out of the way
	                for(j = g1.length - 1; j >= 0; j--) g1[j].dp += topOverlap;
	
	                // add them to the group
	                g0.push.apply(g0, g1);
	                pointgroups.splice(i + 1, 1);
	
	                // adjust for minimum average movement
	                sumdp = 0;
	                for(j = g0.length - 1; j >= 0; j--) sumdp += g0[j].dp;
	                bottomOverlap = sumdp / g0.length;
	                for(j = g0.length - 1; j >= 0; j--) g0[j].dp -= bottomOverlap;
	                donepositioning = false;
	            } else i++;
	        }
	
	        // check if we're going off the plot on either side and fix
	        pointgroups.forEach(constrainGroup);
	    }
	
	    // now put these offsets into hoverData
	    for(i = pointgroups.length - 1; i >= 0; i--) {
	        var grp = pointgroups[i];
	        for(j = grp.length - 1; j >= 0; j--) {
	            var pt = grp[j];
	            var hoverPt = pt.datum;
	            hoverPt.offset = pt.dp;
	            hoverPt.del = pt.del;
	        }
	    }
	}
	
	function alignHoverText(hoverLabels, rotateLabels) {
	    // finally set the text positioning relative to the data and draw the
	    // box around it
	    hoverLabels.each(function(d) {
	        var g = d3.select(this);
	        if(d.del) return g.remove();
	
	        var tx = g.select('text.nums');
	        var anchor = d.anchor;
	        var horzSign = anchor === 'end' ? -1 : 1;
	        var alignShift = {start: 1, end: -1, middle: 0}[anchor];
	        var txx = alignShift * (HOVERARROWSIZE + HOVERTEXTPAD);
	        var tx2x = txx + alignShift * (d.txwidth + HOVERTEXTPAD);
	        var offsetX = 0;
	        var offsetY = d.offset;
	
	        if(anchor === 'middle') {
	            txx -= d.tx2width / 2;
	            tx2x += d.txwidth / 2 + HOVERTEXTPAD;
	        }
	        if(rotateLabels) {
	            offsetY *= -YSHIFTY;
	            offsetX = d.offset * YSHIFTX;
	        }
	
	        g.select('path').attr('d', anchor === 'middle' ?
	            // middle aligned: rect centered on data
	            ('M-' + (d.bx / 2 + d.tx2width / 2) + ',' + (offsetY - d.by / 2) +
	              'h' + d.bx + 'v' + d.by + 'h-' + d.bx + 'Z') :
	            // left or right aligned: side rect with arrow to data
	            ('M0,0L' + (horzSign * HOVERARROWSIZE + offsetX) + ',' + (HOVERARROWSIZE + offsetY) +
	                'v' + (d.by / 2 - HOVERARROWSIZE) +
	                'h' + (horzSign * d.bx) +
	                'v-' + d.by +
	                'H' + (horzSign * HOVERARROWSIZE + offsetX) +
	                'V' + (offsetY - HOVERARROWSIZE) +
	                'Z'));
	
	        var posX = txx + offsetX;
	        var posY = offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD;
	        var textAlign = d.textAlign || 'auto';
	
	        if(textAlign !== 'auto') {
	            if(textAlign === 'left' && anchor !== 'start') {
	                tx.attr('text-anchor', 'start');
	                posX = anchor === 'middle' ?
	                    -d.bx / 2 - d.tx2width / 2 + HOVERTEXTPAD :
	                    -d.bx - HOVERTEXTPAD;
	            } else if(textAlign === 'right' && anchor !== 'end') {
	                tx.attr('text-anchor', 'end');
	                posX = anchor === 'middle' ?
	                    d.bx / 2 - d.tx2width / 2 - HOVERTEXTPAD :
	                    d.bx + HOVERTEXTPAD;
	            }
	        }
	
	        tx.call(svgTextUtils.positionText, posX, posY);
	
	        if(d.tx2width) {
	            g.select('text.name')
	                .call(svgTextUtils.positionText,
	                    tx2x + alignShift * HOVERTEXTPAD + offsetX,
	                    offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD);
	            g.select('rect')
	                .call(Drawing.setRect,
	                    tx2x + (alignShift - 1) * d.tx2width / 2 + offsetX,
	                    offsetY - d.by / 2 - 1,
	                    d.tx2width, d.by + 2);
	        }
	    });
	}
	
	function cleanPoint(d, hovermode) {
	    var index = d.index;
	    var trace = d.trace || {};
	    var cd0 = d.cd[0];
	    var cd = d.cd[index] || {};
	
	    function pass(v) {
	        return v || (isNumeric(v) && v === 0);
	    }
	
	    var getVal = Array.isArray(index) ?
	        function(calcKey, traceKey) {
	            var v = Lib.castOption(cd0, index, calcKey);
	            return pass(v) ? v : Lib.extractOption({}, trace, '', traceKey);
	        } :
	        function(calcKey, traceKey) {
	            return Lib.extractOption(cd, trace, calcKey, traceKey);
	        };
	
	    function fill(key, calcKey, traceKey) {
	        var val = getVal(calcKey, traceKey);
	        if(pass(val)) d[key] = val;
	    }
	
	    fill('hoverinfo', 'hi', 'hoverinfo');
	    fill('bgcolor', 'hbg', 'hoverlabel.bgcolor');
	    fill('borderColor', 'hbc', 'hoverlabel.bordercolor');
	    fill('fontFamily', 'htf', 'hoverlabel.font.family');
	    fill('fontSize', 'hts', 'hoverlabel.font.size');
	    fill('fontColor', 'htc', 'hoverlabel.font.color');
	    fill('nameLength', 'hnl', 'hoverlabel.namelength');
	    fill('textAlign', 'hta', 'hoverlabel.align');
	
	    d.posref = (hovermode === 'y' || (hovermode === 'closest' && trace.orientation === 'h')) ?
	        (d.xa._offset + (d.x0 + d.x1) / 2) :
	        (d.ya._offset + (d.y0 + d.y1) / 2);
	
	    // then constrain all the positions to be on the plot
	    d.x0 = Lib.constrain(d.x0, 0, d.xa._length);
	    d.x1 = Lib.constrain(d.x1, 0, d.xa._length);
	    d.y0 = Lib.constrain(d.y0, 0, d.ya._length);
	    d.y1 = Lib.constrain(d.y1, 0, d.ya._length);
	
	    // and convert the x and y label values into formatted text
	    if(d.xLabelVal !== undefined) {
	        d.xLabel = ('xLabel' in d) ? d.xLabel : Axes.hoverLabelText(d.xa, d.xLabelVal);
	        d.xVal = d.xa.c2d(d.xLabelVal);
	    }
	    if(d.yLabelVal !== undefined) {
	        d.yLabel = ('yLabel' in d) ? d.yLabel : Axes.hoverLabelText(d.ya, d.yLabelVal);
	        d.yVal = d.ya.c2d(d.yLabelVal);
	    }
	
	    // Traces like heatmaps generate the zLabel in their hoverPoints function
	    if(d.zLabelVal !== undefined && d.zLabel === undefined) {
	        d.zLabel = String(d.zLabelVal);
	    }
	
	    // for box means and error bars, add the range to the label
	    if(!isNaN(d.xerr) && !(d.xa.type === 'log' && d.xerr <= 0)) {
	        var xeText = Axes.tickText(d.xa, d.xa.c2l(d.xerr), 'hover').text;
	        if(d.xerrneg !== undefined) {
	            d.xLabel += ' +' + xeText + ' / -' +
	                Axes.tickText(d.xa, d.xa.c2l(d.xerrneg), 'hover').text;
	        } else d.xLabel += ' ± ' + xeText;
	
	        // small distance penalty for error bars, so that if there are
	        // traces with errors and some without, the error bar label will
	        // hoist up to the point
	        if(hovermode === 'x') d.distance += 1;
	    }
	    if(!isNaN(d.yerr) && !(d.ya.type === 'log' && d.yerr <= 0)) {
	        var yeText = Axes.tickText(d.ya, d.ya.c2l(d.yerr), 'hover').text;
	        if(d.yerrneg !== undefined) {
	            d.yLabel += ' +' + yeText + ' / -' +
	                Axes.tickText(d.ya, d.ya.c2l(d.yerrneg), 'hover').text;
	        } else d.yLabel += ' ± ' + yeText;
	
	        if(hovermode === 'y') d.distance += 1;
	    }
	
	    var infomode = d.hoverinfo || d.trace.hoverinfo;
	
	    if(infomode && infomode !== 'all') {
	        infomode = Array.isArray(infomode) ? infomode : infomode.split('+');
	        if(infomode.indexOf('x') === -1) d.xLabel = undefined;
	        if(infomode.indexOf('y') === -1) d.yLabel = undefined;
	        if(infomode.indexOf('z') === -1) d.zLabel = undefined;
	        if(infomode.indexOf('text') === -1) d.text = undefined;
	        if(infomode.indexOf('name') === -1) d.name = undefined;
	    }
	
	    return d;
	}
	
	function createSpikelines(gd, closestPoints, opts) {
	    var container = opts.container;
	    var fullLayout = opts.fullLayout;
	    var gs = fullLayout._size;
	    var evt = opts.event;
	    var showY = !!closestPoints.hLinePoint;
	    var showX = !!closestPoints.vLinePoint;
	
	    var xa, ya;
	
	    // Remove old spikeline items
	    container.selectAll('.spikeline').remove();
	
	    if(!(showX || showY)) return;
	
	    var contrastColor = Color.combine(fullLayout.plot_bgcolor, fullLayout.paper_bgcolor);
	
	    // Horizontal line (to y-axis)
	    if(showY) {
	        var hLinePoint = closestPoints.hLinePoint;
	        var hLinePointX, hLinePointY;
	
	        xa = hLinePoint && hLinePoint.xa;
	        ya = hLinePoint && hLinePoint.ya;
	        var ySnap = ya.spikesnap;
	
	        if(ySnap === 'cursor') {
	            hLinePointX = evt.pointerX;
	            hLinePointY = evt.pointerY;
	        } else {
	            hLinePointX = xa._offset + hLinePoint.x;
	            hLinePointY = ya._offset + hLinePoint.y;
	        }
	        var dfltHLineColor = tinycolor.readability(hLinePoint.color, contrastColor) < 1.5 ?
	            Color.contrast(contrastColor) : hLinePoint.color;
	        var yMode = ya.spikemode;
	        var yThickness = ya.spikethickness;
	        var yColor = ya.spikecolor || dfltHLineColor;
	        var xEdge = Axes.getPxPosition(gd, ya);
	        var xBase, xEndSpike;
	
	        if(yMode.indexOf('toaxis') !== -1 || yMode.indexOf('across') !== -1) {
	            if(yMode.indexOf('toaxis') !== -1) {
	                xBase = xEdge;
	                xEndSpike = hLinePointX;
	            }
	            if(yMode.indexOf('across') !== -1) {
	                var xAcross0 = ya._counterDomainMin;
	                var xAcross1 = ya._counterDomainMax;
	                if(ya.anchor === 'free') {
	                    xAcross0 = Math.min(xAcross0, ya.position);
	                    xAcross1 = Math.max(xAcross1, ya.position);
	                }
	                xBase = gs.l + xAcross0 * gs.w;
	                xEndSpike = gs.l + xAcross1 * gs.w;
	            }
	
	            // Foreground horizontal line (to y-axis)
	            container.insert('line', ':first-child')
	                .attr({
	                    x1: xBase,
	                    x2: xEndSpike,
	                    y1: hLinePointY,
	                    y2: hLinePointY,
	                    'stroke-width': yThickness,
	                    stroke: yColor,
	                    'stroke-dasharray': Drawing.dashStyle(ya.spikedash, yThickness)
	                })
	                .classed('spikeline', true)
	                .classed('crisp', true);
	
	            // Background horizontal Line (to y-axis)
	            container.insert('line', ':first-child')
	                .attr({
	                    x1: xBase,
	                    x2: xEndSpike,
	                    y1: hLinePointY,
	                    y2: hLinePointY,
	                    'stroke-width': yThickness + 2,
	                    stroke: contrastColor
	                })
	                .classed('spikeline', true)
	                .classed('crisp', true);
	        }
	        // Y axis marker
	        if(yMode.indexOf('marker') !== -1) {
	            container.insert('circle', ':first-child')
	                .attr({
	                    cx: xEdge + (ya.side !== 'right' ? yThickness : -yThickness),
	                    cy: hLinePointY,
	                    r: yThickness,
	                    fill: yColor
	                })
	                .classed('spikeline', true);
	        }
	    }
	
	    if(showX) {
	        var vLinePoint = closestPoints.vLinePoint;
	        var vLinePointX, vLinePointY;
	
	        xa = vLinePoint && vLinePoint.xa;
	        ya = vLinePoint && vLinePoint.ya;
	        var xSnap = xa.spikesnap;
	
	        if(xSnap === 'cursor') {
	            vLinePointX = evt.pointerX;
	            vLinePointY = evt.pointerY;
	        } else {
	            vLinePointX = xa._offset + vLinePoint.x;
	            vLinePointY = ya._offset + vLinePoint.y;
	        }
	        var dfltVLineColor = tinycolor.readability(vLinePoint.color, contrastColor) < 1.5 ?
	            Color.contrast(contrastColor) : vLinePoint.color;
	        var xMode = xa.spikemode;
	        var xThickness = xa.spikethickness;
	        var xColor = xa.spikecolor || dfltVLineColor;
	        var yEdge = Axes.getPxPosition(gd, xa);
	        var yBase, yEndSpike;
	
	        if(xMode.indexOf('toaxis') !== -1 || xMode.indexOf('across') !== -1) {
	            if(xMode.indexOf('toaxis') !== -1) {
	                yBase = yEdge;
	                yEndSpike = vLinePointY;
	            }
	            if(xMode.indexOf('across') !== -1) {
	                var yAcross0 = xa._counterDomainMin;
	                var yAcross1 = xa._counterDomainMax;
	                if(xa.anchor === 'free') {
	                    yAcross0 = Math.min(yAcross0, xa.position);
	                    yAcross1 = Math.max(yAcross1, xa.position);
	                }
	                yBase = gs.t + (1 - yAcross1) * gs.h;
	                yEndSpike = gs.t + (1 - yAcross0) * gs.h;
	            }
	
	            // Foreground vertical line (to x-axis)
	            container.insert('line', ':first-child')
	                .attr({
	                    x1: vLinePointX,
	                    x2: vLinePointX,
	                    y1: yBase,
	                    y2: yEndSpike,
	                    'stroke-width': xThickness,
	                    stroke: xColor,
	                    'stroke-dasharray': Drawing.dashStyle(xa.spikedash, xThickness)
	                })
	                .classed('spikeline', true)
	                .classed('crisp', true);
	
	            // Background vertical line (to x-axis)
	            container.insert('line', ':first-child')
	                .attr({
	                    x1: vLinePointX,
	                    x2: vLinePointX,
	                    y1: yBase,
	                    y2: yEndSpike,
	                    'stroke-width': xThickness + 2,
	                    stroke: contrastColor
	                })
	                .classed('spikeline', true)
	                .classed('crisp', true);
	        }
	
	        // X axis marker
	        if(xMode.indexOf('marker') !== -1) {
	            container.insert('circle', ':first-child')
	                .attr({
	                    cx: vLinePointX,
	                    cy: yEdge - (xa.side !== 'top' ? xThickness : -xThickness),
	                    r: xThickness,
	                    fill: xColor
	                })
	                .classed('spikeline', true);
	        }
	    }
	}
	
	function hoverChanged(gd, evt, oldhoverdata) {
	    // don't emit any events if nothing changed
	    if(!oldhoverdata || oldhoverdata.length !== gd._hoverdata.length) return true;
	
	    for(var i = oldhoverdata.length - 1; i >= 0; i--) {
	        var oldPt = oldhoverdata[i];
	        var newPt = gd._hoverdata[i];
	
	        if(oldPt.curveNumber !== newPt.curveNumber ||
	            String(oldPt.pointNumber) !== String(newPt.pointNumber) ||
	            String(oldPt.pointNumbers) !== String(newPt.pointNumbers)
	        ) {
	            return true;
	        }
	    }
	    return false;
	}
	
	function spikesChanged(gd, oldspikepoints) {
	    // don't relayout the plot because of new spikelines if spikelines points didn't change
	    if(!oldspikepoints) return true;
	    if(oldspikepoints.vLinePoint !== gd._spikepoints.vLinePoint ||
	        oldspikepoints.hLinePoint !== gd._spikepoints.hLinePoint
	    ) return true;
	    return false;
	}
	
	function plainText(s, len) {
	    return svgTextUtils.plainText(s || '', {
	        len: len,
	        allowedTags: ['br', 'sub', 'sup', 'b', 'i', 'em']
	    });
	}
	
	},{"../../lib":716,"../../lib/events":706,"../../lib/override_cursor":727,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"../../registry":845,"../color":591,"../dragelement":609,"../drawing":612,"./constants":624,"./helpers":626,"d3":164,"fast-isnumeric":227,"tinycolor2":535}],628:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	module.exports = function handleHoverLabelDefaults(contIn, contOut, coerce, opts) {
	    opts = opts || {};
	
	    coerce('hoverlabel.bgcolor', opts.bgcolor);
	    coerce('hoverlabel.bordercolor', opts.bordercolor);
	    coerce('hoverlabel.namelength', opts.namelength);
	    Lib.coerceFont(coerce, 'hoverlabel.font', opts.font);
	    coerce('hoverlabel.align', opts.align);
	};
	
	},{"../../lib":716}],629:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var dragElement = _dereq_('../dragelement');
	var helpers = _dereq_('./helpers');
	var layoutAttributes = _dereq_('./layout_attributes');
	var hoverModule = _dereq_('./hover');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'fx',
	
	    constants: _dereq_('./constants'),
	    schema: {
	        layout: layoutAttributes
	    },
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: layoutAttributes,
	
	    supplyLayoutGlobalDefaults: _dereq_('./layout_global_defaults'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	
	    calc: _dereq_('./calc'),
	
	    getDistanceFunction: helpers.getDistanceFunction,
	    getClosest: helpers.getClosest,
	    inbox: helpers.inbox,
	    quadrature: helpers.quadrature,
	    appendArrayPointValue: helpers.appendArrayPointValue,
	
	    castHoverOption: castHoverOption,
	    castHoverinfo: castHoverinfo,
	
	    hover: hoverModule.hover,
	    unhover: dragElement.unhover,
	
	    loneHover: hoverModule.loneHover,
	    loneUnhover: loneUnhover,
	
	    click: _dereq_('./click')
	};
	
	function loneUnhover(containerOrSelection) {
	    // duck type whether the arg is a d3 selection because ie9 doesn't
	    // handle instanceof like modern browsers do.
	    var selection = Lib.isD3Selection(containerOrSelection) ?
	            containerOrSelection :
	            d3.select(containerOrSelection);
	
	    selection.selectAll('g.hovertext').remove();
	    selection.selectAll('.spikeline').remove();
	}
	
	// helpers for traces that use Fx.loneHover
	
	function castHoverOption(trace, ptNumber, attr) {
	    return Lib.castOption(trace, ptNumber, 'hoverlabel.' + attr);
	}
	
	function castHoverinfo(trace, fullLayout, ptNumber) {
	    function _coerce(val) {
	        return Lib.coerceHoverinfo({hoverinfo: val}, {_module: trace._module}, fullLayout);
	    }
	
	    return Lib.castOption(trace, ptNumber, 'hoverinfo', _coerce);
	}
	
	},{"../../lib":716,"../dragelement":609,"./attributes":621,"./calc":622,"./click":623,"./constants":624,"./defaults":625,"./helpers":626,"./hover":627,"./layout_attributes":630,"./layout_defaults":631,"./layout_global_defaults":632,"d3":164}],630:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var constants = _dereq_('./constants');
	
	var fontAttrs = _dereq_('../../plots/font_attributes')({
	    editType: 'none',
	    
	});
	fontAttrs.family.dflt = constants.HOVERFONT;
	fontAttrs.size.dflt = constants.HOVERFONTSIZE;
	
	module.exports = {
	    clickmode: {
	        valType: 'flaglist',
	        
	        flags: ['event', 'select'],
	        dflt: 'event',
	        editType: 'plot',
	        extras: ['none'],
	        
	    },
	    dragmode: {
	        valType: 'enumerated',
	        
	        values: ['zoom', 'pan', 'select', 'lasso', 'orbit', 'turntable', false],
	        dflt: 'zoom',
	        editType: 'modebar',
	        
	    },
	    hovermode: {
	        valType: 'enumerated',
	        
	        values: ['x', 'y', 'closest', false],
	        editType: 'modebar',
	        
	    },
	    hoverdistance: {
	        valType: 'integer',
	        min: -1,
	        dflt: 20,
	        
	        editType: 'none',
	        
	    },
	    spikedistance: {
	        valType: 'integer',
	        min: -1,
	        dflt: 20,
	        
	        editType: 'none',
	        
	    },
	    hoverlabel: {
	        bgcolor: {
	            valType: 'color',
	            
	            editType: 'none',
	            
	        },
	        bordercolor: {
	            valType: 'color',
	            
	            editType: 'none',
	            
	        },
	        font: fontAttrs,
	        align: {
	            valType: 'enumerated',
	            values: ['left', 'right', 'auto'],
	            dflt: 'auto',
	            
	            editType: 'none',
	            
	        },
	        namelength: {
	            valType: 'integer',
	            min: -1,
	            dflt: 15,
	            
	            editType: 'none',
	            
	        },
	        editType: 'none'
	    },
	    selectdirection: {
	        valType: 'enumerated',
	        
	        values: ['h', 'v', 'd', 'any'],
	        dflt: 'any',
	        
	        editType: 'none'
	    }
	};
	
	},{"../../plots/font_attributes":790,"./constants":624}],631:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    var clickmode = coerce('clickmode');
	
	    var dragMode = coerce('dragmode');
	    if(dragMode === 'select') coerce('selectdirection');
	
	    var hovermodeDflt;
	    if(layoutOut._has('cartesian')) {
	        if(clickmode.indexOf('select') > -1) {
	            hovermodeDflt = 'closest';
	        } else {
	            // flag for 'horizontal' plots:
	            // determines the state of the mode bar 'compare' hovermode button
	            layoutOut._isHoriz = isHoriz(fullData, layoutOut);
	            hovermodeDflt = layoutOut._isHoriz ? 'y' : 'x';
	        }
	    } else hovermodeDflt = 'closest';
	
	    var hoverMode = coerce('hovermode', hovermodeDflt);
	    if(hoverMode) {
	        coerce('hoverdistance');
	        coerce('spikedistance');
	    }
	
	    // if only mapbox or geo subplots is present on graph,
	    // reset 'zoom' dragmode to 'pan' until 'zoom' is implemented,
	    // so that the correct modebar button is active
	    var hasMapbox = layoutOut._has('mapbox');
	    var hasGeo = layoutOut._has('geo');
	    var len = layoutOut._basePlotModules.length;
	
	    if(layoutOut.dragmode === 'zoom' && (
	        ((hasMapbox || hasGeo) && len === 1) ||
	        (hasMapbox && hasGeo && len === 2)
	    )) {
	        layoutOut.dragmode = 'pan';
	    }
	};
	
	function isHoriz(fullData, fullLayout) {
	    var stackOpts = fullLayout._scatterStackOpts || {};
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	        var subplot = trace.xaxis + trace.yaxis;
	        var subplotStackOpts = stackOpts[subplot] || {};
	        var groupOpts = subplotStackOpts[trace.stackgroup] || {};
	
	        if(trace.orientation !== 'h' && groupOpts.orientation !== 'h') {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	},{"../../lib":716,"./layout_attributes":630}],632:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleHoverLabelDefaults = _dereq_('./hoverlabel_defaults');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutGlobalDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
	};
	
	},{"../../lib":716,"./hoverlabel_defaults":628,"./layout_attributes":630}],633:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var counterRegex = _dereq_('../../lib/regex').counter;
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var cartesianIdRegex = _dereq_('../../plots/cartesian/constants').idRegex;
	var Template = _dereq_('../../plot_api/plot_template');
	
	var gridAttrs = {
	    rows: {
	        valType: 'integer',
	        min: 1,
	        
	        editType: 'plot',
	        
	    },
	    roworder: {
	        valType: 'enumerated',
	        values: ['top to bottom', 'bottom to top'],
	        dflt: 'top to bottom',
	        
	        editType: 'plot',
	        
	    },
	    columns: {
	        valType: 'integer',
	        min: 1,
	        
	        editType: 'plot',
	        
	    },
	    subplots: {
	        valType: 'info_array',
	        freeLength: true,
	        dimensions: 2,
	        items: {valType: 'enumerated', values: [counterRegex('xy').toString(), ''], editType: 'plot'},
	        
	        editType: 'plot',
	        
	    },
	    xaxes: {
	        valType: 'info_array',
	        freeLength: true,
	        items: {valType: 'enumerated', values: [cartesianIdRegex.x.toString(), ''], editType: 'plot'},
	        
	        editType: 'plot',
	        
	    },
	    yaxes: {
	        valType: 'info_array',
	        freeLength: true,
	        items: {valType: 'enumerated', values: [cartesianIdRegex.y.toString(), ''], editType: 'plot'},
	        
	        editType: 'plot',
	        
	    },
	    pattern: {
	        valType: 'enumerated',
	        values: ['independent', 'coupled'],
	        dflt: 'coupled',
	        
	        editType: 'plot',
	        
	    },
	    xgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'plot',
	        
	    },
	    ygap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'plot',
	        
	    },
	    domain: domainAttrs({name: 'grid', editType: 'plot', noGridCell: true}, {
	        
	    }),
	    xside: {
	        valType: 'enumerated',
	        values: ['bottom', 'bottom plot', 'top plot', 'top'],
	        dflt: 'bottom plot',
	        
	        editType: 'plot',
	        
	    },
	    yside: {
	        valType: 'enumerated',
	        values: ['left', 'left plot', 'right plot', 'right'],
	        dflt: 'left plot',
	        
	        editType: 'plot',
	        
	    },
	    editType: 'plot'
	};
	
	function getAxes(layout, grid, axLetter) {
	    var gridVal = grid[axLetter + 'axes'];
	    var splomVal = Object.keys((layout._splomAxes || {})[axLetter] || {});
	
	    if(Array.isArray(gridVal)) return gridVal;
	    if(splomVal.length) return splomVal;
	}
	
	// the shape of the grid - this needs to be done BEFORE supplyDataDefaults
	// so that non-subplot traces can place themselves in the grid
	function sizeDefaults(layoutIn, layoutOut) {
	    var gridIn = layoutIn.grid || {};
	    var xAxes = getAxes(layoutOut, gridIn, 'x');
	    var yAxes = getAxes(layoutOut, gridIn, 'y');
	
	    if(!layoutIn.grid && !xAxes && !yAxes) return;
	
	    var hasSubplotGrid = Array.isArray(gridIn.subplots) && Array.isArray(gridIn.subplots[0]);
	    var hasXaxes = Array.isArray(xAxes);
	    var hasYaxes = Array.isArray(yAxes);
	    var isSplomGenerated = (
	        hasXaxes && xAxes !== gridIn.xaxes &&
	        hasYaxes && yAxes !== gridIn.yaxes
	    );
	
	    var dfltRows, dfltColumns;
	
	    if(hasSubplotGrid) {
	        dfltRows = gridIn.subplots.length;
	        dfltColumns = gridIn.subplots[0].length;
	    } else {
	        if(hasYaxes) dfltRows = yAxes.length;
	        if(hasXaxes) dfltColumns = xAxes.length;
	    }
	
	    var gridOut = Template.newContainer(layoutOut, 'grid');
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(gridIn, gridOut, gridAttrs, attr, dflt);
	    }
	
	    var rows = coerce('rows', dfltRows);
	    var columns = coerce('columns', dfltColumns);
	
	    if(!(rows * columns > 1)) {
	        delete layoutOut.grid;
	        return;
	    }
	
	    if(!hasSubplotGrid && !hasXaxes && !hasYaxes) {
	        var useDefaultSubplots = coerce('pattern') === 'independent';
	        if(useDefaultSubplots) hasSubplotGrid = true;
	    }
	    gridOut._hasSubplotGrid = hasSubplotGrid;
	
	    var rowOrder = coerce('roworder');
	    var reversed = rowOrder === 'top to bottom';
	
	    var dfltGapX = hasSubplotGrid ? 0.2 : 0.1;
	    var dfltGapY = hasSubplotGrid ? 0.3 : 0.1;
	
	    var dfltSideX, dfltSideY;
	    if(isSplomGenerated && layoutOut._splomGridDflt) {
	        dfltSideX = layoutOut._splomGridDflt.xside;
	        dfltSideY = layoutOut._splomGridDflt.yside;
	    }
	
	    gridOut._domains = {
	        x: fillGridPositions('x', coerce, dfltGapX, dfltSideX, columns),
	        y: fillGridPositions('y', coerce, dfltGapY, dfltSideY, rows, reversed)
	    };
	}
	
	// coerce x or y sizing attributes and return an array of domains for this direction
	function fillGridPositions(axLetter, coerce, dfltGap, dfltSide, len, reversed) {
	    var dirGap = coerce(axLetter + 'gap', dfltGap);
	    var domain = coerce('domain.' + axLetter);
	    coerce(axLetter + 'side', dfltSide);
	
	    var out = new Array(len);
	    var start = domain[0];
	    var step = (domain[1] - start) / (len - dirGap);
	    var cellDomain = step * (1 - dirGap);
	    for(var i = 0; i < len; i++) {
	        var cellStart = start + step * i;
	        out[reversed ? (len - 1 - i) : i] = [cellStart, cellStart + cellDomain];
	    }
	    return out;
	}
	
	// the (cartesian) contents of the grid - this needs to happen AFTER supplyDataDefaults
	// so that we know what cartesian subplots are available
	function contentDefaults(layoutIn, layoutOut) {
	    var gridOut = layoutOut.grid;
	    // make sure we got to the end of handleGridSizing
	    if(!gridOut || !gridOut._domains) return;
	
	    var gridIn = layoutIn.grid || {};
	    var subplots = layoutOut._subplots;
	    var hasSubplotGrid = gridOut._hasSubplotGrid;
	    var rows = gridOut.rows;
	    var columns = gridOut.columns;
	    var useDefaultSubplots = gridOut.pattern === 'independent';
	
	    var i, j, xId, yId, subplotId, subplotsOut, yPos;
	
	    var axisMap = gridOut._axisMap = {};
	
	    if(hasSubplotGrid) {
	        var subplotsIn = gridIn.subplots || [];
	        subplotsOut = gridOut.subplots = new Array(rows);
	        var index = 1;
	
	        for(i = 0; i < rows; i++) {
	            var rowOut = subplotsOut[i] = new Array(columns);
	            var rowIn = subplotsIn[i] || [];
	            for(j = 0; j < columns; j++) {
	                if(useDefaultSubplots) {
	                    subplotId = (index === 1) ? 'xy' : ('x' + index + 'y' + index);
	                    index++;
	                } else subplotId = rowIn[j];
	
	                rowOut[j] = '';
	
	                if(subplots.cartesian.indexOf(subplotId) !== -1) {
	                    yPos = subplotId.indexOf('y');
	                    xId = subplotId.slice(0, yPos);
	                    yId = subplotId.slice(yPos);
	                    if((axisMap[xId] !== undefined && axisMap[xId] !== j) ||
	                        (axisMap[yId] !== undefined && axisMap[yId] !== i)
	                    ) {
	                        continue;
	                    }
	
	                    rowOut[j] = subplotId;
	                    axisMap[xId] = j;
	                    axisMap[yId] = i;
	                }
	            }
	        }
	    } else {
	        var xAxes = getAxes(layoutOut, gridIn, 'x');
	        var yAxes = getAxes(layoutOut, gridIn, 'y');
	        gridOut.xaxes = fillGridAxes(xAxes, subplots.xaxis, columns, axisMap, 'x');
	        gridOut.yaxes = fillGridAxes(yAxes, subplots.yaxis, rows, axisMap, 'y');
	    }
	
	    var anchors = gridOut._anchors = {};
	    var reversed = gridOut.roworder === 'top to bottom';
	
	    for(var axisId in axisMap) {
	        var axLetter = axisId.charAt(0);
	        var side = gridOut[axLetter + 'side'];
	
	        var i0, inc, iFinal;
	
	        if(side.length < 8) {
	            // grid edge -  ie not "* plot" - make these as free axes
	            // since we're not guaranteed to have a subplot there at all
	            anchors[axisId] = 'free';
	        } else if(axLetter === 'x') {
	            if((side.charAt(0) === 't') === reversed) {
	                i0 = 0;
	                inc = 1;
	                iFinal = rows;
	            } else {
	                i0 = rows - 1;
	                inc = -1;
	                iFinal = -1;
	            }
	            if(hasSubplotGrid) {
	                var column = axisMap[axisId];
	                for(i = i0; i !== iFinal; i += inc) {
	                    subplotId = subplotsOut[i][column];
	                    if(!subplotId) continue;
	                    yPos = subplotId.indexOf('y');
	                    if(subplotId.slice(0, yPos) === axisId) {
	                        anchors[axisId] = subplotId.slice(yPos);
	                        break;
	                    }
	                }
	            } else {
	                for(i = i0; i !== iFinal; i += inc) {
	                    yId = gridOut.yaxes[i];
	                    if(subplots.cartesian.indexOf(axisId + yId) !== -1) {
	                        anchors[axisId] = yId;
	                        break;
	                    }
	                }
	            }
	        } else {
	            if((side.charAt(0) === 'l')) {
	                i0 = 0;
	                inc = 1;
	                iFinal = columns;
	            } else {
	                i0 = columns - 1;
	                inc = -1;
	                iFinal = -1;
	            }
	            if(hasSubplotGrid) {
	                var row = axisMap[axisId];
	                for(i = i0; i !== iFinal; i += inc) {
	                    subplotId = subplotsOut[row][i];
	                    if(!subplotId) continue;
	                    yPos = subplotId.indexOf('y');
	                    if(subplotId.slice(yPos) === axisId) {
	                        anchors[axisId] = subplotId.slice(0, yPos);
	                        break;
	                    }
	                }
	            } else {
	                for(i = i0; i !== iFinal; i += inc) {
	                    xId = gridOut.xaxes[i];
	                    if(subplots.cartesian.indexOf(xId + axisId) !== -1) {
	                        anchors[axisId] = xId;
	                        break;
	                    }
	                }
	            }
	        }
	    }
	}
	
	function fillGridAxes(axesIn, axesAllowed, len, axisMap, axLetter) {
	    var out = new Array(len);
	    var i;
	
	    function fillOneAxis(i, axisId) {
	        if(axesAllowed.indexOf(axisId) !== -1 && axisMap[axisId] === undefined) {
	            out[i] = axisId;
	            axisMap[axisId] = i;
	        } else out[i] = '';
	    }
	
	    if(Array.isArray(axesIn)) {
	        for(i = 0; i < len; i++) {
	            fillOneAxis(i, axesIn[i]);
	        }
	    } else {
	        // default axis list is the first `len` axis ids
	        fillOneAxis(0, axLetter);
	        for(i = 1; i < len; i++) {
	            fillOneAxis(i, axLetter + (i + 1));
	        }
	    }
	
	    return out;
	}
	
	module.exports = {
	    moduleType: 'component',
	    name: 'grid',
	
	    schema: {
	        layout: {grid: gridAttrs}
	    },
	
	    layoutAttributes: gridAttrs,
	    sizeDefaults: sizeDefaults,
	    contentDefaults: contentDefaults
	};
	
	},{"../../lib":716,"../../lib/regex":732,"../../plot_api/plot_template":754,"../../plots/cartesian/constants":770,"../../plots/domain":789}],634:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var cartesianConstants = _dereq_('../../plots/cartesian/constants');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	
	module.exports = templatedArray('image', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'arraydraw',
	        
	    },
	
	    source: {
	        valType: 'string',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    layer: {
	        valType: 'enumerated',
	        values: ['below', 'above'],
	        dflt: 'above',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    sizex: {
	        valType: 'number',
	        
	        dflt: 0,
	        editType: 'arraydraw',
	        
	    },
	
	    sizey: {
	        valType: 'number',
	        
	        dflt: 0,
	        editType: 'arraydraw',
	        
	    },
	
	    sizing: {
	        valType: 'enumerated',
	        values: ['fill', 'contain', 'stretch'],
	        dflt: 'contain',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    opacity: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 1,
	        editType: 'arraydraw',
	        
	    },
	
	    x: {
	        valType: 'any',
	        
	        dflt: 0,
	        editType: 'arraydraw',
	        
	    },
	
	    y: {
	        valType: 'any',
	        
	        dflt: 0,
	        editType: 'arraydraw',
	        
	    },
	
	    xanchor: {
	        valType: 'enumerated',
	        values: ['left', 'center', 'right'],
	        dflt: 'left',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    yanchor: {
	        valType: 'enumerated',
	        values: ['top', 'middle', 'bottom'],
	        dflt: 'top',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    xref: {
	        valType: 'enumerated',
	        values: [
	            'paper',
	            cartesianConstants.idRegex.x.toString()
	        ],
	        dflt: 'paper',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    yref: {
	        valType: 'enumerated',
	        values: [
	            'paper',
	            cartesianConstants.idRegex.y.toString()
	        ],
	        dflt: 'paper',
	        
	        editType: 'arraydraw',
	        
	    },
	    editType: 'arraydraw'
	});
	
	},{"../../plot_api/plot_template":754,"../../plots/cartesian/constants":770}],635:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var toLogRange = _dereq_('../../lib/to_log_range');
	
	/*
	 * convertCoords: when converting an axis between log and linear
	 * you need to alter any images on that axis to keep them
	 * pointing at the same data point.
	 * In v2.0 this will become obsolete (or perhaps size will still need conversion?)
	 * we convert size by declaring that the maximum extent *in data units* should be
	 * the same, assuming the image is anchored by its center (could remove that restriction
	 * if we think it's important) even though the actual left and right values will not be
	 * quite the same since the scale becomes nonlinear (and central anchor means the pixel
	 * center of the image, not the data units center)
	 *
	 * gd: the plot div
	 * ax: the axis being changed
	 * newType: the type it's getting
	 * doExtra: function(attr, val) from inside relayout that sets the attribute.
	 *     Use this to make the changes as it's aware if any other changes in the
	 *     same relayout call should override this conversion.
	 */
	module.exports = function convertCoords(gd, ax, newType, doExtra) {
	    ax = ax || {};
	
	    var toLog = (newType === 'log') && (ax.type === 'linear');
	    var fromLog = (newType === 'linear') && (ax.type === 'log');
	
	    if(!(toLog || fromLog)) return;
	
	    var images = gd._fullLayout.images;
	    var axLetter = ax._id.charAt(0);
	    var image;
	    var attrPrefix;
	
	    for(var i = 0; i < images.length; i++) {
	        image = images[i];
	        attrPrefix = 'images[' + i + '].';
	
	        if(image[axLetter + 'ref'] === ax._id) {
	            var currentPos = image[axLetter];
	            var currentSize = image['size' + axLetter];
	            var newPos = null;
	            var newSize = null;
	
	            if(toLog) {
	                newPos = toLogRange(currentPos, ax.range);
	
	                // this is the inverse of the conversion we do in fromLog below
	                // so that the conversion is reversible (notice the fromLog conversion
	                // is like sinh, and this one looks like arcsinh)
	                var dx = currentSize / Math.pow(10, newPos) / 2;
	                newSize = 2 * Math.log(dx + Math.sqrt(1 + dx * dx)) / Math.LN10;
	            } else {
	                newPos = Math.pow(10, currentPos);
	                newSize = newPos * (Math.pow(10, currentSize / 2) - Math.pow(10, -currentSize / 2));
	            }
	
	            // if conversion failed, delete the value so it can get a default later on
	            if(!isNumeric(newPos)) {
	                newPos = null;
	                newSize = null;
	            } else if(!isNumeric(newSize)) newSize = null;
	
	            doExtra(attrPrefix + axLetter, newPos);
	            doExtra(attrPrefix + 'size' + axLetter, newSize);
	        }
	    }
	};
	
	},{"../../lib/to_log_range":742,"fast-isnumeric":227}],636:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var name = 'images';
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    var opts = {
	        name: name,
	        handleItemDefaults: imageDefaults
	    };
	
	    handleArrayContainerDefaults(layoutIn, layoutOut, opts);
	};
	
	
	function imageDefaults(imageIn, imageOut, fullLayout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(imageIn, imageOut, attributes, attr, dflt);
	    }
	
	    var source = coerce('source');
	    var visible = coerce('visible', !!source);
	
	    if(!visible) return imageOut;
	
	    coerce('layer');
	    coerce('xanchor');
	    coerce('yanchor');
	    coerce('sizex');
	    coerce('sizey');
	    coerce('sizing');
	    coerce('opacity');
	
	    var gdMock = { _fullLayout: fullLayout };
	    var axLetters = ['x', 'y'];
	
	    for(var i = 0; i < 2; i++) {
	        // 'paper' is the fallback axref
	        var axLetter = axLetters[i];
	        var axRef = Axes.coerceRef(imageIn, imageOut, gdMock, axLetter, 'paper');
	
	        if(axRef !== 'paper') {
	            var ax = Axes.getFromId(gdMock, axRef);
	            ax._imgIndices.push(imageOut._index);
	        }
	
	        Axes.coercePosition(imageOut, gdMock, coerce, axRef, axLetter, 0);
	    }
	
	    return imageOut;
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/cartesian/axes":764,"./attributes":634}],637:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../drawing');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	
	module.exports = function draw(gd) {
	    var fullLayout = gd._fullLayout;
	    var imageDataAbove = [];
	    var imageDataSubplot = {};
	    var imageDataBelow = [];
	    var subplot;
	    var i;
	
	    // Sort into top, subplot, and bottom layers
	    for(i = 0; i < fullLayout.images.length; i++) {
	        var img = fullLayout.images[i];
	
	        if(img.visible) {
	            if(img.layer === 'below' && img.xref !== 'paper' && img.yref !== 'paper') {
	                subplot = img.xref + img.yref;
	
	                var plotinfo = fullLayout._plots[subplot];
	
	                if(!plotinfo) {
	                    // Fall back to _imageLowerLayer in case the requested subplot doesn't exist.
	                    // This can happen if you reference the image to an x / y axis combination
	                    // that doesn't have any data on it (and layer is below)
	                    imageDataBelow.push(img);
	                    continue;
	                }
	
	                if(plotinfo.mainplot) {
	                    subplot = plotinfo.mainplot.id;
	                }
	
	                if(!imageDataSubplot[subplot]) {
	                    imageDataSubplot[subplot] = [];
	                }
	                imageDataSubplot[subplot].push(img);
	            } else if(img.layer === 'above') {
	                imageDataAbove.push(img);
	            } else {
	                imageDataBelow.push(img);
	            }
	        }
	    }
	
	
	    var anchors = {
	        x: {
	            left: { sizing: 'xMin', offset: 0 },
	            center: { sizing: 'xMid', offset: -1 / 2 },
	            right: { sizing: 'xMax', offset: -1 }
	        },
	        y: {
	            top: { sizing: 'YMin', offset: 0 },
	            middle: { sizing: 'YMid', offset: -1 / 2 },
	            bottom: { sizing: 'YMax', offset: -1 }
	        }
	    };
	
	
	    // Images must be converted to dataURL's for exporting.
	    function setImage(d) {
	        var thisImage = d3.select(this);
	
	        if(this._imgSrc === d.source) {
	            return;
	        }
	
	        thisImage.attr('xmlns', xmlnsNamespaces.svg);
	
	        if(d.source && d.source.slice(0, 5) === 'data:') {
	            thisImage.attr('xlink:href', d.source);
	            this._imgSrc = d.source;
	        } else {
	            var imagePromise = new Promise(function(resolve) {
	                var img = new Image();
	                this.img = img;
	
	                // If not set, a `tainted canvas` error is thrown
	                img.setAttribute('crossOrigin', 'anonymous');
	                img.onerror = errorHandler;
	                img.onload = function() {
	                    var canvas = document.createElement('canvas');
	                    canvas.width = this.width;
	                    canvas.height = this.height;
	
	                    var ctx = canvas.getContext('2d');
	                    ctx.drawImage(this, 0, 0);
	
	                    var dataURL = canvas.toDataURL('image/png');
	
	                    thisImage.attr('xlink:href', dataURL);
	
	                    // resolve promise in onload handler instead of on 'load' to support IE11
	                    // see https://github.com/plotly/plotly.js/issues/1685
	                    // for more details
	                    resolve();
	                };
	
	                thisImage.on('error', errorHandler);
	
	                img.src = d.source;
	                this._imgSrc = d.source;
	
	                function errorHandler() {
	                    thisImage.remove();
	                    resolve();
	                }
	            }.bind(this));
	
	            gd._promises.push(imagePromise);
	        }
	    }
	
	    function applyAttributes(d) {
	        var thisImage = d3.select(this);
	
	        // Axes if specified
	        var xa = Axes.getFromId(gd, d.xref);
	        var ya = Axes.getFromId(gd, d.yref);
	
	        var size = fullLayout._size;
	        var width = xa ? Math.abs(xa.l2p(d.sizex) - xa.l2p(0)) : d.sizex * size.w;
	        var height = ya ? Math.abs(ya.l2p(d.sizey) - ya.l2p(0)) : d.sizey * size.h;
	
	        // Offsets for anchor positioning
	        var xOffset = width * anchors.x[d.xanchor].offset;
	        var yOffset = height * anchors.y[d.yanchor].offset;
	
	        var sizing = anchors.x[d.xanchor].sizing + anchors.y[d.yanchor].sizing;
	
	        // Final positions
	        var xPos = (xa ? xa.r2p(d.x) + xa._offset : d.x * size.w + size.l) + xOffset;
	        var yPos = (ya ? ya.r2p(d.y) + ya._offset : size.h - d.y * size.h + size.t) + yOffset;
	
	        // Construct the proper aspectRatio attribute
	        switch(d.sizing) {
	            case 'fill':
	                sizing += ' slice';
	                break;
	
	            case 'stretch':
	                sizing = 'none';
	                break;
	        }
	
	        thisImage.attr({
	            x: xPos,
	            y: yPos,
	            width: width,
	            height: height,
	            preserveAspectRatio: sizing,
	            opacity: d.opacity
	        });
	
	
	        // Set proper clipping on images
	        var xId = xa ? xa._id : '';
	        var yId = ya ? ya._id : '';
	        var clipAxes = xId + yId;
	
	        Drawing.setClipUrl(
	            thisImage,
	            clipAxes ? ('clip' + fullLayout._uid + clipAxes) : null,
	            gd
	        );
	    }
	
	    var imagesBelow = fullLayout._imageLowerLayer.selectAll('image')
	        .data(imageDataBelow);
	    var imagesAbove = fullLayout._imageUpperLayer.selectAll('image')
	        .data(imageDataAbove);
	
	    imagesBelow.enter().append('image');
	    imagesAbove.enter().append('image');
	
	    imagesBelow.exit().remove();
	    imagesAbove.exit().remove();
	
	    imagesBelow.each(function(d) {
	        setImage.bind(this)(d);
	        applyAttributes.bind(this)(d);
	    });
	    imagesAbove.each(function(d) {
	        setImage.bind(this)(d);
	        applyAttributes.bind(this)(d);
	    });
	
	    var allSubplots = Object.keys(fullLayout._plots);
	    for(i = 0; i < allSubplots.length; i++) {
	        subplot = allSubplots[i];
	        var subplotObj = fullLayout._plots[subplot];
	
	        // filter out overlaid plots (which havd their images on the main plot)
	        // and gl2d plots (which don't support below images, at least not yet)
	        if(!subplotObj.imagelayer) continue;
	
	        var imagesOnSubplot = subplotObj.imagelayer.selectAll('image')
	            // even if there are no images on this subplot, we need to run
	            // enter and exit in case there were previously
	            .data(imageDataSubplot[subplot] || []);
	
	        imagesOnSubplot.enter().append('image');
	        imagesOnSubplot.exit().remove();
	
	        imagesOnSubplot.each(function(d) {
	            setImage.bind(this)(d);
	            applyAttributes.bind(this)(d);
	        });
	    }
	};
	
	},{"../../constants/xmlns_namespaces":693,"../../plots/cartesian/axes":764,"../drawing":612,"d3":164}],638:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'component',
	    name: 'images',
	
	    layoutAttributes: _dereq_('./attributes'),
	    supplyLayoutDefaults: _dereq_('./defaults'),
	    includeBasePlot: _dereq_('../../plots/cartesian/include_components')('images'),
	
	    draw: _dereq_('./draw'),
	
	    convertCoords: _dereq_('./convert_coords')
	};
	
	},{"../../plots/cartesian/include_components":774,"./attributes":634,"./convert_coords":635,"./defaults":636,"./draw":637}],639:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../color/attributes');
	
	
	module.exports = {
	    bgcolor: {
	        valType: 'color',
	        
	        editType: 'legend',
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'legend',
	        
	    },
	    borderwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'legend',
	        
	    },
	    font: fontAttrs({
	        editType: 'legend',
	        
	    }),
	    orientation: {
	        valType: 'enumerated',
	        values: ['v', 'h'],
	        dflt: 'v',
	        
	        editType: 'legend',
	        
	    },
	    traceorder: {
	        valType: 'flaglist',
	        flags: ['reversed', 'grouped'],
	        extras: ['normal'],
	        
	        editType: 'legend',
	        
	    },
	    tracegroupgap: {
	        valType: 'number',
	        min: 0,
	        dflt: 10,
	        
	        editType: 'legend',
	        
	    },
	    itemsizing: {
	        valType: 'enumerated',
	        values: ['trace', 'constant'],
	        dflt: 'trace',
	        
	        editType: 'legend',
	        
	    },
	
	    itemclick: {
	        valType: 'enumerated',
	        values: ['toggle', 'toggleothers', false],
	        dflt: 'toggle',
	        
	        editType: 'legend',
	        
	    },
	    itemdoubleclick: {
	        valType: 'enumerated',
	        values: ['toggle', 'toggleothers', false],
	        dflt: 'toggleothers',
	        
	        editType: 'legend',
	        
	    },
	
	    x: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        
	        editType: 'legend',
	        
	    },
	    xanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'left', 'center', 'right'],
	        dflt: 'left',
	        
	        editType: 'legend',
	        
	    },
	    y: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        
	        editType: 'legend',
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'top', 'middle', 'bottom'],
	        
	        editType: 'legend',
	        
	    },
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    valign: {
	        valType: 'enumerated',
	        values: ['top', 'middle', 'bottom'],
	        dflt: 'middle',
	        
	        editType: 'legend',
	        
	    },
	    editType: 'legend'
	};
	
	},{"../../plots/font_attributes":790,"../color/attributes":590}],640:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    scrollBarWidth: 6,
	    scrollBarMinHeight: 20,
	    scrollBarColor: '#808BA4',
	    scrollBarMargin: 4,
	    scrollBarEnterAttrs: {rx: 20, ry: 3, width: 0, height: 0},
	
	    // number of px between legend symbol and legend text (always in x direction)
	    textGap: 40,
	    // number of px between each legend item (x and/or y direction)
	    itemGap: 5
	};
	
	},{}],641:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Template = _dereq_('../../plot_api/plot_template');
	
	var attributes = _dereq_('./attributes');
	var basePlotLayoutAttributes = _dereq_('../../plots/layout_attributes');
	var helpers = _dereq_('./helpers');
	
	
	module.exports = function legendDefaults(layoutIn, layoutOut, fullData) {
	    var containerIn = layoutIn.legend || {};
	
	    var legendTraceCount = 0;
	    var legendReallyHasATrace = false;
	    var defaultOrder = 'normal';
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	
	        if(!trace.visible) continue;
	
	        // Note that we explicitly count any trace that is either shown or
	        // *would* be shown by default, toward the two traces you need to
	        // ensure the legend is shown by default, because this can still help
	        // disambiguate.
	        if(trace.showlegend || trace._dfltShowLegend) {
	            legendTraceCount++;
	            if(trace.showlegend) {
	                legendReallyHasATrace = true;
	                // Always show the legend by default if there's a pie,
	                // or if there's only one trace but it's explicitly shown
	                if(Registry.traceIs(trace, 'pie-like') ||
	                    trace._input.showlegend === true
	                ) {
	                    legendTraceCount++;
	                }
	            }
	        }
	
	        if((Registry.traceIs(trace, 'bar') && layoutOut.barmode === 'stack') ||
	                ['tonextx', 'tonexty'].indexOf(trace.fill) !== -1) {
	            defaultOrder = helpers.isGrouped({traceorder: defaultOrder}) ?
	                'grouped+reversed' : 'reversed';
	        }
	
	        if(trace.legendgroup !== undefined && trace.legendgroup !== '') {
	            defaultOrder = helpers.isReversed({traceorder: defaultOrder}) ?
	                'reversed+grouped' : 'grouped';
	        }
	    }
	
	    var showLegend = Lib.coerce(layoutIn, layoutOut,
	        basePlotLayoutAttributes, 'showlegend',
	        legendReallyHasATrace && legendTraceCount > 1);
	
	    if(showLegend === false && !containerIn.uirevision) return;
	
	    var containerOut = Template.newContainer(layoutOut, 'legend');
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	    }
	
	    coerce('uirevision', layoutOut.uirevision);
	
	    if(showLegend === false) return;
	
	    coerce('bgcolor', layoutOut.paper_bgcolor);
	    coerce('bordercolor');
	    coerce('borderwidth');
	    Lib.coerceFont(coerce, 'font', layoutOut.font);
	
	    var orientation = coerce('orientation');
	    var defaultX, defaultY, defaultYAnchor;
	
	    if(orientation === 'h') {
	        defaultX = 0;
	
	        if(Registry.getComponentMethod('rangeslider', 'isVisible')(layoutIn.xaxis)) {
	            defaultY = 1.1;
	            defaultYAnchor = 'bottom';
	        } else {
	            // maybe use y=1.1 / yanchor=bottom as above
	            //   to avoid https://github.com/plotly/plotly.js/issues/1199
	            //   in v2
	            defaultY = -0.1;
	            defaultYAnchor = 'top';
	        }
	    } else {
	        defaultX = 1.02;
	        defaultY = 1;
	        defaultYAnchor = 'auto';
	    }
	
	    coerce('traceorder', defaultOrder);
	    if(helpers.isGrouped(layoutOut.legend)) coerce('tracegroupgap');
	
	    coerce('itemsizing');
	
	    coerce('itemclick');
	    coerce('itemdoubleclick');
	
	    coerce('x', defaultX);
	    coerce('xanchor');
	    coerce('y', defaultY);
	    coerce('yanchor', defaultYAnchor);
	    coerce('valign');
	    Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../plots/layout_attributes":816,"../../registry":845,"./attributes":639,"./helpers":645}],642:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var Plots = _dereq_('../../plots/plots');
	var Registry = _dereq_('../../registry');
	var Events = _dereq_('../../lib/events');
	var dragElement = _dereq_('../dragelement');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var handleClick = _dereq_('./handle_click');
	
	var constants = _dereq_('./constants');
	var alignmentConstants = _dereq_('../../constants/alignment');
	var LINE_SPACING = alignmentConstants.LINE_SPACING;
	var FROM_TL = alignmentConstants.FROM_TL;
	var FROM_BR = alignmentConstants.FROM_BR;
	
	var getLegendData = _dereq_('./get_legend_data');
	var style = _dereq_('./style');
	var helpers = _dereq_('./helpers');
	
	module.exports = function draw(gd) {
	    var fullLayout = gd._fullLayout;
	    var clipId = 'legend' + fullLayout._uid;
	
	    if(!fullLayout._infolayer || !gd.calcdata) return;
	
	    if(!gd._legendMouseDownTime) gd._legendMouseDownTime = 0;
	
	    var opts = fullLayout.legend;
	    var legendData = fullLayout.showlegend && getLegendData(gd.calcdata, opts);
	    var hiddenSlices = fullLayout.hiddenlabels || [];
	
	    if(!fullLayout.showlegend || !legendData.length) {
	        fullLayout._infolayer.selectAll('.legend').remove();
	        fullLayout._topdefs.select('#' + clipId).remove();
	        return Plots.autoMargin(gd, 'legend');
	    }
	
	    var legend = Lib.ensureSingle(fullLayout._infolayer, 'g', 'legend', function(s) {
	        s.attr('pointer-events', 'all');
	    });
	
	    var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', clipId, function(s) {
	        s.append('rect');
	    });
	
	    var bg = Lib.ensureSingle(legend, 'rect', 'bg', function(s) {
	        s.attr('shape-rendering', 'crispEdges');
	    });
	    bg.call(Color.stroke, opts.bordercolor)
	        .call(Color.fill, opts.bgcolor)
	        .style('stroke-width', opts.borderwidth + 'px');
	
	    var scrollBox = Lib.ensureSingle(legend, 'g', 'scrollbox');
	
	    var scrollBar = Lib.ensureSingle(legend, 'rect', 'scrollbar', function(s) {
	        s.attr(constants.scrollBarEnterAttrs)
	         .call(Color.fill, constants.scrollBarColor);
	    });
	
	    var groups = scrollBox.selectAll('g.groups').data(legendData);
	    groups.enter().append('g').attr('class', 'groups');
	    groups.exit().remove();
	
	    var traces = groups.selectAll('g.traces').data(Lib.identity);
	    traces.enter().append('g').attr('class', 'traces');
	    traces.exit().remove();
	
	    traces.style('opacity', function(d) {
	        var trace = d[0].trace;
	        if(Registry.traceIs(trace, 'pie-like')) {
	            return hiddenSlices.indexOf(d[0].label) !== -1 ? 0.5 : 1;
	        } else {
	            return trace.visible === 'legendonly' ? 0.5 : 1;
	        }
	    })
	    .each(function() { d3.select(this).call(drawTexts, gd); })
	    .call(style, gd)
	    .each(function() { d3.select(this).call(setupTraceToggle, gd); });
	
	    Lib.syncOrAsync([
	        Plots.previousPromises,
	        function() { return computeLegendDimensions(gd, groups, traces); },
	        function() {
	            // IF expandMargin return a Promise (which is truthy),
	            // we're under a doAutoMargin redraw, so we don't have to
	            // draw the remaining pieces below
	            if(expandMargin(gd)) return;
	
	            var gs = fullLayout._size;
	            var bw = opts.borderwidth;
	
	            var lx = gs.l + gs.w * opts.x - FROM_TL[getXanchor(opts)] * opts._width;
	            var ly = gs.t + gs.h * (1 - opts.y) - FROM_TL[getYanchor(opts)] * opts._effHeight;
	
	            if(fullLayout.margin.autoexpand) {
	                var lx0 = lx;
	                var ly0 = ly;
	
	                lx = Lib.constrain(lx, 0, fullLayout.width - opts._width);
	                ly = Lib.constrain(ly, 0, fullLayout.height - opts._effHeight);
	
	                if(lx !== lx0) {
	                    Lib.log('Constrain legend.x to make legend fit inside graph');
	                }
	                if(ly !== ly0) {
	                    Lib.log('Constrain legend.y to make legend fit inside graph');
	                }
	            }
	
	            // Set size and position of all the elements that make up a legend:
	            // legend, background and border, scroll box and scroll bar
	            Drawing.setTranslate(legend, lx, ly);
	
	            // to be safe, remove previous listeners
	            scrollBar.on('.drag', null);
	            legend.on('wheel', null);
	
	            if(opts._height <= opts._maxHeight || gd._context.staticPlot) {
	                // if scrollbar should not be shown.
	                bg.attr({
	                    width: opts._width - bw,
	                    height: opts._effHeight - bw,
	                    x: bw / 2,
	                    y: bw / 2
	                });
	
	                Drawing.setTranslate(scrollBox, 0, 0);
	
	                clipPath.select('rect').attr({
	                    width: opts._width - 2 * bw,
	                    height: opts._effHeight - 2 * bw,
	                    x: bw,
	                    y: bw
	                });
	
	                Drawing.setClipUrl(scrollBox, clipId, gd);
	
	                Drawing.setRect(scrollBar, 0, 0, 0, 0);
	                delete opts._scrollY;
	            } else {
	                var scrollBarHeight = Math.max(constants.scrollBarMinHeight,
	                    opts._effHeight * opts._effHeight / opts._height);
	                var scrollBarYMax = opts._effHeight -
	                    scrollBarHeight -
	                    2 * constants.scrollBarMargin;
	                var scrollBoxYMax = opts._height - opts._effHeight;
	                var scrollRatio = scrollBarYMax / scrollBoxYMax;
	
	                var scrollBoxY = Math.min(opts._scrollY || 0, scrollBoxYMax);
	
	                // increase the background and clip-path width
	                // by the scrollbar width and margin
	                bg.attr({
	                    width: opts._width -
	                        2 * bw +
	                        constants.scrollBarWidth +
	                        constants.scrollBarMargin,
	                    height: opts._effHeight - bw,
	                    x: bw / 2,
	                    y: bw / 2
	                });
	
	                clipPath.select('rect').attr({
	                    width: opts._width -
	                        2 * bw +
	                        constants.scrollBarWidth +
	                        constants.scrollBarMargin,
	                    height: opts._effHeight - 2 * bw,
	                    x: bw,
	                    y: bw + scrollBoxY
	                });
	
	                Drawing.setClipUrl(scrollBox, clipId, gd);
	
	                scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	
	                // scroll legend by mousewheel or touchpad swipe up/down
	                legend.on('wheel', function() {
	                    scrollBoxY = Lib.constrain(
	                        opts._scrollY +
	                            ((d3.event.deltaY / scrollBarYMax) * scrollBoxYMax),
	                        0, scrollBoxYMax);
	                    scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                    if(scrollBoxY !== 0 && scrollBoxY !== scrollBoxYMax) {
	                        d3.event.preventDefault();
	                    }
	                });
	
	                var eventY0, eventY1, scrollBoxY0;
	
	                var getScrollBarDragY = function(scrollBoxY0, eventY0, eventY1) {
	                    var y = ((eventY1 - eventY0) / scrollRatio) + scrollBoxY0;
	                    return Lib.constrain(y, 0, scrollBoxYMax);
	                };
	
	                var getNaturalDragY = function(scrollBoxY0, eventY0, eventY1) {
	                    var y = ((eventY0 - eventY1) / scrollRatio) + scrollBoxY0;
	                    return Lib.constrain(y, 0, scrollBoxYMax);
	                };
	
	                // scroll legend by dragging scrollBAR
	                var scrollBarDrag = d3.behavior.drag()
	                .on('dragstart', function() {
	                    var e = d3.event.sourceEvent;
	                    if(e.type === 'touchstart') {
	                        eventY0 = e.changedTouches[0].clientY;
	                    } else {
	                        eventY0 = e.clientY;
	                    }
	                    scrollBoxY0 = scrollBoxY;
	                })
	                .on('drag', function() {
	                    var e = d3.event.sourceEvent;
	                    if(e.buttons === 2 || e.ctrlKey) return;
	                    if(e.type === 'touchmove') {
	                        eventY1 = e.changedTouches[0].clientY;
	                    } else {
	                        eventY1 = e.clientY;
	                    }
	                    scrollBoxY = getScrollBarDragY(scrollBoxY0, eventY0, eventY1);
	                    scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                });
	                scrollBar.call(scrollBarDrag);
	
	                // scroll legend by touch-dragging scrollBOX
	                var scrollBoxTouchDrag = d3.behavior.drag()
	                .on('dragstart', function() {
	                    var e = d3.event.sourceEvent;
	                    if(e.type === 'touchstart') {
	                        eventY0 = e.changedTouches[0].clientY;
	                        scrollBoxY0 = scrollBoxY;
	                    }
	                })
	                .on('drag', function() {
	                    var e = d3.event.sourceEvent;
	                    if(e.type === 'touchmove') {
	                        eventY1 = e.changedTouches[0].clientY;
	                        scrollBoxY = getNaturalDragY(scrollBoxY0, eventY0, eventY1);
	                        scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                    }
	                });
	                scrollBox.call(scrollBoxTouchDrag);
	            }
	
	            function scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio) {
	                opts._scrollY = gd._fullLayout.legend._scrollY = scrollBoxY;
	                Drawing.setTranslate(scrollBox, 0, -scrollBoxY);
	
	                Drawing.setRect(
	                    scrollBar,
	                    opts._width,
	                    constants.scrollBarMargin + scrollBoxY * scrollRatio,
	                    constants.scrollBarWidth,
	                    scrollBarHeight
	                );
	                clipPath.select('rect').attr('y', bw + scrollBoxY);
	            }
	
	            if(gd._context.edits.legendPosition) {
	                var xf, yf, x0, y0;
	
	                legend.classed('cursor-move', true);
	
	                dragElement.init({
	                    element: legend.node(),
	                    gd: gd,
	                    prepFn: function() {
	                        var transform = Drawing.getTranslate(legend);
	                        x0 = transform.x;
	                        y0 = transform.y;
	                    },
	                    moveFn: function(dx, dy) {
	                        var newX = x0 + dx;
	                        var newY = y0 + dy;
	
	                        Drawing.setTranslate(legend, newX, newY);
	
	                        xf = dragElement.align(newX, 0, gs.l, gs.l + gs.w, opts.xanchor);
	                        yf = dragElement.align(newY, 0, gs.t + gs.h, gs.t, opts.yanchor);
	                    },
	                    doneFn: function() {
	                        if(xf !== undefined && yf !== undefined) {
	                            Registry.call('_guiRelayout', gd, {'legend.x': xf, 'legend.y': yf});
	                        }
	                    },
	                    clickFn: function(numClicks, e) {
	                        var clickedTrace = fullLayout._infolayer.selectAll('g.traces').filter(function() {
	                            var bbox = this.getBoundingClientRect();
	                            return (
	                                e.clientX >= bbox.left && e.clientX <= bbox.right &&
	                                e.clientY >= bbox.top && e.clientY <= bbox.bottom
	                            );
	                        });
	                        if(clickedTrace.size() > 0) {
	                            clickOrDoubleClick(gd, legend, clickedTrace, numClicks, e);
	                        }
	                    }
	                });
	            }
	        }], gd);
	};
	
	function clickOrDoubleClick(gd, legend, legendItem, numClicks, evt) {
	    var trace = legendItem.data()[0][0].trace;
	    var evtData = {
	        event: evt,
	        node: legendItem.node(),
	        curveNumber: trace.index,
	        expandedIndex: trace._expandedIndex,
	        data: gd.data,
	        layout: gd.layout,
	        frames: gd._transitionData._frames,
	        config: gd._context,
	        fullData: gd._fullData,
	        fullLayout: gd._fullLayout
	    };
	
	    if(trace._group) {
	        evtData.group = trace._group;
	    }
	    if(Registry.traceIs(trace, 'pie-like')) {
	        evtData.label = legendItem.datum()[0].label;
	    }
	
	    var clickVal = Events.triggerHandler(gd, 'plotly_legendclick', evtData);
	    if(clickVal === false) return;
	
	    if(numClicks === 1) {
	        legend._clickTimeout = setTimeout(function() {
	            handleClick(legendItem, gd, numClicks);
	        }, gd._context.doubleClickDelay);
	    } else if(numClicks === 2) {
	        if(legend._clickTimeout) clearTimeout(legend._clickTimeout);
	        gd._legendMouseDownTime = 0;
	
	        var dblClickVal = Events.triggerHandler(gd, 'plotly_legenddoubleclick', evtData);
	        if(dblClickVal !== false) handleClick(legendItem, gd, numClicks);
	    }
	}
	
	function drawTexts(g, gd) {
	    var legendItem = g.data()[0][0];
	    var fullLayout = gd._fullLayout;
	    var opts = fullLayout.legend;
	    var trace = legendItem.trace;
	    var isPieLike = Registry.traceIs(trace, 'pie-like');
	    var traceIndex = trace.index;
	    var isEditable = gd._context.edits.legendText && !isPieLike;
	    var maxNameLength = opts._maxNameLength;
	
	    var name = isPieLike ? legendItem.label : trace.name;
	    if(trace._meta) {
	        name = Lib.templateString(name, trace._meta);
	    }
	
	    var textEl = Lib.ensureSingle(g, 'text', 'legendtext');
	
	    textEl.attr('text-anchor', 'start')
	        .classed('user-select-none', true)
	        .call(Drawing.font, fullLayout.legend.font)
	        .text(isEditable ? ensureLength(name, maxNameLength) : name);
	
	    svgTextUtils.positionText(textEl, constants.textGap, 0);
	
	    function textLayout(s) {
	        svgTextUtils.convertToTspans(s, gd, function() {
	            computeTextDimensions(g, gd);
	        });
	    }
	
	    if(isEditable) {
	        textEl.call(svgTextUtils.makeEditable, {gd: gd, text: name})
	            .call(textLayout)
	            .on('edit', function(newName) {
	                this.text(ensureLength(newName, maxNameLength))
	                    .call(textLayout);
	
	                var fullInput = legendItem.trace._fullInput || {};
	                var update = {};
	
	                if(Registry.hasTransform(fullInput, 'groupby')) {
	                    var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
	                    var index = groupbyIndices[groupbyIndices.length - 1];
	
	                    var kcont = Lib.keyedContainer(fullInput, 'transforms[' + index + '].styles', 'target', 'value.name');
	
	                    kcont.set(legendItem.trace._group, newName);
	
	                    update = kcont.constructUpdate();
	                } else {
	                    update.name = newName;
	                }
	
	                return Registry.call('_guiRestyle', gd, update, traceIndex);
	            });
	    } else {
	        textLayout(textEl);
	    }
	}
	
	/*
	 * Make sure we have a reasonably clickable region.
	 * If this string is missing or very short, pad it with spaces out to at least
	 * 4 characters, up to the max length of other labels, on the assumption that
	 * most characters are wider than spaces so a string of spaces will usually be
	 * no wider than the real labels.
	 */
	function ensureLength(str, maxLength) {
	    var targetLength = Math.max(4, maxLength);
	    if(str && str.trim().length >= targetLength / 2) return str;
	    str = str || '';
	    for(var i = targetLength - str.length; i > 0; i--) str += ' ';
	    return str;
	}
	
	function setupTraceToggle(g, gd) {
	    var doubleClickDelay = gd._context.doubleClickDelay;
	    var newMouseDownTime;
	    var numClicks = 1;
	
	    var traceToggle = Lib.ensureSingle(g, 'rect', 'legendtoggle', function(s) {
	        s.style('cursor', 'pointer')
	            .attr('pointer-events', 'all')
	            .call(Color.fill, 'rgba(0,0,0,0)');
	    });
	
	    traceToggle.on('mousedown', function() {
	        newMouseDownTime = (new Date()).getTime();
	        if(newMouseDownTime - gd._legendMouseDownTime < doubleClickDelay) {
	            // in a click train
	            numClicks += 1;
	        } else {
	            // new click train
	            numClicks = 1;
	            gd._legendMouseDownTime = newMouseDownTime;
	        }
	    });
	    traceToggle.on('mouseup', function() {
	        if(gd._dragged || gd._editing) return;
	        var legend = gd._fullLayout.legend;
	
	        if((new Date()).getTime() - gd._legendMouseDownTime > doubleClickDelay) {
	            numClicks = Math.max(numClicks - 1, 1);
	        }
	
	        clickOrDoubleClick(gd, legend, g, numClicks, d3.event);
	    });
	}
	
	function computeTextDimensions(g, gd) {
	    var legendItem = g.data()[0][0];
	
	    if(!legendItem.trace.showlegend) {
	        g.remove();
	        return;
	    }
	
	    var mathjaxGroup = g.select('g[class*=math-group]');
	    var mathjaxNode = mathjaxGroup.node();
	    var opts = gd._fullLayout.legend;
	    var lineHeight = opts.font.size * LINE_SPACING;
	    var height, width;
	
	    if(mathjaxNode) {
	        var mathjaxBB = Drawing.bBox(mathjaxNode);
	
	        height = mathjaxBB.height;
	        width = mathjaxBB.width;
	
	        Drawing.setTranslate(mathjaxGroup, 0, (height / 4));
	    } else {
	        var text = g.select('.legendtext');
	        var textLines = svgTextUtils.lineCount(text);
	        var textNode = text.node();
	
	        height = lineHeight * textLines;
	        width = textNode ? Drawing.bBox(textNode).width : 0;
	
	        // approximation to height offset to center the font
	        // to avoid getBoundingClientRect
	        var textY = lineHeight * (0.3 + (1 - textLines) / 2);
	        svgTextUtils.positionText(text, constants.textGap, textY);
	    }
	
	    legendItem.lineHeight = lineHeight;
	    legendItem.height = Math.max(height, 16) + 3;
	    legendItem.width = width;
	}
	
	/*
	 * Computes in fullLayout.legend:
	 *
	 *  - _height: legend height including items past scrollbox height
	 *  - _maxHeight: maximum legend height before scrollbox is required
	 *  - _effHeight: legend height w/ or w/o scrollbox
	 *
	 *  - _width: legend width
	 *  - _maxWidth (for orientation:h only): maximum width before starting new row
	 */
	function computeLegendDimensions(gd, groups, traces) {
	    var fullLayout = gd._fullLayout;
	    var opts = fullLayout.legend;
	    var gs = fullLayout._size;
	    var isVertical = helpers.isVertical(opts);
	    var isGrouped = helpers.isGrouped(opts);
	
	    var bw = opts.borderwidth;
	    var bw2 = 2 * bw;
	    var textGap = constants.textGap;
	    var itemGap = constants.itemGap;
	    var endPad = 2 * (bw + itemGap);
	
	    var yanchor = getYanchor(opts);
	    var isBelowPlotArea = opts.y < 0 || (opts.y === 0 && yanchor === 'top');
	    var isAbovePlotArea = opts.y > 1 || (opts.y === 1 && yanchor === 'bottom');
	
	    // - if below/above plot area, give it the maximum potential margin-push value
	    // - otherwise, extend the height of the plot area
	    opts._maxHeight = Math.max(
	        (isBelowPlotArea || isAbovePlotArea) ? fullLayout.height / 2 : gs.h,
	        30
	    );
	
	    var toggleRectWidth = 0;
	    opts._width = 0;
	    opts._height = 0;
	
	    if(isVertical) {
	        traces.each(function(d) {
	            var h = d[0].height;
	            Drawing.setTranslate(this, bw, itemGap + bw + opts._height + h / 2);
	            opts._height += h;
	            opts._width = Math.max(opts._width, d[0].width);
	        });
	
	        toggleRectWidth = textGap + opts._width;
	        opts._width += itemGap + textGap + bw2;
	        opts._height += endPad;
	
	        if(isGrouped) {
	            groups.each(function(d, i) {
	                Drawing.setTranslate(this, 0, i * opts.tracegroupgap);
	            });
	            opts._height += (opts._lgroupsLength - 1) * opts.tracegroupgap;
	        }
	    } else {
	        var xanchor = getXanchor(opts);
	        var isLeftOfPlotArea = opts.x < 0 || (opts.x === 0 && xanchor === 'right');
	        var isRightOfPlotArea = opts.x > 1 || (opts.x === 1 && xanchor === 'left');
	        var isBeyondPlotAreaY = isAbovePlotArea || isBelowPlotArea;
	        var hw = fullLayout.width / 2;
	
	        // - if placed within x-margins, extend the width of the plot area
	        // - else if below/above plot area and anchored in the margin, extend to opposite margin,
	        // - otherwise give it the maximum potential margin-push value
	        opts._maxWidth = Math.max(
	            isLeftOfPlotArea ? ((isBeyondPlotAreaY && xanchor === 'left') ? gs.l + gs.w : hw) :
	            isRightOfPlotArea ? ((isBeyondPlotAreaY && xanchor === 'right') ? gs.r + gs.w : hw) :
	            gs.w,
	        2 * textGap);
	        var maxItemWidth = 0;
	        var combinedItemWidth = 0;
	        traces.each(function(d) {
	            var w = d[0].width + textGap;
	            maxItemWidth = Math.max(maxItemWidth, w);
	            combinedItemWidth += w;
	        });
	
	        toggleRectWidth = null;
	        var maxRowWidth = 0;
	
	        if(isGrouped) {
	            var maxGroupHeightInRow = 0;
	            var groupOffsetX = 0;
	            var groupOffsetY = 0;
	            groups.each(function() {
	                var maxWidthInGroup = 0;
	                var offsetY = 0;
	                d3.select(this).selectAll('g.traces').each(function(d) {
	                    var h = d[0].height;
	                    Drawing.setTranslate(this, 0, itemGap + bw + h / 2 + offsetY);
	                    offsetY += h;
	                    maxWidthInGroup = Math.max(maxWidthInGroup, textGap + d[0].width);
	                });
	                maxGroupHeightInRow = Math.max(maxGroupHeightInRow, offsetY);
	
	                var next = maxWidthInGroup + itemGap;
	
	                if((next + bw + groupOffsetX) > opts._maxWidth) {
	                    maxRowWidth = Math.max(maxRowWidth, groupOffsetX);
	                    groupOffsetX = 0;
	                    groupOffsetY += maxGroupHeightInRow + opts.tracegroupgap;
	                    maxGroupHeightInRow = offsetY;
	                }
	
	                Drawing.setTranslate(this, groupOffsetX, groupOffsetY);
	
	                groupOffsetX += next;
	            });
	
	            opts._width = Math.max(maxRowWidth, groupOffsetX) + bw;
	            opts._height = groupOffsetY + maxGroupHeightInRow + endPad;
	        } else {
	            var nTraces = traces.size();
	            var oneRowLegend = (combinedItemWidth + bw2 + (nTraces - 1) * itemGap) < opts._maxWidth;
	
	            var maxItemHeightInRow = 0;
	            var offsetX = 0;
	            var offsetY = 0;
	            var rowWidth = 0;
	            traces.each(function(d) {
	                var h = d[0].height;
	                var w = textGap + d[0].width;
	                var next = (oneRowLegend ? w : maxItemWidth) + itemGap;
	
	                if((next + bw + offsetX) > opts._maxWidth) {
	                    maxRowWidth = Math.max(maxRowWidth, rowWidth);
	                    offsetX = 0;
	                    offsetY += maxItemHeightInRow;
	                    opts._height += maxItemHeightInRow;
	                    maxItemHeightInRow = 0;
	                }
	
	                Drawing.setTranslate(this, bw + offsetX, itemGap + bw + h / 2 + offsetY);
	
	                rowWidth = offsetX + w + itemGap;
	                offsetX += next;
	                maxItemHeightInRow = Math.max(maxItemHeightInRow, h);
	            });
	
	            if(oneRowLegend) {
	                opts._width = offsetX + bw2;
	                opts._height = maxItemHeightInRow + endPad;
	            } else {
	                opts._width = Math.max(maxRowWidth, rowWidth) + bw2;
	                opts._height += maxItemHeightInRow + endPad;
	            }
	        }
	    }
	
	    opts._width = Math.ceil(opts._width);
	    opts._height = Math.ceil(opts._height);
	
	    opts._effHeight = Math.min(opts._height, opts._maxHeight);
	
	    var edits = gd._context.edits;
	    var isEditable = edits.legendText || edits.legendPosition;
	    traces.each(function(d) {
	        var traceToggle = d3.select(this).select('.legendtoggle');
	        var h = d[0].height;
	        var w = isEditable ? textGap : (toggleRectWidth || (textGap + d[0].width));
	        if(!isVertical) w += itemGap / 2;
	        Drawing.setRect(traceToggle, 0, -h / 2, w, h);
	    });
	}
	
	function expandMargin(gd) {
	    var fullLayout = gd._fullLayout;
	    var opts = fullLayout.legend;
	    var xanchor = getXanchor(opts);
	    var yanchor = getYanchor(opts);
	
	    return Plots.autoMargin(gd, 'legend', {
	        x: opts.x,
	        y: opts.y,
	        l: opts._width * (FROM_TL[xanchor]),
	        r: opts._width * (FROM_BR[xanchor]),
	        b: opts._effHeight * (FROM_BR[yanchor]),
	        t: opts._effHeight * (FROM_TL[yanchor])
	    });
	}
	
	function getXanchor(opts) {
	    return Lib.isRightAnchor(opts) ? 'right' :
	        Lib.isCenterAnchor(opts) ? 'center' :
	        'left';
	}
	
	function getYanchor(opts) {
	    return Lib.isBottomAnchor(opts) ? 'bottom' :
	        Lib.isMiddleAnchor(opts) ? 'middle' :
	        'top';
	}
	
	},{"../../constants/alignment":685,"../../lib":716,"../../lib/events":706,"../../lib/svg_text_utils":740,"../../plots/plots":825,"../../registry":845,"../color":591,"../dragelement":609,"../drawing":612,"./constants":640,"./get_legend_data":643,"./handle_click":644,"./helpers":645,"./style":647,"d3":164}],643:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var helpers = _dereq_('./helpers');
	
	module.exports = function getLegendData(calcdata, opts) {
	    var lgroupToTraces = {};
	    var lgroups = [];
	    var hasOneNonBlankGroup = false;
	    var slicesShown = {};
	    var lgroupi = 0;
	    var maxNameLength = 0;
	    var i, j;
	
	    function addOneItem(legendGroup, legendItem) {
	        // each '' legend group is treated as a separate group
	        if(legendGroup === '' || !helpers.isGrouped(opts)) {
	            // TODO: check this against fullData legendgroups?
	            var uniqueGroup = '~~i' + lgroupi;
	            lgroups.push(uniqueGroup);
	            lgroupToTraces[uniqueGroup] = [[legendItem]];
	            lgroupi++;
	        } else if(lgroups.indexOf(legendGroup) === -1) {
	            lgroups.push(legendGroup);
	            hasOneNonBlankGroup = true;
	            lgroupToTraces[legendGroup] = [[legendItem]];
	        } else {
	            lgroupToTraces[legendGroup].push([legendItem]);
	        }
	    }
	
	    // build an { legendgroup: [cd0, cd0], ... } object
	    for(i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	        var lgroup = trace.legendgroup;
	
	        if(!trace.visible || !trace.showlegend) continue;
	
	        if(Registry.traceIs(trace, 'pie-like')) {
	            if(!slicesShown[lgroup]) slicesShown[lgroup] = {};
	
	            for(j = 0; j < cd.length; j++) {
	                var labelj = cd[j].label;
	
	                if(!slicesShown[lgroup][labelj]) {
	                    addOneItem(lgroup, {
	                        label: labelj,
	                        color: cd[j].color,
	                        i: cd[j].i,
	                        trace: trace,
	                        pts: cd[j].pts
	                    });
	
	                    slicesShown[lgroup][labelj] = true;
	                    maxNameLength = Math.max(maxNameLength, (labelj || '').length);
	                }
	            }
	        } else {
	            addOneItem(lgroup, cd0);
	            maxNameLength = Math.max(maxNameLength, (trace.name || '').length);
	        }
	    }
	
	    // won't draw a legend in this case
	    if(!lgroups.length) return [];
	
	    // rearrange lgroupToTraces into a d3-friendly array of arrays
	    var lgroupsLength = lgroups.length;
	    var ltraces;
	    var legendData;
	
	    if(hasOneNonBlankGroup && helpers.isGrouped(opts)) {
	        legendData = new Array(lgroupsLength);
	
	        for(i = 0; i < lgroupsLength; i++) {
	            ltraces = lgroupToTraces[lgroups[i]];
	            legendData[i] = helpers.isReversed(opts) ? ltraces.reverse() : ltraces;
	        }
	    } else {
	        // collapse all groups into one if all groups are blank
	        legendData = [new Array(lgroupsLength)];
	
	        for(i = 0; i < lgroupsLength; i++) {
	            ltraces = lgroupToTraces[lgroups[i]][0];
	            legendData[0][helpers.isReversed(opts) ? lgroupsLength - i - 1 : i] = ltraces;
	        }
	        lgroupsLength = 1;
	    }
	
	    // number of legend groups - needed in legend/draw.js
	    opts._lgroupsLength = lgroupsLength;
	    // maximum name/label length - needed in legend/draw.js
	    opts._maxNameLength = maxNameLength;
	
	    return legendData;
	};
	
	},{"../../registry":845,"./helpers":645}],644:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var SHOWISOLATETIP = true;
	
	module.exports = function handleClick(g, gd, numClicks) {
	    var fullLayout = gd._fullLayout;
	
	    if(gd._dragged || gd._editing) return;
	
	    var itemClick = fullLayout.legend.itemclick;
	    var itemDoubleClick = fullLayout.legend.itemdoubleclick;
	
	    if(numClicks === 1 && itemClick === 'toggle' && itemDoubleClick === 'toggleothers' &&
	        SHOWISOLATETIP && gd.data && gd._context.showTips
	    ) {
	        Lib.notifier(Lib._(gd, 'Double-click on legend to isolate one trace'), 'long');
	        SHOWISOLATETIP = false;
	    } else {
	        SHOWISOLATETIP = false;
	    }
	
	    var mode;
	    if(numClicks === 1) mode = itemClick;
	    else if(numClicks === 2) mode = itemDoubleClick;
	    if(!mode) return;
	
	    var hiddenSlices = fullLayout.hiddenlabels ?
	        fullLayout.hiddenlabels.slice() :
	        [];
	
	    var legendItem = g.data()[0][0];
	    var fullData = gd._fullData;
	    var fullTrace = legendItem.trace;
	    var legendgroup = fullTrace.legendgroup;
	
	    var i, j, kcont, key, keys, val;
	    var attrUpdate = {};
	    var attrIndices = [];
	    var carrs = [];
	    var carrIdx = [];
	
	    function insertUpdate(traceIndex, key, value) {
	        var attrIndex = attrIndices.indexOf(traceIndex);
	        var valueArray = attrUpdate[key];
	        if(!valueArray) {
	            valueArray = attrUpdate[key] = [];
	        }
	
	        if(attrIndices.indexOf(traceIndex) === -1) {
	            attrIndices.push(traceIndex);
	            attrIndex = attrIndices.length - 1;
	        }
	
	        valueArray[attrIndex] = value;
	
	        return attrIndex;
	    }
	
	    function setVisibility(fullTrace, visibility) {
	        var fullInput = fullTrace._fullInput;
	        if(Registry.hasTransform(fullInput, 'groupby')) {
	            var kcont = carrs[fullInput.index];
	            if(!kcont) {
	                var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
	                var lastGroupbyIndex = groupbyIndices[groupbyIndices.length - 1];
	                kcont = Lib.keyedContainer(fullInput, 'transforms[' + lastGroupbyIndex + '].styles', 'target', 'value.visible');
	                carrs[fullInput.index] = kcont;
	            }
	
	            var curState = kcont.get(fullTrace._group);
	
	            // If not specified, assume visible. This happens if there are other style
	            // properties set for a group but not the visibility. There are many similar
	            // ways to do this (e.g. why not just `curState = fullTrace.visible`??? The
	            // answer is: because it breaks other things like groupby trace names in
	            // subtle ways.)
	            if(curState === undefined) {
	                curState = true;
	            }
	
	            if(curState !== false) {
	                // true -> legendonly. All others toggle to true:
	                kcont.set(fullTrace._group, visibility);
	            }
	            carrIdx[fullInput.index] = insertUpdate(fullInput.index, 'visible', fullInput.visible === false ? false : true);
	        } else {
	            // false -> false (not possible since will not be visible in legend)
	            // true -> legendonly
	            // legendonly -> true
	            var nextVisibility = fullInput.visible === false ? false : visibility;
	
	            insertUpdate(fullInput.index, 'visible', nextVisibility);
	        }
	    }
	
	    if(Registry.traceIs(fullTrace, 'pie-like')) {
	        var thisLabel = legendItem.label;
	        var thisLabelIndex = hiddenSlices.indexOf(thisLabel);
	
	        if(mode === 'toggle') {
	            if(thisLabelIndex === -1) hiddenSlices.push(thisLabel);
	            else hiddenSlices.splice(thisLabelIndex, 1);
	        } else if(mode === 'toggleothers') {
	            hiddenSlices = [];
	            gd.calcdata[0].forEach(function(d) {
	                if(thisLabel !== d.label) {
	                    hiddenSlices.push(d.label);
	                }
	            });
	            if(gd._fullLayout.hiddenlabels && gd._fullLayout.hiddenlabels.length === hiddenSlices.length && thisLabelIndex === -1) {
	                hiddenSlices = [];
	            }
	        }
	
	        Registry.call('_guiRelayout', gd, 'hiddenlabels', hiddenSlices);
	    } else {
	        var hasLegendgroup = legendgroup && legendgroup.length;
	        var traceIndicesInGroup = [];
	        var tracei;
	        if(hasLegendgroup) {
	            for(i = 0; i < fullData.length; i++) {
	                tracei = fullData[i];
	                if(!tracei.visible) continue;
	                if(tracei.legendgroup === legendgroup) {
	                    traceIndicesInGroup.push(i);
	                }
	            }
	        }
	
	        if(mode === 'toggle') {
	            var nextVisibility;
	
	            switch(fullTrace.visible) {
	                case true:
	                    nextVisibility = 'legendonly';
	                    break;
	                case false:
	                    nextVisibility = false;
	                    break;
	                case 'legendonly':
	                    nextVisibility = true;
	                    break;
	            }
	
	            if(hasLegendgroup) {
	                for(i = 0; i < fullData.length; i++) {
	                    if(fullData[i].visible !== false && fullData[i].legendgroup === legendgroup) {
	                        setVisibility(fullData[i], nextVisibility);
	                    }
	                }
	            } else {
	                setVisibility(fullTrace, nextVisibility);
	            }
	        } else if(mode === 'toggleothers') {
	            // Compute the clicked index. expandedIndex does what we want for expanded traces
	            // but also culls hidden traces. That means we have some work to do.
	            var isClicked, isInGroup, otherState;
	            var isIsolated = true;
	            for(i = 0; i < fullData.length; i++) {
	                isClicked = fullData[i] === fullTrace;
	                if(isClicked) continue;
	
	                isInGroup = (hasLegendgroup && fullData[i].legendgroup === legendgroup);
	
	                if(!isInGroup && fullData[i].visible === true && !Registry.traceIs(fullData[i], 'notLegendIsolatable')) {
	                    isIsolated = false;
	                    break;
	                }
	            }
	
	            for(i = 0; i < fullData.length; i++) {
	                // False is sticky; we don't change it.
	                if(fullData[i].visible === false) continue;
	
	                if(Registry.traceIs(fullData[i], 'notLegendIsolatable')) {
	                    continue;
	                }
	
	                switch(fullTrace.visible) {
	                    case 'legendonly':
	                        setVisibility(fullData[i], true);
	                        break;
	                    case true:
	                        otherState = isIsolated ? true : 'legendonly';
	                        isClicked = fullData[i] === fullTrace;
	                        isInGroup = isClicked || (hasLegendgroup && fullData[i].legendgroup === legendgroup);
	                        setVisibility(fullData[i], isInGroup ? true : otherState);
	                        break;
	                }
	            }
	        }
	
	        for(i = 0; i < carrs.length; i++) {
	            kcont = carrs[i];
	            if(!kcont) continue;
	            var update = kcont.constructUpdate();
	
	            var updateKeys = Object.keys(update);
	            for(j = 0; j < updateKeys.length; j++) {
	                key = updateKeys[j];
	                val = attrUpdate[key] = attrUpdate[key] || [];
	                val[carrIdx[i]] = update[key];
	            }
	        }
	
	        // The length of the value arrays should be equal and any unspecified
	        // values should be explicitly undefined for them to get properly culled
	        // as updates and not accidentally reset to the default value. This fills
	        // out sparse arrays with the required number of undefined values:
	        keys = Object.keys(attrUpdate);
	        for(i = 0; i < keys.length; i++) {
	            key = keys[i];
	            for(j = 0; j < attrIndices.length; j++) {
	                // Use hasOwnPropety to protect against falsey values:
	                if(!attrUpdate[key].hasOwnProperty(j)) {
	                    attrUpdate[key][j] = undefined;
	                }
	            }
	        }
	
	        Registry.call('_guiRestyle', gd, attrUpdate, attrIndices);
	    }
	};
	
	},{"../../lib":716,"../../registry":845}],645:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	exports.isGrouped = function isGrouped(legendLayout) {
	    return (legendLayout.traceorder || '').indexOf('grouped') !== -1;
	};
	
	exports.isVertical = function isVertical(legendLayout) {
	    return legendLayout.orientation !== 'h';
	};
	
	exports.isReversed = function isReversed(legendLayout) {
	    return (legendLayout.traceorder || '').indexOf('reversed') !== -1;
	};
	
	},{}],646:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = {
	    moduleType: 'component',
	    name: 'legend',
	
	    layoutAttributes: _dereq_('./attributes'),
	    supplyLayoutDefaults: _dereq_('./defaults'),
	
	    draw: _dereq_('./draw'),
	    style: _dereq_('./style')
	};
	
	},{"./attributes":639,"./defaults":641,"./draw":642,"./style":647}],647:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var extractOpts = _dereq_('../colorscale/helpers').extractOpts;
	
	var subTypes = _dereq_('../../traces/scatter/subtypes');
	var stylePie = _dereq_('../../traces/pie/style_one');
	var pieCastOption = _dereq_('../../traces/pie/helpers').castOption;
	
	var CST_MARKER_SIZE = 12;
	var CST_LINE_WIDTH = 5;
	var CST_MARKER_LINE_WIDTH = 2;
	var MAX_LINE_WIDTH = 10;
	var MAX_MARKER_LINE_WIDTH = 5;
	
	module.exports = function style(s, gd) {
	    var fullLayout = gd._fullLayout;
	    var legend = fullLayout.legend;
	    var constantItemSizing = legend.itemsizing === 'constant';
	
	    var boundLineWidth = function(mlw, cont, max, cst) {
	        var v;
	        if(mlw + 1) {
	            v = mlw;
	        } else if(cont && cont.width > 0) {
	            v = cont.width;
	        } else {
	            return 0;
	        }
	        return constantItemSizing ? cst : Math.min(v, max);
	    };
	
	    s.each(function(d) {
	        var traceGroup = d3.select(this);
	
	        var layers = Lib.ensureSingle(traceGroup, 'g', 'layers');
	        layers.style('opacity', d[0].trace.opacity);
	
	        var valign = legend.valign;
	        var lineHeight = d[0].lineHeight;
	        var height = d[0].height;
	
	        if(valign === 'middle' || !lineHeight || !height) {
	            layers.attr('transform', null);
	        } else {
	            var factor = {top: 1, bottom: -1}[valign];
	            var markerOffsetY = factor * (0.5 * (lineHeight - height + 3));
	            layers.attr('transform', 'translate(0,' + markerOffsetY + ')');
	        }
	
	        var fill = layers
	            .selectAll('g.legendfill')
	                .data([d]);
	        fill.enter().append('g')
	            .classed('legendfill', true);
	
	        var line = layers
	            .selectAll('g.legendlines')
	                .data([d]);
	        line.enter().append('g')
	            .classed('legendlines', true);
	
	        var symbol = layers
	            .selectAll('g.legendsymbols')
	                .data([d]);
	        symbol.enter().append('g')
	            .classed('legendsymbols', true);
	
	        symbol.selectAll('g.legendpoints')
	            .data([d])
	          .enter().append('g')
	            .classed('legendpoints', true);
	    })
	    .each(styleWaterfalls)
	    .each(styleFunnels)
	    .each(styleBars)
	    .each(styleBoxes)
	    .each(styleFunnelareas)
	    .each(stylePies)
	    .each(styleLines)
	    .each(stylePoints)
	    .each(styleCandles)
	    .each(styleOHLC);
	
	    function styleLines(d) {
	        var d0 = d[0];
	        var trace = d0.trace;
	        var showFill = trace.visible && trace.fill && trace.fill !== 'none';
	        var showLine = subTypes.hasLines(trace);
	        var contours = trace.contours;
	        var showGradientLine = false;
	        var showGradientFill = false;
	        var dMod, tMod;
	
	        var cOpts = extractOpts(trace);
	        var colorscale = cOpts.colorscale;
	        var reversescale = cOpts.reversescale;
	
	        var fillGradient = function(s) {
	            if(s.size()) {
	                var gradientID = 'legendfill-' + trace.uid;
	                Drawing.gradient(s, gd, gradientID,
	                    getGradientDirection(reversescale),
	                    colorscale, 'fill');
	            }
	        };
	
	        var lineGradient = function(s) {
	            if(s.size()) {
	                var gradientID = 'legendline-' + trace.uid;
	                Drawing.lineGroupStyle(s);
	                Drawing.gradient(s, gd, gradientID,
	                    getGradientDirection(reversescale),
	                    colorscale, 'stroke');
	            }
	        };
	
	        if(contours) {
	            var coloring = contours.coloring;
	
	            if(coloring === 'lines') {
	                showGradientLine = true;
	            } else {
	                showLine = coloring === 'none' || coloring === 'heatmap' || contours.showlines;
	            }
	
	            if(contours.type === 'constraint') {
	                showFill = contours._operation !== '=';
	            } else if(coloring === 'fill' || coloring === 'heatmap') {
	                showGradientFill = true;
	            }
	        }
	
	        // with fill and no markers or text, move the line and fill up a bit
	        // so it's more centered
	        var markersOrText = subTypes.hasMarkers(trace) || subTypes.hasText(trace);
	        var anyFill = showFill || showGradientFill;
	        var anyLine = showLine || showGradientLine;
	        var pathStart = (markersOrText || !anyFill) ? 'M5,0' :
	            // with a line leave it slightly below center, to leave room for the
	            // line thickness and because the line is usually more prominent
	            anyLine ? 'M5,-2' : 'M5,-3';
	
	        var this3 = d3.select(this);
	
	        var fill = this3.select('.legendfill').selectAll('path')
	            .data(showFill || showGradientFill ? [d] : []);
	        fill.enter().append('path').classed('js-fill', true);
	        fill.exit().remove();
	        fill.attr('d', pathStart + 'h30v6h-30z')
	            .call(showFill ? Drawing.fillGroupStyle : fillGradient);
	
	        if(showLine || showGradientLine) {
	            var lw = boundLineWidth(undefined, trace.line, MAX_LINE_WIDTH, CST_LINE_WIDTH);
	            tMod = Lib.minExtend(trace, {line: {width: lw}});
	            dMod = [Lib.minExtend(d0, {trace: tMod})];
	        }
	
	        var line = this3.select('.legendlines').selectAll('path')
	            .data(showLine || showGradientLine ? [dMod] : []);
	        line.enter().append('path').classed('js-line', true);
	        line.exit().remove();
	
	        // this is ugly... but you can't apply a gradient to a perfectly
	        // horizontal or vertical line. Presumably because then
	        // the system doesn't know how to scale vertical variation, even
	        // though there *is* no vertical variation in this case.
	        // so add an invisibly small angle to the line
	        // This issue (and workaround) exist across (Mac) Chrome, FF, and Safari
	        line.attr('d', pathStart + (showGradientLine ? 'l30,0.0001' : 'h30'))
	            .call(showLine ? Drawing.lineGroupStyle : lineGradient);
	    }
	
	    function stylePoints(d) {
	        var d0 = d[0];
	        var trace = d0.trace;
	        var showMarkers = subTypes.hasMarkers(trace);
	        var showText = subTypes.hasText(trace);
	        var showLines = subTypes.hasLines(trace);
	        var dMod, tMod;
	
	        // 'scatter3d' don't use gd.calcdata,
	        // use d0.trace to infer arrayOk attributes
	
	        function boundVal(attrIn, arrayToValFn, bounds, cst) {
	            var valIn = Lib.nestedProperty(trace, attrIn).get();
	            var valToBound = (Lib.isArrayOrTypedArray(valIn) && arrayToValFn) ?
	                arrayToValFn(valIn) :
	                valIn;
	
	            if(constantItemSizing && valToBound && cst !== undefined) {
	                valToBound = cst;
	            }
	
	            if(bounds) {
	                if(valToBound < bounds[0]) return bounds[0];
	                else if(valToBound > bounds[1]) return bounds[1];
	            }
	            return valToBound;
	        }
	
	        function pickFirst(array) { return array[0]; }
	
	        // constrain text, markers, etc so they'll fit on the legend
	        if(showMarkers || showText || showLines) {
	            var dEdit = {};
	            var tEdit = {};
	
	            if(showMarkers) {
	                dEdit.mc = boundVal('marker.color', pickFirst);
	                dEdit.mx = boundVal('marker.symbol', pickFirst);
	                dEdit.mo = boundVal('marker.opacity', Lib.mean, [0.2, 1]);
	                dEdit.mlc = boundVal('marker.line.color', pickFirst);
	                dEdit.mlw = boundVal('marker.line.width', Lib.mean, [0, 5], CST_MARKER_LINE_WIDTH);
	                tEdit.marker = {
	                    sizeref: 1,
	                    sizemin: 1,
	                    sizemode: 'diameter'
	                };
	
	                var ms = boundVal('marker.size', Lib.mean, [2, 16], CST_MARKER_SIZE);
	                dEdit.ms = ms;
	                tEdit.marker.size = ms;
	            }
	
	            if(showLines) {
	                tEdit.line = {
	                    width: boundVal('line.width', pickFirst, [0, 10], CST_LINE_WIDTH)
	                };
	            }
	
	            if(showText) {
	                dEdit.tx = 'Aa';
	                dEdit.tp = boundVal('textposition', pickFirst);
	                dEdit.ts = 10;
	                dEdit.tc = boundVal('textfont.color', pickFirst);
	                dEdit.tf = boundVal('textfont.family', pickFirst);
	            }
	
	            dMod = [Lib.minExtend(d0, dEdit)];
	            tMod = Lib.minExtend(trace, tEdit);
	
	            // always show legend items in base state
	            tMod.selectedpoints = null;
	
	            // never show texttemplate
	            tMod.texttemplate = null;
	        }
	
	        var ptgroup = d3.select(this).select('g.legendpoints');
	
	        var pts = ptgroup.selectAll('path.scatterpts')
	            .data(showMarkers ? dMod : []);
	        // make sure marker is on the bottom, in case it enters after text
	        pts.enter().insert('path', ':first-child')
	            .classed('scatterpts', true)
	            .attr('transform', 'translate(20,0)');
	        pts.exit().remove();
	        pts.call(Drawing.pointStyle, tMod, gd);
	
	        // 'mrc' is set in pointStyle and used in textPointStyle:
	        // constrain it here
	        if(showMarkers) dMod[0].mrc = 3;
	
	        var txt = ptgroup.selectAll('g.pointtext')
	            .data(showText ? dMod : []);
	        txt.enter()
	            .append('g').classed('pointtext', true)
	                .append('text').attr('transform', 'translate(20,0)');
	        txt.exit().remove();
	        txt.selectAll('text').call(Drawing.textPointStyle, tMod, gd);
	    }
	
	    function styleWaterfalls(d) {
	        var trace = d[0].trace;
	
	        var ptsData = [];
	        if(trace.visible && trace.type === 'waterfall') {
	            ptsData = d[0].hasTotals ?
	                [['increasing', 'M-6,-6V6H0Z'], ['totals', 'M6,6H0L-6,-6H-0Z'], ['decreasing', 'M6,6V-6H0Z']] :
	                [['increasing', 'M-6,-6V6H6Z'], ['decreasing', 'M6,6V-6H-6Z']];
	        }
	
	        var pts = d3.select(this).select('g.legendpoints')
	            .selectAll('path.legendwaterfall')
	            .data(ptsData);
	        pts.enter().append('path').classed('legendwaterfall', true)
	            .attr('transform', 'translate(20,0)')
	            .style('stroke-miterlimit', 1);
	        pts.exit().remove();
	
	        pts.each(function(dd) {
	            var pt = d3.select(this);
	            var cont = trace[dd[0]].marker;
	            var lw = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	            pt.attr('d', dd[1])
	                .style('stroke-width', lw + 'px')
	                .call(Color.fill, cont.color);
	
	            if(lw) {
	                pt.call(Color.stroke, cont.line.color);
	            }
	        });
	    }
	
	    function styleBars(d) {
	        styleBarLike(d, this);
	    }
	
	    function styleFunnels(d) {
	        styleBarLike(d, this, 'funnel');
	    }
	
	    function styleBarLike(d, lThis, desiredType) {
	        var trace = d[0].trace;
	        var marker = trace.marker || {};
	        var markerLine = marker.line || {};
	
	        var isVisible = (!desiredType) ? Registry.traceIs(trace, 'bar') :
	            (trace.visible && trace.type === desiredType);
	
	        var barpath = d3.select(lThis).select('g.legendpoints')
	            .selectAll('path.legend' + desiredType)
	            .data(isVisible ? [d] : []);
	        barpath.enter().append('path').classed('legend' + desiredType, true)
	            .attr('d', 'M6,6H-6V-6H6Z')
	            .attr('transform', 'translate(20,0)');
	        barpath.exit().remove();
	
	        barpath.each(function(d) {
	            var p = d3.select(this);
	            var d0 = d[0];
	            var w = boundLineWidth(d0.mlw, marker.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	            p.style('stroke-width', w + 'px')
	                .call(Color.fill, d0.mc || marker.color);
	
	            if(w) Color.stroke(p, d0.mlc || markerLine.color);
	        });
	    }
	
	    function styleBoxes(d) {
	        var trace = d[0].trace;
	
	        var pts = d3.select(this).select('g.legendpoints')
	            .selectAll('path.legendbox')
	            .data(trace.visible && Registry.traceIs(trace, 'box-violin') ? [d] : []);
	        pts.enter().append('path').classed('legendbox', true)
	            // if we want the median bar, prepend M6,0H-6
	            .attr('d', 'M6,6H-6V-6H6Z')
	            .attr('transform', 'translate(20,0)');
	        pts.exit().remove();
	
	        pts.each(function() {
	            var p = d3.select(this);
	
	            if((trace.boxpoints === 'all' || trace.points === 'all') &&
	                Color.opacity(trace.fillcolor) === 0 && Color.opacity((trace.line || {}).color) === 0
	            ) {
	                var tMod = Lib.minExtend(trace, {
	                    marker: {
	                        size: constantItemSizing ? CST_MARKER_SIZE : Lib.constrain(trace.marker.size, 2, 16),
	                        sizeref: 1,
	                        sizemin: 1,
	                        sizemode: 'diameter'
	                    }
	                });
	                pts.call(Drawing.pointStyle, tMod, gd);
	            } else {
	                var w = boundLineWidth(undefined, trace.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	                p.style('stroke-width', w + 'px')
	                    .call(Color.fill, trace.fillcolor);
	
	                if(w) Color.stroke(p, trace.line.color);
	            }
	        });
	    }
	
	    function styleCandles(d) {
	        var trace = d[0].trace;
	
	        var pts = d3.select(this).select('g.legendpoints')
	            .selectAll('path.legendcandle')
	            .data(trace.visible && trace.type === 'candlestick' ? [d, d] : []);
	        pts.enter().append('path').classed('legendcandle', true)
	            .attr('d', function(_, i) {
	                if(i) return 'M-15,0H-8M-8,6V-6H8Z'; // increasing
	                return 'M15,0H8M8,-6V6H-8Z'; // decreasing
	            })
	            .attr('transform', 'translate(20,0)')
	            .style('stroke-miterlimit', 1);
	        pts.exit().remove();
	
	        pts.each(function(_, i) {
	            var p = d3.select(this);
	            var cont = trace[i ? 'increasing' : 'decreasing'];
	            var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	            p.style('stroke-width', w + 'px')
	                .call(Color.fill, cont.fillcolor);
	
	            if(w) Color.stroke(p, cont.line.color);
	        });
	    }
	
	    function styleOHLC(d) {
	        var trace = d[0].trace;
	
	        var pts = d3.select(this).select('g.legendpoints')
	            .selectAll('path.legendohlc')
	            .data(trace.visible && trace.type === 'ohlc' ? [d, d] : []);
	        pts.enter().append('path').classed('legendohlc', true)
	            .attr('d', function(_, i) {
	                if(i) return 'M-15,0H0M-8,-6V0'; // increasing
	                return 'M15,0H0M8,6V0'; // decreasing
	            })
	            .attr('transform', 'translate(20,0)')
	            .style('stroke-miterlimit', 1);
	        pts.exit().remove();
	
	        pts.each(function(_, i) {
	            var p = d3.select(this);
	            var cont = trace[i ? 'increasing' : 'decreasing'];
	            var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	            p.style('fill', 'none')
	                .call(Drawing.dashLine, cont.line.dash, w);
	
	            if(w) Color.stroke(p, cont.line.color);
	        });
	    }
	
	    function stylePies(d) {
	        stylePieLike(d, this, 'pie');
	    }
	
	    function styleFunnelareas(d) {
	        stylePieLike(d, this, 'funnelarea');
	    }
	
	    function stylePieLike(d, lThis, desiredType) {
	        var d0 = d[0];
	        var trace = d0.trace;
	
	        var isVisible = (!desiredType) ? Registry.traceIs(trace, desiredType) :
	            (trace.visible && trace.type === desiredType);
	
	        var pts = d3.select(lThis).select('g.legendpoints')
	            .selectAll('path.legend' + desiredType)
	            .data(isVisible ? [d] : []);
	        pts.enter().append('path').classed('legend' + desiredType, true)
	            .attr('d', 'M6,6H-6V-6H6Z')
	            .attr('transform', 'translate(20,0)');
	        pts.exit().remove();
	
	        if(pts.size()) {
	            var cont = (trace.marker || {}).line;
	            var lw = boundLineWidth(pieCastOption(cont.width, d0.pts), cont, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	
	            var tMod = Lib.minExtend(trace, {marker: {line: {width: lw}}});
	            // since minExtend do not slice more than 3 items we need to patch line.color here
	            tMod.marker.line.color = cont.color;
	
	            var d0Mod = Lib.minExtend(d0, {trace: tMod});
	
	            stylePie(pts, d0Mod, tMod);
	        }
	    }
	};
	
	function getGradientDirection(reversescale) {
	    return reversescale ? 'horizontal' : 'horizontalreversed';
	}
	
	},{"../../lib":716,"../../registry":845,"../../traces/pie/helpers":1097,"../../traces/pie/style_one":1103,"../../traces/scatter/subtypes":1142,"../color":591,"../colorscale/helpers":602,"../drawing":612,"d3":164}],648:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Plots = _dereq_('../../plots/plots');
	var axisIds = _dereq_('../../plots/cartesian/axis_ids');
	var Lib = _dereq_('../../lib');
	var Icons = _dereq_('../../fonts/ploticon');
	
	var _ = Lib._;
	
	var modeBarButtons = module.exports = {};
	
	/**
	 * ModeBar buttons configuration
	 *
	 * @param {string} name
	 *      name / id of the buttons (for tracking)
	 * @param {string} title
	 *      text that appears while hovering over the button,
	 *      enter null, false or '' for no hover text
	 * @param {string} icon
	 *      svg icon object associated with the button
	 *      can be linked to Plotly.Icons to use the default plotly icons
	 * @param {string} [gravity]
	 *      icon positioning
	 * @param {function} click
	 *      click handler associated with the button, a function of
	 *      'gd' (the main graph object) and
	 *      'ev' (the event object)
	 * @param {string} [attr]
	 *      attribute associated with button,
	 *      use this with 'val' to keep track of the state
	 * @param {*} [val]
	 *      initial 'attr' value, can be a function of gd
	 * @param {boolean} [toggle]
	 *      is the button a toggle button?
	 */
	modeBarButtons.toImage = {
	    name: 'toImage',
	    title: function(gd) {
	        var opts = gd._context.toImageButtonOptions || {};
	        var format = opts.format || 'png';
	        return format === 'png' ?
	            _(gd, 'Download plot as a png') : // legacy text
	            _(gd, 'Download plot'); // generic non-PNG text
	    },
	    icon: Icons.camera,
	    click: function(gd) {
	        var toImageButtonOptions = gd._context.toImageButtonOptions;
	        var opts = {format: toImageButtonOptions.format || 'png'};
	
	        Lib.notifier(_(gd, 'Taking snapshot - this may take a few seconds'), 'long');
	
	        if(opts.format !== 'svg' && Lib.isIE()) {
	            Lib.notifier(_(gd, 'IE only supports svg.  Changing format to svg.'), 'long');
	            opts.format = 'svg';
	        }
	
	        ['filename', 'width', 'height', 'scale'].forEach(function(key) {
	            if(key in toImageButtonOptions) {
	                opts[key] = toImageButtonOptions[key];
	            }
	        });
	
	        Registry.call('downloadImage', gd, opts)
	          .then(function(filename) {
	              Lib.notifier(_(gd, 'Snapshot succeeded') + ' - ' + filename, 'long');
	          })
	          .catch(function() {
	              Lib.notifier(_(gd, 'Sorry, there was a problem downloading your snapshot!'), 'long');
	          });
	    }
	};
	
	modeBarButtons.sendDataToCloud = {
	    name: 'sendDataToCloud',
	    title: function(gd) { return _(gd, 'Edit in Chart Studio'); },
	    icon: Icons.disk,
	    click: function(gd) {
	        Plots.sendDataToCloud(gd);
	    }
	};
	
	modeBarButtons.editInChartStudio = {
	    name: 'editInChartStudio',
	    title: function(gd) { return _(gd, 'Edit in Chart Studio'); },
	    icon: Icons.pencil,
	    click: function(gd) {
	        Plots.sendDataToCloud(gd);
	    }
	};
	
	modeBarButtons.zoom2d = {
	    name: 'zoom2d',
	    title: function(gd) { return _(gd, 'Zoom'); },
	    attr: 'dragmode',
	    val: 'zoom',
	    icon: Icons.zoombox,
	    click: handleCartesian
	};
	
	modeBarButtons.pan2d = {
	    name: 'pan2d',
	    title: function(gd) { return _(gd, 'Pan'); },
	    attr: 'dragmode',
	    val: 'pan',
	    icon: Icons.pan,
	    click: handleCartesian
	};
	
	modeBarButtons.select2d = {
	    name: 'select2d',
	    title: function(gd) { return _(gd, 'Box Select'); },
	    attr: 'dragmode',
	    val: 'select',
	    icon: Icons.selectbox,
	    click: handleCartesian
	};
	
	modeBarButtons.lasso2d = {
	    name: 'lasso2d',
	    title: function(gd) { return _(gd, 'Lasso Select'); },
	    attr: 'dragmode',
	    val: 'lasso',
	    icon: Icons.lasso,
	    click: handleCartesian
	};
	
	modeBarButtons.zoomIn2d = {
	    name: 'zoomIn2d',
	    title: function(gd) { return _(gd, 'Zoom in'); },
	    attr: 'zoom',
	    val: 'in',
	    icon: Icons.zoom_plus,
	    click: handleCartesian
	};
	
	modeBarButtons.zoomOut2d = {
	    name: 'zoomOut2d',
	    title: function(gd) { return _(gd, 'Zoom out'); },
	    attr: 'zoom',
	    val: 'out',
	    icon: Icons.zoom_minus,
	    click: handleCartesian
	};
	
	modeBarButtons.autoScale2d = {
	    name: 'autoScale2d',
	    title: function(gd) { return _(gd, 'Autoscale'); },
	    attr: 'zoom',
	    val: 'auto',
	    icon: Icons.autoscale,
	    click: handleCartesian
	};
	
	modeBarButtons.resetScale2d = {
	    name: 'resetScale2d',
	    title: function(gd) { return _(gd, 'Reset axes'); },
	    attr: 'zoom',
	    val: 'reset',
	    icon: Icons.home,
	    click: handleCartesian
	};
	
	modeBarButtons.hoverClosestCartesian = {
	    name: 'hoverClosestCartesian',
	    title: function(gd) { return _(gd, 'Show closest data on hover'); },
	    attr: 'hovermode',
	    val: 'closest',
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: handleCartesian
	};
	
	modeBarButtons.hoverCompareCartesian = {
	    name: 'hoverCompareCartesian',
	    title: function(gd) { return _(gd, 'Compare data on hover'); },
	    attr: 'hovermode',
	    val: function(gd) {
	        return gd._fullLayout._isHoriz ? 'y' : 'x';
	    },
	    icon: Icons.tooltip_compare,
	    gravity: 'ne',
	    click: handleCartesian
	};
	
	function handleCartesian(gd, ev) {
	    var button = ev.currentTarget;
	    var astr = button.getAttribute('data-attr');
	    var val = button.getAttribute('data-val') || true;
	    var fullLayout = gd._fullLayout;
	    var aobj = {};
	    var axList = axisIds.list(gd, null, true);
	    var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
	
	    var ax, i;
	
	    if(astr === 'zoom') {
	        var mag = (val === 'in') ? 0.5 : 2;
	        var r0 = (1 + mag) / 2;
	        var r1 = (1 - mag) / 2;
	        var axName;
	
	        for(i = 0; i < axList.length; i++) {
	            ax = axList[i];
	
	            if(!ax.fixedrange) {
	                axName = ax._name;
	                if(val === 'auto') {
	                    aobj[axName + '.autorange'] = true;
	                } else if(val === 'reset') {
	                    if(ax._rangeInitial === undefined) {
	                        aobj[axName + '.autorange'] = true;
	                    } else {
	                        var rangeInitial = ax._rangeInitial.slice();
	                        aobj[axName + '.range[0]'] = rangeInitial[0];
	                        aobj[axName + '.range[1]'] = rangeInitial[1];
	                    }
	
	                    // N.B. "reset" also resets showspikes
	                    if(ax._showSpikeInitial !== undefined) {
	                        aobj[axName + '.showspikes'] = ax._showSpikeInitial;
	                        if(allSpikesEnabled === 'on' && !ax._showSpikeInitial) {
	                            allSpikesEnabled = 'off';
	                        }
	                    }
	                } else {
	                    var rangeNow = [
	                        ax.r2l(ax.range[0]),
	                        ax.r2l(ax.range[1]),
	                    ];
	
	                    var rangeNew = [
	                        r0 * rangeNow[0] + r1 * rangeNow[1],
	                        r0 * rangeNow[1] + r1 * rangeNow[0]
	                    ];
	
	                    aobj[axName + '.range[0]'] = ax.l2r(rangeNew[0]);
	                    aobj[axName + '.range[1]'] = ax.l2r(rangeNew[1]);
	                }
	            }
	        }
	    } else {
	        // if ALL traces have orientation 'h', 'hovermode': 'x' otherwise: 'y'
	        if(astr === 'hovermode' && (val === 'x' || val === 'y')) {
	            val = fullLayout._isHoriz ? 'y' : 'x';
	            button.setAttribute('data-val', val);
	        }
	
	        aobj[astr] = val;
	    }
	
	    fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
	
	    Registry.call('_guiRelayout', gd, aobj);
	}
	
	modeBarButtons.zoom3d = {
	    name: 'zoom3d',
	    title: function(gd) { return _(gd, 'Zoom'); },
	    attr: 'scene.dragmode',
	    val: 'zoom',
	    icon: Icons.zoombox,
	    click: handleDrag3d
	};
	
	modeBarButtons.pan3d = {
	    name: 'pan3d',
	    title: function(gd) { return _(gd, 'Pan'); },
	    attr: 'scene.dragmode',
	    val: 'pan',
	    icon: Icons.pan,
	    click: handleDrag3d
	};
	
	modeBarButtons.orbitRotation = {
	    name: 'orbitRotation',
	    title: function(gd) { return _(gd, 'Orbital rotation'); },
	    attr: 'scene.dragmode',
	    val: 'orbit',
	    icon: Icons['3d_rotate'],
	    click: handleDrag3d
	};
	
	modeBarButtons.tableRotation = {
	    name: 'tableRotation',
	    title: function(gd) { return _(gd, 'Turntable rotation'); },
	    attr: 'scene.dragmode',
	    val: 'turntable',
	    icon: Icons['z-axis'],
	    click: handleDrag3d
	};
	
	function handleDrag3d(gd, ev) {
	    var button = ev.currentTarget;
	    var attr = button.getAttribute('data-attr');
	    var val = button.getAttribute('data-val') || true;
	    var sceneIds = gd._fullLayout._subplots.gl3d;
	    var layoutUpdate = {};
	
	    var parts = attr.split('.');
	
	    for(var i = 0; i < sceneIds.length; i++) {
	        layoutUpdate[sceneIds[i] + '.' + parts[1]] = val;
	    }
	
	    // for multi-type subplots
	    var val2d = (val === 'pan') ? val : 'zoom';
	    layoutUpdate.dragmode = val2d;
	
	    Registry.call('_guiRelayout', gd, layoutUpdate);
	}
	
	modeBarButtons.resetCameraDefault3d = {
	    name: 'resetCameraDefault3d',
	    title: function(gd) { return _(gd, 'Reset camera to default'); },
	    attr: 'resetDefault',
	    icon: Icons.home,
	    click: handleCamera3d
	};
	
	modeBarButtons.resetCameraLastSave3d = {
	    name: 'resetCameraLastSave3d',
	    title: function(gd) { return _(gd, 'Reset camera to last save'); },
	    attr: 'resetLastSave',
	    icon: Icons.movie,
	    click: handleCamera3d
	};
	
	function handleCamera3d(gd, ev) {
	    var button = ev.currentTarget;
	    var attr = button.getAttribute('data-attr');
	    var fullLayout = gd._fullLayout;
	    var sceneIds = fullLayout._subplots.gl3d || [];
	    var aobj = {};
	
	    for(var i = 0; i < sceneIds.length; i++) {
	        var sceneId = sceneIds[i];
	        var camera = sceneId + '.camera';
	        var aspectratio = sceneId + '.aspectratio';
	        var scene = fullLayout[sceneId]._scene;
	        var didUpdate;
	
	        if(attr === 'resetLastSave') {
	            aobj[camera + '.up'] = scene.viewInitial.up;
	            aobj[camera + '.eye'] = scene.viewInitial.eye;
	            aobj[camera + '.center'] = scene.viewInitial.center;
	            didUpdate = true;
	        } else if(attr === 'resetDefault') {
	            aobj[camera + '.up'] = null;
	            aobj[camera + '.eye'] = null;
	            aobj[camera + '.center'] = null;
	            didUpdate = true;
	        }
	
	        if(didUpdate) {
	            aobj[aspectratio + '.x'] = scene.viewInitial.aspectratio.x;
	            aobj[aspectratio + '.y'] = scene.viewInitial.aspectratio.y;
	            aobj[aspectratio + '.z'] = scene.viewInitial.aspectratio.z;
	        }
	    }
	
	    Registry.call('_guiRelayout', gd, aobj);
	}
	
	modeBarButtons.hoverClosest3d = {
	    name: 'hoverClosest3d',
	    title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
	    attr: 'hovermode',
	    val: null,
	    toggle: true,
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: handleHover3d
	};
	
	function getNextHover3d(gd, ev) {
	    var button = ev.currentTarget;
	    var val = button._previousVal;
	    var fullLayout = gd._fullLayout;
	    var sceneIds = fullLayout._subplots.gl3d || [];
	
	    var axes = ['xaxis', 'yaxis', 'zaxis'];
	
	    // initialize 'current spike' object to be stored in the DOM
	    var currentSpikes = {};
	    var layoutUpdate = {};
	
	    if(val) {
	        layoutUpdate = val;
	        button._previousVal = null;
	    } else {
	        for(var i = 0; i < sceneIds.length; i++) {
	            var sceneId = sceneIds[i];
	            var sceneLayout = fullLayout[sceneId];
	
	            var hovermodeAStr = sceneId + '.hovermode';
	            currentSpikes[hovermodeAStr] = sceneLayout.hovermode;
	            layoutUpdate[hovermodeAStr] = false;
	
	            // copy all the current spike attrs
	            for(var j = 0; j < 3; j++) {
	                var axis = axes[j];
	                var spikeAStr = sceneId + '.' + axis + '.showspikes';
	                layoutUpdate[spikeAStr] = false;
	                currentSpikes[spikeAStr] = sceneLayout[axis].showspikes;
	            }
	        }
	
	        button._previousVal = currentSpikes;
	    }
	    return layoutUpdate;
	}
	
	function handleHover3d(gd, ev) {
	    var layoutUpdate = getNextHover3d(gd, ev);
	    Registry.call('_guiRelayout', gd, layoutUpdate);
	}
	
	modeBarButtons.zoomInGeo = {
	    name: 'zoomInGeo',
	    title: function(gd) { return _(gd, 'Zoom in'); },
	    attr: 'zoom',
	    val: 'in',
	    icon: Icons.zoom_plus,
	    click: handleGeo
	};
	
	modeBarButtons.zoomOutGeo = {
	    name: 'zoomOutGeo',
	    title: function(gd) { return _(gd, 'Zoom out'); },
	    attr: 'zoom',
	    val: 'out',
	    icon: Icons.zoom_minus,
	    click: handleGeo
	};
	
	modeBarButtons.resetGeo = {
	    name: 'resetGeo',
	    title: function(gd) { return _(gd, 'Reset'); },
	    attr: 'reset',
	    val: null,
	    icon: Icons.autoscale,
	    click: handleGeo
	};
	
	modeBarButtons.hoverClosestGeo = {
	    name: 'hoverClosestGeo',
	    title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
	    attr: 'hovermode',
	    val: null,
	    toggle: true,
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: toggleHover
	};
	
	function handleGeo(gd, ev) {
	    var button = ev.currentTarget;
	    var attr = button.getAttribute('data-attr');
	    var val = button.getAttribute('data-val') || true;
	    var fullLayout = gd._fullLayout;
	    var geoIds = fullLayout._subplots.geo;
	
	    for(var i = 0; i < geoIds.length; i++) {
	        var id = geoIds[i];
	        var geoLayout = fullLayout[id];
	
	        if(attr === 'zoom') {
	            var scale = geoLayout.projection.scale;
	            var newScale = (val === 'in') ? 2 * scale : 0.5 * scale;
	
	            Registry.call('_guiRelayout', gd, id + '.projection.scale', newScale);
	        } else if(attr === 'reset') {
	            resetView(gd, 'geo');
	        }
	    }
	}
	
	modeBarButtons.hoverClosestGl2d = {
	    name: 'hoverClosestGl2d',
	    title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
	    attr: 'hovermode',
	    val: null,
	    toggle: true,
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: toggleHover
	};
	
	modeBarButtons.hoverClosestPie = {
	    name: 'hoverClosestPie',
	    title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
	    attr: 'hovermode',
	    val: 'closest',
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: toggleHover
	};
	
	function getNextHover(gd) {
	    var fullLayout = gd._fullLayout;
	
	    if(fullLayout.hovermode) return false;
	
	    if(fullLayout._has('cartesian')) {
	        return fullLayout._isHoriz ? 'y' : 'x';
	    }
	    return 'closest';
	}
	
	function toggleHover(gd) {
	    var newHover = getNextHover(gd);
	    Registry.call('_guiRelayout', gd, 'hovermode', newHover);
	}
	
	modeBarButtons.resetViewSankey = {
	    name: 'resetSankeyGroup',
	    title: function(gd) { return _(gd, 'Reset view'); },
	    icon: Icons.home,
	    click: function(gd) {
	        var aObj = {
	            'node.groups': [],
	            'node.x': [],
	            'node.y': []
	        };
	        for(var i = 0; i < gd._fullData.length; i++) {
	            var viewInitial = gd._fullData[i]._viewInitial;
	            aObj['node.groups'].push(viewInitial.node.groups.slice());
	            aObj['node.x'].push(viewInitial.node.x.slice());
	            aObj['node.y'].push(viewInitial.node.y.slice());
	        }
	        Registry.call('restyle', gd, aObj);
	    }
	};
	
	// buttons when more then one plot types are present
	
	modeBarButtons.toggleHover = {
	    name: 'toggleHover',
	    title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
	    attr: 'hovermode',
	    val: null,
	    toggle: true,
	    icon: Icons.tooltip_basic,
	    gravity: 'ne',
	    click: function(gd, ev) {
	        var layoutUpdate = getNextHover3d(gd, ev);
	        layoutUpdate.hovermode = getNextHover(gd);
	
	        Registry.call('_guiRelayout', gd, layoutUpdate);
	    }
	};
	
	modeBarButtons.resetViews = {
	    name: 'resetViews',
	    title: function(gd) { return _(gd, 'Reset views'); },
	    icon: Icons.home,
	    click: function(gd, ev) {
	        var button = ev.currentTarget;
	
	        button.setAttribute('data-attr', 'zoom');
	        button.setAttribute('data-val', 'reset');
	        handleCartesian(gd, ev);
	
	        button.setAttribute('data-attr', 'resetLastSave');
	        handleCamera3d(gd, ev);
	
	        resetView(gd, 'geo');
	        resetView(gd, 'mapbox');
	    }
	};
	
	modeBarButtons.toggleSpikelines = {
	    name: 'toggleSpikelines',
	    title: function(gd) { return _(gd, 'Toggle Spike Lines'); },
	    icon: Icons.spikeline,
	    attr: '_cartesianSpikesEnabled',
	    val: 'on',
	    click: function(gd) {
	        var fullLayout = gd._fullLayout;
	        var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
	
	        fullLayout._cartesianSpikesEnabled = allSpikesEnabled === 'on' ? 'off' : 'on';
	        Registry.call('_guiRelayout', gd, setSpikelineVisibility(gd));
	    }
	};
	
	function setSpikelineVisibility(gd) {
	    var fullLayout = gd._fullLayout;
	    var areSpikesOn = fullLayout._cartesianSpikesEnabled === 'on';
	    var axList = axisIds.list(gd, null, true);
	    var aobj = {};
	
	    for(var i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        aobj[ax._name + '.showspikes'] = areSpikesOn ? true : ax._showSpikeInitial;
	    }
	
	    return aobj;
	}
	
	modeBarButtons.resetViewMapbox = {
	    name: 'resetViewMapbox',
	    title: function(gd) { return _(gd, 'Reset view'); },
	    attr: 'reset',
	    icon: Icons.home,
	    click: function(gd) {
	        resetView(gd, 'mapbox');
	    }
	};
	
	function resetView(gd, subplotType) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots[subplotType] || [];
	    var aObj = {};
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var id = subplotIds[i];
	        var subplotObj = fullLayout[id]._subplot;
	        var viewInitial = subplotObj.viewInitial;
	        var viewKeys = Object.keys(viewInitial);
	
	        for(var j = 0; j < viewKeys.length; j++) {
	            var key = viewKeys[j];
	            aObj[id + '.' + key] = viewInitial[key];
	        }
	    }
	
	    Registry.call('_guiRelayout', gd, aObj);
	}
	
	},{"../../fonts/ploticon":696,"../../lib":716,"../../plots/cartesian/axis_ids":767,"../../plots/plots":825,"../../registry":845}],649:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	exports.manage = _dereq_('./manage');
	
	},{"./manage":650}],650:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var axisIds = _dereq_('../../plots/cartesian/axis_ids');
	var scatterSubTypes = _dereq_('../../traces/scatter/subtypes');
	var Registry = _dereq_('../../registry');
	
	var createModeBar = _dereq_('./modebar');
	var modeBarButtons = _dereq_('./buttons');
	
	/**
	 * ModeBar wrapper around 'create' and 'update',
	 * chooses buttons to pass to ModeBar constructor based on
	 * plot type and plot config.
	 *
	 * @param {object} gd main plot object
	 *
	 */
	module.exports = function manageModeBar(gd) {
	    var fullLayout = gd._fullLayout;
	    var context = gd._context;
	    var modeBar = fullLayout._modeBar;
	
	    if(!context.displayModeBar && !context.watermark) {
	        if(modeBar) {
	            modeBar.destroy();
	            delete fullLayout._modeBar;
	        }
	        return;
	    }
	
	    if(!Array.isArray(context.modeBarButtonsToRemove)) {
	        throw new Error([
	            '*modeBarButtonsToRemove* configuration options',
	            'must be an array.'
	        ].join(' '));
	    }
	
	    if(!Array.isArray(context.modeBarButtonsToAdd)) {
	        throw new Error([
	            '*modeBarButtonsToAdd* configuration options',
	            'must be an array.'
	        ].join(' '));
	    }
	
	    var customButtons = context.modeBarButtons;
	    var buttonGroups;
	
	    if(Array.isArray(customButtons) && customButtons.length) {
	        buttonGroups = fillCustomButton(customButtons);
	    } else if(!context.displayModeBar && context.watermark) {
	        buttonGroups = [];
	    } else {
	        buttonGroups = getButtonGroups(gd);
	    }
	
	    if(modeBar) modeBar.update(gd, buttonGroups);
	    else fullLayout._modeBar = createModeBar(gd, buttonGroups);
	};
	
	// logic behind which buttons are displayed by default
	function getButtonGroups(gd) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var context = gd._context;
	    var buttonsToRemove = context.modeBarButtonsToRemove;
	    var buttonsToAdd = context.modeBarButtonsToAdd;
	
	    var hasCartesian = fullLayout._has('cartesian');
	    var hasGL3D = fullLayout._has('gl3d');
	    var hasGeo = fullLayout._has('geo');
	    var hasPie = fullLayout._has('pie');
	    var hasFunnelarea = fullLayout._has('funnelarea');
	    var hasGL2D = fullLayout._has('gl2d');
	    var hasTernary = fullLayout._has('ternary');
	    var hasMapbox = fullLayout._has('mapbox');
	    var hasPolar = fullLayout._has('polar');
	    var hasSankey = fullLayout._has('sankey');
	    var allAxesFixed = areAllAxesFixed(fullLayout);
	
	    var groups = [];
	
	    function addGroup(newGroup) {
	        if(!newGroup.length) return;
	
	        var out = [];
	
	        for(var i = 0; i < newGroup.length; i++) {
	            var button = newGroup[i];
	            if(buttonsToRemove.indexOf(button) !== -1) continue;
	            out.push(modeBarButtons[button]);
	        }
	
	        groups.push(out);
	    }
	
	    // buttons common to all plot types
	    var commonGroup = ['toImage'];
	    if(context.showEditInChartStudio) commonGroup.push('editInChartStudio');
	    else if(context.showSendToCloud) commonGroup.push('sendDataToCloud');
	    addGroup(commonGroup);
	
	    var zoomGroup = [];
	    var hoverGroup = [];
	    var resetGroup = [];
	    var dragModeGroup = [];
	
	    if((hasCartesian || hasGL2D || hasPie || hasFunnelarea || hasTernary) + hasGeo + hasGL3D + hasMapbox + hasPolar > 1) {
	        // graphs with more than one plot types get 'union buttons'
	        // which reset the view or toggle hover labels across all subplots.
	        hoverGroup = ['toggleHover'];
	        resetGroup = ['resetViews'];
	    } else if(hasGeo) {
	        zoomGroup = ['zoomInGeo', 'zoomOutGeo'];
	        hoverGroup = ['hoverClosestGeo'];
	        resetGroup = ['resetGeo'];
	    } else if(hasGL3D) {
	        hoverGroup = ['hoverClosest3d'];
	        resetGroup = ['resetCameraDefault3d', 'resetCameraLastSave3d'];
	    } else if(hasMapbox) {
	        hoverGroup = ['toggleHover'];
	        resetGroup = ['resetViewMapbox'];
	    } else if(hasGL2D) {
	        hoverGroup = ['hoverClosestGl2d'];
	    } else if(hasPie) {
	        hoverGroup = ['hoverClosestPie'];
	    } else if(hasSankey) {
	        hoverGroup = ['hoverClosestCartesian', 'hoverCompareCartesian'];
	        resetGroup = ['resetViewSankey'];
	    } else { // hasPolar, hasTernary
	        // always show at least one hover icon.
	        hoverGroup = ['toggleHover'];
	    }
	    // if we have cartesian, allow switching between closest and compare
	    // regardless of what other types are on the plot, since they'll all
	    // just treat any truthy hovermode as 'closest'
	    if(hasCartesian) {
	        hoverGroup = ['toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'];
	    }
	    if(hasNoHover(fullData)) {
	        hoverGroup = [];
	    }
	
	    if((hasCartesian || hasGL2D) && !allAxesFixed) {
	        zoomGroup = ['zoomIn2d', 'zoomOut2d', 'autoScale2d'];
	        if(resetGroup[0] !== 'resetViews') resetGroup = ['resetScale2d'];
	    }
	
	    if(hasGL3D) {
	        dragModeGroup = ['zoom3d', 'pan3d', 'orbitRotation', 'tableRotation'];
	    } else if(((hasCartesian || hasGL2D) && !allAxesFixed) || hasTernary) {
	        dragModeGroup = ['zoom2d', 'pan2d'];
	    } else if(hasMapbox || hasGeo) {
	        dragModeGroup = ['pan2d'];
	    } else if(hasPolar) {
	        dragModeGroup = ['zoom2d'];
	    }
	    if(isSelectable(fullData)) {
	        dragModeGroup.push('select2d', 'lasso2d');
	    }
	
	    addGroup(dragModeGroup);
	    addGroup(zoomGroup.concat(resetGroup));
	    addGroup(hoverGroup);
	
	    return appendButtonsToGroups(groups, buttonsToAdd);
	}
	
	function areAllAxesFixed(fullLayout) {
	    var axList = axisIds.list({_fullLayout: fullLayout}, null, true);
	
	    for(var i = 0; i < axList.length; i++) {
	        if(!axList[i].fixedrange) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	// look for traces that support selection
	// to be updated as we add more selectPoints handlers
	function isSelectable(fullData) {
	    var selectable = false;
	
	    for(var i = 0; i < fullData.length; i++) {
	        if(selectable) break;
	
	        var trace = fullData[i];
	
	        if(!trace._module || !trace._module.selectPoints) continue;
	
	        if(Registry.traceIs(trace, 'scatter-like')) {
	            if(scatterSubTypes.hasMarkers(trace) || scatterSubTypes.hasText(trace)) {
	                selectable = true;
	            }
	        } else if(Registry.traceIs(trace, 'box-violin')) {
	            if(trace.boxpoints === 'all' || trace.points === 'all') {
	                selectable = true;
	            }
	        } else {
	            // assume that in general if the trace module has selectPoints,
	            // then it's selectable. Scatter is an exception to this because it must
	            // have markers or text, not just be a scatter type.
	
	            selectable = true;
	        }
	    }
	
	    return selectable;
	}
	
	// check whether all trace are 'noHover'
	function hasNoHover(fullData) {
	    for(var i = 0; i < fullData.length; i++) {
	        if(!Registry.traceIs(fullData[i], 'noHover')) return false;
	    }
	    return true;
	}
	
	function appendButtonsToGroups(groups, buttons) {
	    if(buttons.length) {
	        if(Array.isArray(buttons[0])) {
	            for(var i = 0; i < buttons.length; i++) {
	                groups.push(buttons[i]);
	            }
	        } else groups.push(buttons);
	    }
	
	    return groups;
	}
	
	// fill in custom buttons referring to default mode bar buttons
	function fillCustomButton(customButtons) {
	    for(var i = 0; i < customButtons.length; i++) {
	        var buttonGroup = customButtons[i];
	
	        for(var j = 0; j < buttonGroup.length; j++) {
	            var button = buttonGroup[j];
	
	            if(typeof button === 'string') {
	                if(modeBarButtons[button] !== undefined) {
	                    customButtons[i][j] = modeBarButtons[button];
	                } else {
	                    throw new Error([
	                        '*modeBarButtons* configuration options',
	                        'invalid button name'
	                    ].join(' '));
	                }
	            }
	        }
	    }
	
	    return customButtons;
	}
	
	},{"../../plots/cartesian/axis_ids":767,"../../registry":845,"../../traces/scatter/subtypes":1142,"./buttons":648,"./modebar":651}],651:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var Icons = _dereq_('../../fonts/ploticon');
	var Parser = new DOMParser();
	
	/**
	 * UI controller for interactive plots
	 * @Class
	 * @Param {object} opts
	 * @Param {object} opts.buttons    nested arrays of grouped buttons config objects
	 * @Param {object} opts.container  container div to append modeBar
	 * @Param {object} opts.graphInfo  primary plot object containing data and layout
	 */
	function ModeBar(opts) {
	    this.container = opts.container;
	    this.element = document.createElement('div');
	
	    this.update(opts.graphInfo, opts.buttons);
	
	    this.container.appendChild(this.element);
	}
	
	var proto = ModeBar.prototype;
	
	/**
	 * Update modeBar (buttons and logo)
	 *
	 * @param {object} graphInfo  primary plot object containing data and layout
	 * @param {array of arrays} buttons nested arrays of grouped buttons to initialize
	 *
	 */
	proto.update = function(graphInfo, buttons) {
	    this.graphInfo = graphInfo;
	
	    var context = this.graphInfo._context;
	    var fullLayout = this.graphInfo._fullLayout;
	    var modeBarId = 'modebar-' + fullLayout._uid;
	
	    this.element.setAttribute('id', modeBarId);
	    this._uid = modeBarId;
	
	    this.element.className = 'modebar';
	    if(context.displayModeBar === 'hover') this.element.className += ' modebar--hover ease-bg';
	
	    if(fullLayout.modebar.orientation === 'v') {
	        this.element.className += ' vertical';
	        buttons = buttons.reverse();
	    }
	
	    var style = fullLayout.modebar;
	    var bgSelector = context.displayModeBar === 'hover' ? '.js-plotly-plot .plotly:hover ' : '';
	
	    Lib.deleteRelatedStyleRule(modeBarId);
	    Lib.addRelatedStyleRule(modeBarId, bgSelector + '#' + modeBarId + ' .modebar-group', 'background-color: ' + style.bgcolor);
	    Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn .icon path', 'fill: ' + style.color);
	    Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn:hover .icon path', 'fill: ' + style.activecolor);
	    Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn.active .icon path', 'fill: ' + style.activecolor);
	
	    // if buttons or logo have changed, redraw modebar interior
	    var needsNewButtons = !this.hasButtons(buttons);
	    var needsNewLogo = (this.hasLogo !== context.displaylogo);
	    var needsNewLocale = (this.locale !== context.locale);
	
	    this.locale = context.locale;
	
	    if(needsNewButtons || needsNewLogo || needsNewLocale) {
	        this.removeAllButtons();
	
	        this.updateButtons(buttons);
	
	        if(context.watermark || context.displaylogo) {
	            var logoGroup = this.getLogo();
	            if(context.watermark) {
	                logoGroup.className = logoGroup.className + ' watermark';
	            }
	
	            if(fullLayout.modebar.orientation === 'v') {
	                this.element.insertBefore(logoGroup, this.element.childNodes[0]);
	            } else {
	                this.element.appendChild(logoGroup);
	            }
	
	            this.hasLogo = true;
	        }
	    }
	
	    this.updateActiveButton();
	};
	
	proto.updateButtons = function(buttons) {
	    var _this = this;
	
	    this.buttons = buttons;
	    this.buttonElements = [];
	    this.buttonsNames = [];
	
	    this.buttons.forEach(function(buttonGroup) {
	        var group = _this.createGroup();
	
	        buttonGroup.forEach(function(buttonConfig) {
	            var buttonName = buttonConfig.name;
	            if(!buttonName) {
	                throw new Error('must provide button \'name\' in button config');
	            }
	            if(_this.buttonsNames.indexOf(buttonName) !== -1) {
	                throw new Error('button name \'' + buttonName + '\' is taken');
	            }
	            _this.buttonsNames.push(buttonName);
	
	            var button = _this.createButton(buttonConfig);
	            _this.buttonElements.push(button);
	            group.appendChild(button);
	        });
	
	        _this.element.appendChild(group);
	    });
	};
	
	/**
	 * Empty div for containing a group of buttons
	 * @Return {HTMLelement}
	 */
	proto.createGroup = function() {
	    var group = document.createElement('div');
	    group.className = 'modebar-group';
	    return group;
	};
	
	/**
	 * Create a new button div and set constant and configurable attributes
	 * @Param {object} config (see ./buttons.js for more info)
	 * @Return {HTMLelement}
	 */
	proto.createButton = function(config) {
	    var _this = this;
	    var button = document.createElement('a');
	
	    button.setAttribute('rel', 'tooltip');
	    button.className = 'modebar-btn';
	
	    var title = config.title;
	    if(title === undefined) title = config.name;
	    // for localization: allow title to be a callable that takes gd as arg
	    else if(typeof title === 'function') title = title(this.graphInfo);
	
	    if(title || title === 0) button.setAttribute('data-title', title);
	
	    if(config.attr !== undefined) button.setAttribute('data-attr', config.attr);
	
	    var val = config.val;
	    if(val !== undefined) {
	        if(typeof val === 'function') val = val(this.graphInfo);
	        button.setAttribute('data-val', val);
	    }
	
	    var click = config.click;
	    if(typeof click !== 'function') {
	        throw new Error('must provide button \'click\' function in button config');
	    } else {
	        button.addEventListener('click', function(ev) {
	            config.click(_this.graphInfo, ev);
	
	            // only needed for 'hoverClosestGeo' which does not call relayout
	            _this.updateActiveButton(ev.currentTarget);
	        });
	    }
	
	    button.setAttribute('data-toggle', config.toggle || false);
	    if(config.toggle) d3.select(button).classed('active', true);
	
	    var icon = config.icon;
	    if(typeof icon === 'function') {
	        button.appendChild(icon());
	    } else {
	        button.appendChild(this.createIcon(icon || Icons.question));
	    }
	    button.setAttribute('data-gravity', config.gravity || 'n');
	
	    return button;
	};
	
	/**
	 * Add an icon to a button
	 * @Param {object} thisIcon
	 * @Param {number} thisIcon.width
	 * @Param {string} thisIcon.path
	 * @Param {string} thisIcon.color
	 * @Return {HTMLelement}
	 */
	proto.createIcon = function(thisIcon) {
	    var iconHeight = isNumeric(thisIcon.height) ?
	        Number(thisIcon.height) :
	        thisIcon.ascent - thisIcon.descent;
	    var svgNS = 'http://www.w3.org/2000/svg';
	    var icon;
	
	    if(thisIcon.path) {
	        icon = document.createElementNS(svgNS, 'svg');
	        icon.setAttribute('viewBox', [0, 0, thisIcon.width, iconHeight].join(' '));
	        icon.setAttribute('class', 'icon');
	
	        var path = document.createElementNS(svgNS, 'path');
	        path.setAttribute('d', thisIcon.path);
	
	        if(thisIcon.transform) {
	            path.setAttribute('transform', thisIcon.transform);
	        } else if(thisIcon.ascent !== undefined) {
	            // Legacy icon transform calculation
	            path.setAttribute('transform', 'matrix(1 0 0 -1 0 ' + thisIcon.ascent + ')');
	        }
	
	        icon.appendChild(path);
	    }
	
	    if(thisIcon.svg) {
	        var svgDoc = Parser.parseFromString(thisIcon.svg, 'application/xml');
	        icon = svgDoc.childNodes[0];
	    }
	
	    icon.setAttribute('height', '1em');
	    icon.setAttribute('width', '1em');
	
	    return icon;
	};
	
	/**
	 * Updates active button with attribute specified in layout
	 * @Param {object} graphInfo plot object containing data and layout
	 * @Return {HTMLelement}
	 */
	proto.updateActiveButton = function(buttonClicked) {
	    var fullLayout = this.graphInfo._fullLayout;
	    var dataAttrClicked = (buttonClicked !== undefined) ?
	        buttonClicked.getAttribute('data-attr') :
	        null;
	
	    this.buttonElements.forEach(function(button) {
	        var thisval = button.getAttribute('data-val') || true;
	        var dataAttr = button.getAttribute('data-attr');
	        var isToggleButton = (button.getAttribute('data-toggle') === 'true');
	        var button3 = d3.select(button);
	
	        // Use 'data-toggle' and 'buttonClicked' to toggle buttons
	        // that have no one-to-one equivalent in fullLayout
	        if(isToggleButton) {
	            if(dataAttr === dataAttrClicked) {
	                button3.classed('active', !button3.classed('active'));
	            }
	        } else {
	            var val = (dataAttr === null) ?
	                dataAttr :
	                Lib.nestedProperty(fullLayout, dataAttr).get();
	
	            button3.classed('active', val === thisval);
	        }
	    });
	};
	
	/**
	 * Check if modeBar is configured as button configuration argument
	 *
	 * @Param {object} buttons 2d array of grouped button config objects
	 * @Return {boolean}
	 */
	proto.hasButtons = function(buttons) {
	    var currentButtons = this.buttons;
	
	    if(!currentButtons) return false;
	
	    if(buttons.length !== currentButtons.length) return false;
	
	    for(var i = 0; i < buttons.length; ++i) {
	        if(buttons[i].length !== currentButtons[i].length) return false;
	        for(var j = 0; j < buttons[i].length; j++) {
	            if(buttons[i][j].name !== currentButtons[i][j].name) return false;
	        }
	    }
	
	    return true;
	};
	
	/**
	 * @return {HTMLDivElement} The logo image wrapped in a group
	 */
	proto.getLogo = function() {
	    var group = this.createGroup();
	    var a = document.createElement('a');
	
	    a.href = 'https://plot.ly/';
	    a.target = '_blank';
	    a.setAttribute('data-title', Lib._(this.graphInfo, 'Produced with Plotly'));
	    a.className = 'modebar-btn plotlyjsicon modebar-btn--logo';
	
	    a.appendChild(this.createIcon(Icons.newplotlylogo));
	
	    group.appendChild(a);
	    return group;
	};
	
	proto.removeAllButtons = function() {
	    while(this.element.firstChild) {
	        this.element.removeChild(this.element.firstChild);
	    }
	
	    this.hasLogo = false;
	};
	
	proto.destroy = function() {
	    Lib.removeElement(this.container.querySelector('.modebar'));
	    Lib.deleteRelatedStyleRule(this._uid);
	};
	
	function createModeBar(gd, buttons) {
	    var fullLayout = gd._fullLayout;
	
	    var modeBar = new ModeBar({
	        graphInfo: gd,
	        container: fullLayout._modebardiv.node(),
	        buttons: buttons
	    });
	
	    if(fullLayout._privateplot) {
	        d3.select(modeBar.element).append('span')
	            .classed('badge-private float--left', true)
	            .text('PRIVATE');
	    }
	
	    return modeBar;
	}
	
	module.exports = createModeBar;
	
	},{"../../fonts/ploticon":696,"../../lib":716,"d3":164,"fast-isnumeric":227}],652:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../color/attributes');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	var buttonAttrs = templatedArray('button', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'plot',
	        
	    },
	    step: {
	        valType: 'enumerated',
	        
	        values: ['month', 'year', 'day', 'hour', 'minute', 'second', 'all'],
	        dflt: 'month',
	        editType: 'plot',
	        
	    },
	    stepmode: {
	        valType: 'enumerated',
	        
	        values: ['backward', 'todate'],
	        dflt: 'backward',
	        editType: 'plot',
	        
	    },
	    count: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        editType: 'plot',
	        
	    },
	    label: {
	        valType: 'string',
	        
	        editType: 'plot',
	        
	    },
	    editType: 'plot',
	    
	});
	
	module.exports = {
	    visible: {
	        valType: 'boolean',
	        
	        editType: 'plot',
	        
	    },
	
	    buttons: buttonAttrs,
	
	    x: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        
	        editType: 'plot',
	        
	    },
	    xanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'left', 'center', 'right'],
	        dflt: 'left',
	        
	        editType: 'plot',
	        
	    },
	    y: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        
	        editType: 'plot',
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'top', 'middle', 'bottom'],
	        dflt: 'bottom',
	        
	        editType: 'plot',
	        
	    },
	
	    font: fontAttrs({
	        editType: 'plot',
	        
	    }),
	
	    bgcolor: {
	        valType: 'color',
	        dflt: colorAttrs.lightLine,
	        
	        editType: 'plot',
	        
	    },
	    activecolor: {
	        valType: 'color',
	        
	        editType: 'plot',
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'plot',
	        
	    },
	    borderwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'plot',
	        
	    },
	    editType: 'plot'
	};
	
	},{"../../plot_api/plot_template":754,"../../plots/font_attributes":790,"../color/attributes":590}],653:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	
	    // 'y' position pad above counter axis domain
	    yPad: 0.02,
	
	    // minimum button width (regardless of text size)
	    minButtonWidth: 30,
	
	    // buttons rect radii
	    rx: 3,
	    ry: 3,
	
	    // light fraction used to compute the 'activecolor' default
	    lightAmount: 25,
	    darkAmount: 10
	};
	
	},{}],654:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../color');
	var Template = _dereq_('../../plot_api/plot_template');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('./constants');
	
	
	module.exports = function handleDefaults(containerIn, containerOut, layout, counterAxes, calendar) {
	    var selectorIn = containerIn.rangeselector || {};
	    var selectorOut = Template.newContainer(containerOut, 'rangeselector');
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(selectorIn, selectorOut, attributes, attr, dflt);
	    }
	
	    var buttons = handleArrayContainerDefaults(selectorIn, selectorOut, {
	        name: 'buttons',
	        handleItemDefaults: buttonDefaults,
	        calendar: calendar
	    });
	
	    var visible = coerce('visible', buttons.length > 0);
	    if(visible) {
	        var posDflt = getPosDflt(containerOut, layout, counterAxes);
	        coerce('x', posDflt[0]);
	        coerce('y', posDflt[1]);
	        Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
	
	        coerce('xanchor');
	        coerce('yanchor');
	
	        Lib.coerceFont(coerce, 'font', layout.font);
	
	        var bgColor = coerce('bgcolor');
	        coerce('activecolor', Color.contrast(bgColor, constants.lightAmount, constants.darkAmount));
	        coerce('bordercolor');
	        coerce('borderwidth');
	    }
	};
	
	function buttonDefaults(buttonIn, buttonOut, selectorOut, opts) {
	    var calendar = opts.calendar;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(buttonIn, buttonOut, attributes.buttons, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	
	    if(visible) {
	        var step = coerce('step');
	        if(step !== 'all') {
	            if(calendar && calendar !== 'gregorian' && (step === 'month' || step === 'year')) {
	                buttonOut.stepmode = 'backward';
	            } else {
	                coerce('stepmode');
	            }
	
	            coerce('count');
	        }
	
	        coerce('label');
	    }
	}
	
	function getPosDflt(containerOut, layout, counterAxes) {
	    var anchoredList = counterAxes.filter(function(ax) {
	        return layout[ax].anchor === containerOut._id;
	    });
	
	    var posY = 0;
	    for(var i = 0; i < anchoredList.length; i++) {
	        var domain = layout[anchoredList[i]].domain;
	        if(domain) posY = Math.max(domain[1], posY);
	    }
	
	    return [containerOut.domain[0], posY + constants.yPad];
	}
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../plots/array_container_defaults":760,"../color":591,"./attributes":652,"./constants":653}],655:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Plots = _dereq_('../../plots/plots');
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var axisIds = _dereq_('../../plots/cartesian/axis_ids');
	
	var alignmentConstants = _dereq_('../../constants/alignment');
	var LINE_SPACING = alignmentConstants.LINE_SPACING;
	var FROM_TL = alignmentConstants.FROM_TL;
	var FROM_BR = alignmentConstants.FROM_BR;
	
	var constants = _dereq_('./constants');
	var getUpdateObject = _dereq_('./get_update_object');
	
	module.exports = function draw(gd) {
	    var fullLayout = gd._fullLayout;
	
	    var selectors = fullLayout._infolayer.selectAll('.rangeselector')
	        .data(makeSelectorData(gd), selectorKeyFunc);
	
	    selectors.enter().append('g')
	        .classed('rangeselector', true);
	
	    selectors.exit().remove();
	
	    selectors.style({
	        cursor: 'pointer',
	        'pointer-events': 'all'
	    });
	
	    selectors.each(function(d) {
	        var selector = d3.select(this);
	        var axisLayout = d;
	        var selectorLayout = axisLayout.rangeselector;
	
	        var buttons = selector.selectAll('g.button')
	            .data(Lib.filterVisible(selectorLayout.buttons));
	
	        buttons.enter().append('g')
	            .classed('button', true);
	
	        buttons.exit().remove();
	
	        buttons.each(function(d) {
	            var button = d3.select(this);
	            var update = getUpdateObject(axisLayout, d);
	
	            d._isActive = isActive(axisLayout, d, update);
	
	            button.call(drawButtonRect, selectorLayout, d);
	            button.call(drawButtonText, selectorLayout, d, gd);
	
	            button.on('click', function() {
	                if(gd._dragged) return;
	
	                Registry.call('_guiRelayout', gd, update);
	            });
	
	            button.on('mouseover', function() {
	                d._isHovered = true;
	                button.call(drawButtonRect, selectorLayout, d);
	            });
	
	            button.on('mouseout', function() {
	                d._isHovered = false;
	                button.call(drawButtonRect, selectorLayout, d);
	            });
	        });
	
	        reposition(gd, buttons, selectorLayout, axisLayout._name, selector);
	    });
	};
	
	function makeSelectorData(gd) {
	    var axes = axisIds.list(gd, 'x', true);
	    var data = [];
	
	    for(var i = 0; i < axes.length; i++) {
	        var axis = axes[i];
	
	        if(axis.rangeselector && axis.rangeselector.visible) {
	            data.push(axis);
	        }
	    }
	
	    return data;
	}
	
	function selectorKeyFunc(d) {
	    return d._id;
	}
	
	function isActive(axisLayout, opts, update) {
	    if(opts.step === 'all') {
	        return axisLayout.autorange === true;
	    } else {
	        var keys = Object.keys(update);
	
	        return (
	            axisLayout.range[0] === update[keys[0]] &&
	            axisLayout.range[1] === update[keys[1]]
	        );
	    }
	}
	
	function drawButtonRect(button, selectorLayout, d) {
	    var rect = Lib.ensureSingle(button, 'rect', 'selector-rect', function(s) {
	        s.attr('shape-rendering', 'crispEdges');
	    });
	
	    rect.attr({
	        'rx': constants.rx,
	        'ry': constants.ry
	    });
	
	    rect.call(Color.stroke, selectorLayout.bordercolor)
	        .call(Color.fill, getFillColor(selectorLayout, d))
	        .style('stroke-width', selectorLayout.borderwidth + 'px');
	}
	
	function getFillColor(selectorLayout, d) {
	    return (d._isActive || d._isHovered) ?
	        selectorLayout.activecolor :
	        selectorLayout.bgcolor;
	}
	
	function drawButtonText(button, selectorLayout, d, gd) {
	    function textLayout(s) {
	        svgTextUtils.convertToTspans(s, gd);
	    }
	
	    var text = Lib.ensureSingle(button, 'text', 'selector-text', function(s) {
	        s.classed('user-select-none', true)
	            .attr('text-anchor', 'middle');
	    });
	
	    text.call(Drawing.font, selectorLayout.font)
	        .text(getLabel(d, gd._fullLayout._meta))
	        .call(textLayout);
	}
	
	function getLabel(opts, _meta) {
	    if(opts.label) {
	        return _meta ?
	            Lib.templateString(opts.label, _meta) :
	            opts.label;
	    }
	
	    if(opts.step === 'all') return 'all';
	
	    return opts.count + opts.step.charAt(0);
	}
	
	function reposition(gd, buttons, opts, axName, selector) {
	    var width = 0;
	    var height = 0;
	
	    var borderWidth = opts.borderwidth;
	
	    buttons.each(function() {
	        var button = d3.select(this);
	        var text = button.select('.selector-text');
	
	        var tHeight = opts.font.size * LINE_SPACING;
	        var hEff = Math.max(tHeight * svgTextUtils.lineCount(text), 16) + 3;
	
	        height = Math.max(height, hEff);
	    });
	
	    buttons.each(function() {
	        var button = d3.select(this);
	        var rect = button.select('.selector-rect');
	        var text = button.select('.selector-text');
	
	        var tWidth = text.node() && Drawing.bBox(text.node()).width;
	        var tHeight = opts.font.size * LINE_SPACING;
	        var tLines = svgTextUtils.lineCount(text);
	
	        var wEff = Math.max(tWidth + 10, constants.minButtonWidth);
	
	        // TODO add MathJax support
	
	        // TODO add buttongap attribute
	
	        button.attr('transform', 'translate(' +
	            (borderWidth + width) + ',' + borderWidth +
	        ')');
	
	        rect.attr({
	            x: 0,
	            y: 0,
	            width: wEff,
	            height: height
	        });
	
	        svgTextUtils.positionText(text, wEff / 2,
	            height / 2 - ((tLines - 1) * tHeight / 2) + 3);
	
	        width += wEff + 5;
	    });
	
	    var graphSize = gd._fullLayout._size;
	    var lx = graphSize.l + graphSize.w * opts.x;
	    var ly = graphSize.t + graphSize.h * (1 - opts.y);
	
	    var xanchor = 'left';
	    if(Lib.isRightAnchor(opts)) {
	        lx -= width;
	        xanchor = 'right';
	    }
	    if(Lib.isCenterAnchor(opts)) {
	        lx -= width / 2;
	        xanchor = 'center';
	    }
	
	    var yanchor = 'top';
	    if(Lib.isBottomAnchor(opts)) {
	        ly -= height;
	        yanchor = 'bottom';
	    }
	    if(Lib.isMiddleAnchor(opts)) {
	        ly -= height / 2;
	        yanchor = 'middle';
	    }
	
	    width = Math.ceil(width);
	    height = Math.ceil(height);
	    lx = Math.round(lx);
	    ly = Math.round(ly);
	
	    Plots.autoMargin(gd, axName + '-range-selector', {
	        x: opts.x,
	        y: opts.y,
	        l: width * FROM_TL[xanchor],
	        r: width * FROM_BR[xanchor],
	        b: height * FROM_BR[yanchor],
	        t: height * FROM_TL[yanchor]
	    });
	
	    selector.attr('transform', 'translate(' + lx + ',' + ly + ')');
	}
	
	},{"../../constants/alignment":685,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/cartesian/axis_ids":767,"../../plots/plots":825,"../../registry":845,"../color":591,"../drawing":612,"./constants":653,"./get_update_object":656,"d3":164}],656:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	module.exports = function getUpdateObject(axisLayout, buttonLayout) {
	    var axName = axisLayout._name;
	    var update = {};
	
	    if(buttonLayout.step === 'all') {
	        update[axName + '.autorange'] = true;
	    } else {
	        var xrange = getXRange(axisLayout, buttonLayout);
	
	        update[axName + '.range[0]'] = xrange[0];
	        update[axName + '.range[1]'] = xrange[1];
	    }
	
	    return update;
	};
	
	function getXRange(axisLayout, buttonLayout) {
	    var currentRange = axisLayout.range;
	    var base = new Date(axisLayout.r2l(currentRange[1]));
	    var step = buttonLayout.step;
	    var count = buttonLayout.count;
	    var range0;
	
	    switch(buttonLayout.stepmode) {
	        case 'backward':
	            range0 = axisLayout.l2r(+d3.time[step].utc.offset(base, -count));
	            break;
	
	        case 'todate':
	            var base2 = d3.time[step].utc.offset(base, -count);
	
	            range0 = axisLayout.l2r(+d3.time[step].utc.ceil(base2));
	            break;
	    }
	
	    var range1 = currentRange[1];
	
	    return [range0, range1];
	}
	
	},{"d3":164}],657:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'component',
	    name: 'rangeselector',
	
	    schema: {
	        subplots: {
	            xaxis: {rangeselector: _dereq_('./attributes')}
	        }
	    },
	
	    layoutAttributes: _dereq_('./attributes'),
	    handleDefaults: _dereq_('./defaults'),
	
	    draw: _dereq_('./draw')
	};
	
	},{"./attributes":652,"./defaults":654,"./draw":655}],658:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorAttributes = _dereq_('../color/attributes');
	
	module.exports = {
	    bgcolor: {
	        valType: 'color',
	        dflt: colorAttributes.background,
	        
	        editType: 'plot',
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: colorAttributes.defaultLine,
	        
	        editType: 'plot',
	        
	    },
	    borderwidth: {
	        valType: 'integer',
	        dflt: 0,
	        min: 0,
	        
	        editType: 'plot',
	        
	    },
	    autorange: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        impliedEdits: {'range[0]': undefined, 'range[1]': undefined},
	        
	    },
	    range: {
	        valType: 'info_array',
	        
	        items: [
	            {valType: 'any', editType: 'calc', impliedEdits: {'^autorange': false}},
	            {valType: 'any', editType: 'calc', impliedEdits: {'^autorange': false}}
	        ],
	        editType: 'calc',
	        impliedEdits: {'autorange': false},
	        
	    },
	    thickness: {
	        valType: 'number',
	        dflt: 0.15,
	        min: 0,
	        max: 1,
	        
	        editType: 'plot',
	        
	    },
	    visible: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    editType: 'calc'
	};
	
	},{"../color/attributes":590}],659:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var listAxes = _dereq_('../../plots/cartesian/axis_ids').list;
	var getAutoRange = _dereq_('../../plots/cartesian/autorange').getAutoRange;
	var constants = _dereq_('./constants');
	
	module.exports = function calcAutorange(gd) {
	    var axes = listAxes(gd, 'x', true);
	
	    // Compute new slider range using axis autorange if necessary.
	    //
	    // Copy back range to input range slider container to skip
	    // this step in subsequent draw calls.
	
	    for(var i = 0; i < axes.length; i++) {
	        var ax = axes[i];
	        var opts = ax[constants.name];
	
	        if(opts && opts.visible && opts.autorange) {
	            opts._input.autorange = true;
	            opts._input.range = opts.range = getAutoRange(gd, ax);
	        }
	    }
	};
	
	},{"../../plots/cartesian/autorange":763,"../../plots/cartesian/axis_ids":767,"./constants":660}],660:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	
	    // attribute container name
	    name: 'rangeslider',
	
	    // class names
	
	    containerClassName: 'rangeslider-container',
	    bgClassName: 'rangeslider-bg',
	    rangePlotClassName: 'rangeslider-rangeplot',
	
	    maskMinClassName: 'rangeslider-mask-min',
	    maskMaxClassName: 'rangeslider-mask-max',
	    slideBoxClassName: 'rangeslider-slidebox',
	
	    grabberMinClassName: 'rangeslider-grabber-min',
	    grabAreaMinClassName: 'rangeslider-grabarea-min',
	    handleMinClassName: 'rangeslider-handle-min',
	
	    grabberMaxClassName: 'rangeslider-grabber-max',
	    grabAreaMaxClassName: 'rangeslider-grabarea-max',
	    handleMaxClassName: 'rangeslider-handle-max',
	
	    maskMinOppAxisClassName: 'rangeslider-mask-min-opp-axis',
	    maskMaxOppAxisClassName: 'rangeslider-mask-max-opp-axis',
	
	    // style constants
	
	    maskColor: 'rgba(0,0,0,0.4)',
	    maskOppAxisColor: 'rgba(0,0,0,0.2)',
	
	    slideBoxFill: 'transparent',
	    slideBoxCursor: 'ew-resize',
	
	    grabAreaFill: 'transparent',
	    grabAreaCursor: 'col-resize',
	    grabAreaWidth: 10,
	
	    handleWidth: 4,
	    handleRadius: 1,
	    handleStrokeWidth: 1,
	
	    extraPad: 15
	};
	
	},{}],661:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Template = _dereq_('../../plot_api/plot_template');
	var axisIds = _dereq_('../../plots/cartesian/axis_ids');
	
	var attributes = _dereq_('./attributes');
	var oppAxisAttrs = _dereq_('./oppaxis_attributes');
	
	module.exports = function handleDefaults(layoutIn, layoutOut, axName) {
	    var axIn = layoutIn[axName];
	    var axOut = layoutOut[axName];
	
	    if(!(axIn.rangeslider || layoutOut._requestRangeslider[axOut._id])) return;
	
	    // not super proud of this (maybe store _ in axis object instead
	    if(!Lib.isPlainObject(axIn.rangeslider)) {
	        axIn.rangeslider = {};
	    }
	
	    var containerIn = axIn.rangeslider;
	    var containerOut = Template.newContainer(axOut, 'rangeslider');
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	    }
	
	    var rangeContainerIn, rangeContainerOut;
	    function coerceRange(attr, dflt) {
	        return Lib.coerce(rangeContainerIn, rangeContainerOut, oppAxisAttrs, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	    if(!visible) return;
	
	    coerce('bgcolor', layoutOut.plot_bgcolor);
	    coerce('bordercolor');
	    coerce('borderwidth');
	    coerce('thickness');
	
	    coerce('autorange', !axOut.isValidRange(containerIn.range));
	    coerce('range');
	
	    var subplots = layoutOut._subplots;
	    if(subplots) {
	        var yIds = subplots.cartesian
	            .filter(function(subplotId) {
	                return subplotId.substr(0, subplotId.indexOf('y')) === axisIds.name2id(axName);
	            })
	            .map(function(subplotId) {
	                return subplotId.substr(subplotId.indexOf('y'), subplotId.length);
	            });
	        var yNames = Lib.simpleMap(yIds, axisIds.id2name);
	        for(var i = 0; i < yNames.length; i++) {
	            var yName = yNames[i];
	
	            rangeContainerIn = containerIn[yName] || {};
	            rangeContainerOut = Template.newContainer(containerOut, yName, 'yaxis');
	
	            var yAxOut = layoutOut[yName];
	
	            var rangemodeDflt;
	            if(rangeContainerIn.range && yAxOut.isValidRange(rangeContainerIn.range)) {
	                rangemodeDflt = 'fixed';
	            }
	
	            var rangeMode = coerceRange('rangemode', rangemodeDflt);
	            if(rangeMode !== 'match') {
	                coerceRange('range', yAxOut.range.slice());
	            }
	        }
	    }
	
	    // to map back range slider (auto) range
	    containerOut._input = containerIn;
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../plots/cartesian/axis_ids":767,"./attributes":658,"./oppaxis_attributes":665}],662:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Plots = _dereq_('../../plots/plots');
	
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var Titles = _dereq_('../titles');
	
	var Cartesian = _dereq_('../../plots/cartesian');
	var axisIDs = _dereq_('../../plots/cartesian/axis_ids');
	
	var dragElement = _dereq_('../dragelement');
	var setCursor = _dereq_('../../lib/setcursor');
	
	var constants = _dereq_('./constants');
	
	module.exports = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var rangeSliderData = fullLayout._rangeSliderData;
	    for(var i = 0; i < rangeSliderData.length; i++) {
	        var opts = rangeSliderData[i][constants.name];
	        // fullLayout._uid may not exist when we call makeData
	        opts._clipId = opts._id + '-' + fullLayout._uid;
	    }
	
	    /*
	     * <g container />
	     *  <rect bg />
	     *  < .... range plot />
	     *  <rect mask-min />
	     *  <rect mask-max />
	     *  <rect slidebox />
	     *  <g grabber-min />
	     *      <rect handle-min />
	     *      <rect grabare-min />
	     *  <g grabber-max />
	     *      <rect handle-max />
	     *      <rect grabare-max />
	     *
	     *  ...
	     */
	
	    function keyFunction(axisOpts) {
	        return axisOpts._name;
	    }
	
	    var rangeSliders = fullLayout._infolayer
	        .selectAll('g.' + constants.containerClassName)
	        .data(rangeSliderData, keyFunction);
	
	    // remove exiting sliders and their corresponding clip paths
	    rangeSliders.exit().each(function(axisOpts) {
	        var opts = axisOpts[constants.name];
	        fullLayout._topdefs.select('#' + opts._clipId).remove();
	    }).remove();
	
	    // return early if no range slider is visible
	    if(rangeSliderData.length === 0) return;
	
	    rangeSliders.enter().append('g')
	        .classed(constants.containerClassName, true)
	        .attr('pointer-events', 'all');
	
	    // for all present range sliders
	    rangeSliders.each(function(axisOpts) {
	        var rangeSlider = d3.select(this);
	        var opts = axisOpts[constants.name];
	        var oppAxisOpts = fullLayout[axisIDs.id2name(axisOpts.anchor)];
	        var oppAxisRangeOpts = opts[axisIDs.id2name(axisOpts.anchor)];
	
	        // update range
	        // Expand slider range to the axis range
	        if(opts.range) {
	            var rng = Lib.simpleMap(opts.range, axisOpts.r2l);
	            var axRng = Lib.simpleMap(axisOpts.range, axisOpts.r2l);
	            var newRng;
	
	            if(axRng[0] < axRng[1]) {
	                newRng = [
	                    Math.min(rng[0], axRng[0]),
	                    Math.max(rng[1], axRng[1])
	                ];
	            } else {
	                newRng = [
	                    Math.max(rng[0], axRng[0]),
	                    Math.min(rng[1], axRng[1])
	                ];
	            }
	
	            opts.range = opts._input.range = Lib.simpleMap(newRng, axisOpts.l2r);
	        }
	
	        axisOpts.cleanRange('rangeslider.range');
	
	        // update range slider dimensions
	
	        var gs = fullLayout._size;
	        var domain = axisOpts.domain;
	
	        opts._width = gs.w * (domain[1] - domain[0]);
	
	        var x = Math.round(gs.l + (gs.w * domain[0]));
	
	        var y = Math.round(
	            gs.t + gs.h * (1 - axisOpts._counterDomainMin) +
	            (axisOpts.side === 'bottom' ? axisOpts._depth : 0) +
	            opts._offsetShift + constants.extraPad
	        );
	
	        rangeSlider.attr('transform', 'translate(' + x + ',' + y + ')');
	
	        // update data <--> pixel coordinate conversion methods
	
	        var range0 = axisOpts.r2l(opts.range[0]);
	        var range1 = axisOpts.r2l(opts.range[1]);
	        var dist = range1 - range0;
	
	        opts.p2d = function(v) {
	            return (v / opts._width) * dist + range0;
	        };
	
	        opts.d2p = function(v) {
	            return (v - range0) / dist * opts._width;
	        };
	
	        opts._rl = [range0, range1];
	
	        if(oppAxisRangeOpts.rangemode !== 'match') {
	            var range0OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[0]);
	            var range1OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[1]);
	            var distOppAxis = range1OppAxis - range0OppAxis;
	
	            opts.d2pOppAxis = function(v) {
	                return (v - range0OppAxis) / distOppAxis * opts._height;
	            };
	        }
	
	        // update inner nodes
	
	        rangeSlider
	            .call(drawBg, gd, axisOpts, opts)
	            .call(addClipPath, gd, axisOpts, opts)
	            .call(drawRangePlot, gd, axisOpts, opts)
	            .call(drawMasks, gd, axisOpts, opts, oppAxisRangeOpts)
	            .call(drawSlideBox, gd, axisOpts, opts)
	            .call(drawGrabbers, gd, axisOpts, opts);
	
	        // setup drag element
	        setupDragElement(rangeSlider, gd, axisOpts, opts);
	
	        // update current range
	        setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts);
	
	        // title goes next to range slider instead of tick labels, so
	        // just take it over and draw it from here
	        if(axisOpts.side === 'bottom') {
	            Titles.draw(gd, axisOpts._id + 'title', {
	                propContainer: axisOpts,
	                propName: axisOpts._name + '.title',
	                placeholder: fullLayout._dfltTitle.x,
	                attributes: {
	                    x: axisOpts._offset + axisOpts._length / 2,
	                    y: y + opts._height + opts._offsetShift + 10 + 1.5 * axisOpts.title.font.size,
	                    'text-anchor': 'middle'
	                }
	            });
	        }
	    });
	};
	
	function setupDragElement(rangeSlider, gd, axisOpts, opts) {
	    var slideBox = rangeSlider.select('rect.' + constants.slideBoxClassName).node();
	    var grabAreaMin = rangeSlider.select('rect.' + constants.grabAreaMinClassName).node();
	    var grabAreaMax = rangeSlider.select('rect.' + constants.grabAreaMaxClassName).node();
	
	    rangeSlider.on('mousedown', function() {
	        var event = d3.event;
	        var target = event.target;
	        var startX = event.clientX;
	        var offsetX = startX - rangeSlider.node().getBoundingClientRect().left;
	        var minVal = opts.d2p(axisOpts._rl[0]);
	        var maxVal = opts.d2p(axisOpts._rl[1]);
	
	        var dragCover = dragElement.coverSlip();
	
	        dragCover.addEventListener('mousemove', mouseMove);
	        dragCover.addEventListener('mouseup', mouseUp);
	
	        function mouseMove(e) {
	            var delta = +e.clientX - startX;
	            var pixelMin, pixelMax, cursor;
	
	            switch(target) {
	                case slideBox:
	                    cursor = 'ew-resize';
	                    pixelMin = minVal + delta;
	                    pixelMax = maxVal + delta;
	                    break;
	
	                case grabAreaMin:
	                    cursor = 'col-resize';
	                    pixelMin = minVal + delta;
	                    pixelMax = maxVal;
	                    break;
	
	                case grabAreaMax:
	                    cursor = 'col-resize';
	                    pixelMin = minVal;
	                    pixelMax = maxVal + delta;
	                    break;
	
	                default:
	                    cursor = 'ew-resize';
	                    pixelMin = offsetX;
	                    pixelMax = offsetX + delta;
	                    break;
	            }
	
	            if(pixelMax < pixelMin) {
	                var tmp = pixelMax;
	                pixelMax = pixelMin;
	                pixelMin = tmp;
	            }
	
	            opts._pixelMin = pixelMin;
	            opts._pixelMax = pixelMax;
	
	            setCursor(d3.select(dragCover), cursor);
	            setDataRange(rangeSlider, gd, axisOpts, opts);
	        }
	
	        function mouseUp() {
	            dragCover.removeEventListener('mousemove', mouseMove);
	            dragCover.removeEventListener('mouseup', mouseUp);
	            Lib.removeElement(dragCover);
	        }
	    });
	}
	
	function setDataRange(rangeSlider, gd, axisOpts, opts) {
	    function clamp(v) {
	        return axisOpts.l2r(Lib.constrain(v, opts._rl[0], opts._rl[1]));
	    }
	
	    var dataMin = clamp(opts.p2d(opts._pixelMin));
	    var dataMax = clamp(opts.p2d(opts._pixelMax));
	
	    window.requestAnimationFrame(function() {
	        Registry.call('_guiRelayout', gd, axisOpts._name + '.range', [dataMin, dataMax]);
	    });
	}
	
	function setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts) {
	    var hw2 = constants.handleWidth / 2;
	
	    function clamp(v) {
	        return Lib.constrain(v, 0, opts._width);
	    }
	
	    function clampOppAxis(v) {
	        return Lib.constrain(v, 0, opts._height);
	    }
	
	    function clampHandle(v) {
	        return Lib.constrain(v, -hw2, opts._width + hw2);
	    }
	
	    var pixelMin = clamp(opts.d2p(axisOpts._rl[0]));
	    var pixelMax = clamp(opts.d2p(axisOpts._rl[1]));
	
	    rangeSlider.select('rect.' + constants.slideBoxClassName)
	        .attr('x', pixelMin)
	        .attr('width', pixelMax - pixelMin);
	
	    rangeSlider.select('rect.' + constants.maskMinClassName)
	        .attr('width', pixelMin);
	
	    rangeSlider.select('rect.' + constants.maskMaxClassName)
	        .attr('x', pixelMax)
	        .attr('width', opts._width - pixelMax);
	
	    if(oppAxisRangeOpts.rangemode !== 'match') {
	        var pixelMinOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[1]));
	        var pixelMaxOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[0]));
	
	        rangeSlider.select('rect.' + constants.maskMinOppAxisClassName)
	            .attr('x', pixelMin)
	            .attr('height', pixelMinOppAxis)
	            .attr('width', pixelMax - pixelMin);
	
	        rangeSlider.select('rect.' + constants.maskMaxOppAxisClassName)
	            .attr('x', pixelMin)
	            .attr('y', pixelMaxOppAxis)
	            .attr('height', opts._height - pixelMaxOppAxis)
	            .attr('width', pixelMax - pixelMin);
	
	        rangeSlider.select('rect.' + constants.slideBoxClassName)
	            .attr('y', pixelMinOppAxis)
	            .attr('height', pixelMaxOppAxis - pixelMinOppAxis);
	    }
	
	    // add offset for crispier corners
	    // https://github.com/plotly/plotly.js/pull/1409
	    var offset = 0.5;
	
	    var xMin = Math.round(clampHandle(pixelMin - hw2)) - offset;
	    var xMax = Math.round(clampHandle(pixelMax - hw2)) + offset;
	
	    rangeSlider.select('g.' + constants.grabberMinClassName)
	        .attr('transform', 'translate(' + xMin + ',' + offset + ')');
	
	    rangeSlider.select('g.' + constants.grabberMaxClassName)
	        .attr('transform', 'translate(' + xMax + ',' + offset + ')');
	}
	
	function drawBg(rangeSlider, gd, axisOpts, opts) {
	    var bg = Lib.ensureSingle(rangeSlider, 'rect', constants.bgClassName, function(s) {
	        s.attr({
	            x: 0,
	            y: 0,
	            'shape-rendering': 'crispEdges'
	        });
	    });
	
	    var borderCorrect = (opts.borderwidth % 2) === 0 ?
	        opts.borderwidth :
	        opts.borderwidth - 1;
	
	    var offsetShift = -opts._offsetShift;
	    var lw = Drawing.crispRound(gd, opts.borderwidth);
	
	    bg.attr({
	        width: opts._width + borderCorrect,
	        height: opts._height + borderCorrect,
	        transform: 'translate(' + offsetShift + ',' + offsetShift + ')',
	        fill: opts.bgcolor,
	        stroke: opts.bordercolor,
	        'stroke-width': lw
	    });
	}
	
	function addClipPath(rangeSlider, gd, axisOpts, opts) {
	    var fullLayout = gd._fullLayout;
	
	    var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', opts._clipId, function(s) {
	        s.append('rect').attr({ x: 0, y: 0 });
	    });
	
	    clipPath.select('rect').attr({
	        width: opts._width,
	        height: opts._height
	    });
	}
	
	function drawRangePlot(rangeSlider, gd, axisOpts, opts) {
	    var calcData = gd.calcdata;
	
	    var rangePlots = rangeSlider.selectAll('g.' + constants.rangePlotClassName)
	        .data(axisOpts._subplotsWith, Lib.identity);
	
	    rangePlots.enter().append('g')
	        .attr('class', function(id) { return constants.rangePlotClassName + ' ' + id; })
	        .call(Drawing.setClipUrl, opts._clipId, gd);
	
	    rangePlots.order();
	
	    rangePlots.exit().remove();
	
	    var mainplotinfo;
	
	    rangePlots.each(function(id, i) {
	        var plotgroup = d3.select(this);
	        var isMainPlot = (i === 0);
	
	        var oppAxisOpts = axisIDs.getFromId(gd, id, 'y');
	        var oppAxisName = oppAxisOpts._name;
	        var oppAxisRangeOpts = opts[oppAxisName];
	
	        var mockFigure = {
	            data: [],
	            layout: {
	                xaxis: {
	                    type: axisOpts.type,
	                    domain: [0, 1],
	                    range: opts.range.slice(),
	                    calendar: axisOpts.calendar
	                },
	                width: opts._width,
	                height: opts._height,
	                margin: { t: 0, b: 0, l: 0, r: 0 }
	            },
	            _context: gd._context
	        };
	
	        mockFigure.layout[oppAxisName] = {
	            type: oppAxisOpts.type,
	            domain: [0, 1],
	            range: oppAxisRangeOpts.rangemode !== 'match' ? oppAxisRangeOpts.range.slice() : oppAxisOpts.range.slice(),
	            calendar: oppAxisOpts.calendar
	        };
	
	        Plots.supplyDefaults(mockFigure);
	
	        var xa = mockFigure._fullLayout.xaxis;
	        var ya = mockFigure._fullLayout[oppAxisName];
	
	        xa.clearCalc();
	        xa.setScale();
	        ya.clearCalc();
	        ya.setScale();
	
	        var plotinfo = {
	            id: id,
	            plotgroup: plotgroup,
	            xaxis: xa,
	            yaxis: ya,
	            isRangePlot: true
	        };
	
	        if(isMainPlot) mainplotinfo = plotinfo;
	        else {
	            plotinfo.mainplot = 'xy';
	            plotinfo.mainplotinfo = mainplotinfo;
	        }
	
	        Cartesian.rangePlot(gd, plotinfo, filterRangePlotCalcData(calcData, id));
	    });
	}
	
	function filterRangePlotCalcData(calcData, subplotId) {
	    var out = [];
	
	    for(var i = 0; i < calcData.length; i++) {
	        var calcTrace = calcData[i];
	        var trace = calcTrace[0].trace;
	
	        if(trace.xaxis + trace.yaxis === subplotId) {
	            out.push(calcTrace);
	        }
	    }
	
	    return out;
	}
	
	function drawMasks(rangeSlider, gd, axisOpts, opts, oppAxisRangeOpts) {
	    var maskMin = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinClassName, function(s) {
	        s.attr({
	            x: 0,
	            y: 0,
	            'shape-rendering': 'crispEdges'
	        });
	    });
	
	    maskMin
	        .attr('height', opts._height)
	        .call(Color.fill, constants.maskColor);
	
	    var maskMax = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxClassName, function(s) {
	        s.attr({
	            y: 0,
	            'shape-rendering': 'crispEdges'
	        });
	    });
	
	    maskMax
	        .attr('height', opts._height)
	        .call(Color.fill, constants.maskColor);
	
	    // masks used for oppAxis zoom
	    if(oppAxisRangeOpts.rangemode !== 'match') {
	        var maskMinOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinOppAxisClassName, function(s) {
	            s.attr({
	                y: 0,
	                'shape-rendering': 'crispEdges'
	            });
	        });
	
	        maskMinOppAxis
	            .attr('width', opts._width)
	            .call(Color.fill, constants.maskOppAxisColor);
	
	        var maskMaxOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxOppAxisClassName, function(s) {
	            s.attr({
	                y: 0,
	                'shape-rendering': 'crispEdges'
	            });
	        });
	
	        maskMaxOppAxis
	            .attr('width', opts._width)
	            .style('border-top', constants.maskOppBorder)
	            .call(Color.fill, constants.maskOppAxisColor);
	    }
	}
	
	function drawSlideBox(rangeSlider, gd, axisOpts, opts) {
	    if(gd._context.staticPlot) return;
	
	    var slideBox = Lib.ensureSingle(rangeSlider, 'rect', constants.slideBoxClassName, function(s) {
	        s.attr({
	            y: 0,
	            cursor: constants.slideBoxCursor,
	            'shape-rendering': 'crispEdges'
	        });
	    });
	
	    slideBox.attr({
	        height: opts._height,
	        fill: constants.slideBoxFill
	    });
	}
	
	function drawGrabbers(rangeSlider, gd, axisOpts, opts) {
	    // <g grabber />
	    var grabberMin = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMinClassName);
	    var grabberMax = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMaxClassName);
	
	    // <g handle />
	    var handleFixAttrs = {
	        x: 0,
	        width: constants.handleWidth,
	        rx: constants.handleRadius,
	        fill: Color.background,
	        stroke: Color.defaultLine,
	        'stroke-width': constants.handleStrokeWidth,
	        'shape-rendering': 'crispEdges'
	    };
	    var handleDynamicAttrs = {
	        y: Math.round(opts._height / 4),
	        height: Math.round(opts._height / 2),
	    };
	    var handleMin = Lib.ensureSingle(grabberMin, 'rect', constants.handleMinClassName, function(s) {
	        s.attr(handleFixAttrs);
	    });
	    handleMin.attr(handleDynamicAttrs);
	
	    var handleMax = Lib.ensureSingle(grabberMax, 'rect', constants.handleMaxClassName, function(s) {
	        s.attr(handleFixAttrs);
	    });
	    handleMax.attr(handleDynamicAttrs);
	
	    // <g grabarea />
	    if(gd._context.staticPlot) return;
	
	    var grabAreaFixAttrs = {
	        width: constants.grabAreaWidth,
	        x: 0,
	        y: 0,
	        fill: constants.grabAreaFill,
	        cursor: constants.grabAreaCursor
	    };
	
	    var grabAreaMin = Lib.ensureSingle(grabberMin, 'rect', constants.grabAreaMinClassName, function(s) {
	        s.attr(grabAreaFixAttrs);
	    });
	    grabAreaMin.attr('height', opts._height);
	
	    var grabAreaMax = Lib.ensureSingle(grabberMax, 'rect', constants.grabAreaMaxClassName, function(s) {
	        s.attr(grabAreaFixAttrs);
	    });
	    grabAreaMax.attr('height', opts._height);
	}
	
	},{"../../lib":716,"../../lib/setcursor":736,"../../plots/cartesian":775,"../../plots/cartesian/axis_ids":767,"../../plots/plots":825,"../../registry":845,"../color":591,"../dragelement":609,"../drawing":612,"../titles":678,"./constants":660,"d3":164}],663:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var axisIDs = _dereq_('../../plots/cartesian/axis_ids');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var constants = _dereq_('./constants');
	var LINE_SPACING = _dereq_('../../constants/alignment').LINE_SPACING;
	var name = constants.name;
	
	function isVisible(ax) {
	    var rangeSlider = ax && ax[name];
	    return rangeSlider && rangeSlider.visible;
	}
	exports.isVisible = isVisible;
	
	exports.makeData = function(fullLayout) {
	    var axes = axisIDs.list({ _fullLayout: fullLayout }, 'x', true);
	    var margin = fullLayout.margin;
	    var rangeSliderData = [];
	
	    if(!fullLayout._has('gl2d')) {
	        for(var i = 0; i < axes.length; i++) {
	            var ax = axes[i];
	
	            if(isVisible(ax)) {
	                rangeSliderData.push(ax);
	
	                var opts = ax[name];
	                opts._id = name + ax._id;
	                opts._height = (fullLayout.height - margin.b - margin.t) * opts.thickness;
	                opts._offsetShift = Math.floor(opts.borderwidth / 2);
	            }
	        }
	    }
	
	    fullLayout._rangeSliderData = rangeSliderData;
	};
	
	exports.autoMarginOpts = function(gd, ax) {
	    var fullLayout = gd._fullLayout;
	    var opts = ax[name];
	    var axLetter = ax._id.charAt(0);
	
	    var bottomDepth = 0;
	    var titleHeight = 0;
	    if(ax.side === 'bottom') {
	        bottomDepth = ax._depth;
	        if(ax.title.text !== fullLayout._dfltTitle[axLetter]) {
	            // as in rangeslider/draw.js
	            titleHeight = 1.5 * ax.title.font.size + 10 + opts._offsetShift;
	            // multi-line extra bump
	            var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
	            titleHeight += extraLines * ax.title.font.size * LINE_SPACING;
	        }
	    }
	
	    return {
	        x: 0,
	        y: ax._counterDomainMin,
	        l: 0,
	        r: 0,
	        t: 0,
	        b: opts._height + bottomDepth + Math.max(fullLayout.margin.b, titleHeight),
	        pad: constants.extraPad + opts._offsetShift * 2
	    };
	};
	
	},{"../../constants/alignment":685,"../../lib/svg_text_utils":740,"../../plots/cartesian/axis_ids":767,"./constants":660}],664:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attrs = _dereq_('./attributes');
	var oppAxisAttrs = _dereq_('./oppaxis_attributes');
	var helpers = _dereq_('./helpers');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'rangeslider',
	
	    schema: {
	        subplots: {
	            xaxis: {
	                rangeslider: Lib.extendFlat({}, attrs, {
	                    yaxis: oppAxisAttrs
	                })
	            }
	        }
	    },
	
	    layoutAttributes: _dereq_('./attributes'),
	    handleDefaults: _dereq_('./defaults'),
	    calcAutorange: _dereq_('./calc_autorange'),
	    draw: _dereq_('./draw'),
	    isVisible: helpers.isVisible,
	    makeData: helpers.makeData,
	    autoMarginOpts: helpers.autoMarginOpts
	};
	
	},{"../../lib":716,"./attributes":658,"./calc_autorange":659,"./defaults":661,"./draw":662,"./helpers":663,"./oppaxis_attributes":665}],665:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    // not really a 'subplot' attribute container,
	    // but this is the flag we use to denote attributes that
	    // support yaxis, yaxis2, yaxis3, ... counters
	    _isSubplotObj: true,
	
	    rangemode: {
	        valType: 'enumerated',
	        values: ['auto', 'fixed', 'match'],
	        dflt: 'match',
	        
	        editType: 'calc',
	        
	    },
	    range: {
	        valType: 'info_array',
	        
	        items: [
	            {valType: 'any', editType: 'plot'},
	            {valType: 'any', editType: 'plot'}
	        ],
	        editType: 'plot',
	        
	    },
	    editType: 'calc'
	};
	
	},{}],666:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var annAttrs = _dereq_('../annotations/attributes');
	var scatterLineAttrs = _dereq_('../../traces/scatter/attributes').line;
	var dash = _dereq_('../drawing/attributes').dash;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	module.exports = templatedArray('shape', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc+arraydraw',
	        
	    },
	
	    type: {
	        valType: 'enumerated',
	        values: ['circle', 'rect', 'path', 'line'],
	        
	        editType: 'calc+arraydraw',
	        
	    },
	
	    layer: {
	        valType: 'enumerated',
	        values: ['below', 'above'],
	        dflt: 'above',
	        
	        editType: 'arraydraw',
	        
	    },
	
	    xref: extendFlat({}, annAttrs.xref, {
	        
	    }),
	    xsizemode: {
	        valType: 'enumerated',
	        values: ['scaled', 'pixel'],
	        dflt: 'scaled',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    xanchor: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    x0: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    x1: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	
	    yref: extendFlat({}, annAttrs.yref, {
	        
	    }),
	    ysizemode: {
	        valType: 'enumerated',
	        values: ['scaled', 'pixel'],
	        dflt: 'scaled',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    yanchor: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    y0: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	    y1: {
	        valType: 'any',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	
	    path: {
	        valType: 'string',
	        
	        editType: 'calc+arraydraw',
	        
	    },
	
	    opacity: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 1,
	        
	        editType: 'arraydraw',
	        
	    },
	    line: {
	        color: extendFlat({}, scatterLineAttrs.color, {editType: 'arraydraw'}),
	        width: extendFlat({}, scatterLineAttrs.width, {editType: 'calc+arraydraw'}),
	        dash: extendFlat({}, dash, {editType: 'arraydraw'}),
	        
	        editType: 'calc+arraydraw'
	    },
	    fillcolor: {
	        valType: 'color',
	        dflt: 'rgba(0,0,0,0)',
	        
	        editType: 'arraydraw',
	        
	    },
	    editType: 'arraydraw'
	});
	
	},{"../../lib/extend":707,"../../plot_api/plot_template":754,"../../traces/scatter/attributes":1118,"../annotations/attributes":574,"../drawing/attributes":611}],667:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var constants = _dereq_('./constants');
	var helpers = _dereq_('./helpers');
	
	
	module.exports = function calcAutorange(gd) {
	    var fullLayout = gd._fullLayout;
	    var shapeList = Lib.filterVisible(fullLayout.shapes);
	
	    if(!shapeList.length || !gd._fullData.length) return;
	
	    for(var i = 0; i < shapeList.length; i++) {
	        var shape = shapeList[i];
	        shape._extremes = {};
	
	        var ax, bounds;
	
	        if(shape.xref !== 'paper') {
	            var vx0 = shape.xsizemode === 'pixel' ? shape.xanchor : shape.x0;
	            var vx1 = shape.xsizemode === 'pixel' ? shape.xanchor : shape.x1;
	            ax = Axes.getFromId(gd, shape.xref);
	
	            bounds = shapeBounds(ax, vx0, vx1, shape.path, constants.paramIsX);
	            if(bounds) {
	                shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcXPaddingOptions(shape));
	            }
	        }
	
	        if(shape.yref !== 'paper') {
	            var vy0 = shape.ysizemode === 'pixel' ? shape.yanchor : shape.y0;
	            var vy1 = shape.ysizemode === 'pixel' ? shape.yanchor : shape.y1;
	            ax = Axes.getFromId(gd, shape.yref);
	
	            bounds = shapeBounds(ax, vy0, vy1, shape.path, constants.paramIsY);
	            if(bounds) {
	                shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcYPaddingOptions(shape));
	            }
	        }
	    }
	};
	
	function calcXPaddingOptions(shape) {
	    return calcPaddingOptions(shape.line.width, shape.xsizemode, shape.x0, shape.x1, shape.path, false);
	}
	
	function calcYPaddingOptions(shape) {
	    return calcPaddingOptions(shape.line.width, shape.ysizemode, shape.y0, shape.y1, shape.path, true);
	}
	
	function calcPaddingOptions(lineWidth, sizeMode, v0, v1, path, isYAxis) {
	    var ppad = lineWidth / 2;
	    var axisDirectionReverted = isYAxis;
	
	    if(sizeMode === 'pixel') {
	        var coords = path ?
	            helpers.extractPathCoords(path, isYAxis ? constants.paramIsY : constants.paramIsX) :
	            [v0, v1];
	        var maxValue = Lib.aggNums(Math.max, null, coords);
	        var minValue = Lib.aggNums(Math.min, null, coords);
	        var beforePad = minValue < 0 ? Math.abs(minValue) + ppad : ppad;
	        var afterPad = maxValue > 0 ? maxValue + ppad : ppad;
	
	        return {
	            ppad: ppad,
	            ppadplus: axisDirectionReverted ? beforePad : afterPad,
	            ppadminus: axisDirectionReverted ? afterPad : beforePad
	        };
	    } else {
	        return {ppad: ppad};
	    }
	}
	
	function shapeBounds(ax, v0, v1, path, paramsToUse) {
	    var convertVal = (ax.type === 'category' || ax.type === 'multicategory') ? ax.r2c : ax.d2c;
	
	    if(v0 !== undefined) return [convertVal(v0), convertVal(v1)];
	    if(!path) return;
	
	    var min = Infinity;
	    var max = -Infinity;
	    var segments = path.match(constants.segmentRE);
	    var i;
	    var segment;
	    var drawnParam;
	    var params;
	    var val;
	
	    if(ax.type === 'date') convertVal = helpers.decodeDate(convertVal);
	
	    for(i = 0; i < segments.length; i++) {
	        segment = segments[i];
	        drawnParam = paramsToUse[segment.charAt(0)].drawn;
	        if(drawnParam === undefined) continue;
	
	        params = segments[i].substr(1).match(constants.paramRE);
	        if(!params || params.length < drawnParam) continue;
	
	        val = convertVal(params[drawnParam]);
	        if(val < min) min = val;
	        if(val > max) max = val;
	    }
	    if(max >= min) return [min, max];
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"./constants":668,"./helpers":671}],668:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = {
	    segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
	    paramRE: /[^\s,]+/g,
	
	    // which numbers in each path segment are x (or y) values
	    // drawn is which param is a drawn point, as opposed to a
	    // control point (which doesn't count toward autorange.
	    // TODO: this means curved paths could extend beyond the
	    // autorange bounds. This is a bit tricky to get right
	    // unless we revert to bounding boxes, but perhaps there's
	    // a calculation we could do...)
	    paramIsX: {
	        M: {0: true, drawn: 0},
	        L: {0: true, drawn: 0},
	        H: {0: true, drawn: 0},
	        V: {},
	        Q: {0: true, 2: true, drawn: 2},
	        C: {0: true, 2: true, 4: true, drawn: 4},
	        T: {0: true, drawn: 0},
	        S: {0: true, 2: true, drawn: 2},
	        // A: {0: true, 5: true},
	        Z: {}
	    },
	
	    paramIsY: {
	        M: {1: true, drawn: 1},
	        L: {1: true, drawn: 1},
	        H: {},
	        V: {0: true, drawn: 0},
	        Q: {1: true, 3: true, drawn: 3},
	        C: {1: true, 3: true, 5: true, drawn: 5},
	        T: {1: true, drawn: 1},
	        S: {1: true, 3: true, drawn: 5},
	        // A: {1: true, 6: true},
	        Z: {}
	    },
	
	    numParams: {
	        M: 2,
	        L: 2,
	        H: 1,
	        V: 1,
	        Q: 4,
	        C: 6,
	        T: 2,
	        S: 4,
	        // A: 7,
	        Z: 0
	    }
	};
	
	},{}],669:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var helpers = _dereq_('./helpers');
	
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    handleArrayContainerDefaults(layoutIn, layoutOut, {
	        name: 'shapes',
	        handleItemDefaults: handleShapeDefaults
	    });
	};
	
	function handleShapeDefaults(shapeIn, shapeOut, fullLayout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(shapeIn, shapeOut, attributes, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	
	    if(!visible) return;
	
	    coerce('layer');
	    coerce('opacity');
	    coerce('fillcolor');
	    coerce('line.color');
	    coerce('line.width');
	    coerce('line.dash');
	
	    var dfltType = shapeIn.path ? 'path' : 'rect';
	    var shapeType = coerce('type', dfltType);
	    var xSizeMode = coerce('xsizemode');
	    var ySizeMode = coerce('ysizemode');
	
	    // positioning
	    var axLetters = ['x', 'y'];
	    for(var i = 0; i < 2; i++) {
	        var axLetter = axLetters[i];
	        var attrAnchor = axLetter + 'anchor';
	        var sizeMode = axLetter === 'x' ? xSizeMode : ySizeMode;
	        var gdMock = {_fullLayout: fullLayout};
	        var ax;
	        var pos2r;
	        var r2pos;
	
	        // xref, yref
	        var axRef = Axes.coerceRef(shapeIn, shapeOut, gdMock, axLetter, '', 'paper');
	
	        if(axRef !== 'paper') {
	            ax = Axes.getFromId(gdMock, axRef);
	            ax._shapeIndices.push(shapeOut._index);
	            r2pos = helpers.rangeToShapePosition(ax);
	            pos2r = helpers.shapePositionToRange(ax);
	        } else {
	            pos2r = r2pos = Lib.identity;
	        }
	
	        // Coerce x0, x1, y0, y1
	        if(shapeType !== 'path') {
	            var dflt0 = 0.25;
	            var dflt1 = 0.75;
	
	            // hack until V2.0 when log has regular range behavior - make it look like other
	            // ranges to send to coerce, then put it back after
	            // this is all to give reasonable default position behavior on log axes, which is
	            // a pretty unimportant edge case so we could just ignore this.
	            var attr0 = axLetter + '0';
	            var attr1 = axLetter + '1';
	            var in0 = shapeIn[attr0];
	            var in1 = shapeIn[attr1];
	            shapeIn[attr0] = pos2r(shapeIn[attr0], true);
	            shapeIn[attr1] = pos2r(shapeIn[attr1], true);
	
	            if(sizeMode === 'pixel') {
	                coerce(attr0, 0);
	                coerce(attr1, 10);
	            } else {
	                Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr0, dflt0);
	                Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr1, dflt1);
	            }
	
	            // hack part 2
	            shapeOut[attr0] = r2pos(shapeOut[attr0]);
	            shapeOut[attr1] = r2pos(shapeOut[attr1]);
	            shapeIn[attr0] = in0;
	            shapeIn[attr1] = in1;
	        }
	
	        // Coerce xanchor and yanchor
	        if(sizeMode === 'pixel') {
	            // Hack for log axis described above
	            var inAnchor = shapeIn[attrAnchor];
	            shapeIn[attrAnchor] = pos2r(shapeIn[attrAnchor], true);
	
	            Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attrAnchor, 0.25);
	
	            // Hack part 2
	            shapeOut[attrAnchor] = r2pos(shapeOut[attrAnchor]);
	            shapeIn[attrAnchor] = inAnchor;
	        }
	    }
	
	    if(shapeType === 'path') {
	        coerce('path');
	    } else {
	        Lib.noneOrAll(shapeIn, shapeOut, ['x0', 'x1', 'y0', 'y1']);
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/cartesian/axes":764,"./attributes":666,"./helpers":671}],670:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
	
	var dragElement = _dereq_('../dragelement');
	var setCursor = _dereq_('../../lib/setcursor');
	
	var constants = _dereq_('./constants');
	var helpers = _dereq_('./helpers');
	
	
	// Shapes are stored in gd.layout.shapes, an array of objects
	// index can point to one item in this array,
	//  or non-numeric to simply add a new one
	//  or -1 to modify all existing
	// opt can be the full options object, or one key (to be set to value)
	//  or undefined to simply redraw
	// if opt is blank, val can be 'add' or a full options object to add a new
	//  annotation at that point in the array, or 'remove' to delete this one
	
	module.exports = {
	    draw: draw,
	    drawOne: drawOne
	};
	
	function draw(gd) {
	    var fullLayout = gd._fullLayout;
	
	    // Remove previous shapes before drawing new in shapes in fullLayout.shapes
	    fullLayout._shapeUpperLayer.selectAll('path').remove();
	    fullLayout._shapeLowerLayer.selectAll('path').remove();
	
	    for(var k in fullLayout._plots) {
	        var shapelayer = fullLayout._plots[k].shapelayer;
	        if(shapelayer) shapelayer.selectAll('path').remove();
	    }
	
	    for(var i = 0; i < fullLayout.shapes.length; i++) {
	        if(fullLayout.shapes[i].visible) {
	            drawOne(gd, i);
	        }
	    }
	
	    // may need to resurrect this if we put text (LaTeX) in shapes
	    // return Plots.previousPromises(gd);
	}
	
	function drawOne(gd, index) {
	    // remove the existing shape if there is one.
	    // because indices can change, we need to look in all shape layers
	    gd._fullLayout._paperdiv
	        .selectAll('.shapelayer [data-index="' + index + '"]')
	        .remove();
	
	    var options = gd._fullLayout.shapes[index] || {};
	
	    // this shape is gone - quit now after deleting it
	    // TODO: use d3 idioms instead of deleting and redrawing every time
	    if(!options._input || options.visible === false) return;
	
	    if(options.layer !== 'below') {
	        drawShape(gd._fullLayout._shapeUpperLayer);
	    } else if(options.xref === 'paper' || options.yref === 'paper') {
	        drawShape(gd._fullLayout._shapeLowerLayer);
	    } else {
	        var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
	        if(plotinfo) {
	            var mainPlot = plotinfo.mainplotinfo || plotinfo;
	            drawShape(mainPlot.shapelayer);
	        } else {
	            // Fall back to _shapeLowerLayer in case the requested subplot doesn't exist.
	            // This can happen if you reference the shape to an x / y axis combination
	            // that doesn't have any data on it (and layer is below)
	            drawShape(gd._fullLayout._shapeLowerLayer);
	        }
	    }
	
	    function drawShape(shapeLayer) {
	        var attrs = {
	            'data-index': index,
	            'fill-rule': 'evenodd',
	            d: getPathString(gd, options)
	        };
	        var lineColor = options.line.width ? options.line.color : 'rgba(0,0,0,0)';
	
	        var path = shapeLayer.append('path')
	            .attr(attrs)
	            .style('opacity', options.opacity)
	            .call(Color.stroke, lineColor)
	            .call(Color.fill, options.fillcolor)
	            .call(Drawing.dashLine, options.line.dash, options.line.width);
	
	        setClipPath(path, gd, options);
	
	        if(gd._context.edits.shapePosition) setupDragElement(gd, path, options, index, shapeLayer);
	    }
	}
	
	function setClipPath(shapePath, gd, shapeOptions) {
	    // note that for layer="below" the clipAxes can be different from the
	    // subplot we're drawing this in. This could cause problems if the shape
	    // spans two subplots. See https://github.com/plotly/plotly.js/issues/1452
	    var clipAxes = (shapeOptions.xref + shapeOptions.yref).replace(/paper/g, '');
	
	    Drawing.setClipUrl(
	        shapePath,
	        clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null,
	        gd
	    );
	}
	
	function setupDragElement(gd, shapePath, shapeOptions, index, shapeLayer) {
	    var MINWIDTH = 10;
	    var MINHEIGHT = 10;
	
	    var xPixelSized = shapeOptions.xsizemode === 'pixel';
	    var yPixelSized = shapeOptions.ysizemode === 'pixel';
	    var isLine = shapeOptions.type === 'line';
	    var isPath = shapeOptions.type === 'path';
	
	    var editHelpers = arrayEditor(gd.layout, 'shapes', shapeOptions);
	    var modifyItem = editHelpers.modifyItem;
	
	    var x0, y0, x1, y1, xAnchor, yAnchor;
	    var n0, s0, w0, e0, optN, optS, optW, optE;
	    var pathIn;
	
	    // setup conversion functions
	    var xa = Axes.getFromId(gd, shapeOptions.xref);
	    var ya = Axes.getFromId(gd, shapeOptions.yref);
	    var x2p = helpers.getDataToPixel(gd, xa);
	    var y2p = helpers.getDataToPixel(gd, ya, true);
	    var p2x = helpers.getPixelToData(gd, xa);
	    var p2y = helpers.getPixelToData(gd, ya, true);
	
	    var sensoryElement = obtainSensoryElement();
	    var dragOptions = {
	        element: sensoryElement.node(),
	        gd: gd,
	        prepFn: startDrag,
	        doneFn: endDrag,
	        clickFn: abortDrag
	    };
	    var dragMode;
	
	    dragElement.init(dragOptions);
	
	    sensoryElement.node().onmousemove = updateDragMode;
	
	    function obtainSensoryElement() {
	        return isLine ? createLineDragHandles() : shapePath;
	    }
	
	    function createLineDragHandles() {
	        var minSensoryWidth = 10;
	        var sensoryWidth = Math.max(shapeOptions.line.width, minSensoryWidth);
	
	        // Helper shapes group
	        // Note that by setting the `data-index` attr, it is ensured that
	        // the helper group is purged in this modules `draw` function
	        var g = shapeLayer.append('g')
	          .attr('data-index', index);
	
	        // Helper path for moving
	        g.append('path')
	          .attr('d', shapePath.attr('d'))
	          .style({
	              'cursor': 'move',
	              'stroke-width': sensoryWidth,
	              'stroke-opacity': '0' // ensure not visible
	          });
	
	        // Helper circles for resizing
	        var circleStyle = {
	            'fill-opacity': '0' // ensure not visible
	        };
	        var circleRadius = sensoryWidth / 2 > minSensoryWidth ? sensoryWidth / 2 : minSensoryWidth;
	
	        g.append('circle')
	          .attr({
	              'data-line-point': 'start-point',
	              'cx': xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x0 : x2p(shapeOptions.x0),
	              'cy': yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y0 : y2p(shapeOptions.y0),
	              'r': circleRadius
	          })
	          .style(circleStyle)
	          .classed('cursor-grab', true);
	
	        g.append('circle')
	          .attr({
	              'data-line-point': 'end-point',
	              'cx': xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x1 : x2p(shapeOptions.x1),
	              'cy': yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y1 : y2p(shapeOptions.y1),
	              'r': circleRadius
	          })
	          .style(circleStyle)
	          .classed('cursor-grab', true);
	
	        return g;
	    }
	
	    function updateDragMode(evt) {
	        if(isLine) {
	            if(evt.target.tagName === 'path') {
	                dragMode = 'move';
	            } else {
	                dragMode = evt.target.attributes['data-line-point'].value === 'start-point' ?
	                  'resize-over-start-point' : 'resize-over-end-point';
	            }
	        } else {
	            // element might not be on screen at time of setup,
	            // so obtain bounding box here
	            var dragBBox = dragOptions.element.getBoundingClientRect();
	
	            // choose 'move' or 'resize'
	            // based on initial position of cursor within the drag element
	            var w = dragBBox.right - dragBBox.left;
	            var h = dragBBox.bottom - dragBBox.top;
	            var x = evt.clientX - dragBBox.left;
	            var y = evt.clientY - dragBBox.top;
	            var cursor = (!isPath && w > MINWIDTH && h > MINHEIGHT && !evt.shiftKey) ?
	                dragElement.getCursor(x / w, 1 - y / h) :
	                'move';
	
	            setCursor(shapePath, cursor);
	
	            // possible values 'move', 'sw', 'w', 'se', 'e', 'ne', 'n', 'nw' and 'w'
	            dragMode = cursor.split('-')[0];
	        }
	    }
	
	    function startDrag(evt) {
	        // setup update strings and initial values
	        if(xPixelSized) {
	            xAnchor = x2p(shapeOptions.xanchor);
	        }
	        if(yPixelSized) {
	            yAnchor = y2p(shapeOptions.yanchor);
	        }
	
	        if(shapeOptions.type === 'path') {
	            pathIn = shapeOptions.path;
	        } else {
	            x0 = xPixelSized ? shapeOptions.x0 : x2p(shapeOptions.x0);
	            y0 = yPixelSized ? shapeOptions.y0 : y2p(shapeOptions.y0);
	            x1 = xPixelSized ? shapeOptions.x1 : x2p(shapeOptions.x1);
	            y1 = yPixelSized ? shapeOptions.y1 : y2p(shapeOptions.y1);
	        }
	
	        if(x0 < x1) {
	            w0 = x0;
	            optW = 'x0';
	            e0 = x1;
	            optE = 'x1';
	        } else {
	            w0 = x1;
	            optW = 'x1';
	            e0 = x0;
	            optE = 'x0';
	        }
	
	        // For fixed size shapes take opposing direction of y-axis into account.
	        // Hint: For data sized shapes this is done by the y2p function.
	        if((!yPixelSized && y0 < y1) || (yPixelSized && y0 > y1)) {
	            n0 = y0;
	            optN = 'y0';
	            s0 = y1;
	            optS = 'y1';
	        } else {
	            n0 = y1;
	            optN = 'y1';
	            s0 = y0;
	            optS = 'y0';
	        }
	
	        // setup dragMode and the corresponding handler
	        updateDragMode(evt);
	        renderVisualCues(shapeLayer, shapeOptions);
	        deactivateClipPathTemporarily(shapePath, shapeOptions, gd);
	        dragOptions.moveFn = (dragMode === 'move') ? moveShape : resizeShape;
	    }
	
	    function endDrag() {
	        setCursor(shapePath);
	        removeVisualCues(shapeLayer);
	
	        // Don't rely on clipPath being activated during re-layout
	        setClipPath(shapePath, gd, shapeOptions);
	        Registry.call('_guiRelayout', gd, editHelpers.getUpdateObj());
	    }
	
	    function abortDrag() {
	        removeVisualCues(shapeLayer);
	    }
	
	    function moveShape(dx, dy) {
	        if(shapeOptions.type === 'path') {
	            var noOp = function(coord) { return coord; };
	            var moveX = noOp;
	            var moveY = noOp;
	
	            if(xPixelSized) {
	                modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
	            } else {
	                moveX = function moveX(x) { return p2x(x2p(x) + dx); };
	                if(xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
	            }
	
	            if(yPixelSized) {
	                modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
	            } else {
	                moveY = function moveY(y) { return p2y(y2p(y) + dy); };
	                if(ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
	            }
	
	            modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
	        } else {
	            if(xPixelSized) {
	                modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
	            } else {
	                modifyItem('x0', shapeOptions.x0 = p2x(x0 + dx));
	                modifyItem('x1', shapeOptions.x1 = p2x(x1 + dx));
	            }
	
	            if(yPixelSized) {
	                modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
	            } else {
	                modifyItem('y0', shapeOptions.y0 = p2y(y0 + dy));
	                modifyItem('y1', shapeOptions.y1 = p2y(y1 + dy));
	            }
	        }
	
	        shapePath.attr('d', getPathString(gd, shapeOptions));
	        renderVisualCues(shapeLayer, shapeOptions);
	    }
	
	    function resizeShape(dx, dy) {
	        if(isPath) {
	            // TODO: implement path resize, don't forget to update dragMode code
	            var noOp = function(coord) { return coord; };
	            var moveX = noOp;
	            var moveY = noOp;
	
	            if(xPixelSized) {
	                modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
	            } else {
	                moveX = function moveX(x) { return p2x(x2p(x) + dx); };
	                if(xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
	            }
	
	            if(yPixelSized) {
	                modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
	            } else {
	                moveY = function moveY(y) { return p2y(y2p(y) + dy); };
	                if(ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
	            }
	
	            modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
	        } else if(isLine) {
	            if(dragMode === 'resize-over-start-point') {
	                var newX0 = x0 + dx;
	                var newY0 = yPixelSized ? y0 - dy : y0 + dy;
	                modifyItem('x0', shapeOptions.x0 = xPixelSized ? newX0 : p2x(newX0));
	                modifyItem('y0', shapeOptions.y0 = yPixelSized ? newY0 : p2y(newY0));
	            } else if(dragMode === 'resize-over-end-point') {
	                var newX1 = x1 + dx;
	                var newY1 = yPixelSized ? y1 - dy : y1 + dy;
	                modifyItem('x1', shapeOptions.x1 = xPixelSized ? newX1 : p2x(newX1));
	                modifyItem('y1', shapeOptions.y1 = yPixelSized ? newY1 : p2y(newY1));
	            }
	        } else {
	            var newN = (~dragMode.indexOf('n')) ? n0 + dy : n0;
	            var newS = (~dragMode.indexOf('s')) ? s0 + dy : s0;
	            var newW = (~dragMode.indexOf('w')) ? w0 + dx : w0;
	            var newE = (~dragMode.indexOf('e')) ? e0 + dx : e0;
	
	            // Do things in opposing direction for y-axis.
	            // Hint: for data-sized shapes the reversal of axis direction is done in p2y.
	            if(~dragMode.indexOf('n') && yPixelSized) newN = n0 - dy;
	            if(~dragMode.indexOf('s') && yPixelSized) newS = s0 - dy;
	
	            // Update shape eventually. Again, be aware of the
	            // opposing direction of the y-axis of fixed size shapes.
	            if((!yPixelSized && newS - newN > MINHEIGHT) ||
	              (yPixelSized && newN - newS > MINHEIGHT)) {
	                modifyItem(optN, shapeOptions[optN] = yPixelSized ? newN : p2y(newN));
	                modifyItem(optS, shapeOptions[optS] = yPixelSized ? newS : p2y(newS));
	            }
	            if(newE - newW > MINWIDTH) {
	                modifyItem(optW, shapeOptions[optW] = xPixelSized ? newW : p2x(newW));
	                modifyItem(optE, shapeOptions[optE] = xPixelSized ? newE : p2x(newE));
	            }
	        }
	
	        shapePath.attr('d', getPathString(gd, shapeOptions));
	        renderVisualCues(shapeLayer, shapeOptions);
	    }
	
	    function renderVisualCues(shapeLayer, shapeOptions) {
	        if(xPixelSized || yPixelSized) {
	            renderAnchor();
	        }
	
	        function renderAnchor() {
	            var isNotPath = shapeOptions.type !== 'path';
	
	            // d3 join with dummy data to satisfy d3 data-binding
	            var visualCues = shapeLayer.selectAll('.visual-cue').data([0]);
	
	            // Enter
	            var strokeWidth = 1;
	            visualCues.enter()
	              .append('path')
	              .attr({
	                  'fill': '#fff',
	                  'fill-rule': 'evenodd',
	                  'stroke': '#000',
	                  'stroke-width': strokeWidth
	              })
	              .classed('visual-cue', true);
	
	            // Update
	            var posX = x2p(
	              xPixelSized ?
	                shapeOptions.xanchor :
	                Lib.midRange(
	                  isNotPath ?
	                    [shapeOptions.x0, shapeOptions.x1] :
	                    helpers.extractPathCoords(shapeOptions.path, constants.paramIsX))
	            );
	            var posY = y2p(
	              yPixelSized ?
	                shapeOptions.yanchor :
	                Lib.midRange(
	                  isNotPath ?
	                    [shapeOptions.y0, shapeOptions.y1] :
	                    helpers.extractPathCoords(shapeOptions.path, constants.paramIsY))
	            );
	
	            posX = helpers.roundPositionForSharpStrokeRendering(posX, strokeWidth);
	            posY = helpers.roundPositionForSharpStrokeRendering(posY, strokeWidth);
	
	            if(xPixelSized && yPixelSized) {
	                var crossPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 1 - strokeWidth) +
	                  'h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z';
	                visualCues.attr('d', crossPath);
	            } else if(xPixelSized) {
	                var vBarPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 9 - strokeWidth) +
	                  'v18 h2 v-18 Z';
	                visualCues.attr('d', vBarPath);
	            } else {
	                var hBarPath = 'M' + (posX - 9 - strokeWidth) + ',' + (posY - 1 - strokeWidth) +
	                  'h18 v2 h-18 Z';
	                visualCues.attr('d', hBarPath);
	            }
	        }
	    }
	
	    function removeVisualCues(shapeLayer) {
	        shapeLayer.selectAll('.visual-cue').remove();
	    }
	
	    function deactivateClipPathTemporarily(shapePath, shapeOptions, gd) {
	        var xref = shapeOptions.xref;
	        var yref = shapeOptions.yref;
	        var xa = Axes.getFromId(gd, xref);
	        var ya = Axes.getFromId(gd, yref);
	
	        var clipAxes = '';
	        if(xref !== 'paper' && !xa.autorange) clipAxes += xref;
	        if(yref !== 'paper' && !ya.autorange) clipAxes += yref;
	
	        Drawing.setClipUrl(
	            shapePath,
	            clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null,
	            gd
	        );
	    }
	}
	
	function getPathString(gd, options) {
	    var type = options.type;
	    var xa = Axes.getFromId(gd, options.xref);
	    var ya = Axes.getFromId(gd, options.yref);
	    var gs = gd._fullLayout._size;
	    var x2r, x2p, y2r, y2p;
	    var x0, x1, y0, y1;
	
	    if(xa) {
	        x2r = helpers.shapePositionToRange(xa);
	        x2p = function(v) { return xa._offset + xa.r2p(x2r(v, true)); };
	    } else {
	        x2p = function(v) { return gs.l + gs.w * v; };
	    }
	
	    if(ya) {
	        y2r = helpers.shapePositionToRange(ya);
	        y2p = function(v) { return ya._offset + ya.r2p(y2r(v, true)); };
	    } else {
	        y2p = function(v) { return gs.t + gs.h * (1 - v); };
	    }
	
	    if(type === 'path') {
	        if(xa && xa.type === 'date') x2p = helpers.decodeDate(x2p);
	        if(ya && ya.type === 'date') y2p = helpers.decodeDate(y2p);
	        return convertPath(options, x2p, y2p);
	    }
	
	    if(options.xsizemode === 'pixel') {
	        var xAnchorPos = x2p(options.xanchor);
	        x0 = xAnchorPos + options.x0;
	        x1 = xAnchorPos + options.x1;
	    } else {
	        x0 = x2p(options.x0);
	        x1 = x2p(options.x1);
	    }
	
	    if(options.ysizemode === 'pixel') {
	        var yAnchorPos = y2p(options.yanchor);
	        y0 = yAnchorPos - options.y0;
	        y1 = yAnchorPos - options.y1;
	    } else {
	        y0 = y2p(options.y0);
	        y1 = y2p(options.y1);
	    }
	
	    if(type === 'line') return 'M' + x0 + ',' + y0 + 'L' + x1 + ',' + y1;
	    if(type === 'rect') return 'M' + x0 + ',' + y0 + 'H' + x1 + 'V' + y1 + 'H' + x0 + 'Z';
	
	    // circle
	    var cx = (x0 + x1) / 2;
	    var cy = (y0 + y1) / 2;
	    var rx = Math.abs(cx - x0);
	    var ry = Math.abs(cy - y0);
	    var rArc = 'A' + rx + ',' + ry;
	    var rightPt = (cx + rx) + ',' + cy;
	    var topPt = cx + ',' + (cy - ry);
	    return 'M' + rightPt + rArc + ' 0 1,1 ' + topPt +
	        rArc + ' 0 0,1 ' + rightPt + 'Z';
	}
	
	
	function convertPath(options, x2p, y2p) {
	    var pathIn = options.path;
	    var xSizemode = options.xsizemode;
	    var ySizemode = options.ysizemode;
	    var xAnchor = options.xanchor;
	    var yAnchor = options.yanchor;
	
	    return pathIn.replace(constants.segmentRE, function(segment) {
	        var paramNumber = 0;
	        var segmentType = segment.charAt(0);
	        var xParams = constants.paramIsX[segmentType];
	        var yParams = constants.paramIsY[segmentType];
	        var nParams = constants.numParams[segmentType];
	
	        var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
	            if(xParams[paramNumber]) {
	                if(xSizemode === 'pixel') param = x2p(xAnchor) + Number(param);
	                else param = x2p(param);
	            } else if(yParams[paramNumber]) {
	                if(ySizemode === 'pixel') param = y2p(yAnchor) - Number(param);
	                else param = y2p(param);
	            }
	            paramNumber++;
	
	            if(paramNumber > nParams) param = 'X';
	            return param;
	        });
	
	        if(paramNumber > nParams) {
	            paramString = paramString.replace(/[\s,]*X.*/, '');
	            Lib.log('Ignoring extra params in segment ' + segment);
	        }
	
	        return segmentType + paramString;
	    });
	}
	
	function movePath(pathIn, moveX, moveY) {
	    return pathIn.replace(constants.segmentRE, function(segment) {
	        var paramNumber = 0;
	        var segmentType = segment.charAt(0);
	        var xParams = constants.paramIsX[segmentType];
	        var yParams = constants.paramIsY[segmentType];
	        var nParams = constants.numParams[segmentType];
	
	        var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
	            if(paramNumber >= nParams) return param;
	
	            if(xParams[paramNumber]) param = moveX(param);
	            else if(yParams[paramNumber]) param = moveY(param);
	
	            paramNumber++;
	
	            return param;
	        });
	
	        return segmentType + paramString;
	    });
	}
	
	},{"../../lib":716,"../../lib/setcursor":736,"../../plot_api/plot_template":754,"../../plots/cartesian/axes":764,"../../registry":845,"../color":591,"../dragelement":609,"../drawing":612,"./constants":668,"./helpers":671}],671:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var constants = _dereq_('./constants');
	
	var Lib = _dereq_('../../lib');
	
	// special position conversion functions... category axis positions can't be
	// specified by their data values, because they don't make a continuous mapping.
	// so these have to be specified in terms of the category serial numbers,
	// but can take fractional values. Other axis types we specify position based on
	// the actual data values.
	// TODO: in V2.0 (when log axis ranges are in data units) range and shape position
	// will be identical, so rangeToShapePosition and shapePositionToRange can be
	// removed entirely.
	
	exports.rangeToShapePosition = function(ax) {
	    return (ax.type === 'log') ? ax.r2d : function(v) { return v; };
	};
	
	exports.shapePositionToRange = function(ax) {
	    return (ax.type === 'log') ? ax.d2r : function(v) { return v; };
	};
	
	exports.decodeDate = function(convertToPx) {
	    return function(v) {
	        if(v.replace) v = v.replace('_', ' ');
	        return convertToPx(v);
	    };
	};
	
	exports.encodeDate = function(convertToDate) {
	    return function(v) { return convertToDate(v).replace(' ', '_'); };
	};
	
	exports.extractPathCoords = function(path, paramsToUse) {
	    var extractedCoordinates = [];
	
	    var segments = path.match(constants.segmentRE);
	    segments.forEach(function(segment) {
	        var relevantParamIdx = paramsToUse[segment.charAt(0)].drawn;
	        if(relevantParamIdx === undefined) return;
	
	        var params = segment.substr(1).match(constants.paramRE);
	        if(!params || params.length < relevantParamIdx) return;
	
	        extractedCoordinates.push(Lib.cleanNumber(params[relevantParamIdx]));
	    });
	
	    return extractedCoordinates;
	};
	
	exports.getDataToPixel = function(gd, axis, isVertical) {
	    var gs = gd._fullLayout._size;
	    var dataToPixel;
	
	    if(axis) {
	        var d2r = exports.shapePositionToRange(axis);
	
	        dataToPixel = function(v) {
	            return axis._offset + axis.r2p(d2r(v, true));
	        };
	
	        if(axis.type === 'date') dataToPixel = exports.decodeDate(dataToPixel);
	    } else if(isVertical) {
	        dataToPixel = function(v) { return gs.t + gs.h * (1 - v); };
	    } else {
	        dataToPixel = function(v) { return gs.l + gs.w * v; };
	    }
	
	    return dataToPixel;
	};
	
	exports.getPixelToData = function(gd, axis, isVertical) {
	    var gs = gd._fullLayout._size;
	    var pixelToData;
	
	    if(axis) {
	        var r2d = exports.rangeToShapePosition(axis);
	        pixelToData = function(p) { return r2d(axis.p2r(p - axis._offset)); };
	    } else if(isVertical) {
	        pixelToData = function(p) { return 1 - (p - gs.t) / gs.h; };
	    } else {
	        pixelToData = function(p) { return (p - gs.l) / gs.w; };
	    }
	
	    return pixelToData;
	};
	
	/**
	 * Based on the given stroke width, rounds the passed
	 * position value to represent either a full or half pixel.
	 *
	 * In case of an odd stroke width (e.g. 1), this measure ensures
	 * that a stroke positioned at the returned position isn't rendered
	 * blurry due to anti-aliasing.
	 *
	 * In case of an even stroke width (e.g. 2), this measure ensures
	 * that the position value is transformed to a full pixel value
	 * so that anti-aliasing doesn't take effect either.
	 *
	 * @param {number} pos The raw position value to be transformed
	 * @param {number} strokeWidth The stroke width
	 * @returns {number} either an integer or a .5 decimal number
	 */
	exports.roundPositionForSharpStrokeRendering = function(pos, strokeWidth) {
	    var strokeWidthIsOdd = Math.round(strokeWidth % 2) === 1;
	    var posValAsInt = Math.round(pos);
	
	    return strokeWidthIsOdd ? posValAsInt + 0.5 : posValAsInt;
	};
	
	},{"../../lib":716,"./constants":668}],672:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var drawModule = _dereq_('./draw');
	
	module.exports = {
	    moduleType: 'component',
	    name: 'shapes',
	
	    layoutAttributes: _dereq_('./attributes'),
	    supplyLayoutDefaults: _dereq_('./defaults'),
	    includeBasePlot: _dereq_('../../plots/cartesian/include_components')('shapes'),
	
	    calcAutorange: _dereq_('./calc_autorange'),
	    draw: drawModule.draw,
	    drawOne: drawModule.drawOne
	};
	
	},{"../../plots/cartesian/include_components":774,"./attributes":666,"./calc_autorange":667,"./defaults":669,"./draw":670}],673:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var padAttrs = _dereq_('../../plots/pad_attributes');
	var extendDeepAll = _dereq_('../../lib/extend').extendDeepAll;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var animationAttrs = _dereq_('../../plots/animation_attributes');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	var constants = _dereq_('./constants');
	
	var stepsAttrs = templatedArray('step', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	    method: {
	        valType: 'enumerated',
	        values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
	        dflt: 'restyle',
	        
	        
	    },
	    args: {
	        valType: 'info_array',
	        
	        freeLength: true,
	        items: [
	            { valType: 'any' },
	            { valType: 'any' },
	            { valType: 'any' }
	        ],
	        
	    },
	    label: {
	        valType: 'string',
	        
	        
	    },
	    value: {
	        valType: 'string',
	        
	        
	    },
	    execute: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    }
	});
	
	module.exports = overrideAll(templatedArray('slider', {
	    visible: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	
	    active: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 0,
	        
	    },
	
	    steps: stepsAttrs,
	
	    lenmode: {
	        valType: 'enumerated',
	        values: ['fraction', 'pixels'],
	        
	        dflt: 'fraction',
	        
	    },
	    len: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        
	    },
	    x: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        dflt: 0,
	        
	        
	    },
	    pad: extendDeepAll(padAttrs({editType: 'arraydraw'}), {
	        
	    }, {t: {dflt: 20}}),
	    xanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'left', 'center', 'right'],
	        dflt: 'left',
	        
	        
	    },
	    y: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        dflt: 0,
	        
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'top', 'middle', 'bottom'],
	        dflt: 'top',
	        
	        
	    },
	
	    transition: {
	        duration: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 150,
	            
	        },
	        easing: {
	            valType: 'enumerated',
	            values: animationAttrs.transition.easing.values,
	            
	            dflt: 'cubic-in-out',
	            
	        }
	    },
	
	    currentvalue: {
	        visible: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	
	        xanchor: {
	            valType: 'enumerated',
	            values: ['left', 'center', 'right'],
	            dflt: 'left',
	            
	            
	        },
	
	        offset: {
	            valType: 'number',
	            dflt: 10,
	            
	            
	        },
	
	        prefix: {
	            valType: 'string',
	            
	            
	        },
	
	        suffix: {
	            valType: 'string',
	            
	            
	        },
	
	        font: fontAttrs({
	            
	        })
	    },
	
	    font: fontAttrs({
	        
	    }),
	
	    activebgcolor: {
	        valType: 'color',
	        
	        dflt: constants.gripBgActiveColor,
	        
	    },
	    bgcolor: {
	        valType: 'color',
	        
	        dflt: constants.railBgColor,
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: constants.railBorderColor,
	        
	        
	    },
	    borderwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: constants.railBorderWidth,
	        
	        
	    },
	    ticklen: {
	        valType: 'number',
	        min: 0,
	        dflt: constants.tickLength,
	        
	        
	    },
	    tickcolor: {
	        valType: 'color',
	        dflt: constants.tickColor,
	        
	        
	    },
	    tickwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        
	    },
	    minorticklen: {
	        valType: 'number',
	        min: 0,
	        dflt: constants.minorTickLength,
	        
	        
	    }
	}), 'arraydraw', 'from-root');
	
	},{"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../../plots/animation_attributes":759,"../../plots/font_attributes":790,"../../plots/pad_attributes":824,"./constants":674}],674:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = {
	
	    // layout attribute name
	    name: 'sliders',
	
	    // class names
	    containerClassName: 'slider-container',
	    groupClassName: 'slider-group',
	    inputAreaClass: 'slider-input-area',
	    railRectClass: 'slider-rail-rect',
	    railTouchRectClass: 'slider-rail-touch-rect',
	    gripRectClass: 'slider-grip-rect',
	    tickRectClass: 'slider-tick-rect',
	    inputProxyClass: 'slider-input-proxy',
	    labelsClass: 'slider-labels',
	    labelGroupClass: 'slider-label-group',
	    labelClass: 'slider-label',
	    currentValueClass: 'slider-current-value',
	
	    railHeight: 5,
	
	    // DOM attribute name in button group keeping track
	    // of active update menu
	    menuIndexAttrName: 'slider-active-index',
	
	    // id root pass to Plots.autoMargin
	    autoMarginIdRoot: 'slider-',
	
	    // min item width / height
	    minWidth: 30,
	    minHeight: 30,
	
	    // padding around item text
	    textPadX: 40,
	
	    // arrow offset off right edge
	    arrowOffsetX: 4,
	
	    railRadius: 2,
	    railWidth: 5,
	    railBorder: 4,
	    railBorderWidth: 1,
	    railBorderColor: '#bec8d9',
	    railBgColor: '#f8fafc',
	
	    // The distance of the rail from the edge of the touchable area
	    // Slightly less than the step inset because of the curved edges
	    // of the rail
	    railInset: 8,
	
	    // The distance from the extremal tick marks to the edge of the
	    // touchable area. This is basically the same as the grip radius,
	    // but for other styles it wouldn't really need to be.
	    stepInset: 10,
	
	    gripRadius: 10,
	    gripWidth: 20,
	    gripHeight: 20,
	    gripBorder: 20,
	    gripBorderWidth: 1,
	    gripBorderColor: '#bec8d9',
	    gripBgColor: '#f6f8fa',
	    gripBgActiveColor: '#dbdde0',
	
	    labelPadding: 8,
	    labelOffset: 0,
	
	    tickWidth: 1,
	    tickColor: '#333',
	    tickOffset: 25,
	    tickLength: 7,
	
	    minorTickOffset: 25,
	    minorTickColor: '#333',
	    minorTickLength: 4,
	
	    // Extra space below the current value label:
	    currentValuePadding: 8,
	    currentValueInset: 0,
	};
	
	},{}],675:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('./constants');
	
	var name = constants.name;
	var stepAttrs = attributes.steps;
	
	
	module.exports = function slidersDefaults(layoutIn, layoutOut) {
	    handleArrayContainerDefaults(layoutIn, layoutOut, {
	        name: name,
	        handleItemDefaults: sliderDefaults
	    });
	};
	
	function sliderDefaults(sliderIn, sliderOut, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(sliderIn, sliderOut, attributes, attr, dflt);
	    }
	
	    var steps = handleArrayContainerDefaults(sliderIn, sliderOut, {
	        name: 'steps',
	        handleItemDefaults: stepDefaults
	    });
	
	    var stepCount = 0;
	    for(var i = 0; i < steps.length; i++) {
	        if(steps[i].visible) stepCount++;
	    }
	
	    var visible;
	    // If it has fewer than two options, it's not really a slider
	    if(stepCount < 2) visible = sliderOut.visible = false;
	    else visible = coerce('visible');
	    if(!visible) return;
	
	    sliderOut._stepCount = stepCount;
	    var visSteps = sliderOut._visibleSteps = Lib.filterVisible(steps);
	
	    var active = coerce('active');
	    if(!(steps[active] || {}).visible) sliderOut.active = visSteps[0]._index;
	
	    coerce('x');
	    coerce('y');
	    Lib.noneOrAll(sliderIn, sliderOut, ['x', 'y']);
	
	    coerce('xanchor');
	    coerce('yanchor');
	
	    coerce('len');
	    coerce('lenmode');
	
	    coerce('pad.t');
	    coerce('pad.r');
	    coerce('pad.b');
	    coerce('pad.l');
	
	    Lib.coerceFont(coerce, 'font', layoutOut.font);
	
	    var currentValueIsVisible = coerce('currentvalue.visible');
	
	    if(currentValueIsVisible) {
	        coerce('currentvalue.xanchor');
	        coerce('currentvalue.prefix');
	        coerce('currentvalue.suffix');
	        coerce('currentvalue.offset');
	
	        Lib.coerceFont(coerce, 'currentvalue.font', sliderOut.font);
	    }
	
	    coerce('transition.duration');
	    coerce('transition.easing');
	
	    coerce('bgcolor');
	    coerce('activebgcolor');
	    coerce('bordercolor');
	    coerce('borderwidth');
	    coerce('ticklen');
	    coerce('tickwidth');
	    coerce('tickcolor');
	    coerce('minorticklen');
	}
	
	function stepDefaults(valueIn, valueOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(valueIn, valueOut, stepAttrs, attr, dflt);
	    }
	
	    var visible;
	    if(valueIn.method !== 'skip' && !Array.isArray(valueIn.args)) {
	        visible = valueOut.visible = false;
	    } else visible = coerce('visible');
	
	    if(visible) {
	        coerce('method');
	        coerce('args');
	        var label = coerce('label', 'step-' + valueOut._index);
	        coerce('value', label);
	        coerce('execute');
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"./attributes":673,"./constants":674}],676:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Plots = _dereq_('../../plots/plots');
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
	
	var constants = _dereq_('./constants');
	var alignmentConstants = _dereq_('../../constants/alignment');
	var LINE_SPACING = alignmentConstants.LINE_SPACING;
	var FROM_TL = alignmentConstants.FROM_TL;
	var FROM_BR = alignmentConstants.FROM_BR;
	
	module.exports = function draw(gd) {
	    var fullLayout = gd._fullLayout;
	    var sliderData = makeSliderData(fullLayout, gd);
	
	    // draw a container for *all* sliders:
	    var sliders = fullLayout._infolayer
	        .selectAll('g.' + constants.containerClassName)
	        .data(sliderData.length > 0 ? [0] : []);
	
	    sliders.enter().append('g')
	        .classed(constants.containerClassName, true)
	        .style('cursor', 'ew-resize');
	
	    function clearSlider(sliderOpts) {
	        if(sliderOpts._commandObserver) {
	            sliderOpts._commandObserver.remove();
	            delete sliderOpts._commandObserver;
	        }
	
	        // Most components don't need to explicitly remove autoMargin, because
	        // marginPushers does this - but slider updates don't go through
	        // a full replot so we need to explicitly remove it.
	        Plots.autoMargin(gd, autoMarginId(sliderOpts));
	    }
	
	    sliders.exit().each(function() {
	        d3.select(this).selectAll('g.' + constants.groupClassName)
	            .each(clearSlider);
	    })
	    .remove();
	
	    // Return early if no menus visible:
	    if(sliderData.length === 0) return;
	
	    var sliderGroups = sliders.selectAll('g.' + constants.groupClassName)
	        .data(sliderData, keyFunction);
	
	    sliderGroups.enter().append('g')
	        .classed(constants.groupClassName, true);
	
	    sliderGroups.exit()
	        .each(clearSlider)
	        .remove();
	
	    // Find the dimensions of the sliders:
	    for(var i = 0; i < sliderData.length; i++) {
	        var sliderOpts = sliderData[i];
	        findDimensions(gd, sliderOpts);
	    }
	
	    sliderGroups.each(function(sliderOpts) {
	        var gSlider = d3.select(this);
	
	        computeLabelSteps(sliderOpts);
	
	        Plots.manageCommandObserver(gd, sliderOpts, sliderOpts._visibleSteps, function(data) {
	            // NB: Same as below. This is *not* always the same as sliderOpts since
	            // if a new set of steps comes in, the reference in this callback would
	            // be invalid. We need to refetch it from the slider group, which is
	            // the join data that creates this slider. So if this slider still exists,
	            // the group should be valid, *to the best of my knowledge.* If not,
	            // we'd have to look it up by d3 data join index/key.
	            var opts = gSlider.data()[0];
	
	            if(opts.active === data.index) return;
	            if(opts._dragging) return;
	
	            setActive(gd, gSlider, opts, data.index, false, true);
	        });
	
	        drawSlider(gd, d3.select(this), sliderOpts);
	    });
	};
	
	function autoMarginId(sliderOpts) {
	    return constants.autoMarginIdRoot + sliderOpts._index;
	}
	
	// This really only just filters by visibility:
	function makeSliderData(fullLayout, gd) {
	    var contOpts = fullLayout[constants.name];
	    var sliderData = [];
	
	    for(var i = 0; i < contOpts.length; i++) {
	        var item = contOpts[i];
	        if(!item.visible) continue;
	        item._gd = gd;
	        sliderData.push(item);
	    }
	
	    return sliderData;
	}
	
	// This is set in the defaults step:
	function keyFunction(opts) {
	    return opts._index;
	}
	
	// Compute the dimensions (mutates sliderOpts):
	function findDimensions(gd, sliderOpts) {
	    var sliderLabels = Drawing.tester.selectAll('g.' + constants.labelGroupClass)
	        .data(sliderOpts._visibleSteps);
	
	    sliderLabels.enter().append('g')
	        .classed(constants.labelGroupClass, true);
	
	    // loop over fake buttons to find width / height
	    var maxLabelWidth = 0;
	    var labelHeight = 0;
	    sliderLabels.each(function(stepOpts) {
	        var labelGroup = d3.select(this);
	
	        var text = drawLabel(labelGroup, {step: stepOpts}, sliderOpts);
	
	        var textNode = text.node();
	        if(textNode) {
	            var bBox = Drawing.bBox(textNode);
	            labelHeight = Math.max(labelHeight, bBox.height);
	            maxLabelWidth = Math.max(maxLabelWidth, bBox.width);
	        }
	    });
	
	    sliderLabels.remove();
	
	    var dims = sliderOpts._dims = {};
	
	    dims.inputAreaWidth = Math.max(
	        constants.railWidth,
	        constants.gripHeight
	    );
	
	    // calculate some overall dimensions - some of these are needed for
	    // calculating the currentValue dimensions
	    var graphSize = gd._fullLayout._size;
	    dims.lx = graphSize.l + graphSize.w * sliderOpts.x;
	    dims.ly = graphSize.t + graphSize.h * (1 - sliderOpts.y);
	
	    if(sliderOpts.lenmode === 'fraction') {
	        // fraction:
	        dims.outerLength = Math.round(graphSize.w * sliderOpts.len);
	    } else {
	        // pixels:
	        dims.outerLength = sliderOpts.len;
	    }
	
	    // The length of the rail, *excluding* padding on either end:
	    dims.inputAreaStart = 0;
	    dims.inputAreaLength = Math.round(dims.outerLength - sliderOpts.pad.l - sliderOpts.pad.r);
	
	    var textableInputLength = dims.inputAreaLength - 2 * constants.stepInset;
	    var availableSpacePerLabel = textableInputLength / (sliderOpts._stepCount - 1);
	    var computedSpacePerLabel = maxLabelWidth + constants.labelPadding;
	    dims.labelStride = Math.max(1, Math.ceil(computedSpacePerLabel / availableSpacePerLabel));
	    dims.labelHeight = labelHeight;
	
	    // loop over all possible values for currentValue to find the
	    // area we need for it
	    dims.currentValueMaxWidth = 0;
	    dims.currentValueHeight = 0;
	    dims.currentValueTotalHeight = 0;
	    dims.currentValueMaxLines = 1;
	
	    if(sliderOpts.currentvalue.visible) {
	        // Get the dimensions of the current value label:
	        var dummyGroup = Drawing.tester.append('g');
	
	        sliderLabels.each(function(stepOpts) {
	            var curValPrefix = drawCurrentValue(dummyGroup, sliderOpts, stepOpts.label);
	            var curValSize = (curValPrefix.node() && Drawing.bBox(curValPrefix.node())) || {width: 0, height: 0};
	            var lines = svgTextUtils.lineCount(curValPrefix);
	            dims.currentValueMaxWidth = Math.max(dims.currentValueMaxWidth, Math.ceil(curValSize.width));
	            dims.currentValueHeight = Math.max(dims.currentValueHeight, Math.ceil(curValSize.height));
	            dims.currentValueMaxLines = Math.max(dims.currentValueMaxLines, lines);
	        });
	
	        dims.currentValueTotalHeight = dims.currentValueHeight + sliderOpts.currentvalue.offset;
	
	        dummyGroup.remove();
	    }
	
	    dims.height = dims.currentValueTotalHeight + constants.tickOffset + sliderOpts.ticklen + constants.labelOffset + dims.labelHeight + sliderOpts.pad.t + sliderOpts.pad.b;
	
	    var xanchor = 'left';
	    if(Lib.isRightAnchor(sliderOpts)) {
	        dims.lx -= dims.outerLength;
	        xanchor = 'right';
	    }
	    if(Lib.isCenterAnchor(sliderOpts)) {
	        dims.lx -= dims.outerLength / 2;
	        xanchor = 'center';
	    }
	
	    var yanchor = 'top';
	    if(Lib.isBottomAnchor(sliderOpts)) {
	        dims.ly -= dims.height;
	        yanchor = 'bottom';
	    }
	    if(Lib.isMiddleAnchor(sliderOpts)) {
	        dims.ly -= dims.height / 2;
	        yanchor = 'middle';
	    }
	
	    dims.outerLength = Math.ceil(dims.outerLength);
	    dims.height = Math.ceil(dims.height);
	    dims.lx = Math.round(dims.lx);
	    dims.ly = Math.round(dims.ly);
	
	    var marginOpts = {
	        y: sliderOpts.y,
	        b: dims.height * FROM_BR[yanchor],
	        t: dims.height * FROM_TL[yanchor]
	    };
	
	    if(sliderOpts.lenmode === 'fraction') {
	        marginOpts.l = 0;
	        marginOpts.xl = sliderOpts.x - sliderOpts.len * FROM_TL[xanchor];
	        marginOpts.r = 0;
	        marginOpts.xr = sliderOpts.x + sliderOpts.len * FROM_BR[xanchor];
	    } else {
	        marginOpts.x = sliderOpts.x;
	        marginOpts.l = dims.outerLength * FROM_TL[xanchor];
	        marginOpts.r = dims.outerLength * FROM_BR[xanchor];
	    }
	
	    Plots.autoMargin(gd, autoMarginId(sliderOpts), marginOpts);
	}
	
	function drawSlider(gd, sliderGroup, sliderOpts) {
	    // This is related to the other long notes in this file regarding what happens
	    // when slider steps disappear. This particular fix handles what happens when
	    // the *current* slider step is removed. The drawing functions will error out
	    // when they fail to find it, so the fix for now is that it will just draw the
	    // slider in the first position but will not execute the command.
	    if(!((sliderOpts.steps[sliderOpts.active] || {}).visible)) {
	        sliderOpts.active = sliderOpts._visibleSteps[0]._index;
	    }
	
	    // These are carefully ordered for proper z-ordering:
	    sliderGroup
	        .call(drawCurrentValue, sliderOpts)
	        .call(drawRail, sliderOpts)
	        .call(drawLabelGroup, sliderOpts)
	        .call(drawTicks, sliderOpts)
	        .call(drawTouchRect, gd, sliderOpts)
	        .call(drawGrip, gd, sliderOpts);
	
	    var dims = sliderOpts._dims;
	
	    // Position the rectangle:
	    Drawing.setTranslate(sliderGroup, dims.lx + sliderOpts.pad.l, dims.ly + sliderOpts.pad.t);
	
	    sliderGroup.call(setGripPosition, sliderOpts, false);
	    sliderGroup.call(drawCurrentValue, sliderOpts);
	}
	
	function drawCurrentValue(sliderGroup, sliderOpts, valueOverride) {
	    if(!sliderOpts.currentvalue.visible) return;
	
	    var dims = sliderOpts._dims;
	    var x0, textAnchor;
	
	    switch(sliderOpts.currentvalue.xanchor) {
	        case 'right':
	            // This is anchored left and adjusted by the width of the longest label
	            // so that the prefix doesn't move. The goal of this is to emphasize
	            // what's actually changing and make the update less distracting.
	            x0 = dims.inputAreaLength - constants.currentValueInset - dims.currentValueMaxWidth;
	            textAnchor = 'left';
	            break;
	        case 'center':
	            x0 = dims.inputAreaLength * 0.5;
	            textAnchor = 'middle';
	            break;
	        default:
	            x0 = constants.currentValueInset;
	            textAnchor = 'left';
	    }
	
	    var text = Lib.ensureSingle(sliderGroup, 'text', constants.labelClass, function(s) {
	        s.classed('user-select-none', true)
	            .attr({
	                'text-anchor': textAnchor,
	                'data-notex': 1
	            });
	    });
	
	    var str = sliderOpts.currentvalue.prefix ? sliderOpts.currentvalue.prefix : '';
	
	    if(typeof valueOverride === 'string') {
	        str += valueOverride;
	    } else {
	        var curVal = sliderOpts.steps[sliderOpts.active].label;
	        var _meta = sliderOpts._gd._fullLayout._meta;
	        if(_meta) curVal = Lib.templateString(curVal, _meta);
	        str += curVal;
	    }
	
	    if(sliderOpts.currentvalue.suffix) {
	        str += sliderOpts.currentvalue.suffix;
	    }
	
	    text.call(Drawing.font, sliderOpts.currentvalue.font)
	        .text(str)
	        .call(svgTextUtils.convertToTspans, sliderOpts._gd);
	
	    var lines = svgTextUtils.lineCount(text);
	
	    var y0 = (dims.currentValueMaxLines + 1 - lines) *
	        sliderOpts.currentvalue.font.size * LINE_SPACING;
	
	    svgTextUtils.positionText(text, x0, y0);
	
	    return text;
	}
	
	function drawGrip(sliderGroup, gd, sliderOpts) {
	    var grip = Lib.ensureSingle(sliderGroup, 'rect', constants.gripRectClass, function(s) {
	        s.call(attachGripEvents, gd, sliderGroup, sliderOpts)
	            .style('pointer-events', 'all');
	    });
	
	    grip.attr({
	        width: constants.gripWidth,
	        height: constants.gripHeight,
	        rx: constants.gripRadius,
	        ry: constants.gripRadius,
	    })
	    .call(Color.stroke, sliderOpts.bordercolor)
	    .call(Color.fill, sliderOpts.bgcolor)
	    .style('stroke-width', sliderOpts.borderwidth + 'px');
	}
	
	function drawLabel(item, data, sliderOpts) {
	    var text = Lib.ensureSingle(item, 'text', constants.labelClass, function(s) {
	        s.classed('user-select-none', true)
	            .attr({
	                'text-anchor': 'middle',
	                'data-notex': 1
	            });
	    });
	
	    var tx = data.step.label;
	    var _meta = sliderOpts._gd._fullLayout._meta;
	    if(_meta) tx = Lib.templateString(tx, _meta);
	
	    text.call(Drawing.font, sliderOpts.font)
	        .text(tx)
	        .call(svgTextUtils.convertToTspans, sliderOpts._gd);
	
	    return text;
	}
	
	function drawLabelGroup(sliderGroup, sliderOpts) {
	    var labels = Lib.ensureSingle(sliderGroup, 'g', constants.labelsClass);
	    var dims = sliderOpts._dims;
	
	    var labelItems = labels.selectAll('g.' + constants.labelGroupClass)
	        .data(dims.labelSteps);
	
	    labelItems.enter().append('g')
	        .classed(constants.labelGroupClass, true);
	
	    labelItems.exit().remove();
	
	    labelItems.each(function(d) {
	        var item = d3.select(this);
	
	        item.call(drawLabel, d, sliderOpts);
	
	        Drawing.setTranslate(item,
	            normalizedValueToPosition(sliderOpts, d.fraction),
	            constants.tickOffset +
	                sliderOpts.ticklen +
	                // position is the baseline of the top line of text only, even
	                // if the label spans multiple lines
	                sliderOpts.font.size * LINE_SPACING +
	                constants.labelOffset +
	                dims.currentValueTotalHeight
	        );
	    });
	}
	
	function handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, doTransition) {
	    var quantizedPosition = Math.round(normalizedPosition * (sliderOpts._stepCount - 1));
	    var quantizedIndex = sliderOpts._visibleSteps[quantizedPosition]._index;
	
	    if(quantizedIndex !== sliderOpts.active) {
	        setActive(gd, sliderGroup, sliderOpts, quantizedIndex, true, doTransition);
	    }
	}
	
	function setActive(gd, sliderGroup, sliderOpts, index, doCallback, doTransition) {
	    var previousActive = sliderOpts.active;
	    sliderOpts.active = index;
	
	    // due to templating, it's possible this slider doesn't even exist yet
	    arrayEditor(gd.layout, constants.name, sliderOpts)
	        .applyUpdate('active', index);
	
	    var step = sliderOpts.steps[sliderOpts.active];
	
	    sliderGroup.call(setGripPosition, sliderOpts, doTransition);
	    sliderGroup.call(drawCurrentValue, sliderOpts);
	
	    gd.emit('plotly_sliderchange', {
	        slider: sliderOpts,
	        step: sliderOpts.steps[sliderOpts.active],
	        interaction: doCallback,
	        previousActive: previousActive
	    });
	
	    if(step && step.method && doCallback) {
	        if(sliderGroup._nextMethod) {
	            // If we've already queued up an update, just overwrite it with the most recent:
	            sliderGroup._nextMethod.step = step;
	            sliderGroup._nextMethod.doCallback = doCallback;
	            sliderGroup._nextMethod.doTransition = doTransition;
	        } else {
	            sliderGroup._nextMethod = {step: step, doCallback: doCallback, doTransition: doTransition};
	            sliderGroup._nextMethodRaf = window.requestAnimationFrame(function() {
	                var _step = sliderGroup._nextMethod.step;
	                if(!_step.method) return;
	
	                if(_step.execute) {
	                    Plots.executeAPICommand(gd, _step.method, _step.args);
	                }
	
	                sliderGroup._nextMethod = null;
	                sliderGroup._nextMethodRaf = null;
	            });
	        }
	    }
	}
	
	function attachGripEvents(item, gd, sliderGroup) {
	    var node = sliderGroup.node();
	    var $gd = d3.select(gd);
	
	    // NB: This is *not* the same as sliderOpts itself! These callbacks
	    // are in a closure so this array won't actually be correct if the
	    // steps have changed since this was initialized. The sliderGroup,
	    // however, has not changed since that *is* the slider, so it must
	    // be present to receive mouse events.
	    function getSliderOpts() {
	        return sliderGroup.data()[0];
	    }
	
	    item.on('mousedown', function() {
	        var sliderOpts = getSliderOpts();
	        gd.emit('plotly_sliderstart', {slider: sliderOpts});
	
	        var grip = sliderGroup.select('.' + constants.gripRectClass);
	
	        d3.event.stopPropagation();
	        d3.event.preventDefault();
	        grip.call(Color.fill, sliderOpts.activebgcolor);
	
	        var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
	        handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, true);
	        sliderOpts._dragging = true;
	
	        $gd.on('mousemove', function() {
	            var sliderOpts = getSliderOpts();
	            var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
	            handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, false);
	        });
	
	        $gd.on('mouseup', function() {
	            var sliderOpts = getSliderOpts();
	            sliderOpts._dragging = false;
	            grip.call(Color.fill, sliderOpts.bgcolor);
	            $gd.on('mouseup', null);
	            $gd.on('mousemove', null);
	
	            gd.emit('plotly_sliderend', {
	                slider: sliderOpts,
	                step: sliderOpts.steps[sliderOpts.active]
	            });
	        });
	    });
	}
	
	function drawTicks(sliderGroup, sliderOpts) {
	    var tick = sliderGroup.selectAll('rect.' + constants.tickRectClass)
	        .data(sliderOpts._visibleSteps);
	    var dims = sliderOpts._dims;
	
	    tick.enter().append('rect')
	        .classed(constants.tickRectClass, true);
	
	    tick.exit().remove();
	
	    tick.attr({
	        width: sliderOpts.tickwidth + 'px',
	        'shape-rendering': 'crispEdges'
	    });
	
	    tick.each(function(d, i) {
	        var isMajor = i % dims.labelStride === 0;
	        var item = d3.select(this);
	
	        item
	            .attr({height: isMajor ? sliderOpts.ticklen : sliderOpts.minorticklen})
	            .call(Color.fill, isMajor ? sliderOpts.tickcolor : sliderOpts.tickcolor);
	
	        Drawing.setTranslate(item,
	            normalizedValueToPosition(sliderOpts, i / (sliderOpts._stepCount - 1)) - 0.5 * sliderOpts.tickwidth,
	            (isMajor ? constants.tickOffset : constants.minorTickOffset) + dims.currentValueTotalHeight
	        );
	    });
	}
	
	function computeLabelSteps(sliderOpts) {
	    var dims = sliderOpts._dims;
	    dims.labelSteps = [];
	    var nsteps = sliderOpts._stepCount;
	
	    for(var i = 0; i < nsteps; i += dims.labelStride) {
	        dims.labelSteps.push({
	            fraction: i / (nsteps - 1),
	            step: sliderOpts._visibleSteps[i]
	        });
	    }
	}
	
	function setGripPosition(sliderGroup, sliderOpts, doTransition) {
	    var grip = sliderGroup.select('rect.' + constants.gripRectClass);
	
	    var quantizedIndex = 0;
	    for(var i = 0; i < sliderOpts._stepCount; i++) {
	        if(sliderOpts._visibleSteps[i]._index === sliderOpts.active) {
	            quantizedIndex = i;
	            break;
	        }
	    }
	
	    var x = normalizedValueToPosition(sliderOpts, quantizedIndex / (sliderOpts._stepCount - 1));
	
	    // If this is true, then *this component* is already invoking its own command
	    // and has triggered its own animation.
	    if(sliderOpts._invokingCommand) return;
	
	    var el = grip;
	    if(doTransition && sliderOpts.transition.duration > 0) {
	        el = el.transition()
	            .duration(sliderOpts.transition.duration)
	            .ease(sliderOpts.transition.easing);
	    }
	
	    // Drawing.setTranslate doesn't work here becasue of the transition duck-typing.
	    // It's also not necessary because there are no other transitions to preserve.
	    el.attr('transform', 'translate(' + (x - constants.gripWidth * 0.5) + ',' + (sliderOpts._dims.currentValueTotalHeight) + ')');
	}
	
	// Convert a number from [0-1] to a pixel position relative to the slider group container:
	function normalizedValueToPosition(sliderOpts, normalizedPosition) {
	    var dims = sliderOpts._dims;
	    return dims.inputAreaStart + constants.stepInset +
	        (dims.inputAreaLength - 2 * constants.stepInset) * Math.min(1, Math.max(0, normalizedPosition));
	}
	
	// Convert a position relative to the slider group to a nubmer in [0, 1]
	function positionToNormalizedValue(sliderOpts, position) {
	    var dims = sliderOpts._dims;
	    return Math.min(1, Math.max(0, (position - constants.stepInset - dims.inputAreaStart) / (dims.inputAreaLength - 2 * constants.stepInset - 2 * dims.inputAreaStart)));
	}
	
	function drawTouchRect(sliderGroup, gd, sliderOpts) {
	    var dims = sliderOpts._dims;
	    var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railTouchRectClass, function(s) {
	        s.call(attachGripEvents, gd, sliderGroup, sliderOpts)
	            .style('pointer-events', 'all');
	    });
	
	    rect.attr({
	        width: dims.inputAreaLength,
	        height: Math.max(dims.inputAreaWidth, constants.tickOffset + sliderOpts.ticklen + dims.labelHeight)
	    })
	        .call(Color.fill, sliderOpts.bgcolor)
	        .attr('opacity', 0);
	
	    Drawing.setTranslate(rect, 0, dims.currentValueTotalHeight);
	}
	
	function drawRail(sliderGroup, sliderOpts) {
	    var dims = sliderOpts._dims;
	    var computedLength = dims.inputAreaLength - constants.railInset * 2;
	    var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railRectClass);
	
	    rect.attr({
	        width: computedLength,
	        height: constants.railWidth,
	        rx: constants.railRadius,
	        ry: constants.railRadius,
	        'shape-rendering': 'crispEdges'
	    })
	    .call(Color.stroke, sliderOpts.bordercolor)
	    .call(Color.fill, sliderOpts.bgcolor)
	    .style('stroke-width', sliderOpts.borderwidth + 'px');
	
	    Drawing.setTranslate(rect,
	        constants.railInset,
	        (dims.inputAreaWidth - constants.railWidth) * 0.5 + dims.currentValueTotalHeight
	    );
	}
	
	},{"../../constants/alignment":685,"../../lib":716,"../../lib/svg_text_utils":740,"../../plot_api/plot_template":754,"../../plots/plots":825,"../color":591,"../drawing":612,"./constants":674,"d3":164}],677:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var constants = _dereq_('./constants');
	
	module.exports = {
	    moduleType: 'component',
	    name: constants.name,
	
	    layoutAttributes: _dereq_('./attributes'),
	    supplyLayoutDefaults: _dereq_('./defaults'),
	
	    draw: _dereq_('./draw')
	};
	
	},{"./attributes":673,"./constants":674,"./defaults":675,"./draw":676}],678:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Plots = _dereq_('../../plots/plots');
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../drawing');
	var Color = _dereq_('../color');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var interactConstants = _dereq_('../../constants/interactions');
	
	var OPPOSITE_SIDE = _dereq_('../../constants/alignment').OPPOSITE_SIDE;
	var numStripRE = / [XY][0-9]* /;
	
	/**
	 * Titles - (re)draw titles on the axes and plot:
	 * @param {DOM element} gd - the graphDiv
	 * @param {string} titleClass - the css class of this title
	 * @param {object} options - how and what to draw
	 *      propContainer - the layout object containing `title` and `titlefont`
	 *          attributes that apply to this title
	 *      propName - the full name of the title property (for Plotly.relayout)
	 *      [traceIndex] - include only if this property applies to one trace
	 *          (such as a colorbar title) - then editing pipes to Plotly.restyle
	 *          instead of Plotly.relayout
	 *      placeholder - placeholder text for an empty editable title
	 *      [avoid] {object} - include if this title should move to avoid other elements
	 *          selection - d3 selection of elements to avoid
	 *          side - which direction to move if there is a conflict
	 *          [offsetLeft] - if these elements are subject to a translation
	 *              wrt the title element
	 *          [offsetTop]
	 *      attributes {object} - position and alignment attributes
	 *          x - pixels
	 *          y - pixels
	 *          text-anchor - start|middle|end
	 *      transform {object} - how to transform the title after positioning
	 *          rotate - degrees
	 *          offset - shift up/down in the rotated frame (unused?)
	 *      containerGroup - if an svg <g> element already exists to hold this
	 *          title, include here. Otherwise it will go in fullLayout._infolayer
	 *      _meta {object (optional} - meta key-value to for title with
	 *          Lib.templateString, default to fullLayout._meta, if not provided
	 *
	 *  @return {selection} d3 selection of title container group
	 */
	function draw(gd, titleClass, options) {
	    var cont = options.propContainer;
	    var prop = options.propName;
	    var placeholder = options.placeholder;
	    var traceIndex = options.traceIndex;
	    var avoid = options.avoid || {};
	    var attributes = options.attributes;
	    var transform = options.transform;
	    var group = options.containerGroup;
	
	    var fullLayout = gd._fullLayout;
	
	    var opacity = 1;
	    var isplaceholder = false;
	    var title = cont.title;
	    var txt = (title && title.text ? title.text : '').trim();
	
	    var font = title && title.font ? title.font : {};
	    var fontFamily = font.family;
	    var fontSize = font.size;
	    var fontColor = font.color;
	
	    // only make this title editable if we positively identify its property
	    // as one that has editing enabled.
	    var editAttr;
	    if(prop === 'title.text') editAttr = 'titleText';
	    else if(prop.indexOf('axis') !== -1) editAttr = 'axisTitleText';
	    else if(prop.indexOf('colorbar' !== -1)) editAttr = 'colorbarTitleText';
	    var editable = gd._context.edits[editAttr];
	
	    if(txt === '') opacity = 0;
	    // look for placeholder text while stripping out numbers from eg X2, Y3
	    // this is just for backward compatibility with the old version that had
	    // "Click to enter X2 title" and may have gotten saved in some old plots,
	    // we don't want this to show up when these are displayed.
	    else if(txt.replace(numStripRE, ' % ') === placeholder.replace(numStripRE, ' % ')) {
	        opacity = 0.2;
	        isplaceholder = true;
	        if(!editable) txt = '';
	    }
	
	    if(options._meta) {
	        txt = Lib.templateString(txt, options._meta);
	    } else if(fullLayout._meta) {
	        txt = Lib.templateString(txt, fullLayout._meta);
	    }
	
	    var elShouldExist = txt || editable;
	
	    if(!group) {
	        group = Lib.ensureSingle(fullLayout._infolayer, 'g', 'g-' + titleClass);
	    }
	
	    var el = group.selectAll('text')
	        .data(elShouldExist ? [0] : []);
	    el.enter().append('text');
	    el.text(txt)
	        // this is hacky, but convertToTspans uses the class
	        // to determine whether to rotate mathJax...
	        // so we need to clear out any old class and put the
	        // correct one (only relevant for colorbars, at least
	        // for now) - ie don't use .classed
	        .attr('class', titleClass);
	    el.exit().remove();
	
	    if(!elShouldExist) return group;
	
	    function titleLayout(titleEl) {
	        Lib.syncOrAsync([drawTitle, scootTitle], titleEl);
	    }
	
	    function drawTitle(titleEl) {
	        var transformVal;
	
	        if(transform) {
	            transformVal = '';
	            if(transform.rotate) {
	                transformVal += 'rotate(' + [transform.rotate, attributes.x, attributes.y] + ')';
	            }
	            if(transform.offset) {
	                transformVal += 'translate(0, ' + transform.offset + ')';
	            }
	        } else {
	            transformVal = null;
	        }
	
	        titleEl.attr('transform', transformVal);
	
	        titleEl.style({
	            'font-family': fontFamily,
	            'font-size': d3.round(fontSize, 2) + 'px',
	            fill: Color.rgb(fontColor),
	            opacity: opacity * Color.opacity(fontColor),
	            'font-weight': Plots.fontWeight
	        })
	        .attr(attributes)
	        .call(svgTextUtils.convertToTspans, gd);
	
	        return Plots.previousPromises(gd);
	    }
	
	    function scootTitle(titleElIn) {
	        var titleGroup = d3.select(titleElIn.node().parentNode);
	
	        if(avoid && avoid.selection && avoid.side && txt) {
	            titleGroup.attr('transform', null);
	
	            // move toward avoid.side (= left, right, top, bottom) if needed
	            // can include pad (pixels, default 2)
	            var backside = OPPOSITE_SIDE[avoid.side];
	            var shiftSign = (avoid.side === 'left' || avoid.side === 'top') ? -1 : 1;
	            var pad = isNumeric(avoid.pad) ? avoid.pad : 2;
	
	            var titlebb = Drawing.bBox(titleGroup.node());
	            var paperbb = {
	                left: 0,
	                top: 0,
	                right: fullLayout.width,
	                bottom: fullLayout.height
	            };
	
	            var maxshift = avoid.maxShift ||
	                shiftSign * (paperbb[avoid.side] - titlebb[avoid.side]);
	            var shift = 0;
	
	            // Prevent the title going off the paper
	            if(maxshift < 0) {
	                shift = maxshift;
	            } else {
	                // so we don't have to offset each avoided element,
	                // give the title the opposite offset
	                var offsetLeft = avoid.offsetLeft || 0;
	                var offsetTop = avoid.offsetTop || 0;
	                titlebb.left -= offsetLeft;
	                titlebb.right -= offsetLeft;
	                titlebb.top -= offsetTop;
	                titlebb.bottom -= offsetTop;
	
	                // iterate over a set of elements (avoid.selection)
	                // to avoid collisions with
	                avoid.selection.each(function() {
	                    var avoidbb = Drawing.bBox(this);
	
	                    if(Lib.bBoxIntersect(titlebb, avoidbb, pad)) {
	                        shift = Math.max(shift, shiftSign * (
	                            avoidbb[avoid.side] - titlebb[backside]) + pad);
	                    }
	                });
	                shift = Math.min(maxshift, shift);
	            }
	
	            if(shift > 0 || maxshift < 0) {
	                var shiftTemplate = {
	                    left: [-shift, 0],
	                    right: [shift, 0],
	                    top: [0, -shift],
	                    bottom: [0, shift]
	                }[avoid.side];
	                titleGroup.attr('transform', 'translate(' + shiftTemplate + ')');
	            }
	        }
	    }
	
	    el.call(titleLayout);
	
	    function setPlaceholder() {
	        opacity = 0;
	        isplaceholder = true;
	        el.text(placeholder)
	            .on('mouseover.opacity', function() {
	                d3.select(this).transition()
	                    .duration(interactConstants.SHOW_PLACEHOLDER).style('opacity', 1);
	            })
	            .on('mouseout.opacity', function() {
	                d3.select(this).transition()
	                    .duration(interactConstants.HIDE_PLACEHOLDER).style('opacity', 0);
	            });
	    }
	
	    if(editable) {
	        if(!txt) setPlaceholder();
	        else el.on('.opacity', null);
	
	        el.call(svgTextUtils.makeEditable, {gd: gd})
	            .on('edit', function(text) {
	                if(traceIndex !== undefined) {
	                    Registry.call('_guiRestyle', gd, prop, text, traceIndex);
	                } else {
	                    Registry.call('_guiRelayout', gd, prop, text);
	                }
	            })
	            .on('cancel', function() {
	                this.text(this.attr('data-unformatted'))
	                    .call(titleLayout);
	            })
	            .on('input', function(d) {
	                this.text(d || ' ')
	                    .call(svgTextUtils.positionText, attributes.x, attributes.y);
	            });
	    }
	    el.classed('js-placeholder', isplaceholder);
	
	    return group;
	}
	
	module.exports = {
	    draw: draw
	};
	
	},{"../../constants/alignment":685,"../../constants/interactions":691,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/plots":825,"../../registry":845,"../color":591,"../drawing":612,"d3":164,"fast-isnumeric":227}],679:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../color/attributes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var padAttrs = _dereq_('../../plots/pad_attributes');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	var buttonsAttrs = templatedArray('button', {
	    visible: {
	        valType: 'boolean',
	        
	        
	    },
	    method: {
	        valType: 'enumerated',
	        values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
	        dflt: 'restyle',
	        
	        
	    },
	    args: {
	        valType: 'info_array',
	        
	        freeLength: true,
	        items: [
	            {valType: 'any'},
	            {valType: 'any'},
	            {valType: 'any'}
	        ],
	        
	    },
	    args2: {
	        valType: 'info_array',
	        
	        freeLength: true,
	        items: [
	            {valType: 'any'},
	            {valType: 'any'},
	            {valType: 'any'}
	        ],
	        
	    },
	    label: {
	        valType: 'string',
	        
	        dflt: '',
	        
	    },
	    execute: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    }
	});
	
	module.exports = overrideAll(templatedArray('updatemenu', {
	    _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
	
	    visible: {
	        valType: 'boolean',
	        
	        
	    },
	
	    type: {
	        valType: 'enumerated',
	        values: ['dropdown', 'buttons'],
	        dflt: 'dropdown',
	        
	        
	    },
	
	    direction: {
	        valType: 'enumerated',
	        values: ['left', 'right', 'up', 'down'],
	        dflt: 'down',
	        
	        
	    },
	
	    active: {
	        valType: 'integer',
	        
	        min: -1,
	        dflt: 0,
	        
	    },
	
	    showactive: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	
	    buttons: buttonsAttrs,
	
	    x: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        dflt: -0.05,
	        
	        
	    },
	    xanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'left', 'center', 'right'],
	        dflt: 'right',
	        
	        
	    },
	    y: {
	        valType: 'number',
	        min: -2,
	        max: 3,
	        dflt: 1,
	        
	        
	    },
	    yanchor: {
	        valType: 'enumerated',
	        values: ['auto', 'top', 'middle', 'bottom'],
	        dflt: 'top',
	        
	        
	    },
	
	    pad: extendFlat(padAttrs({editType: 'arraydraw'}), {
	        
	    }),
	
	    font: fontAttrs({
	        
	    }),
	
	    bgcolor: {
	        valType: 'color',
	        
	        
	    },
	    bordercolor: {
	        valType: 'color',
	        dflt: colorAttrs.borderLine,
	        
	        
	    },
	    borderwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'arraydraw',
	        
	    }
	}), 'arraydraw', 'from-root');
	
	},{"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../../plots/font_attributes":790,"../../plots/pad_attributes":824,"../color/attributes":590}],680:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = {
	
	    // layout attribute name
	    name: 'updatemenus',
	
	    // class names
	    containerClassName: 'updatemenu-container',
	    headerGroupClassName: 'updatemenu-header-group',
	    headerClassName: 'updatemenu-header',
	    headerArrowClassName: 'updatemenu-header-arrow',
	    dropdownButtonGroupClassName: 'updatemenu-dropdown-button-group',
	    dropdownButtonClassName: 'updatemenu-dropdown-button',
	    buttonClassName: 'updatemenu-button',
	    itemRectClassName: 'updatemenu-item-rect',
	    itemTextClassName: 'updatemenu-item-text',
	
	    // DOM attribute name in button group keeping track
	    // of active update menu
	    menuIndexAttrName: 'updatemenu-active-index',
	
	    // id root pass to Plots.autoMargin
	    autoMarginIdRoot: 'updatemenu-',
	
	    // options when 'active: -1'
	    blankHeaderOpts: { label: '  ' },
	
	    // min item width / height
	    minWidth: 30,
	    minHeight: 30,
	
	    // padding around item text
	    textPadX: 24,
	    arrowPadX: 16,
	
	    // item rect radii
	    rx: 2,
	    ry: 2,
	
	    // item  text x offset off left edge
	    textOffsetX: 12,
	
	    // item  text y offset (w.r.t. middle)
	    textOffsetY: 3,
	
	    // arrow offset off right edge
	    arrowOffsetX: 4,
	
	    // gap between header and buttons
	    gapButtonHeader: 5,
	
	    // gap between between buttons
	    gapButton: 2,
	
	    // color given to active buttons
	    activeColor: '#F4FAFF',
	
	    // color given to hovered buttons
	    hoverColor: '#F4FAFF',
	
	    // symbol for menu open arrow
	    arrowSymbol: {
	        left: '◄',
	        right: '►',
	        up: '▲',
	        down: '▼'
	    }
	};
	
	},{}],681:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('./constants');
	
	var name = constants.name;
	var buttonAttrs = attributes.buttons;
	
	
	module.exports = function updateMenusDefaults(layoutIn, layoutOut) {
	    var opts = {
	        name: name,
	        handleItemDefaults: menuDefaults
	    };
	
	    handleArrayContainerDefaults(layoutIn, layoutOut, opts);
	};
	
	function menuDefaults(menuIn, menuOut, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(menuIn, menuOut, attributes, attr, dflt);
	    }
	
	    var buttons = handleArrayContainerDefaults(menuIn, menuOut, {
	        name: 'buttons',
	        handleItemDefaults: buttonDefaults
	    });
	
	    var visible = coerce('visible', buttons.length > 0);
	    if(!visible) return;
	
	    coerce('active');
	    coerce('direction');
	    coerce('type');
	    coerce('showactive');
	
	    coerce('x');
	    coerce('y');
	    Lib.noneOrAll(menuIn, menuOut, ['x', 'y']);
	
	    coerce('xanchor');
	    coerce('yanchor');
	
	    coerce('pad.t');
	    coerce('pad.r');
	    coerce('pad.b');
	    coerce('pad.l');
	
	    Lib.coerceFont(coerce, 'font', layoutOut.font);
	
	    coerce('bgcolor', layoutOut.paper_bgcolor);
	    coerce('bordercolor');
	    coerce('borderwidth');
	}
	
	function buttonDefaults(buttonIn, buttonOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(buttonIn, buttonOut, buttonAttrs, attr, dflt);
	    }
	
	    var visible = coerce('visible',
	        (buttonIn.method === 'skip' || Array.isArray(buttonIn.args)));
	    if(visible) {
	        coerce('method');
	        coerce('args');
	        coerce('args2');
	        coerce('label');
	        coerce('execute');
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"./attributes":679,"./constants":680}],682:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Plots = _dereq_('../../plots/plots');
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
	
	var LINE_SPACING = _dereq_('../../constants/alignment').LINE_SPACING;
	
	var constants = _dereq_('./constants');
	var ScrollBox = _dereq_('./scrollbox');
	
	module.exports = function draw(gd) {
	    var fullLayout = gd._fullLayout;
	    var menuData = Lib.filterVisible(fullLayout[constants.name]);
	
	    /* Update menu data is bound to the header-group.
	     * The items in the header group are always present.
	     *
	     * Upon clicking on a header its corresponding button
	     * data is bound to the button-group.
	     *
	     * We draw all headers in one group before all buttons
	     * so that the buttons *always* appear above the headers.
	     *
	     * Note that only one set of buttons are visible at once.
	     *
	     * <g container />
	     *
	     *     <g header-group />
	     *         <g item header />
	     *         <text item header-arrow />
	     *     <g header-group />
	     *         <g item header />
	     *         <text item header-arrow />
	     *     ...
	     *
	     *     <g button-group />
	     *         <g item button />
	     *         <g item button />
	     *         ...
	     */
	
	    function clearAutoMargin(menuOpts) {
	        Plots.autoMargin(gd, autoMarginId(menuOpts));
	    }
	
	    // draw update menu container
	    var menus = fullLayout._menulayer
	        .selectAll('g.' + constants.containerClassName)
	        .data(menuData.length > 0 ? [0] : []);
	
	    menus.enter().append('g')
	        .classed(constants.containerClassName, true)
	        .style('cursor', 'pointer');
	
	    menus.exit().each(function() {
	        // Most components don't need to explicitly remove autoMargin, because
	        // marginPushers does this - but updatemenu updates don't go through
	        // a full replot so we need to explicitly remove it.
	        // This is for removing *all* updatemenus, removing individuals is
	        // handled below, in headerGroups.exit
	        d3.select(this).selectAll('g.' + constants.headerGroupClassName)
	            .each(clearAutoMargin);
	    }).remove();
	
	    // return early if no update menus are visible
	    if(menuData.length === 0) return;
	
	    // join header group
	    var headerGroups = menus.selectAll('g.' + constants.headerGroupClassName)
	        .data(menuData, keyFunction);
	
	    headerGroups.enter().append('g')
	        .classed(constants.headerGroupClassName, true);
	
	    // draw dropdown button container
	    var gButton = Lib.ensureSingle(menus, 'g', constants.dropdownButtonGroupClassName, function(s) {
	        s.style('pointer-events', 'all');
	    });
	
	    // find dimensions before plotting anything (this mutates menuOpts)
	    for(var i = 0; i < menuData.length; i++) {
	        var menuOpts = menuData[i];
	        findDimensions(gd, menuOpts);
	    }
	
	    // setup scrollbox
	    var scrollBoxId = 'updatemenus' + fullLayout._uid;
	    var scrollBox = new ScrollBox(gd, gButton, scrollBoxId);
	
	    // remove exiting header, remove dropped buttons and reset margins
	    if(headerGroups.enter().size()) {
	        // make sure gButton is on top of all headers
	        gButton.node().parentNode.appendChild(gButton.node());
	        gButton.call(removeAllButtons);
	    }
	
	    headerGroups.exit().each(function(menuOpts) {
	        gButton.call(removeAllButtons);
	        clearAutoMargin(menuOpts);
	    }).remove();
	
	    // draw headers!
	    headerGroups.each(function(menuOpts) {
	        var gHeader = d3.select(this);
	
	        var _gButton = menuOpts.type === 'dropdown' ? gButton : null;
	
	        Plots.manageCommandObserver(gd, menuOpts, menuOpts.buttons, function(data) {
	            setActive(gd, menuOpts, menuOpts.buttons[data.index], gHeader, _gButton, scrollBox, data.index, true);
	        });
	
	        if(menuOpts.type === 'dropdown') {
	            drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
	
	            // if this menu is active, update the dropdown container
	            if(isActive(gButton, menuOpts)) {
	                drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
	            }
	        } else {
	            drawButtons(gd, gHeader, null, null, menuOpts);
	        }
	    });
	};
	
	// Note that '_index' is set at the default step,
	// it corresponds to the menu index in the user layout update menu container.
	// Because a menu can be set invisible,
	// this is a more 'consistent' field than the index in the menuData.
	function keyFunction(menuOpts) {
	    return menuOpts._index;
	}
	
	function isFolded(gButton) {
	    return +gButton.attr(constants.menuIndexAttrName) === -1;
	}
	
	function isActive(gButton, menuOpts) {
	    return +gButton.attr(constants.menuIndexAttrName) === menuOpts._index;
	}
	
	function setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex, isSilentUpdate) {
	    // update 'active' attribute in menuOpts
	    menuOpts.active = buttonIndex;
	
	    // due to templating, it's possible this slider doesn't even exist yet
	    arrayEditor(gd.layout, constants.name, menuOpts)
	        .applyUpdate('active', buttonIndex);
	
	    if(menuOpts.type === 'buttons') {
	        drawButtons(gd, gHeader, null, null, menuOpts);
	    } else if(menuOpts.type === 'dropdown') {
	        // fold up buttons and redraw header
	        gButton.attr(constants.menuIndexAttrName, '-1');
	
	        drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
	
	        if(!isSilentUpdate) {
	            drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
	        }
	    }
	}
	
	function drawHeader(gd, gHeader, gButton, scrollBox, menuOpts) {
	    var header = Lib.ensureSingle(gHeader, 'g', constants.headerClassName, function(s) {
	        s.style('pointer-events', 'all');
	    });
	
	    var dims = menuOpts._dims;
	    var active = menuOpts.active;
	    var headerOpts = menuOpts.buttons[active] || constants.blankHeaderOpts;
	    var posOpts = { y: menuOpts.pad.t, yPad: 0, x: menuOpts.pad.l, xPad: 0, index: 0 };
	    var positionOverrides = {
	        width: dims.headerWidth,
	        height: dims.headerHeight
	    };
	
	    header
	        .call(drawItem, menuOpts, headerOpts, gd)
	        .call(setItemPosition, menuOpts, posOpts, positionOverrides);
	
	    // draw drop arrow at the right edge
	    var arrow = Lib.ensureSingle(gHeader, 'text', constants.headerArrowClassName, function(s) {
	        s.classed('user-select-none', true)
	            .attr('text-anchor', 'end')
	            .call(Drawing.font, menuOpts.font)
	            .text(constants.arrowSymbol[menuOpts.direction]);
	    });
	
	    arrow.attr({
	        x: dims.headerWidth - constants.arrowOffsetX + menuOpts.pad.l,
	        y: dims.headerHeight / 2 + constants.textOffsetY + menuOpts.pad.t
	    });
	
	    header.on('click', function() {
	        gButton.call(removeAllButtons,
	            String(isActive(gButton, menuOpts) ? -1 : menuOpts._index)
	        );
	
	        drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
	    });
	
	    header.on('mouseover', function() {
	        header.call(styleOnMouseOver);
	    });
	
	    header.on('mouseout', function() {
	        header.call(styleOnMouseOut, menuOpts);
	    });
	
	    // translate header group
	    Drawing.setTranslate(gHeader, dims.lx, dims.ly);
	}
	
	function drawButtons(gd, gHeader, gButton, scrollBox, menuOpts) {
	    // If this is a set of buttons, set pointer events = all since we play
	    // some minor games with which container is which in order to simplify
	    // the drawing of *either* buttons or menus
	    if(!gButton) {
	        gButton = gHeader;
	        gButton.attr('pointer-events', 'all');
	    }
	
	    var buttonData = (!isFolded(gButton) || menuOpts.type === 'buttons') ?
	        menuOpts.buttons :
	        [];
	
	    var klass = menuOpts.type === 'dropdown' ? constants.dropdownButtonClassName : constants.buttonClassName;
	
	    var buttons = gButton.selectAll('g.' + klass)
	        .data(Lib.filterVisible(buttonData));
	
	    var enter = buttons.enter().append('g')
	        .classed(klass, true);
	
	    var exit = buttons.exit();
	
	    if(menuOpts.type === 'dropdown') {
	        enter.attr('opacity', '0')
	            .transition()
	            .attr('opacity', '1');
	
	        exit.transition()
	            .attr('opacity', '0')
	            .remove();
	    } else {
	        exit.remove();
	    }
	
	    var x0 = 0;
	    var y0 = 0;
	    var dims = menuOpts._dims;
	
	    var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
	
	    if(menuOpts.type === 'dropdown') {
	        if(isVertical) {
	            y0 = dims.headerHeight + constants.gapButtonHeader;
	        } else {
	            x0 = dims.headerWidth + constants.gapButtonHeader;
	        }
	    }
	
	    if(menuOpts.type === 'dropdown' && menuOpts.direction === 'up') {
	        y0 = -constants.gapButtonHeader + constants.gapButton - dims.openHeight;
	    }
	
	    if(menuOpts.type === 'dropdown' && menuOpts.direction === 'left') {
	        x0 = -constants.gapButtonHeader + constants.gapButton - dims.openWidth;
	    }
	
	    var posOpts = {
	        x: dims.lx + x0 + menuOpts.pad.l,
	        y: dims.ly + y0 + menuOpts.pad.t,
	        yPad: constants.gapButton,
	        xPad: constants.gapButton,
	        index: 0,
	    };
	
	    var scrollBoxPosition = {
	        l: posOpts.x + menuOpts.borderwidth,
	        t: posOpts.y + menuOpts.borderwidth
	    };
	
	    buttons.each(function(buttonOpts, buttonIndex) {
	        var button = d3.select(this);
	
	        button
	            .call(drawItem, menuOpts, buttonOpts, gd)
	            .call(setItemPosition, menuOpts, posOpts);
	
	        button.on('click', function() {
	            // skip `dragend` events
	            if(d3.event.defaultPrevented) return;
	
	            if(buttonOpts.execute) {
	                if(buttonOpts.args2 && menuOpts.active === buttonIndex) {
	                    setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, -1);
	                    Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args2);
	                } else {
	                    setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex);
	                    Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args);
	                }
	            }
	
	            gd.emit('plotly_buttonclicked', {menu: menuOpts, button: buttonOpts, active: menuOpts.active});
	        });
	
	        button.on('mouseover', function() {
	            button.call(styleOnMouseOver);
	        });
	
	        button.on('mouseout', function() {
	            button.call(styleOnMouseOut, menuOpts);
	            buttons.call(styleButtons, menuOpts);
	        });
	    });
	
	    buttons.call(styleButtons, menuOpts);
	
	    if(isVertical) {
	        scrollBoxPosition.w = Math.max(dims.openWidth, dims.headerWidth);
	        scrollBoxPosition.h = posOpts.y - scrollBoxPosition.t;
	    } else {
	        scrollBoxPosition.w = posOpts.x - scrollBoxPosition.l;
	        scrollBoxPosition.h = Math.max(dims.openHeight, dims.headerHeight);
	    }
	
	    scrollBoxPosition.direction = menuOpts.direction;
	
	    if(scrollBox) {
	        if(buttons.size()) {
	            drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, scrollBoxPosition);
	        } else {
	            hideScrollBox(scrollBox);
	        }
	    }
	}
	
	function drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, position) {
	    // enable the scrollbox
	    var direction = menuOpts.direction;
	    var isVertical = (direction === 'up' || direction === 'down');
	    var dims = menuOpts._dims;
	
	    var active = menuOpts.active;
	    var translateX, translateY;
	    var i;
	    if(isVertical) {
	        translateY = 0;
	        for(i = 0; i < active; i++) {
	            translateY += dims.heights[i] + constants.gapButton;
	        }
	    } else {
	        translateX = 0;
	        for(i = 0; i < active; i++) {
	            translateX += dims.widths[i] + constants.gapButton;
	        }
	    }
	
	    scrollBox.enable(position, translateX, translateY);
	
	    if(scrollBox.hbar) {
	        scrollBox.hbar
	            .attr('opacity', '0')
	            .transition()
	            .attr('opacity', '1');
	    }
	
	    if(scrollBox.vbar) {
	        scrollBox.vbar
	            .attr('opacity', '0')
	            .transition()
	            .attr('opacity', '1');
	    }
	}
	
	function hideScrollBox(scrollBox) {
	    var hasHBar = !!scrollBox.hbar;
	    var hasVBar = !!scrollBox.vbar;
	
	    if(hasHBar) {
	        scrollBox.hbar
	            .transition()
	            .attr('opacity', '0')
	            .each('end', function() {
	                hasHBar = false;
	                if(!hasVBar) scrollBox.disable();
	            });
	    }
	
	    if(hasVBar) {
	        scrollBox.vbar
	            .transition()
	            .attr('opacity', '0')
	            .each('end', function() {
	                hasVBar = false;
	                if(!hasHBar) scrollBox.disable();
	            });
	    }
	}
	
	function drawItem(item, menuOpts, itemOpts, gd) {
	    item.call(drawItemRect, menuOpts)
	        .call(drawItemText, menuOpts, itemOpts, gd);
	}
	
	function drawItemRect(item, menuOpts) {
	    var rect = Lib.ensureSingle(item, 'rect', constants.itemRectClassName, function(s) {
	        s.attr({
	            rx: constants.rx,
	            ry: constants.ry,
	            'shape-rendering': 'crispEdges'
	        });
	    });
	
	    rect.call(Color.stroke, menuOpts.bordercolor)
	        .call(Color.fill, menuOpts.bgcolor)
	        .style('stroke-width', menuOpts.borderwidth + 'px');
	}
	
	function drawItemText(item, menuOpts, itemOpts, gd) {
	    var text = Lib.ensureSingle(item, 'text', constants.itemTextClassName, function(s) {
	        s.classed('user-select-none', true)
	            .attr({
	                'text-anchor': 'start',
	                'data-notex': 1
	            });
	    });
	
	    var tx = itemOpts.label;
	    var _meta = gd._fullLayout._meta;
	    if(_meta) tx = Lib.templateString(tx, _meta);
	
	    text.call(Drawing.font, menuOpts.font)
	        .text(tx)
	        .call(svgTextUtils.convertToTspans, gd);
	}
	
	function styleButtons(buttons, menuOpts) {
	    var active = menuOpts.active;
	
	    buttons.each(function(buttonOpts, i) {
	        var button = d3.select(this);
	
	        if(i === active && menuOpts.showactive) {
	            button.select('rect.' + constants.itemRectClassName)
	                .call(Color.fill, constants.activeColor);
	        }
	    });
	}
	
	function styleOnMouseOver(item) {
	    item.select('rect.' + constants.itemRectClassName)
	        .call(Color.fill, constants.hoverColor);
	}
	
	function styleOnMouseOut(item, menuOpts) {
	    item.select('rect.' + constants.itemRectClassName)
	        .call(Color.fill, menuOpts.bgcolor);
	}
	
	// find item dimensions (this mutates menuOpts)
	function findDimensions(gd, menuOpts) {
	    var dims = menuOpts._dims = {
	        width1: 0,
	        height1: 0,
	        heights: [],
	        widths: [],
	        totalWidth: 0,
	        totalHeight: 0,
	        openWidth: 0,
	        openHeight: 0,
	        lx: 0,
	        ly: 0
	    };
	
	    var fakeButtons = Drawing.tester.selectAll('g.' + constants.dropdownButtonClassName)
	        .data(Lib.filterVisible(menuOpts.buttons));
	
	    fakeButtons.enter().append('g')
	        .classed(constants.dropdownButtonClassName, true);
	
	    var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
	
	    // loop over fake buttons to find width / height
	    fakeButtons.each(function(buttonOpts, i) {
	        var button = d3.select(this);
	
	        button.call(drawItem, menuOpts, buttonOpts, gd);
	
	        var text = button.select('.' + constants.itemTextClassName);
	
	        // width is given by max width of all buttons
	        var tWidth = text.node() && Drawing.bBox(text.node()).width;
	        var wEff = Math.max(tWidth + constants.textPadX, constants.minWidth);
	
	        // height is determined by item text
	        var tHeight = menuOpts.font.size * LINE_SPACING;
	        var tLines = svgTextUtils.lineCount(text);
	        var hEff = Math.max(tHeight * tLines, constants.minHeight) + constants.textOffsetY;
	
	        hEff = Math.ceil(hEff);
	        wEff = Math.ceil(wEff);
	
	        // Store per-item sizes since a row of horizontal buttons, for example,
	        // don't all need to be the same width:
	        dims.widths[i] = wEff;
	        dims.heights[i] = hEff;
	
	        // Height and width of individual element:
	        dims.height1 = Math.max(dims.height1, hEff);
	        dims.width1 = Math.max(dims.width1, wEff);
	
	        if(isVertical) {
	            dims.totalWidth = Math.max(dims.totalWidth, wEff);
	            dims.openWidth = dims.totalWidth;
	            dims.totalHeight += hEff + constants.gapButton;
	            dims.openHeight += hEff + constants.gapButton;
	        } else {
	            dims.totalWidth += wEff + constants.gapButton;
	            dims.openWidth += wEff + constants.gapButton;
	            dims.totalHeight = Math.max(dims.totalHeight, hEff);
	            dims.openHeight = dims.totalHeight;
	        }
	    });
	
	    if(isVertical) {
	        dims.totalHeight -= constants.gapButton;
	    } else {
	        dims.totalWidth -= constants.gapButton;
	    }
	
	
	    dims.headerWidth = dims.width1 + constants.arrowPadX;
	    dims.headerHeight = dims.height1;
	
	    if(menuOpts.type === 'dropdown') {
	        if(isVertical) {
	            dims.width1 += constants.arrowPadX;
	            dims.totalHeight = dims.height1;
	        } else {
	            dims.totalWidth = dims.width1;
	        }
	        dims.totalWidth += constants.arrowPadX;
	    }
	
	    fakeButtons.remove();
	
	    var paddedWidth = dims.totalWidth + menuOpts.pad.l + menuOpts.pad.r;
	    var paddedHeight = dims.totalHeight + menuOpts.pad.t + menuOpts.pad.b;
	
	    var graphSize = gd._fullLayout._size;
	    dims.lx = graphSize.l + graphSize.w * menuOpts.x;
	    dims.ly = graphSize.t + graphSize.h * (1 - menuOpts.y);
	
	    var xanchor = 'left';
	    if(Lib.isRightAnchor(menuOpts)) {
	        dims.lx -= paddedWidth;
	        xanchor = 'right';
	    }
	    if(Lib.isCenterAnchor(menuOpts)) {
	        dims.lx -= paddedWidth / 2;
	        xanchor = 'center';
	    }
	
	    var yanchor = 'top';
	    if(Lib.isBottomAnchor(menuOpts)) {
	        dims.ly -= paddedHeight;
	        yanchor = 'bottom';
	    }
	    if(Lib.isMiddleAnchor(menuOpts)) {
	        dims.ly -= paddedHeight / 2;
	        yanchor = 'middle';
	    }
	
	    dims.totalWidth = Math.ceil(dims.totalWidth);
	    dims.totalHeight = Math.ceil(dims.totalHeight);
	    dims.lx = Math.round(dims.lx);
	    dims.ly = Math.round(dims.ly);
	
	    Plots.autoMargin(gd, autoMarginId(menuOpts), {
	        x: menuOpts.x,
	        y: menuOpts.y,
	        l: paddedWidth * ({right: 1, center: 0.5}[xanchor] || 0),
	        r: paddedWidth * ({left: 1, center: 0.5}[xanchor] || 0),
	        b: paddedHeight * ({top: 1, middle: 0.5}[yanchor] || 0),
	        t: paddedHeight * ({bottom: 1, middle: 0.5}[yanchor] || 0)
	    });
	}
	
	function autoMarginId(menuOpts) {
	    return constants.autoMarginIdRoot + menuOpts._index;
	}
	
	// set item positions (mutates posOpts)
	function setItemPosition(item, menuOpts, posOpts, overrideOpts) {
	    overrideOpts = overrideOpts || {};
	    var rect = item.select('.' + constants.itemRectClassName);
	    var text = item.select('.' + constants.itemTextClassName);
	    var borderWidth = menuOpts.borderwidth;
	    var index = posOpts.index;
	    var dims = menuOpts._dims;
	
	    Drawing.setTranslate(item, borderWidth + posOpts.x, borderWidth + posOpts.y);
	
	    var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
	    var finalHeight = overrideOpts.height || (isVertical ? dims.heights[index] : dims.height1);
	
	    rect.attr({
	        x: 0,
	        y: 0,
	        width: overrideOpts.width || (isVertical ? dims.width1 : dims.widths[index]),
	        height: finalHeight
	    });
	
	    var tHeight = menuOpts.font.size * LINE_SPACING;
	    var tLines = svgTextUtils.lineCount(text);
	    var spanOffset = ((tLines - 1) * tHeight / 2);
	
	    svgTextUtils.positionText(text, constants.textOffsetX,
	        finalHeight / 2 - spanOffset + constants.textOffsetY);
	
	    if(isVertical) {
	        posOpts.y += dims.heights[index] + posOpts.yPad;
	    } else {
	        posOpts.x += dims.widths[index] + posOpts.xPad;
	    }
	
	    posOpts.index++;
	}
	
	function removeAllButtons(gButton, newMenuIndexAttr) {
	    gButton
	        .attr(constants.menuIndexAttrName, newMenuIndexAttr || '-1')
	        .selectAll('g.' + constants.dropdownButtonClassName).remove();
	}
	
	},{"../../constants/alignment":685,"../../lib":716,"../../lib/svg_text_utils":740,"../../plot_api/plot_template":754,"../../plots/plots":825,"../color":591,"../drawing":612,"./constants":680,"./scrollbox":684,"d3":164}],683:[function(_dereq_,module,exports){
	arguments[4][677][0].apply(exports,arguments)
	},{"./attributes":679,"./constants":680,"./defaults":681,"./draw":682,"dup":677}],684:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = ScrollBox;
	
	var d3 = _dereq_('d3');
	
	var Color = _dereq_('../color');
	var Drawing = _dereq_('../drawing');
	
	var Lib = _dereq_('../../lib');
	
	/**
	 * Helper class to setup a scroll box
	 *
	 * @class
	 * @param           gd          Plotly's graph div
	 * @param           container   Container to be scroll-boxed (as a D3 selection)
	 * @param {string}  id          Id for the clip path to implement the scroll box
	 */
	function ScrollBox(gd, container, id) {
	    this.gd = gd;
	    this.container = container;
	    this.id = id;
	
	    // See ScrollBox.prototype.enable for further definition
	    this.position = null;  // scrollbox position
	    this.translateX = null;  // scrollbox horizontal translation
	    this.translateY = null;  // scrollbox vertical translation
	    this.hbar = null;  // horizontal scrollbar D3 selection
	    this.vbar = null;  // vertical scrollbar D3 selection
	
	    // <rect> element to capture pointer events
	    this.bg = this.container.selectAll('rect.scrollbox-bg').data([0]);
	
	    this.bg.exit()
	        .on('.drag', null)
	        .on('wheel', null)
	        .remove();
	
	    this.bg.enter().append('rect')
	        .classed('scrollbox-bg', true)
	        .style('pointer-events', 'all')
	        .attr({
	            opacity: 0,
	            x: 0,
	            y: 0,
	            width: 0,
	            height: 0
	        });
	}
	
	// scroll bar dimensions
	ScrollBox.barWidth = 2;
	ScrollBox.barLength = 20;
	ScrollBox.barRadius = 2;
	ScrollBox.barPad = 1;
	ScrollBox.barColor = '#808BA4';
	
	/**
	 * If needed, setup a clip path and scrollbars
	 *
	 * @method
	 * @param {Object}  position
	 * @param {number}  position.l  Left side position (in pixels)
	 * @param {number}  position.t  Top side (in pixels)
	 * @param {number}  position.w  Width (in pixels)
	 * @param {number}  position.h  Height (in pixels)
	 * @param {string}  [position.direction='down']
	 *                  Either 'down', 'left', 'right' or 'up'
	 * @param {number}  [translateX=0]  Horizontal offset (in pixels)
	 * @param {number}  [translateY=0]  Vertical offset (in pixels)
	 */
	ScrollBox.prototype.enable = function enable(position, translateX, translateY) {
	    var fullLayout = this.gd._fullLayout;
	    var fullWidth = fullLayout.width;
	    var fullHeight = fullLayout.height;
	
	    // compute position of scrollbox
	    this.position = position;
	
	    var l = this.position.l;
	    var w = this.position.w;
	    var t = this.position.t;
	    var h = this.position.h;
	    var direction = this.position.direction;
	    var isDown = (direction === 'down');
	    var isLeft = (direction === 'left');
	    var isRight = (direction === 'right');
	    var isUp = (direction === 'up');
	    var boxW = w;
	    var boxH = h;
	    var boxL, boxR;
	    var boxT, boxB;
	
	    if(!isDown && !isLeft && !isRight && !isUp) {
	        this.position.direction = 'down';
	        isDown = true;
	    }
	
	    var isVertical = isDown || isUp;
	    if(isVertical) {
	        boxL = l;
	        boxR = boxL + boxW;
	
	        if(isDown) {
	            // anchor to top side
	            boxT = t;
	            boxB = Math.min(boxT + boxH, fullHeight);
	            boxH = boxB - boxT;
	        } else {
	            // anchor to bottom side
	            boxB = t + boxH;
	            boxT = Math.max(boxB - boxH, 0);
	            boxH = boxB - boxT;
	        }
	    } else {
	        boxT = t;
	        boxB = boxT + boxH;
	
	        if(isLeft) {
	            // anchor to right side
	            boxR = l + boxW;
	            boxL = Math.max(boxR - boxW, 0);
	            boxW = boxR - boxL;
	        } else {
	            // anchor to left side
	            boxL = l;
	            boxR = Math.min(boxL + boxW, fullWidth);
	            boxW = boxR - boxL;
	        }
	    }
	
	    this._box = {
	        l: boxL,
	        t: boxT,
	        w: boxW,
	        h: boxH
	    };
	
	    // compute position of horizontal scroll bar
	    var needsHorizontalScrollBar = (w > boxW);
	    var hbarW = ScrollBox.barLength + 2 * ScrollBox.barPad;
	    var hbarH = ScrollBox.barWidth + 2 * ScrollBox.barPad;
	    // draw horizontal scrollbar on the bottom side
	    var hbarL = l;
	    var hbarT = t + h;
	
	    if(hbarT + hbarH > fullHeight) hbarT = fullHeight - hbarH;
	
	    var hbar = this.container.selectAll('rect.scrollbar-horizontal').data(
	            (needsHorizontalScrollBar) ? [0] : []);
	
	    hbar.exit()
	        .on('.drag', null)
	        .remove();
	
	    hbar.enter().append('rect')
	        .classed('scrollbar-horizontal', true)
	        .call(Color.fill, ScrollBox.barColor);
	
	    if(needsHorizontalScrollBar) {
	        this.hbar = hbar.attr({
	            'rx': ScrollBox.barRadius,
	            'ry': ScrollBox.barRadius,
	            'x': hbarL,
	            'y': hbarT,
	            'width': hbarW,
	            'height': hbarH
	        });
	
	        // hbar center moves between hbarXMin and hbarXMin + hbarTranslateMax
	        this._hbarXMin = hbarL + hbarW / 2;
	        this._hbarTranslateMax = boxW - hbarW;
	    } else {
	        delete this.hbar;
	        delete this._hbarXMin;
	        delete this._hbarTranslateMax;
	    }
	
	    // compute position of vertical scroll bar
	    var needsVerticalScrollBar = (h > boxH);
	    var vbarW = ScrollBox.barWidth + 2 * ScrollBox.barPad;
	    var vbarH = ScrollBox.barLength + 2 * ScrollBox.barPad;
	    // draw vertical scrollbar on the right side
	    var vbarL = l + w;
	    var vbarT = t;
	
	    if(vbarL + vbarW > fullWidth) vbarL = fullWidth - vbarW;
	
	    var vbar = this.container.selectAll('rect.scrollbar-vertical').data(
	            (needsVerticalScrollBar) ? [0] : []);
	
	    vbar.exit()
	        .on('.drag', null)
	        .remove();
	
	    vbar.enter().append('rect')
	        .classed('scrollbar-vertical', true)
	        .call(Color.fill, ScrollBox.barColor);
	
	    if(needsVerticalScrollBar) {
	        this.vbar = vbar.attr({
	            'rx': ScrollBox.barRadius,
	            'ry': ScrollBox.barRadius,
	            'x': vbarL,
	            'y': vbarT,
	            'width': vbarW,
	            'height': vbarH
	        });
	
	        // vbar center moves between vbarYMin and vbarYMin + vbarTranslateMax
	        this._vbarYMin = vbarT + vbarH / 2;
	        this._vbarTranslateMax = boxH - vbarH;
	    } else {
	        delete this.vbar;
	        delete this._vbarYMin;
	        delete this._vbarTranslateMax;
	    }
	
	    // setup a clip path (if scroll bars are needed)
	    var clipId = this.id;
	    var clipL = boxL - 0.5;
	    var clipR = (needsVerticalScrollBar) ? boxR + vbarW + 0.5 : boxR + 0.5;
	    var clipT = boxT - 0.5;
	    var clipB = (needsHorizontalScrollBar) ? boxB + hbarH + 0.5 : boxB + 0.5;
	
	    var clipPath = fullLayout._topdefs.selectAll('#' + clipId)
	        .data((needsHorizontalScrollBar || needsVerticalScrollBar) ? [0] : []);
	
	    clipPath.exit().remove();
	
	    clipPath.enter()
	        .append('clipPath').attr('id', clipId)
	        .append('rect');
	
	    if(needsHorizontalScrollBar || needsVerticalScrollBar) {
	        this._clipRect = clipPath.select('rect').attr({
	            x: Math.floor(clipL),
	            y: Math.floor(clipT),
	            width: Math.ceil(clipR) - Math.floor(clipL),
	            height: Math.ceil(clipB) - Math.floor(clipT)
	        });
	
	        this.container.call(Drawing.setClipUrl, clipId, this.gd);
	
	        this.bg.attr({
	            x: l,
	            y: t,
	            width: w,
	            height: h
	        });
	    } else {
	        this.bg.attr({
	            width: 0,
	            height: 0
	        });
	        this.container
	            .on('wheel', null)
	            .on('.drag', null)
	            .call(Drawing.setClipUrl, null);
	        delete this._clipRect;
	    }
	
	    // set up drag listeners (if scroll bars are needed)
	    if(needsHorizontalScrollBar || needsVerticalScrollBar) {
	        var onBoxDrag = d3.behavior.drag()
	            .on('dragstart', function() {
	                d3.event.sourceEvent.preventDefault();
	            })
	            .on('drag', this._onBoxDrag.bind(this));
	
	        this.container
	            .on('wheel', null)
	            .on('wheel', this._onBoxWheel.bind(this))
	            .on('.drag', null)
	            .call(onBoxDrag);
	
	        var onBarDrag = d3.behavior.drag()
	            .on('dragstart', function() {
	                d3.event.sourceEvent.preventDefault();
	                d3.event.sourceEvent.stopPropagation();
	            })
	            .on('drag', this._onBarDrag.bind(this));
	
	        if(needsHorizontalScrollBar) {
	            this.hbar
	                .on('.drag', null)
	                .call(onBarDrag);
	        }
	
	        if(needsVerticalScrollBar) {
	            this.vbar
	                .on('.drag', null)
	                .call(onBarDrag);
	        }
	    }
	
	    // set scrollbox translation
	    this.setTranslate(translateX, translateY);
	};
	
	/**
	 * If present, remove clip-path and scrollbars
	 *
	 * @method
	 */
	ScrollBox.prototype.disable = function disable() {
	    if(this.hbar || this.vbar) {
	        this.bg.attr({
	            width: 0,
	            height: 0
	        });
	        this.container
	            .on('wheel', null)
	            .on('.drag', null)
	            .call(Drawing.setClipUrl, null);
	        delete this._clipRect;
	    }
	
	    if(this.hbar) {
	        this.hbar.on('.drag', null);
	        this.hbar.remove();
	        delete this.hbar;
	        delete this._hbarXMin;
	        delete this._hbarTranslateMax;
	    }
	
	    if(this.vbar) {
	        this.vbar.on('.drag', null);
	        this.vbar.remove();
	        delete this.vbar;
	        delete this._vbarYMin;
	        delete this._vbarTranslateMax;
	    }
	};
	
	/**
	 * Handles scroll box drag events
	 *
	 * @method
	 */
	ScrollBox.prototype._onBoxDrag = function _onBoxDrag() {
	    var translateX = this.translateX;
	    var translateY = this.translateY;
	
	    if(this.hbar) {
	        translateX -= d3.event.dx;
	    }
	
	    if(this.vbar) {
	        translateY -= d3.event.dy;
	    }
	
	    this.setTranslate(translateX, translateY);
	};
	
	/**
	 * Handles scroll box wheel events
	 *
	 * @method
	 */
	ScrollBox.prototype._onBoxWheel = function _onBoxWheel() {
	    var translateX = this.translateX;
	    var translateY = this.translateY;
	
	    if(this.hbar) {
	        translateX += d3.event.deltaY;
	    }
	
	    if(this.vbar) {
	        translateY += d3.event.deltaY;
	    }
	
	    this.setTranslate(translateX, translateY);
	};
	
	/**
	 * Handles scroll bar drag events
	 *
	 * @method
	 */
	ScrollBox.prototype._onBarDrag = function _onBarDrag() {
	    var translateX = this.translateX;
	    var translateY = this.translateY;
	
	    if(this.hbar) {
	        var xMin = translateX + this._hbarXMin;
	        var xMax = xMin + this._hbarTranslateMax;
	        var x = Lib.constrain(d3.event.x, xMin, xMax);
	        var xf = (x - xMin) / (xMax - xMin);
	
	        var translateXMax = this.position.w - this._box.w;
	
	        translateX = xf * translateXMax;
	    }
	
	    if(this.vbar) {
	        var yMin = translateY + this._vbarYMin;
	        var yMax = yMin + this._vbarTranslateMax;
	        var y = Lib.constrain(d3.event.y, yMin, yMax);
	        var yf = (y - yMin) / (yMax - yMin);
	
	        var translateYMax = this.position.h - this._box.h;
	
	        translateY = yf * translateYMax;
	    }
	
	    this.setTranslate(translateX, translateY);
	};
	
	/**
	 * Set clip path and scroll bar translate transform
	 *
	 * @method
	 * @param {number}  [translateX=0]  Horizontal offset (in pixels)
	 * @param {number}  [translateY=0]  Vertical offset (in pixels)
	 */
	ScrollBox.prototype.setTranslate = function setTranslate(translateX, translateY) {
	    // store translateX and translateY (needed by mouse event handlers)
	    var translateXMax = this.position.w - this._box.w;
	    var translateYMax = this.position.h - this._box.h;
	
	    translateX = Lib.constrain(translateX || 0, 0, translateXMax);
	    translateY = Lib.constrain(translateY || 0, 0, translateYMax);
	
	    this.translateX = translateX;
	    this.translateY = translateY;
	
	    this.container.call(Drawing.setTranslate,
	        this._box.l - this.position.l - translateX,
	        this._box.t - this.position.t - translateY);
	
	    if(this._clipRect) {
	        this._clipRect.attr({
	            x: Math.floor(this.position.l + translateX - 0.5),
	            y: Math.floor(this.position.t + translateY - 0.5)
	        });
	    }
	
	    if(this.hbar) {
	        var xf = translateX / translateXMax;
	
	        this.hbar.call(Drawing.setTranslate,
	            translateX + xf * this._hbarTranslateMax,
	            translateY);
	    }
	
	    if(this.vbar) {
	        var yf = translateY / translateYMax;
	
	        this.vbar.call(Drawing.setTranslate,
	            translateX,
	            translateY + yf * this._vbarTranslateMax);
	    }
	};
	
	},{"../../lib":716,"../color":591,"../drawing":612,"d3":164}],685:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// fraction of some size to get to a named position
	module.exports = {
	    // from bottom left: this is the origin of our paper-reference
	    // positioning system
	    FROM_BL: {
	        left: 0,
	        center: 0.5,
	        right: 1,
	        bottom: 0,
	        middle: 0.5,
	        top: 1
	    },
	    // from top left: this is the screen pixel positioning origin
	    FROM_TL: {
	        left: 0,
	        center: 0.5,
	        right: 1,
	        bottom: 1,
	        middle: 0.5,
	        top: 0
	    },
	    // from bottom right: sometimes you just need the opposite of ^^
	    FROM_BR: {
	        left: 1,
	        center: 0.5,
	        right: 0,
	        bottom: 0,
	        middle: 0.5,
	        top: 1
	    },
	    // multiple of fontSize to get the vertical offset between lines
	    LINE_SPACING: 1.3,
	
	    // multiple of fontSize to shift from the baseline
	    // to the cap (captical letter) line
	    // (to use when we don't calculate this shift from Drawing.bBox)
	    // This is an approximation since in reality cap height can differ
	    // from font to font. However, according to Wikipedia
	    //   an "average" font might have a cap height of 70% of the em
	    // https://en.wikipedia.org/wiki/Em_(typography)#History
	    CAP_SHIFT: 0.70,
	
	    // half the cap height (distance between baseline and cap line)
	    // of an "average" font (for more info see above).
	    MID_SHIFT: 0.35,
	
	    OPPOSITE_SIDE: {
	        left: 'right',
	        right: 'left',
	        top: 'bottom',
	        bottom: 'top'
	    }
	};
	
	},{}],686:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    INCREASING: {
	        COLOR: '#3D9970',
	        SYMBOL: '▲'
	    },
	    DECREASING: {
	        COLOR: '#FF4136',
	        SYMBOL: '▼'
	    }
	};
	
	},{}],687:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    FORMAT_LINK: 'https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md#d3_format',
	    DATE_FORMAT_LINK: 'https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Formatting.md#format'
	};
	
	},{}],688:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    COMPARISON_OPS: ['=', '!=', '<', '>=', '>', '<='],
	    COMPARISON_OPS2: ['=', '<', '>=', '>', '<='],
	    INTERVAL_OPS: ['[]', '()', '[)', '(]', '][', ')(', '](', ')['],
	    SET_OPS: ['{}', '}{'],
	    CONSTRAINT_REDUCTION: {
	        // for contour constraints, open/closed endpoints are equivalent
	        '=': '=',
	
	        '<': '<',
	        '<=': '<',
	
	        '>': '>',
	        '>=': '>',
	
	        '[]': '[]',
	        '()': '[]',
	        '[)': '[]',
	        '(]': '[]',
	
	        '][': '][',
	        ')(': '][',
	        '](': '][',
	        ')[': ']['
	    }
	};
	
	},{}],689:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    solid: [[], 0],
	    dot: [[0.5, 1], 200],
	    dash: [[0.5, 1], 50],
	    longdash: [[0.5, 1], 10],
	    dashdot: [[0.5, 0.625, 0.875, 1], 50],
	    longdashdot: [[0.5, 0.7, 0.8, 1], 10]
	};
	
	},{}],690:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    circle: '●',
	    'circle-open': '○',
	    square: '■',
	    'square-open': '□',
	    diamond: '◆',
	    'diamond-open': '◇',
	    cross: '+',
	    x: '❌'
	};
	
	},{}],691:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    /**
	     * Timing information for interactive elements
	     */
	    SHOW_PLACEHOLDER: 100,
	    HIDE_PLACEHOLDER: 1000,
	
	    // opacity dimming fraction for points that are not in selection
	    DESELECTDIM: 0.2
	};
	
	},{}],692:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    /**
	     * Standardize all missing data in calcdata to use undefined
	     * never null or NaN.
	     * That way we can use !==undefined, or !== BADNUM,
	     * to test for real data
	     */
	    BADNUM: undefined,
	
	    /*
	     * Limit certain operations to well below floating point max value
	     * to avoid glitches: Make sure that even when you multiply it by the
	     * number of pixels on a giant screen it still works
	     */
	    FP_SAFE: Number.MAX_VALUE / 10000,
	
	    /*
	     * conversion of date units to milliseconds
	     * year and month constants are marked "AVG"
	     * to remind us that not all years and months
	     * have the same length
	     */
	    ONEAVGYEAR: 31557600000, // 365.25 days
	    ONEAVGMONTH: 2629800000, // 1/12 of ONEAVGYEAR
	    ONEDAY: 86400000,
	    ONEHOUR: 3600000,
	    ONEMIN: 60000,
	    ONESEC: 1000,
	
	    /*
	     * For fast conversion btwn world calendars and epoch ms, the Julian Day Number
	     * of the unix epoch. From calendars.instance().newDate(1970, 1, 1).toJD()
	     */
	    EPOCHJD: 2440587.5,
	
	    /*
	     * Are two values nearly equal? Compare to 1PPM
	     */
	    ALMOST_EQUAL: 1 - 1e-6,
	
	    /*
	     * If we're asked to clip a non-positive log value, how far off-screen
	     * do we put it?
	     */
	    LOG_CLIP: 10,
	
	    /*
	     * not a number, but for displaying numbers: the "minus sign" symbol is
	     * wider than the regular ascii dash "-"
	     */
	    MINUS_SIGN: '\u2212'
	};
	
	},{}],693:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	exports.xmlns = 'http://www.w3.org/2000/xmlns/';
	exports.svg = 'http://www.w3.org/2000/svg';
	exports.xlink = 'http://www.w3.org/1999/xlink';
	
	// the 'old' d3 quirk got fix in v3.5.7
	// https://github.com/mbostock/d3/commit/a6f66e9dd37f764403fc7c1f26be09ab4af24fed
	exports.svgAttrs = {
	    xmlns: exports.svg,
	    'xmlns:xlink': exports.xlink
	};
	
	},{}],694:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// package version injected by `npm run preprocess`
	exports.version = '1.51.3';
	
	// inject promise polyfill
	_dereq_('es6-promise').polyfill();
	
	// inject plot css
	_dereq_('../build/plotcss');
	
	// inject default MathJax config
	_dereq_('./fonts/mathjax_config')();
	
	// include registry module and expose register method
	var Registry = _dereq_('./registry');
	var register = exports.register = Registry.register;
	
	// expose plot api methods
	var plotApi = _dereq_('./plot_api');
	var methodNames = Object.keys(plotApi);
	for(var i = 0; i < methodNames.length; i++) {
	    var name = methodNames[i];
	    // _ -> private API methods, but still registered for internal use
	    if(name.charAt(0) !== '_') exports[name] = plotApi[name];
	    register({
	        moduleType: 'apiMethod',
	        name: name,
	        fn: plotApi[name]
	    });
	}
	
	// scatter is the only trace included by default
	register(_dereq_('./traces/scatter'));
	
	// register all registrable components modules
	register([
	    _dereq_('./components/fx'),
	    _dereq_('./components/legend'),
	    _dereq_('./components/annotations'),
	    _dereq_('./components/annotations3d'),
	    _dereq_('./components/shapes'),
	    _dereq_('./components/images'),
	    _dereq_('./components/updatemenus'),
	    _dereq_('./components/sliders'),
	    _dereq_('./components/rangeslider'),
	    _dereq_('./components/rangeselector'),
	    _dereq_('./components/grid'),
	    _dereq_('./components/errorbars'),
	    _dereq_('./components/colorscale'),
	    _dereq_('./components/colorbar')
	]);
	
	// locales en and en-US are required for default behavior
	register([
	    _dereq_('./locale-en'),
	    _dereq_('./locale-en-us')
	]);
	
	// plot icons
	exports.Icons = _dereq_('./fonts/ploticon');
	
	// unofficial 'beta' plot methods, use at your own risk
	exports.Plots = _dereq_('./plots/plots');
	exports.Fx = _dereq_('./components/fx');
	exports.Snapshot = _dereq_('./snapshot');
	exports.PlotSchema = _dereq_('./plot_api/plot_schema');
	exports.Queue = _dereq_('./lib/queue');
	
	// export d3 used in the bundle
	exports.d3 = _dereq_('d3');
	
	},{"../build/plotcss":1,"./components/annotations":582,"./components/annotations3d":587,"./components/colorbar":597,"./components/colorscale":603,"./components/errorbars":618,"./components/fx":629,"./components/grid":633,"./components/images":638,"./components/legend":646,"./components/rangeselector":657,"./components/rangeslider":664,"./components/shapes":672,"./components/sliders":677,"./components/updatemenus":683,"./fonts/mathjax_config":695,"./fonts/ploticon":696,"./lib/queue":731,"./locale-en":745,"./locale-en-us":744,"./plot_api":749,"./plot_api/plot_schema":753,"./plots/plots":825,"./registry":845,"./snapshot":850,"./traces/scatter":1130,"d3":164,"es6-promise":220}],695:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/* global MathJax:false */
	
	module.exports = function() {
	    if(typeof MathJax !== 'undefined') {
	        var globalConfig = (window.PlotlyConfig || {}).MathJaxConfig !== 'local';
	
	        if(globalConfig) {
	            MathJax.Hub.Config({
	                messageStyle: 'none',
	                skipStartupTypeset: true,
	                displayAlign: 'left',
	                tex2jax: {
	                    inlineMath: [['$', '$'], ['\\(', '\\)']]
	                }
	            });
	            MathJax.Hub.Configured();
	        }
	    }
	};
	
	},{}],696:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    'undo': {
	        'width': 857.1,
	        'height': 1000,
	        'path': 'm857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'home': {
	        'width': 928.6,
	        'height': 1000,
	        'path': 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'camera-retro': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'zoombox': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'pan': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'zoom_plus': {
	        'width': 875,
	        'height': 1000,
	        'path': 'm1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'zoom_minus': {
	        'width': 875,
	        'height': 1000,
	        'path': 'm0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'autoscale': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'tooltip_basic': {
	        'width': 1500,
	        'height': 1000,
	        'path': 'm375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'tooltip_compare': {
	        'width': 1125,
	        'height': 1000,
	        'path': 'm187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'plotlylogo': {
	        'width': 1542,
	        'height': 1000,
	        'path': 'm0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'z-axis': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    '3d_rotate': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'camera': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'movie': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'question': {
	        'width': 857.1,
	        'height': 1000,
	        'path': 'm500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'disk': {
	        'width': 857.1,
	        'height': 1000,
	        'path': 'm214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'lasso': {
	        'width': 1031,
	        'height': 1000,
	        'path': 'm1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'selectbox': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'm0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z',
	        'transform': 'matrix(1 0 0 -1 0 850)'
	    },
	    'spikeline': {
	        'width': 1000,
	        'height': 1000,
	        'path': 'M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z',
	        'transform': 'matrix(1.5 0 0 -1.5 0 850)'
	    },
	    'pencil': {
	        'width': 1792,
	        'height': 1792,
	        'path': 'M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z',
	        'transform': 'matrix(1 0 0 1 0 1)'
	    },
	    'newplotlylogo': {
	        'name': 'newplotlylogo',
	        'svg': '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 132 132\'><defs><style>.cls-1 {fill: #119dff;} .cls-2 {fill: #25fefd;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id=\'symbol\'><rect class=\'cls-1\' width=\'132\' height=\'132\' rx=\'6\' ry=\'6\'/><circle class=\'cls-2\' cx=\'78\' cy=\'54\' r=\'6\'/><circle class=\'cls-2\' cx=\'102\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'78\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'54\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'30\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'30\' cy=\'54\' r=\'6\'/><path class=\'cls-3\' d=\'M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z\'/><path class=\'cls-3\' d=\'M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z\'/><path class=\'cls-3\' d=\'M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z\'/><path class=\'cls-3\' d=\'M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z\'/></g></svg>'
	    }
	};
	
	},{}],697:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	/**
	 * Determine the position anchor property of x/y xanchor/yanchor components.
	 *
	 * - values < 1/3 align the low side at that fraction,
	 * - values [1/3, 2/3] align the center at that fraction,
	 * - values > 2/3 align the right at that fraction.
	 */
	
	
	exports.isLeftAnchor = function isLeftAnchor(opts) {
	    return (
	      opts.xanchor === 'left' ||
	      (opts.xanchor === 'auto' && opts.x <= 1 / 3)
	    );
	};
	
	exports.isCenterAnchor = function isCenterAnchor(opts) {
	    return (
	        opts.xanchor === 'center' ||
	        (opts.xanchor === 'auto' && opts.x > 1 / 3 && opts.x < 2 / 3)
	    );
	};
	
	exports.isRightAnchor = function isRightAnchor(opts) {
	    return (
	      opts.xanchor === 'right' ||
	      (opts.xanchor === 'auto' && opts.x >= 2 / 3)
	    );
	};
	
	exports.isTopAnchor = function isTopAnchor(opts) {
	    return (
	        opts.yanchor === 'top' ||
	        (opts.yanchor === 'auto' && opts.y >= 2 / 3)
	    );
	};
	
	exports.isMiddleAnchor = function isMiddleAnchor(opts) {
	    return (
	        opts.yanchor === 'middle' ||
	        (opts.yanchor === 'auto' && opts.y > 1 / 3 && opts.y < 2 / 3)
	    );
	};
	
	exports.isBottomAnchor = function isBottomAnchor(opts) {
	    return (
	      opts.yanchor === 'bottom' ||
	      (opts.yanchor === 'auto' && opts.y <= 1 / 3)
	    );
	};
	
	},{}],698:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var modModule = _dereq_('./mod');
	var mod = modModule.mod;
	var modHalf = modModule.modHalf;
	
	var PI = Math.PI;
	var twoPI = 2 * PI;
	
	function deg2rad(deg) { return deg / 180 * PI; }
	
	function rad2deg(rad) { return rad / PI * 180; }
	
	/**
	 * is sector a full circle?
	 * ... this comes up a lot in SVG path-drawing routines
	 *
	 * N.B. we consider all sectors that span more that 2pi 'full' circles
	 *
	 * @param {2-item array} aBnds : angular bounds in *radians*
	 * @return {boolean}
	 */
	function isFullCircle(aBnds) {
	    return Math.abs(aBnds[1] - aBnds[0]) > twoPI - 1e-14;
	}
	
	/**
	 * angular delta between angle 'a' and 'b'
	 * solution taken from: https://stackoverflow.com/a/2007279
	 *
	 * @param {number} a : first angle in *radians*
	 * @param {number} b : second angle in *radians*
	 * @return {number} angular delta in *radians*
	 */
	function angleDelta(a, b) {
	    return modHalf(b - a, twoPI);
	}
	
	/**
	 * angular distance between angle 'a' and 'b'
	 *
	 * @param {number} a : first angle in *radians*
	 * @param {number} b : second angle in *radians*
	 * @return {number} angular distance in *radians*
	 */
	function angleDist(a, b) {
	    return Math.abs(angleDelta(a, b));
	}
	
	/**
	 * is angle inside sector?
	 *
	 * @param {number} a : angle to test in *radians*
	 * @param {2-item array} aBnds : sector's angular bounds in *radians*
	 * @param {boolean}
	 */
	function isAngleInsideSector(a, aBnds) {
	    if(isFullCircle(aBnds)) return true;
	
	    var s0, s1;
	
	    if(aBnds[0] < aBnds[1]) {
	        s0 = aBnds[0];
	        s1 = aBnds[1];
	    } else {
	        s0 = aBnds[1];
	        s1 = aBnds[0];
	    }
	
	    s0 = mod(s0, twoPI);
	    s1 = mod(s1, twoPI);
	    if(s0 > s1) s1 += twoPI;
	
	    var a0 = mod(a, twoPI);
	    var a1 = a0 + twoPI;
	
	    return (a0 >= s0 && a0 <= s1) || (a1 >= s0 && a1 <= s1);
	}
	
	/**
	 * is pt (r,a) inside sector?
	 *
	 * @param {number} r : pt's radial coordinate
	 * @param {number} a : pt's angular coordinate in *radians*
	 * @param {2-item array} rBnds : sector's radial bounds
	 * @param {2-item array} aBnds : sector's angular bounds in *radians*
	 * @return {boolean}
	 */
	function isPtInsideSector(r, a, rBnds, aBnds) {
	    if(!isAngleInsideSector(a, aBnds)) return false;
	
	    var r0, r1;
	
	    if(rBnds[0] < rBnds[1]) {
	        r0 = rBnds[0];
	        r1 = rBnds[1];
	    } else {
	        r0 = rBnds[1];
	        r1 = rBnds[0];
	    }
	
	    return r >= r0 && r <= r1;
	}
	
	// common to pathArc, pathSector and pathAnnulus
	function _path(r0, r1, a0, a1, cx, cy, isClosed) {
	    cx = cx || 0;
	    cy = cy || 0;
	
	    var isCircle = isFullCircle([a0, a1]);
	    var aStart, aMid, aEnd;
	    var rStart, rEnd;
	
	    if(isCircle) {
	        aStart = 0;
	        aMid = PI;
	        aEnd = twoPI;
	    } else {
	        if(a0 < a1) {
	            aStart = a0;
	            aEnd = a1;
	        } else {
	            aStart = a1;
	            aEnd = a0;
	        }
	    }
	
	    if(r0 < r1) {
	        rStart = r0;
	        rEnd = r1;
	    } else {
	        rStart = r1;
	        rEnd = r0;
	    }
	
	    // N.B. svg coordinates here, where y increases downward
	    function pt(r, a) {
	        return [r * Math.cos(a) + cx, cy - r * Math.sin(a)];
	    }
	
	    var largeArc = Math.abs(aEnd - aStart) <= PI ? 0 : 1;
	    function arc(r, a, cw) {
	        return 'A' + [r, r] + ' ' + [0, largeArc, cw] + ' ' + pt(r, a);
	    }
	
	    var p;
	
	    if(isCircle) {
	        if(rStart === null) {
	            p = 'M' + pt(rEnd, aStart) +
	                arc(rEnd, aMid, 0) +
	                arc(rEnd, aEnd, 0) + 'Z';
	        } else {
	            p = 'M' + pt(rStart, aStart) +
	                arc(rStart, aMid, 0) +
	                arc(rStart, aEnd, 0) + 'Z' +
	                'M' + pt(rEnd, aStart) +
	                arc(rEnd, aMid, 1) +
	                arc(rEnd, aEnd, 1) + 'Z';
	        }
	    } else {
	        if(rStart === null) {
	            p = 'M' + pt(rEnd, aStart) + arc(rEnd, aEnd, 0);
	            if(isClosed) p += 'L0,0Z';
	        } else {
	            p = 'M' + pt(rStart, aStart) +
	                'L' + pt(rEnd, aStart) +
	                arc(rEnd, aEnd, 0) +
	                'L' + pt(rStart, aEnd) +
	                arc(rStart, aStart, 1) + 'Z';
	        }
	    }
	
	    return p;
	}
	
	/**
	 * path an arc
	 *
	 * @param {number} r : radius
	 * @param {number} a0 : first angular coordinate in *radians*
	 * @param {number} a1 : second angular coordinate in *radians*
	 * @param {number (optional)} cx : x coordinate of center
	 * @param {number (optional)} cy : y coordinate of center
	 * @return {string} svg path
	 */
	function pathArc(r, a0, a1, cx, cy) {
	    return _path(null, r, a0, a1, cx, cy, 0);
	}
	
	/**
	 * path a sector
	 *
	 * @param {number} r : radius
	 * @param {number} a0 : first angular coordinate in *radians*
	 * @param {number} a1 : second angular coordinate in *radians*
	 * @param {number (optional)} cx : x coordinate of center
	 * @param {number (optional)} cy : y coordinate of center
	 * @return {string} svg path
	 */
	function pathSector(r, a0, a1, cx, cy) {
	    return _path(null, r, a0, a1, cx, cy, 1);
	}
	
	/**
	 * path an annulus
	 *
	 * @param {number} r0 : first radial coordinate
	 * @param {number} r1 : second radial coordinate
	 * @param {number} a0 : first angular coordinate in *radians*
	 * @param {number} a1 : second angular coordinate in *radians*
	 * @param {number (optional)} cx : x coordinate of center
	 * @param {number (optional)} cy : y coordinate of center
	 * @return {string} svg path
	 */
	function pathAnnulus(r0, r1, a0, a1, cx, cy) {
	    return _path(r0, r1, a0, a1, cx, cy, 1);
	}
	
	module.exports = {
	    deg2rad: deg2rad,
	    rad2deg: rad2deg,
	    angleDelta: angleDelta,
	    angleDist: angleDist,
	    isFullCircle: isFullCircle,
	    isAngleInsideSector: isAngleInsideSector,
	    isPtInsideSector: isPtInsideSector,
	    pathArc: pathArc,
	    pathSector: pathSector,
	    pathAnnulus: pathAnnulus
	};
	
	},{"./mod":723}],699:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArray = Array.isArray;
	
	// IE9 fallbacks
	
	var ab = (typeof ArrayBuffer === 'undefined' || !ArrayBuffer.isView) ?
	    {isView: function() { return false; }} :
	    ArrayBuffer;
	
	var dv = (typeof DataView === 'undefined') ?
	    function() {} :
	    DataView;
	
	function isTypedArray(a) {
	    return ab.isView(a) && !(a instanceof dv);
	}
	exports.isTypedArray = isTypedArray;
	
	function isArrayOrTypedArray(a) {
	    return isArray(a) || isTypedArray(a);
	}
	exports.isArrayOrTypedArray = isArrayOrTypedArray;
	
	/*
	 * Test whether an input object is 1D.
	 *
	 * Assumes we already know the object is an array.
	 *
	 * Looks only at the first element, if the dimensionality is
	 * not consistent we won't figure that out here.
	 */
	function isArray1D(a) {
	    return !isArrayOrTypedArray(a[0]);
	}
	exports.isArray1D = isArray1D;
	
	/*
	 * Ensures an array has the right amount of storage space. If it doesn't
	 * exist, it creates an array. If it does exist, it returns it if too
	 * short or truncates it in-place.
	 *
	 * The goal is to just reuse memory to avoid a bit of excessive garbage
	 * collection.
	 */
	exports.ensureArray = function(out, n) {
	    // TODO: typed array support here? This is only used in
	    // traces/carpet/compute_control_points
	    if(!isArray(out)) out = [];
	
	    // If too long, truncate. (If too short, it will grow
	    // automatically so we don't care about that case)
	    out.length = n;
	
	    return out;
	};
	
	/*
	 * TypedArray-compatible concatenation of n arrays
	 * if all arrays are the same type it will preserve that type,
	 * otherwise it falls back on Array.
	 * Also tries to avoid copying, in case one array has zero length
	 * But never mutates an existing array
	 */
	exports.concat = function() {
	    var args = [];
	    var allArray = true;
	    var totalLen = 0;
	
	    var _constructor, arg0, i, argi, posi, leni, out, j;
	
	    for(i = 0; i < arguments.length; i++) {
	        argi = arguments[i];
	        leni = argi.length;
	        if(leni) {
	            if(arg0) args.push(argi);
	            else {
	                arg0 = argi;
	                posi = leni;
	            }
	
	            if(isArray(argi)) {
	                _constructor = false;
	            } else {
	                allArray = false;
	                if(!totalLen) {
	                    _constructor = argi.constructor;
	                } else if(_constructor !== argi.constructor) {
	                    // TODO: in principle we could upgrade here,
	                    // ie keep typed array but convert all to Float64Array?
	                    _constructor = false;
	                }
	            }
	
	            totalLen += leni;
	        }
	    }
	
	    if(!totalLen) return [];
	    if(!args.length) return arg0;
	
	    if(allArray) return arg0.concat.apply(arg0, args);
	    if(_constructor) {
	        // matching typed arrays
	        out = new _constructor(totalLen);
	        out.set(arg0);
	        for(i = 0; i < args.length; i++) {
	            argi = args[i];
	            out.set(argi, posi);
	            posi += argi.length;
	        }
	        return out;
	    }
	
	    // mismatched types or Array + typed
	    out = new Array(totalLen);
	    for(j = 0; j < arg0.length; j++) out[j] = arg0[j];
	    for(i = 0; i < args.length; i++) {
	        argi = args[i];
	        for(j = 0; j < argi.length; j++) out[posi + j] = argi[j];
	        posi += j;
	    }
	    return out;
	};
	
	exports.maxRowLength = function(z) {
	    return _rowLength(z, Math.max, 0);
	};
	
	exports.minRowLength = function(z) {
	    return _rowLength(z, Math.min, Infinity);
	};
	
	function _rowLength(z, fn, len0) {
	    if(isArrayOrTypedArray(z)) {
	        if(isArrayOrTypedArray(z[0])) {
	            var len = len0;
	            for(var i = 0; i < z.length; i++) {
	                len = fn(len, z[i].length);
	            }
	            return len;
	        } else {
	            return z.length;
	        }
	    }
	    return 0;
	}
	
	},{}],700:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var BADNUM = _dereq_('../constants/numerical').BADNUM;
	
	// precompile for speed
	var JUNK = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
	
	/**
	 * cleanNumber: remove common leading and trailing cruft
	 * Always returns either a number or BADNUM.
	 */
	module.exports = function cleanNumber(v) {
	    if(typeof v === 'string') {
	        v = v.replace(JUNK, '');
	    }
	
	    if(isNumeric(v)) return Number(v);
	
	    return BADNUM;
	};
	
	},{"../constants/numerical":692,"fast-isnumeric":227}],701:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * Clear gl frame (if any). This is a common pattern as
	 * we usually set `preserveDrawingBuffer: true` during
	 * gl context creation (e.g. via `reglUtils.prepare`).
	 *
	 * @param {DOM node or object} gd : graph div object
	 */
	module.exports = function clearGlCanvases(gd) {
	    var fullLayout = gd._fullLayout;
	
	    if(fullLayout._glcanvas && fullLayout._glcanvas.size()) {
	        fullLayout._glcanvas.each(function(d) {
	            if(d.regl) d.regl.clear({color: true, depth: true});
	        });
	    }
	};
	
	},{}],702:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * Clear responsive handlers (if any).
	 *
	 * @param {DOM node or object} gd : graph div object
	 */
	module.exports = function clearResponsive(gd) {
	    if(gd._responsiveChartHandler) {
	        window.removeEventListener('resize', gd._responsiveChartHandler);
	        delete gd._responsiveChartHandler;
	    }
	};
	
	},{}],703:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var tinycolor = _dereq_('tinycolor2');
	
	var baseTraceAttrs = _dereq_('../plots/attributes');
	var colorscales = _dereq_('../components/colorscale/scales');
	var DESELECTDIM = _dereq_('../constants/interactions').DESELECTDIM;
	
	var nestedProperty = _dereq_('./nested_property');
	var counterRegex = _dereq_('./regex').counter;
	var modHalf = _dereq_('./mod').modHalf;
	var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
	
	exports.valObjectMeta = {
	    data_array: {
	        // You can use *dflt=[] to force said array to exist though.
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            // TODO maybe `v: {type: 'float32', vals: [/* ... */]}` also
	            if(isArrayOrTypedArray(v)) propOut.set(v);
	            else if(dflt !== undefined) propOut.set(dflt);
	        }
	    },
	    enumerated: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            if(opts.coerceNumber) v = +v;
	            if(opts.values.indexOf(v) === -1) propOut.set(dflt);
	            else propOut.set(v);
	        },
	        validateFunction: function(v, opts) {
	            if(opts.coerceNumber) v = +v;
	
	            var values = opts.values;
	            for(var i = 0; i < values.length; i++) {
	                var k = String(values[i]);
	
	                if((k.charAt(0) === '/' && k.charAt(k.length - 1) === '/')) {
	                    var regex = new RegExp(k.substr(1, k.length - 2));
	                    if(regex.test(v)) return true;
	                } else if(v === values[i]) return true;
	            }
	            return false;
	        }
	    },
	    'boolean': {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            if(v === true || v === false) propOut.set(v);
	            else propOut.set(dflt);
	        }
	    },
	    number: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            if(!isNumeric(v) ||
	                    (opts.min !== undefined && v < opts.min) ||
	                    (opts.max !== undefined && v > opts.max)) {
	                propOut.set(dflt);
	            } else propOut.set(+v);
	        }
	    },
	    integer: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            if(v % 1 || !isNumeric(v) ||
	                    (opts.min !== undefined && v < opts.min) ||
	                    (opts.max !== undefined && v > opts.max)) {
	                propOut.set(dflt);
	            } else propOut.set(+v);
	        }
	    },
	    string: {
	        
	        
	        // TODO 'values shouldn't be in there (edge case: 'dash' in Scatter)
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            if(typeof v !== 'string') {
	                var okToCoerce = (typeof v === 'number');
	
	                if(opts.strict === true || !okToCoerce) propOut.set(dflt);
	                else propOut.set(String(v));
	            } else if(opts.noBlank && !v) propOut.set(dflt);
	            else propOut.set(v);
	        }
	    },
	    color: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            if(tinycolor(v).isValid()) propOut.set(v);
	            else propOut.set(dflt);
	        }
	    },
	    colorlist: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            function isColor(color) {
	                return tinycolor(color).isValid();
	            }
	            if(!Array.isArray(v) || !v.length) propOut.set(dflt);
	            else if(v.every(isColor)) propOut.set(v);
	            else propOut.set(dflt);
	        }
	    },
	    colorscale: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            propOut.set(colorscales.get(v, dflt));
	        }
	    },
	    angle: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            if(v === 'auto') propOut.set('auto');
	            else if(!isNumeric(v)) propOut.set(dflt);
	            else propOut.set(modHalf(+v, 360));
	        }
	    },
	    subplotid: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            var regex = opts.regex || counterRegex(dflt);
	            if(typeof v === 'string' && regex.test(v)) {
	                propOut.set(v);
	                return;
	            }
	            propOut.set(dflt);
	        },
	        validateFunction: function(v, opts) {
	            var dflt = opts.dflt;
	
	            if(v === dflt) return true;
	            if(typeof v !== 'string') return false;
	            if(counterRegex(dflt).test(v)) return true;
	
	            return false;
	        }
	    },
	    flaglist: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            if(typeof v !== 'string') {
	                propOut.set(dflt);
	                return;
	            }
	            if((opts.extras || []).indexOf(v) !== -1) {
	                propOut.set(v);
	                return;
	            }
	            var vParts = v.split('+');
	            var i = 0;
	            while(i < vParts.length) {
	                var vi = vParts[i];
	                if(opts.flags.indexOf(vi) === -1 || vParts.indexOf(vi) < i) {
	                    vParts.splice(i, 1);
	                } else i++;
	            }
	            if(!vParts.length) propOut.set(dflt);
	            else propOut.set(vParts.join('+'));
	        }
	    },
	    any: {
	        
	        
	        
	        coerceFunction: function(v, propOut, dflt) {
	            if(v === undefined) propOut.set(dflt);
	            else propOut.set(v);
	        }
	    },
	    info_array: {
	        
	        
	        // set `dimensions=2` for a 2D array or '1-2' for either
	        // `items` may be a single object instead of an array, in which case
	        // `freeLength` must be true.
	        // if `dimensions='1-2'` and items is a 1D array, then the value can
	        // either be a matching 1D array or an array of such matching 1D arrays
	        
	        coerceFunction: function(v, propOut, dflt, opts) {
	            // simplified coerce function just for array items
	            function coercePart(v, opts, dflt) {
	                var out;
	                var propPart = {set: function(v) { out = v; }};
	
	                if(dflt === undefined) dflt = opts.dflt;
	
	                exports.valObjectMeta[opts.valType].coerceFunction(v, propPart, dflt, opts);
	
	                return out;
	            }
	
	            var twoD = opts.dimensions === 2 || (opts.dimensions === '1-2' && Array.isArray(v) && Array.isArray(v[0]));
	
	            if(!Array.isArray(v)) {
	                propOut.set(dflt);
	                return;
	            }
	
	            var items = opts.items;
	            var vOut = [];
	            var arrayItems = Array.isArray(items);
	            var arrayItems2D = arrayItems && twoD && Array.isArray(items[0]);
	            var innerItemsOnly = twoD && arrayItems && !arrayItems2D;
	            var len = (arrayItems && !innerItemsOnly) ? items.length : v.length;
	
	            var i, j, row, item, len2, vNew;
	
	            dflt = Array.isArray(dflt) ? dflt : [];
	
	            if(twoD) {
	                for(i = 0; i < len; i++) {
	                    vOut[i] = [];
	                    row = Array.isArray(v[i]) ? v[i] : [];
	                    if(innerItemsOnly) len2 = items.length;
	                    else if(arrayItems) len2 = items[i].length;
	                    else len2 = row.length;
	
	                    for(j = 0; j < len2; j++) {
	                        if(innerItemsOnly) item = items[j];
	                        else if(arrayItems) item = items[i][j];
	                        else item = items;
	
	                        vNew = coercePart(row[j], item, (dflt[i] || [])[j]);
	                        if(vNew !== undefined) vOut[i][j] = vNew;
	                    }
	                }
	            } else {
	                for(i = 0; i < len; i++) {
	                    vNew = coercePart(v[i], arrayItems ? items[i] : items, dflt[i]);
	                    if(vNew !== undefined) vOut[i] = vNew;
	                }
	            }
	
	            propOut.set(vOut);
	        },
	        validateFunction: function(v, opts) {
	            if(!Array.isArray(v)) return false;
	
	            var items = opts.items;
	            var arrayItems = Array.isArray(items);
	            var twoD = opts.dimensions === 2;
	
	            // when free length is off, input and declared lengths must match
	            if(!opts.freeLength && v.length !== items.length) return false;
	
	            // valid when all input items are valid
	            for(var i = 0; i < v.length; i++) {
	                if(twoD) {
	                    if(!Array.isArray(v[i]) || (!opts.freeLength && v[i].length !== items[i].length)) {
	                        return false;
	                    }
	                    for(var j = 0; j < v[i].length; j++) {
	                        if(!validate(v[i][j], arrayItems ? items[i][j] : items)) {
	                            return false;
	                        }
	                    }
	                } else if(!validate(v[i], arrayItems ? items[i] : items)) return false;
	            }
	
	            return true;
	        }
	    }
	};
	
	/**
	 * Ensures that container[attribute] has a valid value.
	 *
	 * attributes[attribute] is an object with possible keys:
	 * - valType: data_array, enumerated, boolean, ... as in valObjectMeta
	 * - values: (enumerated only) array of allowed vals
	 * - min, max: (number, integer only) inclusive bounds on allowed vals
	 *      either or both may be omitted
	 * - dflt: if attribute is invalid or missing, use this default
	 *      if dflt is provided as an argument to lib.coerce it takes precedence
	 *      as a convenience, returns the value it finally set
	 */
	exports.coerce = function(containerIn, containerOut, attributes, attribute, dflt) {
	    var opts = nestedProperty(attributes, attribute).get();
	    var propIn = nestedProperty(containerIn, attribute);
	    var propOut = nestedProperty(containerOut, attribute);
	    var v = propIn.get();
	
	    var template = containerOut._template;
	    if(v === undefined && template) {
	        v = nestedProperty(template, attribute).get();
	        // already used the template value, so short-circuit the second check
	        template = 0;
	    }
	
	    if(dflt === undefined) dflt = opts.dflt;
	
	    /**
	     * arrayOk: value MAY be an array, then we do no value checking
	     * at this point, because it can be more complicated than the
	     * individual form (eg. some array vals can be numbers, even if the
	     * single values must be color strings)
	     */
	    if(opts.arrayOk && isArrayOrTypedArray(v)) {
	        propOut.set(v);
	        return v;
	    }
	
	    var coerceFunction = exports.valObjectMeta[opts.valType].coerceFunction;
	    coerceFunction(v, propOut, dflt, opts);
	
	    var out = propOut.get();
	    // in case v was provided but invalid, try the template again so it still
	    // overrides the regular default
	    if(template && out === dflt && !validate(v, opts)) {
	        v = nestedProperty(template, attribute).get();
	        coerceFunction(v, propOut, dflt, opts);
	        out = propOut.get();
	    }
	    return out;
	};
	
	/**
	 * Variation on coerce
	 *
	 * Uses coerce to get attribute value if user input is valid,
	 * returns attribute default if user input it not valid or
	 * returns false if there is no user input.
	 */
	exports.coerce2 = function(containerIn, containerOut, attributes, attribute, dflt) {
	    var propIn = nestedProperty(containerIn, attribute);
	    var propOut = exports.coerce(containerIn, containerOut, attributes, attribute, dflt);
	    var valIn = propIn.get();
	
	    return (valIn !== undefined && valIn !== null) ? propOut : false;
	};
	
	/*
	 * Shortcut to coerce the three font attributes
	 *
	 * 'coerce' is a lib.coerce wrapper with implied first three arguments
	 */
	exports.coerceFont = function(coerce, attr, dfltObj) {
	    var out = {};
	
	    dfltObj = dfltObj || {};
	
	    out.family = coerce(attr + '.family', dfltObj.family);
	    out.size = coerce(attr + '.size', dfltObj.size);
	    out.color = coerce(attr + '.color', dfltObj.color);
	
	    return out;
	};
	
	/** Coerce shortcut for 'hoverinfo'
	 * handling 1-vs-multi-trace dflt logic
	 *
	 * @param {object} traceIn : user trace object
	 * @param {object} traceOut : full trace object (requires _module ref)
	 * @param {object} layoutOut : full layout object (require _dataLength ref)
	 * @return {any} : the coerced value
	 */
	exports.coerceHoverinfo = function(traceIn, traceOut, layoutOut) {
	    var moduleAttrs = traceOut._module.attributes;
	    var attrs = moduleAttrs.hoverinfo ? moduleAttrs : baseTraceAttrs;
	
	    var valObj = attrs.hoverinfo;
	    var dflt;
	
	    if(layoutOut._dataLength === 1) {
	        var flags = valObj.dflt === 'all' ?
	            valObj.flags.slice() :
	            valObj.dflt.split('+');
	
	        flags.splice(flags.indexOf('name'), 1);
	        dflt = flags.join('+');
	    }
	
	    return exports.coerce(traceIn, traceOut, attrs, 'hoverinfo', dflt);
	};
	
	/** Coerce shortcut for [un]selected.marker.opacity,
	 *  which has special default logic, to ensure that it corresponds to the
	 *  default selection behavior while allowing to be overtaken by any other
	 *  [un]selected attribute.
	 *
	 *  N.B. This must be called *after* coercing all the other [un]selected attrs,
	 *  to give the intended result.
	 *
	 * @param {object} traceOut : fullData item
	 * @param {function} coerce : lib.coerce wrapper with implied first three arguments
	 */
	exports.coerceSelectionMarkerOpacity = function(traceOut, coerce) {
	    if(!traceOut.marker) return;
	
	    var mo = traceOut.marker.opacity;
	    // you can still have a `marker` container with no markers if there's text
	    if(mo === undefined) return;
	
	    var smoDflt;
	    var usmoDflt;
	
	    // Don't give [un]selected.marker.opacity a default value if
	    // marker.opacity is an array: handle this during style step.
	    //
	    // Only give [un]selected.marker.opacity a default value if you don't
	    // set any other [un]selected attributes.
	    if(!isArrayOrTypedArray(mo) && !traceOut.selected && !traceOut.unselected) {
	        smoDflt = mo;
	        usmoDflt = DESELECTDIM * mo;
	    }
	
	    coerce('selected.marker.opacity', smoDflt);
	    coerce('unselected.marker.opacity', usmoDflt);
	};
	
	function validate(value, opts) {
	    var valObjectDef = exports.valObjectMeta[opts.valType];
	
	    if(opts.arrayOk && isArrayOrTypedArray(value)) return true;
	
	    if(valObjectDef.validateFunction) {
	        return valObjectDef.validateFunction(value, opts);
	    }
	
	    var failed = {};
	    var out = failed;
	    var propMock = { set: function(v) { out = v; } };
	
	    // 'failed' just something mutable that won't be === anything else
	
	    valObjectDef.coerceFunction(value, propMock, failed, opts);
	    return out !== failed;
	}
	exports.validate = validate;
	
	},{"../components/colorscale/scales":606,"../constants/interactions":691,"../plots/attributes":761,"./array":699,"./mod":723,"./nested_property":724,"./regex":732,"fast-isnumeric":227,"tinycolor2":535}],704:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Loggers = _dereq_('./loggers');
	var mod = _dereq_('./mod').mod;
	
	var constants = _dereq_('../constants/numerical');
	var BADNUM = constants.BADNUM;
	var ONEDAY = constants.ONEDAY;
	var ONEHOUR = constants.ONEHOUR;
	var ONEMIN = constants.ONEMIN;
	var ONESEC = constants.ONESEC;
	var EPOCHJD = constants.EPOCHJD;
	
	var Registry = _dereq_('../registry');
	
	var utcFormat = d3.time.format.utc;
	
	var DATETIME_REGEXP = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d:?\d\d)?)?)?)?)?\s*$/m;
	// special regex for chinese calendars to support yyyy-mmi-dd etc for intercalary months
	var DATETIME_REGEXP_CN = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d:?\d\d)?)?)?)?)?\s*$/m;
	
	// for 2-digit years, the first year we map them onto
	var YFIRST = new Date().getFullYear() - 70;
	
	function isWorldCalendar(calendar) {
	    return (
	        calendar &&
	        Registry.componentsRegistry.calendars &&
	        typeof calendar === 'string' && calendar !== 'gregorian'
	    );
	}
	
	/*
	 * dateTick0: get the canonical tick for this calendar
	 *
	 * bool sunday is for week ticks, shift it to a Sunday.
	 */
	exports.dateTick0 = function(calendar, sunday) {
	    if(isWorldCalendar(calendar)) {
	        return sunday ?
	            Registry.getComponentMethod('calendars', 'CANONICAL_SUNDAY')[calendar] :
	            Registry.getComponentMethod('calendars', 'CANONICAL_TICK')[calendar];
	    } else {
	        return sunday ? '2000-01-02' : '2000-01-01';
	    }
	};
	
	/*
	 * dfltRange: for each calendar, give a valid default range
	 */
	exports.dfltRange = function(calendar) {
	    if(isWorldCalendar(calendar)) {
	        return Registry.getComponentMethod('calendars', 'DFLTRANGE')[calendar];
	    } else {
	        return ['2000-01-01', '2001-01-01'];
	    }
	};
	
	// is an object a javascript date?
	exports.isJSDate = function(v) {
	    return typeof v === 'object' && v !== null && typeof v.getTime === 'function';
	};
	
	// The absolute limits of our date-time system
	// This is a little weird: we use MIN_MS and MAX_MS in dateTime2ms
	// but we use dateTime2ms to calculate them (after defining it!)
	var MIN_MS, MAX_MS;
	
	/**
	 * dateTime2ms - turn a date object or string s into milliseconds
	 * (relative to 1970-01-01, per javascript standard)
	 * optional calendar (string) to use a non-gregorian calendar
	 *
	 * Returns BADNUM if it doesn't find a date
	 *
	 * strings should have the form:
	 *
	 *    -?YYYY-mm-dd<sep>HH:MM:SS.sss<tzInfo>?
	 *
	 * <sep>: space (our normal standard) or T or t (ISO-8601)
	 * <tzInfo>: Z, z, or [+\-]HH:?MM and we THROW IT AWAY
	 * this format comes from https://tools.ietf.org/html/rfc3339#section-5.6
	 * but we allow it even with a space as the separator
	 *
	 * May truncate after any full field, and sss can be any length
	 * even >3 digits, though javascript dates truncate to milliseconds,
	 * we keep as much as javascript numeric precision can hold, but we only
	 * report back up to 100 microsecond precision, because most dates support
	 * this precision (close to 1970 support more, very far away support less)
	 *
	 * Expanded to support negative years to -9999 but you must always
	 * give 4 digits, except for 2-digit positive years which we assume are
	 * near the present time.
	 * Note that we follow ISO 8601:2004: there *is* a year 0, which
	 * is 1BC/BCE, and -1===2BC etc.
	 *
	 * World calendars: not all of these *have* agreed extensions to this full range,
	 * if you have another calendar system but want a date range outside its validity,
	 * you can use a gregorian date string prefixed with 'G' or 'g'.
	 *
	 * Where to cut off 2-digit years between 1900s and 2000s?
	 * from http://support.microsoft.com/kb/244664:
	 *   1930-2029 (the most retro of all...)
	 * but in my mac chrome from eg. d=new Date(Date.parse('8/19/50')):
	 *   1950-2049
	 * by Java, from http://stackoverflow.com/questions/2024273/:
	 *   now-80 - now+19
	 * or FileMaker Pro, from
	 *      http://www.filemaker.com/12help/html/add_view_data.4.21.html:
	 *   now-70 - now+29
	 * but python strptime etc, via
	 *      http://docs.python.org/py3k/library/time.html:
	 *   1969-2068 (super forward-looking, but static, not sliding!)
	 *
	 * lets go with now-70 to now+29, and if anyone runs into this problem
	 * they can learn the hard way not to use 2-digit years, as no choice we
	 * make now will cover all possibilities. mostly this will all be taken
	 * care of in initial parsing, should only be an issue for hand-entered data
	 * currently (2016) this range is:
	 *   1946-2045
	 */
	exports.dateTime2ms = function(s, calendar) {
	    // first check if s is a date object
	    if(exports.isJSDate(s)) {
	        // Convert to the UTC milliseconds that give the same
	        // hours as this date has in the local timezone
	        var tzOffset = s.getTimezoneOffset() * ONEMIN;
	        var offsetTweak = (s.getUTCMinutes() - s.getMinutes()) * ONEMIN +
	            (s.getUTCSeconds() - s.getSeconds()) * ONESEC +
	            (s.getUTCMilliseconds() - s.getMilliseconds());
	
	        if(offsetTweak) {
	            var comb = 3 * ONEMIN;
	            tzOffset = tzOffset - comb / 2 + mod(offsetTweak - tzOffset + comb / 2, comb);
	        }
	        s = Number(s) - tzOffset;
	        if(s >= MIN_MS && s <= MAX_MS) return s;
	        return BADNUM;
	    }
	    // otherwise only accept strings and numbers
	    if(typeof s !== 'string' && typeof s !== 'number') return BADNUM;
	
	    s = String(s);
	
	    var isWorld = isWorldCalendar(calendar);
	
	    // to handle out-of-range dates in international calendars, accept
	    // 'G' as a prefix to force the built-in gregorian calendar.
	    var s0 = s.charAt(0);
	    if(isWorld && (s0 === 'G' || s0 === 'g')) {
	        s = s.substr(1);
	        calendar = '';
	    }
	
	    var isChinese = isWorld && calendar.substr(0, 7) === 'chinese';
	
	    var match = s.match(isChinese ? DATETIME_REGEXP_CN : DATETIME_REGEXP);
	    if(!match) return BADNUM;
	    var y = match[1];
	    var m = match[3] || '1';
	    var d = Number(match[5] || 1);
	    var H = Number(match[7] || 0);
	    var M = Number(match[9] || 0);
	    var S = Number(match[11] || 0);
	
	    if(isWorld) {
	        // disallow 2-digit years for world calendars
	        if(y.length === 2) return BADNUM;
	        y = Number(y);
	
	        var cDate;
	        try {
	            var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
	            if(isChinese) {
	                var isIntercalary = m.charAt(m.length - 1) === 'i';
	                m = parseInt(m, 10);
	                cDate = calInstance.newDate(y, calInstance.toMonthIndex(y, m, isIntercalary), d);
	            } else {
	                cDate = calInstance.newDate(y, Number(m), d);
	            }
	        } catch(e) { return BADNUM; } // Invalid ... date
	
	        if(!cDate) return BADNUM;
	
	        return ((cDate.toJD() - EPOCHJD) * ONEDAY) +
	            (H * ONEHOUR) + (M * ONEMIN) + (S * ONESEC);
	    }
	
	    if(y.length === 2) {
	        y = (Number(y) + 2000 - YFIRST) % 100 + YFIRST;
	    } else y = Number(y);
	
	    // new Date uses months from 0; subtract 1 here just so we
	    // don't have to do it again during the validity test below
	    m -= 1;
	
	    // javascript takes new Date(0..99,m,d) to mean 1900-1999, so
	    // to support years 0-99 we need to use setFullYear explicitly
	    // Note that 2000 is a leap year.
	    var date = new Date(Date.UTC(2000, m, d, H, M));
	    date.setUTCFullYear(y);
	
	    if(date.getUTCMonth() !== m) return BADNUM;
	    if(date.getUTCDate() !== d) return BADNUM;
	
	    return date.getTime() + S * ONESEC;
	};
	
	MIN_MS = exports.MIN_MS = exports.dateTime2ms('-9999');
	MAX_MS = exports.MAX_MS = exports.dateTime2ms('9999-12-31 23:59:59.9999');
	
	// is string s a date? (see above)
	exports.isDateTime = function(s, calendar) {
	    return (exports.dateTime2ms(s, calendar) !== BADNUM);
	};
	
	// pad a number with zeroes, to given # of digits before the decimal point
	function lpad(val, digits) {
	    return String(val + Math.pow(10, digits)).substr(1);
	}
	
	/**
	 * Turn ms into string of the form YYYY-mm-dd HH:MM:SS.ssss
	 * Crop any trailing zeros in time, except never stop right after hours
	 * (we could choose to crop '-01' from date too but for now we always
	 * show the whole date)
	 * Optional range r is the data range that applies, also in ms.
	 * If rng is big, the later parts of time will be omitted
	 */
	var NINETYDAYS = 90 * ONEDAY;
	var THREEHOURS = 3 * ONEHOUR;
	var FIVEMIN = 5 * ONEMIN;
	exports.ms2DateTime = function(ms, r, calendar) {
	    if(typeof ms !== 'number' || !(ms >= MIN_MS && ms <= MAX_MS)) return BADNUM;
	
	    if(!r) r = 0;
	
	    var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
	    var msRounded = Math.round(ms - msecTenths / 10);
	    var dateStr, h, m, s, msec10, d;
	
	    if(isWorldCalendar(calendar)) {
	        var dateJD = Math.floor(msRounded / ONEDAY) + EPOCHJD;
	        var timeMs = Math.floor(mod(ms, ONEDAY));
	        try {
	            dateStr = Registry.getComponentMethod('calendars', 'getCal')(calendar)
	                .fromJD(dateJD).formatDate('yyyy-mm-dd');
	        } catch(e) {
	            // invalid date in this calendar - fall back to Gyyyy-mm-dd
	            dateStr = utcFormat('G%Y-%m-%d')(new Date(msRounded));
	        }
	
	        // yyyy does NOT guarantee 4-digit years. YYYY mostly does, but does
	        // other things for a few calendars, so we can't trust it. Just pad
	        // it manually (after the '-' if there is one)
	        if(dateStr.charAt(0) === '-') {
	            while(dateStr.length < 11) dateStr = '-0' + dateStr.substr(1);
	        } else {
	            while(dateStr.length < 10) dateStr = '0' + dateStr;
	        }
	
	        // TODO: if this is faster, we could use this block for extracting
	        // the time components of regular gregorian too
	        h = (r < NINETYDAYS) ? Math.floor(timeMs / ONEHOUR) : 0;
	        m = (r < NINETYDAYS) ? Math.floor((timeMs % ONEHOUR) / ONEMIN) : 0;
	        s = (r < THREEHOURS) ? Math.floor((timeMs % ONEMIN) / ONESEC) : 0;
	        msec10 = (r < FIVEMIN) ? (timeMs % ONESEC) * 10 + msecTenths : 0;
	    } else {
	        d = new Date(msRounded);
	
	        dateStr = utcFormat('%Y-%m-%d')(d);
	
	        // <90 days: add hours and minutes - never *only* add hours
	        h = (r < NINETYDAYS) ? d.getUTCHours() : 0;
	        m = (r < NINETYDAYS) ? d.getUTCMinutes() : 0;
	        // <3 hours: add seconds
	        s = (r < THREEHOURS) ? d.getUTCSeconds() : 0;
	        // <5 minutes: add ms (plus one extra digit, this is msec*10)
	        msec10 = (r < FIVEMIN) ? d.getUTCMilliseconds() * 10 + msecTenths : 0;
	    }
	
	    return includeTime(dateStr, h, m, s, msec10);
	};
	
	// For converting old-style milliseconds to date strings,
	// we use the local timezone rather than UTC like we use
	// everywhere else, both for backward compatibility and
	// because that's how people mostly use javasript date objects.
	// Clip one extra day off our date range though so we can't get
	// thrown beyond the range by the timezone shift.
	exports.ms2DateTimeLocal = function(ms) {
	    if(!(ms >= MIN_MS + ONEDAY && ms <= MAX_MS - ONEDAY)) return BADNUM;
	
	    var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
	    var d = new Date(Math.round(ms - msecTenths / 10));
	    var dateStr = d3.time.format('%Y-%m-%d')(d);
	    var h = d.getHours();
	    var m = d.getMinutes();
	    var s = d.getSeconds();
	    var msec10 = d.getUTCMilliseconds() * 10 + msecTenths;
	
	    return includeTime(dateStr, h, m, s, msec10);
	};
	
	function includeTime(dateStr, h, m, s, msec10) {
	    // include each part that has nonzero data in or after it
	    if(h || m || s || msec10) {
	        dateStr += ' ' + lpad(h, 2) + ':' + lpad(m, 2);
	        if(s || msec10) {
	            dateStr += ':' + lpad(s, 2);
	            if(msec10) {
	                var digits = 4;
	                while(msec10 % 10 === 0) {
	                    digits -= 1;
	                    msec10 /= 10;
	                }
	                dateStr += '.' + lpad(msec10, digits);
	            }
	        }
	    }
	    return dateStr;
	}
	
	// normalize date format to date string, in case it starts as
	// a Date object or milliseconds
	// optional dflt is the return value if cleaning fails
	exports.cleanDate = function(v, dflt, calendar) {
	    // let us use cleanDate to provide a missing default without an error
	    if(v === BADNUM) return dflt;
	    if(exports.isJSDate(v) || (typeof v === 'number' && isFinite(v))) {
	        // do not allow milliseconds (old) or jsdate objects (inherently
	        // described as gregorian dates) with world calendars
	        if(isWorldCalendar(calendar)) {
	            Loggers.error('JS Dates and milliseconds are incompatible with world calendars', v);
	            return dflt;
	        }
	
	        // NOTE: if someone puts in a year as a number rather than a string,
	        // this will mistakenly convert it thinking it's milliseconds from 1970
	        // that is: '2012' -> Jan. 1, 2012, but 2012 -> 2012 epoch milliseconds
	        v = exports.ms2DateTimeLocal(+v);
	        if(!v && dflt !== undefined) return dflt;
	    } else if(!exports.isDateTime(v, calendar)) {
	        Loggers.error('unrecognized date', v);
	        return dflt;
	    }
	    return v;
	};
	
	/*
	 *  Date formatting for ticks and hovertext
	 */
	
	/*
	 * modDateFormat: Support world calendars, and add one item to
	 * d3's vocabulary:
	 * %{n}f where n is the max number of digits of fractional seconds
	 */
	var fracMatch = /%\d?f/g;
	function modDateFormat(fmt, x, formatter, calendar) {
	    fmt = fmt.replace(fracMatch, function(match) {
	        var digits = Math.min(+(match.charAt(1)) || 6, 6);
	        var fracSecs = ((x / 1000 % 1) + 2)
	            .toFixed(digits)
	            .substr(2).replace(/0+$/, '') || '0';
	        return fracSecs;
	    });
	
	    var d = new Date(Math.floor(x + 0.05));
	
	    if(isWorldCalendar(calendar)) {
	        try {
	            fmt = Registry.getComponentMethod('calendars', 'worldCalFmt')(fmt, x, calendar);
	        } catch(e) {
	            return 'Invalid';
	        }
	    }
	    return formatter(fmt)(d);
	}
	
	/*
	 * formatTime: create a time string from:
	 *   x: milliseconds
	 *   tr: tickround ('M', 'S', or # digits)
	 * only supports UTC times (where every day is 24 hours and 0 is at midnight)
	 */
	var MAXSECONDS = [59, 59.9, 59.99, 59.999, 59.9999];
	function formatTime(x, tr) {
	    var timePart = mod(x + 0.05, ONEDAY);
	
	    var timeStr = lpad(Math.floor(timePart / ONEHOUR), 2) + ':' +
	        lpad(mod(Math.floor(timePart / ONEMIN), 60), 2);
	
	    if(tr !== 'M') {
	        if(!isNumeric(tr)) tr = 0; // should only be 'S'
	
	        /*
	         * this is a weird one - and shouldn't come up unless people
	         * monkey with tick0 in weird ways, but we need to do something!
	         * IN PARTICULAR we had better not display garbage (see below)
	         * for numbers we always round to the nearest increment of the
	         * precision we're showing, and this seems like the right way to
	         * handle seconds and milliseconds, as they have a decimal point
	         * and people will interpret that to mean rounding like numbers.
	         * but for larger increments we floor the value: it's always
	         * 2013 until the ball drops on the new year. We could argue about
	         * which field it is where we start rounding (should 12:08:59
	         * round to 12:09 if we're stopping at minutes?) but for now I'll
	         * say we round seconds but floor everything else. BUT that means
	         * we need to never round up to 60 seconds, ie 23:59:60
	         */
	        var sec = Math.min(mod(x / ONESEC, 60), MAXSECONDS[tr]);
	
	        var secStr = (100 + sec).toFixed(tr).substr(1);
	        if(tr > 0) {
	            secStr = secStr.replace(/0+$/, '').replace(/[\.]$/, '');
	        }
	
	        timeStr += ':' + secStr;
	    }
	    return timeStr;
	}
	
	/*
	 * formatDate: turn a date into tick or hover label text.
	 *
	 *   x: milliseconds, the value to convert
	 *   fmt: optional, an explicit format string (d3 format, even for world calendars)
	 *   tr: tickround ('y', 'm', 'd', 'M', 'S', or # digits)
	 *      used if no explicit fmt is provided
	 *   formatter: locale-aware d3 date formatter for standard gregorian calendars
	 *      should be the result of exports.getD3DateFormat(gd)
	 *   calendar: optional string, the world calendar system to use
	 *
	 * returns the date/time as a string, potentially with the leading portion
	 * on a separate line (after '\n')
	 * Note that this means if you provide an explicit format which includes '\n'
	 * the axis may choose to strip things after it when they don't change from
	 * one tick to the next (as it does with automatic formatting)
	 */
	exports.formatDate = function(x, fmt, tr, formatter, calendar, extraFormat) {
	    calendar = isWorldCalendar(calendar) && calendar;
	
	    if(!fmt) {
	        if(tr === 'y') fmt = extraFormat.year;
	        else if(tr === 'm') fmt = extraFormat.month;
	        else if(tr === 'd') {
	            fmt = extraFormat.dayMonth + '\n' + extraFormat.year;
	        } else {
	            return formatTime(x, tr) + '\n' + modDateFormat(extraFormat.dayMonthYear, x, formatter, calendar);
	        }
	    }
	
	    return modDateFormat(fmt, x, formatter, calendar);
	};
	
	/*
	 * incrementMonth: make a new milliseconds value from the given one,
	 * having changed the month
	 *
	 * special case for world calendars: multiples of 12 are treated as years,
	 * even for calendar systems that don't have (always or ever) 12 months/year
	 * TODO: perhaps we need a different code for year increments to support this?
	 *
	 * ms (number): the initial millisecond value
	 * dMonth (int): the (signed) number of months to shift
	 * calendar (string): the calendar system to use
	 *
	 * changing month does not (and CANNOT) always preserve day, since
	 * months have different lengths. The worst example of this is:
	 *   d = new Date(1970,0,31); d.setMonth(1) -> Feb 31 turns into Mar 3
	 *
	 * But we want to be able to iterate over the last day of each month,
	 * regardless of what its number is.
	 * So shift 3 days forward, THEN set the new month, then unshift:
	 *   1/31 -> 2/28 (or 29) -> 3/31 -> 4/30 -> ...
	 *
	 * Note that odd behavior still exists if you start from the 26th-28th:
	 *   1/28 -> 2/28 -> 3/31
	 * but at least you can't shift any dates into the wrong month,
	 * and ticks on these days incrementing by month would be very unusual
	 */
	var THREEDAYS = 3 * ONEDAY;
	exports.incrementMonth = function(ms, dMonth, calendar) {
	    calendar = isWorldCalendar(calendar) && calendar;
	
	    // pull time out and operate on pure dates, then add time back at the end
	    // this gives maximum precision - not that we *normally* care if we're
	    // incrementing by month, but better to be safe!
	    var timeMs = mod(ms, ONEDAY);
	    ms = Math.round(ms - timeMs);
	
	    if(calendar) {
	        try {
	            var dateJD = Math.round(ms / ONEDAY) + EPOCHJD;
	            var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
	            var cDate = calInstance.fromJD(dateJD);
	
	            if(dMonth % 12) calInstance.add(cDate, dMonth, 'm');
	            else calInstance.add(cDate, dMonth / 12, 'y');
	
	            return (cDate.toJD() - EPOCHJD) * ONEDAY + timeMs;
	        } catch(e) {
	            Loggers.error('invalid ms ' + ms + ' in calendar ' + calendar);
	            // then keep going in gregorian even though the result will be 'Invalid'
	        }
	    }
	
	    var y = new Date(ms + THREEDAYS);
	    return y.setUTCMonth(y.getUTCMonth() + dMonth) + timeMs - THREEDAYS;
	};
	
	/*
	 * findExactDates: what fraction of data is exact days, months, or years?
	 *
	 * data: array of millisecond values
	 * calendar (string) the calendar to test against
	 */
	exports.findExactDates = function(data, calendar) {
	    var exactYears = 0;
	    var exactMonths = 0;
	    var exactDays = 0;
	    var blankCount = 0;
	    var d;
	    var di;
	
	    var calInstance = (
	        isWorldCalendar(calendar) &&
	        Registry.getComponentMethod('calendars', 'getCal')(calendar)
	    );
	
	    for(var i = 0; i < data.length; i++) {
	        di = data[i];
	
	        // not date data at all
	        if(!isNumeric(di)) {
	            blankCount ++;
	            continue;
	        }
	
	        // not an exact date
	        if(di % ONEDAY) continue;
	
	        if(calInstance) {
	            try {
	                d = calInstance.fromJD(di / ONEDAY + EPOCHJD);
	                if(d.day() === 1) {
	                    if(d.month() === 1) exactYears++;
	                    else exactMonths++;
	                } else exactDays++;
	            } catch(e) {
	                // invalid date in this calendar - ignore it here.
	            }
	        } else {
	            d = new Date(di);
	            if(d.getUTCDate() === 1) {
	                if(d.getUTCMonth() === 0) exactYears++;
	                else exactMonths++;
	            } else exactDays++;
	        }
	    }
	    exactMonths += exactYears;
	    exactDays += exactMonths;
	
	    var dataCount = data.length - blankCount;
	
	    return {
	        exactYears: exactYears / dataCount,
	        exactMonths: exactMonths / dataCount,
	        exactDays: exactDays / dataCount
	    };
	};
	
	},{"../constants/numerical":692,"../registry":845,"./loggers":720,"./mod":723,"d3":164,"fast-isnumeric":227}],705:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var loggers = _dereq_('./loggers');
	
	/**
	 * Allow referencing a graph DOM element either directly
	 * or by its id string
	 *
	 * @param {HTMLDivElement|string} gd: a graph element or its id
	 *
	 * @returns {HTMLDivElement} the DOM element of the graph
	 */
	function getGraphDiv(gd) {
	    var gdElement;
	
	    if(typeof gd === 'string') {
	        gdElement = document.getElementById(gd);
	
	        if(gdElement === null) {
	            throw new Error('No DOM element with id \'' + gd + '\' exists on the page.');
	        }
	
	        return gdElement;
	    } else if(gd === null || gd === undefined) {
	        throw new Error('DOM element provided is null or undefined');
	    }
	
	    // otherwise assume that gd is a DOM element
	    return gd;
	}
	
	function isPlotDiv(el) {
	    var el3 = d3.select(el);
	    return el3.node() instanceof HTMLElement &&
	        el3.size() &&
	        el3.classed('js-plotly-plot');
	}
	
	function removeElement(el) {
	    var elParent = el && el.parentNode;
	    if(elParent) elParent.removeChild(el);
	}
	
	/**
	 * for dynamically adding style rules
	 * makes one stylesheet that contains all rules added
	 * by all calls to this function
	 */
	function addStyleRule(selector, styleString) {
	    addRelatedStyleRule('global', selector, styleString);
	}
	
	/**
	 * for dynamically adding style rules
	 * to a stylesheet uniquely identified by a uid
	 */
	function addRelatedStyleRule(uid, selector, styleString) {
	    var id = 'plotly.js-style-' + uid;
	    var style = document.getElementById(id);
	    if(!style) {
	        style = document.createElement('style');
	        style.setAttribute('id', id);
	        // WebKit hack :(
	        style.appendChild(document.createTextNode(''));
	        document.head.appendChild(style);
	    }
	    var styleSheet = style.sheet;
	
	    if(styleSheet.insertRule) {
	        styleSheet.insertRule(selector + '{' + styleString + '}', 0);
	    } else if(styleSheet.addRule) {
	        styleSheet.addRule(selector, styleString, 0);
	    } else loggers.warn('addStyleRule failed');
	}
	
	/**
	 * to remove from the page a stylesheet identified by a given uid
	 */
	function deleteRelatedStyleRule(uid) {
	    var id = 'plotly.js-style-' + uid;
	    var style = document.getElementById(id);
	    if(style) removeElement(style);
	}
	
	module.exports = {
	    getGraphDiv: getGraphDiv,
	    isPlotDiv: isPlotDiv,
	    removeElement: removeElement,
	    addStyleRule: addStyleRule,
	    addRelatedStyleRule: addRelatedStyleRule,
	    deleteRelatedStyleRule: deleteRelatedStyleRule
	};
	
	},{"./loggers":720,"d3":164}],706:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	/* global jQuery:false */
	
	var EventEmitter = _dereq_('events').EventEmitter;
	
	var Events = {
	
	    init: function(plotObj) {
	        /*
	         * If we have already instantiated an emitter for this plot
	         * return early.
	         */
	        if(plotObj._ev instanceof EventEmitter) return plotObj;
	
	        var ev = new EventEmitter();
	        var internalEv = new EventEmitter();
	
	        /*
	         * Assign to plot._ev while we still live in a land
	         * where plot is a DOM element with stuff attached to it.
	         * In the future we can make plot the event emitter itself.
	         */
	        plotObj._ev = ev;
	
	        /*
	         * Create a second event handler that will manage events *internally*.
	         * This allows parts of plotly to respond to thing like relayout without
	         * having to use the user-facing event handler. They cannot peacefully
	         * coexist on the same handler because a user invoking
	         * plotObj.removeAllListeners() would detach internal events, breaking
	         * plotly.
	         */
	        plotObj._internalEv = internalEv;
	
	        /*
	         * Assign bound methods from the ev to the plot object. These methods
	         * will reference the 'this' of plot._ev even though they are methods
	         * of plot. This will keep the event machinery away from the plot object
	         * which currently is often a DOM element but presents an API that will
	         * continue to function when plot becomes an emitter. Not all EventEmitter
	         * methods have been bound to `plot` as some do not currently add value to
	         * the Plotly event API.
	         */
	        plotObj.on = ev.on.bind(ev);
	        plotObj.once = ev.once.bind(ev);
	        plotObj.removeListener = ev.removeListener.bind(ev);
	        plotObj.removeAllListeners = ev.removeAllListeners.bind(ev);
	
	        /*
	         * Create functions for managing internal events. These are *only* triggered
	         * by the mirroring of external events via the emit function.
	         */
	        plotObj._internalOn = internalEv.on.bind(internalEv);
	        plotObj._internalOnce = internalEv.once.bind(internalEv);
	        plotObj._removeInternalListener = internalEv.removeListener.bind(internalEv);
	        plotObj._removeAllInternalListeners = internalEv.removeAllListeners.bind(internalEv);
	
	        /*
	         * We must wrap emit to continue to support JQuery events. The idea
	         * is to check to see if the user is using JQuery events, if they are
	         * we emit JQuery events to trigger user handlers as well as the EventEmitter
	         * events.
	         */
	        plotObj.emit = function(event, data) {
	            if(typeof jQuery !== 'undefined') {
	                jQuery(plotObj).trigger(event, data);
	            }
	
	            ev.emit(event, data);
	            internalEv.emit(event, data);
	        };
	
	        return plotObj;
	    },
	
	    /*
	     * This function behaves like jQuery's triggerHandler. It calls
	     * all handlers for a particular event and returns the return value
	     * of the LAST handler. This function also triggers jQuery's
	     * triggerHandler for backwards compatibility.
	     */
	    triggerHandler: function(plotObj, event, data) {
	        var jQueryHandlerValue;
	        var nodeEventHandlerValue;
	
	        /*
	         * If jQuery exists run all its handlers for this event and
	         * collect the return value of the LAST handler function
	         */
	        if(typeof jQuery !== 'undefined') {
	            jQueryHandlerValue = jQuery(plotObj).triggerHandler(event, data);
	        }
	
	        /*
	         * Now run all the node style event handlers
	         */
	        var ev = plotObj._ev;
	        if(!ev) return jQueryHandlerValue;
	
	        var handlers = ev._events[event];
	        if(!handlers) return jQueryHandlerValue;
	
	        // making sure 'this' is the EventEmitter instance
	        function apply(handler) {
	            // The 'once' case, we can't just call handler() as we need
	            // the return value here. So,
	            // - remove handler
	            // - call listener and grab return value!
	            // - stash 'fired' key to not call handler twice
	            if(handler.listener) {
	                ev.removeListener(event, handler.listener);
	                if(!handler.fired) {
	                    handler.fired = true;
	                    return handler.listener.apply(ev, [data]);
	                }
	            } else {
	                return handler.apply(ev, [data]);
	            }
	        }
	
	        // handlers can be function or an array of functions
	        handlers = Array.isArray(handlers) ? handlers : [handlers];
	
	        var i;
	        for(i = 0; i < handlers.length - 1; i++) {
	            apply(handlers[i]);
	        }
	        // now call the final handler and collect its value
	        nodeEventHandlerValue = apply(handlers[i]);
	
	        /*
	         * Return either the jQuery handler value if it exists or the
	         * nodeEventHandler value. jQuery event value supersedes nodejs
	         * events for backwards compatibility reasons.
	         */
	        return jQueryHandlerValue !== undefined ?
	            jQueryHandlerValue :
	            nodeEventHandlerValue;
	    },
	
	    purge: function(plotObj) {
	        delete plotObj._ev;
	        delete plotObj.on;
	        delete plotObj.once;
	        delete plotObj.removeListener;
	        delete plotObj.removeAllListeners;
	        delete plotObj.emit;
	
	        delete plotObj._ev;
	        delete plotObj._internalEv;
	        delete plotObj._internalOn;
	        delete plotObj._internalOnce;
	        delete plotObj._removeInternalListener;
	        delete plotObj._removeAllInternalListeners;
	
	        return plotObj;
	    }
	
	};
	
	module.exports = Events;
	
	},{"events":105}],707:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isPlainObject = _dereq_('./is_plain_object.js');
	var isArray = Array.isArray;
	
	function primitivesLoopSplice(source, target) {
	    var i, value;
	    for(i = 0; i < source.length; i++) {
	        value = source[i];
	        if(value !== null && typeof(value) === 'object') {
	            return false;
	        }
	        if(value !== void(0)) {
	            target[i] = value;
	        }
	    }
	    return true;
	}
	
	exports.extendFlat = function() {
	    return _extend(arguments, false, false, false);
	};
	
	exports.extendDeep = function() {
	    return _extend(arguments, true, false, false);
	};
	
	exports.extendDeepAll = function() {
	    return _extend(arguments, true, true, false);
	};
	
	exports.extendDeepNoArrays = function() {
	    return _extend(arguments, true, false, true);
	};
	
	/*
	 * Inspired by https://github.com/justmoon/node-extend/blob/master/index.js
	 * All credit to the jQuery authors for perfecting this amazing utility.
	 *
	 * API difference with jQuery version:
	 * - No optional boolean (true -> deep extend) first argument,
	 *   use `extendFlat` for first-level only extend and
	 *   use `extendDeep` for a deep extend.
	 *
	 * Other differences with jQuery version:
	 * - Uses a modern (and faster) isPlainObject routine.
	 * - Expected to work with object {} and array [] arguments only.
	 * - Does not check for circular structure.
	 *   FYI: jQuery only does a check across one level.
	 *   Warning: this might result in infinite loops.
	 *
	 */
	function _extend(inputs, isDeep, keepAllKeys, noArrayCopies) {
	    var target = inputs[0];
	    var length = inputs.length;
	
	    var input, key, src, copy, copyIsArray, clone, allPrimitives;
	
	    // TODO does this do the right thing for typed arrays?
	
	    if(length === 2 && isArray(target) && isArray(inputs[1]) && target.length === 0) {
	        allPrimitives = primitivesLoopSplice(inputs[1], target);
	
	        if(allPrimitives) {
	            return target;
	        } else {
	            target.splice(0, target.length); // reset target and continue to next block
	        }
	    }
	
	    for(var i = 1; i < length; i++) {
	        input = inputs[i];
	
	        for(key in input) {
	            src = target[key];
	            copy = input[key];
	
	            if(noArrayCopies && isArray(copy)) {
	                // Stop early and just transfer the array if array copies are disallowed:
	
	                target[key] = copy;
	            } else if(isDeep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
	                // recurse if we're merging plain objects or arrays
	
	                if(copyIsArray) {
	                    copyIsArray = false;
	                    clone = src && isArray(src) ? src : [];
	                } else {
	                    clone = src && isPlainObject(src) ? src : {};
	                }
	
	                // never move original objects, clone them
	                target[key] = _extend([clone, copy], isDeep, keepAllKeys, noArrayCopies);
	            } else if(typeof copy !== 'undefined' || keepAllKeys) {
	                // don't bring in undefined values, except for extendDeepAll
	
	                target[key] = copy;
	            }
	        }
	    }
	
	    return target;
	}
	
	},{"./is_plain_object.js":717}],708:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	/**
	 * Return news array containing only the unique items
	 * found in input array.
	 *
	 * IMPORTANT: Note that items are considered unique
	 * if `String({})` is unique. For example;
	 *
	 *  Lib.filterUnique([ { a: 1 }, { b: 2 } ])
	 *
	 *  returns [{ a: 1 }]
	 *
	 * and
	 *
	 *  Lib.filterUnique([ '1', 1 ])
	 *
	 *  returns ['1']
	 *
	 *
	 * @param {array} array base array
	 * @return {array} new filtered array
	 */
	module.exports = function filterUnique(array) {
	    var seen = {};
	    var out = [];
	    var j = 0;
	
	    for(var i = 0; i < array.length; i++) {
	        var item = array[i];
	
	        if(seen[item] !== 1) {
	            seen[item] = 1;
	            out[j++] = item;
	        }
	    }
	
	    return out;
	};
	
	},{}],709:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/** Filter out object items with visible !== true
	 *  insider array container.
	 *
	 *  @param {array of objects} container
	 *  @return {array of objects} of length <= container
	 *
	 */
	module.exports = function filterVisible(container) {
	    var filterFn = isCalcData(container) ? calcDataFilter : baseFilter;
	    var out = [];
	
	    for(var i = 0; i < container.length; i++) {
	        var item = container[i];
	        if(filterFn(item)) out.push(item);
	    }
	
	    return out;
	};
	
	function baseFilter(item) {
	    return item.visible === true;
	}
	
	function calcDataFilter(item) {
	    var trace = item[0].trace;
	    return trace.visible === true && trace._length !== 0;
	}
	
	function isCalcData(cont) {
	    return (
	        Array.isArray(cont) &&
	        Array.isArray(cont[0]) &&
	        cont[0][0] &&
	        cont[0][0].trace
	    );
	}
	
	},{}],710:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var countryRegex = _dereq_('country-regex');
	var Lib = _dereq_('../lib');
	
	// make list of all country iso3 ids from at runtime
	var countryIds = Object.keys(countryRegex);
	
	var locationmodeToIdFinder = {
	    'ISO-3': Lib.identity,
	    'USA-states': Lib.identity,
	    'country names': countryNameToISO3
	};
	
	function countryNameToISO3(countryName) {
	    for(var i = 0; i < countryIds.length; i++) {
	        var iso3 = countryIds[i];
	        var regex = new RegExp(countryRegex[iso3]);
	
	        if(regex.test(countryName.trim().toLowerCase())) return iso3;
	    }
	
	    Lib.log('Unrecognized country name: ' + countryName + '.');
	
	    return false;
	}
	
	function locationToFeature(locationmode, location, features) {
	    if(!location || typeof location !== 'string') return false;
	
	    var locationId = locationmodeToIdFinder[locationmode](location);
	    var filteredFeatures;
	    var f, i;
	
	    if(locationId) {
	        if(locationmode === 'USA-states') {
	            // Filter out features out in USA
	            //
	            // This is important as the Natural Earth files
	            // include state/provinces from USA, Canada, Australia and Brazil
	            // which have some overlay in their two-letter ids. For example,
	            // 'WA' is used for both Washington state and Western Australia.
	            filteredFeatures = [];
	            for(i = 0; i < features.length; i++) {
	                f = features[i];
	                if(f.properties && f.properties.gu && f.properties.gu === 'USA') {
	                    filteredFeatures.push(f);
	                }
	            }
	        } else {
	            filteredFeatures = features;
	        }
	
	        for(i = 0; i < filteredFeatures.length; i++) {
	            f = filteredFeatures[i];
	            if(f.id === locationId) return f;
	        }
	
	        Lib.log([
	            'Location with id', locationId,
	            'does not have a matching topojson feature at this resolution.'
	        ].join(' '));
	    }
	
	    return false;
	}
	
	module.exports = {
	    locationToFeature: locationToFeature
	};
	
	},{"../lib":716,"country-regex":135}],711:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var BADNUM = _dereq_('../constants/numerical').BADNUM;
	
	/**
	 * Convert calcTrace to GeoJSON 'MultiLineString' coordinate arrays
	 *
	 * @param {object} calcTrace
	 *  gd.calcdata item.
	 *  Note that calcTrace[i].lonlat is assumed to be defined
	 *
	 * @return {array}
	 *  return line coords array (or array of arrays)
	 *
	 */
	exports.calcTraceToLineCoords = function(calcTrace) {
	    var trace = calcTrace[0].trace;
	    var connectgaps = trace.connectgaps;
	
	    var coords = [];
	    var lineString = [];
	
	    for(var i = 0; i < calcTrace.length; i++) {
	        var calcPt = calcTrace[i];
	        var lonlat = calcPt.lonlat;
	
	        if(lonlat[0] !== BADNUM) {
	            lineString.push(lonlat);
	        } else if(!connectgaps && lineString.length > 0) {
	            coords.push(lineString);
	            lineString = [];
	        }
	    }
	
	    if(lineString.length > 0) {
	        coords.push(lineString);
	    }
	
	    return coords;
	};
	
	
	/**
	 * Make line ('LineString' or 'MultiLineString') GeoJSON
	 *
	 * @param {array} coords
	 *  results form calcTraceToLineCoords
	 * @return {object} out
	 *  GeoJSON object
	 *
	 */
	exports.makeLine = function(coords) {
	    if(coords.length === 1) {
	        return {
	            type: 'LineString',
	            coordinates: coords[0]
	        };
	    } else {
	        return {
	            type: 'MultiLineString',
	            coordinates: coords
	        };
	    }
	};
	
	/**
	 * Make polygon ('Polygon' or 'MultiPolygon') GeoJSON
	 *
	 * @param {array} coords
	 *  results form calcTraceToLineCoords
	 * @return {object} out
	 *  GeoJSON object
	 */
	exports.makePolygon = function(coords) {
	    if(coords.length === 1) {
	        return {
	            type: 'Polygon',
	            coordinates: coords
	        };
	    } else {
	        var _coords = new Array(coords.length);
	
	        for(var i = 0; i < coords.length; i++) {
	            _coords[i] = [coords[i]];
	        }
	
	        return {
	            type: 'MultiPolygon',
	            coordinates: _coords
	        };
	    }
	};
	
	/**
	 * Make blank GeoJSON
	 *
	 * @return {object}
	 *  Blank GeoJSON object
	 *
	 */
	exports.makeBlank = function() {
	    return {
	        type: 'Point',
	        coordinates: []
	    };
	};
	
	},{"../constants/numerical":692}],712:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var mod = _dereq_('./mod').mod;
	
	/*
	 * look for intersection of two line segments
	 *   (1->2 and 3->4) - returns array [x,y] if they do, null if not
	 */
	exports.segmentsIntersect = segmentsIntersect;
	function segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	    var a = x2 - x1;
	    var b = x3 - x1;
	    var c = x4 - x3;
	    var d = y2 - y1;
	    var e = y3 - y1;
	    var f = y4 - y3;
	    var det = a * f - c * d;
	    // parallel lines? intersection is undefined
	    // ignore the case where they are colinear
	    if(det === 0) return null;
	    var t = (b * f - c * e) / det;
	    var u = (b * d - a * e) / det;
	    // segments do not intersect?
	    if(u < 0 || u > 1 || t < 0 || t > 1) return null;
	
	    return {x: x1 + a * t, y: y1 + d * t};
	}
	
	/*
	 * find the minimum distance between two line segments (1->2 and 3->4)
	 */
	exports.segmentDistance = function segmentDistance(x1, y1, x2, y2, x3, y3, x4, y4) {
	    if(segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4)) return 0;
	
	    // the two segments and their lengths squared
	    var x12 = x2 - x1;
	    var y12 = y2 - y1;
	    var x34 = x4 - x3;
	    var y34 = y4 - y3;
	    var ll12 = x12 * x12 + y12 * y12;
	    var ll34 = x34 * x34 + y34 * y34;
	
	    // calculate distance squared, then take the sqrt at the very end
	    var dist2 = Math.min(
	        perpDistance2(x12, y12, ll12, x3 - x1, y3 - y1),
	        perpDistance2(x12, y12, ll12, x4 - x1, y4 - y1),
	        perpDistance2(x34, y34, ll34, x1 - x3, y1 - y3),
	        perpDistance2(x34, y34, ll34, x2 - x3, y2 - y3)
	    );
	
	    return Math.sqrt(dist2);
	};
	
	/*
	 * distance squared from segment ab to point c
	 * [xab, yab] is the vector b-a
	 * [xac, yac] is the vector c-a
	 * llab is the length squared of (b-a), just to simplify calculation
	 */
	function perpDistance2(xab, yab, llab, xac, yac) {
	    var fcAB = (xac * xab + yac * yab);
	    if(fcAB < 0) {
	        // point c is closer to point a
	        return xac * xac + yac * yac;
	    } else if(fcAB > llab) {
	        // point c is closer to point b
	        var xbc = xac - xab;
	        var ybc = yac - yab;
	        return xbc * xbc + ybc * ybc;
	    } else {
	        // perpendicular distance is the shortest
	        var crossProduct = xac * yab - yac * xab;
	        return crossProduct * crossProduct / llab;
	    }
	}
	
	// a very short-term cache for getTextLocation, just because
	// we're often looping over the same locations multiple times
	// invalidated as soon as we look at a different path
	var locationCache, workingPath, workingTextWidth;
	
	// turn a path and position along it into x, y, and angle for the given text
	exports.getTextLocation = function getTextLocation(path, totalPathLen, positionOnPath, textWidth) {
	    if(path !== workingPath || textWidth !== workingTextWidth) {
	        locationCache = {};
	        workingPath = path;
	        workingTextWidth = textWidth;
	    }
	    if(locationCache[positionOnPath]) {
	        return locationCache[positionOnPath];
	    }
	
	    // for the angle, use points on the path separated by the text width
	    // even though due to curvature, the text will cover a bit more than that
	    var p0 = path.getPointAtLength(mod(positionOnPath - textWidth / 2, totalPathLen));
	    var p1 = path.getPointAtLength(mod(positionOnPath + textWidth / 2, totalPathLen));
	    // note: atan handles 1/0 nicely
	    var theta = Math.atan((p1.y - p0.y) / (p1.x - p0.x));
	    // center the text at 2/3 of the center position plus 1/3 the p0/p1 midpoint
	    // that's the average position of this segment, assuming it's roughly quadratic
	    var pCenter = path.getPointAtLength(mod(positionOnPath, totalPathLen));
	    var x = (pCenter.x * 4 + p0.x + p1.x) / 6;
	    var y = (pCenter.y * 4 + p0.y + p1.y) / 6;
	
	    var out = {x: x, y: y, theta: theta};
	    locationCache[positionOnPath] = out;
	    return out;
	};
	
	exports.clearLocationCache = function() {
	    workingPath = null;
	};
	
	/*
	 * Find the segment of `path` that's within the visible area
	 * given by `bounds` {left, right, top, bottom}, to within a
	 * precision of `buffer` px
	 *
	 * returns: undefined if nothing is visible, else object:
	 * {
	 *   min: position where the path first enters bounds, or 0 if it
	 *        starts within bounds
	 *   max: position where the path last exits bounds, or the path length
	 *        if it finishes within bounds
	 *   len: max - min, ie the length of visible path
	 *   total: the total path length - just included so the caller doesn't
	 *        need to call path.getTotalLength() again
	 *   isClosed: true iff the start and end points of the path are both visible
	 *        and are at the same point
	 * }
	 *
	 * Works by starting from either end and repeatedly finding the distance from
	 * that point to the plot area, and if it's outside the plot, moving along the
	 * path by that distance (because the plot must be at least that far away on
	 * the path). Note that if a path enters, exits, and re-enters the plot, we
	 * will not capture this behavior.
	 */
	exports.getVisibleSegment = function getVisibleSegment(path, bounds, buffer) {
	    var left = bounds.left;
	    var right = bounds.right;
	    var top = bounds.top;
	    var bottom = bounds.bottom;
	
	    var pMin = 0;
	    var pTotal = path.getTotalLength();
	    var pMax = pTotal;
	
	    var pt0, ptTotal;
	
	    function getDistToPlot(len) {
	        var pt = path.getPointAtLength(len);
	
	        // hold on to the start and end points for `closed`
	        if(len === 0) pt0 = pt;
	        else if(len === pTotal) ptTotal = pt;
	
	        var dx = (pt.x < left) ? left - pt.x : (pt.x > right ? pt.x - right : 0);
	        var dy = (pt.y < top) ? top - pt.y : (pt.y > bottom ? pt.y - bottom : 0);
	        return Math.sqrt(dx * dx + dy * dy);
	    }
	
	    var distToPlot = getDistToPlot(pMin);
	    while(distToPlot) {
	        pMin += distToPlot + buffer;
	        if(pMin > pMax) return;
	        distToPlot = getDistToPlot(pMin);
	    }
	
	    distToPlot = getDistToPlot(pMax);
	    while(distToPlot) {
	        pMax -= distToPlot + buffer;
	        if(pMin > pMax) return;
	        distToPlot = getDistToPlot(pMax);
	    }
	
	    return {
	        min: pMin,
	        max: pMax,
	        len: pMax - pMin,
	        total: pTotal,
	        isClosed: pMin === 0 && pMax === pTotal &&
	            Math.abs(pt0.x - ptTotal.x) < 0.1 &&
	            Math.abs(pt0.y - ptTotal.y) < 0.1
	    };
	};
	
	/**
	 * Find point on SVG path corresponding to a given constraint coordinate
	 *
	 * @param {SVGPathElement} path
	 * @param {Number} val : constraint coordinate value
	 * @param {String} coord : 'x' or 'y' the constraint coordinate
	 * @param {Object} opts :
	 *  - {Number} pathLength : supply total path length before hand
	 *  - {Number} tolerance
	 *  - {Number} iterationLimit
	 * @return {SVGPoint}
	 */
	exports.findPointOnPath = function findPointOnPath(path, val, coord, opts) {
	    opts = opts || {};
	
	    var pathLength = opts.pathLength || path.getTotalLength();
	    var tolerance = opts.tolerance || 1e-3;
	    var iterationLimit = opts.iterationLimit || 30;
	
	    // if path starts at a val greater than the path tail (like on vertical violins),
	    // we must flip the sign of the computed diff.
	    var mul = path.getPointAtLength(0)[coord] > path.getPointAtLength(pathLength)[coord] ? -1 : 1;
	
	    var i = 0;
	    var b0 = 0;
	    var b1 = pathLength;
	    var mid;
	    var pt;
	    var diff;
	
	    while(i < iterationLimit) {
	        mid = (b0 + b1) / 2;
	        pt = path.getPointAtLength(mid);
	        diff = pt[coord] - val;
	
	        if(Math.abs(diff) < tolerance) {
	            return pt;
	        } else {
	            if(mul * diff > 0) {
	                b1 = mid;
	            } else {
	                b0 = mid;
	            }
	            i++;
	        }
	    }
	    return pt;
	};
	
	},{"./mod":723}],713:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var tinycolor = _dereq_('tinycolor2');
	var rgba = _dereq_('color-normalize');
	
	var Colorscale = _dereq_('../components/colorscale');
	var colorDflt = _dereq_('../components/color/attributes').defaultLine;
	var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
	
	var colorDfltRgba = rgba(colorDflt);
	var opacityDflt = 1;
	
	function calculateColor(colorIn, opacityIn) {
	    var colorOut = colorIn;
	    colorOut[3] *= opacityIn;
	    return colorOut;
	}
	
	function validateColor(colorIn) {
	    if(isNumeric(colorIn)) return colorDfltRgba;
	
	    var colorOut = rgba(colorIn);
	
	    return colorOut.length ? colorOut : colorDfltRgba;
	}
	
	function validateOpacity(opacityIn) {
	    return isNumeric(opacityIn) ? opacityIn : opacityDflt;
	}
	
	function formatColor(containerIn, opacityIn, len) {
	    var colorIn = containerIn.color;
	    var isArrayColorIn = isArrayOrTypedArray(colorIn);
	    var isArrayOpacityIn = isArrayOrTypedArray(opacityIn);
	    var cOpts = Colorscale.extractOpts(containerIn);
	    var colorOut = [];
	
	    var sclFunc, getColor, getOpacity, colori, opacityi;
	
	    if(cOpts.colorscale !== undefined) {
	        sclFunc = Colorscale.makeColorScaleFuncFromTrace(containerIn);
	    } else {
	        sclFunc = validateColor;
	    }
	
	    if(isArrayColorIn) {
	        getColor = function(c, i) {
	            // FIXME: there is double work, considering that sclFunc does the opposite
	            return c[i] === undefined ? colorDfltRgba : rgba(sclFunc(c[i]));
	        };
	    } else getColor = validateColor;
	
	    if(isArrayOpacityIn) {
	        getOpacity = function(o, i) {
	            return o[i] === undefined ? opacityDflt : validateOpacity(o[i]);
	        };
	    } else getOpacity = validateOpacity;
	
	    if(isArrayColorIn || isArrayOpacityIn) {
	        for(var i = 0; i < len; i++) {
	            colori = getColor(colorIn, i);
	            opacityi = getOpacity(opacityIn, i);
	            colorOut[i] = calculateColor(colori, opacityi);
	        }
	    } else colorOut = calculateColor(rgba(colorIn), opacityIn);
	
	    return colorOut;
	}
	
	function parseColorScale(cont, alpha) {
	    if(alpha === undefined) alpha = 1;
	
	    var cOpts = Colorscale.extractOpts(cont);
	
	    var colorscale = cOpts.reversescale ?
	        Colorscale.flipScale(cOpts.colorscale) :
	        cOpts.colorscale;
	
	    return colorscale.map(function(elem) {
	        var index = elem[0];
	        var color = tinycolor(elem[1]);
	        var rgb = color.toRgb();
	        return {
	            index: index,
	            rgb: [rgb.r, rgb.g, rgb.b, alpha]
	        };
	    });
	}
	
	module.exports = {
	    formatColor: formatColor,
	    parseColorScale: parseColorScale
	};
	
	},{"../components/color/attributes":590,"../components/colorscale":603,"./array":699,"color-normalize":121,"fast-isnumeric":227,"tinycolor2":535}],714:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var identity = _dereq_('./identity');
	
	function wrap(d) {return [d];}
	
	module.exports = {
	
	    // The D3 data binding concept and the General Update Pattern promotes the idea of
	    // traversing into the scenegraph by using the `.data(fun, keyFun)` call.
	    // The `fun` is most often a `repeat`, ie. the elements beneath a `<g>` element need
	    // access to the same data, or a `descend`, which fans a scenegraph node into a bunch of
	    // of elements, e.g. points, lines, rows, requiring an array as input.
	    // The role of the `keyFun` is to identify what elements are being entered/exited/updated,
	    // otherwise D3 reverts to using a plain index which would screw up `transition`s.
	    keyFun: function(d) {return d.key;},
	    repeat: wrap,
	    descend: identity,
	
	    // Plotly.js uses a convention of storing the actual contents of the `calcData` as the
	    // element zero of a container array. These helpers are just used for clarity as a
	    // newcomer to the codebase may not know what the `[0]` is, and whether there can be further
	    // elements (not atm).
	    wrap: wrap,
	    unwrap: function(d) {return d[0];}
	};
	
	},{"./identity":715}],715:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// Simple helper functions
	// none of these need any external deps
	
	module.exports = function identity(d) { return d; };
	
	},{}],716:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var numConstants = _dereq_('../constants/numerical');
	var FP_SAFE = numConstants.FP_SAFE;
	var BADNUM = numConstants.BADNUM;
	
	var lib = module.exports = {};
	
	lib.nestedProperty = _dereq_('./nested_property');
	lib.keyedContainer = _dereq_('./keyed_container');
	lib.relativeAttr = _dereq_('./relative_attr');
	lib.isPlainObject = _dereq_('./is_plain_object');
	lib.toLogRange = _dereq_('./to_log_range');
	lib.relinkPrivateKeys = _dereq_('./relink_private');
	
	var arrayModule = _dereq_('./array');
	lib.isTypedArray = arrayModule.isTypedArray;
	lib.isArrayOrTypedArray = arrayModule.isArrayOrTypedArray;
	lib.isArray1D = arrayModule.isArray1D;
	lib.ensureArray = arrayModule.ensureArray;
	lib.concat = arrayModule.concat;
	lib.maxRowLength = arrayModule.maxRowLength;
	lib.minRowLength = arrayModule.minRowLength;
	
	var modModule = _dereq_('./mod');
	lib.mod = modModule.mod;
	lib.modHalf = modModule.modHalf;
	
	var coerceModule = _dereq_('./coerce');
	lib.valObjectMeta = coerceModule.valObjectMeta;
	lib.coerce = coerceModule.coerce;
	lib.coerce2 = coerceModule.coerce2;
	lib.coerceFont = coerceModule.coerceFont;
	lib.coerceHoverinfo = coerceModule.coerceHoverinfo;
	lib.coerceSelectionMarkerOpacity = coerceModule.coerceSelectionMarkerOpacity;
	lib.validate = coerceModule.validate;
	
	var datesModule = _dereq_('./dates');
	lib.dateTime2ms = datesModule.dateTime2ms;
	lib.isDateTime = datesModule.isDateTime;
	lib.ms2DateTime = datesModule.ms2DateTime;
	lib.ms2DateTimeLocal = datesModule.ms2DateTimeLocal;
	lib.cleanDate = datesModule.cleanDate;
	lib.isJSDate = datesModule.isJSDate;
	lib.formatDate = datesModule.formatDate;
	lib.incrementMonth = datesModule.incrementMonth;
	lib.dateTick0 = datesModule.dateTick0;
	lib.dfltRange = datesModule.dfltRange;
	lib.findExactDates = datesModule.findExactDates;
	lib.MIN_MS = datesModule.MIN_MS;
	lib.MAX_MS = datesModule.MAX_MS;
	
	var searchModule = _dereq_('./search');
	lib.findBin = searchModule.findBin;
	lib.sorterAsc = searchModule.sorterAsc;
	lib.sorterDes = searchModule.sorterDes;
	lib.distinctVals = searchModule.distinctVals;
	lib.roundUp = searchModule.roundUp;
	lib.sort = searchModule.sort;
	lib.findIndexOfMin = searchModule.findIndexOfMin;
	
	var statsModule = _dereq_('./stats');
	lib.aggNums = statsModule.aggNums;
	lib.len = statsModule.len;
	lib.mean = statsModule.mean;
	lib.median = statsModule.median;
	lib.midRange = statsModule.midRange;
	lib.variance = statsModule.variance;
	lib.stdev = statsModule.stdev;
	lib.interp = statsModule.interp;
	
	var matrixModule = _dereq_('./matrix');
	lib.init2dArray = matrixModule.init2dArray;
	lib.transposeRagged = matrixModule.transposeRagged;
	lib.dot = matrixModule.dot;
	lib.translationMatrix = matrixModule.translationMatrix;
	lib.rotationMatrix = matrixModule.rotationMatrix;
	lib.rotationXYMatrix = matrixModule.rotationXYMatrix;
	lib.apply2DTransform = matrixModule.apply2DTransform;
	lib.apply2DTransform2 = matrixModule.apply2DTransform2;
	
	var anglesModule = _dereq_('./angles');
	lib.deg2rad = anglesModule.deg2rad;
	lib.rad2deg = anglesModule.rad2deg;
	lib.angleDelta = anglesModule.angleDelta;
	lib.angleDist = anglesModule.angleDist;
	lib.isFullCircle = anglesModule.isFullCircle;
	lib.isAngleInsideSector = anglesModule.isAngleInsideSector;
	lib.isPtInsideSector = anglesModule.isPtInsideSector;
	lib.pathArc = anglesModule.pathArc;
	lib.pathSector = anglesModule.pathSector;
	lib.pathAnnulus = anglesModule.pathAnnulus;
	
	var anchorUtils = _dereq_('./anchor_utils');
	lib.isLeftAnchor = anchorUtils.isLeftAnchor;
	lib.isCenterAnchor = anchorUtils.isCenterAnchor;
	lib.isRightAnchor = anchorUtils.isRightAnchor;
	lib.isTopAnchor = anchorUtils.isTopAnchor;
	lib.isMiddleAnchor = anchorUtils.isMiddleAnchor;
	lib.isBottomAnchor = anchorUtils.isBottomAnchor;
	
	var geom2dModule = _dereq_('./geometry2d');
	lib.segmentsIntersect = geom2dModule.segmentsIntersect;
	lib.segmentDistance = geom2dModule.segmentDistance;
	lib.getTextLocation = geom2dModule.getTextLocation;
	lib.clearLocationCache = geom2dModule.clearLocationCache;
	lib.getVisibleSegment = geom2dModule.getVisibleSegment;
	lib.findPointOnPath = geom2dModule.findPointOnPath;
	
	var extendModule = _dereq_('./extend');
	lib.extendFlat = extendModule.extendFlat;
	lib.extendDeep = extendModule.extendDeep;
	lib.extendDeepAll = extendModule.extendDeepAll;
	lib.extendDeepNoArrays = extendModule.extendDeepNoArrays;
	
	var loggersModule = _dereq_('./loggers');
	lib.log = loggersModule.log;
	lib.warn = loggersModule.warn;
	lib.error = loggersModule.error;
	
	var regexModule = _dereq_('./regex');
	lib.counterRegex = regexModule.counter;
	
	var throttleModule = _dereq_('./throttle');
	lib.throttle = throttleModule.throttle;
	lib.throttleDone = throttleModule.done;
	lib.clearThrottle = throttleModule.clear;
	
	var domModule = _dereq_('./dom');
	lib.getGraphDiv = domModule.getGraphDiv;
	lib.isPlotDiv = domModule.isPlotDiv;
	lib.removeElement = domModule.removeElement;
	lib.addStyleRule = domModule.addStyleRule;
	lib.addRelatedStyleRule = domModule.addRelatedStyleRule;
	lib.deleteRelatedStyleRule = domModule.deleteRelatedStyleRule;
	
	lib.clearResponsive = _dereq_('./clear_responsive');
	
	lib.makeTraceGroups = _dereq_('./make_trace_groups');
	
	lib._ = _dereq_('./localize');
	
	lib.notifier = _dereq_('./notifier');
	
	lib.filterUnique = _dereq_('./filter_unique');
	lib.filterVisible = _dereq_('./filter_visible');
	lib.pushUnique = _dereq_('./push_unique');
	
	lib.cleanNumber = _dereq_('./clean_number');
	
	lib.ensureNumber = function ensureNumber(v) {
	    if(!isNumeric(v)) return BADNUM;
	    v = Number(v);
	    if(v < -FP_SAFE || v > FP_SAFE) return BADNUM;
	    return isNumeric(v) ? Number(v) : BADNUM;
	};
	
	/**
	 * Is v a valid array index? Accepts numeric strings as well as numbers.
	 *
	 * @param {any} v: the value to test
	 * @param {Optional[integer]} len: the array length we are indexing
	 *
	 * @return {bool}: v is a valid array index
	 */
	lib.isIndex = function(v, len) {
	    if(len !== undefined && v >= len) return false;
	    return isNumeric(v) && (v >= 0) && (v % 1 === 0);
	};
	
	lib.noop = _dereq_('./noop');
	lib.identity = _dereq_('./identity');
	
	/**
	 * create an array of length 'cnt' filled with 'v' at all indices
	 *
	 * @param {any} v
	 * @param {number} cnt
	 * @return {array}
	 */
	lib.repeat = function(v, cnt) {
	    var out = new Array(cnt);
	    for(var i = 0; i < cnt; i++) {
	        out[i] = v;
	    }
	    return out;
	};
	
	/**
	 * swap x and y of the same attribute in container cont
	 * specify attr with a ? in place of x/y
	 * you can also swap other things than x/y by providing part1 and part2
	 */
	lib.swapAttrs = function(cont, attrList, part1, part2) {
	    if(!part1) part1 = 'x';
	    if(!part2) part2 = 'y';
	    for(var i = 0; i < attrList.length; i++) {
	        var attr = attrList[i];
	        var xp = lib.nestedProperty(cont, attr.replace('?', part1));
	        var yp = lib.nestedProperty(cont, attr.replace('?', part2));
	        var temp = xp.get();
	        xp.set(yp.get());
	        yp.set(temp);
	    }
	};
	
	/**
	 * SVG painter's algo worked around with reinsertion
	 */
	lib.raiseToTop = function raiseToTop(elem) {
	    elem.parentNode.appendChild(elem);
	};
	
	/**
	 * cancel a possibly pending transition; returned selection may be used by caller
	 */
	lib.cancelTransition = function(selection) {
	    return selection.transition().duration(0);
	};
	
	// constrain - restrict a number v to be between v0 and v1
	lib.constrain = function(v, v0, v1) {
	    if(v0 > v1) return Math.max(v1, Math.min(v0, v));
	    return Math.max(v0, Math.min(v1, v));
	};
	
	/**
	 * do two bounding boxes from getBoundingClientRect,
	 * ie {left,right,top,bottom,width,height}, overlap?
	 * takes optional padding pixels
	 */
	lib.bBoxIntersect = function(a, b, pad) {
	    pad = pad || 0;
	    return (a.left <= b.right + pad &&
	            b.left <= a.right + pad &&
	            a.top <= b.bottom + pad &&
	            b.top <= a.bottom + pad);
	};
	
	/*
	 * simpleMap: alternative to Array.map that only
	 * passes on the element and up to 2 extra args you
	 * provide (but not the array index or the whole array)
	 *
	 * array: the array to map it to
	 * func: the function to apply
	 * x1, x2: optional extra args
	 */
	lib.simpleMap = function(array, func, x1, x2) {
	    var len = array.length;
	    var out = new Array(len);
	    for(var i = 0; i < len; i++) out[i] = func(array[i], x1, x2);
	    return out;
	};
	
	/**
	 * Random string generator
	 *
	 * @param {object} existing
	 *     pass in strings to avoid as keys with truthy values
	 * @param {int} bits
	 *     bits of information in the output string, default 24
	 * @param {int} base
	 *     base of string representation, default 16. Should be a power of 2.
	 */
	lib.randstr = function randstr(existing, bits, base, _recursion) {
	    if(!base) base = 16;
	    if(bits === undefined) bits = 24;
	    if(bits <= 0) return '0';
	
	    var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
	    var res = '';
	    var i, b, x;
	
	    for(i = 2; digits === Infinity; i *= 2) {
	        digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
	    }
	
	    var rem = digits - Math.floor(digits);
	
	    for(i = 0; i < Math.floor(digits); i++) {
	        x = Math.floor(Math.random() * base).toString(base);
	        res = x + res;
	    }
	
	    if(rem) {
	        b = Math.pow(base, rem);
	        x = Math.floor(Math.random() * b).toString(base);
	        res = x + res;
	    }
	
	    var parsed = parseInt(res, base);
	    if((existing && existing[res]) ||
	         (parsed !== Infinity && parsed >= Math.pow(2, bits))) {
	        if(_recursion > 10) {
	            lib.warn('randstr failed uniqueness');
	            return res;
	        }
	        return randstr(existing, bits, base, (_recursion || 0) + 1);
	    } else return res;
	};
	
	lib.OptionControl = function(opt, optname) {
	    /*
	     * An environment to contain all option setters and
	     * getters that collectively modify opts.
	     *
	     * You can call up opts from any function in new object
	     * as this.optname || this.opt
	     *
	     * See FitOpts for example of usage
	     */
	    if(!opt) opt = {};
	    if(!optname) optname = 'opt';
	
	    var self = {};
	    self.optionList = [];
	
	    self._newoption = function(optObj) {
	        optObj[optname] = opt;
	        self[optObj.name] = optObj;
	        self.optionList.push(optObj);
	    };
	
	    self['_' + optname] = opt;
	    return self;
	};
	
	/**
	 * lib.smooth: smooth arrayIn by convolving with
	 * a hann window with given full width at half max
	 * bounce the ends in, so the output has the same length as the input
	 */
	lib.smooth = function(arrayIn, FWHM) {
	    FWHM = Math.round(FWHM) || 0; // only makes sense for integers
	    if(FWHM < 2) return arrayIn;
	
	    var alen = arrayIn.length;
	    var alen2 = 2 * alen;
	    var wlen = 2 * FWHM - 1;
	    var w = new Array(wlen);
	    var arrayOut = new Array(alen);
	    var i;
	    var j;
	    var k;
	    var v;
	
	    // first make the window array
	    for(i = 0; i < wlen; i++) {
	        w[i] = (1 - Math.cos(Math.PI * (i + 1) / FWHM)) / (2 * FWHM);
	    }
	
	    // now do the convolution
	    for(i = 0; i < alen; i++) {
	        v = 0;
	        for(j = 0; j < wlen; j++) {
	            k = i + j + 1 - FWHM;
	
	            // multibounce
	            if(k < -alen) k -= alen2 * Math.round(k / alen2);
	            else if(k >= alen2) k -= alen2 * Math.floor(k / alen2);
	
	            // single bounce
	            if(k < 0) k = - 1 - k;
	            else if(k >= alen) k = alen2 - 1 - k;
	
	            v += arrayIn[k] * w[j];
	        }
	        arrayOut[i] = v;
	    }
	
	    return arrayOut;
	};
	
	/**
	 * syncOrAsync: run a sequence of functions synchronously
	 * as long as its returns are not promises (ie have no .then)
	 * includes one argument arg to send to all functions...
	 * this is mainly just to prevent us having to make wrapper functions
	 * when the only purpose of the wrapper is to reference gd
	 * and a final step to be executed at the end
	 * TODO: if there's an error and everything is sync,
	 * this doesn't happen yet because we want to make sure
	 * that it gets reported
	 */
	lib.syncOrAsync = function(sequence, arg, finalStep) {
	    var ret, fni;
	
	    function continueAsync() {
	        return lib.syncOrAsync(sequence, arg, finalStep);
	    }
	
	    while(sequence.length) {
	        fni = sequence.splice(0, 1)[0];
	        ret = fni(arg);
	
	        if(ret && ret.then) {
	            return ret.then(continueAsync)
	                .then(undefined, lib.promiseError);
	        }
	    }
	
	    return finalStep && finalStep(arg);
	};
	
	
	/**
	 * Helper to strip trailing slash, from
	 * http://stackoverflow.com/questions/6680825/return-string-without-trailing-slash
	 */
	lib.stripTrailingSlash = function(str) {
	    if(str.substr(-1) === '/') return str.substr(0, str.length - 1);
	    return str;
	};
	
	lib.noneOrAll = function(containerIn, containerOut, attrList) {
	    /**
	     * some attributes come together, so if you have one of them
	     * in the input, you should copy the default values of the others
	     * to the input as well.
	     */
	    if(!containerIn) return;
	
	    var hasAny = false;
	    var hasAll = true;
	    var i;
	    var val;
	
	    for(i = 0; i < attrList.length; i++) {
	        val = containerIn[attrList[i]];
	        if(val !== undefined && val !== null) hasAny = true;
	        else hasAll = false;
	    }
	
	    if(hasAny && !hasAll) {
	        for(i = 0; i < attrList.length; i++) {
	            containerIn[attrList[i]] = containerOut[attrList[i]];
	        }
	    }
	};
	
	/** merges calcdata field (given by cdAttr) with traceAttr values
	 *
	 * N.B. Loop over minimum of cd.length and traceAttr.length
	 * i.e. it does not try to fill in beyond traceAttr.length-1
	 *
	 * @param {array} traceAttr : trace attribute
	 * @param {object} cd : calcdata trace
	 * @param {string} cdAttr : calcdata key
	 */
	lib.mergeArray = function(traceAttr, cd, cdAttr, fn) {
	    var hasFn = typeof fn === 'function';
	    if(lib.isArrayOrTypedArray(traceAttr)) {
	        var imax = Math.min(traceAttr.length, cd.length);
	        for(var i = 0; i < imax; i++) {
	            var v = traceAttr[i];
	            cd[i][cdAttr] = hasFn ? fn(v) : v;
	        }
	    }
	};
	
	// cast numbers to positive numbers, returns 0 if not greater than 0
	lib.mergeArrayCastPositive = function(traceAttr, cd, cdAttr) {
	    return lib.mergeArray(traceAttr, cd, cdAttr, function(v) {
	        var w = +v;
	        return !isFinite(w) ? 0 : w > 0 ? w : 0;
	    });
	};
	
	/** fills calcdata field (given by cdAttr) with traceAttr values
	 *  or function of traceAttr values (e.g. some fallback)
	 *
	 * N.B. Loops over all cd items.
	 *
	 * @param {array} traceAttr : trace attribute
	 * @param {object} cd : calcdata trace
	 * @param {string} cdAttr : calcdata key
	 * @param {function} [fn] : optional function to apply to each array item
	 */
	lib.fillArray = function(traceAttr, cd, cdAttr, fn) {
	    fn = fn || lib.identity;
	
	    if(lib.isArrayOrTypedArray(traceAttr)) {
	        for(var i = 0; i < cd.length; i++) {
	            cd[i][cdAttr] = fn(traceAttr[i]);
	        }
	    }
	};
	
	/** Handler for trace-wide vs per-point options
	 *
	 * @param {object} trace : (full) trace object
	 * @param {number} ptNumber : index of the point in question
	 * @param {string} astr : attribute string
	 * @param {function} [fn] : optional function to apply to each array item
	 *
	 * @return {any}
	 */
	lib.castOption = function(trace, ptNumber, astr, fn) {
	    fn = fn || lib.identity;
	
	    var val = lib.nestedProperty(trace, astr).get();
	
	    if(lib.isArrayOrTypedArray(val)) {
	        if(Array.isArray(ptNumber) && lib.isArrayOrTypedArray(val[ptNumber[0]])) {
	            return fn(val[ptNumber[0]][ptNumber[1]]);
	        } else {
	            return fn(val[ptNumber]);
	        }
	    } else {
	        return val;
	    }
	};
	
	/** Extract option from calcdata item, correctly falling back to
	 *  trace value if not found.
	 *
	 *  @param {object} calcPt : calcdata[i][j] item
	 *  @param {object} trace : (full) trace object
	 *  @param {string} calcKey : calcdata key
	 *  @param {string} traceKey : aka trace attribute string
	 *  @return {any}
	 */
	lib.extractOption = function(calcPt, trace, calcKey, traceKey) {
	    if(calcKey in calcPt) return calcPt[calcKey];
	
	    // fallback to trace value,
	    //   must check if value isn't itself an array
	    //   which means the trace attribute has a corresponding
	    //   calcdata key, but its value is falsy
	    var traceVal = lib.nestedProperty(trace, traceKey).get();
	    if(!Array.isArray(traceVal)) return traceVal;
	};
	
	function makePtIndex2PtNumber(indexToPoints) {
	    var ptIndex2ptNumber = {};
	    for(var k in indexToPoints) {
	        var pts = indexToPoints[k];
	        for(var j = 0; j < pts.length; j++) {
	            ptIndex2ptNumber[pts[j]] = +k;
	        }
	    }
	    return ptIndex2ptNumber;
	}
	
	/** Tag selected calcdata items
	 *
	 * N.B. note that point 'index' corresponds to input data array index
	 *  whereas 'number' is its post-transform version.
	 *
	 * @param {array} calcTrace
	 * @param {object} trace
	 *  - selectedpoints {array}
	 *  - _indexToPoints {object}
	 * @param {ptNumber2cdIndex} ptNumber2cdIndex (optional)
	 *  optional map object for trace types that do not have 1-to-1 point number to
	 *  calcdata item index correspondence (e.g. histogram)
	 */
	lib.tagSelected = function(calcTrace, trace, ptNumber2cdIndex) {
	    var selectedpoints = trace.selectedpoints;
	    var indexToPoints = trace._indexToPoints;
	    var ptIndex2ptNumber;
	
	    // make pt index-to-number map object, which takes care of transformed traces
	    if(indexToPoints) {
	        ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
	    }
	
	    function isCdIndexValid(v) {
	        return v !== undefined && v < calcTrace.length;
	    }
	
	    for(var i = 0; i < selectedpoints.length; i++) {
	        var ptIndex = selectedpoints[i];
	
	        if(lib.isIndex(ptIndex)) {
	            var ptNumber = ptIndex2ptNumber ? ptIndex2ptNumber[ptIndex] : ptIndex;
	            var cdIndex = ptNumber2cdIndex ? ptNumber2cdIndex[ptNumber] : ptNumber;
	
	            if(isCdIndexValid(cdIndex)) {
	                calcTrace[cdIndex].selected = 1;
	            }
	        }
	    }
	};
	
	lib.selIndices2selPoints = function(trace) {
	    var selectedpoints = trace.selectedpoints;
	    var indexToPoints = trace._indexToPoints;
	
	    if(indexToPoints) {
	        var ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
	        var out = [];
	
	        for(var i = 0; i < selectedpoints.length; i++) {
	            var ptIndex = selectedpoints[i];
	            if(lib.isIndex(ptIndex)) {
	                var ptNumber = ptIndex2ptNumber[ptIndex];
	                if(lib.isIndex(ptNumber)) {
	                    out.push(ptNumber);
	                }
	            }
	        }
	
	        return out;
	    } else {
	        return selectedpoints;
	    }
	};
	
	/** Returns target as set by 'target' transform attribute
	 *
	 * @param {object} trace : full trace object
	 * @param {object} transformOpts : transform option object
	 *  - target (string} :
	 *      either an attribute string referencing an array in the trace object, or
	 *      a set array.
	 *
	 * @return {array or false} : the target array (NOT a copy!!) or false if invalid
	 */
	lib.getTargetArray = function(trace, transformOpts) {
	    var target = transformOpts.target;
	
	    if(typeof target === 'string' && target) {
	        var array = lib.nestedProperty(trace, target).get();
	        return Array.isArray(array) ? array : false;
	    } else if(Array.isArray(target)) {
	        return target;
	    }
	
	    return false;
	};
	
	/**
	 * modified version of jQuery's extend to strip out private objs and functions,
	 * and cut arrays down to first <arraylen> or 1 elements
	 * because extend-like algorithms are hella slow
	 * obj2 is assumed to already be clean of these things (including no arrays)
	 */
	lib.minExtend = function(obj1, obj2) {
	    var objOut = {};
	    if(typeof obj2 !== 'object') obj2 = {};
	    var arrayLen = 3;
	    var keys = Object.keys(obj1);
	    var i, k, v;
	
	    for(i = 0; i < keys.length; i++) {
	        k = keys[i];
	        v = obj1[k];
	        if(k.charAt(0) === '_' || typeof v === 'function') continue;
	        else if(k === 'module') objOut[k] = v;
	        else if(Array.isArray(v)) {
	            if(k === 'colorscale') {
	                objOut[k] = v.slice();
	            } else {
	                objOut[k] = v.slice(0, arrayLen);
	            }
	        } else if(lib.isTypedArray(v)) {
	            objOut[k] = v.subarray(0, arrayLen);
	        } else if(v && (typeof v === 'object')) objOut[k] = lib.minExtend(obj1[k], obj2[k]);
	        else objOut[k] = v;
	    }
	
	    keys = Object.keys(obj2);
	    for(i = 0; i < keys.length; i++) {
	        k = keys[i];
	        v = obj2[k];
	        if(typeof v !== 'object' || !(k in objOut) || typeof objOut[k] !== 'object') {
	            objOut[k] = v;
	        }
	    }
	
	    return objOut;
	};
	
	lib.titleCase = function(s) {
	    return s.charAt(0).toUpperCase() + s.substr(1);
	};
	
	lib.containsAny = function(s, fragments) {
	    for(var i = 0; i < fragments.length; i++) {
	        if(s.indexOf(fragments[i]) !== -1) return true;
	    }
	    return false;
	};
	
	lib.isIE = function() {
	    return typeof window.navigator.msSaveBlob !== 'undefined';
	};
	
	var IS_IE9_OR_BELOW_REGEX = /MSIE [1-9]\./;
	lib.isIE9orBelow = function() {
	    return lib.isIE() && IS_IE9_OR_BELOW_REGEX.test(window.navigator.userAgent);
	};
	
	var IS_SAFARI_REGEX = /Version\/[\d\.]+.*Safari/;
	lib.isSafari = function() {
	    return IS_SAFARI_REGEX.test(window.navigator.userAgent);
	};
	
	/**
	 * Duck typing to recognize a d3 selection, mostly for IE9's benefit
	 * because it doesn't handle instanceof like modern browsers
	 */
	lib.isD3Selection = function(obj) {
	    return obj && (typeof obj.classed === 'function');
	};
	
	/**
	 * Append element to DOM only if not present.
	 *
	 * @param {d3 selection} parent : parent selection of the element in question
	 * @param {string} nodeType : node type of element to append
	 * @param {string} className (optional) : class name of element in question
	 * @param {fn} enterFn (optional) : optional fn applied to entering elements only
	 * @return {d3 selection} selection of new layer
	 *
	 * Previously, we were using the following pattern:
	 *
	 * ```
	 * var sel = parent.selectAll('.' + className)
	 *     .data([0]);
	 *
	 * sel.enter().append(nodeType)
	 *     .classed(className, true);
	 *
	 * return sel;
	 * ```
	 *
	 * in numerous places in our codebase to achieve the same behavior.
	 *
	 * The logic below performs much better, mostly as we are using
	 * `.select` instead `.selectAll` that is `querySelector` instead of
	 * `querySelectorAll`.
	 *
	 */
	lib.ensureSingle = function(parent, nodeType, className, enterFn) {
	    var sel = parent.select(nodeType + (className ? '.' + className : ''));
	    if(sel.size()) return sel;
	
	    var layer = parent.append(nodeType);
	    if(className) layer.classed(className, true);
	    if(enterFn) layer.call(enterFn);
	
	    return layer;
	};
	
	/**
	 * Same as Lib.ensureSingle, but using id as selector.
	 * This version is mostly used for clipPath nodes.
	 *
	 * @param {d3 selection} parent : parent selection of the element in question
	 * @param {string} nodeType : node type of element to append
	 * @param {string} id : id of element in question
	 * @param {fn} enterFn (optional) : optional fn applied to entering elements only
	 * @return {d3 selection} selection of new layer
	 */
	lib.ensureSingleById = function(parent, nodeType, id, enterFn) {
	    var sel = parent.select(nodeType + '#' + id);
	    if(sel.size()) return sel;
	
	    var layer = parent.append(nodeType).attr('id', id);
	    if(enterFn) layer.call(enterFn);
	
	    return layer;
	};
	
	/**
	 * Converts a string path to an object.
	 *
	 * When given a string containing an array element, it will create a `null`
	 * filled array of the given size.
	 *
	 * @example
	 * lib.objectFromPath('nested.test[2].path', 'value');
	 * // returns { nested: { test: [null, null, { path: 'value' }]}
	 *
	 * @param   {string}    path to nested value
	 * @param   {*}         any value to be set
	 *
	 * @return {Object} the constructed object with a full nested path
	 */
	lib.objectFromPath = function(path, value) {
	    var keys = path.split('.');
	    var tmpObj;
	    var obj = tmpObj = {};
	
	    for(var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var el = null;
	
	        var parts = keys[i].match(/(.*)\[([0-9]+)\]/);
	
	        if(parts) {
	            key = parts[1];
	            el = parts[2];
	
	            tmpObj = tmpObj[key] = [];
	
	            if(i === keys.length - 1) {
	                tmpObj[el] = value;
	            } else {
	                tmpObj[el] = {};
	            }
	
	            tmpObj = tmpObj[el];
	        } else {
	            if(i === keys.length - 1) {
	                tmpObj[key] = value;
	            } else {
	                tmpObj[key] = {};
	            }
	
	            tmpObj = tmpObj[key];
	        }
	    }
	
	    return obj;
	};
	
	/**
	 * Iterate through an object in-place, converting dotted properties to objects.
	 *
	 * Examples:
	 *
	 *   lib.expandObjectPaths({'nested.test.path': 'value'});
	 *     => { nested: { test: {path: 'value'}}}
	 *
	 * It also handles array notation, e.g.:
	 *
	 *   lib.expandObjectPaths({'foo[1].bar': 'value'});
	 *     => { foo: [null, {bar: value}] }
	 *
	 * It handles merges the results when two properties are specified in parallel:
	 *
	 *   lib.expandObjectPaths({'foo[1].bar': 10, 'foo[0].bar': 20});
	 *     => { foo: [{bar: 10}, {bar: 20}] }
	 *
	 * It does NOT, however, merge mulitple mutliply-nested arrays::
	 *
	 *   lib.expandObjectPaths({'marker[1].range[1]': 5, 'marker[1].range[0]': 4})
	 *     => { marker: [null, {range: 4}] }
	 */
	
	// Store this to avoid recompiling regex on *every* prop since this may happen many
	// many times for animations. Could maybe be inside the function. Not sure about
	// scoping vs. recompilation tradeoff, but at least it's not just inlining it into
	// the inner loop.
	var dottedPropertyRegex = /^([^\[\.]+)\.(.+)?/;
	var indexedPropertyRegex = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
	
	lib.expandObjectPaths = function(data) {
	    var match, key, prop, datum, idx, dest, trailingPath;
	    if(typeof data === 'object' && !Array.isArray(data)) {
	        for(key in data) {
	            if(data.hasOwnProperty(key)) {
	                if((match = key.match(dottedPropertyRegex))) {
	                    datum = data[key];
	                    prop = match[1];
	
	                    delete data[key];
	
	                    data[prop] = lib.extendDeepNoArrays(data[prop] || {}, lib.objectFromPath(key, lib.expandObjectPaths(datum))[prop]);
	                } else if((match = key.match(indexedPropertyRegex))) {
	                    datum = data[key];
	
	                    prop = match[1];
	                    idx = parseInt(match[2]);
	
	                    delete data[key];
	
	                    data[prop] = data[prop] || [];
	
	                    if(match[3] === '.') {
	                        // This is the case where theere are subsequent properties into which
	                        // we must recurse, e.g. transforms[0].value
	                        trailingPath = match[4];
	                        dest = data[prop][idx] = data[prop][idx] || {};
	
	                        // NB: Extend deep no arrays prevents this from working on multiple
	                        // nested properties in the same object, e.g.
	                        //
	                        // {
	                        //   foo[0].bar[1].range
	                        //   foo[0].bar[0].range
	                        // }
	                        //
	                        // In this case, the extendDeepNoArrays will overwrite one array with
	                        // the other, so that both properties *will not* be present in the
	                        // result. Fixing this would require a more intelligent tracking
	                        // of changes and merging than extendDeepNoArrays currently accomplishes.
	                        lib.extendDeepNoArrays(dest, lib.objectFromPath(trailingPath, lib.expandObjectPaths(datum)));
	                    } else {
	                        // This is the case where this property is the end of the line,
	                        // e.g. xaxis.range[0]
	                        data[prop][idx] = lib.expandObjectPaths(datum);
	                    }
	                } else {
	                    data[key] = lib.expandObjectPaths(data[key]);
	                }
	            }
	        }
	    }
	
	    return data;
	};
	
	/**
	 * Converts value to string separated by the provided separators.
	 *
	 * @example
	 * lib.numSeparate(2016, '.,');
	 * // returns '2016'
	 *
	 * @example
	 * lib.numSeparate(3000, '.,', true);
	 * // returns '3,000'
	 *
	 * @example
	 * lib.numSeparate(1234.56, '|,')
	 * // returns '1,234|56'
	 *
	 * @param   {string|number} value       the value to be converted
	 * @param   {string}    separators  string of decimal, then thousands separators
	 * @param   {boolean}    separatethousands  boolean, 4-digit integers are separated if true
	 *
	 * @return  {string}    the value that has been separated
	 */
	lib.numSeparate = function(value, separators, separatethousands) {
	    if(!separatethousands) separatethousands = false;
	
	    if(typeof separators !== 'string' || separators.length === 0) {
	        throw new Error('Separator string required for formatting!');
	    }
	
	    if(typeof value === 'number') {
	        value = String(value);
	    }
	
	    var thousandsRe = /(\d+)(\d{3})/;
	    var decimalSep = separators.charAt(0);
	    var thouSep = separators.charAt(1);
	
	    var x = value.split('.');
	    var x1 = x[0];
	    var x2 = x.length > 1 ? decimalSep + x[1] : '';
	
	    // Years are ignored for thousands separators
	    if(thouSep && (x.length > 1 || x1.length > 4 || separatethousands)) {
	        while(thousandsRe.test(x1)) {
	            x1 = x1.replace(thousandsRe, '$1' + thouSep + '$2');
	        }
	    }
	
	    return x1 + x2;
	};
	
	lib.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
	var SIMPLE_PROPERTY_REGEX = /^\w*$/;
	
	/**
	 * Substitute values from an object into a string
	 *
	 * Examples:
	 *  Lib.templateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
	 *  Lib.templateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
	 *
	 * @param {string}  input string containing %{...} template strings
	 * @param {obj}     data object containing substitution values
	 *
	 * @return {string} templated string
	 */
	lib.templateString = function(string, obj) {
	    // Not all that useful, but cache nestedProperty instantiation
	    // just in case it speeds things up *slightly*:
	    var getterCache = {};
	
	    return string.replace(lib.TEMPLATE_STRING_REGEX, function(dummy, key) {
	        if(SIMPLE_PROPERTY_REGEX.test(key)) {
	            return obj[key] || '';
	        }
	        getterCache[key] = getterCache[key] || lib.nestedProperty(obj, key).get;
	        return getterCache[key]() || '';
	    });
	};
	
	var hovertemplateWarnings = {
	    max: 10,
	    count: 0,
	    name: 'hovertemplate'
	};
	lib.hovertemplateString = function() {
	    return templateFormatString.apply(hovertemplateWarnings, arguments);
	};
	
	var texttemplateWarnings = {
	    max: 10,
	    count: 0,
	    name: 'texttemplate'
	};
	lib.texttemplateString = function() {
	    return templateFormatString.apply(texttemplateWarnings, arguments);
	};
	
	var TEMPLATE_STRING_FORMAT_SEPARATOR = /^[:|\|]/;
	/**
	 * Substitute values from an object into a string and optionally formats them using d3-format,
	 * or fallback to associated labels.
	 *
	 * Examples:
	 *  Lib.hovertemplateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
	 *  Lib.hovertemplateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
	 *  Lib.hovertemplateString('price: %{y:$.2f}', {y: 1}) --> 'price: $1.00'
	 *
	 * @param {string}  input string containing %{...:...} template strings
	 * @param {obj}     data object containing fallback text when no formatting is specified, ex.: {yLabel: 'formattedYValue'}
	 * @param {obj}     d3 locale
	 * @param {obj}     data objects containing substitution values
	 *
	 * @return {string} templated string
	 */
	function templateFormatString(string, labels, d3locale) {
	    var opts = this;
	    var args = arguments;
	    if(!labels) labels = {};
	    // Not all that useful, but cache nestedProperty instantiation
	    // just in case it speeds things up *slightly*:
	    var getterCache = {};
	
	    return string.replace(lib.TEMPLATE_STRING_REGEX, function(match, key, format) {
	        var obj, value, i;
	        for(i = 3; i < args.length; i++) {
	            obj = args[i];
	            if(!obj) continue;
	            if(obj.hasOwnProperty(key)) {
	                value = obj[key];
	                break;
	            }
	
	            if(!SIMPLE_PROPERTY_REGEX.test(key)) {
	                value = getterCache[key] || lib.nestedProperty(obj, key).get();
	                if(value) getterCache[key] = value;
	            }
	            if(value !== undefined) break;
	        }
	
	        if(value === undefined && opts) {
	            if(opts.count < opts.max) {
	                lib.warn('Variable \'' + key + '\' in ' + opts.name + ' could not be found!');
	                value = match;
	            }
	
	            if(opts.count === opts.max) {
	                lib.warn('Too many ' + opts.name + ' warnings - additional warnings will be suppressed');
	            }
	            opts.count++;
	
	            return match;
	        }
	
	        if(format) {
	            var fmt;
	            if(format[0] === ':') {
	                fmt = d3locale ? d3locale.numberFormat : d3.format;
	                value = fmt(format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''))(value);
	            }
	
	            if(format[0] === '|') {
	                fmt = d3locale ? d3locale.timeFormat.utc : d3.time.format.utc;
	                var ms = lib.dateTime2ms(value);
	                value = lib.formatDate(ms, format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''), false, fmt);
	            }
	        } else {
	            if(labels.hasOwnProperty(key + 'Label')) value = labels[key + 'Label'];
	        }
	        return value;
	    });
	}
	
	/*
	 * alphanumeric string sort, tailored for subplot IDs like scene2, scene10, x10y13 etc
	 */
	var char0 = 48;
	var char9 = 57;
	lib.subplotSort = function(a, b) {
	    var l = Math.min(a.length, b.length) + 1;
	    var numA = 0;
	    var numB = 0;
	    for(var i = 0; i < l; i++) {
	        var charA = a.charCodeAt(i) || 0;
	        var charB = b.charCodeAt(i) || 0;
	        var isNumA = charA >= char0 && charA <= char9;
	        var isNumB = charB >= char0 && charB <= char9;
	
	        if(isNumA) numA = 10 * numA + charA - char0;
	        if(isNumB) numB = 10 * numB + charB - char0;
	
	        if(!isNumA || !isNumB) {
	            if(numA !== numB) return numA - numB;
	            if(charA !== charB) return charA - charB;
	        }
	    }
	    return numB - numA;
	};
	
	// repeatable pseudorandom generator
	var randSeed = 2000000000;
	
	lib.seedPseudoRandom = function() {
	    randSeed = 2000000000;
	};
	
	lib.pseudoRandom = function() {
	    var lastVal = randSeed;
	    randSeed = (69069 * randSeed + 1) % 4294967296;
	    // don't let consecutive vals be too close together
	    // gets away from really trying to be random, in favor of better local uniformity
	    if(Math.abs(randSeed - lastVal) < 429496729) return lib.pseudoRandom();
	    return randSeed / 4294967296;
	};
	
	
	/** Fill hover 'pointData' container with 'correct' hover text value
	 *
	 * - If trace hoverinfo contains a 'text' flag and hovertext is not set,
	 *   the text elements will be seen in the hover labels.
	 *
	 * - If trace hoverinfo contains a 'text' flag and hovertext is set,
	 *   hovertext takes precedence over text
	 *   i.e. the hoverinfo elements will be seen in the hover labels
	 *
	 *  @param {object} calcPt
	 *  @param {object} trace
	 *  @param {object || array} contOut (mutated here)
	 */
	lib.fillText = function(calcPt, trace, contOut) {
	    var fill = Array.isArray(contOut) ?
	        function(v) { contOut.push(v); } :
	        function(v) { contOut.text = v; };
	
	    var htx = lib.extractOption(calcPt, trace, 'htx', 'hovertext');
	    if(lib.isValidTextValue(htx)) return fill(htx);
	
	    var tx = lib.extractOption(calcPt, trace, 'tx', 'text');
	    if(lib.isValidTextValue(tx)) return fill(tx);
	};
	
	// accept all truthy values and 0 (which gets cast to '0' in the hover labels)
	lib.isValidTextValue = function(v) {
	    return v || v === 0;
	};
	
	/**
	 * @param {number} ratio
	 * @param {number} n (number of decimal places)
	 */
	lib.formatPercent = function(ratio, n) {
	    n = n || 0;
	    var str = (Math.round(100 * ratio * Math.pow(10, n)) * Math.pow(0.1, n)).toFixed(n) + '%';
	    for(var i = 0; i < n; i++) {
	        if(str.indexOf('.') !== -1) {
	            str = str.replace('0%', '%');
	            str = str.replace('.%', '%');
	        }
	    }
	    return str;
	};
	
	lib.isHidden = function(gd) {
	    var display = window.getComputedStyle(gd).display;
	    return !display || display === 'none';
	};
	
	lib.getTextTransform = function(opts) {
	    var textX = opts.textX;
	    var textY = opts.textY;
	    var targetX = opts.targetX;
	    var targetY = opts.targetY;
	    var scale = opts.scale;
	    var rotate = opts.rotate;
	
	    var transformScale;
	    var transformRotate;
	    var transformTranslate;
	
	    if(scale < 1) transformScale = 'scale(' + scale + ') ';
	    else {
	        scale = 1;
	        transformScale = '';
	    }
	
	    transformRotate = (rotate) ?
	        'rotate(' + rotate + ' ' + textX + ' ' + textY + ') ' : '';
	
	    // Note that scaling also affects the center of the text box
	    var translateX = (targetX - scale * textX);
	    var translateY = (targetY - scale * textY);
	    transformTranslate = 'translate(' + translateX + ' ' + translateY + ')';
	
	    return transformTranslate + transformScale + transformRotate;
	};
	
	},{"../constants/numerical":692,"./anchor_utils":697,"./angles":698,"./array":699,"./clean_number":700,"./clear_responsive":702,"./coerce":703,"./dates":704,"./dom":705,"./extend":707,"./filter_unique":708,"./filter_visible":709,"./geometry2d":712,"./identity":715,"./is_plain_object":717,"./keyed_container":718,"./localize":719,"./loggers":720,"./make_trace_groups":721,"./matrix":722,"./mod":723,"./nested_property":724,"./noop":725,"./notifier":726,"./push_unique":730,"./regex":732,"./relative_attr":733,"./relink_private":734,"./search":735,"./stats":738,"./throttle":741,"./to_log_range":742,"d3":164,"fast-isnumeric":227}],717:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	// more info: http://stackoverflow.com/questions/18531624/isplainobject-thing
	module.exports = function isPlainObject(obj) {
	    // We need to be a little less strict in the `imagetest` container because
	    // of how async image requests are handled.
	    //
	    // N.B. isPlainObject(new Constructor()) will return true in `imagetest`
	    if(window && window.process && window.process.versions) {
	        return Object.prototype.toString.call(obj) === '[object Object]';
	    }
	
	    return (
	        Object.prototype.toString.call(obj) === '[object Object]' &&
	        Object.getPrototypeOf(obj) === Object.prototype
	    );
	};
	
	},{}],718:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var nestedProperty = _dereq_('./nested_property');
	
	var SIMPLE_PROPERTY_REGEX = /^\w*$/;
	
	// bitmask for deciding what's updated. Sometimes the name needs to be updated,
	// sometimes the value needs to be updated, and sometimes both do. This is just
	// a simple way to track what's updated such that it's a simple OR operation to
	// assimilate new updates.
	//
	// The only exception is the UNSET bit that tracks when we need to explicitly
	// unset and remove the property. This concrn arises because of the special
	// way in which nestedProperty handles null/undefined. When you specify `null`,
	// it prunes any unused items in the tree. I ran into some issues with it getting
	// null vs undefined confused, so UNSET is just a bit that forces the property
	// update to send `null`, removing the property explicitly rather than setting
	// it to undefined.
	var NONE = 0;
	var NAME = 1;
	var VALUE = 2;
	var BOTH = 3;
	var UNSET = 4;
	
	module.exports = function keyedContainer(baseObj, path, keyName, valueName) {
	    keyName = keyName || 'name';
	    valueName = valueName || 'value';
	    var i, arr, baseProp;
	    var changeTypes = {};
	
	    if(path && path.length) {
	        baseProp = nestedProperty(baseObj, path);
	        arr = baseProp.get();
	    } else {
	        arr = baseObj;
	    }
	
	    path = path || '';
	
	    // Construct an index:
	    var indexLookup = {};
	    if(arr) {
	        for(i = 0; i < arr.length; i++) {
	            indexLookup[arr[i][keyName]] = i;
	        }
	    }
	
	    var isSimpleValueProp = SIMPLE_PROPERTY_REGEX.test(valueName);
	
	    var obj = {
	        set: function(name, value) {
	            var changeType = value === null ? UNSET : NONE;
	
	            // create the base array if necessary
	            if(!arr) {
	                if(!baseProp || changeType === UNSET) return;
	
	                arr = [];
	                baseProp.set(arr);
	            }
	
	            var idx = indexLookup[name];
	            if(idx === undefined) {
	                if(changeType === UNSET) return;
	
	                changeType = changeType | BOTH;
	                idx = arr.length;
	                indexLookup[name] = idx;
	            } else if(value !== (isSimpleValueProp ? arr[idx][valueName] : nestedProperty(arr[idx], valueName).get())) {
	                changeType = changeType | VALUE;
	            }
	
	            var newValue = arr[idx] = arr[idx] || {};
	            newValue[keyName] = name;
	
	            if(isSimpleValueProp) {
	                newValue[valueName] = value;
	            } else {
	                nestedProperty(newValue, valueName).set(value);
	            }
	
	            // If it's not an unset, force that bit to be unset. This is all related to the fact
	            // that undefined and null are a bit specially implemented in nestedProperties.
	            if(value !== null) {
	                changeType = changeType & ~UNSET;
	            }
	
	            changeTypes[idx] = changeTypes[idx] | changeType;
	
	            return obj;
	        },
	        get: function(name) {
	            if(!arr) return;
	
	            var idx = indexLookup[name];
	
	            if(idx === undefined) {
	                return undefined;
	            } else if(isSimpleValueProp) {
	                return arr[idx][valueName];
	            } else {
	                return nestedProperty(arr[idx], valueName).get();
	            }
	        },
	        rename: function(name, newName) {
	            var idx = indexLookup[name];
	
	            if(idx === undefined) return obj;
	            changeTypes[idx] = changeTypes[idx] | NAME;
	
	            indexLookup[newName] = idx;
	            delete indexLookup[name];
	
	            arr[idx][keyName] = newName;
	
	            return obj;
	        },
	        remove: function(name) {
	            var idx = indexLookup[name];
	
	            if(idx === undefined) return obj;
	
	            var object = arr[idx];
	            if(Object.keys(object).length > 2) {
	                // This object contains more than just the key/value, so unset
	                // the value without modifying the entry otherwise:
	                changeTypes[idx] = changeTypes[idx] | VALUE;
	                return obj.set(name, null);
	            }
	
	            if(isSimpleValueProp) {
	                for(i = idx; i < arr.length; i++) {
	                    changeTypes[i] = changeTypes[i] | BOTH;
	                }
	                for(i = idx; i < arr.length; i++) {
	                    indexLookup[arr[i][keyName]]--;
	                }
	                arr.splice(idx, 1);
	                delete(indexLookup[name]);
	            } else {
	                // Perform this update *strictly* so we can check whether the result's
	                // been pruned. If so, it's a removal. If not, it's a value unset only.
	                nestedProperty(object, valueName).set(null);
	
	                // Now check if the top level nested property has any keys left. If so,
	                // the object still has values so we only want to unset the key. If not,
	                // the entire object can be removed since there's no other data.
	                // var topLevelKeys = Object.keys(object[valueName.split('.')[0]] || []);
	
	                changeTypes[idx] = changeTypes[idx] | VALUE | UNSET;
	            }
	
	            return obj;
	        },
	        constructUpdate: function() {
	            var astr, idx;
	            var update = {};
	            var changed = Object.keys(changeTypes);
	            for(var i = 0; i < changed.length; i++) {
	                idx = changed[i];
	                astr = path + '[' + idx + ']';
	                if(arr[idx]) {
	                    if(changeTypes[idx] & NAME) {
	                        update[astr + '.' + keyName] = arr[idx][keyName];
	                    }
	                    if(changeTypes[idx] & VALUE) {
	                        if(isSimpleValueProp) {
	                            update[astr + '.' + valueName] = (changeTypes[idx] & UNSET) ? null : arr[idx][valueName];
	                        } else {
	                            update[astr + '.' + valueName] = (changeTypes[idx] & UNSET) ? null : nestedProperty(arr[idx], valueName).get();
	                        }
	                    }
	                } else {
	                    update[astr] = null;
	                }
	            }
	
	            return update;
	        }
	    };
	
	    return obj;
	};
	
	},{"./nested_property":724}],719:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	
	/**
	 * localize: translate a string for the current locale
	 *
	 * @param {object} gd: the graphDiv for context
	 *  gd._context.locale determines the language (& optional region/country)
	 *  the dictionary for each locale may either be supplied in
	 *  gd._context.locales or globally via Plotly.register
	 * @param {string} s: the string to translate
	 */
	module.exports = function localize(gd, s) {
	    var locale = gd._context.locale;
	
	    /*
	     * Priority of lookup:
	     *     contextDicts[locale],
	     *     registeredDicts[locale],
	     *     contextDicts[baseLocale], (if baseLocale is distinct)
	     *     registeredDicts[baseLocale]
	     * Return the first translation we find.
	     * This way if you have a regionalization you are allowed to specify
	     * only what's different from the base locale, everything else will
	     * fall back on the base.
	     */
	    for(var i = 0; i < 2; i++) {
	        var locales = gd._context.locales;
	        for(var j = 0; j < 2; j++) {
	            var dict = (locales[locale] || {}).dictionary;
	            if(dict) {
	                var out = dict[s];
	                if(out) return out;
	            }
	            locales = Registry.localeRegistry;
	        }
	
	        var baseLocale = locale.split('-')[0];
	        if(baseLocale === locale) break;
	        locale = baseLocale;
	    }
	
	    return s;
	};
	
	},{"../registry":845}],720:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/* eslint-disable no-console */
	
	var dfltConfig = _dereq_('../plot_api/plot_config').dfltConfig;
	
	var loggers = module.exports = {};
	
	/**
	 * ------------------------------------------
	 * debugging tools
	 * ------------------------------------------
	 */
	
	loggers.log = function() {
	    if(dfltConfig.logging > 1) {
	        var messages = ['LOG:'];
	
	        for(var i = 0; i < arguments.length; i++) {
	            messages.push(arguments[i]);
	        }
	
	        apply(console.trace || console.log, messages);
	    }
	};
	
	loggers.warn = function() {
	    if(dfltConfig.logging > 0) {
	        var messages = ['WARN:'];
	
	        for(var i = 0; i < arguments.length; i++) {
	            messages.push(arguments[i]);
	        }
	
	        apply(console.trace || console.log, messages);
	    }
	};
	
	loggers.error = function() {
	    if(dfltConfig.logging > 0) {
	        var messages = ['ERROR:'];
	
	        for(var i = 0; i < arguments.length; i++) {
	            messages.push(arguments[i]);
	        }
	
	        apply(console.error, messages);
	    }
	};
	
	/*
	 * Robust apply, for IE9 where console.log doesn't support
	 * apply like other functions do
	 */
	function apply(f, args) {
	    if(f && f.apply) {
	        try {
	            // `this` should always be console, since here we're always
	            // applying a method of the console object.
	            f.apply(console, args);
	            return;
	        } catch(e) { /* in case apply failed, fall back on the code below */ }
	    }
	
	    // no apply - just try calling the function on each arg independently
	    for(var i = 0; i < args.length; i++) {
	        try {
	            f(args[i]);
	        } catch(e) {
	            // still fails - last resort simple console.log
	            console.log(args[i]);
	        }
	    }
	}
	
	},{"../plot_api/plot_config":752}],721:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	/**
	 * General helper to manage trace groups based on calcdata
	 *
	 * @param {d3.selection} traceLayer: a selection containing a single group
	 *     to draw these traces into
	 * @param {array} cdModule: array of calcdata items for this
	 *     module and subplot combination. Assumes the calcdata item for each
	 *     trace is an array with the fullData trace attached to the first item.
	 * @param {string} cls: the class attribute to give each trace group
	 *     so you can give multiple classes separated by spaces
	 */
	module.exports = function makeTraceGroups(traceLayer, cdModule, cls) {
	    var traces = traceLayer.selectAll('g.' + cls.replace(/\s/g, '.'))
	        .data(cdModule, function(cd) { return cd[0].trace.uid; });
	
	    traces.exit().remove();
	
	    traces.enter().append('g')
	        .attr('class', cls);
	
	    traces.order();
	
	    // stash ref node to trace group in calcdata,
	    // useful for (fast) styleOnSelect
	    var k = traceLayer.classed('rangeplot') ? 'nodeRangePlot3' : 'node3';
	    traces.each(function(cd) { cd[0][k] = d3.select(this); });
	
	    return traces;
	};
	
	},{"d3":164}],722:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	exports.init2dArray = function(rowLength, colLength) {
	    var array = new Array(rowLength);
	    for(var i = 0; i < rowLength; i++) array[i] = new Array(colLength);
	    return array;
	};
	
	/**
	 * transpose a (possibly ragged) 2d array z. inspired by
	 * http://stackoverflow.com/questions/17428587/
	 * transposing-a-2d-array-in-javascript
	 */
	exports.transposeRagged = function(z) {
	    var maxlen = 0;
	    var zlen = z.length;
	    var i, j;
	    // Maximum row length:
	    for(i = 0; i < zlen; i++) maxlen = Math.max(maxlen, z[i].length);
	
	    var t = new Array(maxlen);
	    for(i = 0; i < maxlen; i++) {
	        t[i] = new Array(zlen);
	        for(j = 0; j < zlen; j++) t[i][j] = z[j][i];
	    }
	
	    return t;
	};
	
	// our own dot function so that we don't need to include numeric
	exports.dot = function(x, y) {
	    if(!(x.length && y.length) || x.length !== y.length) return null;
	
	    var len = x.length;
	    var out;
	    var i;
	
	    if(x[0].length) {
	        // mat-vec or mat-mat
	        out = new Array(len);
	        for(i = 0; i < len; i++) out[i] = exports.dot(x[i], y);
	    } else if(y[0].length) {
	        // vec-mat
	        var yTranspose = exports.transposeRagged(y);
	        out = new Array(yTranspose.length);
	        for(i = 0; i < yTranspose.length; i++) out[i] = exports.dot(x, yTranspose[i]);
	    } else {
	        // vec-vec
	        out = 0;
	        for(i = 0; i < len; i++) out += x[i] * y[i];
	    }
	
	    return out;
	};
	
	// translate by (x,y)
	exports.translationMatrix = function(x, y) {
	    return [[1, 0, x], [0, 1, y], [0, 0, 1]];
	};
	
	// rotate by alpha around (0,0)
	exports.rotationMatrix = function(alpha) {
	    var a = alpha * Math.PI / 180;
	    return [[Math.cos(a), -Math.sin(a), 0],
	            [Math.sin(a), Math.cos(a), 0],
	            [0, 0, 1]];
	};
	
	// rotate by alpha around (x,y)
	exports.rotationXYMatrix = function(a, x, y) {
	    return exports.dot(
	        exports.dot(exports.translationMatrix(x, y),
	                    exports.rotationMatrix(a)),
	        exports.translationMatrix(-x, -y));
	};
	
	// applies a 2D transformation matrix to either x and y params or an [x,y] array
	exports.apply2DTransform = function(transform) {
	    return function() {
	        var args = arguments;
	        if(args.length === 3) {
	            args = args[0];
	        }// from map
	        var xy = arguments.length === 1 ? args[0] : [args[0], args[1]];
	        return exports.dot(transform, [xy[0], xy[1], 1]).slice(0, 2);
	    };
	};
	
	// applies a 2D transformation matrix to an [x1,y1,x2,y2] array (to transform a segment)
	exports.apply2DTransform2 = function(transform) {
	    var at = exports.apply2DTransform(transform);
	    return function(xys) {
	        return at(xys.slice(0, 2)).concat(at(xys.slice(2, 4)));
	    };
	};
	
	},{}],723:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * sanitized modulus function that always returns in the range [0, d)
	 * rather than (-d, 0] if v is negative
	 */
	function mod(v, d) {
	    var out = v % d;
	    return out < 0 ? out + d : out;
	}
	
	/**
	 * sanitized modulus function that always returns in the range [-d/2, d/2]
	 * rather than (-d, 0] if v is negative
	 */
	function modHalf(v, d) {
	    return Math.abs(v) > (d / 2) ?
	        v - Math.round(v / d) * d :
	        v;
	}
	
	module.exports = {
	    mod: mod,
	    modHalf: modHalf
	};
	
	},{}],724:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
	
	/**
	 * convert a string s (such as 'xaxis.range[0]')
	 * representing a property of nested object into set and get methods
	 * also return the string and object so we don't have to keep track of them
	 * allows [-1] for an array index, to set a property inside all elements
	 * of an array
	 * eg if obj = {arr: [{a: 1}, {a: 2}]}
	 * you can do p = nestedProperty(obj, 'arr[-1].a')
	 * but you cannot set the array itself this way, to do that
	 * just set the whole array.
	 * eg if obj = {arr: [1, 2, 3]}
	 * you can't do nestedProperty(obj, 'arr[-1]').set(5)
	 * but you can do nestedProperty(obj, 'arr').set([5, 5, 5])
	 */
	module.exports = function nestedProperty(container, propStr) {
	    if(isNumeric(propStr)) propStr = String(propStr);
	    else if(typeof propStr !== 'string' ||
	            propStr.substr(propStr.length - 4) === '[-1]') {
	        throw 'bad property string';
	    }
	
	    var j = 0;
	    var propParts = propStr.split('.');
	    var indexed;
	    var indices;
	    var i;
	
	    // check for parts of the nesting hierarchy that are numbers (ie array elements)
	    while(j < propParts.length) {
	        // look for non-bracket chars, then any number of [##] blocks
	        indexed = String(propParts[j]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/);
	        if(indexed) {
	            if(indexed[1]) propParts[j] = indexed[1];
	            // allow propStr to start with bracketed array indices
	            else if(j === 0) propParts.splice(0, 1);
	            else throw 'bad property string';
	
	            indices = indexed[2]
	                .substr(1, indexed[2].length - 2)
	                .split('][');
	
	            for(i = 0; i < indices.length; i++) {
	                j++;
	                propParts.splice(j, 0, Number(indices[i]));
	            }
	        }
	        j++;
	    }
	
	    if(typeof container !== 'object') {
	        return badContainer(container, propStr, propParts);
	    }
	
	    return {
	        set: npSet(container, propParts, propStr),
	        get: npGet(container, propParts),
	        astr: propStr,
	        parts: propParts,
	        obj: container
	    };
	};
	
	function npGet(cont, parts) {
	    return function() {
	        var curCont = cont;
	        var curPart;
	        var allSame;
	        var out;
	        var i;
	        var j;
	
	        for(i = 0; i < parts.length - 1; i++) {
	            curPart = parts[i];
	            if(curPart === -1) {
	                allSame = true;
	                out = [];
	                for(j = 0; j < curCont.length; j++) {
	                    out[j] = npGet(curCont[j], parts.slice(i + 1))();
	                    if(out[j] !== out[0]) allSame = false;
	                }
	                return allSame ? out[0] : out;
	            }
	            if(typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
	                return undefined;
	            }
	            curCont = curCont[curPart];
	            if(typeof curCont !== 'object' || curCont === null) {
	                return undefined;
	            }
	        }
	
	        // only hit this if parts.length === 1
	        if(typeof curCont !== 'object' || curCont === null) return undefined;
	
	        out = curCont[parts[i]];
	        if(out === null) return undefined;
	        return out;
	    };
	}
	
	/*
	 * Can this value be deleted? We can delete `undefined`, and `null` except INSIDE an
	 * *args* array.
	 *
	 * Previously we also deleted some `{}` and `[]`, in order to try and make set/unset
	 * a net noop; but this causes far more complication than it's worth, and still had
	 * lots of exceptions. See https://github.com/plotly/plotly.js/issues/1410
	 *
	 * *args* arrays get passed directly to API methods and we should respect null if
	 * the user put it there, but otherwise null is deleted as we use it as code
	 * in restyle/relayout/update for "delete this value" whereas undefined means
	 * "ignore this edit"
	 */
	var ARGS_PATTERN = /(^|\.)args\[/;
	function isDeletable(val, propStr) {
	    return (val === undefined) || (val === null && !propStr.match(ARGS_PATTERN));
	}
	
	function npSet(cont, parts, propStr) {
	    return function(val) {
	        var curCont = cont;
	        var propPart = '';
	        var containerLevels = [[cont, propPart]];
	        var toDelete = isDeletable(val, propStr);
	        var curPart;
	        var i;
	
	        for(i = 0; i < parts.length - 1; i++) {
	            curPart = parts[i];
	
	            if(typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
	                throw 'array index but container is not an array';
	            }
	
	            // handle special -1 array index
	            if(curPart === -1) {
	                toDelete = !setArrayAll(curCont, parts.slice(i + 1), val, propStr);
	                if(toDelete) break;
	                else return;
	            }
	
	            if(!checkNewContainer(curCont, curPart, parts[i + 1], toDelete)) {
	                break;
	            }
	
	            curCont = curCont[curPart];
	
	            if(typeof curCont !== 'object' || curCont === null) {
	                throw 'container is not an object';
	            }
	
	            propPart = joinPropStr(propPart, curPart);
	
	            containerLevels.push([curCont, propPart]);
	        }
	
	        if(toDelete) {
	            if(i === parts.length - 1) {
	                delete curCont[parts[i]];
	
	                // The one bit of pruning we still do: drop `undefined` from the end of arrays.
	                // In case someone has already unset previous items, continue until we hit a
	                // non-undefined value.
	                if(Array.isArray(curCont) && +parts[i] === curCont.length - 1) {
	                    while(curCont.length && curCont[curCont.length - 1] === undefined) {
	                        curCont.pop();
	                    }
	                }
	            }
	        } else curCont[parts[i]] = val;
	    };
	}
	
	function joinPropStr(propStr, newPart) {
	    var toAdd = newPart;
	    if(isNumeric(newPart)) toAdd = '[' + newPart + ']';
	    else if(propStr) toAdd = '.' + newPart;
	
	    return propStr + toAdd;
	}
	
	// handle special -1 array index
	function setArrayAll(containerArray, innerParts, val, propStr) {
	    var arrayVal = isArrayOrTypedArray(val);
	    var allSet = true;
	    var thisVal = val;
	    var thisPropStr = propStr.replace('-1', 0);
	    var deleteThis = arrayVal ? false : isDeletable(val, thisPropStr);
	    var firstPart = innerParts[0];
	    var i;
	
	    for(i = 0; i < containerArray.length; i++) {
	        thisPropStr = propStr.replace('-1', i);
	        if(arrayVal) {
	            thisVal = val[i % val.length];
	            deleteThis = isDeletable(thisVal, thisPropStr);
	        }
	        if(deleteThis) allSet = false;
	        if(!checkNewContainer(containerArray, i, firstPart, deleteThis)) {
	            continue;
	        }
	        npSet(containerArray[i], innerParts, propStr.replace('-1', i))(thisVal);
	    }
	    return allSet;
	}
	
	/**
	 * make new sub-container as needed.
	 * returns false if there's no container and none is needed
	 * because we're only deleting an attribute
	 */
	function checkNewContainer(container, part, nextPart, toDelete) {
	    if(container[part] === undefined) {
	        if(toDelete) return false;
	
	        if(typeof nextPart === 'number') container[part] = [];
	        else container[part] = {};
	    }
	    return true;
	}
	
	function badContainer(container, propStr, propParts) {
	    return {
	        set: function() { throw 'bad container'; },
	        get: function() {},
	        astr: propStr,
	        parts: propParts,
	        obj: container
	    };
	}
	
	},{"./array":699,"fast-isnumeric":227}],725:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// Simple helper functions
	// none of these need any external deps
	
	module.exports = function noop() {};
	
	},{}],726:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var NOTEDATA = [];
	
	/**
	 * notifier
	 * @param {String} text The person's user name
	 * @param {Number} [delay=1000] The delay time in milliseconds
	 *          or 'long' which provides 2000 ms delay time.
	 * @return {undefined} this function does not return a value
	 */
	module.exports = function(text, displayLength) {
	    if(NOTEDATA.indexOf(text) !== -1) return;
	
	    NOTEDATA.push(text);
	
	    var ts = 1000;
	    if(isNumeric(displayLength)) ts = displayLength;
	    else if(displayLength === 'long') ts = 3000;
	
	    var notifierContainer = d3.select('body')
	        .selectAll('.plotly-notifier')
	        .data([0]);
	    notifierContainer.enter()
	        .append('div')
	        .classed('plotly-notifier', true);
	
	    var notes = notifierContainer.selectAll('.notifier-note').data(NOTEDATA);
	
	    function killNote(transition) {
	        transition
	            .duration(700)
	            .style('opacity', 0)
	            .each('end', function(thisText) {
	                var thisIndex = NOTEDATA.indexOf(thisText);
	                if(thisIndex !== -1) NOTEDATA.splice(thisIndex, 1);
	                d3.select(this).remove();
	            });
	    }
	
	    notes.enter().append('div')
	        .classed('notifier-note', true)
	        .style('opacity', 0)
	        .each(function(thisText) {
	            var note = d3.select(this);
	
	            note.append('button')
	                .classed('notifier-close', true)
	                .html('&times;')
	                .on('click', function() {
	                    note.transition().call(killNote);
	                });
	
	            var p = note.append('p');
	            var lines = thisText.split(/<br\s*\/?>/g);
	            for(var i = 0; i < lines.length; i++) {
	                if(i) p.append('br');
	                p.append('span').text(lines[i]);
	            }
	
	            note.transition()
	                    .duration(700)
	                    .style('opacity', 1)
	                .transition()
	                    .delay(ts)
	                    .call(killNote);
	        });
	};
	
	},{"d3":164,"fast-isnumeric":227}],727:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var setCursor = _dereq_('./setcursor');
	
	var STASHATTR = 'data-savedcursor';
	var NO_CURSOR = '!!';
	
	/*
	 * works with our CSS cursor classes (see css/_cursor.scss)
	 * to override a previous cursor set on d3 single-element selections,
	 * by moving the name of the original cursor to the data-savedcursor attr.
	 * omit cursor to revert to the previously set value.
	 */
	module.exports = function overrideCursor(el3, csr) {
	    var savedCursor = el3.attr(STASHATTR);
	    if(csr) {
	        if(!savedCursor) {
	            var classes = (el3.attr('class') || '').split(' ');
	            for(var i = 0; i < classes.length; i++) {
	                var cls = classes[i];
	                if(cls.indexOf('cursor-') === 0) {
	                    el3.attr(STASHATTR, cls.substr(7))
	                        .classed(cls, false);
	                }
	            }
	            if(!el3.attr(STASHATTR)) {
	                el3.attr(STASHATTR, NO_CURSOR);
	            }
	        }
	        setCursor(el3, csr);
	    } else if(savedCursor) {
	        el3.attr(STASHATTR, null);
	
	        if(savedCursor === NO_CURSOR) setCursor(el3);
	        else setCursor(el3, savedCursor);
	    }
	};
	
	},{"./setcursor":736}],728:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var dot = _dereq_('./matrix').dot;
	var BADNUM = _dereq_('../constants/numerical').BADNUM;
	
	var polygon = module.exports = {};
	
	/**
	 * Turn an array of [x, y] pairs into a polygon object
	 * that can test if points are inside it
	 *
	 * @param ptsIn Array of [x, y] pairs
	 *
	 * @returns polygon Object {xmin, xmax, ymin, ymax, pts, contains}
	 *      (x|y)(min|max) are the bounding rect of the polygon
	 *      pts is the original array, with the first pair repeated at the end
	 *      contains is a function: (pt, omitFirstEdge)
	 *          pt is the [x, y] pair to test
	 *          omitFirstEdge truthy means points exactly on the first edge don't
	 *              count. This is for use adding one polygon to another so we
	 *              don't double-count the edge where they meet.
	 *          returns boolean: is pt inside the polygon (including on its edges)
	 */
	polygon.tester = function tester(ptsIn) {
	    var pts = ptsIn.slice();
	    var xmin = pts[0][0];
	    var xmax = xmin;
	    var ymin = pts[0][1];
	    var ymax = ymin;
	    var i;
	
	    pts.push(pts[0]);
	    for(i = 1; i < pts.length; i++) {
	        xmin = Math.min(xmin, pts[i][0]);
	        xmax = Math.max(xmax, pts[i][0]);
	        ymin = Math.min(ymin, pts[i][1]);
	        ymax = Math.max(ymax, pts[i][1]);
	    }
	
	    // do we have a rectangle? Handle this here, so we can use the same
	    // tester for the rectangular case without sacrificing speed
	
	    var isRect = false;
	    var rectFirstEdgeTest;
	
	    if(pts.length === 5) {
	        if(pts[0][0] === pts[1][0]) { // vert, horz, vert, horz
	            if(pts[2][0] === pts[3][0] &&
	                    pts[0][1] === pts[3][1] &&
	                    pts[1][1] === pts[2][1]) {
	                isRect = true;
	                rectFirstEdgeTest = function(pt) { return pt[0] === pts[0][0]; };
	            }
	        } else if(pts[0][1] === pts[1][1]) { // horz, vert, horz, vert
	            if(pts[2][1] === pts[3][1] &&
	                    pts[0][0] === pts[3][0] &&
	                    pts[1][0] === pts[2][0]) {
	                isRect = true;
	                rectFirstEdgeTest = function(pt) { return pt[1] === pts[0][1]; };
	            }
	        }
	    }
	
	    function rectContains(pt, omitFirstEdge) {
	        var x = pt[0];
	        var y = pt[1];
	
	        if(x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
	            // pt is outside the bounding box of polygon
	            return false;
	        }
	        if(omitFirstEdge && rectFirstEdgeTest(pt)) return false;
	
	        return true;
	    }
	
	    function contains(pt, omitFirstEdge) {
	        var x = pt[0];
	        var y = pt[1];
	
	        if(x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
	            // pt is outside the bounding box of polygon
	            return false;
	        }
	
	        var imax = pts.length;
	        var x1 = pts[0][0];
	        var y1 = pts[0][1];
	        var crossings = 0;
	        var i;
	        var x0;
	        var y0;
	        var xmini;
	        var ycross;
	
	        for(i = 1; i < imax; i++) {
	            // find all crossings of a vertical line upward from pt with
	            // polygon segments
	            // crossings exactly at xmax don't count, unless the point is
	            // exactly on the segment, then it counts as inside.
	            x0 = x1;
	            y0 = y1;
	            x1 = pts[i][0];
	            y1 = pts[i][1];
	            xmini = Math.min(x0, x1);
	
	            if(x < xmini || x > Math.max(x0, x1) || y > Math.max(y0, y1)) {
	                // outside the bounding box of this segment, it's only a crossing
	                // if it's below the box.
	
	                continue;
	            } else if(y < Math.min(y0, y1)) {
	                // don't count the left-most point of the segment as a crossing
	                // because we don't want to double-count adjacent crossings
	                // UNLESS the polygon turns past vertical at exactly this x
	                // Note that this is repeated below, but we can't factor it out
	                // because
	                if(x !== xmini) crossings++;
	            } else {
	                // inside the bounding box, check the actual line intercept
	
	                // vertical segment - we know already that the point is exactly
	                // on the segment, so mark the crossing as exactly at the point.
	                if(x1 === x0) ycross = y;
	                // any other angle
	                else ycross = y0 + (x - x0) * (y1 - y0) / (x1 - x0);
	
	                // exactly on the edge: counts as inside the polygon, unless it's the
	                // first edge and we're omitting it.
	                if(y === ycross) {
	                    if(i === 1 && omitFirstEdge) return false;
	                    return true;
	                }
	
	                if(y <= ycross && x !== xmini) crossings++;
	            }
	        }
	
	        // if we've gotten this far, odd crossings means inside, even is outside
	        return crossings % 2 === 1;
	    }
	
	    // detect if poly is degenerate
	    var degenerate = true;
	    var lastPt = pts[0];
	    for(i = 1; i < pts.length; i++) {
	        if(lastPt[0] !== pts[i][0] || lastPt[1] !== pts[i][1]) {
	            degenerate = false;
	            break;
	        }
	    }
	
	    return {
	        xmin: xmin,
	        xmax: xmax,
	        ymin: ymin,
	        ymax: ymax,
	        pts: pts,
	        contains: isRect ? rectContains : contains,
	        isRect: isRect,
	        degenerate: degenerate
	    };
	};
	
	/**
	 * Test if a segment of a points array is bent or straight
	 *
	 * @param pts Array of [x, y] pairs
	 * @param start the index of the proposed start of the straight section
	 * @param end the index of the proposed end point
	 * @param tolerance the max distance off the line connecting start and end
	 *      before the line counts as bent
	 * @returns boolean: true means this segment is bent, false means straight
	 */
	polygon.isSegmentBent = function isSegmentBent(pts, start, end, tolerance) {
	    var startPt = pts[start];
	    var segment = [pts[end][0] - startPt[0], pts[end][1] - startPt[1]];
	    var segmentSquared = dot(segment, segment);
	    var segmentLen = Math.sqrt(segmentSquared);
	    var unitPerp = [-segment[1] / segmentLen, segment[0] / segmentLen];
	    var i;
	    var part;
	    var partParallel;
	
	    for(i = start + 1; i < end; i++) {
	        part = [pts[i][0] - startPt[0], pts[i][1] - startPt[1]];
	        partParallel = dot(part, segment);
	
	        if(partParallel < 0 || partParallel > segmentSquared ||
	            Math.abs(dot(part, unitPerp)) > tolerance) return true;
	    }
	    return false;
	};
	
	/**
	 * Make a filtering polygon, to minimize the number of segments
	 *
	 * @param pts Array of [x, y] pairs (must start with at least 1 pair)
	 * @param tolerance the maximum deviation from straight allowed for
	 *      removing points to simplify the polygon
	 *
	 * @returns Object {addPt, raw, filtered}
	 *      addPt is a function(pt: [x, y] pair) to add a raw point and
	 *          continue filtering
	 *      raw is all the input points
	 *      filtered is the resulting filtered Array of [x, y] pairs
	 */
	polygon.filter = function filter(pts, tolerance) {
	    var ptsFiltered = [pts[0]];
	    var doneRawIndex = 0;
	    var doneFilteredIndex = 0;
	
	    function addPt(pt) {
	        pts.push(pt);
	        var prevFilterLen = ptsFiltered.length;
	        var iLast = doneRawIndex;
	        ptsFiltered.splice(doneFilteredIndex + 1);
	
	        for(var i = iLast + 1; i < pts.length; i++) {
	            if(i === pts.length - 1 || polygon.isSegmentBent(pts, iLast, i + 1, tolerance)) {
	                ptsFiltered.push(pts[i]);
	                if(ptsFiltered.length < prevFilterLen - 2) {
	                    doneRawIndex = i;
	                    doneFilteredIndex = ptsFiltered.length - 1;
	                }
	                iLast = i;
	            }
	        }
	    }
	
	    if(pts.length > 1) {
	        var lastPt = pts.pop();
	        addPt(lastPt);
	    }
	
	    return {
	        addPt: addPt,
	        raw: pts,
	        filtered: ptsFiltered
	    };
	};
	
	},{"../constants/numerical":692,"./matrix":722}],729:[function(_dereq_,module,exports){
	(function (global){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var showNoWebGlMsg = _dereq_('./show_no_webgl_msg');
	
	// Note that this module should be ONLY required into
	// files corresponding to regl trace modules
	// so that bundles with non-regl only don't include
	// regl and all its bytes.
	var createRegl = _dereq_('regl');
	
	/**
	 * Idempotent version of createRegl. Create regl instances
	 * in the correct canvases with the correct attributes and
	 * options
	 *
	 * @param {DOM node or object} gd : graph div object
	 * @param {array} extensions : list of extension to pass to createRegl
	 *
	 * @return {boolean} true if all createRegl calls succeeded, false otherwise
	 */
	module.exports = function prepareRegl(gd, extensions) {
	    var fullLayout = gd._fullLayout;
	    var success = true;
	
	    fullLayout._glcanvas.each(function(d) {
	        if(d.regl) return;
	        // only parcoords needs pick layer
	        if(d.pick && !fullLayout._has('parcoords')) return;
	
	        try {
	            d.regl = createRegl({
	                canvas: this,
	                attributes: {
	                    antialias: !d.pick,
	                    preserveDrawingBuffer: true
	                },
	                pixelRatio: gd._context.plotGlPixelRatio || global.devicePixelRatio,
	                extensions: extensions || []
	            });
	        } catch(e) {
	            success = false;
	        }
	
	        if(success) {
	            this.addEventListener('webglcontextlost', function(event) {
	                if(gd && gd.emit) {
	                    gd.emit('plotly_webglcontextlost', {
	                        event: event,
	                        layer: d.key
	                    });
	                }
	            }, false);
	        }
	    });
	
	    if(!success) {
	        showNoWebGlMsg({container: fullLayout._glcontainer.node()});
	    }
	    return success;
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./show_no_webgl_msg":737,"regl":500}],730:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * Push array with unique items
	 *
	 * Ignores falsy items, except 0 so we can use it to construct arrays of indices.
	 *
	 * @param {array} array
	 *  array to be filled
	 * @param {any} item
	 *  item to be or not to be inserted
	 * @return {array}
	 *  ref to array (now possibly containing one more item)
	 *
	 */
	module.exports = function pushUnique(array, item) {
	    if(item instanceof RegExp) {
	        var itemStr = item.toString();
	        for(var i = 0; i < array.length; i++) {
	            if(array[i] instanceof RegExp && array[i].toString() === itemStr) {
	                return array;
	            }
	        }
	        array.push(item);
	    } else if((item || item === 0) && array.indexOf(item) === -1) array.push(item);
	
	    return array;
	};
	
	},{}],731:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var dfltConfig = _dereq_('../plot_api/plot_config').dfltConfig;
	
	/**
	 * Copy arg array *without* removing `undefined` values from objects.
	 *
	 * @param gd
	 * @param args
	 * @returns {Array}
	 */
	function copyArgArray(gd, args) {
	    var copy = [];
	    var arg;
	
	    for(var i = 0; i < args.length; i++) {
	        arg = args[i];
	
	        if(arg === gd) copy[i] = arg;
	        else if(typeof arg === 'object') {
	            copy[i] = Array.isArray(arg) ?
	                Lib.extendDeep([], arg) :
	                Lib.extendDeepAll({}, arg);
	        } else copy[i] = arg;
	    }
	
	    return copy;
	}
	
	
	// -----------------------------------------------------
	// Undo/Redo queue for plots
	// -----------------------------------------------------
	
	
	var queue = {};
	
	// TODO: disable/enable undo and redo buttons appropriately
	
	/**
	 * Add an item to the undoQueue for a graphDiv
	 *
	 * @param gd
	 * @param undoFunc Function undo this operation
	 * @param undoArgs Args to supply undoFunc with
	 * @param redoFunc Function to redo this operation
	 * @param redoArgs Args to supply redoFunc with
	 */
	queue.add = function(gd, undoFunc, undoArgs, redoFunc, redoArgs) {
	    var queueObj,
	        queueIndex;
	
	    // make sure we have the queue and our position in it
	    gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
	    queueIndex = gd.undoQueue.index;
	
	    // if we're already playing an undo or redo, or if this is an auto operation
	    // (like pane resize... any others?) then we don't save this to the undo queue
	    if(gd.autoplay) {
	        if(!gd.undoQueue.inSequence) gd.autoplay = false;
	        return;
	    }
	
	    // if we're not in a sequence or are just starting, we need a new queue item
	    if(!gd.undoQueue.sequence || gd.undoQueue.beginSequence) {
	        queueObj = {undo: {calls: [], args: []}, redo: {calls: [], args: []}};
	        gd.undoQueue.queue.splice(queueIndex, gd.undoQueue.queue.length - queueIndex, queueObj);
	        gd.undoQueue.index += 1;
	    } else {
	        queueObj = gd.undoQueue.queue[queueIndex - 1];
	    }
	    gd.undoQueue.beginSequence = false;
	
	    // we unshift to handle calls for undo in a forward for loop later
	    if(queueObj) {
	        queueObj.undo.calls.unshift(undoFunc);
	        queueObj.undo.args.unshift(undoArgs);
	        queueObj.redo.calls.push(redoFunc);
	        queueObj.redo.args.push(redoArgs);
	    }
	
	    if(gd.undoQueue.queue.length > dfltConfig.queueLength) {
	        gd.undoQueue.queue.shift();
	        gd.undoQueue.index--;
	    }
	};
	
	/**
	 * Begin a sequence of undoQueue changes
	 *
	 * @param gd
	 */
	queue.startSequence = function(gd) {
	    gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
	    gd.undoQueue.sequence = true;
	    gd.undoQueue.beginSequence = true;
	};
	
	/**
	 * Stop a sequence of undoQueue changes
	 *
	 * Call this *after* you're sure your undo chain has ended
	 *
	 * @param gd
	 */
	queue.stopSequence = function(gd) {
	    gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
	    gd.undoQueue.sequence = false;
	    gd.undoQueue.beginSequence = false;
	};
	
	/**
	 * Move one step back in the undo queue, and undo the object there.
	 *
	 * @param gd
	 */
	queue.undo = function undo(gd) {
	    var queueObj, i;
	
	    if(gd.framework && gd.framework.isPolar) {
	        gd.framework.undo();
	        return;
	    }
	    if(gd.undoQueue === undefined ||
	            isNaN(gd.undoQueue.index) ||
	            gd.undoQueue.index <= 0) {
	        return;
	    }
	
	    // index is pointing to next *forward* queueObj, point to the one we're undoing
	    gd.undoQueue.index--;
	
	    // get the queueObj for instructions on how to undo
	    queueObj = gd.undoQueue.queue[gd.undoQueue.index];
	
	    // this sequence keeps things from adding to the queue during undo/redo
	    gd.undoQueue.inSequence = true;
	    for(i = 0; i < queueObj.undo.calls.length; i++) {
	        queue.plotDo(gd, queueObj.undo.calls[i], queueObj.undo.args[i]);
	    }
	    gd.undoQueue.inSequence = false;
	    gd.autoplay = false;
	};
	
	/**
	 * Redo the current object in the undo, then move forward in the queue.
	 *
	 * @param gd
	 */
	queue.redo = function redo(gd) {
	    var queueObj, i;
	
	    if(gd.framework && gd.framework.isPolar) {
	        gd.framework.redo();
	        return;
	    }
	    if(gd.undoQueue === undefined ||
	            isNaN(gd.undoQueue.index) ||
	            gd.undoQueue.index >= gd.undoQueue.queue.length) {
	        return;
	    }
	
	    // get the queueObj for instructions on how to undo
	    queueObj = gd.undoQueue.queue[gd.undoQueue.index];
	
	    // this sequence keeps things from adding to the queue during undo/redo
	    gd.undoQueue.inSequence = true;
	    for(i = 0; i < queueObj.redo.calls.length; i++) {
	        queue.plotDo(gd, queueObj.redo.calls[i], queueObj.redo.args[i]);
	    }
	    gd.undoQueue.inSequence = false;
	    gd.autoplay = false;
	
	    // index is pointing to the thing we just redid, move it
	    gd.undoQueue.index++;
	};
	
	/**
	 * Called by undo/redo to make the actual changes.
	 *
	 * Not meant to be called publically, but included for mocking out in tests.
	 *
	 * @param gd
	 * @param func
	 * @param args
	 */
	queue.plotDo = function(gd, func, args) {
	    gd.autoplay = true;
	
	    // this *won't* copy gd and it preserves `undefined` properties!
	    args = copyArgArray(gd, args);
	
	    // call the supplied function
	    func.apply(null, args);
	};
	
	module.exports = queue;
	
	},{"../lib":716,"../plot_api/plot_config":752}],732:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * make a regex for matching counter ids/names ie xaxis, xaxis2, xaxis10...
	 *
	 * @param {string} head: the head of the pattern, eg 'x' matches 'x', 'x2', 'x10' etc.
	 *      'xy' is a special case for cartesian subplots: it matches 'x2y3' etc
	 * @param {Optional(string)} tail: a fixed piece after the id
	 *      eg counterRegex('scene', '.annotations') for scene2.annotations etc.
	 * @param {boolean} openEnded: if true, the string may continue past the match.
	 * @param {boolean} matchBeginning: if false, the string may start before the match.
	 */
	exports.counter = function(head, tail, openEnded, matchBeginning) {
	    var fullTail = (tail || '') + (openEnded ? '' : '$');
	    var startWithPrefix = matchBeginning === false ? '' : '^';
	    if(head === 'xy') {
	        return new RegExp(startWithPrefix + 'x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?' + fullTail);
	    }
	    return new RegExp(startWithPrefix + head + '([2-9]|[1-9][0-9]+)?' + fullTail);
	};
	
	},{}],733:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	// ASCEND: chop off the last nesting level - either [<n>] or .<key> - to ascend
	// the attribute tree. the remaining attrString is in match[1]
	var ASCEND = /^(.*)(\.[^\.\[\]]+|\[\d\])$/;
	
	// SIMPLEATTR: is this an un-nested attribute? (no dots or brackets)
	var SIMPLEATTR = /^[^\.\[\]]+$/;
	
	/*
	 * calculate a relative attribute string, similar to a relative path
	 *
	 * @param {string} baseAttr:
	 *   an attribute string, such as 'annotations[3].x'. The "current location"
	 *   is the attribute string minus the last component ('annotations[3]')
	 * @param {string} relativeAttr:
	 *   a route to the desired attribute string, using '^' to ascend
	 *
	 * @return {string} attrString:
	 *   for example:
	 *     relativeAttr('annotations[3].x', 'y') = 'annotations[3].y'
	 *     relativeAttr('annotations[3].x', '^[2].z') = 'annotations[2].z'
	 *     relativeAttr('annotations[3].x', '^^margin') = 'margin'
	 *     relativeAttr('annotations[3].x', '^^margin.r') = 'margin.r'
	 */
	module.exports = function(baseAttr, relativeAttr) {
	    while(relativeAttr) {
	        var match = baseAttr.match(ASCEND);
	
	        if(match) baseAttr = match[1];
	        else if(baseAttr.match(SIMPLEATTR)) baseAttr = '';
	        else throw new Error('bad relativeAttr call:' + [baseAttr, relativeAttr]);
	
	        if(relativeAttr.charAt(0) === '^') relativeAttr = relativeAttr.slice(1);
	        else break;
	    }
	
	    if(baseAttr && relativeAttr.charAt(0) !== '[') {
	        return baseAttr + '.' + relativeAttr;
	    }
	    return baseAttr + relativeAttr;
	};
	
	},{}],734:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
	var isPlainObject = _dereq_('./is_plain_object');
	
	/**
	 * Relink private _keys and keys with a function value from one container
	 * to the new container.
	 * Relink means copying if object is pass-by-value and adding a reference
	 * if object is pass-by-ref.
	 * This prevents deepCopying massive structures like a webgl context.
	 */
	module.exports = function relinkPrivateKeys(toContainer, fromContainer) {
	    for(var k in fromContainer) {
	        var fromVal = fromContainer[k];
	        var toVal = toContainer[k];
	
	        if(toVal === fromVal) {
	            continue;
	        }
	        if(k.charAt(0) === '_' || typeof fromVal === 'function') {
	            // if it already exists at this point, it's something
	            // that we recreate each time around, so ignore it
	            if(k in toContainer) continue;
	
	            toContainer[k] = fromVal;
	        } else if(isArrayOrTypedArray(fromVal) && isArrayOrTypedArray(toVal) && isPlainObject(fromVal[0])) {
	            // filter out data_array items that can contain user objects
	            // most of the time the toVal === fromVal check will catch these early
	            // but if the user makes new ones we also don't want to recurse in.
	            if(k === 'customdata' || k === 'ids') continue;
	
	            // recurse into arrays containers
	            var minLen = Math.min(fromVal.length, toVal.length);
	            for(var j = 0; j < minLen; j++) {
	                if((toVal[j] !== fromVal[j]) && isPlainObject(fromVal[j]) && isPlainObject(toVal[j])) {
	                    relinkPrivateKeys(toVal[j], fromVal[j]);
	                }
	            }
	        } else if(isPlainObject(fromVal) && isPlainObject(toVal)) {
	            // recurse into objects, but only if they still exist
	            relinkPrivateKeys(toVal, fromVal);
	
	            if(!Object.keys(toVal).length) delete toContainer[k];
	        }
	    }
	};
	
	},{"./array":699,"./is_plain_object":717}],735:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var loggers = _dereq_('./loggers');
	var identity = _dereq_('./identity');
	
	// don't trust floating point equality - fraction of bin size to call
	// "on the line" and ensure that they go the right way specified by
	// linelow
	var roundingError = 1e-9;
	
	
	/**
	 * findBin - find the bin for val - note that it can return outside the
	 * bin range any pos. or neg. integer for linear bins, or -1 or
	 * bins.length-1 for explicit.
	 * bins is either an object {start,size,end} or an array length #bins+1
	 * bins can be either increasing or decreasing but must be monotonic
	 * for linear bins, we can just calculate. For listed bins, run a binary
	 * search linelow (truthy) says the bin boundary should be attributed to
	 * the lower bin rather than the default upper bin
	 */
	exports.findBin = function(val, bins, linelow) {
	    if(isNumeric(bins.start)) {
	        return linelow ?
	            Math.ceil((val - bins.start) / bins.size - roundingError) - 1 :
	            Math.floor((val - bins.start) / bins.size + roundingError);
	    } else {
	        var n1 = 0;
	        var n2 = bins.length;
	        var c = 0;
	        var binSize = (n2 > 1) ? (bins[n2 - 1] - bins[0]) / (n2 - 1) : 1;
	        var n, test;
	        if(binSize >= 0) {
	            test = linelow ? lessThan : lessOrEqual;
	        } else {
	            test = linelow ? greaterOrEqual : greaterThan;
	        }
	        val += binSize * roundingError * (linelow ? -1 : 1) * (binSize >= 0 ? 1 : -1);
	        // c is just to avoid infinite loops if there's an error
	        while(n1 < n2 && c++ < 100) {
	            n = Math.floor((n1 + n2) / 2);
	            if(test(bins[n], val)) n1 = n + 1;
	            else n2 = n;
	        }
	        if(c > 90) loggers.log('Long binary search...');
	        return n1 - 1;
	    }
	};
	
	function lessThan(a, b) { return a < b; }
	function lessOrEqual(a, b) { return a <= b; }
	function greaterThan(a, b) { return a > b; }
	function greaterOrEqual(a, b) { return a >= b; }
	
	exports.sorterAsc = function(a, b) { return a - b; };
	exports.sorterDes = function(a, b) { return b - a; };
	
	/**
	 * find distinct values in an array, lumping together ones that appear to
	 * just be off by a rounding error
	 * return the distinct values and the minimum difference between any two
	 */
	exports.distinctVals = function(valsIn) {
	    var vals = valsIn.slice();  // otherwise we sort the original array...
	    vals.sort(exports.sorterAsc);
	
	    var l = vals.length - 1;
	    var minDiff = (vals[l] - vals[0]) || 1;
	    var errDiff = minDiff / (l || 1) / 10000;
	    var v2 = [vals[0]];
	
	    for(var i = 0; i < l; i++) {
	        // make sure values aren't just off by a rounding error
	        if(vals[i + 1] > vals[i] + errDiff) {
	            minDiff = Math.min(minDiff, vals[i + 1] - vals[i]);
	            v2.push(vals[i + 1]);
	        }
	    }
	
	    return {vals: v2, minDiff: minDiff};
	};
	
	/**
	 * return the smallest element from (sorted) array arrayIn that's bigger than val,
	 * or (reverse) the largest element smaller than val
	 * used to find the best tick given the minimum (non-rounded) tick
	 * particularly useful for date/time where things are not powers of 10
	 * binary search is probably overkill here...
	 */
	exports.roundUp = function(val, arrayIn, reverse) {
	    var low = 0;
	    var high = arrayIn.length - 1;
	    var mid;
	    var c = 0;
	    var dlow = reverse ? 0 : 1;
	    var dhigh = reverse ? 1 : 0;
	    var rounded = reverse ? Math.ceil : Math.floor;
	    // c is just to avoid infinite loops if there's an error
	    while(low < high && c++ < 100) {
	        mid = rounded((low + high) / 2);
	        if(arrayIn[mid] <= val) low = mid + dlow;
	        else high = mid - dhigh;
	    }
	    return arrayIn[low];
	};
	
	/**
	 * Tweak to Array.sort(sortFn) that improves performance for pre-sorted arrays
	 *
	 * Note that newer browsers (such as Chrome v70+) are starting to pick up
	 * on pre-sorted arrays which may render the following optimization unnecessary
	 * in the future.
	 *
	 * Motivation: sometimes we need to sort arrays but the input is likely to
	 * already be sorted. Browsers don't seem to pick up on pre-sorted arrays,
	 * and in fact Chrome is actually *slower* sorting pre-sorted arrays than purely
	 * random arrays. FF is at least faster if the array is pre-sorted, but still
	 * not as fast as it could be.
	 * Here's how this plays out sorting a length-1e6 array:
	 *
	 * Calls to Sort FN  |  Chrome bare  |  FF bare  |  Chrome tweak  |  FF tweak
	 *                   |  v68.0 Mac    |  v61.0 Mac|                |
	 * ------------------+---------------+-----------+----------------+------------
	 * ordered           |  30.4e6       |  10.1e6   |  1e6           |  1e6
	 * reversed          |  29.4e6       |  9.9e6    |  1e6 + reverse |  1e6 + reverse
	 * random            |  ~21e6        |  ~18.7e6  |  ~21e6         |  ~18.7e6
	 *
	 * So this is a substantial win for pre-sorted (ordered or exactly reversed)
	 * arrays. Including this wrapper on an unsorted array adds a penalty that will
	 * in general be only a few calls to the sort function. The only case this
	 * penalty will be significant is if the array is mostly sorted but there are
	 * a few unsorted items near the end, but the penalty is still at most N calls
	 * out of (for N=1e6) ~20N total calls
	 *
	 * @param {Array} array: the array, to be sorted in place
	 * @param {function} sortFn: As in Array.sort, function(a, b) that puts
	 *     item a before item b if the return is negative, a after b if positive,
	 *     and no change if zero.
	 * @return {Array}: the original array, sorted in place.
	 */
	exports.sort = function(array, sortFn) {
	    var notOrdered = 0;
	    var notReversed = 0;
	    for(var i = 1; i < array.length; i++) {
	        var pairOrder = sortFn(array[i], array[i - 1]);
	        if(pairOrder < 0) notOrdered = 1;
	        else if(pairOrder > 0) notReversed = 1;
	        if(notOrdered && notReversed) return array.sort(sortFn);
	    }
	    return notReversed ? array : array.reverse();
	};
	
	/**
	 * find index in array 'arr' that minimizes 'fn'
	 *
	 * @param {array} arr : array where to search
	 * @param {fn (optional)} fn : function to minimize,
	 *   if not given, fn is the identity function
	 * @return {integer}
	 */
	exports.findIndexOfMin = function(arr, fn) {
	    fn = fn || identity;
	
	    var min = Infinity;
	    var ind;
	
	    for(var i = 0; i < arr.length; i++) {
	        var v = fn(arr[i]);
	        if(v < min) {
	            min = v;
	            ind = i;
	        }
	    }
	    return ind;
	};
	
	},{"./identity":715,"./loggers":720,"fast-isnumeric":227}],736:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	// works with our CSS cursor classes (see css/_cursor.scss)
	// to apply cursors to d3 single-element selections.
	// omit cursor to revert to the default.
	module.exports = function setCursor(el3, csr) {
	    (el3.attr('class') || '').split(' ').forEach(function(cls) {
	        if(cls.indexOf('cursor-') === 0) el3.classed(cls, false);
	    });
	
	    if(csr) el3.classed('cursor-' + csr, true);
	};
	
	},{}],737:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Color = _dereq_('../components/color');
	
	var noop = function() {};
	
	
	/**
	 * Prints a no webgl error message into the scene container
	 * @param {scene instance} scene
	 *
	 * Expects 'scene' to have property 'container'
	 *
	 */
	module.exports = function showNoWebGlMsg(scene) {
	    for(var prop in scene) {
	        if(typeof scene[prop] === 'function') scene[prop] = noop;
	    }
	
	    scene.destroy = function() {
	        scene.container.parentNode.removeChild(scene.container);
	    };
	
	    var div = document.createElement('div');
	    div.className = 'no-webgl';
	    div.style.cursor = 'pointer';
	    div.style.fontSize = '24px';
	    div.style.color = Color.defaults[0];
	    div.style.position = 'absolute';
	    div.style.left = div.style.top = '0px';
	    div.style.width = div.style.height = '100%';
	    div.style['background-color'] = Color.lightLine;
	    div.style['z-index'] = 30;
	
	    var p = document.createElement('p');
	    p.textContent = 'WebGL is not supported by your browser - visit https://get.webgl.org for more info';
	    p.style.position = 'relative';
	    p.style.top = '50%';
	    p.style.left = '50%';
	    p.style.height = '30%';
	    p.style.width = '50%';
	    p.style.margin = '-15% 0 0 -25%';
	
	    div.appendChild(p);
	    scene.container.appendChild(div);
	    scene.container.style.background = '#FFFFFF';
	    scene.container.onclick = function() {
	        window.open('https://get.webgl.org');
	    };
	
	    // return before setting up camera and onrender methods
	    return false;
	};
	
	},{"../components/color":591}],738:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
	
	/**
	 * aggNums() returns the result of an aggregate function applied to an array of
	 * values, where non-numerical values have been tossed out.
	 *
	 * @param {function} f - aggregation function (e.g., Math.min)
	 * @param {Number} v - initial value (continuing from previous calls)
	 *      if there's no continuing value, use null for selector-type
	 *      functions (max,min), or 0 for summations
	 * @param {Array} a - array to aggregate (may be nested, we will recurse,
	 *                    but all elements must have the same dimension)
	 * @param {Number} len - maximum length of a to aggregate
	 * @return {Number} - result of f applied to a starting from v
	 */
	exports.aggNums = function(f, v, a, len) {
	    var i,
	        b;
	    if(!len || len > a.length) len = a.length;
	    if(!isNumeric(v)) v = false;
	    if(isArrayOrTypedArray(a[0])) {
	        b = new Array(len);
	        for(i = 0; i < len; i++) b[i] = exports.aggNums(f, v, a[i]);
	        a = b;
	    }
	
	    for(i = 0; i < len; i++) {
	        if(!isNumeric(v)) v = a[i];
	        else if(isNumeric(a[i])) v = f(+v, +a[i]);
	    }
	    return v;
	};
	
	/**
	 * mean & std dev functions using aggNums, so it handles non-numerics nicely
	 * even need to use aggNums instead of .length, to toss out non-numerics
	 */
	exports.len = function(data) {
	    return exports.aggNums(function(a) { return a + 1; }, 0, data);
	};
	
	exports.mean = function(data, len) {
	    if(!len) len = exports.len(data);
	    return exports.aggNums(function(a, b) { return a + b; }, 0, data) / len;
	};
	
	exports.midRange = function(numArr) {
	    if(numArr === undefined || numArr.length === 0) return undefined;
	    return (exports.aggNums(Math.max, null, numArr) + exports.aggNums(Math.min, null, numArr)) / 2;
	};
	
	exports.variance = function(data, len, mean) {
	    if(!len) len = exports.len(data);
	    if(!isNumeric(mean)) mean = exports.mean(data, len);
	
	    return exports.aggNums(function(a, b) {
	        return a + Math.pow(b - mean, 2);
	    }, 0, data) / len;
	};
	
	exports.stdev = function(data, len, mean) {
	    return Math.sqrt(exports.variance(data, len, mean));
	};
	
	/**
	 * median of a finite set of numbers
	 * reference page: https://en.wikipedia.org/wiki/Median#Finite_set_of_numbers
	**/
	exports.median = function(data) {
	    var b = data.slice().sort();
	    return exports.interp(b, 0.5);
	};
	
	/**
	 * interp() computes a percentile (quantile) for a given distribution.
	 * We interpolate the distribution (to compute quantiles, we follow method #10 here:
	 * http://www.amstat.org/publications/jse/v14n3/langford.html).
	 * Typically the index or rank (n * arr.length) may be non-integer.
	 * For reference: ends are clipped to the extreme values in the array;
	 * For box plots: index you get is half a point too high (see
	 * http://en.wikipedia.org/wiki/Percentile#Nearest_rank) but note that this definition
	 * indexes from 1 rather than 0, so we subtract 1/2 (instead of add).
	 *
	 * @param {Array} arr - This array contains the values that make up the distribution.
	 * @param {Number} n - Between 0 and 1, n = p/100 is such that we compute the p^th percentile.
	 * For example, the 50th percentile (or median) corresponds to n = 0.5
	 * @return {Number} - percentile
	 */
	exports.interp = function(arr, n) {
	    if(!isNumeric(n)) throw 'n should be a finite number';
	    n = n * arr.length - 0.5;
	    if(n < 0) return arr[0];
	    if(n > arr.length - 1) return arr[arr.length - 1];
	    var frac = n % 1;
	    return frac * arr[Math.ceil(n)] + (1 - frac) * arr[Math.floor(n)];
	};
	
	},{"./array":699,"fast-isnumeric":227}],739:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var rgba = _dereq_('color-normalize');
	
	function str2RgbaArray(color) {
	    if(!color) return [0, 0, 0, 1];
	    return rgba(color);
	}
	
	module.exports = str2RgbaArray;
	
	},{"color-normalize":121}],740:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	/* global MathJax:false */
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../lib');
	var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
	var LINE_SPACING = _dereq_('../constants/alignment').LINE_SPACING;
	
	// text converter
	
	function getSize(_selection, _dimension) {
	    return _selection.node().getBoundingClientRect()[_dimension];
	}
	
	var FIND_TEX = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
	
	exports.convertToTspans = function(_context, gd, _callback) {
	    var str = _context.text();
	
	    // Until we get tex integrated more fully (so it can be used along with non-tex)
	    // allow some elements to prohibit it by attaching 'data-notex' to the original
	    var tex = (!_context.attr('data-notex')) &&
	        (typeof MathJax !== 'undefined') &&
	        str.match(FIND_TEX);
	
	    var parent = d3.select(_context.node().parentNode);
	    if(parent.empty()) return;
	    var svgClass = (_context.attr('class')) ? _context.attr('class').split(' ')[0] : 'text';
	    svgClass += '-math';
	    parent.selectAll('svg.' + svgClass).remove();
	    parent.selectAll('g.' + svgClass + '-group').remove();
	    _context.style('display', null)
	        .attr({
	            // some callers use data-unformatted *from the <text> element* in 'cancel'
	            // so we need it here even if we're going to turn it into math
	            // these two (plus style and text-anchor attributes) form the key we're
	            // going to use for Drawing.bBox
	            'data-unformatted': str,
	            'data-math': 'N'
	        });
	
	    function showText() {
	        if(!parent.empty()) {
	            svgClass = _context.attr('class') + '-math';
	            parent.select('svg.' + svgClass).remove();
	        }
	        _context.text('')
	            .style('white-space', 'pre');
	
	        var hasLink = buildSVGText(_context.node(), str);
	
	        if(hasLink) {
	            // at least in Chrome, pointer-events does not seem
	            // to be honored in children of <text> elements
	            // so if we have an anchor, we have to make the
	            // whole element respond
	            _context.style('pointer-events', 'all');
	        }
	
	        exports.positionText(_context);
	
	        if(_callback) _callback.call(_context);
	    }
	
	    if(tex) {
	        ((gd && gd._promises) || []).push(new Promise(function(resolve) {
	            _context.style('display', 'none');
	            var fontSize = parseInt(_context.node().style.fontSize, 10);
	            var config = {fontSize: fontSize};
	
	            texToSVG(tex[2], config, function(_svgEl, _glyphDefs, _svgBBox) {
	                parent.selectAll('svg.' + svgClass).remove();
	                parent.selectAll('g.' + svgClass + '-group').remove();
	
	                var newSvg = _svgEl && _svgEl.select('svg');
	                if(!newSvg || !newSvg.node()) {
	                    showText();
	                    resolve();
	                    return;
	                }
	
	                var mathjaxGroup = parent.append('g')
	                    .classed(svgClass + '-group', true)
	                    .attr({
	                        'pointer-events': 'none',
	                        'data-unformatted': str,
	                        'data-math': 'Y'
	                    });
	
	                mathjaxGroup.node().appendChild(newSvg.node());
	
	                // stitch the glyph defs
	                if(_glyphDefs && _glyphDefs.node()) {
	                    newSvg.node().insertBefore(_glyphDefs.node().cloneNode(true),
	                                               newSvg.node().firstChild);
	                }
	
	                newSvg.attr({
	                    'class': svgClass,
	                    height: _svgBBox.height,
	                    preserveAspectRatio: 'xMinYMin meet'
	                })
	                .style({overflow: 'visible', 'pointer-events': 'none'});
	
	                var fill = _context.node().style.fill || 'black';
	                var g = newSvg.select('g');
	                g.attr({fill: fill, stroke: fill});
	
	                var newSvgW = getSize(g, 'width');
	                var newSvgH = getSize(g, 'height');
	                var newX = +_context.attr('x') - newSvgW *
	                    {start: 0, middle: 0.5, end: 1}[_context.attr('text-anchor') || 'start'];
	                // font baseline is about 1/4 fontSize below centerline
	                var textHeight = fontSize || getSize(_context, 'height');
	                var dy = -textHeight / 4;
	
	                if(svgClass[0] === 'y') {
	                    mathjaxGroup.attr({
	                        transform: 'rotate(' + [-90, +_context.attr('x'), +_context.attr('y')] +
	                        ') translate(' + [-newSvgW / 2, dy - newSvgH / 2] + ')'
	                    });
	                    newSvg.attr({x: +_context.attr('x'), y: +_context.attr('y')});
	                } else if(svgClass[0] === 'l') {
	                    newSvg.attr({x: _context.attr('x'), y: dy - (newSvgH / 2)});
	                } else if(svgClass[0] === 'a' && svgClass.indexOf('atitle') !== 0) {
	                    newSvg.attr({x: 0, y: dy});
	                } else {
	                    newSvg.attr({x: newX, y: (+_context.attr('y') + dy - newSvgH / 2)});
	                }
	
	                if(_callback) _callback.call(_context, mathjaxGroup);
	                resolve(mathjaxGroup);
	            });
	        }));
	    } else showText();
	
	    return _context;
	};
	
	
	// MathJax
	
	var LT_MATCH = /(<|&lt;|&#60;)/g;
	var GT_MATCH = /(>|&gt;|&#62;)/g;
	
	function cleanEscapesForTex(s) {
	    return s.replace(LT_MATCH, '\\lt ')
	        .replace(GT_MATCH, '\\gt ');
	}
	
	function texToSVG(_texString, _config, _callback) {
	    var originalRenderer,
	        originalConfig,
	        originalProcessSectionDelay,
	        tmpDiv;
	
	    MathJax.Hub.Queue(
	    function() {
	        originalConfig = Lib.extendDeepAll({}, MathJax.Hub.config);
	
	        originalProcessSectionDelay = MathJax.Hub.processSectionDelay;
	        if(MathJax.Hub.processSectionDelay !== undefined) {
	            // MathJax 2.5+
	            MathJax.Hub.processSectionDelay = 0;
	        }
	
	        return MathJax.Hub.Config({
	            messageStyle: 'none',
	            tex2jax: {
	                inlineMath: [['$', '$'], ['\\(', '\\)']]
	            },
	            displayAlign: 'left',
	        });
	    },
	    function() {
	        // Get original renderer
	        originalRenderer = MathJax.Hub.config.menuSettings.renderer;
	        if(originalRenderer !== 'SVG') {
	            return MathJax.Hub.setRenderer('SVG');
	        }
	    },
	    function() {
	        var randomID = 'math-output-' + Lib.randstr({}, 64);
	        tmpDiv = d3.select('body').append('div')
	            .attr({id: randomID})
	            .style({visibility: 'hidden', position: 'absolute'})
	            .style({'font-size': _config.fontSize + 'px'})
	            .text(cleanEscapesForTex(_texString));
	
	        return MathJax.Hub.Typeset(tmpDiv.node());
	    },
	    function() {
	        var glyphDefs = d3.select('body').select('#MathJax_SVG_glyphs');
	
	        if(tmpDiv.select('.MathJax_SVG').empty() || !tmpDiv.select('svg').node()) {
	            Lib.log('There was an error in the tex syntax.', _texString);
	            _callback();
	        } else {
	            var svgBBox = tmpDiv.select('svg').node().getBoundingClientRect();
	            _callback(tmpDiv.select('.MathJax_SVG'), glyphDefs, svgBBox);
	        }
	
	        tmpDiv.remove();
	
	        if(originalRenderer !== 'SVG') {
	            return MathJax.Hub.setRenderer(originalRenderer);
	        }
	    },
	    function() {
	        if(originalProcessSectionDelay !== undefined) {
	            MathJax.Hub.processSectionDelay = originalProcessSectionDelay;
	        }
	        return MathJax.Hub.Config(originalConfig);
	    });
	}
	
	var TAG_STYLES = {
	    // would like to use baseline-shift for sub/sup but FF doesn't support it
	    // so we need to use dy along with the uber hacky shift-back-to
	    // baseline below
	    sup: 'font-size:70%',
	    sub: 'font-size:70%',
	    b: 'font-weight:bold',
	    i: 'font-style:italic',
	    a: 'cursor:pointer',
	    span: '',
	    em: 'font-style:italic;font-weight:bold'
	};
	
	// baseline shifts for sub and sup
	var SHIFT_DY = {
	    sub: '0.3em',
	    sup: '-0.6em'
	};
	// reset baseline by adding a tspan (empty except for a zero-width space)
	// with dy of -70% * SHIFT_DY (because font-size=70%)
	var RESET_DY = {
	    sub: '-0.21em',
	    sup: '0.42em'
	};
	var ZERO_WIDTH_SPACE = '\u200b';
	
	/*
	 * Whitelist of protocols in user-supplied urls. Mostly we want to avoid javascript
	 * and related attack vectors. The empty items are there for IE, that in various
	 * versions treats relative paths as having different flavors of no protocol, while
	 * other browsers have these explicitly inherit the protocol of the page they're in.
	 */
	var PROTOCOLS = ['http:', 'https:', 'mailto:', '', undefined, ':'];
	
	var NEWLINES = exports.NEWLINES = /(\r\n?|\n)/g;
	
	var SPLIT_TAGS = /(<[^<>]*>)/;
	
	var ONE_TAG = /<(\/?)([^ >]*)(\s+(.*))?>/i;
	
	var BR_TAG = /<br(\s+.*)?>/i;
	exports.BR_TAG_ALL = /<br(\s+.*)?>/gi;
	
	/*
	 * style and href: pull them out of either single or double quotes. Also
	 * - target: (_blank|_self|_parent|_top|framename)
	 *     note that you can't use target to get a popup but if you use popup,
	 *     a `framename` will be passed along as the name of the popup window.
	 *     per the spec, cannot contain whitespace.
	 *     for backward compatibility we default to '_blank'
	 * - popup: a custom one for us to enable popup (new window) links. String
	 *     for window.open -> strWindowFeatures, like 'menubar=yes,width=500,height=550'
	 *     note that at least in Chrome, you need to give at least one property
	 *     in this string or the page will open in a new tab anyway. We follow this
	 *     convention and will not make a popup if this string is empty.
	 *     per the spec, cannot contain whitespace.
	 *
	 * Because we hack in other attributes with style (sub & sup), drop any trailing
	 * semicolon in user-supplied styles so we can consistently append the tag-dependent style
	 *
	 * These are for tag attributes; Chrome anyway will convert entities in
	 * attribute values, but not in attribute names
	 * you can test this by for example:
	 * > p = document.createElement('p')
	 * > p.innerHTML = '<span styl&#x65;="font-color:r&#x65;d;">Hi</span>'
	 * > p.innerHTML
	 * <- '<span styl&#x65;="font-color:red;">Hi</span>'
	 */
	var STYLEMATCH = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i;
	var HREFMATCH = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i;
	var TARGETMATCH = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i;
	var POPUPMATCH = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
	
	// dedicated matcher for these quoted regexes, that can return their results
	// in two different places
	function getQuotedMatch(_str, re) {
	    if(!_str) return null;
	    var match = _str.match(re);
	    var result = match && (match[3] || match[4]);
	    return result && convertEntities(result);
	}
	
	var COLORMATCH = /(^|;)\s*color:/;
	
	/**
	 * Strip string of tags
	 *
	 * @param {string} _str : input string
	 * @param {object} opts :
	 * - len {number} max length of output string
	 * - allowedTags {array} list of pseudo-html tags to NOT strip
	 * @return {string}
	 */
	exports.plainText = function(_str, opts) {
	    opts = opts || {};
	
	    var len = (opts.len !== undefined && opts.len !== -1) ? opts.len : Infinity;
	    var allowedTags = opts.allowedTags !== undefined ? opts.allowedTags : ['br'];
	
	    var ellipsis = '...';
	    var eLen = ellipsis.length;
	
	    var oldParts = _str.split(SPLIT_TAGS);
	    var newParts = [];
	    var prevTag = '';
	    var l = 0;
	
	    for(var i = 0; i < oldParts.length; i++) {
	        var p = oldParts[i];
	        var match = p.match(ONE_TAG);
	        var tagType = match && match[2].toLowerCase();
	
	        if(tagType) {
	            // N.B. tags do not count towards string length
	            if(allowedTags.indexOf(tagType) !== -1) {
	                newParts.push(p);
	                prevTag = tagType;
	            }
	        } else {
	            var pLen = p.length;
	
	            if((l + pLen) < len) {
	                newParts.push(p);
	                l += pLen;
	            } else if(l < len) {
	                var pLen2 = len - l;
	
	                if(prevTag && (prevTag !== 'br' || pLen2 <= eLen || pLen <= eLen)) {
	                    newParts.pop();
	                }
	
	                if(len > eLen) {
	                    newParts.push(p.substr(0, pLen2 - eLen) + ellipsis);
	                } else {
	                    newParts.push(p.substr(0, pLen2));
	                }
	                break;
	            }
	
	            prevTag = '';
	        }
	    }
	
	    return newParts.join('');
	};
	
	/*
	 * N.B. HTML entities are listed without the leading '&' and trailing ';'
	 * https://www.freeformatter.com/html-entities.html
	 *
	 * FWIW if we wanted to support the full set, it has 2261 entries:
	 * https://www.w3.org/TR/html5/entities.json
	 * though I notice that some of these are duplicates and/or are missing ";"
	 * eg: "&amp;", "&amp", "&AMP;", and "&AMP" all map to "&"
	 * We no longer need to include numeric entities here, these are now handled
	 * by String.fromCodePoint/fromCharCode
	 *
	 * Anyway the only ones that are really important to allow are the HTML special
	 * chars <, >, and &, because these ones can trigger special processing if not
	 * replaced by the corresponding entity.
	 */
	var entityToUnicode = {
	    mu: 'μ',
	    amp: '&',
	    lt: '<',
	    gt: '>',
	    nbsp: ' ',
	    times: '×',
	    plusmn: '±',
	    deg: '°'
	};
	
	// NOTE: in general entities can contain uppercase too (so [a-zA-Z]) but all the
	// ones we support use only lowercase. If we ever change that, update the regex.
	var ENTITY_MATCH = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
	function convertEntities(_str) {
	    return _str.replace(ENTITY_MATCH, function(fullMatch, innerMatch) {
	        var outChar;
	        if(innerMatch.charAt(0) === '#') {
	            // cannot use String.fromCodePoint in IE
	            outChar = fromCodePoint(
	                innerMatch.charAt(1) === 'x' ?
	                    parseInt(innerMatch.substr(2), 16) :
	                    parseInt(innerMatch.substr(1), 10)
	            );
	        } else outChar = entityToUnicode[innerMatch];
	
	        // as in regular HTML, if we didn't decode the entity just
	        // leave the raw text in place.
	        return outChar || fullMatch;
	    });
	}
	exports.convertEntities = convertEntities;
	
	function fromCodePoint(code) {
	    // Don't allow overflow. In Chrome this turns into � but I feel like it's
	    // more useful to just not convert it at all.
	    if(code > 0x10FFFF) return;
	    var stringFromCodePoint = String.fromCodePoint;
	    if(stringFromCodePoint) return stringFromCodePoint(code);
	
	    // IE doesn't have String.fromCodePoint
	    // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
	    var stringFromCharCode = String.fromCharCode;
	    if(code <= 0xFFFF) return stringFromCharCode(code);
	    return stringFromCharCode(
	        (code >> 10) + 0xD7C0,
	        (code % 0x400) + 0xDC00
	    );
	}
	
	/*
	 * buildSVGText: convert our pseudo-html into SVG tspan elements, and attach these
	 * to containerNode
	 *
	 * @param {svg text element} containerNode: the <text> node to insert this text into
	 * @param {string} str: the pseudo-html string to convert to svg
	 *
	 * @returns {bool}: does the result contain any links? We need to handle the text element
	 *   somewhat differently if it does, so just keep track of this when it happens.
	 */
	function buildSVGText(containerNode, str) {
	    /*
	     * Normalize behavior between IE and others wrt newlines and whitespace:pre
	     * this combination makes IE barf https://github.com/plotly/plotly.js/issues/746
	     * Chrome and FF display \n, \r, or \r\n as a space in this mode.
	     * I feel like at some point we turned these into <br> but currently we don't so
	     * I'm just going to cement what we do now in Chrome and FF
	     */
	    str = str.replace(NEWLINES, ' ');
	
	    var hasLink = false;
	
	    // as we're building the text, keep track of what elements we're nested inside
	    // nodeStack will be an array of {node, type, style, href, target, popup}
	    // where only type: 'a' gets the last 3 and node is only added when it's created
	    var nodeStack = [];
	    var currentNode;
	    var currentLine = -1;
	
	    function newLine() {
	        currentLine++;
	
	        var lineNode = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
	        d3.select(lineNode).attr({
	            class: 'line',
	            dy: (currentLine * LINE_SPACING) + 'em'
	        });
	        containerNode.appendChild(lineNode);
	
	        currentNode = lineNode;
	
	        var oldNodeStack = nodeStack;
	        nodeStack = [{node: lineNode}];
	
	        if(oldNodeStack.length > 1) {
	            for(var i = 1; i < oldNodeStack.length; i++) {
	                enterNode(oldNodeStack[i]);
	            }
	        }
	    }
	
	    function enterNode(nodeSpec) {
	        var type = nodeSpec.type;
	        var nodeAttrs = {};
	        var nodeType;
	
	        if(type === 'a') {
	            nodeType = 'a';
	            var target = nodeSpec.target;
	            var href = nodeSpec.href;
	            var popup = nodeSpec.popup;
	            if(href) {
	                nodeAttrs = {
	                    'xlink:xlink:show': (target === '_blank' || target.charAt(0) !== '_') ? 'new' : 'replace',
	                    target: target,
	                    'xlink:xlink:href': href
	                };
	                if(popup) {
	                    // security: href and target are not inserted as code but
	                    // as attributes. popup is, but limited to /[A-Za-z0-9_=,]/
	                    nodeAttrs.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' +
	                        popup + '");return false;';
	                }
	            }
	        } else nodeType = 'tspan';
	
	        if(nodeSpec.style) nodeAttrs.style = nodeSpec.style;
	
	        var newNode = document.createElementNS(xmlnsNamespaces.svg, nodeType);
	
	        if(type === 'sup' || type === 'sub') {
	            addTextNode(currentNode, ZERO_WIDTH_SPACE);
	            currentNode.appendChild(newNode);
	
	            var resetter = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
	            addTextNode(resetter, ZERO_WIDTH_SPACE);
	            d3.select(resetter).attr('dy', RESET_DY[type]);
	            nodeAttrs.dy = SHIFT_DY[type];
	
	            currentNode.appendChild(newNode);
	            currentNode.appendChild(resetter);
	        } else {
	            currentNode.appendChild(newNode);
	        }
	
	        d3.select(newNode).attr(nodeAttrs);
	
	        currentNode = nodeSpec.node = newNode;
	        nodeStack.push(nodeSpec);
	    }
	
	    function addTextNode(node, text) {
	        node.appendChild(document.createTextNode(text));
	    }
	
	    function exitNode(type) {
	        // A bare closing tag can't close the root node. If we encounter this it
	        // means there's an extra closing tag that can just be ignored:
	        if(nodeStack.length === 1) {
	            Lib.log('Ignoring unexpected end tag </' + type + '>.', str);
	            return;
	        }
	
	        var innerNode = nodeStack.pop();
	
	        if(type !== innerNode.type) {
	            Lib.log('Start tag <' + innerNode.type + '> doesnt match end tag <' +
	                type + '>. Pretending it did match.', str);
	        }
	        currentNode = nodeStack[nodeStack.length - 1].node;
	    }
	
	    var hasLines = BR_TAG.test(str);
	
	    if(hasLines) newLine();
	    else {
	        currentNode = containerNode;
	        nodeStack = [{node: containerNode}];
	    }
	
	    var parts = str.split(SPLIT_TAGS);
	    for(var i = 0; i < parts.length; i++) {
	        var parti = parts[i];
	        var match = parti.match(ONE_TAG);
	        var tagType = match && match[2].toLowerCase();
	        var tagStyle = TAG_STYLES[tagType];
	
	        if(tagType === 'br') {
	            newLine();
	        } else if(tagStyle === undefined) {
	            addTextNode(currentNode, convertEntities(parti));
	        } else {
	            // tag - open or close
	            if(match[1]) {
	                exitNode(tagType);
	            } else {
	                var extra = match[4];
	
	                var nodeSpec = {type: tagType};
	
	                // now add style, from both the tag name and any extra css
	                // Most of the svg css that users will care about is just like html,
	                // but font color is different (uses fill). Let our users ignore this.
	                var css = getQuotedMatch(extra, STYLEMATCH);
	                if(css) {
	                    css = css.replace(COLORMATCH, '$1 fill:');
	                    if(tagStyle) css += ';' + tagStyle;
	                } else if(tagStyle) css = tagStyle;
	
	                if(css) nodeSpec.style = css;
	
	                if(tagType === 'a') {
	                    hasLink = true;
	
	                    var href = getQuotedMatch(extra, HREFMATCH);
	
	                    if(href) {
	                        // check safe protocols
	                        var dummyAnchor = document.createElement('a');
	                        dummyAnchor.href = href;
	                        if(PROTOCOLS.indexOf(dummyAnchor.protocol) !== -1) {
	                            // Decode href to allow both already encoded and not encoded
	                            // URIs. Without decoding prior encoding, an already encoded
	                            // URI would be encoded twice producing a semantically different URI.
	                            nodeSpec.href = encodeURI(decodeURI(href));
	                            nodeSpec.target = getQuotedMatch(extra, TARGETMATCH) || '_blank';
	                            nodeSpec.popup = getQuotedMatch(extra, POPUPMATCH);
	                        }
	                    }
	                }
	
	                enterNode(nodeSpec);
	            }
	        }
	    }
	
	    return hasLink;
	}
	
	exports.lineCount = function lineCount(s) {
	    return s.selectAll('tspan.line').size() || 1;
	};
	
	exports.positionText = function positionText(s, x, y) {
	    return s.each(function() {
	        var text = d3.select(this);
	
	        function setOrGet(attr, val) {
	            if(val === undefined) {
	                val = text.attr(attr);
	                if(val === null) {
	                    text.attr(attr, 0);
	                    val = 0;
	                }
	            } else text.attr(attr, val);
	            return val;
	        }
	
	        var thisX = setOrGet('x', x);
	        var thisY = setOrGet('y', y);
	
	        if(this.nodeName === 'text') {
	            text.selectAll('tspan.line').attr({x: thisX, y: thisY});
	        }
	    });
	};
	
	function alignHTMLWith(_base, container, options) {
	    var alignH = options.horizontalAlign;
	    var alignV = options.verticalAlign || 'top';
	    var bRect = _base.node().getBoundingClientRect();
	    var cRect = container.node().getBoundingClientRect();
	    var thisRect;
	    var getTop;
	    var getLeft;
	
	    if(alignV === 'bottom') {
	        getTop = function() { return bRect.bottom - thisRect.height; };
	    } else if(alignV === 'middle') {
	        getTop = function() { return bRect.top + (bRect.height - thisRect.height) / 2; };
	    } else { // default: top
	        getTop = function() { return bRect.top; };
	    }
	
	    if(alignH === 'right') {
	        getLeft = function() { return bRect.right - thisRect.width; };
	    } else if(alignH === 'center') {
	        getLeft = function() { return bRect.left + (bRect.width - thisRect.width) / 2; };
	    } else { // default: left
	        getLeft = function() { return bRect.left; };
	    }
	
	    return function() {
	        thisRect = this.node().getBoundingClientRect();
	        this.style({
	            top: (getTop() - cRect.top) + 'px',
	            left: (getLeft() - cRect.left) + 'px',
	            'z-index': 1000
	        });
	        return this;
	    };
	}
	
	/*
	 * Editable title
	 * @param {d3.selection} context: the element being edited. Normally text,
	 *   but if it isn't, you should provide the styling options
	 * @param {object} options:
	 *   @param {div} options.gd: graphDiv
	 *   @param {d3.selection} options.delegate: item to bind events to if not this
	 *   @param {boolean} options.immediate: start editing now (true) or on click (false, default)
	 *   @param {string} options.fill: font color if not as shown
	 *   @param {string} options.background: background color if not as shown
	 *   @param {string} options.text: initial text, if not as shown
	 *   @param {string} options.horizontalAlign: alignment of the edit box wrt. the bound element
	 *   @param {string} options.verticalAlign: alignment of the edit box wrt. the bound element
	 */
	
	exports.makeEditable = function(context, options) {
	    var gd = options.gd;
	    var _delegate = options.delegate;
	    var dispatch = d3.dispatch('edit', 'input', 'cancel');
	    var handlerElement = _delegate || context;
	
	    context.style({'pointer-events': _delegate ? 'none' : 'all'});
	
	    if(context.size() !== 1) throw new Error('boo');
	
	    function handleClick() {
	        appendEditable();
	        context.style({opacity: 0});
	        // also hide any mathjax svg
	        var svgClass = handlerElement.attr('class');
	        var mathjaxClass;
	        if(svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';
	        else mathjaxClass = '[class*=-math-group]';
	        if(mathjaxClass) {
	            d3.select(context.node().parentNode).select(mathjaxClass).style({opacity: 0});
	        }
	    }
	
	    function selectElementContents(_el) {
	        var el = _el.node();
	        var range = document.createRange();
	        range.selectNodeContents(el);
	        var sel = window.getSelection();
	        sel.removeAllRanges();
	        sel.addRange(range);
	        el.focus();
	    }
	
	    function appendEditable() {
	        var plotDiv = d3.select(gd);
	        var container = plotDiv.select('.svg-container');
	        var div = container.append('div');
	        var cStyle = context.node().style;
	        var fontSize = parseFloat(cStyle.fontSize || 12);
	
	        var initialText = options.text;
	        if(initialText === undefined) initialText = context.attr('data-unformatted');
	
	        div.classed('plugin-editable editable', true)
	            .style({
	                position: 'absolute',
	                'font-family': cStyle.fontFamily || 'Arial',
	                'font-size': fontSize,
	                color: options.fill || cStyle.fill || 'black',
	                opacity: 1,
	                'background-color': options.background || 'transparent',
	                outline: '#ffffff33 1px solid',
	                margin: [-fontSize / 8 + 1, 0, 0, -1].join('px ') + 'px',
	                padding: '0',
	                'box-sizing': 'border-box'
	            })
	            .attr({contenteditable: true})
	            .text(initialText)
	            .call(alignHTMLWith(context, container, options))
	            .on('blur', function() {
	                gd._editing = false;
	                context.text(this.textContent)
	                    .style({opacity: 1});
	                var svgClass = d3.select(this).attr('class');
	                var mathjaxClass;
	                if(svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';
	                else mathjaxClass = '[class*=-math-group]';
	                if(mathjaxClass) {
	                    d3.select(context.node().parentNode).select(mathjaxClass).style({opacity: 0});
	                }
	                var text = this.textContent;
	                d3.select(this).transition().duration(0).remove();
	                d3.select(document).on('mouseup', null);
	                dispatch.edit.call(context, text);
	            })
	            .on('focus', function() {
	                var editDiv = this;
	                gd._editing = true;
	                d3.select(document).on('mouseup', function() {
	                    if(d3.event.target === editDiv) return false;
	                    if(document.activeElement === div.node()) div.node().blur();
	                });
	            })
	            .on('keyup', function() {
	                if(d3.event.which === 27) {
	                    gd._editing = false;
	                    context.style({opacity: 1});
	                    d3.select(this)
	                        .style({opacity: 0})
	                        .on('blur', function() { return false; })
	                        .transition().remove();
	                    dispatch.cancel.call(context, this.textContent);
	                } else {
	                    dispatch.input.call(context, this.textContent);
	                    d3.select(this).call(alignHTMLWith(context, container, options));
	                }
	            })
	            .on('keydown', function() {
	                if(d3.event.which === 13) this.blur();
	            })
	            .call(selectElementContents);
	    }
	
	    if(options.immediate) handleClick();
	    else handlerElement.on('click', handleClick);
	
	    return d3.rebind(context, dispatch, 'on');
	};
	
	},{"../constants/alignment":685,"../constants/xmlns_namespaces":693,"../lib":716,"d3":164}],741:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var timerCache = {};
	
	/**
	 * Throttle a callback. `callback` executes synchronously only if
	 * more than `minInterval` milliseconds have already elapsed since the latest
	 * call (if any). Otherwise we wait until `minInterval` is over and execute the
	 * last callback received while waiting.
	 * So the first and last events in a train are always executed (eventually)
	 * but some of the events in the middle can be dropped.
	 *
	 * @param {string} id: an identifier to mark events to throttle together
	 * @param {number} minInterval: minimum time, in milliseconds, between
	 *   invocations of `callback`
	 * @param {function} callback: the function to throttle. `callback` itself
	 *   should be a purely synchronous function.
	 */
	exports.throttle = function throttle(id, minInterval, callback) {
	    var cache = timerCache[id];
	    var now = Date.now();
	
	    if(!cache) {
	        /*
	         * Throw out old items before making a new one, to prevent the cache
	         * getting overgrown, for example from old plots that have been replaced.
	         * 1 minute age is arbitrary.
	         */
	        for(var idi in timerCache) {
	            if(timerCache[idi].ts < now - 60000) {
	                delete timerCache[idi];
	            }
	        }
	        cache = timerCache[id] = {ts: 0, timer: null};
	    }
	
	    _clearTimeout(cache);
	
	    function exec() {
	        callback();
	        cache.ts = Date.now();
	        if(cache.onDone) {
	            cache.onDone();
	            cache.onDone = null;
	        }
	    }
	
	    if(now > cache.ts + minInterval) {
	        exec();
	        return;
	    }
	
	    cache.timer = setTimeout(function() {
	        exec();
	        cache.timer = null;
	    }, minInterval);
	};
	
	exports.done = function(id) {
	    var cache = timerCache[id];
	    if(!cache || !cache.timer) return Promise.resolve();
	
	    return new Promise(function(resolve) {
	        var previousOnDone = cache.onDone;
	        cache.onDone = function onDone() {
	            if(previousOnDone) previousOnDone();
	            resolve();
	            cache.onDone = null;
	        };
	    });
	};
	
	/**
	 * Clear the throttle cache for one or all timers
	 * @param {optional string} id:
	 *   if provided, clear just this timer
	 *   if omitted, clear all timers (mainly useful for testing)
	 */
	exports.clear = function(id) {
	    if(id) {
	        _clearTimeout(timerCache[id]);
	        delete timerCache[id];
	    } else {
	        for(var idi in timerCache) exports.clear(idi);
	    }
	};
	
	function _clearTimeout(cache) {
	    if(cache && cache.timer !== null) {
	        clearTimeout(cache.timer);
	        cache.timer = null;
	    }
	}
	
	},{}],742:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	/**
	 * convert a linear value into a logged value, folding negative numbers into
	 * the given range
	 */
	module.exports = function toLogRange(val, range) {
	    if(val > 0) return Math.log(val) / Math.LN10;
	
	    // move a negative value reference to a log axis - just put the
	    // result at the lowest range value on the plot (or if the range also went negative,
	    // one millionth of the top of the range)
	    var newVal = Math.log(Math.min(range[0], range[1])) / Math.LN10;
	    if(!isNumeric(newVal)) newVal = Math.log(Math.max(range[0], range[1])) / Math.LN10 - 6;
	    return newVal;
	};
	
	},{"fast-isnumeric":227}],743:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var topojsonUtils = module.exports = {};
	
	var locationmodeToLayer = _dereq_('../plots/geo/constants').locationmodeToLayer;
	var topojsonFeature = _dereq_('topojson-client').feature;
	
	topojsonUtils.getTopojsonName = function(geoLayout) {
	    return [
	        geoLayout.scope.replace(/ /g, '-'), '_',
	        geoLayout.resolution.toString(), 'm'
	    ].join('');
	};
	
	topojsonUtils.getTopojsonPath = function(topojsonURL, topojsonName) {
	    return topojsonURL + topojsonName + '.json';
	};
	
	topojsonUtils.getTopojsonFeatures = function(trace, topojson) {
	    var layer = locationmodeToLayer[trace.locationmode];
	    var obj = topojson.objects[layer];
	
	    return topojsonFeature(topojson, obj).features;
	};
	
	},{"../plots/geo/constants":792,"topojson-client":538}],744:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'locale',
	    name: 'en-US',
	    dictionary: {
	        'Click to enter Colorscale title': 'Click to enter Colorscale title'
	    },
	    format: {
	        date: '%m/%d/%Y'
	    }
	};
	
	},{}],745:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'locale',
	    name: 'en',
	    dictionary: {
	        'Click to enter Colorscale title': 'Click to enter Colourscale title'
	    },
	    format: {
	        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	        shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	        months: [
	            'January', 'February', 'March', 'April', 'May', 'June',
	            'July', 'August', 'September', 'October', 'November', 'December'
	        ],
	        shortMonths: [
	            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
	            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	        ],
	        periods: ['AM', 'PM'],
	        dateTime: '%a %b %e %X %Y',
	        date: '%d/%m/%Y',
	        time: '%H:%M:%S',
	        decimal: '.',
	        thousands: ',',
	        grouping: [3],
	        currency: ['$', ''],
	        year: '%Y',
	        month: '%b %Y',
	        dayMonth: '%b %-d',
	        dayMonthYear: '%b %-d, %Y'
	    }
	};
	
	},{}],746:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	
	/*
	 * containerArrayMatch: does this attribute string point into a
	 * layout container array?
	 *
	 * @param {String} astr: an attribute string, like *annotations[2].text*
	 *
	 * @returns {Object | false} Returns false if `astr` doesn't match a container
	 *  array. If it does, returns:
	 *     {array: {String}, index: {Number}, property: {String}}
	 *  ie the attribute string for the array, the index within the array (or ''
	 *  if the whole array) and the property within that (or '' if the whole array
	 *  or the whole object)
	 */
	module.exports = function containerArrayMatch(astr) {
	    var rootContainers = Registry.layoutArrayContainers;
	    var regexpContainers = Registry.layoutArrayRegexes;
	    var rootPart = astr.split('[')[0];
	    var arrayStr;
	    var match;
	
	    // look for regexp matches first, because they may be nested inside root matches
	    // eg updatemenus[i].buttons is nested inside updatemenus
	    for(var i = 0; i < regexpContainers.length; i++) {
	        match = astr.match(regexpContainers[i]);
	        if(match && match.index === 0) {
	            arrayStr = match[0];
	            break;
	        }
	    }
	
	    // now look for root matches
	    if(!arrayStr) arrayStr = rootContainers[rootContainers.indexOf(rootPart)];
	
	    if(!arrayStr) return false;
	
	    var tail = astr.substr(arrayStr.length);
	    if(!tail) return {array: arrayStr, index: '', property: ''};
	
	    match = tail.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/);
	    if(!match) return false;
	
	    return {array: arrayStr, index: Number(match[1]), property: match[3] || ''};
	};
	
	},{"../registry":845}],747:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var extendFlat = Lib.extendFlat;
	var isPlainObject = Lib.isPlainObject;
	
	var traceOpts = {
	    valType: 'flaglist',
	    extras: ['none'],
	    flags: ['calc', 'clearAxisTypes', 'plot', 'style', 'markerSize', 'colorbars'],
	    
	};
	
	var layoutOpts = {
	    valType: 'flaglist',
	    extras: ['none'],
	    flags: [
	        'calc', 'plot', 'legend', 'ticks', 'axrange',
	        'layoutstyle', 'modebar', 'camera', 'arraydraw', 'colorbars'
	    ],
	    
	};
	
	// flags for inside restyle/relayout include a few extras
	// that shouldn't be used in attributes, to deal with certain
	// combinations and conditionals efficiently
	var traceEditTypeFlags = traceOpts.flags.slice()
	    .concat(['fullReplot']);
	
	var layoutEditTypeFlags = layoutOpts.flags.slice()
	    .concat('layoutReplot');
	
	module.exports = {
	    traces: traceOpts,
	    layout: layoutOpts,
	    /*
	     * default (all false) edit flags for restyle (traces)
	     * creates a new object each call, so the caller can mutate freely
	     */
	    traceFlags: function() { return falseObj(traceEditTypeFlags); },
	
	    /*
	     * default (all false) edit flags for relayout
	     * creates a new object each call, so the caller can mutate freely
	     */
	    layoutFlags: function() { return falseObj(layoutEditTypeFlags); },
	
	    /*
	     * update `flags` with the `editType` values found in `attr`
	     */
	    update: function(flags, attr) {
	        var editType = attr.editType;
	        if(editType && editType !== 'none') {
	            var editTypeParts = editType.split('+');
	            for(var i = 0; i < editTypeParts.length; i++) {
	                flags[editTypeParts[i]] = true;
	            }
	        }
	    },
	
	    overrideAll: overrideAll
	};
	
	function falseObj(keys) {
	    var out = {};
	    for(var i = 0; i < keys.length; i++) out[keys[i]] = false;
	    return out;
	}
	
	/**
	 * For attributes that are largely copied from elsewhere into a plot type that doesn't
	 * support partial redraws - overrides the editType field of all attributes in the object
	 *
	 * @param {object} attrs: the attributes to override. Will not be mutated.
	 * @param {string} editTypeOverride: the new editType to use
	 * @param {'nested'|'from-root'} overrideContainers:
	 *   - 'nested' will override editType for nested containers but not the root.
	 *   - 'from-root' will also override editType of the root container.
	 *   Containers below the absolute top level (trace or layout root) DO need an
	 *   editType even if they are not `valObject`s themselves (eg `scatter.marker`)
	 *   to handle the case where you edit the whole container.
	 *
	 * @return {object} a new attributes object with `editType` modified as directed
	 */
	function overrideAll(attrs, editTypeOverride, overrideContainers) {
	    var out = extendFlat({}, attrs);
	    for(var key in out) {
	        var attr = out[key];
	        if(isPlainObject(attr)) {
	            out[key] = overrideOne(attr, editTypeOverride, overrideContainers, key);
	        }
	    }
	    if(overrideContainers === 'from-root') out.editType = editTypeOverride;
	
	    return out;
	}
	
	function overrideOne(attr, editTypeOverride, overrideContainers, key) {
	    if(attr.valType) {
	        var out = extendFlat({}, attr);
	        out.editType = editTypeOverride;
	
	        if(Array.isArray(attr.items)) {
	            out.items = new Array(attr.items.length);
	            for(var i = 0; i < attr.items.length; i++) {
	                out.items[i] = overrideOne(attr.items[i], editTypeOverride, 'from-root');
	            }
	        }
	        return out;
	    } else {
	        // don't provide an editType for the _deprecated container
	        return overrideAll(attr, editTypeOverride,
	            (key.charAt(0) === '_') ? 'nested' : 'from-root');
	    }
	}
	
	},{"../lib":716}],748:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var m4FromQuat = _dereq_('gl-mat4/fromQuat');
	
	var Registry = _dereq_('../registry');
	var Lib = _dereq_('../lib');
	var Plots = _dereq_('../plots/plots');
	var AxisIds = _dereq_('../plots/cartesian/axis_ids');
	var Color = _dereq_('../components/color');
	
	var cleanId = AxisIds.cleanId;
	var getFromTrace = AxisIds.getFromTrace;
	var traceIs = Registry.traceIs;
	
	// clear the promise queue if one of them got rejected
	exports.clearPromiseQueue = function(gd) {
	    if(Array.isArray(gd._promises) && gd._promises.length > 0) {
	        Lib.log('Clearing previous rejected promises from queue.');
	    }
	
	    gd._promises = [];
	};
	
	// make a few changes to the layout right away
	// before it gets used for anything
	// backward compatibility and cleanup of nonstandard options
	exports.cleanLayout = function(layout) {
	    var i, j;
	
	    if(!layout) layout = {};
	
	    // cannot have (x|y)axis1, numbering goes axis, axis2, axis3...
	    if(layout.xaxis1) {
	        if(!layout.xaxis) layout.xaxis = layout.xaxis1;
	        delete layout.xaxis1;
	    }
	    if(layout.yaxis1) {
	        if(!layout.yaxis) layout.yaxis = layout.yaxis1;
	        delete layout.yaxis1;
	    }
	    if(layout.scene1) {
	        if(!layout.scene) layout.scene = layout.scene1;
	        delete layout.scene1;
	    }
	
	    var axisAttrRegex = (Plots.subplotsRegistry.cartesian || {}).attrRegex;
	    var polarAttrRegex = (Plots.subplotsRegistry.polar || {}).attrRegex;
	    var ternaryAttrRegex = (Plots.subplotsRegistry.ternary || {}).attrRegex;
	    var sceneAttrRegex = (Plots.subplotsRegistry.gl3d || {}).attrRegex;
	
	    var keys = Object.keys(layout);
	    for(i = 0; i < keys.length; i++) {
	        var key = keys[i];
	
	        if(axisAttrRegex && axisAttrRegex.test(key)) {
	            // modifications to cartesian axes
	
	            var ax = layout[key];
	            if(ax.anchor && ax.anchor !== 'free') {
	                ax.anchor = cleanId(ax.anchor);
	            }
	            if(ax.overlaying) ax.overlaying = cleanId(ax.overlaying);
	
	            // old method of axis type - isdate and islog (before category existed)
	            if(!ax.type) {
	                if(ax.isdate) ax.type = 'date';
	                else if(ax.islog) ax.type = 'log';
	                else if(ax.isdate === false && ax.islog === false) ax.type = 'linear';
	            }
	            if(ax.autorange === 'withzero' || ax.autorange === 'tozero') {
	                ax.autorange = true;
	                ax.rangemode = 'tozero';
	            }
	            delete ax.islog;
	            delete ax.isdate;
	            delete ax.categories; // replaced by _categories
	
	            // prune empty domain arrays made before the new nestedProperty
	            if(emptyContainer(ax, 'domain')) delete ax.domain;
	
	            // autotick -> tickmode
	            if(ax.autotick !== undefined) {
	                if(ax.tickmode === undefined) {
	                    ax.tickmode = ax.autotick ? 'auto' : 'linear';
	                }
	                delete ax.autotick;
	            }
	
	            cleanTitle(ax);
	        } else if(polarAttrRegex && polarAttrRegex.test(key)) {
	            // modifications for polar
	
	            var polar = layout[key];
	            cleanTitle(polar.radialaxis);
	        } else if(ternaryAttrRegex && ternaryAttrRegex.test(key)) {
	            // modifications for ternary
	
	            var ternary = layout[key];
	            cleanTitle(ternary.aaxis);
	            cleanTitle(ternary.baxis);
	            cleanTitle(ternary.caxis);
	        } else if(sceneAttrRegex && sceneAttrRegex.test(key)) {
	            // modifications for 3D scenes
	
	            var scene = layout[key];
	
	            // clean old Camera coords
	            var cameraposition = scene.cameraposition;
	
	            if(Array.isArray(cameraposition) && cameraposition[0].length === 4) {
	                var rotation = cameraposition[0];
	                var center = cameraposition[1];
	                var radius = cameraposition[2];
	                var mat = m4FromQuat([], rotation);
	                var eye = [];
	
	                for(j = 0; j < 3; ++j) {
	                    eye[j] = center[j] + radius * mat[2 + 4 * j];
	                }
	
	                scene.camera = {
	                    eye: {x: eye[0], y: eye[1], z: eye[2]},
	                    center: {x: center[0], y: center[1], z: center[2]},
	                    up: {x: 0, y: 0, z: 1} // we just ignore calculating camera z up in this case
	                };
	
	                delete scene.cameraposition;
	            }
	
	            // clean axis titles
	            cleanTitle(scene.xaxis);
	            cleanTitle(scene.yaxis);
	            cleanTitle(scene.zaxis);
	        }
	    }
	
	    var annotationsLen = Array.isArray(layout.annotations) ? layout.annotations.length : 0;
	    for(i = 0; i < annotationsLen; i++) {
	        var ann = layout.annotations[i];
	
	        if(!Lib.isPlainObject(ann)) continue;
	
	        if(ann.ref) {
	            if(ann.ref === 'paper') {
	                ann.xref = 'paper';
	                ann.yref = 'paper';
	            } else if(ann.ref === 'data') {
	                ann.xref = 'x';
	                ann.yref = 'y';
	            }
	            delete ann.ref;
	        }
	
	        cleanAxRef(ann, 'xref');
	        cleanAxRef(ann, 'yref');
	    }
	
	    var shapesLen = Array.isArray(layout.shapes) ? layout.shapes.length : 0;
	    for(i = 0; i < shapesLen; i++) {
	        var shape = layout.shapes[i];
	
	        if(!Lib.isPlainObject(shape)) continue;
	
	        cleanAxRef(shape, 'xref');
	        cleanAxRef(shape, 'yref');
	    }
	
	    var legend = layout.legend;
	    if(legend) {
	        // check for old-style legend positioning (x or y is +/- 100)
	        if(legend.x > 3) {
	            legend.x = 1.02;
	            legend.xanchor = 'left';
	        } else if(legend.x < -2) {
	            legend.x = -0.02;
	            legend.xanchor = 'right';
	        }
	
	        if(legend.y > 3) {
	            legend.y = 1.02;
	            legend.yanchor = 'bottom';
	        } else if(legend.y < -2) {
	            legend.y = -0.02;
	            legend.yanchor = 'top';
	        }
	    }
	
	    // clean plot title
	    cleanTitle(layout);
	
	    /*
	     * Moved from rotate -> orbit for dragmode
	     */
	    if(layout.dragmode === 'rotate') layout.dragmode = 'orbit';
	
	    // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
	    // supported, but new tinycolor does not because they're not valid css
	    Color.clean(layout);
	
	    // clean the layout container in layout.template
	    if(layout.template && layout.template.layout) {
	        exports.cleanLayout(layout.template.layout);
	    }
	
	    return layout;
	};
	
	function cleanAxRef(container, attr) {
	    var valIn = container[attr];
	    var axLetter = attr.charAt(0);
	    if(valIn && valIn !== 'paper') {
	        container[attr] = cleanId(valIn, axLetter);
	    }
	}
	
	/**
	 * Cleans up old title attribute structure (flat) in favor of the new one (nested).
	 *
	 * @param {Object} titleContainer - an object potentially including deprecated title attributes
	 */
	function cleanTitle(titleContainer) {
	    if(titleContainer) {
	        // title -> title.text
	        // (although title used to be a string attribute,
	        // numbers are accepted as well)
	        if(typeof titleContainer.title === 'string' || typeof titleContainer.title === 'number') {
	            titleContainer.title = {
	                text: titleContainer.title
	            };
	        }
	
	        rewireAttr('titlefont', 'font');
	        rewireAttr('titleposition', 'position');
	        rewireAttr('titleside', 'side');
	        rewireAttr('titleoffset', 'offset');
	    }
	
	    function rewireAttr(oldAttrName, newAttrName) {
	        var oldAttrSet = titleContainer[oldAttrName];
	        var newAttrSet = titleContainer.title && titleContainer.title[newAttrName];
	
	        if(oldAttrSet && !newAttrSet) {
	            // Ensure title object exists
	            if(!titleContainer.title) {
	                titleContainer.title = {};
	            }
	
	            titleContainer.title[newAttrName] = titleContainer[oldAttrName];
	            delete titleContainer[oldAttrName];
	        }
	    }
	}
	
	/*
	 * cleanData: Make a few changes to the data for backward compatibility
	 * before it gets used for anything. Modifies the data traces users provide.
	 *
	 * Important: if you're going to add something here that modifies a data array,
	 * update it in place so the new array === the old one.
	 */
	exports.cleanData = function(data) {
	    for(var tracei = 0; tracei < data.length; tracei++) {
	        var trace = data[tracei];
	        var i;
	
	        // use xbins to bin data in x, and ybins to bin data in y
	        if(trace.type === 'histogramy' && 'xbins' in trace && !('ybins' in trace)) {
	            trace.ybins = trace.xbins;
	            delete trace.xbins;
	        }
	
	        // error_y.opacity is obsolete - merge into color
	        if(trace.error_y && 'opacity' in trace.error_y) {
	            var dc = Color.defaults;
	            var yeColor = trace.error_y.color || (traceIs(trace, 'bar') ?
	                Color.defaultLine :
	                dc[tracei % dc.length]);
	            trace.error_y.color = Color.addOpacity(
	                Color.rgb(yeColor),
	                Color.opacity(yeColor) * trace.error_y.opacity);
	            delete trace.error_y.opacity;
	        }
	
	        // convert bardir to orientation, and put the data into
	        // the axes it's eventually going to be used with
	        if('bardir' in trace) {
	            if(trace.bardir === 'h' && (traceIs(trace, 'bar') ||
	                trace.type.substr(0, 9) === 'histogram')) {
	                trace.orientation = 'h';
	                exports.swapXYData(trace);
	            }
	            delete trace.bardir;
	        }
	
	        // now we have only one 1D histogram type, and whether
	        // it uses x or y data depends on trace.orientation
	        if(trace.type === 'histogramy') exports.swapXYData(trace);
	        if(trace.type === 'histogramx' || trace.type === 'histogramy') {
	            trace.type = 'histogram';
	        }
	
	        // scl->scale, reversescl->reversescale
	        if('scl' in trace && !('colorscale' in trace)) {
	            trace.colorscale = trace.scl;
	            delete trace.scl;
	        }
	        if('reversescl' in trace && !('reversescale' in trace)) {
	            trace.reversescale = trace.reversescl;
	            delete trace.reversescl;
	        }
	
	        // axis ids x1 -> x, y1-> y
	        if(trace.xaxis) trace.xaxis = cleanId(trace.xaxis, 'x');
	        if(trace.yaxis) trace.yaxis = cleanId(trace.yaxis, 'y');
	
	        // scene ids scene1 -> scene
	        if(traceIs(trace, 'gl3d') && trace.scene) {
	            trace.scene = Plots.subplotsRegistry.gl3d.cleanId(trace.scene);
	        }
	
	        if(!traceIs(trace, 'pie-like') && !traceIs(trace, 'bar-like')) {
	            if(Array.isArray(trace.textposition)) {
	                for(i = 0; i < trace.textposition.length; i++) {
	                    trace.textposition[i] = cleanTextPosition(trace.textposition[i]);
	                }
	            } else if(trace.textposition) {
	                trace.textposition = cleanTextPosition(trace.textposition);
	            }
	        }
	
	        // fix typo in colorscale definition
	        var _module = Registry.getModule(trace);
	        if(_module && _module.colorbar) {
	            var containerName = _module.colorbar.container;
	            var container = containerName ? trace[containerName] : trace;
	            if(container && container.colorscale) {
	                if(container.colorscale === 'YIGnBu') container.colorscale = 'YlGnBu';
	                if(container.colorscale === 'YIOrRd') container.colorscale = 'YlOrRd';
	            }
	        }
	
	        // fix typo in surface 'highlight*' definitions
	        if(trace.type === 'surface' && Lib.isPlainObject(trace.contours)) {
	            var dims = ['x', 'y', 'z'];
	
	            for(i = 0; i < dims.length; i++) {
	                var opts = trace.contours[dims[i]];
	
	                if(!Lib.isPlainObject(opts)) continue;
	
	                if(opts.highlightColor) {
	                    opts.highlightcolor = opts.highlightColor;
	                    delete opts.highlightColor;
	                }
	
	                if(opts.highlightWidth) {
	                    opts.highlightwidth = opts.highlightWidth;
	                    delete opts.highlightWidth;
	                }
	            }
	        }
	
	        // fixes from converting finance from transforms to real trace types
	        if(trace.type === 'candlestick' || trace.type === 'ohlc') {
	            var increasingShowlegend = (trace.increasing || {}).showlegend !== false;
	            var decreasingShowlegend = (trace.decreasing || {}).showlegend !== false;
	            var increasingName = cleanFinanceDir(trace.increasing);
	            var decreasingName = cleanFinanceDir(trace.decreasing);
	
	            // now figure out something smart to do with the separate direction
	            // names we removed
	            if((increasingName !== false) && (decreasingName !== false)) {
	                // both sub-names existed: base name previously had no effect
	                // so ignore it and try to find a shared part of the sub-names
	
	                var newName = commonPrefix(
	                    increasingName, decreasingName,
	                    increasingShowlegend, decreasingShowlegend
	                );
	                // if no common part, leave whatever name was (or wasn't) there
	                if(newName) trace.name = newName;
	            } else if((increasingName || decreasingName) && !trace.name) {
	                // one sub-name existed but not the base name - just use the sub-name
	                trace.name = increasingName || decreasingName;
	            }
	        }
	
	        // transforms backward compatibility fixes
	        if(Array.isArray(trace.transforms)) {
	            var transforms = trace.transforms;
	
	            for(i = 0; i < transforms.length; i++) {
	                var transform = transforms[i];
	
	                if(!Lib.isPlainObject(transform)) continue;
	
	                switch(transform.type) {
	                    case 'filter':
	                        if(transform.filtersrc) {
	                            transform.target = transform.filtersrc;
	                            delete transform.filtersrc;
	                        }
	
	                        if(transform.calendar) {
	                            if(!transform.valuecalendar) {
	                                transform.valuecalendar = transform.calendar;
	                            }
	                            delete transform.calendar;
	                        }
	                        break;
	
	                    case 'groupby':
	                        // Name has changed from `style` to `styles`, so use `style` but prefer `styles`:
	                        transform.styles = transform.styles || transform.style;
	
	                        if(transform.styles && !Array.isArray(transform.styles)) {
	                            var prevStyles = transform.styles;
	                            var styleKeys = Object.keys(prevStyles);
	
	                            transform.styles = [];
	                            for(var j = 0; j < styleKeys.length; j++) {
	                                transform.styles.push({
	                                    target: styleKeys[j],
	                                    value: prevStyles[styleKeys[j]]
	                                });
	                            }
	                        }
	                        break;
	                }
	            }
	        }
	
	        // prune empty containers made before the new nestedProperty
	        if(emptyContainer(trace, 'line')) delete trace.line;
	        if('marker' in trace) {
	            if(emptyContainer(trace.marker, 'line')) delete trace.marker.line;
	            if(emptyContainer(trace, 'marker')) delete trace.marker;
	        }
	
	        // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
	        // supported, but new tinycolor does not because they're not valid css
	        Color.clean(trace);
	
	        // remove obsolete autobin(x|y) attributes, but only if true
	        // if false, this needs to happen in Histogram.calc because it
	        // can be a one-time autobin so we need to know the results before
	        // we can push them back into the trace.
	        if(trace.autobinx) {
	            delete trace.autobinx;
	            delete trace.xbins;
	        }
	        if(trace.autobiny) {
	            delete trace.autobiny;
	            delete trace.ybins;
	        }
	
	        cleanTitle(trace);
	        if(trace.colorbar) cleanTitle(trace.colorbar);
	        if(trace.marker && trace.marker.colorbar) cleanTitle(trace.marker.colorbar);
	        if(trace.line && trace.line.colorbar) cleanTitle(trace.line.colorbar);
	        if(trace.aaxis) cleanTitle(trace.aaxis);
	        if(trace.baxis) cleanTitle(trace.baxis);
	    }
	};
	
	function cleanFinanceDir(dirContainer) {
	    if(!Lib.isPlainObject(dirContainer)) return false;
	
	    var dirName = dirContainer.name;
	
	    delete dirContainer.name;
	    delete dirContainer.showlegend;
	
	    return (typeof dirName === 'string' || typeof dirName === 'number') && String(dirName);
	}
	
	function commonPrefix(name1, name2, show1, show2) {
	    // if only one is shown in the legend, use that
	    if(show1 && !show2) return name1;
	    if(show2 && !show1) return name2;
	
	    // if both or neither are in the legend, check if one is blank (or whitespace)
	    // and use the other one
	    // note that hover labels can still use the name even if the legend doesn't
	    if(!name1.trim()) return name2;
	    if(!name2.trim()) return name1;
	
	    var minLen = Math.min(name1.length, name2.length);
	    var i;
	    for(i = 0; i < minLen; i++) {
	        if(name1.charAt(i) !== name2.charAt(i)) break;
	    }
	
	    var out = name1.substr(0, i);
	    return out.trim();
	}
	
	// textposition - support partial attributes (ie just 'top')
	// and incorrect use of middle / center etc.
	function cleanTextPosition(textposition) {
	    var posY = 'middle';
	    var posX = 'center';
	
	    if(typeof textposition === 'string') {
	        if(textposition.indexOf('top') !== -1) posY = 'top';
	        else if(textposition.indexOf('bottom') !== -1) posY = 'bottom';
	
	        if(textposition.indexOf('left') !== -1) posX = 'left';
	        else if(textposition.indexOf('right') !== -1) posX = 'right';
	    }
	
	    return posY + ' ' + posX;
	}
	
	function emptyContainer(outer, innerStr) {
	    return (innerStr in outer) &&
	        (typeof outer[innerStr] === 'object') &&
	        (Object.keys(outer[innerStr]).length === 0);
	}
	
	
	// swap all the data and data attributes associated with x and y
	exports.swapXYData = function(trace) {
	    var i;
	    Lib.swapAttrs(trace, ['?', '?0', 'd?', '?bins', 'nbins?', 'autobin?', '?src', 'error_?']);
	    if(Array.isArray(trace.z) && Array.isArray(trace.z[0])) {
	        if(trace.transpose) delete trace.transpose;
	        else trace.transpose = true;
	    }
	    if(trace.error_x && trace.error_y) {
	        var errorY = trace.error_y;
	        var copyYstyle = ('copy_ystyle' in errorY) ?
	            errorY.copy_ystyle :
	            !(errorY.color || errorY.thickness || errorY.width);
	        Lib.swapAttrs(trace, ['error_?.copy_ystyle']);
	        if(copyYstyle) {
	            Lib.swapAttrs(trace, ['error_?.color', 'error_?.thickness', 'error_?.width']);
	        }
	    }
	    if(typeof trace.hoverinfo === 'string') {
	        var hoverInfoParts = trace.hoverinfo.split('+');
	        for(i = 0; i < hoverInfoParts.length; i++) {
	            if(hoverInfoParts[i] === 'x') hoverInfoParts[i] = 'y';
	            else if(hoverInfoParts[i] === 'y') hoverInfoParts[i] = 'x';
	        }
	        trace.hoverinfo = hoverInfoParts.join('+');
	    }
	};
	
	// coerce traceIndices input to array of trace indices
	exports.coerceTraceIndices = function(gd, traceIndices) {
	    if(isNumeric(traceIndices)) {
	        return [traceIndices];
	    } else if(!Array.isArray(traceIndices) || !traceIndices.length) {
	        return gd.data.map(function(_, i) { return i; });
	    } else if(Array.isArray(traceIndices)) {
	        var traceIndicesOut = [];
	        for(var i = 0; i < traceIndices.length; i++) {
	            if(Lib.isIndex(traceIndices[i], gd.data.length)) {
	                traceIndicesOut.push(traceIndices[i]);
	            } else {
	                Lib.warn('trace index (', traceIndices[i], ') is not a number or is out of bounds');
	            }
	        }
	        return traceIndicesOut;
	    }
	
	    return traceIndices;
	};
	
	/**
	 * Manages logic around array container item creation / deletion / update
	 * that nested property alone can't handle.
	 *
	 * @param {Object} np
	 *  nested property of update attribute string about trace or layout object
	 * @param {*} newVal
	 *  update value passed to restyle / relayout / update
	 * @param {Object} undoit
	 *  undo hash (N.B. undoit may be mutated here).
	 *
	 */
	exports.manageArrayContainers = function(np, newVal, undoit) {
	    var obj = np.obj;
	    var parts = np.parts;
	    var pLength = parts.length;
	    var pLast = parts[pLength - 1];
	
	    var pLastIsNumber = isNumeric(pLast);
	
	    if(pLastIsNumber && newVal === null) {
	        // delete item
	
	        // Clear item in array container when new value is null
	        var contPath = parts.slice(0, pLength - 1).join('.');
	        var cont = Lib.nestedProperty(obj, contPath).get();
	        cont.splice(pLast, 1);
	
	        // Note that nested property clears null / undefined at end of
	        // array container, but not within them.
	    } else if(pLastIsNumber && np.get() === undefined) {
	        // create item
	
	        // When adding a new item, make sure undo command will remove it
	        if(np.get() === undefined) undoit[np.astr] = null;
	
	        np.set(newVal);
	    } else {
	        // update item
	
	        // If the last part of attribute string isn't a number,
	        // np.set is all we need.
	        np.set(newVal);
	    }
	};
	
	/*
	 * Match the part to strip off to turn an attribute into its parent
	 * really it should be either '.some_characters' or '[number]'
	 * but we're a little more permissive here and match either
	 * '.not_brackets_or_dot' or '[not_brackets_or_dot]'
	 */
	var ATTR_TAIL_RE = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
	
	function getParent(attr) {
	    var tail = attr.search(ATTR_TAIL_RE);
	    if(tail > 0) return attr.substr(0, tail);
	}
	
	/*
	 * hasParent: does an attribute object contain a parent of the given attribute?
	 * for example, given 'images[2].x' do we also have 'images' or 'images[2]'?
	 *
	 * @param {Object} aobj
	 *  update object, whose keys are attribute strings and values are their new settings
	 * @param {string} attr
	 *  the attribute string to test against
	 * @returns {Boolean}
	 *  is a parent of attr present in aobj?
	 */
	exports.hasParent = function(aobj, attr) {
	    var attrParent = getParent(attr);
	    while(attrParent) {
	        if(attrParent in aobj) return true;
	        attrParent = getParent(attrParent);
	    }
	    return false;
	};
	
	/**
	 * Empty out types for all axes containing these traces so we auto-set them again
	 *
	 * @param {object} gd
	 * @param {[integer]} traces: trace indices to search for axes to clear the types of
	 * @param {object} layoutUpdate: any update being done concurrently to the layout,
	 *   which may supercede clearing the axis types
	 */
	var axLetters = ['x', 'y', 'z'];
	exports.clearAxisTypes = function(gd, traces, layoutUpdate) {
	    for(var i = 0; i < traces.length; i++) {
	        var trace = gd._fullData[i];
	        for(var j = 0; j < 3; j++) {
	            var ax = getFromTrace(gd, trace, axLetters[j]);
	
	            // do not clear log type - that's never an auto result so must have been intentional
	            if(ax && ax.type !== 'log') {
	                var axAttr = ax._name;
	                var sceneName = ax._id.substr(1);
	                if(sceneName.substr(0, 5) === 'scene') {
	                    if(layoutUpdate[sceneName] !== undefined) continue;
	                    axAttr = sceneName + '.' + axAttr;
	                }
	                var typeAttr = axAttr + '.type';
	
	                if(layoutUpdate[axAttr] === undefined && layoutUpdate[typeAttr] === undefined) {
	                    Lib.nestedProperty(gd.layout, typeAttr).set(null);
	                }
	            }
	        }
	    }
	};
	
	},{"../components/color":591,"../lib":716,"../plots/cartesian/axis_ids":767,"../plots/plots":825,"../registry":845,"fast-isnumeric":227,"gl-mat4/fromQuat":264}],749:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var main = _dereq_('./plot_api');
	
	exports.plot = main.plot;
	exports.newPlot = main.newPlot;
	exports.restyle = main.restyle;
	exports.relayout = main.relayout;
	exports.redraw = main.redraw;
	exports.update = main.update;
	exports._guiRestyle = main._guiRestyle;
	exports._guiRelayout = main._guiRelayout;
	exports._guiUpdate = main._guiUpdate;
	exports._storeDirectGUIEdit = main._storeDirectGUIEdit;
	exports.react = main.react;
	exports.extendTraces = main.extendTraces;
	exports.prependTraces = main.prependTraces;
	exports.addTraces = main.addTraces;
	exports.deleteTraces = main.deleteTraces;
	exports.moveTraces = main.moveTraces;
	exports.purge = main.purge;
	exports.addFrames = main.addFrames;
	exports.deleteFrames = main.deleteFrames;
	exports.animate = main.animate;
	exports.setPlotConfig = main.setPlotConfig;
	
	exports.toImage = _dereq_('./to_image');
	exports.validate = _dereq_('./validate');
	exports.downloadImage = _dereq_('../snapshot/download');
	
	var templateApi = _dereq_('./template_api');
	exports.makeTemplate = templateApi.makeTemplate;
	exports.validateTemplate = templateApi.validateTemplate;
	
	},{"../snapshot/download":847,"./plot_api":751,"./template_api":756,"./to_image":757,"./validate":758}],750:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isPlainObject = _dereq_('../lib/is_plain_object');
	var noop = _dereq_('../lib/noop');
	var Loggers = _dereq_('../lib/loggers');
	var sorterAsc = _dereq_('../lib/search').sorterAsc;
	var Registry = _dereq_('../registry');
	
	
	exports.containerArrayMatch = _dereq_('./container_array_match');
	
	var isAddVal = exports.isAddVal = function isAddVal(val) {
	    return val === 'add' || isPlainObject(val);
	};
	
	var isRemoveVal = exports.isRemoveVal = function isRemoveVal(val) {
	    return val === null || val === 'remove';
	};
	
	/*
	 * applyContainerArrayChanges: for managing arrays of layout components in relayout
	 * handles them all with a consistent interface.
	 *
	 * Here are the supported actions -> relayout calls -> edits we get here
	 * (as prepared in _relayout):
	 *
	 * add an empty obj -> {'annotations[2]': 'add'} -> {2: {'': 'add'}}
	 * add a specific obj -> {'annotations[2]': {attrs}} -> {2: {'': {attrs}}}
	 * delete an obj -> {'annotations[2]': 'remove'} -> {2: {'': 'remove'}}
	 *               -> {'annotations[2]': null} -> {2: {'': null}}
	 * delete the whole array -> {'annotations': 'remove'} -> {'': {'': 'remove'}}
	 *                        -> {'annotations': null} -> {'': {'': null}}
	 * edit an object -> {'annotations[2].text': 'boo'} -> {2: {'text': 'boo'}}
	 *
	 * You can combine many edits to different objects. Objects are added and edited
	 * in ascending order, then removed in descending order.
	 * For example, starting with [a, b, c], if you want to:
	 * - replace b with d:
	 *   {'annotations[1]': d, 'annotations[2]': null} (b is item 2 after adding d)
	 * - add a new item d between a and b, and edit b:
	 *    {'annotations[1]': d, 'annotations[2].x': newX} (b is item 2 after adding d)
	 * - delete b and edit c:
	 *    {'annotations[1]': null, 'annotations[2].x': newX} (c is edited before b is removed)
	 *
	 * You CANNOT combine adding/deleting an item at index `i` with edits to the same index `i`
	 * You CANNOT combine replacing/deleting the whole array with anything else (for the same array).
	 *
	 * @param {HTMLDivElement} gd
	 *  the DOM element of the graph container div
	 * @param {Lib.nestedProperty} componentType: the array we are editing
	 * @param {Object} edits
	 *  the changes to make; keys are indices to edit, values are themselves objects:
	 *  {attr: newValue} of changes to make to that index (with add/remove behavior
	 *  in special values of the empty attr)
	 * @param {Object} flags
	 *  the flags for which actions we're going to perform to display these (and
	 *  any other) changes. If we're already `recalc`ing, we don't need to redraw
	 *  individual items
	 * @param {function} _nestedProperty
	 *  a (possibly modified for gui edits) nestedProperty constructor
	 *  The modified version takes a 3rd argument, for a prefix to the attribute
	 *  string necessary for storing GUI edits
	 *
	 * @returns {bool} `true` if it managed to complete drawing of the changes
	 *  `false` would mean the parent should replot.
	 */
	exports.applyContainerArrayChanges = function applyContainerArrayChanges(gd, np, edits, flags, _nestedProperty) {
	    var componentType = np.astr;
	    var supplyComponentDefaults = Registry.getComponentMethod(componentType, 'supplyLayoutDefaults');
	    var draw = Registry.getComponentMethod(componentType, 'draw');
	    var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
	    var replotLater = flags.replot || flags.recalc || (supplyComponentDefaults === noop) || (draw === noop);
	    var layout = gd.layout;
	    var fullLayout = gd._fullLayout;
	
	    if(edits['']) {
	        if(Object.keys(edits).length > 1) {
	            Loggers.warn('Full array edits are incompatible with other edits',
	                componentType);
	        }
	
	        var fullVal = edits[''][''];
	
	        if(isRemoveVal(fullVal)) np.set(null);
	        else if(Array.isArray(fullVal)) np.set(fullVal);
	        else {
	            Loggers.warn('Unrecognized full array edit value', componentType, fullVal);
	            return true;
	        }
	
	        if(replotLater) return false;
	
	        supplyComponentDefaults(layout, fullLayout);
	        draw(gd);
	        return true;
	    }
	
	    var componentNums = Object.keys(edits).map(Number).sort(sorterAsc);
	    var componentArrayIn = np.get();
	    var componentArray = componentArrayIn || [];
	    // componentArrayFull is used just to keep splices in line between
	    // full and input arrays, so private keys can be copied over after
	    // redoing supplyDefaults
	    // TODO: this assumes componentArray is in gd.layout - which will not be
	    // true after we extend this to restyle
	    var componentArrayFull = _nestedProperty(fullLayout, componentType).get();
	
	    var deletes = [];
	    var firstIndexChange = -1;
	    var maxIndex = componentArray.length;
	    var i;
	    var j;
	    var componentNum;
	    var objEdits;
	    var objKeys;
	    var objVal;
	    var adding, prefix;
	
	    // first make the add and edit changes
	    for(i = 0; i < componentNums.length; i++) {
	        componentNum = componentNums[i];
	        objEdits = edits[componentNum];
	        objKeys = Object.keys(objEdits);
	        objVal = objEdits[''],
	        adding = isAddVal(objVal);
	
	        if(componentNum < 0 || componentNum > componentArray.length - (adding ? 0 : 1)) {
	            Loggers.warn('index out of range', componentType, componentNum);
	            continue;
	        }
	
	        if(objVal !== undefined) {
	            if(objKeys.length > 1) {
	                Loggers.warn(
	                    'Insertion & removal are incompatible with edits to the same index.',
	                    componentType, componentNum);
	            }
	
	            if(isRemoveVal(objVal)) {
	                deletes.push(componentNum);
	            } else if(adding) {
	                if(objVal === 'add') objVal = {};
	                componentArray.splice(componentNum, 0, objVal);
	                if(componentArrayFull) componentArrayFull.splice(componentNum, 0, {});
	            } else {
	                Loggers.warn('Unrecognized full object edit value',
	                    componentType, componentNum, objVal);
	            }
	
	            if(firstIndexChange === -1) firstIndexChange = componentNum;
	        } else {
	            for(j = 0; j < objKeys.length; j++) {
	                prefix = componentType + '[' + componentNum + '].';
	                _nestedProperty(componentArray[componentNum], objKeys[j], prefix)
	                    .set(objEdits[objKeys[j]]);
	            }
	        }
	    }
	
	    // now do deletes
	    for(i = deletes.length - 1; i >= 0; i--) {
	        componentArray.splice(deletes[i], 1);
	        // TODO: this drops private keys that had been stored in componentArrayFull
	        // does this have any ill effects?
	        if(componentArrayFull) componentArrayFull.splice(deletes[i], 1);
	    }
	
	    if(!componentArray.length) np.set(null);
	    else if(!componentArrayIn) np.set(componentArray);
	
	    if(replotLater) return false;
	
	    supplyComponentDefaults(layout, fullLayout);
	
	    // finally draw all the components we need to
	    // if we added or removed any, redraw all after it
	    if(drawOne !== noop) {
	        var indicesToDraw;
	        if(firstIndexChange === -1) {
	            // there's no re-indexing to do, so only redraw components that changed
	            indicesToDraw = componentNums;
	        } else {
	            // in case the component array was shortened, we still need do call
	            // drawOne on the latter items so they get properly removed
	            maxIndex = Math.max(componentArray.length, maxIndex);
	            indicesToDraw = [];
	            for(i = 0; i < componentNums.length; i++) {
	                componentNum = componentNums[i];
	                if(componentNum >= firstIndexChange) break;
	                indicesToDraw.push(componentNum);
	            }
	            for(i = firstIndexChange; i < maxIndex; i++) {
	                indicesToDraw.push(i);
	            }
	        }
	        for(i = 0; i < indicesToDraw.length; i++) {
	            drawOne(gd, indicesToDraw[i]);
	        }
	    } else draw(gd);
	
	    return true;
	};
	
	},{"../lib/is_plain_object":717,"../lib/loggers":720,"../lib/noop":725,"../lib/search":735,"../registry":845,"./container_array_match":746}],751:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	var hasHover = _dereq_('has-hover');
	
	var Lib = _dereq_('../lib');
	var nestedProperty = Lib.nestedProperty;
	
	var Events = _dereq_('../lib/events');
	var Queue = _dereq_('../lib/queue');
	
	var Registry = _dereq_('../registry');
	var PlotSchema = _dereq_('./plot_schema');
	var Plots = _dereq_('../plots/plots');
	var Polar = _dereq_('../plots/polar/legacy');
	
	var Axes = _dereq_('../plots/cartesian/axes');
	var Drawing = _dereq_('../components/drawing');
	var Color = _dereq_('../components/color');
	var initInteractions = _dereq_('../plots/cartesian/graph_interact').initInteractions;
	var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
	var svgTextUtils = _dereq_('../lib/svg_text_utils');
	var clearSelect = _dereq_('../plots/cartesian/select').clearSelect;
	
	var dfltConfig = _dereq_('./plot_config').dfltConfig;
	var manageArrays = _dereq_('./manage_arrays');
	var helpers = _dereq_('./helpers');
	var subroutines = _dereq_('./subroutines');
	var editTypes = _dereq_('./edit_types');
	
	var AX_NAME_PATTERN = _dereq_('../plots/cartesian/constants').AX_NAME_PATTERN;
	
	var numericNameWarningCount = 0;
	var numericNameWarningCountLimit = 5;
	
	/**
	 * Main plot-creation function
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 * @param {array of objects} data
	 *      array of traces, containing the data and display information for each trace
	 * @param {object} layout
	 *      object describing the overall display of the plot,
	 *      all the stuff that doesn't pertain to any individual trace
	 * @param {object} config
	 *      configuration options (see ./plot_config.js for more info)
	 *
	 * OR
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 * @param {object} figure
	 *      object containing `data`, `layout`, `config`, and `frames` members
	 *
	 */
	function plot(gd, data, layout, config) {
	    var frames;
	
	    gd = Lib.getGraphDiv(gd);
	
	    // Events.init is idempotent and bails early if gd has already been init'd
	    Events.init(gd);
	
	    if(Lib.isPlainObject(data)) {
	        var obj = data;
	        data = obj.data;
	        layout = obj.layout;
	        config = obj.config;
	        frames = obj.frames;
	    }
	
	    var okToPlot = Events.triggerHandler(gd, 'plotly_beforeplot', [data, layout, config]);
	    if(okToPlot === false) return Promise.reject();
	
	    // if there's no data or layout, and this isn't yet a plotly plot
	    // container, log a warning to help plotly.js users debug
	    if(!data && !layout && !Lib.isPlotDiv(gd)) {
	        Lib.warn('Calling Plotly.plot as if redrawing ' +
	            'but this container doesn\'t yet have a plot.', gd);
	    }
	
	    function addFrames() {
	        if(frames) {
	            return exports.addFrames(gd, frames);
	        }
	    }
	
	    // transfer configuration options to gd until we move over to
	    // a more OO like model
	    setPlotContext(gd, config);
	
	    if(!layout) layout = {};
	
	    // hook class for plots main container (in case of plotly.js
	    // this won't be #embedded-graph or .js-tab-contents)
	    d3.select(gd).classed('js-plotly-plot', true);
	
	    // off-screen getBoundingClientRect testing space,
	    // in #js-plotly-tester (and stored as Drawing.tester)
	    // so we can share cached text across tabs
	    Drawing.makeTester();
	
	    // collect promises for any async actions during plotting
	    // any part of the plotting code can push to gd._promises, then
	    // before we move to the next step, we check that they're all
	    // complete, and empty out the promise list again.
	    if(!Array.isArray(gd._promises)) gd._promises = [];
	
	    var graphWasEmpty = ((gd.data || []).length === 0 && Array.isArray(data));
	
	    // if there is already data on the graph, append the new data
	    // if you only want to redraw, pass a non-array for data
	    if(Array.isArray(data)) {
	        helpers.cleanData(data);
	
	        if(graphWasEmpty) gd.data = data;
	        else gd.data.push.apply(gd.data, data);
	
	        // for routines outside graph_obj that want a clean tab
	        // (rather than appending to an existing one) gd.empty
	        // is used to determine whether to make a new tab
	        gd.empty = false;
	    }
	
	    if(!gd.layout || graphWasEmpty) {
	        gd.layout = helpers.cleanLayout(layout);
	    }
	
	    Plots.supplyDefaults(gd);
	
	    var fullLayout = gd._fullLayout;
	    var hasCartesian = fullLayout._has('cartesian');
	
	    // Legacy polar plots
	    if(!fullLayout._has('polar') && data && data[0] && data[0].r) {
	        Lib.log('Legacy polar charts are deprecated!');
	        return plotLegacyPolar(gd, data, layout);
	    }
	
	    // so we don't try to re-call Plotly.plot from inside
	    // legend and colorbar, if margins changed
	    fullLayout._replotting = true;
	
	    // make or remake the framework if we need to
	    if(graphWasEmpty) makePlotFramework(gd);
	
	    // polar need a different framework
	    if(gd.framework !== makePlotFramework) {
	        gd.framework = makePlotFramework;
	        makePlotFramework(gd);
	    }
	
	    // clear gradient defs on each .plot call, because we know we'll loop through all traces
	    Drawing.initGradients(gd);
	
	    // save initial show spikes once per graph
	    if(graphWasEmpty) Axes.saveShowSpikeInitial(gd);
	
	    // prepare the data and find the autorange
	
	    // generate calcdata, if we need to
	    // to force redoing calcdata, just delete it before calling Plotly.plot
	    var recalc = !gd.calcdata || gd.calcdata.length !== (gd._fullData || []).length;
	    if(recalc) Plots.doCalcdata(gd);
	
	    // in case it has changed, attach fullData traces to calcdata
	    for(var i = 0; i < gd.calcdata.length; i++) {
	        gd.calcdata[i][0].trace = gd._fullData[i];
	    }
	
	    // make the figure responsive
	    if(gd._context.responsive) {
	        if(!gd._responsiveChartHandler) {
	            // Keep a reference to the resize handler to purge it down the road
	            gd._responsiveChartHandler = function() { if(!Lib.isHidden(gd)) Plots.resize(gd); };
	
	            // Listen to window resize
	            window.addEventListener('resize', gd._responsiveChartHandler);
	        }
	    } else {
	        Lib.clearResponsive(gd);
	    }
	
	    /*
	     * start async-friendly code - now we're actually drawing things
	     */
	
	    var oldMargins = Lib.extendFlat({}, fullLayout._size);
	
	    // draw framework first so that margin-pushing
	    // components can position themselves correctly
	    var drawFrameworkCalls = 0;
	    function drawFramework() {
	        var basePlotModules = fullLayout._basePlotModules;
	
	        for(var i = 0; i < basePlotModules.length; i++) {
	            if(basePlotModules[i].drawFramework) {
	                basePlotModules[i].drawFramework(gd);
	            }
	        }
	
	        if(!fullLayout._glcanvas && fullLayout._has('gl')) {
	            fullLayout._glcanvas = fullLayout._glcontainer.selectAll('.gl-canvas').data([{
	                key: 'contextLayer',
	                context: true,
	                pick: false
	            }, {
	                key: 'focusLayer',
	                context: false,
	                pick: false
	            }, {
	                key: 'pickLayer',
	                context: false,
	                pick: true
	            }], function(d) { return d.key; });
	
	            fullLayout._glcanvas.enter().append('canvas')
	                .attr('class', function(d) {
	                    return 'gl-canvas gl-canvas-' + d.key.replace('Layer', '');
	                })
	                .style({
	                    position: 'absolute',
	                    top: 0,
	                    left: 0,
	                    overflow: 'visible',
	                    'pointer-events': 'none'
	                });
	        }
	
	        if(fullLayout._glcanvas) {
	            fullLayout._glcanvas
	                .attr('width', fullLayout.width)
	                .attr('height', fullLayout.height);
	
	            var regl = fullLayout._glcanvas.data()[0].regl;
	            if(regl) {
	                // Unfortunately, this can happen when relayouting to large
	                // width/height on some browsers.
	                if(Math.floor(fullLayout.width) !== regl._gl.drawingBufferWidth ||
	                    Math.floor(fullLayout.height) !== regl._gl.drawingBufferHeight
	                 ) {
	                    var msg = 'WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.';
	                    if(drawFrameworkCalls) {
	                        Lib.error(msg);
	                    } else {
	                        Lib.log(msg + ' Clearing graph and plotting again.');
	                        Plots.cleanPlot([], {}, gd._fullData, fullLayout);
	                        Plots.supplyDefaults(gd);
	                        fullLayout = gd._fullLayout;
	                        Plots.doCalcdata(gd);
	                        drawFrameworkCalls++;
	                        return drawFramework();
	                    }
	                }
	            }
	        }
	
	        if(fullLayout.modebar.orientation === 'h') {
	            fullLayout._modebardiv
	              .style('height', null)
	              .style('width', '100%');
	        } else {
	            fullLayout._modebardiv
	              .style('width', null)
	              .style('height', fullLayout.height + 'px');
	        }
	
	        return Plots.previousPromises(gd);
	    }
	
	    // draw anything that can affect margins.
	    function marginPushers() {
	        // First reset the list of things that are allowed to change the margins
	        // So any deleted traces or components will be wiped out of the
	        // automargin calculation.
	        // This means *every* margin pusher must be listed here, even if it
	        // doesn't actually try to push the margins until later.
	        Plots.clearAutoMarginIds(gd);
	
	        subroutines.drawMarginPushers(gd);
	        Axes.allowAutoMargin(gd);
	
	        // TODO can this be moved elsewhere?
	        if(fullLayout._has('pie')) {
	            var fullData = gd._fullData;
	            for(var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if(trace.type === 'pie' && trace.automargin) {
	                    Plots.allowAutoMargin(gd, 'pie.' + trace.uid + '.automargin');
	                }
	            }
	        }
	
	        Plots.doAutoMargin(gd);
	        return Plots.previousPromises(gd);
	    }
	
	    // in case the margins changed, draw margin pushers again
	    function marginPushersAgain() {
	        if(!Plots.didMarginChange(oldMargins, fullLayout._size)) return;
	
	        return Lib.syncOrAsync([
	            marginPushers,
	            subroutines.layoutStyles
	        ], gd);
	    }
	
	    function positionAndAutorange() {
	        if(!recalc) {
	            doAutoRangeAndConstraints();
	            return;
	        }
	
	        // TODO: autosize extra for text markers and images
	        // see https://github.com/plotly/plotly.js/issues/1111
	        return Lib.syncOrAsync([
	            Registry.getComponentMethod('shapes', 'calcAutorange'),
	            Registry.getComponentMethod('annotations', 'calcAutorange'),
	            doAutoRangeAndConstraints
	        ], gd);
	    }
	
	    function doAutoRangeAndConstraints() {
	        if(gd._transitioning) return;
	
	        subroutines.doAutoRangeAndConstraints(gd);
	
	        // store initial ranges *after* enforcing constraints, otherwise
	        // we will never look like we're at the initial ranges
	        if(graphWasEmpty) Axes.saveRangeInitial(gd);
	
	        // this one is different from shapes/annotations calcAutorange
	        // the others incorporate those components into ax._extremes,
	        // this one actually sets the ranges in rangesliders.
	        Registry.getComponentMethod('rangeslider', 'calcAutorange')(gd);
	    }
	
	    // draw ticks, titles, and calculate axis scaling (._b, ._m)
	    function drawAxes() {
	        return Axes.draw(gd, graphWasEmpty ? '' : 'redraw');
	    }
	
	    var seq = [
	        Plots.previousPromises,
	        addFrames,
	        drawFramework,
	        marginPushers,
	        marginPushersAgain
	    ];
	
	    if(hasCartesian) seq.push(positionAndAutorange);
	
	    seq.push(subroutines.layoutStyles);
	    if(hasCartesian) seq.push(drawAxes);
	
	    seq.push(
	        subroutines.drawData,
	        subroutines.finalDraw,
	        initInteractions,
	        Plots.addLinks,
	        Plots.rehover,
	        Plots.redrag,
	        // TODO: doAutoMargin is only needed here for axis automargin, which
	        // happens outside of marginPushers where all the other automargins are
	        // calculated. Would be much better to separate margin calculations from
	        // component drawing - see https://github.com/plotly/plotly.js/issues/2704
	        Plots.doAutoMargin,
	        Plots.previousPromises
	    );
	
	    // even if everything we did was synchronous, return a promise
	    // so that the caller doesn't care which route we took
	    var plotDone = Lib.syncOrAsync(seq, gd);
	    if(!plotDone || !plotDone.then) plotDone = Promise.resolve();
	
	    return plotDone.then(function() {
	        emitAfterPlot(gd);
	        return gd;
	    });
	}
	
	function emitAfterPlot(gd) {
	    var fullLayout = gd._fullLayout;
	
	    if(fullLayout._redrawFromAutoMarginCount) {
	        fullLayout._redrawFromAutoMarginCount--;
	    } else {
	        gd.emit('plotly_afterplot');
	    }
	}
	
	function setPlotConfig(obj) {
	    return Lib.extendFlat(dfltConfig, obj);
	}
	
	function setBackground(gd, bgColor) {
	    try {
	        gd._fullLayout._paper.style('background', bgColor);
	    } catch(e) {
	        Lib.error(e);
	    }
	}
	
	function opaqueSetBackground(gd, bgColor) {
	    var blend = Color.combine(bgColor, 'white');
	    setBackground(gd, blend);
	}
	
	function setPlotContext(gd, config) {
	    if(!gd._context) {
	        gd._context = Lib.extendDeep({}, dfltConfig);
	
	        // stash <base> href, used to make robust clipPath URLs
	        var base = d3.select('base');
	        gd._context._baseUrl = base.size() && base.attr('href') ?
	            window.location.href.split('#')[0] :
	            '';
	    }
	
	    var context = gd._context;
	
	    var i, keys, key;
	
	    if(config) {
	        keys = Object.keys(config);
	        for(i = 0; i < keys.length; i++) {
	            key = keys[i];
	            if(key === 'editable' || key === 'edits') continue;
	            if(key in context) {
	                if(key === 'setBackground' && config[key] === 'opaque') {
	                    context[key] = opaqueSetBackground;
	                } else {
	                    context[key] = config[key];
	                }
	            }
	        }
	
	        // map plot3dPixelRatio to plotGlPixelRatio for backward compatibility
	        if(config.plot3dPixelRatio && !context.plotGlPixelRatio) {
	            context.plotGlPixelRatio = context.plot3dPixelRatio;
	        }
	
	        // now deal with editable and edits - first editable overrides
	        // everything, then edits refines
	        var editable = config.editable;
	        if(editable !== undefined) {
	            // we're not going to *use* context.editable, we're only going to
	            // use context.edits... but keep it for the record
	            context.editable = editable;
	
	            keys = Object.keys(context.edits);
	            for(i = 0; i < keys.length; i++) {
	                context.edits[keys[i]] = editable;
	            }
	        }
	        if(config.edits) {
	            keys = Object.keys(config.edits);
	            for(i = 0; i < keys.length; i++) {
	                key = keys[i];
	                if(key in context.edits) {
	                    context.edits[key] = config.edits[key];
	                }
	            }
	        }
	
	        // not part of the user-facing config options
	        context._exportedPlot = config._exportedPlot;
	    }
	
	    // staticPlot forces a bunch of others:
	    if(context.staticPlot) {
	        context.editable = false;
	        context.edits = {};
	        context.autosizable = false;
	        context.scrollZoom = false;
	        context.doubleClick = false;
	        context.showTips = false;
	        context.showLink = false;
	        context.displayModeBar = false;
	    }
	
	    // make sure hover-only devices have mode bar visible
	    if(context.displayModeBar === 'hover' && !hasHover) {
	        context.displayModeBar = true;
	    }
	
	    // default and fallback for setBackground
	    if(context.setBackground === 'transparent' || typeof context.setBackground !== 'function') {
	        context.setBackground = setBackground;
	    }
	
	    // Check if gd has a specified widht/height to begin with
	    context._hasZeroHeight = context._hasZeroHeight || gd.clientHeight === 0;
	    context._hasZeroWidth = context._hasZeroWidth || gd.clientWidth === 0;
	
	    // fill context._scrollZoom helper to help manage scrollZoom flaglist
	    var szIn = context.scrollZoom;
	    var szOut = context._scrollZoom = {};
	    if(szIn === true) {
	        szOut.cartesian = 1;
	        szOut.gl3d = 1;
	        szOut.geo = 1;
	        szOut.mapbox = 1;
	    } else if(typeof szIn === 'string') {
	        var parts = szIn.split('+');
	        for(i = 0; i < parts.length; i++) {
	            szOut[parts[i]] = 1;
	        }
	    } else if(szIn !== false) {
	        szOut.gl3d = 1;
	        szOut.geo = 1;
	        szOut.mapbox = 1;
	    }
	}
	
	function plotLegacyPolar(gd, data, layout) {
	    // build or reuse the container skeleton
	    var plotContainer = d3.select(gd).selectAll('.plot-container')
	        .data([0]);
	    plotContainer.enter()
	        .insert('div', ':first-child')
	        .classed('plot-container plotly', true);
	    var paperDiv = plotContainer.selectAll('.svg-container')
	        .data([0]);
	    paperDiv.enter().append('div')
	        .classed('svg-container', true)
	        .style('position', 'relative');
	
	    // empty it everytime for now
	    paperDiv.html('');
	
	    // fulfill gd requirements
	    if(data) gd.data = data;
	    if(layout) gd.layout = layout;
	    Polar.manager.fillLayout(gd);
	
	    // resize canvas
	    paperDiv.style({
	        width: gd._fullLayout.width + 'px',
	        height: gd._fullLayout.height + 'px'
	    });
	
	    // instantiate framework
	    gd.framework = Polar.manager.framework(gd);
	
	    // plot
	    gd.framework({data: gd.data, layout: gd.layout}, paperDiv.node());
	
	    // set undo point
	    gd.framework.setUndoPoint();
	
	    // get the resulting svg for extending it
	    var polarPlotSVG = gd.framework.svg();
	
	    // editable title
	    var opacity = 1;
	    var txt = gd._fullLayout.title ? gd._fullLayout.title.text : '';
	    if(txt === '' || !txt) opacity = 0;
	
	    var titleLayout = function() {
	        this.call(svgTextUtils.convertToTspans, gd);
	        // TODO: html/mathjax
	        // TODO: center title
	    };
	
	    var title = polarPlotSVG.select('.title-group text')
	        .call(titleLayout);
	
	    if(gd._context.edits.titleText) {
	        var placeholderText = Lib._(gd, 'Click to enter Plot title');
	        if(!txt || txt === placeholderText) {
	            opacity = 0.2;
	            // placeholder is not going through convertToTspans
	            // so needs explicit data-unformatted
	            title.attr({'data-unformatted': placeholderText})
	                .text(placeholderText)
	                .style({opacity: opacity})
	                .on('mouseover.opacity', function() {
	                    d3.select(this).transition().duration(100)
	                        .style('opacity', 1);
	                })
	                .on('mouseout.opacity', function() {
	                    d3.select(this).transition().duration(1000)
	                        .style('opacity', 0);
	                });
	        }
	
	        var setContenteditable = function() {
	            this.call(svgTextUtils.makeEditable, {gd: gd})
	                .on('edit', function(text) {
	                    gd.framework({layout: {title: {text: text}}});
	                    this.text(text)
	                        .call(titleLayout);
	                    this.call(setContenteditable);
	                })
	                .on('cancel', function() {
	                    var txt = this.attr('data-unformatted');
	                    this.text(txt).call(titleLayout);
	                });
	        };
	        title.call(setContenteditable);
	    }
	
	    gd._context.setBackground(gd, gd._fullLayout.paper_bgcolor);
	    Plots.addLinks(gd);
	
	    return Promise.resolve();
	}
	
	// convenience function to force a full redraw, mostly for use by plotly.js
	function redraw(gd) {
	    gd = Lib.getGraphDiv(gd);
	
	    if(!Lib.isPlotDiv(gd)) {
	        throw new Error('This element is not a Plotly plot: ' + gd);
	    }
	
	    helpers.cleanData(gd.data);
	    helpers.cleanLayout(gd.layout);
	
	    gd.calcdata = undefined;
	    return exports.plot(gd).then(function() {
	        gd.emit('plotly_redraw');
	        return gd;
	    });
	}
	
	/**
	 * Convenience function to make idempotent plot option obvious to users.
	 *
	 * @param gd
	 * @param {Object[]} data
	 * @param {Object} layout
	 * @param {Object} config
	 */
	function newPlot(gd, data, layout, config) {
	    gd = Lib.getGraphDiv(gd);
	
	    // remove gl contexts
	    Plots.cleanPlot([], {}, gd._fullData || [], gd._fullLayout || {});
	
	    Plots.purge(gd);
	    return exports.plot(gd, data, layout, config);
	}
	
	/**
	 * Wrap negative indicies to their positive counterparts.
	 *
	 * @param {Number[]} indices An array of indices
	 * @param {Number} maxIndex The maximum index allowable (arr.length - 1)
	 */
	function positivifyIndices(indices, maxIndex) {
	    var parentLength = maxIndex + 1;
	    var positiveIndices = [];
	    var i;
	    var index;
	
	    for(i = 0; i < indices.length; i++) {
	        index = indices[i];
	        if(index < 0) {
	            positiveIndices.push(parentLength + index);
	        } else {
	            positiveIndices.push(index);
	        }
	    }
	    return positiveIndices;
	}
	
	/**
	 * Ensures that an index array for manipulating gd.data is valid.
	 *
	 * Intended for use with addTraces, deleteTraces, and moveTraces.
	 *
	 * @param gd
	 * @param indices
	 * @param arrayName
	 */
	function assertIndexArray(gd, indices, arrayName) {
	    var i,
	        index;
	
	    for(i = 0; i < indices.length; i++) {
	        index = indices[i];
	
	        // validate that indices are indeed integers
	        if(index !== parseInt(index, 10)) {
	            throw new Error('all values in ' + arrayName + ' must be integers');
	        }
	
	        // check that all indices are in bounds for given gd.data array length
	        if(index >= gd.data.length || index < -gd.data.length) {
	            throw new Error(arrayName + ' must be valid indices for gd.data.');
	        }
	
	        // check that indices aren't repeated
	        if(indices.indexOf(index, i + 1) > -1 ||
	                index >= 0 && indices.indexOf(-gd.data.length + index) > -1 ||
	                index < 0 && indices.indexOf(gd.data.length + index) > -1) {
	            throw new Error('each index in ' + arrayName + ' must be unique.');
	        }
	    }
	}
	
	/**
	 * Private function used by Plotly.moveTraces to check input args
	 *
	 * @param gd
	 * @param currentIndices
	 * @param newIndices
	 */
	function checkMoveTracesArgs(gd, currentIndices, newIndices) {
	    // check that gd has attribute 'data' and 'data' is array
	    if(!Array.isArray(gd.data)) {
	        throw new Error('gd.data must be an array.');
	    }
	
	    // validate currentIndices array
	    if(typeof currentIndices === 'undefined') {
	        throw new Error('currentIndices is a required argument.');
	    } else if(!Array.isArray(currentIndices)) {
	        currentIndices = [currentIndices];
	    }
	    assertIndexArray(gd, currentIndices, 'currentIndices');
	
	    // validate newIndices array if it exists
	    if(typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
	        newIndices = [newIndices];
	    }
	    if(typeof newIndices !== 'undefined') {
	        assertIndexArray(gd, newIndices, 'newIndices');
	    }
	
	    // check currentIndices and newIndices are the same length if newIdices exists
	    if(typeof newIndices !== 'undefined' && currentIndices.length !== newIndices.length) {
	        throw new Error('current and new indices must be of equal length.');
	    }
	}
	/**
	 * A private function to reduce the type checking clutter in addTraces.
	 *
	 * @param gd
	 * @param traces
	 * @param newIndices
	 */
	function checkAddTracesArgs(gd, traces, newIndices) {
	    var i, value;
	
	    // check that gd has attribute 'data' and 'data' is array
	    if(!Array.isArray(gd.data)) {
	        throw new Error('gd.data must be an array.');
	    }
	
	    // make sure traces exists
	    if(typeof traces === 'undefined') {
	        throw new Error('traces must be defined.');
	    }
	
	    // make sure traces is an array
	    if(!Array.isArray(traces)) {
	        traces = [traces];
	    }
	
	    // make sure each value in traces is an object
	    for(i = 0; i < traces.length; i++) {
	        value = traces[i];
	        if(typeof value !== 'object' || (Array.isArray(value) || value === null)) {
	            throw new Error('all values in traces array must be non-array objects');
	        }
	    }
	
	    // make sure we have an index for each trace
	    if(typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
	        newIndices = [newIndices];
	    }
	    if(typeof newIndices !== 'undefined' && newIndices.length !== traces.length) {
	        throw new Error(
	            'if indices is specified, traces.length must equal indices.length'
	        );
	    }
	}
	
	/**
	 * A private function to reduce the type checking clutter in spliceTraces.
	 * Get all update Properties from gd.data. Validate inputs and outputs.
	 * Used by prependTrace and extendTraces
	 *
	 * @param gd
	 * @param update
	 * @param indices
	 * @param maxPoints
	 */
	function assertExtendTracesArgs(gd, update, indices, maxPoints) {
	    var maxPointsIsObject = Lib.isPlainObject(maxPoints);
	
	    if(!Array.isArray(gd.data)) {
	        throw new Error('gd.data must be an array');
	    }
	    if(!Lib.isPlainObject(update)) {
	        throw new Error('update must be a key:value object');
	    }
	
	    if(typeof indices === 'undefined') {
	        throw new Error('indices must be an integer or array of integers');
	    }
	
	    assertIndexArray(gd, indices, 'indices');
	
	    for(var key in update) {
	        /*
	         * Verify that the attribute to be updated contains as many trace updates
	         * as indices. Failure must result in throw and no-op
	         */
	        if(!Array.isArray(update[key]) || update[key].length !== indices.length) {
	            throw new Error('attribute ' + key + ' must be an array of length equal to indices array length');
	        }
	
	        /*
	         * if maxPoints is an object it must match keys and array lengths of 'update' 1:1
	         */
	        if(maxPointsIsObject &&
	            (!(key in maxPoints) || !Array.isArray(maxPoints[key]) ||
	            maxPoints[key].length !== update[key].length)) {
	            throw new Error('when maxPoints is set as a key:value object it must contain a 1:1 ' +
	                            'corrispondence with the keys and number of traces in the update object');
	        }
	    }
	}
	
	/**
	 * A private function to reduce the type checking clutter in spliceTraces.
	 *
	 * @param {Object|HTMLDivElement} gd
	 * @param {Object} update
	 * @param {Number[]} indices
	 * @param {Number||Object} maxPoints
	 * @return {Object[]}
	 */
	function getExtendProperties(gd, update, indices, maxPoints) {
	    var maxPointsIsObject = Lib.isPlainObject(maxPoints);
	    var updateProps = [];
	    var trace, target, prop, insert, maxp;
	
	    // allow scalar index to represent a single trace position
	    if(!Array.isArray(indices)) indices = [indices];
	
	    // negative indices are wrapped around to their positive value. Equivalent to python indexing.
	    indices = positivifyIndices(indices, gd.data.length - 1);
	
	    // loop through all update keys and traces and harvest validated data.
	    for(var key in update) {
	        for(var j = 0; j < indices.length; j++) {
	            /*
	             * Choose the trace indexed by the indices map argument and get the prop setter-getter
	             * instance that references the key and value for this particular trace.
	             */
	            trace = gd.data[indices[j]];
	            prop = nestedProperty(trace, key);
	
	            /*
	             * Target is the existing gd.data.trace.dataArray value like "x" or "marker.size"
	             * Target must exist as an Array to allow the extend operation to be performed.
	             */
	            target = prop.get();
	            insert = update[key][j];
	
	            if(!Lib.isArrayOrTypedArray(insert)) {
	                throw new Error('attribute: ' + key + ' index: ' + j + ' must be an array');
	            }
	            if(!Lib.isArrayOrTypedArray(target)) {
	                throw new Error('cannot extend missing or non-array attribute: ' + key);
	            }
	            if(target.constructor !== insert.constructor) {
	                throw new Error('cannot extend array with an array of a different type: ' + key);
	            }
	
	            /*
	             * maxPoints may be an object map or a scalar. If object select the key:value, else
	             * Use the scalar maxPoints for all key and trace combinations.
	             */
	            maxp = maxPointsIsObject ? maxPoints[key][j] : maxPoints;
	
	            // could have chosen null here, -1 just tells us to not take a window
	            if(!isNumeric(maxp)) maxp = -1;
	
	            /*
	             * Wrap the nestedProperty in an object containing required data
	             * for lengthening and windowing this particular trace - key combination.
	             * Flooring maxp mirrors the behaviour of floats in the Array.slice JSnative function.
	             */
	            updateProps.push({
	                prop: prop,
	                target: target,
	                insert: insert,
	                maxp: Math.floor(maxp)
	            });
	        }
	    }
	
	    // all target and insertion data now validated
	    return updateProps;
	}
	
	/**
	 * A private function to key Extend and Prepend traces DRY
	 *
	 * @param {Object|HTMLDivElement} gd
	 * @param {Object} update
	 * @param {Number[]} indices
	 * @param {Number||Object} maxPoints
	 * @param {Function} updateArray
	 * @return {Object}
	 */
	function spliceTraces(gd, update, indices, maxPoints, updateArray) {
	    assertExtendTracesArgs(gd, update, indices, maxPoints);
	
	    var updateProps = getExtendProperties(gd, update, indices, maxPoints);
	    var undoUpdate = {};
	    var undoPoints = {};
	
	    for(var i = 0; i < updateProps.length; i++) {
	        var prop = updateProps[i].prop;
	        var maxp = updateProps[i].maxp;
	
	        // return new array and remainder
	        var out = updateArray(updateProps[i].target, updateProps[i].insert, maxp);
	        prop.set(out[0]);
	
	        // build the inverse update object for the undo operation
	        if(!Array.isArray(undoUpdate[prop.astr])) undoUpdate[prop.astr] = [];
	        undoUpdate[prop.astr].push(out[1]);
	
	         // build the matching maxPoints undo object containing original trace lengths
	        if(!Array.isArray(undoPoints[prop.astr])) undoPoints[prop.astr] = [];
	        undoPoints[prop.astr].push(updateProps[i].target.length);
	    }
	
	    return {update: undoUpdate, maxPoints: undoPoints};
	}
	
	function concatTypedArray(arr0, arr1) {
	    var arr2 = new arr0.constructor(arr0.length + arr1.length);
	    arr2.set(arr0);
	    arr2.set(arr1, arr0.length);
	    return arr2;
	}
	
	/**
	 * extend && prepend traces at indices with update arrays, window trace lengths to maxPoints
	 *
	 * Extend and Prepend have identical APIs. Prepend inserts an array at the head while Extend
	 * inserts an array off the tail. Prepend truncates the tail of the array - counting maxPoints
	 * from the head, whereas Extend truncates the head of the array, counting backward maxPoints
	 * from the tail.
	 *
	 * If maxPoints is undefined, nonNumeric, negative or greater than extended trace length no
	 * truncation / windowing will be performed. If its zero, well the whole trace is truncated.
	 *
	 * @param {Object|HTMLDivElement} gd The graph div
	 * @param {Object} update The key:array map of target attributes to extend
	 * @param {Number|Number[]} indices The locations of traces to be extended
	 * @param {Number|Object} [maxPoints] Number of points for trace window after lengthening.
	 *
	 */
	function extendTraces(gd, update, indices, maxPoints) {
	    gd = Lib.getGraphDiv(gd);
	
	    function updateArray(target, insert, maxp) {
	        var newArray, remainder;
	
	        if(Lib.isTypedArray(target)) {
	            if(maxp < 0) {
	                var none = new target.constructor(0);
	                var both = concatTypedArray(target, insert);
	
	                if(maxp < 0) {
	                    newArray = both;
	                    remainder = none;
	                } else {
	                    newArray = none;
	                    remainder = both;
	                }
	            } else {
	                newArray = new target.constructor(maxp);
	                remainder = new target.constructor(target.length + insert.length - maxp);
	
	                if(maxp === insert.length) {
	                    newArray.set(insert);
	                    remainder.set(target);
	                } else if(maxp < insert.length) {
	                    var numberOfItemsFromInsert = insert.length - maxp;
	
	                    newArray.set(insert.subarray(numberOfItemsFromInsert));
	                    remainder.set(target);
	                    remainder.set(insert.subarray(0, numberOfItemsFromInsert), target.length);
	                } else {
	                    var numberOfItemsFromTarget = maxp - insert.length;
	                    var targetBegin = target.length - numberOfItemsFromTarget;
	
	                    newArray.set(target.subarray(targetBegin));
	                    newArray.set(insert, numberOfItemsFromTarget);
	                    remainder.set(target.subarray(0, targetBegin));
	                }
	            }
	        } else {
	            newArray = target.concat(insert);
	            remainder = (maxp >= 0 && maxp < newArray.length) ?
	                newArray.splice(0, newArray.length - maxp) :
	                [];
	        }
	
	        return [newArray, remainder];
	    }
	
	    var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
	    var promise = exports.redraw(gd);
	    var undoArgs = [gd, undo.update, indices, undo.maxPoints];
	    Queue.add(gd, exports.prependTraces, undoArgs, extendTraces, arguments);
	
	    return promise;
	}
	
	function prependTraces(gd, update, indices, maxPoints) {
	    gd = Lib.getGraphDiv(gd);
	
	    function updateArray(target, insert, maxp) {
	        var newArray, remainder;
	
	        if(Lib.isTypedArray(target)) {
	            if(maxp <= 0) {
	                var none = new target.constructor(0);
	                var both = concatTypedArray(insert, target);
	
	                if(maxp < 0) {
	                    newArray = both;
	                    remainder = none;
	                } else {
	                    newArray = none;
	                    remainder = both;
	                }
	            } else {
	                newArray = new target.constructor(maxp);
	                remainder = new target.constructor(target.length + insert.length - maxp);
	
	                if(maxp === insert.length) {
	                    newArray.set(insert);
	                    remainder.set(target);
	                } else if(maxp < insert.length) {
	                    var numberOfItemsFromInsert = insert.length - maxp;
	
	                    newArray.set(insert.subarray(0, numberOfItemsFromInsert));
	                    remainder.set(insert.subarray(numberOfItemsFromInsert));
	                    remainder.set(target, numberOfItemsFromInsert);
	                } else {
	                    var numberOfItemsFromTarget = maxp - insert.length;
	
	                    newArray.set(insert);
	                    newArray.set(target.subarray(0, numberOfItemsFromTarget), insert.length);
	                    remainder.set(target.subarray(numberOfItemsFromTarget));
	                }
	            }
	        } else {
	            newArray = insert.concat(target);
	            remainder = (maxp >= 0 && maxp < newArray.length) ?
	                newArray.splice(maxp, newArray.length) :
	                [];
	        }
	
	        return [newArray, remainder];
	    }
	
	    var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
	    var promise = exports.redraw(gd);
	    var undoArgs = [gd, undo.update, indices, undo.maxPoints];
	    Queue.add(gd, exports.extendTraces, undoArgs, prependTraces, arguments);
	
	    return promise;
	}
	
	/**
	 * Add data traces to an existing graph div.
	 *
	 * @param {Object|HTMLDivElement} gd The graph div
	 * @param {Object[]} gd.data The array of traces we're adding to
	 * @param {Object[]|Object} traces The object or array of objects to add
	 * @param {Number[]|Number} [newIndices=[gd.data.length]] Locations to add traces
	 *
	 */
	function addTraces(gd, traces, newIndices) {
	    gd = Lib.getGraphDiv(gd);
	
	    var currentIndices = [];
	    var undoFunc = exports.deleteTraces;
	    var redoFunc = addTraces;
	    var undoArgs = [gd, currentIndices];
	    var redoArgs = [gd, traces];  // no newIndices here
	    var i;
	    var promise;
	
	    // all validation is done elsewhere to remove clutter here
	    checkAddTracesArgs(gd, traces, newIndices);
	
	    // make sure traces is an array
	    if(!Array.isArray(traces)) {
	        traces = [traces];
	    }
	
	    // make sure traces do not repeat existing ones
	    traces = traces.map(function(trace) {
	        return Lib.extendFlat({}, trace);
	    });
	
	    helpers.cleanData(traces);
	
	    // add the traces to gd.data (no redrawing yet!)
	    for(i = 0; i < traces.length; i++) {
	        gd.data.push(traces[i]);
	    }
	
	    // to continue, we need to call moveTraces which requires currentIndices
	    for(i = 0; i < traces.length; i++) {
	        currentIndices.push(-traces.length + i);
	    }
	
	    // if the user didn't define newIndices, they just want the traces appended
	    // i.e., we can simply redraw and be done
	    if(typeof newIndices === 'undefined') {
	        promise = exports.redraw(gd);
	        Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	        return promise;
	    }
	
	    // make sure indices is property defined
	    if(!Array.isArray(newIndices)) {
	        newIndices = [newIndices];
	    }
	
	    try {
	        // this is redundant, but necessary to not catch later possible errors!
	        checkMoveTracesArgs(gd, currentIndices, newIndices);
	    } catch(error) {
	        // something went wrong, reset gd to be safe and rethrow error
	        gd.data.splice(gd.data.length - traces.length, traces.length);
	        throw error;
	    }
	
	    // if we're here, the user has defined specific places to place the new traces
	    // this requires some extra work that moveTraces will do
	    Queue.startSequence(gd);
	    Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	    promise = exports.moveTraces(gd, currentIndices, newIndices);
	    Queue.stopSequence(gd);
	    return promise;
	}
	
	/**
	 * Delete traces at `indices` from gd.data array.
	 *
	 * @param {Object|HTMLDivElement} gd The graph div
	 * @param {Object[]} gd.data The array of traces we're removing from
	 * @param {Number|Number[]} indices The indices
	 */
	function deleteTraces(gd, indices) {
	    gd = Lib.getGraphDiv(gd);
	
	    var traces = [];
	    var undoFunc = exports.addTraces;
	    var redoFunc = deleteTraces;
	    var undoArgs = [gd, traces, indices];
	    var redoArgs = [gd, indices];
	    var i;
	    var deletedTrace;
	
	    // make sure indices are defined
	    if(typeof indices === 'undefined') {
	        throw new Error('indices must be an integer or array of integers.');
	    } else if(!Array.isArray(indices)) {
	        indices = [indices];
	    }
	    assertIndexArray(gd, indices, 'indices');
	
	    // convert negative indices to positive indices
	    indices = positivifyIndices(indices, gd.data.length - 1);
	
	    // we want descending here so that splicing later doesn't affect indexing
	    indices.sort(Lib.sorterDes);
	    for(i = 0; i < indices.length; i += 1) {
	        deletedTrace = gd.data.splice(indices[i], 1)[0];
	        traces.push(deletedTrace);
	    }
	
	    var promise = exports.redraw(gd);
	    Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	
	    return promise;
	}
	
	/**
	 * Move traces at currentIndices array to locations in newIndices array.
	 *
	 * If newIndices is omitted, currentIndices will be moved to the end. E.g.,
	 * these are equivalent:
	 *
	 * Plotly.moveTraces(gd, [1, 2, 3], [-3, -2, -1])
	 * Plotly.moveTraces(gd, [1, 2, 3])
	 *
	 * @param {Object|HTMLDivElement} gd The graph div
	 * @param {Object[]} gd.data The array of traces we're removing from
	 * @param {Number|Number[]} currentIndices The locations of traces to be moved
	 * @param {Number|Number[]} [newIndices] The locations to move traces to
	 *
	 * Example calls:
	 *
	 *      // move trace i to location x
	 *      Plotly.moveTraces(gd, i, x)
	 *
	 *      // move trace i to end of array
	 *      Plotly.moveTraces(gd, i)
	 *
	 *      // move traces i, j, k to end of array (i != j != k)
	 *      Plotly.moveTraces(gd, [i, j, k])
	 *
	 *      // move traces [i, j, k] to [x, y, z] (i != j != k) (x != y != z)
	 *      Plotly.moveTraces(gd, [i, j, k], [x, y, z])
	 *
	 *      // reorder all traces (assume there are 5--a, b, c, d, e)
	 *      Plotly.moveTraces(gd, [b, d, e, a, c])  // same as 'move to end'
	 */
	function moveTraces(gd, currentIndices, newIndices) {
	    gd = Lib.getGraphDiv(gd);
	
	    var newData = [];
	    var movingTraceMap = [];
	    var undoFunc = moveTraces;
	    var redoFunc = moveTraces;
	    var undoArgs = [gd, newIndices, currentIndices];
	    var redoArgs = [gd, currentIndices, newIndices];
	    var i;
	
	    // to reduce complexity here, check args elsewhere
	    // this throws errors where appropriate
	    checkMoveTracesArgs(gd, currentIndices, newIndices);
	
	    // make sure currentIndices is an array
	    currentIndices = Array.isArray(currentIndices) ? currentIndices : [currentIndices];
	
	    // if undefined, define newIndices to point to the end of gd.data array
	    if(typeof newIndices === 'undefined') {
	        newIndices = [];
	        for(i = 0; i < currentIndices.length; i++) {
	            newIndices.push(-currentIndices.length + i);
	        }
	    }
	
	    // make sure newIndices is an array if it's user-defined
	    newIndices = Array.isArray(newIndices) ? newIndices : [newIndices];
	
	    // convert negative indices to positive indices (they're the same length)
	    currentIndices = positivifyIndices(currentIndices, gd.data.length - 1);
	    newIndices = positivifyIndices(newIndices, gd.data.length - 1);
	
	    // at this point, we've coerced the index arrays into predictable forms
	
	    // get the traces that aren't being moved around
	    for(i = 0; i < gd.data.length; i++) {
	        // if index isn't in currentIndices, include it in ignored!
	        if(currentIndices.indexOf(i) === -1) {
	            newData.push(gd.data[i]);
	        }
	    }
	
	    // get a mapping of indices to moving traces
	    for(i = 0; i < currentIndices.length; i++) {
	        movingTraceMap.push({newIndex: newIndices[i], trace: gd.data[currentIndices[i]]});
	    }
	
	    // reorder this mapping by newIndex, ascending
	    movingTraceMap.sort(function(a, b) {
	        return a.newIndex - b.newIndex;
	    });
	
	    // now, add the moving traces back in, in order!
	    for(i = 0; i < movingTraceMap.length; i += 1) {
	        newData.splice(movingTraceMap[i].newIndex, 0, movingTraceMap[i].trace);
	    }
	
	    gd.data = newData;
	
	    var promise = exports.redraw(gd);
	    Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	
	    return promise;
	}
	
	/**
	 * restyle: update trace attributes of an existing plot
	 *
	 * Can be called two ways.
	 *
	 * Signature 1:
	 * @param {String | HTMLDivElement} gd
	 *  the id or DOM element of the graph container div
	 * @param {String} astr
	 *  attribute string (like `'marker.symbol'`) to update
	 * @param {*} val
	 *  value to give this attribute
	 * @param {Number[] | Number} [traces]
	 *  integer or array of integers for the traces to alter (all if omitted)
	 *
	 * Signature 2:
	 * @param {String | HTMLDivElement} gd
	 *  (as in signature 1)
	 * @param {Object} aobj
	 *  attribute object `{astr1: val1, astr2: val2 ...}`
	 *  allows setting multiple attributes simultaneously
	 * @param {Number[] | Number} [traces]
	 *  (as in signature 1)
	 *
	 * `val` (or `val1`, `val2` ... in the object form) can be an array,
	 * to apply different values to each trace.
	 *
	 * If the array is too short, it will wrap around (useful for
	 * style files that want to specify cyclical default values).
	 */
	function restyle(gd, astr, val, _traces) {
	    gd = Lib.getGraphDiv(gd);
	    helpers.clearPromiseQueue(gd);
	
	    var aobj = {};
	    if(typeof astr === 'string') aobj[astr] = val;
	    else if(Lib.isPlainObject(astr)) {
	        // the 3-arg form
	        aobj = Lib.extendFlat({}, astr);
	        if(_traces === undefined) _traces = val;
	    } else {
	        Lib.warn('Restyle fail.', astr, val, _traces);
	        return Promise.reject();
	    }
	
	    if(Object.keys(aobj).length) gd.changed = true;
	
	    var traces = helpers.coerceTraceIndices(gd, _traces);
	
	    var specs = _restyle(gd, aobj, traces);
	    var flags = specs.flags;
	
	    // clear calcdata and/or axis types if required so they get regenerated
	    if(flags.calc) gd.calcdata = undefined;
	    if(flags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, {});
	
	    // fill in redraw sequence
	    var seq = [];
	
	    if(flags.fullReplot) {
	        seq.push(exports.plot);
	    } else {
	        seq.push(Plots.previousPromises);
	
	        // maybe only call Plots.supplyDataDefaults in the splom case,
	        // to skip over long and slow axes defaults
	        Plots.supplyDefaults(gd);
	
	        if(flags.markerSize) {
	            Plots.doCalcdata(gd);
	            addAxRangeSequence(seq);
	
	            // TODO
	            // if all axes have autorange:false, then
	            // proceed to subroutines.doTraceStyle(),
	            // otherwise we must go through addAxRangeSequence,
	            // which in general must redraws 'all' axes
	        }
	
	        if(flags.style) seq.push(subroutines.doTraceStyle);
	        if(flags.colorbars) seq.push(subroutines.doColorBars);
	
	        seq.push(emitAfterPlot);
	    }
	
	    seq.push(Plots.rehover, Plots.redrag);
	
	    Queue.add(gd,
	        restyle, [gd, specs.undoit, specs.traces],
	        restyle, [gd, specs.redoit, specs.traces]
	    );
	
	    var plotDone = Lib.syncOrAsync(seq, gd);
	    if(!plotDone || !plotDone.then) plotDone = Promise.resolve();
	
	    return plotDone.then(function() {
	        gd.emit('plotly_restyle', specs.eventData);
	        return gd;
	    });
	}
	
	// for undo: undefined initial vals must be turned into nulls
	// so that we unset rather than ignore them
	function undefinedToNull(val) {
	    if(val === undefined) return null;
	    return val;
	}
	
	/**
	 * Factory function to wrap nestedProperty with GUI edits if necessary
	 * with GUI edits we add an optional prefix to the nestedProperty constructor
	 * to prepend to the attribute string in the preGUI store.
	 */
	function makeNP(preGUI, guiEditFlag) {
	    if(!guiEditFlag) return nestedProperty;
	
	    return function(container, attr, prefix) {
	        var np = nestedProperty(container, attr);
	        var npSet = np.set;
	        np.set = function(val) {
	            var fullAttr = (prefix || '') + attr;
	            storeCurrent(fullAttr, np.get(), val, preGUI);
	            npSet(val);
	        };
	        return np;
	    };
	}
	
	function storeCurrent(attr, val, newVal, preGUI) {
	    if(Array.isArray(val) || Array.isArray(newVal)) {
	        var arrayVal = Array.isArray(val) ? val : [];
	        var arrayNew = Array.isArray(newVal) ? newVal : [];
	        var maxLen = Math.max(arrayVal.length, arrayNew.length);
	        for(var i = 0; i < maxLen; i++) {
	            storeCurrent(attr + '[' + i + ']', arrayVal[i], arrayNew[i], preGUI);
	        }
	    } else if(Lib.isPlainObject(val) || Lib.isPlainObject(newVal)) {
	        var objVal = Lib.isPlainObject(val) ? val : {};
	        var objNew = Lib.isPlainObject(newVal) ? newVal : {};
	        var objBoth = Lib.extendFlat({}, objVal, objNew);
	        for(var key in objBoth) {
	            storeCurrent(attr + '.' + key, objVal[key], objNew[key], preGUI);
	        }
	    } else if(preGUI[attr] === undefined) {
	        preGUI[attr] = undefinedToNull(val);
	    }
	}
	
	/**
	 * storeDirectGUIEdit: for routines that skip restyle/relayout and mock it
	 * by emitting a plotly_restyle or plotly_relayout event, this routine
	 * keeps track of the initial state in _preGUI for use by uirevision
	 * Does *not* apply these changes to data/layout - that's the responsibility
	 * of the calling routine.
	 *
	 * @param {object} container: the input attributes container (eg `layout` or a `trace`)
	 * @param {object} preGUI: where original values should be stored, either
	 *     `layout._preGUI` or `layout._tracePreGUI[uid]`
	 * @param {object} edits: the {attr: val} object as normally passed to `relayout` etc
	 */
	function _storeDirectGUIEdit(container, preGUI, edits) {
	    for(var attr in edits) {
	        var np = nestedProperty(container, attr);
	        storeCurrent(attr, np.get(), edits[attr], preGUI);
	    }
	}
	
	function _restyle(gd, aobj, traces) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var data = gd.data;
	    var guiEditFlag = fullLayout._guiEditing;
	    var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
	    var eventData = Lib.extendDeepAll({}, aobj);
	    var i;
	
	    cleanDeprecatedAttributeKeys(aobj);
	
	    // initialize flags
	    var flags = editTypes.traceFlags();
	
	    // copies of the change (and previous values of anything affected)
	    // for the undo / redo queue
	    var redoit = {};
	    var undoit = {};
	    var axlist;
	
	    // make a new empty vals array for undoit
	    function a0() { return traces.map(function() { return undefined; }); }
	
	    // for autoranging multiple axes
	    function addToAxlist(axid) {
	        var axName = Axes.id2name(axid);
	        if(axlist.indexOf(axName) === -1) axlist.push(axName);
	    }
	
	    function autorangeAttr(axName) { return 'LAYOUT' + axName + '.autorange'; }
	
	    function rangeAttr(axName) { return 'LAYOUT' + axName + '.range'; }
	
	    function getFullTrace(traceIndex) {
	        // usually fullData maps 1:1 onto data, but with groupby transforms
	        // the fullData index can be greater. Take the *first* matching trace.
	        for(var j = traceIndex; j < fullData.length; j++) {
	            if(fullData[j]._input === data[traceIndex]) return fullData[j];
	        }
	        // should never get here - and if we *do* it should cause an error
	        // later on undefined fullTrace is passed to nestedProperty.
	    }
	
	    // for attrs that interact (like scales & autoscales), save the
	    // old vals before making the change
	    // val=undefined will not set a value, just record what the value was.
	    // val=null will delete the attribute
	    // attr can be an array to set several at once (all to the same val)
	    function doextra(attr, val, i) {
	        if(Array.isArray(attr)) {
	            attr.forEach(function(a) { doextra(a, val, i); });
	            return;
	        }
	        // quit if explicitly setting this elsewhere
	        if(attr in aobj || helpers.hasParent(aobj, attr)) return;
	
	        var extraparam;
	        if(attr.substr(0, 6) === 'LAYOUT') {
	            extraparam = layoutNP(gd.layout, attr.replace('LAYOUT', ''));
	        } else {
	            var tracei = traces[i];
	            var preGUI = fullLayout._tracePreGUI[getFullTrace(tracei)._fullInput.uid];
	            extraparam = makeNP(preGUI, guiEditFlag)(data[tracei], attr);
	        }
	
	        if(!(attr in undoit)) {
	            undoit[attr] = a0();
	        }
	        if(undoit[attr][i] === undefined) {
	            undoit[attr][i] = undefinedToNull(extraparam.get());
	        }
	        if(val !== undefined) {
	            extraparam.set(val);
	        }
	    }
	
	    function allBins(binAttr) {
	        return function(j) {
	            return fullData[j][binAttr];
	        };
	    }
	
	    function arrayBins(binAttr) {
	        return function(vij, j) {
	            return vij === false ? fullData[traces[j]][binAttr] : null;
	        };
	    }
	
	    // now make the changes to gd.data (and occasionally gd.layout)
	    // and figure out what kind of graphics update we need to do
	    for(var ai in aobj) {
	        if(helpers.hasParent(aobj, ai)) {
	            throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
	        }
	
	        var vi = aobj[ai];
	        var cont;
	        var contFull;
	        var param;
	        var oldVal;
	        var newVal;
	        var valObject;
	
	        // Backward compatibility shim for turning histogram autobin on,
	        // or freezing previous autobinned values.
	        // Replace obsolete `autobin(x|y): true` with `(x|y)bins: null`
	        // and `autobin(x|y): false` with the `(x|y)bins` in `fullData`
	        if(ai === 'autobinx' || ai === 'autobiny') {
	            ai = ai.charAt(ai.length - 1) + 'bins';
	            if(Array.isArray(vi)) vi = vi.map(arrayBins(ai));
	            else if(vi === false) vi = traces.map(allBins(ai));
	            else vi = null;
	        }
	
	        redoit[ai] = vi;
	
	        if(ai.substr(0, 6) === 'LAYOUT') {
	            param = layoutNP(gd.layout, ai.replace('LAYOUT', ''));
	            undoit[ai] = [undefinedToNull(param.get())];
	            // since we're allowing val to be an array, allow it here too,
	            // even though that's meaningless
	            param.set(Array.isArray(vi) ? vi[0] : vi);
	            // ironically, the layout attrs in restyle only require replot,
	            // not relayout
	            flags.calc = true;
	            continue;
	        }
	
	        // set attribute in gd.data
	        undoit[ai] = a0();
	        for(i = 0; i < traces.length; i++) {
	            cont = data[traces[i]];
	            contFull = getFullTrace(traces[i]);
	            var preGUI = fullLayout._tracePreGUI[contFull._fullInput.uid];
	            param = makeNP(preGUI, guiEditFlag)(cont, ai);
	            oldVal = param.get();
	            newVal = Array.isArray(vi) ? vi[i % vi.length] : vi;
	
	            if(newVal === undefined) continue;
	
	            var finalPart = param.parts[param.parts.length - 1];
	            var prefix = ai.substr(0, ai.length - finalPart.length - 1);
	            var prefixDot = prefix ? prefix + '.' : '';
	            var innerContFull = prefix ?
	                nestedProperty(contFull, prefix).get() : contFull;
	
	            valObject = PlotSchema.getTraceValObject(contFull, param.parts);
	
	            if(valObject && valObject.impliedEdits && newVal !== null) {
	                for(var impliedKey in valObject.impliedEdits) {
	                    doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey], i);
	                }
	            } else if((finalPart === 'thicknessmode' || finalPart === 'lenmode') &&
	                    oldVal !== newVal &&
	                    (newVal === 'fraction' || newVal === 'pixels') &&
	                    innerContFull
	            ) {
	                // changing colorbar size modes,
	                // make the resulting size not change
	                // note that colorbar fractional sizing is based on the
	                // original plot size, before anything (like a colorbar)
	                // increases the margins
	
	                var gs = fullLayout._size;
	                var orient = innerContFull.orient;
	                var topOrBottom = (orient === 'top') || (orient === 'bottom');
	                if(finalPart === 'thicknessmode') {
	                    var thicknorm = topOrBottom ? gs.h : gs.w;
	                    doextra(prefixDot + 'thickness', innerContFull.thickness *
	                        (newVal === 'fraction' ? 1 / thicknorm : thicknorm), i);
	                } else {
	                    var lennorm = topOrBottom ? gs.w : gs.h;
	                    doextra(prefixDot + 'len', innerContFull.len *
	                        (newVal === 'fraction' ? 1 / lennorm : lennorm), i);
	                }
	            } else if(ai === 'type' && (
	                (newVal === 'pie') !== (oldVal === 'pie') ||
	                (newVal === 'funnelarea') !== (oldVal === 'funnelarea')
	            )) {
	                var labelsTo = 'x';
	                var valuesTo = 'y';
	                if((newVal === 'bar' || oldVal === 'bar') && cont.orientation === 'h') {
	                    labelsTo = 'y';
	                    valuesTo = 'x';
	                }
	                Lib.swapAttrs(cont, ['?', '?src'], 'labels', labelsTo);
	                Lib.swapAttrs(cont, ['d?', '?0'], 'label', labelsTo);
	                Lib.swapAttrs(cont, ['?', '?src'], 'values', valuesTo);
	
	                if(oldVal === 'pie' || oldVal === 'funnelarea') {
	                    nestedProperty(cont, 'marker.color')
	                        .set(nestedProperty(cont, 'marker.colors').get());
	
	                    // super kludgy - but if all pies are gone we won't remove them otherwise
	                    fullLayout._pielayer.selectAll('g.trace').remove();
	                } else if(Registry.traceIs(cont, 'cartesian')) {
	                    nestedProperty(cont, 'marker.colors')
	                        .set(nestedProperty(cont, 'marker.color').get());
	                }
	            }
	
	            undoit[ai][i] = undefinedToNull(oldVal);
	            // set the new value - if val is an array, it's one el per trace
	            // first check for attributes that get more complex alterations
	            var swapAttrs = [
	                'swapxy', 'swapxyaxes', 'orientation', 'orientationaxes'
	            ];
	            if(swapAttrs.indexOf(ai) !== -1) {
	                // setting an orientation: make sure it's changing
	                // before we swap everything else
	                if(ai === 'orientation') {
	                    param.set(newVal);
	                    // obnoxious that we need this level of coupling... but in order to
	                    // properly handle setting orientation to `null` we need to mimic
	                    // the logic inside Bars.supplyDefaults for default orientation
	                    var defaultOrientation = (cont.x && !cont.y) ? 'h' : 'v';
	                    if((param.get() || defaultOrientation) === contFull.orientation) {
	                        continue;
	                    }
	                } else if(ai === 'orientationaxes') {
	                    // orientationaxes has no value,
	                    // it flips everything and the axes
	
	                    cont.orientation =
	                        {v: 'h', h: 'v'}[contFull.orientation];
	                }
	                helpers.swapXYData(cont);
	                flags.calc = flags.clearAxisTypes = true;
	            } else if(Plots.dataArrayContainers.indexOf(param.parts[0]) !== -1) {
	                // TODO: use manageArrays.applyContainerArrayChanges here too
	                helpers.manageArrayContainers(param, newVal, undoit);
	                flags.calc = true;
	            } else {
	                if(valObject) {
	                    // must redo calcdata when restyling array values of arrayOk attributes
	                    // ... but no need to this for regl-based traces
	                    if(valObject.arrayOk &&
	                        !Registry.traceIs(contFull, 'regl') &&
	                        (Lib.isArrayOrTypedArray(newVal) || Lib.isArrayOrTypedArray(oldVal))
	                    ) {
	                        flags.calc = true;
	                    } else editTypes.update(flags, valObject);
	                } else {
	                    /*
	                     * if we couldn't find valObject,  assume a full recalc.
	                     * This can happen if you're changing type and making
	                     * some other edits too, so the modules we're
	                     * looking at don't have these attributes in them.
	                     */
	                    flags.calc = true;
	                }
	
	                // all the other ones, just modify that one attribute
	                param.set(newVal);
	            }
	        }
	
	        // swap the data attributes of the relevant x and y axes?
	        if(['swapxyaxes', 'orientationaxes'].indexOf(ai) !== -1) {
	            Axes.swap(gd, traces);
	        }
	
	        // swap hovermode if set to "compare x/y data"
	        if(ai === 'orientationaxes') {
	            var hovermode = nestedProperty(gd.layout, 'hovermode');
	            if(hovermode.get() === 'x') {
	                hovermode.set('y');
	            } else if(hovermode.get() === 'y') {
	                hovermode.set('x');
	            }
	        }
	
	        // Major enough changes deserve autoscale and
	        // non-reversed axes so people don't get confused
	        //
	        // Note: autobin (or its new analog bin clearing) is not included here
	        // since we're not pushing bins back to gd.data, so if we have bin
	        // info it was explicitly provided by the user.
	        if(['orientation', 'type'].indexOf(ai) !== -1) {
	            axlist = [];
	            for(i = 0; i < traces.length; i++) {
	                var trace = data[traces[i]];
	
	                if(Registry.traceIs(trace, 'cartesian')) {
	                    addToAxlist(trace.xaxis || 'x');
	                    addToAxlist(trace.yaxis || 'y');
	                }
	            }
	
	            doextra(axlist.map(autorangeAttr), true, 0);
	            doextra(axlist.map(rangeAttr), [0, 1], 0);
	        }
	    }
	
	    if(flags.calc || flags.plot) {
	        flags.fullReplot = true;
	    }
	
	    return {
	        flags: flags,
	        undoit: undoit,
	        redoit: redoit,
	        traces: traces,
	        eventData: Lib.extendDeepNoArrays([], [eventData, traces])
	    };
	}
	
	/**
	 * Converts deprecated attribute keys to
	 * the current API to ensure backwards compatibility.
	 *
	 * This is needed for the update mechanism to determine which
	 * subroutines to run based on the actual attribute
	 * definitions (that don't include the deprecated ones).
	 *
	 * E.g. Maps {'xaxis.title': 'A chart'} to {'xaxis.title.text': 'A chart'}
	 * and {titlefont: {...}} to {'title.font': {...}}.
	 *
	 * @param aobj
	 */
	function cleanDeprecatedAttributeKeys(aobj) {
	    var oldAxisTitleRegex = Lib.counterRegex('axis', '\.title', false, false);
	    var colorbarRegex = /colorbar\.title$/;
	    var keys = Object.keys(aobj);
	    var i, key, value;
	
	    for(i = 0; i < keys.length; i++) {
	        key = keys[i];
	        value = aobj[key];
	
	        if((key === 'title' || oldAxisTitleRegex.test(key) || colorbarRegex.test(key)) &&
	          (typeof value === 'string' || typeof value === 'number')) {
	            replace(key, key.replace('title', 'title.text'));
	        } else if(key.indexOf('titlefont') > -1) {
	            replace(key, key.replace('titlefont', 'title.font'));
	        } else if(key.indexOf('titleposition') > -1) {
	            replace(key, key.replace('titleposition', 'title.position'));
	        } else if(key.indexOf('titleside') > -1) {
	            replace(key, key.replace('titleside', 'title.side'));
	        } else if(key.indexOf('titleoffset') > -1) {
	            replace(key, key.replace('titleoffset', 'title.offset'));
	        }
	    }
	
	    function replace(oldAttrStr, newAttrStr) {
	        aobj[newAttrStr] = aobj[oldAttrStr];
	        delete aobj[oldAttrStr];
	    }
	}
	
	/**
	 * relayout: update layout attributes of an existing plot
	 *
	 * Can be called two ways:
	 *
	 * Signature 1:
	 * @param {String | HTMLDivElement} gd
	 *  the id or dom element of the graph container div
	 * @param {String} astr
	 *  attribute string (like `'xaxis.range[0]'`) to update
	 * @param {*} val
	 *  value to give this attribute
	 *
	 * Signature 2:
	 * @param {String | HTMLDivElement} gd
	 *  (as in signature 1)
	 * @param {Object} aobj
	 *  attribute object `{astr1: val1, astr2: val2 ...}`
	 *  allows setting multiple attributes simultaneously
	 */
	function relayout(gd, astr, val) {
	    gd = Lib.getGraphDiv(gd);
	    helpers.clearPromiseQueue(gd);
	
	    if(gd.framework && gd.framework.isPolar) {
	        return Promise.resolve(gd);
	    }
	
	    var aobj = {};
	    if(typeof astr === 'string') {
	        aobj[astr] = val;
	    } else if(Lib.isPlainObject(astr)) {
	        aobj = Lib.extendFlat({}, astr);
	    } else {
	        Lib.warn('Relayout fail.', astr, val);
	        return Promise.reject();
	    }
	
	    if(Object.keys(aobj).length) gd.changed = true;
	
	    var specs = _relayout(gd, aobj);
	    var flags = specs.flags;
	
	    // clear calcdata if required
	    if(flags.calc) gd.calcdata = undefined;
	
	    // fill in redraw sequence
	
	    // even if we don't have anything left in aobj,
	    // something may have happened within relayout that we
	    // need to wait for
	    var seq = [Plots.previousPromises];
	
	    if(flags.layoutReplot) {
	        seq.push(subroutines.layoutReplot);
	    } else if(Object.keys(aobj).length) {
	        axRangeSupplyDefaultsByPass(gd, flags, specs) || Plots.supplyDefaults(gd);
	
	        if(flags.legend) seq.push(subroutines.doLegend);
	        if(flags.layoutstyle) seq.push(subroutines.layoutStyles);
	        if(flags.axrange) addAxRangeSequence(seq, specs.rangesAltered);
	        if(flags.ticks) seq.push(subroutines.doTicksRelayout);
	        if(flags.modebar) seq.push(subroutines.doModeBar);
	        if(flags.camera) seq.push(subroutines.doCamera);
	        if(flags.colorbars) seq.push(subroutines.doColorBars);
	
	        seq.push(emitAfterPlot);
	    }
	
	    seq.push(Plots.rehover, Plots.redrag);
	
	    Queue.add(gd,
	        relayout, [gd, specs.undoit],
	        relayout, [gd, specs.redoit]
	    );
	
	    var plotDone = Lib.syncOrAsync(seq, gd);
	    if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	
	    return plotDone.then(function() {
	        gd.emit('plotly_relayout', specs.eventData);
	        return gd;
	    });
	}
	
	// Optimization mostly for large splom traces where
	// Plots.supplyDefaults can take > 100ms
	function axRangeSupplyDefaultsByPass(gd, flags, specs) {
	    var fullLayout = gd._fullLayout;
	
	    if(!flags.axrange) return false;
	
	    for(var k in flags) {
	        if(k !== 'axrange' && flags[k]) return false;
	    }
	
	    for(var axId in specs.rangesAltered) {
	        var axName = Axes.id2name(axId);
	        var axIn = gd.layout[axName];
	        var axOut = fullLayout[axName];
	        axOut.autorange = axIn.autorange;
	        axOut.range = axIn.range.slice();
	        axOut.cleanRange();
	
	        if(axOut._matchGroup) {
	            for(var axId2 in axOut._matchGroup) {
	                if(axId2 !== axId) {
	                    var ax2 = fullLayout[Axes.id2name(axId2)];
	                    ax2.autorange = axOut.autorange;
	                    ax2.range = axOut.range.slice();
	                    ax2._input.range = axOut.range.slice();
	                }
	            }
	        }
	    }
	
	    return true;
	}
	
	function addAxRangeSequence(seq, rangesAltered) {
	    // N.B. leave as sequence of subroutines (for now) instead of
	    // subroutine of its own so that finalDraw always gets
	    // executed after drawData
	    var drawAxes = rangesAltered ?
	        function(gd) {
	            var axIds = [];
	            var skipTitle = true;
	
	            for(var id in rangesAltered) {
	                var ax = Axes.getFromId(gd, id);
	                axIds.push(id);
	
	                if(ax._matchGroup) {
	                    for(var id2 in ax._matchGroup) {
	                        if(!rangesAltered[id2]) {
	                            axIds.push(id2);
	                        }
	                    }
	                }
	
	                if(ax.automargin) skipTitle = false;
	            }
	
	            return Axes.draw(gd, axIds, {skipTitle: skipTitle});
	        } :
	        function(gd) {
	            return Axes.draw(gd, 'redraw');
	        };
	
	    seq.push(
	        clearSelect,
	        subroutines.doAutoRangeAndConstraints,
	        drawAxes,
	        subroutines.drawData,
	        subroutines.finalDraw
	    );
	}
	
	var AX_RANGE_RE = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/;
	var AX_AUTORANGE_RE = /^[xyz]axis[0-9]*\.autorange$/;
	var AX_DOMAIN_RE = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
	
	function _relayout(gd, aobj) {
	    var layout = gd.layout;
	    var fullLayout = gd._fullLayout;
	    var guiEditFlag = fullLayout._guiEditing;
	    var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
	    var keys = Object.keys(aobj);
	    var axes = Axes.list(gd);
	    var eventData = Lib.extendDeepAll({}, aobj);
	    var arrayEdits = {};
	
	    var arrayStr, i, j;
	
	    cleanDeprecatedAttributeKeys(aobj);
	    keys = Object.keys(aobj);
	
	    // look for 'allaxes', split out into all axes
	    // in case of 3D the axis are nested within a scene which is held in _id
	    for(i = 0; i < keys.length; i++) {
	        if(keys[i].indexOf('allaxes') === 0) {
	            for(j = 0; j < axes.length; j++) {
	                var scene = axes[j]._id.substr(1);
	                var axisAttr = (scene.indexOf('scene') !== -1) ? (scene + '.') : '';
	                var newkey = keys[i].replace('allaxes', axisAttr + axes[j]._name);
	
	                if(!aobj[newkey]) aobj[newkey] = aobj[keys[i]];
	            }
	
	            delete aobj[keys[i]];
	        }
	    }
	
	    // initialize flags
	    var flags = editTypes.layoutFlags();
	
	    // copies of the change (and previous values of anything affected)
	    // for the undo / redo queue
	    var redoit = {};
	    var undoit = {};
	
	    // for attrs that interact (like scales & autoscales), save the
	    // old vals before making the change
	    // val=undefined will not set a value, just record what the value was.
	    // attr can be an array to set several at once (all to the same val)
	    function doextra(attr, val) {
	        if(Array.isArray(attr)) {
	            attr.forEach(function(a) { doextra(a, val); });
	            return;
	        }
	
	        // if we have another value for this attribute (explicitly or
	        // via a parent) do not override with this auto-generated extra
	        if(attr in aobj || helpers.hasParent(aobj, attr)) return;
	
	        var p = layoutNP(layout, attr);
	        if(!(attr in undoit)) {
	            undoit[attr] = undefinedToNull(p.get());
	        }
	        if(val !== undefined) p.set(val);
	    }
	
	    // for constraint enforcement: keep track of all axes (as {id: name})
	    // we're editing the (auto)range of, so we can tell the others constrained
	    // to scale with them that it's OK for them to shrink
	    var rangesAltered = {};
	    var axId;
	
	    function recordAlteredAxis(pleafPlus) {
	        var axId = Axes.name2id(pleafPlus.split('.')[0]);
	        rangesAltered[axId] = 1;
	        return axId;
	    }
	
	    // alter gd.layout
	    for(var ai in aobj) {
	        if(helpers.hasParent(aobj, ai)) {
	            throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
	        }
	
	        var p = layoutNP(layout, ai);
	        var vi = aobj[ai];
	        var plen = p.parts.length;
	        // p.parts may end with an index integer if the property is an array
	        var pend = plen - 1;
	        while(pend > 0 && typeof p.parts[pend] !== 'string') pend--;
	        // last property in chain (leaf node)
	        var pleaf = p.parts[pend];
	        // leaf plus immediate parent
	        var pleafPlus = p.parts[pend - 1] + '.' + pleaf;
	        // trunk nodes (everything except the leaf)
	        var ptrunk = p.parts.slice(0, pend).join('.');
	        var parentIn = nestedProperty(gd.layout, ptrunk).get();
	        var parentFull = nestedProperty(fullLayout, ptrunk).get();
	        var vOld = p.get();
	
	        if(vi === undefined) continue;
	
	        redoit[ai] = vi;
	
	        // axis reverse is special - it is its own inverse
	        // op and has no flag.
	        undoit[ai] = (pleaf === 'reverse') ? vi : undefinedToNull(vOld);
	
	        var valObject = PlotSchema.getLayoutValObject(fullLayout, p.parts);
	
	        if(valObject && valObject.impliedEdits && vi !== null) {
	            for(var impliedKey in valObject.impliedEdits) {
	                doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey]);
	            }
	        }
	
	        // Setting width or height to null must reset the graph's width / height
	        // back to its initial value as computed during the first pass in Plots.plotAutoSize.
	        //
	        // To do so, we must manually set them back here using the _initialAutoSize cache.
	        // can't use impliedEdits for this because behavior depends on vi
	        if(['width', 'height'].indexOf(ai) !== -1) {
	            if(vi) {
	                doextra('autosize', null);
	                // currently we don't support autosize one dim only - so
	                // explicitly set the other one. Note that doextra will
	                // ignore this if the same relayout call also provides oppositeAttr
	                var oppositeAttr = ai === 'height' ? 'width' : 'height';
	                doextra(oppositeAttr, fullLayout[oppositeAttr]);
	            } else {
	                fullLayout[ai] = gd._initialAutoSize[ai];
	            }
	        } else if(ai === 'autosize') {
	            // depends on vi here too, so again can't use impliedEdits
	            doextra('width', vi ? null : fullLayout.width);
	            doextra('height', vi ? null : fullLayout.height);
	        } else if(pleafPlus.match(AX_RANGE_RE)) {
	            // check autorange vs range
	
	            recordAlteredAxis(pleafPlus);
	            nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
	        } else if(pleafPlus.match(AX_AUTORANGE_RE)) {
	            recordAlteredAxis(pleafPlus);
	            nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
	            var axFull = nestedProperty(fullLayout, ptrunk).get();
	            if(axFull._inputDomain) {
	                // if we're autoranging and this axis has a constrained domain,
	                // reset it so we don't get locked into a shrunken size
	                axFull._input.domain = axFull._inputDomain.slice();
	            }
	        } else if(pleafPlus.match(AX_DOMAIN_RE)) {
	            nestedProperty(fullLayout, ptrunk + '._inputDomain').set(null);
	        }
	
	        // toggling axis type between log and linear: we need to convert
	        // positions for components that are still using linearized values,
	        // not data values like newer components.
	        // previously we did this for log <-> not-log, but now only do it
	        // for log <-> linear
	        if(pleaf === 'type') {
	            var ax = parentIn;
	            var toLog = parentFull.type === 'linear' && vi === 'log';
	            var fromLog = parentFull.type === 'log' && vi === 'linear';
	
	            if(toLog || fromLog) {
	                if(!ax || !ax.range) {
	                    // 2D never gets here, but 3D does
	                    // I don't think this is needed, but left here in case there
	                    // are edge cases I'm not thinking of.
	                    doextra(ptrunk + '.autorange', true);
	                } else if(!parentFull.autorange) {
	                    // toggling log without autorange: need to also recalculate ranges
	                    // because log axes use linearized values for range endpoints
	                    var r0 = ax.range[0];
	                    var r1 = ax.range[1];
	                    if(toLog) {
	                        // if both limits are negative, autorange
	                        if(r0 <= 0 && r1 <= 0) {
	                            doextra(ptrunk + '.autorange', true);
	                        }
	                        // if one is negative, set it 6 orders below the other.
	                        if(r0 <= 0) r0 = r1 / 1e6;
	                        else if(r1 <= 0) r1 = r0 / 1e6;
	                        // now set the range values as appropriate
	                        doextra(ptrunk + '.range[0]', Math.log(r0) / Math.LN10);
	                        doextra(ptrunk + '.range[1]', Math.log(r1) / Math.LN10);
	                    } else {
	                        doextra(ptrunk + '.range[0]', Math.pow(10, r0));
	                        doextra(ptrunk + '.range[1]', Math.pow(10, r1));
	                    }
	                } else if(toLog) {
	                    // just make sure the range is positive and in the right
	                    // order, it'll get recalculated later
	                    ax.range = (ax.range[1] > ax.range[0]) ? [1, 2] : [2, 1];
	                }
	
	                // clear polar view initial stash for radial range so that
	                // value get recomputed in correct units
	                if(Array.isArray(fullLayout._subplots.polar) &&
	                    fullLayout._subplots.polar.length &&
	                    fullLayout[p.parts[0]] &&
	                    p.parts[1] === 'radialaxis'
	                ) {
	                    delete fullLayout[p.parts[0]]._subplot.viewInitial['radialaxis.range'];
	                }
	
	                // Annotations and images also need to convert to/from linearized coords
	                // Shapes do not need this :)
	                Registry.getComponentMethod('annotations', 'convertCoords')(gd, parentFull, vi, doextra);
	                Registry.getComponentMethod('images', 'convertCoords')(gd, parentFull, vi, doextra);
	            } else {
	                // any other type changes: the range from the previous type
	                // will not make sense, so autorange it.
	                doextra(ptrunk + '.autorange', true);
	                doextra(ptrunk + '.range', null);
	            }
	            nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
	        } else if(pleaf.match(AX_NAME_PATTERN)) {
	            var fullProp = nestedProperty(fullLayout, ai).get();
	            var newType = (vi || {}).type;
	
	            // This can potentially cause strange behavior if the autotype is not
	            // numeric (linear, because we don't auto-log) but the previous type
	            // was log. That's a very strange edge case though
	            if(!newType || newType === '-') newType = 'linear';
	            Registry.getComponentMethod('annotations', 'convertCoords')(gd, fullProp, newType, doextra);
	            Registry.getComponentMethod('images', 'convertCoords')(gd, fullProp, newType, doextra);
	        }
	
	        // alter gd.layout
	
	        // collect array component edits for execution all together
	        // so we can ensure consistent behavior adding/removing items
	        // and order-independence for add/remove/edit all together in
	        // one relayout call
	        var containerArrayMatch = manageArrays.containerArrayMatch(ai);
	        if(containerArrayMatch) {
	            arrayStr = containerArrayMatch.array;
	            i = containerArrayMatch.index;
	            var propStr = containerArrayMatch.property;
	            var updateValObject = valObject || {editType: 'calc'};
	
	            if(i !== '' && propStr === '') {
	                // special handling of undoit if we're adding or removing an element
	                // ie 'annotations[2]' which can be {...} (add) or null,
	                // does not work when replacing the entire array
	                if(manageArrays.isAddVal(vi)) {
	                    undoit[ai] = null;
	                } else if(manageArrays.isRemoveVal(vi)) {
	                    undoit[ai] = (nestedProperty(layout, arrayStr).get() || [])[i];
	                } else {
	                    Lib.warn('unrecognized full object value', aobj);
	                }
	            }
	            editTypes.update(flags, updateValObject);
	
	            // prepare the edits object we'll send to applyContainerArrayChanges
	            if(!arrayEdits[arrayStr]) arrayEdits[arrayStr] = {};
	            var objEdits = arrayEdits[arrayStr][i];
	            if(!objEdits) objEdits = arrayEdits[arrayStr][i] = {};
	            objEdits[propStr] = vi;
	
	            delete aobj[ai];
	        } else if(pleaf === 'reverse') {
	            // handle axis reversal explicitly, as there's no 'reverse' attribute
	
	            if(parentIn.range) parentIn.range.reverse();
	            else {
	                doextra(ptrunk + '.autorange', true);
	                parentIn.range = [1, 0];
	            }
	
	            if(parentFull.autorange) flags.calc = true;
	            else flags.plot = true;
	        } else {
	            if((fullLayout._has('scatter-like') && fullLayout._has('regl')) &&
	                (ai === 'dragmode' &&
	                (vi === 'lasso' || vi === 'select') &&
	                !(vOld === 'lasso' || vOld === 'select'))
	            ) {
	                flags.plot = true;
	            } else if(fullLayout._has('gl2d')) {
	                flags.plot = true;
	            } else if(valObject) editTypes.update(flags, valObject);
	            else flags.calc = true;
	
	            p.set(vi);
	        }
	    }
	
	    // now we've collected component edits - execute them all together
	    for(arrayStr in arrayEdits) {
	        var finished = manageArrays.applyContainerArrayChanges(gd,
	            layoutNP(layout, arrayStr), arrayEdits[arrayStr], flags, layoutNP);
	        if(!finished) flags.plot = true;
	    }
	
	    // figure out if we need to recalculate axis constraints
	    var constraints = fullLayout._axisConstraintGroups || [];
	    for(axId in rangesAltered) {
	        for(i = 0; i < constraints.length; i++) {
	            var group = constraints[i];
	            if(group[axId]) {
	                // Always recalc if we're changing constrained ranges.
	                // Otherwise it's possible to violate the constraints by
	                // specifying arbitrary ranges for all axes in the group.
	                // this way some ranges may expand beyond what's specified,
	                // as they do at first draw, to satisfy the constraints.
	                flags.calc = true;
	                for(var groupAxId in group) {
	                    if(!rangesAltered[groupAxId]) {
	                        Axes.getFromId(gd, groupAxId)._constraintShrinkable = true;
	                    }
	                }
	            }
	        }
	    }
	
	    // If the autosize changed or height or width was explicitly specified,
	    // this triggers a redraw
	    // TODO: do we really need special aobj.height/width handling here?
	    // couldn't editType do this?
	    if(updateAutosize(gd) || aobj.height || aobj.width) flags.plot = true;
	
	    if(flags.plot || flags.calc) {
	        flags.layoutReplot = true;
	    }
	
	    // now all attribute mods are done, as are
	    // redo and undo so we can save them
	
	    return {
	        flags: flags,
	        rangesAltered: rangesAltered,
	        undoit: undoit,
	        redoit: redoit,
	        eventData: eventData
	    };
	}
	
	/*
	 * updateAutosize: we made a change, does it change the autosize result?
	 * puts the new size into fullLayout
	 * returns true if either height or width changed
	 */
	function updateAutosize(gd) {
	    var fullLayout = gd._fullLayout;
	    var oldWidth = fullLayout.width;
	    var oldHeight = fullLayout.height;
	
	    // calculate autosizing
	    if(gd.layout.autosize) Plots.plotAutoSize(gd, gd.layout, fullLayout);
	
	    return (fullLayout.width !== oldWidth) || (fullLayout.height !== oldHeight);
	}
	
	/**
	 * update: update trace and layout attributes of an existing plot
	 *
	 * @param {String | HTMLDivElement} gd
	 *  the id or DOM element of the graph container div
	 * @param {Object} traceUpdate
	 *  attribute object `{astr1: val1, astr2: val2 ...}`
	 *  corresponding to updates in the plot's traces
	 * @param {Object} layoutUpdate
	 *  attribute object `{astr1: val1, astr2: val2 ...}`
	 *  corresponding to updates in the plot's layout
	 * @param {Number[] | Number} [traces]
	 *  integer or array of integers for the traces to alter (all if omitted)
	 *
	 */
	function update(gd, traceUpdate, layoutUpdate, _traces) {
	    gd = Lib.getGraphDiv(gd);
	    helpers.clearPromiseQueue(gd);
	
	    if(gd.framework && gd.framework.isPolar) {
	        return Promise.resolve(gd);
	    }
	
	    if(!Lib.isPlainObject(traceUpdate)) traceUpdate = {};
	    if(!Lib.isPlainObject(layoutUpdate)) layoutUpdate = {};
	
	    if(Object.keys(traceUpdate).length) gd.changed = true;
	    if(Object.keys(layoutUpdate).length) gd.changed = true;
	
	    var traces = helpers.coerceTraceIndices(gd, _traces);
	
	    var restyleSpecs = _restyle(gd, Lib.extendFlat({}, traceUpdate), traces);
	    var restyleFlags = restyleSpecs.flags;
	
	    var relayoutSpecs = _relayout(gd, Lib.extendFlat({}, layoutUpdate));
	    var relayoutFlags = relayoutSpecs.flags;
	
	    // clear calcdata and/or axis types if required
	    if(restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
	    if(restyleFlags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, layoutUpdate);
	
	    // fill in redraw sequence
	    var seq = [];
	
	    if(relayoutFlags.layoutReplot) {
	        // N.B. works fine when both
	        // relayoutFlags.layoutReplot and restyleFlags.fullReplot are true
	        seq.push(subroutines.layoutReplot);
	    } else if(restyleFlags.fullReplot) {
	        seq.push(exports.plot);
	    } else {
	        seq.push(Plots.previousPromises);
	        axRangeSupplyDefaultsByPass(gd, relayoutFlags, relayoutSpecs) || Plots.supplyDefaults(gd);
	
	        if(restyleFlags.style) seq.push(subroutines.doTraceStyle);
	        if(restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
	        if(relayoutFlags.legend) seq.push(subroutines.doLegend);
	        if(relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
	        if(relayoutFlags.axrange) addAxRangeSequence(seq, relayoutSpecs.rangesAltered);
	        if(relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
	        if(relayoutFlags.modebar) seq.push(subroutines.doModeBar);
	        if(relayoutFlags.camera) seq.push(subroutines.doCamera);
	
	        seq.push(emitAfterPlot);
	    }
	
	    seq.push(Plots.rehover, Plots.redrag);
	
	    Queue.add(gd,
	        update, [gd, restyleSpecs.undoit, relayoutSpecs.undoit, restyleSpecs.traces],
	        update, [gd, restyleSpecs.redoit, relayoutSpecs.redoit, restyleSpecs.traces]
	    );
	
	    var plotDone = Lib.syncOrAsync(seq, gd);
	    if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	
	    return plotDone.then(function() {
	        gd.emit('plotly_update', {
	            data: restyleSpecs.eventData,
	            layout: relayoutSpecs.eventData
	        });
	
	        return gd;
	    });
	}
	
	/*
	 * internal-use-only restyle/relayout/update variants that record the initial
	 * values in (fullLayout|fullTrace)._preGUI so changes can be persisted across
	 * Plotly.react data updates, dependent on uirevision attributes
	 */
	function guiEdit(func) {
	    return function wrappedEdit(gd) {
	        gd._fullLayout._guiEditing = true;
	        var p = func.apply(null, arguments);
	        gd._fullLayout._guiEditing = false;
	        return p;
	    };
	}
	
	// For connecting edited layout attributes to uirevision attrs
	// If no `attr` we use `match[1] + '.uirevision'`
	// Ordered by most common edits first, to minimize our search time
	var layoutUIControlPatterns = [
	    {pattern: /^hiddenlabels/, attr: 'legend.uirevision'},
	    {pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/},
	
	    // showspikes and modes include those nested inside scenes
	    {pattern: /axis\d*\.showspikes$/, attr: 'modebar.uirevision'},
	    {pattern: /(hover|drag)mode$/, attr: 'modebar.uirevision'},
	
	    {pattern: /^(scene\d*)\.camera/},
	    {pattern: /^(geo\d*)\.(projection|center)/},
	    {pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/},
	    {pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/},
	    {pattern: /^(polar\d*\.angularaxis)\.rotation/},
	    {pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/},
	
	    {pattern: /^legend\.(x|y)$/, attr: 'editrevision'},
	    {pattern: /^(shapes|annotations)/, attr: 'editrevision'},
	    {pattern: /^title\.text$/, attr: 'editrevision'}
	];
	
	// same for trace attributes: if `attr` is given it's in layout,
	// or with no `attr` we use `trace.uirevision`
	var traceUIControlPatterns = [
	    {pattern: /^selectedpoints$/, attr: 'selectionrevision'},
	    // "visible" includes trace.transforms[i].styles[j].value.visible
	    {pattern: /(^|value\.)visible$/, attr: 'legend.uirevision'},
	    {pattern: /^dimensions\[\d+\]\.constraintrange/},
	    {pattern: /^node\.(x|y|groups)/}, // for Sankey nodes
	    {pattern: /^level$/}, // for Sunburst & Treemap traces
	
	    // below this you must be in editable: true mode
	    // TODO: I still put name and title with `trace.uirevision`
	    // reasonable or should these be `editrevision`?
	    // Also applies to axis titles up in the layout section
	
	    // "name" also includes transform.styles
	    {pattern: /(^|value\.)name$/},
	    // including nested colorbar attributes (ie marker.colorbar)
	    {pattern: /colorbar\.title\.text$/},
	    {pattern: /colorbar\.(x|y)$/, attr: 'editrevision'}
	];
	
	function findUIPattern(key, patternSpecs) {
	    for(var i = 0; i < patternSpecs.length; i++) {
	        var spec = patternSpecs[i];
	        var match = key.match(spec.pattern);
	        if(match) {
	            return {head: match[1], attr: spec.attr};
	        }
	    }
	}
	
	// We're finding the new uirevision before supplyDefaults, so do the
	// inheritance manually. Note that only `undefined` inherits - other
	// falsy values are returned.
	function getNewRev(revAttr, container) {
	    var newRev = nestedProperty(container, revAttr).get();
	    if(newRev !== undefined) return newRev;
	
	    var parts = revAttr.split('.');
	    parts.pop();
	    while(parts.length > 1) {
	        parts.pop();
	        newRev = nestedProperty(container, parts.join('.') + '.uirevision').get();
	        if(newRev !== undefined) return newRev;
	    }
	
	    return container.uirevision;
	}
	
	function getFullTraceIndexFromUid(uid, fullData) {
	    for(var i = 0; i < fullData.length; i++) {
	        if(fullData[i]._fullInput.uid === uid) return i;
	    }
	    return -1;
	}
	
	function getTraceIndexFromUid(uid, data, tracei) {
	    for(var i = 0; i < data.length; i++) {
	        if(data[i].uid === uid) return i;
	    }
	    // fall back on trace order, but only if user didn't provide a uid for that trace
	    return (!data[tracei] || data[tracei].uid) ? -1 : tracei;
	}
	
	function valsMatch(v1, v2) {
	    var v1IsObj = Lib.isPlainObject(v1);
	    var v1IsArray = Array.isArray(v1);
	    if(v1IsObj || v1IsArray) {
	        return (
	            (v1IsObj && Lib.isPlainObject(v2)) ||
	            (v1IsArray && Array.isArray(v2))
	        ) && JSON.stringify(v1) === JSON.stringify(v2);
	    }
	    return v1 === v2;
	}
	
	function applyUIRevisions(data, layout, oldFullData, oldFullLayout) {
	    var layoutPreGUI = oldFullLayout._preGUI;
	    var key, revAttr, oldRev, newRev, match, preGUIVal, newNP, newVal;
	    var bothInheritAutorange = [];
	    var newRangeAccepted = {};
	    for(key in layoutPreGUI) {
	        match = findUIPattern(key, layoutUIControlPatterns);
	        if(match) {
	            revAttr = match.attr || (match.head + '.uirevision');
	            oldRev = nestedProperty(oldFullLayout, revAttr).get();
	            newRev = oldRev && getNewRev(revAttr, layout);
	            if(newRev && (newRev === oldRev)) {
	                preGUIVal = layoutPreGUI[key];
	                if(preGUIVal === null) preGUIVal = undefined;
	                newNP = nestedProperty(layout, key);
	                newVal = newNP.get();
	                if(valsMatch(newVal, preGUIVal)) {
	                    if(newVal === undefined && key.substr(key.length - 9) === 'autorange') {
	                        bothInheritAutorange.push(key.substr(0, key.length - 10));
	                    }
	                    newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
	                    continue;
	                }
	            }
	        } else {
	            Lib.warn('unrecognized GUI edit: ' + key);
	        }
	        // if we got this far, the new value was accepted as the new starting
	        // point (either because it changed or revision changed)
	        // so remove it from _preGUI for next time.
	        delete layoutPreGUI[key];
	
	        if(key.substr(key.length - 8, 6) === 'range[') {
	            newRangeAccepted[key.substr(0, key.length - 9)] = 1;
	        }
	    }
	
	    // Special logic for `autorange`, since it interacts with `range`:
	    // If the new figure's matching `range` was kept, and `autorange`
	    // wasn't supplied explicitly in either the original or the new figure,
	    // we shouldn't alter that - but we may just have done that, so fix it.
	    for(var i = 0; i < bothInheritAutorange.length; i++) {
	        var axAttr = bothInheritAutorange[i];
	        if(newRangeAccepted[axAttr]) {
	            var newAx = nestedProperty(layout, axAttr).get();
	            if(newAx) delete newAx.autorange;
	        }
	    }
	
	    // Now traces - try to match them up by uid (in case we added/deleted in
	    // the middle), then fall back on index.
	    var allTracePreGUI = oldFullLayout._tracePreGUI;
	    for(var uid in allTracePreGUI) {
	        var tracePreGUI = allTracePreGUI[uid];
	        var newTrace = null;
	        var fullInput;
	        for(key in tracePreGUI) {
	            // wait until we know we have preGUI values to look for traces
	            // but if we don't find both, stop looking at this uid
	            if(!newTrace) {
	                var fulli = getFullTraceIndexFromUid(uid, oldFullData);
	                if(fulli < 0) {
	                    // Somehow we didn't even have this trace in oldFullData...
	                    // I guess this could happen with `deleteTraces` or something
	                    delete allTracePreGUI[uid];
	                    break;
	                }
	                var fullTrace = oldFullData[fulli];
	                fullInput = fullTrace._fullInput;
	
	                var newTracei = getTraceIndexFromUid(uid, data, fullInput.index);
	                if(newTracei < 0) {
	                    // No match in new data
	                    delete allTracePreGUI[uid];
	                    break;
	                }
	                newTrace = data[newTracei];
	            }
	
	            match = findUIPattern(key, traceUIControlPatterns);
	            if(match) {
	                if(match.attr) {
	                    oldRev = nestedProperty(oldFullLayout, match.attr).get();
	                    newRev = oldRev && getNewRev(match.attr, layout);
	                } else {
	                    oldRev = fullInput.uirevision;
	                    // inheritance for trace.uirevision is simple, just layout.uirevision
	                    newRev = newTrace.uirevision;
	                    if(newRev === undefined) newRev = layout.uirevision;
	                }
	
	                if(newRev && newRev === oldRev) {
	                    preGUIVal = tracePreGUI[key];
	                    if(preGUIVal === null) preGUIVal = undefined;
	                    newNP = nestedProperty(newTrace, key);
	                    newVal = newNP.get();
	                    if(valsMatch(newVal, preGUIVal)) {
	                        newNP.set(undefinedToNull(nestedProperty(fullInput, key).get()));
	                        continue;
	                    }
	                }
	            } else {
	                Lib.warn('unrecognized GUI edit: ' + key + ' in trace uid ' + uid);
	            }
	            delete tracePreGUI[key];
	        }
	    }
	}
	
	/**
	 * Plotly.react:
	 * A plot/update method that takes the full plot state (same API as plot/newPlot)
	 * and diffs to determine the minimal update pathway
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 * @param {array of objects} data
	 *      array of traces, containing the data and display information for each trace
	 * @param {object} layout
	 *      object describing the overall display of the plot,
	 *      all the stuff that doesn't pertain to any individual trace
	 * @param {object} config
	 *      configuration options (see ./plot_config.js for more info)
	 *
	 * OR
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 * @param {object} figure
	 *      object containing `data`, `layout`, `config`, and `frames` members
	 *
	 */
	function react(gd, data, layout, config) {
	    var frames, plotDone;
	
	    function addFrames() { return exports.addFrames(gd, frames); }
	
	    gd = Lib.getGraphDiv(gd);
	    helpers.clearPromiseQueue(gd);
	
	    var oldFullData = gd._fullData;
	    var oldFullLayout = gd._fullLayout;
	
	    // you can use this as the initial draw as well as to update
	    if(!Lib.isPlotDiv(gd) || !oldFullData || !oldFullLayout) {
	        plotDone = exports.newPlot(gd, data, layout, config);
	    } else {
	        if(Lib.isPlainObject(data)) {
	            var obj = data;
	            data = obj.data;
	            layout = obj.layout;
	            config = obj.config;
	            frames = obj.frames;
	        }
	
	        var configChanged = false;
	        // assume that if there's a config at all, we're reacting to it too,
	        // and completely replace the previous config
	        if(config) {
	            var oldConfig = Lib.extendDeep({}, gd._context);
	            gd._context = undefined;
	            setPlotContext(gd, config);
	            configChanged = diffConfig(oldConfig, gd._context);
	        }
	
	        gd.data = data || [];
	        helpers.cleanData(gd.data);
	        gd.layout = layout || {};
	        helpers.cleanLayout(gd.layout);
	
	        applyUIRevisions(gd.data, gd.layout, oldFullData, oldFullLayout);
	
	        // "true" skips updating calcdata and remapping arrays from calcTransforms,
	        // which supplyDefaults usually does at the end, but we may need to NOT do
	        // if the diff (which we haven't determined yet) says we'll recalc
	        Plots.supplyDefaults(gd, {skipUpdateCalc: true});
	
	        var newFullData = gd._fullData;
	        var newFullLayout = gd._fullLayout;
	        var immutable = newFullLayout.datarevision === undefined;
	        var transition = newFullLayout.transition;
	
	        var relayoutFlags = diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition);
	        var newDataRevision = relayoutFlags.newDataRevision;
	        var restyleFlags = diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision);
	
	        // TODO: how to translate this part of relayout to Plotly.react?
	        // // Setting width or height to null must reset the graph's width / height
	        // // back to its initial value as computed during the first pass in Plots.plotAutoSize.
	        // //
	        // // To do so, we must manually set them back here using the _initialAutoSize cache.
	        // if(['width', 'height'].indexOf(ai) !== -1 && vi === null) {
	        //     fullLayout[ai] = gd._initialAutoSize[ai];
	        // }
	
	        if(updateAutosize(gd)) relayoutFlags.layoutReplot = true;
	
	        // clear calcdata if required
	        if(restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
	        // otherwise do the calcdata updates and calcTransform array remaps that we skipped earlier
	        else Plots.supplyDefaultsUpdateCalc(gd.calcdata, newFullData);
	
	        // Note: what restyle/relayout use impliedEdits and clearAxisTypes for
	        // must be handled by the user when using Plotly.react.
	
	        // fill in redraw sequence
	        var seq = [];
	
	        if(frames) {
	            gd._transitionData = {};
	            Plots.createTransitionData(gd);
	            seq.push(addFrames);
	        }
	
	        // Transition pathway,
	        // only used when 'transition' is set by user and
	        // when at least one animatable attribute has changed,
	        // N.B. config changed aren't animatable
	        if(newFullLayout.transition && !configChanged && (restyleFlags.anim || relayoutFlags.anim)) {
	            Plots.doCalcdata(gd);
	            subroutines.doAutoRangeAndConstraints(gd);
	
	            seq.push(function() {
	                return Plots.transitionFromReact(gd, restyleFlags, relayoutFlags, oldFullLayout);
	            });
	        } else if(restyleFlags.fullReplot || relayoutFlags.layoutReplot || configChanged) {
	            gd._fullLayout._skipDefaults = true;
	            seq.push(exports.plot);
	        } else {
	            for(var componentType in relayoutFlags.arrays) {
	                var indices = relayoutFlags.arrays[componentType];
	                if(indices.length) {
	                    var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
	                    if(drawOne !== Lib.noop) {
	                        for(var i = 0; i < indices.length; i++) {
	                            drawOne(gd, indices[i]);
	                        }
	                    } else {
	                        var draw = Registry.getComponentMethod(componentType, 'draw');
	                        if(draw === Lib.noop) {
	                            throw new Error('cannot draw components: ' + componentType);
	                        }
	                        draw(gd);
	                    }
	                }
	            }
	
	            seq.push(Plots.previousPromises);
	            if(restyleFlags.style) seq.push(subroutines.doTraceStyle);
	            if(restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
	            if(relayoutFlags.legend) seq.push(subroutines.doLegend);
	            if(relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
	            if(relayoutFlags.axrange) addAxRangeSequence(seq);
	            if(relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
	            if(relayoutFlags.modebar) seq.push(subroutines.doModeBar);
	            if(relayoutFlags.camera) seq.push(subroutines.doCamera);
	            seq.push(emitAfterPlot);
	        }
	
	        seq.push(Plots.rehover, Plots.redrag);
	
	        plotDone = Lib.syncOrAsync(seq, gd);
	        if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	    }
	
	    return plotDone.then(function() {
	        gd.emit('plotly_react', {
	            data: data,
	            layout: layout
	        });
	
	        return gd;
	    });
	}
	
	function diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision) {
	    var sameTraceLength = oldFullData.length === newFullData.length;
	
	    if(!transition && !sameTraceLength) {
	        return {
	            fullReplot: true,
	            calc: true
	        };
	    }
	
	    var flags = editTypes.traceFlags();
	    flags.arrays = {};
	    flags.nChanges = 0;
	    flags.nChangesAnim = 0;
	
	    var i, trace;
	
	    function getTraceValObject(parts) {
	        var out = PlotSchema.getTraceValObject(trace, parts);
	        if(!trace._module.animatable && out.anim) {
	            out.anim = false;
	        }
	        return out;
	    }
	
	    var diffOpts = {
	        getValObject: getTraceValObject,
	        flags: flags,
	        immutable: immutable,
	        transition: transition,
	        newDataRevision: newDataRevision,
	        gd: gd
	    };
	
	    var seenUIDs = {};
	
	    for(i = 0; i < oldFullData.length; i++) {
	        if(newFullData[i]) {
	            trace = newFullData[i]._fullInput;
	            if(Plots.hasMakesDataTransform(trace)) trace = newFullData[i];
	            if(seenUIDs[trace.uid]) continue;
	            seenUIDs[trace.uid] = 1;
	
	            getDiffFlags(oldFullData[i]._fullInput, trace, [], diffOpts);
	        }
	    }
	
	    if(flags.calc || flags.plot) {
	        flags.fullReplot = true;
	    }
	
	    if(transition && flags.nChanges && flags.nChangesAnim) {
	        flags.anim = (flags.nChanges === flags.nChangesAnim) && sameTraceLength ? 'all' : 'some';
	    }
	
	    return flags;
	}
	
	function diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition) {
	    var flags = editTypes.layoutFlags();
	    flags.arrays = {};
	    flags.rangesAltered = {};
	    flags.nChanges = 0;
	    flags.nChangesAnim = 0;
	
	    function getLayoutValObject(parts) {
	        return PlotSchema.getLayoutValObject(newFullLayout, parts);
	    }
	
	    var diffOpts = {
	        getValObject: getLayoutValObject,
	        flags: flags,
	        immutable: immutable,
	        transition: transition,
	        gd: gd
	    };
	
	    getDiffFlags(oldFullLayout, newFullLayout, [], diffOpts);
	
	    if(flags.plot || flags.calc) {
	        flags.layoutReplot = true;
	    }
	
	    if(transition && flags.nChanges && flags.nChangesAnim) {
	        flags.anim = flags.nChanges === flags.nChangesAnim ? 'all' : 'some';
	    }
	
	    return flags;
	}
	
	function getDiffFlags(oldContainer, newContainer, outerparts, opts) {
	    var valObject, key, astr;
	
	    var getValObject = opts.getValObject;
	    var flags = opts.flags;
	    var immutable = opts.immutable;
	    var inArray = opts.inArray;
	    var arrayIndex = opts.arrayIndex;
	
	    function changed() {
	        var editType = valObject.editType;
	        if(inArray && editType.indexOf('arraydraw') !== -1) {
	            Lib.pushUnique(flags.arrays[inArray], arrayIndex);
	            return;
	        }
	        editTypes.update(flags, valObject);
	
	        if(editType !== 'none') {
	            flags.nChanges++;
	        }
	
	        // track animatable changes
	        if(opts.transition && valObject.anim) {
	            flags.nChangesAnim++;
	        }
	
	        // track cartesian axes with altered ranges
	        if(AX_RANGE_RE.test(astr) || AX_AUTORANGE_RE.test(astr)) {
	            flags.rangesAltered[outerparts[0]] = 1;
	        }
	
	        // clear _inputDomain on cartesian axes with altered domains
	        if(AX_DOMAIN_RE.test(astr)) {
	            nestedProperty(newContainer, '_inputDomain').set(null);
	        }
	
	        // track datarevision changes
	        if(key === 'datarevision') {
	            flags.newDataRevision = 1;
	        }
	    }
	
	    function valObjectCanBeDataArray(valObject) {
	        return valObject.valType === 'data_array' || valObject.arrayOk;
	    }
	
	    for(key in oldContainer) {
	        // short-circuit based on previous calls or previous keys that already maximized the pathway
	        if(flags.calc && !opts.transition) return;
	
	        var oldVal = oldContainer[key];
	        var newVal = newContainer[key];
	        var parts = outerparts.concat(key);
	        astr = parts.join('.');
	
	        if(key.charAt(0) === '_' || typeof oldVal === 'function' || oldVal === newVal) continue;
	
	        // FIXME: ax.tick0 and dtick get filled in during plotting (except for geo subplots),
	        // and unlike other auto values they don't make it back into the input,
	        // so newContainer won't have them.
	        if((key === 'tick0' || key === 'dtick') && outerparts[0] !== 'geo') {
	            var tickMode = newContainer.tickmode;
	            if(tickMode === 'auto' || tickMode === 'array' || !tickMode) continue;
	        }
	        // FIXME: Similarly for axis ranges for 3D
	        // contourcarpet doesn't HAVE zmin/zmax, they're just auto-added. It needs them.
	        if(key === 'range' && newContainer.autorange) continue;
	        if((key === 'zmin' || key === 'zmax') && newContainer.type === 'contourcarpet') continue;
	
	        valObject = getValObject(parts);
	
	        // in case type changed, we may not even *have* a valObject.
	        if(!valObject) continue;
	
	        if(valObject._compareAsJSON && JSON.stringify(oldVal) === JSON.stringify(newVal)) continue;
	
	        var valType = valObject.valType;
	        var i;
	
	        var canBeDataArray = valObjectCanBeDataArray(valObject);
	        var wasArray = Array.isArray(oldVal);
	        var nowArray = Array.isArray(newVal);
	
	        // hack for traces that modify the data in supplyDefaults, like
	        // converting 1D to 2D arrays, which will always create new objects
	        if(wasArray && nowArray) {
	            var inputKey = '_input_' + key;
	            var oldValIn = oldContainer[inputKey];
	            var newValIn = newContainer[inputKey];
	            if(Array.isArray(oldValIn) && oldValIn === newValIn) continue;
	        }
	
	        if(newVal === undefined) {
	            if(canBeDataArray && wasArray) flags.calc = true;
	            else changed();
	        } else if(valObject._isLinkedToArray) {
	            var arrayEditIndices = [];
	            var extraIndices = false;
	            if(!inArray) flags.arrays[key] = arrayEditIndices;
	
	            var minLen = Math.min(oldVal.length, newVal.length);
	            var maxLen = Math.max(oldVal.length, newVal.length);
	            if(minLen !== maxLen) {
	                if(valObject.editType === 'arraydraw') {
	                    extraIndices = true;
	                } else {
	                    changed();
	                    continue;
	                }
	            }
	
	            for(i = 0; i < minLen; i++) {
	                getDiffFlags(oldVal[i], newVal[i], parts.concat(i),
	                    // add array indices, but not if we're already in an array
	                    Lib.extendFlat({inArray: key, arrayIndex: i}, opts));
	            }
	
	            // put this at the end so that we know our collected array indices are sorted
	            // but the check for length changes happens up front so we can short-circuit
	            // diffing if appropriate
	            if(extraIndices) {
	                for(i = minLen; i < maxLen; i++) {
	                    arrayEditIndices.push(i);
	                }
	            }
	        } else if(!valType && Lib.isPlainObject(oldVal)) {
	            getDiffFlags(oldVal, newVal, parts, opts);
	        } else if(canBeDataArray) {
	            if(wasArray && nowArray) {
	                // don't try to diff two data arrays. If immutable we know the data changed,
	                // if not, assume it didn't and let `layout.datarevision` tell us if it did
	                if(immutable) {
	                    flags.calc = true;
	                }
	
	                // look for animatable attributes when the data changed
	                if(immutable || opts.newDataRevision) {
	                    changed();
	                }
	            } else if(wasArray !== nowArray) {
	                flags.calc = true;
	            } else changed();
	        } else if(wasArray && nowArray) {
	            // info array, colorscale, 'any' - these are short, just stringify.
	            // I don't *think* that covers up any real differences post-validation, does it?
	            // otherwise we need to dive in 1 (info_array) or 2 (colorscale) levels and compare
	            // all elements.
	            if(oldVal.length !== newVal.length || String(oldVal) !== String(newVal)) {
	                changed();
	            }
	        } else {
	            changed();
	        }
	    }
	
	    for(key in newContainer) {
	        if(!(key in oldContainer || key.charAt(0) === '_' || typeof newContainer[key] === 'function')) {
	            valObject = getValObject(outerparts.concat(key));
	
	            if(valObjectCanBeDataArray(valObject) && Array.isArray(newContainer[key])) {
	                flags.calc = true;
	                return;
	            } else changed();
	        }
	    }
	}
	
	/*
	 * simple diff for config - for now, just treat all changes as equivalent
	 */
	function diffConfig(oldConfig, newConfig) {
	    var key;
	
	    for(key in oldConfig) {
	        if(key.charAt(0) === '_') continue;
	        var oldVal = oldConfig[key];
	        var newVal = newConfig[key];
	        if(oldVal !== newVal) {
	            if(Lib.isPlainObject(oldVal) && Lib.isPlainObject(newVal)) {
	                if(diffConfig(oldVal, newVal)) {
	                    return true;
	                }
	            } else if(Array.isArray(oldVal) && Array.isArray(newVal)) {
	                if(oldVal.length !== newVal.length) {
	                    return true;
	                }
	                for(var i = 0; i < oldVal.length; i++) {
	                    if(oldVal[i] !== newVal[i]) {
	                        if(Lib.isPlainObject(oldVal[i]) && Lib.isPlainObject(newVal[i])) {
	                            if(diffConfig(oldVal[i], newVal[i])) {
	                                return true;
	                            }
	                        } else {
	                            return true;
	                        }
	                    }
	                }
	            } else {
	                return true;
	            }
	        }
	    }
	}
	
	/**
	 * Animate to a frame, sequence of frame, frame group, or frame definition
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 *
	 * @param {string or object or array of strings or array of objects} frameOrGroupNameOrFrameList
	 *      a single frame, array of frames, or group to which to animate. The intent is
	 *      inferred by the type of the input. Valid inputs are:
	 *
	 *      - string, e.g. 'groupname': animate all frames of a given `group` in the order
	 *            in which they are defined via `Plotly.addFrames`.
	 *
	 *      - array of strings, e.g. ['frame1', frame2']: a list of frames by name to which
	 *            to animate in sequence
	 *
	 *      - object: {data: ...}: a frame definition to which to animate. The frame is not
	 *            and does not need to be added via `Plotly.addFrames`. It may contain any of
	 *            the properties of a frame, including `data`, `layout`, and `traces`. The
	 *            frame is used as provided and does not use the `baseframe` property.
	 *
	 *      - array of objects, e.g. [{data: ...}, {data: ...}]: a list of frame objects,
	 *            each following the same rules as a single `object`.
	 *
	 * @param {object} animationOpts
	 *      configuration for the animation
	 */
	function animate(gd, frameOrGroupNameOrFrameList, animationOpts) {
	    gd = Lib.getGraphDiv(gd);
	
	    if(!Lib.isPlotDiv(gd)) {
	        throw new Error(
	            'This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' +
	            'to create a plot before animating it. For more details, see ' +
	            'https://plot.ly/javascript/animations/'
	        );
	    }
	
	    var trans = gd._transitionData;
	
	    // This is the queue of frames that will be animated as soon as possible. They
	    // are popped immediately upon the *start* of a transition:
	    if(!trans._frameQueue) {
	        trans._frameQueue = [];
	    }
	
	    animationOpts = Plots.supplyAnimationDefaults(animationOpts);
	    var transitionOpts = animationOpts.transition;
	    var frameOpts = animationOpts.frame;
	
	    // Since frames are popped immediately, an empty queue only means all frames have
	    // *started* to transition, not that the animation is complete. To solve that,
	    // track a separate counter that increments at the same time as frames are added
	    // to the queue, but decrements only when the transition is complete.
	    if(trans._frameWaitingCnt === undefined) {
	        trans._frameWaitingCnt = 0;
	    }
	
	    function getTransitionOpts(i) {
	        if(Array.isArray(transitionOpts)) {
	            if(i >= transitionOpts.length) {
	                return transitionOpts[0];
	            } else {
	                return transitionOpts[i];
	            }
	        } else {
	            return transitionOpts;
	        }
	    }
	
	    function getFrameOpts(i) {
	        if(Array.isArray(frameOpts)) {
	            if(i >= frameOpts.length) {
	                return frameOpts[0];
	            } else {
	                return frameOpts[i];
	            }
	        } else {
	            return frameOpts;
	        }
	    }
	
	    // Execute a callback after the wrapper function has been called n times.
	    // This is used to defer the resolution until a transition has resovled *and*
	    // the frame has completed. If it's not done this way, then we get a race
	    // condition in which the animation might resolve before a transition is complete
	    // or vice versa.
	    function callbackOnNthTime(cb, n) {
	        var cnt = 0;
	        return function() {
	            if(cb && ++cnt === n) {
	                return cb();
	            }
	        };
	    }
	
	    return new Promise(function(resolve, reject) {
	        function discardExistingFrames() {
	            if(trans._frameQueue.length === 0) {
	                return;
	            }
	
	            while(trans._frameQueue.length) {
	                var next = trans._frameQueue.pop();
	                if(next.onInterrupt) {
	                    next.onInterrupt();
	                }
	            }
	
	            gd.emit('plotly_animationinterrupted', []);
	        }
	
	        function queueFrames(frameList) {
	            if(frameList.length === 0) return;
	
	            for(var i = 0; i < frameList.length; i++) {
	                var computedFrame;
	
	                if(frameList[i].type === 'byname') {
	                    // If it's a named frame, compute it:
	                    computedFrame = Plots.computeFrame(gd, frameList[i].name);
	                } else {
	                    // Otherwise we must have been given a simple object, so treat
	                    // the input itself as the computed frame.
	                    computedFrame = frameList[i].data;
	                }
	
	                var frameOpts = getFrameOpts(i);
	                var transitionOpts = getTransitionOpts(i);
	
	                // It doesn't make much sense for the transition duration to be greater than
	                // the frame duration, so limit it:
	                transitionOpts.duration = Math.min(transitionOpts.duration, frameOpts.duration);
	
	                var nextFrame = {
	                    frame: computedFrame,
	                    name: frameList[i].name,
	                    frameOpts: frameOpts,
	                    transitionOpts: transitionOpts,
	                };
	                if(i === frameList.length - 1) {
	                    // The last frame in this .animate call stores the promise resolve
	                    // and reject callbacks. This is how we ensure that the animation
	                    // loop (which may exist as a result of a *different* .animate call)
	                    // still resolves or rejecdts this .animate call's promise. once it's
	                    // complete.
	                    nextFrame.onComplete = callbackOnNthTime(resolve, 2);
	                    nextFrame.onInterrupt = reject;
	                }
	
	                trans._frameQueue.push(nextFrame);
	            }
	
	            // Set it as never having transitioned to a frame. This will cause the animation
	            // loop to immediately transition to the next frame (which, for immediate mode,
	            // is the first frame in the list since all others would have been discarded
	            // below)
	            if(animationOpts.mode === 'immediate') {
	                trans._lastFrameAt = -Infinity;
	            }
	
	            // Only it's not already running, start a RAF loop. This could be avoided in the
	            // case that there's only one frame, but it significantly complicated the logic
	            // and only sped things up by about 5% or so for a lorenz attractor simulation.
	            // It would be a fine thing to implement, but the benefit of that optimization
	            // doesn't seem worth the extra complexity.
	            if(!trans._animationRaf) {
	                beginAnimationLoop();
	            }
	        }
	
	        function stopAnimationLoop() {
	            gd.emit('plotly_animated');
	
	            // Be sure to unset also since it's how we know whether a loop is already running:
	            window.cancelAnimationFrame(trans._animationRaf);
	            trans._animationRaf = null;
	        }
	
	        function nextFrame() {
	            if(trans._currentFrame && trans._currentFrame.onComplete) {
	                // Execute the callback and unset it to ensure it doesn't
	                // accidentally get called twice
	                trans._currentFrame.onComplete();
	            }
	
	            var newFrame = trans._currentFrame = trans._frameQueue.shift();
	
	            if(newFrame) {
	                // Since it's sometimes necessary to do deep digging into frame data,
	                // we'll consider it not 100% impossible for nulls or numbers to sneak through,
	                // so check when casting the name, just to be absolutely certain:
	                var stringName = newFrame.name ? newFrame.name.toString() : null;
	                gd._fullLayout._currentFrame = stringName;
	
	                trans._lastFrameAt = Date.now();
	                trans._timeToNext = newFrame.frameOpts.duration;
	
	                // This is simply called and it's left to .transition to decide how to manage
	                // interrupting current transitions. That means we don't need to worry about
	                // how it resolves or what happens after this:
	                Plots.transition(gd,
	                    newFrame.frame.data,
	                    newFrame.frame.layout,
	                    helpers.coerceTraceIndices(gd, newFrame.frame.traces),
	                    newFrame.frameOpts,
	                    newFrame.transitionOpts
	                ).then(function() {
	                    if(newFrame.onComplete) {
	                        newFrame.onComplete();
	                    }
	                });
	
	                gd.emit('plotly_animatingframe', {
	                    name: stringName,
	                    frame: newFrame.frame,
	                    animation: {
	                        frame: newFrame.frameOpts,
	                        transition: newFrame.transitionOpts,
	                    }
	                });
	            } else {
	                // If there are no more frames, then stop the RAF loop:
	                stopAnimationLoop();
	            }
	        }
	
	        function beginAnimationLoop() {
	            gd.emit('plotly_animating');
	
	            // If no timer is running, then set last frame = long ago so that the next
	            // frame is immediately transitioned:
	            trans._lastFrameAt = -Infinity;
	            trans._timeToNext = 0;
	            trans._runningTransitions = 0;
	            trans._currentFrame = null;
	
	            var doFrame = function() {
	                // This *must* be requested before nextFrame since nextFrame may decide
	                // to cancel it if there's nothing more to animated:
	                trans._animationRaf = window.requestAnimationFrame(doFrame);
	
	                // Check if we're ready for a new frame:
	                if(Date.now() - trans._lastFrameAt > trans._timeToNext) {
	                    nextFrame();
	                }
	            };
	
	            doFrame();
	        }
	
	        // This is an animate-local counter that helps match up option input list
	        // items with the particular frame.
	        var configCounter = 0;
	        function setTransitionConfig(frame) {
	            if(Array.isArray(transitionOpts)) {
	                if(configCounter >= transitionOpts.length) {
	                    frame.transitionOpts = transitionOpts[configCounter];
	                } else {
	                    frame.transitionOpts = transitionOpts[0];
	                }
	            } else {
	                frame.transitionOpts = transitionOpts;
	            }
	            configCounter++;
	            return frame;
	        }
	
	        // Disambiguate what's sort of frames have been received
	        var i, frame;
	        var frameList = [];
	        var allFrames = frameOrGroupNameOrFrameList === undefined || frameOrGroupNameOrFrameList === null;
	        var isFrameArray = Array.isArray(frameOrGroupNameOrFrameList);
	        var isSingleFrame = !allFrames && !isFrameArray && Lib.isPlainObject(frameOrGroupNameOrFrameList);
	
	        if(isSingleFrame) {
	            // In this case, a simple object has been passed to animate.
	            frameList.push({
	                type: 'object',
	                data: setTransitionConfig(Lib.extendFlat({}, frameOrGroupNameOrFrameList))
	            });
	        } else if(allFrames || ['string', 'number'].indexOf(typeof frameOrGroupNameOrFrameList) !== -1) {
	            // In this case, null or undefined has been passed so that we want to
	            // animate *all* currently defined frames
	            for(i = 0; i < trans._frames.length; i++) {
	                frame = trans._frames[i];
	
	                if(!frame) continue;
	
	                if(allFrames || String(frame.group) === String(frameOrGroupNameOrFrameList)) {
	                    frameList.push({
	                        type: 'byname',
	                        name: String(frame.name),
	                        data: setTransitionConfig({name: frame.name})
	                    });
	                }
	            }
	        } else if(isFrameArray) {
	            for(i = 0; i < frameOrGroupNameOrFrameList.length; i++) {
	                var frameOrName = frameOrGroupNameOrFrameList[i];
	                if(['number', 'string'].indexOf(typeof frameOrName) !== -1) {
	                    frameOrName = String(frameOrName);
	                    // In this case, there's an array and this frame is a string name:
	                    frameList.push({
	                        type: 'byname',
	                        name: frameOrName,
	                        data: setTransitionConfig({name: frameOrName})
	                    });
	                } else if(Lib.isPlainObject(frameOrName)) {
	                    frameList.push({
	                        type: 'object',
	                        data: setTransitionConfig(Lib.extendFlat({}, frameOrName))
	                    });
	                }
	            }
	        }
	
	        // Verify that all of these frames actually exist; return and reject if not:
	        for(i = 0; i < frameList.length; i++) {
	            frame = frameList[i];
	            if(frame.type === 'byname' && !trans._frameHash[frame.data.name]) {
	                Lib.warn('animate failure: frame not found: "' + frame.data.name + '"');
	                reject();
	                return;
	            }
	        }
	
	        // If the mode is either next or immediate, then all currently queued frames must
	        // be dumped and the corresponding .animate promises rejected.
	        if(['next', 'immediate'].indexOf(animationOpts.mode) !== -1) {
	            discardExistingFrames();
	        }
	
	        if(animationOpts.direction === 'reverse') {
	            frameList.reverse();
	        }
	
	        var currentFrame = gd._fullLayout._currentFrame;
	        if(currentFrame && animationOpts.fromcurrent) {
	            var idx = -1;
	            for(i = 0; i < frameList.length; i++) {
	                frame = frameList[i];
	                if(frame.type === 'byname' && frame.name === currentFrame) {
	                    idx = i;
	                    break;
	                }
	            }
	
	            if(idx > 0 && idx < frameList.length - 1) {
	                var filteredFrameList = [];
	                for(i = 0; i < frameList.length; i++) {
	                    frame = frameList[i];
	                    if(frameList[i].type !== 'byname' || i > idx) {
	                        filteredFrameList.push(frame);
	                    }
	                }
	                frameList = filteredFrameList;
	            }
	        }
	
	        if(frameList.length > 0) {
	            queueFrames(frameList);
	        } else {
	            // This is the case where there were simply no frames. It's a little strange
	            // since there's not much to do:
	            gd.emit('plotly_animated');
	            resolve();
	        }
	    });
	}
	
	/**
	 * Register new frames
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 *
	 * @param {array of objects} frameList
	 *      list of frame definitions, in which each object includes any of:
	 *      - name: {string} name of frame to add
	 *      - data: {array of objects} trace data
	 *      - layout {object} layout definition
	 *      - traces {array} trace indices
	 *      - baseframe {string} name of frame from which this frame gets defaults
	 *
	 *  @param {array of integers} indices
	 *      an array of integer indices matching the respective frames in `frameList`. If not
	 *      provided, an index will be provided in serial order. If already used, the frame
	 *      will be overwritten.
	 */
	function addFrames(gd, frameList, indices) {
	    gd = Lib.getGraphDiv(gd);
	
	    if(frameList === null || frameList === undefined) {
	        return Promise.resolve();
	    }
	
	    if(!Lib.isPlotDiv(gd)) {
	        throw new Error(
	            'This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' +
	            'to create a plot before adding frames. For more details, see ' +
	            'https://plot.ly/javascript/animations/'
	        );
	    }
	
	    var i, frame, j, idx;
	    var _frames = gd._transitionData._frames;
	    var _frameHash = gd._transitionData._frameHash;
	
	
	    if(!Array.isArray(frameList)) {
	        throw new Error('addFrames failure: frameList must be an Array of frame definitions' + frameList);
	    }
	
	    // Create a sorted list of insertions since we run into lots of problems if these
	    // aren't in ascending order of index:
	    //
	    // Strictly for sorting. Make sure this is guaranteed to never collide with any
	    // already-exisisting indices:
	    var bigIndex = _frames.length + frameList.length * 2;
	
	    var insertions = [];
	    var _frameHashLocal = {};
	    for(i = frameList.length - 1; i >= 0; i--) {
	        if(!Lib.isPlainObject(frameList[i])) continue;
	
	        // The entire logic for checking for this type of name collision can be removed once we migrate to ES6 and
	        // use a Map instead of an Object instance, as Map keys aren't converted to strings.
	        var lookupName = frameList[i].name;
	        var name = (_frameHash[lookupName] || _frameHashLocal[lookupName] || {}).name;
	        var newName = frameList[i].name;
	        var collisionPresent = _frameHash[name] || _frameHashLocal[name];
	
	        if(name && newName && typeof newName === 'number' && collisionPresent && numericNameWarningCount < numericNameWarningCountLimit) {
	            numericNameWarningCount++;
	
	            Lib.warn('addFrames: overwriting frame "' + (_frameHash[name] || _frameHashLocal[name]).name +
	                '" with a frame whose name of type "number" also equates to "' +
	                name + '". This is valid but may potentially lead to unexpected ' +
	                'behavior since all plotly.js frame names are stored internally ' +
	                'as strings.');
	
	            if(numericNameWarningCount === numericNameWarningCountLimit) {
	                Lib.warn('addFrames: This API call has yielded too many of these warnings. ' +
	                    'For the rest of this call, further warnings about numeric frame ' +
	                    'names will be suppressed.');
	            }
	        }
	
	        _frameHashLocal[lookupName] = {name: lookupName};
	
	        insertions.push({
	            frame: Plots.supplyFrameDefaults(frameList[i]),
	            index: (indices && indices[i] !== undefined && indices[i] !== null) ? indices[i] : bigIndex + i
	        });
	    }
	
	    // Sort this, taking note that undefined insertions end up at the end:
	    insertions.sort(function(a, b) {
	        if(a.index > b.index) return -1;
	        if(a.index < b.index) return 1;
	        return 0;
	    });
	
	    var ops = [];
	    var revops = [];
	    var frameCount = _frames.length;
	
	    for(i = insertions.length - 1; i >= 0; i--) {
	        frame = insertions[i].frame;
	
	        if(typeof frame.name === 'number') {
	            Lib.warn('Warning: addFrames accepts frames with numeric names, but the numbers are' +
	                'implicitly cast to strings');
	        }
	
	        if(!frame.name) {
	            // Repeatedly assign a default name, incrementing the counter each time until
	            // we get a name that's not in the hashed lookup table:
	            while(_frameHash[(frame.name = 'frame ' + gd._transitionData._counter++)]);
	        }
	
	        if(_frameHash[frame.name]) {
	            // If frame is present, overwrite its definition:
	            for(j = 0; j < _frames.length; j++) {
	                if((_frames[j] || {}).name === frame.name) break;
	            }
	            ops.push({type: 'replace', index: j, value: frame});
	            revops.unshift({type: 'replace', index: j, value: _frames[j]});
	        } else {
	            // Otherwise insert it at the end of the list:
	            idx = Math.max(0, Math.min(insertions[i].index, frameCount));
	
	            ops.push({type: 'insert', index: idx, value: frame});
	            revops.unshift({type: 'delete', index: idx});
	            frameCount++;
	        }
	    }
	
	    var undoFunc = Plots.modifyFrames;
	    var redoFunc = Plots.modifyFrames;
	    var undoArgs = [gd, revops];
	    var redoArgs = [gd, ops];
	
	    if(Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	
	    return Plots.modifyFrames(gd, ops);
	}
	
	/**
	 * Delete frame
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 *
	 * @param {array of integers} frameList
	 *      list of integer indices of frames to be deleted
	 */
	function deleteFrames(gd, frameList) {
	    gd = Lib.getGraphDiv(gd);
	
	    if(!Lib.isPlotDiv(gd)) {
	        throw new Error('This element is not a Plotly plot: ' + gd);
	    }
	
	    var i, idx;
	    var _frames = gd._transitionData._frames;
	    var ops = [];
	    var revops = [];
	
	    if(!frameList) {
	        frameList = [];
	        for(i = 0; i < _frames.length; i++) {
	            frameList.push(i);
	        }
	    }
	
	    frameList = frameList.slice();
	    frameList.sort();
	
	    for(i = frameList.length - 1; i >= 0; i--) {
	        idx = frameList[i];
	        ops.push({type: 'delete', index: idx});
	        revops.unshift({type: 'insert', index: idx, value: _frames[idx]});
	    }
	
	    var undoFunc = Plots.modifyFrames;
	    var redoFunc = Plots.modifyFrames;
	    var undoArgs = [gd, revops];
	    var redoArgs = [gd, ops];
	
	    if(Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	
	    return Plots.modifyFrames(gd, ops);
	}
	
	/**
	 * Purge a graph container div back to its initial pre-Plotly.plot state
	 *
	 * @param {string id or DOM element} gd
	 *      the id or DOM element of the graph container div
	 */
	function purge(gd) {
	    gd = Lib.getGraphDiv(gd);
	
	    var fullLayout = gd._fullLayout || {};
	    var fullData = gd._fullData || [];
	
	    // remove gl contexts
	    Plots.cleanPlot([], {}, fullData, fullLayout);
	
	    // purge properties
	    Plots.purge(gd);
	
	    // purge event emitter methods
	    Events.purge(gd);
	
	    // remove plot container
	    if(fullLayout._container) fullLayout._container.remove();
	
	    // in contrast to Plotly.Plots.purge which does NOT clear _context!
	    delete gd._context;
	
	    return gd;
	}
	
	// -------------------------------------------------------
	// makePlotFramework: Create the plot container and axes
	// -------------------------------------------------------
	function makePlotFramework(gd) {
	    var gd3 = d3.select(gd);
	    var fullLayout = gd._fullLayout;
	
	    // Plot container
	    fullLayout._container = gd3.selectAll('.plot-container').data([0]);
	    fullLayout._container.enter().insert('div', ':first-child')
	        .classed('plot-container', true)
	        .classed('plotly', true);
	
	    // Make the svg container
	    fullLayout._paperdiv = fullLayout._container.selectAll('.svg-container').data([0]);
	    fullLayout._paperdiv.enter().append('div')
	        .classed('svg-container', true)
	        .style('position', 'relative');
	
	    // Make the graph containers
	    // start fresh each time we get here, so we know the order comes out
	    // right, rather than enter/exit which can muck up the order
	    // TODO: sort out all the ordering so we don't have to
	    // explicitly delete anything
	    // FIXME: parcoords reuses this object, not the best pattern
	    fullLayout._glcontainer = fullLayout._paperdiv.selectAll('.gl-container')
	        .data([{}]);
	
	    fullLayout._glcontainer.enter().append('div')
	        .classed('gl-container', true);
	
	    fullLayout._paperdiv.selectAll('.main-svg').remove();
	    fullLayout._paperdiv.select('.modebar-container').remove();
	
	    fullLayout._paper = fullLayout._paperdiv.insert('svg', ':first-child')
	        .classed('main-svg', true);
	
	    fullLayout._toppaper = fullLayout._paperdiv.append('svg')
	        .classed('main-svg', true);
	
	    fullLayout._modebardiv = fullLayout._paperdiv.append('div');
	
	    fullLayout._hoverpaper = fullLayout._paperdiv.append('svg')
	        .classed('main-svg', true);
	
	    if(!fullLayout._uid) {
	        var otherUids = {};
	        d3.selectAll('defs').each(function() {
	            if(this.id) otherUids[this.id.split('-')[1]] = 1;
	        });
	        fullLayout._uid = Lib.randstr(otherUids);
	    }
	
	    fullLayout._paperdiv.selectAll('.main-svg')
	        .attr(xmlnsNamespaces.svgAttrs);
	
	    fullLayout._defs = fullLayout._paper.append('defs')
	        .attr('id', 'defs-' + fullLayout._uid);
	
	    fullLayout._clips = fullLayout._defs.append('g')
	        .classed('clips', true);
	
	    fullLayout._topdefs = fullLayout._toppaper.append('defs')
	        .attr('id', 'topdefs-' + fullLayout._uid);
	
	    fullLayout._topclips = fullLayout._topdefs.append('g')
	        .classed('clips', true);
	
	    fullLayout._bgLayer = fullLayout._paper.append('g')
	        .classed('bglayer', true);
	
	    fullLayout._draggers = fullLayout._paper.append('g')
	        .classed('draglayer', true);
	
	    // lower shape/image layer - note that this is behind
	    // all subplots data/grids but above the backgrounds
	    // except inset subplots, whose backgrounds are drawn
	    // inside their own group so that they appear above
	    // the data for the main subplot
	    // lower shapes and images which are fully referenced to
	    // a subplot still get drawn within the subplot's group
	    // so they will work correctly on insets
	    var layerBelow = fullLayout._paper.append('g')
	        .classed('layer-below', true);
	    fullLayout._imageLowerLayer = layerBelow.append('g')
	        .classed('imagelayer', true);
	    fullLayout._shapeLowerLayer = layerBelow.append('g')
	        .classed('shapelayer', true);
	
	    // single cartesian layer for the whole plot
	    fullLayout._cartesianlayer = fullLayout._paper.append('g').classed('cartesianlayer', true);
	
	    // single polar layer for the whole plot
	    fullLayout._polarlayer = fullLayout._paper.append('g').classed('polarlayer', true);
	
	    // single ternary layer for the whole plot
	    fullLayout._ternarylayer = fullLayout._paper.append('g').classed('ternarylayer', true);
	
	    // single geo layer for the whole plot
	    fullLayout._geolayer = fullLayout._paper.append('g').classed('geolayer', true);
	
	    // single funnelarea layer for the whole plot
	    fullLayout._funnelarealayer = fullLayout._paper.append('g').classed('funnelarealayer', true);
	
	    // single pie layer for the whole plot
	    fullLayout._pielayer = fullLayout._paper.append('g').classed('pielayer', true);
	
	    // single treemap layer for the whole plot
	    fullLayout._treemaplayer = fullLayout._paper.append('g').classed('treemaplayer', true);
	
	    // single sunburst layer for the whole plot
	    fullLayout._sunburstlayer = fullLayout._paper.append('g').classed('sunburstlayer', true);
	
	    // single indicator layer for the whole plot
	    fullLayout._indicatorlayer = fullLayout._toppaper.append('g').classed('indicatorlayer', true);
	
	    // fill in image server scrape-svg
	    fullLayout._glimages = fullLayout._paper.append('g').classed('glimages', true);
	
	    // lastly upper shapes, info (legend, annotations) and hover layers go on top
	    // these are in a different svg element normally, but get collapsed into a single
	    // svg when exporting (after inserting 3D)
	    // upper shapes/images are only those drawn above the whole plot, including subplots
	    var layerAbove = fullLayout._toppaper.append('g')
	        .classed('layer-above', true);
	    fullLayout._imageUpperLayer = layerAbove.append('g')
	        .classed('imagelayer', true);
	    fullLayout._shapeUpperLayer = layerAbove.append('g')
	        .classed('shapelayer', true);
	
	    fullLayout._infolayer = fullLayout._toppaper.append('g').classed('infolayer', true);
	    fullLayout._menulayer = fullLayout._toppaper.append('g').classed('menulayer', true);
	    fullLayout._zoomlayer = fullLayout._toppaper.append('g').classed('zoomlayer', true);
	    fullLayout._hoverlayer = fullLayout._hoverpaper.append('g').classed('hoverlayer', true);
	
	    // Make the modebar container
	    fullLayout._modebardiv
	        .classed('modebar-container', true)
	        .style('position', 'absolute')
	        .style('top', '0px')
	        .style('right', '0px');
	
	    gd.emit('plotly_framework');
	}
	
	exports.animate = animate;
	exports.addFrames = addFrames;
	exports.deleteFrames = deleteFrames;
	
	exports.addTraces = addTraces;
	exports.deleteTraces = deleteTraces;
	exports.extendTraces = extendTraces;
	exports.moveTraces = moveTraces;
	exports.prependTraces = prependTraces;
	
	exports.newPlot = newPlot;
	exports.plot = plot;
	exports.purge = purge;
	
	exports.react = react;
	exports.redraw = redraw;
	exports.relayout = relayout;
	exports.restyle = restyle;
	
	exports.setPlotConfig = setPlotConfig;
	
	exports.update = update;
	
	exports._guiRelayout = guiEdit(relayout);
	exports._guiRestyle = guiEdit(restyle);
	exports._guiUpdate = guiEdit(update);
	
	exports._storeDirectGUIEdit = _storeDirectGUIEdit;
	
	},{"../components/color":591,"../components/drawing":612,"../constants/xmlns_namespaces":693,"../lib":716,"../lib/events":706,"../lib/queue":731,"../lib/svg_text_utils":740,"../plots/cartesian/axes":764,"../plots/cartesian/constants":770,"../plots/cartesian/graph_interact":773,"../plots/cartesian/select":781,"../plots/plots":825,"../plots/polar/legacy":833,"../registry":845,"./edit_types":747,"./helpers":748,"./manage_arrays":750,"./plot_config":752,"./plot_schema":753,"./subroutines":755,"d3":164,"fast-isnumeric":227,"has-hover":411}],752:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * This will be transferred over to gd and overridden by
	 * config args to Plotly.plot.
	 *
	 * The defaults are the appropriate settings for plotly.js,
	 * so we get the right experience without any config argument.
	 *
	 * N.B. the config options are not coerced using Lib.coerce so keys
	 * like `valType` and `values` are only set for documentation purposes
	 * at the moment.
	 */
	
	var configAttributes = {
	    staticPlot: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	
	    plotlyServerURL: {
	        valType: 'string',
	        dflt: 'https://plot.ly',
	        
	    },
	
	    editable: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    edits: {
	        annotationPosition: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        annotationTail: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        annotationText: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        axisTitleText: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        colorbarPosition: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        colorbarTitleText: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        legendPosition: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        legendText: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        shapePosition: {
	            valType: 'boolean',
	            dflt: false,
	            
	        },
	        titleText: {
	            valType: 'boolean',
	            dflt: false,
	            
	        }
	    },
	
	    autosizable: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    responsive: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    fillFrame: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    frameMargins: {
	        valType: 'number',
	        dflt: 0,
	        min: 0,
	        max: 0.5,
	        
	    },
	
	    scrollZoom: {
	        valType: 'flaglist',
	        flags: ['cartesian', 'gl3d', 'geo', 'mapbox'],
	        extras: [true, false],
	        dflt: 'gl3d+geo+mapbox',
	        
	    },
	    doubleClick: {
	        valType: 'enumerated',
	        values: [false, 'reset', 'autosize', 'reset+autosize'],
	        dflt: 'reset+autosize',
	        
	    },
	    doubleClickDelay: {
	        valType: 'number',
	        dflt: 300,
	        min: 0,
	        
	    },
	
	    showAxisDragHandles: {
	        valType: 'boolean',
	        dflt: true,
	        
	    },
	    showAxisRangeEntryBoxes: {
	        valType: 'boolean',
	        dflt: true,
	        
	    },
	
	    showTips: {
	        valType: 'boolean',
	        dflt: true,
	        
	    },
	
	    showLink: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    linkText: {
	        valType: 'string',
	        dflt: 'Edit chart',
	        noBlank: true,
	        
	    },
	    sendData: {
	        valType: 'boolean',
	        dflt: true,
	        
	    },
	    showSources: {
	        valType: 'any',
	        dflt: false,
	        
	    },
	
	    displayModeBar: {
	        valType: 'enumerated',
	        values: ['hover', true, false],
	        dflt: 'hover',
	        
	    },
	    showSendToCloud: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    showEditInChartStudio: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	    modeBarButtonsToRemove: {
	        valType: 'any',
	        dflt: [],
	        
	    },
	    modeBarButtonsToAdd: {
	        valType: 'any',
	        dflt: [],
	        
	    },
	    modeBarButtons: {
	        valType: 'any',
	        dflt: false,
	        
	    },
	    toImageButtonOptions: {
	        valType: 'any',
	        dflt: {},
	        
	    },
	    displaylogo: {
	        valType: 'boolean',
	        dflt: true,
	        
	    },
	    watermark: {
	        valType: 'boolean',
	        dflt: false,
	        
	    },
	
	    plotGlPixelRatio: {
	        valType: 'number',
	        dflt: 2,
	        min: 1,
	        max: 4,
	        
	    },
	
	    setBackground: {
	        valType: 'any',
	        dflt: 'transparent',
	        
	    },
	
	    topojsonURL: {
	        valType: 'string',
	        noBlank: true,
	        dflt: 'https://cdn.plot.ly/',
	        
	    },
	
	    mapboxAccessToken: {
	        valType: 'string',
	        dflt: null,
	        
	    },
	
	    logging: {
	        valType: 'boolean',
	        dflt: 1,
	        
	    },
	
	    queueLength: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	    },
	
	    globalTransforms: {
	        valType: 'any',
	        dflt: [],
	        
	    },
	
	    locale: {
	        valType: 'string',
	        dflt: 'en-US',
	        
	    },
	
	    locales: {
	        valType: 'any',
	        dflt: {},
	        
	    }
	};
	
	var dfltConfig = {};
	
	function crawl(src, target) {
	    for(var k in src) {
	        var obj = src[k];
	        if(obj.valType) {
	            target[k] = obj.dflt;
	        } else {
	            if(!target[k]) {
	                target[k] = {};
	            }
	            crawl(obj, target[k]);
	        }
	    }
	}
	
	crawl(configAttributes, dfltConfig);
	
	module.exports = {
	    configAttributes: configAttributes,
	    dfltConfig: dfltConfig
	};
	
	},{}],753:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	var Lib = _dereq_('../lib');
	
	var baseAttributes = _dereq_('../plots/attributes');
	var baseLayoutAttributes = _dereq_('../plots/layout_attributes');
	var frameAttributes = _dereq_('../plots/frame_attributes');
	var animationAttributes = _dereq_('../plots/animation_attributes');
	var configAttributes = _dereq_('./plot_config').configAttributes;
	
	// polar attributes are not part of the Registry yet
	var polarAreaAttrs = _dereq_('../plots/polar/legacy/area_attributes');
	var polarAxisAttrs = _dereq_('../plots/polar/legacy/axis_attributes');
	
	var editTypes = _dereq_('./edit_types');
	
	var extendFlat = Lib.extendFlat;
	var extendDeepAll = Lib.extendDeepAll;
	var isPlainObject = Lib.isPlainObject;
	var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	var nestedProperty = Lib.nestedProperty;
	var valObjectMeta = Lib.valObjectMeta;
	
	var IS_SUBPLOT_OBJ = '_isSubplotObj';
	var IS_LINKED_TO_ARRAY = '_isLinkedToArray';
	var ARRAY_ATTR_REGEXPS = '_arrayAttrRegexps';
	var DEPRECATED = '_deprecated';
	var UNDERSCORE_ATTRS = [IS_SUBPLOT_OBJ, IS_LINKED_TO_ARRAY, ARRAY_ATTR_REGEXPS, DEPRECATED];
	
	exports.IS_SUBPLOT_OBJ = IS_SUBPLOT_OBJ;
	exports.IS_LINKED_TO_ARRAY = IS_LINKED_TO_ARRAY;
	exports.DEPRECATED = DEPRECATED;
	exports.UNDERSCORE_ATTRS = UNDERSCORE_ATTRS;
	
	/** Outputs the full plotly.js plot schema
	 *
	 * @return {object}
	 *  - defs
	 *  - traces
	 *  - layout
	 *  - transforms
	 *  - frames
	 *  - animations
	 *  - config
	 */
	exports.get = function() {
	    var traces = {};
	
	    Registry.allTypes.concat('area').forEach(function(type) {
	        traces[type] = getTraceAttributes(type);
	    });
	
	    var transforms = {};
	
	    Object.keys(Registry.transformsRegistry).forEach(function(type) {
	        transforms[type] = getTransformAttributes(type);
	    });
	
	    return {
	        defs: {
	            valObjects: valObjectMeta,
	            metaKeys: UNDERSCORE_ATTRS.concat(['description', 'role', 'editType', 'impliedEdits']),
	            editType: {
	                traces: editTypes.traces,
	                layout: editTypes.layout
	            },
	            impliedEdits: {
	                
	            }
	        },
	
	        traces: traces,
	        layout: getLayoutAttributes(),
	
	        transforms: transforms,
	
	        frames: getFramesAttributes(),
	        animation: formatAttributes(animationAttributes),
	
	        config: formatAttributes(configAttributes)
	    };
	};
	
	/**
	 * Crawl the attribute tree, recursively calling a callback function
	 *
	 * @param {object} attrs
	 *  The node of the attribute tree (e.g. the root) from which recursion originates
	 * @param {Function} callback
	 *  A callback function with the signature:
	 *          @callback callback
	 *          @param {object} attr an attribute
	 *          @param {String} attrName name string
	 *          @param {object[]} attrs all the attributes
	 *          @param {Number} level the recursion level, 0 at the root
	 *          @param {String} fullAttrString full attribute name (ie 'marker.line')
	 * @param {Number} [specifiedLevel]
	 *  The level in the tree, in order to let the callback function detect descend or backtrack,
	 *  typically unsupplied (implied 0), just used by the self-recursive call.
	 *  The necessity arises because the tree traversal is not controlled by callback return values.
	 *  The decision to not use callback return values for controlling tree pruning arose from
	 *  the goal of keeping the crawler backwards compatible. Observe that one of the pruning conditions
	 *  precedes the callback call.
	 * @param {string} [attrString]
	 *  the path to the current attribute, as an attribute string (ie 'marker.line')
	 *  typically unsupplied, but you may supply it if you want to disambiguate which attrs tree you
	 *  are starting from
	 *
	 * @return {object} transformOut
	 *  copy of transformIn that contains attribute defaults
	 */
	exports.crawl = function(attrs, callback, specifiedLevel, attrString) {
	    var level = specifiedLevel || 0;
	    attrString = attrString || '';
	
	    Object.keys(attrs).forEach(function(attrName) {
	        var attr = attrs[attrName];
	
	        if(UNDERSCORE_ATTRS.indexOf(attrName) !== -1) return;
	
	        var fullAttrString = (attrString ? attrString + '.' : '') + attrName;
	        callback(attr, attrName, attrs, level, fullAttrString);
	
	        if(exports.isValObject(attr)) return;
	
	        if(isPlainObject(attr) && attrName !== 'impliedEdits') {
	            exports.crawl(attr, callback, level + 1, fullAttrString);
	        }
	    });
	};
	
	/** Is object a value object (or a container object)?
	 *
	 * @param {object} obj
	 * @return {boolean}
	 *  returns true for a valid value object and
	 *  false for tree nodes in the attribute hierarchy
	 */
	exports.isValObject = function(obj) {
	    return obj && obj.valType !== undefined;
	};
	
	/**
	 * Find all data array attributes in a given trace object - including
	 * `arrayOk` attributes.
	 *
	 * @param {object} trace
	 *  full trace object that contains a reference to `_module.attributes`
	 *
	 * @return {array} arrayAttributes
	 *  list of array attributes for the given trace
	 */
	exports.findArrayAttributes = function(trace) {
	    var arrayAttributes = [];
	    var stack = [];
	    var isArrayStack = [];
	    var baseContainer, baseAttrName;
	
	    function callback(attr, attrName, attrs, level) {
	        stack = stack.slice(0, level).concat([attrName]);
	        isArrayStack = isArrayStack.slice(0, level).concat([attr && attr._isLinkedToArray]);
	
	        var splittableAttr = (
	            attr &&
	            (attr.valType === 'data_array' || attr.arrayOk === true) &&
	            !(stack[level - 1] === 'colorbar' && (attrName === 'ticktext' || attrName === 'tickvals'))
	        );
	
	        // Manually exclude 'colorbar.tickvals' and 'colorbar.ticktext' for now
	        // which are declared as `valType: 'data_array'` but scale independently of
	        // the coordinate arrays.
	        //
	        // Down the road, we might want to add a schema field (e.g `uncorrelatedArray: true`)
	        // to distinguish attributes of the likes.
	
	        if(!splittableAttr) return;
	
	        crawlIntoTrace(baseContainer, 0, '');
	    }
	
	    function crawlIntoTrace(container, i, astrPartial) {
	        var item = container[stack[i]];
	        var newAstrPartial = astrPartial + stack[i];
	        if(i === stack.length - 1) {
	            if(isArrayOrTypedArray(item)) {
	                arrayAttributes.push(baseAttrName + newAstrPartial);
	            }
	        } else {
	            if(isArrayStack[i]) {
	                if(Array.isArray(item)) {
	                    for(var j = 0; j < item.length; j++) {
	                        if(isPlainObject(item[j])) {
	                            crawlIntoTrace(item[j], i + 1, newAstrPartial + '[' + j + '].');
	                        }
	                    }
	                }
	            } else if(isPlainObject(item)) {
	                crawlIntoTrace(item, i + 1, newAstrPartial + '.');
	            }
	        }
	    }
	
	    baseContainer = trace;
	    baseAttrName = '';
	    exports.crawl(baseAttributes, callback);
	    if(trace._module && trace._module.attributes) {
	        exports.crawl(trace._module.attributes, callback);
	    }
	
	    var transforms = trace.transforms;
	    if(transforms) {
	        for(var i = 0; i < transforms.length; i++) {
	            var transform = transforms[i];
	            var module = transform._module;
	
	            if(module) {
	                baseAttrName = 'transforms[' + i + '].';
	                baseContainer = transform;
	
	                exports.crawl(module.attributes, callback);
	            }
	        }
	    }
	
	    return arrayAttributes;
	};
	
	/*
	 * Find the valObject for one attribute in an existing trace
	 *
	 * @param {object} trace
	 *  full trace object that contains a reference to `_module.attributes`
	 * @param {object} parts
	 *  an array of parts, like ['transforms', 1, 'value']
	 *  typically from nestedProperty(...).parts
	 *
	 * @return {object|false}
	 *  the valObject for this attribute, or the last found parent
	 *  in some cases the innermost valObject will not exist, for example
	 *  `valType: 'any'` attributes where we might set a part of the attribute.
	 *  In that case, stop at the deepest valObject we *do* find.
	 */
	exports.getTraceValObject = function(trace, parts) {
	    var head = parts[0];
	    var i = 1; // index to start recursing from
	    var moduleAttrs, valObject;
	
	    if(head === 'transforms') {
	        if(parts.length === 1) {
	            return baseAttributes.transforms;
	        }
	        var transforms = trace.transforms;
	        if(!Array.isArray(transforms) || !transforms.length) return false;
	        var tNum = parts[1];
	        if(!isIndex(tNum) || tNum >= transforms.length) {
	            return false;
	        }
	        moduleAttrs = (Registry.transformsRegistry[transforms[tNum].type] || {}).attributes;
	        valObject = moduleAttrs && moduleAttrs[parts[2]];
	        i = 3; // start recursing only inside the transform
	    } else if(trace.type === 'area') {
	        valObject = polarAreaAttrs[head];
	    } else {
	        // first look in the module for this trace
	        // components have already merged their trace attributes in here
	        var _module = trace._module;
	        if(!_module) _module = (Registry.modules[trace.type || baseAttributes.type.dflt] || {})._module;
	        if(!_module) return false;
	
	        moduleAttrs = _module.attributes;
	        valObject = moduleAttrs && moduleAttrs[head];
	
	        // then look in the subplot attributes
	        if(!valObject) {
	            var subplotModule = _module.basePlotModule;
	            if(subplotModule && subplotModule.attributes) {
	                valObject = subplotModule.attributes[head];
	            }
	        }
	
	        // finally look in the global attributes
	        if(!valObject) valObject = baseAttributes[head];
	    }
	
	    return recurseIntoValObject(valObject, parts, i);
	};
	
	/*
	 * Find the valObject for one layout attribute
	 *
	 * @param {array} parts
	 *  an array of parts, like ['annotations', 1, 'x']
	 *  typically from nestedProperty(...).parts
	 *
	 * @return {object|false}
	 *  the valObject for this attribute, or the last found parent
	 *  in some cases the innermost valObject will not exist, for example
	 *  `valType: 'any'` attributes where we might set a part of the attribute.
	 *  In that case, stop at the deepest valObject we *do* find.
	 */
	exports.getLayoutValObject = function(fullLayout, parts) {
	    var valObject = layoutHeadAttr(fullLayout, parts[0]);
	
	    return recurseIntoValObject(valObject, parts, 1);
	};
	
	function layoutHeadAttr(fullLayout, head) {
	    var i, key, _module, attributes;
	
	    // look for attributes of the subplot types used on the plot
	    var basePlotModules = fullLayout._basePlotModules;
	    if(basePlotModules) {
	        var out;
	        for(i = 0; i < basePlotModules.length; i++) {
	            _module = basePlotModules[i];
	            if(_module.attrRegex && _module.attrRegex.test(head)) {
	                // if a module defines overrides, these take precedence
	                // initially this is to allow gl2d different editTypes from svg cartesian
	                if(_module.layoutAttrOverrides) return _module.layoutAttrOverrides;
	
	                // otherwise take the first attributes we find
	                if(!out && _module.layoutAttributes) out = _module.layoutAttributes;
	            }
	
	            // a module can also override the behavior of base (and component) module layout attrs
	            // again see gl2d for initial use case
	            var baseOverrides = _module.baseLayoutAttrOverrides;
	            if(baseOverrides && head in baseOverrides) return baseOverrides[head];
	        }
	        if(out) return out;
	    }
	
	    // look for layout attributes contributed by traces on the plot
	    var modules = fullLayout._modules;
	    if(modules) {
	        for(i = 0; i < modules.length; i++) {
	            attributes = modules[i].layoutAttributes;
	            if(attributes && head in attributes) {
	                return attributes[head];
	            }
	        }
	    }
	
	    /*
	     * Next look in components.
	     * Components that define a schema have already merged this into
	     * base and subplot attribute defs, so ignore these.
	     * Others (older style) all put all their attributes
	     * inside a container matching the module `name`
	     * eg `attributes` (array) or `legend` (object)
	     */
	    for(key in Registry.componentsRegistry) {
	        _module = Registry.componentsRegistry[key];
	        if(_module.name === 'colorscale' && head.indexOf('coloraxis') === 0) {
	            return _module.layoutAttributes[head];
	        } else if(!_module.schema && (head === _module.name)) {
	            return _module.layoutAttributes;
	        }
	    }
	
	    if(head in baseLayoutAttributes) return baseLayoutAttributes[head];
	
	    // Polar doesn't populate _modules or _basePlotModules
	    // just fall back on these when the others fail
	    if(head === 'radialaxis' || head === 'angularaxis') {
	        return polarAxisAttrs[head];
	    }
	    return polarAxisAttrs.layout[head] || false;
	}
	
	function recurseIntoValObject(valObject, parts, i) {
	    if(!valObject) return false;
	
	    if(valObject._isLinkedToArray) {
	        // skip array index, abort if we try to dive into an array without an index
	        if(isIndex(parts[i])) i++;
	        else if(i < parts.length) return false;
	    }
	
	    // now recurse as far as we can. Occasionally we have an attribute
	    // setting an internal part below what's in the schema; just return
	    // the innermost schema item we find.
	    for(; i < parts.length; i++) {
	        var newValObject = valObject[parts[i]];
	        if(isPlainObject(newValObject)) valObject = newValObject;
	        else break;
	
	        if(i === parts.length - 1) break;
	
	        if(valObject._isLinkedToArray) {
	            i++;
	            if(!isIndex(parts[i])) return false;
	        } else if(valObject.valType === 'info_array') {
	            i++;
	            var index = parts[i];
	            if(!isIndex(index)) return false;
	
	            var items = valObject.items;
	            if(Array.isArray(items)) {
	                if(index >= items.length) return false;
	                if(valObject.dimensions === 2) {
	                    i++;
	                    if(parts.length === i) return valObject;
	                    var index2 = parts[i];
	                    if(!isIndex(index2)) return false;
	                    valObject = items[index][index2];
	                } else valObject = items[index];
	            } else {
	                valObject = items;
	            }
	        }
	    }
	
	    return valObject;
	}
	
	// note: this is different from Lib.isIndex, this one doesn't accept numeric
	// strings, only actual numbers.
	function isIndex(val) {
	    return val === Math.round(val) && val >= 0;
	}
	
	function getTraceAttributes(type) {
	    var _module, basePlotModule;
	
	    if(type === 'area') {
	        _module = { attributes: polarAreaAttrs };
	        basePlotModule = {};
	    } else {
	        _module = Registry.modules[type]._module,
	        basePlotModule = _module.basePlotModule;
	    }
	
	    var attributes = {};
	
	    // make 'type' the first attribute in the object
	    attributes.type = null;
	
	    var copyBaseAttributes = extendDeepAll({}, baseAttributes);
	    var copyModuleAttributes = extendDeepAll({}, _module.attributes);
	
	    // prune global-level trace attributes that are already defined in a trace
	    exports.crawl(copyModuleAttributes, function(attr, attrName, attrs, level, fullAttrString) {
	        nestedProperty(copyBaseAttributes, fullAttrString).set(undefined);
	        // Prune undefined attributes
	        if(attr === undefined) nestedProperty(copyModuleAttributes, fullAttrString).set(undefined);
	    });
	
	    // base attributes (same for all trace types)
	    extendDeepAll(attributes, copyBaseAttributes);
	
	    // prune-out base attributes based on trace module categories
	    if(Registry.traceIs(type, 'noOpacity')) {
	        delete attributes.opacity;
	    }
	    if(!Registry.traceIs(type, 'showLegend')) {
	        delete attributes.showlegend;
	        delete attributes.legendgroup;
	    }
	    if(Registry.traceIs(type, 'noHover')) {
	        delete attributes.hoverinfo;
	        delete attributes.hoverlabel;
	    }
	    if(!_module.selectPoints) {
	        delete attributes.selectedpoints;
	    }
	
	    // module attributes
	    extendDeepAll(attributes, copyModuleAttributes);
	
	    // subplot attributes
	    if(basePlotModule.attributes) {
	        extendDeepAll(attributes, basePlotModule.attributes);
	    }
	
	    // 'type' gets overwritten by baseAttributes; reset it here
	    attributes.type = type;
	
	    var out = {
	        meta: _module.meta || {},
	        categories: _module.categories || {},
	        animatable: Boolean(_module.animatable),
	        type: type,
	        attributes: formatAttributes(attributes),
	    };
	
	    // trace-specific layout attributes
	    if(_module.layoutAttributes) {
	        var layoutAttributes = {};
	
	        extendDeepAll(layoutAttributes, _module.layoutAttributes);
	        out.layoutAttributes = formatAttributes(layoutAttributes);
	    }
	
	    // drop anim:true in non-animatable modules
	    if(!_module.animatable) {
	        exports.crawl(out, function(attr) {
	            if(exports.isValObject(attr) && 'anim' in attr) {
	                delete attr.anim;
	            }
	        });
	    }
	
	    return out;
	}
	
	function getLayoutAttributes() {
	    var layoutAttributes = {};
	    var key, _module;
	
	    // global layout attributes
	    extendDeepAll(layoutAttributes, baseLayoutAttributes);
	
	    // add base plot module layout attributes
	    for(key in Registry.subplotsRegistry) {
	        _module = Registry.subplotsRegistry[key];
	
	        if(!_module.layoutAttributes) continue;
	
	        if(Array.isArray(_module.attr)) {
	            for(var i = 0; i < _module.attr.length; i++) {
	                handleBasePlotModule(layoutAttributes, _module, _module.attr[i]);
	            }
	        } else {
	            var astr = _module.attr === 'subplot' ? _module.name : _module.attr;
	            handleBasePlotModule(layoutAttributes, _module, astr);
	        }
	    }
	
	    // polar layout attributes
	    layoutAttributes = assignPolarLayoutAttrs(layoutAttributes);
	
	    // add registered components layout attributes
	    for(key in Registry.componentsRegistry) {
	        _module = Registry.componentsRegistry[key];
	        var schema = _module.schema;
	
	        if(schema && (schema.subplots || schema.layout)) {
	            /*
	             * Components with defined schema have already been merged in at register time
	             * but a few components define attributes that apply only to xaxis
	             * not yaxis (rangeselector, rangeslider) - delete from y schema.
	             * Note that the input attributes for xaxis/yaxis are the same object
	             * so it's not possible to only add them to xaxis from the start.
	             * If we ever have such asymmetry the other way, or anywhere else,
	             * we will need to extend both this code and mergeComponentAttrsToSubplot
	             * (which will not find yaxis only for example)
	             */
	            var subplots = schema.subplots;
	            if(subplots && subplots.xaxis && !subplots.yaxis) {
	                for(var xkey in subplots.xaxis) {
	                    delete layoutAttributes.yaxis[xkey];
	                }
	            }
	        } else if(_module.name === 'colorscale') {
	            extendDeepAll(layoutAttributes, _module.layoutAttributes);
	        } else if(_module.layoutAttributes) {
	            // older style without schema need to be explicitly merged in now
	            insertAttrs(layoutAttributes, _module.layoutAttributes, _module.name);
	        }
	    }
	
	    return {
	        layoutAttributes: formatAttributes(layoutAttributes)
	    };
	}
	
	function getTransformAttributes(type) {
	    var _module = Registry.transformsRegistry[type];
	    var attributes = extendDeepAll({}, _module.attributes);
	
	    // add registered components transform attributes
	    Object.keys(Registry.componentsRegistry).forEach(function(k) {
	        var _module = Registry.componentsRegistry[k];
	
	        if(_module.schema && _module.schema.transforms && _module.schema.transforms[type]) {
	            Object.keys(_module.schema.transforms[type]).forEach(function(v) {
	                insertAttrs(attributes, _module.schema.transforms[type][v], v);
	            });
	        }
	    });
	
	    return {
	        attributes: formatAttributes(attributes)
	    };
	}
	
	function getFramesAttributes() {
	    var attrs = {
	        frames: extendDeepAll({}, frameAttributes)
	    };
	
	    formatAttributes(attrs);
	
	    return attrs.frames;
	}
	
	function formatAttributes(attrs) {
	    mergeValTypeAndRole(attrs);
	    formatArrayContainers(attrs);
	    stringify(attrs);
	
	    return attrs;
	}
	
	function mergeValTypeAndRole(attrs) {
	    function makeSrcAttr(attrName) {
	        return {
	            valType: 'string',
	            
	            
	            editType: 'none'
	        };
	    }
	
	    function callback(attr, attrName, attrs) {
	        if(exports.isValObject(attr)) {
	            if(attr.valType === 'data_array') {
	                // all 'data_array' attrs have role 'data'
	                attr.role = 'data';
	                // all 'data_array' attrs have a corresponding 'src' attr
	                attrs[attrName + 'src'] = makeSrcAttr(attrName);
	            } else if(attr.arrayOk === true) {
	                // all 'arrayOk' attrs have a corresponding 'src' attr
	                attrs[attrName + 'src'] = makeSrcAttr(attrName);
	            }
	        } else if(isPlainObject(attr)) {
	            // all attrs container objects get role 'object'
	            attr.role = 'object';
	        }
	    }
	
	    exports.crawl(attrs, callback);
	}
	
	function formatArrayContainers(attrs) {
	    function callback(attr, attrName, attrs) {
	        if(!attr) return;
	
	        var itemName = attr[IS_LINKED_TO_ARRAY];
	
	        if(!itemName) return;
	
	        delete attr[IS_LINKED_TO_ARRAY];
	
	        attrs[attrName] = { items: {} };
	        attrs[attrName].items[itemName] = attr;
	        attrs[attrName].role = 'object';
	    }
	
	    exports.crawl(attrs, callback);
	}
	
	// this can take around 10ms and should only be run from PlotSchema.get(),
	// to ensure JSON.stringify(PlotSchema.get()) gives the intended result.
	function stringify(attrs) {
	    function walk(attr) {
	        for(var k in attr) {
	            if(isPlainObject(attr[k])) {
	                walk(attr[k]);
	            } else if(Array.isArray(attr[k])) {
	                for(var i = 0; i < attr[k].length; i++) {
	                    walk(attr[k][i]);
	                }
	            } else {
	                // as JSON.stringify(/test/) // => {}
	                if(attr[k] instanceof RegExp) {
	                    attr[k] = attr[k].toString();
	                }
	            }
	        }
	    }
	
	    walk(attrs);
	}
	
	function assignPolarLayoutAttrs(layoutAttributes) {
	    extendFlat(layoutAttributes, {
	        radialaxis: polarAxisAttrs.radialaxis,
	        angularaxis: polarAxisAttrs.angularaxis
	    });
	
	    extendFlat(layoutAttributes, polarAxisAttrs.layout);
	
	    return layoutAttributes;
	}
	
	function handleBasePlotModule(layoutAttributes, _module, astr) {
	    var np = nestedProperty(layoutAttributes, astr);
	    var attrs = extendDeepAll({}, _module.layoutAttributes);
	
	    attrs[IS_SUBPLOT_OBJ] = true;
	    np.set(attrs);
	}
	
	function insertAttrs(baseAttrs, newAttrs, astr) {
	    var np = nestedProperty(baseAttrs, astr);
	
	    np.set(extendDeepAll(np.get() || {}, newAttrs));
	}
	
	},{"../lib":716,"../plots/animation_attributes":759,"../plots/attributes":761,"../plots/frame_attributes":791,"../plots/layout_attributes":816,"../plots/polar/legacy/area_attributes":831,"../plots/polar/legacy/axis_attributes":832,"../registry":845,"./edit_types":747,"./plot_config":752}],754:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var plotAttributes = _dereq_('../plots/attributes');
	
	var TEMPLATEITEMNAME = 'templateitemname';
	
	var templateAttrs = {
	    name: {
	        valType: 'string',
	        
	        editType: 'none',
	        
	    }
	};
	templateAttrs[TEMPLATEITEMNAME] = {
	    valType: 'string',
	    
	    editType: 'calc',
	    
	};
	
	/**
	 * templatedArray: decorate an attributes object with templating (and array)
	 * properties.
	 *
	 * @param {string} name: the singular form of the array name. Sets
	 *     `_isLinkedToArray` to this, so the schema knows to treat this as an array.
	 * @param {object} attrs: the item attributes. Since all callers are expected
	 *     to be constructing this object on the spot, we mutate it here for
	 *     performance, rather than extending a new object with it.
	 *
	 * @returns {object}: the decorated `attrs` object
	 */
	exports.templatedArray = function(name, attrs) {
	    attrs._isLinkedToArray = name;
	    attrs.name = templateAttrs.name;
	    attrs[TEMPLATEITEMNAME] = templateAttrs[TEMPLATEITEMNAME];
	    return attrs;
	};
	
	/**
	 * traceTemplater: logic for matching traces to trace templates
	 *
	 * @param {object} dataTemplate: collection of {traceType: [{template}, ...]}
	 *     ie each type the template applies to contains a list of template objects,
	 *     to be provided cyclically to data traces of that type.
	 *
	 * @returns {object}: {newTrace}, a function:
	 *     newTrace(traceIn): that takes the input traceIn, coerces its type, then
	 *         uses that type to find the next template to apply. returns the output
	 *         traceOut with template attached, ready to continue supplyDefaults.
	 */
	exports.traceTemplater = function(dataTemplate) {
	    var traceCounts = {};
	    var traceType, typeTemplates;
	
	    for(traceType in dataTemplate) {
	        typeTemplates = dataTemplate[traceType];
	        if(Array.isArray(typeTemplates) && typeTemplates.length) {
	            traceCounts[traceType] = 0;
	        }
	    }
	
	    function newTrace(traceIn) {
	        traceType = Lib.coerce(traceIn, {}, plotAttributes, 'type');
	        var traceOut = {type: traceType, _template: null};
	        if(traceType in traceCounts) {
	            typeTemplates = dataTemplate[traceType];
	            // cycle through traces in the template set for this type
	            var typei = traceCounts[traceType] % typeTemplates.length;
	            traceCounts[traceType]++;
	            traceOut._template = typeTemplates[typei];
	        } else {
	            // TODO: anything we should do for types missing from the template?
	            // try to apply some other type? Or just bail as we do here?
	            // Actually I think yes, we should apply other types; would be nice
	            // if all scatter* could inherit from each other, and if histogram
	            // could inherit from bar, etc... but how to specify this? And do we
	            // compose them, or if a type is present require it to be complete?
	            // Actually this could apply to layout too - 3D annotations
	            // inheriting from 2D, axes of different types inheriting from each
	            // other...
	        }
	        return traceOut;
	    }
	
	    return {
	        newTrace: newTrace
	        // TODO: function to figure out what's left & what didn't work
	    };
	};
	
	/**
	 * newContainer: Create a new sub-container inside `container` and propagate any
	 * applicable template to it. If there's no template, still propagates
	 * `undefined` so relinkPrivate will not retain an old template!
	 *
	 * @param {object} container: the outer container, should already have _template
	 *     if there *is* a template for this plot
	 * @param {string} name: the key of the new container to make
	 * @param {string} baseName: if applicable, a base attribute to take the
	 *     template from, ie for xaxis3 the base would be xaxis
	 *
	 * @returns {object}: an object for inclusion _full*, empty except for the
	 *     appropriate template piece
	 */
	exports.newContainer = function(container, name, baseName) {
	    var template = container._template;
	    var part = template && (template[name] || (baseName && template[baseName]));
	    if(!Lib.isPlainObject(part)) part = null;
	
	    var out = container[name] = {_template: part};
	    return out;
	};
	
	/**
	 * arrayTemplater: special logic for templating both defaults and specific items
	 * in a container array (annotations etc)
	 *
	 * @param {object} container: the outer container, should already have _template
	 *     if there *is* a template for this plot
	 * @param {string} name: the name of the array to template (ie 'annotations')
	 *     will be used to find default ('annotationdefaults' object) and specific
	 *     ('annotations' array) template specs.
	 * @param {string} inclusionAttr: the attribute determining this item's
	 *     inclusion in the output, usually 'visible' or 'enabled'
	 *
	 * @returns {object}: {newItem, defaultItems}, both functions:
	 *     newItem(itemIn): create an output item, bare except for the correct
	 *         template and name(s), as the base for supplyDefaults
	 *     defaultItems(): to be called after all newItem calls, return any
	 *         specific template items that have not already beeen included,
	 *         also as bare output items ready for supplyDefaults.
	 */
	exports.arrayTemplater = function(container, name, inclusionAttr) {
	    var template = container._template;
	    var defaultsTemplate = template && template[arrayDefaultKey(name)];
	    var templateItems = template && template[name];
	    if(!Array.isArray(templateItems) || !templateItems.length) {
	        templateItems = [];
	    }
	
	    var usedNames = {};
	
	    function newItem(itemIn) {
	        // include name and templateitemname in the output object for ALL
	        // container array items. Note: you could potentially use different
	        // name and templateitemname, if you're using one template to make
	        // another template. templateitemname would be the name in the original
	        // template, and name is the new "subclassed" item name.
	        var out = {name: itemIn.name, _input: itemIn};
	        var templateItemName = out[TEMPLATEITEMNAME] = itemIn[TEMPLATEITEMNAME];
	
	        // no itemname: use the default template
	        if(!validItemName(templateItemName)) {
	            out._template = defaultsTemplate;
	            return out;
	        }
	
	        // look for an item matching this itemname
	        // note these do not inherit from the default template, only the item.
	        for(var i = 0; i < templateItems.length; i++) {
	            var templateItem = templateItems[i];
	            if(templateItem.name === templateItemName) {
	                // Note: it's OK to use a template item more than once
	                // but using it at least once will stop it from generating
	                // a default item at the end.
	                usedNames[templateItemName] = 1;
	                out._template = templateItem;
	                return out;
	            }
	        }
	
	        // Didn't find a matching template item, so since this item is intended
	        // to only be modifications it's most likely broken. Hide it unless
	        // it's explicitly marked visible - in which case it gets NO template,
	        // not even the default.
	        out[inclusionAttr] = itemIn[inclusionAttr] || false;
	        // special falsy value we can look for in validateTemplate
	        out._template = false;
	        return out;
	    }
	
	    function defaultItems() {
	        var out = [];
	        for(var i = 0; i < templateItems.length; i++) {
	            var templateItem = templateItems[i];
	            var name = templateItem.name;
	            // only allow named items to be added as defaults,
	            // and only allow each name once
	            if(validItemName(name) && !usedNames[name]) {
	                var outi = {
	                    _template: templateItem,
	                    name: name,
	                    _input: {_templateitemname: name}
	                };
	                outi[TEMPLATEITEMNAME] = templateItem[TEMPLATEITEMNAME];
	                out.push(outi);
	                usedNames[name] = 1;
	            }
	        }
	        return out;
	    }
	
	    return {
	        newItem: newItem,
	        defaultItems: defaultItems
	    };
	};
	
	function validItemName(name) {
	    return name && typeof name === 'string';
	}
	
	function arrayDefaultKey(name) {
	    var lastChar = name.length - 1;
	    if(name.charAt(lastChar) !== 's') {
	        Lib.warn('bad argument to arrayDefaultKey: ' + name);
	    }
	    return name.substr(0, name.length - 1) + 'defaults';
	}
	exports.arrayDefaultKey = arrayDefaultKey;
	
	/**
	 * arrayEditor: helper for editing array items that may have come from
	 *     template defaults (in which case they will not exist in the input yet)
	 *
	 * @param {object} parentIn: the input container (eg gd.layout)
	 * @param {string} containerStr: the attribute string for the container inside
	 *     `parentIn`.
	 * @param {object} itemOut: the _full* item (eg gd._fullLayout.annotations[0])
	 *     that we'll be editing. Assumed to have been created by `arrayTemplater`.
	 *
	 * @returns {object}: {modifyBase, modifyItem, getUpdateObj, applyUpdate}, all functions:
	 *     modifyBase(attr, value): Add an update that's *not* related to the item.
	 *         `attr` is the full attribute string.
	 *     modifyItem(attr, value): Add an update to the item. `attr` is just the
	 *         portion of the attribute string inside the item.
	 *     getUpdateObj(): Get the final constructed update object, to use in
	 *         `restyle` or `relayout`. Also resets the update object in case this
	 *         update was canceled.
	 *     applyUpdate(attr, value): optionally add an update `attr: value`,
	 *         then apply it to `parent` which should be the parent of `containerIn`,
	 *         ie the object to which `containerStr` is the attribute string.
	 */
	exports.arrayEditor = function(parentIn, containerStr, itemOut) {
	    var lengthIn = (Lib.nestedProperty(parentIn, containerStr).get() || []).length;
	    var index = itemOut._index;
	    // Check that we are indeed off the end of this container.
	    // Otherwise a devious user could put a key `_templateitemname` in their
	    // own input and break lots of things.
	    var templateItemName = (index >= lengthIn) && (itemOut._input || {})._templateitemname;
	    if(templateItemName) index = lengthIn;
	    var itemStr = containerStr + '[' + index + ']';
	
	    var update;
	    function resetUpdate() {
	        update = {};
	        if(templateItemName) {
	            update[itemStr] = {};
	            update[itemStr][TEMPLATEITEMNAME] = templateItemName;
	        }
	    }
	    resetUpdate();
	
	    function modifyBase(attr, value) {
	        update[attr] = value;
	    }
	
	    function modifyItem(attr, value) {
	        if(templateItemName) {
	            // we're making a new object: edit that object
	            Lib.nestedProperty(update[itemStr], attr).set(value);
	        } else {
	            // we're editing an existing object: include *just* the edit
	            update[itemStr + '.' + attr] = value;
	        }
	    }
	
	    function getUpdateObj() {
	        var updateOut = update;
	        resetUpdate();
	        return updateOut;
	    }
	
	    function applyUpdate(attr, value) {
	        if(attr) modifyItem(attr, value);
	        var updateToApply = getUpdateObj();
	        for(var key in updateToApply) {
	            Lib.nestedProperty(parentIn, key).set(updateToApply[key]);
	        }
	    }
	
	    return {
	        modifyBase: modifyBase,
	        modifyItem: modifyItem,
	        getUpdateObj: getUpdateObj,
	        applyUpdate: applyUpdate
	    };
	};
	
	},{"../lib":716,"../plots/attributes":761}],755:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Registry = _dereq_('../registry');
	var Plots = _dereq_('../plots/plots');
	
	var Lib = _dereq_('../lib');
	var clearGlCanvases = _dereq_('../lib/clear_gl_canvases');
	
	var Color = _dereq_('../components/color');
	var Drawing = _dereq_('../components/drawing');
	var Titles = _dereq_('../components/titles');
	var ModeBar = _dereq_('../components/modebar');
	
	var Axes = _dereq_('../plots/cartesian/axes');
	var alignmentConstants = _dereq_('../constants/alignment');
	var axisConstraints = _dereq_('../plots/cartesian/constraints');
	var enforceAxisConstraints = axisConstraints.enforce;
	var cleanAxisConstraints = axisConstraints.clean;
	var doAutoRange = _dereq_('../plots/cartesian/autorange').doAutoRange;
	
	var SVG_TEXT_ANCHOR_START = 'start';
	var SVG_TEXT_ANCHOR_MIDDLE = 'middle';
	var SVG_TEXT_ANCHOR_END = 'end';
	
	exports.layoutStyles = function(gd) {
	    return Lib.syncOrAsync([Plots.doAutoMargin, lsInner], gd);
	};
	
	function overlappingDomain(xDomain, yDomain, domains) {
	    for(var i = 0; i < domains.length; i++) {
	        var existingX = domains[i][0];
	        var existingY = domains[i][1];
	
	        if(existingX[0] >= xDomain[1] || existingX[1] <= xDomain[0]) {
	            continue;
	        }
	        if(existingY[0] < yDomain[1] && existingY[1] > yDomain[0]) {
	            return true;
	        }
	    }
	    return false;
	}
	
	function lsInner(gd) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	    var pad = gs.p;
	    var axList = Axes.list(gd, '', true);
	    var i, subplot, plotinfo, ax, xa, ya;
	
	    fullLayout._paperdiv.style({
	        width: (gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroWidth && !gd.layout.width) ? '100%' : fullLayout.width + 'px',
	        height: (gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroHeight && !gd.layout.height) ? '100%' : fullLayout.height + 'px'
	    })
	    .selectAll('.main-svg')
	    .call(Drawing.setSize, fullLayout.width, fullLayout.height);
	    gd._context.setBackground(gd, fullLayout.paper_bgcolor);
	
	    exports.drawMainTitle(gd);
	    ModeBar.manage(gd);
	
	    // _has('cartesian') means SVG specifically, not GL2D - but GL2D
	    // can still get here because it makes some of the SVG structure
	    // for shared features like selections.
	    if(!fullLayout._has('cartesian')) {
	        return Plots.previousPromises(gd);
	    }
	
	    function getLinePosition(ax, counterAx, side) {
	        var lwHalf = ax._lw / 2;
	
	        if(ax._id.charAt(0) === 'x') {
	            if(!counterAx) return gs.t + gs.h * (1 - (ax.position || 0)) + (lwHalf % 1);
	            else if(side === 'top') return counterAx._offset - pad - lwHalf;
	            return counterAx._offset + counterAx._length + pad + lwHalf;
	        }
	
	        if(!counterAx) return gs.l + gs.w * (ax.position || 0) + (lwHalf % 1);
	        else if(side === 'right') return counterAx._offset + counterAx._length + pad + lwHalf;
	        return counterAx._offset - pad - lwHalf;
	    }
	
	    // some preparation of axis position info
	    for(i = 0; i < axList.length; i++) {
	        ax = axList[i];
	
	        var counterAx = ax._anchorAxis;
	
	        // clear axis line positions, to be set in the subplot loop below
	        ax._linepositions = {};
	
	        // stash crispRounded linewidth so we don't need to pass gd all over the place
	        ax._lw = Drawing.crispRound(gd, ax.linewidth, 1);
	
	        // figure out the main axis line and main mirror line position.
	        // it's easier to follow the logic if we handle these separately from
	        // ax._linepositions, which are only used by mirror=allticks
	        // for non-main-subplot ticks, and mirror=all(ticks)? for zero line
	        // hiding logic
	        ax._mainLinePosition = getLinePosition(ax, counterAx, ax.side);
	        ax._mainMirrorPosition = (ax.mirror && counterAx) ?
	            getLinePosition(ax, counterAx,
	                alignmentConstants.OPPOSITE_SIDE[ax.side]) : null;
	    }
	
	    // figure out which backgrounds we need to draw,
	    // and in which layers to put them
	    var lowerBackgroundIDs = [];
	    var backgroundIds = [];
	    var lowerDomains = [];
	    // no need to draw background when paper and plot color are the same color,
	    // activate mode just for large splom (which benefit the most from this
	    // optimization), but this could apply to all cartesian subplots.
	    var noNeedForBg = (
	        Color.opacity(fullLayout.paper_bgcolor) === 1 &&
	        Color.opacity(fullLayout.plot_bgcolor) === 1 &&
	        fullLayout.paper_bgcolor === fullLayout.plot_bgcolor
	    );
	
	    for(subplot in fullLayout._plots) {
	        plotinfo = fullLayout._plots[subplot];
	
	        if(plotinfo.mainplot) {
	            // mainplot is a reference to the main plot this one is overlaid on
	            // so if it exists, this is an overlaid plot and we don't need to
	            // give it its own background
	            if(plotinfo.bg) {
	                plotinfo.bg.remove();
	            }
	            plotinfo.bg = undefined;
	        } else {
	            var xDomain = plotinfo.xaxis.domain;
	            var yDomain = plotinfo.yaxis.domain;
	            var plotgroup = plotinfo.plotgroup;
	
	            if(overlappingDomain(xDomain, yDomain, lowerDomains)) {
	                var pgNode = plotgroup.node();
	                var plotgroupBg = plotinfo.bg = Lib.ensureSingle(plotgroup, 'rect', 'bg');
	                pgNode.insertBefore(plotgroupBg.node(), pgNode.childNodes[0]);
	                backgroundIds.push(subplot);
	            } else {
	                plotgroup.select('rect.bg').remove();
	                lowerDomains.push([xDomain, yDomain]);
	                if(!noNeedForBg) {
	                    lowerBackgroundIDs.push(subplot);
	                    backgroundIds.push(subplot);
	                }
	            }
	        }
	    }
	
	    // now create all the lower-layer backgrounds at once now that
	    // we have the list of subplots that need them
	    var lowerBackgrounds = fullLayout._bgLayer.selectAll('.bg')
	        .data(lowerBackgroundIDs);
	
	    lowerBackgrounds.enter().append('rect')
	        .classed('bg', true);
	
	    lowerBackgrounds.exit().remove();
	
	    lowerBackgrounds.each(function(subplot) {
	        fullLayout._plots[subplot].bg = d3.select(this);
	    });
	
	    // style all backgrounds
	    for(i = 0; i < backgroundIds.length; i++) {
	        plotinfo = fullLayout._plots[backgroundIds[i]];
	        xa = plotinfo.xaxis;
	        ya = plotinfo.yaxis;
	
	        if(plotinfo.bg) {
	            plotinfo.bg
	                .call(Drawing.setRect,
	                    xa._offset - pad, ya._offset - pad,
	                    xa._length + 2 * pad, ya._length + 2 * pad)
	                .call(Color.fill, fullLayout.plot_bgcolor)
	                .style('stroke-width', 0);
	        }
	    }
	
	    if(!fullLayout._hasOnlyLargeSploms) {
	        for(subplot in fullLayout._plots) {
	            plotinfo = fullLayout._plots[subplot];
	            xa = plotinfo.xaxis;
	            ya = plotinfo.yaxis;
	
	            // Clip so that data only shows up on the plot area.
	            var clipId = plotinfo.clipId = 'clip' + fullLayout._uid + subplot + 'plot';
	
	            var plotClip = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function(s) {
	                s.classed('plotclip', true)
	                    .append('rect');
	            });
	
	            plotinfo.clipRect = plotClip.select('rect').attr({
	                width: xa._length,
	                height: ya._length
	            });
	
	            Drawing.setTranslate(plotinfo.plot, xa._offset, ya._offset);
	
	            var plotClipId;
	            var layerClipId;
	
	            if(plotinfo._hasClipOnAxisFalse) {
	                plotClipId = null;
	                layerClipId = clipId;
	            } else {
	                plotClipId = clipId;
	                layerClipId = null;
	            }
	
	            Drawing.setClipUrl(plotinfo.plot, plotClipId, gd);
	
	            // stash layer clipId value (null or same as clipId)
	            // to DRY up Drawing.setClipUrl calls on trace-module and trace layers
	            // downstream
	            plotinfo.layerClipId = layerClipId;
	        }
	    }
	
	    var xLinesXLeft, xLinesXRight, xLinesYBottom, xLinesYTop,
	        leftYLineWidth, rightYLineWidth;
	    var yLinesYBottom, yLinesYTop, yLinesXLeft, yLinesXRight,
	        connectYBottom, connectYTop;
	    var extraSubplot;
	
	    function xLinePath(y) {
	        return 'M' + xLinesXLeft + ',' + y + 'H' + xLinesXRight;
	    }
	
	    function xLinePathFree(y) {
	        return 'M' + xa._offset + ',' + y + 'h' + xa._length;
	    }
	
	    function yLinePath(x) {
	        return 'M' + x + ',' + yLinesYTop + 'V' + yLinesYBottom;
	    }
	
	    function yLinePathFree(x) {
	        return 'M' + x + ',' + ya._offset + 'v' + ya._length;
	    }
	
	    function mainPath(ax, pathFn, pathFnFree) {
	        if(!ax.showline || subplot !== ax._mainSubplot) return '';
	        if(!ax._anchorAxis) return pathFnFree(ax._mainLinePosition);
	        var out = pathFn(ax._mainLinePosition);
	        if(ax.mirror) out += pathFn(ax._mainMirrorPosition);
	        return out;
	    }
	
	    for(subplot in fullLayout._plots) {
	        plotinfo = fullLayout._plots[subplot];
	        xa = plotinfo.xaxis;
	        ya = plotinfo.yaxis;
	
	        /*
	         * x lines get longer where they meet y lines, to make a crisp corner.
	         * The x lines get the padding (margin.pad) plus the y line width to
	         * fill up the corner nicely. Free x lines are excluded - they always
	         * span exactly the data area of the plot
	         *
	         *  | XXXXX
	         *  | XXXXX
	         *  |
	         *  +------
	         *     x1
	         *    -----
	         *     x2
	         */
	        var xPath = 'M0,0';
	        if(shouldShowLinesOrTicks(xa, subplot)) {
	            leftYLineWidth = findCounterAxisLineWidth(xa, 'left', ya, axList);
	            xLinesXLeft = xa._offset - (leftYLineWidth ? (pad + leftYLineWidth) : 0);
	            rightYLineWidth = findCounterAxisLineWidth(xa, 'right', ya, axList);
	            xLinesXRight = xa._offset + xa._length + (rightYLineWidth ? (pad + rightYLineWidth) : 0);
	            xLinesYBottom = getLinePosition(xa, ya, 'bottom');
	            xLinesYTop = getLinePosition(xa, ya, 'top');
	
	            // save axis line positions for extra ticks to reference
	            // each subplot that gets ticks from "allticks" gets an entry:
	            //    [left or bottom, right or top]
	            extraSubplot = (!xa._anchorAxis || subplot !== xa._mainSubplot);
	            if(extraSubplot && (xa.mirror === 'allticks' || xa.mirror === 'all')) {
	                xa._linepositions[subplot] = [xLinesYBottom, xLinesYTop];
	            }
	
	            xPath = mainPath(xa, xLinePath, xLinePathFree);
	            if(extraSubplot && xa.showline && (xa.mirror === 'all' || xa.mirror === 'allticks')) {
	                xPath += xLinePath(xLinesYBottom) + xLinePath(xLinesYTop);
	            }
	
	            plotinfo.xlines
	                .style('stroke-width', xa._lw + 'px')
	                .call(Color.stroke, xa.showline ?
	                    xa.linecolor : 'rgba(0,0,0,0)');
	        }
	        plotinfo.xlines.attr('d', xPath);
	
	        /*
	         * y lines that meet x axes get longer only by margin.pad, because
	         * the x axes fill in the corner space. Free y axes, like free x axes,
	         * always span exactly the data area of the plot
	         *
	         *   |   | XXXX
	         * y2| y1| XXXX
	         *   |   | XXXX
	         *       |
	         *       +-----
	         */
	        var yPath = 'M0,0';
	        if(shouldShowLinesOrTicks(ya, subplot)) {
	            connectYBottom = findCounterAxisLineWidth(ya, 'bottom', xa, axList);
	            yLinesYBottom = ya._offset + ya._length + (connectYBottom ? pad : 0);
	            connectYTop = findCounterAxisLineWidth(ya, 'top', xa, axList);
	            yLinesYTop = ya._offset - (connectYTop ? pad : 0);
	            yLinesXLeft = getLinePosition(ya, xa, 'left');
	            yLinesXRight = getLinePosition(ya, xa, 'right');
	
	            extraSubplot = (!ya._anchorAxis || subplot !== ya._mainSubplot);
	            if(extraSubplot && (ya.mirror === 'allticks' || ya.mirror === 'all')) {
	                ya._linepositions[subplot] = [yLinesXLeft, yLinesXRight];
	            }
	
	            yPath = mainPath(ya, yLinePath, yLinePathFree);
	            if(extraSubplot && ya.showline && (ya.mirror === 'all' || ya.mirror === 'allticks')) {
	                yPath += yLinePath(yLinesXLeft) + yLinePath(yLinesXRight);
	            }
	
	            plotinfo.ylines
	                .style('stroke-width', ya._lw + 'px')
	                .call(Color.stroke, ya.showline ?
	                    ya.linecolor : 'rgba(0,0,0,0)');
	        }
	        plotinfo.ylines.attr('d', yPath);
	    }
	
	    Axes.makeClipPaths(gd);
	
	    return Plots.previousPromises(gd);
	}
	
	function shouldShowLinesOrTicks(ax, subplot) {
	    return (ax.ticks || ax.showline) &&
	        (subplot === ax._mainSubplot || ax.mirror === 'all' || ax.mirror === 'allticks');
	}
	
	/*
	 * should we draw a line on counterAx at this side of ax?
	 * It's assumed that counterAx is known to overlay the subplot we're working on
	 * but it may not be its main axis.
	 */
	function shouldShowLineThisSide(ax, side, counterAx) {
	    // does counterAx get a line at all?
	    if(!counterAx.showline || !counterAx._lw) return false;
	
	    // are we drawing *all* lines for counterAx?
	    if(counterAx.mirror === 'all' || counterAx.mirror === 'allticks') return true;
	
	    var anchorAx = counterAx._anchorAxis;
	
	    // is this a free axis? free axes can only have a subplot side-line with all(ticks)? mirroring
	    if(!anchorAx) return false;
	
	    // in order to handle cases where the user forgot to anchor this axis correctly
	    // (because its default anchor has the same domain on the relevant end)
	    // check whether the relevant position is the same.
	    var sideIndex = alignmentConstants.FROM_BL[side];
	    if(counterAx.side === side) {
	        return anchorAx.domain[sideIndex] === ax.domain[sideIndex];
	    }
	    return counterAx.mirror && anchorAx.domain[1 - sideIndex] === ax.domain[1 - sideIndex];
	}
	
	/*
	 * Is there another axis intersecting `side` end of `ax`?
	 * First look at `counterAx` (the axis for this subplot),
	 * then at all other potential counteraxes on or overlaying this subplot.
	 * Take the line width from the first one that has a line.
	 */
	function findCounterAxisLineWidth(ax, side, counterAx, axList) {
	    if(shouldShowLineThisSide(ax, side, counterAx)) {
	        return counterAx._lw;
	    }
	    for(var i = 0; i < axList.length; i++) {
	        var axi = axList[i];
	        if(axi._mainAxis === counterAx._mainAxis && shouldShowLineThisSide(ax, side, axi)) {
	            return axi._lw;
	        }
	    }
	    return 0;
	}
	
	exports.drawMainTitle = function(gd) {
	    var fullLayout = gd._fullLayout;
	
	    var textAnchor = getMainTitleTextAnchor(fullLayout);
	    var dy = getMainTitleDy(fullLayout);
	
	    Titles.draw(gd, 'gtitle', {
	        propContainer: fullLayout,
	        propName: 'title.text',
	        placeholder: fullLayout._dfltTitle.plot,
	        attributes: {
	            x: getMainTitleX(fullLayout, textAnchor),
	            y: getMainTitleY(fullLayout, dy),
	            'text-anchor': textAnchor,
	            dy: dy
	        }
	    });
	};
	
	function getMainTitleX(fullLayout, textAnchor) {
	    var title = fullLayout.title;
	    var gs = fullLayout._size;
	    var hPadShift = 0;
	
	    if(textAnchor === SVG_TEXT_ANCHOR_START) {
	        hPadShift = title.pad.l;
	    } else if(textAnchor === SVG_TEXT_ANCHOR_END) {
	        hPadShift = -title.pad.r;
	    }
	
	    switch(title.xref) {
	        case 'paper':
	            return gs.l + gs.w * title.x + hPadShift;
	        case 'container':
	        default:
	            return fullLayout.width * title.x + hPadShift;
	    }
	}
	
	function getMainTitleY(fullLayout, dy) {
	    var title = fullLayout.title;
	    var gs = fullLayout._size;
	    var vPadShift = 0;
	
	    if(dy === '0em' || !dy) {
	        vPadShift = -title.pad.b;
	    } else if(dy === alignmentConstants.CAP_SHIFT + 'em') {
	        vPadShift = title.pad.t;
	    }
	
	    if(title.y === 'auto') {
	        return gs.t / 2;
	    } else {
	        switch(title.yref) {
	            case 'paper':
	                return gs.t + gs.h - gs.h * title.y + vPadShift;
	            case 'container':
	            default:
	                return fullLayout.height - fullLayout.height * title.y + vPadShift;
	        }
	    }
	}
	
	function getMainTitleTextAnchor(fullLayout) {
	    var title = fullLayout.title;
	
	    var textAnchor = SVG_TEXT_ANCHOR_MIDDLE;
	    if(Lib.isRightAnchor(title)) {
	        textAnchor = SVG_TEXT_ANCHOR_END;
	    } else if(Lib.isLeftAnchor(title)) {
	        textAnchor = SVG_TEXT_ANCHOR_START;
	    }
	
	    return textAnchor;
	}
	
	function getMainTitleDy(fullLayout) {
	    var title = fullLayout.title;
	
	    var dy = '0em';
	    if(Lib.isTopAnchor(title)) {
	        dy = alignmentConstants.CAP_SHIFT + 'em';
	    } else if(Lib.isMiddleAnchor(title)) {
	        dy = alignmentConstants.MID_SHIFT + 'em';
	    }
	
	    return dy;
	}
	
	exports.doTraceStyle = function(gd) {
	    var calcdata = gd.calcdata;
	    var editStyleCalls = [];
	    var i;
	
	    for(i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var cd0 = cd[0] || {};
	        var trace = cd0.trace || {};
	        var _module = trace._module || {};
	
	        // See if we need to do arraysToCalcdata
	        // call it regardless of what change we made, in case
	        // supplyDefaults brought in an array that was already
	        // in gd.data but not in gd._fullData previously
	        var arraysToCalcdata = _module.arraysToCalcdata;
	        if(arraysToCalcdata) arraysToCalcdata(cd, trace);
	
	        var editStyle = _module.editStyle;
	        if(editStyle) editStyleCalls.push({fn: editStyle, cd0: cd0});
	    }
	
	    if(editStyleCalls.length) {
	        for(i = 0; i < editStyleCalls.length; i++) {
	            var edit = editStyleCalls[i];
	            edit.fn(gd, edit.cd0);
	        }
	        clearGlCanvases(gd);
	        exports.redrawReglTraces(gd);
	    }
	
	    Plots.style(gd);
	    Registry.getComponentMethod('legend', 'draw')(gd);
	
	    return Plots.previousPromises(gd);
	};
	
	exports.doColorBars = function(gd) {
	    Registry.getComponentMethod('colorbar', 'draw')(gd);
	    return Plots.previousPromises(gd);
	};
	
	// force plot() to redo the layout and replot with the modified layout
	exports.layoutReplot = function(gd) {
	    var layout = gd.layout;
	    gd.layout = undefined;
	    return Registry.call('plot', gd, '', layout);
	};
	
	exports.doLegend = function(gd) {
	    Registry.getComponentMethod('legend', 'draw')(gd);
	    return Plots.previousPromises(gd);
	};
	
	exports.doTicksRelayout = function(gd) {
	    Axes.draw(gd, 'redraw');
	
	    if(gd._fullLayout._hasOnlyLargeSploms) {
	        Registry.subplotsRegistry.splom.updateGrid(gd);
	        clearGlCanvases(gd);
	        exports.redrawReglTraces(gd);
	    }
	
	    exports.drawMainTitle(gd);
	    return Plots.previousPromises(gd);
	};
	
	exports.doModeBar = function(gd) {
	    var fullLayout = gd._fullLayout;
	
	    ModeBar.manage(gd);
	
	    for(var i = 0; i < fullLayout._basePlotModules.length; i++) {
	        var updateFx = fullLayout._basePlotModules[i].updateFx;
	        if(updateFx) updateFx(gd);
	    }
	
	    return Plots.previousPromises(gd);
	};
	
	exports.doCamera = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var sceneIds = fullLayout._subplots.gl3d;
	
	    for(var i = 0; i < sceneIds.length; i++) {
	        var sceneLayout = fullLayout[sceneIds[i]];
	        var scene = sceneLayout._scene;
	
	        scene.setViewport(sceneLayout);
	    }
	};
	
	exports.drawData = function(gd) {
	    var fullLayout = gd._fullLayout;
	
	    clearGlCanvases(gd);
	
	    // loop over the base plot modules present on graph
	    var basePlotModules = fullLayout._basePlotModules;
	    for(var i = 0; i < basePlotModules.length; i++) {
	        basePlotModules[i].plot(gd);
	    }
	
	    exports.redrawReglTraces(gd);
	
	    // styling separate from drawing
	    Plots.style(gd);
	
	    // draw components that can be drawn on axes,
	    // and that do not push the margins
	    Registry.getComponentMethod('shapes', 'draw')(gd);
	    Registry.getComponentMethod('annotations', 'draw')(gd);
	    Registry.getComponentMethod('images', 'draw')(gd);
	
	    // Mark the first render as complete
	    fullLayout._replotting = false;
	
	    return Plots.previousPromises(gd);
	};
	
	// Draw (or redraw) all regl-based traces in one go,
	// useful during drag and selection where buffers of targeted traces are updated,
	// but all traces need to be redrawn following clearGlCanvases.
	//
	// Note that _module.plot for regl trace does NOT draw things
	// on the canvas, they only update the buffers.
	// Drawing is perform here.
	//
	// TODO try adding per-subplot option using gl.SCISSOR_TEST for
	// non-overlaying, disjoint subplots.
	//
	// TODO try to include parcoords in here.
	// https://github.com/plotly/plotly.js/issues/3069
	exports.redrawReglTraces = function(gd) {
	    var fullLayout = gd._fullLayout;
	
	    if(fullLayout._has('regl')) {
	        var fullData = gd._fullData;
	        var cartesianIds = [];
	        var polarIds = [];
	        var i, sp;
	
	        if(fullLayout._hasOnlyLargeSploms) {
	            fullLayout._splomGrid.draw();
	        }
	
	        // N.B.
	        // - Loop over fullData (not _splomScenes) to preserve splom trace-to-trace ordering
	        // - Fill list if subplot ids (instead of fullLayout._subplots) to handle cases where all traces
	        //   of a given module are `visible !== true`
	        for(i = 0; i < fullData.length; i++) {
	            var trace = fullData[i];
	
	            if(trace.visible === true && trace._length !== 0) {
	                if(trace.type === 'splom') {
	                    fullLayout._splomScenes[trace.uid].draw();
	                } else if(trace.type === 'scattergl') {
	                    Lib.pushUnique(cartesianIds, trace.xaxis + trace.yaxis);
	                } else if(trace.type === 'scatterpolargl') {
	                    Lib.pushUnique(polarIds, trace.subplot);
	                }
	            }
	        }
	
	        for(i = 0; i < cartesianIds.length; i++) {
	            sp = fullLayout._plots[cartesianIds[i]];
	            if(sp._scene) sp._scene.draw();
	        }
	
	        for(i = 0; i < polarIds.length; i++) {
	            sp = fullLayout[polarIds[i]]._subplot;
	            if(sp._scene) sp._scene.draw();
	        }
	    }
	};
	
	exports.doAutoRangeAndConstraints = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var axList = Axes.list(gd, '', true);
	    var matchGroups = fullLayout._axisMatchGroups || [];
	    var ax;
	    var axRng;
	
	    for(var i = 0; i < axList.length; i++) {
	        ax = axList[i];
	        cleanAxisConstraints(gd, ax);
	        doAutoRange(gd, ax);
	    }
	
	    enforceAxisConstraints(gd);
	
	    groupLoop:
	    for(var j = 0; j < matchGroups.length; j++) {
	        var group = matchGroups[j];
	        var rng = null;
	        var id;
	
	        for(id in group) {
	            ax = Axes.getFromId(gd, id);
	            if(ax.autorange === false) continue groupLoop;
	
	            axRng = Lib.simpleMap(ax.range, ax.r2l);
	            if(rng) {
	                if(rng[0] < rng[1]) {
	                    rng[0] = Math.min(rng[0], axRng[0]);
	                    rng[1] = Math.max(rng[1], axRng[1]);
	                } else {
	                    rng[0] = Math.max(rng[0], axRng[0]);
	                    rng[1] = Math.min(rng[1], axRng[1]);
	                }
	            } else {
	                rng = axRng;
	            }
	        }
	
	        for(id in group) {
	            ax = Axes.getFromId(gd, id);
	            ax.range = Lib.simpleMap(rng, ax.l2r);
	            ax._input.range = ax.range.slice();
	            ax.setScale();
	        }
	    }
	};
	
	// An initial paint must be completed before these components can be
	// correctly sized and the whole plot re-margined. fullLayout._replotting must
	// be set to false before these will work properly.
	exports.finalDraw = function(gd) {
	    // TODO: rangesliders really belong in marginPushers but they need to be
	    // drawn after data - can we at least get the margin pushing part separated
	    // out and done earlier?
	    Registry.getComponentMethod('rangeslider', 'draw')(gd);
	    // TODO: rangeselector only needs to be here (in addition to drawMarginPushers)
	    // because the margins need to be fully determined before we can call
	    // autorange and update axis ranges (which rangeselector needs to know which
	    // button is active). Can we break out its automargin step from its draw step?
	    Registry.getComponentMethod('rangeselector', 'draw')(gd);
	};
	
	exports.drawMarginPushers = function(gd) {
	    Registry.getComponentMethod('legend', 'draw')(gd);
	    Registry.getComponentMethod('rangeselector', 'draw')(gd);
	    Registry.getComponentMethod('sliders', 'draw')(gd);
	    Registry.getComponentMethod('updatemenus', 'draw')(gd);
	    Registry.getComponentMethod('colorbar', 'draw')(gd);
	};
	
	},{"../components/color":591,"../components/drawing":612,"../components/modebar":649,"../components/titles":678,"../constants/alignment":685,"../lib":716,"../lib/clear_gl_canvases":701,"../plots/cartesian/autorange":763,"../plots/cartesian/axes":764,"../plots/cartesian/constraints":771,"../plots/plots":825,"../registry":845,"d3":164}],756:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var isPlainObject = Lib.isPlainObject;
	var PlotSchema = _dereq_('./plot_schema');
	var Plots = _dereq_('../plots/plots');
	var plotAttributes = _dereq_('../plots/attributes');
	var Template = _dereq_('./plot_template');
	var dfltConfig = _dereq_('./plot_config').dfltConfig;
	
	/**
	 * Plotly.makeTemplate: create a template off an existing figure to reuse
	 * style attributes on other figures.
	 *
	 * Note: separated from the rest of templates because otherwise we get circular
	 * references due to PlotSchema.
	 *
	 * @param {object|DOM element|string} figure: The figure to base the template on
	 *     should contain a trace array `figure.data`
	 *     and a layout object `figure.layout`
	 * @returns {object} template: the extracted template - can then be used as
	 *     `layout.template` in another figure.
	 */
	exports.makeTemplate = function(figure) {
	    figure = Lib.isPlainObject(figure) ? figure : Lib.getGraphDiv(figure);
	    figure = Lib.extendDeep({_context: dfltConfig}, {data: figure.data, layout: figure.layout});
	    Plots.supplyDefaults(figure);
	    var data = figure.data || [];
	    var layout = figure.layout || {};
	    // copy over a few items to help follow the schema
	    layout._basePlotModules = figure._fullLayout._basePlotModules;
	    layout._modules = figure._fullLayout._modules;
	
	    var template = {
	        data: {},
	        layout: {}
	    };
	
	    /*
	     * Note: we do NOT validate template values, we just take what's in the
	     * user inputs data and layout, not the validated values in fullData and
	     * fullLayout. Even if we were to validate here, there's no guarantee that
	     * these values would still be valid when applied to a new figure, which
	     * may contain different trace modes, different axes, etc. So it's
	     * important that when applying a template we still validate the template
	     * values, rather than just using them as defaults.
	     */
	
	    data.forEach(function(trace) {
	        // TODO: What if no style info is extracted for this trace. We may
	        // not want an empty object as the null value.
	        // TODO: allow transforms to contribute to templates?
	        // as it stands they are ignored, which may be for the best...
	
	        var traceTemplate = {};
	        walkStyleKeys(trace, traceTemplate, getTraceInfo.bind(null, trace));
	
	        var traceType = Lib.coerce(trace, {}, plotAttributes, 'type');
	        var typeTemplates = template.data[traceType];
	        if(!typeTemplates) typeTemplates = template.data[traceType] = [];
	        typeTemplates.push(traceTemplate);
	    });
	
	    walkStyleKeys(layout, template.layout, getLayoutInfo.bind(null, layout));
	
	    /*
	     * Compose the new template with an existing one to the same effect
	     *
	     * NOTE: there's a possibility of slightly different behavior: if the plot
	     * has an invalid value and the old template has a valid value for the same
	     * attribute, the plot will use the old template value but this routine
	     * will pull the invalid value (resulting in the original default).
	     * In the general case it's not possible to solve this with a single value,
	     * since valid options can be context-dependent. It could be solved with
	     * a *list* of values, but that would be huge complexity for little gain.
	     */
	    delete template.layout.template;
	    var oldTemplate = layout.template;
	    if(isPlainObject(oldTemplate)) {
	        var oldLayoutTemplate = oldTemplate.layout;
	
	        var i, traceType, oldTypeTemplates, oldTypeLen, typeTemplates, typeLen;
	
	        if(isPlainObject(oldLayoutTemplate)) {
	            mergeTemplates(oldLayoutTemplate, template.layout);
	        }
	        var oldDataTemplate = oldTemplate.data;
	        if(isPlainObject(oldDataTemplate)) {
	            for(traceType in template.data) {
	                oldTypeTemplates = oldDataTemplate[traceType];
	                if(Array.isArray(oldTypeTemplates)) {
	                    typeTemplates = template.data[traceType];
	                    typeLen = typeTemplates.length;
	                    oldTypeLen = oldTypeTemplates.length;
	                    for(i = 0; i < typeLen; i++) {
	                        mergeTemplates(oldTypeTemplates[i % oldTypeLen], typeTemplates[i]);
	                    }
	                    for(i = typeLen; i < oldTypeLen; i++) {
	                        typeTemplates.push(Lib.extendDeep({}, oldTypeTemplates[i]));
	                    }
	                }
	            }
	            for(traceType in oldDataTemplate) {
	                if(!(traceType in template.data)) {
	                    template.data[traceType] = Lib.extendDeep([], oldDataTemplate[traceType]);
	                }
	            }
	        }
	    }
	
	    return template;
	};
	
	function mergeTemplates(oldTemplate, newTemplate) {
	    // we don't care about speed here, just make sure we have a totally
	    // distinct object from the previous template
	    oldTemplate = Lib.extendDeep({}, oldTemplate);
	
	    // sort keys so we always get annotationdefaults before annotations etc
	    // so arrayTemplater will work right
	    var oldKeys = Object.keys(oldTemplate).sort();
	    var i, j;
	
	    function mergeOne(oldVal, newVal, key) {
	        if(isPlainObject(newVal) && isPlainObject(oldVal)) {
	            mergeTemplates(oldVal, newVal);
	        } else if(Array.isArray(newVal) && Array.isArray(oldVal)) {
	            // Note: omitted `inclusionAttr` from arrayTemplater here,
	            // it's irrelevant as we only want the resulting `_template`.
	            var templater = Template.arrayTemplater({_template: oldTemplate}, key);
	            for(j = 0; j < newVal.length; j++) {
	                var item = newVal[j];
	                var oldItem = templater.newItem(item)._template;
	                if(oldItem) mergeTemplates(oldItem, item);
	            }
	            var defaultItems = templater.defaultItems();
	            for(j = 0; j < defaultItems.length; j++) newVal.push(defaultItems[j]._template);
	
	            // templateitemname only applies to receiving plots
	            for(j = 0; j < newVal.length; j++) delete newVal[j].templateitemname;
	        }
	    }
	
	    for(i = 0; i < oldKeys.length; i++) {
	        var key = oldKeys[i];
	        var oldVal = oldTemplate[key];
	        if(key in newTemplate) {
	            mergeOne(oldVal, newTemplate[key], key);
	        } else newTemplate[key] = oldVal;
	
	        // if this is a base key from the old template (eg xaxis), look for
	        // extended keys (eg xaxis2) in the new template to merge into
	        if(getBaseKey(key) === key) {
	            for(var key2 in newTemplate) {
	                var baseKey2 = getBaseKey(key2);
	                if(key2 !== baseKey2 && baseKey2 === key && !(key2 in oldTemplate)) {
	                    mergeOne(oldVal, newTemplate[key2], key);
	                }
	            }
	        }
	    }
	}
	
	function getBaseKey(key) {
	    return key.replace(/[0-9]+$/, '');
	}
	
	function walkStyleKeys(parent, templateOut, getAttributeInfo, path, basePath) {
	    var pathAttr = basePath && getAttributeInfo(basePath);
	    for(var key in parent) {
	        var child = parent[key];
	        var nextPath = getNextPath(parent, key, path);
	        var nextBasePath = getNextPath(parent, key, basePath);
	        var attr = getAttributeInfo(nextBasePath);
	        if(!attr) {
	            var baseKey = getBaseKey(key);
	            if(baseKey !== key) {
	                nextBasePath = getNextPath(parent, baseKey, basePath);
	                attr = getAttributeInfo(nextBasePath);
	            }
	        }
	
	        // we'll get an attr if path starts with a valid part, then has an
	        // invalid ending. Make sure we got all the way to the end.
	        if(pathAttr && (pathAttr === attr)) continue;
	
	        if(!attr || attr._noTemplating ||
	            attr.valType === 'data_array' ||
	            (attr.arrayOk && Array.isArray(child))
	        ) {
	            continue;
	        }
	
	        if(!attr.valType && isPlainObject(child)) {
	            walkStyleKeys(child, templateOut, getAttributeInfo, nextPath, nextBasePath);
	        } else if(attr._isLinkedToArray && Array.isArray(child)) {
	            var dfltDone = false;
	            var namedIndex = 0;
	            var usedNames = {};
	            for(var i = 0; i < child.length; i++) {
	                var item = child[i];
	                if(isPlainObject(item)) {
	                    var name = item.name;
	                    if(name) {
	                        if(!usedNames[name]) {
	                            // named array items: allow all attributes except data arrays
	                            walkStyleKeys(item, templateOut, getAttributeInfo,
	                                getNextPath(child, namedIndex, nextPath),
	                                getNextPath(child, namedIndex, nextBasePath));
	                            namedIndex++;
	                            usedNames[name] = 1;
	                        }
	                    } else if(!dfltDone) {
	                        var dfltKey = Template.arrayDefaultKey(key);
	                        var dfltPath = getNextPath(parent, dfltKey, path);
	
	                        // getAttributeInfo will fail if we try to use dfltKey directly.
	                        // Instead put this item into the next array element, then
	                        // pull it out and move it to dfltKey.
	                        var pathInArray = getNextPath(child, namedIndex, nextPath);
	                        walkStyleKeys(item, templateOut, getAttributeInfo, pathInArray,
	                            getNextPath(child, namedIndex, nextBasePath));
	                        var itemPropInArray = Lib.nestedProperty(templateOut, pathInArray);
	                        var dfltProp = Lib.nestedProperty(templateOut, dfltPath);
	                        dfltProp.set(itemPropInArray.get());
	                        itemPropInArray.set(null);
	
	                        dfltDone = true;
	                    }
	                }
	            }
	        } else {
	            var templateProp = Lib.nestedProperty(templateOut, nextPath);
	            templateProp.set(child);
	        }
	    }
	}
	
	function getLayoutInfo(layout, path) {
	    return PlotSchema.getLayoutValObject(
	        layout, Lib.nestedProperty({}, path).parts
	    );
	}
	
	function getTraceInfo(trace, path) {
	    return PlotSchema.getTraceValObject(
	        trace, Lib.nestedProperty({}, path).parts
	    );
	}
	
	function getNextPath(parent, key, path) {
	    var nextPath;
	    if(!path) nextPath = key;
	    else if(Array.isArray(parent)) nextPath = path + '[' + key + ']';
	    else nextPath = path + '.' + key;
	
	    return nextPath;
	}
	
	/**
	 * validateTemplate: Test for consistency between the given figure and
	 * a template, either already included in the figure or given separately.
	 * Note that not every issue we identify here is necessarily a problem,
	 * it depends on what you're using the template for.
	 *
	 * @param {object|DOM element} figure: the plot, with {data, layout} members,
	 *     to test the template against
	 * @param {Optional(object)} template: the template, with its own {data, layout},
	 *     to test. If omitted, we will look for a template already attached as the
	 *     plot's `layout.template` attribute.
	 *
	 * @returns {array} array of error objects each containing:
	 *  - {string} code
	 *      error code ('missing', 'unused', 'reused', 'noLayout', 'noData')
	 *  - {string} msg
	 *      a full readable description of the issue.
	 */
	exports.validateTemplate = function(figureIn, template) {
	    var figure = Lib.extendDeep({}, {
	        _context: dfltConfig,
	        data: figureIn.data,
	        layout: figureIn.layout
	    });
	    var layout = figure.layout || {};
	    if(!isPlainObject(template)) template = layout.template || {};
	    var layoutTemplate = template.layout;
	    var dataTemplate = template.data;
	    var errorList = [];
	
	    figure.layout = layout;
	    figure.layout.template = template;
	    Plots.supplyDefaults(figure);
	
	    var fullLayout = figure._fullLayout;
	    var fullData = figure._fullData;
	
	    var layoutPaths = {};
	    function crawlLayoutForContainers(obj, paths) {
	        for(var key in obj) {
	            if(key.charAt(0) !== '_' && isPlainObject(obj[key])) {
	                var baseKey = getBaseKey(key);
	                var nextPaths = [];
	                var i;
	                for(i = 0; i < paths.length; i++) {
	                    nextPaths.push(getNextPath(obj, key, paths[i]));
	                    if(baseKey !== key) nextPaths.push(getNextPath(obj, baseKey, paths[i]));
	                }
	                for(i = 0; i < nextPaths.length; i++) {
	                    layoutPaths[nextPaths[i]] = 1;
	                }
	                crawlLayoutForContainers(obj[key], nextPaths);
	            }
	        }
	    }
	
	    function crawlLayoutTemplateForContainers(obj, path) {
	        for(var key in obj) {
	            if(key.indexOf('defaults') === -1 && isPlainObject(obj[key])) {
	                var nextPath = getNextPath(obj, key, path);
	                if(layoutPaths[nextPath]) {
	                    crawlLayoutTemplateForContainers(obj[key], nextPath);
	                } else {
	                    errorList.push({code: 'unused', path: nextPath});
	                }
	            }
	        }
	    }
	
	    if(!isPlainObject(layoutTemplate)) {
	        errorList.push({code: 'layout'});
	    } else {
	        crawlLayoutForContainers(fullLayout, ['layout']);
	        crawlLayoutTemplateForContainers(layoutTemplate, 'layout');
	    }
	
	    if(!isPlainObject(dataTemplate)) {
	        errorList.push({code: 'data'});
	    } else {
	        var typeCount = {};
	        var traceType;
	        for(var i = 0; i < fullData.length; i++) {
	            var fullTrace = fullData[i];
	            traceType = fullTrace.type;
	            typeCount[traceType] = (typeCount[traceType] || 0) + 1;
	            if(!fullTrace._fullInput._template) {
	                // this takes care of the case of traceType in the data but not
	                // the template
	                errorList.push({
	                    code: 'missing',
	                    index: fullTrace._fullInput.index,
	                    traceType: traceType
	                });
	            }
	        }
	        for(traceType in dataTemplate) {
	            var templateCount = dataTemplate[traceType].length;
	            var dataCount = typeCount[traceType] || 0;
	            if(templateCount > dataCount) {
	                errorList.push({
	                    code: 'unused',
	                    traceType: traceType,
	                    templateCount: templateCount,
	                    dataCount: dataCount
	                });
	            } else if(dataCount > templateCount) {
	                errorList.push({
	                    code: 'reused',
	                    traceType: traceType,
	                    templateCount: templateCount,
	                    dataCount: dataCount
	                });
	            }
	        }
	    }
	
	    // _template: false is when someone tried to modify an array item
	    // but there was no template with matching name
	    function crawlForMissingTemplates(obj, path) {
	        for(var key in obj) {
	            if(key.charAt(0) === '_') continue;
	            var val = obj[key];
	            var nextPath = getNextPath(obj, key, path);
	            if(isPlainObject(val)) {
	                if(Array.isArray(obj) && val._template === false && val.templateitemname) {
	                    errorList.push({
	                        code: 'missing',
	                        path: nextPath,
	                        templateitemname: val.templateitemname
	                    });
	                }
	                crawlForMissingTemplates(val, nextPath);
	            } else if(Array.isArray(val) && hasPlainObject(val)) {
	                crawlForMissingTemplates(val, nextPath);
	            }
	        }
	    }
	    crawlForMissingTemplates({data: fullData, layout: fullLayout}, '');
	
	    if(errorList.length) return errorList.map(format);
	};
	
	function hasPlainObject(arr) {
	    for(var i = 0; i < arr.length; i++) {
	        if(isPlainObject(arr[i])) return true;
	    }
	}
	
	function format(opts) {
	    var msg;
	    switch(opts.code) {
	        case 'data':
	            msg = 'The template has no key data.';
	            break;
	        case 'layout':
	            msg = 'The template has no key layout.';
	            break;
	        case 'missing':
	            if(opts.path) {
	                msg = 'There are no templates for item ' + opts.path +
	                    ' with name ' + opts.templateitemname;
	            } else {
	                msg = 'There are no templates for trace ' + opts.index +
	                    ', of type ' + opts.traceType + '.';
	            }
	            break;
	        case 'unused':
	            if(opts.path) {
	                msg = 'The template item at ' + opts.path +
	                    ' was not used in constructing the plot.';
	            } else if(opts.dataCount) {
	                msg = 'Some of the templates of type ' + opts.traceType +
	                    ' were not used. The template has ' + opts.templateCount +
	                    ' traces, the data only has ' + opts.dataCount +
	                    ' of this type.';
	            } else {
	                msg = 'The template has ' + opts.templateCount +
	                    ' traces of type ' + opts.traceType +
	                    ' but there are none in the data.';
	            }
	            break;
	        case 'reused':
	            msg = 'Some of the templates of type ' + opts.traceType +
	                ' were used more than once. The template has ' +
	                opts.templateCount + ' traces, the data has ' +
	                opts.dataCount + ' of this type.';
	            break;
	    }
	    opts.msg = msg;
	
	    return opts;
	}
	
	},{"../lib":716,"../plots/attributes":761,"../plots/plots":825,"./plot_config":752,"./plot_schema":753,"./plot_template":754}],757:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var plotApi = _dereq_('./plot_api');
	var Lib = _dereq_('../lib');
	
	var helpers = _dereq_('../snapshot/helpers');
	var toSVG = _dereq_('../snapshot/tosvg');
	var svgToImg = _dereq_('../snapshot/svgtoimg');
	
	var attrs = {
	    format: {
	        valType: 'enumerated',
	        values: ['png', 'jpeg', 'webp', 'svg'],
	        dflt: 'png',
	        
	    },
	    width: {
	        valType: 'number',
	        min: 1,
	        
	    },
	    height: {
	        valType: 'number',
	        min: 1,
	        
	    },
	    scale: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	    },
	    setBackground: {
	        valType: 'any',
	        dflt: false,
	        
	    },
	    imageDataOnly: {
	        valType: 'boolean',
	        dflt: false,
	        
	    }
	};
	
	/** Plotly.toImage
	 *
	 * @param {object | string | HTML div} gd
	 *   can either be a data/layout/config object
	 *   or an existing graph <div>
	 *   or an id to an existing graph <div>
	 * @param {object} opts (see above)
	 * @return {promise}
	 */
	function toImage(gd, opts) {
	    opts = opts || {};
	
	    var data;
	    var layout;
	    var config;
	    var fullLayout;
	
	    if(Lib.isPlainObject(gd)) {
	        data = gd.data || [];
	        layout = gd.layout || {};
	        config = gd.config || {};
	        fullLayout = {};
	    } else {
	        gd = Lib.getGraphDiv(gd);
	        data = Lib.extendDeep([], gd.data);
	        layout = Lib.extendDeep({}, gd.layout);
	        config = gd._context;
	        fullLayout = gd._fullLayout || {};
	    }
	
	    function isImpliedOrValid(attr) {
	        return !(attr in opts) || Lib.validate(opts[attr], attrs[attr]);
	    }
	
	    if((!isImpliedOrValid('width') && opts.width !== null) ||
	        (!isImpliedOrValid('height') && opts.height !== null)) {
	        throw new Error('Height and width should be pixel values.');
	    }
	
	    if(!isImpliedOrValid('format')) {
	        throw new Error('Image format is not jpeg, png, svg or webp.');
	    }
	
	    var fullOpts = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(opts, fullOpts, attrs, attr, dflt);
	    }
	
	    var format = coerce('format');
	    var width = coerce('width');
	    var height = coerce('height');
	    var scale = coerce('scale');
	    var setBackground = coerce('setBackground');
	    var imageDataOnly = coerce('imageDataOnly');
	
	    // put the cloned div somewhere off screen before attaching to DOM
	    var clonedGd = document.createElement('div');
	    clonedGd.style.position = 'absolute';
	    clonedGd.style.left = '-5000px';
	    document.body.appendChild(clonedGd);
	
	    // extend layout with image options
	    var layoutImage = Lib.extendFlat({}, layout);
	    if(width) {
	        layoutImage.width = width;
	    } else if(opts.width === null && isNumeric(fullLayout.width)) {
	        layoutImage.width = fullLayout.width;
	    }
	    if(height) {
	        layoutImage.height = height;
	    } else if(opts.height === null && isNumeric(fullLayout.height)) {
	        layoutImage.height = fullLayout.height;
	    }
	
	    // extend config for static plot
	    var configImage = Lib.extendFlat({}, config, {
	        _exportedPlot: true,
	        staticPlot: true,
	        setBackground: setBackground
	    });
	
	    var redrawFunc = helpers.getRedrawFunc(clonedGd);
	
	    function wait() {
	        return new Promise(function(resolve) {
	            setTimeout(resolve, helpers.getDelay(clonedGd._fullLayout));
	        });
	    }
	
	    function convert() {
	        return new Promise(function(resolve, reject) {
	            var svg = toSVG(clonedGd, format, scale);
	            var width = clonedGd._fullLayout.width;
	            var height = clonedGd._fullLayout.height;
	
	            plotApi.purge(clonedGd);
	            document.body.removeChild(clonedGd);
	
	            if(format === 'svg') {
	                if(imageDataOnly) {
	                    return resolve(svg);
	                } else {
	                    return resolve(helpers.encodeSVG(svg));
	                }
	            }
	
	            var canvas = document.createElement('canvas');
	            canvas.id = Lib.randstr();
	
	            svgToImg({
	                format: format,
	                width: width,
	                height: height,
	                scale: scale,
	                canvas: canvas,
	                svg: svg,
	                // ask svgToImg to return a Promise
	                //  rather than EventEmitter
	                //  leave EventEmitter for backward
	                //  compatibility
	                promise: true
	            })
	            .then(resolve)
	            .catch(reject);
	        });
	    }
	
	    function urlToImageData(url) {
	        if(imageDataOnly) {
	            return url.replace(helpers.IMAGE_URL_PREFIX, '');
	        } else {
	            return url;
	        }
	    }
	
	    return new Promise(function(resolve, reject) {
	        plotApi.plot(clonedGd, data, layoutImage, configImage)
	            .then(redrawFunc)
	            .then(wait)
	            .then(convert)
	            .then(function(url) { resolve(urlToImageData(url)); })
	            .catch(function(err) { reject(err); });
	    });
	}
	
	module.exports = toImage;
	
	},{"../lib":716,"../snapshot/helpers":849,"../snapshot/svgtoimg":851,"../snapshot/tosvg":853,"./plot_api":751,"fast-isnumeric":227}],758:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var Plots = _dereq_('../plots/plots');
	var PlotSchema = _dereq_('./plot_schema');
	var dfltConfig = _dereq_('./plot_config').dfltConfig;
	
	var isPlainObject = Lib.isPlainObject;
	var isArray = Array.isArray;
	var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	
	/**
	 * Validate a data array and layout object.
	 *
	 * @param {array} data
	 * @param {object} layout
	 *
	 * @return {array} array of error objects each containing:
	 *  - {string} code
	 *      error code ('object', 'array', 'schema', 'unused', 'invisible' or 'value')
	 *  - {string} container
	 *      container where the error occurs ('data' or 'layout')
	 *  - {number} trace
	 *      trace index of the 'data' container where the error occurs
	 *  - {array} path
	 *      nested path to the key that causes the error
	 *  - {string} astr
	 *      attribute string variant of 'path' compatible with Plotly.restyle and
	 *      Plotly.relayout.
	 *  - {string} msg
	 *      error message (shown in console in logger config argument is enable)
	 */
	module.exports = function validate(data, layout) {
	    var schema = PlotSchema.get();
	    var errorList = [];
	    var gd = {_context: Lib.extendFlat({}, dfltConfig)};
	
	    var dataIn, layoutIn;
	
	    if(isArray(data)) {
	        gd.data = Lib.extendDeep([], data);
	        dataIn = data;
	    } else {
	        gd.data = [];
	        dataIn = [];
	        errorList.push(format('array', 'data'));
	    }
	
	    if(isPlainObject(layout)) {
	        gd.layout = Lib.extendDeep({}, layout);
	        layoutIn = layout;
	    } else {
	        gd.layout = {};
	        layoutIn = {};
	        if(arguments.length > 1) {
	            errorList.push(format('object', 'layout'));
	        }
	    }
	
	    // N.B. dataIn and layoutIn are in general not the same as
	    // gd.data and gd.layout after supplyDefaults as some attributes
	    // in gd.data and gd.layout (still) get mutated during this step.
	
	    Plots.supplyDefaults(gd);
	
	    var dataOut = gd._fullData;
	    var len = dataIn.length;
	
	    for(var i = 0; i < len; i++) {
	        var traceIn = dataIn[i];
	        var base = ['data', i];
	
	        if(!isPlainObject(traceIn)) {
	            errorList.push(format('object', base));
	            continue;
	        }
	
	        var traceOut = dataOut[i];
	        var traceType = traceOut.type;
	        var traceSchema = schema.traces[traceType].attributes;
	
	        // PlotSchema does something fancy with trace 'type', reset it here
	        // to make the trace schema compatible with Lib.validate.
	        traceSchema.type = {
	            valType: 'enumerated',
	            values: [traceType]
	        };
	
	        if(traceOut.visible === false && traceIn.visible !== false) {
	            errorList.push(format('invisible', base));
	        }
	
	        crawl(traceIn, traceOut, traceSchema, errorList, base);
	
	        var transformsIn = traceIn.transforms;
	        var transformsOut = traceOut.transforms;
	
	        if(transformsIn) {
	            if(!isArray(transformsIn)) {
	                errorList.push(format('array', base, ['transforms']));
	            }
	
	            base.push('transforms');
	
	            for(var j = 0; j < transformsIn.length; j++) {
	                var path = ['transforms', j];
	                var transformType = transformsIn[j].type;
	
	                if(!isPlainObject(transformsIn[j])) {
	                    errorList.push(format('object', base, path));
	                    continue;
	                }
	
	                var transformSchema = schema.transforms[transformType] ?
	                    schema.transforms[transformType].attributes :
	                    {};
	
	                // add 'type' to transform schema to validate the transform type
	                transformSchema.type = {
	                    valType: 'enumerated',
	                    values: Object.keys(schema.transforms)
	                };
	
	                crawl(transformsIn[j], transformsOut[j], transformSchema, errorList, base, path);
	            }
	        }
	    }
	
	    var layoutOut = gd._fullLayout;
	    var layoutSchema = fillLayoutSchema(schema, dataOut);
	
	    crawl(layoutIn, layoutOut, layoutSchema, errorList, 'layout');
	
	    // return undefined if no validation errors were found
	    return (errorList.length === 0) ? void(0) : errorList;
	};
	
	function crawl(objIn, objOut, schema, list, base, path) {
	    path = path || [];
	
	    var keys = Object.keys(objIn);
	
	    for(var i = 0; i < keys.length; i++) {
	        var k = keys[i];
	
	        // transforms are handled separately
	        if(k === 'transforms') continue;
	
	        var p = path.slice();
	        p.push(k);
	
	        var valIn = objIn[k];
	        var valOut = objOut[k];
	
	        var nestedSchema = getNestedSchema(schema, k);
	        var isInfoArray = (nestedSchema || {}).valType === 'info_array';
	        var isColorscale = (nestedSchema || {}).valType === 'colorscale';
	        var items = (nestedSchema || {}).items;
	
	        if(!isInSchema(schema, k)) {
	            list.push(format('schema', base, p));
	        } else if(isPlainObject(valIn) && isPlainObject(valOut)) {
	            crawl(valIn, valOut, nestedSchema, list, base, p);
	        } else if(isInfoArray && isArray(valIn)) {
	            if(valIn.length > valOut.length) {
	                list.push(format('unused', base, p.concat(valOut.length)));
	            }
	            var len = valOut.length;
	            var arrayItems = Array.isArray(items);
	            if(arrayItems) len = Math.min(len, items.length);
	            var m, n, item, valInPart, valOutPart;
	            if(nestedSchema.dimensions === 2) {
	                for(n = 0; n < len; n++) {
	                    if(isArray(valIn[n])) {
	                        if(valIn[n].length > valOut[n].length) {
	                            list.push(format('unused', base, p.concat(n, valOut[n].length)));
	                        }
	                        var len2 = valOut[n].length;
	                        for(m = 0; m < (arrayItems ? Math.min(len2, items[n].length) : len2); m++) {
	                            item = arrayItems ? items[n][m] : items;
	                            valInPart = valIn[n][m];
	                            valOutPart = valOut[n][m];
	                            if(!Lib.validate(valInPart, item)) {
	                                list.push(format('value', base, p.concat(n, m), valInPart));
	                            } else if(valOutPart !== valInPart && valOutPart !== +valInPart) {
	                                list.push(format('dynamic', base, p.concat(n, m), valInPart, valOutPart));
	                            }
	                        }
	                    } else {
	                        list.push(format('array', base, p.concat(n), valIn[n]));
	                    }
	                }
	            } else {
	                for(n = 0; n < len; n++) {
	                    item = arrayItems ? items[n] : items;
	                    valInPart = valIn[n];
	                    valOutPart = valOut[n];
	                    if(!Lib.validate(valInPart, item)) {
	                        list.push(format('value', base, p.concat(n), valInPart));
	                    } else if(valOutPart !== valInPart && valOutPart !== +valInPart) {
	                        list.push(format('dynamic', base, p.concat(n), valInPart, valOutPart));
	                    }
	                }
	            }
	        } else if(nestedSchema.items && !isInfoArray && isArray(valIn)) {
	            var _nestedSchema = items[Object.keys(items)[0]];
	            var indexList = [];
	
	            var j, _p;
	
	            // loop over valOut items while keeping track of their
	            // corresponding input container index (given by _index)
	            for(j = 0; j < valOut.length; j++) {
	                var _index = valOut[j]._index || j;
	
	                _p = p.slice();
	                _p.push(_index);
	
	                if(isPlainObject(valIn[_index]) && isPlainObject(valOut[j])) {
	                    indexList.push(_index);
	                    var valInj = valIn[_index];
	                    var valOutj = valOut[j];
	                    if(isPlainObject(valInj) && valInj.visible !== false && valOutj.visible === false) {
	                        list.push(format('invisible', base, _p));
	                    } else crawl(valInj, valOutj, _nestedSchema, list, base, _p);
	                }
	            }
	
	            // loop over valIn to determine where it went wrong for some items
	            for(j = 0; j < valIn.length; j++) {
	                _p = p.slice();
	                _p.push(j);
	
	                if(!isPlainObject(valIn[j])) {
	                    list.push(format('object', base, _p, valIn[j]));
	                } else if(indexList.indexOf(j) === -1) {
	                    list.push(format('unused', base, _p));
	                }
	            }
	        } else if(!isPlainObject(valIn) && isPlainObject(valOut)) {
	            list.push(format('object', base, p, valIn));
	        } else if(!isArrayOrTypedArray(valIn) && isArrayOrTypedArray(valOut) && !isInfoArray && !isColorscale) {
	            list.push(format('array', base, p, valIn));
	        } else if(!(k in objOut)) {
	            list.push(format('unused', base, p, valIn));
	        } else if(!Lib.validate(valIn, nestedSchema)) {
	            list.push(format('value', base, p, valIn));
	        } else if(nestedSchema.valType === 'enumerated' &&
	            ((nestedSchema.coerceNumber && valIn !== +valOut) || valIn !== valOut)
	        ) {
	            list.push(format('dynamic', base, p, valIn, valOut));
	        }
	    }
	
	    return list;
	}
	
	// the 'full' layout schema depends on the traces types presents
	function fillLayoutSchema(schema, dataOut) {
	    var layoutSchema = schema.layout.layoutAttributes;
	
	    for(var i = 0; i < dataOut.length; i++) {
	        var traceOut = dataOut[i];
	        var traceSchema = schema.traces[traceOut.type];
	        var traceLayoutAttr = traceSchema.layoutAttributes;
	
	        if(traceLayoutAttr) {
	            if(traceOut.subplot) {
	                Lib.extendFlat(layoutSchema[traceSchema.attributes.subplot.dflt], traceLayoutAttr);
	            } else {
	                Lib.extendFlat(layoutSchema, traceLayoutAttr);
	            }
	        }
	    }
	
	    return layoutSchema;
	}
	
	// validation error codes
	var code2msgFunc = {
	    object: function(base, astr) {
	        var prefix;
	
	        if(base === 'layout' && astr === '') prefix = 'The layout argument';
	        else if(base[0] === 'data' && astr === '') {
	            prefix = 'Trace ' + base[1] + ' in the data argument';
	        } else prefix = inBase(base) + 'key ' + astr;
	
	        return prefix + ' must be linked to an object container';
	    },
	    array: function(base, astr) {
	        var prefix;
	
	        if(base === 'data') prefix = 'The data argument';
	        else prefix = inBase(base) + 'key ' + astr;
	
	        return prefix + ' must be linked to an array container';
	    },
	    schema: function(base, astr) {
	        return inBase(base) + 'key ' + astr + ' is not part of the schema';
	    },
	    unused: function(base, astr, valIn) {
	        var target = isPlainObject(valIn) ? 'container' : 'key';
	
	        return inBase(base) + target + ' ' + astr + ' did not get coerced';
	    },
	    dynamic: function(base, astr, valIn, valOut) {
	        return [
	            inBase(base) + 'key',
	            astr,
	            '(set to \'' + valIn + '\')',
	            'got reset to',
	            '\'' + valOut + '\'',
	            'during defaults.'
	        ].join(' ');
	    },
	    invisible: function(base, astr) {
	        return (
	            astr ? (inBase(base) + 'item ' + astr) : ('Trace ' + base[1])
	        ) + ' got defaulted to be not visible';
	    },
	    value: function(base, astr, valIn) {
	        return [
	            inBase(base) + 'key ' + astr,
	            'is set to an invalid value (' + valIn + ')'
	        ].join(' ');
	    }
	};
	
	function inBase(base) {
	    if(isArray(base)) return 'In data trace ' + base[1] + ', ';
	
	    return 'In ' + base + ', ';
	}
	
	function format(code, base, path, valIn, valOut) {
	    path = path || '';
	
	    var container, trace;
	
	    // container is either 'data' or 'layout
	    // trace is the trace index if 'data', null otherwise
	
	    if(isArray(base)) {
	        container = base[0];
	        trace = base[1];
	    } else {
	        container = base;
	        trace = null;
	    }
	
	    var astr = convertPathToAttributeString(path);
	    var msg = code2msgFunc[code](base, astr, valIn, valOut);
	
	    // log to console if logger config option is enabled
	    Lib.log(msg);
	
	    return {
	        code: code,
	        container: container,
	        trace: trace,
	        path: path,
	        astr: astr,
	        msg: msg
	    };
	}
	
	function isInSchema(schema, key) {
	    var parts = splitKey(key);
	    var keyMinusId = parts.keyMinusId;
	    var id = parts.id;
	
	    if((keyMinusId in schema) && schema[keyMinusId]._isSubplotObj && id) {
	        return true;
	    }
	
	    return (key in schema);
	}
	
	function getNestedSchema(schema, key) {
	    if(key in schema) return schema[key];
	
	    var parts = splitKey(key);
	
	    return schema[parts.keyMinusId];
	}
	
	var idRegex = Lib.counterRegex('([a-z]+)');
	
	function splitKey(key) {
	    var idMatch = key.match(idRegex);
	
	    return {
	        keyMinusId: idMatch && idMatch[1],
	        id: idMatch && idMatch[2]
	    };
	}
	
	function convertPathToAttributeString(path) {
	    if(!isArray(path)) return String(path);
	
	    var astr = '';
	
	    for(var i = 0; i < path.length; i++) {
	        var p = path[i];
	
	        if(typeof p === 'number') {
	            astr = astr.substr(0, astr.length - 1) + '[' + p + ']';
	        } else {
	            astr += p;
	        }
	
	        if(i < path.length - 1) astr += '.';
	    }
	
	    return astr;
	}
	
	},{"../lib":716,"../plots/plots":825,"./plot_config":752,"./plot_schema":753}],759:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    mode: {
	        valType: 'enumerated',
	        dflt: 'afterall',
	        
	        values: ['immediate', 'next', 'afterall'],
	        
	    },
	    direction: {
	        valType: 'enumerated',
	        
	        values: ['forward', 'reverse'],
	        dflt: 'forward',
	        
	    },
	    fromcurrent: {
	        valType: 'boolean',
	        dflt: false,
	        
	        
	    },
	    frame: {
	        duration: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 500,
	            
	        },
	        redraw: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	    },
	    transition: {
	        duration: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 500,
	            editType: 'none',
	            
	        },
	        easing: {
	            valType: 'enumerated',
	            dflt: 'cubic-in-out',
	            values: [
	                'linear',
	                'quad',
	                'cubic',
	                'sin',
	                'exp',
	                'circle',
	                'elastic',
	                'back',
	                'bounce',
	                'linear-in',
	                'quad-in',
	                'cubic-in',
	                'sin-in',
	                'exp-in',
	                'circle-in',
	                'elastic-in',
	                'back-in',
	                'bounce-in',
	                'linear-out',
	                'quad-out',
	                'cubic-out',
	                'sin-out',
	                'exp-out',
	                'circle-out',
	                'elastic-out',
	                'back-out',
	                'bounce-out',
	                'linear-in-out',
	                'quad-in-out',
	                'cubic-in-out',
	                'sin-in-out',
	                'exp-in-out',
	                'circle-in-out',
	                'elastic-in-out',
	                'back-in-out',
	                'bounce-in-out'
	            ],
	            
	            editType: 'none',
	            
	        },
	        ordering: {
	            valType: 'enumerated',
	            values: ['layout first', 'traces first'],
	            dflt: 'layout first',
	            
	            editType: 'none',
	            
	        }
	    }
	};
	
	},{}],760:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var Template = _dereq_('../plot_api/plot_template');
	
	/** Convenience wrapper for making array container logic DRY and consistent
	 *
	 * @param {object} parentObjIn
	 *  user input object where the container in question is linked
	 *  (i.e. either a user trace object or the user layout object)
	 *
	 * @param {object} parentObjOut
	 *  full object where the coerced container will be linked
	 *  (i.e. either a full trace object or the full layout object)
	 *
	 * @param {object} opts
	 *  options object:
	 *   - name {string}
	 *      name of the key linking the container in question
	 *   - inclusionAttr {string}
	 *      name of the item attribute for inclusion/exclusion. Default is 'visible'.
	 *      Since inclusion is true, use eg 'enabled' instead of 'disabled'.
	 *   - handleItemDefaults {function}
	 *      defaults method to be called on each item in the array container in question
	 *
	 *      Its arguments are:
	 *          - itemIn {object} item in user layout
	 *          - itemOut {object} item in full layout
	 *          - parentObj {object} (as in closure)
	 *          - opts {object} (as in closure)
	 * N.B.
	 *
	 *  - opts is passed to handleItemDefaults so it can also store
	 *    links to supplementary data (e.g. fullData for layout components)
	 *
	 */
	module.exports = function handleArrayContainerDefaults(parentObjIn, parentObjOut, opts) {
	    var name = opts.name;
	    var inclusionAttr = opts.inclusionAttr || 'visible';
	
	    var previousContOut = parentObjOut[name];
	
	    var contIn = Lib.isArrayOrTypedArray(parentObjIn[name]) ? parentObjIn[name] : [];
	    var contOut = parentObjOut[name] = [];
	    var templater = Template.arrayTemplater(parentObjOut, name, inclusionAttr);
	    var i, itemOut;
	
	    for(i = 0; i < contIn.length; i++) {
	        var itemIn = contIn[i];
	
	        if(!Lib.isPlainObject(itemIn)) {
	            itemOut = templater.newItem({});
	            itemOut[inclusionAttr] = false;
	        } else {
	            itemOut = templater.newItem(itemIn);
	        }
	
	        itemOut._index = i;
	
	        if(itemOut[inclusionAttr] !== false) {
	            opts.handleItemDefaults(itemIn, itemOut, parentObjOut, opts);
	        }
	
	        contOut.push(itemOut);
	    }
	
	    var defaultItems = templater.defaultItems();
	    for(i = 0; i < defaultItems.length; i++) {
	        itemOut = defaultItems[i];
	        itemOut._index = contOut.length;
	        opts.handleItemDefaults({}, itemOut, parentObjOut, opts, {});
	        contOut.push(itemOut);
	    }
	
	    // in case this array gets its defaults rebuilt independent of the whole layout,
	    // relink the private keys just for this array.
	    if(Lib.isArrayOrTypedArray(previousContOut)) {
	        var len = Math.min(previousContOut.length, contOut.length);
	        for(i = 0; i < len; i++) {
	            Lib.relinkPrivateKeys(contOut[i], previousContOut[i]);
	        }
	    }
	
	    return contOut;
	};
	
	},{"../lib":716,"../plot_api/plot_template":754}],761:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fxAttrs = _dereq_('../components/fx/attributes');
	
	module.exports = {
	    type: {
	        valType: 'enumerated',
	        
	        values: [],     // listed dynamically
	        dflt: 'scatter',
	        editType: 'calc+clearAxisTypes',
	        _noTemplating: true // we handle this at a higher level
	    },
	    visible: {
	        valType: 'enumerated',
	        values: [true, false, 'legendonly'],
	        
	        dflt: true,
	        editType: 'calc',
	        
	    },
	    showlegend: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'style',
	        
	    },
	    legendgroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'style',
	        
	    },
	    opacity: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 1,
	        editType: 'style',
	        
	    },
	    name: {
	        valType: 'string',
	        
	        editType: 'style',
	        
	    },
	    uid: {
	        valType: 'string',
	        
	        editType: 'plot',
	        anim: true,
	        
	    },
	    ids: {
	        valType: 'data_array',
	        editType: 'calc',
	        anim: true,
	        
	    },
	    customdata: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    meta: {
	        valType: 'any',
	        arrayOk: true,
	        
	        editType: 'plot',
	        
	    },
	
	    // N.B. these cannot be 'data_array' as they do not have the same length as
	    // other data arrays and arrayOk attributes in general
	    //
	    // Maybe add another valType:
	    // https://github.com/plotly/plotly.js/issues/1894
	    selectedpoints: {
	        valType: 'any',
	        
	        editType: 'calc',
	        
	    },
	
	    hoverinfo: {
	        valType: 'flaglist',
	        
	        flags: ['x', 'y', 'z', 'text', 'name'],
	        extras: ['all', 'none', 'skip'],
	        arrayOk: true,
	        dflt: 'all',
	        editType: 'none',
	        
	    },
	    hoverlabel: fxAttrs.hoverlabel,
	    stream: {
	        token: {
	            valType: 'string',
	            noBlank: true,
	            strict: true,
	            
	            editType: 'calc',
	            
	        },
	        maxpoints: {
	            valType: 'number',
	            min: 0,
	            max: 10000,
	            dflt: 500,
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    },
	    transforms: {
	        _isLinkedToArray: 'transform',
	        editType: 'calc',
	        
	    },
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    }
	};
	
	},{"../components/fx/attributes":621}],762:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    xaxis: {
	        valType: 'subplotid',
	        
	        dflt: 'x',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    yaxis: {
	        valType: 'subplotid',
	        
	        dflt: 'y',
	        editType: 'calc+clearAxisTypes',
	        
	    }
	};
	
	},{}],763:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var FP_SAFE = _dereq_('../../constants/numerical').FP_SAFE;
	var Registry = _dereq_('../../registry');
	
	module.exports = {
	    getAutoRange: getAutoRange,
	    makePadFn: makePadFn,
	    doAutoRange: doAutoRange,
	    findExtremes: findExtremes,
	    concatExtremes: concatExtremes
	};
	
	/**
	 * getAutoRange
	 *
	 * Collects all _extremes values corresponding to a given axis
	 * and computes its auto range.
	 *
	 * Note that getAutoRange uses return values from findExtremes.
	 *
	 * @param {object} gd:
	 *   graph div object with filled-in fullData and fullLayout, in particular
	 *   with filled-in '_extremes' containers:
	 *   {
	 *      val: calcdata value,
	 *      pad: extra pixels beyond this value,
	 *      extrapad: bool, does this point want 5% extra padding
	 *   }
	 * @param {object} ax:
	 *   full axis object, in particular with filled-in '_traceIndices'
	 *   and '_annIndices' / '_shapeIndices' if applicable
	 * @return {array}
	 *   an array of [min, max]. These are calcdata for log and category axes
	 *   and data for linear and date axes.
	 *
	 * TODO: we want to change log to data as well, but it's hard to do this
	 * maintaining backward compatibility. category will always have to use calcdata
	 * though, because otherwise values between categories (or outside all categories)
	 * would be impossible.
	 */
	function getAutoRange(gd, ax) {
	    var i, j;
	    var newRange = [];
	
	    var getPad = makePadFn(ax);
	    var extremes = concatExtremes(gd, ax);
	    var minArray = extremes.min;
	    var maxArray = extremes.max;
	
	    if(minArray.length === 0 || maxArray.length === 0) {
	        return Lib.simpleMap(ax.range, ax.r2l);
	    }
	
	    var minmin = minArray[0].val;
	    var maxmax = maxArray[0].val;
	
	    for(i = 1; i < minArray.length; i++) {
	        if(minmin !== maxmax) break;
	        minmin = Math.min(minmin, minArray[i].val);
	    }
	    for(i = 1; i < maxArray.length; i++) {
	        if(minmin !== maxmax) break;
	        maxmax = Math.max(maxmax, maxArray[i].val);
	    }
	
	    var axReverse = false;
	
	    if(ax.range) {
	        var rng = Lib.simpleMap(ax.range, ax.r2l);
	        axReverse = rng[1] < rng[0];
	    }
	    // one-time setting to easily reverse the axis
	    // when plotting from code
	    if(ax.autorange === 'reversed') {
	        axReverse = true;
	        ax.autorange = true;
	    }
	
	    var rangeMode = ax.rangemode;
	    var toZero = rangeMode === 'tozero';
	    var nonNegative = rangeMode === 'nonnegative';
	    var axLen = ax._length;
	    // don't allow padding to reduce the data to < 10% of the length
	    var minSpan = axLen / 10;
	
	    var mbest = 0;
	    var minpt, maxpt, minbest, maxbest, dp, dv;
	
	    for(i = 0; i < minArray.length; i++) {
	        minpt = minArray[i];
	        for(j = 0; j < maxArray.length; j++) {
	            maxpt = maxArray[j];
	            dv = maxpt.val - minpt.val;
	            if(dv > 0) {
	                dp = axLen - getPad(minpt) - getPad(maxpt);
	                if(dp > minSpan) {
	                    if(dv / dp > mbest) {
	                        minbest = minpt;
	                        maxbest = maxpt;
	                        mbest = dv / dp;
	                    }
	                } else if(dv / axLen > mbest) {
	                    // in case of padding longer than the axis
	                    // at least include the unpadded data values.
	                    minbest = {val: minpt.val, pad: 0};
	                    maxbest = {val: maxpt.val, pad: 0};
	                    mbest = dv / axLen;
	                }
	            }
	        }
	    }
	
	    function getMaxPad(prev, pt) {
	        return Math.max(prev, getPad(pt));
	    }
	
	    if(minmin === maxmax) {
	        var lower = minmin - 1;
	        var upper = minmin + 1;
	        if(toZero) {
	            if(minmin === 0) {
	                // The only value we have on this axis is 0, and we want to
	                // autorange so zero is one end.
	                // In principle this could be [0, 1] or [-1, 0] but usually
	                // 'tozero' pins 0 to the low end, so follow that.
	                newRange = [0, 1];
	            } else {
	                var maxPad = (minmin > 0 ? maxArray : minArray).reduce(getMaxPad, 0);
	                // we're pushing a single value away from the edge due to its
	                // padding, with the other end clamped at zero
	                // 0.5 means don't push it farther than the center.
	                var rangeEnd = minmin / (1 - Math.min(0.5, maxPad / axLen));
	                newRange = minmin > 0 ? [0, rangeEnd] : [rangeEnd, 0];
	            }
	        } else if(nonNegative) {
	            newRange = [Math.max(0, lower), Math.max(1, upper)];
	        } else {
	            newRange = [lower, upper];
	        }
	    } else {
	        if(toZero) {
	            if(minbest.val >= 0) {
	                minbest = {val: 0, pad: 0};
	            }
	            if(maxbest.val <= 0) {
	                maxbest = {val: 0, pad: 0};
	            }
	        } else if(nonNegative) {
	            if(minbest.val - mbest * getPad(minbest) < 0) {
	                minbest = {val: 0, pad: 0};
	            }
	            if(maxbest.val <= 0) {
	                maxbest = {val: 1, pad: 0};
	            }
	        }
	
	        // in case it changed again...
	        mbest = (maxbest.val - minbest.val) /
	            (axLen - getPad(minbest) - getPad(maxbest));
	
	        newRange = [
	            minbest.val - mbest * getPad(minbest),
	            maxbest.val + mbest * getPad(maxbest)
	        ];
	    }
	
	    // maintain reversal
	    if(axReverse) newRange.reverse();
	
	    return Lib.simpleMap(newRange, ax.l2r || Number);
	}
	
	/*
	 * calculate the pixel padding for ax._min and ax._max entries with
	 * optional extrapad as 5% of the total axis length
	 */
	function makePadFn(ax) {
	    // 5% padding for points that specify extrapad: true
	    var extrappad = ax._length / 20;
	
	    // domain-constrained axes: base extrappad on the unconstrained
	    // domain so it's consistent as the domain changes
	    if((ax.constrain === 'domain') && ax._inputDomain) {
	        extrappad *= (ax._inputDomain[1] - ax._inputDomain[0]) /
	            (ax.domain[1] - ax.domain[0]);
	    }
	
	    return function getPad(pt) { return pt.pad + (pt.extrapad ? extrappad : 0); };
	}
	
	function concatExtremes(gd, ax) {
	    var axId = ax._id;
	    var fullData = gd._fullData;
	    var fullLayout = gd._fullLayout;
	    var minArray = [];
	    var maxArray = [];
	    var i, j, d;
	
	    function _concat(cont, indices) {
	        for(i = 0; i < indices.length; i++) {
	            var item = cont[indices[i]];
	            var extremes = (item._extremes || {})[axId];
	            if(item.visible === true && extremes) {
	                for(j = 0; j < extremes.min.length; j++) {
	                    d = extremes.min[j];
	                    collapseMinArray(minArray, d.val, d.pad, {extrapad: d.extrapad});
	                }
	                for(j = 0; j < extremes.max.length; j++) {
	                    d = extremes.max[j];
	                    collapseMaxArray(maxArray, d.val, d.pad, {extrapad: d.extrapad});
	                }
	            }
	        }
	    }
	
	    _concat(fullData, ax._traceIndices);
	    _concat(fullLayout.annotations || [], ax._annIndices || []);
	    _concat(fullLayout.shapes || [], ax._shapeIndices || []);
	
	    return {min: minArray, max: maxArray};
	}
	
	function doAutoRange(gd, ax) {
	    ax.setScale();
	
	    if(ax.autorange) {
	        ax.range = getAutoRange(gd, ax);
	
	        ax._r = ax.range.slice();
	        ax._rl = Lib.simpleMap(ax._r, ax.r2l);
	
	        // doAutoRange will get called on fullLayout,
	        // but we want to report its results back to layout
	
	        var axIn = ax._input;
	
	        // before we edit _input, store preGUI values
	        var edits = {};
	        edits[ax._attr + '.range'] = ax.range;
	        edits[ax._attr + '.autorange'] = ax.autorange;
	        Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, edits);
	
	        axIn.range = ax.range.slice();
	        axIn.autorange = ax.autorange;
	    }
	
	    var anchorAx = ax._anchorAxis;
	
	    if(anchorAx && anchorAx.rangeslider) {
	        var axeRangeOpts = anchorAx.rangeslider[ax._name];
	        if(axeRangeOpts) {
	            if(axeRangeOpts.rangemode === 'auto') {
	                axeRangeOpts.range = getAutoRange(gd, ax);
	            }
	        }
	        anchorAx._input.rangeslider[ax._name] = Lib.extendFlat({}, axeRangeOpts);
	    }
	}
	
	/**
	 * findExtremes
	 *
	 * Find min/max extremes of an array of coordinates on a given axis.
	 *
	 * Note that findExtremes is called during `calc`, when we don't yet know the axis
	 * length; all the inputs should be based solely on the trace data, nothing
	 * about the axis layout.
	 *
	 * Note that `ppad` and `vpad` as well as their asymmetric variants refer to
	 * the before and after padding of the passed `data` array, not to the whole axis.
	 *
	 * @param {object} ax: full axis object
	 *   relies on
	 *   - ax.type
	 *   - ax._m (just its sign)
	 *   - ax.d2l
	 * @param {array} data:
	 *  array of numbers (i.e. already run though ax.d2c)
	 * @param {object} opts:
	 *  available keys are:
	 *      vpad: (number or number array) pad values (data value +-vpad)
	 *      ppad: (number or number array) pad pixels (pixel location +-ppad)
	 *      ppadplus, ppadminus, vpadplus, vpadminus:
	 *          separate padding for each side, overrides symmetric
	 *      padded: (boolean) add 5% padding to both ends
	 *          (unless one end is overridden by tozero)
	 *      tozero: (boolean) make sure to include zero if axis is linear,
	 *          and make it a tight bound if possible
	 *      vpadLinearized: (boolean) whether or not vpad (or vpadplus/vpadminus)
	 *          is linearized (for log scale axes)
	 *
	 * @return {object}
	 *  - min {array of objects}
	 *  - max {array of objects}
	 *  each object item has fields:
	 *    - val {number}
	 *    - pad {number}
	 *    - extrappad {number}
	 *  - opts {object}: a ref to the passed "options" object
	 */
	function findExtremes(ax, data, opts) {
	    if(!opts) opts = {};
	    if(!ax._m) ax.setScale();
	
	    var minArray = [];
	    var maxArray = [];
	
	    var len = data.length;
	    var extrapad = opts.padded || false;
	    var tozero = opts.tozero && (ax.type === 'linear' || ax.type === '-');
	    var isLog = ax.type === 'log';
	    var hasArrayOption = false;
	    var vpadLinearized = opts.vpadLinearized || false;
	    var i, v, di, dmin, dmax, ppadiplus, ppadiminus, vmin, vmax;
	
	    function makePadAccessor(item) {
	        if(Array.isArray(item)) {
	            hasArrayOption = true;
	            return function(i) { return Math.max(Number(item[i]||0), 0); };
	        } else {
	            var v = Math.max(Number(item||0), 0);
	            return function() { return v; };
	        }
	    }
	
	    var ppadplus = makePadAccessor((ax._m > 0 ?
	        opts.ppadplus : opts.ppadminus) || opts.ppad || 0);
	    var ppadminus = makePadAccessor((ax._m > 0 ?
	        opts.ppadminus : opts.ppadplus) || opts.ppad || 0);
	    var vpadplus = makePadAccessor(opts.vpadplus || opts.vpad);
	    var vpadminus = makePadAccessor(opts.vpadminus || opts.vpad);
	
	    if(!hasArrayOption) {
	        // with no arrays other than `data` we don't need to consider
	        // every point, only the extreme data points
	        vmin = Infinity;
	        vmax = -Infinity;
	
	        if(isLog) {
	            for(i = 0; i < len; i++) {
	                v = data[i];
	                // data is not linearized yet so we still have to filter out negative logs
	                if(v < vmin && v > 0) vmin = v;
	                if(v > vmax && v < FP_SAFE) vmax = v;
	            }
	        } else {
	            for(i = 0; i < len; i++) {
	                v = data[i];
	                if(v < vmin && v > -FP_SAFE) vmin = v;
	                if(v > vmax && v < FP_SAFE) vmax = v;
	            }
	        }
	
	        data = [vmin, vmax];
	        len = 2;
	    }
	
	    var collapseOpts = {tozero: tozero, extrapad: extrapad};
	
	    function addItem(i) {
	        di = data[i];
	        if(!isNumeric(di)) return;
	        ppadiplus = ppadplus(i);
	        ppadiminus = ppadminus(i);
	
	        if(vpadLinearized) {
	            dmin = ax.c2l(di) - vpadminus(i);
	            dmax = ax.c2l(di) + vpadplus(i);
	        } else {
	            vmin = di - vpadminus(i);
	            vmax = di + vpadplus(i);
	            // special case for log axes: if vpad makes this object span
	            // more than an order of mag, clip it to one order. This is so
	            // we don't have non-positive errors or absurdly large lower
	            // range due to rounding errors
	            if(isLog && vmin < vmax / 10) vmin = vmax / 10;
	
	            dmin = ax.c2l(vmin);
	            dmax = ax.c2l(vmax);
	        }
	
	        if(tozero) {
	            dmin = Math.min(0, dmin);
	            dmax = Math.max(0, dmax);
	        }
	        if(goodNumber(dmin)) {
	            collapseMinArray(minArray, dmin, ppadiminus, collapseOpts);
	        }
	        if(goodNumber(dmax)) {
	            collapseMaxArray(maxArray, dmax, ppadiplus, collapseOpts);
	        }
	    }
	
	    // For efficiency covering monotonic or near-monotonic data,
	    // check a few points at both ends first and then sweep
	    // through the middle
	    var iMax = Math.min(6, len);
	    for(i = 0; i < iMax; i++) addItem(i);
	    for(i = len - 1; i >= iMax; i--) addItem(i);
	
	    return {
	        min: minArray,
	        max: maxArray,
	        opts: opts
	    };
	}
	
	function collapseMinArray(array, newVal, newPad, opts) {
	    collapseArray(array, newVal, newPad, opts, lessOrEqual);
	}
	
	function collapseMaxArray(array, newVal, newPad, opts) {
	    collapseArray(array, newVal, newPad, opts, greaterOrEqual);
	}
	
	/**
	 * collapseArray
	 *
	 * Takes items from 'array' and compares them to 'newVal', 'newPad'.
	 *
	 * @param {array} array:
	 *  current set of min or max extremes
	 * @param {number} newVal:
	 *  new value to compare against
	 * @param {number} newPad:
	 *  pad value associated with 'newVal'
	 * @param {object} opts:
	 *  - tozero {boolean}
	 *  - extrapad {number}
	 * @param {function} atLeastAsExtreme:
	 *  comparison function, use
	 *  - lessOrEqual for min 'array' and
	 *  - greaterOrEqual for max 'array'
	 *
	 * In practice, 'array' is either
	 *  - 'extremes[ax._id].min' or
	 *  - 'extremes[ax._id].max
	 *  found in traces and layout items that affect autorange.
	 *
	 * Since we don't yet know the relationship between pixels and values
	 * (that's what we're trying to figure out!) AND we don't yet know how
	 * many pixels `extrapad` represents (it's going to be 5% of the length,
	 * but we don't want to have to redo calc just because length changed)
	 * two point must satisfy three criteria simultaneously for one to supersede the other:
	 *  - at least as extreme a `val`
	 *  - at least as big a `pad`
	 *  - an unpadded point cannot supersede a padded point, but any other combination can
	 *
	 * Then:
	 * - If the item supersedes the new point, set includeThis false
	 * - If the new pt supersedes the item, delete it from 'array'
	 */
	function collapseArray(array, newVal, newPad, opts, atLeastAsExtreme) {
	    var tozero = opts.tozero;
	    var extrapad = opts.extrapad;
	    var includeThis = true;
	
	    for(var j = 0; j < array.length && includeThis; j++) {
	        var v = array[j];
	        if(atLeastAsExtreme(v.val, newVal) && v.pad >= newPad && (v.extrapad || !extrapad)) {
	            includeThis = false;
	            break;
	        } else if(atLeastAsExtreme(newVal, v.val) && v.pad <= newPad && (extrapad || !v.extrapad)) {
	            array.splice(j, 1);
	            j--;
	        }
	    }
	    if(includeThis) {
	        var clipAtZero = (tozero && newVal === 0);
	        array.push({
	            val: newVal,
	            pad: clipAtZero ? 0 : newPad,
	            extrapad: clipAtZero ? false : extrapad
	        });
	    }
	}
	
	// In order to stop overflow errors, don't consider points
	// too close to the limits of js floating point
	function goodNumber(v) {
	    return isNumeric(v) && Math.abs(v) < FP_SAFE;
	}
	
	function lessOrEqual(v0, v1) { return v0 <= v1; }
	function greaterOrEqual(v0, v1) { return v0 >= v1; }
	
	},{"../../constants/numerical":692,"../../lib":716,"../../registry":845,"fast-isnumeric":227}],764:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	var Plots = _dereq_('../../plots/plots');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var Titles = _dereq_('../../components/titles');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	
	var axAttrs = _dereq_('./layout_attributes');
	var cleanTicks = _dereq_('./clean_ticks');
	
	var constants = _dereq_('../../constants/numerical');
	var ONEAVGYEAR = constants.ONEAVGYEAR;
	var ONEAVGMONTH = constants.ONEAVGMONTH;
	var ONEDAY = constants.ONEDAY;
	var ONEHOUR = constants.ONEHOUR;
	var ONEMIN = constants.ONEMIN;
	var ONESEC = constants.ONESEC;
	var MINUS_SIGN = constants.MINUS_SIGN;
	var BADNUM = constants.BADNUM;
	
	var alignmentConstants = _dereq_('../../constants/alignment');
	var MID_SHIFT = alignmentConstants.MID_SHIFT;
	var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
	var LINE_SPACING = alignmentConstants.LINE_SPACING;
	var OPPOSITE_SIDE = alignmentConstants.OPPOSITE_SIDE;
	
	var axes = module.exports = {};
	
	axes.setConvert = _dereq_('./set_convert');
	var autoType = _dereq_('./axis_autotype');
	
	var axisIds = _dereq_('./axis_ids');
	axes.id2name = axisIds.id2name;
	axes.name2id = axisIds.name2id;
	axes.cleanId = axisIds.cleanId;
	axes.list = axisIds.list;
	axes.listIds = axisIds.listIds;
	axes.getFromId = axisIds.getFromId;
	axes.getFromTrace = axisIds.getFromTrace;
	
	var autorange = _dereq_('./autorange');
	axes.getAutoRange = autorange.getAutoRange;
	axes.findExtremes = autorange.findExtremes;
	
	/*
	 * find the list of possible axes to reference with an xref or yref attribute
	 * and coerce it to that list
	 *
	 * attr: the attribute we're generating a reference for. Should end in 'x' or 'y'
	 *     but can be prefixed, like 'ax' for annotation's arrow x
	 * dflt: the default to coerce to, or blank to use the first axis (falling back on
	 *     extraOption if there is no axis)
	 * extraOption: aside from existing axes with this letter, what non-axis value is allowed?
	 *     Only required if it's different from `dflt`
	 */
	axes.coerceRef = function(containerIn, containerOut, gd, attr, dflt, extraOption) {
	    var axLetter = attr.charAt(attr.length - 1);
	    var axlist = gd._fullLayout._subplots[axLetter + 'axis'];
	    var refAttr = attr + 'ref';
	    var attrDef = {};
	
	    if(!dflt) dflt = axlist[0] || extraOption;
	    if(!extraOption) extraOption = dflt;
	
	    // data-ref annotations are not supported in gl2d yet
	
	    attrDef[refAttr] = {
	        valType: 'enumerated',
	        values: axlist.concat(extraOption ? [extraOption] : []),
	        dflt: dflt
	    };
	
	    // xref, yref
	    return Lib.coerce(containerIn, containerOut, attrDef, refAttr);
	};
	
	/*
	 * coerce position attributes (range-type) that can be either on axes or absolute
	 * (paper or pixel) referenced. The biggest complication here is that we don't know
	 * before looking at the axis whether the value must be a number or not (it may be
	 * a date string), so we can't use the regular valType='number' machinery
	 *
	 * axRef (string): the axis this position is referenced to, or:
	 *     paper: fraction of the plot area
	 *     pixel: pixels relative to some starting position
	 * attr (string): the attribute in containerOut we are coercing
	 * dflt (number): the default position, as a fraction or pixels. If the attribute
	 *     is to be axis-referenced, this will be converted to an axis data value
	 *
	 * Also cleans the values, since the attribute definition itself has to say
	 * valType: 'any' to handle date axes. This allows us to accept:
	 * - for category axes: category names, and convert them here into serial numbers.
	 *   Note that this will NOT work for axis range endpoints, because we don't know
	 *   the category list yet (it's set by ax.makeCalcdata during calc)
	 *   but it works for component (note, shape, images) positions.
	 * - for date axes: JS Dates or milliseconds, and convert to date strings
	 * - for other types: coerce them to numbers
	 */
	axes.coercePosition = function(containerOut, gd, coerce, axRef, attr, dflt) {
	    var cleanPos, pos;
	
	    if(axRef === 'paper' || axRef === 'pixel') {
	        cleanPos = Lib.ensureNumber;
	        pos = coerce(attr, dflt);
	    } else {
	        var ax = axes.getFromId(gd, axRef);
	        dflt = ax.fraction2r(dflt);
	        pos = coerce(attr, dflt);
	        cleanPos = ax.cleanPos;
	    }
	
	    containerOut[attr] = cleanPos(pos);
	};
	
	axes.cleanPosition = function(pos, gd, axRef) {
	    var cleanPos = (axRef === 'paper' || axRef === 'pixel') ?
	        Lib.ensureNumber :
	        axes.getFromId(gd, axRef).cleanPos;
	
	    return cleanPos(pos);
	};
	
	axes.redrawComponents = function(gd, axIds) {
	    axIds = axIds ? axIds : axes.listIds(gd);
	
	    var fullLayout = gd._fullLayout;
	
	    function _redrawOneComp(moduleName, methodName, stashName, shortCircuit) {
	        var method = Registry.getComponentMethod(moduleName, methodName);
	        var stash = {};
	
	        for(var i = 0; i < axIds.length; i++) {
	            var ax = fullLayout[axes.id2name(axIds[i])];
	            var indices = ax[stashName];
	
	            for(var j = 0; j < indices.length; j++) {
	                var ind = indices[j];
	
	                if(!stash[ind]) {
	                    method(gd, ind);
	                    stash[ind] = 1;
	                    // once is enough for images (which doesn't use the `i` arg anyway)
	                    if(shortCircuit) return;
	                }
	            }
	        }
	    }
	
	    // annotations and shapes 'draw' method is slow,
	    // use the finer-grained 'drawOne' method instead
	    _redrawOneComp('annotations', 'drawOne', '_annIndices');
	    _redrawOneComp('shapes', 'drawOne', '_shapeIndices');
	    _redrawOneComp('images', 'draw', '_imgIndices', true);
	};
	
	var getDataConversions = axes.getDataConversions = function(gd, trace, target, targetArray) {
	    var ax;
	
	    // If target points to an axis, use the type we already have for that
	    // axis to find the data type. Otherwise use the values to autotype.
	    var d2cTarget = (target === 'x' || target === 'y' || target === 'z') ?
	        target :
	        targetArray;
	
	    // In the case of an array target, make a mock data array
	    // and call supplyDefaults to the data type and
	    // setup the data-to-calc method.
	    if(Array.isArray(d2cTarget)) {
	        ax = {
	            type: autoType(targetArray),
	            _categories: []
	        };
	        axes.setConvert(ax);
	
	        // build up ax._categories (usually done during ax.makeCalcdata()
	        if(ax.type === 'category') {
	            for(var i = 0; i < targetArray.length; i++) {
	                ax.d2c(targetArray[i]);
	            }
	        }
	        // TODO what to do for transforms?
	    } else {
	        ax = axes.getFromTrace(gd, trace, d2cTarget);
	    }
	
	    // if 'target' has corresponding axis
	    // -> use setConvert method
	    if(ax) return {d2c: ax.d2c, c2d: ax.c2d};
	
	    // special case for 'ids'
	    // -> cast to String
	    if(d2cTarget === 'ids') return {d2c: toString, c2d: toString};
	
	    // otherwise (e.g. numeric-array of 'marker.color' or 'marker.size')
	    // -> cast to Number
	
	    return {d2c: toNum, c2d: toNum};
	};
	
	function toNum(v) { return +v; }
	function toString(v) { return String(v); }
	
	axes.getDataToCoordFunc = function(gd, trace, target, targetArray) {
	    return getDataConversions(gd, trace, target, targetArray).d2c;
	};
	
	// get counteraxis letter for this axis (name or id)
	// this can also be used as the id for default counter axis
	axes.counterLetter = function(id) {
	    var axLetter = id.charAt(0);
	    if(axLetter === 'x') return 'y';
	    if(axLetter === 'y') return 'x';
	};
	
	// incorporate a new minimum difference and first tick into
	// forced
	// note that _forceTick0 is linearized, so needs to be turned into
	// a range value for setting tick0
	axes.minDtick = function(ax, newDiff, newFirst, allow) {
	    // doesn't make sense to do forced min dTick on log or category axes,
	    // and the plot itself may decide to cancel (ie non-grouped bars)
	    if(['log', 'category', 'multicategory'].indexOf(ax.type) !== -1 || !allow) {
	        ax._minDtick = 0;
	    } else if(ax._minDtick === undefined) {
	        // undefined means there's nothing there yet
	
	        ax._minDtick = newDiff;
	        ax._forceTick0 = newFirst;
	    } else if(ax._minDtick) {
	        if((ax._minDtick / newDiff + 1e-6) % 1 < 2e-6 &&
	            // existing minDtick is an integer multiple of newDiff
	            // (within rounding err)
	            // and forceTick0 can be shifted to newFirst
	
	                (((newFirst - ax._forceTick0) / newDiff % 1) +
	                    1.000001) % 1 < 2e-6) {
	            ax._minDtick = newDiff;
	            ax._forceTick0 = newFirst;
	        } else if((newDiff / ax._minDtick + 1e-6) % 1 > 2e-6 ||
	            // if the converse is true (newDiff is a multiple of minDtick and
	            // newFirst can be shifted to forceTick0) then do nothing - same
	            // forcing stands. Otherwise, cancel forced minimum
	
	                (((newFirst - ax._forceTick0) / ax._minDtick % 1) +
	                    1.000001) % 1 > 2e-6) {
	            ax._minDtick = 0;
	        }
	    }
	};
	
	// save a copy of the initial axis ranges in fullLayout
	// use them in mode bar and dblclick events
	axes.saveRangeInitial = function(gd, overwrite) {
	    var axList = axes.list(gd, '', true);
	    var hasOneAxisChanged = false;
	
	    for(var i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        var isNew = (ax._rangeInitial === undefined);
	        var hasChanged = isNew || !(
	            ax.range[0] === ax._rangeInitial[0] &&
	            ax.range[1] === ax._rangeInitial[1]
	        );
	
	        if((isNew && ax.autorange === false) || (overwrite && hasChanged)) {
	            ax._rangeInitial = ax.range.slice();
	            hasOneAxisChanged = true;
	        }
	    }
	
	    return hasOneAxisChanged;
	};
	
	// save a copy of the initial spike visibility
	axes.saveShowSpikeInitial = function(gd, overwrite) {
	    var axList = axes.list(gd, '', true);
	    var hasOneAxisChanged = false;
	    var allSpikesEnabled = 'on';
	
	    for(var i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        var isNew = (ax._showSpikeInitial === undefined);
	        var hasChanged = isNew || !(ax.showspikes === ax._showspikes);
	
	        if(isNew || (overwrite && hasChanged)) {
	            ax._showSpikeInitial = ax.showspikes;
	            hasOneAxisChanged = true;
	        }
	
	        if(allSpikesEnabled === 'on' && !ax.showspikes) {
	            allSpikesEnabled = 'off';
	        }
	    }
	    gd._fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
	    return hasOneAxisChanged;
	};
	
	axes.autoBin = function(data, ax, nbins, is2d, calendar, size) {
	    var dataMin = Lib.aggNums(Math.min, null, data);
	    var dataMax = Lib.aggNums(Math.max, null, data);
	
	    if(ax.type === 'category' || ax.type === 'multicategory') {
	        return {
	            start: dataMin - 0.5,
	            end: dataMax + 0.5,
	            size: Math.max(1, Math.round(size) || 1),
	            _dataSpan: dataMax - dataMin,
	        };
	    }
	
	    if(!calendar) calendar = ax.calendar;
	
	    // piggyback off tick code to make "nice" bin sizes and edges
	    var dummyAx;
	    if(ax.type === 'log') {
	        dummyAx = {
	            type: 'linear',
	            range: [dataMin, dataMax]
	        };
	    } else {
	        dummyAx = {
	            type: ax.type,
	            range: Lib.simpleMap([dataMin, dataMax], ax.c2r, 0, calendar),
	            calendar: calendar
	        };
	    }
	    axes.setConvert(dummyAx);
	
	    size = size && cleanTicks.dtick(size, dummyAx.type);
	
	    if(size) {
	        dummyAx.dtick = size;
	        dummyAx.tick0 = cleanTicks.tick0(undefined, dummyAx.type, calendar);
	    } else {
	        var size0;
	        if(nbins) size0 = ((dataMax - dataMin) / nbins);
	        else {
	            // totally auto: scale off std deviation so the highest bin is
	            // somewhat taller than the total number of bins, but don't let
	            // the size get smaller than the 'nice' rounded down minimum
	            // difference between values
	            var distinctData = Lib.distinctVals(data);
	            var msexp = Math.pow(10, Math.floor(
	                Math.log(distinctData.minDiff) / Math.LN10));
	            var minSize = msexp * Lib.roundUp(
	                distinctData.minDiff / msexp, [0.9, 1.9, 4.9, 9.9], true);
	            size0 = Math.max(minSize, 2 * Lib.stdev(data) /
	                Math.pow(data.length, is2d ? 0.25 : 0.4));
	
	            // fallback if ax.d2c output BADNUMs
	            // e.g. when user try to plot categorical bins
	            // on a layout.xaxis.type: 'linear'
	            if(!isNumeric(size0)) size0 = 1;
	        }
	
	        axes.autoTicks(dummyAx, size0);
	    }
	
	    var finalSize = dummyAx.dtick;
	    var binStart = axes.tickIncrement(
	            axes.tickFirst(dummyAx), finalSize, 'reverse', calendar);
	    var binEnd, bincount;
	
	    // check for too many data points right at the edges of bins
	    // (>50% within 1% of bin edges) or all data points integral
	    // and offset the bins accordingly
	    if(typeof finalSize === 'number') {
	        binStart = autoShiftNumericBins(binStart, data, dummyAx, dataMin, dataMax);
	
	        bincount = 1 + Math.floor((dataMax - binStart) / finalSize);
	        binEnd = binStart + bincount * finalSize;
	    } else {
	        // month ticks - should be the only nonlinear kind we have at this point.
	        // dtick (as supplied by axes.autoTick) only has nonlinear values on
	        // date and log axes, but even if you display a histogram on a log axis
	        // we bin it on a linear axis (which one could argue against, but that's
	        // a separate issue)
	        if(dummyAx.dtick.charAt(0) === 'M') {
	            binStart = autoShiftMonthBins(binStart, data, finalSize, dataMin, calendar);
	        }
	
	        // calculate the endpoint for nonlinear ticks - you have to
	        // just increment until you're done
	        binEnd = binStart;
	        bincount = 0;
	        while(binEnd <= dataMax) {
	            binEnd = axes.tickIncrement(binEnd, finalSize, false, calendar);
	            bincount++;
	        }
	    }
	
	    return {
	        start: ax.c2r(binStart, 0, calendar),
	        end: ax.c2r(binEnd, 0, calendar),
	        size: finalSize,
	        _dataSpan: dataMax - dataMin
	    };
	};
	
	
	function autoShiftNumericBins(binStart, data, ax, dataMin, dataMax) {
	    var edgecount = 0;
	    var midcount = 0;
	    var intcount = 0;
	    var blankCount = 0;
	
	    function nearEdge(v) {
	        // is a value within 1% of a bin edge?
	        return (1 + (v - binStart) * 100 / ax.dtick) % 100 < 2;
	    }
	
	    for(var i = 0; i < data.length; i++) {
	        if(data[i] % 1 === 0) intcount++;
	        else if(!isNumeric(data[i])) blankCount++;
	
	        if(nearEdge(data[i])) edgecount++;
	        if(nearEdge(data[i] + ax.dtick / 2)) midcount++;
	    }
	    var dataCount = data.length - blankCount;
	
	    if(intcount === dataCount && ax.type !== 'date') {
	        if(ax.dtick < 1) {
	            // all integers: if bin size is <1, it's because
	            // that was specifically requested (large nbins)
	            // so respect that... but center the bins containing
	            // integers on those integers
	
	            binStart = dataMin - 0.5 * ax.dtick;
	        } else {
	            // otherwise start half an integer down regardless of
	            // the bin size, just enough to clear up endpoint
	            // ambiguity about which integers are in which bins.
	
	            binStart -= 0.5;
	            if(binStart + ax.dtick < dataMin) binStart += ax.dtick;
	        }
	    } else if(midcount < dataCount * 0.1) {
	        if(edgecount > dataCount * 0.3 ||
	                nearEdge(dataMin) || nearEdge(dataMax)) {
	            // lots of points at the edge, not many in the middle
	            // shift half a bin
	            var binshift = ax.dtick / 2;
	            binStart += (binStart + binshift < dataMin) ? binshift : -binshift;
	        }
	    }
	    return binStart;
	}
	
	
	function autoShiftMonthBins(binStart, data, dtick, dataMin, calendar) {
	    var stats = Lib.findExactDates(data, calendar);
	    // number of data points that needs to be an exact value
	    // to shift that increment to (near) the bin center
	    var threshold = 0.8;
	
	    if(stats.exactDays > threshold) {
	        var numMonths = Number(dtick.substr(1));
	
	        if((stats.exactYears > threshold) && (numMonths % 12 === 0)) {
	            // The exact middle of a non-leap-year is 1.5 days into July
	            // so if we start the bins here, all but leap years will
	            // get hover-labeled as exact years.
	            binStart = axes.tickIncrement(binStart, 'M6', 'reverse') + ONEDAY * 1.5;
	        } else if(stats.exactMonths > threshold) {
	            // Months are not as clean, but if we shift half the *longest*
	            // month (31/2 days) then 31-day months will get labeled exactly
	            // and shorter months will get labeled with the correct month
	            // but shifted 12-36 hours into it.
	            binStart = axes.tickIncrement(binStart, 'M1', 'reverse') + ONEDAY * 15.5;
	        } else {
	            // Shifting half a day is exact, but since these are month bins it
	            // will always give a somewhat odd-looking label, until we do something
	            // smarter like showing the bin boundaries (or the bounds of the actual
	            // data in each bin)
	            binStart -= ONEDAY / 2;
	        }
	        var nextBinStart = axes.tickIncrement(binStart, dtick);
	
	        if(nextBinStart <= dataMin) return nextBinStart;
	    }
	    return binStart;
	}
	
	// ----------------------------------------------------
	// Ticks and grids
	// ----------------------------------------------------
	
	// ensure we have tick0, dtick, and tick rounding calculated
	axes.prepTicks = function(ax) {
	    var rng = Lib.simpleMap(ax.range, ax.r2l);
	
	    // calculate max number of (auto) ticks to display based on plot size
	    if(ax.tickmode === 'auto' || !ax.dtick) {
	        var nt = ax.nticks;
	        var minPx;
	
	        if(!nt) {
	            if(ax.type === 'category' || ax.type === 'multicategory') {
	                minPx = ax.tickfont ? (ax.tickfont.size || 12) * 1.2 : 15;
	                nt = ax._length / minPx;
	            } else {
	                minPx = ax._id.charAt(0) === 'y' ? 40 : 80;
	                nt = Lib.constrain(ax._length / minPx, 4, 9) + 1;
	            }
	
	            // radial axes span half their domain,
	            // multiply nticks value by two to get correct number of auto ticks.
	            if(ax._name === 'radialaxis') nt *= 2;
	        }
	
	        // add a couple of extra digits for filling in ticks when we
	        // have explicit tickvals without tick text
	        if(ax.tickmode === 'array') nt *= 100;
	
	        axes.autoTicks(ax, Math.abs(rng[1] - rng[0]) / nt);
	        // check for a forced minimum dtick
	        if(ax._minDtick > 0 && ax.dtick < ax._minDtick * 2) {
	            ax.dtick = ax._minDtick;
	            ax.tick0 = ax.l2r(ax._forceTick0);
	        }
	    }
	
	    // check for missing tick0
	    if(!ax.tick0) {
	        ax.tick0 = (ax.type === 'date') ? '2000-01-01' : 0;
	    }
	
	    // ensure we don't try to make ticks below our minimum precision
	    // see https://github.com/plotly/plotly.js/issues/2892
	    if(ax.type === 'date' && ax.dtick < 0.1) ax.dtick = 0.1;
	
	    // now figure out rounding of tick values
	    autoTickRound(ax);
	};
	
	// calculate the ticks: text, values, positioning
	// if ticks are set to automatic, determine the right values (tick0,dtick)
	// in any case, set tickround to # of digits to round tick labels to,
	// or codes to this effect for log and date scales
	axes.calcTicks = function calcTicks(ax) {
	    axes.prepTicks(ax);
	    var rng = Lib.simpleMap(ax.range, ax.r2l);
	
	    // now that we've figured out the auto values for formatting
	    // in case we're missing some ticktext, we can break out for array ticks
	    if(ax.tickmode === 'array') return arrayTicks(ax);
	
	    // find the first tick
	    ax._tmin = axes.tickFirst(ax);
	
	    // add a tiny bit so we get ticks which may have rounded out
	    var startTick = rng[0] * 1.0001 - rng[1] * 0.0001;
	    var endTick = rng[1] * 1.0001 - rng[0] * 0.0001;
	    // check for reversed axis
	    var axrev = (rng[1] < rng[0]);
	
	    // No visible ticks? Quit.
	    // I've only seen this on category axes with all categories off the edge.
	    if((ax._tmin < startTick) !== axrev) return [];
	
	    // return the full set of tick vals
	    var tickVals = [];
	    if(ax.type === 'category' || ax.type === 'multicategory') {
	        endTick = (axrev) ? Math.max(-0.5, endTick) :
	            Math.min(ax._categories.length - 0.5, endTick);
	    }
	
	    var isDLog = (ax.type === 'log') && !(isNumeric(ax.dtick) || ax.dtick.charAt(0) === 'L');
	
	    var xPrevious = null;
	    var maxTicks = Math.max(1000, ax._length || 0);
	    for(var x = ax._tmin;
	            (axrev) ? (x >= endTick) : (x <= endTick);
	            x = axes.tickIncrement(x, ax.dtick, axrev, ax.calendar)) {
	        // prevent infinite loops - no more than one tick per pixel,
	        // and make sure each value is different from the previous
	        if(tickVals.length > maxTicks || x === xPrevious) break;
	        xPrevious = x;
	
	        var minor = false;
	        if(isDLog && (x !== (x | 0))) {
	            minor = true;
	        }
	
	        tickVals.push({
	            minor: minor,
	            value: x
	        });
	    }
	
	    // If same angle over a full circle, the last tick vals is a duplicate.
	    // TODO must do something similar for angular date axes.
	    if(isAngular(ax) && Math.abs(rng[1] - rng[0]) === 360) {
	        tickVals.pop();
	    }
	
	    // save the last tick as well as first, so we can
	    // show the exponent only on the last one
	    ax._tmax = (tickVals[tickVals.length - 1] || {}).value;
	
	    // for showing the rest of a date when the main tick label is only the
	    // latter part: ax._prevDateHead holds what we showed most recently.
	    // Start with it cleared and mark that we're in calcTicks (ie calculating a
	    // whole string of these so we should care what the previous date head was!)
	    ax._prevDateHead = '';
	    ax._inCalcTicks = true;
	
	    var ticksOut = new Array(tickVals.length);
	    for(var i = 0; i < tickVals.length; i++) {
	        ticksOut[i] = axes.tickText(
	            ax,
	            tickVals[i].value,
	            false, // hover
	            tickVals[i].minor // noSuffixPrefix
	        );
	    }
	
	    ax._inCalcTicks = false;
	
	    return ticksOut;
	};
	
	function arrayTicks(ax) {
	    var vals = ax.tickvals;
	    var text = ax.ticktext;
	    var ticksOut = new Array(vals.length);
	    var rng = Lib.simpleMap(ax.range, ax.r2l);
	    var r0expanded = rng[0] * 1.0001 - rng[1] * 0.0001;
	    var r1expanded = rng[1] * 1.0001 - rng[0] * 0.0001;
	    var tickMin = Math.min(r0expanded, r1expanded);
	    var tickMax = Math.max(r0expanded, r1expanded);
	    var j = 0;
	
	    // without a text array, just format the given values as any other ticks
	    // except with more precision to the numbers
	    if(!Array.isArray(text)) text = [];
	
	    // make sure showing ticks doesn't accidentally add new categories
	    // TODO multicategory, if we allow ticktext / tickvals
	    var tickVal2l = ax.type === 'category' ? ax.d2l_noadd : ax.d2l;
	
	    // array ticks on log axes always show the full number
	    // (if no explicit ticktext overrides it)
	    if(ax.type === 'log' && String(ax.dtick).charAt(0) !== 'L') {
	        ax.dtick = 'L' + Math.pow(10, Math.floor(Math.min(ax.range[0], ax.range[1])) - 1);
	    }
	
	    for(var i = 0; i < vals.length; i++) {
	        var vali = tickVal2l(vals[i]);
	        if(vali > tickMin && vali < tickMax) {
	            if(text[i] === undefined) ticksOut[j] = axes.tickText(ax, vali);
	            else ticksOut[j] = tickTextObj(ax, vali, String(text[i]));
	            j++;
	        }
	    }
	
	    if(j < vals.length) ticksOut.splice(j, vals.length - j);
	
	    return ticksOut;
	}
	
	var roundBase10 = [2, 5, 10];
	var roundBase24 = [1, 2, 3, 6, 12];
	var roundBase60 = [1, 2, 5, 10, 15, 30];
	// 2&3 day ticks are weird, but need something btwn 1&7
	var roundDays = [1, 2, 3, 7, 14];
	// approx. tick positions for log axes, showing all (1) and just 1, 2, 5 (2)
	// these don't have to be exact, just close enough to round to the right value
	var roundLog1 = [-0.046, 0, 0.301, 0.477, 0.602, 0.699, 0.778, 0.845, 0.903, 0.954, 1];
	var roundLog2 = [-0.301, 0, 0.301, 0.699, 1];
	// N.B. `thetaunit; 'radians' angular axes must be converted to degrees
	var roundAngles = [15, 30, 45, 90, 180];
	
	function roundDTick(roughDTick, base, roundingSet) {
	    return base * Lib.roundUp(roughDTick / base, roundingSet);
	}
	
	// autoTicks: calculate best guess at pleasant ticks for this axis
	// inputs:
	//      ax - an axis object
	//      roughDTick - rough tick spacing (to be turned into a nice round number)
	// outputs (into ax):
	//   tick0: starting point for ticks (not necessarily on the graph)
	//      usually 0 for numeric (=10^0=1 for log) or jan 1, 2000 for dates
	//   dtick: the actual, nice round tick spacing, usually a little larger than roughDTick
	//      if the ticks are spaced linearly (linear scale, categories,
	//          log with only full powers, date ticks < month),
	//          this will just be a number
	//      months: M#
	//      years: M# where # is 12*number of years
	//      log with linear ticks: L# where # is the linear tick spacing
	//      log showing powers plus some intermediates:
	//          D1 shows all digits, D2 shows 2 and 5
	axes.autoTicks = function(ax, roughDTick) {
	    var base;
	
	    function getBase(v) {
	        return Math.pow(v, Math.floor(Math.log(roughDTick) / Math.LN10));
	    }
	
	    if(ax.type === 'date') {
	        ax.tick0 = Lib.dateTick0(ax.calendar);
	        // the criteria below are all based on the rough spacing we calculate
	        // being > half of the final unit - so precalculate twice the rough val
	        var roughX2 = 2 * roughDTick;
	
	        if(roughX2 > ONEAVGYEAR) {
	            roughDTick /= ONEAVGYEAR;
	            base = getBase(10);
	            ax.dtick = 'M' + (12 * roundDTick(roughDTick, base, roundBase10));
	        } else if(roughX2 > ONEAVGMONTH) {
	            roughDTick /= ONEAVGMONTH;
	            ax.dtick = 'M' + roundDTick(roughDTick, 1, roundBase24);
	        } else if(roughX2 > ONEDAY) {
	            ax.dtick = roundDTick(roughDTick, ONEDAY, roundDays);
	            // get week ticks on sunday
	            // this will also move the base tick off 2000-01-01 if dtick is
	            // 2 or 3 days... but that's a weird enough case that we'll ignore it.
	            ax.tick0 = Lib.dateTick0(ax.calendar, true);
	        } else if(roughX2 > ONEHOUR) {
	            ax.dtick = roundDTick(roughDTick, ONEHOUR, roundBase24);
	        } else if(roughX2 > ONEMIN) {
	            ax.dtick = roundDTick(roughDTick, ONEMIN, roundBase60);
	        } else if(roughX2 > ONESEC) {
	            ax.dtick = roundDTick(roughDTick, ONESEC, roundBase60);
	        } else {
	            // milliseconds
	            base = getBase(10);
	            ax.dtick = roundDTick(roughDTick, base, roundBase10);
	        }
	    } else if(ax.type === 'log') {
	        ax.tick0 = 0;
	        var rng = Lib.simpleMap(ax.range, ax.r2l);
	
	        if(roughDTick > 0.7) {
	            // only show powers of 10
	            ax.dtick = Math.ceil(roughDTick);
	        } else if(Math.abs(rng[1] - rng[0]) < 1) {
	            // span is less than one power of 10
	            var nt = 1.5 * Math.abs((rng[1] - rng[0]) / roughDTick);
	
	            // ticks on a linear scale, labeled fully
	            roughDTick = Math.abs(Math.pow(10, rng[1]) -
	                Math.pow(10, rng[0])) / nt;
	            base = getBase(10);
	            ax.dtick = 'L' + roundDTick(roughDTick, base, roundBase10);
	        } else {
	            // include intermediates between powers of 10,
	            // labeled with small digits
	            // ax.dtick = "D2" (show 2 and 5) or "D1" (show all digits)
	            ax.dtick = (roughDTick > 0.3) ? 'D2' : 'D1';
	        }
	    } else if(ax.type === 'category' || ax.type === 'multicategory') {
	        ax.tick0 = 0;
	        ax.dtick = Math.ceil(Math.max(roughDTick, 1));
	    } else if(isAngular(ax)) {
	        ax.tick0 = 0;
	        base = 1;
	        ax.dtick = roundDTick(roughDTick, base, roundAngles);
	    } else {
	        // auto ticks always start at 0
	        ax.tick0 = 0;
	        base = getBase(10);
	        ax.dtick = roundDTick(roughDTick, base, roundBase10);
	    }
	
	    // prevent infinite loops
	    if(ax.dtick === 0) ax.dtick = 1;
	
	    // TODO: this is from log axis histograms with autorange off
	    if(!isNumeric(ax.dtick) && typeof ax.dtick !== 'string') {
	        var olddtick = ax.dtick;
	        ax.dtick = 1;
	        throw 'ax.dtick error: ' + String(olddtick);
	    }
	};
	
	// after dtick is already known, find tickround = precision
	// to display in tick labels
	//   for numeric ticks, integer # digits after . to round to
	//   for date ticks, the last date part to show (y,m,d,H,M,S)
	//      or an integer # digits past seconds
	function autoTickRound(ax) {
	    var dtick = ax.dtick;
	
	    ax._tickexponent = 0;
	    if(!isNumeric(dtick) && typeof dtick !== 'string') {
	        dtick = 1;
	    }
	
	    if(ax.type === 'category' || ax.type === 'multicategory') {
	        ax._tickround = null;
	    }
	    if(ax.type === 'date') {
	        // If tick0 is unusual, give tickround a bit more information
	        // not necessarily *all* the information in tick0 though, if it's really odd
	        // minimal string length for tick0: 'd' is 10, 'M' is 16, 'S' is 19
	        // take off a leading minus (year < 0) and i (intercalary month) so length is consistent
	        var tick0ms = ax.r2l(ax.tick0);
	        var tick0str = ax.l2r(tick0ms).replace(/(^-|i)/g, '');
	        var tick0len = tick0str.length;
	
	        if(String(dtick).charAt(0) === 'M') {
	            // any tick0 more specific than a year: alway show the full date
	            if(tick0len > 10 || tick0str.substr(5) !== '01-01') ax._tickround = 'd';
	            // show the month unless ticks are full multiples of a year
	            else ax._tickround = (+(dtick.substr(1)) % 12 === 0) ? 'y' : 'm';
	        } else if((dtick >= ONEDAY && tick0len <= 10) || (dtick >= ONEDAY * 15)) ax._tickround = 'd';
	        else if((dtick >= ONEMIN && tick0len <= 16) || (dtick >= ONEHOUR)) ax._tickround = 'M';
	        else if((dtick >= ONESEC && tick0len <= 19) || (dtick >= ONEMIN)) ax._tickround = 'S';
	        else {
	            // tickround is a number of digits of fractional seconds
	            // of any two adjacent ticks, at least one will have the maximum fractional digits
	            // of all possible ticks - so take the max. length of tick0 and the next one
	            var tick1len = ax.l2r(tick0ms + dtick).replace(/^-/, '').length;
	            ax._tickround = Math.max(tick0len, tick1len) - 20;
	
	            // We shouldn't get here... but in case there's a situation I'm
	            // not thinking of where tick0str and tick1str are identical or
	            // something, fall back on maximum precision
	            if(ax._tickround < 0) ax._tickround = 4;
	        }
	    } else if(isNumeric(dtick) || dtick.charAt(0) === 'L') {
	        // linear or log (except D1, D2)
	        var rng = ax.range.map(ax.r2d || Number);
	        if(!isNumeric(dtick)) dtick = Number(dtick.substr(1));
	        // 2 digits past largest digit of dtick
	        ax._tickround = 2 - Math.floor(Math.log(dtick) / Math.LN10 + 0.01);
	
	        var maxend = Math.max(Math.abs(rng[0]), Math.abs(rng[1]));
	        var rangeexp = Math.floor(Math.log(maxend) / Math.LN10 + 0.01);
	        if(Math.abs(rangeexp) > 3) {
	            if(isSIFormat(ax.exponentformat) && !beyondSI(rangeexp)) {
	                ax._tickexponent = 3 * Math.round((rangeexp - 1) / 3);
	            } else ax._tickexponent = rangeexp;
	        }
	    } else {
	        // D1 or D2 (log)
	        ax._tickround = null;
	    }
	}
	
	// months and years don't have constant millisecond values
	// (but a year is always 12 months so we only need months)
	// log-scale ticks are also not consistently spaced, except
	// for pure powers of 10
	// numeric ticks always have constant differences, other datetime ticks
	// can all be calculated as constant number of milliseconds
	axes.tickIncrement = function(x, dtick, axrev, calendar) {
	    var axSign = axrev ? -1 : 1;
	
	    // includes linear, all dates smaller than month, and pure 10^n in log
	    if(isNumeric(dtick)) return x + axSign * dtick;
	
	    // everything else is a string, one character plus a number
	    var tType = dtick.charAt(0);
	    var dtSigned = axSign * Number(dtick.substr(1));
	
	    // Dates: months (or years - see Lib.incrementMonth)
	    if(tType === 'M') return Lib.incrementMonth(x, dtSigned, calendar);
	
	    // Log scales: Linear, Digits
	    else if(tType === 'L') return Math.log(Math.pow(10, x) + dtSigned) / Math.LN10;
	
	    // log10 of 2,5,10, or all digits (logs just have to be
	    // close enough to round)
	    else if(tType === 'D') {
	        var tickset = (dtick === 'D2') ? roundLog2 : roundLog1;
	        var x2 = x + axSign * 0.01;
	        var frac = Lib.roundUp(Lib.mod(x2, 1), tickset, axrev);
	
	        return Math.floor(x2) +
	            Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
	    } else throw 'unrecognized dtick ' + String(dtick);
	};
	
	// calculate the first tick on an axis
	axes.tickFirst = function(ax) {
	    var r2l = ax.r2l || Number;
	    var rng = Lib.simpleMap(ax.range, r2l);
	    var axrev = rng[1] < rng[0];
	    var sRound = axrev ? Math.floor : Math.ceil;
	    // add a tiny extra bit to make sure we get ticks
	    // that may have been rounded out
	    var r0 = rng[0] * 1.0001 - rng[1] * 0.0001;
	    var dtick = ax.dtick;
	    var tick0 = r2l(ax.tick0);
	
	    if(isNumeric(dtick)) {
	        var tmin = sRound((r0 - tick0) / dtick) * dtick + tick0;
	
	        // make sure no ticks outside the category list
	        if(ax.type === 'category' || ax.type === 'multicategory') {
	            tmin = Lib.constrain(tmin, 0, ax._categories.length - 1);
	        }
	        return tmin;
	    }
	
	    var tType = dtick.charAt(0);
	    var dtNum = Number(dtick.substr(1));
	
	    // Dates: months (or years)
	    if(tType === 'M') {
	        var cnt = 0;
	        var t0 = tick0;
	        var t1, mult, newDTick;
	
	        // This algorithm should work for *any* nonlinear (but close to linear!)
	        // tick spacing. Limit to 10 iterations, for gregorian months it's normally <=3.
	        while(cnt < 10) {
	            t1 = axes.tickIncrement(t0, dtick, axrev, ax.calendar);
	            if((t1 - r0) * (t0 - r0) <= 0) {
	                // t1 and t0 are on opposite sides of r0! we've succeeded!
	                if(axrev) return Math.min(t0, t1);
	                return Math.max(t0, t1);
	            }
	            mult = (r0 - ((t0 + t1) / 2)) / (t1 - t0);
	            newDTick = tType + ((Math.abs(Math.round(mult)) || 1) * dtNum);
	            t0 = axes.tickIncrement(t0, newDTick, mult < 0 ? !axrev : axrev, ax.calendar);
	            cnt++;
	        }
	        Lib.error('tickFirst did not converge', ax);
	        return t0;
	    } else if(tType === 'L') {
	        // Log scales: Linear, Digits
	
	        return Math.log(sRound(
	            (Math.pow(10, r0) - tick0) / dtNum) * dtNum + tick0) / Math.LN10;
	    } else if(tType === 'D') {
	        var tickset = (dtick === 'D2') ? roundLog2 : roundLog1;
	        var frac = Lib.roundUp(Lib.mod(r0, 1), tickset, axrev);
	
	        return Math.floor(r0) +
	            Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
	    } else throw 'unrecognized dtick ' + String(dtick);
	};
	
	// draw the text for one tick.
	// px,py are the location on gd.paper
	// prefix is there so the x axis ticks can be dropped a line
	// ax is the axis layout, x is the tick value
	// hover is a (truthy) flag for whether to show numbers with a bit
	// more precision for hovertext
	axes.tickText = function(ax, x, hover, noSuffixPrefix) {
	    var out = tickTextObj(ax, x);
	    var arrayMode = ax.tickmode === 'array';
	    var extraPrecision = hover || arrayMode;
	    var axType = ax.type;
	    // TODO multicategory, if we allow ticktext / tickvals
	    var tickVal2l = axType === 'category' ? ax.d2l_noadd : ax.d2l;
	    var i;
	
	    if(arrayMode && Array.isArray(ax.ticktext)) {
	        var rng = Lib.simpleMap(ax.range, ax.r2l);
	        var minDiff = Math.abs(rng[1] - rng[0]) / 10000;
	
	        for(i = 0; i < ax.ticktext.length; i++) {
	            if(Math.abs(x - tickVal2l(ax.tickvals[i])) < minDiff) break;
	        }
	        if(i < ax.ticktext.length) {
	            out.text = String(ax.ticktext[i]);
	            return out;
	        }
	    }
	
	    function isHidden(showAttr) {
	        if(showAttr === undefined) return true;
	        if(hover) return showAttr === 'none';
	
	        var firstOrLast = {
	            first: ax._tmin,
	            last: ax._tmax
	        }[showAttr];
	
	        return showAttr !== 'all' && x !== firstOrLast;
	    }
	
	    var hideexp = hover ?
	        'never' :
	        ax.exponentformat !== 'none' && isHidden(ax.showexponent) ? 'hide' : '';
	
	    if(axType === 'date') formatDate(ax, out, hover, extraPrecision);
	    else if(axType === 'log') formatLog(ax, out, hover, extraPrecision, hideexp);
	    else if(axType === 'category') formatCategory(ax, out);
	    else if(axType === 'multicategory') formatMultiCategory(ax, out, hover);
	    else if(isAngular(ax)) formatAngle(ax, out, hover, extraPrecision, hideexp);
	    else formatLinear(ax, out, hover, extraPrecision, hideexp);
	
	    // add prefix and suffix
	    if(!noSuffixPrefix) {
	        if(ax.tickprefix && !isHidden(ax.showtickprefix)) out.text = ax.tickprefix + out.text;
	        if(ax.ticksuffix && !isHidden(ax.showticksuffix)) out.text += ax.ticksuffix;
	    }
	
	    // Setup ticks and grid lines boundaries
	    // at 1/2 a 'category' to the left/bottom
	    if(ax.tickson === 'boundaries' || ax.showdividers) {
	        var inbounds = function(v) {
	            var p = ax.l2p(v);
	            return p >= 0 && p <= ax._length ? v : null;
	        };
	
	        out.xbnd = [
	            inbounds(out.x - 0.5),
	            inbounds(out.x + ax.dtick - 0.5)
	        ];
	    }
	
	    return out;
	};
	
	/**
	 * create text for a hover label on this axis, with special handling of
	 * log axes (where negative values can't be displayed but can appear in hover text)
	 *
	 * @param {object} ax: the axis to format text for
	 * @param {number} val: calcdata value to format
	 * @param {Optional(number)} val2: a second value to display
	 *
	 * @returns {string} `val` formatted as a string appropriate to this axis, or
	 *     `val` and `val2` as a range (ie '<val> - <val2>') if `val2` is provided and
	 *     it's different from `val`.
	 */
	axes.hoverLabelText = function(ax, val, val2) {
	    if(val2 !== BADNUM && val2 !== val) {
	        return axes.hoverLabelText(ax, val) + ' - ' + axes.hoverLabelText(ax, val2);
	    }
	
	    var logOffScale = (ax.type === 'log' && val <= 0);
	    var tx = axes.tickText(ax, ax.c2l(logOffScale ? -val : val), 'hover').text;
	
	    if(logOffScale) {
	        return val === 0 ? '0' : MINUS_SIGN + tx;
	    }
	
	    // TODO: should we do something special if the axis calendar and
	    // the data calendar are different? Somehow display both dates with
	    // their system names? Right now it will just display in the axis calendar
	    // but users could add the other one as text.
	    return tx;
	};
	
	function tickTextObj(ax, x, text) {
	    var tf = ax.tickfont || {};
	
	    return {
	        x: x,
	        dx: 0,
	        dy: 0,
	        text: text || '',
	        fontSize: tf.size,
	        font: tf.family,
	        fontColor: tf.color
	    };
	}
	
	function formatDate(ax, out, hover, extraPrecision) {
	    var tr = ax._tickround;
	    var fmt = (hover && ax.hoverformat) || axes.getTickFormat(ax);
	
	    if(extraPrecision) {
	        // second or sub-second precision: extra always shows max digits.
	        // for other fields, extra precision just adds one field.
	        if(isNumeric(tr)) tr = 4;
	        else tr = {y: 'm', m: 'd', d: 'M', M: 'S', S: 4}[tr];
	    }
	
	    var dateStr = Lib.formatDate(out.x, fmt, tr, ax._dateFormat, ax.calendar, ax._extraFormat);
	    var headStr;
	
	    var splitIndex = dateStr.indexOf('\n');
	    if(splitIndex !== -1) {
	        headStr = dateStr.substr(splitIndex + 1);
	        dateStr = dateStr.substr(0, splitIndex);
	    }
	
	    if(extraPrecision) {
	        // if extraPrecision led to trailing zeros, strip them off
	        // actually, this can lead to removing even more zeros than
	        // in the original rounding, but that's fine because in these
	        // contexts uniformity is not so important (if there's even
	        // anything to be uniform with!)
	
	        // can we remove the whole time part?
	        if(dateStr === '00:00:00' || dateStr === '00:00') {
	            dateStr = headStr;
	            headStr = '';
	        } else if(dateStr.length === 8) {
	            // strip off seconds if they're zero (zero fractional seconds
	            // are already omitted)
	            // but we never remove minutes and leave just hours
	            dateStr = dateStr.replace(/:00$/, '');
	        }
	    }
	
	    if(headStr) {
	        if(hover) {
	            // hover puts it all on one line, so headPart works best up front
	            // except for year headPart: turn this into "Jan 1, 2000" etc.
	            if(tr === 'd') dateStr += ', ' + headStr;
	            else dateStr = headStr + (dateStr ? ', ' + dateStr : '');
	        } else if(!ax._inCalcTicks || (headStr !== ax._prevDateHead)) {
	            dateStr += '<br>' + headStr;
	            ax._prevDateHead = headStr;
	        }
	    }
	
	    out.text = dateStr;
	}
	
	function formatLog(ax, out, hover, extraPrecision, hideexp) {
	    var dtick = ax.dtick;
	    var x = out.x;
	    var tickformat = ax.tickformat;
	    var dtChar0 = typeof dtick === 'string' && dtick.charAt(0);
	
	    if(hideexp === 'never') {
	        // If this is a hover label, then we must *never* hide the exponent
	        // for the sake of display, which could give the wrong value by
	        // potentially many orders of magnitude. If hideexp was 'never', then
	        // it's now succeeded by preventing the other condition from automating
	        // this choice. Thus we can unset it so that the axis formatting takes
	        // precedence.
	        hideexp = '';
	    }
	
	    if(extraPrecision && (dtChar0 !== 'L')) {
	        dtick = 'L3';
	        dtChar0 = 'L';
	    }
	
	    if(tickformat || (dtChar0 === 'L')) {
	        out.text = numFormat(Math.pow(10, x), ax, hideexp, extraPrecision);
	    } else if(isNumeric(dtick) || ((dtChar0 === 'D') && (Lib.mod(x + 0.01, 1) < 0.1))) {
	        var p = Math.round(x);
	        var absP = Math.abs(p);
	        var exponentFormat = ax.exponentformat;
	        if(exponentFormat === 'power' || (isSIFormat(exponentFormat) && beyondSI(p))) {
	            if(p === 0) out.text = 1;
	            else if(p === 1) out.text = '10';
	            else out.text = '10<sup>' + (p > 1 ? '' : MINUS_SIGN) + absP + '</sup>';
	
	            out.fontSize *= 1.25;
	        } else if((exponentFormat === 'e' || exponentFormat === 'E') && absP > 2) {
	            out.text = '1' + exponentFormat + (p > 0 ? '+' : MINUS_SIGN) + absP;
	        } else {
	            out.text = numFormat(Math.pow(10, x), ax, '', 'fakehover');
	            if(dtick === 'D1' && ax._id.charAt(0) === 'y') {
	                out.dy -= out.fontSize / 6;
	            }
	        }
	    } else if(dtChar0 === 'D') {
	        out.text = String(Math.round(Math.pow(10, Lib.mod(x, 1))));
	        out.fontSize *= 0.75;
	    } else throw 'unrecognized dtick ' + String(dtick);
	
	    // if 9's are printed on log scale, move the 10's away a bit
	    if(ax.dtick === 'D1') {
	        var firstChar = String(out.text).charAt(0);
	        if(firstChar === '0' || firstChar === '1') {
	            if(ax._id.charAt(0) === 'y') {
	                out.dx -= out.fontSize / 4;
	            } else {
	                out.dy += out.fontSize / 2;
	                out.dx += (ax.range[1] > ax.range[0] ? 1 : -1) *
	                    out.fontSize * (x < 0 ? 0.5 : 0.25);
	            }
	        }
	    }
	}
	
	function formatCategory(ax, out) {
	    var tt = ax._categories[Math.round(out.x)];
	    if(tt === undefined) tt = '';
	    out.text = String(tt);
	}
	
	function formatMultiCategory(ax, out, hover) {
	    var v = Math.round(out.x);
	    var cats = ax._categories[v] || [];
	    var tt = cats[1] === undefined ? '' : String(cats[1]);
	    var tt2 = cats[0] === undefined ? '' : String(cats[0]);
	
	    if(hover) {
	        // TODO is this what we want?
	        out.text = tt2 + ' - ' + tt;
	    } else {
	        // setup for secondary labels
	        out.text = tt;
	        out.text2 = tt2;
	    }
	}
	
	function formatLinear(ax, out, hover, extraPrecision, hideexp) {
	    if(hideexp === 'never') {
	        // If this is a hover label, then we must *never* hide the exponent
	        // for the sake of display, which could give the wrong value by
	        // potentially many orders of magnitude. If hideexp was 'never', then
	        // it's now succeeded by preventing the other condition from automating
	        // this choice. Thus we can unset it so that the axis formatting takes
	        // precedence.
	        hideexp = '';
	    } else if(ax.showexponent === 'all' && Math.abs(out.x / ax.dtick) < 1e-6) {
	        // don't add an exponent to zero if we're showing all exponents
	        // so the only reason you'd show an exponent on zero is if it's the
	        // ONLY tick to get an exponent (first or last)
	        hideexp = 'hide';
	    }
	    out.text = numFormat(out.x, ax, hideexp, extraPrecision);
	}
	
	function formatAngle(ax, out, hover, extraPrecision, hideexp) {
	    if(ax.thetaunit === 'radians' && !hover) {
	        var num = out.x / 180;
	
	        if(num === 0) {
	            out.text = '0';
	        } else {
	            var frac = num2frac(num);
	
	            if(frac[1] >= 100) {
	                out.text = numFormat(Lib.deg2rad(out.x), ax, hideexp, extraPrecision);
	            } else {
	                var isNeg = out.x < 0;
	
	                if(frac[1] === 1) {
	                    if(frac[0] === 1) out.text = 'π';
	                    else out.text = frac[0] + 'π';
	                } else {
	                    out.text = [
	                        '<sup>', frac[0], '</sup>',
	                        '⁄',
	                        '<sub>', frac[1], '</sub>',
	                        'π'
	                    ].join('');
	                }
	
	                if(isNeg) out.text = MINUS_SIGN + out.text;
	            }
	        }
	    } else {
	        out.text = numFormat(out.x, ax, hideexp, extraPrecision);
	    }
	}
	
	// inspired by
	// https://github.com/yisibl/num2fraction/blob/master/index.js
	function num2frac(num) {
	    function almostEq(a, b) {
	        return Math.abs(a - b) <= 1e-6;
	    }
	
	    function findGCD(a, b) {
	        return almostEq(b, 0) ? a : findGCD(b, a % b);
	    }
	
	    function findPrecision(n) {
	        var e = 1;
	        while(!almostEq(Math.round(n * e) / e, n)) {
	            e *= 10;
	        }
	        return e;
	    }
	
	    var precision = findPrecision(num);
	    var number = num * precision;
	    var gcd = Math.abs(findGCD(number, precision));
	
	    return [
	        // numerator
	        Math.round(number / gcd),
	        // denominator
	        Math.round(precision / gcd)
	    ];
	}
	
	// format a number (tick value) according to the axis settings
	// new, more reliable procedure than d3.round or similar:
	// add half the rounding increment, then stringify and truncate
	// also automatically switch to sci. notation
	var SIPREFIXES = ['f', 'p', 'n', 'μ', 'm', '', 'k', 'M', 'G', 'T'];
	
	function isSIFormat(exponentFormat) {
	    return exponentFormat === 'SI' || exponentFormat === 'B';
	}
	
	// are we beyond the range of common SI prefixes?
	// 10^-16 -> 1x10^-16
	// 10^-15 -> 1f
	// ...
	// 10^14 -> 100T
	// 10^15 -> 1x10^15
	// 10^16 -> 1x10^16
	function beyondSI(exponent) {
	    return exponent > 14 || exponent < -15;
	}
	
	function numFormat(v, ax, fmtoverride, hover) {
	    var isNeg = v < 0;
	    // max number of digits past decimal point to show
	    var tickRound = ax._tickround;
	    var exponentFormat = fmtoverride || ax.exponentformat || 'B';
	    var exponent = ax._tickexponent;
	    var tickformat = axes.getTickFormat(ax);
	    var separatethousands = ax.separatethousands;
	
	    // special case for hover: set exponent just for this value, and
	    // add a couple more digits of precision over tick labels
	    if(hover) {
	        // make a dummy axis obj to get the auto rounding and exponent
	        var ah = {
	            exponentformat: exponentFormat,
	            dtick: ax.showexponent === 'none' ? ax.dtick :
	                (isNumeric(v) ? Math.abs(v) || 1 : 1),
	            // if not showing any exponents, don't change the exponent
	            // from what we calculate
	            range: ax.showexponent === 'none' ? ax.range.map(ax.r2d) : [0, v || 1]
	        };
	        autoTickRound(ah);
	        tickRound = (Number(ah._tickround) || 0) + 4;
	        exponent = ah._tickexponent;
	        if(ax.hoverformat) tickformat = ax.hoverformat;
	    }
	
	    if(tickformat) return ax._numFormat(tickformat)(v).replace(/-/g, MINUS_SIGN);
	
	    // 'epsilon' - rounding increment
	    var e = Math.pow(10, -tickRound) / 2;
	
	    // exponentFormat codes:
	    // 'e' (1.2e+6, default)
	    // 'E' (1.2E+6)
	    // 'SI' (1.2M)
	    // 'B' (same as SI except 10^9=B not G)
	    // 'none' (1200000)
	    // 'power' (1.2x10^6)
	    // 'hide' (1.2, use 3rd argument=='hide' to eg
	    //      only show exponent on last tick)
	    if(exponentFormat === 'none') exponent = 0;
	
	    // take the sign out, put it back manually at the end
	    // - makes cases easier
	    v = Math.abs(v);
	    if(v < e) {
	        // 0 is just 0, but may get exponent if it's the last tick
	        v = '0';
	        isNeg = false;
	    } else {
	        v += e;
	        // take out a common exponent, if any
	        if(exponent) {
	            v *= Math.pow(10, -exponent);
	            tickRound += exponent;
	        }
	        // round the mantissa
	        if(tickRound === 0) v = String(Math.floor(v));
	        else if(tickRound < 0) {
	            v = String(Math.round(v));
	            v = v.substr(0, v.length + tickRound);
	            for(var i = tickRound; i < 0; i++) v += '0';
	        } else {
	            v = String(v);
	            var dp = v.indexOf('.') + 1;
	            if(dp) v = v.substr(0, dp + tickRound).replace(/\.?0+$/, '');
	        }
	        // insert appropriate decimal point and thousands separator
	        v = Lib.numSeparate(v, ax._separators, separatethousands);
	    }
	
	    // add exponent
	    if(exponent && exponentFormat !== 'hide') {
	        if(isSIFormat(exponentFormat) && beyondSI(exponent)) exponentFormat = 'power';
	
	        var signedExponent;
	        if(exponent < 0) signedExponent = MINUS_SIGN + -exponent;
	        else if(exponentFormat !== 'power') signedExponent = '+' + exponent;
	        else signedExponent = String(exponent);
	
	        if(exponentFormat === 'e' || exponentFormat === 'E') {
	            v += exponentFormat + signedExponent;
	        } else if(exponentFormat === 'power') {
	            v += '×10<sup>' + signedExponent + '</sup>';
	        } else if(exponentFormat === 'B' && exponent === 9) {
	            v += 'B';
	        } else if(isSIFormat(exponentFormat)) {
	            v += SIPREFIXES[exponent / 3 + 5];
	        }
	    }
	
	    // put sign back in and return
	    // replace standard minus character (which is technically a hyphen)
	    // with a true minus sign
	    if(isNeg) return MINUS_SIGN + v;
	    return v;
	}
	
	axes.getTickFormat = function(ax) {
	    var i;
	
	    function convertToMs(dtick) {
	        return typeof dtick !== 'string' ? dtick : Number(dtick.replace('M', '')) * ONEAVGMONTH;
	    }
	
	    function compareLogTicks(left, right) {
	        var priority = ['L', 'D'];
	        if(typeof left === typeof right) {
	            if(typeof left === 'number') {
	                return left - right;
	            } else {
	                var leftPriority = priority.indexOf(left.charAt(0));
	                var rightPriority = priority.indexOf(right.charAt(0));
	                if(leftPriority === rightPriority) {
	                    return Number(left.replace(/(L|D)/g, '')) - Number(right.replace(/(L|D)/g, ''));
	                } else {
	                    return leftPriority - rightPriority;
	                }
	            }
	        } else {
	            return typeof left === 'number' ? 1 : -1;
	        }
	    }
	
	    function isProperStop(dtick, range, convert) {
	        var convertFn = convert || function(x) { return x;};
	        var leftDtick = range[0];
	        var rightDtick = range[1];
	        return ((!leftDtick && typeof leftDtick !== 'number') || convertFn(leftDtick) <= convertFn(dtick)) &&
	               ((!rightDtick && typeof rightDtick !== 'number') || convertFn(rightDtick) >= convertFn(dtick));
	    }
	
	    function isProperLogStop(dtick, range) {
	        var isLeftDtickNull = range[0] === null;
	        var isRightDtickNull = range[1] === null;
	        var isDtickInRangeLeft = compareLogTicks(dtick, range[0]) >= 0;
	        var isDtickInRangeRight = compareLogTicks(dtick, range[1]) <= 0;
	        return (isLeftDtickNull || isDtickInRangeLeft) && (isRightDtickNull || isDtickInRangeRight);
	    }
	
	    var tickstop, stopi;
	    if(ax.tickformatstops && ax.tickformatstops.length > 0) {
	        switch(ax.type) {
	            case 'date':
	            case 'linear': {
	                for(i = 0; i < ax.tickformatstops.length; i++) {
	                    stopi = ax.tickformatstops[i];
	                    if(stopi.enabled && isProperStop(ax.dtick, stopi.dtickrange, convertToMs)) {
	                        tickstop = stopi;
	                        break;
	                    }
	                }
	                break;
	            }
	            case 'log': {
	                for(i = 0; i < ax.tickformatstops.length; i++) {
	                    stopi = ax.tickformatstops[i];
	                    if(stopi.enabled && isProperLogStop(ax.dtick, stopi.dtickrange)) {
	                        tickstop = stopi;
	                        break;
	                    }
	                }
	                break;
	            }
	            default:
	        }
	    }
	    return tickstop ? tickstop.value : ax.tickformat;
	};
	
	// getSubplots - extract all subplot IDs we need
	// as an array of items like 'xy', 'x2y', 'x2y2'...
	// sorted by x (x,x2,x3...) then y
	// optionally restrict to only subplots containing axis object ax
	//
	// NOTE: this is currently only used OUTSIDE plotly.js (toolpanel, webapp)
	// ideally we get rid of it there (or just copy this there) and remove it here
	axes.getSubplots = function(gd, ax) {
	    var subplotObj = gd._fullLayout._subplots;
	    var allSubplots = subplotObj.cartesian.concat(subplotObj.gl2d || []);
	
	    var out = ax ? axes.findSubplotsWithAxis(allSubplots, ax) : allSubplots;
	
	    out.sort(function(a, b) {
	        var aParts = a.substr(1).split('y');
	        var bParts = b.substr(1).split('y');
	
	        if(aParts[0] === bParts[0]) return +aParts[1] - +bParts[1];
	        return +aParts[0] - +bParts[0];
	    });
	
	    return out;
	};
	
	// find all subplots with axis 'ax'
	// NOTE: this is only used in axes.getSubplots (only used outside plotly.js) and
	// gl2d/convert (where it restricts axis subplots to only those with gl2d)
	axes.findSubplotsWithAxis = function(subplots, ax) {
	    var axMatch = new RegExp(
	        (ax._id.charAt(0) === 'x') ? ('^' + ax._id + 'y') : (ax._id + '$')
	    );
	    var subplotsWithAx = [];
	
	    for(var i = 0; i < subplots.length; i++) {
	        var sp = subplots[i];
	        if(axMatch.test(sp)) subplotsWithAx.push(sp);
	    }
	
	    return subplotsWithAx;
	};
	
	// makeClipPaths: prepare clipPaths for all single axes and all possible xy pairings
	axes.makeClipPaths = function(gd) {
	    var fullLayout = gd._fullLayout;
	
	    // for more info: https://github.com/plotly/plotly.js/issues/2595
	    if(fullLayout._hasOnlyLargeSploms) return;
	
	    var fullWidth = {_offset: 0, _length: fullLayout.width, _id: ''};
	    var fullHeight = {_offset: 0, _length: fullLayout.height, _id: ''};
	    var xaList = axes.list(gd, 'x', true);
	    var yaList = axes.list(gd, 'y', true);
	    var clipList = [];
	    var i, j;
	
	    for(i = 0; i < xaList.length; i++) {
	        clipList.push({x: xaList[i], y: fullHeight});
	        for(j = 0; j < yaList.length; j++) {
	            if(i === 0) clipList.push({x: fullWidth, y: yaList[j]});
	            clipList.push({x: xaList[i], y: yaList[j]});
	        }
	    }
	
	    // selectors don't work right with camelCase tags,
	    // have to use class instead
	    // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
	    var axClips = fullLayout._clips.selectAll('.axesclip')
	        .data(clipList, function(d) { return d.x._id + d.y._id; });
	
	    axClips.enter().append('clipPath')
	        .classed('axesclip', true)
	        .attr('id', function(d) { return 'clip' + fullLayout._uid + d.x._id + d.y._id; })
	      .append('rect');
	
	    axClips.exit().remove();
	
	    axClips.each(function(d) {
	        d3.select(this).select('rect').attr({
	            x: d.x._offset || 0,
	            y: d.y._offset || 0,
	            width: d.x._length || 1,
	            height: d.y._length || 1
	        });
	    });
	};
	
	/**
	 * Main multi-axis drawing routine!
	 *
	 * @param {DOM element} gd : graph div
	 * @param {string or array of strings} arg : polymorphic argument
	 * @param {object} opts:
	 * - @param {boolean} skipTitle : optional flag to skip axis title draw/update
	 *
	 * Signature 1: Axes.draw(gd, 'redraw')
	 *   use this to clear and redraw all axes on graph
	 *
	 * Signature 2: Axes.draw(gd, '')
	 *   use this to draw all axes on graph w/o the selectAll().remove()
	 *   of the 'redraw' signature
	 *
	 * Signature 3: Axes.draw(gd, [axId, axId2, ...])
	 *   where the items are axis id string,
	 *   use this to update multiple axes in one call
	 *
	 * N.B draw updates:
	 * - ax._r (stored range for use by zoom/pan)
	 * - ax._rl (stored linearized range for use by zoom/pan)
	 */
	axes.draw = function(gd, arg, opts) {
	    var fullLayout = gd._fullLayout;
	
	    if(arg === 'redraw') {
	        fullLayout._paper.selectAll('g.subplot').each(function(d) {
	            var id = d[0];
	            var plotinfo = fullLayout._plots[id];
	            var xa = plotinfo.xaxis;
	            var ya = plotinfo.yaxis;
	
	            plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick').remove();
	            plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick').remove();
	            plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick2').remove();
	            plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick2').remove();
	            plotinfo.xaxislayer.selectAll('.' + xa._id + 'divider').remove();
	            plotinfo.yaxislayer.selectAll('.' + ya._id + 'divider').remove();
	
	            if(plotinfo.gridlayer) plotinfo.gridlayer.selectAll('path').remove();
	            if(plotinfo.zerolinelayer) plotinfo.zerolinelayer.selectAll('path').remove();
	
	            fullLayout._infolayer.select('.g-' + xa._id + 'title').remove();
	            fullLayout._infolayer.select('.g-' + ya._id + 'title').remove();
	        });
	    }
	
	    var axList = (!arg || arg === 'redraw') ? axes.listIds(gd) : arg;
	
	    return Lib.syncOrAsync(axList.map(function(axId) {
	        return function() {
	            if(!axId) return;
	
	            var ax = axes.getFromId(gd, axId);
	            var axDone = axes.drawOne(gd, ax, opts);
	
	            ax._r = ax.range.slice();
	            ax._rl = Lib.simpleMap(ax._r, ax.r2l);
	
	            return axDone;
	        };
	    }));
	};
	
	/**
	 * Draw one cartesian axis
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 * @param {object} opts
	 * - @param {boolean} skipTitle (set to true to skip axis title draw call)
	 *
	 * Depends on:
	 * - ax._mainSubplot (from linkSubplots)
	 * - ax._mainAxis
	 * - ax._anchorAxis
	 * - ax._subplotsWith
	 * - ax._counterDomainMin, ax._counterDomainMax (optionally, from linkSubplots)
	 * - ax._tickAngles (on redraw only, old value relinked during supplyDefaults)
	 * - ax._mainLinePosition (from lsInner)
	 * - ax._mainMirrorPosition
	 * - ax._linepositions
	 *
	 * Fills in:
	 * - ax._vals:
	 * - ax._gridVals:
	 * - ax._selections:
	 * - ax._tickAngles:
	 * - ax._depth (when required only):
	 * - and calls ax.setScale
	 */
	axes.drawOne = function(gd, ax, opts) {
	    opts = opts || {};
	
	    var i, sp, plotinfo;
	
	    ax.setScale();
	
	    var fullLayout = gd._fullLayout;
	    var axId = ax._id;
	    var axLetter = axId.charAt(0);
	    var counterLetter = axes.counterLetter(axId);
	    var mainLinePosition = ax._mainLinePosition;
	    var mainMirrorPosition = ax._mainMirrorPosition;
	    var mainPlotinfo = fullLayout._plots[ax._mainSubplot];
	    var mainAxLayer = mainPlotinfo[axLetter + 'axislayer'];
	
	    var vals = ax._vals = axes.calcTicks(ax);
	
	    // Add a couple of axis properties that should cause us to recreate
	    // elements. Used in d3 data function.
	    var axInfo = [ax.mirror, mainLinePosition, mainMirrorPosition].join('_');
	    for(i = 0; i < vals.length; i++) {
	        vals[i].axInfo = axInfo;
	    }
	
	    // stash selections to avoid DOM queries e.g.
	    // - stash tickLabels selection, so that drawTitle can use it to scoot title
	    ax._selections = {};
	    // stash tick angle (including the computed 'auto' values) per tick-label class
	    // linkup 'previous' tick angles on redraws
	    if(ax._tickAngles) ax._prevTickAngles = ax._tickAngles;
	    ax._tickAngles = {};
	    // measure [in px] between axis position and outward-most part of bounding box
	    // (touching either the tick label or ticks)
	    // depth can be expansive to compute, so we only do so when required
	    ax._depth = null;
	
	    // calcLabelLevelBbox can be expensive,
	    // so make sure to not call it twice during the same Axes.drawOne call
	    // by stashing label-level bounding boxes per tick-label class
	    var llbboxes = {};
	    function getLabelLevelBbox(suffix) {
	        var cls = axId + (suffix || 'tick');
	        if(!llbboxes[cls]) llbboxes[cls] = calcLabelLevelBbox(ax, cls);
	        return llbboxes[cls];
	    }
	
	    if(!ax.visible) return;
	
	    var transFn = axes.makeTransFn(ax);
	    var tickVals;
	    // We remove zero lines, grid lines, and inside ticks if they're within 1px of the end
	    // The key case here is removing zero lines when the axis bound is zero
	    var valsClipped;
	
	    if(ax.tickson === 'boundaries') {
	        var boundaryVals = getBoundaryVals(ax, vals);
	        valsClipped = axes.clipEnds(ax, boundaryVals);
	        tickVals = ax.ticks === 'inside' ? valsClipped : boundaryVals;
	    } else {
	        valsClipped = axes.clipEnds(ax, vals);
	        tickVals = ax.ticks === 'inside' ? valsClipped : vals;
	    }
	
	    var gridVals = ax._gridVals = valsClipped;
	    var dividerVals = getDividerVals(ax, vals);
	
	    if(!fullLayout._hasOnlyLargeSploms) {
	        var subplotsWithAx = ax._subplotsWith;
	
	        // keep track of which subplots (by main counter axis) we've already
	        // drawn grids for, so we don't overdraw overlaying subplots
	        var finishedGrids = {};
	
	        for(i = 0; i < subplotsWithAx.length; i++) {
	            sp = subplotsWithAx[i];
	            plotinfo = fullLayout._plots[sp];
	
	            var counterAxis = plotinfo[counterLetter + 'axis'];
	            var mainCounterID = counterAxis._mainAxis._id;
	            if(finishedGrids[mainCounterID]) continue;
	            finishedGrids[mainCounterID] = 1;
	
	            var gridPath = axLetter === 'x' ?
	                'M0,' + counterAxis._offset + 'v' + counterAxis._length :
	                'M' + counterAxis._offset + ',0h' + counterAxis._length;
	
	            axes.drawGrid(gd, ax, {
	                vals: gridVals,
	                counterAxis: counterAxis,
	                layer: plotinfo.gridlayer.select('.' + axId),
	                path: gridPath,
	                transFn: transFn
	            });
	            axes.drawZeroLine(gd, ax, {
	                counterAxis: counterAxis,
	                layer: plotinfo.zerolinelayer,
	                path: gridPath,
	                transFn: transFn
	            });
	        }
	    }
	
	    var tickSigns = axes.getTickSigns(ax);
	    var tickSubplots = [];
	
	    if(ax.ticks) {
	        var mainTickPath = axes.makeTickPath(ax, mainLinePosition, tickSigns[2]);
	        var mirrorTickPath;
	        var fullTickPath;
	        if(ax._anchorAxis && ax.mirror && ax.mirror !== true) {
	            mirrorTickPath = axes.makeTickPath(ax, mainMirrorPosition, tickSigns[3]);
	            fullTickPath = mainTickPath + mirrorTickPath;
	        } else {
	            mirrorTickPath = '';
	            fullTickPath = mainTickPath;
	        }
	
	        var tickPath;
	        if(ax.showdividers && ax.ticks === 'outside' && ax.tickson === 'boundaries') {
	            var dividerLookup = {};
	            for(i = 0; i < dividerVals.length; i++) {
	                dividerLookup[dividerVals[i].x] = 1;
	            }
	            tickPath = function(d) {
	                return dividerLookup[d.x] ? mirrorTickPath : fullTickPath;
	            };
	        } else {
	            tickPath = fullTickPath;
	        }
	
	        axes.drawTicks(gd, ax, {
	            vals: tickVals,
	            layer: mainAxLayer,
	            path: tickPath,
	            transFn: transFn
	        });
	
	        if(ax.mirror === 'allticks') {
	            tickSubplots = Object.keys(ax._linepositions || {});
	        }
	    }
	
	    for(i = 0; i < tickSubplots.length; i++) {
	        sp = tickSubplots[i];
	        plotinfo = fullLayout._plots[sp];
	        // [bottom or left, top or right], free and main are handled above
	        var linepositions = ax._linepositions[sp] || [];
	        var spTickPath = axes.makeTickPath(ax, linepositions[0], tickSigns[0]) +
	            axes.makeTickPath(ax, linepositions[1], tickSigns[1]);
	
	        axes.drawTicks(gd, ax, {
	            vals: tickVals,
	            layer: plotinfo[axLetter + 'axislayer'],
	            path: spTickPath,
	            transFn: transFn
	        });
	    }
	
	    var seq = [];
	
	    // tick labels - for now just the main labels.
	    // TODO: mirror labels, esp for subplots
	
	    seq.push(function() {
	        return axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: mainAxLayer,
	            transFn: transFn,
	            labelFns: axes.makeLabelFns(ax, mainLinePosition)
	        });
	    });
	
	    if(ax.type === 'multicategory') {
	        var pad = {x: 2, y: 10}[axLetter];
	
	        seq.push(function() {
	            var bboxKey = {x: 'height', y: 'width'}[axLetter];
	            var standoff = getLabelLevelBbox()[bboxKey] + pad +
	                (ax._tickAngles[axId + 'tick'] ? ax.tickfont.size * LINE_SPACING : 0);
	
	            return axes.drawLabels(gd, ax, {
	                vals: getSecondaryLabelVals(ax, vals),
	                layer: mainAxLayer,
	                cls: axId + 'tick2',
	                repositionOnUpdate: true,
	                secondary: true,
	                transFn: transFn,
	                labelFns: axes.makeLabelFns(ax, mainLinePosition + standoff * tickSigns[4])
	            });
	        });
	
	        seq.push(function() {
	            ax._depth = tickSigns[4] * (getLabelLevelBbox('tick2')[ax.side] - mainLinePosition);
	
	            return drawDividers(gd, ax, {
	                vals: dividerVals,
	                layer: mainAxLayer,
	                path: axes.makeTickPath(ax, mainLinePosition, tickSigns[4], ax._depth),
	                transFn: transFn
	            });
	        });
	    } else if(ax.title.hasOwnProperty('standoff')) {
	        seq.push(function() {
	            ax._depth = tickSigns[4] * (getLabelLevelBbox()[ax.side] - mainLinePosition);
	        });
	    }
	
	    var hasRangeSlider = Registry.getComponentMethod('rangeslider', 'isVisible')(ax);
	
	    seq.push(function() {
	        var s = ax.side.charAt(0);
	        var sMirror = OPPOSITE_SIDE[ax.side].charAt(0);
	        var pos = axes.getPxPosition(gd, ax);
	        var outsideTickLen = ax.ticks === 'outside' ? ax.ticklen : 0;
	        var llbbox;
	
	        var push;
	        var mirrorPush;
	        var rangeSliderPush;
	
	        if(ax.automargin || hasRangeSlider) {
	            if(ax.type === 'multicategory') {
	                llbbox = getLabelLevelBbox('tick2');
	            } else {
	                llbbox = getLabelLevelBbox();
	                if(axLetter === 'x' && s === 'b') {
	                    ax._depth = Math.max(llbbox.width > 0 ? llbbox.bottom - pos : 0, outsideTickLen);
	                }
	            }
	        }
	
	        if(ax.automargin) {
	            push = {x: 0, y: 0, r: 0, l: 0, t: 0, b: 0};
	            var domainIndices = [0, 1];
	
	            if(axLetter === 'x') {
	                if(s === 'b') {
	                    push[s] = ax._depth;
	                } else {
	                    push[s] = ax._depth = Math.max(llbbox.width > 0 ? pos - llbbox.top : 0, outsideTickLen);
	                    domainIndices.reverse();
	                }
	
	                if(llbbox.width > 0) {
	                    var rExtra = llbbox.right - (ax._offset + ax._length);
	                    if(rExtra > 0) {
	                        push.xr = 1;
	                        push.r = rExtra;
	                    }
	                    var lExtra = ax._offset - llbbox.left;
	                    if(lExtra > 0) {
	                        push.xl = 0;
	                        push.l = lExtra;
	                    }
	                }
	            } else {
	                if(s === 'l') {
	                    push[s] = ax._depth = Math.max(llbbox.height > 0 ? pos - llbbox.left : 0, outsideTickLen);
	                } else {
	                    push[s] = ax._depth = Math.max(llbbox.height > 0 ? llbbox.right - pos : 0, outsideTickLen);
	                    domainIndices.reverse();
	                }
	
	                if(llbbox.height > 0) {
	                    var bExtra = llbbox.bottom - (ax._offset + ax._length);
	                    if(bExtra > 0) {
	                        push.yb = 0;
	                        push.b = bExtra;
	                    }
	                    var tExtra = ax._offset - llbbox.top;
	                    if(tExtra > 0) {
	                        push.yt = 1;
	                        push.t = tExtra;
	                    }
	                }
	            }
	
	            push[counterLetter] = ax.anchor === 'free' ?
	                ax.position :
	                ax._anchorAxis.domain[domainIndices[0]];
	
	            if(ax.title.text !== fullLayout._dfltTitle[axLetter]) {
	                push[s] += approxTitleDepth(ax) + (ax.title.standoff || 0);
	            }
	
	            if(ax.mirror && ax.anchor !== 'free') {
	                mirrorPush = {x: 0, y: 0, r: 0, l: 0, t: 0, b: 0};
	
	                mirrorPush[sMirror] = ax.linewidth;
	                if(ax.mirror && ax.mirror !== true) mirrorPush[sMirror] += outsideTickLen;
	
	                if(ax.mirror === true || ax.mirror === 'ticks') {
	                    mirrorPush[counterLetter] = ax._anchorAxis.domain[domainIndices[1]];
	                } else if(ax.mirror === 'all' || ax.mirror === 'allticks') {
	                    mirrorPush[counterLetter] = [ax._counterDomainMin, ax._counterDomainMax][domainIndices[1]];
	                }
	            }
	        }
	
	        if(hasRangeSlider) {
	            rangeSliderPush = Registry.getComponentMethod('rangeslider', 'autoMarginOpts')(gd, ax);
	        }
	
	        Plots.autoMargin(gd, axAutoMarginID(ax), push);
	        Plots.autoMargin(gd, axMirrorAutoMarginID(ax), mirrorPush);
	        Plots.autoMargin(gd, rangeSliderAutoMarginID(ax), rangeSliderPush);
	    });
	
	    if(!opts.skipTitle &&
	        !(hasRangeSlider && ax.side === 'bottom')
	    ) {
	        seq.push(function() { return drawTitle(gd, ax); });
	    }
	
	    return Lib.syncOrAsync(seq);
	};
	
	function getBoundaryVals(ax, vals) {
	    var out = [];
	    var i;
	
	    // boundaryVals are never used for labels;
	    // no need to worry about the other tickTextObj keys
	    var _push = function(d, bndIndex) {
	        var xb = d.xbnd[bndIndex];
	        if(xb !== null) {
	            out.push(Lib.extendFlat({}, d, {x: xb}));
	        }
	    };
	
	    if(vals.length) {
	        for(i = 0; i < vals.length; i++) {
	            _push(vals[i], 0);
	        }
	        _push(vals[i - 1], 1);
	    }
	
	    return out;
	}
	
	function getSecondaryLabelVals(ax, vals) {
	    var out = [];
	    var lookup = {};
	
	    for(var i = 0; i < vals.length; i++) {
	        var d = vals[i];
	        if(lookup[d.text2]) {
	            lookup[d.text2].push(d.x);
	        } else {
	            lookup[d.text2] = [d.x];
	        }
	    }
	
	    for(var k in lookup) {
	        out.push(tickTextObj(ax, Lib.interp(lookup[k], 0.5), k));
	    }
	
	    return out;
	}
	
	function getDividerVals(ax, vals) {
	    var out = [];
	    var i, current;
	
	    // never used for labels;
	    // no need to worry about the other tickTextObj keys
	    var _push = function(d, bndIndex) {
	        var xb = d.xbnd[bndIndex];
	        if(xb !== null) {
	            out.push(Lib.extendFlat({}, d, {x: xb}));
	        }
	    };
	
	    if(ax.showdividers && vals.length) {
	        for(i = 0; i < vals.length; i++) {
	            var d = vals[i];
	            if(d.text2 !== current) {
	                _push(d, 0);
	            }
	            current = d.text2;
	        }
	        _push(vals[i - 1], 1);
	    }
	
	    return out;
	}
	
	function calcLabelLevelBbox(ax, cls) {
	    var top, bottom;
	    var left, right;
	
	    if(ax._selections[cls].size()) {
	        top = Infinity;
	        bottom = -Infinity;
	        left = Infinity;
	        right = -Infinity;
	        ax._selections[cls].each(function() {
	            var thisLabel = selectTickLabel(this);
	            // Use parent node <g.(x|y)tick>, to make Drawing.bBox
	            // retrieve a bbox computed with transform info
	            //
	            // To improve perf, it would be nice to use `thisLabel.node()`
	            // (like in fixLabelOverlaps) instead and use Axes.getPxPosition
	            // together with the makeLabelFns outputs and `tickangle`
	            // to compute one bbox per (tick value x tick style)
	            var bb = Drawing.bBox(thisLabel.node().parentNode);
	            top = Math.min(top, bb.top);
	            bottom = Math.max(bottom, bb.bottom);
	            left = Math.min(left, bb.left);
	            right = Math.max(right, bb.right);
	        });
	    } else {
	        top = 0;
	        bottom = 0;
	        left = 0;
	        right = 0;
	    }
	
	    return {
	        top: top,
	        bottom: bottom,
	        left: left,
	        right: right,
	        height: bottom - top,
	        width: right - left
	    };
	}
	
	/**
	 * Which direction do the 'ax.side' values, and free ticks go?
	 *
	 * @param {object} ax (full) axis object
	 *  - {string} _id (starting with 'x' or 'y')
	 *  - {string} side
	 *  - {string} ticks
	 * @return {array} all entries are either -1 or 1
	 *  - [0]: sign for top/right ticks (i.e. negative SVG direction)
	 *  - [1]: sign for bottom/left ticks (i.e. positive SVG direction)
	 *  - [2]: sign for ticks corresponding to 'ax.side'
	 *  - [3]: sign for ticks mirroring 'ax.side'
	 *  - [4]: sign of arrow starting at axis pointing towards margin
	 */
	axes.getTickSigns = function(ax) {
	    var axLetter = ax._id.charAt(0);
	    var sideOpposite = {x: 'top', y: 'right'}[axLetter];
	    var main = ax.side === sideOpposite ? 1 : -1;
	    var out = [-1, 1, main, -main];
	    // then we flip if outside XOR y axis
	    if((ax.ticks !== 'inside') === (axLetter === 'x')) {
	        out = out.map(function(v) { return -v; });
	    }
	    // independent of `ticks`; do not flip this one
	    if(ax.side) {
	        out.push({l: -1, t: -1, r: 1, b: 1}[ax.side.charAt(0)]);
	    }
	    return out;
	};
	
	/**
	 * Make axis translate transform function
	 *
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {number} _offset
	 *  - {fn} l2p
	 * @return {fn} function of calcTicks items
	 */
	axes.makeTransFn = function(ax) {
	    var axLetter = ax._id.charAt(0);
	    var offset = ax._offset;
	    return axLetter === 'x' ?
	        function(d) { return 'translate(' + (offset + ax.l2p(d.x)) + ',0)'; } :
	        function(d) { return 'translate(0,' + (offset + ax.l2p(d.x)) + ')'; };
	};
	
	/**
	 * Make axis tick path string
	 *
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {number} ticklen
	 *  - {number} linewidth
	 * @param {number} shift along direction of ticklen
	 * @param {1 or -1} sgn tick sign
	 * @param {number (optional)} len tick length
	 * @return {string}
	 */
	axes.makeTickPath = function(ax, shift, sgn, len) {
	    len = len !== undefined ? len : ax.ticklen;
	
	    var axLetter = ax._id.charAt(0);
	    var pad = (ax.linewidth || 1) / 2;
	
	    return axLetter === 'x' ?
	        'M0,' + (shift + pad * sgn) + 'v' + (len * sgn) :
	        'M' + (shift + pad * sgn) + ',0h' + (len * sgn);
	};
	
	/**
	 * Make axis tick label x, y and anchor functions
	 *
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {string} ticks
	 *  - {number} ticklen
	 *  - {string} side
	 *  - {number} linewidth
	 *  - {number} tickfont.size
	 *  - {boolean} showline
	 * @param {number} shift
	 * @param {number} angle [in degrees] ...
	 * @return {object}
	 *  - {fn} xFn
	 *  - {fn} yFn
	 *  - {fn} anchorFn
	 *  - {fn} heightFn
	 *  - {number} labelStandoff (gap parallel to ticks)
	 *  - {number} labelShift (gap perpendicular to ticks)
	 */
	axes.makeLabelFns = function(ax, shift, angle) {
	    var axLetter = ax._id.charAt(0);
	    var ticksOnOutsideLabels = ax.tickson !== 'boundaries' && ax.ticks === 'outside';
	
	    var labelStandoff = 0;
	    var labelShift = 0;
	
	    if(ticksOnOutsideLabels) {
	        labelStandoff += ax.ticklen;
	    }
	    if(angle && ax.ticks === 'outside') {
	        var rad = Lib.deg2rad(angle);
	        labelStandoff = ax.ticklen * Math.cos(rad) + 1;
	        labelShift = ax.ticklen * Math.sin(rad);
	    }
	    if(ax.showticklabels && (ticksOnOutsideLabels || ax.showline)) {
	        labelStandoff += 0.2 * ax.tickfont.size;
	    }
	    labelStandoff += (ax.linewidth || 1) / 2;
	
	    var out = {
	        labelStandoff: labelStandoff,
	        labelShift: labelShift
	    };
	
	    var x0, y0, ff, flipIt;
	
	    if(axLetter === 'x') {
	        flipIt = ax.side === 'bottom' ? 1 : -1;
	        x0 = labelShift * flipIt;
	        y0 = shift + labelStandoff * flipIt;
	        ff = ax.side === 'bottom' ? 1 : -0.2;
	
	        out.xFn = function(d) { return d.dx + x0; };
	        out.yFn = function(d) { return d.dy + y0 + d.fontSize * ff; };
	        out.anchorFn = function(d, a) {
	            if(!isNumeric(a) || a === 0 || a === 180) {
	                return 'middle';
	            }
	            return (a * flipIt < 0) ? 'end' : 'start';
	        };
	        out.heightFn = function(d, a, h) {
	            return (a < -60 || a > 60) ? -0.5 * h :
	                ax.side === 'top' ? -h :
	                0;
	        };
	    } else if(axLetter === 'y') {
	        flipIt = ax.side === 'right' ? 1 : -1;
	        x0 = labelStandoff;
	        y0 = -labelShift * flipIt;
	        ff = Math.abs(ax.tickangle) === 90 ? 0.5 : 0;
	
	        out.xFn = function(d) { return d.dx + shift + (x0 + d.fontSize * ff) * flipIt; };
	        out.yFn = function(d) { return d.dy + y0 + d.fontSize * MID_SHIFT; };
	        out.anchorFn = function(d, a) {
	            if(isNumeric(a) && Math.abs(a) === 90) {
	                return 'middle';
	            }
	            return ax.side === 'right' ? 'start' : 'end';
	        };
	        out.heightFn = function(d, a, h) {
	            a *= ax.side === 'left' ? 1 : -1;
	            return a < -30 ? -h :
	                a < 30 ? -0.5 * h :
	                0;
	        };
	    }
	
	    return out;
	};
	
	function tickDataFn(d) {
	    return [d.text, d.x, d.axInfo, d.font, d.fontSize, d.fontColor].join('_');
	}
	
	/**
	 * Draw axis ticks
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {string} ticks
	 *  - {number} linewidth
	 *  - {string} tickcolor
	 * @param {object} opts
	 * - {array of object} vals (calcTicks output-like)
	 * - {d3 selection} layer
	 * - {string or fn} path
	 * - {fn} transFn
	 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
	 */
	axes.drawTicks = function(gd, ax, opts) {
	    opts = opts || {};
	
	    var cls = ax._id + 'tick';
	
	    var ticks = opts.layer.selectAll('path.' + cls)
	        .data(ax.ticks ? opts.vals : [], tickDataFn);
	
	    ticks.exit().remove();
	
	    ticks.enter().append('path')
	        .classed(cls, 1)
	        .classed('ticks', 1)
	        .classed('crisp', opts.crisp !== false)
	        .call(Color.stroke, ax.tickcolor)
	        .style('stroke-width', Drawing.crispRound(gd, ax.tickwidth, 1) + 'px')
	        .attr('d', opts.path);
	
	    ticks.attr('transform', opts.transFn);
	};
	
	/**
	 * Draw axis grid
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {boolean} showgrid
	 *  - {string} gridcolor
	 *  - {string} gridwidth
	 *  - {boolean} zeroline
	 *  - {string} type
	 *  - {string} dtick
	 * @param {object} opts
	 * - {array of object} vals (calcTicks output-like)
	 * - {d3 selection} layer
	 * - {object} counterAxis (full axis object corresponding to counter axis)
	 *     optional - only required if this axis supports zero lines
	 * - {string or fn} path
	 * - {fn} transFn
	 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
	 */
	axes.drawGrid = function(gd, ax, opts) {
	    opts = opts || {};
	
	    var cls = ax._id + 'grid';
	    var vals = opts.vals;
	    var counterAx = opts.counterAxis;
	    if(ax.showgrid === false) {
	        vals = [];
	    } else if(counterAx && axes.shouldShowZeroLine(gd, ax, counterAx)) {
	        var isArrayMode = ax.tickmode === 'array';
	        for(var i = 0; i < vals.length; i++) {
	            var xi = vals[i].x;
	            if(isArrayMode ? !xi : (Math.abs(xi) < ax.dtick / 100)) {
	                vals = vals.slice(0, i).concat(vals.slice(i + 1));
	                // In array mode you can in principle have multiple
	                // ticks at 0, so test them all. Otherwise once we found
	                // one we can stop.
	                if(isArrayMode) i--;
	                else break;
	            }
	        }
	    }
	
	    var grid = opts.layer.selectAll('path.' + cls)
	        .data(vals, tickDataFn);
	
	    grid.exit().remove();
	
	    grid.enter().append('path')
	        .classed(cls, 1)
	        .classed('crisp', opts.crisp !== false);
	
	    ax._gw = Drawing.crispRound(gd, ax.gridwidth, 1);
	
	    grid.attr('transform', opts.transFn)
	        .attr('d', opts.path)
	        .call(Color.stroke, ax.gridcolor || '#ddd')
	        .style('stroke-width', ax._gw + 'px');
	
	    if(typeof opts.path === 'function') grid.attr('d', opts.path);
	};
	
	/**
	 * Draw axis zero-line
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {boolean} zeroline
	 *  - {number} zerolinewidth
	 *  - {string} zerolinecolor
	 *  - {number (optional)} _gridWidthCrispRound
	 * @param {object} opts
	 * - {d3 selection} layer
	 * - {object} counterAxis (full axis object corresponding to counter axis)
	 * - {string or fn} path
	 * - {fn} transFn
	 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
	 */
	axes.drawZeroLine = function(gd, ax, opts) {
	    opts = opts || opts;
	
	    var cls = ax._id + 'zl';
	    var show = axes.shouldShowZeroLine(gd, ax, opts.counterAxis);
	
	    var zl = opts.layer.selectAll('path.' + cls)
	        .data(show ? [{x: 0, id: ax._id}] : []);
	
	    zl.exit().remove();
	
	    zl.enter().append('path')
	        .classed(cls, 1)
	        .classed('zl', 1)
	        .classed('crisp', opts.crisp !== false)
	        .each(function() {
	            // use the fact that only one element can enter to trigger a sort.
	            // If several zerolines enter at the same time we will sort once per,
	            // but generally this should be a minimal overhead.
	            opts.layer.selectAll('path').sort(function(da, db) {
	                return axisIds.idSort(da.id, db.id);
	            });
	        });
	
	    zl.attr('transform', opts.transFn)
	        .attr('d', opts.path)
	        .call(Color.stroke, ax.zerolinecolor || Color.defaultLine)
	        .style('stroke-width', Drawing.crispRound(gd, ax.zerolinewidth, ax._gw || 1) + 'px');
	};
	
	/**
	 * Draw axis tick labels
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {boolean} showticklabels
	 *  - {number} tickangle
	 *  - {object (optional)} _selections
	 *  - {object} (optional)} _tickAngles
	 *  - {object} (optional)} _prevTickAngles
	 * @param {object} opts
	 * - {array of object} vals (calcTicks output-like)
	 * - {d3 selection} layer
	 * - {string (optional)} cls (node className)
	 * - {boolean} repositionOnUpdate (set to true to reposition update selection)
	 * - {boolean} secondary
	 * - {fn} transFn
	 * - {object} labelFns
	 *  + {fn} xFn
	 *  + {fn} yFn
	 *  + {fn} anchorFn
	 *  + {fn} heightFn
	 */
	axes.drawLabels = function(gd, ax, opts) {
	    opts = opts || {};
	
	    var fullLayout = gd._fullLayout;
	    var axId = ax._id;
	    var axLetter = axId.charAt(0);
	    var cls = opts.cls || axId + 'tick';
	    var vals = opts.vals;
	    var labelFns = opts.labelFns;
	    var tickAngle = opts.secondary ? 0 : ax.tickangle;
	    var prevAngle = (ax._prevTickAngles || {})[cls];
	
	    var tickLabels = opts.layer.selectAll('g.' + cls)
	        .data(ax.showticklabels ? vals : [], tickDataFn);
	
	    var labelsReady = [];
	
	    tickLabels.enter().append('g')
	        .classed(cls, 1)
	        .append('text')
	            // only so tex has predictable alignment that we can
	            // alter later
	            .attr('text-anchor', 'middle')
	            .each(function(d) {
	                var thisLabel = d3.select(this);
	                var newPromise = gd._promises.length;
	
	                thisLabel
	                    .call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d))
	                    .call(Drawing.font, d.font, d.fontSize, d.fontColor)
	                    .text(d.text)
	                    .call(svgTextUtils.convertToTspans, gd);
	
	                if(gd._promises[newPromise]) {
	                    // if we have an async label, we'll deal with that
	                    // all here so take it out of gd._promises and
	                    // instead position the label and promise this in
	                    // labelsReady
	                    labelsReady.push(gd._promises.pop().then(function() {
	                        positionLabels(thisLabel, tickAngle);
	                    }));
	                } else {
	                    // sync label: just position it now.
	                    positionLabels(thisLabel, tickAngle);
	                }
	            });
	
	    tickLabels.exit().remove();
	
	    if(opts.repositionOnUpdate) {
	        tickLabels.each(function(d) {
	            d3.select(this).select('text')
	                .call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d));
	        });
	    }
	
	    function positionLabels(s, angle) {
	        s.each(function(d) {
	            var thisLabel = d3.select(this);
	            var mathjaxGroup = thisLabel.select('.text-math-group');
	            var anchor = labelFns.anchorFn(d, angle);
	
	            var transform = opts.transFn.call(thisLabel.node(), d) +
	                ((isNumeric(angle) && +angle !== 0) ?
	                (' rotate(' + angle + ',' + labelFns.xFn(d) + ',' +
	                    (labelFns.yFn(d) - d.fontSize / 2) + ')') :
	                '');
	
	            // how much to shift a multi-line label to center it vertically.
	            var nLines = svgTextUtils.lineCount(thisLabel);
	            var lineHeight = LINE_SPACING * d.fontSize;
	            var anchorHeight = labelFns.heightFn(d, isNumeric(angle) ? +angle : 0, (nLines - 1) * lineHeight);
	
	            if(anchorHeight) {
	                transform += ' translate(0, ' + anchorHeight + ')';
	            }
	
	            if(mathjaxGroup.empty()) {
	                thisLabel.select('text').attr({
	                    transform: transform,
	                    'text-anchor': anchor
	                });
	            } else {
	                var mjWidth = Drawing.bBox(mathjaxGroup.node()).width;
	                var mjShift = mjWidth * {end: -0.5, start: 0.5}[anchor];
	                mathjaxGroup.attr('transform', transform + (mjShift ? 'translate(' + mjShift + ',0)' : ''));
	            }
	        });
	    }
	
	    // make sure all labels are correctly positioned at their base angle
	    // the positionLabels call above is only for newly drawn labels.
	    // do this without waiting, using the last calculated angle to
	    // minimize flicker, then do it again when we know all labels are
	    // there, putting back the prescribed angle to check for overlaps.
	    positionLabels(tickLabels, (prevAngle + 1) ? prevAngle : tickAngle);
	
	    function allLabelsReady() {
	        return labelsReady.length && Promise.all(labelsReady);
	    }
	
	    var autoangle = null;
	
	    function fixLabelOverlaps() {
	        positionLabels(tickLabels, tickAngle);
	
	        // check for auto-angling if x labels overlap
	        // don't auto-angle at all for log axes with
	        // base and digit format
	        if(vals.length && axLetter === 'x' && !isNumeric(tickAngle) &&
	            (ax.type !== 'log' || String(ax.dtick).charAt(0) !== 'D')
	        ) {
	            autoangle = 0;
	
	            var maxFontSize = 0;
	            var lbbArray = [];
	            var i;
	
	            tickLabels.each(function(d) {
	                maxFontSize = Math.max(maxFontSize, d.fontSize);
	
	                var x = ax.l2p(d.x);
	                var thisLabel = selectTickLabel(this);
	                var bb = Drawing.bBox(thisLabel.node());
	
	                lbbArray.push({
	                    // ignore about y, just deal with x overlaps
	                    top: 0,
	                    bottom: 10,
	                    height: 10,
	                    left: x - bb.width / 2,
	                    // impose a 2px gap
	                    right: x + bb.width / 2 + 2,
	                    width: bb.width + 2
	                });
	            });
	
	            if((ax.tickson === 'boundaries' || ax.showdividers) && !opts.secondary) {
	                var gap = 2;
	                if(ax.ticks) gap += ax.tickwidth / 2;
	
	                // TODO should secondary labels also fall into this fix-overlap regime?
	
	                for(i = 0; i < lbbArray.length; i++) {
	                    var xbnd = vals[i].xbnd;
	                    var lbb = lbbArray[i];
	                    if(
	                        (xbnd[0] !== null && (lbb.left - ax.l2p(xbnd[0])) < gap) ||
	                        (xbnd[1] !== null && (ax.l2p(xbnd[1]) - lbb.right) < gap)
	                    ) {
	                        autoangle = 90;
	                        break;
	                    }
	                }
	            } else {
	                var vLen = vals.length;
	                var tickSpacing = Math.abs((vals[vLen - 1].x - vals[0].x) * ax._m) / (vLen - 1);
	                var rotate90 = (tickSpacing < maxFontSize * 2.5) || ax.type === 'multicategory';
	
	                // any overlap at all - set 30 degrees or 90 degrees
	                for(i = 0; i < lbbArray.length - 1; i++) {
	                    if(Lib.bBoxIntersect(lbbArray[i], lbbArray[i + 1])) {
	                        autoangle = rotate90 ? 90 : 30;
	                        break;
	                    }
	                }
	            }
	
	            if(autoangle) {
	                positionLabels(tickLabels, autoangle);
	            }
	        }
	    }
	
	    if(ax._selections) {
	        ax._selections[cls] = tickLabels;
	    }
	
	    var seq = [allLabelsReady];
	
	    // N.B. during auto-margin redraws, if the axis fixed its label overlaps
	    // by rotating 90 degrees, do not attempt to re-fix its label overlaps
	    // as this can lead to infinite redraw loops!
	    if(ax.automargin && fullLayout._redrawFromAutoMarginCount && prevAngle === 90) {
	        autoangle = 90;
	        seq.push(function() {
	            positionLabels(tickLabels, prevAngle);
	        });
	    } else {
	        seq.push(fixLabelOverlaps);
	    }
	
	    // save current tick angle for future redraws
	    if(ax._tickAngles) {
	        seq.push(function() {
	            ax._tickAngles[cls] = autoangle === null ?
	                (isNumeric(tickAngle) ? tickAngle : 0) :
	                autoangle;
	        });
	    }
	
	    var done = Lib.syncOrAsync(seq);
	    if(done && done.then) gd._promises.push(done);
	    return done;
	};
	
	/**
	 * Draw axis dividers
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {string} showdividers
	 *  - {number} dividerwidth
	 *  - {string} dividercolor
	 * @param {object} opts
	 * - {array of object} vals (calcTicks output-like)
	 * - {d3 selection} layer
	 * - {fn} path
	 * - {fn} transFn
	 */
	function drawDividers(gd, ax, opts) {
	    var cls = ax._id + 'divider';
	    var vals = opts.vals;
	
	    var dividers = opts.layer.selectAll('path.' + cls)
	        .data(vals, tickDataFn);
	
	    dividers.exit().remove();
	
	    dividers.enter().insert('path', ':first-child')
	        .classed(cls, 1)
	        .classed('crisp', 1)
	        .call(Color.stroke, ax.dividercolor)
	        .style('stroke-width', Drawing.crispRound(gd, ax.dividerwidth, 1) + 'px');
	
	    dividers
	        .attr('transform', opts.transFn)
	        .attr('d', opts.path);
	}
	
	/**
	 * Get axis position in px, that is the distance for the graph's
	 * top (left) edge for x (y) axes.
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {string} side
	 *  if anchored:
	 *  - {object} _anchorAxis
	 *  Otherwise:
	 *  - {number} position
	 * @return {number}
	 */
	axes.getPxPosition = function(gd, ax) {
	    var gs = gd._fullLayout._size;
	    var axLetter = ax._id.charAt(0);
	    var side = ax.side;
	    var anchorAxis;
	
	    if(ax.anchor !== 'free') {
	        anchorAxis = ax._anchorAxis;
	    } else if(axLetter === 'x') {
	        anchorAxis = {
	            _offset: gs.t + (1 - (ax.position || 0)) * gs.h,
	            _length: 0
	        };
	    } else if(axLetter === 'y') {
	        anchorAxis = {
	            _offset: gs.l + (ax.position || 0) * gs.w,
	            _length: 0
	        };
	    }
	
	    if(side === 'top' || side === 'left') {
	        return anchorAxis._offset;
	    } else if(side === 'bottom' || side === 'right') {
	        return anchorAxis._offset + anchorAxis._length;
	    }
	};
	
	/**
	 * Approximate axis title depth (w/o computing its bounding box)
	 *
	 * @param {object} ax (full) axis object
	 *  - {string} title.text
	 *  - {number} title.font.size
	 *  - {number} title.standoff
	 * @return {number} (in px)
	 */
	function approxTitleDepth(ax) {
	    var fontSize = ax.title.font.size;
	    var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
	    if(ax.title.hasOwnProperty('standoff')) {
	        return extraLines ?
	            fontSize * (CAP_SHIFT + (extraLines * LINE_SPACING)) :
	            fontSize * CAP_SHIFT;
	    } else {
	        return extraLines ?
	            fontSize * (extraLines + 1) * LINE_SPACING :
	            fontSize;
	    }
	}
	
	/**
	 * Draw axis title, compute default standoff if necessary
	 *
	 * @param {DOM element} gd
	 * @param {object} ax (full) axis object
	 *  - {string} _id
	 *  - {string} _name
	 *  - {string} side
	 *  - {number} title.font.size
	 *  - {object} _selections
	 *
	 *  - {number} _depth
	 *  - {number} title.standoff
	 *  OR
	 *  - {number} linewidth
	 *  - {boolean} showticklabels
	 */
	function drawTitle(gd, ax) {
	    var fullLayout = gd._fullLayout;
	    var axId = ax._id;
	    var axLetter = axId.charAt(0);
	    var fontSize = ax.title.font.size;
	
	    var titleStandoff;
	
	    if(ax.title.hasOwnProperty('standoff')) {
	        titleStandoff = ax._depth + ax.title.standoff + approxTitleDepth(ax);
	    } else {
	        if(ax.type === 'multicategory') {
	            titleStandoff = ax._depth;
	        } else {
	            var offsetBase = 1.5;
	            titleStandoff = 10 + fontSize * offsetBase + (ax.linewidth ? ax.linewidth - 1 : 0);
	        }
	
	        if(axLetter === 'x') {
	            titleStandoff += ax.side === 'top' ?
	                fontSize * (ax.showticklabels ? 1 : 0) :
	                fontSize * (ax.showticklabels ? 1.5 : 0.5);
	        } else {
	            titleStandoff += ax.side === 'right' ?
	                fontSize * (ax.showticklabels ? 1 : 0.5) :
	                fontSize * (ax.showticklabels ? 0.5 : 0);
	        }
	    }
	
	    var pos = axes.getPxPosition(gd, ax);
	    var transform, x, y;
	
	    if(axLetter === 'x') {
	        x = ax._offset + ax._length / 2;
	        y = (ax.side === 'top') ? pos - titleStandoff : pos + titleStandoff;
	    } else {
	        y = ax._offset + ax._length / 2;
	        x = (ax.side === 'right') ? pos + titleStandoff : pos - titleStandoff;
	        transform = {rotate: '-90', offset: 0};
	    }
	
	    var avoid;
	
	    if(ax.type !== 'multicategory') {
	        var tickLabels = ax._selections[ax._id + 'tick'];
	
	        avoid = {
	            selection: tickLabels,
	            side: ax.side
	        };
	
	        if(tickLabels && tickLabels.node() && tickLabels.node().parentNode) {
	            var translation = Drawing.getTranslate(tickLabels.node().parentNode);
	            avoid.offsetLeft = translation.x;
	            avoid.offsetTop = translation.y;
	        }
	
	        if(ax.title.hasOwnProperty('standoff')) {
	            avoid.pad = 0;
	        }
	    }
	
	    return Titles.draw(gd, axId + 'title', {
	        propContainer: ax,
	        propName: ax._name + '.title.text',
	        placeholder: fullLayout._dfltTitle[axLetter],
	        avoid: avoid,
	        transform: transform,
	        attributes: {x: x, y: y, 'text-anchor': 'middle'}
	    });
	}
	
	axes.shouldShowZeroLine = function(gd, ax, counterAxis) {
	    var rng = Lib.simpleMap(ax.range, ax.r2l);
	    return (
	        (rng[0] * rng[1] <= 0) &&
	        ax.zeroline &&
	        (ax.type === 'linear' || ax.type === '-') &&
	        (
	            clipEnds(ax, 0) ||
	            !anyCounterAxLineAtZero(gd, ax, counterAxis, rng) ||
	            hasBarsOrFill(gd, ax)
	        )
	    );
	};
	
	axes.clipEnds = function(ax, vals) {
	    return vals.filter(function(d) { return clipEnds(ax, d.x); });
	};
	
	function clipEnds(ax, l) {
	    var p = ax.l2p(l);
	    return (p > 1 && p < ax._length - 1);
	}
	
	function anyCounterAxLineAtZero(gd, ax, counterAxis, rng) {
	    var mainCounterAxis = counterAxis._mainAxis;
	    if(!mainCounterAxis) return;
	
	    var fullLayout = gd._fullLayout;
	    var axLetter = ax._id.charAt(0);
	    var counterLetter = axes.counterLetter(ax._id);
	
	    var zeroPosition = ax._offset + (
	        ((Math.abs(rng[0]) < Math.abs(rng[1])) === (axLetter === 'x')) ?
	        0 : ax._length
	    );
	
	    function lineNearZero(ax2) {
	        if(!ax2.showline || !ax2.linewidth) return false;
	        var tolerance = Math.max((ax2.linewidth + ax.zerolinewidth) / 2, 1);
	
	        function closeEnough(pos2) {
	            return typeof pos2 === 'number' && Math.abs(pos2 - zeroPosition) < tolerance;
	        }
	
	        if(closeEnough(ax2._mainLinePosition) || closeEnough(ax2._mainMirrorPosition)) {
	            return true;
	        }
	        var linePositions = ax2._linepositions || {};
	        for(var k in linePositions) {
	            if(closeEnough(linePositions[k][0]) || closeEnough(linePositions[k][1])) {
	                return true;
	            }
	        }
	    }
	
	    var plotinfo = fullLayout._plots[counterAxis._mainSubplot];
	    if(!(plotinfo.mainplotinfo || plotinfo).overlays.length) {
	        return lineNearZero(counterAxis, zeroPosition);
	    }
	
	    var counterLetterAxes = axes.list(gd, counterLetter);
	    for(var i = 0; i < counterLetterAxes.length; i++) {
	        var counterAxis2 = counterLetterAxes[i];
	        if(
	            counterAxis2._mainAxis === mainCounterAxis &&
	            lineNearZero(counterAxis2, zeroPosition)
	        ) {
	            return true;
	        }
	    }
	}
	
	function hasBarsOrFill(gd, ax) {
	    var fullData = gd._fullData;
	    var subplot = ax._mainSubplot;
	    var axLetter = ax._id.charAt(0);
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	
	        if(trace.visible === true && (trace.xaxis + trace.yaxis) === subplot) {
	            if(
	                Registry.traceIs(trace, 'bar-like') &&
	                trace.orientation === {x: 'h', y: 'v'}[axLetter]
	            ) return true;
	
	            if(
	                trace.fill &&
	                trace.fill.charAt(trace.fill.length - 1) === axLetter
	            ) return true;
	        }
	    }
	    return false;
	}
	
	function selectTickLabel(gTick) {
	    var s = d3.select(gTick);
	    var mj = s.select('.text-math-group');
	    return mj.empty() ? s.select('text') : mj;
	}
	
	/**
	 * Find all margin pushers for 2D axes and reserve them for later use
	 * Both label and rangeslider automargin calculations happen later so
	 * we need to explicitly allow their ids in order to not delete them.
	 *
	 * TODO: can we pull the actual automargin calls forward to avoid this hack?
	 * We're probably also doing multiple redraws in this case, would be faster
	 * if we can just do the whole calculation ahead of time and draw once.
	 */
	axes.allowAutoMargin = function(gd) {
	    var axList = axes.list(gd, '', true);
	    for(var i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        if(ax.automargin) {
	            Plots.allowAutoMargin(gd, axAutoMarginID(ax));
	            if(ax.mirror) {
	                Plots.allowAutoMargin(gd, axMirrorAutoMarginID(ax));
	            }
	        }
	        if(Registry.getComponentMethod('rangeslider', 'isVisible')(ax)) {
	            Plots.allowAutoMargin(gd, rangeSliderAutoMarginID(ax));
	        }
	    }
	};
	
	function axAutoMarginID(ax) { return ax._id + '.automargin'; }
	function axMirrorAutoMarginID(ax) { return axAutoMarginID(ax) + '.mirror'; }
	function rangeSliderAutoMarginID(ax) { return ax._id + '.rangeslider'; }
	
	// swap all the presentation attributes of the axes showing these traces
	axes.swap = function(gd, traces) {
	    var axGroups = makeAxisGroups(gd, traces);
	
	    for(var i = 0; i < axGroups.length; i++) {
	        swapAxisGroup(gd, axGroups[i].x, axGroups[i].y);
	    }
	};
	
	function makeAxisGroups(gd, traces) {
	    var groups = [];
	    var i, j;
	
	    for(i = 0; i < traces.length; i++) {
	        var groupsi = [];
	        var xi = gd._fullData[traces[i]].xaxis;
	        var yi = gd._fullData[traces[i]].yaxis;
	        if(!xi || !yi) continue; // not a 2D cartesian trace?
	
	        for(j = 0; j < groups.length; j++) {
	            if(groups[j].x.indexOf(xi) !== -1 || groups[j].y.indexOf(yi) !== -1) {
	                groupsi.push(j);
	            }
	        }
	
	        if(!groupsi.length) {
	            groups.push({x: [xi], y: [yi]});
	            continue;
	        }
	
	        var group0 = groups[groupsi[0]];
	        var groupj;
	
	        if(groupsi.length > 1) {
	            for(j = 1; j < groupsi.length; j++) {
	                groupj = groups[groupsi[j]];
	                mergeAxisGroups(group0.x, groupj.x);
	                mergeAxisGroups(group0.y, groupj.y);
	            }
	        }
	        mergeAxisGroups(group0.x, [xi]);
	        mergeAxisGroups(group0.y, [yi]);
	    }
	
	    return groups;
	}
	
	function mergeAxisGroups(intoSet, fromSet) {
	    for(var i = 0; i < fromSet.length; i++) {
	        if(intoSet.indexOf(fromSet[i]) === -1) intoSet.push(fromSet[i]);
	    }
	}
	
	function swapAxisGroup(gd, xIds, yIds) {
	    var xFullAxes = [];
	    var yFullAxes = [];
	    var layout = gd.layout;
	    var i, j;
	
	    for(i = 0; i < xIds.length; i++) xFullAxes.push(axes.getFromId(gd, xIds[i]));
	    for(i = 0; i < yIds.length; i++) yFullAxes.push(axes.getFromId(gd, yIds[i]));
	
	    var allAxKeys = Object.keys(axAttrs);
	
	    var noSwapAttrs = [
	        'anchor', 'domain', 'overlaying', 'position', 'side', 'tickangle', 'editType'
	    ];
	    var numericTypes = ['linear', 'log'];
	
	    for(i = 0; i < allAxKeys.length; i++) {
	        var keyi = allAxKeys[i];
	        var xVal = xFullAxes[0][keyi];
	        var yVal = yFullAxes[0][keyi];
	        var allEqual = true;
	        var coerceLinearX = false;
	        var coerceLinearY = false;
	        if(keyi.charAt(0) === '_' || typeof xVal === 'function' ||
	                noSwapAttrs.indexOf(keyi) !== -1) {
	            continue;
	        }
	        for(j = 1; j < xFullAxes.length && allEqual; j++) {
	            var xVali = xFullAxes[j][keyi];
	            if(keyi === 'type' && numericTypes.indexOf(xVal) !== -1 &&
	                    numericTypes.indexOf(xVali) !== -1 && xVal !== xVali) {
	                // type is special - if we find a mixture of linear and log,
	                // coerce them all to linear on flipping
	                coerceLinearX = true;
	            } else if(xVali !== xVal) allEqual = false;
	        }
	        for(j = 1; j < yFullAxes.length && allEqual; j++) {
	            var yVali = yFullAxes[j][keyi];
	            if(keyi === 'type' && numericTypes.indexOf(yVal) !== -1 &&
	                    numericTypes.indexOf(yVali) !== -1 && yVal !== yVali) {
	                // type is special - if we find a mixture of linear and log,
	                // coerce them all to linear on flipping
	                coerceLinearY = true;
	            } else if(yFullAxes[j][keyi] !== yVal) allEqual = false;
	        }
	        if(allEqual) {
	            if(coerceLinearX) layout[xFullAxes[0]._name].type = 'linear';
	            if(coerceLinearY) layout[yFullAxes[0]._name].type = 'linear';
	            swapAxisAttrs(layout, keyi, xFullAxes, yFullAxes, gd._fullLayout._dfltTitle);
	        }
	    }
	
	    // now swap x&y for any annotations anchored to these x & y
	    for(i = 0; i < gd._fullLayout.annotations.length; i++) {
	        var ann = gd._fullLayout.annotations[i];
	        if(xIds.indexOf(ann.xref) !== -1 &&
	                yIds.indexOf(ann.yref) !== -1) {
	            Lib.swapAttrs(layout.annotations[i], ['?']);
	        }
	    }
	}
	
	function swapAxisAttrs(layout, key, xFullAxes, yFullAxes, dfltTitle) {
	    // in case the value is the default for either axis,
	    // look at the first axis in each list and see if
	    // this key's value is undefined
	    var np = Lib.nestedProperty;
	    var xVal = np(layout[xFullAxes[0]._name], key).get();
	    var yVal = np(layout[yFullAxes[0]._name], key).get();
	    var i;
	
	    if(key === 'title') {
	        // special handling of placeholder titles
	        if(xVal && xVal.text === dfltTitle.x) {
	            xVal.text = dfltTitle.y;
	        }
	        if(yVal && yVal.text === dfltTitle.y) {
	            yVal.text = dfltTitle.x;
	        }
	    }
	
	    for(i = 0; i < xFullAxes.length; i++) {
	        np(layout, xFullAxes[i]._name + '.' + key).set(yVal);
	    }
	    for(i = 0; i < yFullAxes.length; i++) {
	        np(layout, yFullAxes[i]._name + '.' + key).set(xVal);
	    }
	}
	
	function isAngular(ax) {
	    return ax._id === 'angularaxis';
	}
	
	},{"../../components/color":591,"../../components/drawing":612,"../../components/titles":678,"../../constants/alignment":685,"../../constants/numerical":692,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/plots":825,"../../registry":845,"./autorange":763,"./axis_autotype":765,"./axis_ids":767,"./clean_ticks":769,"./layout_attributes":776,"./set_convert":782,"d3":164,"fast-isnumeric":227}],765:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function autoType(array, calendar, opts) {
	    opts = opts || {};
	
	    if(!opts.noMultiCategory && multiCategory(array)) return 'multicategory';
	    if(moreDates(array, calendar)) return 'date';
	    if(category(array)) return 'category';
	    if(linearOK(array)) return 'linear';
	    else return '-';
	};
	
	// is there at least one number in array? If not, we should leave
	// ax.type empty so it can be autoset later
	function linearOK(array) {
	    if(!array) return false;
	
	    for(var i = 0; i < array.length; i++) {
	        if(isNumeric(array[i])) return true;
	    }
	
	    return false;
	}
	
	// does the array a have mostly dates rather than numbers?
	// note: some values can be neither (such as blanks, text)
	// 2- or 4-digit integers can be both, so require twice as many
	// dates as non-dates, to exclude cases with mostly 2 & 4 digit
	// numbers and a few dates
	// as with categories, consider DISTINCT values only.
	function moreDates(a, calendar) {
	    // test at most 1000 points, evenly spaced
	    var inc = Math.max(1, (a.length - 1) / 1000);
	    var dcnt = 0;
	    var ncnt = 0;
	    var seen = {};
	
	    for(var i = 0; i < a.length; i += inc) {
	        var ai = a[Math.round(i)];
	        var stri = String(ai);
	        if(seen[stri]) continue;
	        seen[stri] = 1;
	
	        if(Lib.isDateTime(ai, calendar)) dcnt += 1;
	        if(isNumeric(ai)) ncnt += 1;
	    }
	
	    return (dcnt > ncnt * 2);
	}
	
	// are the (x,y)-values in gd.data mostly text?
	// require twice as many DISTINCT categories as distinct numbers
	function category(a) {
	    // test at most 1000 points
	    var inc = Math.max(1, (a.length - 1) / 1000);
	    var curvenums = 0;
	    var curvecats = 0;
	    var seen = {};
	
	    for(var i = 0; i < a.length; i += inc) {
	        var ai = a[Math.round(i)];
	        var stri = String(ai);
	        if(seen[stri]) continue;
	        seen[stri] = 1;
	
	        if(typeof ai === 'boolean') curvecats++;
	        else if(Lib.cleanNumber(ai) !== BADNUM) curvenums++;
	        else if(typeof ai === 'string') curvecats++;
	    }
	
	    return curvecats > curvenums * 2;
	}
	
	// very-loose requirements for multicategory,
	// trace modules that should never auto-type to multicategory
	// should be declared with 'noMultiCategory'
	function multiCategory(a) {
	    return Lib.isArrayOrTypedArray(a[0]) && Lib.isArrayOrTypedArray(a[1]);
	}
	
	},{"../../constants/numerical":692,"../../lib":716,"fast-isnumeric":227}],766:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	var handleTickValueDefaults = _dereq_('./tick_value_defaults');
	var handleTickMarkDefaults = _dereq_('./tick_mark_defaults');
	var handleTickLabelDefaults = _dereq_('./tick_label_defaults');
	var handleCategoryOrderDefaults = _dereq_('./category_order_defaults');
	var handleLineGridDefaults = _dereq_('./line_grid_defaults');
	var setConvert = _dereq_('./set_convert');
	
	/**
	 * options: object containing:
	 *
	 *  letter: 'x' or 'y'
	 *  title: name of the axis (ie 'Colorbar') to go in default title
	 *  font: the default font to inherit
	 *  outerTicks: boolean, should ticks default to outside?
	 *  showGrid: boolean, should gridlines be shown by default?
	 *  noHover: boolean, this axis doesn't support hover effects?
	 *  noTickson: boolean, this axis doesn't support 'tickson'
	 *  data: the plot data, used to manage categories
	 *  bgColor: the plot background color, to calculate default gridline colors
	 *  calendar:
	 *  splomStash:
	 *  visibleDflt: boolean
	 *  reverseDflt: boolean
	 *  automargin: boolean
	 */
	module.exports = function handleAxisDefaults(containerIn, containerOut, coerce, options, layoutOut) {
	    var letter = options.letter;
	    var font = options.font || {};
	    var splomStash = options.splomStash || {};
	
	    var visible = coerce('visible', !options.visibleDflt);
	
	    var axType = containerOut.type;
	
	    if(axType === 'date') {
	        var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
	        handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
	    }
	
	    setConvert(containerOut, layoutOut);
	
	    var autorangeDflt = !containerOut.isValidRange(containerIn.range);
	    if(autorangeDflt && options.reverseDflt) autorangeDflt = 'reversed';
	    var autoRange = coerce('autorange', autorangeDflt);
	    if(autoRange && (axType === 'linear' || axType === '-')) coerce('rangemode');
	
	    coerce('range');
	    containerOut.cleanRange();
	
	    handleCategoryOrderDefaults(containerIn, containerOut, coerce, options);
	
	    if(axType !== 'category' && !options.noHover) coerce('hoverformat');
	
	    var dfltColor = coerce('color');
	    // if axis.color was provided, use it for fonts too; otherwise,
	    // inherit from global font color in case that was provided.
	    // Compare to dflt rather than to containerIn, so we can provide color via
	    // template too.
	    var dfltFontColor = (dfltColor !== layoutAttributes.color.dflt) ? dfltColor : font.color;
	    // try to get default title from splom trace, fallback to graph-wide value
	    var dfltTitle = splomStash.label || layoutOut._dfltTitle[letter];
	
	    handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, {pass: 1});
	    if(!visible) return containerOut;
	
	    coerce('title.text', dfltTitle);
	    Lib.coerceFont(coerce, 'title.font', {
	        family: font.family,
	        size: Math.round(font.size * 1.2),
	        color: dfltFontColor
	    });
	
	    handleTickValueDefaults(containerIn, containerOut, coerce, axType);
	    handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, {pass: 2});
	    handleTickMarkDefaults(containerIn, containerOut, coerce, options);
	    handleLineGridDefaults(containerIn, containerOut, coerce, {
	        dfltColor: dfltColor,
	        bgColor: options.bgColor,
	        showGrid: options.showGrid,
	        attributes: layoutAttributes
	    });
	
	    if(containerOut.showline || containerOut.ticks) coerce('mirror');
	
	    if(options.automargin) coerce('automargin');
	
	    var isMultiCategory = containerOut.type === 'multicategory';
	
	    if(!options.noTickson &&
	        (containerOut.type === 'category' || isMultiCategory) &&
	        (containerOut.ticks || containerOut.showgrid)
	    ) {
	        var ticksonDflt;
	        if(isMultiCategory) ticksonDflt = 'boundaries';
	        coerce('tickson', ticksonDflt);
	    }
	
	    if(isMultiCategory) {
	        var showDividers = coerce('showdividers');
	        if(showDividers) {
	            coerce('dividercolor');
	            coerce('dividerwidth');
	        }
	    }
	
	    return containerOut;
	};
	
	},{"../../lib":716,"../../registry":845,"./category_order_defaults":768,"./layout_attributes":776,"./line_grid_defaults":778,"./set_convert":782,"./tick_label_defaults":783,"./tick_mark_defaults":784,"./tick_value_defaults":785}],767:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	
	var constants = _dereq_('./constants');
	
	
	// convert between axis names (xaxis, xaxis2, etc, elements of gd.layout)
	// and axis id's (x, x2, etc). Would probably have ditched 'xaxis'
	// completely in favor of just 'x' if it weren't ingrained in the API etc.
	exports.id2name = function id2name(id) {
	    if(typeof id !== 'string' || !id.match(constants.AX_ID_PATTERN)) return;
	    var axNum = id.substr(1);
	    if(axNum === '1') axNum = '';
	    return id.charAt(0) + 'axis' + axNum;
	};
	
	exports.name2id = function name2id(name) {
	    if(!name.match(constants.AX_NAME_PATTERN)) return;
	    var axNum = name.substr(5);
	    if(axNum === '1') axNum = '';
	    return name.charAt(0) + axNum;
	};
	
	exports.cleanId = function cleanId(id, axLetter) {
	    if(!id.match(constants.AX_ID_PATTERN)) return;
	    if(axLetter && id.charAt(0) !== axLetter) return;
	
	    var axNum = id.substr(1).replace(/^0+/, '');
	    if(axNum === '1') axNum = '';
	    return id.charAt(0) + axNum;
	};
	
	// get all axis objects, as restricted in listNames
	exports.list = function(gd, axLetter, only2d) {
	    var fullLayout = gd._fullLayout;
	    if(!fullLayout) return [];
	
	    var idList = exports.listIds(gd, axLetter);
	    var out = new Array(idList.length);
	    var i;
	
	    for(i = 0; i < idList.length; i++) {
	        var idi = idList[i];
	        out[i] = fullLayout[idi.charAt(0) + 'axis' + idi.substr(1)];
	    }
	
	    if(!only2d) {
	        var sceneIds3D = fullLayout._subplots.gl3d || [];
	
	        for(i = 0; i < sceneIds3D.length; i++) {
	            var scene = fullLayout[sceneIds3D[i]];
	
	            if(axLetter) out.push(scene[axLetter + 'axis']);
	            else out.push(scene.xaxis, scene.yaxis, scene.zaxis);
	        }
	    }
	
	    return out;
	};
	
	// get all axis ids, optionally restricted by letter
	// this only makes sense for 2d axes
	exports.listIds = function(gd, axLetter) {
	    var fullLayout = gd._fullLayout;
	    if(!fullLayout) return [];
	
	    var subplotLists = fullLayout._subplots;
	    if(axLetter) return subplotLists[axLetter + 'axis'];
	    return subplotLists.xaxis.concat(subplotLists.yaxis);
	};
	
	// get an axis object from its id 'x','x2' etc
	// optionally, id can be a subplot (ie 'x2y3') and type gets x or y from it
	exports.getFromId = function(gd, id, type) {
	    var fullLayout = gd._fullLayout;
	
	    if(type === 'x') id = id.replace(/y[0-9]*/, '');
	    else if(type === 'y') id = id.replace(/x[0-9]*/, '');
	
	    return fullLayout[exports.id2name(id)];
	};
	
	// get an axis object of specified type from the containing trace
	exports.getFromTrace = function(gd, fullTrace, type) {
	    var fullLayout = gd._fullLayout;
	    var ax = null;
	
	    if(Registry.traceIs(fullTrace, 'gl3d')) {
	        var scene = fullTrace.scene;
	        if(scene.substr(0, 5) === 'scene') {
	            ax = fullLayout[scene][type + 'axis'];
	        }
	    } else {
	        ax = exports.getFromId(gd, fullTrace[type + 'axis'] || type);
	    }
	
	    return ax;
	};
	
	// sort x, x2, x10, y, y2, y10...
	exports.idSort = function(id1, id2) {
	    var letter1 = id1.charAt(0);
	    var letter2 = id2.charAt(0);
	    if(letter1 !== letter2) return letter1 > letter2 ? 1 : -1;
	    return +(id1.substr(1) || 1) - +(id2.substr(1) || 1);
	};
	
	exports.getAxisGroup = function getAxisGroup(fullLayout, axId) {
	    var matchGroups = fullLayout._axisMatchGroups;
	
	    for(var i = 0; i < matchGroups.length; i++) {
	        var group = matchGroups[i];
	        if(group[axId]) return 'g' + i;
	    }
	    return axId;
	};
	
	},{"../../registry":845,"./constants":770}],768:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	function findCategories(ax, opts) {
	    var dataAttr = opts.dataAttr || ax._id.charAt(0);
	    var lookup = {};
	    var axData;
	    var i, j;
	
	    if(opts.axData) {
	        // non-x/y case
	        axData = opts.axData;
	    } else {
	        // x/y case
	        axData = [];
	        for(i = 0; i < opts.data.length; i++) {
	            var trace = opts.data[i];
	            if(trace[dataAttr + 'axis'] === ax._id) {
	                axData.push(trace);
	            }
	        }
	    }
	
	    for(i = 0; i < axData.length; i++) {
	        var vals = axData[i][dataAttr];
	        for(j = 0; j < vals.length; j++) {
	            var v = vals[j];
	            if(v !== null && v !== undefined) {
	                lookup[v] = 1;
	            }
	        }
	    }
	
	    return Object.keys(lookup);
	}
	
	/**
	 * Fills in category* default and initial categories.
	 *
	 * @param {object} containerIn : input axis object
	 * @param {object} containerOut : full axis object
	 * @param {function} coerce : Lib.coerce fn wrapper
	 * @param {object} opts :
	 *   - data {array} : (full) data trace
	 * OR
	 *   - axData {array} : (full) data associated with axis being coerced here
	 *   - dataAttr {string} : attribute name corresponding to coordinate array
	 */
	module.exports = function handleCategoryOrderDefaults(containerIn, containerOut, coerce, opts) {
	    if(containerOut.type !== 'category') return;
	
	    var arrayIn = containerIn.categoryarray;
	    var isValidArray = (Array.isArray(arrayIn) && arrayIn.length > 0);
	
	    // override default 'categoryorder' value when non-empty array is supplied
	    var orderDefault;
	    if(isValidArray) orderDefault = 'array';
	
	    var order = coerce('categoryorder', orderDefault);
	    var array;
	
	    // coerce 'categoryarray' only in array order case
	    if(order === 'array') {
	        array = coerce('categoryarray');
	    }
	
	    // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
	    if(!isValidArray && order === 'array') {
	        order = containerOut.categoryorder = 'trace';
	    }
	
	    // set up things for makeCalcdata
	    if(order === 'trace') {
	        containerOut._initialCategories = [];
	    } else if(order === 'array') {
	        containerOut._initialCategories = array.slice();
	    } else {
	        array = findCategories(containerOut, opts).sort();
	        if(order === 'category ascending') {
	            containerOut._initialCategories = array;
	        } else if(order === 'category descending') {
	            containerOut._initialCategories = array.reverse();
	        }
	    }
	};
	
	},{}],769:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var Lib = _dereq_('../../lib');
	var ONEDAY = _dereq_('../../constants/numerical').ONEDAY;
	
	/**
	 * Return a validated dtick value for this axis
	 *
	 * @param {any} dtick: the candidate dtick. valid values are numbers and strings,
	 *     and further constrained depending on the axis type.
	 * @param {string} axType: the axis type
	 */
	exports.dtick = function(dtick, axType) {
	    var isLog = axType === 'log';
	    var isDate = axType === 'date';
	    var isCat = axType === 'category';
	    var dtickDflt = isDate ? ONEDAY : 1;
	
	    if(!dtick) return dtickDflt;
	
	    if(isNumeric(dtick)) {
	        dtick = Number(dtick);
	        if(dtick <= 0) return dtickDflt;
	        if(isCat) {
	            // category dtick must be positive integers
	            return Math.max(1, Math.round(dtick));
	        }
	        if(isDate) {
	            // date dtick must be at least 0.1ms (our current precision)
	            return Math.max(0.1, dtick);
	        }
	        return dtick;
	    }
	
	    if(typeof dtick !== 'string' || !(isDate || isLog)) {
	        return dtickDflt;
	    }
	
	    var prefix = dtick.charAt(0);
	    var dtickNum = dtick.substr(1);
	    dtickNum = isNumeric(dtickNum) ? Number(dtickNum) : 0;
	
	    if((dtickNum <= 0) || !(
	            // "M<n>" gives ticks every (integer) n months
	            (isDate && prefix === 'M' && dtickNum === Math.round(dtickNum)) ||
	            // "L<f>" gives ticks linearly spaced in data (not in position) every (float) f
	            (isLog && prefix === 'L') ||
	            // "D1" gives powers of 10 with all small digits between, "D2" gives only 2 and 5
	            (isLog && prefix === 'D' && (dtickNum === 1 || dtickNum === 2))
	        )) {
	        return dtickDflt;
	    }
	
	    return dtick;
	};
	
	/**
	 * Return a validated tick0 for this axis
	 *
	 * @param {any} tick0: the candidate tick0. Valid values are numbers and strings,
	 *     further constrained depending on the axis type
	 * @param {string} axType: the axis type
	 * @param {string} calendar: for date axes, the calendar to validate/convert with
	 * @param {any} dtick: an already valid dtick. Only used for D1 and D2 log dticks,
	 *     which do not support tick0 at all.
	 */
	exports.tick0 = function(tick0, axType, calendar, dtick) {
	    if(axType === 'date') {
	        return Lib.cleanDate(tick0, Lib.dateTick0(calendar));
	    }
	    if(dtick === 'D1' || dtick === 'D2') {
	        // D1 and D2 modes ignore tick0 entirely
	        return undefined;
	    }
	    // Aside from date axes, tick0 must be numeric
	    return isNumeric(tick0) ? Number(tick0) : 0;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"fast-isnumeric":227}],770:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	var counterRegex = _dereq_('../../lib/regex').counter;
	
	
	module.exports = {
	
	    idRegex: {
	        x: counterRegex('x'),
	        y: counterRegex('y')
	    },
	
	    attrRegex: counterRegex('[xy]axis'),
	
	    // axis match regular expression
	    xAxisMatch: counterRegex('xaxis'),
	    yAxisMatch: counterRegex('yaxis'),
	
	    // pattern matching axis ids and names
	    // note that this is more permissive than counterRegex, as
	    // id2name, name2id, and cleanId accept "x1" etc
	    AX_ID_PATTERN: /^[xyz][0-9]*$/,
	    AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
	
	    // and for 2D subplots
	    SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
	
	    // pixels to move mouse before you stop clamping to starting point
	    MINDRAG: 8,
	
	    // smallest dimension allowed for a select box
	    MINSELECT: 12,
	
	    // smallest dimension allowed for a zoombox
	    MINZOOM: 20,
	
	    // width of axis drag regions
	    DRAGGERSIZE: 20,
	
	    // max pixels off straight before a lasso select line counts as bent
	    BENDPX: 1.5,
	
	    // delay before a redraw (relayout) after smooth panning and zooming
	    REDRAWDELAY: 50,
	
	    // throttling limit (ms) for selectPoints calls
	    SELECTDELAY: 100,
	
	    // cache ID suffix for throttle
	    SELECTID: '-select',
	
	    // last resort axis ranges for x and y axes if we have no data
	    DFLTRANGEX: [-1, 6],
	    DFLTRANGEY: [-1, 4],
	
	    // Layers to keep trace types in the right order
	    // N.B. each  'unique' plot method must have its own layer
	    traceLayerClasses: [
	        'imagelayer',
	        'heatmaplayer',
	        'contourcarpetlayer', 'contourlayer',
	        'funnellayer', 'waterfalllayer', 'barlayer',
	        'carpetlayer',
	        'violinlayer',
	        'boxlayer',
	        'ohlclayer',
	        'scattercarpetlayer', 'scatterlayer'
	    ],
	
	    clipOnAxisFalseQuery: [
	        '.scatterlayer',
	        '.barlayer',
	        '.funnellayer',
	        '.waterfalllayer'
	    ],
	
	    layerValue2layerClass: {
	        'above traces': 'above',
	        'below traces': 'below'
	    }
	};
	
	},{"../../lib/regex":732}],771:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var id2name = _dereq_('./axis_ids').id2name;
	var scaleZoom = _dereq_('./scale_zoom');
	var makePadFn = _dereq_('./autorange').makePadFn;
	var concatExtremes = _dereq_('./autorange').concatExtremes;
	
	var ALMOST_EQUAL = _dereq_('../../constants/numerical').ALMOST_EQUAL;
	var FROM_BL = _dereq_('../../constants/alignment').FROM_BL;
	
	exports.handleConstraintDefaults = function(containerIn, containerOut, coerce, opts) {
	    var allAxisIds = opts.allAxisIds;
	    var layoutOut = opts.layoutOut;
	    var scaleanchorDflt = opts.scaleanchorDflt;
	    var constrainDflt = opts.constrainDflt;
	    var constraintGroups = layoutOut._axisConstraintGroups;
	    var matchGroups = layoutOut._axisMatchGroups;
	    var axId = containerOut._id;
	    var axLetter = axId.charAt(0);
	    var splomStash = ((layoutOut._splomAxes || {})[axLetter] || {})[axId] || {};
	    var thisID = containerOut._id;
	    var letter = thisID.charAt(0);
	
	    // coerce the constraint mechanics even if this axis has no scaleanchor
	    // because it may be the anchor of another axis.
	    var constrain = coerce('constrain', constrainDflt);
	    Lib.coerce(containerIn, containerOut, {
	        constraintoward: {
	            valType: 'enumerated',
	            values: letter === 'x' ? ['left', 'center', 'right'] : ['bottom', 'middle', 'top'],
	            dflt: letter === 'x' ? 'center' : 'middle'
	        }
	    }, 'constraintoward');
	
	    var matches, matchOpts;
	
	    if((containerIn.matches || splomStash.matches) && !containerOut.fixedrange) {
	        matchOpts = getConstraintOpts(matchGroups, thisID, allAxisIds, layoutOut);
	        matches = Lib.coerce(containerIn, containerOut, {
	            matches: {
	                valType: 'enumerated',
	                values: matchOpts.linkableAxes || [],
	                dflt: splomStash.matches
	            }
	        }, 'matches');
	    }
	
	    // 'matches' wins over 'scaleanchor' (for now)
	    var scaleanchor, scaleOpts;
	
	    if(!matches &&
	       !(containerOut.fixedrange && constrain !== 'domain') &&
	       (containerIn.scaleanchor || scaleanchorDflt)
	     ) {
	        scaleOpts = getConstraintOpts(constraintGroups, thisID, allAxisIds, layoutOut, constrain);
	        scaleanchor = Lib.coerce(containerIn, containerOut, {
	            scaleanchor: {
	                valType: 'enumerated',
	                values: scaleOpts.linkableAxes || []
	            }
	        }, 'scaleanchor', scaleanchorDflt);
	    }
	
	    if(matches) {
	        delete containerOut.constrain;
	        updateConstraintGroups(matchGroups, matchOpts.thisGroup, thisID, matches, 1);
	    } else if(allAxisIds.indexOf(containerIn.matches) !== -1) {
	        Lib.warn('ignored ' + containerOut._name + '.matches: "' +
	            containerIn.matches + '" to avoid either an infinite loop ' +
	            'or because the target axis has fixed range.');
	    }
	
	    if(scaleanchor) {
	        var scaleratio = coerce('scaleratio');
	
	        // TODO: I suppose I could do attribute.min: Number.MIN_VALUE to avoid zero,
	        // but that seems hacky. Better way to say "must be a positive number"?
	        // Of course if you use several super-tiny values you could eventually
	        // force a product of these to zero and all hell would break loose...
	        // Likewise with super-huge values.
	        if(!scaleratio) scaleratio = containerOut.scaleratio = 1;
	
	        updateConstraintGroups(constraintGroups, scaleOpts.thisGroup, thisID, scaleanchor, scaleratio);
	    } else if(allAxisIds.indexOf(containerIn.scaleanchor) !== -1) {
	        Lib.warn('ignored ' + containerOut._name + '.scaleanchor: "' +
	            containerIn.scaleanchor + '" to avoid either an infinite loop ' +
	            'and possibly inconsistent scaleratios, or because the target ' +
	            'axis has fixed range or this axis declares a *matches* constraint.');
	    }
	};
	
	// If this axis is already part of a constraint group, we can't
	// scaleanchor any other axis in that group, or we'd make a loop.
	// Filter allAxisIds to enforce this, also matching axis types.
	function getConstraintOpts(groups, thisID, allAxisIds, layoutOut, constrain) {
	    var doesNotConstrainRange = constrain !== 'range';
	    var thisType = layoutOut[id2name(thisID)].type;
	    var i, j, idj, axj;
	
	    var linkableAxes = [];
	    for(j = 0; j < allAxisIds.length; j++) {
	        idj = allAxisIds[j];
	        if(idj === thisID) continue;
	
	        axj = layoutOut[id2name(idj)];
	        if(axj.type === thisType) {
	            if(!axj.fixedrange) {
	                linkableAxes.push(idj);
	            } else if(doesNotConstrainRange && axj.anchor) {
	                // allow domain constraints on subplots where
	                // BOTH axes have fixedrange:true and constrain:domain
	                var counterAxj = layoutOut[id2name(axj.anchor)];
	                if(counterAxj.fixedrange) {
	                    linkableAxes.push(idj);
	                }
	            }
	        }
	    }
	
	    for(i = 0; i < groups.length; i++) {
	        if(groups[i][thisID]) {
	            var thisGroup = groups[i];
	
	            var linkableAxesNoLoops = [];
	            for(j = 0; j < linkableAxes.length; j++) {
	                idj = linkableAxes[j];
	                if(!thisGroup[idj]) linkableAxesNoLoops.push(idj);
	            }
	            return {linkableAxes: linkableAxesNoLoops, thisGroup: thisGroup};
	        }
	    }
	
	    return {linkableAxes: linkableAxes, thisGroup: null};
	}
	
	/*
	 * Add this axis to the axis constraint groups, which is the collection
	 * of axes that are all constrained together on scale.
	 *
	 * constraintGroups: a list of objects. each object is
	 * {axis_id: scale_within_group}, where scale_within_group is
	 * only important relative to the rest of the group, and defines
	 * the relative scales between all axes in the group
	 *
	 * thisGroup: the group the current axis is already in
	 * thisID: the id if the current axis
	 * scaleanchor: the id of the axis to scale it with
	 * scaleratio: the ratio of this axis to the scaleanchor axis
	 */
	function updateConstraintGroups(constraintGroups, thisGroup, thisID, scaleanchor, scaleratio) {
	    var i, j, groupi, keyj, thisGroupIndex;
	
	    if(thisGroup === null) {
	        thisGroup = {};
	        thisGroup[thisID] = 1;
	        thisGroupIndex = constraintGroups.length;
	        constraintGroups.push(thisGroup);
	    } else {
	        thisGroupIndex = constraintGroups.indexOf(thisGroup);
	    }
	
	    var thisGroupKeys = Object.keys(thisGroup);
	
	    // we know that this axis isn't in any other groups, but we don't know
	    // about the scaleanchor axis. If it is, we need to merge the groups.
	    for(i = 0; i < constraintGroups.length; i++) {
	        groupi = constraintGroups[i];
	        if(i !== thisGroupIndex && groupi[scaleanchor]) {
	            var baseScale = groupi[scaleanchor];
	            for(j = 0; j < thisGroupKeys.length; j++) {
	                keyj = thisGroupKeys[j];
	                groupi[keyj] = baseScale * scaleratio * thisGroup[keyj];
	            }
	            constraintGroups.splice(thisGroupIndex, 1);
	            return;
	        }
	    }
	
	    // otherwise, we insert the new scaleanchor axis as the base scale (1)
	    // in its group, and scale the rest of the group to it
	    if(scaleratio !== 1) {
	        for(j = 0; j < thisGroupKeys.length; j++) {
	            thisGroup[thisGroupKeys[j]] *= scaleratio;
	        }
	    }
	    thisGroup[scaleanchor] = 1;
	}
	
	exports.enforce = function enforce(gd) {
	    var fullLayout = gd._fullLayout;
	    var constraintGroups = fullLayout._axisConstraintGroups || [];
	
	    var i, j, axisID, ax, normScale, mode, factor;
	
	    for(i = 0; i < constraintGroups.length; i++) {
	        var group = constraintGroups[i];
	        var axisIDs = Object.keys(group);
	
	        var minScale = Infinity;
	        var maxScale = 0;
	        // mostly matchScale will be the same as minScale
	        // ie we expand axis ranges to encompass *everything*
	        // that's currently in any of their ranges, but during
	        // autorange of a subset of axes we will ignore other
	        // axes for this purpose.
	        var matchScale = Infinity;
	        var normScales = {};
	        var axes = {};
	        var hasAnyDomainConstraint = false;
	
	        // find the (normalized) scale of each axis in the group
	        for(j = 0; j < axisIDs.length; j++) {
	            axisID = axisIDs[j];
	            axes[axisID] = ax = fullLayout[id2name(axisID)];
	
	            if(ax._inputDomain) ax.domain = ax._inputDomain.slice();
	            else ax._inputDomain = ax.domain.slice();
	
	            if(!ax._inputRange) ax._inputRange = ax.range.slice();
	
	            // set axis scale here so we can use _m rather than
	            // having to calculate it from length and range
	            ax.setScale();
	
	            // abs: inverted scales still satisfy the constraint
	            normScales[axisID] = normScale = Math.abs(ax._m) / group[axisID];
	            minScale = Math.min(minScale, normScale);
	            if(ax.constrain === 'domain' || !ax._constraintShrinkable) {
	                matchScale = Math.min(matchScale, normScale);
	            }
	
	            // this has served its purpose, so remove it
	            delete ax._constraintShrinkable;
	            maxScale = Math.max(maxScale, normScale);
	
	            if(ax.constrain === 'domain') hasAnyDomainConstraint = true;
	        }
	
	        // Do we have a constraint mismatch? Give a small buffer for rounding errors
	        if(minScale > ALMOST_EQUAL * maxScale && !hasAnyDomainConstraint) continue;
	
	        // now increase any ranges we need to until all normalized scales are equal
	        for(j = 0; j < axisIDs.length; j++) {
	            axisID = axisIDs[j];
	            normScale = normScales[axisID];
	            ax = axes[axisID];
	            mode = ax.constrain;
	
	            // even if the scale didn't change, if we're shrinking domain
	            // we need to recalculate in case `constraintoward` changed
	            if(normScale !== matchScale || mode === 'domain') {
	                factor = normScale / matchScale;
	
	                if(mode === 'range') {
	                    scaleZoom(ax, factor);
	                } else {
	                    // mode === 'domain'
	
	                    var inputDomain = ax._inputDomain;
	                    var domainShrunk = (ax.domain[1] - ax.domain[0]) /
	                        (inputDomain[1] - inputDomain[0]);
	                    var rangeShrunk = (ax.r2l(ax.range[1]) - ax.r2l(ax.range[0])) /
	                        (ax.r2l(ax._inputRange[1]) - ax.r2l(ax._inputRange[0]));
	
	                    factor /= domainShrunk;
	
	                    if(factor * rangeShrunk < 1) {
	                        // we've asked to magnify the axis more than we can just by
	                        // enlarging the domain - so we need to constrict range
	                        ax.domain = ax._input.domain = inputDomain.slice();
	                        scaleZoom(ax, factor);
	                        continue;
	                    }
	
	                    if(rangeShrunk < 1) {
	                        // the range has previously been constricted by ^^, but we've
	                        // switched to the domain-constricted regime, so reset range
	                        ax.range = ax._input.range = ax._inputRange.slice();
	                        factor *= rangeShrunk;
	                    }
	
	                    if(ax.autorange) {
	                        /*
	                         * range & factor may need to change because range was
	                         * calculated for the larger scaling, so some pixel
	                         * paddings may get cut off when we reduce the domain.
	                         *
	                         * This is easier than the regular autorange calculation
	                         * because we already know the scaling `m`, but we still
	                         * need to cut out impossible constraints (like
	                         * annotations with super-long arrows). That's what
	                         * outerMin/Max are for - if the expansion was going to
	                         * go beyond the original domain, it must be impossible
	                         */
	                        var rl0 = ax.r2l(ax.range[0]);
	                        var rl1 = ax.r2l(ax.range[1]);
	                        var rangeCenter = (rl0 + rl1) / 2;
	                        var rangeMin = rangeCenter;
	                        var rangeMax = rangeCenter;
	                        var halfRange = Math.abs(rl1 - rangeCenter);
	                        // extra tiny bit for rounding errors, in case we actually
	                        // *are* expanding to the full domain
	                        var outerMin = rangeCenter - halfRange * factor * 1.0001;
	                        var outerMax = rangeCenter + halfRange * factor * 1.0001;
	                        var getPad = makePadFn(ax);
	
	                        updateDomain(ax, factor);
	                        var m = Math.abs(ax._m);
	                        var extremes = concatExtremes(gd, ax);
	                        var minArray = extremes.min;
	                        var maxArray = extremes.max;
	                        var newVal;
	                        var k;
	
	                        for(k = 0; k < minArray.length; k++) {
	                            newVal = minArray[k].val - getPad(minArray[k]) / m;
	                            if(newVal > outerMin && newVal < rangeMin) {
	                                rangeMin = newVal;
	                            }
	                        }
	
	                        for(k = 0; k < maxArray.length; k++) {
	                            newVal = maxArray[k].val + getPad(maxArray[k]) / m;
	                            if(newVal < outerMax && newVal > rangeMax) {
	                                rangeMax = newVal;
	                            }
	                        }
	
	                        var domainExpand = (rangeMax - rangeMin) / (2 * halfRange);
	                        factor /= domainExpand;
	
	                        rangeMin = ax.l2r(rangeMin);
	                        rangeMax = ax.l2r(rangeMax);
	                        ax.range = ax._input.range = (rl0 < rl1) ?
	                            [rangeMin, rangeMax] : [rangeMax, rangeMin];
	                    }
	
	                    updateDomain(ax, factor);
	                }
	            }
	        }
	    }
	};
	
	// For use before autoranging, check if this axis was previously constrained
	// by domain but no longer is
	exports.clean = function clean(gd, ax) {
	    if(ax._inputDomain) {
	        var isConstrained = false;
	        var axId = ax._id;
	        var constraintGroups = gd._fullLayout._axisConstraintGroups;
	        for(var j = 0; j < constraintGroups.length; j++) {
	            if(constraintGroups[j][axId]) {
	                isConstrained = true;
	                break;
	            }
	        }
	        if(!isConstrained || ax.constrain !== 'domain') {
	            ax._input.domain = ax.domain = ax._inputDomain;
	            delete ax._inputDomain;
	        }
	    }
	};
	
	function updateDomain(ax, factor) {
	    var inputDomain = ax._inputDomain;
	    var centerFraction = FROM_BL[ax.constraintoward];
	    var center = inputDomain[0] + (inputDomain[1] - inputDomain[0]) * centerFraction;
	
	    ax.domain = ax._input.domain = [
	        center + (inputDomain[0] - center) / factor,
	        center + (inputDomain[1] - center) / factor
	    ];
	    ax.setScale();
	}
	
	},{"../../constants/alignment":685,"../../constants/numerical":692,"../../lib":716,"./autorange":763,"./axis_ids":767,"./scale_zoom":780}],772:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	var supportsPassive = _dereq_('has-passive-events');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Fx = _dereq_('../../components/fx');
	var Axes = _dereq_('./axes');
	var setCursor = _dereq_('../../lib/setcursor');
	var dragElement = _dereq_('../../components/dragelement');
	var FROM_TL = _dereq_('../../constants/alignment').FROM_TL;
	var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
	var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
	
	var Plots = _dereq_('../plots');
	
	var getFromId = _dereq_('./axis_ids').getFromId;
	var prepSelect = _dereq_('./select').prepSelect;
	var clearSelect = _dereq_('./select').clearSelect;
	var selectOnClick = _dereq_('./select').selectOnClick;
	var scaleZoom = _dereq_('./scale_zoom');
	
	var constants = _dereq_('./constants');
	var MINDRAG = constants.MINDRAG;
	var MINZOOM = constants.MINZOOM;
	
	// flag for showing "doubleclick to zoom out" only at the beginning
	var SHOWZOOMOUTTIP = true;
	
	// dragBox: create an element to drag one or more axis ends
	// inputs:
	//      plotinfo - which subplot are we making dragboxes on?
	//      x,y,w,h - left, top, width, height of the box
	//      ns - how does this drag the vertical axis?
	//          'n' - top only
	//          's' - bottom only
	//          'ns' - top and bottom together, difference unchanged
	//      ew - same for horizontal axis
	function makeDragBox(gd, plotinfo, x, y, w, h, ns, ew) {
	    // mouseDown stores ms of first mousedown event in the last
	    // `gd._context.doubleClickDelay` ms on the drag bars
	    // numClicks stores how many mousedowns have been seen
	    // within `gd._context.doubleClickDelay` so we can check for click or doubleclick events
	    // dragged stores whether a drag has occurred, so we don't have to
	    // redraw unnecessarily, ie if no move bigger than MINDRAG or MINZOOM px
	    var zoomlayer = gd._fullLayout._zoomlayer;
	    var isMainDrag = (ns + ew === 'nsew');
	    var singleEnd = (ns + ew).length === 1;
	
	    // main subplot x and y (i.e. found in plotinfo - the main ones)
	    var xa0, ya0;
	    // {ax._id: ax} hash objects
	    var xaHash, yaHash;
	    // xaHash/yaHash values (arrays)
	    var xaxes, yaxes;
	    // main axis offsets
	    var xs, ys;
	    // main axis lengths
	    var pw, ph;
	    // contains keys 'xaHash', 'yaHash', 'xaxes', and 'yaxes'
	    // which are the x/y {ax._id: ax} hash objects and their values
	    // for linked axis relative to this subplot
	    var links;
	    // similar to `links` but for matching axes
	    var matches;
	    // set to ew/ns val when active, set to '' when inactive
	    var xActive, yActive;
	    // are all axes in this subplot are fixed?
	    var allFixedRanges;
	    // do we need to edit x/y ranges?
	    var editX, editY;
	    // graph-wide optimization flags
	    var hasScatterGl, hasSplom, hasSVG;
	    // collected changes to be made to the plot by relayout at the end
	    var updates;
	
	    function recomputeAxisLists() {
	        xa0 = plotinfo.xaxis;
	        ya0 = plotinfo.yaxis;
	        pw = xa0._length;
	        ph = ya0._length;
	        xs = xa0._offset;
	        ys = ya0._offset;
	
	        xaHash = {};
	        xaHash[xa0._id] = xa0;
	        yaHash = {};
	        yaHash[ya0._id] = ya0;
	
	        // if we're dragging two axes at once, also drag overlays
	        if(ns && ew) {
	            var overlays = plotinfo.overlays;
	            for(var i = 0; i < overlays.length; i++) {
	                var xa = overlays[i].xaxis;
	                xaHash[xa._id] = xa;
	                var ya = overlays[i].yaxis;
	                yaHash[ya._id] = ya;
	            }
	        }
	
	        xaxes = hashValues(xaHash);
	        yaxes = hashValues(yaHash);
	        xActive = isDirectionActive(xaxes, ew);
	        yActive = isDirectionActive(yaxes, ns);
	        allFixedRanges = !yActive && !xActive;
	
	        links = calcLinks(gd, gd._fullLayout._axisConstraintGroups, xaHash, yaHash);
	        matches = calcLinks(gd, gd._fullLayout._axisMatchGroups, xaHash, yaHash);
	        editX = ew || links.isSubplotConstrained || matches.isSubplotConstrained;
	        editY = ns || links.isSubplotConstrained || matches.isSubplotConstrained;
	
	        var fullLayout = gd._fullLayout;
	        hasScatterGl = fullLayout._has('scattergl');
	        hasSplom = fullLayout._has('splom');
	        hasSVG = fullLayout._has('svg');
	    }
	
	    recomputeAxisLists();
	
	    var cursor = getDragCursor(yActive + xActive, gd._fullLayout.dragmode, isMainDrag);
	    var dragger = makeRectDragger(plotinfo, ns + ew + 'drag', cursor, x, y, w, h);
	
	    // still need to make the element if the axes are disabled
	    // but nuke its events (except for maindrag which needs them for hover)
	    // and stop there
	    if(allFixedRanges && !isMainDrag) {
	        dragger.onmousedown = null;
	        dragger.style.pointerEvents = 'none';
	        return dragger;
	    }
	
	    var dragOptions = {
	        element: dragger,
	        gd: gd,
	        plotinfo: plotinfo
	    };
	
	    dragOptions.prepFn = function(e, startX, startY) {
	        var dragModePrev = dragOptions.dragmode;
	        var dragModeNow = gd._fullLayout.dragmode;
	        if(dragModeNow !== dragModePrev) {
	            dragOptions.dragmode = dragModeNow;
	        }
	
	        recomputeAxisLists();
	
	        if(!allFixedRanges) {
	            if(isMainDrag) {
	                // main dragger handles all drag modes, and changes
	                // to pan (or to zoom if it already is pan) on shift
	                if(e.shiftKey) {
	                    if(dragModeNow === 'pan') dragModeNow = 'zoom';
	                    else if(!isSelectOrLasso(dragModeNow)) dragModeNow = 'pan';
	                } else if(e.ctrlKey) {
	                    dragModeNow = 'pan';
	                }
	            } else {
	                // all other draggers just pan
	                dragModeNow = 'pan';
	            }
	        }
	
	        if(dragModeNow === 'lasso') dragOptions.minDrag = 1;
	        else dragOptions.minDrag = undefined;
	
	        if(isSelectOrLasso(dragModeNow)) {
	            dragOptions.xaxes = xaxes;
	            dragOptions.yaxes = yaxes;
	            // this attaches moveFn, clickFn, doneFn on dragOptions
	            prepSelect(e, startX, startY, dragOptions, dragModeNow);
	        } else {
	            dragOptions.clickFn = clickFn;
	            if(isSelectOrLasso(dragModePrev)) {
	                // TODO Fix potential bug
	                // Note: clearing / resetting selection state only happens, when user
	                // triggers at least one interaction in pan/zoom mode. Otherwise, the
	                // select/lasso outlines are deleted (in plots.js.cleanPlot) but the selection
	                // cache isn't cleared. So when the user switches back to select/lasso and
	                // 'adds to a selection' with Shift, the "old", seemingly removed outlines
	                // are redrawn again because the selection cache still holds their coordinates.
	                // However, this isn't easily solved, since plots.js would need
	                // to have a reference to the dragOptions object (which holds the
	                // selection cache).
	                clearAndResetSelect();
	            }
	
	            if(!allFixedRanges) {
	                if(dragModeNow === 'zoom') {
	                    dragOptions.moveFn = zoomMove;
	                    dragOptions.doneFn = zoomDone;
	
	                    // zoomMove takes care of the threshold, but we need to
	                    // minimize this so that constrained zoom boxes will flip
	                    // orientation at the right place
	                    dragOptions.minDrag = 1;
	
	                    zoomPrep(e, startX, startY);
	                } else if(dragModeNow === 'pan') {
	                    dragOptions.moveFn = plotDrag;
	                    dragOptions.doneFn = dragTail;
	                }
	            }
	        }
	
	        gd._fullLayout._redrag = function() {
	            var dragDataNow = gd._dragdata;
	
	            if(dragDataNow && dragDataNow.element === dragger) {
	                var dragModeNow = gd._fullLayout.dragmode;
	
	                if(!isSelectOrLasso(dragModeNow)) {
	                    recomputeAxisLists();
	                    updateSubplots([0, 0, pw, ph]);
	                    dragOptions.moveFn(dragDataNow.dx, dragDataNow.dy);
	                }
	
	                // TODO should we try to "re-select" under select/lasso modes?
	                // probably best to wait for https://github.com/plotly/plotly.js/issues/1851
	            }
	        };
	    };
	
	    function clearAndResetSelect() {
	        // clear selection polygon cache (if any)
	        dragOptions.plotinfo.selection = false;
	        // clear selection outlines
	        clearSelect(gd);
	    }
	
	    function clickFn(numClicks, evt) {
	        var clickmode = gd._fullLayout.clickmode;
	
	        removeZoombox(gd);
	
	        if(numClicks === 2 && !singleEnd) doubleClick();
	
	        if(isMainDrag) {
	            if(clickmode.indexOf('select') > -1) {
	                selectOnClick(evt, gd, xaxes, yaxes, plotinfo.id, dragOptions);
	            }
	
	            if(clickmode.indexOf('event') > -1) {
	                Fx.click(gd, evt, plotinfo.id);
	            }
	        } else if(numClicks === 1 && singleEnd) {
	            var ax = ns ? ya0 : xa0;
	            var end = (ns === 's' || ew === 'w') ? 0 : 1;
	            var attrStr = ax._name + '.range[' + end + ']';
	            var initialText = getEndText(ax, end);
	            var hAlign = 'left';
	            var vAlign = 'middle';
	
	            if(ax.fixedrange) return;
	
	            if(ns) {
	                vAlign = (ns === 'n') ? 'top' : 'bottom';
	                if(ax.side === 'right') hAlign = 'right';
	            } else if(ew === 'e') hAlign = 'right';
	
	            if(gd._context.showAxisRangeEntryBoxes) {
	                d3.select(dragger)
	                    .call(svgTextUtils.makeEditable, {
	                        gd: gd,
	                        immediate: true,
	                        background: gd._fullLayout.paper_bgcolor,
	                        text: String(initialText),
	                        fill: ax.tickfont ? ax.tickfont.color : '#444',
	                        horizontalAlign: hAlign,
	                        verticalAlign: vAlign
	                    })
	                    .on('edit', function(text) {
	                        var v = ax.d2r(text);
	                        if(v !== undefined) {
	                            Registry.call('_guiRelayout', gd, attrStr, v);
	                        }
	                    });
	            }
	        }
	    }
	
	    dragElement.init(dragOptions);
	
	    // x/y px position at start of drag
	    var x0, y0;
	    // bbox object of the zoombox
	    var box;
	    // luminance of bg behind zoombox
	    var lum;
	    // zoombox path outline
	    var path0;
	    // is zoombox dimmed (during drag)
	    var dimmed;
	    // 'x'-only, 'y' or 'xy' zooming
	    var zoomMode;
	    // zoombox d3 selection
	    var zb;
	    // zoombox corner d3 selection
	    var corners;
	    // zoom takes over minDrag, so it also has to take over gd._dragged
	    var zoomDragged;
	
	    function zoomPrep(e, startX, startY) {
	        var dragBBox = dragger.getBoundingClientRect();
	        x0 = startX - dragBBox.left;
	        y0 = startY - dragBBox.top;
	        box = {l: x0, r: x0, w: 0, t: y0, b: y0, h: 0};
	        lum = gd._hmpixcount ?
	            (gd._hmlumcount / gd._hmpixcount) :
	            tinycolor(gd._fullLayout.plot_bgcolor).getLuminance();
	        path0 = 'M0,0H' + pw + 'V' + ph + 'H0V0';
	        dimmed = false;
	        zoomMode = 'xy';
	        zoomDragged = false;
	        zb = makeZoombox(zoomlayer, lum, xs, ys, path0);
	        corners = makeCorners(zoomlayer, xs, ys);
	    }
	
	    function zoomMove(dx0, dy0) {
	        if(gd._transitioningWithDuration) {
	            return false;
	        }
	
	        var x1 = Math.max(0, Math.min(pw, dx0 + x0));
	        var y1 = Math.max(0, Math.min(ph, dy0 + y0));
	        var dx = Math.abs(x1 - x0);
	        var dy = Math.abs(y1 - y0);
	
	        box.l = Math.min(x0, x1);
	        box.r = Math.max(x0, x1);
	        box.t = Math.min(y0, y1);
	        box.b = Math.max(y0, y1);
	
	        function noZoom() {
	            zoomMode = '';
	            box.r = box.l;
	            box.t = box.b;
	            corners.attr('d', 'M0,0Z');
	        }
	
	        if(links.isSubplotConstrained) {
	            if(dx > MINZOOM || dy > MINZOOM) {
	                zoomMode = 'xy';
	                if(dx / pw > dy / ph) {
	                    dy = dx * ph / pw;
	                    if(y0 > y1) box.t = y0 - dy;
	                    else box.b = y0 + dy;
	                } else {
	                    dx = dy * pw / ph;
	                    if(x0 > x1) box.l = x0 - dx;
	                    else box.r = x0 + dx;
	                }
	                corners.attr('d', xyCorners(box));
	            } else {
	                noZoom();
	            }
	        } else if(matches.isSubplotConstrained) {
	            if(dx > MINZOOM || dy > MINZOOM) {
	                zoomMode = 'xy';
	
	                var r0 = Math.min(box.l / pw, (ph - box.b) / ph);
	                var r1 = Math.max(box.r / pw, (ph - box.t) / ph);
	
	                box.l = r0 * pw;
	                box.r = r1 * pw;
	                box.b = (1 - r0) * ph;
	                box.t = (1 - r1) * ph;
	                corners.attr('d', xyCorners(box));
	            } else {
	                noZoom();
	            }
	        } else if(!yActive || dy < Math.min(Math.max(dx * 0.6, MINDRAG), MINZOOM)) {
	            // look for small drags in one direction or the other,
	            // and only drag the other axis
	
	            if(dx < MINDRAG || !xActive) {
	                noZoom();
	            } else {
	                box.t = 0;
	                box.b = ph;
	                zoomMode = 'x';
	                corners.attr('d', xCorners(box, y0));
	            }
	        } else if(!xActive || dx < Math.min(dy * 0.6, MINZOOM)) {
	            box.l = 0;
	            box.r = pw;
	            zoomMode = 'y';
	            corners.attr('d', yCorners(box, x0));
	        } else {
	            zoomMode = 'xy';
	            corners.attr('d', xyCorners(box));
	        }
	        box.w = box.r - box.l;
	        box.h = box.b - box.t;
	
	        if(zoomMode) zoomDragged = true;
	        gd._dragged = zoomDragged;
	
	        updateZoombox(zb, corners, box, path0, dimmed, lum);
	        computeZoomUpdates();
	        gd.emit('plotly_relayouting', updates);
	        dimmed = true;
	    }
	
	    function computeZoomUpdates() {
	        updates = {};
	
	        // TODO: edit linked axes in zoomAxRanges and in dragTail
	        if(zoomMode === 'xy' || zoomMode === 'x') {
	            zoomAxRanges(xaxes, box.l / pw, box.r / pw, updates, links.xaxes);
	            updateMatchedAxRange('x', updates);
	        }
	        if(zoomMode === 'xy' || zoomMode === 'y') {
	            zoomAxRanges(yaxes, (ph - box.b) / ph, (ph - box.t) / ph, updates, links.yaxes);
	            updateMatchedAxRange('y', updates);
	        }
	    }
	
	    function zoomDone() {
	        computeZoomUpdates();
	        removeZoombox(gd);
	        dragTail();
	        showDoubleClickNotifier(gd);
	    }
	
	    // scroll zoom, on all draggers except corners
	    var scrollViewBox = [0, 0, pw, ph];
	    // wait a little after scrolling before redrawing
	    var redrawTimer = null;
	    var REDRAWDELAY = constants.REDRAWDELAY;
	    var mainplot = plotinfo.mainplot ? gd._fullLayout._plots[plotinfo.mainplot] : plotinfo;
	
	    function zoomWheel(e) {
	        // deactivate mousewheel scrolling on embedded graphs
	        // devs can override this with layout._enablescrollzoom,
	        // but _ ensures this setting won't leave their page
	        if(!gd._context._scrollZoom.cartesian && !gd._fullLayout._enablescrollzoom) {
	            return;
	        }
	
	        clearAndResetSelect();
	
	        // If a transition is in progress, then disable any behavior:
	        if(gd._transitioningWithDuration) {
	            e.preventDefault();
	            e.stopPropagation();
	            return;
	        }
	
	        recomputeAxisLists();
	
	        clearTimeout(redrawTimer);
	
	        var wheelDelta = -e.deltaY;
	        if(!isFinite(wheelDelta)) wheelDelta = e.wheelDelta / 10;
	        if(!isFinite(wheelDelta)) {
	            Lib.log('Did not find wheel motion attributes: ', e);
	            return;
	        }
	
	        var zoom = Math.exp(-Math.min(Math.max(wheelDelta, -20), 20) / 200);
	        var gbb = mainplot.draglayer.select('.nsewdrag').node().getBoundingClientRect();
	        var xfrac = (e.clientX - gbb.left) / gbb.width;
	        var yfrac = (gbb.bottom - e.clientY) / gbb.height;
	        var i;
	
	        function zoomWheelOneAxis(ax, centerFraction, zoom) {
	            if(ax.fixedrange) return;
	
	            var axRange = Lib.simpleMap(ax.range, ax.r2l);
	            var v0 = axRange[0] + (axRange[1] - axRange[0]) * centerFraction;
	            function doZoom(v) { return ax.l2r(v0 + (v - v0) * zoom); }
	            ax.range = axRange.map(doZoom);
	        }
	
	        if(editX) {
	            // if we're only zooming this axis because of constraints,
	            // zoom it about the center
	            if(!ew) xfrac = 0.5;
	
	            for(i = 0; i < xaxes.length; i++) {
	                zoomWheelOneAxis(xaxes[i], xfrac, zoom);
	            }
	            updateMatchedAxRange('x');
	
	            scrollViewBox[2] *= zoom;
	            scrollViewBox[0] += scrollViewBox[2] * xfrac * (1 / zoom - 1);
	        }
	        if(editY) {
	            if(!ns) yfrac = 0.5;
	
	            for(i = 0; i < yaxes.length; i++) {
	                zoomWheelOneAxis(yaxes[i], yfrac, zoom);
	            }
	            updateMatchedAxRange('y');
	
	            scrollViewBox[3] *= zoom;
	            scrollViewBox[1] += scrollViewBox[3] * (1 - yfrac) * (1 / zoom - 1);
	        }
	
	        // viewbox redraw at first
	        updateSubplots(scrollViewBox);
	        ticksAndAnnotations();
	
	        gd.emit('plotly_relayouting', updates);
	
	        // then replot after a delay to make sure
	        // no more scrolling is coming
	        redrawTimer = setTimeout(function() {
	            scrollViewBox = [0, 0, pw, ph];
	            dragTail();
	        }, REDRAWDELAY);
	
	        e.preventDefault();
	        return;
	    }
	
	    // everything but the corners gets wheel zoom
	    if(ns.length * ew.length !== 1) {
	        attachWheelEventHandler(dragger, zoomWheel);
	    }
	
	    // plotDrag: move the plot in response to a drag
	    function plotDrag(dx, dy) {
	        // If a transition is in progress, then disable any behavior:
	        if(gd._transitioningWithDuration) {
	            return;
	        }
	
	        // prevent axis drawing from monkeying with margins until we're done
	        gd._fullLayout._replotting = true;
	
	        if(xActive === 'ew' || yActive === 'ns') {
	            if(xActive) {
	                dragAxList(xaxes, dx);
	                updateMatchedAxRange('x');
	            }
	            if(yActive) {
	                dragAxList(yaxes, dy);
	                updateMatchedAxRange('y');
	            }
	            updateSubplots([xActive ? -dx : 0, yActive ? -dy : 0, pw, ph]);
	            ticksAndAnnotations();
	            gd.emit('plotly_relayouting', updates);
	            return;
	        }
	
	        // dz: set a new value for one end (0 or 1) of an axis array axArray,
	        // and return a pixel shift for that end for the viewbox
	        // based on pixel drag distance d
	        // TODO: this makes (generally non-fatal) errors when you get
	        // near floating point limits
	        function dz(axArray, end, d) {
	            var otherEnd = 1 - end;
	            var movedAx;
	            var newLinearizedEnd;
	            for(var i = 0; i < axArray.length; i++) {
	                var axi = axArray[i];
	                if(axi.fixedrange) continue;
	                movedAx = axi;
	                newLinearizedEnd = axi._rl[otherEnd] +
	                    (axi._rl[end] - axi._rl[otherEnd]) / dZoom(d / axi._length);
	                var newEnd = axi.l2r(newLinearizedEnd);
	
	                // if l2r comes back false or undefined, it means we've dragged off
	                // the end of valid ranges - so stop.
	                if(newEnd !== false && newEnd !== undefined) axi.range[end] = newEnd;
	            }
	            return movedAx._length * (movedAx._rl[end] - newLinearizedEnd) /
	                (movedAx._rl[end] - movedAx._rl[otherEnd]);
	        }
	
	        if(links.isSubplotConstrained && xActive && yActive) {
	            // dragging a corner of a constrained subplot:
	            // respect the fixed corner, but harmonize dx and dy
	            var dxySign = ((xActive === 'w') === (yActive === 'n')) ? 1 : -1;
	            var dxyFraction = (dx / pw + dxySign * dy / ph) / 2;
	            dx = dxyFraction * pw;
	            dy = dxySign * dxyFraction * ph;
	        }
	
	        if(xActive === 'w') dx = dz(xaxes, 0, dx);
	        else if(xActive === 'e') dx = dz(xaxes, 1, -dx);
	        else if(!xActive) dx = 0;
	
	        if(yActive === 'n') dy = dz(yaxes, 1, dy);
	        else if(yActive === 's') dy = dz(yaxes, 0, -dy);
	        else if(!yActive) dy = 0;
	
	        var xStart = (xActive === 'w') ? dx : 0;
	        var yStart = (yActive === 'n') ? dy : 0;
	
	        if(links.isSubplotConstrained) {
	            var i;
	            if(!xActive && yActive.length === 1) {
	                // dragging one end of the y axis of a constrained subplot
	                // scale the other axis the same about its middle
	                for(i = 0; i < xaxes.length; i++) {
	                    xaxes[i].range = xaxes[i]._r.slice();
	                    scaleZoom(xaxes[i], 1 - dy / ph);
	                }
	                dx = dy * pw / ph;
	                xStart = dx / 2;
	            }
	            if(!yActive && xActive.length === 1) {
	                for(i = 0; i < yaxes.length; i++) {
	                    yaxes[i].range = yaxes[i]._r.slice();
	                    scaleZoom(yaxes[i], 1 - dx / pw);
	                }
	                dy = dx * ph / pw;
	                yStart = dy / 2;
	            }
	        }
	
	        updateMatchedAxRange('x');
	        updateMatchedAxRange('y');
	        updateSubplots([xStart, yStart, pw - dx, ph - dy]);
	        ticksAndAnnotations();
	        gd.emit('plotly_relayouting', updates);
	    }
	
	    function updateMatchedAxRange(axLetter, out) {
	        var matchedAxes = matches.isSubplotConstrained ?
	            {x: yaxes, y: xaxes}[axLetter] :
	            matches[axLetter + 'axes'];
	
	        var constrainedAxes = matches.isSubplotConstrained ?
	            {x: xaxes, y: yaxes}[axLetter] :
	            [];
	
	        for(var i = 0; i < matchedAxes.length; i++) {
	            var ax = matchedAxes[i];
	            var axId = ax._id;
	            var axId2 = matches.xLinks[axId] || matches.yLinks[axId];
	            var ax2 = constrainedAxes[0] || xaHash[axId2] || yaHash[axId2];
	
	            if(ax2) {
	                if(out) {
	                    // zoombox case - don't mutate 'range', just add keys in 'updates'
	                    out[ax._name + '.range[0]'] = out[ax2._name + '.range[0]'];
	                    out[ax._name + '.range[1]'] = out[ax2._name + '.range[1]'];
	                } else {
	                    ax.range = ax2.range.slice();
	                }
	            }
	        }
	    }
	
	    // Draw ticks and annotations (and other components) when ranges change.
	    // Also records the ranges that have changed for use by update at the end.
	    function ticksAndAnnotations() {
	        var activeAxIds = [];
	        var i;
	
	        function pushActiveAxIds(axList) {
	            for(i = 0; i < axList.length; i++) {
	                if(!axList[i].fixedrange) activeAxIds.push(axList[i]._id);
	            }
	        }
	
	        if(editX) {
	            pushActiveAxIds(xaxes);
	            pushActiveAxIds(links.xaxes);
	            pushActiveAxIds(matches.xaxes);
	        }
	        if(editY) {
	            pushActiveAxIds(yaxes);
	            pushActiveAxIds(links.yaxes);
	            pushActiveAxIds(matches.yaxes);
	        }
	
	        updates = {};
	        for(i = 0; i < activeAxIds.length; i++) {
	            var axId = activeAxIds[i];
	            var ax = getFromId(gd, axId);
	            Axes.drawOne(gd, ax, {skipTitle: true});
	            updates[ax._name + '.range[0]'] = ax.range[0];
	            updates[ax._name + '.range[1]'] = ax.range[1];
	        }
	
	        Axes.redrawComponents(gd, activeAxIds);
	    }
	
	    function doubleClick() {
	        if(gd._transitioningWithDuration) return;
	
	        var doubleClickConfig = gd._context.doubleClick;
	
	        var axList = [];
	        if(xActive) axList = axList.concat(xaxes);
	        if(yActive) axList = axList.concat(yaxes);
	        if(matches.xaxes) axList = axList.concat(matches.xaxes);
	        if(matches.yaxes) axList = axList.concat(matches.yaxes);
	
	        var attrs = {};
	        var ax, i, rangeInitial;
	
	        // For reset+autosize mode:
	        // If *any* of the main axes is not at its initial range
	        // (or autoranged, if we have no initial range, to match the logic in
	        // doubleClickConfig === 'reset' below), we reset.
	        // If they are *all* at their initial ranges, then we autosize.
	        if(doubleClickConfig === 'reset+autosize') {
	            doubleClickConfig = 'autosize';
	
	            for(i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                if((ax._rangeInitial && (
	                        ax.range[0] !== ax._rangeInitial[0] ||
	                        ax.range[1] !== ax._rangeInitial[1]
	                    )) ||
	                    (!ax._rangeInitial && !ax.autorange)
	                ) {
	                    doubleClickConfig = 'reset';
	                    break;
	                }
	            }
	        }
	
	        if(doubleClickConfig === 'autosize') {
	            // don't set the linked axes here, so relayout marks them as shrinkable
	            // and we autosize just to the requested axis/axes
	            for(i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                if(!ax.fixedrange) attrs[ax._name + '.autorange'] = true;
	            }
	        } else if(doubleClickConfig === 'reset') {
	            // when we're resetting, reset all linked axes too, so we get back
	            // to the fully-auto-with-constraints situation
	            if(xActive || links.isSubplotConstrained) axList = axList.concat(links.xaxes);
	            if(yActive && !links.isSubplotConstrained) axList = axList.concat(links.yaxes);
	
	            if(links.isSubplotConstrained) {
	                if(!xActive) axList = axList.concat(xaxes);
	                else if(!yActive) axList = axList.concat(yaxes);
	            }
	
	            for(i = 0; i < axList.length; i++) {
	                ax = axList[i];
	
	                if(!ax.fixedrange) {
	                    if(!ax._rangeInitial) {
	                        attrs[ax._name + '.autorange'] = true;
	                    } else {
	                        rangeInitial = ax._rangeInitial;
	                        attrs[ax._name + '.range[0]'] = rangeInitial[0];
	                        attrs[ax._name + '.range[1]'] = rangeInitial[1];
	                    }
	                }
	            }
	        }
	
	        gd.emit('plotly_doubleclick', null);
	        Registry.call('_guiRelayout', gd, attrs);
	    }
	
	    // dragTail - finish a drag event with a redraw
	    function dragTail() {
	        // put the subplot viewboxes back to default (Because we're going to)
	        // be repositioning the data in the relayout. But DON'T call
	        // ticksAndAnnotations again - it's unnecessary and would overwrite `updates`
	        updateSubplots([0, 0, pw, ph]);
	
	        // since we may have been redrawing some things during the drag, we may have
	        // accumulated MathJax promises - wait for them before we relayout.
	        Lib.syncOrAsync([
	            Plots.previousPromises,
	            function() {
	                gd._fullLayout._replotting = false;
	                Registry.call('_guiRelayout', gd, updates);
	            }
	        ], gd);
	    }
	
	    // updateSubplots - find all plot viewboxes that should be
	    // affected by this drag, and update them. look for all plots
	    // sharing an affected axis (including the one being dragged),
	    // includes also scattergl and splom logic.
	    function updateSubplots(viewBox) {
	        var fullLayout = gd._fullLayout;
	        var plotinfos = fullLayout._plots;
	        var subplots = fullLayout._subplots.cartesian;
	        var i, sp, xa, ya;
	
	        if(hasSplom) {
	            Registry.subplotsRegistry.splom.drag(gd);
	        }
	
	        if(hasScatterGl) {
	            for(i = 0; i < subplots.length; i++) {
	                sp = plotinfos[subplots[i]];
	                xa = sp.xaxis;
	                ya = sp.yaxis;
	
	                if(sp._scene) {
	                    var xrng = Lib.simpleMap(xa.range, xa.r2l);
	                    var yrng = Lib.simpleMap(ya.range, ya.r2l);
	                    sp._scene.update({range: [xrng[0], yrng[0], xrng[1], yrng[1]]});
	                }
	            }
	        }
	
	        if(hasSplom || hasScatterGl) {
	            clearGlCanvases(gd);
	            redrawReglTraces(gd);
	        }
	
	        if(hasSVG) {
	            var xScaleFactor = viewBox[2] / xa0._length;
	            var yScaleFactor = viewBox[3] / ya0._length;
	
	            for(i = 0; i < subplots.length; i++) {
	                sp = plotinfos[subplots[i]];
	                xa = sp.xaxis;
	                ya = sp.yaxis;
	
	                var editX2 = editX && !xa.fixedrange && xaHash[xa._id];
	                var editY2 = editY && !ya.fixedrange && yaHash[ya._id];
	
	                var xScaleFactor2, yScaleFactor2;
	                var clipDx, clipDy;
	
	                if(editX2) {
	                    xScaleFactor2 = xScaleFactor;
	                    clipDx = ew ? viewBox[0] : getShift(xa, xScaleFactor2);
	                } else if(matches.xaHash[xa._id]) {
	                    xScaleFactor2 = xScaleFactor;
	                    clipDx = viewBox[0] * xa._length / xa0._length;
	                } else if(matches.yaHash[xa._id]) {
	                    xScaleFactor2 = yScaleFactor;
	                    clipDx = yActive === 'ns' ?
	                        -viewBox[1] * xa._length / ya0._length :
	                        getShift(xa, xScaleFactor2, {n: 'top', s: 'bottom'}[yActive]);
	                } else {
	                    xScaleFactor2 = getLinkedScaleFactor(xa, xScaleFactor, yScaleFactor);
	                    clipDx = scaleAndGetShift(xa, xScaleFactor2);
	                }
	
	                if(editY2) {
	                    yScaleFactor2 = yScaleFactor;
	                    clipDy = ns ? viewBox[1] : getShift(ya, yScaleFactor2);
	                } else if(matches.yaHash[ya._id]) {
	                    yScaleFactor2 = yScaleFactor;
	                    clipDy = viewBox[1] * ya._length / ya0._length;
	                } else if(matches.xaHash[ya._id]) {
	                    yScaleFactor2 = xScaleFactor;
	                    clipDy = xActive === 'ew' ?
	                        -viewBox[0] * ya._length / xa0._length :
	                        getShift(ya, yScaleFactor2, {e: 'right', w: 'left'}[xActive]);
	                } else {
	                    yScaleFactor2 = getLinkedScaleFactor(ya, xScaleFactor, yScaleFactor);
	                    clipDy = scaleAndGetShift(ya, yScaleFactor2);
	                }
	
	                // don't scale at all if neither axis is scalable here
	                if(!xScaleFactor2 && !yScaleFactor2) {
	                    continue;
	                }
	
	                // but if only one is, reset the other axis scaling
	                if(!xScaleFactor2) xScaleFactor2 = 1;
	                if(!yScaleFactor2) yScaleFactor2 = 1;
	
	                var plotDx = xa._offset - clipDx / xScaleFactor2;
	                var plotDy = ya._offset - clipDy / yScaleFactor2;
	
	                // TODO could be more efficient here:
	                // setTranslate and setScale do a lot of extra work
	                // when working independently, should perhaps combine
	                // them into a single routine.
	                sp.clipRect
	                    .call(Drawing.setTranslate, clipDx, clipDy)
	                    .call(Drawing.setScale, xScaleFactor2, yScaleFactor2);
	
	                sp.plot
	                    .call(Drawing.setTranslate, plotDx, plotDy)
	                    .call(Drawing.setScale, 1 / xScaleFactor2, 1 / yScaleFactor2);
	
	                // apply an inverse scale to individual points to counteract
	                // the scale of the trace group.
	                // apply only when scale changes, as adjusting the scale of
	                // all the points can be expansive.
	                if(xScaleFactor2 !== sp.xScaleFactor || yScaleFactor2 !== sp.yScaleFactor) {
	                    Drawing.setPointGroupScale(sp.zoomScalePts, xScaleFactor2, yScaleFactor2);
	                    Drawing.setTextPointsScale(sp.zoomScaleTxt, xScaleFactor2, yScaleFactor2);
	                }
	
	                Drawing.hideOutsideRangePoints(sp.clipOnAxisFalseTraces, sp);
	
	                // update x/y scaleFactor stash
	                sp.xScaleFactor = xScaleFactor2;
	                sp.yScaleFactor = yScaleFactor2;
	            }
	        }
	    }
	
	    // Find the appropriate scaling for this axis, if it's linked to the
	    // dragged axes by constraints. 0 is special, it means this axis shouldn't
	    // ever be scaled (will be converted to 1 if the other axis is scaled)
	    function getLinkedScaleFactor(ax, xScaleFactor, yScaleFactor) {
	        if(ax.fixedrange) return 0;
	
	        if(editX && links.xaHash[ax._id]) {
	            return xScaleFactor;
	        }
	        if(editY && (links.isSubplotConstrained ? links.xaHash : links.yaHash)[ax._id]) {
	            return yScaleFactor;
	        }
	        return 0;
	    }
	
	    function scaleAndGetShift(ax, scaleFactor) {
	        if(scaleFactor) {
	            ax.range = ax._r.slice();
	            scaleZoom(ax, scaleFactor);
	            return getShift(ax, scaleFactor);
	        }
	        return 0;
	    }
	
	    function getShift(ax, scaleFactor, from) {
	        return ax._length * (1 - scaleFactor) * FROM_TL[from || ax.constraintoward || 'middle'];
	    }
	
	    return dragger;
	}
	
	function makeDragger(plotinfo, nodeName, dragClass, cursor) {
	    var dragger3 = Lib.ensureSingle(plotinfo.draglayer, nodeName, dragClass, function(s) {
	        s.classed('drag', true)
	            .style({fill: 'transparent', 'stroke-width': 0})
	            .attr('data-subplot', plotinfo.id);
	    });
	
	    dragger3.call(setCursor, cursor);
	
	    return dragger3.node();
	}
	
	function makeRectDragger(plotinfo, dragClass, cursor, x, y, w, h) {
	    var dragger = makeDragger(plotinfo, 'rect', dragClass, cursor);
	    d3.select(dragger).call(Drawing.setRect, x, y, w, h);
	    return dragger;
	}
	
	function isDirectionActive(axList, activeVal) {
	    for(var i = 0; i < axList.length; i++) {
	        if(!axList[i].fixedrange) return activeVal;
	    }
	    return '';
	}
	
	function getEndText(ax, end) {
	    var initialVal = ax.range[end];
	    var diff = Math.abs(initialVal - ax.range[1 - end]);
	    var dig;
	
	    // TODO: this should basically be ax.r2d but we're doing extra
	    // rounding here... can we clean up at all?
	    if(ax.type === 'date') {
	        return initialVal;
	    } else if(ax.type === 'log') {
	        dig = Math.ceil(Math.max(0, -Math.log(diff) / Math.LN10)) + 3;
	        return d3.format('.' + dig + 'g')(Math.pow(10, initialVal));
	    } else { // linear numeric (or category... but just show numbers here)
	        dig = Math.floor(Math.log(Math.abs(initialVal)) / Math.LN10) -
	            Math.floor(Math.log(diff) / Math.LN10) + 4;
	        return d3.format('.' + String(dig) + 'g')(initialVal);
	    }
	}
	
	function zoomAxRanges(axList, r0Fraction, r1Fraction, updates, linkedAxes) {
	    for(var i = 0; i < axList.length; i++) {
	        var axi = axList[i];
	        if(axi.fixedrange) continue;
	
	        var axRangeLinear0 = axi._rl[0];
	        var axRangeLinearSpan = axi._rl[1] - axRangeLinear0;
	        updates[axi._name + '.range[0]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r0Fraction);
	        updates[axi._name + '.range[1]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r1Fraction);
	    }
	
	    // zoom linked axes about their centers
	    if(linkedAxes && linkedAxes.length) {
	        var linkedR0Fraction = (r0Fraction + (1 - r1Fraction)) / 2;
	        zoomAxRanges(linkedAxes, linkedR0Fraction, 1 - linkedR0Fraction, updates, []);
	    }
	}
	
	function dragAxList(axList, pix) {
	    for(var i = 0; i < axList.length; i++) {
	        var axi = axList[i];
	        if(!axi.fixedrange) {
	            axi.range = [
	                axi.l2r(axi._rl[0] - pix / axi._m),
	                axi.l2r(axi._rl[1] - pix / axi._m)
	            ];
	        }
	    }
	}
	
	// common transform for dragging one end of an axis
	// d>0 is compressing scale (cursor is over the plot,
	//  the axis end should move with the cursor)
	// d<0 is expanding (cursor is off the plot, axis end moves
	//  nonlinearly so you can expand far)
	function dZoom(d) {
	    return 1 - ((d >= 0) ? Math.min(d, 0.9) :
	        1 / (1 / Math.max(d, -0.3) + 3.222));
	}
	
	function getDragCursor(nsew, dragmode, isMainDrag) {
	    if(!nsew) return 'pointer';
	    if(nsew === 'nsew') {
	        // in this case here, clear cursor and
	        // use the cursor style set on <g .draglayer>
	        if(isMainDrag) return '';
	        if(dragmode === 'pan') return 'move';
	        return 'crosshair';
	    }
	    return nsew.toLowerCase() + '-resize';
	}
	
	function makeZoombox(zoomlayer, lum, xs, ys, path0) {
	    return zoomlayer.append('path')
	        .attr('class', 'zoombox')
	        .style({
	            'fill': lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
	            'stroke-width': 0
	        })
	        .attr('transform', 'translate(' + xs + ', ' + ys + ')')
	        .attr('d', path0 + 'Z');
	}
	
	function makeCorners(zoomlayer, xs, ys) {
	    return zoomlayer.append('path')
	        .attr('class', 'zoombox-corners')
	        .style({
	            fill: Color.background,
	            stroke: Color.defaultLine,
	            'stroke-width': 1,
	            opacity: 0
	        })
	        .attr('transform', 'translate(' + xs + ', ' + ys + ')')
	        .attr('d', 'M0,0Z');
	}
	
	function updateZoombox(zb, corners, box, path0, dimmed, lum) {
	    zb.attr('d',
	        path0 + 'M' + (box.l) + ',' + (box.t) + 'v' + (box.h) +
	        'h' + (box.w) + 'v-' + (box.h) + 'h-' + (box.w) + 'Z');
	    transitionZoombox(zb, corners, dimmed, lum);
	}
	
	function transitionZoombox(zb, corners, dimmed, lum) {
	    if(!dimmed) {
	        zb.transition()
	            .style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' :
	                'rgba(255,255,255,0.3)')
	            .duration(200);
	        corners.transition()
	            .style('opacity', 1)
	            .duration(200);
	    }
	}
	
	function removeZoombox(gd) {
	    d3.select(gd)
	        .selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners')
	        .remove();
	}
	
	function showDoubleClickNotifier(gd) {
	    if(SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
	        Lib.notifier(Lib._(gd, 'Double-click to zoom back out'), 'long');
	        SHOWZOOMOUTTIP = false;
	    }
	}
	
	function isSelectOrLasso(dragmode) {
	    return dragmode === 'lasso' || dragmode === 'select';
	}
	
	function xCorners(box, y0) {
	    return 'M' +
	        (box.l - 0.5) + ',' + (y0 - MINZOOM - 0.5) +
	        'h-3v' + (2 * MINZOOM + 1) + 'h3ZM' +
	        (box.r + 0.5) + ',' + (y0 - MINZOOM - 0.5) +
	        'h3v' + (2 * MINZOOM + 1) + 'h-3Z';
	}
	
	function yCorners(box, x0) {
	    return 'M' +
	        (x0 - MINZOOM - 0.5) + ',' + (box.t - 0.5) +
	        'v-3h' + (2 * MINZOOM + 1) + 'v3ZM' +
	        (x0 - MINZOOM - 0.5) + ',' + (box.b + 0.5) +
	        'v3h' + (2 * MINZOOM + 1) + 'v-3Z';
	}
	
	function xyCorners(box) {
	    var clen = Math.floor(Math.min(box.b - box.t, box.r - box.l, MINZOOM) / 2);
	    return 'M' +
	        (box.l - 3.5) + ',' + (box.t - 0.5 + clen) + 'h3v' + (-clen) +
	            'h' + clen + 'v-3h-' + (clen + 3) + 'ZM' +
	        (box.r + 3.5) + ',' + (box.t - 0.5 + clen) + 'h-3v' + (-clen) +
	            'h' + (-clen) + 'v-3h' + (clen + 3) + 'ZM' +
	        (box.r + 3.5) + ',' + (box.b + 0.5 - clen) + 'h-3v' + clen +
	            'h' + (-clen) + 'v3h' + (clen + 3) + 'ZM' +
	        (box.l - 3.5) + ',' + (box.b + 0.5 - clen) + 'h3v' + clen +
	            'h' + clen + 'v3h-' + (clen + 3) + 'Z';
	}
	
	function calcLinks(gd, groups, xaHash, yaHash) {
	    var isSubplotConstrained = false;
	    var xLinks = {};
	    var yLinks = {};
	    var xID, yID, xLinkID, yLinkID;
	
	    for(var i = 0; i < groups.length; i++) {
	        var group = groups[i];
	        // check if any of the x axes we're dragging is in this constraint group
	        for(xID in xaHash) {
	            if(group[xID]) {
	                // put the rest of these axes into xLinks, if we're not already
	                // dragging them, so we know to scale these axes automatically too
	                // to match the changes in the dragged x axes
	                for(xLinkID in group) {
	                    if(!(xLinkID.charAt(0) === 'x' ? xaHash : yaHash)[xLinkID]) {
	                        xLinks[xLinkID] = xID;
	                    }
	                }
	
	                // check if the x and y axes of THIS drag are linked
	                for(yID in yaHash) {
	                    if(group[yID]) isSubplotConstrained = true;
	                }
	            }
	        }
	
	        // now check if any of the y axes we're dragging is in this constraint group
	        // only look for outside links, as we've already checked for links within the dragger
	        for(yID in yaHash) {
	            if(group[yID]) {
	                for(yLinkID in group) {
	                    if(!(yLinkID.charAt(0) === 'x' ? xaHash : yaHash)[yLinkID]) {
	                        yLinks[yLinkID] = yID;
	                    }
	                }
	            }
	        }
	    }
	
	    if(isSubplotConstrained) {
	        // merge xLinks and yLinks if the subplot is constrained,
	        // since we'll always apply both anyway and the two will contain
	        // duplicates
	        Lib.extendFlat(xLinks, yLinks);
	        yLinks = {};
	    }
	
	    var xaHashLinked = {};
	    var xaxesLinked = [];
	    for(xLinkID in xLinks) {
	        var xa = getFromId(gd, xLinkID);
	        xaxesLinked.push(xa);
	        xaHashLinked[xa._id] = xa;
	    }
	
	    var yaHashLinked = {};
	    var yaxesLinked = [];
	    for(yLinkID in yLinks) {
	        var ya = getFromId(gd, yLinkID);
	        yaxesLinked.push(ya);
	        yaHashLinked[ya._id] = ya;
	    }
	
	    return {
	        xaHash: xaHashLinked,
	        yaHash: yaHashLinked,
	        xaxes: xaxesLinked,
	        yaxes: yaxesLinked,
	        xLinks: xLinks,
	        yLinks: yLinks,
	        isSubplotConstrained: isSubplotConstrained
	    };
	}
	
	// still seems to be some confusion about onwheel vs onmousewheel...
	function attachWheelEventHandler(element, handler) {
	    if(!supportsPassive) {
	        if(element.onwheel !== undefined) element.onwheel = handler;
	        else if(element.onmousewheel !== undefined) element.onmousewheel = handler;
	    } else {
	        var wheelEventName = element.onwheel !== undefined ? 'wheel' : 'mousewheel';
	
	        if(element._onwheel) {
	            element.removeEventListener(wheelEventName, element._onwheel);
	        }
	        element._onwheel = handler;
	
	        element.addEventListener(wheelEventName, handler, {passive: false});
	    }
	}
	
	function hashValues(hash) {
	    var out = [];
	    for(var k in hash) out.push(hash[k]);
	    return out;
	}
	
	module.exports = {
	    makeDragBox: makeDragBox,
	
	    makeDragger: makeDragger,
	    makeRectDragger: makeRectDragger,
	    makeZoombox: makeZoombox,
	    makeCorners: makeCorners,
	
	    updateZoombox: updateZoombox,
	    xyCorners: xyCorners,
	    transitionZoombox: transitionZoombox,
	    removeZoombox: removeZoombox,
	    showDoubleClickNotifier: showDoubleClickNotifier,
	
	    attachWheelEventHandler: attachWheelEventHandler
	};
	
	},{"../../components/color":591,"../../components/dragelement":609,"../../components/drawing":612,"../../components/fx":629,"../../constants/alignment":685,"../../lib":716,"../../lib/clear_gl_canvases":701,"../../lib/setcursor":736,"../../lib/svg_text_utils":740,"../../plot_api/subroutines":755,"../../registry":845,"../plots":825,"./axes":764,"./axis_ids":767,"./constants":770,"./scale_zoom":780,"./select":781,"d3":164,"has-passive-events":412,"tinycolor2":535}],773:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Fx = _dereq_('../../components/fx');
	var dragElement = _dereq_('../../components/dragelement');
	var setCursor = _dereq_('../../lib/setcursor');
	
	var makeDragBox = _dereq_('./dragbox').makeDragBox;
	var DRAGGERSIZE = _dereq_('./constants').DRAGGERSIZE;
	
	exports.initInteractions = function initInteractions(gd) {
	    var fullLayout = gd._fullLayout;
	
	    if(gd._context.staticPlot) {
	        // this sweeps up more than just cartesian drag elements...
	        d3.select(gd).selectAll('.drag').remove();
	        return;
	    }
	
	    if(!fullLayout._has('cartesian') && !fullLayout._has('splom')) return;
	
	    var subplots = Object.keys(fullLayout._plots || {}).sort(function(a, b) {
	        // sort overlays last, then by x axis number, then y axis number
	        if((fullLayout._plots[a].mainplot && true) ===
	            (fullLayout._plots[b].mainplot && true)) {
	            var aParts = a.split('y');
	            var bParts = b.split('y');
	            return (aParts[0] === bParts[0]) ?
	                (Number(aParts[1] || 1) - Number(bParts[1] || 1)) :
	                (Number(aParts[0] || 1) - Number(bParts[0] || 1));
	        }
	        return fullLayout._plots[a].mainplot ? 1 : -1;
	    });
	
	    subplots.forEach(function(subplot) {
	        var plotinfo = fullLayout._plots[subplot];
	        var xa = plotinfo.xaxis;
	        var ya = plotinfo.yaxis;
	
	        // main and corner draggers need not be repeated for
	        // overlaid subplots - these draggers drag them all
	        if(!plotinfo.mainplot) {
	            // main dragger goes over the grids and data, so we use its
	            // mousemove events for all data hover effects
	            var maindrag = makeDragBox(gd, plotinfo, xa._offset, ya._offset,
	                xa._length, ya._length, 'ns', 'ew');
	
	            maindrag.onmousemove = function(evt) {
	                // This is on `gd._fullLayout`, *not* fullLayout because the reference
	                // changes by the time this is called again.
	                gd._fullLayout._rehover = function() {
	                    if((gd._fullLayout._hoversubplot === subplot) && gd._fullLayout._plots[subplot]) {
	                        Fx.hover(gd, evt, subplot);
	                    }
	                };
	
	                Fx.hover(gd, evt, subplot);
	
	                // Note that we have *not* used the cached fullLayout variable here
	                // since that may be outdated when this is called as a callback later on
	                gd._fullLayout._lasthover = maindrag;
	                gd._fullLayout._hoversubplot = subplot;
	            };
	
	            /*
	             * IMPORTANT:
	             * We must check for the presence of the drag cover here.
	             * If we don't, a 'mouseout' event is triggered on the
	             * maindrag before each 'click' event, which has the effect
	             * of clearing the hoverdata; thus, cancelling the click event.
	             */
	            maindrag.onmouseout = function(evt) {
	                if(gd._dragging) return;
	
	                // When the mouse leaves this maindrag, unset the hovered subplot.
	                // This may cause problems if it leaves the subplot directly *onto*
	                // another subplot, but that's a tiny corner case at the moment.
	                gd._fullLayout._hoversubplot = null;
	
	                dragElement.unhover(gd, evt);
	            };
	
	            // corner draggers
	            if(gd._context.showAxisDragHandles) {
	                makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset - DRAGGERSIZE,
	                    DRAGGERSIZE, DRAGGERSIZE, 'n', 'w');
	                makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset - DRAGGERSIZE,
	                    DRAGGERSIZE, DRAGGERSIZE, 'n', 'e');
	                makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset + ya._length,
	                    DRAGGERSIZE, DRAGGERSIZE, 's', 'w');
	                makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset + ya._length,
	                    DRAGGERSIZE, DRAGGERSIZE, 's', 'e');
	            }
	        }
	        if(gd._context.showAxisDragHandles) {
	            // x axis draggers - if you have overlaid plots,
	            // these drag each axis separately
	            if(subplot === xa._mainSubplot) {
	                // the y position of the main x axis line
	                var y0 = xa._mainLinePosition;
	                if(xa.side === 'top') y0 -= DRAGGERSIZE;
	                makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.1, y0,
	                    xa._length * 0.8, DRAGGERSIZE, '', 'ew');
	                makeDragBox(gd, plotinfo, xa._offset, y0,
	                    xa._length * 0.1, DRAGGERSIZE, '', 'w');
	                makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.9, y0,
	                    xa._length * 0.1, DRAGGERSIZE, '', 'e');
	            }
	            // y axis draggers
	            if(subplot === ya._mainSubplot) {
	                // the x position of the main y axis line
	                var x0 = ya._mainLinePosition;
	                if(ya.side !== 'right') x0 -= DRAGGERSIZE;
	                makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.1,
	                    DRAGGERSIZE, ya._length * 0.8, 'ns', '');
	                makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.9,
	                    DRAGGERSIZE, ya._length * 0.1, 's', '');
	                makeDragBox(gd, plotinfo, x0, ya._offset,
	                    DRAGGERSIZE, ya._length * 0.1, 'n', '');
	            }
	        }
	    });
	
	    // In case you mousemove over some hovertext, send it to Fx.hover too
	    // we do this so that we can put the hover text in front of everything,
	    // but still be able to interact with everything as if it isn't there
	    var hoverLayer = fullLayout._hoverlayer.node();
	
	    hoverLayer.onmousemove = function(evt) {
	        evt.target = gd._fullLayout._lasthover;
	        Fx.hover(gd, evt, fullLayout._hoversubplot);
	    };
	
	    hoverLayer.onclick = function(evt) {
	        evt.target = gd._fullLayout._lasthover;
	        Fx.click(gd, evt);
	    };
	
	    // also delegate mousedowns... TODO: does this actually work?
	    hoverLayer.onmousedown = function(evt) {
	        gd._fullLayout._lasthover.onmousedown(evt);
	    };
	
	    exports.updateFx(gd);
	};
	
	// Minimal set of update needed on 'modebar' edits.
	// We only need to update the <g .draglayer> cursor style.
	//
	// Note that changing the axis configuration and/or the fixedrange attribute
	// should trigger a full initInteractions.
	exports.updateFx = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
	    setCursor(fullLayout._draggers, cursor);
	};
	
	},{"../../components/dragelement":609,"../../components/fx":629,"../../lib/setcursor":736,"./constants":770,"./dragbox":772,"d3":164}],774:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	/**
	 * Factory function for checking component arrays for subplot references.
	 *
	 * @param {string} containerArrayName: the top-level array in gd.layout to check
	 *   If an item in this container is found that references a cartesian x and/or y axis,
	 *   ensure cartesian is marked as a base plot module and record the axes (and subplot
	 *   if both refs are axes) in gd._fullLayout
	 *
	 * @return {function}: with args layoutIn (gd.layout) and layoutOut (gd._fullLayout)
	 * as expected of a component includeBasePlot method
	 */
	module.exports = function makeIncludeComponents(containerArrayName) {
	    return function includeComponents(layoutIn, layoutOut) {
	        var array = layoutIn[containerArrayName];
	        if(!Array.isArray(array)) return;
	
	        var Cartesian = Registry.subplotsRegistry.cartesian;
	        var idRegex = Cartesian.idRegex;
	        var subplots = layoutOut._subplots;
	        var xaList = subplots.xaxis;
	        var yaList = subplots.yaxis;
	        var cartesianList = subplots.cartesian;
	        var hasCartesianOrGL2D = layoutOut._has('cartesian') || layoutOut._has('gl2d');
	
	        for(var i = 0; i < array.length; i++) {
	            var itemi = array[i];
	            if(!Lib.isPlainObject(itemi)) continue;
	
	            var xref = itemi.xref;
	            var yref = itemi.yref;
	
	            var hasXref = idRegex.x.test(xref);
	            var hasYref = idRegex.y.test(yref);
	            if(hasXref || hasYref) {
	                if(!hasCartesianOrGL2D) Lib.pushUnique(layoutOut._basePlotModules, Cartesian);
	
	                var newAxis = false;
	                if(hasXref && xaList.indexOf(xref) === -1) {
	                    xaList.push(xref);
	                    newAxis = true;
	                }
	                if(hasYref && yaList.indexOf(yref) === -1) {
	                    yaList.push(yref);
	                    newAxis = true;
	                }
	
	                /*
	                 * Notice the logic here: only add a subplot for a component if
	                 * it's referencing both x and y axes AND it's creating a new axis
	                 * so for example if your plot already has xy and x2y2, an annotation
	                 * on x2y or xy2 will not create a new subplot.
	                 */
	                if(newAxis && hasXref && hasYref) {
	                    cartesianList.push(xref + yref);
	                }
	            }
	        }
	    };
	};
	
	},{"../../lib":716,"../../registry":845}],775:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Plots = _dereq_('../plots');
	var Drawing = _dereq_('../../components/drawing');
	
	var getModuleCalcData = _dereq_('../get_data').getModuleCalcData;
	var axisIds = _dereq_('./axis_ids');
	var constants = _dereq_('./constants');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	
	var ensureSingle = Lib.ensureSingle;
	
	function ensureSingleAndAddDatum(parent, nodeType, className) {
	    return Lib.ensureSingle(parent, nodeType, className, function(s) {
	        s.datum(className);
	    });
	}
	
	exports.name = 'cartesian';
	
	exports.attr = ['xaxis', 'yaxis'];
	
	exports.idRoot = ['x', 'y'];
	
	exports.idRegex = constants.idRegex;
	
	exports.attrRegex = constants.attrRegex;
	
	exports.attributes = _dereq_('./attributes');
	
	exports.layoutAttributes = _dereq_('./layout_attributes');
	
	exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
	
	exports.transitionAxes = _dereq_('./transition_axes');
	
	exports.finalizeSubplots = function(layoutIn, layoutOut) {
	    var subplots = layoutOut._subplots;
	    var xList = subplots.xaxis;
	    var yList = subplots.yaxis;
	    var spSVG = subplots.cartesian;
	    var spAll = spSVG.concat(subplots.gl2d || []);
	    var allX = {};
	    var allY = {};
	    var i, xi, yi;
	
	    for(i = 0; i < spAll.length; i++) {
	        var parts = spAll[i].split('y');
	        allX[parts[0]] = 1;
	        allY['y' + parts[1]] = 1;
	    }
	
	    // check for x axes with no subplot, and make one from the anchor of that x axis
	    for(i = 0; i < xList.length; i++) {
	        xi = xList[i];
	        if(!allX[xi]) {
	            yi = (layoutIn[axisIds.id2name(xi)] || {}).anchor;
	            if(!constants.idRegex.y.test(yi)) yi = 'y';
	            spSVG.push(xi + yi);
	            spAll.push(xi + yi);
	
	            if(!allY[yi]) {
	                allY[yi] = 1;
	                Lib.pushUnique(yList, yi);
	            }
	        }
	    }
	
	    // same for y axes with no subplot
	    for(i = 0; i < yList.length; i++) {
	        yi = yList[i];
	        if(!allY[yi]) {
	            xi = (layoutIn[axisIds.id2name(yi)] || {}).anchor;
	            if(!constants.idRegex.x.test(xi)) xi = 'x';
	            spSVG.push(xi + yi);
	            spAll.push(xi + yi);
	
	            if(!allX[xi]) {
	                allX[xi] = 1;
	                Lib.pushUnique(xList, xi);
	            }
	        }
	    }
	
	    // finally, if we've gotten here we're supposed to show cartesian...
	    // so if there are NO subplots at all, make one from the first
	    // x & y axes in the input layout
	    if(!spAll.length) {
	        xi = '';
	        yi = '';
	        for(var ki in layoutIn) {
	            if(constants.attrRegex.test(ki)) {
	                var axLetter = ki.charAt(0);
	                if(axLetter === 'x') {
	                    if(!xi || (+ki.substr(5) < +xi.substr(5))) {
	                        xi = ki;
	                    }
	                } else if(!yi || (+ki.substr(5) < +yi.substr(5))) {
	                    yi = ki;
	                }
	            }
	        }
	        xi = xi ? axisIds.name2id(xi) : 'x';
	        yi = yi ? axisIds.name2id(yi) : 'y';
	        xList.push(xi);
	        yList.push(yi);
	        spSVG.push(xi + yi);
	    }
	};
	
	/**
	 * Cartesian.plot
	 *
	 * @param {DOM div | object} gd
	 * @param {array (optional)} traces
	 *  array of traces indices to plot
	 *  if undefined, plots all cartesian traces,
	 * @param {object} (optional) transitionOpts
	 *  transition option object
	 * @param {function} (optional) makeOnCompleteCallback
	 *  transition make callback function from Plots.transition
	 */
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = gd._fullLayout;
	    var subplots = fullLayout._subplots.cartesian;
	    var calcdata = gd.calcdata;
	    var i;
	
	    if(!Array.isArray(traces)) {
	        // If traces is not provided, then it's a complete replot and missing
	        // traces are removed
	        traces = [];
	        for(i = 0; i < calcdata.length; i++) traces.push(i);
	    }
	
	    for(i = 0; i < subplots.length; i++) {
	        var subplot = subplots[i];
	        var subplotInfo = fullLayout._plots[subplot];
	
	        // Get all calcdata for this subplot:
	        var cdSubplot = [];
	        var pcd;
	
	        for(var j = 0; j < calcdata.length; j++) {
	            var cd = calcdata[j];
	            var trace = cd[0].trace;
	
	            // Skip trace if whitelist provided and it's not whitelisted:
	            // if (Array.isArray(traces) && traces.indexOf(i) === -1) continue;
	            if(trace.xaxis + trace.yaxis === subplot) {
	                // XXX: Should trace carpet dependencies. Only replot all carpet plots if the carpet
	                // axis has actually changed:
	                //
	                // If this trace is specifically requested, add it to the list:
	                if(traces.indexOf(trace.index) !== -1 || trace.carpet) {
	                    // Okay, so example: traces 0, 1, and 2 have fill = tonext. You animate
	                    // traces 0 and 2. Trace 1 also needs to be updated, otherwise its fill
	                    // is outdated. So this retroactively adds the previous trace if the
	                    // traces are interdependent.
	                    if(
	                        pcd &&
	                        pcd[0].trace.xaxis + pcd[0].trace.yaxis === subplot &&
	                        ['tonextx', 'tonexty', 'tonext'].indexOf(trace.fill) !== -1 &&
	                        cdSubplot.indexOf(pcd) === -1
	                    ) {
	                        cdSubplot.push(pcd);
	                    }
	
	                    cdSubplot.push(cd);
	                }
	
	                // Track the previous trace on this subplot for the retroactive-add step
	                // above:
	                pcd = cd;
	            }
	        }
	
	        plotOne(gd, subplotInfo, cdSubplot, transitionOpts, makeOnCompleteCallback);
	    }
	};
	
	function plotOne(gd, plotinfo, cdSubplot, transitionOpts, makeOnCompleteCallback) {
	    var traceLayerClasses = constants.traceLayerClasses;
	    var fullLayout = gd._fullLayout;
	    var modules = fullLayout._modules;
	    var _module, cdModuleAndOthers, cdModule;
	
	    var layerData = [];
	    var zoomScaleQueryParts = [];
	
	    for(var i = 0; i < modules.length; i++) {
	        _module = modules[i];
	        var name = _module.name;
	        var categories = Registry.modules[name].categories;
	
	        if(categories.svg) {
	            var className = (_module.layerName || name + 'layer');
	            var plotMethod = _module.plot;
	
	            // plot all visible traces of this type on this subplot at once
	            cdModuleAndOthers = getModuleCalcData(cdSubplot, plotMethod);
	            cdModule = cdModuleAndOthers[0];
	            // don't need to search the found traces again - in fact we need to NOT
	            // so that if two modules share the same plotter we don't double-plot
	            cdSubplot = cdModuleAndOthers[1];
	
	            if(cdModule.length) {
	                layerData.push({
	                    i: traceLayerClasses.indexOf(className),
	                    className: className,
	                    plotMethod: plotMethod,
	                    cdModule: cdModule
	                });
	            }
	
	            if(categories.zoomScale) {
	                zoomScaleQueryParts.push('.' + className);
	            }
	        }
	    }
	
	    layerData.sort(function(a, b) { return a.i - b.i; });
	
	    var layers = plotinfo.plot.selectAll('g.mlayer')
	        .data(layerData, function(d) { return d.className; });
	
	    layers.enter().append('g')
	        .attr('class', function(d) { return d.className; })
	        .classed('mlayer', true)
	        .classed('rangeplot', plotinfo.isRangePlot);
	
	    layers.exit().remove();
	
	    layers.order();
	
	    layers.each(function(d) {
	        var sel = d3.select(this);
	        var className = d.className;
	
	        d.plotMethod(
	            gd, plotinfo, d.cdModule, sel,
	            transitionOpts, makeOnCompleteCallback
	        );
	
	        // layers that allow `cliponaxis: false`
	        if(constants.clipOnAxisFalseQuery.indexOf('.' + className) === -1) {
	            Drawing.setClipUrl(sel, plotinfo.layerClipId, gd);
	        }
	    });
	
	    // call Scattergl.plot separately
	    if(fullLayout._has('scattergl')) {
	        _module = Registry.getModule('scattergl');
	        cdModule = getModuleCalcData(cdSubplot, _module)[0];
	        _module.plot(gd, plotinfo, cdModule);
	    }
	
	    // stash "hot" selections for faster interaction on drag and scroll
	    if(!gd._context.staticPlot) {
	        if(plotinfo._hasClipOnAxisFalse) {
	            plotinfo.clipOnAxisFalseTraces = plotinfo.plot
	                .selectAll(constants.clipOnAxisFalseQuery.join(','))
	                .selectAll('.trace');
	        }
	
	        if(zoomScaleQueryParts.length) {
	            var traces = plotinfo.plot
	                .selectAll(zoomScaleQueryParts.join(','))
	                .selectAll('.trace');
	
	            plotinfo.zoomScalePts = traces.selectAll('path.point');
	            plotinfo.zoomScaleTxt = traces.selectAll('.textpoint');
	        }
	    }
	}
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldPlots = oldFullLayout._plots || {};
	    var newPlots = newFullLayout._plots || {};
	    var oldSubplotList = oldFullLayout._subplots || {};
	    var plotinfo;
	    var i, k;
	
	    // when going from a large splom graph to something else,
	    // we need to clear <g subplot> so that the new cartesian subplot
	    // can have the correct layer ordering
	    if(oldFullLayout._hasOnlyLargeSploms && !newFullLayout._hasOnlyLargeSploms) {
	        for(k in oldPlots) {
	            plotinfo = oldPlots[k];
	            if(plotinfo.plotgroup) plotinfo.plotgroup.remove();
	        }
	    }
	
	    var hadGl = (oldFullLayout._has && oldFullLayout._has('gl'));
	    var hasGl = (newFullLayout._has && newFullLayout._has('gl'));
	
	    if(hadGl && !hasGl) {
	        for(k in oldPlots) {
	            plotinfo = oldPlots[k];
	            if(plotinfo._scene) plotinfo._scene.destroy();
	        }
	    }
	
	    // delete any titles we don't need anymore
	    // check if axis list has changed, and if so clear old titles
	    if(oldSubplotList.xaxis && oldSubplotList.yaxis) {
	        var oldAxIDs = axisIds.listIds({_fullLayout: oldFullLayout});
	        for(i = 0; i < oldAxIDs.length; i++) {
	            var oldAxId = oldAxIDs[i];
	            if(!newFullLayout[axisIds.id2name(oldAxId)]) {
	                oldFullLayout._infolayer.selectAll('.g-' + oldAxId + 'title').remove();
	            }
	        }
	    }
	
	    var hadCartesian = (oldFullLayout._has && oldFullLayout._has('cartesian'));
	    var hasCartesian = (newFullLayout._has && newFullLayout._has('cartesian'));
	
	    if(hadCartesian && !hasCartesian) {
	        // if we've gotten rid of all cartesian traces, remove all the subplot svg items
	
	        purgeSubplotLayers(oldFullLayout._cartesianlayer.selectAll('.subplot'), oldFullLayout);
	        oldFullLayout._defs.selectAll('.axesclip').remove();
	        delete oldFullLayout._axisConstraintGroups;
	    } else if(oldSubplotList.cartesian) {
	        // otherwise look for subplots we need to remove
	
	        for(i = 0; i < oldSubplotList.cartesian.length; i++) {
	            var oldSubplotId = oldSubplotList.cartesian[i];
	            if(!newPlots[oldSubplotId]) {
	                var selector = '.' + oldSubplotId + ',.' + oldSubplotId + '-x,.' + oldSubplotId + '-y';
	                oldFullLayout._cartesianlayer.selectAll(selector).remove();
	                removeSubplotExtras(oldSubplotId, oldFullLayout);
	            }
	        }
	    }
	};
	
	exports.drawFramework = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotData = makeSubplotData(gd);
	
	    var subplotLayers = fullLayout._cartesianlayer.selectAll('.subplot')
	        .data(subplotData, String);
	
	    subplotLayers.enter().append('g')
	        .attr('class', function(d) { return 'subplot ' + d[0]; });
	
	    subplotLayers.order();
	
	    subplotLayers.exit()
	        .call(purgeSubplotLayers, fullLayout);
	
	    subplotLayers.each(function(d) {
	        var id = d[0];
	        var plotinfo = fullLayout._plots[id];
	
	        plotinfo.plotgroup = d3.select(this);
	        makeSubplotLayer(gd, plotinfo);
	
	        // make separate drag layers for each subplot,
	        // but append them to paper rather than the plot groups,
	        // so they end up on top of the rest
	        plotinfo.draglayer = ensureSingle(fullLayout._draggers, 'g', id);
	    });
	};
	
	exports.rangePlot = function(gd, plotinfo, cdSubplot) {
	    makeSubplotLayer(gd, plotinfo);
	    plotOne(gd, plotinfo, cdSubplot);
	    Plots.style(gd);
	};
	
	function makeSubplotData(gd) {
	    var fullLayout = gd._fullLayout;
	    var ids = fullLayout._subplots.cartesian;
	    var len = ids.length;
	    var i, j, id, plotinfo, xa, ya;
	
	    // split 'regular' and 'overlaying' subplots
	    var regulars = [];
	    var overlays = [];
	
	    for(i = 0; i < len; i++) {
	        id = ids[i];
	        plotinfo = fullLayout._plots[id];
	        xa = plotinfo.xaxis;
	        ya = plotinfo.yaxis;
	
	        var xa2 = xa._mainAxis;
	        var ya2 = ya._mainAxis;
	        var mainplot = xa2._id + ya2._id;
	        var mainplotinfo = fullLayout._plots[mainplot];
	        plotinfo.overlays = [];
	
	        if(mainplot !== id && mainplotinfo) {
	            plotinfo.mainplot = mainplot;
	            plotinfo.mainplotinfo = mainplotinfo;
	            overlays.push(id);
	        } else {
	            plotinfo.mainplot = undefined;
	            plotinfo.mainPlotinfo = undefined;
	            regulars.push(id);
	        }
	    }
	
	    // fill in list of overlaying subplots in 'main plot'
	    for(i = 0; i < overlays.length; i++) {
	        id = overlays[i];
	        plotinfo = fullLayout._plots[id];
	        plotinfo.mainplotinfo.overlays.push(plotinfo);
	    }
	
	    // put 'regular' subplot data before 'overlaying'
	    var subplotIds = regulars.concat(overlays);
	    var subplotData = new Array(len);
	
	    for(i = 0; i < len; i++) {
	        id = subplotIds[i];
	        plotinfo = fullLayout._plots[id];
	        xa = plotinfo.xaxis;
	        ya = plotinfo.yaxis;
	
	        // use info about axis layer and overlaying pattern
	        // to clean what need to be cleaned up in exit selection
	        var d = [id, xa.layer, ya.layer, xa.overlaying || '', ya.overlaying || ''];
	        for(j = 0; j < plotinfo.overlays.length; j++) {
	            d.push(plotinfo.overlays[j].id);
	        }
	        subplotData[i] = d;
	    }
	
	    return subplotData;
	}
	
	function makeSubplotLayer(gd, plotinfo) {
	    var plotgroup = plotinfo.plotgroup;
	    var id = plotinfo.id;
	    var xLayer = constants.layerValue2layerClass[plotinfo.xaxis.layer];
	    var yLayer = constants.layerValue2layerClass[plotinfo.yaxis.layer];
	    var hasOnlyLargeSploms = gd._fullLayout._hasOnlyLargeSploms;
	
	    if(!plotinfo.mainplot) {
	        if(hasOnlyLargeSploms) {
	            // TODO could do even better
	            // - we don't need plot (but we would have to mock it in lsInner
	            //   and other places
	            // - we don't (x|y)lines and (x|y)axislayer for most subplots
	            //   usually just the bottom x and left y axes.
	            plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
	            plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
	            plotinfo.xaxislayer = ensureSingle(plotgroup, 'g', 'xaxislayer-above');
	            plotinfo.yaxislayer = ensureSingle(plotgroup, 'g', 'yaxislayer-above');
	        } else {
	            var backLayer = ensureSingle(plotgroup, 'g', 'layer-subplot');
	            plotinfo.shapelayer = ensureSingle(backLayer, 'g', 'shapelayer');
	            plotinfo.imagelayer = ensureSingle(backLayer, 'g', 'imagelayer');
	
	            plotinfo.gridlayer = ensureSingle(plotgroup, 'g', 'gridlayer');
	            plotinfo.zerolinelayer = ensureSingle(plotgroup, 'g', 'zerolinelayer');
	
	            ensureSingle(plotgroup, 'path', 'xlines-below');
	            ensureSingle(plotgroup, 'path', 'ylines-below');
	            plotinfo.overlinesBelow = ensureSingle(plotgroup, 'g', 'overlines-below');
	
	            ensureSingle(plotgroup, 'g', 'xaxislayer-below');
	            ensureSingle(plotgroup, 'g', 'yaxislayer-below');
	            plotinfo.overaxesBelow = ensureSingle(plotgroup, 'g', 'overaxes-below');
	
	            plotinfo.plot = ensureSingle(plotgroup, 'g', 'plot');
	            plotinfo.overplot = ensureSingle(plotgroup, 'g', 'overplot');
	
	            plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
	            plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
	            plotinfo.overlinesAbove = ensureSingle(plotgroup, 'g', 'overlines-above');
	
	            ensureSingle(plotgroup, 'g', 'xaxislayer-above');
	            ensureSingle(plotgroup, 'g', 'yaxislayer-above');
	            plotinfo.overaxesAbove = ensureSingle(plotgroup, 'g', 'overaxes-above');
	
	            // set refs to correct layers as determined by 'axis.layer'
	            plotinfo.xlines = plotgroup.select('.xlines-' + xLayer);
	            plotinfo.ylines = plotgroup.select('.ylines-' + yLayer);
	            plotinfo.xaxislayer = plotgroup.select('.xaxislayer-' + xLayer);
	            plotinfo.yaxislayer = plotgroup.select('.yaxislayer-' + yLayer);
	        }
	    } else {
	        var mainplotinfo = plotinfo.mainplotinfo;
	        var mainplotgroup = mainplotinfo.plotgroup;
	        var xId = id + '-x';
	        var yId = id + '-y';
	
	        // now make the components of overlaid subplots
	        // overlays don't have backgrounds, and append all
	        // their other components to the corresponding
	        // extra groups of their main plots.
	
	        plotinfo.gridlayer = mainplotinfo.gridlayer;
	        plotinfo.zerolinelayer = mainplotinfo.zerolinelayer;
	
	        ensureSingle(mainplotinfo.overlinesBelow, 'path', xId);
	        ensureSingle(mainplotinfo.overlinesBelow, 'path', yId);
	        ensureSingle(mainplotinfo.overaxesBelow, 'g', xId);
	        ensureSingle(mainplotinfo.overaxesBelow, 'g', yId);
	
	        plotinfo.plot = ensureSingle(mainplotinfo.overplot, 'g', id);
	
	        ensureSingle(mainplotinfo.overlinesAbove, 'path', xId);
	        ensureSingle(mainplotinfo.overlinesAbove, 'path', yId);
	        ensureSingle(mainplotinfo.overaxesAbove, 'g', xId);
	        ensureSingle(mainplotinfo.overaxesAbove, 'g', yId);
	
	        // set refs to correct layers as determined by 'abovetraces'
	        plotinfo.xlines = mainplotgroup.select('.overlines-' + xLayer).select('.' + xId);
	        plotinfo.ylines = mainplotgroup.select('.overlines-' + yLayer).select('.' + yId);
	        plotinfo.xaxislayer = mainplotgroup.select('.overaxes-' + xLayer).select('.' + xId);
	        plotinfo.yaxislayer = mainplotgroup.select('.overaxes-' + yLayer).select('.' + yId);
	    }
	
	    // common attributes for all subplots, overlays or not
	
	    if(!hasOnlyLargeSploms) {
	        ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.xaxis._id);
	        ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.yaxis._id);
	        plotinfo.gridlayer.selectAll('g')
	            .map(function(d) { return d[0]; })
	            .sort(axisIds.idSort);
	    }
	
	    plotinfo.xlines
	        .style('fill', 'none')
	        .classed('crisp', true);
	
	    plotinfo.ylines
	        .style('fill', 'none')
	        .classed('crisp', true);
	}
	
	function purgeSubplotLayers(layers, fullLayout) {
	    if(!layers) return;
	
	    var overlayIdsToRemove = {};
	
	    layers.each(function(d) {
	        var id = d[0];
	        var plotgroup = d3.select(this);
	
	        plotgroup.remove();
	        removeSubplotExtras(id, fullLayout);
	        overlayIdsToRemove[id] = true;
	
	        // do not remove individual axis <clipPath>s here
	        // as other subplots may need them
	    });
	
	    // must remove overlaid subplot trace layers 'manually'
	
	    for(var k in fullLayout._plots) {
	        var subplotInfo = fullLayout._plots[k];
	        var overlays = subplotInfo.overlays || [];
	
	        for(var j = 0; j < overlays.length; j++) {
	            var overlayInfo = overlays[j];
	
	            if(overlayIdsToRemove[overlayInfo.id]) {
	                overlayInfo.plot.selectAll('.trace').remove();
	            }
	        }
	    }
	}
	
	function removeSubplotExtras(subplotId, fullLayout) {
	    fullLayout._draggers.selectAll('g.' + subplotId).remove();
	    fullLayout._defs.select('#clip' + fullLayout._uid + subplotId + 'plot').remove();
	}
	
	exports.toSVG = function(gd) {
	    var imageRoot = gd._fullLayout._glimages;
	    var root = d3.select(gd).selectAll('.svg-container');
	    var canvases = root.filter(function(d, i) {return i === root.size() - 1;})
	        .selectAll('.gl-canvas-context, .gl-canvas-focus');
	
	    function canvasToImage() {
	        var canvas = this;
	        var imageData = canvas.toDataURL('image/png');
	        var image = imageRoot.append('svg:image');
	
	        image.attr({
	            xmlns: xmlnsNamespaces.svg,
	            'xlink:href': imageData,
	            preserveAspectRatio: 'none',
	            x: 0,
	            y: 0,
	            width: canvas.width,
	            height: canvas.height
	        });
	    }
	
	    canvases.each(canvasToImage);
	};
	
	exports.updateFx = _dereq_('./graph_interact').updateFx;
	
	},{"../../components/drawing":612,"../../constants/xmlns_namespaces":693,"../../lib":716,"../../registry":845,"../get_data":799,"../plots":825,"./attributes":762,"./axis_ids":767,"./constants":770,"./graph_interact":773,"./layout_attributes":776,"./layout_defaults":777,"./transition_axes":786,"d3":164}],776:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../font_attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	var DATE_FORMAT_LINK = _dereq_('../../constants/docs').DATE_FORMAT_LINK;
	
	var constants = _dereq_('./constants');
	
	module.exports = {
	    visible: {
	        valType: 'boolean',
	        
	        editType: 'plot',
	        
	    },
	    color: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'ticks',
	        
	    },
	    title: {
	        text: {
	            valType: 'string',
	            
	            editType: 'ticks',
	            
	        },
	        font: fontAttrs({
	            editType: 'ticks',
	            
	        }),
	        standoff: {
	            valType: 'number',
	            
	            min: 0,
	            editType: 'ticks',
	            
	        },
	        editType: 'ticks'
	    },
	    type: {
	        valType: 'enumerated',
	        // '-' means we haven't yet run autotype or couldn't find any data
	        // it gets turned into linear in gd._fullLayout but not copied back
	        // to gd.data like the others are.
	        values: ['-', 'linear', 'log', 'date', 'category', 'multicategory'],
	        dflt: '-',
	        
	        editType: 'calc',
	        // we forget when an axis has been autotyped, just writing the auto
	        // value back to the input - so it doesn't make sense to template this.
	        // Note: we do NOT prohibit this in `coerce`, so if someone enters a
	        // type in the template explicitly it will be honored as the default.
	        _noTemplating: true,
	        
	    },
	    autorange: {
	        valType: 'enumerated',
	        values: [true, false, 'reversed'],
	        dflt: true,
	        
	        editType: 'axrange',
	        impliedEdits: {'range[0]': undefined, 'range[1]': undefined},
	        
	    },
	    rangemode: {
	        valType: 'enumerated',
	        values: ['normal', 'tozero', 'nonnegative'],
	        dflt: 'normal',
	        
	        editType: 'plot',
	        
	    },
	    range: {
	        valType: 'info_array',
	        
	        items: [
	            {valType: 'any', editType: 'axrange', impliedEdits: {'^autorange': false}, anim: true},
	            {valType: 'any', editType: 'axrange', impliedEdits: {'^autorange': false}, anim: true}
	        ],
	        editType: 'axrange',
	        impliedEdits: {'autorange': false},
	        anim: true,
	        
	    },
	    fixedrange: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    // scaleanchor: not used directly, just put here for reference
	    // values are any opposite-letter axis id
	    scaleanchor: {
	        valType: 'enumerated',
	        values: [
	            constants.idRegex.x.toString(),
	            constants.idRegex.y.toString()
	        ],
	        
	        editType: 'plot',
	        
	    },
	    scaleratio: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'plot',
	        
	    },
	    constrain: {
	        valType: 'enumerated',
	        values: ['range', 'domain'],
	        dflt: 'range',
	        
	        editType: 'plot',
	        
	    },
	    // constraintoward: not used directly, just put here for reference
	    constraintoward: {
	        valType: 'enumerated',
	        values: ['left', 'center', 'right', 'top', 'middle', 'bottom'],
	        
	        editType: 'plot',
	        
	    },
	    matches: {
	        valType: 'enumerated',
	        values: [
	            constants.idRegex.x.toString(),
	            constants.idRegex.y.toString()
	        ],
	        
	        editType: 'calc',
	        
	    },
	    // ticks
	    tickmode: {
	        valType: 'enumerated',
	        values: ['auto', 'linear', 'array'],
	        
	        editType: 'ticks',
	        impliedEdits: {tick0: undefined, dtick: undefined},
	        
	    },
	    nticks: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'ticks',
	        
	    },
	    tick0: {
	        valType: 'any',
	        
	        editType: 'ticks',
	        impliedEdits: {tickmode: 'linear'},
	        
	    },
	    dtick: {
	        valType: 'any',
	        
	        editType: 'ticks',
	        impliedEdits: {tickmode: 'linear'},
	        
	    },
	    tickvals: {
	        valType: 'data_array',
	        editType: 'ticks',
	        
	    },
	    ticktext: {
	        valType: 'data_array',
	        editType: 'ticks',
	        
	    },
	    ticks: {
	        valType: 'enumerated',
	        values: ['outside', 'inside', ''],
	        
	        editType: 'ticks',
	        
	    },
	    tickson: {
	        valType: 'enumerated',
	        values: ['labels', 'boundaries'],
	        
	        dflt: 'labels',
	        editType: 'ticks',
	        
	    },
	    mirror: {
	        valType: 'enumerated',
	        values: [true, 'ticks', false, 'all', 'allticks'],
	        dflt: false,
	        
	        editType: 'ticks+layoutstyle',
	        
	    },
	    ticklen: {
	        valType: 'number',
	        min: 0,
	        dflt: 5,
	        
	        editType: 'ticks',
	        
	    },
	    tickwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'ticks',
	        
	    },
	    tickcolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'ticks',
	        
	    },
	    showticklabels: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'ticks',
	        
	    },
	    automargin: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'ticks',
	        
	    },
	    showspikes: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'modebar',
	        
	    },
	    spikecolor: {
	        valType: 'color',
	        dflt: null,
	        
	        editType: 'none',
	        
	    },
	    spikethickness: {
	        valType: 'number',
	        dflt: 3,
	        
	        editType: 'none',
	        
	    },
	    spikedash: extendFlat({}, dash, {dflt: 'dash', editType: 'none'}),
	    spikemode: {
	        valType: 'flaglist',
	        flags: ['toaxis', 'across', 'marker'],
	        
	        dflt: 'toaxis',
	        editType: 'none',
	        
	    },
	    spikesnap: {
	        valType: 'enumerated',
	        values: ['data', 'cursor'],
	        dflt: 'data',
	        
	        editType: 'none',
	        
	    },
	    tickfont: fontAttrs({
	        editType: 'ticks',
	        
	    }),
	    tickangle: {
	        valType: 'angle',
	        dflt: 'auto',
	        
	        editType: 'ticks',
	        
	    },
	    tickprefix: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'ticks',
	        
	    },
	    showtickprefix: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'ticks',
	        
	    },
	    ticksuffix: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'ticks',
	        
	    },
	    showticksuffix: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'ticks',
	        
	    },
	    showexponent: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'ticks',
	        
	    },
	    exponentformat: {
	        valType: 'enumerated',
	        values: ['none', 'e', 'E', 'power', 'SI', 'B'],
	        dflt: 'B',
	        
	        editType: 'ticks',
	        
	    },
	    separatethousands: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'ticks',
	        
	    },
	    tickformat: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'ticks',
	        
	    },
	    tickformatstops: templatedArray('tickformatstop', {
	        enabled: {
	            valType: 'boolean',
	            
	            dflt: true,
	            editType: 'ticks',
	            
	        },
	        dtickrange: {
	            valType: 'info_array',
	            
	            items: [
	                {valType: 'any', editType: 'ticks'},
	                {valType: 'any', editType: 'ticks'}
	            ],
	            editType: 'ticks',
	            
	        },
	        value: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'ticks',
	            
	        },
	        editType: 'ticks'
	    }),
	    hoverformat: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'none',
	        
	    },
	    // lines and grids
	    showline: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'ticks+layoutstyle',
	        
	    },
	    linecolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'layoutstyle',
	        
	    },
	    linewidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'ticks+layoutstyle',
	        
	    },
	    showgrid: {
	        valType: 'boolean',
	        
	        editType: 'ticks',
	        
	    },
	    gridcolor: {
	        valType: 'color',
	        dflt: colorAttrs.lightLine,
	        
	        editType: 'ticks',
	        
	    },
	    gridwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'ticks',
	        
	    },
	    zeroline: {
	        valType: 'boolean',
	        
	        editType: 'ticks',
	        
	    },
	    zerolinecolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'ticks',
	        
	    },
	    zerolinewidth: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'ticks',
	        
	    },
	
	    showdividers: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'ticks',
	        
	    },
	    dividercolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'ticks',
	        
	    },
	    dividerwidth: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'ticks',
	        
	    },
	    // TODO dividerlen: that would override "to label base" length?
	
	    // positioning attributes
	    // anchor: not used directly, just put here for reference
	    // values are any opposite-letter axis id
	    anchor: {
	        valType: 'enumerated',
	        values: [
	            'free',
	            constants.idRegex.x.toString(),
	            constants.idRegex.y.toString()
	        ],
	        
	        editType: 'plot',
	        
	    },
	    // side: not used directly, as values depend on direction
	    // values are top, bottom for x axes, and left, right for y
	    side: {
	        valType: 'enumerated',
	        values: ['top', 'bottom', 'left', 'right'],
	        
	        editType: 'plot',
	        
	    },
	    // overlaying: not used directly, just put here for reference
	    // values are false and any other same-letter axis id that's not
	    // itself overlaying anything
	    overlaying: {
	        valType: 'enumerated',
	        values: [
	            'free',
	            constants.idRegex.x.toString(),
	            constants.idRegex.y.toString()
	        ],
	        
	        editType: 'plot',
	        
	    },
	    layer: {
	        valType: 'enumerated',
	        values: ['above traces', 'below traces'],
	        dflt: 'above traces',
	        
	        editType: 'plot',
	        
	    },
	    domain: {
	        valType: 'info_array',
	        
	        items: [
	            {valType: 'number', min: 0, max: 1, editType: 'plot'},
	            {valType: 'number', min: 0, max: 1, editType: 'plot'}
	        ],
	        dflt: [0, 1],
	        editType: 'plot',
	        
	    },
	    position: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0,
	        
	        editType: 'plot',
	        
	    },
	    categoryorder: {
	        valType: 'enumerated',
	        values: [
	            'trace', 'category ascending', 'category descending', 'array',
	            'total ascending', 'total descending',
	            'min ascending', 'min descending',
	            'max ascending', 'max descending',
	            'sum ascending', 'sum descending',
	            'mean ascending', 'mean descending',
	            'median ascending', 'median descending'
	        ],
	        dflt: 'trace',
	        
	        editType: 'calc',
	        
	    },
	    categoryarray: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    editType: 'calc',
	
	    _deprecated: {
	        autotick: {
	            valType: 'boolean',
	            
	            editType: 'ticks',
	            
	        },
	        title: {
	            valType: 'string',
	            
	            editType: 'ticks',
	            
	        },
	        titlefont: fontAttrs({
	            editType: 'ticks',
	            
	        })
	    }
	};
	
	},{"../../components/color/attributes":590,"../../components/drawing/attributes":611,"../../constants/docs":687,"../../lib/extend":707,"../../plot_api/plot_template":754,"../font_attributes":790,"./constants":770}],777:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Template = _dereq_('../../plot_api/plot_template');
	var basePlotLayoutAttributes = _dereq_('../layout_attributes');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	var handleTypeDefaults = _dereq_('./type_defaults');
	var handleAxisDefaults = _dereq_('./axis_defaults');
	var handleConstraintDefaults = _dereq_('./constraints').handleConstraintDefaults;
	var handlePositionDefaults = _dereq_('./position_defaults');
	
	var axisIds = _dereq_('./axis_ids');
	var id2name = axisIds.id2name;
	var name2id = axisIds.name2id;
	
	var Registry = _dereq_('../../registry');
	var traceIs = Registry.traceIs;
	var getComponentMethod = Registry.getComponentMethod;
	
	function appendList(cont, k, item) {
	    if(Array.isArray(cont[k])) cont[k].push(item);
	    else cont[k] = [item];
	}
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    var ax2traces = {};
	    var xaMayHide = {};
	    var yaMayHide = {};
	    var xaMustDisplay = {};
	    var yaMustDisplay = {};
	    var yaMustNotReverse = {};
	    var yaMayReverse = {};
	    var axHasImage = {};
	    var outerTicks = {};
	    var noGrids = {};
	    var i, j;
	
	    // look for axes in the data
	    for(i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	        if(!traceIs(trace, 'cartesian') && !traceIs(trace, 'gl2d')) continue;
	
	        var xaName;
	        if(trace.xaxis) {
	            xaName = id2name(trace.xaxis);
	            appendList(ax2traces, xaName, trace);
	        } else if(trace.xaxes) {
	            for(j = 0; j < trace.xaxes.length; j++) {
	                appendList(ax2traces, id2name(trace.xaxes[j]), trace);
	            }
	        }
	
	        var yaName;
	        if(trace.yaxis) {
	            yaName = id2name(trace.yaxis);
	            appendList(ax2traces, yaName, trace);
	        } else if(trace.yaxes) {
	            for(j = 0; j < trace.yaxes.length; j++) {
	                appendList(ax2traces, id2name(trace.yaxes[j]), trace);
	            }
	        }
	
	        // logic for funnels
	        if(trace.type === 'funnel') {
	            if(trace.orientation === 'h') {
	                if(xaName) xaMayHide[xaName] = true;
	                if(yaName) yaMayReverse[yaName] = true;
	            } else {
	                if(yaName) yaMayHide[yaName] = true;
	            }
	        } else if(trace.type === 'image') {
	            if(yaName) axHasImage[yaName] = true;
	            if(xaName) axHasImage[xaName] = true;
	        } else {
	            if(yaName) {
	                yaMustDisplay[yaName] = true;
	                yaMustNotReverse[yaName] = true;
	            }
	
	            if(!traceIs(trace, 'carpet') || (trace.type === 'carpet' && !trace._cheater)) {
	                if(xaName) xaMustDisplay[xaName] = true;
	            }
	        }
	
	        // Two things trigger axis visibility:
	        // 1. is not carpet
	        // 2. carpet that's not cheater
	
	        // The above check for definitely-not-cheater is not adequate. This
	        // second list tracks which axes *could* be a cheater so that the
	        // full condition triggering hiding is:
	        //   *could* be a cheater and *is not definitely visible*
	        if(trace.type === 'carpet' && trace._cheater) {
	            if(xaName) xaMayHide[xaName] = true;
	        }
	
	        // check for default formatting tweaks
	        if(traceIs(trace, '2dMap')) {
	            outerTicks[xaName] = true;
	            outerTicks[yaName] = true;
	        }
	
	        if(traceIs(trace, 'oriented')) {
	            var positionAxis = trace.orientation === 'h' ? yaName : xaName;
	            noGrids[positionAxis] = true;
	        }
	    }
	
	    var subplots = layoutOut._subplots;
	    var xIds = subplots.xaxis;
	    var yIds = subplots.yaxis;
	    var xNames = Lib.simpleMap(xIds, id2name);
	    var yNames = Lib.simpleMap(yIds, id2name);
	    var axNames = xNames.concat(yNames);
	
	    // plot_bgcolor only makes sense if there's a (2D) plot!
	    // TODO: bgcolor for each subplot, to inherit from the main one
	    var plotBgColor = Color.background;
	    if(xIds.length && yIds.length) {
	        plotBgColor = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, 'plot_bgcolor');
	    }
	
	    var bgColor = Color.combine(plotBgColor, layoutOut.paper_bgcolor);
	
	    var axName, axLetter, axLayoutIn, axLayoutOut;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
	    }
	
	    function coerce2(attr, dflt) {
	        return Lib.coerce2(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
	    }
	
	    function getCounterAxes(axLetter) {
	        return (axLetter === 'x') ? yIds : xIds;
	    }
	
	    var counterAxes = {x: getCounterAxes('x'), y: getCounterAxes('y')};
	    var allAxisIds = counterAxes.x.concat(counterAxes.y);
	
	    function getOverlayableAxes(axLetter, axName) {
	        var list = (axLetter === 'x') ? xNames : yNames;
	        var out = [];
	
	        for(var j = 0; j < list.length; j++) {
	            var axName2 = list[j];
	
	            if(axName2 !== axName && !(layoutIn[axName2] || {}).overlaying) {
	                out.push(name2id(axName2));
	            }
	        }
	
	        return out;
	    }
	
	    // first pass creates the containers, determines types, and handles most of the settings
	    for(i = 0; i < axNames.length; i++) {
	        axName = axNames[i];
	        axLetter = axName.charAt(0);
	
	        if(!Lib.isPlainObject(layoutIn[axName])) {
	            layoutIn[axName] = {};
	        }
	
	        axLayoutIn = layoutIn[axName];
	        axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + 'axis');
	
	        var traces = ax2traces[axName] || [];
	        axLayoutOut._traceIndices = traces.map(function(t) { return t._expandedIndex; });
	        axLayoutOut._annIndices = [];
	        axLayoutOut._shapeIndices = [];
	        axLayoutOut._imgIndices = [];
	        axLayoutOut._subplotsWith = [];
	        axLayoutOut._counterAxes = [];
	
	        // set up some private properties
	        axLayoutOut._name = axLayoutOut._attr = axName;
	        var id = axLayoutOut._id = name2id(axName);
	
	        var overlayableAxes = getOverlayableAxes(axLetter, axName);
	
	        var visibleDflt =
	            (axLetter === 'x' && !xaMustDisplay[axName] && xaMayHide[axName]) ||
	            (axLetter === 'y' && !yaMustDisplay[axName] && yaMayHide[axName]);
	
	        var reverseDflt =
	            (axLetter === 'y' &&
	              (
	                (!yaMustNotReverse[axName] && yaMayReverse[axName]) ||
	                axHasImage[axName]
	              ));
	
	        var defaultOptions = {
	            letter: axLetter,
	            font: layoutOut.font,
	            outerTicks: outerTicks[axName],
	            showGrid: !noGrids[axName],
	            data: traces,
	            bgColor: bgColor,
	            calendar: layoutOut.calendar,
	            automargin: true,
	            visibleDflt: visibleDflt,
	            reverseDflt: reverseDflt,
	            splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[id]
	        };
	
	        coerce('uirevision', layoutOut.uirevision);
	
	        handleTypeDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions);
	        handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions, layoutOut);
	
	        var spikecolor = coerce2('spikecolor');
	        var spikethickness = coerce2('spikethickness');
	        var spikedash = coerce2('spikedash');
	        var spikemode = coerce2('spikemode');
	        var spikesnap = coerce2('spikesnap');
	        var showSpikes = coerce('showspikes', !!spikecolor || !!spikethickness || !!spikedash || !!spikemode || !!spikesnap);
	
	        if(!showSpikes) {
	            delete axLayoutOut.spikecolor;
	            delete axLayoutOut.spikethickness;
	            delete axLayoutOut.spikedash;
	            delete axLayoutOut.spikemode;
	            delete axLayoutOut.spikesnap;
	        }
	
	        handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
	            letter: axLetter,
	            counterAxes: counterAxes[axLetter],
	            overlayableAxes: overlayableAxes,
	            grid: layoutOut.grid
	        });
	
	        coerce('title.standoff');
	
	        axLayoutOut._input = axLayoutIn;
	    }
	
	    // quick second pass for range slider and selector defaults
	    var rangeSliderDefaults = getComponentMethod('rangeslider', 'handleDefaults');
	    var rangeSelectorDefaults = getComponentMethod('rangeselector', 'handleDefaults');
	
	    for(i = 0; i < xNames.length; i++) {
	        axName = xNames[i];
	        axLayoutIn = layoutIn[axName];
	        axLayoutOut = layoutOut[axName];
	
	        rangeSliderDefaults(layoutIn, layoutOut, axName);
	
	        if(axLayoutOut.type === 'date') {
	            rangeSelectorDefaults(
	                axLayoutIn,
	                axLayoutOut,
	                layoutOut,
	                yNames,
	                axLayoutOut.calendar
	            );
	        }
	
	        coerce('fixedrange');
	    }
	
	    for(i = 0; i < yNames.length; i++) {
	        axName = yNames[i];
	        axLayoutIn = layoutIn[axName];
	        axLayoutOut = layoutOut[axName];
	
	        var anchoredAxis = layoutOut[id2name(axLayoutOut.anchor)];
	
	        var fixedRangeDflt = getComponentMethod('rangeslider', 'isVisible')(anchoredAxis);
	
	        coerce('fixedrange', fixedRangeDflt);
	    }
	
	    // Finally, handle scale constraints and matching axes.
	    //
	    // We need to do this after all axes have coerced both `type`
	    // (so we link only axes of the same type) and
	    // `fixedrange` (so we can avoid linking from OR TO a fixed axis).
	
	    // sets of axes linked by `scaleanchor` along with the scaleratios compounded
	    // together, populated in handleConstraintDefaults
	    var constraintGroups = layoutOut._axisConstraintGroups = [];
	    // similar to _axisConstraintGroups, but for matching axes
	    var matchGroups = layoutOut._axisMatchGroups = [];
	
	    for(i = 0; i < axNames.length; i++) {
	        axName = axNames[i];
	        axLetter = axName.charAt(0);
	        axLayoutIn = layoutIn[axName];
	        axLayoutOut = layoutOut[axName];
	
	        var scaleanchorDflt;
	        if(axLetter === 'y' && !axLayoutIn.hasOwnProperty('scaleanchor') && axHasImage[axName]) {
	            scaleanchorDflt = axLayoutOut.anchor;
	        } else {scaleanchorDflt = undefined;}
	
	        var constrainDflt;
	        if(!axLayoutIn.hasOwnProperty('constrain') && axHasImage[axName]) {
	            constrainDflt = 'domain';
	        } else {constrainDflt = undefined;}
	
	        handleConstraintDefaults(axLayoutIn, axLayoutOut, coerce, {
	            allAxisIds: allAxisIds,
	            layoutOut: layoutOut,
	            scaleanchorDflt: scaleanchorDflt,
	            constrainDflt: constrainDflt
	        });
	    }
	
	    for(i = 0; i < matchGroups.length; i++) {
	        var group = matchGroups[i];
	        var rng = null;
	        var autorange = null;
	        var axId;
	
	        // find 'matching' range attrs
	        for(axId in group) {
	            axLayoutOut = layoutOut[id2name(axId)];
	            if(!axLayoutOut.matches) {
	                rng = axLayoutOut.range;
	                autorange = axLayoutOut.autorange;
	            }
	        }
	        // if `ax.matches` values are reciprocal,
	        // pick values of first axis in group
	        if(rng === null || autorange === null) {
	            for(axId in group) {
	                axLayoutOut = layoutOut[id2name(axId)];
	                rng = axLayoutOut.range;
	                autorange = axLayoutOut.autorange;
	                break;
	            }
	        }
	        // apply matching range attrs
	        for(axId in group) {
	            axLayoutOut = layoutOut[id2name(axId)];
	            if(axLayoutOut.matches) {
	                axLayoutOut.range = rng.slice();
	                axLayoutOut.autorange = autorange;
	            }
	            axLayoutOut._matchGroup = group;
	        }
	
	        // remove matching axis from scaleanchor constraint groups (for now)
	        if(constraintGroups.length) {
	            for(axId in group) {
	                for(j = 0; j < constraintGroups.length; j++) {
	                    var group2 = constraintGroups[j];
	                    for(var axId2 in group2) {
	                        if(axId === axId2) {
	                            Lib.warn('Axis ' + axId2 + ' is set with both ' +
	                                'a *scaleanchor* and *matches* constraint; ' +
	                                'ignoring the scale constraint.');
	
	                            delete group2[axId2];
	                            if(Object.keys(group2).length < 2) {
	                                constraintGroups.splice(j, 1);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }
	};
	
	},{"../../components/color":591,"../../lib":716,"../../plot_api/plot_template":754,"../../registry":845,"../layout_attributes":816,"./axis_defaults":766,"./axis_ids":767,"./constraints":771,"./layout_attributes":776,"./position_defaults":779,"./type_defaults":787}],778:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorMix = _dereq_('tinycolor2').mix;
	var lightFraction = _dereq_('../../components/color/attributes').lightFraction;
	var Lib = _dereq_('../../lib');
	
	/**
	 * @param {object} opts :
	 *   - dfltColor {string} : default axis color
	 *   - bgColor {string} : combined subplot bg color
	 *   - blend {number, optional} : blend percentage (to compute dflt grid color)
	 *   - showLine {boolean} : show line by default
	 *   - showGrid {boolean} : show grid by default
	 *   - noZeroLine {boolean} : don't coerce zeroline* attributes
	 *   - attributes {object} : attribute object associated with input containers
	 */
	module.exports = function handleLineGridDefaults(containerIn, containerOut, coerce, opts) {
	    opts = opts || {};
	
	    var dfltColor = opts.dfltColor;
	
	    function coerce2(attr, dflt) {
	        return Lib.coerce2(containerIn, containerOut, opts.attributes, attr, dflt);
	    }
	
	    var lineColor = coerce2('linecolor', dfltColor);
	    var lineWidth = coerce2('linewidth');
	    var showLine = coerce('showline', opts.showLine || !!lineColor || !!lineWidth);
	
	    if(!showLine) {
	        delete containerOut.linecolor;
	        delete containerOut.linewidth;
	    }
	
	    var gridColorDflt = colorMix(dfltColor, opts.bgColor, opts.blend || lightFraction).toRgbString();
	    var gridColor = coerce2('gridcolor', gridColorDflt);
	    var gridWidth = coerce2('gridwidth');
	    var showGridLines = coerce('showgrid', opts.showGrid || !!gridColor || !!gridWidth);
	
	    if(!showGridLines) {
	        delete containerOut.gridcolor;
	        delete containerOut.gridwidth;
	    }
	
	    if(!opts.noZeroLine) {
	        var zeroLineColor = coerce2('zerolinecolor', dfltColor);
	        var zeroLineWidth = coerce2('zerolinewidth');
	        var showZeroLine = coerce('zeroline', opts.showGrid || !!zeroLineColor || !!zeroLineWidth);
	
	        if(!showZeroLine) {
	            delete containerOut.zerolinecolor;
	            delete containerOut.zerolinewidth;
	        }
	    }
	};
	
	},{"../../components/color/attributes":590,"../../lib":716,"tinycolor2":535}],779:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	
	
	module.exports = function handlePositionDefaults(containerIn, containerOut, coerce, options) {
	    var counterAxes = options.counterAxes || [];
	    var overlayableAxes = options.overlayableAxes || [];
	    var letter = options.letter;
	    var grid = options.grid;
	
	    var dfltAnchor, dfltDomain, dfltSide, dfltPosition;
	
	    if(grid) {
	        dfltDomain = grid._domains[letter][grid._axisMap[containerOut._id]];
	        dfltAnchor = grid._anchors[containerOut._id];
	        if(dfltDomain) {
	            dfltSide = grid[letter + 'side'].split(' ')[0];
	            dfltPosition = grid.domain[letter][dfltSide === 'right' || dfltSide === 'top' ? 1 : 0];
	        }
	    }
	
	    // Even if there's a grid, this axis may not be in it - fall back on non-grid defaults
	    dfltDomain = dfltDomain || [0, 1];
	    dfltAnchor = dfltAnchor || (isNumeric(containerIn.position) ? 'free' : (counterAxes[0] || 'free'));
	    dfltSide = dfltSide || (letter === 'x' ? 'bottom' : 'left');
	    dfltPosition = dfltPosition || 0;
	
	    var anchor = Lib.coerce(containerIn, containerOut, {
	        anchor: {
	            valType: 'enumerated',
	            values: ['free'].concat(counterAxes),
	            dflt: dfltAnchor
	        }
	    }, 'anchor');
	
	    if(anchor === 'free') coerce('position', dfltPosition);
	
	    Lib.coerce(containerIn, containerOut, {
	        side: {
	            valType: 'enumerated',
	            values: letter === 'x' ? ['bottom', 'top'] : ['left', 'right'],
	            dflt: dfltSide
	        }
	    }, 'side');
	
	    var overlaying = false;
	    if(overlayableAxes.length) {
	        overlaying = Lib.coerce(containerIn, containerOut, {
	            overlaying: {
	                valType: 'enumerated',
	                values: [false].concat(overlayableAxes),
	                dflt: false
	            }
	        }, 'overlaying');
	    }
	
	    if(!overlaying) {
	        // TODO: right now I'm copying this domain over to overlaying axes
	        // in ax.setscale()... but this means we still need (imperfect) logic
	        // in the axes popover to hide domain for the overlaying axis.
	        // perhaps I should make a private version _domain that all axes get???
	        var domain = coerce('domain', dfltDomain);
	
	        // according to https://www.npmjs.com/package/canvas-size
	        // the minimum value of max canvas width across browsers and devices is 4096
	        // which applied in the calculation below:
	        if(domain[0] > domain[1] - 1 / 4096) containerOut.domain = dfltDomain;
	        Lib.noneOrAll(containerIn.domain, containerOut.domain, dfltDomain);
	    }
	
	    coerce('layer');
	
	    return containerOut;
	};
	
	},{"../../lib":716,"fast-isnumeric":227}],780:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var FROM_BL = _dereq_('../../constants/alignment').FROM_BL;
	
	module.exports = function scaleZoom(ax, factor, centerFraction) {
	    if(centerFraction === undefined) {
	        centerFraction = FROM_BL[ax.constraintoward || 'center'];
	    }
	
	    var rangeLinear = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
	    var center = rangeLinear[0] + (rangeLinear[1] - rangeLinear[0]) * centerFraction;
	
	    ax.range = ax._input.range = [
	        ax.l2r(center + (rangeLinear[0] - center) * factor),
	        ax.l2r(center + (rangeLinear[1] - center) * factor)
	    ];
	};
	
	},{"../../constants/alignment":685}],781:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var polybool = _dereq_('polybooljs');
	
	var Registry = _dereq_('../../registry');
	var Color = _dereq_('../../components/color');
	var Fx = _dereq_('../../components/fx');
	
	var Lib = _dereq_('../../lib');
	var polygon = _dereq_('../../lib/polygon');
	var throttle = _dereq_('../../lib/throttle');
	var makeEventData = _dereq_('../../components/fx/helpers').makeEventData;
	var getFromId = _dereq_('./axis_ids').getFromId;
	var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
	
	var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
	
	var constants = _dereq_('./constants');
	var MINSELECT = constants.MINSELECT;
	
	var filteredPolygon = polygon.filter;
	var polygonTester = polygon.tester;
	
	function getAxId(ax) { return ax._id; }
	
	function prepSelect(e, startX, startY, dragOptions, mode) {
	    var gd = dragOptions.gd;
	    var fullLayout = gd._fullLayout;
	    var zoomLayer = fullLayout._zoomlayer;
	    var dragBBox = dragOptions.element.getBoundingClientRect();
	    var plotinfo = dragOptions.plotinfo;
	    var xs = plotinfo.xaxis._offset;
	    var ys = plotinfo.yaxis._offset;
	    var x0 = startX - dragBBox.left;
	    var y0 = startY - dragBBox.top;
	    var x1 = x0;
	    var y1 = y0;
	    var path0 = 'M' + x0 + ',' + y0;
	    var pw = dragOptions.xaxes[0]._length;
	    var ph = dragOptions.yaxes[0]._length;
	    var allAxes = dragOptions.xaxes.concat(dragOptions.yaxes);
	    var subtract = e.altKey;
	
	    var filterPoly, selectionTester, mergedPolygons, currentPolygon;
	    var i, searchInfo, eventData;
	
	    coerceSelectionsCache(e, gd, dragOptions);
	
	    if(mode === 'lasso') {
	        filterPoly = filteredPolygon([[x0, y0]], constants.BENDPX);
	    }
	
	    var outlines = zoomLayer.selectAll('path.select-outline-' + plotinfo.id).data([1, 2]);
	
	    outlines.enter()
	        .append('path')
	        .attr('class', function(d) { return 'select-outline select-outline-' + d + ' select-outline-' + plotinfo.id; })
	        .attr('transform', 'translate(' + xs + ', ' + ys + ')')
	        .attr('d', path0 + 'Z');
	
	    var corners = zoomLayer.append('path')
	        .attr('class', 'zoombox-corners')
	        .style({
	            fill: Color.background,
	            stroke: Color.defaultLine,
	            'stroke-width': 1
	        })
	        .attr('transform', 'translate(' + xs + ', ' + ys + ')')
	        .attr('d', 'M0,0Z');
	
	
	    var throttleID = fullLayout._uid + constants.SELECTID;
	    var selection = [];
	
	    // find the traces to search for selection points
	    var searchTraces = determineSearchTraces(gd, dragOptions.xaxes,
	      dragOptions.yaxes, dragOptions.subplot);
	
	    // in v2 (once log ranges are fixed),
	    // we'll be able to p2r here for all axis types
	    function p2r(ax, v) {
	        return ax.type === 'log' ? ax.p2d(v) : ax.p2r(v);
	    }
	
	    function axValue(ax) {
	        var index = (ax._id.charAt(0) === 'y') ? 1 : 0;
	        return function(v) { return p2r(ax, v[index]); };
	    }
	
	    function ascending(a, b) { return a - b; }
	
	    // allow subplots to override fillRangeItems routine
	    var fillRangeItems;
	
	    if(plotinfo.fillRangeItems) {
	        fillRangeItems = plotinfo.fillRangeItems;
	    } else {
	        if(mode === 'select') {
	            fillRangeItems = function(eventData, poly) {
	                var ranges = eventData.range = {};
	
	                for(i = 0; i < allAxes.length; i++) {
	                    var ax = allAxes[i];
	                    var axLetter = ax._id.charAt(0);
	
	                    ranges[ax._id] = [
	                        p2r(ax, poly[axLetter + 'min']),
	                        p2r(ax, poly[axLetter + 'max'])
	                    ].sort(ascending);
	                }
	            };
	        } else {
	            fillRangeItems = function(eventData, poly, filterPoly) {
	                var dataPts = eventData.lassoPoints = {};
	
	                for(i = 0; i < allAxes.length; i++) {
	                    var ax = allAxes[i];
	                    dataPts[ax._id] = filterPoly.filtered.map(axValue(ax));
	                }
	            };
	        }
	    }
	
	    dragOptions.moveFn = function(dx0, dy0) {
	        x1 = Math.max(0, Math.min(pw, dx0 + x0));
	        y1 = Math.max(0, Math.min(ph, dy0 + y0));
	
	        var dx = Math.abs(x1 - x0);
	        var dy = Math.abs(y1 - y0);
	
	        if(mode === 'select') {
	            var direction = fullLayout.selectdirection;
	
	            if(fullLayout.selectdirection === 'any') {
	                if(dy < Math.min(dx * 0.6, MINSELECT)) direction = 'h';
	                else if(dx < Math.min(dy * 0.6, MINSELECT)) direction = 'v';
	                else direction = 'd';
	            } else {
	                direction = fullLayout.selectdirection;
	            }
	
	            if(direction === 'h') {
	                // horizontal motion: make a vertical box
	                currentPolygon = [[x0, 0], [x0, ph], [x1, ph], [x1, 0]];
	                currentPolygon.xmin = Math.min(x0, x1);
	                currentPolygon.xmax = Math.max(x0, x1);
	                currentPolygon.ymin = Math.min(0, ph);
	                currentPolygon.ymax = Math.max(0, ph);
	                // extras to guide users in keeping a straight selection
	                corners.attr('d', 'M' + currentPolygon.xmin + ',' + (y0 - MINSELECT) +
	                    'h-4v' + (2 * MINSELECT) + 'h4Z' +
	                    'M' + (currentPolygon.xmax - 1) + ',' + (y0 - MINSELECT) +
	                    'h4v' + (2 * MINSELECT) + 'h-4Z');
	            } else if(direction === 'v') {
	                // vertical motion: make a horizontal box
	                currentPolygon = [[0, y0], [0, y1], [pw, y1], [pw, y0]];
	                currentPolygon.xmin = Math.min(0, pw);
	                currentPolygon.xmax = Math.max(0, pw);
	                currentPolygon.ymin = Math.min(y0, y1);
	                currentPolygon.ymax = Math.max(y0, y1);
	                corners.attr('d', 'M' + (x0 - MINSELECT) + ',' + currentPolygon.ymin +
	                    'v-4h' + (2 * MINSELECT) + 'v4Z' +
	                    'M' + (x0 - MINSELECT) + ',' + (currentPolygon.ymax - 1) +
	                    'v4h' + (2 * MINSELECT) + 'v-4Z');
	            } else if(direction === 'd') {
	                // diagonal motion
	                currentPolygon = [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
	                currentPolygon.xmin = Math.min(x0, x1);
	                currentPolygon.xmax = Math.max(x0, x1);
	                currentPolygon.ymin = Math.min(y0, y1);
	                currentPolygon.ymax = Math.max(y0, y1);
	                corners.attr('d', 'M0,0Z');
	            }
	        } else if(mode === 'lasso') {
	            filterPoly.addPt([x1, y1]);
	            currentPolygon = filterPoly.filtered;
	        }
	
	        // create outline & tester
	        if(dragOptions.selectionDefs && dragOptions.selectionDefs.length) {
	            mergedPolygons = mergePolygons(dragOptions.mergedPolygons, currentPolygon, subtract);
	            currentPolygon.subtract = subtract;
	            selectionTester = multiTester(dragOptions.selectionDefs.concat([currentPolygon]));
	        } else {
	            mergedPolygons = [currentPolygon];
	            selectionTester = polygonTester(currentPolygon);
	        }
	
	        // draw selection
	        drawSelection(mergedPolygons, outlines);
	
	
	        throttle.throttle(
	            throttleID,
	            constants.SELECTDELAY,
	            function() {
	                selection = [];
	
	                var thisSelection;
	                var traceSelections = [];
	                var traceSelection;
	                for(i = 0; i < searchTraces.length; i++) {
	                    searchInfo = searchTraces[i];
	
	                    traceSelection = searchInfo._module.selectPoints(searchInfo, selectionTester);
	                    traceSelections.push(traceSelection);
	
	                    thisSelection = fillSelectionItem(traceSelection, searchInfo);
	
	                    if(selection.length) {
	                        for(var j = 0; j < thisSelection.length; j++) {
	                            selection.push(thisSelection[j]);
	                        }
	                    } else selection = thisSelection;
	                }
	
	                eventData = {points: selection};
	                updateSelectedState(gd, searchTraces, eventData);
	                fillRangeItems(eventData, currentPolygon, filterPoly);
	                dragOptions.gd.emit('plotly_selecting', eventData);
	            }
	        );
	    };
	
	    dragOptions.clickFn = function(numClicks, evt) {
	        var clickmode = fullLayout.clickmode;
	
	        corners.remove();
	
	        throttle.done(throttleID).then(function() {
	            throttle.clear(throttleID);
	            if(numClicks === 2) {
	                // clear selection on doubleclick
	                outlines.remove();
	                for(i = 0; i < searchTraces.length; i++) {
	                    searchInfo = searchTraces[i];
	                    searchInfo._module.selectPoints(searchInfo, false);
	                }
	
	                updateSelectedState(gd, searchTraces);
	
	                clearSelectionsCache(dragOptions);
	
	                gd.emit('plotly_deselect', null);
	            } else {
	                if(clickmode.indexOf('select') > -1) {
	                    selectOnClick(evt, gd, dragOptions.xaxes, dragOptions.yaxes,
	                      dragOptions.subplot, dragOptions, outlines);
	                }
	
	                if(clickmode === 'event') {
	                    // TODO: remove in v2 - this was probably never intended to work as it does,
	                    // but in case anyone depends on it we don't want to break it now.
	                    // Note that click-to-select introduced pre v2 also emitts proper
	                    // event data when clickmode is having 'select' in its flag list.
	                    gd.emit('plotly_selected', undefined);
	                }
	            }
	
	            Fx.click(gd, evt);
	        }).catch(Lib.error);
	    };
	
	    dragOptions.doneFn = function() {
	        corners.remove();
	
	        throttle.done(throttleID).then(function() {
	            throttle.clear(throttleID);
	            dragOptions.gd.emit('plotly_selected', eventData);
	
	            if(currentPolygon && dragOptions.selectionDefs) {
	                // save last polygons
	                currentPolygon.subtract = subtract;
	                dragOptions.selectionDefs.push(currentPolygon);
	
	                // we have to keep reference to arrays container
	                dragOptions.mergedPolygons.length = 0;
	                [].push.apply(dragOptions.mergedPolygons, mergedPolygons);
	            }
	
	            if(dragOptions.doneFnCompleted) {
	                dragOptions.doneFnCompleted(selection);
	            }
	        }).catch(Lib.error);
	    };
	}
	
	function selectOnClick(evt, gd, xAxes, yAxes, subplot, dragOptions, polygonOutlines) {
	    var hoverData = gd._hoverdata;
	    var clickmode = gd._fullLayout.clickmode;
	    var sendEvents = clickmode.indexOf('event') > -1;
	    var selection = [];
	    var searchTraces, searchInfo, currentSelectionDef, selectionTester, traceSelection;
	    var thisTracesSelection, pointOrBinSelected, subtract, eventData, i;
	
	    if(isHoverDataSet(hoverData)) {
	        coerceSelectionsCache(evt, gd, dragOptions);
	        searchTraces = determineSearchTraces(gd, xAxes, yAxes, subplot);
	        var clickedPtInfo = extractClickedPtInfo(hoverData, searchTraces);
	        var isBinnedTrace = clickedPtInfo.pointNumbers.length > 0;
	
	
	        // Note: potentially costly operation isPointOrBinSelected is
	        // called as late as possible through the use of an assignment
	        // in an if condition.
	        if(isBinnedTrace ?
	            isOnlyThisBinSelected(searchTraces, clickedPtInfo) :
	            isOnlyOnePointSelected(searchTraces) &&
	                (pointOrBinSelected = isPointOrBinSelected(clickedPtInfo))) {
	            if(polygonOutlines) polygonOutlines.remove();
	            for(i = 0; i < searchTraces.length; i++) {
	                searchInfo = searchTraces[i];
	                searchInfo._module.selectPoints(searchInfo, false);
	            }
	
	            updateSelectedState(gd, searchTraces);
	
	            clearSelectionsCache(dragOptions);
	
	            if(sendEvents) {
	                gd.emit('plotly_deselect', null);
	            }
	        } else {
	            subtract = evt.shiftKey &&
	              (pointOrBinSelected !== undefined ?
	                pointOrBinSelected :
	                isPointOrBinSelected(clickedPtInfo));
	            currentSelectionDef = newPointSelectionDef(clickedPtInfo.pointNumber, clickedPtInfo.searchInfo, subtract);
	
	            var allSelectionDefs = dragOptions.selectionDefs.concat([currentSelectionDef]);
	            selectionTester = multiTester(allSelectionDefs);
	
	            for(i = 0; i < searchTraces.length; i++) {
	                traceSelection = searchTraces[i]._module.selectPoints(searchTraces[i], selectionTester);
	                thisTracesSelection = fillSelectionItem(traceSelection, searchTraces[i]);
	
	                if(selection.length) {
	                    for(var j = 0; j < thisTracesSelection.length; j++) {
	                        selection.push(thisTracesSelection[j]);
	                    }
	                } else selection = thisTracesSelection;
	            }
	
	            eventData = {points: selection};
	            updateSelectedState(gd, searchTraces, eventData);
	
	            if(currentSelectionDef && dragOptions) {
	                dragOptions.selectionDefs.push(currentSelectionDef);
	            }
	
	            if(polygonOutlines) drawSelection(dragOptions.mergedPolygons, polygonOutlines);
	
	            if(sendEvents) {
	                gd.emit('plotly_selected', eventData);
	            }
	        }
	    }
	}
	
	/**
	 * Constructs a new point selection definition object.
	 */
	function newPointSelectionDef(pointNumber, searchInfo, subtract) {
	    return {
	        pointNumber: pointNumber,
	        searchInfo: searchInfo,
	        subtract: subtract
	    };
	}
	
	function isPointSelectionDef(o) {
	    return 'pointNumber' in o && 'searchInfo' in o;
	}
	
	/*
	 * Constructs a new point number tester.
	 */
	function newPointNumTester(pointSelectionDef) {
	    return {
	        xmin: 0,
	        xmax: 0,
	        ymin: 0,
	        ymax: 0,
	        pts: [],
	        contains: function(pt, omitFirstEdge, pointNumber, searchInfo) {
	            var idxWantedTrace = pointSelectionDef.searchInfo.cd[0].trace._expandedIndex;
	            var idxActualTrace = searchInfo.cd[0].trace._expandedIndex;
	            return idxActualTrace === idxWantedTrace &&
	              pointNumber === pointSelectionDef.pointNumber;
	        },
	        isRect: false,
	        degenerate: false,
	        subtract: pointSelectionDef.subtract
	    };
	}
	
	/**
	 * Wraps multiple selection testers.
	 *
	 * @param {Array} list - An array of selection testers.
	 *
	 * @return a selection tester object with a contains function
	 * that can be called to evaluate a point against all wrapped
	 * selection testers that were passed in list.
	 */
	function multiTester(list) {
	    var testers = [];
	    var xmin = isPointSelectionDef(list[0]) ? 0 : list[0][0][0];
	    var xmax = xmin;
	    var ymin = isPointSelectionDef(list[0]) ? 0 : list[0][0][1];
	    var ymax = ymin;
	
	    for(var i = 0; i < list.length; i++) {
	        if(isPointSelectionDef(list[i])) {
	            testers.push(newPointNumTester(list[i]));
	        } else {
	            var tester = polygon.tester(list[i]);
	            tester.subtract = list[i].subtract;
	            testers.push(tester);
	            xmin = Math.min(xmin, tester.xmin);
	            xmax = Math.max(xmax, tester.xmax);
	            ymin = Math.min(ymin, tester.ymin);
	            ymax = Math.max(ymax, tester.ymax);
	        }
	    }
	
	    /**
	     * Tests if the given point is within this tester.
	     *
	     * @param {Array} pt - [0] is the x coordinate, [1] is the y coordinate of the point.
	     * @param {*} arg - An optional parameter to pass down to wrapped testers.
	     * @param {number} pointNumber - The point number of the point within the underlying data array.
	     * @param {number} searchInfo - An object identifying the trace the point is contained in.
	     *
	     * @return {boolean} true if point is considered to be selected, false otherwise.
	     */
	    function contains(pt, arg, pointNumber, searchInfo) {
	        var contained = false;
	        for(var i = 0; i < testers.length; i++) {
	            if(testers[i].contains(pt, arg, pointNumber, searchInfo)) {
	                // if contained by subtract tester - exclude the point
	                contained = testers[i].subtract === false;
	            }
	        }
	
	        return contained;
	    }
	
	    return {
	        xmin: xmin,
	        xmax: xmax,
	        ymin: ymin,
	        ymax: ymax,
	        pts: [],
	        contains: contains,
	        isRect: false,
	        degenerate: false
	    };
	}
	
	function coerceSelectionsCache(evt, gd, dragOptions) {
	    var fullLayout = gd._fullLayout;
	    var plotinfo = dragOptions.plotinfo;
	
	    var selectingOnSameSubplot = (
	        fullLayout._lastSelectedSubplot &&
	        fullLayout._lastSelectedSubplot === plotinfo.id
	    );
	    var hasModifierKey = evt.shiftKey || evt.altKey;
	
	    if(selectingOnSameSubplot && hasModifierKey &&
	      (plotinfo.selection && plotinfo.selection.selectionDefs) && !dragOptions.selectionDefs) {
	        // take over selection definitions from prev mode, if any
	        dragOptions.selectionDefs = plotinfo.selection.selectionDefs;
	        dragOptions.mergedPolygons = plotinfo.selection.mergedPolygons;
	    } else if(!hasModifierKey || !plotinfo.selection) {
	        clearSelectionsCache(dragOptions);
	    }
	
	    // clear selection outline when selecting a different subplot
	    if(!selectingOnSameSubplot) {
	        clearSelect(gd);
	        fullLayout._lastSelectedSubplot = plotinfo.id;
	    }
	}
	
	function clearSelectionsCache(dragOptions) {
	    var plotinfo = dragOptions.plotinfo;
	
	    plotinfo.selection = {};
	    plotinfo.selection.selectionDefs = dragOptions.selectionDefs = [];
	    plotinfo.selection.mergedPolygons = dragOptions.mergedPolygons = [];
	}
	
	function determineSearchTraces(gd, xAxes, yAxes, subplot) {
	    var searchTraces = [];
	    var xAxisIds = xAxes.map(getAxId);
	    var yAxisIds = yAxes.map(getAxId);
	    var cd, trace, i;
	
	    for(i = 0; i < gd.calcdata.length; i++) {
	        cd = gd.calcdata[i];
	        trace = cd[0].trace;
	
	        if(trace.visible !== true || !trace._module || !trace._module.selectPoints) continue;
	
	        if(subplot && (trace.subplot === subplot || trace.geo === subplot)) {
	            searchTraces.push(createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]));
	        } else if(
	          trace.type === 'splom' &&
	          // FIXME: make sure we don't have more than single axis for splom
	          trace._xaxes[xAxisIds[0]] && trace._yaxes[yAxisIds[0]]
	        ) {
	            var info = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
	            info.scene = gd._fullLayout._splomScenes[trace.uid];
	            searchTraces.push(info);
	        } else if(
	          trace.type === 'sankey'
	        ) {
	            var sankeyInfo = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
	            searchTraces.push(sankeyInfo);
	        } else {
	            if(xAxisIds.indexOf(trace.xaxis) === -1) continue;
	            if(yAxisIds.indexOf(trace.yaxis) === -1) continue;
	
	            searchTraces.push(createSearchInfo(trace._module, cd,
	              getFromId(gd, trace.xaxis), getFromId(gd, trace.yaxis)));
	        }
	    }
	
	    return searchTraces;
	
	    function createSearchInfo(module, calcData, xaxis, yaxis) {
	        return {
	            _module: module,
	            cd: calcData,
	            xaxis: xaxis,
	            yaxis: yaxis
	        };
	    }
	}
	
	function drawSelection(polygons, outlines) {
	    var paths = [];
	    var i, d;
	
	    for(i = 0; i < polygons.length; i++) {
	        var ppts = polygons[i];
	        paths.push(ppts.join('L') + 'L' + ppts[0]);
	    }
	
	    d = polygons.length > 0 ?
	      'M' + paths.join('M') + 'Z' :
	      'M0,0Z';
	    outlines.attr('d', d);
	}
	
	function isHoverDataSet(hoverData) {
	    return hoverData &&
	      Array.isArray(hoverData) &&
	      hoverData[0].hoverOnBox !== true;
	}
	
	function extractClickedPtInfo(hoverData, searchTraces) {
	    var hoverDatum = hoverData[0];
	    var pointNumber = -1;
	    var pointNumbers = [];
	    var searchInfo, i;
	
	    for(i = 0; i < searchTraces.length; i++) {
	        searchInfo = searchTraces[i];
	        if(hoverDatum.fullData._expandedIndex === searchInfo.cd[0].trace._expandedIndex) {
	            // Special case for box (and violin)
	            if(hoverDatum.hoverOnBox === true) {
	                break;
	            }
	
	            // Hint: in some traces like histogram, one graphical element
	            // doesn't correspond to one particular data point, but to
	            // bins of data points. Thus, hoverDatum can have a binNumber
	            // property instead of pointNumber.
	            if(hoverDatum.pointNumber !== undefined) {
	                pointNumber = hoverDatum.pointNumber;
	            } else if(hoverDatum.binNumber !== undefined) {
	                pointNumber = hoverDatum.binNumber;
	                pointNumbers = hoverDatum.pointNumbers;
	            }
	
	            break;
	        }
	    }
	
	    return {
	        pointNumber: pointNumber,
	        pointNumbers: pointNumbers,
	        searchInfo: searchInfo
	    };
	}
	
	function isPointOrBinSelected(clickedPtInfo) {
	    var trace = clickedPtInfo.searchInfo.cd[0].trace;
	    var ptNum = clickedPtInfo.pointNumber;
	    var ptNums = clickedPtInfo.pointNumbers;
	    var ptNumsSet = ptNums.length > 0;
	
	    // When pointsNumbers is set (e.g. histogram's binning),
	    // it is assumed that when the first point of
	    // a bin is selected, all others are as well
	    var ptNumToTest = ptNumsSet ? ptNums[0] : ptNum;
	
	    // TODO potential performance improvement
	    // Primarily we need this function to determine if a click adds
	    // or subtracts from a selection.
	    // In cases `trace.selectedpoints` is a huge array, indexOf
	    // might be slow. One remedy would be to introduce a hash somewhere.
	    return trace.selectedpoints ? trace.selectedpoints.indexOf(ptNumToTest) > -1 : false;
	}
	
	function isOnlyThisBinSelected(searchTraces, clickedPtInfo) {
	    var tracesWithSelectedPts = [];
	    var searchInfo, trace, isSameTrace, i;
	
	    for(i = 0; i < searchTraces.length; i++) {
	        searchInfo = searchTraces[i];
	        if(searchInfo.cd[0].trace.selectedpoints && searchInfo.cd[0].trace.selectedpoints.length > 0) {
	            tracesWithSelectedPts.push(searchInfo);
	        }
	    }
	
	    if(tracesWithSelectedPts.length === 1) {
	        isSameTrace = tracesWithSelectedPts[0] === clickedPtInfo.searchInfo;
	        if(isSameTrace) {
	            trace = clickedPtInfo.searchInfo.cd[0].trace;
	            if(trace.selectedpoints.length === clickedPtInfo.pointNumbers.length) {
	                for(i = 0; i < clickedPtInfo.pointNumbers.length; i++) {
	                    if(trace.selectedpoints.indexOf(clickedPtInfo.pointNumbers[i]) < 0) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	    }
	
	    return false;
	}
	
	function isOnlyOnePointSelected(searchTraces) {
	    var len = 0;
	    var searchInfo, trace, i;
	
	    for(i = 0; i < searchTraces.length; i++) {
	        searchInfo = searchTraces[i];
	        trace = searchInfo.cd[0].trace;
	        if(trace.selectedpoints) {
	            if(trace.selectedpoints.length > 1) return false;
	
	            len += trace.selectedpoints.length;
	            if(len > 1) return false;
	        }
	    }
	
	    return len === 1;
	}
	
	function updateSelectedState(gd, searchTraces, eventData) {
	    var i, searchInfo, cd, trace;
	
	    // before anything else, update preGUI if necessary
	    for(i = 0; i < searchTraces.length; i++) {
	        var fullInputTrace = searchTraces[i].cd[0].trace._fullInput;
	        var tracePreGUI = gd._fullLayout._tracePreGUI[fullInputTrace.uid] || {};
	        if(tracePreGUI.selectedpoints === undefined) {
	            tracePreGUI.selectedpoints = fullInputTrace._input.selectedpoints || null;
	        }
	    }
	
	    if(eventData) {
	        var pts = eventData.points || [];
	
	        for(i = 0; i < searchTraces.length; i++) {
	            trace = searchTraces[i].cd[0].trace;
	            trace._input.selectedpoints = trace._fullInput.selectedpoints = [];
	            if(trace._fullInput !== trace) trace.selectedpoints = [];
	        }
	
	        for(i = 0; i < pts.length; i++) {
	            var pt = pts[i];
	            var data = pt.data;
	            var fullData = pt.fullData;
	
	            if(pt.pointIndices) {
	                [].push.apply(data.selectedpoints, pt.pointIndices);
	                if(trace._fullInput !== trace) {
	                    [].push.apply(fullData.selectedpoints, pt.pointIndices);
	                }
	            } else {
	                data.selectedpoints.push(pt.pointIndex);
	                if(trace._fullInput !== trace) {
	                    fullData.selectedpoints.push(pt.pointIndex);
	                }
	            }
	        }
	    } else {
	        for(i = 0; i < searchTraces.length; i++) {
	            trace = searchTraces[i].cd[0].trace;
	            delete trace.selectedpoints;
	            delete trace._input.selectedpoints;
	            if(trace._fullInput !== trace) {
	                delete trace._fullInput.selectedpoints;
	            }
	        }
	    }
	
	    var hasRegl = false;
	
	    for(i = 0; i < searchTraces.length; i++) {
	        searchInfo = searchTraces[i];
	        cd = searchInfo.cd;
	        trace = cd[0].trace;
	
	        if(Registry.traceIs(trace, 'regl')) {
	            hasRegl = true;
	        }
	
	        var _module = searchInfo._module;
	        var fn = _module.styleOnSelect || _module.style;
	        if(fn) {
	            fn(gd, cd, cd[0].node3);
	            if(cd[0].nodeRangePlot3) fn(gd, cd, cd[0].nodeRangePlot3);
	        }
	    }
	
	    if(hasRegl) {
	        clearGlCanvases(gd);
	        redrawReglTraces(gd);
	    }
	}
	
	function mergePolygons(list, poly, subtract) {
	    var res;
	
	    if(subtract) {
	        res = polybool.difference({
	            regions: list,
	            inverted: false
	        }, {
	            regions: [poly],
	            inverted: false
	        });
	
	        return res.regions;
	    }
	
	    res = polybool.union({
	        regions: list,
	        inverted: false
	    }, {
	        regions: [poly],
	        inverted: false
	    });
	
	    return res.regions;
	}
	
	function fillSelectionItem(selection, searchInfo) {
	    if(Array.isArray(selection)) {
	        var cd = searchInfo.cd;
	        var trace = searchInfo.cd[0].trace;
	
	        for(var i = 0; i < selection.length; i++) {
	            selection[i] = makeEventData(selection[i], trace, cd);
	        }
	    }
	
	    return selection;
	}
	
	// until we get around to persistent selections, remove the outline
	// here. The selection itself will be removed when the plot redraws
	// at the end.
	function clearSelect(gd) {
	    var fullLayout = gd._fullLayout || {};
	    var zoomlayer = fullLayout._zoomlayer;
	    if(zoomlayer) {
	        zoomlayer.selectAll('.select-outline').remove();
	    }
	}
	
	module.exports = {
	    prepSelect: prepSelect,
	    clearSelect: clearSelect,
	    selectOnClick: selectOnClick
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../components/fx/helpers":626,"../../lib":716,"../../lib/clear_gl_canvases":701,"../../lib/polygon":728,"../../lib/throttle":741,"../../plot_api/subroutines":755,"../../registry":845,"./axis_ids":767,"./constants":770,"polybooljs":474}],782:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var cleanNumber = Lib.cleanNumber;
	var ms2DateTime = Lib.ms2DateTime;
	var dateTime2ms = Lib.dateTime2ms;
	var ensureNumber = Lib.ensureNumber;
	var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	
	var numConstants = _dereq_('../../constants/numerical');
	var FP_SAFE = numConstants.FP_SAFE;
	var BADNUM = numConstants.BADNUM;
	var LOG_CLIP = numConstants.LOG_CLIP;
	
	var constants = _dereq_('./constants');
	var axisIds = _dereq_('./axis_ids');
	
	function fromLog(v) {
	    return Math.pow(10, v);
	}
	
	function isValidCategory(v) {
	    return v !== null && v !== undefined;
	}
	
	/**
	 * Define the conversion functions for an axis data is used in 5 ways:
	 *
	 *  d: data, in whatever form it's provided
	 *  c: calcdata: turned into numbers, but not linearized
	 *  l: linearized - same as c except for log axes (and other nonlinear
	 *      mappings later?) this is used when we need to know if it's
	 *      *possible* to show some data on this axis, without caring about
	 *      the current range
	 *  p: pixel value - mapped to the screen with current size and zoom
	 *  r: ranges, tick0, and annotation positions match one of the above
	 *     but are handled differently for different types:
	 *     - linear and date: data format (d)
	 *     - category: calcdata format (c), and will stay that way because
	 *       the data format has no continuous mapping
	 *     - log: linearized (l) format
	 *       TODO: in v2.0 we plan to change it to data format. At that point
	 *       shapes will work the same way as ranges, tick0, and annotations
	 *       so they can use this conversion too.
	 *
	 * Creates/updates these conversion functions, and a few more utilities
	 * like cleanRange, and makeCalcdata
	 *
	 * also clears the autotick constraints ._minDtick, ._forceTick0
	 */
	module.exports = function setConvert(ax, fullLayout) {
	    fullLayout = fullLayout || {};
	
	    var axId = (ax._id || 'x');
	    var axLetter = axId.charAt(0);
	
	    function toLog(v, clip) {
	        if(v > 0) return Math.log(v) / Math.LN10;
	
	        else if(v <= 0 && clip && ax.range && ax.range.length === 2) {
	            // clip NaN (ie past negative infinity) to LOG_CLIP axis
	            // length past the negative edge
	            var r0 = ax.range[0];
	            var r1 = ax.range[1];
	            return 0.5 * (r0 + r1 - 2 * LOG_CLIP * Math.abs(r0 - r1));
	        } else return BADNUM;
	    }
	
	    /*
	     * wrapped dateTime2ms that:
	     * - accepts ms numbers for backward compatibility
	     * - inserts a dummy arg so calendar is the 3rd arg (see notes below).
	     * - defaults to ax.calendar
	     */
	    function dt2ms(v, _, calendar) {
	        // NOTE: Changed this behavior: previously we took any numeric value
	        // to be a ms, even if it was a string that could be a bare year.
	        // Now we convert it as a date if at all possible, and only try
	        // as (local) ms if that fails.
	        var ms = dateTime2ms(v, calendar || ax.calendar);
	        if(ms === BADNUM) {
	            if(isNumeric(v)) {
	                v = +v;
	                // keep track of tenths of ms, that `new Date` will drop
	                // same logic as in Lib.ms2DateTime
	                var msecTenths = Math.floor(Lib.mod(v + 0.05, 1) * 10);
	                var msRounded = Math.round(v - msecTenths / 10);
	                ms = dateTime2ms(new Date(msRounded)) + msecTenths / 10;
	            } else return BADNUM;
	        }
	        return ms;
	    }
	
	    // wrapped ms2DateTime to insert default ax.calendar
	    function ms2dt(v, r, calendar) {
	        return ms2DateTime(v, r, calendar || ax.calendar);
	    }
	
	    function getCategoryName(v) {
	        return ax._categories[Math.round(v)];
	    }
	
	    /*
	     * setCategoryIndex: return the index of category v,
	     * inserting it in the list if it's not already there
	     *
	     * this will enter the categories in the order it
	     * encounters them, ie all the categories from the
	     * first data set, then all the ones from the second
	     * that aren't in the first etc.
	     *
	     * it is assumed that this function is being invoked in the
	     * already sorted category order; otherwise there would be
	     * a disconnect between the array and the index returned
	     */
	    function setCategoryIndex(v) {
	        if(isValidCategory(v)) {
	            if(ax._categoriesMap === undefined) {
	                ax._categoriesMap = {};
	            }
	
	            if(ax._categoriesMap[v] !== undefined) {
	                return ax._categoriesMap[v];
	            } else {
	                ax._categories.push(typeof v === 'number' ? String(v) : v);
	
	                var curLength = ax._categories.length - 1;
	                ax._categoriesMap[v] = curLength;
	
	                return curLength;
	            }
	        }
	        return BADNUM;
	    }
	
	    function setMultiCategoryIndex(arrayIn, len) {
	        var arrayOut = new Array(len);
	
	        for(var i = 0; i < len; i++) {
	            var v0 = (arrayIn[0] || [])[i];
	            var v1 = (arrayIn[1] || [])[i];
	            arrayOut[i] = getCategoryIndex([v0, v1]);
	        }
	
	        return arrayOut;
	    }
	
	    function getCategoryIndex(v) {
	        if(ax._categoriesMap) {
	            return ax._categoriesMap[v];
	        }
	    }
	
	    function getCategoryPosition(v) {
	        // d2l/d2c variant that that won't add categories but will also
	        // allow numbers to be mapped to the linearized axis positions
	        var index = getCategoryIndex(v);
	        if(index !== undefined) return index;
	        if(isNumeric(v)) return +v;
	    }
	
	    function l2p(v) {
	        if(!isNumeric(v)) return BADNUM;
	
	        // include 2 fractional digits on pixel, for PDF zooming etc
	        return d3.round(ax._b + ax._m * v, 2);
	    }
	
	    function p2l(px) { return (px - ax._b) / ax._m; }
	
	    // conversions among c/l/p are fairly simple - do them together for all axis types
	    ax.c2l = (ax.type === 'log') ? toLog : ensureNumber;
	    ax.l2c = (ax.type === 'log') ? fromLog : ensureNumber;
	
	    ax.l2p = l2p;
	    ax.p2l = p2l;
	
	    ax.c2p = (ax.type === 'log') ? function(v, clip) { return l2p(toLog(v, clip)); } : l2p;
	    ax.p2c = (ax.type === 'log') ? function(px) { return fromLog(p2l(px)); } : p2l;
	
	    /*
	     * now type-specific conversions for **ALL** other combinations
	     * they're all written out, instead of being combinations of each other, for
	     * both clarity and speed.
	     */
	    if(['linear', '-'].indexOf(ax.type) !== -1) {
	        // all are data vals, but d and r need cleaning
	        ax.d2r = ax.r2d = ax.d2c = ax.r2c = ax.d2l = ax.r2l = cleanNumber;
	        ax.c2d = ax.c2r = ax.l2d = ax.l2r = ensureNumber;
	
	        ax.d2p = ax.r2p = function(v) { return ax.l2p(cleanNumber(v)); };
	        ax.p2d = ax.p2r = p2l;
	
	        ax.cleanPos = ensureNumber;
	    } else if(ax.type === 'log') {
	        // d and c are data vals, r and l are logged (but d and r need cleaning)
	        ax.d2r = ax.d2l = function(v, clip) { return toLog(cleanNumber(v), clip); };
	        ax.r2d = ax.r2c = function(v) { return fromLog(cleanNumber(v)); };
	
	        ax.d2c = ax.r2l = cleanNumber;
	        ax.c2d = ax.l2r = ensureNumber;
	
	        ax.c2r = toLog;
	        ax.l2d = fromLog;
	
	        ax.d2p = function(v, clip) { return ax.l2p(ax.d2r(v, clip)); };
	        ax.p2d = function(px) { return fromLog(p2l(px)); };
	
	        ax.r2p = function(v) { return ax.l2p(cleanNumber(v)); };
	        ax.p2r = p2l;
	
	        ax.cleanPos = ensureNumber;
	    } else if(ax.type === 'date') {
	        // r and d are date strings, l and c are ms
	
	        /*
	         * Any of these functions with r and d on either side, calendar is the
	         * **3rd** argument. log has reserved the second argument.
	         *
	         * Unless you need the special behavior of the second arg (ms2DateTime
	         * uses this to limit precision, toLog uses true to clip negatives
	         * to offscreen low rather than undefined), it's safe to pass 0.
	         */
	        ax.d2r = ax.r2d = Lib.identity;
	
	        ax.d2c = ax.r2c = ax.d2l = ax.r2l = dt2ms;
	        ax.c2d = ax.c2r = ax.l2d = ax.l2r = ms2dt;
	
	        ax.d2p = ax.r2p = function(v, _, calendar) { return ax.l2p(dt2ms(v, 0, calendar)); };
	        ax.p2d = ax.p2r = function(px, r, calendar) { return ms2dt(p2l(px), r, calendar); };
	
	        ax.cleanPos = function(v) { return Lib.cleanDate(v, BADNUM, ax.calendar); };
	    } else if(ax.type === 'category') {
	        // d is categories (string)
	        // c and l are indices (numbers)
	        // r is categories or numbers
	
	        ax.d2c = ax.d2l = setCategoryIndex;
	        ax.r2d = ax.c2d = ax.l2d = getCategoryName;
	
	        ax.d2r = ax.d2l_noadd = getCategoryPosition;
	
	        ax.r2c = function(v) {
	            var index = getCategoryPosition(v);
	            return index !== undefined ? index : ax.fraction2r(0.5);
	        };
	
	        ax.l2r = ax.c2r = ensureNumber;
	        ax.r2l = getCategoryPosition;
	
	        ax.d2p = function(v) { return ax.l2p(ax.r2c(v)); };
	        ax.p2d = function(px) { return getCategoryName(p2l(px)); };
	        ax.r2p = ax.d2p;
	        ax.p2r = p2l;
	
	        ax.cleanPos = function(v) {
	            if(typeof v === 'string' && v !== '') return v;
	            return ensureNumber(v);
	        };
	    } else if(ax.type === 'multicategory') {
	        // N.B. multicategory axes don't define d2c and d2l,
	        // as 'data-to-calcdata' conversion needs to take into
	        // account all data array items as in ax.makeCalcdata.
	
	        ax.r2d = ax.c2d = ax.l2d = getCategoryName;
	        ax.d2r = ax.d2l_noadd = getCategoryPosition;
	
	        ax.r2c = function(v) {
	            var index = getCategoryPosition(v);
	            return index !== undefined ? index : ax.fraction2r(0.5);
	        };
	
	        ax.r2c_just_indices = getCategoryIndex;
	
	        ax.l2r = ax.c2r = ensureNumber;
	        ax.r2l = getCategoryPosition;
	
	        ax.d2p = function(v) { return ax.l2p(ax.r2c(v)); };
	        ax.p2d = function(px) { return getCategoryName(p2l(px)); };
	        ax.r2p = ax.d2p;
	        ax.p2r = p2l;
	
	        ax.cleanPos = function(v) {
	            if(Array.isArray(v) || (typeof v === 'string' && v !== '')) return v;
	            return ensureNumber(v);
	        };
	
	        ax.setupMultiCategory = function(fullData) {
	            var traceIndices = ax._traceIndices;
	            var i, j;
	
	            var matchGroups = fullLayout._axisMatchGroups;
	            if(matchGroups && matchGroups.length && ax._categories.length === 0) {
	                for(i = 0; i < matchGroups.length; i++) {
	                    var group = matchGroups[i];
	                    if(group[axId]) {
	                        for(var axId2 in group) {
	                            if(axId2 !== axId) {
	                                var ax2 = fullLayout[axisIds.id2name(axId2)];
	                                traceIndices = traceIndices.concat(ax2._traceIndices);
	                            }
	                        }
	                    }
	                }
	            }
	
	            // [ [cnt, {$cat: index}], for 1,2 ]
	            var seen = [[0, {}], [0, {}]];
	            // [ [arrayIn[0][i], arrayIn[1][i]], for i .. N ]
	            var list = [];
	
	            for(i = 0; i < traceIndices.length; i++) {
	                var trace = fullData[traceIndices[i]];
	
	                if(axLetter in trace) {
	                    var arrayIn = trace[axLetter];
	                    var len = trace._length || Lib.minRowLength(arrayIn);
	
	                    if(isArrayOrTypedArray(arrayIn[0]) && isArrayOrTypedArray(arrayIn[1])) {
	                        for(j = 0; j < len; j++) {
	                            var v0 = arrayIn[0][j];
	                            var v1 = arrayIn[1][j];
	
	                            if(isValidCategory(v0) && isValidCategory(v1)) {
	                                list.push([v0, v1]);
	
	                                if(!(v0 in seen[0][1])) {
	                                    seen[0][1][v0] = seen[0][0]++;
	                                }
	                                if(!(v1 in seen[1][1])) {
	                                    seen[1][1][v1] = seen[1][0]++;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	
	            list.sort(function(a, b) {
	                var ind0 = seen[0][1];
	                var d = ind0[a[0]] - ind0[b[0]];
	                if(d) return d;
	
	                var ind1 = seen[1][1];
	                return ind1[a[1]] - ind1[b[1]];
	            });
	
	            for(i = 0; i < list.length; i++) {
	                setCategoryIndex(list[i]);
	            }
	        };
	    }
	
	    // find the range value at the specified (linear) fraction of the axis
	    ax.fraction2r = function(v) {
	        var rl0 = ax.r2l(ax.range[0]);
	        var rl1 = ax.r2l(ax.range[1]);
	        return ax.l2r(rl0 + v * (rl1 - rl0));
	    };
	
	    // find the fraction of the range at the specified range value
	    ax.r2fraction = function(v) {
	        var rl0 = ax.r2l(ax.range[0]);
	        var rl1 = ax.r2l(ax.range[1]);
	        return (ax.r2l(v) - rl0) / (rl1 - rl0);
	    };
	
	    /*
	     * cleanRange: make sure range is a couplet of valid & distinct values
	     * keep numbers away from the limits of floating point numbers,
	     * and dates away from the ends of our date system (+/- 9999 years)
	     *
	     * optional param rangeAttr: operate on a different attribute, like
	     * ax._r, rather than ax.range
	     */
	    ax.cleanRange = function(rangeAttr, opts) {
	        if(!opts) opts = {};
	        if(!rangeAttr) rangeAttr = 'range';
	
	        var range = Lib.nestedProperty(ax, rangeAttr).get();
	        var i, dflt;
	
	        if(ax.type === 'date') dflt = Lib.dfltRange(ax.calendar);
	        else if(axLetter === 'y') dflt = constants.DFLTRANGEY;
	        else dflt = opts.dfltRange || constants.DFLTRANGEX;
	
	        // make sure we don't later mutate the defaults
	        dflt = dflt.slice();
	
	        if(ax.rangemode === 'tozero' || ax.rangemode === 'nonnegative') {
	            dflt[0] = 0;
	        }
	
	        if(!range || range.length !== 2) {
	            Lib.nestedProperty(ax, rangeAttr).set(dflt);
	            return;
	        }
	
	        if(ax.type === 'date' && !ax.autorange) {
	            // check if milliseconds or js date objects are provided for range
	            // and convert to date strings
	            range[0] = Lib.cleanDate(range[0], BADNUM, ax.calendar);
	            range[1] = Lib.cleanDate(range[1], BADNUM, ax.calendar);
	        }
	
	        for(i = 0; i < 2; i++) {
	            if(ax.type === 'date') {
	                if(!Lib.isDateTime(range[i], ax.calendar)) {
	                    ax[rangeAttr] = dflt;
	                    break;
	                }
	
	                if(ax.r2l(range[0]) === ax.r2l(range[1])) {
	                    // split by +/- 1 second
	                    var linCenter = Lib.constrain(ax.r2l(range[0]),
	                        Lib.MIN_MS + 1000, Lib.MAX_MS - 1000);
	                    range[0] = ax.l2r(linCenter - 1000);
	                    range[1] = ax.l2r(linCenter + 1000);
	                    break;
	                }
	            } else {
	                if(!isNumeric(range[i])) {
	                    if(isNumeric(range[1 - i])) {
	                        range[i] = range[1 - i] * (i ? 10 : 0.1);
	                    } else {
	                        ax[rangeAttr] = dflt;
	                        break;
	                    }
	                }
	
	                if(range[i] < -FP_SAFE) range[i] = -FP_SAFE;
	                else if(range[i] > FP_SAFE) range[i] = FP_SAFE;
	
	                if(range[0] === range[1]) {
	                    // somewhat arbitrary: split by 1 or 1ppm, whichever is bigger
	                    var inc = Math.max(1, Math.abs(range[0] * 1e-6));
	                    range[0] -= inc;
	                    range[1] += inc;
	                }
	            }
	        }
	    };
	
	    // set scaling to pixels
	    ax.setScale = function(usePrivateRange) {
	        var gs = fullLayout._size;
	
	        // make sure we have a domain (pull it in from the axis
	        // this one is overlaying if necessary)
	        if(ax.overlaying) {
	            var ax2 = axisIds.getFromId({ _fullLayout: fullLayout }, ax.overlaying);
	            ax.domain = ax2.domain;
	        }
	
	        // While transitions are occuring, occurring, we get a double-transform
	        // issue if we transform the drawn layer *and* use the new axis range to
	        // draw the data. This allows us to construct setConvert using the pre-
	        // interaction values of the range:
	        var rangeAttr = (usePrivateRange && ax._r) ? '_r' : 'range';
	        var calendar = ax.calendar;
	        ax.cleanRange(rangeAttr);
	
	        var rl0 = ax.r2l(ax[rangeAttr][0], calendar);
	        var rl1 = ax.r2l(ax[rangeAttr][1], calendar);
	
	        if(axLetter === 'y') {
	            ax._offset = gs.t + (1 - ax.domain[1]) * gs.h;
	            ax._length = gs.h * (ax.domain[1] - ax.domain[0]);
	            ax._m = ax._length / (rl0 - rl1);
	            ax._b = -ax._m * rl1;
	        } else {
	            ax._offset = gs.l + ax.domain[0] * gs.w;
	            ax._length = gs.w * (ax.domain[1] - ax.domain[0]);
	            ax._m = ax._length / (rl1 - rl0);
	            ax._b = -ax._m * rl0;
	        }
	
	        if(!isFinite(ax._m) || !isFinite(ax._b) || ax._length < 0) {
	            fullLayout._replotting = false;
	            throw new Error('Something went wrong with axis scaling');
	        }
	    };
	
	    // makeCalcdata: takes an x or y array and converts it
	    // to a position on the axis object "ax"
	    // inputs:
	    //      trace - a data object from gd.data
	    //      axLetter - a string, either 'x' or 'y', for which item
	    //          to convert (TODO: is this now always the same as
	    //          the first letter of ax._id?)
	    // in case the expected data isn't there, make a list of
	    // integers based on the opposite data
	    ax.makeCalcdata = function(trace, axLetter) {
	        var arrayIn, arrayOut, i, len;
	
	        var axType = ax.type;
	        var cal = axType === 'date' && trace[axLetter + 'calendar'];
	
	        if(axLetter in trace) {
	            arrayIn = trace[axLetter];
	            len = trace._length || Lib.minRowLength(arrayIn);
	
	            if(Lib.isTypedArray(arrayIn) && (axType === 'linear' || axType === 'log')) {
	                if(len === arrayIn.length) {
	                    return arrayIn;
	                } else if(arrayIn.subarray) {
	                    return arrayIn.subarray(0, len);
	                }
	            }
	
	            if(axType === 'multicategory') {
	                return setMultiCategoryIndex(arrayIn, len);
	            }
	
	            arrayOut = new Array(len);
	            for(i = 0; i < len; i++) {
	                arrayOut[i] = ax.d2c(arrayIn[i], 0, cal);
	            }
	        } else {
	            var v0 = ((axLetter + '0') in trace) ? ax.d2c(trace[axLetter + '0'], 0, cal) : 0;
	            var dv = (trace['d' + axLetter]) ? Number(trace['d' + axLetter]) : 1;
	
	            // the opposing data, for size if we have x and dx etc
	            arrayIn = trace[{x: 'y', y: 'x'}[axLetter]];
	            len = trace._length || arrayIn.length;
	            arrayOut = new Array(len);
	
	            for(i = 0; i < len; i++) {
	                arrayOut[i] = v0 + i * dv;
	            }
	        }
	
	        return arrayOut;
	    };
	
	    ax.isValidRange = function(range) {
	        return (
	            Array.isArray(range) &&
	            range.length === 2 &&
	            isNumeric(ax.r2l(range[0])) &&
	            isNumeric(ax.r2l(range[1]))
	        );
	    };
	
	    ax.isPtWithinRange = function(d, calendar) {
	        var coord = ax.c2l(d[axLetter], null, calendar);
	        var r0 = ax.r2l(ax.range[0]);
	        var r1 = ax.r2l(ax.range[1]);
	
	        if(r0 < r1) {
	            return r0 <= coord && coord <= r1;
	        } else {
	            // Reversed axis case.
	            return r1 <= coord && coord <= r0;
	        }
	    };
	
	    // should skip if not category nor multicategory
	    ax.clearCalc = function() {
	        var emptyCategories = function() {
	            ax._categories = [];
	            ax._categoriesMap = {};
	        };
	
	        var matchGroups = fullLayout._axisMatchGroups;
	
	        if(matchGroups && matchGroups.length) {
	            var found = false;
	
	            for(var i = 0; i < matchGroups.length; i++) {
	                var group = matchGroups[i];
	
	                if(group[axId]) {
	                    found = true;
	                    var categories = null;
	                    var categoriesMap = null;
	
	                    for(var axId2 in group) {
	                        var ax2 = fullLayout[axisIds.id2name(axId2)];
	                        if(ax2._categories) {
	                            categories = ax2._categories;
	                            categoriesMap = ax2._categoriesMap;
	                            break;
	                        }
	                    }
	
	                    if(categories && categoriesMap) {
	                        ax._categories = categories;
	                        ax._categoriesMap = categoriesMap;
	                    } else {
	                        emptyCategories();
	                    }
	                    break;
	                }
	            }
	            if(!found) emptyCategories();
	        } else {
	            emptyCategories();
	        }
	
	        if(ax._initialCategories) {
	            for(var j = 0; j < ax._initialCategories.length; j++) {
	                setCategoryIndex(ax._initialCategories[j]);
	            }
	        }
	    };
	
	    // sort the axis (and all the matching ones) by _initialCategories
	    // returns the indices of the traces affected by the reordering
	    ax.sortByInitialCategories = function() {
	        var affectedTraces = [];
	        var emptyCategories = function() {
	            ax._categories = [];
	            ax._categoriesMap = {};
	        };
	
	        emptyCategories();
	
	        if(ax._initialCategories) {
	            for(var j = 0; j < ax._initialCategories.length; j++) {
	                setCategoryIndex(ax._initialCategories[j]);
	            }
	        }
	
	        affectedTraces = affectedTraces.concat(ax._traceIndices);
	
	        // Propagate to matching axes
	        var group = ax._matchGroup;
	        for(var axId2 in group) {
	            if(axId === axId2) continue;
	            var ax2 = fullLayout[axisIds.id2name(axId2)];
	            ax2._categories = ax._categories;
	            ax2._categoriesMap = ax._categoriesMap;
	            affectedTraces = affectedTraces.concat(ax2._traceIndices);
	        }
	        return affectedTraces;
	    };
	
	    // Propagate localization into the axis so that
	    // methods in Axes can use it w/o having to pass fullLayout
	    // Default (non-d3) number formatting uses separators directly
	    // dates and d3-formatted numbers use the d3 locale
	    // Fall back on default format for dummy axes that don't care about formatting
	    var locale = fullLayout._d3locale;
	    if(ax.type === 'date') {
	        ax._dateFormat = locale ? locale.timeFormat.utc : d3.time.format.utc;
	        ax._extraFormat = fullLayout._extraFormat;
	    }
	    // occasionally we need _numFormat to pass through
	    // even though it won't be needed by this axis
	    ax._separators = fullLayout.separators;
	    ax._numFormat = locale ? locale.numberFormat : d3.format;
	
	    // and for bar charts and box plots: reset forced minimum tick spacing
	    delete ax._minDtick;
	    delete ax._forceTick0;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"./axis_ids":767,"./constants":770,"d3":164,"fast-isnumeric":227}],783:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	var handleArrayContainerDefaults = _dereq_('../array_container_defaults');
	
	module.exports = function handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, config) {
	    if(!config || config.pass === 1) {
	        handlePrefixSuffix(containerIn, containerOut, coerce, axType, options);
	    }
	
	    if(!config || config.pass === 2) {
	        handleOtherDefaults(containerIn, containerOut, coerce, axType, options);
	    }
	};
	
	function handlePrefixSuffix(containerIn, containerOut, coerce, axType, options) {
	    var showAttrDflt = getShowAttrDflt(containerIn);
	
	    var tickPrefix = coerce('tickprefix');
	    if(tickPrefix) coerce('showtickprefix', showAttrDflt);
	
	    var tickSuffix = coerce('ticksuffix', options.tickSuffixDflt);
	    if(tickSuffix) coerce('showticksuffix', showAttrDflt);
	}
	
	function handleOtherDefaults(containerIn, containerOut, coerce, axType, options) {
	    var showAttrDflt = getShowAttrDflt(containerIn);
	
	    var tickPrefix = coerce('tickprefix');
	    if(tickPrefix) coerce('showtickprefix', showAttrDflt);
	
	    var tickSuffix = coerce('ticksuffix', options.tickSuffixDflt);
	    if(tickSuffix) coerce('showticksuffix', showAttrDflt);
	
	    var showTickLabels = coerce('showticklabels');
	    if(showTickLabels) {
	        var font = options.font || {};
	        var contColor = containerOut.color;
	        // as with titlefont.color, inherit axis.color only if one was
	        // explicitly provided
	        var dfltFontColor = (contColor && contColor !== layoutAttributes.color.dflt) ?
	            contColor : font.color;
	        Lib.coerceFont(coerce, 'tickfont', {
	            family: font.family,
	            size: font.size,
	            color: dfltFontColor
	        });
	        coerce('tickangle');
	
	        if(axType !== 'category') {
	            var tickFormat = coerce('tickformat');
	            var tickformatStops = containerIn.tickformatstops;
	            if(Array.isArray(tickformatStops) && tickformatStops.length) {
	                handleArrayContainerDefaults(containerIn, containerOut, {
	                    name: 'tickformatstops',
	                    inclusionAttr: 'enabled',
	                    handleItemDefaults: tickformatstopDefaults
	                });
	            }
	            if(!tickFormat && axType !== 'date') {
	                coerce('showexponent', showAttrDflt);
	                coerce('exponentformat');
	                coerce('separatethousands');
	            }
	        }
	    }
	}
	
	/*
	 * Attributes 'showexponent', 'showtickprefix' and 'showticksuffix'
	 * share values.
	 *
	 * If only 1 attribute is set,
	 * the remaining attributes inherit that value.
	 *
	 * If 2 attributes are set to the same value,
	 * the remaining attribute inherits that value.
	 *
	 * If 2 attributes are set to different values,
	 * the remaining is set to its dflt value.
	 *
	 */
	function getShowAttrDflt(containerIn) {
	    var showAttrsAll = ['showexponent', 'showtickprefix', 'showticksuffix'];
	    var showAttrs = showAttrsAll.filter(function(a) {
	        return containerIn[a] !== undefined;
	    });
	    var sameVal = function(a) {
	        return containerIn[a] === containerIn[showAttrs[0]];
	    };
	
	    if(showAttrs.every(sameVal) || showAttrs.length === 1) {
	        return containerIn[showAttrs[0]];
	    }
	}
	
	function tickformatstopDefaults(valueIn, valueOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(valueIn, valueOut, layoutAttributes.tickformatstops, attr, dflt);
	    }
	
	    var enabled = coerce('enabled');
	    if(enabled) {
	        coerce('dtickrange');
	        coerce('value');
	    }
	}
	
	},{"../../lib":716,"../array_container_defaults":760,"./layout_attributes":776}],784:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	
	
	/**
	 * options: inherits outerTicks from axes.handleAxisDefaults
	 */
	module.exports = function handleTickDefaults(containerIn, containerOut, coerce, options) {
	    var tickLen = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'ticklen');
	    var tickWidth = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'tickwidth');
	    var tickColor = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'tickcolor', containerOut.color);
	    var showTicks = coerce('ticks', (options.outerTicks || tickLen || tickWidth || tickColor) ? 'outside' : '');
	
	    if(!showTicks) {
	        delete containerOut.ticklen;
	        delete containerOut.tickwidth;
	        delete containerOut.tickcolor;
	    }
	};
	
	},{"../../lib":716,"./layout_attributes":776}],785:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var cleanTicks = _dereq_('./clean_ticks');
	
	module.exports = function handleTickValueDefaults(containerIn, containerOut, coerce, axType) {
	    var tickmode;
	
	    if(containerIn.tickmode === 'array' &&
	            (axType === 'log' || axType === 'date')) {
	        tickmode = containerOut.tickmode = 'auto';
	    } else {
	        var tickmodeDefault = Array.isArray(containerIn.tickvals) ? 'array' :
	            containerIn.dtick ? 'linear' :
	            'auto';
	        tickmode = coerce('tickmode', tickmodeDefault);
	    }
	
	    if(tickmode === 'auto') coerce('nticks');
	    else if(tickmode === 'linear') {
	        // dtick is usually a positive number, but there are some
	        // special strings available for log or date axes
	        // tick0 also has special logic
	        var dtick = containerOut.dtick = cleanTicks.dtick(
	            containerIn.dtick, axType);
	        containerOut.tick0 = cleanTicks.tick0(
	            containerIn.tick0, axType, containerOut.calendar, dtick);
	    } else if(axType !== 'multicategory') {
	        var tickvals = coerce('tickvals');
	        if(tickvals === undefined) containerOut.tickmode = 'auto';
	        else coerce('ticktext');
	    }
	};
	
	},{"./clean_ticks":769}],786:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var Axes = _dereq_('./axes');
	
	/**
	 * transitionAxes
	 *
	 * transition axes from one set of ranges to another, using a svg
	 * transformations, similar to during panning.
	 *
	 * @param {DOM element | object} gd
	 * @param {array} edits : array of 'edits', each item with
	 * - plotinfo {object} subplot object
	 * - xr0 {array} initial x-range
	 * - xr1 {array} end x-range
	 * - yr0 {array} initial y-range
	 * - yr1 {array} end y-range
	 * @param {object} transitionOpts
	 * @param {function} makeOnCompleteCallback
	 */
	module.exports = function transitionAxes(gd, edits, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = gd._fullLayout;
	
	    // special case for redraw:false Plotly.animate that relies on this
	    // to update axis-referenced layout components
	    if(edits.length === 0) {
	        Axes.redrawComponents(gd);
	        return;
	    }
	
	    function unsetSubplotTransform(subplot) {
	        var xa = subplot.xaxis;
	        var ya = subplot.yaxis;
	
	        fullLayout._defs.select('#' + subplot.clipId + '> rect')
	            .call(Drawing.setTranslate, 0, 0)
	            .call(Drawing.setScale, 1, 1);
	
	        subplot.plot
	            .call(Drawing.setTranslate, xa._offset, ya._offset)
	            .call(Drawing.setScale, 1, 1);
	
	        var traceGroups = subplot.plot.selectAll('.scatterlayer .trace');
	
	        // This is specifically directed at scatter traces, applying an inverse
	        // scale to individual points to counteract the scale of the trace
	        // as a whole:
	        traceGroups.selectAll('.point')
	            .call(Drawing.setPointGroupScale, 1, 1);
	        traceGroups.selectAll('.textpoint')
	            .call(Drawing.setTextPointsScale, 1, 1);
	        traceGroups
	            .call(Drawing.hideOutsideRangePoints, subplot);
	    }
	
	    function updateSubplot(edit, progress) {
	        var plotinfo = edit.plotinfo;
	        var xa = plotinfo.xaxis;
	        var ya = plotinfo.yaxis;
	        var xlen = xa._length;
	        var ylen = ya._length;
	        var editX = !!edit.xr1;
	        var editY = !!edit.yr1;
	        var viewBox = [];
	
	        if(editX) {
	            var xr0 = Lib.simpleMap(edit.xr0, xa.r2l);
	            var xr1 = Lib.simpleMap(edit.xr1, xa.r2l);
	            var dx0 = xr0[1] - xr0[0];
	            var dx1 = xr1[1] - xr1[0];
	            viewBox[0] = (xr0[0] * (1 - progress) + progress * xr1[0] - xr0[0]) / (xr0[1] - xr0[0]) * xlen;
	            viewBox[2] = xlen * ((1 - progress) + progress * dx1 / dx0);
	            xa.range[0] = xa.l2r(xr0[0] * (1 - progress) + progress * xr1[0]);
	            xa.range[1] = xa.l2r(xr0[1] * (1 - progress) + progress * xr1[1]);
	        } else {
	            viewBox[0] = 0;
	            viewBox[2] = xlen;
	        }
	
	        if(editY) {
	            var yr0 = Lib.simpleMap(edit.yr0, ya.r2l);
	            var yr1 = Lib.simpleMap(edit.yr1, ya.r2l);
	            var dy0 = yr0[1] - yr0[0];
	            var dy1 = yr1[1] - yr1[0];
	            viewBox[1] = (yr0[1] * (1 - progress) + progress * yr1[1] - yr0[1]) / (yr0[0] - yr0[1]) * ylen;
	            viewBox[3] = ylen * ((1 - progress) + progress * dy1 / dy0);
	            ya.range[0] = xa.l2r(yr0[0] * (1 - progress) + progress * yr1[0]);
	            ya.range[1] = ya.l2r(yr0[1] * (1 - progress) + progress * yr1[1]);
	        } else {
	            viewBox[1] = 0;
	            viewBox[3] = ylen;
	        }
	
	        Axes.drawOne(gd, xa, {skipTitle: true});
	        Axes.drawOne(gd, ya, {skipTitle: true});
	        Axes.redrawComponents(gd, [xa._id, ya._id]);
	
	        var xScaleFactor = editX ? xlen / viewBox[2] : 1;
	        var yScaleFactor = editY ? ylen / viewBox[3] : 1;
	        var clipDx = editX ? viewBox[0] : 0;
	        var clipDy = editY ? viewBox[1] : 0;
	        var fracDx = editX ? (viewBox[0] / viewBox[2] * xlen) : 0;
	        var fracDy = editY ? (viewBox[1] / viewBox[3] * ylen) : 0;
	        var plotDx = xa._offset - fracDx;
	        var plotDy = ya._offset - fracDy;
	
	        plotinfo.clipRect
	            .call(Drawing.setTranslate, clipDx, clipDy)
	            .call(Drawing.setScale, 1 / xScaleFactor, 1 / yScaleFactor);
	
	        plotinfo.plot
	            .call(Drawing.setTranslate, plotDx, plotDy)
	            .call(Drawing.setScale, xScaleFactor, yScaleFactor);
	
	        // apply an inverse scale to individual points to counteract
	        // the scale of the trace group.
	        Drawing.setPointGroupScale(plotinfo.zoomScalePts, 1 / xScaleFactor, 1 / yScaleFactor);
	        Drawing.setTextPointsScale(plotinfo.zoomScaleTxt, 1 / xScaleFactor, 1 / yScaleFactor);
	    }
	
	    var onComplete;
	    if(makeOnCompleteCallback) {
	        // This module makes the choice whether or not it notifies Plotly.transition
	        // about completion:
	        onComplete = makeOnCompleteCallback();
	    }
	
	    function transitionComplete() {
	        var aobj = {};
	
	        for(var i = 0; i < edits.length; i++) {
	            var edit = edits[i];
	            var xa = edit.plotinfo.xaxis;
	            var ya = edit.plotinfo.yaxis;
	            if(edit.xr1) aobj[xa._name + '.range'] = edit.xr1.slice();
	            if(edit.yr1) aobj[ya._name + '.range'] = edit.yr1.slice();
	        }
	
	        // Signal that this transition has completed:
	        onComplete && onComplete();
	
	        return Registry.call('relayout', gd, aobj).then(function() {
	            for(var i = 0; i < edits.length; i++) {
	                unsetSubplotTransform(edits[i].plotinfo);
	            }
	        });
	    }
	
	    function transitionInterrupt() {
	        var aobj = {};
	
	        for(var i = 0; i < edits.length; i++) {
	            var edit = edits[i];
	            var xa = edit.plotinfo.xaxis;
	            var ya = edit.plotinfo.yaxis;
	            if(edit.xr0) aobj[xa._name + '.range'] = edit.xr0.slice();
	            if(edit.yr0) aobj[ya._name + '.range'] = edit.yr0.slice();
	        }
	
	        return Registry.call('relayout', gd, aobj).then(function() {
	            for(var i = 0; i < edits.length; i++) {
	                unsetSubplotTransform(edits[i].plotinfo);
	            }
	        });
	    }
	
	    var t1, t2, raf;
	    var easeFn = d3.ease(transitionOpts.easing);
	
	    gd._transitionData._interruptCallbacks.push(function() {
	        window.cancelAnimationFrame(raf);
	        raf = null;
	        return transitionInterrupt();
	    });
	
	    function doFrame() {
	        t2 = Date.now();
	
	        var tInterp = Math.min(1, (t2 - t1) / transitionOpts.duration);
	        var progress = easeFn(tInterp);
	
	        for(var i = 0; i < edits.length; i++) {
	            updateSubplot(edits[i], progress);
	        }
	
	        if(t2 - t1 > transitionOpts.duration) {
	            transitionComplete();
	            raf = window.cancelAnimationFrame(doFrame);
	        } else {
	            raf = window.requestAnimationFrame(doFrame);
	        }
	    }
	
	    t1 = Date.now();
	    raf = window.requestAnimationFrame(doFrame);
	
	    return Promise.resolve();
	};
	
	},{"../../components/drawing":612,"../../lib":716,"../../registry":845,"./axes":764,"d3":164}],787:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var traceIs = _dereq_('../../registry').traceIs;
	var autoType = _dereq_('./axis_autotype');
	
	/*
	 *  data: the plot data to use in choosing auto type
	 *  name: axis object name (ie 'xaxis') if one should be stored
	 */
	module.exports = function handleTypeDefaults(containerIn, containerOut, coerce, options) {
	    var axType = coerce('type', (options.splomStash || {}).type);
	
	    if(axType === '-') {
	        setAutoType(containerOut, options.data);
	
	        if(containerOut.type === '-') {
	            containerOut.type = 'linear';
	        } else {
	            // copy autoType back to input axis
	            // note that if this object didn't exist
	            // in the input layout, we have to put it in
	            // this happens in the main supplyDefaults function
	            containerIn.type = containerOut.type;
	        }
	    }
	};
	
	function setAutoType(ax, data) {
	    // new logic: let people specify any type they want,
	    // only autotype if type is '-'
	    if(ax.type !== '-') return;
	
	    var id = ax._id;
	    var axLetter = id.charAt(0);
	
	    // support 3d
	    if(id.indexOf('scene') !== -1) id = axLetter;
	
	    var d0 = getFirstNonEmptyTrace(data, id, axLetter);
	    if(!d0) return;
	
	    // first check for histograms, as the count direction
	    // should always default to a linear axis
	    if(d0.type === 'histogram' &&
	            axLetter === {v: 'y', h: 'x'}[d0.orientation || 'v']) {
	        ax.type = 'linear';
	        return;
	    }
	
	    var calAttr = axLetter + 'calendar';
	    var calendar = d0[calAttr];
	    var opts = {noMultiCategory: !traceIs(d0, 'cartesian') || traceIs(d0, 'noMultiCategory')};
	    var i;
	
	    // check all boxes on this x axis to see
	    // if they're dates, numbers, or categories
	    if(isBoxWithoutPositionCoords(d0, axLetter)) {
	        var posLetter = getBoxPosLetter(d0);
	        var boxPositions = [];
	
	        for(i = 0; i < data.length; i++) {
	            var trace = data[i];
	            if(!traceIs(trace, 'box-violin') || (trace[axLetter + 'axis'] || axLetter) !== id) continue;
	
	            if(trace[posLetter] !== undefined) boxPositions.push(trace[posLetter][0]);
	            else if(trace.name !== undefined) boxPositions.push(trace.name);
	            else boxPositions.push('text');
	
	            if(trace[calAttr] !== calendar) calendar = undefined;
	        }
	
	        ax.type = autoType(boxPositions, calendar, opts);
	    } else if(d0.type === 'splom') {
	        var dimensions = d0.dimensions;
	        var dim = dimensions[d0._axesDim[id]];
	        if(dim.visible) ax.type = autoType(dim.values, calendar, opts);
	    } else {
	        ax.type = autoType(d0[axLetter] || [d0[axLetter + '0']], calendar, opts);
	    }
	}
	
	function getFirstNonEmptyTrace(data, id, axLetter) {
	    for(var i = 0; i < data.length; i++) {
	        var trace = data[i];
	
	        if(trace.type === 'splom' &&
	                trace._length > 0 &&
	                (trace['_' + axLetter + 'axes'] || {})[id]
	        ) {
	            return trace;
	        }
	
	        if((trace[axLetter + 'axis'] || axLetter) === id) {
	            if(isBoxWithoutPositionCoords(trace, axLetter)) {
	                return trace;
	            } else if((trace[axLetter] || []).length || trace[axLetter + '0']) {
	                return trace;
	            }
	        }
	    }
	}
	
	function getBoxPosLetter(trace) {
	    return {v: 'x', h: 'y'}[trace.orientation || 'v'];
	}
	
	function isBoxWithoutPositionCoords(trace, axLetter) {
	    var posLetter = getBoxPosLetter(trace);
	    var isBox = traceIs(trace, 'box-violin');
	    var isCandlestick = traceIs(trace._fullInput || {}, 'candlestick');
	
	    return (
	        isBox &&
	        !isCandlestick &&
	        axLetter === posLetter &&
	        trace[posLetter] === undefined &&
	        trace[posLetter + '0'] === undefined
	    );
	}
	
	},{"../../registry":845,"./axis_autotype":765}],788:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	var Lib = _dereq_('../lib');
	
	/*
	 * Create or update an observer. This function is designed to be
	 * idempotent so that it can be called over and over as the component
	 * updates, and will attach and detach listeners as needed.
	 *
	 * @param {optional object} container
	 *      An object on which the observer is stored. This is the mechanism
	 *      by which it is idempotent. If it already exists, another won't be
	 *      added. Each time it's called, the value lookup table is updated.
	 * @param {array} commandList
	 *      An array of commands, following either `buttons` of `updatemenus`
	 *      or `steps` of `sliders`.
	 * @param {function} onchange
	 *      A listener called when the value is changed. Receives data object
	 *      with information about the new state.
	 */
	exports.manageCommandObserver = function(gd, container, commandList, onchange) {
	    var ret = {};
	    var enabled = true;
	
	    if(container && container._commandObserver) {
	        ret = container._commandObserver;
	    }
	
	    if(!ret.cache) {
	        ret.cache = {};
	    }
	
	    // Either create or just recompute this:
	    ret.lookupTable = {};
	
	    var binding = exports.hasSimpleAPICommandBindings(gd, commandList, ret.lookupTable);
	
	    if(container && container._commandObserver) {
	        if(!binding) {
	            // If container exists and there are no longer any bindings,
	            // remove existing:
	            if(container._commandObserver.remove) {
	                container._commandObserver.remove();
	                container._commandObserver = null;
	                return ret;
	            }
	        } else {
	            // If container exists and there *are* bindings, then the lookup
	            // table should have been updated and check is already attached,
	            // so there's nothing to be done:
	            return ret;
	        }
	    }
	
	    // Determine whether there's anything to do for this binding:
	
	    if(binding) {
	        // Build the cache:
	        bindingValueHasChanged(gd, binding, ret.cache);
	
	        ret.check = function check() {
	            if(!enabled) return;
	
	            var update = bindingValueHasChanged(gd, binding, ret.cache);
	
	            if(update.changed && onchange) {
	                // Disable checks for the duration of this command in order to avoid
	                // infinite loops:
	                if(ret.lookupTable[update.value] !== undefined) {
	                    ret.disable();
	                    Promise.resolve(onchange({
	                        value: update.value,
	                        type: binding.type,
	                        prop: binding.prop,
	                        traces: binding.traces,
	                        index: ret.lookupTable[update.value]
	                    })).then(ret.enable, ret.enable);
	                }
	            }
	
	            return update.changed;
	        };
	
	        var checkEvents = [
	            'plotly_relayout',
	            'plotly_redraw',
	            'plotly_restyle',
	            'plotly_update',
	            'plotly_animatingframe',
	            'plotly_afterplot'
	        ];
	
	        for(var i = 0; i < checkEvents.length; i++) {
	            gd._internalOn(checkEvents[i], ret.check);
	        }
	
	        ret.remove = function() {
	            for(var i = 0; i < checkEvents.length; i++) {
	                gd._removeInternalListener(checkEvents[i], ret.check);
	            }
	        };
	    } else {
	        // TODO: It'd be really neat to actually give a *reason* for this, but at least a warning
	        // is a start
	        Lib.log('Unable to automatically bind plot updates to API command');
	
	        ret.lookupTable = {};
	        ret.remove = function() {};
	    }
	
	    ret.disable = function disable() {
	        enabled = false;
	    };
	
	    ret.enable = function enable() {
	        enabled = true;
	    };
	
	    if(container) {
	        container._commandObserver = ret;
	    }
	
	    return ret;
	};
	
	/*
	 * This function checks to see if an array of objects containing
	 * method and args properties is compatible with automatic two-way
	 * binding. The criteria right now are that
	 *
	 *   1. multiple traces may be affected
	 *   2. only one property may be affected
	 *   3. the same property must be affected by all commands
	 */
	exports.hasSimpleAPICommandBindings = function(gd, commandList, bindingsByValue) {
	    var i;
	    var n = commandList.length;
	
	    var refBinding;
	
	    for(i = 0; i < n; i++) {
	        var binding;
	        var command = commandList[i];
	        var method = command.method;
	        var args = command.args;
	
	        if(!Array.isArray(args)) args = [];
	
	        // If any command has no method, refuse to bind:
	        if(!method) {
	            return false;
	        }
	        var bindings = exports.computeAPICommandBindings(gd, method, args);
	
	        // Right now, handle one and *only* one property being set:
	        if(bindings.length !== 1) {
	            return false;
	        }
	
	        if(!refBinding) {
	            refBinding = bindings[0];
	            if(Array.isArray(refBinding.traces)) {
	                refBinding.traces.sort();
	            }
	        } else {
	            binding = bindings[0];
	            if(binding.type !== refBinding.type) {
	                return false;
	            }
	            if(binding.prop !== refBinding.prop) {
	                return false;
	            }
	            if(Array.isArray(refBinding.traces)) {
	                if(Array.isArray(binding.traces)) {
	                    binding.traces.sort();
	                    for(var j = 0; j < refBinding.traces.length; j++) {
	                        if(refBinding.traces[j] !== binding.traces[j]) {
	                            return false;
	                        }
	                    }
	                } else {
	                    return false;
	                }
	            } else {
	                if(binding.prop !== refBinding.prop) {
	                    return false;
	                }
	            }
	        }
	
	        binding = bindings[0];
	        var value = binding.value;
	        if(Array.isArray(value)) {
	            if(value.length === 1) {
	                value = value[0];
	            } else {
	                return false;
	            }
	        }
	        if(bindingsByValue) {
	            bindingsByValue[value] = i;
	        }
	    }
	
	    return refBinding;
	};
	
	function bindingValueHasChanged(gd, binding, cache) {
	    var container, value, obj;
	    var changed = false;
	
	    if(binding.type === 'data') {
	        // If it's data, we need to get a trace. Based on the limited scope
	        // of what we cover, we can just take the first trace from the list,
	        // or otherwise just the first trace:
	        container = gd._fullData[binding.traces !== null ? binding.traces[0] : 0];
	    } else if(binding.type === 'layout') {
	        container = gd._fullLayout;
	    } else {
	        return false;
	    }
	
	    value = Lib.nestedProperty(container, binding.prop).get();
	
	    obj = cache[binding.type] = cache[binding.type] || {};
	
	    if(obj.hasOwnProperty(binding.prop)) {
	        if(obj[binding.prop] !== value) {
	            changed = true;
	        }
	    }
	
	    obj[binding.prop] = value;
	
	    return {
	        changed: changed,
	        value: value
	    };
	}
	
	/*
	 * Execute an API command. There's really not much to this; it just provides
	 * a common hook so that implementations don't need to be synchronized across
	 * multiple components with the ability to invoke API commands.
	 *
	 * @param {string} method
	 *      The name of the plotly command to execute. Must be one of 'animate',
	 *      'restyle', 'relayout', 'update'.
	 * @param {array} args
	 *      A list of arguments passed to the API command
	 */
	exports.executeAPICommand = function(gd, method, args) {
	    if(method === 'skip') return Promise.resolve();
	
	    var _method = Registry.apiMethodRegistry[method];
	    var allArgs = [gd];
	    if(!Array.isArray(args)) args = [];
	
	    for(var i = 0; i < args.length; i++) {
	        allArgs.push(args[i]);
	    }
	
	    return _method.apply(null, allArgs).catch(function(err) {
	        Lib.warn('API call to Plotly.' + method + ' rejected.', err);
	        return Promise.reject(err);
	    });
	};
	
	exports.computeAPICommandBindings = function(gd, method, args) {
	    var bindings;
	
	    if(!Array.isArray(args)) args = [];
	
	    switch(method) {
	        case 'restyle':
	            bindings = computeDataBindings(gd, args);
	            break;
	        case 'relayout':
	            bindings = computeLayoutBindings(gd, args);
	            break;
	        case 'update':
	            bindings = computeDataBindings(gd, [args[0], args[2]])
	                .concat(computeLayoutBindings(gd, [args[1]]));
	            break;
	        case 'animate':
	            bindings = computeAnimateBindings(gd, args);
	            break;
	        default:
	            // This is the case where intelligent logic about what affects
	            // this command is not implemented. It causes no ill effects.
	            // For example, addFrames simply won't bind to a control component.
	            bindings = [];
	    }
	    return bindings;
	};
	
	function computeAnimateBindings(gd, args) {
	    // We'll assume that the only relevant modification an animation
	    // makes that's meaningfully tracked is the frame:
	    if(Array.isArray(args[0]) && args[0].length === 1 && ['string', 'number'].indexOf(typeof args[0][0]) !== -1) {
	        return [{type: 'layout', prop: '_currentFrame', value: args[0][0].toString()}];
	    } else {
	        return [];
	    }
	}
	
	function computeLayoutBindings(gd, args) {
	    var bindings = [];
	
	    var astr = args[0];
	    var aobj = {};
	    if(typeof astr === 'string') {
	        aobj[astr] = args[1];
	    } else if(Lib.isPlainObject(astr)) {
	        aobj = astr;
	    } else {
	        return bindings;
	    }
	
	    crawl(aobj, function(path, attrName, attr) {
	        bindings.push({type: 'layout', prop: path, value: attr});
	    }, '', 0);
	
	    return bindings;
	}
	
	function computeDataBindings(gd, args) {
	    var traces, astr, val, aobj;
	    var bindings = [];
	
	    // Logic copied from Plotly.restyle:
	    astr = args[0];
	    val = args[1];
	    traces = args[2];
	    aobj = {};
	    if(typeof astr === 'string') {
	        aobj[astr] = val;
	    } else if(Lib.isPlainObject(astr)) {
	        // the 3-arg form
	        aobj = astr;
	
	        if(traces === undefined) {
	            traces = val;
	        }
	    } else {
	        return bindings;
	    }
	
	    if(traces === undefined) {
	        // Explicitly assign this to null instead of undefined:
	        traces = null;
	    }
	
	    crawl(aobj, function(path, attrName, _attr) {
	        var thisTraces;
	        var attr;
	
	        if(Array.isArray(_attr)) {
	            attr = _attr.slice();
	
	            var nAttr = Math.min(attr.length, gd.data.length);
	            if(traces) {
	                nAttr = Math.min(nAttr, traces.length);
	            }
	            thisTraces = [];
	            for(var j = 0; j < nAttr; j++) {
	                thisTraces[j] = traces ? traces[j] : j;
	            }
	        } else {
	            attr = _attr;
	            thisTraces = traces ? traces.slice() : null;
	        }
	
	        // Convert [7] to just 7 when traces is null:
	        if(thisTraces === null) {
	            if(Array.isArray(attr)) {
	                attr = attr[0];
	            }
	        } else if(Array.isArray(thisTraces)) {
	            if(!Array.isArray(attr)) {
	                var tmp = attr;
	                attr = [];
	                for(var i = 0; i < thisTraces.length; i++) {
	                    attr[i] = tmp;
	                }
	            }
	            attr.length = Math.min(thisTraces.length, attr.length);
	        }
	
	        bindings.push({
	            type: 'data',
	            prop: path,
	            traces: thisTraces,
	            value: attr
	        });
	    }, '', 0);
	
	    return bindings;
	}
	
	function crawl(attrs, callback, path, depth) {
	    Object.keys(attrs).forEach(function(attrName) {
	        var attr = attrs[attrName];
	
	        if(attrName[0] === '_') return;
	
	        var thisPath = path + (depth > 0 ? '.' : '') + attrName;
	
	        if(Lib.isPlainObject(attr)) {
	            crawl(attr, callback, thisPath, depth + 1);
	        } else {
	            // Only execute the callback on leaf nodes:
	            callback(thisPath, attrName, attr);
	        }
	    });
	}
	
	},{"../lib":716,"../registry":845}],789:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extendFlat = _dereq_('../lib/extend').extendFlat;
	
	/**
	 * Make a xy domain attribute group
	 *
	 * @param {object} opts
	 *   @param {string}
	 *     opts.name: name to be inserted in the default description
	 *   @param {boolean}
	 *     opts.trace: set to true for trace containers
	 *   @param {string}
	 *     opts.editType: editType for all pieces
	 *   @param {boolean}
	 *     opts.noGridCell: set to true to omit `row` and `column`
	 *
	 * @param {object} extra
	 *   @param {string}
	 *     extra.description: extra description. N.B we use
	 *     a separate extra container to make it compatible with
	 *     the compress_attributes transform.
	 *
	 * @return {object} attributes object containing {x,y} as specified
	 */
	exports.attributes = function(opts, extra) {
	    opts = opts || {};
	    extra = extra || {};
	
	    var base = {
	        valType: 'info_array',
	        
	        editType: opts.editType,
	        items: [
	            {valType: 'number', min: 0, max: 1, editType: opts.editType},
	            {valType: 'number', min: 0, max: 1, editType: opts.editType}
	        ],
	        dflt: [0, 1]
	    };
	
	    var namePart = opts.name ? opts.name + ' ' : '';
	    var contPart = opts.trace ? 'trace ' : 'subplot ';
	    var descPart = extra.description ? ' ' + extra.description : '';
	
	    var out = {
	        x: extendFlat({}, base, {
	            
	        }),
	        y: extendFlat({}, base, {
	            
	        }),
	        editType: opts.editType
	    };
	
	    if(!opts.noGridCell) {
	        out.row = {
	            valType: 'integer',
	            min: 0,
	            dflt: 0,
	            
	            editType: opts.editType,
	            
	        };
	        out.column = {
	            valType: 'integer',
	            min: 0,
	            dflt: 0,
	            
	            editType: opts.editType,
	            
	        };
	    }
	
	    return out;
	};
	
	exports.defaults = function(containerOut, layout, coerce, dfltDomains) {
	    var dfltX = (dfltDomains && dfltDomains.x) || [0, 1];
	    var dfltY = (dfltDomains && dfltDomains.y) || [0, 1];
	
	    var grid = layout.grid;
	    if(grid) {
	        var column = coerce('domain.column');
	        if(column !== undefined) {
	            if(column < grid.columns) dfltX = grid._domains.x[column];
	            else delete containerOut.domain.column;
	        }
	
	        var row = coerce('domain.row');
	        if(row !== undefined) {
	            if(row < grid.rows) dfltY = grid._domains.y[row];
	            else delete containerOut.domain.row;
	        }
	    }
	
	    var x = coerce('domain.x', dfltX);
	    var y = coerce('domain.y', dfltY);
	
	    // don't accept bad input data
	    if(!(x[0] < x[1])) containerOut.domain.x = dfltX.slice();
	    if(!(y[0] < y[1])) containerOut.domain.y = dfltY.slice();
	};
	
	},{"../lib/extend":707}],790:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * make a font attribute group
	 *
	 * @param {object} opts
	 *   @param {string}
	 *     opts.description: where & how this font is used
	 *   @param {optional bool} arrayOk:
	 *     should each part (family, size, color) be arrayOk? default false.
	 *   @param {string} editType:
	 *     the editType for all pieces of this font
	 *   @param {optional string} colorEditType:
	 *     a separate editType just for color
	 *
	 * @return {object} attributes object containing {family, size, color} as specified
	 */
	module.exports = function(opts) {
	    var editType = opts.editType;
	    var colorEditType = opts.colorEditType;
	    if(colorEditType === undefined) colorEditType = editType;
	    var attrs = {
	        family: {
	            valType: 'string',
	            
	            noBlank: true,
	            strict: true,
	            editType: editType,
	            
	        },
	        size: {
	            valType: 'number',
	            
	            min: 1,
	            editType: editType
	        },
	        color: {
	            valType: 'color',
	            
	            editType: colorEditType
	        },
	        editType: editType,
	        // blank strings so compress_attributes can remove
	        // TODO - that's uber hacky... better solution?
	        
	    };
	
	    if(opts.arrayOk) {
	        attrs.family.arrayOk = true;
	        attrs.size.arrayOk = true;
	        attrs.color.arrayOk = true;
	    }
	
	    return attrs;
	};
	
	},{}],791:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    _isLinkedToArray: 'frames_entry',
	
	    group: {
	        valType: 'string',
	        
	        
	    },
	    name: {
	        valType: 'string',
	        
	        
	    },
	    traces: {
	        valType: 'any',
	        
	        
	    },
	    baseframe: {
	        valType: 'string',
	        
	        
	    },
	    data: {
	        valType: 'any',
	        
	        
	    },
	    layout: {
	        valType: 'any',
	        
	        
	    }
	};
	
	},{}],792:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// projection names to d3 function name
	exports.projNames = {
	    // d3.geo.projection
	    'equirectangular': 'equirectangular',
	    'mercator': 'mercator',
	    'orthographic': 'orthographic',
	    'natural earth': 'naturalEarth',
	    'kavrayskiy7': 'kavrayskiy7',
	    'miller': 'miller',
	    'robinson': 'robinson',
	    'eckert4': 'eckert4',
	    'azimuthal equal area': 'azimuthalEqualArea',
	    'azimuthal equidistant': 'azimuthalEquidistant',
	    'conic equal area': 'conicEqualArea',
	    'conic conformal': 'conicConformal',
	    'conic equidistant': 'conicEquidistant',
	    'gnomonic': 'gnomonic',
	    'stereographic': 'stereographic',
	    'mollweide': 'mollweide',
	    'hammer': 'hammer',
	    'transverse mercator': 'transverseMercator',
	    'albers usa': 'albersUsa',
	    'winkel tripel': 'winkel3',
	    'aitoff': 'aitoff',
	    'sinusoidal': 'sinusoidal'
	};
	
	// name of the axes
	exports.axesNames = ['lonaxis', 'lataxis'];
	
	// max longitudinal angular span (EXPERIMENTAL)
	exports.lonaxisSpan = {
	    'orthographic': 180,
	    'azimuthal equal area': 360,
	    'azimuthal equidistant': 360,
	    'conic conformal': 180,
	    'gnomonic': 160,
	    'stereographic': 180,
	    'transverse mercator': 180,
	    '*': 360
	};
	
	// max latitudinal angular span (EXPERIMENTAL)
	exports.lataxisSpan = {
	    'conic conformal': 150,
	    'stereographic': 179.5,
	    '*': 180
	};
	
	// defaults for each scope
	exports.scopeDefaults = {
	    world: {
	        lonaxisRange: [-180, 180],
	        lataxisRange: [-90, 90],
	        projType: 'equirectangular',
	        projRotate: [0, 0, 0]
	    },
	    usa: {
	        lonaxisRange: [-180, -50],
	        lataxisRange: [15, 80],
	        projType: 'albers usa'
	    },
	    europe: {
	        lonaxisRange: [-30, 60],
	        lataxisRange: [30, 85],
	        projType: 'conic conformal',
	        projRotate: [15, 0, 0],
	        projParallels: [0, 60]
	    },
	    asia: {
	        lonaxisRange: [22, 160],
	        lataxisRange: [-15, 55],
	        projType: 'mercator',
	        projRotate: [0, 0, 0]
	    },
	    africa: {
	        lonaxisRange: [-30, 60],
	        lataxisRange: [-40, 40],
	        projType: 'mercator',
	        projRotate: [0, 0, 0]
	    },
	    'north america': {
	        lonaxisRange: [-180, -45],
	        lataxisRange: [5, 85],
	        projType: 'conic conformal',
	        projRotate: [-100, 0, 0],
	        projParallels: [29.5, 45.5]
	    },
	    'south america': {
	        lonaxisRange: [-100, -30],
	        lataxisRange: [-60, 15],
	        projType: 'mercator',
	        projRotate: [0, 0, 0]
	    }
	};
	
	// angular pad to avoid rounding error around clip angles
	exports.clipPad = 1e-3;
	
	// map projection precision
	exports.precision = 0.1;
	
	// default land and water fill colors
	exports.landColor = '#F0DC82';
	exports.waterColor = '#3399FF';
	
	// locationmode to layer name
	exports.locationmodeToLayer = {
	    'ISO-3': 'countries',
	    'USA-states': 'subunits',
	    'country names': 'countries'
	};
	
	// SVG element for a sphere (use to frame maps)
	exports.sphereSVG = {type: 'Sphere'};
	
	// N.B. base layer names must be the same as in the topojson files
	
	// base layer with a fill color
	exports.fillLayers = {
	    ocean: 1,
	    land: 1,
	    lakes: 1
	};
	
	// base layer with a only a line color
	exports.lineLayers = {
	    subunits: 1,
	    countries: 1,
	    coastlines: 1,
	    rivers: 1,
	    frame: 1
	};
	
	exports.layers = [
	    'bg',
	    'ocean', 'land', 'lakes',
	    'subunits', 'countries', 'coastlines', 'rivers',
	    'lataxis', 'lonaxis', 'frame',
	    'backplot',
	    'frontplot'
	];
	
	exports.layersForChoropleth = [
	    'bg',
	    'ocean', 'land',
	    'subunits', 'countries', 'coastlines',
	    'lataxis', 'lonaxis', 'frame',
	    'backplot',
	    'rivers', 'lakes',
	    'frontplot'
	];
	
	exports.layerNameToAdjective = {
	    ocean: 'ocean',
	    land: 'land',
	    lakes: 'lake',
	    subunits: 'subunit',
	    countries: 'country',
	    coastlines: 'coastline',
	    rivers: 'river',
	    frame: 'frame'
	};
	
	},{}],793:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/* global PlotlyGeoAssets:false */
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Fx = _dereq_('../../components/fx');
	var Plots = _dereq_('../plots');
	var Axes = _dereq_('../cartesian/axes');
	var dragElement = _dereq_('../../components/dragelement');
	var prepSelect = _dereq_('../cartesian/select').prepSelect;
	var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
	
	var createGeoZoom = _dereq_('./zoom');
	var constants = _dereq_('./constants');
	
	var topojsonUtils = _dereq_('../../lib/topojson_utils');
	var topojsonFeature = _dereq_('topojson-client').feature;
	
	_dereq_('./projections')(d3);
	
	function Geo(opts) {
	    this.id = opts.id;
	    this.graphDiv = opts.graphDiv;
	    this.container = opts.container;
	    this.topojsonURL = opts.topojsonURL;
	    this.isStatic = opts.staticPlot;
	
	    this.topojsonName = null;
	    this.topojson = null;
	
	    this.projection = null;
	    this.scope = null;
	    this.viewInitial = null;
	    this.fitScale = null;
	    this.bounds = null;
	    this.midPt = null;
	
	    this.hasChoropleth = false;
	    this.traceHash = {};
	
	    this.layers = {};
	    this.basePaths = {};
	    this.dataPaths = {};
	    this.dataPoints = {};
	
	    this.clipDef = null;
	    this.clipRect = null;
	    this.bgRect = null;
	
	    this.makeFramework();
	}
	
	var proto = Geo.prototype;
	
	module.exports = function createGeo(opts) {
	    return new Geo(opts);
	};
	
	proto.plot = function(geoCalcData, fullLayout, promises) {
	    var _this = this;
	    var geoLayout = fullLayout[this.id];
	
	    var needsTopojson = false;
	    for(var k in constants.layerNameToAdjective) {
	        if(k !== 'frame' && geoLayout['show' + k]) {
	            needsTopojson = true;
	            break;
	        }
	    }
	    for(var i = 0; i < geoCalcData.length; i++) {
	        if(geoCalcData[0][0].trace.locationmode) {
	            needsTopojson = true;
	            break;
	        }
	    }
	    if(!needsTopojson) {
	        return _this.update(geoCalcData, fullLayout);
	    }
	
	    var topojsonNameNew = topojsonUtils.getTopojsonName(geoLayout);
	
	    if(_this.topojson === null || topojsonNameNew !== _this.topojsonName) {
	        _this.topojsonName = topojsonNameNew;
	
	        if(PlotlyGeoAssets.topojson[_this.topojsonName] === undefined) {
	            promises.push(_this.fetchTopojson().then(function(topojson) {
	                PlotlyGeoAssets.topojson[_this.topojsonName] = topojson;
	                _this.topojson = topojson;
	                _this.update(geoCalcData, fullLayout);
	            }));
	        } else {
	            _this.topojson = PlotlyGeoAssets.topojson[_this.topojsonName];
	            _this.update(geoCalcData, fullLayout);
	        }
	    } else {
	        _this.update(geoCalcData, fullLayout);
	    }
	};
	
	proto.fetchTopojson = function() {
	    var topojsonPath = topojsonUtils.getTopojsonPath(
	        this.topojsonURL,
	        this.topojsonName
	    );
	    return new Promise(function(resolve, reject) {
	        d3.json(topojsonPath, function(err, topojson) {
	            if(err) {
	                if(err.status === 404) {
	                    return reject(new Error([
	                        'plotly.js could not find topojson file at',
	                        topojsonPath, '.',
	                        'Make sure the *topojsonURL* plot config option',
	                        'is set properly.'
	                    ].join(' ')));
	                } else {
	                    return reject(new Error([
	                        'unexpected error while fetching topojson file at',
	                        topojsonPath
	                    ].join(' ')));
	                }
	            }
	            resolve(topojson);
	        });
	    });
	};
	
	proto.update = function(geoCalcData, fullLayout) {
	    var geoLayout = fullLayout[this.id];
	
	    var hasInvalidBounds = this.updateProjection(fullLayout, geoLayout);
	    if(hasInvalidBounds) return;
	
	    // important: maps with choropleth traces have a different layer order
	    this.hasChoropleth = false;
	    for(var i = 0; i < geoCalcData.length; i++) {
	        if(geoCalcData[i][0].trace.type === 'choropleth') {
	            this.hasChoropleth = true;
	            break;
	        }
	    }
	
	    if(!this.viewInitial || this.scope !== geoLayout.scope) {
	        this.saveViewInitial(geoLayout);
	    }
	    this.scope = geoLayout.scope;
	
	    this.updateBaseLayers(fullLayout, geoLayout);
	    this.updateDims(fullLayout, geoLayout);
	    this.updateFx(fullLayout, geoLayout);
	
	    Plots.generalUpdatePerTraceModule(this.graphDiv, this, geoCalcData, geoLayout);
	
	    var scatterLayer = this.layers.frontplot.select('.scatterlayer');
	    this.dataPoints.point = scatterLayer.selectAll('.point');
	    this.dataPoints.text = scatterLayer.selectAll('text');
	    this.dataPaths.line = scatterLayer.selectAll('.js-line');
	
	    var choroplethLayer = this.layers.backplot.select('.choroplethlayer');
	    this.dataPaths.choropleth = choroplethLayer.selectAll('path');
	
	    this.render();
	};
	
	proto.updateProjection = function(fullLayout, geoLayout) {
	    var gs = fullLayout._size;
	    var domain = geoLayout.domain;
	    var projLayout = geoLayout.projection;
	    var rotation = projLayout.rotation || {};
	    var center = geoLayout.center || {};
	
	    var projection = this.projection = getProjection(geoLayout);
	
	    // set 'pre-fit' projection
	    projection
	        .center([center.lon - rotation.lon, center.lat - rotation.lat])
	        .rotate([-rotation.lon, -rotation.lat, rotation.roll])
	        .parallels(projLayout.parallels);
	
	    // setup subplot extent [[x0,y0], [x1,y1]]
	    var extent = [[
	        gs.l + gs.w * domain.x[0],
	        gs.t + gs.h * (1 - domain.y[1])
	    ], [
	        gs.l + gs.w * domain.x[1],
	        gs.t + gs.h * (1 - domain.y[0])
	    ]];
	
	    var lonaxis = geoLayout.lonaxis;
	    var lataxis = geoLayout.lataxis;
	    var rangeBox = makeRangeBox(lonaxis.range, lataxis.range);
	
	    // fit projection 'scale' and 'translate' to set lon/lat ranges
	    projection.fitExtent(extent, rangeBox);
	
	    var b = this.bounds = projection.getBounds(rangeBox);
	    var s = this.fitScale = projection.scale();
	    var t = projection.translate();
	
	    if(
	        !isFinite(b[0][0]) || !isFinite(b[0][1]) ||
	        !isFinite(b[1][0]) || !isFinite(b[1][1]) ||
	        isNaN(t[0]) || isNaN(t[0])
	    ) {
	        var gd = this.graphDiv;
	        var attrToUnset = ['projection.rotation', 'center', 'lonaxis.range', 'lataxis.range'];
	        var msg = 'Invalid geo settings, relayout\'ing to default view.';
	        var updateObj = {};
	
	        // clear all attribute that could cause invalid bounds,
	        // clear viewInitial to update reset-view behavior
	
	        for(var i = 0; i < attrToUnset.length; i++) {
	            updateObj[this.id + '.' + attrToUnset[i]] = null;
	        }
	
	        this.viewInitial = null;
	
	        Lib.warn(msg);
	        gd._promises.push(Registry.call('relayout', gd, updateObj));
	        return msg;
	    }
	
	    // px coordinates of view mid-point,
	    // useful to update `geo.center` after interactions
	    var midPt = this.midPt = [
	        (b[0][0] + b[1][0]) / 2,
	        (b[0][1] + b[1][1]) / 2
	    ];
	
	    // adjust projection to user setting
	    projection
	        .scale(projLayout.scale * s)
	        .translate([t[0] + (midPt[0] - t[0]), t[1] + (midPt[1] - t[1])])
	        .clipExtent(b);
	
	    // the 'albers usa' projection does not expose a 'center' method
	    // so here's this hack to make it respond to 'geoLayout.center'
	    if(geoLayout._isAlbersUsa) {
	        var centerPx = projection([center.lon, center.lat]);
	        var tt = projection.translate();
	
	        projection.translate([
	            tt[0] - (centerPx[0] - tt[0]),
	            tt[1] - (centerPx[1] - tt[1])
	        ]);
	    }
	};
	
	proto.updateBaseLayers = function(fullLayout, geoLayout) {
	    var _this = this;
	    var topojson = _this.topojson;
	    var layers = _this.layers;
	    var basePaths = _this.basePaths;
	
	    function isAxisLayer(d) {
	        return (d === 'lonaxis' || d === 'lataxis');
	    }
	
	    function isLineLayer(d) {
	        return Boolean(constants.lineLayers[d]);
	    }
	
	    function isFillLayer(d) {
	        return Boolean(constants.fillLayers[d]);
	    }
	
	    var allLayers = this.hasChoropleth ?
	        constants.layersForChoropleth :
	        constants.layers;
	
	    var layerData = allLayers.filter(function(d) {
	        return (isLineLayer(d) || isFillLayer(d)) ? geoLayout['show' + d] :
	            isAxisLayer(d) ? geoLayout[d].showgrid :
	            true;
	    });
	
	    var join = _this.framework.selectAll('.layer')
	        .data(layerData, String);
	
	    join.exit().each(function(d) {
	        delete layers[d];
	        delete basePaths[d];
	        d3.select(this).remove();
	    });
	
	    join.enter().append('g')
	        .attr('class', function(d) { return 'layer ' + d; })
	        .each(function(d) {
	            var layer = layers[d] = d3.select(this);
	
	            if(d === 'bg') {
	                _this.bgRect = layer.append('rect')
	                    .style('pointer-events', 'all');
	            } else if(isAxisLayer(d)) {
	                basePaths[d] = layer.append('path')
	                    .style('fill', 'none');
	            } else if(d === 'backplot') {
	                layer.append('g')
	                    .classed('choroplethlayer', true);
	            } else if(d === 'frontplot') {
	                layer.append('g')
	                    .classed('scatterlayer', true);
	            } else if(isLineLayer(d)) {
	                basePaths[d] = layer.append('path')
	                    .style('fill', 'none')
	                    .style('stroke-miterlimit', 2);
	            } else if(isFillLayer(d)) {
	                basePaths[d] = layer.append('path')
	                    .style('stroke', 'none');
	            }
	        });
	
	    join.order();
	
	    join.each(function(d) {
	        var path = basePaths[d];
	        var adj = constants.layerNameToAdjective[d];
	
	        if(d === 'frame') {
	            path.datum(constants.sphereSVG);
	        } else if(isLineLayer(d) || isFillLayer(d)) {
	            path.datum(topojsonFeature(topojson, topojson.objects[d]));
	        } else if(isAxisLayer(d)) {
	            path.datum(makeGraticule(d, geoLayout, fullLayout))
	                .call(Color.stroke, geoLayout[d].gridcolor)
	                .call(Drawing.dashLine, '', geoLayout[d].gridwidth);
	        }
	
	        if(isLineLayer(d)) {
	            path.call(Color.stroke, geoLayout[adj + 'color'])
	                .call(Drawing.dashLine, '', geoLayout[adj + 'width']);
	        } else if(isFillLayer(d)) {
	            path.call(Color.fill, geoLayout[adj + 'color']);
	        }
	    });
	};
	
	proto.updateDims = function(fullLayout, geoLayout) {
	    var b = this.bounds;
	    var hFrameWidth = (geoLayout.framewidth || 0) / 2;
	
	    var l = b[0][0] - hFrameWidth;
	    var t = b[0][1] - hFrameWidth;
	    var w = b[1][0] - l + hFrameWidth;
	    var h = b[1][1] - t + hFrameWidth;
	
	    Drawing.setRect(this.clipRect, l, t, w, h);
	
	    this.bgRect
	        .call(Drawing.setRect, l, t, w, h)
	        .call(Color.fill, geoLayout.bgcolor);
	
	    this.xaxis._offset = l;
	    this.xaxis._length = w;
	
	    this.yaxis._offset = t;
	    this.yaxis._length = h;
	};
	
	proto.updateFx = function(fullLayout, geoLayout) {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var bgRect = _this.bgRect;
	    var dragMode = fullLayout.dragmode;
	    var clickMode = fullLayout.clickmode;
	
	    if(_this.isStatic) return;
	
	    function zoomReset() {
	        var viewInitial = _this.viewInitial;
	        var updateObj = {};
	
	        for(var k in viewInitial) {
	            updateObj[_this.id + '.' + k] = viewInitial[k];
	        }
	
	        Registry.call('_guiRelayout', gd, updateObj);
	        gd.emit('plotly_doubleclick', null);
	    }
	
	    function invert(lonlat) {
	        return _this.projection.invert([
	            lonlat[0] + _this.xaxis._offset,
	            lonlat[1] + _this.yaxis._offset
	        ]);
	    }
	
	    var fillRangeItems;
	
	    if(dragMode === 'select') {
	        fillRangeItems = function(eventData, poly) {
	            var ranges = eventData.range = {};
	            ranges[_this.id] = [
	                invert([poly.xmin, poly.ymin]),
	                invert([poly.xmax, poly.ymax])
	            ];
	        };
	    } else if(dragMode === 'lasso') {
	        fillRangeItems = function(eventData, poly, pts) {
	            var dataPts = eventData.lassoPoints = {};
	            dataPts[_this.id] = pts.filtered.map(invert);
	        };
	    }
	
	    // Note: dragOptions is needed to be declared for all dragmodes because
	    // it's the object that holds persistent selection state.
	    var dragOptions = {
	        element: _this.bgRect.node(),
	        gd: gd,
	        plotinfo: {
	            id: _this.id,
	            xaxis: _this.xaxis,
	            yaxis: _this.yaxis,
	            fillRangeItems: fillRangeItems
	        },
	        xaxes: [_this.xaxis],
	        yaxes: [_this.yaxis],
	        subplot: _this.id,
	        clickFn: function(numClicks) {
	            if(numClicks === 2) {
	                fullLayout._zoomlayer.selectAll('.select-outline').remove();
	            }
	        }
	    };
	
	    if(dragMode === 'pan') {
	        bgRect.node().onmousedown = null;
	        bgRect.call(createGeoZoom(_this, geoLayout));
	        bgRect.on('dblclick.zoom', zoomReset);
	        if(!gd._context._scrollZoom.geo) {
	            bgRect.on('wheel.zoom', null);
	        }
	    } else if(dragMode === 'select' || dragMode === 'lasso') {
	        bgRect.on('.zoom', null);
	
	        dragOptions.prepFn = function(e, startX, startY) {
	            prepSelect(e, startX, startY, dragOptions, dragMode);
	        };
	
	        dragElement.init(dragOptions);
	    }
	
	    bgRect.on('mousemove', function() {
	        var lonlat = _this.projection.invert(d3.mouse(this));
	
	        if(!lonlat || isNaN(lonlat[0]) || isNaN(lonlat[1])) {
	            return dragElement.unhover(gd, d3.event);
	        }
	
	        _this.xaxis.p2c = function() { return lonlat[0]; };
	        _this.yaxis.p2c = function() { return lonlat[1]; };
	
	        Fx.hover(gd, d3.event, _this.id);
	    });
	
	    bgRect.on('mouseout', function() {
	        if(gd._dragging) return;
	        dragElement.unhover(gd, d3.event);
	    });
	
	    bgRect.on('click', function() {
	        // For select and lasso the dragElement is handling clicks
	        if(dragMode !== 'select' && dragMode !== 'lasso') {
	            if(clickMode.indexOf('select') > -1) {
	                selectOnClick(d3.event, gd, [_this.xaxis], [_this.yaxis],
	                  _this.id, dragOptions);
	            }
	
	            if(clickMode.indexOf('event') > -1) {
	                // TODO: like pie and mapbox, this doesn't support right-click
	                // actually this one is worse, as right-click starts a pan, or leaves
	                // select in a weird state.
	                // Also, only tangentially related, we should cancel hover during pan
	                Fx.click(gd, d3.event);
	            }
	        }
	    });
	};
	
	proto.makeFramework = function() {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var fullLayout = gd._fullLayout;
	    var clipId = 'clip' + fullLayout._uid + _this.id;
	
	    _this.clipDef = fullLayout._clips.append('clipPath')
	        .attr('id', clipId);
	
	    _this.clipRect = _this.clipDef.append('rect');
	
	    _this.framework = d3.select(_this.container).append('g')
	        .attr('class', 'geo ' + _this.id)
	        .call(Drawing.setClipUrl, clipId, gd);
	
	    // sane lonlat to px
	    _this.project = function(v) {
	        var px = _this.projection(v);
	        return px ?
	            [px[0] - _this.xaxis._offset, px[1] - _this.yaxis._offset] :
	            [null, null];
	    };
	
	    _this.xaxis = {
	        _id: 'x',
	        c2p: function(v) { return _this.project(v)[0]; }
	    };
	
	    _this.yaxis = {
	        _id: 'y',
	        c2p: function(v) { return _this.project(v)[1]; }
	    };
	
	    // mock axis for hover formatting
	    _this.mockAxis = {
	        type: 'linear',
	        showexponent: 'all',
	        exponentformat: 'B'
	    };
	    Axes.setConvert(_this.mockAxis, fullLayout);
	};
	
	proto.saveViewInitial = function(geoLayout) {
	    var center = geoLayout.center || {};
	    var projLayout = geoLayout.projection;
	    var rotation = projLayout.rotation || {};
	
	    if(geoLayout._isScoped) {
	        this.viewInitial = {
	            'center.lon': center.lon,
	            'center.lat': center.lat,
	            'projection.scale': projLayout.scale
	        };
	    } else if(geoLayout._isClipped) {
	        this.viewInitial = {
	            'projection.scale': projLayout.scale,
	            'projection.rotation.lon': rotation.lon,
	            'projection.rotation.lat': rotation.lat
	        };
	    } else {
	        this.viewInitial = {
	            'center.lon': center.lon,
	            'center.lat': center.lat,
	            'projection.scale': projLayout.scale,
	            'projection.rotation.lon': rotation.lon
	        };
	    }
	};
	
	// [hot code path] (re)draw all paths which depend on the projection
	proto.render = function() {
	    var projection = this.projection;
	    var pathFn = projection.getPath();
	    var k;
	
	    function translatePoints(d) {
	        var lonlatPx = projection(d.lonlat);
	        return lonlatPx ?
	            'translate(' + lonlatPx[0] + ',' + lonlatPx[1] + ')' :
	             null;
	    }
	
	    function hideShowPoints(d) {
	        return projection.isLonLatOverEdges(d.lonlat) ? 'none' : null;
	    }
	
	    for(k in this.basePaths) {
	        this.basePaths[k].attr('d', pathFn);
	    }
	
	    for(k in this.dataPaths) {
	        this.dataPaths[k].attr('d', function(d) { return pathFn(d.geojson); });
	    }
	
	    for(k in this.dataPoints) {
	        this.dataPoints[k]
	            .attr('display', hideShowPoints)
	            .attr('transform', translatePoints);
	    }
	};
	
	// Helper that wraps d3.geo[/* projection name /*]() which:
	//
	// - adds 'fitExtent' (available in d3 v4)
	// - adds 'getPath', 'getBounds' convenience methods
	// - scopes logic related to 'clipAngle'
	// - adds 'isLonLatOverEdges' method
	// - sets projection precision
	// - sets methods that aren't always defined depending
	//   on the projection type to a dummy 'd3-esque' function,
	//
	// This wrapper alleviates subsequent code of (many) annoying if-statements.
	function getProjection(geoLayout) {
	    var projLayout = geoLayout.projection;
	    var projType = projLayout.type;
	
	    var projection = d3.geo[constants.projNames[projType]]();
	
	    var clipAngle = geoLayout._isClipped ?
	        constants.lonaxisSpan[projType] / 2 :
	        null;
	
	    var methods = ['center', 'rotate', 'parallels', 'clipExtent'];
	    var dummyFn = function(_) { return _ ? projection : []; };
	
	    for(var i = 0; i < methods.length; i++) {
	        var m = methods[i];
	        if(typeof projection[m] !== 'function') {
	            projection[m] = dummyFn;
	        }
	    }
	
	    projection.isLonLatOverEdges = function(lonlat) {
	        if(projection(lonlat) === null) {
	            return true;
	        }
	
	        if(clipAngle) {
	            var r = projection.rotate();
	            var angle = d3.geo.distance(lonlat, [-r[0], -r[1]]);
	            var maxAngle = clipAngle * Math.PI / 180;
	            return angle > maxAngle;
	        } else {
	            return false;
	        }
	    };
	
	    projection.getPath = function() {
	        return d3.geo.path().projection(projection);
	    };
	
	    projection.getBounds = function(object) {
	        return projection.getPath().bounds(object);
	    };
	
	    // adapted from d3 v4:
	    // https://github.com/d3/d3-geo/blob/master/src/projection/fit.js
	    projection.fitExtent = function(extent, object) {
	        var w = extent[1][0] - extent[0][0];
	        var h = extent[1][1] - extent[0][1];
	        var clip = projection.clipExtent && projection.clipExtent();
	
	        projection
	            .scale(150)
	            .translate([0, 0]);
	
	        if(clip) projection.clipExtent(null);
	
	        var b = projection.getBounds(object);
	        var k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1]));
	        var x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2;
	        var y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	        if(clip) projection.clipExtent(clip);
	
	        return projection
	            .scale(k * 150)
	            .translate([x, y]);
	    };
	
	    projection.precision(constants.precision);
	
	    if(clipAngle) {
	        projection.clipAngle(clipAngle - constants.clipPad);
	    }
	
	    return projection;
	}
	
	function makeGraticule(axisName, geoLayout, fullLayout) {
	    // equivalent to the d3 "ε"
	    var epsilon = 1e-6;
	    // same as the geoGraticule default
	    var precision = 2.5;
	
	    var axLayout = geoLayout[axisName];
	    var scopeDefaults = constants.scopeDefaults[geoLayout.scope];
	    var rng;
	    var oppRng;
	    var coordFn;
	
	    if(axisName === 'lonaxis') {
	        rng = scopeDefaults.lonaxisRange;
	        oppRng = scopeDefaults.lataxisRange;
	        coordFn = function(v, l) { return [v, l]; };
	    } else if(axisName === 'lataxis') {
	        rng = scopeDefaults.lataxisRange;
	        oppRng = scopeDefaults.lonaxisRange;
	        coordFn = function(v, l) { return [l, v]; };
	    }
	
	    var dummyAx = {
	        type: 'linear',
	        range: [rng[0], rng[1] - epsilon],
	        tick0: axLayout.tick0,
	        dtick: axLayout.dtick
	    };
	
	    Axes.setConvert(dummyAx, fullLayout);
	    var vals = Axes.calcTicks(dummyAx);
	
	    // remove duplicate on antimeridian
	    if(!geoLayout.isScoped && axisName === 'lonaxis') {
	        vals.pop();
	    }
	
	    var len = vals.length;
	    var coords = new Array(len);
	
	    for(var i = 0; i < len; i++) {
	        var v = vals[i].x;
	        var line = coords[i] = [];
	        for(var l = oppRng[0]; l < oppRng[1] + precision; l += precision) {
	            line.push(coordFn(v, l));
	        }
	    }
	
	    return {
	        type: 'MultiLineString',
	        coordinates: coords
	    };
	}
	
	// Returns polygon GeoJSON corresponding to lon/lat range box
	// with well-defined direction
	//
	// Note that clipPad padding is added around range to avoid aliasing.
	function makeRangeBox(lon, lat) {
	    var clipPad = constants.clipPad;
	    var lon0 = lon[0] + clipPad;
	    var lon1 = lon[1] - clipPad;
	    var lat0 = lat[0] + clipPad;
	    var lat1 = lat[1] - clipPad;
	
	    // to cross antimeridian w/o ambiguity
	    if(lon0 > 0 && lon1 < 0) lon1 += 360;
	
	    var dlon4 = (lon1 - lon0) / 4;
	
	    return {
	        type: 'Polygon',
	        coordinates: [[
	            [lon0, lat0],
	            [lon0, lat1],
	            [lon0 + dlon4, lat1],
	            [lon0 + 2 * dlon4, lat1],
	            [lon0 + 3 * dlon4, lat1],
	            [lon1, lat1],
	            [lon1, lat0],
	            [lon1 - dlon4, lat0],
	            [lon1 - 2 * dlon4, lat0],
	            [lon1 - 3 * dlon4, lat0],
	            [lon0, lat0]
	        ]]
	    };
	}
	
	},{"../../components/color":591,"../../components/dragelement":609,"../../components/drawing":612,"../../components/fx":629,"../../lib":716,"../../lib/topojson_utils":743,"../../registry":845,"../cartesian/axes":764,"../cartesian/select":781,"../plots":825,"./constants":792,"./projections":797,"./zoom":798,"d3":164,"topojson-client":538}],794:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
	var counterRegex = _dereq_('../../lib').counterRegex;
	
	var createGeo = _dereq_('./geo');
	
	var GEO = 'geo';
	var counter = counterRegex(GEO);
	
	var attributes = {};
	attributes[GEO] = {
	    valType: 'subplotid',
	    
	    dflt: GEO,
	    editType: 'calc',
	    
	};
	
	function plotGeo(gd) {
	    var fullLayout = gd._fullLayout;
	    var calcData = gd.calcdata;
	    var geoIds = fullLayout._subplots[GEO];
	
	    for(var i = 0; i < geoIds.length; i++) {
	        var geoId = geoIds[i];
	        var geoCalcData = getSubplotCalcData(calcData, GEO, geoId);
	        var geoLayout = fullLayout[geoId];
	        var geo = geoLayout._subplot;
	
	        if(!geo) {
	            geo = createGeo({
	                id: geoId,
	                graphDiv: gd,
	                container: fullLayout._geolayer.node(),
	                topojsonURL: gd._context.topojsonURL,
	                staticPlot: gd._context.staticPlot
	            });
	
	            fullLayout[geoId]._subplot = geo;
	        }
	
	        geo.plot(geoCalcData, fullLayout, gd._promises);
	    }
	}
	
	function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldGeoKeys = oldFullLayout._subplots[GEO] || [];
	
	    for(var i = 0; i < oldGeoKeys.length; i++) {
	        var oldGeoKey = oldGeoKeys[i];
	        var oldGeo = oldFullLayout[oldGeoKey]._subplot;
	
	        if(!newFullLayout[oldGeoKey] && !!oldGeo) {
	            oldGeo.framework.remove();
	            oldGeo.clipDef.remove();
	        }
	    }
	}
	
	function updateFx(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots[GEO];
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplotLayout = fullLayout[subplotIds[i]];
	        var subplotObj = subplotLayout._subplot;
	        subplotObj.updateFx(fullLayout, subplotLayout);
	    }
	}
	
	module.exports = {
	    attr: GEO,
	    name: GEO,
	    idRoot: GEO,
	    idRegex: counter,
	    attrRegex: counter,
	    attributes: attributes,
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    plot: plotGeo,
	    updateFx: updateFx,
	    clean: clean
	};
	
	},{"../../lib":716,"../../plots/get_data":799,"./geo":793,"./layout_attributes":795,"./layout_defaults":796}],795:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorAttrs = _dereq_('../../components/color/attributes');
	var domainAttrs = _dereq_('../domain').attributes;
	var constants = _dereq_('./constants');
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var geoAxesAttrs = {
	    range: {
	        valType: 'info_array',
	        
	        items: [
	            {valType: 'number'},
	            {valType: 'number'}
	        ],
	        
	    },
	    showgrid: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    tick0: {
	        valType: 'number',
	        
	        dflt: 0,
	        
	    },
	    dtick: {
	        valType: 'number',
	        
	        
	    },
	    gridcolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.lightLine,
	        
	    },
	    gridwidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    }
	};
	
	var attrs = module.exports = overrideAll({
	    domain: domainAttrs({name: 'geo'}, {
	        
	    }),
	
	    resolution: {
	        valType: 'enumerated',
	        values: [110, 50],
	        
	        dflt: 110,
	        coerceNumber: true,
	        
	    },
	    scope: {
	        valType: 'enumerated',
	        
	        values: Object.keys(constants.scopeDefaults),
	        dflt: 'world',
	        
	    },
	    projection: {
	        type: {
	            valType: 'enumerated',
	            
	            values: Object.keys(constants.projNames),
	            
	        },
	        rotation: {
	            lon: {
	                valType: 'number',
	                
	                
	            },
	            lat: {
	                valType: 'number',
	                
	                
	            },
	            roll: {
	                valType: 'number',
	                
	                
	            }
	        },
	        parallels: {
	            valType: 'info_array',
	            
	            items: [
	                {valType: 'number'},
	                {valType: 'number'}
	            ],
	            
	        },
	        scale: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 1,
	            
	        },
	    },
	    center: {
	        lon: {
	            valType: 'number',
	            
	            
	        },
	        lat: {
	            valType: 'number',
	            
	            
	        }
	    },
	    showcoastlines: {
	        valType: 'boolean',
	        
	        
	    },
	    coastlinecolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.defaultLine,
	        
	    },
	    coastlinewidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    },
	    showland: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    landcolor: {
	        valType: 'color',
	        
	        dflt: constants.landColor,
	        
	    },
	    showocean: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    oceancolor: {
	        valType: 'color',
	        
	        dflt: constants.waterColor,
	        
	    },
	    showlakes: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    lakecolor: {
	        valType: 'color',
	        
	        dflt: constants.waterColor,
	        
	    },
	    showrivers: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    rivercolor: {
	        valType: 'color',
	        
	        dflt: constants.waterColor,
	        
	    },
	    riverwidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    },
	    showcountries: {
	        valType: 'boolean',
	        
	        
	    },
	    countrycolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.defaultLine,
	        
	    },
	    countrywidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    },
	    showsubunits: {
	        valType: 'boolean',
	        
	        
	    },
	    subunitcolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.defaultLine,
	        
	    },
	    subunitwidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    },
	    showframe: {
	        valType: 'boolean',
	        
	        
	    },
	    framecolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.defaultLine,
	        
	    },
	    framewidth: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        
	    },
	    bgcolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.background,
	        
	    },
	    lonaxis: geoAxesAttrs,
	    lataxis: geoAxesAttrs
	}, 'plot', 'from-root');
	
	// set uirevision outside of overrideAll so it can be `editType: 'none'`
	attrs.uirevision = {
	    valType: 'any',
	    
	    editType: 'none',
	    
	};
	
	},{"../../components/color/attributes":590,"../../plot_api/edit_types":747,"../domain":789,"./constants":792}],796:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var handleSubplotDefaults = _dereq_('../subplot_defaults');
	var constants = _dereq_('./constants');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	var axesNames = constants.axesNames;
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	        type: 'geo',
	        attributes: layoutAttributes,
	        handleDefaults: handleGeoDefaults,
	        partition: 'y'
	    });
	};
	
	function handleGeoDefaults(geoLayoutIn, geoLayoutOut, coerce) {
	    var show;
	
	    var resolution = coerce('resolution');
	    var scope = coerce('scope');
	    var scopeParams = constants.scopeDefaults[scope];
	
	    var projType = coerce('projection.type', scopeParams.projType);
	    var isAlbersUsa = geoLayoutOut._isAlbersUsa = projType === 'albers usa';
	
	    // no other scopes are allowed for 'albers usa' projection
	    if(isAlbersUsa) scope = geoLayoutOut.scope = 'usa';
	
	    var isScoped = geoLayoutOut._isScoped = (scope !== 'world');
	    var isConic = geoLayoutOut._isConic = projType.indexOf('conic') !== -1;
	    geoLayoutOut._isClipped = !!constants.lonaxisSpan[projType];
	
	    for(var i = 0; i < axesNames.length; i++) {
	        var axisName = axesNames[i];
	        var dtickDflt = [30, 10][i];
	        var rangeDflt;
	
	        if(isScoped) {
	            rangeDflt = scopeParams[axisName + 'Range'];
	        } else {
	            var dfltSpans = constants[axisName + 'Span'];
	            var hSpan = (dfltSpans[projType] || dfltSpans['*']) / 2;
	            var rot = coerce(
	                'projection.rotation.' + axisName.substr(0, 3),
	                scopeParams.projRotate[i]
	            );
	            rangeDflt = [rot - hSpan, rot + hSpan];
	        }
	
	        coerce(axisName + '.range', rangeDflt);
	        coerce(axisName + '.tick0');
	        coerce(axisName + '.dtick', dtickDflt);
	
	        show = coerce(axisName + '.showgrid');
	        if(show) {
	            coerce(axisName + '.gridcolor');
	            coerce(axisName + '.gridwidth');
	        }
	    }
	
	    var lonRange = geoLayoutOut.lonaxis.range;
	    var latRange = geoLayoutOut.lataxis.range;
	
	    // to cross antimeridian w/o ambiguity
	    var lon0 = lonRange[0];
	    var lon1 = lonRange[1];
	    if(lon0 > 0 && lon1 < 0) lon1 += 360;
	
	    var centerLon = (lon0 + lon1) / 2;
	    var projLon;
	
	    if(!isAlbersUsa) {
	        var dfltProjRotate = isScoped ? scopeParams.projRotate : [centerLon, 0, 0];
	
	        projLon = coerce('projection.rotation.lon', dfltProjRotate[0]);
	        coerce('projection.rotation.lat', dfltProjRotate[1]);
	        coerce('projection.rotation.roll', dfltProjRotate[2]);
	
	        show = coerce('showcoastlines', !isScoped);
	        if(show) {
	            coerce('coastlinecolor');
	            coerce('coastlinewidth');
	        }
	
	        show = coerce('showocean');
	        if(show) coerce('oceancolor');
	    }
	
	    var centerLonDflt;
	    var centerLatDflt;
	
	    if(isAlbersUsa) {
	        // 'albers usa' does not have a 'center',
	        // these values were found using via:
	        //   projection.invert([geoLayout.center.lon, geoLayoutIn.center.lat])
	        centerLonDflt = -96.6;
	        centerLatDflt = 38.7;
	    } else {
	        centerLonDflt = isScoped ? centerLon : projLon;
	        centerLatDflt = (latRange[0] + latRange[1]) / 2;
	    }
	
	    coerce('center.lon', centerLonDflt);
	    coerce('center.lat', centerLatDflt);
	
	    if(isConic) {
	        var dfltProjParallels = scopeParams.projParallels || [0, 60];
	        coerce('projection.parallels', dfltProjParallels);
	    }
	
	    coerce('projection.scale');
	
	    show = coerce('showland');
	    if(show) coerce('landcolor');
	
	    show = coerce('showlakes');
	    if(show) coerce('lakecolor');
	
	    show = coerce('showrivers');
	    if(show) {
	        coerce('rivercolor');
	        coerce('riverwidth');
	    }
	
	    show = coerce('showcountries', isScoped && scope !== 'usa');
	    if(show) {
	        coerce('countrycolor');
	        coerce('countrywidth');
	    }
	
	    if(scope === 'usa' || (scope === 'north america' && resolution === 50)) {
	        // Only works for:
	        //   USA states at 110m
	        //   USA states + Canada provinces at 50m
	        coerce('showsubunits', true);
	        coerce('subunitcolor');
	        coerce('subunitwidth');
	    }
	
	    if(!isScoped) {
	        // Does not work in non-world scopes
	        show = coerce('showframe', true);
	        if(show) {
	            coerce('framecolor');
	            coerce('framewidth');
	        }
	    }
	
	    coerce('bgcolor');
	}
	
	},{"../subplot_defaults":839,"./constants":792,"./layout_attributes":795}],797:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	/*
	 * Generated by https://github.com/etpinard/d3-geo-projection-picker
	 *
	 * which is hand-picks projection from https://github.com/d3/d3-geo-projection
	 *
	 * into a CommonJS require-able module.
	 */
	
	'use strict';
	
	/* eslint-disable */
	
	function addProjectionsToD3(d3) {
	  d3.geo.project = function(object, projection) {
	    var stream = projection.stream;
	    if (!stream) throw new Error("not yet supported");
	    return (object && d3_geo_projectObjectType.hasOwnProperty(object.type) ? d3_geo_projectObjectType[object.type] : d3_geo_projectGeometry)(object, stream);
	  };
	  function d3_geo_projectFeature(object, stream) {
	    return {
	      type: "Feature",
	      id: object.id,
	      properties: object.properties,
	      geometry: d3_geo_projectGeometry(object.geometry, stream)
	    };
	  }
	  function d3_geo_projectGeometry(geometry, stream) {
	    if (!geometry) return null;
	    if (geometry.type === "GeometryCollection") return {
	      type: "GeometryCollection",
	      geometries: object.geometries.map(function(geometry) {
	        return d3_geo_projectGeometry(geometry, stream);
	      })
	    };
	    if (!d3_geo_projectGeometryType.hasOwnProperty(geometry.type)) return null;
	    var sink = d3_geo_projectGeometryType[geometry.type];
	    d3.geo.stream(geometry, stream(sink));
	    return sink.result();
	  }
	  var d3_geo_projectObjectType = {
	    Feature: d3_geo_projectFeature,
	    FeatureCollection: function(object, stream) {
	      return {
	        type: "FeatureCollection",
	        features: object.features.map(function(feature) {
	          return d3_geo_projectFeature(feature, stream);
	        })
	      };
	    }
	  };
	  var d3_geo_projectPoints = [], d3_geo_projectLines = [];
	  var d3_geo_projectPoint = {
	    point: function(x, y) {
	      d3_geo_projectPoints.push([ x, y ]);
	    },
	    result: function() {
	      var result = !d3_geo_projectPoints.length ? null : d3_geo_projectPoints.length < 2 ? {
	        type: "Point",
	        coordinates: d3_geo_projectPoints[0]
	      } : {
	        type: "MultiPoint",
	        coordinates: d3_geo_projectPoints
	      };
	      d3_geo_projectPoints = [];
	      return result;
	    }
	  };
	  var d3_geo_projectLine = {
	    lineStart: d3_geo_projectNoop,
	    point: function(x, y) {
	      d3_geo_projectPoints.push([ x, y ]);
	    },
	    lineEnd: function() {
	      if (d3_geo_projectPoints.length) d3_geo_projectLines.push(d3_geo_projectPoints),
	      d3_geo_projectPoints = [];
	    },
	    result: function() {
	      var result = !d3_geo_projectLines.length ? null : d3_geo_projectLines.length < 2 ? {
	        type: "LineString",
	        coordinates: d3_geo_projectLines[0]
	      } : {
	        type: "MultiLineString",
	        coordinates: d3_geo_projectLines
	      };
	      d3_geo_projectLines = [];
	      return result;
	    }
	  };
	  var d3_geo_projectPolygon = {
	    polygonStart: d3_geo_projectNoop,
	    lineStart: d3_geo_projectNoop,
	    point: function(x, y) {
	      d3_geo_projectPoints.push([ x, y ]);
	    },
	    lineEnd: function() {
	      var n = d3_geo_projectPoints.length;
	      if (n) {
	        do d3_geo_projectPoints.push(d3_geo_projectPoints[0].slice()); while (++n < 4);
	        d3_geo_projectLines.push(d3_geo_projectPoints), d3_geo_projectPoints = [];
	      }
	    },
	    polygonEnd: d3_geo_projectNoop,
	    result: function() {
	      if (!d3_geo_projectLines.length) return null;
	      var polygons = [], holes = [];
	      d3_geo_projectLines.forEach(function(ring) {
	        if (d3_geo_projectClockwise(ring)) polygons.push([ ring ]); else holes.push(ring);
	      });
	      holes.forEach(function(hole) {
	        var point = hole[0];
	        polygons.some(function(polygon) {
	          if (d3_geo_projectContains(polygon[0], point)) {
	            polygon.push(hole);
	            return true;
	          }
	        }) || polygons.push([ hole ]);
	      });
	      d3_geo_projectLines = [];
	      return !polygons.length ? null : polygons.length > 1 ? {
	        type: "MultiPolygon",
	        coordinates: polygons
	      } : {
	        type: "Polygon",
	        coordinates: polygons[0]
	      };
	    }
	  };
	  var d3_geo_projectGeometryType = {
	    Point: d3_geo_projectPoint,
	    MultiPoint: d3_geo_projectPoint,
	    LineString: d3_geo_projectLine,
	    MultiLineString: d3_geo_projectLine,
	    Polygon: d3_geo_projectPolygon,
	    MultiPolygon: d3_geo_projectPolygon,
	    Sphere: d3_geo_projectPolygon
	  };
	  function d3_geo_projectNoop() {}
	  function d3_geo_projectClockwise(ring) {
	    if ((n = ring.length) < 4) return false;
	    var i = 0, n, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	    while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	    return area <= 0;
	  }
	  function d3_geo_projectContains(ring, point) {
	    var x = point[0], y = point[1], contains = false;
	    for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	      var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
	      if (yi > y ^ yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = !contains;
	    }
	    return contains;
	  }
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, halfπ = π / 2, sqrtπ = Math.sqrt(π), radians = π / 180, degrees = 180 / π;
	  function sinci(x) {
	    return x ? x / Math.sin(x) : 1;
	  }
	  function sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function asqrt(x) {
	    return x > 0 ? Math.sqrt(x) : 0;
	  }
	  var projection = d3.geo.projection, projectionMutator = d3.geo.projectionMutator;
	  d3.geo.interrupt = function(project) {
	    var lobes = [ [ [ [ -π, 0 ], [ 0, halfπ ], [ π, 0 ] ] ], [ [ [ -π, 0 ], [ 0, -halfπ ], [ π, 0 ] ] ] ];
	    var bounds;
	    function forward(λ, φ) {
	      var sign = φ < 0 ? -1 : +1, hemilobes = lobes[+(φ < 0)];
	      for (var i = 0, n = hemilobes.length - 1; i < n && λ > hemilobes[i][2][0]; ++i) ;
	      var coordinates = project(λ - hemilobes[i][1][0], φ);
	      coordinates[0] += project(hemilobes[i][1][0], sign * φ > sign * hemilobes[i][0][1] ? hemilobes[i][0][1] : φ)[0];
	      return coordinates;
	    }
	    function reset() {
	      bounds = lobes.map(function(hemilobes) {
	        return hemilobes.map(function(lobe) {
	          var x0 = project(lobe[0][0], lobe[0][1])[0], x1 = project(lobe[2][0], lobe[2][1])[0], y0 = project(lobe[1][0], lobe[0][1])[1], y1 = project(lobe[1][0], lobe[1][1])[1], t;
	          if (y0 > y1) t = y0, y0 = y1, y1 = t;
	          return [ [ x0, y0 ], [ x1, y1 ] ];
	        });
	      });
	    }
	    if (project.invert) forward.invert = function(x, y) {
	      var hemibounds = bounds[+(y < 0)], hemilobes = lobes[+(y < 0)];
	      for (var i = 0, n = hemibounds.length; i < n; ++i) {
	        var b = hemibounds[i];
	        if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
	          var coordinates = project.invert(x - project(hemilobes[i][1][0], 0)[0], y);
	          coordinates[0] += hemilobes[i][1][0];
	          return pointEqual(forward(coordinates[0], coordinates[1]), [ x, y ]) ? coordinates : null;
	        }
	      }
	    };
	    var projection = d3.geo.projection(forward), stream_ = projection.stream;
	    projection.stream = function(stream) {
	      var rotate = projection.rotate(), rotateStream = stream_(stream), sphereStream = (projection.rotate([ 0, 0 ]),
	      stream_(stream));
	      projection.rotate(rotate);
	      rotateStream.sphere = function() {
	        d3.geo.stream(sphere(), sphereStream);
	      };
	      return rotateStream;
	    };
	    projection.lobes = function(_) {
	      if (!arguments.length) return lobes.map(function(lobes) {
	        return lobes.map(function(lobe) {
	          return [ [ lobe[0][0] * 180 / π, lobe[0][1] * 180 / π ], [ lobe[1][0] * 180 / π, lobe[1][1] * 180 / π ], [ lobe[2][0] * 180 / π, lobe[2][1] * 180 / π ] ];
	        });
	      });
	      lobes = _.map(function(lobes) {
	        return lobes.map(function(lobe) {
	          return [ [ lobe[0][0] * π / 180, lobe[0][1] * π / 180 ], [ lobe[1][0] * π / 180, lobe[1][1] * π / 180 ], [ lobe[2][0] * π / 180, lobe[2][1] * π / 180 ] ];
	        });
	      });
	      reset();
	      return projection;
	    };
	    function sphere() {
	      var ε = 1e-6, coordinates = [];
	      for (var i = 0, n = lobes[0].length; i < n; ++i) {
	        var lobe = lobes[0][i], λ0 = lobe[0][0] * 180 / π, φ0 = lobe[0][1] * 180 / π, φ1 = lobe[1][1] * 180 / π, λ2 = lobe[2][0] * 180 / π, φ2 = lobe[2][1] * 180 / π;
	        coordinates.push(resample([ [ λ0 + ε, φ0 + ε ], [ λ0 + ε, φ1 - ε ], [ λ2 - ε, φ1 - ε ], [ λ2 - ε, φ2 + ε ] ], 30));
	      }
	      for (var i = lobes[1].length - 1; i >= 0; --i) {
	        var lobe = lobes[1][i], λ0 = lobe[0][0] * 180 / π, φ0 = lobe[0][1] * 180 / π, φ1 = lobe[1][1] * 180 / π, λ2 = lobe[2][0] * 180 / π, φ2 = lobe[2][1] * 180 / π;
	        coordinates.push(resample([ [ λ2 - ε, φ2 - ε ], [ λ2 - ε, φ1 + ε ], [ λ0 + ε, φ1 + ε ], [ λ0 + ε, φ0 - ε ] ], 30));
	      }
	      return {
	        type: "Polygon",
	        coordinates: [ d3.merge(coordinates) ]
	      };
	    }
	    function resample(coordinates, m) {
	      var i = -1, n = coordinates.length, p0 = coordinates[0], p1, dx, dy, resampled = [];
	      while (++i < n) {
	        p1 = coordinates[i];
	        dx = (p1[0] - p0[0]) / m;
	        dy = (p1[1] - p0[1]) / m;
	        for (var j = 0; j < m; ++j) resampled.push([ p0[0] + j * dx, p0[1] + j * dy ]);
	        p0 = p1;
	      }
	      resampled.push(p1);
	      return resampled;
	    }
	    function pointEqual(a, b) {
	      return Math.abs(a[0] - b[0]) < ε && Math.abs(a[1] - b[1]) < ε;
	    }
	    return projection;
	  };
	  function eckert4(λ, φ) {
	    var k = (2 + halfπ) * Math.sin(φ);
	    φ /= 2;
	    for (var i = 0, δ = Infinity; i < 10 && Math.abs(δ) > ε; i++) {
	      var cosφ = Math.cos(φ);
	      φ -= δ = (φ + Math.sin(φ) * (cosφ + 2) - k) / (2 * cosφ * (1 + cosφ));
	    }
	    return [ 2 / Math.sqrt(π * (4 + π)) * λ * (1 + Math.cos(φ)), 2 * Math.sqrt(π / (4 + π)) * Math.sin(φ) ];
	  }
	  eckert4.invert = function(x, y) {
	    var A = .5 * y * Math.sqrt((4 + π) / π), k = asin(A), c = Math.cos(k);
	    return [ x / (2 / Math.sqrt(π * (4 + π)) * (1 + c)), asin((k + A * (c + 2)) / (2 + halfπ)) ];
	  };
	  (d3.geo.eckert4 = function() {
	    return projection(eckert4);
	  }).raw = eckert4;
	  var hammerAzimuthalEqualArea = d3.geo.azimuthalEqualArea.raw;
	  function hammer(A, B) {
	    if (arguments.length < 2) B = A;
	    if (B === 1) return hammerAzimuthalEqualArea;
	    if (B === Infinity) return hammerQuarticAuthalic;
	    function forward(λ, φ) {
	      var coordinates = hammerAzimuthalEqualArea(λ / B, φ);
	      coordinates[0] *= A;
	      return coordinates;
	    }
	    forward.invert = function(x, y) {
	      var coordinates = hammerAzimuthalEqualArea.invert(x / A, y);
	      coordinates[0] *= B;
	      return coordinates;
	    };
	    return forward;
	  }
	  function hammerProjection() {
	    var B = 2, m = projectionMutator(hammer), p = m(B);
	    p.coefficient = function(_) {
	      if (!arguments.length) return B;
	      return m(B = +_);
	    };
	    return p;
	  }
	  function hammerQuarticAuthalic(λ, φ) {
	    return [ λ * Math.cos(φ) / Math.cos(φ /= 2), 2 * Math.sin(φ) ];
	  }
	  hammerQuarticAuthalic.invert = function(x, y) {
	    var φ = 2 * asin(y / 2);
	    return [ x * Math.cos(φ / 2) / Math.cos(φ), φ ];
	  };
	  (d3.geo.hammer = hammerProjection).raw = hammer;
	  function kavrayskiy7(λ, φ) {
	    return [ 3 * λ / (2 * π) * Math.sqrt(π * π / 3 - φ * φ), φ ];
	  }
	  kavrayskiy7.invert = function(x, y) {
	    return [ 2 / 3 * π * x / Math.sqrt(π * π / 3 - y * y), y ];
	  };
	  (d3.geo.kavrayskiy7 = function() {
	    return projection(kavrayskiy7);
	  }).raw = kavrayskiy7;
	  function miller(λ, φ) {
	    return [ λ, 1.25 * Math.log(Math.tan(π / 4 + .4 * φ)) ];
	  }
	  miller.invert = function(x, y) {
	    return [ x, 2.5 * Math.atan(Math.exp(.8 * y)) - .625 * π ];
	  };
	  (d3.geo.miller = function() {
	    return projection(miller);
	  }).raw = miller;
	  function mollweideBromleyθ(Cp) {
	    return function(θ) {
	      var Cpsinθ = Cp * Math.sin(θ), i = 30, δ;
	      do θ -= δ = (θ + Math.sin(θ) - Cpsinθ) / (1 + Math.cos(θ)); while (Math.abs(δ) > ε && --i > 0);
	      return θ / 2;
	    };
	  }
	  function mollweideBromley(Cx, Cy, Cp) {
	    var θ = mollweideBromleyθ(Cp);
	    function forward(λ, φ) {
	      return [ Cx * λ * Math.cos(φ = θ(φ)), Cy * Math.sin(φ) ];
	    }
	    forward.invert = function(x, y) {
	      var θ = asin(y / Cy);
	      return [ x / (Cx * Math.cos(θ)), asin((2 * θ + Math.sin(2 * θ)) / Cp) ];
	    };
	    return forward;
	  }
	  var mollweideθ = mollweideBromleyθ(π), mollweide = mollweideBromley(Math.SQRT2 / halfπ, Math.SQRT2, π);
	  (d3.geo.mollweide = function() {
	    return projection(mollweide);
	  }).raw = mollweide;
	  function naturalEarth(λ, φ) {
	    var φ2 = φ * φ, φ4 = φ2 * φ2;
	    return [ λ * (.8707 - .131979 * φ2 + φ4 * (-.013791 + φ4 * (.003971 * φ2 - .001529 * φ4))), φ * (1.007226 + φ2 * (.015085 + φ4 * (-.044475 + .028874 * φ2 - .005916 * φ4))) ];
	  }
	  naturalEarth.invert = function(x, y) {
	    var φ = y, i = 25, δ;
	    do {
	      var φ2 = φ * φ, φ4 = φ2 * φ2;
	      φ -= δ = (φ * (1.007226 + φ2 * (.015085 + φ4 * (-.044475 + .028874 * φ2 - .005916 * φ4))) - y) / (1.007226 + φ2 * (.015085 * 3 + φ4 * (-.044475 * 7 + .028874 * 9 * φ2 - .005916 * 11 * φ4)));
	    } while (Math.abs(δ) > ε && --i > 0);
	    return [ x / (.8707 + (φ2 = φ * φ) * (-.131979 + φ2 * (-.013791 + φ2 * φ2 * φ2 * (.003971 - .001529 * φ2)))), φ ];
	  };
	  (d3.geo.naturalEarth = function() {
	    return projection(naturalEarth);
	  }).raw = naturalEarth;
	  var robinsonConstants = [ [ .9986, -.062 ], [ 1, 0 ], [ .9986, .062 ], [ .9954, .124 ], [ .99, .186 ], [ .9822, .248 ], [ .973, .31 ], [ .96, .372 ], [ .9427, .434 ], [ .9216, .4958 ], [ .8962, .5571 ], [ .8679, .6176 ], [ .835, .6769 ], [ .7986, .7346 ], [ .7597, .7903 ], [ .7186, .8435 ], [ .6732, .8936 ], [ .6213, .9394 ], [ .5722, .9761 ], [ .5322, 1 ] ];
	  robinsonConstants.forEach(function(d) {
	    d[1] *= 1.0144;
	  });
	  function robinson(λ, φ) {
	    var i = Math.min(18, Math.abs(φ) * 36 / π), i0 = Math.floor(i), di = i - i0, ax = (k = robinsonConstants[i0])[0], ay = k[1], bx = (k = robinsonConstants[++i0])[0], by = k[1], cx = (k = robinsonConstants[Math.min(19, ++i0)])[0], cy = k[1], k;
	    return [ λ * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2), (φ > 0 ? halfπ : -halfπ) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) ];
	  }
	  robinson.invert = function(x, y) {
	    var yy = y / halfπ, φ = yy * 90, i = Math.min(18, Math.abs(φ / 5)), i0 = Math.max(0, Math.floor(i));
	    do {
	      var ay = robinsonConstants[i0][1], by = robinsonConstants[i0 + 1][1], cy = robinsonConstants[Math.min(19, i0 + 2)][1], u = cy - ay, v = cy - 2 * by + ay, t = 2 * (Math.abs(yy) - by) / u, c = v / u, di = t * (1 - c * t * (1 - 2 * c * t));
	      if (di >= 0 || i0 === 1) {
	        φ = (y >= 0 ? 5 : -5) * (di + i);
	        var j = 50, δ;
	        do {
	          i = Math.min(18, Math.abs(φ) / 5);
	          i0 = Math.floor(i);
	          di = i - i0;
	          ay = robinsonConstants[i0][1];
	          by = robinsonConstants[i0 + 1][1];
	          cy = robinsonConstants[Math.min(19, i0 + 2)][1];
	          φ -= (δ = (y >= 0 ? halfπ : -halfπ) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
	        } while (Math.abs(δ) > ε2 && --j > 0);
	        break;
	      }
	    } while (--i0 >= 0);
	    var ax = robinsonConstants[i0][0], bx = robinsonConstants[i0 + 1][0], cx = robinsonConstants[Math.min(19, i0 + 2)][0];
	    return [ x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2), φ * radians ];
	  };
	  (d3.geo.robinson = function() {
	    return projection(robinson);
	  }).raw = robinson;
	  function sinusoidal(λ, φ) {
	    return [ λ * Math.cos(φ), φ ];
	  }
	  sinusoidal.invert = function(x, y) {
	    return [ x / Math.cos(y), y ];
	  };
	  (d3.geo.sinusoidal = function() {
	    return projection(sinusoidal);
	  }).raw = sinusoidal;
	  function aitoff(λ, φ) {
	    var cosφ = Math.cos(φ), sinciα = sinci(acos(cosφ * Math.cos(λ /= 2)));
	    return [ 2 * cosφ * Math.sin(λ) * sinciα, Math.sin(φ) * sinciα ];
	  }
	  aitoff.invert = function(x, y) {
	    if (x * x + 4 * y * y > π * π + ε) return;
	    var λ = x, φ = y, i = 25;
	    do {
	      var sinλ = Math.sin(λ), sinλ_2 = Math.sin(λ / 2), cosλ_2 = Math.cos(λ / 2), sinφ = Math.sin(φ), cosφ = Math.cos(φ), sin_2φ = Math.sin(2 * φ), sin2φ = sinφ * sinφ, cos2φ = cosφ * cosφ, sin2λ_2 = sinλ_2 * sinλ_2, C = 1 - cos2φ * cosλ_2 * cosλ_2, E = C ? acos(cosφ * cosλ_2) * Math.sqrt(F = 1 / C) : F = 0, F, fx = 2 * E * cosφ * sinλ_2 - x, fy = E * sinφ - y, δxδλ = F * (cos2φ * sin2λ_2 + E * cosφ * cosλ_2 * sin2φ), δxδφ = F * (.5 * sinλ * sin_2φ - E * 2 * sinφ * sinλ_2), δyδλ = F * .25 * (sin_2φ * sinλ_2 - E * sinφ * cos2φ * sinλ), δyδφ = F * (sin2φ * cosλ_2 + E * sin2λ_2 * cosφ), denominator = δxδφ * δyδλ - δyδφ * δxδλ;
	      if (!denominator) break;
	      var δλ = (fy * δxδφ - fx * δyδφ) / denominator, δφ = (fx * δyδλ - fy * δxδλ) / denominator;
	      λ -= δλ, φ -= δφ;
	    } while ((Math.abs(δλ) > ε || Math.abs(δφ) > ε) && --i > 0);
	    return [ λ, φ ];
	  };
	  (d3.geo.aitoff = function() {
	    return projection(aitoff);
	  }).raw = aitoff;
	  function winkel3(λ, φ) {
	    var coordinates = aitoff(λ, φ);
	    return [ (coordinates[0] + λ / halfπ) / 2, (coordinates[1] + φ) / 2 ];
	  }
	  winkel3.invert = function(x, y) {
	    var λ = x, φ = y, i = 25;
	    do {
	      var cosφ = Math.cos(φ), sinφ = Math.sin(φ), sin_2φ = Math.sin(2 * φ), sin2φ = sinφ * sinφ, cos2φ = cosφ * cosφ, sinλ = Math.sin(λ), cosλ_2 = Math.cos(λ / 2), sinλ_2 = Math.sin(λ / 2), sin2λ_2 = sinλ_2 * sinλ_2, C = 1 - cos2φ * cosλ_2 * cosλ_2, E = C ? acos(cosφ * cosλ_2) * Math.sqrt(F = 1 / C) : F = 0, F, fx = .5 * (2 * E * cosφ * sinλ_2 + λ / halfπ) - x, fy = .5 * (E * sinφ + φ) - y, δxδλ = .5 * F * (cos2φ * sin2λ_2 + E * cosφ * cosλ_2 * sin2φ) + .5 / halfπ, δxδφ = F * (sinλ * sin_2φ / 4 - E * sinφ * sinλ_2), δyδλ = .125 * F * (sin_2φ * sinλ_2 - E * sinφ * cos2φ * sinλ), δyδφ = .5 * F * (sin2φ * cosλ_2 + E * sin2λ_2 * cosφ) + .5, denominator = δxδφ * δyδλ - δyδφ * δxδλ, δλ = (fy * δxδφ - fx * δyδφ) / denominator, δφ = (fx * δyδλ - fy * δxδλ) / denominator;
	      λ -= δλ, φ -= δφ;
	    } while ((Math.abs(δλ) > ε || Math.abs(δφ) > ε) && --i > 0);
	    return [ λ, φ ];
	  };
	  (d3.geo.winkel3 = function() {
	    return projection(winkel3);
	  }).raw = winkel3;
	}
	
	module.exports = addProjectionsToD3;
	
	},{}],798:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var radians = Math.PI / 180;
	var degrees = 180 / Math.PI;
	var zoomstartStyle = {cursor: 'pointer'};
	var zoomendStyle = {cursor: 'auto'};
	
	function createGeoZoom(geo, geoLayout) {
	    var projection = geo.projection;
	    var zoomConstructor;
	
	    if(geoLayout._isScoped) {
	        zoomConstructor = zoomScoped;
	    } else if(geoLayout._isClipped) {
	        zoomConstructor = zoomClipped;
	    } else {
	        zoomConstructor = zoomNonClipped;
	    }
	
	    // TODO add a conic-specific zoom
	
	    return zoomConstructor(geo, projection);
	}
	
	module.exports = createGeoZoom;
	
	// common to all zoom types
	function initZoom(geo, projection) {
	    return d3.behavior.zoom()
	        .translate(projection.translate())
	        .scale(projection.scale());
	}
	
	// sync zoom updates with user & full layout
	function sync(geo, projection, cb) {
	    var id = geo.id;
	    var gd = geo.graphDiv;
	    var layout = gd.layout;
	    var userOpts = layout[id];
	    var fullLayout = gd._fullLayout;
	    var fullOpts = fullLayout[id];
	
	    var preGUI = {};
	    var eventData = {};
	
	    function set(propStr, val) {
	        preGUI[id + '.' + propStr] = Lib.nestedProperty(userOpts, propStr).get();
	        Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
	
	        var fullNp = Lib.nestedProperty(fullOpts, propStr);
	        if(fullNp.get() !== val) {
	            fullNp.set(val);
	            Lib.nestedProperty(userOpts, propStr).set(val);
	            eventData[id + '.' + propStr] = val;
	        }
	    }
	
	    cb(set);
	    set('projection.scale', projection.scale() / geo.fitScale);
	    gd.emit('plotly_relayout', eventData);
	}
	
	// zoom for scoped projections
	function zoomScoped(geo, projection) {
	    var zoom = initZoom(geo, projection);
	
	    function handleZoomstart() {
	        d3.select(this).style(zoomstartStyle);
	    }
	
	    function handleZoom() {
	        projection
	            .scale(d3.event.scale)
	            .translate(d3.event.translate);
	        geo.render();
	
	        var center = projection.invert(geo.midPt);
	        geo.graphDiv.emit('plotly_relayouting', {
	            'geo.projection.scale': projection.scale() / geo.fitScale,
	            'geo.center.lon': center[0],
	            'geo.center.lat': center[1]
	        });
	    }
	
	    function syncCb(set) {
	        var center = projection.invert(geo.midPt);
	
	        set('center.lon', center[0]);
	        set('center.lat', center[1]);
	    }
	
	    function handleZoomend() {
	        d3.select(this).style(zoomendStyle);
	        sync(geo, projection, syncCb);
	    }
	
	    zoom
	        .on('zoomstart', handleZoomstart)
	        .on('zoom', handleZoom)
	        .on('zoomend', handleZoomend);
	
	    return zoom;
	}
	
	// zoom for non-clipped projections
	function zoomNonClipped(geo, projection) {
	    var zoom = initZoom(geo, projection);
	
	    var INSIDETOLORANCEPXS = 2;
	
	    var mouse0, rotate0, translate0, lastRotate, zoomPoint,
	        mouse1, rotate1, point1, didZoom;
	
	    function position(x) { return projection.invert(x); }
	
	    function outside(x) {
	        var pos = position(x);
	        if(!pos) return true;
	
	        var pt = projection(pos);
	        return (
	            Math.abs(pt[0] - x[0]) > INSIDETOLORANCEPXS ||
	            Math.abs(pt[1] - x[1]) > INSIDETOLORANCEPXS
	        );
	    }
	
	    function handleZoomstart() {
	        d3.select(this).style(zoomstartStyle);
	
	        mouse0 = d3.mouse(this);
	        rotate0 = projection.rotate();
	        translate0 = projection.translate();
	        lastRotate = rotate0;
	        zoomPoint = position(mouse0);
	    }
	
	    function handleZoom() {
	        mouse1 = d3.mouse(this);
	
	        if(outside(mouse0)) {
	            zoom.scale(projection.scale());
	            zoom.translate(projection.translate());
	            return;
	        }
	
	        projection.scale(d3.event.scale);
	        projection.translate([translate0[0], d3.event.translate[1]]);
	
	        if(!zoomPoint) {
	            mouse0 = mouse1;
	            zoomPoint = position(mouse0);
	        } else if(position(mouse1)) {
	            point1 = position(mouse1);
	            rotate1 = [lastRotate[0] + (point1[0] - zoomPoint[0]), rotate0[1], rotate0[2]];
	            projection.rotate(rotate1);
	            lastRotate = rotate1;
	        }
	
	        didZoom = true;
	        geo.render();
	
	        var rotate = projection.rotate();
	        var center = projection.invert(geo.midPt);
	        geo.graphDiv.emit('plotly_relayouting', {
	            'geo.projection.scale': projection.scale() / geo.fitScale,
	            'geo.center.lon': center[0],
	            'geo.center.lat': center[1],
	            'geo.projection.rotation.lon': -rotate[0]
	
	        });
	    }
	
	    function handleZoomend() {
	        d3.select(this).style(zoomendStyle);
	        if(didZoom) sync(geo, projection, syncCb);
	    }
	
	    function syncCb(set) {
	        var rotate = projection.rotate();
	        var center = projection.invert(geo.midPt);
	
	        set('projection.rotation.lon', -rotate[0]);
	        set('center.lon', center[0]);
	        set('center.lat', center[1]);
	    }
	
	    zoom
	        .on('zoomstart', handleZoomstart)
	        .on('zoom', handleZoom)
	        .on('zoomend', handleZoomend);
	
	    return zoom;
	}
	
	// zoom for clipped projections
	// inspired by https://www.jasondavies.com/maps/d3.geo.zoom.js
	function zoomClipped(geo, projection) {
	    var view = {r: projection.rotate(), k: projection.scale()};
	    var zoom = initZoom(geo, projection);
	    var event = d3eventDispatch(zoom, 'zoomstart', 'zoom', 'zoomend');
	    var zooming = 0;
	    var zoomOn = zoom.on;
	
	    var zoomPoint;
	
	    zoom.on('zoomstart', function() {
	        d3.select(this).style(zoomstartStyle);
	
	        var mouse0 = d3.mouse(this);
	        var rotate0 = projection.rotate();
	        var lastRotate = rotate0;
	        var translate0 = projection.translate();
	        var q = quaternionFromEuler(rotate0);
	
	        zoomPoint = position(projection, mouse0);
	
	        zoomOn.call(zoom, 'zoom', function() {
	            var mouse1 = d3.mouse(this);
	
	            projection.scale(view.k = d3.event.scale);
	
	            if(!zoomPoint) {
	                // if no zoomPoint, the mouse wasn't over the actual geography yet
	                // maybe this point is the start... we'll find out next time!
	                mouse0 = mouse1;
	                zoomPoint = position(projection, mouse0);
	            } else if(position(projection, mouse1)) {
	                // check if the point is on the map
	                // if not, don't do anything new but scale
	                // if it is, then we can assume between will exist below
	                // so we don't need the 'bank' function, whatever that is.
	
	                // go back to original projection temporarily
	                // except for scale... that's kind of independent?
	                projection
	                    .rotate(rotate0)
	                    .translate(translate0);
	
	                // calculate the new params
	                var point1 = position(projection, mouse1);
	                var between = rotateBetween(zoomPoint, point1);
	                var newEuler = eulerFromQuaternion(multiply(q, between));
	                var rotateAngles = view.r = unRoll(newEuler, zoomPoint, lastRotate);
	
	                if(!isFinite(rotateAngles[0]) || !isFinite(rotateAngles[1]) ||
	                   !isFinite(rotateAngles[2])) {
	                    rotateAngles = lastRotate;
	                }
	
	                // update the projection
	                projection.rotate(rotateAngles);
	                lastRotate = rotateAngles;
	            }
	
	            zoomed(event.of(this, arguments));
	        });
	
	        zoomstarted(event.of(this, arguments));
	    })
	    .on('zoomend', function() {
	        d3.select(this).style(zoomendStyle);
	        zoomOn.call(zoom, 'zoom', null);
	        zoomended(event.of(this, arguments));
	        sync(geo, projection, syncCb);
	    })
	    .on('zoom.redraw', function() {
	        geo.render();
	
	        var _rotate = projection.rotate();
	        geo.graphDiv.emit('plotly_relayouting', {
	            'geo.projection.scale': projection.scale() / geo.fitScale,
	            'geo.projection.rotation.lon': -_rotate[0],
	            'geo.projection.rotation.lat': -_rotate[1]
	        });
	    });
	
	    function zoomstarted(dispatch) {
	        if(!zooming++) dispatch({type: 'zoomstart'});
	    }
	
	    function zoomed(dispatch) {
	        dispatch({type: 'zoom'});
	    }
	
	    function zoomended(dispatch) {
	        if(!--zooming) dispatch({type: 'zoomend'});
	    }
	
	    function syncCb(set) {
	        var _rotate = projection.rotate();
	        set('projection.rotation.lon', -_rotate[0]);
	        set('projection.rotation.lat', -_rotate[1]);
	    }
	
	    return d3.rebind(zoom, event, 'on');
	}
	
	// -- helper functions for zoomClipped
	
	function position(projection, point) {
	    var spherical = projection.invert(point);
	    return spherical && isFinite(spherical[0]) && isFinite(spherical[1]) && cartesian(spherical);
	}
	
	function quaternionFromEuler(euler) {
	    var lambda = 0.5 * euler[0] * radians;
	    var phi = 0.5 * euler[1] * radians;
	    var gamma = 0.5 * euler[2] * radians;
	    var sinLambda = Math.sin(lambda);
	    var cosLambda = Math.cos(lambda);
	    var sinPhi = Math.sin(phi);
	    var cosPhi = Math.cos(phi);
	    var sinGamma = Math.sin(gamma);
	    var cosGamma = Math.cos(gamma);
	    return [
	        cosLambda * cosPhi * cosGamma + sinLambda * sinPhi * sinGamma,
	        sinLambda * cosPhi * cosGamma - cosLambda * sinPhi * sinGamma,
	        cosLambda * sinPhi * cosGamma + sinLambda * cosPhi * sinGamma,
	        cosLambda * cosPhi * sinGamma - sinLambda * sinPhi * cosGamma
	    ];
	}
	
	function multiply(a, b) {
	    var a0 = a[0];
	    var a1 = a[1];
	    var a2 = a[2];
	    var a3 = a[3];
	    var b0 = b[0];
	    var b1 = b[1];
	    var b2 = b[2];
	    var b3 = b[3];
	    return [
	        a0 * b0 - a1 * b1 - a2 * b2 - a3 * b3,
	        a0 * b1 + a1 * b0 + a2 * b3 - a3 * b2,
	        a0 * b2 - a1 * b3 + a2 * b0 + a3 * b1,
	        a0 * b3 + a1 * b2 - a2 * b1 + a3 * b0
	    ];
	}
	
	function rotateBetween(a, b) {
	    if(!a || !b) return;
	    var axis = cross(a, b);
	    var norm = Math.sqrt(dot(axis, axis));
	    var halfgamma = 0.5 * Math.acos(Math.max(-1, Math.min(1, dot(a, b))));
	    var k = Math.sin(halfgamma) / norm;
	    return norm && [Math.cos(halfgamma), axis[2] * k, -axis[1] * k, axis[0] * k];
	}
	
	// input:
	//   rotateAngles: a calculated set of Euler angles
	//   pt: a point (cartesian in 3-space) to keep fixed
	//   roll0: an initial roll, to be preserved
	// output:
	//   a set of Euler angles that preserve the projection of pt
	//     but set roll (output[2]) equal to roll0
	//     note that this doesn't depend on the particular projection,
	//     just on the rotation angles
	function unRoll(rotateAngles, pt, lastRotate) {
	    // calculate the fixed point transformed by these Euler angles
	    // but with the desired roll undone
	    var ptRotated = rotateCartesian(pt, 2, rotateAngles[0]);
	    ptRotated = rotateCartesian(ptRotated, 1, rotateAngles[1]);
	    ptRotated = rotateCartesian(ptRotated, 0, rotateAngles[2] - lastRotate[2]);
	
	    var x = pt[0];
	    var y = pt[1];
	    var z = pt[2];
	    var f = ptRotated[0];
	    var g = ptRotated[1];
	    var h = ptRotated[2];
	
	    // the following essentially solves:
	    // ptRotated = rotateCartesian(rotateCartesian(pt, 2, newYaw), 1, newPitch)
	    // for newYaw and newPitch, as best it can
	    var theta = Math.atan2(y, x) * degrees;
	    var a = Math.sqrt(x * x + y * y);
	    var b;
	    var newYaw1;
	
	    if(Math.abs(g) > a) {
	        newYaw1 = (g > 0 ? 90 : -90) - theta;
	        b = 0;
	    } else {
	        newYaw1 = Math.asin(g / a) * degrees - theta;
	        b = Math.sqrt(a * a - g * g);
	    }
	
	    var newYaw2 = 180 - newYaw1 - 2 * theta;
	    var newPitch1 = (Math.atan2(h, f) - Math.atan2(z, b)) * degrees;
	    var newPitch2 = (Math.atan2(h, f) - Math.atan2(z, -b)) * degrees;
	
	    // which is closest to lastRotate[0,1]: newYaw/Pitch or newYaw2/Pitch2?
	    var dist1 = angleDistance(lastRotate[0], lastRotate[1], newYaw1, newPitch1);
	    var dist2 = angleDistance(lastRotate[0], lastRotate[1], newYaw2, newPitch2);
	
	    if(dist1 <= dist2) return [newYaw1, newPitch1, lastRotate[2]];
	    else return [newYaw2, newPitch2, lastRotate[2]];
	}
	
	function angleDistance(yaw0, pitch0, yaw1, pitch1) {
	    var dYaw = angleMod(yaw1 - yaw0);
	    var dPitch = angleMod(pitch1 - pitch0);
	    return Math.sqrt(dYaw * dYaw + dPitch * dPitch);
	}
	
	// reduce an angle in degrees to [-180,180]
	function angleMod(angle) {
	    return (angle % 360 + 540) % 360 - 180;
	}
	
	// rotate a cartesian vector
	// axis is 0 (x), 1 (y), or 2 (z)
	// angle is in degrees
	function rotateCartesian(vector, axis, angle) {
	    var angleRads = angle * radians;
	    var vectorOut = vector.slice();
	    var ax1 = (axis === 0) ? 1 : 0;
	    var ax2 = (axis === 2) ? 1 : 2;
	    var cosa = Math.cos(angleRads);
	    var sina = Math.sin(angleRads);
	
	    vectorOut[ax1] = vector[ax1] * cosa - vector[ax2] * sina;
	    vectorOut[ax2] = vector[ax2] * cosa + vector[ax1] * sina;
	
	    return vectorOut;
	}
	function eulerFromQuaternion(q) {
	    return [
	        Math.atan2(2 * (q[0] * q[1] + q[2] * q[3]), 1 - 2 * (q[1] * q[1] + q[2] * q[2])) * degrees,
	        Math.asin(Math.max(-1, Math.min(1, 2 * (q[0] * q[2] - q[3] * q[1])))) * degrees,
	        Math.atan2(2 * (q[0] * q[3] + q[1] * q[2]), 1 - 2 * (q[2] * q[2] + q[3] * q[3])) * degrees
	    ];
	}
	
	function cartesian(spherical) {
	    var lambda = spherical[0] * radians;
	    var phi = spherical[1] * radians;
	    var cosPhi = Math.cos(phi);
	    return [
	        cosPhi * Math.cos(lambda),
	        cosPhi * Math.sin(lambda),
	        Math.sin(phi)
	    ];
	}
	
	function dot(a, b) {
	    var s = 0;
	    for(var i = 0, n = a.length; i < n; ++i) s += a[i] * b[i];
	    return s;
	}
	
	function cross(a, b) {
	    return [
	        a[1] * b[2] - a[2] * b[1],
	        a[2] * b[0] - a[0] * b[2],
	        a[0] * b[1] - a[1] * b[0]
	    ];
	}
	
	// Like d3.dispatch, but for custom events abstracting native UI events. These
	// events have a target component (such as a brush), a target element (such as
	// the svg:g element containing the brush) and the standard arguments `d` (the
	// target element's data) and `i` (the selection index of the target element).
	function d3eventDispatch(target) {
	    var i = 0;
	    var n = arguments.length;
	    var argumentz = [];
	
	    while(++i < n) argumentz.push(arguments[i]);
	
	    var dispatch = d3.dispatch.apply(null, argumentz);
	
	    // Creates a dispatch context for the specified `thiz` (typically, the target
	    // DOM element that received the source event) and `argumentz` (typically, the
	    // data `d` and index `i` of the target element). The returned function can be
	    // used to dispatch an event to any registered listeners; the function takes a
	    // single argument as input, being the event to dispatch. The event must have
	    // a "type" attribute which corresponds to a type registered in the
	    // constructor. This context will automatically populate the "sourceEvent" and
	    // "target" attributes of the event, as well as setting the `d3.event` global
	    // for the duration of the notification.
	    dispatch.of = function(thiz, argumentz) {
	        return function(e1) {
	            var e0;
	            try {
	                e0 = e1.sourceEvent = d3.event;
	                e1.target = target;
	                d3.event = e1;
	                dispatch[e1.type].apply(thiz, argumentz);
	            } finally {
	                d3.event = e0;
	            }
	        };
	    };
	
	    return dispatch;
	}
	
	},{"../../lib":716,"../../registry":845,"d3":164}],799:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	var SUBPLOT_PATTERN = _dereq_('./cartesian/constants').SUBPLOT_PATTERN;
	
	/**
	 * Get calcdata trace(s) associated with a given subplot
	 *
	 * @param {array} calcData: as in gd.calcdata
	 * @param {string} type: subplot type
	 * @param {string} subplotId: subplot id to look for
	 *
	 * @return {array} array of calcdata traces
	 */
	exports.getSubplotCalcData = function(calcData, type, subplotId) {
	    var basePlotModule = Registry.subplotsRegistry[type];
	    if(!basePlotModule) return [];
	
	    var attr = basePlotModule.attr;
	    var subplotCalcData = [];
	
	    for(var i = 0; i < calcData.length; i++) {
	        var calcTrace = calcData[i];
	        var trace = calcTrace[0].trace;
	
	        if(trace[attr] === subplotId) subplotCalcData.push(calcTrace);
	    }
	
	    return subplotCalcData;
	};
	/**
	 * Get calcdata trace(s) that can be plotted with a given module
	 * NOTE: this isn't necessarily just exactly matching trace type,
	 * if multiple trace types use the same plotting routine, they will be
	 * collected here.
	 * In order to not plot the same thing multiple times, we return two arrays,
	 * the calcdata we *will* plot with this module, and the ones we *won't*
	 *
	 * @param {array} calcdata: as in gd.calcdata
	 * @param {object|string|fn} arg1:
	 *  the plotting module, or its name, or its plot method
	 *
	 * @return {array[array]} [foundCalcdata, remainingCalcdata]
	 */
	exports.getModuleCalcData = function(calcdata, arg1) {
	    var moduleCalcData = [];
	    var remainingCalcData = [];
	
	    var plotMethod;
	    if(typeof arg1 === 'string') {
	        plotMethod = Registry.getModule(arg1).plot;
	    } else if(typeof arg1 === 'function') {
	        plotMethod = arg1;
	    } else {
	        plotMethod = arg1.plot;
	    }
	    if(!plotMethod) {
	        return [moduleCalcData, calcdata];
	    }
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var trace = cd[0].trace;
	        // N.B.
	        // - 'legendonly' traces do not make it past here
	        // - skip over 'visible' traces that got trimmed completely during calc transforms
	        if(trace.visible !== true || trace._length === 0) continue;
	
	        // group calcdata trace not by 'module' (as the name of this function
	        // would suggest), but by 'module plot method' so that if some traces
	        // share the same module plot method (e.g. bar and histogram), we
	        // only call it one!
	        if(trace._module.plot === plotMethod) {
	            moduleCalcData.push(cd);
	        } else {
	            remainingCalcData.push(cd);
	        }
	    }
	
	    return [moduleCalcData, remainingCalcData];
	};
	
	/**
	 * Get the data trace(s) associated with a given subplot.
	 *
	 * @param {array} data  plotly full data array.
	 * @param {string} type subplot type to look for.
	 * @param {string} subplotId subplot id to look for.
	 *
	 * @return {array} list of trace objects.
	 *
	 */
	exports.getSubplotData = function getSubplotData(data, type, subplotId) {
	    if(!Registry.subplotsRegistry[type]) return [];
	
	    var attr = Registry.subplotsRegistry[type].attr;
	    var subplotData = [];
	    var trace, subplotX, subplotY;
	
	    if(type === 'gl2d') {
	        var spmatch = subplotId.match(SUBPLOT_PATTERN);
	        subplotX = 'x' + spmatch[1];
	        subplotY = 'y' + spmatch[2];
	    }
	
	    for(var i = 0; i < data.length; i++) {
	        trace = data[i];
	
	        if(type === 'gl2d' && Registry.traceIs(trace, 'gl2d')) {
	            if(trace[attr[0]] === subplotX && trace[attr[1]] === subplotY) {
	                subplotData.push(trace);
	            }
	        } else {
	            if(trace[attr] === subplotId) subplotData.push(trace);
	        }
	    }
	
	    return subplotData;
	};
	
	},{"../registry":845,"./cartesian/constants":770}],800:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var mouseChange = _dereq_('mouse-change');
	var mouseWheel = _dereq_('mouse-wheel');
	var mouseOffset = _dereq_('mouse-event-offset');
	var cartesianConstants = _dereq_('../cartesian/constants');
	var hasPassive = _dereq_('has-passive-events');
	
	module.exports = createCamera;
	
	function Camera2D(element, plot) {
	    this.element = element;
	    this.plot = plot;
	    this.mouseListener = null;
	    this.wheelListener = null;
	    this.lastInputTime = Date.now();
	    this.lastPos = [0, 0];
	    this.boxEnabled = false;
	    this.boxInited = false;
	    this.boxStart = [0, 0];
	    this.boxEnd = [0, 0];
	    this.dragStart = [0, 0];
	}
	
	
	function createCamera(scene) {
	    var element = scene.mouseContainer;
	    var plot = scene.glplot;
	    var result = new Camera2D(element, plot);
	
	    function unSetAutoRange() {
	        scene.xaxis.autorange = false;
	        scene.yaxis.autorange = false;
	    }
	
	    function getSubplotConstraint() {
	        // note: this assumes we only have one x and one y axis on this subplot
	        // when this constraint is lifted this block won't make sense
	        var constraints = scene.graphDiv._fullLayout._axisConstraintGroups;
	        var xaId = scene.xaxis._id;
	        var yaId = scene.yaxis._id;
	        for(var i = 0; i < constraints.length; i++) {
	            if(constraints[i][xaId] !== -1) {
	                if(constraints[i][yaId] !== -1) return true;
	                break;
	            }
	        }
	        return false;
	    }
	
	    result.mouseListener = mouseChange(element, handleInteraction);
	
	    // enable simple touch interactions
	    element.addEventListener('touchstart', function(ev) {
	        var xy = mouseOffset(ev.changedTouches[0], element);
	        handleInteraction(0, xy[0], xy[1]);
	        handleInteraction(1, xy[0], xy[1]);
	
	        ev.preventDefault();
	    }, hasPassive ? {passive: false} : false);
	    element.addEventListener('touchmove', function(ev) {
	        ev.preventDefault();
	        var xy = mouseOffset(ev.changedTouches[0], element);
	        handleInteraction(1, xy[0], xy[1]);
	
	        ev.preventDefault();
	    }, hasPassive ? {passive: false} : false);
	    element.addEventListener('touchend', function(ev) {
	        handleInteraction(0, result.lastPos[0], result.lastPos[1]);
	
	        ev.preventDefault();
	    }, hasPassive ? {passive: false} : false);
	
	    function handleInteraction(buttons, x, y) {
	        var dataBox = scene.calcDataBox();
	        var viewBox = plot.viewBox;
	
	        var lastX = result.lastPos[0];
	        var lastY = result.lastPos[1];
	
	        var MINDRAG = cartesianConstants.MINDRAG * plot.pixelRatio;
	        var MINZOOM = cartesianConstants.MINZOOM * plot.pixelRatio;
	
	        var dx, dy;
	
	        x *= plot.pixelRatio;
	        y *= plot.pixelRatio;
	
	        // mouseChange gives y about top; convert to about bottom
	        y = (viewBox[3] - viewBox[1]) - y;
	
	        function updateRange(i0, start, end) {
	            var range0 = Math.min(start, end);
	            var range1 = Math.max(start, end);
	
	            if(range0 !== range1) {
	                dataBox[i0] = range0;
	                dataBox[i0 + 2] = range1;
	                result.dataBox = dataBox;
	                scene.setRanges(dataBox);
	            } else {
	                scene.selectBox.selectBox = [0, 0, 1, 1];
	                scene.glplot.setDirty();
	            }
	        }
	
	        switch(scene.fullLayout.dragmode) {
	            case 'zoom':
	                if(buttons) {
	                    var dataX = x /
	                            (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) +
	                        dataBox[0];
	                    var dataY = y /
	                            (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) +
	                        dataBox[1];
	
	                    if(!result.boxInited) {
	                        result.boxStart[0] = dataX;
	                        result.boxStart[1] = dataY;
	                        result.dragStart[0] = x;
	                        result.dragStart[1] = y;
	                    }
	
	                    result.boxEnd[0] = dataX;
	                    result.boxEnd[1] = dataY;
	
	                    // we need to mark the box as initialized right away
	                    // so that we can tell the start and end points apart
	                    result.boxInited = true;
	
	                    // but don't actually enable the box until the cursor moves
	                    if(!result.boxEnabled && (
	                        result.boxStart[0] !== result.boxEnd[0] ||
	                        result.boxStart[1] !== result.boxEnd[1])
	                    ) {
	                        result.boxEnabled = true;
	                    }
	
	                    // constrain aspect ratio if the axes require it
	                    var smallDx = Math.abs(result.dragStart[0] - x) < MINZOOM;
	                    var smallDy = Math.abs(result.dragStart[1] - y) < MINZOOM;
	                    if(getSubplotConstraint() && !(smallDx && smallDy)) {
	                        dx = result.boxEnd[0] - result.boxStart[0];
	                        dy = result.boxEnd[1] - result.boxStart[1];
	                        var dydx = (dataBox[3] - dataBox[1]) / (dataBox[2] - dataBox[0]);
	
	                        if(Math.abs(dx * dydx) > Math.abs(dy)) {
	                            result.boxEnd[1] = result.boxStart[1] +
	                                Math.abs(dx) * dydx * (dy >= 0 ? 1 : -1);
	
	                            // gl-select-box clips to the plot area bounds,
	                            // which breaks the axis constraint, so don't allow
	                            // this box to go out of bounds
	                            if(result.boxEnd[1] < dataBox[1]) {
	                                result.boxEnd[1] = dataBox[1];
	                                result.boxEnd[0] = result.boxStart[0] +
	                                    (dataBox[1] - result.boxStart[1]) / Math.abs(dydx);
	                            } else if(result.boxEnd[1] > dataBox[3]) {
	                                result.boxEnd[1] = dataBox[3];
	                                result.boxEnd[0] = result.boxStart[0] +
	                                    (dataBox[3] - result.boxStart[1]) / Math.abs(dydx);
	                            }
	                        } else {
	                            result.boxEnd[0] = result.boxStart[0] +
	                                Math.abs(dy) / dydx * (dx >= 0 ? 1 : -1);
	
	                            if(result.boxEnd[0] < dataBox[0]) {
	                                result.boxEnd[0] = dataBox[0];
	                                result.boxEnd[1] = result.boxStart[1] +
	                                    (dataBox[0] - result.boxStart[0]) * Math.abs(dydx);
	                            } else if(result.boxEnd[0] > dataBox[2]) {
	                                result.boxEnd[0] = dataBox[2];
	                                result.boxEnd[1] = result.boxStart[1] +
	                                    (dataBox[2] - result.boxStart[0]) * Math.abs(dydx);
	                            }
	                        }
	                    } else {
	                        // otherwise clamp small changes to the origin so we get 1D zoom
	
	                        if(smallDx) result.boxEnd[0] = result.boxStart[0];
	                        if(smallDy) result.boxEnd[1] = result.boxStart[1];
	                    }
	                } else if(result.boxEnabled) {
	                    dx = result.boxStart[0] !== result.boxEnd[0];
	                    dy = result.boxStart[1] !== result.boxEnd[1];
	                    if(dx || dy) {
	                        if(dx) {
	                            updateRange(0, result.boxStart[0], result.boxEnd[0]);
	                            scene.xaxis.autorange = false;
	                        }
	                        if(dy) {
	                            updateRange(1, result.boxStart[1], result.boxEnd[1]);
	                            scene.yaxis.autorange = false;
	                        }
	                        scene.relayoutCallback();
	                    } else {
	                        scene.glplot.setDirty();
	                    }
	                    result.boxEnabled = false;
	                    result.boxInited = false;
	                } else if(result.boxInited) {
	                    // if box was inited but button released then - reset the box
	
	                    result.boxInited = false;
	                }
	                break;
	
	            case 'pan':
	                result.boxEnabled = false;
	                result.boxInited = false;
	
	                if(buttons) {
	                    if(!result.panning) {
	                        result.dragStart[0] = x;
	                        result.dragStart[1] = y;
	                    }
	
	                    if(Math.abs(result.dragStart[0] - x) < MINDRAG) x = result.dragStart[0];
	                    if(Math.abs(result.dragStart[1] - y) < MINDRAG) y = result.dragStart[1];
	
	                    dx = (lastX - x) * (dataBox[2] - dataBox[0]) /
	                        (plot.viewBox[2] - plot.viewBox[0]);
	                    dy = (lastY - y) * (dataBox[3] - dataBox[1]) /
	                        (plot.viewBox[3] - plot.viewBox[1]);
	
	                    dataBox[0] += dx;
	                    dataBox[2] += dx;
	                    dataBox[1] += dy;
	                    dataBox[3] += dy;
	
	                    scene.setRanges(dataBox);
	
	                    result.panning = true;
	                    result.lastInputTime = Date.now();
	                    unSetAutoRange();
	                    scene.cameraChanged();
	                    scene.handleAnnotations();
	                } else if(result.panning) {
	                    result.panning = false;
	                    scene.relayoutCallback();
	                }
	                break;
	        }
	
	        result.lastPos[0] = x;
	        result.lastPos[1] = y;
	    }
	
	    result.wheelListener = mouseWheel(element, function(dx, dy) {
	        if(!scene.scrollZoom) return false;
	
	        var dataBox = scene.calcDataBox();
	        var viewBox = plot.viewBox;
	
	        var lastX = result.lastPos[0];
	        var lastY = result.lastPos[1];
	
	        var scale = Math.exp(5.0 * dy / (viewBox[3] - viewBox[1]));
	
	        var cx = lastX /
	                (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) +
	            dataBox[0];
	        var cy = lastY /
	                (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) +
	            dataBox[1];
	
	        dataBox[0] = (dataBox[0] - cx) * scale + cx;
	        dataBox[2] = (dataBox[2] - cx) * scale + cx;
	        dataBox[1] = (dataBox[1] - cy) * scale + cy;
	        dataBox[3] = (dataBox[3] - cy) * scale + cy;
	
	        scene.setRanges(dataBox);
	
	        result.lastInputTime = Date.now();
	        unSetAutoRange();
	        scene.cameraChanged();
	        scene.handleAnnotations();
	        scene.relayoutCallback();
	
	        return true;
	    }, true);
	
	    return result;
	}
	
	},{"../cartesian/constants":770,"has-passive-events":412,"mouse-change":436,"mouse-event-offset":437,"mouse-wheel":439}],801:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Axes = _dereq_('../cartesian/axes');
	
	var str2RGBArray = _dereq_('../../lib/str2rgbarray');
	
	function Axes2DOptions(scene) {
	    this.scene = scene;
	    this.gl = scene.gl;
	    this.pixelRatio = scene.pixelRatio;
	
	    this.screenBox = [0, 0, 1, 1];
	    this.viewBox = [0, 0, 1, 1];
	    this.dataBox = [-1, -1, 1, 1];
	
	    this.borderLineEnable = [false, false, false, false];
	    this.borderLineWidth = [1, 1, 1, 1];
	    this.borderLineColor = [
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1]
	    ];
	
	    this.ticks = [[], []];
	    this.tickEnable = [true, true, false, false];
	    this.tickPad = [15, 15, 15, 15];
	    this.tickAngle = [0, 0, 0, 0];
	    this.tickColor = [
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1]
	    ];
	    this.tickMarkLength = [0, 0, 0, 0];
	    this.tickMarkWidth = [0, 0, 0, 0];
	    this.tickMarkColor = [
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1]
	    ];
	
	    this.labels = ['x', 'y'];
	    this.labelEnable = [true, true, false, false];
	    this.labelAngle = [0, Math.PI / 2, 0, 3.0 * Math.PI / 2];
	    this.labelPad = [15, 15, 15, 15];
	    this.labelSize = [12, 12];
	    this.labelFont = ['sans-serif', 'sans-serif'];
	    this.labelColor = [
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1],
	        [0, 0, 0, 1]
	    ];
	
	    this.title = '';
	    this.titleEnable = true;
	    this.titleCenter = [0, 0, 0, 0];
	    this.titleAngle = 0;
	    this.titleColor = [0, 0, 0, 1];
	    this.titleFont = 'sans-serif';
	    this.titleSize = 18;
	
	    this.gridLineEnable = [true, true];
	    this.gridLineColor = [
	        [0, 0, 0, 0.5],
	        [0, 0, 0, 0.5]
	    ];
	    this.gridLineWidth = [1, 1];
	
	    this.zeroLineEnable = [true, true];
	    this.zeroLineWidth = [1, 1];
	    this.zeroLineColor = [
	        [0, 0, 0, 1],
	        [0, 0, 0, 1]
	    ];
	
	    this.borderColor = [0, 0, 0, 0];
	    this.backgroundColor = [0, 0, 0, 0];
	
	    this.static = this.scene.staticPlot;
	}
	
	var proto = Axes2DOptions.prototype;
	
	var AXES = ['xaxis', 'yaxis'];
	
	proto.merge = function(options) {
	    // titles are rendered in SVG
	    this.titleEnable = false;
	    this.backgroundColor = str2RGBArray(options.plot_bgcolor);
	
	    var axisName, ax, axTitle, axMirror;
	    var hasAxisInDfltPos, hasAxisInAltrPos, hasSharedAxis, mirrorLines, mirrorTicks;
	    var i, j;
	
	    for(i = 0; i < 2; ++i) {
	        axisName = AXES[i];
	        var axisLetter = axisName.charAt(0);
	
	        // get options relevant to this subplot,
	        // '_name' is e.g. xaxis, xaxis2, yaxis, yaxis4 ...
	        ax = options[this.scene[axisName]._name];
	
	        axTitle = ax.title.text === this.scene.fullLayout._dfltTitle[axisLetter] ? '' : ax.title.text;
	
	        for(j = 0; j <= 2; j += 2) {
	            this.labelEnable[i + j] = false;
	            this.labels[i + j] = axTitle;
	            this.labelColor[i + j] = str2RGBArray(ax.title.font.color);
	            this.labelFont[i + j] = ax.title.font.family;
	            this.labelSize[i + j] = ax.title.font.size;
	            this.labelPad[i + j] = this.getLabelPad(axisName, ax);
	
	            this.tickEnable[i + j] = false;
	            this.tickColor[i + j] = str2RGBArray((ax.tickfont || {}).color);
	            this.tickAngle[i + j] = (ax.tickangle === 'auto') ?
	                0 :
	                Math.PI * -ax.tickangle / 180;
	            this.tickPad[i + j] = this.getTickPad(ax);
	
	            this.tickMarkLength[i + j] = 0;
	            this.tickMarkWidth[i + j] = ax.tickwidth || 0;
	            this.tickMarkColor[i + j] = str2RGBArray(ax.tickcolor);
	
	            this.borderLineEnable[i + j] = false;
	            this.borderLineColor[i + j] = str2RGBArray(ax.linecolor);
	            this.borderLineWidth[i + j] = ax.linewidth || 0;
	        }
	
	        hasSharedAxis = this.hasSharedAxis(ax);
	        hasAxisInDfltPos = this.hasAxisInDfltPos(axisName, ax) && !hasSharedAxis;
	        hasAxisInAltrPos = this.hasAxisInAltrPos(axisName, ax) && !hasSharedAxis;
	
	        axMirror = ax.mirror || false;
	        mirrorLines = hasSharedAxis ?
	            (String(axMirror).indexOf('all') !== -1) :  // 'all' or 'allticks'
	            !!axMirror;                                 // all but false
	        mirrorTicks = hasSharedAxis ?
	            (axMirror === 'allticks') :
	            (String(axMirror).indexOf('ticks') !== -1); // 'ticks' or 'allticks'
	
	        // Axis titles and tick labels can only appear of one side of the scene
	        //  and are never show on subplots that share existing axes.
	
	        if(hasAxisInDfltPos) this.labelEnable[i] = true;
	        else if(hasAxisInAltrPos) this.labelEnable[i + 2] = true;
	
	        if(hasAxisInDfltPos) this.tickEnable[i] = ax.showticklabels;
	        else if(hasAxisInAltrPos) this.tickEnable[i + 2] = ax.showticklabels;
	
	        // Grid lines and ticks can appear on both sides of the scene
	        //  and can appear on subplot that share existing axes via `ax.mirror`.
	
	        if(hasAxisInDfltPos || mirrorLines) this.borderLineEnable[i] = ax.showline;
	        if(hasAxisInAltrPos || mirrorLines) this.borderLineEnable[i + 2] = ax.showline;
	
	        if(hasAxisInDfltPos || mirrorTicks) this.tickMarkLength[i] = this.getTickMarkLength(ax);
	        if(hasAxisInAltrPos || mirrorTicks) this.tickMarkLength[i + 2] = this.getTickMarkLength(ax);
	
	        this.gridLineEnable[i] = ax.showgrid;
	        this.gridLineColor[i] = str2RGBArray(ax.gridcolor);
	        this.gridLineWidth[i] = ax.gridwidth;
	
	        this.zeroLineEnable[i] = ax.zeroline;
	        this.zeroLineColor[i] = str2RGBArray(ax.zerolinecolor);
	        this.zeroLineWidth[i] = ax.zerolinewidth;
	    }
	};
	
	// is an axis shared with an already-drawn subplot ?
	proto.hasSharedAxis = function(ax) {
	    var scene = this.scene;
	    var subplotIds = scene.fullLayout._subplots.gl2d;
	    var list = Axes.findSubplotsWithAxis(subplotIds, ax);
	
	    // if index === 0, then the subplot is already drawn as subplots
	    // are drawn in order.
	    return (list.indexOf(scene.id) !== 0);
	};
	
	// has an axis in default position (i.e. bottom/left) ?
	proto.hasAxisInDfltPos = function(axisName, ax) {
	    var axSide = ax.side;
	
	    if(axisName === 'xaxis') return (axSide === 'bottom');
	    else if(axisName === 'yaxis') return (axSide === 'left');
	};
	
	// has an axis in alternate position (i.e. top/right) ?
	proto.hasAxisInAltrPos = function(axisName, ax) {
	    var axSide = ax.side;
	
	    if(axisName === 'xaxis') return (axSide === 'top');
	    else if(axisName === 'yaxis') return (axSide === 'right');
	};
	
	proto.getLabelPad = function(axisName, ax) {
	    var offsetBase = 1.5;
	    var fontSize = ax.title.font.size;
	    var showticklabels = ax.showticklabels;
	
	    if(axisName === 'xaxis') {
	        return (ax.side === 'top') ?
	            -10 + fontSize * (offsetBase + (showticklabels ? 1 : 0)) :
	            -10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
	    } else if(axisName === 'yaxis') {
	        return (ax.side === 'right') ?
	            10 + fontSize * (offsetBase + (showticklabels ? 1 : 0.5)) :
	            10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
	    }
	};
	
	proto.getTickPad = function(ax) {
	    return (ax.ticks === 'outside') ? 10 + ax.ticklen : 15;
	};
	
	proto.getTickMarkLength = function(ax) {
	    if(!ax.ticks) return 0;
	
	    var ticklen = ax.ticklen;
	
	    return (ax.ticks === 'inside') ? -ticklen : ticklen;
	};
	
	
	function createAxes2D(scene) {
	    return new Axes2DOptions(scene);
	}
	
	module.exports = createAxes2D;
	
	},{"../../lib/str2rgbarray":739,"../cartesian/axes":764}],802:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var Scene2D = _dereq_('./scene2d');
	var layoutGlobalAttrs = _dereq_('../layout_attributes');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	var constants = _dereq_('../cartesian/constants');
	var Cartesian = _dereq_('../cartesian');
	var fxAttrs = _dereq_('../../components/fx/layout_attributes');
	var getSubplotData = _dereq_('../get_data').getSubplotData;
	
	exports.name = 'gl2d';
	
	exports.attr = ['xaxis', 'yaxis'];
	
	exports.idRoot = ['x', 'y'];
	
	exports.idRegex = constants.idRegex;
	
	exports.attrRegex = constants.attrRegex;
	
	exports.attributes = _dereq_('../cartesian/attributes');
	
	exports.supplyLayoutDefaults = function(layoutIn, layoutOut, fullData) {
	    if(!layoutOut._has('cartesian')) {
	        Cartesian.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	    }
	};
	
	// gl2d uses svg axis attributes verbatim, but overrides editType
	// this could potentially be just `layoutAttributes` but it would
	// still need special handling somewhere to give it precedence over
	// the svg version when both are in use on one plot
	exports.layoutAttrOverrides = overrideAll(Cartesian.layoutAttributes, 'plot', 'from-root');
	
	// similar overrides for base plot attributes (and those added by components)
	exports.baseLayoutAttrOverrides = overrideAll({
	    plot_bgcolor: layoutGlobalAttrs.plot_bgcolor,
	    hoverlabel: fxAttrs.hoverlabel
	    // dragmode needs calc but only when transitioning TO lasso or select
	    // so for now it's left inside _relayout
	    // dragmode: fxAttrs.dragmode
	}, 'plot', 'nested');
	
	exports.plot = function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var subplotIds = fullLayout._subplots.gl2d;
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplotId = subplotIds[i];
	        var subplotObj = fullLayout._plots[subplotId];
	        var fullSubplotData = getSubplotData(fullData, 'gl2d', subplotId);
	
	        // ref. to corresp. Scene instance
	        var scene = subplotObj._scene2d;
	
	        // If Scene is not instantiated, create one!
	        if(scene === undefined) {
	            scene = new Scene2D({
	                id: subplotId,
	                graphDiv: gd,
	                container: gd.querySelector('.gl-container'),
	                staticPlot: gd._context.staticPlot,
	                plotGlPixelRatio: gd._context.plotGlPixelRatio
	            },
	                fullLayout
	            );
	
	            // set ref to Scene instance
	            subplotObj._scene2d = scene;
	        }
	
	        scene.plot(fullSubplotData, gd.calcdata, fullLayout, gd.layout);
	    }
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldSceneKeys = oldFullLayout._subplots.gl2d || [];
	
	    for(var i = 0; i < oldSceneKeys.length; i++) {
	        var id = oldSceneKeys[i];
	        var oldSubplot = oldFullLayout._plots[id];
	
	        // old subplot wasn't gl2d; nothing to do
	        if(!oldSubplot._scene2d) continue;
	
	        // if no traces are present, delete gl2d subplot
	        var subplotData = getSubplotData(newFullData, 'gl2d', id);
	        if(subplotData.length === 0) {
	            oldSubplot._scene2d.destroy();
	            delete oldFullLayout._plots[id];
	        }
	    }
	
	    // since we use cartesian interactions, do cartesian clean
	    Cartesian.clean.apply(this, arguments);
	};
	
	exports.drawFramework = function(gd) {
	    if(!gd._context.staticPlot) {
	        Cartesian.drawFramework(gd);
	    }
	};
	
	exports.toSVG = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots.gl2d;
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplot = fullLayout._plots[subplotIds[i]];
	        var scene = subplot._scene2d;
	
	        var imageData = scene.toImage('png');
	        var image = fullLayout._glimages.append('svg:image');
	
	        image.attr({
	            xmlns: xmlnsNamespaces.svg,
	            'xlink:href': imageData,
	            x: 0,
	            y: 0,
	            width: '100%',
	            height: '100%',
	            preserveAspectRatio: 'none'
	        });
	
	        scene.destroy();
	    }
	};
	
	exports.updateFx = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots.gl2d;
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplotObj = fullLayout._plots[subplotIds[i]]._scene2d;
	        subplotObj.updateFx(fullLayout.dragmode);
	    }
	};
	
	},{"../../components/fx/layout_attributes":630,"../../constants/xmlns_namespaces":693,"../../plot_api/edit_types":747,"../cartesian":775,"../cartesian/attributes":762,"../cartesian/constants":770,"../get_data":799,"../layout_attributes":816,"./scene2d":803}],803:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Fx = _dereq_('../../components/fx');
	
	var createPlot2D = _dereq_('gl-plot2d');
	var createSpikes = _dereq_('gl-spikes2d');
	var createSelectBox = _dereq_('gl-select-box');
	var getContext = _dereq_('webgl-context');
	
	var createOptions = _dereq_('./convert');
	var createCamera = _dereq_('./camera');
	var showNoWebGlMsg = _dereq_('../../lib/show_no_webgl_msg');
	var axisConstraints = _dereq_('../cartesian/constraints');
	var enforceAxisConstraints = axisConstraints.enforce;
	var cleanAxisConstraints = axisConstraints.clean;
	var doAutoRange = _dereq_('../cartesian/autorange').doAutoRange;
	
	var AXES = ['xaxis', 'yaxis'];
	var STATIC_CANVAS, STATIC_CONTEXT;
	
	var SUBPLOT_PATTERN = _dereq_('../cartesian/constants').SUBPLOT_PATTERN;
	
	
	function Scene2D(options, fullLayout) {
	    this.container = options.container;
	    this.graphDiv = options.graphDiv;
	    this.pixelRatio = options.plotGlPixelRatio || window.devicePixelRatio;
	    this.id = options.id;
	    this.staticPlot = !!options.staticPlot;
	    this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian;
	
	    this.fullData = null;
	    this.updateRefs(fullLayout);
	
	    this.makeFramework();
	    if(this.stopped) return;
	
	    // update options
	    this.glplotOptions = createOptions(this);
	    this.glplotOptions.merge(fullLayout);
	
	    // create the plot
	    this.glplot = createPlot2D(this.glplotOptions);
	
	    // create camera
	    this.camera = createCamera(this);
	
	    // trace set
	    this.traces = {};
	
	    // create axes spikes
	    this.spikes = createSpikes(this.glplot);
	
	    this.selectBox = createSelectBox(this.glplot, {
	        innerFill: false,
	        outerFill: true
	    });
	
	    // last button state
	    this.lastButtonState = 0;
	
	    // last pick result
	    this.pickResult = null;
	
	    // is the mouse over the plot?
	    // it's OK if this says true when it's not, so long as
	    // when we get a mouseout we set it to false before handling
	    this.isMouseOver = true;
	
	    // flag to stop render loop
	    this.stopped = false;
	
	    // redraw the plot
	    this.redraw = this.draw.bind(this);
	    this.redraw();
	}
	
	module.exports = Scene2D;
	
	var proto = Scene2D.prototype;
	
	proto.makeFramework = function() {
	    // create canvas and gl context
	    if(this.staticPlot) {
	        if(!STATIC_CONTEXT) {
	            STATIC_CANVAS = document.createElement('canvas');
	
	            STATIC_CONTEXT = getContext({
	                canvas: STATIC_CANVAS,
	                preserveDrawingBuffer: false,
	                premultipliedAlpha: true,
	                antialias: true
	            });
	
	            if(!STATIC_CONTEXT) {
	                throw new Error('Error creating static canvas/context for image server');
	            }
	        }
	
	        this.canvas = STATIC_CANVAS;
	        this.gl = STATIC_CONTEXT;
	    } else {
	        var liveCanvas = this.container.querySelector('.gl-canvas-focus');
	
	        var gl = getContext({
	            canvas: liveCanvas,
	            preserveDrawingBuffer: true,
	            premultipliedAlpha: true
	        });
	
	        if(!gl) {
	            showNoWebGlMsg(this);
	            this.stopped = true;
	            return;
	        }
	
	        this.canvas = liveCanvas;
	        this.gl = gl;
	    }
	
	    // position the canvas
	    var canvas = this.canvas;
	
	    canvas.style.width = '100%';
	    canvas.style.height = '100%';
	    canvas.style.position = 'absolute';
	    canvas.style.top = '0px';
	    canvas.style.left = '0px';
	    canvas.style['pointer-events'] = 'none';
	
	    this.updateSize(canvas);
	
	    // disabling user select on the canvas
	    // sanitizes double-clicks interactions
	    // ref: https://github.com/plotly/plotly.js/issues/744
	    canvas.className += ' user-select-none';
	
	    // create SVG container for hover text
	    var svgContainer = this.svgContainer = document.createElementNS(
	        'http://www.w3.org/2000/svg',
	        'svg');
	    svgContainer.style.position = 'absolute';
	    svgContainer.style.top = svgContainer.style.left = '0px';
	    svgContainer.style.width = svgContainer.style.height = '100%';
	    svgContainer.style['z-index'] = 20;
	    svgContainer.style['pointer-events'] = 'none';
	
	    // create div to catch the mouse event
	    var mouseContainer = this.mouseContainer = document.createElement('div');
	    mouseContainer.style.position = 'absolute';
	    mouseContainer.style['pointer-events'] = 'auto';
	
	    this.pickCanvas = this.container.querySelector('.gl-canvas-pick');
	
	
	    // append canvas, hover svg and mouse div to container
	    var container = this.container;
	    container.appendChild(svgContainer);
	    container.appendChild(mouseContainer);
	
	    var self = this;
	    mouseContainer.addEventListener('mouseout', function() {
	        self.isMouseOver = false;
	        self.unhover();
	    });
	    mouseContainer.addEventListener('mouseover', function() {
	        self.isMouseOver = true;
	    });
	};
	
	proto.toImage = function(format) {
	    if(!format) format = 'png';
	
	    this.stopped = true;
	
	    if(this.staticPlot) this.container.appendChild(STATIC_CANVAS);
	
	    // update canvas size
	    this.updateSize(this.canvas);
	
	
	    // grab context and yank out pixels
	    var gl = this.glplot.gl;
	    var w = gl.drawingBufferWidth;
	    var h = gl.drawingBufferHeight;
	
	    // force redraw
	    gl.clearColor(1, 1, 1, 0);
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	    this.glplot.setDirty();
	    this.glplot.draw();
	
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	    var pixels = new Uint8Array(w * h * 4);
	    gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
	
	    // flip pixels
	    for(var j = 0, k = h - 1; j < k; ++j, --k) {
	        for(var i = 0; i < w; ++i) {
	            for(var l = 0; l < 4; ++l) {
	                var tmp = pixels[4 * (w * j + i) + l];
	                pixels[4 * (w * j + i) + l] = pixels[4 * (w * k + i) + l];
	                pixels[4 * (w * k + i) + l] = tmp;
	            }
	        }
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = w;
	    canvas.height = h;
	
	    var context = canvas.getContext('2d');
	    var imageData = context.createImageData(w, h);
	    imageData.data.set(pixels);
	    context.putImageData(imageData, 0, 0);
	
	    var dataURL;
	
	    switch(format) {
	        case 'jpeg':
	            dataURL = canvas.toDataURL('image/jpeg');
	            break;
	        case 'webp':
	            dataURL = canvas.toDataURL('image/webp');
	            break;
	        default:
	            dataURL = canvas.toDataURL('image/png');
	    }
	
	    if(this.staticPlot) this.container.removeChild(STATIC_CANVAS);
	
	    return dataURL;
	};
	
	proto.updateSize = function(canvas) {
	    if(!canvas) canvas = this.canvas;
	
	    var pixelRatio = this.pixelRatio;
	    var fullLayout = this.fullLayout;
	
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	    var pixelWidth = Math.ceil(pixelRatio * width) |0;
	    var pixelHeight = Math.ceil(pixelRatio * height) |0;
	
	    // check for resize
	    if(canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
	        canvas.width = pixelWidth;
	        canvas.height = pixelHeight;
	    }
	
	    return canvas;
	};
	
	proto.computeTickMarks = function() {
	    this.xaxis.setScale();
	    this.yaxis.setScale();
	
	    var nextTicks = [
	        Axes.calcTicks(this.xaxis),
	        Axes.calcTicks(this.yaxis)
	    ];
	
	    for(var j = 0; j < 2; ++j) {
	        for(var i = 0; i < nextTicks[j].length; ++i) {
	            // coercing tick value (may not be a string) to a string
	            nextTicks[j][i].text = nextTicks[j][i].text + '';
	        }
	    }
	
	    return nextTicks;
	};
	
	function compareTicks(a, b) {
	    for(var i = 0; i < 2; ++i) {
	        var aticks = a[i];
	        var bticks = b[i];
	
	        if(aticks.length !== bticks.length) return true;
	
	        for(var j = 0; j < aticks.length; ++j) {
	            if(aticks[j].x !== bticks[j].x) return true;
	        }
	    }
	
	    return false;
	}
	
	proto.updateRefs = function(newFullLayout) {
	    this.fullLayout = newFullLayout;
	
	    var spmatch = this.id.match(SUBPLOT_PATTERN);
	    var xaxisName = 'xaxis' + spmatch[1];
	    var yaxisName = 'yaxis' + spmatch[2];
	
	    this.xaxis = this.fullLayout[xaxisName];
	    this.yaxis = this.fullLayout[yaxisName];
	};
	
	proto.relayoutCallback = function() {
	    var graphDiv = this.graphDiv;
	    var xaxis = this.xaxis;
	    var yaxis = this.yaxis;
	    var layout = graphDiv.layout;
	
	    // make a meaningful value to be passed on to possible 'plotly_relayout' subscriber(s)
	    var update = {};
	    var xrange = update[xaxis._name + '.range'] = xaxis.range.slice();
	    var yrange = update[yaxis._name + '.range'] = yaxis.range.slice();
	    update[xaxis._name + '.autorange'] = xaxis.autorange;
	    update[yaxis._name + '.autorange'] = yaxis.autorange;
	
	    Registry.call('_storeDirectGUIEdit', graphDiv.layout, graphDiv._fullLayout._preGUI, update);
	
	    // update the input layout
	    var xaIn = layout[xaxis._name];
	    xaIn.range = xrange;
	    xaIn.autorange = xaxis.autorange;
	
	    var yaIn = layout[yaxis._name];
	    yaIn.range = yrange;
	    yaIn.autorange = yaxis.autorange;
	
	    // lastInputTime helps determine which one is the latest input (if async)
	    update.lastInputTime = this.camera.lastInputTime;
	    graphDiv.emit('plotly_relayout', update);
	};
	
	proto.cameraChanged = function() {
	    var camera = this.camera;
	
	    this.glplot.setDataBox(this.calcDataBox());
	
	    var nextTicks = this.computeTickMarks();
	    var curTicks = this.glplotOptions.ticks;
	
	    if(compareTicks(nextTicks, curTicks)) {
	        this.glplotOptions.ticks = nextTicks;
	        this.glplotOptions.dataBox = camera.dataBox;
	        this.glplot.update(this.glplotOptions);
	        this.handleAnnotations();
	    }
	};
	
	proto.handleAnnotations = function() {
	    var gd = this.graphDiv;
	    var annotations = this.fullLayout.annotations;
	
	    for(var i = 0; i < annotations.length; i++) {
	        var ann = annotations[i];
	
	        if(ann.xref === this.xaxis._id && ann.yref === this.yaxis._id) {
	            Registry.getComponentMethod('annotations', 'drawOne')(gd, i);
	        }
	    }
	};
	
	proto.destroy = function() {
	    if(!this.glplot) return;
	
	    var traces = this.traces;
	
	    if(traces) {
	        Object.keys(traces).map(function(key) {
	            traces[key].dispose();
	            delete traces[key];
	        });
	    }
	
	    this.glplot.dispose();
	
	    this.container.removeChild(this.svgContainer);
	    this.container.removeChild(this.mouseContainer);
	
	    this.fullData = null;
	    this.glplot = null;
	    this.stopped = true;
	    this.camera.mouseListener.enabled = false;
	    this.mouseContainer.removeEventListener('wheel', this.camera.wheelListener);
	    this.camera = null;
	};
	
	proto.plot = function(fullData, calcData, fullLayout) {
	    var glplot = this.glplot;
	
	    this.updateRefs(fullLayout);
	    this.xaxis.clearCalc();
	    this.yaxis.clearCalc();
	    this.updateTraces(fullData, calcData);
	    this.updateFx(fullLayout.dragmode);
	
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	
	    this.updateSize(this.canvas);
	
	    var options = this.glplotOptions;
	    options.merge(fullLayout);
	    options.screenBox = [0, 0, width, height];
	
	    var mockGraphDiv = {_fullLayout: {
	        _axisConstraintGroups: this.graphDiv._fullLayout._axisConstraintGroups,
	        xaxis: this.xaxis,
	        yaxis: this.yaxis
	    }};
	
	    cleanAxisConstraints(mockGraphDiv, this.xaxis);
	    cleanAxisConstraints(mockGraphDiv, this.yaxis);
	
	    var size = fullLayout._size;
	    var domainX = this.xaxis.domain;
	    var domainY = this.yaxis.domain;
	
	    options.viewBox = [
	        size.l + domainX[0] * size.w,
	        size.b + domainY[0] * size.h,
	        (width - size.r) - (1 - domainX[1]) * size.w,
	        (height - size.t) - (1 - domainY[1]) * size.h
	    ];
	
	    this.mouseContainer.style.width = size.w * (domainX[1] - domainX[0]) + 'px';
	    this.mouseContainer.style.height = size.h * (domainY[1] - domainY[0]) + 'px';
	    this.mouseContainer.height = size.h * (domainY[1] - domainY[0]);
	    this.mouseContainer.style.left = size.l + domainX[0] * size.w + 'px';
	    this.mouseContainer.style.top = size.t + (1 - domainY[1]) * size.h + 'px';
	
	    var ax, i;
	
	    for(i = 0; i < 2; ++i) {
	        ax = this[AXES[i]];
	        ax._length = options.viewBox[i + 2] - options.viewBox[i];
	
	        doAutoRange(this.graphDiv, ax);
	        ax.setScale();
	    }
	
	    enforceAxisConstraints(mockGraphDiv);
	
	    options.ticks = this.computeTickMarks();
	
	    options.dataBox = this.calcDataBox();
	
	    options.merge(fullLayout);
	    glplot.update(options);
	
	    // force redraw so that promise is returned when rendering is completed
	    this.glplot.draw();
	};
	
	proto.calcDataBox = function() {
	    var xaxis = this.xaxis;
	    var yaxis = this.yaxis;
	    var xrange = xaxis.range;
	    var yrange = yaxis.range;
	    var xr2l = xaxis.r2l;
	    var yr2l = yaxis.r2l;
	
	    return [xr2l(xrange[0]), yr2l(yrange[0]), xr2l(xrange[1]), yr2l(yrange[1])];
	};
	
	proto.setRanges = function(dataBox) {
	    var xaxis = this.xaxis;
	    var yaxis = this.yaxis;
	    var xl2r = xaxis.l2r;
	    var yl2r = yaxis.l2r;
	
	    xaxis.range = [xl2r(dataBox[0]), xl2r(dataBox[2])];
	    yaxis.range = [yl2r(dataBox[1]), yl2r(dataBox[3])];
	};
	
	proto.updateTraces = function(fullData, calcData) {
	    var traceIds = Object.keys(this.traces);
	    var i, j, fullTrace;
	
	    this.fullData = fullData;
	
	    // remove empty traces
	    traceIdLoop:
	    for(i = 0; i < traceIds.length; i++) {
	        var oldUid = traceIds[i];
	        var oldTrace = this.traces[oldUid];
	
	        for(j = 0; j < fullData.length; j++) {
	            fullTrace = fullData[j];
	
	            if(fullTrace.uid === oldUid && fullTrace.type === oldTrace.type) {
	                continue traceIdLoop;
	            }
	        }
	
	        oldTrace.dispose();
	        delete this.traces[oldUid];
	    }
	
	    // update / create trace objects
	    for(i = 0; i < fullData.length; i++) {
	        fullTrace = fullData[i];
	        var calcTrace = calcData[i];
	        var traceObj = this.traces[fullTrace.uid];
	
	        if(traceObj) traceObj.update(fullTrace, calcTrace);
	        else {
	            traceObj = fullTrace._module.plot(this, fullTrace, calcTrace);
	            this.traces[fullTrace.uid] = traceObj;
	        }
	    }
	
	    // order object per traces
	    this.glplot.objects.sort(function(a, b) {
	        return a._trace.index - b._trace.index;
	    });
	};
	
	proto.updateFx = function(dragmode) {
	    // switch to svg interactions in lasso/select mode
	    if(dragmode === 'lasso' || dragmode === 'select') {
	        this.pickCanvas.style['pointer-events'] = 'none';
	        this.mouseContainer.style['pointer-events'] = 'none';
	    } else {
	        this.pickCanvas.style['pointer-events'] = 'auto';
	        this.mouseContainer.style['pointer-events'] = 'auto';
	    }
	
	    // set proper cursor
	    if(dragmode === 'pan') {
	        this.mouseContainer.style.cursor = 'move';
	    } else if(dragmode === 'zoom') {
	        this.mouseContainer.style.cursor = 'crosshair';
	    } else {
	        this.mouseContainer.style.cursor = null;
	    }
	};
	
	proto.emitPointAction = function(nextSelection, eventType) {
	    var uid = nextSelection.trace.uid;
	    var ptNumber = nextSelection.pointIndex;
	    var trace;
	
	    for(var i = 0; i < this.fullData.length; i++) {
	        if(this.fullData[i].uid === uid) {
	            trace = this.fullData[i];
	        }
	    }
	
	    var pointData = {
	        x: nextSelection.traceCoord[0],
	        y: nextSelection.traceCoord[1],
	        curveNumber: trace.index,
	        pointNumber: ptNumber,
	        data: trace._input,
	        fullData: this.fullData,
	        xaxis: this.xaxis,
	        yaxis: this.yaxis
	    };
	
	    Fx.appendArrayPointValue(pointData, trace, ptNumber);
	
	    this.graphDiv.emit(eventType, {points: [pointData]});
	};
	
	proto.draw = function() {
	    if(this.stopped) return;
	
	    requestAnimationFrame(this.redraw);
	
	    var glplot = this.glplot;
	    var camera = this.camera;
	    var mouseListener = camera.mouseListener;
	    var mouseUp = this.lastButtonState === 1 && mouseListener.buttons === 0;
	    var fullLayout = this.fullLayout;
	
	    this.lastButtonState = mouseListener.buttons;
	
	    this.cameraChanged();
	
	    var x = mouseListener.x * glplot.pixelRatio;
	    var y = this.canvas.height - glplot.pixelRatio * mouseListener.y;
	
	    var result;
	
	    if(camera.boxEnabled && fullLayout.dragmode === 'zoom') {
	        this.selectBox.enabled = true;
	
	        var selectBox = this.selectBox.selectBox = [
	            Math.min(camera.boxStart[0], camera.boxEnd[0]),
	            Math.min(camera.boxStart[1], camera.boxEnd[1]),
	            Math.max(camera.boxStart[0], camera.boxEnd[0]),
	            Math.max(camera.boxStart[1], camera.boxEnd[1])
	        ];
	
	        // 1D zoom
	        for(var i = 0; i < 2; i++) {
	            if(camera.boxStart[i] === camera.boxEnd[i]) {
	                selectBox[i] = glplot.dataBox[i];
	                selectBox[i + 2] = glplot.dataBox[i + 2];
	            }
	        }
	
	        glplot.setDirty();
	    } else if(!camera.panning && this.isMouseOver) {
	        this.selectBox.enabled = false;
	
	        var size = fullLayout._size;
	        var domainX = this.xaxis.domain;
	        var domainY = this.yaxis.domain;
	
	        result = glplot.pick(
	            (x / glplot.pixelRatio) + size.l + domainX[0] * size.w,
	            (y / glplot.pixelRatio) - (size.t + (1 - domainY[1]) * size.h)
	        );
	
	        var nextSelection = result && result.object._trace.handlePick(result);
	
	        if(nextSelection && mouseUp) {
	            this.emitPointAction(nextSelection, 'plotly_click');
	        }
	
	        if(result && result.object._trace.hoverinfo !== 'skip' && fullLayout.hovermode) {
	            if(nextSelection && (
	                !this.lastPickResult ||
	                this.lastPickResult.traceUid !== nextSelection.trace.uid ||
	                this.lastPickResult.dataCoord[0] !== nextSelection.dataCoord[0] ||
	                this.lastPickResult.dataCoord[1] !== nextSelection.dataCoord[1])
	            ) {
	                var selection = nextSelection;
	
	                this.lastPickResult = {
	                    traceUid: nextSelection.trace ? nextSelection.trace.uid : null,
	                    dataCoord: nextSelection.dataCoord.slice()
	                };
	                this.spikes.update({ center: result.dataCoord });
	
	                selection.screenCoord = [
	                    ((glplot.viewBox[2] - glplot.viewBox[0]) *
	                    (result.dataCoord[0] - glplot.dataBox[0]) /
	                        (glplot.dataBox[2] - glplot.dataBox[0]) + glplot.viewBox[0]) /
	                            glplot.pixelRatio,
	                    (this.canvas.height - (glplot.viewBox[3] - glplot.viewBox[1]) *
	                    (result.dataCoord[1] - glplot.dataBox[1]) /
	                        (glplot.dataBox[3] - glplot.dataBox[1]) - glplot.viewBox[1]) /
	                            glplot.pixelRatio
	                ];
	
	                // this needs to happen before the next block that deletes traceCoord data
	                // also it's important to copy, otherwise data is lost by the time event data is read
	                this.emitPointAction(nextSelection, 'plotly_hover');
	
	                var trace = this.fullData[selection.trace.index] || {};
	                var ptNumber = selection.pointIndex;
	                var hoverinfo = Fx.castHoverinfo(trace, fullLayout, ptNumber);
	
	                if(hoverinfo && hoverinfo !== 'all') {
	                    var parts = hoverinfo.split('+');
	                    if(parts.indexOf('x') === -1) selection.traceCoord[0] = undefined;
	                    if(parts.indexOf('y') === -1) selection.traceCoord[1] = undefined;
	                    if(parts.indexOf('z') === -1) selection.traceCoord[2] = undefined;
	                    if(parts.indexOf('text') === -1) selection.textLabel = undefined;
	                    if(parts.indexOf('name') === -1) selection.name = undefined;
	                }
	
	                Fx.loneHover({
	                    x: selection.screenCoord[0],
	                    y: selection.screenCoord[1],
	                    xLabel: this.hoverFormatter('xaxis', selection.traceCoord[0]),
	                    yLabel: this.hoverFormatter('yaxis', selection.traceCoord[1]),
	                    zLabel: selection.traceCoord[2],
	                    text: selection.textLabel,
	                    name: selection.name,
	                    color: Fx.castHoverOption(trace, ptNumber, 'bgcolor') || selection.color,
	                    borderColor: Fx.castHoverOption(trace, ptNumber, 'bordercolor'),
	                    fontFamily: Fx.castHoverOption(trace, ptNumber, 'font.family'),
	                    fontSize: Fx.castHoverOption(trace, ptNumber, 'font.size'),
	                    fontColor: Fx.castHoverOption(trace, ptNumber, 'font.color'),
	                    nameLength: Fx.castHoverOption(trace, ptNumber, 'namelength'),
	                    textAlign: Fx.castHoverOption(trace, ptNumber, 'align')
	                }, {
	                    container: this.svgContainer,
	                    gd: this.graphDiv
	                });
	            }
	        }
	    }
	
	    // Remove hover effects if we're not over a point OR
	    // if we're zooming or panning (in which case result is not set)
	    if(!result) {
	        this.unhover();
	    }
	
	    glplot.draw();
	};
	
	proto.unhover = function() {
	    if(this.lastPickResult) {
	        this.spikes.update({});
	        this.lastPickResult = null;
	        this.graphDiv.emit('plotly_unhover');
	        Fx.loneUnhover(this.svgContainer);
	    }
	};
	
	proto.hoverFormatter = function(axisName, val) {
	    if(val === undefined) return undefined;
	
	    var axis = this[axisName];
	    return Axes.tickText(axis, axis.c2l(val), 'hover').text;
	};
	
	},{"../../components/fx":629,"../../lib/show_no_webgl_msg":737,"../../plots/cartesian/axes":764,"../../registry":845,"../cartesian/autorange":763,"../cartesian/constants":770,"../cartesian/constraints":771,"./camera":800,"./convert":801,"gl-plot2d":289,"gl-select-box":301,"gl-spikes2d":310,"webgl-context":554}],804:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var fxAttrs = _dereq_('../../components/fx/layout_attributes');
	
	var Scene = _dereq_('./scene');
	var getSubplotData = _dereq_('../get_data').getSubplotData;
	var Lib = _dereq_('../../lib');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	
	var GL3D = 'gl3d';
	var SCENE = 'scene';
	
	
	exports.name = GL3D;
	
	exports.attr = SCENE;
	
	exports.idRoot = SCENE;
	
	exports.idRegex = exports.attrRegex = Lib.counterRegex('scene');
	
	exports.attributes = _dereq_('./layout/attributes');
	
	exports.layoutAttributes = _dereq_('./layout/layout_attributes');
	
	exports.baseLayoutAttrOverrides = overrideAll({
	    hoverlabel: fxAttrs.hoverlabel
	}, 'plot', 'nested');
	
	exports.supplyLayoutDefaults = _dereq_('./layout/defaults');
	
	exports.plot = function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var sceneIds = fullLayout._subplots[GL3D];
	
	    for(var i = 0; i < sceneIds.length; i++) {
	        var sceneId = sceneIds[i];
	        var fullSceneData = getSubplotData(fullData, GL3D, sceneId);
	        var sceneLayout = fullLayout[sceneId];
	        var camera = sceneLayout.camera;
	        var scene = sceneLayout._scene;
	
	        if(!scene) {
	            scene = new Scene({
	                id: sceneId,
	                graphDiv: gd,
	                container: gd.querySelector('.gl-container'),
	                staticPlot: gd._context.staticPlot,
	                plotGlPixelRatio: gd._context.plotGlPixelRatio,
	                camera: camera
	            },
	                fullLayout
	            );
	
	            // set ref to Scene instance
	            sceneLayout._scene = scene;
	        }
	
	        // save 'initial' camera view settings for modebar button
	        if(!scene.viewInitial) {
	            scene.viewInitial = {
	                up: {
	                    x: camera.up.x,
	                    y: camera.up.y,
	                    z: camera.up.z
	                },
	                eye: {
	                    x: camera.eye.x,
	                    y: camera.eye.y,
	                    z: camera.eye.z
	                },
	                center: {
	                    x: camera.center.x,
	                    y: camera.center.y,
	                    z: camera.center.z
	                }
	            };
	        }
	
	        scene.plot(fullSceneData, fullLayout, gd.layout);
	    }
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldSceneKeys = oldFullLayout._subplots[GL3D] || [];
	
	    for(var i = 0; i < oldSceneKeys.length; i++) {
	        var oldSceneKey = oldSceneKeys[i];
	
	        if(!newFullLayout[oldSceneKey] && !!oldFullLayout[oldSceneKey]._scene) {
	            oldFullLayout[oldSceneKey]._scene.destroy();
	
	            if(oldFullLayout._infolayer) {
	                oldFullLayout._infolayer
	                    .selectAll('.annotation-' + oldSceneKey)
	                    .remove();
	            }
	        }
	    }
	};
	
	exports.toSVG = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var sceneIds = fullLayout._subplots[GL3D];
	    var size = fullLayout._size;
	
	    for(var i = 0; i < sceneIds.length; i++) {
	        var sceneLayout = fullLayout[sceneIds[i]];
	        var domain = sceneLayout.domain;
	        var scene = sceneLayout._scene;
	
	        var imageData = scene.toImage('png');
	        var image = fullLayout._glimages.append('svg:image');
	
	        image.attr({
	            xmlns: xmlnsNamespaces.svg,
	            'xlink:href': imageData,
	            x: size.l + size.w * domain.x[0],
	            y: size.t + size.h * (1 - domain.y[1]),
	            width: size.w * (domain.x[1] - domain.x[0]),
	            height: size.h * (domain.y[1] - domain.y[0]),
	            preserveAspectRatio: 'none'
	        });
	
	        scene.destroy();
	    }
	};
	
	// clean scene ids, 'scene1' -> 'scene'
	exports.cleanId = function cleanId(id) {
	    if(!id.match(/^scene[0-9]*$/)) return;
	
	    var sceneNum = id.substr(5);
	    if(sceneNum === '1') sceneNum = '';
	
	    return SCENE + sceneNum;
	};
	
	exports.updateFx = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots[GL3D];
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplotObj = fullLayout[subplotIds[i]]._scene;
	        subplotObj.updateFx(fullLayout.dragmode, fullLayout.hovermode);
	    }
	};
	
	},{"../../components/fx/layout_attributes":630,"../../constants/xmlns_namespaces":693,"../../lib":716,"../../plot_api/edit_types":747,"../get_data":799,"./layout/attributes":805,"./layout/defaults":809,"./layout/layout_attributes":810,"./scene":814}],805:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    scene: {
	        valType: 'subplotid',
	        
	        dflt: 'scene',
	        editType: 'calc+clearAxisTypes',
	        
	    }
	};
	
	},{}],806:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../../components/color');
	var axesAttrs = _dereq_('../../cartesian/layout_attributes');
	var extendFlat = _dereq_('../../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../../plot_api/edit_types').overrideAll;
	
	module.exports = overrideAll({
	    visible: axesAttrs.visible,
	    showspikes: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	    spikesides: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	    spikethickness: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 2,
	        
	    },
	    spikecolor: {
	        valType: 'color',
	        
	        dflt: Color.defaultLine,
	        
	    },
	    showbackground: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	    backgroundcolor: {
	        valType: 'color',
	        
	        dflt: 'rgba(204, 204, 204, 0.5)',
	        
	    },
	    showaxeslabels: {
	        valType: 'boolean',
	        
	        dflt: true,
	        
	    },
	    color: axesAttrs.color,
	    categoryorder: axesAttrs.categoryorder,
	    categoryarray: axesAttrs.categoryarray,
	    title: {
	        text: axesAttrs.title.text,
	        font: axesAttrs.title.font
	    },
	    type: extendFlat({}, axesAttrs.type, {
	        values: ['-', 'linear', 'log', 'date', 'category']
	    }),
	    autorange: axesAttrs.autorange,
	    rangemode: axesAttrs.rangemode,
	    range: extendFlat({}, axesAttrs.range, {
	        items: [
	            {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}},
	            {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}}
	        ],
	        anim: false
	    }),
	    // ticks
	    tickmode: axesAttrs.tickmode,
	    nticks: axesAttrs.nticks,
	    tick0: axesAttrs.tick0,
	    dtick: axesAttrs.dtick,
	    tickvals: axesAttrs.tickvals,
	    ticktext: axesAttrs.ticktext,
	    ticks: axesAttrs.ticks,
	    mirror: axesAttrs.mirror,
	    ticklen: axesAttrs.ticklen,
	    tickwidth: axesAttrs.tickwidth,
	    tickcolor: axesAttrs.tickcolor,
	    showticklabels: axesAttrs.showticklabels,
	    tickfont: axesAttrs.tickfont,
	    tickangle: axesAttrs.tickangle,
	    tickprefix: axesAttrs.tickprefix,
	    showtickprefix: axesAttrs.showtickprefix,
	    ticksuffix: axesAttrs.ticksuffix,
	    showticksuffix: axesAttrs.showticksuffix,
	    showexponent: axesAttrs.showexponent,
	    exponentformat: axesAttrs.exponentformat,
	    separatethousands: axesAttrs.separatethousands,
	    tickformat: axesAttrs.tickformat,
	    tickformatstops: axesAttrs.tickformatstops,
	    hoverformat: axesAttrs.hoverformat,
	    // lines and grids
	    showline: axesAttrs.showline,
	    linecolor: axesAttrs.linecolor,
	    linewidth: axesAttrs.linewidth,
	    showgrid: axesAttrs.showgrid,
	    gridcolor: extendFlat({}, axesAttrs.gridcolor,  // shouldn't this be on-par with 2D?
	        {dflt: 'rgb(204, 204, 204)'}),
	    gridwidth: axesAttrs.gridwidth,
	    zeroline: axesAttrs.zeroline,
	    zerolinecolor: axesAttrs.zerolinecolor,
	    zerolinewidth: axesAttrs.zerolinewidth,
	    _deprecated: {
	        title: axesAttrs._deprecated.title,
	        titlefont: axesAttrs._deprecated.titlefont
	    }
	}, 'plot', 'from-root');
	
	},{"../../../components/color":591,"../../../lib/extend":707,"../../../plot_api/edit_types":747,"../../cartesian/layout_attributes":776}],807:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var colorMix = _dereq_('tinycolor2').mix;
	
	var Lib = _dereq_('../../../lib');
	var Template = _dereq_('../../../plot_api/plot_template');
	
	var layoutAttributes = _dereq_('./axis_attributes');
	var handleTypeDefaults = _dereq_('../../cartesian/type_defaults');
	var handleAxisDefaults = _dereq_('../../cartesian/axis_defaults');
	
	var axesNames = ['xaxis', 'yaxis', 'zaxis'];
	
	// TODO: hard-coded lightness fraction based on gridline default colors
	// that differ from other subplot types.
	var gridLightness = 100 * (204 - 0x44) / (255 - 0x44);
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, options) {
	    var containerIn, containerOut;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, layoutAttributes, attr, dflt);
	    }
	
	    for(var j = 0; j < axesNames.length; j++) {
	        var axName = axesNames[j];
	        containerIn = layoutIn[axName] || {};
	
	        containerOut = Template.newContainer(layoutOut, axName);
	        containerOut._id = axName[0] + options.scene;
	        containerOut._name = axName;
	
	        handleTypeDefaults(containerIn, containerOut, coerce, options);
	
	        handleAxisDefaults(
	            containerIn,
	            containerOut,
	            coerce,
	            {
	                font: options.font,
	                letter: axName[0],
	                data: options.data,
	                showGrid: true,
	                noTickson: true,
	                bgColor: options.bgColor,
	                calendar: options.calendar
	            },
	            options.fullLayout);
	
	        coerce('gridcolor', colorMix(containerOut.color, options.bgColor, gridLightness).toRgbString());
	        coerce('title.text', axName[0]);  // shouldn't this be on-par with 2D?
	
	        containerOut.setScale = Lib.noop;
	
	        if(coerce('showspikes')) {
	            coerce('spikesides');
	            coerce('spikethickness');
	            coerce('spikecolor', containerOut.color);
	        }
	
	        coerce('showaxeslabels');
	        if(coerce('showbackground')) coerce('backgroundcolor');
	    }
	};
	
	},{"../../../lib":716,"../../../plot_api/plot_template":754,"../../cartesian/axis_defaults":766,"../../cartesian/type_defaults":787,"./axis_attributes":806,"tinycolor2":535}],808:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var str2RgbaArray = _dereq_('../../../lib/str2rgbarray');
	var Lib = _dereq_('../../../lib');
	
	var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
	
	function AxesOptions() {
	    this.bounds = [
	        [-10, -10, -10],
	        [10, 10, 10]
	    ];
	
	    this.ticks = [ [], [], [] ];
	    this.tickEnable = [ true, true, true ];
	    this.tickFont = [ 'sans-serif', 'sans-serif', 'sans-serif' ];
	    this.tickSize = [ 12, 12, 12 ];
	    this.tickAngle = [ 0, 0, 0 ];
	    this.tickColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	    this.tickPad = [ 18, 18, 18 ];
	
	    this.labels = [ 'x', 'y', 'z' ];
	    this.labelEnable = [ true, true, true ];
	    this.labelFont = ['Open Sans', 'Open Sans', 'Open Sans'];
	    this.labelSize = [ 20, 20, 20 ];
	    this.labelColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	    this.labelPad = [ 30, 30, 30 ];
	
	    this.lineEnable = [ true, true, true ];
	    this.lineMirror = [ false, false, false ];
	    this.lineWidth = [ 1, 1, 1 ];
	    this.lineColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	
	    this.lineTickEnable = [ true, true, true ];
	    this.lineTickMirror = [ false, false, false ];
	    this.lineTickLength = [ 10, 10, 10 ];
	    this.lineTickWidth = [ 1, 1, 1 ];
	    this.lineTickColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	
	    this.gridEnable = [ true, true, true ];
	    this.gridWidth = [ 1, 1, 1 ];
	    this.gridColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	
	    this.zeroEnable = [ true, true, true ];
	    this.zeroLineColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
	    this.zeroLineWidth = [ 2, 2, 2 ];
	
	    this.backgroundEnable = [ true, true, true ];
	    this.backgroundColor = [ [0.8, 0.8, 0.8, 0.5],
	                              [0.8, 0.8, 0.8, 0.5],
	                              [0.8, 0.8, 0.8, 0.5] ];
	
	    // some default values are stored for applying model transforms
	    this._defaultTickPad = this.tickPad.slice();
	    this._defaultLabelPad = this.labelPad.slice();
	    this._defaultLineTickLength = this.lineTickLength.slice();
	}
	
	var proto = AxesOptions.prototype;
	
	proto.merge = function(fullLayout, sceneLayout) {
	    var opts = this;
	    for(var i = 0; i < 3; ++i) {
	        var axes = sceneLayout[AXES_NAMES[i]];
	
	        if(!axes.visible) {
	            opts.tickEnable[i] = false;
	            opts.labelEnable[i] = false;
	            opts.lineEnable[i] = false;
	            opts.lineTickEnable[i] = false;
	            opts.gridEnable[i] = false;
	            opts.zeroEnable[i] = false;
	            opts.backgroundEnable[i] = false;
	            continue;
	        }
	
	        // Axes labels
	        opts.labels[i] = fullLayout._meta ?
	            Lib.templateString(axes.title.text, fullLayout._meta) :
	            axes.title.text;
	
	        if('font' in axes.title) {
	            if(axes.title.font.color) opts.labelColor[i] = str2RgbaArray(axes.title.font.color);
	            if(axes.title.font.family) opts.labelFont[i] = axes.title.font.family;
	            if(axes.title.font.size) opts.labelSize[i] = axes.title.font.size;
	        }
	
	        // Lines
	        if('showline' in axes) opts.lineEnable[i] = axes.showline;
	        if('linecolor' in axes) opts.lineColor[i] = str2RgbaArray(axes.linecolor);
	        if('linewidth' in axes) opts.lineWidth[i] = axes.linewidth;
	
	        if('showgrid' in axes) opts.gridEnable[i] = axes.showgrid;
	        if('gridcolor' in axes) opts.gridColor[i] = str2RgbaArray(axes.gridcolor);
	        if('gridwidth' in axes) opts.gridWidth[i] = axes.gridwidth;
	
	        // Remove zeroline if axis type is log
	        // otherwise the zeroline is incorrectly drawn at 1 on log axes
	        if(axes.type === 'log') opts.zeroEnable[i] = false;
	        else if('zeroline' in axes) opts.zeroEnable[i] = axes.zeroline;
	        if('zerolinecolor' in axes) opts.zeroLineColor[i] = str2RgbaArray(axes.zerolinecolor);
	        if('zerolinewidth' in axes) opts.zeroLineWidth[i] = axes.zerolinewidth;
	
	        // tick lines
	        if('ticks' in axes && !!axes.ticks) opts.lineTickEnable[i] = true;
	        else opts.lineTickEnable[i] = false;
	
	        if('ticklen' in axes) {
	            opts.lineTickLength[i] = opts._defaultLineTickLength[i] = axes.ticklen;
	        }
	        if('tickcolor' in axes) opts.lineTickColor[i] = str2RgbaArray(axes.tickcolor);
	        if('tickwidth' in axes) opts.lineTickWidth[i] = axes.tickwidth;
	        if('tickangle' in axes) {
	            opts.tickAngle[i] = (axes.tickangle === 'auto') ?
	                -3600 : // i.e. special number to set auto option
	                Math.PI * -axes.tickangle / 180;
	        }
	
	        // tick labels
	        if('showticklabels' in axes) opts.tickEnable[i] = axes.showticklabels;
	        if('tickfont' in axes) {
	            if(axes.tickfont.color) opts.tickColor[i] = str2RgbaArray(axes.tickfont.color);
	            if(axes.tickfont.family) opts.tickFont[i] = axes.tickfont.family;
	            if(axes.tickfont.size) opts.tickSize[i] = axes.tickfont.size;
	        }
	
	        if('mirror' in axes) {
	            if(['ticks', 'all', 'allticks'].indexOf(axes.mirror) !== -1) {
	                opts.lineTickMirror[i] = true;
	                opts.lineMirror[i] = true;
	            } else if(axes.mirror === true) {
	                opts.lineTickMirror[i] = false;
	                opts.lineMirror[i] = true;
	            } else {
	                opts.lineTickMirror[i] = false;
	                opts.lineMirror[i] = false;
	            }
	        } else opts.lineMirror[i] = false;
	
	        // grid background
	        if('showbackground' in axes && axes.showbackground !== false) {
	            opts.backgroundEnable[i] = true;
	            opts.backgroundColor[i] = str2RgbaArray(axes.backgroundcolor);
	        } else opts.backgroundEnable[i] = false;
	    }
	};
	
	
	function createAxesOptions(fullLayout, sceneLayout) {
	    var result = new AxesOptions();
	    result.merge(fullLayout, sceneLayout);
	    return result;
	}
	
	module.exports = createAxesOptions;
	
	},{"../../../lib":716,"../../../lib/str2rgbarray":739}],809:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../../lib');
	var Color = _dereq_('../../../components/color');
	var Registry = _dereq_('../../../registry');
	
	var handleSubplotDefaults = _dereq_('../../subplot_defaults');
	var supplyGl3dAxisLayoutDefaults = _dereq_('./axis_defaults');
	var layoutAttributes = _dereq_('./layout_attributes');
	var getSubplotData = _dereq_('../../get_data').getSubplotData;
	
	var GL3D = 'gl3d';
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    var hasNon3D = layoutOut._basePlotModules.length > 1;
	
	    // some layout-wide attribute are used in all scenes
	    // if 3D is the only visible plot type
	    function getDfltFromLayout(attr) {
	        if(hasNon3D) return;
	
	        var isValid = Lib.validate(layoutIn[attr], layoutAttributes[attr]);
	        if(isValid) return layoutIn[attr];
	    }
	
	    handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	        type: GL3D,
	        attributes: layoutAttributes,
	        handleDefaults: handleGl3dDefaults,
	        fullLayout: layoutOut,
	        font: layoutOut.font,
	        fullData: fullData,
	        getDfltFromLayout: getDfltFromLayout,
	        paper_bgcolor: layoutOut.paper_bgcolor,
	        calendar: layoutOut.calendar
	    });
	};
	
	function handleGl3dDefaults(sceneLayoutIn, sceneLayoutOut, coerce, opts) {
	    /*
	     * Scene numbering proceeds as follows
	     * scene
	     * scene2
	     * scene3
	     *
	     * and d.scene will be undefined or some number or number string
	     *
	     * Also write back a blank scene object to user layout so that some
	     * attributes like aspectratio can be written back dynamically.
	     */
	
	    var bgcolor = coerce('bgcolor');
	    var bgColorCombined = Color.combine(bgcolor, opts.paper_bgcolor);
	
	    var cameraKeys = ['up', 'center', 'eye'];
	
	    for(var j = 0; j < cameraKeys.length; j++) {
	        coerce('camera.' + cameraKeys[j] + '.x');
	        coerce('camera.' + cameraKeys[j] + '.y');
	        coerce('camera.' + cameraKeys[j] + '.z');
	    }
	
	    coerce('camera.projection.type');
	
	    /*
	     * coerce to positive number (min 0) but also do not accept 0 (>0 not >=0)
	     * note that 0's go false with the !! call
	     */
	    var hasAspect = !!coerce('aspectratio.x') &&
	                    !!coerce('aspectratio.y') &&
	                    !!coerce('aspectratio.z');
	
	    var defaultAspectMode = hasAspect ? 'manual' : 'auto';
	    var aspectMode = coerce('aspectmode', defaultAspectMode);
	
	    /*
	     * We need aspectratio object in all the Layouts as it is dynamically set
	     * in the calculation steps, ie, we cant set the correct data now, it happens later.
	     * We must also account for the case the user sends bad ratio data with 'manual' set
	     * for the mode. In this case we must force change it here as the default coerce
	     * misses it above.
	     */
	    if(!hasAspect) {
	        sceneLayoutIn.aspectratio = sceneLayoutOut.aspectratio = {x: 1, y: 1, z: 1};
	
	        if(aspectMode === 'manual') sceneLayoutOut.aspectmode = 'auto';
	
	        /*
	         * kind of like autorange - we need the calculated aspectmode back in
	         * the input layout or relayout can cause problems later
	         */
	        sceneLayoutIn.aspectmode = sceneLayoutOut.aspectmode;
	    }
	
	    var fullGl3dData = getSubplotData(opts.fullData, GL3D, opts.id);
	
	    supplyGl3dAxisLayoutDefaults(sceneLayoutIn, sceneLayoutOut, {
	        font: opts.font,
	        scene: opts.id,
	        data: fullGl3dData,
	        bgColor: bgColorCombined,
	        calendar: opts.calendar,
	        fullLayout: opts.fullLayout
	    });
	
	    Registry.getComponentMethod('annotations3d', 'handleDefaults')(
	        sceneLayoutIn, sceneLayoutOut, opts
	    );
	
	    var dragmode = opts.getDfltFromLayout('dragmode');
	
	    if(dragmode !== false) {
	        if(!dragmode) {
	            dragmode = 'orbit';
	
	            if(sceneLayoutIn.camera &&
	                sceneLayoutIn.camera.up) {
	                var x = sceneLayoutIn.camera.up.x;
	                var y = sceneLayoutIn.camera.up.y;
	                var z = sceneLayoutIn.camera.up.z;
	
	                if(z !== 0) {
	                    if(!x || !y || !z) {
	                        dragmode = 'turntable';
	                    } else if(z / Math.sqrt(x * x + y * y + z * z) > 0.999) {
	                        dragmode = 'turntable';
	                    }
	                }
	            } else {
	                dragmode = 'turntable';
	            }
	        }
	    }
	
	    coerce('dragmode', dragmode);
	    coerce('hovermode', opts.getDfltFromLayout('hovermode'));
	}
	
	},{"../../../components/color":591,"../../../lib":716,"../../../registry":845,"../../get_data":799,"../../subplot_defaults":839,"./axis_defaults":807,"./layout_attributes":810}],810:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var gl3dAxisAttrs = _dereq_('./axis_attributes');
	var domainAttrs = _dereq_('../../domain').attributes;
	var extendFlat = _dereq_('../../../lib/extend').extendFlat;
	var counterRegex = _dereq_('../../../lib').counterRegex;
	
	function makeCameraVector(x, y, z) {
	    return {
	        x: {
	            valType: 'number',
	            
	            dflt: x,
	            editType: 'camera'
	        },
	        y: {
	            valType: 'number',
	            
	            dflt: y,
	            editType: 'camera'
	        },
	        z: {
	            valType: 'number',
	            
	            dflt: z,
	            editType: 'camera'
	        },
	        editType: 'camera'
	    };
	}
	
	module.exports = {
	    _arrayAttrRegexps: [counterRegex('scene', '.annotations', true)],
	
	    bgcolor: {
	        valType: 'color',
	        
	        dflt: 'rgba(0,0,0,0)',
	        editType: 'plot'
	    },
	    camera: {
	        up: extendFlat(makeCameraVector(0, 0, 1), {
	            
	        }),
	        center: extendFlat(makeCameraVector(0, 0, 0), {
	            
	        }),
	        eye: extendFlat(makeCameraVector(1.25, 1.25, 1.25), {
	            
	        }),
	        projection: {
	            type: {
	                valType: 'enumerated',
	                
	                values: ['perspective', 'orthographic'],
	                dflt: 'perspective',
	                editType: 'calc',
	                
	            },
	            editType: 'calc'
	        },
	        editType: 'camera'
	    },
	    domain: domainAttrs({name: 'scene', editType: 'plot'}),
	    aspectmode: {
	        valType: 'enumerated',
	        
	        values: ['auto', 'cube', 'data', 'manual'],
	        dflt: 'auto',
	        editType: 'plot',
	        impliedEdits: {
	            'aspectratio.x': undefined,
	            'aspectratio.y': undefined,
	            'aspectratio.z': undefined
	        },
	        
	    },
	    aspectratio: { // must be positive (0's are coerced to 1)
	        x: {
	            valType: 'number',
	            
	            min: 0,
	            editType: 'plot',
	            impliedEdits: {'^aspectmode': 'manual'}
	        },
	        y: {
	            valType: 'number',
	            
	            min: 0,
	            editType: 'plot',
	            impliedEdits: {'^aspectmode': 'manual'}
	        },
	        z: {
	            valType: 'number',
	            
	            min: 0,
	            editType: 'plot',
	            impliedEdits: {'^aspectmode': 'manual'}
	        },
	        editType: 'plot',
	        impliedEdits: {aspectmode: 'manual'},
	        
	    },
	
	    xaxis: gl3dAxisAttrs,
	    yaxis: gl3dAxisAttrs,
	    zaxis: gl3dAxisAttrs,
	
	    dragmode: {
	        valType: 'enumerated',
	        
	        values: ['orbit', 'turntable', 'zoom', 'pan', false],
	        editType: 'plot',
	        
	    },
	    hovermode: {
	        valType: 'enumerated',
	        
	        values: ['closest', false],
	        dflt: 'closest',
	        editType: 'modebar',
	        
	    },
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    editType: 'plot',
	
	    _deprecated: {
	        cameraposition: {
	            valType: 'info_array',
	            
	            editType: 'camera',
	            
	        }
	    }
	};
	
	},{"../../../lib":716,"../../../lib/extend":707,"../../domain":789,"./axis_attributes":806}],811:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var str2RGBArray = _dereq_('../../../lib/str2rgbarray');
	
	var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
	
	function SpikeOptions() {
	    this.enabled = [true, true, true];
	    this.colors = [[0, 0, 0, 1],
	                   [0, 0, 0, 1],
	                   [0, 0, 0, 1]];
	    this.drawSides = [true, true, true];
	    this.lineWidth = [1, 1, 1];
	}
	
	var proto = SpikeOptions.prototype;
	
	proto.merge = function(sceneLayout) {
	    for(var i = 0; i < 3; ++i) {
	        var axes = sceneLayout[AXES_NAMES[i]];
	
	        if(!axes.visible) {
	            this.enabled[i] = false;
	            this.drawSides[i] = false;
	            continue;
	        }
	
	        this.enabled[i] = axes.showspikes;
	        this.colors[i] = str2RGBArray(axes.spikecolor);
	        this.drawSides[i] = axes.spikesides;
	        this.lineWidth[i] = axes.spikethickness;
	    }
	};
	
	function createSpikeOptions(layout) {
	    var result = new SpikeOptions();
	    result.merge(layout);
	    return result;
	}
	
	module.exports = createSpikeOptions;
	
	},{"../../../lib/str2rgbarray":739}],812:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	/* eslint block-scoped-var: 0*/
	/* eslint no-redeclare: 0*/
	
	'use strict';
	
	module.exports = computeTickMarks;
	
	var Axes = _dereq_('../../cartesian/axes');
	var Lib = _dereq_('../../../lib');
	
	var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
	
	var centerPoint = [0, 0, 0];
	
	function contourLevelsFromTicks(ticks) {
	    var result = new Array(3);
	    for(var i = 0; i < 3; ++i) {
	        var tlevel = ticks[i];
	        var clevel = new Array(tlevel.length);
	        for(var j = 0; j < tlevel.length; ++j) {
	            clevel[j] = tlevel[j].x;
	        }
	        result[i] = clevel;
	    }
	    return result;
	}
	
	function computeTickMarks(scene) {
	    var axesOptions = scene.axesOptions;
	    var glRange = scene.glplot.axesPixels;
	    var sceneLayout = scene.fullSceneLayout;
	
	    var ticks = [[], [], []];
	
	    for(var i = 0; i < 3; ++i) {
	        var axes = sceneLayout[AXES_NAMES[i]];
	
	        axes._length = (glRange[i].hi - glRange[i].lo) *
	            glRange[i].pixelsPerDataUnit / scene.dataScale[i];
	
	        if(Math.abs(axes._length) === Infinity ||
	           isNaN(axes._length)) {
	            ticks[i] = [];
	        } else {
	            axes._input_range = axes.range.slice();
	            axes.range[0] = (glRange[i].lo) / scene.dataScale[i];
	            axes.range[1] = (glRange[i].hi) / scene.dataScale[i];
	            axes._m = 1.0 / (scene.dataScale[i] * glRange[i].pixelsPerDataUnit);
	
	            if(axes.range[0] === axes.range[1]) {
	                axes.range[0] -= 1;
	                axes.range[1] += 1;
	            }
	            // this is necessary to short-circuit the 'y' handling
	            // in autotick part of calcTicks... Treating all axes as 'y' in this case
	            // running the autoticks here, then setting
	            // autoticks to false to get around the 2D handling in calcTicks.
	            var tickModeCached = axes.tickmode;
	            if(axes.tickmode === 'auto') {
	                axes.tickmode = 'linear';
	                var nticks = axes.nticks || Lib.constrain((axes._length / 40), 4, 9);
	                Axes.autoTicks(axes, Math.abs(axes.range[1] - axes.range[0]) / nticks);
	            }
	            var dataTicks = Axes.calcTicks(axes);
	            for(var j = 0; j < dataTicks.length; ++j) {
	                dataTicks[j].x = dataTicks[j].x * scene.dataScale[i];
	
	                if(axes.type === 'date') {
	                    dataTicks[j].text =
	                    dataTicks[j].text.replace(/\<br\>/g, ' ');
	                }
	            }
	            ticks[i] = dataTicks;
	
	
	            axes.tickmode = tickModeCached;
	        }
	    }
	
	    axesOptions.ticks = ticks;
	
	    // Calculate tick lengths dynamically
	    for(var i = 0; i < 3; ++i) {
	        centerPoint[i] = 0.5 * (scene.glplot.bounds[0][i] + scene.glplot.bounds[1][i]);
	        for(var j = 0; j < 2; ++j) {
	            axesOptions.bounds[j][i] = scene.glplot.bounds[j][i];
	        }
	    }
	
	    scene.contourLevels = contourLevelsFromTicks(ticks);
	}
	
	},{"../../../lib":716,"../../cartesian/axes":764}],813:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	function xformMatrix(m, v) {
	    var out = [0, 0, 0, 0];
	    var i, j;
	
	    for(i = 0; i < 4; ++i) {
	        for(j = 0; j < 4; ++j) {
	            out[j] += m[4 * i + j] * v[i];
	        }
	    }
	
	    return out;
	}
	
	function project(camera, v) {
	    var p = xformMatrix(camera.projection,
	        xformMatrix(camera.view,
	        xformMatrix(camera.model, [v[0], v[1], v[2], 1])));
	    return p;
	}
	
	module.exports = project;
	
	},{}],814:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var glPlot3d = _dereq_('gl-plot3d');
	var createCamera = glPlot3d.createCamera;
	var createPlot = glPlot3d.createScene;
	
	var getContext = _dereq_('webgl-context');
	var passiveSupported = _dereq_('has-passive-events');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Fx = _dereq_('../../components/fx');
	
	var str2RGBAarray = _dereq_('../../lib/str2rgbarray');
	var showNoWebGlMsg = _dereq_('../../lib/show_no_webgl_msg');
	
	var project = _dereq_('./project');
	var createAxesOptions = _dereq_('./layout/convert');
	var createSpikeOptions = _dereq_('./layout/spikes');
	var computeTickMarks = _dereq_('./layout/tick_marks');
	
	
	var STATIC_CANVAS, STATIC_CONTEXT;
	
	function render(scene) {
	    var gd = scene.graphDiv;
	    var trace;
	
	    // update size of svg container
	    var svgContainer = scene.svgContainer;
	    var clientRect = scene.container.getBoundingClientRect();
	    var width = clientRect.width;
	    var height = clientRect.height;
	    svgContainer.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
	    svgContainer.setAttributeNS(null, 'width', width);
	    svgContainer.setAttributeNS(null, 'height', height);
	
	    computeTickMarks(scene);
	    scene.glplot.axes.update(scene.axesOptions);
	
	    // check if pick has changed
	    var keys = Object.keys(scene.traces);
	    var lastPicked = null;
	    var selection = scene.glplot.selection;
	    for(var i = 0; i < keys.length; ++i) {
	        trace = scene.traces[keys[i]];
	        if(trace.data.hoverinfo !== 'skip' && trace.handlePick(selection)) {
	            lastPicked = trace;
	        }
	
	        if(trace.setContourLevels) trace.setContourLevels();
	    }
	
	    function formatter(axisName, val) {
	        var axis = scene.fullSceneLayout[axisName];
	
	        return Axes.tickText(axis, axis.d2l(val), 'hover').text;
	    }
	
	    var oldEventData;
	
	    if(lastPicked !== null) {
	        var pdata = project(scene.glplot.cameraParams, selection.dataCoordinate);
	        trace = lastPicked.data;
	        var traceNow = gd._fullData[trace.index];
	        var ptNumber = selection.index;
	
	        var labels = {
	            xLabel: formatter('xaxis', selection.traceCoordinate[0]),
	            yLabel: formatter('yaxis', selection.traceCoordinate[1]),
	            zLabel: formatter('zaxis', selection.traceCoordinate[2])
	        };
	
	        var hoverinfo = Fx.castHoverinfo(traceNow, scene.fullLayout, ptNumber);
	        var hoverinfoParts = (hoverinfo || '').split('+');
	        var isHoverinfoAll = hoverinfo && hoverinfo === 'all';
	
	        if(!traceNow.hovertemplate && !isHoverinfoAll) {
	            if(hoverinfoParts.indexOf('x') === -1) labels.xLabel = undefined;
	            if(hoverinfoParts.indexOf('y') === -1) labels.yLabel = undefined;
	            if(hoverinfoParts.indexOf('z') === -1) labels.zLabel = undefined;
	            if(hoverinfoParts.indexOf('text') === -1) selection.textLabel = undefined;
	            if(hoverinfoParts.indexOf('name') === -1) lastPicked.name = undefined;
	        }
	
	        var tx;
	        var vectorTx = [];
	
	        if(trace.type === 'cone' || trace.type === 'streamtube') {
	            labels.uLabel = formatter('xaxis', selection.traceCoordinate[3]);
	            if(isHoverinfoAll || hoverinfoParts.indexOf('u') !== -1) {
	                vectorTx.push('u: ' + labels.uLabel);
	            }
	
	            labels.vLabel = formatter('yaxis', selection.traceCoordinate[4]);
	            if(isHoverinfoAll || hoverinfoParts.indexOf('v') !== -1) {
	                vectorTx.push('v: ' + labels.vLabel);
	            }
	
	            labels.wLabel = formatter('zaxis', selection.traceCoordinate[5]);
	            if(isHoverinfoAll || hoverinfoParts.indexOf('w') !== -1) {
	                vectorTx.push('w: ' + labels.wLabel);
	            }
	
	            labels.normLabel = selection.traceCoordinate[6].toPrecision(3);
	            if(isHoverinfoAll || hoverinfoParts.indexOf('norm') !== -1) {
	                vectorTx.push('norm: ' + labels.normLabel);
	            }
	            if(trace.type === 'streamtube') {
	                labels.divergenceLabel = selection.traceCoordinate[7].toPrecision(3);
	                if(isHoverinfoAll || hoverinfoParts.indexOf('divergence') !== -1) {
	                    vectorTx.push('divergence: ' + labels.divergenceLabel);
	                }
	            }
	            if(selection.textLabel) {
	                vectorTx.push(selection.textLabel);
	            }
	            tx = vectorTx.join('<br>');
	        } else if(trace.type === 'isosurface' || trace.type === 'volume') {
	            labels.valueLabel = Axes.tickText(scene.mockAxis, scene.mockAxis.d2l(selection.traceCoordinate[3]), 'hover').text;
	            vectorTx.push('value: ' + labels.valueLabel);
	            if(selection.textLabel) {
	                vectorTx.push(selection.textLabel);
	            }
	            tx = vectorTx.join('<br>');
	        } else {
	            tx = selection.textLabel;
	        }
	
	        var pointData = {
	            x: selection.traceCoordinate[0],
	            y: selection.traceCoordinate[1],
	            z: selection.traceCoordinate[2],
	            data: traceNow._input,
	            fullData: traceNow,
	            curveNumber: traceNow.index,
	            pointNumber: ptNumber
	        };
	
	        Fx.appendArrayPointValue(pointData, traceNow, ptNumber);
	
	        if(trace._module.eventData) {
	            pointData = traceNow._module.eventData(pointData, selection, traceNow, {}, ptNumber);
	        }
	
	        var eventData = {points: [pointData]};
	
	        if(scene.fullSceneLayout.hovermode) {
	            Fx.loneHover({
	                trace: traceNow,
	                x: (0.5 + 0.5 * pdata[0] / pdata[3]) * width,
	                y: (0.5 - 0.5 * pdata[1] / pdata[3]) * height,
	                xLabel: labels.xLabel,
	                yLabel: labels.yLabel,
	                zLabel: labels.zLabel,
	                text: tx,
	                name: lastPicked.name,
	                color: Fx.castHoverOption(traceNow, ptNumber, 'bgcolor') || lastPicked.color,
	                borderColor: Fx.castHoverOption(traceNow, ptNumber, 'bordercolor'),
	                fontFamily: Fx.castHoverOption(traceNow, ptNumber, 'font.family'),
	                fontSize: Fx.castHoverOption(traceNow, ptNumber, 'font.size'),
	                fontColor: Fx.castHoverOption(traceNow, ptNumber, 'font.color'),
	                nameLength: Fx.castHoverOption(traceNow, ptNumber, 'namelength'),
	                textAlign: Fx.castHoverOption(traceNow, ptNumber, 'align'),
	                hovertemplate: Lib.castOption(traceNow, ptNumber, 'hovertemplate'),
	                hovertemplateLabels: Lib.extendFlat({}, pointData, labels),
	                eventData: [pointData]
	            }, {
	                container: svgContainer,
	                gd: gd
	            });
	        }
	
	        if(selection.buttons && selection.distance < 5) {
	            gd.emit('plotly_click', eventData);
	        } else {
	            gd.emit('plotly_hover', eventData);
	        }
	
	        oldEventData = eventData;
	    } else {
	        Fx.loneUnhover(svgContainer);
	        gd.emit('plotly_unhover', oldEventData);
	    }
	
	    scene.drawAnnotations(scene);
	}
	
	function tryCreatePlot(scene, cameraObject, pixelRatio, canvas, gl) {
	    var glplotOptions = {
	        canvas: canvas,
	        gl: gl,
	        container: scene.container,
	        axes: scene.axesOptions,
	        spikes: scene.spikeOptions,
	        pickRadius: 10,
	        snapToData: true,
	        autoScale: true,
	        autoBounds: false,
	        cameraObject: cameraObject,
	        pixelRatio: pixelRatio
	    };
	
	    // for static plots, we reuse the WebGL context
	    //  as WebKit doesn't collect them reliably
	    if(scene.staticMode) {
	        if(!STATIC_CONTEXT) {
	            STATIC_CANVAS = document.createElement('canvas');
	            STATIC_CONTEXT = getContext({
	                canvas: STATIC_CANVAS,
	                preserveDrawingBuffer: true,
	                premultipliedAlpha: true,
	                antialias: true
	            });
	            if(!STATIC_CONTEXT) {
	                throw new Error('error creating static canvas/context for image server');
	            }
	        }
	        glplotOptions.pixelRatio = scene.pixelRatio;
	        glplotOptions.gl = STATIC_CONTEXT;
	        glplotOptions.canvas = STATIC_CANVAS;
	    }
	
	    var failed = 0;
	
	    try {
	        scene.glplot = createPlot(glplotOptions);
	    } catch(e) {
	        failed++;
	        try { // try second time to fix issue with Chrome 77 https://github.com/plotly/plotly.js/issues/4233
	            scene.glplot = createPlot(glplotOptions);
	        } catch(e) {
	            failed++;
	        }
	    }
	
	    return failed < 2;
	}
	
	function initializeGLPlot(scene, canvas, gl) {
	    scene.initializeGLCamera();
	
	    var success = tryCreatePlot(scene, scene.camera, scene.pixelRatio, canvas, gl);
	    /*
	    * createPlot will throw when webgl is not enabled in the client.
	    * Lets return an instance of the module with all functions noop'd.
	    * The destroy method - which will remove the container from the DOM
	    * is overridden with a function that removes the container only.
	    */
	    if(!success) return showNoWebGlMsg(scene);
	
	    var gd = scene.graphDiv;
	    var layout = gd.layout;
	
	    var makeUpdate = function() {
	        var update = {};
	
	        if(scene.isCameraChanged(layout)) {
	            // camera updates
	            update[scene.id + '.camera'] = scene.getCamera();
	        }
	
	        if(scene.isAspectChanged(layout)) {
	            // scene updates
	            update[scene.id + '.aspectratio'] = scene.glplot.getAspectratio();
	        }
	
	        return update;
	    };
	
	    var relayoutCallback = function(scene) {
	        if(scene.fullSceneLayout.dragmode === false) return;
	
	        var update = makeUpdate();
	        scene.saveLayout(layout);
	        scene.graphDiv.emit('plotly_relayout', update);
	    };
	
	    scene.glplot.canvas.addEventListener('mouseup', function() {
	        relayoutCallback(scene);
	    });
	
	    scene.glplot.canvas.addEventListener('wheel', function(e) {
	        if(gd._context._scrollZoom.gl3d) {
	            if(scene.glplot.camera._ortho) {
	                var s = (e.deltaX > e.deltaY) ? 1.1 : 1.0 / 1.1;
	                var o = scene.glplot.getAspectratio();
	                scene.glplot.setAspectratio({
	                    x: s * o.x,
	                    y: s * o.y,
	                    z: s * o.z
	                });
	            }
	
	            relayoutCallback(scene);
	        }
	    }, passiveSupported ? {passive: false} : false);
	
	    scene.glplot.canvas.addEventListener('mousemove', function() {
	        if(scene.fullSceneLayout.dragmode === false) return;
	        if(scene.camera.mouseListener.buttons === 0) return;
	
	        var update = makeUpdate();
	        scene.graphDiv.emit('plotly_relayouting', update);
	    });
	
	    if(!scene.staticMode) {
	        scene.glplot.canvas.addEventListener('webglcontextlost', function(event) {
	            if(gd && gd.emit) {
	                gd.emit('plotly_webglcontextlost', {
	                    event: event,
	                    layer: scene.id
	                });
	            }
	        }, false);
	    }
	
	    scene.glplot.camera = scene.camera;
	
	    scene.glplot.oncontextloss = function() {
	        scene.recoverContext();
	    };
	
	    scene.glplot.onrender = render.bind(null, scene);
	
	    // List of scene objects
	    scene.traces = {};
	
	    scene.make4thDimension();
	
	    return true;
	}
	
	function Scene(options, fullLayout) {
	    // create sub container for plot
	    var sceneContainer = document.createElement('div');
	    var plotContainer = options.container;
	
	    // keep a ref to the graph div to fire hover+click events
	    this.graphDiv = options.graphDiv;
	
	    // create SVG container for hover text
	    var svgContainer = document.createElementNS(
	        'http://www.w3.org/2000/svg',
	        'svg');
	    svgContainer.style.position = 'absolute';
	    svgContainer.style.top = svgContainer.style.left = '0px';
	    svgContainer.style.width = svgContainer.style.height = '100%';
	    svgContainer.style['z-index'] = 20;
	    svgContainer.style['pointer-events'] = 'none';
	    sceneContainer.appendChild(svgContainer);
	    this.svgContainer = svgContainer;
	
	    // Tag the container with the sceneID
	    sceneContainer.id = options.id;
	    sceneContainer.style.position = 'absolute';
	    sceneContainer.style.top = sceneContainer.style.left = '0px';
	    sceneContainer.style.width = sceneContainer.style.height = '100%';
	    plotContainer.appendChild(sceneContainer);
	
	    this.fullLayout = fullLayout;
	    this.id = options.id || 'scene';
	    this.fullSceneLayout = fullLayout[this.id];
	
	    // Saved from last call to plot()
	    this.plotArgs = [ [], {}, {} ];
	
	    /*
	     * Move this to calc step? Why does it work here?
	     */
	    this.axesOptions = createAxesOptions(fullLayout, fullLayout[this.id]);
	    this.spikeOptions = createSpikeOptions(fullLayout[this.id]);
	    this.container = sceneContainer;
	    this.staticMode = !!options.staticPlot;
	    this.pixelRatio = this.pixelRatio || options.plotGlPixelRatio || 2;
	
	    // Coordinate rescaling
	    this.dataScale = [1, 1, 1];
	
	    this.contourLevels = [ [], [], [] ];
	
	    this.convertAnnotations = Registry.getComponentMethod('annotations3d', 'convert');
	    this.drawAnnotations = Registry.getComponentMethod('annotations3d', 'draw');
	
	    initializeGLPlot(this);
	}
	
	var proto = Scene.prototype;
	
	proto.initializeGLCamera = function() {
	    var cameraData = this.fullSceneLayout.camera;
	    var isOrtho = (cameraData.projection.type === 'orthographic');
	
	    this.camera = createCamera(this.container, {
	        center: [cameraData.center.x, cameraData.center.y, cameraData.center.z],
	        eye: [cameraData.eye.x, cameraData.eye.y, cameraData.eye.z],
	        up: [cameraData.up.x, cameraData.up.y, cameraData.up.z],
	        _ortho: isOrtho,
	        zoomMin: 0.01,
	        zoomMax: 100,
	        mode: 'orbit'
	    });
	};
	
	proto.recoverContext = function() {
	    var scene = this;
	    var gl = this.glplot.gl;
	    var canvas = this.glplot.canvas;
	
	    this.glplot.dispose();
	
	    function tryRecover() {
	        if(gl.isContextLost()) {
	            requestAnimationFrame(tryRecover);
	            return;
	        }
	        if(!initializeGLPlot(scene, canvas, gl)) {
	            Lib.error('Catastrophic and unrecoverable WebGL error. Context lost.');
	            return;
	        }
	        scene.plot.apply(scene, scene.plotArgs);
	    }
	    requestAnimationFrame(tryRecover);
	};
	
	var axisProperties = [ 'xaxis', 'yaxis', 'zaxis' ];
	
	function computeTraceBounds(scene, trace, bounds) {
	    var sceneLayout = scene.fullSceneLayout;
	
	    for(var d = 0; d < 3; d++) {
	        var axisName = axisProperties[d];
	        var axLetter = axisName.charAt(0);
	        var ax = sceneLayout[axisName];
	        var coords = trace[axLetter];
	        var calendar = trace[axLetter + 'calendar'];
	        var len = trace['_' + axLetter + 'length'];
	
	        if(!Lib.isArrayOrTypedArray(coords)) {
	            bounds[0][d] = Math.min(bounds[0][d], 0);
	            bounds[1][d] = Math.max(bounds[1][d], len - 1);
	        } else {
	            var v;
	
	            for(var i = 0; i < (len || coords.length); i++) {
	                if(Lib.isArrayOrTypedArray(coords[i])) {
	                    for(var j = 0; j < coords[i].length; ++j) {
	                        v = ax.d2l(coords[i][j], 0, calendar);
	                        if(!isNaN(v) && isFinite(v)) {
	                            bounds[0][d] = Math.min(bounds[0][d], v);
	                            bounds[1][d] = Math.max(bounds[1][d], v);
	                        }
	                    }
	                } else {
	                    v = ax.d2l(coords[i], 0, calendar);
	                    if(!isNaN(v) && isFinite(v)) {
	                        bounds[0][d] = Math.min(bounds[0][d], v);
	                        bounds[1][d] = Math.max(bounds[1][d], v);
	                    }
	                }
	            }
	        }
	    }
	}
	
	function computeAnnotationBounds(scene, bounds) {
	    var sceneLayout = scene.fullSceneLayout;
	    var annotations = sceneLayout.annotations || [];
	
	    for(var d = 0; d < 3; d++) {
	        var axisName = axisProperties[d];
	        var axLetter = axisName.charAt(0);
	        var ax = sceneLayout[axisName];
	
	        for(var j = 0; j < annotations.length; j++) {
	            var ann = annotations[j];
	
	            if(ann.visible) {
	                var pos = ax.r2l(ann[axLetter]);
	                if(!isNaN(pos) && isFinite(pos)) {
	                    bounds[0][d] = Math.min(bounds[0][d], pos);
	                    bounds[1][d] = Math.max(bounds[1][d], pos);
	                }
	            }
	        }
	    }
	}
	
	proto.plot = function(sceneData, fullLayout, layout) {
	    // Save parameters
	    this.plotArgs = [sceneData, fullLayout, layout];
	
	    if(this.glplot.contextLost) return;
	
	    var data, trace;
	    var i, j, axis, axisType;
	    var fullSceneLayout = fullLayout[this.id];
	    var sceneLayout = layout[this.id];
	
	    if(fullSceneLayout.bgcolor) this.glplot.clearColor = str2RGBAarray(fullSceneLayout.bgcolor);
	    else this.glplot.clearColor = [0, 0, 0, 0];
	
	    this.glplot.snapToData = true;
	
	    // Update layout
	    this.fullLayout = fullLayout;
	    this.fullSceneLayout = fullSceneLayout;
	
	    this.glplotLayout = fullSceneLayout;
	    this.axesOptions.merge(fullLayout, fullSceneLayout);
	    this.spikeOptions.merge(fullSceneLayout);
	
	    // Update camera and camera mode
	    this.setViewport(fullSceneLayout);
	    this.updateFx(fullSceneLayout.dragmode, fullSceneLayout.hovermode);
	    this.camera.enableWheel = this.graphDiv._context._scrollZoom.gl3d;
	
	    // Update scene
	    this.glplot.update({});
	
	    // Update axes functions BEFORE updating traces
	    this.setConvert(axis);
	
	    // Convert scene data
	    if(!sceneData) sceneData = [];
	    else if(!Array.isArray(sceneData)) sceneData = [sceneData];
	
	    // Compute trace bounding box
	    var dataBounds = [
	        [Infinity, Infinity, Infinity],
	        [-Infinity, -Infinity, -Infinity]
	    ];
	
	    for(i = 0; i < sceneData.length; ++i) {
	        data = sceneData[i];
	        if(data.visible !== true || data._length === 0) continue;
	
	        computeTraceBounds(this, data, dataBounds);
	    }
	    computeAnnotationBounds(this, dataBounds);
	
	    var dataScale = [1, 1, 1];
	    for(j = 0; j < 3; ++j) {
	        if(dataBounds[1][j] === dataBounds[0][j]) {
	            dataScale[j] = 1.0;
	        } else {
	            dataScale[j] = 1.0 / (dataBounds[1][j] - dataBounds[0][j]);
	        }
	    }
	
	    // Save scale
	    this.dataScale = dataScale;
	
	    // after computeTraceBounds where ax._categories are filled in
	    this.convertAnnotations(this);
	
	    // Update traces
	    for(i = 0; i < sceneData.length; ++i) {
	        data = sceneData[i];
	        if(data.visible !== true || data._length === 0) {
	            continue;
	        }
	        trace = this.traces[data.uid];
	        if(trace) {
	            if(trace.data.type === data.type) {
	                trace.update(data);
	            } else {
	                trace.dispose();
	                trace = data._module.plot(this, data);
	                this.traces[data.uid] = trace;
	            }
	        } else {
	            trace = data._module.plot(this, data);
	            this.traces[data.uid] = trace;
	        }
	        trace.name = data.name;
	    }
	
	    // Remove empty traces
	    var traceIds = Object.keys(this.traces);
	
	    traceIdLoop:
	    for(i = 0; i < traceIds.length; ++i) {
	        for(j = 0; j < sceneData.length; ++j) {
	            if(sceneData[j].uid === traceIds[i] &&
	                (sceneData[j].visible === true && sceneData[j]._length !== 0)) {
	                continue traceIdLoop;
	            }
	        }
	        trace = this.traces[traceIds[i]];
	        trace.dispose();
	        delete this.traces[traceIds[i]];
	    }
	
	    // order object per trace index
	    this.glplot.objects.sort(function(a, b) {
	        return a._trace.data.index - b._trace.data.index;
	    });
	
	    // Update ranges (needs to be called *after* objects are added due to updates)
	    var sceneBounds = [[0, 0, 0], [0, 0, 0]];
	    var axisDataRange = [];
	    var axisTypeRatios = {};
	
	    for(i = 0; i < 3; ++i) {
	        axis = fullSceneLayout[axisProperties[i]];
	        axisType = axis.type;
	
	        if(axisType in axisTypeRatios) {
	            axisTypeRatios[axisType].acc *= dataScale[i];
	            axisTypeRatios[axisType].count += 1;
	        } else {
	            axisTypeRatios[axisType] = {
	                acc: dataScale[i],
	                count: 1
	            };
	        }
	
	        if(axis.autorange) {
	            sceneBounds[0][i] = Infinity;
	            sceneBounds[1][i] = -Infinity;
	
	            var objects = this.glplot.objects;
	            var annotations = this.fullSceneLayout.annotations || [];
	            var axLetter = axis._name.charAt(0);
	
	            for(j = 0; j < objects.length; j++) {
	                var obj = objects[j];
	                var objBounds = obj.bounds;
	                var pad = obj._trace.data._pad || 0;
	
	                if(obj.constructor.name === 'ErrorBars' && axis._lowerLogErrorBound) {
	                    sceneBounds[0][i] = Math.min(sceneBounds[0][i], axis._lowerLogErrorBound);
	                } else {
	                    sceneBounds[0][i] = Math.min(sceneBounds[0][i], objBounds[0][i] / dataScale[i] - pad);
	                }
	                sceneBounds[1][i] = Math.max(sceneBounds[1][i], objBounds[1][i] / dataScale[i] + pad);
	            }
	
	            for(j = 0; j < annotations.length; j++) {
	                var ann = annotations[j];
	
	                // N.B. not taking into consideration the arrowhead
	                if(ann.visible) {
	                    var pos = axis.r2l(ann[axLetter]);
	                    sceneBounds[0][i] = Math.min(sceneBounds[0][i], pos);
	                    sceneBounds[1][i] = Math.max(sceneBounds[1][i], pos);
	                }
	            }
	
	            if('rangemode' in axis && axis.rangemode === 'tozero') {
	                sceneBounds[0][i] = Math.min(sceneBounds[0][i], 0);
	                sceneBounds[1][i] = Math.max(sceneBounds[1][i], 0);
	            }
	            if(sceneBounds[0][i] > sceneBounds[1][i]) {
	                sceneBounds[0][i] = -1;
	                sceneBounds[1][i] = 1;
	            } else {
	                var d = sceneBounds[1][i] - sceneBounds[0][i];
	                sceneBounds[0][i] -= d / 32.0;
	                sceneBounds[1][i] += d / 32.0;
	            }
	
	            if(axis.autorange === 'reversed') {
	                // swap bounds:
	                var tmp = sceneBounds[0][i];
	                sceneBounds[0][i] = sceneBounds[1][i];
	                sceneBounds[1][i] = tmp;
	            }
	        } else {
	            var range = axis.range;
	            sceneBounds[0][i] = axis.r2l(range[0]);
	            sceneBounds[1][i] = axis.r2l(range[1]);
	        }
	        if(sceneBounds[0][i] === sceneBounds[1][i]) {
	            sceneBounds[0][i] -= 1;
	            sceneBounds[1][i] += 1;
	        }
	        axisDataRange[i] = sceneBounds[1][i] - sceneBounds[0][i];
	
	        // Update plot bounds
	        this.glplot.bounds[0][i] = sceneBounds[0][i] * dataScale[i];
	        this.glplot.bounds[1][i] = sceneBounds[1][i] * dataScale[i];
	    }
	
	    var axesScaleRatio = [1, 1, 1];
	
	    // Compute axis scale per category
	    for(i = 0; i < 3; ++i) {
	        axis = fullSceneLayout[axisProperties[i]];
	        axisType = axis.type;
	        var axisRatio = axisTypeRatios[axisType];
	        axesScaleRatio[i] = Math.pow(axisRatio.acc, 1.0 / axisRatio.count) / dataScale[i];
	    }
	
	    /*
	     * Dynamically set the aspect ratio depending on the users aspect settings
	     */
	    var axisAutoScaleFactor = 4;
	    var aspectRatio;
	
	    if(fullSceneLayout.aspectmode === 'auto') {
	        if(Math.max.apply(null, axesScaleRatio) / Math.min.apply(null, axesScaleRatio) <= axisAutoScaleFactor) {
	            /*
	             * USE DATA MODE WHEN AXIS RANGE DIMENSIONS ARE RELATIVELY EQUAL
	             */
	
	            aspectRatio = axesScaleRatio;
	        } else {
	            /*
	             * USE EQUAL MODE WHEN AXIS RANGE DIMENSIONS ARE HIGHLY UNEQUAL
	             */
	            aspectRatio = [1, 1, 1];
	        }
	    } else if(fullSceneLayout.aspectmode === 'cube') {
	        aspectRatio = [1, 1, 1];
	    } else if(fullSceneLayout.aspectmode === 'data') {
	        aspectRatio = axesScaleRatio;
	    } else if(fullSceneLayout.aspectmode === 'manual') {
	        var userRatio = fullSceneLayout.aspectratio;
	        aspectRatio = [userRatio.x, userRatio.y, userRatio.z];
	    } else {
	        throw new Error('scene.js aspectRatio was not one of the enumerated types');
	    }
	
	    /*
	     * Write aspect Ratio back to user data and fullLayout so that it is modifies as user
	     * manipulates the aspectmode settings and the fullLayout is up-to-date.
	     */
	    fullSceneLayout.aspectratio.x = sceneLayout.aspectratio.x = aspectRatio[0];
	    fullSceneLayout.aspectratio.y = sceneLayout.aspectratio.y = aspectRatio[1];
	    fullSceneLayout.aspectratio.z = sceneLayout.aspectratio.z = aspectRatio[2];
	
	    /*
	     * Finally assign the computed aspecratio to the glplot module. This will have an effect
	     * on the next render cycle.
	     */
	    this.glplot.setAspectratio(fullSceneLayout.aspectratio);
	
	    // save 'initial' camera view settings for modebar button
	    if(!this.viewInitial.aspectratio) {
	        this.viewInitial.aspectratio = {
	            x: fullSceneLayout.aspectratio.x,
	            y: fullSceneLayout.aspectratio.y,
	            z: fullSceneLayout.aspectratio.z
	        };
	    }
	
	    // Update frame position for multi plots
	    var domain = fullSceneLayout.domain || null;
	    var size = fullLayout._size || null;
	
	    if(domain && size) {
	        var containerStyle = this.container.style;
	        containerStyle.position = 'absolute';
	        containerStyle.left = (size.l + domain.x[0] * size.w) + 'px';
	        containerStyle.top = (size.t + (1 - domain.y[1]) * size.h) + 'px';
	        containerStyle.width = (size.w * (domain.x[1] - domain.x[0])) + 'px';
	        containerStyle.height = (size.h * (domain.y[1] - domain.y[0])) + 'px';
	    }
	
	    // force redraw so that promise is returned when rendering is completed
	    this.glplot.redraw();
	};
	
	proto.destroy = function() {
	    if(!this.glplot) return;
	
	    this.camera.mouseListener.enabled = false;
	    this.container.removeEventListener('wheel', this.camera.wheelListener);
	    this.camera = this.glplot.camera = null;
	    this.glplot.dispose();
	    this.container.parentNode.removeChild(this.container);
	    this.glplot = null;
	};
	
	// getCameraArrays :: plotly_coords -> gl-plot3d_coords
	// inverse of getLayoutCamera
	function getCameraArrays(camera) {
	    return [
	        [camera.eye.x, camera.eye.y, camera.eye.z],
	        [camera.center.x, camera.center.y, camera.center.z],
	        [camera.up.x, camera.up.y, camera.up.z]
	    ];
	}
	
	// getLayoutCamera :: gl-plot3d_coords -> plotly_coords
	// inverse of getCameraArrays
	function getLayoutCamera(camera) {
	    return {
	        up: {x: camera.up[0], y: camera.up[1], z: camera.up[2]},
	        center: {x: camera.center[0], y: camera.center[1], z: camera.center[2]},
	        eye: {x: camera.eye[0], y: camera.eye[1], z: camera.eye[2]},
	        projection: {type: (camera._ortho === true) ? 'orthographic' : 'perspective'}
	    };
	}
	
	// get camera position in plotly coords from 'gl-plot3d' coords
	proto.getCamera = function() {
	    this.glplot.camera.view.recalcMatrix(this.camera.view.lastT());
	    return getLayoutCamera(this.glplot.camera);
	};
	
	// set gl-plot3d camera position and scene aspects with a set of plotly coords
	proto.setViewport = function(sceneLayout) {
	    var cameraData = sceneLayout.camera;
	
	    this.glplot.camera.lookAt.apply(this, getCameraArrays(cameraData));
	    this.glplot.setAspectratio(sceneLayout.aspectratio);
	
	    var newOrtho = (cameraData.projection.type === 'orthographic');
	    var oldOrtho = this.glplot.camera._ortho;
	
	    if(newOrtho !== oldOrtho) {
	        this.glplot.redraw();
	
	        var RGBA = this.glplot.clearColor;
	        this.glplot.gl.clearColor(
	            RGBA[0], RGBA[1], RGBA[2], RGBA[3]
	        );
	        this.glplot.gl.clear(
	            this.glplot.gl.DEPTH_BUFFER_BIT |
	            this.glplot.gl.COLOR_BUFFER_BIT
	        );
	
	        this.glplot.dispose();
	
	        initializeGLPlot(this);
	        this.glplot.camera._ortho = newOrtho;
	    }
	};
	
	proto.isCameraChanged = function(layout) {
	    var cameraData = this.getCamera();
	    var cameraNestedProp = Lib.nestedProperty(layout, this.id + '.camera');
	    var cameraDataLastSave = cameraNestedProp.get();
	
	    function same(x, y, i, j) {
	        var vectors = ['up', 'center', 'eye'];
	        var components = ['x', 'y', 'z'];
	        return y[vectors[i]] && (x[vectors[i]][components[j]] === y[vectors[i]][components[j]]);
	    }
	
	    var changed = false;
	    if(cameraDataLastSave === undefined) {
	        changed = true;
	    } else {
	        for(var i = 0; i < 3; i++) {
	            for(var j = 0; j < 3; j++) {
	                if(!same(cameraData, cameraDataLastSave, i, j)) {
	                    changed = true;
	                    break;
	                }
	            }
	        }
	
	        if(!cameraDataLastSave.projection || (
	            cameraData.projection &&
	            cameraData.projection.type !== cameraDataLastSave.projection.type)) {
	            changed = true;
	        }
	    }
	
	    return changed;
	};
	
	proto.isAspectChanged = function(layout) {
	    var aspectData = this.glplot.getAspectratio();
	    var aspectNestedProp = Lib.nestedProperty(layout, this.id + '.aspectratio');
	    var aspectDataLastSave = aspectNestedProp.get();
	
	    return (
	        aspectDataLastSave === undefined || (
	        aspectDataLastSave.x !== aspectData.x ||
	        aspectDataLastSave.y !== aspectData.y ||
	        aspectDataLastSave.z !== aspectData.z
	    ));
	};
	
	// save camera to user layout (i.e. gd.layout)
	proto.saveLayout = function(layout) {
	    var fullLayout = this.fullLayout;
	
	    var cameraData;
	    var cameraNestedProp;
	    var cameraDataLastSave;
	
	    var aspectData;
	    var aspectNestedProp;
	    var aspectDataLastSave;
	
	    var cameraChanged = this.isCameraChanged(layout);
	    var aspectChanged = this.isAspectChanged(layout);
	
	    var hasChanged = cameraChanged || aspectChanged;
	    if(hasChanged) {
	        var preGUI = {};
	        if(cameraChanged) {
	            cameraData = this.getCamera();
	            cameraNestedProp = Lib.nestedProperty(layout, this.id + '.camera');
	            cameraDataLastSave = cameraNestedProp.get();
	
	            preGUI[this.id + '.camera'] = cameraDataLastSave;
	        }
	        if(aspectChanged) {
	            aspectData = this.glplot.getAspectratio();
	            aspectNestedProp = Lib.nestedProperty(layout, this.id + '.aspectratio');
	            aspectDataLastSave = aspectNestedProp.get();
	
	            preGUI[this.id + '.aspectratio'] = aspectDataLastSave;
	        }
	        Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
	
	        if(cameraChanged) {
	            cameraNestedProp.set(cameraData);
	
	            var cameraFullNP = Lib.nestedProperty(fullLayout, this.id + '.camera');
	            cameraFullNP.set(cameraData);
	        }
	
	        if(aspectChanged) {
	            aspectNestedProp.set(aspectData);
	
	            var aspectFullNP = Lib.nestedProperty(fullLayout, this.id + '.aspectratio');
	            aspectFullNP.set(aspectData);
	
	            this.glplot.redraw();
	        }
	    }
	
	    return hasChanged;
	};
	
	proto.updateFx = function(dragmode, hovermode) {
	    var camera = this.camera;
	    if(camera) {
	        // rotate and orbital are synonymous
	        if(dragmode === 'orbit') {
	            camera.mode = 'orbit';
	            camera.keyBindingMode = 'rotate';
	        } else if(dragmode === 'turntable') {
	            camera.up = [0, 0, 1];
	            camera.mode = 'turntable';
	            camera.keyBindingMode = 'rotate';
	
	            // The setter for camera.mode animates the transition to z-up,
	            // but only if we *don't* explicitly set z-up earlier via the
	            // relayout. So push `up` back to layout & fullLayout manually now.
	            var gd = this.graphDiv;
	            var fullLayout = gd._fullLayout;
	            var fullCamera = this.fullSceneLayout.camera;
	            var x = fullCamera.up.x;
	            var y = fullCamera.up.y;
	            var z = fullCamera.up.z;
	            // only push `up` back to (full)layout if it's going to change
	            if(z / Math.sqrt(x * x + y * y + z * z) < 0.999) {
	                var attr = this.id + '.camera.up';
	                var zUp = {x: 0, y: 0, z: 1};
	                var edits = {};
	                edits[attr] = zUp;
	                var layout = gd.layout;
	                Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, edits);
	                fullCamera.up = zUp;
	                Lib.nestedProperty(layout, attr).set(zUp);
	            }
	        } else {
	            // none rotation modes [pan or zoom]
	            camera.keyBindingMode = dragmode;
	        }
	    }
	
	    // to put dragmode and hovermode on the same grounds from relayout
	    this.fullSceneLayout.hovermode = hovermode;
	};
	
	proto.toImage = function(format) {
	    if(!format) format = 'png';
	
	    if(this.staticMode) this.container.appendChild(STATIC_CANVAS);
	
	    // Force redraw
	    this.glplot.redraw();
	
	    // Grab context and yank out pixels
	    var gl = this.glplot.gl;
	    var w = gl.drawingBufferWidth;
	    var h = gl.drawingBufferHeight;
	
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	    var pixels = new Uint8Array(w * h * 4);
	    gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
	
	    // Flip pixels
	    for(var j = 0, k = h - 1; j < k; ++j, --k) {
	        for(var i = 0; i < w; ++i) {
	            for(var l = 0; l < 4; ++l) {
	                var tmp = pixels[4 * (w * j + i) + l];
	                pixels[4 * (w * j + i) + l] = pixels[4 * (w * k + i) + l];
	                pixels[4 * (w * k + i) + l] = tmp;
	            }
	        }
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = w;
	    canvas.height = h;
	    var context = canvas.getContext('2d');
	    var imageData = context.createImageData(w, h);
	    imageData.data.set(pixels);
	    context.putImageData(imageData, 0, 0);
	
	    var dataURL;
	
	    switch(format) {
	        case 'jpeg':
	            dataURL = canvas.toDataURL('image/jpeg');
	            break;
	        case 'webp':
	            dataURL = canvas.toDataURL('image/webp');
	            break;
	        default:
	            dataURL = canvas.toDataURL('image/png');
	    }
	
	    if(this.staticMode) this.container.removeChild(STATIC_CANVAS);
	
	    return dataURL;
	};
	
	proto.setConvert = function() {
	    for(var i = 0; i < 3; i++) {
	        var ax = this.fullSceneLayout[axisProperties[i]];
	        Axes.setConvert(ax, this.fullLayout);
	        ax.setScale = Lib.noop;
	    }
	};
	
	proto.make4thDimension = function() {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var fullLayout = gd._fullLayout;
	
	    // mock axis for hover formatting
	    _this.mockAxis = {
	        type: 'linear',
	        showexponent: 'all',
	        exponentformat: 'B'
	    };
	    Axes.setConvert(_this.mockAxis, fullLayout);
	};
	
	module.exports = Scene;
	
	},{"../../components/fx":629,"../../lib":716,"../../lib/show_no_webgl_msg":737,"../../lib/str2rgbarray":739,"../../plots/cartesian/axes":764,"../../registry":845,"./layout/convert":808,"./layout/spikes":811,"./layout/tick_marks":812,"./project":813,"gl-plot3d":292,"has-passive-events":412,"webgl-context":554}],815:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function zip3(x, y, z, len) {
	    len = len || x.length;
	
	    var result = new Array(len);
	    for(var i = 0; i < len; i++) {
	        result[i] = [x[i], y[i], z[i]];
	    }
	    return result;
	};
	
	},{}],816:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('./font_attributes');
	var animationAttrs = _dereq_('./animation_attributes');
	var colorAttrs = _dereq_('../components/color/attributes');
	var padAttrs = _dereq_('./pad_attributes');
	var extendFlat = _dereq_('../lib/extend').extendFlat;
	
	var globalFont = fontAttrs({
	    editType: 'calc',
	    
	});
	globalFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
	globalFont.size.dflt = 12;
	globalFont.color.dflt = colorAttrs.defaultLine;
	
	module.exports = {
	    font: globalFont,
	    title: {
	        text: {
	            valType: 'string',
	            
	            editType: 'layoutstyle',
	            
	        },
	        font: fontAttrs({
	            editType: 'layoutstyle',
	            
	        }),
	        xref: {
	            valType: 'enumerated',
	            dflt: 'container',
	            values: ['container', 'paper'],
	            
	            editType: 'layoutstyle',
	            
	        },
	        yref: {
	            valType: 'enumerated',
	            dflt: 'container',
	            values: ['container', 'paper'],
	            
	            editType: 'layoutstyle',
	            
	        },
	        x: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            dflt: 0.5,
	            
	            editType: 'layoutstyle',
	            
	        },
	        y: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            dflt: 'auto',
	            
	            editType: 'layoutstyle',
	            
	        },
	        xanchor: {
	            valType: 'enumerated',
	            dflt: 'auto',
	            values: ['auto', 'left', 'center', 'right'],
	            
	            editType: 'layoutstyle',
	            
	        },
	        yanchor: {
	            valType: 'enumerated',
	            dflt: 'auto',
	            values: ['auto', 'top', 'middle', 'bottom'],
	            
	            editType: 'layoutstyle',
	            
	        },
	        pad: extendFlat(padAttrs({editType: 'layoutstyle'}), {
	            
	        }),
	        editType: 'layoutstyle'
	    },
	    autosize: {
	        valType: 'boolean',
	        
	        dflt: false,
	        // autosize, width, and height get special editType treatment in _relayout
	        // so we can handle noop resizes more efficiently
	        editType: 'none',
	        
	    },
	    width: {
	        valType: 'number',
	        
	        min: 10,
	        dflt: 700,
	        editType: 'plot',
	        
	    },
	    height: {
	        valType: 'number',
	        
	        min: 10,
	        dflt: 450,
	        editType: 'plot',
	        
	    },
	    margin: {
	        l: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 80,
	            editType: 'plot',
	            
	        },
	        r: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 80,
	            editType: 'plot',
	            
	        },
	        t: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 100,
	            editType: 'plot',
	            
	        },
	        b: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 80,
	            editType: 'plot',
	            
	        },
	        pad: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 0,
	            editType: 'plot',
	            
	        },
	        autoexpand: {
	            valType: 'boolean',
	            
	            dflt: true,
	            editType: 'plot',
	            
	        },
	        editType: 'plot'
	    },
	    paper_bgcolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.background,
	        editType: 'plot',
	        
	    },
	    plot_bgcolor: {
	        // defined here, but set in cartesian.supplyLayoutDefaults
	        // because it needs to know if there are (2D) axes or not
	        valType: 'color',
	        
	        dflt: colorAttrs.background,
	        editType: 'layoutstyle',
	        
	    },
	    separators: {
	        valType: 'string',
	        
	        editType: 'plot',
	        
	    },
	    hidesources: {
	        valType: 'boolean',
	        
	        dflt: false,
	        editType: 'plot',
	        
	    },
	    showlegend: {
	        // handled in legend.supplyLayoutDefaults
	        // but included here because it's not in the legend object
	        valType: 'boolean',
	        
	        editType: 'legend',
	        
	    },
	    colorway: {
	        valType: 'colorlist',
	        dflt: colorAttrs.defaults,
	        
	        editType: 'calc',
	        
	    },
	    datarevision: {
	        valType: 'any',
	        
	        editType: 'calc',
	        
	    },
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    editrevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    selectionrevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	    template: {
	        valType: 'any',
	        
	        editType: 'calc',
	        
	    },
	    modebar: {
	        orientation: {
	            valType: 'enumerated',
	            values: ['v', 'h'],
	            dflt: 'h',
	            
	            editType: 'modebar',
	            
	        },
	        bgcolor: {
	            valType: 'color',
	            
	            editType: 'modebar',
	            
	        },
	        color: {
	            valType: 'color',
	            
	            editType: 'modebar',
	            
	        },
	        activecolor: {
	            valType: 'color',
	            
	            editType: 'modebar',
	            
	        },
	        uirevision: {
	            valType: 'any',
	            
	            editType: 'none',
	            
	        },
	        editType: 'modebar'
	    },
	
	    meta: {
	        valType: 'any',
	        arrayOk: true,
	        
	        editType: 'plot',
	        
	    },
	
	    transition: extendFlat({}, animationAttrs.transition, {
	        
	        editType: 'none'
	    }),
	    _deprecated: {
	        title: {
	            valType: 'string',
	            
	            editType: 'layoutstyle',
	            
	        },
	        titlefont: fontAttrs({
	            editType: 'layoutstyle',
	            
	        })
	    }
	};
	
	},{"../components/color/attributes":590,"../lib/extend":707,"./animation_attributes":759,"./font_attributes":790,"./pad_attributes":824}],817:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var requiredVersion = '1.3.2';
	
	var stylesNonMapbox = {
	    'open-street-map': {
	        id: 'osm',
	        version: 8,
	        sources: {
	            'plotly-osm-tiles': {
	                type: 'raster',
	                attribution: '<a href="http://www.openstreetmap.org/about/" target="_blank">© OpenStreetMap</a>',
	                tiles: [
	                    'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
	                    'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
	                ],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-osm-tiles',
	            type: 'raster',
	            source: 'plotly-osm-tiles',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'white-bg': {
	        id: 'white-bg',
	        version: 8,
	        sources: {},
	        layers: [{
	            id: 'white-bg',
	            type: 'background',
	            paint: {'background-color': '#FFFFFF'},
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'carto-positron': {
	        id: 'carto-positron',
	        version: 8,
	        sources: {
	            'plotly-carto-positron': {
	                type: 'raster',
	                attribution: '<a href="https://carto.com/" target="_blank">© CARTO</a>',
	                tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-carto-positron',
	            type: 'raster',
	            source: 'plotly-carto-positron',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'carto-darkmatter': {
	        id: 'carto-darkmatter',
	        version: 8,
	        sources: {
	            'plotly-carto-darkmatter': {
	                type: 'raster',
	                attribution: '<a href="https://carto.com/" target="_blank">© CARTO</a>',
	                tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-carto-darkmatter',
	            type: 'raster',
	            source: 'plotly-carto-darkmatter',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'stamen-terrain': {
	        id: 'stamen-terrain',
	        version: 8,
	        sources: {
	            'plotly-stamen-terrain': {
	                type: 'raster',
	                attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.',
	                tiles: ['https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png'],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-stamen-terrain',
	            type: 'raster',
	            source: 'plotly-stamen-terrain',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'stamen-toner': {
	        id: 'stamen-toner',
	        version: 8,
	        sources: {
	            'plotly-stamen-toner': {
	                type: 'raster',
	                attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.',
	                tiles: ['https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png'],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-stamen-toner',
	            type: 'raster',
	            source: 'plotly-stamen-toner',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    },
	    'stamen-watercolor': {
	        id: 'stamen-watercolor',
	        version: 8,
	        sources: {
	            'plotly-stamen-watercolor': {
	                type: 'raster',
	                attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>.',
	                tiles: ['https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png'],
	                tileSize: 256
	            }
	        },
	        layers: [{
	            id: 'plotly-stamen-watercolor',
	            type: 'raster',
	            source: 'plotly-stamen-watercolor',
	            minzoom: 0,
	            maxzoom: 22
	        }]
	    }
	};
	
	var styleValuesNonMapbox = Object.keys(stylesNonMapbox);
	
	module.exports = {
	    requiredVersion: requiredVersion,
	
	    styleUrlPrefix: 'mapbox://styles/mapbox/',
	    styleUrlSuffix: 'v9',
	
	    styleValuesMapbox: ['basic', 'streets', 'outdoors', 'light', 'dark', 'satellite', 'satellite-streets'],
	    styleValueDflt: 'basic',
	    stylesNonMapbox: stylesNonMapbox,
	    styleValuesNonMapbox: styleValuesNonMapbox,
	
	    traceLayerPrefix: 'plotly-trace-layer-',
	    layoutLayerPrefix: 'plotly-layout-layer-',
	
	    wrongVersionErrorMsg: [
	        'Your custom plotly.js bundle is not using the correct mapbox-gl version',
	        'Please install mapbox-gl@' + requiredVersion + '.'
	    ].join('\n'),
	
	    noAccessTokenErrorMsg: [
	        'Missing Mapbox access token.',
	        'Mapbox trace type require a Mapbox access token to be registered.',
	        'For example:',
	        '  Plotly.plot(gd, data, layout, { mapboxAccessToken: \'my-access-token\' });',
	        'More info here: https://www.mapbox.com/help/define-access-token/'
	    ].join('\n'),
	
	    missingStyleErrorMsg: [
	        'No valid mapbox style found, please set `mapbox.style` to one of:',
	        styleValuesNonMapbox.join(', '),
	        'or register a Mapbox access token to use a Mapbox-served style.'
	    ].join('\n'),
	
	    multipleTokensErrorMsg: [
	        'Set multiple mapbox access token across different mapbox subplot,',
	        'using first token found as mapbox-gl does not allow multiple' +
	        'access tokens on the same page.'
	    ].join('\n'),
	
	    mapOnErrorMsg: 'Mapbox error.',
	
	    // Mapbox logo for static export
	    mapboxLogo: {
	        path0: 'm 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z',
	        path1: 'M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z',
	        path2: 'M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z',
	        polygon: '11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34'
	    },
	
	    // a subset of node_modules/mapbox-gl/dist/mapbox-gl.css
	    styleRules: {
	        map: 'overflow:hidden;position:relative;',
	        'missing-css': 'display:none;',
	        'canary': 'background-color:salmon;',
	
	        // Reusing CSS directives from: https://api.tiles.mapbox.com/mapbox-gl-js/v1.1.1/mapbox-gl.css
	        'ctrl-bottom-left': 'position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;',
	        'ctrl-bottom-right': 'position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;',
	        'ctrl': 'clear: both; pointer-events: auto; transform: translate(0, 0);',
	
	        // Compact ctrl
	        'ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner': 'display: none;',
	        'ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner': 'display: block; margin-top:2px',
	        'ctrl-attrib.mapboxgl-compact:hover': 'padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;',
	        'ctrl-attrib.mapboxgl-compact::after': 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
	        'ctrl-attrib.mapboxgl-compact': 'min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;',
	        'ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; right: 0',
	        'ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; left: 0',
	
	        'ctrl-bottom-left .mapboxgl-ctrl': 'margin: 0 0 10px 10px; float: left;',
	        'ctrl-bottom-right .mapboxgl-ctrl': 'margin: 0 10px 10px 0; float: right;',
	
	        'ctrl-attrib': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
	        'ctrl-attrib a': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
	        'ctrl-attrib a:hover': 'color: inherit; text-decoration: underline;',
	
	        'ctrl-attrib .mapbox-improve-map': 'font-weight: bold; margin-left: 2px;',
	        'attrib-empty': 'display: none;',
	
	        // Compact Mapbox logo without text
	        'ctrl-logo': 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'
	
	        // Mapbox logo WITH text below (commented out for now)
	        // 'ctrl-logo': 'width: 85px; height: 21px; margin: 0 0 -3px -3px; display: block; background-repeat: no-repeat; cursor: pointer; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E%3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84.49 21" style="enable-background:new 0 0 84.49 21;" xml:space="preserve"%3E%3Cg%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M83.25,14.26c0,0.12-0.09,0.21-0.21,0.21h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39l-1.44,2.39 c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68L76.2,6.84 c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.4-2.35 c0.06-0.11,0.18-0.17,0.3-0.17H83c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.37,3.63l2.43,3.67 C83.24,14.18,83.25,14.22,83.25,14.26z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M66.24,9.59c-0.39-1.88-1.96-3.28-3.84-3.28c-1.03,0-2.03,0.42-2.73,1.18V3.51c0-0.13-0.1-0.23-0.23-0.23h-1.4 c-0.13,0-0.23,0.11-0.23,0.23v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.11,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.73,1.18 c1.88,0,3.45-1.41,3.84-3.29C66.37,10.79,66.37,10.18,66.24,9.59L66.24,9.59z M62.08,13c-1.32,0-2.39-1.11-2.41-2.48v-0.06 c0.02-1.38,1.09-2.48,2.41-2.48s2.42,1.12,2.42,2.51S63.41,13,62.08,13z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M71.67,6.32c-1.98-0.01-3.72,1.35-4.16,3.29c-0.13,0.59-0.13,1.19,0,1.77c0.44,1.94,2.17,3.32,4.17,3.3 c2.35,0,4.26-1.87,4.26-4.19S74.04,6.32,71.67,6.32z M71.65,13.01c-1.33,0-2.42-1.12-2.42-2.51s1.08-2.52,2.42-2.52 c1.33,0,2.42,1.12,2.42,2.51S72.99,13,71.65,13.01L71.65,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M62.08,7.98c-1.32,0-2.39,1.11-2.41,2.48v0.06C59.68,11.9,60.75,13,62.08,13s2.42-1.12,2.42-2.51 S63.41,7.98,62.08,7.98z M62.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25 c0.63,0,1.17,0.57,1.17,1.27C63.24,11.2,62.73,11.76,62.08,11.76z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M71.65,7.98c-1.33,0-2.42,1.12-2.42,2.51S70.32,13,71.65,13s2.42-1.12,2.42-2.51S72.99,7.98,71.65,7.98z M71.65,11.76c-0.64,0-1.17-0.57-1.17-1.27c0-0.7,0.53-1.26,1.17-1.26s1.17,0.57,1.17,1.27C72.82,11.21,72.29,11.76,71.65,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M45.74,6.53h-1.4c-0.13,0-0.23,0.11-0.23,0.23v0.73c-0.71-0.75-1.7-1.18-2.73-1.18 c-2.17,0-3.94,1.87-3.94,4.19s1.77,4.19,3.94,4.19c1.04,0,2.03-0.43,2.73-1.19v0.73c0,0.13,0.1,0.23,0.23,0.23h1.4 c0.13,0,0.23-0.11,0.23-0.23V6.74c0-0.12-0.09-0.22-0.22-0.22C45.75,6.53,45.75,6.53,45.74,6.53z M44.12,10.53 C44.11,11.9,43.03,13,41.71,13s-2.42-1.12-2.42-2.51s1.08-2.52,2.4-2.52c1.33,0,2.39,1.11,2.41,2.48L44.12,10.53z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M41.71,7.98c-1.33,0-2.42,1.12-2.42,2.51S40.37,13,41.71,13s2.39-1.11,2.41-2.48v-0.06 C44.1,9.09,43.03,7.98,41.71,7.98z M40.55,10.49c0-0.7,0.52-1.27,1.17-1.27c0.64,0,1.14,0.56,1.17,1.25v0.04 c-0.01,0.68-0.53,1.24-1.17,1.24C41.08,11.75,40.55,11.19,40.55,10.49z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M52.41,6.32c-1.03,0-2.03,0.42-2.73,1.18V6.75c0-0.13-0.1-0.23-0.23-0.23h-1.4c-0.13,0-0.23,0.11-0.23,0.23 v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.1,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.74,1.18c2.17,0,3.94-1.87,3.94-4.19 S54.58,6.32,52.41,6.32z M52.08,13.01c-1.32,0-2.39-1.11-2.42-2.48v-0.07c0.02-1.38,1.09-2.49,2.4-2.49c1.32,0,2.41,1.12,2.41,2.51 S53.4,13,52.08,13.01L52.08,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M52.08,7.98c-1.32,0-2.39,1.11-2.42,2.48v0.06c0.03,1.38,1.1,2.48,2.42,2.48s2.41-1.12,2.41-2.51 S53.4,7.98,52.08,7.98z M52.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25c0.63,0,1.17,0.58,1.17,1.27 S52.72,11.76,52.08,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M36.08,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68c0-0.98-0.74-1.71-1.62-1.71 c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.11,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V6.74 c0.01-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03c1.09,0,2.09,0.6,2.6,1.55 c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78L36.08,14.24z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M84.34,13.59l-0.07-0.13l-1.96-2.99l1.94-2.95c0.44-0.67,0.26-1.56-0.41-2.02c-0.02,0-0.03,0-0.04-0.01 c-0.23-0.15-0.5-0.22-0.78-0.22h-1.61c-0.56,0-1.08,0.29-1.37,0.78L79.72,6.6l-0.34-0.56C79.09,5.56,78.57,5.27,78,5.27h-1.6 c-0.6,0-1.13,0.37-1.35,0.92c-2.19-1.66-5.28-1.47-7.26,0.45c-0.35,0.34-0.65,0.72-0.89,1.14c-0.9-1.62-2.58-2.72-4.5-2.72 c-0.5,0-1.01,0.07-1.48,0.23V3.51c0-0.82-0.66-1.48-1.47-1.48h-1.4c-0.81,0-1.47,0.66-1.47,1.47v3.75 c-0.95-1.36-2.5-2.18-4.17-2.19c-0.74,0-1.46,0.16-2.12,0.47c-0.24-0.17-0.54-0.26-0.84-0.26h-1.4c-0.45,0-0.87,0.21-1.15,0.56 c-0.02-0.03-0.04-0.05-0.07-0.08c-0.28-0.3-0.68-0.47-1.09-0.47h-1.39c-0.3,0-0.6,0.09-0.84,0.26c-0.67-0.3-1.39-0.46-2.12-0.46 c-1.83,0-3.43,1-4.37,2.5c-0.2-0.46-0.48-0.89-0.83-1.25c-0.8-0.81-1.89-1.25-3.02-1.25h-0.01c-0.89,0.01-1.75,0.33-2.46,0.88 c-0.74-0.57-1.64-0.88-2.57-0.88H28.1c-0.29,0-0.58,0.03-0.86,0.11c-0.28,0.06-0.56,0.16-0.82,0.28c-0.21-0.12-0.45-0.18-0.7-0.18 h-1.4c-0.82,0-1.47,0.66-1.47,1.47v7.5c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.48-0.66,1.48-1.48l0,0V9.79 c0.03-0.36,0.23-0.59,0.36-0.59c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41c0.82,0,1.47-0.66,1.47-1.47 l-0.01-4.57c0.06-0.32,0.25-0.47,0.35-0.47c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41 c0.82,0,1.47-0.66,1.47-1.47v-0.38c0.96,1.29,2.46,2.06,4.06,2.06c0.74,0,1.46-0.16,2.12-0.47c0.24,0.17,0.54,0.26,0.84,0.26h1.39 c0.3,0,0.6-0.09,0.84-0.26v2.01c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.47-0.66,1.47-1.47v-1.77c0.48,0.15,0.99,0.23,1.49,0.22 c1.7,0,3.22-0.87,4.17-2.2v0.52c0,0.82,0.66,1.47,1.47,1.47h1.4c0.3,0,0.6-0.09,0.84-0.26c0.66,0.31,1.39,0.47,2.12,0.47 c1.92,0,3.6-1.1,4.49-2.73c1.54,2.65,4.95,3.53,7.58,1.98c0.18-0.11,0.36-0.22,0.53-0.36c0.22,0.55,0.76,0.91,1.35,0.9H78 c0.56,0,1.08-0.29,1.37-0.78l0.37-0.61l0.37,0.61c0.29,0.48,0.81,0.78,1.38,0.78h1.6c0.81,0,1.46-0.66,1.45-1.46 C84.49,14.02,84.44,13.8,84.34,13.59L84.34,13.59z M35.86,14.47h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23 V9.68c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23 V6.74c0.01-0.13,0.11-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03 c1.09,0,2.09,0.6,2.6,1.55c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78l0.01,5.16C36.09,14.36,35.98,14.46,35.86,14.47 L35.86,14.47z M45.97,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V13.5c-0.7,0.76-1.69,1.18-2.72,1.18 c-2.17,0-3.94-1.87-3.94-4.19s1.77-4.19,3.94-4.19c1.03,0,2.02,0.43,2.73,1.18V6.74c0-0.13,0.1-0.23,0.23-0.23h1.4 c0.12-0.01,0.22,0.08,0.23,0.21c0,0.01,0,0.01,0,0.02v7.51h-0.01V14.24z M52.41,14.67c-1.03,0-2.02-0.43-2.73-1.18v3.97 c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.1-0.23-0.23V6.75c0-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.23,0.11,0.23,0.23v0.73 c0.71-0.76,1.7-1.18,2.73-1.18c2.17,0,3.94,1.86,3.94,4.18S54.58,14.67,52.41,14.67z M66.24,11.39c-0.39,1.87-1.96,3.29-3.84,3.29 c-1.03,0-2.02-0.43-2.73-1.18v0.73c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V3.51c0-0.13,0.1-0.23,0.23-0.23 h1.4c0.13,0,0.23,0.11,0.23,0.23v3.97c0.71-0.75,1.7-1.18,2.73-1.17c1.88,0,3.45,1.4,3.84,3.28C66.37,10.19,66.37,10.8,66.24,11.39 L66.24,11.39L66.24,11.39z M71.67,14.68c-2,0.01-3.73-1.35-4.17-3.3c-0.13-0.59-0.13-1.19,0-1.77c0.44-1.94,2.17-3.31,4.17-3.3 c2.36,0,4.26,1.87,4.26,4.19S74.03,14.68,71.67,14.68L71.67,14.68z M83.04,14.47h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39 l-1.44,2.39c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68 L76.2,6.84c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.41-2.36 c0.06-0.11,0.18-0.17,0.3-0.17h1.61c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.38,3.64l2.43,3.67 c0.02,0.03,0.03,0.07,0.03,0.12C83.25,14.38,83.16,14.47,83.04,14.47L83.04,14.47L83.04,14.47z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M10.5,1.24c-5.11,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25s9.25-4.15,9.25-9.25 C19.75,5.38,15.61,1.24,10.5,1.24z M14.89,12.77c-1.93,1.93-4.78,2.31-6.7,2.31c-0.7,0-1.41-0.05-2.1-0.16c0,0-1.02-5.64,2.14-8.81 c0.83-0.83,1.95-1.28,3.13-1.28c1.27,0,2.49,0.51,3.39,1.42C16.59,8.09,16.64,11,14.89,12.77z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M10.5-0.01C4.7-0.01,0,4.7,0,10.49s4.7,10.5,10.5,10.5S21,16.29,21,10.49C20.99,4.7,16.3-0.01,10.5-0.01z M10.5,19.74c-5.11,0-9.25-4.15-9.25-9.25s4.14-9.26,9.25-9.26s9.25,4.15,9.25,9.25C19.75,15.61,15.61,19.74,10.5,19.74z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M14.74,6.25C12.9,4.41,9.98,4.35,8.23,6.1c-3.16,3.17-2.14,8.81-2.14,8.81s5.64,1.02,8.81-2.14 C16.64,11,16.59,8.09,14.74,6.25z M12.47,10.34l-0.91,1.87l-0.9-1.87L8.8,9.43l1.86-0.9l0.9-1.87l0.91,1.87l1.86,0.9L12.47,10.34z"/%3E %3Cpolygon class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" points="14.33,9.43 12.47,10.34 11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 "/%3E%3C/g%3E%3C/svg%3E\');'
	    }
	};
	
	},{}],818:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	/**
	 * Convert plotly.js 'textposition' to mapbox-gl 'anchor' and 'offset'
	 * (with the help of the icon size).
	 *
	 * @param {string} textpostion : plotly.js textposition value
	 * @param {number} iconSize : plotly.js icon size (e.g. marker.size for traces)
	 *
	 * @return {object}
	 *      - anchor
	 *      - offset
	 */
	module.exports = function convertTextOpts(textposition, iconSize) {
	    var parts = textposition.split(' ');
	    var vPos = parts[0];
	    var hPos = parts[1];
	
	    // ballpack values
	    var factor = Lib.isArrayOrTypedArray(iconSize) ? Lib.mean(iconSize) : iconSize;
	    var xInc = 0.5 + (factor / 100);
	    var yInc = 1.5 + (factor / 100);
	
	    var anchorVals = ['', ''];
	    var offset = [0, 0];
	
	    switch(vPos) {
	        case 'top':
	            anchorVals[0] = 'top';
	            offset[1] = -yInc;
	            break;
	        case 'bottom':
	            anchorVals[0] = 'bottom';
	            offset[1] = yInc;
	            break;
	    }
	
	    switch(hPos) {
	        case 'left':
	            anchorVals[1] = 'right';
	            offset[0] = -xInc;
	            break;
	        case 'right':
	            anchorVals[1] = 'left';
	            offset[0] = xInc;
	            break;
	    }
	
	    // Mapbox text-anchor must be one of:
	    //  center, left, right, top, bottom,
	    //  top-left, top-right, bottom-left, bottom-right
	
	    var anchor;
	    if(anchorVals[0] && anchorVals[1]) anchor = anchorVals.join('-');
	    else if(anchorVals[0]) anchor = anchorVals[0];
	    else if(anchorVals[1]) anchor = anchorVals[1];
	    else anchor = 'center';
	
	    return { anchor: anchor, offset: offset };
	};
	
	},{"../../lib":716}],819:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var mapboxgl = _dereq_('mapbox-gl');
	
	var Lib = _dereq_('../../lib');
	var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../../components/drawing');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var Mapbox = _dereq_('./mapbox');
	
	var MAPBOX = 'mapbox';
	
	var constants = exports.constants = _dereq_('./constants');
	
	exports.name = MAPBOX;
	
	exports.attr = 'subplot';
	
	exports.idRoot = MAPBOX;
	
	exports.idRegex = exports.attrRegex = Lib.counterRegex(MAPBOX);
	
	exports.attributes = {
	    subplot: {
	        valType: 'subplotid',
	        
	        dflt: 'mapbox',
	        editType: 'calc',
	        
	    }
	};
	
	exports.layoutAttributes = _dereq_('./layout_attributes');
	
	exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
	
	exports.plot = function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var calcData = gd.calcdata;
	    var mapboxIds = fullLayout._subplots[MAPBOX];
	
	    if(mapboxgl.version !== constants.requiredVersion) {
	        throw new Error(constants.wrongVersionErrorMsg);
	    }
	
	    var accessToken = findAccessToken(gd, mapboxIds);
	    mapboxgl.accessToken = accessToken;
	
	    for(var i = 0; i < mapboxIds.length; i++) {
	        var id = mapboxIds[i];
	        var subplotCalcData = getSubplotCalcData(calcData, MAPBOX, id);
	        var opts = fullLayout[id];
	        var mapbox = opts._subplot;
	
	        if(!mapbox) {
	            mapbox = new Mapbox(gd, id);
	            fullLayout[id]._subplot = mapbox;
	        }
	
	        if(!mapbox.viewInitial) {
	            mapbox.viewInitial = {
	                center: Lib.extendFlat({}, opts.center),
	                zoom: opts.zoom,
	                bearing: opts.bearing,
	                pitch: opts.pitch
	            };
	        }
	
	        mapbox.plot(subplotCalcData, fullLayout, gd._promises);
	    }
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldMapboxKeys = oldFullLayout._subplots[MAPBOX] || [];
	
	    for(var i = 0; i < oldMapboxKeys.length; i++) {
	        var oldMapboxKey = oldMapboxKeys[i];
	
	        if(!newFullLayout[oldMapboxKey] && !!oldFullLayout[oldMapboxKey]._subplot) {
	            oldFullLayout[oldMapboxKey]._subplot.destroy();
	        }
	    }
	};
	
	exports.toSVG = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots[MAPBOX];
	    var size = fullLayout._size;
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var opts = fullLayout[subplotIds[i]];
	        var domain = opts.domain;
	        var mapbox = opts._subplot;
	
	        var imageData = mapbox.toImage('png');
	        var image = fullLayout._glimages.append('svg:image');
	
	        image.attr({
	            xmlns: xmlnsNamespaces.svg,
	            'xlink:href': imageData,
	            x: size.l + size.w * domain.x[0],
	            y: size.t + size.h * (1 - domain.y[1]),
	            width: size.w * (domain.x[1] - domain.x[0]),
	            height: size.h * (domain.y[1] - domain.y[0]),
	            preserveAspectRatio: 'none'
	        });
	
	        var subplotDiv = d3.select(opts._subplot.div);
	
	        // Append logo if visible
	        var hidden = subplotDiv.select('.mapboxgl-ctrl-logo').node().offsetParent === null;
	        if(!hidden) {
	            var logo = fullLayout._glimages.append('g');
	            logo.attr('transform', 'translate(' + (size.l + size.w * domain.x[0] + 10) + ', ' + (size.t + size.h * (1 - domain.y[0]) - 31) + ')');
	            logo.append('path')
	              .attr('d', constants.mapboxLogo.path0)
	              .style({
	                  opacity: 0.9,
	                  fill: '#ffffff',
	                  'enable-background': 'new'
	              });
	
	            logo.append('path')
	              .attr('d', constants.mapboxLogo.path1)
	              .style('opacity', 0.35)
	              .style('enable-background', 'new');
	
	            logo.append('path')
	              .attr('d', constants.mapboxLogo.path2)
	              .style('opacity', 0.35)
	              .style('enable-background', 'new');
	
	            logo.append('polygon')
	              .attr('points', constants.mapboxLogo.polygon)
	              .style({
	                  opacity: 0.9,
	                  fill: '#ffffff',
	                  'enable-background': 'new'
	              });
	        }
	
	        // Add attributions
	        var attributions = subplotDiv
	                              .select('.mapboxgl-ctrl-attrib').text()
	                              .replace('Improve this map', '');
	
	        var attributionGroup = fullLayout._glimages.append('g');
	
	        var attributionText = attributionGroup.append('text');
	        attributionText
	          .text(attributions)
	          .classed('static-attribution', true)
	          .attr({
	              'font-size': 12,
	              'font-family': 'Arial',
	              'color': 'rgba(0, 0, 0, 0.75)',
	              'text-anchor': 'end',
	              'data-unformatted': attributions
	          });
	
	        var bBox = Drawing.bBox(attributionText.node());
	
	        // Break into multiple lines twice larger than domain
	        var maxWidth = size.w * (domain.x[1] - domain.x[0]);
	        if((bBox.width > maxWidth / 2)) {
	            var multilineAttributions = attributions.split('|').join('<br>');
	            attributionText
	              .text(multilineAttributions)
	              .attr('data-unformatted', multilineAttributions)
	              .call(svgTextUtils.convertToTspans, gd);
	
	            bBox = Drawing.bBox(attributionText.node());
	        }
	        attributionText.attr('transform', 'translate(-3, ' + (-bBox.height + 8) + ')');
	
	        // Draw white rectangle behind text
	        attributionGroup
	          .insert('rect', '.static-attribution')
	          .attr({
	              x: -bBox.width - 6,
	              y: -bBox.height - 3,
	              width: bBox.width + 6,
	              height: bBox.height + 3,
	              fill: 'rgba(255, 255, 255, 0.75)'
	          });
	
	        // Scale down if larger than domain
	        var scaleRatio = 1;
	        if((bBox.width + 6) > maxWidth) scaleRatio = maxWidth / (bBox.width + 6);
	
	        var offset = [(size.l + size.w * domain.x[1]), (size.t + size.h * (1 - domain.y[0]))];
	        attributionGroup.attr('transform', 'translate(' + offset[0] + ',' + offset[1] + ') scale(' + scaleRatio + ')');
	    }
	};
	
	// N.B. mapbox-gl only allows one accessToken to be set per page:
	// https://github.com/mapbox/mapbox-gl-js/issues/6331
	function findAccessToken(gd, mapboxIds) {
	    var fullLayout = gd._fullLayout;
	    var context = gd._context;
	
	    // special case for Mapbox Atlas users
	    if(context.mapboxAccessToken === '') return '';
	
	    var tokensUseful = [];
	    var tokensListed = [];
	    var hasOneSetMapboxStyle = false;
	    var wontWork = false;
	
	    // Take the first token we find in a mapbox subplot.
	    // These default to the context value but may be overridden.
	    for(var i = 0; i < mapboxIds.length; i++) {
	        var opts = fullLayout[mapboxIds[i]];
	        var token = opts.accesstoken;
	
	        if(isMapboxStyle(opts.style)) {
	            if(token) {
	                Lib.pushUnique(tokensUseful, token);
	            } else {
	                if(isMapboxStyle(opts._input.style)) {
	                    Lib.error('Uses Mapbox map style, but did not set an access token.');
	                    hasOneSetMapboxStyle = true;
	                }
	                wontWork = true;
	            }
	        }
	
	        if(token) {
	            Lib.pushUnique(tokensListed, token);
	        }
	    }
	
	    if(wontWork) {
	        var msg = hasOneSetMapboxStyle ?
	            constants.noAccessTokenErrorMsg :
	            constants.missingStyleErrorMsg;
	        throw new Error(msg);
	    }
	
	    if(tokensUseful.length) {
	        if(tokensUseful.length > 1) {
	            Lib.warn(constants.multipleTokensErrorMsg);
	        }
	        return tokensUseful[0];
	    } else {
	        if(tokensListed.length) {
	            Lib.log([
	                'Listed mapbox access token(s)', tokensListed.join(','),
	                'but did not use a Mapbox map style, ignoring token(s).'
	            ].join(' '));
	        }
	        return '';
	    }
	}
	
	function isMapboxStyle(s) {
	    return typeof s === 'string' && (
	        constants.styleValuesMapbox.indexOf(s) !== -1 ||
	        s.indexOf('mapbox://') === 0
	    );
	}
	
	exports.updateFx = function(gd) {
	    var fullLayout = gd._fullLayout;
	    var subplotIds = fullLayout._subplots[MAPBOX];
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var subplotObj = fullLayout[subplotIds[i]]._subplot;
	        subplotObj.updateFx(fullLayout);
	    }
	};
	
	},{"../../components/drawing":612,"../../constants/xmlns_namespaces":693,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/get_data":799,"./constants":817,"./layout_attributes":821,"./layout_defaults":822,"./mapbox":823,"d3":164,"mapbox-gl":427}],820:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var convertTextOpts = _dereq_('./convert_text_opts');
	var constants = _dereq_('./constants');
	
	function MapboxLayer(subplot, index) {
	    this.subplot = subplot;
	
	    this.uid = subplot.uid + '-' + index;
	    this.index = index;
	
	    this.idSource = 'source-' + this.uid;
	    this.idLayer = constants.layoutLayerPrefix + this.uid;
	
	    // some state variable to check if a remove/add step is needed
	    this.sourceType = null;
	    this.source = null;
	    this.layerType = null;
	    this.below = null;
	
	    // is layer currently visible
	    this.visible = false;
	}
	
	var proto = MapboxLayer.prototype;
	
	proto.update = function update(opts) {
	    if(!this.visible) {
	        // IMPORTANT: must create source before layer to not cause errors
	        this.updateSource(opts);
	        this.updateLayer(opts);
	    } else if(this.needsNewSource(opts)) {
	        // IMPORTANT: must delete layer before source to not cause errors
	        this.removeLayer();
	        this.updateSource(opts);
	        this.updateLayer(opts);
	    } else if(this.needsNewLayer(opts)) {
	        this.updateLayer(opts);
	    } else {
	        this.updateStyle(opts);
	    }
	
	    this.visible = isVisible(opts);
	};
	
	proto.needsNewSource = function(opts) {
	    // for some reason changing layer to 'fill' or 'symbol'
	    // w/o changing the source throws an exception in mapbox-gl 0.18 ;
	    // stay safe and make new source on type changes
	    return (
	        this.sourceType !== opts.sourcetype ||
	        this.source !== opts.source ||
	        this.layerType !== opts.type
	    );
	};
	
	proto.needsNewLayer = function(opts) {
	    return (
	        this.layerType !== opts.type ||
	        this.below !== this.subplot.belowLookup['layout-' + this.index]
	    );
	};
	
	proto.updateSource = function(opts) {
	    var map = this.subplot.map;
	
	    if(map.getSource(this.idSource)) map.removeSource(this.idSource);
	
	    this.sourceType = opts.sourcetype;
	    this.source = opts.source;
	
	    if(!isVisible(opts)) return;
	
	    var sourceOpts = convertSourceOpts(opts);
	
	    map.addSource(this.idSource, sourceOpts);
	};
	
	proto.updateLayer = function(opts) {
	    var subplot = this.subplot;
	    var convertedOpts = convertOpts(opts);
	
	    var below = this.subplot.belowLookup['layout-' + this.index];
	    var _below;
	
	    if(below === 'traces') {
	        var mapLayers = subplot.getMapLayers();
	
	        // find id of first plotly trace layer
	        for(var i = 0; i < mapLayers.length; i++) {
	            var layerId = mapLayers[i].id;
	            if(typeof layerId === 'string' &&
	                layerId.indexOf(constants.traceLayerPrefix) === 0
	            ) {
	                _below = layerId;
	                break;
	            }
	        }
	    } else {
	        _below = below;
	    }
	
	    this.removeLayer();
	
	    if(isVisible(opts)) {
	        subplot.addLayer({
	            id: this.idLayer,
	            source: this.idSource,
	            'source-layer': opts.sourcelayer || '',
	            type: opts.type,
	            minzoom: opts.minzoom,
	            maxzoom: opts.maxzoom,
	            layout: convertedOpts.layout,
	            paint: convertedOpts.paint
	        }, _below);
	    }
	
	    this.layerType = opts.type;
	    this.below = below;
	};
	
	proto.updateStyle = function(opts) {
	    if(isVisible(opts)) {
	        var convertedOpts = convertOpts(opts);
	        this.subplot.setOptions(this.idLayer, 'setLayoutProperty', convertedOpts.layout);
	        this.subplot.setOptions(this.idLayer, 'setPaintProperty', convertedOpts.paint);
	    }
	};
	
	proto.removeLayer = function() {
	    var map = this.subplot.map;
	    if(map.getLayer(this.idLayer)) {
	        map.removeLayer(this.idLayer);
	    }
	};
	
	proto.dispose = function() {
	    var map = this.subplot.map;
	    if(map.getLayer(this.idLayer)) map.removeLayer(this.idLayer);
	    if(map.getSource(this.idSource)) map.removeSource(this.idSource);
	};
	
	function isVisible(opts) {
	    if(!opts.visible) return false;
	
	    var source = opts.source;
	
	    if(Array.isArray(source) && source.length > 0) {
	        for(var i = 0; i < source.length; i++) {
	            if(typeof source[i] !== 'string' || source[i].length === 0) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    return Lib.isPlainObject(source) ||
	        (typeof source === 'string' && source.length > 0);
	}
	
	function convertOpts(opts) {
	    var layout = {};
	    var paint = {};
	
	    switch(opts.type) {
	        case 'circle':
	            Lib.extendFlat(paint, {
	                'circle-radius': opts.circle.radius,
	                'circle-color': opts.color,
	                'circle-opacity': opts.opacity
	            });
	            break;
	
	        case 'line':
	            Lib.extendFlat(paint, {
	                'line-width': opts.line.width,
	                'line-color': opts.color,
	                'line-opacity': opts.opacity,
	                'line-dasharray': opts.line.dash
	            });
	            break;
	
	        case 'fill':
	            Lib.extendFlat(paint, {
	                'fill-color': opts.color,
	                'fill-outline-color': opts.fill.outlinecolor,
	                'fill-opacity': opts.opacity
	
	                // no way to pass specify outline width at the moment
	            });
	            break;
	
	        case 'symbol':
	            var symbol = opts.symbol;
	            var textOpts = convertTextOpts(symbol.textposition, symbol.iconsize);
	
	            Lib.extendFlat(layout, {
	                'icon-image': symbol.icon + '-15',
	                'icon-size': symbol.iconsize / 10,
	
	                'text-field': symbol.text,
	                'text-size': symbol.textfont.size,
	                'text-anchor': textOpts.anchor,
	                'text-offset': textOpts.offset,
	                'symbol-placement': symbol.placement,
	
	                // TODO font family
	                // 'text-font': symbol.textfont.family.split(', '),
	            });
	
	            Lib.extendFlat(paint, {
	                'icon-color': opts.color,
	                'text-color': symbol.textfont.color,
	                'text-opacity': opts.opacity
	            });
	            break;
	    }
	
	    return {
	        layout: layout,
	        paint: paint
	    };
	}
	
	function convertSourceOpts(opts) {
	    var sourceType = opts.sourcetype;
	    var source = opts.source;
	    var sourceOpts = {type: sourceType};
	    var field;
	
	    if(sourceType === 'geojson') {
	        field = 'data';
	    } else if(sourceType === 'vector') {
	        field = typeof source === 'string' ? 'url' : 'tiles';
	    } else if(sourceType === 'raster') {
	        field = 'tiles';
	        sourceOpts.tileSize = 256;
	    } else if(sourceType === 'image') {
	        field = 'url';
	        sourceOpts.coordinates = opts.coordinates;
	    }
	
	    sourceOpts[field] = source;
	
	    if(opts.sourceattribution) sourceOpts.attribution = opts.sourceattribution;
	
	    return sourceOpts;
	}
	
	module.exports = function createMapboxLayer(subplot, index, opts) {
	    var mapboxLayer = new MapboxLayer(subplot, index);
	
	    mapboxLayer.update(opts);
	
	    return mapboxLayer;
	};
	
	},{"../../lib":716,"./constants":817,"./convert_text_opts":818}],821:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var defaultLine = _dereq_('../../components/color').defaultLine;
	var domainAttrs = _dereq_('../domain').attributes;
	var fontAttrs = _dereq_('../font_attributes');
	var textposition = _dereq_('../../traces/scatter/attributes').textposition;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	var constants = _dereq_('./constants');
	
	var fontAttr = fontAttrs({
	    
	});
	fontAttr.family.dflt = 'Open Sans Regular, Arial Unicode MS Regular';
	
	var attrs = module.exports = overrideAll({
	    _arrayAttrRegexps: [Lib.counterRegex('mapbox', '.layers', true)],
	
	    domain: domainAttrs({name: 'mapbox'}),
	
	    accesstoken: {
	        valType: 'string',
	        noBlank: true,
	        strict: true,
	        
	        
	    },
	    style: {
	        valType: 'any',
	        values: constants.styleValuesMapbox.concat(constants.styleValuesNonMapbox),
	        dflt: constants.styleValueDflt,
	        
	        
	    },
	
	    center: {
	        lon: {
	            valType: 'number',
	            dflt: 0,
	            
	            
	        },
	        lat: {
	            valType: 'number',
	            dflt: 0,
	            
	            
	        }
	    },
	    zoom: {
	        valType: 'number',
	        dflt: 1,
	        
	        
	    },
	    bearing: {
	        valType: 'number',
	        dflt: 0,
	        
	        
	    },
	    pitch: {
	        valType: 'number',
	        dflt: 0,
	        
	        
	    },
	
	    layers: templatedArray('layer', {
	        visible: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	        sourcetype: {
	            valType: 'enumerated',
	            values: ['geojson', 'vector', 'raster', 'image'],
	            dflt: 'geojson',
	            
	            
	        },
	
	        source: {
	            valType: 'any',
	            
	            
	        },
	
	        sourcelayer: {
	            valType: 'string',
	            dflt: '',
	            
	            
	        },
	
	        sourceattribution: {
	            valType: 'string',
	            
	            
	        },
	
	        type: {
	            valType: 'enumerated',
	            values: ['circle', 'line', 'fill', 'symbol', 'raster'],
	            dflt: 'circle',
	            
	            
	        },
	
	        coordinates: {
	            valType: 'any',
	            
	            
	        },
	
	        // attributes shared between all types
	        below: {
	            valType: 'string',
	            
	            
	        },
	        color: {
	            valType: 'color',
	            dflt: defaultLine,
	            
	            
	        },
	        opacity: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	            
	        },
	        minzoom: {
	            valType: 'number',
	            min: 0,
	            max: 24,
	            dflt: 0,
	            
	            
	        },
	        maxzoom: {
	            valType: 'number',
	            min: 0,
	            max: 24,
	            dflt: 24,
	            
	            
	        },
	
	        // type-specific style attributes
	        circle: {
	            radius: {
	                valType: 'number',
	                dflt: 15,
	                
	                
	            }
	        },
	
	        line: {
	            width: {
	                valType: 'number',
	                dflt: 2,
	                
	                
	            },
	            dash: {
	                valType: 'data_array',
	                
	                
	            }
	        },
	
	        fill: {
	            outlinecolor: {
	                valType: 'color',
	                dflt: defaultLine,
	                
	                
	            }
	        },
	
	        symbol: {
	            icon: {
	                valType: 'string',
	                dflt: 'marker',
	                
	                
	            },
	            iconsize: {
	                valType: 'number',
	                dflt: 10,
	                
	                
	            },
	            text: {
	                valType: 'string',
	                dflt: '',
	                
	                
	            },
	            placement: {
	                valType: 'enumerated',
	                values: ['point', 'line', 'line-center'],
	                dflt: 'point',
	                
	                
	            },
	            textfont: fontAttr,
	            textposition: Lib.extendFlat({}, textposition, { arrayOk: false })
	        }
	    })
	}, 'plot', 'from-root');
	
	// set uirevision outside of overrideAll so it can be `editType: 'none'`
	attrs.uirevision = {
	    valType: 'any',
	    
	    editType: 'none',
	    
	};
	
	},{"../../components/color":591,"../../lib":716,"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../../traces/scatter/attributes":1118,"../domain":789,"../font_attributes":790,"./constants":817}],822:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleSubplotDefaults = _dereq_('../subplot_defaults');
	var handleArrayContainerDefaults = _dereq_('../array_container_defaults');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	        type: 'mapbox',
	        attributes: layoutAttributes,
	        handleDefaults: handleDefaults,
	        partition: 'y',
	        accessToken: layoutOut._mapboxAccessToken
	    });
	};
	
	function handleDefaults(containerIn, containerOut, coerce, opts) {
	    coerce('accesstoken', opts.accessToken);
	    coerce('style');
	    coerce('center.lon');
	    coerce('center.lat');
	    coerce('zoom');
	    coerce('bearing');
	    coerce('pitch');
	
	    handleArrayContainerDefaults(containerIn, containerOut, {
	        name: 'layers',
	        handleItemDefaults: handleLayerDefaults
	    });
	
	    // copy ref to input container to update 'center' and 'zoom' on map move
	    containerOut._input = containerIn;
	}
	
	function handleLayerDefaults(layerIn, layerOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layerIn, layerOut, layoutAttributes.layers, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	    if(visible) {
	        var sourceType = coerce('sourcetype');
	        var mustBeRasterLayer = sourceType === 'raster' || sourceType === 'image';
	
	        coerce('source');
	        coerce('sourceattribution');
	
	        if(sourceType === 'vector') {
	            coerce('sourcelayer');
	        }
	
	        if(sourceType === 'image') {
	            coerce('coordinates');
	        }
	
	        var typeDflt;
	        if(mustBeRasterLayer) typeDflt = 'raster';
	
	        var type = coerce('type', typeDflt);
	
	        if(mustBeRasterLayer && type !== 'raster') {
	            type = layerOut.type = 'raster';
	            Lib.log('Source types *raster* and *image* must drawn *raster* layer type.');
	        }
	
	        coerce('below');
	        coerce('color');
	        coerce('opacity');
	        coerce('minzoom');
	        coerce('maxzoom');
	
	        if(type === 'circle') {
	            coerce('circle.radius');
	        }
	
	        if(type === 'line') {
	            coerce('line.width');
	            coerce('line.dash');
	        }
	
	        if(type === 'fill') {
	            coerce('fill.outlinecolor');
	        }
	
	        if(type === 'symbol') {
	            coerce('symbol.icon');
	            coerce('symbol.iconsize');
	
	            coerce('symbol.text');
	            Lib.coerceFont(coerce, 'symbol.textfont');
	            coerce('symbol.textposition');
	            coerce('symbol.placement');
	        }
	    }
	}
	
	},{"../../lib":716,"../array_container_defaults":760,"../subplot_defaults":839,"./layout_attributes":821}],823:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/* global PlotlyGeoAssets:false */
	
	var mapboxgl = _dereq_('mapbox-gl');
	var d3 = _dereq_('d3');
	
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../cartesian/axes');
	var dragElement = _dereq_('../../components/dragelement');
	var prepSelect = _dereq_('../cartesian/select').prepSelect;
	var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
	var constants = _dereq_('./constants');
	var createMapboxLayer = _dereq_('./layers');
	
	function Mapbox(gd, id) {
	    this.id = id;
	    this.gd = gd;
	
	    var fullLayout = gd._fullLayout;
	    var context = gd._context;
	
	    this.container = fullLayout._glcontainer.node();
	    this.isStatic = context.staticPlot;
	
	    // unique id for this Mapbox instance
	    this.uid = fullLayout._uid + '-' + this.id;
	
	    // create framework on instantiation for a smoother first plot call
	    this.div = null;
	    this.xaxis = null;
	    this.yaxis = null;
	    this.createFramework(fullLayout);
	
	    // state variables used to infer how and what to update
	    this.map = null;
	    this.accessToken = null;
	    this.styleObj = null;
	    this.traceHash = {};
	    this.layerList = [];
	    this.belowLookup = {};
	}
	
	var proto = Mapbox.prototype;
	
	proto.plot = function(calcData, fullLayout, promises) {
	    var self = this;
	    var opts = fullLayout[self.id];
	
	    // remove map and create a new map if access token has change
	    if(self.map && (opts.accesstoken !== self.accessToken)) {
	        self.map.remove();
	        self.map = null;
	        self.styleObj = null;
	        self.traceHash = [];
	        self.layerList = {};
	    }
	
	    var promise;
	
	    if(!self.map) {
	        promise = new Promise(function(resolve, reject) {
	            self.createMap(calcData, fullLayout, resolve, reject);
	        });
	    } else {
	        promise = new Promise(function(resolve, reject) {
	            self.updateMap(calcData, fullLayout, resolve, reject);
	        });
	    }
	
	    promises.push(promise);
	};
	
	proto.createMap = function(calcData, fullLayout, resolve, reject) {
	    var self = this;
	    var opts = fullLayout[self.id];
	
	    // store style id and URL or object
	    var styleObj = self.styleObj = getStyleObj(opts.style);
	
	    // store access token associated with this map
	    self.accessToken = opts.accesstoken;
	
	    // create the map!
	    var map = self.map = new mapboxgl.Map({
	        container: self.div,
	
	        style: styleObj.style,
	        center: convertCenter(opts.center),
	        zoom: opts.zoom,
	        bearing: opts.bearing,
	        pitch: opts.pitch,
	
	        interactive: !self.isStatic,
	        preserveDrawingBuffer: self.isStatic,
	
	        doubleClickZoom: false,
	        boxZoom: false,
	
	        attributionControl: false
	    })
	    .addControl(new mapboxgl.AttributionControl({
	        compact: true
	    }));
	
	
	    // make sure canvas does not inherit left and top css
	    map._canvas.style.left = '0px';
	    map._canvas.style.top = '0px';
	
	    self.rejectOnError(reject);
	
	    if(!self.isStatic) {
	        self.initFx(calcData, fullLayout);
	    }
	
	    var promises = [];
	
	    promises.push(new Promise(function(resolve) {
	        map.once('load', resolve);
	    }));
	
	    promises = promises.concat(self.fetchMapData(calcData, fullLayout));
	
	    Promise.all(promises).then(function() {
	        self.fillBelowLookup(calcData, fullLayout);
	        self.updateData(calcData);
	        self.updateLayout(fullLayout);
	        self.resolveOnRender(resolve);
	    }).catch(reject);
	};
	
	proto.fetchMapData = function(calcData) {
	    var promises = [];
	
	    function fetch(url) {
	        return new Promise(function(resolve, reject) {
	            d3.json(url, function(err, d) {
	                if(err) {
	                    delete PlotlyGeoAssets[url];
	                    var msg = err.status === 404 ?
	                        ('GeoJSON at URL "' + url + '" does not exist.') :
	                        ('Unexpected error while fetching from ' + url);
	                    return reject(new Error(msg));
	                }
	
	                PlotlyGeoAssets[url] = d;
	                resolve(d);
	            });
	        });
	    }
	
	    for(var i = 0; i < calcData.length; i++) {
	        var trace = calcData[i][0].trace;
	        var url = trace.geojson;
	
	        if(typeof url === 'string' && !PlotlyGeoAssets[url]) {
	            PlotlyGeoAssets[url] = 'pending';
	            promises.push(fetch(url));
	        }
	    }
	
	    return promises;
	};
	
	proto.updateMap = function(calcData, fullLayout, resolve, reject) {
	    var self = this;
	    var map = self.map;
	    var opts = fullLayout[this.id];
	
	    self.rejectOnError(reject);
	
	    var promises = [];
	    var styleObj = getStyleObj(opts.style);
	
	    if(self.styleObj.id !== styleObj.id) {
	        self.styleObj = styleObj;
	        map.setStyle(styleObj.style);
	
	        // need to rebuild trace layers on reload
	        // to avoid 'lost event' errors
	        self.traceHash = {};
	
	        promises.push(new Promise(function(resolve) {
	            map.once('styledata', resolve);
	        }));
	    }
	
	    promises = promises.concat(self.fetchMapData(calcData, fullLayout));
	
	    Promise.all(promises).then(function() {
	        self.fillBelowLookup(calcData, fullLayout);
	        self.updateData(calcData);
	        self.updateLayout(fullLayout);
	        self.resolveOnRender(resolve);
	    }).catch(reject);
	};
	
	proto.fillBelowLookup = function(calcData, fullLayout) {
	    var opts = fullLayout[this.id];
	    var layers = opts.layers;
	    var i, val;
	
	    var belowLookup = this.belowLookup = {};
	    var hasTraceAtTop = false;
	
	    for(i = 0; i < calcData.length; i++) {
	        var trace = calcData[i][0].trace;
	        var _module = trace._module;
	
	        if(typeof trace.below === 'string') {
	            val = trace.below;
	        } else if(_module.getBelow) {
	            // 'smart' default that depend the map's base layers
	            val = _module.getBelow(trace, this);
	        }
	
	        if(val === '') {
	            hasTraceAtTop = true;
	        }
	
	        belowLookup['trace-' + trace.uid] = val || '';
	    }
	
	    for(i = 0; i < layers.length; i++) {
	        var item = layers[i];
	
	        if(typeof item.below === 'string') {
	            val = item.below;
	        } else if(hasTraceAtTop) {
	            // if one or more trace(s) set `below:''` and
	            // layers[i].below is unset,
	            // place layer below traces
	            val = 'traces';
	        } else {
	            val = '';
	        }
	
	        belowLookup['layout-' + i] = val;
	    }
	
	    // N.B. If multiple layers have the 'below' value,
	    // we must clear the stashed 'below' field in order
	    // to make `traceHash[k].update()` and `layerList[i].update()`
	    // remove/add the all those layers to have preserve
	    // the correct layer ordering
	    var val2list = {};
	    var k, id;
	
	    for(k in belowLookup) {
	        val = belowLookup[k];
	        if(val2list[val]) {
	            val2list[val].push(k);
	        } else {
	            val2list[val] = [k];
	        }
	    }
	
	    for(val in val2list) {
	        var list = val2list[val];
	        if(list.length > 1) {
	            for(i = 0; i < list.length; i++) {
	                k = list[i];
	                if(k.indexOf('trace-') === 0) {
	                    id = k.split('trace-')[1];
	                    if(this.traceHash[id]) {
	                        this.traceHash[id].below = null;
	                    }
	                } else if(k.indexOf('layout-') === 0) {
	                    id = k.split('layout-')[1];
	                    if(this.layerList[id]) {
	                        this.layerList[id].below = null;
	                    }
	                }
	            }
	        }
	    }
	};
	
	var traceType2orderIndex = {
	    choroplethmapbox: 0,
	    densitymapbox: 1,
	    scattermapbox: 2
	};
	
	proto.updateData = function(calcData) {
	    var traceHash = this.traceHash;
	    var traceObj, trace, i, j;
	
	    // Need to sort here by trace type here,
	    // in case traces with different `type` have the same
	    // below value, but sorting we ensure that
	    // e.g. choroplethmapbox traces will be below scattermapbox traces
	    var calcDataSorted = calcData.slice().sort(function(a, b) {
	        return (
	            traceType2orderIndex[a[0].trace.type] -
	            traceType2orderIndex[b[0].trace.type]
	        );
	    });
	
	    // update or create trace objects
	    for(i = 0; i < calcDataSorted.length; i++) {
	        var calcTrace = calcDataSorted[i];
	
	        trace = calcTrace[0].trace;
	        traceObj = traceHash[trace.uid];
	
	        var didUpdate = false;
	        if(traceObj) {
	            if(traceObj.type === trace.type) {
	                traceObj.update(calcTrace);
	                didUpdate = true;
	            } else {
	                traceObj.dispose();
	            }
	        }
	        if(!didUpdate && trace._module) {
	            traceHash[trace.uid] = trace._module.plot(this, calcTrace);
	        }
	    }
	
	    // remove empty trace objects
	    var ids = Object.keys(traceHash);
	    idLoop:
	    for(i = 0; i < ids.length; i++) {
	        var id = ids[i];
	
	        for(j = 0; j < calcData.length; j++) {
	            trace = calcData[j][0].trace;
	            if(id === trace.uid) continue idLoop;
	        }
	
	        traceObj = traceHash[id];
	        traceObj.dispose();
	        delete traceHash[id];
	    }
	};
	
	proto.updateLayout = function(fullLayout) {
	    var map = this.map;
	    var opts = fullLayout[this.id];
	
	    map.setCenter(convertCenter(opts.center));
	    map.setZoom(opts.zoom);
	    map.setBearing(opts.bearing);
	    map.setPitch(opts.pitch);
	
	    this.updateLayers(fullLayout);
	    this.updateFramework(fullLayout);
	    this.updateFx(fullLayout);
	    this.map.resize();
	
	    if(this.gd._context._scrollZoom.mapbox) {
	        map.scrollZoom.enable();
	    } else {
	        map.scrollZoom.disable();
	    }
	};
	
	proto.resolveOnRender = function(resolve) {
	    var map = this.map;
	
	    map.on('render', function onRender() {
	        if(map.loaded()) {
	            map.off('render', onRender);
	            // resolve at end of render loop
	            //
	            // Need a 10ms delay (0ms should suffice to skip a thread in the
	            // render loop) to workaround mapbox-gl bug introduced in v1.3.0
	            setTimeout(resolve, 10);
	        }
	    });
	};
	
	proto.rejectOnError = function(reject) {
	    var map = this.map;
	
	    function handler() {
	        reject(new Error(constants.mapOnErrorMsg));
	    }
	
	    map.once('error', handler);
	    map.once('style.error', handler);
	    map.once('source.error', handler);
	    map.once('tile.error', handler);
	    map.once('layer.error', handler);
	};
	
	proto.createFramework = function(fullLayout) {
	    var self = this;
	
	    var div = self.div = document.createElement('div');
	    div.id = self.uid;
	    div.style.position = 'absolute';
	    self.container.appendChild(div);
	
	    // create mock x/y axes for hover routine
	    self.xaxis = {
	        _id: 'x',
	        c2p: function(v) { return self.project(v).x; }
	    };
	    self.yaxis = {
	        _id: 'y',
	        c2p: function(v) { return self.project(v).y; }
	    };
	
	    self.updateFramework(fullLayout);
	
	    // mock axis for hover formatting
	    self.mockAxis = {
	        type: 'linear',
	        showexponent: 'all',
	        exponentformat: 'B'
	    };
	    Axes.setConvert(self.mockAxis, fullLayout);
	};
	
	proto.initFx = function(calcData, fullLayout) {
	    var self = this;
	    var gd = self.gd;
	    var map = self.map;
	
	    var wheeling = false;
	
	    // keep track of pan / zoom in user layout and emit relayout event
	    map.on('moveend', function(evt) {
	        if(!self.map) return;
	
	        var fullLayoutNow = gd._fullLayout;
	
	        // 'moveend' gets triggered by map.setCenter, map.setZoom,
	        // map.setBearing and map.setPitch.
	        //
	        // Here, we make sure that state updates amd 'plotly_relayout'
	        // are triggered only when the 'moveend' originates from a
	        // mouse target (filtering out API calls) to not
	        // duplicate 'plotly_relayout' events.
	
	        if(evt.originalEvent || wheeling) {
	            var optsNow = fullLayoutNow[self.id];
	            Registry.call('_storeDirectGUIEdit', gd.layout, fullLayoutNow._preGUI, self.getViewEdits(optsNow));
	
	            var viewNow = self.getView();
	            optsNow._input.center = optsNow.center = viewNow.center;
	            optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
	            optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
	            optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
	
	            gd.emit('plotly_relayout', self.getViewEdits(viewNow));
	        }
	        wheeling = false;
	
	        if(fullLayoutNow._rehover) {
	            fullLayoutNow._rehover();
	        }
	    });
	
	    map.on('wheel', function() {
	        wheeling = true;
	    });
	
	    map.on('mousemove', function(evt) {
	        var bb = self.div.getBoundingClientRect();
	
	        // some hackery to get Fx.hover to work
	        evt.clientX = evt.point.x + bb.left;
	        evt.clientY = evt.point.y + bb.top;
	
	        evt.target.getBoundingClientRect = function() { return bb; };
	
	        self.xaxis.p2c = function() { return evt.lngLat.lng; };
	        self.yaxis.p2c = function() { return evt.lngLat.lat; };
	
	        gd._fullLayout._rehover = function() {
	            if(gd._fullLayout._hoversubplot === self.id && gd._fullLayout[self.id]) {
	                Fx.hover(gd, evt, self.id);
	            }
	        };
	
	        Fx.hover(gd, evt, self.id);
	        gd._fullLayout._hoversubplot = self.id;
	    });
	
	    function unhover() {
	        Fx.loneUnhover(fullLayout._hoverlayer);
	    }
	
	    map.on('dragstart', unhover);
	    map.on('zoomstart', unhover);
	
	    map.on('mouseout', function() {
	        gd._fullLayout._hoversubplot = null;
	    });
	
	    function emitUpdate() {
	        var viewNow = self.getView();
	        gd.emit('plotly_relayouting', self.getViewEdits(viewNow));
	    }
	
	    map.on('drag', emitUpdate);
	    map.on('zoom', emitUpdate);
	
	    map.on('dblclick', function() {
	        var optsNow = gd._fullLayout[self.id];
	        Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, self.getViewEdits(optsNow));
	
	        var viewInitial = self.viewInitial;
	        map.setCenter(convertCenter(viewInitial.center));
	        map.setZoom(viewInitial.zoom);
	        map.setBearing(viewInitial.bearing);
	        map.setPitch(viewInitial.pitch);
	
	        var viewNow = self.getView();
	        optsNow._input.center = optsNow.center = viewNow.center;
	        optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
	        optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
	        optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
	
	        gd.emit('plotly_doubleclick', null);
	        gd.emit('plotly_relayout', self.getViewEdits(viewNow));
	    });
	
	    // define event handlers on map creation, to keep one ref per map,
	    // so that map.on / map.off in updateFx works as expected
	    self.clearSelect = function() {
	        gd._fullLayout._zoomlayer.selectAll('.select-outline').remove();
	    };
	
	    /**
	     * Returns a click handler function that is supposed
	     * to handle clicks in pan mode.
	     */
	    self.onClickInPanFn = function(dragOptions) {
	        return function(evt) {
	            var clickMode = gd._fullLayout.clickmode;
	
	            if(clickMode.indexOf('select') > -1) {
	                selectOnClick(evt.originalEvent, gd, [self.xaxis], [self.yaxis], self.id, dragOptions);
	            }
	
	            if(clickMode.indexOf('event') > -1) {
	                // TODO: this does not support right-click. If we want to support it, we
	                // would likely need to change mapbox to use dragElement instead of straight
	                // mapbox event binding. Or perhaps better, make a simple wrapper with the
	                // right mousedown, mousemove, and mouseup handlers just for a left/right click
	                // pie would use this too.
	                Fx.click(gd, evt.originalEvent);
	            }
	        };
	    };
	};
	
	proto.updateFx = function(fullLayout) {
	    var self = this;
	    var map = self.map;
	    var gd = self.gd;
	
	    if(self.isStatic) return;
	
	    function invert(pxpy) {
	        var obj = self.map.unproject(pxpy);
	        return [obj.lng, obj.lat];
	    }
	
	    var dragMode = fullLayout.dragmode;
	    var fillRangeItems;
	
	    if(dragMode === 'select') {
	        fillRangeItems = function(eventData, poly) {
	            var ranges = eventData.range = {};
	            ranges[self.id] = [
	                invert([poly.xmin, poly.ymin]),
	                invert([poly.xmax, poly.ymax])
	            ];
	        };
	    } else {
	        fillRangeItems = function(eventData, poly, pts) {
	            var dataPts = eventData.lassoPoints = {};
	            dataPts[self.id] = pts.filtered.map(invert);
	        };
	    }
	
	    // Note: dragOptions is needed to be declared for all dragmodes because
	    // it's the object that holds persistent selection state.
	    // Merge old dragOptions with new to keep possibly initialized
	    // persistent selection state.
	    var oldDragOptions = self.dragOptions;
	    self.dragOptions = Lib.extendDeep(oldDragOptions || {}, {
	        element: self.div,
	        gd: gd,
	        plotinfo: {
	            id: self.id,
	            xaxis: self.xaxis,
	            yaxis: self.yaxis,
	            fillRangeItems: fillRangeItems
	        },
	        xaxes: [self.xaxis],
	        yaxes: [self.yaxis],
	        subplot: self.id
	    });
	
	    // Unregister the old handler before potentially registering
	    // a new one. Otherwise multiple click handlers might
	    // be registered resulting in unwanted behavior.
	    map.off('click', self.onClickInPanHandler);
	    if(dragMode === 'select' || dragMode === 'lasso') {
	        map.dragPan.disable();
	        map.on('zoomstart', self.clearSelect);
	
	        self.dragOptions.prepFn = function(e, startX, startY) {
	            prepSelect(e, startX, startY, self.dragOptions, dragMode);
	        };
	
	        dragElement.init(self.dragOptions);
	    } else {
	        map.dragPan.enable();
	        map.off('zoomstart', self.clearSelect);
	        self.div.onmousedown = null;
	
	        // TODO: this does not support right-click. If we want to support it, we
	        // would likely need to change mapbox to use dragElement instead of straight
	        // mapbox event binding. Or perhaps better, make a simple wrapper with the
	        // right mousedown, mousemove, and mouseup handlers just for a left/right click
	        // pie would use this too.
	        self.onClickInPanHandler = self.onClickInPanFn(self.dragOptions);
	        map.on('click', self.onClickInPanHandler);
	    }
	};
	
	proto.updateFramework = function(fullLayout) {
	    var domain = fullLayout[this.id].domain;
	    var size = fullLayout._size;
	
	    var style = this.div.style;
	    style.width = size.w * (domain.x[1] - domain.x[0]) + 'px';
	    style.height = size.h * (domain.y[1] - domain.y[0]) + 'px';
	    style.left = size.l + domain.x[0] * size.w + 'px';
	    style.top = size.t + (1 - domain.y[1]) * size.h + 'px';
	
	    this.xaxis._offset = size.l + domain.x[0] * size.w;
	    this.xaxis._length = size.w * (domain.x[1] - domain.x[0]);
	
	    this.yaxis._offset = size.t + (1 - domain.y[1]) * size.h;
	    this.yaxis._length = size.h * (domain.y[1] - domain.y[0]);
	};
	
	proto.updateLayers = function(fullLayout) {
	    var opts = fullLayout[this.id];
	    var layers = opts.layers;
	    var layerList = this.layerList;
	    var i;
	
	    // if the layer arrays don't match,
	    // don't try to be smart,
	    // delete them all, and start all over.
	
	    if(layers.length !== layerList.length) {
	        for(i = 0; i < layerList.length; i++) {
	            layerList[i].dispose();
	        }
	
	        layerList = this.layerList = [];
	
	        for(i = 0; i < layers.length; i++) {
	            layerList.push(createMapboxLayer(this, i, layers[i]));
	        }
	    } else {
	        for(i = 0; i < layers.length; i++) {
	            layerList[i].update(layers[i]);
	        }
	    }
	};
	
	proto.destroy = function() {
	    if(this.map) {
	        this.map.remove();
	        this.map = null;
	        this.container.removeChild(this.div);
	    }
	};
	
	proto.toImage = function() {
	    this.map.stop();
	    return this.map.getCanvas().toDataURL();
	};
	
	// convenience wrapper to create set multiple layer
	// 'layout' or 'paint options at once.
	proto.setOptions = function(id, methodName, opts) {
	    for(var k in opts) {
	        this.map[methodName](id, k, opts[k]);
	    }
	};
	
	proto.getMapLayers = function() {
	    return this.map.getStyle().layers;
	};
	
	// convenience wrapper that first check in 'below' references
	// a layer that exist and then add the layer to the map,
	proto.addLayer = function(opts, below) {
	    var map = this.map;
	
	    if(typeof below === 'string') {
	        if(below === '') {
	            map.addLayer(opts, below);
	            return;
	        }
	
	        var mapLayers = this.getMapLayers();
	        for(var i = 0; i < mapLayers.length; i++) {
	            if(below === mapLayers[i].id) {
	                map.addLayer(opts, below);
	                return;
	            }
	        }
	
	        Lib.warn([
	            'Trying to add layer with *below* value',
	            below,
	            'referencing a layer that does not exist',
	            'or that does not yet exist.'
	        ].join(' '));
	    }
	
	    map.addLayer(opts);
	};
	
	// convenience method to project a [lon, lat] array to pixel coords
	proto.project = function(v) {
	    return this.map.project(new mapboxgl.LngLat(v[0], v[1]));
	};
	
	// get map's current view values in plotly.js notation
	proto.getView = function() {
	    var map = this.map;
	    var mapCenter = map.getCenter();
	    var center = { lon: mapCenter.lng, lat: mapCenter.lat };
	
	    return {
	        center: center,
	        zoom: map.getZoom(),
	        bearing: map.getBearing(),
	        pitch: map.getPitch()
	    };
	};
	
	proto.getViewEdits = function(cont) {
	    var id = this.id;
	    var keys = ['center', 'zoom', 'bearing', 'pitch'];
	    var obj = {};
	
	    for(var i = 0; i < keys.length; i++) {
	        var k = keys[i];
	        obj[id + '.' + k] = cont[k];
	    }
	
	    return obj;
	};
	
	function getStyleObj(val) {
	    var styleObj = {};
	
	    if(Lib.isPlainObject(val)) {
	        styleObj.id = val.id;
	        styleObj.style = val;
	    } else if(typeof val === 'string') {
	        styleObj.id = val;
	
	        if(constants.styleValuesMapbox.indexOf(val) !== -1) {
	            styleObj.style = convertStyleVal(val);
	        } else if(constants.stylesNonMapbox[val]) {
	            styleObj.style = constants.stylesNonMapbox[val];
	        } else {
	            styleObj.style = val;
	        }
	    } else {
	        styleObj.id = constants.styleValueDflt;
	        styleObj.style = convertStyleVal(constants.styleValueDflt);
	    }
	
	    styleObj.transition = {duration: 0, delay: 0};
	
	    return styleObj;
	}
	
	// if style is part of the 'official' mapbox values, add URL prefix and suffix
	function convertStyleVal(val) {
	    return constants.styleUrlPrefix + val + '-' + constants.styleUrlSuffix;
	}
	
	function convertCenter(center) {
	    return [center.lon, center.lat];
	}
	
	module.exports = Mapbox;
	
	},{"../../components/dragelement":609,"../../components/fx":629,"../../lib":716,"../../registry":845,"../cartesian/axes":764,"../cartesian/select":781,"./constants":817,"./layers":820,"d3":164,"mapbox-gl":427}],824:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * Creates a set of padding attributes.
	 *
	 * @param {object} opts
	 *   @param {string} editType:
	 *     the editType for all pieces of this padding definition
	 *
	 * @return {object} attributes object containing {t, r, b, l} as specified
	 */
	module.exports = function(opts) {
	    var editType = opts.editType;
	    return {
	        t: {
	            valType: 'number',
	            dflt: 0,
	            
	            editType: editType,
	            
	        },
	        r: {
	            valType: 'number',
	            dflt: 0,
	            
	            editType: editType,
	            
	        },
	        b: {
	            valType: 'number',
	            dflt: 0,
	            
	            editType: editType,
	            
	        },
	        l: {
	            valType: 'number',
	            dflt: 0,
	            
	            editType: editType,
	            
	        },
	        editType: editType
	    };
	};
	
	},{}],825:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Registry = _dereq_('../registry');
	var PlotSchema = _dereq_('../plot_api/plot_schema');
	var Template = _dereq_('../plot_api/plot_template');
	var Lib = _dereq_('../lib');
	var Color = _dereq_('../components/color');
	var BADNUM = _dereq_('../constants/numerical').BADNUM;
	
	var axisIDs = _dereq_('./cartesian/axis_ids');
	
	var animationAttrs = _dereq_('./animation_attributes');
	var frameAttrs = _dereq_('./frame_attributes');
	
	var getModuleCalcData = _dereq_('../plots/get_data').getModuleCalcData;
	
	var relinkPrivateKeys = Lib.relinkPrivateKeys;
	var _ = Lib._;
	
	var plots = module.exports = {};
	
	// Expose registry methods on Plots for backward-compatibility
	Lib.extendFlat(plots, Registry);
	
	plots.attributes = _dereq_('./attributes');
	plots.attributes.type.values = plots.allTypes;
	plots.fontAttrs = _dereq_('./font_attributes');
	plots.layoutAttributes = _dereq_('./layout_attributes');
	
	// TODO make this a plot attribute?
	plots.fontWeight = 'normal';
	
	var transformsRegistry = plots.transformsRegistry;
	
	var commandModule = _dereq_('./command');
	plots.executeAPICommand = commandModule.executeAPICommand;
	plots.computeAPICommandBindings = commandModule.computeAPICommandBindings;
	plots.manageCommandObserver = commandModule.manageCommandObserver;
	plots.hasSimpleAPICommandBindings = commandModule.hasSimpleAPICommandBindings;
	
	// in some cases the browser doesn't seem to know how big
	// the text is at first, so it needs to draw it,
	// then wait a little, then draw it again
	plots.redrawText = function(gd) {
	    gd = Lib.getGraphDiv(gd);
	
	    var fullLayout = gd._fullLayout || {};
	    var hasPolar = fullLayout._has && fullLayout._has('polar');
	    var hasLegacyPolar = !hasPolar && gd.data && gd.data[0] && gd.data[0].r;
	
	    // do not work if polar is present
	    if(hasLegacyPolar) return;
	
	    return new Promise(function(resolve) {
	        setTimeout(function() {
	            Registry.getComponentMethod('annotations', 'draw')(gd);
	            Registry.getComponentMethod('legend', 'draw')(gd);
	            Registry.getComponentMethod('colorbar', 'draw')(gd);
	            resolve(plots.previousPromises(gd));
	        }, 300);
	    });
	};
	
	// resize plot about the container size
	plots.resize = function(gd) {
	    gd = Lib.getGraphDiv(gd);
	
	    var resolveLastResize;
	    var p = new Promise(function(resolve, reject) {
	        if(!gd || Lib.isHidden(gd)) {
	            reject(new Error('Resize must be passed a displayed plot div element.'));
	        }
	
	        if(gd._redrawTimer) clearTimeout(gd._redrawTimer);
	        if(gd._resolveResize) resolveLastResize = gd._resolveResize;
	        gd._resolveResize = resolve;
	
	        gd._redrawTimer = setTimeout(function() {
	            // return if there is nothing to resize or is hidden
	            if(!gd.layout || (gd.layout.width && gd.layout.height) || Lib.isHidden(gd)) {
	                resolve(gd);
	                return;
	            }
	
	            delete gd.layout.width;
	            delete gd.layout.height;
	
	            // autosizing doesn't count as a change that needs saving
	            var oldchanged = gd.changed;
	
	            // nor should it be included in the undo queue
	            gd.autoplay = true;
	
	            Registry.call('relayout', gd, {autosize: true}).then(function() {
	                gd.changed = oldchanged;
	                // Only resolve if a new call hasn't been made!
	                if(gd._resolveResize === resolve) {
	                    delete gd._resolveResize;
	                    resolve(gd);
	                }
	            });
	        }, 100);
	    });
	
	    if(resolveLastResize) resolveLastResize(p);
	    return p;
	};
	
	
	// for use in Lib.syncOrAsync, check if there are any
	// pending promises in this plot and wait for them
	plots.previousPromises = function(gd) {
	    if((gd._promises || []).length) {
	        return Promise.all(gd._promises)
	            .then(function() { gd._promises = []; });
	    }
	};
	
	/**
	 * Adds the 'Edit chart' link.
	 * Note that now Plotly.plot() calls this so it can regenerate whenever it replots
	 *
	 * Add source links to your graph inside the 'showSources' config argument.
	 */
	plots.addLinks = function(gd) {
	    // Do not do anything if showLink and showSources are not set to true in config
	    if(!gd._context.showLink && !gd._context.showSources) return;
	
	    var fullLayout = gd._fullLayout;
	
	    var linkContainer = Lib.ensureSingle(fullLayout._paper, 'text', 'js-plot-link-container', function(s) {
	        s.style({
	            'font-family': '"Open Sans", Arial, sans-serif',
	            'font-size': '12px',
	            'fill': Color.defaultLine,
	            'pointer-events': 'all'
	        })
	        .each(function() {
	            var links = d3.select(this);
	            links.append('tspan').classed('js-link-to-tool', true);
	            links.append('tspan').classed('js-link-spacer', true);
	            links.append('tspan').classed('js-sourcelinks', true);
	        });
	    });
	
	    // The text node inside svg
	    var text = linkContainer.node();
	    var attrs = {y: fullLayout._paper.attr('height') - 9};
	
	    // If text's width is bigger than the layout
	    // Check that text is a child node or document.body
	    // because otherwise IE/Edge might throw an exception
	    // when calling getComputedTextLength().
	    // Apparently offsetParent is null for invisibles.
	    if(document.body.contains(text) && text.getComputedTextLength() >= (fullLayout.width - 20)) {
	        // Align the text at the left
	        attrs['text-anchor'] = 'start';
	        attrs.x = 5;
	    } else {
	        // Align the text at the right
	        attrs['text-anchor'] = 'end';
	        attrs.x = fullLayout._paper.attr('width') - 7;
	    }
	
	    linkContainer.attr(attrs);
	
	    var toolspan = linkContainer.select('.js-link-to-tool');
	    var spacespan = linkContainer.select('.js-link-spacer');
	    var sourcespan = linkContainer.select('.js-sourcelinks');
	
	    if(gd._context.showSources) gd._context.showSources(gd);
	
	    // 'view in plotly' link for embedded plots
	    if(gd._context.showLink) positionPlayWithData(gd, toolspan);
	
	    // separator if we have both sources and tool link
	    spacespan.text((toolspan.text() && sourcespan.text()) ? ' - ' : '');
	};
	
	// note that now this function is only adding the brand in
	// iframes and 3rd-party apps
	function positionPlayWithData(gd, container) {
	    container.text('');
	    var link = container.append('a')
	        .attr({
	            'xlink:xlink:href': '#',
	            'class': 'link--impt link--embedview',
	            'font-weight': 'bold'
	        })
	        .text(gd._context.linkText + ' ' + String.fromCharCode(187));
	
	    if(gd._context.sendData) {
	        link.on('click', function() {
	            plots.sendDataToCloud(gd);
	        });
	    } else {
	        var path = window.location.pathname.split('/');
	        var query = window.location.search;
	        link.attr({
	            'xlink:xlink:show': 'new',
	            'xlink:xlink:href': '/' + path[2].split('.')[0] + '/' + path[1] + query
	        });
	    }
	}
	
	plots.sendDataToCloud = function(gd) {
	    gd.emit('plotly_beforeexport');
	
	    var baseUrl = (window.PLOTLYENV || {}).BASE_URL || gd._context.plotlyServerURL;
	
	    var hiddenformDiv = d3.select(gd)
	        .append('div')
	        .attr('id', 'hiddenform')
	        .style('display', 'none');
	
	    var hiddenform = hiddenformDiv
	        .append('form')
	        .attr({
	            action: baseUrl + '/external',
	            method: 'post',
	            target: '_blank'
	        });
	
	    var hiddenformInput = hiddenform
	        .append('input')
	        .attr({
	            type: 'text',
	            name: 'data'
	        });
	
	    hiddenformInput.node().value = plots.graphJson(gd, false, 'keepdata');
	    hiddenform.node().submit();
	    hiddenformDiv.remove();
	
	    gd.emit('plotly_afterexport');
	    return false;
	};
	
	var d3FormatKeys = [
	    'days', 'shortDays', 'months', 'shortMonths', 'periods',
	    'dateTime', 'date', 'time',
	    'decimal', 'thousands', 'grouping', 'currency'
	];
	
	var extraFormatKeys = [
	    'year', 'month', 'dayMonth', 'dayMonthYear'
	];
	
	/*
	 * Fill in default values
	 * @param {DOM element} gd
	 * @param {object} opts
	 * @param {boolean} opts.skipUpdateCalc: normally if the existing gd.calcdata looks
	 *   compatible with the new gd._fullData we finish by linking the new _fullData traces
	 *   to the old gd.calcdata, so it's correctly set if we're not going to recalc. But also,
	 *   if there are calcTransforms on the trace, we first remap data arrays from the old full
	 *   trace into the new one. Use skipUpdateCalc to defer this (needed by Plotly.react)
	 *
	 * gd.data, gd.layout:
	 *   are precisely what the user specified (except as modified by cleanData/cleanLayout),
	 *   these fields shouldn't be modified (except for filling in some auto values)
	 *   nor used directly after the supply defaults step.
	 *
	 * gd._fullData, gd._fullLayout:
	 *   are complete descriptions of how to draw the plot,
	 *   use these fields in all required computations.
	 *
	 * gd._fullLayout._modules
	 *   is a list of all the trace modules required to draw the plot.
	 *
	 * gd._fullLayout._visibleModules
	 *   subset of _modules, a list of modules corresponding to visible:true traces.
	 *
	 * gd._fullLayout._basePlotModules
	 *   is a list of all the plot modules required to draw the plot.
	 *
	 * gd._fullLayout._transformModules
	 *   is a list of all the transform modules invoked.
	 *
	 */
	plots.supplyDefaults = function(gd, opts) {
	    var skipUpdateCalc = opts && opts.skipUpdateCalc;
	    var oldFullLayout = gd._fullLayout || {};
	
	    if(oldFullLayout._skipDefaults) {
	        delete oldFullLayout._skipDefaults;
	        return;
	    }
	
	    var newFullLayout = gd._fullLayout = {};
	    var newLayout = gd.layout || {};
	
	    var oldFullData = gd._fullData || [];
	    var newFullData = gd._fullData = [];
	    var newData = gd.data || [];
	
	    var oldCalcdata = gd.calcdata || [];
	
	    var context = gd._context || {};
	
	    var i;
	
	    // Create all the storage space for frames, but only if doesn't already exist
	    if(!gd._transitionData) plots.createTransitionData(gd);
	
	    // So we only need to do this once (and since we have gd here)
	    // get the translated placeholder titles.
	    // These ones get used as default values so need to be known at supplyDefaults
	    // others keep their blank defaults but render the placeholder as desired later
	    // TODO: make these work the same way, only inserting the placeholder text at draw time?
	    // The challenge is that this has slightly different behavior right now in editable mode:
	    // using the placeholder as default makes this text permanently (but lightly) visible,
	    // but explicit '' for these titles gives you a placeholder that's hidden until you mouse
	    // over it - so you're not distracted by it if you really don't want a title, but if you do
	    // and you're new to plotly you may not be able to find it.
	    // When editable=false the two behave the same, no title is drawn.
	    newFullLayout._dfltTitle = {
	        plot: _(gd, 'Click to enter Plot title'),
	        x: _(gd, 'Click to enter X axis title'),
	        y: _(gd, 'Click to enter Y axis title'),
	        colorbar: _(gd, 'Click to enter Colorscale title'),
	        annotation: _(gd, 'new text')
	    };
	    newFullLayout._traceWord = _(gd, 'trace');
	
	    var formatObj = getFormatObj(gd, d3FormatKeys);
	
	    // stash the token from context so mapbox subplots can use it as default
	    newFullLayout._mapboxAccessToken = context.mapboxAccessToken;
	
	    // first fill in what we can of layout without looking at data
	    // because fullData needs a few things from layout
	    if(oldFullLayout._initialAutoSizeIsDone) {
	        // coerce the updated layout while preserving width and height
	        var oldWidth = oldFullLayout.width;
	        var oldHeight = oldFullLayout.height;
	
	        plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
	
	        if(!newLayout.width) newFullLayout.width = oldWidth;
	        if(!newLayout.height) newFullLayout.height = oldHeight;
	        plots.sanitizeMargins(newFullLayout);
	    } else {
	        // coerce the updated layout and autosize if needed
	        plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
	
	        var missingWidthOrHeight = (!newLayout.width || !newLayout.height);
	        var autosize = newFullLayout.autosize;
	        var autosizable = context.autosizable;
	        var initialAutoSize = missingWidthOrHeight && (autosize || autosizable);
	
	        if(initialAutoSize) plots.plotAutoSize(gd, newLayout, newFullLayout);
	        else if(missingWidthOrHeight) plots.sanitizeMargins(newFullLayout);
	
	        // for backwards-compatibility with Plotly v1.x.x
	        if(!autosize && missingWidthOrHeight) {
	            newLayout.width = newFullLayout.width;
	            newLayout.height = newFullLayout.height;
	        }
	    }
	
	    newFullLayout._d3locale = getFormatter(formatObj, newFullLayout.separators);
	    newFullLayout._extraFormat = getFormatObj(gd, extraFormatKeys);
	
	    newFullLayout._initialAutoSizeIsDone = true;
	
	    // keep track of how many traces are inputted
	    newFullLayout._dataLength = newData.length;
	
	    // clear the lists of trace and baseplot modules, and subplots
	    newFullLayout._modules = [];
	    newFullLayout._visibleModules = [];
	    newFullLayout._basePlotModules = [];
	    var subplots = newFullLayout._subplots = emptySubplotLists();
	
	    // initialize axis and subplot hash objects for splom-generated grids
	    var splomAxes = newFullLayout._splomAxes = {x: {}, y: {}};
	    var splomSubplots = newFullLayout._splomSubplots = {};
	    // initialize splom grid defaults
	    newFullLayout._splomGridDflt = {};
	
	    // for stacked area traces to share config across traces
	    newFullLayout._scatterStackOpts = {};
	    // for the first scatter trace on each subplot (so it knows tonext->tozero)
	    newFullLayout._firstScatter = {};
	    // for grouped bar/box/violin trace to share config across traces
	    newFullLayout._alignmentOpts = {};
	    // track color axes referenced in the data
	    newFullLayout._colorAxes = {};
	
	    // for traces to request a default rangeslider on their x axes
	    // eg set `_requestRangeslider.x2 = true` for xaxis2
	    newFullLayout._requestRangeslider = {};
	
	    // pull uids from old data to use as new defaults
	    newFullLayout._traceUids = getTraceUids(oldFullData, newData);
	
	    // then do the data
	    newFullLayout._globalTransforms = (gd._context || {}).globalTransforms;
	    plots.supplyDataDefaults(newData, newFullData, newLayout, newFullLayout);
	
	    // redo grid size defaults with info about splom x/y axes,
	    // and fill in generated cartesian axes and subplots
	    var splomXa = Object.keys(splomAxes.x);
	    var splomYa = Object.keys(splomAxes.y);
	    if(splomXa.length > 1 && splomYa.length > 1) {
	        Registry.getComponentMethod('grid', 'sizeDefaults')(newLayout, newFullLayout);
	
	        for(i = 0; i < splomXa.length; i++) {
	            Lib.pushUnique(subplots.xaxis, splomXa[i]);
	        }
	        for(i = 0; i < splomYa.length; i++) {
	            Lib.pushUnique(subplots.yaxis, splomYa[i]);
	        }
	        for(var k in splomSubplots) {
	            Lib.pushUnique(subplots.cartesian, k);
	        }
	    }
	
	    // attach helper method to check whether a plot type is present on graph
	    newFullLayout._has = plots._hasPlotType.bind(newFullLayout);
	
	    if(oldFullData.length === newFullData.length) {
	        for(i = 0; i < newFullData.length; i++) {
	            relinkPrivateKeys(newFullData[i], oldFullData[i]);
	        }
	    }
	
	    // finally, fill in the pieces of layout that may need to look at data
	    plots.supplyLayoutModuleDefaults(newLayout, newFullLayout, newFullData, gd._transitionData);
	
	    // Special cases that introduce interactions between traces.
	    // This is after relinkPrivateKeys so we can use those in crossTraceDefaults
	    // and after layout module defaults, so we can use eg barmode
	    var _modules = newFullLayout._visibleModules;
	    var crossTraceDefaultsFuncs = [];
	    for(i = 0; i < _modules.length; i++) {
	        var funci = _modules[i].crossTraceDefaults;
	        // some trace types share crossTraceDefaults (ie histogram2d, histogram2dcontour)
	        if(funci) Lib.pushUnique(crossTraceDefaultsFuncs, funci);
	    }
	    for(i = 0; i < crossTraceDefaultsFuncs.length; i++) {
	        crossTraceDefaultsFuncs[i](newFullData, newFullLayout);
	    }
	
	    // turn on flag to optimize large splom-only graphs
	    // mostly by omitting SVG layers during Cartesian.drawFramework
	    newFullLayout._hasOnlyLargeSploms = (
	        newFullLayout._basePlotModules.length === 1 &&
	        newFullLayout._basePlotModules[0].name === 'splom' &&
	        splomXa.length > 15 &&
	        splomYa.length > 15 &&
	        newFullLayout.shapes.length === 0 &&
	        newFullLayout.images.length === 0
	    );
	
	    // TODO remove in v2.0.0
	    // add has-plot-type refs to fullLayout for backward compatibility
	    newFullLayout._hasCartesian = newFullLayout._has('cartesian');
	    newFullLayout._hasGeo = newFullLayout._has('geo');
	    newFullLayout._hasGL3D = newFullLayout._has('gl3d');
	    newFullLayout._hasGL2D = newFullLayout._has('gl2d');
	    newFullLayout._hasTernary = newFullLayout._has('ternary');
	    newFullLayout._hasPie = newFullLayout._has('pie');
	
	    // relink / initialize subplot axis objects
	    plots.linkSubplots(newFullData, newFullLayout, oldFullData, oldFullLayout);
	
	    // clean subplots and other artifacts from previous plot calls
	    plots.cleanPlot(newFullData, newFullLayout, oldFullData, oldFullLayout);
	
	    // clear selection outline until we implement persistent selection,
	    // don't clear them though when drag handlers (e.g. listening to
	    // `plotly_selecting`) update the graph.
	    // we should try to come up with a better solution when implementing
	    // https://github.com/plotly/plotly.js/issues/1851
	    if(oldFullLayout._zoomlayer && !gd._dragging) {
	        oldFullLayout._zoomlayer.selectAll('.select-outline').remove();
	    }
	
	
	    // fill in meta helpers
	    fillMetaTextHelpers(newFullData, newFullLayout);
	
	    // relink functions and _ attributes to promote consistency between plots
	    relinkPrivateKeys(newFullLayout, oldFullLayout);
	
	    // colorscale crossTraceDefaults needs newFullLayout with relinked keys
	    Registry.getComponentMethod('colorscale', 'crossTraceDefaults')(newFullData, newFullLayout);
	
	    // For persisting GUI-driven changes in layout
	    // _preGUI and _tracePreGUI were already copied over in relinkPrivateKeys
	    if(!newFullLayout._preGUI) newFullLayout._preGUI = {};
	    // track trace GUI changes by uid rather than by trace index
	    if(!newFullLayout._tracePreGUI) newFullLayout._tracePreGUI = {};
	    var tracePreGUI = newFullLayout._tracePreGUI;
	    var uids = {};
	    var uid;
	    for(uid in tracePreGUI) uids[uid] = 'old';
	    for(i = 0; i < newFullData.length; i++) {
	        uid = newFullData[i]._fullInput.uid;
	        if(!uids[uid]) tracePreGUI[uid] = {};
	        uids[uid] = 'new';
	    }
	    for(uid in uids) {
	        if(uids[uid] === 'old') delete tracePreGUI[uid];
	    }
	
	    // set up containers for margin calculations
	    initMargins(newFullLayout);
	
	    // collect and do some initial calculations for rangesliders
	    Registry.getComponentMethod('rangeslider', 'makeData')(newFullLayout);
	
	    // update object references in calcdata
	    if(!skipUpdateCalc && oldCalcdata.length === newFullData.length) {
	        plots.supplyDefaultsUpdateCalc(oldCalcdata, newFullData);
	    }
	};
	
	plots.supplyDefaultsUpdateCalc = function(oldCalcdata, newFullData) {
	    for(var i = 0; i < newFullData.length; i++) {
	        var newTrace = newFullData[i];
	        var cd0 = (oldCalcdata[i] || [])[0];
	        if(cd0 && cd0.trace) {
	            var oldTrace = cd0.trace;
	            if(oldTrace._hasCalcTransform) {
	                var arrayAttrs = oldTrace._arrayAttrs;
	                var j, astr, oldArrayVal;
	
	                for(j = 0; j < arrayAttrs.length; j++) {
	                    astr = arrayAttrs[j];
	                    oldArrayVal = Lib.nestedProperty(oldTrace, astr).get().slice();
	                    Lib.nestedProperty(newTrace, astr).set(oldArrayVal);
	                }
	            }
	            cd0.trace = newTrace;
	        }
	    }
	};
	
	/**
	 * Create a list of uid strings satisfying (in this order of importance):
	 * 1. all unique, all strings
	 * 2. matches input uids if provided
	 * 3. matches previous data uids
	 */
	function getTraceUids(oldFullData, newData) {
	    var len = newData.length;
	    var oldFullInput = [];
	    var i, prevFullInput;
	    for(i = 0; i < oldFullData.length; i++) {
	        var thisFullInput = oldFullData[i]._fullInput;
	        if(thisFullInput !== prevFullInput) oldFullInput.push(thisFullInput);
	        prevFullInput = thisFullInput;
	    }
	    var oldLen = oldFullInput.length;
	    var out = new Array(len);
	    var seenUids = {};
	
	    function setUid(uid, i) {
	        out[i] = uid;
	        seenUids[uid] = 1;
	    }
	
	    function tryUid(uid, i) {
	        if(uid && typeof uid === 'string' && !seenUids[uid]) {
	            setUid(uid, i);
	            return true;
	        }
	    }
	
	    for(i = 0; i < len; i++) {
	        var newUid = newData[i].uid;
	        if(typeof newUid === 'number') newUid = String(newUid);
	
	        if(tryUid(newUid, i)) continue;
	        if(i < oldLen && tryUid(oldFullInput[i].uid, i)) continue;
	        setUid(Lib.randstr(seenUids), i);
	    }
	
	    return out;
	}
	
	/**
	 * Make a container for collecting subplots we need to display.
	 *
	 * Finds all subplot types we need to enumerate once and caches it,
	 * but makes a new output object each time.
	 * Single-trace subplots (which have no `id`) such as pie, table, etc
	 * do not need to be collected because we just draw all visible traces.
	 */
	function emptySubplotLists() {
	    var collectableSubplotTypes = Registry.collectableSubplotTypes;
	    var out = {};
	    var i, j;
	
	    if(!collectableSubplotTypes) {
	        collectableSubplotTypes = [];
	
	        var subplotsRegistry = Registry.subplotsRegistry;
	
	        for(var subplotType in subplotsRegistry) {
	            var subplotModule = subplotsRegistry[subplotType];
	            var subplotAttr = subplotModule.attr;
	
	            if(subplotAttr) {
	                collectableSubplotTypes.push(subplotType);
	
	                // special case, currently just for cartesian:
	                // we need to enumerate axes, not just subplots
	                if(Array.isArray(subplotAttr)) {
	                    for(j = 0; j < subplotAttr.length; j++) {
	                        Lib.pushUnique(collectableSubplotTypes, subplotAttr[j]);
	                    }
	                }
	            }
	        }
	    }
	
	    for(i = 0; i < collectableSubplotTypes.length; i++) {
	        out[collectableSubplotTypes[i]] = [];
	    }
	    return out;
	}
	
	/**
	 * getFormatObj: use _context to get the format object from locale.
	 * Used to get d3.locale argument object and extraFormat argument object
	 *
	 * Regarding d3.locale argument :
	 * decimal and thousands can be overridden later by layout.separators
	 * grouping and currency are not presently used by our automatic number
	 * formatting system but can be used by custom formats.
	 *
	 * @returns {object} d3.locale format object
	 */
	function getFormatObj(gd, formatKeys) {
	    var locale = gd._context.locale;
	    if(!locale) locale === 'en-US';
	
	    var formatDone = false;
	    var formatObj = {};
	
	    function includeFormat(newFormat) {
	        var formatFinished = true;
	        for(var i = 0; i < formatKeys.length; i++) {
	            var formatKey = formatKeys[i];
	            if(!formatObj[formatKey]) {
	                if(newFormat[formatKey]) {
	                    formatObj[formatKey] = newFormat[formatKey];
	                } else formatFinished = false;
	            }
	        }
	        if(formatFinished) formatDone = true;
	    }
	
	    // same as localize, look for format parts in each format spec in the chain
	    for(var i = 0; i < 2; i++) {
	        var locales = gd._context.locales;
	        for(var j = 0; j < 2; j++) {
	            var formatj = (locales[locale] || {}).format;
	            if(formatj) {
	                includeFormat(formatj);
	                if(formatDone) break;
	            }
	            locales = Registry.localeRegistry;
	        }
	
	        var baseLocale = locale.split('-')[0];
	        if(formatDone || baseLocale === locale) break;
	        locale = baseLocale;
	    }
	
	    // lastly pick out defaults from english (non-US, as DMY is so much more common)
	    if(!formatDone) includeFormat(Registry.localeRegistry.en.format);
	
	    return formatObj;
	}
	
	/**
	 * getFormatter: combine the final separators with the locale formatting object
	 * we pulled earlier to generate number and time formatters
	 * TODO: remove separators in v2, only use locale, so we don't need this step?
	 *
	 * @param {object} formatObj: d3.locale format object
	 * @param {string} separators: length-2 string to override decimal and thousands
	 *   separators in number formatting
	 *
	 * @returns {object} {numberFormat, timeFormat} d3 formatter factory functions
	 *   for numbers and time
	 */
	function getFormatter(formatObj, separators) {
	    formatObj.decimal = separators.charAt(0);
	    formatObj.thousands = separators.charAt(1);
	
	    return d3.locale(formatObj);
	}
	
	function fillMetaTextHelpers(newFullData, newFullLayout) {
	    var _meta;
	    var meta4data = [];
	
	    if(newFullLayout.meta) {
	        _meta = newFullLayout._meta = {
	            meta: newFullLayout.meta,
	            layout: {meta: newFullLayout.meta}
	        };
	    }
	
	    for(var i = 0; i < newFullData.length; i++) {
	        var trace = newFullData[i];
	
	        if(trace.meta) {
	            meta4data[trace.index] = trace._meta = {meta: trace.meta};
	        } else if(newFullLayout.meta) {
	            trace._meta = {meta: newFullLayout.meta};
	        }
	        if(newFullLayout.meta) {
	            trace._meta.layout = {meta: newFullLayout.meta};
	        }
	    }
	
	    if(meta4data.length) {
	        if(!_meta) {
	            _meta = newFullLayout._meta = {};
	        }
	        _meta.data = meta4data;
	    }
	}
	
	// Create storage for all of the data related to frames and transitions:
	plots.createTransitionData = function(gd) {
	    // Set up the default keyframe if it doesn't exist:
	    if(!gd._transitionData) {
	        gd._transitionData = {};
	    }
	
	    if(!gd._transitionData._frames) {
	        gd._transitionData._frames = [];
	    }
	
	    if(!gd._transitionData._frameHash) {
	        gd._transitionData._frameHash = {};
	    }
	
	    if(!gd._transitionData._counter) {
	        gd._transitionData._counter = 0;
	    }
	
	    if(!gd._transitionData._interruptCallbacks) {
	        gd._transitionData._interruptCallbacks = [];
	    }
	};
	
	// helper function to be bound to fullLayout to check
	// whether a certain plot type is present on plot
	// or trace has a category
	plots._hasPlotType = function(category) {
	    var i;
	
	    // check base plot modules
	    var basePlotModules = this._basePlotModules || [];
	    for(i = 0; i < basePlotModules.length; i++) {
	        if(basePlotModules[i].name === category) return true;
	    }
	
	    // check trace modules (including non-visible:true)
	    var modules = this._modules || [];
	    for(i = 0; i < modules.length; i++) {
	        var name = modules[i].name;
	        if(name === category) return true;
	        // N.B. this is modules[i] along with 'categories' as a hash object
	        var _module = Registry.modules[name];
	        if(_module && _module.categories[category]) return true;
	    }
	
	    return false;
	};
	
	plots.cleanPlot = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var i, j;
	
	    var basePlotModules = oldFullLayout._basePlotModules || [];
	    for(i = 0; i < basePlotModules.length; i++) {
	        var _module = basePlotModules[i];
	
	        if(_module.clean) {
	            _module.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
	        }
	    }
	
	    var hadGl = oldFullLayout._has && oldFullLayout._has('gl');
	    var hasGl = newFullLayout._has && newFullLayout._has('gl');
	
	    if(hadGl && !hasGl) {
	        if(oldFullLayout._glcontainer !== undefined) {
	            oldFullLayout._glcontainer.selectAll('.gl-canvas').remove();
	            oldFullLayout._glcontainer.selectAll('.no-webgl').remove();
	            oldFullLayout._glcanvas = null;
	        }
	    }
	
	    var hasInfoLayer = !!oldFullLayout._infolayer;
	
	    oldLoop:
	    for(i = 0; i < oldFullData.length; i++) {
	        var oldTrace = oldFullData[i];
	        var oldUid = oldTrace.uid;
	
	        for(j = 0; j < newFullData.length; j++) {
	            var newTrace = newFullData[j];
	
	            if(oldUid === newTrace.uid) continue oldLoop;
	        }
	
	        // clean old colorbars
	        if(hasInfoLayer) {
	            oldFullLayout._infolayer.select('.cb' + oldUid).remove();
	        }
	    }
	};
	
	plots.linkSubplots = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var i, j;
	
	    var oldSubplots = oldFullLayout._plots || {};
	    var newSubplots = newFullLayout._plots = {};
	    var newSubplotList = newFullLayout._subplots;
	
	    var mockGd = {
	        _fullData: newFullData,
	        _fullLayout: newFullLayout
	    };
	
	    var ids = newSubplotList.cartesian.concat(newSubplotList.gl2d || []);
	
	    for(i = 0; i < ids.length; i++) {
	        var id = ids[i];
	        var oldSubplot = oldSubplots[id];
	        var xaxis = axisIDs.getFromId(mockGd, id, 'x');
	        var yaxis = axisIDs.getFromId(mockGd, id, 'y');
	        var plotinfo;
	
	        // link or create subplot object
	        if(oldSubplot) {
	            plotinfo = newSubplots[id] = oldSubplot;
	        } else {
	            plotinfo = newSubplots[id] = {};
	            plotinfo.id = id;
	        }
	
	        // add these axis ids to each others' subplot lists
	        xaxis._counterAxes.push(yaxis._id);
	        yaxis._counterAxes.push(xaxis._id);
	        xaxis._subplotsWith.push(id);
	        yaxis._subplotsWith.push(id);
	
	        // update x and y axis layout object refs
	        plotinfo.xaxis = xaxis;
	        plotinfo.yaxis = yaxis;
	
	        // By default, we clip at the subplot level,
	        // but if one trace on a given subplot has *cliponaxis* set to false,
	        // we need to clip at the trace module layer level;
	        // find this out here, once of for all.
	        plotinfo._hasClipOnAxisFalse = false;
	
	        for(j = 0; j < newFullData.length; j++) {
	            var trace = newFullData[j];
	
	            if(
	                trace.xaxis === plotinfo.xaxis._id &&
	                trace.yaxis === plotinfo.yaxis._id &&
	                trace.cliponaxis === false
	            ) {
	                plotinfo._hasClipOnAxisFalse = true;
	                break;
	            }
	        }
	    }
	
	    // while we're at it, link overlaying axes to their main axes and
	    // anchored axes to the axes they're anchored to
	    var axList = axisIDs.list(mockGd, null, true);
	    var ax;
	    for(i = 0; i < axList.length; i++) {
	        ax = axList[i];
	        var mainAx = null;
	
	        if(ax.overlaying) {
	            mainAx = axisIDs.getFromId(mockGd, ax.overlaying);
	
	            // you cannot overlay an axis that's already overlaying another
	            if(mainAx && mainAx.overlaying) {
	                ax.overlaying = false;
	                mainAx = null;
	            }
	        }
	        ax._mainAxis = mainAx || ax;
	
	        /*
	         * For now force overlays to overlay completely... so they
	         * can drag together correctly and share backgrounds.
	         * Later perhaps we make separate axis domain and
	         * tick/line domain or something, so they can still share
	         * the (possibly larger) dragger and background but don't
	         * have to both be drawn over that whole domain
	         */
	        if(mainAx) ax.domain = mainAx.domain.slice();
	
	        ax._anchorAxis = ax.anchor === 'free' ?
	            null :
	            axisIDs.getFromId(mockGd, ax.anchor);
	    }
	
	    // finally, we can find the main subplot for each axis
	    // (on which the ticks & labels are drawn)
	    for(i = 0; i < axList.length; i++) {
	        ax = axList[i];
	        ax._counterAxes.sort(axisIDs.idSort);
	        ax._subplotsWith.sort(Lib.subplotSort);
	        ax._mainSubplot = findMainSubplot(ax, newFullLayout);
	
	        // find "full" domain span of counter axes,
	        // this loop can be costly, so only compute it when required
	        if(ax._counterAxes.length && (
	            (ax.spikemode && ax.spikemode.indexOf('across') !== -1) ||
	            (ax.automargin && ax.mirror && ax.anchor !== 'free') ||
	            Registry.getComponentMethod('rangeslider', 'isVisible')(ax)
	        )) {
	            var min = 1;
	            var max = 0;
	            for(j = 0; j < ax._counterAxes.length; j++) {
	                var ax2 = axisIDs.getFromId(mockGd, ax._counterAxes[j]);
	                min = Math.min(min, ax2.domain[0]);
	                max = Math.max(max, ax2.domain[1]);
	            }
	            if(min < max) {
	                ax._counterDomainMin = min;
	                ax._counterDomainMax = max;
	            }
	        }
	    }
	};
	
	function findMainSubplot(ax, fullLayout) {
	    var mockGd = {_fullLayout: fullLayout};
	
	    var isX = ax._id.charAt(0) === 'x';
	    var anchorAx = ax._mainAxis._anchorAxis;
	    var mainSubplotID = '';
	    var nextBestMainSubplotID = '';
	    var anchorID = '';
	
	    // First try the main ID with the anchor
	    if(anchorAx) {
	        anchorID = anchorAx._mainAxis._id;
	        mainSubplotID = isX ? (ax._id + anchorID) : (anchorID + ax._id);
	    }
	
	    // Then look for a subplot with the counteraxis overlaying the anchor
	    // If that fails just use the first subplot including this axis
	    if(!mainSubplotID || !fullLayout._plots[mainSubplotID]) {
	        mainSubplotID = '';
	
	        var counterIDs = ax._counterAxes;
	        for(var j = 0; j < counterIDs.length; j++) {
	            var counterPart = counterIDs[j];
	            var id = isX ? (ax._id + counterPart) : (counterPart + ax._id);
	            if(!nextBestMainSubplotID) nextBestMainSubplotID = id;
	            var counterAx = axisIDs.getFromId(mockGd, counterPart);
	            if(anchorID && counterAx.overlaying === anchorID) {
	                mainSubplotID = id;
	                break;
	            }
	        }
	    }
	
	    return mainSubplotID || nextBestMainSubplotID;
	}
	
	// This function clears any trace attributes with valType: color and
	// no set dflt filed in the plot schema. This is needed because groupby (which
	// is the only transform for which this currently applies) supplies parent
	// trace defaults, then expanded trace defaults. The result is that `null`
	// colors are default-supplied and inherited as a color instead of a null.
	// The result is that expanded trace default colors have no effect, with
	// the final result that groups are indistinguishable. This function clears
	// those colors so that individual groupby groups get unique colors.
	plots.clearExpandedTraceDefaultColors = function(trace) {
	    var colorAttrs, path, i;
	
	    // This uses weird closure state in order to satisfy the linter rule
	    // that we can't create functions in a loop.
	    function locateColorAttrs(attr, attrName, attrs, level) {
	        path[level] = attrName;
	        path.length = level + 1;
	        if(attr.valType === 'color' && attr.dflt === undefined) {
	            colorAttrs.push(path.join('.'));
	        }
	    }
	
	    path = [];
	
	    // Get the cached colorAttrs:
	    colorAttrs = trace._module._colorAttrs;
	
	    // Or else compute and cache the colorAttrs on the module:
	    if(!colorAttrs) {
	        trace._module._colorAttrs = colorAttrs = [];
	        PlotSchema.crawl(
	            trace._module.attributes,
	            locateColorAttrs
	        );
	    }
	
	    for(i = 0; i < colorAttrs.length; i++) {
	        var origprop = Lib.nestedProperty(trace, '_input.' + colorAttrs[i]);
	
	        if(!origprop.get()) {
	            Lib.nestedProperty(trace, colorAttrs[i]).set(null);
	        }
	    }
	};
	
	
	plots.supplyDataDefaults = function(dataIn, dataOut, layout, fullLayout) {
	    var modules = fullLayout._modules;
	    var visibleModules = fullLayout._visibleModules;
	    var basePlotModules = fullLayout._basePlotModules;
	    var cnt = 0;
	    var colorCnt = 0;
	
	    var i, fullTrace, trace;
	
	    fullLayout._transformModules = [];
	
	    function pushModule(fullTrace) {
	        dataOut.push(fullTrace);
	
	        var _module = fullTrace._module;
	        if(!_module) return;
	
	        Lib.pushUnique(modules, _module);
	        if(fullTrace.visible === true) Lib.pushUnique(visibleModules, _module);
	        Lib.pushUnique(basePlotModules, fullTrace._module.basePlotModule);
	        cnt++;
	
	        // TODO: do we really want color not to increment for explicitly invisible traces?
	        // This logic is weird, but matches previous behavior: traces that you explicitly
	        // set to visible:false do not increment the color, but traces WE determine to be
	        // empty or invalid (and thus set to visible:false) DO increment color.
	        // I kind of think we should just let all traces increment color, visible or not.
	        // see mock: axes-autotype-empty vs. a test of restyling visible: false that
	        // I can't find right now...
	        if(fullTrace._input.visible !== false) colorCnt++;
	    }
	
	    var carpetIndex = {};
	    var carpetDependents = [];
	    var dataTemplate = (layout.template || {}).data || {};
	    var templater = Template.traceTemplater(dataTemplate);
	
	    for(i = 0; i < dataIn.length; i++) {
	        trace = dataIn[i];
	
	        // reuse uid we may have pulled out of oldFullData
	        // Note: templater supplies trace type
	        fullTrace = templater.newTrace(trace);
	        fullTrace.uid = fullLayout._traceUids[i];
	        plots.supplyTraceDefaults(trace, fullTrace, colorCnt, fullLayout, i);
	
	        fullTrace.index = i;
	        fullTrace._input = trace;
	        fullTrace._expandedIndex = cnt;
	
	        if(fullTrace.transforms && fullTrace.transforms.length) {
	            var sdInvisible = trace.visible !== false && fullTrace.visible === false;
	
	            var expandedTraces = applyTransforms(fullTrace, dataOut, layout, fullLayout);
	
	            for(var j = 0; j < expandedTraces.length; j++) {
	                var expandedTrace = expandedTraces[j];
	
	                // No further templating during transforms.
	                var fullExpandedTrace = {
	                    _template: fullTrace._template,
	                    type: fullTrace.type,
	                    // set uid using parent uid and expanded index
	                    // to promote consistency between update calls
	                    uid: fullTrace.uid + j
	                };
	
	                // If the first supplyDefaults created `visible: false`,
	                // clear it before running supplyDefaults a second time,
	                // because sometimes there are items we still want to coerce
	                // inside trace modules before determining that the trace is
	                // again `visible: false`, for example partial visibilities
	                // in `splom` traces.
	                if(sdInvisible && expandedTrace.visible === false) {
	                    delete expandedTrace.visible;
	                }
	
	                plots.supplyTraceDefaults(expandedTrace, fullExpandedTrace, cnt, fullLayout, i);
	
	                // relink private (i.e. underscore) keys expanded trace to full expanded trace so
	                // that transform supply-default methods can set _ keys for future use.
	                relinkPrivateKeys(fullExpandedTrace, expandedTrace);
	
	                // add info about parent data trace
	                fullExpandedTrace.index = i;
	                fullExpandedTrace._input = trace;
	                fullExpandedTrace._fullInput = fullTrace;
	
	                // add info about the expanded data
	                fullExpandedTrace._expandedIndex = cnt;
	                fullExpandedTrace._expandedInput = expandedTrace;
	
	                pushModule(fullExpandedTrace);
	            }
	        } else {
	            // add identify refs for consistency with transformed traces
	            fullTrace._fullInput = fullTrace;
	            fullTrace._expandedInput = fullTrace;
	
	            pushModule(fullTrace);
	        }
	
	        if(Registry.traceIs(fullTrace, 'carpetAxis')) {
	            carpetIndex[fullTrace.carpet] = fullTrace;
	        }
	
	        if(Registry.traceIs(fullTrace, 'carpetDependent')) {
	            carpetDependents.push(i);
	        }
	    }
	
	    for(i = 0; i < carpetDependents.length; i++) {
	        fullTrace = dataOut[carpetDependents[i]];
	
	        if(!fullTrace.visible) continue;
	
	        var carpetAxis = carpetIndex[fullTrace.carpet];
	        fullTrace._carpet = carpetAxis;
	
	        if(!carpetAxis || !carpetAxis.visible) {
	            fullTrace.visible = false;
	            continue;
	        }
	
	        fullTrace.xaxis = carpetAxis.xaxis;
	        fullTrace.yaxis = carpetAxis.yaxis;
	    }
	};
	
	plots.supplyAnimationDefaults = function(opts) {
	    opts = opts || {};
	    var i;
	    var optsOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(opts || {}, optsOut, animationAttrs, attr, dflt);
	    }
	
	    coerce('mode');
	    coerce('direction');
	    coerce('fromcurrent');
	
	    if(Array.isArray(opts.frame)) {
	        optsOut.frame = [];
	        for(i = 0; i < opts.frame.length; i++) {
	            optsOut.frame[i] = plots.supplyAnimationFrameDefaults(opts.frame[i] || {});
	        }
	    } else {
	        optsOut.frame = plots.supplyAnimationFrameDefaults(opts.frame || {});
	    }
	
	    if(Array.isArray(opts.transition)) {
	        optsOut.transition = [];
	        for(i = 0; i < opts.transition.length; i++) {
	            optsOut.transition[i] = plots.supplyAnimationTransitionDefaults(opts.transition[i] || {});
	        }
	    } else {
	        optsOut.transition = plots.supplyAnimationTransitionDefaults(opts.transition || {});
	    }
	
	    return optsOut;
	};
	
	plots.supplyAnimationFrameDefaults = function(opts) {
	    var optsOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(opts || {}, optsOut, animationAttrs.frame, attr, dflt);
	    }
	
	    coerce('duration');
	    coerce('redraw');
	
	    return optsOut;
	};
	
	plots.supplyAnimationTransitionDefaults = function(opts) {
	    var optsOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(opts || {}, optsOut, animationAttrs.transition, attr, dflt);
	    }
	
	    coerce('duration');
	    coerce('easing');
	
	    return optsOut;
	};
	
	plots.supplyFrameDefaults = function(frameIn) {
	    var frameOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(frameIn, frameOut, frameAttrs, attr, dflt);
	    }
	
	    coerce('group');
	    coerce('name');
	    coerce('traces');
	    coerce('baseframe');
	    coerce('data');
	    coerce('layout');
	
	    return frameOut;
	};
	
	plots.supplyTraceDefaults = function(traceIn, traceOut, colorIndex, layout, traceInIndex) {
	    var colorway = layout.colorway || Color.defaults;
	    var defaultColor = colorway[colorIndex % colorway.length];
	
	    var i;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, plots.attributes, attr, dflt);
	    }
	
	    var visible = coerce('visible');
	
	    coerce('type');
	    coerce('name', layout._traceWord + ' ' + traceInIndex);
	
	    coerce('uirevision', layout.uirevision);
	
	    // we want even invisible traces to make their would-be subplots visible
	    // so coerce the subplot id(s) now no matter what
	    var _module = plots.getModule(traceOut);
	
	    traceOut._module = _module;
	    if(_module) {
	        var basePlotModule = _module.basePlotModule;
	        var subplotAttr = basePlotModule.attr;
	        var subplotAttrs = basePlotModule.attributes;
	        if(subplotAttr && subplotAttrs) {
	            var subplots = layout._subplots;
	            var subplotId = '';
	
	            // TODO - currently if we draw an empty gl2d subplot, it draws
	            // nothing then gets stuck and you can't get it back without newPlot
	            // sort this out in the regl refactor? but for now just drop empty gl2d subplots
	            if(basePlotModule.name !== 'gl2d' || visible) {
	                if(Array.isArray(subplotAttr)) {
	                    for(i = 0; i < subplotAttr.length; i++) {
	                        var attri = subplotAttr[i];
	                        var vali = Lib.coerce(traceIn, traceOut, subplotAttrs, attri);
	
	                        if(subplots[attri]) Lib.pushUnique(subplots[attri], vali);
	                        subplotId += vali;
	                    }
	                } else {
	                    subplotId = Lib.coerce(traceIn, traceOut, subplotAttrs, subplotAttr);
	                }
	
	                if(subplots[basePlotModule.name]) {
	                    Lib.pushUnique(subplots[basePlotModule.name], subplotId);
	                }
	            }
	        }
	    }
	
	    if(visible) {
	        coerce('customdata');
	        coerce('ids');
	        coerce('meta');
	
	        if(Registry.traceIs(traceOut, 'showLegend')) {
	            traceOut._dfltShowLegend = true;
	            coerce('showlegend');
	            coerce('legendgroup');
	        } else {
	            traceOut._dfltShowLegend = false;
	        }
	
	        if(_module) {
	            _module.supplyDefaults(traceIn, traceOut, defaultColor, layout);
	        }
	
	        if(!Registry.traceIs(traceOut, 'noOpacity')) {
	            coerce('opacity');
	        }
	
	        if(Registry.traceIs(traceOut, 'notLegendIsolatable')) {
	            // This clears out the legendonly state for traces like carpet that
	            // cannot be isolated in the legend
	            traceOut.visible = !!traceOut.visible;
	        }
	
	        if(!Registry.traceIs(traceOut, 'noHover')) {
	            if(!traceOut.hovertemplate) Lib.coerceHoverinfo(traceIn, traceOut, layout);
	
	            // parcats support hover, but not hoverlabel stylings (yet)
	            if(traceOut.type !== 'parcats') {
	                Registry.getComponentMethod('fx', 'supplyDefaults')(traceIn, traceOut, defaultColor, layout);
	            }
	        }
	
	        if(_module && _module.selectPoints) {
	            coerce('selectedpoints');
	        }
	
	        plots.supplyTransformDefaults(traceIn, traceOut, layout);
	    }
	
	    return traceOut;
	};
	
	/**
	 * hasMakesDataTransform: does this trace have a transform that makes its own
	 * data, either by grabbing it from somewhere else or by creating it from input
	 * parameters? If so, we should still keep going with supplyDefaults
	 * even if the trace is invisible, which may just be because it has no data yet.
	 */
	function hasMakesDataTransform(trace) {
	    var transforms = trace.transforms;
	    if(Array.isArray(transforms) && transforms.length) {
	        for(var i = 0; i < transforms.length; i++) {
	            var ti = transforms[i];
	            var _module = ti._module || transformsRegistry[ti.type];
	            if(_module && _module.makesData) return true;
	        }
	    }
	    return false;
	}
	
	plots.hasMakesDataTransform = hasMakesDataTransform;
	
	plots.supplyTransformDefaults = function(traceIn, traceOut, layout) {
	    // For now we only allow transforms on 1D traces, ie those that specify a _length.
	    // If we were to implement 2D transforms, we'd need to have each transform
	    // describe its own applicability and disable itself when it doesn't apply.
	    // Also allow transforms that make their own data, but not in globalTransforms
	    if(!(traceOut._length || hasMakesDataTransform(traceIn))) return;
	
	    var globalTransforms = layout._globalTransforms || [];
	    var transformModules = layout._transformModules || [];
	
	    if(!Array.isArray(traceIn.transforms) && globalTransforms.length === 0) return;
	
	    var containerIn = traceIn.transforms || [];
	    var transformList = globalTransforms.concat(containerIn);
	    var containerOut = traceOut.transforms = [];
	
	    for(var i = 0; i < transformList.length; i++) {
	        var transformIn = transformList[i];
	        var type = transformIn.type;
	        var _module = transformsRegistry[type];
	        var transformOut;
	
	        /*
	         * Supply defaults may run twice. First pass runs all supply defaults steps
	         * and adds the _module to any output transforms.
	         * If transforms exist another pass is run so that any generated traces also
	         * go through supply defaults. This has the effect of rerunning
	         * supplyTransformDefaults. If the transform does not have a `transform`
	         * function it could not have generated any new traces and the second stage
	         * is unnecessary. We detect this case with the following variables.
	         */
	        var isFirstStage = !(transformIn._module && transformIn._module === _module);
	        var doLaterStages = _module && typeof _module.transform === 'function';
	
	        if(!_module) Lib.warn('Unrecognized transform type ' + type + '.');
	
	        if(_module && _module.supplyDefaults && (isFirstStage || doLaterStages)) {
	            transformOut = _module.supplyDefaults(transformIn, traceOut, layout, traceIn);
	            transformOut.type = type;
	            transformOut._module = _module;
	
	            Lib.pushUnique(transformModules, _module);
	        } else {
	            transformOut = Lib.extendFlat({}, transformIn);
	        }
	
	        containerOut.push(transformOut);
	    }
	};
	
	function applyTransforms(fullTrace, fullData, layout, fullLayout) {
	    var container = fullTrace.transforms;
	    var dataOut = [fullTrace];
	
	    for(var i = 0; i < container.length; i++) {
	        var transform = container[i];
	        var _module = transformsRegistry[transform.type];
	
	        if(_module && _module.transform) {
	            dataOut = _module.transform(dataOut, {
	                transform: transform,
	                fullTrace: fullTrace,
	                fullData: fullData,
	                layout: layout,
	                fullLayout: fullLayout,
	                transformIndex: i
	            });
	        }
	    }
	
	    return dataOut;
	}
	
	plots.supplyLayoutGlobalDefaults = function(layoutIn, layoutOut, formatObj) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, plots.layoutAttributes, attr, dflt);
	    }
	
	    var template = layoutIn.template;
	    if(Lib.isPlainObject(template)) {
	        layoutOut.template = template;
	        layoutOut._template = template.layout;
	        layoutOut._dataTemplate = template.data;
	    }
	
	    var globalFont = Lib.coerceFont(coerce, 'font');
	
	    coerce('title.text', layoutOut._dfltTitle.plot);
	
	    Lib.coerceFont(coerce, 'title.font', {
	        family: globalFont.family,
	        size: Math.round(globalFont.size * 1.4),
	        color: globalFont.color
	    });
	
	    coerce('title.xref');
	    coerce('title.yref');
	    coerce('title.x');
	    coerce('title.y');
	    coerce('title.xanchor');
	    coerce('title.yanchor');
	    coerce('title.pad.t');
	    coerce('title.pad.r');
	    coerce('title.pad.b');
	    coerce('title.pad.l');
	
	    // Make sure that autosize is defaulted to *true*
	    // on layouts with no set width and height for backward compatibly,
	    // in particular https://plot.ly/javascript/responsive-fluid-layout/
	    //
	    // Before https://github.com/plotly/plotly.js/pull/635 ,
	    // layouts with no set width and height were set temporary set to 'initial'
	    // to pass through the autosize routine
	    //
	    // This behavior is subject to change in v2.
	    coerce('autosize', !(layoutIn.width && layoutIn.height));
	
	    coerce('width');
	    coerce('height');
	    coerce('margin.l');
	    coerce('margin.r');
	    coerce('margin.t');
	    coerce('margin.b');
	    coerce('margin.pad');
	    coerce('margin.autoexpand');
	
	    if(layoutIn.width && layoutIn.height) plots.sanitizeMargins(layoutOut);
	
	    Registry.getComponentMethod('grid', 'sizeDefaults')(layoutIn, layoutOut);
	
	    coerce('paper_bgcolor');
	
	    coerce('separators', formatObj.decimal + formatObj.thousands);
	    coerce('hidesources');
	
	    coerce('colorway');
	
	    coerce('datarevision');
	    var uirevision = coerce('uirevision');
	    coerce('editrevision', uirevision);
	    coerce('selectionrevision', uirevision);
	
	    coerce('modebar.orientation');
	    coerce('modebar.bgcolor', Color.addOpacity(layoutOut.paper_bgcolor, 0.5));
	    var modebarDefaultColor = Color.contrast(Color.rgb(layoutOut.modebar.bgcolor));
	    coerce('modebar.color', Color.addOpacity(modebarDefaultColor, 0.3));
	    coerce('modebar.activecolor', Color.addOpacity(modebarDefaultColor, 0.7));
	    coerce('modebar.uirevision', uirevision);
	
	    coerce('meta');
	
	    // do not include defaults in fullLayout when users do not set transition
	    if(Lib.isPlainObject(layoutIn.transition)) {
	        coerce('transition.duration');
	        coerce('transition.easing');
	        coerce('transition.ordering');
	    }
	
	    Registry.getComponentMethod(
	        'calendars',
	        'handleDefaults'
	    )(layoutIn, layoutOut, 'calendar');
	
	    Registry.getComponentMethod(
	        'fx',
	        'supplyLayoutGlobalDefaults'
	    )(layoutIn, layoutOut, coerce);
	};
	
	plots.plotAutoSize = function plotAutoSize(gd, layout, fullLayout) {
	    var context = gd._context || {};
	    var frameMargins = context.frameMargins;
	    var newWidth;
	    var newHeight;
	
	    var isPlotDiv = Lib.isPlotDiv(gd);
	
	    if(isPlotDiv) gd.emit('plotly_autosize');
	
	    // embedded in an iframe - just take the full iframe size
	    // if we get to this point, with no aspect ratio restrictions
	    if(context.fillFrame) {
	        newWidth = window.innerWidth;
	        newHeight = window.innerHeight;
	
	        // somehow we get a few extra px height sometimes...
	        // just hide it
	        document.body.style.overflow = 'hidden';
	    } else {
	        // plotly.js - let the developers do what they want, either
	        // provide height and width for the container div,
	        // specify size in layout, or take the defaults,
	        // but don't enforce any ratio restrictions
	        var computedStyle = isPlotDiv ? window.getComputedStyle(gd) : {};
	
	        newWidth = parseFloat(computedStyle.width) || parseFloat(computedStyle.maxWidth) || fullLayout.width;
	        newHeight = parseFloat(computedStyle.height) || parseFloat(computedStyle.maxHeight) || fullLayout.height;
	
	        if(isNumeric(frameMargins) && frameMargins > 0) {
	            var factor = 1 - 2 * frameMargins;
	            newWidth = Math.round(factor * newWidth);
	            newHeight = Math.round(factor * newHeight);
	        }
	    }
	
	    var minWidth = plots.layoutAttributes.width.min;
	    var minHeight = plots.layoutAttributes.height.min;
	    if(newWidth < minWidth) newWidth = minWidth;
	    if(newHeight < minHeight) newHeight = minHeight;
	
	    var widthHasChanged = !layout.width &&
	        (Math.abs(fullLayout.width - newWidth) > 1);
	    var heightHasChanged = !layout.height &&
	        (Math.abs(fullLayout.height - newHeight) > 1);
	
	    if(heightHasChanged || widthHasChanged) {
	        if(widthHasChanged) fullLayout.width = newWidth;
	        if(heightHasChanged) fullLayout.height = newHeight;
	    }
	
	    // cache initial autosize value, used in relayout when
	    // width or height values are set to null
	    if(!gd._initialAutoSize) {
	        gd._initialAutoSize = { width: newWidth, height: newHeight };
	    }
	
	    plots.sanitizeMargins(fullLayout);
	};
	
	plots.supplyLayoutModuleDefaults = function(layoutIn, layoutOut, fullData, transitionData) {
	    var componentsRegistry = Registry.componentsRegistry;
	    var basePlotModules = layoutOut._basePlotModules;
	    var component, i, _module;
	
	    var Cartesian = Registry.subplotsRegistry.cartesian;
	
	    // check if any components need to add more base plot modules
	    // that weren't captured by traces
	    for(component in componentsRegistry) {
	        _module = componentsRegistry[component];
	
	        if(_module.includeBasePlot) {
	            _module.includeBasePlot(layoutIn, layoutOut);
	        }
	    }
	
	    // make sure we *at least* have some cartesian axes
	    if(!basePlotModules.length) {
	        basePlotModules.push(Cartesian);
	    }
	
	    // ensure all cartesian axes have at least one subplot
	    if(layoutOut._has('cartesian')) {
	        Registry.getComponentMethod('grid', 'contentDefaults')(layoutIn, layoutOut);
	        Cartesian.finalizeSubplots(layoutIn, layoutOut);
	    }
	
	    // sort subplot lists
	    for(var subplotType in layoutOut._subplots) {
	        layoutOut._subplots[subplotType].sort(Lib.subplotSort);
	    }
	
	    // base plot module layout defaults
	    for(i = 0; i < basePlotModules.length; i++) {
	        _module = basePlotModules[i];
	
	        // e.g. pie does not have a layout-defaults step
	        if(_module.supplyLayoutDefaults) {
	            _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	        }
	    }
	
	    // trace module layout defaults
	    // use _modules rather than _visibleModules so that even
	    // legendonly traces can include settings - eg barmode, which affects
	    // legend.traceorder default value.
	    var modules = layoutOut._modules;
	    for(i = 0; i < modules.length; i++) {
	        _module = modules[i];
	
	        if(_module.supplyLayoutDefaults) {
	            _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	        }
	    }
	
	    // transform module layout defaults
	    var transformModules = layoutOut._transformModules;
	    for(i = 0; i < transformModules.length; i++) {
	        _module = transformModules[i];
	
	        if(_module.supplyLayoutDefaults) {
	            _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData, transitionData);
	        }
	    }
	
	    for(component in componentsRegistry) {
	        _module = componentsRegistry[component];
	
	        if(_module.supplyLayoutDefaults) {
	            _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	        }
	    }
	};
	
	// Remove all plotly attributes from a div so it can be replotted fresh
	// TODO: these really need to be encapsulated into a much smaller set...
	plots.purge = function(gd) {
	    // note: we DO NOT remove _context because it doesn't change when we insert
	    // a new plot, and may have been set outside of our scope.
	
	    var fullLayout = gd._fullLayout || {};
	    if(fullLayout._glcontainer !== undefined) {
	        fullLayout._glcontainer.selectAll('.gl-canvas').remove();
	        fullLayout._glcontainer.remove();
	        fullLayout._glcanvas = null;
	    }
	
	    // remove modebar
	    if(fullLayout._modeBar) fullLayout._modeBar.destroy();
	
	    if(gd._transitionData) {
	        // Ensure any dangling callbacks are simply dropped if the plot is purged.
	        // This is more or less only actually important for testing.
	        if(gd._transitionData._interruptCallbacks) {
	            gd._transitionData._interruptCallbacks.length = 0;
	        }
	
	        if(gd._transitionData._animationRaf) {
	            window.cancelAnimationFrame(gd._transitionData._animationRaf);
	        }
	    }
	
	    // remove any planned throttles
	    Lib.clearThrottle();
	
	    // remove responsive handler
	    Lib.clearResponsive(gd);
	
	    // data and layout
	    delete gd.data;
	    delete gd.layout;
	    delete gd._fullData;
	    delete gd._fullLayout;
	    delete gd.calcdata;
	    delete gd.framework;
	    delete gd.empty;
	
	    delete gd.fid;
	
	    delete gd.undoqueue; // action queue
	    delete gd.undonum;
	    delete gd.autoplay; // are we doing an action that doesn't go in undo queue?
	    delete gd.changed;
	
	    // these get recreated on Plotly.plot anyway, but just to be safe
	    // (and to have a record of them...)
	    delete gd._promises;
	    delete gd._redrawTimer;
	    delete gd._hmlumcount;
	    delete gd._hmpixcount;
	    delete gd._transitionData;
	    delete gd._transitioning;
	    delete gd._initialAutoSize;
	    delete gd._transitioningWithDuration;
	
	    // created during certain events, that *should* clean them up
	    // themselves, but may not if there was an error
	    delete gd._dragging;
	    delete gd._dragged;
	    delete gd._dragdata;
	    delete gd._hoverdata;
	    delete gd._snapshotInProgress;
	    delete gd._editing;
	    delete gd._mouseDownTime;
	    delete gd._legendMouseDownTime;
	
	    // remove all event listeners
	    if(gd.removeAllListeners) gd.removeAllListeners();
	};
	
	plots.style = function(gd) {
	    var _modules = gd._fullLayout._visibleModules;
	    var styleModules = [];
	    var i;
	
	    // some trace modules reuse the same style method,
	    // make sure to not unnecessary call them multiple times.
	
	    for(i = 0; i < _modules.length; i++) {
	        var _module = _modules[i];
	        if(_module.style) {
	            Lib.pushUnique(styleModules, _module.style);
	        }
	    }
	
	    for(i = 0; i < styleModules.length; i++) {
	        styleModules[i](gd);
	    }
	};
	
	plots.sanitizeMargins = function(fullLayout) {
	    // polar doesn't do margins...
	    if(!fullLayout || !fullLayout.margin) return;
	
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	    var margin = fullLayout.margin;
	    var plotWidth = width - (margin.l + margin.r);
	    var plotHeight = height - (margin.t + margin.b);
	    var correction;
	
	    // if margin.l + margin.r = 0 then plotWidth > 0
	    // as width >= 10 by supplyDefaults
	    // similarly for margin.t + margin.b
	
	    if(plotWidth < 0) {
	        correction = (width - 1) / (margin.l + margin.r);
	        margin.l = Math.floor(correction * margin.l);
	        margin.r = Math.floor(correction * margin.r);
	    }
	
	    if(plotHeight < 0) {
	        correction = (height - 1) / (margin.t + margin.b);
	        margin.t = Math.floor(correction * margin.t);
	        margin.b = Math.floor(correction * margin.b);
	    }
	};
	
	plots.clearAutoMarginIds = function(gd) {
	    gd._fullLayout._pushmarginIds = {};
	};
	
	plots.allowAutoMargin = function(gd, id) {
	    gd._fullLayout._pushmarginIds[id] = 1;
	};
	
	function initMargins(fullLayout) {
	    var margin = fullLayout.margin;
	
	    if(!fullLayout._size) {
	        var gs = fullLayout._size = {
	            l: Math.round(margin.l),
	            r: Math.round(margin.r),
	            t: Math.round(margin.t),
	            b: Math.round(margin.b),
	            p: Math.round(margin.pad)
	        };
	        gs.w = Math.round(fullLayout.width) - gs.l - gs.r;
	        gs.h = Math.round(fullLayout.height) - gs.t - gs.b;
	    }
	    if(!fullLayout._pushmargin) fullLayout._pushmargin = {};
	    if(!fullLayout._pushmarginIds) fullLayout._pushmarginIds = {};
	}
	
	/**
	 * autoMargin: called by components that may need to expand the margins to
	 * be rendered on-plot.
	 *
	 * @param {DOM element} gd
	 * @param {string} id - an identifier unique (within this plot) to this object,
	 *     so we can remove a previous margin expansion from the same object.
	 * @param {object} o - the margin requirements of this object, or omit to delete
	 *     this entry (like if it's hidden). Keys are:
	 *     x, y: plot fraction of the anchor point.
	 *     xl, xr, yt, yb: if the object has an extent defined in plot fraction,
	 *         you can specify both edges as plot fractions in each dimension
	 *     l, r, t, b: the pixels to pad past the plot fraction x[l|r] and y[t|b]
	 *     pad: extra pixels to add in all directions, default 12 (why?)
	 */
	plots.autoMargin = function(gd, id, o) {
	    var fullLayout = gd._fullLayout;
	
	    var pushMargin = fullLayout._pushmargin;
	    var pushMarginIds = fullLayout._pushmarginIds;
	
	    if(fullLayout.margin.autoexpand !== false) {
	        if(!o) {
	            delete pushMargin[id];
	            delete pushMarginIds[id];
	        } else {
	            var pad = o.pad;
	            if(pad === undefined) {
	                var margin = fullLayout.margin;
	                // if no explicit pad is given, use 12px unless there's a
	                // specified margin that's smaller than that
	                pad = Math.min(12, margin.l, margin.r, margin.t, margin.b);
	            }
	
	            // if the item is too big, just give it enough automargin to
	            // make sure you can still grab it and bring it back
	            if(o.l + o.r > fullLayout.width * 0.5) {
	                Lib.log('Margin push', id, 'is too big in x, dropping');
	                o.l = o.r = 0;
	            }
	            if(o.b + o.t > fullLayout.height * 0.5) {
	                Lib.log('Margin push', id, 'is too big in y, dropping');
	                o.b = o.t = 0;
	            }
	
	            var xl = o.xl !== undefined ? o.xl : o.x;
	            var xr = o.xr !== undefined ? o.xr : o.x;
	            var yt = o.yt !== undefined ? o.yt : o.y;
	            var yb = o.yb !== undefined ? o.yb : o.y;
	
	            pushMargin[id] = {
	                l: {val: xl, size: o.l + pad},
	                r: {val: xr, size: o.r + pad},
	                b: {val: yb, size: o.b + pad},
	                t: {val: yt, size: o.t + pad}
	            };
	            pushMarginIds[id] = 1;
	        }
	
	        if(!fullLayout._replotting) {
	            return plots.doAutoMargin(gd);
	        }
	    }
	};
	
	plots.doAutoMargin = function(gd) {
	    var fullLayout = gd._fullLayout;
	    if(!fullLayout._size) fullLayout._size = {};
	    initMargins(fullLayout);
	
	    var gs = fullLayout._size;
	    var margin = fullLayout.margin;
	    var oldMargins = Lib.extendFlat({}, gs);
	
	    // adjust margins for outside components
	    // fullLayout.margin is the requested margin,
	    // fullLayout._size has margins and plotsize after adjustment
	    var ml = margin.l;
	    var mr = margin.r;
	    var mt = margin.t;
	    var mb = margin.b;
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	    var pushMargin = fullLayout._pushmargin;
	    var pushMarginIds = fullLayout._pushmarginIds;
	
	    if(fullLayout.margin.autoexpand !== false) {
	        for(var k in pushMargin) {
	            if(!pushMarginIds[k]) delete pushMargin[k];
	        }
	
	        // fill in the requested margins
	        pushMargin.base = {
	            l: {val: 0, size: ml},
	            r: {val: 1, size: mr},
	            t: {val: 1, size: mt},
	            b: {val: 0, size: mb}
	        };
	
	        // now cycle through all the combinations of l and r
	        // (and t and b) to find the required margins
	
	        for(var k1 in pushMargin) {
	            var pushleft = pushMargin[k1].l || {};
	            var pushbottom = pushMargin[k1].b || {};
	            var fl = pushleft.val;
	            var pl = pushleft.size;
	            var fb = pushbottom.val;
	            var pb = pushbottom.size;
	
	            for(var k2 in pushMargin) {
	                if(isNumeric(pl) && pushMargin[k2].r) {
	                    var fr = pushMargin[k2].r.val;
	                    var pr = pushMargin[k2].r.size;
	
	                    if(fr > fl) {
	                        var newL = (pl * fr + (pr - width) * fl) / (fr - fl);
	                        var newR = (pr * (1 - fl) + (pl - width) * (1 - fr)) / (fr - fl);
	                        if(newL >= 0 && newR >= 0 && width - (newL + newR) > 0 && newL + newR > ml + mr) {
	                            ml = newL;
	                            mr = newR;
	                        }
	                    }
	                }
	
	                if(isNumeric(pb) && pushMargin[k2].t) {
	                    var ft = pushMargin[k2].t.val;
	                    var pt = pushMargin[k2].t.size;
	
	                    if(ft > fb) {
	                        var newB = (pb * ft + (pt - height) * fb) / (ft - fb);
	                        var newT = (pt * (1 - fb) + (pb - height) * (1 - ft)) / (ft - fb);
	                        if(newB >= 0 && newT >= 0 && height - (newT + newB) > 0 && newB + newT > mb + mt) {
	                            mb = newB;
	                            mt = newT;
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    gs.l = Math.round(ml);
	    gs.r = Math.round(mr);
	    gs.t = Math.round(mt);
	    gs.b = Math.round(mb);
	    gs.p = Math.round(margin.pad);
	    gs.w = Math.round(width) - gs.l - gs.r;
	    gs.h = Math.round(height) - gs.t - gs.b;
	
	    // if things changed and we're not already redrawing, trigger a redraw
	    if(!fullLayout._replotting && plots.didMarginChange(oldMargins, gs)) {
	        if('_redrawFromAutoMarginCount' in fullLayout) {
	            fullLayout._redrawFromAutoMarginCount++;
	        } else {
	            fullLayout._redrawFromAutoMarginCount = 1;
	        }
	
	        // Always allow at least one redraw and give each margin-push
	        // call 3 loops to converge. Of course, for most cases this way too many,
	        // but let's keep things on the safe side until we fix our
	        // auto-margin pipeline problems:
	        // https://github.com/plotly/plotly.js/issues/2704
	        var maxNumberOfRedraws = 3 * (1 + Object.keys(pushMarginIds).length);
	
	        if(fullLayout._redrawFromAutoMarginCount < maxNumberOfRedraws) {
	            return Registry.call('plot', gd);
	        } else {
	            Lib.warn('Too many auto-margin redraws.');
	        }
	    }
	};
	
	var marginKeys = ['l', 'r', 't', 'b', 'p', 'w', 'h'];
	
	plots.didMarginChange = function(margin0, margin1) {
	    for(var i = 0; i < marginKeys.length; i++) {
	        var k = marginKeys[i];
	        var m0 = margin0[k];
	        var m1 = margin1[k];
	        // use 1px tolerance in case we old/new differ only
	        // by rounding errors, which can lead to infinite loops
	        if(!isNumeric(m0) || Math.abs(m1 - m0) > 1) {
	            return true;
	        }
	    }
	    return false;
	};
	
	/**
	 * JSONify the graph data and layout
	 *
	 * This function needs to recurse because some src can be inside
	 * sub-objects.
	 *
	 * It also strips out functions and private (starts with _) elements.
	 * Therefore, we can add temporary things to data and layout that don't
	 * get saved.
	 *
	 * @param gd The graphDiv
	 * @param {Boolean} dataonly If true, don't return layout.
	 * @param {'keepref'|'keepdata'|'keepall'} [mode='keepref'] Filter what's kept
	 *      keepref: remove data for which there's a src present
	 *          eg if there's xsrc present (and xsrc is well-formed,
	 *          ie has : and some chars before it), strip out x
	 *      keepdata: remove all src tags, don't remove the data itself
	 *      keepall: keep data and src
	 * @param {String} output If you specify 'object', the result will not be stringified
	 * @param {Boolean} useDefaults If truthy, use _fullLayout and _fullData
	 * @returns {Object|String}
	 */
	plots.graphJson = function(gd, dataonly, mode, output, useDefaults) {
	    // if the defaults aren't supplied yet, we need to do that...
	    if((useDefaults && dataonly && !gd._fullData) ||
	            (useDefaults && !dataonly && !gd._fullLayout)) {
	        plots.supplyDefaults(gd);
	    }
	
	    var data = (useDefaults) ? gd._fullData : gd.data;
	    var layout = (useDefaults) ? gd._fullLayout : gd.layout;
	    var frames = (gd._transitionData || {})._frames;
	
	    function stripObj(d) {
	        if(typeof d === 'function') {
	            return null;
	        }
	        if(Lib.isPlainObject(d)) {
	            var o = {};
	            var v, src;
	            for(v in d) {
	                // remove private elements and functions
	                // _ is for private, [ is a mistake ie [object Object]
	                if(typeof d[v] === 'function' ||
	                        ['_', '['].indexOf(v.charAt(0)) !== -1) {
	                    continue;
	                }
	
	                // look for src/data matches and remove the appropriate one
	                if(mode === 'keepdata') {
	                    // keepdata: remove all ...src tags
	                    if(v.substr(v.length - 3) === 'src') {
	                        continue;
	                    }
	                } else if(mode === 'keepstream') {
	                    // keep sourced data if it's being streamed.
	                    // similar to keepref, but if the 'stream' object exists
	                    // in a trace, we will keep the data array.
	                    src = d[v + 'src'];
	                    if(typeof src === 'string' && src.indexOf(':') > 0) {
	                        if(!Lib.isPlainObject(d.stream)) {
	                            continue;
	                        }
	                    }
	                } else if(mode !== 'keepall') {
	                    // keepref: remove sourced data but only
	                    // if the source tag is well-formed
	                    src = d[v + 'src'];
	                    if(typeof src === 'string' && src.indexOf(':') > 0) {
	                        continue;
	                    }
	                }
	
	                // OK, we're including this... recurse into it
	                o[v] = stripObj(d[v]);
	            }
	            return o;
	        }
	
	        if(Array.isArray(d)) {
	            return d.map(stripObj);
	        }
	
	        if(Lib.isTypedArray(d)) {
	            return Lib.simpleMap(d, Lib.identity);
	        }
	
	        // convert native dates to date strings...
	        // mostly for external users exporting to plotly
	        if(Lib.isJSDate(d)) return Lib.ms2DateTimeLocal(+d);
	
	        return d;
	    }
	
	    var obj = {
	        data: (data || []).map(function(v) {
	            var d = stripObj(v);
	            // fit has some little arrays in it that don't contain data,
	            // just fit params and meta
	            if(dataonly) { delete d.fit; }
	            return d;
	        })
	    };
	    if(!dataonly) { obj.layout = stripObj(layout); }
	
	    if(gd.framework && gd.framework.isPolar) obj = gd.framework.getConfig();
	
	    if(frames) obj.frames = stripObj(frames);
	
	    return (output === 'object') ? obj : JSON.stringify(obj);
	};
	
	/**
	 * Modify a keyframe using a list of operations:
	 *
	 * @param {array of objects} operations
	 *      Sequence of operations to be performed on the keyframes
	 */
	plots.modifyFrames = function(gd, operations) {
	    var i, op, frame;
	    var _frames = gd._transitionData._frames;
	    var _frameHash = gd._transitionData._frameHash;
	
	    for(i = 0; i < operations.length; i++) {
	        op = operations[i];
	
	        switch(op.type) {
	            // No reason this couldn't exist, but is currently unused/untested:
	            /* case 'rename':
	                frame = _frames[op.index];
	                delete _frameHash[frame.name];
	                _frameHash[op.name] = frame;
	                frame.name = op.name;
	                break;*/
	            case 'replace':
	                frame = op.value;
	                var oldName = (_frames[op.index] || {}).name;
	                var newName = frame.name;
	                _frames[op.index] = _frameHash[newName] = frame;
	
	                if(newName !== oldName) {
	                    // If name has changed in addition to replacement, then update
	                    // the lookup table:
	                    delete _frameHash[oldName];
	                    _frameHash[newName] = frame;
	                }
	
	                break;
	            case 'insert':
	                frame = op.value;
	                _frameHash[frame.name] = frame;
	                _frames.splice(op.index, 0, frame);
	                break;
	            case 'delete':
	                frame = _frames[op.index];
	                delete _frameHash[frame.name];
	                _frames.splice(op.index, 1);
	                break;
	        }
	    }
	
	    return Promise.resolve();
	};
	
	/*
	 * Compute a keyframe. Merge a keyframe into its base frame(s) and
	 * expand properties.
	 *
	 * @param {object} frameLookup
	 *      An object containing frames keyed by name (i.e. gd._transitionData._frameHash)
	 * @param {string} frame
	 *      The name of the keyframe to be computed
	 *
	 * Returns: a new object with the merged content
	 */
	plots.computeFrame = function(gd, frameName) {
	    var frameLookup = gd._transitionData._frameHash;
	    var i, traceIndices, traceIndex, destIndex;
	
	    // Null or undefined will fail on .toString(). We'll allow numbers since we
	    // make it clear frames must be given string names, but we'll allow numbers
	    // here since they're otherwise fine for looking up frames as long as they're
	    // properly cast to strings. We really just want to ensure here that this
	    // 1) doesn't fail, and
	    // 2) doens't give an incorrect answer (which String(frameName) would)
	    if(!frameName) {
	        throw new Error('computeFrame must be given a string frame name');
	    }
	
	    var framePtr = frameLookup[frameName.toString()];
	
	    // Return false if the name is invalid:
	    if(!framePtr) {
	        return false;
	    }
	
	    var frameStack = [framePtr];
	    var frameNameStack = [framePtr.name];
	
	    // Follow frame pointers:
	    while(framePtr.baseframe && (framePtr = frameLookup[framePtr.baseframe.toString()])) {
	        // Avoid infinite loops:
	        if(frameNameStack.indexOf(framePtr.name) !== -1) break;
	
	        frameStack.push(framePtr);
	        frameNameStack.push(framePtr.name);
	    }
	
	    // A new object for the merged result:
	    var result = {};
	
	    // Merge, starting with the last and ending with the desired frame:
	    while((framePtr = frameStack.pop())) {
	        if(framePtr.layout) {
	            result.layout = plots.extendLayout(result.layout, framePtr.layout);
	        }
	
	        if(framePtr.data) {
	            if(!result.data) {
	                result.data = [];
	            }
	            traceIndices = framePtr.traces;
	
	            if(!traceIndices) {
	                // If not defined, assume serial order starting at zero
	                traceIndices = [];
	                for(i = 0; i < framePtr.data.length; i++) {
	                    traceIndices[i] = i;
	                }
	            }
	
	            if(!result.traces) {
	                result.traces = [];
	            }
	
	            for(i = 0; i < framePtr.data.length; i++) {
	                // Loop through this frames data, find out where it should go,
	                // and merge it!
	                traceIndex = traceIndices[i];
	                if(traceIndex === undefined || traceIndex === null) {
	                    continue;
	                }
	
	                destIndex = result.traces.indexOf(traceIndex);
	                if(destIndex === -1) {
	                    destIndex = result.data.length;
	                    result.traces[destIndex] = traceIndex;
	                }
	
	                result.data[destIndex] = plots.extendTrace(result.data[destIndex], framePtr.data[i]);
	            }
	        }
	    }
	
	    return result;
	};
	
	/*
	 * Recompute the lookup table that maps frame name -> frame object. addFrames/
	 * deleteFrames already manages this data one at a time, so the only time this
	 * is necessary is if you poke around manually in `gd._transitionData._frames`
	 * and create and haven't updated the lookup table.
	 */
	plots.recomputeFrameHash = function(gd) {
	    var hash = gd._transitionData._frameHash = {};
	    var frames = gd._transitionData._frames;
	    for(var i = 0; i < frames.length; i++) {
	        var frame = frames[i];
	        if(frame && frame.name) {
	            hash[frame.name] = frame;
	        }
	    }
	};
	
	/**
	 * Extend an object, treating container arrays very differently by extracting
	 * their contents and merging them separately.
	 *
	 * This exists so that we can extendDeepNoArrays and avoid stepping into data
	 * arrays without knowledge of the plot schema, but so that we may also manually
	 * recurse into known container arrays, such as transforms.
	 *
	 * See extendTrace and extendLayout below for usage.
	 */
	plots.extendObjectWithContainers = function(dest, src, containerPaths) {
	    var containerProp, containerVal, i, j, srcProp, destProp, srcContainer, destContainer;
	    var copy = Lib.extendDeepNoArrays({}, src || {});
	    var expandedObj = Lib.expandObjectPaths(copy);
	    var containerObj = {};
	
	    // Step through and extract any container properties. Otherwise extendDeepNoArrays
	    // will clobber any existing properties with an empty array and then supplyDefaults
	    // will reset everything to defaults.
	    if(containerPaths && containerPaths.length) {
	        for(i = 0; i < containerPaths.length; i++) {
	            containerProp = Lib.nestedProperty(expandedObj, containerPaths[i]);
	            containerVal = containerProp.get();
	
	            if(containerVal === undefined) {
	                Lib.nestedProperty(containerObj, containerPaths[i]).set(null);
	            } else {
	                containerProp.set(null);
	                Lib.nestedProperty(containerObj, containerPaths[i]).set(containerVal);
	            }
	        }
	    }
	
	    dest = Lib.extendDeepNoArrays(dest || {}, expandedObj);
	
	    if(containerPaths && containerPaths.length) {
	        for(i = 0; i < containerPaths.length; i++) {
	            srcProp = Lib.nestedProperty(containerObj, containerPaths[i]);
	            srcContainer = srcProp.get();
	
	            if(!srcContainer) continue;
	
	            destProp = Lib.nestedProperty(dest, containerPaths[i]);
	            destContainer = destProp.get();
	
	            if(!Array.isArray(destContainer)) {
	                destContainer = [];
	                destProp.set(destContainer);
	            }
	
	            for(j = 0; j < srcContainer.length; j++) {
	                var srcObj = srcContainer[j];
	
	                if(srcObj === null) destContainer[j] = null;
	                else {
	                    destContainer[j] = plots.extendObjectWithContainers(destContainer[j], srcObj);
	                }
	            }
	
	            destProp.set(destContainer);
	        }
	    }
	
	    return dest;
	};
	
	plots.dataArrayContainers = ['transforms', 'dimensions'];
	plots.layoutArrayContainers = Registry.layoutArrayContainers;
	
	/*
	 * Extend a trace definition. This method:
	 *
	 *  1. directly transfers any array references
	 *  2. manually recurses into container arrays like transforms
	 *
	 * The result is the original object reference with the new contents merged in.
	 */
	plots.extendTrace = function(destTrace, srcTrace) {
	    return plots.extendObjectWithContainers(destTrace, srcTrace, plots.dataArrayContainers);
	};
	
	/*
	 * Extend a layout definition. This method:
	 *
	 *  1. directly transfers any array references (not critically important for
	 *     layout since there aren't really data arrays)
	 *  2. manually recurses into container arrays like annotations
	 *
	 * The result is the original object reference with the new contents merged in.
	 */
	plots.extendLayout = function(destLayout, srcLayout) {
	    return plots.extendObjectWithContainers(destLayout, srcLayout, plots.layoutArrayContainers);
	};
	
	/**
	 * Transition to a set of new data and layout properties from Plotly.animate
	 *
	 * @param {DOM element} gd
	 * @param {Object[]} data
	 *      an array of data objects following the normal Plotly data definition format
	 * @param {Object} layout
	 *      a layout object, following normal Plotly layout format
	 * @param {Number[]} traces
	 *      indices of the corresponding traces specified in `data`
	 * @param {Object} frameOpts
	 *      options for the frame (i.e. whether to redraw post-transition)
	 * @param {Object} transitionOpts
	 *      options for the transition
	 */
	plots.transition = function(gd, data, layout, traces, frameOpts, transitionOpts) {
	    var opts = {redraw: frameOpts.redraw};
	    var transitionedTraces = {};
	    var axEdits = [];
	
	    opts.prepareFn = function() {
	        var dataLength = Array.isArray(data) ? data.length : 0;
	        var traceIndices = traces.slice(0, dataLength);
	
	        for(var i = 0; i < traceIndices.length; i++) {
	            var traceIdx = traceIndices[i];
	            var trace = gd._fullData[traceIdx];
	            var _module = trace._module;
	
	            // There's nothing to do if this module is not defined:
	            if(!_module) continue;
	
	            // Don't register the trace as transitioned if it doesn't know what to do.
	            // If it *is* registered, it will receive a callback that it's responsible
	            // for calling in order to register the transition as having completed.
	            if(_module.animatable) {
	                var n = _module.basePlotModule.name;
	                if(!transitionedTraces[n]) transitionedTraces[n] = [];
	                transitionedTraces[n].push(traceIdx);
	            }
	
	            gd.data[traceIndices[i]] = plots.extendTrace(gd.data[traceIndices[i]], data[i]);
	        }
	
	        // Follow the same procedure. Clone it so we don't mangle the input, then
	        // expand any object paths so we can merge deep into gd.layout:
	        var layoutUpdate = Lib.expandObjectPaths(Lib.extendDeepNoArrays({}, layout));
	
	        // Before merging though, we need to modify the incoming layout. We only
	        // know how to *transition* layout ranges, so it's imperative that a new
	        // range not be sent to the layout before the transition has started. So
	        // we must remove the things we can transition:
	        var axisAttrRe = /^[xy]axis[0-9]*$/;
	        for(var attr in layoutUpdate) {
	            if(!axisAttrRe.test(attr)) continue;
	            delete layoutUpdate[attr].range;
	        }
	
	        plots.extendLayout(gd.layout, layoutUpdate);
	
	        // Supply defaults after applying the incoming properties. Note that any attempt
	        // to simplify this step and reduce the amount of work resulted in the reconstruction
	        // of essentially the whole supplyDefaults step, so that it seems sensible to just use
	        // supplyDefaults even though it's heavier than would otherwise be desired for
	        // transitions:
	
	        // first delete calcdata so supplyDefaults knows a calc step is coming
	        delete gd.calcdata;
	
	        plots.supplyDefaults(gd);
	        plots.doCalcdata(gd);
	
	        var newLayout = Lib.expandObjectPaths(layout);
	
	        if(newLayout) {
	            var subplots = gd._fullLayout._plots;
	
	            for(var k in subplots) {
	                var plotinfo = subplots[k];
	                var xa = plotinfo.xaxis;
	                var ya = plotinfo.yaxis;
	                var xr0 = xa.range.slice();
	                var yr0 = ya.range.slice();
	
	                var xr1 = null;
	                var yr1 = null;
	                var editX = null;
	                var editY = null;
	
	                if(Array.isArray(newLayout[xa._name + '.range'])) {
	                    xr1 = newLayout[xa._name + '.range'].slice();
	                } else if(Array.isArray((newLayout[xa._name] || {}).range)) {
	                    xr1 = newLayout[xa._name].range.slice();
	                }
	                if(Array.isArray(newLayout[ya._name + '.range'])) {
	                    yr1 = newLayout[ya._name + '.range'].slice();
	                } else if(Array.isArray((newLayout[ya._name] || {}).range)) {
	                    yr1 = newLayout[ya._name].range.slice();
	                }
	
	                if(xr0 && xr1 &&
	                    (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1]))
	                ) {
	                    editX = {xr0: xr0, xr1: xr1};
	                }
	                if(yr0 && yr1 &&
	                    (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1]))
	                ) {
	                    editY = {yr0: yr0, yr1: yr1};
	                }
	
	                if(editX || editY) {
	                    axEdits.push(Lib.extendFlat({plotinfo: plotinfo}, editX, editY));
	                }
	            }
	        }
	
	        return Promise.resolve();
	    };
	
	    opts.runFn = function(makeCallback) {
	        var traceTransitionOpts;
	        var basePlotModules = gd._fullLayout._basePlotModules;
	        var hasAxisTransition = axEdits.length;
	        var i;
	
	        if(layout) {
	            for(i = 0; i < basePlotModules.length; i++) {
	                if(basePlotModules[i].transitionAxes) {
	                    basePlotModules[i].transitionAxes(gd, axEdits, transitionOpts, makeCallback);
	                }
	            }
	        }
	
	        // Here handle the exception that we refuse to animate scales and axes at the same
	        // time. In other words, if there's an axis transition, then set the data transition
	        // to instantaneous.
	        if(hasAxisTransition) {
	            traceTransitionOpts = Lib.extendFlat({}, transitionOpts);
	            traceTransitionOpts.duration = 0;
	            // This means do not transition cartesian traces,
	            // this happens on layout-only (e.g. axis range) animations
	            delete transitionedTraces.cartesian;
	        } else {
	            traceTransitionOpts = transitionOpts;
	        }
	
	        // Note that we pass a callback to *create* the callback that must be invoked on completion.
	        // This is since not all traces know about transitions, so it greatly simplifies matters if
	        // the trace is responsible for creating a callback, if needed, and then executing it when
	        // the time is right.
	        for(var n in transitionedTraces) {
	            var traceIndices = transitionedTraces[n];
	            var _module = gd._fullData[traceIndices[0]]._module;
	            _module.basePlotModule.plot(gd, traceIndices, traceTransitionOpts, makeCallback);
	        }
	    };
	
	    return _transition(gd, transitionOpts, opts);
	};
	
	/**
	 * Transition to a set of new data and layout properties from Plotly.react
	 *
	 * @param {DOM element} gd
	 * @param {object} restyleFlags
	 * - anim {'all'|'some'}
	 * @param {object} relayoutFlags
	 * - anim {'all'|'some'}
	 * @param {object} oldFullLayout : old (pre Plotly.react) fullLayout
	 */
	plots.transitionFromReact = function(gd, restyleFlags, relayoutFlags, oldFullLayout) {
	    var fullLayout = gd._fullLayout;
	    var transitionOpts = fullLayout.transition;
	    var opts = {};
	    var axEdits = [];
	
	    opts.prepareFn = function() {
	        var subplots = fullLayout._plots;
	
	        // no need to redraw at end of transition,
	        // if all changes are animatable
	        opts.redraw = false;
	        if(restyleFlags.anim === 'some') opts.redraw = true;
	        if(relayoutFlags.anim === 'some') opts.redraw = true;
	
	        for(var k in subplots) {
	            var plotinfo = subplots[k];
	            var xa = plotinfo.xaxis;
	            var ya = plotinfo.yaxis;
	            var xr0 = oldFullLayout[xa._name].range.slice();
	            var yr0 = oldFullLayout[ya._name].range.slice();
	            var xr1 = xa.range.slice();
	            var yr1 = ya.range.slice();
	
	            xa.setScale();
	            ya.setScale();
	
	            var editX = null;
	            var editY = null;
	
	            if(xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1])) {
	                editX = {xr0: xr0, xr1: xr1};
	            }
	            if(ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1])) {
	                editY = {yr0: yr0, yr1: yr1};
	            }
	
	            if(editX || editY) {
	                axEdits.push(Lib.extendFlat({plotinfo: plotinfo}, editX, editY));
	            }
	        }
	
	        return Promise.resolve();
	    };
	
	    opts.runFn = function(makeCallback) {
	        var fullData = gd._fullData;
	        var fullLayout = gd._fullLayout;
	        var basePlotModules = fullLayout._basePlotModules;
	
	        var axisTransitionOpts;
	        var traceTransitionOpts;
	        var transitionedTraces;
	
	        var allTraceIndices = [];
	        for(var i = 0; i < fullData.length; i++) {
	            allTraceIndices.push(i);
	        }
	
	        function transitionAxes() {
	            for(var j = 0; j < basePlotModules.length; j++) {
	                if(basePlotModules[j].transitionAxes) {
	                    basePlotModules[j].transitionAxes(gd, axEdits, axisTransitionOpts, makeCallback);
	                }
	            }
	        }
	
	        function transitionTraces() {
	            for(var j = 0; j < basePlotModules.length; j++) {
	                basePlotModules[j].plot(gd, transitionedTraces, traceTransitionOpts, makeCallback);
	            }
	        }
	
	        if(axEdits.length && restyleFlags.anim) {
	            if(transitionOpts.ordering === 'traces first') {
	                axisTransitionOpts = Lib.extendFlat({}, transitionOpts, {duration: 0});
	                transitionedTraces = allTraceIndices;
	                traceTransitionOpts = transitionOpts;
	                setTimeout(transitionAxes, transitionOpts.duration);
	                transitionTraces();
	            } else {
	                axisTransitionOpts = transitionOpts;
	                transitionedTraces = null;
	                traceTransitionOpts = Lib.extendFlat({}, transitionOpts, {duration: 0});
	                setTimeout(transitionTraces, axisTransitionOpts.duration);
	                transitionAxes();
	            }
	        } else if(axEdits.length) {
	            axisTransitionOpts = transitionOpts;
	            transitionAxes();
	        } else if(restyleFlags.anim) {
	            transitionedTraces = allTraceIndices;
	            traceTransitionOpts = transitionOpts;
	            transitionTraces();
	        }
	    };
	
	    return _transition(gd, transitionOpts, opts);
	};
	
	/**
	 * trace/layout transition wrapper that works
	 * for transitions initiated by Plotly.animate and Plotly.react.
	 *
	 * @param {DOM element} gd
	 * @param {object} transitionOpts
	 * @param {object} opts
	 * - redraw {boolean}
	 * - prepareFn {function} *should return a Promise*
	 * - runFn {function} ran inside executeTransitions
	 */
	function _transition(gd, transitionOpts, opts) {
	    var aborted = false;
	
	    function executeCallbacks(list) {
	        var p = Promise.resolve();
	        if(!list) return p;
	        while(list.length) {
	            p = p.then((list.shift()));
	        }
	        return p;
	    }
	
	    function flushCallbacks(list) {
	        if(!list) return;
	        while(list.length) {
	            list.shift();
	        }
	    }
	
	    function executeTransitions() {
	        gd.emit('plotly_transitioning', []);
	
	        return new Promise(function(resolve) {
	            // This flag is used to disabled things like autorange:
	            gd._transitioning = true;
	
	            // When instantaneous updates are coming through quickly, it's too much to simply disable
	            // all interaction, so store this flag so we can disambiguate whether mouse interactions
	            // should be fully disabled or not:
	            if(transitionOpts.duration > 0) {
	                gd._transitioningWithDuration = true;
	            }
	
	            // If another transition is triggered, this callback will be executed simply because it's
	            // in the interruptCallbacks queue. If this transition completes, it will instead flush
	            // that queue and forget about this callback.
	            gd._transitionData._interruptCallbacks.push(function() {
	                aborted = true;
	            });
	
	            if(opts.redraw) {
	                gd._transitionData._interruptCallbacks.push(function() {
	                    return Registry.call('redraw', gd);
	                });
	            }
	
	            // Emit this and make sure it happens last:
	            gd._transitionData._interruptCallbacks.push(function() {
	                gd.emit('plotly_transitioninterrupted', []);
	            });
	
	            // Construct callbacks that are executed on transition end. This ensures the d3 transitions
	            // are *complete* before anything else is done.
	            var numCallbacks = 0;
	            var numCompleted = 0;
	            function makeCallback() {
	                numCallbacks++;
	                return function() {
	                    numCompleted++;
	                    // When all are complete, perform a redraw:
	                    if(!aborted && numCompleted === numCallbacks) {
	                        completeTransition(resolve);
	                    }
	                };
	            }
	
	            opts.runFn(makeCallback);
	
	            // If nothing else creates a callback, then this will trigger the completion in the next tick:
	            setTimeout(makeCallback());
	        });
	    }
	
	    function completeTransition(callback) {
	        // This a simple workaround for tests which purge the graph before animations
	        // have completed. That's not a very common case, so this is the simplest
	        // fix.
	        if(!gd._transitionData) return;
	
	        flushCallbacks(gd._transitionData._interruptCallbacks);
	
	        return Promise.resolve().then(function() {
	            if(opts.redraw) {
	                return Registry.call('redraw', gd);
	            }
	        }).then(function() {
	            // Set transitioning false again once the redraw has occurred. This is used, for example,
	            // to prevent the trailing redraw from autoranging:
	            gd._transitioning = false;
	            gd._transitioningWithDuration = false;
	
	            gd.emit('plotly_transitioned', []);
	        }).then(callback);
	    }
	
	    function interruptPreviousTransitions() {
	        // Fail-safe against purged plot:
	        if(!gd._transitionData) return;
	
	        // If a transition is interrupted, set this to false. At the moment, the only thing that would
	        // interrupt a transition is another transition, so that it will momentarily be set to true
	        // again, but this determines whether autorange or dragbox work, so it's for the sake of
	        // cleanliness:
	        gd._transitioning = false;
	
	        return executeCallbacks(gd._transitionData._interruptCallbacks);
	    }
	
	    var seq = [
	        plots.previousPromises,
	        interruptPreviousTransitions,
	        opts.prepareFn,
	        plots.rehover,
	        executeTransitions
	    ];
	
	    var transitionStarting = Lib.syncOrAsync(seq, gd);
	
	    if(!transitionStarting || !transitionStarting.then) {
	        transitionStarting = Promise.resolve();
	    }
	
	    return transitionStarting.then(function() { return gd; });
	}
	
	plots.doCalcdata = function(gd, traces) {
	    var axList = axisIDs.list(gd);
	    var fullData = gd._fullData;
	    var fullLayout = gd._fullLayout;
	
	    var trace, _module, i, j;
	
	    // XXX: Is this correct? Needs a closer look so that *some* traces can be recomputed without
	    // *all* needing doCalcdata:
	    var calcdata = new Array(fullData.length);
	    var oldCalcdata = (gd.calcdata || []).slice();
	    gd.calcdata = calcdata;
	
	    // extra helper variables
	
	    // how many box/violins plots do we have (in case they're grouped)
	    fullLayout._numBoxes = 0;
	    fullLayout._numViolins = 0;
	
	    // initialize violin per-scale-group stats container
	    fullLayout._violinScaleGroupStats = {};
	
	    // for calculating avg luminosity of heatmaps
	    gd._hmpixcount = 0;
	    gd._hmlumcount = 0;
	
	    // for sharing colors across pies / sunbursts / treemap / funnelarea (and for legend)
	    fullLayout._piecolormap = {};
	    fullLayout._sunburstcolormap = {};
	    fullLayout._treemapcolormap = {};
	    fullLayout._funnelareacolormap = {};
	
	    // If traces were specified and this trace was not included,
	    // then transfer it over from the old calcdata:
	    for(i = 0; i < fullData.length; i++) {
	        if(Array.isArray(traces) && traces.indexOf(i) === -1) {
	            calcdata[i] = oldCalcdata[i];
	            continue;
	        }
	    }
	
	    for(i = 0; i < fullData.length; i++) {
	        trace = fullData[i];
	
	        trace._arrayAttrs = PlotSchema.findArrayAttributes(trace);
	
	        // keep track of trace extremes (for autorange) in here
	        trace._extremes = {};
	    }
	
	    // add polar axes to axis list
	    var polarIds = fullLayout._subplots.polar || [];
	    for(i = 0; i < polarIds.length; i++) {
	        axList.push(
	            fullLayout[polarIds[i]].radialaxis,
	            fullLayout[polarIds[i]].angularaxis
	        );
	    }
	
	    // clear relinked cmin/cmax values in shared axes to start aggregation from scratch
	    for(var k in fullLayout._colorAxes) {
	        var cOpts = fullLayout[k];
	        if(cOpts.cauto !== false) {
	            delete cOpts.cmin;
	            delete cOpts.cmax;
	        }
	    }
	
	    var hasCalcTransform = false;
	
	    function transformCalci(i) {
	        trace = fullData[i];
	        _module = trace._module;
	
	        if(trace.visible === true && trace.transforms) {
	            // we need one round of trace module calc before
	            // the calc transform to 'fill in' the categories list
	            // used for example in the data-to-coordinate method
	            if(_module && _module.calc) {
	                var cdi = _module.calc(gd, trace);
	
	                // must clear scene 'batches', so that 2nd
	                // _module.calc call starts from scratch
	                if(cdi[0] && cdi[0].t && cdi[0].t._scene) {
	                    delete cdi[0].t._scene.dirty;
	                }
	            }
	
	            for(j = 0; j < trace.transforms.length; j++) {
	                var transform = trace.transforms[j];
	
	                _module = transformsRegistry[transform.type];
	                if(_module && _module.calcTransform) {
	                    trace._hasCalcTransform = true;
	                    hasCalcTransform = true;
	                    _module.calcTransform(gd, trace, transform);
	                }
	            }
	        }
	    }
	
	    function calci(i, isContainer) {
	        trace = fullData[i];
	        _module = trace._module;
	
	        if(!!_module.isContainer !== isContainer) return;
	
	        var cd = [];
	
	        if(trace.visible === true && trace._length !== 0) {
	            // clear existing ref in case it got relinked
	            delete trace._indexToPoints;
	            // keep ref of index-to-points map object of the *last* enabled transform,
	            // this index-to-points map object is required to determine the calcdata indices
	            // that correspond to input indices (e.g. from 'selectedpoints')
	            var transforms = trace.transforms || [];
	            for(j = transforms.length - 1; j >= 0; j--) {
	                if(transforms[j].enabled) {
	                    trace._indexToPoints = transforms[j]._indexToPoints;
	                    break;
	                }
	            }
	
	            if(_module && _module.calc) {
	                cd = _module.calc(gd, trace);
	            }
	        }
	
	        // Make sure there is a first point.
	        //
	        // This ensures there is a calcdata item for every trace,
	        // even if cartesian logic doesn't handle it (for things like legends).
	        if(!Array.isArray(cd) || !cd[0]) {
	            cd = [{x: BADNUM, y: BADNUM}];
	        }
	
	        // add the trace-wide properties to the first point,
	        // per point properties to every point
	        // t is the holder for trace-wide properties
	        if(!cd[0].t) cd[0].t = {};
	        cd[0].trace = trace;
	
	        calcdata[i] = cd;
	    }
	
	    setupAxisCategories(axList, fullData);
	
	    // 'transform' loop - must calc container traces first
	    // so that if their dependent traces can get transform properly
	    for(i = 0; i < fullData.length; i++) calci(i, true);
	    for(i = 0; i < fullData.length; i++) transformCalci(i);
	
	    // clear stuff that should recomputed in 'regular' loop
	    if(hasCalcTransform) setupAxisCategories(axList, fullData);
	
	    // 'regular' loop - make sure container traces (eg carpet) calc before
	    // contained traces (eg contourcarpet)
	    for(i = 0; i < fullData.length; i++) calci(i, true);
	    for(i = 0; i < fullData.length; i++) calci(i, false);
	
	    doCrossTraceCalc(gd);
	
	    // Sort axis categories per value if specified
	    var sorted = sortAxisCategoriesByValue(axList, gd);
	    if(sorted.length) {
	        // how many box/violins plots do we have (in case they're grouped)
	        fullLayout._numBoxes = 0;
	        fullLayout._numViolins = 0;
	        // If a sort operation was performed, run calc() again
	        for(i = 0; i < sorted.length; i++) calci(sorted[i], true);
	        for(i = 0; i < sorted.length; i++) calci(sorted[i], false);
	        doCrossTraceCalc(gd);
	    }
	
	    Registry.getComponentMethod('fx', 'calc')(gd);
	    Registry.getComponentMethod('errorbars', 'calc')(gd);
	};
	
	var sortAxisCategoriesByValueRegex = /(total|sum|min|max|mean|median) (ascending|descending)/;
	
	function sortAxisCategoriesByValue(axList, gd) {
	    var affectedTraces = [];
	    var i, j, k, l, o;
	
	    function zMapCategory(type, ax, value) {
	        var axLetter = ax._id.charAt(0);
	        if(type === 'histogram2dcontour') {
	            var counterAxLetter = ax._counterAxes[0];
	            var counterAx = axisIDs.getFromId(gd, counterAxLetter);
	
	            var xCategorical = axLetter === 'x' || (counterAxLetter === 'x' && counterAx.type === 'category');
	            var yCategorical = axLetter === 'y' || (counterAxLetter === 'y' && counterAx.type === 'category');
	
	            return function(o, l) {
	                if(o === 0 || l === 0) return -1; // Skip first row and column
	                if(xCategorical && o === value[l].length - 1) return -1;
	                if(yCategorical && l === value.length - 1) return -1;
	
	                return (axLetter === 'y' ? l : o) - 1;
	            };
	        } else {
	            return function(o, l) {
	                return axLetter === 'y' ? l : o;
	            };
	        }
	    }
	
	    var aggFn = {
	        'min': function(values) {return Lib.aggNums(Math.min, null, values);},
	        'max': function(values) {return Lib.aggNums(Math.max, null, values);},
	        'sum': function(values) {return Lib.aggNums(function(a, b) { return a + b;}, null, values);},
	        'total': function(values) {return Lib.aggNums(function(a, b) { return a + b;}, null, values);},
	        'mean': function(values) {return Lib.mean(values);},
	        'median': function(values) {return Lib.median(values);}
	    };
	
	    for(i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        if(ax.type !== 'category') continue;
	
	        // Order by value
	        var match = ax.categoryorder.match(sortAxisCategoriesByValueRegex);
	        if(match) {
	            var aggregator = match[1];
	            var order = match[2];
	
	            // Store values associated with each category
	            var categoriesValue = [];
	            for(j = 0; j < ax._categories.length; j++) {
	                categoriesValue.push([ax._categories[j], []]);
	            }
	
	            // Collect values across traces
	            for(j = 0; j < ax._traceIndices.length; j++) {
	                var traceIndex = ax._traceIndices[j];
	                var fullTrace = gd._fullData[traceIndex];
	                var axLetter = ax._id.charAt(0);
	
	                // Skip over invisible traces
	                if(fullTrace.visible !== true) continue;
	
	                var type = fullTrace.type;
	                if(Registry.traceIs(fullTrace, 'histogram')) {
	                    delete fullTrace._xautoBinFinished;
	                    delete fullTrace._yautoBinFinished;
	                }
	
	                var cd = gd.calcdata[traceIndex];
	                for(k = 0; k < cd.length; k++) {
	                    var cdi = cd[k];
	                    var cat, catIndex, value;
	
	                    if(type === 'splom') {
	                        // If `splom`, collect values across dimensions
	                        // Find which dimension the current axis is representing
	                        var currentDimensionIndex = fullTrace._axesDim[ax._id];
	
	                        // Apply logic to associated x axis if it's defined
	                        if(axLetter === 'y') {
	                            var associatedXAxisID = fullTrace._diag[currentDimensionIndex][0];
	                            if(associatedXAxisID) ax = gd._fullLayout[axisIDs.id2name(associatedXAxisID)];
	                        }
	
	                        var categories = cdi.trace.dimensions[currentDimensionIndex].values;
	                        for(l = 0; l < categories.length; l++) {
	                            cat = categories[l];
	                            catIndex = ax._categoriesMap[cat];
	
	                            // Collect associated values at index `l` over all other dimensions
	                            for(o = 0; o < cdi.trace.dimensions.length; o++) {
	                                if(o === currentDimensionIndex) continue;
	                                var dimension = cdi.trace.dimensions[o];
	                                categoriesValue[catIndex][1].push(dimension.values[l]);
	                            }
	                        }
	                    } else if(type === 'scattergl') {
	                        // If `scattergl`, collect all values stashed under cdi.t
	                        for(l = 0; l < cdi.t.x.length; l++) {
	                            if(axLetter === 'x') {
	                                cat = cdi.t.x[l];
	                                catIndex = cat;
	                                value = cdi.t.y[l];
	                            }
	
	                            if(axLetter === 'y') {
	                                cat = cdi.t.y[l];
	                                catIndex = cat;
	                                value = cdi.t.x[l];
	                            }
	                            categoriesValue[catIndex][1].push(value);
	                        }
	                        // must clear scene 'batches', so that 2nd
	                        // _module.calc call starts from scratch
	                        if(cdi.t && cdi.t._scene) {
	                            delete cdi.t._scene.dirty;
	                        }
	                    } else if(cdi.hasOwnProperty('z')) {
	                        // If 2dMap, collect values in `z`
	                        value = cdi.z;
	                        var mapping = zMapCategory(fullTrace.type, ax, value);
	
	                        for(l = 0; l < value.length; l++) {
	                            for(o = 0; o < value[l].length; o++) {
	                                catIndex = mapping(o, l);
	                                if(catIndex + 1) categoriesValue[catIndex][1].push(value[l][o]);
	                            }
	                        }
	                    } else {
	                        // For all other 2d cartesian traces
	                        if(axLetter === 'x') {
	                            cat = cdi.p + 1 ? cdi.p : cdi.x;
	                            value = cdi.s || cdi.v || cdi.y;
	                        } else if(axLetter === 'y') {
	                            cat = cdi.p + 1 ? cdi.p : cdi.y;
	                            value = cdi.s || cdi.v || cdi.x;
	                        }
	                        if(!Array.isArray(value)) value = [value];
	                        for(l = 0; l < value.length; l++) {
	                            categoriesValue[cat][1].push(value[l]);
	                        }
	                    }
	                }
	            }
	
	            ax._categoriesValue = categoriesValue;
	
	            var categoriesAggregatedValue = [];
	            for(j = 0; j < categoriesValue.length; j++) {
	                categoriesAggregatedValue.push([
	                    categoriesValue[j][0],
	                    aggFn[aggregator](categoriesValue[j][1])
	                ]);
	            }
	
	            // Sort by aggregated value
	            categoriesAggregatedValue.sort(function(a, b) {
	                return a[1] - b[1];
	            });
	
	            ax._categoriesAggregatedValue = categoriesAggregatedValue;
	
	            // Set new category order
	            ax._initialCategories = categoriesAggregatedValue.map(function(c) {
	                return c[0];
	            });
	
	            // Reverse if descending
	            if(order === 'descending') {
	                ax._initialCategories.reverse();
	            }
	
	            // Sort all matching axes
	            affectedTraces = affectedTraces.concat(ax.sortByInitialCategories());
	        }
	    }
	    return affectedTraces;
	}
	
	function setupAxisCategories(axList, fullData) {
	    for(var i = 0; i < axList.length; i++) {
	        var ax = axList[i];
	        ax.clearCalc();
	        if(ax.type === 'multicategory') {
	            ax.setupMultiCategory(fullData);
	        }
	    }
	}
	
	function doCrossTraceCalc(gd) {
	    var fullLayout = gd._fullLayout;
	    var modules = fullLayout._visibleModules;
	    var hash = {};
	    var i, j, k;
	
	    // position and range calculations for traces that
	    // depend on each other ie bars (stacked or grouped)
	    // and boxes (grouped) push each other out of the way
	
	    for(j = 0; j < modules.length; j++) {
	        var _module = modules[j];
	        var fn = _module.crossTraceCalc;
	        if(fn) {
	            var spType = _module.basePlotModule.name;
	            if(hash[spType]) {
	                Lib.pushUnique(hash[spType], fn);
	            } else {
	                hash[spType] = [fn];
	            }
	        }
	    }
	
	    for(k in hash) {
	        var methods = hash[k];
	        var subplots = fullLayout._subplots[k];
	
	        if(Array.isArray(subplots)) {
	            for(i = 0; i < subplots.length; i++) {
	                var sp = subplots[i];
	                var spInfo = k === 'cartesian' ?
	                    fullLayout._plots[sp] :
	                    fullLayout[sp];
	
	                for(j = 0; j < methods.length; j++) {
	                    methods[j](gd, spInfo, sp);
	                }
	            }
	        } else {
	            for(j = 0; j < methods.length; j++) {
	                methods[j](gd);
	            }
	        }
	    }
	}
	
	plots.rehover = function(gd) {
	    if(gd._fullLayout._rehover) {
	        gd._fullLayout._rehover();
	    }
	};
	
	plots.redrag = function(gd) {
	    if(gd._fullLayout._redrag) {
	        gd._fullLayout._redrag();
	    }
	};
	
	plots.generalUpdatePerTraceModule = function(gd, subplot, subplotCalcData, subplotLayout) {
	    var traceHashOld = subplot.traceHash;
	    var traceHash = {};
	    var i;
	
	    // build up moduleName -> calcData hash
	    for(i = 0; i < subplotCalcData.length; i++) {
	        var calcTraces = subplotCalcData[i];
	        var trace = calcTraces[0].trace;
	
	        // skip over visible === false traces
	        // as they don't have `_module` ref
	        if(trace.visible) {
	            traceHash[trace.type] = traceHash[trace.type] || [];
	            traceHash[trace.type].push(calcTraces);
	        }
	    }
	
	    // when a trace gets deleted, make sure that its module's
	    // plot method is called so that it is properly
	    // removed from the DOM.
	    for(var moduleNameOld in traceHashOld) {
	        if(!traceHash[moduleNameOld]) {
	            var fakeCalcTrace = traceHashOld[moduleNameOld][0];
	            var fakeTrace = fakeCalcTrace[0].trace;
	
	            fakeTrace.visible = false;
	            traceHash[moduleNameOld] = [fakeCalcTrace];
	        }
	    }
	
	    // call module plot method
	    for(var moduleName in traceHash) {
	        var moduleCalcData = traceHash[moduleName];
	        var _module = moduleCalcData[0][0].trace._module;
	
	        _module.plot(gd, subplot, Lib.filterVisible(moduleCalcData), subplotLayout);
	    }
	
	    // update moduleName -> calcData hash
	    subplot.traceHash = traceHash;
	};
	
	plots.plotBasePlot = function(desiredType, gd, traces, transitionOpts, makeOnCompleteCallback) {
	    var _module = Registry.getModule(desiredType);
	    var cdmodule = getModuleCalcData(gd.calcdata, _module)[0];
	    _module.plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback);
	};
	
	plots.cleanBasePlot = function(desiredType, newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var had = (oldFullLayout._has && oldFullLayout._has(desiredType));
	    var has = (newFullLayout._has && newFullLayout._has(desiredType));
	
	    if(had && !has) {
	        oldFullLayout['_' + desiredType + 'layer'].selectAll('g.trace').remove();
	    }
	};
	
	},{"../components/color":591,"../constants/numerical":692,"../lib":716,"../plot_api/plot_schema":753,"../plot_api/plot_template":754,"../plots/get_data":799,"../registry":845,"./animation_attributes":759,"./attributes":761,"./cartesian/axis_ids":767,"./command":788,"./font_attributes":790,"./frame_attributes":791,"./layout_attributes":816,"d3":164,"fast-isnumeric":227}],826:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attr: 'subplot',
	    name: 'polar',
	
	    axisNames: ['angularaxis', 'radialaxis'],
	    axisName2dataArray: {angularaxis: 'theta', radialaxis: 'r'},
	
	    layerNames: [
	        'draglayer',
	        'plotbg',
	        'backplot',
	        'angular-grid',
	        'radial-grid',
	        'frontplot',
	        'angular-line',
	        'radial-line',
	        'angular-axis',
	        'radial-axis'
	    ],
	
	    radialDragBoxSize: 50,
	    angularDragBoxSize: 30,
	    cornerLen: 25,
	    cornerHalfWidth: 2,
	
	    // pixels to move mouse before you stop clamping to starting point
	    MINDRAG: 8,
	    // smallest radial distance [px] allowed for a zoombox
	    MINZOOM: 20,
	    // distance [px] off (r=0) or (r=radius) where we transition
	    // from single-sided to two-sided radial zoom
	    OFFEDGE: 20
	};
	
	},{}],827:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var polygonTester = _dereq_('../../lib/polygon').tester;
	
	var findIndexOfMin = Lib.findIndexOfMin;
	var isAngleInsideSector = Lib.isAngleInsideSector;
	var angleDelta = Lib.angleDelta;
	var angleDist = Lib.angleDist;
	
	/**
	 * is pt (r,a) inside polygon made up vertices at angles 'vangles'
	 * inside a given polar sector
	 *
	 * @param {number} r : pt's radial coordinate
	 * @param {number} a : pt's angular coordinate in *radians*
	 * @param {2-item array} rBnds : sector's radial bounds
	 * @param {2-item array} aBnds : sector's angular bounds *radians*
	 * @param {array} vangles : angles of polygon vertices in *radians*
	 * @return {boolean}
	 */
	function isPtInsidePolygon(r, a, rBnds, aBnds, vangles) {
	    if(!isAngleInsideSector(a, aBnds)) return false;
	
	    var r0, r1;
	
	    if(rBnds[0] < rBnds[1]) {
	        r0 = rBnds[0];
	        r1 = rBnds[1];
	    } else {
	        r0 = rBnds[1];
	        r1 = rBnds[0];
	    }
	
	    var polygonIn = polygonTester(makePolygon(r0, aBnds[0], aBnds[1], vangles));
	    var polygonOut = polygonTester(makePolygon(r1, aBnds[0], aBnds[1], vangles));
	    var xy = [r * Math.cos(a), r * Math.sin(a)];
	    return polygonOut.contains(xy) && !polygonIn.contains(xy);
	}
	
	// find intersection of 'v0' <-> 'v1' edge with a ray at angle 'a'
	// (i.e. a line that starts from the origin at angle 'a')
	// given an (xp,yp) pair on the 'v0' <-> 'v1' line
	// (N.B. 'v0' and 'v1' are angles in radians)
	function findIntersectionXY(v0, v1, a, xpyp) {
	    var xstar, ystar;
	
	    var xp = xpyp[0];
	    var yp = xpyp[1];
	    var dsin = clampTiny(Math.sin(v1) - Math.sin(v0));
	    var dcos = clampTiny(Math.cos(v1) - Math.cos(v0));
	    var tanA = Math.tan(a);
	    var cotanA = clampTiny(1 / tanA);
	    var m = dsin / dcos;
	    var b = yp - m * xp;
	
	    if(cotanA) {
	        if(dsin && dcos) {
	            // given
	            //  g(x) := v0 -> v1 line = m*x + b
	            //  h(x) := ray at angle 'a' = m*x = tanA*x
	            // solve g(xstar) = h(xstar)
	            xstar = b / (tanA - m);
	            ystar = tanA * xstar;
	        } else if(dcos) {
	            // horizontal v0 -> v1
	            xstar = yp * cotanA;
	            ystar = yp;
	        } else {
	            // vertical v0 -> v1
	            xstar = xp;
	            ystar = xp * tanA;
	        }
	    } else {
	        // vertical ray
	        if(dsin && dcos) {
	            xstar = 0;
	            ystar = b;
	        } else if(dcos) {
	            xstar = 0;
	            ystar = yp;
	        } else {
	            // does this case exists?
	            xstar = ystar = NaN;
	        }
	    }
	
	    return [xstar, ystar];
	}
	
	// solves l^2 = (f(x)^2 - yp)^2 + (x - xp)^2
	// rearranged into 0 = a*x^2 + b * x + c
	//
	// where f(x) = m*x + t + yp
	// and   (x0, x1) = (-b +/- del) / (2*a)
	function findXYatLength(l, m, xp, yp) {
	    var t = -m * xp;
	    var a = m * m + 1;
	    var b = 2 * (m * t - xp);
	    var c = t * t + xp * xp - l * l;
	    var del = Math.sqrt(b * b - 4 * a * c);
	    var x0 = (-b + del) / (2 * a);
	    var x1 = (-b - del) / (2 * a);
	    return [
	        [x0, m * x0 + t + yp],
	        [x1, m * x1 + t + yp]
	    ];
	}
	
	function makeRegularPolygon(r, vangles) {
	    var len = vangles.length;
	    var vertices = new Array(len + 1);
	    var i;
	    for(i = 0; i < len; i++) {
	        var va = vangles[i];
	        vertices[i] = [r * Math.cos(va), r * Math.sin(va)];
	    }
	    vertices[i] = vertices[0].slice();
	    return vertices;
	}
	
	function makeClippedPolygon(r, a0, a1, vangles) {
	    var len = vangles.length;
	    var vertices = [];
	    var i, j;
	
	    function a2xy(a) {
	        return [r * Math.cos(a), r * Math.sin(a)];
	    }
	
	    function findXY(va0, va1, s) {
	        return findIntersectionXY(va0, va1, s, a2xy(va0));
	    }
	
	    function cycleIndex(ind) {
	        return Lib.mod(ind, len);
	    }
	
	    function isInside(v) {
	        return isAngleInsideSector(v, [a0, a1]);
	    }
	
	    // find index in sector closest to a0
	    // use it to find intersection of v[i0] <-> v[i0-1] edge with sector radius
	    var i0 = findIndexOfMin(vangles, function(v) {
	        return isInside(v) ? angleDist(v, a0) : Infinity;
	    });
	    var xy0 = findXY(vangles[i0], vangles[cycleIndex(i0 - 1)], a0);
	    vertices.push(xy0);
	
	    // fill in in-sector vertices
	    for(i = i0, j = 0; j < len; i++, j++) {
	        var va = vangles[cycleIndex(i)];
	        if(!isInside(va)) break;
	        vertices.push(a2xy(va));
	    }
	
	    // find index in sector closest to a1,
	    // use it to find intersection of v[iN] <-> v[iN+1] edge with sector radius
	    var iN = findIndexOfMin(vangles, function(v) {
	        return isInside(v) ? angleDist(v, a1) : Infinity;
	    });
	    var xyN = findXY(vangles[iN], vangles[cycleIndex(iN + 1)], a1);
	    vertices.push(xyN);
	
	    vertices.push([0, 0]);
	    vertices.push(vertices[0].slice());
	
	    return vertices;
	}
	
	function makePolygon(r, a0, a1, vangles) {
	    return Lib.isFullCircle([a0, a1]) ?
	        makeRegularPolygon(r, vangles) :
	        makeClippedPolygon(r, a0, a1, vangles);
	}
	
	function findPolygonOffset(r, a0, a1, vangles) {
	    var minX = Infinity;
	    var minY = Infinity;
	    var vertices = makePolygon(r, a0, a1, vangles);
	
	    for(var i = 0; i < vertices.length; i++) {
	        var v = vertices[i];
	        minX = Math.min(minX, v[0]);
	        minY = Math.min(minY, -v[1]);
	    }
	    return [minX, minY];
	}
	
	/**
	 * find vertex angles (in 'vangles') the enclose angle 'a'
	 *
	 * @param {number} a : angle in *radians*
	 * @param {array} vangles : angles of polygon vertices in *radians*
	 * @return {2-item array}
	 */
	function findEnclosingVertexAngles(a, vangles) {
	    var minFn = function(v) {
	        var adelta = angleDelta(v, a);
	        return adelta > 0 ? adelta : Infinity;
	    };
	    var i0 = findIndexOfMin(vangles, minFn);
	    var i1 = Lib.mod(i0 + 1, vangles.length);
	    return [vangles[i0], vangles[i1]];
	}
	
	// to more easily catch 'almost zero' numbers in if-else blocks
	function clampTiny(v) {
	    return Math.abs(v) > 1e-10 ? v : 0;
	}
	
	function transformForSVG(pts0, cx, cy) {
	    cx = cx || 0;
	    cy = cy || 0;
	
	    var len = pts0.length;
	    var pts1 = new Array(len);
	
	    for(var i = 0; i < len; i++) {
	        var pt = pts0[i];
	        pts1[i] = [cx + pt[0], cy - pt[1]];
	    }
	    return pts1;
	}
	
	/**
	 * path polygon
	 *
	 * @param {number} r : polygon 'radius'
	 * @param {number} a0 : first angular coordinate in *radians*
	 * @param {number} a1 : second angular coordinate in *radians*
	 * @param {array} vangles : angles of polygon vertices in *radians*
	 * @param {number (optional)} cx : x coordinate of center
	 * @param {number (optional)} cy : y coordinate of center
	 * @return {string} svg path
	 *
	 */
	function pathPolygon(r, a0, a1, vangles, cx, cy) {
	    var poly = makePolygon(r, a0, a1, vangles);
	    return 'M' + transformForSVG(poly, cx, cy).join('L');
	}
	
	/**
	 * path a polygon 'annulus'
	 * i.e. a polygon with a concentric hole
	 *
	 * N.B. this routine uses the evenodd SVG rule
	 *
	 * @param {number} r0 : first radial coordinate
	 * @param {number} r1 : second radial coordinate
	 * @param {number} a0 : first angular coordinate in *radians*
	 * @param {number} a1 : second angular coordinate in *radians*
	 * @param {array} vangles : angles of polygon vertices in *radians*
	 * @param {number (optional)} cx : x coordinate of center
	 * @param {number (optional)} cy : y coordinate of center
	 * @return {string} svg path
	 *
	 */
	function pathPolygonAnnulus(r0, r1, a0, a1, vangles, cx, cy) {
	    var rStart, rEnd;
	
	    if(r0 < r1) {
	        rStart = r0;
	        rEnd = r1;
	    } else {
	        rStart = r1;
	        rEnd = r0;
	    }
	
	    var inner = transformForSVG(makePolygon(rStart, a0, a1, vangles), cx, cy);
	    var outer = transformForSVG(makePolygon(rEnd, a0, a1, vangles), cx, cy);
	    return 'M' + outer.reverse().join('L') + 'M' + inner.join('L');
	}
	
	module.exports = {
	    isPtInsidePolygon: isPtInsidePolygon,
	    findPolygonOffset: findPolygonOffset,
	    findEnclosingVertexAngles: findEnclosingVertexAngles,
	    findIntersectionXY: findIntersectionXY,
	    findXYatLength: findXYatLength,
	    clampTiny: clampTiny,
	    pathPolygon: pathPolygon,
	    pathPolygonAnnulus: pathPolygonAnnulus
	};
	
	},{"../../lib":716,"../../lib/polygon":728}],828:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var getSubplotCalcData = _dereq_('../get_data').getSubplotCalcData;
	var counterRegex = _dereq_('../../lib').counterRegex;
	
	var createPolar = _dereq_('./polar');
	var constants = _dereq_('./constants');
	
	var attr = constants.attr;
	var name = constants.name;
	var counter = counterRegex(name);
	
	var attributes = {};
	attributes[attr] = {
	    valType: 'subplotid',
	    
	    dflt: name,
	    editType: 'calc',
	    
	};
	
	function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var calcData = gd.calcdata;
	    var subplotIds = fullLayout._subplots[name];
	
	    for(var i = 0; i < subplotIds.length; i++) {
	        var id = subplotIds[i];
	        var subplotCalcData = getSubplotCalcData(calcData, name, id);
	        var subplot = fullLayout[id]._subplot;
	
	        if(!subplot) {
	            subplot = createPolar(gd, id);
	            fullLayout[id]._subplot = subplot;
	        }
	
	        subplot.plot(subplotCalcData, fullLayout, gd._promises);
	    }
	}
	
	function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldIds = oldFullLayout._subplots[name] || [];
	    var hadGl = (oldFullLayout._has && oldFullLayout._has('gl'));
	    var hasGl = (newFullLayout._has && newFullLayout._has('gl'));
	    var mustCleanScene = hadGl && !hasGl;
	
	    for(var i = 0; i < oldIds.length; i++) {
	        var id = oldIds[i];
	        var oldSubplot = oldFullLayout[id]._subplot;
	
	        if(!newFullLayout[id] && !!oldSubplot) {
	            oldSubplot.framework.remove();
	            oldSubplot.layers['radial-axis-title'].remove();
	
	            for(var k in oldSubplot.clipPaths) {
	                oldSubplot.clipPaths[k].remove();
	            }
	        }
	
	        if(mustCleanScene && oldSubplot._scene) {
	            oldSubplot._scene.destroy();
	            oldSubplot._scene = null;
	        }
	    }
	}
	
	module.exports = {
	    attr: attr,
	    name: name,
	    idRoot: name,
	    idRegex: counter,
	    attrRegex: counter,
	    attributes: attributes,
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    plot: plot,
	    clean: clean,
	    toSVG: _dereq_('../cartesian').toSVG
	};
	
	},{"../../lib":716,"../cartesian":775,"../get_data":799,"./constants":826,"./layout_attributes":829,"./layout_defaults":830,"./polar":837}],829:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorAttrs = _dereq_('../../components/color/attributes');
	var axesAttrs = _dereq_('../cartesian/layout_attributes');
	var domainAttrs = _dereq_('../domain').attributes;
	var extendFlat = _dereq_('../../lib').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var axisLineGridAttr = overrideAll({
	    color: axesAttrs.color,
	    showline: extendFlat({}, axesAttrs.showline, {dflt: true}),
	    linecolor: axesAttrs.linecolor,
	    linewidth: axesAttrs.linewidth,
	    showgrid: extendFlat({}, axesAttrs.showgrid, {dflt: true}),
	    gridcolor: axesAttrs.gridcolor,
	    gridwidth: axesAttrs.gridwidth
	
	    // TODO add spike* attributes down the road
	
	    // should we add zeroline* attributes?
	
	}, 'plot', 'from-root');
	
	var axisTickAttrs = overrideAll({
	    tickmode: axesAttrs.tickmode,
	    nticks: axesAttrs.nticks,
	    tick0: axesAttrs.tick0,
	    dtick: axesAttrs.dtick,
	    tickvals: axesAttrs.tickvals,
	    ticktext: axesAttrs.ticktext,
	    ticks: axesAttrs.ticks,
	    ticklen: axesAttrs.ticklen,
	    tickwidth: axesAttrs.tickwidth,
	    tickcolor: axesAttrs.tickcolor,
	    showticklabels: axesAttrs.showticklabels,
	    showtickprefix: axesAttrs.showtickprefix,
	    tickprefix: axesAttrs.tickprefix,
	    showticksuffix: axesAttrs.showticksuffix,
	    ticksuffix: axesAttrs.ticksuffix,
	    showexponent: axesAttrs.showexponent,
	    exponentformat: axesAttrs.exponentformat,
	    separatethousands: axesAttrs.separatethousands,
	    tickfont: axesAttrs.tickfont,
	    tickangle: axesAttrs.tickangle,
	    tickformat: axesAttrs.tickformat,
	    tickformatstops: axesAttrs.tickformatstops,
	    layer: axesAttrs.layer
	}, 'plot', 'from-root');
	
	var radialAxisAttrs = {
	    visible: extendFlat({}, axesAttrs.visible, {dflt: true}),
	    type: extendFlat({}, axesAttrs.type, {
	        values: ['-', 'linear', 'log', 'date', 'category']
	    }),
	
	    autorange: extendFlat({}, axesAttrs.autorange, {editType: 'plot'}),
	    rangemode: {
	        valType: 'enumerated',
	        values: ['tozero', 'nonnegative', 'normal'],
	        dflt: 'tozero',
	        
	        editType: 'calc',
	        
	    },
	    range: extendFlat({}, axesAttrs.range, {
	        items: [
	            {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}},
	            {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}}
	        ],
	        editType: 'plot'
	    }),
	
	    categoryorder: axesAttrs.categoryorder,
	    categoryarray: axesAttrs.categoryarray,
	
	    angle: {
	        valType: 'angle',
	        editType: 'plot',
	        
	        
	    },
	
	    side: {
	        valType: 'enumerated',
	        // TODO add 'center' for `showline: false` radial axes
	        values: ['clockwise', 'counterclockwise'],
	        dflt: 'clockwise',
	        editType: 'plot',
	        
	        
	    },
	
	
	    title: {
	        // radial title is not gui-editable at the moment,
	        // so it needs dflt: '', similar to carpet axes.
	        text: extendFlat({}, axesAttrs.title.text, {editType: 'plot', dflt: ''}),
	        font: extendFlat({}, axesAttrs.title.font, {editType: 'plot'}),
	
	        // TODO
	        // - might need a 'titleside' and even 'titledirection' down the road
	        // - what about standoff ??
	
	        editType: 'plot'
	    },
	
	    hoverformat: axesAttrs.hoverformat,
	
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	
	    editType: 'calc',
	
	    _deprecated: {
	        title: axesAttrs._deprecated.title,
	        titlefont: axesAttrs._deprecated.titlefont
	    }
	};
	
	extendFlat(
	    radialAxisAttrs,
	
	    // N.B. radialaxis grid lines are circular,
	    // but radialaxis lines are straight from circle center to outer bound
	    axisLineGridAttr,
	    axisTickAttrs
	);
	
	var angularAxisAttrs = {
	    visible: extendFlat({}, axesAttrs.visible, {dflt: true}),
	    type: {
	        valType: 'enumerated',
	        // 'linear' should maybe be called 'angle' or 'angular' here
	        // to make clear that axis here is periodic and more tightly match
	        // `thetaunit`?
	        //
	        // skip 'date' for first push
	        // no 'log' for now
	        values: ['-', 'linear', 'category'],
	        dflt: '-',
	        
	        editType: 'calc',
	        _noTemplating: true,
	        
	    },
	
	    categoryorder: axesAttrs.categoryorder,
	    categoryarray: axesAttrs.categoryarray,
	
	    thetaunit: {
	        valType: 'enumerated',
	        values: ['radians', 'degrees'],
	        dflt: 'degrees',
	        
	        editType: 'calc',
	        
	    },
	
	    period: {
	        valType: 'number',
	        editType: 'calc',
	        min: 0,
	        
	        
	        // Examples for date axes:
	        //
	        // - period that equals the timeseries length
	        //  http://flowingdata.com/2017/01/24/one-dataset-visualized-25-ways/18-polar-coordinates/
	        // - and 1-year periods (focusing on seasonal change0
	        //  http://otexts.org/fpp2/seasonal-plots.html
	        //  https://blogs.scientificamerican.com/sa-visual/why-are-so-many-babies-born-around-8-00-a-m/
	        //  http://www.seasonaladjustment.com/2012/09/05/clock-plot-visualising-seasonality-using-r-and-ggplot2-part-3/
	        //  https://i.pinimg.com/736x/49/b9/72/49b972ccb3206a1a6d6f870dac543280.jpg
	        //  https://www.climate-lab-book.ac.uk/spirals/
	    },
	
	    direction: {
	        valType: 'enumerated',
	        values: ['counterclockwise', 'clockwise'],
	        dflt: 'counterclockwise',
	        
	        editType: 'calc',
	        
	    },
	
	    rotation: {
	        valType: 'angle',
	        editType: 'calc',
	        
	        
	    },
	
	    hoverformat: axesAttrs.hoverformat,
	
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	
	    editType: 'calc'
	};
	
	extendFlat(
	    angularAxisAttrs,
	
	    // N.B. angular grid lines are straight lines from circle center to outer bound
	    // the angular line is circular bounding the polar plot area.
	    axisLineGridAttr,
	
	    // N.B. ticksuffix defaults to '°' for angular axes with `thetaunit: 'degrees'`
	    axisTickAttrs
	);
	
	module.exports = {
	    // TODO for x/y/zoom system for paper-based zooming:
	    // x: {},
	    // y: {},
	    // zoom: {},
	
	    domain: domainAttrs({name: 'polar', editType: 'plot'}),
	
	    sector: {
	        valType: 'info_array',
	        items: [
	            {valType: 'number', editType: 'plot'},
	            {valType: 'number', editType: 'plot'}
	        ],
	        dflt: [0, 360],
	        
	        editType: 'plot',
	        
	    },
	    hole: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0,
	        editType: 'plot',
	        
	        
	    },
	
	    bgcolor: {
	        valType: 'color',
	        
	        editType: 'plot',
	        dflt: colorAttrs.background,
	        
	    },
	
	    radialaxis: radialAxisAttrs,
	    angularaxis: angularAxisAttrs,
	
	    gridshape: {
	        valType: 'enumerated',
	        values: ['circular', 'linear'],
	        dflt: 'circular',
	        
	        editType: 'plot',
	        
	    },
	
	    // TODO maybe?
	    // annotations:
	
	    uirevision: {
	        valType: 'any',
	        
	        editType: 'none',
	        
	    },
	
	    editType: 'calc'
	};
	
	},{"../../components/color/attributes":590,"../../lib":716,"../../plot_api/edit_types":747,"../cartesian/layout_attributes":776,"../domain":789}],830:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Template = _dereq_('../../plot_api/plot_template');
	
	var handleSubplotDefaults = _dereq_('../subplot_defaults');
	var getSubplotData = _dereq_('../get_data').getSubplotData;
	
	var handleTickValueDefaults = _dereq_('../cartesian/tick_value_defaults');
	var handleTickMarkDefaults = _dereq_('../cartesian/tick_mark_defaults');
	var handleTickLabelDefaults = _dereq_('../cartesian/tick_label_defaults');
	var handleCategoryOrderDefaults = _dereq_('../cartesian/category_order_defaults');
	var handleLineGridDefaults = _dereq_('../cartesian/line_grid_defaults');
	var autoType = _dereq_('../cartesian/axis_autotype');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	var setConvert = _dereq_('./set_convert');
	var constants = _dereq_('./constants');
	var axisNames = constants.axisNames;
	
	function handleDefaults(contIn, contOut, coerce, opts) {
	    var bgColor = coerce('bgcolor');
	    opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
	
	    var sector = coerce('sector');
	    coerce('hole');
	
	    // could optimize, subplotData is not always needed!
	    var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
	    var layoutOut = opts.layoutOut;
	    var axName;
	
	    function coerceAxis(attr, dflt) {
	        return coerce(axName + '.' + attr, dflt);
	    }
	
	    for(var i = 0; i < axisNames.length; i++) {
	        axName = axisNames[i];
	
	        if(!Lib.isPlainObject(contIn[axName])) {
	            contIn[axName] = {};
	        }
	
	        var axIn = contIn[axName];
	        var axOut = Template.newContainer(contOut, axName);
	        axOut._id = axOut._name = axName;
	        axOut._attr = opts.id + '.' + axName;
	        axOut._traceIndices = subplotData.map(function(t) { return t._expandedIndex; });
	
	        var dataAttr = constants.axisName2dataArray[axName];
	        var axType = handleAxisTypeDefaults(axIn, axOut, coerceAxis, subplotData, dataAttr);
	
	        handleCategoryOrderDefaults(axIn, axOut, coerceAxis, {
	            axData: subplotData,
	            dataAttr: dataAttr
	        });
	
	        var visible = coerceAxis('visible');
	        setConvert(axOut, contOut, layoutOut);
	
	        coerceAxis('uirevision', contOut.uirevision);
	
	        var dfltColor;
	        var dfltFontColor;
	
	        if(visible) {
	            dfltColor = coerceAxis('color');
	            dfltFontColor = (dfltColor === axIn.color) ? dfltColor : opts.font.color;
	        }
	
	        // We don't want to make downstream code call ax.setScale,
	        // as both radial and angular axes don't have a set domain.
	        // Furthermore, angular axes don't have a set range.
	        //
	        // Mocked domains and ranges are set by the polar subplot instances,
	        // but Axes.findExtremes uses the sign of _m to determine which padding value
	        // to use.
	        //
	        // By setting, _m to 1 here, we make Axes.findExtremes think that
	        // range[1] > range[0], and vice-versa for `autorange: 'reversed'` below.
	        axOut._m = 1;
	
	        switch(axName) {
	            case 'radialaxis':
	                var autoRange = coerceAxis('autorange', !axOut.isValidRange(axIn.range));
	                axIn.autorange = autoRange;
	                if(autoRange && (axType === 'linear' || axType === '-')) coerceAxis('rangemode');
	                if(autoRange === 'reversed') axOut._m = -1;
	
	                coerceAxis('range');
	                axOut.cleanRange('range', {dfltRange: [0, 1]});
	
	                if(visible) {
	                    coerceAxis('side');
	                    coerceAxis('angle', sector[0]);
	
	                    coerceAxis('title.text');
	                    Lib.coerceFont(coerceAxis, 'title.font', {
	                        family: opts.font.family,
	                        size: Math.round(opts.font.size * 1.2),
	                        color: dfltFontColor
	                    });
	                }
	                break;
	
	            case 'angularaxis':
	                // We do not support 'true' date angular axes yet,
	                // users can still plot dates on angular axes by setting
	                // `angularaxis.type: 'category'`.
	                //
	                // Here, if a date angular axes is detected, we make
	                // all its corresponding traces invisible, so that
	                // when we do add support for data angular axes, the new
	                // behavior won't conflict with existing behavior
	                if(axType === 'date') {
	                    Lib.log('Polar plots do not support date angular axes yet.');
	
	                    for(var j = 0; j < subplotData.length; j++) {
	                        subplotData[j].visible = false;
	                    }
	
	                    // turn this into a 'dummy' linear axis so that
	                    // the subplot still renders ok
	                    axType = axIn.type = axOut.type = 'linear';
	                }
	
	                if(axType === 'linear') {
	                    coerceAxis('thetaunit');
	                } else {
	                    coerceAxis('period');
	                }
	
	                var direction = coerceAxis('direction');
	                coerceAxis('rotation', {counterclockwise: 0, clockwise: 90}[direction]);
	                break;
	        }
	
	        if(visible) {
	            handleTickValueDefaults(axIn, axOut, coerceAxis, axOut.type);
	            handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
	                tickSuffixDflt: axOut.thetaunit === 'degrees' ? '°' : undefined
	            });
	            handleTickMarkDefaults(axIn, axOut, coerceAxis, {outerTicks: true});
	
	            var showTickLabels = coerceAxis('showticklabels');
	            if(showTickLabels) {
	                Lib.coerceFont(coerceAxis, 'tickfont', {
	                    family: opts.font.family,
	                    size: opts.font.size,
	                    color: dfltFontColor
	                });
	                coerceAxis('tickangle');
	                coerceAxis('tickformat');
	            }
	
	            handleLineGridDefaults(axIn, axOut, coerceAxis, {
	                dfltColor: dfltColor,
	                bgColor: opts.bgColor,
	                // default grid color is darker here (60%, vs cartesian default ~91%)
	                // because the grid is not square so the eye needs heavier cues to follow
	                blend: 60,
	                showLine: true,
	                showGrid: true,
	                noZeroLine: true,
	                attributes: layoutAttributes[axName]
	            });
	
	            coerceAxis('layer');
	        }
	
	        if(axType !== 'category') coerceAxis('hoverformat');
	
	        axOut._input = axIn;
	    }
	
	    if(contOut.angularaxis.type === 'category') {
	        coerce('gridshape');
	    }
	}
	
	function handleAxisTypeDefaults(axIn, axOut, coerce, subplotData, dataAttr) {
	    var axType = coerce('type');
	
	    if(axType === '-') {
	        var trace;
	
	        for(var i = 0; i < subplotData.length; i++) {
	            if(subplotData[i].visible) {
	                trace = subplotData[i];
	                break;
	            }
	        }
	
	        if(trace && trace[dataAttr]) {
	            axOut.type = autoType(trace[dataAttr], 'gregorian');
	        }
	
	        if(axOut.type === '-') {
	            axOut.type = 'linear';
	        } else {
	            // copy autoType back to input axis
	            // note that if this object didn't exist
	            // in the input layout, we have to put it in
	            // this happens in the main supplyDefaults function
	            axIn.type = axOut.type;
	        }
	    }
	
	    return axOut.type;
	}
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	        type: constants.name,
	        attributes: layoutAttributes,
	        handleDefaults: handleDefaults,
	        font: layoutOut.font,
	        paper_bgcolor: layoutOut.paper_bgcolor,
	        fullData: fullData,
	        layoutOut: layoutOut
	    });
	};
	
	},{"../../components/color":591,"../../lib":716,"../../plot_api/plot_template":754,"../cartesian/axis_autotype":765,"../cartesian/category_order_defaults":768,"../cartesian/line_grid_defaults":778,"../cartesian/tick_label_defaults":783,"../cartesian/tick_mark_defaults":784,"../cartesian/tick_value_defaults":785,"../get_data":799,"../subplot_defaults":839,"./constants":826,"./layout_attributes":829,"./set_convert":838}],831:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../../../traces/scatter/attributes');
	var scatterMarkerAttrs = scatterAttrs.marker;
	var extendFlat = _dereq_('../../../lib/extend').extendFlat;
	
	var deprecationWarning = [
	    'Area traces are deprecated!',
	    'Please switch to the *barpolar* trace type.'
	].join(' ');
	
	module.exports = {
	    r: extendFlat({}, scatterAttrs.r, {
	        
	    }),
	    t: extendFlat({}, scatterAttrs.t, {
	        
	    }),
	    marker: {
	        color: extendFlat({}, scatterMarkerAttrs.color, {
	            
	        }),
	        size: extendFlat({}, scatterMarkerAttrs.size, {
	            
	        }),
	        symbol: extendFlat({}, scatterMarkerAttrs.symbol, {
	            
	        }),
	        opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
	            
	        }),
	        editType: 'calc'
	    }
	};
	
	},{"../../../lib/extend":707,"../../../traces/scatter/attributes":1118}],832:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var axesAttrs = _dereq_('../../cartesian/layout_attributes');
	var extendFlat = _dereq_('../../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../../plot_api/edit_types').overrideAll;
	
	var deprecationWarning = [
	    'Legacy polar charts are deprecated!',
	    'Please switch to *polar* subplots.'
	].join(' ');
	
	var domainAttr = extendFlat({}, axesAttrs.domain, {
	    
	});
	
	function mergeAttrs(axisName, nonCommonAttrs) {
	    var commonAttrs = {
	        showline: {
	            valType: 'boolean',
	            
	            
	        },
	        showticklabels: {
	            valType: 'boolean',
	            
	            
	        },
	        tickorientation: {
	            valType: 'enumerated',
	            values: ['horizontal', 'vertical'],
	            
	            
	        },
	        ticklen: {
	            valType: 'number',
	            min: 0,
	            
	            
	        },
	        tickcolor: {
	            valType: 'color',
	            
	            
	        },
	        ticksuffix: {
	            valType: 'string',
	            
	            
	        },
	        endpadding: {
	            valType: 'number',
	            
	            description: deprecationWarning,
	        },
	        visible: {
	            valType: 'boolean',
	            
	            
	        }
	    };
	
	    return extendFlat({}, nonCommonAttrs, commonAttrs);
	}
	
	module.exports = overrideAll({
	    radialaxis: mergeAttrs('radial', {
	        range: {
	            valType: 'info_array',
	            
	            items: [
	                { valType: 'number' },
	                { valType: 'number' }
	            ],
	            
	        },
	        domain: domainAttr,
	        orientation: {
	            valType: 'number',
	            
	            
	        }
	    }),
	
	    angularaxis: mergeAttrs('angular', {
	        range: {
	            valType: 'info_array',
	            
	            items: [
	                { valType: 'number', dflt: 0 },
	                { valType: 'number', dflt: 360 }
	            ],
	            
	        },
	        domain: domainAttr
	    }),
	
	    // attributes that appear at layout root
	    layout: {
	        direction: {
	            valType: 'enumerated',
	            values: ['clockwise', 'counterclockwise'],
	            
	            
	        },
	        orientation: {
	            valType: 'angle',
	            
	            
	        }
	    }
	}, 'plot', 'nested');
	
	},{"../../../lib/extend":707,"../../../plot_api/edit_types":747,"../../cartesian/layout_attributes":776}],833:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Polar = module.exports = _dereq_('./micropolar');
	
	Polar.manager = _dereq_('./micropolar_manager');
	
	},{"./micropolar":834,"./micropolar_manager":835}],834:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../../lib');
	var extendDeepAll = Lib.extendDeepAll;
	var MID_SHIFT = _dereq_('../../../constants/alignment').MID_SHIFT;
	
	var µ = module.exports = { version: '0.2.2' };
	
	µ.Axis = function module() {
	    var config = {
	        data: [],
	        layout: {}
	    }, inputConfig = {}, liveConfig = {};
	    var svg, container, dispatch = d3.dispatch('hover'), radialScale, angularScale;
	    var exports = {};
	    function render(_container) {
	        container = _container || container;
	        var data = config.data;
	        var axisConfig = config.layout;
	        if (typeof container == 'string' || container.nodeName) container = d3.select(container);
	        container.datum(data).each(function(_data, _index) {
	            var dataOriginal = _data.slice();
	            liveConfig = {
	                data: µ.util.cloneJson(dataOriginal),
	                layout: µ.util.cloneJson(axisConfig)
	            };
	            var colorIndex = 0;
	            dataOriginal.forEach(function(d, i) {
	                if (!d.color) {
	                    d.color = axisConfig.defaultColorRange[colorIndex];
	                    colorIndex = (colorIndex + 1) % axisConfig.defaultColorRange.length;
	                }
	                if (!d.strokeColor) {
	                    d.strokeColor = d.geometry === 'LinePlot' ? d.color : d3.rgb(d.color).darker().toString();
	                }
	                liveConfig.data[i].color = d.color;
	                liveConfig.data[i].strokeColor = d.strokeColor;
	                liveConfig.data[i].strokeDash = d.strokeDash;
	                liveConfig.data[i].strokeSize = d.strokeSize;
	            });
	            var data = dataOriginal.filter(function(d, i) {
	                var visible = d.visible;
	                return typeof visible === 'undefined' || visible === true;
	            });
	            var isStacked = false;
	            var dataWithGroupId = data.map(function(d, i) {
	                isStacked = isStacked || typeof d.groupId !== 'undefined';
	                return d;
	            });
	            if (isStacked) {
	                var grouped = d3.nest().key(function(d, i) {
	                    return typeof d.groupId != 'undefined' ? d.groupId : 'unstacked';
	                }).entries(dataWithGroupId);
	                var dataYStack = [];
	                var stacked = grouped.map(function(d, i) {
	                    if (d.key === 'unstacked') return d.values; else {
	                        var prevArray = d.values[0].r.map(function(d, i) {
	                            return 0;
	                        });
	                        d.values.forEach(function(d, i, a) {
	                            d.yStack = [ prevArray ];
	                            dataYStack.push(prevArray);
	                            prevArray = µ.util.sumArrays(d.r, prevArray);
	                        });
	                        return d.values;
	                    }
	                });
	                data = d3.merge(stacked);
	            }
	            data.forEach(function(d, i) {
	                d.t = Array.isArray(d.t[0]) ? d.t : [ d.t ];
	                d.r = Array.isArray(d.r[0]) ? d.r : [ d.r ];
	            });
	            var radius = Math.min(axisConfig.width - axisConfig.margin.left - axisConfig.margin.right, axisConfig.height - axisConfig.margin.top - axisConfig.margin.bottom) / 2;
	            radius = Math.max(10, radius);
	            var chartCenter = [ axisConfig.margin.left + radius, axisConfig.margin.top + radius ];
	            var extent;
	            if (isStacked) {
	                var highestStackedValue = d3.max(µ.util.sumArrays(µ.util.arrayLast(data).r[0], µ.util.arrayLast(dataYStack)));
	                extent = [ 0, highestStackedValue ];
	            } else extent = d3.extent(µ.util.flattenArray(data.map(function(d, i) {
	                return d.r;
	            })));
	            if (axisConfig.radialAxis.domain != µ.DATAEXTENT) extent[0] = 0;
	            radialScale = d3.scale.linear().domain(axisConfig.radialAxis.domain != µ.DATAEXTENT && axisConfig.radialAxis.domain ? axisConfig.radialAxis.domain : extent).range([ 0, radius ]);
	            liveConfig.layout.radialAxis.domain = radialScale.domain();
	            var angularDataMerged = µ.util.flattenArray(data.map(function(d, i) {
	                return d.t;
	            }));
	            var isOrdinal = typeof angularDataMerged[0] === 'string';
	            var ticks;
	            if (isOrdinal) {
	                angularDataMerged = µ.util.deduplicate(angularDataMerged);
	                ticks = angularDataMerged.slice();
	                angularDataMerged = d3.range(angularDataMerged.length);
	                data = data.map(function(d, i) {
	                    var result = d;
	                    d.t = [ angularDataMerged ];
	                    if (isStacked) result.yStack = d.yStack;
	                    return result;
	                });
	            }
	            var hasOnlyLineOrDotPlot = data.filter(function(d, i) {
	                return d.geometry === 'LinePlot' || d.geometry === 'DotPlot';
	            }).length === data.length;
	            var needsEndSpacing = axisConfig.needsEndSpacing === null ? isOrdinal || !hasOnlyLineOrDotPlot : axisConfig.needsEndSpacing;
	            var useProvidedDomain = axisConfig.angularAxis.domain && axisConfig.angularAxis.domain != µ.DATAEXTENT && !isOrdinal && axisConfig.angularAxis.domain[0] >= 0;
	            var angularDomain = useProvidedDomain ? axisConfig.angularAxis.domain : d3.extent(angularDataMerged);
	            var angularDomainStep = Math.abs(angularDataMerged[1] - angularDataMerged[0]);
	            if (hasOnlyLineOrDotPlot && !isOrdinal) angularDomainStep = 0;
	            var angularDomainWithPadding = angularDomain.slice();
	            if (needsEndSpacing && isOrdinal) angularDomainWithPadding[1] += angularDomainStep;
	            var tickCount = axisConfig.angularAxis.ticksCount || 4;
	            if (tickCount > 8) tickCount = tickCount / (tickCount / 8) + tickCount % 8;
	            if (axisConfig.angularAxis.ticksStep) {
	                tickCount = (angularDomainWithPadding[1] - angularDomainWithPadding[0]) / tickCount;
	            }
	            var angularTicksStep = axisConfig.angularAxis.ticksStep || (angularDomainWithPadding[1] - angularDomainWithPadding[0]) / (tickCount * (axisConfig.minorTicks + 1));
	            if (ticks) angularTicksStep = Math.max(Math.round(angularTicksStep), 1);
	            if (!angularDomainWithPadding[2]) angularDomainWithPadding[2] = angularTicksStep;
	            var angularAxisRange = d3.range.apply(this, angularDomainWithPadding);
	            angularAxisRange = angularAxisRange.map(function(d, i) {
	                return parseFloat(d.toPrecision(12));
	            });
	            angularScale = d3.scale.linear().domain(angularDomainWithPadding.slice(0, 2)).range(axisConfig.direction === 'clockwise' ? [ 0, 360 ] : [ 360, 0 ]);
	            liveConfig.layout.angularAxis.domain = angularScale.domain();
	            liveConfig.layout.angularAxis.endPadding = needsEndSpacing ? angularDomainStep : 0;
	            svg = d3.select(this).select('svg.chart-root');
	            if (typeof svg === 'undefined' || svg.empty()) {
	                var skeleton = "<svg xmlns='http://www.w3.org/2000/svg' class='chart-root'>' + '<g class='outer-group'>' + '<g class='chart-group'>' + '<circle class='background-circle'></circle>' + '<g class='geometry-group'></g>' + '<g class='radial axis-group'>' + '<circle class='outside-circle'></circle>' + '</g>' + '<g class='angular axis-group'></g>' + '<g class='guides-group'><line></line><circle r='0'></circle></g>' + '</g>' + '<g class='legend-group'></g>' + '<g class='tooltips-group'></g>' + '<g class='title-group'><text></text></g>' + '</g>' + '</svg>";
	                var doc = new DOMParser().parseFromString(skeleton, 'application/xml');
	                var newSvg = this.appendChild(this.ownerDocument.importNode(doc.documentElement, true));
	                svg = d3.select(newSvg);
	            }
	            svg.select('.guides-group').style({
	                'pointer-events': 'none'
	            });
	            svg.select('.angular.axis-group').style({
	                'pointer-events': 'none'
	            });
	            svg.select('.radial.axis-group').style({
	                'pointer-events': 'none'
	            });
	            var chartGroup = svg.select('.chart-group');
	            var lineStyle = {
	                fill: 'none',
	                stroke: axisConfig.tickColor
	            };
	            var fontStyle = {
	                'font-size': axisConfig.font.size,
	                'font-family': axisConfig.font.family,
	                fill: axisConfig.font.color,
	                'text-shadow': [ '-1px 0px', '1px -1px', '-1px 1px', '1px 1px' ].map(function(d, i) {
	                    return ' ' + d + ' 0 ' + axisConfig.font.outlineColor;
	                }).join(',')
	            };
	            var legendContainer;
	            if (axisConfig.showLegend) {
	                legendContainer = svg.select('.legend-group').attr({
	                    transform: 'translate(' + [ radius, axisConfig.margin.top ] + ')'
	                }).style({
	                    display: 'block'
	                });
	                var elements = data.map(function(d, i) {
	                    var datumClone = µ.util.cloneJson(d);
	                    datumClone.symbol = d.geometry === 'DotPlot' ? d.dotType || 'circle' : d.geometry != 'LinePlot' ? 'square' : 'line';
	                    datumClone.visibleInLegend = typeof d.visibleInLegend === 'undefined' || d.visibleInLegend;
	                    datumClone.color = d.geometry === 'LinePlot' ? d.strokeColor : d.color;
	                    return datumClone;
	                });
	
	                µ.Legend().config({
	                    data: data.map(function(d, i) {
	                        return d.name || 'Element' + i;
	                    }),
	                    legendConfig: extendDeepAll({},
	                        µ.Legend.defaultConfig().legendConfig,
	                        {
	                            container: legendContainer,
	                            elements: elements,
	                            reverseOrder: axisConfig.legend.reverseOrder
	                        }
	                    )
	                })();
	
	                var legendBBox = legendContainer.node().getBBox();
	                radius = Math.min(axisConfig.width - legendBBox.width - axisConfig.margin.left - axisConfig.margin.right, axisConfig.height - axisConfig.margin.top - axisConfig.margin.bottom) / 2;
	                radius = Math.max(10, radius);
	                chartCenter = [ axisConfig.margin.left + radius, axisConfig.margin.top + radius ];
	                radialScale.range([ 0, radius ]);
	                liveConfig.layout.radialAxis.domain = radialScale.domain();
	                legendContainer.attr('transform', 'translate(' + [ chartCenter[0] + radius, chartCenter[1] - radius ] + ')');
	            } else {
	                legendContainer = svg.select('.legend-group').style({
	                    display: 'none'
	                });
	            }
	            svg.attr({
	                width: axisConfig.width,
	                height: axisConfig.height
	            }).style({
	                opacity: axisConfig.opacity
	            });
	            chartGroup.attr('transform', 'translate(' + chartCenter + ')').style({
	                cursor: 'crosshair'
	            });
	            var centeringOffset = [ (axisConfig.width - (axisConfig.margin.left + axisConfig.margin.right + radius * 2 + (legendBBox ? legendBBox.width : 0))) / 2, (axisConfig.height - (axisConfig.margin.top + axisConfig.margin.bottom + radius * 2)) / 2 ];
	            centeringOffset[0] = Math.max(0, centeringOffset[0]);
	            centeringOffset[1] = Math.max(0, centeringOffset[1]);
	            svg.select('.outer-group').attr('transform', 'translate(' + centeringOffset + ')');
	            if (axisConfig.title && axisConfig.title.text) {
	                var title = svg.select('g.title-group text').style(fontStyle).text(axisConfig.title.text);
	                var titleBBox = title.node().getBBox();
	                title.attr({
	                    x: chartCenter[0] - titleBBox.width / 2,
	                    y: chartCenter[1] - radius - 20
	                });
	            }
	            var radialAxis = svg.select('.radial.axis-group');
	            if (axisConfig.radialAxis.gridLinesVisible) {
	                var gridCircles = radialAxis.selectAll('circle.grid-circle').data(radialScale.ticks(5));
	                gridCircles.enter().append('circle').attr({
	                    'class': 'grid-circle'
	                }).style(lineStyle);
	                gridCircles.attr('r', radialScale);
	                gridCircles.exit().remove();
	            }
	            radialAxis.select('circle.outside-circle').attr({
	                r: radius
	            }).style(lineStyle);
	            var backgroundCircle = svg.select('circle.background-circle').attr({
	                r: radius
	            }).style({
	                fill: axisConfig.backgroundColor,
	                stroke: axisConfig.stroke
	            });
	            function currentAngle(d, i) {
	                return angularScale(d) % 360 + axisConfig.orientation;
	            }
	            if (axisConfig.radialAxis.visible) {
	                var axis = d3.svg.axis().scale(radialScale).ticks(5).tickSize(5);
	                radialAxis.call(axis).attr({
	                    transform: 'rotate(' + axisConfig.radialAxis.orientation + ')'
	                });
	                radialAxis.selectAll('.domain').style(lineStyle);
	                radialAxis.selectAll('g>text').text(function(d, i) {
	                    return this.textContent + axisConfig.radialAxis.ticksSuffix;
	                }).style(fontStyle).style({
	                    'text-anchor': 'start'
	                }).attr({
	                    x: 0,
	                    y: 0,
	                    dx: 0,
	                    dy: 0,
	                    transform: function(d, i) {
	                        if (axisConfig.radialAxis.tickOrientation === 'horizontal') {
	                            return 'rotate(' + -axisConfig.radialAxis.orientation + ') translate(' + [ 0, fontStyle['font-size'] ] + ')';
	                        } else return 'translate(' + [ 0, fontStyle['font-size'] ] + ')';
	                    }
	                });
	                radialAxis.selectAll('g>line').style({
	                    stroke: 'black'
	                });
	            }
	            var angularAxis = svg.select('.angular.axis-group').selectAll('g.angular-tick').data(angularAxisRange);
	            var angularAxisEnter = angularAxis.enter().append('g').classed('angular-tick', true);
	            angularAxis.attr({
	                transform: function(d, i) {
	                    return 'rotate(' + currentAngle(d, i) + ')';
	                }
	            }).style({
	                display: axisConfig.angularAxis.visible ? 'block' : 'none'
	            });
	            angularAxis.exit().remove();
	            angularAxisEnter.append('line').classed('grid-line', true).classed('major', function(d, i) {
	                return i % (axisConfig.minorTicks + 1) == 0;
	            }).classed('minor', function(d, i) {
	                return !(i % (axisConfig.minorTicks + 1) == 0);
	            }).style(lineStyle);
	            angularAxisEnter.selectAll('.minor').style({
	                stroke: axisConfig.minorTickColor
	            });
	            angularAxis.select('line.grid-line').attr({
	                x1: axisConfig.tickLength ? radius - axisConfig.tickLength : 0,
	                x2: radius
	            }).style({
	                display: axisConfig.angularAxis.gridLinesVisible ? 'block' : 'none'
	            });
	            angularAxisEnter.append('text').classed('axis-text', true).style(fontStyle);
	            var ticksText = angularAxis.select('text.axis-text').attr({
	                x: radius + axisConfig.labelOffset,
	                dy: MID_SHIFT + 'em',
	                transform: function(d, i) {
	                    var angle = currentAngle(d, i);
	                    var rad = radius + axisConfig.labelOffset;
	                    var orient = axisConfig.angularAxis.tickOrientation;
	                    if (orient == 'horizontal') return 'rotate(' + -angle + ' ' + rad + ' 0)'; else if (orient == 'radial') return angle < 270 && angle > 90 ? 'rotate(180 ' + rad + ' 0)' : null; else return 'rotate(' + (angle <= 180 && angle > 0 ? -90 : 90) + ' ' + rad + ' 0)';
	                }
	            }).style({
	                'text-anchor': 'middle',
	                display: axisConfig.angularAxis.labelsVisible ? 'block' : 'none'
	            }).text(function(d, i) {
	                if (i % (axisConfig.minorTicks + 1) != 0) return '';
	                if (ticks) {
	                    return ticks[d] + axisConfig.angularAxis.ticksSuffix;
	                } else return d + axisConfig.angularAxis.ticksSuffix;
	            }).style(fontStyle);
	            if (axisConfig.angularAxis.rewriteTicks) ticksText.text(function(d, i) {
	                if (i % (axisConfig.minorTicks + 1) != 0) return '';
	                return axisConfig.angularAxis.rewriteTicks(this.textContent, i);
	            });
	            var rightmostTickEndX = d3.max(chartGroup.selectAll('.angular-tick text')[0].map(function(d, i) {
	                return d.getCTM().e + d.getBBox().width;
	            }));
	            legendContainer.attr({
	                transform: 'translate(' + [ radius + rightmostTickEndX, axisConfig.margin.top ] + ')'
	            });
	            var hasGeometry = svg.select('g.geometry-group').selectAll('g').size() > 0;
	            var geometryContainer = svg.select('g.geometry-group').selectAll('g.geometry').data(data);
	            geometryContainer.enter().append('g').attr({
	                'class': function(d, i) {
	                    return 'geometry geometry' + i;
	                }
	            });
	            geometryContainer.exit().remove();
	            if (data[0] || hasGeometry) {
	                var geometryConfigs = [];
	                data.forEach(function(d, i) {
	                    var geometryConfig = {};
	                    geometryConfig.radialScale = radialScale;
	                    geometryConfig.angularScale = angularScale;
	                    geometryConfig.container = geometryContainer.filter(function(dB, iB) {
	                        return iB == i;
	                    });
	                    geometryConfig.geometry = d.geometry;
	                    geometryConfig.orientation = axisConfig.orientation;
	                    geometryConfig.direction = axisConfig.direction;
	                    geometryConfig.index = i;
	                    geometryConfigs.push({
	                        data: d,
	                        geometryConfig: geometryConfig
	                    });
	                });
	                var geometryConfigsGrouped = d3.nest().key(function(d, i) {
	                    return typeof d.data.groupId != 'undefined' || 'unstacked';
	                }).entries(geometryConfigs);
	                var geometryConfigsGrouped2 = [];
	                geometryConfigsGrouped.forEach(function(d, i) {
	                    if (d.key === 'unstacked') geometryConfigsGrouped2 = geometryConfigsGrouped2.concat(d.values.map(function(d, i) {
	                        return [ d ];
	                    })); else geometryConfigsGrouped2.push(d.values);
	                });
	                geometryConfigsGrouped2.forEach(function(d, i) {
	                    var geometry;
	                    if (Array.isArray(d)) geometry = d[0].geometryConfig.geometry; else geometry = d.geometryConfig.geometry;
	                    var finalGeometryConfig = d.map(function(dB, iB) {
	                        return extendDeepAll(µ[geometry].defaultConfig(), dB);
	                    });
	                    µ[geometry]().config(finalGeometryConfig)();
	                });
	            }
	            var guides = svg.select('.guides-group');
	            var tooltipContainer = svg.select('.tooltips-group');
	            var angularTooltip = µ.tooltipPanel().config({
	                container: tooltipContainer,
	                fontSize: 8
	            })();
	            var radialTooltip = µ.tooltipPanel().config({
	                container: tooltipContainer,
	                fontSize: 8
	            })();
	            var geometryTooltip = µ.tooltipPanel().config({
	                container: tooltipContainer,
	                hasTick: true
	            })();
	            var angularValue, radialValue;
	            if (!isOrdinal) {
	                var angularGuideLine = guides.select('line').attr({
	                    x1: 0,
	                    y1: 0,
	                    y2: 0
	                }).style({
	                    stroke: 'grey',
	                    'pointer-events': 'none'
	                });
	                chartGroup.on('mousemove.angular-guide', function(d, i) {
	                    var mouseAngle = µ.util.getMousePos(backgroundCircle).angle;
	                    angularGuideLine.attr({
	                        x2: -radius,
	                        transform: 'rotate(' + mouseAngle + ')'
	                    }).style({
	                        opacity: .5
	                    });
	                    var angleWithOriginOffset = (mouseAngle + 180 + 360 - axisConfig.orientation) % 360;
	                    angularValue = angularScale.invert(angleWithOriginOffset);
	                    var pos = µ.util.convertToCartesian(radius + 12, mouseAngle + 180);
	                    angularTooltip.text(µ.util.round(angularValue)).move([ pos[0] + chartCenter[0], pos[1] + chartCenter[1] ]);
	                }).on('mouseout.angular-guide', function(d, i) {
	                    guides.select('line').style({
	                        opacity: 0
	                    });
	                });
	            }
	            var angularGuideCircle = guides.select('circle').style({
	                stroke: 'grey',
	                fill: 'none'
	            });
	            chartGroup.on('mousemove.radial-guide', function(d, i) {
	                var r = µ.util.getMousePos(backgroundCircle).radius;
	                angularGuideCircle.attr({
	                    r: r
	                }).style({
	                    opacity: .5
	                });
	                radialValue = radialScale.invert(µ.util.getMousePos(backgroundCircle).radius);
	                var pos = µ.util.convertToCartesian(r, axisConfig.radialAxis.orientation);
	                radialTooltip.text(µ.util.round(radialValue)).move([ pos[0] + chartCenter[0], pos[1] + chartCenter[1] ]);
	            }).on('mouseout.radial-guide', function(d, i) {
	                angularGuideCircle.style({
	                    opacity: 0
	                });
	                geometryTooltip.hide();
	                angularTooltip.hide();
	                radialTooltip.hide();
	            });
	            svg.selectAll('.geometry-group .mark').on('mouseover.tooltip', function(d, i) {
	                var el = d3.select(this);
	                var color = this.style.fill;
	                var newColor = 'black';
	                var opacity = this.style.opacity || 1;
	                el.attr({
	                    'data-opacity': opacity
	                });
	                if (color && color !== 'none') {
	                    el.attr({
	                        'data-fill': color
	                    });
	                    newColor = d3.hsl(color).darker().toString();
	                    el.style({
	                        fill: newColor,
	                        opacity: 1
	                    });
	                    var textData = {
	                        t: µ.util.round(d[0]),
	                        r: µ.util.round(d[1])
	                    };
	                    if (isOrdinal) textData.t = ticks[d[0]];
	                    var text = 't: ' + textData.t + ', r: ' + textData.r;
	                    var bbox = this.getBoundingClientRect();
	                    var svgBBox = svg.node().getBoundingClientRect();
	                    var pos = [ bbox.left + bbox.width / 2 - centeringOffset[0] - svgBBox.left, bbox.top + bbox.height / 2 - centeringOffset[1] - svgBBox.top ];
	                    geometryTooltip.config({
	                        color: newColor
	                    }).text(text);
	                    geometryTooltip.move(pos);
	                } else {
	                    color = this.style.stroke || 'black';
	                    el.attr({
	                        'data-stroke': color
	                    });
	                    newColor = d3.hsl(color).darker().toString();
	                    el.style({
	                        stroke: newColor,
	                        opacity: 1
	                    });
	                }
	            }).on('mousemove.tooltip', function(d, i) {
	                if (d3.event.which != 0) return false;
	                if (d3.select(this).attr('data-fill')) geometryTooltip.show();
	            }).on('mouseout.tooltip', function(d, i) {
	                geometryTooltip.hide();
	                var el = d3.select(this);
	                var fillColor = el.attr('data-fill');
	                if (fillColor) el.style({
	                    fill: fillColor,
	                    opacity: el.attr('data-opacity')
	                }); else el.style({
	                    stroke: el.attr('data-stroke'),
	                    opacity: el.attr('data-opacity')
	                });
	            });
	        });
	        return exports;
	    }
	    exports.render = function(_container) {
	        render(_container);
	        return this;
	    };
	    exports.config = function(_x) {
	        if (!arguments.length) return config;
	        var xClone = µ.util.cloneJson(_x);
	        xClone.data.forEach(function(d, i) {
	            if (!config.data[i]) config.data[i] = {};
	            extendDeepAll(config.data[i], µ.Axis.defaultConfig().data[0]);
	            extendDeepAll(config.data[i], d);
	        });
	        extendDeepAll(config.layout, µ.Axis.defaultConfig().layout);
	        extendDeepAll(config.layout, xClone.layout);
	        return this;
	    };
	    exports.getLiveConfig = function() {
	        return liveConfig;
	    };
	    exports.getinputConfig = function() {
	        return inputConfig;
	    };
	    exports.radialScale = function(_x) {
	        return radialScale;
	    };
	    exports.angularScale = function(_x) {
	        return angularScale;
	    };
	    exports.svg = function() {
	        return svg;
	    };
	    d3.rebind(exports, dispatch, 'on');
	    return exports;
	};
	
	µ.Axis.defaultConfig = function(d, i) {
	    var config = {
	        data: [ {
	            t: [ 1, 2, 3, 4 ],
	            r: [ 10, 11, 12, 13 ],
	            name: 'Line1',
	            geometry: 'LinePlot',
	            color: null,
	            strokeDash: 'solid',
	            strokeColor: null,
	            strokeSize: '1',
	            visibleInLegend: true,
	            opacity: 1
	        } ],
	        layout: {
	            defaultColorRange: d3.scale.category10().range(),
	            title: null,
	            height: 450,
	            width: 500,
	            margin: {
	                top: 40,
	                right: 40,
	                bottom: 40,
	                left: 40
	            },
	            font: {
	                size: 12,
	                color: 'gray',
	                outlineColor: 'white',
	                family: 'Tahoma, sans-serif'
	            },
	            direction: 'clockwise',
	            orientation: 0,
	            labelOffset: 10,
	            radialAxis: {
	                domain: null,
	                orientation: -45,
	                ticksSuffix: '',
	                visible: true,
	                gridLinesVisible: true,
	                tickOrientation: 'horizontal',
	                rewriteTicks: null
	            },
	            angularAxis: {
	                domain: [ 0, 360 ],
	                ticksSuffix: '',
	                visible: true,
	                gridLinesVisible: true,
	                labelsVisible: true,
	                tickOrientation: 'horizontal',
	                rewriteTicks: null,
	                ticksCount: null,
	                ticksStep: null
	            },
	            minorTicks: 0,
	            tickLength: null,
	            tickColor: 'silver',
	            minorTickColor: '#eee',
	            backgroundColor: 'none',
	            needsEndSpacing: null,
	            showLegend: true,
	            legend: {
	                reverseOrder: false
	            },
	            opacity: 1
	        }
	    };
	    return config;
	};
	
	µ.util = {};
	
	µ.DATAEXTENT = 'dataExtent';
	
	µ.AREA = 'AreaChart';
	
	µ.LINE = 'LinePlot';
	
	µ.DOT = 'DotPlot';
	
	µ.BAR = 'BarChart';
	
	µ.util._override = function(_objA, _objB) {
	    for (var x in _objA) if (x in _objB) _objB[x] = _objA[x];
	};
	
	µ.util._extend = function(_objA, _objB) {
	    for (var x in _objA) _objB[x] = _objA[x];
	};
	
	µ.util._rndSnd = function() {
	    return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
	};
	
	µ.util.dataFromEquation2 = function(_equation, _step) {
	    var step = _step || 6;
	    var data = d3.range(0, 360 + step, step).map(function(deg, index) {
	        var theta = deg * Math.PI / 180;
	        var radius = _equation(theta);
	        return [ deg, radius ];
	    });
	    return data;
	};
	
	µ.util.dataFromEquation = function(_equation, _step, _name) {
	    var step = _step || 6;
	    var t = [], r = [];
	    d3.range(0, 360 + step, step).forEach(function(deg, index) {
	        var theta = deg * Math.PI / 180;
	        var radius = _equation(theta);
	        t.push(deg);
	        r.push(radius);
	    });
	    var result = {
	        t: t,
	        r: r
	    };
	    if (_name) result.name = _name;
	    return result;
	};
	
	µ.util.ensureArray = function(_val, _count) {
	    if (typeof _val === 'undefined') return null;
	    var arr = [].concat(_val);
	    return d3.range(_count).map(function(d, i) {
	        return arr[i] || arr[0];
	    });
	};
	
	µ.util.fillArrays = function(_obj, _valueNames, _count) {
	    _valueNames.forEach(function(d, i) {
	        _obj[d] = µ.util.ensureArray(_obj[d], _count);
	    });
	    return _obj;
	};
	
	µ.util.cloneJson = function(json) {
	    return JSON.parse(JSON.stringify(json));
	};
	
	µ.util.validateKeys = function(obj, keys) {
	    if (typeof keys === 'string') keys = keys.split('.');
	    var next = keys.shift();
	    return obj[next] && (!keys.length || objHasKeys(obj[next], keys));
	};
	
	µ.util.sumArrays = function(a, b) {
	    return d3.zip(a, b).map(function(d, i) {
	        return d3.sum(d);
	    });
	};
	
	µ.util.arrayLast = function(a) {
	    return a[a.length - 1];
	};
	
	µ.util.arrayEqual = function(a, b) {
	    var i = Math.max(a.length, b.length, 1);
	    while (i-- >= 0 && a[i] === b[i]) ;
	    return i === -2;
	};
	
	µ.util.flattenArray = function(arr) {
	    var r = [];
	    while (!µ.util.arrayEqual(r, arr)) {
	        r = arr;
	        arr = [].concat.apply([], arr);
	    }
	    return arr;
	};
	
	µ.util.deduplicate = function(arr) {
	    return arr.filter(function(v, i, a) {
	        return a.indexOf(v) == i;
	    });
	};
	
	µ.util.convertToCartesian = function(radius, theta) {
	    var thetaRadians = theta * Math.PI / 180;
	    var x = radius * Math.cos(thetaRadians);
	    var y = radius * Math.sin(thetaRadians);
	    return [ x, y ];
	};
	
	µ.util.round = function(_value, _digits) {
	    var digits = _digits || 2;
	    var mult = Math.pow(10, digits);
	    return Math.round(_value * mult) / mult;
	};
	
	µ.util.getMousePos = function(_referenceElement) {
	    var mousePos = d3.mouse(_referenceElement.node());
	    var mouseX = mousePos[0];
	    var mouseY = mousePos[1];
	    var mouse = {};
	    mouse.x = mouseX;
	    mouse.y = mouseY;
	    mouse.pos = mousePos;
	    mouse.angle = (Math.atan2(mouseY, mouseX) + Math.PI) * 180 / Math.PI;
	    mouse.radius = Math.sqrt(mouseX * mouseX + mouseY * mouseY);
	    return mouse;
	};
	
	µ.util.duplicatesCount = function(arr) {
	    var uniques = {}, val;
	    var dups = {};
	    for (var i = 0, len = arr.length; i < len; i++) {
	        val = arr[i];
	        if (val in uniques) {
	            uniques[val]++;
	            dups[val] = uniques[val];
	        } else {
	            uniques[val] = 1;
	        }
	    }
	    return dups;
	};
	
	µ.util.duplicates = function(arr) {
	    return Object.keys(µ.util.duplicatesCount(arr));
	};
	
	µ.util.translator = function(obj, sourceBranch, targetBranch, reverse) {
	    if (reverse) {
	        var targetBranchCopy = targetBranch.slice();
	        targetBranch = sourceBranch;
	        sourceBranch = targetBranchCopy;
	    }
	    var value = sourceBranch.reduce(function(previousValue, currentValue) {
	        if (typeof previousValue != 'undefined') return previousValue[currentValue];
	    }, obj);
	    if (typeof value === 'undefined') return;
	    sourceBranch.reduce(function(previousValue, currentValue, index) {
	        if (typeof previousValue == 'undefined') return;
	        if (index === sourceBranch.length - 1) delete previousValue[currentValue];
	        return previousValue[currentValue];
	    }, obj);
	    targetBranch.reduce(function(previousValue, currentValue, index) {
	        if (typeof previousValue[currentValue] === 'undefined') previousValue[currentValue] = {};
	        if (index === targetBranch.length - 1) previousValue[currentValue] = value;
	        return previousValue[currentValue];
	    }, obj);
	};
	
	µ.PolyChart = function module() {
	    var config = [ µ.PolyChart.defaultConfig() ];
	    var dispatch = d3.dispatch('hover');
	    var dashArray = {
	        solid: 'none',
	        dash: [ 5, 2 ],
	        dot: [ 2, 5 ]
	    };
	    var colorScale;
	    function exports() {
	        var geometryConfig = config[0].geometryConfig;
	        var container = geometryConfig.container;
	        if (typeof container == 'string') container = d3.select(container);
	        container.datum(config).each(function(_config, _index) {
	            var isStack = !!_config[0].data.yStack;
	            var data = _config.map(function(d, i) {
	                if (isStack) return d3.zip(d.data.t[0], d.data.r[0], d.data.yStack[0]); else return d3.zip(d.data.t[0], d.data.r[0]);
	            });
	            var angularScale = geometryConfig.angularScale;
	            var domainMin = geometryConfig.radialScale.domain()[0];
	            var generator = {};
	            generator.bar = function(d, i, pI) {
	                var dataConfig = _config[pI].data;
	                var h = geometryConfig.radialScale(d[1]) - geometryConfig.radialScale(0);
	                var stackTop = geometryConfig.radialScale(d[2] || 0);
	                var w = dataConfig.barWidth;
	                d3.select(this).attr({
	                    'class': 'mark bar',
	                    d: 'M' + [ [ h + stackTop, -w / 2 ], [ h + stackTop, w / 2 ], [ stackTop, w / 2 ], [ stackTop, -w / 2 ] ].join('L') + 'Z',
	                    transform: function(d, i) {
	                        return 'rotate(' + (geometryConfig.orientation + angularScale(d[0])) + ')';
	                    }
	                });
	            };
	            generator.dot = function(d, i, pI) {
	                var stackedData = d[2] ? [ d[0], d[1] + d[2] ] : d;
	                var symbol = d3.svg.symbol().size(_config[pI].data.dotSize).type(_config[pI].data.dotType)(d, i);
	                d3.select(this).attr({
	                    'class': 'mark dot',
	                    d: symbol,
	                    transform: function(d, i) {
	                        var coord = convertToCartesian(getPolarCoordinates(stackedData));
	                        return 'translate(' + [ coord.x, coord.y ] + ')';
	                    }
	                });
	            };
	            var line = d3.svg.line.radial().interpolate(_config[0].data.lineInterpolation).radius(function(d) {
	                return geometryConfig.radialScale(d[1]);
	            }).angle(function(d) {
	                return geometryConfig.angularScale(d[0]) * Math.PI / 180;
	            });
	            generator.line = function(d, i, pI) {
	                var lineData = d[2] ? data[pI].map(function(d, i) {
	                    return [ d[0], d[1] + d[2] ];
	                }) : data[pI];
	                d3.select(this).each(generator['dot']).style({
	                    opacity: function(dB, iB) {
	                        return +_config[pI].data.dotVisible;
	                    },
	                    fill: markStyle.stroke(d, i, pI)
	                }).attr({
	                    'class': 'mark dot'
	                });
	                if (i > 0) return;
	                var lineSelection = d3.select(this.parentNode).selectAll('path.line').data([ 0 ]);
	                lineSelection.enter().insert('path');
	                lineSelection.attr({
	                    'class': 'line',
	                    d: line(lineData),
	                    transform: function(dB, iB) {
	                        return 'rotate(' + (geometryConfig.orientation + 90) + ')';
	                    },
	                    'pointer-events': 'none'
	                }).style({
	                    fill: function(dB, iB) {
	                        return markStyle.fill(d, i, pI);
	                    },
	                    'fill-opacity': 0,
	                    stroke: function(dB, iB) {
	                        return markStyle.stroke(d, i, pI);
	                    },
	                    'stroke-width': function(dB, iB) {
	                        return markStyle['stroke-width'](d, i, pI);
	                    },
	                    'stroke-dasharray': function(dB, iB) {
	                        return markStyle['stroke-dasharray'](d, i, pI);
	                    },
	                    opacity: function(dB, iB) {
	                        return markStyle.opacity(d, i, pI);
	                    },
	                    display: function(dB, iB) {
	                        return markStyle.display(d, i, pI);
	                    }
	                });
	            };
	            var angularRange = geometryConfig.angularScale.range();
	            var triangleAngle = Math.abs(angularRange[1] - angularRange[0]) / data[0].length * Math.PI / 180;
	            var arc = d3.svg.arc().startAngle(function(d) {
	                return -triangleAngle / 2;
	            }).endAngle(function(d) {
	                return triangleAngle / 2;
	            }).innerRadius(function(d) {
	                return geometryConfig.radialScale(domainMin + (d[2] || 0));
	            }).outerRadius(function(d) {
	                return geometryConfig.radialScale(domainMin + (d[2] || 0)) + geometryConfig.radialScale(d[1]);
	            });
	            generator.arc = function(d, i, pI) {
	                d3.select(this).attr({
	                    'class': 'mark arc',
	                    d: arc,
	                    transform: function(d, i) {
	                        return 'rotate(' + (geometryConfig.orientation + angularScale(d[0]) + 90) + ')';
	                    }
	                });
	            };
	            var markStyle = {
	                fill: function(d, i, pI) {
	                    return _config[pI].data.color;
	                },
	                stroke: function(d, i, pI) {
	                    return _config[pI].data.strokeColor;
	                },
	                'stroke-width': function(d, i, pI) {
	                    return _config[pI].data.strokeSize + 'px';
	                },
	                'stroke-dasharray': function(d, i, pI) {
	                    return dashArray[_config[pI].data.strokeDash];
	                },
	                opacity: function(d, i, pI) {
	                    return _config[pI].data.opacity;
	                },
	                display: function(d, i, pI) {
	                    return typeof _config[pI].data.visible === 'undefined' || _config[pI].data.visible ? 'block' : 'none';
	                }
	            };
	            var geometryLayer = d3.select(this).selectAll('g.layer').data(data);
	            geometryLayer.enter().append('g').attr({
	                'class': 'layer'
	            });
	            var geometry = geometryLayer.selectAll('path.mark').data(function(d, i) {
	                return d;
	            });
	            geometry.enter().append('path').attr({
	                'class': 'mark'
	            });
	            geometry.style(markStyle).each(generator[geometryConfig.geometryType]);
	            geometry.exit().remove();
	            geometryLayer.exit().remove();
	            function getPolarCoordinates(d, i) {
	                var r = geometryConfig.radialScale(d[1]);
	                var t = (geometryConfig.angularScale(d[0]) + geometryConfig.orientation) * Math.PI / 180;
	                return {
	                    r: r,
	                    t: t
	                };
	            }
	            function convertToCartesian(polarCoordinates) {
	                var x = polarCoordinates.r * Math.cos(polarCoordinates.t);
	                var y = polarCoordinates.r * Math.sin(polarCoordinates.t);
	                return {
	                    x: x,
	                    y: y
	                };
	            }
	        });
	    }
	    exports.config = function(_x) {
	        if (!arguments.length) return config;
	        _x.forEach(function(d, i) {
	            if (!config[i]) config[i] = {};
	            extendDeepAll(config[i], µ.PolyChart.defaultConfig());
	            extendDeepAll(config[i], d);
	        });
	        return this;
	    };
	    exports.getColorScale = function() {
	        return colorScale;
	    };
	    d3.rebind(exports, dispatch, 'on');
	    return exports;
	};
	
	µ.PolyChart.defaultConfig = function() {
	    var config = {
	        data: {
	            name: 'geom1',
	            t: [ [ 1, 2, 3, 4 ] ],
	            r: [ [ 1, 2, 3, 4 ] ],
	            dotType: 'circle',
	            dotSize: 64,
	            dotVisible: false,
	            barWidth: 20,
	            color: '#ffa500',
	            strokeSize: 1,
	            strokeColor: 'silver',
	            strokeDash: 'solid',
	            opacity: 1,
	            index: 0,
	            visible: true,
	            visibleInLegend: true
	        },
	        geometryConfig: {
	            geometry: 'LinePlot',
	            geometryType: 'arc',
	            direction: 'clockwise',
	            orientation: 0,
	            container: 'body',
	            radialScale: null,
	            angularScale: null,
	            colorScale: d3.scale.category20()
	        }
	    };
	    return config;
	};
	
	µ.BarChart = function module() {
	    return µ.PolyChart();
	};
	
	µ.BarChart.defaultConfig = function() {
	    var config = {
	        geometryConfig: {
	            geometryType: 'bar'
	        }
	    };
	    return config;
	};
	
	µ.AreaChart = function module() {
	    return µ.PolyChart();
	};
	
	µ.AreaChart.defaultConfig = function() {
	    var config = {
	        geometryConfig: {
	            geometryType: 'arc'
	        }
	    };
	    return config;
	};
	
	µ.DotPlot = function module() {
	    return µ.PolyChart();
	};
	
	µ.DotPlot.defaultConfig = function() {
	    var config = {
	        geometryConfig: {
	            geometryType: 'dot',
	            dotType: 'circle'
	        }
	    };
	    return config;
	};
	
	µ.LinePlot = function module() {
	    return µ.PolyChart();
	};
	
	µ.LinePlot.defaultConfig = function() {
	    var config = {
	        geometryConfig: {
	            geometryType: 'line'
	        }
	    };
	    return config;
	};
	
	µ.Legend = function module() {
	    var config = µ.Legend.defaultConfig();
	    var dispatch = d3.dispatch('hover');
	    function exports() {
	        var legendConfig = config.legendConfig;
	        var flattenData = config.data.map(function(d, i) {
	            return [].concat(d).map(function(dB, iB) {
	                var element = extendDeepAll({}, legendConfig.elements[i]);
	                element.name = dB;
	                element.color = [].concat(legendConfig.elements[i].color)[iB];
	                return element;
	            });
	        });
	        var data = d3.merge(flattenData);
	        data = data.filter(function(d, i) {
	            return legendConfig.elements[i] && (legendConfig.elements[i].visibleInLegend || typeof legendConfig.elements[i].visibleInLegend === 'undefined');
	        });
	        if (legendConfig.reverseOrder) data = data.reverse();
	        var container = legendConfig.container;
	        if (typeof container == 'string' || container.nodeName) container = d3.select(container);
	        var colors = data.map(function(d, i) {
	            return d.color;
	        });
	        var lineHeight = legendConfig.fontSize;
	        var isContinuous = legendConfig.isContinuous == null ? typeof data[0] === 'number' : legendConfig.isContinuous;
	        var height = isContinuous ? legendConfig.height : lineHeight * data.length;
	        var legendContainerGroup = container.classed('legend-group', true);
	        var svg = legendContainerGroup.selectAll('svg').data([ 0 ]);
	        var svgEnter = svg.enter().append('svg').attr({
	            width: 300,
	            height: height + lineHeight,
	            xmlns: 'http://www.w3.org/2000/svg',
	            'xmlns:xlink': 'http://www.w3.org/1999/xlink',
	            version: '1.1'
	        });
	        svgEnter.append('g').classed('legend-axis', true);
	        svgEnter.append('g').classed('legend-marks', true);
	        var dataNumbered = d3.range(data.length);
	        var colorScale = d3.scale[isContinuous ? 'linear' : 'ordinal']().domain(dataNumbered).range(colors);
	        var dataScale = d3.scale[isContinuous ? 'linear' : 'ordinal']().domain(dataNumbered)[isContinuous ? 'range' : 'rangePoints']([ 0, height ]);
	        var shapeGenerator = function(_type, _size) {
	            var squareSize = _size * 3;
	            if (_type === 'line') {
	                return 'M' + [ [ -_size / 2, -_size / 12 ], [ _size / 2, -_size / 12 ], [ _size / 2, _size / 12 ], [ -_size / 2, _size / 12 ] ] + 'Z';
	            } else if (d3.svg.symbolTypes.indexOf(_type) != -1) return d3.svg.symbol().type(_type).size(squareSize)(); else return d3.svg.symbol().type('square').size(squareSize)();
	        };
	        if (isContinuous) {
	            var gradient = svg.select('.legend-marks').append('defs').append('linearGradient').attr({
	                id: 'grad1',
	                x1: '0%',
	                y1: '0%',
	                x2: '0%',
	                y2: '100%'
	            }).selectAll('stop').data(colors);
	            gradient.enter().append('stop');
	            gradient.attr({
	                offset: function(d, i) {
	                    return i / (colors.length - 1) * 100 + '%';
	                }
	            }).style({
	                'stop-color': function(d, i) {
	                    return d;
	                }
	            });
	            svg.append('rect').classed('legend-mark', true).attr({
	                height: legendConfig.height,
	                width: legendConfig.colorBandWidth,
	                fill: 'url(#grad1)'
	            });
	        } else {
	            var legendElement = svg.select('.legend-marks').selectAll('path.legend-mark').data(data);
	            legendElement.enter().append('path').classed('legend-mark', true);
	            legendElement.attr({
	                transform: function(d, i) {
	                    return 'translate(' + [ lineHeight / 2, dataScale(i) + lineHeight / 2 ] + ')';
	                },
	                d: function(d, i) {
	                    var symbolType = d.symbol;
	                    return shapeGenerator(symbolType, lineHeight);
	                },
	                fill: function(d, i) {
	                    return colorScale(i);
	                }
	            });
	            legendElement.exit().remove();
	        }
	        var legendAxis = d3.svg.axis().scale(dataScale).orient('right');
	        var axis = svg.select('g.legend-axis').attr({
	            transform: 'translate(' + [ isContinuous ? legendConfig.colorBandWidth : lineHeight, lineHeight / 2 ] + ')'
	        }).call(legendAxis);
	        axis.selectAll('.domain').style({
	            fill: 'none',
	            stroke: 'none'
	        });
	        axis.selectAll('line').style({
	            fill: 'none',
	            stroke: isContinuous ? legendConfig.textColor : 'none'
	        });
	        axis.selectAll('text').style({
	            fill: legendConfig.textColor,
	            'font-size': legendConfig.fontSize
	        }).text(function(d, i) {
	            return data[i].name;
	        });
	        return exports;
	    }
	    exports.config = function(_x) {
	        if (!arguments.length) return config;
	        extendDeepAll(config, _x);
	        return this;
	    };
	    d3.rebind(exports, dispatch, 'on');
	    return exports;
	};
	
	µ.Legend.defaultConfig = function(d, i) {
	    var config = {
	        data: [ 'a', 'b', 'c' ],
	        legendConfig: {
	            elements: [ {
	                symbol: 'line',
	                color: 'red'
	            }, {
	                symbol: 'square',
	                color: 'yellow'
	            }, {
	                symbol: 'diamond',
	                color: 'limegreen'
	            } ],
	            height: 150,
	            colorBandWidth: 30,
	            fontSize: 12,
	            container: 'body',
	            isContinuous: null,
	            textColor: 'grey',
	            reverseOrder: false
	        }
	    };
	    return config;
	};
	
	µ.tooltipPanel = function() {
	    var tooltipEl, tooltipTextEl, backgroundEl;
	    var config = {
	        container: null,
	        hasTick: false,
	        fontSize: 12,
	        color: 'white',
	        padding: 5
	    };
	    var id = 'tooltip-' + µ.tooltipPanel.uid++;
	    var tickSize = 10;
	    var exports = function() {
	        tooltipEl = config.container.selectAll('g.' + id).data([ 0 ]);
	        var tooltipEnter = tooltipEl.enter().append('g').classed(id, true).style({
	            'pointer-events': 'none',
	            display: 'none'
	        });
	        backgroundEl = tooltipEnter.append('path').style({
	            fill: 'white',
	            'fill-opacity': .9
	        }).attr({
	            d: 'M0 0'
	        });
	        tooltipTextEl = tooltipEnter.append('text').attr({
	            dx: config.padding + tickSize,
	            dy: +config.fontSize * .3
	        });
	        return exports;
	    };
	    exports.text = function(_text) {
	        var l = d3.hsl(config.color).l;
	        var strokeColor = l >= .5 ? '#aaa' : 'white';
	        var fillColor = l >= .5 ? 'black' : 'white';
	        var text = _text || '';
	        tooltipTextEl.style({
	            fill: fillColor,
	            'font-size': config.fontSize + 'px'
	        }).text(text);
	        var padding = config.padding;
	        var bbox = tooltipTextEl.node().getBBox();
	        var boxStyle = {
	            fill: config.color,
	            stroke: strokeColor,
	            'stroke-width': '2px'
	        };
	        var backGroundW = bbox.width + padding * 2 + tickSize;
	        var backGroundH = bbox.height + padding * 2;
	        backgroundEl.attr({
	            d: 'M' + [ [ tickSize, -backGroundH / 2 ], [ tickSize, -backGroundH / 4 ], [ config.hasTick ? 0 : tickSize, 0 ], [ tickSize, backGroundH / 4 ], [ tickSize, backGroundH / 2 ], [ backGroundW, backGroundH / 2 ], [ backGroundW, -backGroundH / 2 ] ].join('L') + 'Z'
	        }).style(boxStyle);
	        tooltipEl.attr({
	            transform: 'translate(' + [ tickSize, -backGroundH / 2 + padding * 2 ] + ')'
	        });
	        tooltipEl.style({
	            display: 'block'
	        });
	        return exports;
	    };
	    exports.move = function(_pos) {
	        if (!tooltipEl) return;
	        tooltipEl.attr({
	            transform: 'translate(' + [ _pos[0], _pos[1] ] + ')'
	        }).style({
	            display: 'block'
	        });
	        return exports;
	    };
	    exports.hide = function() {
	        if (!tooltipEl) return;
	        tooltipEl.style({
	            display: 'none'
	        });
	        return exports;
	    };
	    exports.show = function() {
	        if (!tooltipEl) return;
	        tooltipEl.style({
	            display: 'block'
	        });
	        return exports;
	    };
	    exports.config = function(_x) {
	        extendDeepAll(config, _x);
	        return exports;
	    };
	    return exports;
	};
	
	µ.tooltipPanel.uid = 1;
	
	µ.adapter = {};
	
	µ.adapter.plotly = function module() {
	    var exports = {};
	    exports.convert = function(_inputConfig, reverse) {
	        var outputConfig = {};
	        if (_inputConfig.data) {
	            outputConfig.data = _inputConfig.data.map(function(d, i) {
	                var r = extendDeepAll({}, d);
	                var toTranslate = [
	                    [ r, [ 'marker', 'color' ], [ 'color' ] ],
	                    [ r, [ 'marker', 'opacity' ], [ 'opacity' ] ],
	                    [ r, [ 'marker', 'line', 'color' ], [ 'strokeColor' ] ],
	                    [ r, [ 'marker', 'line', 'dash' ], [ 'strokeDash' ] ],
	                    [ r, [ 'marker', 'line', 'width' ], [ 'strokeSize' ] ],
	                    [ r, [ 'marker', 'symbol' ], [ 'dotType' ] ],
	                    [ r, [ 'marker', 'size' ], [ 'dotSize' ] ],
	                    [ r, [ 'marker', 'barWidth' ], [ 'barWidth' ] ],
	                    [ r, [ 'line', 'interpolation' ], [ 'lineInterpolation' ] ],
	                    [ r, [ 'showlegend' ], [ 'visibleInLegend' ] ]
	                ];
	                toTranslate.forEach(function(d, i) {
	                    µ.util.translator.apply(null, d.concat(reverse));
	                });
	
	                if (!reverse) delete r.marker;
	                if (reverse) delete r.groupId;
	                if (!reverse) {
	                    if (r.type === 'scatter') {
	                        if (r.mode === 'lines') r.geometry = 'LinePlot'; else if (r.mode === 'markers') r.geometry = 'DotPlot'; else if (r.mode === 'lines+markers') {
	                            r.geometry = 'LinePlot';
	                            r.dotVisible = true;
	                        }
	                    } else if (r.type === 'area') r.geometry = 'AreaChart'; else if (r.type === 'bar') r.geometry = 'BarChart';
	                    delete r.mode;
	                    delete r.type;
	                } else {
	                    if (r.geometry === 'LinePlot') {
	                        r.type = 'scatter';
	                        if (r.dotVisible === true) {
	                            delete r.dotVisible;
	                            r.mode = 'lines+markers';
	                        } else r.mode = 'lines';
	                    } else if (r.geometry === 'DotPlot') {
	                        r.type = 'scatter';
	                        r.mode = 'markers';
	                    } else if (r.geometry === 'AreaChart') r.type = 'area'; else if (r.geometry === 'BarChart') r.type = 'bar';
	                    delete r.geometry;
	                }
	                return r;
	            });
	            if (!reverse && _inputConfig.layout && _inputConfig.layout.barmode === 'stack') {
	                var duplicates = µ.util.duplicates(outputConfig.data.map(function(d, i) {
	                    return d.geometry;
	                }));
	                outputConfig.data.forEach(function(d, i) {
	                    var idx = duplicates.indexOf(d.geometry);
	                    if (idx != -1) outputConfig.data[i].groupId = idx;
	                });
	            }
	        }
	        if (_inputConfig.layout) {
	            var r = extendDeepAll({}, _inputConfig.layout);
	            var toTranslate = [
	                [ r, [ 'plot_bgcolor' ], [ 'backgroundColor' ] ],
	                [ r, [ 'showlegend' ], [ 'showLegend' ] ],
	                [ r, [ 'radialaxis' ], [ 'radialAxis' ] ],
	                [ r, [ 'angularaxis' ], [ 'angularAxis' ] ],
	                [ r.angularaxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
	                [ r.angularaxis, [ 'showticklabels' ], [ 'labelsVisible' ] ],
	                [ r.angularaxis, [ 'nticks' ], [ 'ticksCount' ] ],
	                [ r.angularaxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
	                [ r.angularaxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
	                [ r.angularaxis, [ 'range' ], [ 'domain' ] ],
	                [ r.angularaxis, [ 'endpadding' ], [ 'endPadding' ] ],
	                [ r.radialaxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
	                [ r.radialaxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
	                [ r.radialaxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
	                [ r.radialaxis, [ 'range' ], [ 'domain' ] ],
	                [ r.angularAxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
	                [ r.angularAxis, [ 'showticklabels' ], [ 'labelsVisible' ] ],
	                [ r.angularAxis, [ 'nticks' ], [ 'ticksCount' ] ],
	                [ r.angularAxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
	                [ r.angularAxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
	                [ r.angularAxis, [ 'range' ], [ 'domain' ] ],
	                [ r.angularAxis, [ 'endpadding' ], [ 'endPadding' ] ],
	                [ r.radialAxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
	                [ r.radialAxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
	                [ r.radialAxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
	                [ r.radialAxis, [ 'range' ], [ 'domain' ] ],
	                [ r.font, [ 'outlinecolor' ], [ 'outlineColor' ] ],
	                [ r.legend, [ 'traceorder' ], [ 'reverseOrder' ] ],
	                [ r, [ 'labeloffset' ], [ 'labelOffset' ] ],
	                [ r, [ 'defaultcolorrange' ], [ 'defaultColorRange' ] ]
	            ];
	            toTranslate.forEach(function(d, i) {
	                µ.util.translator.apply(null, d.concat(reverse));
	            });
	
	            if (!reverse) {
	                if (r.angularAxis && typeof r.angularAxis.ticklen !== 'undefined') r.tickLength = r.angularAxis.ticklen;
	                if (r.angularAxis && typeof r.angularAxis.tickcolor !== 'undefined') r.tickColor = r.angularAxis.tickcolor;
	            } else {
	                if (typeof r.tickLength !== 'undefined') {
	                    r.angularaxis.ticklen = r.tickLength;
	                    delete r.tickLength;
	                }
	                if (r.tickColor) {
	                    r.angularaxis.tickcolor = r.tickColor;
	                    delete r.tickColor;
	                }
	            }
	            if (r.legend && typeof r.legend.reverseOrder != 'boolean') {
	                r.legend.reverseOrder = r.legend.reverseOrder != 'normal';
	            }
	            if (r.legend && typeof r.legend.traceorder == 'boolean') {
	                r.legend.traceorder = r.legend.traceorder ? 'reversed' : 'normal';
	                delete r.legend.reverseOrder;
	            }
	            if (r.margin && typeof r.margin.t != 'undefined') {
	                var source = [ 't', 'r', 'b', 'l', 'pad' ];
	                var target = [ 'top', 'right', 'bottom', 'left', 'pad' ];
	                var margin = {};
	                d3.entries(r.margin).forEach(function(dB, iB) {
	                    margin[target[source.indexOf(dB.key)]] = dB.value;
	                });
	                r.margin = margin;
	            }
	            if (reverse) {
	                delete r.needsEndSpacing;
	                delete r.minorTickColor;
	                delete r.minorTicks;
	                delete r.angularaxis.ticksCount;
	                delete r.angularaxis.ticksCount;
	                delete r.angularaxis.ticksStep;
	                delete r.angularaxis.rewriteTicks;
	                delete r.angularaxis.nticks;
	                delete r.radialaxis.ticksCount;
	                delete r.radialaxis.ticksCount;
	                delete r.radialaxis.ticksStep;
	                delete r.radialaxis.rewriteTicks;
	                delete r.radialaxis.nticks;
	            }
	            outputConfig.layout = r;
	        }
	        return outputConfig;
	    };
	    return exports;
	};
	
	},{"../../../constants/alignment":685,"../../../lib":716,"d3":164}],835:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	/* eslint-disable new-cap */
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../../lib');
	var Color = _dereq_('../../../components/color');
	
	var micropolar = _dereq_('./micropolar');
	var UndoManager = _dereq_('./undo_manager');
	var extendDeepAll = Lib.extendDeepAll;
	
	var manager = module.exports = {};
	
	manager.framework = function(_gd) {
	    var config, previousConfigClone, plot, convertedInput, container;
	    var undoManager = new UndoManager();
	
	    function exports(_inputConfig, _container) {
	        if(_container) container = _container;
	        d3.select(d3.select(container).node().parentNode).selectAll('.svg-container>*:not(.chart-root)').remove();
	
	        config = (!config) ?
	            _inputConfig :
	            extendDeepAll(config, _inputConfig);
	
	        if(!plot) plot = micropolar.Axis();
	        convertedInput = micropolar.adapter.plotly().convert(config);
	        plot.config(convertedInput).render(container);
	        _gd.data = config.data;
	        _gd.layout = config.layout;
	        manager.fillLayout(_gd);
	        return config;
	    }
	    exports.isPolar = true;
	    exports.svg = function() { return plot.svg(); };
	    exports.getConfig = function() { return config; };
	    exports.getLiveConfig = function() {
	        return micropolar.adapter.plotly().convert(plot.getLiveConfig(), true);
	    };
	    exports.getLiveScales = function() { return {t: plot.angularScale(), r: plot.radialScale()}; };
	    exports.setUndoPoint = function() {
	        var that = this;
	        var configClone = micropolar.util.cloneJson(config);
	        (function(_configClone, _previousConfigClone) {
	            undoManager.add({
	                undo: function() {
	                    if(_previousConfigClone) that(_previousConfigClone);
	                },
	                redo: function() {
	                    that(_configClone);
	                }
	            });
	        })(configClone, previousConfigClone);
	        previousConfigClone = micropolar.util.cloneJson(configClone);
	    };
	    exports.undo = function() { undoManager.undo(); };
	    exports.redo = function() { undoManager.redo(); };
	    return exports;
	};
	
	manager.fillLayout = function(_gd) {
	    var container = d3.select(_gd).selectAll('.plot-container');
	    var paperDiv = container.selectAll('.svg-container');
	    var paper = _gd.framework && _gd.framework.svg && _gd.framework.svg();
	    var dflts = {
	        width: 800,
	        height: 600,
	        paper_bgcolor: Color.background,
	        _container: container,
	        _paperdiv: paperDiv,
	        _paper: paper
	    };
	
	    _gd._fullLayout = extendDeepAll(dflts, _gd.layout);
	};
	
	},{"../../../components/color":591,"../../../lib":716,"./micropolar":834,"./undo_manager":836,"d3":164}],836:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// Modified from https://github.com/ArthurClemens/Javascript-Undo-Manager
	// Copyright (c) 2010-2013 Arthur Clemens, arthur@visiblearea.com
	module.exports = function UndoManager() {
	    var undoCommands = [];
	    var index = -1;
	    var isExecuting = false;
	    var callback;
	
	    function execute(command, action) {
	        if(!command) return this;
	
	        isExecuting = true;
	        command[action]();
	        isExecuting = false;
	
	        return this;
	    }
	
	    return {
	        add: function(command) {
	            if(isExecuting) return this;
	            undoCommands.splice(index + 1, undoCommands.length - index);
	            undoCommands.push(command);
	            index = undoCommands.length - 1;
	            return this;
	        },
	        setCallback: function(callbackFunc) { callback = callbackFunc; },
	        undo: function() {
	            var command = undoCommands[index];
	            if(!command) return this;
	            execute(command, 'undo');
	            index -= 1;
	            if(callback) callback(command.undo);
	            return this;
	        },
	        redo: function() {
	            var command = undoCommands[index + 1];
	            if(!command) return this;
	            execute(command, 'redo');
	            index += 1;
	            if(callback) callback(command.redo);
	            return this;
	        },
	        clear: function() {
	            undoCommands = [];
	            index = -1;
	        },
	        hasUndo: function() { return index !== -1; },
	        hasRedo: function() { return index < (undoCommands.length - 1); },
	        getCommands: function() { return undoCommands; },
	        getPreviousCommand: function() { return undoCommands[index - 1]; },
	        getIndex: function() { return index; }
	    };
	};
	
	},{}],837:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Plots = _dereq_('../plots');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var setConvertCartesian = _dereq_('../cartesian/set_convert');
	var setConvertPolar = _dereq_('./set_convert');
	var doAutoRange = _dereq_('../cartesian/autorange').doAutoRange;
	var dragBox = _dereq_('../cartesian/dragbox');
	var dragElement = _dereq_('../../components/dragelement');
	var Fx = _dereq_('../../components/fx');
	var Titles = _dereq_('../../components/titles');
	var prepSelect = _dereq_('../cartesian/select').prepSelect;
	var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
	var clearSelect = _dereq_('../cartesian/select').clearSelect;
	var setCursor = _dereq_('../../lib/setcursor');
	var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
	var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
	
	var MID_SHIFT = _dereq_('../../constants/alignment').MID_SHIFT;
	var constants = _dereq_('./constants');
	var helpers = _dereq_('./helpers');
	
	var _ = Lib._;
	var mod = Lib.mod;
	var deg2rad = Lib.deg2rad;
	var rad2deg = Lib.rad2deg;
	
	function Polar(gd, id) {
	    this.id = id;
	    this.gd = gd;
	
	    this._hasClipOnAxisFalse = null;
	    this.vangles = null;
	    this.radialAxisAngle = null;
	    this.traceHash = {};
	    this.layers = {};
	    this.clipPaths = {};
	    this.clipIds = {};
	    this.viewInitial = {};
	
	    var fullLayout = gd._fullLayout;
	    var clipIdBase = 'clip' + fullLayout._uid + id;
	
	    this.clipIds.forTraces = clipIdBase + '-for-traces';
	    this.clipPaths.forTraces = fullLayout._clips.append('clipPath')
	        .attr('id', this.clipIds.forTraces);
	    this.clipPaths.forTraces.append('path');
	
	    this.framework = fullLayout._polarlayer.append('g')
	        .attr('class', id);
	
	    // unfortunately, we have to keep track of some axis tick settings
	    // as polar subplots do not implement the 'ticks' editType
	    this.radialTickLayout = null;
	    this.angularTickLayout = null;
	}
	
	var proto = Polar.prototype;
	
	module.exports = function createPolar(gd, id) {
	    return new Polar(gd, id);
	};
	
	proto.plot = function(polarCalcData, fullLayout) {
	    var _this = this;
	    var polarLayout = fullLayout[_this.id];
	
	    _this._hasClipOnAxisFalse = false;
	    for(var i = 0; i < polarCalcData.length; i++) {
	        var trace = polarCalcData[i][0].trace;
	        if(trace.cliponaxis === false) {
	            _this._hasClipOnAxisFalse = true;
	            break;
	        }
	    }
	
	    _this.updateLayers(fullLayout, polarLayout);
	    _this.updateLayout(fullLayout, polarLayout);
	    Plots.generalUpdatePerTraceModule(_this.gd, _this, polarCalcData, polarLayout);
	    _this.updateFx(fullLayout, polarLayout);
	};
	
	proto.updateLayers = function(fullLayout, polarLayout) {
	    var _this = this;
	    var layers = _this.layers;
	    var radialLayout = polarLayout.radialaxis;
	    var angularLayout = polarLayout.angularaxis;
	    var layerNames = constants.layerNames;
	
	    var frontPlotIndex = layerNames.indexOf('frontplot');
	    var layerData = layerNames.slice(0, frontPlotIndex);
	    var isAngularAxisBelowTraces = angularLayout.layer === 'below traces';
	    var isRadialAxisBelowTraces = radialLayout.layer === 'below traces';
	
	    if(isAngularAxisBelowTraces) layerData.push('angular-line');
	    if(isRadialAxisBelowTraces) layerData.push('radial-line');
	    if(isAngularAxisBelowTraces) layerData.push('angular-axis');
	    if(isRadialAxisBelowTraces) layerData.push('radial-axis');
	
	    layerData.push('frontplot');
	
	    if(!isAngularAxisBelowTraces) layerData.push('angular-line');
	    if(!isRadialAxisBelowTraces) layerData.push('radial-line');
	    if(!isAngularAxisBelowTraces) layerData.push('angular-axis');
	    if(!isRadialAxisBelowTraces) layerData.push('radial-axis');
	
	    var join = _this.framework.selectAll('.polarsublayer')
	        .data(layerData, String);
	
	    join.enter().append('g')
	        .attr('class', function(d) { return 'polarsublayer ' + d;})
	        .each(function(d) {
	            var sel = layers[d] = d3.select(this);
	
	            switch(d) {
	                case 'frontplot':
	                    // TODO add option to place in 'backplot' layer??
	                    sel.append('g').classed('barlayer', true);
	                    sel.append('g').classed('scatterlayer', true);
	                    break;
	                case 'backplot':
	                    sel.append('g').classed('maplayer', true);
	                    break;
	                case 'plotbg':
	                    layers.bg = sel.append('path');
	                    break;
	                case 'radial-grid':
	                    sel.style('fill', 'none');
	                    break;
	                case 'angular-grid':
	                    sel.style('fill', 'none');
	                    break;
	                case 'radial-line':
	                    sel.append('line').style('fill', 'none');
	                    break;
	                case 'angular-line':
	                    sel.append('path').style('fill', 'none');
	                    break;
	            }
	        });
	
	    join.order();
	};
	
	/* Polar subplots juggle with 6 'axis objects' (!), these are:
	 *
	 * - polarLayout.radialaxis (aka radialLayout in this file):
	 * - polarLayout.angularaxis (aka angularLayout in this file):
	 *   used for data -> calcdata conversions (aka d2c) during the calc step
	 *
	 * - this.radialAxis
	 *   extends polarLayout.radialaxis, adds mocked 'domain' and
	 *   few other keys in order to reuse Cartesian doAutoRange and the Axes
	 *   drawing routines.
	 *   used for calcdata -> geometric conversions (aka c2g) during the plot step
	 *   + setGeometry setups ax.c2g for given ax.range
	 *   + setScale setups ax._m,ax._b for given ax.range
	 *
	 * - this.angularAxis
	 *   extends polarLayout.angularaxis, adds mocked 'range' and 'domain' and
	 *   a few other keys in order to reuse the Axes drawing routines.
	 *   used for calcdata -> geometric conversions (aka c2g) during the plot step
	 *   + setGeometry setups ax.c2g given ax.rotation, ax.direction & ax._categories,
	 *                 and mocks ax.range
	 *   + setScale setups ax._m,ax._b with that mocked ax.range
	 *
	 * - this.xaxis
	 * - this.yaxis
	 *   setup so that polar traces can reuse plot methods of Cartesian traces
	 *   which mostly rely on 2pixel methods (e.g ax.c2p)
	 */
	proto.updateLayout = function(fullLayout, polarLayout) {
	    var _this = this;
	    var layers = _this.layers;
	    var gs = fullLayout._size;
	
	    // axis attributes
	    var radialLayout = polarLayout.radialaxis;
	    var angularLayout = polarLayout.angularaxis;
	    // layout domains
	    var xDomain = polarLayout.domain.x;
	    var yDomain = polarLayout.domain.y;
	    // offsets from paper edge to layout domain box
	    _this.xOffset = gs.l + gs.w * xDomain[0];
	    _this.yOffset = gs.t + gs.h * (1 - yDomain[1]);
	    // lengths of the layout domain box
	    var xLength = _this.xLength = gs.w * (xDomain[1] - xDomain[0]);
	    var yLength = _this.yLength = gs.h * (yDomain[1] - yDomain[0]);
	    // sector to plot
	    var sector = polarLayout.sector;
	    _this.sectorInRad = sector.map(deg2rad);
	    var sectorBBox = _this.sectorBBox = computeSectorBBox(sector);
	    var dxSectorBBox = sectorBBox[2] - sectorBBox[0];
	    var dySectorBBox = sectorBBox[3] - sectorBBox[1];
	    // aspect ratios
	    var arDomain = yLength / xLength;
	    var arSector = Math.abs(dySectorBBox / dxSectorBBox);
	    // actual lengths and domains of subplot box
	    var xLength2, yLength2;
	    var xDomain2, yDomain2;
	    var gap;
	    if(arDomain > arSector) {
	        xLength2 = xLength;
	        yLength2 = xLength * arSector;
	        gap = (yLength - yLength2) / gs.h / 2;
	        xDomain2 = [xDomain[0], xDomain[1]];
	        yDomain2 = [yDomain[0] + gap, yDomain[1] - gap];
	    } else {
	        xLength2 = yLength / arSector;
	        yLength2 = yLength;
	        gap = (xLength - xLength2) / gs.w / 2;
	        xDomain2 = [xDomain[0] + gap, xDomain[1] - gap];
	        yDomain2 = [yDomain[0], yDomain[1]];
	    }
	    _this.xLength2 = xLength2;
	    _this.yLength2 = yLength2;
	    _this.xDomain2 = xDomain2;
	    _this.yDomain2 = yDomain2;
	    // actual offsets from paper edge to the subplot box top-left corner
	    var xOffset2 = _this.xOffset2 = gs.l + gs.w * xDomain2[0];
	    var yOffset2 = _this.yOffset2 = gs.t + gs.h * (1 - yDomain2[1]);
	    // circle radius in px
	    var radius = _this.radius = xLength2 / dxSectorBBox;
	    // 'inner' radius in px (when polar.hole is set)
	    var innerRadius = _this.innerRadius = polarLayout.hole * radius;
	    // circle center position in px
	    var cx = _this.cx = xOffset2 - radius * sectorBBox[0];
	    var cy = _this.cy = yOffset2 + radius * sectorBBox[3];
	    // circle center in the coordinate system of plot area
	    var cxx = _this.cxx = cx - xOffset2;
	    var cyy = _this.cyy = cy - yOffset2;
	
	    _this.radialAxis = _this.mockAxis(fullLayout, polarLayout, radialLayout, {
	        // make this an 'x' axis to make positioning (especially rotation) easier
	        _id: 'x',
	        // convert to 'x' axis equivalent
	        side: {
	            counterclockwise: 'top',
	            clockwise: 'bottom'
	        }[radialLayout.side],
	        // spans length 1 radius
	        domain: [innerRadius / gs.w, radius / gs.w]
	    });
	
	    _this.angularAxis = _this.mockAxis(fullLayout, polarLayout, angularLayout, {
	        side: 'right',
	        // to get auto nticks right
	        domain: [0, Math.PI],
	        // don't pass through autorange logic
	        autorange: false
	    });
	
	    _this.doAutoRange(fullLayout, polarLayout);
	    // N.B. this sets _this.vangles
	    _this.updateAngularAxis(fullLayout, polarLayout);
	    // N.B. this sets _this.radialAxisAngle
	    _this.updateRadialAxis(fullLayout, polarLayout);
	    _this.updateRadialAxisTitle(fullLayout, polarLayout);
	
	    _this.xaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
	        _id: 'x',
	        domain: xDomain2
	    });
	
	    _this.yaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
	        _id: 'y',
	        domain: yDomain2
	    });
	
	    var dPath = _this.pathSubplot();
	
	    _this.clipPaths.forTraces.select('path')
	        .attr('d', dPath)
	        .attr('transform', strTranslate(cxx, cyy));
	
	    layers.frontplot
	        .attr('transform', strTranslate(xOffset2, yOffset2))
	        .call(Drawing.setClipUrl, _this._hasClipOnAxisFalse ? null : _this.clipIds.forTraces, _this.gd);
	
	    layers.bg
	        .attr('d', dPath)
	        .attr('transform', strTranslate(cx, cy))
	        .call(Color.fill, polarLayout.bgcolor);
	};
	
	proto.mockAxis = function(fullLayout, polarLayout, axLayout, opts) {
	    var ax = Lib.extendFlat({}, axLayout, opts);
	    setConvertPolar(ax, polarLayout, fullLayout);
	    return ax;
	};
	
	proto.mockCartesianAxis = function(fullLayout, polarLayout, opts) {
	    var _this = this;
	    var axId = opts._id;
	
	    var ax = Lib.extendFlat({type: 'linear'}, opts);
	    setConvertCartesian(ax, fullLayout);
	
	    var bboxIndices = {
	        x: [0, 2],
	        y: [1, 3]
	    };
	
	    ax.setRange = function() {
	        var sectorBBox = _this.sectorBBox;
	        var ind = bboxIndices[axId];
	        var rl = _this.radialAxis._rl;
	        var drl = (rl[1] - rl[0]) / (1 - polarLayout.hole);
	        ax.range = [sectorBBox[ind[0]] * drl, sectorBBox[ind[1]] * drl];
	    };
	
	    ax.isPtWithinRange = axId === 'x' ?
	        function(d) { return _this.isPtInside(d); } :
	        function() { return true; };
	
	    ax.setRange();
	    ax.setScale();
	    return ax;
	};
	
	proto.doAutoRange = function(fullLayout, polarLayout) {
	    var gd = this.gd;
	    var radialAxis = this.radialAxis;
	    var radialLayout = polarLayout.radialaxis;
	
	    radialAxis.setScale();
	    doAutoRange(gd, radialAxis);
	
	    var rng = radialAxis.range;
	    radialLayout.range = rng.slice();
	    radialLayout._input.range = rng.slice();
	
	    radialAxis._rl = [
	        radialAxis.r2l(rng[0], null, 'gregorian'),
	        radialAxis.r2l(rng[1], null, 'gregorian')
	    ];
	};
	
	proto.updateRadialAxis = function(fullLayout, polarLayout) {
	    var _this = this;
	    var gd = _this.gd;
	    var layers = _this.layers;
	    var radius = _this.radius;
	    var innerRadius = _this.innerRadius;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var radialLayout = polarLayout.radialaxis;
	    var a0 = mod(polarLayout.sector[0], 360);
	    var ax = _this.radialAxis;
	    var hasRoomForIt = innerRadius < radius;
	
	    _this.fillViewInitialKey('radialaxis.angle', radialLayout.angle);
	    _this.fillViewInitialKey('radialaxis.range', ax.range.slice());
	
	    ax.setGeometry();
	
	    // rotate auto tick labels by 180 if in quadrant II and III to make them
	    // readable from left-to-right
	    //
	    // TODO try moving deeper in Axes.drawLabels for better results?
	    if(ax.tickangle === 'auto' && (a0 > 90 && a0 <= 270)) {
	        ax.tickangle = 180;
	    }
	
	    // easier to set rotate angle with custom translate function
	    var transFn = function(d) {
	        return 'translate(' + (ax.l2p(d.x) + innerRadius) + ',0)';
	    };
	
	    // set special grid path function
	    var gridPathFn = function(d) {
	        return _this.pathArc(ax.r2p(d.x) + innerRadius);
	    };
	
	    var newTickLayout = strTickLayout(radialLayout);
	    if(_this.radialTickLayout !== newTickLayout) {
	        layers['radial-axis'].selectAll('.xtick').remove();
	        _this.radialTickLayout = newTickLayout;
	    }
	
	    if(hasRoomForIt) {
	        ax.setScale();
	
	        var vals = Axes.calcTicks(ax);
	        var valsClipped = Axes.clipEnds(ax, vals);
	        var tickSign = Axes.getTickSigns(ax)[2];
	
	        Axes.drawTicks(gd, ax, {
	            vals: vals,
	            layer: layers['radial-axis'],
	            path: Axes.makeTickPath(ax, 0, tickSign),
	            transFn: transFn,
	            crisp: false
	        });
	
	        Axes.drawGrid(gd, ax, {
	            vals: valsClipped,
	            layer: layers['radial-grid'],
	            path: gridPathFn,
	            transFn: Lib.noop,
	            crisp: false
	        });
	
	        Axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: layers['radial-axis'],
	            transFn: transFn,
	            labelFns: Axes.makeLabelFns(ax, 0)
	        });
	    }
	
	    // stash 'actual' radial axis angle for drag handlers (in degrees)
	    var angle = _this.radialAxisAngle = _this.vangles ?
	        rad2deg(snapToVertexAngle(deg2rad(radialLayout.angle), _this.vangles)) :
	        radialLayout.angle;
	
	    var tLayer = strTranslate(cx, cy);
	    var tLayer2 = tLayer + strRotate(-angle);
	
	    updateElement(
	        layers['radial-axis'],
	        hasRoomForIt && (radialLayout.showticklabels || radialLayout.ticks),
	        {transform: tLayer2}
	    );
	
	    updateElement(
	        layers['radial-grid'],
	        hasRoomForIt && radialLayout.showgrid,
	        {transform: tLayer}
	    );
	
	    updateElement(
	        layers['radial-line'].select('line'),
	        hasRoomForIt && radialLayout.showline,
	        {
	            x1: innerRadius,
	            y1: 0,
	            x2: radius,
	            y2: 0,
	            transform: tLayer2
	        }
	    )
	    .attr('stroke-width', radialLayout.linewidth)
	    .call(Color.stroke, radialLayout.linecolor);
	};
	
	proto.updateRadialAxisTitle = function(fullLayout, polarLayout, _angle) {
	    var _this = this;
	    var gd = _this.gd;
	    var radius = _this.radius;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var radialLayout = polarLayout.radialaxis;
	    var titleClass = _this.id + 'title';
	
	    var angle = _angle !== undefined ? _angle : _this.radialAxisAngle;
	    var angleRad = deg2rad(angle);
	    var cosa = Math.cos(angleRad);
	    var sina = Math.sin(angleRad);
	
	    var pad = 0;
	
	    // Hint: no need to check if there is in fact a title.text set
	    // because if plot is editable, pad needs to be calculated anyways
	    // to properly show placeholder text when title is empty.
	    if(radialLayout.title) {
	        var h = Drawing.bBox(_this.layers['radial-axis'].node()).height;
	        var ts = radialLayout.title.font.size;
	        pad = radialLayout.side === 'counterclockwise' ?
	            -h - ts * 0.4 :
	            h + ts * 0.8;
	    }
	
	    _this.layers['radial-axis-title'] = Titles.draw(gd, titleClass, {
	        propContainer: radialLayout,
	        propName: _this.id + '.radialaxis.title',
	        placeholder: _(gd, 'Click to enter radial axis title'),
	        attributes: {
	            x: cx + (radius / 2) * cosa + pad * sina,
	            y: cy - (radius / 2) * sina + pad * cosa,
	            'text-anchor': 'middle'
	        },
	        transform: {rotate: -angle}
	    });
	};
	
	proto.updateAngularAxis = function(fullLayout, polarLayout) {
	    var _this = this;
	    var gd = _this.gd;
	    var layers = _this.layers;
	    var radius = _this.radius;
	    var innerRadius = _this.innerRadius;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var angularLayout = polarLayout.angularaxis;
	    var ax = _this.angularAxis;
	
	    _this.fillViewInitialKey('angularaxis.rotation', angularLayout.rotation);
	
	    ax.setGeometry();
	    ax.setScale();
	
	    // 't'ick to 'g'eometric radians is used all over the place here
	    var t2g = function(d) { return ax.t2g(d.x); };
	
	    // run rad2deg on tick0 and ditck for thetaunit: 'radians' axes
	    if(ax.type === 'linear' && ax.thetaunit === 'radians') {
	        ax.tick0 = rad2deg(ax.tick0);
	        ax.dtick = rad2deg(ax.dtick);
	    }
	
	    var _transFn = function(rad) {
	        return strTranslate(cx + radius * Math.cos(rad), cy - radius * Math.sin(rad));
	    };
	
	    var transFn = function(d) {
	        return _transFn(t2g(d));
	    };
	
	    var transFn2 = function(d) {
	        var rad = t2g(d);
	        return _transFn(rad) + strRotate(-rad2deg(rad));
	    };
	
	    var gridPathFn = function(d) {
	        var rad = t2g(d);
	        var cosRad = Math.cos(rad);
	        var sinRad = Math.sin(rad);
	        return 'M' + [cx + innerRadius * cosRad, cy - innerRadius * sinRad] +
	            'L' + [cx + radius * cosRad, cy - radius * sinRad];
	    };
	
	    var out = Axes.makeLabelFns(ax, 0);
	    var labelStandoff = out.labelStandoff;
	    var labelFns = {};
	
	    labelFns.xFn = function(d) {
	        var rad = t2g(d);
	        return Math.cos(rad) * labelStandoff;
	    };
	
	    labelFns.yFn = function(d) {
	        var rad = t2g(d);
	        var ff = Math.sin(rad) > 0 ? 0.2 : 1;
	        return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) +
	            Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
	    };
	
	    labelFns.anchorFn = function(d) {
	        var rad = t2g(d);
	        var cos = Math.cos(rad);
	        return Math.abs(cos) < 0.1 ?
	            'middle' :
	            (cos > 0 ? 'start' : 'end');
	    };
	
	    labelFns.heightFn = function(d, a, h) {
	        var rad = t2g(d);
	        return -0.5 * (1 + Math.sin(rad)) * h;
	    };
	
	    var newTickLayout = strTickLayout(angularLayout);
	    if(_this.angularTickLayout !== newTickLayout) {
	        layers['angular-axis'].selectAll('.' + ax._id + 'tick').remove();
	        _this.angularTickLayout = newTickLayout;
	    }
	
	    var vals = Axes.calcTicks(ax);
	
	    // angle of polygon vertices in geometric radians (null means circles)
	    // TODO what to do when ax.period > ax._categories ??
	    var vangles;
	    if(polarLayout.gridshape === 'linear') {
	        vangles = vals.map(t2g);
	
	        // ax._vals should be always ordered, make them
	        // always turn counterclockwise for convenience here
	        if(Lib.angleDelta(vangles[0], vangles[1]) < 0) {
	            vangles = vangles.slice().reverse();
	        }
	    } else {
	        vangles = null;
	    }
	    _this.vangles = vangles;
	
	    // Use tickval filter for category axes instead of tweaking
	    // the range w.r.t sector, so that sectors that cross 360 can
	    // show all their ticks.
	    if(ax.type === 'category') {
	        vals = vals.filter(function(d) {
	            return Lib.isAngleInsideSector(t2g(d), _this.sectorInRad);
	        });
	    }
	
	    if(ax.visible) {
	        var tickSign = ax.ticks === 'inside' ? -1 : 1;
	        var pad = (ax.linewidth || 1) / 2;
	
	        Axes.drawTicks(gd, ax, {
	            vals: vals,
	            layer: layers['angular-axis'],
	            path: 'M' + (tickSign * pad) + ',0h' + (tickSign * ax.ticklen),
	            transFn: transFn2,
	            crisp: false
	        });
	
	        Axes.drawGrid(gd, ax, {
	            vals: vals,
	            layer: layers['angular-grid'],
	            path: gridPathFn,
	            transFn: Lib.noop,
	            crisp: false
	        });
	
	        Axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: layers['angular-axis'],
	            repositionOnUpdate: true,
	            transFn: transFn,
	            labelFns: labelFns
	        });
	    }
	
	    // TODO maybe two arcs is better here?
	    // maybe split style attributes between inner and outer angular axes?
	
	    updateElement(layers['angular-line'].select('path'), angularLayout.showline, {
	        d: _this.pathSubplot(),
	        transform: strTranslate(cx, cy)
	    })
	    .attr('stroke-width', angularLayout.linewidth)
	    .call(Color.stroke, angularLayout.linecolor);
	};
	
	proto.updateFx = function(fullLayout, polarLayout) {
	    if(!this.gd._context.staticPlot) {
	        this.updateAngularDrag(fullLayout);
	        this.updateRadialDrag(fullLayout, polarLayout, 0);
	        this.updateRadialDrag(fullLayout, polarLayout, 1);
	        this.updateMainDrag(fullLayout);
	    }
	};
	
	proto.updateMainDrag = function(fullLayout) {
	    var _this = this;
	    var gd = _this.gd;
	    var layers = _this.layers;
	    var zoomlayer = fullLayout._zoomlayer;
	    var MINZOOM = constants.MINZOOM;
	    var OFFEDGE = constants.OFFEDGE;
	    var radius = _this.radius;
	    var innerRadius = _this.innerRadius;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var cxx = _this.cxx;
	    var cyy = _this.cyy;
	    var sectorInRad = _this.sectorInRad;
	    var vangles = _this.vangles;
	    var radialAxis = _this.radialAxis;
	    var clampTiny = helpers.clampTiny;
	    var findXYatLength = helpers.findXYatLength;
	    var findEnclosingVertexAngles = helpers.findEnclosingVertexAngles;
	    var chw = constants.cornerHalfWidth;
	    var chl = constants.cornerLen / 2;
	
	    var mainDrag = dragBox.makeDragger(layers, 'path', 'maindrag', 'crosshair');
	
	    d3.select(mainDrag)
	        .attr('d', _this.pathSubplot())
	        .attr('transform', strTranslate(cx, cy));
	
	    var dragOpts = {
	        element: mainDrag,
	        gd: gd,
	        subplot: _this.id,
	        plotinfo: {
	            id: _this.id,
	            xaxis: _this.xaxis,
	            yaxis: _this.yaxis
	        },
	        xaxes: [_this.xaxis],
	        yaxes: [_this.yaxis]
	    };
	
	    // mouse px position at drag start (0), move (1)
	    var x0, y0;
	    // radial distance from circle center at drag start (0), move (1)
	    var r0, r1;
	    // zoombox persistent quantities
	    var path0, dimmed, lum;
	    // zoombox, corners elements
	    var zb, corners;
	
	    function norm(x, y) {
	        return Math.sqrt(x * x + y * y);
	    }
	
	    function xy2r(x, y) {
	        return norm(x - cxx, y - cyy);
	    }
	
	    function xy2a(x, y) {
	        return Math.atan2(cyy - y, x - cxx);
	    }
	
	    function ra2xy(r, a) {
	        return [r * Math.cos(a), r * Math.sin(-a)];
	    }
	
	    function pathCorner(r, a) {
	        if(r === 0) return _this.pathSector(2 * chw);
	
	        var da = chl / r;
	        var am = a - da;
	        var ap = a + da;
	        var rb = Math.max(0, Math.min(r, radius));
	        var rm = rb - chw;
	        var rp = rb + chw;
	
	        return 'M' + ra2xy(rm, am) +
	            'A' + [rm, rm] + ' 0,0,0 ' + ra2xy(rm, ap) +
	            'L' + ra2xy(rp, ap) +
	            'A' + [rp, rp] + ' 0,0,1 ' + ra2xy(rp, am) +
	            'Z';
	    }
	
	    // (x,y) is the pt at middle of the va0 <-> va1 edge
	    //
	    // ... we could eventually add another mode for cursor
	    // angles 'close to' enough to a particular vertex.
	    function pathCornerForPolygons(r, va0, va1) {
	        if(r === 0) return _this.pathSector(2 * chw);
	
	        var xy0 = ra2xy(r, va0);
	        var xy1 = ra2xy(r, va1);
	        var x = clampTiny((xy0[0] + xy1[0]) / 2);
	        var y = clampTiny((xy0[1] + xy1[1]) / 2);
	        var innerPts, outerPts;
	
	        if(x && y) {
	            var m = y / x;
	            var mperp = -1 / m;
	            var midPts = findXYatLength(chw, m, x, y);
	            innerPts = findXYatLength(chl, mperp, midPts[0][0], midPts[0][1]);
	            outerPts = findXYatLength(chl, mperp, midPts[1][0], midPts[1][1]);
	        } else {
	            var dx, dy;
	            if(y) {
	                // horizontal handles
	                dx = chl;
	                dy = chw;
	            } else {
	                // vertical handles
	                dx = chw;
	                dy = chl;
	            }
	            innerPts = [[x - dx, y - dy], [x + dx, y - dy]];
	            outerPts = [[x - dx, y + dy], [x + dx, y + dy]];
	        }
	
	        return 'M' + innerPts.join('L') +
	            'L' + outerPts.reverse().join('L') + 'Z';
	    }
	
	    function zoomPrep() {
	        r0 = null;
	        r1 = null;
	        path0 = _this.pathSubplot();
	        dimmed = false;
	
	        var polarLayoutNow = gd._fullLayout[_this.id];
	        lum = tinycolor(polarLayoutNow.bgcolor).getLuminance();
	
	        zb = dragBox.makeZoombox(zoomlayer, lum, cx, cy, path0);
	        zb.attr('fill-rule', 'evenodd');
	        corners = dragBox.makeCorners(zoomlayer, cx, cy);
	        clearSelect(gd);
	    }
	
	    // N.B. this sets scoped 'r0' and 'r1'
	    // return true if 'valid' zoom distance, false otherwise
	    function clampAndSetR0R1(rr0, rr1) {
	        rr1 = Math.max(Math.min(rr1, radius), innerRadius);
	
	        // starting or ending drag near center (outer edge),
	        // clamps radial distance at origin (at r=radius)
	        if(rr0 < OFFEDGE) rr0 = 0;
	        else if((radius - rr0) < OFFEDGE) rr0 = radius;
	        else if(rr1 < OFFEDGE) rr1 = 0;
	        else if((radius - rr1) < OFFEDGE) rr1 = radius;
	
	        // make sure r0 < r1,
	        // to get correct fill pattern in path1 below
	        if(Math.abs(rr1 - rr0) > MINZOOM) {
	            if(rr0 < rr1) {
	                r0 = rr0;
	                r1 = rr1;
	            } else {
	                r0 = rr1;
	                r1 = rr0;
	            }
	            return true;
	        } else {
	            r0 = null;
	            r1 = null;
	            return false;
	        }
	    }
	
	    function applyZoomMove(path1, cpath) {
	        path1 = path1 || path0;
	        cpath = cpath || 'M0,0Z';
	
	        zb.attr('d', path1);
	        corners.attr('d', cpath);
	        dragBox.transitionZoombox(zb, corners, dimmed, lum);
	        dimmed = true;
	
	        var updateObj = {};
	        computeZoomUpdates(updateObj);
	        gd.emit('plotly_relayouting', updateObj);
	    }
	
	    function zoomMove(dx, dy) {
	        var x1 = x0 + dx;
	        var y1 = y0 + dy;
	        var rr0 = xy2r(x0, y0);
	        var rr1 = Math.min(xy2r(x1, y1), radius);
	        var a0 = xy2a(x0, y0);
	        var path1;
	        var cpath;
	
	        if(clampAndSetR0R1(rr0, rr1)) {
	            path1 = path0 + _this.pathSector(r1);
	            if(r0) path1 += _this.pathSector(r0);
	            // keep 'starting' angle
	            cpath = pathCorner(r0, a0) + pathCorner(r1, a0);
	        }
	        applyZoomMove(path1, cpath);
	    }
	
	    function findPolygonRadius(x, y, va0, va1) {
	        var xy = helpers.findIntersectionXY(va0, va1, va0, [x - cxx, cyy - y]);
	        return norm(xy[0], xy[1]);
	    }
	
	    function zoomMoveForPolygons(dx, dy) {
	        var x1 = x0 + dx;
	        var y1 = y0 + dy;
	        var a0 = xy2a(x0, y0);
	        var a1 = xy2a(x1, y1);
	        var vangles0 = findEnclosingVertexAngles(a0, vangles);
	        var vangles1 = findEnclosingVertexAngles(a1, vangles);
	        var rr0 = findPolygonRadius(x0, y0, vangles0[0], vangles0[1]);
	        var rr1 = Math.min(findPolygonRadius(x1, y1, vangles1[0], vangles1[1]), radius);
	        var path1;
	        var cpath;
	
	        if(clampAndSetR0R1(rr0, rr1)) {
	            path1 = path0 + _this.pathSector(r1);
	            if(r0) path1 += _this.pathSector(r0);
	            // keep 'starting' angle here too
	            cpath = [
	                pathCornerForPolygons(r0, vangles0[0], vangles0[1]),
	                pathCornerForPolygons(r1, vangles0[0], vangles0[1])
	            ].join(' ');
	        }
	        applyZoomMove(path1, cpath);
	    }
	
	    function zoomDone() {
	        dragBox.removeZoombox(gd);
	
	        if(r0 === null || r1 === null) return;
	        var updateObj = {};
	        computeZoomUpdates(updateObj);
	
	        dragBox.showDoubleClickNotifier(gd);
	
	        Registry.call('_guiRelayout', gd, updateObj);
	    }
	
	    function computeZoomUpdates(update) {
	        var rl = radialAxis._rl;
	        var m = (rl[1] - rl[0]) / (1 - innerRadius / radius) / radius;
	        var newRng = [
	            rl[0] + (r0 - innerRadius) * m,
	            rl[0] + (r1 - innerRadius) * m
	        ];
	        update[_this.id + '.radialaxis.range'] = newRng;
	    }
	
	    function zoomClick(numClicks, evt) {
	        var clickMode = gd._fullLayout.clickmode;
	
	        dragBox.removeZoombox(gd);
	
	        // TODO double once vs twice logic (autorange vs fixed range)
	        if(numClicks === 2) {
	            var updateObj = {};
	            for(var k in _this.viewInitial) {
	                updateObj[_this.id + '.' + k] = _this.viewInitial[k];
	            }
	
	            gd.emit('plotly_doubleclick', null);
	            Registry.call('_guiRelayout', gd, updateObj);
	        }
	
	        if(clickMode.indexOf('select') > -1 && numClicks === 1) {
	            selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOpts);
	        }
	
	        if(clickMode.indexOf('event') > -1) {
	            Fx.click(gd, evt, _this.id);
	        }
	    }
	
	    dragOpts.prepFn = function(evt, startX, startY) {
	        var dragModeNow = gd._fullLayout.dragmode;
	
	        var bbox = mainDrag.getBoundingClientRect();
	        x0 = startX - bbox.left;
	        y0 = startY - bbox.top;
	
	        // need to offset x/y as bbox center does not
	        // match origin for asymmetric polygons
	        if(vangles) {
	            var offset = helpers.findPolygonOffset(radius, sectorInRad[0], sectorInRad[1], vangles);
	            x0 += cxx + offset[0];
	            y0 += cyy + offset[1];
	        }
	
	        switch(dragModeNow) {
	            case 'zoom':
	                if(vangles) {
	                    dragOpts.moveFn = zoomMoveForPolygons;
	                } else {
	                    dragOpts.moveFn = zoomMove;
	                }
	                dragOpts.clickFn = zoomClick;
	                dragOpts.doneFn = zoomDone;
	                zoomPrep(evt, startX, startY);
	                break;
	            case 'select':
	            case 'lasso':
	                prepSelect(evt, startX, startY, dragOpts, dragModeNow);
	                break;
	        }
	    };
	
	    mainDrag.onmousemove = function(evt) {
	        Fx.hover(gd, evt, _this.id);
	        gd._fullLayout._lasthover = mainDrag;
	        gd._fullLayout._hoversubplot = _this.id;
	    };
	
	    mainDrag.onmouseout = function(evt) {
	        if(gd._dragging) return;
	        dragElement.unhover(gd, evt);
	    };
	
	    dragElement.init(dragOpts);
	};
	
	proto.updateRadialDrag = function(fullLayout, polarLayout, rngIndex) {
	    var _this = this;
	    var gd = _this.gd;
	    var layers = _this.layers;
	    var radius = _this.radius;
	    var innerRadius = _this.innerRadius;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var radialAxis = _this.radialAxis;
	    var bl = constants.radialDragBoxSize;
	    var bl2 = bl / 2;
	
	    if(!radialAxis.visible) return;
	
	    var angle0 = deg2rad(_this.radialAxisAngle);
	    var rl = radialAxis._rl;
	    var rl0 = rl[0];
	    var rl1 = rl[1];
	    var rbase = rl[rngIndex];
	    var m = 0.75 * (rl[1] - rl[0]) / (1 - polarLayout.hole) / radius;
	
	    var tx, ty, className;
	    if(rngIndex) {
	        tx = cx + (radius + bl2) * Math.cos(angle0);
	        ty = cy - (radius + bl2) * Math.sin(angle0);
	        className = 'radialdrag';
	    } else {
	        // the 'inner' box can get called:
	        // - when polar.hole>0
	        // - when polar.sector isn't a full circle
	        // otherwise it is hidden behind the main drag.
	        tx = cx + (innerRadius - bl2) * Math.cos(angle0);
	        ty = cy - (innerRadius - bl2) * Math.sin(angle0);
	        className = 'radialdrag-inner';
	    }
	
	    var radialDrag = dragBox.makeRectDragger(layers, className, 'crosshair', -bl2, -bl2, bl, bl);
	    var dragOpts = {element: radialDrag, gd: gd};
	
	    updateElement(d3.select(radialDrag), radialAxis.visible && innerRadius < radius, {
	        transform: strTranslate(tx, ty)
	    });
	
	    // move function (either rotate or re-range flavor)
	    var moveFn2;
	    // rotate angle on done
	    var angle1;
	    // re-range range[1] (or range[0]) on done
	    var rprime;
	
	    function moveFn(dx, dy) {
	        if(moveFn2) {
	            moveFn2(dx, dy);
	        } else {
	            var dvec = [dx, -dy];
	            var rvec = [Math.cos(angle0), Math.sin(angle0)];
	            var comp = Math.abs(Lib.dot(dvec, rvec) / Math.sqrt(Lib.dot(dvec, dvec)));
	
	            // mostly perpendicular motions rotate,
	            // mostly parallel motions re-range
	            if(!isNaN(comp)) {
	                moveFn2 = comp < 0.5 ? rotateMove : rerangeMove;
	            }
	        }
	
	        var update = {};
	        computeRadialAxisUpdates(update);
	        gd.emit('plotly_relayouting', update);
	    }
	
	    function computeRadialAxisUpdates(update) {
	        if(angle1 !== null) {
	            update[_this.id + '.radialaxis.angle'] = angle1;
	        } else if(rprime !== null) {
	            update[_this.id + '.radialaxis.range[' + rngIndex + ']'] = rprime;
	        }
	    }
	
	    function doneFn() {
	        if(angle1 !== null) {
	            Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.angle', angle1);
	        } else if(rprime !== null) {
	            Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.range[' + rngIndex + ']', rprime);
	        }
	    }
	
	    function rotateMove(dx, dy) {
	        // disable for inner drag boxes
	        if(rngIndex === 0) return;
	
	        var x1 = tx + dx;
	        var y1 = ty + dy;
	
	        angle1 = Math.atan2(cy - y1, x1 - cx);
	        if(_this.vangles) angle1 = snapToVertexAngle(angle1, _this.vangles);
	        angle1 = rad2deg(angle1);
	
	        var transform = strTranslate(cx, cy) + strRotate(-angle1);
	        layers['radial-axis'].attr('transform', transform);
	        layers['radial-line'].select('line').attr('transform', transform);
	
	        var fullLayoutNow = _this.gd._fullLayout;
	        var polarLayoutNow = fullLayoutNow[_this.id];
	        _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, angle1);
	    }
	
	    function rerangeMove(dx, dy) {
	        // project (dx, dy) unto unit radial axis vector
	        var dr = Lib.dot([dx, -dy], [Math.cos(angle0), Math.sin(angle0)]);
	        rprime = rbase - m * dr;
	
	        // make sure rprime does not change the range[0] -> range[1] sign
	        if((m > 0) !== (rngIndex ? rprime > rl0 : rprime < rl1)) {
	            rprime = null;
	            return;
	        }
	
	        var fullLayoutNow = gd._fullLayout;
	        var polarLayoutNow = fullLayoutNow[_this.id];
	
	        // update radial range -> update c2g -> update _m,_b
	        radialAxis.range[rngIndex] = rprime;
	        radialAxis._rl[rngIndex] = rprime;
	        _this.updateRadialAxis(fullLayoutNow, polarLayoutNow);
	
	        _this.xaxis.setRange();
	        _this.xaxis.setScale();
	        _this.yaxis.setRange();
	        _this.yaxis.setScale();
	
	        var hasRegl = false;
	
	        for(var traceType in _this.traceHash) {
	            var moduleCalcData = _this.traceHash[traceType];
	            var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
	            var _module = moduleCalcData[0][0].trace._module;
	            _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
	            if(Registry.traceIs(traceType, 'gl') && moduleCalcDataVisible.length) hasRegl = true;
	        }
	
	        if(hasRegl) {
	            clearGlCanvases(gd);
	            redrawReglTraces(gd);
	        }
	    }
	
	    dragOpts.prepFn = function() {
	        moveFn2 = null;
	        angle1 = null;
	        rprime = null;
	
	        dragOpts.moveFn = moveFn;
	        dragOpts.doneFn = doneFn;
	
	        clearSelect(gd);
	    };
	
	    dragOpts.clampFn = function(dx, dy) {
	        if(Math.sqrt(dx * dx + dy * dy) < constants.MINDRAG) {
	            dx = 0;
	            dy = 0;
	        }
	        return [dx, dy];
	    };
	
	    dragElement.init(dragOpts);
	};
	
	proto.updateAngularDrag = function(fullLayout) {
	    var _this = this;
	    var gd = _this.gd;
	    var layers = _this.layers;
	    var radius = _this.radius;
	    var angularAxis = _this.angularAxis;
	    var cx = _this.cx;
	    var cy = _this.cy;
	    var cxx = _this.cxx;
	    var cyy = _this.cyy;
	    var dbs = constants.angularDragBoxSize;
	
	    var angularDrag = dragBox.makeDragger(layers, 'path', 'angulardrag', 'move');
	    var dragOpts = {element: angularDrag, gd: gd};
	
	    d3.select(angularDrag)
	        .attr('d', _this.pathAnnulus(radius, radius + dbs))
	        .attr('transform', strTranslate(cx, cy))
	        .call(setCursor, 'move');
	
	    function xy2a(x, y) {
	        return Math.atan2(cyy + dbs - y, x - cxx - dbs);
	    }
	
	    // scatter trace, points and textpoints selections
	    var scatterTraces = layers.frontplot.select('.scatterlayer').selectAll('.trace');
	    var scatterPoints = scatterTraces.selectAll('.point');
	    var scatterTextPoints = scatterTraces.selectAll('.textpoint');
	
	    // mouse px position at drag start (0), move (1)
	    var x0, y0;
	    // angular axis angle rotation at drag start (0), move (1)
	    var rot0, rot1;
	    // induced radial axis rotation (only used on polygon grids)
	    var rrot1;
	    // angle about circle center at drag start
	    var a0;
	
	    function moveFn(dx, dy) {
	        var fullLayoutNow = _this.gd._fullLayout;
	        var polarLayoutNow = fullLayoutNow[_this.id];
	
	        var x1 = x0 + dx;
	        var y1 = y0 + dy;
	        var a1 = xy2a(x1, y1);
	        var da = rad2deg(a1 - a0);
	        rot1 = rot0 + da;
	
	        layers.frontplot.attr('transform',
	            strTranslate(_this.xOffset2, _this.yOffset2) + strRotate([-da, cxx, cyy])
	        );
	
	        if(_this.vangles) {
	            rrot1 = _this.radialAxisAngle + da;
	
	            var trans = strTranslate(cx, cy) + strRotate(-da);
	            var trans2 = strTranslate(cx, cy) + strRotate(-rrot1);
	
	            layers.bg.attr('transform', trans);
	            layers['radial-grid'].attr('transform', trans);
	            layers['radial-axis'].attr('transform', trans2);
	            layers['radial-line'].select('line').attr('transform', trans2);
	            _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, rrot1);
	        } else {
	            _this.clipPaths.forTraces.select('path').attr('transform',
	                strTranslate(cxx, cyy) + strRotate(da)
	            );
	        }
	
	        // 'un-rotate' marker and text points
	        scatterPoints.each(function() {
	            var sel = d3.select(this);
	            var xy = Drawing.getTranslate(sel);
	            sel.attr('transform', strTranslate(xy.x, xy.y) + strRotate([da]));
	        });
	        scatterTextPoints.each(function() {
	            var sel = d3.select(this);
	            var tx = sel.select('text');
	            var xy = Drawing.getTranslate(sel);
	            // N.B rotate -> translate ordering matters
	            sel.attr('transform', strRotate([da, tx.attr('x'), tx.attr('y')]) + strTranslate(xy.x, xy.y));
	        });
	
	        // update rotation -> range -> _m,_b
	        angularAxis.rotation = Lib.modHalf(rot1, 360);
	        _this.updateAngularAxis(fullLayoutNow, polarLayoutNow);
	
	        if(_this._hasClipOnAxisFalse && !Lib.isFullCircle(_this.sectorInRad)) {
	            scatterTraces.call(Drawing.hideOutsideRangePoints, _this);
	        }
	
	        var hasRegl = false;
	
	        for(var traceType in _this.traceHash) {
	            if(Registry.traceIs(traceType, 'gl')) {
	                var moduleCalcData = _this.traceHash[traceType];
	                var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
	                var _module = moduleCalcData[0][0].trace._module;
	                _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
	                if(moduleCalcDataVisible.length) hasRegl = true;
	            }
	        }
	
	        if(hasRegl) {
	            clearGlCanvases(gd);
	            redrawReglTraces(gd);
	        }
	
	        var update = {};
	        computeRotationUpdates(update);
	        gd.emit('plotly_relayouting', update);
	    }
	
	    function computeRotationUpdates(updateObj) {
	        updateObj[_this.id + '.angularaxis.rotation'] = rot1;
	
	        if(_this.vangles) {
	            updateObj[_this.id + '.radialaxis.angle'] = rrot1;
	        }
	    }
	
	    function doneFn() {
	        scatterTextPoints.select('text').attr('transform', null);
	
	        var updateObj = {};
	        computeRotationUpdates(updateObj);
	        Registry.call('_guiRelayout', gd, updateObj);
	    }
	
	    dragOpts.prepFn = function(evt, startX, startY) {
	        var polarLayoutNow = fullLayout[_this.id];
	        rot0 = polarLayoutNow.angularaxis.rotation;
	
	        var bbox = angularDrag.getBoundingClientRect();
	        x0 = startX - bbox.left;
	        y0 = startY - bbox.top;
	        a0 = xy2a(x0, y0);
	
	        dragOpts.moveFn = moveFn;
	        dragOpts.doneFn = doneFn;
	
	        clearSelect(gd);
	    };
	
	    // I don't what we should do in this case, skip we now
	    if(_this.vangles && !Lib.isFullCircle(_this.sectorInRad)) {
	        dragOpts.prepFn = Lib.noop;
	        setCursor(d3.select(angularDrag), null);
	    }
	
	    dragElement.init(dragOpts);
	};
	
	proto.isPtInside = function(d) {
	    var sectorInRad = this.sectorInRad;
	    var vangles = this.vangles;
	    var thetag = this.angularAxis.c2g(d.theta);
	    var radialAxis = this.radialAxis;
	    var r = radialAxis.c2l(d.r);
	    var rl = radialAxis._rl;
	
	    var fn = vangles ? helpers.isPtInsidePolygon : Lib.isPtInsideSector;
	    return fn(r, thetag, rl, sectorInRad, vangles);
	};
	
	proto.pathArc = function(r) {
	    var sectorInRad = this.sectorInRad;
	    var vangles = this.vangles;
	    var fn = vangles ? helpers.pathPolygon : Lib.pathArc;
	    return fn(r, sectorInRad[0], sectorInRad[1], vangles);
	};
	
	proto.pathSector = function(r) {
	    var sectorInRad = this.sectorInRad;
	    var vangles = this.vangles;
	    var fn = vangles ? helpers.pathPolygon : Lib.pathSector;
	    return fn(r, sectorInRad[0], sectorInRad[1], vangles);
	};
	
	proto.pathAnnulus = function(r0, r1) {
	    var sectorInRad = this.sectorInRad;
	    var vangles = this.vangles;
	    var fn = vangles ? helpers.pathPolygonAnnulus : Lib.pathAnnulus;
	    return fn(r0, r1, sectorInRad[0], sectorInRad[1], vangles);
	};
	
	proto.pathSubplot = function() {
	    var r0 = this.innerRadius;
	    var r1 = this.radius;
	    return r0 ? this.pathAnnulus(r0, r1) : this.pathSector(r1);
	};
	
	proto.fillViewInitialKey = function(key, val) {
	    if(!(key in this.viewInitial)) {
	        this.viewInitial[key] = val;
	    }
	};
	
	function strTickLayout(axLayout) {
	    var out = axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
	    if('side' in axLayout) out += axLayout.side;
	    return out;
	}
	
	// Finds the bounding box of a given circle sector,
	// inspired by https://math.stackexchange.com/q/1852703
	//
	// assumes:
	// - sector[0] < sector[1]
	// - counterclockwise rotation
	function computeSectorBBox(sector) {
	    var s0 = sector[0];
	    var s1 = sector[1];
	    var arc = s1 - s0;
	    var a0 = mod(s0, 360);
	    var a1 = a0 + arc;
	
	    var ax0 = Math.cos(deg2rad(a0));
	    var ay0 = Math.sin(deg2rad(a0));
	    var ax1 = Math.cos(deg2rad(a1));
	    var ay1 = Math.sin(deg2rad(a1));
	
	    var x0, y0, x1, y1;
	
	    if((a0 <= 90 && a1 >= 90) || (a0 > 90 && a1 >= 450)) {
	        y1 = 1;
	    } else if(ay0 <= 0 && ay1 <= 0) {
	        y1 = 0;
	    } else {
	        y1 = Math.max(ay0, ay1);
	    }
	
	    if((a0 <= 180 && a1 >= 180) || (a0 > 180 && a1 >= 540)) {
	        x0 = -1;
	    } else if(ax0 >= 0 && ax1 >= 0) {
	        x0 = 0;
	    } else {
	        x0 = Math.min(ax0, ax1);
	    }
	
	    if((a0 <= 270 && a1 >= 270) || (a0 > 270 && a1 >= 630)) {
	        y0 = -1;
	    } else if(ay0 >= 0 && ay1 >= 0) {
	        y0 = 0;
	    } else {
	        y0 = Math.min(ay0, ay1);
	    }
	
	    if(a1 >= 360) {
	        x1 = 1;
	    } else if(ax0 <= 0 && ax1 <= 0) {
	        x1 = 0;
	    } else {
	        x1 = Math.max(ax0, ax1);
	    }
	
	    return [x0, y0, x1, y1];
	}
	
	function snapToVertexAngle(a, vangles) {
	    var fn = function(v) { return Lib.angleDist(a, v); };
	    var ind = Lib.findIndexOfMin(vangles, fn);
	    return vangles[ind];
	}
	
	function updateElement(sel, showAttr, attrs) {
	    if(showAttr) {
	        sel.attr('display', null);
	        sel.attr(attrs);
	    } else if(sel) {
	        sel.attr('display', 'none');
	    }
	    return sel;
	}
	
	function strTranslate(x, y) {
	    return 'translate(' + x + ',' + y + ')';
	}
	
	function strRotate(angle) {
	    return 'rotate(' + angle + ')';
	}
	
	},{"../../components/color":591,"../../components/dragelement":609,"../../components/drawing":612,"../../components/fx":629,"../../components/titles":678,"../../constants/alignment":685,"../../lib":716,"../../lib/clear_gl_canvases":701,"../../lib/setcursor":736,"../../plot_api/subroutines":755,"../../plots/cartesian/axes":764,"../../registry":845,"../cartesian/autorange":763,"../cartesian/dragbox":772,"../cartesian/select":781,"../cartesian/set_convert":782,"../plots":825,"./constants":826,"./helpers":827,"./set_convert":838,"d3":164,"tinycolor2":535}],838:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var setConvertCartesian = _dereq_('../cartesian/set_convert');
	
	var deg2rad = Lib.deg2rad;
	var rad2deg = Lib.rad2deg;
	
	/**
	 * setConvert for polar axes!
	 *
	 * @param {object} ax
	 *   axis in question (works for both radial and angular axes)
	 * @param {object} polarLayout
	 *   full polar layout of the subplot associated with 'ax'
	 * @param {object} fullLayout
	 *   full layout
	 *
	 * Here, reuse some of the Cartesian setConvert logic,
	 * but we must extend some of it, as both radial and angular axes
	 * don't have domains and angular axes don't have _true_ ranges.
	 *
	 * Moreover, we introduce two new coordinate systems:
	 * - 'g' for geometric coordinates and
	 * - 't' for angular ticks
	 *
	 * Radial axis coordinate systems:
	 * - d, c and l: same as for cartesian axes
	 * - g: like calcdata but translated about `radialaxis.range[0]` & `polar.hole`
	 *
	 * Angular axis coordinate systems:
	 * - d: data, in whatever form it's provided
	 * - c: calcdata, turned into radians (for linear axes)
	 *      or category indices (category axes)
	 * - t: tick calcdata, just like 'c' but in degrees for linear axes
	 * - g: geometric calcdata, radians coordinates that take into account
	 *      axis rotation and direction
	 *
	 * Then, 'g'eometric data is ready to be converted to (x,y).
	 */
	module.exports = function setConvert(ax, polarLayout, fullLayout) {
	    setConvertCartesian(ax, fullLayout);
	
	    switch(ax._id) {
	        case 'x':
	        case 'radialaxis':
	            setConvertRadial(ax, polarLayout);
	            break;
	        case 'angularaxis':
	            setConvertAngular(ax, polarLayout);
	            break;
	    }
	};
	
	function setConvertRadial(ax, polarLayout) {
	    var subplot = polarLayout._subplot;
	
	    ax.setGeometry = function() {
	        var rl0 = ax._rl[0];
	        var rl1 = ax._rl[1];
	
	        var b = subplot.innerRadius;
	        var m = (subplot.radius - b) / (rl1 - rl0);
	        var b2 = b / m;
	
	        var rFilter = rl0 > rl1 ?
	            function(v) { return v <= 0; } :
	            function(v) { return v >= 0; };
	
	        ax.c2g = function(v) {
	            var r = ax.c2l(v) - rl0;
	            return (rFilter(r) ? r : 0) + b2;
	        };
	
	        ax.g2c = function(v) {
	            return ax.l2c(v + rl0 - b2);
	        };
	
	        ax.g2p = function(v) { return v * m; };
	        ax.c2p = function(v) { return ax.g2p(ax.c2g(v)); };
	    };
	}
	
	function toRadians(v, unit) {
	    return unit === 'degrees' ? deg2rad(v) : v;
	}
	
	function fromRadians(v, unit) {
	    return unit === 'degrees' ? rad2deg(v) : v;
	}
	
	function setConvertAngular(ax, polarLayout) {
	    var axType = ax.type;
	
	    if(axType === 'linear') {
	        var _d2c = ax.d2c;
	        var _c2d = ax.c2d;
	
	        ax.d2c = function(v, unit) { return toRadians(_d2c(v), unit); };
	        ax.c2d = function(v, unit) { return _c2d(fromRadians(v, unit)); };
	    }
	
	    // override makeCalcdata to handle thetaunit and special theta0/dtheta logic
	    ax.makeCalcdata = function(trace, coord) {
	        var arrayIn = trace[coord];
	        var len = trace._length;
	        var arrayOut, i;
	
	        var _d2c = function(v) { return ax.d2c(v, trace.thetaunit); };
	
	        if(arrayIn) {
	            if(Lib.isTypedArray(arrayIn) && axType === 'linear') {
	                if(len === arrayIn.length) {
	                    return arrayIn;
	                } else if(arrayIn.subarray) {
	                    return arrayIn.subarray(0, len);
	                }
	            }
	
	            arrayOut = new Array(len);
	            for(i = 0; i < len; i++) {
	                arrayOut[i] = _d2c(arrayIn[i]);
	            }
	        } else {
	            var coord0 = coord + '0';
	            var dcoord = 'd' + coord;
	            var v0 = (coord0 in trace) ? _d2c(trace[coord0]) : 0;
	            var dv = (trace[dcoord]) ? _d2c(trace[dcoord]) : (ax.period || 2 * Math.PI) / len;
	
	            arrayOut = new Array(len);
	            for(i = 0; i < len; i++) {
	                arrayOut[i] = v0 + i * dv;
	            }
	        }
	
	        return arrayOut;
	    };
	
	    // N.B. we mock the axis 'range' here
	    ax.setGeometry = function() {
	        var sector = polarLayout.sector;
	        var sectorInRad = sector.map(deg2rad);
	        var dir = {clockwise: -1, counterclockwise: 1}[ax.direction];
	        var rot = deg2rad(ax.rotation);
	
	        var rad2g = function(v) { return dir * v + rot; };
	        var g2rad = function(v) { return (v - rot) / dir; };
	
	        var rad2c, c2rad;
	        var rad2t, t2rad;
	
	        switch(axType) {
	            case 'linear':
	                c2rad = rad2c = Lib.identity;
	                t2rad = deg2rad;
	                rad2t = rad2deg;
	
	                // Set the angular range in degrees to make auto-tick computation cleaner,
	                // changing rotation/direction should not affect the angular tick value.
	                ax.range = Lib.isFullCircle(sectorInRad) ?
	                    [sector[0], sector[0] + 360] :
	                    sectorInRad.map(g2rad).map(rad2deg);
	                break;
	
	            case 'category':
	                var catLen = ax._categories.length;
	                var _period = ax.period ? Math.max(ax.period, catLen) : catLen;
	
	                // fallback in case all categories have been filtered out
	                if(_period === 0) _period = 1;
	
	                c2rad = t2rad = function(v) { return v * 2 * Math.PI / _period; };
	                rad2c = rad2t = function(v) { return v * _period / Math.PI / 2; };
	
	                ax.range = [0, _period];
	                break;
	        }
	
	        ax.c2g = function(v) { return rad2g(c2rad(v)); };
	        ax.g2c = function(v) { return rad2c(g2rad(v)); };
	
	        ax.t2g = function(v) { return rad2g(t2rad(v)); };
	        ax.g2t = function(v) { return rad2t(g2rad(v)); };
	    };
	}
	
	},{"../../lib":716,"../cartesian/set_convert":782}],839:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var Template = _dereq_('../plot_api/plot_template');
	var handleDomainDefaults = _dereq_('./domain').defaults;
	
	
	/**
	 * Find and supply defaults to all subplots of a given type
	 * This handles subplots that are contained within one container - so
	 * gl3d, geo, ternary... but not 2d axes which have separate x and y axes
	 * finds subplots, coerces their `domain` attributes, then calls the
	 * given handleDefaults function to fill in everything else.
	 *
	 * layoutIn: the complete user-supplied input layout
	 * layoutOut: the complete finished layout
	 * fullData: the finished data array, used only to find subplots
	 * opts: {
	 *  type: subplot type string
	 *  attributes: subplot attributes object
	 *  partition: 'x' or 'y', which direction to divide domain space by default
	 *      (default 'x', ie side-by-side subplots)
	 *      TODO: this option is only here because 3D and geo made opposite
	 *      choices in this regard previously and I didn't want to change it.
	 *      Instead we should do:
	 *      - something consistent
	 *      - something more square (4 cuts 2x2, 5/6 cuts 2x3, etc.)
	 *      - something that includes all subplot types in one arrangement,
	 *        now that we can have them together!
	 *  handleDefaults: function of (subplotLayoutIn, subplotLayoutOut, coerce, opts)
	 *      this opts object is passed through to handleDefaults, so attach any
	 *      additional items needed by this function here as well
	 * }
	 */
	module.exports = function handleSubplotDefaults(layoutIn, layoutOut, fullData, opts) {
	    var subplotType = opts.type;
	    var subplotAttributes = opts.attributes;
	    var handleDefaults = opts.handleDefaults;
	    var partition = opts.partition || 'x';
	
	    var ids = layoutOut._subplots[subplotType];
	    var idsLength = ids.length;
	
	    var baseId = idsLength && ids[0].replace(/\d+$/, '');
	
	    var subplotLayoutIn, subplotLayoutOut;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(subplotLayoutIn, subplotLayoutOut, subplotAttributes, attr, dflt);
	    }
	
	    for(var i = 0; i < idsLength; i++) {
	        var id = ids[i];
	
	        // ternary traces get a layout ternary for free!
	        if(layoutIn[id]) subplotLayoutIn = layoutIn[id];
	        else subplotLayoutIn = layoutIn[id] = {};
	
	        subplotLayoutOut = Template.newContainer(layoutOut, id, baseId);
	
	        // All subplot containers get a `uirevision` inheriting from the base.
	        // Currently all subplots containers have some user interaction
	        // attributes, but if we ever add one that doesn't, we would need an
	        // option to skip this step.
	        coerce('uirevision', layoutOut.uirevision);
	
	        var dfltDomains = {};
	        dfltDomains[partition] = [i / idsLength, (i + 1) / idsLength];
	        handleDomainDefaults(subplotLayoutOut, layoutOut, coerce, dfltDomains);
	
	        opts.id = id;
	        handleDefaults(subplotLayoutIn, subplotLayoutOut, coerce, opts);
	    }
	};
	
	},{"../lib":716,"../plot_api/plot_template":754,"./domain":789}],840:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var FORMAT_LINK = _dereq_('../constants/docs').FORMAT_LINK;
	var DATE_FORMAT_LINK = _dereq_('../constants/docs').DATE_FORMAT_LINK;
	
	var templateFormatStringDescription = [
	    'Variables are inserted using %{variable}, for example "y: %{y}".',
	    'Numbers are formatted using d3-format\'s syntax %{variable:d3-format}, for example "Price: %{y:$.2f}".',
	    FORMAT_LINK,
	    'for details on the formatting syntax.',
	    'Dates are formatted using d3-time-format\'s syntax %{variable|d3-time-format}, for example "Day: %{2019-01-01|%A}".',
	    DATE_FORMAT_LINK,
	    'for details on the date formatting syntax.'
	].join(' ');
	
	function describeVariables(extra) {
	    var descPart = extra.description ? ' ' + extra.description : '';
	    var keys = extra.keys || [];
	    if(keys.length > 0) {
	        var quotedKeys = [];
	        for(var i = 0; i < keys.length; i++) {
	            quotedKeys[i] = '`' + keys[i] + '`';
	        }
	        descPart = descPart + 'Finally, the template string has access to ';
	        if(keys.length === 1) {
	            descPart = 'variable ' + quotedKeys[0];
	        } else {
	            descPart = 'variables ' + quotedKeys.slice(0, -1).join(', ') + ' and ' + quotedKeys.slice(-1) + '.';
	        }
	    }
	    return descPart;
	}
	
	exports.hovertemplateAttrs = function(opts, extra) {
	    opts = opts || {};
	    extra = extra || {};
	
	    var descPart = describeVariables(extra);
	
	    var hovertemplate = {
	        valType: 'string',
	        
	        dflt: '',
	        editType: opts.editType || 'none',
	        
	    };
	
	    if(opts.arrayOk !== false) {
	        hovertemplate.arrayOk = true;
	    }
	
	    return hovertemplate;
	};
	
	exports.texttemplateAttrs = function(opts, extra) {
	    opts = opts || {};
	    extra = extra || {};
	
	    var descPart = describeVariables(extra);
	
	    var texttemplate = {
	        valType: 'string',
	        
	        dflt: '',
	        editType: opts.editType || 'calc',
	        
	    };
	
	    if(opts.arrayOk !== false) {
	        texttemplate.arrayOk = true;
	    }
	    return texttemplate;
	};
	
	},{"../constants/docs":687}],841:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Ternary = _dereq_('./ternary');
	
	var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
	var counterRegex = _dereq_('../../lib').counterRegex;
	var TERNARY = 'ternary';
	
	exports.name = TERNARY;
	
	var attr = exports.attr = 'subplot';
	
	exports.idRoot = TERNARY;
	
	exports.idRegex = exports.attrRegex = counterRegex(TERNARY);
	
	var attributes = exports.attributes = {};
	attributes[attr] = {
	    valType: 'subplotid',
	    
	    dflt: 'ternary',
	    editType: 'calc',
	    
	};
	
	exports.layoutAttributes = _dereq_('./layout_attributes');
	
	exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
	
	exports.plot = function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var calcData = gd.calcdata;
	    var ternaryIds = fullLayout._subplots[TERNARY];
	
	    for(var i = 0; i < ternaryIds.length; i++) {
	        var ternaryId = ternaryIds[i];
	        var ternaryCalcData = getSubplotCalcData(calcData, TERNARY, ternaryId);
	        var ternary = fullLayout[ternaryId]._subplot;
	
	        // If ternary is not instantiated, create one!
	        if(!ternary) {
	            ternary = new Ternary({
	                id: ternaryId,
	                graphDiv: gd,
	                container: fullLayout._ternarylayer.node()
	            },
	                fullLayout
	            );
	
	            fullLayout[ternaryId]._subplot = ternary;
	        }
	
	        ternary.plot(ternaryCalcData, fullLayout, gd._promises);
	    }
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var oldTernaryKeys = oldFullLayout._subplots[TERNARY] || [];
	
	    for(var i = 0; i < oldTernaryKeys.length; i++) {
	        var oldTernaryKey = oldTernaryKeys[i];
	        var oldTernary = oldFullLayout[oldTernaryKey]._subplot;
	
	        if(!newFullLayout[oldTernaryKey] && !!oldTernary) {
	            oldTernary.plotContainer.remove();
	            oldTernary.clipDef.remove();
	            oldTernary.clipDefRelative.remove();
	            oldTernary.layers['a-title'].remove();
	            oldTernary.layers['b-title'].remove();
	            oldTernary.layers['c-title'].remove();
	        }
	    }
	};
	
	},{"../../lib":716,"../../plots/get_data":799,"./layout_attributes":842,"./layout_defaults":843,"./ternary":844}],842:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorAttrs = _dereq_('../../components/color/attributes');
	var domainAttrs = _dereq_('../domain').attributes;
	var axesAttrs = _dereq_('../cartesian/layout_attributes');
	
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var ternaryAxesAttrs = {
	    title: {
	        text: axesAttrs.title.text,
	        font: axesAttrs.title.font
	        // TODO does standoff here make sense?
	    },
	    color: axesAttrs.color,
	    // ticks
	    tickmode: axesAttrs.tickmode,
	    nticks: extendFlat({}, axesAttrs.nticks, {dflt: 6, min: 1}),
	    tick0: axesAttrs.tick0,
	    dtick: axesAttrs.dtick,
	    tickvals: axesAttrs.tickvals,
	    ticktext: axesAttrs.ticktext,
	    ticks: axesAttrs.ticks,
	    ticklen: axesAttrs.ticklen,
	    tickwidth: axesAttrs.tickwidth,
	    tickcolor: axesAttrs.tickcolor,
	    showticklabels: axesAttrs.showticklabels,
	    showtickprefix: axesAttrs.showtickprefix,
	    tickprefix: axesAttrs.tickprefix,
	    showticksuffix: axesAttrs.showticksuffix,
	    ticksuffix: axesAttrs.ticksuffix,
	    showexponent: axesAttrs.showexponent,
	    exponentformat: axesAttrs.exponentformat,
	    separatethousands: axesAttrs.separatethousands,
	    tickfont: axesAttrs.tickfont,
	    tickangle: axesAttrs.tickangle,
	    tickformat: axesAttrs.tickformat,
	    tickformatstops: axesAttrs.tickformatstops,
	    hoverformat: axesAttrs.hoverformat,
	    // lines and grids
	    showline: extendFlat({}, axesAttrs.showline, {dflt: true}),
	    linecolor: axesAttrs.linecolor,
	    linewidth: axesAttrs.linewidth,
	    showgrid: extendFlat({}, axesAttrs.showgrid, {dflt: true}),
	    gridcolor: axesAttrs.gridcolor,
	    gridwidth: axesAttrs.gridwidth,
	    layer: axesAttrs.layer,
	    // range
	    min: {
	        valType: 'number',
	        dflt: 0,
	        
	        min: 0,
	        
	    },
	    _deprecated: {
	        title: axesAttrs._deprecated.title,
	        titlefont: axesAttrs._deprecated.titlefont
	    }
	};
	
	var attrs = module.exports = overrideAll({
	    domain: domainAttrs({name: 'ternary'}),
	
	    bgcolor: {
	        valType: 'color',
	        
	        dflt: colorAttrs.background,
	        
	    },
	    sum: {
	        valType: 'number',
	        
	        dflt: 1,
	        min: 0,
	        
	    },
	    aaxis: ternaryAxesAttrs,
	    baxis: ternaryAxesAttrs,
	    caxis: ternaryAxesAttrs
	}, 'plot', 'from-root');
	
	// set uirevisions outside of `overrideAll` so we can get `editType: none`
	attrs.uirevision = {
	    valType: 'any',
	    
	    editType: 'none',
	    
	};
	
	attrs.aaxis.uirevision = attrs.baxis.uirevision = attrs.caxis.uirevision = {
	    valType: 'any',
	    
	    editType: 'none',
	    
	};
	
	},{"../../components/color/attributes":590,"../../lib/extend":707,"../../plot_api/edit_types":747,"../cartesian/layout_attributes":776,"../domain":789}],843:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var Template = _dereq_('../../plot_api/plot_template');
	var Lib = _dereq_('../../lib');
	
	var handleSubplotDefaults = _dereq_('../subplot_defaults');
	var handleTickLabelDefaults = _dereq_('../cartesian/tick_label_defaults');
	var handleTickMarkDefaults = _dereq_('../cartesian/tick_mark_defaults');
	var handleTickValueDefaults = _dereq_('../cartesian/tick_value_defaults');
	var handleLineGridDefaults = _dereq_('../cartesian/line_grid_defaults');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	var axesNames = ['aaxis', 'baxis', 'caxis'];
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	        type: 'ternary',
	        attributes: layoutAttributes,
	        handleDefaults: handleTernaryDefaults,
	        font: layoutOut.font,
	        paper_bgcolor: layoutOut.paper_bgcolor
	    });
	};
	
	function handleTernaryDefaults(ternaryLayoutIn, ternaryLayoutOut, coerce, options) {
	    var bgColor = coerce('bgcolor');
	    var sum = coerce('sum');
	    options.bgColor = Color.combine(bgColor, options.paper_bgcolor);
	    var axName, containerIn, containerOut;
	
	    // TODO: allow most (if not all) axis attributes to be set
	    // in the outer container and used as defaults in the individual axes?
	
	    for(var j = 0; j < axesNames.length; j++) {
	        axName = axesNames[j];
	        containerIn = ternaryLayoutIn[axName] || {};
	        containerOut = Template.newContainer(ternaryLayoutOut, axName);
	        containerOut._name = axName;
	
	        handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut);
	    }
	
	    // if the min values contradict each other, set them all to default (0)
	    // and delete *all* the inputs so the user doesn't get confused later by
	    // changing one and having them all change.
	    var aaxis = ternaryLayoutOut.aaxis;
	    var baxis = ternaryLayoutOut.baxis;
	    var caxis = ternaryLayoutOut.caxis;
	    if(aaxis.min + baxis.min + caxis.min >= sum) {
	        aaxis.min = 0;
	        baxis.min = 0;
	        caxis.min = 0;
	        if(ternaryLayoutIn.aaxis) delete ternaryLayoutIn.aaxis.min;
	        if(ternaryLayoutIn.baxis) delete ternaryLayoutIn.baxis.min;
	        if(ternaryLayoutIn.caxis) delete ternaryLayoutIn.caxis.min;
	    }
	}
	
	function handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut) {
	    var axAttrs = layoutAttributes[containerOut._name];
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, axAttrs, attr, dflt);
	    }
	
	    coerce('uirevision', ternaryLayoutOut.uirevision);
	
	    containerOut.type = 'linear'; // no other types allowed for ternary
	
	    var dfltColor = coerce('color');
	    // if axis.color was provided, use it for fonts too; otherwise,
	    // inherit from global font color in case that was provided.
	    var dfltFontColor = (dfltColor !== axAttrs.color.dflt) ? dfltColor : options.font.color;
	
	    var axName = containerOut._name;
	    var letterUpper = axName.charAt(0).toUpperCase();
	    var dfltTitle = 'Component ' + letterUpper;
	
	    var title = coerce('title.text', dfltTitle);
	    containerOut._hovertitle = title === dfltTitle ? title : letterUpper;
	
	    Lib.coerceFont(coerce, 'title.font', {
	        family: options.font.family,
	        size: Math.round(options.font.size * 1.2),
	        color: dfltFontColor
	    });
	
	    // range is just set by 'min' - max is determined by the other axes mins
	    coerce('min');
	
	    handleTickValueDefaults(containerIn, containerOut, coerce, 'linear');
	    handleTickLabelDefaults(containerIn, containerOut, coerce, 'linear', {});
	    handleTickMarkDefaults(containerIn, containerOut, coerce,
	        { outerTicks: true });
	
	    var showTickLabels = coerce('showticklabels');
	    if(showTickLabels) {
	        Lib.coerceFont(coerce, 'tickfont', {
	            family: options.font.family,
	            size: options.font.size,
	            color: dfltFontColor
	        });
	        coerce('tickangle');
	        coerce('tickformat');
	    }
	
	    handleLineGridDefaults(containerIn, containerOut, coerce, {
	        dfltColor: dfltColor,
	        bgColor: options.bgColor,
	        // default grid color is darker here (60%, vs cartesian default ~91%)
	        // because the grid is not square so the eye needs heavier cues to follow
	        blend: 60,
	        showLine: true,
	        showGrid: true,
	        noZeroLine: true,
	        attributes: axAttrs
	    });
	
	    coerce('hoverformat');
	    coerce('layer');
	}
	
	},{"../../components/color":591,"../../lib":716,"../../plot_api/plot_template":754,"../cartesian/line_grid_defaults":778,"../cartesian/tick_label_defaults":783,"../cartesian/tick_mark_defaults":784,"../cartesian/tick_value_defaults":785,"../subplot_defaults":839,"./layout_attributes":842}],844:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var _ = Lib._;
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var setConvert = _dereq_('../cartesian/set_convert');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var Plots = _dereq_('../plots');
	var Axes = _dereq_('../cartesian/axes');
	var dragElement = _dereq_('../../components/dragelement');
	var Fx = _dereq_('../../components/fx');
	var Titles = _dereq_('../../components/titles');
	var prepSelect = _dereq_('../cartesian/select').prepSelect;
	var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
	var clearSelect = _dereq_('../cartesian/select').clearSelect;
	var constants = _dereq_('../cartesian/constants');
	
	function Ternary(options, fullLayout) {
	    this.id = options.id;
	    this.graphDiv = options.graphDiv;
	    this.init(fullLayout);
	    this.makeFramework(fullLayout);
	
	    // unfortunately, we have to keep track of some axis tick settings
	    // as ternary subplots do not implement the 'ticks' editType
	    this.aTickLayout = null;
	    this.bTickLayout = null;
	    this.cTickLayout = null;
	}
	
	module.exports = Ternary;
	
	var proto = Ternary.prototype;
	
	proto.init = function(fullLayout) {
	    this.container = fullLayout._ternarylayer;
	    this.defs = fullLayout._defs;
	    this.layoutId = fullLayout._uid;
	    this.traceHash = {};
	    this.layers = {};
	};
	
	proto.plot = function(ternaryCalcData, fullLayout) {
	    var _this = this;
	    var ternaryLayout = fullLayout[_this.id];
	    var graphSize = fullLayout._size;
	
	    _this._hasClipOnAxisFalse = false;
	    for(var i = 0; i < ternaryCalcData.length; i++) {
	        var trace = ternaryCalcData[i][0].trace;
	
	        if(trace.cliponaxis === false) {
	            _this._hasClipOnAxisFalse = true;
	            break;
	        }
	    }
	
	    _this.updateLayers(ternaryLayout);
	    _this.adjustLayout(ternaryLayout, graphSize);
	    Plots.generalUpdatePerTraceModule(_this.graphDiv, _this, ternaryCalcData, ternaryLayout);
	    _this.layers.plotbg.select('path').call(Color.fill, ternaryLayout.bgcolor);
	};
	
	proto.makeFramework = function(fullLayout) {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var ternaryLayout = fullLayout[_this.id];
	
	    var clipId = _this.clipId = 'clip' + _this.layoutId + _this.id;
	    var clipIdRelative = _this.clipIdRelative = 'clip-relative' + _this.layoutId + _this.id;
	
	    // clippath for this ternary subplot
	    _this.clipDef = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function(s) {
	        s.append('path').attr('d', 'M0,0Z');
	    });
	
	    // 'relative' clippath (i.e. no translation) for this ternary subplot
	    _this.clipDefRelative = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipIdRelative, function(s) {
	        s.append('path').attr('d', 'M0,0Z');
	    });
	
	    // container for everything in this ternary subplot
	    _this.plotContainer = Lib.ensureSingle(_this.container, 'g', _this.id);
	    _this.updateLayers(ternaryLayout);
	
	    Drawing.setClipUrl(_this.layers.backplot, clipId, gd);
	    Drawing.setClipUrl(_this.layers.grids, clipId, gd);
	};
	
	proto.updateLayers = function(ternaryLayout) {
	    var _this = this;
	    var layers = _this.layers;
	
	    // inside that container, we have one container for the data, and
	    // one each for the three axes around it.
	
	    var plotLayers = ['draglayer', 'plotbg', 'backplot', 'grids'];
	
	    if(ternaryLayout.aaxis.layer === 'below traces') {
	        plotLayers.push('aaxis', 'aline');
	    }
	    if(ternaryLayout.baxis.layer === 'below traces') {
	        plotLayers.push('baxis', 'bline');
	    }
	    if(ternaryLayout.caxis.layer === 'below traces') {
	        plotLayers.push('caxis', 'cline');
	    }
	
	    plotLayers.push('frontplot');
	
	    if(ternaryLayout.aaxis.layer === 'above traces') {
	        plotLayers.push('aaxis', 'aline');
	    }
	    if(ternaryLayout.baxis.layer === 'above traces') {
	        plotLayers.push('baxis', 'bline');
	    }
	    if(ternaryLayout.caxis.layer === 'above traces') {
	        plotLayers.push('caxis', 'cline');
	    }
	
	    var toplevel = _this.plotContainer.selectAll('g.toplevel')
	        .data(plotLayers, String);
	
	    var grids = ['agrid', 'bgrid', 'cgrid'];
	
	    toplevel.enter().append('g')
	        .attr('class', function(d) { return 'toplevel ' + d; })
	        .each(function(d) {
	            var s = d3.select(this);
	            layers[d] = s;
	
	            // containers for different trace types.
	            // NOTE - this is different from cartesian, where all traces
	            // are in front of grids. Here I'm putting maps behind the grids
	            // so the grids will always be visible if they're requested.
	            // Perhaps we want that for cartesian too?
	            if(d === 'frontplot') {
	                s.append('g').classed('scatterlayer', true);
	            } else if(d === 'backplot') {
	                s.append('g').classed('maplayer', true);
	            } else if(d === 'plotbg') {
	                s.append('path').attr('d', 'M0,0Z');
	            } else if(d === 'aline' || d === 'bline' || d === 'cline') {
	                s.append('path');
	            } else if(d === 'grids') {
	                grids.forEach(function(d) {
	                    layers[d] = s.append('g').classed('grid ' + d, true);
	                });
	            }
	        });
	
	    toplevel.order();
	};
	
	var whRatio = Math.sqrt(4 / 3);
	
	proto.adjustLayout = function(ternaryLayout, graphSize) {
	    var _this = this;
	    var domain = ternaryLayout.domain;
	    var xDomainCenter = (domain.x[0] + domain.x[1]) / 2;
	    var yDomainCenter = (domain.y[0] + domain.y[1]) / 2;
	    var xDomain = domain.x[1] - domain.x[0];
	    var yDomain = domain.y[1] - domain.y[0];
	    var wmax = xDomain * graphSize.w;
	    var hmax = yDomain * graphSize.h;
	    var sum = ternaryLayout.sum;
	    var amin = ternaryLayout.aaxis.min;
	    var bmin = ternaryLayout.baxis.min;
	    var cmin = ternaryLayout.caxis.min;
	
	    var x0, y0, w, h, xDomainFinal, yDomainFinal;
	
	    if(wmax > whRatio * hmax) {
	        h = hmax;
	        w = h * whRatio;
	    } else {
	        w = wmax;
	        h = w / whRatio;
	    }
	
	    xDomainFinal = xDomain * w / wmax;
	    yDomainFinal = yDomain * h / hmax;
	
	    x0 = graphSize.l + graphSize.w * xDomainCenter - w / 2;
	    y0 = graphSize.t + graphSize.h * (1 - yDomainCenter) - h / 2;
	
	    _this.x0 = x0;
	    _this.y0 = y0;
	    _this.w = w;
	    _this.h = h;
	    _this.sum = sum;
	
	    // set up the x and y axis objects we'll use to lay out the points
	    _this.xaxis = {
	        type: 'linear',
	        range: [amin + 2 * cmin - sum, sum - amin - 2 * bmin],
	        domain: [
	            xDomainCenter - xDomainFinal / 2,
	            xDomainCenter + xDomainFinal / 2
	        ],
	        _id: 'x'
	    };
	    setConvert(_this.xaxis, _this.graphDiv._fullLayout);
	    _this.xaxis.setScale();
	    _this.xaxis.isPtWithinRange = function(d) {
	        return (
	            d.a >= _this.aaxis.range[0] &&
	            d.a <= _this.aaxis.range[1] &&
	            d.b >= _this.baxis.range[1] &&
	            d.b <= _this.baxis.range[0] &&
	            d.c >= _this.caxis.range[1] &&
	            d.c <= _this.caxis.range[0]
	        );
	    };
	
	    _this.yaxis = {
	        type: 'linear',
	        range: [amin, sum - bmin - cmin],
	        domain: [
	            yDomainCenter - yDomainFinal / 2,
	            yDomainCenter + yDomainFinal / 2
	        ],
	        _id: 'y'
	    };
	    setConvert(_this.yaxis, _this.graphDiv._fullLayout);
	    _this.yaxis.setScale();
	    _this.yaxis.isPtWithinRange = function() { return true; };
	
	    // set up the modified axes for tick drawing
	    var yDomain0 = _this.yaxis.domain[0];
	
	    // aaxis goes up the left side. Set it up as a y axis, but with
	    // fictitious angles and domain, but then rotate and translate
	    // it into place at the end
	    var aaxis = _this.aaxis = extendFlat({}, ternaryLayout.aaxis, {
	        range: [amin, sum - bmin - cmin],
	        side: 'left',
	        // tickangle = 'auto' means 0 anyway for a y axis, need to coerce to 0 here
	        // so we can shift by 30.
	        tickangle: (+ternaryLayout.aaxis.tickangle || 0) - 30,
	        domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
	        anchor: 'free',
	        position: 0,
	        _id: 'y',
	        _length: w
	    });
	    setConvert(aaxis, _this.graphDiv._fullLayout);
	    aaxis.setScale();
	
	    // baxis goes across the bottom (backward). We can set it up as an x axis
	    // without any enclosing transformation.
	    var baxis = _this.baxis = extendFlat({}, ternaryLayout.baxis, {
	        range: [sum - amin - cmin, bmin],
	        side: 'bottom',
	        domain: _this.xaxis.domain,
	        anchor: 'free',
	        position: 0,
	        _id: 'x',
	        _length: w
	    });
	    setConvert(baxis, _this.graphDiv._fullLayout);
	    baxis.setScale();
	
	    // caxis goes down the right side. Set it up as a y axis, with
	    // post-transformation similar to aaxis
	    var caxis = _this.caxis = extendFlat({}, ternaryLayout.caxis, {
	        range: [sum - amin - bmin, cmin],
	        side: 'right',
	        tickangle: (+ternaryLayout.caxis.tickangle || 0) + 30,
	        domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
	        anchor: 'free',
	        position: 0,
	        _id: 'y',
	        _length: w
	    });
	    setConvert(caxis, _this.graphDiv._fullLayout);
	    caxis.setScale();
	
	    var triangleClip = 'M' + x0 + ',' + (y0 + h) + 'h' + w + 'l-' + (w / 2) + ',-' + h + 'Z';
	    _this.clipDef.select('path').attr('d', triangleClip);
	    _this.layers.plotbg.select('path').attr('d', triangleClip);
	
	    var triangleClipRelative = 'M0,' + h + 'h' + w + 'l-' + (w / 2) + ',-' + h + 'Z';
	    _this.clipDefRelative.select('path').attr('d', triangleClipRelative);
	
	    var plotTransform = 'translate(' + x0 + ',' + y0 + ')';
	    _this.plotContainer.selectAll('.scatterlayer,.maplayer')
	        .attr('transform', plotTransform);
	
	    _this.clipDefRelative.select('path').attr('transform', null);
	
	    // TODO: shift axes to accommodate linewidth*sin(30) tick mark angle
	
	    // TODO: there's probably an easier way to handle these translations/offsets now...
	    var bTransform = 'translate(' + (x0 - baxis._offset) + ',' + (y0 + h) + ')';
	
	    _this.layers.baxis.attr('transform', bTransform);
	    _this.layers.bgrid.attr('transform', bTransform);
	
	    var aTransform = 'translate(' + (x0 + w / 2) + ',' + y0 +
	        ')rotate(30)translate(0,' + -aaxis._offset + ')';
	    _this.layers.aaxis.attr('transform', aTransform);
	    _this.layers.agrid.attr('transform', aTransform);
	
	    var cTransform = 'translate(' + (x0 + w / 2) + ',' + y0 +
	        ')rotate(-30)translate(0,' + -caxis._offset + ')';
	    _this.layers.caxis.attr('transform', cTransform);
	    _this.layers.cgrid.attr('transform', cTransform);
	
	    _this.drawAxes(true);
	
	    _this.layers.aline.select('path')
	        .attr('d', aaxis.showline ?
	            'M' + x0 + ',' + (y0 + h) + 'l' + (w / 2) + ',-' + h : 'M0,0')
	        .call(Color.stroke, aaxis.linecolor || '#000')
	        .style('stroke-width', (aaxis.linewidth || 0) + 'px');
	    _this.layers.bline.select('path')
	        .attr('d', baxis.showline ?
	            'M' + x0 + ',' + (y0 + h) + 'h' + w : 'M0,0')
	        .call(Color.stroke, baxis.linecolor || '#000')
	        .style('stroke-width', (baxis.linewidth || 0) + 'px');
	    _this.layers.cline.select('path')
	        .attr('d', caxis.showline ?
	            'M' + (x0 + w / 2) + ',' + y0 + 'l' + (w / 2) + ',' + h : 'M0,0')
	        .call(Color.stroke, caxis.linecolor || '#000')
	        .style('stroke-width', (caxis.linewidth || 0) + 'px');
	
	    if(!_this.graphDiv._context.staticPlot) {
	        _this.initInteractions();
	    }
	
	    Drawing.setClipUrl(
	        _this.layers.frontplot,
	        _this._hasClipOnAxisFalse ? null : _this.clipId,
	        _this.graphDiv
	    );
	};
	
	proto.drawAxes = function(doTitles) {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var titlesuffix = _this.id.substr(7) + 'title';
	    var layers = _this.layers;
	    var aaxis = _this.aaxis;
	    var baxis = _this.baxis;
	    var caxis = _this.caxis;
	
	    _this.drawAx(aaxis);
	    _this.drawAx(baxis);
	    _this.drawAx(caxis);
	
	    if(doTitles) {
	        var apad = Math.max(aaxis.showticklabels ? aaxis.tickfont.size / 2 : 0,
	            (caxis.showticklabels ? caxis.tickfont.size * 0.75 : 0) +
	            (caxis.ticks === 'outside' ? caxis.ticklen * 0.87 : 0));
	        var bpad = (baxis.showticklabels ? baxis.tickfont.size : 0) +
	            (baxis.ticks === 'outside' ? baxis.ticklen : 0) + 3;
	
	        layers['a-title'] = Titles.draw(gd, 'a' + titlesuffix, {
	            propContainer: aaxis,
	            propName: _this.id + '.aaxis.title',
	            placeholder: _(gd, 'Click to enter Component A title'),
	            attributes: {
	                x: _this.x0 + _this.w / 2,
	                y: _this.y0 - aaxis.title.font.size / 3 - apad,
	                'text-anchor': 'middle'
	            }
	        });
	        layers['b-title'] = Titles.draw(gd, 'b' + titlesuffix, {
	            propContainer: baxis,
	            propName: _this.id + '.baxis.title',
	            placeholder: _(gd, 'Click to enter Component B title'),
	            attributes: {
	                x: _this.x0 - bpad,
	                y: _this.y0 + _this.h + baxis.title.font.size * 0.83 + bpad,
	                'text-anchor': 'middle'
	            }
	        });
	        layers['c-title'] = Titles.draw(gd, 'c' + titlesuffix, {
	            propContainer: caxis,
	            propName: _this.id + '.caxis.title',
	            placeholder: _(gd, 'Click to enter Component C title'),
	            attributes: {
	                x: _this.x0 + _this.w + bpad,
	                y: _this.y0 + _this.h + caxis.title.font.size * 0.83 + bpad,
	                'text-anchor': 'middle'
	            }
	        });
	    }
	};
	
	proto.drawAx = function(ax) {
	    var _this = this;
	    var gd = _this.graphDiv;
	    var axName = ax._name;
	    var axLetter = axName.charAt(0);
	    var axId = ax._id;
	    var axLayer = _this.layers[axName];
	    var counterAngle = 30;
	
	    var stashKey = axLetter + 'tickLayout';
	    var newTickLayout = strTickLayout(ax);
	    if(_this[stashKey] !== newTickLayout) {
	        axLayer.selectAll('.' + axId + 'tick').remove();
	        _this[stashKey] = newTickLayout;
	    }
	
	    ax.setScale();
	
	    var vals = Axes.calcTicks(ax);
	    var valsClipped = Axes.clipEnds(ax, vals);
	    var transFn = Axes.makeTransFn(ax);
	    var tickSign = Axes.getTickSigns(ax)[2];
	
	    var caRad = Lib.deg2rad(counterAngle);
	    var pad = tickSign * (ax.linewidth || 1) / 2;
	    var len = tickSign * ax.ticklen;
	    var w = _this.w;
	    var h = _this.h;
	
	    var tickPath = axLetter === 'b' ?
	        'M0,' + pad + 'l' + (Math.sin(caRad) * len) + ',' + (Math.cos(caRad) * len) :
	        'M' + pad + ',0l' + (Math.cos(caRad) * len) + ',' + (-Math.sin(caRad) * len);
	
	    var gridPath = {
	        a: 'M0,0l' + h + ',-' + (w / 2),
	        b: 'M0,0l-' + (w / 2) + ',-' + h,
	        c: 'M0,0l-' + h + ',' + (w / 2)
	    }[axLetter];
	
	    Axes.drawTicks(gd, ax, {
	        vals: ax.ticks === 'inside' ? valsClipped : vals,
	        layer: axLayer,
	        path: tickPath,
	        transFn: transFn,
	        crisp: false
	    });
	
	    Axes.drawGrid(gd, ax, {
	        vals: valsClipped,
	        layer: _this.layers[axLetter + 'grid'],
	        path: gridPath,
	        transFn: transFn,
	        crisp: false
	    });
	
	    Axes.drawLabels(gd, ax, {
	        vals: vals,
	        layer: axLayer,
	        transFn: transFn,
	        labelFns: Axes.makeLabelFns(ax, 0, counterAngle)
	    });
	};
	
	function strTickLayout(axLayout) {
	    return axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
	}
	
	// hard coded paths for zoom corners
	// uses the same sizing as cartesian, length is MINZOOM/2, width is 3px
	var CLEN = constants.MINZOOM / 2 + 0.87;
	var BLPATH = 'm-0.87,.5h' + CLEN + 'v3h-' + (CLEN + 5.2) +
	    'l' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
	    'l2.6,1.5l-' + (CLEN / 2) + ',' + (CLEN * 0.87) + 'Z';
	var BRPATH = 'm0.87,.5h-' + CLEN + 'v3h' + (CLEN + 5.2) +
	    'l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
	    'l-2.6,1.5l' + (CLEN / 2) + ',' + (CLEN * 0.87) + 'Z';
	var TOPPATH = 'm0,1l' + (CLEN / 2) + ',' + (CLEN * 0.87) +
	    'l2.6,-1.5l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
	    'l-' + (CLEN / 2 + 2.6) + ',' + (CLEN * 0.87 + 4.5) +
	    'l2.6,1.5l' + (CLEN / 2) + ',-' + (CLEN * 0.87) + 'Z';
	var STARTMARKER = 'm0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z';
	
	// I guess this could be shared with cartesian... but for now it's separate.
	var SHOWZOOMOUTTIP = true;
	
	proto.initInteractions = function() {
	    var _this = this;
	    var dragger = _this.layers.plotbg.select('path').node();
	    var gd = _this.graphDiv;
	    var zoomLayer = gd._fullLayout._zoomlayer;
	
	    // use plotbg for the main interactions
	    var dragOptions = {
	        element: dragger,
	        gd: gd,
	        plotinfo: {
	            id: _this.id,
	            xaxis: _this.xaxis,
	            yaxis: _this.yaxis
	        },
	        subplot: _this.id,
	        prepFn: function(e, startX, startY) {
	            // these aren't available yet when initInteractions
	            // is called
	            dragOptions.xaxes = [_this.xaxis];
	            dragOptions.yaxes = [_this.yaxis];
	            var dragModeNow = gd._fullLayout.dragmode;
	
	            if(dragModeNow === 'lasso') dragOptions.minDrag = 1;
	            else dragOptions.minDrag = undefined;
	
	            if(dragModeNow === 'zoom') {
	                dragOptions.moveFn = zoomMove;
	                dragOptions.clickFn = clickZoomPan;
	                dragOptions.doneFn = zoomDone;
	                zoomPrep(e, startX, startY);
	            } else if(dragModeNow === 'pan') {
	                dragOptions.moveFn = plotDrag;
	                dragOptions.clickFn = clickZoomPan;
	                dragOptions.doneFn = dragDone;
	                panPrep();
	                clearSelect(gd);
	            } else if(dragModeNow === 'select' || dragModeNow === 'lasso') {
	                prepSelect(e, startX, startY, dragOptions, dragModeNow);
	            }
	        }
	    };
	
	    var x0, y0, mins0, span0, mins, lum, path0, dimmed, zb, corners;
	
	    function makeUpdate(_mins) {
	        var attrs = {};
	        attrs[_this.id + '.aaxis.min'] = _mins.a;
	        attrs[_this.id + '.baxis.min'] = _mins.b;
	        attrs[_this.id + '.caxis.min'] = _mins.c;
	        return attrs;
	    }
	
	    function clickZoomPan(numClicks, evt) {
	        var clickMode = gd._fullLayout.clickmode;
	
	        removeZoombox(gd);
	
	        if(numClicks === 2) {
	            gd.emit('plotly_doubleclick', null);
	            Registry.call('_guiRelayout', gd, makeUpdate({a: 0, b: 0, c: 0}));
	        }
	
	        if(clickMode.indexOf('select') > -1 && numClicks === 1) {
	            selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOptions);
	        }
	
	        if(clickMode.indexOf('event') > -1) {
	            Fx.click(gd, evt, _this.id);
	        }
	    }
	
	    function zoomPrep(e, startX, startY) {
	        var dragBBox = dragger.getBoundingClientRect();
	        x0 = startX - dragBBox.left;
	        y0 = startY - dragBBox.top;
	        mins0 = {
	            a: _this.aaxis.range[0],
	            b: _this.baxis.range[1],
	            c: _this.caxis.range[1]
	        };
	        mins = mins0;
	        span0 = _this.aaxis.range[1] - mins0.a;
	        lum = tinycolor(_this.graphDiv._fullLayout[_this.id].bgcolor).getLuminance();
	        path0 = 'M0,' + _this.h + 'L' + (_this.w / 2) + ', 0L' + _this.w + ',' + _this.h + 'Z';
	        dimmed = false;
	
	        zb = zoomLayer.append('path')
	            .attr('class', 'zoombox')
	            .attr('transform', 'translate(' + _this.x0 + ', ' + _this.y0 + ')')
	            .style({
	                'fill': lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
	                'stroke-width': 0
	            })
	            .attr('d', path0);
	
	        corners = zoomLayer.append('path')
	            .attr('class', 'zoombox-corners')
	            .attr('transform', 'translate(' + _this.x0 + ', ' + _this.y0 + ')')
	            .style({
	                fill: Color.background,
	                stroke: Color.defaultLine,
	                'stroke-width': 1,
	                opacity: 0
	            })
	            .attr('d', 'M0,0Z');
	
	        clearSelect(gd);
	    }
	
	    function getAFrac(x, y) { return 1 - (y / _this.h); }
	    function getBFrac(x, y) { return 1 - ((x + (_this.h - y) / Math.sqrt(3)) / _this.w); }
	    function getCFrac(x, y) { return ((x - (_this.h - y) / Math.sqrt(3)) / _this.w); }
	
	    function zoomMove(dx0, dy0) {
	        var x1 = x0 + dx0;
	        var y1 = y0 + dy0;
	        var afrac = Math.max(0, Math.min(1, getAFrac(x0, y0), getAFrac(x1, y1)));
	        var bfrac = Math.max(0, Math.min(1, getBFrac(x0, y0), getBFrac(x1, y1)));
	        var cfrac = Math.max(0, Math.min(1, getCFrac(x0, y0), getCFrac(x1, y1)));
	        var xLeft = ((afrac / 2) + cfrac) * _this.w;
	        var xRight = (1 - (afrac / 2) - bfrac) * _this.w;
	        var xCenter = (xLeft + xRight) / 2;
	        var xSpan = xRight - xLeft;
	        var yBottom = (1 - afrac) * _this.h;
	        var yTop = yBottom - xSpan / whRatio;
	
	        if(xSpan < constants.MINZOOM) {
	            mins = mins0;
	            zb.attr('d', path0);
	            corners.attr('d', 'M0,0Z');
	        } else {
	            mins = {
	                a: mins0.a + afrac * span0,
	                b: mins0.b + bfrac * span0,
	                c: mins0.c + cfrac * span0
	            };
	            zb.attr('d', path0 + 'M' + xLeft + ',' + yBottom +
	                'H' + xRight + 'L' + xCenter + ',' + yTop +
	                'L' + xLeft + ',' + yBottom + 'Z');
	            corners.attr('d', 'M' + x0 + ',' + y0 + STARTMARKER +
	                'M' + xLeft + ',' + yBottom + BLPATH +
	                'M' + xRight + ',' + yBottom + BRPATH +
	                'M' + xCenter + ',' + yTop + TOPPATH);
	        }
	
	        if(!dimmed) {
	            zb.transition()
	                .style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' :
	                    'rgba(255,255,255,0.3)')
	                .duration(200);
	            corners.transition()
	                .style('opacity', 1)
	                .duration(200);
	            dimmed = true;
	        }
	
	        gd.emit('plotly_relayouting', makeUpdate(mins));
	    }
	
	    function zoomDone() {
	        removeZoombox(gd);
	
	        if(mins === mins0) return;
	
	        Registry.call('_guiRelayout', gd, makeUpdate(mins));
	
	        if(SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
	            Lib.notifier(_(gd, 'Double-click to zoom back out'), 'long');
	            SHOWZOOMOUTTIP = false;
	        }
	    }
	
	    function panPrep() {
	        mins0 = {
	            a: _this.aaxis.range[0],
	            b: _this.baxis.range[1],
	            c: _this.caxis.range[1]
	        };
	        mins = mins0;
	    }
	
	    function plotDrag(dx, dy) {
	        var dxScaled = dx / _this.xaxis._m;
	        var dyScaled = dy / _this.yaxis._m;
	        mins = {
	            a: mins0.a - dyScaled,
	            b: mins0.b + (dxScaled + dyScaled) / 2,
	            c: mins0.c - (dxScaled - dyScaled) / 2
	        };
	        var minsorted = [mins.a, mins.b, mins.c].sort();
	        var minindices = {
	            a: minsorted.indexOf(mins.a),
	            b: minsorted.indexOf(mins.b),
	            c: minsorted.indexOf(mins.c)
	        };
	        if(minsorted[0] < 0) {
	            if(minsorted[1] + minsorted[0] / 2 < 0) {
	                minsorted[2] += minsorted[0] + minsorted[1];
	                minsorted[0] = minsorted[1] = 0;
	            } else {
	                minsorted[2] += minsorted[0] / 2;
	                minsorted[1] += minsorted[0] / 2;
	                minsorted[0] = 0;
	            }
	            mins = {
	                a: minsorted[minindices.a],
	                b: minsorted[minindices.b],
	                c: minsorted[minindices.c]
	            };
	            dy = (mins0.a - mins.a) * _this.yaxis._m;
	            dx = (mins0.c - mins.c - mins0.b + mins.b) * _this.xaxis._m;
	        }
	
	        // move the data (translate, don't redraw)
	        var plotTransform = 'translate(' + (_this.x0 + dx) + ',' + (_this.y0 + dy) + ')';
	        _this.plotContainer.selectAll('.scatterlayer,.maplayer')
	            .attr('transform', plotTransform);
	
	        var plotTransform2 = 'translate(' + -dx + ',' + -dy + ')';
	        _this.clipDefRelative.select('path').attr('transform', plotTransform2);
	
	        // move the ticks
	        _this.aaxis.range = [mins.a, _this.sum - mins.b - mins.c];
	        _this.baxis.range = [_this.sum - mins.a - mins.c, mins.b];
	        _this.caxis.range = [_this.sum - mins.a - mins.b, mins.c];
	
	        _this.drawAxes(false);
	
	        if(_this._hasClipOnAxisFalse) {
	            _this.plotContainer
	                .select('.scatterlayer').selectAll('.trace')
	                .call(Drawing.hideOutsideRangePoints, _this);
	        }
	
	        gd.emit('plotly_relayouting', makeUpdate(mins));
	    }
	
	    function dragDone() {
	        Registry.call('_guiRelayout', gd, makeUpdate(mins));
	    }
	
	    // finally, set up hover and click
	    // these event handlers must already be set before dragElement.init
	    // so it can stash them and override them.
	    dragger.onmousemove = function(evt) {
	        Fx.hover(gd, evt, _this.id);
	        gd._fullLayout._lasthover = dragger;
	        gd._fullLayout._hoversubplot = _this.id;
	    };
	
	    dragger.onmouseout = function(evt) {
	        if(gd._dragging) return;
	
	        dragElement.unhover(gd, evt);
	    };
	
	    dragElement.init(dragOptions);
	};
	
	function removeZoombox(gd) {
	    d3.select(gd)
	        .selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners')
	        .remove();
	}
	
	},{"../../components/color":591,"../../components/dragelement":609,"../../components/drawing":612,"../../components/fx":629,"../../components/titles":678,"../../lib":716,"../../lib/extend":707,"../../registry":845,"../cartesian/axes":764,"../cartesian/constants":770,"../cartesian/select":781,"../cartesian/set_convert":782,"../plots":825,"d3":164,"tinycolor2":535}],845:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Loggers = _dereq_('./lib/loggers');
	var noop = _dereq_('./lib/noop');
	var pushUnique = _dereq_('./lib/push_unique');
	var isPlainObject = _dereq_('./lib/is_plain_object');
	var addStyleRule = _dereq_('./lib/dom').addStyleRule;
	var ExtendModule = _dereq_('./lib/extend');
	
	var basePlotAttributes = _dereq_('./plots/attributes');
	var baseLayoutAttributes = _dereq_('./plots/layout_attributes');
	
	var extendFlat = ExtendModule.extendFlat;
	var extendDeepAll = ExtendModule.extendDeepAll;
	
	exports.modules = {};
	exports.allCategories = {};
	exports.allTypes = [];
	exports.subplotsRegistry = {};
	exports.transformsRegistry = {};
	exports.componentsRegistry = {};
	exports.layoutArrayContainers = [];
	exports.layoutArrayRegexes = [];
	exports.traceLayoutAttributes = {};
	exports.localeRegistry = {};
	exports.apiMethodRegistry = {};
	exports.collectableSubplotTypes = null;
	
	/**
	 * Top-level register routine, exported as Plotly.register
	 *
	 * @param {object array or array of objects} _modules :
	 *  module object or list of module object to register.
	 *
	 *  A valid `moduleType: 'trace'` module has fields:
	 *  - name {string} : the trace type
	 *  - categories {array} : categories associated with this trace type,
	 *                         tested with Register.traceIs()
	 *  - meta {object} : meta info (mostly for plot-schema)
	 *
	 *  A valid `moduleType: 'locale'` module has fields:
	 *  - name {string} : the locale name. Should be a 2-digit language string ('en', 'de')
	 *                    optionally with a country/region code ('en-GB', 'de-CH'). If a country
	 *                    code is used but the base language locale has not yet been supplied,
	 *                    we will use this locale for the base as well.
	 *  - dictionary {object} : the dictionary mapping input strings to localized strings
	 *                          generally the keys should be the literal input strings, but
	 *                          if default translations are provided you can use any string as a key.
	 *  - format {object} : a `d3.locale` format specifier for this locale
	 *                      any omitted keys we'll fall back on en-US.
	 *
	 *  A valid `moduleType: 'transform'` module has fields:
	 *  - name {string} : transform name
	 *  - transform {function} : default-level transform function
	 *  - calcTransform {function} : calc-level transform function
	 *  - attributes {object} : transform attributes declarations
	 *  - supplyDefaults {function} : attributes default-supply function
	 *
	 *  A valid `moduleType: 'component'` module has fields:
	 *  - name {string} : the component name, used it with Register.getComponentMethod()
	 *                    to employ component method.
	 *
	 *  A valid `moduleType: 'apiMethod'` module has fields:
	 *  - name {string} : the api method name.
	 *  - fn {function} : the api method called with Register.call();
	 *
	 */
	exports.register = function register(_modules) {
	    exports.collectableSubplotTypes = null;
	
	    if(!_modules) {
	        throw new Error('No argument passed to Plotly.register.');
	    } else if(_modules && !Array.isArray(_modules)) {
	        _modules = [_modules];
	    }
	
	    for(var i = 0; i < _modules.length; i++) {
	        var newModule = _modules[i];
	
	        if(!newModule) {
	            throw new Error('Invalid module was attempted to be registered!');
	        }
	
	        switch(newModule.moduleType) {
	            case 'trace':
	                registerTraceModule(newModule);
	                break;
	            case 'transform':
	                registerTransformModule(newModule);
	                break;
	            case 'component':
	                registerComponentModule(newModule);
	                break;
	            case 'locale':
	                registerLocale(newModule);
	                break;
	            case 'apiMethod':
	                var name = newModule.name;
	                exports.apiMethodRegistry[name] = newModule.fn;
	                break;
	            default:
	                throw new Error('Invalid module was attempted to be registered!');
	        }
	    }
	};
	
	/**
	 * Get registered module using trace object or trace type
	 *
	 * @param {object||string} trace
	 *  trace object with prop 'type' or trace type as a string
	 * @return {object}
	 *  module object corresponding to trace type
	 */
	exports.getModule = function(trace) {
	    var _module = exports.modules[getTraceType(trace)];
	    if(!_module) return false;
	    return _module._module;
	};
	
	/**
	 * Determine if this trace type is in a given category
	 *
	 * @param {object||string} traceType
	 *  a trace (object) or trace type (string)
	 * @param {string} category
	 *  category in question
	 * @return {boolean}
	 */
	exports.traceIs = function(traceType, category) {
	    traceType = getTraceType(traceType);
	
	    // old plot.ly workspace hack, nothing to see here
	    if(traceType === 'various') return false;
	
	    var _module = exports.modules[traceType];
	
	    if(!_module) {
	        if(traceType && traceType !== 'area') {
	            Loggers.log('Unrecognized trace type ' + traceType + '.');
	        }
	
	        _module = exports.modules[basePlotAttributes.type.dflt];
	    }
	
	    return !!_module.categories[category];
	};
	
	/**
	 * Determine if this trace has a transform of the given type and return
	 * array of matching indices.
	 *
	 * @param {object} data
	 *  a trace object (member of data or fullData)
	 * @param {string} type
	 *  type of trace to test
	 * @return {array}
	 *  array of matching indices. If none found, returns []
	 */
	exports.getTransformIndices = function(data, type) {
	    var indices = [];
	    var transforms = data.transforms || [];
	    for(var i = 0; i < transforms.length; i++) {
	        if(transforms[i].type === type) {
	            indices.push(i);
	        }
	    }
	    return indices;
	};
	
	/**
	 * Determine if this trace has a transform of the given type
	 *
	 * @param {object} data
	 *  a trace object (member of data or fullData)
	 * @param {string} type
	 *  type of trace to test
	 * @return {boolean}
	 */
	exports.hasTransform = function(data, type) {
	    var transforms = data.transforms || [];
	    for(var i = 0; i < transforms.length; i++) {
	        if(transforms[i].type === type) {
	            return true;
	        }
	    }
	    return false;
	};
	
	/**
	 * Retrieve component module method. Falls back on noop if either the
	 * module or the method is missing, so the result can always be safely called
	 *
	 * @param {string} name
	 *  name of component (as declared in component module)
	 * @param {string} method
	 *  name of component module method
	 * @return {function}
	 */
	exports.getComponentMethod = function(name, method) {
	    var _module = exports.componentsRegistry[name];
	
	    if(!_module) return noop;
	    return _module[method] || noop;
	};
	
	/**
	 * Call registered api method.
	 *
	 * @param {string} name : api method name
	 * @param {...array} args : arguments passed to api method
	 * @return {any} : returns api method output
	 */
	exports.call = function() {
	    var name = arguments[0];
	    var args = [].slice.call(arguments, 1);
	    return exports.apiMethodRegistry[name].apply(null, args);
	};
	
	function registerTraceModule(_module) {
	    var thisType = _module.name;
	    var categoriesIn = _module.categories;
	    var meta = _module.meta;
	
	    if(exports.modules[thisType]) {
	        Loggers.log('Type ' + thisType + ' already registered');
	        return;
	    }
	
	    if(!exports.subplotsRegistry[_module.basePlotModule.name]) {
	        registerSubplot(_module.basePlotModule);
	    }
	
	    var categoryObj = {};
	    for(var i = 0; i < categoriesIn.length; i++) {
	        categoryObj[categoriesIn[i]] = true;
	        exports.allCategories[categoriesIn[i]] = true;
	    }
	
	    exports.modules[thisType] = {
	        _module: _module,
	        categories: categoryObj
	    };
	
	    if(meta && Object.keys(meta).length) {
	        exports.modules[thisType].meta = meta;
	    }
	
	    exports.allTypes.push(thisType);
	
	    for(var componentName in exports.componentsRegistry) {
	        mergeComponentAttrsToTrace(componentName, thisType);
	    }
	
	    /*
	     * Collect all trace layout attributes in one place for easier lookup later
	     * but don't merge them into the base schema as it would confuse the docs
	     * (at least after https://github.com/plotly/documentation/issues/202 gets done!)
	     */
	    if(_module.layoutAttributes) {
	        extendFlat(exports.traceLayoutAttributes, _module.layoutAttributes);
	    }
	
	    var basePlotModule = _module.basePlotModule;
	    var bpmName = basePlotModule.name;
	
	    // add mapbox-gl CSS here to avoid console warning on instantiation
	    if(bpmName === 'mapbox') {
	        var styleRules = basePlotModule.constants.styleRules;
	        for(var k in styleRules) {
	            addStyleRule('.js-plotly-plot .plotly .mapboxgl-' + k, styleRules[k]);
	        }
	    }
	
	    // if `plotly-geo-assets.js` is not included,
	    // add `PlotlyGeoAssets` global to stash references to all fetched
	    // topojson / geojson data
	    if((bpmName === 'geo' || bpmName === 'mapbox') &&
	        (typeof window !== undefined && window.PlotlyGeoAssets === undefined)
	    ) {
	        window.PlotlyGeoAssets = {topojson: {}};
	    }
	}
	
	function registerSubplot(_module) {
	    var plotType = _module.name;
	
	    if(exports.subplotsRegistry[plotType]) {
	        Loggers.log('Plot type ' + plotType + ' already registered.');
	        return;
	    }
	
	    // relayout array handling will look for component module methods with this
	    // name and won't find them because this is a subplot module... but that
	    // should be fine, it will just fall back on redrawing the plot.
	    findArrayRegexps(_module);
	
	    // not sure what's best for the 'cartesian' type at this point
	    exports.subplotsRegistry[plotType] = _module;
	
	    for(var componentName in exports.componentsRegistry) {
	        mergeComponentAttrsToSubplot(componentName, _module.name);
	    }
	}
	
	function registerComponentModule(_module) {
	    if(typeof _module.name !== 'string') {
	        throw new Error('Component module *name* must be a string.');
	    }
	
	    var name = _module.name;
	    exports.componentsRegistry[name] = _module;
	
	    if(_module.layoutAttributes) {
	        if(_module.layoutAttributes._isLinkedToArray) {
	            pushUnique(exports.layoutArrayContainers, name);
	        }
	        findArrayRegexps(_module);
	    }
	
	    for(var traceType in exports.modules) {
	        mergeComponentAttrsToTrace(name, traceType);
	    }
	
	    for(var subplotName in exports.subplotsRegistry) {
	        mergeComponentAttrsToSubplot(name, subplotName);
	    }
	
	    for(var transformType in exports.transformsRegistry) {
	        mergeComponentAttrsToTransform(name, transformType);
	    }
	
	    if(_module.schema && _module.schema.layout) {
	        extendDeepAll(baseLayoutAttributes, _module.schema.layout);
	    }
	}
	
	function registerTransformModule(_module) {
	    if(typeof _module.name !== 'string') {
	        throw new Error('Transform module *name* must be a string.');
	    }
	
	    var prefix = 'Transform module ' + _module.name;
	    var hasTransform = typeof _module.transform === 'function';
	    var hasCalcTransform = typeof _module.calcTransform === 'function';
	
	    if(!hasTransform && !hasCalcTransform) {
	        throw new Error(prefix + ' is missing a *transform* or *calcTransform* method.');
	    }
	    if(hasTransform && hasCalcTransform) {
	        Loggers.log([
	            prefix + ' has both a *transform* and *calcTransform* methods.',
	            'Please note that all *transform* methods are executed',
	            'before all *calcTransform* methods.'
	        ].join(' '));
	    }
	    if(!isPlainObject(_module.attributes)) {
	        Loggers.log(prefix + ' registered without an *attributes* object.');
	    }
	    if(typeof _module.supplyDefaults !== 'function') {
	        Loggers.log(prefix + ' registered without a *supplyDefaults* method.');
	    }
	
	    exports.transformsRegistry[_module.name] = _module;
	
	    for(var componentName in exports.componentsRegistry) {
	        mergeComponentAttrsToTransform(componentName, _module.name);
	    }
	}
	
	function registerLocale(_module) {
	    var locale = _module.name;
	    var baseLocale = locale.split('-')[0];
	
	    var newDict = _module.dictionary;
	    var newFormat = _module.format;
	    var hasDict = newDict && Object.keys(newDict).length;
	    var hasFormat = newFormat && Object.keys(newFormat).length;
	
	    var locales = exports.localeRegistry;
	
	    var localeObj = locales[locale];
	    if(!localeObj) locales[locale] = localeObj = {};
	
	    // Should we use this dict for the base locale?
	    // In case we're overwriting a previous dict for this locale, check
	    // whether the base matches the full locale dict now. If we're not
	    // overwriting, locales[locale] is undefined so this just checks if
	    // baseLocale already had a dict or not.
	    // Same logic for dateFormats
	    if(baseLocale !== locale) {
	        var baseLocaleObj = locales[baseLocale];
	        if(!baseLocaleObj) locales[baseLocale] = baseLocaleObj = {};
	
	        if(hasDict && baseLocaleObj.dictionary === localeObj.dictionary) {
	            baseLocaleObj.dictionary = newDict;
	        }
	        if(hasFormat && baseLocaleObj.format === localeObj.format) {
	            baseLocaleObj.format = newFormat;
	        }
	    }
	
	    if(hasDict) localeObj.dictionary = newDict;
	    if(hasFormat) localeObj.format = newFormat;
	}
	
	function findArrayRegexps(_module) {
	    if(_module.layoutAttributes) {
	        var arrayAttrRegexps = _module.layoutAttributes._arrayAttrRegexps;
	        if(arrayAttrRegexps) {
	            for(var i = 0; i < arrayAttrRegexps.length; i++) {
	                pushUnique(exports.layoutArrayRegexes, arrayAttrRegexps[i]);
	            }
	        }
	    }
	}
	
	function mergeComponentAttrsToTrace(componentName, traceType) {
	    var componentSchema = exports.componentsRegistry[componentName].schema;
	    if(!componentSchema || !componentSchema.traces) return;
	
	    var traceAttrs = componentSchema.traces[traceType];
	    if(traceAttrs) {
	        extendDeepAll(exports.modules[traceType]._module.attributes, traceAttrs);
	    }
	}
	
	function mergeComponentAttrsToTransform(componentName, transformType) {
	    var componentSchema = exports.componentsRegistry[componentName].schema;
	    if(!componentSchema || !componentSchema.transforms) return;
	
	    var transformAttrs = componentSchema.transforms[transformType];
	    if(transformAttrs) {
	        extendDeepAll(exports.transformsRegistry[transformType].attributes, transformAttrs);
	    }
	}
	
	function mergeComponentAttrsToSubplot(componentName, subplotName) {
	    var componentSchema = exports.componentsRegistry[componentName].schema;
	    if(!componentSchema || !componentSchema.subplots) return;
	
	    var subplotModule = exports.subplotsRegistry[subplotName];
	    var subplotAttrs = subplotModule.layoutAttributes;
	    var subplotAttr = subplotModule.attr === 'subplot' ? subplotModule.name : subplotModule.attr;
	    if(Array.isArray(subplotAttr)) subplotAttr = subplotAttr[0];
	
	    var componentLayoutAttrs = componentSchema.subplots[subplotAttr];
	    if(subplotAttrs && componentLayoutAttrs) {
	        extendDeepAll(subplotAttrs, componentLayoutAttrs);
	    }
	}
	
	function getTraceType(traceType) {
	    if(typeof traceType === 'object') traceType = traceType.type;
	    return traceType;
	}
	
	},{"./lib/dom":705,"./lib/extend":707,"./lib/is_plain_object":717,"./lib/loggers":720,"./lib/noop":725,"./lib/push_unique":730,"./plots/attributes":761,"./plots/layout_attributes":816}],846:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	var Lib = _dereq_('../lib');
	
	var extendFlat = Lib.extendFlat;
	var extendDeep = Lib.extendDeep;
	
	// Put default plotTile layouts here
	function cloneLayoutOverride(tileClass) {
	    var override;
	
	    switch(tileClass) {
	        case 'themes__thumb':
	            override = {
	                autosize: true,
	                width: 150,
	                height: 150,
	                title: {text: ''},
	                showlegend: false,
	                margin: {l: 5, r: 5, t: 5, b: 5, pad: 0},
	                annotations: []
	            };
	            break;
	
	        case 'thumbnail':
	            override = {
	                title: {text: ''},
	                hidesources: true,
	                showlegend: false,
	                borderwidth: 0,
	                bordercolor: '',
	                margin: {l: 1, r: 1, t: 1, b: 1, pad: 0},
	                annotations: []
	            };
	            break;
	
	        default:
	            override = {};
	    }
	
	
	    return override;
	}
	
	function keyIsAxis(keyName) {
	    var types = ['xaxis', 'yaxis', 'zaxis'];
	    return (types.indexOf(keyName.slice(0, 5)) > -1);
	}
	
	
	module.exports = function clonePlot(graphObj, options) {
	    // Polar plot compatibility
	    if(graphObj.framework && graphObj.framework.isPolar) {
	        graphObj = graphObj.framework.getConfig();
	    }
	
	    var i;
	    var oldData = graphObj.data;
	    var oldLayout = graphObj.layout;
	    var newData = extendDeep([], oldData);
	    var newLayout = extendDeep({}, oldLayout, cloneLayoutOverride(options.tileClass));
	    var context = graphObj._context || {};
	
	    if(options.width) newLayout.width = options.width;
	    if(options.height) newLayout.height = options.height;
	
	    if(options.tileClass === 'thumbnail' || options.tileClass === 'themes__thumb') {
	        // kill annotations
	        newLayout.annotations = [];
	        var keys = Object.keys(newLayout);
	
	        for(i = 0; i < keys.length; i++) {
	            if(keyIsAxis(keys[i])) {
	                newLayout[keys[i]].title = {text: ''};
	            }
	        }
	
	        // kill colorbar and pie labels
	        for(i = 0; i < newData.length; i++) {
	            var trace = newData[i];
	            trace.showscale = false;
	            if(trace.marker) trace.marker.showscale = false;
	            if(Registry.traceIs(trace, 'pie-like')) trace.textposition = 'none';
	        }
	    }
	
	    if(Array.isArray(options.annotations)) {
	        for(i = 0; i < options.annotations.length; i++) {
	            newLayout.annotations.push(options.annotations[i]);
	        }
	    }
	
	    // TODO: does this scene modification really belong here?
	    // If we still need it, can it move into the gl3d module?
	    var sceneIds = Object.keys(newLayout).filter(function(key) {
	        return key.match(/^scene\d*$/);
	    });
	    if(sceneIds.length) {
	        var axesImageOverride = {};
	        if(options.tileClass === 'thumbnail') {
	            axesImageOverride = {
	                title: {text: ''},
	                showaxeslabels: false,
	                showticklabels: false,
	                linetickenable: false
	            };
	        }
	        for(i = 0; i < sceneIds.length; i++) {
	            var scene = newLayout[sceneIds[i]];
	
	            if(!scene.xaxis) {
	                scene.xaxis = {};
	            }
	
	            if(!scene.yaxis) {
	                scene.yaxis = {};
	            }
	
	            if(!scene.zaxis) {
	                scene.zaxis = {};
	            }
	
	            extendFlat(scene.xaxis, axesImageOverride);
	            extendFlat(scene.yaxis, axesImageOverride);
	            extendFlat(scene.zaxis, axesImageOverride);
	
	            // TODO what does this do?
	            scene._scene = null;
	        }
	    }
	
	    var gd = document.createElement('div');
	    if(options.tileClass) gd.className = options.tileClass;
	
	    var plotTile = {
	        gd: gd,
	        td: gd, // for external (image server) compatibility
	        layout: newLayout,
	        data: newData,
	        config: {
	            staticPlot: (options.staticPlot === undefined) ?
	                true :
	                options.staticPlot,
	            plotGlPixelRatio: (options.plotGlPixelRatio === undefined) ?
	                2 :
	                options.plotGlPixelRatio,
	            displaylogo: options.displaylogo || false,
	            showLink: options.showLink || false,
	            showTips: options.showTips || false,
	            mapboxAccessToken: context.mapboxAccessToken
	        }
	    };
	
	    if(options.setBackground !== 'transparent') {
	        plotTile.config.setBackground = options.setBackground || 'opaque';
	    }
	
	    // attaching the default Layout the gd, so you can grab it later
	    plotTile.gd.defaultLayout = cloneLayoutOverride(options.tileClass);
	
	    return plotTile;
	};
	
	},{"../lib":716,"../registry":845}],847:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	
	var toImage = _dereq_('../plot_api/to_image');
	
	var fileSaver = _dereq_('./filesaver');
	var helpers = _dereq_('./helpers');
	
	/**
	 * Plotly.downloadImage
	 *
	 * @param {object | string | HTML div} gd
	 *   can either be a data/layout/config object
	 *   or an existing graph <div>
	 *   or an id to an existing graph <div>
	 * @param {object} opts (see Plotly.toImage in ../plot_api/to_image)
	 * @return {promise}
	 */
	function downloadImage(gd, opts) {
	    var _gd;
	    if(!Lib.isPlainObject(gd)) _gd = Lib.getGraphDiv(gd);
	
	    opts = opts || {};
	    opts.format = opts.format || 'png';
	    opts.imageDataOnly = true;
	
	    return new Promise(function(resolve, reject) {
	        if(_gd && _gd._snapshotInProgress) {
	            reject(new Error('Snapshotting already in progress.'));
	        }
	
	        // see comments within svgtoimg for additional
	        //   discussion of problems with IE
	        //   can now draw to canvas, but CORS tainted canvas
	        //   does not allow toDataURL
	        //   svg format will work though
	        if(Lib.isIE() && opts.format !== 'svg') {
	            reject(new Error(helpers.MSG_IE_BAD_FORMAT));
	        }
	
	        if(_gd) _gd._snapshotInProgress = true;
	        var promise = toImage(gd, opts);
	
	        var filename = opts.filename || gd.fn || 'newplot';
	        filename += '.' + opts.format;
	
	        promise.then(function(result) {
	            if(_gd) _gd._snapshotInProgress = false;
	            return fileSaver(result, filename, opts.format);
	        }).then(function(name) {
	            resolve(name);
	        }).catch(function(err) {
	            if(_gd) _gd._snapshotInProgress = false;
	            reject(err);
	        });
	    });
	}
	
	module.exports = downloadImage;
	
	},{"../lib":716,"../plot_api/to_image":757,"./filesaver":848,"./helpers":849}],848:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var helpers = _dereq_('./helpers');
	
	/*
	* substantial portions of this code from FileSaver.js
	* https://github.com/eligrey/FileSaver.js
	* License: https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	* FileSaver.js
	* A saveAs() FileSaver implementation.
	* 1.1.20160328
	*
	* By Eli Grey, http://eligrey.com
	* License: MIT
	*   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	*/
	function fileSaver(url, name, format) {
	    var saveLink = document.createElement('a');
	    var canUseSaveLink = 'download' in saveLink;
	
	    var promise = new Promise(function(resolve, reject) {
	        var blob;
	        var objectUrl;
	
	        if(Lib.isIE9orBelow()) {
	            reject(new Error('IE < 10 unsupported'));
	        }
	
	        // Safari doesn't allow downloading of blob urls
	        if(Lib.isSafari()) {
	            var prefix = format === 'svg' ? ',' : ';base64,';
	            helpers.octetStream(prefix + encodeURIComponent(url));
	            return resolve(name);
	        }
	
	        // IE 10+ (native saveAs)
	        if(Lib.isIE()) {
	            // At this point we are only dealing with a decoded SVG as
	            // a data URL (since IE only supports SVG)
	            blob = helpers.createBlob(url, 'svg');
	            window.navigator.msSaveBlob(blob, name);
	            blob = null;
	            return resolve(name);
	        }
	
	        if(canUseSaveLink) {
	            blob = helpers.createBlob(url, format);
	            objectUrl = helpers.createObjectURL(blob);
	
	            saveLink.href = objectUrl;
	            saveLink.download = name;
	            document.body.appendChild(saveLink);
	            saveLink.click();
	
	            document.body.removeChild(saveLink);
	            helpers.revokeObjectURL(objectUrl);
	            blob = null;
	
	            return resolve(name);
	        }
	
	        reject(new Error('download error'));
	    });
	
	    return promise;
	}
	
	
	module.exports = fileSaver;
	
	},{"../lib":716,"./helpers":849}],849:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../registry');
	
	exports.getDelay = function(fullLayout) {
	    if(!fullLayout._has) return 0;
	
	    return (
	        fullLayout._has('gl3d') ||
	        fullLayout._has('gl2d') ||
	        fullLayout._has('mapbox')
	    ) ? 500 : 0;
	};
	
	exports.getRedrawFunc = function(gd) {
	    return function() {
	        var fullLayout = gd._fullLayout || {};
	        var hasPolar = fullLayout._has && fullLayout._has('polar');
	        var hasLegacyPolar = !hasPolar && gd.data && gd.data[0] && gd.data[0].r;
	
	        if(!hasLegacyPolar) {
	            Registry.getComponentMethod('colorbar', 'draw')(gd);
	        }
	    };
	};
	
	exports.encodeSVG = function(svg) {
	    return 'data:image/svg+xml,' + encodeURIComponent(svg);
	};
	
	var DOM_URL = window.URL || window.webkitURL;
	
	exports.createObjectURL = function(blob) {
	    return DOM_URL.createObjectURL(blob);
	};
	
	exports.revokeObjectURL = function(url) {
	    return DOM_URL.revokeObjectURL(url);
	};
	
	exports.createBlob = function(url, format) {
	    if(format === 'svg') {
	        return new window.Blob([url], {type: 'image/svg+xml;charset=utf-8'});
	    } else {
	        var binary = fixBinary(window.atob(url));
	        return new window.Blob([binary], {type: 'image/' + format});
	    }
	};
	
	exports.octetStream = function(s) {
	    document.location.href = 'data:application/octet-stream' + s;
	};
	
	// Taken from https://bl.ocks.org/nolanlawson/0eac306e4dac2114c752
	function fixBinary(b) {
	    var len = b.length;
	    var buf = new ArrayBuffer(len);
	    var arr = new Uint8Array(buf);
	    for(var i = 0; i < len; i++) {
	        arr[i] = b.charCodeAt(i);
	    }
	    return buf;
	}
	
	exports.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
	
	exports.MSG_IE_BAD_FORMAT = 'Sorry IE does not support downloading from canvas. Try {format:\'svg\'} instead.';
	
	},{"../registry":845}],850:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var helpers = _dereq_('./helpers');
	
	var Snapshot = {
	    getDelay: helpers.getDelay,
	    getRedrawFunc: helpers.getRedrawFunc,
	    clone: _dereq_('./cloneplot'),
	    toSVG: _dereq_('./tosvg'),
	    svgToImg: _dereq_('./svgtoimg'),
	    toImage: _dereq_('./toimage'),
	    downloadImage: _dereq_('./download')
	};
	
	module.exports = Snapshot;
	
	},{"./cloneplot":846,"./download":847,"./helpers":849,"./svgtoimg":851,"./toimage":852,"./tosvg":853}],851:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var EventEmitter = _dereq_('events').EventEmitter;
	
	var helpers = _dereq_('./helpers');
	
	function svgToImg(opts) {
	    var ev = opts.emitter || new EventEmitter();
	
	    var promise = new Promise(function(resolve, reject) {
	        var Image = window.Image;
	        var svg = opts.svg;
	        var format = opts.format || 'png';
	
	        // IE only support svg
	        if(Lib.isIE() && format !== 'svg') {
	            var ieSvgError = new Error(helpers.MSG_IE_BAD_FORMAT);
	            reject(ieSvgError);
	            // eventually remove the ev
	            //  in favor of promises
	            if(!opts.promise) {
	                return ev.emit('error', ieSvgError);
	            } else {
	                return promise;
	            }
	        }
	
	        var canvas = opts.canvas;
	        var scale = opts.scale || 1;
	        var w0 = opts.width || 300;
	        var h0 = opts.height || 150;
	        var w1 = scale * w0;
	        var h1 = scale * h0;
	
	        var ctx = canvas.getContext('2d');
	        var img = new Image();
	        var svgBlob, url;
	
	        if(format === 'svg' || Lib.isIE9orBelow() || Lib.isSafari()) {
	            url = helpers.encodeSVG(svg);
	        } else {
	            svgBlob = helpers.createBlob(svg, 'svg');
	            url = helpers.createObjectURL(svgBlob);
	        }
	
	        canvas.width = w1;
	        canvas.height = h1;
	
	        img.onload = function() {
	            var imgData;
	
	            svgBlob = null;
	            helpers.revokeObjectURL(url);
	
	            // don't need to draw to canvas if svg
	            //  save some time and also avoid failure on IE
	            if(format !== 'svg') {
	                ctx.drawImage(img, 0, 0, w1, h1);
	            }
	
	            switch(format) {
	                case 'jpeg':
	                    imgData = canvas.toDataURL('image/jpeg');
	                    break;
	                case 'png':
	                    imgData = canvas.toDataURL('image/png');
	                    break;
	                case 'webp':
	                    imgData = canvas.toDataURL('image/webp');
	                    break;
	                case 'svg':
	                    imgData = url;
	                    break;
	                default:
	                    var errorMsg = 'Image format is not jpeg, png, svg or webp.';
	                    reject(new Error(errorMsg));
	                    // eventually remove the ev
	                    //  in favor of promises
	                    if(!opts.promise) {
	                        return ev.emit('error', errorMsg);
	                    }
	            }
	            resolve(imgData);
	            // eventually remove the ev
	            //  in favor of promises
	            if(!opts.promise) {
	                ev.emit('success', imgData);
	            }
	        };
	
	        img.onerror = function(err) {
	            svgBlob = null;
	            helpers.revokeObjectURL(url);
	
	            reject(err);
	            // eventually remove the ev
	            //  in favor of promises
	            if(!opts.promise) {
	                return ev.emit('error', err);
	            }
	        };
	
	        img.src = url;
	    });
	
	    // temporary for backward compatibility
	    //  move to only Promise in 2.0.0
	    //  and eliminate the EventEmitter
	    if(opts.promise) {
	        return promise;
	    }
	
	    return ev;
	}
	
	module.exports = svgToImg;
	
	},{"../lib":716,"./helpers":849,"events":105}],852:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var EventEmitter = _dereq_('events').EventEmitter;
	
	var Registry = _dereq_('../registry');
	var Lib = _dereq_('../lib');
	
	var helpers = _dereq_('./helpers');
	var clonePlot = _dereq_('./cloneplot');
	var toSVG = _dereq_('./tosvg');
	var svgToImg = _dereq_('./svgtoimg');
	
	/**
	 * @param {object} gd figure Object
	 * @param {object} opts option object
	 * @param opts.format 'jpeg' | 'png' | 'webp' | 'svg'
	 */
	function toImage(gd, opts) {
	    // first clone the GD so we can operate in a clean environment
	    var ev = new EventEmitter();
	
	    var clone = clonePlot(gd, {format: 'png'});
	    var clonedGd = clone.gd;
	
	    // put the cloned div somewhere off screen before attaching to DOM
	    clonedGd.style.position = 'absolute';
	    clonedGd.style.left = '-5000px';
	    document.body.appendChild(clonedGd);
	
	    function wait() {
	        var delay = helpers.getDelay(clonedGd._fullLayout);
	
	        setTimeout(function() {
	            var svg = toSVG(clonedGd);
	
	            var canvas = document.createElement('canvas');
	            canvas.id = Lib.randstr();
	
	            ev = svgToImg({
	                format: opts.format,
	                width: clonedGd._fullLayout.width,
	                height: clonedGd._fullLayout.height,
	                canvas: canvas,
	                emitter: ev,
	                svg: svg
	            });
	
	            ev.clean = function() {
	                if(clonedGd) document.body.removeChild(clonedGd);
	            };
	        }, delay);
	    }
	
	    var redrawFunc = helpers.getRedrawFunc(clonedGd);
	
	    Registry.call('plot', clonedGd, clone.data, clone.layout, clone.config)
	        .then(redrawFunc)
	        .then(wait)
	        .catch(function(err) {
	            ev.emit('error', err);
	        });
	
	
	    return ev;
	}
	
	module.exports = toImage;
	
	},{"../lib":716,"../registry":845,"./cloneplot":846,"./helpers":849,"./svgtoimg":851,"./tosvg":853,"events":105}],853:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../lib');
	var Drawing = _dereq_('../components/drawing');
	var Color = _dereq_('../components/color');
	
	var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
	var DOUBLEQUOTE_REGEX = /"/g;
	var DUMMY_SUB = 'TOBESTRIPPED';
	var DUMMY_REGEX = new RegExp('("' + DUMMY_SUB + ')|(' + DUMMY_SUB + '")', 'g');
	
	function htmlEntityDecode(s) {
	    var hiddenDiv = d3.select('body').append('div').style({display: 'none'}).html('');
	    var replaced = s.replace(/(&[^;]*;)/gi, function(d) {
	        if(d === '&lt;') { return '&#60;'; } // special handling for brackets
	        if(d === '&rt;') { return '&#62;'; }
	        if(d.indexOf('<') !== -1 || d.indexOf('>') !== -1) { return ''; }
	        return hiddenDiv.html(d).text(); // everything else, let the browser decode it to unicode
	    });
	    hiddenDiv.remove();
	    return replaced;
	}
	
	function xmlEntityEncode(str) {
	    return str.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, '&amp;');
	}
	
	module.exports = function toSVG(gd, format, scale) {
	    var fullLayout = gd._fullLayout;
	    var svg = fullLayout._paper;
	    var toppaper = fullLayout._toppaper;
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	    var i;
	
	    // make background color a rect in the svg, then revert after scraping
	    // all other alterations have been dealt with by properly preparing the svg
	    // in the first place... like setting cursors with css classes so we don't
	    // have to remove them, and providing the right namespaces in the svg to
	    // begin with
	    svg.insert('rect', ':first-child')
	        .call(Drawing.setRect, 0, 0, width, height)
	        .call(Color.fill, fullLayout.paper_bgcolor);
	
	    // subplot-specific to-SVG methods
	    // which notably add the contents of the gl-container
	    // into the main svg node
	    var basePlotModules = fullLayout._basePlotModules || [];
	    for(i = 0; i < basePlotModules.length; i++) {
	        var _module = basePlotModules[i];
	
	        if(_module.toSVG) _module.toSVG(gd);
	    }
	
	    // add top items above them assumes everything in toppaper is either
	    // a group or a defs, and if it's empty (like hoverlayer) we can ignore it.
	    if(toppaper) {
	        var nodes = toppaper.node().childNodes;
	
	        // make copy of nodes as childNodes prop gets mutated in loop below
	        var topGroups = Array.prototype.slice.call(nodes);
	
	        for(i = 0; i < topGroups.length; i++) {
	            var topGroup = topGroups[i];
	
	            if(topGroup.childNodes.length) svg.node().appendChild(topGroup);
	        }
	    }
	
	    // remove draglayer for Adobe Illustrator compatibility
	    if(fullLayout._draggers) {
	        fullLayout._draggers.remove();
	    }
	
	    // in case the svg element had an explicit background color, remove this
	    // we want the rect to get the color so it's the right size; svg bg will
	    // fill whatever container it's displayed in regardless of plot size.
	    svg.node().style.background = '';
	
	    svg.selectAll('text')
	        .attr({'data-unformatted': null, 'data-math': null})
	        .each(function() {
	            var txt = d3.select(this);
	
	            // hidden text is pre-formatting mathjax, the browser ignores it
	            // but in a static plot it's useless and it can confuse batik
	            // we've tried to standardize on display:none but make sure we still
	            // catch visibility:hidden if it ever arises
	            if(this.style.visibility === 'hidden' || this.style.display === 'none') {
	                txt.remove();
	                return;
	            } else {
	                // clear other visibility/display values to default
	                // to not potentially confuse non-browser SVG implementations
	                txt.style({visibility: null, display: null});
	            }
	
	            // Font family styles break things because of quotation marks,
	            // so we must remove them *after* the SVG DOM has been serialized
	            // to a string (browsers convert singles back)
	            var ff = this.style.fontFamily;
	            if(ff && ff.indexOf('"') !== -1) {
	                txt.style('font-family', ff.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	            }
	        });
	
	    svg.selectAll('.point, .scatterpts, .legendfill>path, .legendlines>path, .cbfill').each(function() {
	        var pt = d3.select(this);
	
	        // similar to font family styles above,
	        // we must remove " after the SVG DOM has been serialized
	        var fill = this.style.fill;
	        if(fill && fill.indexOf('url(') !== -1) {
	            pt.style('fill', fill.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	        }
	
	        var stroke = this.style.stroke;
	        if(stroke && stroke.indexOf('url(') !== -1) {
	            pt.style('stroke', stroke.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	        }
	    });
	
	    if(format === 'pdf' || format === 'eps') {
	        // these formats make the extra line MathJax adds around symbols look super thick in some cases
	        // it looks better if this is removed entirely.
	        svg.selectAll('#MathJax_SVG_glyphs path')
	            .attr('stroke-width', 0);
	    }
	
	    // fix for IE namespacing quirk?
	    // http://stackoverflow.com/questions/19610089/unwanted-namespaces-on-svg-markup-when-using-xmlserializer-in-javascript-with-ie
	    svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns', xmlnsNamespaces.svg);
	    svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns:xlink', xmlnsNamespaces.xlink);
	
	    if(format === 'svg' && scale) {
	        svg.attr('width', scale * width);
	        svg.attr('height', scale * height);
	        svg.attr('viewBox', '0 0 ' + width + ' ' + height);
	    }
	
	    var s = new window.XMLSerializer().serializeToString(svg.node());
	    s = htmlEntityDecode(s);
	    s = xmlEntityEncode(s);
	
	    // Fix quotations around font strings and gradient URLs
	    s = s.replace(DUMMY_REGEX, '\'');
	
	    // IE is very strict, so we will need to clean
	    //  svg with the following regex
	    //  yes this is messy, but do not know a better way
	    // Even with this IE will not work due to tainted canvas
	    //  see https://github.com/kangax/fabric.js/issues/1957
	    //      http://stackoverflow.com/questions/18112047/canvas-todataurl-working-in-all-browsers-except-ie10
	    // Leave here just in case the CORS/tainted IE issue gets resolved
	    if(Lib.isIE()) {
	        // replace double quote with single quote
	        s = s.replace(/"/gi, '\'');
	        // url in svg are single quoted
	        //   since we changed double to single
	        //   we'll need to change these to double-quoted
	        s = s.replace(/(\('#)([^']*)('\))/gi, '(\"#$2\")');
	        // font names with spaces will be escaped single-quoted
	        //   we'll need to change these to double-quoted
	        s = s.replace(/(\\')/gi, '\"');
	    }
	
	    return s;
	};
	
	},{"../components/color":591,"../components/drawing":612,"../constants/xmlns_namespaces":693,"../lib":716,"d3":164}],854:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// arrayOk attributes, merge them into calcdata array
	module.exports = function arraysToCalcdata(cd, trace) {
	    for(var i = 0; i < cd.length; i++) cd[i].i = i;
	
	    Lib.mergeArray(trace.text, cd, 'tx');
	    Lib.mergeArray(trace.hovertext, cd, 'htx');
	
	    var marker = trace.marker;
	    if(marker) {
	        Lib.mergeArray(marker.opacity, cd, 'mo', true);
	        Lib.mergeArray(marker.color, cd, 'mc');
	
	        var markerLine = marker.line;
	        if(markerLine) {
	            Lib.mergeArray(markerLine.color, cd, 'mlc');
	            Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
	        }
	    }
	};
	
	},{"../../lib":716}],855:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var constants = _dereq_('./constants');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var textFontAttrs = fontAttrs({
	    editType: 'calc',
	    arrayOk: true,
	    colorEditType: 'style',
	    
	});
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	var markerLineWidth = extendFlat({},
	    scatterMarkerLineAttrs.width, { dflt: 0 });
	
	var markerLine = extendFlat({
	    width: markerLineWidth,
	    editType: 'calc'
	}, colorScaleAttrs('marker.line'));
	
	var marker = extendFlat({
	    line: markerLine,
	    editType: 'calc'
	}, colorScaleAttrs('marker'), {
	    opacity: {
	        valType: 'number',
	        arrayOk: true,
	        dflt: 1,
	        min: 0,
	        max: 1,
	        
	        editType: 'style',
	        
	    }
	});
	
	module.exports = {
	    x: scatterAttrs.x,
	    x0: scatterAttrs.x0,
	    dx: scatterAttrs.dx,
	    y: scatterAttrs.y,
	    y0: scatterAttrs.y0,
	    dy: scatterAttrs.dy,
	
	    text: scatterAttrs.text,
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: constants.eventDataKeys
	    }),
	    hovertext: scatterAttrs.hovertext,
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    textposition: {
	        valType: 'enumerated',
	        
	        values: ['inside', 'outside', 'auto', 'none'],
	        dflt: 'none',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	
	    insidetextanchor: {
	        valType: 'enumerated',
	        values: ['end', 'middle', 'start'],
	        dflt: 'end',
	        
	        editType: 'plot',
	        
	    },
	
	    textangle: {
	        valType: 'angle',
	        dflt: 'auto',
	        
	        editType: 'plot',
	        
	    },
	
	    textfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	
	    insidetextfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	
	    outsidetextfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	
	    constraintext: {
	        valType: 'enumerated',
	        values: ['inside', 'outside', 'both', 'none'],
	        
	        dflt: 'both',
	        editType: 'calc',
	        
	    },
	
	    cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
	        
	    }),
	
	    orientation: {
	        valType: 'enumerated',
	        
	        values: ['v', 'h'],
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    base: {
	        valType: 'any',
	        dflt: null,
	        arrayOk: true,
	        
	        editType: 'calc',
	        
	    },
	
	    offset: {
	        valType: 'number',
	        dflt: null,
	        arrayOk: true,
	        
	        editType: 'calc',
	        
	    },
	
	    width: {
	        valType: 'number',
	        dflt: null,
	        min: 0,
	        arrayOk: true,
	        
	        editType: 'calc',
	        
	    },
	
	    marker: marker,
	
	    offsetgroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	    alignmentgroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	
	    selected: {
	        marker: {
	            opacity: scatterAttrs.selected.marker.opacity,
	            color: scatterAttrs.selected.marker.color,
	            editType: 'style'
	        },
	        textfont: scatterAttrs.selected.textfont,
	        editType: 'style'
	    },
	    unselected: {
	        marker: {
	            opacity: scatterAttrs.unselected.marker.opacity,
	            color: scatterAttrs.unselected.marker.color,
	            editType: 'style'
	        },
	        textfont: scatterAttrs.unselected.textfont,
	        editType: 'style'
	    },
	
	    r: scatterAttrs.r,
	    t: scatterAttrs.t,
	
	    _deprecated: {
	        bardir: {
	            valType: 'enumerated',
	            
	            editType: 'calc',
	            values: ['v', 'h'],
	            
	        }
	    }
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/font_attributes":790,"../../plots/template_attributes":840,"../scatter/attributes":1118,"./constants":857}],856:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var size, pos;
	
	    if(trace.orientation === 'h') {
	        size = xa.makeCalcdata(trace, 'x');
	        pos = ya.makeCalcdata(trace, 'y');
	    } else {
	        size = ya.makeCalcdata(trace, 'y');
	        pos = xa.makeCalcdata(trace, 'x');
	    }
	
	    // create the "calculated data" to plot
	    var serieslen = Math.min(pos.length, size.length);
	    var cd = new Array(serieslen);
	
	    // set position and size
	    for(var i = 0; i < serieslen; i++) {
	        cd[i] = { p: pos[i], s: size[i] };
	
	        if(trace.ids) {
	            cd[i].id = String(trace.ids[i]);
	        }
	    }
	
	    // auto-z and autocolorscale if applicable
	    if(hasColorscale(trace, 'marker')) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.marker.color,
	            containerStr: 'marker',
	            cLetter: 'c'
	        });
	    }
	    if(hasColorscale(trace, 'marker.line')) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.marker.line.color,
	            containerStr: 'marker.line',
	            cLetter: 'c'
	        });
	    }
	
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	},{"../../components/colorscale/calc":599,"../../components/colorscale/helpers":602,"../../plots/cartesian/axes":764,"../scatter/calc_selection":1120,"./arrays_to_calcdata":854}],857:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    // padding in pixels around text
	    TEXTPAD: 3,
	    // 'value' and 'label' are not really necessary for bar traces,
	    // but they were made available to `texttemplate` (maybe by accident)
	    // via tokens `%{value}` and `%{label}` starting in 1.50.0,
	    // so let's include them in the event data also.
	    eventDataKeys: ['value', 'label']
	};
	
	},{}],858:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
	var Sieve = _dereq_('./sieve.js');
	
	/*
	 * Bar chart stacking/grouping positioning and autoscaling calculations
	 * for each direction separately calculate the ranges and positions
	 * note that this handles histograms too
	 * now doing this one subplot at a time
	 */
	
	function crossTraceCalc(gd, plotinfo) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    var fullLayout = gd._fullLayout;
	    var fullTraces = gd._fullData;
	    var calcTraces = gd.calcdata;
	    var calcTracesHorz = [];
	    var calcTracesVert = [];
	
	    for(var i = 0; i < fullTraces.length; i++) {
	        var fullTrace = fullTraces[i];
	        if(
	            fullTrace.visible === true &&
	            Registry.traceIs(fullTrace, 'bar') &&
	            fullTrace.xaxis === xa._id &&
	            fullTrace.yaxis === ya._id
	        ) {
	            if(fullTrace.orientation === 'h') {
	                calcTracesHorz.push(calcTraces[i]);
	            } else {
	                calcTracesVert.push(calcTraces[i]);
	            }
	        }
	    }
	
	    var opts = {
	        mode: fullLayout.barmode,
	        norm: fullLayout.barnorm,
	        gap: fullLayout.bargap,
	        groupgap: fullLayout.bargroupgap
	    };
	
	    setGroupPositions(gd, xa, ya, calcTracesVert, opts);
	    setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
	}
	
	function setGroupPositions(gd, pa, sa, calcTraces, opts) {
	    if(!calcTraces.length) return;
	
	    var excluded;
	    var included;
	    var i, calcTrace, fullTrace;
	
	    initBase(sa, calcTraces);
	
	    switch(opts.mode) {
	        case 'overlay':
	            setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts);
	            break;
	
	        case 'group':
	            // exclude from the group those traces for which the user set an offset
	            excluded = [];
	            included = [];
	            for(i = 0; i < calcTraces.length; i++) {
	                calcTrace = calcTraces[i];
	                fullTrace = calcTrace[0].trace;
	
	                if(fullTrace.offset === undefined) included.push(calcTrace);
	                else excluded.push(calcTrace);
	            }
	
	            if(included.length) {
	                setGroupPositionsInGroupMode(gd, pa, sa, included, opts);
	            }
	            if(excluded.length) {
	                setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
	            }
	            break;
	
	        case 'stack':
	        case 'relative':
	            // exclude from the stack those traces for which the user set a base
	            excluded = [];
	            included = [];
	            for(i = 0; i < calcTraces.length; i++) {
	                calcTrace = calcTraces[i];
	                fullTrace = calcTrace[0].trace;
	
	                if(fullTrace.base === undefined) included.push(calcTrace);
	                else excluded.push(calcTrace);
	            }
	
	            if(included.length) {
	                setGroupPositionsInStackOrRelativeMode(gd, pa, sa, included, opts);
	            }
	            if(excluded.length) {
	                setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
	            }
	            break;
	    }
	
	    collectExtents(calcTraces, pa);
	}
	
	function initBase(sa, calcTraces) {
	    var i, j;
	
	    for(i = 0; i < calcTraces.length; i++) {
	        var cd = calcTraces[i];
	        var trace = cd[0].trace;
	        var base = (trace.type === 'funnel') ? trace._base : trace.base;
	        var b;
	
	        // not sure if it really makes sense to have dates for bar size data...
	        // ideally if we want to make gantt charts or something we'd treat
	        // the actual size (trace.x or y) as time delta but base as absolute
	        // time. But included here for completeness.
	        var scalendar = trace.orientation === 'h' ? trace.xcalendar : trace.ycalendar;
	
	        // 'base' on categorical axes makes no sense
	        var d2c = sa.type === 'category' || sa.type === 'multicategory' ?
	            function() { return null; } :
	            sa.d2c;
	
	        if(isArrayOrTypedArray(base)) {
	            for(j = 0; j < Math.min(base.length, cd.length); j++) {
	                b = d2c(base[j], 0, scalendar);
	                if(isNumeric(b)) {
	                    cd[j].b = +b;
	                    cd[j].hasB = 1;
	                } else cd[j].b = 0;
	            }
	            for(; j < cd.length; j++) {
	                cd[j].b = 0;
	            }
	        } else {
	            b = d2c(base, 0, scalendar);
	            var hasBase = isNumeric(b);
	            b = hasBase ? b : 0;
	            for(j = 0; j < cd.length; j++) {
	                cd[j].b = b;
	                if(hasBase) cd[j].hasB = 1;
	            }
	        }
	    }
	}
	
	function setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts) {
	    // update position axis and set bar offsets and widths
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	
	        var sieve = new Sieve([calcTrace], {
	            sepNegVal: false,
	            overlapNoMerge: !opts.norm
	        });
	
	        // set bar offsets and widths, and update position axis
	        setOffsetAndWidth(pa, sieve, opts);
	
	        // set bar bases and sizes, and update size axis
	        //
	        // (note that `setGroupPositionsInOverlayMode` handles the case barnorm
	        // is defined, because this function is also invoked for traces that
	        // can't be grouped or stacked)
	        if(opts.norm) {
	            sieveBars(sieve);
	            normalizeBars(sa, sieve, opts);
	        } else {
	            setBaseAndTop(sa, sieve);
	        }
	    }
	}
	
	function setGroupPositionsInGroupMode(gd, pa, sa, calcTraces, opts) {
	    var sieve = new Sieve(calcTraces, {
	        sepNegVal: false,
	        overlapNoMerge: !opts.norm
	    });
	
	    // set bar offsets and widths, and update position axis
	    setOffsetAndWidthInGroupMode(gd, pa, sieve, opts);
	
	    // relative-stack bars within the same trace that would otherwise
	    // be hidden
	    unhideBarsWithinTrace(sieve);
	
	    // set bar bases and sizes, and update size axis
	    if(opts.norm) {
	        sieveBars(sieve);
	        normalizeBars(sa, sieve, opts);
	    } else {
	        setBaseAndTop(sa, sieve);
	    }
	}
	
	function setGroupPositionsInStackOrRelativeMode(gd, pa, sa, calcTraces, opts) {
	    var sieve = new Sieve(calcTraces, {
	        sepNegVal: opts.mode === 'relative',
	        overlapNoMerge: !(opts.norm || opts.mode === 'stack' || opts.mode === 'relative')
	    });
	
	    // set bar offsets and widths, and update position axis
	    setOffsetAndWidth(pa, sieve, opts);
	
	    // set bar bases and sizes, and update size axis
	    stackBars(sa, sieve, opts);
	
	    // flag the outmost bar (for text display purposes)
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	
	        for(var j = 0; j < calcTrace.length; j++) {
	            var bar = calcTrace[j];
	
	            if(bar.s !== BADNUM) {
	                var isOutmostBar = ((bar.b + bar.s) === sieve.get(bar.p, bar.s));
	                if(isOutmostBar) bar._outmost = true;
	            }
	        }
	    }
	
	    // Note that marking the outmost bars has to be done
	    // before `normalizeBars` changes `bar.b` and `bar.s`.
	    if(opts.norm) normalizeBars(sa, sieve, opts);
	}
	
	function setOffsetAndWidth(pa, sieve, opts) {
	    var minDiff = sieve.minDiff;
	    var calcTraces = sieve.traces;
	
	    // set bar offsets and widths
	    var barGroupWidth = minDiff * (1 - opts.gap);
	    var barWidthPlusGap = barGroupWidth;
	    var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
	
	    // computer bar group center and bar offset
	    var offsetFromCenter = -barWidth / 2;
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var t = calcTrace[0].t;
	
	        // store bar width and offset for this trace
	        t.barwidth = barWidth;
	        t.poffset = offsetFromCenter;
	        t.bargroupwidth = barGroupWidth;
	        t.bardelta = minDiff;
	    }
	
	    // stack bars that only differ by rounding
	    sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
	
	    // if defined, apply trace offset and width
	    applyAttributes(sieve);
	
	    // store the bar center in each calcdata item
	    setBarCenterAndWidth(pa, sieve);
	
	    // update position axes
	    updatePositionAxis(pa, sieve);
	}
	
	function setOffsetAndWidthInGroupMode(gd, pa, sieve, opts) {
	    var fullLayout = gd._fullLayout;
	    var positions = sieve.positions;
	    var distinctPositions = sieve.distinctPositions;
	    var minDiff = sieve.minDiff;
	    var calcTraces = sieve.traces;
	    var nTraces = calcTraces.length;
	
	    // if there aren't any overlapping positions,
	    // let them have full width even if mode is group
	    var overlap = (positions.length !== distinctPositions.length);
	    var barGroupWidth = minDiff * (1 - opts.gap);
	
	    var groupId = getAxisGroup(fullLayout, pa._id) + calcTraces[0][0].trace.orientation;
	    var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
	
	    for(var i = 0; i < nTraces; i++) {
	        var calcTrace = calcTraces[i];
	        var trace = calcTrace[0].trace;
	
	        var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
	        var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
	
	        var barWidthPlusGap;
	        if(nOffsetGroups) {
	            barWidthPlusGap = barGroupWidth / nOffsetGroups;
	        } else {
	            barWidthPlusGap = overlap ? barGroupWidth / nTraces : barGroupWidth;
	        }
	
	        var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
	
	        var offsetFromCenter;
	        if(nOffsetGroups) {
	            offsetFromCenter = ((2 * trace._offsetIndex + 1 - nOffsetGroups) * barWidthPlusGap - barWidth) / 2;
	        } else {
	            offsetFromCenter = overlap ?
	                ((2 * i + 1 - nTraces) * barWidthPlusGap - barWidth) / 2 :
	                -barWidth / 2;
	        }
	
	        var t = calcTrace[0].t;
	        t.barwidth = barWidth;
	        t.poffset = offsetFromCenter;
	        t.bargroupwidth = barGroupWidth;
	        t.bardelta = minDiff;
	    }
	
	    // stack bars that only differ by rounding
	    sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
	
	    // if defined, apply trace width
	    applyAttributes(sieve);
	
	    // store the bar center in each calcdata item
	    setBarCenterAndWidth(pa, sieve);
	
	    // update position axes
	    updatePositionAxis(pa, sieve, overlap);
	}
	
	function applyAttributes(sieve) {
	    var calcTraces = sieve.traces;
	    var i, j;
	
	    for(i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var calcTrace0 = calcTrace[0];
	        var fullTrace = calcTrace0.trace;
	        var t = calcTrace0.t;
	        var offset = fullTrace._offset || fullTrace.offset;
	        var initialPoffset = t.poffset;
	        var newPoffset;
	
	        if(isArrayOrTypedArray(offset)) {
	            // if offset is an array, then clone it into t.poffset.
	            newPoffset = Array.prototype.slice.call(offset, 0, calcTrace.length);
	
	            // guard against non-numeric items
	            for(j = 0; j < newPoffset.length; j++) {
	                if(!isNumeric(newPoffset[j])) {
	                    newPoffset[j] = initialPoffset;
	                }
	            }
	
	            // if the length of the array is too short,
	            // then extend it with the initial value of t.poffset
	            for(j = newPoffset.length; j < calcTrace.length; j++) {
	                newPoffset.push(initialPoffset);
	            }
	
	            t.poffset = newPoffset;
	        } else if(offset !== undefined) {
	            t.poffset = offset;
	        }
	
	        var width = fullTrace._width || fullTrace.width;
	        var initialBarwidth = t.barwidth;
	
	        if(isArrayOrTypedArray(width)) {
	            // if width is an array, then clone it into t.barwidth.
	            var newBarwidth = Array.prototype.slice.call(width, 0, calcTrace.length);
	
	            // guard against non-numeric items
	            for(j = 0; j < newBarwidth.length; j++) {
	                if(!isNumeric(newBarwidth[j])) newBarwidth[j] = initialBarwidth;
	            }
	
	            // if the length of the array is too short,
	            // then extend it with the initial value of t.barwidth
	            for(j = newBarwidth.length; j < calcTrace.length; j++) {
	                newBarwidth.push(initialBarwidth);
	            }
	
	            t.barwidth = newBarwidth;
	
	            // if user didn't set offset,
	            // then correct t.poffset to ensure bars remain centered
	            if(offset === undefined) {
	                newPoffset = [];
	                for(j = 0; j < calcTrace.length; j++) {
	                    newPoffset.push(
	                        initialPoffset + (initialBarwidth - newBarwidth[j]) / 2
	                    );
	                }
	                t.poffset = newPoffset;
	            }
	        } else if(width !== undefined) {
	            t.barwidth = width;
	
	            // if user didn't set offset,
	            // then correct t.poffset to ensure bars remain centered
	            if(offset === undefined) {
	                t.poffset = initialPoffset + (initialBarwidth - width) / 2;
	            }
	        }
	    }
	}
	
	function setBarCenterAndWidth(pa, sieve) {
	    var calcTraces = sieve.traces;
	    var pLetter = getAxisLetter(pa);
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var t = calcTrace[0].t;
	        var poffset = t.poffset;
	        var poffsetIsArray = Array.isArray(poffset);
	        var barwidth = t.barwidth;
	        var barwidthIsArray = Array.isArray(barwidth);
	
	        for(var j = 0; j < calcTrace.length; j++) {
	            var calcBar = calcTrace[j];
	
	            // store the actual bar width and position, for use by hover
	            var width = calcBar.w = barwidthIsArray ? barwidth[j] : barwidth;
	            calcBar[pLetter] = calcBar.p + (poffsetIsArray ? poffset[j] : poffset) + width / 2;
	        }
	    }
	}
	
	function updatePositionAxis(pa, sieve, allowMinDtick) {
	    var calcTraces = sieve.traces;
	    var minDiff = sieve.minDiff;
	    var vpad = minDiff / 2;
	
	    Axes.minDtick(pa, sieve.minDiff, sieve.distinctPositions[0], allowMinDtick);
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var calcTrace0 = calcTrace[0];
	        var fullTrace = calcTrace0.trace;
	        var pts = [];
	        var bar, l, r, j;
	
	        for(j = 0; j < calcTrace.length; j++) {
	            bar = calcTrace[j];
	            l = bar.p - vpad;
	            r = bar.p + vpad;
	            pts.push(l, r);
	        }
	
	        if(fullTrace.width || fullTrace.offset) {
	            var t = calcTrace0.t;
	            var poffset = t.poffset;
	            var barwidth = t.barwidth;
	            var poffsetIsArray = Array.isArray(poffset);
	            var barwidthIsArray = Array.isArray(barwidth);
	
	            for(j = 0; j < calcTrace.length; j++) {
	                bar = calcTrace[j];
	                var calcBarOffset = poffsetIsArray ? poffset[j] : poffset;
	                var calcBarWidth = barwidthIsArray ? barwidth[j] : barwidth;
	                l = bar.p + calcBarOffset;
	                r = l + calcBarWidth;
	                pts.push(l, r);
	            }
	        }
	
	        fullTrace._extremes[pa._id] = Axes.findExtremes(pa, pts, {padded: false});
	    }
	}
	
	// store these bar bases and tops in calcdata
	// and make sure the size axis includes zero,
	// along with the bases and tops of each bar.
	function setBaseAndTop(sa, sieve) {
	    var calcTraces = sieve.traces;
	    var sLetter = getAxisLetter(sa);
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var fullTrace = calcTrace[0].trace;
	        var pts = [];
	        var allBaseAboveZero = true;
	
	        for(var j = 0; j < calcTrace.length; j++) {
	            var bar = calcTrace[j];
	            var base = bar.b;
	            var top = base + bar.s;
	
	            bar[sLetter] = top;
	            pts.push(top);
	            if(bar.hasB) pts.push(base);
	
	            if(!bar.hasB || !(bar.b > 0 && bar.s > 0)) {
	                allBaseAboveZero = false;
	            }
	        }
	
	        fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	            tozero: !allBaseAboveZero,
	            padded: true
	        });
	    }
	}
	
	function stackBars(sa, sieve, opts) {
	    var sLetter = getAxisLetter(sa);
	    var calcTraces = sieve.traces;
	    var calcTrace;
	    var fullTrace;
	    var isFunnel;
	    var i, j;
	    var bar;
	
	    for(i = 0; i < calcTraces.length; i++) {
	        calcTrace = calcTraces[i];
	        fullTrace = calcTrace[0].trace;
	
	        if(fullTrace.type === 'funnel') {
	            for(j = 0; j < calcTrace.length; j++) {
	                bar = calcTrace[j];
	
	                if(bar.s !== BADNUM) {
	                    // create base of funnels
	                    sieve.put(bar.p, -0.5 * bar.s);
	                }
	            }
	        }
	    }
	
	    for(i = 0; i < calcTraces.length; i++) {
	        calcTrace = calcTraces[i];
	        fullTrace = calcTrace[0].trace;
	
	        isFunnel = (fullTrace.type === 'funnel');
	
	        var pts = [];
	
	        for(j = 0; j < calcTrace.length; j++) {
	            bar = calcTrace[j];
	
	            if(bar.s !== BADNUM) {
	                // stack current bar and get previous sum
	                var value;
	                if(isFunnel) {
	                    value = bar.s;
	                } else {
	                    value = bar.s + bar.b;
	                }
	
	                var base = sieve.put(bar.p, value);
	
	                var top = base + value;
	
	                // store the bar base and top in each calcdata item
	                bar.b = base;
	                bar[sLetter] = top;
	
	                if(!opts.norm) {
	                    pts.push(top);
	                    if(bar.hasB) {
	                        pts.push(base);
	                    }
	                }
	            }
	        }
	
	        // if barnorm is set, let normalizeBars update the axis range
	        if(!opts.norm) {
	            fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	                // N.B. we don't stack base with 'base',
	                // so set tozero:true always!
	                tozero: true,
	                padded: true
	            });
	        }
	    }
	}
	
	function sieveBars(sieve) {
	    var calcTraces = sieve.traces;
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	
	        for(var j = 0; j < calcTrace.length; j++) {
	            var bar = calcTrace[j];
	
	            if(bar.s !== BADNUM) {
	                sieve.put(bar.p, bar.b + bar.s);
	            }
	        }
	    }
	}
	
	function unhideBarsWithinTrace(sieve) {
	    var calcTraces = sieve.traces;
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var fullTrace = calcTrace[0].trace;
	
	        if(fullTrace.base === undefined) {
	            var inTraceSieve = new Sieve([calcTrace], {
	                sepNegVal: true,
	                overlapNoMerge: true
	            });
	
	            for(var j = 0; j < calcTrace.length; j++) {
	                var bar = calcTrace[j];
	
	                if(bar.p !== BADNUM) {
	                    // stack current bar and get previous sum
	                    var base = inTraceSieve.put(bar.p, bar.b + bar.s);
	
	                    // if previous sum if non-zero, this means:
	                    // multiple bars have same starting point are potentially hidden,
	                    // shift them vertically so that all bars are visible by default
	                    if(base) bar.b = base;
	                }
	            }
	        }
	    }
	}
	
	// Note:
	//
	// normalizeBars requires that either sieveBars or stackBars has been
	// previously invoked.
	function normalizeBars(sa, sieve, opts) {
	    var calcTraces = sieve.traces;
	    var sLetter = getAxisLetter(sa);
	    var sTop = opts.norm === 'fraction' ? 1 : 100;
	    var sTiny = sTop / 1e9; // in case of rounding error in sum
	    var sMin = sa.l2c(sa.c2l(0));
	    var sMax = opts.mode === 'stack' ? sTop : sMin;
	
	    function needsPadding(v) {
	        return (
	            isNumeric(sa.c2l(v)) &&
	            ((v < sMin - sTiny) || (v > sMax + sTiny) || !isNumeric(sMin))
	        );
	    }
	
	    for(var i = 0; i < calcTraces.length; i++) {
	        var calcTrace = calcTraces[i];
	        var fullTrace = calcTrace[0].trace;
	        var pts = [];
	        var allBaseAboveZero = true;
	        var padded = false;
	
	        for(var j = 0; j < calcTrace.length; j++) {
	            var bar = calcTrace[j];
	
	            if(bar.s !== BADNUM) {
	                var scale = Math.abs(sTop / sieve.get(bar.p, bar.s));
	                bar.b *= scale;
	                bar.s *= scale;
	
	                var base = bar.b;
	                var top = base + bar.s;
	
	                bar[sLetter] = top;
	                pts.push(top);
	                padded = padded || needsPadding(top);
	
	                if(bar.hasB) {
	                    pts.push(base);
	                    padded = padded || needsPadding(base);
	                }
	
	                if(!bar.hasB || !(bar.b > 0 && bar.s > 0)) {
	                    allBaseAboveZero = false;
	                }
	            }
	        }
	
	        fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	            tozero: !allBaseAboveZero,
	            padded: padded
	        });
	    }
	}
	
	// find the full position span of bars at each position
	// for use by hover, to ensure labels move in if bars are
	// narrower than the space they're in.
	// run once per trace group (subplot & direction) and
	// the same mapping is attached to all calcdata traces
	function collectExtents(calcTraces, pa) {
	    var pLetter = getAxisLetter(pa);
	    var extents = {};
	    var i, j, cd;
	
	    var pMin = Infinity;
	    var pMax = -Infinity;
	
	    for(i = 0; i < calcTraces.length; i++) {
	        cd = calcTraces[i];
	        for(j = 0; j < cd.length; j++) {
	            var p = cd[j].p;
	            if(isNumeric(p)) {
	                pMin = Math.min(pMin, p);
	                pMax = Math.max(pMax, p);
	            }
	        }
	    }
	
	    // this is just for positioning of hover labels, and nobody will care if
	    // the label is 1px too far out; so round positions to 1/10K in case
	    // position values don't exactly match from trace to trace
	    var roundFactor = 10000 / (pMax - pMin);
	    var round = extents.round = function(p) {
	        return String(Math.round(roundFactor * (p - pMin)));
	    };
	
	    for(i = 0; i < calcTraces.length; i++) {
	        cd = calcTraces[i];
	        cd[0].t.extents = extents;
	
	        var poffset = cd[0].t.poffset;
	        var poffsetIsArray = Array.isArray(poffset);
	
	        for(j = 0; j < cd.length; j++) {
	            var di = cd[j];
	            var p0 = di[pLetter] - di.w / 2;
	
	            if(isNumeric(p0)) {
	                var p1 = di[pLetter] + di.w / 2;
	                var pVal = round(di.p);
	                if(extents[pVal]) {
	                    extents[pVal] = [Math.min(p0, extents[pVal][0]), Math.max(p1, extents[pVal][1])];
	                } else {
	                    extents[pVal] = [p0, p1];
	                }
	            }
	
	            di.p0 = di.p + (poffsetIsArray ? poffset[j] : poffset);
	            di.p1 = di.p0 + di.w;
	            di.s0 = di.b;
	            di.s1 = di.s0 + di.s;
	        }
	    }
	}
	
	function getAxisLetter(ax) {
	    return ax._id.charAt(0);
	}
	
	module.exports = {
	    crossTraceCalc: crossTraceCalc,
	    setGroupPositions: setGroupPositions
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axes":764,"../../plots/cartesian/axis_ids":767,"../../registry":845,"./sieve.js":868,"fast-isnumeric":227}],859:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Registry = _dereq_('../../registry');
	
	var handleXYDefaults = _dereq_('../scatter/xy_defaults');
	var handleStyleDefaults = _dereq_('./style_defaults');
	var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
	var attributes = _dereq_('./attributes');
	
	var coerceFont = Lib.coerceFont;
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('orientation', (traceOut.x && !traceOut.y) ? 'h' : 'v');
	    coerce('base');
	    coerce('offset');
	    coerce('width');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var textposition = coerce('textposition');
	    handleText(traceIn, traceOut, layout, coerce, textposition, {
	        moduleHasSelected: true,
	        moduleHasUnselected: true,
	        moduleHasConstrain: true,
	        moduleHasCliponaxis: true,
	        moduleHasTextangle: true,
	        moduleHasInsideanchor: true
	    });
	
	    handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	
	    var lineColor = (traceOut.marker.line || {}).color;
	
	    // override defaultColor for error bars with defaultLine
	    var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'y'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'x', inherit: 'y'});
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	}
	
	function handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce) {
	    var orientation = traceOut.orientation;
	    // N.B. grouping is done across all trace types that support it
	    var posAxId = traceOut[{v: 'x', h: 'y'}[orientation] + 'axis'];
	    var groupId = getAxisGroup(fullLayout, posAxId) + orientation;
	
	    var alignmentOpts = fullLayout._alignmentOpts || {};
	    var alignmentgroup = coerce('alignmentgroup');
	
	    var alignmentGroups = alignmentOpts[groupId];
	    if(!alignmentGroups) alignmentGroups = alignmentOpts[groupId] = {};
	
	    var alignmentGroupOpts = alignmentGroups[alignmentgroup];
	
	    if(alignmentGroupOpts) {
	        alignmentGroupOpts.traces.push(traceOut);
	    } else {
	        alignmentGroupOpts = alignmentGroups[alignmentgroup] = {
	            traces: [traceOut],
	            alignmentIndex: Object.keys(alignmentGroups).length,
	            offsetGroups: {}
	        };
	    }
	
	    var offsetgroup = coerce('offsetgroup');
	    var offsetGroups = alignmentGroupOpts.offsetGroups;
	    var offsetGroupOpts = offsetGroups[offsetgroup];
	
	    if(offsetgroup) {
	        if(!offsetGroupOpts) {
	            offsetGroupOpts = offsetGroups[offsetgroup] = {
	                offsetIndex: Object.keys(offsetGroups).length
	            };
	        }
	
	        traceOut._offsetIndex = offsetGroupOpts.offsetIndex;
	    }
	}
	
	function crossTraceDefaults(fullData, fullLayout) {
	    var traceIn, traceOut;
	
	    function coerce(attr) {
	        return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	    }
	
	    if(fullLayout.barmode === 'group') {
	        for(var i = 0; i < fullData.length; i++) {
	            traceOut = fullData[i];
	
	            if(traceOut.type === 'bar') {
	                traceIn = traceOut._input;
	                handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	            }
	        }
	    }
	}
	
	function handleText(traceIn, traceOut, layout, coerce, textposition, opts) {
	    opts = opts || {};
	    var moduleHasSelected = !(opts.moduleHasSelected === false);
	    var moduleHasUnselected = !(opts.moduleHasUnselected === false);
	    var moduleHasConstrain = !(opts.moduleHasConstrain === false);
	    var moduleHasCliponaxis = !(opts.moduleHasCliponaxis === false);
	    var moduleHasTextangle = !(opts.moduleHasTextangle === false);
	    var moduleHasInsideanchor = !(opts.moduleHasInsideanchor === false);
	
	    var hasBoth = Array.isArray(textposition) || textposition === 'auto';
	    var hasInside = hasBoth || textposition === 'inside';
	    var hasOutside = hasBoth || textposition === 'outside';
	
	    if(hasInside || hasOutside) {
	        var dfltFont = coerceFont(coerce, 'textfont', layout.font);
	
	        // Note that coercing `insidetextfont` is always needed –
	        // even if `textposition` is `outside` for each trace – since
	        // an outside label can become an inside one, for example because
	        // of a bar being stacked on top of it.
	        var insideTextFontDefault = Lib.extendFlat({}, dfltFont);
	        var isTraceTextfontColorSet = traceIn.textfont && traceIn.textfont.color;
	        var isColorInheritedFromLayoutFont = !isTraceTextfontColorSet;
	        if(isColorInheritedFromLayoutFont) {
	            delete insideTextFontDefault.color;
	        }
	        coerceFont(coerce, 'insidetextfont', insideTextFontDefault);
	
	        if(hasOutside) coerceFont(coerce, 'outsidetextfont', dfltFont);
	
	
	        if(moduleHasSelected) coerce('selected.textfont.color');
	        if(moduleHasUnselected) coerce('unselected.textfont.color');
	        if(moduleHasConstrain) coerce('constraintext');
	        if(moduleHasCliponaxis) coerce('cliponaxis');
	        if(moduleHasTextangle) coerce('textangle');
	
	        coerce('texttemplate');
	    }
	
	    if(hasInside) {
	        if(moduleHasInsideanchor) coerce('insidetextanchor');
	    }
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults,
	    crossTraceDefaults: crossTraceDefaults,
	    handleGroupingDefaults: handleGroupingDefaults,
	    handleText: handleText
	};
	
	},{"../../components/color":591,"../../lib":716,"../../plots/cartesian/axis_ids":767,"../../registry":845,"../scatter/xy_defaults":1144,"./attributes":855,"./style_defaults":870}],860:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt, trace) {
	    // standard cartesian event data
	    out.x = 'xVal' in pt ? pt.xVal : pt.x;
	    out.y = 'yVal' in pt ? pt.yVal : pt.y;
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    if(trace.orientation === 'h') {
	        out.label = out.y;
	        out.value = out.x;
	    } else {
	        out.label = out.x;
	        out.value = out.y;
	    }
	
	    return out;
	};
	
	},{}],861:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var tinycolor = _dereq_('tinycolor2');
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	exports.coerceString = function(attributeDefinition, value, defaultValue) {
	    if(typeof value === 'string') {
	        if(value || !attributeDefinition.noBlank) return value;
	    } else if(typeof value === 'number' || value === true) {
	        if(!attributeDefinition.strict) return String(value);
	    }
	
	    return (defaultValue !== undefined) ?
	      defaultValue :
	      attributeDefinition.dflt;
	};
	
	exports.coerceNumber = function(attributeDefinition, value, defaultValue) {
	    if(isNumeric(value)) {
	        value = +value;
	
	        var min = attributeDefinition.min;
	        var max = attributeDefinition.max;
	        var isOutOfBounds = (min !== undefined && value < min) ||
	              (max !== undefined && value > max);
	
	        if(!isOutOfBounds) return value;
	    }
	
	    return (defaultValue !== undefined) ?
	      defaultValue :
	      attributeDefinition.dflt;
	};
	
	exports.coerceColor = function(attributeDefinition, value, defaultValue) {
	    if(tinycolor(value).isValid()) return value;
	
	    return (defaultValue !== undefined) ?
	      defaultValue :
	      attributeDefinition.dflt;
	};
	
	exports.coerceEnumerated = function(attributeDefinition, value, defaultValue) {
	    if(attributeDefinition.coerceNumber) value = +value;
	
	    if(attributeDefinition.values.indexOf(value) !== -1) return value;
	
	    return (defaultValue !== undefined) ?
	      defaultValue :
	      attributeDefinition.dflt;
	};
	
	exports.getValue = function(arrayOrScalar, index) {
	    var value;
	    if(!Array.isArray(arrayOrScalar)) value = arrayOrScalar;
	    else if(index < arrayOrScalar.length) value = arrayOrScalar[index];
	    return value;
	};
	
	exports.getLineWidth = function(trace, di) {
	    var w =
	        (0 < di.mlw) ? di.mlw :
	        !isArrayOrTypedArray(trace.marker.line.width) ? trace.marker.line.width :
	        0;
	
	    return w;
	};
	
	},{"../../lib":716,"fast-isnumeric":227,"tinycolor2":535}],862:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var Registry = _dereq_('../../registry');
	var Color = _dereq_('../../components/color');
	
	var fillText = _dereq_('../../lib').fillText;
	var getLineWidth = _dereq_('./helpers').getLineWidth;
	var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var barPointData = hoverOnBars(pointData, xval, yval, hovermode);
	
	    if(barPointData) {
	        var cd = barPointData.cd;
	        var trace = cd[0].trace;
	        var di = cd[barPointData.index];
	
	        barPointData.color = getTraceColor(trace, di);
	        Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, barPointData);
	
	        return [barPointData];
	    }
	}
	
	function hoverOnBars(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var t = cd[0].t;
	    var isClosest = (hovermode === 'closest');
	    var isWaterfall = (trace.type === 'waterfall');
	    var maxHoverDistance = pointData.maxHoverDistance;
	    var maxSpikeDistance = pointData.maxSpikeDistance;
	
	    var posVal, sizeVal, posLetter, sizeLetter, dx, dy, pRangeCalc;
	
	    function thisBarMinPos(di) { return di[posLetter] - di.w / 2; }
	    function thisBarMaxPos(di) { return di[posLetter] + di.w / 2; }
	
	    var minPos = isClosest ?
	        thisBarMinPos :
	        function(di) {
	            /*
	             * In compare mode, accept a bar if you're on it *or* its group.
	             * Nearly always it's the group that matters, but in case the bar
	             * was explicitly set wider than its group we'd better accept the
	             * whole bar.
	             *
	             * use `bardelta` instead of `bargroupwidth` so we accept hover
	             * in the gap. That way hover doesn't flash on and off as you
	             * mouse over the plot in compare modes.
	             * In 'closest' mode though the flashing seems inevitable,
	             * without far more complex logic
	             */
	            return Math.min(thisBarMinPos(di), di.p - t.bardelta / 2);
	        };
	
	    var maxPos = isClosest ?
	        thisBarMaxPos :
	        function(di) {
	            return Math.max(thisBarMaxPos(di), di.p + t.bardelta / 2);
	        };
	
	    function _positionFn(_minPos, _maxPos) {
	        // add a little to the pseudo-distance for wider bars, so that like scatter,
	        // if you are over two overlapping bars, the narrower one wins.
	        return Fx.inbox(_minPos - posVal, _maxPos - posVal,
	            maxHoverDistance + Math.min(1, Math.abs(_maxPos - _minPos) / pRangeCalc) - 1);
	    }
	
	    function positionFn(di) {
	        return _positionFn(minPos(di), maxPos(di));
	    }
	
	    function thisBarPositionFn(di) {
	        return _positionFn(thisBarMinPos(di), thisBarMaxPos(di));
	    }
	
	    function sizeFn(di) {
	        var v = sizeVal;
	        var b = di.b;
	        var s = di[sizeLetter];
	
	        if(isWaterfall) {
	            s += Math.abs(di.rawS || 0);
	        }
	
	        // add a gradient so hovering near the end of a
	        // bar makes it a little closer match
	        return Fx.inbox(b - v, s - v, maxHoverDistance + (s - v) / (s - b) - 1);
	    }
	
	    if(trace.orientation === 'h') {
	        posVal = yval;
	        sizeVal = xval;
	        posLetter = 'y';
	        sizeLetter = 'x';
	        dx = sizeFn;
	        dy = positionFn;
	    } else {
	        posVal = xval;
	        sizeVal = yval;
	        posLetter = 'x';
	        sizeLetter = 'y';
	        dy = sizeFn;
	        dx = positionFn;
	    }
	
	    var pa = pointData[posLetter + 'a'];
	    var sa = pointData[sizeLetter + 'a'];
	
	    pRangeCalc = Math.abs(pa.r2c(pa.range[1]) - pa.r2c(pa.range[0]));
	
	    function dxy(di) { return (dx(di) + dy(di)) / 2; }
	    var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	    Fx.getClosest(cd, distfn, pointData);
	
	    // skip the rest (for this trace) if we didn't find a close point
	    if(pointData.index === false) return;
	
	    // if we get here and we're not in 'closest' mode, push min/max pos back
	    // onto the group - even though that means occasionally the mouse will be
	    // over the hover label.
	    if(!isClosest) {
	        minPos = function(di) {
	            return Math.min(thisBarMinPos(di), di.p - t.bargroupwidth / 2);
	        };
	        maxPos = function(di) {
	            return Math.max(thisBarMaxPos(di), di.p + t.bargroupwidth / 2);
	        };
	    }
	
	    // the closest data point
	    var index = pointData.index;
	    var di = cd[index];
	
	    var size = (trace.base) ? di.b + di.s : di.s;
	    pointData[sizeLetter + '0'] = pointData[sizeLetter + '1'] = sa.c2p(di[sizeLetter], true);
	    pointData[sizeLetter + 'LabelVal'] = size;
	
	    var extent = t.extents[t.extents.round(di.p)];
	    pointData[posLetter + '0'] = pa.c2p(isClosest ? minPos(di) : extent[0], true);
	    pointData[posLetter + '1'] = pa.c2p(isClosest ? maxPos(di) : extent[1], true);
	    pointData[posLetter + 'LabelVal'] = di.p;
	
	    pointData.labelLabel = hoverLabelText(pa, pointData[posLetter + 'LabelVal']);
	    pointData.valueLabel = hoverLabelText(sa, pointData[sizeLetter + 'LabelVal']);
	
	    // spikelines always want "closest" distance regardless of hovermode
	    pointData.spikeDistance = (sizeFn(di) + thisBarPositionFn(di)) / 2 + maxSpikeDistance - maxHoverDistance;
	    // they also want to point to the data value, regardless of where the label goes
	    // in case of bars shifted within groups
	    pointData[posLetter + 'Spike'] = pa.c2p(di.p, true);
	
	    fillText(di, trace, pointData);
	    pointData.hovertemplate = trace.hovertemplate;
	
	    return pointData;
	}
	
	function getTraceColor(trace, di) {
	    var mc = di.mcc || trace.marker.color;
	    var mlc = di.mlcc || trace.marker.line.color;
	    var mlw = getLineWidth(trace, di);
	
	    if(Color.opacity(mc)) return mc;
	    else if(Color.opacity(mlc) && mlw) return mlc;
	}
	
	module.exports = {
	    hoverPoints: hoverPoints,
	    hoverOnBars: hoverOnBars,
	    getTraceColor: getTraceColor
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../lib":716,"../../plots/cartesian/axes":764,"../../registry":845,"./helpers":861}],863:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    calc: _dereq_('./calc'),
	    crossTraceCalc: _dereq_('./cross_trace_calc').crossTraceCalc,
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    arraysToCalcdata: _dereq_('./arrays_to_calcdata'),
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style').style,
	    styleOnSelect: _dereq_('./style').styleOnSelect,
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    eventData: _dereq_('./event_data'),
	    selectPoints: _dereq_('./select'),
	
	    moduleType: 'trace',
	    name: 'bar',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['bar-like', 'cartesian', 'svg', 'bar', 'oriented', 'errorBarsOK', 'showLegend', 'zoomScale'],
	    animatable: true,
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../scatter/marker_colorbar":1136,"./arrays_to_calcdata":854,"./attributes":855,"./calc":856,"./cross_trace_calc":858,"./defaults":859,"./event_data":860,"./hover":862,"./layout_attributes":864,"./layout_defaults":865,"./plot":866,"./select":867,"./style":869}],864:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    barmode: {
	        valType: 'enumerated',
	        values: ['stack', 'group', 'overlay', 'relative'],
	        dflt: 'group',
	        
	        editType: 'calc',
	        
	    },
	    barnorm: {
	        valType: 'enumerated',
	        values: ['', 'fraction', 'percent'],
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    bargap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'calc',
	        
	    },
	    bargroupgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],865:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function(layoutIn, layoutOut, fullData) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    var hasBars = false;
	    var shouldBeGapless = false;
	    var gappedAnyway = false;
	    var usedSubplots = {};
	
	    var mode = coerce('barmode');
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	        if(Registry.traceIs(trace, 'bar') && trace.visible) hasBars = true;
	        else continue;
	
	        // if we have at least 2 grouped bar traces on the same subplot,
	        // we should default to a gap anyway, even if the data is histograms
	        if(mode === 'group') {
	            var subploti = trace.xaxis + trace.yaxis;
	            if(usedSubplots[subploti]) gappedAnyway = true;
	            usedSubplots[subploti] = true;
	        }
	
	        if(trace.visible && trace.type === 'histogram') {
	            var pa = Axes.getFromId({_fullLayout: layoutOut},
	                        trace[trace.orientation === 'v' ? 'xaxis' : 'yaxis']);
	            if(pa.type !== 'category') shouldBeGapless = true;
	        }
	    }
	
	    if(!hasBars) {
	        delete layoutOut.barmode;
	        return;
	    }
	
	    if(mode !== 'overlay') coerce('barnorm');
	
	    coerce('bargap', (shouldBeGapless && !gappedAnyway) ? 0 : 0.2);
	    coerce('bargroupgap');
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../../registry":845,"./layout_attributes":864}],866:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Registry = _dereq_('../../registry');
	var tickText = _dereq_('../../plots/cartesian/axes').tickText;
	
	var style = _dereq_('./style');
	var helpers = _dereq_('./helpers');
	var constants = _dereq_('./constants');
	var attributes = _dereq_('./attributes');
	
	var attributeText = attributes.text;
	var attributeTextPosition = attributes.textposition;
	
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	
	var TEXTPAD = constants.TEXTPAD;
	
	function keyFunc(d) {return d.id;}
	function getKeyFunc(trace) {
	    if(trace.ids) {
	        return keyFunc;
	    }
	}
	
	function dirSign(a, b) {
	    return (a < b) ? 1 : -1;
	}
	
	function getXY(di, xa, ya, isHorizontal) {
	    var s = [];
	    var p = [];
	
	    var sAxis = isHorizontal ? xa : ya;
	    var pAxis = isHorizontal ? ya : xa;
	
	    s[0] = sAxis.c2p(di.s0, true);
	    p[0] = pAxis.c2p(di.p0, true);
	
	    s[1] = sAxis.c2p(di.s1, true);
	    p[1] = pAxis.c2p(di.p1, true);
	
	    return isHorizontal ? [s, p] : [p, s];
	}
	
	function transition(selection, opts, makeOnCompleteCallback) {
	    if(hasTransition(opts)) {
	        var onComplete;
	        if(makeOnCompleteCallback) {
	            onComplete = makeOnCompleteCallback();
	        }
	        return selection
	          .transition()
	          .duration(opts.duration)
	          .ease(opts.easing)
	          .each('end', function() { onComplete && onComplete(); })
	          .each('interrupt', function() { onComplete && onComplete(); });
	    } else {
	        return selection;
	    }
	}
	
	function hasTransition(transitionOpts) {
	    return transitionOpts && transitionOpts.duration > 0;
	}
	
	function plot(gd, plotinfo, cdModule, traceLayer, opts, makeOnCompleteCallback) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var fullLayout = gd._fullLayout;
	
	    if(!opts) {
	        opts = {
	            mode: fullLayout.barmode,
	            norm: fullLayout.barmode,
	            gap: fullLayout.bargap,
	            groupgap: fullLayout.bargroupgap
	        };
	    }
	
	    var bartraces = Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var trace = cd[0].trace;
	        var isWaterfall = (trace.type === 'waterfall');
	        var isFunnel = (trace.type === 'funnel');
	        var isBar = (trace.type === 'bar');
	        var shouldDisplayZeros = (isBar || isFunnel);
	
	        var adjustPixel = 0;
	        if(isWaterfall && trace.connector.visible && trace.connector.mode === 'between') {
	            adjustPixel = trace.connector.line.width / 2;
	        }
	
	        var isHorizontal = (trace.orientation === 'h');
	
	        var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
	
	        var keyFunc = getKeyFunc(trace);
	        var bars = pointGroup.selectAll('g.point').data(Lib.identity, keyFunc);
	
	        bars.enter().append('g')
	            .classed('point', true);
	
	        bars.exit().remove();
	
	        bars.each(function(di, i) {
	            var bar = d3.select(this);
	
	            // now display the bar
	            // clipped xf/yf (2nd arg true): non-positive
	            // log values go off-screen by plotwidth
	            // so you see them continue if you drag the plot
	            var xy = getXY(di, xa, ya, isHorizontal);
	
	            var x0 = xy[0][0];
	            var x1 = xy[0][1];
	            var y0 = xy[1][0];
	            var y1 = xy[1][1];
	
	            var isBlank = (
	                x0 === x1 ||
	                y0 === y1 ||
	                !isNumeric(x0) ||
	                !isNumeric(x1) ||
	                !isNumeric(y0) ||
	                !isNumeric(y1)
	            );
	            // display zeros if line.width > 0
	            if(isBlank && shouldDisplayZeros && helpers.getLineWidth(trace, di) && (isHorizontal ? x1 - x0 === 0 : y1 - y0 === 0)) {
	                isBlank = false;
	            }
	            di.isBlank = isBlank;
	
	            if(isBlank && isHorizontal) x1 = x0;
	            if(isBlank && !isHorizontal) y1 = y0;
	
	            // in waterfall mode `between` we need to adjust bar end points to match the connector width
	            if(adjustPixel && !isBlank) {
	                if(isHorizontal) {
	                    x0 -= dirSign(x0, x1) * adjustPixel;
	                    x1 += dirSign(x0, x1) * adjustPixel;
	                } else {
	                    y0 -= dirSign(y0, y1) * adjustPixel;
	                    y1 += dirSign(y0, y1) * adjustPixel;
	                }
	            }
	
	            var lw;
	            var mc;
	
	            if(trace.type === 'waterfall') {
	                if(!isBlank) {
	                    var cont = trace[di.dir].marker;
	                    lw = cont.line.width;
	                    mc = cont.color;
	                }
	            } else {
	                lw = helpers.getLineWidth(trace, di);
	                mc = di.mc || trace.marker.color;
	            }
	
	            var offset = d3.round((lw / 2) % 1, 2);
	
	            function roundWithLine(v) {
	                // if there are explicit gaps, don't round,
	                // it can make the gaps look crappy
	                return (opts.gap === 0 && opts.groupgap === 0) ?
	                    d3.round(Math.round(v) - offset, 2) : v;
	            }
	
	            function expandToVisible(v, vc) {
	                // if it's not in danger of disappearing entirely,
	                // round more precisely
	                return Math.abs(v - vc) >= 2 ? roundWithLine(v) :
	                // but if it's very thin, expand it so it's
	                // necessarily visible, even if it might overlap
	                // its neighbor
	                (v > vc ? Math.ceil(v) : Math.floor(v));
	            }
	
	            if(!gd._context.staticPlot) {
	                // if bars are not fully opaque or they have a line
	                // around them, round to integer pixels, mainly for
	                // safari so we prevent overlaps from its expansive
	                // pixelation. if the bars ARE fully opaque and have
	                // no line, expand to a full pixel to make sure we
	                // can see them
	
	                var op = Color.opacity(mc);
	                var fixpx = (op < 1 || lw > 0.01) ? roundWithLine : expandToVisible;
	                x0 = fixpx(x0, x1);
	                x1 = fixpx(x1, x0);
	                y0 = fixpx(y0, y1);
	                y1 = fixpx(y1, y0);
	            }
	
	            var sel = transition(Lib.ensureSingle(bar, 'path'), opts, makeOnCompleteCallback);
	            sel
	                .style('vector-effect', 'non-scaling-stroke')
	                .attr('d', 'M' + x0 + ',' + y0 + 'V' + y1 + 'H' + x1 + 'V' + y0 + 'Z')
	                .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	
	            if(hasTransition(opts)) {
	                var styleFns = Drawing.makePointStyleFns(trace);
	                Drawing.singlePointStyle(di, sel, trace, styleFns, gd);
	            }
	
	            appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, opts, makeOnCompleteCallback);
	
	            if(plotinfo.layerClipId) {
	                Drawing.hideOutsideRangePoint(di, bar.select('text'), xa, ya, trace.xcalendar, trace.ycalendar);
	            }
	        });
	
	        // lastly, clip points groups of `cliponaxis !== false` traces
	        // on `plotinfo._hasClipOnAxisFalse === true` subplots
	        var hasClipOnAxisFalse = trace.cliponaxis === false;
	        Drawing.setClipUrl(plotGroup, hasClipOnAxisFalse ? null : plotinfo.layerClipId, gd);
	    });
	
	    // error bars are on the top
	    Registry.getComponentMethod('errorbars', 'plot')(gd, bartraces, plotinfo, opts);
	}
	
	function appendBarText(gd, plotinfo, bar, calcTrace, i, x0, x1, y0, y1, opts, makeOnCompleteCallback) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    var fullLayout = gd._fullLayout;
	    var textPosition;
	
	    function appendTextNode(bar, text, textFont) {
	        var textSelection = Lib.ensureSingle(bar, 'text')
	            .text(text)
	            .attr({
	                'class': 'bartext bartext-' + textPosition,
	                'text-anchor': 'middle',
	                // prohibit tex interpretation until we can handle
	                // tex and regular text together
	                'data-notex': 1
	            })
	            .call(Drawing.font, textFont)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        return textSelection;
	    }
	
	    // get trace attributes
	    var trace = calcTrace[0].trace;
	    var isHorizontal = (trace.orientation === 'h');
	
	    var text = getText(fullLayout, calcTrace, i, xa, ya);
	    textPosition = getTextPosition(trace, i);
	
	    // compute text position
	    var inStackOrRelativeMode =
	        opts.mode === 'stack' ||
	        opts.mode === 'relative';
	
	    var calcBar = calcTrace[i];
	    var isOutmostBar = !inStackOrRelativeMode || calcBar._outmost;
	
	    if(!text ||
	        textPosition === 'none' ||
	        ((calcBar.isBlank || x0 === x1 || y0 === y1) && (
	            textPosition === 'auto' ||
	            textPosition === 'inside'))) {
	        bar.select('text').remove();
	        return;
	    }
	
	    var layoutFont = fullLayout.font;
	    var barColor = style.getBarColor(calcTrace[i], trace);
	    var insideTextFont = style.getInsideTextFont(trace, i, layoutFont, barColor);
	    var outsideTextFont = style.getOutsideTextFont(trace, i, layoutFont);
	
	    // Special case: don't use the c2p(v, true) value on log size axes,
	    // so that we can get correctly inside text scaling
	    var di = bar.datum();
	    if(isHorizontal) {
	        if(xa.type === 'log' && di.s0 <= 0) {
	            if(xa.range[0] < xa.range[1]) {
	                x0 = 0;
	            } else {
	                x0 = xa._length;
	            }
	        }
	    } else {
	        if(ya.type === 'log' && di.s0 <= 0) {
	            if(ya.range[0] < ya.range[1]) {
	                y0 = ya._length;
	            } else {
	                y0 = 0;
	            }
	        }
	    }
	
	    // padding excluded
	    var barWidth = Math.abs(x1 - x0) - 2 * TEXTPAD;
	    var barHeight = Math.abs(y1 - y0) - 2 * TEXTPAD;
	
	    var textSelection;
	    var textBB;
	    var textWidth;
	    var textHeight;
	
	    if(textPosition === 'outside') {
	        if(!isOutmostBar && !calcBar.hasB) textPosition = 'inside';
	    }
	
	    if(textPosition === 'auto') {
	        if(isOutmostBar) {
	            // draw text using insideTextFont and check if it fits inside bar
	            textPosition = 'inside';
	            textSelection = appendTextNode(bar, text, insideTextFont);
	
	            textBB = Drawing.bBox(textSelection.node()),
	            textWidth = textBB.width,
	            textHeight = textBB.height;
	
	            var textHasSize = (textWidth > 0 && textHeight > 0);
	            var fitsInside = (textWidth <= barWidth && textHeight <= barHeight);
	            var fitsInsideIfRotated = (textWidth <= barHeight && textHeight <= barWidth);
	            var fitsInsideIfShrunk = (isHorizontal) ?
	                (barWidth >= textWidth * (barHeight / textHeight)) :
	                (barHeight >= textHeight * (barWidth / textWidth));
	
	            if(textHasSize && (
	                fitsInside ||
	                fitsInsideIfRotated ||
	                fitsInsideIfShrunk)
	            ) {
	                textPosition = 'inside';
	            } else {
	                textPosition = 'outside';
	                textSelection.remove();
	                textSelection = null;
	            }
	        } else {
	            textPosition = 'inside';
	        }
	    }
	
	    if(!textSelection) {
	        textSelection = appendTextNode(bar, text,
	                (textPosition === 'outside') ?
	                outsideTextFont : insideTextFont);
	
	        var currentTransform = textSelection.attr('transform');
	        textSelection.attr('transform', '');
	        textBB = Drawing.bBox(textSelection.node()),
	        textWidth = textBB.width,
	        textHeight = textBB.height;
	        textSelection.attr('transform', currentTransform);
	
	        if(textWidth <= 0 || textHeight <= 0) {
	            textSelection.remove();
	            return;
	        }
	    }
	
	    // compute text transform
	    var transform, constrained;
	    if(textPosition === 'outside') {
	        constrained =
	            trace.constraintext === 'both' ||
	            trace.constraintext === 'outside';
	
	        transform = Lib.getTextTransform(toMoveOutsideBar(x0, x1, y0, y1, textBB, {
	            isHorizontal: isHorizontal,
	            constrained: constrained,
	            angle: trace.textangle
	        }));
	    } else {
	        constrained =
	            trace.constraintext === 'both' ||
	            trace.constraintext === 'inside';
	
	        transform = Lib.getTextTransform(toMoveInsideBar(x0, x1, y0, y1, textBB, {
	            isHorizontal: isHorizontal,
	            constrained: constrained,
	            angle: trace.textangle,
	            anchor: trace.insidetextanchor
	        }));
	    }
	
	    transition(textSelection, opts, makeOnCompleteCallback).attr('transform', transform);
	}
	
	function getRotateFromAngle(angle) {
	    return (angle === 'auto') ? 0 : angle;
	}
	
	function toMoveInsideBar(x0, x1, y0, y1, textBB, opts) {
	    var isHorizontal = !!opts.isHorizontal;
	    var constrained = !!opts.constrained;
	    var angle = opts.angle || 0;
	    var anchor = opts.anchor || 0;
	
	    var textWidth = textBB.width;
	    var textHeight = textBB.height;
	    var lx = Math.abs(x1 - x0);
	    var ly = Math.abs(y1 - y0);
	
	    var textpad = (
	        lx > (2 * TEXTPAD) &&
	        ly > (2 * TEXTPAD)
	    ) ? TEXTPAD : 0;
	
	    lx -= 2 * textpad;
	    ly -= 2 * textpad;
	
	    var autoRotate = (angle === 'auto');
	    var isAutoRotated = false;
	    if(autoRotate &&
	        !(textWidth <= lx && textHeight <= ly) &&
	        (textWidth > lx || textHeight > ly) && (
	        !(textWidth > ly || textHeight > lx) ||
	        ((textWidth < textHeight) !== (lx < ly))
	    )) {
	        isAutoRotated = true;
	    }
	
	    if(isAutoRotated) {
	        // don't rotate yet only swap bar width with height
	        var tmp = ly;
	        ly = lx;
	        lx = tmp;
	    }
	
	    var rotate = getRotateFromAngle(angle);
	    var absSin = Math.abs(Math.sin(Math.PI / 180 * rotate));
	    var absCos = Math.abs(Math.cos(Math.PI / 180 * rotate));
	
	    // compute and apply text padding
	    var dx = Math.max(lx * absCos, ly * absSin);
	    var dy = Math.max(lx * absSin, ly * absCos);
	
	    var scale = (constrained) ?
	        Math.min(dx / textWidth, dy / textHeight) :
	        Math.max(absCos, absSin);
	
	    scale = Math.min(1, scale);
	
	    // compute text and target positions
	    var targetX = (x0 + x1) / 2;
	    var targetY = (y0 + y1) / 2;
	
	    if(anchor !== 'middle') { // case of 'start' or 'end'
	        var targetWidth = scale * (isHorizontal !== isAutoRotated ? textHeight : textWidth);
	        var targetHeight = scale * (isHorizontal !== isAutoRotated ? textWidth : textHeight);
	        textpad += 0.5 * (targetWidth * absSin + targetHeight * absCos);
	
	        if(isHorizontal) {
	            textpad *= dirSign(x0, x1);
	            targetX = (anchor === 'start') ? x0 + textpad : x1 - textpad;
	        } else {
	            textpad *= dirSign(y0, y1);
	            targetY = (anchor === 'start') ? y0 + textpad : y1 - textpad;
	        }
	    }
	
	    var textX = (textBB.left + textBB.right) / 2;
	    var textY = (textBB.top + textBB.bottom) / 2;
	
	    // lastly apply auto rotation
	    if(isAutoRotated) rotate += 90;
	
	    return {
	        textX: textX,
	        textY: textY,
	        targetX: targetX,
	        targetY: targetY,
	        scale: scale,
	        rotate: rotate
	    };
	}
	
	function toMoveOutsideBar(x0, x1, y0, y1, textBB, opts) {
	    var isHorizontal = !!opts.isHorizontal;
	    var constrained = !!opts.constrained;
	    var angle = opts.angle || 0;
	
	    var textWidth = textBB.width;
	    var textHeight = textBB.height;
	    var lx = Math.abs(x1 - x0);
	    var ly = Math.abs(y1 - y0);
	
	    var textpad;
	    // Keep the padding so the text doesn't sit right against
	    // the bars, but don't factor it into barWidth
	    if(isHorizontal) {
	        textpad = (ly > 2 * TEXTPAD) ? TEXTPAD : 0;
	    } else {
	        textpad = (lx > 2 * TEXTPAD) ? TEXTPAD : 0;
	    }
	
	    // compute rotate and scale
	    var scale = 1;
	    if(constrained) {
	        scale = (isHorizontal) ?
	            Math.min(1, ly / textHeight) :
	            Math.min(1, lx / textWidth);
	    }
	
	    var rotate = getRotateFromAngle(angle);
	    var absSin = Math.abs(Math.sin(Math.PI / 180 * rotate));
	    var absCos = Math.abs(Math.cos(Math.PI / 180 * rotate));
	
	    // compute text and target positions
	    var targetWidth = scale * (isHorizontal ? textHeight : textWidth);
	    var targetHeight = scale * (isHorizontal ? textWidth : textHeight);
	    textpad += 0.5 * (targetWidth * absSin + targetHeight * absCos);
	
	    var targetX = (x0 + x1) / 2;
	    var targetY = (y0 + y1) / 2;
	
	    if(isHorizontal) {
	        targetX = x1 - textpad * dirSign(x1, x0);
	    } else {
	        targetY = y1 + textpad * dirSign(y0, y1);
	    }
	
	    var textX = (textBB.left + textBB.right) / 2;
	    var textY = (textBB.top + textBB.bottom) / 2;
	
	    return {
	        textX: textX,
	        textY: textY,
	        targetX: targetX,
	        targetY: targetY,
	        scale: scale,
	        rotate: rotate
	    };
	}
	
	function getText(fullLayout, calcTrace, index, xa, ya) {
	    var trace = calcTrace[0].trace;
	    var texttemplate = trace.texttemplate;
	
	    var value;
	    if(texttemplate) {
	        value = calcTexttemplate(fullLayout, calcTrace, index, xa, ya);
	    } else if(trace.textinfo) {
	        value = calcTextinfo(calcTrace, index, xa, ya);
	    } else {
	        value = helpers.getValue(trace.text, index);
	    }
	
	    return helpers.coerceString(attributeText, value);
	}
	
	function getTextPosition(trace, index) {
	    var value = helpers.getValue(trace.textposition, index);
	    return helpers.coerceEnumerated(attributeTextPosition, value);
	}
	
	function calcTexttemplate(fullLayout, calcTrace, index, xa, ya) {
	    var trace = calcTrace[0].trace;
	    var texttemplate = Lib.castOption(trace, index, 'texttemplate');
	    if(!texttemplate) return '';
	    var isWaterfall = (trace.type === 'waterfall');
	    var isFunnel = (trace.type === 'funnel');
	
	    var pLetter, pAxis;
	    var vLetter, vAxis;
	    if(trace.orientation === 'h') {
	        pLetter = 'y';
	        pAxis = ya;
	        vLetter = 'x';
	        vAxis = xa;
	    } else {
	        pLetter = 'x';
	        pAxis = xa;
	        vLetter = 'y';
	        vAxis = ya;
	    }
	
	    function formatLabel(u) {
	        return tickText(pAxis, u, true).text;
	    }
	
	    function formatNumber(v) {
	        return tickText(vAxis, +v, true).text;
	    }
	
	    var cdi = calcTrace[index];
	    var obj = {};
	
	    obj.label = cdi.p;
	    obj.labelLabel = obj[pLetter + 'Label'] = formatLabel(cdi.p);
	
	    var tx = Lib.castOption(trace, cdi.i, 'text');
	    if(tx === 0 || tx) obj.text = tx;
	
	    obj.value = cdi.s;
	    obj.valueLabel = obj[vLetter + 'Label'] = formatNumber(cdi.s);
	
	    var pt = {};
	    appendArrayPointValue(pt, trace, cdi.i);
	
	    if(isWaterfall) {
	        obj.delta = +cdi.rawS || cdi.s;
	        obj.deltaLabel = formatNumber(obj.delta);
	        obj.final = cdi.v;
	        obj.finalLabel = formatNumber(obj.final);
	        obj.initial = obj.final - obj.delta;
	        obj.initialLabel = formatNumber(obj.initial);
	    }
	
	    if(isFunnel) {
	        obj.value = cdi.s;
	        obj.valueLabel = formatNumber(obj.value);
	
	        obj.percentInitial = cdi.begR;
	        obj.percentInitialLabel = Lib.formatPercent(cdi.begR);
	        obj.percentPrevious = cdi.difR;
	        obj.percentPreviousLabel = Lib.formatPercent(cdi.difR);
	        obj.percentTotal = cdi.sumR;
	        obj.percenTotalLabel = Lib.formatPercent(cdi.sumR);
	    }
	
	    var customdata = Lib.castOption(trace, cdi.i, 'customdata');
	    if(customdata) obj.customdata = customdata;
	    return Lib.texttemplateString(texttemplate, obj, fullLayout._d3locale, pt, obj, trace._meta || {});
	}
	
	function calcTextinfo(calcTrace, index, xa, ya) {
	    var trace = calcTrace[0].trace;
	    var isHorizontal = (trace.orientation === 'h');
	    var isWaterfall = (trace.type === 'waterfall');
	    var isFunnel = (trace.type === 'funnel');
	
	    function formatLabel(u) {
	        var pAxis = isHorizontal ? ya : xa;
	        return tickText(pAxis, u, true).text;
	    }
	
	    function formatNumber(v) {
	        var sAxis = isHorizontal ? xa : ya;
	        return tickText(sAxis, +v, true).text;
	    }
	
	    var textinfo = trace.textinfo;
	    var cdi = calcTrace[index];
	
	    var parts = textinfo.split('+');
	    var text = [];
	    var tx;
	
	    var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
	
	    if(hasFlag('label')) {
	        text.push(formatLabel(calcTrace[index].p));
	    }
	
	    if(hasFlag('text')) {
	        tx = Lib.castOption(trace, cdi.i, 'text');
	        if(tx === 0 || tx) text.push(tx);
	    }
	
	    if(isWaterfall) {
	        var delta = +cdi.rawS || cdi.s;
	        var final = cdi.v;
	        var initial = final - delta;
	
	        if(hasFlag('initial')) text.push(formatNumber(initial));
	        if(hasFlag('delta')) text.push(formatNumber(delta));
	        if(hasFlag('final')) text.push(formatNumber(final));
	    }
	
	    if(isFunnel) {
	        if(hasFlag('value')) text.push(formatNumber(cdi.s));
	
	        var nPercent = 0;
	        if(hasFlag('percent initial')) nPercent++;
	        if(hasFlag('percent previous')) nPercent++;
	        if(hasFlag('percent total')) nPercent++;
	
	        var hasMultiplePercents = nPercent > 1;
	
	        if(hasFlag('percent initial')) {
	            tx = Lib.formatPercent(cdi.begR);
	            if(hasMultiplePercents) tx += ' of initial';
	            text.push(tx);
	        }
	        if(hasFlag('percent previous')) {
	            tx = Lib.formatPercent(cdi.difR);
	            if(hasMultiplePercents) tx += ' of previous';
	            text.push(tx);
	        }
	        if(hasFlag('percent total')) {
	            tx = Lib.formatPercent(cdi.sumR);
	            if(hasMultiplePercents) tx += ' of total';
	            text.push(tx);
	        }
	    }
	
	    return text.join('<br>');
	}
	
	module.exports = {
	    plot: plot,
	    toMoveInsideBar: toMoveInsideBar,
	    toMoveOutsideBar: toMoveOutsideBar
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../components/fx/helpers":626,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"../../registry":845,"./attributes":855,"./constants":857,"./helpers":861,"./style":869,"d3":164,"fast-isnumeric":227}],867:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var trace = cd[0].trace;
	    var isFunnel = (trace.type === 'funnel');
	    var isHorizontal = (trace.orientation === 'h');
	    var selection = [];
	    var i;
	
	    if(selectionTester === false) {
	        // clear selection
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            var di = cd[i];
	            var ct = 'ct' in di ? di.ct : getCentroid(di, xa, ya, isHorizontal, isFunnel);
	
	            if(selectionTester.contains(ct, false, i, searchInfo)) {
	                selection.push({
	                    pointNumber: i,
	                    x: xa.c2d(di.x),
	                    y: ya.c2d(di.y)
	                });
	                di.selected = 1;
	            } else {
	                di.selected = 0;
	            }
	        }
	    }
	
	    return selection;
	};
	
	function getCentroid(d, xa, ya, isHorizontal, isFunnel) {
	    var x0 = xa.c2p(isHorizontal ? d.s0 : d.p0, true);
	    var x1 = xa.c2p(isHorizontal ? d.s1 : d.p1, true);
	    var y0 = ya.c2p(isHorizontal ? d.p0 : d.s0, true);
	    var y1 = ya.c2p(isHorizontal ? d.p1 : d.s1, true);
	
	    if(isFunnel) {
	        return [(x0 + x1) / 2, (y0 + y1) / 2];
	    } else {
	        if(isHorizontal) {
	            return [x1, (y0 + y1) / 2];
	        } else {
	            return [(x0 + x1) / 2, y1];
	        }
	    }
	}
	
	},{}],868:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = Sieve;
	
	var distinctVals = _dereq_('../../lib').distinctVals;
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	/**
	 * Helper class to sieve data from traces into bins
	 *
	 * @class
	 *
	 * @param {Array} traces
	*   Array of calculated traces
	 * @param {object} opts
	 *  - @param {boolean} [sepNegVal]
	 *      If true, then split data at the same position into a bar
	 *      for positive values and another for negative values
	 *  - @param {boolean} [overlapNoMerge]
	 *     If true, then don't merge overlapping bars into a single bar
	 */
	function Sieve(traces, opts) {
	    this.traces = traces;
	    this.sepNegVal = opts.sepNegVal;
	    this.overlapNoMerge = opts.overlapNoMerge;
	
	    // for single-bin histograms - see histogram/calc
	    var width1 = Infinity;
	
	    var positions = [];
	    for(var i = 0; i < traces.length; i++) {
	        var trace = traces[i];
	        for(var j = 0; j < trace.length; j++) {
	            var bar = trace[j];
	            if(bar.p !== BADNUM) positions.push(bar.p);
	        }
	        if(trace[0] && trace[0].width1) {
	            width1 = Math.min(trace[0].width1, width1);
	        }
	    }
	    this.positions = positions;
	
	    var dv = distinctVals(positions);
	    this.distinctPositions = dv.vals;
	    if(dv.vals.length === 1 && width1 !== Infinity) this.minDiff = width1;
	    else this.minDiff = Math.min(dv.minDiff, width1);
	
	    this.binWidth = this.minDiff;
	
	    this.bins = {};
	}
	
	/**
	 * Sieve datum
	 *
	 * @method
	 * @param {number} position
	 * @param {number} value
	 * @returns {number} Previous bin value
	 */
	Sieve.prototype.put = function put(position, value) {
	    var label = this.getLabel(position, value);
	    var oldValue = this.bins[label] || 0;
	
	    this.bins[label] = oldValue + value;
	
	    return oldValue;
	};
	
	/**
	 * Get current bin value for a given datum
	 *
	 * @method
	 * @param {number} position  Position of datum
	 * @param {number} [value]   Value of datum
	 *                           (required if this.sepNegVal is true)
	 * @returns {number} Current bin value
	 */
	Sieve.prototype.get = function get(position, value) {
	    var label = this.getLabel(position, value);
	    return this.bins[label] || 0;
	};
	
	/**
	 * Get bin label for a given datum
	 *
	 * @method
	 * @param {number} position  Position of datum
	 * @param {number} [value]   Value of datum
	 *                           (required if this.sepNegVal is true)
	 * @returns {string} Bin label
	 * (prefixed with a 'v' if value is negative and this.sepNegVal is
	 * true; otherwise prefixed with '^')
	 */
	Sieve.prototype.getLabel = function getLabel(position, value) {
	    var prefix = (value < 0 && this.sepNegVal) ? 'v' : '^';
	    var label = (this.overlapNoMerge) ?
	        position :
	        Math.round(position / this.binWidth);
	    return prefix + label;
	};
	
	},{"../../constants/numerical":692,"../../lib":716}],869:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var attributes = _dereq_('./attributes');
	var attributeTextFont = attributes.textfont;
	var attributeInsideTextFont = attributes.insidetextfont;
	var attributeOutsideTextFont = attributes.outsidetextfont;
	var helpers = _dereq_('./helpers');
	
	function style(gd) {
	    var s = d3.select(gd).selectAll('g.barlayer').selectAll('g.trace');
	    var barcount = s.size();
	    var fullLayout = gd._fullLayout;
	
	    // trace styling
	    s.style('opacity', function(d) { return d[0].trace.opacity; })
	
	    // for gapless (either stacked or neighboring grouped) bars use
	    // crispEdges to turn off antialiasing so an artificial gap
	    // isn't introduced.
	    .each(function(d) {
	        if((fullLayout.barmode === 'stack' && barcount > 1) ||
	                (fullLayout.bargap === 0 &&
	                 fullLayout.bargroupgap === 0 &&
	                 !d[0].trace.marker.line.width)) {
	            d3.select(this).attr('shape-rendering', 'crispEdges');
	        }
	    });
	
	    s.selectAll('g.points').each(function(d) {
	        var sel = d3.select(this);
	        var trace = d[0].trace;
	        stylePoints(sel, trace, gd);
	    });
	
	    Registry.getComponentMethod('errorbars', 'style')(s);
	}
	
	function stylePoints(sel, trace, gd) {
	    Drawing.pointStyle(sel.selectAll('path'), trace, gd);
	    styleTextPoints(sel, trace, gd);
	}
	
	function styleTextPoints(sel, trace, gd) {
	    sel.selectAll('text').each(function(d) {
	        var tx = d3.select(this);
	        var font = determineFont(tx, d, trace, gd);
	        Drawing.font(tx, font);
	    });
	}
	
	function styleOnSelect(gd, cd, sel) {
	    var trace = cd[0].trace;
	
	    if(trace.selectedpoints) {
	        stylePointsInSelectionMode(sel, trace, gd);
	    } else {
	        stylePoints(sel, trace, gd);
	        Registry.getComponentMethod('errorbars', 'style')(sel);
	    }
	}
	
	function stylePointsInSelectionMode(s, trace, gd) {
	    Drawing.selectedPointStyle(s.selectAll('path'), trace);
	    styleTextInSelectionMode(s.selectAll('text'), trace, gd);
	}
	
	function styleTextInSelectionMode(txs, trace, gd) {
	    txs.each(function(d) {
	        var tx = d3.select(this);
	        var font;
	
	        if(d.selected) {
	            font = Lib.extendFlat({}, determineFont(tx, d, trace, gd));
	
	            var selectedFontColor = trace.selected.textfont && trace.selected.textfont.color;
	            if(selectedFontColor) {
	                font.color = selectedFontColor;
	            }
	
	            Drawing.font(tx, font);
	        } else {
	            Drawing.selectedTextStyle(tx, trace);
	        }
	    });
	}
	
	function determineFont(tx, d, trace, gd) {
	    var layoutFont = gd._fullLayout.font;
	    var textFont = trace.textfont;
	
	    if(tx.classed('bartext-inside')) {
	        var barColor = getBarColor(d, trace);
	        textFont = getInsideTextFont(trace, d.i, layoutFont, barColor);
	    } else if(tx.classed('bartext-outside')) {
	        textFont = getOutsideTextFont(trace, d.i, layoutFont);
	    }
	
	    return textFont;
	}
	
	function getTextFont(trace, index, defaultValue) {
	    return getFontValue(
	      attributeTextFont, trace.textfont, index, defaultValue);
	}
	
	function getInsideTextFont(trace, index, layoutFont, barColor) {
	    var defaultFont = getTextFont(trace, index, layoutFont);
	
	    var wouldFallBackToLayoutFont =
	      (trace._input.textfont === undefined || trace._input.textfont.color === undefined) ||
	      (Array.isArray(trace.textfont.color) && trace.textfont.color[index] === undefined);
	    if(wouldFallBackToLayoutFont) {
	        defaultFont = {
	            color: Color.contrast(barColor),
	            family: defaultFont.family,
	            size: defaultFont.size
	        };
	    }
	
	    return getFontValue(
	      attributeInsideTextFont, trace.insidetextfont, index, defaultFont);
	}
	
	function getOutsideTextFont(trace, index, layoutFont) {
	    var defaultFont = getTextFont(trace, index, layoutFont);
	    return getFontValue(
	      attributeOutsideTextFont, trace.outsidetextfont, index, defaultFont);
	}
	
	function getFontValue(attributeDefinition, attributeValue, index, defaultValue) {
	    attributeValue = attributeValue || {};
	
	    var familyValue = helpers.getValue(attributeValue.family, index);
	    var sizeValue = helpers.getValue(attributeValue.size, index);
	    var colorValue = helpers.getValue(attributeValue.color, index);
	
	    return {
	        family: helpers.coerceString(
	          attributeDefinition.family, familyValue, defaultValue.family),
	        size: helpers.coerceNumber(
	          attributeDefinition.size, sizeValue, defaultValue.size),
	        color: helpers.coerceColor(
	          attributeDefinition.color, colorValue, defaultValue.color)
	    };
	}
	
	function getBarColor(cd, trace) {
	    if(trace.type === 'waterfall') {
	        return trace[cd.dir].marker.color;
	    }
	    return cd.mc || trace.marker.color;
	}
	
	module.exports = {
	    style: style,
	    styleTextPoints: styleTextPoints,
	    styleOnSelect: styleOnSelect,
	    getInsideTextFont: getInsideTextFont,
	    getOutsideTextFont: getOutsideTextFont,
	    getBarColor: getBarColor
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../lib":716,"../../registry":845,"./attributes":855,"./helpers":861,"d3":164}],870:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	
	module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout) {
	    coerce('marker.color', defaultColor);
	
	    if(hasColorscale(traceIn, 'marker')) {
	        colorscaleDefaults(
	            traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'}
	        );
	    }
	
	    coerce('marker.line.color', Color.defaultLine);
	
	    if(hasColorscale(traceIn, 'marker.line')) {
	        colorscaleDefaults(
	            traceIn, traceOut, layout, coerce, {prefix: 'marker.line.', cLetter: 'c'}
	        );
	    }
	
	    coerce('marker.line.width');
	    coerce('marker.opacity');
	    coerce('selected.marker.color');
	    coerce('unselected.marker.color');
	};
	
	},{"../../components/color":591,"../../components/colorscale/defaults":601,"../../components/colorscale/helpers":602}],871:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var scatterPolarAttrs = _dereq_('../scatterpolar/attributes');
	var barAttrs = _dereq_('../bar/attributes');
	
	module.exports = {
	    r: scatterPolarAttrs.r,
	    theta: scatterPolarAttrs.theta,
	    r0: scatterPolarAttrs.r0,
	    dr: scatterPolarAttrs.dr,
	    theta0: scatterPolarAttrs.theta0,
	    dtheta: scatterPolarAttrs.dtheta,
	    thetaunit: scatterPolarAttrs.thetaunit,
	
	    // orientation: {
	    //     valType: 'enumerated',
	    //     
	    //     values: ['radial', 'angular'],
	    //     editType: 'calc+clearAxisTypes',
	    //     
	    // },
	
	    base: extendFlat({}, barAttrs.base, {
	        
	    }),
	    offset: extendFlat({}, barAttrs.offset, {
	        
	    }),
	    width: extendFlat({}, barAttrs.width, {
	        
	    }),
	
	    text: extendFlat({}, barAttrs.text, {
	        
	    }),
	    hovertext: extendFlat({}, barAttrs.hovertext, {
	        
	    }),
	
	    // textposition: {},
	    // textfont: {},
	    // insidetextfont: {},
	    // outsidetextfont: {},
	    // constraintext: {},
	    // cliponaxis: extendFlat({}, barAttrs.cliponaxis, {dflt: false}),
	
	    marker: barAttrs.marker,
	
	    hoverinfo: scatterPolarAttrs.hoverinfo,
	    hovertemplate: hovertemplateAttrs(),
	
	    selected: barAttrs.selected,
	    unselected: barAttrs.unselected
	
	    // error_x (error_r, error_theta)
	    // error_y
	};
	
	},{"../../lib/extend":707,"../../plots/template_attributes":840,"../bar/attributes":855,"../scatterpolar/attributes":1190}],872:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var arraysToCalcdata = _dereq_('../bar/arrays_to_calcdata');
	var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
	var calcSelection = _dereq_('../scatter/calc_selection');
	var traceIs = _dereq_('../../registry').traceIs;
	var extendFlat = _dereq_('../../lib').extendFlat;
	
	function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var subplotId = trace.subplot;
	    var radialAxis = fullLayout[subplotId].radialaxis;
	    var angularAxis = fullLayout[subplotId].angularaxis;
	    var rArray = radialAxis.makeCalcdata(trace, 'r');
	    var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
	    var len = trace._length;
	    var cd = new Array(len);
	
	    // 'size' axis variables
	    var sArray = rArray;
	    // 'pos' axis variables
	    var pArray = thetaArray;
	
	    for(var i = 0; i < len; i++) {
	        cd[i] = {p: pArray[i], s: sArray[i]};
	    }
	
	    // convert width and offset in 'c' coordinate,
	    // set 'c' value(s) in trace._width and trace._offset,
	    // to make Bar.crossTraceCalc "just work"
	    function d2c(attr) {
	        var val = trace[attr];
	        if(val !== undefined) {
	            trace['_' + attr] = Array.isArray(val) ?
	                angularAxis.makeCalcdata(trace, attr) :
	                angularAxis.d2c(val, trace.thetaunit);
	        }
	    }
	
	    if(angularAxis.type === 'linear') {
	        d2c('width');
	        d2c('offset');
	    }
	
	    if(hasColorscale(trace, 'marker')) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.marker.color,
	            containerStr: 'marker',
	            cLetter: 'c'
	        });
	    }
	    if(hasColorscale(trace, 'marker.line')) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.marker.line.color,
	            containerStr: 'marker.line',
	            cLetter: 'c'
	        });
	    }
	
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	}
	
	function crossTraceCalc(gd, polarLayout, subplotId) {
	    var calcdata = gd.calcdata;
	    var barPolarCd = [];
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cdi = calcdata[i];
	        var trace = cdi[0].trace;
	
	        if(trace.visible === true && traceIs(trace, 'bar') &&
	            trace.subplot === subplotId
	        ) {
	            barPolarCd.push(cdi);
	        }
	    }
	
	    // to make _extremes is filled in correctly so that
	    // polar._subplot.radialAxis can get auotrange'd
	    // TODO clean up!
	    // I think we want to call getAutorange on polar.radialaxis
	    // NOT on polar._subplot.radialAxis
	    var rAxis = extendFlat({}, polarLayout.radialaxis, {_id: 'x'});
	    var aAxis = polarLayout.angularaxis;
	
	    setGroupPositions(gd, aAxis, rAxis, barPolarCd, {
	        mode: polarLayout.barmode,
	        norm: polarLayout.barnorm,
	        gap: polarLayout.bargap,
	        groupgap: polarLayout.bargroupgap
	    });
	}
	
	module.exports = {
	    calc: calc,
	    crossTraceCalc: crossTraceCalc
	};
	
	},{"../../components/colorscale/calc":599,"../../components/colorscale/helpers":602,"../../lib":716,"../../registry":845,"../bar/arrays_to_calcdata":854,"../bar/cross_trace_calc":858,"../scatter/calc_selection":1120}],873:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleRThetaDefaults = _dereq_('../scatterpolar/defaults').handleRThetaDefaults;
	var handleStyleDefaults = _dereq_('../bar/style_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    // coerce('orientation', (traceOut.theta && !traceOut.r) ? 'angular' : 'radial');
	
	    coerce('thetaunit');
	    coerce('base');
	    coerce('offset');
	    coerce('width');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    // var textPosition = coerce('textposition');
	    // var hasBoth = Array.isArray(textPosition) || textPosition === 'auto';
	    // var hasInside = hasBoth || textPosition === 'inside';
	    // var hasOutside = hasBoth || textPosition === 'outside';
	
	    // if(hasInside || hasOutside) {
	    //     var textFont = coerceFont(coerce, 'textfont', layout.font);
	    //     if(hasInside) coerceFont(coerce, 'insidetextfont', textFont);
	    //     if(hasOutside) coerceFont(coerce, 'outsidetextfont', textFont);
	    //     coerce('constraintext');
	    //     coerce('selected.textfont.color');
	    //     coerce('unselected.textfont.color');
	    //     coerce('cliponaxis');
	    // }
	
	    handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../bar/style_defaults":870,"../scatterpolar/defaults":1192,"./attributes":871}],874:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var getTraceColor = _dereq_('../bar/hover').getTraceColor;
	var fillText = Lib.fillText;
	var makeHoverPointText = _dereq_('../scatterpolar/hover').makeHoverPointText;
	var isPtInsidePolygon = _dereq_('../../plots/polar/helpers').isPtInsidePolygon;
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	
	    var subplot = pointData.subplot;
	    var radialAxis = subplot.radialAxis;
	    var angularAxis = subplot.angularAxis;
	    var vangles = subplot.vangles;
	    var inboxFn = vangles ? isPtInsidePolygon : Lib.isPtInsideSector;
	    var maxHoverDistance = pointData.maxHoverDistance;
	    var period = angularAxis._period || 2 * Math.PI;
	
	    var rVal = Math.abs(radialAxis.g2p(Math.sqrt(xval * xval + yval * yval)));
	    var thetaVal = Math.atan2(yval, xval);
	
	    // polar.(x|y)axis.p2c doesn't get the reversed radial axis range case right
	    if(radialAxis.range[0] > radialAxis.range[1]) {
	        thetaVal += Math.PI;
	    }
	
	    var distFn = function(di) {
	        if(inboxFn(rVal, thetaVal, [di.rp0, di.rp1], [di.thetag0, di.thetag1], vangles)) {
	            return maxHoverDistance +
	                // add a little to the pseudo-distance for wider bars, so that like scatter,
	                // if you are over two overlapping bars, the narrower one wins.
	                Math.min(1, Math.abs(di.thetag1 - di.thetag0) / period) - 1 +
	                // add a gradient so hovering near the end of a
	                // bar makes it a little closer match
	                (di.rp1 - rVal) / (di.rp1 - di.rp0) - 1;
	        } else {
	            return Infinity;
	        }
	    };
	
	    Fx.getClosest(cd, distFn, pointData);
	    if(pointData.index === false) return;
	
	    var index = pointData.index;
	    var cdi = cd[index];
	
	    pointData.x0 = pointData.x1 = cdi.ct[0];
	    pointData.y0 = pointData.y1 = cdi.ct[1];
	
	    var _cdi = Lib.extendFlat({}, cdi, {r: cdi.s, theta: cdi.p});
	    fillText(cdi, trace, pointData);
	    makeHoverPointText(_cdi, trace, subplot, pointData);
	    pointData.hovertemplate = trace.hovertemplate;
	    pointData.color = getTraceColor(trace, cdi);
	    pointData.xLabelVal = pointData.yLabelVal = undefined;
	
	    if(cdi.s < 0) {
	        pointData.idealAlign = 'left';
	    }
	
	    return [pointData];
	};
	
	},{"../../components/fx":629,"../../lib":716,"../../plots/polar/helpers":827,"../bar/hover":862,"../scatterpolar/hover":1194}],875:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'barpolar',
	    basePlotModule: _dereq_('../../plots/polar'),
	    categories: ['polar', 'bar', 'showLegend'],
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./calc').crossTraceCalc,
	
	    plot: _dereq_('./plot'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('../scatterpolar/format_labels'),
	
	    style: _dereq_('../bar/style').style,
	    styleOnSelect: _dereq_('../bar/style').styleOnSelect,
	
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('../bar/select'),
	
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/polar":828,"../bar/select":867,"../bar/style":869,"../scatter/marker_colorbar":1136,"../scatterpolar/format_labels":1193,"./attributes":871,"./calc":872,"./defaults":873,"./hover":874,"./layout_attributes":876,"./layout_defaults":877,"./plot":878}],876:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    barmode: {
	        valType: 'enumerated',
	        values: ['stack', 'overlay'],
	        dflt: 'stack',
	        
	        editType: 'calc',
	        
	    },
	    bargap: {
	        valType: 'number',
	        dflt: 0.1,
	        min: 0,
	        max: 1,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],877:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attrs = _dereq_('./layout_attributes');
	
	module.exports = function(layoutIn, layoutOut, fullData) {
	    var subplotsDone = {};
	    var sp;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn[sp] || {}, layoutOut[sp], attrs, attr, dflt);
	    }
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	        if(trace.type === 'barpolar' && trace.visible === true) {
	            sp = trace.subplot;
	            if(!subplotsDone[sp]) {
	                coerce('barmode');
	                coerce('bargap');
	                subplotsDone[sp] = 1;
	            }
	        }
	    }
	};
	
	},{"../../lib":716,"./layout_attributes":876}],878:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var helpers = _dereq_('../../plots/polar/helpers');
	
	module.exports = function plot(gd, subplot, cdbar) {
	    var xa = subplot.xaxis;
	    var ya = subplot.yaxis;
	    var radialAxis = subplot.radialAxis;
	    var angularAxis = subplot.angularAxis;
	    var pathFn = makePathFn(subplot);
	    var barLayer = subplot.layers.frontplot.select('g.barlayer');
	
	    Lib.makeTraceGroups(barLayer, cdbar, 'trace bars').each(function() {
	        var plotGroup = d3.select(this);
	        var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
	        var bars = pointGroup.selectAll('g.point').data(Lib.identity);
	
	        bars.enter().append('g')
	            .style('vector-effect', 'non-scaling-stroke')
	            .style('stroke-miterlimit', 2)
	            .classed('point', true);
	
	        bars.exit().remove();
	
	        bars.each(function(di) {
	            var bar = d3.select(this);
	
	            var rp0 = di.rp0 = radialAxis.c2p(di.s0);
	            var rp1 = di.rp1 = radialAxis.c2p(di.s1);
	            var thetag0 = di.thetag0 = angularAxis.c2g(di.p0);
	            var thetag1 = di.thetag1 = angularAxis.c2g(di.p1);
	
	            var dPath;
	
	            if(!isNumeric(rp0) || !isNumeric(rp1) ||
	                !isNumeric(thetag0) || !isNumeric(thetag1) ||
	                rp0 === rp1 || thetag0 === thetag1
	            ) {
	                // do not remove blank bars, to keep data-to-node
	                // mapping intact during radial drag, that we
	                // can skip calling _module.style during interactions
	                dPath = 'M0,0Z';
	            } else {
	                // this 'center' pt is used for selections and hover labels
	                var rg1 = radialAxis.c2g(di.s1);
	                var thetagMid = (thetag0 + thetag1) / 2;
	                di.ct = [
	                    xa.c2p(rg1 * Math.cos(thetagMid)),
	                    ya.c2p(rg1 * Math.sin(thetagMid))
	                ];
	
	                dPath = pathFn(rp0, rp1, thetag0, thetag1);
	            }
	
	            Lib.ensureSingle(bar, 'path').attr('d', dPath);
	        });
	
	        // clip plotGroup, when trace layer isn't clipped
	        Drawing.setClipUrl(
	            plotGroup,
	            subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null,
	            gd
	        );
	    });
	};
	
	function makePathFn(subplot) {
	    var cxx = subplot.cxx;
	    var cyy = subplot.cyy;
	
	    if(subplot.vangles) {
	        return function(r0, r1, _a0, _a1) {
	            var a0, a1;
	
	            if(Lib.angleDelta(_a0, _a1) > 0) {
	                a0 = _a0;
	                a1 = _a1;
	            } else {
	                a0 = _a1;
	                a1 = _a0;
	            }
	
	            var va0 = helpers.findEnclosingVertexAngles(a0, subplot.vangles)[0];
	            var va1 = helpers.findEnclosingVertexAngles(a1, subplot.vangles)[1];
	            var vaBar = [va0, (a0 + a1) / 2, va1];
	            return helpers.pathPolygonAnnulus(r0, r1, a0, a1, vaBar, cxx, cyy);
	        };
	    }
	
	    return function(r0, r1, a0, a1) {
	        return Lib.pathAnnulus(r0, r1, a0, a1, cxx, cyy);
	    };
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../../plots/polar/helpers":827,"d3":164,"fast-isnumeric":227}],879:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var barAttrs = _dereq_('../bar/attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	module.exports = {
	    y: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    x0: {
	        valType: 'any',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y0: {
	        valType: 'any',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    name: {
	        valType: 'string',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	    hovertemplate: hovertemplateAttrs({
	        
	    }),
	    whiskerwidth: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0.5,
	        
	        editType: 'calc',
	        
	    },
	    notched: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    notchwidth: {
	        valType: 'number',
	        min: 0,
	        max: 0.5,
	        dflt: 0.25,
	        
	        editType: 'calc',
	        
	    },
	    boxpoints: {
	        valType: 'enumerated',
	        values: ['all', 'outliers', 'suspectedoutliers', false],
	        dflt: 'outliers',
	        
	        editType: 'calc',
	        
	    },
	    boxmean: {
	        valType: 'enumerated',
	        values: [true, 'sd', false],
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    jitter: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'calc',
	        
	    },
	    pointpos: {
	        valType: 'number',
	        min: -2,
	        max: 2,
	        
	        editType: 'calc',
	        
	    },
	    orientation: {
	        valType: 'enumerated',
	        values: ['v', 'h'],
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    width: {
	        valType: 'number',
	        min: 0,
	        
	        dflt: 0,
	        editType: 'calc',
	        
	    },
	
	    marker: {
	        outliercolor: {
	            valType: 'color',
	            dflt: 'rgba(0, 0, 0, 0)',
	            
	            editType: 'style',
	            
	        },
	        symbol: extendFlat({}, scatterMarkerAttrs.symbol,
	            {arrayOk: false, editType: 'plot'}),
	        opacity: extendFlat({}, scatterMarkerAttrs.opacity,
	            {arrayOk: false, dflt: 1, editType: 'style'}),
	        size: extendFlat({}, scatterMarkerAttrs.size,
	            {arrayOk: false, editType: 'calc'}),
	        color: extendFlat({}, scatterMarkerAttrs.color,
	            {arrayOk: false, editType: 'style'}),
	        line: {
	            color: extendFlat({}, scatterMarkerLineAttrs.color,
	                {arrayOk: false, dflt: colorAttrs.defaultLine, editType: 'style'}
	            ),
	            width: extendFlat({}, scatterMarkerLineAttrs.width,
	                {arrayOk: false, dflt: 0, editType: 'style'}
	            ),
	            outliercolor: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            outlierwidth: {
	                valType: 'number',
	                min: 0,
	                dflt: 1,
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        editType: 'plot'
	    },
	    line: {
	        color: {
	            valType: 'color',
	            
	            editType: 'style',
	            
	        },
	        width: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 2,
	            editType: 'style',
	            
	        },
	        editType: 'plot'
	    },
	    fillcolor: scatterAttrs.fillcolor,
	
	    offsetgroup: barAttrs.offsetgroup,
	    alignmentgroup: barAttrs.alignmentgroup,
	
	    selected: {
	        marker: scatterAttrs.selected.marker,
	        editType: 'style'
	    },
	    unselected: {
	        marker: scatterAttrs.unselected.marker,
	        editType: 'style'
	    },
	    hoveron: {
	        valType: 'flaglist',
	        flags: ['boxes', 'points'],
	        dflt: 'boxes+points',
	        
	        editType: 'style',
	        
	    }
	};
	
	},{"../../components/color/attributes":590,"../../lib/extend":707,"../../plots/template_attributes":840,"../bar/attributes":855,"../scatter/attributes":1118}],880:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var _ = Lib._;
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	// outlier definition based on http://www.physics.csbsju.edu/stats/box2.html
	module.exports = function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var cd = [];
	
	    // N.B. violin reuses same Box.calc
	    var numKey = trace.type === 'violin' ? '_numViolins' : '_numBoxes';
	
	    var i;
	    var valAxis, valLetter;
	    var posAxis, posLetter;
	
	    if(trace.orientation === 'h') {
	        valAxis = xa;
	        valLetter = 'x';
	        posAxis = ya;
	        posLetter = 'y';
	    } else {
	        valAxis = ya;
	        valLetter = 'y';
	        posAxis = xa;
	        posLetter = 'x';
	    }
	
	    var val = valAxis.makeCalcdata(trace, valLetter);
	    var pos = getPos(trace, posLetter, posAxis, val, fullLayout[numKey]);
	
	    var dv = Lib.distinctVals(pos);
	    var posDistinct = dv.vals;
	    var dPos = dv.minDiff / 2;
	    var posBins = makeBins(posDistinct, dPos);
	
	    var pLen = posDistinct.length;
	    var ptsPerBin = initNestedArray(pLen);
	
	    // bin pts info per position bins
	    for(i = 0; i < trace._length; i++) {
	        var v = val[i];
	        if(!isNumeric(v)) continue;
	
	        var n = Lib.findBin(pos[i], posBins);
	        if(n >= 0 && n < pLen) {
	            var pt = {v: v, i: i};
	            arraysToCalcdata(pt, trace, i);
	            ptsPerBin[n].push(pt);
	        }
	    }
	
	    var cdi;
	    var ptFilterFn = (trace.boxpoints || trace.points) === 'all' ?
	        Lib.identity :
	        function(pt) { return (pt.v < cdi.lf || pt.v > cdi.uf); };
	
	    var minLowerNotch = Infinity;
	    var maxUpperNotch = -Infinity;
	
	    // build calcdata trace items, one item per distinct position
	    for(i = 0; i < pLen; i++) {
	        if(ptsPerBin[i].length > 0) {
	            var pts = ptsPerBin[i].sort(sortByVal);
	            var boxVals = pts.map(extractVal);
	            var bvLen = boxVals.length;
	
	            cdi = {};
	            cdi.pos = posDistinct[i];
	            cdi.pts = pts;
	
	            // Sort categories by values
	            cdi[posLetter] = cdi.pos;
	            cdi[valLetter] = cdi.pts.map(function(pt) { return pt.v; });
	
	            cdi.min = boxVals[0];
	            cdi.max = boxVals[bvLen - 1];
	            cdi.mean = Lib.mean(boxVals, bvLen);
	            cdi.sd = Lib.stdev(boxVals, bvLen, cdi.mean);
	
	            // first quartile
	            cdi.q1 = Lib.interp(boxVals, 0.25);
	             // median
	            cdi.med = Lib.interp(boxVals, 0.5);
	            // third quartile
	            cdi.q3 = Lib.interp(boxVals, 0.75);
	
	            // lower and upper fences - last point inside
	            // 1.5 interquartile ranges from quartiles
	            cdi.lf = Math.min(
	                cdi.q1,
	                boxVals[Math.min(
	                    Lib.findBin(2.5 * cdi.q1 - 1.5 * cdi.q3, boxVals, true) + 1,
	                    bvLen - 1
	                )]
	            );
	            cdi.uf = Math.max(
	                cdi.q3,
	                boxVals[Math.max(
	                    Lib.findBin(2.5 * cdi.q3 - 1.5 * cdi.q1, boxVals),
	                    0
	                )]
	            );
	
	            // lower and upper outliers - 3 IQR out (don't clip to max/min,
	            // this is only for discriminating suspected & far outliers)
	            cdi.lo = 4 * cdi.q1 - 3 * cdi.q3;
	            cdi.uo = 4 * cdi.q3 - 3 * cdi.q1;
	
	            // lower and upper notches ~95% Confidence Intervals for median
	            var iqr = cdi.q3 - cdi.q1;
	            var mci = 1.57 * iqr / Math.sqrt(bvLen);
	            cdi.ln = cdi.med - mci;
	            cdi.un = cdi.med + mci;
	            minLowerNotch = Math.min(minLowerNotch, cdi.ln);
	            maxUpperNotch = Math.max(maxUpperNotch, cdi.un);
	
	            cdi.pts2 = pts.filter(ptFilterFn);
	
	            cd.push(cdi);
	        }
	    }
	
	    calcSelection(cd, trace);
	
	    trace._extremes[valAxis._id] = Axes.findExtremes(valAxis,
	        trace.notched ? val.concat([minLowerNotch, maxUpperNotch]) : val,
	        {padded: true}
	    );
	
	    if(cd.length > 0) {
	        cd[0].t = {
	            num: fullLayout[numKey],
	            dPos: dPos,
	            posLetter: posLetter,
	            valLetter: valLetter,
	            labels: {
	                med: _(gd, 'median:'),
	                min: _(gd, 'min:'),
	                q1: _(gd, 'q1:'),
	                q3: _(gd, 'q3:'),
	                max: _(gd, 'max:'),
	                mean: trace.boxmean === 'sd' ? _(gd, 'mean ± σ:') : _(gd, 'mean:'),
	                lf: _(gd, 'lower fence:'),
	                uf: _(gd, 'upper fence:')
	            }
	        };
	
	        fullLayout[numKey]++;
	        return cd;
	    } else {
	        return [{t: {empty: true}}];
	    }
	};
	
	// In vertical (horizontal) box plots:
	// if no x (y) data, use x0 (y0), or name
	// so if you want one box
	// per trace, set x0 (y0) to the x (y) value or category for this trace
	// (or set x (y) to a constant array matching y (x))
	function getPos(trace, posLetter, posAxis, val, num) {
	    if(posLetter in trace) {
	        return posAxis.makeCalcdata(trace, posLetter);
	    }
	
	    var pos0;
	
	    if(posLetter + '0' in trace) {
	        pos0 = trace[posLetter + '0'];
	    } else if('name' in trace && (
	        posAxis.type === 'category' || (
	            isNumeric(trace.name) &&
	            ['linear', 'log'].indexOf(posAxis.type) !== -1
	        ) || (
	            Lib.isDateTime(trace.name) &&
	            posAxis.type === 'date'
	        )
	    )) {
	        pos0 = trace.name;
	    } else {
	        pos0 = num;
	    }
	
	    var pos0c = posAxis.type === 'multicategory' ?
	        posAxis.r2c_just_indices(pos0) :
	        posAxis.d2c(pos0, 0, trace[posLetter + 'calendar']);
	
	    return val.map(function() { return pos0c; });
	}
	
	function makeBins(x, dx) {
	    var len = x.length;
	    var bins = new Array(len + 1);
	
	    for(var i = 0; i < len; i++) {
	        bins[i] = x[i] - dx;
	    }
	    bins[len] = x[len - 1] + dx;
	
	    return bins;
	}
	
	function initNestedArray(len) {
	    var arr = new Array(len);
	    for(var i = 0; i < len; i++) {
	        arr[i] = [];
	    }
	    return arr;
	}
	
	function arraysToCalcdata(pt, trace, i) {
	    var trace2calc = {
	        text: 'tx',
	        hovertext: 'htx'
	    };
	
	    for(var k in trace2calc) {
	        if(Array.isArray(trace[k])) {
	            pt[trace2calc[k]] = trace[k][i];
	        }
	    }
	}
	
	function calcSelection(cd, trace) {
	    if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	        for(var i = 0; i < cd.length; i++) {
	            var pts = cd[i].pts || [];
	            var ptNumber2cdIndex = {};
	
	            for(var j = 0; j < pts.length; j++) {
	                ptNumber2cdIndex[pts[j].i] = j;
	            }
	
	            Lib.tagSelected(pts, trace, ptNumber2cdIndex);
	        }
	    }
	}
	
	function sortByVal(a, b) { return a.v - b.v; }
	
	function extractVal(o) { return o.v; }
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"fast-isnumeric":227}],881:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
	
	var orientations = ['v', 'h'];
	
	function crossTraceCalc(gd, plotinfo) {
	    var calcdata = gd.calcdata;
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    for(var i = 0; i < orientations.length; i++) {
	        var orientation = orientations[i];
	        var posAxis = orientation === 'h' ? ya : xa;
	        var boxList = [];
	
	        // make list of boxes / candlesticks
	        // For backward compatibility, candlesticks are treated as if they *are* box traces here
	        for(var j = 0; j < calcdata.length; j++) {
	            var cd = calcdata[j];
	            var t = cd[0].t;
	            var trace = cd[0].trace;
	
	            if(trace.visible === true &&
	                    (trace.type === 'box' || trace.type === 'candlestick') &&
	                    !t.empty &&
	                    (trace.orientation || 'v') === orientation &&
	                    trace.xaxis === xa._id &&
	                    trace.yaxis === ya._id
	              ) {
	                boxList.push(j);
	            }
	        }
	
	        setPositionOffset('box', gd, boxList, posAxis);
	    }
	}
	
	function setPositionOffset(traceType, gd, boxList, posAxis) {
	    var calcdata = gd.calcdata;
	    var fullLayout = gd._fullLayout;
	    var axId = posAxis._id;
	    var axLetter = axId.charAt(0);
	
	    var i, j, calcTrace;
	    var pointList = [];
	    var shownPts = 0;
	
	    // make list of box points
	    for(i = 0; i < boxList.length; i++) {
	        calcTrace = calcdata[boxList[i]];
	        for(j = 0; j < calcTrace.length; j++) {
	            pointList.push(posAxis.c2l(calcTrace[j].pos, true));
	            shownPts += (calcTrace[j].pts2 || []).length;
	        }
	    }
	
	    if(!pointList.length) return;
	
	    // box plots - update dPos based on multiple traces
	    var boxdv = Lib.distinctVals(pointList);
	    var dPos0 = boxdv.minDiff / 2;
	
	    // check for forced minimum dtick
	    Axes.minDtick(posAxis, boxdv.minDiff, boxdv.vals[0], true);
	
	    var numKey = traceType === 'violin' ? '_numViolins' : '_numBoxes';
	    var numTotal = fullLayout[numKey];
	    var group = fullLayout[traceType + 'mode'] === 'group' && numTotal > 1;
	    var groupFraction = 1 - fullLayout[traceType + 'gap'];
	    var groupGapFraction = 1 - fullLayout[traceType + 'groupgap'];
	
	    for(i = 0; i < boxList.length; i++) {
	        calcTrace = calcdata[boxList[i]];
	
	        var trace = calcTrace[0].trace;
	        var t = calcTrace[0].t;
	        var width = trace.width;
	        var side = trace.side;
	
	        // position coordinate delta
	        var dPos;
	        // box half width;
	        var bdPos;
	        // box center offset
	        var bPos;
	        // half-width within which to accept hover for this box/violin
	        // always split the distance to the closest box/violin
	        var wHover;
	
	        if(width) {
	            dPos = bdPos = wHover = width / 2;
	            bPos = 0;
	        } else {
	            dPos = dPos0;
	
	            if(group) {
	                var groupId = getAxisGroup(fullLayout, posAxis._id) + trace.orientation;
	                var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
	                var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
	                var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
	                var num = nOffsetGroups || numTotal;
	                var shift = nOffsetGroups ? trace._offsetIndex : t.num;
	
	                bdPos = dPos * groupFraction * groupGapFraction / num;
	                bPos = 2 * dPos * (-0.5 + (shift + 0.5) / num) * groupFraction;
	                wHover = dPos * groupFraction / num;
	            } else {
	                bdPos = dPos * groupFraction * groupGapFraction;
	                bPos = 0;
	                wHover = dPos;
	            }
	        }
	        t.dPos = dPos;
	        t.bPos = bPos;
	        t.bdPos = bdPos;
	        t.wHover = wHover;
	
	        // box/violin-only value-space push value
	        var pushplus;
	        var pushminus;
	        // edge of box/violin
	        var edge = bPos + bdPos;
	        var edgeplus;
	        var edgeminus;
	        // value-space padding
	        var vpadplus;
	        var vpadminus;
	        // pixel-space padding
	        var ppadplus;
	        var ppadminus;
	        // do we add 5% of both sides (more logic for points beyond box/violin below)
	        var padded = Boolean(width);
	        // does this trace show points?
	        var hasPts = (trace.boxpoints || trace.points) && (shownPts > 0);
	
	        if(side === 'positive') {
	            pushplus = dPos * (width ? 1 : 0.5);
	            edgeplus = edge;
	            pushminus = edgeplus = bPos;
	        } else if(side === 'negative') {
	            pushplus = edgeplus = bPos;
	            pushminus = dPos * (width ? 1 : 0.5);
	            edgeminus = edge;
	        } else {
	            pushplus = pushminus = dPos;
	            edgeplus = edgeminus = edge;
	        }
	
	        if(hasPts) {
	            var pointpos = trace.pointpos;
	            var jitter = trace.jitter;
	            var ms = trace.marker.size / 2;
	
	            var pp = 0;
	            if((pointpos + jitter) >= 0) {
	                pp = edge * (pointpos + jitter);
	                if(pp > pushplus) {
	                    // (++) beyond plus-value, use pp
	                    padded = true;
	                    ppadplus = ms;
	                    vpadplus = pp;
	                } else if(pp > edgeplus) {
	                    // (+), use push-value (it's bigger), but add px-pad
	                    ppadplus = ms;
	                    vpadplus = pushplus;
	                }
	            }
	            if(pp <= pushplus) {
	                // (->) fallback to push value
	                vpadplus = pushplus;
	            }
	
	            var pm = 0;
	            if((pointpos - jitter) <= 0) {
	                pm = -edge * (pointpos - jitter);
	                if(pm > pushminus) {
	                    // (--) beyond plus-value, use pp
	                    padded = true;
	                    ppadminus = ms;
	                    vpadminus = pm;
	                } else if(pm > edgeminus) {
	                    // (-), use push-value (it's bigger), but add px-pad
	                    ppadminus = ms;
	                    vpadminus = pushminus;
	                }
	            }
	            if(pm <= pushminus) {
	                // (<-) fallback to push value
	                vpadminus = pushminus;
	            }
	        } else {
	            vpadplus = pushplus;
	            vpadminus = pushminus;
	        }
	
	        var pos = new Array(calcTrace.length);
	        for(j = 0; j < calcTrace.length; j++) {
	            pos[j] = calcTrace[j].pos;
	        }
	
	        trace._extremes[axId] = Axes.findExtremes(posAxis, pos, {
	            padded: padded,
	            vpadminus: vpadminus,
	            vpadplus: vpadplus,
	            vpadLinearized: true,
	            // N.B. SVG px-space positive/negative
	            ppadminus: {x: ppadminus, y: ppadplus}[axLetter],
	            ppadplus: {x: ppadplus, y: ppadminus}[axLetter],
	        });
	    }
	}
	
	module.exports = {
	    crossTraceCalc: crossTraceCalc,
	    setPositionOffset: setPositionOffset
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../../plots/cartesian/axis_ids":767}],882:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	var Color = _dereq_('../../components/color');
	var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
	var attributes = _dereq_('./attributes');
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    handleSampleDefaults(traceIn, traceOut, coerce, layout);
	    if(traceOut.visible === false) return;
	
	    coerce('line.color', (traceIn.marker || {}).color || defaultColor);
	    coerce('line.width');
	    coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
	
	    coerce('whiskerwidth');
	    coerce('boxmean');
	    coerce('width');
	
	    var notched = coerce('notched', traceIn.notchwidth !== undefined);
	    if(notched) coerce('notchwidth');
	
	    handlePointsDefaults(traceIn, traceOut, coerce, {prefix: 'box'});
	}
	
	function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
	    var y = coerce('y');
	    var x = coerce('x');
	    var hasX = x && x.length;
	
	    var defaultOrientation, len;
	
	    if(y && y.length) {
	        defaultOrientation = 'v';
	        if(hasX) {
	            len = Math.min(Lib.minRowLength(x), Lib.minRowLength(y));
	        } else {
	            coerce('x0');
	            len = Lib.minRowLength(y);
	        }
	    } else if(hasX) {
	        defaultOrientation = 'h';
	        coerce('y0');
	        len = Lib.minRowLength(x);
	    } else {
	        traceOut.visible = false;
	        return;
	    }
	    traceOut._length = len;
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
	
	    coerce('orientation', defaultOrientation);
	}
	
	function handlePointsDefaults(traceIn, traceOut, coerce, opts) {
	    var prefix = opts.prefix;
	
	    var outlierColorDflt = Lib.coerce2(traceIn, traceOut, attributes, 'marker.outliercolor');
	    var lineoutliercolor = coerce('marker.line.outliercolor');
	
	    var points = coerce(
	        prefix + 'points',
	        (outlierColorDflt || lineoutliercolor) ? 'suspectedoutliers' : undefined
	    );
	
	    if(points) {
	        coerce('jitter', points === 'all' ? 0.3 : 0);
	        coerce('pointpos', points === 'all' ? -1.5 : 0);
	
	        coerce('marker.symbol');
	        coerce('marker.opacity');
	        coerce('marker.size');
	        coerce('marker.color', traceOut.line.color);
	        coerce('marker.line.color');
	        coerce('marker.line.width');
	
	        if(points === 'suspectedoutliers') {
	            coerce('marker.line.outliercolor', traceOut.marker.color);
	            coerce('marker.line.outlierwidth');
	        }
	
	        coerce('selected.marker.color');
	        coerce('unselected.marker.color');
	        coerce('selected.marker.size');
	        coerce('unselected.marker.size');
	
	        coerce('text');
	        coerce('hovertext');
	    } else {
	        delete traceOut.marker;
	    }
	
	    var hoveron = coerce('hoveron');
	    if(hoveron === 'all' || hoveron.indexOf('points') !== -1) {
	        coerce('hovertemplate');
	    }
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	}
	
	function crossTraceDefaults(fullData, fullLayout) {
	    var traceIn, traceOut;
	
	    function coerce(attr) {
	        return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	    }
	
	    for(var i = 0; i < fullData.length; i++) {
	        traceOut = fullData[i];
	        var traceType = traceOut.type;
	
	        if(traceType === 'box' || traceType === 'violin') {
	            traceIn = traceOut._input;
	            if(fullLayout[traceType + 'mode'] === 'group') {
	                handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	            }
	        }
	    }
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults,
	    crossTraceDefaults: crossTraceDefaults,
	
	    handleSampleDefaults: handleSampleDefaults,
	    handlePointsDefaults: handlePointsDefaults
	};
	
	},{"../../components/color":591,"../../lib":716,"../../registry":845,"../bar/defaults":859,"./attributes":879}],883:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt) {
	    // Note: hoverOnBox property is needed for click-to-select
	    // to ignore when a box was clicked. This is the reason box
	    // implements this custom eventData function.
	    if(pt.hoverOnBox) out.hoverOnBox = pt.hoverOnBox;
	
	    if('xVal' in pt) out.x = pt.xVal;
	    if('yVal' in pt) out.y = pt.yVal;
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    return out;
	};
	
	},{}],884:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	var Fx = _dereq_('../../components/fx');
	var Color = _dereq_('../../components/color');
	var fillText = Lib.fillText;
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var hoveron = trace.hoveron;
	    var closeBoxData = [];
	    var closePtData;
	
	    if(hoveron.indexOf('boxes') !== -1) {
	        closeBoxData = closeBoxData.concat(hoverOnBoxes(pointData, xval, yval, hovermode));
	    }
	
	    if(hoveron.indexOf('points') !== -1) {
	        closePtData = hoverOnPoints(pointData, xval, yval);
	    }
	
	    // If there's a point in range and hoveron has points, show the best single point only.
	    // If hoveron has boxes and there's no point in range (or hoveron doesn't have points), show the box stats.
	    if(hovermode === 'closest') {
	        if(closePtData) return [closePtData];
	        return closeBoxData;
	    }
	
	    // Otherwise in compare mode, allow a point AND the box stats to be labeled
	    // If there are multiple boxes in range (ie boxmode = 'overlay') we'll see stats for all of them.
	    if(closePtData) {
	        closeBoxData.push(closePtData);
	        return closeBoxData;
	    }
	    return closeBoxData;
	}
	
	function hoverOnBoxes(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var trace = cd[0].trace;
	    var t = cd[0].t;
	    var isViolin = trace.type === 'violin';
	    var closeBoxData = [];
	
	    var pLetter, vLetter, pAxis, vAxis, vVal, pVal, dx, dy, dPos,
	        hoverPseudoDistance, spikePseudoDistance;
	
	    var boxDelta = t.bdPos;
	    var boxDeltaPos, boxDeltaNeg;
	    var posAcceptance = t.wHover;
	    var shiftPos = function(di) { return pAxis.c2l(di.pos) + t.bPos - pAxis.c2l(pVal); };
	
	    if(isViolin && trace.side !== 'both') {
	        if(trace.side === 'positive') {
	            dPos = function(di) {
	                var pos = shiftPos(di);
	                return Fx.inbox(pos, pos + posAcceptance, hoverPseudoDistance);
	            };
	            boxDeltaPos = boxDelta;
	            boxDeltaNeg = 0;
	        }
	        if(trace.side === 'negative') {
	            dPos = function(di) {
	                var pos = shiftPos(di);
	                return Fx.inbox(pos - posAcceptance, pos, hoverPseudoDistance);
	            };
	            boxDeltaPos = 0;
	            boxDeltaNeg = boxDelta;
	        }
	    } else {
	        dPos = function(di) {
	            var pos = shiftPos(di);
	            return Fx.inbox(pos - posAcceptance, pos + posAcceptance, hoverPseudoDistance);
	        };
	        boxDeltaPos = boxDeltaNeg = boxDelta;
	    }
	
	    var dVal;
	
	    if(isViolin) {
	        dVal = function(di) {
	            return Fx.inbox(di.span[0] - vVal, di.span[1] - vVal, hoverPseudoDistance);
	        };
	    } else {
	        dVal = function(di) {
	            return Fx.inbox(di.min - vVal, di.max - vVal, hoverPseudoDistance);
	        };
	    }
	
	    if(trace.orientation === 'h') {
	        vVal = xval;
	        pVal = yval;
	        dx = dVal;
	        dy = dPos;
	        pLetter = 'y';
	        pAxis = ya;
	        vLetter = 'x';
	        vAxis = xa;
	    } else {
	        vVal = yval;
	        pVal = xval;
	        dx = dPos;
	        dy = dVal;
	        pLetter = 'x';
	        pAxis = xa;
	        vLetter = 'y';
	        vAxis = ya;
	    }
	
	    // if two boxes are overlaying, let the narrowest one win
	    var pseudoDistance = Math.min(1, boxDelta / Math.abs(pAxis.r2c(pAxis.range[1]) - pAxis.r2c(pAxis.range[0])));
	    hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
	    spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
	
	    function dxy(di) { return (dx(di) + dy(di)) / 2; }
	    var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	    Fx.getClosest(cd, distfn, pointData);
	
	    // skip the rest (for this trace) if we didn't find a close point
	    // and create the item(s) in closedata for this point
	    if(pointData.index === false) return [];
	
	    var di = cd[pointData.index];
	    var lc = trace.line.color;
	    var mc = (trace.marker || {}).color;
	
	    if(Color.opacity(lc) && trace.line.width) pointData.color = lc;
	    else if(Color.opacity(mc) && trace.boxpoints) pointData.color = mc;
	    else pointData.color = trace.fillcolor;
	
	    pointData[pLetter + '0'] = pAxis.c2p(di.pos + t.bPos - boxDeltaNeg, true);
	    pointData[pLetter + '1'] = pAxis.c2p(di.pos + t.bPos + boxDeltaPos, true);
	
	    pointData[pLetter + 'LabelVal'] = di.pos;
	
	    var spikePosAttr = pLetter + 'Spike';
	    pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
	    pointData[spikePosAttr] = pAxis.c2p(di.pos, true);
	
	    // box plots: each "point" gets many labels
	    var usedVals = {};
	    var attrs = ['med', 'q1', 'q3', 'min', 'max'];
	
	    if(trace.boxmean || (trace.meanline || {}).visible) {
	        attrs.push('mean');
	    }
	    if(trace.boxpoints || trace.points) {
	        attrs.push('lf', 'uf');
	    }
	
	    for(var i = 0; i < attrs.length; i++) {
	        var attr = attrs[i];
	
	        if(!(attr in di) || (di[attr] in usedVals)) continue;
	        usedVals[di[attr]] = true;
	
	        // copy out to a new object for each value to label
	        var val = di[attr];
	        var valPx = vAxis.c2p(val, true);
	        var pointData2 = Lib.extendFlat({}, pointData);
	
	        pointData2.attr = attr;
	        pointData2[vLetter + '0'] = pointData2[vLetter + '1'] = valPx;
	        pointData2[vLetter + 'LabelVal'] = val;
	        pointData2[vLetter + 'Label'] = (t.labels ? t.labels[attr] + ' ' : '') + Axes.hoverLabelText(vAxis, val);
	
	        // Note: introduced to be able to distinguish a
	        // clicked point from a box during click-to-select
	        pointData2.hoverOnBox = true;
	
	        if(attr === 'mean' && ('sd' in di) && trace.boxmean === 'sd') {
	            pointData2[vLetter + 'err'] = di.sd;
	        }
	
	        // only keep name and spikes on the first item (median)
	        pointData.name = '';
	        pointData.spikeDistance = undefined;
	        pointData[spikePosAttr] = undefined;
	
	        // no hovertemplate support yet
	        pointData2.hovertemplate = false;
	
	        closeBoxData.push(pointData2);
	    }
	
	    return closeBoxData;
	}
	
	function hoverOnPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var trace = cd[0].trace;
	    var xPx = xa.c2p(xval);
	    var yPx = ya.c2p(yval);
	    var closePtData;
	
	    var dx = function(di) {
	        var rad = Math.max(3, di.mrc || 0);
	        return Math.max(Math.abs(xa.c2p(di.x) - xPx) - rad, 1 - 3 / rad);
	    };
	    var dy = function(di) {
	        var rad = Math.max(3, di.mrc || 0);
	        return Math.max(Math.abs(ya.c2p(di.y) - yPx) - rad, 1 - 3 / rad);
	    };
	    var distfn = Fx.quadrature(dx, dy);
	
	    // show one point per trace
	    var ijClosest = false;
	    var di, pt;
	
	    for(var i = 0; i < cd.length; i++) {
	        di = cd[i];
	
	        for(var j = 0; j < (di.pts || []).length; j++) {
	            pt = di.pts[j];
	
	            var newDistance = distfn(pt);
	            if(newDistance <= pointData.distance) {
	                pointData.distance = newDistance;
	                ijClosest = [i, j];
	            }
	        }
	    }
	
	    if(!ijClosest) return false;
	
	    di = cd[ijClosest[0]];
	    pt = di.pts[ijClosest[1]];
	
	    var xc = xa.c2p(pt.x, true);
	    var yc = ya.c2p(pt.y, true);
	    var rad = pt.mrc || 1;
	
	    closePtData = Lib.extendFlat({}, pointData, {
	        // corresponds to index in x/y input data array
	        index: pt.i,
	        color: (trace.marker || {}).color,
	        name: trace.name,
	        x0: xc - rad,
	        x1: xc + rad,
	        y0: yc - rad,
	        y1: yc + rad,
	        spikeDistance: pointData.distance,
	        hovertemplate: trace.hovertemplate
	    });
	
	    var pa;
	    if(trace.orientation === 'h') {
	        pa = ya;
	        closePtData.xLabelVal = pt.x;
	        closePtData.yLabelVal = di.pos;
	    } else {
	        pa = xa;
	        closePtData.xLabelVal = di.pos;
	        closePtData.yLabelVal = pt.y;
	    }
	
	    var pLetter = pa._id.charAt(0);
	    closePtData[pLetter + 'Spike'] = pa.c2p(di.pos, true);
	
	    fillText(pt, trace, closePtData);
	
	    return closePtData;
	}
	
	module.exports = {
	    hoverPoints: hoverPoints,
	    hoverOnBoxes: hoverOnBoxes,
	    hoverOnPoints: hoverOnPoints
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../lib":716,"../../plots/cartesian/axes":764}],885:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
	    supplyLayoutDefaults: _dereq_('./layout_defaults').supplyLayoutDefaults,
	    calc: _dereq_('./calc'),
	    crossTraceCalc: _dereq_('./cross_trace_calc').crossTraceCalc,
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style').style,
	    styleOnSelect: _dereq_('./style').styleOnSelect,
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    eventData: _dereq_('./event_data'),
	    selectPoints: _dereq_('./select'),
	
	    moduleType: 'trace',
	    name: 'box',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'boxLayout', 'zoomScale'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./attributes":879,"./calc":880,"./cross_trace_calc":881,"./defaults":882,"./event_data":883,"./hover":884,"./layout_attributes":886,"./layout_defaults":887,"./plot":888,"./select":889,"./style":890}],886:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    boxmode: {
	        valType: 'enumerated',
	        values: ['group', 'overlay'],
	        dflt: 'overlay',
	        
	        editType: 'calc',
	        
	    },
	    boxgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0.3,
	        
	        editType: 'calc',
	        
	    },
	    boxgroupgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0.3,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],887:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	function _supply(layoutIn, layoutOut, fullData, coerce, traceType) {
	    var category = traceType + 'Layout';
	    var hasTraceType = false;
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	
	        if(Registry.traceIs(trace, category)) {
	            hasTraceType = true;
	            break;
	        }
	    }
	    if(!hasTraceType) return;
	
	    coerce(traceType + 'mode');
	    coerce(traceType + 'gap');
	    coerce(traceType + 'groupgap');
	}
	
	function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	    _supply(layoutIn, layoutOut, fullData, coerce, 'box');
	}
	
	module.exports = {
	    supplyLayoutDefaults: supplyLayoutDefaults,
	    _supply: _supply
	};
	
	},{"../../lib":716,"../../registry":845,"./layout_attributes":886}],888:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	
	// constants for dynamic jitter (ie less jitter for sparser points)
	var JITTERCOUNT = 5; // points either side of this to include
	var JITTERSPREAD = 0.01; // fraction of IQR to count as "dense"
	
	function plot(gd, plotinfo, cdbox, boxLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(boxLayer, cdbox, 'trace boxes').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var t = cd0.t;
	        var trace = cd0.trace;
	
	        // whisker width
	        t.wdPos = t.bdPos * trace.whiskerwidth;
	
	        if(trace.visible !== true || t.empty) {
	            plotGroup.remove();
	            return;
	        }
	
	        var posAxis, valAxis;
	
	        if(trace.orientation === 'h') {
	            posAxis = ya;
	            valAxis = xa;
	        } else {
	            posAxis = xa;
	            valAxis = ya;
	        }
	
	        plotBoxAndWhiskers(plotGroup, {pos: posAxis, val: valAxis}, trace, t);
	        plotPoints(plotGroup, {x: xa, y: ya}, trace, t);
	        plotBoxMean(plotGroup, {pos: posAxis, val: valAxis}, trace, t);
	    });
	}
	
	function plotBoxAndWhiskers(sel, axes, trace, t) {
	    var posAxis = axes.pos;
	    var valAxis = axes.val;
	    var bPos = t.bPos;
	    var wdPos = t.wdPos || 0;
	    var bPosPxOffset = t.bPosPxOffset || 0;
	    var whiskerWidth = trace.whiskerwidth || 0;
	    var notched = trace.notched || false;
	    var nw = notched ? 1 - 2 * trace.notchwidth : 1;
	
	    // to support for one-sided box
	    var bdPos0;
	    var bdPos1;
	    if(Array.isArray(t.bdPos)) {
	        bdPos0 = t.bdPos[0];
	        bdPos1 = t.bdPos[1];
	    } else {
	        bdPos0 = t.bdPos;
	        bdPos1 = t.bdPos;
	    }
	
	    var paths = sel.selectAll('path.box').data((
	        trace.type !== 'violin' ||
	        trace.box.visible
	    ) ? Lib.identity : []);
	
	    paths.enter().append('path')
	        .style('vector-effect', 'non-scaling-stroke')
	        .attr('class', 'box');
	
	    paths.exit().remove();
	
	    paths.each(function(d) {
	        if(d.empty) return 'M0,0Z';
	
	        var lcenter = posAxis.c2l(d.pos + bPos, true);
	        var posc = posAxis.l2p(lcenter) + bPosPxOffset;
	        var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
	        var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
	        var posw0 = posAxis.l2p(lcenter - wdPos) + bPosPxOffset;
	        var posw1 = posAxis.l2p(lcenter + wdPos) + bPosPxOffset;
	        var posm0 = posAxis.l2p(lcenter - bdPos0 * nw) + bPosPxOffset;
	        var posm1 = posAxis.l2p(lcenter + bdPos1 * nw) + bPosPxOffset;
	        var q1 = valAxis.c2p(d.q1, true);
	        var q3 = valAxis.c2p(d.q3, true);
	        // make sure median isn't identical to either of the
	        // quartiles, so we can see it
	        var m = Lib.constrain(
	            valAxis.c2p(d.med, true),
	            Math.min(q1, q3) + 1, Math.max(q1, q3) - 1
	        );
	
	        // for compatibility with box, violin, and candlestick
	        // perhaps we should put this into cd0.t instead so it's more explicit,
	        // but what we have now is:
	        // - box always has d.lf, but boxpoints can be anything
	        // - violin has d.lf and should always use it (boxpoints is undefined)
	        // - candlestick has only min/max
	        var useExtremes = (d.lf === undefined) || (trace.boxpoints === false);
	        var lf = valAxis.c2p(useExtremes ? d.min : d.lf, true);
	        var uf = valAxis.c2p(useExtremes ? d.max : d.uf, true);
	        var ln = valAxis.c2p(d.ln, true);
	        var un = valAxis.c2p(d.un, true);
	
	        if(trace.orientation === 'h') {
	            d3.select(this).attr('d',
	                'M' + m + ',' + posm0 + 'V' + posm1 + // median line
	                'M' + q1 + ',' + pos0 + 'V' + pos1 + // left edge
	                (notched ? 'H' + ln + 'L' + m + ',' + posm1 + 'L' + un + ',' + pos1 : '') + // top notched edge
	                'H' + q3 + // end of the top edge
	                'V' + pos0 + // right edge
	                (notched ? 'H' + un + 'L' + m + ',' + posm0 + 'L' + ln + ',' + pos0 : '') + // bottom notched edge
	                'Z' + // end of the box
	                'M' + q1 + ',' + posc + 'H' + lf + 'M' + q3 + ',' + posc + 'H' + uf + // whiskers
	                ((whiskerWidth === 0) ? '' : // whisker caps
	                    'M' + lf + ',' + posw0 + 'V' + posw1 + 'M' + uf + ',' + posw0 + 'V' + posw1));
	        } else {
	            d3.select(this).attr('d',
	                'M' + posm0 + ',' + m + 'H' + posm1 + // median line
	                'M' + pos0 + ',' + q1 + 'H' + pos1 + // top of the box
	                (notched ? 'V' + ln + 'L' + posm1 + ',' + m + 'L' + pos1 + ',' + un : '') + // notched right edge
	                'V' + q3 + // end of the right edge
	                'H' + pos0 + // bottom of the box
	                (notched ? 'V' + un + 'L' + posm0 + ',' + m + 'L' + pos0 + ',' + ln : '') + // notched left edge
	                'Z' + // end of the box
	                'M' + posc + ',' + q1 + 'V' + lf + 'M' + posc + ',' + q3 + 'V' + uf + // whiskers
	                ((whiskerWidth === 0) ? '' : // whisker caps
	                    'M' + posw0 + ',' + lf + 'H' + posw1 + 'M' + posw0 + ',' + uf + 'H' + posw1));
	        }
	    });
	}
	
	function plotPoints(sel, axes, trace, t) {
	    var xa = axes.x;
	    var ya = axes.y;
	    var bdPos = t.bdPos;
	    var bPos = t.bPos;
	
	    // to support violin points
	    var mode = trace.boxpoints || trace.points;
	
	    // repeatable pseudo-random number generator
	    Lib.seedPseudoRandom();
	
	    // since box plot points get an extra level of nesting, each
	    // box needs the trace styling info
	    var fn = function(d) {
	        d.forEach(function(v) {
	            v.t = t;
	            v.trace = trace;
	        });
	        return d;
	    };
	
	    var gPoints = sel.selectAll('g.points')
	        .data(mode ? fn : []);
	
	    gPoints.enter().append('g')
	        .attr('class', 'points');
	
	    gPoints.exit().remove();
	
	    var paths = gPoints.selectAll('path')
	        .data(function(d) {
	            var i;
	            var pts = d.pts2;
	
	            // normally use IQR, but if this is 0 or too small, use max-min
	            var typicalSpread = Math.max((d.max - d.min) / 10, d.q3 - d.q1);
	            var minSpread = typicalSpread * 1e-9;
	            var spreadLimit = typicalSpread * JITTERSPREAD;
	            var jitterFactors = [];
	            var maxJitterFactor = 0;
	            var newJitter;
	
	            // dynamic jitter
	            if(trace.jitter) {
	                if(typicalSpread === 0) {
	                    // edge case of no spread at all: fall back to max jitter
	                    maxJitterFactor = 1;
	                    jitterFactors = new Array(pts.length);
	                    for(i = 0; i < pts.length; i++) {
	                        jitterFactors[i] = 1;
	                    }
	                } else {
	                    for(i = 0; i < pts.length; i++) {
	                        var i0 = Math.max(0, i - JITTERCOUNT);
	                        var pmin = pts[i0].v;
	                        var i1 = Math.min(pts.length - 1, i + JITTERCOUNT);
	                        var pmax = pts[i1].v;
	
	                        if(mode !== 'all') {
	                            if(pts[i].v < d.lf) pmax = Math.min(pmax, d.lf);
	                            else pmin = Math.max(pmin, d.uf);
	                        }
	
	                        var jitterFactor = Math.sqrt(spreadLimit * (i1 - i0) / (pmax - pmin + minSpread)) || 0;
	                        jitterFactor = Lib.constrain(Math.abs(jitterFactor), 0, 1);
	
	                        jitterFactors.push(jitterFactor);
	                        maxJitterFactor = Math.max(jitterFactor, maxJitterFactor);
	                    }
	                }
	                newJitter = trace.jitter * 2 / (maxJitterFactor || 1);
	            }
	
	            // fills in 'x' and 'y' in calcdata 'pts' item
	            for(i = 0; i < pts.length; i++) {
	                var pt = pts[i];
	                var v = pt.v;
	
	                var jitterOffset = trace.jitter ?
	                    (newJitter * jitterFactors[i] * (Lib.pseudoRandom() - 0.5)) :
	                    0;
	
	                var posPx = d.pos + bPos + bdPos * (trace.pointpos + jitterOffset);
	
	                if(trace.orientation === 'h') {
	                    pt.y = posPx;
	                    pt.x = v;
	                } else {
	                    pt.x = posPx;
	                    pt.y = v;
	                }
	
	                // tag suspected outliers
	                if(mode === 'suspectedoutliers' && v < d.uo && v > d.lo) {
	                    pt.so = true;
	                }
	            }
	
	            return pts;
	        });
	
	    paths.enter().append('path')
	        .classed('point', true);
	
	    paths.exit().remove();
	
	    paths.call(Drawing.translatePoints, xa, ya);
	}
	
	function plotBoxMean(sel, axes, trace, t) {
	    var posAxis = axes.pos;
	    var valAxis = axes.val;
	    var bPos = t.bPos;
	    var bPosPxOffset = t.bPosPxOffset || 0;
	
	    // to support violin mean lines
	    var mode = trace.boxmean || (trace.meanline || {}).visible;
	
	    // to support for one-sided box
	    var bdPos0;
	    var bdPos1;
	    if(Array.isArray(t.bdPos)) {
	        bdPos0 = t.bdPos[0];
	        bdPos1 = t.bdPos[1];
	    } else {
	        bdPos0 = t.bdPos;
	        bdPos1 = t.bdPos;
	    }
	
	    var paths = sel.selectAll('path.mean').data((
	        (trace.type === 'box' && trace.boxmean) ||
	        (trace.type === 'violin' && trace.box.visible && trace.meanline.visible)
	    ) ? Lib.identity : []);
	
	    paths.enter().append('path')
	        .attr('class', 'mean')
	        .style({
	            fill: 'none',
	            'vector-effect': 'non-scaling-stroke'
	        });
	
	    paths.exit().remove();
	
	    paths.each(function(d) {
	        var lcenter = posAxis.c2l(d.pos + bPos, true);
	        var posc = posAxis.l2p(lcenter) + bPosPxOffset;
	        var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
	        var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
	        var m = valAxis.c2p(d.mean, true);
	        var sl = valAxis.c2p(d.mean - d.sd, true);
	        var sh = valAxis.c2p(d.mean + d.sd, true);
	
	        if(trace.orientation === 'h') {
	            d3.select(this).attr('d',
	                'M' + m + ',' + pos0 + 'V' + pos1 +
	                (mode === 'sd' ?
	                    'm0,0L' + sl + ',' + posc + 'L' + m + ',' + pos0 + 'L' + sh + ',' + posc + 'Z' :
	                    '')
	            );
	        } else {
	            d3.select(this).attr('d',
	                'M' + pos0 + ',' + m + 'H' + pos1 +
	                (mode === 'sd' ?
	                    'm0,0L' + posc + ',' + sl + 'L' + pos0 + ',' + m + 'L' + posc + ',' + sh + 'Z' :
	                    '')
	            );
	        }
	    });
	}
	
	module.exports = {
	    plot: plot,
	    plotBoxAndWhiskers: plotBoxAndWhiskers,
	    plotPoints: plotPoints,
	    plotBoxMean: plotBoxMean
	};
	
	},{"../../components/drawing":612,"../../lib":716,"d3":164}],889:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	    var i, j;
	
	    if(selectionTester === false) {
	        for(i = 0; i < cd.length; i++) {
	            for(j = 0; j < (cd[i].pts || []).length; j++) {
	                // clear selection
	                cd[i].pts[j].selected = 0;
	            }
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            for(j = 0; j < (cd[i].pts || []).length; j++) {
	                var pt = cd[i].pts[j];
	                var x = xa.c2p(pt.x);
	                var y = ya.c2p(pt.y);
	
	                if(selectionTester.contains([x, y], null, pt.i, searchInfo)) {
	                    selection.push({
	                        pointNumber: pt.i,
	                        x: xa.c2d(pt.x),
	                        y: ya.c2d(pt.y)
	                    });
	                    pt.selected = 1;
	                } else {
	                    pt.selected = 0;
	                }
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{}],890:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	
	function style(gd, cd, sel) {
	    var s = sel ? sel : d3.select(gd).selectAll('g.trace.boxes');
	
	    s.style('opacity', function(d) { return d[0].trace.opacity; });
	
	    s.each(function(d) {
	        var el = d3.select(this);
	        var trace = d[0].trace;
	        var lineWidth = trace.line.width;
	
	        function styleBox(boxSel, lineWidth, lineColor, fillColor) {
	            boxSel.style('stroke-width', lineWidth + 'px')
	                .call(Color.stroke, lineColor)
	                .call(Color.fill, fillColor);
	        }
	
	        var allBoxes = el.selectAll('path.box');
	
	        if(trace.type === 'candlestick') {
	            allBoxes.each(function(boxData) {
	                if(boxData.empty) return;
	
	                var thisBox = d3.select(this);
	                var container = trace[boxData.dir]; // dir = 'increasing' or 'decreasing'
	                styleBox(thisBox, container.line.width, container.line.color, container.fillcolor);
	                // TODO: custom selection style for candlesticks
	                thisBox.style('opacity', trace.selectedpoints && !boxData.selected ? 0.3 : 1);
	            });
	        } else {
	            styleBox(allBoxes, lineWidth, trace.line.color, trace.fillcolor);
	            el.selectAll('path.mean')
	                .style({
	                    'stroke-width': lineWidth,
	                    'stroke-dasharray': (2 * lineWidth) + 'px,' + lineWidth + 'px'
	                })
	                .call(Color.stroke, trace.line.color);
	
	            var pts = el.selectAll('path.point');
	            Drawing.pointStyle(pts, trace, gd);
	        }
	    });
	}
	
	function styleOnSelect(gd, cd, sel) {
	    var trace = cd[0].trace;
	    var pts = sel.selectAll('path.point');
	
	    if(trace.selectedpoints) {
	        Drawing.selectedPointStyle(pts, trace);
	    } else {
	        Drawing.pointStyle(pts, trace, gd);
	    }
	}
	
	module.exports = {
	    style: style,
	    styleOnSelect: styleOnSelect
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"d3":164}],891:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib').extendFlat;
	var OHLCattrs = _dereq_('../ohlc/attributes');
	var boxAttrs = _dereq_('../box/attributes');
	
	function directionAttrs(lineColorDefault) {
	    return {
	        line: {
	            color: extendFlat({}, boxAttrs.line.color, {dflt: lineColorDefault}),
	            width: boxAttrs.line.width,
	            editType: 'style'
	        },
	
	        fillcolor: boxAttrs.fillcolor,
	        editType: 'style'
	    };
	}
	
	module.exports = {
	    x: OHLCattrs.x,
	    open: OHLCattrs.open,
	    high: OHLCattrs.high,
	    low: OHLCattrs.low,
	    close: OHLCattrs.close,
	
	    line: {
	        width: extendFlat({}, boxAttrs.line.width, {
	            
	        }),
	        editType: 'style'
	    },
	
	    increasing: directionAttrs(OHLCattrs.increasing.line.color.dflt),
	
	    decreasing: directionAttrs(OHLCattrs.decreasing.line.color.dflt),
	
	    text: OHLCattrs.text,
	    hovertext: OHLCattrs.hovertext,
	    whiskerwidth: extendFlat({}, boxAttrs.whiskerwidth, { dflt: 0 }),
	
	    hoverlabel: OHLCattrs.hoverlabel,
	};
	
	},{"../../lib":716,"../box/attributes":879,"../ohlc/attributes":1064}],892:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var calcCommon = _dereq_('../ohlc/calc').calcCommon;
	
	module.exports = function(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var xa = Axes.getFromId(gd, trace.xaxis);
	    var ya = Axes.getFromId(gd, trace.yaxis);
	
	    var x = xa.makeCalcdata(trace, 'x');
	
	    var cd = calcCommon(gd, trace, x, ya, ptFunc);
	
	    if(cd.length) {
	        Lib.extendFlat(cd[0].t, {
	            num: fullLayout._numBoxes,
	            dPos: Lib.distinctVals(x).minDiff / 2,
	            posLetter: 'x',
	            valLetter: 'y',
	        });
	
	        fullLayout._numBoxes++;
	        return cd;
	    } else {
	        return [{t: {empty: true}}];
	    }
	};
	
	function ptFunc(o, h, l, c) {
	    return {
	        min: l,
	        q1: Math.min(o, c),
	        med: c,
	        q3: Math.max(o, c),
	        max: h,
	    };
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../ohlc/calc":1065}],893:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var handleOHLC = _dereq_('../ohlc/ohlc_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleOHLC(traceIn, traceOut, coerce, layout);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('line.width');
	
	    handleDirection(traceIn, traceOut, coerce, 'increasing');
	    handleDirection(traceIn, traceOut, coerce, 'decreasing');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('whiskerwidth');
	
	    layout._requestRangeslider[traceOut.xaxis] = true;
	};
	
	function handleDirection(traceIn, traceOut, coerce, direction) {
	    var lineColor = coerce(direction + '.line.color');
	    coerce(direction + '.line.width', traceOut.line.width);
	    coerce(direction + '.fillcolor', Color.addOpacity(lineColor, 0.5));
	}
	
	},{"../../components/color":591,"../../lib":716,"../ohlc/ohlc_defaults":1069,"./attributes":891}],894:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'candlestick',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'showLegend', 'candlestick', 'boxLayout'],
	    meta: {
	        
	    },
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('../box/layout_attributes'),
	    supplyLayoutDefaults: _dereq_('../box/layout_defaults').supplyLayoutDefaults,
	    crossTraceCalc: _dereq_('../box/cross_trace_calc').crossTraceCalc,
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('../box/plot').plot,
	    layerName: 'boxlayer',
	    style: _dereq_('../box/style').style,
	    hoverPoints: _dereq_('../ohlc/hover').hoverPoints,
	    selectPoints: _dereq_('../ohlc/select')
	};
	
	},{"../../plots/cartesian":775,"../box/cross_trace_calc":881,"../box/layout_attributes":886,"../box/layout_defaults":887,"../box/plot":888,"../box/style":890,"../ohlc/hover":1067,"../ohlc/select":1071,"./attributes":891,"./calc":892,"./defaults":893}],895:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var handleAxisDefaults = _dereq_('./axis_defaults');
	var Template = _dereq_('../../plot_api/plot_template');
	
	module.exports = function handleABDefaults(traceIn, traceOut, fullLayout, coerce, dfltColor) {
	    var a = coerce('a');
	
	    if(!a) {
	        coerce('da');
	        coerce('a0');
	    }
	
	    var b = coerce('b');
	
	    if(!b) {
	        coerce('db');
	        coerce('b0');
	    }
	
	    mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor);
	};
	
	function mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor) {
	    var axesList = ['aaxis', 'baxis'];
	
	    axesList.forEach(function(axName) {
	        var axLetter = axName.charAt(0);
	        var axIn = traceIn[axName] || {};
	        var axOut = Template.newContainer(traceOut, axName);
	
	        var defaultOptions = {
	            tickfont: 'x',
	            id: axLetter + 'axis',
	            letter: axLetter,
	            font: traceOut.font,
	            name: axName,
	            data: traceIn[axLetter],
	            calendar: traceOut.calendar,
	            dfltColor: dfltColor,
	            bgColor: fullLayout.paper_bgcolor,
	            fullLayout: fullLayout
	        };
	
	        handleAxisDefaults(axIn, axOut, defaultOptions);
	        axOut._categories = axOut._categories || [];
	
	        // so we don't have to repeat autotype unnecessarily,
	        // copy an autotype back to traceIn
	        if(!traceIn[axName] && axIn.type !== '-') {
	            traceIn[axName] = {type: axIn.type};
	        }
	    });
	}
	
	},{"../../plot_api/plot_template":754,"./axis_defaults":900}],896:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	module.exports = function(a) {
	    return minMax(a, 0);
	};
	
	function minMax(a, depth) {
	    // Limit to ten dimensional datasets. This seems *exceedingly* unlikely to
	    // ever cause problems or even be a concern. It's include strictly so that
	    // circular arrays could never cause this to loop.
	    if(!isArrayOrTypedArray(a) || depth >= 10) {
	        return null;
	    }
	
	    var min = Infinity;
	    var max = -Infinity;
	    var n = a.length;
	    for(var i = 0; i < n; i++) {
	        var datum = a[i];
	
	        if(isArrayOrTypedArray(datum)) {
	            var result = minMax(datum, depth + 1);
	
	            if(result) {
	                min = Math.min(result[0], min);
	                max = Math.max(result[1], max);
	            }
	        } else {
	            min = Math.min(datum, min);
	            max = Math.max(datum, max);
	        }
	    }
	
	    return [min, max];
	}
	
	},{"../../lib":716}],897:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var axisAttrs = _dereq_('./axis_attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	
	var carpetFont = fontAttrs({
	    editType: 'calc',
	    
	});
	// TODO: inherit from global font
	carpetFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
	carpetFont.size.dflt = 12;
	carpetFont.color.dflt = colorAttrs.defaultLine;
	
	module.exports = {
	    carpet: {
	        valType: 'string',
	        
	        editType: 'calc',
	        
	    },
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    a: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    a0: {
	        valType: 'number',
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    da: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    b: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    b0: {
	        valType: 'number',
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    db: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    cheaterslope: {
	        valType: 'number',
	        
	        dflt: 1,
	        editType: 'calc',
	        
	    },
	    aaxis: axisAttrs,
	    baxis: axisAttrs,
	    font: carpetFont,
	    color: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'plot',
	        
	    },
	    transforms: undefined
	};
	
	},{"../../components/color/attributes":590,"../../plots/font_attributes":790,"./axis_attributes":899}],898:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	/* This function retrns a set of control points that define a curve aligned along
	 * either the a or b axis. Exactly one of a or b must be an array defining the range
	 * spanned.
	 *
	 * Honestly this is the most complicated function I've implemente here so far because
	 * of the way it handles knot insertion and direction/axis-agnostic slices.
	 */
	module.exports = function(carpet, carpetcd, a, b) {
	    var idx, tangent, tanIsoIdx, tanIsoPar, segment, refidx;
	    var p0, p1, v0, v1, start, end, range;
	
	    var axis = isArrayOrTypedArray(a) ? 'a' : 'b';
	    var ax = axis === 'a' ? carpet.aaxis : carpet.baxis;
	    var smoothing = ax.smoothing;
	    var toIdx = axis === 'a' ? carpet.a2i : carpet.b2j;
	    var pt = axis === 'a' ? a : b;
	    var iso = axis === 'a' ? b : a;
	    var n = axis === 'a' ? carpetcd.a.length : carpetcd.b.length;
	    var m = axis === 'a' ? carpetcd.b.length : carpetcd.a.length;
	    var isoIdx = Math.floor(axis === 'a' ? carpet.b2j(iso) : carpet.a2i(iso));
	
	    var xy = axis === 'a' ? function(value) {
	        return carpet.evalxy([], value, isoIdx);
	    } : function(value) {
	        return carpet.evalxy([], isoIdx, value);
	    };
	
	    if(smoothing) {
	        tanIsoIdx = Math.max(0, Math.min(m - 2, isoIdx));
	        tanIsoPar = isoIdx - tanIsoIdx;
	        tangent = axis === 'a' ? function(i, ti) {
	            return carpet.dxydi([], i, tanIsoIdx, ti, tanIsoPar);
	        } : function(j, tj) {
	            return carpet.dxydj([], tanIsoIdx, j, tanIsoPar, tj);
	        };
	    }
	
	    var vstart = toIdx(pt[0]);
	    var vend = toIdx(pt[1]);
	
	    // So that we can make this work in two directions, flip all of the
	    // math functions if the direction is from higher to lower indices:
	    //
	    // Note that the tolerance is directional!
	    var dir = vstart < vend ? 1 : -1;
	    var tol = (vend - vstart) * 1e-8;
	    var dirfloor = dir > 0 ? Math.floor : Math.ceil;
	    var dirceil = dir > 0 ? Math.ceil : Math.floor;
	    var dirmin = dir > 0 ? Math.min : Math.max;
	    var dirmax = dir > 0 ? Math.max : Math.min;
	
	    var idx0 = dirfloor(vstart + tol);
	    var idx1 = dirceil(vend - tol);
	
	    p0 = xy(vstart);
	    var segments = [[p0]];
	
	    for(idx = idx0; idx * dir < idx1 * dir; idx += dir) {
	        segment = [];
	        start = dirmax(vstart, idx);
	        end = dirmin(vend, idx + dir);
	        range = end - start;
	
	        // In order to figure out which cell we're in for the derivative (remember,
	        // the derivatives are *not* constant across grid lines), let's just average
	        // the start and end points. This cuts out just a tiny bit of logic and
	        // there's really no computational difference:
	        refidx = Math.max(0, Math.min(n - 2, Math.floor(0.5 * (start + end))));
	
	        p1 = xy(end);
	        if(smoothing) {
	            v0 = tangent(refidx, start - refidx);
	            v1 = tangent(refidx, end - refidx);
	
	            segment.push([
	                p0[0] + v0[0] / 3 * range,
	                p0[1] + v0[1] / 3 * range
	            ]);
	
	            segment.push([
	                p1[0] - v1[0] / 3 * range,
	                p1[1] - v1[1] / 3 * range
	            ]);
	        }
	
	        segment.push(p1);
	
	        segments.push(segment);
	        p0 = p1;
	    }
	
	    return segments;
	};
	
	},{"../../lib":716}],899:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	var DATE_FORMAT_LINK = _dereq_('../../constants/docs').TIME_FORMAT_LINK;
	
	module.exports = {
	    color: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	    smoothing: {
	        valType: 'number',
	        dflt: 1,
	        min: 0,
	        max: 1.3,
	        
	        editType: 'calc'
	    },
	    title: {
	        text: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'calc',
	            
	        },
	        font: fontAttrs({
	            editType: 'calc',
	            
	        }),
	        // TODO how is this different than `title.standoff`
	        offset: {
	            valType: 'number',
	            
	            dflt: 10,
	            editType: 'calc',
	            
	        },
	        editType: 'calc',
	    },
	    type: {
	        valType: 'enumerated',
	        // '-' means we haven't yet run autotype or couldn't find any data
	        // it gets turned into linear in gd._fullLayout but not copied back
	        // to gd.data like the others are.
	        values: ['-', 'linear', 'date', 'category'],
	        dflt: '-',
	        
	        editType: 'calc',
	        
	    },
	    autorange: {
	        valType: 'enumerated',
	        values: [true, false, 'reversed'],
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    rangemode: {
	        valType: 'enumerated',
	        values: ['normal', 'tozero', 'nonnegative'],
	        dflt: 'normal',
	        
	        editType: 'calc',
	        
	    },
	    range: {
	        valType: 'info_array',
	        
	        editType: 'calc',
	        items: [
	            {valType: 'any', editType: 'calc'},
	            {valType: 'any', editType: 'calc'}
	        ],
	        
	    },
	
	    fixedrange: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    cheatertype: {
	        valType: 'enumerated',
	        values: ['index', 'value'],
	        dflt: 'value',
	        
	        editType: 'calc'
	    },
	    tickmode: {
	        valType: 'enumerated',
	        values: ['linear', 'array'],
	        dflt: 'array',
	        
	        editType: 'calc'
	    },
	    nticks: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    tickvals: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    ticktext: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    showticklabels: {
	        valType: 'enumerated',
	        values: ['start', 'end', 'both', 'none'],
	        dflt: 'start',
	        
	        editType: 'calc',
	        
	    },
	    tickfont: fontAttrs({
	        editType: 'calc',
	        
	    }),
	    tickangle: {
	        valType: 'angle',
	        dflt: 'auto',
	        
	        editType: 'calc',
	        
	    },
	    tickprefix: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    showtickprefix: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'calc',
	        
	    },
	    ticksuffix: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    showticksuffix: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'calc',
	        
	    },
	    showexponent: {
	        valType: 'enumerated',
	        values: ['all', 'first', 'last', 'none'],
	        dflt: 'all',
	        
	        editType: 'calc',
	        
	    },
	    exponentformat: {
	        valType: 'enumerated',
	        values: ['none', 'e', 'E', 'power', 'SI', 'B'],
	        dflt: 'B',
	        
	        editType: 'calc',
	        
	    },
	    separatethousands: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    tickformat: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    tickformatstops: overrideAll(axesAttrs.tickformatstops, 'calc', 'from-root'),
	    categoryorder: {
	        valType: 'enumerated',
	        values: [
	            'trace', 'category ascending', 'category descending', 'array'
	            /* , 'value ascending', 'value descending'*/ // value ascending / descending to be implemented later
	        ],
	        dflt: 'trace',
	        
	        editType: 'calc',
	        
	    },
	    categoryarray: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    labelpadding: {
	        valType: 'integer',
	        
	        dflt: 10,
	        editType: 'calc',
	        
	    },
	    labelprefix: {
	        valType: 'string',
	        
	        editType: 'calc',
	        
	    },
	    labelsuffix: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    // lines and grids
	    showline: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    linecolor: {
	        valType: 'color',
	        dflt: colorAttrs.defaultLine,
	        
	        editType: 'calc',
	        
	    },
	    linewidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    gridcolor: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	    gridwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    showgrid: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc',
	        
	    },
	    minorgridcount: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    minorgridwidth: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    minorgridcolor: {
	        valType: 'color',
	        dflt: colorAttrs.lightLine,
	        
	        editType: 'calc',
	        
	    },
	    startline: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    startlinecolor: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	    startlinewidth: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    endline: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    endlinewidth: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    endlinecolor: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	    tick0: {
	        valType: 'number',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    dtick: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    arraytick0: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    arraydtick: {
	        valType: 'integer',
	        min: 1,
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	
	    _deprecated: {
	        title: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        },
	        titlefont: fontAttrs({
	            editType: 'calc',
	            
	        }),
	        titleoffset: {
	            valType: 'number',
	            
	            dflt: 10,
	            editType: 'calc',
	            
	        }
	    },
	
	    editType: 'calc'
	};
	
	},{"../../components/color/attributes":590,"../../constants/docs":687,"../../plot_api/edit_types":747,"../../plots/cartesian/layout_attributes":776,"../../plots/font_attributes":790}],900:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var carpetAttrs = _dereq_('./attributes');
	
	var addOpacity = _dereq_('../../components/color').addOpacity;
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
	var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
	var handleCategoryOrderDefaults = _dereq_('../../plots/cartesian/category_order_defaults');
	var setConvert = _dereq_('../../plots/cartesian/set_convert');
	var autoType = _dereq_('../../plots/cartesian/axis_autotype');
	
	/**
	 * options: object containing:
	 *
	 *  letter: 'a' or 'b'
	 *  title: name of the axis (ie 'Colorbar') to go in default title
	 *  name: axis object name (ie 'xaxis') if one should be stored
	 *  font: the default font to inherit
	 *  outerTicks: boolean, should ticks default to outside?
	 *  showGrid: boolean, should gridlines be shown by default?
	 *  data: the plot data to use in choosing auto type
	 *  bgColor: the plot background color, to calculate default gridline colors
	 */
	module.exports = function handleAxisDefaults(containerIn, containerOut, options) {
	    var letter = options.letter;
	    var font = options.font || {};
	    var attributes = carpetAttrs[letter + 'axis'];
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	    }
	
	    function coerce2(attr, dflt) {
	        return Lib.coerce2(containerIn, containerOut, attributes, attr, dflt);
	    }
	
	    // set up some private properties
	    if(options.name) {
	        containerOut._name = options.name;
	        containerOut._id = options.name;
	    }
	
	    // now figure out type and do some more initialization
	    var axType = coerce('type');
	    if(axType === '-') {
	        if(options.data) setAutoType(containerOut, options.data);
	
	        if(containerOut.type === '-') {
	            containerOut.type = 'linear';
	        } else {
	            // copy autoType back to input axis
	            // note that if this object didn't exist
	            // in the input layout, we have to put it in
	            // this happens in the main supplyDefaults function
	            axType = containerIn.type = containerOut.type;
	        }
	    }
	
	    coerce('smoothing');
	    coerce('cheatertype');
	
	    coerce('showticklabels');
	    coerce('labelprefix', letter + ' = ');
	    coerce('labelsuffix');
	    coerce('showtickprefix');
	    coerce('showticksuffix');
	
	    coerce('separatethousands');
	    coerce('tickformat');
	    coerce('exponentformat');
	    coerce('showexponent');
	    coerce('categoryorder');
	
	    coerce('tickmode');
	    coerce('tickvals');
	    coerce('ticktext');
	    coerce('tick0');
	    coerce('dtick');
	
	    if(containerOut.tickmode === 'array') {
	        coerce('arraytick0');
	        coerce('arraydtick');
	    }
	
	    coerce('labelpadding');
	
	    containerOut._hovertitle = letter;
	
	
	    if(axType === 'date') {
	        var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
	        handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
	    }
	
	    // we need some of the other functions setConvert attaches, but for
	    // path finding, override pixel scaling to simple passthrough (identity)
	    setConvert(containerOut, options.fullLayout);
	    containerOut.c2p = Lib.identity;
	
	    var dfltColor = coerce('color', options.dfltColor);
	    // if axis.color was provided, use it for fonts too; otherwise,
	    // inherit from global font color in case that was provided.
	    var dfltFontColor = (dfltColor === containerIn.color) ? dfltColor : font.color;
	
	    var title = coerce('title.text');
	    if(title) {
	        Lib.coerceFont(coerce, 'title.font', {
	            family: font.family,
	            size: Math.round(font.size * 1.2),
	            color: dfltFontColor
	        });
	        coerce('title.offset');
	    }
	
	    coerce('tickangle');
	
	    var autoRange = coerce('autorange', !containerOut.isValidRange(containerIn.range));
	
	    if(autoRange) coerce('rangemode');
	
	    coerce('range');
	    containerOut.cleanRange();
	
	    coerce('fixedrange');
	
	    handleTickValueDefaults(containerIn, containerOut, coerce, axType);
	    handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);
	    handleCategoryOrderDefaults(containerIn, containerOut, coerce, {
	        data: options.data,
	        dataAttr: letter
	    });
	
	    var gridColor = coerce2('gridcolor', addOpacity(dfltColor, 0.3));
	    var gridWidth = coerce2('gridwidth');
	    var showGrid = coerce('showgrid');
	
	    if(!showGrid) {
	        delete containerOut.gridcolor;
	        delete containerOut.gridwidth;
	    }
	
	    var startLineColor = coerce2('startlinecolor', dfltColor);
	    var startLineWidth = coerce2('startlinewidth', gridWidth);
	    var showStartLine = coerce('startline', containerOut.showgrid || !!startLineColor || !!startLineWidth);
	
	    if(!showStartLine) {
	        delete containerOut.startlinecolor;
	        delete containerOut.startlinewidth;
	    }
	
	    var endLineColor = coerce2('endlinecolor', dfltColor);
	    var endLineWidth = coerce2('endlinewidth', gridWidth);
	    var showEndLine = coerce('endline', containerOut.showgrid || !!endLineColor || !!endLineWidth);
	
	    if(!showEndLine) {
	        delete containerOut.endlinecolor;
	        delete containerOut.endlinewidth;
	    }
	
	    if(!showGrid) {
	        delete containerOut.gridcolor;
	        delete containerOut.gridWidth;
	    } else {
	        coerce('minorgridcount');
	        coerce('minorgridwidth', gridWidth);
	        coerce('minorgridcolor', addOpacity(gridColor, 0.06));
	
	        if(!containerOut.minorgridcount) {
	            delete containerOut.minorgridwidth;
	            delete containerOut.minorgridcolor;
	        }
	    }
	
	    if(containerOut.showticklabels === 'none') {
	        delete containerOut.tickfont;
	        delete containerOut.tickangle;
	        delete containerOut.showexponent;
	        delete containerOut.exponentformat;
	        delete containerOut.tickformat;
	        delete containerOut.showticksuffix;
	        delete containerOut.showtickprefix;
	    }
	
	    if(!containerOut.showticksuffix) {
	        delete containerOut.ticksuffix;
	    }
	
	    if(!containerOut.showtickprefix) {
	        delete containerOut.tickprefix;
	    }
	
	    // It needs to be coerced, then something above overrides this deep in the axis code,
	    // but no, we *actually* want to coerce this.
	    coerce('tickmode');
	
	    return containerOut;
	};
	
	function setAutoType(ax, data) {
	    // new logic: let people specify any type they want,
	    // only autotype if type is '-'
	    if(ax.type !== '-') return;
	
	    var id = ax._id;
	    var axLetter = id.charAt(0);
	
	    var calAttr = axLetter + 'calendar';
	    var calendar = ax[calAttr];
	
	    ax.type = autoType(data, calendar);
	}
	
	},{"../../components/color":591,"../../lib":716,"../../plots/cartesian/axis_autotype":765,"../../plots/cartesian/category_order_defaults":768,"../../plots/cartesian/set_convert":782,"../../plots/cartesian/tick_label_defaults":783,"../../plots/cartesian/tick_value_defaults":785,"../../registry":845,"./attributes":897}],901:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var isArray1D = _dereq_('../../lib').isArray1D;
	var cheaterBasis = _dereq_('./cheater_basis');
	var arrayMinmax = _dereq_('./array_minmax');
	var calcGridlines = _dereq_('./calc_gridlines');
	var calcLabels = _dereq_('./calc_labels');
	var calcClipPath = _dereq_('./calc_clippath');
	var clean2dArray = _dereq_('../heatmap/clean_2d_array');
	var smoothFill2dArray = _dereq_('./smooth_fill_2d_array');
	var convertColumnData = _dereq_('../heatmap/convert_column_xyz');
	var setConvert = _dereq_('./set_convert');
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis);
	    var ya = Axes.getFromId(gd, trace.yaxis);
	    var aax = trace.aaxis;
	    var bax = trace.baxis;
	
	    var x = trace.x;
	    var y = trace.y;
	    var cols = [];
	    if(x && isArray1D(x)) cols.push('x');
	    if(y && isArray1D(y)) cols.push('y');
	
	    if(cols.length) {
	        convertColumnData(trace, aax, bax, 'a', 'b', cols);
	    }
	
	    var a = trace._a = trace._a || trace.a;
	    var b = trace._b = trace._b || trace.b;
	    x = trace._x || trace.x;
	    y = trace._y || trace.y;
	
	    var t = {};
	
	    if(trace._cheater) {
	        var avals = aax.cheatertype === 'index' ? a.length : a;
	        var bvals = bax.cheatertype === 'index' ? b.length : b;
	        x = cheaterBasis(avals, bvals, trace.cheaterslope);
	    }
	
	    trace._x = x = clean2dArray(x);
	    trace._y = y = clean2dArray(y);
	
	    // Fill in any undefined values with elliptic smoothing. This doesn't take
	    // into account the spacing of the values. That is, the derivatives should
	    // be modified to use a and b values. It's not that hard, but this is already
	    // moderate overkill for just filling in missing values.
	    smoothFill2dArray(x, a, b);
	    smoothFill2dArray(y, a, b);
	
	    setConvert(trace);
	
	    // create conversion functions that depend on the data
	    trace.setScale();
	
	    // This is a rather expensive scan. Nothing guarantees monotonicity,
	    // so we need to scan through all data to get proper ranges:
	    var xrange = arrayMinmax(x);
	    var yrange = arrayMinmax(y);
	
	    var dx = 0.5 * (xrange[1] - xrange[0]);
	    var xc = 0.5 * (xrange[1] + xrange[0]);
	
	    var dy = 0.5 * (yrange[1] - yrange[0]);
	    var yc = 0.5 * (yrange[1] + yrange[0]);
	
	    // Expand the axes to fit the plot, except just grow it by a factor of 1.3
	    // because the labels should be taken into account except that's difficult
	    // hence 1.3.
	    var grow = 1.3;
	    xrange = [xc - dx * grow, xc + dx * grow];
	    yrange = [yc - dy * grow, yc + dy * grow];
	
	    trace._extremes[xa._id] = Axes.findExtremes(xa, xrange, {padded: true});
	    trace._extremes[ya._id] = Axes.findExtremes(ya, yrange, {padded: true});
	
	    // Enumerate the gridlines, both major and minor, and store them on the trace
	    // object:
	    calcGridlines(trace, 'a', 'b');
	    calcGridlines(trace, 'b', 'a');
	
	    // Calculate the text labels for each major gridline and store them on the
	    // trace object:
	    calcLabels(trace, aax);
	    calcLabels(trace, bax);
	
	    // Tabulate points for the four segments that bound the axes so that we can
	    // map to pixel coordinates in the plot function and create a clip rect:
	    t.clipsegments = calcClipPath(trace._xctrl, trace._yctrl, aax, bax);
	
	    t.x = x;
	    t.y = y;
	    t.a = a;
	    t.b = b;
	
	    return [t];
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../heatmap/clean_2d_array":1000,"../heatmap/convert_column_xyz":1002,"./array_minmax":896,"./calc_clippath":902,"./calc_gridlines":903,"./calc_labels":904,"./cheater_basis":906,"./set_convert":919,"./smooth_fill_2d_array":920}],902:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = function makeClipPath(xctrl, yctrl, aax, bax) {
	    var i, x, y;
	    var segments = [];
	
	    var asmoothing = !!aax.smoothing;
	    var bsmoothing = !!bax.smoothing;
	    var nea1 = xctrl[0].length - 1;
	    var neb1 = xctrl.length - 1;
	
	    // Along the lower a axis:
	    for(i = 0, x = [], y = []; i <= nea1; i++) {
	        x[i] = xctrl[0][i];
	        y[i] = yctrl[0][i];
	    }
	    segments.push({x: x, y: y, bicubic: asmoothing});
	
	    // Along the upper b axis:
	    for(i = 0, x = [], y = []; i <= neb1; i++) {
	        x[i] = xctrl[i][nea1];
	        y[i] = yctrl[i][nea1];
	    }
	    segments.push({x: x, y: y, bicubic: bsmoothing});
	
	    // Backwards along the upper a axis:
	    for(i = nea1, x = [], y = []; i >= 0; i--) {
	        x[nea1 - i] = xctrl[neb1][i];
	        y[nea1 - i] = yctrl[neb1][i];
	    }
	    segments.push({x: x, y: y, bicubic: asmoothing});
	
	    // Backwards along the lower b axis:
	    for(i = neb1, x = [], y = []; i >= 0; i--) {
	        x[neb1 - i] = xctrl[i][0];
	        y[neb1 - i] = yctrl[i][0];
	    }
	    segments.push({x: x, y: y, bicubic: bsmoothing});
	
	    return segments;
	};
	
	},{}],903:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = function calcGridlines(trace, axisLetter, crossAxisLetter) {
	    var i, j, j0;
	    var eps, bounds, n1, n2, n, value, v;
	    var j1, v0, v1, d;
	
	    var data = trace['_' + axisLetter];
	    var axis = trace[axisLetter + 'axis'];
	
	    var gridlines = axis._gridlines = [];
	    var minorgridlines = axis._minorgridlines = [];
	    var boundarylines = axis._boundarylines = [];
	
	    var crossData = trace['_' + crossAxisLetter];
	    var crossAxis = trace[crossAxisLetter + 'axis'];
	
	    if(axis.tickmode === 'array') {
	        axis.tickvals = data.slice();
	    }
	
	    var xcp = trace._xctrl;
	    var ycp = trace._yctrl;
	    var nea = xcp[0].length;
	    var neb = xcp.length;
	    var na = trace._a.length;
	    var nb = trace._b.length;
	
	    Axes.prepTicks(axis);
	
	    // don't leave tickvals in axis looking like an attribute
	    if(axis.tickmode === 'array') delete axis.tickvals;
	
	    // The default is an empty array that will cause the join to remove the gridline if
	    // it's just disappeared:
	    // axis._startline = axis._endline = [];
	
	    // If the cross axis uses bicubic interpolation, then the grid
	    // lines fall once every three expanded grid row/cols:
	    var stride = axis.smoothing ? 3 : 1;
	
	    function constructValueGridline(value) {
	        var i, j, j0, tj, pxy, i0, ti, xy, dxydi0, dxydi1, dxydj0, dxydj1;
	        var xpoints = [];
	        var ypoints = [];
	        var ret = {};
	        // Search for the fractional grid index giving this line:
	        if(axisLetter === 'b') {
	            // For the position we use just the i-j coordinates:
	            j = trace.b2j(value);
	
	            // The derivatives for catmull-rom splines are discontinuous across cell
	            // boundaries though, so we need to provide both the cell and the position
	            // within the cell separately:
	            j0 = Math.floor(Math.max(0, Math.min(nb - 2, j)));
	            tj = j - j0;
	
	            ret.length = nb;
	            ret.crossLength = na;
	
	            ret.xy = function(i) {
	                return trace.evalxy([], i, j);
	            };
	
	            ret.dxy = function(i0, ti) {
	                return trace.dxydi([], i0, j0, ti, tj);
	            };
	
	            for(i = 0; i < na; i++) {
	                i0 = Math.min(na - 2, i);
	                ti = i - i0;
	                xy = trace.evalxy([], i, j);
	
	                if(crossAxis.smoothing && i > 0) {
	                    // First control point:
	                    dxydi0 = trace.dxydi([], i - 1, j0, 0, tj);
	                    xpoints.push(pxy[0] + dxydi0[0] / 3);
	                    ypoints.push(pxy[1] + dxydi0[1] / 3);
	
	                    // Second control point:
	                    dxydi1 = trace.dxydi([], i - 1, j0, 1, tj);
	                    xpoints.push(xy[0] - dxydi1[0] / 3);
	                    ypoints.push(xy[1] - dxydi1[1] / 3);
	                }
	
	                xpoints.push(xy[0]);
	                ypoints.push(xy[1]);
	
	                pxy = xy;
	            }
	        } else {
	            i = trace.a2i(value);
	            i0 = Math.floor(Math.max(0, Math.min(na - 2, i)));
	            ti = i - i0;
	
	            ret.length = na;
	            ret.crossLength = nb;
	
	            ret.xy = function(j) {
	                return trace.evalxy([], i, j);
	            };
	
	            ret.dxy = function(j0, tj) {
	                return trace.dxydj([], i0, j0, ti, tj);
	            };
	
	            for(j = 0; j < nb; j++) {
	                j0 = Math.min(nb - 2, j);
	                tj = j - j0;
	                xy = trace.evalxy([], i, j);
	
	                if(crossAxis.smoothing && j > 0) {
	                    // First control point:
	                    dxydj0 = trace.dxydj([], i0, j - 1, ti, 0);
	                    xpoints.push(pxy[0] + dxydj0[0] / 3);
	                    ypoints.push(pxy[1] + dxydj0[1] / 3);
	
	                    // Second control point:
	                    dxydj1 = trace.dxydj([], i0, j - 1, ti, 1);
	                    xpoints.push(xy[0] - dxydj1[0] / 3);
	                    ypoints.push(xy[1] - dxydj1[1] / 3);
	                }
	
	                xpoints.push(xy[0]);
	                ypoints.push(xy[1]);
	
	                pxy = xy;
	            }
	        }
	
	        ret.axisLetter = axisLetter;
	        ret.axis = axis;
	        ret.crossAxis = crossAxis;
	        ret.value = value;
	        ret.constvar = crossAxisLetter;
	        ret.index = n;
	        ret.x = xpoints;
	        ret.y = ypoints;
	        ret.smoothing = crossAxis.smoothing;
	
	        return ret;
	    }
	
	    function constructArrayGridline(idx) {
	        var j, i0, j0, ti, tj;
	        var xpoints = [];
	        var ypoints = [];
	        var ret = {};
	        ret.length = data.length;
	        ret.crossLength = crossData.length;
	
	        if(axisLetter === 'b') {
	            j0 = Math.max(0, Math.min(nb - 2, idx));
	            tj = Math.min(1, Math.max(0, idx - j0));
	
	            ret.xy = function(i) {
	                return trace.evalxy([], i, idx);
	            };
	
	            ret.dxy = function(i0, ti) {
	                return trace.dxydi([], i0, j0, ti, tj);
	            };
	
	            // In the tickmode: array case, this operation is a simple
	            // transfer of data:
	            for(j = 0; j < nea; j++) {
	                xpoints[j] = xcp[idx * stride][j];
	                ypoints[j] = ycp[idx * stride][j];
	            }
	        } else {
	            i0 = Math.max(0, Math.min(na - 2, idx));
	            ti = Math.min(1, Math.max(0, idx - i0));
	
	            ret.xy = function(j) {
	                return trace.evalxy([], idx, j);
	            };
	
	            ret.dxy = function(j0, tj) {
	                return trace.dxydj([], i0, j0, ti, tj);
	            };
	
	            // In the tickmode: array case, this operation is a simple
	            // transfer of data:
	            for(j = 0; j < neb; j++) {
	                xpoints[j] = xcp[j][idx * stride];
	                ypoints[j] = ycp[j][idx * stride];
	            }
	        }
	
	        ret.axisLetter = axisLetter;
	        ret.axis = axis;
	        ret.crossAxis = crossAxis;
	        ret.value = data[idx];
	        ret.constvar = crossAxisLetter;
	        ret.index = idx;
	        ret.x = xpoints;
	        ret.y = ypoints;
	        ret.smoothing = crossAxis.smoothing;
	
	        return ret;
	    }
	
	    if(axis.tickmode === 'array') {
	        // var j0 = axis.startline ? 1 : 0;
	        // var j1 = data.length - (axis.endline ? 1 : 0);
	
	        eps = 5e-15;
	        bounds = [
	            Math.floor(((data.length - 1) - axis.arraytick0) / axis.arraydtick * (1 + eps)),
	            Math.ceil((- axis.arraytick0) / axis.arraydtick / (1 + eps))
	        ].sort(function(a, b) {return a - b;});
	
	        // Unpack sorted values so we can be sure to avoid infinite loops if something
	        // is backwards:
	        n1 = bounds[0] - 1;
	        n2 = bounds[1] + 1;
	
	        // If the axes fall along array lines, then this is a much simpler process since
	        // we already have all the control points we need
	        for(n = n1; n < n2; n++) {
	            j = axis.arraytick0 + axis.arraydtick * n;
	            if(j < 0 || j > data.length - 1) continue;
	            gridlines.push(extendFlat(constructArrayGridline(j), {
	                color: axis.gridcolor,
	                width: axis.gridwidth
	            }));
	        }
	
	        for(n = n1; n < n2; n++) {
	            j0 = axis.arraytick0 + axis.arraydtick * n;
	            j1 = Math.min(j0 + axis.arraydtick, data.length - 1);
	
	            // TODO: fix the bounds computation so we don't have to do a large range and then throw
	            // out unneeded numbers
	            if(j0 < 0 || j0 > data.length - 1) continue;
	            if(j1 < 0 || j1 > data.length - 1) continue;
	
	            v0 = data[j0];
	            v1 = data[j1];
	
	            for(i = 0; i < axis.minorgridcount; i++) {
	                d = j1 - j0;
	
	                // TODO: fix the bounds computation so we don't have to do a large range and then throw
	                // out unneeded numbers
	                if(d <= 0) continue;
	
	                // XXX: This calculation isn't quite right. Off by one somewhere?
	                v = v0 + (v1 - v0) * (i + 1) / (axis.minorgridcount + 1) * (axis.arraydtick / d);
	
	                // TODO: fix the bounds computation so we don't have to do a large range and then throw
	                // out unneeded numbers
	                if(v < data[0] || v > data[data.length - 1]) continue;
	                minorgridlines.push(extendFlat(constructValueGridline(v), {
	                    color: axis.minorgridcolor,
	                    width: axis.minorgridwidth
	                }));
	            }
	        }
	
	        if(axis.startline) {
	            boundarylines.push(extendFlat(constructArrayGridline(0), {
	                color: axis.startlinecolor,
	                width: axis.startlinewidth
	            }));
	        }
	
	        if(axis.endline) {
	            boundarylines.push(extendFlat(constructArrayGridline(data.length - 1), {
	                color: axis.endlinecolor,
	                width: axis.endlinewidth
	            }));
	        }
	    } else {
	        // If the lines do not fall along the axes, then we have to interpolate
	        // the contro points and so some math to figure out where the lines are
	        // in the first place.
	
	        // Compute the integer boudns of tick0 + n * dtick that fall within the range
	        // (roughly speaking):
	        // Give this a nice generous epsilon. We use at as * (1 + eps) in order to make
	        // inequalities a little tolerant in a more or less correct manner:
	        eps = 5e-15;
	        bounds = [
	            Math.floor((data[data.length - 1] - axis.tick0) / axis.dtick * (1 + eps)),
	            Math.ceil((data[0] - axis.tick0) / axis.dtick / (1 + eps))
	        ].sort(function(a, b) {return a - b;});
	
	        // Unpack sorted values so we can be sure to avoid infinite loops if something
	        // is backwards:
	        n1 = bounds[0];
	        n2 = bounds[1];
	
	        for(n = n1; n <= n2; n++) {
	            value = axis.tick0 + axis.dtick * n;
	
	            gridlines.push(extendFlat(constructValueGridline(value), {
	                color: axis.gridcolor,
	                width: axis.gridwidth
	            }));
	        }
	
	        for(n = n1 - 1; n < n2 + 1; n++) {
	            value = axis.tick0 + axis.dtick * n;
	
	            for(i = 0; i < axis.minorgridcount; i++) {
	                v = value + axis.dtick * (i + 1) / (axis.minorgridcount + 1);
	                if(v < data[0] || v > data[data.length - 1]) continue;
	                minorgridlines.push(extendFlat(constructValueGridline(v), {
	                    color: axis.minorgridcolor,
	                    width: axis.minorgridwidth
	                }));
	            }
	        }
	
	        if(axis.startline) {
	            boundarylines.push(extendFlat(constructValueGridline(data[0]), {
	                color: axis.startlinecolor,
	                width: axis.startlinewidth
	            }));
	        }
	
	        if(axis.endline) {
	            boundarylines.push(extendFlat(constructValueGridline(data[data.length - 1]), {
	                color: axis.endlinecolor,
	                width: axis.endlinewidth
	            }));
	        }
	    }
	};
	
	},{"../../lib/extend":707,"../../plots/cartesian/axes":764}],904:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = function calcLabels(trace, axis) {
	    var i, tobj, prefix, suffix, gridline;
	
	    var labels = axis._labels = [];
	    var gridlines = axis._gridlines;
	
	    for(i = 0; i < gridlines.length; i++) {
	        gridline = gridlines[i];
	
	        if(['start', 'both'].indexOf(axis.showticklabels) !== -1) {
	            tobj = Axes.tickText(axis, gridline.value);
	
	            extendFlat(tobj, {
	                prefix: prefix,
	                suffix: suffix,
	                endAnchor: true,
	                xy: gridline.xy(0),
	                dxy: gridline.dxy(0, 0),
	                axis: gridline.axis,
	                length: gridline.crossAxis.length,
	                font: gridline.axis.tickfont,
	                isFirst: i === 0,
	                isLast: i === gridlines.length - 1
	            });
	
	            labels.push(tobj);
	        }
	
	        if(['end', 'both'].indexOf(axis.showticklabels) !== -1) {
	            tobj = Axes.tickText(axis, gridline.value);
	
	            extendFlat(tobj, {
	                endAnchor: false,
	                xy: gridline.xy(gridline.crossLength - 1),
	                dxy: gridline.dxy(gridline.crossLength - 2, 1),
	                axis: gridline.axis,
	                length: gridline.crossAxis.length,
	                font: gridline.axis.tickfont,
	                isFirst: i === 0,
	                isLast: i === gridlines.length - 1
	            });
	
	            labels.push(tobj);
	        }
	    }
	};
	
	},{"../../lib/extend":707,"../../plots/cartesian/axes":764}],905:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * Compute the tangent vector according to catmull-rom cubic splines (centripetal,
	 * I think). That differs from the control point in two ways:
	 *   1. It is a vector, not a position relative to the point
	 *   2. the vector is longer than the position relative to p1 by a factor of 3
	 *
	 * Close to the boundaries, we'll use these as *quadratic control points, so that
	 * to make a nice grid, we'll need to divide the tangent by 2 instead of 3. (The
	 * math works out this way if you work through the bezier derivatives)
	 */
	var CatmullRomExp = 0.5;
	module.exports = function makeControlPoints(p0, p1, p2, smoothness) {
	    var d1x = p0[0] - p1[0];
	    var d1y = p0[1] - p1[1];
	    var d2x = p2[0] - p1[0];
	    var d2y = p2[1] - p1[1];
	    var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
	    var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
	    var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
	    var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
	    var denom1 = d2a * (d1a + d2a) * 3;
	    var denom2 = d1a * (d1a + d2a) * 3;
	
	    return [[
	        p1[0] + (denom1 && numx / denom1),
	        p1[1] + (denom1 && numy / denom1)
	    ], [
	        p1[0] - (denom2 && numx / denom2),
	        p1[1] - (denom2 && numy / denom2)
	    ]];
	};
	
	},{}],906:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	/*
	 * Construct a 2D array of cheater values given a, b, and a slope.
	 * If
	 */
	module.exports = function(a, b, cheaterslope) {
	    var i, j, ascal, bscal, aval, bval;
	    var data = [];
	
	    var na = isArrayOrTypedArray(a) ? a.length : a;
	    var nb = isArrayOrTypedArray(b) ? b.length : b;
	    var adata = isArrayOrTypedArray(a) ? a : null;
	    var bdata = isArrayOrTypedArray(b) ? b : null;
	
	    // If we're using data, scale it so that for data that's just barely
	    // not evenly spaced, the switch to value-based indexing is continuous.
	    // This means evenly spaced data should look the same whether value
	    // or index cheatertype.
	    if(adata) {
	        ascal = (adata.length - 1) / (adata[adata.length - 1] - adata[0]) / (na - 1);
	    }
	
	    if(bdata) {
	        bscal = (bdata.length - 1) / (bdata[bdata.length - 1] - bdata[0]) / (nb - 1);
	    }
	
	    var xval;
	    var xmin = Infinity;
	    var xmax = -Infinity;
	    for(j = 0; j < nb; j++) {
	        data[j] = [];
	        bval = bdata ? (bdata[j] - bdata[0]) * bscal : j / (nb - 1);
	        for(i = 0; i < na; i++) {
	            aval = adata ? (adata[i] - adata[0]) * ascal : i / (na - 1);
	            xval = aval - bval * cheaterslope;
	            xmin = Math.min(xval, xmin);
	            xmax = Math.max(xval, xmax);
	            data[j][i] = xval;
	        }
	    }
	
	    // Normalize cheater values to the 0-1 range. This comes into play when you have
	    // multiple cheater plots. After careful consideration, it seems better if cheater
	    // values are normalized to a consistent range. Otherwise one cheater affects the
	    // layout of other cheaters on the same axis.
	    var slope = 1.0 / (xmax - xmin);
	    var offset = -xmin * slope;
	    for(j = 0; j < nb; j++) {
	        for(i = 0; i < na; i++) {
	            data[j][i] = slope * data[j][i] + offset;
	        }
	    }
	
	    return data;
	};
	
	},{"../../lib":716}],907:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var makeControlPoints = _dereq_('./catmull_rom');
	var ensureArray = _dereq_('../../lib').ensureArray;
	
	/*
	 * Turns a coarse grid into a fine grid with control points.
	 *
	 * Here's an ASCII representation:
	 *
	 *       o ----- o ----- o ----- o
	 *       |       |       |       |
	 *       |       |       |       |
	 *       |       |       |       |
	 *       o ----- o ----- o ----- o
	 *       |       |       |       |
	 *       |       |       |       |
	 *    ^  |       |       |       |
	 *    |  o ----- o ----- o ----- o
	 *  b |  |       |       |       |
	 *    |  |       |       |       |
	 *    |  |       |       |       |
	 *       o ----- o ----- o ----- o
	 *         ------>
	 *           a
	 *
	 * First of all, note that we want to do this in *cartesian* space. This means
	 * we might run into problems when there are extreme differences in x/y scaling,
	 * but the alternative is that the topology of the contours might actually be
	 * view-dependent, which seems worse. As a fallback, the only parameter that
	 * actually affects the result is the *aspect ratio*, so that we can at least
	 * improve the situation a bit without going all the way to screen coordinates.
	 *
	 * This function flattens the points + tangents  into a slightly denser grid of
	 * *control points*. The resulting grid looks like this:
	 *
	 *       9 +--o-o--+ -o-o--+--o-o--+
	 *       8 o  o o  o  o o  o  o o  o
	 *         |       |       |       |
	 *       7 o  o o  o  o o  o  o o  o
	 *       6 +--o-o--+ -o-o--+--o-o--+
	 *       5 o  o o  o  o o  o  o o  o
	 *         |       |       |       |
	 *    ^  4 o  o o  o  o o  o  o o  o
	 *    |  3 +--o-o--+ -o-o--+--o-o--+
	 *  b |  2 o  o o  o  o o  o  o o  o
	 *    |    |       |       |       |
	 *    |  1 o  o o  o  o o  o  o o  o
	 *       0 +--o-o--+ -o-o--+--o-o--+
	 *         0  1 2  3  4 5  6  7 8  9
	 *         ------>
	 *           a
	 *
	 * where `o`s represent newly-computed control points. the resulting dimension is
	 *
	 *     (m - 1) * 3 + 1
	 *   = 3 * m - 2
	 *
	 * We could simply store the tangents separately, but that's a nightmare to organize
	 * in two dimensions since we'll be slicing grid lines in both directions and since
	 * that basically requires very nearly just as much storage as just storing the dense
	 * grid.
	 *
	 * Wow!
	 */
	
	
	/*
	 * Catmull-rom is biased at the boundaries toward the interior and we actually
	 * can't use catmull-rom to compute the control point closest to (but inside)
	 * the boundary.
	 *
	 * A note on plotly's spline interpolation. It uses the catmull rom control point
	 * closest to the boundary *as* a quadratic control point. This seems incorrect,
	 * so I've elected not to follow that. Given control points 0 and 1, regular plotly
	 * splines give *equivalent* cubic control points:
	 *
	 * Input:
	 *
	 *   boundary
	 *     |                    |
	 *     p0           p2      p3    --> interior
	 *     0.0          0.667   1.0
	 *     |                    |
	 *
	 * Cubic-equivalent of what plotly splines draw::
	 *
	 *   boundary
	 *     |                    |
	 *     p0   p1      p2      p3    --> interior
	 *     0.0  0.4444  0.8888  1.0
	 *     |                    |
	 *
	 * What this function fills in:
	 *
	 *   boundary
	 *     |                    |
	 *     p0    p1     p2      p3    --> interior
	 *     0.0   0.333  0.667   1.0
	 *     |                    |
	 *
	 * Parameters:
	 *   p0: boundary point
	 *   p2: catmull rom point based on computation at p3
	 *   p3: first grid point
	 *
	 * Of course it works whichever way it's oriented; you just need to interpret the
	 * input/output accordingly.
	 */
	function inferCubicControlPoint(p0, p2, p3) {
	    // Extend p1 away from p0 by 50%. This is the equivalent quadratic point that
	    // would give the same slope as catmull rom at p0.
	    var p2e0 = -0.5 * p3[0] + 1.5 * p2[0];
	    var p2e1 = -0.5 * p3[1] + 1.5 * p2[1];
	
	    return [
	        (2 * p2e0 + p0[0]) / 3,
	        (2 * p2e1 + p0[1]) / 3,
	    ];
	}
	
	module.exports = function computeControlPoints(xe, ye, x, y, asmoothing, bsmoothing) {
	    var i, j, ie, je, xej, yej, xj, yj, cp, p1;
	    // At this point, we know these dimensions are correct and representative of
	    // the whole 2D arrays:
	    var na = x[0].length;
	    var nb = x.length;
	
	    // (n)umber of (e)xpanded points:
	    var nea = asmoothing ? 3 * na - 2 : na;
	    var neb = bsmoothing ? 3 * nb - 2 : nb;
	
	    xe = ensureArray(xe, neb);
	    ye = ensureArray(ye, neb);
	
	    for(ie = 0; ie < neb; ie++) {
	        xe[ie] = ensureArray(xe[ie], nea);
	        ye[ie] = ensureArray(ye[ie], nea);
	    }
	
	    // This loop fills in the X'd points:
	    //
	    //    .       .       .       .
	    //    .       .       .       .
	    //    |       |       |       |
	    //    |       |       |       |
	    //    X ----- X ----- X ----- X
	    //    |       |       |       |
	    //    |       |       |       |
	    //    |       |       |       |
	    //    X ----- X ----- X ----- X
	    //
	    //
	    // ie = (i) (e)xpanded:
	    for(j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
	        xej = xe[je];
	        yej = ye[je];
	        xj = x[j];
	        yj = y[j];
	
	        // je = (j) (e)xpanded:
	        for(i = 0, ie = 0; i < na; i++, ie += asmoothing ? 3 : 1) {
	            xej[ie] = xj[i];
	            yej[ie] = yj[i];
	        }
	    }
	
	    if(asmoothing) {
	        // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
	        // control points computed along the a-axis:
	        //     .       .       .       .
	        //     .       .       .       .
	        //     |       |       |       |
	        //     |       |       |       |
	        //     o -Y-X- o -X-X- o -X-Y- o
	        //     |       |       |       |
	        //     |       |       |       |
	        //     |       |       |       |
	        //     o -Y-X- o -X-X- o -X-Y- o
	        //
	        // i:  0       1       2       3
	        // ie: 0  1 3  3  4 5  6  7 8  9
	        //
	        //           ------>
	        //             a
	        //
	        for(j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
	            // Fill in the points marked X for this a-row:
	            for(i = 1, ie = 3; i < na - 1; i++, ie += 3) {
	                cp = makeControlPoints(
	                    [x[j][i - 1], y[j][i - 1]],
	                    [x[j][i ], y[j][i]],
	                    [x[j][i + 1], y[j][i + 1]],
	                    asmoothing
	                );
	
	                xe[je][ie - 1] = cp[0][0];
	                ye[je][ie - 1] = cp[0][1];
	                xe[je][ie + 1] = cp[1][0];
	                ye[je][ie + 1] = cp[1][1];
	            }
	
	            // The very first cubic interpolation point (to the left for i = 1 above) is
	            // used as a *quadratic* interpolation point by the spline drawing function
	            // which isn't really correct. But for the sake of consistency, we'll use it
	            // as such. Since we're using cubic splines, that means we need to shorten the
	            // tangent by 1/3 and also construct a new cubic spline control point 1/3 from
	            // the original to the i = 0 point.
	            p1 = inferCubicControlPoint(
	                [xe[je][0], ye[je][0]],
	                [xe[je][2], ye[je][2]],
	                [xe[je][3], ye[je][3]]
	            );
	            xe[je][1] = p1[0];
	            ye[je][1] = p1[1];
	
	            // Ditto last points, sans explanation:
	            p1 = inferCubicControlPoint(
	                [xe[je][nea - 1], ye[je][nea - 1]],
	                [xe[je][nea - 3], ye[je][nea - 3]],
	                [xe[je][nea - 4], ye[je][nea - 4]]
	            );
	            xe[je][nea - 2] = p1[0];
	            ye[je][nea - 2] = p1[1];
	        }
	    }
	
	    if(bsmoothing) {
	        // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
	        // control points computed along the b-axis:
	        //     .       .       .       .
	        //     X  X X  X  X X  X  X X  X
	        //     |       |       |       |
	        //     X  X X  X  X X  X  X X  X
	        //     o -o-o- o -o-o- o -o-o- o
	        //     X  X X  X  X X  X  X X  X
	        //     |       |       |       |
	        //     Y  Y Y  Y  Y Y  Y  Y Y  Y
	        //     o -o-o- o -o-o- o -o-o- o
	        //
	        // i:  0       1       2       3
	        // ie: 0  1 3  3  4 5  6  7 8  9
	        //
	        //           ------>
	        //             a
	        //
	        for(ie = 0; ie < nea; ie++) {
	            for(je = 3; je < neb - 3; je += 3) {
	                cp = makeControlPoints(
	                    [xe[je - 3][ie], ye[je - 3][ie]],
	                    [xe[je][ie], ye[je][ie]],
	                    [xe[je + 3][ie], ye[je + 3][ie]],
	                    bsmoothing
	                );
	
	                xe[je - 1][ie] = cp[0][0];
	                ye[je - 1][ie] = cp[0][1];
	                xe[je + 1][ie] = cp[1][0];
	                ye[je + 1][ie] = cp[1][1];
	            }
	            // Do the same boundary condition magic for these control points marked Y above:
	            p1 = inferCubicControlPoint(
	                [xe[0][ie], ye[0][ie]],
	                [xe[2][ie], ye[2][ie]],
	                [xe[3][ie], ye[3][ie]]
	            );
	            xe[1][ie] = p1[0];
	            ye[1][ie] = p1[1];
	
	            p1 = inferCubicControlPoint(
	                [xe[neb - 1][ie], ye[neb - 1][ie]],
	                [xe[neb - 3][ie], ye[neb - 3][ie]],
	                [xe[neb - 4][ie], ye[neb - 4][ie]]
	            );
	            xe[neb - 2][ie] = p1[0];
	            ye[neb - 2][ie] = p1[1];
	        }
	    }
	
	    if(asmoothing && bsmoothing) {
	        // Do one more pass, this time recomputing exactly what we just computed.
	        // It's overdetermined since we're peforming catmull-rom in two directions,
	        // so we'll just average the overdetermined. These points don't lie along the
	        // grid lines, so note that only grid lines will follow normal plotly spline
	        // interpolation.
	        //
	        // Unless of course there was no b smoothing. Then these intermediate points
	        // don't actually exist and this section is bypassed.
	        //     .       .       .       .
	        //     o  X X  o  X X  o  X X  o
	        //     |       |       |       |
	        //     o  X X  o  X X  o  X X  o
	        //     o -o-o- o -o-o- o -o-o- o
	        //     o  X X  o  X X  o  X X  o
	        //     |       |       |       |
	        //     o  Y Y  o  Y Y  o  Y Y  o
	        //     o -o-o- o -o-o- o -o-o- o
	        //
	        // i:  0       1       2       3
	        // ie: 0  1 3  3  4 5  6  7 8  9
	        //
	        //           ------>
	        //             a
	        //
	        for(je = 1; je < neb; je += (je + 1) % 3 === 0 ? 2 : 1) {
	            // Fill in the points marked X for this a-row:
	            for(ie = 3; ie < nea - 3; ie += 3) {
	                cp = makeControlPoints(
	                    [xe[je][ie - 3], ye[je][ie - 3]],
	                    [xe[je][ie], ye[je][ie]],
	                    [xe[je][ie + 3], ye[je][ie + 3]],
	                    asmoothing
	                );
	
	                xe[je][ie - 1] = 0.5 * (xe[je][ie - 1] + cp[0][0]);
	                ye[je][ie - 1] = 0.5 * (ye[je][ie - 1] + cp[0][1]);
	                xe[je][ie + 1] = 0.5 * (xe[je][ie + 1] + cp[1][0]);
	                ye[je][ie + 1] = 0.5 * (ye[je][ie + 1] + cp[1][1]);
	            }
	
	            // This case is just slightly different. The computation is the same,
	            // but having computed this, we'll average with the existing result.
	            p1 = inferCubicControlPoint(
	                [xe[je][0], ye[je][0]],
	                [xe[je][2], ye[je][2]],
	                [xe[je][3], ye[je][3]]
	            );
	            xe[je][1] = 0.5 * (xe[je][1] + p1[0]);
	            ye[je][1] = 0.5 * (ye[je][1] + p1[1]);
	
	            p1 = inferCubicControlPoint(
	                [xe[je][nea - 1], ye[je][nea - 1]],
	                [xe[je][nea - 3], ye[je][nea - 3]],
	                [xe[je][nea - 4], ye[je][nea - 4]]
	            );
	            xe[je][nea - 2] = 0.5 * (xe[je][nea - 2] + p1[0]);
	            ye[je][nea - 2] = 0.5 * (ye[je][nea - 2] + p1[1]);
	        }
	    }
	
	    return [xe, ye];
	};
	
	},{"../../lib":716,"./catmull_rom":905}],908:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    RELATIVE_CULL_TOLERANCE: 1e-6
	};
	
	},{}],909:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * Evaluates the derivative of a list of control point arrays. That is, it expects an array or arrays
	 * that are expanded relative to the raw data to include the bicubic control points, if applicable. If
	 * only linear interpolation is desired, then the data points correspond 1-1 along that axis to the
	 * data itself. Since it's catmull-rom splines in either direction note in particular that the
	 * derivatives are discontinuous across cell boundaries. That's the reason you need both the *cell*
	 * and the *point within the cell*.
	 *
	 * Also note that the discontinuity of the derivative is in magnitude only. The direction *is*
	 * continuous across cell boundaries.
	 *
	 * For example, to compute the derivative of the xcoordinate halfway betwen the 7 and 8th i-gridpoints
	 * and the 10th and 11th j-gridpoints given bicubic smoothing in both dimensions, you'd write:
	 *
	 *     var deriv = createIDerivativeEvaluator([x], 1, 1);
	 *
	 *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
	 *     // => [0.12345]
	 *
	 * Since there'd be a bunch of duplicate computation to compute multiple derivatives, you can double
	 * this up by providing more arrays:
	 *
	 *     var deriv = createIDerivativeEvaluator([x, y], 1, 1);
	 *
	 *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
	 *     // => [0.12345, 0.78910]
	 *
	 * NB: It's presumed that at this point all data has been sanitized and is valid numerical data arrays
	 * of the correct dimension.
	 */
	module.exports = function(arrays, asmoothing, bsmoothing) {
	    if(asmoothing && bsmoothing) {
	        return function(out, i0, j0, u, v) {
	            if(!out) out = [];
	            var f0, f1, f2, f3, ak, k;
	
	            // Since it's a grid of control points, the actual indices are * 3:
	            i0 *= 3;
	            j0 *= 3;
	
	            // Precompute some numbers:
	            var u2 = u * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ouu2 = ou * u * 2;
	            var a = -3 * ou2;
	            var b = 3 * (ou2 - ouu2);
	            var c = 3 * (ouu2 - u2);
	            var d = 3 * u2;
	
	            var v2 = v * v;
	            var v3 = v2 * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ov3 = ov2 * ov;
	
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                // Compute the derivatives in the u-direction:
	                f0 = a * ak[j0 ][i0] + b * ak[j0 ][i0 + 1] + c * ak[j0 ][i0 + 2] + d * ak[j0 ][i0 + 3];
	                f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
	                f2 = a * ak[j0 + 2][i0] + b * ak[j0 + 2][i0 + 1] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 2][i0 + 3];
	                f3 = a * ak[j0 + 3][i0] + b * ak[j0 + 3][i0 + 1] + c * ak[j0 + 3][i0 + 2] + d * ak[j0 + 3][i0 + 3];
	
	                // Now just interpolate in the v-direction since it's all separable:
	                out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	            }
	
	            return out;
	        };
	    } else if(asmoothing) {
	        // Handle smooth in the a-direction but linear in the b-direction by performing four
	        // linear interpolations followed by one cubic interpolation of the result
	        return function(out, i0, j0, u, v) {
	            if(!out) out = [];
	            var f0, f1, k, ak;
	            i0 *= 3;
	            var u2 = u * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ouu2 = ou * u * 2;
	            var a = -3 * ou2;
	            var b = 3 * (ou2 - ouu2);
	            var c = 3 * (ouu2 - u2);
	            var d = 3 * u2;
	            var ov = 1 - v;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = a * ak[j0 ][i0] + b * ak[j0 ][i0 + 1] + c * ak[j0 ][i0 + 2] + d * ak[j0 ][i0 + 3];
	                f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
	
	                out[k] = ov * f0 + v * f1;
	            }
	            return out;
	        };
	    } else if(bsmoothing) {
	        // Same as the above case, except reversed. I've disabled the no-unused vars rule
	        // so that this function is fully interpolation-agnostic. Otherwise it would need
	        // to be called differently in different cases. Which wouldn't be the worst, but
	        /* eslint-disable no-unused-vars */
	        return function(out, i0, j0, u, v) {
	        /* eslint-enable no-unused-vars */
	            if(!out) out = [];
	            var f0, f1, f2, f3, k, ak;
	            j0 *= 3;
	            var v2 = v * v;
	            var v3 = v2 * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ov3 = ov2 * ov;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ak[j0][i0 + 1] - ak[j0][i0];
	                f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
	                f2 = ak[j0 + 2][i0 + 1] - ak[j0 + 2][i0];
	                f3 = ak[j0 + 3][i0 + 1] - ak[j0 + 3][i0];
	
	                out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	            }
	            return out;
	        };
	    } else {
	        // Finally, both directions are linear:
	        /* eslint-disable no-unused-vars */
	        return function(out, i0, j0, u, v) {
	        /* eslint-enable no-unused-vars */
	            if(!out) out = [];
	            var f0, f1, k, ak;
	            var ov = 1 - v;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ak[j0][i0 + 1] - ak[j0][i0];
	                f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
	
	                out[k] = ov * f0 + v * f1;
	            }
	            return out;
	        };
	    }
	};
	
	},{}],910:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function(arrays, asmoothing, bsmoothing) {
	    if(asmoothing && bsmoothing) {
	        return function(out, i0, j0, u, v) {
	            if(!out) out = [];
	            var f0, f1, f2, f3, ak, k;
	
	            // Since it's a grid of control points, the actual indices are * 3:
	            i0 *= 3;
	            j0 *= 3;
	
	            // Precompute some numbers:
	            var u2 = u * u;
	            var u3 = u2 * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ou3 = ou2 * ou;
	
	            var v2 = v * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ovv2 = ov * v * 2;
	            var a = -3 * ov2;
	            var b = 3 * (ov2 - ovv2);
	            var c = 3 * (ovv2 - v2);
	            var d = 3 * v2;
	
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	
	                // Compute the derivatives in the v-direction:
	                f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
	                f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
	                f2 = a * ak[j0][i0 + 2] + b * ak[j0 + 1][i0 + 2] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 3][i0 + 2];
	                f3 = a * ak[j0][i0 + 3] + b * ak[j0 + 1][i0 + 3] + c * ak[j0 + 2][i0 + 3] + d * ak[j0 + 3][i0 + 3];
	
	                // Now just interpolate in the v-direction since it's all separable:
	                out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	            }
	
	            return out;
	        };
	    } else if(asmoothing) {
	        // Handle smooth in the a-direction but linear in the b-direction by performing four
	        // linear interpolations followed by one cubic interpolation of the result
	        return function(out, i0, j0, v, u) {
	            if(!out) out = [];
	            var f0, f1, f2, f3, k, ak;
	            i0 *= 3;
	            var u2 = u * u;
	            var u3 = u2 * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ou3 = ou2 * ou;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	
	                f0 = ak[j0 + 1][i0] - ak[j0][i0];
	                f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
	                f2 = ak[j0 + 1][i0 + 2] - ak[j0][i0 + 2];
	                f3 = ak[j0 + 1][i0 + 3] - ak[j0][i0 + 3];
	
	                out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	
	                // mathematically equivalent:
	                // f0 = ou3 * ak[j0    ][i0] + 3 * (ou2 * u * ak[j0    ][i0 + 1] + ou * u2 * ak[j0    ][i0 + 2]) + u3 * ak[j0    ][i0 + 3];
	                // f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
	                // out[k] = f1 - f0;
	            }
	            return out;
	        };
	    } else if(bsmoothing) {
	        // Same as the above case, except reversed:
	        /* eslint-disable no-unused-vars */
	        return function(out, i0, j0, u, v) {
	        /* eslint-enable no-unused-vars */
	            if(!out) out = [];
	            var f0, f1, k, ak;
	            j0 *= 3;
	            var ou = 1 - u;
	            var v2 = v * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ovv2 = ov * v * 2;
	            var a = -3 * ov2;
	            var b = 3 * (ov2 - ovv2);
	            var c = 3 * (ovv2 - v2);
	            var d = 3 * v2;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
	                f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
	
	                out[k] = ou * f0 + u * f1;
	            }
	            return out;
	        };
	    } else {
	        // Finally, both directions are linear:
	        /* eslint-disable no-unused-vars */
	        return function(out, i0, j0, v, u) {
	        /* eslint-enable no-unused-vars */
	            if(!out) out = [];
	            var f0, f1, k, ak;
	            var ov = 1 - v;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ak[j0 + 1][i0] - ak[j0][i0];
	                f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
	
	                out[k] = ov * f0 + v * f1;
	            }
	            return out;
	        };
	    }
	};
	
	},{}],911:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * Return a function that evaluates a set of linear or bicubic control points.
	 * This will get evaluated a lot, so we'll at least do a bit of extra work to
	 * flatten some of the choices. In particular, we'll unroll the linear/bicubic
	 * combinations and we'll allow computing results in parallel to cut down
	 * on repeated arithmetic.
	 *
	 * Take note that we don't search for the correct range in this function. The
	 * reason is for consistency due to the corrresponding derivative function. In
	 * particular, the derivatives aren't continuous across cells, so it's important
	 * to be able control whether the derivative at a cell boundary is approached
	 * from one side or the other.
	 */
	module.exports = function(arrays, na, nb, asmoothing, bsmoothing) {
	    var imax = na - 2;
	    var jmax = nb - 2;
	
	    if(asmoothing && bsmoothing) {
	        return function(out, i, j) {
	            if(!out) out = [];
	            var f0, f1, f2, f3, ak, k;
	
	            var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	            var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	            var u = Math.max(0, Math.min(1, i - i0));
	            var v = Math.max(0, Math.min(1, j - j0));
	
	            // Since it's a grid of control points, the actual indices are * 3:
	            i0 *= 3;
	            j0 *= 3;
	
	            // Precompute some numbers:
	            var u2 = u * u;
	            var u3 = u2 * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ou3 = ou2 * ou;
	
	            var v2 = v * v;
	            var v3 = v2 * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ov3 = ov2 * ov;
	
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ou3 * ak[j0][i0] + 3 * (ou2 * u * ak[j0][i0 + 1] + ou * u2 * ak[j0][i0 + 2]) + u3 * ak[j0][i0 + 3];
	                f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
	                f2 = ou3 * ak[j0 + 2][i0] + 3 * (ou2 * u * ak[j0 + 2][i0 + 1] + ou * u2 * ak[j0 + 2][i0 + 2]) + u3 * ak[j0 + 2][i0 + 3];
	                f3 = ou3 * ak[j0 + 3][i0] + 3 * (ou2 * u * ak[j0 + 3][i0 + 1] + ou * u2 * ak[j0 + 3][i0 + 2]) + u3 * ak[j0 + 3][i0 + 3];
	                out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	            }
	
	            return out;
	        };
	    } else if(asmoothing) {
	        // Handle smooth in the a-direction but linear in the b-direction by performing four
	        // linear interpolations followed by one cubic interpolation of the result
	        return function(out, i, j) {
	            if(!out) out = [];
	
	            var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	            var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	            var u = Math.max(0, Math.min(1, i - i0));
	            var v = Math.max(0, Math.min(1, j - j0));
	
	            var f0, f1, f2, f3, k, ak;
	            i0 *= 3;
	            var u2 = u * u;
	            var u3 = u2 * u;
	            var ou = 1 - u;
	            var ou2 = ou * ou;
	            var ou3 = ou2 * ou;
	            var ov = 1 - v;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ov * ak[j0][i0] + v * ak[j0 + 1][i0];
	                f1 = ov * ak[j0][i0 + 1] + v * ak[j0 + 1][i0 + 1];
	                f2 = ov * ak[j0][i0 + 2] + v * ak[j0 + 1][i0 + 1];
	                f3 = ov * ak[j0][i0 + 3] + v * ak[j0 + 1][i0 + 1];
	
	                out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	            }
	            return out;
	        };
	    } else if(bsmoothing) {
	        // Same as the above case, except reversed:
	        return function(out, i, j) {
	            if(!out) out = [];
	
	            var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	            var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	            var u = Math.max(0, Math.min(1, i - i0));
	            var v = Math.max(0, Math.min(1, j - j0));
	
	            var f0, f1, f2, f3, k, ak;
	            j0 *= 3;
	            var v2 = v * v;
	            var v3 = v2 * v;
	            var ov = 1 - v;
	            var ov2 = ov * ov;
	            var ov3 = ov2 * ov;
	            var ou = 1 - u;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
	                f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
	                f2 = ou * ak[j0 + 2][i0] + u * ak[j0 + 2][i0 + 1];
	                f3 = ou * ak[j0 + 3][i0] + u * ak[j0 + 3][i0 + 1];
	
	                out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	            }
	            return out;
	        };
	    } else {
	        // Finally, both directions are linear:
	        return function(out, i, j) {
	            if(!out) out = [];
	
	            var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	            var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	            var u = Math.max(0, Math.min(1, i - i0));
	            var v = Math.max(0, Math.min(1, j - j0));
	
	            var f0, f1, k, ak;
	            var ov = 1 - v;
	            var ou = 1 - u;
	            for(k = 0; k < arrays.length; k++) {
	                ak = arrays[k];
	                f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
	                f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
	
	                out[k] = ov * f0 + v * f1;
	            }
	            return out;
	        };
	    }
	};
	
	},{}],912:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleXYDefaults = _dereq_('./xy_defaults');
	var handleABDefaults = _dereq_('./ab_defaults');
	var attributes = _dereq_('./attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, dfltColor, fullLayout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    traceOut._clipPathId = 'clip' + traceOut.uid + 'carpet';
	
	    var defaultColor = coerce('color', colorAttrs.defaultLine);
	    Lib.coerceFont(coerce, 'font');
	
	    coerce('carpet');
	
	    handleABDefaults(traceIn, traceOut, fullLayout, coerce, defaultColor);
	
	    if(!traceOut.a || !traceOut.b) {
	        traceOut.visible = false;
	        return;
	    }
	
	    if(traceOut.a.length < 3) {
	        traceOut.aaxis.smoothing = 0;
	    }
	
	    if(traceOut.b.length < 3) {
	        traceOut.baxis.smoothing = 0;
	    }
	
	    // NB: the input is x/y arrays. You should know that the *first* dimension of x and y
	    // corresponds to b and the second to a. This sounds backwards but ends up making sense
	    // the important part to know is that when you write y[j][i], j goes from 0 to b.length - 1
	    // and i goes from 0 to a.length - 1.
	    var validData = handleXYDefaults(traceIn, traceOut, coerce);
	    if(!validData) {
	        traceOut.visible = false;
	    }
	
	    if(traceOut._cheater) {
	        coerce('cheaterslope');
	    }
	};
	
	},{"../../components/color/attributes":590,"../../lib":716,"./ab_defaults":895,"./attributes":897,"./xy_defaults":921}],913:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    plot: _dereq_('./plot'),
	    calc: _dereq_('./calc'),
	    animatable: true,
	    isContainer: true, // so carpet traces get `calc` before other traces
	
	    moduleType: 'trace',
	    name: 'carpet',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'carpet', 'carpetAxis', 'notLegendIsolatable', 'noMultiCategory', 'noHover', 'noSortingByValue'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./attributes":897,"./calc":901,"./defaults":912,"./plot":918}],914:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/*
	 * Given a trace, look up the carpet axis by carpet.
	 */
	module.exports = function(gd, trace) {
	    var n = gd._fullData.length;
	    var firstAxis;
	    for(var i = 0; i < n; i++) {
	        var maybeCarpet = gd._fullData[i];
	
	        if(maybeCarpet.index === trace.index) continue;
	
	        if(maybeCarpet.type === 'carpet') {
	            if(!firstAxis) {
	                firstAxis = maybeCarpet;
	            }
	
	            if(maybeCarpet.carpet === trace.carpet) {
	                return maybeCarpet;
	            }
	        }
	    }
	
	    return firstAxis;
	};
	
	},{}],915:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function makePath(xp, yp, isBicubic) {
	    // Prevent d3 errors that would result otherwise:
	    if(xp.length === 0) return '';
	
	    var i;
	    var path = [];
	    var stride = isBicubic ? 3 : 1;
	    for(i = 0; i < xp.length; i += stride) {
	        path.push(xp[i] + ',' + yp[i]);
	
	        if(isBicubic && i < xp.length - stride) {
	            path.push('C');
	            path.push([
	                xp[i + 1] + ',' + yp[i + 1],
	                xp[i + 2] + ',' + yp[i + 2] + ' ',
	            ].join(' '));
	        }
	    }
	    return path.join(isBicubic ? '' : 'L');
	};
	
	},{}],916:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	/*
	 * Map an array of x or y coordinates (c) to screen-space pixel coordinates (p).
	 * The output array is optional, but if provided, it will be reused without
	 * reallocation to the extent possible.
	 */
	module.exports = function mapArray(out, data, func) {
	    var i;
	
	    if(!isArrayOrTypedArray(out)) {
	        // If not an array, make it an array:
	        out = [];
	    } else if(out.length > data.length) {
	        // If too long, truncate. (If too short, it will grow
	        // automatically so we don't care about that case)
	        out = out.slice(0, data.length);
	    }
	
	    for(i = 0; i < data.length; i++) {
	        out[i] = func(data[i]);
	    }
	
	    return out;
	};
	
	},{"../../lib":716}],917:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = function orientText(trace, xaxis, yaxis, xy, dxy, refDxy) {
	    var dx = dxy[0] * trace.dpdx(xaxis);
	    var dy = dxy[1] * trace.dpdy(yaxis);
	    var flip = 1;
	
	    var offsetMultiplier = 1.0;
	    if(refDxy) {
	        var l1 = Math.sqrt(dxy[0] * dxy[0] + dxy[1] * dxy[1]);
	        var l2 = Math.sqrt(refDxy[0] * refDxy[0] + refDxy[1] * refDxy[1]);
	        var dot = (dxy[0] * refDxy[0] + dxy[1] * refDxy[1]) / l1 / l2;
	        offsetMultiplier = Math.max(0.0, dot);
	    }
	
	    var angle = Math.atan2(dy, dx) * 180 / Math.PI;
	    if(angle < -90) {
	        angle += 180;
	        flip = -flip;
	    } else if(angle > 90) {
	        angle -= 180;
	        flip = -flip;
	    }
	
	    return {
	        angle: angle,
	        flip: flip,
	        p: trace.c2p(xy, xaxis, yaxis),
	        offsetMultplier: offsetMultiplier
	    };
	};
	
	},{}],918:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../../components/drawing');
	var map1dArray = _dereq_('./map_1d_array');
	var makepath = _dereq_('./makepath');
	var orientText = _dereq_('./orient_text');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var Lib = _dereq_('../../lib');
	var alignmentConstants = _dereq_('../../constants/alignment');
	
	module.exports = function plot(gd, plotinfo, cdcarpet, carpetLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var fullLayout = gd._fullLayout;
	    var clipLayer = fullLayout._clips;
	
	    Lib.makeTraceGroups(carpetLayer, cdcarpet, 'trace').each(function(cd) {
	        var axisLayer = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	        var aax = trace.aaxis;
	        var bax = trace.baxis;
	
	        var minorLayer = Lib.ensureSingle(axisLayer, 'g', 'minorlayer');
	        var majorLayer = Lib.ensureSingle(axisLayer, 'g', 'majorlayer');
	        var boundaryLayer = Lib.ensureSingle(axisLayer, 'g', 'boundarylayer');
	        var labelLayer = Lib.ensureSingle(axisLayer, 'g', 'labellayer');
	
	        axisLayer.style('opacity', trace.opacity);
	
	        drawGridLines(xa, ya, majorLayer, aax, 'a', aax._gridlines, true);
	        drawGridLines(xa, ya, majorLayer, bax, 'b', bax._gridlines, true);
	        drawGridLines(xa, ya, minorLayer, aax, 'a', aax._minorgridlines, true);
	        drawGridLines(xa, ya, minorLayer, bax, 'b', bax._minorgridlines, true);
	
	        // NB: These are not ommitted if the lines are not active. The joins must be executed
	        // in order for them to get cleaned up without a full redraw
	        drawGridLines(xa, ya, boundaryLayer, aax, 'a-boundary', aax._boundarylines);
	        drawGridLines(xa, ya, boundaryLayer, bax, 'b-boundary', bax._boundarylines);
	
	        var labelOrientationA = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, aax._labels, 'a-label');
	        var labelOrientationB = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, bax._labels, 'b-label');
	
	        drawAxisTitles(gd, labelLayer, trace, cd0, xa, ya, labelOrientationA, labelOrientationB);
	
	        drawClipPath(trace, cd0, clipLayer, xa, ya);
	    });
	};
	
	function drawClipPath(trace, t, layer, xaxis, yaxis) {
	    var seg, xp, yp, i;
	
	    var clip = layer.select('#' + trace._clipPathId);
	
	    if(!clip.size()) {
	        clip = layer.append('clipPath')
	            .classed('carpetclip', true);
	    }
	
	    var path = Lib.ensureSingle(clip, 'path', 'carpetboundary');
	    var segments = t.clipsegments;
	    var segs = [];
	
	    for(i = 0; i < segments.length; i++) {
	        seg = segments[i];
	        xp = map1dArray([], seg.x, xaxis.c2p);
	        yp = map1dArray([], seg.y, yaxis.c2p);
	        segs.push(makepath(xp, yp, seg.bicubic));
	    }
	
	    // This could be optimized ever so slightly to avoid no-op L segments
	    // at the corners, but it's so negligible that I don't think it's worth
	    // the extra complexity
	    var clipPathData = 'M' + segs.join('L') + 'Z';
	    clip.attr('id', trace._clipPathId);
	    path.attr('d', clipPathData);
	}
	
	function drawGridLines(xaxis, yaxis, layer, axis, axisLetter, gridlines) {
	    var lineClass = 'const-' + axisLetter + '-lines';
	    var gridJoin = layer.selectAll('.' + lineClass).data(gridlines);
	
	    gridJoin.enter().append('path')
	        .classed(lineClass, true)
	        .style('vector-effect', 'non-scaling-stroke');
	
	    gridJoin.each(function(d) {
	        var gridline = d;
	        var x = gridline.x;
	        var y = gridline.y;
	
	        var xp = map1dArray([], x, xaxis.c2p);
	        var yp = map1dArray([], y, yaxis.c2p);
	
	        var path = 'M' + makepath(xp, yp, gridline.smoothing);
	
	        var el = d3.select(this);
	
	        el.attr('d', path)
	            .style('stroke-width', gridline.width)
	            .style('stroke', gridline.color)
	            .style('fill', 'none');
	    });
	
	    gridJoin.exit().remove();
	}
	
	function drawAxisLabels(gd, xaxis, yaxis, trace, t, layer, labels, labelClass) {
	    var labelJoin = layer.selectAll('text.' + labelClass).data(labels);
	
	    labelJoin.enter().append('text')
	        .classed(labelClass, true);
	
	    var maxExtent = 0;
	    var labelOrientation = {};
	
	    labelJoin.each(function(label, i) {
	        // Most of the positioning is done in calc_labels. Only the parts that depend upon
	        // the screen space representation of the x and y axes are here:
	        var orientation;
	        if(label.axis.tickangle === 'auto') {
	            orientation = orientText(trace, xaxis, yaxis, label.xy, label.dxy);
	        } else {
	            var angle = (label.axis.tickangle + 180.0) * Math.PI / 180.0;
	            orientation = orientText(trace, xaxis, yaxis, label.xy, [Math.cos(angle), Math.sin(angle)]);
	        }
	
	        if(!i) {
	            // TODO: offsetMultiplier? Not currently used anywhere...
	            labelOrientation = {angle: orientation.angle, flip: orientation.flip};
	        }
	        var direction = (label.endAnchor ? -1 : 1) * orientation.flip;
	
	        var labelEl = d3.select(this)
	            .attr({
	                'text-anchor': direction > 0 ? 'start' : 'end',
	                'data-notex': 1
	            })
	            .call(Drawing.font, label.font)
	            .text(label.text)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        var bbox = Drawing.bBox(this);
	
	        labelEl.attr('transform',
	                // Translate to the correct point:
	                'translate(' + orientation.p[0] + ',' + orientation.p[1] + ') ' +
	                // Rotate to line up with grid line tangent:
	                'rotate(' + orientation.angle + ')' +
	                // Adjust the baseline and indentation:
	                'translate(' + label.axis.labelpadding * direction + ',' + bbox.height * 0.3 + ')'
	            );
	
	        maxExtent = Math.max(maxExtent, bbox.width + label.axis.labelpadding);
	    });
	
	    labelJoin.exit().remove();
	
	    labelOrientation.maxExtent = maxExtent;
	    return labelOrientation;
	}
	
	function drawAxisTitles(gd, layer, trace, t, xa, ya, labelOrientationA, labelOrientationB) {
	    var a, b, xy, dxy;
	
	    var aMin = Lib.aggNums(Math.min, null, trace.a);
	    var aMax = Lib.aggNums(Math.max, null, trace.a);
	    var bMin = Lib.aggNums(Math.min, null, trace.b);
	    var bMax = Lib.aggNums(Math.max, null, trace.b);
	
	    a = 0.5 * (aMin + aMax);
	    b = bMin;
	    xy = trace.ab2xy(a, b, true);
	    dxy = trace.dxyda_rough(a, b);
	    if(labelOrientationA.angle === undefined) {
	        Lib.extendFlat(labelOrientationA, orientText(trace, xa, ya, xy, trace.dxydb_rough(a, b)));
	    }
	    drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.aaxis, xa, ya, labelOrientationA, 'a-title');
	
	    a = aMin;
	    b = 0.5 * (bMin + bMax);
	    xy = trace.ab2xy(a, b, true);
	    dxy = trace.dxydb_rough(a, b);
	    if(labelOrientationB.angle === undefined) {
	        Lib.extendFlat(labelOrientationB, orientText(trace, xa, ya, xy, trace.dxyda_rough(a, b)));
	    }
	    drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.baxis, xa, ya, labelOrientationB, 'b-title');
	}
	
	var lineSpacing = alignmentConstants.LINE_SPACING;
	var midShift = ((1 - alignmentConstants.MID_SHIFT) / lineSpacing) + 1;
	
	function drawAxisTitle(gd, layer, trace, t, xy, dxy, axis, xa, ya, labelOrientation, labelClass) {
	    var data = [];
	    if(axis.title.text) data.push(axis.title.text);
	    var titleJoin = layer.selectAll('text.' + labelClass).data(data);
	    var offset = labelOrientation.maxExtent;
	
	    titleJoin.enter().append('text')
	        .classed(labelClass, true);
	
	    // There's only one, but we'll do it as a join so it's updated nicely:
	    titleJoin.each(function() {
	        var orientation = orientText(trace, xa, ya, xy, dxy);
	
	        if(['start', 'both'].indexOf(axis.showticklabels) === -1) {
	            offset = 0;
	        }
	
	        // In addition to the size of the labels, add on some extra padding:
	        var titleSize = axis.title.font.size;
	        offset += titleSize + axis.title.offset;
	
	        var labelNorm = labelOrientation.angle + (labelOrientation.flip < 0 ? 180 : 0);
	        var angleDiff = (labelNorm - orientation.angle + 450) % 360;
	        var reverseTitle = angleDiff > 90 && angleDiff < 270;
	
	        var el = d3.select(this);
	
	        el.text(axis.title.text)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        if(reverseTitle) {
	            offset = (-svgTextUtils.lineCount(el) + midShift) * lineSpacing * titleSize - offset;
	        }
	
	        el.attr('transform',
	                'translate(' + orientation.p[0] + ',' + orientation.p[1] + ') ' +
	                'rotate(' + orientation.angle + ') ' +
	                'translate(0,' + offset + ')'
	            )
	            .classed('user-select-none', true)
	            .attr('text-anchor', 'middle')
	            .call(Drawing.font, axis.title.font);
	    });
	
	    titleJoin.exit().remove();
	}
	
	},{"../../components/drawing":612,"../../constants/alignment":685,"../../lib":716,"../../lib/svg_text_utils":740,"./makepath":915,"./map_1d_array":916,"./orient_text":917,"d3":164}],919:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var constants = _dereq_('./constants');
	var search = _dereq_('../../lib/search').findBin;
	var computeControlPoints = _dereq_('./compute_control_points');
	var createSplineEvaluator = _dereq_('./create_spline_evaluator');
	var createIDerivativeEvaluator = _dereq_('./create_i_derivative_evaluator');
	var createJDerivativeEvaluator = _dereq_('./create_j_derivative_evaluator');
	
	/*
	 * Create conversion functions to go from one basis to another. In particular the letter
	 * abbreviations are:
	 *
	 *   i: i/j coordinates along the grid. Integer values correspond to data points
	 *   a: real-valued coordinates along the a/b axes
	 *   c: cartesian x-y coordinates
	 *   p: screen-space pixel coordinates
	 */
	module.exports = function setConvert(trace) {
	    var a = trace._a;
	    var b = trace._b;
	    var na = a.length;
	    var nb = b.length;
	    var aax = trace.aaxis;
	    var bax = trace.baxis;
	
	    // Grab the limits once rather than recomputing the bounds for every point
	    // independently:
	    var amin = a[0];
	    var amax = a[na - 1];
	    var bmin = b[0];
	    var bmax = b[nb - 1];
	    var arange = a[a.length - 1] - a[0];
	    var brange = b[b.length - 1] - b[0];
	
	    // Compute the tolerance so that points are visible slightly outside the
	    // defined carpet axis:
	    var atol = arange * constants.RELATIVE_CULL_TOLERANCE;
	    var btol = brange * constants.RELATIVE_CULL_TOLERANCE;
	
	    // Expand the limits to include the relative tolerance:
	    amin -= atol;
	    amax += atol;
	    bmin -= btol;
	    bmax += btol;
	
	    trace.isVisible = function(a, b) {
	        return a > amin && a < amax && b > bmin && b < bmax;
	    };
	
	    trace.isOccluded = function(a, b) {
	        return a < amin || a > amax || b < bmin || b > bmax;
	    };
	
	    trace.setScale = function() {
	        var x = trace._x;
	        var y = trace._y;
	
	        // This is potentially a very expensive step! It does the bulk of the work of constructing
	        // an expanded basis of control points. Note in particular that it overwrites the existing
	        // basis without creating a new array since that would potentially thrash the garbage
	        // collector.
	        var result = computeControlPoints(trace._xctrl, trace._yctrl, x, y, aax.smoothing, bax.smoothing);
	        trace._xctrl = result[0];
	        trace._yctrl = result[1];
	
	        // This step is the second step in the process, but it's somewhat simpler. It just unrolls
	        // some logic since it would be unnecessarily expensive to compute both interpolations
	        // nearly identically but separately and to include a bunch of linear vs. bicubic logic in
	        // every single call.
	        trace.evalxy = createSplineEvaluator([trace._xctrl, trace._yctrl], na, nb, aax.smoothing, bax.smoothing);
	
	        trace.dxydi = createIDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
	        trace.dxydj = createJDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
	    };
	
	    /*
	     * Convert from i/j data grid coordinates to a/b values. Note in particular that this
	     * is *linear* interpolation, even if the data is interpolated bicubically.
	     */
	    trace.i2a = function(i) {
	        var i0 = Math.max(0, Math.floor(i[0]), na - 2);
	        var ti = i[0] - i0;
	        return (1 - ti) * a[i0] + ti * a[i0 + 1];
	    };
	
	    trace.j2b = function(j) {
	        var j0 = Math.max(0, Math.floor(j[1]), na - 2);
	        var tj = j[1] - j0;
	        return (1 - tj) * b[j0] + tj * b[j0 + 1];
	    };
	
	    trace.ij2ab = function(ij) {
	        return [trace.i2a(ij[0]), trace.j2b(ij[1])];
	    };
	
	    /*
	     * Convert from a/b coordinates to i/j grid-numbered coordinates. This requires searching
	     * through the a/b data arrays and assumes they are monotonic, which is presumed to have
	     * been enforced already.
	     */
	    trace.a2i = function(aval) {
	        var i0 = Math.max(0, Math.min(search(aval, a), na - 2));
	        var a0 = a[i0];
	        var a1 = a[i0 + 1];
	        return Math.max(0, Math.min(na - 1, i0 + (aval - a0) / (a1 - a0)));
	    };
	
	    trace.b2j = function(bval) {
	        var j0 = Math.max(0, Math.min(search(bval, b), nb - 2));
	        var b0 = b[j0];
	        var b1 = b[j0 + 1];
	        return Math.max(0, Math.min(nb - 1, j0 + (bval - b0) / (b1 - b0)));
	    };
	
	    trace.ab2ij = function(ab) {
	        return [trace.a2i(ab[0]), trace.b2j(ab[1])];
	    };
	
	    /*
	     * Convert from i/j coordinates to x/y caretesian coordinates. This means either bilinear
	     * or bicubic spline evaluation, but the hard part is already done at this point.
	     */
	    trace.i2c = function(i, j) {
	        return trace.evalxy([], i, j);
	    };
	
	    trace.ab2xy = function(aval, bval, extrapolate) {
	        if(!extrapolate && (aval < a[0] || aval > a[na - 1] | bval < b[0] || bval > b[nb - 1])) {
	            return [false, false];
	        }
	        var i = trace.a2i(aval);
	        var j = trace.b2j(bval);
	
	        var pt = trace.evalxy([], i, j);
	
	        if(extrapolate) {
	            // This section uses the boundary derivatives to extrapolate linearly outside
	            // the defined range. Consider a scatter line with one point inside the carpet
	            // axis and one point outside. If we don't extrapolate, we can't draw the line
	            // at all.
	            var iex = 0;
	            var jex = 0;
	            var der = [];
	
	            var i0, ti, j0, tj;
	            if(aval < a[0]) {
	                i0 = 0;
	                ti = 0;
	                iex = (aval - a[0]) / (a[1] - a[0]);
	            } else if(aval > a[na - 1]) {
	                i0 = na - 2;
	                ti = 1;
	                iex = (aval - a[na - 1]) / (a[na - 1] - a[na - 2]);
	            } else {
	                i0 = Math.max(0, Math.min(na - 2, Math.floor(i)));
	                ti = i - i0;
	            }
	
	            if(bval < b[0]) {
	                j0 = 0;
	                tj = 0;
	                jex = (bval - b[0]) / (b[1] - b[0]);
	            } else if(bval > b[nb - 1]) {
	                j0 = nb - 2;
	                tj = 1;
	                jex = (bval - b[nb - 1]) / (b[nb - 1] - b[nb - 2]);
	            } else {
	                j0 = Math.max(0, Math.min(nb - 2, Math.floor(j)));
	                tj = j - j0;
	            }
	
	            if(iex) {
	                trace.dxydi(der, i0, j0, ti, tj);
	                pt[0] += der[0] * iex;
	                pt[1] += der[1] * iex;
	            }
	
	            if(jex) {
	                trace.dxydj(der, i0, j0, ti, tj);
	                pt[0] += der[0] * jex;
	                pt[1] += der[1] * jex;
	            }
	        }
	
	        return pt;
	    };
	
	
	    trace.c2p = function(xy, xa, ya) {
	        return [xa.c2p(xy[0]), ya.c2p(xy[1])];
	    };
	
	    trace.p2x = function(p, xa, ya) {
	        return [xa.p2c(p[0]), ya.p2c(p[1])];
	    };
	
	    trace.dadi = function(i /* , u*/) {
	        // Right now only a piecewise linear a or b basis is permitted since smoother interpolation
	        // would cause monotonicity problems. As a retult, u is entirely disregarded in this
	        // computation, though we'll specify it as a parameter for the sake of completeness and
	        // future-proofing. It would be possible to use monotonic cubic interpolation, for example.
	        //
	        // See: https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
	        // u = u || 0;
	
	        var i0 = Math.max(0, Math.min(a.length - 2, i));
	
	        // The step (demoninator) is implicitly 1 since that's the grid spacing.
	        return a[i0 + 1] - a[i0];
	    };
	
	    trace.dbdj = function(j /* , v*/) {
	        // See above caveats for dadi which also apply here
	        var j0 = Math.max(0, Math.min(b.length - 2, j));
	
	        // The step (demoninator) is implicitly 1 since that's the grid spacing.
	        return b[j0 + 1] - b[j0];
	    };
	
	    // Takes: grid cell coordinate (i, j) and fractional grid cell coordinates (u, v)
	    // Returns: (dx/da, dy/db)
	    //
	    // NB: separate grid cell + fractional grid cell coordinate format is due to the discontinuous
	    // derivative, as described better in create_i_derivative_evaluator.js
	    trace.dxyda = function(i0, j0, u, v) {
	        var dxydi = trace.dxydi(null, i0, j0, u, v);
	        var dadi = trace.dadi(i0, u);
	
	        return [dxydi[0] / dadi, dxydi[1] / dadi];
	    };
	
	    trace.dxydb = function(i0, j0, u, v) {
	        var dxydj = trace.dxydj(null, i0, j0, u, v);
	        var dbdj = trace.dbdj(j0, v);
	
	        return [dxydj[0] / dbdj, dxydj[1] / dbdj];
	    };
	
	    // Sometimes we don't care about precision and all we really want is decent rough
	    // directions (as is the case with labels). In that case, we can do a very rough finite
	    // difference and spare having to worry about precise grid coordinates:
	    trace.dxyda_rough = function(a, b, reldiff) {
	        var h = arange * (reldiff || 0.1);
	        var plus = trace.ab2xy(a + h, b, true);
	        var minus = trace.ab2xy(a - h, b, true);
	
	        return [
	            (plus[0] - minus[0]) * 0.5 / h,
	            (plus[1] - minus[1]) * 0.5 / h
	        ];
	    };
	
	    trace.dxydb_rough = function(a, b, reldiff) {
	        var h = brange * (reldiff || 0.1);
	        var plus = trace.ab2xy(a, b + h, true);
	        var minus = trace.ab2xy(a, b - h, true);
	
	        return [
	            (plus[0] - minus[0]) * 0.5 / h,
	            (plus[1] - minus[1]) * 0.5 / h
	        ];
	    };
	
	    trace.dpdx = function(xa) {
	        return xa._m;
	    };
	
	    trace.dpdy = function(ya) {
	        return ya._m;
	    };
	};
	
	},{"../../lib/search":735,"./compute_control_points":907,"./constants":908,"./create_i_derivative_evaluator":909,"./create_j_derivative_evaluator":910,"./create_spline_evaluator":911}],920:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	/*
	 * Given a 2D array as well as a basis in either direction, this function fills in the
	 * 2D array using a combination of smoothing and extrapolation. This is rather important
	 * for carpet plots since it's used for layout so that we can't simply omit or blank out
	 * points. We need a reasonable guess so that the interpolation puts points somewhere
	 * even if we were to somehow represent that the data was missing later on.
	 *
	 * input:
	 *  - data: 2D array of arrays
	 *  - a: array such that a.length === data[0].length
	 *  - b: array such that b.length === data.length
	 */
	module.exports = function smoothFill2dArray(data, a, b) {
	    var i, j, k;
	    var ip = [];
	    var jp = [];
	    // var neighborCnts = [];
	
	    var ni = data[0].length;
	    var nj = data.length;
	
	    function avgSurrounding(i, j) {
	        // As a low-quality start, we can simply average surrounding points (in a not
	        // non-uniform grid aware manner):
	        var sum = 0.0;
	        var val;
	        var cnt = 0;
	        if(i > 0 && (val = data[j][i - 1]) !== undefined) {
	            cnt++;
	            sum += val;
	        }
	        if(i < ni - 1 && (val = data[j][i + 1]) !== undefined) {
	            cnt++;
	            sum += val;
	        }
	        if(j > 0 && (val = data[j - 1][i]) !== undefined) {
	            cnt++;
	            sum += val;
	        }
	        if(j < nj - 1 && (val = data[j + 1][i]) !== undefined) {
	            cnt++;
	            sum += val;
	        }
	        return sum / Math.max(1, cnt);
	    }
	
	    // This loop iterates over all cells. Any cells that are null will be noted and those
	    // are the only points we will loop over and update via laplace's equation. Points with
	    // any neighbors will receive the average. If there are no neighboring points, then they
	    // will be set to zero. Also as we go, track the maximum magnitude so that we can scale
	    // our tolerance accordingly.
	    var dmax = 0.0;
	    for(i = 0; i < ni; i++) {
	        for(j = 0; j < nj; j++) {
	            if(data[j][i] === undefined) {
	                ip.push(i);
	                jp.push(j);
	
	                data[j][i] = avgSurrounding(i, j);
	                // neighborCnts.push(result.neighbors);
	            }
	            dmax = Math.max(dmax, Math.abs(data[j][i]));
	        }
	    }
	
	    if(!ip.length) return data;
	
	    // The tolerance doesn't need to be excessive. It's just for display positioning
	    var dxp, dxm, dap, dam, dbp, dbm, c, d, diff, reldiff, overrelaxation;
	    var tol = 1e-5;
	    var resid = 0;
	    var itermax = 100;
	    var iter = 0;
	    var n = ip.length;
	    do {
	        resid = 0;
	        // Normally we'd loop in two dimensions, but not all points are blank and need
	        // an update, so we instead loop only over the points that were tabulated above
	        for(k = 0; k < n; k++) {
	            i = ip[k];
	            j = jp[k];
	            // neighborCnt = neighborCnts[k];
	
	            // Track a counter for how many contributions there are. We'll use this counter
	            // to average at the end, which reduces to laplace's equation with neumann boundary
	            // conditions on the first derivative (second derivative is zero so that we get
	            // a nice linear extrapolation at the boundaries).
	            var boundaryCnt = 0;
	            var newVal = 0;
	
	            var d0, d1, x0, x1, i0, j0;
	            if(i === 0) {
	                // If this lies along the i = 0 boundary, extrapolate from the two points
	                // to the right of this point. Note that the finite differences take into
	                // account non-uniform grid spacing:
	                i0 = Math.min(ni - 1, 2);
	                x0 = a[i0];
	                x1 = a[1];
	                d0 = data[j][i0];
	                d1 = data[j][1];
	                newVal += d1 + (d1 - d0) * (a[0] - x1) / (x1 - x0);
	                boundaryCnt++;
	            } else if(i === ni - 1) {
	                // If along the high i boundary, extrapolate from the two points to the
	                // left of this point
	                i0 = Math.max(0, ni - 3);
	                x0 = a[i0];
	                x1 = a[ni - 2];
	                d0 = data[j][i0];
	                d1 = data[j][ni - 2];
	                newVal += d1 + (d1 - d0) * (a[ni - 1] - x1) / (x1 - x0);
	                boundaryCnt++;
	            }
	
	            if((i === 0 || i === ni - 1) && (j > 0 && j < nj - 1)) {
	                // If along the min(i) or max(i) boundaries, also smooth vertically as long
	                // as we're not in a corner. Note that the finite differences used here
	                // are also aware of nonuniform grid spacing:
	                dxp = b[j + 1] - b[j];
	                dxm = b[j] - b[j - 1];
	                newVal += (dxm * data[j + 1][i] + dxp * data[j - 1][i]) / (dxm + dxp);
	                boundaryCnt++;
	            }
	
	            if(j === 0) {
	                // If along the j = 0 boundary, extrpolate this point from the two points
	                // above it
	                j0 = Math.min(nj - 1, 2);
	                x0 = b[j0];
	                x1 = b[1];
	                d0 = data[j0][i];
	                d1 = data[1][i];
	                newVal += d1 + (d1 - d0) * (b[0] - x1) / (x1 - x0);
	                boundaryCnt++;
	            } else if(j === nj - 1) {
	                // Same for the max j boundary from the cells below it:
	                j0 = Math.max(0, nj - 3);
	                x0 = b[j0];
	                x1 = b[nj - 2];
	                d0 = data[j0][i];
	                d1 = data[nj - 2][i];
	                newVal += d1 + (d1 - d0) * (b[nj - 1] - x1) / (x1 - x0);
	                boundaryCnt++;
	            }
	
	            if((j === 0 || j === nj - 1) && (i > 0 && i < ni - 1)) {
	                // Now average points to the left/right as long as not in a corner:
	                dxp = a[i + 1] - a[i];
	                dxm = a[i] - a[i - 1];
	                newVal += (dxm * data[j][i + 1] + dxp * data[j][i - 1]) / (dxm + dxp);
	                boundaryCnt++;
	            }
	
	            if(!boundaryCnt) {
	                // If none of the above conditions were triggered, then this is an interior
	                // point and we can just do a laplace equation update. As above, these differences
	                // are aware of nonuniform grid spacing:
	                dap = a[i + 1] - a[i];
	                dam = a[i] - a[i - 1];
	                dbp = b[j + 1] - b[j];
	                dbm = b[j] - b[j - 1];
	
	                // These are just some useful constants for the iteration, which is perfectly
	                // straightforward but a little long to derive from f_xx + f_yy = 0.
	                c = dap * dam * (dap + dam);
	                d = dbp * dbm * (dbp + dbm);
	
	                newVal = (c * (dbm * data[j + 1][i] + dbp * data[j - 1][i]) +
	                          d * (dam * data[j][i + 1] + dap * data[j][i - 1])) /
	                          (d * (dam + dap) + c * (dbm + dbp));
	            } else {
	                // If we did have contributions from the boundary conditions, then average
	                // the result from the various contributions:
	                newVal /= boundaryCnt;
	            }
	
	            // Jacobi updates are ridiculously slow to converge, so this approach uses a
	            // Gauss-seidel iteration which is dramatically faster.
	            diff = newVal - data[j][i];
	            reldiff = diff / dmax;
	            resid += reldiff * reldiff;
	
	            // Gauss-Seidel-ish iteration, omega chosen based on heuristics and some
	            // quick tests.
	            //
	            // NB: Don't overrelax the boundarie. Otherwise set an overrelaxation factor
	            // which is a little low but safely optimal-ish:
	            overrelaxation = boundaryCnt ? 0 : 0.85;
	
	            // If there are four non-null neighbors, then we want a simple average without
	            // overrelaxation. If all the surrouding points are null, then we want the full
	            // overrelaxation
	            //
	            // Based on experiments, this actually seems to slow down convergence just a bit.
	            // I'll leave it here for reference in case this needs to be revisited, but
	            // it seems to work just fine without this.
	            // if (overrelaxation) overrelaxation *= (4 - neighborCnt) / 4;
	
	            data[j][i] += diff * (1 + overrelaxation);
	        }
	
	        resid = Math.sqrt(resid);
	    } while(iter++ < itermax && resid > tol);
	
	    Lib.log('Smoother converged to', resid, 'after', iter, 'iterations');
	
	    return data;
	};
	
	},{"../../lib":716}],921:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isArray1D = _dereq_('../../lib').isArray1D;
	
	module.exports = function handleXYDefaults(traceIn, traceOut, coerce) {
	    var x = coerce('x');
	    var hasX = x && x.length;
	    var y = coerce('y');
	    var hasY = y && y.length;
	    if(!hasX && !hasY) return false;
	
	    traceOut._cheater = !x;
	
	    if((!hasX || isArray1D(x)) && (!hasY || isArray1D(y))) {
	        var len = hasX ? x.length : Infinity;
	        if(hasY) len = Math.min(len, y.length);
	        if(traceOut.a && traceOut.a.length) len = Math.min(len, traceOut.a.length);
	        if(traceOut.b && traceOut.b.length) len = Math.min(len, traceOut.b.length);
	        traceOut._length = len;
	    } else traceOut._length = null;
	
	    return true;
	};
	
	},{"../../lib":716}],922:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var scatterGeoAttrs = _dereq_('../scattergeo/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var defaultLine = _dereq_('../../components/color/attributes').defaultLine;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var scatterGeoMarkerLineAttrs = scatterGeoAttrs.marker.line;
	
	module.exports = extendFlat({
	    locations: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    locationmode: scatterGeoAttrs.locationmode,
	    z: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    text: extendFlat({}, scatterGeoAttrs.text, {
	        
	    }),
	    hovertext: extendFlat({}, scatterGeoAttrs.hovertext, {
	        
	    }),
	    marker: {
	        line: {
	            color: extendFlat({}, scatterGeoMarkerLineAttrs.color, {dflt: defaultLine}),
	            width: extendFlat({}, scatterGeoMarkerLineAttrs.width, {dflt: 1}),
	            editType: 'calc'
	        },
	        opacity: {
	            valType: 'number',
	            arrayOk: true,
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	            editType: 'style',
	            
	        },
	        editType: 'calc'
	    },
	
	    selected: {
	        marker: {
	            opacity: scatterGeoAttrs.selected.marker.opacity,
	            editType: 'plot'
	        },
	        editType: 'plot'
	    },
	    unselected: {
	        marker: {
	            opacity: scatterGeoAttrs.unselected.marker.opacity,
	            editType: 'plot'
	        },
	        editType: 'plot'
	    },
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        editType: 'calc',
	        flags: ['location', 'z', 'text', 'name']
	    }),
	    hovertemplate: hovertemplateAttrs()
	},
	
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        editTypeOverride: 'calc'
	    })
	);
	
	},{"../../components/color/attributes":590,"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scattergeo/attributes":1159}],923:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	
	function isNonBlankString(v) {
	    return v && typeof v === 'string';
	}
	
	module.exports = function calc(gd, trace) {
	    var len = trace._length;
	    var calcTrace = new Array(len);
	
	    var isValidLoc;
	
	    if(trace.geojson) {
	        isValidLoc = function(v) { return isNonBlankString(v) || isNumeric(v); };
	    } else {
	        isValidLoc = isNonBlankString;
	    }
	
	    for(var i = 0; i < len; i++) {
	        var calcPt = calcTrace[i] = {};
	        var loc = trace.locations[i];
	        var z = trace.z[i];
	
	        if(isValidLoc(loc) && isNumeric(z)) {
	            calcPt.loc = loc;
	            calcPt.z = z;
	        } else {
	            calcPt.loc = null;
	            calcPt.z = BADNUM;
	        }
	
	        calcPt.index = i;
	    }
	
	    arraysToCalcdata(calcTrace, trace);
	    colorscaleCalc(gd, trace, {
	        vals: trace.z,
	        containerStr: '',
	        cLetter: 'z'
	    });
	    calcSelection(calcTrace, trace);
	
	    return calcTrace;
	};
	
	},{"../../components/colorscale/calc":599,"../../constants/numerical":692,"../scatter/arrays_to_calcdata":1117,"../scatter/calc_selection":1120,"fast-isnumeric":227}],924:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var locations = coerce('locations');
	    var z = coerce('z');
	
	    if(!(locations && locations.length && Lib.isArrayOrTypedArray(z) && z.length)) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = Math.min(locations.length, z.length);
	
	    coerce('locationmode');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var mlw = coerce('marker.line.width');
	    if(mlw) coerce('marker.line.color');
	    coerce('marker.opacity');
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":922}],925:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt, trace, cd, pointNumber) {
	    out.location = pt.location;
	    out.z = pt.z;
	
	    var cdi = cd[pointNumber];
	    if(cdi.fIn) {
	        out.properties = cdi.fIn.properties;
	    }
	
	    return out;
	};
	
	},{}],926:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var attributes = _dereq_('./attributes');
	var fillText = _dereq_('../../lib').fillText;
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var geo = pointData.subplot;
	
	    var pt, i, j, isInside;
	
	    for(i = 0; i < cd.length; i++) {
	        pt = cd[i];
	        isInside = false;
	
	        if(pt._polygons) {
	            for(j = 0; j < pt._polygons.length; j++) {
	                if(pt._polygons[j].contains([xval, yval])) {
	                    isInside = !isInside;
	                }
	                // for polygons that cross antimeridian as xval is in [-180, 180]
	                if(pt._polygons[j].contains([xval + 360, yval])) {
	                    isInside = !isInside;
	                }
	            }
	
	            if(isInside) break;
	        }
	    }
	
	    if(!isInside || !pt) return;
	
	    pointData.x0 = pointData.x1 = pointData.xa.c2p(pt.ct);
	    pointData.y0 = pointData.y1 = pointData.ya.c2p(pt.ct);
	
	    pointData.index = pt.index;
	    pointData.location = pt.loc;
	    pointData.z = pt.z;
	    pointData.zLabel = Axes.tickText(geo.mockAxis, geo.mockAxis.c2l(pt.z), 'hover').text;
	    pointData.hovertemplate = pt.hovertemplate;
	
	    makeHoverInfo(pointData, trace, pt, geo.mockAxis);
	
	    return [pointData];
	};
	
	function makeHoverInfo(pointData, trace, pt) {
	    if(trace.hovertemplate) return;
	
	    var hoverinfo = pt.hi || trace.hoverinfo;
	    var loc = String(pt.loc);
	
	    var parts = (hoverinfo === 'all') ?
	        attributes.hoverinfo.flags :
	        hoverinfo.split('+');
	
	    var hasName = (parts.indexOf('name') !== -1);
	    var hasLocation = (parts.indexOf('location') !== -1);
	    var hasZ = (parts.indexOf('z') !== -1);
	    var hasText = (parts.indexOf('text') !== -1);
	    var hasIdAsNameLabel = !hasName && hasLocation;
	
	    var text = [];
	
	    if(hasIdAsNameLabel) {
	        pointData.nameOverride = loc;
	    } else {
	        if(hasName) pointData.nameOverride = trace.name;
	        if(hasLocation) text.push(loc);
	    }
	
	    if(hasZ) {
	        text.push(pointData.zLabel);
	    }
	    if(hasText) {
	        fillText(pt, trace, text);
	    }
	
	    pointData.extraText = text.join('<br>');
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"./attributes":922}],927:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../heatmap/colorbar'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style').style,
	    styleOnSelect: _dereq_('./style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	    selectPoints: _dereq_('./select'),
	
	    moduleType: 'trace',
	    name: 'choropleth',
	    basePlotModule: _dereq_('../../plots/geo'),
	    categories: ['geo', 'noOpacity'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/geo":794,"../heatmap/colorbar":1001,"./attributes":922,"./calc":923,"./defaults":924,"./event_data":925,"./hover":926,"./plot":928,"./select":929,"./style":930}],928:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var polygon = _dereq_('../../lib/polygon');
	
	var getTopojsonFeatures = _dereq_('../../lib/topojson_utils').getTopojsonFeatures;
	var locationToFeature = _dereq_('../../lib/geo_location_utils').locationToFeature;
	var style = _dereq_('./style').style;
	
	function plot(gd, geo, calcData) {
	    for(var i = 0; i < calcData.length; i++) {
	        calcGeoJSON(calcData[i], geo.topojson);
	    }
	
	    var choroplethLayer = geo.layers.backplot.select('.choroplethlayer');
	    Lib.makeTraceGroups(choroplethLayer, calcData, 'trace choropleth').each(function(calcTrace) {
	        var sel = d3.select(this);
	
	        var paths = sel.selectAll('path.choroplethlocation')
	            .data(Lib.identity);
	
	        paths.enter().append('path')
	            .classed('choroplethlocation', true);
	
	        paths.exit().remove();
	
	        // call style here within topojson request callback
	        style(gd, calcTrace);
	    });
	}
	
	function calcGeoJSON(calcTrace, topojson) {
	    var trace = calcTrace[0].trace;
	    var len = calcTrace.length;
	    var features = getTopojsonFeatures(trace, topojson);
	
	    for(var i = 0; i < len; i++) {
	        var calcPt = calcTrace[i];
	        var feature = locationToFeature(trace.locationmode, calcPt.loc, features);
	
	        if(!feature) {
	            calcPt.geojson = null;
	            continue;
	        }
	
	        calcPt.geojson = feature;
	        calcPt.ct = feature.properties.ct;
	        calcPt._polygons = feature2polygons(feature);
	    }
	}
	
	function feature2polygons(feature) {
	    var geometry = feature.geometry;
	    var coords = geometry.coordinates;
	    var loc = feature.id;
	
	    var polygons = [];
	    var appendPolygon, j, k, m;
	
	    function doesCrossAntiMerdian(pts) {
	        for(var l = 0; l < pts.length - 1; l++) {
	            if(pts[l][0] > 0 && pts[l + 1][0] < 0) return l;
	        }
	        return null;
	    }
	
	    if(loc === 'RUS' || loc === 'FJI') {
	        // Russia and Fiji have landmasses that cross the antimeridian,
	        // we need to add +360 to their longitude coordinates, so that
	        // polygon 'contains' doesn't get confused when crossing the antimeridian.
	        //
	        // Note that other countries have polygons on either side of the antimeridian
	        // (e.g. some Aleutian island for the USA), but those don't confuse
	        // the 'contains' method; these are skipped here.
	        appendPolygon = function(_pts) {
	            var pts;
	
	            if(doesCrossAntiMerdian(_pts) === null) {
	                pts = _pts;
	            } else {
	                pts = new Array(_pts.length);
	                for(m = 0; m < _pts.length; m++) {
	                    // do nut mutate calcdata[i][j].geojson !!
	                    pts[m] = [
	                        _pts[m][0] < 0 ? _pts[m][0] + 360 : _pts[m][0],
	                        _pts[m][1]
	                    ];
	                }
	            }
	
	            polygons.push(polygon.tester(pts));
	        };
	    } else if(loc === 'ATA') {
	        // Antarctica has a landmass that wraps around every longitudes which
	        // confuses the 'contains' methods.
	        appendPolygon = function(pts) {
	            var crossAntiMeridianIndex = doesCrossAntiMerdian(pts);
	
	            // polygon that do not cross anti-meridian need no special handling
	            if(crossAntiMeridianIndex === null) {
	                return polygons.push(polygon.tester(pts));
	            }
	
	            // stitch polygon by adding pt over South Pole,
	            // so that it covers the projected region covers all latitudes
	            //
	            // Note that the algorithm below only works for polygons that
	            // start and end on longitude -180 (like the ones built by
	            // https://github.com/etpinard/sane-topojson).
	            var stitch = new Array(pts.length + 1);
	            var si = 0;
	
	            for(m = 0; m < pts.length; m++) {
	                if(m > crossAntiMeridianIndex) {
	                    stitch[si++] = [pts[m][0] + 360, pts[m][1]];
	                } else if(m === crossAntiMeridianIndex) {
	                    stitch[si++] = pts[m];
	                    stitch[si++] = [pts[m][0], -90];
	                } else {
	                    stitch[si++] = pts[m];
	                }
	            }
	
	            // polygon.tester by default appends pt[0] to the points list,
	            // we must remove it here, to avoid a jump in longitude from 180 to -180,
	            // that would confuse the 'contains' method
	            var tester = polygon.tester(stitch);
	            tester.pts.pop();
	            polygons.push(tester);
	        };
	    } else {
	        // otherwise using same array ref is fine
	        appendPolygon = function(pts) {
	            polygons.push(polygon.tester(pts));
	        };
	    }
	
	    switch(geometry.type) {
	        case 'MultiPolygon':
	            for(j = 0; j < coords.length; j++) {
	                for(k = 0; k < coords[j].length; k++) {
	                    appendPolygon(coords[j][k]);
	                }
	            }
	            break;
	        case 'Polygon':
	            for(j = 0; j < coords.length; j++) {
	                appendPolygon(coords[j]);
	            }
	            break;
	    }
	
	    return polygons;
	}
	
	module.exports = {
	    plot: plot,
	    feature2polygons: feature2polygons
	};
	
	},{"../../lib":716,"../../lib/geo_location_utils":710,"../../lib/polygon":728,"../../lib/topojson_utils":743,"./style":930,"d3":164}],929:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	
	    var i, di, ct, x, y;
	
	    if(selectionTester === false) {
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            di = cd[i];
	            ct = di.ct;
	
	            if(!ct) continue;
	
	            x = xa.c2p(ct);
	            y = ya.c2p(ct);
	
	            if(selectionTester.contains([x, y], null, i, searchInfo)) {
	                selection.push({
	                    pointNumber: i,
	                    lon: ct[0],
	                    lat: ct[1]
	                });
	                di.selected = 1;
	            } else {
	                di.selected = 0;
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{}],930:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Colorscale = _dereq_('../../components/colorscale');
	
	function style(gd, calcTrace) {
	    if(calcTrace) styleTrace(gd, calcTrace);
	}
	
	function styleTrace(gd, calcTrace) {
	    var trace = calcTrace[0].trace;
	    var s = calcTrace[0].node3;
	    var locs = s.selectAll('.choroplethlocation');
	    var marker = trace.marker || {};
	    var markerLine = marker.line || {};
	
	    var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
	
	    locs.each(function(d) {
	        d3.select(this)
	            .attr('fill', sclFunc(d.z))
	            .call(Color.stroke, d.mlc || markerLine.color)
	            .call(Drawing.dashLine, '', d.mlw || markerLine.width || 0)
	            .style('opacity', marker.opacity);
	    });
	
	    Drawing.selectedPointStyle(locs, trace, gd);
	}
	
	function styleOnSelect(gd, calcTrace) {
	    var s = calcTrace[0].node3;
	    var trace = calcTrace[0].trace;
	
	    if(trace.selectedpoints) {
	        Drawing.selectedPointStyle(s.selectAll('.choroplethlocation'), trace, gd);
	    } else {
	        styleTrace(gd, calcTrace);
	    }
	}
	
	module.exports = {
	    style: style,
	    styleOnSelect: styleOnSelect
	};
	
	},{"../../components/color":591,"../../components/colorscale":603,"../../components/drawing":612,"d3":164}],931:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var choroplethAttrs = _dereq_('../choropleth/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = extendFlat({
	    locations: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    // TODO
	    // Maybe start with only one value (that we could name e.g. 'geojson-id'),
	    // but eventually:
	    // - we could also support for our own dist/topojson/*
	    // - some people might want `geojson-properties-name` to map data arrays to
	    //   GeoJSON features
	    // locationmode: choroplethAttrs.locationmode,
	
	    z: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    // TODO maybe we could also set a "key" to dig out values out of the
	    // GeoJSON feature `properties` fields?
	
	    geojson: {
	        valType: 'any',
	        
	        editType: 'calc',
	        
	    },
	
	    // TODO agree on name / behaviour
	    //
	    // 'below' is used currently for layout.mapbox.layers,
	    // even though it's not very plotly-esque.
	    //
	    // Note also, that the mapbox-gl style don't all have the same layers,
	    // see https://codepen.io/etpinard/pen/ydVMwM for full list
	    below: {
	        valType: 'string',
	        
	        editType: 'plot',
	        
	    },
	
	    text: choroplethAttrs.text,
	    hovertext: choroplethAttrs.hovertext,
	
	    marker: {
	        line: {
	            color: extendFlat({}, choroplethAttrs.marker.line.color, {editType: 'plot'}),
	            width: extendFlat({}, choroplethAttrs.marker.line.width, {editType: 'plot'}),
	            editType: 'calc'
	        },
	        // TODO maybe having a dflt less than 1, together with `below:''` would be better?
	        opacity: extendFlat({}, choroplethAttrs.marker.opacity, {editType: 'plot'}),
	        editType: 'calc'
	    },
	
	    selected: {
	        marker: {
	            opacity: extendFlat({}, choroplethAttrs.selected.marker.opacity, {editType: 'plot'}),
	            editType: 'plot'
	        },
	        editType: 'plot'
	    },
	    unselected: {
	        marker: {
	            opacity: extendFlat({}, choroplethAttrs.unselected.marker.opacity, {editType: 'plot'}),
	            editType: 'plot'
	        },
	        editType: 'plot'
	    },
	
	    hoverinfo: choroplethAttrs.hoverinfo,
	    hovertemplate: hovertemplateAttrs({}, {keys: ['properties']})
	},
	
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        editTypeOverride: 'calc'
	    })
	);
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/template_attributes":840,"../choropleth/attributes":922}],932:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var turfArea = _dereq_('@turf/area');
	var turfCentroid = _dereq_('@turf/centroid');
	
	var Lib = _dereq_('../../lib');
	var Colorscale = _dereq_('../../components/colorscale');
	var Drawing = _dereq_('../../components/drawing');
	
	var makeBlank = _dereq_('../../lib/geojson_utils').makeBlank;
	var feature2polygons = _dereq_('../choropleth/plot').feature2polygons;
	
	/* N.B.
	 *
	 * We fetch the GeoJSON files "ourselves" (during
	 * mapbox.prototype.fetchMapData) where they are stored in a global object
	 * named `PlotlyGeoAssets` (same as for topojson files in `geo` subplots).
	 *
	 * Mapbox does allow using URLs as geojson sources, but does NOT allow filtering
	 * features by feature `id` that are not numbers (more info in:
	 * https://github.com/mapbox/mapbox-gl-js/issues/8088).
	 */
	
	function convert(calcTrace) {
	    var trace = calcTrace[0].trace;
	    var isVisible = trace.visible === true && trace._length !== 0;
	
	    var fill = {
	        layout: {visibility: 'none'},
	        paint: {}
	    };
	
	    var line = {
	        layout: {visibility: 'none'},
	        paint: {}
	    };
	
	    var opts = trace._opts = {
	        fill: fill,
	        line: line,
	        geojson: makeBlank()
	    };
	
	    if(!isVisible) return opts;
	
	    var geojsonIn = typeof trace.geojson === 'string' ?
	        (window.PlotlyGeoAssets || {})[trace.geojson] :
	        trace.geojson;
	
	    // This should not happen, but just in case something goes
	    // really wrong when fetching the GeoJSON
	    if(!Lib.isPlainObject(geojsonIn)) {
	        Lib.error('Oops ... something when wrong when fetching ' + trace.geojson);
	        return opts;
	    }
	
	    var lookup = {};
	    var featuresOut = [];
	    var i;
	
	    for(i = 0; i < calcTrace.length; i++) {
	        var cdi = calcTrace[i];
	        if(cdi.loc) lookup[cdi.loc] = cdi;
	    }
	
	    var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
	    var marker = trace.marker;
	    var markerLine = marker.line || {};
	
	    var opacityFn;
	    if(Lib.isArrayOrTypedArray(marker.opacity)) {
	        opacityFn = function(d) {
	            var mo = d.mo;
	            return isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
	        };
	    }
	
	    var lineColorFn;
	    if(Lib.isArrayOrTypedArray(markerLine.color)) {
	        lineColorFn = function(d) { return d.mlc; };
	    }
	
	    var lineWidthFn;
	    if(Lib.isArrayOrTypedArray(markerLine.width)) {
	        lineWidthFn = function(d) { return d.mlw; };
	    }
	
	    function appendFeature(fIn) {
	        var cdi = lookup[fIn.id];
	
	        if(cdi) {
	            var geometry = fIn.geometry;
	
	            if(geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
	                var props = {fc: sclFunc(cdi.z)};
	
	                if(opacityFn) props.mo = opacityFn(cdi);
	                if(lineColorFn) props.mlc = lineColorFn(cdi);
	                if(lineWidthFn) props.mlw = lineWidthFn(cdi);
	
	                var fOut = {
	                    type: 'Feature',
	                    geometry: geometry,
	                    properties: props
	                };
	
	                cdi._polygons = feature2polygons(fOut);
	                cdi.ct = findCentroid(fOut);
	                cdi.fIn = fIn;
	                cdi.fOut = fOut;
	                featuresOut.push(fOut);
	            } else {
	                Lib.log([
	                    'Location with id', cdi.loc, 'does not have a valid GeoJSON geometry,',
	                    'choroplethmapbox traces only support *Polygon* and *MultiPolygon* geometries.'
	                ].join(' '));
	            }
	        }
	
	        // remove key from lookup, so that we can track (if any)
	        // the locations that did not have a corresponding GeoJSON feature
	        delete lookup[fIn.id];
	    }
	
	    switch(geojsonIn.type) {
	        case 'FeatureCollection':
	            var featuresIn = geojsonIn.features;
	            for(i = 0; i < featuresIn.length; i++) {
	                appendFeature(featuresIn[i]);
	            }
	            break;
	        case 'Feature':
	            appendFeature(geojsonIn);
	            break;
	        default:
	            Lib.warn([
	                'Invalid GeoJSON type', (geojsonIn.type || 'none') + ',',
	                'choroplethmapbox traces only support *FeatureCollection* and *Feature* types.'
	            ].join(' '));
	            return opts;
	    }
	
	    for(var loc in lookup) {
	        Lib.log('Location with id ' + loc + ' does not have a matching feature');
	    }
	
	    var opacitySetting = opacityFn ?
	        {type: 'identity', property: 'mo'} :
	        marker.opacity;
	
	    Lib.extendFlat(fill.paint, {
	        'fill-color': {type: 'identity', property: 'fc'},
	        'fill-opacity': opacitySetting
	    });
	
	    Lib.extendFlat(line.paint, {
	        'line-color': lineColorFn ?
	            {type: 'identity', property: 'mlc'} :
	            markerLine.color,
	        'line-width': lineWidthFn ?
	            {type: 'identity', property: 'mlw'} :
	            markerLine.width,
	        'line-opacity': opacitySetting
	    });
	
	    fill.layout.visibility = 'visible';
	    line.layout.visibility = 'visible';
	
	    opts.geojson = {type: 'FeatureCollection', features: featuresOut};
	
	    convertOnSelect(calcTrace);
	
	    return opts;
	}
	
	function convertOnSelect(calcTrace) {
	    var trace = calcTrace[0].trace;
	    var opts = trace._opts;
	    var opacitySetting;
	
	    if(trace.selectedpoints) {
	        var fns = Drawing.makeSelectedPointStyleFns(trace);
	
	        for(var i = 0; i < calcTrace.length; i++) {
	            var cdi = calcTrace[i];
	            if(cdi.fOut) {
	                cdi.fOut.properties.mo2 = fns.selectedOpacityFn(cdi);
	            }
	        }
	
	        opacitySetting = {type: 'identity', property: 'mo2'};
	    } else {
	        opacitySetting = Lib.isArrayOrTypedArray(trace.marker.opacity) ?
	            {type: 'identity', property: 'mo'} :
	            trace.marker.opacity;
	    }
	
	    Lib.extendFlat(opts.fill.paint, {'fill-opacity': opacitySetting});
	    Lib.extendFlat(opts.line.paint, {'line-opacity': opacitySetting});
	
	    return opts;
	}
	
	// TODO this find the centroid of the polygon of maxArea
	// (just like we currently do for geo choropleth polygons),
	// maybe instead it would make more sense to compute the centroid
	// of each polygon and consider those on hover/select
	function findCentroid(feature) {
	    var geometry = feature.geometry;
	    var poly;
	
	    if(geometry.type === 'MultiPolygon') {
	        var coords = geometry.coordinates;
	        var maxArea = 0;
	
	        for(var i = 0; i < coords.length; i++) {
	            var polyi = {type: 'Polygon', coordinates: coords[i]};
	            var area = turfArea.default(polyi);
	            if(area > maxArea) {
	                maxArea = area;
	                poly = polyi;
	            }
	        }
	    } else {
	        poly = geometry;
	    }
	
	    return turfCentroid.default(poly).geometry.coordinates;
	}
	
	module.exports = {
	    convert: convert,
	    convertOnSelect: convertOnSelect
	};
	
	},{"../../components/colorscale":603,"../../components/drawing":612,"../../lib":716,"../../lib/geojson_utils":711,"../choropleth/plot":928,"@turf/area":57,"@turf/centroid":58,"fast-isnumeric":227}],933:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var locations = coerce('locations');
	    var z = coerce('z');
	    var geojson = coerce('geojson');
	
	    if(!Lib.isArrayOrTypedArray(locations) || !locations.length ||
	        !Lib.isArrayOrTypedArray(z) || !z.length ||
	        !((typeof geojson === 'string' && geojson !== '') || Lib.isPlainObject(geojson))
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = Math.min(locations.length, z.length);
	
	    coerce('below');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var mlw = coerce('marker.line.width');
	    if(mlw) coerce('marker.line.color');
	    coerce('marker.opacity');
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":931}],934:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../heatmap/colorbar'),
	    calc: _dereq_('../choropleth/calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: _dereq_('../choropleth/hover'),
	    eventData: _dereq_('../choropleth/event_data'),
	    selectPoints: _dereq_('../choropleth/select'),
	
	    styleOnSelect: function(_, cd) {
	        if(cd) {
	            var trace = cd[0].trace;
	            trace._glTrace.updateOnSelect(cd);
	        }
	    },
	
	    getBelow: function(trace, subplot) {
	        var mapLayers = subplot.getMapLayers();
	
	        // find layer just above top-most "water" layer
	        // that is not a plotly layer
	        for(var i = mapLayers.length - 2; i >= 0; i--) {
	            var layerId = mapLayers[i].id;
	
	            if(typeof layerId === 'string' &&
	                layerId.indexOf('water') === 0
	             ) {
	                for(var j = i + 1; j < mapLayers.length; j++) {
	                    layerId = mapLayers[j].id;
	
	                    if(typeof layerId === 'string' &&
	                        layerId.indexOf('plotly-') === -1
	                    ) {
	                        return layerId;
	                    }
	                }
	            }
	        }
	    },
	
	    moduleType: 'trace',
	    name: 'choroplethmapbox',
	    basePlotModule: _dereq_('../../plots/mapbox'),
	    categories: ['mapbox', 'gl', 'noOpacity'],
	    meta: {
	        hr_name: 'choropleth_mapbox',
	        
	    }
	};
	
	},{"../../plots/mapbox":819,"../choropleth/calc":923,"../choropleth/event_data":925,"../choropleth/hover":926,"../choropleth/select":929,"../heatmap/colorbar":1001,"./attributes":931,"./defaults":933,"./plot":935}],935:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var convert = _dereq_('./convert').convert;
	var convertOnSelect = _dereq_('./convert').convertOnSelect;
	var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
	
	function ChoroplethMapbox(subplot, uid) {
	    this.type = 'choroplethmapbox';
	    this.subplot = subplot;
	    this.uid = uid;
	
	    // N.B. fill and line layers share same source
	    this.sourceId = 'source-' + uid;
	
	    this.layerList = [
	        ['fill', LAYER_PREFIX + uid + '-fill'],
	        ['line', LAYER_PREFIX + uid + '-line']
	    ];
	
	    // previous 'below' value,
	    // need this to update it properly
	    this.below = null;
	}
	
	var proto = ChoroplethMapbox.prototype;
	
	proto.update = function(calcTrace) {
	    this._update(convert(calcTrace));
	};
	
	proto.updateOnSelect = function(calcTrace) {
	    this._update(convertOnSelect(calcTrace));
	};
	
	proto._update = function(optsAll) {
	    var subplot = this.subplot;
	    var layerList = this.layerList;
	    var below = subplot.belowLookup['trace-' + this.uid];
	
	    subplot.map
	        .getSource(this.sourceId)
	        .setData(optsAll.geojson);
	
	    if(below !== this.below) {
	        this._removeLayers();
	        this._addLayers(optsAll, below);
	        this.below = below;
	    }
	
	    for(var i = 0; i < layerList.length; i++) {
	        var item = layerList[i];
	        var k = item[0];
	        var id = item[1];
	        var opts = optsAll[k];
	
	        subplot.setOptions(id, 'setLayoutProperty', opts.layout);
	
	        if(opts.layout.visibility === 'visible') {
	            subplot.setOptions(id, 'setPaintProperty', opts.paint);
	        }
	    }
	};
	
	proto._addLayers = function(optsAll, below) {
	    var subplot = this.subplot;
	    var layerList = this.layerList;
	    var sourceId = this.sourceId;
	
	    for(var i = 0; i < layerList.length; i++) {
	        var item = layerList[i];
	        var k = item[0];
	        var opts = optsAll[k];
	
	        subplot.addLayer({
	            type: k,
	            id: item[1],
	            source: sourceId,
	            layout: opts.layout,
	            paint: opts.paint
	        }, below);
	    }
	};
	
	proto._removeLayers = function() {
	    var map = this.subplot.map;
	    var layerList = this.layerList;
	
	    for(var i = layerList.length - 1; i >= 0; i--) {
	        map.removeLayer(layerList[i][1]);
	    }
	};
	
	proto.dispose = function() {
	    var map = this.subplot.map;
	    this._removeLayers();
	    map.removeSource(this.sourceId);
	};
	
	module.exports = function createChoroplethMapbox(subplot, calcTrace) {
	    var trace = calcTrace[0].trace;
	    var choroplethMapbox = new ChoroplethMapbox(subplot, trace.uid);
	    var sourceId = choroplethMapbox.sourceId;
	    var optsAll = convert(calcTrace);
	    var below = choroplethMapbox.below = subplot.belowLookup['trace-' + trace.uid];
	
	    subplot.map.addSource(sourceId, {
	        type: 'geojson',
	        data: optsAll.geojson
	    });
	
	    choroplethMapbox._addLayers(optsAll, below);
	
	    // link ref for quick update during selections
	    calcTrace[0].trace._glTrace = choroplethMapbox;
	
	    return choroplethMapbox;
	};
	
	},{"../../plots/mapbox/constants":817,"./convert":932}],936:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var mesh3dAttrs = _dereq_('../mesh3d/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var attrs = {
	    x: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    z: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    u: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    v: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    w: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    // TODO add way to specify cone positions independently of the vector field
	    // provided, similar to MATLAB's coneplot Cx/Cy/Cz meshgrids,
	    // see https://www.mathworks.com/help/matlab/ref/coneplot.html
	    //
	    // Alternatively, if our goal is only to 'fill in gaps' in the vector data,
	    // we could try to extend the heatmap 'connectgaps' algorithm to 3D.
	    // From AJ: this particular algorithm which amounts to a Poisson equation,
	    // both for interpolation and extrapolation - is the right one to use for
	    // cones too.  It makes a field with zero divergence, which is a good
	    // baseline assumption for vector fields.
	    //
	    // cones: {
	    //     // potential attributes to add:
	    //     //
	    //     // - meshmode: 'cartesian-product', 'pts', 'grid'
	    //     //
	    //     // under `meshmode: 'grid'`
	    //     // - (x|y|z)grid.start
	    //     // - (x|y|z)grid.end
	    //     // - (x|y|z)grid.size
	    //
	    //     x: {
	    //         valType: 'data_array',
	    //         editType: 'calc',
	    //         
	    //     },
	    //     y: {
	    //         valType: 'data_array',
	    //         editType: 'calc',
	    //         
	    //     },
	    //     z: {
	    //         valType: 'data_array',
	    //         editType: 'calc',
	    //         
	    //     },
	    //
	    //     editType: 'calc',
	    //     
	    // },
	
	    sizemode: {
	        valType: 'enumerated',
	        values: ['scaled', 'absolute'],
	        
	        editType: 'calc',
	        dflt: 'scaled',
	        
	    },
	    sizeref: {
	        valType: 'number',
	        
	        editType: 'calc',
	        min: 0,
	        
	    },
	
	    anchor: {
	        valType: 'enumerated',
	        
	        editType: 'calc',
	        values: ['tip', 'tail', 'cm', 'center'],
	        dflt: 'cm',
	        
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	    hovertemplate: hovertemplateAttrs({editType: 'calc'}, {keys: ['norm']})
	};
	
	extendFlat(attrs, colorScaleAttrs('', {
	    colorAttr: 'u/v/w norm',
	    showScaleDflt: true,
	    editTypeOverride: 'calc'
	}));
	
	var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
	
	fromMesh3d.forEach(function(k) {
	    attrs[k] = mesh3dAttrs[k];
	});
	
	attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
	    editType: 'calc',
	    flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'text', 'name'],
	    dflt: 'x+y+z+norm+text+name'
	});
	
	attrs.transforms = undefined;
	
	module.exports = attrs;
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../mesh3d/attributes":1059}],937:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	
	module.exports = function calc(gd, trace) {
	    var u = trace.u;
	    var v = trace.v;
	    var w = trace.w;
	    var len = Math.min(
	        trace.x.length, trace.y.length, trace.z.length,
	        u.length, v.length, w.length
	    );
	    var normMax = -Infinity;
	    var normMin = Infinity;
	
	    for(var i = 0; i < len; i++) {
	        var uu = u[i];
	        var vv = v[i];
	        var ww = w[i];
	        var norm = Math.sqrt(uu * uu + vv * vv + ww * ww);
	
	        normMax = Math.max(normMax, norm);
	        normMin = Math.min(normMin, norm);
	    }
	
	    trace._len = len;
	    trace._normMax = normMax;
	
	    colorscaleCalc(gd, trace, {
	        vals: [normMin, normMax],
	        containerStr: '',
	        cLetter: 'c'
	    });
	};
	
	},{"../../components/colorscale/calc":599}],938:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var conePlot = _dereq_('gl-cone3d');
	var createConeMesh = _dereq_('gl-cone3d').createConeMesh;
	
	var simpleMap = _dereq_('../../lib').simpleMap;
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var zip3 = _dereq_('../../plots/gl3d/zip3');
	
	function Cone(scene, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.mesh = null;
	    this.data = null;
	}
	
	var proto = Cone.prototype;
	
	proto.handlePick = function(selection) {
	    if(selection.object === this.mesh) {
	        var selectIndex = selection.index = selection.data.index;
	        var xx = this.data.x[selectIndex];
	        var yy = this.data.y[selectIndex];
	        var zz = this.data.z[selectIndex];
	        var uu = this.data.u[selectIndex];
	        var vv = this.data.v[selectIndex];
	        var ww = this.data.w[selectIndex];
	
	        selection.traceCoordinate = [
	            xx, yy, zz,
	            uu, vv, ww,
	            Math.sqrt(uu * uu + vv * vv + ww * ww)
	        ];
	
	        var text = this.data.hovertext || this.data.text;
	        if(Array.isArray(text) && text[selectIndex] !== undefined) {
	            selection.textLabel = text[selectIndex];
	        } else if(text) {
	            selection.textLabel = text;
	        }
	
	        return true;
	    }
	};
	
	var axisName2scaleIndex = {xaxis: 0, yaxis: 1, zaxis: 2};
	var anchor2coneOffset = {tip: 1, tail: 0, cm: 0.25, center: 0.5};
	var anchor2coneSpan = {tip: 1, tail: 1, cm: 0.75, center: 0.5};
	
	function convert(scene, trace) {
	    var sceneLayout = scene.fullSceneLayout;
	    var dataScale = scene.dataScale;
	    var coneOpts = {};
	
	    function toDataCoords(arr, axisName) {
	        var ax = sceneLayout[axisName];
	        var scale = dataScale[axisName2scaleIndex[axisName]];
	        return simpleMap(arr, function(v) { return ax.d2l(v) * scale; });
	    }
	
	    coneOpts.vectors = zip3(
	        toDataCoords(trace.u, 'xaxis'),
	        toDataCoords(trace.v, 'yaxis'),
	        toDataCoords(trace.w, 'zaxis'),
	        trace._len
	    );
	
	    coneOpts.positions = zip3(
	        toDataCoords(trace.x, 'xaxis'),
	        toDataCoords(trace.y, 'yaxis'),
	        toDataCoords(trace.z, 'zaxis'),
	        trace._len
	    );
	
	    var cOpts = extractOpts(trace);
	    coneOpts.colormap = parseColorScale(trace);
	    coneOpts.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
	    coneOpts.coneOffset = anchor2coneOffset[trace.anchor];
	
	    if(trace.sizemode === 'scaled') {
	        // unitless sizeref
	        coneOpts.coneSize = trace.sizeref || 0.5;
	    } else {
	        // sizeref here has unit of velocity
	        coneOpts.coneSize = trace.sizeref && trace._normMax ?
	            trace.sizeref / trace._normMax :
	            0.5;
	    }
	
	    var meshData = conePlot(coneOpts);
	
	    // pass gl-mesh3d lighting attributes
	    var lp = trace.lightposition;
	    meshData.lightPosition = [lp.x, lp.y, lp.z];
	    meshData.ambient = trace.lighting.ambient;
	    meshData.diffuse = trace.lighting.diffuse;
	    meshData.specular = trace.lighting.specular;
	    meshData.roughness = trace.lighting.roughness;
	    meshData.fresnel = trace.lighting.fresnel;
	    meshData.opacity = trace.opacity;
	
	    // stash autorange pad value
	    trace._pad = anchor2coneSpan[trace.anchor] * meshData.vectorScale * meshData.coneScale * trace._normMax;
	
	    return meshData;
	}
	
	proto.update = function(data) {
	    this.data = data;
	
	    var meshData = convert(this.scene, data);
	    this.mesh.update(meshData);
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.mesh);
	    this.mesh.dispose();
	};
	
	function createConeTrace(scene, data) {
	    var gl = scene.glplot.gl;
	
	    var meshData = convert(scene, data);
	    var mesh = createConeMesh(gl, meshData);
	
	    var cone = new Cone(scene, data.uid);
	    cone.mesh = mesh;
	    cone.data = data;
	    mesh._trace = cone;
	
	    scene.glplot.add(mesh);
	
	    return cone;
	}
	
	module.exports = createConeTrace;
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gl_format_color":713,"../../plots/gl3d/zip3":815,"gl-cone3d":244}],939:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var u = coerce('u');
	    var v = coerce('v');
	    var w = coerce('w');
	
	    var x = coerce('x');
	    var y = coerce('y');
	    var z = coerce('z');
	
	    if(
	        !u || !u.length || !v || !v.length || !w || !w.length ||
	        !x || !x.length || !y || !y.length || !z || !z.length
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('sizeref');
	    coerce('sizemode');
	
	    coerce('anchor');
	
	    coerce('lighting.ambient');
	    coerce('lighting.diffuse');
	    coerce('lighting.specular');
	    coerce('lighting.roughness');
	    coerce('lighting.fresnel');
	    coerce('lightposition.x');
	    coerce('lightposition.y');
	    coerce('lightposition.z');
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    // disable 1D transforms (for now)
	    traceOut._length = null;
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":936}],940:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'cone',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./convert'),
	    eventData: function(out, pt) {
	        out.norm = pt.traceCoordinate[6];
	        return out;
	    },
	
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"./attributes":936,"./calc":937,"./convert":938,"./defaults":939}],941:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var heatmapAttrs = _dereq_('../heatmap/attributes');
	var scatterAttrs = _dereq_('../scatter/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var filterOps = _dereq_('../../constants/filter_ops');
	var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
	var INTERVAL_OPS = filterOps.INTERVAL_OPS;
	
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	
	var scatterLineAttrs = scatterAttrs.line;
	
	module.exports = extendFlat({
	    z: heatmapAttrs.z,
	    x: heatmapAttrs.x,
	    x0: heatmapAttrs.x0,
	    dx: heatmapAttrs.dx,
	    y: heatmapAttrs.y,
	    y0: heatmapAttrs.y0,
	    dy: heatmapAttrs.dy,
	    text: heatmapAttrs.text,
	    hovertext: heatmapAttrs.hovertext,
	    transpose: heatmapAttrs.transpose,
	    xtype: heatmapAttrs.xtype,
	    ytype: heatmapAttrs.ytype,
	    zhoverformat: heatmapAttrs.zhoverformat,
	    hovertemplate: heatmapAttrs.hovertemplate,
	    hoverongaps: heatmapAttrs.hoverongaps,
	    connectgaps: extendFlat({}, heatmapAttrs.connectgaps, {
	        
	    }),
	
	    fillcolor: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	
	    autocontour: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        impliedEdits: {
	            'contours.start': undefined,
	            'contours.end': undefined,
	            'contours.size': undefined
	        },
	        
	    },
	    ncontours: {
	        valType: 'integer',
	        dflt: 15,
	        min: 1,
	        
	        editType: 'calc',
	        
	    },
	
	    contours: {
	        type: {
	            valType: 'enumerated',
	            values: ['levels', 'constraint'],
	            dflt: 'levels',
	            
	            editType: 'calc',
	            
	        },
	        start: {
	            valType: 'number',
	            dflt: null,
	            
	            editType: 'plot',
	            impliedEdits: {'^autocontour': false},
	            
	        },
	        end: {
	            valType: 'number',
	            dflt: null,
	            
	            editType: 'plot',
	            impliedEdits: {'^autocontour': false},
	            
	        },
	        size: {
	            valType: 'number',
	            dflt: null,
	            min: 0,
	            
	            editType: 'plot',
	            impliedEdits: {'^autocontour': false},
	            
	        },
	        coloring: {
	            valType: 'enumerated',
	            values: ['fill', 'heatmap', 'lines', 'none'],
	            dflt: 'fill',
	            
	            editType: 'calc',
	            
	        },
	        showlines: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        showlabels: {
	            valType: 'boolean',
	            dflt: false,
	            
	            editType: 'plot',
	            
	        },
	        labelfont: fontAttrs({
	            editType: 'plot',
	            colorEditType: 'style',
	            
	        }),
	        labelformat: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'plot',
	            
	        },
	        operation: {
	            valType: 'enumerated',
	            values: [].concat(COMPARISON_OPS2).concat(INTERVAL_OPS),
	            
	            dflt: '=',
	            editType: 'calc',
	            
	        },
	        value: {
	            valType: 'any',
	            dflt: 0,
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc',
	        impliedEdits: {'autocontour': false}
	    },
	
	    line: {
	        color: extendFlat({}, scatterLineAttrs.color, {
	            editType: 'style+colorbars',
	            
	        }),
	        width: {
	            valType: 'number',
	            min: 0,
	            
	            editType: 'style+colorbars',
	            
	        },
	        dash: dash,
	        smoothing: extendFlat({}, scatterLineAttrs.smoothing, {
	            
	        }),
	        editType: 'plot'
	    }
	},
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        autoColorDflt: false,
	        editTypeOverride: 'calc'
	    })
	);
	
	},{"../../components/colorscale/attributes":598,"../../components/drawing/attributes":611,"../../constants/docs":687,"../../constants/filter_ops":688,"../../lib/extend":707,"../../plots/font_attributes":790,"../heatmap/attributes":998,"../scatter/attributes":1118}],942:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Colorscale = _dereq_('../../components/colorscale');
	
	var heatmapCalc = _dereq_('../heatmap/calc');
	var setContours = _dereq_('./set_contours');
	var endPlus = _dereq_('./end_plus');
	
	// most is the same as heatmap calc, then adjust it
	// though a few things inside heatmap calc still look for
	// contour maps, because the makeBoundArray calls are too entangled
	module.exports = function calc(gd, trace) {
	    var cd = heatmapCalc(gd, trace);
	
	    var zOut = cd[0].z;
	    setContours(trace, zOut);
	
	    var contours = trace.contours;
	    var cOpts = Colorscale.extractOpts(trace);
	    var cVals;
	
	    if(contours.coloring === 'heatmap' && cOpts.auto && trace.autocontour === false) {
	        var start = contours.start;
	        var end = endPlus(contours);
	        var cs = contours.size || 1;
	        var nc = Math.floor((end - start) / cs) + 1;
	
	        if(!isFinite(cs)) {
	            cs = 1;
	            nc = 1;
	        }
	
	        var min0 = start - cs / 2;
	        var max0 = min0 + nc * cs;
	        cVals = [min0, max0];
	    } else {
	        cVals = zOut;
	    }
	
	    Colorscale.calc(gd, trace, {vals: cVals, cLetter: 'z'});
	
	    return cd;
	};
	
	},{"../../components/colorscale":603,"../heatmap/calc":999,"./end_plus":952,"./set_contours":960}],943:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function(pathinfo, contours) {
	    var pi0 = pathinfo[0];
	    var z = pi0.z;
	    var i;
	
	    switch(contours.type) {
	        case 'levels':
	            // Why (just) use z[0][0] and z[0][1]?
	            //
	            // N.B. using boundaryMin instead of edgeVal2 here makes the
	            //      `contour_scatter` mock fail
	            var edgeVal2 = Math.min(z[0][0], z[0][1]);
	
	            for(i = 0; i < pathinfo.length; i++) {
	                var pi = pathinfo[i];
	                pi.prefixBoundary = !pi.edgepaths.length &&
	                    (edgeVal2 > pi.level || pi.starts.length && edgeVal2 === pi.level);
	            }
	            break;
	        case 'constraint':
	            // after convertToConstraints, pathinfo has length=0
	            pi0.prefixBoundary = false;
	
	            // joinAllPaths does enough already when edgepaths are present
	            if(pi0.edgepaths.length) return;
	
	            var na = pi0.x.length;
	            var nb = pi0.y.length;
	            var boundaryMax = -Infinity;
	            var boundaryMin = Infinity;
	
	            for(i = 0; i < nb; i++) {
	                boundaryMin = Math.min(boundaryMin, z[i][0]);
	                boundaryMin = Math.min(boundaryMin, z[i][na - 1]);
	                boundaryMax = Math.max(boundaryMax, z[i][0]);
	                boundaryMax = Math.max(boundaryMax, z[i][na - 1]);
	            }
	            for(i = 1; i < na - 1; i++) {
	                boundaryMin = Math.min(boundaryMin, z[0][i]);
	                boundaryMin = Math.min(boundaryMin, z[nb - 1][i]);
	                boundaryMax = Math.max(boundaryMax, z[0][i]);
	                boundaryMax = Math.max(boundaryMax, z[nb - 1][i]);
	            }
	
	            var contoursValue = contours.value;
	            var v1, v2;
	
	            switch(contours._operation) {
	                case '>':
	                    if(contoursValue > boundaryMax) {
	                        pi0.prefixBoundary = true;
	                    }
	                    break;
	                case '<':
	                    if(contoursValue < boundaryMin ||
	                        (pi0.starts.length && contoursValue === boundaryMin)) {
	                        pi0.prefixBoundary = true;
	                    }
	                    break;
	                case '[]':
	                    v1 = Math.min(contoursValue[0], contoursValue[1]);
	                    v2 = Math.max(contoursValue[0], contoursValue[1]);
	                    if(v2 < boundaryMin || v1 > boundaryMax ||
	                        (pi0.starts.length && v2 === boundaryMin)) {
	                        pi0.prefixBoundary = true;
	                    }
	                    break;
	                case '][':
	                    v1 = Math.min(contoursValue[0], contoursValue[1]);
	                    v2 = Math.max(contoursValue[0], contoursValue[1]);
	                    if(v1 < boundaryMin && v2 > boundaryMax) {
	                        pi0.prefixBoundary = true;
	                    }
	                    break;
	            }
	            break;
	    }
	};
	
	},{}],944:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var makeColorMap = _dereq_('./make_color_map');
	var endPlus = _dereq_('./end_plus');
	
	function calc(gd, trace, opts) {
	    var contours = trace.contours;
	    var line = trace.line;
	    var cs = contours.size || 1;
	    var coloring = contours.coloring;
	    var colorMap = makeColorMap(trace, {isColorbar: true});
	
	    if(coloring === 'heatmap') {
	        var cOpts = extractOpts(trace);
	        opts._fillgradient = trace.colorscale;
	        opts._zrange = [cOpts.min, cOpts.max];
	    } else if(coloring === 'fill') {
	        opts._fillcolor = colorMap;
	    }
	
	    opts._line = {
	        color: coloring === 'lines' ? colorMap : line.color,
	        width: contours.showlines !== false ? line.width : 0,
	        dash: line.dash
	    };
	
	    opts._levels = {
	        start: contours.start,
	        end: endPlus(contours),
	        size: cs
	    };
	}
	
	module.exports = {
	    min: 'zmin',
	    max: 'zmax',
	    calc: calc
	};
	
	},{"../../components/colorscale":603,"./end_plus":952,"./make_color_map":957}],945:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	module.exports = {
	    // some constants to help with marching squares algorithm
	    // where does the path start for each index?
	    BOTTOMSTART: [1, 9, 13, 104, 713],
	    TOPSTART: [4, 6, 7, 104, 713],
	    LEFTSTART: [8, 12, 14, 208, 1114],
	    RIGHTSTART: [2, 3, 11, 208, 1114],
	
	    // which way [dx,dy] do we leave a given index?
	    // saddles are already disambiguated
	    NEWDELTA: [
	        null, [-1, 0], [0, -1], [-1, 0],
	        [1, 0], null, [0, -1], [-1, 0],
	        [0, 1], [0, 1], null, [0, 1],
	        [1, 0], [1, 0], [0, -1]
	    ],
	
	    // for each saddle, the first index here is used
	    // for dx||dy<0, the second for dx||dy>0
	    CHOOSESADDLE: {
	        104: [4, 1],
	        208: [2, 8],
	        713: [7, 13],
	        1114: [11, 14]
	    },
	
	    // after one index has been used for a saddle, which do we
	    // substitute to be used up later?
	    SADDLEREMAINDER: {1: 4, 2: 8, 4: 1, 7: 13, 8: 2, 11: 14, 13: 7, 14: 11},
	
	    // length of a contour, as a multiple of the plot area diagonal, per label
	    LABELDISTANCE: 2,
	
	    // number of contour levels after which we start increasing the number of
	    // labels we draw. Many contours means they will generally be close
	    // together, so it will be harder to follow a long way to find a label
	    LABELINCREASE: 10,
	
	    // minimum length of a contour line, as a multiple of the label length,
	    // at which we draw *any* labels
	    LABELMIN: 3,
	
	    // max number of labels to draw on a single contour path, no matter how long
	    LABELMAX: 10,
	
	    // constants for the label position cost function
	    LABELOPTIMIZER: {
	        // weight given to edge proximity
	        EDGECOST: 1,
	        // weight given to the angle off horizontal
	        ANGLECOST: 1,
	        // weight given to distance from already-placed labels
	        NEIGHBORCOST: 5,
	        // cost multiplier for labels on the same level
	        SAMELEVELFACTOR: 10,
	        // minimum distance (as a multiple of the label length)
	        // for labels on the same level
	        SAMELEVELDISTANCE: 5,
	        // maximum cost before we won't even place the label
	        MAXCOST: 100,
	        // number of evenly spaced points to look at in the first
	        // iteration of the search
	        INITIALSEARCHPOINTS: 10,
	        // number of binary search iterations after the initial wide search
	        ITERATIONS: 5
	    }
	};
	
	},{}],946:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	var isNumeric = _dereq_('fast-isnumeric');
	
	var handleLabelDefaults = _dereq_('./label_defaults');
	
	var Color = _dereq_('../../components/color');
	var addOpacity = Color.addOpacity;
	var opacity = Color.opacity;
	
	var filterOps = _dereq_('../../constants/filter_ops');
	var CONSTRAINT_REDUCTION = filterOps.CONSTRAINT_REDUCTION;
	var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
	
	module.exports = function handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, opts) {
	    var contours = traceOut.contours;
	    var showLines, lineColor, fillColor;
	
	    var operation = coerce('contours.operation');
	    contours._operation = CONSTRAINT_REDUCTION[operation];
	
	    handleConstraintValueDefaults(coerce, contours);
	
	    if(operation === '=') {
	        showLines = contours.showlines = true;
	    } else {
	        showLines = coerce('contours.showlines');
	        fillColor = coerce('fillcolor', addOpacity(
	            (traceIn.line || {}).color || defaultColor, 0.5
	        ));
	    }
	
	    if(showLines) {
	        var lineDfltColor = fillColor && opacity(fillColor) ?
	            addOpacity(traceOut.fillcolor, 1) :
	            defaultColor;
	        lineColor = coerce('line.color', lineDfltColor);
	        coerce('line.width', 2);
	        coerce('line.dash');
	    }
	
	    coerce('line.smoothing');
	
	    handleLabelDefaults(coerce, layout, lineColor, opts);
	};
	
	function handleConstraintValueDefaults(coerce, contours) {
	    var zvalue;
	
	    if(COMPARISON_OPS2.indexOf(contours.operation) === -1) {
	        // Requires an array of two numbers:
	        coerce('contours.value', [0, 1]);
	
	        if(!Array.isArray(contours.value)) {
	            if(isNumeric(contours.value)) {
	                zvalue = parseFloat(contours.value);
	                contours.value = [zvalue, zvalue + 1];
	            }
	        } else if(contours.value.length > 2) {
	            contours.value = contours.value.slice(2);
	        } else if(contours.length === 0) {
	            contours.value = [0, 1];
	        } else if(contours.length < 2) {
	            zvalue = parseFloat(contours.value[0]);
	            contours.value = [zvalue, zvalue + 1];
	        } else {
	            contours.value = [
	                parseFloat(contours.value[0]),
	                parseFloat(contours.value[1])
	            ];
	        }
	    } else {
	        // Requires a single scalar:
	        coerce('contours.value', 0);
	
	        if(!isNumeric(contours.value)) {
	            if(Array.isArray(contours.value)) {
	                contours.value = parseFloat(contours.value[0]);
	            } else {
	                contours.value = 0;
	            }
	        }
	    }
	}
	
	},{"../../components/color":591,"../../constants/filter_ops":688,"./label_defaults":956,"fast-isnumeric":227}],947:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var filterOps = _dereq_('../../constants/filter_ops');
	var isNumeric = _dereq_('fast-isnumeric');
	
	// This syntax conforms to the existing filter transform syntax, but we don't care
	// about open vs. closed intervals for simply drawing contours constraints:
	module.exports = {
	    '[]': makeRangeSettings('[]'),
	    '][': makeRangeSettings(']['),
	    '>': makeInequalitySettings('>'),
	    '<': makeInequalitySettings('<'),
	    '=': makeInequalitySettings('=')
	};
	
	// This does not in any way shape or form support calendars. It's adapted from
	// transforms/filter.js.
	function coerceValue(operation, value) {
	    var hasArrayValue = Array.isArray(value);
	
	    var coercedValue;
	
	    function coerce(value) {
	        return isNumeric(value) ? (+value) : null;
	    }
	
	    if(filterOps.COMPARISON_OPS2.indexOf(operation) !== -1) {
	        coercedValue = hasArrayValue ? coerce(value[0]) : coerce(value);
	    } else if(filterOps.INTERVAL_OPS.indexOf(operation) !== -1) {
	        coercedValue = hasArrayValue ?
	            [coerce(value[0]), coerce(value[1])] :
	            [coerce(value), coerce(value)];
	    } else if(filterOps.SET_OPS.indexOf(operation) !== -1) {
	        coercedValue = hasArrayValue ? value.map(coerce) : [coerce(value)];
	    }
	
	    return coercedValue;
	}
	
	// Returns a parabola scaled so that the min/max is either +/- 1 and zero at the two values
	// provided. The data is mapped by this function when constructing intervals so that it's
	// very easy to construct contours as normal.
	function makeRangeSettings(operation) {
	    return function(value) {
	        value = coerceValue(operation, value);
	
	        // Ensure proper ordering:
	        var min = Math.min(value[0], value[1]);
	        var max = Math.max(value[0], value[1]);
	
	        return {
	            start: min,
	            end: max,
	            size: max - min
	        };
	    };
	}
	
	function makeInequalitySettings(operation) {
	    return function(value) {
	        value = coerceValue(operation, value);
	
	        return {
	            start: value,
	            end: Infinity,
	            size: Infinity
	        };
	    };
	}
	
	},{"../../constants/filter_ops":688,"fast-isnumeric":227}],948:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function handleContourDefaults(traceIn, traceOut, coerce, coerce2) {
	    var contourStart = coerce2('contours.start');
	    var contourEnd = coerce2('contours.end');
	    var missingEnd = (contourStart === false) || (contourEnd === false);
	
	    // normally we only need size if autocontour is off. But contour.calc
	    // pushes its calculated contour size back to the input trace, so for
	    // things like restyle that can call supplyDefaults without calc
	    // after the initial draw, we can just reuse the previous calculation
	    var contourSize = coerce('contours.size');
	    var autoContour;
	
	    if(missingEnd) autoContour = traceOut.autocontour = true;
	    else autoContour = coerce('autocontour', false);
	
	    if(autoContour || !contourSize) coerce('ncontours');
	};
	
	},{}],949:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// The contour extraction is great, except it totally fails for constraints because we
	// need weird range loops and flipped contours instead of the usual format. This function
	// does some weird manipulation of the extracted pathinfo data such that it magically
	// draws contours correctly *as* constraints.
	//
	// ** I do not know which "weird range loops" the comment above is referring to.
	module.exports = function(pathinfo, operation) {
	    var i, pi0, pi1;
	
	    var op0 = function(arr) { return arr.reverse(); };
	    var op1 = function(arr) { return arr; };
	
	    switch(operation) {
	        case '=':
	        case '<':
	            return pathinfo;
	        case '>':
	            if(pathinfo.length !== 1) {
	                Lib.warn('Contour data invalid for the specified inequality operation.');
	            }
	
	            // In this case there should be exactly one contour levels in pathinfo.
	            // We flip all of the data. This will draw the contour as closed.
	            pi0 = pathinfo[0];
	
	            for(i = 0; i < pi0.edgepaths.length; i++) {
	                pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
	            }
	            for(i = 0; i < pi0.paths.length; i++) {
	                pi0.paths[i] = op0(pi0.paths[i]);
	            }
	            for(i = 0; i < pi0.starts.length; i++) {
	                pi0.starts[i] = op0(pi0.starts[i]);
	            }
	
	            return pathinfo;
	        case '][':
	            var tmp = op0;
	            op0 = op1;
	            op1 = tmp;
	            // It's a nice rule, except this definitely *is* what's intended here.
	            /* eslint-disable: no-fallthrough */
	        case '[]':
	            /* eslint-enable: no-fallthrough */
	            if(pathinfo.length !== 2) {
	                Lib.warn('Contour data invalid for the specified inequality range operation.');
	            }
	
	            // In this case there should be exactly two contour levels in pathinfo.
	            // - We concatenate the info into one pathinfo.
	            // - We must also flip all of the data in the `[]` case.
	            // This will draw the contours as closed.
	            pi0 = copyPathinfo(pathinfo[0]);
	            pi1 = copyPathinfo(pathinfo[1]);
	
	            for(i = 0; i < pi0.edgepaths.length; i++) {
	                pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
	            }
	            for(i = 0; i < pi0.paths.length; i++) {
	                pi0.paths[i] = op0(pi0.paths[i]);
	            }
	            for(i = 0; i < pi0.starts.length; i++) {
	                pi0.starts[i] = op0(pi0.starts[i]);
	            }
	
	            while(pi1.edgepaths.length) {
	                pi0.edgepaths.push(op1(pi1.edgepaths.shift()));
	            }
	            while(pi1.paths.length) {
	                pi0.paths.push(op1(pi1.paths.shift()));
	            }
	            while(pi1.starts.length) {
	                pi0.starts.push(op1(pi1.starts.shift()));
	            }
	
	            return [pi0];
	    }
	};
	
	function copyPathinfo(pi) {
	    return Lib.extendFlat({}, pi, {
	        edgepaths: Lib.extendDeep([], pi.edgepaths),
	        paths: Lib.extendDeep([], pi.paths),
	        starts: Lib.extendDeep([], pi.starts)
	    });
	}
	
	},{"../../lib":716}],950:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleXYZDefaults = _dereq_('../heatmap/xyz_defaults');
	var handleConstraintDefaults = _dereq_('./constraint_defaults');
	var handleContoursDefaults = _dereq_('./contours_defaults');
	var handleStyleDefaults = _dereq_('./style_defaults');
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    function coerce2(attr) {
	        return Lib.coerce2(traceIn, traceOut, attributes, attr);
	    }
	
	    var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	    coerce('hoverongaps');
	
	    var isConstraint = (coerce('contours.type') === 'constraint');
	    coerce('connectgaps', Lib.isArray1D(traceOut.z));
	
	    if(isConstraint) {
	        handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor);
	    } else {
	        handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	        handleStyleDefaults(traceIn, traceOut, coerce, layout);
	    }
	};
	
	},{"../../lib":716,"../heatmap/xyz_defaults":1012,"./attributes":941,"./constraint_defaults":946,"./contours_defaults":948,"./style_defaults":962}],951:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var constraintMapping = _dereq_('./constraint_mapping');
	var endPlus = _dereq_('./end_plus');
	
	module.exports = function emptyPathinfo(contours, plotinfo, cd0) {
	    var contoursFinal = (contours.type === 'constraint') ?
	        constraintMapping[contours._operation](contours.value) :
	        contours;
	
	    var cs = contoursFinal.size;
	    var pathinfo = [];
	    var end = endPlus(contoursFinal);
	
	    var carpet = cd0.trace._carpetTrace;
	
	    var basePathinfo = carpet ? {
	        // store axes so we can convert to px
	        xaxis: carpet.aaxis,
	        yaxis: carpet.baxis,
	        // full data arrays to use for interpolation
	        x: cd0.a,
	        y: cd0.b
	    } : {
	        xaxis: plotinfo.xaxis,
	        yaxis: plotinfo.yaxis,
	        x: cd0.x,
	        y: cd0.y
	    };
	
	    for(var ci = contoursFinal.start; ci < end; ci += cs) {
	        pathinfo.push(Lib.extendFlat({
	            level: ci,
	            // all the cells with nontrivial marching index
	            crossings: {},
	            // starting points on the edges of the lattice for each contour
	            starts: [],
	            // all unclosed paths (may have less items than starts,
	            // if a path is closed by rounding)
	            edgepaths: [],
	            // all closed paths
	            paths: [],
	            z: cd0.z,
	            smoothing: cd0.trace.line.smoothing
	        }, basePathinfo));
	
	        if(pathinfo.length > 1000) {
	            Lib.warn('Too many contours, clipping at 1000', contours);
	            break;
	        }
	    }
	    return pathinfo;
	};
	
	},{"../../lib":716,"./constraint_mapping":947,"./end_plus":952}],952:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	/*
	 * tiny helper to move the end of the contours a little to prevent
	 * losing the last contour to rounding errors
	 */
	module.exports = function endPlus(contours) {
	    return contours.end + contours.size / 1e6;
	};
	
	},{}],953:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var constants = _dereq_('./constants');
	
	module.exports = function findAllPaths(pathinfo, xtol, ytol) {
	    var cnt,
	        startLoc,
	        i,
	        pi,
	        j;
	
	    // Default just passes these values through as they were before:
	    xtol = xtol || 0.01;
	    ytol = ytol || 0.01;
	
	    for(i = 0; i < pathinfo.length; i++) {
	        pi = pathinfo[i];
	
	        for(j = 0; j < pi.starts.length; j++) {
	            startLoc = pi.starts[j];
	            makePath(pi, startLoc, 'edge', xtol, ytol);
	        }
	
	        cnt = 0;
	        while(Object.keys(pi.crossings).length && cnt < 10000) {
	            cnt++;
	            startLoc = Object.keys(pi.crossings)[0].split(',').map(Number);
	            makePath(pi, startLoc, undefined, xtol, ytol);
	        }
	        if(cnt === 10000) Lib.log('Infinite loop in contour?');
	    }
	};
	
	function equalPts(pt1, pt2, xtol, ytol) {
	    return Math.abs(pt1[0] - pt2[0]) < xtol &&
	           Math.abs(pt1[1] - pt2[1]) < ytol;
	}
	
	// distance in index units - uses the 3rd and 4th items in points
	function ptDist(pt1, pt2) {
	    var dx = pt1[2] - pt2[2];
	    var dy = pt1[3] - pt2[3];
	    return Math.sqrt(dx * dx + dy * dy);
	}
	
	function makePath(pi, loc, edgeflag, xtol, ytol) {
	    var locStr = loc.join(',');
	    var mi = pi.crossings[locStr];
	    var marchStep = getStartStep(mi, edgeflag, loc);
	    // start by going backward a half step and finding the crossing point
	    var pts = [getInterpPx(pi, loc, [-marchStep[0], -marchStep[1]])];
	    var m = pi.z.length;
	    var n = pi.z[0].length;
	    var startLoc = loc.slice();
	    var startStep = marchStep.slice();
	    var cnt;
	
	    // now follow the path
	    for(cnt = 0; cnt < 10000; cnt++) { // just to avoid infinite loops
	        if(mi > 20) {
	            mi = constants.CHOOSESADDLE[mi][(marchStep[0] || marchStep[1]) < 0 ? 0 : 1];
	            pi.crossings[locStr] = constants.SADDLEREMAINDER[mi];
	        } else {
	            delete pi.crossings[locStr];
	        }
	
	        marchStep = constants.NEWDELTA[mi];
	        if(!marchStep) {
	            Lib.log('Found bad marching index:', mi, loc, pi.level);
	            break;
	        }
	
	        // find the crossing a half step forward, and then take the full step
	        pts.push(getInterpPx(pi, loc, marchStep));
	        loc[0] += marchStep[0];
	        loc[1] += marchStep[1];
	        locStr = loc.join(',');
	
	        // don't include the same point multiple times
	        if(equalPts(pts[pts.length - 1], pts[pts.length - 2], xtol, ytol)) pts.pop();
	
	        var atEdge = (marchStep[0] && (loc[0] < 0 || loc[0] > n - 2)) ||
	                (marchStep[1] && (loc[1] < 0 || loc[1] > m - 2));
	
	        var closedLoop = loc[0] === startLoc[0] && loc[1] === startLoc[1] &&
	                marchStep[0] === startStep[0] && marchStep[1] === startStep[1];
	
	        // have we completed a loop, or reached an edge?
	        if((closedLoop) || (edgeflag && atEdge)) break;
	
	        mi = pi.crossings[locStr];
	    }
	
	    if(cnt === 10000) {
	        Lib.log('Infinite loop in contour?');
	    }
	    var closedpath = equalPts(pts[0], pts[pts.length - 1], xtol, ytol);
	    var totaldist = 0;
	    var distThresholdFactor = 0.2 * pi.smoothing;
	    var alldists = [];
	    var cropstart = 0;
	    var distgroup, cnt2, cnt3, newpt, ptcnt, ptavg, thisdist,
	        i, j, edgepathi, edgepathj;
	
	    /*
	     * Check for points that are too close together (<1/5 the average dist
	     * *in grid index units* (important for log axes and nonuniform grids),
	     * less if less smoothed) and just take the center (or avg of center 2).
	     * This cuts down on funny behavior when a point is very close to a
	     * contour level.
	     */
	    for(cnt = 1; cnt < pts.length; cnt++) {
	        thisdist = ptDist(pts[cnt], pts[cnt - 1]);
	        totaldist += thisdist;
	        alldists.push(thisdist);
	    }
	
	    var distThreshold = totaldist / alldists.length * distThresholdFactor;
	
	    function getpt(i) { return pts[i % pts.length]; }
	
	    for(cnt = pts.length - 2; cnt >= cropstart; cnt--) {
	        distgroup = alldists[cnt];
	        if(distgroup < distThreshold) {
	            cnt3 = 0;
	            for(cnt2 = cnt - 1; cnt2 >= cropstart; cnt2--) {
	                if(distgroup + alldists[cnt2] < distThreshold) {
	                    distgroup += alldists[cnt2];
	                } else break;
	            }
	
	            // closed path with close points wrapping around the boundary?
	            if(closedpath && cnt === pts.length - 2) {
	                for(cnt3 = 0; cnt3 < cnt2; cnt3++) {
	                    if(distgroup + alldists[cnt3] < distThreshold) {
	                        distgroup += alldists[cnt3];
	                    } else break;
	                }
	            }
	            ptcnt = cnt - cnt2 + cnt3 + 1;
	            ptavg = Math.floor((cnt + cnt2 + cnt3 + 2) / 2);
	
	            // either endpoint included: keep the endpoint
	            if(!closedpath && cnt === pts.length - 2) newpt = pts[pts.length - 1];
	            else if(!closedpath && cnt2 === -1) newpt = pts[0];
	
	            // odd # of points - just take the central one
	            else if(ptcnt % 2) newpt = getpt(ptavg);
	
	            // even # of pts - average central two
	            else {
	                newpt = [(getpt(ptavg)[0] + getpt(ptavg + 1)[0]) / 2,
	                    (getpt(ptavg)[1] + getpt(ptavg + 1)[1]) / 2];
	            }
	
	            pts.splice(cnt2 + 1, cnt - cnt2 + 1, newpt);
	            cnt = cnt2 + 1;
	            if(cnt3) cropstart = cnt3;
	            if(closedpath) {
	                if(cnt === pts.length - 2) pts[cnt3] = pts[pts.length - 1];
	                else if(cnt === 0) pts[pts.length - 1] = pts[0];
	            }
	        }
	    }
	    pts.splice(0, cropstart);
	
	    // done with the index parts - remove them so path generation works right
	    // because it depends on only having [xpx, ypx]
	    for(cnt = 0; cnt < pts.length; cnt++) pts[cnt].length = 2;
	
	    // don't return single-point paths (ie all points were the same
	    // so they got deleted?)
	    if(pts.length < 2) return;
	    else if(closedpath) {
	        pts.pop();
	        pi.paths.push(pts);
	    } else {
	        if(!edgeflag) {
	            Lib.log('Unclosed interior contour?',
	                pi.level, startLoc.join(','), pts.join('L'));
	        }
	
	        // edge path - does it start where an existing edge path ends, or vice versa?
	        var merged = false;
	        for(i = 0; i < pi.edgepaths.length; i++) {
	            edgepathi = pi.edgepaths[i];
	            if(!merged && equalPts(edgepathi[0], pts[pts.length - 1], xtol, ytol)) {
	                pts.pop();
	                merged = true;
	
	                // now does it ALSO meet the end of another (or the same) path?
	                var doublemerged = false;
	                for(j = 0; j < pi.edgepaths.length; j++) {
	                    edgepathj = pi.edgepaths[j];
	                    if(equalPts(edgepathj[edgepathj.length - 1], pts[0], xtol, ytol)) {
	                        doublemerged = true;
	                        pts.shift();
	                        pi.edgepaths.splice(i, 1);
	                        if(j === i) {
	                            // the path is now closed
	                            pi.paths.push(pts.concat(edgepathj));
	                        } else {
	                            if(j > i) j--;
	                            pi.edgepaths[j] = edgepathj.concat(pts, edgepathi);
	                        }
	                        break;
	                    }
	                }
	                if(!doublemerged) {
	                    pi.edgepaths[i] = pts.concat(edgepathi);
	                }
	            }
	        }
	        for(i = 0; i < pi.edgepaths.length; i++) {
	            if(merged) break;
	            edgepathi = pi.edgepaths[i];
	            if(equalPts(edgepathi[edgepathi.length - 1], pts[0], xtol, ytol)) {
	                pts.shift();
	                pi.edgepaths[i] = edgepathi.concat(pts);
	                merged = true;
	            }
	        }
	
	        if(!merged) pi.edgepaths.push(pts);
	    }
	}
	
	// special function to get the marching step of the
	// first point in the path (leading to loc)
	function getStartStep(mi, edgeflag, loc) {
	    var dx = 0;
	    var dy = 0;
	    if(mi > 20 && edgeflag) {
	        // these saddles start at +/- x
	        if(mi === 208 || mi === 1114) {
	            // if we're starting at the left side, we must be going right
	            dx = loc[0] === 0 ? 1 : -1;
	        } else {
	            // if we're starting at the bottom, we must be going up
	            dy = loc[1] === 0 ? 1 : -1;
	        }
	    } else if(constants.BOTTOMSTART.indexOf(mi) !== -1) dy = 1;
	    else if(constants.LEFTSTART.indexOf(mi) !== -1) dx = 1;
	    else if(constants.TOPSTART.indexOf(mi) !== -1) dy = -1;
	    else dx = -1;
	    return [dx, dy];
	}
	
	/*
	 * Find the pixel coordinates of a particular crossing
	 *
	 * @param {object} pi: the pathinfo object at this level
	 * @param {array} loc: the grid index [x, y] of the crossing
	 * @param {array} step: the direction [dx, dy] we're moving on the grid
	 *
	 * @return {array} [xpx, ypx, xi, yi]: the first two are the pixel location,
	 *   the next two are the interpolated grid indices, which we use for
	 *   distance calculations to delete points that are too close together.
	 *   This is important when the grid is nonuniform (and most dramatically when
	 *   we're on log axes and include invalid (0 or negative) values.
	 *   It's crucial to delete these extra two before turning an array of these
	 *   points into a path, because those routines require length-2 points.
	 */
	function getInterpPx(pi, loc, step) {
	    var locx = loc[0] + Math.max(step[0], 0);
	    var locy = loc[1] + Math.max(step[1], 0);
	    var zxy = pi.z[locy][locx];
	    var xa = pi.xaxis;
	    var ya = pi.yaxis;
	
	    if(step[1]) {
	        var dx = (pi.level - zxy) / (pi.z[locy][locx + 1] - zxy);
	
	        return [xa.c2p((1 - dx) * pi.x[locx] + dx * pi.x[locx + 1], true),
	            ya.c2p(pi.y[locy], true),
	            locx + dx, locy];
	    } else {
	        var dy = (pi.level - zxy) / (pi.z[locy + 1][locx] - zxy);
	        return [xa.c2p(pi.x[locx], true),
	            ya.c2p((1 - dy) * pi.y[locy] + dy * pi.y[locy + 1], true),
	            locx, locy + dy];
	    }
	}
	
	},{"../../lib":716,"./constants":945}],954:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	
	var heatmapHoverPoints = _dereq_('../heatmap/hover');
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer) {
	    var hoverData = heatmapHoverPoints(pointData, xval, yval, hovermode, hoverLayer, true);
	
	    if(hoverData) {
	        hoverData.forEach(function(hoverPt) {
	            var trace = hoverPt.trace;
	            if(trace.contours.type === 'constraint') {
	                if(trace.fillcolor && Color.opacity(trace.fillcolor)) {
	                    hoverPt.color = Color.addOpacity(trace.fillcolor, 1);
	                } else if(trace.contours.showlines && Color.opacity(trace.line.color)) {
	                    hoverPt.color = Color.addOpacity(trace.line.color, 1);
	                }
	            }
	        });
	    }
	
	    return hoverData;
	};
	
	},{"../../components/color":591,"../heatmap/hover":1005}],955:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style'),
	    colorbar: _dereq_('./colorbar'),
	    hoverPoints: _dereq_('./hover'),
	
	    moduleType: 'trace',
	    name: 'contour',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', '2dMap', 'contour', 'showLegend'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./attributes":941,"./calc":942,"./colorbar":944,"./defaults":950,"./hover":954,"./plot":959,"./style":961}],956:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	module.exports = function handleLabelDefaults(coerce, layout, lineColor, opts) {
	    if(!opts) opts = {};
	    var showLabels = coerce('contours.showlabels');
	    if(showLabels) {
	        var globalFont = layout.font;
	        Lib.coerceFont(coerce, 'contours.labelfont', {
	            family: globalFont.family,
	            size: globalFont.size,
	            color: lineColor
	        });
	        coerce('contours.labelformat');
	    }
	
	    if(opts.hasHover !== false) coerce('zhoverformat');
	};
	
	},{"../../lib":716}],957:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Colorscale = _dereq_('../../components/colorscale');
	var endPlus = _dereq_('./end_plus');
	
	module.exports = function makeColorMap(trace) {
	    var contours = trace.contours;
	    var start = contours.start;
	    var end = endPlus(contours);
	    var cs = contours.size || 1;
	    var nc = Math.floor((end - start) / cs) + 1;
	    var extra = contours.coloring === 'lines' ? 0 : 1;
	    var cOpts = Colorscale.extractOpts(trace);
	
	    if(!isFinite(cs)) {
	        cs = 1;
	        nc = 1;
	    }
	
	    var scl = cOpts.reversescale ?
	        Colorscale.flipScale(cOpts.colorscale) :
	        cOpts.colorscale;
	
	    var len = scl.length;
	    var domain = new Array(len);
	    var range = new Array(len);
	
	    var si, i;
	
	    if(contours.coloring === 'heatmap') {
	        var zmin0 = cOpts.min;
	        var zmax0 = cOpts.max;
	
	        for(i = 0; i < len; i++) {
	            si = scl[i];
	            domain[i] = si[0] * (zmax0 - zmin0) + zmin0;
	            range[i] = si[1];
	        }
	
	        // do the contours extend beyond the colorscale?
	        // if so, extend the colorscale with constants
	        var zRange = d3.extent([
	            zmin0,
	            zmax0,
	            contours.start,
	            contours.start + cs * (nc - 1)
	        ]);
	        var zmin = zRange[zmin0 < zmax0 ? 0 : 1];
	        var zmax = zRange[zmin0 < zmax0 ? 1 : 0];
	
	        if(zmin !== zmin0) {
	            domain.splice(0, 0, zmin);
	            range.splice(0, 0, range[0]);
	        }
	
	        if(zmax !== zmax0) {
	            domain.push(zmax);
	            range.push(range[range.length - 1]);
	        }
	    } else {
	        for(i = 0; i < len; i++) {
	            si = scl[i];
	            domain[i] = (si[0] * (nc + extra - 1) - (extra / 2)) * cs + start;
	            range[i] = si[1];
	        }
	    }
	
	    return Colorscale.makeColorScaleFunc(
	        {domain: domain, range: range},
	        {noNumericCheck: true}
	    );
	};
	
	},{"../../components/colorscale":603,"./end_plus":952,"d3":164}],958:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var constants = _dereq_('./constants');
	
	// Calculate all the marching indices, for ALL levels at once.
	// since we want to be exhaustive we'll check for contour crossings
	// at every intersection, rather than just following a path
	// TODO: shorten the inner loop to only the relevant levels
	module.exports = function makeCrossings(pathinfo) {
	    var z = pathinfo[0].z;
	    var m = z.length;
	    var n = z[0].length; // we already made sure z isn't ragged in interp2d
	    var twoWide = m === 2 || n === 2;
	    var xi;
	    var yi;
	    var startIndices;
	    var ystartIndices;
	    var label;
	    var corners;
	    var mi;
	    var pi;
	    var i;
	
	    for(yi = 0; yi < m - 1; yi++) {
	        ystartIndices = [];
	        if(yi === 0) ystartIndices = ystartIndices.concat(constants.BOTTOMSTART);
	        if(yi === m - 2) ystartIndices = ystartIndices.concat(constants.TOPSTART);
	
	        for(xi = 0; xi < n - 1; xi++) {
	            startIndices = ystartIndices.slice();
	            if(xi === 0) startIndices = startIndices.concat(constants.LEFTSTART);
	            if(xi === n - 2) startIndices = startIndices.concat(constants.RIGHTSTART);
	
	            label = xi + ',' + yi;
	            corners = [[z[yi][xi], z[yi][xi + 1]],
	                       [z[yi + 1][xi], z[yi + 1][xi + 1]]];
	            for(i = 0; i < pathinfo.length; i++) {
	                pi = pathinfo[i];
	                mi = getMarchingIndex(pi.level, corners);
	                if(!mi) continue;
	
	                pi.crossings[label] = mi;
	                if(startIndices.indexOf(mi) !== -1) {
	                    pi.starts.push([xi, yi]);
	                    if(twoWide && startIndices.indexOf(mi,
	                            startIndices.indexOf(mi) + 1) !== -1) {
	                        // the same square has starts from opposite sides
	                        // it's not possible to have starts on opposite edges
	                        // of a corner, only a start and an end...
	                        // but if the array is only two points wide (either way)
	                        // you can have starts on opposite sides.
	                        pi.starts.push([xi, yi]);
	                    }
	                }
	            }
	        }
	    }
	};
	
	// modified marching squares algorithm,
	// so we disambiguate the saddle points from the start
	// and we ignore the cases with no crossings
	// the index I'm using is based on:
	// http://en.wikipedia.org/wiki/Marching_squares
	// except that the saddles bifurcate and I represent them
	// as the decimal combination of the two appropriate
	// non-saddle indices
	function getMarchingIndex(val, corners) {
	    var mi = (corners[0][0] > val ? 0 : 1) +
	             (corners[0][1] > val ? 0 : 2) +
	             (corners[1][1] > val ? 0 : 4) +
	             (corners[1][0] > val ? 0 : 8);
	    if(mi === 5 || mi === 10) {
	        var avg = (corners[0][0] + corners[0][1] +
	                   corners[1][0] + corners[1][1]) / 4;
	        // two peaks with a big valley
	        if(val > avg) return (mi === 5) ? 713 : 1114;
	        // two valleys with a big ridge
	        return (mi === 5) ? 104 : 208;
	    }
	    return (mi === 15) ? 0 : mi;
	}
	
	},{"./constants":945}],959:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var Colorscale = _dereq_('../../components/colorscale');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var setConvert = _dereq_('../../plots/cartesian/set_convert');
	
	var heatmapPlot = _dereq_('../heatmap/plot');
	var makeCrossings = _dereq_('./make_crossings');
	var findAllPaths = _dereq_('./find_all_paths');
	var emptyPathinfo = _dereq_('./empty_pathinfo');
	var convertToConstraints = _dereq_('./convert_to_constraints');
	var closeBoundaries = _dereq_('./close_boundaries');
	var constants = _dereq_('./constants');
	var costConstants = constants.LABELOPTIMIZER;
	
	exports.plot = function plot(gd, plotinfo, cdcontours, contourLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(contourLayer, cdcontours, 'contour').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	        var x = cd0.x;
	        var y = cd0.y;
	        var contours = trace.contours;
	        var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
	
	        // use a heatmap to fill - draw it behind the lines
	        var heatmapColoringLayer = Lib.ensureSingle(plotGroup, 'g', 'heatmapcoloring');
	        var cdheatmaps = [];
	        if(contours.coloring === 'heatmap') {
	            cdheatmaps = [cd];
	        }
	        heatmapPlot(gd, plotinfo, cdheatmaps, heatmapColoringLayer);
	
	        makeCrossings(pathinfo);
	        findAllPaths(pathinfo);
	
	        var leftedge = xa.c2p(x[0], true);
	        var rightedge = xa.c2p(x[x.length - 1], true);
	        var bottomedge = ya.c2p(y[0], true);
	        var topedge = ya.c2p(y[y.length - 1], true);
	        var perimeter = [
	            [leftedge, topedge],
	            [rightedge, topedge],
	            [rightedge, bottomedge],
	            [leftedge, bottomedge]
	        ];
	
	        var fillPathinfo = pathinfo;
	        if(contours.type === 'constraint') {
	            // N.B. this also mutates pathinfo
	            fillPathinfo = convertToConstraints(pathinfo, contours._operation);
	        }
	
	        // draw everything
	        makeBackground(plotGroup, perimeter, contours);
	        makeFills(plotGroup, fillPathinfo, perimeter, contours);
	        makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours);
	        clipGaps(plotGroup, plotinfo, gd, cd0, perimeter);
	    });
	};
	
	function makeBackground(plotgroup, perimeter, contours) {
	    var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
	
	    var bgfill = bggroup.selectAll('path')
	        .data(contours.coloring === 'fill' ? [0] : []);
	    bgfill.enter().append('path');
	    bgfill.exit().remove();
	    bgfill
	        .attr('d', 'M' + perimeter.join('L') + 'Z')
	        .style('stroke', 'none');
	}
	
	function makeFills(plotgroup, pathinfo, perimeter, contours) {
	    var hasFills = contours.coloring === 'fill' || (contours.type === 'constraint' && contours._operation !== '=');
	    var boundaryPath = 'M' + perimeter.join('L') + 'Z';
	
	    // fills prefixBoundary in pathinfo items
	    if(hasFills) {
	        closeBoundaries(pathinfo, contours);
	    }
	
	    var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
	
	    var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
	    fillitems.enter().append('path');
	    fillitems.exit().remove();
	    fillitems.each(function(pi) {
	        // join all paths for this level together into a single path
	        // first follow clockwise around the perimeter to close any open paths
	        // if the whole perimeter is above this level, start with a path
	        // enclosing the whole thing. With all that, the parity should mean
	        // that we always fill everything above the contour, nothing below
	        var fullpath = (pi.prefixBoundary ? boundaryPath : '') +
	            joinAllPaths(pi, perimeter);
	
	        if(!fullpath) {
	            d3.select(this).remove();
	        } else {
	            d3.select(this)
	                .attr('d', fullpath)
	                .style('stroke', 'none');
	        }
	    });
	}
	
	function joinAllPaths(pi, perimeter) {
	    var fullpath = '';
	    var i = 0;
	    var startsleft = pi.edgepaths.map(function(v, i) { return i; });
	    var newloop = true;
	    var endpt;
	    var newendpt;
	    var cnt;
	    var nexti;
	    var possiblei;
	    var addpath;
	
	    function istop(pt) { return Math.abs(pt[1] - perimeter[0][1]) < 0.01; }
	    function isbottom(pt) { return Math.abs(pt[1] - perimeter[2][1]) < 0.01; }
	    function isleft(pt) { return Math.abs(pt[0] - perimeter[0][0]) < 0.01; }
	    function isright(pt) { return Math.abs(pt[0] - perimeter[2][0]) < 0.01; }
	
	    while(startsleft.length) {
	        addpath = Drawing.smoothopen(pi.edgepaths[i], pi.smoothing);
	        fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
	        startsleft.splice(startsleft.indexOf(i), 1);
	        endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
	        nexti = -1;
	
	        // now loop through sides, moving our endpoint until we find a new start
	        for(cnt = 0; cnt < 4; cnt++) { // just to prevent infinite loops
	            if(!endpt) {
	                Lib.log('Missing end?', i, pi);
	                break;
	            }
	
	            if(istop(endpt) && !isright(endpt)) newendpt = perimeter[1]; // right top
	            else if(isleft(endpt)) newendpt = perimeter[0]; // left top
	            else if(isbottom(endpt)) newendpt = perimeter[3]; // right bottom
	            else if(isright(endpt)) newendpt = perimeter[2]; // left bottom
	
	            for(possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
	                var ptNew = pi.edgepaths[possiblei][0];
	                // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
	                if(Math.abs(endpt[0] - newendpt[0]) < 0.01) {
	                    if(Math.abs(endpt[0] - ptNew[0]) < 0.01 &&
	                            (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                    }
	                } else if(Math.abs(endpt[1] - newendpt[1]) < 0.01) {
	                    if(Math.abs(endpt[1] - ptNew[1]) < 0.01 &&
	                            (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                    }
	                } else {
	                    Lib.log('endpt to newendpt is not vert. or horz.',
	                        endpt, newendpt, ptNew);
	                }
	            }
	
	            endpt = newendpt;
	
	            if(nexti >= 0) break;
	            fullpath += 'L' + newendpt;
	        }
	
	        if(nexti === pi.edgepaths.length) {
	            Lib.log('unclosed perimeter path');
	            break;
	        }
	
	        i = nexti;
	
	        // if we closed back on a loop we already included,
	        // close it and start a new loop
	        newloop = (startsleft.indexOf(i) === -1);
	        if(newloop) {
	            i = startsleft[0];
	            fullpath += 'Z';
	        }
	    }
	
	    // finally add the interior paths
	    for(i = 0; i < pi.paths.length; i++) {
	        fullpath += Drawing.smoothclosed(pi.paths[i], pi.smoothing);
	    }
	
	    return fullpath;
	}
	
	function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours) {
	    var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
	    var showLines = contours.showlines !== false;
	    var showLabels = contours.showlabels;
	    var clipLinesForLabels = showLines && showLabels;
	
	    // Even if we're not going to show lines, we need to create them
	    // if we're showing labels, because the fill paths include the perimeter
	    // so can't be used to position the labels correctly.
	    // In this case we'll remove the lines after making the labels.
	    var linegroup = exports.createLines(lineContainer, showLines || showLabels, pathinfo);
	
	    var lineClip = exports.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
	
	    var labelGroup = plotgroup.selectAll('g.contourlabels')
	        .data(showLabels ? [0] : []);
	
	    labelGroup.exit().remove();
	
	    labelGroup.enter().append('g')
	        .classed('contourlabels', true);
	
	    if(showLabels) {
	        var labelClipPathData = [];
	        var labelData = [];
	
	        // invalidate the getTextLocation cache in case paths changed
	        Lib.clearLocationCache();
	
	        var contourFormat = exports.labelFormatter(gd, cd0);
	
	        var dummyText = Drawing.tester.append('text')
	            .attr('data-notex', 1)
	            .call(Drawing.font, contours.labelfont);
	
	        var xa = pathinfo[0].xaxis;
	        var ya = pathinfo[0].yaxis;
	        var xLen = xa._length;
	        var yLen = ya._length;
	        var xRng = xa.range;
	        var yRng = ya.range;
	        var xMin = Lib.aggNums(Math.min, null, cd0.x);
	        var xMax = Lib.aggNums(Math.max, null, cd0.x);
	        var yMin = Lib.aggNums(Math.min, null, cd0.y);
	        var yMax = Lib.aggNums(Math.max, null, cd0.y);
	        var x0 = Math.max(xa.c2p(xMin, true), 0);
	        var x1 = Math.min(xa.c2p(xMax, true), xLen);
	        var y0 = Math.max(ya.c2p(yMax, true), 0);
	        var y1 = Math.min(ya.c2p(yMin, true), yLen);
	
	        // visible bounds of the contour trace (and the midpoints, to
	        // help with cost calculations)
	        var bounds = {};
	
	        if(xRng[0] < xRng[1]) {
	            bounds.left = x0;
	            bounds.right = x1;
	        } else {
	            bounds.left = x1;
	            bounds.right = x0;
	        }
	
	        if(yRng[0] < yRng[1]) {
	            bounds.top = y0;
	            bounds.bottom = y1;
	        } else {
	            bounds.top = y1;
	            bounds.bottom = y0;
	        }
	
	        bounds.middle = (bounds.top + bounds.bottom) / 2;
	        bounds.center = (bounds.left + bounds.right) / 2;
	
	        labelClipPathData.push([
	            [bounds.left, bounds.top],
	            [bounds.right, bounds.top],
	            [bounds.right, bounds.bottom],
	            [bounds.left, bounds.bottom]
	        ]);
	
	        var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
	
	        // the path length to use to scale the number of labels to draw:
	        var normLength = constants.LABELDISTANCE * plotDiagonal /
	            Math.max(1, pathinfo.length / constants.LABELINCREASE);
	
	        linegroup.each(function(d) {
	            var textOpts = exports.calcTextOpts(d.level, contourFormat, dummyText, gd);
	
	            d3.select(this).selectAll('path').each(function() {
	                var path = this;
	                var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
	                if(!pathBounds) return;
	
	                if(pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
	
	                var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength),
	                    constants.LABELMAX);
	
	                for(var i = 0; i < maxLabels; i++) {
	                    var loc = exports.findBestTextLocation(path, pathBounds, textOpts,
	                        labelData, bounds);
	
	                    if(!loc) break;
	
	                    exports.addLabelData(loc, textOpts, labelData, labelClipPathData);
	                }
	            });
	        });
	
	        dummyText.remove();
	
	        exports.drawLabels(labelGroup, labelData, gd, lineClip,
	            clipLinesForLabels ? labelClipPathData : null);
	    }
	
	    if(showLabels && !showLines) linegroup.remove();
	}
	
	exports.createLines = function(lineContainer, makeLines, pathinfo) {
	    var smoothing = pathinfo[0].smoothing;
	
	    var linegroup = lineContainer.selectAll('g.contourlevel')
	        .data(makeLines ? pathinfo : []);
	
	    linegroup.exit().remove();
	    linegroup.enter().append('g')
	        .classed('contourlevel', true);
	
	    if(makeLines) {
	        // pedgepaths / ppaths are used by contourcarpet, for the paths transformed from a/b to x/y
	        // edgepaths / paths are used by contour since it's in x/y from the start
	        var opencontourlines = linegroup.selectAll('path.openline')
	            .data(function(d) { return d.pedgepaths || d.edgepaths; });
	
	        opencontourlines.exit().remove();
	        opencontourlines.enter().append('path')
	            .classed('openline', true);
	
	        opencontourlines
	            .attr('d', function(d) {
	                return Drawing.smoothopen(d, smoothing);
	            })
	            .style('stroke-miterlimit', 1)
	            .style('vector-effect', 'non-scaling-stroke');
	
	        var closedcontourlines = linegroup.selectAll('path.closedline')
	            .data(function(d) { return d.ppaths || d.paths; });
	
	        closedcontourlines.exit().remove();
	        closedcontourlines.enter().append('path')
	            .classed('closedline', true);
	
	        closedcontourlines
	            .attr('d', function(d) {
	                return Drawing.smoothclosed(d, smoothing);
	            })
	            .style('stroke-miterlimit', 1)
	            .style('vector-effect', 'non-scaling-stroke');
	    }
	
	    return linegroup;
	};
	
	exports.createLineClip = function(lineContainer, clipLinesForLabels, gd, uid) {
	    var clips = gd._fullLayout._clips;
	    var clipId = clipLinesForLabels ? ('clipline' + uid) : null;
	
	    var lineClip = clips.selectAll('#' + clipId)
	        .data(clipLinesForLabels ? [0] : []);
	    lineClip.exit().remove();
	
	    lineClip.enter().append('clipPath')
	        .classed('contourlineclip', true)
	        .attr('id', clipId);
	
	    Drawing.setClipUrl(lineContainer, clipId, gd);
	
	    return lineClip;
	};
	
	exports.labelFormatter = function(gd, cd0) {
	    var fullLayout = gd._fullLayout;
	    var trace = cd0.trace;
	    var contours = trace.contours;
	
	    if(contours.labelformat) {
	        return fullLayout._d3locale.numberFormat(contours.labelformat);
	    } else {
	        var formatAxis;
	        var cOpts = Colorscale.extractOpts(trace);
	        if(cOpts && cOpts.colorbar && cOpts.colorbar._axis) {
	            formatAxis = cOpts.colorbar._axis;
	        } else {
	            formatAxis = {
	                type: 'linear',
	                _id: 'ycontour',
	                showexponent: 'all',
	                exponentformat: 'B'
	            };
	
	            if(contours.type === 'constraint') {
	                var value = contours.value;
	                if(Array.isArray(value)) {
	                    formatAxis.range = [value[0], value[value.length - 1]];
	                } else formatAxis.range = [value, value];
	            } else {
	                formatAxis.range = [contours.start, contours.end];
	                formatAxis.nticks = (contours.end - contours.start) / contours.size;
	            }
	
	            if(formatAxis.range[0] === formatAxis.range[1]) {
	                formatAxis.range[1] += formatAxis.range[0] || 1;
	            }
	            if(!formatAxis.nticks) formatAxis.nticks = 1000;
	
	            setConvert(formatAxis, fullLayout);
	            Axes.prepTicks(formatAxis);
	            formatAxis._tmin = null;
	            formatAxis._tmax = null;
	        }
	        return function(v) {
	            return Axes.tickText(formatAxis, v).text;
	        };
	    }
	};
	
	exports.calcTextOpts = function(level, contourFormat, dummyText, gd) {
	    var text = contourFormat(level);
	    dummyText.text(text)
	        .call(svgTextUtils.convertToTspans, gd);
	    var bBox = Drawing.bBox(dummyText.node(), true);
	
	    return {
	        text: text,
	        width: bBox.width,
	        height: bBox.height,
	        level: level,
	        dy: (bBox.top + bBox.bottom) / 2
	    };
	};
	
	exports.findBestTextLocation = function(path, pathBounds, textOpts, labelData, plotBounds) {
	    var textWidth = textOpts.width;
	
	    var p0, dp, pMax, pMin, loc;
	    if(pathBounds.isClosed) {
	        dp = pathBounds.len / costConstants.INITIALSEARCHPOINTS;
	        p0 = pathBounds.min + dp / 2;
	        pMax = pathBounds.max;
	    } else {
	        dp = (pathBounds.len - textWidth) / (costConstants.INITIALSEARCHPOINTS + 1);
	        p0 = pathBounds.min + dp + textWidth / 2;
	        pMax = pathBounds.max - (dp + textWidth) / 2;
	    }
	
	    var cost = Infinity;
	    for(var j = 0; j < costConstants.ITERATIONS; j++) {
	        for(var p = p0; p < pMax; p += dp) {
	            var newLocation = Lib.getTextLocation(path, pathBounds.total, p, textWidth);
	            var newCost = locationCost(newLocation, textOpts, labelData, plotBounds);
	            if(newCost < cost) {
	                cost = newCost;
	                loc = newLocation;
	                pMin = p;
	            }
	        }
	        if(cost > costConstants.MAXCOST * 2) break;
	
	        // subsequent iterations just look half steps away from the
	        // best we found in the previous iteration
	        if(j) dp /= 2;
	        p0 = pMin - dp / 2;
	        pMax = p0 + dp * 1.5;
	    }
	    if(cost <= costConstants.MAXCOST) return loc;
	};
	
	/*
	 * locationCost: a cost function for label locations
	 * composed of three kinds of penalty:
	 * - for open paths, being close to the end of the path
	 * - the angle away from horizontal
	 * - being too close to already placed neighbors
	 */
	function locationCost(loc, textOpts, labelData, bounds) {
	    var halfWidth = textOpts.width / 2;
	    var halfHeight = textOpts.height / 2;
	    var x = loc.x;
	    var y = loc.y;
	    var theta = loc.theta;
	    var dx = Math.cos(theta) * halfWidth;
	    var dy = Math.sin(theta) * halfWidth;
	
	    // cost for being near an edge
	    var normX = ((x > bounds.center) ? (bounds.right - x) : (x - bounds.left)) /
	        (dx + Math.abs(Math.sin(theta) * halfHeight));
	    var normY = ((y > bounds.middle) ? (bounds.bottom - y) : (y - bounds.top)) /
	        (Math.abs(dy) + Math.cos(theta) * halfHeight);
	    if(normX < 1 || normY < 1) return Infinity;
	    var cost = costConstants.EDGECOST * (1 / (normX - 1) + 1 / (normY - 1));
	
	    // cost for not being horizontal
	    cost += costConstants.ANGLECOST * theta * theta;
	
	    // cost for being close to other labels
	    var x1 = x - dx;
	    var y1 = y - dy;
	    var x2 = x + dx;
	    var y2 = y + dy;
	    for(var i = 0; i < labelData.length; i++) {
	        var labeli = labelData[i];
	        var dxd = Math.cos(labeli.theta) * labeli.width / 2;
	        var dyd = Math.sin(labeli.theta) * labeli.width / 2;
	        var dist = Lib.segmentDistance(
	            x1, y1,
	            x2, y2,
	            labeli.x - dxd, labeli.y - dyd,
	            labeli.x + dxd, labeli.y + dyd
	        ) * 2 / (textOpts.height + labeli.height);
	
	        var sameLevel = labeli.level === textOpts.level;
	        var distOffset = sameLevel ? costConstants.SAMELEVELDISTANCE : 1;
	
	        if(dist <= distOffset) return Infinity;
	
	        var distFactor = costConstants.NEIGHBORCOST *
	            (sameLevel ? costConstants.SAMELEVELFACTOR : 1);
	
	        cost += distFactor / (dist - distOffset);
	    }
	
	    return cost;
	}
	
	exports.addLabelData = function(loc, textOpts, labelData, labelClipPathData) {
	    var halfWidth = textOpts.width / 2;
	    var halfHeight = textOpts.height / 2;
	
	    var x = loc.x;
	    var y = loc.y;
	    var theta = loc.theta;
	
	    var sin = Math.sin(theta);
	    var cos = Math.cos(theta);
	    var dxw = halfWidth * cos;
	    var dxh = halfHeight * sin;
	    var dyw = halfWidth * sin;
	    var dyh = -halfHeight * cos;
	    var bBoxPts = [
	        [x - dxw - dxh, y - dyw - dyh],
	        [x + dxw - dxh, y + dyw - dyh],
	        [x + dxw + dxh, y + dyw + dyh],
	        [x - dxw + dxh, y - dyw + dyh],
	    ];
	
	    labelData.push({
	        text: textOpts.text,
	        x: x,
	        y: y,
	        dy: textOpts.dy,
	        theta: theta,
	        level: textOpts.level,
	        width: textOpts.width,
	        height: textOpts.height
	    });
	
	    labelClipPathData.push(bBoxPts);
	};
	
	exports.drawLabels = function(labelGroup, labelData, gd, lineClip, labelClipPathData) {
	    var labels = labelGroup.selectAll('text')
	        .data(labelData, function(d) {
	            return d.text + ',' + d.x + ',' + d.y + ',' + d.theta;
	        });
	
	    labels.exit().remove();
	
	    labels.enter().append('text')
	        .attr({
	            'data-notex': 1,
	            'text-anchor': 'middle'
	        })
	        .each(function(d) {
	            var x = d.x + Math.sin(d.theta) * d.dy;
	            var y = d.y - Math.cos(d.theta) * d.dy;
	            d3.select(this)
	                .text(d.text)
	                .attr({
	                    x: x,
	                    y: y,
	                    transform: 'rotate(' + (180 * d.theta / Math.PI) + ' ' + x + ' ' + y + ')'
	                })
	                .call(svgTextUtils.convertToTspans, gd);
	        });
	
	    if(labelClipPathData) {
	        var clipPath = '';
	        for(var i = 0; i < labelClipPathData.length; i++) {
	            clipPath += 'M' + labelClipPathData[i].join('L') + 'Z';
	        }
	
	        var lineClipPath = Lib.ensureSingle(lineClip, 'path', '');
	        lineClipPath.attr('d', clipPath);
	    }
	};
	
	function clipGaps(plotGroup, plotinfo, gd, cd0, perimeter) {
	    var trace = cd0.trace;
	    var clips = gd._fullLayout._clips;
	    var clipId = 'clip' + trace.uid;
	
	    var clipPath = clips.selectAll('#' + clipId)
	        .data(trace.connectgaps ? [] : [0]);
	    clipPath.enter().append('clipPath')
	        .classed('contourclip', true)
	        .attr('id', clipId);
	    clipPath.exit().remove();
	
	    if(trace.connectgaps === false) {
	        var clipPathInfo = {
	            // fraction of the way from missing to present point
	            // to draw the boundary.
	            // if you make this 1 (or 1-epsilon) then a point in
	            // a sea of missing data will disappear entirely.
	            level: 0.9,
	            crossings: {},
	            starts: [],
	            edgepaths: [],
	            paths: [],
	            xaxis: plotinfo.xaxis,
	            yaxis: plotinfo.yaxis,
	            x: cd0.x,
	            y: cd0.y,
	            // 0 = no data, 1 = data
	            z: makeClipMask(cd0),
	            smoothing: 0
	        };
	
	        makeCrossings([clipPathInfo]);
	        findAllPaths([clipPathInfo]);
	        closeBoundaries([clipPathInfo], {type: 'levels'});
	
	        var path = Lib.ensureSingle(clipPath, 'path', '');
	        path.attr('d',
	            (clipPathInfo.prefixBoundary ? 'M' + perimeter.join('L') + 'Z' : '') +
	            joinAllPaths(clipPathInfo, perimeter)
	        );
	    } else clipId = null;
	
	    Drawing.setClipUrl(plotGroup, clipId, gd);
	}
	
	function makeClipMask(cd0) {
	    var empties = cd0.trace._emptypoints;
	    var z = [];
	    var m = cd0.z.length;
	    var n = cd0.z[0].length;
	    var i;
	    var row = [];
	    var emptyPoint;
	
	    for(i = 0; i < n; i++) row.push(1);
	    for(i = 0; i < m; i++) z.push(row.slice());
	    for(i = 0; i < empties.length; i++) {
	        emptyPoint = empties[i];
	        z[emptyPoint[0]][emptyPoint[1]] = 0;
	    }
	    // save this mask to determine whether to show this data in hover
	    cd0.zmask = z;
	    return z;
	}
	
	},{"../../components/colorscale":603,"../../components/drawing":612,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"../../plots/cartesian/set_convert":782,"../heatmap/plot":1009,"./close_boundaries":943,"./constants":945,"./convert_to_constraints":949,"./empty_pathinfo":951,"./find_all_paths":953,"./make_crossings":958,"d3":164}],960:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	
	module.exports = function setContours(trace, vals) {
	    var contours = trace.contours;
	
	    // check if we need to auto-choose contour levels
	    if(trace.autocontour) {
	        // N.B. do not try to use coloraxis cmin/cmax,
	        // these values here are meant to remain "per-trace" for now
	        var zmin = trace.zmin;
	        var zmax = trace.zmax;
	        if(trace.zauto || zmin === undefined) {
	            zmin = Lib.aggNums(Math.min, null, vals);
	        }
	        if(trace.zauto || zmax === undefined) {
	            zmax = Lib.aggNums(Math.max, null, vals);
	        }
	
	        var dummyAx = autoContours(zmin, zmax, trace.ncontours);
	        contours.size = dummyAx.dtick;
	        contours.start = Axes.tickFirst(dummyAx);
	        dummyAx.range.reverse();
	        contours.end = Axes.tickFirst(dummyAx);
	
	        if(contours.start === zmin) contours.start += contours.size;
	        if(contours.end === zmax) contours.end -= contours.size;
	
	        // if you set a small ncontours, *and* the ends are exactly on zmin/zmax
	        // there's an edge case where start > end now. Make sure there's at least
	        // one meaningful contour, put it midway between the crossed values
	        if(contours.start > contours.end) {
	            contours.start = contours.end = (contours.start + contours.end) / 2;
	        }
	
	        // copy auto-contour info back to the source data.
	        // previously we copied the whole contours object back, but that had
	        // other info (coloring, showlines) that should be left to supplyDefaults
	        if(!trace._input.contours) trace._input.contours = {};
	        Lib.extendFlat(trace._input.contours, {
	            start: contours.start,
	            end: contours.end,
	            size: contours.size
	        });
	        trace._input.autocontour = true;
	    } else if(contours.type !== 'constraint') {
	        // sanity checks on manually-supplied start/end/size
	        var start = contours.start;
	        var end = contours.end;
	        var inputContours = trace._input.contours;
	
	        if(start > end) {
	            contours.start = inputContours.start = end;
	            end = contours.end = inputContours.end = start;
	            start = contours.start;
	        }
	
	        if(!(contours.size > 0)) {
	            var sizeOut;
	            if(start === end) sizeOut = 1;
	            else sizeOut = autoContours(start, end, trace.ncontours).dtick;
	
	            inputContours.size = contours.size = sizeOut;
	        }
	    }
	};
	
	
	/*
	 * autoContours: make a dummy axis object with dtick we can use
	 * as contours.size, and if needed we can use Axes.tickFirst
	 * with this axis object to calculate the start and end too
	 *
	 * start: the value to start the contours at
	 * end: the value to end at (must be > start)
	 * ncontours: max number of contours to make, like roughDTick
	 *
	 * returns: an axis object
	 */
	function autoContours(start, end, ncontours) {
	    var dummyAx = {
	        type: 'linear',
	        range: [start, end]
	    };
	
	    Axes.autoTicks(
	        dummyAx,
	        (end - start) / (ncontours || 15)
	    );
	
	    return dummyAx;
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764}],961:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Drawing = _dereq_('../../components/drawing');
	var heatmapStyle = _dereq_('../heatmap/style');
	
	var makeColorMap = _dereq_('./make_color_map');
	
	
	module.exports = function style(gd) {
	    var contours = d3.select(gd).selectAll('g.contour');
	
	    contours.style('opacity', function(d) {
	        return d[0].trace.opacity;
	    });
	
	    contours.each(function(d) {
	        var c = d3.select(this);
	        var trace = d[0].trace;
	        var contours = trace.contours;
	        var line = trace.line;
	        var cs = contours.size || 1;
	        var start = contours.start;
	
	        // for contourcarpet only - is this a constraint-type contour trace?
	        var isConstraintType = contours.type === 'constraint';
	        var colorLines = !isConstraintType && contours.coloring === 'lines';
	        var colorFills = !isConstraintType && contours.coloring === 'fill';
	
	        var colorMap = (colorLines || colorFills) ? makeColorMap(trace) : null;
	
	        c.selectAll('g.contourlevel').each(function(d) {
	            d3.select(this).selectAll('path')
	                .call(Drawing.lineGroupStyle,
	                    line.width,
	                    colorLines ? colorMap(d.level) : line.color,
	                    line.dash);
	        });
	
	        var labelFont = contours.labelfont;
	        c.selectAll('g.contourlabels text').each(function(d) {
	            Drawing.font(d3.select(this), {
	                family: labelFont.family,
	                size: labelFont.size,
	                color: labelFont.color || (colorLines ? colorMap(d.level) : line.color)
	            });
	        });
	
	        if(isConstraintType) {
	            c.selectAll('g.contourfill path')
	                .style('fill', trace.fillcolor);
	        } else if(colorFills) {
	            var firstFill;
	
	            c.selectAll('g.contourfill path')
	                .style('fill', function(d) {
	                    if(firstFill === undefined) firstFill = d.level;
	                    return colorMap(d.level + 0.5 * cs);
	                });
	
	            if(firstFill === undefined) firstFill = start;
	
	            c.selectAll('g.contourbg path')
	                .style('fill', colorMap(firstFill - 0.5 * cs));
	        }
	    });
	
	    heatmapStyle(gd);
	};
	
	},{"../../components/drawing":612,"../heatmap/style":1010,"./make_color_map":957,"d3":164}],962:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var handleLabelDefaults = _dereq_('./label_defaults');
	
	
	module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, layout, opts) {
	    var coloring = coerce('contours.coloring');
	
	    var showLines;
	    var lineColor = '';
	    if(coloring === 'fill') showLines = coerce('contours.showlines');
	
	    if(showLines !== false) {
	        if(coloring !== 'lines') lineColor = coerce('line.color', '#000');
	        coerce('line.width', 0.5);
	        coerce('line.dash');
	    }
	
	    if(coloring !== 'none') {
	        // plots/plots always coerces showlegend to true, but in this case
	        // we default to false and (by default) show a colorbar instead
	        if(traceIn.showlegend !== true) traceOut.showlegend = false;
	        traceOut._dfltShowLegend = false;
	
	        colorscaleDefaults(
	            traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'}
	        );
	    }
	
	    coerce('line.smoothing');
	
	    handleLabelDefaults(coerce, layout, lineColor, opts);
	};
	
	},{"../../components/colorscale/defaults":601,"./label_defaults":956}],963:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var heatmapAttrs = _dereq_('../heatmap/attributes');
	var contourAttrs = _dereq_('../contour/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var contourContourAttrs = contourAttrs.contours;
	
	module.exports = extendFlat({
	    carpet: {
	        valType: 'string',
	        
	        editType: 'calc',
	        
	    },
	    z: heatmapAttrs.z,
	    a: heatmapAttrs.x,
	    a0: heatmapAttrs.x0,
	    da: heatmapAttrs.dx,
	    b: heatmapAttrs.y,
	    b0: heatmapAttrs.y0,
	    db: heatmapAttrs.dy,
	    text: heatmapAttrs.text,
	    hovertext: heatmapAttrs.hovertext,
	    transpose: heatmapAttrs.transpose,
	    atype: heatmapAttrs.xtype,
	    btype: heatmapAttrs.ytype,
	
	    fillcolor: contourAttrs.fillcolor,
	
	    autocontour: contourAttrs.autocontour,
	    ncontours: contourAttrs.ncontours,
	
	    contours: {
	        type: contourContourAttrs.type,
	        start: contourContourAttrs.start,
	        end: contourContourAttrs.end,
	        size: contourContourAttrs.size,
	        coloring: {
	            // from contourAttrs.contours.coloring but no 'heatmap' option
	            valType: 'enumerated',
	            values: ['fill', 'lines', 'none'],
	            dflt: 'fill',
	            
	            editType: 'calc',
	            
	        },
	        showlines: contourContourAttrs.showlines,
	        showlabels: contourContourAttrs.showlabels,
	        labelfont: contourContourAttrs.labelfont,
	        labelformat: contourContourAttrs.labelformat,
	        operation: contourContourAttrs.operation,
	        value: contourContourAttrs.value,
	        editType: 'calc',
	        impliedEdits: {'autocontour': false}
	    },
	
	    line: {
	        color: contourAttrs.line.color,
	        width: contourAttrs.line.width,
	        dash: contourAttrs.line.dash,
	        smoothing: contourAttrs.line.smoothing,
	        editType: 'plot'
	    },
	
	    transforms: undefined
	},
	
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        autoColorDflt: false
	    })
	);
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../contour/attributes":941,"../heatmap/attributes":998}],964:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var Lib = _dereq_('../../lib');
	
	var convertColumnData = _dereq_('../heatmap/convert_column_xyz');
	var clean2dArray = _dereq_('../heatmap/clean_2d_array');
	var interp2d = _dereq_('../heatmap/interp2d');
	var findEmpties = _dereq_('../heatmap/find_empties');
	var makeBoundArray = _dereq_('../heatmap/make_bound_array');
	var supplyDefaults = _dereq_('./defaults');
	var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
	var setContours = _dereq_('../contour/set_contours');
	
	// most is the same as heatmap calc, then adjust it
	// though a few things inside heatmap calc still look for
	// contour maps, because the makeBoundArray calls are too entangled
	module.exports = function calc(gd, trace) {
	    var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	    if(!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
	
	    if(!trace.a || !trace.b) {
	        // Look up the original incoming carpet data:
	        var carpetdata = gd.data[carpet.index];
	
	        // Look up the incoming trace data, *except* perform a shallow
	        // copy so that we're not actually modifying it when we use it
	        // to supply defaults:
	        var tracedata = gd.data[trace.index];
	        // var tracedata = extendFlat({}, gd.data[trace.index]);
	
	        // If the data is not specified
	        if(!tracedata.a) tracedata.a = carpetdata.a;
	        if(!tracedata.b) tracedata.b = carpetdata.b;
	
	        supplyDefaults(tracedata, trace, trace._defaultColor, gd._fullLayout);
	    }
	
	    var cd = heatmappishCalc(gd, trace);
	    setContours(trace, trace._z);
	
	    return cd;
	};
	
	function heatmappishCalc(gd, trace) {
	    // prepare the raw data
	    // run makeCalcdata on x and y even for heatmaps, in case of category mappings
	    var carpet = trace._carpetTrace;
	    var aax = carpet.aaxis;
	    var bax = carpet.baxis;
	    var a,
	        a0,
	        da,
	        b,
	        b0,
	        db,
	        z;
	
	    // cancel minimum tick spacings (only applies to bars and boxes)
	    aax._minDtick = 0;
	    bax._minDtick = 0;
	
	    if(Lib.isArray1D(trace.z)) convertColumnData(trace, aax, bax, 'a', 'b', ['z']);
	    a = trace._a = trace._a || trace.a;
	    b = trace._b = trace._b || trace.b;
	
	    a = a ? aax.makeCalcdata(trace, '_a') : [];
	    b = b ? bax.makeCalcdata(trace, '_b') : [];
	    a0 = trace.a0 || 0;
	    da = trace.da || 1;
	    b0 = trace.b0 || 0;
	    db = trace.db || 1;
	
	    z = trace._z = clean2dArray(trace._z || trace.z, trace.transpose);
	
	    trace._emptypoints = findEmpties(z);
	    interp2d(z, trace._emptypoints);
	
	    // create arrays of brick boundaries, to be used by autorange and heatmap.plot
	    var xlen = Lib.maxRowLength(z);
	    var xIn = trace.xtype === 'scaled' ? '' : a;
	    var xArray = makeBoundArray(trace, xIn, a0, da, xlen, aax);
	    var yIn = trace.ytype === 'scaled' ? '' : b;
	    var yArray = makeBoundArray(trace, yIn, b0, db, z.length, bax);
	
	    var cd0 = {
	        a: xArray,
	        b: yArray,
	        z: z,
	    };
	
	    if(trace.contours.type === 'levels' && trace.contours.coloring !== 'none') {
	        // auto-z and autocolorscale if applicable
	        colorscaleCalc(gd, trace, {
	            vals: z,
	            containerStr: '',
	            cLetter: 'z'
	        });
	    }
	
	    return [cd0];
	}
	
	},{"../../components/colorscale/calc":599,"../../lib":716,"../carpet/lookup_carpetid":914,"../contour/set_contours":960,"../heatmap/clean_2d_array":1000,"../heatmap/convert_column_xyz":1002,"../heatmap/find_empties":1004,"../heatmap/interp2d":1007,"../heatmap/make_bound_array":1008,"./defaults":965}],965:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleXYZDefaults = _dereq_('../heatmap/xyz_defaults');
	var attributes = _dereq_('./attributes');
	var handleConstraintDefaults = _dereq_('../contour/constraint_defaults');
	var handleContoursDefaults = _dereq_('../contour/contours_defaults');
	var handleStyleDefaults = _dereq_('../contour/style_defaults');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    function coerce2(attr) {
	        return Lib.coerce2(traceIn, traceOut, attributes, attr);
	    }
	
	    coerce('carpet');
	
	    // If either a or b is not present, then it's not a valid trace *unless* the carpet
	    // axis has the a or b values we're looking for. So if these are not found, just defer
	    // that decision until the calc step.
	    //
	    // NB: the calc step will modify the original data input by assigning whichever of
	    // a or b are missing. This is necessary because panning goes right from supplyDefaults
	    // to plot (skipping calc). That means on subsequent updates, this *will* need to be
	    // able to find a and b.
	    //
	    // The long-term proper fix is that this should perhaps use underscored attributes to
	    // at least modify the user input to a slightly lesser extent. Fully removing the
	    // input mutation is challenging. The underscore approach is not currently taken since
	    // it requires modification to all of the functions below that expect the coerced
	    // attribute name to match the property name -- except '_a' !== 'a' so that is not
	    // straightforward.
	    if(traceIn.a && traceIn.b) {
	        var len = handleXYZDefaults(traceIn, traceOut, coerce, layout, 'a', 'b');
	
	        if(!len) {
	            traceOut.visible = false;
	            return;
	        }
	
	        coerce('text');
	        var isConstraint = (coerce('contours.type') === 'constraint');
	
	        if(isConstraint) {
	            handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, {hasHover: false});
	        } else {
	            handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	            handleStyleDefaults(traceIn, traceOut, coerce, layout, {hasHover: false});
	        }
	    } else {
	        traceOut._defaultColor = defaultColor;
	        traceOut._length = null;
	    }
	};
	
	},{"../../lib":716,"../contour/constraint_defaults":946,"../contour/contours_defaults":948,"../contour/style_defaults":962,"../heatmap/xyz_defaults":1012,"./attributes":963}],966:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../contour/colorbar'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('../contour/style'),
	
	    moduleType: 'trace',
	    name: 'contourcarpet',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'carpet', 'contour', 'symbols', 'showLegend', 'hasLines', 'carpetDependent', 'noHover', 'noSortingByValue'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../contour/colorbar":944,"../contour/style":961,"./attributes":963,"./calc":964,"./defaults":965,"./plot":967}],967:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var map1dArray = _dereq_('../carpet/map_1d_array');
	var makepath = _dereq_('../carpet/makepath');
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	
	var makeCrossings = _dereq_('../contour/make_crossings');
	var findAllPaths = _dereq_('../contour/find_all_paths');
	var contourPlot = _dereq_('../contour/plot');
	var constants = _dereq_('../contour/constants');
	var convertToConstraints = _dereq_('../contour/convert_to_constraints');
	var emptyPathinfo = _dereq_('../contour/empty_pathinfo');
	var closeBoundaries = _dereq_('../contour/close_boundaries');
	var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
	var axisAlignedLine = _dereq_('../carpet/axis_aligned_line');
	
	module.exports = function plot(gd, plotinfo, cdcontours, contourcarpetLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(contourcarpetLayer, cdcontours, 'contour').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	        var carpetcd = gd.calcdata[carpet.index][0];
	
	        if(!carpet.visible || carpet.visible === 'legendonly') return;
	
	        var a = cd0.a;
	        var b = cd0.b;
	        var contours = trace.contours;
	        var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
	        var isConstraint = contours.type === 'constraint';
	        var operation = contours._operation;
	        var coloring = isConstraint ? (operation === '=' ? 'lines' : 'fill') : contours.coloring;
	
	        // Map [a, b] (data) --> [i, j] (pixels)
	        function ab2p(ab) {
	            var pt = carpet.ab2xy(ab[0], ab[1], true);
	            return [xa.c2p(pt[0]), ya.c2p(pt[1])];
	        }
	
	        // Define the perimeter in a/b coordinates:
	        var perimeter = [
	            [a[0], b[b.length - 1]],
	            [a[a.length - 1], b[b.length - 1]],
	            [a[a.length - 1], b[0]],
	            [a[0], b[0]]
	        ];
	
	        // Extract the contour levels:
	        makeCrossings(pathinfo);
	        var atol = (a[a.length - 1] - a[0]) * 1e-8;
	        var btol = (b[b.length - 1] - b[0]) * 1e-8;
	        findAllPaths(pathinfo, atol, btol);
	
	        // Constraints might need to be draw inverted, which is not something contours
	        // handle by default since they're assumed fully opaque so that they can be
	        // drawn overlapping. This function flips the paths as necessary so that they're
	        // drawn correctly.
	        //
	        // TODO: Perhaps this should be generalized and *all* paths should be drawn as
	        // closed regions so that translucent contour levels would be valid.
	        // See: https://github.com/plotly/plotly.js/issues/1356
	        var fillPathinfo = pathinfo;
	        if(contours.type === 'constraint') {
	            fillPathinfo = convertToConstraints(pathinfo, operation);
	        }
	
	        // Map the paths in a/b coordinates to pixel coordinates:
	        mapPathinfo(pathinfo, ab2p);
	
	        // draw everything
	
	        // Compute the boundary path
	        var seg, xp, yp, i;
	        var segs = [];
	        for(i = carpetcd.clipsegments.length - 1; i >= 0; i--) {
	            seg = carpetcd.clipsegments[i];
	            xp = map1dArray([], seg.x, xa.c2p);
	            yp = map1dArray([], seg.y, ya.c2p);
	            xp.reverse();
	            yp.reverse();
	            segs.push(makepath(xp, yp, seg.bicubic));
	        }
	
	        var boundaryPath = 'M' + segs.join('L') + 'Z';
	
	        // Draw the baseline background fill that fills in the space behind any other
	        // contour levels:
	        makeBackground(plotGroup, carpetcd.clipsegments, xa, ya, isConstraint, coloring);
	
	        // Draw the specific contour fills. As a simplification, they're assumed to be
	        // fully opaque so that it's easy to draw them simply overlapping. The alternative
	        // would be to flip adjacent paths and draw closed paths for each level instead.
	        makeFills(trace, plotGroup, xa, ya, fillPathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath);
	
	        // Draw contour lines:
	        makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours, plotinfo, carpet);
	
	        // Clip the boundary of the plot
	        Drawing.setClipUrl(plotGroup, carpet._clipPathId, gd);
	    });
	};
	
	function mapPathinfo(pathinfo, map) {
	    var i, j, k, pi, pedgepaths, ppaths, pedgepath, ppath, path;
	
	    for(i = 0; i < pathinfo.length; i++) {
	        pi = pathinfo[i];
	        pedgepaths = pi.pedgepaths = [];
	        ppaths = pi.ppaths = [];
	        for(j = 0; j < pi.edgepaths.length; j++) {
	            path = pi.edgepaths[j];
	            pedgepath = [];
	            for(k = 0; k < path.length; k++) {
	                pedgepath[k] = map(path[k]);
	            }
	            pedgepaths.push(pedgepath);
	        }
	        for(j = 0; j < pi.paths.length; j++) {
	            path = pi.paths[j];
	            ppath = [];
	            for(k = 0; k < path.length; k++) {
	                ppath[k] = map(path[k]);
	            }
	            ppaths.push(ppath);
	        }
	    }
	}
	
	function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours, plotinfo, carpet) {
	    var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
	    var showLines = contours.showlines !== false;
	    var showLabels = contours.showlabels;
	    var clipLinesForLabels = showLines && showLabels;
	
	    // Even if we're not going to show lines, we need to create them
	    // if we're showing labels, because the fill paths include the perimeter
	    // so can't be used to position the labels correctly.
	    // In this case we'll remove the lines after making the labels.
	    var linegroup = contourPlot.createLines(lineContainer, showLines || showLabels, pathinfo);
	
	    var lineClip = contourPlot.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
	
	    var labelGroup = plotgroup.selectAll('g.contourlabels')
	        .data(showLabels ? [0] : []);
	
	    labelGroup.exit().remove();
	
	    labelGroup.enter().append('g')
	        .classed('contourlabels', true);
	
	    if(showLabels) {
	        var xa = plotinfo.xaxis;
	        var ya = plotinfo.yaxis;
	        var xLen = xa._length;
	        var yLen = ya._length;
	        // for simplicity use the xy box for label clipping outline.
	        var labelClipPathData = [[
	            [0, 0],
	            [xLen, 0],
	            [xLen, yLen],
	            [0, yLen]
	        ]];
	
	
	        var labelData = [];
	
	        // invalidate the getTextLocation cache in case paths changed
	        Lib.clearLocationCache();
	
	        var contourFormat = contourPlot.labelFormatter(gd, cd0);
	
	        var dummyText = Drawing.tester.append('text')
	            .attr('data-notex', 1)
	            .call(Drawing.font, contours.labelfont);
	
	        // use `bounds` only to keep labels away from the x/y boundaries
	        // `constrainToCarpet` below ensures labels don't go off the
	        // carpet edges
	        var bounds = {
	            left: 0,
	            right: xLen,
	            center: xLen / 2,
	            top: 0,
	            bottom: yLen,
	            middle: yLen / 2
	        };
	
	        var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
	
	        // the path length to use to scale the number of labels to draw:
	        var normLength = constants.LABELDISTANCE * plotDiagonal /
	            Math.max(1, pathinfo.length / constants.LABELINCREASE);
	
	        linegroup.each(function(d) {
	            var textOpts = contourPlot.calcTextOpts(d.level, contourFormat, dummyText, gd);
	
	            d3.select(this).selectAll('path').each(function(pathData) {
	                var path = this;
	                var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
	                if(!pathBounds) return;
	
	                constrainToCarpet(path, pathData, d, pathBounds, carpet, textOpts.height);
	
	                if(pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
	
	                var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength),
	                    constants.LABELMAX);
	
	                for(var i = 0; i < maxLabels; i++) {
	                    var loc = contourPlot.findBestTextLocation(path, pathBounds, textOpts,
	                        labelData, bounds);
	
	                    if(!loc) break;
	
	                    contourPlot.addLabelData(loc, textOpts, labelData, labelClipPathData);
	                }
	            });
	        });
	
	        dummyText.remove();
	
	        contourPlot.drawLabels(labelGroup, labelData, gd, lineClip,
	            clipLinesForLabels ? labelClipPathData : null);
	    }
	
	    if(showLabels && !showLines) linegroup.remove();
	}
	
	// figure out if this path goes off the edge of the carpet
	// and shorten the part we call visible to keep labels away from the edge
	function constrainToCarpet(path, pathData, levelData, pathBounds, carpet, textHeight) {
	    var pathABData;
	    for(var i = 0; i < levelData.pedgepaths.length; i++) {
	        if(pathData === levelData.pedgepaths[i]) {
	            pathABData = levelData.edgepaths[i];
	        }
	    }
	    if(!pathABData) return;
	
	    var aMin = carpet.a[0];
	    var aMax = carpet.a[carpet.a.length - 1];
	    var bMin = carpet.b[0];
	    var bMax = carpet.b[carpet.b.length - 1];
	
	    function getOffset(abPt, pathVector) {
	        var offset = 0;
	        var edgeVector;
	        var dAB = 0.1;
	        if(Math.abs(abPt[0] - aMin) < dAB || Math.abs(abPt[0] - aMax) < dAB) {
	            edgeVector = normalizeVector(carpet.dxydb_rough(abPt[0], abPt[1], dAB));
	            offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
	        }
	
	        if(Math.abs(abPt[1] - bMin) < dAB || Math.abs(abPt[1] - bMax) < dAB) {
	            edgeVector = normalizeVector(carpet.dxyda_rough(abPt[0], abPt[1], dAB));
	            offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
	        }
	        return offset;
	    }
	
	    var startVector = getUnitVector(path, 0, 1);
	    var endVector = getUnitVector(path, pathBounds.total, pathBounds.total - 1);
	    var minStart = getOffset(pathABData[0], startVector);
	    var maxEnd = pathBounds.total - getOffset(pathABData[pathABData.length - 1], endVector);
	
	    if(pathBounds.min < minStart) pathBounds.min = minStart;
	    if(pathBounds.max > maxEnd) pathBounds.max = maxEnd;
	
	    pathBounds.len = pathBounds.max - pathBounds.min;
	}
	
	function getUnitVector(path, p0, p1) {
	    var pt0 = path.getPointAtLength(p0);
	    var pt1 = path.getPointAtLength(p1);
	    var dx = pt1.x - pt0.x;
	    var dy = pt1.y - pt0.y;
	    var len = Math.sqrt(dx * dx + dy * dy);
	    return [dx / len, dy / len];
	}
	
	function normalizeVector(v) {
	    var len = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	    return [v[0] / len, v[1] / len];
	}
	
	function vectorTan(v0, v1) {
	    var cos = Math.abs(v0[0] * v1[0] + v0[1] * v1[1]);
	    var sin = Math.sqrt(1 - cos * cos);
	    return sin / cos;
	}
	
	function makeBackground(plotgroup, clipsegments, xaxis, yaxis, isConstraint, coloring) {
	    var seg, xp, yp, i;
	    var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
	
	    var bgfill = bggroup.selectAll('path')
	        .data((coloring === 'fill' && !isConstraint) ? [0] : []);
	    bgfill.enter().append('path');
	    bgfill.exit().remove();
	
	    var segs = [];
	    for(i = 0; i < clipsegments.length; i++) {
	        seg = clipsegments[i];
	        xp = map1dArray([], seg.x, xaxis.c2p);
	        yp = map1dArray([], seg.y, yaxis.c2p);
	        segs.push(makepath(xp, yp, seg.bicubic));
	    }
	
	    bgfill
	        .attr('d', 'M' + segs.join('L') + 'Z')
	        .style('stroke', 'none');
	}
	
	function makeFills(trace, plotgroup, xa, ya, pathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath) {
	    var hasFills = coloring === 'fill';
	
	    // fills prefixBoundary in pathinfo items
	    if(hasFills) {
	        closeBoundaries(pathinfo, trace.contours);
	    }
	
	    var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
	    var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
	    fillitems.enter().append('path');
	    fillitems.exit().remove();
	    fillitems.each(function(pi) {
	        // join all paths for this level together into a single path
	        // first follow clockwise around the perimeter to close any open paths
	        // if the whole perimeter is above this level, start with a path
	        // enclosing the whole thing. With all that, the parity should mean
	        // that we always fill everything above the contour, nothing below
	        var fullpath = (pi.prefixBoundary ? boundaryPath : '') +
	            joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya);
	
	        if(!fullpath) {
	            d3.select(this).remove();
	        } else {
	            d3.select(this)
	                .attr('d', fullpath)
	                .style('stroke', 'none');
	        }
	    });
	}
	
	function joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya) {
	    var i;
	    var fullpath = '';
	
	    var startsleft = pi.edgepaths.map(function(v, i) { return i; });
	    var newloop = true;
	    var endpt, newendpt, cnt, nexti, possiblei, addpath;
	
	    var atol = Math.abs(perimeter[0][0] - perimeter[2][0]) * 1e-4;
	    var btol = Math.abs(perimeter[0][1] - perimeter[2][1]) * 1e-4;
	
	    function istop(pt) { return Math.abs(pt[1] - perimeter[0][1]) < btol; }
	    function isbottom(pt) { return Math.abs(pt[1] - perimeter[2][1]) < btol; }
	    function isleft(pt) { return Math.abs(pt[0] - perimeter[0][0]) < atol; }
	    function isright(pt) { return Math.abs(pt[0] - perimeter[2][0]) < atol; }
	
	    function pathto(pt0, pt1) {
	        var i, j, segments, axis;
	        var path = '';
	
	        if((istop(pt0) && !isright(pt0)) || (isbottom(pt0) && !isleft(pt0))) {
	            axis = carpet.aaxis;
	            segments = axisAlignedLine(carpet, carpetcd, [pt0[0], pt1[0]], 0.5 * (pt0[1] + pt1[1]));
	        } else {
	            axis = carpet.baxis;
	            segments = axisAlignedLine(carpet, carpetcd, 0.5 * (pt0[0] + pt1[0]), [pt0[1], pt1[1]]);
	        }
	
	        for(i = 1; i < segments.length; i++) {
	            path += axis.smoothing ? 'C' : 'L';
	            for(j = 0; j < segments[i].length; j++) {
	                var pt = segments[i][j];
	                path += [xa.c2p(pt[0]), ya.c2p(pt[1])] + ' ';
	            }
	        }
	
	        return path;
	    }
	
	    i = 0;
	    endpt = null;
	    while(startsleft.length) {
	        var startpt = pi.edgepaths[i][0];
	
	        if(endpt) {
	            fullpath += pathto(endpt, startpt);
	        }
	
	        addpath = Drawing.smoothopen(pi.edgepaths[i].map(ab2p), pi.smoothing);
	        fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
	        startsleft.splice(startsleft.indexOf(i), 1);
	        endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
	        nexti = -1;
	
	        // now loop through sides, moving our endpoint until we find a new start
	        for(cnt = 0; cnt < 4; cnt++) { // just to prevent infinite loops
	            if(!endpt) {
	                Lib.log('Missing end?', i, pi);
	                break;
	            }
	
	            if(istop(endpt) && !isright(endpt)) {
	                newendpt = perimeter[1]; // left top ---> right top
	            } else if(isleft(endpt)) {
	                newendpt = perimeter[0]; // left bottom ---> left top
	            } else if(isbottom(endpt)) {
	                newendpt = perimeter[3]; // right bottom
	            } else if(isright(endpt)) {
	                newendpt = perimeter[2]; // left bottom
	            }
	
	            for(possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
	                var ptNew = pi.edgepaths[possiblei][0];
	                // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
	                if(Math.abs(endpt[0] - newendpt[0]) < atol) {
	                    if(Math.abs(endpt[0] - ptNew[0]) < atol &&
	                            (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                    }
	                } else if(Math.abs(endpt[1] - newendpt[1]) < btol) {
	                    if(Math.abs(endpt[1] - ptNew[1]) < btol &&
	                            (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                    }
	                } else {
	                    Lib.log('endpt to newendpt is not vert. or horz.', endpt, newendpt, ptNew);
	                }
	            }
	
	            if(nexti >= 0) break;
	            fullpath += pathto(endpt, newendpt);
	            endpt = newendpt;
	        }
	
	        if(nexti === pi.edgepaths.length) {
	            Lib.log('unclosed perimeter path');
	            break;
	        }
	
	        i = nexti;
	
	        // if we closed back on a loop we already included,
	        // close it and start a new loop
	        newloop = (startsleft.indexOf(i) === -1);
	        if(newloop) {
	            i = startsleft[0];
	            fullpath += pathto(endpt, newendpt) + 'Z';
	            endpt = null;
	        }
	    }
	
	    // finally add the interior paths
	    for(i = 0; i < pi.paths.length; i++) {
	        fullpath += Drawing.smoothclosed(pi.paths[i].map(ab2p), pi.smoothing);
	    }
	
	    return fullpath;
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../carpet/axis_aligned_line":898,"../carpet/lookup_carpetid":914,"../carpet/makepath":915,"../carpet/map_1d_array":916,"../contour/close_boundaries":943,"../contour/constants":945,"../contour/convert_to_constraints":949,"../contour/empty_pathinfo":951,"../contour/find_all_paths":953,"../contour/make_crossings":958,"../contour/plot":959,"d3":164}],968:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var baseAttrs = _dereq_('../../plots/attributes');
	var scatterMapboxAttrs = _dereq_('../scattermapbox/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	/*
	 * - https://docs.mapbox.com/help/tutorials/make-a-heatmap-with-mapbox-gl-js/
	 * - https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
	 * - https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers-heatmap
	 * - https://blog.mapbox.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
	 *
	 * Gotchas:
	 * - https://github.com/mapbox/mapbox-gl-js/issues/6463
	 * - https://github.com/mapbox/mapbox-gl-js/issues/6112
	 */
	
	/*
	 *
	 * In mathematical terms, Mapbox GL heatmaps are a bivariate (2D) kernel density
	 * estimation with a Gaussian kernel. It means that each data point has an area
	 * of “influence” around it (called a kernel) where the numerical value of
	 * influence (which we call density) decreases as you go further from the point.
	 * If we sum density values of all points in every pixel of the screen, we get a
	 * combined density value which we then map to a heatmap color.
	 *
	 */
	
	module.exports = extendFlat({
	    lon: scatterMapboxAttrs.lon,
	    lat: scatterMapboxAttrs.lat,
	
	    z: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    radius: {
	        valType: 'number',
	        
	        editType: 'plot',
	        arrayOk: true,
	        min: 1,
	        dflt: 30,
	        
	    },
	
	    below: {
	        valType: 'string',
	        
	        editType: 'plot',
	        
	    },
	
	    text: scatterMapboxAttrs.text,
	    hovertext: scatterMapboxAttrs.hovertext,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['lon', 'lat', 'z', 'text', 'name']
	    }),
	    hovertemplate: hovertemplateAttrs()
	},
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        editTypeOverride: 'calc'
	    })
	);
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scattermapbox/attributes":1181}],969:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var _ = _dereq_('../../lib')._;
	
	module.exports = function calc(gd, trace) {
	    var len = trace._length;
	    var calcTrace = new Array(len);
	    var z = trace.z;
	    var hasZ = isArrayOrTypedArray(z) && z.length;
	
	    for(var i = 0; i < len; i++) {
	        var cdi = calcTrace[i] = {};
	
	        var lon = trace.lon[i];
	        var lat = trace.lat[i];
	
	        cdi.lonlat = isNumeric(lon) && isNumeric(lat) ?
	            [+lon, +lat] :
	            [BADNUM, BADNUM];
	
	        if(hasZ) {
	            var zi = z[i];
	            cdi.z = isNumeric(zi) ? zi : BADNUM;
	        }
	    }
	
	    colorscaleCalc(gd, trace, {
	        vals: hasZ ? z : [0, 1],
	        containerStr: '',
	        cLetter: 'z'
	    });
	
	    if(len) {
	        calcTrace[0].t = {
	            labels: {
	                lat: _(gd, 'lat:') + ' ',
	                lon: _(gd, 'lon:') + ' '
	            }
	        };
	    }
	
	    return calcTrace;
	};
	
	},{"../../components/colorscale/calc":599,"../../constants/numerical":692,"../../lib":716,"fast-isnumeric":227}],970:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var Colorscale = _dereq_('../../components/colorscale');
	
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	var makeBlank = _dereq_('../../lib/geojson_utils').makeBlank;
	
	module.exports = function convert(calcTrace) {
	    var trace = calcTrace[0].trace;
	    var isVisible = (trace.visible === true && trace._length !== 0);
	
	    var heatmap = {
	        layout: {visibility: 'none'},
	        paint: {}
	    };
	
	    var opts = trace._opts = {
	        heatmap: heatmap,
	        geojson: makeBlank()
	    };
	
	    // early return if not visible or placeholder
	    if(!isVisible) return opts;
	
	    var features = [];
	    var i;
	
	    var z = trace.z;
	    var radius = trace.radius;
	    var hasZ = Lib.isArrayOrTypedArray(z) && z.length;
	    var hasArrayRadius = Lib.isArrayOrTypedArray(radius);
	
	    for(i = 0; i < calcTrace.length; i++) {
	        var cdi = calcTrace[i];
	        var lonlat = cdi.lonlat;
	
	        if(lonlat[0] !== BADNUM) {
	            var props = {};
	
	            if(hasZ) {
	                var zi = cdi.z;
	                props.z = zi !== BADNUM ? zi : 0;
	            }
	            if(hasArrayRadius) {
	                props.r = (isNumeric(radius[i]) && radius[i] > 0) ? +radius[i] : 0;
	            }
	
	            features.push({
	                type: 'Feature',
	                geometry: {type: 'Point', coordinates: lonlat},
	                properties: props
	            });
	        }
	    }
	
	    var cOpts = Colorscale.extractOpts(trace);
	    var scl = cOpts.reversescale ?
	        Colorscale.flipScale(cOpts.colorscale) :
	        cOpts.colorscale;
	
	    // Add alpha channel to first colorscale step.
	    // If not, we would essentially color the entire map.
	    // See https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
	    var scl01 = scl[0][1];
	    var color0 = Color.opacity(scl01) < 1 ? scl01 : Color.addOpacity(scl01, 0);
	
	    var heatmapColor = [
	        'interpolate', ['linear'],
	        ['heatmap-density'],
	        0, color0
	    ];
	    for(i = 1; i < scl.length; i++) {
	        heatmapColor.push(scl[i][0], scl[i][1]);
	    }
	
	    // Those "weights" have to be in [0, 1], we can do this either:
	    // - as here using a mapbox-gl expression
	    // - or, scale the 'z' property in the feature loop
	    var zExp = [
	        'interpolate', ['linear'],
	        ['get', 'z'],
	        cOpts.min, 0,
	        cOpts.max, 1
	    ];
	
	    Lib.extendFlat(opts.heatmap.paint, {
	        'heatmap-weight': hasZ ? zExp : 1 / (cOpts.max - cOpts.min),
	
	        'heatmap-color': heatmapColor,
	
	        'heatmap-radius': hasArrayRadius ?
	            {type: 'identity', property: 'r'} :
	            trace.radius,
	
	        'heatmap-opacity': trace.opacity
	    });
	
	    opts.geojson = {type: 'FeatureCollection', features: features};
	    opts.heatmap.layout.visibility = 'visible';
	
	    return opts;
	};
	
	},{"../../components/color":591,"../../components/colorscale":603,"../../constants/numerical":692,"../../lib":716,"../../lib/geojson_utils":711,"fast-isnumeric":227}],971:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var lon = coerce('lon') || [];
	    var lat = coerce('lat') || [];
	
	    var len = Math.min(lon.length, lat.length);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = len;
	
	    coerce('z');
	    coerce('radius');
	    coerce('below');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":968}],972:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt) {
	    out.lon = pt.lon;
	    out.lat = pt.lat;
	    out.z = pt.z;
	    return out;
	};
	
	},{}],973:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var scatterMapboxHoverPoints = _dereq_('../scattermapbox/hover');
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var pts = scatterMapboxHoverPoints(pointData, xval, yval);
	    if(!pts) return;
	
	    var newPointData = pts[0];
	    var cd = newPointData.cd;
	    var trace = cd[0].trace;
	    var di = cd[newPointData.index];
	
	    // let Fx.hover pick the color
	    delete newPointData.color;
	
	    if('z' in di) {
	        var ax = newPointData.subplot.mockAxis;
	        newPointData.z = di.z;
	        newPointData.zLabel = Axes.tickText(ax, ax.c2l(di.z), 'hover').text;
	    }
	
	    newPointData.extraText = getExtraText(trace, di, cd[0].t.labels);
	
	    return [newPointData];
	};
	
	function getExtraText(trace, di, labels) {
	    if(trace.hovertemplate) return;
	
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var parts = hoverinfo.split('+');
	    var isAll = parts.indexOf('all') !== -1;
	    var hasLon = parts.indexOf('lon') !== -1;
	    var hasLat = parts.indexOf('lat') !== -1;
	    var lonlat = di.lonlat;
	    var text = [];
	
	    function format(v) {
	        return v + '\u00B0';
	    }
	
	    if(isAll || (hasLon && hasLat)) {
	        text.push('(' + format(lonlat[0]) + ', ' + format(lonlat[1]) + ')');
	    } else if(hasLon) {
	        text.push(labels.lon + format(lonlat[0]));
	    } else if(hasLat) {
	        text.push(labels.lat + format(lonlat[1]));
	    }
	
	    if(isAll || parts.indexOf('text') !== -1) {
	        Lib.fillText(di, trace, text);
	    }
	
	    return text.join('<br>');
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../scattermapbox/hover":1186}],974:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../heatmap/colorbar'),
	    formatLabels: _dereq_('../scattermapbox/format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	
	    getBelow: function(trace, subplot) {
	        var mapLayers = subplot.getMapLayers();
	
	        // find first layer with `type: 'symbol'`,
	        // that is not a plotly layer
	        for(var i = 0; i < mapLayers.length; i++) {
	            var layer = mapLayers[i];
	            var layerId = layer.id;
	            if(layer.type === 'symbol' &&
	                typeof layerId === 'string' && layerId.indexOf('plotly-') === -1
	            ) {
	                return layerId;
	            }
	        }
	    },
	
	    moduleType: 'trace',
	    name: 'densitymapbox',
	    basePlotModule: _dereq_('../../plots/mapbox'),
	    categories: ['mapbox', 'gl'],
	    meta: {
	        hr_name: 'density_mapbox',
	        
	    }
	};
	
	},{"../../plots/mapbox":819,"../heatmap/colorbar":1001,"../scattermapbox/format_labels":1185,"./attributes":968,"./calc":969,"./defaults":971,"./event_data":972,"./hover":973,"./plot":975}],975:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var convert = _dereq_('./convert');
	var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
	
	function DensityMapbox(subplot, uid) {
	    this.type = 'densitymapbox';
	    this.subplot = subplot;
	    this.uid = uid;
	
	    this.sourceId = 'source-' + uid;
	
	    this.layerList = [
	        ['heatmap', LAYER_PREFIX + uid + '-heatmap']
	    ];
	
	    // previous 'below' value,
	    // need this to update it properly
	    this.below = null;
	}
	
	var proto = DensityMapbox.prototype;
	
	proto.update = function(calcTrace) {
	    var subplot = this.subplot;
	    var layerList = this.layerList;
	    var optsAll = convert(calcTrace);
	    var below = subplot.belowLookup['trace-' + this.uid];
	
	    subplot.map
	        .getSource(this.sourceId)
	        .setData(optsAll.geojson);
	
	    if(below !== this.below) {
	        this._removeLayers();
	        this._addLayers(optsAll, below);
	        this.below = below;
	    }
	
	    for(var i = 0; i < layerList.length; i++) {
	        var item = layerList[i];
	        var k = item[0];
	        var id = item[1];
	        var opts = optsAll[k];
	
	        subplot.setOptions(id, 'setLayoutProperty', opts.layout);
	
	        if(opts.layout.visibility === 'visible') {
	            subplot.setOptions(id, 'setPaintProperty', opts.paint);
	        }
	    }
	};
	
	proto._addLayers = function(optsAll, below) {
	    var subplot = this.subplot;
	    var layerList = this.layerList;
	    var sourceId = this.sourceId;
	
	    for(var i = 0; i < layerList.length; i++) {
	        var item = layerList[i];
	        var k = item[0];
	        var opts = optsAll[k];
	
	        subplot.addLayer({
	            type: k,
	            id: item[1],
	            source: sourceId,
	            layout: opts.layout,
	            paint: opts.paint
	        }, below);
	    }
	};
	
	proto._removeLayers = function() {
	    var map = this.subplot.map;
	    var layerList = this.layerList;
	
	    for(var i = layerList.length - 1; i >= 0; i--) {
	        map.removeLayer(layerList[i][1]);
	    }
	};
	
	proto.dispose = function() {
	    var map = this.subplot.map;
	    this._removeLayers();
	    map.removeSource(this.sourceId);
	};
	
	module.exports = function createDensityMapbox(subplot, calcTrace) {
	    var trace = calcTrace[0].trace;
	    var densityMapbox = new DensityMapbox(subplot, trace.uid);
	    var sourceId = densityMapbox.sourceId;
	    var optsAll = convert(calcTrace);
	    var below = densityMapbox.below = subplot.belowLookup['trace-' + trace.uid];
	
	    subplot.map.addSource(sourceId, {
	        type: 'geojson',
	        data: optsAll.geojson
	    });
	
	    densityMapbox._addLayers(optsAll, below);
	
	    return densityMapbox;
	};
	
	},{"../../plots/mapbox/constants":817,"./convert":970}],976:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// arrayOk attributes, merge them into calcdata array
	module.exports = function arraysToCalcdata(cd, trace) {
	    for(var i = 0; i < cd.length; i++) cd[i].i = i;
	
	    Lib.mergeArray(trace.text, cd, 'tx');
	    Lib.mergeArray(trace.hovertext, cd, 'htx');
	
	    var marker = trace.marker;
	    if(marker) {
	        Lib.mergeArray(marker.opacity, cd, 'mo');
	        Lib.mergeArray(marker.color, cd, 'mc');
	
	        var markerLine = marker.line;
	        if(markerLine) {
	            Lib.mergeArray(markerLine.color, cd, 'mlc');
	            Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
	        }
	    }
	};
	
	},{"../../lib":716}],977:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var barAttrs = _dereq_('../bar/attributes');
	var lineAttrs = _dereq_('../scatter/attributes').line;
	var baseAttrs = _dereq_('../../plots/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var Color = _dereq_('../../components/color');
	
	module.exports = {
	    x: barAttrs.x,
	    x0: barAttrs.x0,
	    dx: barAttrs.dx,
	    y: barAttrs.y,
	    y0: barAttrs.y0,
	    dy: barAttrs.dy,
	
	    hovertext: barAttrs.hovertext,
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['name', 'x', 'y', 'text', 'percent initial', 'percent previous', 'percent total']
	    }),
	
	    textinfo: {
	        valType: 'flaglist',
	        flags: ['label', 'text', 'percent initial', 'percent previous', 'percent total', 'value'],
	        extras: ['none'],
	        
	        editType: 'plot',
	        arrayOk: false,
	        
	    },
	    // TODO: incorporate `label` and `value` in the eventData
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: constants.eventDataKeys.concat(['label', 'value'])
	    }),
	
	    text: barAttrs.text,
	    textposition: extendFlat({}, barAttrs.textposition, {dflt: 'auto'}),
	    insidetextanchor: extendFlat({}, barAttrs.insidetextanchor, {dflt: 'middle'}),
	    textangle: extendFlat({}, barAttrs.textangle, {dflt: 0}),
	    textfont: barAttrs.textfont,
	    insidetextfont: barAttrs.insidetextfont,
	    outsidetextfont: barAttrs.outsidetextfont,
	    constraintext: barAttrs.constraintext,
	    cliponaxis: barAttrs.cliponaxis,
	
	    orientation: extendFlat({}, barAttrs.orientation, {
	        
	    }),
	
	    offset: extendFlat({}, barAttrs.offset, {arrayOk: false}),
	    width: extendFlat({}, barAttrs.width, {arrayOk: false}),
	
	    marker: barAttrs.marker,
	
	    connector: {
	        fillcolor: {
	            valType: 'color',
	            
	            editType: 'style',
	            
	        },
	        line: {
	            color: extendFlat({}, lineAttrs.color, {dflt: Color.defaultLine}),
	            width: extendFlat({}, lineAttrs.width, {
	                dflt: 0,
	                editType: 'plot',
	            }),
	            dash: lineAttrs.dash,
	            editType: 'style'
	        },
	        visible: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        editType: 'plot'
	    },
	
	    offsetgroup: barAttrs.offsetgroup,
	    alignmentgroup: barAttrs.alignmentgroup
	};
	
	},{"../../components/color":591,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../bar/attributes":855,"../scatter/attributes":1118,"./constants":979}],978:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var size, pos, i, cdi;
	
	    if(trace.orientation === 'h') {
	        size = xa.makeCalcdata(trace, 'x');
	        pos = ya.makeCalcdata(trace, 'y');
	    } else {
	        size = ya.makeCalcdata(trace, 'y');
	        pos = xa.makeCalcdata(trace, 'x');
	    }
	
	    // create the "calculated data" to plot
	    var serieslen = Math.min(pos.length, size.length);
	    var cd = new Array(serieslen);
	
	    // Unlike other bar-like traces funnels do not support base attribute.
	    // bases for funnels are computed internally in a way that
	    // the mid-point of each bar are located on the axis line.
	    trace._base = [];
	
	    // set position and size
	    for(i = 0; i < serieslen; i++) {
	        // treat negative values as bad numbers
	        if(size[i] < 0) size[i] = BADNUM;
	
	        var connectToNext = false;
	        if(size[i] !== BADNUM) {
	            if(i + 1 < serieslen && size[i + 1] !== BADNUM) {
	                connectToNext = true;
	            }
	        }
	
	        cdi = cd[i] = {
	            p: pos[i],
	            s: size[i],
	            cNext: connectToNext
	        };
	
	        trace._base[i] = -0.5 * cdi.s;
	
	        if(trace.ids) {
	            cdi.id = String(trace.ids[i]);
	        }
	
	        // calculate total values
	        if(i === 0) cd[0].vTotal = 0;
	        cd[0].vTotal += fixNum(cdi.s);
	
	        // ratio from initial value
	        cdi.begR = fixNum(cdi.s) / fixNum(cd[0].s);
	    }
	
	    var prevGoodNum;
	    for(i = 0; i < serieslen; i++) {
	        cdi = cd[i];
	        if(cdi.s === BADNUM) continue;
	
	        // ratio of total value
	        cdi.sumR = cdi.s / cd[0].vTotal;
	
	        // ratio of previous (good) value
	        cdi.difR = (prevGoodNum !== undefined) ? cdi.s / prevGoodNum : 1;
	
	        prevGoodNum = cdi.s;
	    }
	
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	function fixNum(a) {
	    return (a === BADNUM) ? 0 : a;
	}
	
	},{"../../constants/numerical":692,"../../plots/cartesian/axes":764,"../scatter/calc_selection":1120,"./arrays_to_calcdata":976}],979:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    eventDataKeys: [
	        'percentInitial',
	        'percentPrevious',
	        'percentTotal'
	    ]
	};
	
	},{}],980:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
	
	module.exports = function crossTraceCalc(gd, plotinfo) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var calcdata = gd.calcdata;
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var funnels = [];
	    var funnelsVert = [];
	    var funnelsHorz = [];
	    var cd, i;
	
	    for(i = 0; i < fullData.length; i++) {
	        var fullTrace = fullData[i];
	        var isHorizontal = (fullTrace.orientation === 'h');
	
	        if(
	            fullTrace.visible === true &&
	            fullTrace.xaxis === xa._id &&
	            fullTrace.yaxis === ya._id &&
	            fullTrace.type === 'funnel'
	        ) {
	            cd = calcdata[i];
	
	            if(isHorizontal) {
	                funnelsHorz.push(cd);
	            } else {
	                funnelsVert.push(cd);
	            }
	
	            funnels.push(cd);
	        }
	    }
	
	    var opts = {
	        mode: fullLayout.funnelmode,
	        norm: fullLayout.funnelnorm,
	        gap: fullLayout.funnelgap,
	        groupgap: fullLayout.funnelgroupgap
	    };
	
	    setGroupPositions(gd, xa, ya, funnelsVert, opts);
	    setGroupPositions(gd, ya, xa, funnelsHorz, opts);
	
	    for(i = 0; i < funnels.length; i++) {
	        cd = funnels[i];
	
	        for(var j = 0; j < cd.length; j++) {
	            if(j + 1 < cd.length) {
	                cd[j].nextP0 = cd[j + 1].p0;
	                cd[j].nextS0 = cd[j + 1].s0;
	
	                cd[j].nextP1 = cd[j + 1].p1;
	                cd[j].nextS1 = cd[j + 1].s1;
	            }
	        }
	    }
	};
	
	},{"../bar/cross_trace_calc":858}],981:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	var handleXYDefaults = _dereq_('../scatter/xy_defaults');
	var attributes = _dereq_('./attributes');
	var Color = _dereq_('../../components/color');
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('orientation', (traceOut.y && !traceOut.x) ? 'v' : 'h');
	    coerce('offset');
	    coerce('width');
	
	    var text = coerce('text');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var textposition = coerce('textposition');
	    handleText(traceIn, traceOut, layout, coerce, textposition, {
	        moduleHasSelected: false,
	        moduleHasUnselected: false,
	        moduleHasConstrain: true,
	        moduleHasCliponaxis: true,
	        moduleHasTextangle: true,
	        moduleHasInsideanchor: true
	    });
	
	    if(traceOut.textposition !== 'none' && !traceOut.texttemplate) {
	        coerce('textinfo', Array.isArray(text) ? 'text+value' : 'value');
	    }
	
	    var markerColor = coerce('marker.color', defaultColor);
	    coerce('marker.line.color', Color.defaultLine);
	    coerce('marker.line.width');
	
	    var connectorVisible = coerce('connector.visible');
	    if(connectorVisible) {
	        coerce('connector.fillcolor', defaultFillColor(markerColor));
	
	        var connectorLineWidth = coerce('connector.line.width');
	        if(connectorLineWidth) {
	            coerce('connector.line.color');
	            coerce('connector.line.dash');
	        }
	    }
	}
	
	function defaultFillColor(markerColor) {
	    var cBase = Lib.isArrayOrTypedArray(markerColor) ? '#000' : markerColor;
	
	    return Color.addOpacity(cBase, 0.5 * Color.opacity(cBase));
	}
	
	function crossTraceDefaults(fullData, fullLayout) {
	    var traceIn, traceOut;
	
	    function coerce(attr) {
	        return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	    }
	
	    if(fullLayout.funnelmode === 'group') {
	        for(var i = 0; i < fullData.length; i++) {
	            traceOut = fullData[i];
	            traceIn = traceOut._input;
	
	            handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	        }
	    }
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults,
	    crossTraceDefaults: crossTraceDefaults
	};
	
	},{"../../components/color":591,"../../lib":716,"../bar/defaults":859,"../scatter/xy_defaults":1144,"./attributes":977}],982:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
	    // standard cartesian event data
	    out.x = 'xVal' in pt ? pt.xVal : pt.x;
	    out.y = 'yVal' in pt ? pt.yVal : pt.y;
	
	    // for funnel
	    if('percentInitial' in pt) out.percentInitial = pt.percentInitial;
	    if('percentPrevious' in pt) out.percentPrevious = pt.percentPrevious;
	    if('percentTotal' in pt) out.percentTotal = pt.percentTotal;
	
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    return out;
	};
	
	},{}],983:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var opacity = _dereq_('../../components/color').opacity;
	var hoverOnBars = _dereq_('../bar/hover').hoverOnBars;
	var formatPercent = _dereq_('../../lib').formatPercent;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var point = hoverOnBars(pointData, xval, yval, hovermode);
	    if(!point) return;
	
	    var cd = point.cd;
	    var trace = cd[0].trace;
	    var isHorizontal = (trace.orientation === 'h');
	
	    // the closest data point
	    var index = point.index;
	    var di = cd[index];
	
	    var sizeLetter = isHorizontal ? 'x' : 'y';
	    point[sizeLetter + 'LabelVal'] = di.s;
	
	    point.percentInitial = di.begR;
	    point.percentInitialLabel = formatPercent(di.begR, 1);
	
	    point.percentPrevious = di.difR;
	    point.percentPreviousLabel = formatPercent(di.difR, 1);
	
	    point.percentTotal = di.sumR;
	    point.percentTotalLabel = formatPercent(di.sumR, 1);
	
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var text = [];
	    if(hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
	        var isAll = (hoverinfo === 'all');
	        var parts = hoverinfo.split('+');
	
	        var hasFlag = function(flag) { return isAll || parts.indexOf(flag) !== -1; };
	
	        if(hasFlag('percent initial')) {
	            text.push(point.percentInitialLabel + ' of initial');
	        }
	        if(hasFlag('percent previous')) {
	            text.push(point.percentPreviousLabel + ' of previous');
	        }
	        if(hasFlag('percent total')) {
	            text.push(point.percentTotalLabel + ' of total');
	        }
	    }
	    point.extraText = text.join('<br>');
	
	    point.color = getTraceColor(trace, di);
	
	    return [point];
	};
	
	function getTraceColor(trace, di) {
	    var cont = trace.marker;
	    var mc = di.mc || cont.color;
	    var mlc = di.mlc || cont.line.color;
	    var mlw = di.mlw || cont.line.width;
	    if(opacity(mc)) return mc;
	    else if(opacity(mlc) && mlw) return mlc;
	}
	
	},{"../../components/color":591,"../../lib":716,"../bar/hover":862}],984:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    calc: _dereq_('./calc'),
	    crossTraceCalc: _dereq_('./cross_trace_calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style').style,
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	
	    selectPoints: _dereq_('../bar/select'),
	
	    moduleType: 'trace',
	    name: 'funnel',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../bar/select":867,"./attributes":977,"./calc":978,"./cross_trace_calc":980,"./defaults":981,"./event_data":982,"./hover":983,"./layout_attributes":985,"./layout_defaults":986,"./plot":987,"./style":988}],985:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    funnelmode: {
	        valType: 'enumerated',
	        values: ['stack', 'group', 'overlay'],
	        dflt: 'stack',
	        
	        editType: 'calc',
	        
	    },
	    funnelgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'calc',
	        
	    },
	    funnelgroupgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],986:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function(layoutIn, layoutOut, fullData) {
	    var hasTraceType = false;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	
	        if(trace.visible && trace.type === 'funnel') {
	            hasTraceType = true;
	            break;
	        }
	    }
	
	    if(hasTraceType) {
	        coerce('funnelmode');
	        coerce('funnelgap', 0.2);
	        coerce('funnelgroupgap');
	    }
	};
	
	},{"../../lib":716,"./layout_attributes":985}],987:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var barPlot = _dereq_('../bar/plot').plot;
	
	module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
	    var fullLayout = gd._fullLayout;
	
	    plotConnectorRegions(gd, plotinfo, cdModule, traceLayer);
	    plotConnectorLines(gd, plotinfo, cdModule, traceLayer);
	
	    barPlot(gd, plotinfo, cdModule, traceLayer, {
	        mode: fullLayout.funnelmode,
	        norm: fullLayout.funnelmode,
	        gap: fullLayout.funnelgap,
	        groupgap: fullLayout.funnelgroupgap
	    });
	};
	
	function plotConnectorRegions(gd, plotinfo, cdModule, traceLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var trace = cd[0].trace;
	
	        var group = Lib.ensureSingle(plotGroup, 'g', 'regions');
	
	        if(!trace.connector || !trace.connector.visible) {
	            group.remove();
	            return;
	        }
	
	        var isHorizontal = (trace.orientation === 'h');
	
	        var connectors = group.selectAll('g.region').data(Lib.identity);
	
	        connectors.enter().append('g')
	            .classed('region', true);
	
	        connectors.exit().remove();
	
	        var len = connectors.size();
	
	        connectors.each(function(di, i) {
	            // don't draw lines between nulls
	            if(i !== len - 1 && !di.cNext) return;
	
	            var xy = getXY(di, xa, ya, isHorizontal);
	            var x = xy[0];
	            var y = xy[1];
	
	            var shape = '';
	
	            if(x[3] !== undefined && y[3] !== undefined) {
	                if(isHorizontal) {
	                    shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2] + 'H' + x[3] + 'L' + x[1] + ',' + y[1] + 'Z';
	                } else {
	                    shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3] + 'V' + y[2] + 'L' + x[1] + ',' + y[0] + 'Z';
	                }
	            }
	
	            Lib.ensureSingle(d3.select(this), 'path')
	                .attr('d', shape)
	                .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	        });
	    });
	}
	
	function plotConnectorLines(gd, plotinfo, cdModule, traceLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var trace = cd[0].trace;
	
	        var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
	
	        if(!trace.connector || !trace.connector.visible || !trace.connector.line.width) {
	            group.remove();
	            return;
	        }
	
	        var isHorizontal = (trace.orientation === 'h');
	
	        var connectors = group.selectAll('g.line').data(Lib.identity);
	
	        connectors.enter().append('g')
	            .classed('line', true);
	
	        connectors.exit().remove();
	
	        var len = connectors.size();
	
	        connectors.each(function(di, i) {
	            // don't draw lines between nulls
	            if(i !== len - 1 && !di.cNext) return;
	
	            var xy = getXY(di, xa, ya, isHorizontal);
	            var x = xy[0];
	            var y = xy[1];
	
	            var shape = '';
	
	            if(x[3] !== undefined && y[3] !== undefined) {
	                if(isHorizontal) {
	                    shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2];
	                    shape += 'M' + x[1] + ',' + y[1] + 'L' + x[3] + ',' + y[2];
	                } else {
	                    shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3];
	                    shape += 'M' + x[1] + ',' + y[0] + 'L' + x[2] + ',' + y[2];
	                }
	            }
	
	            if(shape === '') shape = 'M0,0Z';
	
	            Lib.ensureSingle(d3.select(this), 'path')
	                .attr('d', shape)
	                .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	        });
	    });
	}
	
	function getXY(di, xa, ya, isHorizontal) {
	    var s = [];
	    var p = [];
	
	    var sAxis = isHorizontal ? xa : ya;
	    var pAxis = isHorizontal ? ya : xa;
	
	    s[0] = sAxis.c2p(di.s0, true);
	    p[0] = pAxis.c2p(di.p0, true);
	
	    s[1] = sAxis.c2p(di.s1, true);
	    p[1] = pAxis.c2p(di.p1, true);
	
	    s[2] = sAxis.c2p(di.nextS0, true);
	    p[2] = pAxis.c2p(di.nextP0, true);
	
	    s[3] = sAxis.c2p(di.nextS1, true);
	    p[3] = pAxis.c2p(di.nextP1, true);
	
	    return isHorizontal ? [s, p] : [p, s];
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../bar/plot":866,"d3":164}],988:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Drawing = _dereq_('../../components/drawing');
	var Color = _dereq_('../../components/color');
	var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
	
	var styleTextPoints = _dereq_('../bar/style').styleTextPoints;
	
	function style(gd, cd, sel) {
	    var s = sel ? sel : d3.select(gd).selectAll('g.funnellayer').selectAll('g.trace');
	
	    s.style('opacity', function(d) { return d[0].trace.opacity; });
	
	    s.each(function(d) {
	        var gTrace = d3.select(this);
	        var trace = d[0].trace;
	
	        gTrace.selectAll('.point > path').each(function(di) {
	            if(!di.isBlank) {
	                var cont = trace.marker;
	
	                d3.select(this)
	                    .call(Color.fill, di.mc || cont.color)
	                    .call(Color.stroke, di.mlc || cont.line.color)
	                    .call(Drawing.dashLine, cont.line.dash, di.mlw || cont.line.width)
	                    .style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
	            }
	        });
	
	        styleTextPoints(gTrace, trace, gd);
	
	        gTrace.selectAll('.regions').each(function() {
	            d3.select(this).selectAll('path').style('stroke-width', 0).call(Color.fill, trace.connector.fillcolor);
	        });
	
	        gTrace.selectAll('.lines').each(function() {
	            var cont = trace.connector.line;
	
	            Drawing.lineGroupStyle(
	                d3.select(this).selectAll('path'),
	                cont.width,
	                cont.color,
	                cont.dash
	            );
	        });
	    });
	}
	
	module.exports = {
	    style: style
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../constants/interactions":691,"../bar/style":869,"d3":164}],989:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var pieAttrs = _dereq_('../pie/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    labels: pieAttrs.labels,
	    // equivalent of x0 and dx, if label is missing
	    label0: pieAttrs.label0,
	    dlabel: pieAttrs.dlabel,
	    values: pieAttrs.values,
	
	    marker: {
	        colors: pieAttrs.marker.colors,
	        line: {
	            color: extendFlat({}, pieAttrs.marker.line.color, {
	                dflt: null,
	                
	            }),
	            width: extendFlat({}, pieAttrs.marker.line.width, {dflt: 1}),
	            editType: 'calc'
	        },
	        editType: 'calc'
	    },
	
	    text: pieAttrs.text,
	    hovertext: pieAttrs.hovertext,
	
	    scalegroup: extendFlat({}, pieAttrs.scalegroup, {
	        
	    }),
	
	    textinfo: extendFlat({}, pieAttrs.textinfo, {
	        flags: ['label', 'text', 'value', 'percent']
	    }),
	
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['label', 'color', 'value', 'text', 'percent']
	    }),
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['label', 'text', 'value', 'percent', 'name']
	    }),
	
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: ['label', 'color', 'value', 'text', 'percent']
	    }),
	
	    textposition: extendFlat({}, pieAttrs.textposition, {
	        values: ['inside', 'none'],
	        dflt: 'inside'
	    }),
	
	    textfont: pieAttrs.textfont,
	    insidetextfont: pieAttrs.insidetextfont,
	
	    title: {
	        text: pieAttrs.title.text,
	        font: pieAttrs.title.font,
	        position: extendFlat({}, pieAttrs.title.position, {
	            values: ['top left', 'top center', 'top right'],
	            dflt: 'top center'
	        }),
	        editType: 'plot'
	    },
	
	    domain: domainAttrs({name: 'funnelarea', trace: true, editType: 'calc'}),
	
	    aspectratio: {
	        valType: 'number',
	        
	        min: 0,
	        dflt: 1,
	        editType: 'plot',
	        
	    },
	
	    baseratio: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 0.333,
	        editType: 'plot',
	        
	    }
	};
	
	},{"../../lib/extend":707,"../../plots/attributes":761,"../../plots/domain":789,"../../plots/template_attributes":840,"../pie/attributes":1092}],990:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var plots = _dereq_('../../plots/plots');
	
	exports.name = 'funnelarea';
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	};
	
	},{"../../plots/plots":825}],991:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var pieCalc = _dereq_('../pie/calc');
	
	function calc(gd, trace) {
	    return pieCalc.calc(gd, trace);
	}
	
	function crossTraceCalc(gd) {
	    pieCalc.crossTraceCalc(gd, { type: 'funnelarea' });
	}
	
	module.exports = {
	    calc: calc,
	    crossTraceCalc: crossTraceCalc
	};
	
	},{"../pie/calc":1094}],992:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len;
	    var vals = coerce('values');
	    var hasVals = Lib.isArrayOrTypedArray(vals);
	    var labels = coerce('labels');
	    if(Array.isArray(labels)) {
	        len = labels.length;
	        if(hasVals) len = Math.min(len, vals.length);
	    } else if(hasVals) {
	        len = vals.length;
	
	        coerce('label0');
	        coerce('dlabel');
	    }
	
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	    traceOut._length = len;
	
	    var lineWidth = coerce('marker.line.width');
	    if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
	
	    coerce('marker.colors');
	
	    coerce('scalegroup');
	
	    var textData = coerce('text');
	    var textTemplate = coerce('texttemplate');
	    var textInfo;
	    if(!textTemplate) textInfo = coerce('textinfo', Array.isArray(textData) ? 'text+percent' : 'percent');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    if(textTemplate || (textInfo && textInfo !== 'none')) {
	        var textposition = coerce('textposition');
	        handleText(traceIn, traceOut, layout, coerce, textposition, {
	            moduleHasSelected: false,
	            moduleHasUnselected: false,
	            moduleHasConstrain: false,
	            moduleHasCliponaxis: false,
	            moduleHasTextangle: false,
	            moduleHasInsideanchor: false
	        });
	    }
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    var title = coerce('title.text');
	    if(title) {
	        coerce('title.position');
	        Lib.coerceFont(coerce, 'title.font', layout.font);
	    }
	
	    coerce('aspectratio');
	    coerce('baseratio');
	};
	
	},{"../../lib":716,"../../plots/domain":789,"../bar/defaults":859,"./attributes":989}],993:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'funnelarea',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['pie-like', 'funnelarea', 'showLegend'],
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./calc').crossTraceCalc,
	
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    styleOne: _dereq_('../pie/style_one'),
	
	    meta: {
	        
	    }
	};
	
	},{"../pie/style_one":1103,"./attributes":989,"./base_plot":990,"./calc":991,"./defaults":992,"./layout_attributes":994,"./layout_defaults":995,"./plot":996,"./style":997}],994:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hiddenlabels = _dereq_('../pie/layout_attributes').hiddenlabels;
	
	module.exports = {
	    hiddenlabels: hiddenlabels,
	
	    funnelareacolorway: {
	        valType: 'colorlist',
	        
	        editType: 'calc',
	        
	    },
	    extendfunnelareacolors: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{"../pie/layout_attributes":1099}],995:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    coerce('hiddenlabels');
	    coerce('funnelareacolorway', layoutOut.colorway);
	    coerce('extendfunnelareacolors');
	};
	
	},{"../../lib":716,"./layout_attributes":994}],996:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var barPlot = _dereq_('../bar/plot');
	var toMoveInsideBar = barPlot.toMoveInsideBar;
	
	var pieHelpers = _dereq_('../pie/helpers');
	var piePlot = _dereq_('../pie/plot');
	
	var attachFxHandlers = piePlot.attachFxHandlers;
	var determineInsideTextFont = piePlot.determineInsideTextFont;
	
	var layoutAreas = piePlot.layoutAreas;
	var prerenderTitles = piePlot.prerenderTitles;
	var positionTitleOutside = piePlot.positionTitleOutside;
	
	module.exports = function plot(gd, cdModule) {
	    var fullLayout = gd._fullLayout;
	
	    prerenderTitles(cdModule, gd);
	    layoutAreas(cdModule, fullLayout._size);
	
	    Lib.makeTraceGroups(fullLayout._funnelarealayer, cdModule, 'trace').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        setCoords(cd);
	
	        plotGroup.each(function() {
	            var slices = d3.select(this).selectAll('g.slice').data(cd);
	
	            slices.enter().append('g')
	                .classed('slice', true);
	            slices.exit().remove();
	
	            slices.each(function(pt) {
	                if(pt.hidden) {
	                    d3.select(this).selectAll('path,g').remove();
	                    return;
	                }
	
	                // to have consistent event data compared to other traces
	                pt.pointNumber = pt.i;
	                pt.curveNumber = trace.index;
	
	                var cx = cd0.cx;
	                var cy = cd0.cy;
	                var sliceTop = d3.select(this);
	                var slicePath = sliceTop.selectAll('path.surface').data([pt]);
	
	                slicePath.enter().append('path')
	                    .classed('surface', true)
	                    .style({'pointer-events': 'all'});
	
	                sliceTop.call(attachFxHandlers, gd, cd);
	
	                var shape =
	                    'M' + (cx + pt.TR[0]) + ',' + (cy + pt.TR[1]) +
	                    line(pt.TR, pt.BR) +
	                    line(pt.BR, pt.BL) +
	                    line(pt.BL, pt.TL) +
	                    'Z';
	
	                slicePath.attr('d', shape);
	
	                // add text
	                piePlot.formatSliceLabel(gd, pt, cd0);
	                var textPosition = pieHelpers.castOption(trace.textposition, pt.pts);
	                var sliceTextGroup = sliceTop.selectAll('g.slicetext')
	                    .data(pt.text && (textPosition !== 'none') ? [0] : []);
	
	                sliceTextGroup.enter().append('g')
	                    .classed('slicetext', true);
	                sliceTextGroup.exit().remove();
	
	                sliceTextGroup.each(function() {
	                    var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
	                        // prohibit tex interpretation until we can handle
	                        // tex and regular text together
	                        s.attr('data-notex', 1);
	                    });
	
	                    sliceText.text(pt.text)
	                        .attr({
	                            'class': 'slicetext',
	                            transform: '',
	                            'text-anchor': 'middle'
	                        })
	                        .call(Drawing.font, determineInsideTextFont(trace, pt, gd._fullLayout.font))
	                        .call(svgTextUtils.convertToTspans, gd);
	
	                    // position the text relative to the slice
	                    var textBB = Drawing.bBox(sliceText.node());
	                    var transform;
	
	                    var x0, x1;
	                    var y0 = Math.min(pt.BL[1], pt.BR[1]);
	                    var y1 = Math.max(pt.TL[1], pt.TR[1]);
	
	                    x0 = Math.max(pt.TL[0], pt.BL[0]);
	                    x1 = Math.min(pt.TR[0], pt.BR[0]);
	
	                    transform = Lib.getTextTransform(toMoveInsideBar(x0, x1, y0, y1, textBB, {
	                        isHorizontal: true,
	                        constrained: true,
	                        angle: 0,
	                        anchor: 'middle'
	                    }));
	
	                    sliceText.attr('transform',
	                        'translate(' + cx + ',' + cy + ')' + transform
	                    );
	                });
	            });
	
	            // add the title
	            var titleTextGroup = d3.select(this).selectAll('g.titletext')
	                .data(trace.title.text ? [0] : []);
	
	            titleTextGroup.enter().append('g')
	                .classed('titletext', true);
	            titleTextGroup.exit().remove();
	
	            titleTextGroup.each(function() {
	                var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
	                    // prohibit tex interpretation as above
	                    s.attr('data-notex', 1);
	                });
	
	                var txt = trace.title.text;
	                if(trace._meta) {
	                    txt = Lib.templateString(txt, trace._meta);
	                }
	
	                titleText.text(txt)
	                    .attr({
	                        'class': 'titletext',
	                        transform: '',
	                        'text-anchor': 'middle',
	                    })
	                .call(Drawing.font, trace.title.font)
	                .call(svgTextUtils.convertToTspans, gd);
	
	                var transform = positionTitleOutside(cd0, fullLayout._size);
	
	                titleText.attr('transform',
	                    'translate(' + transform.x + ',' + transform.y + ')' +
	                    (transform.scale < 1 ? ('scale(' + transform.scale + ')') : '') +
	                    'translate(' + transform.tx + ',' + transform.ty + ')');
	            });
	        });
	    });
	};
	
	function line(a, b) {
	    var dx = b[0] - a[0];
	    var dy = b[1] - a[1];
	
	    return 'l' + dx + ',' + dy;
	}
	
	function getBetween(a, b) {
	    return [
	        0.5 * (a[0] + b[0]),
	        0.5 * (a[1] + b[1])
	    ];
	}
	
	function setCoords(cd) {
	    if(!cd.length) return;
	
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	
	    var aspectratio = trace.aspectratio;
	
	    var h = trace.baseratio;
	    if(h > 0.999) h = 0.999; // TODO: may handle this case separately
	    var h2 = Math.pow(h, 2);
	
	    var v1 = cd0.vTotal;
	    var v0 = v1 * h2 / (1 - h2);
	
	    var totalValues = v1;
	    var sumSteps = v0 / v1;
	
	    function calcPos() {
	        var q = Math.sqrt(sumSteps);
	        return {
	            x: q,
	            y: -q
	        };
	    }
	
	    function getPoint() {
	        var pos = calcPos();
	        return [pos.x, pos.y];
	    }
	
	    var p;
	    var allPoints = [];
	    allPoints.push(getPoint());
	
	    var i, cdi;
	    for(i = cd.length - 1; i > -1; i--) {
	        cdi = cd[i];
	        if(cdi.hidden) continue;
	
	        var step = cdi.v / totalValues;
	        sumSteps += step;
	
	        allPoints.push(getPoint());
	    }
	
	    var minY = Infinity;
	    var maxY = -Infinity;
	    for(i = 0; i < allPoints.length; i++) {
	        p = allPoints[i];
	        minY = Math.min(minY, p[1]);
	        maxY = Math.max(maxY, p[1]);
	    }
	
	    // center the shape
	    for(i = 0; i < allPoints.length; i++) {
	        allPoints[i][1] -= (maxY + minY) / 2;
	    }
	
	    var lastX = allPoints[allPoints.length - 1][0];
	
	    // get pie r
	    var r = cd0.r;
	
	    var rY = (maxY - minY) / 2;
	    var scaleX = r / lastX;
	    var scaleY = r / rY * aspectratio;
	
	    // set funnelarea r
	    cd0.r = scaleY * rY;
	
	    // scale the shape
	    for(i = 0; i < allPoints.length; i++) {
	        allPoints[i][0] *= scaleX;
	        allPoints[i][1] *= scaleY;
	    }
	
	    // record first position
	    p = allPoints[0];
	    var prevLeft = [-p[0], p[1]];
	    var prevRight = [p[0], p[1]];
	
	    var n = 0; // note we skip the very first point.
	    for(i = cd.length - 1; i > -1; i--) {
	        cdi = cd[i];
	        if(cdi.hidden) continue;
	
	        n += 1;
	        var x = allPoints[n][0];
	        var y = allPoints[n][1];
	
	        cdi.TL = [-x, y];
	        cdi.TR = [x, y];
	
	        cdi.BL = prevLeft;
	        cdi.BR = prevRight;
	
	        cdi.pxmid = getBetween(cdi.TR, cdi.BR);
	
	        prevLeft = cdi.TL;
	        prevRight = cdi.TR;
	    }
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../../lib/svg_text_utils":740,"../bar/plot":866,"../pie/helpers":1097,"../pie/plot":1101,"d3":164}],997:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var styleOne = _dereq_('../pie/style_one');
	
	module.exports = function style(gd) {
	    gd._fullLayout._funnelarealayer.selectAll('.trace').each(function(cd) {
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	        var traceSelection = d3.select(this);
	
	        traceSelection.style({opacity: trace.opacity});
	
	        traceSelection.selectAll('path.surface').each(function(pt) {
	            d3.select(this).call(styleOne, pt, trace);
	        });
	    });
	};
	
	},{"../pie/style_one":1103,"d3":164}],998:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = extendFlat({
	    z: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    x: extendFlat({}, scatterAttrs.x, {impliedEdits: {xtype: 'array'}}),
	    x0: extendFlat({}, scatterAttrs.x0, {impliedEdits: {xtype: 'scaled'}}),
	    dx: extendFlat({}, scatterAttrs.dx, {impliedEdits: {xtype: 'scaled'}}),
	    y: extendFlat({}, scatterAttrs.y, {impliedEdits: {ytype: 'array'}}),
	    y0: extendFlat({}, scatterAttrs.y0, {impliedEdits: {ytype: 'scaled'}}),
	    dy: extendFlat({}, scatterAttrs.dy, {impliedEdits: {ytype: 'scaled'}}),
	
	    text: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    hovertext: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    transpose: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    xtype: {
	        valType: 'enumerated',
	        values: ['array', 'scaled'],
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    ytype: {
	        valType: 'enumerated',
	        values: ['array', 'scaled'],
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    zsmooth: {
	        valType: 'enumerated',
	        values: ['fast', 'best', false],
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    hoverongaps: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'none',
	        
	    },
	    connectgaps: {
	        valType: 'boolean',
	        
	        editType: 'calc',
	        
	    },
	    xgap: {
	        valType: 'number',
	        dflt: 0,
	        min: 0,
	        
	        editType: 'plot',
	        
	    },
	    ygap: {
	        valType: 'number',
	        dflt: 0,
	        min: 0,
	        
	        editType: 'plot',
	        
	    },
	    zhoverformat: {
	        valType: 'string',
	        dflt: '',
	        
	        editType: 'none',
	        
	    },
	    hovertemplate: hovertemplateAttrs()
	}, {
	    transforms: undefined
	},
	    colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
	);
	
	},{"../../components/colorscale/attributes":598,"../../constants/docs":687,"../../lib/extend":707,"../../plots/template_attributes":840,"../scatter/attributes":1118}],999:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var histogram2dCalc = _dereq_('../histogram2d/calc');
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var convertColumnData = _dereq_('./convert_column_xyz');
	var clean2dArray = _dereq_('./clean_2d_array');
	var interp2d = _dereq_('./interp2d');
	var findEmpties = _dereq_('./find_empties');
	var makeBoundArray = _dereq_('./make_bound_array');
	
	module.exports = function calc(gd, trace) {
	    // prepare the raw data
	    // run makeCalcdata on x and y even for heatmaps, in case of category mappings
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var isContour = Registry.traceIs(trace, 'contour');
	    var isHist = Registry.traceIs(trace, 'histogram');
	    var isGL2D = Registry.traceIs(trace, 'gl2d');
	    var zsmooth = isContour ? 'best' : trace.zsmooth;
	    var x;
	    var x0;
	    var dx;
	    var y;
	    var y0;
	    var dy;
	    var z;
	    var i;
	    var binned;
	
	    // cancel minimum tick spacings (only applies to bars and boxes)
	    xa._minDtick = 0;
	    ya._minDtick = 0;
	
	    if(isHist) {
	        binned = histogram2dCalc(gd, trace);
	        x = binned.x;
	        x0 = binned.x0;
	        dx = binned.dx;
	        y = binned.y;
	        y0 = binned.y0;
	        dy = binned.dy;
	        z = binned.z;
	    } else {
	        var zIn = trace.z;
	        if(Lib.isArray1D(zIn)) {
	            convertColumnData(trace, xa, ya, 'x', 'y', ['z']);
	            x = trace._x;
	            y = trace._y;
	            zIn = trace._z;
	        } else {
	            x = trace._x = trace.x ? xa.makeCalcdata(trace, 'x') : [];
	            y = trace._y = trace.y ? ya.makeCalcdata(trace, 'y') : [];
	        }
	
	        x0 = trace.x0;
	        dx = trace.dx;
	        y0 = trace.y0;
	        dy = trace.dy;
	
	        z = clean2dArray(zIn, trace, xa, ya);
	
	        if(isContour || trace.connectgaps) {
	            trace._emptypoints = findEmpties(z);
	            interp2d(z, trace._emptypoints);
	        }
	    }
	
	    function noZsmooth(msg) {
	        zsmooth = trace._input.zsmooth = trace.zsmooth = false;
	        Lib.warn('cannot use zsmooth: "fast": ' + msg);
	    }
	
	    // check whether we really can smooth (ie all boxes are about the same size)
	    if(zsmooth === 'fast') {
	        if(xa.type === 'log' || ya.type === 'log') {
	            noZsmooth('log axis found');
	        } else if(!isHist) {
	            if(x.length) {
	                var avgdx = (x[x.length - 1] - x[0]) / (x.length - 1);
	                var maxErrX = Math.abs(avgdx / 100);
	                for(i = 0; i < x.length - 1; i++) {
	                    if(Math.abs(x[i + 1] - x[i] - avgdx) > maxErrX) {
	                        noZsmooth('x scale is not linear');
	                        break;
	                    }
	                }
	            }
	            if(y.length && zsmooth === 'fast') {
	                var avgdy = (y[y.length - 1] - y[0]) / (y.length - 1);
	                var maxErrY = Math.abs(avgdy / 100);
	                for(i = 0; i < y.length - 1; i++) {
	                    if(Math.abs(y[i + 1] - y[i] - avgdy) > maxErrY) {
	                        noZsmooth('y scale is not linear');
	                        break;
	                    }
	                }
	            }
	        }
	    }
	
	    // create arrays of brick boundaries, to be used by autorange and heatmap.plot
	    var xlen = Lib.maxRowLength(z);
	    var xIn = trace.xtype === 'scaled' ? '' : x;
	    var xArray = makeBoundArray(trace, xIn, x0, dx, xlen, xa);
	    var yIn = trace.ytype === 'scaled' ? '' : y;
	    var yArray = makeBoundArray(trace, yIn, y0, dy, z.length, ya);
	
	    // handled in gl2d convert step
	    if(!isGL2D) {
	        trace._extremes[xa._id] = Axes.findExtremes(xa, xArray);
	        trace._extremes[ya._id] = Axes.findExtremes(ya, yArray);
	    }
	
	    var cd0 = {
	        x: xArray,
	        y: yArray,
	        z: z,
	        text: trace._text || trace.text,
	        hovertext: trace._hovertext || trace.hovertext
	    };
	
	    if(xIn && xIn.length === xArray.length - 1) cd0.xCenter = xIn;
	    if(yIn && yIn.length === yArray.length - 1) cd0.yCenter = yIn;
	
	    if(isHist) {
	        cd0.xRanges = binned.xRanges;
	        cd0.yRanges = binned.yRanges;
	        cd0.pts = binned.pts;
	    }
	
	    if(!isContour) {
	        colorscaleCalc(gd, trace, {vals: z, cLetter: 'z'});
	    }
	
	    if(isContour && trace.contours && trace.contours.coloring === 'heatmap') {
	        var dummyTrace = {
	            type: trace.type === 'contour' ? 'heatmap' : 'histogram2d',
	            xcalendar: trace.xcalendar,
	            ycalendar: trace.ycalendar
	        };
	        cd0.xfill = makeBoundArray(dummyTrace, xIn, x0, dx, xlen, xa);
	        cd0.yfill = makeBoundArray(dummyTrace, yIn, y0, dy, z.length, ya);
	    }
	
	    return [cd0];
	};
	
	},{"../../components/colorscale/calc":599,"../../lib":716,"../../plots/cartesian/axes":764,"../../registry":845,"../histogram2d/calc":1030,"./clean_2d_array":1000,"./convert_column_xyz":1002,"./find_empties":1004,"./interp2d":1007,"./make_bound_array":1008}],1000:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var Lib = _dereq_('../../lib');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function clean2dArray(zOld, trace, xa, ya) {
	    var rowlen, collen, getCollen, old2new, i, j;
	
	    function cleanZvalue(v) {
	        if(!isNumeric(v)) return undefined;
	        return +v;
	    }
	
	    if(trace && trace.transpose) {
	        rowlen = 0;
	        for(i = 0; i < zOld.length; i++) rowlen = Math.max(rowlen, zOld[i].length);
	        if(rowlen === 0) return false;
	        getCollen = function(zOld) { return zOld.length; };
	        old2new = function(zOld, i, j) { return (zOld[j] || [])[i]; };
	    } else {
	        rowlen = zOld.length;
	        getCollen = function(zOld, i) { return zOld[i].length; };
	        old2new = function(zOld, i, j) { return (zOld[i] || [])[j]; };
	    }
	
	    var padOld2new = function(zOld, i, j) {
	        if(i === BADNUM || j === BADNUM) return BADNUM;
	        return old2new(zOld, i, j);
	    };
	
	    function axisMapping(ax) {
	        if(trace && trace.type !== 'carpet' && trace.type !== 'contourcarpet' &&
	            ax && ax.type === 'category' && trace['_' + ax._id.charAt(0)].length) {
	            var axLetter = ax._id.charAt(0);
	            var axMapping = {};
	            var traceCategories = trace['_' + axLetter + 'CategoryMap'] || trace[axLetter];
	            for(i = 0; i < traceCategories.length; i++) {
	                axMapping[traceCategories[i]] = i;
	            }
	            return function(i) {
	                var ind = axMapping[ax._categories[i]];
	                return ind + 1 ? ind : BADNUM;
	            };
	        } else {
	            return Lib.identity;
	        }
	    }
	
	    var xMap = axisMapping(xa);
	    var yMap = axisMapping(ya);
	
	    if(ya && ya.type === 'category') rowlen = ya._categories.length;
	    var zNew = new Array(rowlen);
	
	    for(i = 0; i < rowlen; i++) {
	        if(xa && xa.type === 'category') {
	            collen = xa._categories.length;
	        } else {
	            collen = getCollen(zOld, i);
	        }
	        zNew[i] = new Array(collen);
	        for(j = 0; j < collen; j++) zNew[i][j] = cleanZvalue(padOld2new(zOld, yMap(i), xMap(j)));
	    }
	
	    return zNew;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"fast-isnumeric":227}],1001:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    min: 'zmin',
	    max: 'zmax'
	};
	
	},{}],1002:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function convertColumnData(trace, ax1, ax2, var1Name, var2Name, arrayVarNames) {
	    var colLen = trace._length;
	    var col1 = ax1.makeCalcdata(trace, var1Name);
	    var col2 = ax2.makeCalcdata(trace, var2Name);
	    var textCol = trace.text;
	    var hasColumnText = (textCol !== undefined && Lib.isArray1D(textCol));
	    var hoverTextCol = trace.hovertext;
	    var hasColumnHoverText = (hoverTextCol !== undefined && Lib.isArray1D(hoverTextCol));
	    var i, j;
	
	    var col1dv = Lib.distinctVals(col1);
	    var col1vals = col1dv.vals;
	    var col2dv = Lib.distinctVals(col2);
	    var col2vals = col2dv.vals;
	    var newArrays = [];
	    var text;
	    var hovertext;
	
	    for(i = 0; i < arrayVarNames.length; i++) {
	        newArrays[i] = Lib.init2dArray(col2vals.length, col1vals.length);
	    }
	
	    if(hasColumnText) {
	        text = Lib.init2dArray(col2vals.length, col1vals.length);
	    }
	    if(hasColumnHoverText) {
	        hovertext = Lib.init2dArray(col2vals.length, col1vals.length);
	    }
	
	    for(i = 0; i < colLen; i++) {
	        if(col1[i] !== BADNUM && col2[i] !== BADNUM) {
	            var i1 = Lib.findBin(col1[i] + col1dv.minDiff / 2, col1vals);
	            var i2 = Lib.findBin(col2[i] + col2dv.minDiff / 2, col2vals);
	
	            for(j = 0; j < arrayVarNames.length; j++) {
	                var arrayVarName = arrayVarNames[j];
	                var arrayVar = trace[arrayVarName];
	                var newArray = newArrays[j];
	                newArray[i2][i1] = arrayVar[i];
	            }
	
	            if(hasColumnText) text[i2][i1] = textCol[i];
	            if(hasColumnHoverText) hovertext[i2][i1] = hoverTextCol[i];
	        }
	    }
	
	    trace['_' + var1Name] = col1vals;
	    trace['_' + var2Name] = col2vals;
	    for(j = 0; j < arrayVarNames.length; j++) {
	        trace['_' + arrayVarNames[j]] = newArrays[j];
	    }
	    if(hasColumnText) trace._text = text;
	    if(hasColumnHoverText) trace._hovertext = hovertext;
	
	    if(ax1 && ax1.type === 'category') {
	        trace['_' + var1Name + 'CategoryMap'] = col1vals.map(function(v) { return ax1._categories[v];});
	    }
	
	    if(ax2 && ax2.type === 'category') {
	        trace['_' + var2Name + 'CategoryMap'] = col2vals.map(function(v) { return ax2._categories[v];});
	    }
	};
	
	},{"../../constants/numerical":692,"../../lib":716}],1003:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleXYZDefaults = _dereq_('./xyz_defaults');
	var handleStyleDefaults = _dereq_('./style_defaults');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	    if(!validData) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    handleStyleDefaults(traceIn, traceOut, coerce, layout);
	
	    coerce('hoverongaps');
	    coerce('connectgaps', Lib.isArray1D(traceOut.z) && (traceOut.zsmooth !== false));
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":998,"./style_defaults":1011,"./xyz_defaults":1012}],1004:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var maxRowLength = _dereq_('../../lib').maxRowLength;
	
	/* Return a list of empty points in 2D array z
	 * each empty point z[i][j] gives an array [i, j, neighborCount]
	 * neighborCount is the count of 4 nearest neighbors that DO exist
	 * this is to give us an order of points to evaluate for interpolation.
	 * if no neighbors exist, we iteratively look for neighbors that HAVE
	 * neighbors, and add a fractional neighborCount
	 */
	module.exports = function findEmpties(z) {
	    var empties = [];
	    var neighborHash = {};
	    var noNeighborList = [];
	    var nextRow = z[0];
	    var row = [];
	    var blank = [0, 0, 0];
	    var rowLength = maxRowLength(z);
	    var prevRow;
	    var i;
	    var j;
	    var thisPt;
	    var p;
	    var neighborCount;
	    var newNeighborHash;
	    var foundNewNeighbors;
	
	    for(i = 0; i < z.length; i++) {
	        prevRow = row;
	        row = nextRow;
	        nextRow = z[i + 1] || [];
	        for(j = 0; j < rowLength; j++) {
	            if(row[j] === undefined) {
	                neighborCount = (row[j - 1] !== undefined ? 1 : 0) +
	                    (row[j + 1] !== undefined ? 1 : 0) +
	                    (prevRow[j] !== undefined ? 1 : 0) +
	                    (nextRow[j] !== undefined ? 1 : 0);
	
	                if(neighborCount) {
	                    // for this purpose, don't count off-the-edge points
	                    // as undefined neighbors
	                    if(i === 0) neighborCount++;
	                    if(j === 0) neighborCount++;
	                    if(i === z.length - 1) neighborCount++;
	                    if(j === row.length - 1) neighborCount++;
	
	                    // if all neighbors that could exist do, we don't
	                    // need this for finding farther neighbors
	                    if(neighborCount < 4) {
	                        neighborHash[[i, j]] = [i, j, neighborCount];
	                    }
	
	                    empties.push([i, j, neighborCount]);
	                } else noNeighborList.push([i, j]);
	            }
	        }
	    }
	
	    while(noNeighborList.length) {
	        newNeighborHash = {};
	        foundNewNeighbors = false;
	
	        // look for cells that now have neighbors but didn't before
	        for(p = noNeighborList.length - 1; p >= 0; p--) {
	            thisPt = noNeighborList[p];
	            i = thisPt[0];
	            j = thisPt[1];
	
	            neighborCount = ((neighborHash[[i - 1, j]] || blank)[2] +
	                (neighborHash[[i + 1, j]] || blank)[2] +
	                (neighborHash[[i, j - 1]] || blank)[2] +
	                (neighborHash[[i, j + 1]] || blank)[2]) / 20;
	
	            if(neighborCount) {
	                newNeighborHash[thisPt] = [i, j, neighborCount];
	                noNeighborList.splice(p, 1);
	                foundNewNeighbors = true;
	            }
	        }
	
	        if(!foundNewNeighbors) {
	            throw 'findEmpties iterated with no new neighbors';
	        }
	
	        // put these new cells into the main neighbor list
	        for(thisPt in newNeighborHash) {
	            neighborHash[thisPt] = newNeighborHash[thisPt];
	            empties.push(newNeighborHash[thisPt]);
	        }
	    }
	
	    // sort the full list in descending order of neighbor count
	    return empties.sort(function(a, b) { return b[2] - a[2]; });
	};
	
	},{"../../lib":716}],1005:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer, contour) {
	    var cd0 = pointData.cd[0];
	    var trace = cd0.trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var x = cd0.x;
	    var y = cd0.y;
	    var z = cd0.z;
	    var xc = cd0.xCenter;
	    var yc = cd0.yCenter;
	    var zmask = cd0.zmask;
	    var zhoverformat = trace.zhoverformat;
	    var x2 = x;
	    var y2 = y;
	
	    var xl, yl, nx, ny;
	
	    if(pointData.index !== false) {
	        try {
	            nx = Math.round(pointData.index[1]);
	            ny = Math.round(pointData.index[0]);
	        } catch(e) {
	            Lib.error('Error hovering on heatmap, ' +
	                'pointNumber must be [row,col], found:', pointData.index);
	            return;
	        }
	        if(nx < 0 || nx >= z[0].length || ny < 0 || ny > z.length) {
	            return;
	        }
	    } else if(Fx.inbox(xval - x[0], xval - x[x.length - 1], 0) > 0 ||
	            Fx.inbox(yval - y[0], yval - y[y.length - 1], 0) > 0) {
	        return;
	    } else {
	        if(contour) {
	            var i2;
	            x2 = [2 * x[0] - x[1]];
	
	            for(i2 = 1; i2 < x.length; i2++) {
	                x2.push((x[i2] + x[i2 - 1]) / 2);
	            }
	            x2.push([2 * x[x.length - 1] - x[x.length - 2]]);
	
	            y2 = [2 * y[0] - y[1]];
	            for(i2 = 1; i2 < y.length; i2++) {
	                y2.push((y[i2] + y[i2 - 1]) / 2);
	            }
	            y2.push([2 * y[y.length - 1] - y[y.length - 2]]);
	        }
	        nx = Math.max(0, Math.min(x2.length - 2, Lib.findBin(xval, x2)));
	        ny = Math.max(0, Math.min(y2.length - 2, Lib.findBin(yval, y2)));
	    }
	
	    var x0 = xa.c2p(x[nx]);
	    var x1 = xa.c2p(x[nx + 1]);
	    var y0 = ya.c2p(y[ny]);
	    var y1 = ya.c2p(y[ny + 1]);
	
	    if(contour) {
	        x1 = x0;
	        xl = x[nx];
	        y1 = y0;
	        yl = y[ny];
	    } else {
	        xl = xc ? xc[nx] : ((x[nx] + x[nx + 1]) / 2);
	        yl = yc ? yc[ny] : ((y[ny] + y[ny + 1]) / 2);
	
	        if(xa && xa.type === 'category') xl = x[nx];
	        if(ya && ya.type === 'category') yl = y[ny];
	
	        if(trace.zsmooth) {
	            x0 = x1 = xa.c2p(xl);
	            y0 = y1 = ya.c2p(yl);
	        }
	    }
	
	    var zVal = z[ny][nx];
	    if(zmask && !zmask[ny][nx]) zVal = undefined;
	
	    if(zVal === undefined && !trace.hoverongaps) return;
	
	    var text;
	    if(Array.isArray(cd0.hovertext) && Array.isArray(cd0.hovertext[ny])) {
	        text = cd0.hovertext[ny][nx];
	    } else if(Array.isArray(cd0.text) && Array.isArray(cd0.text[ny])) {
	        text = cd0.text[ny][nx];
	    }
	
	    // dummy axis for formatting the z value
	    var cOpts = extractOpts(trace);
	    var dummyAx = {
	        type: 'linear',
	        range: [cOpts.min, cOpts.max],
	        hoverformat: zhoverformat,
	        _separators: xa._separators,
	        _numFormat: xa._numFormat
	    };
	    var zLabel = Axes.tickText(dummyAx, zVal, 'hover').text;
	
	    return [Lib.extendFlat(pointData, {
	        index: [ny, nx],
	        // never let a 2D override 1D type as closest point
	        distance: pointData.maxHoverDistance,
	        spikeDistance: pointData.maxSpikeDistance,
	        x0: x0,
	        x1: x1,
	        y0: y0,
	        y1: y1,
	        xLabelVal: xl,
	        yLabelVal: yl,
	        zLabelVal: zVal,
	        zLabel: zLabel,
	        text: text
	    })];
	};
	
	},{"../../components/colorscale":603,"../../components/fx":629,"../../lib":716,"../../plots/cartesian/axes":764}],1006:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    colorbar: _dereq_('./colorbar'),
	    style: _dereq_('./style'),
	    hoverPoints: _dereq_('./hover'),
	
	    moduleType: 'trace',
	    name: 'heatmap',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', '2dMap'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./attributes":998,"./calc":999,"./colorbar":1001,"./defaults":1003,"./hover":1005,"./plot":1009,"./style":1010}],1007:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var INTERPTHRESHOLD = 1e-2;
	var NEIGHBORSHIFTS = [[-1, 0], [1, 0], [0, -1], [0, 1]];
	
	function correctionOvershoot(maxFractionalChange) {
	    // start with less overshoot, until we know it's converging,
	    // then ramp up the overshoot for faster convergence
	    return 0.5 - 0.25 * Math.min(1, maxFractionalChange * 0.5);
	}
	
	/*
	 * interp2d: Fill in missing data from a 2D array using an iterative
	 *   poisson equation solver with zero-derivative BC at edges.
	 *   Amazingly, this just amounts to repeatedly averaging all the existing
	 *   nearest neighbors, at least if we don't take x/y scaling into account,
	 *   which is the right approach here where x and y may not even have the
	 *   same units.
	 *
	 * @param {array of arrays} z
	 *      The 2D array to fill in. Will be mutated here. Assumed to already be
	 *      cleaned, so all entries are numbers except gaps, which are `undefined`.
	 * @param {array of arrays} emptyPoints
	 *      Each entry [i, j, neighborCount] for empty points z[i][j] and the number
	 *      of neighbors that are *not* missing. Assumed to be sorted from most to
	 *      least neighbors, as produced by heatmap/find_empties.
	 */
	module.exports = function interp2d(z, emptyPoints) {
	    var maxFractionalChange = 1;
	    var i;
	
	    // one pass to fill in a starting value for all the empties
	    iterateInterp2d(z, emptyPoints);
	
	    // we're don't need to iterate lone empties - remove them
	    for(i = 0; i < emptyPoints.length; i++) {
	        if(emptyPoints[i][2] < 4) break;
	    }
	    // but don't remove these points from the original array,
	    // we'll use them for masking, so make a copy.
	    emptyPoints = emptyPoints.slice(i);
	
	    for(i = 0; i < 100 && maxFractionalChange > INTERPTHRESHOLD; i++) {
	        maxFractionalChange = iterateInterp2d(z, emptyPoints,
	            correctionOvershoot(maxFractionalChange));
	    }
	    if(maxFractionalChange > INTERPTHRESHOLD) {
	        Lib.log('interp2d didn\'t converge quickly', maxFractionalChange);
	    }
	
	    return z;
	};
	
	function iterateInterp2d(z, emptyPoints, overshoot) {
	    var maxFractionalChange = 0;
	    var thisPt;
	    var i;
	    var j;
	    var p;
	    var q;
	    var neighborShift;
	    var neighborRow;
	    var neighborVal;
	    var neighborCount;
	    var neighborSum;
	    var initialVal;
	    var minNeighbor;
	    var maxNeighbor;
	
	    for(p = 0; p < emptyPoints.length; p++) {
	        thisPt = emptyPoints[p];
	        i = thisPt[0];
	        j = thisPt[1];
	        initialVal = z[i][j];
	        neighborSum = 0;
	        neighborCount = 0;
	
	        for(q = 0; q < 4; q++) {
	            neighborShift = NEIGHBORSHIFTS[q];
	            neighborRow = z[i + neighborShift[0]];
	            if(!neighborRow) continue;
	            neighborVal = neighborRow[j + neighborShift[1]];
	            if(neighborVal !== undefined) {
	                if(neighborSum === 0) {
	                    minNeighbor = maxNeighbor = neighborVal;
	                } else {
	                    minNeighbor = Math.min(minNeighbor, neighborVal);
	                    maxNeighbor = Math.max(maxNeighbor, neighborVal);
	                }
	                neighborCount++;
	                neighborSum += neighborVal;
	            }
	        }
	
	        if(neighborCount === 0) {
	            throw 'iterateInterp2d order is wrong: no defined neighbors';
	        }
	
	        // this is the laplace equation interpolation:
	        // each point is just the average of its neighbors
	        // note that this ignores differential x/y scaling
	        // which I think is the right approach, since we
	        // don't know what that scaling means
	        z[i][j] = neighborSum / neighborCount;
	
	        if(initialVal === undefined) {
	            if(neighborCount < 4) maxFractionalChange = 1;
	        } else {
	            // we can make large empty regions converge faster
	            // if we overshoot the change vs the previous value
	            z[i][j] = (1 + overshoot) * z[i][j] - overshoot * initialVal;
	
	            if(maxNeighbor > minNeighbor) {
	                maxFractionalChange = Math.max(maxFractionalChange,
	                    Math.abs(z[i][j] - initialVal) / (maxNeighbor - minNeighbor));
	            }
	        }
	    }
	
	    return maxFractionalChange;
	}
	
	},{"../../lib":716}],1008:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	module.exports = function makeBoundArray(trace, arrayIn, v0In, dvIn, numbricks, ax) {
	    var arrayOut = [];
	    var isContour = Registry.traceIs(trace, 'contour');
	    var isHist = Registry.traceIs(trace, 'histogram');
	    var isGL2D = Registry.traceIs(trace, 'gl2d');
	    var v0;
	    var dv;
	    var i;
	
	    var isArrayOfTwoItemsOrMore = isArrayOrTypedArray(arrayIn) && arrayIn.length > 1;
	
	    if(isArrayOfTwoItemsOrMore && !isHist && (ax.type !== 'category')) {
	        var len = arrayIn.length;
	
	        // given vals are brick centers
	        // hopefully length === numbricks, but use this method even if too few are supplied
	        // and extend it linearly based on the last two points
	        if(len <= numbricks) {
	            // contour plots only want the centers
	            if(isContour || isGL2D) arrayOut = arrayIn.slice(0, numbricks);
	            else if(numbricks === 1) {
	                arrayOut = [arrayIn[0] - 0.5, arrayIn[0] + 0.5];
	            } else {
	                arrayOut = [1.5 * arrayIn[0] - 0.5 * arrayIn[1]];
	
	                for(i = 1; i < len; i++) {
	                    arrayOut.push((arrayIn[i - 1] + arrayIn[i]) * 0.5);
	                }
	
	                arrayOut.push(1.5 * arrayIn[len - 1] - 0.5 * arrayIn[len - 2]);
	            }
	
	            if(len < numbricks) {
	                var lastPt = arrayOut[arrayOut.length - 1];
	                var delta = lastPt - arrayOut[arrayOut.length - 2];
	
	                for(i = len; i < numbricks; i++) {
	                    lastPt += delta;
	                    arrayOut.push(lastPt);
	                }
	            }
	        } else {
	            // hopefully length === numbricks+1, but do something regardless:
	            // given vals are brick boundaries
	            return isContour ?
	                arrayIn.slice(0, numbricks) :  // we must be strict for contours
	                arrayIn.slice(0, numbricks + 1);
	        }
	    } else {
	        var calendar = trace[ax._id.charAt(0) + 'calendar'];
	
	        if(isHist) {
	            v0 = ax.r2c(v0In, 0, calendar);
	        } else {
	            if(isArrayOrTypedArray(arrayIn) && arrayIn.length === 1) {
	                v0 = arrayIn[0];
	            } else if(v0In === undefined) {
	                v0 = 0;
	            } else {
	                var fn = ax.type === 'log' ? ax.d2c : ax.r2c;
	                v0 = fn(v0In, 0, calendar);
	            }
	        }
	
	        dv = dvIn || 1;
	
	        for(i = (isContour || isGL2D) ? 0 : -0.5; i < numbricks; i++) {
	            arrayOut.push(v0 + dv * i);
	        }
	    }
	
	    return arrayOut;
	};
	
	},{"../../lib":716,"../../registry":845}],1009:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var makeColorScaleFuncFromTrace = _dereq_('../../components/colorscale').makeColorScaleFuncFromTrace;
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	
	module.exports = function(gd, plotinfo, cdheatmaps, heatmapLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(heatmapLayer, cdheatmaps, 'hm').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        var z = cd0.z;
	        var x = cd0.x;
	        var y = cd0.y;
	        var xc = cd0.xCenter;
	        var yc = cd0.yCenter;
	        var isContour = Registry.traceIs(trace, 'contour');
	        var zsmooth = isContour ? 'best' : trace.zsmooth;
	
	        // get z dims
	        var m = z.length;
	        var n = Lib.maxRowLength(z);
	        var xrev = false;
	        var yrev = false;
	
	        var left, right, temp, top, bottom, i;
	
	        // TODO: if there are multiple overlapping categorical heatmaps,
	        // or if we allow category sorting, then the categories may not be
	        // sequential... may need to reorder and/or expand z
	
	        // Get edges of png in pixels (xa.c2p() maps axes coordinates to pixel coordinates)
	        // figure out if either axis is reversed (y is usually reversed, in pixel coords)
	        // also clip the image to maximum 50% outside the visible plot area
	        // bigger image lets you pan more naturally, but slows performance.
	        // TODO: use low-resolution images outside the visible plot for panning
	        // these while loops find the first and last brick bounds that are defined
	        // (in case of log of a negative)
	        i = 0;
	        while(left === undefined && i < x.length - 1) {
	            left = xa.c2p(x[i]);
	            i++;
	        }
	        i = x.length - 1;
	        while(right === undefined && i > 0) {
	            right = xa.c2p(x[i]);
	            i--;
	        }
	
	        if(right < left) {
	            temp = right;
	            right = left;
	            left = temp;
	            xrev = true;
	        }
	
	        i = 0;
	        while(top === undefined && i < y.length - 1) {
	            top = ya.c2p(y[i]);
	            i++;
	        }
	        i = y.length - 1;
	        while(bottom === undefined && i > 0) {
	            bottom = ya.c2p(y[i]);
	            i--;
	        }
	
	        if(bottom < top) {
	            temp = top;
	            top = bottom;
	            bottom = temp;
	            yrev = true;
	        }
	
	        // for contours with heatmap fill, we generate the boundaries based on
	        // brick centers but then use the brick edges for drawing the bricks
	        if(isContour) {
	            xc = x;
	            yc = y;
	            x = cd0.xfill;
	            y = cd0.yfill;
	        }
	
	        // make an image that goes at most half a screen off either side, to keep
	        // time reasonable when you zoom in. if zsmooth is true/fast, don't worry
	        // about this, because zooming doesn't increase number of pixels
	        // if zsmooth is best, don't include anything off screen because it takes too long
	        if(zsmooth !== 'fast') {
	            var extra = zsmooth === 'best' ? 0 : 0.5;
	            left = Math.max(-extra * xa._length, left);
	            right = Math.min((1 + extra) * xa._length, right);
	            top = Math.max(-extra * ya._length, top);
	            bottom = Math.min((1 + extra) * ya._length, bottom);
	        }
	
	        var imageWidth = Math.round(right - left);
	        var imageHeight = Math.round(bottom - top);
	
	        // setup image nodes
	
	        // if image is entirely off-screen, don't even draw it
	        var isOffScreen = (imageWidth <= 0 || imageHeight <= 0);
	
	        if(isOffScreen) {
	            var noImage = plotGroup.selectAll('image').data([]);
	            noImage.exit().remove();
	            return;
	        }
	
	        // generate image data
	
	        var canvasW, canvasH;
	        if(zsmooth === 'fast') {
	            canvasW = n;
	            canvasH = m;
	        } else {
	            canvasW = imageWidth;
	            canvasH = imageHeight;
	        }
	
	        var canvas = document.createElement('canvas');
	        canvas.width = canvasW;
	        canvas.height = canvasH;
	        var context = canvas.getContext('2d');
	
	        var sclFunc = makeColorScaleFuncFromTrace(trace, {noNumericCheck: true, returnArray: true});
	
	        // map brick boundaries to image pixels
	        var xpx,
	            ypx;
	        if(zsmooth === 'fast') {
	            xpx = xrev ?
	                function(index) { return n - 1 - index; } :
	                Lib.identity;
	            ypx = yrev ?
	                function(index) { return m - 1 - index; } :
	                Lib.identity;
	        } else {
	            xpx = function(index) {
	                return Lib.constrain(Math.round(xa.c2p(x[index]) - left),
	                    0, imageWidth);
	            };
	            ypx = function(index) {
	                return Lib.constrain(Math.round(ya.c2p(y[index]) - top),
	                    0, imageHeight);
	            };
	        }
	
	        // build the pixel map brick-by-brick
	        // cruise through z-matrix row-by-row
	        // build a brick at each z-matrix value
	        var yi = ypx(0);
	        var yb = [yi, yi];
	        var xbi = xrev ? 0 : 1;
	        var ybi = yrev ? 0 : 1;
	        // for collecting an average luminosity of the heatmap
	        var pixcount = 0;
	        var rcount = 0;
	        var gcount = 0;
	        var bcount = 0;
	
	        var xb, j, xi, v, row, c;
	
	        function setColor(v, pixsize) {
	            if(v !== undefined) {
	                var c = sclFunc(v);
	                c[0] = Math.round(c[0]);
	                c[1] = Math.round(c[1]);
	                c[2] = Math.round(c[2]);
	
	                pixcount += pixsize;
	                rcount += c[0] * pixsize;
	                gcount += c[1] * pixsize;
	                bcount += c[2] * pixsize;
	                return c;
	            }
	            return [0, 0, 0, 0];
	        }
	
	        function interpColor(r0, r1, xinterp, yinterp) {
	            var z00 = r0[xinterp.bin0];
	            if(z00 === undefined) return setColor(undefined, 1);
	
	            var z01 = r0[xinterp.bin1];
	            var z10 = r1[xinterp.bin0];
	            var z11 = r1[xinterp.bin1];
	            var dx = (z01 - z00) || 0;
	            var dy = (z10 - z00) || 0;
	            var dxy;
	
	            // the bilinear interpolation term needs different calculations
	            // for all the different permutations of missing data
	            // among the neighbors of the main point, to ensure
	            // continuity across brick boundaries.
	            if(z01 === undefined) {
	                if(z11 === undefined) dxy = 0;
	                else if(z10 === undefined) dxy = 2 * (z11 - z00);
	                else dxy = (2 * z11 - z10 - z00) * 2 / 3;
	            } else if(z11 === undefined) {
	                if(z10 === undefined) dxy = 0;
	                else dxy = (2 * z00 - z01 - z10) * 2 / 3;
	            } else if(z10 === undefined) dxy = (2 * z11 - z01 - z00) * 2 / 3;
	            else dxy = (z11 + z00 - z01 - z10);
	
	            return setColor(z00 + xinterp.frac * dx + yinterp.frac * (dy + xinterp.frac * dxy));
	        }
	
	        if(zsmooth) { // best or fast, works fastest with imageData
	            var pxIndex = 0;
	            var pixels;
	
	            try {
	                pixels = new Uint8Array(imageWidth * imageHeight * 4);
	            } catch(e) {
	                pixels = new Array(imageWidth * imageHeight * 4);
	            }
	
	            if(zsmooth === 'best') {
	                var xForPx = xc || x;
	                var yForPx = yc || y;
	                var xPixArray = new Array(xForPx.length);
	                var yPixArray = new Array(yForPx.length);
	                var xinterpArray = new Array(imageWidth);
	                var findInterpX = xc ? findInterpFromCenters : findInterp;
	                var findInterpY = yc ? findInterpFromCenters : findInterp;
	                var yinterp, r0, r1;
	
	                // first make arrays of x and y pixel locations of brick boundaries
	                for(i = 0; i < xForPx.length; i++) xPixArray[i] = Math.round(xa.c2p(xForPx[i]) - left);
	                for(i = 0; i < yForPx.length; i++) yPixArray[i] = Math.round(ya.c2p(yForPx[i]) - top);
	
	                // then make arrays of interpolations
	                // (bin0=closest, bin1=next, frac=fractional dist.)
	                for(i = 0; i < imageWidth; i++) xinterpArray[i] = findInterpX(i, xPixArray);
	
	                // now do the interpolations and fill the png
	                for(j = 0; j < imageHeight; j++) {
	                    yinterp = findInterpY(j, yPixArray);
	                    r0 = z[yinterp.bin0];
	                    r1 = z[yinterp.bin1];
	                    for(i = 0; i < imageWidth; i++, pxIndex += 4) {
	                        c = interpColor(r0, r1, xinterpArray[i], yinterp);
	                        putColor(pixels, pxIndex, c);
	                    }
	                }
	            } else { // zsmooth = fast
	                for(j = 0; j < m; j++) {
	                    row = z[j];
	                    yb = ypx(j);
	                    for(i = 0; i < imageWidth; i++) {
	                        c = setColor(row[i], 1);
	                        pxIndex = (yb * imageWidth + xpx(i)) * 4;
	                        putColor(pixels, pxIndex, c);
	                    }
	                }
	            }
	
	            var imageData = context.createImageData(imageWidth, imageHeight);
	            try {
	                imageData.data.set(pixels);
	            } catch(e) {
	                var pxArray = imageData.data;
	                var dlen = pxArray.length;
	                for(j = 0; j < dlen; j ++) {
	                    pxArray[j] = pixels[j];
	                }
	            }
	
	            context.putImageData(imageData, 0, 0);
	        } else { // zsmooth = false -> filling potentially large bricks works fastest with fillRect
	            // gaps do not need to be exact integers, but if they *are* we will get
	            // cleaner edges by rounding at least one edge
	            var xGap = trace.xgap;
	            var yGap = trace.ygap;
	            var xGapLeft = Math.floor(xGap / 2);
	            var yGapTop = Math.floor(yGap / 2);
	
	            for(j = 0; j < m; j++) {
	                row = z[j];
	                yb.reverse();
	                yb[ybi] = ypx(j + 1);
	                if(yb[0] === yb[1] || yb[0] === undefined || yb[1] === undefined) {
	                    continue;
	                }
	                xi = xpx(0);
	                xb = [xi, xi];
	                for(i = 0; i < n; i++) {
	                    // build one color brick!
	                    xb.reverse();
	                    xb[xbi] = xpx(i + 1);
	                    if(xb[0] === xb[1] || xb[0] === undefined || xb[1] === undefined) {
	                        continue;
	                    }
	                    v = row[i];
	                    c = setColor(v, (xb[1] - xb[0]) * (yb[1] - yb[0]));
	                    context.fillStyle = 'rgba(' + c.join(',') + ')';
	
	                    context.fillRect(xb[0] + xGapLeft, yb[0] + yGapTop,
	                        xb[1] - xb[0] - xGap, yb[1] - yb[0] - yGap);
	                }
	            }
	        }
	
	        rcount = Math.round(rcount / pixcount);
	        gcount = Math.round(gcount / pixcount);
	        bcount = Math.round(bcount / pixcount);
	        var avgColor = tinycolor('rgb(' + rcount + ',' + gcount + ',' + bcount + ')');
	
	        gd._hmpixcount = (gd._hmpixcount||0) + pixcount;
	        gd._hmlumcount = (gd._hmlumcount||0) + pixcount * avgColor.getLuminance();
	
	        var image3 = plotGroup.selectAll('image')
	            .data(cd);
	
	        image3.enter().append('svg:image').attr({
	            xmlns: xmlnsNamespaces.svg,
	            preserveAspectRatio: 'none'
	        });
	
	        image3.attr({
	            height: imageHeight,
	            width: imageWidth,
	            x: left,
	            y: top,
	            'xlink:href': canvas.toDataURL('image/png')
	        });
	    });
	};
	
	// get interpolated bin value. Returns {bin0:closest bin, frac:fractional dist to next, bin1:next bin}
	function findInterp(pixel, pixArray) {
	    var maxBin = pixArray.length - 2;
	    var bin = Lib.constrain(Lib.findBin(pixel, pixArray), 0, maxBin);
	    var pix0 = pixArray[bin];
	    var pix1 = pixArray[bin + 1];
	    var interp = Lib.constrain(bin + (pixel - pix0) / (pix1 - pix0) - 0.5, 0, maxBin);
	    var bin0 = Math.round(interp);
	    var frac = Math.abs(interp - bin0);
	
	    if(!interp || interp === maxBin || !frac) {
	        return {
	            bin0: bin0,
	            bin1: bin0,
	            frac: 0
	        };
	    }
	    return {
	        bin0: bin0,
	        frac: frac,
	        bin1: Math.round(bin0 + frac / (interp - bin0))
	    };
	}
	
	function findInterpFromCenters(pixel, centerPixArray) {
	    var maxBin = centerPixArray.length - 1;
	    var bin = Lib.constrain(Lib.findBin(pixel, centerPixArray), 0, maxBin);
	    var pix0 = centerPixArray[bin];
	    var pix1 = centerPixArray[bin + 1];
	    var frac = ((pixel - pix0) / (pix1 - pix0)) || 0;
	    if(frac <= 0) {
	        return {
	            bin0: bin,
	            bin1: bin,
	            frac: 0
	        };
	    }
	    if(frac < 0.5) {
	        return {
	            bin0: bin,
	            bin1: bin + 1,
	            frac: frac
	        };
	    }
	    return {
	        bin0: bin + 1,
	        bin1: bin,
	        frac: 1 - frac
	    };
	}
	
	function putColor(pixels, pxIndex, c) {
	    pixels[pxIndex] = c[0];
	    pixels[pxIndex + 1] = c[1];
	    pixels[pxIndex + 2] = c[2];
	    pixels[pxIndex + 3] = Math.round(c[3] * 255);
	}
	
	},{"../../components/colorscale":603,"../../constants/xmlns_namespaces":693,"../../lib":716,"../../registry":845,"d3":164,"tinycolor2":535}],1010:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	module.exports = function style(gd) {
	    d3.select(gd).selectAll('.hm image')
	        .style('opacity', function(d) {
	            return d.trace.opacity;
	        });
	};
	
	},{"d3":164}],1011:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = function handleStyleDefaults(traceIn, traceOut, coerce) {
	    var zsmooth = coerce('zsmooth');
	    if(zsmooth === false) {
	        // ensure that xgap and ygap are coerced only when zsmooth allows them to have an effect.
	        coerce('xgap');
	        coerce('ygap');
	    }
	
	    coerce('zhoverformat');
	};
	
	},{}],1012:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var Lib = _dereq_('../../lib');
	
	var Registry = _dereq_('../../registry');
	
	module.exports = function handleXYZDefaults(traceIn, traceOut, coerce, layout, xName, yName) {
	    var z = coerce('z');
	    xName = xName || 'x';
	    yName = yName || 'y';
	    var x, y;
	
	    if(z === undefined || !z.length) return 0;
	
	    if(Lib.isArray1D(traceIn.z)) {
	        x = coerce(xName);
	        y = coerce(yName);
	
	        var xlen = Lib.minRowLength(x);
	        var ylen = Lib.minRowLength(y);
	
	        // column z must be accompanied by xName and yName arrays
	        if(xlen === 0 || ylen === 0) return 0;
	
	        traceOut._length = Math.min(xlen, ylen, z.length);
	    } else {
	        x = coordDefaults(xName, coerce);
	        y = coordDefaults(yName, coerce);
	
	        // TODO put z validation elsewhere
	        if(!isValidZ(z)) return 0;
	
	        coerce('transpose');
	
	        traceOut._length = null;
	    }
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, [xName, yName], layout);
	
	    return true;
	};
	
	function coordDefaults(coordStr, coerce) {
	    var coord = coerce(coordStr);
	    var coordType = coord ? coerce(coordStr + 'type', 'array') : 'scaled';
	
	    if(coordType === 'scaled') {
	        coerce(coordStr + '0');
	        coerce('d' + coordStr);
	    }
	
	    return coord;
	}
	
	function isValidZ(z) {
	    var allRowsAreArrays = true;
	    var oneRowIsFilled = false;
	    var hasOneNumber = false;
	    var zi;
	
	    /*
	     * Without this step:
	     *
	     * hasOneNumber = false breaks contour but not heatmap
	     * allRowsAreArrays = false breaks contour but not heatmap
	     * oneRowIsFilled = false breaks both
	     */
	
	    for(var i = 0; i < z.length; i++) {
	        zi = z[i];
	        if(!Lib.isArrayOrTypedArray(zi)) {
	            allRowsAreArrays = false;
	            break;
	        }
	        if(zi.length > 0) oneRowIsFilled = true;
	        for(var j = 0; j < zi.length; j++) {
	            if(isNumeric(zi[j])) {
	                hasOneNumber = true;
	                break;
	            }
	        }
	    }
	
	    return (allRowsAreArrays && oneRowIsFilled && hasOneNumber);
	}
	
	},{"../../lib":716,"../../registry":845,"fast-isnumeric":227}],1013:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var heatmapAttrs = _dereq_('../heatmap/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var commonList = [
	    'z',
	    'x', 'x0', 'dx',
	    'y', 'y0', 'dy',
	    'text', 'transpose',
	    'xtype', 'ytype'
	];
	
	var attrs = {};
	
	for(var i = 0; i < commonList.length; i++) {
	    var k = commonList[i];
	    attrs[k] = heatmapAttrs[k];
	}
	
	extendFlat(
	    attrs,
	    colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
	);
	
	module.exports = overrideAll(attrs, 'calc', 'nested');
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../heatmap/attributes":998}],1014:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var createHeatmap2D = _dereq_('gl-heatmap2d');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var str2RGBArray = _dereq_('../../lib/str2rgbarray');
	
	
	function Heatmap(scene, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.type = 'heatmapgl';
	
	    this.name = '';
	    this.hoverinfo = 'all';
	
	    this.xData = [];
	    this.yData = [];
	    this.zData = [];
	    this.textLabels = [];
	
	    this.idToIndex = [];
	    this.bounds = [0, 0, 0, 0];
	
	    this.options = {
	        z: [],
	        x: [],
	        y: [],
	        shape: [0, 0],
	        colorLevels: [0],
	        colorValues: [0, 0, 0, 1]
	    };
	
	    this.heatmap = createHeatmap2D(scene.glplot, this.options);
	    this.heatmap._trace = this;
	}
	
	var proto = Heatmap.prototype;
	
	proto.handlePick = function(pickResult) {
	    var options = this.options;
	    var shape = options.shape;
	    var index = pickResult.pointId;
	    var xIndex = index % shape[0];
	    var yIndex = Math.floor(index / shape[0]);
	    var zIndex = index;
	
	    return {
	        trace: this,
	        dataCoord: pickResult.dataCoord,
	        traceCoord: [
	            options.x[xIndex],
	            options.y[yIndex],
	            options.z[zIndex]
	        ],
	        textLabel: this.textLabels[index],
	        name: this.name,
	        pointIndex: [yIndex, xIndex],
	        hoverinfo: this.hoverinfo
	    };
	};
	
	proto.update = function(fullTrace, calcTrace) {
	    var calcPt = calcTrace[0];
	
	    this.index = fullTrace.index;
	    this.name = fullTrace.name;
	    this.hoverinfo = fullTrace.hoverinfo;
	
	    // convert z from 2D -> 1D
	    var z = calcPt.z;
	    this.options.z = [].concat.apply([], z);
	
	    var rowLen = z[0].length;
	    var colLen = z.length;
	    this.options.shape = [rowLen, colLen];
	
	    this.options.x = calcPt.x;
	    this.options.y = calcPt.y;
	
	    var colorOptions = convertColorscale(fullTrace);
	    this.options.colorLevels = colorOptions.colorLevels;
	    this.options.colorValues = colorOptions.colorValues;
	
	    // convert text from 2D -> 1D
	    this.textLabels = [].concat.apply([], fullTrace.text);
	
	    this.heatmap.update(this.options);
	
	    var xa = this.scene.xaxis;
	    var ya = this.scene.yaxis;
	    fullTrace._extremes[xa._id] = Axes.findExtremes(xa, calcPt.x);
	    fullTrace._extremes[ya._id] = Axes.findExtremes(ya, calcPt.y);
	};
	
	proto.dispose = function() {
	    this.heatmap.dispose();
	};
	
	function convertColorscale(fullTrace) {
	    var scl = fullTrace.colorscale;
	    var zmin = fullTrace.zmin;
	    var zmax = fullTrace.zmax;
	
	    var N = scl.length;
	    var domain = new Array(N);
	    var range = new Array(4 * N);
	
	    for(var i = 0; i < N; i++) {
	        var si = scl[i];
	        var color = str2RGBArray(si[1]);
	
	        domain[i] = zmin + si[0] * (zmax - zmin);
	
	        for(var j = 0; j < 4; j++) {
	            range[(4 * i) + j] = color[j];
	        }
	    }
	
	    return {
	        colorLevels: domain,
	        colorValues: range
	    };
	}
	
	function createHeatmap(scene, fullTrace, calcTrace) {
	    var plot = new Heatmap(scene, fullTrace.uid);
	    plot.update(fullTrace, calcTrace);
	    return plot;
	}
	
	module.exports = createHeatmap;
	
	},{"../../lib/str2rgbarray":739,"../../plots/cartesian/axes":764,"gl-heatmap2d":253}],1015:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('../heatmap/defaults'),
	    colorbar: _dereq_('../heatmap/colorbar'),
	
	    calc: _dereq_('../heatmap/calc'),
	    plot: _dereq_('./convert'),
	
	    moduleType: 'trace',
	    name: 'heatmapgl',
	    basePlotModule: _dereq_('../../plots/gl2d'),
	    categories: ['gl', 'gl2d', '2dMap'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl2d":802,"../heatmap/calc":999,"../heatmap/colorbar":1001,"../heatmap/defaults":1003,"./attributes":1013,"./convert":1014}],1016:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var barAttrs = _dereq_('../bar/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var makeBinAttrs = _dereq_('./bin_attributes');
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    text: extendFlat({}, barAttrs.text, {
	        
	    }),
	    hovertext: extendFlat({}, barAttrs.hovertext, {
	        
	    }),
	    orientation: barAttrs.orientation,
	
	    histfunc: {
	        valType: 'enumerated',
	        values: ['count', 'sum', 'avg', 'min', 'max'],
	        
	        dflt: 'count',
	        editType: 'calc',
	        
	    },
	    histnorm: {
	        valType: 'enumerated',
	        values: ['', 'percent', 'probability', 'density', 'probability density'],
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	
	    cumulative: {
	        enabled: {
	            valType: 'boolean',
	            dflt: false,
	            
	            editType: 'calc',
	            
	        },
	
	        direction: {
	            valType: 'enumerated',
	            values: ['increasing', 'decreasing'],
	            dflt: 'increasing',
	            
	            editType: 'calc',
	            
	        },
	
	        currentbin: {
	            valType: 'enumerated',
	            values: ['include', 'exclude', 'half'],
	            dflt: 'include',
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    },
	    nbinsx: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    xbins: makeBinAttrs('x', true),
	
	    nbinsy: {
	        valType: 'integer',
	        min: 0,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    ybins: makeBinAttrs('y', true),
	    autobinx: {
	        valType: 'boolean',
	        dflt: null,
	        
	        editType: 'calc',
	        
	    },
	    autobiny: {
	        valType: 'boolean',
	        dflt: null,
	        
	        editType: 'calc',
	        
	    },
	
	    bingroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    marker: barAttrs.marker,
	
	    offsetgroup: barAttrs.offsetgroup,
	    alignmentgroup: barAttrs.alignmentgroup,
	
	    selected: barAttrs.selected,
	    unselected: barAttrs.unselected,
	
	    _deprecated: {
	        bardir: barAttrs._deprecated.bardir
	    }
	};
	
	},{"../../lib/extend":707,"../../plots/template_attributes":840,"../bar/attributes":855,"./bin_attributes":1018,"./constants":1022}],1017:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = function doAvg(size, counts) {
	    var nMax = size.length;
	    var total = 0;
	    for(var i = 0; i < nMax; i++) {
	        if(counts[i]) {
	            size[i] /= counts[i];
	            total += size[i];
	        } else size[i] = null;
	    }
	    return total;
	};
	
	},{}],1018:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function makeBinAttrs(axLetter, match) {
	    return {
	        start: {
	            valType: 'any', // for date axes
	            
	            editType: 'calc',
	            
	        },
	        end: {
	            valType: 'any', // for date axes
	            
	            editType: 'calc',
	            
	        },
	        size: {
	            valType: 'any', // for date axes
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    };
	};
	
	},{}],1019:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	
	module.exports = {
	    count: function(n, i, size) {
	        size[n]++;
	        return 1;
	    },
	
	    sum: function(n, i, size, counterData) {
	        var v = counterData[i];
	        if(isNumeric(v)) {
	            v = Number(v);
	            size[n] += v;
	            return v;
	        }
	        return 0;
	    },
	
	    avg: function(n, i, size, counterData, counts) {
	        var v = counterData[i];
	        if(isNumeric(v)) {
	            v = Number(v);
	            size[n] += v;
	            counts[n]++;
	        }
	        return 0;
	    },
	
	    min: function(n, i, size, counterData) {
	        var v = counterData[i];
	        if(isNumeric(v)) {
	            v = Number(v);
	            if(!isNumeric(size[n])) {
	                size[n] = v;
	                return v;
	            } else if(size[n] > v) {
	                var delta = v - size[n];
	                size[n] = v;
	                return delta;
	            }
	        }
	        return 0;
	    },
	
	    max: function(n, i, size, counterData) {
	        var v = counterData[i];
	        if(isNumeric(v)) {
	            v = Number(v);
	            if(!isNumeric(size[n])) {
	                size[n] = v;
	                return v;
	            } else if(size[n] < v) {
	                var delta = v - size[n];
	                size[n] = v;
	                return delta;
	            }
	        }
	        return 0;
	    }
	};
	
	},{"fast-isnumeric":227}],1020:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var numConstants = _dereq_('../../constants/numerical');
	var oneYear = numConstants.ONEAVGYEAR;
	var oneMonth = numConstants.ONEAVGMONTH;
	var oneDay = numConstants.ONEDAY;
	var oneHour = numConstants.ONEHOUR;
	var oneMin = numConstants.ONEMIN;
	var oneSec = numConstants.ONESEC;
	var tickIncrement = _dereq_('../../plots/cartesian/axes').tickIncrement;
	
	
	/*
	 * make a function that will find rounded bin edges
	 * @param {number} leftGap: how far from the left edge of any bin is the closest data value?
	 * @param {number} rightGap: how far from the right edge of any bin is the closest data value?
	 * @param {Array[number]} binEdges: the actual edge values used in binning
	 * @param {object} pa: the position axis
	 * @param {string} calendar: the data calendar
	 *
	 * @return {function(v, isRightEdge)}:
	 *   find the start (isRightEdge is falsy) or end (truthy) label value for a bin edge `v`
	 */
	module.exports = function getBinSpanLabelRound(leftGap, rightGap, binEdges, pa, calendar) {
	    // the rounding digit is the largest digit that changes in *all* of 4 regions:
	    // - inside the rightGap before binEdges[0] (shifted 10% to the left)
	    // - inside the leftGap after binEdges[0] (expanded by 10% of rightGap on each end)
	    // - same for binEdges[1]
	    var dv0 = -1.1 * rightGap;
	    var dv1 = -0.1 * rightGap;
	    var dv2 = leftGap - dv1;
	    var edge0 = binEdges[0];
	    var edge1 = binEdges[1];
	    var leftDigit = Math.min(
	        biggestDigitChanged(edge0 + dv1, edge0 + dv2, pa, calendar),
	        biggestDigitChanged(edge1 + dv1, edge1 + dv2, pa, calendar)
	    );
	    var rightDigit = Math.min(
	        biggestDigitChanged(edge0 + dv0, edge0 + dv1, pa, calendar),
	        biggestDigitChanged(edge1 + dv0, edge1 + dv1, pa, calendar)
	    );
	
	    // normally we try to make the label for the right edge different from
	    // the left edge label, so it's unambiguous which bin gets data on the edge.
	    // but if this results in more than 3 extra digits (or for dates, more than
	    // 2 fields ie hr&min or min&sec, which is 3600x), it'll be more clutter than
	    // useful so keep the label cleaner instead
	    var digit, disambiguateEdges;
	    if(leftDigit > rightDigit && rightDigit < Math.abs(edge1 - edge0) / 4000) {
	        digit = leftDigit;
	        disambiguateEdges = false;
	    } else {
	        digit = Math.min(leftDigit, rightDigit);
	        disambiguateEdges = true;
	    }
	
	    if(pa.type === 'date' && digit > oneDay) {
	        var dashExclude = (digit === oneYear) ? 1 : 6;
	        var increment = (digit === oneYear) ? 'M12' : 'M1';
	
	        return function(v, isRightEdge) {
	            var dateStr = pa.c2d(v, oneYear, calendar);
	            var dashPos = dateStr.indexOf('-', dashExclude);
	            if(dashPos > 0) dateStr = dateStr.substr(0, dashPos);
	            var roundedV = pa.d2c(dateStr, 0, calendar);
	
	            if(roundedV < v) {
	                var nextV = tickIncrement(roundedV, increment, false, calendar);
	                if((roundedV + nextV) / 2 < v + leftGap) roundedV = nextV;
	            }
	
	            if(isRightEdge && disambiguateEdges) {
	                return tickIncrement(roundedV, increment, true, calendar);
	            }
	
	            return roundedV;
	        };
	    }
	
	    return function(v, isRightEdge) {
	        var roundedV = digit * Math.round(v / digit);
	        // if we rounded down and we could round up and still be < leftGap
	        // (or what leftGap values round to), do that
	        if(roundedV + (digit / 10) < v && roundedV + (digit * 0.9) < v + leftGap) {
	            roundedV += digit;
	        }
	        // finally for the right edge back off one digit - but only if we can do that
	        // and not clip off any data that's potentially in the bin
	        if(isRightEdge && disambiguateEdges) {
	            roundedV -= digit;
	        }
	        return roundedV;
	    };
	};
	
	/*
	 * Find the largest digit that changes within a (calcdata) region [v1, v2]
	 * if dates, "digit" means date/time part when it's bigger than a second
	 * returns the unit value to round to this digit, eg 0.01 to round to hundredths, or
	 * 100 to round to hundreds. returns oneMonth or oneYear for month or year rounding,
	 * so that Math.min will work, rather than 'M1' and 'M12'
	 */
	function biggestDigitChanged(v1, v2, pa, calendar) {
	    // are we crossing zero? can't say anything.
	    // in principle this doesn't apply to dates but turns out this doesn't matter.
	    if(v1 * v2 <= 0) return Infinity;
	
	    var dv = Math.abs(v2 - v1);
	    var isDate = pa.type === 'date';
	    var digit = biggestGuaranteedDigitChanged(dv, isDate);
	    // see if a larger digit also changed
	    for(var i = 0; i < 10; i++) {
	        // numbers: next digit needs to be >10x but <100x then gets rounded down.
	        // dates: next digit can be as much as 60x (then rounded down)
	        var nextDigit = biggestGuaranteedDigitChanged(digit * 80, isDate);
	        // if we get to years, the chain stops
	        if(digit === nextDigit) break;
	        if(didDigitChange(nextDigit, v1, v2, isDate, pa, calendar)) digit = nextDigit;
	        else break;
	    }
	    return digit;
	}
	
	/*
	 * Find the largest digit that *definitely* changes in a region [v, v + dv] for any v
	 * for nonuniform date regions (months/years) pick the largest
	 */
	function biggestGuaranteedDigitChanged(dv, isDate) {
	    if(isDate && dv > oneSec) {
	        // this is supposed to be the biggest *guaranteed* change
	        // so compare to the longest month and year across any calendar,
	        // and we'll iterate back up later
	        // note: does not support rounding larger than one year. We could add
	        // that if anyone wants it, but seems unusual and not strictly necessary.
	        if(dv > oneDay) {
	            if(dv > oneYear * 1.1) return oneYear;
	            if(dv > oneMonth * 1.1) return oneMonth;
	            return oneDay;
	        }
	
	        if(dv > oneHour) return oneHour;
	        if(dv > oneMin) return oneMin;
	        return oneSec;
	    }
	    return Math.pow(10, Math.floor(Math.log(dv) / Math.LN10));
	}
	
	function didDigitChange(digit, v1, v2, isDate, pa, calendar) {
	    if(isDate && digit > oneDay) {
	        var dateParts1 = dateParts(v1, pa, calendar);
	        var dateParts2 = dateParts(v2, pa, calendar);
	        var parti = (digit === oneYear) ? 0 : 1;
	        return dateParts1[parti] !== dateParts2[parti];
	    }
	    return Math.floor(v2 / digit) - Math.floor(v1 / digit) > 0.1;
	}
	
	function dateParts(v, pa, calendar) {
	    var parts = pa.c2d(v, oneYear, calendar).split('-');
	    if(parts[0] === '') {
	        parts.unshift();
	        parts[0] = '-' + parts[0];
	    }
	    return parts;
	}
	
	},{"../../constants/numerical":692,"../../plots/cartesian/axes":764}],1021:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var arraysToCalcdata = _dereq_('../bar/arrays_to_calcdata');
	var binFunctions = _dereq_('./bin_functions');
	var normFunctions = _dereq_('./norm_functions');
	var doAvg = _dereq_('./average');
	var getBinSpanLabelRound = _dereq_('./bin_label_vals');
	
	function calc(gd, trace) {
	    var pos = [];
	    var size = [];
	    var pa = Axes.getFromId(gd, trace.orientation === 'h' ? trace.yaxis : trace.xaxis);
	    var mainData = trace.orientation === 'h' ? 'y' : 'x';
	    var counterData = {x: 'y', y: 'x'}[mainData];
	    var calendar = trace[mainData + 'calendar'];
	    var cumulativeSpec = trace.cumulative;
	    var i;
	
	    var binsAndPos = calcAllAutoBins(gd, trace, pa, mainData);
	    var binSpec = binsAndPos[0];
	    var pos0 = binsAndPos[1];
	
	    var nonuniformBins = typeof binSpec.size === 'string';
	    var binEdges = [];
	    var bins = nonuniformBins ? binEdges : binSpec;
	    // make the empty bin array
	    var inc = [];
	    var counts = [];
	    var inputPoints = [];
	    var total = 0;
	    var norm = trace.histnorm;
	    var func = trace.histfunc;
	    var densityNorm = norm.indexOf('density') !== -1;
	    var i2, binEnd, n;
	
	    if(cumulativeSpec.enabled && densityNorm) {
	        // we treat "cumulative" like it means "integral" if you use a density norm,
	        // which in the end means it's the same as without "density"
	        norm = norm.replace(/ ?density$/, '');
	        densityNorm = false;
	    }
	
	    var extremeFunc = func === 'max' || func === 'min';
	    var sizeInit = extremeFunc ? null : 0;
	    var binFunc = binFunctions.count;
	    var normFunc = normFunctions[norm];
	    var isAvg = false;
	    var pr2c = function(v) { return pa.r2c(v, 0, calendar); };
	    var rawCounterData;
	
	    if(Lib.isArrayOrTypedArray(trace[counterData]) && func !== 'count') {
	        rawCounterData = trace[counterData];
	        isAvg = func === 'avg';
	        binFunc = binFunctions[func];
	    }
	
	    // create the bins (and any extra arrays needed)
	    // assume more than 1e6 bins is an error, so we don't crash the browser
	    i = pr2c(binSpec.start);
	
	    // decrease end a little in case of rounding errors
	    binEnd = pr2c(binSpec.end) + (i - Axes.tickIncrement(i, binSpec.size, false, calendar)) / 1e6;
	
	    while(i < binEnd && pos.length < 1e6) {
	        i2 = Axes.tickIncrement(i, binSpec.size, false, calendar);
	        pos.push((i + i2) / 2);
	        size.push(sizeInit);
	        inputPoints.push([]);
	        // nonuniform bins (like months) we need to search,
	        // rather than straight calculate the bin we're in
	        binEdges.push(i);
	        // nonuniform bins also need nonuniform normalization factors
	        if(densityNorm) inc.push(1 / (i2 - i));
	        if(isAvg) counts.push(0);
	        // break to avoid infinite loops
	        if(i2 <= i) break;
	        i = i2;
	    }
	    binEdges.push(i);
	
	    // for date axes we need bin bounds to be calcdata. For nonuniform bins
	    // we already have this, but uniform with start/end/size they're still strings.
	    if(!nonuniformBins && pa.type === 'date') {
	        bins = {
	            start: pr2c(bins.start),
	            end: pr2c(bins.end),
	            size: bins.size
	        };
	    }
	
	    // bin the data
	    // and make histogram-specific pt-number-to-cd-index map object
	    var nMax = size.length;
	    var uniqueValsPerBin = true;
	    var leftGap = Infinity;
	    var rightGap = Infinity;
	    var ptNumber2cdIndex = {};
	    for(i = 0; i < pos0.length; i++) {
	        var posi = pos0[i];
	        n = Lib.findBin(posi, bins);
	        if(n >= 0 && n < nMax) {
	            total += binFunc(n, i, size, rawCounterData, counts);
	            if(uniqueValsPerBin && inputPoints[n].length && posi !== pos0[inputPoints[n][0]]) {
	                uniqueValsPerBin = false;
	            }
	            inputPoints[n].push(i);
	            ptNumber2cdIndex[i] = n;
	
	            leftGap = Math.min(leftGap, posi - binEdges[n]);
	            rightGap = Math.min(rightGap, binEdges[n + 1] - posi);
	        }
	    }
	
	    var roundFn;
	    if(!uniqueValsPerBin) {
	        roundFn = getBinSpanLabelRound(leftGap, rightGap, binEdges, pa, calendar);
	    }
	
	    // average and/or normalize the data, if needed
	    if(isAvg) total = doAvg(size, counts);
	    if(normFunc) normFunc(size, total, inc);
	
	    // after all normalization etc, now we can accumulate if desired
	    if(cumulativeSpec.enabled) cdf(size, cumulativeSpec.direction, cumulativeSpec.currentbin);
	
	    var seriesLen = Math.min(pos.length, size.length);
	    var cd = [];
	    var firstNonzero = 0;
	    var lastNonzero = seriesLen - 1;
	
	    // look for empty bins at the ends to remove, so autoscale omits them
	    for(i = 0; i < seriesLen; i++) {
	        if(size[i]) {
	            firstNonzero = i;
	            break;
	        }
	    }
	    for(i = seriesLen - 1; i >= firstNonzero; i--) {
	        if(size[i]) {
	            lastNonzero = i;
	            break;
	        }
	    }
	
	    // create the "calculated data" to plot
	    for(i = firstNonzero; i <= lastNonzero; i++) {
	        if((isNumeric(pos[i]) && isNumeric(size[i]))) {
	            var cdi = {
	                p: pos[i],
	                s: size[i],
	                b: 0
	            };
	
	            // setup hover and event data fields,
	            // N.B. pts and "hover" positions ph0/ph1 don't seem to make much sense
	            // for cumulative distributions
	            if(!cumulativeSpec.enabled) {
	                cdi.pts = inputPoints[i];
	                if(uniqueValsPerBin) {
	                    cdi.ph0 = cdi.ph1 = (inputPoints[i].length) ? pos0[inputPoints[i][0]] : pos[i];
	                } else {
	                    cdi.ph0 = roundFn(binEdges[i]);
	                    cdi.ph1 = roundFn(binEdges[i + 1], true);
	                }
	            }
	            cd.push(cdi);
	        }
	    }
	
	    if(cd.length === 1) {
	        // when we collapse to a single bin, calcdata no longer describes bin size
	        // so we need to explicitly specify it
	        cd[0].width1 = Axes.tickIncrement(cd[0].p, binSpec.size, false, calendar) - cd[0].p;
	    }
	
	    arraysToCalcdata(cd, trace);
	
	    if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	        Lib.tagSelected(cd, trace, ptNumber2cdIndex);
	    }
	
	    return cd;
	}
	
	/*
	 * calcAllAutoBins: we want all histograms inside the same bingroup
	 * (see logic in Histogram.crossTraceDefaults) to share bin specs
	 *
	 * If the user has explicitly specified differing
	 * bin specs, there's nothing we can do, but if possible we will try to use the
	 * smallest bins of any of the auto values for all histograms inside the same
	 * bingroup.
	 */
	function calcAllAutoBins(gd, trace, pa, mainData, _overlayEdgeCase) {
	    var binAttr = mainData + 'bins';
	    var fullLayout = gd._fullLayout;
	    var groupName = trace['_' + mainData + 'bingroup'];
	    var binOpts = fullLayout._histogramBinOpts[groupName];
	    var isOverlay = fullLayout.barmode === 'overlay';
	    var i, traces, tracei, calendar, pos0, autoVals, cumulativeSpec;
	
	    var r2c = function(v) { return pa.r2c(v, 0, calendar); };
	    var c2r = function(v) { return pa.c2r(v, 0, calendar); };
	
	    var cleanBound = pa.type === 'date' ?
	        function(v) { return (v || v === 0) ? Lib.cleanDate(v, null, calendar) : null; } :
	        function(v) { return isNumeric(v) ? Number(v) : null; };
	
	    function setBound(attr, bins, newBins) {
	        if(bins[attr + 'Found']) {
	            bins[attr] = cleanBound(bins[attr]);
	            if(bins[attr] === null) bins[attr] = newBins[attr];
	        } else {
	            autoVals[attr] = bins[attr] = newBins[attr];
	            Lib.nestedProperty(traces[0], binAttr + '.' + attr).set(newBins[attr]);
	        }
	    }
	
	    // all but the first trace in this group has already been marked finished
	    // clear this flag, so next time we run calc we will run autobin again
	    if(trace['_' + mainData + 'autoBinFinished']) {
	        delete trace['_' + mainData + 'autoBinFinished'];
	    } else {
	        traces = binOpts.traces;
	        var allPos = [];
	
	        // Note: we're including `legendonly` traces here for autobin purposes,
	        // so that showing & hiding from the legend won't affect bins.
	        // But this complicates things a bit since those traces don't `calc`,
	        // hence `isFirstVisible`.
	        var isFirstVisible = true;
	        var has2dMap = false;
	        var hasHist2dContour = false;
	        for(i = 0; i < traces.length; i++) {
	            tracei = traces[i];
	
	            if(tracei.visible) {
	                var mainDatai = binOpts.dirs[i];
	                pos0 = tracei['_' + mainDatai + 'pos0'] = pa.makeCalcdata(tracei, mainDatai);
	
	                allPos = Lib.concat(allPos, pos0);
	                delete tracei['_' + mainData + 'autoBinFinished'];
	
	                if(trace.visible === true) {
	                    if(isFirstVisible) {
	                        isFirstVisible = false;
	                    } else {
	                        delete tracei._autoBin;
	                        tracei['_' + mainData + 'autoBinFinished'] = 1;
	                    }
	                    if(Registry.traceIs(tracei, '2dMap')) {
	                        has2dMap = true;
	                    }
	                    if(tracei.type === 'histogram2dcontour') {
	                        hasHist2dContour = true;
	                    }
	                }
	            }
	        }
	
	        calendar = traces[0][mainData + 'calendar'];
	        var newBinSpec = Axes.autoBin(allPos, pa, binOpts.nbins, has2dMap, calendar, binOpts.sizeFound && binOpts.size);
	
	        var autoBin = traces[0]._autoBin = {};
	        autoVals = autoBin[binOpts.dirs[0]] = {};
	
	        if(hasHist2dContour) {
	            // the "true" 2nd argument reverses the tick direction (which we can't
	            // just do with a minus sign because of month bins)
	            if(!binOpts.size) {
	                newBinSpec.start = c2r(Axes.tickIncrement(
	                    r2c(newBinSpec.start), newBinSpec.size, true, calendar));
	            }
	            if(binOpts.end === undefined) {
	                newBinSpec.end = c2r(Axes.tickIncrement(
	                    r2c(newBinSpec.end), newBinSpec.size, false, calendar));
	            }
	        }
	
	        // Edge case: single-valued histogram overlaying others
	        // Use them all together to calculate the bin size for the single-valued one
	        if(isOverlay && !Registry.traceIs(trace, '2dMap') && newBinSpec._dataSpan === 0 &&
	            pa.type !== 'category' && pa.type !== 'multicategory') {
	            // Several single-valued histograms! Stop infinite recursion,
	            // just return an extra flag that tells handleSingleValueOverlays
	            // to sort out this trace too
	            if(_overlayEdgeCase) return [newBinSpec, pos0, true];
	
	            newBinSpec = handleSingleValueOverlays(gd, trace, pa, mainData, binAttr);
	        }
	
	        // adjust for CDF edge cases
	        cumulativeSpec = tracei.cumulative || {};
	        if(cumulativeSpec.enabled && (cumulativeSpec.currentbin !== 'include')) {
	            if(cumulativeSpec.direction === 'decreasing') {
	                newBinSpec.start = c2r(Axes.tickIncrement(
	                    r2c(newBinSpec.start), newBinSpec.size, true, calendar));
	            } else {
	                newBinSpec.end = c2r(Axes.tickIncrement(
	                    r2c(newBinSpec.end), newBinSpec.size, false, calendar));
	            }
	        }
	
	        binOpts.size = newBinSpec.size;
	        if(!binOpts.sizeFound) {
	            autoVals.size = newBinSpec.size;
	            Lib.nestedProperty(traces[0], binAttr + '.size').set(newBinSpec.size);
	        }
	
	        setBound('start', binOpts, newBinSpec);
	        setBound('end', binOpts, newBinSpec);
	    }
	
	    pos0 = trace['_' + mainData + 'pos0'];
	    delete trace['_' + mainData + 'pos0'];
	
	    // Each trace can specify its own start/end, or if omitted
	    // we ensure they're beyond the bounds of this trace's data,
	    // and we need to make sure start is aligned with the main start
	    var traceInputBins = trace._input[binAttr] || {};
	    var traceBinOptsCalc = Lib.extendFlat({}, binOpts);
	    var mainStart = binOpts.start;
	    var startIn = pa.r2l(traceInputBins.start);
	    var hasStart = startIn !== undefined;
	    if((binOpts.startFound || hasStart) && startIn !== pa.r2l(mainStart)) {
	        // We have an explicit start to reconcile across traces
	        // if this trace has an explicit start, shift it down to a bin edge
	        // if another trace had an explicit start, shift it down to a
	        // bin edge past our data
	        var traceStart = hasStart ?
	            startIn :
	            Lib.aggNums(Math.min, null, pos0);
	
	        var dummyAx = {
	            type: (pa.type === 'category' || pa.type === 'multicategory') ? 'linear' : pa.type,
	            r2l: pa.r2l,
	            dtick: binOpts.size,
	            tick0: mainStart,
	            calendar: calendar,
	            range: ([traceStart, Axes.tickIncrement(traceStart, binOpts.size, false, calendar)]).map(pa.l2r)
	        };
	        var newStart = Axes.tickFirst(dummyAx);
	        if(newStart > pa.r2l(traceStart)) {
	            newStart = Axes.tickIncrement(newStart, binOpts.size, true, calendar);
	        }
	        traceBinOptsCalc.start = pa.l2r(newStart);
	        if(!hasStart) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.start);
	    }
	
	    var mainEnd = binOpts.end;
	    var endIn = pa.r2l(traceInputBins.end);
	    var hasEnd = endIn !== undefined;
	    if((binOpts.endFound || hasEnd) && endIn !== pa.r2l(mainEnd)) {
	        // Reconciling an explicit end is easier, as it doesn't need to
	        // match bin edges
	        var traceEnd = hasEnd ?
	            endIn :
	            Lib.aggNums(Math.max, null, pos0);
	
	        traceBinOptsCalc.end = pa.l2r(traceEnd);
	        if(!hasEnd) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.end);
	    }
	
	    // Backward compatibility for one-time autobinning.
	    // autobin: true is handled in cleanData, but autobin: false
	    // needs to be here where we have determined the values.
	    var autoBinAttr = 'autobin' + mainData;
	    if(trace._input[autoBinAttr] === false) {
	        trace._input[binAttr] = Lib.extendFlat({}, trace[binAttr] || {});
	        delete trace._input[autoBinAttr];
	        delete trace[autoBinAttr];
	    }
	
	    return [traceBinOptsCalc, pos0];
	}
	
	/*
	 * Adjust single-value histograms in overlay mode to make as good a
	 * guess as we can at autobin values the user would like.
	 *
	 * Returns the binSpec for the trace that sparked all this
	 */
	function handleSingleValueOverlays(gd, trace, pa, mainData, binAttr) {
	    var fullLayout = gd._fullLayout;
	    var overlaidTraceGroup = getConnectedHistograms(gd, trace);
	    var pastThisTrace = false;
	    var minSize = Infinity;
	    var singleValuedTraces = [trace];
	    var i, tracei, binOpts;
	
	    // first collect all the:
	    // - min bin size from all multi-valued traces
	    // - single-valued traces
	    for(i = 0; i < overlaidTraceGroup.length; i++) {
	        tracei = overlaidTraceGroup[i];
	
	        if(tracei === trace) {
	            pastThisTrace = true;
	        } else if(!pastThisTrace) {
	            // This trace has already had its autobins calculated, so either:
	            // - it is part of a bingroup
	            // - it is NOT a single-valued trace
	            binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
	            minSize = Math.min(minSize, binOpts.size || tracei[binAttr].size);
	        } else {
	            var resulti = calcAllAutoBins(gd, tracei, pa, mainData, true);
	            var binSpeci = resulti[0];
	            var isSingleValued = resulti[2];
	
	            // so we can use this result when we get to tracei in the normal
	            // course of events, mark it as done and put _pos0 back
	            tracei['_' + mainData + 'autoBinFinished'] = 1;
	            tracei['_' + mainData + 'pos0'] = resulti[1];
	
	            if(isSingleValued) {
	                singleValuedTraces.push(tracei);
	            } else {
	                minSize = Math.min(minSize, binSpeci.size);
	            }
	        }
	    }
	
	    // find the real data values for each single-valued trace
	    // hunt through pos0 for the first valid value
	    var dataVals = new Array(singleValuedTraces.length);
	    for(i = 0; i < singleValuedTraces.length; i++) {
	        var pos0 = singleValuedTraces[i]['_' + mainData + 'pos0'];
	        for(var j = 0; j < pos0.length; j++) {
	            if(pos0[j] !== undefined) {
	                dataVals[i] = pos0[j];
	                break;
	            }
	        }
	    }
	
	    // are ALL traces are single-valued? use the min difference between
	    // all of their values (which defaults to 1 if there's still only one)
	    if(!isFinite(minSize)) {
	        minSize = Lib.distinctVals(dataVals).minDiff;
	    }
	
	    // now apply the min size we found to all single-valued traces
	    for(i = 0; i < singleValuedTraces.length; i++) {
	        tracei = singleValuedTraces[i];
	        var calendar = tracei[mainData + 'calendar'];
	
	        var newBins = {
	            start: pa.c2r(dataVals[i] - minSize / 2, 0, calendar),
	            end: pa.c2r(dataVals[i] + minSize / 2, 0, calendar),
	            size: minSize
	        };
	
	        tracei._input[binAttr] = tracei[binAttr] = newBins;
	
	        binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
	        if(binOpts) Lib.extendFlat(binOpts, newBins);
	    }
	
	    return trace[binAttr];
	}
	
	/*
	 * Return an array of histograms that share axes and orientation.
	 *
	 * Only considers histograms. In principle we could include bars in a
	 * similar way to how we do manually binned histograms, though this
	 * would have tons of edge cases and value judgments to make.
	 */
	function getConnectedHistograms(gd, trace) {
	    var xid = trace.xaxis;
	    var yid = trace.yaxis;
	    var orientation = trace.orientation;
	
	    var out = [];
	    var fullData = gd._fullData;
	    for(var i = 0; i < fullData.length; i++) {
	        var tracei = fullData[i];
	        if(tracei.type === 'histogram' &&
	            tracei.visible === true &&
	            tracei.orientation === orientation &&
	            tracei.xaxis === xid && tracei.yaxis === yid
	        ) {
	            out.push(tracei);
	        }
	    }
	
	    return out;
	}
	
	function cdf(size, direction, currentBin) {
	    var i, vi, prevSum;
	
	    function firstHalfPoint(i) {
	        prevSum = size[i];
	        size[i] /= 2;
	    }
	
	    function nextHalfPoint(i) {
	        vi = size[i];
	        size[i] = prevSum + vi / 2;
	        prevSum += vi;
	    }
	
	    if(currentBin === 'half') {
	        if(direction === 'increasing') {
	            firstHalfPoint(0);
	            for(i = 1; i < size.length; i++) {
	                nextHalfPoint(i);
	            }
	        } else {
	            firstHalfPoint(size.length - 1);
	            for(i = size.length - 2; i >= 0; i--) {
	                nextHalfPoint(i);
	            }
	        }
	    } else if(direction === 'increasing') {
	        for(i = 1; i < size.length; i++) {
	            size[i] += size[i - 1];
	        }
	
	        // 'exclude' is identical to 'include' just shifted one bin over
	        if(currentBin === 'exclude') {
	            size.unshift(0);
	            size.pop();
	        }
	    } else {
	        for(i = size.length - 2; i >= 0; i--) {
	            size[i] += size[i + 1];
	        }
	
	        if(currentBin === 'exclude') {
	            size.push(0);
	            size.shift();
	        }
	    }
	}
	
	module.exports = {
	    calc: calc,
	    calcAllAutoBins: calcAllAutoBins
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../../registry":845,"../bar/arrays_to_calcdata":854,"./average":1017,"./bin_functions":1019,"./bin_label_vals":1020,"./norm_functions":1028,"fast-isnumeric":227}],1022:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    eventDataKeys: ['binNumber']
	};
	
	},{}],1023:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var axisIds = _dereq_('../../plots/cartesian/axis_ids');
	
	var traceIs = _dereq_('../../registry').traceIs;
	var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
	
	var nestedProperty = Lib.nestedProperty;
	var getAxisGroup = axisIds.getAxisGroup;
	
	var BINATTRS = [
	    {aStr: {x: 'xbins.start', y: 'ybins.start'}, name: 'start'},
	    {aStr: {x: 'xbins.end', y: 'ybins.end'}, name: 'end'},
	    {aStr: {x: 'xbins.size', y: 'ybins.size'}, name: 'size'},
	    {aStr: {x: 'nbinsx', y: 'nbinsy'}, name: 'nbins'}
	];
	
	var BINDIRECTIONS = ['x', 'y'];
	
	// handle bin attrs and relink auto-determined values so fullData is complete
	module.exports = function crossTraceDefaults(fullData, fullLayout) {
	    var allBinOpts = fullLayout._histogramBinOpts = {};
	    var histTraces = [];
	    var mustMatchTracesLookup = {};
	    var otherTracesList = [];
	
	    var traceOut, traces, groupName, binDir;
	    var i, j, k;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceOut._input, traceOut, traceOut._module.attributes, attr, dflt);
	    }
	
	    function orientation2binDir(traceOut) {
	        return traceOut.orientation === 'v' ? 'x' : 'y';
	    }
	
	    function getAxisType(traceOut, binDir) {
	        var ax = axisIds.getFromTrace({_fullLayout: fullLayout}, traceOut, binDir);
	        return ax.type;
	    }
	
	    function fillBinOpts(traceOut, groupName, binDir) {
	        // N.B. group traces that don't have a bingroup with themselves
	        var fallbackGroupName = traceOut.uid + '__' + binDir;
	        if(!groupName) groupName = fallbackGroupName;
	
	        var axType = getAxisType(traceOut, binDir);
	        var calendar = traceOut[binDir + 'calendar'];
	        var binOpts = allBinOpts[groupName];
	        var needsNewItem = true;
	
	        if(binOpts) {
	            if(axType === binOpts.axType && calendar === binOpts.calendar) {
	                needsNewItem = false;
	                binOpts.traces.push(traceOut);
	                binOpts.dirs.push(binDir);
	            } else {
	                groupName = fallbackGroupName;
	
	                if(axType !== binOpts.axType) {
	                    Lib.warn([
	                        'Attempted to group the bins of trace', traceOut.index,
	                        'set on a', 'type:' + axType, 'axis',
	                        'with bins on', 'type:' + binOpts.axType, 'axis.'
	                    ].join(' '));
	                }
	                if(calendar !== binOpts.calendar) {
	                    // prohibit bingroup for traces using different calendar,
	                    // there's probably a way to make this work, but skip for now
	                    Lib.warn([
	                        'Attempted to group the bins of trace', traceOut.index,
	                        'set with a', calendar, 'calendar',
	                        'with bins',
	                        (binOpts.calendar ? 'on a ' + binOpts.calendar + ' calendar' : 'w/o a set calendar')
	                    ].join(' '));
	                }
	            }
	        }
	
	        if(needsNewItem) {
	            allBinOpts[groupName] = {
	                traces: [traceOut],
	                dirs: [binDir],
	                axType: axType,
	                calendar: traceOut[binDir + 'calendar'] || ''
	            };
	        }
	        traceOut['_' + binDir + 'bingroup'] = groupName;
	    }
	
	    for(i = 0; i < fullData.length; i++) {
	        traceOut = fullData[i];
	
	        if(traceIs(traceOut, 'histogram')) {
	            histTraces.push(traceOut);
	
	            // TODO: this shouldn't be relinked as it's only used within calc
	            // https://github.com/plotly/plotly.js/issues/749
	            delete traceOut._xautoBinFinished;
	            delete traceOut._yautoBinFinished;
	
	            // N.B. need to coerce *alignmentgroup* before *bingroup*, as traces
	            // in same alignmentgroup "have to match"
	            if(!traceIs(traceOut, '2dMap')) {
	                handleGroupingDefaults(traceOut._input, traceOut, fullLayout, coerce);
	            }
	        }
	    }
	
	    var alignmentOpts = fullLayout._alignmentOpts || {};
	
	    // Look for traces that "have to match", that is:
	    // - 1d histogram traces on the same subplot with same orientation under barmode:stack,
	    // - 1d histogram traces on the same subplot with same orientation under barmode:group
	    // - 1d histogram traces on the same position axis with the same orientation
	    //   and the same *alignmentgroup* (coerced under barmode:group)
	    // - Once `stackgroup` gets implemented (see https://github.com/plotly/plotly.js/issues/3614),
	    //   traces within the same stackgroup will also "have to match"
	    for(i = 0; i < histTraces.length; i++) {
	        traceOut = histTraces[i];
	        groupName = '';
	
	        if(!traceIs(traceOut, '2dMap')) {
	            binDir = orientation2binDir(traceOut);
	
	            if(fullLayout.barmode === 'group' && traceOut.alignmentgroup) {
	                var pa = traceOut[binDir + 'axis'];
	                var aGroupId = getAxisGroup(fullLayout, pa) + traceOut.orientation;
	                if((alignmentOpts[aGroupId] || {})[traceOut.alignmentgroup]) {
	                    groupName = aGroupId;
	                }
	            }
	
	            if(!groupName && fullLayout.barmode !== 'overlay') {
	                groupName = (
	                    getAxisGroup(fullLayout, traceOut.xaxis) +
	                    getAxisGroup(fullLayout, traceOut.yaxis) +
	                    orientation2binDir(traceOut)
	                );
	            }
	        }
	
	        if(groupName) {
	            if(!mustMatchTracesLookup[groupName]) {
	                mustMatchTracesLookup[groupName] = [];
	            }
	            mustMatchTracesLookup[groupName].push(traceOut);
	        } else {
	            otherTracesList.push(traceOut);
	        }
	    }
	
	    // Setup binOpts for traces that have to match,
	    // if the traces have a valid bingroup, use that
	    // if not use axis+binDir groupName
	    for(groupName in mustMatchTracesLookup) {
	        traces = mustMatchTracesLookup[groupName];
	
	        // no need to 'force' anything when a single
	        // trace is detected as "must match"
	        if(traces.length === 1) {
	            otherTracesList.push(traces[0]);
	            continue;
	        }
	
	        var binGroupFound = false;
	        for(i = 0; i < traces.length; i++) {
	            traceOut = traces[i];
	            binGroupFound = coerce('bingroup');
	            break;
	        }
	
	        groupName = binGroupFound || groupName;
	
	        for(i = 0; i < traces.length; i++) {
	            traceOut = traces[i];
	            var bingroupIn = traceOut._input.bingroup;
	            if(bingroupIn && bingroupIn !== groupName) {
	                Lib.warn([
	                    'Trace', traceOut.index, 'must match',
	                    'within bingroup', groupName + '.',
	                    'Ignoring its bingroup:', bingroupIn, 'setting.'
	                ].join(' '));
	            }
	            traceOut.bingroup = groupName;
	
	            // N.B. no need to worry about 2dMap case
	            // (where both bin direction are set in each trace)
	            // as 2dMap trace never "have to match"
	            fillBinOpts(traceOut, groupName, orientation2binDir(traceOut));
	        }
	    }
	
	    // setup binOpts for traces that can but don't have to match,
	    // notice that these traces can be matched with traces that have to match
	    for(i = 0; i < otherTracesList.length; i++) {
	        traceOut = otherTracesList[i];
	
	        var binGroup = coerce('bingroup');
	
	        if(traceIs(traceOut, '2dMap')) {
	            for(k = 0; k < 2; k++) {
	                binDir = BINDIRECTIONS[k];
	                var binGroupInDir = coerce(binDir + 'bingroup',
	                    binGroup ? binGroup + '__' + binDir : null
	                );
	                fillBinOpts(traceOut, binGroupInDir, binDir);
	            }
	        } else {
	            fillBinOpts(traceOut, binGroup, orientation2binDir(traceOut));
	        }
	    }
	
	    // coerce bin attrs!
	    for(groupName in allBinOpts) {
	        var binOpts = allBinOpts[groupName];
	        traces = binOpts.traces;
	
	        for(j = 0; j < BINATTRS.length; j++) {
	            var attrSpec = BINATTRS[j];
	            var attr = attrSpec.name;
	            var aStr;
	            var autoVals;
	
	            // nbins(x|y) is moot if we have a size. This depends on
	            // nbins coming after size in binAttrs.
	            if(attr === 'nbins' && binOpts.sizeFound) continue;
	
	            for(i = 0; i < traces.length; i++) {
	                traceOut = traces[i];
	                binDir = binOpts.dirs[i];
	                aStr = attrSpec.aStr[binDir];
	
	                if(nestedProperty(traceOut._input, aStr).get() !== undefined) {
	                    binOpts[attr] = coerce(aStr);
	                    binOpts[attr + 'Found'] = true;
	                    break;
	                }
	
	                autoVals = (traceOut._autoBin || {})[binDir] || {};
	                if(autoVals[attr]) {
	                    // if this is the *first* autoval
	                    nestedProperty(traceOut, aStr).set(autoVals[attr]);
	                }
	            }
	
	            // start and end we need to coerce anyway, after having collected the
	            // first of each into binOpts, in case a trace wants to restrict its
	            // data to a certain range
	            if(attr === 'start' || attr === 'end') {
	                for(; i < traces.length; i++) {
	                    traceOut = traces[i];
	                    if(traceOut['_' + binDir + 'bingroup']) {
	                        autoVals = (traceOut._autoBin || {})[binDir] || {};
	                        coerce(aStr, autoVals[attr]);
	                    }
	                }
	            }
	
	            if(attr === 'nbins' && !binOpts.sizeFound && !binOpts.nbinsFound) {
	                traceOut = traces[0];
	                binOpts[attr] = coerce(aStr);
	            }
	        }
	    }
	};
	
	},{"../../lib":716,"../../plots/cartesian/axis_ids":767,"../../registry":845,"../bar/defaults":859}],1024:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	
	var handleStyleDefaults = _dereq_('../bar/style_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var x = coerce('x');
	    var y = coerce('y');
	
	    var cumulative = coerce('cumulative.enabled');
	    if(cumulative) {
	        coerce('cumulative.direction');
	        coerce('cumulative.currentbin');
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var orientation = coerce('orientation', (y && !x) ? 'h' : 'v');
	    var sampleLetter = orientation === 'v' ? 'x' : 'y';
	    var aggLetter = orientation === 'v' ? 'y' : 'x';
	
	    var len = (x && y) ?
	        Math.min(Lib.minRowLength(x) && Lib.minRowLength(y)) :
	        Lib.minRowLength(traceOut[sampleLetter] || []);
	
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = len;
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
	
	    var hasAggregationData = traceOut[aggLetter];
	    if(hasAggregationData) coerce('histfunc');
	    coerce('histnorm');
	
	    // Note: bin defaults are now handled in Histogram.crossTraceDefaults
	    // autobin(x|y) are only included here to appease Plotly.validate
	    coerce('autobin' + sampleLetter);
	
	    handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	
	    var lineColor = (traceOut.marker.line || {}).color;
	
	    // override defaultColor for error bars with defaultLine
	    var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'y'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'x', inherit: 'y'});
	};
	
	},{"../../components/color":591,"../../lib":716,"../../registry":845,"../bar/style_defaults":870,"./attributes":1016}],1025:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt, trace, cd, pointNumber) {
	    // standard cartesian event data
	    out.x = 'xVal' in pt ? pt.xVal : pt.x;
	    out.y = 'yVal' in pt ? pt.yVal : pt.y;
	
	    // for 2d histograms
	    if('zLabelVal' in pt) out.z = pt.zLabelVal;
	
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    // specific to histogram - CDFs do not have pts (yet?)
	    if(!(trace.cumulative || {}).enabled) {
	        var pts = Array.isArray(pointNumber) ?
	            cd[0].pts[pointNumber[0]][pointNumber[1]] :
	            cd[pointNumber].pts;
	
	        out.pointNumbers = pts;
	        out.binNumber = out.pointNumber;
	        delete out.pointNumber;
	        delete out.pointIndex;
	
	        var pointIndices;
	        if(trace._indexToPoints) {
	            pointIndices = [];
	            for(var i = 0; i < pts.length; i++) {
	                pointIndices = pointIndices.concat(trace._indexToPoints[pts[i]]);
	            }
	        } else {
	            pointIndices = pts;
	        }
	
	        out.pointIndices = pointIndices;
	    }
	
	    return out;
	};
	
	},{}],1026:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var barHover = _dereq_('../bar/hover').hoverPoints;
	var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var pts = barHover(pointData, xval, yval, hovermode);
	
	    if(!pts) return;
	
	    pointData = pts[0];
	    var di = pointData.cd[pointData.index];
	    var trace = pointData.cd[0].trace;
	
	    if(!trace.cumulative.enabled) {
	        var posLetter = trace.orientation === 'h' ? 'y' : 'x';
	
	        pointData[posLetter + 'Label'] = hoverLabelText(pointData[posLetter + 'a'], di.ph0, di.ph1);
	    }
	
	    if(trace.hovermplate) pointData.hovertemplate = trace.hovertemplate;
	
	    return pts;
	};
	
	},{"../../plots/cartesian/axes":764,"../bar/hover":862}],1027:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * Histogram has its own attribute, defaults and calc steps,
	 * but uses bar's plot to display
	 * and bar's crossTraceCalc (formerly known as setPositions) for stacking and grouping
	 */
	
	/**
	 * histogram errorBarsOK is debatable, but it's put in for backward compat.
	 * there are use cases for it - sqrt for a simple histogram works right now,
	 * constant and % work but they're not so meaningful. I guess it could be cool
	 * to allow quadrature combination of errors in summed histograms...
	 */
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('../bar/layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('./cross_trace_defaults'),
	    supplyLayoutDefaults: _dereq_('../bar/layout_defaults'),
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('../bar/cross_trace_calc').crossTraceCalc,
	    plot: _dereq_('../bar/plot').plot,
	    layerName: 'barlayer',
	    style: _dereq_('../bar/style').style,
	    styleOnSelect: _dereq_('../bar/style').styleOnSelect,
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('../bar/select'),
	    eventData: _dereq_('./event_data'),
	
	    moduleType: 'trace',
	    name: 'histogram',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['bar-like', 'cartesian', 'svg', 'bar', 'histogram', 'oriented', 'errorBarsOK', 'showLegend'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../bar/cross_trace_calc":858,"../bar/layout_attributes":864,"../bar/layout_defaults":865,"../bar/plot":866,"../bar/select":867,"../bar/style":869,"../scatter/marker_colorbar":1136,"./attributes":1016,"./calc":1021,"./cross_trace_defaults":1023,"./defaults":1024,"./event_data":1025,"./hover":1026}],1028:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = {
	    percent: function(size, total) {
	        var nMax = size.length;
	        var norm = 100 / total;
	        for(var n = 0; n < nMax; n++) size[n] *= norm;
	    },
	    probability: function(size, total) {
	        var nMax = size.length;
	        for(var n = 0; n < nMax; n++) size[n] /= total;
	    },
	    density: function(size, total, inc, yinc) {
	        var nMax = size.length;
	        yinc = yinc || 1;
	        for(var n = 0; n < nMax; n++) size[n] *= inc[n] * yinc;
	    },
	    'probability density': function(size, total, inc, yinc) {
	        var nMax = size.length;
	        if(yinc) total /= yinc;
	        for(var n = 0; n < nMax; n++) size[n] *= inc[n] / total;
	    }
	};
	
	},{}],1029:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var histogramAttrs = _dereq_('../histogram/attributes');
	var makeBinAttrs = _dereq_('../histogram/bin_attributes');
	var heatmapAttrs = _dereq_('../heatmap/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = extendFlat(
	    {
	        x: histogramAttrs.x,
	        y: histogramAttrs.y,
	
	        z: {
	            valType: 'data_array',
	            editType: 'calc',
	            
	        },
	        marker: {
	            color: {
	                valType: 'data_array',
	                editType: 'calc',
	                
	            },
	            editType: 'calc'
	        },
	
	        histnorm: histogramAttrs.histnorm,
	        histfunc: histogramAttrs.histfunc,
	        nbinsx: histogramAttrs.nbinsx,
	        xbins: makeBinAttrs('x'),
	        nbinsy: histogramAttrs.nbinsy,
	        ybins: makeBinAttrs('y'),
	        autobinx: histogramAttrs.autobinx,
	        autobiny: histogramAttrs.autobiny,
	
	        bingroup: extendFlat({}, histogramAttrs.bingroup, {
	            
	        }),
	        xbingroup: extendFlat({}, histogramAttrs.bingroup, {
	            
	        }),
	        ybingroup: extendFlat({}, histogramAttrs.bingroup, {
	            
	        }),
	
	        xgap: heatmapAttrs.xgap,
	        ygap: heatmapAttrs.ygap,
	        zsmooth: heatmapAttrs.zsmooth,
	        zhoverformat: heatmapAttrs.zhoverformat,
	        hovertemplate: hovertemplateAttrs({}, {keys: 'z'})
	    },
	    colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
	);
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/template_attributes":840,"../heatmap/attributes":998,"../histogram/attributes":1016,"../histogram/bin_attributes":1018}],1030:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var binFunctions = _dereq_('../histogram/bin_functions');
	var normFunctions = _dereq_('../histogram/norm_functions');
	var doAvg = _dereq_('../histogram/average');
	var getBinSpanLabelRound = _dereq_('../histogram/bin_label_vals');
	var calcAllAutoBins = _dereq_('../histogram/calc').calcAllAutoBins;
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis);
	    var ya = Axes.getFromId(gd, trace.yaxis);
	
	    var xcalendar = trace.xcalendar;
	    var ycalendar = trace.ycalendar;
	    var xr2c = function(v) { return xa.r2c(v, 0, xcalendar); };
	    var yr2c = function(v) { return ya.r2c(v, 0, ycalendar); };
	    var xc2r = function(v) { return xa.c2r(v, 0, xcalendar); };
	    var yc2r = function(v) { return ya.c2r(v, 0, ycalendar); };
	
	    var i, j, n, m;
	
	    // calculate the bins
	    var xBinsAndPos = calcAllAutoBins(gd, trace, xa, 'x');
	    var xBinSpec = xBinsAndPos[0];
	    var xPos0 = xBinsAndPos[1];
	    var yBinsAndPos = calcAllAutoBins(gd, trace, ya, 'y');
	    var yBinSpec = yBinsAndPos[0];
	    var yPos0 = yBinsAndPos[1];
	
	    var serieslen = trace._length;
	    if(xPos0.length > serieslen) xPos0.splice(serieslen, xPos0.length - serieslen);
	    if(yPos0.length > serieslen) yPos0.splice(serieslen, yPos0.length - serieslen);
	
	    // make the empty bin array & scale the map
	    var z = [];
	    var onecol = [];
	    var zerocol = [];
	    var nonuniformBinsX = typeof xBinSpec.size === 'string';
	    var nonuniformBinsY = typeof yBinSpec.size === 'string';
	    var xEdges = [];
	    var yEdges = [];
	    var xbins = nonuniformBinsX ? xEdges : xBinSpec;
	    var ybins = nonuniformBinsY ? yEdges : yBinSpec;
	    var total = 0;
	    var counts = [];
	    var inputPoints = [];
	    var norm = trace.histnorm;
	    var func = trace.histfunc;
	    var densitynorm = norm.indexOf('density') !== -1;
	    var extremefunc = func === 'max' || func === 'min';
	    var sizeinit = extremefunc ? null : 0;
	    var binfunc = binFunctions.count;
	    var normfunc = normFunctions[norm];
	    var doavg = false;
	    var xinc = [];
	    var yinc = [];
	
	    // set a binning function other than count?
	    // for binning functions: check first for 'z',
	    // then 'mc' in case we had a colored scatter plot
	    // and want to transfer these colors to the 2D histo
	    // TODO: axe this, make it the responsibility of the app changing type? or an impliedEdit?
	    var rawCounterData = ('z' in trace) ?
	        trace.z :
	        (('marker' in trace && Array.isArray(trace.marker.color)) ?
	            trace.marker.color : '');
	    if(rawCounterData && func !== 'count') {
	        doavg = func === 'avg';
	        binfunc = binFunctions[func];
	    }
	
	    // decrease end a little in case of rounding errors
	    var xBinSize = xBinSpec.size;
	    var xBinStart = xr2c(xBinSpec.start);
	    var xBinEnd = xr2c(xBinSpec.end) +
	        (xBinStart - Axes.tickIncrement(xBinStart, xBinSize, false, xcalendar)) / 1e6;
	
	    for(i = xBinStart; i < xBinEnd; i = Axes.tickIncrement(i, xBinSize, false, xcalendar)) {
	        onecol.push(sizeinit);
	        xEdges.push(i);
	        if(doavg) zerocol.push(0);
	    }
	    xEdges.push(i);
	
	    var nx = onecol.length;
	    var dx = (i - xBinStart) / nx;
	    var x0 = xc2r(xBinStart + dx / 2);
	
	    var yBinSize = yBinSpec.size;
	    var yBinStart = yr2c(yBinSpec.start);
	    var yBinEnd = yr2c(yBinSpec.end) +
	        (yBinStart - Axes.tickIncrement(yBinStart, yBinSize, false, ycalendar)) / 1e6;
	
	    for(i = yBinStart; i < yBinEnd; i = Axes.tickIncrement(i, yBinSize, false, ycalendar)) {
	        z.push(onecol.slice());
	        yEdges.push(i);
	        var ipCol = new Array(nx);
	        for(j = 0; j < nx; j++) ipCol[j] = [];
	        inputPoints.push(ipCol);
	        if(doavg) counts.push(zerocol.slice());
	    }
	    yEdges.push(i);
	
	    var ny = z.length;
	    var dy = (i - yBinStart) / ny;
	    var y0 = yc2r(yBinStart + dy / 2);
	
	    if(densitynorm) {
	        xinc = makeIncrements(onecol.length, xbins, dx, nonuniformBinsX);
	        yinc = makeIncrements(z.length, ybins, dy, nonuniformBinsY);
	    }
	
	    // for date axes we need bin bounds to be calcdata. For nonuniform bins
	    // we already have this, but uniform with start/end/size they're still strings.
	    if(!nonuniformBinsX && xa.type === 'date') xbins = binsToCalc(xr2c, xbins);
	    if(!nonuniformBinsY && ya.type === 'date') ybins = binsToCalc(yr2c, ybins);
	
	    // put data into bins
	    var uniqueValsPerX = true;
	    var uniqueValsPerY = true;
	    var xVals = new Array(nx);
	    var yVals = new Array(ny);
	    var xGapLow = Infinity;
	    var xGapHigh = Infinity;
	    var yGapLow = Infinity;
	    var yGapHigh = Infinity;
	    for(i = 0; i < serieslen; i++) {
	        var xi = xPos0[i];
	        var yi = yPos0[i];
	        n = Lib.findBin(xi, xbins);
	        m = Lib.findBin(yi, ybins);
	        if(n >= 0 && n < nx && m >= 0 && m < ny) {
	            total += binfunc(n, i, z[m], rawCounterData, counts[m]);
	            inputPoints[m][n].push(i);
	
	            if(uniqueValsPerX) {
	                if(xVals[n] === undefined) xVals[n] = xi;
	                else if(xVals[n] !== xi) uniqueValsPerX = false;
	            }
	            if(uniqueValsPerY) {
	                if(yVals[m] === undefined) yVals[m] = yi;
	                else if(yVals[m] !== yi) uniqueValsPerY = false;
	            }
	
	            xGapLow = Math.min(xGapLow, xi - xEdges[n]);
	            xGapHigh = Math.min(xGapHigh, xEdges[n + 1] - xi);
	            yGapLow = Math.min(yGapLow, yi - yEdges[m]);
	            yGapHigh = Math.min(yGapHigh, yEdges[m + 1] - yi);
	        }
	    }
	    // normalize, if needed
	    if(doavg) {
	        for(m = 0; m < ny; m++) total += doAvg(z[m], counts[m]);
	    }
	    if(normfunc) {
	        for(m = 0; m < ny; m++) normfunc(z[m], total, xinc, yinc[m]);
	    }
	
	    return {
	        x: xPos0,
	        xRanges: getRanges(xEdges, uniqueValsPerX && xVals, xGapLow, xGapHigh, xa, xcalendar),
	        x0: x0,
	        dx: dx,
	        y: yPos0,
	        yRanges: getRanges(yEdges, uniqueValsPerY && yVals, yGapLow, yGapHigh, ya, ycalendar),
	        y0: y0,
	        dy: dy,
	        z: z,
	        pts: inputPoints
	    };
	};
	
	function makeIncrements(len, bins, dv, nonuniform) {
	    var out = new Array(len);
	    var i;
	    if(nonuniform) {
	        for(i = 0; i < len; i++) out[i] = 1 / (bins[i + 1] - bins[i]);
	    } else {
	        var inc = 1 / dv;
	        for(i = 0; i < len; i++) out[i] = inc;
	    }
	    return out;
	}
	
	function binsToCalc(r2c, bins) {
	    return {
	        start: r2c(bins.start),
	        end: r2c(bins.end),
	        size: bins.size
	    };
	}
	
	function getRanges(edges, uniqueVals, gapLow, gapHigh, ax, calendar) {
	    var i;
	    var len = edges.length - 1;
	    var out = new Array(len);
	    var roundFn = getBinSpanLabelRound(gapLow, gapHigh, edges, ax, calendar);
	
	    for(i = 0; i < len; i++) {
	        var v = (uniqueVals || [])[i];
	        out[i] = v === undefined ?
	            [roundFn(edges[i]), roundFn(edges[i + 1], true)] :
	            [v, v];
	    }
	    return out;
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../histogram/average":1017,"../histogram/bin_functions":1019,"../histogram/bin_label_vals":1020,"../histogram/calc":1021,"../histogram/norm_functions":1028}],1031:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleSampleDefaults = _dereq_('./sample_defaults');
	var handleStyleDefaults = _dereq_('../heatmap/style_defaults');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    handleSampleDefaults(traceIn, traceOut, coerce, layout);
	    if(traceOut.visible === false) return;
	
	    handleStyleDefaults(traceIn, traceOut, coerce, layout);
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
	    coerce('hovertemplate');
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"../heatmap/style_defaults":1011,"./attributes":1029,"./sample_defaults":1034}],1032:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var heatmapHover = _dereq_('../heatmap/hover');
	var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer, contour) {
	    var pts = heatmapHover(pointData, xval, yval, hovermode, hoverLayer, contour);
	
	    if(!pts) return;
	
	    pointData = pts[0];
	    var indices = pointData.index;
	    var ny = indices[0];
	    var nx = indices[1];
	    var cd0 = pointData.cd[0];
	    var xRange = cd0.xRanges[nx];
	    var yRange = cd0.yRanges[ny];
	
	    pointData.xLabel = hoverLabelText(pointData.xa, xRange[0], xRange[1]);
	    pointData.yLabel = hoverLabelText(pointData.ya, yRange[0], yRange[1]);
	
	    return pts;
	};
	
	},{"../../plots/cartesian/axes":764,"../heatmap/hover":1005}],1033:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('../histogram/cross_trace_defaults'),
	    calc: _dereq_('../heatmap/calc'),
	    plot: _dereq_('../heatmap/plot'),
	    layerName: 'heatmaplayer',
	    colorbar: _dereq_('../heatmap/colorbar'),
	    style: _dereq_('../heatmap/style'),
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('../histogram/event_data'),
	
	    moduleType: 'trace',
	    name: 'histogram2d',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', '2dMap', 'histogram'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../heatmap/calc":999,"../heatmap/colorbar":1001,"../heatmap/plot":1009,"../heatmap/style":1010,"../histogram/cross_trace_defaults":1023,"../histogram/event_data":1025,"./attributes":1029,"./defaults":1031,"./hover":1032}],1034:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	module.exports = function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
	    var x = coerce('x');
	    var y = coerce('y');
	    var xlen = Lib.minRowLength(x);
	    var ylen = Lib.minRowLength(y);
	
	    // we could try to accept x0 and dx, etc...
	    // but that's a pretty weird use case.
	    // for now require both x and y explicitly specified.
	    if(!xlen || !ylen) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = Math.min(xlen, ylen);
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
	
	    // if marker.color is an array, we can use it in aggregation instead of z
	    var hasAggregationData = coerce('z') || coerce('marker.color');
	
	    if(hasAggregationData) coerce('histfunc');
	    coerce('histnorm');
	
	    // Note: bin defaults are now handled in Histogram2D.crossTraceDefaults
	    // autobin(x|y) are only included here to appease Plotly.validate
	    coerce('autobinx');
	    coerce('autobiny');
	};
	
	},{"../../lib":716,"../../registry":845}],1035:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var histogram2dAttrs = _dereq_('../histogram2d/attributes');
	var contourAttrs = _dereq_('../contour/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = extendFlat({
	    x: histogram2dAttrs.x,
	    y: histogram2dAttrs.y,
	    z: histogram2dAttrs.z,
	    marker: histogram2dAttrs.marker,
	
	    histnorm: histogram2dAttrs.histnorm,
	    histfunc: histogram2dAttrs.histfunc,
	    nbinsx: histogram2dAttrs.nbinsx,
	    xbins: histogram2dAttrs.xbins,
	    nbinsy: histogram2dAttrs.nbinsy,
	    ybins: histogram2dAttrs.ybins,
	    autobinx: histogram2dAttrs.autobinx,
	    autobiny: histogram2dAttrs.autobiny,
	
	    bingroup: histogram2dAttrs.bingroup,
	    xbingroup: histogram2dAttrs.xbingroup,
	    ybingroup: histogram2dAttrs.ybingroup,
	
	    autocontour: contourAttrs.autocontour,
	    ncontours: contourAttrs.ncontours,
	    contours: contourAttrs.contours,
	    line: {
	        color: contourAttrs.line.color,
	        width: extendFlat({}, contourAttrs.line.width, {
	            dflt: 0.5,
	            
	        }),
	        dash: contourAttrs.line.dash,
	        smoothing: contourAttrs.line.smoothing,
	        editType: 'plot'
	    },
	    zhoverformat: histogram2dAttrs.zhoverformat,
	    hovertemplate: histogram2dAttrs.hovertemplate
	},
	    colorScaleAttrs('', {
	        cLetter: 'z',
	        editTypeOverride: 'calc'
	    })
	);
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../contour/attributes":941,"../histogram2d/attributes":1029}],1036:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleSampleDefaults = _dereq_('../histogram2d/sample_defaults');
	var handleContoursDefaults = _dereq_('../contour/contours_defaults');
	var handleStyleDefaults = _dereq_('../contour/style_defaults');
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    function coerce2(attr) {
	        return Lib.coerce2(traceIn, traceOut, attributes, attr);
	    }
	
	    handleSampleDefaults(traceIn, traceOut, coerce, layout);
	    if(traceOut.visible === false) return;
	
	    handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	    handleStyleDefaults(traceIn, traceOut, coerce, layout);
	    coerce('hovertemplate');
	};
	
	},{"../../lib":716,"../contour/contours_defaults":948,"../contour/style_defaults":962,"../histogram2d/sample_defaults":1034,"./attributes":1035}],1037:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('../histogram/cross_trace_defaults'),
	    calc: _dereq_('../contour/calc'),
	    plot: _dereq_('../contour/plot').plot,
	    layerName: 'contourlayer',
	    style: _dereq_('../contour/style'),
	    colorbar: _dereq_('../contour/colorbar'),
	    hoverPoints: _dereq_('../contour/hover'),
	
	    moduleType: 'trace',
	    name: 'histogram2dcontour',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', '2dMap', 'contour', 'histogram', 'showLegend'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../contour/calc":942,"../contour/colorbar":944,"../contour/hover":954,"../contour/plot":959,"../contour/style":961,"../histogram/cross_trace_defaults":1023,"./attributes":1035,"./defaults":1036}],1038:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var baseAttrs = _dereq_('../../plots/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var colormodel = _dereq_('./constants').colormodel;
	
	var cm = ['rgb', 'rgba', 'hsl', 'hsla'];
	var zminDesc = [];
	var zmaxDesc = [];
	for(var i = 0; i < cm.length; i++) {
	    zminDesc.push('For the `' + cm[i] + '` colormodel, it is [' + colormodel[cm[i]].min.join(', ') + '].');
	    zmaxDesc.push('For the `' + cm[i] + '` colormodel, it is [' + colormodel[cm[i]].max.join(', ') + '].');
	}
	
	module.exports = extendFlat({
	    z: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    colormodel: {
	        valType: 'enumerated',
	        values: cm,
	        dflt: 'rgb',
	        
	        editType: 'calc',
	        
	    },
	    zmin: {
	        valType: 'info_array',
	        items: [
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'}
	        ],
	        
	        editType: 'calc',
	        
	    },
	    zmax: {
	        valType: 'info_array',
	        items: [
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'},
	            {valType: 'number', editType: 'calc'}
	        ],
	        
	        editType: 'calc',
	        
	    },
	    x0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    dx: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    dy: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	    text: {
	        valType: 'data_array',
	        editType: 'plot',
	        
	    },
	    hovertext: {
	        valType: 'data_array',
	        editType: 'plot',
	        
	    },
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['x', 'y', 'z', 'color', 'name', 'text'],
	        dflt: 'x+y+z+text+name'
	    }),
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: ['z', 'color', 'colormodel']
	    }),
	
	    transforms: undefined
	});
	
	},{"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"./constants":1040}],1039:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var constants = _dereq_('./constants');
	var isNumeric = _dereq_('fast-isnumeric');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var maxRowLength = _dereq_('../../lib').maxRowLength;
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	
	    var x0 = xa.d2c(trace.x0) - trace.dx / 2;
	    var y0 = ya.d2c(trace.y0) - trace.dy / 2;
	    var h = trace.z.length;
	    var w = maxRowLength(trace.z);
	
	    // Set axis range
	    var i;
	    var xrange = [x0, x0 + w * trace.dx];
	    var yrange = [y0, y0 + h * trace.dy];
	    if(xa && xa.type === 'log') for(i = 0; i < w; i++) xrange.push(x0 + i * trace.dx);
	    if(ya && ya.type === 'log') for(i = 0; i < h; i++) yrange.push(y0 + i * trace.dy);
	    trace._extremes[xa._id] = Axes.findExtremes(xa, xrange);
	    trace._extremes[ya._id] = Axes.findExtremes(ya, yrange);
	    trace._scaler = makeScaler(trace);
	
	    var cd0 = {
	        x0: x0,
	        y0: y0,
	        z: trace.z,
	        w: w,
	        h: h
	    };
	    return [cd0];
	};
	
	function scale(zero, ratio, min, max) {
	    return function(c) {
	        return Lib.constrain((c - zero) * ratio, min, max);
	    };
	}
	
	function constrain(min, max) {
	    return function(c) { return Lib.constrain(c, min, max);};
	}
	
	// Generate a function to scale color components according to zmin/zmax and the colormodel
	function makeScaler(trace) {
	    var colormodel = trace.colormodel;
	    var n = colormodel.length;
	    var cr = constants.colormodel[colormodel];
	
	    trace._sArray = [];
	    // Loop over all color components
	    for(var k = 0; k < n; k++) {
	        if(cr.min[k] !== trace.zmin[k] || cr.max[k] !== trace.zmax[k]) {
	            trace._sArray.push(scale(
	                trace.zmin[k],
	                (cr.max[k] - cr.min[k]) / (trace.zmax[k] - trace.zmin[k]),
	                cr.min[k],
	                cr.max[k]
	            ));
	        } else {
	            trace._sArray.push(constrain(cr.min[k], cr.max[k]));
	        }
	    }
	
	    return function(pixel) {
	        var c = pixel.slice(0, n);
	        for(var k = 0; k < n; k++) {
	            var ck = c[k];
	            if(!isNumeric(ck)) return false;
	            c[k] = trace._sArray[k](ck);
	        }
	        return c;
	    };
	}
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"./constants":1040,"fast-isnumeric":227}],1040:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    colormodel: {
	        rgb: {
	            min: [0, 0, 0],
	            max: [255, 255, 255],
	            fmt: function(c) {return c.slice(0, 3);},
	            suffix: ['', '', '']
	        },
	        rgba: {
	            min: [0, 0, 0, 0],
	            max: [255, 255, 255, 1],
	            fmt: function(c) {return c.slice(0, 4);},
	            suffix: ['', '', '', '']
	        },
	        hsl: {
	            min: [0, 0, 0],
	            max: [360, 100, 100],
	            fmt: function(c) {
	                var p = c.slice(0, 3);
	                p[1] = p[1] + '%';
	                p[2] = p[2] + '%';
	                return p;
	            },
	            suffix: ['°', '%', '%']
	        },
	        hsla: {
	            min: [0, 0, 0, 0],
	            max: [360, 100, 100, 1],
	            fmt: function(c) {
	                var p = c.slice(0, 4);
	                p[1] = p[1] + '%';
	                p[2] = p[2] + '%';
	                return p;
	            },
	            suffix: ['°', '%', '%', '']
	        }
	    }
	};
	
	},{}],1041:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('./constants');
	
	module.exports = function supplyDefaults(traceIn, traceOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	    var z = coerce('z');
	    if(z === undefined || !z.length || !z[0] || !z[0].length) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('x0');
	    coerce('y0');
	    coerce('dx');
	    coerce('dy');
	    var colormodel = coerce('colormodel');
	
	    coerce('zmin', constants.colormodel[colormodel].min);
	    coerce('zmax', constants.colormodel[colormodel].max);
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    traceOut._length = null;
	};
	
	},{"../../lib":716,"./attributes":1038,"./constants":1040}],1042:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt) {
	    if('xVal' in pt) out.x = pt.xVal;
	    if('yVal' in pt) out.y = pt.yVal;
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	    out.color = pt.color;
	    out.colormodel = pt.trace.colormodel;
	    return out;
	};
	
	},{}],1043:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var constants = _dereq_('./constants');
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var cd0 = pointData.cd[0];
	    var trace = cd0.trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	
	    // Return early if not on image
	    if(Fx.inbox(xval - cd0.x0, xval - (cd0.x0 + cd0.w * trace.dx), 0) > 0 ||
	            Fx.inbox(yval - cd0.y0, yval - (cd0.y0 + cd0.h * trace.dy), 0) > 0) {
	        return;
	    }
	
	    // Find nearest pixel's index
	    var nx = Math.floor((xval - cd0.x0) / trace.dx);
	    var ny = Math.floor(Math.abs(yval - cd0.y0) / trace.dy);
	
	    // return early if pixel is undefined
	    if(!cd0.z[ny][nx]) return;
	
	    var hoverinfo = cd0.hi || trace.hoverinfo;
	    var fmtColor;
	    if(hoverinfo) {
	        var parts = hoverinfo.split('+');
	        if(parts.indexOf('all') !== -1) parts = ['color'];
	        if(parts.indexOf('color') !== -1) fmtColor = true;
	    }
	
	    var colormodel = trace.colormodel;
	    var dims = colormodel.length;
	    var c = trace._scaler(cd0.z[ny][nx]);
	    var s = constants.colormodel[colormodel].suffix;
	
	    var colorstring = [];
	    if(trace.hovertemplate || fmtColor) {
	        colorstring.push('[' + [c[0] + s[0], c[1] + s[1], c[2] + s[2]].join(', '));
	        if(dims === 4) colorstring.push(', ' + c[3] + s[3]);
	        colorstring.push(']');
	        colorstring = colorstring.join('');
	        pointData.extraText = colormodel.toUpperCase() + ': ' + colorstring;
	    }
	
	    var text;
	    if(Array.isArray(trace.hovertext) && Array.isArray(trace.hovertext[ny])) {
	        text = trace.hovertext[ny][nx];
	    } else if(Array.isArray(trace.text) && Array.isArray(trace.text[ny])) {
	        text = trace.text[ny][nx];
	    }
	
	    // TODO: for color model with 3 dims, display something useful for hovertemplate `%{color[3]}`
	    var py = ya.c2p(cd0.y0 + (ny + 0.5) * trace.dy);
	    var xVal = cd0.x0 + (nx + 0.5) * trace.dx;
	    var yVal = cd0.y0 + (ny + 0.5) * trace.dy;
	    var zLabel = '[' + cd0.z[ny][nx].slice(0, trace.colormodel.length).join(', ') + ']';
	    return [Lib.extendFlat(pointData, {
	        index: [ny, nx],
	        x0: xa.c2p(cd0.x0 + nx * trace.dx),
	        x1: xa.c2p(cd0.x0 + (nx + 1) * trace.dx),
	        y0: py,
	        y1: py,
	        color: c,
	        xVal: xVal,
	        xLabelVal: xVal,
	        yVal: yVal,
	        yLabelVal: yVal,
	        zLabelVal: zLabel,
	        text: text,
	        hovertemplateLabels: {
	            'zLabel': zLabel,
	            'colorLabel': colorstring,
	            'color[0]Label': c[0] + s[0],
	            'color[1]Label': c[1] + s[1],
	            'color[2]Label': c[2] + s[2],
	            'color[3]Label': c[3] + s[3]
	        }
	    })];
	};
	
	},{"../../components/fx":629,"../../lib":716,"./constants":1040}],1044:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	
	    moduleType: 'trace',
	    name: 'image',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', '2dMap', 'noSortingByValue'],
	    animatable: false,
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./attributes":1038,"./calc":1039,"./defaults":1041,"./event_data":1042,"./hover":1043,"./plot":1045,"./style":1046}],1045:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	var constants = _dereq_('./constants');
	
	module.exports = function plot(gd, plotinfo, cdimage, imageLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(imageLayer, cdimage, 'im').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        var z = cd0.z;
	        var x0 = cd0.x0;
	        var y0 = cd0.y0;
	        var w = cd0.w;
	        var h = cd0.h;
	        var dx = trace.dx;
	        var dy = trace.dy;
	
	        var left, right, temp, top, bottom, i;
	        // in case of log of a negative
	        i = 0;
	        while(left === undefined && i < w) {
	            left = xa.c2p(x0 + i * dx);
	            i++;
	        }
	        i = w;
	        while(right === undefined && i > 0) {
	            right = xa.c2p(x0 + i * dx);
	            i--;
	        }
	        i = 0;
	        while(top === undefined && i < h) {
	            top = ya.c2p(y0 + i * dy);
	            i++;
	        }
	        i = h;
	        while(bottom === undefined && i > 0) {
	            bottom = ya.c2p(y0 + i * dy);
	            i--;
	        }
	
	        if(right < left) {
	            temp = right;
	            right = left;
	            left = temp;
	        }
	
	        if(bottom < top) {
	            temp = top;
	            top = bottom;
	            bottom = temp;
	        }
	
	        // Reduce image size when zoomed in to save memory
	        var extra = 0.5; // half the axis size
	        left = Math.max(-extra * xa._length, left);
	        right = Math.min((1 + extra) * xa._length, right);
	        top = Math.max(-extra * ya._length, top);
	        bottom = Math.min((1 + extra) * ya._length, bottom);
	        var imageWidth = Math.round(right - left);
	        var imageHeight = Math.round(bottom - top);
	
	        // if image is entirely off-screen, don't even draw it
	        var isOffScreen = (imageWidth <= 0 || imageHeight <= 0);
	        if(isOffScreen) {
	            var noImage = plotGroup.selectAll('image').data([]);
	            noImage.exit().remove();
	            return;
	        }
	
	        // Draw each pixel
	        var canvas = document.createElement('canvas');
	        canvas.width = imageWidth;
	        canvas.height = imageHeight;
	        var context = canvas.getContext('2d');
	
	        var ipx = function(i) {return Lib.constrain(Math.round(xa.c2p(x0 + i * dx) - left), 0, imageWidth);};
	        var jpx = function(j) {return Lib.constrain(Math.round(ya.c2p(y0 + j * dy) - top), 0, imageHeight);};
	
	        var fmt = constants.colormodel[trace.colormodel].fmt;
	        var c;
	        for(i = 0; i < cd0.w; i++) {
	            var ipx0 = ipx(i); var ipx1 = ipx(i + 1);
	            if(ipx1 === ipx0 || isNaN(ipx1) || isNaN(ipx0)) continue;
	            for(var j = 0; j < cd0.h; j++) {
	                var jpx0 = jpx(j); var jpx1 = jpx(j + 1);
	                if(jpx1 === jpx0 || isNaN(jpx1) || isNaN(jpx0) || !z[j][i]) continue;
	                c = trace._scaler(z[j][i]);
	                if(c) {
	                    context.fillStyle = trace.colormodel + '(' + fmt(c).join(',') + ')';
	                } else {
	                    // Return a transparent pixel
	                    context.fillStyle = 'rgba(0,0,0,0)';
	                }
	                context.fillRect(ipx0, jpx0, ipx1 - ipx0, jpx1 - jpx0);
	            }
	        }
	
	        var image3 = plotGroup.selectAll('image')
	            .data(cd);
	
	        image3.enter().append('svg:image').attr({
	            xmlns: xmlnsNamespaces.svg,
	            preserveAspectRatio: 'none'
	        });
	
	        image3.attr({
	            height: imageHeight,
	            width: imageWidth,
	            x: left,
	            y: top,
	            'xlink:href': canvas.toDataURL('image/png')
	        });
	    });
	};
	
	},{"../../constants/xmlns_namespaces":693,"../../lib":716,"./constants":1040,"d3":164}],1046:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	module.exports = function style(gd) {
	    d3.select(gd).selectAll('.im image')
	        .style('opacity', function(d) {
	            return d.trace.opacity;
	        });
	};
	
	},{"d3":164}],1047:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var extendDeep = _dereq_('../../lib/extend').extendDeep;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	var delta = _dereq_('../../constants/delta.js');
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	
	var textFontAttrs = fontAttrs({
	    editType: 'plot',
	    colorEditType: 'plot'
	});
	
	var gaugeBarAttrs = {
	    color: {
	        valType: 'color',
	        editType: 'plot',
	        
	        
	    },
	    line: {
	        color: {
	            valType: 'color',
	            
	            dflt: colorAttrs.defaultLine,
	            editType: 'plot',
	            
	        },
	        width: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 0,
	            editType: 'plot',
	            
	        },
	        editType: 'calc'
	    },
	    thickness: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 1,
	        editType: 'plot',
	        
	    },
	    editType: 'calc'
	};
	
	var rangeAttr = {
	    valType: 'info_array',
	    
	    items: [
	            {valType: 'number', editType: 'plot'},
	            {valType: 'number', editType: 'plot'}
	    ],
	    editType: 'plot',
	    
	};
	
	var stepsAttrs = templatedArray('step', extendDeep({}, gaugeBarAttrs, {
	    range: rangeAttr
	}));
	
	module.exports = {
	    mode: {
	        valType: 'flaglist',
	        editType: 'calc',
	        
	        flags: ['number', 'delta', 'gauge'],
	        dflt: 'number',
	        
	    },
	    value: {
	        valType: 'number',
	        editType: 'calc',
	        
	        anim: true,
	        
	    },
	    align: {
	        valType: 'enumerated',
	        values: ['left', 'center', 'right'],
	        
	        editType: 'plot',
	        
	    },
	    // position
	    domain: domainAttrs({name: 'indicator', trace: true, editType: 'calc'}),
	
	    title: {
	        text: {
	            valType: 'string',
	            
	            editType: 'plot',
	            
	        },
	        align: {
	            valType: 'enumerated',
	            values: ['left', 'center', 'right'],
	            
	            editType: 'plot',
	            
	        },
	        font: extendFlat({}, textFontAttrs, {
	            
	        }),
	        editType: 'plot'
	    },
	    number: {
	        valueformat: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'plot',
	            
	        },
	        font: extendFlat({}, textFontAttrs, {
	            
	        }),
	        prefix: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'plot',
	            
	        },
	        suffix: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'plot',
	            
	        },
	        editType: 'plot'
	    },
	    delta: {
	        reference: {
	            valType: 'number',
	            
	            editType: 'calc',
	            
	        },
	        position: {
	            valType: 'enumerated',
	            values: ['top', 'bottom', 'left', 'right'],
	            
	            dflt: 'bottom',
	            editType: 'plot',
	            
	        },
	        relative: {
	            valType: 'boolean',
	            editType: 'plot',
	            
	            dflt: false,
	            
	        },
	        valueformat: {
	            valType: 'string',
	            
	            editType: 'plot',
	            
	        },
	        increasing: {
	            symbol: {
	                valType: 'string',
	                
	                dflt: delta.INCREASING.SYMBOL,
	                editType: 'plot',
	                
	            },
	            color: {
	                valType: 'color',
	                
	                dflt: delta.INCREASING.COLOR,
	                editType: 'plot',
	                
	            },
	            // TODO: add attribute to show sign
	            editType: 'plot'
	        },
	        decreasing: {
	            symbol: {
	                valType: 'string',
	                
	                dflt: delta.DECREASING.SYMBOL,
	                editType: 'plot',
	                
	            },
	            color: {
	                valType: 'color',
	                
	                dflt: delta.DECREASING.COLOR,
	                editType: 'plot',
	                
	            },
	            // TODO: add attribute to hide sign
	            editType: 'plot'
	        },
	        font: extendFlat({}, textFontAttrs, {
	            
	        }),
	        editType: 'calc'
	    },
	    gauge: {
	        shape: {
	            valType: 'enumerated',
	            editType: 'plot',
	            
	            dflt: 'angular',
	            values: ['angular', 'bullet'],
	            
	        },
	        bar: extendDeep({}, gaugeBarAttrs, {
	            color: {dflt: 'green'},
	            
	        }),
	        // Background of the gauge
	        bgcolor: {
	            valType: 'color',
	            
	            editType: 'plot',
	            
	        },
	        bordercolor: {
	            valType: 'color',
	            dflt: colorAttrs.defaultLine,
	            
	            editType: 'plot',
	            
	        },
	        borderwidth: {
	            valType: 'number',
	            min: 0,
	            dflt: 1,
	            
	            editType: 'plot',
	            
	        },
	        axis: overrideAll({
	            range: rangeAttr,
	            visible: extendFlat({}, axesAttrs.visible, {
	                dflt: true
	            }),
	            // tick and title properties named and function exactly as in axes
	            tickmode: axesAttrs.tickmode,
	            nticks: axesAttrs.nticks,
	            tick0: axesAttrs.tick0,
	            dtick: axesAttrs.dtick,
	            tickvals: axesAttrs.tickvals,
	            ticktext: axesAttrs.ticktext,
	            ticks: extendFlat({}, axesAttrs.ticks, {dflt: 'outside'}),
	            ticklen: axesAttrs.ticklen,
	            tickwidth: axesAttrs.tickwidth,
	            tickcolor: axesAttrs.tickcolor,
	            showticklabels: axesAttrs.showticklabels,
	            tickfont: fontAttrs({
	                
	            }),
	            tickangle: axesAttrs.tickangle,
	            tickformat: axesAttrs.tickformat,
	            tickformatstops: axesAttrs.tickformatstops,
	            tickprefix: axesAttrs.tickprefix,
	            showtickprefix: axesAttrs.showtickprefix,
	            ticksuffix: axesAttrs.ticksuffix,
	            showticksuffix: axesAttrs.showticksuffix,
	            separatethousands: axesAttrs.separatethousands,
	            exponentformat: axesAttrs.exponentformat,
	            showexponent: axesAttrs.showexponent,
	            editType: 'plot'
	        }, 'plot'),
	        // Steps (or ranges) and thresholds
	        steps: stepsAttrs,
	        threshold: {
	            line: {
	                color: extendFlat({}, gaugeBarAttrs.line.color, {
	                    
	                }),
	                width: extendFlat({}, gaugeBarAttrs.line.width, {
	                    dflt: 1,
	                    
	                }),
	                editType: 'plot'
	            },
	            thickness: extendFlat({}, gaugeBarAttrs.thickness, {
	                dflt: 0.85,
	                
	            }),
	            value: {
	                valType: 'number',
	                editType: 'calc',
	                dflt: false,
	                
	                
	            },
	            editType: 'plot'
	        },
	        
	        editType: 'plot'
	        // TODO: in future version, add marker: (bar|needle)
	    }
	};
	
	},{"../../components/color/attributes":590,"../../constants/delta.js":686,"../../constants/docs":687,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../../plots/cartesian/layout_attributes":776,"../../plots/domain":789,"../../plots/font_attributes":790}],1048:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var plots = _dereq_('../../plots/plots');
	
	exports.name = 'indicator';
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	};
	
	},{"../../plots/plots":825}],1049:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// var Lib = require('../../lib');
	
	function calc(gd, trace) {
	    var cd = [];
	
	    var lastReading = trace.value;
	    if(!(typeof trace._lastValue === 'number')) trace._lastValue = trace.value;
	    var secondLastReading = trace._lastValue;
	    var deltaRef = secondLastReading;
	    if(trace._hasDelta && typeof trace.delta.reference === 'number') {
	        deltaRef = trace.delta.reference;
	    }
	    cd[0] = {
	        y: lastReading,
	        lastY: secondLastReading,
	
	        delta: lastReading - deltaRef,
	        relativeDelta: (lastReading - deltaRef) / deltaRef,
	    };
	    return cd;
	}
	
	module.exports = {
	    calc: calc
	};
	
	},{}],1050:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    // Defaults for delta
	    defaultNumberFontSize: 80,
	    bulletNumberDomainSize: 0.25,
	    bulletPadding: 0.025,
	    innerRadius: 0.75,
	    valueThickness: 0.5, // thickness of value bars relative to full thickness,
	    titlePadding: 5,
	    horizontalPadding: 10
	};
	
	},{}],1051:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var Template = _dereq_('../../plot_api/plot_template');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	var cn = _dereq_('./constants.js');
	
	var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
	var handleTickMarkDefaults = _dereq_('../../plots/cartesian/tick_mark_defaults');
	var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    // Mode
	    coerce('mode');
	    traceOut._hasNumber = traceOut.mode.indexOf('number') !== -1;
	    traceOut._hasDelta = traceOut.mode.indexOf('delta') !== -1;
	    traceOut._hasGauge = traceOut.mode.indexOf('gauge') !== -1;
	
	    var value = coerce('value');
	    traceOut._range = [0, (typeof value === 'number' ? 1.5 * value : 1)];
	
	    // Number attributes
	    var auto = new Array(2);
	    var bignumberFontSize;
	    if(traceOut._hasNumber) {
	        coerce('number.valueformat');
	        coerce('number.font.color', layout.font.color);
	        coerce('number.font.family', layout.font.family);
	        coerce('number.font.size');
	        if(traceOut.number.font.size === undefined) {
	            traceOut.number.font.size = cn.defaultNumberFontSize;
	            auto[0] = true;
	        }
	        coerce('number.prefix');
	        coerce('number.suffix');
	        bignumberFontSize = traceOut.number.font.size;
	    }
	
	    // delta attributes
	    var deltaFontSize;
	    if(traceOut._hasDelta) {
	        coerce('delta.font.color', layout.font.color);
	        coerce('delta.font.family', layout.font.family);
	        coerce('delta.font.size');
	        if(traceOut.delta.font.size === undefined) {
	            traceOut.delta.font.size = (traceOut._hasNumber ? 0.5 : 1) * (bignumberFontSize || cn.defaultNumberFontSize);
	            auto[1] = true;
	        }
	        coerce('delta.reference', traceOut.value);
	        coerce('delta.relative');
	        coerce('delta.valueformat', traceOut.delta.relative ? '2%' : '');
	        coerce('delta.increasing.symbol');
	        coerce('delta.increasing.color');
	        coerce('delta.decreasing.symbol');
	        coerce('delta.decreasing.color');
	        coerce('delta.position');
	        deltaFontSize = traceOut.delta.font.size;
	    }
	    traceOut._scaleNumbers = (!traceOut._hasNumber || auto[0]) && (!traceOut._hasDelta || auto[1]) || false;
	
	    // Title attributes
	    coerce('title.font.color', layout.font.color);
	    coerce('title.font.family', layout.font.family);
	    coerce('title.font.size', 0.25 * (bignumberFontSize || deltaFontSize || cn.defaultNumberFontSize));
	    coerce('title.text');
	
	    // Gauge attributes
	    var gaugeIn, gaugeOut, axisIn, axisOut;
	    function coerceGauge(attr, dflt) {
	        return Lib.coerce(gaugeIn, gaugeOut, attributes.gauge, attr, dflt);
	    }
	    function coerceGaugeAxis(attr, dflt) {
	        return Lib.coerce(axisIn, axisOut, attributes.gauge.axis, attr, dflt);
	    }
	
	    if(traceOut._hasGauge) {
	        gaugeIn = traceIn.gauge;
	        if(!gaugeIn) gaugeIn = {};
	        gaugeOut = Template.newContainer(traceOut, 'gauge');
	        coerceGauge('shape');
	        var isBullet = traceOut._isBullet = traceOut.gauge.shape === 'bullet';
	        if(!isBullet) {
	            coerce('title.align', 'center');
	        }
	        var isAngular = traceOut._isAngular = traceOut.gauge.shape === 'angular';
	        if(!isAngular) {
	            coerce('align', 'center');
	        }
	
	        // gauge background
	        coerceGauge('bgcolor', layout.paper_bgcolor);
	        coerceGauge('borderwidth');
	        coerceGauge('bordercolor');
	
	        // gauge bar indicator
	        coerceGauge('bar.color');
	        coerceGauge('bar.line.color');
	        coerceGauge('bar.line.width');
	        var defaultBarThickness = cn.valueThickness * (traceOut.gauge.shape === 'bullet' ? 0.5 : 1);
	        coerceGauge('bar.thickness', defaultBarThickness);
	
	        // Gauge steps
	        handleArrayContainerDefaults(gaugeIn, gaugeOut, {
	            name: 'steps',
	            handleItemDefaults: stepDefaults
	        });
	
	        // Gauge threshold
	        coerceGauge('threshold.value');
	        coerceGauge('threshold.thickness');
	        coerceGauge('threshold.line.width');
	        coerceGauge('threshold.line.color');
	
	        // Gauge axis
	        axisIn = {};
	        if(gaugeIn) axisIn = gaugeIn.axis || {};
	        axisOut = Template.newContainer(gaugeOut, 'axis');
	        coerceGaugeAxis('visible');
	        traceOut._range = coerceGaugeAxis('range', traceOut._range);
	
	        var opts = {outerTicks: true};
	        handleTickValueDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear');
	        handleTickLabelDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear', opts);
	        handleTickMarkDefaults(axisIn, axisOut, coerceGaugeAxis, opts);
	    } else {
	        coerce('title.align', 'center');
	        coerce('align', 'center');
	        traceOut._isAngular = traceOut._isBullet = false;
	    }
	
	    // disable 1D transforms
	    traceOut._length = null;
	}
	
	function stepDefaults(stepIn, stepOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(stepIn, stepOut, attributes.gauge.steps, attr, dflt);
	    }
	
	    coerce('color');
	    coerce('line.color');
	    coerce('line.width');
	    coerce('range');
	    coerce('thickness');
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults
	};
	
	},{"../../lib":716,"../../plot_api/plot_template":754,"../../plots/array_container_defaults":760,"../../plots/cartesian/tick_label_defaults":783,"../../plots/cartesian/tick_mark_defaults":784,"../../plots/cartesian/tick_value_defaults":785,"../../plots/domain":789,"./attributes":1047,"./constants.js":1050}],1052:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'indicator',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['svg', 'noOpacity', 'noHover'],
	    animatable: true,
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	
	    calc: _dereq_('./calc').calc,
	
	    plot: _dereq_('./plot'),
	
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1047,"./base_plot":1048,"./calc":1049,"./defaults":1051,"./plot":1053}],1053:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var rad2deg = Lib.rad2deg;
	var MID_SHIFT = _dereq_('../../constants/alignment').MID_SHIFT;
	var Drawing = _dereq_('../../components/drawing');
	var cn = _dereq_('./constants');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var handleAxisDefaults = _dereq_('../../plots/cartesian/axis_defaults');
	var handleAxisPositionDefaults = _dereq_('../../plots/cartesian/position_defaults');
	var axisLayoutAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	
	var Color = _dereq_('../../components/color');
	var anchor = {
	    'left': 'start',
	    'center': 'middle',
	    'right': 'end'
	};
	var position = {
	    'left': 0,
	    'center': 0.5,
	    'right': 1
	};
	
	var SI_PREFIX = /[yzafpnµmkMGTPEZY]/;
	
	function hasTransition(transitionOpts) {
	    // If transition config is provided, then it is only a partial replot and traces not
	    // updated are removed.
	    return transitionOpts && transitionOpts.duration > 0;
	}
	
	module.exports = function plot(gd, cdModule, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = gd._fullLayout;
	    var onComplete;
	
	    if(hasTransition(transitionOpts)) {
	        if(makeOnCompleteCallback) {
	            // If it was passed a callback to register completion, make a callback. If
	            // this is created, then it must be executed on completion, otherwise the
	            // pos-transition redraw will not execute:
	            onComplete = makeOnCompleteCallback();
	        }
	    }
	
	    Lib.makeTraceGroups(fullLayout._indicatorlayer, cdModule, 'trace').each(function(cd) {
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        var plotGroup = d3.select(this);
	
	        // Elements in trace
	        var hasGauge = trace._hasGauge;
	        var isAngular = trace._isAngular;
	        var isBullet = trace._isBullet;
	
	        // Domain size
	        var domain = trace.domain;
	        var size = {
	            w: fullLayout._size.w * (domain.x[1] - domain.x[0]),
	            h: fullLayout._size.h * (domain.y[1] - domain.y[0]),
	            l: fullLayout._size.l + fullLayout._size.w * domain.x[0],
	            r: fullLayout._size.r + fullLayout._size.w * (1 - domain.x[1]),
	            t: fullLayout._size.t + fullLayout._size.h * (1 - domain.y[1]),
	            b: fullLayout._size.b + fullLayout._size.h * (domain.y[0])
	        };
	        var centerX = size.l + size.w / 2;
	        var centerY = size.t + size.h / 2;
	
	        // Angular gauge size
	        var radius = Math.min(size.w / 2, size.h); // fill domain
	        var innerRadius = cn.innerRadius * radius;
	
	        // Position numbers based on mode and set the scaling logic
	        var numbersX, numbersY, numbersScaler;
	        var numbersAlign = trace.align || 'center';
	
	        numbersY = centerY;
	        if(!hasGauge) {
	            numbersX = size.l + position[numbersAlign] * size.w;
	            numbersScaler = function(el) {
	                return fitTextInsideBox(el, size.w, size.h);
	            };
	        } else {
	            if(isAngular) {
	                numbersX = centerX;
	                numbersY = centerY + radius / 2;
	                numbersScaler = function(el) {
	                    return fitTextInsideCircle(el, 0.9 * innerRadius);
	                };
	            }
	            if(isBullet) {
	                var padding = cn.bulletPadding;
	                var p = (1 - cn.bulletNumberDomainSize) + padding;
	                numbersX = size.l + (p + (1 - p) * position[numbersAlign]) * size.w;
	                numbersScaler = function(el) {
	                    return fitTextInsideBox(el, (cn.bulletNumberDomainSize - padding) * size.w, size.h);
	                };
	            }
	        }
	
	        // Draw numbers
	        drawNumbers(gd, plotGroup, cd, {
	            numbersX: numbersX,
	            numbersY: numbersY,
	            numbersScaler: numbersScaler,
	            transitionOpts: transitionOpts,
	            onComplete: onComplete
	        });
	
	        // Reexpress our gauge background attributes for drawing
	        var gaugeBg, gaugeOutline;
	        if(hasGauge) {
	            gaugeBg = {
	                range: trace.gauge.axis.range,
	                color: trace.gauge.bgcolor,
	                line: {
	                    color: trace.gauge.bordercolor,
	                    width: 0
	                },
	                thickness: 1
	            };
	
	            gaugeOutline = {
	                range: trace.gauge.axis.range,
	                color: 'rgba(0, 0, 0, 0)',
	                line: {
	                    color: trace.gauge.bordercolor,
	                    width: trace.gauge.borderwidth
	                },
	                thickness: 1
	            };
	        }
	
	        // Prepare angular gauge layers
	        var angularGauge = plotGroup.selectAll('g.angular').data(isAngular ? cd : []);
	        angularGauge.exit().remove();
	        var angularaxisLayer = plotGroup.selectAll('g.angularaxis').data(isAngular ? cd : []);
	        angularaxisLayer.exit().remove();
	
	        if(isAngular) {
	            drawAngularGauge(gd, plotGroup, cd, {
	                radius: radius,
	                innerRadius: innerRadius,
	
	                gauge: angularGauge,
	                layer: angularaxisLayer,
	                size: size,
	                gaugeBg: gaugeBg,
	                gaugeOutline: gaugeOutline,
	                transitionOpts: transitionOpts,
	                onComplete: onComplete
	            });
	        }
	
	        // Prepare bullet layers
	        var bulletGauge = plotGroup.selectAll('g.bullet').data(isBullet ? cd : []);
	        bulletGauge.exit().remove();
	        var bulletaxisLayer = plotGroup.selectAll('g.bulletaxis').data(isBullet ? cd : []);
	        bulletaxisLayer.exit().remove();
	
	        if(isBullet) {
	            drawBulletGauge(gd, plotGroup, cd, {
	                gauge: bulletGauge,
	                layer: bulletaxisLayer,
	                size: size,
	                gaugeBg: gaugeBg,
	                gaugeOutline: gaugeOutline,
	                transitionOpts: transitionOpts,
	                onComplete: onComplete
	            });
	        }
	
	        // title
	        var title = plotGroup.selectAll('text.title').data(cd);
	        title.exit().remove();
	        title.enter().append('text').classed('title', true);
	        title
	            .attr('text-anchor', function() {
	                return isBullet ? anchor.right : anchor[trace.title.align];
	            })
	            .text(trace.title.text)
	            .call(Drawing.font, trace.title.font)
	            .call(svgTextUtils.convertToTspans, gd);
	
	        // Position title
	        title.attr('transform', function() {
	            var titleX = size.l + size.w * position[trace.title.align];
	            var titleY;
	            var titlePadding = cn.titlePadding;
	            var titlebBox = Drawing.bBox(title.node());
	            if(hasGauge) {
	                if(isAngular) {
	                    // position above axis ticks/labels
	                    if(trace.gauge.axis.visible) {
	                        var bBox = Drawing.bBox(angularaxisLayer.node());
	                        titleY = (bBox.top - titlePadding) - titlebBox.bottom;
	                    } else {
	                        titleY = size.t + size.h / 2 - radius / 2 - titlebBox.bottom - titlePadding;
	                    }
	                }
	                if(isBullet) {
	                    // position outside domain
	                    titleY = numbersY - (titlebBox.top + titlebBox.bottom) / 2;
	                    titleX = size.l - cn.bulletPadding * size.w; // Outside domain, on the left
	                }
	            } else {
	                // position above numbers
	                titleY = (trace._numbersTop - titlePadding) - titlebBox.bottom;
	            }
	            return strTranslate(titleX, titleY);
	        });
	    });
	};
	
	function drawBulletGauge(gd, plotGroup, cd, opts) {
	    var trace = cd[0].trace;
	
	    var bullet = opts.gauge;
	    var axisLayer = opts.layer;
	    var gaugeBg = opts.gaugeBg;
	    var gaugeOutline = opts.gaugeOutline;
	    var size = opts.size;
	    var domain = trace.domain;
	
	    var transitionOpts = opts.transitionOpts;
	    var onComplete = opts.onComplete;
	
	    // preparing axis
	    var ax, vals, transFn, tickSign, shift;
	
	    // Enter bullet, axis
	    bullet.enter().append('g').classed('bullet', true);
	    bullet.attr('transform', 'translate(' + size.l + ', ' + size.t + ')');
	
	    axisLayer.enter().append('g')
	        .classed('bulletaxis', true)
	        .classed('crisp', true);
	    axisLayer.selectAll('g.' + 'xbulletaxis' + 'tick,path,text').remove();
	
	    // Draw bullet
	    var bulletHeight = size.h; // use all vertical domain
	    var innerBulletHeight = trace.gauge.bar.thickness * bulletHeight;
	    var bulletLeft = domain.x[0];
	    var bulletRight = domain.x[0] + (domain.x[1] - domain.x[0]) * ((trace._hasNumber || trace._hasDelta) ? (1 - cn.bulletNumberDomainSize) : 1);
	
	    ax = mockAxis(gd, trace.gauge.axis);
	    ax._id = 'xbulletaxis';
	    ax.domain = [bulletLeft, bulletRight];
	    ax.setScale();
	
	    vals = Axes.calcTicks(ax);
	    transFn = Axes.makeTransFn(ax);
	    tickSign = Axes.getTickSigns(ax)[2];
	
	    shift = size.t + size.h;
	    if(ax.visible) {
	        Axes.drawTicks(gd, ax, {
	            vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
	            layer: axisLayer,
	            path: Axes.makeTickPath(ax, shift, tickSign),
	            transFn: transFn
	        });
	
	        Axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: axisLayer,
	            transFn: transFn,
	            labelFns: Axes.makeLabelFns(ax, shift)
	        });
	    }
	
	    function drawRect(s) {
	        s
	            .attr('width', function(d) { return Math.max(0, ax.c2p(d.range[1]) - ax.c2p(d.range[0]));})
	            .attr('x', function(d) { return ax.c2p(d.range[0]);})
	            .attr('y', function(d) { return 0.5 * (1 - d.thickness) * bulletHeight;})
	            .attr('height', function(d) { return d.thickness * bulletHeight; });
	    }
	
	    // Draw bullet background, steps
	    var boxes = [gaugeBg].concat(trace.gauge.steps);
	    var bgBullet = bullet.selectAll('g.bg-bullet').data(boxes);
	    bgBullet.enter().append('g').classed('bg-bullet', true).append('rect');
	    bgBullet.select('rect')
	        .call(drawRect)
	        .call(styleShape);
	    bgBullet.exit().remove();
	
	    // Draw value bar with transitions
	    var fgBullet = bullet.selectAll('g.value-bullet').data([trace.gauge.bar]);
	    fgBullet.enter().append('g').classed('value-bullet', true).append('rect');
	    fgBullet.select('rect')
	        .attr('height', innerBulletHeight)
	        .attr('y', (bulletHeight - innerBulletHeight) / 2)
	        .call(styleShape);
	    if(hasTransition(transitionOpts)) {
	        fgBullet.select('rect')
	            .transition()
	            .duration(transitionOpts.duration)
	            .ease(transitionOpts.easing)
	            .each('end', function() { onComplete && onComplete(); })
	            .each('interrupt', function() { onComplete && onComplete(); })
	            .attr('width', Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))));
	    } else {
	        fgBullet.select('rect')
	            .attr('width', typeof cd[0].y === 'number' ?
	                Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))) :
	                0);
	    }
	    fgBullet.exit().remove();
	
	    var data = cd.filter(function() {return trace.gauge.threshold.value;});
	    var threshold = bullet.selectAll('g.threshold-bullet').data(data);
	    threshold.enter().append('g').classed('threshold-bullet', true).append('line');
	    threshold.select('line')
	        .attr('x1', ax.c2p(trace.gauge.threshold.value))
	        .attr('x2', ax.c2p(trace.gauge.threshold.value))
	        .attr('y1', (1 - trace.gauge.threshold.thickness) / 2 * bulletHeight)
	        .attr('y2', (1 - (1 - trace.gauge.threshold.thickness) / 2) * bulletHeight)
	        .call(Color.stroke, trace.gauge.threshold.line.color)
	        .style('stroke-width', trace.gauge.threshold.line.width);
	    threshold.exit().remove();
	
	    var bulletOutline = bullet.selectAll('g.gauge-outline').data([gaugeOutline]);
	    bulletOutline.enter().append('g').classed('gauge-outline', true).append('rect');
	    bulletOutline.select('rect')
	        .call(drawRect)
	        .call(styleShape);
	    bulletOutline.exit().remove();
	}
	
	function drawAngularGauge(gd, plotGroup, cd, opts) {
	    var trace = cd[0].trace;
	
	    var size = opts.size;
	    var radius = opts.radius;
	    var innerRadius = opts.innerRadius;
	    var gaugeBg = opts.gaugeBg;
	    var gaugeOutline = opts.gaugeOutline;
	    var gaugePosition = [size.l + size.w / 2, size.t + size.h / 2 + radius / 2];
	    var gauge = opts.gauge;
	    var axisLayer = opts.layer;
	
	    var transitionOpts = opts.transitionOpts;
	    var onComplete = opts.onComplete;
	
	    // circular gauge
	    var theta = Math.PI / 2;
	    function valueToAngle(v) {
	        var min = trace.gauge.axis.range[0];
	        var max = trace.gauge.axis.range[1];
	        var angle = (v - min) / (max - min) * Math.PI - theta;
	        if(angle < -theta) return -theta;
	        if(angle > theta) return theta;
	        return angle;
	    }
	
	    function arcPathGenerator(size) {
	        return d3.svg.arc()
	                  .innerRadius((innerRadius + radius) / 2 - size / 2 * (radius - innerRadius))
	                  .outerRadius((innerRadius + radius) / 2 + size / 2 * (radius - innerRadius))
	                  .startAngle(-theta);
	    }
	
	    function drawArc(p) {
	        p
	            .attr('d', function(d) {
	                return arcPathGenerator(d.thickness)
	                  .startAngle(valueToAngle(d.range[0]))
	                  .endAngle(valueToAngle(d.range[1]))();
	            });
	    }
	
	    // preparing axis
	    var ax, vals, transFn, tickSign;
	
	    // Enter gauge and axis
	    gauge.enter().append('g').classed('angular', true);
	    gauge.attr('transform', strTranslate(gaugePosition[0], gaugePosition[1]));
	
	    axisLayer.enter().append('g')
	        .classed('angularaxis', true)
	        .classed('crisp', true);
	    axisLayer.selectAll('g.' + 'xangularaxis' + 'tick,path,text').remove();
	
	    ax = mockAxis(gd, trace.gauge.axis);
	    ax.type = 'linear';
	    ax.range = trace.gauge.axis.range;
	    ax._id = 'xangularaxis'; // or 'y', but I don't think this makes a difference here
	    ax.setScale();
	
	    // 't'ick to 'g'eometric radians is used all over the place here
	    var t2g = function(d) {
	        return (ax.range[0] - d.x) / (ax.range[1] - ax.range[0]) * Math.PI + Math.PI;
	    };
	
	    var labelFns = {};
	    var out = Axes.makeLabelFns(ax, 0);
	    var labelStandoff = out.labelStandoff;
	    labelFns.xFn = function(d) {
	        var rad = t2g(d);
	        return Math.cos(rad) * labelStandoff;
	    };
	    labelFns.yFn = function(d) {
	        var rad = t2g(d);
	        var ff = Math.sin(rad) > 0 ? 0.2 : 1;
	        return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) +
	                Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
	    };
	    labelFns.anchorFn = function(d) {
	        var rad = t2g(d);
	        var cos = Math.cos(rad);
	        return Math.abs(cos) < 0.1 ?
	                'middle' :
	                (cos > 0 ? 'start' : 'end');
	    };
	    labelFns.heightFn = function(d, a, h) {
	        var rad = t2g(d);
	        return -0.5 * (1 + Math.sin(rad)) * h;
	    };
	    var _transFn = function(rad) {
	        return strTranslate(
	            gaugePosition[0] + radius * Math.cos(rad),
	            gaugePosition[1] - radius * Math.sin(rad)
	        );
	    };
	    transFn = function(d) {
	        return _transFn(t2g(d));
	    };
	    var transFn2 = function(d) {
	        var rad = t2g(d);
	        return _transFn(rad) + 'rotate(' + -rad2deg(rad) + ')';
	    };
	    vals = Axes.calcTicks(ax);
	    tickSign = Axes.getTickSigns(ax)[2];
	    if(ax.visible) {
	        tickSign = ax.ticks === 'inside' ? -1 : 1;
	        var pad = (ax.linewidth || 1) / 2;
	        Axes.drawTicks(gd, ax, {
	            vals: vals,
	            layer: axisLayer,
	            path: 'M' + (tickSign * pad) + ',0h' + (tickSign * ax.ticklen),
	            transFn: transFn2
	        });
	        Axes.drawLabels(gd, ax, {
	            vals: vals,
	            layer: axisLayer,
	            transFn: transFn,
	            labelFns: labelFns
	        });
	    }
	
	    // Draw background + steps
	    var arcs = [gaugeBg].concat(trace.gauge.steps);
	    var bgArc = gauge.selectAll('g.bg-arc').data(arcs);
	    bgArc.enter().append('g').classed('bg-arc', true).append('path');
	    bgArc.select('path').call(drawArc).call(styleShape);
	    bgArc.exit().remove();
	
	    // Draw foreground with transition
	    var valueArcPathGenerator = arcPathGenerator(trace.gauge.bar.thickness);
	    var valueArc = gauge.selectAll('g.value-arc').data([trace.gauge.bar]);
	    valueArc.enter().append('g').classed('value-arc', true).append('path');
	    var valueArcPath = valueArc.select('path');
	    if(hasTransition(transitionOpts)) {
	        valueArcPath
	            .transition()
	            .duration(transitionOpts.duration)
	            .ease(transitionOpts.easing)
	            .each('end', function() { onComplete && onComplete(); })
	            .each('interrupt', function() { onComplete && onComplete(); })
	            .attrTween('d', arcTween(valueArcPathGenerator, valueToAngle(cd[0].lastY), valueToAngle(cd[0].y)));
	        trace._lastValue = cd[0].y;
	    } else {
	        valueArcPath.attr('d', typeof cd[0].y === 'number' ?
	            valueArcPathGenerator.endAngle(valueToAngle(cd[0].y)) :
	            'M0,0Z');
	    }
	    valueArcPath.call(styleShape);
	    valueArc.exit().remove();
	
	    // Draw threshold
	    arcs = [];
	    var v = trace.gauge.threshold.value;
	    if(v) {
	        arcs.push({
	            range: [v, v],
	            color: trace.gauge.threshold.color,
	            line: {
	                color: trace.gauge.threshold.line.color,
	                width: trace.gauge.threshold.line.width
	            },
	            thickness: trace.gauge.threshold.thickness
	        });
	    }
	    var thresholdArc = gauge.selectAll('g.threshold-arc').data(arcs);
	    thresholdArc.enter().append('g').classed('threshold-arc', true).append('path');
	    thresholdArc.select('path').call(drawArc).call(styleShape);
	    thresholdArc.exit().remove();
	
	    // Draw border last
	    var gaugeBorder = gauge.selectAll('g.gauge-outline').data([gaugeOutline]);
	    gaugeBorder.enter().append('g').classed('gauge-outline', true).append('path');
	    gaugeBorder.select('path').call(drawArc).call(styleShape);
	    gaugeBorder.exit().remove();
	}
	
	function drawNumbers(gd, plotGroup, cd, opts) {
	    var trace = cd[0].trace;
	
	    var numbersX = opts.numbersX;
	    var numbersY = opts.numbersY;
	    var numbersAlign = trace.align || 'center';
	    var numbersAnchor = anchor[numbersAlign];
	
	    var transitionOpts = opts.transitionOpts;
	    var onComplete = opts.onComplete;
	
	    var numbers = Lib.ensureSingle(plotGroup, 'g', 'numbers');
	    var bignumberbBox, deltabBox;
	    var numbersbBox;
	
	    var data = [];
	    if(trace._hasNumber) data.push('number');
	    if(trace._hasDelta) {
	        data.push('delta');
	        if(trace.delta.position === 'left') data.reverse();
	    }
	    var sel = numbers.selectAll('text').data(data);
	    sel.enter().append('text');
	    sel
	        .attr('text-anchor', function() {return numbersAnchor;})
	        .attr('class', function(d) { return d;})
	        .attr('x', null)
	        .attr('y', null)
	        .attr('dx', null)
	        .attr('dy', null);
	    sel.exit().remove();
	
	    // Function to override the number formatting used during transitions
	    function transitionFormat(valueformat, fmt, from, to) {
	        // For now, do not display SI prefix if start and end value do not have any
	        if(valueformat.match('s') && // If using SI prefix
	            (from >= 0 !== to >= 0) && // If sign change
	            (!fmt(from).slice(-1).match(SI_PREFIX) && !fmt(to).slice(-1).match(SI_PREFIX)) // Has no SI prefix
	        ) {
	            var transitionValueFormat = valueformat.slice().replace('s', 'f').replace(/\d+/, function(m) { return parseInt(m) - 1;});
	            var transitionAx = mockAxis(gd, {tickformat: transitionValueFormat});
	            return function(v) {
	                // Switch to fixed precision if number is smaller than one
	                if(Math.abs(v) < 1) return Axes.tickText(transitionAx, v).text;
	                return fmt(v);
	            };
	        } else {
	            return fmt;
	        }
	    }
	
	    function drawBignumber() {
	        var bignumberAx = mockAxis(gd, {tickformat: trace.number.valueformat}, trace._range);
	        bignumberAx.setScale();
	        Axes.prepTicks(bignumberAx);
	
	        var fmt = function(v) { return Axes.tickText(bignumberAx, v).text;};
	        var bignumberSuffix = trace.number.suffix;
	        var bignumberPrefix = trace.number.prefix;
	
	        var number = numbers.select('text.number');
	
	        function writeNumber() {
	            var txt = typeof cd[0].y === 'number' ?
	                bignumberPrefix + fmt(cd[0].y) + bignumberSuffix :
	                '-';
	            number.text(txt)
	                .call(Drawing.font, trace.number.font)
	                .call(svgTextUtils.convertToTspans, gd);
	        }
	
	        if(hasTransition(transitionOpts)) {
	            number
	                .transition()
	                .duration(transitionOpts.duration)
	                .ease(transitionOpts.easing)
	                .each('end', function() { writeNumber(); onComplete && onComplete(); })
	                .each('interrupt', function() { writeNumber(); onComplete && onComplete(); })
	                .attrTween('text', function() {
	                    var that = d3.select(this);
	                    var interpolator = d3.interpolateNumber(cd[0].lastY, cd[0].y);
	                    trace._lastValue = cd[0].y;
	
	                    var transitionFmt = transitionFormat(trace.number.valueformat, fmt, cd[0].lastY, cd[0].y);
	                    return function(t) {
	                        that.text(bignumberPrefix + transitionFmt(interpolator(t)) + bignumberSuffix);
	                    };
	                });
	        } else {
	            writeNumber();
	        }
	
	        bignumberbBox = measureText(bignumberPrefix + fmt(cd[0].y) + bignumberSuffix, trace.number.font, numbersAnchor, gd);
	        return number;
	    }
	
	    function drawDelta() {
	        var deltaAx = mockAxis(gd, {tickformat: trace.delta.valueformat}, trace._range);
	        deltaAx.setScale();
	        Axes.prepTicks(deltaAx);
	
	        var deltaFmt = function(v) { return Axes.tickText(deltaAx, v).text;};
	        var deltaValue = function(d) {
	            var value = trace.delta.relative ? d.relativeDelta : d.delta;
	            return value;
	        };
	        var deltaFormatText = function(value, numberFmt) {
	            if(value === 0 || typeof value !== 'number' || isNaN(value)) return '-';
	            return (value > 0 ? trace.delta.increasing.symbol : trace.delta.decreasing.symbol) + numberFmt(value);
	        };
	        var deltaFill = function(d) {
	            return d.delta >= 0 ? trace.delta.increasing.color : trace.delta.decreasing.color;
	        };
	        if(trace._deltaLastValue === undefined) {
	            trace._deltaLastValue = deltaValue(cd[0]);
	        }
	        var delta = numbers.select('text.delta');
	        delta
	            .call(Drawing.font, trace.delta.font)
	            .call(Color.fill, deltaFill({delta: trace._deltaLastValue}));
	
	        function writeDelta() {
	            delta.text(deltaFormatText(deltaValue(cd[0]), deltaFmt))
	                .call(Color.fill, deltaFill(cd[0]))
	                .call(svgTextUtils.convertToTspans, gd);
	        }
	
	        if(hasTransition(transitionOpts)) {
	            delta
	                .transition()
	                .duration(transitionOpts.duration)
	                .ease(transitionOpts.easing)
	                .tween('text', function() {
	                    var that = d3.select(this);
	                    var to = deltaValue(cd[0]);
	                    var from = trace._deltaLastValue;
	                    var transitionFmt = transitionFormat(trace.delta.valueformat, deltaFmt, from, to);
	                    var interpolator = d3.interpolateNumber(from, to);
	                    trace._deltaLastValue = to;
	                    return function(t) {
	                        that.text(deltaFormatText(interpolator(t), transitionFmt));
	                        that.call(Color.fill, deltaFill({delta: interpolator(t)}));
	                    };
	                })
	                .each('end', function() { writeDelta(); onComplete && onComplete(); })
	                .each('interrupt', function() { writeDelta(); onComplete && onComplete(); });
	        } else {
	            writeDelta();
	        }
	
	        deltabBox = measureText(deltaFormatText(deltaValue(cd[0]), deltaFmt), trace.delta.font, numbersAnchor, gd);
	        return delta;
	    }
	
	    var key = trace.mode + trace.align;
	    var delta;
	    if(trace._hasDelta) {
	        delta = drawDelta();
	        key += trace.delta.position + trace.delta.font.size + trace.delta.font.family + trace.delta.valueformat;
	        key += trace.delta.increasing.symbol + trace.delta.decreasing.symbol;
	        numbersbBox = deltabBox;
	    }
	    if(trace._hasNumber) {
	        drawBignumber();
	        key += trace.number.font.size + trace.number.font.family + trace.number.valueformat + trace.number.suffix + trace.number.prefix;
	        numbersbBox = bignumberbBox;
	    }
	
	    // Position delta relative to bignumber
	    if(trace._hasDelta && trace._hasNumber) {
	        var bignumberCenter = [
	            (bignumberbBox.left + bignumberbBox.right) / 2,
	            (bignumberbBox.top + bignumberbBox.bottom) / 2
	        ];
	        var deltaCenter = [
	            (deltabBox.left + deltabBox.right) / 2,
	            (deltabBox.top + deltabBox.bottom) / 2
	        ];
	
	        var dx, dy;
	        var padding = 0.75 * trace.delta.font.size;
	        if(trace.delta.position === 'left') {
	            dx = cache(trace, 'deltaPos', 0, -1 * (bignumberbBox.width * (position[trace.align]) + deltabBox.width * (1 - position[trace.align]) + padding), key, Math.min);
	            dy = bignumberCenter[1] - deltaCenter[1];
	
	            numbersbBox = {
	                width: bignumberbBox.width + deltabBox.width + padding,
	                height: Math.max(bignumberbBox.height, deltabBox.height),
	                left: deltabBox.left + dx,
	                right: bignumberbBox.right,
	                top: Math.min(bignumberbBox.top, deltabBox.top + dy),
	                bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
	            };
	        }
	        if(trace.delta.position === 'right') {
	            dx = cache(trace, 'deltaPos', 0, bignumberbBox.width * (1 - position[trace.align]) + deltabBox.width * position[trace.align] + padding, key, Math.max);
	            dy = bignumberCenter[1] - deltaCenter[1];
	
	            numbersbBox = {
	                width: bignumberbBox.width + deltabBox.width + padding,
	                height: Math.max(bignumberbBox.height, deltabBox.height),
	                left: bignumberbBox.left,
	                right: deltabBox.right + dx,
	                top: Math.min(bignumberbBox.top, deltabBox.top + dy),
	                bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
	            };
	        }
	        if(trace.delta.position === 'bottom') {
	            dx = null;
	            dy = deltabBox.height;
	
	            numbersbBox = {
	                width: Math.max(bignumberbBox.width, deltabBox.width),
	                height: bignumberbBox.height + deltabBox.height,
	                left: Math.min(bignumberbBox.left, deltabBox.left),
	                right: Math.max(bignumberbBox.right, deltabBox.right),
	                top: bignumberbBox.bottom - bignumberbBox.height,
	                bottom: bignumberbBox.bottom + deltabBox.height
	            };
	        }
	        if(trace.delta.position === 'top') {
	            dx = null;
	            dy = bignumberbBox.top;
	
	            numbersbBox = {
	                width: Math.max(bignumberbBox.width, deltabBox.width),
	                height: bignumberbBox.height + deltabBox.height,
	                left: Math.min(bignumberbBox.left, deltabBox.left),
	                right: Math.max(bignumberbBox.right, deltabBox.right),
	                top: bignumberbBox.bottom - bignumberbBox.height - deltabBox.height,
	                bottom: bignumberbBox.bottom
	            };
	        }
	
	        delta.attr({dx: dx, dy: dy});
	    }
	
	    // Resize numbers to fit within space and position
	    if(trace._hasNumber || trace._hasDelta) {
	        numbers.attr('transform', function() {
	            var m = opts.numbersScaler(numbersbBox);
	            key += m[2];
	            var scaleRatio = cache(trace, 'numbersScale', 1, m[0], key, Math.min);
	            var translateY;
	            if(!trace._scaleNumbers) scaleRatio = 1;
	            if(trace._isAngular) {
	                // align vertically to bottom
	                translateY = numbersY - scaleRatio * numbersbBox.bottom;
	            } else {
	                // align vertically to center
	                translateY = numbersY - scaleRatio * (numbersbBox.top + numbersbBox.bottom) / 2;
	            }
	
	            // Stash the top position of numbersbBox for title positioning
	            trace._numbersTop = scaleRatio * (numbersbBox.top) + translateY;
	
	            var ref = numbersbBox[numbersAlign];
	            if(numbersAlign === 'center') ref = (numbersbBox.left + numbersbBox.right) / 2;
	            var translateX = numbersX - scaleRatio * ref;
	
	            // Stash translateX
	            translateX = cache(trace, 'numbersTranslate', 0, translateX, key, Math.max);
	            return strTranslate(translateX, translateY) + ' scale(' + scaleRatio + ')';
	        });
	    }
	}
	
	// Apply fill, stroke, stroke-width to SVG shape
	function styleShape(p) {
	    p
	        .each(function(d) { Color.stroke(d3.select(this), d.line.color);})
	        .each(function(d) { Color.fill(d3.select(this), d.color);})
	        .style('stroke-width', function(d) { return d.line.width;});
	}
	
	// Returns a tween for a transition’s "d" attribute, transitioning any selected
	// arcs from their current angle to the specified new angle.
	function arcTween(arc, endAngle, newAngle) {
	    return function() {
	        var interpolate = d3.interpolate(endAngle, newAngle);
	        return function(t) {
	            return arc.endAngle(interpolate(t))();
	        };
	    };
	}
	
	// mocks our axis
	function mockAxis(gd, opts, zrange) {
	    var fullLayout = gd._fullLayout;
	
	    var axisIn = Lib.extendFlat({
	        type: 'linear',
	        ticks: 'outside',
	        range: zrange,
	        showline: true
	    }, opts);
	
	    var axisOut = {
	        type: 'linear',
	        _id: 'x' + opts._id
	    };
	
	    var axisOptions = {
	        letter: 'x',
	        font: fullLayout.font,
	        noHover: true,
	        noTickson: true
	    };
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(axisIn, axisOut, axisLayoutAttrs, attr, dflt);
	    }
	
	    handleAxisDefaults(axisIn, axisOut, coerce, axisOptions, fullLayout);
	    handleAxisPositionDefaults(axisIn, axisOut, coerce, axisOptions);
	
	    return axisOut;
	}
	
	function strTranslate(x, y) {
	    return 'translate(' + x + ',' + y + ')';
	}
	
	function fitTextInsideBox(textBB, width, height) {
	    // compute scaling ratio to have text fit within specified width and height
	    var ratio = Math.min(width / textBB.width, height / textBB.height);
	    return [ratio, textBB, width + 'x' + height];
	}
	
	function fitTextInsideCircle(textBB, radius) {
	    // compute scaling ratio to have text fit within specified radius
	    var elRadius = Math.sqrt((textBB.width / 2) * (textBB.width / 2) + textBB.height * textBB.height);
	    var ratio = radius / elRadius;
	    return [ratio, textBB, radius];
	}
	
	function measureText(txt, font, textAnchor, gd) {
	    var element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
	    var sel = d3.select(element);
	    sel.text(txt)
	      .attr('x', 0)
	      .attr('y', 0)
	      .attr('text-anchor', textAnchor)
	      .attr('data-unformatted', txt)
	      .call(svgTextUtils.convertToTspans, gd)
	      .call(Drawing.font, font);
	    return Drawing.bBox(sel.node());
	}
	
	function cache(trace, name, initialValue, value, key, fn) {
	    var objName = '_cache' + name;
	    if(!(trace[objName] && trace[objName].key === key)) {
	        trace[objName] = {key: key, value: initialValue};
	    }
	    var v = Lib.aggNums(fn, null, [trace[objName].value, value], 2);
	    trace[objName].value = v;
	
	    return v;
	}
	
	},{"../../components/color":591,"../../components/drawing":612,"../../constants/alignment":685,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"../../plots/cartesian/axis_defaults":766,"../../plots/cartesian/layout_attributes":776,"../../plots/cartesian/position_defaults":779,"./constants":1050,"d3":164}],1054:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var meshAttrs = _dereq_('../mesh3d/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	function makeSliceAttr(axLetter) {
	    return {
	        show: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        locations: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        fill: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	        }
	    };
	}
	
	function makeCapAttr(axLetter) {
	    return {
	        show: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	        fill: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	        }
	    };
	}
	
	var attrs = module.exports = overrideAll(extendFlat({
	    x: {
	        valType: 'data_array',
	        
	        
	    },
	    y: {
	        valType: 'data_array',
	        
	        
	    },
	    z: {
	        valType: 'data_array',
	        
	        
	    },
	    value: {
	        valType: 'data_array',
	        
	        
	    },
	    isomin: {
	        valType: 'number',
	        
	        
	    },
	    isomax: {
	        valType: 'number',
	        
	        
	    },
	
	    surface: {
	        show: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	        count: {
	            valType: 'integer',
	            
	            dflt: 2,
	            min: 1,
	            
	        },
	        fill: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	        },
	        pattern: {
	            valType: 'flaglist',
	            flags: ['A', 'B', 'C', 'D', 'E'],
	            extras: ['all', 'odd', 'even'],
	            dflt: 'all',
	            
	            
	        }
	    },
	
	    spaceframe: {
	        show: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        fill: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 0.15,
	            
	        }
	    },
	
	    slices: {
	        x: makeSliceAttr('x'),
	        y: makeSliceAttr('y'),
	        z: makeSliceAttr('z')
	    },
	
	    caps: {
	        x: makeCapAttr('x'),
	        y: makeCapAttr('y'),
	        z: makeCapAttr('z')
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        
	    },
	    hovertemplate: hovertemplateAttrs()
	},
	
	colorScaleAttrs('', {
	    colorAttr: '`value`',
	    showScaleDflt: true,
	    editTypeOverride: 'calc'
	}), {
	    opacity: meshAttrs.opacity,
	    lightposition: meshAttrs.lightposition,
	    lighting: meshAttrs.lighting,
	    flatshading: meshAttrs.flatshading,
	    contour: meshAttrs.contour,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	}), 'calc', 'nested');
	
	// required defaults to speed up surface normal calculations
	attrs.flatshading.dflt = true; attrs.lighting.facenormalsepsilon.dflt = 0;
	
	attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
	attrs.transforms = undefined;
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../../plots/template_attributes":840,"../mesh3d/attributes":1059}],1055:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	
	module.exports = function calc(gd, trace) {
	    trace._len = Math.min(trace.x.length, trace.y.length, trace.z.length, trace.value.length);
	
	    var min = Infinity;
	    var max = -Infinity;
	    var len = trace.value.length;
	    for(var i = 0; i < len; i++) {
	        var v = trace.value[i];
	        min = Math.min(min, v);
	        max = Math.max(max, v);
	    }
	
	    trace._minValues = min;
	    trace._maxValues = max;
	
	    trace._vMin = (trace.isomin === undefined || trace.isomin === null) ? min : trace.isomin;
	    trace._vMax = (trace.isomax === undefined || trace.isomin === null) ? max : trace.isomax;
	
	    colorscaleCalc(gd, trace, {
	        vals: [trace._vMin, trace._vMax],
	        containerStr: '',
	        cLetter: 'c'
	    });
	};
	
	},{"../../components/colorscale/calc":599}],1056:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createMesh = _dereq_('gl-mesh3d');
	
	var Lib = _dereq_('../../lib');
	
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var zip3 = _dereq_('../../plots/gl3d/zip3');
	
	function distinctVals(col) {
	    return Lib.distinctVals(col).vals;
	}
	
	var findNearestOnAxis = function(w, arr) {
	    for(var q = arr.length - 1; q > 0; q--) {
	        var min = Math.min(arr[q], arr[q - 1]);
	        var max = Math.max(arr[q], arr[q - 1]);
	        if(max > min && min < w && w <= max) {
	            return {
	                id: q,
	                distRatio: (max - w) / (max - min)
	            };
	        }
	    }
	    return {
	        id: 0,
	        distRatio: 0
	    };
	};
	
	function IsosurfaceTrace(scene, mesh, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.mesh = mesh;
	    this.name = '';
	    this.data = null;
	    this.showContour = false;
	}
	
	var proto = IsosurfaceTrace.prototype;
	
	proto.handlePick = function(selection) {
	    if(selection.object === this.mesh) {
	        var rawId = selection.data.index;
	
	        var x = this.data._x[rawId];
	        var y = this.data._y[rawId];
	        var z = this.data._z[rawId];
	
	        var height = this.data._Ys.length;
	        var depth = this.data._Zs.length;
	
	        var i = findNearestOnAxis(x, this.data._Xs).id;
	        var j = findNearestOnAxis(y, this.data._Ys).id;
	        var k = findNearestOnAxis(z, this.data._Zs).id;
	
	        var selectIndex = selection.index = k + depth * j + depth * height * i;
	
	        selection.traceCoordinate = [
	            this.data._x[selectIndex],
	            this.data._y[selectIndex],
	            this.data._z[selectIndex],
	            this.data.value[selectIndex]
	        ];
	
	        var text = this.data.hovertext || this.data.text;
	        if(Array.isArray(text) && text[selectIndex] !== undefined) {
	            selection.textLabel = text[selectIndex];
	        } else if(text) {
	            selection.textLabel = text;
	        }
	
	        return true;
	    }
	};
	
	proto.update = function(data) {
	    var scene = this.scene;
	    var layout = scene.fullSceneLayout;
	
	    this.data = generateIsoMeshes(data);
	
	    // Unpack position data
	    function toDataCoords(axis, coord, scale, calendar) {
	        return coord.map(function(x) {
	            return axis.d2l(x, 0, calendar) * scale;
	        });
	    }
	
	    var positions = zip3(
	        toDataCoords(layout.xaxis, data._x, scene.dataScale[0], data.xcalendar),
	        toDataCoords(layout.yaxis, data._y, scene.dataScale[1], data.ycalendar),
	        toDataCoords(layout.zaxis, data._z, scene.dataScale[2], data.zcalendar));
	
	    var cells = zip3(data._i, data._j, data._k);
	
	    var config = {
	        positions: positions,
	        cells: cells,
	        lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	        ambient: data.lighting.ambient,
	        diffuse: data.lighting.diffuse,
	        specular: data.lighting.specular,
	        roughness: data.lighting.roughness,
	        fresnel: data.lighting.fresnel,
	        vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	        faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	        opacity: data.opacity,
	        contourEnable: data.contour.show,
	        contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	        contourWidth: data.contour.width,
	        useFacetNormals: data.flatshading
	    };
	
	    var cOpts = extractOpts(data);
	    config.vertexIntensity = data._intensity;
	    config.vertexIntensityBounds = [cOpts.min, cOpts.max];
	    config.colormap = parseColorScale(data);
	
	    // Update mesh
	    this.mesh.update(config);
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.mesh);
	    this.mesh.dispose();
	};
	
	function generateIsoMeshes(data) {
	    data._i = [];
	    data._j = [];
	    data._k = [];
	
	    var showSurface = data.surface.show;
	    var showSpaceframe = data.spaceframe.show;
	
	    var surfaceFill = data.surface.fill;
	    var spaceframeFill = data.spaceframe.fill;
	
	    var drawingSurface = false;
	    var drawingSpaceframe = false;
	
	    var numFaces = 0;
	    var numVertices;
	    var beginVertextLength;
	
	    var Xs = distinctVals(data.x.slice(0, data._len));
	    var Ys = distinctVals(data.y.slice(0, data._len));
	    var Zs = distinctVals(data.z.slice(0, data._len));
	
	    var width = Xs.length;
	    var height = Ys.length;
	    var depth = Zs.length;
	
	    function getIndex(i, j, k) {
	        return k + depth * j + depth * height * i;
	    }
	
	    var minValues = data._minValues;
	    var maxValues = data._maxValues;
	
	    var vMin = data._vMin;
	    var vMax = data._vMax;
	
	    var allXs;
	    var allYs;
	    var allZs;
	    var allVs;
	
	    function findVertexId(x, y, z) {
	        // could be used to find the vertex id of previously generated vertex within the group
	
	        var len = allVs.length;
	        for(var f = beginVertextLength; f < len; f++) {
	            if(
	                x === allXs[f] &&
	                y === allYs[f] &&
	                z === allZs[f]
	            ) {
	                return f;
	            }
	        }
	        return -1;
	    }
	
	    function beginGroup() {
	        beginVertextLength = numVertices;
	    }
	
	    function emptyVertices() {
	        allXs = [];
	        allYs = [];
	        allZs = [];
	        allVs = [];
	        numVertices = 0;
	
	        beginGroup();
	    }
	
	    function addVertex(x, y, z, v) {
	        allXs.push(x);
	        allYs.push(y);
	        allZs.push(z);
	        allVs.push(v);
	        numVertices++;
	
	        return numVertices - 1;
	    }
	
	    function addFace(a, b, c) {
	        data._i.push(a);
	        data._j.push(b);
	        data._k.push(c);
	        numFaces++;
	
	        return numFaces - 1;
	    }
	
	    function getCenter(A, B, C) {
	        var M = [];
	        for(var i = 0; i < A.length; i++) {
	            M[i] = (A[i] + B[i] + C[i]) / 3.0;
	        }
	        return M;
	    }
	
	    function getBetween(A, B, r) {
	        var M = [];
	        for(var i = 0; i < A.length; i++) {
	            M[i] = A[i] * (1 - r) + r * B[i];
	        }
	        return M;
	    }
	
	    var activeFill;
	    function setFill(fill) {
	        activeFill = fill;
	    }
	
	    function createOpenTri(xyzv, abc) {
	        var A = xyzv[0];
	        var B = xyzv[1];
	        var C = xyzv[2];
	        var G = getCenter(A, B, C);
	
	        var r = Math.sqrt(1 - activeFill);
	        var p1 = getBetween(G, A, r);
	        var p2 = getBetween(G, B, r);
	        var p3 = getBetween(G, C, r);
	
	        var a = abc[0];
	        var b = abc[1];
	        var c = abc[2];
	
	        return {
	            xyzv: [
	                [A, B, p2], [p2, p1, A],
	                [B, C, p3], [p3, p2, B],
	                [C, A, p1], [p1, p3, C]
	            ],
	            abc: [
	                [a, b, -1], [-1, -1, a],
	                [b, c, -1], [-1, -1, b],
	                [c, a, -1], [-1, -1, c]
	            ]
	        };
	    }
	
	    function styleIncludes(style, char) {
	        if(style === 'all' || style === null) return true;
	        return (style.indexOf(char) > -1);
	    }
	
	    function mapValue(style, value) {
	        if(style === null) return value;
	        return style;
	    }
	
	    function drawTri(style, xyzv, abc) {
	        beginGroup();
	
	        var allXYZVs = [xyzv];
	        var allABCs = [abc];
	        if(activeFill >= 1) {
	            allXYZVs = [xyzv];
	            allABCs = [abc];
	        } else if(activeFill > 0) {
	            var openTri = createOpenTri(xyzv, abc);
	            allXYZVs = openTri.xyzv;
	            allABCs = openTri.abc;
	        }
	
	        for(var f = 0; f < allXYZVs.length; f++) {
	            xyzv = allXYZVs[f];
	            abc = allABCs[f];
	
	            var pnts = [];
	            for(var i = 0; i < 3; i++) {
	                var x = xyzv[i][0];
	                var y = xyzv[i][1];
	                var z = xyzv[i][2];
	                var v = xyzv[i][3];
	
	                var id = (abc[i] > -1) ? abc[i] : findVertexId(x, y, z);
	                if(id > -1) {
	                    pnts[i] = id;
	                } else {
	                    pnts[i] = addVertex(x, y, z, mapValue(style, v));
	                }
	            }
	
	            addFace(pnts[0], pnts[1], pnts[2]);
	        }
	    }
	
	    function drawQuad(style, xyzv, abcd) {
	        var makeTri = function(i, j, k) {
	            drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
	        };
	
	        makeTri(0, 1, 2);
	        makeTri(2, 3, 0);
	    }
	
	    function drawTetra(style, xyzv, abcd) {
	        var makeTri = function(i, j, k) {
	            drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
	        };
	
	        makeTri(0, 1, 2);
	        makeTri(3, 0, 1);
	        makeTri(2, 3, 0);
	        makeTri(1, 2, 3);
	    }
	
	    function calcIntersection(pointOut, pointIn, min, max) {
	        var value = pointOut[3];
	
	        if(value < min) value = min;
	        if(value > max) value = max;
	
	        var ratio = (pointOut[3] - value) / (pointOut[3] - pointIn[3] + 0.000000001); // we had to add this error to force solve the tiny caps
	
	        var result = [];
	        for(var s = 0; s < 4; s++) {
	            result[s] = (1 - ratio) * pointOut[s] + ratio * pointIn[s];
	        }
	        return result;
	    }
	
	    function inRange(value, min, max) {
	        return (
	            value >= min &&
	            value <= max
	        );
	    }
	
	    function almostInFinalRange(value) {
	        var vErr = 0.001 * (vMax - vMin);
	        return (
	            value >= vMin - vErr &&
	            value <= vMax + vErr
	        );
	    }
	
	    function getXYZV(indecies) {
	        var xyzv = [];
	        for(var q = 0; q < 4; q++) {
	            var index = indecies[q];
	            xyzv.push(
	                [
	                    data.x[index],
	                    data.y[index],
	                    data.z[index],
	                    data.value[index]
	                ]
	            );
	        }
	
	        return xyzv;
	    }
	
	    var MAX_PASS = 3;
	
	    function tryCreateTri(style, xyzv, abc, min, max, nPass) {
	        if(!nPass) nPass = 1;
	
	        abc = [-1, -1, -1]; // Note: for the moment we override indices
	        // to run faster! But it is possible to comment this line
	        // to reduce the number of vertices.
	
	        var result = false;
	
	        var ok = [
	            inRange(xyzv[0][3], min, max),
	            inRange(xyzv[1][3], min, max),
	            inRange(xyzv[2][3], min, max)
	        ];
	
	        if(!ok[0] && !ok[1] && !ok[2]) {
	            return false;
	        }
	
	        var tryDrawTri = function(style, xyzv, abc) {
	            if( // we check here if the points are in `real` iso-min/max range
	                almostInFinalRange(xyzv[0][3]) &&
	                almostInFinalRange(xyzv[1][3]) &&
	                almostInFinalRange(xyzv[2][3])
	            ) {
	                drawTri(style, xyzv, abc);
	                return true;
	            } else if(nPass < MAX_PASS) {
	                return tryCreateTri(style, xyzv, abc, vMin, vMax, ++nPass); // i.e. second pass using actual vMin vMax bounds
	            }
	            return false;
	        };
	
	        if(ok[0] && ok[1] && ok[2]) {
	            return tryDrawTri(style, xyzv, abc) || result;
	        }
	
	        var interpolated = false;
	
	        [
	            [0, 1, 2],
	            [2, 0, 1],
	            [1, 2, 0]
	        ].forEach(function(e) {
	            if(ok[e[0]] && ok[e[1]] && !ok[e[2]]) {
	                var A = xyzv[e[0]];
	                var B = xyzv[e[1]];
	                var C = xyzv[e[2]];
	
	                var p1 = calcIntersection(C, A, min, max);
	                var p2 = calcIntersection(C, B, min, max);
	
	                result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
	                result = tryDrawTri(style, [A, B, p2], [abc[e[0]], abc[e[1]], -1]) || result;
	
	                interpolated = true;
	            }
	        });
	        if(interpolated) return result;
	
	        [
	            [0, 1, 2],
	            [1, 2, 0],
	            [2, 0, 1]
	        ].forEach(function(e) {
	            if(ok[e[0]] && !ok[e[1]] && !ok[e[2]]) {
	                var A = xyzv[e[0]];
	                var B = xyzv[e[1]];
	                var C = xyzv[e[2]];
	
	                var p1 = calcIntersection(B, A, min, max);
	                var p2 = calcIntersection(C, A, min, max);
	
	                result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
	
	                interpolated = true;
	            }
	        });
	        return result;
	    }
	
	    function tryCreateTetra(style, abcd, min, max) {
	        var result = false;
	
	        var xyzv = getXYZV(abcd);
	
	        var ok = [
	            inRange(xyzv[0][3], min, max),
	            inRange(xyzv[1][3], min, max),
	            inRange(xyzv[2][3], min, max),
	            inRange(xyzv[3][3], min, max)
	        ];
	
	        if(!ok[0] && !ok[1] && !ok[2] && !ok[3]) {
	            return result;
	        }
	
	        if(ok[0] && ok[1] && ok[2] && ok[3]) {
	            if(drawingSpaceframe) {
	                result = drawTetra(style, xyzv, abcd) || result;
	            }
	            return result;
	        }
	
	        var interpolated = false;
	
	        [
	            [0, 1, 2, 3],
	            [3, 0, 1, 2],
	            [2, 3, 0, 1],
	            [1, 2, 3, 0]
	        ].forEach(function(e) {
	            if(ok[e[0]] && ok[e[1]] && ok[e[2]] && !ok[e[3]]) {
	                var A = xyzv[e[0]];
	                var B = xyzv[e[1]];
	                var C = xyzv[e[2]];
	                var D = xyzv[e[3]];
	
	                if(drawingSpaceframe) {
	                    result = drawTri(style, [A, B, C], [abcd[e[0]], abcd[e[1]], abcd[e[2]]]) || result;
	                } else {
	                    var p1 = calcIntersection(D, A, min, max);
	                    var p2 = calcIntersection(D, B, min, max);
	                    var p3 = calcIntersection(D, C, min, max);
	
	                    result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
	                }
	
	                interpolated = true;
	            }
	        });
	        if(interpolated) return result;
	
	        [
	            [0, 1, 2, 3],
	            [1, 2, 3, 0],
	            [2, 3, 0, 1],
	            [3, 0, 1, 2],
	            [0, 2, 3, 1],
	            [1, 3, 2, 0]
	        ].forEach(function(e) {
	            if(ok[e[0]] && ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
	                var A = xyzv[e[0]];
	                var B = xyzv[e[1]];
	                var C = xyzv[e[2]];
	                var D = xyzv[e[3]];
	
	                var p1 = calcIntersection(C, A, min, max);
	                var p2 = calcIntersection(C, B, min, max);
	                var p3 = calcIntersection(D, B, min, max);
	                var p4 = calcIntersection(D, A, min, max);
	
	                if(drawingSpaceframe) {
	                    result = drawTri(style, [A, p4, p1], [abcd[e[0]], -1, -1]) || result;
	                    result = drawTri(style, [B, p2, p3], [abcd[e[1]], -1, -1]) || result;
	                } else {
	                    result = drawQuad(null, [p1, p2, p3, p4], [-1, -1, -1, -1]) || result;
	                }
	
	                interpolated = true;
	            }
	        });
	        if(interpolated) return result;
	
	        [
	            [0, 1, 2, 3],
	            [1, 2, 3, 0],
	            [2, 3, 0, 1],
	            [3, 0, 1, 2]
	        ].forEach(function(e) {
	            if(ok[e[0]] && !ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
	                var A = xyzv[e[0]];
	                var B = xyzv[e[1]];
	                var C = xyzv[e[2]];
	                var D = xyzv[e[3]];
	
	                var p1 = calcIntersection(B, A, min, max);
	                var p2 = calcIntersection(C, A, min, max);
	                var p3 = calcIntersection(D, A, min, max);
	
	                if(drawingSpaceframe) {
	                    result = drawTri(style, [A, p1, p2], [abcd[e[0]], -1, -1]) || result;
	                    result = drawTri(style, [A, p2, p3], [abcd[e[0]], -1, -1]) || result;
	                    result = drawTri(style, [A, p3, p1], [abcd[e[0]], -1, -1]) || result;
	                } else {
	                    result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
	                }
	
	                interpolated = true;
	            }
	        });
	        return result;
	    }
	
	    function addCube(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max) {
	        var result = false;
	
	        if(drawingSurface) {
	            if(styleIncludes(style, 'A')) {
	                result = tryCreateTetra(null, [p000, p001, p010, p100], min, max) || result;
	            }
	            if(styleIncludes(style, 'B')) {
	                result = tryCreateTetra(null, [p001, p010, p011, p111], min, max) || result;
	            }
	            if(styleIncludes(style, 'C')) {
	                result = tryCreateTetra(null, [p001, p100, p101, p111], min, max) || result;
	            }
	            if(styleIncludes(style, 'D')) {
	                result = tryCreateTetra(null, [p010, p100, p110, p111], min, max) || result;
	            }
	            if(styleIncludes(style, 'E')) {
	                result = tryCreateTetra(null, [p001, p010, p100, p111], min, max) || result;
	            }
	        }
	
	        if(drawingSpaceframe) {
	            result = tryCreateTetra(style, [p001, p010, p100, p111], min, max) || result;
	        }
	
	        return result;
	    }
	
	    function addRect(style, a, b, c, d, min, max, previousResult) {
	        return [
	            (previousResult[0] === true) ? true :
	            tryCreateTri(style, getXYZV([a, b, c]), [a, b, c], min, max),
	            (previousResult[1] === true) ? true :
	            tryCreateTri(style, getXYZV([c, d, a]), [c, d, a], min, max)
	        ];
	    }
	
	    function begin2dCell(style, p00, p01, p10, p11, min, max, isEven, previousResult) {
	        // used to create caps and/or slices on exact axis points
	        if(isEven) {
	            return addRect(style, p00, p01, p11, p10, min, max, previousResult);
	        } else {
	            return addRect(style, p01, p11, p10, p00, min, max, previousResult);
	        }
	    }
	
	    function beginSection(style, i, j, k, min, max, distRatios) {
	        // used to create slices between axis points
	
	        var result = false;
	        var A, B, C, D;
	
	        var makeSection = function() {
	            result = tryCreateTri(style, [A, B, C], [-1, -1, -1], min, max) || result;
	            result = tryCreateTri(style, [C, D, A], [-1, -1, -1], min, max) || result;
	        };
	
	        var rX = distRatios[0];
	        var rY = distRatios[1];
	        var rZ = distRatios[2];
	
	        if(rX) {
	            A = getBetween(getXYZV([getIndex(i, j - 0, k - 0)])[0], getXYZV([getIndex(i - 1, j - 0, k - 0)])[0], rX);
	            B = getBetween(getXYZV([getIndex(i, j - 0, k - 1)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rX);
	            C = getBetween(getXYZV([getIndex(i, j - 1, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rX);
	            D = getBetween(getXYZV([getIndex(i, j - 1, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rX);
	            makeSection();
	        }
	
	        if(rY) {
	            A = getBetween(getXYZV([getIndex(i - 0, j, k - 0)])[0], getXYZV([getIndex(i - 0, j - 1, k - 0)])[0], rY);
	            B = getBetween(getXYZV([getIndex(i - 0, j, k - 1)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rY);
	            C = getBetween(getXYZV([getIndex(i - 1, j, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rY);
	            D = getBetween(getXYZV([getIndex(i - 1, j, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rY);
	            makeSection();
	        }
	
	        if(rZ) {
	            A = getBetween(getXYZV([getIndex(i - 0, j - 0, k)])[0], getXYZV([getIndex(i - 0, j - 0, k - 1)])[0], rZ);
	            B = getBetween(getXYZV([getIndex(i - 0, j - 1, k)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rZ);
	            C = getBetween(getXYZV([getIndex(i - 1, j - 1, k)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rZ);
	            D = getBetween(getXYZV([getIndex(i - 1, j - 0, k)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rZ);
	            makeSection();
	        }
	
	        return result;
	    }
	
	    function begin3dCell(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max, isEven) {
	        // used to create spaceframe and/or iso-surfaces
	
	        var cellStyle = style;
	        if(isEven) {
	            if(drawingSurface && style === 'even') cellStyle = null;
	            return addCube(cellStyle, p000, p001, p010, p011, p100, p101, p110, p111, min, max);
	        } else {
	            if(drawingSurface && style === 'odd') cellStyle = null;
	            return addCube(cellStyle, p111, p110, p101, p100, p011, p010, p001, p000, min, max);
	        }
	    }
	
	    function draw2dX(style, items, min, max, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var i = items[q];
	            for(var k = 1; k < depth; k++) {
	                for(var j = 1; j < height; j++) {
	                    result.push(
	                        begin2dCell(style,
	                            getIndex(i, j - 1, k - 1),
	                            getIndex(i, j - 1, k),
	                            getIndex(i, j, k - 1),
	                            getIndex(i, j, k),
	                            min,
	                            max,
	                            (i + j + k) % 2,
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function draw2dY(style, items, min, max, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var j = items[q];
	            for(var i = 1; i < width; i++) {
	                for(var k = 1; k < depth; k++) {
	                    result.push(
	                        begin2dCell(style,
	                            getIndex(i - 1, j, k - 1),
	                            getIndex(i, j, k - 1),
	                            getIndex(i - 1, j, k),
	                            getIndex(i, j, k),
	                            min,
	                            max,
	                            (i + j + k) % 2,
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function draw2dZ(style, items, min, max, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var k = items[q];
	            for(var j = 1; j < height; j++) {
	                for(var i = 1; i < width; i++) {
	                    result.push(
	                        begin2dCell(style,
	                            getIndex(i - 1, j - 1, k),
	                            getIndex(i - 1, j, k),
	                            getIndex(i, j - 1, k),
	                            getIndex(i, j, k),
	                            min,
	                            max,
	                            (i + j + k) % 2,
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function draw3d(style, min, max) {
	        for(var k = 1; k < depth; k++) {
	            for(var j = 1; j < height; j++) {
	                for(var i = 1; i < width; i++) {
	                    begin3dCell(style,
	                        getIndex(i - 1, j - 1, k - 1),
	                        getIndex(i - 1, j - 1, k),
	                        getIndex(i - 1, j, k - 1),
	                        getIndex(i - 1, j, k),
	                        getIndex(i, j - 1, k - 1),
	                        getIndex(i, j - 1, k),
	                        getIndex(i, j, k - 1),
	                        getIndex(i, j, k),
	                        min,
	                        max,
	                        (i + j + k) % 2
	                    );
	                }
	            }
	        }
	    }
	
	    function drawSpaceframe(style, min, max) {
	        drawingSpaceframe = true;
	        draw3d(style, min, max);
	        drawingSpaceframe = false;
	    }
	
	    function drawSurface(style, min, max) {
	        drawingSurface = true;
	        draw3d(style, min, max);
	        drawingSurface = false;
	    }
	
	    function drawSectionX(style, items, min, max, distRatios, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var i = items[q];
	            for(var k = 1; k < depth; k++) {
	                for(var j = 1; j < height; j++) {
	                    result.push(
	                        beginSection(style, i, j, k, min, max, distRatios[q],
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function drawSectionY(style, items, min, max, distRatios, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var j = items[q];
	            for(var i = 1; i < width; i++) {
	                for(var k = 1; k < depth; k++) {
	                    result.push(
	                        beginSection(style, i, j, k, min, max, distRatios[q],
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function drawSectionZ(style, items, min, max, distRatios, previousResult) {
	        var result = [];
	        var n = 0;
	        for(var q = 0; q < items.length; q++) {
	            var k = items[q];
	            for(var j = 1; j < height; j++) {
	                for(var i = 1; i < width; i++) {
	                    result.push(
	                        beginSection(style, i, j, k, min, max, distRatios[q],
	                            (previousResult && previousResult[n]) ? previousResult[n] : []
	                        )
	                    );
	                    n++;
	                }
	            }
	        }
	        return result;
	    }
	
	    function createRange(a, b) {
	        var range = [];
	        for(var q = a; q < b; q++) {
	            range.push(q);
	        }
	        return range;
	    }
	
	    function insertGridPoints() {
	        for(var i = 0; i < width; i++) {
	            for(var j = 0; j < height; j++) {
	                for(var k = 0; k < depth; k++) {
	                    var index = getIndex(i, j, k);
	                    addVertex(
	                        data.x[index],
	                        data.y[index],
	                        data.z[index],
	                        data.value[index]
	                    );
	                }
	            }
	        }
	    }
	
	    function drawAll() {
	        emptyVertices();
	
	        // insert grid points
	        insertGridPoints();
	
	        var activeStyle = null;
	
	        // draw spaceframes
	        if(showSpaceframe && spaceframeFill) {
	            setFill(spaceframeFill);
	
	            drawSpaceframe(activeStyle, vMin, vMax);
	        }
	
	        // draw iso-surfaces
	        if(showSurface && surfaceFill) {
	            setFill(surfaceFill);
	
	            var surfacePattern = data.surface.pattern;
	            var surfaceCount = data.surface.count;
	            for(var q = 0; q < surfaceCount; q++) {
	                var ratio = (surfaceCount === 1) ? 0.5 : q / (surfaceCount - 1);
	                var level = (1 - ratio) * vMin + ratio * vMax;
	
	                var d1 = Math.abs(level - minValues);
	                var d2 = Math.abs(level - maxValues);
	                var ranges = (d1 > d2) ?
	                    [minValues, level] :
	                    [level, maxValues];
	
	                drawSurface(surfacePattern, ranges[0], ranges[1]);
	            }
	        }
	
	        var setupMinMax = [
	            [ Math.min(vMin, maxValues), Math.max(vMin, maxValues) ],
	            [ Math.min(minValues, vMax), Math.max(minValues, vMax) ]
	        ];
	
	        ['x', 'y', 'z'].forEach(function(e) {
	            var preRes = [];
	            for(var s = 0; s < setupMinMax.length; s++) {
	                var count = 0;
	
	                var activeMin = setupMinMax[s][0];
	                var activeMax = setupMinMax[s][1];
	
	                // draw slices
	                var slice = data.slices[e];
	                if(slice.show && slice.fill) {
	                    setFill(slice.fill);
	
	                    var exactIndices = [];
	                    var ceilIndices = [];
	                    var distRatios = [];
	                    if(slice.locations.length) {
	                        for(var q = 0; q < slice.locations.length; q++) {
	                            var near = findNearestOnAxis(
	                                slice.locations[q],
	                                (e === 'x') ? Xs :
	                                (e === 'y') ? Ys : Zs
	                            );
	
	                            if(near.distRatio === 0) {
	                                exactIndices.push(near.id);
	                            } else if(near.id > 0) {
	                                ceilIndices.push(near.id);
	                                if(e === 'x') {
	                                    distRatios.push([near.distRatio, 0, 0]);
	                                } else if(e === 'y') {
	                                    distRatios.push([0, near.distRatio, 0]);
	                                } else {
	                                    distRatios.push([0, 0, near.distRatio]);
	                                }
	                            }
	                        }
	                    } else {
	                        if(e === 'x') {
	                            exactIndices = createRange(1, width - 1);
	                        } else if(e === 'y') {
	                            exactIndices = createRange(1, height - 1);
	                        } else {
	                            exactIndices = createRange(1, depth - 1);
	                        }
	                    }
	
	                    if(ceilIndices.length > 0) {
	                        if(e === 'x') {
	                            preRes[count] = drawSectionX(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        } else if(e === 'y') {
	                            preRes[count] = drawSectionY(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        } else {
	                            preRes[count] = drawSectionZ(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        }
	                        count++;
	                    }
	
	                    if(exactIndices.length > 0) {
	                        if(e === 'x') {
	                            preRes[count] = draw2dX(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        } else if(e === 'y') {
	                            preRes[count] = draw2dY(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        } else {
	                            preRes[count] = draw2dZ(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        }
	                        count++;
	                    }
	                }
	
	                // draw caps
	                var cap = data.caps[e];
	                if(cap.show && cap.fill) {
	                    setFill(cap.fill);
	                    if(e === 'x') {
	                        preRes[count] = draw2dX(activeStyle, [0, width - 1], activeMin, activeMax, preRes[count]);
	                    } else if(e === 'y') {
	                        preRes[count] = draw2dY(activeStyle, [0, height - 1], activeMin, activeMax, preRes[count]);
	                    } else {
	                        preRes[count] = draw2dZ(activeStyle, [0, depth - 1], activeMin, activeMax, preRes[count]);
	                    }
	                    count++;
	                }
	            }
	        });
	
	        // remove vertices arrays (i.e. grid points) in case no face was created.
	        if(numFaces === 0) {
	            emptyVertices();
	        }
	
	        data._x = allXs;
	        data._y = allYs;
	        data._z = allZs;
	        data._intensity = allVs;
	
	        data._Xs = Xs;
	        data._Ys = Ys;
	        data._Zs = Zs;
	    }
	
	    drawAll();
	
	    return data;
	}
	
	function createIsosurfaceTrace(scene, data) {
	    var gl = scene.glplot.gl;
	    var mesh = createMesh({gl: gl});
	    var result = new IsosurfaceTrace(scene, mesh, data.uid);
	
	    mesh._trace = result;
	    result.update(data);
	    scene.glplot.add(mesh);
	    return result;
	}
	
	module.exports = {
	    findNearestOnAxis: findNearestOnAxis,
	    generateIsoMeshes: generateIsoMeshes,
	    createIsosurfaceTrace: createIsosurfaceTrace,
	};
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gl_format_color":713,"../../lib/str2rgbarray":739,"../../plots/gl3d/zip3":815,"gl-mesh3d":282}],1057:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	var attributes = _dereq_('./attributes');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	}
	
	function supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	    var isomin = coerce('isomin');
	    var isomax = coerce('isomax');
	
	    if(isomax !== undefined && isomax !== null &&
	        isomin !== undefined && isomin !== null &&
	         isomin > isomax) {
	        // applying default values in this case:
	        traceOut.isomin = null;
	        traceOut.isomax = null;
	    }
	
	    var x = coerce('x');
	    var y = coerce('y');
	    var z = coerce('z');
	    var value = coerce('value');
	
	    if(
	        !x || !x.length ||
	        !y || !y.length ||
	        !z || !z.length ||
	        !value || !value.length
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
	
	    ['x', 'y', 'z'].forEach(function(dim) {
	        var capDim = 'caps.' + dim;
	        var showCap = coerce(capDim + '.show');
	        if(showCap) {
	            coerce(capDim + '.fill');
	        }
	
	        var sliceDim = 'slices.' + dim;
	        var showSlice = coerce(sliceDim + '.show');
	        if(showSlice) {
	            coerce(sliceDim + '.fill');
	            coerce(sliceDim + '.locations');
	        }
	    });
	
	    var showSpaceframe = coerce('spaceframe.show');
	    if(showSpaceframe) {
	        coerce('spaceframe.fill');
	    }
	
	    var showSurface = coerce('surface.show');
	    if(showSurface) {
	        coerce('surface.count');
	        coerce('surface.fill');
	        coerce('surface.pattern');
	    }
	
	    var showContour = coerce('contour.show');
	    if(showContour) {
	        coerce('contour.color');
	        coerce('contour.width');
	    }
	
	    // Coerce remaining properties
	    [
	        'text',
	        'hovertext',
	        'hovertemplate',
	        'lighting.ambient',
	        'lighting.diffuse',
	        'lighting.specular',
	        'lighting.roughness',
	        'lighting.fresnel',
	        'lighting.vertexnormalsepsilon',
	        'lighting.facenormalsepsilon',
	        'lightposition.x',
	        'lightposition.y',
	        'lightposition.z',
	        'flatshading',
	        'opacity'
	    ].forEach(function(x) { coerce(x); });
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
	
	    // disable 1D transforms (for now)
	    traceOut._length = null;
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults,
	    supplyIsoDefaults: supplyIsoDefaults
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"../../registry":845,"./attributes":1054}],1058:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    calc: _dereq_('./calc'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    plot: _dereq_('./convert').createIsosurfaceTrace,
	
	    moduleType: 'trace',
	    name: 'isosurface',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"./attributes":1054,"./calc":1055,"./convert":1056,"./defaults":1057}],1059:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var surfaceAttrs = _dereq_('../surface/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = extendFlat({
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    z: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    i: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    j: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	
	    },
	    k: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	    hovertemplate: hovertemplateAttrs({editType: 'calc'}),
	
	    delaunayaxis: {
	        valType: 'enumerated',
	        
	        values: [ 'x', 'y', 'z' ],
	        dflt: 'z',
	        editType: 'calc',
	        
	    },
	
	    alphahull: {
	        valType: 'number',
	        
	        dflt: -1,
	        editType: 'calc',
	        
	    },
	
	    intensity: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    // Color field
	    color: {
	        valType: 'color',
	        
	        editType: 'calc',
	        
	    },
	    vertexcolor: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    facecolor: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    transforms: undefined
	},
	
	colorScaleAttrs('', {
	    colorAttr: '`intensity`',
	    showScaleDflt: true,
	    editTypeOverride: 'calc'
	}), {
	    opacity: surfaceAttrs.opacity,
	
	    // Flat shaded mode
	    flatshading: {
	        valType: 'boolean',
	        
	        dflt: false,
	        editType: 'calc',
	        
	    },
	
	    contour: {
	        show: extendFlat({}, surfaceAttrs.contours.x.show, {
	            
	        }),
	        color: surfaceAttrs.contours.x.color,
	        width: surfaceAttrs.contours.x.width,
	        editType: 'calc'
	    },
	
	    lightposition: {
	        x: extendFlat({}, surfaceAttrs.lightposition.x, {dflt: 1e5}),
	        y: extendFlat({}, surfaceAttrs.lightposition.y, {dflt: 1e5}),
	        z: extendFlat({}, surfaceAttrs.lightposition.z, {dflt: 0}),
	        editType: 'calc'
	    },
	    lighting: extendFlat({
	        vertexnormalsepsilon: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 1,
	            dflt: 1e-12, // otherwise finely tessellated things eg. the brain will have no specular light reflection
	            editType: 'calc',
	            
	        },
	        facenormalsepsilon: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 1,
	            dflt: 1e-6, // even the brain model doesn't appear to need finer than this
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    }, surfaceAttrs.lighting),
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {editType: 'calc'})
	});
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../surface/attributes":1240}],1060:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	
	module.exports = function calc(gd, trace) {
	    if(trace.intensity) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.intensity,
	            containerStr: '',
	            cLetter: 'c'
	        });
	    }
	};
	
	},{"../../components/colorscale/calc":599}],1061:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createMesh = _dereq_('gl-mesh3d');
	var triangulate = _dereq_('delaunay-triangulate');
	var alphaShape = _dereq_('alpha-shape');
	var convexHull = _dereq_('convex-hull');
	
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var zip3 = _dereq_('../../plots/gl3d/zip3');
	
	function Mesh3DTrace(scene, mesh, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.mesh = mesh;
	    this.name = '';
	    this.color = '#fff';
	    this.data = null;
	    this.showContour = false;
	}
	
	var proto = Mesh3DTrace.prototype;
	
	proto.handlePick = function(selection) {
	    if(selection.object === this.mesh) {
	        var selectIndex = selection.index = selection.data.index;
	
	        selection.traceCoordinate = [
	            this.data.x[selectIndex],
	            this.data.y[selectIndex],
	            this.data.z[selectIndex]
	        ];
	
	        var text = this.data.hovertext || this.data.text;
	        if(Array.isArray(text) && text[selectIndex] !== undefined) {
	            selection.textLabel = text[selectIndex];
	        } else if(text) {
	            selection.textLabel = text;
	        }
	
	        return true;
	    }
	};
	
	function parseColorArray(colors) {
	    var b = [];
	    var len = colors.length;
	    for(var i = 0; i < len; i++) {
	        b[i] = str2RgbaArray(colors[i]);
	    }
	    return b;
	}
	
	// Unpack position data
	function toDataCoords(axis, coord, scale, calendar) {
	    var b = [];
	    var len = coord.length;
	    for(var i = 0; i < len; i++) {
	        b[i] = axis.d2l(coord[i], 0, calendar) * scale;
	    }
	    return b;
	}
	
	// Round indices if passed as floats
	function toRoundIndex(a) {
	    var b = [];
	    var len = a.length;
	    for(var i = 0; i < len; i++) {
	        b[i] = Math.round(a[i]);
	    }
	    return b;
	}
	
	function delaunayCells(delaunayaxis, positions) {
	    var d = ['x', 'y', 'z'].indexOf(delaunayaxis);
	    var b = [];
	    var len = positions.length;
	    for(var i = 0; i < len; i++) {
	        b[i] = [positions[i][(d + 1) % 3], positions[i][(d + 2) % 3]];
	    }
	    return triangulate(b);
	}
	
	// Validate indices
	function hasValidIndices(list, numVertices) {
	    var len = list.length;
	    for(var i = 0; i < len; i++) {
	        if(list[i] <= -0.5 || list[i] >= numVertices - 0.5) { // Note: the indices would be rounded -0.49 is valid.
	            return false;
	        }
	    }
	    return true;
	}
	
	proto.update = function(data) {
	    var scene = this.scene;
	    var layout = scene.fullSceneLayout;
	
	    this.data = data;
	
	    var numVertices = data.x.length;
	
	    var positions = zip3(
	        toDataCoords(layout.xaxis, data.x, scene.dataScale[0], data.xcalendar),
	        toDataCoords(layout.yaxis, data.y, scene.dataScale[1], data.ycalendar),
	        toDataCoords(layout.zaxis, data.z, scene.dataScale[2], data.zcalendar)
	    );
	
	    var cells;
	    if(data.i && data.j && data.k) {
	        if(
	            data.i.length !== data.j.length ||
	            data.j.length !== data.k.length ||
	            !hasValidIndices(data.i, numVertices) ||
	            !hasValidIndices(data.j, numVertices) ||
	            !hasValidIndices(data.k, numVertices)
	        ) {
	            return;
	        }
	        cells = zip3(
	            toRoundIndex(data.i),
	            toRoundIndex(data.j),
	            toRoundIndex(data.k)
	        );
	    } else if(data.alphahull === 0) {
	        cells = convexHull(positions);
	    } else if(data.alphahull > 0) {
	        cells = alphaShape(data.alphahull, positions);
	    } else {
	        cells = delaunayCells(data.delaunayaxis, positions);
	    }
	
	    var config = {
	        positions: positions,
	        cells: cells,
	        lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	        ambient: data.lighting.ambient,
	        diffuse: data.lighting.diffuse,
	        specular: data.lighting.specular,
	        roughness: data.lighting.roughness,
	        fresnel: data.lighting.fresnel,
	        vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	        faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	        opacity: data.opacity,
	        contourEnable: data.contour.show,
	        contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	        contourWidth: data.contour.width,
	        useFacetNormals: data.flatshading
	    };
	
	    if(data.intensity) {
	        var cOpts = extractOpts(data);
	        this.color = '#fff';
	        config.vertexIntensity = data.intensity;
	        config.vertexIntensityBounds = [cOpts.min, cOpts.max];
	        config.colormap = parseColorScale(data);
	    } else if(data.vertexcolor) {
	        this.color = data.vertexcolor[0];
	        config.vertexColors = parseColorArray(data.vertexcolor);
	    } else if(data.facecolor) {
	        this.color = data.facecolor[0];
	        config.cellColors = parseColorArray(data.facecolor);
	    } else {
	        this.color = data.color;
	        config.meshColor = str2RgbaArray(data.color);
	    }
	
	    // Update mesh
	    this.mesh.update(config);
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.mesh);
	    this.mesh.dispose();
	};
	
	function createMesh3DTrace(scene, data) {
	    var gl = scene.glplot.gl;
	    var mesh = createMesh({gl: gl});
	    var result = new Mesh3DTrace(scene, mesh, data.uid);
	    mesh._trace = result;
	    result.update(data);
	    scene.glplot.add(mesh);
	    return result;
	}
	
	module.exports = createMesh3DTrace;
	
	},{"../../components/colorscale":603,"../../lib/gl_format_color":713,"../../lib/str2rgbarray":739,"../../plots/gl3d/zip3":815,"alpha-shape":66,"convex-hull":131,"delaunay-triangulate":166,"gl-mesh3d":282}],1062:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    // read in face/vertex properties
	    function readComponents(array) {
	        var ret = array.map(function(attr) {
	            var result = coerce(attr);
	
	            if(result && Lib.isArrayOrTypedArray(result)) return result;
	            return null;
	        });
	
	        return ret.every(function(x) {
	            return x && x.length === ret[0].length;
	        }) && ret;
	    }
	
	    var coords = readComponents(['x', 'y', 'z']);
	    if(!coords) {
	        traceOut.visible = false;
	        return;
	    }
	
	    readComponents(['i', 'j', 'k']);
	    // three indices should be all provided or not
	    if(
	        (traceOut.i && (!traceOut.j || !traceOut.k)) ||
	        (traceOut.j && (!traceOut.k || !traceOut.i)) ||
	        (traceOut.k && (!traceOut.i || !traceOut.j))
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
	
	    // Coerce remaining properties
	    [
	        'lighting.ambient',
	        'lighting.diffuse',
	        'lighting.specular',
	        'lighting.roughness',
	        'lighting.fresnel',
	        'lighting.vertexnormalsepsilon',
	        'lighting.facenormalsepsilon',
	        'lightposition.x',
	        'lightposition.y',
	        'lightposition.z',
	        'flatshading',
	        'alphahull',
	        'delaunayaxis',
	        'opacity'
	    ].forEach(function(x) { coerce(x); });
	
	    var showContour = coerce('contour.show');
	    if(showContour) {
	        coerce('contour.color');
	        coerce('contour.width');
	    }
	
	    if('intensity' in traceIn) {
	        coerce('intensity');
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
	    } else {
	        traceOut.showscale = false;
	
	        if('facecolor' in traceIn) coerce('facecolor');
	        else if('vertexcolor' in traceIn) coerce('vertexcolor');
	        else coerce('color', defaultColor);
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    // disable 1D transforms
	    // x/y/z should match lengths, and i/j/k should match as well, but
	    // the two sets have different lengths so transforms wouldn't work.
	    traceOut._length = null;
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"../../registry":845,"./attributes":1059}],1063:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    plot: _dereq_('./convert'),
	
	    moduleType: 'trace',
	    name: 'mesh3d',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"./attributes":1059,"./calc":1060,"./convert":1061,"./defaults":1062}],1064:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib').extendFlat;
	var scatterAttrs = _dereq_('../scatter/attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	var fxAttrs = _dereq_('../../components/fx/attributes');
	var delta = _dereq_('../../constants/delta.js');
	
	var INCREASING_COLOR = delta.INCREASING.COLOR;
	var DECREASING_COLOR = delta.DECREASING.COLOR;
	
	var lineAttrs = scatterAttrs.line;
	
	function directionAttrs(lineColorDefault) {
	    return {
	        line: {
	            color: extendFlat({}, lineAttrs.color, {dflt: lineColorDefault}),
	            width: lineAttrs.width,
	            dash: dash,
	            editType: 'style'
	        },
	        editType: 'style'
	    };
	}
	
	module.exports = {
	
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    open: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    high: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    low: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    close: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    line: {
	        width: extendFlat({}, lineAttrs.width, {
	            
	        }),
	        dash: extendFlat({}, dash, {
	            
	        }),
	        editType: 'style'
	    },
	
	    increasing: directionAttrs(INCREASING_COLOR),
	
	    decreasing: directionAttrs(DECREASING_COLOR),
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	
	    tickwidth: {
	        valType: 'number',
	        min: 0,
	        max: 0.5,
	        dflt: 0.3,
	        
	        editType: 'calc',
	        
	    },
	
	    hoverlabel: extendFlat({}, fxAttrs.hoverlabel, {
	        split: {
	            valType: 'boolean',
	            
	            dflt: false,
	            editType: 'style',
	            
	        }
	    }),
	};
	
	},{"../../components/drawing/attributes":611,"../../components/fx/attributes":621,"../../constants/delta.js":686,"../../lib":716,"../scatter/attributes":1118}],1065:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var _ = Lib._;
	var Axes = _dereq_('../../plots/cartesian/axes');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis);
	    var ya = Axes.getFromId(gd, trace.yaxis);
	
	    var tickLen = convertTickWidth(gd, xa, trace);
	    var minDiff = trace._minDiff;
	    trace._minDiff = null;
	    var x = trace._xcalc;
	    trace._xcalc = null;
	
	    var cd = calcCommon(gd, trace, x, ya, ptFunc);
	
	    trace._extremes[xa._id] = Axes.findExtremes(xa, x, {vpad: minDiff / 2});
	    if(cd.length) {
	        Lib.extendFlat(cd[0].t, {
	            wHover: minDiff / 2,
	            tickLen: tickLen
	        });
	        return cd;
	    } else {
	        return [{t: {empty: true}}];
	    }
	}
	
	function ptFunc(o, h, l, c) {
	    return {
	        o: o,
	        h: h,
	        l: l,
	        c: c
	    };
	}
	
	
	// shared between OHLC and candlestick
	// ptFunc makes a calcdata point specific to each trace type, from oi, hi, li, ci
	function calcCommon(gd, trace, x, ya, ptFunc) {
	    var o = ya.makeCalcdata(trace, 'open');
	    var h = ya.makeCalcdata(trace, 'high');
	    var l = ya.makeCalcdata(trace, 'low');
	    var c = ya.makeCalcdata(trace, 'close');
	
	    var hasTextArray = Array.isArray(trace.text);
	    var hasHovertextArray = Array.isArray(trace.hovertext);
	
	    // we're optimists - before we have any changing data, assume increasing
	    var increasing = true;
	    var cPrev = null;
	
	    var cd = [];
	    for(var i = 0; i < x.length; i++) {
	        var xi = x[i];
	        var oi = o[i];
	        var hi = h[i];
	        var li = l[i];
	        var ci = c[i];
	
	        if(xi !== BADNUM && oi !== BADNUM && hi !== BADNUM && li !== BADNUM && ci !== BADNUM) {
	            if(ci === oi) {
	                // if open == close, look for a change from the previous close
	                if(cPrev !== null && ci !== cPrev) increasing = ci > cPrev;
	                // else (c === cPrev or cPrev is null) no change
	            } else increasing = ci > oi;
	
	            cPrev = ci;
	
	            var pt = ptFunc(oi, hi, li, ci);
	
	            pt.pos = xi;
	            pt.yc = (oi + ci) / 2;
	            pt.i = i;
	            pt.dir = increasing ? 'increasing' : 'decreasing';
	
	            // For categoryorder, store low and high
	            pt.x = pt.pos;
	            pt.y = [li, hi];
	
	            if(hasTextArray) pt.tx = trace.text[i];
	            if(hasHovertextArray) pt.htx = trace.hovertext[i];
	
	            cd.push(pt);
	        } else {
	            cd.push({pos: xi, empty: true});
	        }
	    }
	
	    trace._extremes[ya._id] = Axes.findExtremes(ya, Lib.concat(l, h), {padded: true});
	
	    if(cd.length) {
	        cd[0].t = {
	            labels: {
	                open: _(gd, 'open:') + ' ',
	                high: _(gd, 'high:') + ' ',
	                low: _(gd, 'low:') + ' ',
	                close: _(gd, 'close:') + ' '
	            }
	        };
	    }
	
	    return cd;
	}
	
	/*
	 * find min x-coordinates difference of all traces
	 * attached to this x-axis and stash the result in _minDiff
	 * in all traces; when a trace uses this in its
	 * calc step it deletes _minDiff, so that next calc this is
	 * done again in case the data changed.
	 * also since we need it here, stash _xcalc on the trace
	 */
	function convertTickWidth(gd, xa, trace) {
	    var minDiff = trace._minDiff;
	
	    if(!minDiff) {
	        var fullData = gd._fullData;
	        var ohlcTracesOnThisXaxis = [];
	
	        minDiff = Infinity;
	
	        var i;
	
	        for(i = 0; i < fullData.length; i++) {
	            var tracei = fullData[i];
	
	            if(tracei.type === 'ohlc' &&
	                tracei.visible === true &&
	                tracei.xaxis === xa._id
	            ) {
	                ohlcTracesOnThisXaxis.push(tracei);
	
	                var xcalc = xa.makeCalcdata(tracei, 'x');
	                tracei._xcalc = xcalc;
	
	                var _minDiff = Lib.distinctVals(xcalc).minDiff;
	                if(_minDiff && isFinite(_minDiff)) {
	                    minDiff = Math.min(minDiff, _minDiff);
	                }
	            }
	        }
	
	        // if minDiff is still Infinity here, set it to 1
	        if(minDiff === Infinity) minDiff = 1;
	
	        for(i = 0; i < ohlcTracesOnThisXaxis.length; i++) {
	            ohlcTracesOnThisXaxis[i]._minDiff = minDiff;
	        }
	    }
	
	    return minDiff * trace.tickwidth;
	}
	
	module.exports = {
	    calc: calc,
	    calcCommon: calcCommon
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axes":764}],1066:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleOHLC = _dereq_('./ohlc_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleOHLC(traceIn, traceOut, coerce, layout);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('line.width');
	    coerce('line.dash');
	
	    handleDirection(traceIn, traceOut, coerce, 'increasing');
	    handleDirection(traceIn, traceOut, coerce, 'decreasing');
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('tickwidth');
	
	    layout._requestRangeslider[traceOut.xaxis] = true;
	};
	
	function handleDirection(traceIn, traceOut, coerce, direction) {
	    coerce(direction + '.line.color');
	    coerce(direction + '.line.width', traceOut.line.width);
	    coerce(direction + '.line.dash', traceOut.line.dash);
	}
	
	},{"../../lib":716,"./attributes":1064,"./ohlc_defaults":1069}],1067:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	var Fx = _dereq_('../../components/fx');
	var Color = _dereq_('../../components/color');
	var fillText = _dereq_('../../lib').fillText;
	var delta = _dereq_('../../constants/delta.js');
	
	var DIRSYMBOL = {
	    increasing: delta.INCREASING.SYMBOL,
	    decreasing: delta.DECREASING.SYMBOL
	};
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	
	    if(trace.hoverlabel.split) {
	        return hoverSplit(pointData, xval, yval, hovermode);
	    }
	
	    return hoverOnPoints(pointData, xval, yval, hovermode);
	}
	
	function getClosestPoint(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var xa = pointData.xa;
	    var trace = cd[0].trace;
	    var t = cd[0].t;
	
	    var type = trace.type;
	    var minAttr = type === 'ohlc' ? 'l' : 'min';
	    var maxAttr = type === 'ohlc' ? 'h' : 'max';
	
	    var hoverPseudoDistance, spikePseudoDistance;
	
	    // potentially shift xval for grouped candlesticks
	    var centerShift = t.bPos || 0;
	    var shiftPos = function(di) { return di.pos + centerShift - xval; };
	
	    // ohlc and candlestick call displayHalfWidth different things...
	    var displayHalfWidth = t.bdPos || t.tickLen;
	    var hoverHalfWidth = t.wHover;
	
	    // if two figures are overlaying, let the narrowest one win
	    var pseudoDistance = Math.min(1, displayHalfWidth / Math.abs(xa.r2c(xa.range[1]) - xa.r2c(xa.range[0])));
	    hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
	    spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
	
	    function dx(di) {
	        var pos = shiftPos(di);
	        return Fx.inbox(pos - hoverHalfWidth, pos + hoverHalfWidth, hoverPseudoDistance);
	    }
	
	    function dy(di) {
	        var min = di[minAttr];
	        var max = di[maxAttr];
	        return min === max || Fx.inbox(min - yval, max - yval, hoverPseudoDistance);
	    }
	
	    function dxy(di) { return (dx(di) + dy(di)) / 2; }
	
	    var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	    Fx.getClosest(cd, distfn, pointData);
	
	    if(pointData.index === false) return null;
	
	    var di = cd[pointData.index];
	
	    if(di.empty) return null;
	
	    var dir = di.dir;
	    var container = trace[dir];
	    var lc = container.line.color;
	
	    if(Color.opacity(lc) && container.line.width) pointData.color = lc;
	    else pointData.color = container.fillcolor;
	
	    pointData.x0 = xa.c2p(di.pos + centerShift - displayHalfWidth, true);
	    pointData.x1 = xa.c2p(di.pos + centerShift + displayHalfWidth, true);
	
	    pointData.xLabelVal = di.pos;
	
	    pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
	    pointData.xSpike = xa.c2p(di.pos, true);
	
	    return pointData;
	}
	
	function hoverSplit(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var ya = pointData.ya;
	    var trace = cd[0].trace;
	    var t = cd[0].t;
	    var closeBoxData = [];
	
	    var closestPoint = getClosestPoint(pointData, xval, yval, hovermode);
	    // skip the rest (for this trace) if we didn't find a close point
	    if(!closestPoint) return [];
	
	    var cdIndex = closestPoint.index;
	    var di = cd[cdIndex];
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var hoverParts = hoverinfo.split('+');
	    var isAll = hoverinfo === 'all';
	    var hasY = isAll || hoverParts.indexOf('y') !== -1;
	
	    // similar to hoverOnPoints, we return nothing
	    // if all or y is not present.
	    if(!hasY) return [];
	
	    var attrs = ['high', 'open', 'close', 'low'];
	
	    // several attributes can have the same y-coordinate. We will
	    // bunch them together in a single text block. For this, we keep
	    // a dictionary mapping y-coord -> point data.
	    var usedVals = {};
	
	    for(var i = 0; i < attrs.length; i++) {
	        var attr = attrs[i];
	
	        var val = trace[attr][closestPoint.index];
	        var valPx = ya.c2p(val, true);
	        var pointData2;
	        if(val in usedVals) {
	            pointData2 = usedVals[val];
	            pointData2.yLabel += '<br>' + t.labels[attr] + Axes.hoverLabelText(ya, val);
	        } else {
	            // copy out to a new object for each new y-value to label
	            pointData2 = Lib.extendFlat({}, closestPoint);
	
	            pointData2.y0 = pointData2.y1 = valPx;
	            pointData2.yLabelVal = val;
	            pointData2.yLabel = t.labels[attr] + Axes.hoverLabelText(ya, val);
	
	            pointData2.name = '';
	
	            closeBoxData.push(pointData2);
	            usedVals[val] = pointData2;
	        }
	    }
	
	    return closeBoxData;
	}
	
	function hoverOnPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var ya = pointData.ya;
	    var trace = cd[0].trace;
	    var t = cd[0].t;
	
	    var closestPoint = getClosestPoint(pointData, xval, yval, hovermode);
	    // skip the rest (for this trace) if we didn't find a close point
	    if(!closestPoint) return [];
	
	    // we don't make a calcdata point if we're missing any piece (x/o/h/l/c)
	    // so we need to fix the index here to point to the data arrays
	    var cdIndex = closestPoint.index;
	    var di = cd[cdIndex];
	    var i = closestPoint.index = di.i;
	    var dir = di.dir;
	
	    function getLabelLine(attr) {
	        return t.labels[attr] + Axes.hoverLabelText(ya, trace[attr][i]);
	    }
	
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var hoverParts = hoverinfo.split('+');
	    var isAll = hoverinfo === 'all';
	    var hasY = isAll || hoverParts.indexOf('y') !== -1;
	    var hasText = isAll || hoverParts.indexOf('text') !== -1;
	
	    var textParts = hasY ? [
	        getLabelLine('open'),
	        getLabelLine('high'),
	        getLabelLine('low'),
	        getLabelLine('close') + '  ' + DIRSYMBOL[dir]
	    ] : [];
	    if(hasText) fillText(di, trace, textParts);
	
	    // don't make .yLabelVal or .text, since we're managing hoverinfo
	    // put it all in .extraText
	    closestPoint.extraText = textParts.join('<br>');
	
	    // this puts the label *and the spike* at the midpoint of the box, ie
	    // halfway between open and close, not between high and low.
	    closestPoint.y0 = closestPoint.y1 = ya.c2p(di.yc, true);
	
	    return [closestPoint];
	}
	
	module.exports = {
	    hoverPoints: hoverPoints,
	    hoverSplit: hoverSplit,
	    hoverOnPoints: hoverOnPoints
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../constants/delta.js":686,"../../lib":716,"../../plots/cartesian/axes":764}],1068:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'ohlc',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'showLegend'],
	    meta: {
	        
	    },
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc').calc,
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    selectPoints: _dereq_('./select')
	};
	
	},{"../../plots/cartesian":775,"./attributes":1064,"./calc":1065,"./defaults":1066,"./hover":1067,"./plot":1070,"./select":1071,"./style":1072}],1069:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	module.exports = function handleOHLC(traceIn, traceOut, coerce, layout) {
	    var x = coerce('x');
	    var open = coerce('open');
	    var high = coerce('high');
	    var low = coerce('low');
	    var close = coerce('close');
	
	    coerce('hoverlabel.split');
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x'], layout);
	
	    if(!(open && high && low && close)) return;
	
	    var len = Math.min(open.length, high.length, low.length, close.length);
	    if(x) len = Math.min(len, Lib.minRowLength(x));
	    traceOut._length = len;
	
	    return len;
	};
	
	},{"../../lib":716,"../../registry":845}],1070:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	
	module.exports = function plot(gd, plotinfo, cdOHLC, ohlcLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(ohlcLayer, cdOHLC, 'trace ohlc').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var t = cd0.t;
	        var trace = cd0.trace;
	
	        if(trace.visible !== true || t.empty) {
	            plotGroup.remove();
	            return;
	        }
	
	        var tickLen = t.tickLen;
	
	        var paths = plotGroup.selectAll('path').data(Lib.identity);
	
	        paths.enter().append('path');
	
	        paths.exit().remove();
	
	        paths.attr('d', function(d) {
	            if(d.empty) return 'M0,0Z';
	
	            var x = xa.c2p(d.pos, true);
	            var xo = xa.c2p(d.pos - tickLen, true);
	            var xc = xa.c2p(d.pos + tickLen, true);
	
	            var yo = ya.c2p(d.o, true);
	            var yh = ya.c2p(d.h, true);
	            var yl = ya.c2p(d.l, true);
	            var yc = ya.c2p(d.c, true);
	
	            return 'M' + xo + ',' + yo + 'H' + x +
	                'M' + x + ',' + yh + 'V' + yl +
	                'M' + xc + ',' + yc + 'H' + x;
	        });
	    });
	};
	
	},{"../../lib":716,"d3":164}],1071:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	    var i;
	    // for (potentially grouped) candlesticks
	    var posOffset = cd[0].t.bPos || 0;
	
	    if(selectionTester === false) {
	        // clear selection
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            var di = cd[i];
	
	            if(selectionTester.contains([xa.c2p(di.pos + posOffset), ya.c2p(di.yc)], null, di.i, searchInfo)) {
	                selection.push({
	                    pointNumber: di.i,
	                    x: xa.c2d(di.pos),
	                    y: ya.c2d(di.yc)
	                });
	                di.selected = 1;
	            } else {
	                di.selected = 0;
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{}],1072:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../../components/drawing');
	var Color = _dereq_('../../components/color');
	
	module.exports = function style(gd, cd, sel) {
	    var s = sel ? sel : d3.select(gd).selectAll('g.ohlclayer').selectAll('g.trace');
	
	    s.style('opacity', function(d) {
	        return d[0].trace.opacity;
	    });
	
	    s.each(function(d) {
	        var trace = d[0].trace;
	
	        d3.select(this).selectAll('path').each(function(di) {
	            if(di.empty) return;
	
	            var dirLine = trace[di.dir].line;
	            d3.select(this)
	                .style('fill', 'none')
	                .call(Color.stroke, dirLine.color)
	                .call(Drawing.dashLine, dirLine.dash, dirLine.width)
	                // TODO: custom selection style for OHLC
	                .style('opacity', trace.selectedpoints && !di.selected ? 0.3 : 1);
	        });
	    });
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"d3":164}],1073:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var baseAttrs = _dereq_('../../plots/attributes');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	
	var line = extendFlat(
	    {editType: 'calc'},
	    colorScaleAttrs('line', {editTypeOverride: 'calc'}),
	    {
	        shape: {
	            valType: 'enumerated',
	            values: ['linear', 'hspline'],
	            dflt: 'linear',
	            
	            editType: 'plot',
	            
	        },
	
	        hovertemplate: hovertemplateAttrs({
	            editType: 'plot',
	            arrayOk: false
	        }, {
	            keys: ['count', 'probability'],
	            
	        })
	    }
	);
	
	module.exports = {
	    domain: domainAttrs({name: 'parcats', trace: true, editType: 'calc'}),
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['count', 'probability'],
	        editType: 'plot',
	        arrayOk: false
	    }),
	    hoveron: {
	        valType: 'enumerated',
	        values: ['category', 'color', 'dimension'],
	        dflt: 'category',
	        
	        editType: 'plot',
	        
	    },
	    hovertemplate: hovertemplateAttrs({
	        editType: 'plot',
	        arrayOk: false
	    }, {
	        keys: [
	            'count', 'probability', 'category',
	            'categorycount', 'colorcount', 'bandcolorcount'
	        ],
	        
	    }),
	
	    arrangement: {
	        valType: 'enumerated',
	        values: ['perpendicular', 'freeform', 'fixed'],
	        dflt: 'perpendicular',
	        
	        editType: 'plot',
	        
	    },
	    bundlecolors: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'plot',
	        
	    },
	    sortpaths: {
	        valType: 'enumerated',
	        values: ['forward', 'backward'],
	        dflt: 'forward',
	        
	        editType: 'plot',
	        
	    },
	    labelfont: fontAttrs({
	        editType: 'calc',
	        
	    }),
	
	    tickfont: fontAttrs({
	        editType: 'calc',
	        
	    }),
	
	    dimensions: {
	        _isLinkedToArray: 'dimension',
	        label: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        },
	        categoryorder: {
	            valType: 'enumerated',
	            values: [
	                'trace', 'category ascending', 'category descending', 'array'
	            ],
	            dflt: 'trace',
	            
	            editType: 'calc',
	            
	        },
	        categoryarray: {
	            valType: 'data_array',
	            
	            editType: 'calc',
	            
	        },
	        ticktext: {
	            valType: 'data_array',
	            
	            editType: 'calc',
	            
	        },
	        values: {
	            valType: 'data_array',
	            
	            dflt: [],
	            editType: 'calc',
	            
	        },
	        displayindex: {
	            valType: 'integer',
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc',
	        
	        visible: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'calc',
	            
	        }
	    },
	
	    line: line,
	    counts: {
	        valType: 'number',
	        min: 0,
	        dflt: 1,
	        arrayOk: true,
	        
	        editType: 'calc',
	        
	    },
	
	    // Hide unsupported top-level properties from plot-schema
	    customdata: undefined,
	    hoverlabel: undefined,
	    ids: undefined,
	    legendgroup: undefined,
	    opacity: undefined,
	    selectedpoints: undefined,
	    showlegend: undefined
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/domain":789,"../../plots/font_attributes":790,"../../plots/template_attributes":840}],1074:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
	var parcatsPlot = _dereq_('./plot');
	
	var PARCATS = 'parcats';
	exports.name = PARCATS;
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    var cdModuleAndOthers = getModuleCalcData(gd.calcdata, PARCATS);
	
	    if(cdModuleAndOthers.length) {
	        var calcData = cdModuleAndOthers[0];
	        parcatsPlot(gd, calcData, transitionOpts, makeOnCompleteCallback);
	    }
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var hadTable = (oldFullLayout._has && oldFullLayout._has('parcats'));
	    var hasTable = (newFullLayout._has && newFullLayout._has('parcats'));
	
	    if(hadTable && !hasTable) {
	        oldFullLayout._paperdiv.selectAll('.parcats').remove();
	    }
	};
	
	},{"../../plots/get_data":799,"./plot":1079}],1075:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	// Requirements
	// ============
	var wrap = _dereq_('../../lib/gup').wrap;
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	var filterUnique = _dereq_('../../lib/filter_unique.js');
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	
	/**
	 * Create a wrapped ParcatsModel object from trace
	 *
	 * Note: trace defaults have already been applied
	 * @param {Object} gd
	 * @param {Object} trace
	 * @return {Array.<ParcatsModel>}
	 */
	module.exports = function calc(gd, trace) {
	    var visibleDims = Lib.filterVisible(trace.dimensions);
	
	    if(visibleDims.length === 0) return [];
	
	    var uniqueInfoDims = visibleDims.map(function(dim) {
	        var categoryValues;
	        if(dim.categoryorder === 'trace') {
	            // Use order of first occurrence in trace
	            categoryValues = null;
	        } else if(dim.categoryorder === 'array') {
	            // Use categories specified in `categoryarray` first,
	            // then add extra to the end in trace order
	            categoryValues = dim.categoryarray;
	        } else {
	            // Get all categories up front so we can order them
	            // Should we check for numbers as sort numerically?
	            categoryValues = filterUnique(dim.values).sort();
	            if(dim.categoryorder === 'category descending') {
	                categoryValues = categoryValues.reverse();
	            }
	        }
	        return getUniqueInfo(dim.values, categoryValues);
	    });
	
	    var counts,
	        count,
	        totalCount;
	    if(Lib.isArrayOrTypedArray(trace.counts)) {
	        counts = trace.counts;
	    } else {
	        counts = [trace.counts];
	    }
	
	    validateDimensionDisplayInds(visibleDims);
	
	    visibleDims.forEach(function(dim, dimInd) {
	        validateCategoryProperties(dim, uniqueInfoDims[dimInd]);
	    });
	
	    // Handle path colors
	    // ------------------
	    var line = trace.line;
	    var markerColorscale;
	
	    // Process colorscale
	    if(line) {
	        if(hasColorscale(trace, 'line')) {
	            colorscaleCalc(gd, trace, {
	                vals: trace.line.color,
	                containerStr: 'line',
	                cLetter: 'c'
	            });
	        }
	        markerColorscale = Drawing.tryColorscale(line);
	    } else {
	        markerColorscale = Lib.identity;
	    }
	
	    // Build color generation function
	    function getMarkerColorInfo(index) {
	        var value, rawColor;
	        if(Lib.isArrayOrTypedArray(line.color)) {
	            value = line.color[index % line.color.length];
	            rawColor = value;
	        } else {
	            value = line.color;
	        }
	
	        return {color: markerColorscale(value), rawColor: rawColor};
	    }
	
	    // Number of values and counts
	    // ---------------------------
	    var numValues = visibleDims[0].values.length;
	
	    // Build path info
	    // ---------------
	    // Mapping from category inds to PathModel objects
	    var pathModels = {};
	
	    // Category inds array for each dimension
	    var categoryIndsDims = uniqueInfoDims.map(function(di) {return di.inds;});
	
	    // Initialize total count
	    totalCount = 0;
	    var valueInd;
	    var d;
	
	    for(valueInd = 0; valueInd < numValues; valueInd++) {
	        // Category inds for this input value across dimensions
	        var categoryIndsPath = [];
	        for(d = 0; d < categoryIndsDims.length; d++) {
	            categoryIndsPath.push(categoryIndsDims[d][valueInd]);
	        }
	
	        // Count
	        count = counts[valueInd % counts.length];
	
	        // Update total count
	        totalCount += count;
	
	        // Path color
	        var pathColorInfo = getMarkerColorInfo(valueInd);
	
	        // path key
	        var pathKey = categoryIndsPath + '-' + pathColorInfo.rawColor;
	
	        // Create / Update PathModel
	        if(pathModels[pathKey] === undefined) {
	            pathModels[pathKey] = createPathModel(categoryIndsPath,
	                pathColorInfo.color,
	                pathColorInfo.rawColor);
	        }
	        updatePathModel(pathModels[pathKey], valueInd, count);
	    }
	
	    var dimensionModels = visibleDims.map(function(di, i) {
	        return createDimensionModel(i, di._index, di._displayindex, di.label, totalCount);
	    });
	
	
	    for(valueInd = 0; valueInd < numValues; valueInd++) {
	        count = counts[valueInd % counts.length];
	
	        for(d = 0; d < dimensionModels.length; d++) {
	            var containerInd = dimensionModels[d].containerInd;
	            var catInd = uniqueInfoDims[d].inds[valueInd];
	            var cats = dimensionModels[d].categories;
	
	            if(cats[catInd] === undefined) {
	                var catValue = trace.dimensions[containerInd]._categoryarray[catInd];
	                var catLabel = trace.dimensions[containerInd]._ticktext[catInd];
	                cats[catInd] = createCategoryModel(d, catInd, catValue, catLabel);
	            }
	
	            updateCategoryModel(cats[catInd], valueInd, count);
	        }
	    }
	
	    // Compute unique
	    return wrap(createParcatsModel(dimensionModels, pathModels, totalCount));
	};
	
	// Models
	// ======
	
	// Parcats Model
	// -------------
	/**
	 * @typedef {Object} ParcatsModel
	 *  Object containing calculated information about a parcats trace
	 *
	 * @property {Array.<DimensionModel>} dimensions
	 *  Array of dimension models
	 * @property {Object.<string,PathModel>} paths
	 *  Dictionary from category inds string (e.g. "1,2,1,1") to path model
	 * @property {Number} maxCats
	 *  The maximum number of categories of any dimension in the diagram
	 * @property {Number} count
	 *  Total number of input values
	 * @property {Object} trace
	 */
	
	/**
	 * Create and new ParcatsModel object
	 * @param {Array.<DimensionModel>} dimensions
	 * @param {Object.<string,PathModel>} paths
	 * @param {Number} count
	 * @return {ParcatsModel}
	 */
	function createParcatsModel(dimensions, paths, count) {
	    var maxCats = dimensions
	        .map(function(d) {return d.categories.length;})
	        .reduce(function(v1, v2) {return Math.max(v1, v2);});
	    return {dimensions: dimensions, paths: paths, trace: undefined, maxCats: maxCats, count: count};
	}
	
	// Dimension Model
	// ---------------
	/**
	 * @typedef {Object} DimensionModel
	 *  Object containing calculated information about a single dimension
	 *
	 * @property {Number} dimensionInd
	 *  The index of this dimension among the *visible* dimensions
	 * @property {Number} containerInd
	 *  The index of this dimension in the original dimensions container,
	 *  irrespective of dimension visibility
	 * @property {Number} displayInd
	 *  The display index of this dimension (where 0 is the left most dimension)
	 * @property {String} dimensionLabel
	 *  The label of this dimension
	 * @property {Number} count
	 *  Total number of input values
	 * @property {Array.<CategoryModel>} categories
	 * @property {Number|null} dragX
	 *  The x position of dimension that is currently being dragged. null if not being dragged
	 */
	
	/**
	 * Create and new DimensionModel object with an empty categories array
	 * @param {Number} dimensionInd
	 * @param {Number} containerInd
	 * @param {Number} displayInd
	 * @param {String} dimensionLabel
	 * @param {Number} count
	 *  Total number of input values
	 * @return {DimensionModel}
	 */
	function createDimensionModel(dimensionInd, containerInd, displayInd, dimensionLabel, count) {
	    return {
	        dimensionInd: dimensionInd,
	        containerInd: containerInd,
	        displayInd: displayInd,
	        dimensionLabel: dimensionLabel,
	        count: count,
	        categories: [],
	        dragX: null
	    };
	}
	
	// Category Model
	// --------------
	/**
	 * @typedef {Object} CategoryModel
	 *  Object containing calculated information about a single category.
	 *
	 * @property {Number} dimensionInd
	 *  The index of this categories dimension
	 * @property {Number} categoryInd
	 *  The index of this category
	 * @property {Number} displayInd
	 *  The display index of this category (where 0 is the topmost category)
	 * @property {String} categoryLabel
	 *  The name of this category
	 * @property categoryValue: Raw value of the category
	 * @property {Array} valueInds
	 *  Array of indices (into the original value array) of all samples in this category
	 * @property {Number} count
	 *  The number of elements from the original array in this path
	 * @property {Number|null} dragY
	 *  The y position of category that is currently being dragged. null if not being dragged
	 */
	
	/**
	 * Create and return a new CategoryModel object
	 * @param {Number} dimensionInd
	 * @param {Number} categoryInd
	 *  The display index of this category (where 0 is the topmost category)
	 * @param {String} categoryValue
	 * @param {String} categoryLabel
	 * @return {CategoryModel}
	 */
	function createCategoryModel(dimensionInd, categoryInd, categoryValue, categoryLabel) {
	    return {
	        dimensionInd: dimensionInd,
	        categoryInd: categoryInd,
	        categoryValue: categoryValue,
	        displayInd: categoryInd,
	        categoryLabel: categoryLabel,
	        valueInds: [],
	        count: 0,
	        dragY: null
	    };
	}
	
	/**
	 * Update a CategoryModel object with a new value index
	 * Note: The calling parameter is modified in place.
	 *
	 * @param {CategoryModel} categoryModel
	 * @param {Number} valueInd
	 * @param {Number} count
	 */
	function updateCategoryModel(categoryModel, valueInd, count) {
	    categoryModel.valueInds.push(valueInd);
	    categoryModel.count += count;
	}
	
	
	// Path Model
	// ----------
	/**
	 * @typedef {Object} PathModel
	 *  Object containing calculated information about the samples in a path.
	 *
	 * @property {Array} categoryInds
	 *  Array of category indices for each dimension (length `numDimensions`)
	 * @param {String} pathColor
	 *  Color of this path. (Note: Any colorscaling has already taken place)
	 * @property {Array} valueInds
	 *  Array of indices (into the original value array) of all samples in this path
	 * @property {Number} count
	 *  The number of elements from the original array in this path
	 * @property {String} color
	 *  The path's color (ass CSS color string)
	 * @property rawColor
	 *  The raw color value specified by the user. May be a CSS color string or a Number
	 */
	
	/**
	 * Create and return a new PathModel object
	 * @param {Array} categoryInds
	 * @param color
	 * @param rawColor
	 * @return {PathModel}
	 */
	function createPathModel(categoryInds, color, rawColor) {
	    return {
	        categoryInds: categoryInds,
	        color: color,
	        rawColor: rawColor,
	        valueInds: [],
	        count: 0
	    };
	}
	
	/**
	 * Update a PathModel object with a new value index
	 * Note: The calling parameter is modified in place.
	 *
	 * @param {PathModel} pathModel
	 * @param {Number} valueInd
	 * @param {Number} count
	 */
	function updatePathModel(pathModel, valueInd, count) {
	    pathModel.valueInds.push(valueInd);
	    pathModel.count += count;
	}
	
	// Unique calculations
	// ===================
	/**
	 * @typedef {Object} UniqueInfo
	 *  Object containing information about the unique values of an input array
	 *
	 * @property {Array} uniqueValues
	 *  The unique values in the input array
	 * @property {Array} uniqueCounts
	 *  The number of times each entry in uniqueValues occurs in input array.
	 *  This has the same length as `uniqueValues`
	 * @property {Array} inds
	 *  Indices into uniqueValues that would reproduce original input array
	 */
	
	/**
	 * Compute unique value information for an array
	 *
	 * IMPORTANT: Note that values are considered unique
	 * if their string representations are unique.
	 *
	 * @param {Array} values
	 * @param {Array|undefined} uniqueValues
	 *  Array of expected unique values. The uniqueValues property of the resulting UniqueInfo object will begin with
	 *  these entries. Entries are included even if there are zero occurrences in the values array. Entries found in
	 *  the values array that are not present in uniqueValues will be included at the end of the array in the
	 *  UniqueInfo object.
	 * @return {UniqueInfo}
	 */
	function getUniqueInfo(values, uniqueValues) {
	    // Initialize uniqueValues if not specified
	    if(uniqueValues === undefined || uniqueValues === null) {
	        uniqueValues = [];
	    } else {
	        // Shallow copy so append below doesn't alter input array
	        uniqueValues = uniqueValues.map(function(e) {return e;});
	    }
	
	    // Initialize Variables
	    var uniqueValueCounts = {};
	    var uniqueValueInds = {};
	    var inds = [];
	
	    // Initialize uniqueValueCounts and
	    uniqueValues.forEach(function(uniqueVal, valInd) {
	        uniqueValueCounts[uniqueVal] = 0;
	        uniqueValueInds[uniqueVal] = valInd;
	    });
	
	    // Compute the necessary unique info in a single pass
	    for(var i = 0; i < values.length; i++) {
	        var item = values[i];
	        var itemInd;
	
	        if(uniqueValueCounts[item] === undefined) {
	            // This item has a previously unseen value
	            uniqueValueCounts[item] = 1;
	            itemInd = uniqueValues.push(item) - 1;
	            uniqueValueInds[item] = itemInd;
	        } else {
	            // Increment count for this item
	            uniqueValueCounts[item]++;
	            itemInd = uniqueValueInds[item];
	        }
	        inds.push(itemInd);
	    }
	
	    // Build UniqueInfo
	    var uniqueCounts = uniqueValues.map(function(v) { return uniqueValueCounts[v]; });
	
	    return {
	        uniqueValues: uniqueValues,
	        uniqueCounts: uniqueCounts,
	        inds: inds
	    };
	}
	
	
	/**
	 * Validate the requested display order for the dimensions.
	 * If the display order is a permutation of 0 through dimensions.length - 1, link to _displayindex
	 * Otherwise, replace the display order with the dimension order
	 * @param {Object} trace
	 */
	function validateDimensionDisplayInds(visibleDims) {
	    var displayInds = visibleDims.map(function(d) { return d.displayindex; });
	    var i;
	
	    if(isRangePermutation(displayInds)) {
	        for(i = 0; i < visibleDims.length; i++) {
	            visibleDims[i]._displayindex = visibleDims[i].displayindex;
	        }
	    } else {
	        for(i = 0; i < visibleDims.length; i++) {
	            visibleDims[i]._displayindex = i;
	        }
	    }
	}
	
	
	/**
	 * Update category properties based on the unique values found for this dimension
	 * @param {Object} dim
	 * @param {UniqueInfo} uniqueInfoDim
	 */
	function validateCategoryProperties(dim, uniqueInfoDim) {
	    // Update categoryarray
	    dim._categoryarray = uniqueInfoDim.uniqueValues;
	
	    // Handle ticktext
	    if(dim.ticktext === null || dim.ticktext === undefined) {
	        dim._ticktext = [];
	    } else {
	        // Shallow copy to avoid modifying input array
	        dim._ticktext = dim.ticktext.slice();
	    }
	
	    // Extend ticktext with elements from uniqueInfoDim.uniqueValues
	    for(var i = dim._ticktext.length; i < uniqueInfoDim.uniqueValues.length; i++) {
	        dim._ticktext.push(uniqueInfoDim.uniqueValues[i]);
	    }
	}
	
	/**
	 * Determine whether an array contains a permutation of the integers from 0 to the array's length - 1
	 * @param {Array} inds
	 * @return {boolean}
	 */
	function isRangePermutation(inds) {
	    var indsSpecified = new Array(inds.length);
	
	    for(var i = 0; i < inds.length; i++) {
	        // Check for out of bounds
	        if(inds[i] < 0 || inds[i] >= inds.length) {
	            return false;
	        }
	
	        // Check for collisions with already specified index
	        if(indsSpecified[inds[i]] !== undefined) {
	            return false;
	        }
	
	        indsSpecified[inds[i]] = true;
	    }
	
	    // Nothing out of bounds and no collisions. We have a permutation
	    return true;
	}
	
	},{"../../components/colorscale/calc":599,"../../components/colorscale/helpers":602,"../../components/drawing":612,"../../lib":716,"../../lib/filter_unique.js":708,"../../lib/gup":714}],1076:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var mergeLength = _dereq_('../parcoords/merge_length');
	
	function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	    coerce('line.shape');
	    coerce('line.hovertemplate');
	
	    var lineColor = coerce('line.color', layout.colorway[0]);
	    if(hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
	        if(lineColor.length) {
	            coerce('line.colorscale');
	            colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
	            return lineColor.length;
	        } else {
	            traceOut.line.color = defaultColor;
	        }
	    }
	    return Infinity;
	}
	
	function dimensionDefaults(dimensionIn, dimensionOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
	    }
	
	    var values = coerce('values');
	    var visible = coerce('visible');
	    if(!(values && values.length)) {
	        visible = dimensionOut.visible = false;
	    }
	
	    if(visible) {
	        // Dimension level
	        coerce('label');
	        coerce('displayindex', dimensionOut._index);
	
	        // Category level
	        var arrayIn = dimensionIn.categoryarray;
	        var isValidArray = (Array.isArray(arrayIn) && arrayIn.length > 0);
	
	        var orderDefault;
	        if(isValidArray) orderDefault = 'array';
	        var order = coerce('categoryorder', orderDefault);
	
	        // coerce 'categoryarray' only in array order case
	        if(order === 'array') {
	            coerce('categoryarray');
	            coerce('ticktext');
	        } else {
	            delete dimensionIn.categoryarray;
	            delete dimensionIn.ticktext;
	        }
	
	        // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
	        if(!isValidArray && order === 'array') {
	            dimensionOut.categoryorder = 'trace';
	        }
	    }
	}
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	        name: 'dimensions',
	        handleItemDefaults: dimensionDefaults
	    });
	
	    var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    if(!Array.isArray(dimensions) || !dimensions.length) {
	        traceOut.visible = false;
	    }
	
	    mergeLength(traceOut, dimensions, 'values', len);
	
	    coerce('hoveron');
	    coerce('hovertemplate');
	    coerce('arrangement');
	    coerce('bundlecolors');
	    coerce('sortpaths');
	    coerce('counts');
	
	    var labelfontDflt = {
	        family: layout.font.family,
	        size: Math.round(layout.font.size),
	        color: layout.font.color
	    };
	
	    Lib.coerceFont(coerce, 'labelfont', labelfontDflt);
	
	    var categoryfontDefault = {
	        family: layout.font.family,
	        size: Math.round(layout.font.size / 1.2),
	        color: layout.font.color
	    };
	
	    Lib.coerceFont(coerce, 'tickfont', categoryfontDefault);
	};
	
	},{"../../components/colorscale/defaults":601,"../../components/colorscale/helpers":602,"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/domain":789,"../parcoords/merge_length":1089,"./attributes":1073}],1077:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    colorbar: {
	        container: 'line',
	        min: 'cmin',
	        max: 'cmax'
	    },
	
	    moduleType: 'trace',
	    name: 'parcats',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['noOpacity'],
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1073,"./base_plot":1074,"./calc":1075,"./defaults":1076,"./plot":1079}],1078:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Plotly = _dereq_('../../plot_api/plot_api');
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var tinycolor = _dereq_('tinycolor2');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	function performPlot(parcatsModels, graphDiv, layout, svg) {
	    var viewModels = parcatsModels.map(createParcatsViewModel.bind(0, graphDiv, layout));
	
	    // Get (potentially empty) parcatslayer selection with bound data to single element array
	    var layerSelection = svg.selectAll('g.parcatslayer').data([null]);
	
	    // Initialize single parcatslayer group if it doesn't exist
	    layerSelection.enter()
	        .append('g')
	        .attr('class', 'parcatslayer')
	        .style('pointer-events', 'all');
	
	    // Bind data to children of layerSelection and get reference to traceSelection
	    var traceSelection = layerSelection
	        .selectAll('g.trace.parcats')
	        .data(viewModels, key);
	
	    // Initialize group for each trace/dimensions
	    var traceEnter = traceSelection.enter()
	        .append('g')
	        .attr('class', 'trace parcats');
	
	    // Update properties for each trace
	    traceSelection
	        .attr('transform', function(d) {
	            return 'translate(' + d.x + ', ' + d.y + ')';
	        });
	
	    // Initialize paths group
	    traceEnter
	        .append('g')
	        .attr('class', 'paths');
	
	    // Update paths transform
	    var pathsSelection = traceSelection
	        .select('g.paths');
	
	    // Get paths selection
	    var pathSelection = pathsSelection
	        .selectAll('path.path')
	        .data(function(d) {
	            return d.paths;
	        }, key);
	
	    // Update existing path colors
	    pathSelection
	        .attr('fill', function(d) {
	            return d.model.color;
	        });
	
	    // Create paths
	    var pathSelectionEnter = pathSelection
	        .enter()
	        .append('path')
	        .attr('class', 'path')
	        .attr('stroke-opacity', 0)
	        .attr('fill', function(d) {
	            return d.model.color;
	        })
	        .attr('fill-opacity', 0);
	
	    stylePathsNoHover(pathSelectionEnter);
	
	    // Set path geometry
	    pathSelection
	        .attr('d', function(d) {
	            return d.svgD;
	        });
	
	    // sort paths
	    if(!pathSelectionEnter.empty()) {
	        // Only sort paths if there has been a change.
	        // Otherwise paths are already sorted or a hover operation may be in progress
	        pathSelection.sort(compareRawColor);
	    }
	
	    // Remove any old paths
	    pathSelection.exit().remove();
	
	    // Path hover
	    pathSelection
	        .on('mouseover', mouseoverPath)
	        .on('mouseout', mouseoutPath)
	        .on('click', clickPath);
	
	    // Initialize dimensions group
	    traceEnter.append('g').attr('class', 'dimensions');
	
	    // Update dimensions transform
	    var dimensionsSelection = traceSelection
	        .select('g.dimensions');
	
	    // Get dimension selection
	    var dimensionSelection = dimensionsSelection
	        .selectAll('g.dimension')
	        .data(function(d) {
	            return d.dimensions;
	        }, key);
	
	    // Create dimension groups
	    dimensionSelection.enter()
	        .append('g')
	        .attr('class', 'dimension');
	
	    // Update dimension group transforms
	    dimensionSelection.attr('transform', function(d) {
	        return 'translate(' + d.x + ', 0)';
	    });
	
	    // Remove any old dimensions
	    dimensionSelection.exit().remove();
	
	    // Get category selection
	    var categorySelection = dimensionSelection
	        .selectAll('g.category')
	        .data(function(d) {
	            return d.categories;
	        }, key);
	
	    // Initialize category groups
	    var categoryGroupEnterSelection = categorySelection
	        .enter()
	        .append('g')
	        .attr('class', 'category');
	
	    // Update category transforms
	    categorySelection
	        .attr('transform', function(d) {
	            return 'translate(0, ' + d.y + ')';
	        });
	
	
	    // Initialize rectangle
	    categoryGroupEnterSelection
	        .append('rect')
	        .attr('class', 'catrect')
	        .attr('pointer-events', 'none');
	
	
	    // Update rectangle
	    categorySelection.select('rect.catrect')
	        .attr('fill', 'none')
	        .attr('width', function(d) {
	            return d.width;
	        })
	        .attr('height', function(d) {
	            return d.height;
	        });
	
	    styleCategoriesNoHover(categoryGroupEnterSelection);
	
	    // Initialize color band rects
	    var bandSelection = categorySelection
	        .selectAll('rect.bandrect')
	        .data(
	            /** @param {CategoryViewModel} catViewModel*/
	            function(catViewModel) {
	                return catViewModel.bands;
	            }, key);
	
	    // Raise all update bands to the top so that fading enter/exit bands will be behind
	    bandSelection.each(function() {Lib.raiseToTop(this);});
	
	    // Update band color
	    bandSelection
	        .attr('fill', function(d) {
	            return d.color;
	        });
	
	    var bandsSelectionEnter = bandSelection.enter()
	        .append('rect')
	        .attr('class', 'bandrect')
	        .attr('stroke-opacity', 0)
	        .attr('fill', function(d) {
	            return d.color;
	        })
	        .attr('fill-opacity', 0);
	
	    bandSelection
	        .attr('fill', function(d) {
	            return d.color;
	        })
	        .attr('width', function(d) {
	            return d.width;
	        })
	        .attr('height', function(d) {
	            return d.height;
	        })
	        .attr('y', function(d) {
	            return d.y;
	        })
	        .attr('cursor',
	            /** @param {CategoryBandViewModel} bandModel*/
	            function(bandModel) {
	                if(bandModel.parcatsViewModel.arrangement === 'fixed') {
	                    return 'default';
	                } else if(bandModel.parcatsViewModel.arrangement === 'perpendicular') {
	                    return 'ns-resize';
	                } else {
	                    return 'move';
	                }
	            });
	
	    styleBandsNoHover(bandsSelectionEnter);
	
	    bandSelection.exit().remove();
	
	    // Initialize category label
	    categoryGroupEnterSelection
	        .append('text')
	        .attr('class', 'catlabel')
	        .attr('pointer-events', 'none');
	
	    var paperColor = graphDiv._fullLayout.paper_bgcolor;
	
	    // Update category label
	    categorySelection.select('text.catlabel')
	        .attr('text-anchor',
	            function(d) {
	                if(catInRightDim(d)) {
	                    // Place label to the right of category
	                    return 'start';
	                } else {
	                    // Place label to the left of category
	                    return 'end';
	                }
	            })
	        .attr('alignment-baseline', 'middle')
	
	        .style('text-shadow',
	            paperColor + ' -1px  1px 2px, ' +
	            paperColor + ' 1px  1px 2px, ' +
	            paperColor + '  1px -1px 2px, ' +
	            paperColor + ' -1px -1px 2px')
	        .style('fill', 'rgb(0, 0, 0)')
	        .attr('x',
	            function(d) {
	                if(catInRightDim(d)) {
	                    // Place label to the right of category
	                    return d.width + 5;
	                } else {
	                    // Place label to the left of category
	                    return -5;
	                }
	            })
	        .attr('y', function(d) {
	            return d.height / 2;
	        })
	        .text(function(d) {
	            return d.model.categoryLabel;
	        })
	        .each(
	            /** @param {CategoryViewModel} catModel*/
	            function(catModel) {
	                Drawing.font(d3.select(this), catModel.parcatsViewModel.categorylabelfont);
	                svgTextUtils.convertToTspans(d3.select(this), graphDiv);
	            });
	
	    // Initialize dimension label
	    categoryGroupEnterSelection
	        .append('text')
	        .attr('class', 'dimlabel');
	
	    // Update dimension label
	    categorySelection.select('text.dimlabel')
	        .attr('text-anchor', 'middle')
	        .attr('alignment-baseline', 'baseline')
	        .attr('cursor',
	             /** @param {CategoryViewModel} catModel*/
	            function(catModel) {
	                if(catModel.parcatsViewModel.arrangement === 'fixed') {
	                    return 'default';
	                } else {
	                    return 'ew-resize';
	                }
	            })
	        .attr('x', function(d) {
	            return d.width / 2;
	        })
	        .attr('y', -5)
	        .text(function(d, i) {
	            if(i === 0) {
	                // Add dimension label above topmost category
	                return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
	            } else {
	                return null;
	            }
	        })
	        .each(
	            /** @param {CategoryViewModel} catModel*/
	            function(catModel) {
	                Drawing.font(d3.select(this), catModel.parcatsViewModel.labelfont);
	            });
	
	    // Category hover
	    // categorySelection.select('rect.catrect')
	    categorySelection.selectAll('rect.bandrect')
	        .on('mouseover', mouseoverCategoryBand)
	        .on('mouseout', mouseoutCategory);
	
	    // Remove unused categories
	    categorySelection.exit().remove();
	
	    // Setup drag
	    dimensionSelection.call(d3.behavior.drag()
	        .origin(function(d) {
	            return {x: d.x, y: 0};
	        })
	        .on('dragstart', dragDimensionStart)
	        .on('drag', dragDimension)
	        .on('dragend', dragDimensionEnd));
	
	
	    // Save off selections to view models
	    traceSelection.each(function(d) {
	        d.traceSelection = d3.select(this);
	        d.pathSelection = d3.select(this).selectAll('g.paths').selectAll('path.path');
	        d.dimensionSelection = d3.select(this).selectAll('g.dimensions').selectAll('g.dimension');
	    });
	
	    // Remove any orphan traces
	    traceSelection.exit().remove();
	}
	
	/**
	 * Create / update parcat traces
	 *
	 * @param {Object} graphDiv
	 * @param {Object} svg
	 * @param {Array.<ParcatsModel>} parcatsModels
	 * @param {Layout} layout
	 */
	module.exports = function(graphDiv, svg, parcatsModels, layout) {
	    performPlot(parcatsModels, graphDiv, layout, svg);
	};
	
	/**
	 * Function the returns the key property of an object for use with as D3 join function
	 * @param d
	 */
	function key(d) {
	    return d.key;
	}
	
	 /** True if a category view model is in the right-most display dimension
	  * @param {CategoryViewModel} d */
	function catInRightDim(d) {
	    var numDims = d.parcatsViewModel.dimensions.length;
	    var leftDimInd = d.parcatsViewModel.dimensions[numDims - 1].model.dimensionInd;
	    return d.model.dimensionInd === leftDimInd;
	}
	
	/**
	 * @param {PathViewModel} a
	 * @param {PathViewModel} b
	 */
	function compareRawColor(a, b) {
	    if(a.model.rawColor > b.model.rawColor) {
	        return 1;
	    } else if(a.model.rawColor < b.model.rawColor) {
	        return -1;
	    } else {
	        return 0;
	    }
	}
	
	/**
	 * Handle path mouseover
	 * @param {PathViewModel} d
	 */
	function mouseoverPath(d) {
	    if(!d.parcatsViewModel.dragDimension) {
	        // We're not currently dragging
	
	        if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	            // hoverinfo is not skip, so we at least style the paths and emit interaction events
	
	            // Raise path to top
	            Lib.raiseToTop(this);
	
	            stylePathsHover(d3.select(this));
	
	            // Emit hover event
	            var points = buildPointsArrayForPath(d);
	            var constraints = buildConstraintsForPath(d);
	            d.parcatsViewModel.graphDiv.emit('plotly_hover', {
	                points: points, event: d3.event, constraints: constraints
	            });
	
	            // Handle hover label
	            if(d.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
	                // hoverinfo is a combination of 'count' and 'probability'
	
	                // Mouse
	                var hoverX = d3.mouse(this)[0];
	
	                // Label
	                var gd = d.parcatsViewModel.graphDiv;
	                var trace = d.parcatsViewModel.trace;
	                var fullLayout = gd._fullLayout;
	                var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
	                var graphDivBBox = d.parcatsViewModel.graphDiv.getBoundingClientRect();
	
	                // Find path center in path coordinates
	                var pathCenterX,
	                    pathCenterY,
	                    dimInd;
	
	                for(dimInd = 0; dimInd < (d.leftXs.length - 1); dimInd++) {
	                    if(d.leftXs[dimInd] + d.dimWidths[dimInd] - 2 <= hoverX && hoverX <= d.leftXs[dimInd + 1] + 2) {
	                        var leftDim = d.parcatsViewModel.dimensions[dimInd];
	                        var rightDim = d.parcatsViewModel.dimensions[dimInd + 1];
	                        pathCenterX = (leftDim.x + leftDim.width + rightDim.x) / 2;
	                        pathCenterY = (d.topYs[dimInd] + d.topYs[dimInd + 1] + d.height) / 2;
	                        break;
	                    }
	                }
	
	                // Find path center in root coordinates
	                var hoverCenterX = d.parcatsViewModel.x + pathCenterX;
	                var hoverCenterY = d.parcatsViewModel.y + pathCenterY;
	
	                var textColor = tinycolor.mostReadable(d.model.color, ['black', 'white']);
	
	                var count = d.model.count;
	                var prob = count / d.parcatsViewModel.model.count;
	                var labels = {
	                    countLabel: count,
	                    probabilityLabel: prob.toFixed(3)
	                };
	
	                // Build hover text
	                var hovertextParts = [];
	                if(d.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
	                    hovertextParts.push(['Count:', labels.countLabel].join(' '));
	                }
	                if(d.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
	                    hovertextParts.push(['P:', labels.probabilityLabel].join(' '));
	                }
	
	                var hovertext = hovertextParts.join('<br>');
	                var mouseX = d3.mouse(gd)[0];
	
	                Fx.loneHover({
	                    trace: trace,
	                    x: hoverCenterX - rootBBox.left + graphDivBBox.left,
	                    y: hoverCenterY - rootBBox.top + graphDivBBox.top,
	                    text: hovertext,
	                    color: d.model.color,
	                    borderColor: 'black',
	                    fontFamily: 'Monaco, "Courier New", monospace',
	                    fontSize: 10,
	                    fontColor: textColor,
	                    idealAlign: mouseX < hoverCenterX ? 'right' : 'left',
	                    hovertemplate: (trace.line || {}).hovertemplate,
	                    hovertemplateLabels: labels,
	                    eventData: [{
	                        data: trace._input,
	                        fullData: trace,
	                        count: count,
	                        probability: prob
	                    }]
	                }, {
	                    container: fullLayout._hoverlayer.node(),
	                    outerContainer: fullLayout._paper.node(),
	                    gd: gd
	                });
	            }
	        }
	    }
	}
	
	/**
	 * Handle path mouseout
	 * @param {PathViewModel} d
	 */
	function mouseoutPath(d) {
	    if(!d.parcatsViewModel.dragDimension) {
	        // We're not currently dragging
	        stylePathsNoHover(d3.select(this));
	
	        // Remove and hover label
	        Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	
	        // Restore path order
	        d.parcatsViewModel.pathSelection.sort(compareRawColor);
	
	        // Emit unhover event
	        if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	            var points = buildPointsArrayForPath(d);
	            var constraints = buildConstraintsForPath(d);
	            d.parcatsViewModel.graphDiv.emit('plotly_unhover', {
	                points: points, event: d3.event, constraints: constraints
	            });
	        }
	    }
	}
	
	/**
	 * Build array of point objects for a path
	 *
	 * For use in click/hover events
	 * @param {PathViewModel} d
	 */
	function buildPointsArrayForPath(d) {
	    var points = [];
	    var curveNumber = getTraceIndex(d.parcatsViewModel);
	
	    for(var i = 0; i < d.model.valueInds.length; i++) {
	        var pointNumber = d.model.valueInds[i];
	        points.push({
	            curveNumber: curveNumber,
	            pointNumber: pointNumber
	        });
	    }
	    return points;
	}
	
	/**
	 * Build constraints object for a path
	 *
	 * For use in click/hover events
	 * @param {PathViewModel} d
	 */
	function buildConstraintsForPath(d) {
	    var constraints = {};
	    var dimensions = d.parcatsViewModel.model.dimensions;
	
	    // dimensions
	    for(var i = 0; i < dimensions.length; i++) {
	        var dimension = dimensions[i];
	        var category = dimension.categories[d.model.categoryInds[i]];
	        constraints[dimension.containerInd] = category.categoryValue;
	    }
	
	    // color
	    if(d.model.rawColor !== undefined) {
	        constraints.color = d.model.rawColor;
	    }
	    return constraints;
	}
	
	/**
	 * Handle path click
	 * @param {PathViewModel} d
	 */
	function clickPath(d) {
	    if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	        // hoverinfo it's skip, so interaction events aren't disabled
	        var points = buildPointsArrayForPath(d);
	        var constraints = buildConstraintsForPath(d);
	        d.parcatsViewModel.graphDiv.emit('plotly_click', {
	            points: points, event: d3.event, constraints: constraints
	        });
	    }
	}
	
	function stylePathsNoHover(pathSelection) {
	    pathSelection
	        .attr('fill', function(d) {
	            return d.model.color;
	        })
	        .attr('fill-opacity', 0.6)
	        .attr('stroke', 'lightgray')
	        .attr('stroke-width', 0.2)
	        .attr('stroke-opacity', 1.0);
	}
	
	function stylePathsHover(pathSelection) {
	    pathSelection
	        .attr('fill-opacity', 0.8)
	        .attr('stroke', function(d) {
	            return tinycolor.mostReadable(d.model.color, ['black', 'white']);
	        })
	        .attr('stroke-width', 0.3);
	}
	
	function styleCategoryHover(categorySelection) {
	    categorySelection
	        .select('rect.catrect')
	        .attr('stroke', 'black')
	        .attr('stroke-width', 2.5);
	}
	
	function styleCategoriesNoHover(categorySelection) {
	    categorySelection
	        .select('rect.catrect')
	        .attr('stroke', 'black')
	        .attr('stroke-width', 1)
	        .attr('stroke-opacity', 1);
	}
	
	function styleBandsHover(bandsSelection) {
	    bandsSelection
	        .attr('stroke', 'black')
	        .attr('stroke-width', 1.5);
	}
	
	function styleBandsNoHover(bandsSelection) {
	    bandsSelection
	        .attr('stroke', 'black')
	        .attr('stroke-width', 0.2)
	        .attr('stroke-opacity', 1.0)
	        .attr('fill-opacity', 1.0);
	}
	
	/**
	 * Return selection of all paths that pass through the specified category
	 * @param {CategoryBandViewModel} catBandViewModel
	 */
	function selectPathsThroughCategoryBandColor(catBandViewModel) {
	    var allPaths = catBandViewModel.parcatsViewModel.pathSelection;
	    var dimInd = catBandViewModel.categoryViewModel.model.dimensionInd;
	    var catInd = catBandViewModel.categoryViewModel.model.categoryInd;
	
	    return allPaths
	        .filter(
	            /** @param {PathViewModel} pathViewModel */
	            function(pathViewModel) {
	                return pathViewModel.model.categoryInds[dimInd] === catInd &&
	                    pathViewModel.model.color === catBandViewModel.color;
	            });
	}
	
	
	/**
	 * Perform hover styling for all paths that pass though the specified band element's category
	 *
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 *
	 */
	function styleForCategoryHovermode(bandElement) {
	    // Get all bands in the current category
	    var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');
	
	    // Raise and style paths
	    bandSel.each(function(bvm) {
	        var paths = selectPathsThroughCategoryBandColor(bvm);
	        stylePathsHover(paths);
	        paths.each(function() {
	            // Raise path to top
	            Lib.raiseToTop(this);
	        });
	    });
	
	    // Style category
	    styleCategoryHover(d3.select(bandElement.parentNode));
	}
	
	/**
	 * Perform hover styling for all paths that pass though the category of the specified band element and share the
	 * same color
	 *
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 *
	 */
	function styleForColorHovermode(bandElement) {
	    var bandViewModel = d3.select(bandElement).datum();
	    var catPaths = selectPathsThroughCategoryBandColor(bandViewModel);
	    stylePathsHover(catPaths);
	    catPaths.each(function() {
	        // Raise path to top
	        Lib.raiseToTop(this);
	    });
	
	    // Style category for drag
	    d3.select(bandElement.parentNode)
	        .selectAll('rect.bandrect')
	        .filter(function(b) {return b.color === bandViewModel.color;})
	        .each(function() {
	            Lib.raiseToTop(this);
	            styleBandsHover(d3.select(this));
	        });
	}
	
	
	/**
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 * @param eventName
	 *  Event name (plotly_hover or plotly_click)
	 * @param event
	 *  Mouse Event
	 */
	function emitPointsEventCategoryHovermode(bandElement, eventName, event) {
	    // Get all bands in the current category
	    var bandViewModel = d3.select(bandElement).datum();
	    var categoryModel = bandViewModel.categoryViewModel.model;
	    var gd = bandViewModel.parcatsViewModel.graphDiv;
	    var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');
	
	    var points = [];
	    bandSel.each(function(bvm) {
	        var paths = selectPathsThroughCategoryBandColor(bvm);
	        paths.each(function(pathViewModel) {
	            // Extend points array
	            Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
	        });
	    });
	
	    var constraints = {};
	    constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
	    gd.emit(eventName, {
	        points: points, event: event, constraints: constraints
	    });
	}
	
	/**
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 * @param eventName
	 *  Event name (plotly_hover or plotly_click)
	 * @param event
	 *  Mouse Event
	 */
	function emitPointsEventColorHovermode(bandElement, eventName, event) {
	    var bandViewModel = d3.select(bandElement).datum();
	    var categoryModel = bandViewModel.categoryViewModel.model;
	    var gd = bandViewModel.parcatsViewModel.graphDiv;
	    var paths = selectPathsThroughCategoryBandColor(bandViewModel);
	
	    var points = [];
	    paths.each(function(pathViewModel) {
	        // Extend points array
	        Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
	    });
	
	    var constraints = {};
	    constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
	    // color
	    if(bandViewModel.rawColor !== undefined) {
	        constraints.color = bandViewModel.rawColor;
	    }
	    gd.emit(eventName, {
	        points: points, event: event, constraints: constraints
	    });
	}
	
	/**
	 * Create hover label for a band element's category (for use when hoveron === 'category')
	 *
	 * @param {ClientRect} rootBBox
	 *  Client bounding box for root of figure
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 *
	 */
	function createHoverLabelForCategoryHovermode(rootBBox, bandElement) {
	    // Selections
	    var rectSelection = d3.select(bandElement.parentNode).select('rect.catrect');
	    var rectBoundingBox = rectSelection.node().getBoundingClientRect();
	
	    // Models
	    /** @type {CategoryViewModel} */
	    var catViewModel = rectSelection.datum();
	    var parcatsViewModel = catViewModel.parcatsViewModel;
	    var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
	    var trace = parcatsViewModel.trace;
	
	    // Positions
	    var hoverCenterY = rectBoundingBox.top + rectBoundingBox.height / 2;
	    var hoverCenterX,
	        hoverLabelIdealAlign;
	
	    if(parcatsViewModel.dimensions.length > 1 &&
	        dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
	        // right most dimension
	        hoverCenterX = rectBoundingBox.left;
	        hoverLabelIdealAlign = 'left';
	    } else {
	        hoverCenterX = rectBoundingBox.left + rectBoundingBox.width;
	        hoverLabelIdealAlign = 'right';
	    }
	
	    var count = catViewModel.model.count;
	    var catLabel = catViewModel.model.categoryLabel;
	    var prob = count / catViewModel.parcatsViewModel.model.count;
	    var labels = {
	        countLabel: count,
	        categoryLabel: catLabel,
	        probabilityLabel: prob.toFixed(3)
	    };
	
	    // Hover label text
	    var hoverinfoParts = [];
	    if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
	        hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
	    }
	    if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
	        hoverinfoParts.push(['P(' + labels.categoryLabel + '):', labels.probabilityLabel].join(' '));
	    }
	
	    var hovertext = hoverinfoParts.join('<br>');
	    return {
	        trace: trace,
	        x: hoverCenterX - rootBBox.left,
	        y: hoverCenterY - rootBBox.top,
	        text: hovertext,
	        color: 'lightgray',
	        borderColor: 'black',
	        fontFamily: 'Monaco, "Courier New", monospace',
	        fontSize: 12,
	        fontColor: 'black',
	        idealAlign: hoverLabelIdealAlign,
	        hovertemplate: trace.hovertemplate,
	        hovertemplateLabels: labels,
	        eventData: [{
	            data: trace._input,
	            fullData: trace,
	            count: count,
	            category: catLabel,
	            probability: prob
	        }]
	    };
	}
	
	/**
	 * Create hover label for a band element's category (for use when hoveron === 'category')
	 *
	 * @param {ClientRect} rootBBox
	 *  Client bounding box for root of figure
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 *
	 */
	function createHoverLabelForDimensionHovermode(rootBBox, bandElement) {
	    var allHoverlabels = [];
	
	    d3.select(bandElement.parentNode.parentNode)
	        .selectAll('g.category')
	        .select('rect.catrect')
	        .each(function() {
	            var bandNode = this;
	            allHoverlabels.push(createHoverLabelForCategoryHovermode(rootBBox, bandNode));
	        });
	
	    return allHoverlabels;
	}
	
	/**
	 * Create hover labels for a band element's category (for use when hoveron === 'dimension')
	 *
	 * @param {ClientRect} rootBBox
	 *  Client bounding box for root of figure
	 * @param {HTMLElement} bandElement
	 *  HTML element for band
	 *
	 */
	function createHoverLabelForColorHovermode(rootBBox, bandElement) {
	    var bandBoundingBox = bandElement.getBoundingClientRect();
	
	    // Models
	    /** @type {CategoryBandViewModel} */
	    var bandViewModel = d3.select(bandElement).datum();
	    var catViewModel = bandViewModel.categoryViewModel;
	    var parcatsViewModel = catViewModel.parcatsViewModel;
	    var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
	    var trace = parcatsViewModel.trace;
	
	    // positions
	    var hoverCenterY = bandBoundingBox.y + bandBoundingBox.height / 2;
	
	    var hoverCenterX,
	        hoverLabelIdealAlign;
	    if(parcatsViewModel.dimensions.length > 1 &&
	        dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
	        // right most dimension
	        hoverCenterX = bandBoundingBox.left;
	        hoverLabelIdealAlign = 'left';
	    } else {
	        hoverCenterX = bandBoundingBox.left + bandBoundingBox.width;
	        hoverLabelIdealAlign = 'right';
	    }
	
	    // Labels
	    var catLabel = catViewModel.model.categoryLabel;
	
	    // Counts
	    var totalCount = bandViewModel.parcatsViewModel.model.count;
	
	    var bandColorCount = 0;
	    bandViewModel.categoryViewModel.bands.forEach(function(b) {
	        if(b.color === bandViewModel.color) {
	            bandColorCount += b.count;
	        }
	    });
	
	    var catCount = catViewModel.model.count;
	
	    var colorCount = 0;
	    parcatsViewModel.pathSelection.each(
	        /** @param {PathViewModel} pathViewModel */
	        function(pathViewModel) {
	            if(pathViewModel.model.color === bandViewModel.color) {
	                colorCount += pathViewModel.model.count;
	            }
	        });
	
	    var pColorAndCat = bandColorCount / totalCount;
	    var pCatGivenColor = bandColorCount / colorCount;
	    var pColorGivenCat = bandColorCount / catCount;
	
	    var labels = {
	        countLabel: totalCount,
	        categoryLabel: catLabel,
	        probabilityLabel: pColorAndCat.toFixed(3)
	    };
	
	    // Hover label text
	    var hoverinfoParts = [];
	    if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
	        hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
	    }
	    if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
	        hoverinfoParts.push('P(color ∩ ' + catLabel + '): ' + labels.probabilityLabel);
	        hoverinfoParts.push('P(' + catLabel + ' | color): ' + pCatGivenColor.toFixed(3));
	        hoverinfoParts.push('P(color | ' + catLabel + '): ' + pColorGivenCat.toFixed(3));
	    }
	
	    var hovertext = hoverinfoParts.join('<br>');
	
	    // Compute text color
	    var textColor = tinycolor.mostReadable(bandViewModel.color, ['black', 'white']);
	
	    return {
	        trace: trace,
	        x: hoverCenterX - rootBBox.left,
	        y: hoverCenterY - rootBBox.top,
	        // name: 'NAME',
	        text: hovertext,
	        color: bandViewModel.color,
	        borderColor: 'black',
	        fontFamily: 'Monaco, "Courier New", monospace',
	        fontColor: textColor,
	        fontSize: 10,
	        idealAlign: hoverLabelIdealAlign,
	        hovertemplate: trace.hovertemplate,
	        hovertemplateLabels: labels,
	        eventData: [{
	            data: trace._input,
	            fullData: trace,
	            category: catLabel,
	            count: totalCount,
	            probability: pColorAndCat,
	            categorycount: catCount,
	            colorcount: colorCount,
	            bandcolorcount: bandColorCount
	        }]
	    };
	}
	
	/**
	 * Handle dimension mouseover
	 * @param {CategoryBandViewModel} bandViewModel
	 */
	function mouseoverCategoryBand(bandViewModel) {
	    if(!bandViewModel.parcatsViewModel.dragDimension) {
	        // We're not currently dragging
	
	        if(bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	            // hoverinfo is not skip, so we at least style the bands and emit interaction events
	
	            // Mouse
	            var mouseY = d3.mouse(this)[1];
	            if(mouseY < -1) {
	                // Hover is above above the category rectangle (probably the dimension title text)
	                return;
	            }
	
	            var gd = bandViewModel.parcatsViewModel.graphDiv;
	            var fullLayout = gd._fullLayout;
	            var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
	            var hoveron = bandViewModel.parcatsViewModel.hoveron;
	
	            /** @type {HTMLElement} */
	            var bandElement = this;
	
	            // Handle style and events
	            if(hoveron === 'color') {
	                styleForColorHovermode(bandElement);
	                emitPointsEventColorHovermode(bandElement, 'plotly_hover', d3.event);
	            } else {
	                styleForCategoryHovermode(bandElement);
	                emitPointsEventCategoryHovermode(bandElement, 'plotly_hover', d3.event);
	            }
	
	            // Handle hover label
	            if(bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
	                var hoverItems;
	                if(hoveron === 'category') {
	                    hoverItems = createHoverLabelForCategoryHovermode(rootBBox, bandElement);
	                } else if(hoveron === 'color') {
	                    hoverItems = createHoverLabelForColorHovermode(rootBBox, bandElement);
	                } else if(hoveron === 'dimension') {
	                    hoverItems = createHoverLabelForDimensionHovermode(rootBBox, bandElement);
	                }
	
	                if(hoverItems) {
	                    Fx.loneHover(hoverItems, {
	                        container: fullLayout._hoverlayer.node(),
	                        outerContainer: fullLayout._paper.node(),
	                        gd: gd
	                    });
	                }
	            }
	        }
	    }
	}
	
	
	/**
	 * Handle dimension mouseover
	 * @param {CategoryBandViewModel} bandViewModel
	 */
	function mouseoutCategory(bandViewModel) {
	    var parcatsViewModel = bandViewModel.parcatsViewModel;
	
	    if(!parcatsViewModel.dragDimension) {
	        // We're not dragging anything
	
	        // Reset unhovered styles
	        stylePathsNoHover(parcatsViewModel.pathSelection);
	        styleCategoriesNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category'));
	        styleBandsNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category').selectAll('rect.bandrect'));
	
	        // Remove hover label
	        Fx.loneUnhover(parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	
	        // Restore path order
	        parcatsViewModel.pathSelection.sort(compareRawColor);
	
	        // Emit unhover event
	        if(parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	            var hoveron = bandViewModel.parcatsViewModel.hoveron;
	            var bandElement = this;
	
	            // Handle style and events
	            if(hoveron === 'color') {
	                emitPointsEventColorHovermode(bandElement, 'plotly_unhover', d3.event);
	            } else {
	                emitPointsEventCategoryHovermode(bandElement, 'plotly_unhover', d3.event);
	            }
	        }
	    }
	}
	
	
	/**
	 * Handle dimension drag start
	 * @param {DimensionViewModel} d
	 */
	function dragDimensionStart(d) {
	    // Check if dragging is supported
	    if(d.parcatsViewModel.arrangement === 'fixed') {
	        return;
	    }
	
	    // Save off initial drag indexes for dimension
	    d.dragDimensionDisplayInd = d.model.displayInd;
	    d.initialDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
	    d.dragHasMoved = false;
	
	    // Check for category hit
	    d.dragCategoryDisplayInd = null;
	    d3.select(this)
	        .selectAll('g.category')
	        .select('rect.catrect')
	        .each(
	            /** @param {CategoryViewModel} catViewModel */
	            function(catViewModel) {
	                var catMouseX = d3.mouse(this)[0];
	                var catMouseY = d3.mouse(this)[1];
	
	
	                if(-2 <= catMouseX && catMouseX <= catViewModel.width + 2 &&
	                    -2 <= catMouseY && catMouseY <= catViewModel.height + 2) {
	                    // Save off initial drag indexes for categories
	                    d.dragCategoryDisplayInd = catViewModel.model.displayInd;
	                    d.initialDragCategoryDisplayInds = d.model.categories.map(function(c) {
	                        return c.displayInd;
	                    });
	
	                    // Initialize categories dragY to be the current y position
	                    catViewModel.model.dragY = catViewModel.y;
	
	                    // Raise category
	                    Lib.raiseToTop(this.parentNode);
	
	                    // Get band element
	                    d3.select(this.parentNode)
	                        .selectAll('rect.bandrect')
	                        /** @param {CategoryBandViewModel} bandViewModel */
	                        .each(function(bandViewModel) {
	                            if(bandViewModel.y < catMouseY && catMouseY <= bandViewModel.y + bandViewModel.height) {
	                                d.potentialClickBand = this;
	                            }
	                        });
	                }
	            });
	
	    // Update toplevel drag dimension
	    d.parcatsViewModel.dragDimension = d;
	
	    // Remove hover label if any
	    Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	}
	
	/**
	 * Handle dimension drag
	 * @param {DimensionViewModel} d
	 */
	function dragDimension(d) {
	    // Check if dragging is supported
	    if(d.parcatsViewModel.arrangement === 'fixed') {
	        return;
	    }
	
	    d.dragHasMoved = true;
	
	    if(d.dragDimensionDisplayInd === null) {
	        return;
	    }
	
	    var dragDimInd = d.dragDimensionDisplayInd;
	    var prevDimInd = dragDimInd - 1;
	    var nextDimInd = dragDimInd + 1;
	
	    var dragDimension = d.parcatsViewModel
	        .dimensions[dragDimInd];
	
	    // Update category
	    if(d.dragCategoryDisplayInd !== null) {
	        var dragCategory = dragDimension.categories[d.dragCategoryDisplayInd];
	
	        // Update dragY by dy
	        dragCategory.model.dragY += d3.event.dy;
	        var categoryY = dragCategory.model.dragY;
	
	        // Check for category drag swaps
	        var catDisplayInd = dragCategory.model.displayInd;
	        var dimCategoryViews = dragDimension.categories;
	
	        var catAbove = dimCategoryViews[catDisplayInd - 1];
	        var catBelow = dimCategoryViews[catDisplayInd + 1];
	
	        // Check for overlap above
	        if(catAbove !== undefined) {
	            if(categoryY < (catAbove.y + catAbove.height / 2.0)) {
	                // Swap display inds
	                dragCategory.model.displayInd = catAbove.model.displayInd;
	                catAbove.model.displayInd = catDisplayInd;
	            }
	        }
	
	        if(catBelow !== undefined) {
	            if((categoryY + dragCategory.height) > (catBelow.y + catBelow.height / 2.0)) {
	                // Swap display inds
	                dragCategory.model.displayInd = catBelow.model.displayInd;
	                catBelow.model.displayInd = catDisplayInd;
	            }
	        }
	
	        // Update category drag display index
	        d.dragCategoryDisplayInd = dragCategory.model.displayInd;
	    }
	
	    // Update dimension position
	    if(d.dragCategoryDisplayInd === null || d.parcatsViewModel.arrangement === 'freeform') {
	        dragDimension.model.dragX = d3.event.x;
	
	        // Check for dimension swaps
	        var prevDimension = d.parcatsViewModel.dimensions[prevDimInd];
	        var nextDimension = d.parcatsViewModel.dimensions[nextDimInd];
	
	        if(prevDimension !== undefined) {
	            if(dragDimension.model.dragX < (prevDimension.x + prevDimension.width)) {
	                // Swap display inds
	                dragDimension.model.displayInd = prevDimension.model.displayInd;
	                prevDimension.model.displayInd = dragDimInd;
	            }
	        }
	
	        if(nextDimension !== undefined) {
	            if((dragDimension.model.dragX + dragDimension.width) > nextDimension.x) {
	                // Swap display inds
	                dragDimension.model.displayInd = nextDimension.model.displayInd;
	                nextDimension.model.displayInd = d.dragDimensionDisplayInd;
	            }
	        }
	
	        // Update drag display index
	        d.dragDimensionDisplayInd = dragDimension.model.displayInd;
	    }
	
	    // Update view models
	    updateDimensionViewModels(d.parcatsViewModel);
	    updatePathViewModels(d.parcatsViewModel);
	
	    // Update svg geometry
	    updateSvgCategories(d.parcatsViewModel);
	    updateSvgPaths(d.parcatsViewModel);
	}
	
	
	/**
	 * Handle dimension drag end
	 * @param {DimensionViewModel} d
	 */
	function dragDimensionEnd(d) {
	    // Check if dragging is supported
	    if(d.parcatsViewModel.arrangement === 'fixed') {
	        return;
	    }
	
	    if(d.dragDimensionDisplayInd === null) {
	        return;
	    }
	
	    d3.select(this).selectAll('text').attr('font-weight', 'normal');
	
	    // Compute restyle command
	    // -----------------------
	    var restyleData = {};
	    var traceInd = getTraceIndex(d.parcatsViewModel);
	
	    // ### Handle dimension reordering ###
	    var finalDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
	    var anyDimsReordered = d.initialDragDimensionDisplayInds.some(function(initDimDisplay, dimInd) {
	        return initDimDisplay !== finalDragDimensionDisplayInds[dimInd];
	    });
	
	    if(anyDimsReordered) {
	        finalDragDimensionDisplayInds.forEach(function(finalDimDisplay, dimInd) {
	            var containerInd = d.parcatsViewModel.model.dimensions[dimInd].containerInd;
	            restyleData['dimensions[' + containerInd + '].displayindex'] = finalDimDisplay;
	        });
	    }
	
	    // ### Handle category reordering ###
	    var anyCatsReordered = false;
	    if(d.dragCategoryDisplayInd !== null) {
	        var finalDragCategoryDisplayInds = d.model.categories.map(function(c) {
	            return c.displayInd;
	        });
	
	        anyCatsReordered = d.initialDragCategoryDisplayInds.some(function(initCatDisplay, catInd) {
	            return initCatDisplay !== finalDragCategoryDisplayInds[catInd];
	        });
	
	        if(anyCatsReordered) {
	            // Sort a shallow copy of the category models by display index
	            var sortedCategoryModels = d.model.categories.slice().sort(
	                function(a, b) { return a.displayInd - b.displayInd; });
	
	            // Get new categoryarray and ticktext values
	            var newCategoryArray = sortedCategoryModels.map(function(v) { return v.categoryValue; });
	            var newCategoryLabels = sortedCategoryModels.map(function(v) { return v.categoryLabel; });
	
	            restyleData['dimensions[' + d.model.containerInd + '].categoryarray'] = [newCategoryArray];
	            restyleData['dimensions[' + d.model.containerInd + '].ticktext'] = [newCategoryLabels];
	            restyleData['dimensions[' + d.model.containerInd + '].categoryorder'] = 'array';
	        }
	    }
	
	    // Handle potential click event
	    // ----------------------------
	    if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
	        if(!d.dragHasMoved && d.potentialClickBand) {
	            if(d.parcatsViewModel.hoveron === 'color') {
	                emitPointsEventColorHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
	            } else {
	                emitPointsEventCategoryHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
	            }
	        }
	    }
	
	    // Nullify drag states
	    // -------------------
	    d.model.dragX = null;
	    if(d.dragCategoryDisplayInd !== null) {
	        var dragCategory = d.parcatsViewModel
	            .dimensions[d.dragDimensionDisplayInd]
	            .categories[d.dragCategoryDisplayInd];
	
	        dragCategory.model.dragY = null;
	        d.dragCategoryDisplayInd = null;
	    }
	
	    d.dragDimensionDisplayInd = null;
	    d.parcatsViewModel.dragDimension = null;
	    d.dragHasMoved = null;
	    d.potentialClickBand = null;
	
	    // Update view models
	    // ------------------
	    updateDimensionViewModels(d.parcatsViewModel);
	    updatePathViewModels(d.parcatsViewModel);
	
	    // Perform transition
	    // ------------------
	    var transition = d3.transition()
	        .duration(300)
	        .ease('cubic-in-out');
	
	    transition
	        .each(function() {
	            updateSvgCategories(d.parcatsViewModel, true);
	            updateSvgPaths(d.parcatsViewModel, true);
	        })
	        .each('end', function() {
	            if(anyDimsReordered || anyCatsReordered) {
	                // Perform restyle if the order of categories or dimensions changed
	                Plotly.restyle(d.parcatsViewModel.graphDiv, restyleData, [traceInd]);
	            }
	        });
	}
	
	/**
	 *
	 * @param {ParcatsViewModel} parcatsViewModel
	 */
	function getTraceIndex(parcatsViewModel) {
	    var traceInd;
	    var allTraces = parcatsViewModel.graphDiv._fullData;
	    for(var i = 0; i < allTraces.length; i++) {
	        if(parcatsViewModel.key === allTraces[i].uid) {
	            traceInd = i;
	            break;
	        }
	    }
	    return traceInd;
	}
	
	/** Update the svg paths for view model
	 * @param {ParcatsViewModel} parcatsViewModel
	 * @param {boolean} hasTransition Whether to update element with transition
	 */
	function updateSvgPaths(parcatsViewModel, hasTransition) {
	    if(hasTransition === undefined) {
	        hasTransition = false;
	    }
	
	    function transition(selection) {
	        return hasTransition ? selection.transition() : selection;
	    }
	
	    // Update binding
	    parcatsViewModel.pathSelection.data(function(d) {
	        return d.paths;
	    }, key);
	
	    // Update paths
	    transition(parcatsViewModel.pathSelection).attr('d', function(d) {
	        return d.svgD;
	    });
	}
	
	/** Update the svg paths for view model
	 * @param {ParcatsViewModel} parcatsViewModel
	 * @param {boolean} hasTransition Whether to update element with transition
	 */
	function updateSvgCategories(parcatsViewModel, hasTransition) {
	    if(hasTransition === undefined) {
	        hasTransition = false;
	    }
	
	    function transition(selection) {
	        return hasTransition ? selection.transition() : selection;
	    }
	
	    // Update binding
	    parcatsViewModel.dimensionSelection
	        .data(function(d) {
	            return d.dimensions;
	        }, key);
	
	    var categorySelection = parcatsViewModel.dimensionSelection
	        .selectAll('g.category')
	        .data(function(d) {return d.categories;}, key);
	
	    // Update dimension position
	    transition(parcatsViewModel.dimensionSelection)
	        .attr('transform', function(d) {
	            return 'translate(' + d.x + ', 0)';
	        });
	
	    // Update category position
	    transition(categorySelection)
	        .attr('transform', function(d) {
	            return 'translate(0, ' + d.y + ')';
	        });
	
	    var dimLabelSelection = categorySelection.select('.dimlabel');
	
	    // ### Update dimension label
	    // Only the top-most display category should have the dimension label
	    dimLabelSelection
	        .text(function(d, i) {
	            if(i === 0) {
	                // Add dimension label above topmost category
	                return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
	            } else {
	                return null;
	            }
	        });
	
	    // Update category label
	    // Categories in the right-most display dimension have their labels on
	    // the right, all others on the left
	    var catLabelSelection = categorySelection.select('.catlabel');
	    catLabelSelection
	        .attr('text-anchor',
	            function(d) {
	                if(catInRightDim(d)) {
	                    // Place label to the right of category
	                    return 'start';
	                } else {
	                    // Place label to the left of category
	                    return 'end';
	                }
	            })
	        .attr('x',
	            function(d) {
	                if(catInRightDim(d)) {
	                    // Place label to the right of category
	                    return d.width + 5;
	                } else {
	                    // Place label to the left of category
	                    return -5;
	                }
	            })
	        .each(function(d) {
	            // Update attriubutes of <tspan> elements
	            var newX;
	            var newAnchor;
	            if(catInRightDim(d)) {
	                // Place label to the right of category
	                newX = d.width + 5;
	                newAnchor = 'start';
	            } else {
	                // Place label to the left of category
	                newX = -5;
	                newAnchor = 'end';
	            }
	            d3.select(this)
	                .selectAll('tspan')
	                .attr('x', newX)
	                .attr('text-anchor', newAnchor);
	        });
	
	    // Update bands
	    // Initialize color band rects
	    var bandSelection = categorySelection
	        .selectAll('rect.bandrect')
	        .data(
	            /** @param {CategoryViewModel} catViewModel*/
	            function(catViewModel) {
	                return catViewModel.bands;
	            }, key);
	
	    var bandsSelectionEnter = bandSelection.enter()
	        .append('rect')
	        .attr('class', 'bandrect')
	        .attr('cursor', 'move')
	        .attr('stroke-opacity', 0)
	        .attr('fill', function(d) {
	            return d.color;
	        })
	        .attr('fill-opacity', 0);
	
	    bandSelection
	        .attr('fill', function(d) {
	            return d.color;
	        })
	        .attr('width', function(d) {
	            return d.width;
	        })
	        .attr('height', function(d) {
	            return d.height;
	        })
	        .attr('y', function(d) {
	            return d.y;
	        });
	
	    styleBandsNoHover(bandsSelectionEnter);
	
	    // Raise bands to the top
	    bandSelection.each(function() {Lib.raiseToTop(this);});
	
	    // Remove unused bands
	    bandSelection.exit().remove();
	}
	
	/**
	 * Create a ParcatsViewModel traces
	 * @param {Object} graphDiv
	 *  Top-level graph div element
	 * @param {Layout} layout
	 *  SVG layout object
	 * @param {Array.<ParcatsModel>} wrappedParcatsModel
	 *  Wrapped ParcatsModel for this trace
	 * @return {ParcatsViewModel}
	 */
	function createParcatsViewModel(graphDiv, layout, wrappedParcatsModel) {
	    // Unwrap model
	    var parcatsModel = wrappedParcatsModel[0];
	
	    // Compute margin
	    var margin = layout.margin || {l: 80, r: 80, t: 100, b: 80};
	
	    // Compute pixel position/extents
	    var trace = parcatsModel.trace;
	    var domain = trace.domain;
	    var figureWidth = layout.width;
	    var figureHeight = layout.height;
	    var traceWidth = Math.floor(figureWidth * (domain.x[1] - domain.x[0]));
	    var traceHeight = Math.floor(figureHeight * (domain.y[1] - domain.y[0]));
	    var traceX = domain.x[0] * figureWidth + margin.l;
	    var traceY = layout.height - domain.y[1] * layout.height + margin.t;
	
	    // Handle path shape
	    // -----------------
	    var pathShape = trace.line.shape;
	
	    // Handle hover info
	    // -----------------
	    var hoverinfoItems;
	    if(trace.hoverinfo === 'all') {
	        hoverinfoItems = ['count', 'probability'];
	    } else {
	        hoverinfoItems = (trace.hoverinfo || '').split('+');
	    }
	
	    // Construct parcatsViewModel
	    // --------------------------
	    var parcatsViewModel = {
	        trace: trace,
	        key: trace.uid,
	        model: parcatsModel,
	        x: traceX,
	        y: traceY,
	        width: traceWidth,
	        height: traceHeight,
	        hoveron: trace.hoveron,
	        hoverinfoItems: hoverinfoItems,
	        arrangement: trace.arrangement,
	        bundlecolors: trace.bundlecolors,
	        sortpaths: trace.sortpaths,
	        labelfont: trace.labelfont,
	        categorylabelfont: trace.tickfont,
	        pathShape: pathShape,
	        dragDimension: null,
	        margin: margin,
	        paths: [],
	        dimensions: [],
	        graphDiv: graphDiv,
	        traceSelection: null,
	        pathSelection: null,
	        dimensionSelection: null
	    };
	
	    // Update dimension view models if we have at least 1 dimension
	    if(parcatsModel.dimensions) {
	        updateDimensionViewModels(parcatsViewModel);
	
	        // Update path view models if we have at least 2 dimensions
	        updatePathViewModels(parcatsViewModel);
	    }
	    // Inside a categories view model
	    return parcatsViewModel;
	}
	
	/**
	 * Build the SVG string to represents a parallel categories path
	 * @param {Array.<Number>} leftXPositions
	 *  Array of the x positions of the left edge of each dimension (in display order)
	 * @param {Array.<Number>} pathYs
	 *  Array of the y positions of the top of the path at each dimension (in display order)
	 * @param {Array.<Number>} dimWidths
	 *  Array of the widths of each dimension in display order
	 * @param {Number} pathHeight
	 *  The height of the path in pixels
	 * @param {Number} curvature
	 *  The curvature factor for the path. 0 results in a straight line and values greater than zero result in curved paths
	 * @return {string}
	 */
	function buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, curvature) {
	    // Compute the x midpoint of each path segment
	    var xRefPoints1 = [];
	    var xRefPoints2 = [];
	    var refInterpolator;
	    var d;
	
	    for(d = 0; d < dimWidths.length - 1; d++) {
	        refInterpolator = d3.interpolateNumber(dimWidths[d] + leftXPositions[d], leftXPositions[d + 1]);
	        xRefPoints1.push(refInterpolator(curvature));
	        xRefPoints2.push(refInterpolator(1 - curvature));
	    }
	
	    // Move to top of path on left edge of left-most category
	    var svgD = 'M ' + leftXPositions[0] + ',' + pathYs[0];
	
	    // Horizontal line to right edge
	    svgD += 'l' + dimWidths[0] + ',0 ';
	
	    // Horizontal line to right edge
	    for(d = 1; d < dimWidths.length; d++) {
	        // Curve to left edge of category
	        svgD += 'C' + xRefPoints1[d - 1] + ',' + pathYs[d - 1] +
	              ' ' + xRefPoints2[d - 1] + ',' + pathYs[d] +
	              ' ' + leftXPositions[d] + ',' + pathYs[d];
	
	        // svgD += 'L' + leftXPositions[d] + ',' + pathYs[d];
	
	        // Horizontal line to right edge
	        svgD += 'l' + dimWidths[d] + ',0 ';
	    }
	
	    // Line down
	    svgD += 'l' + '0,' + pathHeight + ' ';
	
	    // Line to left edge of right-most category
	    svgD += 'l -' + dimWidths[dimWidths.length - 1] + ',0 ';
	
	    for(d = dimWidths.length - 2; d >= 0; d--) {
	        // Curve to right edge of category
	        svgD += 'C' + xRefPoints2[d] + ',' + (pathYs[d + 1] + pathHeight) +
	             ' ' + xRefPoints1[d] + ',' + (pathYs[d] + pathHeight) +
	             ' ' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);
	
	        // svgD += 'L' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);
	
	        // Horizontal line to right edge
	        svgD += 'l-' + dimWidths[d] + ',0 ';
	    }
	
	    // Close path
	    svgD += 'Z';
	    return svgD;
	}
	
	/**
	 * Update the path view models based on the dimension view models in a ParcatsViewModel
	 *
	 * @param {ParcatsViewModel} parcatsViewModel
	 *  View model for trace
	 */
	function updatePathViewModels(parcatsViewModel) {
	    // Initialize an array of the y position of the top of the next path to be added to each category.
	    //
	    // nextYPositions[d][c] is the y position of the next path through category with index c of dimension with index d
	    var dimensionViewModels = parcatsViewModel.dimensions;
	    var parcatsModel = parcatsViewModel.model;
	    var nextYPositions = dimensionViewModels.map(
	        function(d) {
	            return d.categories.map(
	                function(c) {
	                    return c.y;
	                });
	        });
	
	    // Array from category index to category display index for each true dimension index
	    var catToDisplayIndPerDim = parcatsViewModel.model.dimensions.map(
	        function(d) {
	            return d.categories.map(function(c) {return c.displayInd;});
	        });
	
	    // Array from true dimension index to dimension display index
	    var dimToDisplayInd = parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
	    var displayToDimInd = parcatsViewModel.dimensions.map(function(d) {return d.model.dimensionInd;});
	
	    // Array of the x position of the left edge of the rectangles for each dimension
	    var leftXPositions = dimensionViewModels.map(
	        function(d) {
	            return d.x;
	        });
	
	    // Compute dimension widths
	    var dimWidths = dimensionViewModels.map(function(d) {return d.width;});
	
	    // Build sorted Array of PathModel objects
	    var pathModels = [];
	    for(var p in parcatsModel.paths) {
	        if(parcatsModel.paths.hasOwnProperty(p)) {
	            pathModels.push(parcatsModel.paths[p]);
	        }
	    }
	
	    // Compute category display inds to use for sorting paths
	    function pathDisplayCategoryInds(pathModel) {
	        var dimensionInds = pathModel.categoryInds.map(function(catInd, dimInd) {return catToDisplayIndPerDim[dimInd][catInd];});
	        var displayInds = displayToDimInd.map(function(dimInd) {
	            return dimensionInds[dimInd];
	        });
	        return displayInds;
	    }
	
	    // Sort in ascending order by display index array
	    pathModels.sort(function(v1, v2) {
	        // Build display inds for each path
	        var sortArray1 = pathDisplayCategoryInds(v1);
	        var sortArray2 = pathDisplayCategoryInds(v2);
	
	        // Handle path sort order
	        if(parcatsViewModel.sortpaths === 'backward') {
	            sortArray1.reverse();
	            sortArray2.reverse();
	        }
	
	        // Append the first value index of the path to break ties
	        sortArray1.push(v1.valueInds[0]);
	        sortArray2.push(v2.valueInds[0]);
	
	        // Handle color bundling
	        if(parcatsViewModel.bundlecolors) {
	            // Prepend sort array with the raw color value
	            sortArray1.unshift(v1.rawColor);
	            sortArray2.unshift(v2.rawColor);
	        }
	
	        // colors equal, sort by display categories
	        if(sortArray1 < sortArray2) {
	            return -1;
	        }
	        if(sortArray1 > sortArray2) {
	            return 1;
	        }
	
	        return 0;
	    });
	
	    // Create path models
	    var pathViewModels = new Array(pathModels.length);
	    var totalCount = dimensionViewModels[0].model.count;
	    var totalHeight = dimensionViewModels[0].categories
	        .map(function(c) { return c.height; })
	        .reduce(function(v1, v2) { return v1 + v2; });
	
	
	    for(var pathNumber = 0; pathNumber < pathModels.length; pathNumber++) {
	        var pathModel = pathModels[pathNumber];
	
	        var pathHeight;
	        if(totalCount > 0) {
	            pathHeight = totalHeight * (pathModel.count / totalCount);
	        } else {
	            pathHeight = 0;
	        }
	
	        // Build path y coords
	        var pathYs = new Array(nextYPositions.length);
	        for(var d = 0; d < pathModel.categoryInds.length; d++) {
	            var catInd = pathModel.categoryInds[d];
	            var catDisplayInd = catToDisplayIndPerDim[d][catInd];
	            var dimDisplayInd = dimToDisplayInd[d];
	
	            // Update next y position
	            pathYs[dimDisplayInd] = nextYPositions[dimDisplayInd][catDisplayInd];
	            nextYPositions[dimDisplayInd][catDisplayInd] += pathHeight;
	
	            // Update category color information
	            var catViewModle = parcatsViewModel.dimensions[dimDisplayInd].categories[catDisplayInd];
	            var numBands = catViewModle.bands.length;
	            var lastCatBand = catViewModle.bands[numBands - 1];
	
	            if(lastCatBand === undefined || pathModel.rawColor !== lastCatBand.rawColor) {
	                // Create a new band
	                var bandY = lastCatBand === undefined ? 0 : lastCatBand.y + lastCatBand.height;
	                catViewModle.bands.push({
	                    key: bandY,
	                    color: pathModel.color,
	                    rawColor: pathModel.rawColor,
	                    height: pathHeight,
	                    width: catViewModle.width,
	                    count: pathModel.count,
	                    y: bandY,
	                    categoryViewModel: catViewModle,
	                    parcatsViewModel: parcatsViewModel
	                });
	            } else {
	                // Extend current band
	                var currentBand = catViewModle.bands[numBands - 1];
	                currentBand.height += pathHeight;
	                currentBand.count += pathModel.count;
	            }
	        }
	
	        // build svg path
	        var svgD;
	        if(parcatsViewModel.pathShape === 'hspline') {
	            svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0.5);
	        } else {
	            svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0);
	        }
	
	        pathViewModels[pathNumber] = {
	            key: pathModel.valueInds[0],
	            model: pathModel,
	            height: pathHeight,
	            leftXs: leftXPositions,
	            topYs: pathYs,
	            dimWidths: dimWidths,
	            svgD: svgD,
	            parcatsViewModel: parcatsViewModel
	        };
	    }
	
	    parcatsViewModel.paths = pathViewModels;
	
	 // * @property key
	 // *  Unique key for this model
	 // * @property {PathModel} model
	 // *  Source path model
	 // * @property {Number} height
	 // *  Height of this path (pixels)
	 // * @property {String} svgD
	 // *  SVG path "d" attribute string
	}
	
	/**
	 * Update the dimension view models based on the dimension models in a ParcatsViewModel
	 *
	 * @param {ParcatsViewModel} parcatsViewModel
	 *  View model for trace
	 */
	function updateDimensionViewModels(parcatsViewModel) {
	    // Compute dimension ordering
	    var dimensionsIndInfo = parcatsViewModel.model.dimensions.map(function(d) {
	        return {displayInd: d.displayInd, dimensionInd: d.dimensionInd};
	    });
	
	    dimensionsIndInfo.sort(function(a, b) {
	        return a.displayInd - b.displayInd;
	    });
	
	    var dimensions = [];
	    for(var displayInd in dimensionsIndInfo) {
	        var dimensionInd = dimensionsIndInfo[displayInd].dimensionInd;
	        var dimModel = parcatsViewModel.model.dimensions[dimensionInd];
	        dimensions.push(createDimensionViewModel(parcatsViewModel, dimModel));
	    }
	
	    parcatsViewModel.dimensions = dimensions;
	}
	
	/**
	 * Create a parcats DimensionViewModel
	 *
	 * @param {ParcatsViewModel} parcatsViewModel
	 *  View model for trace
	 * @param {DimensionModel} dimensionModel
	 * @return {DimensionViewModel}
	 */
	function createDimensionViewModel(parcatsViewModel, dimensionModel) {
	    // Compute dimension x position
	    var categoryLabelPad = 40;
	    var dimWidth = 16;
	    var numDimensions = parcatsViewModel.model.dimensions.length;
	    var displayInd = dimensionModel.displayInd;
	
	    // Compute x coordinate values
	    var dimDx;
	    var dimX0;
	    var dimX;
	
	    if(numDimensions > 1) {
	        dimDx = (parcatsViewModel.width - 2 * categoryLabelPad - dimWidth) / (numDimensions - 1);
	    } else {
	        dimDx = 0;
	    }
	    dimX0 = categoryLabelPad;
	    dimX = dimX0 + dimDx * displayInd;
	
	    // Compute categories
	    var categories = [];
	    var maxCats = parcatsViewModel.model.maxCats;
	    var numCats = dimensionModel.categories.length;
	    var catSpacing = 8;
	    var totalCount = dimensionModel.count;
	    var totalHeight = parcatsViewModel.height - catSpacing * (maxCats - 1);
	    var nextCatHeight;
	    var nextCatModel;
	    var nextCat;
	    var catInd;
	    var catDisplayInd;
	
	    // Compute starting Y offset
	    var nextCatY = (maxCats - numCats) * catSpacing / 2.0;
	
	    // Compute category ordering
	    var categoryIndInfo = dimensionModel.categories.map(function(c) {
	        return {displayInd: c.displayInd, categoryInd: c.categoryInd};
	    });
	
	    categoryIndInfo.sort(function(a, b) {
	        return a.displayInd - b.displayInd;
	    });
	
	    for(catDisplayInd = 0; catDisplayInd < numCats; catDisplayInd++) {
	        catInd = categoryIndInfo[catDisplayInd].categoryInd;
	        nextCatModel = dimensionModel.categories[catInd];
	
	        if(totalCount > 0) {
	            nextCatHeight = (nextCatModel.count / totalCount) * totalHeight;
	        } else {
	            nextCatHeight = 0;
	        }
	
	        nextCat = {
	            key: nextCatModel.valueInds[0],
	            model: nextCatModel,
	            width: dimWidth,
	            height: nextCatHeight,
	            y: nextCatModel.dragY !== null ? nextCatModel.dragY : nextCatY,
	            bands: [],
	            parcatsViewModel: parcatsViewModel
	        };
	
	        nextCatY = nextCatY + nextCatHeight + catSpacing;
	        categories.push(nextCat);
	    }
	
	    return {
	        key: dimensionModel.dimensionInd,
	        x: dimensionModel.dragX !== null ? dimensionModel.dragX : dimX,
	        y: 0,
	        width: dimWidth,
	        model: dimensionModel,
	        categories: categories,
	        parcatsViewModel: parcatsViewModel,
	        dragCategoryDisplayInd: null,
	        dragDimensionDisplayInd: null,
	        initialDragDimensionDisplayInds: null,
	        initialDragCategoryDisplayInds: null,
	        dragHasMoved: null,
	        potentialClickBand: null
	    };
	}
	
	// JSDoc typedefs
	// ==============
	/**
	 * @typedef {Object} Layout
	 *  Object containing svg layout information
	 *
	 * @property {Number} width (pixels)
	 *  Usable width for Figure (after margins are removed)
	 * @property {Number} height (pixels)
	 *  Usable height for Figure (after margins are removed)
	 * @property {Margin} margin
	 *  Margin around the Figure (pixels)
	 */
	
	/**
	 * @typedef {Object} Margin
	 *  Object containing padding information in pixels
	 *
	 * @property {Number} t
	 *  Top margin
	 * @property {Number} r
	 *  Right margin
	 * @property {Number} b
	 *  Bottom margin
	 * @property {Number} l
	 *  Left margin
	 */
	
	/**
	 * @typedef {Object} Font
	 *  Object containing font information
	 *
	 * @property {Number} size: Font size
	 * @property {String} color: Font color
	 * @property {String} family: Font family
	 */
	
	/**
	 * @typedef {Object} ParcatsViewModel
	 *  Object containing calculated parcats view information
	 *
	 *  These are quantities that require Layout information to calculate
	 * @property key
	 *  Unique key for this model
	 * @property {ParcatsModel} model
	 *  Source parcats model
	 * @property {Array.<DimensionViewModel>} dimensions
	 *  Array of dimension view models
	 * @property {Number} width
	 *  Width for this trace (pixels)
	 * @property {Number} height
	 *  Height for this trace (pixels)
	 * @property {Number} x
	 *  X position of this trace with respect to the Figure (pixels)
	 * @property {Number} y
	 *  Y position of this trace with respect to the Figure (pixels)
	 * @property {String} hoveron
	 *  Hover interaction mode. One of: 'category', 'color', or 'dimension'
	 * @property {Array.<String>} hoverinfoItems
	 *  Info to display on hover. Array with a combination of 'counts' and/or 'probabilities', or 'none', or 'skip'
	 * @property {String} arrangement
	 *  Category arrangement. One of: 'perpendicular', 'freeform', or 'fixed'
	 * @property {Boolean} bundlecolors
	 *  Whether paths should be sorted so that like colors are bundled together as they pass through categories
	 * @property {String} sortpaths
	 *  If 'forward' then sort paths based on dimensions from left to right. If 'backward' sort based on dimensions
	 *  from right to left
	 * @property {Font} labelfont
	 *  Font for the dimension labels
	 * @property {Font} categorylabelfont
	 *  Font for the category labels
	 * @property {String} pathShape
	 *  The shape of the paths. Either 'linear' or 'hspline'.
	 * @property {DimensionViewModel|null} dragDimension
	 *  Dimension currently being dragged. Null if no drag in progress
	 * @property {Margin} margin
	 *  Margin around the Figure
	 * @property {Object} graphDiv
	 *  Top-level graph div element
	 * @property {Object} traceSelection
	 *  D3 selection of this view models trace group element
	 * @property {Object} pathSelection
	 *  D3 selection of this view models path elements
	 * @property {Object} dimensionSelection
	 *  D3 selection of this view models dimension group element
	 */
	
	/**
	 * @typedef {Object} DimensionViewModel
	 *  Object containing calculated parcats dimension view information
	 *
	 *  These are quantities that require Layout information to calculate
	 * @property key
	 *  Unique key for this model
	 * @property {DimensionModel} model
	 *  Source dimension model
	 * @property {Number} x
	 *  X position of the center of this dimension with respect to the Figure (pixels)
	 * @property {Number} y
	 *  Y position of the top of this dimension with respect to the Figure (pixels)
	 * @property {Number} width
	 *  Width of categories in this dimension (pixels)
	 * @property {ParcatsViewModel} parcatsViewModel
	 *  The parent trace's view model
	 * @property {Array.<CategoryViewModel>} categories
	 *  Dimensions category view models
	 * @property {Number|null} dragCategoryDisplayInd
	 *  Display index of category currently being dragged. null if no category is being dragged
	 * @property {Number|null} dragDimensionDisplayInd
	 *  Display index of the dimension being dragged. null if no dimension is being dragged
	 * @property {Array.<Number>|null} initialDragDimensionDisplayInds
	 *  Dimensions display indexes at the beginning of the current drag. null if no dimension is being dragged
	 * @property {Array.<Number>|null} initialDragCategoryDisplayInds
	 *  Category display indexes for the at the beginning of the current drag. null if no category is being dragged
	 * @property {HTMLElement} potentialClickBand
	 *  Band under mouse when current drag began. If no drag movement takes place then a click will be emitted for this
	 *  band. Null if not drag in progress.
	 * @property {Boolean} dragHasMoved
	 *  True if there is an active drag and the drag has moved. If drag doesn't move before being ended then
	 *  this may be interpreted as a click. Null if no drag in progress
	 */
	
	/**
	 * @typedef {Object} CategoryViewModel
	 *  Object containing calculated parcats category view information
	 *
	 *  These are quantities that require Layout information to calculate
	 * @property key
	 *  Unique key for this model
	 * @property {CategoryModel} model
	 *  Source category model
	 * @property {Number} width
	 *  Width for this category (pixels)
	 * @property {Number} height
	 *  Height for this category (pixels)
	 * @property {Number} y
	 *  Y position of this cateogry with respect to the Figure (pixels)
	 * @property {Array.<CategoryBandViewModel>} bands
	 *  Array of color bands inside the category
	 * @property {ParcatsViewModel} parcatsViewModel
	 *  The parent trace's view model
	 */
	
	/**
	 * @typedef {Object} CategoryBandViewModel
	 *  Object containing calculated category band information. A category band is a region inside a category covering
	 *  paths of a single color
	 *
	 * @property key
	 *  Unique key for this model
	 * @property color
	 *  Band color
	 * @property rawColor
	 *  Raw color value for band
	 * @property {Number} width
	 *  Band width
	 * @property {Number} height
	 *  Band height
	 * @property {Number} y
	 *  Y position of top of the band with respect to the category
	 * @property {Number} count
	 *  The number of samples represented by the band
	 * @property {CategoryViewModel} categoryViewModel
	 *  The parent categorie's view model
	 * @property {ParcatsViewModel} parcatsViewModel
	 *  The parent trace's view model
	 */
	
	/**
	 * @typedef {Object} PathViewModel
	 *  Object containing calculated parcats path view information
	 *
	 *  These are quantities that require Layout information to calculate
	 * @property key
	 *  Unique key for this model
	 * @property {PathModel} model
	 *  Source path model
	 * @property {Number} height
	 *  Height of this path (pixels)
	 * @property {Array.<Number>} leftXs
	 *  The x position of the left edge of each display dimension
	 * @property {Array.<Number>} topYs
	 *  The y position of the top of the path for each display dimension
	 * @property {Array.<Number>} dimWidths
	 *  The width of each display dimension
	 * @property {String} svgD
	 *  SVG path "d" attribute string
	 * @property {ParcatsViewModel} parcatsViewModel
	 *  The parent trace's view model
	 */
	
	},{"../../components/drawing":612,"../../components/fx":629,"../../lib":716,"../../lib/svg_text_utils":740,"../../plot_api/plot_api":751,"d3":164,"tinycolor2":535}],1079:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	var parcats = _dereq_('./parcats');
	
	/**
	 * Create / update parcat traces
	 *
	 * @param {Object} graphDiv
	 * @param {Array.<ParcatsModel>} parcatsModels
	 */
	module.exports = function plot(graphDiv, parcatsModels, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = graphDiv._fullLayout;
	    var svg = fullLayout._paper;
	    var size = fullLayout._size;
	
	    parcats(
	        graphDiv,
	        svg,
	        parcatsModels,
	        {
	            width: size.w,
	            height: size.h,
	            margin: {
	                t: size.t,
	                r: size.r,
	                b: size.b,
	                l: size.l
	            }
	        },
	        transitionOpts,
	        makeOnCompleteCallback
	    );
	};
	
	},{"./parcats":1078}],1080:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	module.exports = {
	    domain: domainAttrs({name: 'parcoords', trace: true, editType: 'plot'}),
	
	    labelangle: {
	        valType: 'angle',
	        dflt: 0,
	        
	        editType: 'plot',
	        
	    },
	
	    labelside: {
	        valType: 'enumerated',
	        
	        values: ['top', 'bottom'],
	        dflt: 'top',
	        editType: 'plot',
	        
	    },
	
	    labelfont: fontAttrs({
	        editType: 'plot',
	        
	    }),
	    tickfont: fontAttrs({
	        editType: 'plot',
	        
	    }),
	    rangefont: fontAttrs({
	        editType: 'plot',
	        
	    }),
	
	    dimensions: templatedArray('dimension', {
	        label: {
	            valType: 'string',
	            
	            editType: 'plot',
	            
	        },
	        // TODO: better way to determine ordinal vs continuous axes,
	        // so users can use tickvals/ticktext with a continuous axis.
	        tickvals: extendFlat({}, axesAttrs.tickvals, {
	            editType: 'plot',
	            
	        }),
	        ticktext: extendFlat({}, axesAttrs.ticktext, {
	            editType: 'plot',
	            
	        }),
	        tickformat: extendFlat({}, axesAttrs.tickformat, {
	            editType: 'plot'
	        }),
	        visible: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        range: {
	            valType: 'info_array',
	            
	            items: [
	                {valType: 'number', editType: 'plot'},
	                {valType: 'number', editType: 'plot'}
	            ],
	            editType: 'plot',
	            
	        },
	        constraintrange: {
	            valType: 'info_array',
	            
	            freeLength: true,
	            dimensions: '1-2',
	            items: [
	                {valType: 'number', editType: 'plot'},
	                {valType: 'number', editType: 'plot'}
	            ],
	            editType: 'plot',
	            
	        },
	        multiselect: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        values: {
	            valType: 'data_array',
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc',
	        
	    }),
	
	    line: extendFlat({editType: 'calc'},
	        colorScaleAttrs('line', {
	            // the default autocolorscale isn't quite usable for parcoords due to context ambiguity around 0 (grey, off-white)
	            // autocolorscale therefore defaults to false too, to avoid being overridden by the blue-white-red autocolor palette
	            colorscaleDflt: 'Viridis',
	            autoColorDflt: false,
	            editTypeOverride: 'calc'
	        })
	    )
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/plot_template":754,"../../plots/cartesian/layout_attributes":776,"../../plots/domain":789,"../../plots/font_attributes":790}],1081:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var c = _dereq_('./constants');
	var d3 = _dereq_('d3');
	var keyFun = _dereq_('../../lib/gup').keyFun;
	var repeat = _dereq_('../../lib/gup').repeat;
	var sortAsc = _dereq_('../../lib').sorterAsc;
	
	var snapRatio = c.bar.snapRatio;
	function snapOvershoot(v, vAdjacent) { return v * (1 - snapRatio) + vAdjacent * snapRatio; }
	
	var snapClose = c.bar.snapClose;
	function closeToCovering(v, vAdjacent) { return v * (1 - snapClose) + vAdjacent * snapClose; }
	
	// snap for the low end of a range on an ordinal scale
	// on an ordinal scale, always show some overshoot from the exact value,
	// so it's clear we're covering it
	// find the interval we're in, and snap to 1/4 the distance to the next
	// these two could be unified at a slight loss of readability / perf
	function ordinalScaleSnap(isHigh, a, v, existingRanges) {
	    if(overlappingExisting(v, existingRanges)) return v;
	
	    var dir = isHigh ? -1 : 1;
	
	    var first = 0;
	    var last = a.length - 1;
	    if(dir < 0) {
	        var tmp = first;
	        first = last;
	        last = tmp;
	    }
	
	    var aHere = a[first];
	    var aPrev = aHere;
	    for(var i = first; dir * i < dir * last; i += dir) {
	        var nextI = i + dir;
	        var aNext = a[nextI];
	
	        // very close to the previous - snap down to it
	        if(dir * v < dir * closeToCovering(aHere, aNext)) return snapOvershoot(aHere, aPrev);
	        if(dir * v < dir * aNext || nextI === last) return snapOvershoot(aNext, aHere);
	
	        aPrev = aHere;
	        aHere = aNext;
	    }
	}
	
	function overlappingExisting(v, existingRanges) {
	    for(var i = 0; i < existingRanges.length; i++) {
	        if(v >= existingRanges[i][0] && v <= existingRanges[i][1]) return true;
	    }
	    return false;
	}
	
	function barHorizontalSetup(selection) {
	    selection
	        .attr('x', -c.bar.captureWidth / 2)
	        .attr('width', c.bar.captureWidth);
	}
	
	function backgroundBarHorizontalSetup(selection) {
	    selection
	        .attr('visibility', 'visible')
	        .style('visibility', 'visible')
	        .attr('fill', 'yellow')
	        .attr('opacity', 0);
	}
	
	function setHighlight(d) {
	    if(!d.brush.filterSpecified) {
	        return '0,' + d.height;
	    }
	
	    var pixelRanges = unitToPx(d.brush.filter.getConsolidated(), d.height);
	    var dashArray = [0]; // we start with a 0 length selection as filter ranges are inclusive, not exclusive
	    var p, sectionHeight, iNext;
	    var currentGap = pixelRanges.length ? pixelRanges[0][0] : null;
	    for(var i = 0; i < pixelRanges.length; i++) {
	        p = pixelRanges[i];
	        sectionHeight = p[1] - p[0];
	        dashArray.push(currentGap);
	        dashArray.push(sectionHeight);
	        iNext = i + 1;
	        if(iNext < pixelRanges.length) {
	            currentGap = pixelRanges[iNext][0] - p[1];
	        }
	    }
	    dashArray.push(d.height);
	    // d.height is added at the end to ensure that (1) we have an even number of dasharray points, MDN page says
	    // "If an odd number of values is provided, then the list of values is repeated to yield an even number of values."
	    // and (2) it's _at least_ as long as the full height (even if range is minuscule and at the bottom) though this
	    // may not be necessary, maybe duplicating the last point would do too. But no harm in a longer dasharray than line.
	    return dashArray;
	}
	
	function unitToPx(unitRanges, height) {
	    return unitRanges.map(function(pr) {
	        return pr.map(function(v) { return Math.max(0, v * height); }).sort(sortAsc);
	    });
	}
	
	// is the cursor over the north, middle, or south of a bar?
	// the end handles extend over the last 10% of the bar
	function getRegion(fPix, y) {
	    var pad = c.bar.handleHeight;
	    if(y > fPix[1] + pad || y < fPix[0] - pad) return;
	    if(y >= 0.9 * fPix[1] + 0.1 * fPix[0]) return 'n';
	    if(y <= 0.9 * fPix[0] + 0.1 * fPix[1]) return 's';
	    return 'ns';
	}
	
	function clearCursor() {
	    d3.select(document.body)
	        .style('cursor', null);
	}
	
	function styleHighlight(selection) {
	    // stroke-dasharray is used to minimize the number of created DOM nodes, because the requirement calls for up to
	    // 1000 individual selections on an axis, and there can be 60 axes per parcoords, and multiple parcoords per
	    // dashboard. The technique is similar to https://codepen.io/monfera/pen/rLYqWR and using a `polyline` with
	    // multiple sections, or a `path` element via its `d` attribute would also be DOM-sparing alternatives.
	    selection.attr('stroke-dasharray', setHighlight);
	}
	
	function renderHighlight(root, tweenCallback) {
	    var bar = d3.select(root).selectAll('.highlight, .highlight-shadow');
	    var barToStyle = tweenCallback ? bar.transition().duration(c.bar.snapDuration).each('end', tweenCallback) : bar;
	    styleHighlight(barToStyle);
	}
	
	function getInterval(d, y) {
	    var b = d.brush;
	    var active = b.filterSpecified;
	    var closestInterval = NaN;
	    var out = {};
	    var i;
	
	    if(active) {
	        var height = d.height;
	        var intervals = b.filter.getConsolidated();
	        var pixIntervals = unitToPx(intervals, height);
	        var hoveredInterval = NaN;
	        var previousInterval = NaN;
	        var nextInterval = NaN;
	        for(i = 0; i <= pixIntervals.length; i++) {
	            var p = pixIntervals[i];
	            if(p && p[0] <= y && y <= p[1]) {
	                // over a bar
	                hoveredInterval = i;
	                break;
	            } else {
	                // between bars, or before/after the first/last bar
	                previousInterval = i ? i - 1 : NaN;
	                if(p && p[0] > y) {
	                    nextInterval = i;
	                    break; // no point continuing as intervals are non-overlapping and sorted; could use log search
	                }
	            }
	        }
	
	        closestInterval = hoveredInterval;
	        if(isNaN(closestInterval)) {
	            if(isNaN(previousInterval) || isNaN(nextInterval)) {
	                closestInterval = isNaN(previousInterval) ? nextInterval : previousInterval;
	            } else {
	                closestInterval = (y - pixIntervals[previousInterval][1] < pixIntervals[nextInterval][0] - y) ?
	                    previousInterval : nextInterval;
	            }
	        }
	
	        if(!isNaN(closestInterval)) {
	            var fPix = pixIntervals[closestInterval];
	            var region = getRegion(fPix, y);
	
	            if(region) {
	                out.interval = intervals[closestInterval];
	                out.intervalPix = fPix;
	                out.region = region;
	            }
	        }
	    }
	
	    if(d.ordinal && !out.region) {
	        var a = d.unitTickvals;
	        var unitLocation = d.unitToPaddedPx.invert(y);
	        for(i = 0; i < a.length; i++) {
	            var rangei = [
	                a[Math.max(i - 1, 0)] * 0.25 + a[i] * 0.75,
	                a[Math.min(i + 1, a.length - 1)] * 0.25 + a[i] * 0.75
	            ];
	            if(unitLocation >= rangei[0] && unitLocation <= rangei[1]) {
	                out.clickableOrdinalRange = rangei;
	                break;
	            }
	        }
	    }
	
	    return out;
	}
	
	function dragstart(lThis, d) {
	    d3.event.sourceEvent.stopPropagation();
	    var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	    var unitLocation = d.unitToPaddedPx.invert(y);
	    var b = d.brush;
	    var interval = getInterval(d, y);
	    var unitRange = interval.interval;
	    var s = b.svgBrush;
	    s.wasDragged = false; // we start assuming there won't be a drag - useful for reset
	    s.grabbingBar = interval.region === 'ns';
	    if(s.grabbingBar) {
	        var pixelRange = unitRange.map(d.unitToPaddedPx);
	        s.grabPoint = y - pixelRange[0] - c.verticalPadding;
	        s.barLength = pixelRange[1] - pixelRange[0];
	    }
	    s.clickableOrdinalRange = interval.clickableOrdinalRange;
	    s.stayingIntervals = (d.multiselect && b.filterSpecified) ? b.filter.getConsolidated() : [];
	    if(unitRange) {
	        s.stayingIntervals = s.stayingIntervals.filter(function(int2) {
	            return int2[0] !== unitRange[0] && int2[1] !== unitRange[1];
	        });
	    }
	    s.startExtent = interval.region ? unitRange[interval.region === 's' ? 1 : 0] : unitLocation;
	    d.parent.inBrushDrag = true;
	    s.brushStartCallback();
	}
	
	function drag(lThis, d) {
	    d3.event.sourceEvent.stopPropagation();
	    var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	    var s = d.brush.svgBrush;
	    s.wasDragged = true;
	    s._dragging = true;
	
	    if(s.grabbingBar) { // moving the bar
	        s.newExtent = [y - s.grabPoint, y + s.barLength - s.grabPoint].map(d.unitToPaddedPx.invert);
	    } else { // south/north drag or new bar creation
	        s.newExtent = [s.startExtent, d.unitToPaddedPx.invert(y)].sort(sortAsc);
	    }
	
	    d.brush.filterSpecified = true;
	    s.extent = s.stayingIntervals.concat([s.newExtent]);
	    s.brushCallback(d);
	    renderHighlight(lThis.parentNode);
	}
	
	function dragend(lThis, d) {
	    var brush = d.brush;
	    var filter = brush.filter;
	    var s = brush.svgBrush;
	
	    if(!s._dragging) { // i.e. click
	        // mock zero drag
	        mousemove(lThis, d);
	        drag(lThis, d);
	        // remember it is a click not a drag
	        d.brush.svgBrush.wasDragged = false;
	    }
	    s._dragging = false;
	
	    var e = d3.event;
	    e.sourceEvent.stopPropagation();
	    var grabbingBar = s.grabbingBar;
	    s.grabbingBar = false;
	    s.grabLocation = undefined;
	    d.parent.inBrushDrag = false;
	    clearCursor(); // instead of clearing, a nicer thing would be to set it according to current location
	    if(!s.wasDragged) { // a click+release on the same spot (ie. w/o dragging) means a bar or full reset
	        s.wasDragged = undefined; // logic-wise unneeded, just shows `wasDragged` has no longer a meaning
	        if(s.clickableOrdinalRange) {
	            if(brush.filterSpecified && d.multiselect) {
	                s.extent.push(s.clickableOrdinalRange);
	            } else {
	                s.extent = [s.clickableOrdinalRange];
	                brush.filterSpecified = true;
	            }
	        } else if(grabbingBar) {
	            s.extent = s.stayingIntervals;
	            if(s.extent.length === 0) {
	                brushClear(brush);
	            }
	        } else {
	            brushClear(brush);
	        }
	        s.brushCallback(d);
	        renderHighlight(lThis.parentNode);
	        s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
	        return; // no need to fuse intervals or snap to ordinals, so we can bail early
	    }
	
	    var mergeIntervals = function() {
	        // Key piece of logic: once the button is released, possibly overlapping intervals will be fused:
	        // Here it's done immediately on click release while on ordinal snap transition it's done at the end
	        filter.set(filter.getConsolidated());
	    };
	
	    if(d.ordinal) {
	        var a = d.unitTickvals;
	        if(a[a.length - 1] < a[0]) a.reverse();
	        s.newExtent = [
	            ordinalScaleSnap(0, a, s.newExtent[0], s.stayingIntervals),
	            ordinalScaleSnap(1, a, s.newExtent[1], s.stayingIntervals)
	        ];
	        var hasNewExtent = s.newExtent[1] > s.newExtent[0];
	        s.extent = s.stayingIntervals.concat(hasNewExtent ? [s.newExtent] : []);
	        if(!s.extent.length) {
	            brushClear(brush);
	        }
	        s.brushCallback(d);
	        if(hasNewExtent) {
	            // merging intervals post the snap tween
	            renderHighlight(lThis.parentNode, mergeIntervals);
	        } else {
	            // if no new interval, don't animate, just redraw the highlight immediately
	            mergeIntervals();
	            renderHighlight(lThis.parentNode);
	        }
	    } else {
	        mergeIntervals(); // merging intervals immediately
	    }
	    s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
	}
	
	function mousemove(lThis, d) {
	    var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	    var interval = getInterval(d, y);
	
	    var cursor = 'crosshair';
	    if(interval.clickableOrdinalRange) cursor = 'pointer';
	    else if(interval.region) cursor = interval.region + '-resize';
	    d3.select(document.body)
	        .style('cursor', cursor);
	}
	
	function attachDragBehavior(selection) {
	    // There's some fiddling with pointer cursor styling so that the cursor preserves its shape while dragging a brush
	    // even if the cursor strays from the interacting bar, which is bound to happen as bars are thin and the user
	    // will inevitably leave the hotspot strip. In this regard, it does something similar to what the D3 brush would do.
	    selection
	        .on('mousemove', function(d) {
	            d3.event.preventDefault();
	            if(!d.parent.inBrushDrag) mousemove(this, d);
	        })
	        .on('mouseleave', function(d) {
	            if(!d.parent.inBrushDrag) clearCursor();
	        })
	        .call(d3.behavior.drag()
	            .on('dragstart', function(d) { dragstart(this, d); })
	            .on('drag', function(d) { drag(this, d); })
	            .on('dragend', function(d) { dragend(this, d); })
	        );
	}
	
	function startAsc(a, b) { return a[0] - b[0]; }
	
	function renderAxisBrush(axisBrush) {
	    var background = axisBrush.selectAll('.background').data(repeat);
	
	    background.enter()
	        .append('rect')
	        .classed('background', true)
	        .call(barHorizontalSetup)
	        .call(backgroundBarHorizontalSetup)
	        .style('pointer-events', 'auto') // parent pointer events are disabled; we must have it to register events
	        .attr('transform', 'translate(0 ' + c.verticalPadding + ')');
	
	    background
	        .call(attachDragBehavior)
	        .attr('height', function(d) {
	            return d.height - c.verticalPadding;
	        });
	
	    var highlightShadow = axisBrush.selectAll('.highlight-shadow').data(repeat); // we have a set here, can't call it `extent`
	
	    highlightShadow.enter()
	        .append('line')
	        .classed('highlight-shadow', true)
	        .attr('x', -c.bar.width / 2)
	        .attr('stroke-width', c.bar.width + c.bar.strokeWidth)
	        .attr('stroke', c.bar.strokeColor)
	        .attr('opacity', c.bar.strokeOpacity)
	        .attr('stroke-linecap', 'butt');
	
	    highlightShadow
	        .attr('y1', function(d) { return d.height; })
	        .call(styleHighlight);
	
	    var highlight = axisBrush.selectAll('.highlight').data(repeat); // we have a set here, can't call it `extent`
	
	    highlight.enter()
	        .append('line')
	        .classed('highlight', true)
	        .attr('x', -c.bar.width / 2)
	        .attr('stroke-width', c.bar.width - c.bar.strokeWidth)
	        .attr('stroke', c.bar.fillColor)
	        .attr('opacity', c.bar.fillOpacity)
	        .attr('stroke-linecap', 'butt');
	
	    highlight
	        .attr('y1', function(d) { return d.height; })
	        .call(styleHighlight);
	}
	
	function ensureAxisBrush(axisOverlays) {
	    var axisBrush = axisOverlays.selectAll('.' + c.cn.axisBrush)
	        .data(repeat, keyFun);
	
	    axisBrush.enter()
	        .append('g')
	        .classed(c.cn.axisBrush, true);
	
	    renderAxisBrush(axisBrush);
	}
	
	function getBrushExtent(brush) {
	    return brush.svgBrush.extent.map(function(e) {return e.slice();});
	}
	
	function brushClear(brush) {
	    brush.filterSpecified = false;
	    brush.svgBrush.extent = [[-Infinity, Infinity]];
	}
	
	function axisBrushMoved(callback) {
	    return function axisBrushMoved(dimension) {
	        var brush = dimension.brush;
	        var extent = getBrushExtent(brush);
	        var newExtent = extent.slice();
	        brush.filter.set(newExtent);
	        callback();
	    };
	}
	
	function dedupeRealRanges(intervals) {
	    // Fuses elements of intervals if they overlap, yielding discontiguous intervals, results.length <= intervals.length
	    // Currently uses closed intervals, ie. dedupeRealRanges([[400, 800], [300, 400]]) -> [300, 800]
	    var queue = intervals.slice();
	    var result = [];
	    var currentInterval;
	    var current = queue.shift();
	    while(current) { // [].shift === undefined, so we don't descend into an empty array
	        currentInterval = current.slice();
	        while((current = queue.shift()) && current[0] <= /* right-open interval would need `<` */ currentInterval[1]) {
	            currentInterval[1] = Math.max(currentInterval[1], current[1]);
	        }
	        result.push(currentInterval);
	    }
	    return result;
	}
	
	function makeFilter() {
	    var filter = [];
	    var consolidated;
	    var bounds;
	    return {
	        set: function(a) {
	            filter = a
	                .map(function(d) { return d.slice().sort(sortAsc); })
	                .sort(startAsc);
	
	            // handle unselected case
	            if(filter.length === 1 &&
	                filter[0][0] === -Infinity &&
	                filter[0][1] === Infinity) {
	                filter = [[0, -1]];
	            }
	
	            consolidated = dedupeRealRanges(filter);
	            bounds = filter.reduce(function(p, n) {
	                return [Math.min(p[0], n[0]), Math.max(p[1], n[1])];
	            }, [Infinity, -Infinity]);
	        },
	        get: function() { return filter.slice(); },
	        getConsolidated: function() { return consolidated; },
	        getBounds: function() { return bounds; }
	    };
	}
	
	function makeBrush(state, rangeSpecified, initialRange, brushStartCallback, brushCallback, brushEndCallback) {
	    var filter = makeFilter();
	    filter.set(initialRange);
	    return {
	        filter: filter,
	        filterSpecified: rangeSpecified, // there's a difference between not filtering and filtering a non-proper subset
	        svgBrush: {
	            extent: [], // this is where the svgBrush writes contents into
	            brushStartCallback: brushStartCallback,
	            brushCallback: axisBrushMoved(brushCallback),
	            brushEndCallback: brushEndCallback
	        }
	    };
	}
	
	// for use by supplyDefaults, but it needed tons of pieces from here so
	// seemed to make more sense just to put the whole routine here
	function cleanRanges(ranges, dimension) {
	    if(Array.isArray(ranges[0])) {
	        ranges = ranges.map(function(ri) { return ri.sort(sortAsc); });
	
	        if(!dimension.multiselect) ranges = [ranges[0]];
	        else ranges = dedupeRealRanges(ranges.sort(startAsc));
	    } else ranges = [ranges.sort(sortAsc)];
	
	    // ordinal snapping
	    if(dimension.tickvals) {
	        var sortedTickVals = dimension.tickvals.slice().sort(sortAsc);
	        ranges = ranges.map(function(ri) {
	            var rSnapped = [
	                ordinalScaleSnap(0, sortedTickVals, ri[0], []),
	                ordinalScaleSnap(1, sortedTickVals, ri[1], [])
	            ];
	            if(rSnapped[1] > rSnapped[0]) return rSnapped;
	        })
	        .filter(function(ri) { return ri; });
	
	        if(!ranges.length) return;
	    }
	    return ranges.length > 1 ? ranges : ranges[0];
	}
	
	module.exports = {
	    makeBrush: makeBrush,
	    ensureAxisBrush: ensureAxisBrush,
	    cleanRanges: cleanRanges
	};
	
	},{"../../lib":716,"../../lib/gup":714,"./constants":1084,"d3":164}],1082:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
	var parcoordsPlot = _dereq_('./plot');
	var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
	
	exports.name = 'parcoords';
	
	exports.plot = function(gd) {
	    var calcData = getModuleCalcData(gd.calcdata, 'parcoords')[0];
	    if(calcData.length) parcoordsPlot(gd, calcData);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var hadParcoords = (oldFullLayout._has && oldFullLayout._has('parcoords'));
	    var hasParcoords = (newFullLayout._has && newFullLayout._has('parcoords'));
	
	    if(hadParcoords && !hasParcoords) {
	        oldFullLayout._paperdiv.selectAll('.parcoords').remove();
	        oldFullLayout._glimages.selectAll('*').remove();
	    }
	};
	
	exports.toSVG = function(gd) {
	    var imageRoot = gd._fullLayout._glimages;
	    var root = d3.select(gd).selectAll('.svg-container');
	    var canvases = root.filter(function(d, i) {return i === root.size() - 1;})
	        .selectAll('.gl-canvas-context, .gl-canvas-focus');
	
	    function canvasToImage() {
	        var canvas = this;
	        var imageData = canvas.toDataURL('image/png');
	        var image = imageRoot.append('svg:image');
	
	        image.attr({
	            xmlns: xmlnsNamespaces.svg,
	            'xlink:href': imageData,
	            preserveAspectRatio: 'none',
	            x: 0,
	            y: 0,
	            width: canvas.width,
	            height: canvas.height
	        });
	    }
	
	    canvases.each(canvasToImage);
	
	    // Chrome / Safari bug workaround - browser apparently loses connection to the defined pattern
	    // Without the workaround, these browsers 'lose' the filter brush styling (color etc.) after a snapshot
	    // on a subsequent interaction.
	    // Firefox works fine without this workaround
	    window.setTimeout(function() {
	        d3.selectAll('#filterBarPattern')
	            .attr('id', 'filterBarPattern');
	    }, 60);
	};
	
	},{"../../constants/xmlns_namespaces":693,"../../plots/get_data":799,"./plot":1091,"d3":164}],1083:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var Colorscale = _dereq_('../../components/colorscale');
	var wrap = _dereq_('../../lib/gup').wrap;
	
	module.exports = function calc(gd, trace) {
	    var lineColor;
	    var cscale;
	
	    if(Colorscale.hasColorscale(trace, 'line') && isArrayOrTypedArray(trace.line.color)) {
	        lineColor = trace.line.color;
	        cscale = Colorscale.extractOpts(trace.line).colorscale;
	
	        Colorscale.calc(gd, trace, {
	            vals: lineColor,
	            containerStr: 'line',
	            cLetter: 'c'
	        });
	    } else {
	        lineColor = constHalf(trace._length);
	        cscale = [[0, trace.line.color], [1, trace.line.color]];
	    }
	
	    return wrap({lineColor: lineColor, cscale: cscale});
	};
	
	function constHalf(len) {
	    var out = new Array(len);
	    for(var i = 0; i < len; i++) {
	        out[i] = 0.5;
	    }
	    return out;
	}
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gup":714}],1084:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	
	module.exports = {
	    maxDimensionCount: 60, // this cannot be increased without WebGL code refactoring
	    overdrag: 45,
	    verticalPadding: 2, // otherwise, horizontal lines on top or bottom are of lower width
	    tickDistance: 50,
	    canvasPixelRatio: 1,
	    blockLineCount: 5000,
	    layers: ['contextLineLayer', 'focusLineLayer', 'pickLineLayer'],
	    axisTitleOffset: 28,
	    axisExtentOffset: 10,
	    deselectedLineColor: '#777',
	    bar: {
	        width: 4, // Visible width of the filter bar
	        captureWidth: 10, // Mouse-sensitive width for interaction (Fitts law)
	        fillColor: 'magenta', // Color of the filter bar fill
	        fillOpacity: 1, // Filter bar fill opacity
	        snapDuration: 150, // tween duration in ms for brush snap for ordinal axes
	        snapRatio: 0.25, // ratio of bar extension relative to the distance between two adjacent ordinal values
	        snapClose: 0.01, // fraction of inter-value distance to snap to the closer one, even if you're not over it
	        strokeColor: 'white', // Color of the filter bar side lines
	        strokeOpacity: 1, // Filter bar side stroke opacity
	        strokeWidth: 1, // Filter bar side stroke width in pixels
	        handleHeight: 8, // Height of the filter bar vertical resize areas on top and bottom
	        handleOpacity: 1, // Opacity of the filter bar vertical resize areas on top and bottom
	        handleOverlap: 0 // A larger than 0 value causes overlaps with the filter bar, represented as pixels
	    },
	    cn: {
	        axisExtentText: 'axis-extent-text',
	        parcoordsLineLayers: 'parcoords-line-layers',
	        parcoordsLineLayer: 'parcoords-lines',
	        parcoords: 'parcoords',
	        parcoordsControlView: 'parcoords-control-view',
	        yAxis: 'y-axis',
	        axisOverlays: 'axis-overlays',
	        axis: 'axis',
	        axisHeading: 'axis-heading',
	        axisTitle: 'axis-title',
	        axisExtent: 'axis-extent',
	        axisExtentTop: 'axis-extent-top',
	        axisExtentTopText: 'axis-extent-top-text',
	        axisExtentBottom: 'axis-extent-bottom',
	        axisExtentBottomText: 'axis-extent-bottom-text',
	        axisBrush: 'axis-brush'
	    },
	    id: {
	        filterBarPattern: 'filter-bar-pattern'
	
	    }
	};
	
	},{}],1085:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var attributes = _dereq_('./attributes');
	var axisBrush = _dereq_('./axisbrush');
	var maxDimensionCount = _dereq_('./constants').maxDimensionCount;
	var mergeLength = _dereq_('./merge_length');
	
	function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	    var lineColor = coerce('line.color', defaultColor);
	
	    if(hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
	        if(lineColor.length) {
	            coerce('line.colorscale');
	            colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
	            // TODO: I think it would be better to keep showing lines beyond the last line color
	            // but I'm not sure what color to give these lines - probably black or white
	            // depending on the background color?
	            return lineColor.length;
	        } else {
	            traceOut.line.color = defaultColor;
	        }
	    }
	    return Infinity;
	}
	
	function dimensionDefaults(dimensionIn, dimensionOut, parentOut, opts) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
	    }
	
	    var values = coerce('values');
	    var visible = coerce('visible');
	    if(!(values && values.length)) {
	        visible = dimensionOut.visible = false;
	    }
	
	    if(visible) {
	        coerce('label');
	        coerce('tickvals');
	        coerce('ticktext');
	        coerce('tickformat');
	        var range = coerce('range');
	
	        dimensionOut._ax = {
	            _id: 'y',
	            type: 'linear',
	            showexponent: 'all',
	            exponentformat: 'B',
	            range: range
	        };
	
	        Axes.setConvert(dimensionOut._ax, opts.layout);
	
	        coerce('multiselect');
	        var constraintRange = coerce('constraintrange');
	        if(constraintRange) {
	            dimensionOut.constraintrange = axisBrush.cleanRanges(constraintRange, dimensionOut);
	        }
	    }
	}
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var dimensionsIn = traceIn.dimensions;
	    if(Array.isArray(dimensionsIn) && dimensionsIn.length > maxDimensionCount) {
	        Lib.log('parcoords traces support up to ' + maxDimensionCount + ' dimensions at the moment');
	        dimensionsIn.splice(maxDimensionCount);
	    }
	
	    var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	        name: 'dimensions',
	        layout: layout,
	        handleItemDefaults: dimensionDefaults
	    });
	
	    var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    if(!Array.isArray(dimensions) || !dimensions.length) {
	        traceOut.visible = false;
	    }
	
	    mergeLength(traceOut, dimensions, 'values', len);
	
	    // make default font size 10px (default is 12),
	    // scale linearly with global font size
	    var fontDflt = {
	        family: layout.font.family,
	        size: Math.round(layout.font.size / 1.2),
	        color: layout.font.color
	    };
	
	    Lib.coerceFont(coerce, 'labelfont', fontDflt);
	    Lib.coerceFont(coerce, 'tickfont', fontDflt);
	    Lib.coerceFont(coerce, 'rangefont', fontDflt);
	
	    coerce('labelangle');
	    coerce('labelside');
	};
	
	},{"../../components/colorscale/defaults":601,"../../components/colorscale/helpers":602,"../../lib":716,"../../plots/array_container_defaults":760,"../../plots/cartesian/axes":764,"../../plots/domain":789,"./attributes":1080,"./axisbrush":1081,"./constants":1084,"./merge_length":1089}],1086:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isTypedArray = _dereq_('../../lib').isTypedArray;
	
	exports.convertTypedArray = function(a) {
	    return isTypedArray(a) ? Array.prototype.slice.call(a) : a;
	};
	
	exports.isOrdinal = function(dimension) {
	    return !!dimension.tickvals;
	};
	
	exports.isVisible = function(dimension) {
	    return dimension.visible || !('visible' in dimension);
	};
	
	},{"../../lib":716}],1087:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    colorbar: {
	        container: 'line',
	        min: 'cmin',
	        max: 'cmax'
	    },
	
	    moduleType: 'trace',
	    name: 'parcoords',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['gl', 'regl', 'noOpacity', 'noHover'],
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1080,"./base_plot":1082,"./calc":1083,"./defaults":1085,"./plot":1091}],1088:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var glslify = _dereq_('glslify');
	var vertexShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nattribute vec4 p01_04, p05_08, p09_12, p13_16,\n               p17_20, p21_24, p25_28, p29_32,\n               p33_36, p37_40, p41_44, p45_48,\n               p49_52, p53_56, p57_60, colors;\n\nuniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,\n             loA, hiA, loB, hiB, loC, hiC, loD, hiD;\n\nuniform vec2 resolution, viewBoxPos, viewBoxSize;\nuniform sampler2D mask, palette;\nuniform float maskHeight;\nuniform float drwLayer; // 0: context, 1: focus, 2: pick\nuniform vec4 contextColor;\n\nbool isPick    = (drwLayer > 1.5);\nbool isContext = (drwLayer < 0.5);\n\nconst vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);\nconst vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);\n\nfloat val(mat4 p, mat4 v) {\n    return dot(matrixCompMult(p, v) * UNITS, UNITS);\n}\n\nfloat axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);\n    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);\n    return y1 * (1.0 - ratio) + y2 * ratio;\n}\n\nint iMod(int a, int b) {\n    return a - b * (a / b);\n}\n\nbool fOutside(float p, float lo, float hi) {\n    return (lo < hi) && (lo > p || p > hi);\n}\n\nbool vOutside(vec4 p, vec4 lo, vec4 hi) {\n    return (\n        fOutside(p[0], lo[0], hi[0]) ||\n        fOutside(p[1], lo[1], hi[1]) ||\n        fOutside(p[2], lo[2], hi[2]) ||\n        fOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool mOutside(mat4 p, mat4 lo, mat4 hi) {\n    return (\n        vOutside(p[0], lo[0], hi[0]) ||\n        vOutside(p[1], lo[1], hi[1]) ||\n        vOutside(p[2], lo[2], hi[2]) ||\n        vOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {\n    return mOutside(A, loA, hiA) ||\n           mOutside(B, loB, hiB) ||\n           mOutside(C, loC, hiC) ||\n           mOutside(D, loD, hiD);\n}\n\nbool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {\n    mat4 pnts[4];\n    pnts[0] = A;\n    pnts[1] = B;\n    pnts[2] = C;\n    pnts[3] = D;\n\n    for(int i = 0; i < 4; ++i) {\n        for(int j = 0; j < 4; ++j) {\n            for(int k = 0; k < 4; ++k) {\n                if(0 == iMod(\n                    int(255.0 * texture2D(mask,\n                        vec2(\n                            (float(i * 2 + j / 2) + 0.5) / 8.0,\n                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight\n                        ))[3]\n                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),\n                    2\n                )) return true;\n            }\n        }\n    }\n    return false;\n}\n\nvec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float x = 0.5 * sign(v) + 0.5;\n    float y = axisY(x, A, B, C, D);\n    float z = 1.0 - abs(v);\n\n    z += isContext ? 0.0 : 2.0 * float(\n        outsideBoundingBox(A, B, C, D) ||\n        outsideRasterMask(A, B, C, D)\n    );\n\n    return vec4(\n        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,\n        z,\n        1.0\n    );\n}\n\nvoid main() {\n    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);\n    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);\n    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);\n    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);\n\n    float v = colors[3];\n\n    gl_Position = position(isContext, v, A, B, C, D);\n\n    fragColor =\n        isContext ? vec4(contextColor) :\n        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));\n}\n"]);
	var fragmentShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n    gl_FragColor = fragColor;\n}\n"]);
	var maxDim = _dereq_('./constants').maxDimensionCount;
	
	var Lib = _dereq_('../../lib');
	
	// don't change; otherwise near/far plane lines are lost
	var depthLimitEpsilon = 1e-6;
	
	// precision of multiselect is the full range divided into this many parts
	var maskHeight = 2048;
	
	var dummyPixel = new Uint8Array(4);
	var dataPixel = new Uint8Array(4);
	
	var paletteTextureConfig = {
	    shape: [256, 1],
	    format: 'rgba',
	    type: 'uint8',
	    mag: 'nearest',
	    min: 'nearest'
	};
	
	function ensureDraw(regl) {
	    regl.read({
	        x: 0,
	        y: 0,
	        width: 1,
	        height: 1,
	        data: dummyPixel
	    });
	}
	
	function clear(regl, x, y, width, height) {
	    var gl = regl._gl;
	    gl.enable(gl.SCISSOR_TEST);
	    gl.scissor(x, y, width, height);
	    regl.clear({color: [0, 0, 0, 0], depth: 1}); // clearing is done in scissored panel only
	}
	
	function renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item) {
	    var rafKey = item.key;
	
	    function render(blockNumber) {
	        var count = Math.min(blockLineCount, sampleCount - blockNumber * blockLineCount);
	
	        if(blockNumber === 0) {
	            // stop drawing possibly stale glyphs before clearing
	            window.cancelAnimationFrame(renderState.currentRafs[rafKey]);
	            delete renderState.currentRafs[rafKey];
	            clear(regl, item.scissorX, item.scissorY, item.scissorWidth, item.viewBoxSize[1]);
	        }
	
	        if(renderState.clearOnly) {
	            return;
	        }
	
	        item.count = 2 * count;
	        item.offset = 2 * blockNumber * blockLineCount;
	        glAes(item);
	
	        if(blockNumber * blockLineCount + count < sampleCount) {
	            renderState.currentRafs[rafKey] = window.requestAnimationFrame(function() {
	                render(blockNumber + 1);
	            });
	        }
	
	        renderState.drawCompleted = false;
	    }
	
	    if(!renderState.drawCompleted) {
	        ensureDraw(regl);
	        renderState.drawCompleted = true;
	    }
	
	    // start with rendering item 0; recursion handles the rest
	    render(0);
	}
	
	function adjustDepth(d) {
	    // WebGL matrix operations use floats with limited precision, potentially causing a number near a border of [0, 1]
	    // to end up slightly outside the border. With an epsilon, we reduce the chance that a line gets clipped by the
	    // near or the far plane.
	    return Math.max(depthLimitEpsilon, Math.min(1 - depthLimitEpsilon, d));
	}
	
	function palette(unitToColor, opacity) {
	    var result = new Array(256);
	    for(var i = 0; i < 256; i++) {
	        result[i] = unitToColor(i / 255).concat(opacity);
	    }
	    return result;
	}
	
	// Maps the sample index [0...sampleCount - 1] to a range of [0, 1] as the shader expects colors in the [0, 1] range.
	// but first it shifts the sample index by 0, 8 or 16 bits depending on rgbIndex [0..2]
	// with the end result that each line will be of a unique color, making it possible for the pick handler
	// to uniquely identify which line is hovered over (bijective mapping).
	// The inverse, i.e. readPixel is invoked from 'parcoords.js'
	function calcPickColor(i, rgbIndex) {
	    return (i >>> 8 * rgbIndex) % 256 / 255;
	}
	
	function makePoints(sampleCount, dims, color) {
	    var points = new Array(sampleCount * (maxDim + 4));
	    var n = 0;
	    for(var i = 0; i < sampleCount; i++) {
	        for(var k = 0; k < maxDim; k++) {
	            points[n++] = (k < dims.length) ? dims[k].paddedUnitValues[i] : 0.5;
	        }
	        points[n++] = calcPickColor(i, 2);
	        points[n++] = calcPickColor(i, 1);
	        points[n++] = calcPickColor(i, 0);
	        points[n++] = adjustDepth(color[i]);
	    }
	    return points;
	}
	
	function makeVecAttr(vecIndex, sampleCount, points) {
	    var pointPairs = new Array(sampleCount * 8);
	    var n = 0;
	    for(var i = 0; i < sampleCount; i++) {
	        for(var j = 0; j < 2; j++) {
	            for(var k = 0; k < 4; k++) {
	                var q = vecIndex * 4 + k;
	                var v = points[i * 64 + q];
	                if(q === 63 && j === 0) {
	                    v *= -1;
	                }
	                pointPairs[n++] = v;
	            }
	        }
	    }
	    return pointPairs;
	}
	
	function pad2(num) {
	    var s = '0' + num;
	    return s.substr(s.length - 2);
	}
	
	function getAttrName(i) {
	    return (i < maxDim) ? 'p' + pad2(i + 1) + '_' + pad2(i + 4) : 'colors';
	}
	
	function setAttributes(attributes, sampleCount, points) {
	    for(var i = 0; i <= maxDim; i += 4) {
	        attributes[getAttrName(i)](makeVecAttr(i / 4, sampleCount, points));
	    }
	}
	
	function emptyAttributes(regl) {
	    var attributes = {};
	    for(var i = 0; i <= maxDim; i += 4) {
	        attributes[getAttrName(i)] = regl.buffer({usage: 'dynamic', type: 'float', data: new Uint8Array(0)});
	    }
	    return attributes;
	}
	
	function makeItem(model, leftmost, rightmost, itemNumber, i0, i1, x, y, panelSizeX, panelSizeY, crossfilterDimensionIndex, drwLayer, constraints) {
	    var dims = [[], []];
	    for(var k = 0; k < 64; k++) {
	        dims[0][k] = (k === i0) ? 1 : 0;
	        dims[1][k] = (k === i1) ? 1 : 0;
	    }
	
	    var overdrag = model.lines.canvasOverdrag;
	    var domain = model.domain;
	    var canvasWidth = model.canvasWidth;
	    var canvasHeight = model.canvasHeight;
	
	    var deselectedLinesColor = model.deselectedLines.color;
	
	    var itemModel = Lib.extendFlat({
	        key: crossfilterDimensionIndex,
	        resolution: [canvasWidth, canvasHeight],
	        viewBoxPos: [x + overdrag, y],
	        viewBoxSize: [panelSizeX, panelSizeY],
	        i0: i0,
	        i1: i1,
	
	        dim0A: dims[0].slice(0, 16),
	        dim0B: dims[0].slice(16, 32),
	        dim0C: dims[0].slice(32, 48),
	        dim0D: dims[0].slice(48, 64),
	        dim1A: dims[1].slice(0, 16),
	        dim1B: dims[1].slice(16, 32),
	        dim1C: dims[1].slice(32, 48),
	        dim1D: dims[1].slice(48, 64),
	
	        drwLayer: drwLayer,
	        contextColor: [
	            deselectedLinesColor[0] / 255,
	            deselectedLinesColor[1] / 255,
	            deselectedLinesColor[2] / 255,
	            deselectedLinesColor[3] < 1 ?
	                deselectedLinesColor[3] :
	                Math.max(1 / 255, Math.pow(1 / model.lines.color.length, 1 / 3))
	        ],
	
	        scissorX: (itemNumber === leftmost ? 0 : x + overdrag) + (model.pad.l - overdrag) + model.layoutWidth * domain.x[0],
	        scissorWidth: (itemNumber === rightmost ? canvasWidth - x + overdrag : panelSizeX + 0.5) + (itemNumber === leftmost ? x + overdrag : 0),
	        scissorY: y + model.pad.b + model.layoutHeight * domain.y[0],
	        scissorHeight: panelSizeY,
	
	        viewportX: model.pad.l - overdrag + model.layoutWidth * domain.x[0],
	        viewportY: model.pad.b + model.layoutHeight * domain.y[0],
	        viewportWidth: canvasWidth,
	        viewportHeight: canvasHeight
	    }, constraints);
	
	    return itemModel;
	}
	
	function expandedPixelRange(bounds) {
	    var dh = maskHeight - 1;
	    var a = Math.max(0, Math.floor(bounds[0] * dh), 0);
	    var b = Math.min(dh, Math.ceil(bounds[1] * dh), dh);
	    return [
	        Math.min(a, b),
	        Math.max(a, b)
	    ];
	}
	
	module.exports = function(canvasGL, d) {
	    // context & pick describe which canvas we're talking about - won't change with new data
	    var isContext = d.context;
	    var isPick = d.pick;
	
	    var regl = d.regl;
	
	    var renderState = {
	        currentRafs: {},
	        drawCompleted: true,
	        clearOnly: false
	    };
	
	    // state to be set by update and used later
	    var model;
	    var vm;
	    var initialDims;
	    var sampleCount;
	    var attributes = emptyAttributes(regl);
	    var maskTexture;
	    var paletteTexture = regl.texture(paletteTextureConfig);
	
	    var prevAxisOrder = [];
	
	    update(d);
	
	    var glAes = regl({
	
	        profile: false,
	
	        blend: {
	            enable: isContext,
	            func: {
	                srcRGB: 'src alpha',
	                dstRGB: 'one minus src alpha',
	                srcAlpha: 1,
	                dstAlpha: 1 // 'one minus src alpha'
	            },
	            equation: {
	                rgb: 'add',
	                alpha: 'add'
	            },
	            color: [0, 0, 0, 0]
	        },
	
	        depth: {
	            enable: !isContext,
	            mask: true,
	            func: 'less',
	            range: [0, 1]
	        },
	
	        // for polygons
	        cull: {
	            enable: true,
	            face: 'back'
	        },
	
	        scissor: {
	            enable: true,
	            box: {
	                x: regl.prop('scissorX'),
	                y: regl.prop('scissorY'),
	                width: regl.prop('scissorWidth'),
	                height: regl.prop('scissorHeight')
	            }
	        },
	
	        viewport: {
	            x: regl.prop('viewportX'),
	            y: regl.prop('viewportY'),
	            width: regl.prop('viewportWidth'),
	            height: regl.prop('viewportHeight')
	        },
	
	        dither: false,
	
	        vert: vertexShaderSource,
	
	        frag: fragmentShaderSource,
	
	        primitive: 'lines',
	        lineWidth: 1,
	        attributes: attributes,
	        uniforms: {
	            resolution: regl.prop('resolution'),
	            viewBoxPos: regl.prop('viewBoxPos'),
	            viewBoxSize: regl.prop('viewBoxSize'),
	            dim0A: regl.prop('dim0A'),
	            dim1A: regl.prop('dim1A'),
	            dim0B: regl.prop('dim0B'),
	            dim1B: regl.prop('dim1B'),
	            dim0C: regl.prop('dim0C'),
	            dim1C: regl.prop('dim1C'),
	            dim0D: regl.prop('dim0D'),
	            dim1D: regl.prop('dim1D'),
	            loA: regl.prop('loA'),
	            hiA: regl.prop('hiA'),
	            loB: regl.prop('loB'),
	            hiB: regl.prop('hiB'),
	            loC: regl.prop('loC'),
	            hiC: regl.prop('hiC'),
	            loD: regl.prop('loD'),
	            hiD: regl.prop('hiD'),
	            palette: paletteTexture,
	            contextColor: regl.prop('contextColor'),
	            mask: regl.prop('maskTexture'),
	            drwLayer: regl.prop('drwLayer'),
	            maskHeight: regl.prop('maskHeight')
	        },
	        offset: regl.prop('offset'),
	        count: regl.prop('count')
	    });
	
	    function update(dNew) {
	        model = dNew.model;
	        vm = dNew.viewModel;
	        initialDims = vm.dimensions.slice();
	        sampleCount = initialDims[0] ? initialDims[0].values.length : 0;
	
	        var lines = model.lines;
	        var color = isPick ? lines.color.map(function(_, i) {return i / lines.color.length;}) : lines.color;
	
	        var points = makePoints(sampleCount, initialDims, color);
	        setAttributes(attributes, sampleCount, points);
	
	        if(!isContext && !isPick) {
	            paletteTexture = regl.texture(Lib.extendFlat({
	                data: palette(model.unitToColor, 255)
	            }, paletteTextureConfig));
	        }
	    }
	
	    function makeConstraints(isContext) {
	        var i, j, k;
	
	        var limits = [[], []];
	        for(k = 0; k < 64; k++) {
	            var p = (!isContext && k < initialDims.length) ?
	                initialDims[k].brush.filter.getBounds() : [-Infinity, Infinity];
	
	            limits[0][k] = p[0];
	            limits[1][k] = p[1];
	        }
	
	        var len = maskHeight * 8;
	        var mask = new Array(len);
	        for(i = 0; i < len; i++) {
	            mask[i] = 255;
	        }
	        if(!isContext) {
	            for(i = 0; i < initialDims.length; i++) {
	                var u = i % 8;
	                var v = (i - u) / 8;
	                var bitMask = Math.pow(2, u);
	                var dim = initialDims[i];
	                var ranges = dim.brush.filter.get();
	                if(ranges.length < 2) continue; // bail if the bounding box based filter is sufficient
	
	                var prevEnd = expandedPixelRange(ranges[0])[1];
	                for(j = 1; j < ranges.length; j++) {
	                    var nextRange = expandedPixelRange(ranges[j]);
	                    for(k = prevEnd + 1; k < nextRange[0]; k++) {
	                        mask[k * 8 + v] &= ~bitMask;
	                    }
	                    prevEnd = Math.max(prevEnd, nextRange[1]);
	                }
	            }
	        }
	
	        var textureData = {
	            // 8 units x 8 bits = 64 bits, just sufficient for the almost 64 dimensions we support
	            shape: [8, maskHeight],
	            format: 'alpha',
	            type: 'uint8',
	            mag: 'nearest',
	            min: 'nearest',
	            data: mask
	        };
	        if(maskTexture) maskTexture(textureData);
	        else maskTexture = regl.texture(textureData);
	
	        return {
	            maskTexture: maskTexture,
	            maskHeight: maskHeight,
	            loA: limits[0].slice(0, 16),
	            loB: limits[0].slice(16, 32),
	            loC: limits[0].slice(32, 48),
	            loD: limits[0].slice(48, 64),
	            hiA: limits[1].slice(0, 16),
	            hiB: limits[1].slice(16, 32),
	            hiC: limits[1].slice(32, 48),
	            hiD: limits[1].slice(48, 64),
	        };
	    }
	
	    function renderGLParcoords(panels, setChanged, clearOnly) {
	        var panelCount = panels.length;
	        var i;
	
	        var leftmost;
	        var rightmost;
	        var lowestX = Infinity;
	        var highestX = -Infinity;
	
	        for(i = 0; i < panelCount; i++) {
	            if(panels[i].dim0.canvasX < lowestX) {
	                lowestX = panels[i].dim0.canvasX;
	                leftmost = i;
	            }
	            if(panels[i].dim1.canvasX > highestX) {
	                highestX = panels[i].dim1.canvasX;
	                rightmost = i;
	            }
	        }
	
	        if(panelCount === 0) {
	            // clear canvas here, as the panel iteration below will not enter the loop body
	            clear(regl, 0, 0, model.canvasWidth, model.canvasHeight);
	        }
	        var constraints = makeConstraints(isContext);
	
	        for(i = 0; i < panelCount; i++) {
	            var p = panels[i];
	            var i0 = p.dim0.crossfilterDimensionIndex;
	            var i1 = p.dim1.crossfilterDimensionIndex;
	            var x = p.canvasX;
	            var y = p.canvasY;
	            var nextX = x + p.panelSizeX;
	            if(setChanged ||
	                !prevAxisOrder[i0] ||
	                prevAxisOrder[i0][0] !== x ||
	                prevAxisOrder[i0][1] !== nextX
	            ) {
	                prevAxisOrder[i0] = [x, nextX];
	
	                var item = makeItem(
	                    model,
	                    leftmost, rightmost, i, i0, i1, x, y,
	                    p.panelSizeX, p.panelSizeY,
	                    p.dim0.crossfilterDimensionIndex,
	                    isContext ? 0 : isPick ? 2 : 1,
	                    constraints
	                );
	
	                renderState.clearOnly = clearOnly;
	
	                var blockLineCount = setChanged ? model.lines.blockLineCount : sampleCount;
	                renderBlock(
	                    regl, glAes, renderState, blockLineCount, sampleCount, item
	                );
	            }
	        }
	    }
	
	    function readPixel(canvasX, canvasY) {
	        regl.read({
	            x: canvasX,
	            y: canvasY,
	            width: 1,
	            height: 1,
	            data: dataPixel
	        });
	        return dataPixel;
	    }
	
	    function readPixels(canvasX, canvasY, width, height) {
	        var pixelArray = new Uint8Array(4 * width * height);
	        regl.read({
	            x: canvasX,
	            y: canvasY,
	            width: width,
	            height: height,
	            data: pixelArray
	        });
	        return pixelArray;
	    }
	
	    function destroy() {
	        canvasGL.style['pointer-events'] = 'none';
	        paletteTexture.destroy();
	        if(maskTexture) maskTexture.destroy();
	        for(var k in attributes) attributes[k].destroy();
	    }
	
	    return {
	        render: renderGLParcoords,
	        readPixel: readPixel,
	        readPixels: readPixels,
	        destroy: destroy,
	        update: update
	    };
	};
	
	},{"../../lib":716,"./constants":1084,"glslify":410}],1089:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	/**
	 * mergeLength: set trace length as the minimum of all dimension data lengths
	 *     and propagates this length into each dimension
	 *
	 * @param {object} traceOut: the fullData trace
	 * @param {Array(object)} dimensions: array of dimension objects
	 * @param {string} dataAttr: the attribute of each dimension containing the data
	 * @param {integer} len: an already-existing length from other attributes
	 */
	module.exports = function(traceOut, dimensions, dataAttr, len) {
	    if(!len) len = Infinity;
	    var i, dimi;
	    for(i = 0; i < dimensions.length; i++) {
	        dimi = dimensions[i];
	        if(dimi.visible) len = Math.min(len, dimi[dataAttr].length);
	    }
	    if(len === Infinity) len = 0;
	
	    traceOut._length = len;
	    for(i = 0; i < dimensions.length; i++) {
	        dimi = dimensions[i];
	        if(dimi.visible) dimi._length = len;
	    }
	
	    return len;
	};
	
	},{}],1090:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var rgba = _dereq_('color-rgba');
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	var Drawing = _dereq_('../../components/drawing');
	var Colorscale = _dereq_('../../components/colorscale');
	
	var gup = _dereq_('../../lib/gup');
	var keyFun = gup.keyFun;
	var repeat = gup.repeat;
	var unwrap = gup.unwrap;
	
	var helpers = _dereq_('./helpers');
	var c = _dereq_('./constants');
	var brush = _dereq_('./axisbrush');
	var lineLayerMaker = _dereq_('./lines');
	
	function findExtreme(fn, values, len) {
	    return Lib.aggNums(fn, null, values, len);
	}
	
	function findExtremes(values, len) {
	    return fixExtremes(
	        findExtreme(Math.min, values, len),
	        findExtreme(Math.max, values, len)
	    );
	}
	
	function dimensionExtent(dimension) {
	    var range = dimension.range;
	    return range ?
	        fixExtremes(range[0], range[1]) :
	        findExtremes(dimension.values, dimension._length);
	}
	
	function fixExtremes(lo, hi) {
	    if(isNaN(lo) || !isFinite(lo)) {
	        lo = 0;
	    }
	
	    if(isNaN(hi) || !isFinite(hi)) {
	        hi = 0;
	    }
	
	    // avoid a degenerate (zero-width) domain
	    if(lo === hi) {
	        if(lo === 0) {
	            // no use to multiplying zero, so add/subtract in this case
	            lo -= 1;
	            hi += 1;
	        } else {
	            // this keeps the range in the order of magnitude of the data
	            lo *= 0.9;
	            hi *= 1.1;
	        }
	    }
	
	    return [lo, hi];
	}
	
	function toText(formatter, texts) {
	    if(texts) {
	        return function(v, i) {
	            var text = texts[i];
	            if(text === null || text === undefined) return formatter(v);
	            return text;
	        };
	    }
	    return formatter;
	}
	
	function domainScale(height, padding, dimension, tickvals, ticktext) {
	    var extent = dimensionExtent(dimension);
	    if(tickvals) {
	        return d3.scale.ordinal()
	            .domain(tickvals.map(toText(d3.format(dimension.tickformat), ticktext)))
	            .range(tickvals
	                .map(function(d) {
	                    var unitVal = (d - extent[0]) / (extent[1] - extent[0]);
	                    return (height - padding + unitVal * (2 * padding - height));
	                })
	            );
	    }
	    return d3.scale.linear()
	        .domain(extent)
	        .range([height - padding, padding]);
	}
	
	function unitToPaddedPx(height, padding) {
	    return d3.scale.linear().range([padding, height - padding]);
	}
	
	function domainToPaddedUnitScale(dimension, padFraction) {
	    return d3.scale.linear()
	        .domain(dimensionExtent(dimension))
	        .range([padFraction, 1 - padFraction]);
	}
	
	function ordinalScale(dimension) {
	    if(!dimension.tickvals) return;
	
	    var extent = dimensionExtent(dimension);
	    return d3.scale.ordinal()
	        .domain(dimension.tickvals)
	        .range(dimension.tickvals.map(function(d) {
	            return (d - extent[0]) / (extent[1] - extent[0]);
	        }));
	}
	
	function unitToColorScale(cscale) {
	    var colorStops = cscale.map(function(d) { return d[0]; });
	    var colorTuples = cscale.map(function(d) {
	        var RGBA = rgba(d[1]);
	        return d3.rgb('rgb(' + RGBA[0] + ',' + RGBA[1] + ',' + RGBA[2] + ')');
	    });
	    var prop = function(n) { return function(o) { return o[n]; }; };
	
	    // We can't use d3 color interpolation as we may have non-uniform color palette raster
	    // (various color stop distances).
	    var polylinearUnitScales = 'rgb'.split('').map(function(key) {
	        return d3.scale.linear()
	            .clamp(true)
	            .domain(colorStops)
	            .range(colorTuples.map(prop(key)));
	    });
	
	    return function(d) {
	        return polylinearUnitScales.map(function(s) {
	            return s(d);
	        });
	    };
	}
	
	function someFiltersActive(view) {
	    return view.dimensions.some(function(p) {
	        return p.brush.filterSpecified;
	    });
	}
	
	function model(layout, d, i) {
	    var cd0 = unwrap(d);
	    var trace = cd0.trace;
	    var lineColor = helpers.convertTypedArray(cd0.lineColor);
	    var line = trace.line;
	    var deselectedLines = {color: rgba(c.deselectedLineColor)};
	    var cOpts = Colorscale.extractOpts(line);
	    var cscale = cOpts.reversescale ? Colorscale.flipScale(cd0.cscale) : cd0.cscale;
	    var domain = trace.domain;
	    var dimensions = trace.dimensions;
	    var width = layout.width;
	    var labelAngle = trace.labelangle;
	    var labelSide = trace.labelside;
	    var labelFont = trace.labelfont;
	    var tickFont = trace.tickfont;
	    var rangeFont = trace.rangefont;
	
	    var lines = Lib.extendDeepNoArrays({}, line, {
	        color: lineColor.map(d3.scale.linear().domain(
	            dimensionExtent({
	                values: lineColor,
	                range: [cOpts.min, cOpts.max],
	                _length: trace._length
	            })
	        )),
	        blockLineCount: c.blockLineCount,
	        canvasOverdrag: c.overdrag * c.canvasPixelRatio
	    });
	
	    var groupWidth = Math.floor(width * (domain.x[1] - domain.x[0]));
	    var groupHeight = Math.floor(layout.height * (domain.y[1] - domain.y[0]));
	
	    var pad = layout.margin || {l: 80, r: 80, t: 100, b: 80};
	    var rowContentWidth = groupWidth;
	    var rowHeight = groupHeight;
	
	    return {
	        key: i,
	        colCount: dimensions.filter(helpers.isVisible).length,
	        dimensions: dimensions,
	        tickDistance: c.tickDistance,
	        unitToColor: unitToColorScale(cscale),
	        lines: lines,
	        deselectedLines: deselectedLines,
	        labelAngle: labelAngle,
	        labelSide: labelSide,
	        labelFont: labelFont,
	        tickFont: tickFont,
	        rangeFont: rangeFont,
	        layoutWidth: width,
	        layoutHeight: layout.height,
	        domain: domain,
	        translateX: domain.x[0] * width,
	        translateY: layout.height - domain.y[1] * layout.height,
	        pad: pad,
	        canvasWidth: rowContentWidth * c.canvasPixelRatio + 2 * lines.canvasOverdrag,
	        canvasHeight: rowHeight * c.canvasPixelRatio,
	        width: rowContentWidth,
	        height: rowHeight,
	        canvasPixelRatio: c.canvasPixelRatio
	    };
	}
	
	function viewModel(state, callbacks, model) {
	    var width = model.width;
	    var height = model.height;
	    var dimensions = model.dimensions;
	    var canvasPixelRatio = model.canvasPixelRatio;
	
	    var xScale = function(d) {return width * d / Math.max(1, model.colCount - 1);};
	
	    var unitPad = c.verticalPadding / height;
	    var _unitToPaddedPx = unitToPaddedPx(height, c.verticalPadding);
	
	    var vm = {
	        key: model.key,
	        xScale: xScale,
	        model: model,
	        inBrushDrag: false // consider factoring it out and putting it in a centralized global-ish gesture state object
	    };
	
	    var uniqueKeys = {};
	
	    vm.dimensions = dimensions.filter(helpers.isVisible).map(function(dimension, i) {
	        var domainToPaddedUnit = domainToPaddedUnitScale(dimension, unitPad);
	        var foundKey = uniqueKeys[dimension.label];
	        uniqueKeys[dimension.label] = (foundKey || 0) + 1;
	        var key = dimension.label + (foundKey ? '__' + foundKey : '');
	        var specifiedConstraint = dimension.constraintrange;
	        var filterRangeSpecified = specifiedConstraint && specifiedConstraint.length;
	        if(filterRangeSpecified && !Array.isArray(specifiedConstraint[0])) {
	            specifiedConstraint = [specifiedConstraint];
	        }
	        var filterRange = filterRangeSpecified ?
	            specifiedConstraint.map(function(d) { return d.map(domainToPaddedUnit); }) :
	            [[-Infinity, Infinity]];
	        var brushMove = function() {
	            var p = vm;
	            p.focusLayer && p.focusLayer.render(p.panels, true);
	            var filtersActive = someFiltersActive(p);
	            if(!state.contextShown() && filtersActive) {
	                p.contextLayer && p.contextLayer.render(p.panels, true);
	                state.contextShown(true);
	            } else if(state.contextShown() && !filtersActive) {
	                p.contextLayer && p.contextLayer.render(p.panels, true, true);
	                state.contextShown(false);
	            }
	        };
	
	        var truncatedValues = dimension.values;
	        if(truncatedValues.length > dimension._length) {
	            truncatedValues = truncatedValues.slice(0, dimension._length);
	        }
	
	        var tickvals = dimension.tickvals;
	        var ticktext;
	        function makeTickItem(v, i) { return {val: v, text: ticktext[i]}; }
	        function sortTickItem(a, b) { return a.val - b.val; }
	        if(Array.isArray(tickvals) && tickvals.length) {
	            ticktext = dimension.ticktext;
	
	            // ensure ticktext and tickvals have same length
	            if(!Array.isArray(ticktext) || !ticktext.length) {
	                ticktext = tickvals.map(d3.format(dimension.tickformat));
	            } else if(ticktext.length > tickvals.length) {
	                ticktext = ticktext.slice(0, tickvals.length);
	            } else if(tickvals.length > ticktext.length) {
	                tickvals = tickvals.slice(0, ticktext.length);
	            }
	
	            // check if we need to sort tickvals/ticktext
	            for(var j = 1; j < tickvals.length; j++) {
	                if(tickvals[j] < tickvals[j - 1]) {
	                    var tickItems = tickvals.map(makeTickItem).sort(sortTickItem);
	                    for(var k = 0; k < tickvals.length; k++) {
	                        tickvals[k] = tickItems[k].val;
	                        ticktext[k] = tickItems[k].text;
	                    }
	                    break;
	                }
	            }
	        } else tickvals = undefined;
	
	        truncatedValues = helpers.convertTypedArray(truncatedValues);
	
	        return {
	            key: key,
	            label: dimension.label,
	            tickFormat: dimension.tickformat,
	            tickvals: tickvals,
	            ticktext: ticktext,
	            ordinal: helpers.isOrdinal(dimension),
	            multiselect: dimension.multiselect,
	            xIndex: i,
	            crossfilterDimensionIndex: i,
	            visibleIndex: dimension._index,
	            height: height,
	            values: truncatedValues,
	            paddedUnitValues: truncatedValues.map(domainToPaddedUnit),
	            unitTickvals: tickvals && tickvals.map(domainToPaddedUnit),
	            xScale: xScale,
	            x: xScale(i),
	            canvasX: xScale(i) * canvasPixelRatio,
	            unitToPaddedPx: _unitToPaddedPx,
	            domainScale: domainScale(height, c.verticalPadding, dimension, tickvals, ticktext),
	            ordinalScale: ordinalScale(dimension),
	            parent: vm,
	            model: model,
	            brush: brush.makeBrush(
	                state,
	                filterRangeSpecified,
	                filterRange,
	                function() {
	                    state.linePickActive(false);
	                },
	                brushMove,
	                function(f) {
	                    vm.focusLayer.render(vm.panels, true);
	                    vm.pickLayer && vm.pickLayer.render(vm.panels, true);
	                    state.linePickActive(true);
	                    if(callbacks && callbacks.filterChanged) {
	                        var invScale = domainToPaddedUnit.invert;
	
	                        // update gd.data as if a Plotly.restyle were fired
	                        var newRanges = f.map(function(r) {
	                            return r.map(invScale).sort(Lib.sorterAsc);
	                        }).sort(function(a, b) { return a[0] - b[0]; });
	                        callbacks.filterChanged(vm.key, dimension._index, newRanges);
	                    }
	                }
	            )
	        };
	    });
	
	    return vm;
	}
	
	function styleExtentTexts(selection) {
	    selection
	        .classed(c.cn.axisExtentText, true)
	        .attr('text-anchor', 'middle')
	        .style('cursor', 'default')
	        .style('user-select', 'none');
	}
	
	function parcoordsInteractionState() {
	    var linePickActive = true;
	    var contextShown = false;
	    return {
	        linePickActive: function(val) {return arguments.length ? linePickActive = !!val : linePickActive;},
	        contextShown: function(val) {return arguments.length ? contextShown = !!val : contextShown;}
	    };
	}
	
	function calcTilt(angle, position) {
	    var dir = (position === 'top') ? 1 : -1;
	    var radians = angle * Math.PI / 180;
	    var dx = Math.sin(radians);
	    var dy = Math.cos(radians);
	    return {
	        dir: dir,
	        dx: dx,
	        dy: dy,
	        degrees: angle
	    };
	}
	
	function updatePanelLayout(yAxis, vm) {
	    var panels = vm.panels || (vm.panels = []);
	    var data = yAxis.data();
	    for(var i = 0; i < data.length - 1; i++) {
	        var p = panels[i] || (panels[i] = {});
	        var dim0 = data[i];
	        var dim1 = data[i + 1];
	        p.dim0 = dim0;
	        p.dim1 = dim1;
	        p.canvasX = dim0.canvasX;
	        p.panelSizeX = dim1.canvasX - dim0.canvasX;
	        p.panelSizeY = vm.model.canvasHeight;
	        p.y = 0;
	        p.canvasY = 0;
	    }
	}
	
	function calcAllTicks(cd) {
	    for(var i = 0; i < cd.length; i++) {
	        for(var j = 0; j < cd[i].length; j++) {
	            var trace = cd[i][j].trace;
	            var dimensions = trace.dimensions;
	
	            for(var k = 0; k < dimensions.length; k++) {
	                var values = dimensions[k].values;
	                var dim = dimensions[k]._ax;
	
	                if(dim) {
	                    if(!dim.range) {
	                        dim.range = findExtremes(values, trace._length);
	                    } else {
	                        dim.range = fixExtremes(dim.range[0], dim.range[1]);
	                    }
	
	                    if(!dim.dtick) {
	                        dim.dtick = 0.01 * (Math.abs(dim.range[1] - dim.range[0]) || 1);
	                    }
	
	                    dim.tickformat = dimensions[k].tickformat;
	                    Axes.calcTicks(dim);
	                    dim.cleanRange();
	                }
	            }
	        }
	    }
	}
	
	function linearFormat(dim, v) {
	    return Axes.tickText(dim._ax, v, false).text;
	}
	
	function extremeText(d, isTop) {
	    if(d.ordinal) return '';
	    var domain = d.domainScale.domain();
	    var v = (domain[isTop ? domain.length - 1 : 0]);
	
	    return linearFormat(d.model.dimensions[d.visibleIndex], v);
	}
	
	
	module.exports = function parcoords(gd, cdModule, layout, callbacks) {
	    var fullLayout = gd._fullLayout;
	    var svg = fullLayout._toppaper;
	    var glContainer = fullLayout._glcontainer;
	
	    calcAllTicks(cdModule);
	
	    var state = parcoordsInteractionState();
	
	    var vm = cdModule
	        .filter(function(d) { return unwrap(d).trace.visible; })
	        .map(model.bind(0, layout))
	        .map(viewModel.bind(0, state, callbacks));
	
	    glContainer.each(function(d, i) {
	        return Lib.extendFlat(d, vm[i]);
	    });
	
	    var glLayers = glContainer.selectAll('.gl-canvas')
	        .each(function(d) {
	            // FIXME: figure out how to handle multiple instances
	            d.viewModel = vm[0];
	            d.model = d.viewModel ? d.viewModel.model : null;
	        });
	
	    var lastHovered = null;
	
	    var pickLayer = glLayers.filter(function(d) {return d.pick;});
	
	    // emit hover / unhover event
	    pickLayer
	        .style('pointer-events', 'auto')
	        .on('mousemove', function(d) {
	            if(state.linePickActive() && d.lineLayer && callbacks && callbacks.hover) {
	                var event = d3.event;
	                var cw = this.width;
	                var ch = this.height;
	                var pointer = d3.mouse(this);
	                var x = pointer[0];
	                var y = pointer[1];
	
	                if(x < 0 || y < 0 || x >= cw || y >= ch) {
	                    return;
	                }
	                var pixel = d.lineLayer.readPixel(x, ch - 1 - y);
	                var found = pixel[3] !== 0;
	                // inverse of the calcPickColor in `lines.js`; detailed comment there
	                var curveNumber = found ? pixel[2] + 256 * (pixel[1] + 256 * pixel[0]) : null;
	                var eventData = {
	                    x: x,
	                    y: y,
	                    clientX: event.clientX,
	                    clientY: event.clientY,
	                    dataIndex: d.model.key,
	                    curveNumber: curveNumber
	                };
	                if(curveNumber !== lastHovered) { // don't unnecessarily repeat the same hit (or miss)
	                    if(found) {
	                        callbacks.hover(eventData);
	                    } else if(callbacks.unhover) {
	                        callbacks.unhover(eventData);
	                    }
	                    lastHovered = curveNumber;
	                }
	            }
	        });
	
	    glLayers
	        .style('opacity', function(d) {return d.pick ? 0 : 1;});
	
	    svg.style('background', 'rgba(255, 255, 255, 0)');
	    var controlOverlay = svg.selectAll('.' + c.cn.parcoords)
	        .data(vm, keyFun);
	
	    controlOverlay.exit().remove();
	
	    controlOverlay.enter()
	        .append('g')
	        .classed(c.cn.parcoords, true)
	        .style('shape-rendering', 'crispEdges')
	        .style('pointer-events', 'none');
	
	    controlOverlay.attr('transform', function(d) {
	        return 'translate(' + d.model.translateX + ',' + d.model.translateY + ')';
	    });
	
	    var parcoordsControlView = controlOverlay.selectAll('.' + c.cn.parcoordsControlView)
	        .data(repeat, keyFun);
	
	    parcoordsControlView.enter()
	        .append('g')
	        .classed(c.cn.parcoordsControlView, true);
	
	    parcoordsControlView.attr('transform', function(d) {
	        return 'translate(' + d.model.pad.l + ',' + d.model.pad.t + ')';
	    });
	
	    var yAxis = parcoordsControlView.selectAll('.' + c.cn.yAxis)
	        .data(function(p) { return p.dimensions; }, keyFun);
	
	    yAxis.enter()
	        .append('g')
	        .classed(c.cn.yAxis, true);
	
	    parcoordsControlView.each(function(p) {
	        updatePanelLayout(yAxis, p);
	    });
	
	    glLayers
	        .each(function(d) {
	            if(d.viewModel) {
	                if(!d.lineLayer || callbacks) { // recreate in case of having callbacks e.g. restyle. Should we test for callback to be a restyle?
	                    d.lineLayer = lineLayerMaker(this, d);
	                } else d.lineLayer.update(d);
	
	                if(d.key || d.key === 0) d.viewModel[d.key] = d.lineLayer;
	
	                var setChanged = (!d.context || // don't update background
	                                  callbacks);   // unless there is a callback on the context layer. Should we test the callback?
	
	                d.lineLayer.render(d.viewModel.panels, setChanged);
	            }
	        });
	
	    yAxis.attr('transform', function(d) {
	        return 'translate(' + d.xScale(d.xIndex) + ', 0)';
	    });
	
	    // drag column for reordering columns
	    yAxis.call(d3.behavior.drag()
	        .origin(function(d) { return d; })
	        .on('drag', function(d) {
	            var p = d.parent;
	            state.linePickActive(false);
	            d.x = Math.max(-c.overdrag, Math.min(d.model.width + c.overdrag, d3.event.x));
	            d.canvasX = d.x * d.model.canvasPixelRatio;
	            yAxis
	                .sort(function(a, b) { return a.x - b.x; })
	                .each(function(e, i) {
	                    e.xIndex = i;
	                    e.x = d === e ? e.x : e.xScale(e.xIndex);
	                    e.canvasX = e.x * e.model.canvasPixelRatio;
	                });
	
	            updatePanelLayout(yAxis, p);
	
	            yAxis.filter(function(e) { return Math.abs(d.xIndex - e.xIndex) !== 0; })
	                .attr('transform', function(d) { return 'translate(' + d.xScale(d.xIndex) + ', 0)'; });
	            d3.select(this).attr('transform', 'translate(' + d.x + ', 0)');
	            yAxis.each(function(e, i0, i1) { if(i1 === d.parent.key) p.dimensions[i0] = e; });
	            p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
	            p.focusLayer.render && p.focusLayer.render(p.panels);
	        })
	        .on('dragend', function(d) {
	            var p = d.parent;
	            d.x = d.xScale(d.xIndex);
	            d.canvasX = d.x * d.model.canvasPixelRatio;
	            updatePanelLayout(yAxis, p);
	            d3.select(this)
	                .attr('transform', function(d) { return 'translate(' + d.x + ', 0)'; });
	            p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
	            p.focusLayer && p.focusLayer.render(p.panels);
	            p.pickLayer && p.pickLayer.render(p.panels, true);
	            state.linePickActive(true);
	
	            if(callbacks && callbacks.axesMoved) {
	                callbacks.axesMoved(p.key, p.dimensions.map(function(e) {return e.crossfilterDimensionIndex;}));
	            }
	        })
	    );
	
	    yAxis.exit()
	        .remove();
	
	    var axisOverlays = yAxis.selectAll('.' + c.cn.axisOverlays)
	        .data(repeat, keyFun);
	
	    axisOverlays.enter()
	        .append('g')
	        .classed(c.cn.axisOverlays, true);
	
	    axisOverlays.selectAll('.' + c.cn.axis).remove();
	
	    var axis = axisOverlays.selectAll('.' + c.cn.axis)
	        .data(repeat, keyFun);
	
	    axis.enter()
	        .append('g')
	        .classed(c.cn.axis, true);
	
	    axis
	        .each(function(d) {
	            var wantedTickCount = d.model.height / d.model.tickDistance;
	            var scale = d.domainScale;
	            var sdom = scale.domain();
	            d3.select(this)
	                .call(d3.svg.axis()
	                    .orient('left')
	                    .tickSize(4)
	                    .outerTickSize(2)
	                    .ticks(wantedTickCount, d.tickFormat) // works for continuous scales only...
	                    .tickValues(d.ordinal ? // and this works for ordinal scales
	                        sdom :
	                        null)
	                    .tickFormat(function(v) {
	                        return helpers.isOrdinal(d) ? v : linearFormat(d.model.dimensions[d.visibleIndex], v);
	                    })
	                    .scale(scale));
	            Drawing.font(axis.selectAll('text'), d.model.tickFont);
	        });
	
	    axis.selectAll('.domain, .tick>line')
	        .attr('fill', 'none')
	        .attr('stroke', 'black')
	        .attr('stroke-opacity', 0.25)
	        .attr('stroke-width', '1px');
	
	    axis.selectAll('text')
	        .style('text-shadow', '1px 1px 1px #fff, -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff')
	        .style('cursor', 'default')
	        .style('user-select', 'none');
	
	    var axisHeading = axisOverlays.selectAll('.' + c.cn.axisHeading)
	        .data(repeat, keyFun);
	
	    axisHeading.enter()
	        .append('g')
	        .classed(c.cn.axisHeading, true);
	
	    var axisTitle = axisHeading.selectAll('.' + c.cn.axisTitle)
	        .data(repeat, keyFun);
	
	    axisTitle.enter()
	        .append('text')
	        .classed(c.cn.axisTitle, true)
	        .attr('text-anchor', 'middle')
	        .style('cursor', 'ew-resize')
	        .style('user-select', 'none')
	        .style('pointer-events', 'auto');
	
	    axisTitle
	        .text(function(d) { return d.label; })
	        .each(function(d) {
	            var e = d3.select(this);
	            Drawing.font(e, d.model.labelFont);
	            svgTextUtils.convertToTspans(e, gd);
	        })
	        .attr('transform', function(d) {
	            var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
	            var r = c.axisTitleOffset;
	            return (
	                (tilt.dir > 0 ? '' : 'translate(0,' + (2 * r + d.model.height) + ')') +
	                'rotate(' + tilt.degrees + ')' +
	                'translate(' + (-r * tilt.dx) + ',' + (-r * tilt.dy) + ')'
	            );
	        })
	        .attr('text-anchor', function(d) {
	            var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
	            var adx = Math.abs(tilt.dx);
	            var ady = Math.abs(tilt.dy);
	
	            if(2 * adx > ady) {
	                return (tilt.dir * tilt.dx < 0) ? 'start' : 'end';
	            } else {
	                return 'middle';
	            }
	        });
	
	    var axisExtent = axisOverlays.selectAll('.' + c.cn.axisExtent)
	        .data(repeat, keyFun);
	
	    axisExtent.enter()
	        .append('g')
	        .classed(c.cn.axisExtent, true);
	
	    var axisExtentTop = axisExtent.selectAll('.' + c.cn.axisExtentTop)
	        .data(repeat, keyFun);
	
	    axisExtentTop.enter()
	        .append('g')
	        .classed(c.cn.axisExtentTop, true);
	
	    axisExtentTop
	        .attr('transform', 'translate(' + 0 + ',' + -c.axisExtentOffset + ')');
	
	    var axisExtentTopText = axisExtentTop.selectAll('.' + c.cn.axisExtentTopText)
	        .data(repeat, keyFun);
	
	    axisExtentTopText.enter()
	        .append('text')
	        .classed(c.cn.axisExtentTopText, true)
	        .call(styleExtentTexts);
	
	    axisExtentTopText
	        .text(function(d) { return extremeText(d, true); })
	        .each(function(d) { Drawing.font(d3.select(this), d.model.rangeFont); });
	
	    var axisExtentBottom = axisExtent.selectAll('.' + c.cn.axisExtentBottom)
	        .data(repeat, keyFun);
	
	    axisExtentBottom.enter()
	        .append('g')
	        .classed(c.cn.axisExtentBottom, true);
	
	    axisExtentBottom
	        .attr('transform', function(d) {
	            return 'translate(' + 0 + ',' + (d.model.height + c.axisExtentOffset) + ')';
	        });
	
	    var axisExtentBottomText = axisExtentBottom.selectAll('.' + c.cn.axisExtentBottomText)
	        .data(repeat, keyFun);
	
	    axisExtentBottomText.enter()
	        .append('text')
	        .classed(c.cn.axisExtentBottomText, true)
	        .attr('dy', '0.75em')
	        .call(styleExtentTexts);
	
	    axisExtentBottomText
	        .text(function(d) { return extremeText(d, false); })
	        .each(function(d) { Drawing.font(d3.select(this), d.model.rangeFont); });
	
	    brush.ensureAxisBrush(axisOverlays);
	};
	
	},{"../../components/colorscale":603,"../../components/drawing":612,"../../lib":716,"../../lib/gup":714,"../../lib/svg_text_utils":740,"../../plots/cartesian/axes":764,"./axisbrush":1081,"./constants":1084,"./helpers":1086,"./lines":1088,"color-rgba":123,"d3":164}],1091:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var parcoords = _dereq_('./parcoords');
	var prepareRegl = _dereq_('../../lib/prepare_regl');
	var isVisible = _dereq_('./helpers').isVisible;
	
	function newIndex(visibleIndices, orig, dim) {
	    var origIndex = orig.indexOf(dim);
	    var currentIndex = visibleIndices.indexOf(origIndex);
	    if(currentIndex === -1) {
	        // invisible dimensions initially go to the end
	        currentIndex += orig.length;
	    }
	    return currentIndex;
	}
	
	function sorter(visibleIndices, orig) {
	    return function sorter(d1, d2) {
	        return (
	            newIndex(visibleIndices, orig, d1) -
	            newIndex(visibleIndices, orig, d2)
	        );
	    };
	}
	
	module.exports = function plot(gd, cdModule) {
	    var fullLayout = gd._fullLayout;
	
	    var success = prepareRegl(gd);
	    if(!success) return;
	
	    var currentDims = {};
	    var initialDims = {};
	    var fullIndices = {};
	    var inputIndices = {};
	
	    var size = fullLayout._size;
	
	    cdModule.forEach(function(d, i) {
	        var trace = d[0].trace;
	        fullIndices[i] = trace.index;
	        var iIn = inputIndices[i] = trace._fullInput.index;
	        currentDims[i] = gd.data[iIn].dimensions;
	        initialDims[i] = gd.data[iIn].dimensions.slice();
	    });
	
	    var filterChanged = function(i, initialDimIndex, newRanges) {
	        // Have updated `constraintrange` data on `gd.data` and raise `Plotly.restyle` event
	        // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call
	
	        var dim = initialDims[i][initialDimIndex];
	        var newConstraints = newRanges.map(function(r) { return r.slice(); });
	
	        // Store constraint range in preGUI
	        // This one doesn't work if it's stored in pieces in _storeDirectGUIEdit
	        // because it's an array of variable dimensionality. So store the whole
	        // thing at once manually.
	        var aStr = 'dimensions[' + initialDimIndex + '].constraintrange';
	        var preGUI = fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid];
	        if(preGUI[aStr] === undefined) {
	            var initialVal = dim.constraintrange;
	            preGUI[aStr] = initialVal || null;
	        }
	
	        var fullDimension = gd._fullData[fullIndices[i]].dimensions[initialDimIndex];
	
	        if(!newConstraints.length) {
	            delete dim.constraintrange;
	            delete fullDimension.constraintrange;
	            newConstraints = null;
	        } else {
	            if(newConstraints.length === 1) newConstraints = newConstraints[0];
	            dim.constraintrange = newConstraints;
	            fullDimension.constraintrange = newConstraints.slice();
	            // wrap in another array for restyle event data
	            newConstraints = [newConstraints];
	        }
	
	        var restyleData = {};
	        restyleData[aStr] = newConstraints;
	        gd.emit('plotly_restyle', [restyleData, [inputIndices[i]]]);
	    };
	
	    var hover = function(eventData) {
	        gd.emit('plotly_hover', eventData);
	    };
	
	    var unhover = function(eventData) {
	        gd.emit('plotly_unhover', eventData);
	    };
	
	    var axesMoved = function(i, visibleIndices) {
	        // Have updated order data on `gd.data` and raise `Plotly.restyle` event
	        // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call
	
	        // drag&drop sorting of the visible dimensions
	        var orig = sorter(visibleIndices, initialDims[i].filter(isVisible));
	        currentDims[i].sort(orig);
	
	        // invisible dimensions are not interpreted in the context of drag&drop sorting as an invisible dimension
	        // cannot be dragged; they're interspersed into their original positions by this subsequent merging step
	        initialDims[i].filter(function(d) {return !isVisible(d);})
	             .sort(function(d) {
	                 // subsequent splicing to be done left to right, otherwise indices may be incorrect
	                 return initialDims[i].indexOf(d);
	             })
	            .forEach(function(d) {
	                currentDims[i].splice(currentDims[i].indexOf(d), 1); // remove from the end
	                currentDims[i].splice(initialDims[i].indexOf(d), 0, d); // insert at original index
	            });
	
	        // TODO: we can't really store this part of the interaction state
	        // directly as below, since it incudes data arrays. If we want to
	        // persist column order we may have to do something special for this
	        // case to just store the order itself.
	        // Registry.call('_storeDirectGUIEdit',
	        //     gd.data[inputIndices[i]],
	        //     fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid],
	        //     {dimensions: currentDims[i]}
	        // );
	
	        gd.emit('plotly_restyle', [{dimensions: [currentDims[i]]}, [inputIndices[i]]]);
	    };
	
	    parcoords(
	        gd,
	        cdModule,
	        { // layout
	            width: size.w,
	            height: size.h,
	            margin: {
	                t: size.t,
	                r: size.r,
	                b: size.b,
	                l: size.l
	            }
	        },
	        { // callbacks
	            filterChanged: filterChanged,
	            hover: hover,
	            unhover: unhover,
	            axesMoved: axesMoved
	        }
	    );
	};
	
	},{"../../lib/prepare_regl":729,"./helpers":1086,"./parcoords":1090}],1092:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var baseAttrs = _dereq_('../../plots/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var textFontAttrs = fontAttrs({
	    editType: 'plot',
	    arrayOk: true,
	    colorEditType: 'plot',
	    
	});
	
	module.exports = {
	    labels: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    // equivalent of x0 and dx, if label is missing
	    label0: {
	        valType: 'number',
	        
	        dflt: 0,
	        editType: 'calc',
	        
	    },
	    dlabel: {
	        valType: 'number',
	        
	        dflt: 1,
	        editType: 'calc',
	        
	    },
	
	    values: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    marker: {
	        colors: {
	            valType: 'data_array',  // TODO 'color_array' ?
	            editType: 'calc',
	            
	        },
	
	        line: {
	            color: {
	                valType: 'color',
	                
	                dflt: colorAttrs.defaultLine,
	                arrayOk: true,
	                editType: 'style',
	                
	            },
	            width: {
	                valType: 'number',
	                
	                min: 0,
	                dflt: 0,
	                arrayOk: true,
	                editType: 'style',
	                
	            },
	            editType: 'calc'
	        },
	        editType: 'calc'
	    },
	
	    text: {
	        valType: 'data_array',
	        editType: 'plot',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'style',
	        
	    },
	
	// 'see eg:'
	// 'https://www.e-education.psu.edu/natureofgeoinfo/sites/www.e-education.psu.edu.natureofgeoinfo/files/image/hisp_pies.gif',
	// '(this example involves a map too - may someday be a whole trace type',
	// 'of its own. but the point is the size of the whole pie is important.)'
	    scalegroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	
	    // labels (legend is handled by plots.attributes.showlegend and layout.hiddenlabels)
	    textinfo: {
	        valType: 'flaglist',
	        
	        flags: ['label', 'text', 'value', 'percent'],
	        extras: ['none'],
	        editType: 'calc',
	        
	    },
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['label', 'text', 'value', 'percent', 'name']
	    }),
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: ['label', 'color', 'value', 'percent', 'text']
	    }),
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['label', 'color', 'value', 'percent', 'text']
	    }),
	    textposition: {
	        valType: 'enumerated',
	        
	        values: ['inside', 'outside', 'auto', 'none'],
	        dflt: 'auto',
	        arrayOk: true,
	        editType: 'plot',
	        
	    },
	    textfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	    insidetextfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	    outsidetextfont: extendFlat({}, textFontAttrs, {
	        
	    }),
	    automargin: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'plot',
	        
	    },
	
	    title: {
	        text: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'plot',
	            
	        },
	        font: extendFlat({}, textFontAttrs, {
	            
	        }),
	        position: {
	            valType: 'enumerated',
	            values: [
	                'top left', 'top center', 'top right',
	                'middle center',
	                'bottom left', 'bottom center', 'bottom right'
	            ],
	            
	            editType: 'plot',
	            
	        },
	
	        editType: 'plot'
	    },
	
	    // position and shape
	    domain: domainAttrs({name: 'pie', trace: true, editType: 'calc'}),
	
	    hole: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 0,
	        editType: 'calc',
	        
	    },
	
	    // ordering and direction
	    sort: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc',
	        
	    },
	    direction: {
	        /**
	         * there are two common conventions, both of which place the first
	         * (largest, if sorted) slice with its left edge at 12 o'clock but
	         * succeeding slices follow either cw or ccw from there.
	         *
	         * see http://visage.co/data-visualization-101-pie-charts/
	         */
	        valType: 'enumerated',
	        values: ['clockwise', 'counterclockwise'],
	        
	        dflt: 'counterclockwise',
	        editType: 'calc',
	        
	    },
	    rotation: {
	        valType: 'number',
	        
	        min: -360,
	        max: 360,
	        dflt: 0,
	        editType: 'calc',
	        
	    },
	
	    pull: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 0,
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	
	    _deprecated: {
	        title: {
	            valType: 'string',
	            dflt: '',
	            
	            editType: 'calc',
	            
	        },
	        titlefont: extendFlat({}, textFontAttrs, {
	            
	        }),
	        titleposition: {
	            valType: 'enumerated',
	            values: [
	                'top left', 'top center', 'top right',
	                'middle center',
	                'bottom left', 'bottom center', 'bottom right'
	            ],
	            
	            editType: 'calc',
	            
	        }
	    }
	};
	
	},{"../../components/color/attributes":590,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/domain":789,"../../plots/font_attributes":790,"../../plots/template_attributes":840}],1093:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var plots = _dereq_('../../plots/plots');
	
	exports.name = 'pie';
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	};
	
	},{"../../plots/plots":825}],1094:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var tinycolor = _dereq_('tinycolor2');
	
	var Color = _dereq_('../../components/color');
	
	var extendedColorWayList = {};
	
	function calc(gd, trace) {
	    var cd = [];
	
	    var fullLayout = gd._fullLayout;
	    var hiddenLabels = fullLayout.hiddenlabels || [];
	
	    var labels = trace.labels;
	    var colors = trace.marker.colors || [];
	    var vals = trace.values;
	    var hasVals = isArrayOrTypedArray(vals) && vals.length;
	
	    var i, pt;
	
	    if(trace.dlabel) {
	        labels = new Array(vals.length);
	        for(i = 0; i < vals.length; i++) {
	            labels[i] = String(trace.label0 + i * trace.dlabel);
	        }
	    }
	
	    var allThisTraceLabels = {};
	    var pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
	    var seriesLen = (hasVals ? vals : labels).length;
	    var vTotal = 0;
	    var isAggregated = false;
	
	    for(i = 0; i < seriesLen; i++) {
	        var v, label, hidden;
	        if(hasVals) {
	            v = vals[i];
	            if(!isNumeric(v)) continue;
	            v = +v;
	            if(v < 0) continue;
	        } else v = 1;
	
	        label = labels[i];
	        if(label === undefined || label === '') label = i;
	        label = String(label);
	
	        var thisLabelIndex = allThisTraceLabels[label];
	        if(thisLabelIndex === undefined) {
	            allThisTraceLabels[label] = cd.length;
	
	            hidden = hiddenLabels.indexOf(label) !== -1;
	
	            if(!hidden) vTotal += v;
	
	            cd.push({
	                v: v,
	                label: label,
	                color: pullColor(colors[i], label),
	                i: i,
	                pts: [i],
	                hidden: hidden
	            });
	        } else {
	            isAggregated = true;
	
	            pt = cd[thisLabelIndex];
	            pt.v += v;
	            pt.pts.push(i);
	            if(!pt.hidden) vTotal += v;
	
	            if(pt.color === false && colors[i]) {
	                pt.color = pullColor(colors[i], label);
	            }
	        }
	    }
	
	    var shouldSort = (trace.type === 'funnelarea') ? isAggregated : trace.sort;
	    if(shouldSort) cd.sort(function(a, b) { return b.v - a.v; });
	
	    // include the sum of all values in the first point
	    if(cd[0]) cd[0].vTotal = vTotal;
	
	    return cd;
	}
	
	function makePullColorFn(colorMap) {
	    return function pullColor(color, id) {
	        if(!color) return false;
	
	        color = tinycolor(color);
	        if(!color.isValid()) return false;
	
	        color = Color.addOpacity(color, color.getAlpha());
	        if(!colorMap[id]) colorMap[id] = color;
	
	        return color;
	    };
	}
	
	/*
	 * `calc` filled in (and collated) explicit colors.
	 * Now we need to propagate these explicit colors to other traces,
	 * and fill in default colors.
	 * This is done after sorting, so we pick defaults
	 * in the order slices will be displayed
	 */
	function crossTraceCalc(gd, plotinfo) { // TODO: should we name the second argument opts?
	    var desiredType = (plotinfo || {}).type;
	    if(!desiredType) desiredType = 'pie';
	
	    var fullLayout = gd._fullLayout;
	    var calcdata = gd.calcdata;
	    var colorWay = fullLayout[desiredType + 'colorway'];
	    var colorMap = fullLayout['_' + desiredType + 'colormap'];
	
	    if(fullLayout['extend' + desiredType + 'colors']) {
	        colorWay = generateExtendedColors(colorWay, extendedColorWayList);
	    }
	    var dfltColorCount = 0;
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var traceType = cd[0].trace.type;
	        if(traceType !== desiredType) continue;
	
	        for(var j = 0; j < cd.length; j++) {
	            var pt = cd[j];
	            if(pt.color === false) {
	                // have we seen this label and assigned a color to it in a previous trace?
	                if(colorMap[pt.label]) {
	                    pt.color = colorMap[pt.label];
	                } else {
	                    colorMap[pt.label] = pt.color = colorWay[dfltColorCount % colorWay.length];
	                    dfltColorCount++;
	                }
	            }
	        }
	    }
	}
	
	/**
	 * pick a default color from the main default set, augmented by
	 * itself lighter then darker before repeating
	 */
	function generateExtendedColors(colorList, extendedColorWays) {
	    var i;
	    var colorString = JSON.stringify(colorList);
	    var colors = extendedColorWays[colorString];
	    if(!colors) {
	        colors = colorList.slice();
	
	        for(i = 0; i < colorList.length; i++) {
	            colors.push(tinycolor(colorList[i]).lighten(20).toHexString());
	        }
	
	        for(i = 0; i < colorList.length; i++) {
	            colors.push(tinycolor(colorList[i]).darken(20).toHexString());
	        }
	        extendedColorWays[colorString] = colors;
	    }
	
	    return colors;
	}
	
	module.exports = {
	    calc: calc,
	    crossTraceCalc: crossTraceCalc,
	
	    makePullColorFn: makePullColorFn,
	    generateExtendedColors: generateExtendedColors
	};
	
	},{"../../components/color":591,"../../lib":716,"fast-isnumeric":227,"tinycolor2":535}],1095:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len;
	    var vals = coerce('values');
	    var hasVals = Lib.isArrayOrTypedArray(vals);
	    var labels = coerce('labels');
	    if(Array.isArray(labels)) {
	        len = labels.length;
	        if(hasVals) len = Math.min(len, vals.length);
	    } else if(hasVals) {
	        len = vals.length;
	
	        coerce('label0');
	        coerce('dlabel');
	    }
	
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	    traceOut._length = len;
	
	    var lineWidth = coerce('marker.line.width');
	    if(lineWidth) coerce('marker.line.color');
	
	    coerce('marker.colors');
	
	    coerce('scalegroup');
	    // TODO: hole needs to be coerced to the same value within a scaleegroup
	
	    var textData = coerce('text');
	    var textTemplate = coerce('texttemplate');
	    var textInfo;
	    if(!textTemplate) textInfo = coerce('textinfo', Array.isArray(textData) ? 'text+percent' : 'percent');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    if(textTemplate || (textInfo && textInfo !== 'none')) {
	        var textposition = coerce('textposition');
	        handleText(traceIn, traceOut, layout, coerce, textposition, {
	            moduleHasSelected: false,
	            moduleHasUnselected: false,
	            moduleHasConstrain: false,
	            moduleHasCliponaxis: false,
	            moduleHasTextangle: false,
	            moduleHasInsideanchor: false
	        });
	
	        var hasBoth = Array.isArray(textposition) || textposition === 'auto';
	        var hasOutside = hasBoth || textposition === 'outside';
	        if(hasOutside) {
	            coerce('automargin');
	        }
	    }
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    var hole = coerce('hole');
	    var title = coerce('title.text');
	    if(title) {
	        var titlePosition = coerce('title.position', hole ? 'middle center' : 'top center');
	        if(!hole && titlePosition === 'middle center') traceOut.title.position = 'top center';
	        Lib.coerceFont(coerce, 'title.font', layout.font);
	    }
	
	    coerce('sort');
	    coerce('direction');
	    coerce('rotation');
	    coerce('pull');
	};
	
	},{"../../lib":716,"../../plots/domain":789,"../bar/defaults":859,"./attributes":1092}],1096:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var appendArrayMultiPointValues = _dereq_('../../components/fx/helpers').appendArrayMultiPointValues;
	
	// Note: like other eventData routines, this creates the data for hover/unhover/click events
	// but it has a different API and goes through a totally different pathway.
	// So to ensure it doesn't get misused, it's not attached to the Pie module.
	module.exports = function eventData(pt, trace) {
	    var out = {
	        curveNumber: trace.index,
	        pointNumbers: pt.pts,
	        data: trace._input,
	        fullData: trace,
	        label: pt.label,
	        color: pt.color,
	        value: pt.v,
	        percent: pt.percent,
	        text: pt.text,
	
	        // pt.v (and pt.i below) for backward compatibility
	        v: pt.v
	    };
	
	    // Only include pointNumber if it's unambiguous
	    if(pt.pts.length === 1) out.pointNumber = out.i = pt.pts[0];
	
	    // Add extra data arrays to the output
	    // notice that this is the multi-point version ('s' on the end!)
	    // so added data will be arrays matching the pointNumbers array.
	    appendArrayMultiPointValues(out, trace, pt.pts);
	
	    // don't include obsolete fields in new funnelarea traces
	    if(trace.type === 'funnelarea') {
	        delete out.v;
	        delete out.i;
	    }
	
	    return out;
	};
	
	},{"../../components/fx/helpers":626}],1097:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	exports.formatPiePercent = function formatPiePercent(v, separators) {
	    var vRounded = (v * 100).toPrecision(3);
	    if(vRounded.lastIndexOf('.') !== -1) {
	        vRounded = vRounded.replace(/[.]?0+$/, '');
	    }
	    return Lib.numSeparate(vRounded, separators) + '%';
	};
	
	exports.formatPieValue = function formatPieValue(v, separators) {
	    var vRounded = v.toPrecision(10);
	    if(vRounded.lastIndexOf('.') !== -1) {
	        vRounded = vRounded.replace(/[.]?0+$/, '');
	    }
	    return Lib.numSeparate(vRounded, separators);
	};
	
	exports.getFirstFilled = function getFirstFilled(array, indices) {
	    if(!Array.isArray(array)) return;
	    for(var i = 0; i < indices.length; i++) {
	        var v = array[indices[i]];
	        if(v || v === 0 || v === '') return v;
	    }
	};
	
	exports.castOption = function castOption(item, indices) {
	    if(Array.isArray(item)) return exports.getFirstFilled(item, indices);
	    else if(item) return item;
	};
	
	},{"../../lib":716}],1098:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./calc').crossTraceCalc,
	
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style'),
	    styleOne: _dereq_('./style_one'),
	
	    moduleType: 'trace',
	    name: 'pie',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['pie-like', 'pie', 'showLegend'],
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1092,"./base_plot":1093,"./calc":1094,"./defaults":1095,"./layout_attributes":1099,"./layout_defaults":1100,"./plot":1101,"./style":1102,"./style_one":1103}],1099:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    hiddenlabels: {
	        valType: 'data_array',
	        
	        editType: 'calc',
	        
	    },
	    piecolorway: {
	        valType: 'colorlist',
	        
	        editType: 'calc',
	        
	    },
	    extendpiecolors: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],1100:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    coerce('hiddenlabels');
	    coerce('piecolorway', layoutOut.colorway);
	    coerce('extendpiecolors');
	};
	
	},{"../../lib":716,"./layout_attributes":1099}],1101:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Plots = _dereq_('../../plots/plots');
	var Fx = _dereq_('../../components/fx');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var helpers = _dereq_('./helpers');
	var eventData = _dereq_('./event_data');
	var isValidTextValue = _dereq_('../../lib').isValidTextValue;
	
	function plot(gd, cdModule) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	
	    prerenderTitles(cdModule, gd);
	    layoutAreas(cdModule, gs);
	
	    var plotGroups = Lib.makeTraceGroups(fullLayout._pielayer, cdModule, 'trace').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        setCoords(cd);
	
	        // TODO: miter might look better but can sometimes cause problems
	        // maybe miter with a small-ish stroke-miterlimit?
	        plotGroup.attr('stroke-linejoin', 'round');
	
	        plotGroup.each(function() {
	            var slices = d3.select(this).selectAll('g.slice').data(cd);
	
	            slices.enter().append('g')
	                .classed('slice', true);
	            slices.exit().remove();
	
	            var quadrants = [
	                [[], []], // y<0: x<0, x>=0
	                [[], []] // y>=0: x<0, x>=0
	            ];
	            var hasOutsideText = false;
	
	            slices.each(function(pt) {
	                if(pt.hidden) {
	                    d3.select(this).selectAll('path,g').remove();
	                    return;
	                }
	
	                // to have consistent event data compared to other traces
	                pt.pointNumber = pt.i;
	                pt.curveNumber = trace.index;
	
	                quadrants[pt.pxmid[1] < 0 ? 0 : 1][pt.pxmid[0] < 0 ? 0 : 1].push(pt);
	
	                var cx = cd0.cx;
	                var cy = cd0.cy;
	                var sliceTop = d3.select(this);
	                var slicePath = sliceTop.selectAll('path.surface').data([pt]);
	
	                slicePath.enter().append('path')
	                    .classed('surface', true)
	                    .style({'pointer-events': 'all'});
	
	                sliceTop.call(attachFxHandlers, gd, cd);
	
	                if(trace.pull) {
	                    var pull = +helpers.castOption(trace.pull, pt.pts) || 0;
	                    if(pull > 0) {
	                        cx += pull * pt.pxmid[0];
	                        cy += pull * pt.pxmid[1];
	                    }
	                }
	
	                pt.cxFinal = cx;
	                pt.cyFinal = cy;
	
	                function arc(start, finish, cw, scale) {
	                    var dx = scale * (finish[0] - start[0]);
	                    var dy = scale * (finish[1] - start[1]);
	
	                    return 'a' +
	                        (scale * cd0.r) + ',' + (scale * cd0.r) + ' 0 ' +
	                        pt.largeArc + (cw ? ' 1 ' : ' 0 ') + dx + ',' + dy;
	                }
	
	                var hole = trace.hole;
	                if(pt.v === cd0.vTotal) { // 100% fails bcs arc start and end are identical
	                    var outerCircle = 'M' + (cx + pt.px0[0]) + ',' + (cy + pt.px0[1]) +
	                        arc(pt.px0, pt.pxmid, true, 1) +
	                        arc(pt.pxmid, pt.px0, true, 1) + 'Z';
	                    if(hole) {
	                        slicePath.attr('d',
	                            'M' + (cx + hole * pt.px0[0]) + ',' + (cy + hole * pt.px0[1]) +
	                            arc(pt.px0, pt.pxmid, false, hole) +
	                            arc(pt.pxmid, pt.px0, false, hole) +
	                            'Z' + outerCircle);
	                    } else slicePath.attr('d', outerCircle);
	                } else {
	                    var outerArc = arc(pt.px0, pt.px1, true, 1);
	
	                    if(hole) {
	                        var rim = 1 - hole;
	                        slicePath.attr('d',
	                            'M' + (cx + hole * pt.px1[0]) + ',' + (cy + hole * pt.px1[1]) +
	                            arc(pt.px1, pt.px0, false, hole) +
	                            'l' + (rim * pt.px0[0]) + ',' + (rim * pt.px0[1]) +
	                            outerArc +
	                            'Z');
	                    } else {
	                        slicePath.attr('d',
	                            'M' + cx + ',' + cy +
	                            'l' + pt.px0[0] + ',' + pt.px0[1] +
	                            outerArc +
	                            'Z');
	                    }
	                }
	
	                // add text
	                formatSliceLabel(gd, pt, cd0);
	                var textPosition = helpers.castOption(trace.textposition, pt.pts);
	                var sliceTextGroup = sliceTop.selectAll('g.slicetext')
	                    .data(pt.text && (textPosition !== 'none') ? [0] : []);
	
	                sliceTextGroup.enter().append('g')
	                    .classed('slicetext', true);
	                sliceTextGroup.exit().remove();
	
	                sliceTextGroup.each(function() {
	                    var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
	                        // prohibit tex interpretation until we can handle
	                        // tex and regular text together
	                        s.attr('data-notex', 1);
	                    });
	
	                    sliceText.text(pt.text)
	                        .attr({
	                            'class': 'slicetext',
	                            transform: '',
	                            'text-anchor': 'middle'
	                        })
	                        .call(Drawing.font, textPosition === 'outside' ?
	                          determineOutsideTextFont(trace, pt, gd._fullLayout.font) :
	                          determineInsideTextFont(trace, pt, gd._fullLayout.font))
	                        .call(svgTextUtils.convertToTspans, gd);
	
	                    // position the text relative to the slice
	                    var textBB = Drawing.bBox(sliceText.node());
	                    var transform;
	
	                    if(textPosition === 'outside') {
	                        transform = transformOutsideText(textBB, pt);
	                    } else {
	                        transform = transformInsideText(textBB, pt, cd0);
	                        if(textPosition === 'auto' && transform.scale < 1) {
	                            sliceText.call(Drawing.font, trace.outsidetextfont);
	                            if(trace.outsidetextfont.family !== trace.insidetextfont.family ||
	                                    trace.outsidetextfont.size !== trace.insidetextfont.size) {
	                                textBB = Drawing.bBox(sliceText.node());
	                            }
	                            transform = transformOutsideText(textBB, pt);
	                        }
	                    }
	
	                    var translateX = cx + pt.pxmid[0] * transform.rCenter + (transform.x || 0);
	                    var translateY = cy + pt.pxmid[1] * transform.rCenter + (transform.y || 0);
	
	                    // save some stuff to use later ensure no labels overlap
	                    if(transform.outside) {
	                        pt.yLabelMin = translateY - textBB.height / 2;
	                        pt.yLabelMid = translateY;
	                        pt.yLabelMax = translateY + textBB.height / 2;
	                        pt.labelExtraX = 0;
	                        pt.labelExtraY = 0;
	                        hasOutsideText = true;
	                    }
	
	                    sliceText.attr('transform',
	                        'translate(' + translateX + ',' + translateY + ')' +
	                        (transform.scale < 1 ? ('scale(' + transform.scale + ')') : '') +
	                        (transform.rotate ? ('rotate(' + transform.rotate + ')') : '') +
	                        'translate(' +
	                            (-(textBB.left + textBB.right) / 2) + ',' +
	                            (-(textBB.top + textBB.bottom) / 2) +
	                        ')');
	                });
	            });
	
	            // add the title
	            var titleTextGroup = d3.select(this).selectAll('g.titletext')
	                .data(trace.title.text ? [0] : []);
	
	            titleTextGroup.enter().append('g')
	                .classed('titletext', true);
	            titleTextGroup.exit().remove();
	
	            titleTextGroup.each(function() {
	                var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
	                    // prohibit tex interpretation as above
	                    s.attr('data-notex', 1);
	                });
	
	                var txt = trace.title.text;
	                if(trace._meta) {
	                    txt = Lib.templateString(txt, trace._meta);
	                }
	
	                titleText.text(txt)
	                    .attr({
	                        'class': 'titletext',
	                        transform: '',
	                        'text-anchor': 'middle',
	                    })
	                .call(Drawing.font, trace.title.font)
	                .call(svgTextUtils.convertToTspans, gd);
	
	                var transform;
	
	                if(trace.title.position === 'middle center') {
	                    transform = positionTitleInside(cd0);
	                } else {
	                    transform = positionTitleOutside(cd0, gs);
	                }
	
	                titleText.attr('transform',
	                    'translate(' + transform.x + ',' + transform.y + ')' +
	                    (transform.scale < 1 ? ('scale(' + transform.scale + ')') : '') +
	                    'translate(' + transform.tx + ',' + transform.ty + ')');
	            });
	
	            // now make sure no labels overlap (at least within one pie)
	            if(hasOutsideText) scootLabels(quadrants, trace);
	
	            plotTextLines(slices, trace);
	
	            if(hasOutsideText && trace.automargin) {
	                // TODO if we ever want to improve perf,
	                // we could reuse the textBB computed above together
	                // with the sliceText transform info
	                var traceBbox = Drawing.bBox(plotGroup.node());
	
	                var domain = trace.domain;
	                var vpw = gs.w * (domain.x[1] - domain.x[0]);
	                var vph = gs.h * (domain.y[1] - domain.y[0]);
	                var xgap = (0.5 * vpw - cd0.r) / gs.w;
	                var ygap = (0.5 * vph - cd0.r) / gs.h;
	
	                Plots.autoMargin(gd, 'pie.' + trace.uid + '.automargin', {
	                    xl: domain.x[0] - xgap,
	                    xr: domain.x[1] + xgap,
	                    yb: domain.y[0] - ygap,
	                    yt: domain.y[1] + ygap,
	                    l: Math.max(cd0.cx - cd0.r - traceBbox.left, 0),
	                    r: Math.max(traceBbox.right - (cd0.cx + cd0.r), 0),
	                    b: Math.max(traceBbox.bottom - (cd0.cy + cd0.r), 0),
	                    t: Math.max(cd0.cy - cd0.r - traceBbox.top, 0),
	                    pad: 5
	                });
	            }
	        });
	    });
	
	    // This is for a bug in Chrome (as of 2015-07-22, and does not affect FF)
	    // if insidetextfont and outsidetextfont are different sizes, sometimes the size
	    // of an "em" gets taken from the wrong element at first so lines are
	    // spaced wrong. You just have to tell it to try again later and it gets fixed.
	    // I have no idea why we haven't seen this in other contexts. Also, sometimes
	    // it gets the initial draw correct but on redraw it gets confused.
	    setTimeout(function() {
	        plotGroups.selectAll('tspan').each(function() {
	            var s = d3.select(this);
	            if(s.attr('dy')) s.attr('dy', s.attr('dy'));
	        });
	    }, 0);
	}
	
	// TODO add support for transition
	function plotTextLines(slices, trace) {
	    slices.each(function(pt) {
	        var sliceTop = d3.select(this);
	
	        if(!pt.labelExtraX && !pt.labelExtraY) {
	            sliceTop.select('path.textline').remove();
	            return;
	        }
	
	        // first move the text to its new location
	        var sliceText = sliceTop.select('g.slicetext text');
	
	        sliceText.attr('transform', 'translate(' + pt.labelExtraX + ',' + pt.labelExtraY + ')' +
	            sliceText.attr('transform'));
	
	        // then add a line to the new location
	        var lineStartX = pt.cxFinal + pt.pxmid[0];
	        var lineStartY = pt.cyFinal + pt.pxmid[1];
	        var textLinePath = 'M' + lineStartX + ',' + lineStartY;
	        var finalX = (pt.yLabelMax - pt.yLabelMin) * (pt.pxmid[0] < 0 ? -1 : 1) / 4;
	
	        if(pt.labelExtraX) {
	            var yFromX = pt.labelExtraX * pt.pxmid[1] / pt.pxmid[0];
	            var yNet = pt.yLabelMid + pt.labelExtraY - (pt.cyFinal + pt.pxmid[1]);
	
	            if(Math.abs(yFromX) > Math.abs(yNet)) {
	                textLinePath +=
	                    'l' + (yNet * pt.pxmid[0] / pt.pxmid[1]) + ',' + yNet +
	                    'H' + (lineStartX + pt.labelExtraX + finalX);
	            } else {
	                textLinePath += 'l' + pt.labelExtraX + ',' + yFromX +
	                    'v' + (yNet - yFromX) +
	                    'h' + finalX;
	            }
	        } else {
	            textLinePath +=
	                'V' + (pt.yLabelMid + pt.labelExtraY) +
	                'h' + finalX;
	        }
	
	        Lib.ensureSingle(sliceTop, 'path', 'textline')
	            .call(Color.stroke, trace.outsidetextfont.color)
	            .attr({
	                'stroke-width': Math.min(2, trace.outsidetextfont.size / 8),
	                d: textLinePath,
	                fill: 'none'
	            });
	    });
	}
	
	function attachFxHandlers(sliceTop, gd, cd) {
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var cx = cd0.cx;
	    var cy = cd0.cy;
	
	    // hover state vars
	    // have we drawn a hover label, so it should be cleared later
	    if(!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
	    // have we emitted a hover event, so later an unhover event should be emitted
	    // note that click events do not depend on this - you can still get them
	    // with hovermode: false or if you were earlier dragging, then clicked
	    // in the same slice that you moused up in
	    if(!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
	
	    sliceTop.on('mouseover', function(pt) {
	        // in case fullLayout or fullData has changed without a replot
	        var fullLayout2 = gd._fullLayout;
	        var trace2 = gd._fullData[trace.index];
	
	        if(gd._dragging || fullLayout2.hovermode === false) return;
	
	        var hoverinfo = trace2.hoverinfo;
	        if(Array.isArray(hoverinfo)) {
	            // super hacky: we need to pull out the *first* hoverinfo from
	            // pt.pts, then put it back into an array in a dummy trace
	            // and call castHoverinfo on that.
	            // TODO: do we want to have Fx.castHoverinfo somehow handle this?
	            // it already takes an array for index, for 2D, so this seems tricky.
	            hoverinfo = Fx.castHoverinfo({
	                hoverinfo: [helpers.castOption(hoverinfo, pt.pts)],
	                _module: trace._module
	            }, fullLayout2, 0);
	        }
	
	        if(hoverinfo === 'all') hoverinfo = 'label+text+value+percent+name';
	
	        // in case we dragged over the pie from another subplot,
	        // or if hover is turned off
	        if(trace2.hovertemplate || (hoverinfo !== 'none' && hoverinfo !== 'skip' && hoverinfo)) {
	            var rInscribed = pt.rInscribed || 0;
	            var hoverCenterX = cx + pt.pxmid[0] * (1 - rInscribed);
	            var hoverCenterY = cy + pt.pxmid[1] * (1 - rInscribed);
	            var separators = fullLayout2.separators;
	            var text = [];
	
	            if(hoverinfo && hoverinfo.indexOf('label') !== -1) text.push(pt.label);
	            pt.text = helpers.castOption(trace2.hovertext || trace2.text, pt.pts);
	            if(hoverinfo && hoverinfo.indexOf('text') !== -1) {
	                var tx = pt.text;
	                if(Lib.isValidTextValue(tx)) text.push(tx);
	            }
	            pt.value = pt.v;
	            pt.valueLabel = helpers.formatPieValue(pt.v, separators);
	            if(hoverinfo && hoverinfo.indexOf('value') !== -1) text.push(pt.valueLabel);
	            pt.percent = pt.v / cd0.vTotal;
	            pt.percentLabel = helpers.formatPiePercent(pt.percent, separators);
	            if(hoverinfo && hoverinfo.indexOf('percent') !== -1) text.push(pt.percentLabel);
	
	            var hoverLabel = trace2.hoverlabel;
	            var hoverFont = hoverLabel.font;
	
	            Fx.loneHover({
	                trace: trace,
	                x0: hoverCenterX - rInscribed * cd0.r,
	                x1: hoverCenterX + rInscribed * cd0.r,
	                y: hoverCenterY,
	                text: text.join('<br>'),
	                name: (trace2.hovertemplate || hoverinfo.indexOf('name') !== -1) ? trace2.name : undefined,
	                idealAlign: pt.pxmid[0] < 0 ? 'left' : 'right',
	                color: helpers.castOption(hoverLabel.bgcolor, pt.pts) || pt.color,
	                borderColor: helpers.castOption(hoverLabel.bordercolor, pt.pts),
	                fontFamily: helpers.castOption(hoverFont.family, pt.pts),
	                fontSize: helpers.castOption(hoverFont.size, pt.pts),
	                fontColor: helpers.castOption(hoverFont.color, pt.pts),
	                nameLength: helpers.castOption(hoverLabel.namelength, pt.pts),
	                textAlign: helpers.castOption(hoverLabel.align, pt.pts),
	                hovertemplate: helpers.castOption(trace2.hovertemplate, pt.pts),
	                hovertemplateLabels: pt,
	                eventData: [eventData(pt, trace2)]
	            }, {
	                container: fullLayout2._hoverlayer.node(),
	                outerContainer: fullLayout2._paper.node(),
	                gd: gd
	            });
	
	            trace._hasHoverLabel = true;
	        }
	
	        trace._hasHoverEvent = true;
	        gd.emit('plotly_hover', {
	            points: [eventData(pt, trace2)],
	            event: d3.event
	        });
	    });
	
	    sliceTop.on('mouseout', function(evt) {
	        var fullLayout2 = gd._fullLayout;
	        var trace2 = gd._fullData[trace.index];
	        var pt = d3.select(this).datum();
	
	        if(trace._hasHoverEvent) {
	            evt.originalEvent = d3.event;
	            gd.emit('plotly_unhover', {
	                points: [eventData(pt, trace2)],
	                event: d3.event
	            });
	            trace._hasHoverEvent = false;
	        }
	
	        if(trace._hasHoverLabel) {
	            Fx.loneUnhover(fullLayout2._hoverlayer.node());
	            trace._hasHoverLabel = false;
	        }
	    });
	
	    sliceTop.on('click', function(pt) {
	        // TODO: this does not support right-click. If we want to support it, we
	        // would likely need to change pie to use dragElement instead of straight
	        // mapbox event binding. Or perhaps better, make a simple wrapper with the
	        // right mousedown, mousemove, and mouseup handlers just for a left/right click
	        // mapbox would use this too.
	        var fullLayout2 = gd._fullLayout;
	        var trace2 = gd._fullData[trace.index];
	
	        if(gd._dragging || fullLayout2.hovermode === false) return;
	
	        gd._hoverdata = [eventData(pt, trace2)];
	        Fx.click(gd, d3.event);
	    });
	}
	
	function determineOutsideTextFont(trace, pt, layoutFont) {
	    var color =
	        helpers.castOption(trace.outsidetextfont.color, pt.pts) ||
	        helpers.castOption(trace.textfont.color, pt.pts) ||
	        layoutFont.color;
	
	    var family =
	        helpers.castOption(trace.outsidetextfont.family, pt.pts) ||
	        helpers.castOption(trace.textfont.family, pt.pts) ||
	        layoutFont.family;
	
	    var size =
	        helpers.castOption(trace.outsidetextfont.size, pt.pts) ||
	        helpers.castOption(trace.textfont.size, pt.pts) ||
	        layoutFont.size;
	
	    return {
	        color: color,
	        family: family,
	        size: size
	    };
	}
	
	function determineInsideTextFont(trace, pt, layoutFont) {
	    var customColor = helpers.castOption(trace.insidetextfont.color, pt.pts);
	    if(!customColor && trace._input.textfont) {
	        // Why not simply using trace.textfont? Because if not set, it
	        // defaults to layout.font which has a default color. But if
	        // textfont.color and insidetextfont.color don't supply a value,
	        // a contrasting color shall be used.
	        customColor = helpers.castOption(trace._input.textfont.color, pt.pts);
	    }
	
	    var family =
	        helpers.castOption(trace.insidetextfont.family, pt.pts) ||
	        helpers.castOption(trace.textfont.family, pt.pts) ||
	        layoutFont.family;
	
	    var size =
	        helpers.castOption(trace.insidetextfont.size, pt.pts) ||
	        helpers.castOption(trace.textfont.size, pt.pts) ||
	        layoutFont.size;
	
	    return {
	        color: customColor || Color.contrast(pt.color),
	        family: family,
	        size: size
	    };
	}
	
	function prerenderTitles(cdModule, gd) {
	    var cd0, trace;
	
	    // Determine the width and height of the title for each pie.
	    for(var i = 0; i < cdModule.length; i++) {
	        cd0 = cdModule[i][0];
	        trace = cd0.trace;
	
	        if(trace.title.text) {
	            var txt = trace.title.text;
	            if(trace._meta) {
	                txt = Lib.templateString(txt, trace._meta);
	            }
	
	            var dummyTitle = Drawing.tester.append('text')
	              .attr('data-notex', 1)
	              .text(txt)
	              .call(Drawing.font, trace.title.font)
	              .call(svgTextUtils.convertToTspans, gd);
	            var bBox = Drawing.bBox(dummyTitle.node(), true);
	            cd0.titleBox = {
	                width: bBox.width,
	                height: bBox.height,
	            };
	            dummyTitle.remove();
	        }
	    }
	}
	
	function transformInsideText(textBB, pt, cd0) {
	    var textDiameter = Math.sqrt(textBB.width * textBB.width + textBB.height * textBB.height);
	    var textAspect = textBB.width / textBB.height;
	    var halfAngle = pt.halfangle;
	    var ring = pt.ring;
	    var rInscribed = pt.rInscribed;
	    var r = cd0.r || pt.rpx1;
	
	    // max size text can be inserted inside without rotating it
	    // this inscribes the text rectangle in a circle, which is then inscribed
	    // in the slice, so it will be an underestimate, which some day we may want
	    // to improve so this case can get more use
	    var transform = {
	        scale: rInscribed * r * 2 / textDiameter,
	
	        // and the center position and rotation in this case
	        rCenter: 1 - rInscribed,
	        rotate: 0
	    };
	
	    if(transform.scale >= 1) return transform;
	
	    // max size if text is rotated radially
	    var Qr = textAspect + 1 / (2 * Math.tan(halfAngle));
	    var maxHalfHeightRotRadial = r * Math.min(
	        1 / (Math.sqrt(Qr * Qr + 0.5) + Qr),
	        ring / (Math.sqrt(textAspect * textAspect + ring / 2) + textAspect)
	    );
	    var radialTransform = {
	        scale: maxHalfHeightRotRadial * 2 / textBB.height,
	        rCenter: Math.cos(maxHalfHeightRotRadial / r) -
	            maxHalfHeightRotRadial * textAspect / r,
	        rotate: (180 / Math.PI * pt.midangle + 720) % 180 - 90
	    };
	
	    // max size if text is rotated tangentially
	    var aspectInv = 1 / textAspect;
	    var Qt = aspectInv + 1 / (2 * Math.tan(halfAngle));
	    var maxHalfWidthTangential = r * Math.min(
	        1 / (Math.sqrt(Qt * Qt + 0.5) + Qt),
	        ring / (Math.sqrt(aspectInv * aspectInv + ring / 2) + aspectInv)
	    );
	    var tangentialTransform = {
	        scale: maxHalfWidthTangential * 2 / textBB.width,
	        rCenter: Math.cos(maxHalfWidthTangential / r) -
	            maxHalfWidthTangential / textAspect / r,
	        rotate: (180 / Math.PI * pt.midangle + 810) % 180 - 90
	    };
	    // if we need a rotated transform, pick the biggest one
	    // even if both are bigger than 1
	    var rotatedTransform = tangentialTransform.scale > radialTransform.scale ?
	            tangentialTransform : radialTransform;
	
	    if(transform.scale < 1 && rotatedTransform.scale > transform.scale) return rotatedTransform;
	    return transform;
	}
	
	function getInscribedRadiusFraction(pt, cd0) {
	    if(pt.v === cd0.vTotal && !cd0.trace.hole) return 1;// special case of 100% with no hole
	
	    return Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2);
	}
	
	function transformOutsideText(textBB, pt) {
	    var x = pt.pxmid[0];
	    var y = pt.pxmid[1];
	    var dx = textBB.width / 2;
	    var dy = textBB.height / 2;
	
	    if(x < 0) dx *= -1;
	    if(y < 0) dy *= -1;
	
	    return {
	        scale: 1,
	        rCenter: 1,
	        rotate: 0,
	        x: dx + Math.abs(dy) * (dx > 0 ? 1 : -1) / 2,
	        y: dy / (1 + x * x / (y * y)),
	        outside: true
	    };
	}
	
	function positionTitleInside(cd0) {
	    var textDiameter =
	        Math.sqrt(cd0.titleBox.width * cd0.titleBox.width + cd0.titleBox.height * cd0.titleBox.height);
	    return {
	        x: cd0.cx,
	        y: cd0.cy,
	        scale: cd0.trace.hole * cd0.r * 2 / textDiameter,
	        tx: 0,
	        ty: - cd0.titleBox.height / 2 + cd0.trace.title.font.size
	    };
	}
	
	function positionTitleOutside(cd0, plotSize) {
	    var scaleX = 1;
	    var scaleY = 1;
	    var maxPull;
	
	    var trace = cd0.trace;
	    // position of the baseline point of the text box in the plot, before scaling.
	    // we anchored the text in the middle, so the baseline is on the bottom middle
	    // of the first line of text.
	    var topMiddle = {
	        x: cd0.cx,
	        y: cd0.cy
	    };
	    // relative translation of the text box after scaling
	    var translate = {
	        tx: 0,
	        ty: 0
	    };
	
	    // we reason below as if the baseline is the top middle point of the text box.
	    // so we must add the font size to approximate the y-coord. of the top.
	    // note that this correction must happen after scaling.
	    translate.ty += trace.title.font.size;
	    maxPull = getMaxPull(trace);
	
	    if(trace.title.position.indexOf('top') !== -1) {
	        topMiddle.y -= (1 + maxPull) * cd0.r;
	        translate.ty -= cd0.titleBox.height;
	    } else if(trace.title.position.indexOf('bottom') !== -1) {
	        topMiddle.y += (1 + maxPull) * cd0.r;
	    }
	
	    var rx = applyAspectRatio(cd0.r, cd0.trace.aspectratio);
	
	    var maxWidth = plotSize.w * (trace.domain.x[1] - trace.domain.x[0]) / 2;
	    if(trace.title.position.indexOf('left') !== -1) {
	        // we start the text at the left edge of the pie
	        maxWidth = maxWidth + rx;
	        topMiddle.x -= (1 + maxPull) * rx;
	        translate.tx += cd0.titleBox.width / 2;
	    } else if(trace.title.position.indexOf('center') !== -1) {
	        maxWidth *= 2;
	    } else if(trace.title.position.indexOf('right') !== -1) {
	        maxWidth = maxWidth + rx;
	        topMiddle.x += (1 + maxPull) * rx;
	        translate.tx -= cd0.titleBox.width / 2;
	    }
	    scaleX = maxWidth / cd0.titleBox.width;
	    scaleY = getTitleSpace(cd0, plotSize) / cd0.titleBox.height;
	    return {
	        x: topMiddle.x,
	        y: topMiddle.y,
	        scale: Math.min(scaleX, scaleY),
	        tx: translate.tx,
	        ty: translate.ty
	    };
	}
	
	function applyAspectRatio(x, aspectratio) {
	    return x / ((aspectratio === undefined) ? 1 : aspectratio);
	}
	
	function getTitleSpace(cd0, plotSize) {
	    var trace = cd0.trace;
	    var pieBoxHeight = plotSize.h * (trace.domain.y[1] - trace.domain.y[0]);
	    // use at most half of the plot for the title
	    return Math.min(cd0.titleBox.height, pieBoxHeight / 2);
	}
	
	function getMaxPull(trace) {
	    var maxPull = trace.pull;
	    if(!maxPull) return 0;
	
	    var j;
	    if(Array.isArray(maxPull)) {
	        maxPull = 0;
	        for(j = 0; j < trace.pull.length; j++) {
	            if(trace.pull[j] > maxPull) maxPull = trace.pull[j];
	        }
	    }
	    return maxPull;
	}
	
	function scootLabels(quadrants, trace) {
	    var xHalf, yHalf, equatorFirst, farthestX, farthestY,
	        xDiffSign, yDiffSign, thisQuad, oppositeQuad,
	        wholeSide, i, thisQuadOutside, firstOppositeOutsidePt;
	
	    function topFirst(a, b) { return a.pxmid[1] - b.pxmid[1]; }
	    function bottomFirst(a, b) { return b.pxmid[1] - a.pxmid[1]; }
	
	    function scootOneLabel(thisPt, prevPt) {
	        if(!prevPt) prevPt = {};
	
	        var prevOuterY = prevPt.labelExtraY + (yHalf ? prevPt.yLabelMax : prevPt.yLabelMin);
	        var thisInnerY = yHalf ? thisPt.yLabelMin : thisPt.yLabelMax;
	        var thisOuterY = yHalf ? thisPt.yLabelMax : thisPt.yLabelMin;
	        var thisSliceOuterY = thisPt.cyFinal + farthestY(thisPt.px0[1], thisPt.px1[1]);
	        var newExtraY = prevOuterY - thisInnerY;
	
	        var xBuffer, i, otherPt, otherOuterY, otherOuterX, newExtraX;
	
	        // make sure this label doesn't overlap other labels
	        // this *only* has us move these labels vertically
	        if(newExtraY * yDiffSign > 0) thisPt.labelExtraY = newExtraY;
	
	        // make sure this label doesn't overlap any slices
	        if(!Array.isArray(trace.pull)) return; // this can only happen with array pulls
	
	        for(i = 0; i < wholeSide.length; i++) {
	            otherPt = wholeSide[i];
	
	            // overlap can only happen if the other point is pulled more than this one
	            if(otherPt === thisPt || (
	                (helpers.castOption(trace.pull, thisPt.pts) || 0) >=
	                (helpers.castOption(trace.pull, otherPt.pts) || 0))
	            ) {
	                continue;
	            }
	
	            if((thisPt.pxmid[1] - otherPt.pxmid[1]) * yDiffSign > 0) {
	                // closer to the equator - by construction all of these happen first
	                // move the text vertically to get away from these slices
	                otherOuterY = otherPt.cyFinal + farthestY(otherPt.px0[1], otherPt.px1[1]);
	                newExtraY = otherOuterY - thisInnerY - thisPt.labelExtraY;
	
	                if(newExtraY * yDiffSign > 0) thisPt.labelExtraY += newExtraY;
	            } else if((thisOuterY + thisPt.labelExtraY - thisSliceOuterY) * yDiffSign > 0) {
	                // farther from the equator - happens after we've done all the
	                // vertical moving we're going to do
	                // move horizontally to get away from these more polar slices
	
	                // if we're moving horz. based on a slice that's several slices away from this one
	                // then we need some extra space for the lines to labels between them
	                xBuffer = 3 * xDiffSign * Math.abs(i - wholeSide.indexOf(thisPt));
	
	                otherOuterX = otherPt.cxFinal + farthestX(otherPt.px0[0], otherPt.px1[0]);
	                newExtraX = otherOuterX + xBuffer - (thisPt.cxFinal + thisPt.pxmid[0]) - thisPt.labelExtraX;
	
	                if(newExtraX * xDiffSign > 0) thisPt.labelExtraX += newExtraX;
	            }
	        }
	    }
	
	    for(yHalf = 0; yHalf < 2; yHalf++) {
	        equatorFirst = yHalf ? topFirst : bottomFirst;
	        farthestY = yHalf ? Math.max : Math.min;
	        yDiffSign = yHalf ? 1 : -1;
	
	        for(xHalf = 0; xHalf < 2; xHalf++) {
	            farthestX = xHalf ? Math.max : Math.min;
	            xDiffSign = xHalf ? 1 : -1;
	
	            // first sort the array
	            // note this is a copy of cd, so cd itself doesn't get sorted
	            // but we can still modify points in place.
	            thisQuad = quadrants[yHalf][xHalf];
	            thisQuad.sort(equatorFirst);
	
	            oppositeQuad = quadrants[1 - yHalf][xHalf];
	            wholeSide = oppositeQuad.concat(thisQuad);
	
	            thisQuadOutside = [];
	            for(i = 0; i < thisQuad.length; i++) {
	                if(thisQuad[i].yLabelMid !== undefined) thisQuadOutside.push(thisQuad[i]);
	            }
	
	            firstOppositeOutsidePt = false;
	            for(i = 0; yHalf && i < oppositeQuad.length; i++) {
	                if(oppositeQuad[i].yLabelMid !== undefined) {
	                    firstOppositeOutsidePt = oppositeQuad[i];
	                    break;
	                }
	            }
	
	            // each needs to avoid the previous
	            for(i = 0; i < thisQuadOutside.length; i++) {
	                var prevPt = i && thisQuadOutside[i - 1];
	                // bottom half needs to avoid the first label of the top half
	                // top half we still need to call scootOneLabel on the first slice
	                // so we can avoid other slices, but we don't pass a prevPt
	                if(firstOppositeOutsidePt && !i) prevPt = firstOppositeOutsidePt;
	                scootOneLabel(thisQuadOutside[i], prevPt);
	            }
	        }
	    }
	}
	
	function layoutAreas(cdModule, plotSize) {
	    var scaleGroups = [];
	
	    // figure out the center and maximum radius
	    for(var i = 0; i < cdModule.length; i++) {
	        var cd0 = cdModule[i][0];
	        var trace = cd0.trace;
	
	        var domain = trace.domain;
	        var width = plotSize.w * (domain.x[1] - domain.x[0]);
	        var height = plotSize.h * (domain.y[1] - domain.y[0]);
	        // leave some space for the title, if it will be displayed outside
	        if(trace.title.text && trace.title.position !== 'middle center') {
	            height -= getTitleSpace(cd0, plotSize);
	        }
	
	        var rx = width / 2;
	        var ry = height / 2;
	        if(trace.type === 'funnelarea' && !trace.scalegroup) {
	            ry /= trace.aspectratio;
	        }
	
	        cd0.r = Math.min(rx, ry) / (1 + getMaxPull(trace));
	
	        cd0.cx = plotSize.l + plotSize.w * (trace.domain.x[1] + trace.domain.x[0]) / 2;
	        cd0.cy = plotSize.t + plotSize.h * (1 - trace.domain.y[0]) - height / 2;
	        if(trace.title.text && trace.title.position.indexOf('bottom') !== -1) {
	            cd0.cy -= getTitleSpace(cd0, plotSize);
	        }
	
	        if(trace.scalegroup && scaleGroups.indexOf(trace.scalegroup) === -1) {
	            scaleGroups.push(trace.scalegroup);
	        }
	    }
	
	    groupScale(cdModule, scaleGroups);
	}
	
	function groupScale(cdModule, scaleGroups) {
	    var cd0, i, trace;
	
	    // scale those that are grouped
	    for(var k = 0; k < scaleGroups.length; k++) {
	        var min = Infinity;
	        var g = scaleGroups[k];
	
	        for(i = 0; i < cdModule.length; i++) {
	            cd0 = cdModule[i][0];
	            trace = cd0.trace;
	
	            if(trace.scalegroup === g) {
	                var area;
	                if(trace.type === 'pie') {
	                    area = cd0.r * cd0.r;
	                } else if(trace.type === 'funnelarea') {
	                    var rx, ry;
	
	                    if(trace.aspectratio > 1) {
	                        rx = cd0.r;
	                        ry = rx / trace.aspectratio;
	                    } else {
	                        ry = cd0.r;
	                        rx = ry * trace.aspectratio;
	                    }
	
	                    rx *= (1 + trace.baseratio) / 2;
	
	                    area = rx * ry;
	                }
	
	                min = Math.min(min, area / cd0.vTotal);
	            }
	        }
	
	        for(i = 0; i < cdModule.length; i++) {
	            cd0 = cdModule[i][0];
	            trace = cd0.trace;
	            if(trace.scalegroup === g) {
	                var v = min * cd0.vTotal;
	                if(trace.type === 'funnelarea') {
	                    v /= (1 + trace.baseratio) / 2;
	                    v /= trace.aspectratio;
	                }
	
	                cd0.r = Math.sqrt(v);
	            }
	        }
	    }
	}
	
	function setCoords(cd) {
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var currentAngle = trace.rotation * Math.PI / 180;
	    var angleFactor = 2 * Math.PI / cd0.vTotal;
	    var firstPt = 'px0';
	    var lastPt = 'px1';
	
	    var i, cdi, currentCoords;
	
	    if(trace.direction === 'counterclockwise') {
	        for(i = 0; i < cd.length; i++) {
	            if(!cd[i].hidden) break; // find the first non-hidden slice
	        }
	        if(i === cd.length) return; // all slices hidden
	
	        currentAngle += angleFactor * cd[i].v;
	        angleFactor *= -1;
	        firstPt = 'px1';
	        lastPt = 'px0';
	    }
	
	    function getCoords(angle) {
	        return [cd0.r * Math.sin(angle), -cd0.r * Math.cos(angle)];
	    }
	
	    currentCoords = getCoords(currentAngle);
	
	    for(i = 0; i < cd.length; i++) {
	        cdi = cd[i];
	        if(cdi.hidden) continue;
	
	        cdi[firstPt] = currentCoords;
	
	        currentAngle += angleFactor * cdi.v / 2;
	        cdi.pxmid = getCoords(currentAngle);
	        cdi.midangle = currentAngle;
	
	        currentAngle += angleFactor * cdi.v / 2;
	        currentCoords = getCoords(currentAngle);
	
	        cdi[lastPt] = currentCoords;
	
	        cdi.largeArc = (cdi.v > cd0.vTotal / 2) ? 1 : 0;
	
	        cdi.halfangle = Math.PI * Math.min(cdi.v / cd0.vTotal, 0.5);
	        cdi.ring = 1 - trace.hole;
	        cdi.rInscribed = getInscribedRadiusFraction(cdi, cd0);
	    }
	}
	
	function formatSliceLabel(gd, pt, cd0) {
	    var fullLayout = gd._fullLayout;
	    var trace = cd0.trace;
	    // look for textemplate
	    var texttemplate = trace.texttemplate;
	
	    // now insert text
	    var textinfo = trace.textinfo;
	    if(!texttemplate && textinfo && textinfo !== 'none') {
	        var parts = textinfo.split('+');
	        var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
	        var hasLabel = hasFlag('label');
	        var hasText = hasFlag('text');
	        var hasValue = hasFlag('value');
	        var hasPercent = hasFlag('percent');
	
	        var separators = fullLayout.separators;
	        var text;
	
	        text = hasLabel ? [pt.label] : [];
	        if(hasText) {
	            var tx = helpers.getFirstFilled(trace.text, pt.pts);
	            if(isValidTextValue(tx)) text.push(tx);
	        }
	        if(hasValue) text.push(helpers.formatPieValue(pt.v, separators));
	        if(hasPercent) text.push(helpers.formatPiePercent(pt.v / cd0.vTotal, separators));
	        pt.text = text.join('<br>');
	    }
	
	    function makeTemplateVariables(pt) {
	        return {
	            label: pt.label,
	            value: pt.v,
	            valueLabel: helpers.formatPieValue(pt.v, fullLayout.separators),
	            percent: pt.v / cd0.vTotal,
	            percentLabel: helpers.formatPiePercent(pt.v / cd0.vTotal, fullLayout.separators),
	            color: pt.color,
	            text: pt.text,
	            customdata: Lib.castOption(trace, pt.i, 'customdata')
	        };
	    }
	
	    if(texttemplate) {
	        var txt = Lib.castOption(trace, pt.i, 'texttemplate');
	        if(!txt) {
	            pt.text = '';
	        } else {
	            var obj = makeTemplateVariables(pt);
	            var ptTx = helpers.getFirstFilled(trace.text, pt.pts);
	            if(isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
	            pt.text = Lib.texttemplateString(txt, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
	        }
	    }
	}
	module.exports = {
	    plot: plot,
	    formatSliceLabel: formatSliceLabel,
	    transformInsideText: transformInsideText,
	    determineInsideTextFont: determineInsideTextFont,
	    positionTitleOutside: positionTitleOutside,
	    prerenderTitles: prerenderTitles,
	    layoutAreas: layoutAreas,
	    attachFxHandlers: attachFxHandlers,
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../components/fx":629,"../../lib":716,"../../lib/svg_text_utils":740,"../../plots/plots":825,"./event_data":1096,"./helpers":1097,"d3":164}],1102:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var styleOne = _dereq_('./style_one');
	
	module.exports = function style(gd) {
	    gd._fullLayout._pielayer.selectAll('.trace').each(function(cd) {
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	        var traceSelection = d3.select(this);
	
	        traceSelection.style({opacity: trace.opacity});
	
	        traceSelection.selectAll('path.surface').each(function(pt) {
	            d3.select(this).call(styleOne, pt, trace);
	        });
	    });
	};
	
	},{"./style_one":1103,"d3":164}],1103:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var castOption = _dereq_('./helpers').castOption;
	
	module.exports = function styleOne(s, pt, trace) {
	    var line = trace.marker.line;
	    var lineColor = castOption(line.color, pt.pts) || Color.defaultLine;
	    var lineWidth = castOption(line.width, pt.pts) || 0;
	
	    s.style('stroke-width', lineWidth)
	        .call(Color.fill, pt.color)
	        .call(Color.stroke, lineColor);
	};
	
	},{"../../components/color":591,"./helpers":1097}],1104:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterglAttrs = _dereq_('../scatter/attributes');
	
	module.exports = {
	    x: scatterglAttrs.x,
	    y: scatterglAttrs.y,
	    xy: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    indices: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    xbounds: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    ybounds: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    text: scatterglAttrs.text,
	    marker: {
	        color: {
	            valType: 'color',
	            arrayOk: false,
	            
	            editType: 'calc',
	            
	        },
	        opacity: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            dflt: 1,
	            arrayOk: false,
	            
	            editType: 'calc',
	            
	        },
	        blend: {
	            valType: 'boolean',
	            dflt: null,
	            
	            editType: 'calc',
	            
	        },
	        sizemin: {
	            valType: 'number',
	            min: 0.1,
	            max: 2,
	            dflt: 0.5,
	            
	            editType: 'calc',
	            
	        },
	        sizemax: {
	            valType: 'number',
	            min: 0.1,
	            dflt: 20,
	            
	            editType: 'calc',
	            
	        },
	        border: {
	            color: {
	                valType: 'color',
	                arrayOk: false,
	                
	                editType: 'calc',
	                
	            },
	            arearatio: {
	                valType: 'number',
	                min: 0,
	                max: 1,
	                dflt: 0,
	                
	                editType: 'calc',
	                
	            },
	            editType: 'calc'
	        },
	        editType: 'calc'
	    },
	    transforms: undefined
	};
	
	},{"../scatter/attributes":1118}],1105:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createPointCloudRenderer = _dereq_('gl-pointcloud2d');
	
	var str2RGBArray = _dereq_('../../lib/str2rgbarray');
	var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
	var getTraceColor = _dereq_('../scatter/get_trace_color');
	
	function Pointcloud(scene, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.type = 'pointcloud';
	
	    this.pickXData = [];
	    this.pickYData = [];
	    this.xData = [];
	    this.yData = [];
	    this.textLabels = [];
	    this.color = 'rgb(0, 0, 0)';
	    this.name = '';
	    this.hoverinfo = 'all';
	
	    this.idToIndex = new Int32Array(0);
	    this.bounds = [0, 0, 0, 0];
	
	    this.pointcloudOptions = {
	        positions: new Float32Array(0),
	        idToIndex: this.idToIndex,
	        sizemin: 0.5,
	        sizemax: 12,
	        color: [0, 0, 0, 1],
	        areaRatio: 1,
	        borderColor: [0, 0, 0, 1]
	    };
	    this.pointcloud = createPointCloudRenderer(scene.glplot, this.pointcloudOptions);
	    this.pointcloud._trace = this; // scene2d requires this prop
	}
	
	var proto = Pointcloud.prototype;
	
	proto.handlePick = function(pickResult) {
	    var index = this.idToIndex[pickResult.pointId];
	
	    // prefer the readout from XY, if present
	    return {
	        trace: this,
	        dataCoord: pickResult.dataCoord,
	        traceCoord: this.pickXYData ?
	            [this.pickXYData[index * 2], this.pickXYData[index * 2 + 1]] :
	            [this.pickXData[index], this.pickYData[index]],
	        textLabel: Array.isArray(this.textLabels) ?
	            this.textLabels[index] :
	            this.textLabels,
	        color: this.color,
	        name: this.name,
	        pointIndex: index,
	        hoverinfo: this.hoverinfo
	    };
	};
	
	proto.update = function(options) {
	    this.index = options.index;
	    this.textLabels = options.text;
	    this.name = options.name;
	    this.hoverinfo = options.hoverinfo;
	    this.bounds = [Infinity, Infinity, -Infinity, -Infinity];
	
	    this.updateFast(options);
	
	    this.color = getTraceColor(options, {});
	};
	
	proto.updateFast = function(options) {
	    var x = this.xData = this.pickXData = options.x;
	    var y = this.yData = this.pickYData = options.y;
	    var xy = this.pickXYData = options.xy;
	
	    var userBounds = options.xbounds && options.ybounds;
	    var index = options.indices;
	
	    var len;
	    var idToIndex;
	    var positions;
	    var bounds = this.bounds;
	
	    var xx, yy, i;
	
	    if(xy) {
	        positions = xy;
	
	        // dividing xy.length by 2 and truncating to integer if xy.length was not even
	        len = xy.length >>> 1;
	
	        if(userBounds) {
	            bounds[0] = options.xbounds[0];
	            bounds[2] = options.xbounds[1];
	            bounds[1] = options.ybounds[0];
	            bounds[3] = options.ybounds[1];
	        } else {
	            for(i = 0; i < len; i++) {
	                xx = positions[i * 2];
	                yy = positions[i * 2 + 1];
	
	                if(xx < bounds[0]) bounds[0] = xx;
	                if(xx > bounds[2]) bounds[2] = xx;
	                if(yy < bounds[1]) bounds[1] = yy;
	                if(yy > bounds[3]) bounds[3] = yy;
	            }
	        }
	
	        if(index) {
	            idToIndex = index;
	        } else {
	            idToIndex = new Int32Array(len);
	
	            for(i = 0; i < len; i++) {
	                idToIndex[i] = i;
	            }
	        }
	    } else {
	        len = x.length;
	
	        positions = new Float32Array(2 * len);
	        idToIndex = new Int32Array(len);
	
	        for(i = 0; i < len; i++) {
	            xx = x[i];
	            yy = y[i];
	
	            idToIndex[i] = i;
	
	            positions[i * 2] = xx;
	            positions[i * 2 + 1] = yy;
	
	            if(xx < bounds[0]) bounds[0] = xx;
	            if(xx > bounds[2]) bounds[2] = xx;
	            if(yy < bounds[1]) bounds[1] = yy;
	            if(yy > bounds[3]) bounds[3] = yy;
	        }
	    }
	
	    this.idToIndex = idToIndex;
	    this.pointcloudOptions.idToIndex = idToIndex;
	
	    this.pointcloudOptions.positions = positions;
	
	    var markerColor = str2RGBArray(options.marker.color);
	    var borderColor = str2RGBArray(options.marker.border.color);
	    var opacity = options.opacity * options.marker.opacity;
	
	    markerColor[3] *= opacity;
	    this.pointcloudOptions.color = markerColor;
	
	    // detect blending from the number of points, if undefined
	    // because large data with blending hits performance
	    var blend = options.marker.blend;
	    if(blend === null) {
	        var maxPoints = 100;
	        blend = x.length < maxPoints || y.length < maxPoints;
	    }
	    this.pointcloudOptions.blend = blend;
	
	    borderColor[3] *= opacity;
	    this.pointcloudOptions.borderColor = borderColor;
	
	    var markerSizeMin = options.marker.sizemin;
	    var markerSizeMax = Math.max(options.marker.sizemax, options.marker.sizemin);
	    this.pointcloudOptions.sizeMin = markerSizeMin;
	    this.pointcloudOptions.sizeMax = markerSizeMax;
	    this.pointcloudOptions.areaRatio = options.marker.border.arearatio;
	
	    this.pointcloud.update(this.pointcloudOptions);
	
	    // add item for autorange routine
	    var xa = this.scene.xaxis;
	    var ya = this.scene.yaxis;
	    var pad = markerSizeMax / 2 || 0.5;
	    options._extremes[xa._id] = findExtremes(xa, [bounds[0], bounds[2]], {ppad: pad});
	    options._extremes[ya._id] = findExtremes(ya, [bounds[1], bounds[3]], {ppad: pad});
	};
	
	proto.dispose = function() {
	    this.pointcloud.dispose();
	};
	
	function createPointcloud(scene, data) {
	    var plot = new Pointcloud(scene, data.uid);
	    plot.update(data);
	    return plot;
	}
	
	module.exports = createPointcloud;
	
	},{"../../lib/str2rgbarray":739,"../../plots/cartesian/autorange":763,"../scatter/get_trace_color":1128,"gl-pointcloud2d":294}],1106:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    coerce('x');
	    coerce('y');
	
	    coerce('xbounds');
	    coerce('ybounds');
	
	    if(traceIn.xy && traceIn.xy instanceof Float32Array) {
	        traceOut.xy = traceIn.xy;
	    }
	
	    if(traceIn.indices && traceIn.indices instanceof Int32Array) {
	        traceOut.indices = traceIn.indices;
	    }
	
	    coerce('text');
	    coerce('marker.color', defaultColor);
	    coerce('marker.opacity');
	    coerce('marker.blend');
	    coerce('marker.sizemin');
	    coerce('marker.sizemax');
	    coerce('marker.border.color', defaultColor);
	    coerce('marker.border.arearatio');
	
	    // disable 1D transforms - that would defeat the purpose of this trace type, performance!
	    traceOut._length = null;
	};
	
	},{"../../lib":716,"./attributes":1104}],1107:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	
	    // reuse the Scatter3D 'dummy' calc step so that legends know what to do
	    calc: _dereq_('../scatter3d/calc'),
	    plot: _dereq_('./convert'),
	
	    moduleType: 'trace',
	    name: 'pointcloud',
	    basePlotModule: _dereq_('../../plots/gl2d'),
	    categories: ['gl', 'gl2d', 'showLegend'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl2d":802,"../scatter3d/calc":1146,"./attributes":1104,"./convert":1105,"./defaults":1106}],1108:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var colorAttrs = _dereq_('../../components/color/attributes');
	var fxAttrs = _dereq_('../../components/fx/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var colorAttributes = _dereq_('../../components/colorscale/attributes');
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	
	var attrs = module.exports = overrideAll({
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: [],
	        arrayOk: false,
	        
	    }),
	    hoverlabel: fxAttrs.hoverlabel,
	    domain: domainAttrs({name: 'sankey', trace: true}),
	
	    orientation: {
	        valType: 'enumerated',
	        values: ['v', 'h'],
	        dflt: 'h',
	        
	        
	    },
	
	    valueformat: {
	        valType: 'string',
	        dflt: '.3s',
	        
	        
	    },
	
	    valuesuffix: {
	        valType: 'string',
	        dflt: '',
	        
	        
	    },
	
	    arrangement: {
	        valType: 'enumerated',
	        values: ['snap', 'perpendicular', 'freeform', 'fixed'],
	        dflt: 'snap',
	        
	        
	    },
	
	    textfont: fontAttrs({
	        
	    }),
	
	    node: {
	        label: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        groups: {
	            valType: 'info_array',
	            impliedEdits: {'x': [], 'y': []},
	            dimensions: 2,
	            freeLength: true,
	            dflt: [],
	            items: {valType: 'number', editType: 'calc'},
	            
	            
	        },
	        x: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        y: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        color: {
	            valType: 'color',
	            
	            arrayOk: true,
	            
	        },
	        line: {
	            color: {
	                valType: 'color',
	                
	                dflt: colorAttrs.defaultLine,
	                arrayOk: true,
	                
	            },
	            width: {
	                valType: 'number',
	                
	                min: 0,
	                dflt: 0.5,
	                arrayOk: true,
	                
	            }
	        },
	        pad: {
	            valType: 'number',
	            arrayOk: false,
	            min: 0,
	            dflt: 20,
	            
	            
	        },
	        thickness: {
	            valType: 'number',
	            arrayOk: false,
	            min: 1,
	            dflt: 20,
	            
	            
	        },
	        hoverinfo: {
	            valType: 'enumerated',
	            values: ['all', 'none', 'skip'],
	            dflt: 'all',
	            
	            
	        },
	        hoverlabel: fxAttrs.hoverlabel, // needs editType override,
	        hovertemplate: hovertemplateAttrs({}, {
	            
	            keys: ['value', 'label']
	        }),
	        
	    },
	
	    link: {
	        label: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        color: {
	            valType: 'color',
	            
	            arrayOk: true,
	            
	        },
	        line: {
	            color: {
	                valType: 'color',
	                
	                dflt: colorAttrs.defaultLine,
	                arrayOk: true,
	                
	            },
	            width: {
	                valType: 'number',
	                
	                min: 0,
	                dflt: 0,
	                arrayOk: true,
	                
	            }
	        },
	        source: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	        target: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	        value: {
	            valType: 'data_array',
	            dflt: [],
	            
	            
	        },
	        hoverinfo: {
	            valType: 'enumerated',
	            values: ['all', 'none', 'skip'],
	            dflt: 'all',
	            
	            
	        },
	        hoverlabel: fxAttrs.hoverlabel, // needs editType override,
	        hovertemplate: hovertemplateAttrs({}, {
	            
	            keys: ['value', 'label']
	        }),
	        colorscales: templatedArray('concentrationscales', {
	            editType: 'calc',
	            label: {
	                valType: 'string',
	                
	                editType: 'calc',
	                
	                dflt: ''
	            },
	            cmax: {
	                valType: 'number',
	                
	                editType: 'calc',
	                dflt: 1,
	                
	            },
	            cmin: {
	                valType: 'number',
	                
	                editType: 'calc',
	                dflt: 0,
	                
	            },
	            colorscale: extendFlat(colorAttributes().colorscale, {dflt: [[0, 'white'], [1, 'black']]})
	        }),
	        
	        
	    }
	}, 'calc', 'nested');
	attrs.transforms = undefined;
	
	},{"../../components/color/attributes":590,"../../components/colorscale/attributes":598,"../../components/fx/attributes":621,"../../constants/docs":687,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plot_api/plot_template":754,"../../plots/attributes":761,"../../plots/domain":789,"../../plots/font_attributes":790,"../../plots/template_attributes":840}],1109:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
	var plot = _dereq_('./plot');
	var fxAttrs = _dereq_('../../components/fx/layout_attributes');
	
	var setCursor = _dereq_('../../lib/setcursor');
	var dragElement = _dereq_('../../components/dragelement');
	var prepSelect = _dereq_('../../plots/cartesian/select').prepSelect;
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var SANKEY = 'sankey';
	
	exports.name = SANKEY;
	
	exports.baseLayoutAttrOverrides = overrideAll({
	    hoverlabel: fxAttrs.hoverlabel
	}, 'plot', 'nested');
	
	exports.plot = function(gd) {
	    var calcData = getModuleCalcData(gd.calcdata, SANKEY)[0];
	    plot(gd, calcData);
	    exports.updateFx(gd);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var hadPlot = (oldFullLayout._has && oldFullLayout._has(SANKEY));
	    var hasPlot = (newFullLayout._has && newFullLayout._has(SANKEY));
	
	    if(hadPlot && !hasPlot) {
	        oldFullLayout._paperdiv.selectAll('.sankey').remove();
	        oldFullLayout._paperdiv.selectAll('.bgsankey').remove();
	    }
	};
	
	exports.updateFx = function(gd) {
	    for(var i = 0; i < gd._fullData.length; i++) {
	        subplotUpdateFx(gd, i);
	    }
	};
	
	function subplotUpdateFx(gd, index) {
	    var trace = gd._fullData[index];
	    var fullLayout = gd._fullLayout;
	
	    var dragMode = fullLayout.dragmode;
	    var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
	    var bgRect = trace._bgRect;
	
	    if(dragMode === 'pan' || dragMode === 'zoom') return;
	
	    setCursor(bgRect, cursor);
	
	    var xaxis = {
	        _id: 'x',
	        c2p: Lib.identity,
	        _offset: trace._sankey.translateX,
	        _length: trace._sankey.width
	    };
	    var yaxis = {
	        _id: 'y',
	        c2p: Lib.identity,
	        _offset: trace._sankey.translateY,
	        _length: trace._sankey.height
	    };
	
	    // Note: dragOptions is needed to be declared for all dragmodes because
	    // it's the object that holds persistent selection state.
	    var dragOptions = {
	        gd: gd,
	        element: bgRect.node(),
	        plotinfo: {
	            id: index,
	            xaxis: xaxis,
	            yaxis: yaxis,
	            fillRangeItems: Lib.noop
	        },
	        subplot: index,
	        // create mock x/y axes for hover routine
	        xaxes: [xaxis],
	        yaxes: [yaxis],
	        doneFnCompleted: function(selection) {
	            var traceNow = gd._fullData[index];
	            var newGroups;
	            var oldGroups = traceNow.node.groups.slice();
	            var newGroup = [];
	
	            function findNode(pt) {
	                var nodes = traceNow._sankey.graph.nodes;
	                for(var i = 0; i < nodes.length; i++) {
	                    if(nodes[i].pointNumber === pt) return nodes[i];
	                }
	            }
	
	            for(var j = 0; j < selection.length; j++) {
	                var node = findNode(selection[j].pointNumber);
	                if(!node) continue;
	
	                // If the node represents a group
	                if(node.group) {
	                    // Add all its children to the current selection
	                    for(var k = 0; k < node.childrenNodes.length; k++) {
	                        newGroup.push(node.childrenNodes[k].pointNumber);
	                    }
	                    // Flag group for removal from existing list of groups
	                    oldGroups[node.pointNumber - traceNow.node._count] = false;
	                } else {
	                    newGroup.push(node.pointNumber);
	                }
	            }
	
	            newGroups = oldGroups
	                .filter(Boolean)
	                .concat([newGroup]);
	
	            Registry.call('_guiRestyle', gd, {
	                'node.groups': [ newGroups ]
	            }, index);
	        }
	    };
	
	    dragOptions.prepFn = function(e, startX, startY) {
	        prepSelect(e, startX, startY, dragOptions, dragMode);
	    };
	
	    dragElement.init(dragOptions);
	}
	
	},{"../../components/dragelement":609,"../../components/fx/layout_attributes":630,"../../lib":716,"../../lib/setcursor":736,"../../plot_api/edit_types":747,"../../plots/cartesian/select":781,"../../plots/get_data":799,"../../registry":845,"./plot":1114}],1110:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var tarjan = _dereq_('strongly-connected-components');
	var Lib = _dereq_('../../lib');
	var wrap = _dereq_('../../lib/gup').wrap;
	
	var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	var isIndex = Lib.isIndex;
	var Colorscale = _dereq_('../../components/colorscale');
	
	function convertToD3Sankey(trace) {
	    var nodeSpec = trace.node;
	    var linkSpec = trace.link;
	
	    var links = [];
	    var hasLinkColorArray = isArrayOrTypedArray(linkSpec.color);
	    var linkedNodes = {};
	
	    var components = {};
	    var componentCount = linkSpec.colorscales.length;
	    var i;
	    for(i = 0; i < componentCount; i++) {
	        var cscale = linkSpec.colorscales[i];
	        var specs = Colorscale.extractScale(cscale, {cLetter: 'c'});
	        var scale = Colorscale.makeColorScaleFunc(specs);
	        components[cscale.label] = scale;
	    }
	
	    var maxNodeId = 0;
	    for(i = 0; i < linkSpec.value.length; i++) {
	        if(linkSpec.source[i] > maxNodeId) maxNodeId = linkSpec.source[i];
	        if(linkSpec.target[i] > maxNodeId) maxNodeId = linkSpec.target[i];
	    }
	    var nodeCount = maxNodeId + 1;
	    trace.node._count = nodeCount;
	
	    // Group nodes
	    var j;
	    var groups = trace.node.groups;
	    var groupLookup = {};
	    for(i = 0; i < groups.length; i++) {
	        var group = groups[i];
	        // Build a lookup table to quickly find in which group a node is
	        for(j = 0; j < group.length; j++) {
	            var nodeIndex = group[j];
	            var groupIndex = nodeCount + i;
	            if(groupLookup.hasOwnProperty(nodeIndex)) {
	                Lib.warn('Node ' + nodeIndex + ' is already part of a group.');
	            } else {
	                groupLookup[nodeIndex] = groupIndex;
	            }
	        }
	    }
	
	    // Process links
	    var groupedLinks = {
	        source: [],
	        target: []
	    };
	    for(i = 0; i < linkSpec.value.length; i++) {
	        var val = linkSpec.value[i];
	        // remove negative values, but keep zeros with special treatment
	        var source = linkSpec.source[i];
	        var target = linkSpec.target[i];
	        if(!(val > 0 && isIndex(source, nodeCount) && isIndex(target, nodeCount))) {
	            continue;
	        }
	
	        // Remove links that are within the same group
	        if(groupLookup.hasOwnProperty(source) && groupLookup.hasOwnProperty(target) && groupLookup[source] === groupLookup[target]) {
	            continue;
	        }
	
	        // if link targets a node in the group, relink target to that group
	        if(groupLookup.hasOwnProperty(target)) {
	            target = groupLookup[target];
	        }
	
	        // if link originates from a node in a group, relink source to that group
	        if(groupLookup.hasOwnProperty(source)) {
	            source = groupLookup[source];
	        }
	
	        source = +source;
	        target = +target;
	        linkedNodes[source] = linkedNodes[target] = true;
	
	        var label = '';
	        if(linkSpec.label && linkSpec.label[i]) label = linkSpec.label[i];
	
	        var concentrationscale = null;
	        if(label && components.hasOwnProperty(label)) concentrationscale = components[label];
	
	        links.push({
	            pointNumber: i,
	            label: label,
	            color: hasLinkColorArray ? linkSpec.color[i] : linkSpec.color,
	            concentrationscale: concentrationscale,
	            source: source,
	            target: target,
	            value: +val
	        });
	
	        groupedLinks.source.push(source);
	        groupedLinks.target.push(target);
	    }
	
	    // Process nodes
	    var totalCount = nodeCount + groups.length;
	    var hasNodeColorArray = isArrayOrTypedArray(nodeSpec.color);
	    var nodes = [];
	    for(i = 0; i < totalCount; i++) {
	        if(!linkedNodes[i]) continue;
	        var l = nodeSpec.label[i];
	
	        nodes.push({
	            group: (i > nodeCount - 1),
	            childrenNodes: [],
	            pointNumber: i,
	            label: l,
	            color: hasNodeColorArray ? nodeSpec.color[i] : nodeSpec.color
	        });
	    }
	
	    // Check if we have circularity on the resulting graph
	    var circular = false;
	    if(circularityPresent(totalCount, groupedLinks.source, groupedLinks.target)) {
	        circular = true;
	    }
	
	    return {
	        circular: circular,
	        links: links,
	        nodes: nodes,
	
	        // Data structure for groups
	        groups: groups,
	        groupLookup: groupLookup
	    };
	}
	
	function circularityPresent(nodeLen, sources, targets) {
	    var nodes = Lib.init2dArray(nodeLen, 0);
	
	    for(var i = 0; i < Math.min(sources.length, targets.length); i++) {
	        if(Lib.isIndex(sources[i], nodeLen) && Lib.isIndex(targets[i], nodeLen)) {
	            if(sources[i] === targets[i]) {
	                return true; // self-link which is also a scc of one
	            }
	            nodes[sources[i]].push(targets[i]);
	        }
	    }
	
	    var scc = tarjan(nodes);
	
	    // Tarján's strongly connected components algorithm coded by Mikola Lysenko
	    // returns at least one non-singular component if there's circularity in the graph
	    return scc.components.some(function(c) {
	        return c.length > 1;
	    });
	}
	
	module.exports = function calc(gd, trace) {
	    var result = convertToD3Sankey(trace);
	
	    return wrap({
	        circular: result.circular,
	        _nodes: result.nodes,
	        _links: result.links,
	
	        // Data structure for grouping
	        _groups: result.groups,
	        _groupLookup: result.groupLookup,
	    });
	};
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gup":714,"strongly-connected-components":528}],1111:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    nodeTextOffsetHorizontal: 4,
	    nodeTextOffsetVertical: 3,
	    nodePadAcross: 10,
	    sankeyIterations: 50,
	    forceIterations: 5,
	    forceTicksPerFrame: 10,
	    duration: 500,
	    ease: 'linear',
	    cn: {
	        sankey: 'sankey',
	        sankeyLinks: 'sankey-links',
	        sankeyLink: 'sankey-link',
	        sankeyNodeSet: 'sankey-node-set',
	        sankeyNode: 'sankey-node',
	        nodeRect: 'node-rect',
	        nodeCapture: 'node-capture',
	        nodeCentered: 'node-entered',
	        nodeLabelGuide: 'node-label-guide',
	        nodeLabel: 'node-label',
	        nodeLabelTextPath: 'node-label-text-path'
	    }
	};
	
	},{}],1112:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var Color = _dereq_('../../components/color');
	var tinycolor = _dereq_('tinycolor2');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleHoverLabelDefaults = _dereq_('../../components/fx/hoverlabel_defaults');
	var Template = _dereq_('../../plot_api/plot_template');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var hoverlabelDefault = Lib.extendDeep(layout.hoverlabel, traceIn.hoverlabel);
	
	    // node attributes
	    var nodeIn = traceIn.node;
	    var nodeOut = Template.newContainer(traceOut, 'node');
	
	    function coerceNode(attr, dflt) {
	        return Lib.coerce(nodeIn, nodeOut, attributes.node, attr, dflt);
	    }
	    coerceNode('label');
	    coerceNode('groups');
	    coerceNode('x');
	    coerceNode('y');
	    coerceNode('pad');
	    coerceNode('thickness');
	    coerceNode('line.color');
	    coerceNode('line.width');
	    coerceNode('hoverinfo', traceIn.hoverinfo);
	    handleHoverLabelDefaults(nodeIn, nodeOut, coerceNode, hoverlabelDefault);
	    coerceNode('hovertemplate');
	
	    var colors = layout.colorway;
	
	    var defaultNodePalette = function(i) {return colors[i % colors.length];};
	
	    coerceNode('color', nodeOut.label.map(function(d, i) {
	        return Color.addOpacity(defaultNodePalette(i), 0.8);
	    }));
	
	    // link attributes
	    var linkIn = traceIn.link || {};
	    var linkOut = Template.newContainer(traceOut, 'link');
	
	    function coerceLink(attr, dflt) {
	        return Lib.coerce(linkIn, linkOut, attributes.link, attr, dflt);
	    }
	    coerceLink('label');
	    coerceLink('source');
	    coerceLink('target');
	    coerceLink('value');
	    coerceLink('line.color');
	    coerceLink('line.width');
	    coerceLink('hoverinfo', traceIn.hoverinfo);
	    handleHoverLabelDefaults(linkIn, linkOut, coerceLink, hoverlabelDefault);
	    coerceLink('hovertemplate');
	
	    var defaultLinkColor = tinycolor(layout.paper_bgcolor).getLuminance() < 0.333 ?
	                'rgba(255, 255, 255, 0.6)' :
	                'rgba(0, 0, 0, 0.2)';
	
	    coerceLink('color', Lib.repeat(defaultLinkColor, linkOut.value.length));
	
	    handleArrayContainerDefaults(linkIn, linkOut, {
	        name: 'colorscales',
	        handleItemDefaults: concentrationscalesDefaults
	    });
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    coerce('orientation');
	    coerce('valueformat');
	    coerce('valuesuffix');
	
	    var dfltArrangement;
	    if(nodeOut.x.length && nodeOut.y.length) {
	        dfltArrangement = 'freeform';
	    }
	    coerce('arrangement', dfltArrangement);
	
	    Lib.coerceFont(coerce, 'textfont', Lib.extendFlat({}, layout.font));
	
	    // disable 1D transforms - arrays here are 1D but their lengths/meanings
	    // don't match, between nodes and links
	    traceOut._length = null;
	};
	
	function concentrationscalesDefaults(In, Out) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(In, Out, attributes.link.colorscales, attr, dflt);
	    }
	
	    coerce('label');
	    coerce('cmin');
	    coerce('cmax');
	    coerce('colorscale');
	}
	
	},{"../../components/color":591,"../../components/fx/hoverlabel_defaults":628,"../../lib":716,"../../plot_api/plot_template":754,"../../plots/array_container_defaults":760,"../../plots/domain":789,"./attributes":1108,"tinycolor2":535}],1113:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	
	    moduleType: 'trace',
	    name: 'sankey',
	    basePlotModule: _dereq_('./base_plot'),
	    selectPoints: _dereq_('./select.js'),
	    categories: ['noOpacity'],
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1108,"./base_plot":1109,"./calc":1110,"./defaults":1112,"./plot":1114,"./select.js":1116}],1114:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var render = _dereq_('./render');
	var Fx = _dereq_('../../components/fx');
	var Color = _dereq_('../../components/color');
	var Lib = _dereq_('../../lib');
	var cn = _dereq_('./constants').cn;
	
	var _ = Lib._;
	
	function renderableValuePresent(d) {return d !== '';}
	
	function ownTrace(selection, d) {
	    return selection.filter(function(s) {return s.key === d.traceId;});
	}
	
	function makeTranslucent(element, alpha) {
	    d3.select(element)
	        .select('path')
	        .style('fill-opacity', alpha);
	    d3.select(element)
	        .select('rect')
	        .style('fill-opacity', alpha);
	}
	
	function makeTextContrasty(element) {
	    d3.select(element)
	        .select('text.name')
	        .style('fill', 'black');
	}
	
	function relatedLinks(d) {
	    return function(l) {
	        return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
	    };
	}
	
	function relatedNodes(l) {
	    return function(d) {
	        return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
	    };
	}
	
	function nodeHoveredStyle(sankeyNode, d, sankey) {
	    if(d && sankey) {
	        ownTrace(sankey, d)
	            .selectAll('.' + cn.sankeyLink)
	            .filter(relatedLinks(d))
	            .call(linkHoveredStyle.bind(0, d, sankey, false));
	    }
	}
	
	function nodeNonHoveredStyle(sankeyNode, d, sankey) {
	    if(d && sankey) {
	        ownTrace(sankey, d)
	            .selectAll('.' + cn.sankeyLink)
	            .filter(relatedLinks(d))
	            .call(linkNonHoveredStyle.bind(0, d, sankey, false));
	    }
	}
	
	function linkHoveredStyle(d, sankey, visitNodes, sankeyLink) {
	    var label = sankeyLink.datum().link.label;
	
	    sankeyLink.style('fill-opacity', function(l) {
	        if(!l.link.concentrationscale) {
	            return 0.4;
	        }
	    });
	
	    if(label) {
	        ownTrace(sankey, d)
	            .selectAll('.' + cn.sankeyLink)
	            .filter(function(l) {return l.link.label === label;})
	            .style('fill-opacity', function(l) {
	                if(!l.link.concentrationscale) {
	                    return 0.4;
	                }
	            });
	    }
	
	    if(visitNodes) {
	        ownTrace(sankey, d)
	            .selectAll('.' + cn.sankeyNode)
	            .filter(relatedNodes(d))
	            .call(nodeHoveredStyle);
	    }
	}
	
	function linkNonHoveredStyle(d, sankey, visitNodes, sankeyLink) {
	    var label = sankeyLink.datum().link.label;
	
	    sankeyLink.style('fill-opacity', function(d) {return d.tinyColorAlpha;});
	    if(label) {
	        ownTrace(sankey, d)
	            .selectAll('.' + cn.sankeyLink)
	            .filter(function(l) {return l.link.label === label;})
	            .style('fill-opacity', function(d) {return d.tinyColorAlpha;});
	    }
	
	    if(visitNodes) {
	        ownTrace(sankey, d)
	            .selectAll(cn.sankeyNode)
	            .filter(relatedNodes(d))
	            .call(nodeNonHoveredStyle);
	    }
	}
	
	// does not support array values for now
	function castHoverOption(trace, attr) {
	    var labelOpts = trace.hoverlabel || {};
	    var val = Lib.nestedProperty(labelOpts, attr).get();
	    return Array.isArray(val) ? false : val;
	}
	
	module.exports = function plot(gd, calcData) {
	    var fullLayout = gd._fullLayout;
	    var svg = fullLayout._paper;
	    var size = fullLayout._size;
	
	    // stash initial view
	    for(var i = 0; i < gd._fullData.length; i++) {
	        if(!gd._fullData[i].visible) continue;
	        if(gd._fullData[i].type !== cn.sankey) continue;
	        if(!gd._fullData[i]._viewInitial) {
	            var node = gd._fullData[i].node;
	            gd._fullData[i]._viewInitial = {
	                node: {
	                    groups: node.groups.slice(),
	                    x: node.x.slice(),
	                    y: node.y.slice()
	                }
	            };
	        }
	    }
	
	    var linkSelect = function(element, d) {
	        var evt = d.link;
	        evt.originalEvent = d3.event;
	        gd._hoverdata = [evt];
	        Fx.click(gd, { target: true });
	    };
	
	    var linkHover = function(element, d, sankey) {
	        if(gd._fullLayout.hovermode === false) return;
	        d3.select(element).call(linkHoveredStyle.bind(0, d, sankey, true));
	        if(d.link.trace.link.hoverinfo !== 'skip') {
	            d.link.fullData = d.link.trace;
	            gd.emit('plotly_hover', {
	                event: d3.event,
	                points: [d.link]
	            });
	        }
	    };
	
	    var sourceLabel = _(gd, 'source:') + ' ';
	    var targetLabel = _(gd, 'target:') + ' ';
	    var concentrationLabel = _(gd, 'concentration:') + ' ';
	    var incomingLabel = _(gd, 'incoming flow count:') + ' ';
	    var outgoingLabel = _(gd, 'outgoing flow count:') + ' ';
	
	    var linkHoverFollow = function(element, d) {
	        if(gd._fullLayout.hovermode === false) return;
	        var obj = d.link.trace.link;
	        if(obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
	
	        var hoverItems = [];
	
	        function hoverCenterPosition(link) {
	            var hoverCenterX, hoverCenterY;
	            if(link.circular) {
	                hoverCenterX = (link.circularPathData.leftInnerExtent + link.circularPathData.rightInnerExtent) / 2;
	                hoverCenterY = link.circularPathData.verticalFullExtent;
	            } else {
	                hoverCenterX = (link.source.x1 + link.target.x0) / 2;
	                hoverCenterY = (link.y0 + link.y1) / 2;
	            }
	            var center = [hoverCenterX, hoverCenterY];
	            if(link.trace.orientation === 'v') center.reverse();
	            center[0] += d.parent.translateX;
	            center[1] += d.parent.translateY;
	            return center;
	        }
	
	        // For each related links, create a hoverItem
	        var anchorIndex = 0;
	        for(var i = 0; i < d.flow.links.length; i++) {
	            var link = d.flow.links[i];
	            if(gd._fullLayout.hovermode === 'closest' && d.link.pointNumber !== link.pointNumber) continue;
	            if(d.link.pointNumber === link.pointNumber) anchorIndex = i;
	            link.fullData = link.trace;
	            obj = d.link.trace.link;
	            var hoverCenter = hoverCenterPosition(link);
	            var hovertemplateLabels = {valueLabel: d3.format(d.valueFormat)(link.value) + d.valueSuffix};
	
	            hoverItems.push({
	                x: hoverCenter[0],
	                y: hoverCenter[1],
	                name: hovertemplateLabels.valueLabel,
	                text: [
	                    link.label || '',
	                    sourceLabel + link.source.label,
	                    targetLabel + link.target.label,
	                    link.concentrationscale ? concentrationLabel + d3.format('%0.2f')(link.flow.labelConcentration) : ''
	                ].filter(renderableValuePresent).join('<br>'),
	                color: castHoverOption(obj, 'bgcolor') || Color.addOpacity(link.color, 1),
	                borderColor: castHoverOption(obj, 'bordercolor'),
	                fontFamily: castHoverOption(obj, 'font.family'),
	                fontSize: castHoverOption(obj, 'font.size'),
	                fontColor: castHoverOption(obj, 'font.color'),
	                nameLength: castHoverOption(obj, 'namelength'),
	                textAlign: castHoverOption(obj, 'align'),
	                idealAlign: d3.event.x < hoverCenter[0] ? 'right' : 'left',
	
	                hovertemplate: obj.hovertemplate,
	                hovertemplateLabels: hovertemplateLabels,
	                eventData: [link]
	            });
	        }
	
	        var tooltips = Fx.loneHover(hoverItems, {
	            container: fullLayout._hoverlayer.node(),
	            outerContainer: fullLayout._paper.node(),
	            gd: gd,
	            anchorIndex: anchorIndex
	        });
	
	        tooltips.each(function() {
	            var tooltip = this;
	            if(!d.link.concentrationscale) {
	                makeTranslucent(tooltip, 0.65);
	            }
	            makeTextContrasty(tooltip);
	        });
	    };
	
	    var linkUnhover = function(element, d, sankey) {
	        if(gd._fullLayout.hovermode === false) return;
	        d3.select(element).call(linkNonHoveredStyle.bind(0, d, sankey, true));
	        if(d.link.trace.link.hoverinfo !== 'skip') {
	            d.link.fullData = d.link.trace;
	            gd.emit('plotly_unhover', {
	                event: d3.event,
	                points: [d.link]
	            });
	        }
	
	        Fx.loneUnhover(fullLayout._hoverlayer.node());
	    };
	
	    var nodeSelect = function(element, d, sankey) {
	        var evt = d.node;
	        evt.originalEvent = d3.event;
	        gd._hoverdata = [evt];
	        d3.select(element).call(nodeNonHoveredStyle, d, sankey);
	        Fx.click(gd, { target: true });
	    };
	
	    var nodeHover = function(element, d, sankey) {
	        if(gd._fullLayout.hovermode === false) return;
	        d3.select(element).call(nodeHoveredStyle, d, sankey);
	        if(d.node.trace.node.hoverinfo !== 'skip') {
	            d.node.fullData = d.node.trace;
	            gd.emit('plotly_hover', {
	                event: d3.event,
	                points: [d.node]
	            });
	        }
	    };
	
	    var nodeHoverFollow = function(element, d) {
	        if(gd._fullLayout.hovermode === false) return;
	
	        var obj = d.node.trace.node;
	        if(obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
	        var nodeRect = d3.select(element).select('.' + cn.nodeRect);
	        var rootBBox = gd._fullLayout._paperdiv.node().getBoundingClientRect();
	        var boundingBox = nodeRect.node().getBoundingClientRect();
	        var hoverCenterX0 = boundingBox.left - 2 - rootBBox.left;
	        var hoverCenterX1 = boundingBox.right + 2 - rootBBox.left;
	        var hoverCenterY = boundingBox.top + boundingBox.height / 4 - rootBBox.top;
	
	        var hovertemplateLabels = {valueLabel: d3.format(d.valueFormat)(d.node.value) + d.valueSuffix};
	        d.node.fullData = d.node.trace;
	
	        var tooltip = Fx.loneHover({
	            x0: hoverCenterX0,
	            x1: hoverCenterX1,
	            y: hoverCenterY,
	            name: d3.format(d.valueFormat)(d.node.value) + d.valueSuffix,
	            text: [
	                d.node.label,
	                incomingLabel + d.node.targetLinks.length,
	                outgoingLabel + d.node.sourceLinks.length
	            ].filter(renderableValuePresent).join('<br>'),
	            color: castHoverOption(obj, 'bgcolor') || d.tinyColorHue,
	            borderColor: castHoverOption(obj, 'bordercolor'),
	            fontFamily: castHoverOption(obj, 'font.family'),
	            fontSize: castHoverOption(obj, 'font.size'),
	            fontColor: castHoverOption(obj, 'font.color'),
	            nameLength: castHoverOption(obj, 'namelength'),
	            textAlign: castHoverOption(obj, 'align'),
	            idealAlign: 'left',
	
	            hovertemplate: obj.hovertemplate,
	            hovertemplateLabels: hovertemplateLabels,
	            eventData: [d.node]
	        }, {
	            container: fullLayout._hoverlayer.node(),
	            outerContainer: fullLayout._paper.node(),
	            gd: gd
	        });
	
	        makeTranslucent(tooltip, 0.85);
	        makeTextContrasty(tooltip);
	    };
	
	    var nodeUnhover = function(element, d, sankey) {
	        if(gd._fullLayout.hovermode === false) return;
	        d3.select(element).call(nodeNonHoveredStyle, d, sankey);
	        if(d.node.trace.node.hoverinfo !== 'skip') {
	            d.node.fullData = d.node.trace;
	            gd.emit('plotly_unhover', {
	                event: d3.event,
	                points: [d.node]
	            });
	        }
	
	        Fx.loneUnhover(fullLayout._hoverlayer.node());
	    };
	
	    render(
	        gd,
	        svg,
	        calcData,
	        {
	            width: size.w,
	            height: size.h,
	            margin: {
	                t: size.t,
	                r: size.r,
	                b: size.b,
	                l: size.l
	            }
	        },
	        {
	            linkEvents: {
	                hover: linkHover,
	                follow: linkHoverFollow,
	                unhover: linkUnhover,
	                select: linkSelect
	            },
	            nodeEvents: {
	                hover: nodeHover,
	                follow: nodeHoverFollow,
	                unhover: nodeUnhover,
	                select: nodeSelect
	            }
	        }
	    );
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../lib":716,"./constants":1111,"./render":1115,"d3":164}],1115:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var c = _dereq_('./constants');
	var d3 = _dereq_('d3');
	var tinycolor = _dereq_('tinycolor2');
	var Color = _dereq_('../../components/color');
	var Drawing = _dereq_('../../components/drawing');
	var d3Sankey = _dereq_('@plotly/d3-sankey');
	var d3SankeyCircular = _dereq_('@plotly/d3-sankey-circular');
	var d3Force = _dereq_('d3-force');
	var Lib = _dereq_('../../lib');
	var gup = _dereq_('../../lib/gup');
	var keyFun = gup.keyFun;
	var repeat = gup.repeat;
	var unwrap = gup.unwrap;
	var interpolateNumber = _dereq_('d3-interpolate').interpolateNumber;
	
	var Registry = _dereq_('../../registry');
	
	// view models
	
	function sankeyModel(layout, d, traceIndex) {
	    var calcData = unwrap(d);
	    var trace = calcData.trace;
	    var domain = trace.domain;
	    var horizontal = trace.orientation === 'h';
	    var nodePad = trace.node.pad;
	    var nodeThickness = trace.node.thickness;
	
	    var width = layout.width * (domain.x[1] - domain.x[0]);
	    var height = layout.height * (domain.y[1] - domain.y[0]);
	
	    var nodes = calcData._nodes;
	    var links = calcData._links;
	    var circular = calcData.circular;
	
	    // Select Sankey generator
	    var sankey;
	    if(circular) {
	        sankey = d3SankeyCircular
	            .sankeyCircular()
	            .circularLinkGap(0);
	    } else {
	        sankey = d3Sankey.sankey();
	    }
	
	    sankey
	      .iterations(c.sankeyIterations)
	      .size(horizontal ? [width, height] : [height, width])
	      .nodeWidth(nodeThickness)
	      .nodePadding(nodePad)
	      .nodeId(function(d) {
	          return d.pointNumber;
	      })
	      .nodes(nodes)
	      .links(links);
	
	    var graph = sankey();
	
	    if(sankey.nodePadding() < nodePad) {
	        Lib.warn('node.pad was reduced to ', sankey.nodePadding(), ' to fit within the figure.');
	    }
	
	    // Counters for nested loops
	    var i, j, k;
	
	    // Create transient nodes for animations
	    for(var nodePointNumber in calcData._groupLookup) {
	        var groupIndex = parseInt(calcData._groupLookup[nodePointNumber]);
	
	        // Find node representing groupIndex
	        var groupingNode;
	
	        for(i = 0; i < graph.nodes.length; i++) {
	            if(graph.nodes[i].pointNumber === groupIndex) {
	                groupingNode = graph.nodes[i];
	                break;
	            }
	        }
	        // If groupinNode is undefined, no links are targeting this group
	        if(!groupingNode) continue;
	
	        var child = {
	            pointNumber: parseInt(nodePointNumber),
	            x0: groupingNode.x0,
	            x1: groupingNode.x1,
	            y0: groupingNode.y0,
	            y1: groupingNode.y1,
	            partOfGroup: true,
	            sourceLinks: [],
	            targetLinks: []
	        };
	
	        graph.nodes.unshift(child);
	        groupingNode.childrenNodes.unshift(child);
	    }
	
	    function computeLinkConcentrations() {
	        for(i = 0; i < graph.nodes.length; i++) {
	            var node = graph.nodes[i];
	            // Links connecting the same two nodes are part of a flow
	            var flows = {};
	            var flowKey;
	            var link;
	            for(j = 0; j < node.targetLinks.length; j++) {
	                link = node.targetLinks[j];
	                flowKey = link.source.pointNumber + ':' + link.target.pointNumber;
	                if(!flows.hasOwnProperty(flowKey)) flows[flowKey] = [];
	                flows[flowKey].push(link);
	            }
	
	            // Compute statistics for each flow
	            var keys = Object.keys(flows);
	            for(j = 0; j < keys.length; j++) {
	                flowKey = keys[j];
	                var flowLinks = flows[flowKey];
	
	                // Find the total size of the flow and total size per label
	                var total = 0;
	                var totalPerLabel = {};
	                for(k = 0; k < flowLinks.length; k++) {
	                    link = flowLinks[k];
	                    if(!totalPerLabel[link.label]) totalPerLabel[link.label] = 0;
	                    totalPerLabel[link.label] += link.value;
	                    total += link.value;
	                }
	
	                // Find the ratio of the link's value and the size of the flow
	                for(k = 0; k < flowLinks.length; k++) {
	                    link = flowLinks[k];
	                    link.flow = {
	                        value: total,
	                        labelConcentration: totalPerLabel[link.label] / total,
	                        concentration: link.value / total,
	                        links: flowLinks
	                    };
	                    if(link.concentrationscale) {
	                        link.color = tinycolor(link.concentrationscale(link.flow.labelConcentration));
	                    }
	                }
	            }
	
	            // Gather statistics of all links at current node
	            var totalOutflow = 0;
	            for(j = 0; j < node.sourceLinks.length; j++) {
	                totalOutflow += node.sourceLinks[j].value;
	            }
	            for(j = 0; j < node.sourceLinks.length; j++) {
	                link = node.sourceLinks[j];
	                link.concentrationOut = link.value / totalOutflow;
	            }
	
	            var totalInflow = 0;
	            for(j = 0; j < node.targetLinks.length; j++) {
	                totalInflow += node.targetLinks[j].value;
	            }
	
	            for(j = 0; j < node.targetLinks.length; j++) {
	                link = node.targetLinks[j];
	                link.concenrationIn = link.value / totalInflow;
	            }
	        }
	    }
	    computeLinkConcentrations();
	
	    // Push any overlapping nodes down.
	    function resolveCollisionsTopToBottom(columns) {
	        columns.forEach(function(nodes) {
	            var node;
	            var dy;
	            var y = 0;
	            var n = nodes.length;
	            var i;
	            nodes.sort(function(a, b) {
	                return a.y0 - b.y0;
	            });
	            for(i = 0; i < n; ++i) {
	                node = nodes[i];
	                if(node.y0 >= y) {
	                    // No overlap
	                } else {
	                    dy = (y - node.y0);
	                    if(dy > 1e-6) node.y0 += dy, node.y1 += dy;
	                }
	                y = node.y1 + nodePad;
	            }
	        });
	    }
	
	    // Group nodes into columns based on their x position
	    function snapToColumns(nodes) {
	        // Sort nodes by x position
	        var orderedNodes = nodes.map(function(n, i) {
	            return {
	                x0: n.x0,
	                index: i
	            };
	        })
	        .sort(function(a, b) {
	            return a.x0 - b.x0;
	        });
	
	        var columns = [];
	        var colNumber = -1;
	        var colX; // Position of column
	        var lastX = -Infinity; // Position of last node
	        var dx;
	        for(i = 0; i < orderedNodes.length; i++) {
	            var node = nodes[orderedNodes[i].index];
	            // If the node does not overlap with the last one
	            if(node.x0 > lastX + nodeThickness) {
	                // Start a new column
	                colNumber += 1;
	                colX = node.x0;
	            }
	            lastX = node.x0;
	
	            // Add node to its associated column
	            if(!columns[colNumber]) columns[colNumber] = [];
	            columns[colNumber].push(node);
	
	            // Change node's x position to align it with its column
	            dx = colX - node.x0;
	            node.x0 += dx, node.x1 += dx;
	        }
	        return columns;
	    }
	
	    // Force node position
	    if(trace.node.x.length && trace.node.y.length) {
	        for(i = 0; i < Math.min(trace.node.x.length, trace.node.y.length, graph.nodes.length); i++) {
	            if(trace.node.x[i] && trace.node.y[i]) {
	                var pos = [trace.node.x[i] * width, trace.node.y[i] * height];
	                graph.nodes[i].x0 = pos[0] - nodeThickness / 2;
	                graph.nodes[i].x1 = pos[0] + nodeThickness / 2;
	
	                var nodeHeight = graph.nodes[i].y1 - graph.nodes[i].y0;
	                graph.nodes[i].y0 = pos[1] - nodeHeight / 2;
	                graph.nodes[i].y1 = pos[1] + nodeHeight / 2;
	            }
	        }
	        if(trace.arrangement === 'snap') {
	            nodes = graph.nodes;
	            var columns = snapToColumns(nodes);
	            resolveCollisionsTopToBottom(columns);
	        }
	        // Update links
	        sankey.update(graph);
	    }
	
	
	    return {
	        circular: circular,
	        key: traceIndex,
	        trace: trace,
	        guid: Lib.randstr(),
	        horizontal: horizontal,
	        width: width,
	        height: height,
	        nodePad: trace.node.pad,
	        nodeLineColor: trace.node.line.color,
	        nodeLineWidth: trace.node.line.width,
	        linkLineColor: trace.link.line.color,
	        linkLineWidth: trace.link.line.width,
	        valueFormat: trace.valueformat,
	        valueSuffix: trace.valuesuffix,
	        textFont: trace.textfont,
	        translateX: domain.x[0] * layout.width + layout.margin.l,
	        translateY: layout.height - domain.y[1] * layout.height + layout.margin.t,
	        dragParallel: horizontal ? height : width,
	        dragPerpendicular: horizontal ? width : height,
	        arrangement: trace.arrangement,
	        sankey: sankey,
	        graph: graph,
	        forceLayouts: {},
	        interactionState: {
	            dragInProgress: false,
	            hovered: false
	        }
	    };
	}
	
	function linkModel(d, l, i) {
	    var tc = tinycolor(l.color);
	    var basicKey = l.source.label + '|' + l.target.label;
	    var key = basicKey + '__' + i;
	
	    // for event data
	    l.trace = d.trace;
	    l.curveNumber = d.trace.index;
	
	    return {
	        circular: d.circular,
	        key: key,
	        traceId: d.key,
	        pointNumber: l.pointNumber,
	        link: l,
	        tinyColorHue: Color.tinyRGB(tc),
	        tinyColorAlpha: tc.getAlpha(),
	        linkPath: linkPath,
	        linkLineColor: d.linkLineColor,
	        linkLineWidth: d.linkLineWidth,
	        valueFormat: d.valueFormat,
	        valueSuffix: d.valueSuffix,
	        sankey: d.sankey,
	        parent: d,
	        interactionState: d.interactionState,
	        flow: l.flow
	    };
	}
	
	function createCircularClosedPathString(link) {
	    // Using coordinates computed by d3-sankey-circular
	    var pathString = '';
	    var offset = link.width / 2;
	    var coords = link.circularPathData;
	    if(link.circularLinkType === 'top') {
	        // Top path
	        pathString =
	          // start at the left of the target node
	          'M ' +
	          coords.targetX + ' ' + (coords.targetY + offset) + ' ' +
	          'L' +
	          coords.rightInnerExtent + ' ' + (coords.targetY + offset) +
	          'A' +
	          (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 1 ' +
	          (coords.rightFullExtent - offset) + ' ' + (coords.targetY - coords.rightSmallArcRadius) +
	          'L' +
	          (coords.rightFullExtent - offset) + ' ' + coords.verticalRightInnerExtent +
	          'A' +
	          (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 1 ' +
	          coords.rightInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
	          'L' +
	          coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
	          'A' +
	          (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 1 ' +
	          (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent +
	          'L' +
	          (coords.leftFullExtent + offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) +
	          'A' +
	          (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 1 ' +
	          coords.leftInnerExtent + ' ' + (coords.sourceY + offset) +
	          'L' +
	          coords.sourceX + ' ' + (coords.sourceY + offset) +
	
	          // Walking back
	          'L' +
	          coords.sourceX + ' ' + (coords.sourceY - offset) +
	          'L' +
	          coords.leftInnerExtent + ' ' + (coords.sourceY - offset) +
	          'A' +
	          (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 0 ' +
	          (coords.leftFullExtent - offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) +
	          'L' +
	          (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent +
	          'A' +
	          (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 0 ' +
	          coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
	          'L' +
	          coords.rightInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
	          'A' +
	          (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 0 ' +
	          (coords.rightFullExtent + offset) + ' ' + coords.verticalRightInnerExtent +
	          'L' +
	          (coords.rightFullExtent + offset) + ' ' + (coords.targetY - coords.rightSmallArcRadius) +
	          'A' +
	          (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 0 ' +
	          coords.rightInnerExtent + ' ' + (coords.targetY - offset) +
	          'L' +
	          coords.targetX + ' ' + (coords.targetY - offset) +
	          'Z';
	    } else {
	        // Bottom path
	        pathString =
	          // start at the left of the target node
	          'M ' +
	          coords.targetX + ' ' + (coords.targetY - offset) + ' ' +
	          'L' +
	          coords.rightInnerExtent + ' ' + (coords.targetY - offset) +
	          'A' +
	          (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 0 ' +
	          (coords.rightFullExtent - offset) + ' ' + (coords.targetY + coords.rightSmallArcRadius) +
	          'L' +
	          (coords.rightFullExtent - offset) + ' ' + coords.verticalRightInnerExtent +
	          'A' +
	          (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 0 ' +
	          coords.rightInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
	          'L' +
	          coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
	          'A' +
	          (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 0 ' +
	          (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent +
	          'L' +
	          (coords.leftFullExtent + offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) +
	          'A' +
	          (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 0 ' +
	          coords.leftInnerExtent + ' ' + (coords.sourceY - offset) +
	          'L' +
	          coords.sourceX + ' ' + (coords.sourceY - offset) +
	
	          // Walking back
	          'L' +
	          coords.sourceX + ' ' + (coords.sourceY + offset) +
	          'L' +
	          coords.leftInnerExtent + ' ' + (coords.sourceY + offset) +
	          'A' +
	          (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 1 ' +
	          (coords.leftFullExtent - offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) +
	          'L' +
	          (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent +
	          'A' +
	          (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 1 ' +
	          coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
	          'L' +
	          coords.rightInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
	          'A' +
	          (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 1 ' +
	          (coords.rightFullExtent + offset) + ' ' + coords.verticalRightInnerExtent +
	          'L' +
	          (coords.rightFullExtent + offset) + ' ' + (coords.targetY + coords.rightSmallArcRadius) +
	          'A' +
	          (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 1 ' +
	          coords.rightInnerExtent + ' ' + (coords.targetY + offset) +
	          'L' +
	          coords.targetX + ' ' + (coords.targetY + offset) +
	          'Z';
	    }
	    return pathString;
	}
	
	function linkPath() {
	    var curvature = 0.5;
	    function path(d) {
	        if(d.link.circular) {
	            return createCircularClosedPathString(d.link);
	        } else {
	            var x0 = d.link.source.x1;
	            var x1 = d.link.target.x0;
	            var xi = interpolateNumber(x0, x1);
	            var x2 = xi(curvature);
	            var x3 = xi(1 - curvature);
	            var y0a = d.link.y0 - d.link.width / 2;
	            var y0b = d.link.y0 + d.link.width / 2;
	            var y1a = d.link.y1 - d.link.width / 2;
	            var y1b = d.link.y1 + d.link.width / 2;
	            return 'M' + x0 + ',' + y0a +
	                 'C' + x2 + ',' + y0a +
	                 ' ' + x3 + ',' + y1a +
	                 ' ' + x1 + ',' + y1a +
	                 'L' + x1 + ',' + y1b +
	                 'C' + x3 + ',' + y1b +
	                 ' ' + x2 + ',' + y0b +
	                 ' ' + x0 + ',' + y0b +
	                 'Z';
	        }
	    }
	    return path;
	}
	
	function nodeModel(d, n) {
	    var tc = tinycolor(n.color);
	    var zoneThicknessPad = c.nodePadAcross;
	    var zoneLengthPad = d.nodePad / 2;
	    n.dx = n.x1 - n.x0;
	    n.dy = n.y1 - n.y0;
	    var visibleThickness = n.dx;
	    var visibleLength = Math.max(0.5, n.dy);
	
	    var key = 'node_' + n.pointNumber;
	    // If it's a group, it's mutable and should be unique
	    if(n.group) {
	        key = Lib.randstr();
	    }
	
	    // for event data
	    n.trace = d.trace;
	    n.curveNumber = d.trace.index;
	
	    return {
	        index: n.pointNumber,
	        key: key,
	        partOfGroup: n.partOfGroup || false,
	        group: n.group,
	        traceId: d.key,
	        trace: d.trace,
	        node: n,
	        nodePad: d.nodePad,
	        nodeLineColor: d.nodeLineColor,
	        nodeLineWidth: d.nodeLineWidth,
	        textFont: d.textFont,
	        size: d.horizontal ? d.height : d.width,
	        visibleWidth: Math.ceil(visibleThickness),
	        visibleHeight: visibleLength,
	        zoneX: -zoneThicknessPad,
	        zoneY: -zoneLengthPad,
	        zoneWidth: visibleThickness + 2 * zoneThicknessPad,
	        zoneHeight: visibleLength + 2 * zoneLengthPad,
	        labelY: d.horizontal ? n.dy / 2 + 1 : n.dx / 2 + 1,
	        left: n.originalLayer === 1,
	        sizeAcross: d.width,
	        forceLayouts: d.forceLayouts,
	        horizontal: d.horizontal,
	        darkBackground: tc.getBrightness() <= 128,
	        tinyColorHue: Color.tinyRGB(tc),
	        tinyColorAlpha: tc.getAlpha(),
	        valueFormat: d.valueFormat,
	        valueSuffix: d.valueSuffix,
	        sankey: d.sankey,
	        graph: d.graph,
	        arrangement: d.arrangement,
	        uniqueNodeLabelPathId: [d.guid, d.key, key].join('_'),
	        interactionState: d.interactionState,
	        figure: d
	    };
	}
	
	// rendering snippets
	
	function updateNodePositions(sankeyNode) {
	    sankeyNode
	        .attr('transform', function(d) {
	            return 'translate(' + d.node.x0.toFixed(3) + ', ' + (d.node.y0).toFixed(3) + ')';
	        });
	}
	
	function updateNodeShapes(sankeyNode) {
	    sankeyNode.call(updateNodePositions);
	}
	
	function updateShapes(sankeyNode, sankeyLink) {
	    sankeyNode.call(updateNodeShapes);
	    sankeyLink.attr('d', linkPath());
	}
	
	function sizeNode(rect) {
	    rect
	      .attr('width', function(d) {return d.node.x1 - d.node.x0;})
	      .attr('height', function(d) {return d.visibleHeight;});
	}
	
	function salientEnough(d) {return (d.link.width > 1 || d.linkLineWidth > 0);}
	
	function sankeyTransform(d) {
	    var offset = 'translate(' + d.translateX + ',' + d.translateY + ')';
	    return offset + (d.horizontal ? 'matrix(1 0 0 1 0 0)' : 'matrix(0 1 1 0 0 0)');
	}
	
	function nodeCentering(d) {
	    return 'translate(' + (d.horizontal ? 0 : d.labelY) + ' ' + (d.horizontal ? d.labelY : 0) + ')';
	}
	
	function textGuidePath(d) {
	    return d3.svg.line()([
	        [d.horizontal ? (d.left ? -d.sizeAcross : d.visibleWidth + c.nodeTextOffsetHorizontal) : c.nodeTextOffsetHorizontal, 0],
	        [d.horizontal ? (d.left ? - c.nodeTextOffsetHorizontal : d.sizeAcross) : d.visibleHeight - c.nodeTextOffsetHorizontal, 0]
	    ]);
	}
	
	function sankeyInverseTransform(d) {return d.horizontal ? 'matrix(1 0 0 1 0 0)' : 'matrix(0 1 1 0 0 0)';}
	function textFlip(d) {return d.horizontal ? 'scale(1 1)' : 'scale(-1 1)';}
	function nodeTextColor(d) {return d.darkBackground && !d.horizontal ? 'rgb(255,255,255)' : 'rgb(0,0,0)';}
	function nodeTextOffset(d) {return d.horizontal && d.left ? '100%' : '0%';}
	
	// event handling
	
	function attachPointerEvents(selection, sankey, eventSet) {
	    selection
	        .on('.basic', null) // remove any preexisting handlers
	        .on('mouseover.basic', function(d) {
	            if(!d.interactionState.dragInProgress && !d.partOfGroup) {
	                eventSet.hover(this, d, sankey);
	                d.interactionState.hovered = [this, d];
	            }
	        })
	        .on('mousemove.basic', function(d) {
	            if(!d.interactionState.dragInProgress && !d.partOfGroup) {
	                eventSet.follow(this, d);
	                d.interactionState.hovered = [this, d];
	            }
	        })
	        .on('mouseout.basic', function(d) {
	            if(!d.interactionState.dragInProgress && !d.partOfGroup) {
	                eventSet.unhover(this, d, sankey);
	                d.interactionState.hovered = false;
	            }
	        })
	        .on('click.basic', function(d) {
	            if(d.interactionState.hovered) {
	                eventSet.unhover(this, d, sankey);
	                d.interactionState.hovered = false;
	            }
	            if(!d.interactionState.dragInProgress && !d.partOfGroup) {
	                eventSet.select(this, d, sankey);
	            }
	        });
	}
	
	function attachDragHandler(sankeyNode, sankeyLink, callbacks, gd) {
	    var dragBehavior = d3.behavior.drag()
	        .origin(function(d) {
	            return {
	                x: d.node.x0 + d.visibleWidth / 2,
	                y: d.node.y0 + d.visibleHeight / 2
	            };
	        })
	
	        .on('dragstart', function(d) {
	            if(d.arrangement === 'fixed') return;
	            Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'dragcover', function(s) {
	                gd._fullLayout._dragCover = s;
	            });
	            Lib.raiseToTop(this);
	            d.interactionState.dragInProgress = d.node;
	
	            saveCurrentDragPosition(d.node);
	            if(d.interactionState.hovered) {
	                callbacks.nodeEvents.unhover.apply(0, d.interactionState.hovered);
	                d.interactionState.hovered = false;
	            }
	            if(d.arrangement === 'snap') {
	                var forceKey = d.traceId + '|' + d.key;
	                if(d.forceLayouts[forceKey]) {
	                    d.forceLayouts[forceKey].alpha(1);
	                } else { // make a forceLayout if needed
	                    attachForce(sankeyNode, forceKey, d, gd);
	                }
	                startForce(sankeyNode, sankeyLink, d, forceKey, gd);
	            }
	        })
	
	        .on('drag', function(d) {
	            if(d.arrangement === 'fixed') return;
	            var x = d3.event.x;
	            var y = d3.event.y;
	            if(d.arrangement === 'snap') {
	                d.node.x0 = x - d.visibleWidth / 2;
	                d.node.x1 = x + d.visibleWidth / 2;
	                d.node.y0 = y - d.visibleHeight / 2;
	                d.node.y1 = y + d.visibleHeight / 2;
	            } else {
	                if(d.arrangement === 'freeform') {
	                    d.node.x0 = x - d.visibleWidth / 2;
	                    d.node.x1 = x + d.visibleWidth / 2;
	                }
	                y = Math.max(0, Math.min(d.size - d.visibleHeight / 2, y));
	                d.node.y0 = y - d.visibleHeight / 2;
	                d.node.y1 = y + d.visibleHeight / 2;
	            }
	
	            saveCurrentDragPosition(d.node);
	            if(d.arrangement !== 'snap') {
	                d.sankey.update(d.graph);
	                updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
	            }
	        })
	
	        .on('dragend', function(d) {
	            if(d.arrangement === 'fixed') return;
	            d.interactionState.dragInProgress = false;
	            for(var i = 0; i < d.node.childrenNodes.length; i++) {
	                d.node.childrenNodes[i].x = d.node.x;
	                d.node.childrenNodes[i].y = d.node.y;
	            }
	            if(d.arrangement !== 'snap') persistFinalNodePositions(d, gd);
	        });
	
	    sankeyNode
	        .on('.drag', null) // remove possible previous handlers
	        .call(dragBehavior);
	}
	
	function attachForce(sankeyNode, forceKey, d, gd) {
	    // Attach force to nodes in the same column (same x coordinate)
	    switchToForceFormat(d.graph.nodes);
	    var nodes = d.graph.nodes
	        .filter(function(n) {return n.originalX === d.node.originalX;})
	        // Filter out children
	        .filter(function(n) {return !n.partOfGroup;});
	    d.forceLayouts[forceKey] = d3Force.forceSimulation(nodes)
	        .alphaDecay(0)
	        .force('collide', d3Force.forceCollide()
	            .radius(function(n) {return n.dy / 2 + d.nodePad / 2;})
	            .strength(1)
	            .iterations(c.forceIterations))
	        .force('constrain', snappingForce(sankeyNode, forceKey, nodes, d, gd))
	        .stop();
	}
	
	function startForce(sankeyNode, sankeyLink, d, forceKey, gd) {
	    window.requestAnimationFrame(function faster() {
	        var i;
	        for(i = 0; i < c.forceTicksPerFrame; i++) {
	            d.forceLayouts[forceKey].tick();
	        }
	
	        var nodes = d.graph.nodes;
	        switchToSankeyFormat(nodes);
	
	        d.sankey.update(d.graph);
	        updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
	
	        if(d.forceLayouts[forceKey].alpha() > 0) {
	            window.requestAnimationFrame(faster);
	        } else {
	            // Make sure the final x position is equal to its original value
	            // because the force simulation will have numerical error
	            var x = d.node.originalX;
	            d.node.x0 = x - d.visibleWidth / 2;
	            d.node.x1 = x + d.visibleWidth / 2;
	
	            persistFinalNodePositions(d, gd);
	        }
	    });
	}
	
	function snappingForce(sankeyNode, forceKey, nodes, d) {
	    return function _snappingForce() {
	        var maxVelocity = 0;
	        for(var i = 0; i < nodes.length; i++) {
	            var n = nodes[i];
	            if(n === d.interactionState.dragInProgress) { // constrain node position to the dragging pointer
	                n.x = n.lastDraggedX;
	                n.y = n.lastDraggedY;
	            } else {
	                n.vx = (n.originalX - n.x) / c.forceTicksPerFrame; // snap to layer
	                n.y = Math.min(d.size - n.dy / 2, Math.max(n.dy / 2, n.y)); // constrain to extent
	            }
	            maxVelocity = Math.max(maxVelocity, Math.abs(n.vx), Math.abs(n.vy));
	        }
	        if(!d.interactionState.dragInProgress && maxVelocity < 0.1 && d.forceLayouts[forceKey].alpha() > 0) {
	            d.forceLayouts[forceKey].alpha(0); // This will stop the animation loop
	        }
	    };
	}
	
	// basic data utilities
	
	function persistFinalNodePositions(d, gd) {
	    var x = [];
	    var y = [];
	    for(var i = 0; i < d.graph.nodes.length; i++) {
	        var nodeX = (d.graph.nodes[i].x0 + d.graph.nodes[i].x1) / 2;
	        var nodeY = (d.graph.nodes[i].y0 + d.graph.nodes[i].y1) / 2;
	        x.push(nodeX / d.figure.width);
	        y.push(nodeY / d.figure.height);
	    }
	    Registry.call('_guiRestyle', gd, {
	        'node.x': [x],
	        'node.y': [y]
	    }, d.trace.index)
	    .then(function() {
	        if(gd._fullLayout._dragCover) gd._fullLayout._dragCover.remove();
	    });
	}
	
	function persistOriginalPlace(nodes) {
	    var distinctLayerPositions = [];
	    var i;
	    for(i = 0; i < nodes.length; i++) {
	        nodes[i].originalX = (nodes[i].x0 + nodes[i].x1) / 2;
	        nodes[i].originalY = (nodes[i].y0 + nodes[i].y1) / 2;
	        if(distinctLayerPositions.indexOf(nodes[i].originalX) === -1) {
	            distinctLayerPositions.push(nodes[i].originalX);
	        }
	    }
	    distinctLayerPositions.sort(function(a, b) {return a - b;});
	    for(i = 0; i < nodes.length; i++) {
	        nodes[i].originalLayerIndex = distinctLayerPositions.indexOf(nodes[i].originalX);
	        nodes[i].originalLayer = nodes[i].originalLayerIndex / (distinctLayerPositions.length - 1);
	    }
	}
	
	function saveCurrentDragPosition(d) {
	    d.lastDraggedX = d.x0 + d.dx / 2;
	    d.lastDraggedY = d.y0 + d.dy / 2;
	}
	
	function sameLayer(d) {
	    return function(n) {return n.node.originalX === d.node.originalX;};
	}
	
	function switchToForceFormat(nodes) {
	    // force uses x, y as centers
	    for(var i = 0; i < nodes.length; i++) {
	        nodes[i].y = (nodes[i].y0 + nodes[i].y1) / 2;
	        nodes[i].x = (nodes[i].x0 + nodes[i].x1) / 2;
	    }
	}
	
	function switchToSankeyFormat(nodes) {
	    // sankey uses x0, x1, y0, y1
	    for(var i = 0; i < nodes.length; i++) {
	        nodes[i].y0 = nodes[i].y - nodes[i].dy / 2;
	        nodes[i].y1 = nodes[i].y0 + nodes[i].dy;
	
	        nodes[i].x0 = nodes[i].x - nodes[i].dx / 2;
	        nodes[i].x1 = nodes[i].x0 + nodes[i].dx;
	    }
	}
	
	// scene graph
	module.exports = function(gd, svg, calcData, layout, callbacks) {
	    // To prevent animation on first render
	    var firstRender = false;
	    Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'first-render', function() {
	        firstRender = true;
	    });
	
	    // To prevent animation on dragging
	    var dragcover = gd._fullLayout._dragCover;
	
	    var styledData = calcData
	            .filter(function(d) {return unwrap(d).trace.visible;})
	            .map(sankeyModel.bind(null, layout));
	
	    var sankey = svg.selectAll('.' + c.cn.sankey)
	        .data(styledData, keyFun);
	
	    sankey.exit()
	        .remove();
	
	    sankey.enter()
	        .append('g')
	        .classed(c.cn.sankey, true)
	        .style('box-sizing', 'content-box')
	        .style('position', 'absolute')
	        .style('left', 0)
	        .style('shape-rendering', 'geometricPrecision')
	        .style('pointer-events', 'auto')
	        .attr('transform', sankeyTransform);
	
	    sankey.each(function(d, i) {
	        gd._fullData[i]._sankey = d;
	        // Create dragbox if missing
	        var dragboxClassName = 'bgsankey-' + d.trace.uid + '-' + i;
	        Lib.ensureSingle(gd._fullLayout._draggers, 'rect', dragboxClassName);
	
	        gd._fullData[i]._bgRect = d3.select('.' + dragboxClassName);
	
	        // Style dragbox
	        gd._fullData[i]._bgRect
	          .style('pointer-events', 'all')
	          .attr('width', d.width)
	          .attr('height', d.height)
	          .attr('x', d.translateX)
	          .attr('y', d.translateY)
	          .classed('bgsankey', true)
	          .style({fill: 'transparent', 'stroke-width': 0});
	    });
	
	    sankey.transition()
	        .ease(c.ease).duration(c.duration)
	        .attr('transform', sankeyTransform);
	
	    var sankeyLinks = sankey.selectAll('.' + c.cn.sankeyLinks)
	        .data(repeat, keyFun);
	
	    sankeyLinks.enter()
	        .append('g')
	        .classed(c.cn.sankeyLinks, true)
	        .style('fill', 'none');
	
	    var sankeyLink = sankeyLinks.selectAll('.' + c.cn.sankeyLink)
	          .data(function(d) {
	              var links = d.graph.links;
	              return links
	                .filter(function(l) {return l.value;})
	                .map(linkModel.bind(null, d));
	          }, keyFun);
	
	    sankeyLink
	          .enter().append('path')
	          .classed(c.cn.sankeyLink, true)
	          .call(attachPointerEvents, sankey, callbacks.linkEvents);
	
	    sankeyLink
	        .style('stroke', function(d) {
	            return salientEnough(d) ? Color.tinyRGB(tinycolor(d.linkLineColor)) : d.tinyColorHue;
	        })
	        .style('stroke-opacity', function(d) {
	            return salientEnough(d) ? Color.opacity(d.linkLineColor) : d.tinyColorAlpha;
	        })
	        .style('fill', function(d) {
	            return d.tinyColorHue;
	        })
	        .style('fill-opacity', function(d) {
	            return d.tinyColorAlpha;
	        })
	        .style('stroke-width', function(d) {
	            return salientEnough(d) ? d.linkLineWidth : 1;
	        })
	        .attr('d', linkPath());
	
	    sankeyLink
	        .style('opacity', function() { return (gd._context.staticPlot || firstRender || dragcover) ? 1 : 0;})
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .style('opacity', 1);
	
	    sankeyLink.exit()
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .style('opacity', 0)
	        .remove();
	
	    var sankeyNodeSet = sankey.selectAll('.' + c.cn.sankeyNodeSet)
	        .data(repeat, keyFun);
	
	    sankeyNodeSet.enter()
	        .append('g')
	        .classed(c.cn.sankeyNodeSet, true);
	
	    sankeyNodeSet
	        .style('cursor', function(d) {
	            switch(d.arrangement) {
	                case 'fixed': return 'default';
	                case 'perpendicular': return 'ns-resize';
	                default: return 'move';
	            }
	        });
	
	    var sankeyNode = sankeyNodeSet.selectAll('.' + c.cn.sankeyNode)
	        .data(function(d) {
	            var nodes = d.graph.nodes;
	            persistOriginalPlace(nodes);
	            return nodes
	              .map(nodeModel.bind(null, d));
	        }, keyFun);
	
	    sankeyNode.enter()
	        .append('g')
	        .classed(c.cn.sankeyNode, true)
	        .call(updateNodePositions)
	        .style('opacity', function(n) { return ((gd._context.staticPlot || firstRender) && !n.partOfGroup) ? 1 : 0;});
	
	    sankeyNode
	        .call(attachPointerEvents, sankey, callbacks.nodeEvents)
	        .call(attachDragHandler, sankeyLink, callbacks, gd); // has to be here as it binds sankeyLink
	
	    sankeyNode
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .call(updateNodePositions)
	        .style('opacity', function(n) { return n.partOfGroup ? 0 : 1;});
	
	    sankeyNode.exit()
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .style('opacity', 0)
	        .remove();
	
	    var nodeRect = sankeyNode.selectAll('.' + c.cn.nodeRect)
	        .data(repeat);
	
	    nodeRect.enter()
	        .append('rect')
	        .classed(c.cn.nodeRect, true)
	        .call(sizeNode);
	
	    nodeRect
	        .style('stroke-width', function(d) {return d.nodeLineWidth;})
	        .style('stroke', function(d) {return Color.tinyRGB(tinycolor(d.nodeLineColor));})
	        .style('stroke-opacity', function(d) {return Color.opacity(d.nodeLineColor);})
	        .style('fill', function(d) {return d.tinyColorHue;})
	        .style('fill-opacity', function(d) {return d.tinyColorAlpha;});
	
	    nodeRect.transition()
	        .ease(c.ease).duration(c.duration)
	        .call(sizeNode);
	
	    var nodeCapture = sankeyNode.selectAll('.' + c.cn.nodeCapture)
	        .data(repeat);
	
	    nodeCapture.enter()
	        .append('rect')
	        .classed(c.cn.nodeCapture, true)
	        .style('fill-opacity', 0);
	
	    nodeCapture
	        .attr('x', function(d) {return d.zoneX;})
	        .attr('y', function(d) {return d.zoneY;})
	        .attr('width', function(d) {return d.zoneWidth;})
	        .attr('height', function(d) {return d.zoneHeight;});
	
	    var nodeCentered = sankeyNode.selectAll('.' + c.cn.nodeCentered)
	        .data(repeat);
	
	    nodeCentered.enter()
	        .append('g')
	        .classed(c.cn.nodeCentered, true)
	        .attr('transform', nodeCentering);
	
	    nodeCentered
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .attr('transform', nodeCentering);
	
	    var nodeLabelGuide = nodeCentered.selectAll('.' + c.cn.nodeLabelGuide)
	        .data(repeat);
	
	    nodeLabelGuide.enter()
	        .append('path')
	        .classed(c.cn.nodeLabelGuide, true)
	        .attr('id', function(d) {return d.uniqueNodeLabelPathId;})
	        .attr('d', textGuidePath)
	        .attr('transform', sankeyInverseTransform);
	
	    nodeLabelGuide
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .attr('d', textGuidePath)
	        .attr('transform', sankeyInverseTransform);
	
	    var nodeLabel = nodeCentered.selectAll('.' + c.cn.nodeLabel)
	        .data(repeat);
	
	    nodeLabel.enter()
	        .append('text')
	        .classed(c.cn.nodeLabel, true)
	        .attr('transform', textFlip)
	        .style('user-select', 'none')
	        .style('cursor', 'default')
	        .style('fill', 'black');
	
	    nodeLabel
	        .style('text-shadow', function(d) {
	            return d.horizontal ? '-1px 1px 1px #fff, 1px 1px 1px #fff, 1px -1px 1px #fff, -1px -1px 1px #fff' : 'none';
	        })
	        .each(function(d) {Drawing.font(nodeLabel, d.textFont);});
	
	    nodeLabel
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .attr('transform', textFlip);
	
	    var nodeLabelTextPath = nodeLabel.selectAll('.' + c.cn.nodeLabelTextPath)
	        .data(repeat);
	
	    nodeLabelTextPath.enter()
	        .append('textPath')
	        .classed(c.cn.nodeLabelTextPath, true)
	        .attr('alignment-baseline', 'middle')
	        .attr('xlink:href', function(d) {return '#' + d.uniqueNodeLabelPathId;})
	        .attr('startOffset', nodeTextOffset)
	        .style('fill', nodeTextColor);
	
	    nodeLabelTextPath
	        .text(function(d) {return d.horizontal || d.node.dy > 5 ? d.node.label : '';})
	        .attr('text-anchor', function(d) {return d.horizontal && d.left ? 'end' : 'start';});
	
	    nodeLabelTextPath
	        .transition()
	        .ease(c.ease).duration(c.duration)
	        .attr('startOffset', nodeTextOffset)
	        .style('fill', nodeTextColor);
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../lib":716,"../../lib/gup":714,"../../registry":845,"./constants":1111,"@plotly/d3-sankey":56,"@plotly/d3-sankey-circular":55,"d3":164,"d3-force":157,"d3-interpolate":159,"tinycolor2":535}],1116:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var selection = [];
	    var fullData = cd[0].trace;
	
	    var nodes = fullData._sankey.graph.nodes;
	
	    for(var i = 0; i < nodes.length; i++) {
	        var node = nodes[i];
	        if(node.partOfGroup) continue; // Those are invisible
	
	        // Position of node's centroid
	        var pos = [(node.x0 + node.x1) / 2, (node.y0 + node.y1) / 2];
	
	        // Swap x and y if trace is vertical
	        if(fullData.orientation === 'v') pos.reverse();
	
	        if(selectionTester && selectionTester.contains(pos, false, i, searchInfo)) {
	            selection.push({
	                pointNumber: node.pointNumber
	                // TODO: add eventData
	            });
	        }
	    }
	    return selection;
	};
	
	},{}],1117:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	
	// arrayOk attributes, merge them into calcdata array
	module.exports = function arraysToCalcdata(cd, trace) {
	    // so each point knows which index it originally came from
	    for(var i = 0; i < cd.length; i++) cd[i].i = i;
	
	    Lib.mergeArray(trace.text, cd, 'tx');
	    Lib.mergeArray(trace.texttemplate, cd, 'txt');
	    Lib.mergeArray(trace.hovertext, cd, 'htx');
	    Lib.mergeArray(trace.customdata, cd, 'data');
	    Lib.mergeArray(trace.textposition, cd, 'tp');
	    if(trace.textfont) {
	        Lib.mergeArrayCastPositive(trace.textfont.size, cd, 'ts');
	        Lib.mergeArray(trace.textfont.color, cd, 'tc');
	        Lib.mergeArray(trace.textfont.family, cd, 'tf');
	    }
	
	    var marker = trace.marker;
	    if(marker) {
	        Lib.mergeArrayCastPositive(marker.size, cd, 'ms');
	        Lib.mergeArrayCastPositive(marker.opacity, cd, 'mo');
	        Lib.mergeArray(marker.symbol, cd, 'mx');
	        Lib.mergeArray(marker.color, cd, 'mc');
	
	        var markerLine = marker.line;
	        if(marker.line) {
	            Lib.mergeArray(markerLine.color, cd, 'mlc');
	            Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
	        }
	
	        var markerGradient = marker.gradient;
	        if(markerGradient && markerGradient.type !== 'none') {
	            Lib.mergeArray(markerGradient.type, cd, 'mgt');
	            Lib.mergeArray(markerGradient.color, cd, 'mgc');
	        }
	    }
	};
	
	},{"../../lib":716}],1118:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	
	var Drawing = _dereq_('../../components/drawing');
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    x: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        anim: true,
	        
	    },
	    x0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        anim: true,
	        
	    },
	    dx: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        anim: true,
	        
	    },
	    y: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        anim: true,
	        
	    },
	    y0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        anim: true,
	        
	    },
	    dy: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        anim: true,
	        
	    },
	
	    stackgroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	    orientation: {
	        valType: 'enumerated',
	        
	        values: ['v', 'h'],
	        editType: 'calc',
	        
	    },
	    groupnorm: {
	        valType: 'enumerated',
	        values: ['', 'fraction', 'percent'],
	        dflt: '',
	        
	        editType: 'calc',
	        
	    },
	    stackgaps: {
	        valType: 'enumerated',
	        values: ['infer zero', 'interpolate'],
	        dflt: 'infer zero',
	        
	        editType: 'calc',
	        
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'calc',
	        
	    },
	
	    texttemplate: texttemplateAttrs({}, {
	
	    }),
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        editType: 'style',
	        
	    },
	    mode: {
	        valType: 'flaglist',
	        flags: ['lines', 'markers', 'text'],
	        extras: ['none'],
	        
	        editType: 'calc',
	        
	    },
	    hoveron: {
	        valType: 'flaglist',
	        flags: ['points', 'fills'],
	        
	        editType: 'style',
	        
	    },
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	    line: {
	        color: {
	            valType: 'color',
	            
	            editType: 'style',
	            anim: true,
	            
	        },
	        width: {
	            valType: 'number',
	            min: 0,
	            dflt: 2,
	            
	            editType: 'style',
	            anim: true,
	            
	        },
	        shape: {
	            valType: 'enumerated',
	            values: ['linear', 'spline', 'hv', 'vh', 'hvh', 'vhv'],
	            dflt: 'linear',
	            
	            editType: 'plot',
	            
	        },
	        smoothing: {
	            valType: 'number',
	            min: 0,
	            max: 1.3,
	            dflt: 1,
	            
	            editType: 'plot',
	            
	        },
	        dash: extendFlat({}, dash, {editType: 'style'}),
	        simplify: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        editType: 'plot'
	    },
	
	    connectgaps: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    cliponaxis: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'plot',
	        
	    },
	
	    fill: {
	        valType: 'enumerated',
	        values: ['none', 'tozeroy', 'tozerox', 'tonexty', 'tonextx', 'toself', 'tonext'],
	        
	        editType: 'calc',
	        
	    },
	    fillcolor: {
	        valType: 'color',
	        
	        editType: 'style',
	        anim: true,
	        
	    },
	    marker: extendFlat({
	        symbol: {
	            valType: 'enumerated',
	            values: Drawing.symbolList,
	            dflt: 'circle',
	            arrayOk: true,
	            
	            editType: 'style',
	            
	        },
	        opacity: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            arrayOk: true,
	            
	            editType: 'style',
	            anim: true,
	            
	        },
	        size: {
	            valType: 'number',
	            min: 0,
	            dflt: 6,
	            arrayOk: true,
	            
	            editType: 'calc',
	            anim: true,
	            
	        },
	        maxdisplayed: {
	            valType: 'number',
	            min: 0,
	            dflt: 0,
	            
	            editType: 'plot',
	            
	        },
	        sizeref: {
	            valType: 'number',
	            dflt: 1,
	            
	            editType: 'calc',
	            
	        },
	        sizemin: {
	            valType: 'number',
	            min: 0,
	            dflt: 0,
	            
	            editType: 'calc',
	            
	        },
	        sizemode: {
	            valType: 'enumerated',
	            values: ['diameter', 'area'],
	            dflt: 'diameter',
	            
	            editType: 'calc',
	            
	        },
	
	        line: extendFlat({
	            width: {
	                valType: 'number',
	                min: 0,
	                arrayOk: true,
	                
	                editType: 'style',
	                anim: true,
	                
	            },
	            editType: 'calc'
	        },
	            colorScaleAttrs('marker.line', {anim: true})
	        ),
	        gradient: {
	            type: {
	                valType: 'enumerated',
	                values: ['radial', 'horizontal', 'vertical', 'none'],
	                arrayOk: true,
	                dflt: 'none',
	                
	                editType: 'calc',
	                
	            },
	            color: {
	                valType: 'color',
	                arrayOk: true,
	                
	                editType: 'calc',
	                
	            },
	            editType: 'calc'
	        },
	        editType: 'calc'
	    },
	        colorScaleAttrs('marker', {anim: true})
	    ),
	    selected: {
	        marker: {
	            opacity: {
	                valType: 'number',
	                min: 0,
	                max: 1,
	                
	                editType: 'style',
	                
	            },
	            color: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            size: {
	                valType: 'number',
	                min: 0,
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        textfont: {
	            color: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        editType: 'style'
	    },
	    unselected: {
	        marker: {
	            opacity: {
	                valType: 'number',
	                min: 0,
	                max: 1,
	                
	                editType: 'style',
	                
	            },
	            color: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            size: {
	                valType: 'number',
	                min: 0,
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        textfont: {
	            color: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        editType: 'style'
	    },
	
	    textposition: {
	        valType: 'enumerated',
	        values: [
	            'top left', 'top center', 'top right',
	            'middle left', 'middle center', 'middle right',
	            'bottom left', 'bottom center', 'bottom right'
	        ],
	        dflt: 'middle center',
	        arrayOk: true,
	        
	        editType: 'calc',
	        
	    },
	    textfont: fontAttrs({
	        editType: 'calc',
	        colorEditType: 'style',
	        arrayOk: true,
	        
	    }),
	
	    r: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    t: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    }
	};
	
	},{"../../components/colorscale/attributes":598,"../../components/drawing":612,"../../components/drawing/attributes":611,"../../lib/extend":707,"../../plots/font_attributes":790,"../../plots/template_attributes":840,"./constants":1122}],1119:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var Lib = _dereq_('../../lib');
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var subTypes = _dereq_('./subtypes');
	var calcColorscale = _dereq_('./colorscale_calc');
	var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
	var calcSelection = _dereq_('./calc_selection');
	
	function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var x = xa.makeCalcdata(trace, 'x');
	    var y = ya.makeCalcdata(trace, 'y');
	    var serieslen = trace._length;
	    var cd = new Array(serieslen);
	    var ids = trace.ids;
	    var stackGroupOpts = getStackOpts(trace, fullLayout, xa, ya);
	    var interpolateGaps = false;
	    var isV, i, j, k, interpolate, vali;
	
	    setFirstScatter(fullLayout, trace);
	
	    var xAttr = 'x';
	    var yAttr = 'y';
	    var posAttr;
	    if(stackGroupOpts) {
	        Lib.pushUnique(stackGroupOpts.traceIndices, trace._expandedIndex);
	        isV = stackGroupOpts.orientation === 'v';
	
	        // size, like we use for bar
	        if(isV) {
	            yAttr = 's';
	            posAttr = 'x';
	        } else {
	            xAttr = 's';
	            posAttr = 'y';
	        }
	        interpolate = stackGroupOpts.stackgaps === 'interpolate';
	    } else {
	        var ppad = calcMarkerSize(trace, serieslen);
	        calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	    }
	
	    for(i = 0; i < serieslen; i++) {
	        var cdi = cd[i] = {};
	        var xValid = isNumeric(x[i]);
	        var yValid = isNumeric(y[i]);
	        if(xValid && yValid) {
	            cdi[xAttr] = x[i];
	            cdi[yAttr] = y[i];
	        } else if(stackGroupOpts && (isV ? xValid : yValid)) {
	            // if we're stacking we need to hold on to all valid positions
	            // even with invalid sizes
	
	            cdi[posAttr] = isV ? x[i] : y[i];
	            cdi.gap = true;
	            if(interpolate) {
	                cdi.s = BADNUM;
	                interpolateGaps = true;
	            } else {
	                cdi.s = 0;
	            }
	        } else {
	            cdi[xAttr] = cdi[yAttr] = BADNUM;
	        }
	
	        if(ids) {
	            cdi.id = String(ids[i]);
	        }
	    }
	
	    arraysToCalcdata(cd, trace);
	    calcColorscale(gd, trace);
	    calcSelection(cd, trace);
	
	    if(stackGroupOpts) {
	        // remove bad positions and sort
	        // note that original indices get added to cd in arraysToCalcdata
	        i = 0;
	        while(i < cd.length) {
	            if(cd[i][posAttr] === BADNUM) {
	                cd.splice(i, 1);
	            } else i++;
	        }
	
	        Lib.sort(cd, function(a, b) {
	            return (a[posAttr] - b[posAttr]) || (a.i - b.i);
	        });
	
	        if(interpolateGaps) {
	            // first fill the beginning with constant from the first point
	            i = 0;
	            while(i < cd.length - 1 && cd[i].gap) {
	                i++;
	            }
	            vali = cd[i].s;
	            if(!vali) vali = cd[i].s = 0; // in case of no data AT ALL in this trace - use 0
	            for(j = 0; j < i; j++) {
	                cd[j].s = vali;
	            }
	            // then fill the end with constant from the last point
	            k = cd.length - 1;
	            while(k > i && cd[k].gap) {
	                k--;
	            }
	            vali = cd[k].s;
	            for(j = cd.length - 1; j > k; j--) {
	                cd[j].s = vali;
	            }
	            // now interpolate internal gaps linearly
	            while(i < k) {
	                i++;
	                if(cd[i].gap) {
	                    j = i + 1;
	                    while(cd[j].gap) {
	                        j++;
	                    }
	                    var pos0 = cd[i - 1][posAttr];
	                    var size0 = cd[i - 1].s;
	                    var m = (cd[j].s - size0) / (cd[j][posAttr] - pos0);
	                    while(i < j) {
	                        cd[i].s = size0 + (cd[i][posAttr] - pos0) * m;
	                        i++;
	                    }
	                }
	            }
	        }
	    }
	
	    return cd;
	}
	
	function calcAxisExpansion(gd, trace, xa, ya, x, y, ppad) {
	    var serieslen = trace._length;
	    var fullLayout = gd._fullLayout;
	    var xId = xa._id;
	    var yId = ya._id;
	    var firstScatter = fullLayout._firstScatter[firstScatterGroup(trace)] === trace.uid;
	    var stackOrientation = (getStackOpts(trace, fullLayout, xa, ya) || {}).orientation;
	    var fill = trace.fill;
	
	    // cancel minimum tick spacings (only applies to bars and boxes)
	    xa._minDtick = 0;
	    ya._minDtick = 0;
	
	    // check whether bounds should be tight, padded, extended to zero...
	    // most cases both should be padded on both ends, so start with that.
	    var xOptions = {padded: true};
	    var yOptions = {padded: true};
	
	    if(ppad) {
	        xOptions.ppad = yOptions.ppad = ppad;
	    }
	
	    // TODO: text size
	
	    var openEnded = serieslen < 2 || (x[0] !== x[serieslen - 1]) || (y[0] !== y[serieslen - 1]);
	
	    if(openEnded && (
	        (fill === 'tozerox') ||
	        ((fill === 'tonextx') && (firstScatter || stackOrientation === 'h'))
	    )) {
	        // include zero (tight) and extremes (padded) if fill to zero
	        // (unless the shape is closed, then it's just filling the shape regardless)
	
	        xOptions.tozero = true;
	    } else if(!(trace.error_y || {}).visible && (
	        // if no error bars, markers or text, or fill to y=0 remove x padding
	
	            (fill === 'tonexty' || fill === 'tozeroy') ||
	            (!subTypes.hasMarkers(trace) && !subTypes.hasText(trace))
	        )) {
	        xOptions.padded = false;
	        xOptions.ppad = 0;
	    }
	
	    if(openEnded && (
	        (fill === 'tozeroy') ||
	        ((fill === 'tonexty') && (firstScatter || stackOrientation === 'v'))
	    )) {
	        // now check for y - rather different logic, though still mostly padded both ends
	        // include zero (tight) and extremes (padded) if fill to zero
	        // (unless the shape is closed, then it's just filling the shape regardless)
	
	        yOptions.tozero = true;
	    } else if(fill === 'tonextx' || fill === 'tozerox') {
	        // tight y: any x fill
	
	        yOptions.padded = false;
	    }
	
	    // N.B. asymmetric splom traces call this with blank {} xa or ya
	    if(xId) trace._extremes[xId] = Axes.findExtremes(xa, x, xOptions);
	    if(yId) trace._extremes[yId] = Axes.findExtremes(ya, y, yOptions);
	}
	
	function calcMarkerSize(trace, serieslen) {
	    if(!subTypes.hasMarkers(trace)) return;
	
	    // Treat size like x or y arrays --- Run d2c
	    // this needs to go before ppad computation
	    var marker = trace.marker;
	    var sizeref = 1.6 * (trace.marker.sizeref || 1);
	    var markerTrans;
	
	    if(trace.marker.sizemode === 'area') {
	        markerTrans = function(v) {
	            return Math.max(Math.sqrt((v || 0) / sizeref), 3);
	        };
	    } else {
	        markerTrans = function(v) {
	            return Math.max((v || 0) / sizeref, 3);
	        };
	    }
	
	    if(Lib.isArrayOrTypedArray(marker.size)) {
	        // I tried auto-type but category and dates dont make much sense.
	        var ax = {type: 'linear'};
	        Axes.setConvert(ax);
	
	        var s = ax.makeCalcdata(trace.marker, 'size');
	
	        var sizeOut = new Array(serieslen);
	        for(var i = 0; i < serieslen; i++) {
	            sizeOut[i] = markerTrans(s[i]);
	        }
	        return sizeOut;
	    } else {
	        return markerTrans(marker.size);
	    }
	}
	
	/**
	 * mark the first scatter trace for each subplot
	 * note that scatter and scattergl each get their own first trace
	 * note also that I'm doing this during calc rather than supplyDefaults
	 * so I don't need to worry about transforms, but if we ever do
	 * per-trace calc this will get confused.
	 */
	function setFirstScatter(fullLayout, trace) {
	    var group = firstScatterGroup(trace);
	    var firstScatter = fullLayout._firstScatter;
	    if(!firstScatter[group]) firstScatter[group] = trace.uid;
	}
	
	function firstScatterGroup(trace) {
	    var stackGroup = trace.stackgroup;
	    return trace.xaxis + trace.yaxis + trace.type +
	        (stackGroup ? '-' + stackGroup : '');
	}
	
	function getStackOpts(trace, fullLayout, xa, ya) {
	    var stackGroup = trace.stackgroup;
	    if(!stackGroup) return;
	    var stackOpts = fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup];
	    var stackAx = stackOpts.orientation === 'v' ? ya : xa;
	    // Allow stacking only on numeric axes
	    // calc is a little late to be figuring this out, but during supplyDefaults
	    // we don't know the axis type yet
	    if(stackAx.type === 'linear' || stackAx.type === 'log') return stackOpts;
	}
	
	module.exports = {
	    calc: calc,
	    calcMarkerSize: calcMarkerSize,
	    calcAxisExpansion: calcAxisExpansion,
	    setFirstScatter: setFirstScatter,
	    getStackOpts: getStackOpts
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axes":764,"./arrays_to_calcdata":1117,"./calc_selection":1120,"./colorscale_calc":1121,"./subtypes":1142,"fast-isnumeric":227}],1120:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	module.exports = function calcSelection(cd, trace) {
	    if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	        Lib.tagSelected(cd, trace);
	    }
	};
	
	},{"../../lib":716}],1121:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var calcColorscale = _dereq_('../../components/colorscale/calc');
	
	var subTypes = _dereq_('./subtypes');
	
	module.exports = function calcMarkerColorscale(gd, trace) {
	    if(subTypes.hasLines(trace) && hasColorscale(trace, 'line')) {
	        calcColorscale(gd, trace, {
	            vals: trace.line.color,
	            containerStr: 'line',
	            cLetter: 'c'
	        });
	    }
	
	    if(subTypes.hasMarkers(trace)) {
	        if(hasColorscale(trace, 'marker')) {
	            calcColorscale(gd, trace, {
	                vals: trace.marker.color,
	                containerStr: 'marker',
	                cLetter: 'c'
	            });
	        }
	        if(hasColorscale(trace, 'marker.line')) {
	            calcColorscale(gd, trace, {
	                vals: trace.marker.line.color,
	                containerStr: 'marker.line',
	                cLetter: 'c'
	            });
	        }
	    }
	};
	
	},{"../../components/colorscale/calc":599,"../../components/colorscale/helpers":602,"./subtypes":1142}],1122:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    PTS_LINESONLY: 20,
	
	    // fixed parameters of clustering and clipping algorithms
	
	    // fraction of clustering tolerance "so close we don't even consider it a new point"
	    minTolerance: 0.2,
	    // how fast does clustering tolerance increase as you get away from the visible region
	    toleranceGrowth: 10,
	
	    // number of viewport sizes away from the visible region
	    // at which we clip all lines to the perimeter
	    maxScreensAway: 20,
	
	    eventDataKeys: []
	};
	
	},{}],1123:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var calc = _dereq_('./calc');
	
	/*
	 * Scatter stacking & normalization calculations
	 * runs per subplot, and can handle multiple stacking groups
	 */
	
	module.exports = function crossTraceCalc(gd, plotinfo) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var subplot = xa._id + ya._id;
	
	    var subplotStackOpts = gd._fullLayout._scatterStackOpts[subplot];
	    if(!subplotStackOpts) return;
	
	    var calcTraces = gd.calcdata;
	
	    var i, j, k, i2, cd, cd0, posj, sumj, norm;
	    var groupOpts, interpolate, groupnorm, posAttr, valAttr;
	    var hasAnyBlanks;
	
	    for(var stackGroup in subplotStackOpts) {
	        groupOpts = subplotStackOpts[stackGroup];
	        var indices = groupOpts.traceIndices;
	
	        // can get here with no indices if the stack axis is non-numeric
	        if(!indices.length) continue;
	
	        interpolate = groupOpts.stackgaps === 'interpolate';
	        groupnorm = groupOpts.groupnorm;
	        if(groupOpts.orientation === 'v') {
	            posAttr = 'x';
	            valAttr = 'y';
	        } else {
	            posAttr = 'y';
	            valAttr = 'x';
	        }
	        hasAnyBlanks = new Array(indices.length);
	        for(i = 0; i < hasAnyBlanks.length; i++) {
	            hasAnyBlanks[i] = false;
	        }
	
	        // Collect the complete set of all positions across ALL traces.
	        // Start with the first trace, then interleave items from later traces
	        // as needed.
	        // Fill in mising items as we go.
	        cd0 = calcTraces[indices[0]];
	        var allPositions = new Array(cd0.length);
	        for(i = 0; i < cd0.length; i++) {
	            allPositions[i] = cd0[i][posAttr];
	        }
	
	        for(i = 1; i < indices.length; i++) {
	            cd = calcTraces[indices[i]];
	
	            for(j = k = 0; j < cd.length; j++) {
	                posj = cd[j][posAttr];
	                for(; posj > allPositions[k] && k < allPositions.length; k++) {
	                    // the current trace is missing a position from some previous trace(s)
	                    insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
	                    j++;
	                }
	                if(posj !== allPositions[k]) {
	                    // previous trace(s) are missing a position from the current trace
	                    for(i2 = 0; i2 < i; i2++) {
	                        insertBlank(calcTraces[indices[i2]], k, posj, i2, hasAnyBlanks, interpolate, posAttr);
	                    }
	                    allPositions.splice(k, 0, posj);
	                }
	                k++;
	            }
	            for(; k < allPositions.length; k++) {
	                insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
	                j++;
	            }
	        }
	
	        var serieslen = allPositions.length;
	
	        // stack (and normalize)!
	        for(j = 0; j < cd0.length; j++) {
	            sumj = cd0[j][valAttr] = cd0[j].s;
	            for(i = 1; i < indices.length; i++) {
	                cd = calcTraces[indices[i]];
	                cd[0].trace._rawLength = cd[0].trace._length;
	                cd[0].trace._length = serieslen;
	                sumj += cd[j].s;
	                cd[j][valAttr] = sumj;
	            }
	
	            if(groupnorm) {
	                norm = ((groupnorm === 'fraction') ? sumj : (sumj / 100)) || 1;
	                for(i = 0; i < indices.length; i++) {
	                    var cdj = calcTraces[indices[i]][j];
	                    cdj[valAttr] /= norm;
	                    cdj.sNorm = cdj.s / norm;
	                }
	            }
	        }
	
	        // autorange
	        for(i = 0; i < indices.length; i++) {
	            cd = calcTraces[indices[i]];
	            var trace = cd[0].trace;
	            var ppad = calc.calcMarkerSize(trace, trace._rawLength);
	            var arrayPad = Array.isArray(ppad);
	            if((ppad && hasAnyBlanks[i]) || arrayPad) {
	                var ppadRaw = ppad;
	                ppad = new Array(serieslen);
	                for(j = 0; j < serieslen; j++) {
	                    ppad[j] = cd[j].gap ? 0 : (arrayPad ? ppadRaw[cd[j].i] : ppadRaw);
	                }
	            }
	            var x = new Array(serieslen);
	            var y = new Array(serieslen);
	            for(j = 0; j < serieslen; j++) {
	                x[j] = cd[j].x;
	                y[j] = cd[j].y;
	            }
	            calc.calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	
	            // while we're here (in a loop over all traces in the stack)
	            // record the orientation, so hover can find it easily
	            cd[0].t.orientation = groupOpts.orientation;
	        }
	    }
	};
	
	function insertBlank(calcTrace, index, position, traceIndex, hasAnyBlanks, interpolate, posAttr) {
	    hasAnyBlanks[traceIndex] = true;
	    var newEntry = {
	        i: null,
	        gap: true,
	        s: 0
	    };
	    newEntry[posAttr] = position;
	    calcTrace.splice(index, 0, newEntry);
	    // Even if we're not interpolating, if one trace has multiple
	    // values at the same position and this trace only has one value there,
	    // we just duplicate that one value rather than insert a zero.
	    // We also make it look like a real point - because it's ambiguous which
	    // one really is the real one!
	    if(index && position === calcTrace[index - 1][posAttr]) {
	        var prevEntry = calcTrace[index - 1];
	        newEntry.s = prevEntry.s;
	        // TODO is it going to cause any problems to have multiple
	        // calcdata points with the same index?
	        newEntry.i = prevEntry.i;
	        newEntry.gap = prevEntry.gap;
	    } else if(interpolate) {
	        newEntry.s = getInterp(calcTrace, index, position, posAttr);
	    }
	    if(!index) {
	        // t and trace need to stay on the first cd entry
	        calcTrace[0].t = calcTrace[1].t;
	        calcTrace[0].trace = calcTrace[1].trace;
	        delete calcTrace[1].t;
	        delete calcTrace[1].trace;
	    }
	}
	
	function getInterp(calcTrace, index, position, posAttr) {
	    var pt0 = calcTrace[index - 1];
	    var pt1 = calcTrace[index + 1];
	    if(!pt1) return pt0.s;
	    if(!pt0) return pt1.s;
	    return pt0.s + (pt1.s - pt0.s) * (position - pt0[posAttr]) / (pt1[posAttr] - pt0[posAttr]);
	}
	
	},{"./calc":1119}],1124:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	// remove opacity for any trace that has a fill or is filled to
	module.exports = function crossTraceDefaults(fullData) {
	    for(var i = 0; i < fullData.length; i++) {
	        var tracei = fullData[i];
	        if(tracei.type !== 'scatter') continue;
	
	        var filli = tracei.fill;
	        if(filli === 'none' || filli === 'toself') continue;
	
	        tracei.opacity = undefined;
	
	        if(filli === 'tonexty' || filli === 'tonextx') {
	            for(var j = i - 1; j >= 0; j--) {
	                var tracej = fullData[j];
	
	                if((tracej.type === 'scatter') &&
	                        (tracej.xaxis === tracei.xaxis) &&
	                        (tracej.yaxis === tracei.yaxis)) {
	                    tracej.opacity = undefined;
	                    break;
	                }
	            }
	        }
	    }
	};
	
	},{}],1125:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('./constants');
	var subTypes = _dereq_('./subtypes');
	var handleXYDefaults = _dereq_('./xy_defaults');
	var handleStackDefaults = _dereq_('./stack_defaults');
	var handleMarkerDefaults = _dereq_('./marker_defaults');
	var handleLineDefaults = _dereq_('./line_defaults');
	var handleLineShapeDefaults = _dereq_('./line_shape_defaults');
	var handleTextDefaults = _dereq_('./text_defaults');
	var handleFillColorDefaults = _dereq_('./fillcolor_defaults');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) traceOut.visible = false;
	
	    if(!traceOut.visible) return;
	
	    var stackGroupOpts = handleStackDefaults(traceIn, traceOut, layout, coerce);
	
	    var defaultMode = !stackGroupOpts && (len < constants.PTS_LINESONLY) ?
	        'lines+markers' : 'lines';
	    coerce('text');
	    coerce('hovertext');
	    coerce('mode', defaultMode);
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        handleLineShapeDefaults(traceIn, traceOut, coerce);
	        coerce('connectgaps');
	        coerce('line.simplify');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    var dfltHoverOn = [];
	
	    if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	        coerce('cliponaxis');
	        coerce('marker.maxdisplayed');
	        dfltHoverOn.push('points');
	    }
	
	    // It's possible for this default to be changed by a later trace.
	    // We handle that case in some hacky code inside handleStackDefaults.
	    coerce('fill', stackGroupOpts ? stackGroupOpts.fillDflt : 'none');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	        if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	    }
	
	    var lineColor = (traceOut.line || {}).color;
	    var markerColor = (traceOut.marker || {}).color;
	
	    if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
	        dfltHoverOn.push('fills');
	    }
	    coerce('hoveron', dfltHoverOn.join('+') || 'points');
	    if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
	    var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'y'});
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../../registry":845,"./attributes":1118,"./constants":1122,"./fillcolor_defaults":1126,"./line_defaults":1131,"./line_shape_defaults":1133,"./marker_defaults":1137,"./stack_defaults":1140,"./subtypes":1142,"./text_defaults":1143,"./xy_defaults":1144}],1126:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	
	module.exports = function fillColorDefaults(traceIn, traceOut, defaultColor, coerce) {
	    var inheritColorFromMarker = false;
	
	    if(traceOut.marker) {
	        // don't try to inherit a color array
	        var markerColor = traceOut.marker.color;
	        var markerLineColor = (traceOut.marker.line || {}).color;
	
	        if(markerColor && !isArrayOrTypedArray(markerColor)) {
	            inheritColorFromMarker = markerColor;
	        } else if(markerLineColor && !isArrayOrTypedArray(markerLineColor)) {
	            inheritColorFromMarker = markerLineColor;
	        }
	    }
	
	    coerce('fillcolor', Color.addOpacity(
	        (traceOut.line || {}).color ||
	        inheritColorFromMarker ||
	        defaultColor, 0.5
	    ));
	};
	
	},{"../../components/color":591,"../../lib":716}],1127:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var labels = {};
	
	    var mockGd = {_fullLayout: fullLayout};
	    var xa = Axes.getFromTrace(mockGd, trace, 'x');
	    var ya = Axes.getFromTrace(mockGd, trace, 'y');
	
	    labels.xLabel = Axes.tickText(xa, cdi.x, true).text;
	    labels.yLabel = Axes.tickText(ya, cdi.y, true).text;
	
	    return labels;
	};
	
	},{"../../plots/cartesian/axes":764}],1128:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var subtypes = _dereq_('./subtypes');
	
	
	module.exports = function getTraceColor(trace, di) {
	    var lc, tc;
	
	    // TODO: text modes
	
	    if(trace.mode === 'lines') {
	        lc = trace.line.color;
	        return (lc && Color.opacity(lc)) ?
	            lc : trace.fillcolor;
	    } else if(trace.mode === 'none') {
	        return trace.fill ? trace.fillcolor : '';
	    } else {
	        var mc = di.mcc || (trace.marker || {}).color;
	        var mlc = di.mlcc || ((trace.marker || {}).line || {}).color;
	
	        tc = (mc && Color.opacity(mc)) ? mc :
	            (mlc && Color.opacity(mlc) &&
	                (di.mlw || ((trace.marker || {}).line || {}).width)) ? mlc : '';
	
	        if(tc) {
	            // make sure the points aren't TOO transparent
	            if(Color.opacity(tc) < 0.3) {
	                return Color.addOpacity(tc, 0.3);
	            } else return tc;
	        } else {
	            lc = (trace.line || {}).color;
	            return (lc && Color.opacity(lc) &&
	                subtypes.hasLines(trace) && trace.line.width) ?
	                    lc : trace.fillcolor;
	        }
	    }
	};
	
	},{"../../components/color":591,"./subtypes":1142}],1129:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Fx = _dereq_('../../components/fx');
	var Registry = _dereq_('../../registry');
	var getTraceColor = _dereq_('./get_trace_color');
	var Color = _dereq_('../../components/color');
	var fillText = Lib.fillText;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var xpx = xa.c2p(xval);
	    var ypx = ya.c2p(yval);
	    var pt = [xpx, ypx];
	    var hoveron = trace.hoveron || '';
	    var minRad = (trace.mode.indexOf('markers') !== -1) ? 3 : 0.5;
	
	    // look for points to hover on first, then take fills only if we
	    // didn't find a point
	    if(hoveron.indexOf('points') !== -1) {
	        var dx = function(di) {
	            // dx and dy are used in compare modes - here we want to always
	            // prioritize the closest data point, at least as long as markers are
	            // the same size or nonexistent, but still try to prioritize small markers too.
	            var rad = Math.max(3, di.mrc || 0);
	            var kink = 1 - 1 / rad;
	            var dxRaw = Math.abs(xa.c2p(di.x) - xpx);
	            var d = (dxRaw < rad) ? (kink * dxRaw / rad) : (dxRaw - rad + kink);
	            return d;
	        };
	        var dy = function(di) {
	            var rad = Math.max(3, di.mrc || 0);
	            var kink = 1 - 1 / rad;
	            var dyRaw = Math.abs(ya.c2p(di.y) - ypx);
	            return (dyRaw < rad) ? (kink * dyRaw / rad) : (dyRaw - rad + kink);
	        };
	        var dxy = function(di) {
	            // scatter points: d.mrc is the calculated marker radius
	            // adjust the distance so if you're inside the marker it
	            // always will show up regardless of point size, but
	            // prioritize smaller points
	            var rad = Math.max(minRad, di.mrc || 0);
	            var dx = xa.c2p(di.x) - xpx;
	            var dy = ya.c2p(di.y) - ypx;
	            return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - minRad / rad);
	        };
	        var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	
	        Fx.getClosest(cd, distfn, pointData);
	
	        // skip the rest (for this trace) if we didn't find a close point
	        if(pointData.index !== false) {
	            // the closest data point
	            var di = cd[pointData.index];
	            var xc = xa.c2p(di.x, true);
	            var yc = ya.c2p(di.y, true);
	            var rad = di.mrc || 1;
	
	            // now we're done using the whole `calcdata` array, replace the
	            // index with the original index (in case of inserted point from
	            // stacked area)
	            pointData.index = di.i;
	
	            var orientation = cd[0].t.orientation;
	            // TODO: for scatter and bar, option to show (sub)totals and
	            // raw data? Currently stacked and/or normalized bars just show
	            // the normalized individual sizes, so that's what I'm doing here
	            // for now.
	            var sizeVal = orientation && (di.sNorm || di.s);
	            var xLabelVal = (orientation === 'h') ? sizeVal : di.x;
	            var yLabelVal = (orientation === 'v') ? sizeVal : di.y;
	
	            Lib.extendFlat(pointData, {
	                color: getTraceColor(trace, di),
	
	                x0: xc - rad,
	                x1: xc + rad,
	                xLabelVal: xLabelVal,
	
	                y0: yc - rad,
	                y1: yc + rad,
	                yLabelVal: yLabelVal,
	
	                spikeDistance: dxy(di),
	                hovertemplate: trace.hovertemplate
	            });
	
	            fillText(di, trace, pointData);
	            Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData);
	
	            return [pointData];
	        }
	    }
	
	    // even if hoveron is 'fills', only use it if we have polygons too
	    if(hoveron.indexOf('fills') !== -1 && trace._polygons) {
	        var polygons = trace._polygons;
	        var polygonsIn = [];
	        var inside = false;
	        var xmin = Infinity;
	        var xmax = -Infinity;
	        var ymin = Infinity;
	        var ymax = -Infinity;
	
	        var i, j, polygon, pts, xCross, x0, x1, y0, y1;
	
	        for(i = 0; i < polygons.length; i++) {
	            polygon = polygons[i];
	            // TODO: this is not going to work right for curved edges, it will
	            // act as though they're straight. That's probably going to need
	            // the elements themselves to capture the events. Worth it?
	            if(polygon.contains(pt)) {
	                inside = !inside;
	                // TODO: need better than just the overall bounding box
	                polygonsIn.push(polygon);
	                ymin = Math.min(ymin, polygon.ymin);
	                ymax = Math.max(ymax, polygon.ymax);
	            }
	        }
	
	        if(inside) {
	            // constrain ymin/max to the visible plot, so the label goes
	            // at the middle of the piece you can see
	            ymin = Math.max(ymin, 0);
	            ymax = Math.min(ymax, ya._length);
	
	            // find the overall left-most and right-most points of the
	            // polygon(s) we're inside at their combined vertical midpoint.
	            // This is where we will draw the hover label.
	            // Note that this might not be the vertical midpoint of the
	            // whole trace, if it's disjoint.
	            var yAvg = (ymin + ymax) / 2;
	            for(i = 0; i < polygonsIn.length; i++) {
	                pts = polygonsIn[i].pts;
	                for(j = 1; j < pts.length; j++) {
	                    y0 = pts[j - 1][1];
	                    y1 = pts[j][1];
	                    if((y0 > yAvg) !== (y1 >= yAvg)) {
	                        x0 = pts[j - 1][0];
	                        x1 = pts[j][0];
	                        if(y1 - y0) {
	                            xCross = x0 + (x1 - x0) * (yAvg - y0) / (y1 - y0);
	                            xmin = Math.min(xmin, xCross);
	                            xmax = Math.max(xmax, xCross);
	                        }
	                    }
	                }
	            }
	
	            // constrain xmin/max to the visible plot now too
	            xmin = Math.max(xmin, 0);
	            xmax = Math.min(xmax, xa._length);
	
	            // get only fill or line color for the hover color
	            var color = Color.defaultLine;
	            if(Color.opacity(trace.fillcolor)) color = trace.fillcolor;
	            else if(Color.opacity((trace.line || {}).color)) {
	                color = trace.line.color;
	            }
	
	            Lib.extendFlat(pointData, {
	                // never let a 2D override 1D type as closest point
	                // also: no spikeDistance, it's not allowed for fills
	                distance: pointData.maxHoverDistance,
	                x0: xmin,
	                x1: xmax,
	                y0: yAvg,
	                y1: yAvg,
	                color: color,
	                hovertemplate: false
	            });
	
	            delete pointData.index;
	
	            if(trace.text && !Array.isArray(trace.text)) {
	                pointData.text = String(trace.text);
	            } else pointData.text = trace.name;
	
	            return [pointData];
	        }
	    }
	};
	
	},{"../../components/color":591,"../../components/fx":629,"../../lib":716,"../../registry":845,"./get_trace_color":1128}],1130:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var subtypes = _dereq_('./subtypes');
	
	module.exports = {
	    hasLines: subtypes.hasLines,
	    hasMarkers: subtypes.hasMarkers,
	    hasText: subtypes.hasText,
	    isBubble: subtypes.isBubble,
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('./cross_trace_defaults'),
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./cross_trace_calc'),
	    arraysToCalcdata: _dereq_('./arrays_to_calcdata'),
	    plot: _dereq_('./plot'),
	    colorbar: _dereq_('./marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    style: _dereq_('./style').style,
	    styleOnSelect: _dereq_('./style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('./select'),
	    animatable: true,
	
	    moduleType: 'trace',
	    name: 'scatter',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: [
	        'cartesian', 'svg', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like',
	        'zoomScale'
	    ],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"./arrays_to_calcdata":1117,"./attributes":1118,"./calc":1119,"./cross_trace_calc":1123,"./cross_trace_defaults":1124,"./defaults":1125,"./format_labels":1127,"./hover":1129,"./marker_colorbar":1136,"./plot":1138,"./select":1139,"./style":1141,"./subtypes":1142}],1131:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	
	module.exports = function lineDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
	    var markerColor = (traceIn.marker || {}).color;
	
	    coerce('line.color', defaultColor);
	
	    if(hasColorscale(traceIn, 'line')) {
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
	    } else {
	        var lineColorDflt = (isArrayOrTypedArray(markerColor) ? false : markerColor) || defaultColor;
	        coerce('line.color', lineColorDflt);
	    }
	
	    coerce('line.width');
	    if(!(opts || {}).noDash) coerce('line.dash');
	};
	
	},{"../../components/colorscale/defaults":601,"../../components/colorscale/helpers":602,"../../lib":716}],1132:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var numConstants = _dereq_('../../constants/numerical');
	var BADNUM = numConstants.BADNUM;
	var LOG_CLIP = numConstants.LOG_CLIP;
	var LOG_CLIP_PLUS = LOG_CLIP + 0.5;
	var LOG_CLIP_MINUS = LOG_CLIP - 0.5;
	var Lib = _dereq_('../../lib');
	var segmentsIntersect = Lib.segmentsIntersect;
	var constrain = Lib.constrain;
	var constants = _dereq_('./constants');
	
	
	module.exports = function linePoints(d, opts) {
	    var xa = opts.xaxis;
	    var ya = opts.yaxis;
	    var xLog = xa.type === 'log';
	    var yLog = ya.type === 'log';
	    var xLen = xa._length;
	    var yLen = ya._length;
	    var connectGaps = opts.connectGaps;
	    var baseTolerance = opts.baseTolerance;
	    var shape = opts.shape;
	    var linear = shape === 'linear';
	    var fill = opts.fill && opts.fill !== 'none';
	    var segments = [];
	    var minTolerance = constants.minTolerance;
	    var len = d.length;
	    var pts = new Array(len);
	    var pti = 0;
	
	    var i;
	
	    // pt variables are pixel coordinates [x,y] of one point
	    // these four are the outputs of clustering on a line
	    var clusterStartPt, clusterEndPt, clusterHighPt, clusterLowPt;
	
	    // "this" is the next point we're considering adding to the cluster
	    var thisPt;
	
	    // did we encounter the high point first, then a low point, or vice versa?
	    var clusterHighFirst;
	
	    // the first two points in the cluster determine its unit vector
	    // so the second is always in the "High" direction
	    var clusterUnitVector;
	
	    // the pixel delta from clusterStartPt
	    var thisVector;
	
	    // val variables are (signed) pixel distances along the cluster vector
	    var clusterRefDist, clusterHighVal, clusterLowVal, thisVal;
	
	    // deviation variables are (signed) pixel distances normal to the cluster vector
	    var clusterMinDeviation, clusterMaxDeviation, thisDeviation;
	
	    // turn one calcdata point into pixel coordinates
	    function getPt(index) {
	        var di = d[index];
	        if(!di) return false;
	        var x = opts.linearized ? xa.l2p(di.x) : xa.c2p(di.x);
	        var y = opts.linearized ? ya.l2p(di.y) : ya.c2p(di.y);
	
	        // if non-positive log values, set them VERY far off-screen
	        // so the line looks essentially straight from the previous point.
	        if(x === BADNUM) {
	            if(xLog) x = xa.c2p(di.x, true);
	            if(x === BADNUM) return false;
	            // If BOTH were bad log values, make the line follow a constant
	            // exponent rather than a constant slope
	            if(yLog && y === BADNUM) {
	                x *= Math.abs(xa._m * yLen * (xa._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS) /
	                    (ya._m * xLen * (ya._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS)));
	            }
	            x *= 1000;
	        }
	        if(y === BADNUM) {
	            if(yLog) y = ya.c2p(di.y, true);
	            if(y === BADNUM) return false;
	            y *= 1000;
	        }
	        return [x, y];
	    }
	
	    function crossesViewport(xFrac0, yFrac0, xFrac1, yFrac1) {
	        var dx = xFrac1 - xFrac0;
	        var dy = yFrac1 - yFrac0;
	        var dx0 = 0.5 - xFrac0;
	        var dy0 = 0.5 - yFrac0;
	        var norm2 = dx * dx + dy * dy;
	        var dot = dx * dx0 + dy * dy0;
	        if(dot > 0 && dot < norm2) {
	            var cross = dx0 * dy - dy0 * dx;
	            if(cross * cross < norm2) return true;
	        }
	    }
	
	    var latestXFrac, latestYFrac;
	    // if we're off-screen, increase tolerance over baseTolerance
	    function getTolerance(pt, nextPt) {
	        var xFrac = pt[0] / xLen;
	        var yFrac = pt[1] / yLen;
	        var offScreenFraction = Math.max(0, -xFrac, xFrac - 1, -yFrac, yFrac - 1);
	        if(offScreenFraction && (latestXFrac !== undefined) &&
	            crossesViewport(xFrac, yFrac, latestXFrac, latestYFrac)
	        ) {
	            offScreenFraction = 0;
	        }
	        if(offScreenFraction && nextPt &&
	            crossesViewport(xFrac, yFrac, nextPt[0] / xLen, nextPt[1] / yLen)
	        ) {
	            offScreenFraction = 0;
	        }
	
	        return (1 + constants.toleranceGrowth * offScreenFraction) * baseTolerance;
	    }
	
	    function ptDist(pt1, pt2) {
	        var dx = pt1[0] - pt2[0];
	        var dy = pt1[1] - pt2[1];
	        return Math.sqrt(dx * dx + dy * dy);
	    }
	
	    // last bit of filtering: clip paths that are VERY far off-screen
	    // so we don't get near the browser's hard limit (+/- 2^29 px in Chrome and FF)
	
	    var maxScreensAway = constants.maxScreensAway;
	
	    // find the intersections between the segment from pt1 to pt2
	    // and the large rectangle maxScreensAway around the viewport
	    // if one of pt1 and pt2 is inside and the other outside, there
	    // will be only one intersection.
	    // if both are outside there will be 0 or 2 intersections
	    // (or 1 if it's right at a corner - we'll treat that like 0)
	    // returns an array of intersection pts
	    var xEdge0 = -xLen * maxScreensAway;
	    var xEdge1 = xLen * (1 + maxScreensAway);
	    var yEdge0 = -yLen * maxScreensAway;
	    var yEdge1 = yLen * (1 + maxScreensAway);
	    var edges = [
	        [xEdge0, yEdge0, xEdge1, yEdge0],
	        [xEdge1, yEdge0, xEdge1, yEdge1],
	        [xEdge1, yEdge1, xEdge0, yEdge1],
	        [xEdge0, yEdge1, xEdge0, yEdge0]
	    ];
	    var xEdge, yEdge, lastXEdge, lastYEdge, lastFarPt, edgePt;
	
	    // for linear line shape, edge intersections should be linearly interpolated
	    // spline uses this too, which isn't precisely correct but is actually pretty
	    // good, because Catmull-Rom weights far-away points less in creating the curvature
	    function getLinearEdgeIntersections(pt1, pt2) {
	        var out = [];
	        var ptCount = 0;
	        for(var i = 0; i < 4; i++) {
	            var edge = edges[i];
	            var ptInt = segmentsIntersect(
	                pt1[0], pt1[1], pt2[0], pt2[1],
	                edge[0], edge[1], edge[2], edge[3]
	            );
	            if(ptInt && (!ptCount ||
	                Math.abs(ptInt.x - out[0][0]) > 1 ||
	                Math.abs(ptInt.y - out[0][1]) > 1
	            )) {
	                ptInt = [ptInt.x, ptInt.y];
	                // if we have 2 intersections, make sure the closest one to pt1 comes first
	                if(ptCount && ptDist(ptInt, pt1) < ptDist(out[0], pt1)) out.unshift(ptInt);
	                else out.push(ptInt);
	                ptCount++;
	            }
	        }
	        return out;
	    }
	
	    function onlyConstrainedPoint(pt) {
	        if(pt[0] < xEdge0 || pt[0] > xEdge1 || pt[1] < yEdge0 || pt[1] > yEdge1) {
	            return [constrain(pt[0], xEdge0, xEdge1), constrain(pt[1], yEdge0, yEdge1)];
	        }
	    }
	
	    function sameEdge(pt1, pt2) {
	        if(pt1[0] === pt2[0] && (pt1[0] === xEdge0 || pt1[0] === xEdge1)) return true;
	        if(pt1[1] === pt2[1] && (pt1[1] === yEdge0 || pt1[1] === yEdge1)) return true;
	    }
	
	    // for line shapes hv and vh, movement in the two dimensions is decoupled,
	    // so all we need to do is constrain each dimension independently
	    function getHVEdgeIntersections(pt1, pt2) {
	        var out = [];
	        var ptInt1 = onlyConstrainedPoint(pt1);
	        var ptInt2 = onlyConstrainedPoint(pt2);
	        if(ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
	
	        if(ptInt1) out.push(ptInt1);
	        if(ptInt2) out.push(ptInt2);
	        return out;
	    }
	
	    // hvh and vhv we sometimes have to move one of the intersection points
	    // out BEYOND the clipping rect, by a maximum of a factor of 2, so that
	    // the midpoint line is drawn in the right place
	    function getABAEdgeIntersections(dim, limit0, limit1) {
	        return function(pt1, pt2) {
	            var ptInt1 = onlyConstrainedPoint(pt1);
	            var ptInt2 = onlyConstrainedPoint(pt2);
	
	            var out = [];
	            if(ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
	
	            if(ptInt1) out.push(ptInt1);
	            if(ptInt2) out.push(ptInt2);
	
	            var midShift = 2 * Lib.constrain((pt1[dim] + pt2[dim]) / 2, limit0, limit1) -
	                ((ptInt1 || pt1)[dim] + (ptInt2 || pt2)[dim]);
	            if(midShift) {
	                var ptToAlter;
	                if(ptInt1 && ptInt2) {
	                    ptToAlter = (midShift > 0 === ptInt1[dim] > ptInt2[dim]) ? ptInt1 : ptInt2;
	                } else ptToAlter = ptInt1 || ptInt2;
	
	                ptToAlter[dim] += midShift;
	            }
	
	            return out;
	        };
	    }
	
	    var getEdgeIntersections;
	    if(shape === 'linear' || shape === 'spline') {
	        getEdgeIntersections = getLinearEdgeIntersections;
	    } else if(shape === 'hv' || shape === 'vh') {
	        getEdgeIntersections = getHVEdgeIntersections;
	    } else if(shape === 'hvh') getEdgeIntersections = getABAEdgeIntersections(0, xEdge0, xEdge1);
	    else if(shape === 'vhv') getEdgeIntersections = getABAEdgeIntersections(1, yEdge0, yEdge1);
	
	    // a segment pt1->pt2 entirely outside the nearby region:
	    // find the corner it gets closest to touching
	    function getClosestCorner(pt1, pt2) {
	        var dx = pt2[0] - pt1[0];
	        var m = (pt2[1] - pt1[1]) / dx;
	        var b = (pt1[1] * pt2[0] - pt2[1] * pt1[0]) / dx;
	
	        if(b > 0) return [m > 0 ? xEdge0 : xEdge1, yEdge1];
	        else return [m > 0 ? xEdge1 : xEdge0, yEdge0];
	    }
	
	    function updateEdge(pt) {
	        var x = pt[0];
	        var y = pt[1];
	        var xSame = x === pts[pti - 1][0];
	        var ySame = y === pts[pti - 1][1];
	        // duplicate point?
	        if(xSame && ySame) return;
	        if(pti > 1) {
	            // backtracking along an edge?
	            var xSame2 = x === pts[pti - 2][0];
	            var ySame2 = y === pts[pti - 2][1];
	            if(xSame && (x === xEdge0 || x === xEdge1) && xSame2) {
	                if(ySame2) pti--; // backtracking exactly - drop prev pt and don't add
	                else pts[pti - 1] = pt; // not exact: replace the prev pt
	            } else if(ySame && (y === yEdge0 || y === yEdge1) && ySame2) {
	                if(xSame2) pti--;
	                else pts[pti - 1] = pt;
	            } else pts[pti++] = pt;
	        } else pts[pti++] = pt;
	    }
	
	    function updateEdgesForReentry(pt) {
	        // if we're outside the nearby region and going back in,
	        // we may need to loop around a corner point
	        if(pts[pti - 1][0] !== pt[0] && pts[pti - 1][1] !== pt[1]) {
	            updateEdge([lastXEdge, lastYEdge]);
	        }
	        updateEdge(pt);
	        lastFarPt = null;
	        lastXEdge = lastYEdge = 0;
	    }
	
	    function addPt(pt) {
	        latestXFrac = pt[0] / xLen;
	        latestYFrac = pt[1] / yLen;
	        // Are we more than maxScreensAway off-screen any direction?
	        // if so, clip to this box, but in such a way that on-screen
	        // drawing is unchanged
	        xEdge = (pt[0] < xEdge0) ? xEdge0 : (pt[0] > xEdge1) ? xEdge1 : 0;
	        yEdge = (pt[1] < yEdge0) ? yEdge0 : (pt[1] > yEdge1) ? yEdge1 : 0;
	        if(xEdge || yEdge) {
	            if(!pti) {
	                // to get fills right - if first point is far, push it toward the
	                // screen in whichever direction(s) are far
	
	                pts[pti++] = [xEdge || pt[0], yEdge || pt[1]];
	            } else if(lastFarPt) {
	                // both this point and the last are outside the nearby region
	                // check if we're crossing the nearby region
	                var intersections = getEdgeIntersections(lastFarPt, pt);
	                if(intersections.length > 1) {
	                    updateEdgesForReentry(intersections[0]);
	                    pts[pti++] = intersections[1];
	                }
	            } else {
	                // we're leaving the nearby region - add the point where we left it
	
	                edgePt = getEdgeIntersections(pts[pti - 1], pt)[0];
	                pts[pti++] = edgePt;
	            }
	
	            var lastPt = pts[pti - 1];
	            if(xEdge && yEdge && (lastPt[0] !== xEdge || lastPt[1] !== yEdge)) {
	                // we've gone out beyond a new corner: add the corner too
	                // so that the next point will take the right winding
	                if(lastFarPt) {
	                    if(lastXEdge !== xEdge && lastYEdge !== yEdge) {
	                        if(lastXEdge && lastYEdge) {
	                            // we've gone around to an opposite corner - we
	                            // need to add the correct extra corner
	                            // in order to get the right winding
	                            updateEdge(getClosestCorner(lastFarPt, pt));
	                        } else {
	                            // we're coming from a far edge - the extra corner
	                            // we need is determined uniquely by the sectors
	                            updateEdge([lastXEdge || xEdge, lastYEdge || yEdge]);
	                        }
	                    } else if(lastXEdge && lastYEdge) {
	                        updateEdge([lastXEdge, lastYEdge]);
	                    }
	                }
	                updateEdge([xEdge, yEdge]);
	            } else if((lastXEdge - xEdge) && (lastYEdge - yEdge)) {
	                // we're coming from an edge or far corner to an edge - again the
	                // extra corner we need is uniquely determined by the sectors
	                updateEdge([xEdge || lastXEdge, yEdge || lastYEdge]);
	            }
	            lastFarPt = pt;
	            lastXEdge = xEdge;
	            lastYEdge = yEdge;
	        } else {
	            if(lastFarPt) {
	                // this point is in range but the previous wasn't: add its entry pt first
	                updateEdgesForReentry(getEdgeIntersections(lastFarPt, pt)[0]);
	            }
	
	            pts[pti++] = pt;
	        }
	    }
	
	    // loop over ALL points in this trace
	    for(i = 0; i < len; i++) {
	        clusterStartPt = getPt(i);
	        if(!clusterStartPt) continue;
	
	        pti = 0;
	        lastFarPt = null;
	        addPt(clusterStartPt);
	
	        // loop over one segment of the trace
	        for(i++; i < len; i++) {
	            clusterHighPt = getPt(i);
	            if(!clusterHighPt) {
	                if(connectGaps) continue;
	                else break;
	            }
	
	            // can't decimate if nonlinear line shape
	            // TODO: we *could* decimate [hv]{2,3} shapes if we restricted clusters to horz or vert again
	            // but spline would be verrry awkward to decimate
	            if(!linear || !opts.simplify) {
	                addPt(clusterHighPt);
	                continue;
	            }
	
	            var nextPt = getPt(i + 1);
	
	            clusterRefDist = ptDist(clusterHighPt, clusterStartPt);
	
	            // #3147 - always include the very first and last points for fills
	            if(!(fill && (pti === 0 || pti === len - 1)) &&
	                clusterRefDist < getTolerance(clusterHighPt, nextPt) * minTolerance) continue;
	
	            clusterUnitVector = [
	                (clusterHighPt[0] - clusterStartPt[0]) / clusterRefDist,
	                (clusterHighPt[1] - clusterStartPt[1]) / clusterRefDist
	            ];
	
	            clusterLowPt = clusterStartPt;
	            clusterHighVal = clusterRefDist;
	            clusterLowVal = clusterMinDeviation = clusterMaxDeviation = 0;
	            clusterHighFirst = false;
	            clusterEndPt = clusterHighPt;
	
	            // loop over one cluster of points that collapse onto one line
	            for(i++; i < d.length; i++) {
	                thisPt = nextPt;
	                nextPt = getPt(i + 1);
	                if(!thisPt) {
	                    if(connectGaps) continue;
	                    else break;
	                }
	                thisVector = [
	                    thisPt[0] - clusterStartPt[0],
	                    thisPt[1] - clusterStartPt[1]
	                ];
	                // cross product (or dot with normal to the cluster vector)
	                thisDeviation = thisVector[0] * clusterUnitVector[1] - thisVector[1] * clusterUnitVector[0];
	                clusterMinDeviation = Math.min(clusterMinDeviation, thisDeviation);
	                clusterMaxDeviation = Math.max(clusterMaxDeviation, thisDeviation);
	
	                if(clusterMaxDeviation - clusterMinDeviation > getTolerance(thisPt, nextPt)) break;
	
	                clusterEndPt = thisPt;
	                thisVal = thisVector[0] * clusterUnitVector[0] + thisVector[1] * clusterUnitVector[1];
	
	                if(thisVal > clusterHighVal) {
	                    clusterHighVal = thisVal;
	                    clusterHighPt = thisPt;
	                    clusterHighFirst = false;
	                } else if(thisVal < clusterLowVal) {
	                    clusterLowVal = thisVal;
	                    clusterLowPt = thisPt;
	                    clusterHighFirst = true;
	                }
	            }
	
	            // insert this cluster into pts
	            // we've already inserted the start pt, now check if we have high and low pts
	            if(clusterHighFirst) {
	                addPt(clusterHighPt);
	                if(clusterEndPt !== clusterLowPt) addPt(clusterLowPt);
	            } else {
	                if(clusterLowPt !== clusterStartPt) addPt(clusterLowPt);
	                if(clusterEndPt !== clusterHighPt) addPt(clusterHighPt);
	            }
	            // and finally insert the end pt
	            addPt(clusterEndPt);
	
	            // have we reached the end of this segment?
	            if(i >= d.length || !thisPt) break;
	
	            // otherwise we have an out-of-cluster point to insert as next clusterStartPt
	            addPt(thisPt);
	            clusterStartPt = thisPt;
	        }
	
	        // to get fills right - repeat what we did at the start
	        if(lastFarPt) updateEdge([lastXEdge || lastFarPt[0], lastYEdge || lastFarPt[1]]);
	
	        segments.push(pts.slice(0, pti));
	    }
	
	    return segments;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"./constants":1122}],1133:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	// common to 'scatter' and 'scatterternary'
	module.exports = function handleLineShapeDefaults(traceIn, traceOut, coerce) {
	    var shape = coerce('line.shape');
	    if(shape === 'spline') coerce('line.smoothing');
	};
	
	},{}],1134:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var LINKEDFILLS = {tonextx: 1, tonexty: 1, tonext: 1};
	
	module.exports = function linkTraces(gd, plotinfo, cdscatter) {
	    var trace, i, group, prevtrace, groupIndex;
	
	    // first sort traces to keep stacks & filled-together groups together
	    var groupIndices = {};
	    var needsSort = false;
	    var prevGroupIndex = -1;
	    var nextGroupIndex = 0;
	    var prevUnstackedGroupIndex = -1;
	    for(i = 0; i < cdscatter.length; i++) {
	        trace = cdscatter[i][0].trace;
	        group = trace.stackgroup || '';
	        if(group) {
	            if(group in groupIndices) {
	                groupIndex = groupIndices[group];
	            } else {
	                groupIndex = groupIndices[group] = nextGroupIndex;
	                nextGroupIndex++;
	            }
	        } else if(trace.fill in LINKEDFILLS && prevUnstackedGroupIndex >= 0) {
	            groupIndex = prevUnstackedGroupIndex;
	        } else {
	            groupIndex = prevUnstackedGroupIndex = nextGroupIndex;
	            nextGroupIndex++;
	        }
	
	        if(groupIndex < prevGroupIndex) needsSort = true;
	        trace._groupIndex = prevGroupIndex = groupIndex;
	    }
	
	    var cdscatterSorted = cdscatter.slice();
	    if(needsSort) {
	        cdscatterSorted.sort(function(a, b) {
	            var traceA = a[0].trace;
	            var traceB = b[0].trace;
	            return (traceA._groupIndex - traceB._groupIndex) ||
	                (traceA.index - traceB.index);
	        });
	    }
	
	    // now link traces to each other
	    var prevtraces = {};
	    for(i = 0; i < cdscatterSorted.length; i++) {
	        trace = cdscatterSorted[i][0].trace;
	        group = trace.stackgroup || '';
	
	        // Note: The check which ensures all cdscatter here are for the same axis and
	        // are either cartesian or scatterternary has been removed. This code assumes
	        // the passed scattertraces have been filtered to the proper plot types and
	        // the proper subplots.
	        if(trace.visible === true) {
	            trace._nexttrace = null;
	
	            if(trace.fill in LINKEDFILLS) {
	                prevtrace = prevtraces[group];
	                trace._prevtrace = prevtrace || null;
	
	                if(prevtrace) {
	                    prevtrace._nexttrace = trace;
	                }
	            }
	
	            trace._ownfill = (trace.fill && (
	                trace.fill.substr(0, 6) === 'tozero' ||
	                trace.fill === 'toself' ||
	                (trace.fill.substr(0, 2) === 'to' && !trace._prevtrace)
	            ));
	
	            prevtraces[group] = trace;
	        } else {
	            trace._prevtrace = trace._nexttrace = trace._ownfill = null;
	        }
	    }
	
	    return cdscatterSorted;
	};
	
	},{}],1135:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	
	// used in the drawing step for 'scatter' and 'scattegeo' and
	// in the convert step for 'scatter3d'
	module.exports = function makeBubbleSizeFn(trace) {
	    var marker = trace.marker;
	    var sizeRef = marker.sizeref || 1;
	    var sizeMin = marker.sizemin || 0;
	
	    // for bubble charts, allow scaling the provided value linearly
	    // and by area or diameter.
	    // Note this only applies to the array-value sizes
	
	    var baseFn = (marker.sizemode === 'area') ?
	        function(v) { return Math.sqrt(v / sizeRef); } :
	        function(v) { return v / sizeRef; };
	
	    // TODO add support for position/negative bubbles?
	    // TODO add 'sizeoffset' attribute?
	    return function(v) {
	        var baseSize = baseFn(v / 2);
	
	        // don't show non-numeric and negative sizes
	        return (isNumeric(baseSize) && (baseSize > 0)) ?
	            Math.max(baseSize, sizeMin) :
	            0;
	    };
	};
	
	},{"fast-isnumeric":227}],1136:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	module.exports = {
	    container: 'marker',
	    min: 'cmin',
	    max: 'cmax'
	};
	
	},{}],1137:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	
	var subTypes = _dereq_('./subtypes');
	
	/*
	 * opts: object of flags to control features not all marker users support
	 *   noLine: caller does not support marker lines
	 *   gradient: caller supports gradients
	 *   noSelect: caller does not support selected/unselected attribute containers
	 */
	module.exports = function markerDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
	    var isBubble = subTypes.isBubble(traceIn);
	    var lineColor = (traceIn.line || {}).color;
	    var defaultMLC;
	
	    opts = opts || {};
	
	    // marker.color inherit from line.color (even if line.color is an array)
	    if(lineColor) defaultColor = lineColor;
	
	    coerce('marker.symbol');
	    coerce('marker.opacity', isBubble ? 0.7 : 1);
	    coerce('marker.size');
	
	    coerce('marker.color', defaultColor);
	    if(hasColorscale(traceIn, 'marker')) {
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
	    }
	
	    if(!opts.noSelect) {
	        coerce('selected.marker.color');
	        coerce('unselected.marker.color');
	        coerce('selected.marker.size');
	        coerce('unselected.marker.size');
	    }
	
	    if(!opts.noLine) {
	        // if there's a line with a different color than the marker, use
	        // that line color as the default marker line color
	        // (except when it's an array)
	        // mostly this is for transparent markers to behave nicely
	        if(lineColor && !Array.isArray(lineColor) && (traceOut.marker.color !== lineColor)) {
	            defaultMLC = lineColor;
	        } else if(isBubble) defaultMLC = Color.background;
	        else defaultMLC = Color.defaultLine;
	
	        coerce('marker.line.color', defaultMLC);
	        if(hasColorscale(traceIn, 'marker.line')) {
	            colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.line.', cLetter: 'c'});
	        }
	
	        coerce('marker.line.width', isBubble ? 1 : 0);
	    }
	
	    if(isBubble) {
	        coerce('marker.sizeref');
	        coerce('marker.sizemin');
	        coerce('marker.sizemode');
	    }
	
	    if(opts.gradient) {
	        var gradientType = coerce('marker.gradient.type');
	        if(gradientType !== 'none') {
	            coerce('marker.gradient.color');
	        }
	    }
	};
	
	},{"../../components/color":591,"../../components/colorscale/defaults":601,"../../components/colorscale/helpers":602,"./subtypes":1142}],1138:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var ensureSingle = Lib.ensureSingle;
	var identity = Lib.identity;
	var Drawing = _dereq_('../../components/drawing');
	
	var subTypes = _dereq_('./subtypes');
	var linePoints = _dereq_('./line_points');
	var linkTraces = _dereq_('./link_traces');
	var polygonTester = _dereq_('../../lib/polygon').tester;
	
	module.exports = function plot(gd, plotinfo, cdscatter, scatterLayer, transitionOpts, makeOnCompleteCallback) {
	    var join, onComplete;
	
	    // If transition config is provided, then it is only a partial replot and traces not
	    // updated are removed.
	    var isFullReplot = !transitionOpts;
	    var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
	
	    // Link traces so the z-order of fill layers is correct
	    var cdscatterSorted = linkTraces(gd, plotinfo, cdscatter);
	
	    join = scatterLayer.selectAll('g.trace')
	        .data(cdscatterSorted, function(d) { return d[0].trace.uid; });
	
	    // Append new traces:
	    join.enter().append('g')
	        .attr('class', function(d) {
	            return 'trace scatter trace' + d[0].trace.uid;
	        })
	        .style('stroke-miterlimit', 2);
	    join.order();
	
	    createFills(gd, join, plotinfo);
	
	    if(hasTransition) {
	        if(makeOnCompleteCallback) {
	            // If it was passed a callback to register completion, make a callback. If
	            // this is created, then it must be executed on completion, otherwise the
	            // pos-transition redraw will not execute:
	            onComplete = makeOnCompleteCallback();
	        }
	
	        var transition = d3.transition()
	            .duration(transitionOpts.duration)
	            .ease(transitionOpts.easing)
	            .each('end', function() {
	                onComplete && onComplete();
	            })
	            .each('interrupt', function() {
	                onComplete && onComplete();
	            });
	
	        transition.each(function() {
	            // Must run the selection again since otherwise enters/updates get grouped together
	            // and these get executed out of order. Except we need them in order!
	            scatterLayer.selectAll('g.trace').each(function(d, i) {
	                plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
	            });
	        });
	    } else {
	        join.each(function(d, i) {
	            plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
	        });
	    }
	
	    if(isFullReplot) {
	        join.exit().remove();
	    }
	
	    // remove paths that didn't get used
	    scatterLayer.selectAll('path:not([d])').remove();
	};
	
	function createFills(gd, traceJoin, plotinfo) {
	    traceJoin.each(function(d) {
	        var fills = ensureSingle(d3.select(this), 'g', 'fills');
	        Drawing.setClipUrl(fills, plotinfo.layerClipId, gd);
	
	        var trace = d[0].trace;
	
	        var fillData = [];
	        if(trace._ownfill) fillData.push('_ownFill');
	        if(trace._nexttrace) fillData.push('_nextFill');
	
	        var fillJoin = fills.selectAll('g').data(fillData, identity);
	
	        fillJoin.enter().append('g');
	
	        fillJoin.exit()
	            .each(function(d) { trace[d] = null; })
	            .remove();
	
	        fillJoin.order().each(function(d) {
	            // make a path element inside the fill group, just so
	            // we can give it its own data later on and the group can
	            // keep its simple '_*Fill' data
	            trace[d] = ensureSingle(d3.select(this), 'path', 'js-fill');
	        });
	    });
	}
	
	function plotOne(gd, idx, plotinfo, cdscatter, cdscatterAll, element, transitionOpts) {
	    var i;
	
	    // Since this has been reorganized and we're executing this on individual traces,
	    // we need to pass it the full list of cdscatter as well as this trace's index (idx)
	    // since it does an internal n^2 loop over comparisons with other traces:
	    selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll);
	
	    var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
	
	    function transition(selection) {
	        return hasTransition ? selection.transition() : selection;
	    }
	
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    var trace = cdscatter[0].trace;
	    var line = trace.line;
	    var tr = d3.select(element);
	
	    var errorBarGroup = ensureSingle(tr, 'g', 'errorbars');
	    var lines = ensureSingle(tr, 'g', 'lines');
	    var points = ensureSingle(tr, 'g', 'points');
	    var text = ensureSingle(tr, 'g', 'text');
	
	    // error bars are at the bottom
	    Registry.getComponentMethod('errorbars', 'plot')(gd, errorBarGroup, plotinfo, transitionOpts);
	
	    if(trace.visible !== true) return;
	
	    transition(tr).style('opacity', trace.opacity);
	
	    // BUILD LINES AND FILLS
	    var ownFillEl3, tonext;
	    var ownFillDir = trace.fill.charAt(trace.fill.length - 1);
	    if(ownFillDir !== 'x' && ownFillDir !== 'y') ownFillDir = '';
	
	    // store node for tweaking by selectPoints
	    cdscatter[0][plotinfo.isRangePlot ? 'nodeRangePlot3' : 'node3'] = tr;
	
	    var prevRevpath = '';
	    var prevPolygons = [];
	    var prevtrace = trace._prevtrace;
	
	    if(prevtrace) {
	        prevRevpath = prevtrace._prevRevpath || '';
	        tonext = prevtrace._nextFill;
	        prevPolygons = prevtrace._polygons;
	    }
	
	    var thispath;
	    var thisrevpath;
	    // fullpath is all paths for this curve, joined together straight
	    // across gaps, for filling
	    var fullpath = '';
	    // revpath is fullpath reversed, for fill-to-next
	    var revpath = '';
	    // functions for converting a point array to a path
	    var pathfn, revpathbase, revpathfn;
	    // variables used before and after the data join
	    var pt0, lastSegment, pt1, thisPolygons;
	
	    // initialize line join data / method
	    var segments = [];
	    var makeUpdate = Lib.noop;
	
	    ownFillEl3 = trace._ownFill;
	
	    if(subTypes.hasLines(trace) || trace.fill !== 'none') {
	        if(tonext) {
	            // This tells .style which trace to use for fill information:
	            tonext.datum(cdscatter);
	        }
	
	        if(['hv', 'vh', 'hvh', 'vhv'].indexOf(line.shape) !== -1) {
	            pathfn = Drawing.steps(line.shape);
	            revpathbase = Drawing.steps(
	                line.shape.split('').reverse().join('')
	            );
	        } else if(line.shape === 'spline') {
	            pathfn = revpathbase = function(pts) {
	                var pLast = pts[pts.length - 1];
	                if(pts.length > 1 && pts[0][0] === pLast[0] && pts[0][1] === pLast[1]) {
	                    // identical start and end points: treat it as a
	                    // closed curve so we don't get a kink
	                    return Drawing.smoothclosed(pts.slice(1), line.smoothing);
	                } else {
	                    return Drawing.smoothopen(pts, line.smoothing);
	                }
	            };
	        } else {
	            pathfn = revpathbase = function(pts) {
	                return 'M' + pts.join('L');
	            };
	        }
	
	        revpathfn = function(pts) {
	            // note: this is destructive (reverses pts in place) so can't use pts after this
	            return revpathbase(pts.reverse());
	        };
	
	        segments = linePoints(cdscatter, {
	            xaxis: xa,
	            yaxis: ya,
	            connectGaps: trace.connectgaps,
	            baseTolerance: Math.max(line.width || 1, 3) / 4,
	            shape: line.shape,
	            simplify: line.simplify,
	            fill: trace.fill
	        });
	
	        // since we already have the pixel segments here, use them to make
	        // polygons for hover on fill
	        // TODO: can we skip this if hoveron!=fills? That would mean we
	        // need to redraw when you change hoveron...
	        thisPolygons = trace._polygons = new Array(segments.length);
	        for(i = 0; i < segments.length; i++) {
	            trace._polygons[i] = polygonTester(segments[i]);
	        }
	
	        if(segments.length) {
	            pt0 = segments[0][0];
	            lastSegment = segments[segments.length - 1];
	            pt1 = lastSegment[lastSegment.length - 1];
	        }
	
	        makeUpdate = function(isEnter) {
	            return function(pts) {
	                thispath = pathfn(pts);
	                thisrevpath = revpathfn(pts);
	                if(!fullpath) {
	                    fullpath = thispath;
	                    revpath = thisrevpath;
	                } else if(ownFillDir) {
	                    fullpath += 'L' + thispath.substr(1);
	                    revpath = thisrevpath + ('L' + revpath.substr(1));
	                } else {
	                    fullpath += 'Z' + thispath;
	                    revpath = thisrevpath + 'Z' + revpath;
	                }
	
	                if(subTypes.hasLines(trace) && pts.length > 1) {
	                    var el = d3.select(this);
	
	                    // This makes the coloring work correctly:
	                    el.datum(cdscatter);
	
	                    if(isEnter) {
	                        transition(el.style('opacity', 0)
	                            .attr('d', thispath)
	                            .call(Drawing.lineGroupStyle))
	                                .style('opacity', 1);
	                    } else {
	                        var sel = transition(el);
	                        sel.attr('d', thispath);
	                        Drawing.singleLineStyle(cdscatter, sel);
	                    }
	                }
	            };
	        };
	    }
	
	    var lineJoin = lines.selectAll('.js-line').data(segments);
	
	    transition(lineJoin.exit())
	        .style('opacity', 0)
	        .remove();
	
	    lineJoin.each(makeUpdate(false));
	
	    lineJoin.enter().append('path')
	        .classed('js-line', true)
	        .style('vector-effect', 'non-scaling-stroke')
	        .call(Drawing.lineGroupStyle)
	        .each(makeUpdate(true));
	
	    Drawing.setClipUrl(lineJoin, plotinfo.layerClipId, gd);
	
	    function clearFill(selection) {
	        transition(selection).attr('d', 'M0,0Z');
	    }
	
	    if(segments.length) {
	        if(ownFillEl3) {
	            ownFillEl3.datum(cdscatter);
	            if(pt0 && pt1) {
	                if(ownFillDir) {
	                    if(ownFillDir === 'y') {
	                        pt0[1] = pt1[1] = ya.c2p(0, true);
	                    } else if(ownFillDir === 'x') {
	                        pt0[0] = pt1[0] = xa.c2p(0, true);
	                    }
	
	                    // fill to zero: full trace path, plus extension of
	                    // the endpoints to the appropriate axis
	                    // For the sake of animations, wrap the points around so that
	                    // the points on the axes are the first two points. Otherwise
	                    // animations get a little crazy if the number of points changes.
	                    transition(ownFillEl3).attr('d', 'M' + pt1 + 'L' + pt0 + 'L' + fullpath.substr(1))
	                        .call(Drawing.singleFillStyle);
	                } else {
	                    // fill to self: just join the path to itself
	                    transition(ownFillEl3).attr('d', fullpath + 'Z')
	                        .call(Drawing.singleFillStyle);
	                }
	            }
	        } else if(tonext) {
	            if(trace.fill.substr(0, 6) === 'tonext' && fullpath && prevRevpath) {
	                // fill to next: full trace path, plus the previous path reversed
	                if(trace.fill === 'tonext') {
	                    // tonext: for use by concentric shapes, like manually constructed
	                    // contours, we just add the two paths closed on themselves.
	                    // This makes strange results if one path is *not* entirely
	                    // inside the other, but then that is a strange usage.
	                    transition(tonext).attr('d', fullpath + 'Z' + prevRevpath + 'Z')
	                        .call(Drawing.singleFillStyle);
	                } else {
	                    // tonextx/y: for now just connect endpoints with lines. This is
	                    // the correct behavior if the endpoints are at the same value of
	                    // y/x, but if they *aren't*, we should ideally do more complicated
	                    // things depending on whether the new endpoint projects onto the
	                    // existing curve or off the end of it
	                    transition(tonext).attr('d', fullpath + 'L' + prevRevpath.substr(1) + 'Z')
	                        .call(Drawing.singleFillStyle);
	                }
	                trace._polygons = trace._polygons.concat(prevPolygons);
	            } else {
	                clearFill(tonext);
	                trace._polygons = null;
	            }
	        }
	        trace._prevRevpath = revpath;
	        trace._prevPolygons = thisPolygons;
	    } else {
	        if(ownFillEl3) clearFill(ownFillEl3);
	        else if(tonext) clearFill(tonext);
	        trace._polygons = trace._prevRevpath = trace._prevPolygons = null;
	    }
	
	
	    function visFilter(d) {
	        return d.filter(function(v) { return !v.gap && v.vis; });
	    }
	
	    function visFilterWithGaps(d) {
	        return d.filter(function(v) { return v.vis; });
	    }
	
	    function gapFilter(d) {
	        return d.filter(function(v) { return !v.gap; });
	    }
	
	    function keyFunc(d) {
	        return d.id;
	    }
	
	    // Returns a function if the trace is keyed, otherwise returns undefined
	    function getKeyFunc(trace) {
	        if(trace.ids) {
	            return keyFunc;
	        }
	    }
	
	    function hideFilter() {
	        return false;
	    }
	
	    function makePoints(points, text, cdscatter) {
	        var join, selection, hasNode;
	
	        var trace = cdscatter[0].trace;
	        var showMarkers = subTypes.hasMarkers(trace);
	        var showText = subTypes.hasText(trace);
	
	        var keyFunc = getKeyFunc(trace);
	        var markerFilter = hideFilter;
	        var textFilter = hideFilter;
	
	        if(showMarkers || showText) {
	            var showFilter = identity;
	            // if we're stacking, "infer zero" gap mode gets markers in the
	            // gap points - because we've inferred a zero there - but other
	            // modes (currently "interpolate", later "interrupt" hopefully)
	            // we don't draw generated markers
	            var stackGroup = trace.stackgroup;
	            var isInferZero = stackGroup && (
	                gd._fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup].stackgaps === 'infer zero');
	            if(trace.marker.maxdisplayed || trace._needsCull) {
	                showFilter = isInferZero ? visFilterWithGaps : visFilter;
	            } else if(stackGroup && !isInferZero) {
	                showFilter = gapFilter;
	            }
	
	            if(showMarkers) markerFilter = showFilter;
	            if(showText) textFilter = showFilter;
	        }
	
	        // marker points
	
	        selection = points.selectAll('path.point');
	
	        join = selection.data(markerFilter, keyFunc);
	
	        var enter = join.enter().append('path')
	            .classed('point', true);
	
	        if(hasTransition) {
	            enter
	                .call(Drawing.pointStyle, trace, gd)
	                .call(Drawing.translatePoints, xa, ya)
	                .style('opacity', 0)
	                .transition()
	                .style('opacity', 1);
	        }
	
	        join.order();
	
	        var styleFns;
	        if(showMarkers) {
	            styleFns = Drawing.makePointStyleFns(trace);
	        }
	
	        join.each(function(d) {
	            var el = d3.select(this);
	            var sel = transition(el);
	            hasNode = Drawing.translatePoint(d, sel, xa, ya);
	
	            if(hasNode) {
	                Drawing.singlePointStyle(d, sel, trace, styleFns, gd);
	
	                if(plotinfo.layerClipId) {
	                    Drawing.hideOutsideRangePoint(d, sel, xa, ya, trace.xcalendar, trace.ycalendar);
	                }
	
	                if(trace.customdata) {
	                    el.classed('plotly-customdata', d.data !== null && d.data !== undefined);
	                }
	            } else {
	                sel.remove();
	            }
	        });
	
	        if(hasTransition) {
	            join.exit().transition()
	                .style('opacity', 0)
	                .remove();
	        } else {
	            join.exit().remove();
	        }
	
	        // text points
	        selection = text.selectAll('g');
	        join = selection.data(textFilter, keyFunc);
	
	        // each text needs to go in its own 'g' in case
	        // it gets converted to mathjax
	        join.enter().append('g').classed('textpoint', true).append('text');
	
	        join.order();
	
	        join.each(function(d) {
	            var g = d3.select(this);
	            var sel = transition(g.select('text'));
	            hasNode = Drawing.translatePoint(d, sel, xa, ya);
	
	            if(hasNode) {
	                if(plotinfo.layerClipId) {
	                    Drawing.hideOutsideRangePoint(d, g, xa, ya, trace.xcalendar, trace.ycalendar);
	                }
	            } else {
	                g.remove();
	            }
	        });
	
	        join.selectAll('text')
	            .call(Drawing.textPointStyle, trace, gd)
	            .each(function(d) {
	                // This just *has* to be totally custom becuase of SVG text positioning :(
	                // It's obviously copied from translatePoint; we just can't use that
	                var x = xa.c2p(d.x);
	                var y = ya.c2p(d.y);
	
	                d3.select(this).selectAll('tspan.line').each(function() {
	                    transition(d3.select(this)).attr({x: x, y: y});
	                });
	            });
	
	        join.exit().remove();
	    }
	
	    points.datum(cdscatter);
	    text.datum(cdscatter);
	    makePoints(points, text, cdscatter);
	
	    // lastly, clip points groups of `cliponaxis !== false` traces
	    // on `plotinfo._hasClipOnAxisFalse === true` subplots
	    var hasClipOnAxisFalse = trace.cliponaxis === false;
	    var clipUrl = hasClipOnAxisFalse ? null : plotinfo.layerClipId;
	    Drawing.setClipUrl(points, clipUrl, gd);
	    Drawing.setClipUrl(text, clipUrl, gd);
	}
	
	function selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var xr = d3.extent(Lib.simpleMap(xa.range, xa.r2c));
	    var yr = d3.extent(Lib.simpleMap(ya.range, ya.r2c));
	
	    var trace = cdscatter[0].trace;
	    if(!subTypes.hasMarkers(trace)) return;
	    // if marker.maxdisplayed is used, select a maximum of
	    // mnum markers to show, from the set that are in the viewport
	    var mnum = trace.marker.maxdisplayed;
	
	    // TODO: remove some as we get away from the viewport?
	    if(mnum === 0) return;
	
	    var cd = cdscatter.filter(function(v) {
	        return v.x >= xr[0] && v.x <= xr[1] && v.y >= yr[0] && v.y <= yr[1];
	    });
	    var inc = Math.ceil(cd.length / mnum);
	    var tnum = 0;
	    cdscatterAll.forEach(function(cdj, j) {
	        var tracei = cdj[0].trace;
	        if(subTypes.hasMarkers(tracei) &&
	                tracei.marker.maxdisplayed > 0 && j < idx) {
	            tnum++;
	        }
	    });
	
	    // if multiple traces use maxdisplayed, stagger which markers we
	    // display this formula offsets successive traces by 1/3 of the
	    // increment, adding an extra small amount after each triplet so
	    // it's not quite periodic
	    var i0 = Math.round(tnum * inc / 3 + Math.floor(tnum / 3) * inc / 7.1);
	
	    // for error bars: save in cd which markers to show
	    // so we don't have to repeat this
	    cdscatter.forEach(function(v) { delete v.vis; });
	    cd.forEach(function(v, i) {
	        if(Math.round((i + i0) % inc) === 0) v.vis = true;
	    });
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../../lib/polygon":728,"../../registry":845,"./line_points":1132,"./link_traces":1134,"./subtypes":1142,"d3":164}],1139:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var subtypes = _dereq_('./subtypes');
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	    var trace = cd[0].trace;
	    var i;
	    var di;
	    var x;
	    var y;
	
	    var hasOnlyLines = (!subtypes.hasMarkers(trace) && !subtypes.hasText(trace));
	    if(hasOnlyLines) return [];
	
	    if(selectionTester === false) { // clear selection
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            di = cd[i];
	            x = xa.c2p(di.x);
	            y = ya.c2p(di.y);
	
	            if((di.i !== null) && selectionTester.contains([x, y], false, i, searchInfo)) {
	                selection.push({
	                    pointNumber: di.i,
	                    x: xa.c2d(di.x),
	                    y: ya.c2d(di.y)
	                });
	                di.selected = 1;
	            } else {
	                di.selected = 0;
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{"./subtypes":1142}],1140:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var perStackAttrs = ['orientation', 'groupnorm', 'stackgaps'];
	
	module.exports = function handleStackDefaults(traceIn, traceOut, layout, coerce) {
	    var stackOpts = layout._scatterStackOpts;
	
	    var stackGroup = coerce('stackgroup');
	    if(stackGroup) {
	        // use independent stacking options per subplot
	        var subplot = traceOut.xaxis + traceOut.yaxis;
	        var subplotStackOpts = stackOpts[subplot];
	        if(!subplotStackOpts) subplotStackOpts = stackOpts[subplot] = {};
	
	        var groupOpts = subplotStackOpts[stackGroup];
	        var firstTrace = false;
	        if(groupOpts) {
	            groupOpts.traces.push(traceOut);
	        } else {
	            groupOpts = subplotStackOpts[stackGroup] = {
	                // keep track of trace indices for use during stacking calculations
	                // this will be filled in during `calc` and used during `crossTraceCalc`
	                // so it's OK if we don't recreate it during a non-calc edit
	                traceIndices: [],
	                // Hold on to the whole set of prior traces
	                // First one is most important, so we can clear defaults
	                // there if we find explicit values only in later traces.
	                // We're only going to *use* the values stored in groupOpts,
	                // but for the editor and validate we want things self-consistent
	                // The full set of traces is used only to fix `fill` default if
	                // we find `orientation: 'h'` beyond the first trace
	                traces: [traceOut]
	            };
	            firstTrace = true;
	        }
	        // TODO: how is this going to work with groupby transforms?
	        // in principle it should be OK I guess, as long as explicit group styles
	        // don't override explicit base-trace styles?
	
	        var dflts = {
	            orientation: (traceOut.x && !traceOut.y) ? 'h' : 'v'
	        };
	
	        for(var i = 0; i < perStackAttrs.length; i++) {
	            var attr = perStackAttrs[i];
	            var attrFound = attr + 'Found';
	            if(!groupOpts[attrFound]) {
	                var traceHasAttr = traceIn[attr] !== undefined;
	                var isOrientation = attr === 'orientation';
	                if(traceHasAttr || firstTrace) {
	                    groupOpts[attr] = coerce(attr, dflts[attr]);
	
	                    if(isOrientation) {
	                        groupOpts.fillDflt = groupOpts[attr] === 'h' ?
	                            'tonextx' : 'tonexty';
	                    }
	
	                    if(traceHasAttr) {
	                        // Note: this will show a value here even if it's invalid
	                        // in which case it will revert to default.
	                        groupOpts[attrFound] = true;
	
	                        // Note: only one trace in the stack will get a _fullData
	                        // entry for a given stack-wide attribute. If no traces
	                        // (or the first trace) specify that attribute, the
	                        // first trace will get it. If the first trace does NOT
	                        // specify it but some later trace does, then it gets
	                        // removed from the first trace and only included in the
	                        // one that specified it. This is mostly important for
	                        // editors (that want to see the full values to know
	                        // what settings are available) and Plotly.react diffing.
	                        // Editors may want to use fullLayout._scatterStackOpts
	                        // directly and make these settings available from all
	                        // traces in the stack... then set the new value into
	                        // the first trace, and clear all later traces.
	                        if(!firstTrace) {
	                            delete groupOpts.traces[0][attr];
	
	                            // orientation can affect default fill of previous traces
	                            if(isOrientation) {
	                                for(var j = 0; j < groupOpts.traces.length - 1; j++) {
	                                    var trace2 = groupOpts.traces[j];
	                                    if(trace2._input.fill !== trace2.fill) {
	                                        trace2.fill = groupOpts.fillDflt;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return groupOpts;
	    }
	};
	
	},{}],1141:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../../components/drawing');
	var Registry = _dereq_('../../registry');
	
	function style(gd) {
	    var s = d3.select(gd).selectAll('g.trace.scatter');
	
	    s.style('opacity', function(d) {
	        return d[0].trace.opacity;
	    });
	
	    s.selectAll('g.points').each(function(d) {
	        var sel = d3.select(this);
	        var trace = d.trace || d[0].trace;
	        stylePoints(sel, trace, gd);
	    });
	
	    s.selectAll('g.text').each(function(d) {
	        var sel = d3.select(this);
	        var trace = d.trace || d[0].trace;
	        styleText(sel, trace, gd);
	    });
	
	    s.selectAll('g.trace path.js-line')
	        .call(Drawing.lineGroupStyle);
	
	    s.selectAll('g.trace path.js-fill')
	        .call(Drawing.fillGroupStyle);
	
	    Registry.getComponentMethod('errorbars', 'style')(s);
	}
	
	function stylePoints(sel, trace, gd) {
	    Drawing.pointStyle(sel.selectAll('path.point'), trace, gd);
	}
	
	function styleText(sel, trace, gd) {
	    Drawing.textPointStyle(sel.selectAll('text'), trace, gd);
	}
	
	function styleOnSelect(gd, cd, sel) {
	    var trace = cd[0].trace;
	
	    if(trace.selectedpoints) {
	        Drawing.selectedPointStyle(sel.selectAll('path.point'), trace);
	        Drawing.selectedTextStyle(sel.selectAll('text'), trace);
	    } else {
	        stylePoints(sel, trace, gd);
	        styleText(sel, trace, gd);
	    }
	}
	
	module.exports = {
	    style: style,
	    stylePoints: stylePoints,
	    styleText: styleText,
	    styleOnSelect: styleOnSelect
	};
	
	},{"../../components/drawing":612,"../../registry":845,"d3":164}],1142:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	module.exports = {
	    hasLines: function(trace) {
	        return trace.visible && trace.mode &&
	            trace.mode.indexOf('lines') !== -1;
	    },
	
	    hasMarkers: function(trace) {
	        return trace.visible && (
	            (trace.mode && trace.mode.indexOf('markers') !== -1) ||
	            // until splom implements 'mode'
	            trace.type === 'splom'
	        );
	    },
	
	    hasText: function(trace) {
	        return trace.visible && trace.mode &&
	            trace.mode.indexOf('text') !== -1;
	    },
	
	    isBubble: function(trace) {
	        return Lib.isPlainObject(trace.marker) &&
	            Lib.isArrayOrTypedArray(trace.marker.size);
	    }
	};
	
	},{"../../lib":716}],1143:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	/*
	 * opts: object of flags to control features not all text users support
	 *   noSelect: caller does not support selected/unselected attribute containers
	 */
	module.exports = function(traceIn, traceOut, layout, coerce, opts) {
	    opts = opts || {};
	
	    coerce('textposition');
	    Lib.coerceFont(coerce, 'textfont', layout.font);
	
	    if(!opts.noSelect) {
	        coerce('selected.textfont.color');
	        coerce('unselected.textfont.color');
	    }
	};
	
	},{"../../lib":716}],1144:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	module.exports = function handleXYDefaults(traceIn, traceOut, layout, coerce) {
	    var x = coerce('x');
	    var y = coerce('y');
	    var len;
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
	
	    if(x) {
	        var xlen = Lib.minRowLength(x);
	        if(y) {
	            len = Math.min(xlen, Lib.minRowLength(y));
	        } else {
	            len = xlen;
	            coerce('y0');
	            coerce('dy');
	        }
	    } else {
	        if(!y) return 0;
	
	        len = Lib.minRowLength(y);
	        coerce('x0');
	        coerce('dx');
	    }
	
	    traceOut._length = len;
	
	    return len;
	};
	
	},{"../../lib":716,"../../registry":845}],1145:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var colorAttributes = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var baseAttrs = _dereq_('../../plots/attributes');
	var DASHES = _dereq_('../../constants/gl3d_dashes');
	
	var MARKER_SYMBOLS = _dereq_('../../constants/gl3d_markers');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var scatterLineAttrs = scatterAttrs.line;
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	var lineAttrs = extendFlat({
	    width: scatterLineAttrs.width,
	    dash: {
	        valType: 'enumerated',
	        values: Object.keys(DASHES),
	        dflt: 'solid',
	        
	        
	    }
	}, colorAttributes('line'));
	
	function makeProjectionAttr(axLetter) {
	    return {
	        show: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        opacity: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	        },
	        scale: {
	            valType: 'number',
	            
	            min: 0,
	            max: 10,
	            dflt: 2 / 3,
	            
	        }
	    };
	}
	
	var attrs = module.exports = overrideAll({
	    x: scatterAttrs.x,
	    y: scatterAttrs.y,
	    z: {
	        valType: 'data_array',
	        
	    },
	
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    texttemplate: texttemplateAttrs({}, {
	
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	    hovertemplate: hovertemplateAttrs(),
	
	    mode: extendFlat({}, scatterAttrs.mode,  // shouldn't this be on-par with 2D?
	        {dflt: 'lines+markers'}),
	    surfaceaxis: {
	        valType: 'enumerated',
	        
	        values: [-1, 0, 1, 2],
	        dflt: -1,
	        
	    },
	    surfacecolor: {
	        valType: 'color',
	        
	        
	    },
	    projection: {
	        x: makeProjectionAttr('x'),
	        y: makeProjectionAttr('y'),
	        z: makeProjectionAttr('z')
	    },
	
	    connectgaps: scatterAttrs.connectgaps,
	    line: lineAttrs,
	
	    marker: extendFlat({  // Parity with scatter.js?
	        symbol: {
	            valType: 'enumerated',
	            values: Object.keys(MARKER_SYMBOLS),
	            
	            dflt: 'circle',
	            arrayOk: true,
	            
	        },
	        size: extendFlat({}, scatterMarkerAttrs.size, {dflt: 8}),
	        sizeref: scatterMarkerAttrs.sizeref,
	        sizemin: scatterMarkerAttrs.sizemin,
	        sizemode: scatterMarkerAttrs.sizemode,
	        opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
	            arrayOk: false,
	            
	        }),
	        colorbar: scatterMarkerAttrs.colorbar,
	
	        line: extendFlat({
	            width: extendFlat({}, scatterMarkerLineAttrs.width, {arrayOk: false})
	        },
	            colorAttributes('marker.line')
	        )
	    },
	        colorAttributes('marker')
	    ),
	
	    textposition: extendFlat({}, scatterAttrs.textposition, {dflt: 'top center'}),
	    textfont: {
	        color: scatterAttrs.textfont.color,
	        size: scatterAttrs.textfont.size,
	        family: extendFlat({}, scatterAttrs.textfont.family, {arrayOk: false})
	    },
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	}, 'calc', 'nested');
	
	attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';
	
	},{"../../components/colorscale/attributes":598,"../../constants/gl3d_dashes":689,"../../constants/gl3d_markers":690,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scatter/attributes":1118}],1146:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	
	/**
	 * This is a kludge to put the array attributes into
	 * calcdata the way Scatter.plot does, so that legends and
	 * popovers know what to do with them.
	 */
	module.exports = function calc(gd, trace) {
	    var cd = [{x: false, y: false, trace: trace, t: {}}];
	
	    arraysToCalcdata(cd, trace);
	    calcColorscale(gd, trace);
	
	    return cd;
	};
	
	},{"../scatter/arrays_to_calcdata":1117,"../scatter/colorscale_calc":1121}],1147:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	
	function calculateAxisErrors(data, params, scaleFactor, axis) {
	    if(!params || !params.visible) return null;
	
	    var computeError = Registry.getComponentMethod('errorbars', 'makeComputeError')(params);
	    var result = new Array(data.length);
	
	    for(var i = 0; i < data.length; i++) {
	        var errors = computeError(+data[i], i);
	
	        if(axis.type === 'log') {
	            var point = axis.c2l(data[i]);
	            var min = data[i] - errors[0];
	            var max = data[i] + errors[1];
	
	            result[i] = [
	                (axis.c2l(min, true) - point) * scaleFactor,
	                (axis.c2l(max, true) - point) * scaleFactor
	            ];
	
	            // Keep track of the lower error bound which isn't negative!
	            if(min > 0) {
	                var lower = axis.c2l(min);
	                if(!axis._lowerLogErrorBound) axis._lowerLogErrorBound = lower;
	                axis._lowerErrorBound = Math.min(axis._lowerLogErrorBound, lower);
	            }
	        } else {
	            result[i] = [
	                -errors[0] * scaleFactor,
	                errors[1] * scaleFactor
	            ];
	        }
	    }
	
	    return result;
	}
	
	function dataLength(array) {
	    for(var i = 0; i < array.length; i++) {
	        if(array[i]) return array[i].length;
	    }
	    return 0;
	}
	
	function calculateErrors(data, scaleFactor, sceneLayout) {
	    var errors = [
	        calculateAxisErrors(data.x, data.error_x, scaleFactor[0], sceneLayout.xaxis),
	        calculateAxisErrors(data.y, data.error_y, scaleFactor[1], sceneLayout.yaxis),
	        calculateAxisErrors(data.z, data.error_z, scaleFactor[2], sceneLayout.zaxis)
	    ];
	
	    var n = dataLength(errors);
	    if(n === 0) return null;
	
	    var errorBounds = new Array(n);
	
	    for(var i = 0; i < n; i++) {
	        var bound = [[0, 0, 0], [0, 0, 0]];
	
	        for(var j = 0; j < 3; j++) {
	            if(errors[j]) {
	                for(var k = 0; k < 2; k++) {
	                    bound[k][j] = errors[j][i][k];
	                }
	            }
	        }
	
	        errorBounds[i] = bound;
	    }
	
	    return errorBounds;
	}
	
	module.exports = calculateErrors;
	
	},{"../../registry":845}],1148:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var createLinePlot = _dereq_('gl-line3d');
	var createScatterPlot = _dereq_('gl-scatter3d');
	var createErrorBars = _dereq_('gl-error3d');
	var createMesh = _dereq_('gl-mesh3d');
	var triangulate = _dereq_('delaunay-triangulate');
	
	var Lib = _dereq_('../../lib');
	var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
	var formatColor = _dereq_('../../lib/gl_format_color').formatColor;
	var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
	var DASH_PATTERNS = _dereq_('../../constants/gl3d_dashes');
	var MARKER_SYMBOLS = _dereq_('../../constants/gl3d_markers');
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	
	var calculateError = _dereq_('./calc_errors');
	
	function LineWithMarkers(scene, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.linePlot = null;
	    this.scatterPlot = null;
	    this.errorBars = null;
	    this.textMarkers = null;
	    this.delaunayMesh = null;
	    this.color = null;
	    this.mode = '';
	    this.dataPoints = [];
	    this.axesBounds = [
	        [-Infinity, -Infinity, -Infinity],
	        [Infinity, Infinity, Infinity]
	    ];
	    this.textLabels = null;
	    this.data = null;
	}
	
	var proto = LineWithMarkers.prototype;
	
	proto.handlePick = function(selection) {
	    if(selection.object &&
	        (selection.object === this.linePlot ||
	         selection.object === this.delaunayMesh ||
	         selection.object === this.textMarkers ||
	         selection.object === this.scatterPlot)
	    ) {
	        var ind = selection.index = selection.data.index;
	
	        if(selection.object.highlight) {
	            selection.object.highlight(null);
	        }
	        if(this.scatterPlot) {
	            selection.object = this.scatterPlot;
	            this.scatterPlot.highlight(selection.data);
	        }
	
	        selection.textLabel = '';
	        if(this.textLabels) {
	            if(Array.isArray(this.textLabels)) {
	                if(this.textLabels[ind] || this.textLabels[ind] === 0) {
	                    selection.textLabel = this.textLabels[ind];
	                }
	            } else {
	                selection.textLabel = this.textLabels;
	            }
	        }
	
	        selection.traceCoordinate = [
	            this.data.x[ind],
	            this.data.y[ind],
	            this.data.z[ind]
	        ];
	
	        return true;
	    }
	};
	
	function constructDelaunay(points, color, axis) {
	    var u = (axis + 1) % 3;
	    var v = (axis + 2) % 3;
	    var filteredPoints = [];
	    var filteredIds = [];
	    var i;
	
	    for(i = 0; i < points.length; ++i) {
	        var p = points[i];
	        if(isNaN(p[u]) || !isFinite(p[u]) ||
	           isNaN(p[v]) || !isFinite(p[v])) {
	            continue;
	        }
	        filteredPoints.push([p[u], p[v]]);
	        filteredIds.push(i);
	    }
	    var cells = triangulate(filteredPoints);
	    for(i = 0; i < cells.length; ++i) {
	        var c = cells[i];
	        for(var j = 0; j < c.length; ++j) {
	            c[j] = filteredIds[c[j]];
	        }
	    }
	    return {
	        positions: points,
	        cells: cells,
	        meshColor: color
	    };
	}
	
	function calculateErrorParams(errors) {
	    var capSize = [0.0, 0.0, 0.0];
	    var color = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
	    var lineWidth = [1.0, 1.0, 1.0];
	
	    for(var i = 0; i < 3; i++) {
	        var e = errors[i];
	
	        if(e && e.copy_zstyle !== false && errors[2].visible !== false) e = errors[2];
	        if(!e || !e.visible) continue;
	
	        capSize[i] = e.width / 2;  // ballpark rescaling
	        color[i] = str2RgbaArray(e.color);
	        lineWidth[i] = e.thickness;
	    }
	
	    return {capSize: capSize, color: color, lineWidth: lineWidth};
	}
	
	function parseAlignmentX(a) {
	    if(a === null || a === undefined) return 0;
	
	    return (a.indexOf('left') > -1) ? -1 :
	           (a.indexOf('right') > -1) ? 1 : 0;
	}
	
	function parseAlignmentY(a) {
	    if(a === null || a === undefined) return 0;
	
	    return (a.indexOf('top') > -1) ? -1 :
	           (a.indexOf('bottom') > -1) ? 1 : 0;
	}
	
	function calculateTextOffset(tp) {
	    // Read out text properties
	
	    var defaultAlignmentX = 0;
	    var defaultAlignmentY = 0;
	
	    var textOffset = [
	        defaultAlignmentX,
	        defaultAlignmentY
	    ];
	
	    if(Array.isArray(tp)) {
	        for(var i = 0; i < tp.length; i++) {
	            textOffset[i] = [
	                defaultAlignmentX,
	                defaultAlignmentY
	            ];
	            if(tp[i]) {
	                textOffset[i][0] = parseAlignmentX(tp[i]);
	                textOffset[i][1] = parseAlignmentY(tp[i]);
	            }
	        }
	    } else {
	        textOffset[0] = parseAlignmentX(tp);
	        textOffset[1] = parseAlignmentY(tp);
	    }
	
	    return textOffset;
	}
	
	
	function calculateSize(sizeIn, sizeFn) {
	    // rough parity with Plotly 2D markers
	    return sizeFn(sizeIn * 4);
	}
	
	function calculateSymbol(symbolIn) {
	    return MARKER_SYMBOLS[symbolIn];
	}
	
	function formatParam(paramIn, len, calculate, dflt, extraFn) {
	    var paramOut = null;
	
	    if(Lib.isArrayOrTypedArray(paramIn)) {
	        paramOut = [];
	
	        for(var i = 0; i < len; i++) {
	            if(paramIn[i] === undefined) paramOut[i] = dflt;
	            else paramOut[i] = calculate(paramIn[i], extraFn);
	        }
	    } else paramOut = calculate(paramIn, Lib.identity);
	
	    return paramOut;
	}
	
	
	function convertPlotlyOptions(scene, data) {
	    var points = [];
	    var sceneLayout = scene.fullSceneLayout;
	    var scaleFactor = scene.dataScale;
	    var xaxis = sceneLayout.xaxis;
	    var yaxis = sceneLayout.yaxis;
	    var zaxis = sceneLayout.zaxis;
	    var marker = data.marker;
	    var line = data.line;
	    var x = data.x || [];
	    var y = data.y || [];
	    var z = data.z || [];
	    var len = x.length;
	    var xcalendar = data.xcalendar;
	    var ycalendar = data.ycalendar;
	    var zcalendar = data.zcalendar;
	    var xc, yc, zc;
	    var params, i;
	    var text;
	
	    // Convert points
	    for(i = 0; i < len; i++) {
	        // sanitize numbers and apply transforms based on axes.type
	        xc = xaxis.d2l(x[i], 0, xcalendar) * scaleFactor[0];
	        yc = yaxis.d2l(y[i], 0, ycalendar) * scaleFactor[1];
	        zc = zaxis.d2l(z[i], 0, zcalendar) * scaleFactor[2];
	
	        points[i] = [xc, yc, zc];
	    }
	
	    // convert text
	    if(Array.isArray(data.text)) text = data.text;
	    else if(data.text !== undefined) {
	        text = new Array(len);
	        for(i = 0; i < len; i++) text[i] = data.text;
	    }
	
	    function formatter(axName, val) {
	        var ax = sceneLayout[axName];
	        return Axes.tickText(ax, ax.d2l(val), true).text;
	    }
	
	    // check texttemplate
	    var texttemplate = data.texttemplate;
	    if(texttemplate) {
	        var fullLayout = scene.fullLayout;
	        var d3locale = fullLayout._d3locale;
	        var isArray = Array.isArray(texttemplate);
	        var N = isArray ? Math.min(texttemplate.length, len) : len;
	        var txt = isArray ?
	            function(i) { return texttemplate[i]; } :
	            function() { return texttemplate; };
	
	        text = new Array(N);
	
	        for(i = 0; i < N; i++) {
	            var d = {x: x[i], y: y[i], z: z[i]};
	            var labels = {
	                xLabel: formatter('xaxis', x[i]),
	                yLabel: formatter('yaxis', y[i]),
	                zLabel: formatter('zaxis', z[i])
	            };
	            var pointValues = {};
	            appendArrayPointValue(pointValues, data, i);
	            var meta = data._meta || {};
	            text[i] = Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta);
	        }
	    }
	
	    // Build object parameters
	    params = {
	        position: points,
	        mode: data.mode,
	        text: text
	    };
	
	    if('line' in data) {
	        params.lineColor = formatColor(line, 1, len);
	        params.lineWidth = line.width;
	        params.lineDashes = line.dash;
	    }
	
	    if('marker' in data) {
	        var sizeFn = makeBubbleSizeFn(data);
	
	        params.scatterColor = formatColor(marker, 1, len);
	        params.scatterSize = formatParam(marker.size, len, calculateSize, 20, sizeFn);
	        params.scatterMarker = formatParam(marker.symbol, len, calculateSymbol, '●');
	        params.scatterLineWidth = marker.line.width;  // arrayOk === false
	        params.scatterLineColor = formatColor(marker.line, 1, len);
	        params.scatterAngle = 0;
	    }
	
	    if('textposition' in data) {
	        params.textOffset = calculateTextOffset(data.textposition);
	        params.textColor = formatColor(data.textfont, 1, len);
	        params.textSize = formatParam(data.textfont.size, len, Lib.identity, 12);
	        params.textFont = data.textfont.family;  // arrayOk === false
	        params.textAngle = 0;
	    }
	
	    var dims = ['x', 'y', 'z'];
	    params.project = [false, false, false];
	    params.projectScale = [1, 1, 1];
	    params.projectOpacity = [1, 1, 1];
	    for(i = 0; i < 3; ++i) {
	        var projection = data.projection[dims[i]];
	        if((params.project[i] = projection.show)) {
	            params.projectOpacity[i] = projection.opacity;
	            params.projectScale[i] = projection.scale;
	        }
	    }
	
	    params.errorBounds = calculateError(data, scaleFactor, sceneLayout);
	
	    var errorParams = calculateErrorParams([data.error_x, data.error_y, data.error_z]);
	    params.errorColor = errorParams.color;
	    params.errorLineWidth = errorParams.lineWidth;
	    params.errorCapSize = errorParams.capSize;
	
	    params.delaunayAxis = data.surfaceaxis;
	    params.delaunayColor = str2RgbaArray(data.surfacecolor);
	
	    return params;
	}
	
	function arrayToColor(color) {
	    if(Array.isArray(color)) {
	        var c = color[0];
	
	        if(Array.isArray(c)) color = c;
	
	        return 'rgb(' + color.slice(0, 3).map(function(x) {
	            return Math.round(x * 255);
	        }) + ')';
	    }
	
	    return null;
	}
	
	proto.update = function(data) {
	    var gl = this.scene.glplot.gl;
	    var lineOptions;
	    var scatterOptions;
	    var errorOptions;
	    var textOptions;
	    var dashPattern = DASH_PATTERNS.solid;
	
	    // Save data
	    this.data = data;
	
	    // Run data conversion
	    var options = convertPlotlyOptions(this.scene, data);
	
	    if('mode' in options) {
	        this.mode = options.mode;
	    }
	    if('lineDashes' in options) {
	        if(options.lineDashes in DASH_PATTERNS) {
	            dashPattern = DASH_PATTERNS[options.lineDashes];
	        }
	    }
	
	    this.color = arrayToColor(options.scatterColor) ||
	                 arrayToColor(options.lineColor);
	
	    // Save data points
	    this.dataPoints = options.position;
	
	    lineOptions = {
	        gl: this.scene.glplot.gl,
	        position: options.position,
	        color: options.lineColor,
	        lineWidth: options.lineWidth || 1,
	        dashes: dashPattern[0],
	        dashScale: dashPattern[1],
	        opacity: data.opacity,
	        connectGaps: data.connectgaps
	    };
	
	    if(this.mode.indexOf('lines') !== -1) {
	        if(this.linePlot) this.linePlot.update(lineOptions);
	        else {
	            this.linePlot = createLinePlot(lineOptions);
	            this.linePlot._trace = this;
	            this.scene.glplot.add(this.linePlot);
	        }
	    } else if(this.linePlot) {
	        this.scene.glplot.remove(this.linePlot);
	        this.linePlot.dispose();
	        this.linePlot = null;
	    }
	
	    // N.B. marker.opacity must be a scalar for performance
	    var scatterOpacity = data.opacity;
	    if(data.marker && data.marker.opacity) scatterOpacity *= data.marker.opacity;
	
	    scatterOptions = {
	        gl: this.scene.glplot.gl,
	        position: options.position,
	        color: options.scatterColor,
	        size: options.scatterSize,
	        glyph: options.scatterMarker,
	        opacity: scatterOpacity,
	        orthographic: true,
	        lineWidth: options.scatterLineWidth,
	        lineColor: options.scatterLineColor,
	        project: options.project,
	        projectScale: options.projectScale,
	        projectOpacity: options.projectOpacity
	    };
	
	    if(this.mode.indexOf('markers') !== -1) {
	        if(this.scatterPlot) this.scatterPlot.update(scatterOptions);
	        else {
	            this.scatterPlot = createScatterPlot(scatterOptions);
	            this.scatterPlot._trace = this;
	            this.scatterPlot.highlightScale = 1;
	            this.scene.glplot.add(this.scatterPlot);
	        }
	    } else if(this.scatterPlot) {
	        this.scene.glplot.remove(this.scatterPlot);
	        this.scatterPlot.dispose();
	        this.scatterPlot = null;
	    }
	
	    textOptions = {
	        gl: this.scene.glplot.gl,
	        position: options.position,
	        glyph: options.text,
	        color: options.textColor,
	        size: options.textSize,
	        angle: options.textAngle,
	        alignment: options.textOffset,
	        font: options.textFont,
	        orthographic: true,
	        lineWidth: 0,
	        project: false,
	        opacity: data.opacity
	    };
	
	    this.textLabels = data.hovertext || data.text;
	
	    if(this.mode.indexOf('text') !== -1) {
	        if(this.textMarkers) this.textMarkers.update(textOptions);
	        else {
	            this.textMarkers = createScatterPlot(textOptions);
	            this.textMarkers._trace = this;
	            this.textMarkers.highlightScale = 1;
	            this.scene.glplot.add(this.textMarkers);
	        }
	    } else if(this.textMarkers) {
	        this.scene.glplot.remove(this.textMarkers);
	        this.textMarkers.dispose();
	        this.textMarkers = null;
	    }
	
	    errorOptions = {
	        gl: this.scene.glplot.gl,
	        position: options.position,
	        color: options.errorColor,
	        error: options.errorBounds,
	        lineWidth: options.errorLineWidth,
	        capSize: options.errorCapSize,
	        opacity: data.opacity
	    };
	    if(this.errorBars) {
	        if(options.errorBounds) {
	            this.errorBars.update(errorOptions);
	        } else {
	            this.scene.glplot.remove(this.errorBars);
	            this.errorBars.dispose();
	            this.errorBars = null;
	        }
	    } else if(options.errorBounds) {
	        this.errorBars = createErrorBars(errorOptions);
	        this.errorBars._trace = this;
	        this.scene.glplot.add(this.errorBars);
	    }
	
	    if(options.delaunayAxis >= 0) {
	        var delaunayOptions = constructDelaunay(
	            options.position,
	            options.delaunayColor,
	            options.delaunayAxis
	        );
	        delaunayOptions.opacity = data.opacity;
	
	        if(this.delaunayMesh) {
	            this.delaunayMesh.update(delaunayOptions);
	        } else {
	            delaunayOptions.gl = gl;
	            this.delaunayMesh = createMesh(delaunayOptions);
	            this.delaunayMesh._trace = this;
	            this.scene.glplot.add(this.delaunayMesh);
	        }
	    } else if(this.delaunayMesh) {
	        this.scene.glplot.remove(this.delaunayMesh);
	        this.delaunayMesh.dispose();
	        this.delaunayMesh = null;
	    }
	};
	
	proto.dispose = function() {
	    if(this.linePlot) {
	        this.scene.glplot.remove(this.linePlot);
	        this.linePlot.dispose();
	    }
	    if(this.scatterPlot) {
	        this.scene.glplot.remove(this.scatterPlot);
	        this.scatterPlot.dispose();
	    }
	    if(this.errorBars) {
	        this.scene.glplot.remove(this.errorBars);
	        this.errorBars.dispose();
	    }
	    if(this.textMarkers) {
	        this.scene.glplot.remove(this.textMarkers);
	        this.textMarkers.dispose();
	    }
	    if(this.delaunayMesh) {
	        this.scene.glplot.remove(this.delaunayMesh);
	        this.delaunayMesh.dispose();
	    }
	};
	
	function createLineWithMarkers(scene, data) {
	    var plot = new LineWithMarkers(scene, data.uid);
	    plot.update(data);
	    return plot;
	}
	
	module.exports = createLineWithMarkers;
	
	},{"../../components/fx/helpers":626,"../../constants/gl3d_dashes":689,"../../constants/gl3d_markers":690,"../../lib":716,"../../lib/gl_format_color":713,"../../lib/str2rgbarray":739,"../../plots/cartesian/axes":764,"../scatter/make_bubble_size_func":1135,"./calc_errors":1147,"delaunay-triangulate":166,"gl-error3d":249,"gl-line3d":257,"gl-mesh3d":282,"gl-scatter3d":299}],1149:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	    coerce('mode');
	
	    if(subTypes.hasLines(traceOut)) {
	        coerce('connectgaps');
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noSelect: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce, {noSelect: true});
	    }
	
	    var lineColor = (traceOut.line || {}).color;
	    var markerColor = (traceOut.marker || {}).color;
	    if(coerce('surfaceaxis') >= 0) coerce('surfacecolor', lineColor || markerColor);
	
	    var dims = ['x', 'y', 'z'];
	    for(var i = 0; i < 3; ++i) {
	        var projection = 'projection.' + dims[i];
	        if(coerce(projection + '.show')) {
	            coerce(projection + '.opacity');
	            coerce(projection + '.scale');
	        }
	    }
	
	    var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'z'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y', inherit: 'z'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'z'});
	};
	
	function handleXYZDefaults(traceIn, traceOut, coerce, layout) {
	    var len = 0;
	    var x = coerce('x');
	    var y = coerce('y');
	    var z = coerce('z');
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
	
	    if(x && y && z) {
	        // TODO: what happens if one is missing?
	        len = Math.min(x.length, y.length, z.length);
	        traceOut._length = traceOut._xlength = traceOut._ylength = traceOut._zlength = len;
	    }
	
	    return len;
	}
	
	},{"../../lib":716,"../../registry":845,"../scatter/line_defaults":1131,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1145}],1150:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    plot: _dereq_('./convert'),
	    attributes: _dereq_('./attributes'),
	    markerSymbols: _dereq_('../../constants/gl3d_markers'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: [
	        {
	            container: 'marker',
	            min: 'cmin',
	            max: 'cmax'
	        }, {
	            container: 'line',
	            min: 'cmin',
	            max: 'cmax'
	        }
	    ],
	    calc: _dereq_('./calc'),
	
	    moduleType: 'trace',
	    name: 'scatter3d',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d', 'symbols', 'showLegend', 'scatter-like'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../constants/gl3d_markers":690,"../../plots/gl3d":804,"./attributes":1145,"./calc":1146,"./convert":1148,"./defaults":1149}],1151:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterLineAttrs = scatterAttrs.line;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	module.exports = {
	    carpet: {
	        valType: 'string',
	        
	        editType: 'calc',
	        
	    },
	    a: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    b: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['a', 'b', 'text']
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	    line: {
	        color: scatterLineAttrs.color,
	        width: scatterLineAttrs.width,
	        dash: scatterLineAttrs.dash,
	        shape: extendFlat({}, scatterLineAttrs.shape,
	            {values: ['linear', 'spline']}),
	        smoothing: scatterLineAttrs.smoothing,
	        editType: 'calc'
	    },
	    connectgaps: scatterAttrs.connectgaps,
	    fill: extendFlat({}, scatterAttrs.fill, {
	        values: ['none', 'toself', 'tonext'],
	        dflt: 'none',
	        
	    }),
	    fillcolor: scatterAttrs.fillcolor,
	    marker: extendFlat({
	        symbol: scatterMarkerAttrs.symbol,
	        opacity: scatterMarkerAttrs.opacity,
	        maxdisplayed: scatterMarkerAttrs.maxdisplayed,
	        size: scatterMarkerAttrs.size,
	        sizeref: scatterMarkerAttrs.sizeref,
	        sizemin: scatterMarkerAttrs.sizemin,
	        sizemode: scatterMarkerAttrs.sizemode,
	        line: extendFlat({
	            width: scatterMarkerLineAttrs.width,
	            editType: 'calc'
	        },
	            colorScaleAttrs('marker.line')
	        ),
	        gradient: scatterMarkerAttrs.gradient,
	        editType: 'calc'
	    },
	        colorScaleAttrs('marker')
	    ),
	
	    textfont: scatterAttrs.textfont,
	    textposition: scatterAttrs.textposition,
	
	    selected: scatterAttrs.selected,
	    unselected: scatterAttrs.unselected,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['a', 'b', 'text', 'name']
	    }),
	    hoveron: scatterAttrs.hoveron,
	    hovertemplate: hovertemplateAttrs()
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scatter/attributes":1118}],1152:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
	var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
	
	module.exports = function calc(gd, trace) {
	    var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	    if(!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
	    var i;
	
	    // Transfer this over from carpet before plotting since this is a necessary
	    // condition in order for cartesian to actually plot this trace:
	    trace.xaxis = carpet.xaxis;
	    trace.yaxis = carpet.yaxis;
	
	    // make the calcdata array
	    var serieslen = trace._length;
	    var cd = new Array(serieslen);
	    var a, b;
	    var needsCull = false;
	    for(i = 0; i < serieslen; i++) {
	        a = trace.a[i];
	        b = trace.b[i];
	        if(isNumeric(a) && isNumeric(b)) {
	            var xy = carpet.ab2xy(+a, +b, true);
	            var visible = carpet.isVisible(+a, +b);
	            if(!visible) needsCull = true;
	            cd[i] = {x: xy[0], y: xy[1], a: a, b: b, vis: visible};
	        } else cd[i] = {x: false, y: false};
	    }
	
	    trace._needsCull = needsCull;
	
	    cd[0].carpet = carpet;
	    cd[0].trace = trace;
	
	    calcMarkerSize(trace, serieslen);
	    calcColorscale(gd, trace);
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	},{"../carpet/lookup_carpetid":914,"../scatter/arrays_to_calcdata":1117,"../scatter/calc":1119,"../scatter/calc_selection":1120,"../scatter/colorscale_calc":1121,"fast-isnumeric":227}],1153:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var constants = _dereq_('../scatter/constants');
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    coerce('carpet');
	
	    // XXX: Don't hard code this
	    traceOut.xaxis = 'x';
	    traceOut.yaxis = 'y';
	
	    var a = coerce('a');
	    var b = coerce('b');
	    var len = Math.min(a.length, b.length);
	
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = len;
	
	    coerce('text');
	    coerce('texttemplate');
	    coerce('hovertext');
	
	    var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
	    coerce('mode', defaultMode);
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        handleLineShapeDefaults(traceIn, traceOut, coerce);
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    var dfltHoverOn = [];
	
	    if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	        coerce('marker.maxdisplayed');
	        dfltHoverOn.push('points');
	    }
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	        if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	    }
	
	    if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
	        dfltHoverOn.push('fills');
	    }
	
	    var hoverOn = coerce('hoveron', dfltHoverOn.join('+') || 'points');
	    if(hoverOn !== 'fills') coerce('hovertemplate');
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../scatter/constants":1122,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/line_shape_defaults":1133,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1151}],1154:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt, trace, cd, pointNumber) {
	    var cdi = cd[pointNumber];
	
	    out.a = cdi.a;
	    out.b = cdi.b;
	    out.y = cdi.y;
	
	    return out;
	};
	
	},{}],1155:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function formatLabels(cdi, trace) {
	    var labels = {};
	
	    var carpet = trace._carpet;
	    var ij = carpet.ab2ij([cdi.a, cdi.b]);
	    var i0 = Math.floor(ij[0]);
	    var ti = ij[0] - i0;
	    var j0 = Math.floor(ij[1]);
	    var tj = ij[1] - j0;
	    var xy = carpet.evalxy([], i0, j0, ti, tj);
	
	    labels.yLabel = xy[1].toFixed(3);
	
	    return labels;
	};
	
	},{}],1156:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterHover = _dereq_('../scatter/hover');
	var fillText = _dereq_('../../lib').fillText;
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	    if(!scatterPointData || scatterPointData[0].index === false) return;
	
	    var newPointData = scatterPointData[0];
	
	    // if hovering on a fill, we don't show any point data so the label is
	    // unchanged from what scatter gives us - except that it needs to
	    // be constrained to the trianglular plot area, not just the rectangular
	    // area defined by the synthetic x and y axes
	    // TODO: in some cases the vertical middle of the shape is not within
	    // the triangular viewport at all, so the label can become disconnected
	    // from the shape entirely. But calculating what portion of the shape
	    // is actually visible, as constrained by the diagonal axis lines, is not
	    // so easy and anyway we lost the information we would have needed to do
	    // this inside scatterHover.
	    if(newPointData.index === undefined) {
	        var yFracUp = 1 - (newPointData.y0 / pointData.ya._length);
	        var xLen = pointData.xa._length;
	        var xMin = xLen * yFracUp / 2;
	        var xMax = xLen - xMin;
	        newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
	        newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
	        return scatterPointData;
	    }
	
	    var cdi = newPointData.cd[newPointData.index];
	
	    newPointData.a = cdi.a;
	    newPointData.b = cdi.b;
	
	    newPointData.xLabelVal = undefined;
	    newPointData.yLabelVal = undefined;
	    // TODO: nice formatting, and label by axis title, for a, b, and c?
	
	    var trace = newPointData.trace;
	    var carpet = trace._carpet;
	
	    var labels = trace._module.formatLabels(cdi, trace);
	    newPointData.yLabel = labels.yLabel;
	
	    delete newPointData.text;
	    var text = [];
	
	    function textPart(ax, val) {
	        var prefix;
	
	        if(ax.labelprefix && ax.labelprefix.length > 0) {
	            prefix = ax.labelprefix.replace(/ = $/, '');
	        } else {
	            prefix = ax._hovertitle;
	        }
	
	        text.push(prefix + ': ' + val.toFixed(3) + ax.labelsuffix);
	    }
	
	
	    if(!trace.hovertemplate) {
	        var hoverinfo = cdi.hi || trace.hoverinfo;
	        var parts = hoverinfo.split('+');
	
	        if(parts.indexOf('all') !== -1) parts = ['a', 'b', 'text'];
	        if(parts.indexOf('a') !== -1) textPart(carpet.aaxis, cdi.a);
	        if(parts.indexOf('b') !== -1) textPart(carpet.baxis, cdi.b);
	
	        text.push('y: ' + newPointData.yLabel);
	
	        if(parts.indexOf('text') !== -1) {
	            fillText(cdi, trace, text);
	        }
	
	        newPointData.extraText = text.join('<br>');
	    }
	
	    return scatterPointData;
	};
	
	},{"../../lib":716,"../scatter/hover":1129}],1157:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('../scatter/style').style,
	    styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('../scatter/select'),
	    eventData: _dereq_('./event_data'),
	
	    moduleType: 'trace',
	    name: 'scattercarpet',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['svg', 'carpet', 'symbols', 'showLegend', 'carpetDependent', 'zoomScale'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../scatter/marker_colorbar":1136,"../scatter/select":1139,"../scatter/style":1141,"./attributes":1151,"./calc":1152,"./defaults":1153,"./event_data":1154,"./format_labels":1155,"./hover":1156,"./plot":1158}],1158:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var scatterPlot = _dereq_('../scatter/plot');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var Drawing = _dereq_('../../components/drawing');
	
	module.exports = function plot(gd, plotinfoproxy, data, layer) {
	    var i, trace, node;
	
	    var carpet = data[0][0].carpet;
	    // mimic cartesian plotinfo
	    var plotinfo = {
	        xaxis: Axes.getFromId(gd, carpet.xaxis || 'x'),
	        yaxis: Axes.getFromId(gd, carpet.yaxis || 'y'),
	        plot: plotinfoproxy.plot,
	    };
	
	    scatterPlot(gd, plotinfo, data, layer);
	
	    for(i = 0; i < data.length; i++) {
	        trace = data[i][0].trace;
	
	        // Note: .select is adequate but seems to mutate the node data,
	        // which is at least a bit suprising and causes problems elsewhere
	        node = layer.selectAll('g.trace' + trace.uid + ' .js-line');
	
	        // Note: it would be more efficient if this didn't need to be applied
	        // separately to all scattercarpet traces, but that would require
	        // lots of reorganization of scatter traces that is otherwise not
	        // necessary. That makes this a potential optimization.
	        Drawing.setClipUrl(node, data[i][0].carpet._clipPathId, gd);
	    }
	};
	
	},{"../../components/drawing":612,"../../plots/cartesian/axes":764,"../scatter/plot":1138}],1159:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var scatterAttrs = _dereq_('../scatter/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var colorAttributes = _dereq_('../../components/colorscale/attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterLineAttrs = scatterAttrs.line;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	module.exports = overrideAll({
	    lon: {
	        valType: 'data_array',
	        
	    },
	    lat: {
	        valType: 'data_array',
	        
	    },
	
	    locations: {
	        valType: 'data_array',
	        
	    },
	    locationmode: {
	        valType: 'enumerated',
	        values: ['ISO-3', 'USA-states', 'country names'],
	        
	        dflt: 'ISO-3',
	        
	    },
	
	    mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
	
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['lat', 'lon', 'location', 'text']
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	
	    textfont: scatterAttrs.textfont,
	    textposition: scatterAttrs.textposition,
	
	    line: {
	        color: scatterLineAttrs.color,
	        width: scatterLineAttrs.width,
	        dash: dash
	    },
	    connectgaps: scatterAttrs.connectgaps,
	
	    marker: extendFlat({
	        symbol: scatterMarkerAttrs.symbol,
	        opacity: scatterMarkerAttrs.opacity,
	        size: scatterMarkerAttrs.size,
	        sizeref: scatterMarkerAttrs.sizeref,
	        sizemin: scatterMarkerAttrs.sizemin,
	        sizemode: scatterMarkerAttrs.sizemode,
	        colorbar: scatterMarkerAttrs.colorbar,
	        line: extendFlat({
	            width: scatterMarkerLineAttrs.width
	        },
	            colorAttributes('marker.line')
	        ),
	        gradient: scatterMarkerAttrs.gradient
	    },
	        colorAttributes('marker')
	    ),
	
	    fill: {
	        valType: 'enumerated',
	        values: ['none', 'toself'],
	        dflt: 'none',
	        
	        
	    },
	    fillcolor: scatterAttrs.fillcolor,
	
	    selected: scatterAttrs.selected,
	    unselected: scatterAttrs.unselected,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['lon', 'lat', 'location', 'text', 'name']
	    }),
	    hovertemplate: hovertemplateAttrs(),
	}, 'calc', 'nested');
	
	},{"../../components/colorscale/attributes":598,"../../components/drawing/attributes":611,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scatter/attributes":1118}],1160:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var calcMarkerColorscale = _dereq_('../scatter/colorscale_calc');
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	
	var _ = _dereq_('../../lib')._;
	
	module.exports = function calc(gd, trace) {
	    var hasLocationData = Array.isArray(trace.locations);
	    var len = hasLocationData ? trace.locations.length : trace._length;
	    var calcTrace = new Array(len);
	
	    for(var i = 0; i < len; i++) {
	        var calcPt = calcTrace[i] = {};
	
	        if(hasLocationData) {
	            var loc = trace.locations[i];
	            calcPt.loc = typeof loc === 'string' ? loc : null;
	        } else {
	            var lon = trace.lon[i];
	            var lat = trace.lat[i];
	
	            if(isNumeric(lon) && isNumeric(lat)) calcPt.lonlat = [+lon, +lat];
	            else calcPt.lonlat = [BADNUM, BADNUM];
	        }
	    }
	
	    arraysToCalcdata(calcTrace, trace);
	    calcMarkerColorscale(gd, trace);
	    calcSelection(calcTrace, trace);
	
	    if(len) {
	        calcTrace[0].t = {
	            labels: {
	                lat: _(gd, 'lat:') + ' ',
	                lon: _(gd, 'lon:') + ' '
	            }
	        };
	    }
	
	    return calcTrace;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../scatter/arrays_to_calcdata":1117,"../scatter/calc_selection":1120,"../scatter/colorscale_calc":1121,"fast-isnumeric":227}],1161:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleLonLatLocDefaults(traceIn, traceOut, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	    coerce('mode');
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	    }
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	function handleLonLatLocDefaults(traceIn, traceOut, coerce) {
	    var len = 0;
	    var locations = coerce('locations');
	
	    var lon, lat;
	
	    if(locations) {
	        coerce('locationmode');
	        len = locations.length;
	        return len;
	    }
	
	    lon = coerce('lon') || [];
	    lat = coerce('lat') || [];
	    len = Math.min(lon.length, lat.length);
	    traceOut._length = len;
	
	    return len;
	}
	
	},{"../../lib":716,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1159}],1162:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = function eventData(out, pt) {
	    out.lon = pt.lon;
	    out.lat = pt.lat;
	    out.location = pt.loc ? pt.loc : null;
	
	    return out;
	};
	
	},{}],1163:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var labels = {};
	
	    var geo = fullLayout[trace.geo]._subplot;
	    var ax = geo.mockAxis;
	    var lonlat = cdi.lonlat;
	    labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
	    labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
	
	    return labels;
	};
	
	},{"../../plots/cartesian/axes":764}],1164:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var getTraceColor = _dereq_('../scatter/get_trace_color');
	var fillText = _dereq_('../../lib').fillText;
	var attributes = _dereq_('./attributes');
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var geo = pointData.subplot;
	
	    var isLonLatOverEdges = geo.projection.isLonLatOverEdges;
	    var project = geo.project;
	
	    function distFn(d) {
	        var lonlat = d.lonlat;
	
	        if(lonlat[0] === BADNUM) return Infinity;
	        if(isLonLatOverEdges(lonlat)) return Infinity;
	
	        var pt = project(lonlat);
	        var px = project([xval, yval]);
	        var dx = Math.abs(pt[0] - px[0]);
	        var dy = Math.abs(pt[1] - px[1]);
	        var rad = Math.max(3, d.mrc || 0);
	
	        // N.B. d.mrc is the calculated marker radius
	        // which is only set for trace with 'markers' mode.
	
	        return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
	    }
	
	    Fx.getClosest(cd, distFn, pointData);
	
	    // skip the rest (for this trace) if we didn't find a close point
	    if(pointData.index === false) return;
	
	    var di = cd[pointData.index];
	    var lonlat = di.lonlat;
	    var pos = [xa.c2p(lonlat), ya.c2p(lonlat)];
	    var rad = di.mrc || 1;
	
	    pointData.x0 = pos[0] - rad;
	    pointData.x1 = pos[0] + rad;
	    pointData.y0 = pos[1] - rad;
	    pointData.y1 = pos[1] + rad;
	
	    pointData.loc = di.loc;
	    pointData.lon = lonlat[0];
	    pointData.lat = lonlat[1];
	
	    var fullLayout = {};
	    fullLayout[trace.geo] = {_subplot: geo};
	    var labels = trace._module.formatLabels(di, trace, fullLayout);
	    pointData.lonLabel = labels.lonLabel;
	    pointData.latLabel = labels.latLabel;
	
	    pointData.color = getTraceColor(trace, di);
	    pointData.extraText = getExtraText(trace, di, pointData, cd[0].t.labels);
	    pointData.hovertemplate = trace.hovertemplate;
	
	    return [pointData];
	};
	
	function getExtraText(trace, pt, pointData, labels) {
	    if(trace.hovertemplate) return;
	
	    var hoverinfo = pt.hi || trace.hoverinfo;
	
	    var parts = hoverinfo === 'all' ?
	        attributes.hoverinfo.flags :
	        hoverinfo.split('+');
	
	    var hasLocation = parts.indexOf('location') !== -1 && Array.isArray(trace.locations);
	    var hasLon = (parts.indexOf('lon') !== -1);
	    var hasLat = (parts.indexOf('lat') !== -1);
	    var hasText = (parts.indexOf('text') !== -1);
	    var text = [];
	
	    function format(val) { return val + '\u00B0'; }
	
	    if(hasLocation) {
	        text.push(pt.loc);
	    } else if(hasLon && hasLat) {
	        text.push('(' + format(pointData.lonLabel) + ', ' + format(pointData.latLabel) + ')');
	    } else if(hasLon) {
	        text.push(labels.lon + format(pointData.lonLabel));
	    } else if(hasLat) {
	        text.push(labels.lat + format(pointData.latLabel));
	    }
	
	    if(hasText) {
	        fillText(pt, trace, text);
	    }
	
	    return text.join('<br>');
	}
	
	},{"../../components/fx":629,"../../constants/numerical":692,"../../lib":716,"../scatter/get_trace_color":1128,"./attributes":1159}],1165:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	    selectPoints: _dereq_('./select'),
	
	    moduleType: 'trace',
	    name: 'scattergeo',
	    basePlotModule: _dereq_('../../plots/geo'),
	    categories: ['geo', 'symbols', 'showLegend', 'scatter-like'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/geo":794,"../scatter/marker_colorbar":1136,"../scatter/style":1141,"./attributes":1159,"./calc":1160,"./defaults":1161,"./event_data":1162,"./format_labels":1163,"./hover":1164,"./plot":1166,"./select":1167,"./style":1168}],1166:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Lib = _dereq_('../../lib');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	var getTopojsonFeatures = _dereq_('../../lib/topojson_utils').getTopojsonFeatures;
	var locationToFeature = _dereq_('../../lib/geo_location_utils').locationToFeature;
	var geoJsonUtils = _dereq_('../../lib/geojson_utils');
	var subTypes = _dereq_('../scatter/subtypes');
	var style = _dereq_('./style');
	
	module.exports = function plot(gd, geo, calcData) {
	    for(var i = 0; i < calcData.length; i++) {
	        calcGeoJSON(calcData[i], geo.topojson);
	    }
	
	    function removeBADNUM(d, node) {
	        if(d.lonlat[0] === BADNUM) {
	            d3.select(node).remove();
	        }
	    }
	
	    var scatterLayer = geo.layers.frontplot.select('.scatterlayer');
	    var gTraces = Lib.makeTraceGroups(scatterLayer, calcData, 'trace scattergeo');
	
	    // TODO find a way to order the inner nodes on update
	    gTraces.selectAll('*').remove();
	
	    gTraces.each(function(calcTrace) {
	        var s = d3.select(this);
	        var trace = calcTrace[0].trace;
	
	        if(subTypes.hasLines(trace) || trace.fill !== 'none') {
	            var lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
	
	            var lineData = (trace.fill !== 'none') ?
	                geoJsonUtils.makePolygon(lineCoords) :
	                geoJsonUtils.makeLine(lineCoords);
	
	            s.selectAll('path.js-line')
	                .data([{geojson: lineData, trace: trace}])
	              .enter().append('path')
	                .classed('js-line', true)
	                .style('stroke-miterlimit', 2);
	        }
	
	        if(subTypes.hasMarkers(trace)) {
	            s.selectAll('path.point')
	                .data(Lib.identity)
	             .enter().append('path')
	                .classed('point', true)
	                .each(function(calcPt) { removeBADNUM(calcPt, this); });
	        }
	
	        if(subTypes.hasText(trace)) {
	            s.selectAll('g')
	                .data(Lib.identity)
	              .enter().append('g')
	                .append('text')
	                .each(function(calcPt) { removeBADNUM(calcPt, this); });
	        }
	
	        // call style here within topojson request callback
	        style(gd, calcTrace);
	    });
	};
	
	function calcGeoJSON(calcTrace, topojson) {
	    var trace = calcTrace[0].trace;
	
	    if(!Array.isArray(trace.locations)) return;
	
	    var features = getTopojsonFeatures(trace, topojson);
	    var locationmode = trace.locationmode;
	
	    for(var i = 0; i < calcTrace.length; i++) {
	        var calcPt = calcTrace[i];
	        var feature = locationToFeature(locationmode, calcPt.loc, features);
	
	        calcPt.lonlat = feature ? feature.properties.ct : [BADNUM, BADNUM];
	    }
	}
	
	},{"../../constants/numerical":692,"../../lib":716,"../../lib/geo_location_utils":710,"../../lib/geojson_utils":711,"../../lib/topojson_utils":743,"../scatter/subtypes":1142,"./style":1168,"d3":164}],1167:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var subtypes = _dereq_('../scatter/subtypes');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	    var trace = cd[0].trace;
	
	    var di, lonlat, x, y, i;
	
	    var hasOnlyLines = (!subtypes.hasMarkers(trace) && !subtypes.hasText(trace));
	    if(hasOnlyLines) return [];
	
	    if(selectionTester === false) {
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            di = cd[i];
	            lonlat = di.lonlat;
	
	            // some projection types can't handle BADNUMs
	            if(lonlat[0] === BADNUM) continue;
	
	            x = xa.c2p(lonlat);
	            y = ya.c2p(lonlat);
	
	            if(selectionTester.contains([x, y], null, i, searchInfo)) {
	                selection.push({
	                    pointNumber: i,
	                    lon: lonlat[0],
	                    lat: lonlat[1]
	                });
	                di.selected = 1;
	            } else {
	                di.selected = 0;
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{"../../constants/numerical":692,"../scatter/subtypes":1142}],1168:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Drawing = _dereq_('../../components/drawing');
	var Color = _dereq_('../../components/color');
	
	var scatterStyle = _dereq_('../scatter/style');
	var stylePoints = scatterStyle.stylePoints;
	var styleText = scatterStyle.styleText;
	
	module.exports = function style(gd, calcTrace) {
	    if(calcTrace) styleTrace(gd, calcTrace);
	};
	
	function styleTrace(gd, calcTrace) {
	    var trace = calcTrace[0].trace;
	    var s = calcTrace[0].node3;
	
	    s.style('opacity', calcTrace[0].trace.opacity);
	
	    stylePoints(s, trace, gd);
	    styleText(s, trace, gd);
	
	    // this part is incompatible with Drawing.lineGroupStyle
	    s.selectAll('path.js-line')
	        .style('fill', 'none')
	        .each(function(d) {
	            var path = d3.select(this);
	            var trace = d.trace;
	            var line = trace.line || {};
	
	            path.call(Color.stroke, line.color)
	                .call(Drawing.dashLine, line.dash || '', line.width || 0);
	
	            if(trace.fill !== 'none') {
	                path.call(Color.fill, trace.fillcolor);
	            }
	        });
	}
	
	},{"../../components/color":591,"../../components/drawing":612,"../scatter/style":1141,"d3":164}],1169:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var baseAttrs = _dereq_('../../plots/attributes');
	var scatterAttrs = _dereq_('../scatter/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var DASHES = _dereq_('./constants').DASHES;
	
	var scatterLineAttrs = scatterAttrs.line;
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	var attrs = module.exports = overrideAll({
	    x: scatterAttrs.x,
	    x0: scatterAttrs.x0,
	    dx: scatterAttrs.dx,
	    y: scatterAttrs.y,
	    y0: scatterAttrs.y0,
	    dy: scatterAttrs.dy,
	
	    text: scatterAttrs.text,
	    hovertext: scatterAttrs.hovertext,
	
	    textposition: scatterAttrs.textposition,
	    textfont: scatterAttrs.textfont,
	
	    mode: {
	        valType: 'flaglist',
	        flags: ['lines', 'markers', 'text'],
	        extras: ['none'],
	        
	        
	    },
	    line: {
	        color: scatterLineAttrs.color,
	        width: scatterLineAttrs.width,
	        shape: {
	            valType: 'enumerated',
	            values: ['linear', 'hv', 'vh', 'hvh', 'vhv'],
	            dflt: 'linear',
	            
	            editType: 'plot',
	            
	        },
	        dash: {
	            valType: 'enumerated',
	            values: Object.keys(DASHES),
	            dflt: 'solid',
	            
	            
	        }
	    },
	    marker: extendFlat({}, colorScaleAttrs('marker'), {
	        symbol: scatterMarkerAttrs.symbol,
	        size: scatterMarkerAttrs.size,
	        sizeref: scatterMarkerAttrs.sizeref,
	        sizemin: scatterMarkerAttrs.sizemin,
	        sizemode: scatterMarkerAttrs.sizemode,
	        opacity: scatterMarkerAttrs.opacity,
	        colorbar: scatterMarkerAttrs.colorbar,
	        line: extendFlat({}, colorScaleAttrs('marker.line'), {
	            width: scatterMarkerLineAttrs.width
	        })
	    }),
	    connectgaps: scatterAttrs.connectgaps,
	    fill: extendFlat({}, scatterAttrs.fill, {dflt: 'none'}),
	    fillcolor: scatterAttrs.fillcolor,
	
	    // no hoveron
	
	    selected: {
	        marker: scatterAttrs.selected.marker,
	        textfont: scatterAttrs.selected.textfont
	    },
	    unselected: {
	        marker: scatterAttrs.unselected.marker,
	        textfont: scatterAttrs.unselected.textfont
	    },
	
	    opacity: baseAttrs.opacity
	
	}, 'calc', 'nested');
	
	attrs.x.editType = attrs.y.editType = attrs.x0.editType = attrs.y0.editType = 'calc+clearAxisTypes';
	attrs.hovertemplate = scatterAttrs.hovertemplate;
	attrs.texttemplate = scatterAttrs.texttemplate;
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../scatter/attributes":1118,"./constants":1171}],1170:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var cluster = _dereq_('point-cluster');
	
	var Lib = _dereq_('../../lib');
	var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
	var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
	
	var scatterCalc = _dereq_('../scatter/calc');
	var calcMarkerSize = scatterCalc.calcMarkerSize;
	var calcAxisExpansion = scatterCalc.calcAxisExpansion;
	var setFirstScatter = scatterCalc.setFirstScatter;
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var convert = _dereq_('./convert');
	var sceneUpdate = _dereq_('./scene_update');
	
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	var TOO_MANY_POINTS = _dereq_('./constants').TOO_MANY_POINTS;
	
	module.exports = function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var xa = AxisIDs.getFromId(gd, trace.xaxis);
	    var ya = AxisIDs.getFromId(gd, trace.yaxis);
	    var subplot = fullLayout._plots[trace.xaxis + trace.yaxis];
	    var len = trace._length;
	    var hasTooManyPoints = len >= TOO_MANY_POINTS;
	    var len2 = len * 2;
	    var stash = {};
	    var i, xx, yy;
	
	    var x = trace._x = xa.makeCalcdata(trace, 'x');
	    var y = trace._y = ya.makeCalcdata(trace, 'y');
	
	    // we need hi-precision for scatter2d,
	    // regl-scatter2d uses NaNs for bad/missing values
	    var positions = new Array(len2);
	    for(i = 0; i < len; i++) {
	        xx = x[i];
	        yy = y[i];
	        positions[i * 2] = xx === BADNUM ? NaN : xx;
	        positions[i * 2 + 1] = yy === BADNUM ? NaN : yy;
	    }
	
	    if(xa.type === 'log') {
	        for(i = 0; i < len2; i += 2) {
	            positions[i] = xa.c2l(positions[i]);
	        }
	    }
	    if(ya.type === 'log') {
	        for(i = 1; i < len2; i += 2) {
	            positions[i] = ya.c2l(positions[i]);
	        }
	    }
	
	    // we don't build a tree for log axes since it takes long to convert log2px
	    // and it is also
	    if(hasTooManyPoints && (xa.type !== 'log' && ya.type !== 'log')) {
	        // FIXME: delegate this to webworker
	        stash.tree = cluster(positions);
	    } else {
	        var ids = stash.ids = new Array(len);
	        for(i = 0; i < len; i++) {
	            ids[i] = i;
	        }
	    }
	
	    // create scene options and scene
	    calcColorscale(gd, trace);
	    var opts = sceneOptions(gd, subplot, trace, positions, x, y);
	    var scene = sceneUpdate(gd, subplot);
	
	    // Reuse SVG scatter axis expansion routine.
	    // For graphs with very large number of points and array marker.size,
	    // use average marker size instead to speed things up.
	    setFirstScatter(fullLayout, trace);
	    var ppad;
	    if(!hasTooManyPoints) {
	        ppad = calcMarkerSize(trace, len);
	    } else if(opts.marker) {
	        ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
	    }
	    calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	    if(opts.errorX) expandForErrorBars(trace, xa, opts.errorX);
	    if(opts.errorY) expandForErrorBars(trace, ya, opts.errorY);
	
	    // set flags to create scene renderers
	    if(opts.fill && !scene.fill2d) scene.fill2d = true;
	    if(opts.marker && !scene.scatter2d) scene.scatter2d = true;
	    if(opts.line && !scene.line2d) scene.line2d = true;
	    if((opts.errorX || opts.errorY) && !scene.error2d) scene.error2d = true;
	    if(opts.text && !scene.glText) scene.glText = true;
	    if(opts.marker) opts.marker.snap = len;
	
	    scene.lineOptions.push(opts.line);
	    scene.errorXOptions.push(opts.errorX);
	    scene.errorYOptions.push(opts.errorY);
	    scene.fillOptions.push(opts.fill);
	    scene.markerOptions.push(opts.marker);
	    scene.markerSelectedOptions.push(opts.markerSel);
	    scene.markerUnselectedOptions.push(opts.markerUnsel);
	    scene.textOptions.push(opts.text);
	    scene.textSelectedOptions.push(opts.textSel);
	    scene.textUnselectedOptions.push(opts.textUnsel);
	    scene.selectBatch.push([]);
	    scene.unselectBatch.push([]);
	
	    stash._scene = scene;
	    stash.index = scene.count;
	    stash.x = x;
	    stash.y = y;
	    stash.positions = positions;
	    scene.count++;
	
	    return [{x: false, y: false, t: stash, trace: trace}];
	};
	
	function expandForErrorBars(trace, ax, opts) {
	    var extremes = trace._extremes[ax._id];
	    var errExt = findExtremes(ax, opts._bnds, {padded: true});
	    extremes.min = extremes.min.concat(errExt.min);
	    extremes.max = extremes.max.concat(errExt.max);
	}
	
	function sceneOptions(gd, subplot, trace, positions, x, y) {
	    var opts = convert.style(gd, trace);
	
	    if(opts.marker) {
	        opts.marker.positions = positions;
	    }
	
	    if(opts.line && positions.length > 1) {
	        Lib.extendFlat(
	            opts.line,
	            convert.linePositions(gd, trace, positions)
	        );
	    }
	
	    if(opts.errorX || opts.errorY) {
	        var errors = convert.errorBarPositions(gd, trace, positions, x, y);
	
	        if(opts.errorX) {
	            Lib.extendFlat(opts.errorX, errors.x);
	        }
	        if(opts.errorY) {
	            Lib.extendFlat(opts.errorY, errors.y);
	        }
	    }
	
	    if(opts.text) {
	        Lib.extendFlat(
	            opts.text,
	            {positions: positions},
	            convert.textPosition(gd, trace, opts.text, opts.marker)
	        );
	        Lib.extendFlat(
	            opts.textSel,
	            {positions: positions},
	            convert.textPosition(gd, trace, opts.text, opts.markerSel)
	        );
	        Lib.extendFlat(
	            opts.textUnsel,
	            {positions: positions},
	            convert.textPosition(gd, trace, opts.text, opts.markerUnsel)
	        );
	    }
	
	    return opts;
	}
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/autorange":763,"../../plots/cartesian/axis_ids":767,"../scatter/calc":1119,"../scatter/colorscale_calc":1121,"./constants":1171,"./convert":1172,"./scene_update":1179,"point-cluster":470}],1171:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var SYMBOL_SIZE = 20;
	
	module.exports = {
	    TOO_MANY_POINTS: 1e5,
	
	    SYMBOL_SDF_SIZE: 200,
	    SYMBOL_SIZE: SYMBOL_SIZE,
	    SYMBOL_STROKE: SYMBOL_SIZE / 20,
	
	    DOT_RE: /-dot/,
	    OPEN_RE: /-open/,
	
	    DASHES: {
	        solid: [1],
	        dot: [1, 1],
	        dash: [4, 1],
	        longdash: [8, 1],
	        dashdot: [4, 1, 1, 1],
	        longdashdot: [8, 1, 1, 1]
	    }
	};
	
	},{}],1172:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var svgSdf = _dereq_('svg-path-sdf');
	var rgba = _dereq_('color-normalize');
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
	
	var formatColor = _dereq_('../../lib/gl_format_color').formatColor;
	var subTypes = _dereq_('../scatter/subtypes');
	var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
	
	var constants = _dereq_('./constants');
	var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
	
	var TEXTOFFSETSIGN = {
	    start: 1, left: 1, end: -1, right: -1, middle: 0, center: 0, bottom: 1, top: -1
	};
	
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	
	function convertStyle(gd, trace) {
	    var i;
	
	    var opts = {
	        marker: undefined,
	        markerSel: undefined,
	        markerUnsel: undefined,
	        line: undefined,
	        fill: undefined,
	        errorX: undefined,
	        errorY: undefined,
	        text: undefined,
	        textSel: undefined,
	        textUnsel: undefined
	    };
	
	    if(trace.visible !== true) return opts;
	
	    if(subTypes.hasText(trace)) {
	        opts.text = convertTextStyle(gd, trace);
	        opts.textSel = convertTextSelection(gd, trace, trace.selected);
	        opts.textUnsel = convertTextSelection(gd, trace, trace.unselected);
	    }
	
	    if(subTypes.hasMarkers(trace)) {
	        opts.marker = convertMarkerStyle(trace);
	        opts.markerSel = convertMarkerSelection(trace, trace.selected);
	        opts.markerUnsel = convertMarkerSelection(trace, trace.unselected);
	
	        if(!trace.unselected && Array.isArray(trace.marker.opacity)) {
	            var mo = trace.marker.opacity;
	            opts.markerUnsel.opacity = new Array(mo.length);
	            for(i = 0; i < mo.length; i++) {
	                opts.markerUnsel.opacity[i] = DESELECTDIM * mo[i];
	            }
	        }
	    }
	
	    if(subTypes.hasLines(trace)) {
	        opts.line = {
	            overlay: true,
	            thickness: trace.line.width,
	            color: trace.line.color,
	            opacity: trace.opacity
	        };
	
	        var dashes = (constants.DASHES[trace.line.dash] || [1]).slice();
	        for(i = 0; i < dashes.length; ++i) {
	            dashes[i] *= trace.line.width;
	        }
	        opts.line.dashes = dashes;
	    }
	
	    if(trace.error_x && trace.error_x.visible) {
	        opts.errorX = convertErrorBarStyle(trace, trace.error_x);
	    }
	
	    if(trace.error_y && trace.error_y.visible) {
	        opts.errorY = convertErrorBarStyle(trace, trace.error_y);
	    }
	
	    if(!!trace.fill && trace.fill !== 'none') {
	        opts.fill = {
	            closed: true,
	            fill: trace.fillcolor,
	            thickness: 0
	        };
	    }
	
	    return opts;
	}
	
	function convertTextStyle(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var count = trace._length;
	    var textfontIn = trace.textfont;
	    var textpositionIn = trace.textposition;
	    var textPos = Array.isArray(textpositionIn) ? textpositionIn : [textpositionIn];
	    var tfc = textfontIn.color;
	    var tfs = textfontIn.size;
	    var tff = textfontIn.family;
	    var optsOut = {};
	    var i;
	
	    var texttemplate = trace.texttemplate;
	    if(texttemplate) {
	        optsOut.text = [];
	
	        var d3locale = fullLayout._d3locale;
	        var isArray = Array.isArray(texttemplate);
	        var N = isArray ? Math.min(texttemplate.length, count) : count;
	        var txt = isArray ?
	            function(i) { return texttemplate[i]; } :
	            function() { return texttemplate; };
	
	        for(i = 0; i < N; i++) {
	            var d = {i: i};
	            var labels = trace._module.formatLabels(d, trace, fullLayout);
	            var pointValues = {};
	            appendArrayPointValue(pointValues, trace, i);
	            var meta = trace._meta || {};
	            optsOut.text.push(Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta));
	        }
	    } else {
	        if(Array.isArray(trace.text) && trace.text.length < count) {
	            // if text array is shorter, we'll need to append to it, so let's slice to prevent mutating
	            optsOut.text = trace.text.slice();
	        } else {
	            optsOut.text = trace.text;
	        }
	    }
	    // pad text array with empty strings
	    if(Array.isArray(optsOut.text)) {
	        for(i = optsOut.text.length; i < count; i++) {
	            optsOut.text[i] = '';
	        }
	    }
	
	    optsOut.opacity = trace.opacity;
	    optsOut.font = {};
	    optsOut.align = [];
	    optsOut.baseline = [];
	
	    for(i = 0; i < textPos.length; i++) {
	        var tp = textPos[i].split(/\s+/);
	
	        switch(tp[1]) {
	            case 'left':
	                optsOut.align.push('right');
	                break;
	            case 'right':
	                optsOut.align.push('left');
	                break;
	            default:
	                optsOut.align.push(tp[1]);
	        }
	        switch(tp[0]) {
	            case 'top':
	                optsOut.baseline.push('bottom');
	                break;
	            case 'bottom':
	                optsOut.baseline.push('top');
	                break;
	            default:
	                optsOut.baseline.push(tp[0]);
	        }
	    }
	
	    if(Array.isArray(tfc)) {
	        optsOut.color = new Array(count);
	        for(i = 0; i < count; i++) {
	            optsOut.color[i] = tfc[i];
	        }
	    } else {
	        optsOut.color = tfc;
	    }
	
	    if(Array.isArray(tfs) || Array.isArray(tff)) {
	        // if any textfont param is array - make render a batch
	        optsOut.font = new Array(count);
	        for(i = 0; i < count; i++) {
	            var fonti = optsOut.font[i] = {};
	
	            fonti.size = Array.isArray(tfs) ?
	                (isNumeric(tfs[i]) ? tfs[i] : 0) :
	                tfs;
	
	            fonti.family = Array.isArray(tff) ? tff[i] : tff;
	        }
	    } else {
	        // if both are single values, make render fast single-value
	        optsOut.font = {size: tfs, family: tff};
	    }
	
	    return optsOut;
	}
	
	
	function convertMarkerStyle(trace) {
	    var count = trace._length;
	    var optsIn = trace.marker;
	    var optsOut = {};
	    var i;
	
	    var multiSymbol = Array.isArray(optsIn.symbol);
	    var multiColor = Lib.isArrayOrTypedArray(optsIn.color);
	    var multiLineColor = Lib.isArrayOrTypedArray(optsIn.line.color);
	    var multiOpacity = Lib.isArrayOrTypedArray(optsIn.opacity);
	    var multiSize = Lib.isArrayOrTypedArray(optsIn.size);
	    var multiLineWidth = Lib.isArrayOrTypedArray(optsIn.line.width);
	
	    var isOpen;
	    if(!multiSymbol) isOpen = constants.OPEN_RE.test(optsIn.symbol);
	
	    // prepare colors
	    if(multiSymbol || multiColor || multiLineColor || multiOpacity) {
	        optsOut.colors = new Array(count);
	        optsOut.borderColors = new Array(count);
	
	        var colors = formatColor(optsIn, optsIn.opacity, count);
	        var borderColors = formatColor(optsIn.line, optsIn.opacity, count);
	
	        if(!Array.isArray(borderColors[0])) {
	            var borderColor = borderColors;
	            borderColors = Array(count);
	            for(i = 0; i < count; i++) {
	                borderColors[i] = borderColor;
	            }
	        }
	        if(!Array.isArray(colors[0])) {
	            var color = colors;
	            colors = Array(count);
	            for(i = 0; i < count; i++) {
	                colors[i] = color;
	            }
	        }
	
	        optsOut.colors = colors;
	        optsOut.borderColors = borderColors;
	
	        for(i = 0; i < count; i++) {
	            if(multiSymbol) {
	                var symbol = optsIn.symbol[i];
	                isOpen = constants.OPEN_RE.test(symbol);
	            }
	            if(isOpen) {
	                borderColors[i] = colors[i].slice();
	                colors[i] = colors[i].slice();
	                colors[i][3] = 0;
	            }
	        }
	
	        optsOut.opacity = trace.opacity;
	    } else {
	        if(isOpen) {
	            optsOut.color = rgba(optsIn.color, 'uint8');
	            optsOut.color[3] = 0;
	            optsOut.borderColor = rgba(optsIn.color, 'uint8');
	        } else {
	            optsOut.color = rgba(optsIn.color, 'uint8');
	            optsOut.borderColor = rgba(optsIn.line.color, 'uint8');
	        }
	
	        optsOut.opacity = trace.opacity * optsIn.opacity;
	    }
	
	    // prepare symbols
	    if(multiSymbol) {
	        optsOut.markers = new Array(count);
	        for(i = 0; i < count; i++) {
	            optsOut.markers[i] = getSymbolSdf(optsIn.symbol[i]);
	        }
	    } else {
	        optsOut.marker = getSymbolSdf(optsIn.symbol);
	    }
	
	    // prepare sizes
	    var markerSizeFunc = makeBubbleSizeFn(trace);
	    var s;
	
	    if(multiSize || multiLineWidth) {
	        var sizes = optsOut.sizes = new Array(count);
	        var borderSizes = optsOut.borderSizes = new Array(count);
	        var sizeTotal = 0;
	        var sizeAvg;
	
	        if(multiSize) {
	            for(i = 0; i < count; i++) {
	                sizes[i] = markerSizeFunc(optsIn.size[i]);
	                sizeTotal += sizes[i];
	            }
	            sizeAvg = sizeTotal / count;
	        } else {
	            s = markerSizeFunc(optsIn.size);
	            for(i = 0; i < count; i++) {
	                sizes[i] = s;
	            }
	        }
	
	        // See  https://github.com/plotly/plotly.js/pull/1781#discussion_r121820798
	        if(multiLineWidth) {
	            for(i = 0; i < count; i++) {
	                borderSizes[i] = optsIn.line.width[i] / 2;
	            }
	        } else {
	            s = optsIn.line.width / 2;
	            for(i = 0; i < count; i++) {
	                borderSizes[i] = s;
	            }
	        }
	
	        optsOut.sizeAvg = sizeAvg;
	    } else {
	        optsOut.size = markerSizeFunc(optsIn && optsIn.size || 10);
	        optsOut.borderSizes = markerSizeFunc(optsIn.line.width);
	    }
	
	    return optsOut;
	}
	
	function convertMarkerSelection(trace, target) {
	    var optsIn = trace.marker;
	    var optsOut = {};
	
	    if(!target) return optsOut;
	
	    if(target.marker && target.marker.symbol) {
	        optsOut = convertMarkerStyle(Lib.extendFlat({}, optsIn, target.marker));
	    } else if(target.marker) {
	        if(target.marker.size) optsOut.size = target.marker.size / 2;
	        if(target.marker.color) optsOut.colors = target.marker.color;
	        if(target.marker.opacity !== undefined) optsOut.opacity = target.marker.opacity;
	    }
	
	    return optsOut;
	}
	
	function convertTextSelection(gd, trace, target) {
	    var optsOut = {};
	
	    if(!target) return optsOut;
	
	    if(target.textfont) {
	        var optsIn = {
	            opacity: 1,
	            text: trace.text,
	            texttemplate: trace.texttemplate,
	            textposition: trace.textposition,
	            textfont: Lib.extendFlat({}, trace.textfont)
	        };
	        if(target.textfont) {
	            Lib.extendFlat(optsIn.textfont, target.textfont);
	        }
	        optsOut = convertTextStyle(gd, optsIn);
	    }
	
	    return optsOut;
	}
	
	function convertErrorBarStyle(trace, target) {
	    var optsOut = {
	        capSize: target.width * 2,
	        lineWidth: target.thickness,
	        color: target.color
	    };
	
	    if(target.copy_ystyle) {
	        optsOut = trace.error_y;
	    }
	
	    return optsOut;
	}
	
	var SYMBOL_SDF_SIZE = constants.SYMBOL_SDF_SIZE;
	var SYMBOL_SIZE = constants.SYMBOL_SIZE;
	var SYMBOL_STROKE = constants.SYMBOL_STROKE;
	var SYMBOL_SDF = {};
	var SYMBOL_SVG_CIRCLE = Drawing.symbolFuncs[0](SYMBOL_SIZE * 0.05);
	
	function getSymbolSdf(symbol) {
	    if(symbol === 'circle') return null;
	
	    var symbolPath, symbolSdf;
	    var symbolNumber = Drawing.symbolNumber(symbol);
	    var symbolFunc = Drawing.symbolFuncs[symbolNumber % 100];
	    var symbolNoDot = !!Drawing.symbolNoDot[symbolNumber % 100];
	    var symbolNoFill = !!Drawing.symbolNoFill[symbolNumber % 100];
	
	    var isDot = constants.DOT_RE.test(symbol);
	
	    // get symbol sdf from cache or generate it
	    if(SYMBOL_SDF[symbol]) return SYMBOL_SDF[symbol];
	
	    if(isDot && !symbolNoDot) {
	        symbolPath = symbolFunc(SYMBOL_SIZE * 1.1) + SYMBOL_SVG_CIRCLE;
	    } else {
	        symbolPath = symbolFunc(SYMBOL_SIZE);
	    }
	
	    symbolSdf = svgSdf(symbolPath, {
	        w: SYMBOL_SDF_SIZE,
	        h: SYMBOL_SDF_SIZE,
	        viewBox: [-SYMBOL_SIZE, -SYMBOL_SIZE, SYMBOL_SIZE, SYMBOL_SIZE],
	        stroke: symbolNoFill ? SYMBOL_STROKE : -SYMBOL_STROKE
	    });
	    SYMBOL_SDF[symbol] = symbolSdf;
	
	    return symbolSdf || null;
	}
	
	function convertLinePositions(gd, trace, positions) {
	    var len = positions.length;
	    var count = len / 2;
	    var linePositions;
	    var i;
	
	    if(subTypes.hasLines(trace) && count) {
	        if(trace.line.shape === 'hv') {
	            linePositions = [];
	            for(i = 0; i < count - 1; i++) {
	                if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
	                    linePositions.push(NaN, NaN, NaN, NaN);
	                } else {
	                    linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                    if(!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
	                        linePositions.push(positions[i * 2 + 2], positions[i * 2 + 1]);
	                    } else {
	                        linePositions.push(NaN, NaN);
	                    }
	                }
	            }
	            linePositions.push(positions[len - 2], positions[len - 1]);
	        } else if(trace.line.shape === 'hvh') {
	            linePositions = [];
	            for(i = 0; i < count - 1; i++) {
	                if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
	                    if(!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                    } else {
	                        linePositions.push(NaN, NaN);
	                    }
	                    linePositions.push(NaN, NaN);
	                } else {
	                    var midPtX = (positions[i * 2] + positions[i * 2 + 2]) / 2;
	                    linePositions.push(
	                        positions[i * 2],
	                        positions[i * 2 + 1],
	                        midPtX,
	                        positions[i * 2 + 1],
	                        midPtX,
	                        positions[i * 2 + 3]
	                    );
	                }
	            }
	            linePositions.push(positions[len - 2], positions[len - 1]);
	        } else if(trace.line.shape === 'vhv') {
	            linePositions = [];
	            for(i = 0; i < count - 1; i++) {
	                if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
	                    if(!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                    } else {
	                        linePositions.push(NaN, NaN);
	                    }
	                    linePositions.push(NaN, NaN);
	                } else {
	                    var midPtY = (positions[i * 2 + 1] + positions[i * 2 + 3]) / 2;
	                    linePositions.push(
	                        positions[i * 2],
	                        positions[i * 2 + 1],
	                        positions[i * 2],
	                        midPtY,
	                        positions[i * 2 + 2],
	                        midPtY
	                    );
	                }
	            }
	            linePositions.push(positions[len - 2], positions[len - 1]);
	        } else if(trace.line.shape === 'vh') {
	            linePositions = [];
	            for(i = 0; i < count - 1; i++) {
	                if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
	                    linePositions.push(NaN, NaN, NaN, NaN);
	                } else {
	                    linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                    if(!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 3]);
	                    } else {
	                        linePositions.push(NaN, NaN);
	                    }
	                }
	            }
	            linePositions.push(positions[len - 2], positions[len - 1]);
	        } else {
	            linePositions = positions;
	        }
	    }
	
	    // If we have data with gaps, we ought to use rect joins
	    // FIXME: get rid of this
	    var hasNaN = false;
	    for(i = 0; i < linePositions.length; i++) {
	        if(isNaN(linePositions[i])) {
	            hasNaN = true;
	            break;
	        }
	    }
	
	    var join = (hasNaN || linePositions.length > constants.TOO_MANY_POINTS) ? 'rect' :
	        subTypes.hasMarkers(trace) ? 'rect' : 'round';
	
	    // fill gaps
	    if(hasNaN && trace.connectgaps) {
	        var lastX = linePositions[0];
	        var lastY = linePositions[1];
	
	        for(i = 0; i < linePositions.length; i += 2) {
	            if(isNaN(linePositions[i]) || isNaN(linePositions[i + 1])) {
	                linePositions[i] = lastX;
	                linePositions[i + 1] = lastY;
	            } else {
	                lastX = linePositions[i];
	                lastY = linePositions[i + 1];
	            }
	        }
	    }
	
	    return {
	        join: join,
	        positions: linePositions
	    };
	}
	
	function convertErrorBarPositions(gd, trace, positions, x, y) {
	    var makeComputeError = Registry.getComponentMethod('errorbars', 'makeComputeError');
	    var xa = AxisIDs.getFromId(gd, trace.xaxis);
	    var ya = AxisIDs.getFromId(gd, trace.yaxis);
	    var count = positions.length / 2;
	    var out = {};
	
	    function convertOneAxis(coords, ax) {
	        var axLetter = ax._id.charAt(0);
	        var opts = trace['error_' + axLetter];
	
	        if(opts && opts.visible && (ax.type === 'linear' || ax.type === 'log')) {
	            var computeError = makeComputeError(opts);
	            var pOffset = {x: 0, y: 1}[axLetter];
	            var eOffset = {x: [0, 1, 2, 3], y: [2, 3, 0, 1]}[axLetter];
	            var errors = new Float64Array(4 * count);
	            var minShoe = Infinity;
	            var maxHat = -Infinity;
	
	            for(var i = 0, j = 0; i < count; i++, j += 4) {
	                var dc = coords[i];
	
	                if(isNumeric(dc)) {
	                    var dl = positions[i * 2 + pOffset];
	                    var vals = computeError(dc, i);
	                    var lv = vals[0];
	                    var hv = vals[1];
	
	                    if(isNumeric(lv) && isNumeric(hv)) {
	                        var shoe = dc - lv;
	                        var hat = dc + hv;
	
	                        errors[j + eOffset[0]] = dl - ax.c2l(shoe);
	                        errors[j + eOffset[1]] = ax.c2l(hat) - dl;
	                        errors[j + eOffset[2]] = 0;
	                        errors[j + eOffset[3]] = 0;
	
	                        minShoe = Math.min(minShoe, dc - lv);
	                        maxHat = Math.max(maxHat, dc + hv);
	                    }
	                }
	            }
	
	            out[axLetter] = {
	                positions: positions,
	                errors: errors,
	                _bnds: [minShoe, maxHat]
	            };
	        }
	    }
	
	    convertOneAxis(x, xa);
	    convertOneAxis(y, ya);
	    return out;
	}
	
	function convertTextPosition(gd, trace, textOpts, markerOpts) {
	    var count = trace._length;
	    var out = {};
	    var i;
	
	    // corresponds to textPointPosition from component.drawing
	    if(subTypes.hasMarkers(trace)) {
	        var fontOpts = textOpts.font;
	        var align = textOpts.align;
	        var baseline = textOpts.baseline;
	        out.offset = new Array(count);
	
	        for(i = 0; i < count; i++) {
	            var ms = markerOpts.sizes ? markerOpts.sizes[i] : markerOpts.size;
	            var fs = Array.isArray(fontOpts) ? fontOpts[i].size : fontOpts.size;
	
	            var a = Array.isArray(align) ?
	                (align.length > 1 ? align[i] : align[0]) :
	                align;
	            var b = Array.isArray(baseline) ?
	                (baseline.length > 1 ? baseline[i] : baseline[0]) :
	                baseline;
	
	            var hSign = TEXTOFFSETSIGN[a];
	            var vSign = TEXTOFFSETSIGN[b];
	            var xPad = ms ? ms / 0.8 + 1 : 0;
	            var yPad = -vSign * xPad - vSign * 0.5;
	            out.offset[i] = [hSign * xPad / fs, yPad / fs];
	        }
	    }
	
	    return out;
	}
	
	module.exports = {
	    style: convertStyle,
	
	    markerStyle: convertMarkerStyle,
	    markerSelection: convertMarkerSelection,
	
	    linePositions: convertLinePositions,
	    errorBarPositions: convertErrorBarPositions,
	    textPosition: convertTextPosition
	};
	
	},{"../../components/drawing":612,"../../components/fx/helpers":626,"../../constants/interactions":691,"../../lib":716,"../../lib/gl_format_color":713,"../../plots/cartesian/axis_ids":767,"../../registry":845,"../scatter/make_bubble_size_func":1135,"../scatter/subtypes":1142,"./constants":1171,"color-normalize":121,"fast-isnumeric":227,"svg-path-sdf":533}],1173:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Registry = _dereq_('../../registry');
	
	var attributes = _dereq_('./attributes');
	var constants = _dereq_('../scatter/constants');
	var subTypes = _dereq_('../scatter/subtypes');
	var handleXYDefaults = _dereq_('../scatter/xy_defaults');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var isOpen = traceIn.marker ? /-open/.test(traceIn.marker.symbol) : false;
	    var isBubble = subTypes.isBubble(traceIn);
	
	    var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	    var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	    coerce('mode', defaultMode);
	
	    if(subTypes.hasLines(traceOut)) {
	        coerce('connectgaps');
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        coerce('line.shape');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    var lineColor = (traceOut.line || {}).color;
	    var markerColor = (traceOut.marker || {}).color;
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	    }
	
	    var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y'});
	    errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'y'});
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../../registry":845,"../scatter/constants":1122,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"../scatter/xy_defaults":1144,"./attributes":1169}],1174:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	
	var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
	
	function styleTextSelection(cd) {
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var stash = cd0.t;
	    var scene = stash._scene;
	    var index = stash.index;
	    var els = scene.selectBatch[index];
	    var unels = scene.unselectBatch[index];
	    var baseOpts = scene.textOptions[index];
	    var selOpts = scene.textSelectedOptions[index] || {};
	    var unselOpts = scene.textUnselectedOptions[index] || {};
	    var opts = Lib.extendFlat({}, baseOpts);
	    var i, j;
	
	    if(els.length || unels.length) {
	        var stc = selOpts.color;
	        var utc = unselOpts.color;
	        var base = baseOpts.color;
	        var hasArrayBase = Array.isArray(base);
	        opts.color = new Array(trace._length);
	
	        for(i = 0; i < els.length; i++) {
	            j = els[i];
	            opts.color[j] = stc || (hasArrayBase ? base[j] : base);
	        }
	        for(i = 0; i < unels.length; i++) {
	            j = unels[i];
	            var basej = hasArrayBase ? base[j] : base;
	            opts.color[j] = utc ? utc :
	                stc ? basej : Color.addOpacity(basej, DESELECTDIM);
	        }
	    }
	
	    scene.glText[index].update(opts);
	}
	
	module.exports = {
	    styleTextSelection: styleTextSelection
	};
	
	},{"../../components/color":591,"../../constants/interactions":691,"../../lib":716}],1175:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterFormatLabels = _dereq_('../scatter/format_labels');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var i = cdi.i;
	    if(!('x' in cdi)) cdi.x = trace._x[i];
	    if(!('y' in cdi)) cdi.y = trace._y[i];
	    return scatterFormatLabels(cdi, trace, fullLayout);
	};
	
	},{"../scatter/format_labels":1127}],1176:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	var getTraceColor = _dereq_('../scatter/get_trace_color');
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var stash = cd[0].t;
	    var trace = cd[0].trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var x = stash.x;
	    var y = stash.y;
	    var xpx = xa.c2p(xval);
	    var ypx = ya.c2p(yval);
	    var maxDistance = pointData.distance;
	    var ids;
	
	    // FIXME: make sure this is a proper way to calc search radius
	    if(stash.tree) {
	        var xl = xa.p2c(xpx - maxDistance);
	        var xr = xa.p2c(xpx + maxDistance);
	        var yl = ya.p2c(ypx - maxDistance);
	        var yr = ya.p2c(ypx + maxDistance);
	
	        if(hovermode === 'x') {
	            ids = stash.tree.range(
	                Math.min(xl, xr), Math.min(ya._rl[0], ya._rl[1]),
	                Math.max(xl, xr), Math.max(ya._rl[0], ya._rl[1])
	            );
	        } else {
	            ids = stash.tree.range(
	                Math.min(xl, xr), Math.min(yl, yr),
	                Math.max(xl, xr), Math.max(yl, yr)
	            );
	        }
	    } else {
	        ids = stash.ids;
	    }
	
	    // pick the id closest to the point
	    // note that point possibly may not be found
	    var id, ptx, pty, i, dx, dy, dist, dxy;
	
	    var minDist = maxDistance;
	    if(hovermode === 'x') {
	        for(i = 0; i < ids.length; i++) {
	            ptx = x[ids[i]];
	            dx = Math.abs(xa.c2p(ptx) - xpx);
	            if(dx < minDist) {
	                minDist = dx;
	                dy = ya.c2p(y[ids[i]]) - ypx;
	                dxy = Math.sqrt(dx * dx + dy * dy);
	                id = ids[i];
	            }
	        }
	    } else {
	        for(i = ids.length - 1; i > -1; i--) {
	            ptx = x[ids[i]];
	            pty = y[ids[i]];
	            dx = xa.c2p(ptx) - xpx;
	            dy = ya.c2p(pty) - ypx;
	
	            dist = Math.sqrt(dx * dx + dy * dy);
	            if(dist < minDist) {
	                minDist = dxy = dist;
	                id = ids[i];
	            }
	        }
	    }
	
	    pointData.index = id;
	    pointData.distance = minDist;
	    pointData.dxy = dxy;
	
	    if(id === undefined) return [pointData];
	
	    return [calcHover(pointData, x, y, trace)];
	}
	
	function calcHover(pointData, x, y, trace) {
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var minDist = pointData.distance;
	    var dxy = pointData.dxy;
	    var id = pointData.index;
	
	    // the closest data point
	    var di = {
	        pointNumber: id,
	        x: x[id],
	        y: y[id]
	    };
	
	    // that is single-item arrays_to_calcdata excerpt, since we are doing it for a single point and we don't have to do it beforehead for 1e6 points
	    di.tx = Array.isArray(trace.text) ? trace.text[id] : trace.text;
	    di.htx = Array.isArray(trace.hovertext) ? trace.hovertext[id] : trace.hovertext;
	    di.data = Array.isArray(trace.customdata) ? trace.customdata[id] : trace.customdata;
	    di.tp = Array.isArray(trace.textposition) ? trace.textposition[id] : trace.textposition;
	
	    var font = trace.textfont;
	    if(font) {
	        di.ts = Array.isArray(font.size) ? font.size[id] : font.size;
	        di.tc = Array.isArray(font.color) ? font.color[id] : font.color;
	        di.tf = Array.isArray(font.family) ? font.family[id] : font.family;
	    }
	
	    var marker = trace.marker;
	    if(marker) {
	        di.ms = Lib.isArrayOrTypedArray(marker.size) ? marker.size[id] : marker.size;
	        di.mo = Lib.isArrayOrTypedArray(marker.opacity) ? marker.opacity[id] : marker.opacity;
	        di.mx = Array.isArray(marker.symbol) ? marker.symbol[id] : marker.symbol;
	        di.mc = Lib.isArrayOrTypedArray(marker.color) ? marker.color[id] : marker.color;
	    }
	
	    var line = marker && marker.line;
	    if(line) {
	        di.mlc = Array.isArray(line.color) ? line.color[id] : line.color;
	        di.mlw = Lib.isArrayOrTypedArray(line.width) ? line.width[id] : line.width;
	    }
	
	    var grad = marker && marker.gradient;
	    if(grad && grad.type !== 'none') {
	        di.mgt = Array.isArray(grad.type) ? grad.type[id] : grad.type;
	        di.mgc = Array.isArray(grad.color) ? grad.color[id] : grad.color;
	    }
	
	    var xp = xa.c2p(di.x, true);
	    var yp = ya.c2p(di.y, true);
	    var rad = di.mrc || 1;
	
	    var hoverlabel = trace.hoverlabel;
	
	    if(hoverlabel) {
	        di.hbg = Array.isArray(hoverlabel.bgcolor) ? hoverlabel.bgcolor[id] : hoverlabel.bgcolor;
	        di.hbc = Array.isArray(hoverlabel.bordercolor) ? hoverlabel.bordercolor[id] : hoverlabel.bordercolor;
	        di.hts = Array.isArray(hoverlabel.font.size) ? hoverlabel.font.size[id] : hoverlabel.font.size;
	        di.htc = Array.isArray(hoverlabel.font.color) ? hoverlabel.font.color[id] : hoverlabel.font.color;
	        di.htf = Array.isArray(hoverlabel.font.family) ? hoverlabel.font.family[id] : hoverlabel.font.family;
	        di.hnl = Array.isArray(hoverlabel.namelength) ? hoverlabel.namelength[id] : hoverlabel.namelength;
	    }
	    var hoverinfo = trace.hoverinfo;
	    if(hoverinfo) {
	        di.hi = Array.isArray(hoverinfo) ? hoverinfo[id] : hoverinfo;
	    }
	
	    var hovertemplate = trace.hovertemplate;
	    if(hovertemplate) {
	        di.ht = Array.isArray(hovertemplate) ? hovertemplate[id] : hovertemplate;
	    }
	
	    var fakeCd = {};
	    fakeCd[pointData.index] = di;
	
	    var pointData2 = Lib.extendFlat({}, pointData, {
	        color: getTraceColor(trace, di),
	
	        x0: xp - rad,
	        x1: xp + rad,
	        xLabelVal: di.x,
	
	        y0: yp - rad,
	        y1: yp + rad,
	        yLabelVal: di.y,
	
	        cd: fakeCd,
	        distance: minDist,
	        spikeDistance: dxy,
	
	        hovertemplate: di.ht
	    });
	
	    if(di.htx) pointData2.text = di.htx;
	    else if(di.tx) pointData2.text = di.tx;
	    else if(trace.text) pointData2.text = trace.text;
	
	    Lib.fillText(di, trace, pointData2);
	    Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData2);
	
	    return pointData2;
	}
	
	module.exports = {
	    hoverPoints: hoverPoints,
	    calcHover: calcHover
	};
	
	},{"../../lib":716,"../../registry":845,"../scatter/get_trace_color":1128}],1177:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hover = _dereq_('./hover');
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'scattergl',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['gl', 'regl', 'cartesian', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('../scatter/cross_trace_defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: hover.hoverPoints,
	    selectPoints: _dereq_('./select'),
	
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../scatter/cross_trace_defaults":1124,"../scatter/marker_colorbar":1136,"./attributes":1169,"./calc":1170,"./defaults":1173,"./format_labels":1175,"./hover":1176,"./plot":1178,"./select":1180}],1178:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createScatter = _dereq_('regl-scatter2d');
	var createLine = _dereq_('regl-line2d');
	var createError = _dereq_('regl-error2d');
	var Text = _dereq_('gl-text');
	
	var Lib = _dereq_('../../lib');
	var prepareRegl = _dereq_('../../lib/prepare_regl');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var linkTraces = _dereq_('../scatter/link_traces');
	
	var styleTextSelection = _dereq_('./edit_style').styleTextSelection;
	
	function getViewport(fullLayout, xaxis, yaxis) {
	    var gs = fullLayout._size;
	    var width = fullLayout.width;
	    var height = fullLayout.height;
	    return [
	        gs.l + xaxis.domain[0] * gs.w,
	        gs.b + yaxis.domain[0] * gs.h,
	        (width - gs.r) - (1 - xaxis.domain[1]) * gs.w,
	        (height - gs.t) - (1 - yaxis.domain[1]) * gs.h
	    ];
	}
	
	module.exports = function plot(gd, subplot, cdata) {
	    if(!cdata.length) return;
	
	    var fullLayout = gd._fullLayout;
	    var scene = subplot._scene;
	    var xaxis = subplot.xaxis;
	    var yaxis = subplot.yaxis;
	    var i, j;
	
	    // we may have more subplots than initialized data due to Axes.getSubplots method
	    if(!scene) return;
	
	    var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint']);
	    if(!success) {
	        scene.init();
	        return;
	    }
	
	    var count = scene.count;
	    var regl = fullLayout._glcanvas.data()[0].regl;
	
	    // that is needed for fills
	    linkTraces(gd, subplot, cdata);
	
	    if(scene.dirty) {
	        // make sure scenes are created
	        if(scene.error2d === true) {
	            scene.error2d = createError(regl);
	        }
	        if(scene.line2d === true) {
	            scene.line2d = createLine(regl);
	        }
	        if(scene.scatter2d === true) {
	            scene.scatter2d = createScatter(regl);
	        }
	        if(scene.fill2d === true) {
	            scene.fill2d = createLine(regl);
	        }
	        if(scene.glText === true) {
	            scene.glText = new Array(count);
	            for(i = 0; i < count; i++) {
	                scene.glText[i] = new Text(regl);
	            }
	        }
	
	        // update main marker options
	        if(scene.glText) {
	            if(count > scene.glText.length) {
	                // add gl text marker
	                var textsToAdd = count - scene.glText.length;
	                for(i = 0; i < textsToAdd; i++) {
	                    scene.glText.push(new Text(regl));
	                }
	            } else if(count < scene.glText.length) {
	                // remove gl text marker
	                var textsToRemove = scene.glText.length - count;
	                var removedTexts = scene.glText.splice(count, textsToRemove);
	                removedTexts.forEach(function(text) { text.destroy(); });
	            }
	
	            for(i = 0; i < count; i++) {
	                scene.glText[i].update(scene.textOptions[i]);
	            }
	        }
	        if(scene.line2d) {
	            scene.line2d.update(scene.lineOptions);
	            scene.lineOptions = scene.lineOptions.map(function(lineOptions) {
	                if(lineOptions && lineOptions.positions) {
	                    var srcPos = lineOptions.positions;
	
	                    var firstptdef = 0;
	                    while(firstptdef < srcPos.length && (isNaN(srcPos[firstptdef]) || isNaN(srcPos[firstptdef + 1]))) {
	                        firstptdef += 2;
	                    }
	                    var lastptdef = srcPos.length - 2;
	                    while(lastptdef > firstptdef && (isNaN(srcPos[lastptdef]) || isNaN(srcPos[lastptdef + 1]))) {
	                        lastptdef -= 2;
	                    }
	                    lineOptions.positions = srcPos.slice(firstptdef, lastptdef + 2);
	                }
	                return lineOptions;
	            });
	            scene.line2d.update(scene.lineOptions);
	        }
	        if(scene.error2d) {
	            var errorBatch = (scene.errorXOptions || []).concat(scene.errorYOptions || []);
	            scene.error2d.update(errorBatch);
	        }
	        if(scene.scatter2d) {
	            scene.scatter2d.update(scene.markerOptions);
	        }
	
	        // fill requires linked traces, so we generate it's positions here
	        scene.fillOrder = Lib.repeat(null, count);
	        if(scene.fill2d) {
	            scene.fillOptions = scene.fillOptions.map(function(fillOptions, i) {
	                var cdscatter = cdata[i];
	                if(!fillOptions || !cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
	                var cd = cdscatter[0];
	                var trace = cd.trace;
	                var stash = cd.t;
	                var lineOptions = scene.lineOptions[i];
	                var last, j;
	
	                var fillData = [];
	                if(trace._ownfill) fillData.push(i);
	                if(trace._nexttrace) fillData.push(i + 1);
	                if(fillData.length) scene.fillOrder[i] = fillData;
	
	                var pos = [];
	                var srcPos = (lineOptions && lineOptions.positions) || stash.positions;
	                var firstptdef, lastptdef;
	
	                if(trace.fill === 'tozeroy') {
	                    firstptdef = 0;
	                    while(firstptdef < srcPos.length && isNaN(srcPos[firstptdef + 1])) {
	                        firstptdef += 2;
	                    }
	                    lastptdef = srcPos.length - 2;
	                    while(lastptdef > firstptdef && isNaN(srcPos[lastptdef + 1])) {
	                        lastptdef -= 2;
	                    }
	                    if(srcPos[firstptdef + 1] !== 0) {
	                        pos = [srcPos[firstptdef], 0];
	                    }
	                    pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
	                    if(srcPos[lastptdef + 1] !== 0) {
	                        pos = pos.concat([srcPos[lastptdef], 0]);
	                    }
	                } else if(trace.fill === 'tozerox') {
	                    firstptdef = 0;
	                    while(firstptdef < srcPos.length && isNaN(srcPos[firstptdef])) {
	                        firstptdef += 2;
	                    }
	                    lastptdef = srcPos.length - 2;
	                    while(lastptdef > firstptdef && isNaN(srcPos[lastptdef])) {
	                        lastptdef -= 2;
	                    }
	                    if(srcPos[firstptdef] !== 0) {
	                        pos = [0, srcPos[firstptdef + 1]];
	                    }
	                    pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
	                    if(srcPos[lastptdef] !== 0) {
	                        pos = pos.concat([ 0, srcPos[lastptdef + 1]]);
	                    }
	                } else if(trace.fill === 'toself' || trace.fill === 'tonext') {
	                    pos = [];
	                    last = 0;
	                    for(j = 0; j < srcPos.length; j += 2) {
	                        if(isNaN(srcPos[j]) || isNaN(srcPos[j + 1])) {
	                            pos = pos.concat(srcPos.slice(last, j));
	                            pos.push(srcPos[last], srcPos[last + 1]);
	                            last = j + 2;
	                        }
	                    }
	                    pos = pos.concat(srcPos.slice(last));
	                    if(last) {
	                        pos.push(srcPos[last], srcPos[last + 1]);
	                    }
	                } else {
	                    var nextTrace = trace._nexttrace;
	
	                    if(nextTrace) {
	                        var nextOptions = scene.lineOptions[i + 1];
	
	                        if(nextOptions) {
	                            var nextPos = nextOptions.positions;
	                            if(trace.fill === 'tonexty') {
	                                pos = srcPos.slice();
	
	                                for(i = Math.floor(nextPos.length / 2); i--;) {
	                                    var xx = nextPos[i * 2];
	                                    var yy = nextPos[i * 2 + 1];
	                                    if(isNaN(xx) || isNaN(yy)) continue;
	                                    pos.push(xx, yy);
	                                }
	                                fillOptions.fill = nextTrace.fillcolor;
	                            }
	                        }
	                    }
	                }
	
	                // detect prev trace positions to exclude from current fill
	                if(trace._prevtrace && trace._prevtrace.fill === 'tonext') {
	                    var prevLinePos = scene.lineOptions[i - 1].positions;
	
	                    // FIXME: likely this logic should be tested better
	                    var offset = pos.length / 2;
	                    last = offset;
	                    var hole = [last];
	                    for(j = 0; j < prevLinePos.length; j += 2) {
	                        if(isNaN(prevLinePos[j]) || isNaN(prevLinePos[j + 1])) {
	                            hole.push(j / 2 + offset + 1);
	                            last = j + 2;
	                        }
	                    }
	
	                    pos = pos.concat(prevLinePos);
	                    fillOptions.hole = hole;
	                }
	                fillOptions.fillmode = trace.fill;
	                fillOptions.opacity = trace.opacity;
	                fillOptions.positions = pos;
	
	                return fillOptions;
	            });
	
	            scene.fill2d.update(scene.fillOptions);
	        }
	    }
	
	    // form batch arrays, and check for selected points
	    var dragmode = fullLayout.dragmode;
	    var selectMode = dragmode === 'lasso' || dragmode === 'select';
	    var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
	
	    for(i = 0; i < count; i++) {
	        var cd0 = cdata[i][0];
	        var trace = cd0.trace;
	        var stash = cd0.t;
	        var index = stash.index;
	        var len = trace._length;
	        var x = stash.x;
	        var y = stash.y;
	
	        if(trace.selectedpoints || selectMode || clickSelectEnabled) {
	            if(!selectMode) selectMode = true;
	
	            // regenerate scene batch, if traces number changed during selection
	            if(trace.selectedpoints) {
	                var selPts = scene.selectBatch[index] = Lib.selIndices2selPoints(trace);
	
	                var selDict = {};
	                for(j = 0; j < selPts.length; j++) {
	                    selDict[selPts[j]] = 1;
	                }
	                var unselPts = [];
	                for(j = 0; j < len; j++) {
	                    if(!selDict[j]) unselPts.push(j);
	                }
	                scene.unselectBatch[index] = unselPts;
	            }
	
	            // precalculate px coords since we are not going to pan during select
	            // TODO, could do better here e.g.
	            // - spin that in a webworker
	            // - compute selection from polygons in data coordinates
	            //   (maybe just for linear axes)
	            var xpx = stash.xpx = new Array(len);
	            var ypx = stash.ypx = new Array(len);
	            for(j = 0; j < len; j++) {
	                xpx[j] = xaxis.c2p(x[j]);
	                ypx[j] = yaxis.c2p(y[j]);
	            }
	        } else {
	            stash.xpx = stash.ypx = null;
	        }
	    }
	
	    if(selectMode) {
	        // create scatter instance by cloning scatter2d
	        if(!scene.select2d) {
	            scene.select2d = createScatter(fullLayout._glcanvas.data()[1].regl);
	        }
	
	        // use unselected styles on 'context' canvas
	        if(scene.scatter2d) {
	            var unselOpts = new Array(count);
	            for(i = 0; i < count; i++) {
	                unselOpts[i] = scene.selectBatch[i].length || scene.unselectBatch[i].length ?
	                    scene.markerUnselectedOptions[i] :
	                    {};
	            }
	            scene.scatter2d.update(unselOpts);
	        }
	
	        // use selected style on 'focus' canvas
	        if(scene.select2d) {
	            scene.select2d.update(scene.markerOptions);
	            scene.select2d.update(scene.markerSelectedOptions);
	        }
	
	        if(scene.glText) {
	            cdata.forEach(function(cdscatter) {
	                var trace = ((cdscatter || [])[0] || {}).trace || {};
	                if(subTypes.hasText(trace)) {
	                    styleTextSelection(cdscatter);
	                }
	            });
	        }
	    } else {
	        // reset 'context' scatter2d opts to base opts,
	        // thus unsetting markerUnselectedOptions from selection
	        if(scene.scatter2d) {
	            scene.scatter2d.update(scene.markerOptions);
	        }
	    }
	
	    // provide viewport and range
	    var vpRange0 = {
	        viewport: getViewport(fullLayout, xaxis, yaxis),
	        // TODO do we need those fallbacks?
	        range: [
	            (xaxis._rl || xaxis.range)[0],
	            (yaxis._rl || yaxis.range)[0],
	            (xaxis._rl || xaxis.range)[1],
	            (yaxis._rl || yaxis.range)[1]
	        ]
	    };
	    var vpRange = Lib.repeat(vpRange0, scene.count);
	
	    // upload viewport/range data to GPU
	    if(scene.fill2d) {
	        scene.fill2d.update(vpRange);
	    }
	    if(scene.line2d) {
	        scene.line2d.update(vpRange);
	    }
	    if(scene.error2d) {
	        scene.error2d.update(vpRange.concat(vpRange));
	    }
	    if(scene.scatter2d) {
	        scene.scatter2d.update(vpRange);
	    }
	    if(scene.select2d) {
	        scene.select2d.update(vpRange);
	    }
	    if(scene.glText) {
	        scene.glText.forEach(function(text) { text.update(vpRange0); });
	    }
	};
	
	},{"../../lib":716,"../../lib/prepare_regl":729,"../scatter/link_traces":1134,"../scatter/subtypes":1142,"./edit_style":1174,"gl-text":318,"regl-error2d":491,"regl-line2d":492,"regl-scatter2d":498}],1179:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// make sure scene exists on subplot, return it
	module.exports = function sceneUpdate(gd, subplot) {
	    var scene = subplot._scene;
	
	    var resetOpts = {
	        // number of traces in subplot, since scene:subplot -> 1:1
	        count: 0,
	        // whether scene requires init hook in plot call (dirty plot call)
	        dirty: true,
	        // last used options
	        lineOptions: [],
	        fillOptions: [],
	        markerOptions: [],
	        markerSelectedOptions: [],
	        markerUnselectedOptions: [],
	        errorXOptions: [],
	        errorYOptions: [],
	        textOptions: [],
	        textSelectedOptions: [],
	        textUnselectedOptions: [],
	        // selection batches
	        selectBatch: [],
	        unselectBatch: []
	    };
	
	    // regl- component stubs, initialized in dirty plot call
	    var initOpts = {
	        fill2d: false,
	        scatter2d: false,
	        error2d: false,
	        line2d: false,
	        glText: false,
	        select2d: false
	    };
	
	    if(!subplot._scene) {
	        scene = subplot._scene = {};
	
	        scene.init = function init() {
	            Lib.extendFlat(scene, initOpts, resetOpts);
	        };
	
	        scene.init();
	
	        // apply new option to all regl components (used on drag)
	        scene.update = function update(opt) {
	            var opts = Lib.repeat(opt, scene.count);
	
	            if(scene.fill2d) scene.fill2d.update(opts);
	            if(scene.scatter2d) scene.scatter2d.update(opts);
	            if(scene.line2d) scene.line2d.update(opts);
	            if(scene.error2d) scene.error2d.update(opts.concat(opts));
	            if(scene.select2d) scene.select2d.update(opts);
	            if(scene.glText) {
	                for(var i = 0; i < scene.count; i++) {
	                    scene.glText[i].update(opt);
	                }
	            }
	        };
	
	        // draw traces in proper order
	        scene.draw = function draw() {
	            var count = scene.count;
	            var fill2d = scene.fill2d;
	            var error2d = scene.error2d;
	            var line2d = scene.line2d;
	            var scatter2d = scene.scatter2d;
	            var glText = scene.glText;
	            var select2d = scene.select2d;
	            var selectBatch = scene.selectBatch;
	            var unselectBatch = scene.unselectBatch;
	
	            for(var i = 0; i < count; i++) {
	                if(fill2d && scene.fillOrder[i]) {
	                    fill2d.draw(scene.fillOrder[i]);
	                }
	                if(line2d && scene.lineOptions[i]) {
	                    line2d.draw(i);
	                }
	                if(error2d) {
	                    if(scene.errorXOptions[i]) error2d.draw(i);
	                    if(scene.errorYOptions[i]) error2d.draw(i + count);
	                }
	                if(scatter2d && scene.markerOptions[i]) {
	                    if(unselectBatch[i].length) {
	                        var arg = Lib.repeat([], scene.count);
	                        arg[i] = unselectBatch[i];
	                        scatter2d.draw(arg);
	                    } else if(!selectBatch[i].length) {
	                        scatter2d.draw(i);
	                    }
	                }
	                if(glText[i] && scene.textOptions[i]) {
	                    glText[i].render();
	                }
	            }
	
	            if(select2d) {
	                select2d.draw(selectBatch);
	            }
	
	            scene.dirty = false;
	        };
	
	        // remove scene resources
	        scene.destroy = function destroy() {
	            if(scene.fill2d && scene.fill2d.destroy) scene.fill2d.destroy();
	            if(scene.scatter2d && scene.scatter2d.destroy) scene.scatter2d.destroy();
	            if(scene.error2d && scene.error2d.destroy) scene.error2d.destroy();
	            if(scene.line2d && scene.line2d.destroy) scene.line2d.destroy();
	            if(scene.select2d && scene.select2d.destroy) scene.select2d.destroy();
	            if(scene.glText) {
	                scene.glText.forEach(function(text) {
	                    if(text.destroy) text.destroy();
	                });
	            }
	
	            scene.lineOptions = null;
	            scene.fillOptions = null;
	            scene.markerOptions = null;
	            scene.markerSelectedOptions = null;
	            scene.markerUnselectedOptions = null;
	            scene.errorXOptions = null;
	            scene.errorYOptions = null;
	            scene.textOptions = null;
	            scene.textSelectedOptions = null;
	            scene.textUnselectedOptions = null;
	
	            scene.selectBatch = null;
	            scene.unselectBatch = null;
	
	            // we can't just delete _scene, because `destroy` is called in the
	            // middle of supplyDefaults, before relinkPrivateKeys which will put it back.
	            subplot._scene = null;
	        };
	    }
	
	    // in case if we have scene from the last calc - reset data
	    if(!scene.dirty) {
	        Lib.extendFlat(scene, resetOpts);
	    }
	
	    return scene;
	};
	
	},{"../../lib":716}],1180:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var subTypes = _dereq_('../scatter/subtypes');
	var styleTextSelection = _dereq_('./edit_style').styleTextSelection;
	
	module.exports = function select(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var selection = [];
	    var trace = cd[0].trace;
	    var stash = cd[0].t;
	    var len = trace._length;
	    var x = stash.x;
	    var y = stash.y;
	    var scene = stash._scene;
	    var index = stash.index;
	
	    if(!scene) return selection;
	
	    var hasText = subTypes.hasText(trace);
	    var hasMarkers = subTypes.hasMarkers(trace);
	    var hasOnlyLines = !hasMarkers && !hasText;
	
	    if(trace.visible !== true || hasOnlyLines) return selection;
	
	    var els = [];
	    var unels = [];
	
	    // degenerate polygon does not enable selection
	    // filter out points by visible scatter ones
	    if(selectionTester !== false && !selectionTester.degenerate) {
	        for(var i = 0; i < len; i++) {
	            if(selectionTester.contains([stash.xpx[i], stash.ypx[i]], false, i, searchInfo)) {
	                els.push(i);
	                selection.push({
	                    pointNumber: i,
	                    x: x[i],
	                    y: y[i]
	                });
	            } else {
	                unels.push(i);
	            }
	        }
	    }
	
	    if(hasMarkers) {
	        var scatter2d = scene.scatter2d;
	
	        if(!els.length && !unels.length) {
	            // reset to base styles when clearing
	            var baseOpts = new Array(scene.count);
	            baseOpts[index] = scene.markerOptions[index];
	            scatter2d.update.apply(scatter2d, baseOpts);
	        } else if(!scene.selectBatch[index].length && !scene.unselectBatch[index].length) {
	            // set unselected styles on 'context' canvas (if not done already)
	            var unselOpts = new Array(scene.count);
	            unselOpts[index] = scene.markerUnselectedOptions[index];
	            scatter2d.update.apply(scatter2d, unselOpts);
	        }
	    }
	
	    scene.selectBatch[index] = els;
	    scene.unselectBatch[index] = unels;
	
	    if(hasText) {
	        styleTextSelection(cd);
	    }
	
	    return selection;
	};
	
	},{"../scatter/subtypes":1142,"./edit_style":1174}],1181:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var scatterGeoAttrs = _dereq_('../scattergeo/attributes');
	var scatterAttrs = _dereq_('../scatter/attributes');
	var mapboxAttrs = _dereq_('../../plots/mapbox/layout_attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var lineAttrs = scatterGeoAttrs.line;
	var markerAttrs = scatterGeoAttrs.marker;
	
	module.exports = overrideAll({
	    lon: scatterGeoAttrs.lon,
	    lat: scatterGeoAttrs.lat,
	
	    // locations
	    // locationmode
	
	    mode: extendFlat({}, scatterAttrs.mode, {
	        dflt: 'markers',
	        
	    }),
	
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['lat', 'lon', 'text']
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	
	    line: {
	        color: lineAttrs.color,
	        width: lineAttrs.width
	
	        // TODO
	        // dash: dash
	    },
	
	    connectgaps: scatterAttrs.connectgaps,
	
	    marker: extendFlat({
	        symbol: {
	            valType: 'string',
	            dflt: 'circle',
	            
	            arrayOk: true,
	            
	        },
	        opacity: markerAttrs.opacity,
	        size: markerAttrs.size,
	        sizeref: markerAttrs.sizeref,
	        sizemin: markerAttrs.sizemin,
	        sizemode: markerAttrs.sizemode
	    },
	        colorScaleAttrs('marker')
	        // line
	    ),
	
	    fill: scatterGeoAttrs.fill,
	    fillcolor: scatterAttrs.fillcolor,
	
	    textfont: mapboxAttrs.layers.symbol.textfont,
	    textposition: mapboxAttrs.layers.symbol.textposition,
	
	    below: {
	        valType: 'string',
	        
	        
	    },
	
	    selected: {
	        marker: scatterAttrs.selected.marker
	    },
	    unselected: {
	        marker: scatterAttrs.unselected.marker
	    },
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['lon', 'lat', 'text', 'name']
	    }),
	    hovertemplate: hovertemplateAttrs(),
	}, 'calc', 'nested');
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../../plots/mapbox/layout_attributes":821,"../../plots/template_attributes":840,"../scatter/attributes":1118,"../scattergeo/attributes":1159}],1182:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	var geoJsonUtils = _dereq_('../../lib/geojson_utils');
	
	var Colorscale = _dereq_('../../components/colorscale');
	var Drawing = _dereq_('../../components/drawing');
	var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
	var subTypes = _dereq_('../scatter/subtypes');
	var convertTextOpts = _dereq_('../../plots/mapbox/convert_text_opts');
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	
	var NEWLINES = _dereq_('../../lib/svg_text_utils').NEWLINES;
	var BR_TAG_ALL = _dereq_('../../lib/svg_text_utils').BR_TAG_ALL;
	
	module.exports = function convert(gd, calcTrace) {
	    var trace = calcTrace[0].trace;
	
	    var isVisible = (trace.visible === true && trace._length !== 0);
	    var hasFill = (trace.fill !== 'none');
	    var hasLines = subTypes.hasLines(trace);
	    var hasMarkers = subTypes.hasMarkers(trace);
	    var hasText = subTypes.hasText(trace);
	    var hasCircles = (hasMarkers && trace.marker.symbol === 'circle');
	    var hasSymbols = (hasMarkers && trace.marker.symbol !== 'circle');
	
	    var fill = initContainer();
	    var line = initContainer();
	    var circle = initContainer();
	    var symbol = initContainer();
	
	    var opts = {
	        fill: fill,
	        line: line,
	        circle: circle,
	        symbol: symbol
	    };
	
	    // early return if not visible or placeholder
	    if(!isVisible) return opts;
	
	    // fill layer and line layer use the same coords
	    var lineCoords;
	    if(hasFill || hasLines) {
	        lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
	    }
	
	    if(hasFill) {
	        fill.geojson = geoJsonUtils.makePolygon(lineCoords);
	        fill.layout.visibility = 'visible';
	
	        Lib.extendFlat(fill.paint, {
	            'fill-color': trace.fillcolor
	        });
	    }
	
	    if(hasLines) {
	        line.geojson = geoJsonUtils.makeLine(lineCoords);
	        line.layout.visibility = 'visible';
	
	        Lib.extendFlat(line.paint, {
	            'line-width': trace.line.width,
	            'line-color': trace.line.color,
	            'line-opacity': trace.opacity
	        });
	
	        // TODO convert line.dash into line-dasharray
	    }
	
	    if(hasCircles) {
	        var circleOpts = makeCircleOpts(calcTrace);
	        circle.geojson = circleOpts.geojson;
	        circle.layout.visibility = 'visible';
	
	        Lib.extendFlat(circle.paint, {
	            'circle-color': circleOpts.mcc,
	            'circle-radius': circleOpts.mrc,
	            'circle-opacity': circleOpts.mo
	        });
	    }
	
	    if(hasSymbols || hasText) {
	        symbol.geojson = makeSymbolGeoJSON(calcTrace, gd);
	
	        Lib.extendFlat(symbol.layout, {
	            visibility: 'visible',
	            'icon-image': '{symbol}-15',
	            'text-field': '{text}'
	        });
	
	        if(hasSymbols) {
	            Lib.extendFlat(symbol.layout, {
	                'icon-size': trace.marker.size / 10
	            });
	
	            Lib.extendFlat(symbol.paint, {
	                'icon-opacity': trace.opacity * trace.marker.opacity,
	
	                // TODO does not work ??
	                'icon-color': trace.marker.color
	            });
	        }
	
	        if(hasText) {
	            var iconSize = (trace.marker || {}).size;
	            var textOpts = convertTextOpts(trace.textposition, iconSize);
	
	            // all data-driven below !!
	
	            Lib.extendFlat(symbol.layout, {
	                'text-size': trace.textfont.size,
	                'text-anchor': textOpts.anchor,
	                'text-offset': textOpts.offset
	
	                // TODO font family
	                // 'text-font': symbol.textfont.family.split(', '),
	            });
	
	            Lib.extendFlat(symbol.paint, {
	                'text-color': trace.textfont.color,
	                'text-opacity': trace.opacity
	            });
	        }
	    }
	
	    return opts;
	};
	
	function initContainer() {
	    return {
	        geojson: geoJsonUtils.makeBlank(),
	        layout: { visibility: 'none' },
	        paint: {}
	    };
	}
	
	function makeCircleOpts(calcTrace) {
	    var trace = calcTrace[0].trace;
	    var marker = trace.marker;
	    var selectedpoints = trace.selectedpoints;
	    var arrayColor = Lib.isArrayOrTypedArray(marker.color);
	    var arraySize = Lib.isArrayOrTypedArray(marker.size);
	    var arrayOpacity = Lib.isArrayOrTypedArray(marker.opacity);
	    var i;
	
	    function addTraceOpacity(o) { return trace.opacity * o; }
	
	    function size2radius(s) { return s / 2; }
	
	    var colorFn;
	    if(arrayColor) {
	        if(Colorscale.hasColorscale(trace, 'marker')) {
	            colorFn = Colorscale.makeColorScaleFuncFromTrace(marker);
	        } else {
	            colorFn = Lib.identity;
	        }
	    }
	
	    var sizeFn;
	    if(arraySize) {
	        sizeFn = makeBubbleSizeFn(trace);
	    }
	
	    var opacityFn;
	    if(arrayOpacity) {
	        opacityFn = function(mo) {
	            var mo2 = isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
	            return addTraceOpacity(mo2);
	        };
	    }
	
	    var features = [];
	    for(i = 0; i < calcTrace.length; i++) {
	        var calcPt = calcTrace[i];
	        var lonlat = calcPt.lonlat;
	
	        if(isBADNUM(lonlat)) continue;
	
	        var props = {};
	        if(colorFn) props.mcc = calcPt.mcc = colorFn(calcPt.mc);
	        if(sizeFn) props.mrc = calcPt.mrc = sizeFn(calcPt.ms);
	        if(opacityFn) props.mo = opacityFn(calcPt.mo);
	        if(selectedpoints) props.selected = calcPt.selected || 0;
	
	        features.push({
	            type: 'Feature',
	            geometry: {type: 'Point', coordinates: lonlat},
	            properties: props
	        });
	    }
	
	    var fns;
	    if(selectedpoints) {
	        fns = Drawing.makeSelectedPointStyleFns(trace);
	
	        for(i = 0; i < features.length; i++) {
	            var d = features[i].properties;
	
	            if(fns.selectedOpacityFn) {
	                d.mo = addTraceOpacity(fns.selectedOpacityFn(d));
	            }
	            if(fns.selectedColorFn) {
	                d.mcc = fns.selectedColorFn(d);
	            }
	            if(fns.selectedSizeFn) {
	                d.mrc = fns.selectedSizeFn(d);
	            }
	        }
	    }
	
	    return {
	        geojson: {type: 'FeatureCollection', features: features},
	        mcc: arrayColor || (fns && fns.selectedColorFn) ?
	            {type: 'identity', property: 'mcc'} :
	            marker.color,
	        mrc: arraySize || (fns && fns.selectedSizeFn) ?
	            {type: 'identity', property: 'mrc'} :
	            size2radius(marker.size),
	        mo: arrayOpacity || (fns && fns.selectedOpacityFn) ?
	            {type: 'identity', property: 'mo'} :
	            addTraceOpacity(marker.opacity)
	    };
	}
	
	function makeSymbolGeoJSON(calcTrace, gd) {
	    var fullLayout = gd._fullLayout;
	    var trace = calcTrace[0].trace;
	
	    var marker = trace.marker || {};
	    var symbol = marker.symbol;
	
	    var fillSymbol = (symbol !== 'circle') ?
	        getFillFunc(symbol) :
	        blankFillFunc;
	
	    var fillText = subTypes.hasText(trace) ?
	        getFillFunc(trace.text) :
	        blankFillFunc;
	
	    var features = [];
	
	    for(var i = 0; i < calcTrace.length; i++) {
	        var calcPt = calcTrace[i];
	
	        if(isBADNUM(calcPt.lonlat)) continue;
	
	        var texttemplate = trace.texttemplate;
	        var text;
	
	        if(texttemplate) {
	            var tt = Array.isArray(texttemplate) ? (texttemplate[i] || '') : texttemplate;
	            var labels = trace._module.formatLabels(calcPt, trace, fullLayout);
	            var pointValues = {};
	            appendArrayPointValue(pointValues, trace, calcPt.i);
	            var meta = trace._meta || {};
	            text = Lib.texttemplateString(tt, labels, fullLayout._d3locale, pointValues, calcPt, meta);
	        } else {
	            text = fillText(calcPt.tx);
	        }
	
	        if(text) {
	            text = text.replace(NEWLINES, '').replace(BR_TAG_ALL, '\n');
	        }
	
	        features.push({
	            type: 'Feature',
	            geometry: {
	                type: 'Point',
	                coordinates: calcPt.lonlat
	            },
	            properties: {
	                symbol: fillSymbol(calcPt.mx),
	                text: text
	            }
	        });
	    }
	
	    return {
	        type: 'FeatureCollection',
	        features: features
	    };
	}
	
	function getFillFunc(attr) {
	    if(Lib.isArrayOrTypedArray(attr)) {
	        return function(v) { return v; };
	    } else if(attr) {
	        return function() { return attr; };
	    } else {
	        return blankFillFunc;
	    }
	}
	
	function blankFillFunc() { return ''; }
	
	// only need to check lon (OR lat)
	function isBADNUM(lonlat) {
	    return lonlat[0] === BADNUM;
	}
	
	},{"../../components/colorscale":603,"../../components/drawing":612,"../../components/fx/helpers":626,"../../constants/numerical":692,"../../lib":716,"../../lib/geojson_utils":711,"../../lib/svg_text_utils":740,"../../plots/mapbox/convert_text_opts":818,"../scatter/make_bubble_size_func":1135,"../scatter/subtypes":1142,"fast-isnumeric":227}],1183:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleLonLatDefaults(traceIn, traceOut, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('texttemplate');
	    coerce('hovertext');
	    coerce('hovertemplate');
	    coerce('mode');
	    coerce('below');
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noDash: true});
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noLine: true});
	
	        // array marker.size and marker.color are only supported with circles
	        var marker = traceOut.marker;
	        if(marker.symbol !== 'circle') {
	            if(Lib.isArrayOrTypedArray(marker.size)) marker.size = marker.size[0];
	            if(Lib.isArrayOrTypedArray(marker.color)) marker.color = marker.color[0];
	        }
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        handleTextDefaults(traceIn, traceOut, layout, coerce, {noSelect: true});
	    }
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	    }
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	function handleLonLatDefaults(traceIn, traceOut, coerce) {
	    var lon = coerce('lon') || [];
	    var lat = coerce('lat') || [];
	    var len = Math.min(lon.length, lat.length);
	    traceOut._length = len;
	
	    return len;
	}
	
	},{"../../lib":716,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1181}],1184:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	
	module.exports = function eventData(out, pt) {
	    out.lon = pt.lon;
	    out.lat = pt.lat;
	
	    return out;
	};
	
	},{}],1185:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var labels = {};
	
	    var subplot = fullLayout[trace.subplot]._subplot;
	    var ax = subplot.mockAxis;
	
	    var lonlat = cdi.lonlat;
	    labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
	    labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
	
	    return labels;
	};
	
	},{"../../plots/cartesian/axes":764}],1186:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var getTraceColor = _dereq_('../scatter/get_trace_color');
	var fillText = Lib.fillText;
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function hoverPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var subplot = pointData.subplot;
	
	    // compute winding number about [-180, 180] globe
	    var winding = (xval >= 0) ?
	        Math.floor((xval + 180) / 360) :
	        Math.ceil((xval - 180) / 360);
	
	    // shift longitude to [-180, 180] to determine closest point
	    var lonShift = winding * 360;
	    var xval2 = xval - lonShift;
	
	    function distFn(d) {
	        var lonlat = d.lonlat;
	        if(lonlat[0] === BADNUM) return Infinity;
	
	        var lon = Lib.modHalf(lonlat[0], 360);
	        var lat = lonlat[1];
	        var pt = subplot.project([lon, lat]);
	        var dx = pt.x - xa.c2p([xval2, lat]);
	        var dy = pt.y - ya.c2p([lon, yval]);
	        var rad = Math.max(3, d.mrc || 0);
	
	        return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
	    }
	
	    Fx.getClosest(cd, distFn, pointData);
	
	    // skip the rest (for this trace) if we didn't find a close point
	    if(pointData.index === false) return;
	
	    var di = cd[pointData.index];
	    var lonlat = di.lonlat;
	    var lonlatShifted = [Lib.modHalf(lonlat[0], 360) + lonShift, lonlat[1]];
	
	    // shift labels back to original winded globe
	    var xc = xa.c2p(lonlatShifted);
	    var yc = ya.c2p(lonlatShifted);
	    var rad = di.mrc || 1;
	
	    pointData.x0 = xc - rad;
	    pointData.x1 = xc + rad;
	    pointData.y0 = yc - rad;
	    pointData.y1 = yc + rad;
	
	    var fullLayout = {};
	    fullLayout[trace.subplot] = {_subplot: subplot};
	    var labels = trace._module.formatLabels(di, trace, fullLayout);
	    pointData.lonLabel = labels.lonLabel;
	    pointData.latLabel = labels.latLabel;
	
	    pointData.color = getTraceColor(trace, di);
	    pointData.extraText = getExtraText(trace, di, cd[0].t.labels);
	    pointData.hovertemplate = trace.hovertemplate;
	
	    return [pointData];
	};
	
	function getExtraText(trace, di, labels) {
	    if(trace.hovertemplate) return;
	
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var parts = hoverinfo.split('+');
	    var isAll = parts.indexOf('all') !== -1;
	    var hasLon = parts.indexOf('lon') !== -1;
	    var hasLat = parts.indexOf('lat') !== -1;
	    var lonlat = di.lonlat;
	    var text = [];
	
	    // TODO should we use a mock axis to format hover?
	    // If so, we'll need to make precision be zoom-level dependent
	    function format(v) {
	        return v + '\u00B0';
	    }
	
	    if(isAll || (hasLon && hasLat)) {
	        text.push('(' + format(lonlat[0]) + ', ' + format(lonlat[1]) + ')');
	    } else if(hasLon) {
	        text.push(labels.lon + format(lonlat[0]));
	    } else if(hasLat) {
	        text.push(labels.lat + format(lonlat[1]));
	    }
	
	    if(isAll || parts.indexOf('text') !== -1) {
	        fillText(di, trace, text);
	    }
	
	    return text.join('<br>');
	}
	
	},{"../../components/fx":629,"../../constants/numerical":692,"../../lib":716,"../scatter/get_trace_color":1128}],1187:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('../scattergeo/calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	    selectPoints: _dereq_('./select'),
	
	    styleOnSelect: function(_, cd) {
	        if(cd) {
	            var trace = cd[0].trace;
	            trace._glTrace.update(cd);
	        }
	    },
	
	    moduleType: 'trace',
	    name: 'scattermapbox',
	    basePlotModule: _dereq_('../../plots/mapbox'),
	    categories: ['mapbox', 'gl', 'symbols', 'showLegend', 'scatter-like'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/mapbox":819,"../scatter/marker_colorbar":1136,"../scattergeo/calc":1160,"./attributes":1181,"./defaults":1183,"./event_data":1184,"./format_labels":1185,"./hover":1186,"./plot":1188,"./select":1189}],1188:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var convert = _dereq_('./convert');
	var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
	var ORDER = ['fill', 'line', 'circle', 'symbol'];
	
	function ScatterMapbox(subplot, uid) {
	    this.type = 'scattermapbox';
	    this.subplot = subplot;
	    this.uid = uid;
	
	    this.sourceIds = {
	        fill: 'source-' + uid + '-fill',
	        line: 'source-' + uid + '-line',
	        circle: 'source-' + uid + '-circle',
	        symbol: 'source-' + uid + '-symbol'
	    };
	
	    this.layerIds = {
	        fill: LAYER_PREFIX + uid + '-fill',
	        line: LAYER_PREFIX + uid + '-line',
	        circle: LAYER_PREFIX + uid + '-circle',
	        symbol: LAYER_PREFIX + uid + '-symbol'
	    };
	
	    // We could merge the 'fill' source with the 'line' source and
	    // the 'circle' source with the 'symbol' source if ever having
	    // for up-to 4 sources per 'scattermapbox' traces becomes a problem.
	
	    // previous 'below' value,
	    // need this to update it properly
	    this.below = null;
	}
	
	var proto = ScatterMapbox.prototype;
	
	proto.addSource = function(k, opts) {
	    this.subplot.map.addSource(this.sourceIds[k], {
	        type: 'geojson',
	        data: opts.geojson
	    });
	};
	
	proto.setSourceData = function(k, opts) {
	    this.subplot.map
	        .getSource(this.sourceIds[k])
	        .setData(opts.geojson);
	};
	
	proto.addLayer = function(k, opts, below) {
	    this.subplot.addLayer({
	        type: k,
	        id: this.layerIds[k],
	        source: this.sourceIds[k],
	        layout: opts.layout,
	        paint: opts.paint
	    }, below);
	};
	
	proto.update = function update(calcTrace) {
	    var subplot = this.subplot;
	    var map = subplot.map;
	    var optsAll = convert(subplot.gd, calcTrace);
	    var below = subplot.belowLookup['trace-' + this.uid];
	    var i, k, opts;
	
	    if(below !== this.below) {
	        for(i = ORDER.length - 1; i >= 0; i--) {
	            k = ORDER[i];
	            map.removeLayer(this.layerIds[k]);
	        }
	        for(i = 0; i < ORDER.length; i++) {
	            k = ORDER[i];
	            opts = optsAll[k];
	            this.addLayer(k, opts, below);
	        }
	        this.below = below;
	    }
	
	    for(i = 0; i < ORDER.length; i++) {
	        k = ORDER[i];
	        opts = optsAll[k];
	
	        subplot.setOptions(this.layerIds[k], 'setLayoutProperty', opts.layout);
	
	        if(opts.layout.visibility === 'visible') {
	            this.setSourceData(k, opts);
	            subplot.setOptions(this.layerIds[k], 'setPaintProperty', opts.paint);
	        }
	    }
	
	    // link ref for quick update during selections
	    calcTrace[0].trace._glTrace = this;
	};
	
	proto.dispose = function dispose() {
	    var map = this.subplot.map;
	
	    for(var i = ORDER.length - 1; i >= 0; i--) {
	        var k = ORDER[i];
	        map.removeLayer(this.layerIds[k]);
	        map.removeSource(this.sourceIds[k]);
	    }
	};
	
	module.exports = function createScatterMapbox(subplot, calcTrace) {
	    var trace = calcTrace[0].trace;
	    var scatterMapbox = new ScatterMapbox(subplot, trace.uid);
	    var optsAll = convert(subplot.gd, calcTrace);
	    var below = scatterMapbox.below = subplot.belowLookup['trace-' + trace.uid];
	
	    for(var i = 0; i < ORDER.length; i++) {
	        var k = ORDER[i];
	        var opts = optsAll[k];
	        scatterMapbox.addSource(k, opts);
	        scatterMapbox.addLayer(k, opts, below);
	    }
	
	    // link ref for quick update during selections
	    calcTrace[0].trace._glTrace = scatterMapbox;
	
	    return scatterMapbox;
	};
	
	},{"../../plots/mapbox/constants":817,"./convert":1182}],1189:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var subtypes = _dereq_('../scatter/subtypes');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function selectPoints(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	    var trace = cd[0].trace;
	    var i;
	
	    if(!subtypes.hasMarkers(trace)) return [];
	
	    if(selectionTester === false) {
	        for(i = 0; i < cd.length; i++) {
	            cd[i].selected = 0;
	        }
	    } else {
	        for(i = 0; i < cd.length; i++) {
	            var di = cd[i];
	            var lonlat = di.lonlat;
	
	            if(lonlat[0] !== BADNUM) {
	                var lonlat2 = [Lib.modHalf(lonlat[0], 360), lonlat[1]];
	                var xy = [xa.c2p(lonlat2), ya.c2p(lonlat2)];
	
	                if(selectionTester.contains(xy, null, i, searchInfo)) {
	                    selection.push({
	                        pointNumber: i,
	                        lon: lonlat[0],
	                        lat: lonlat[1]
	                    });
	                    di.selected = 1;
	                } else {
	                    di.selected = 0;
	                }
	            }
	        }
	    }
	
	    return selection;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../scatter/subtypes":1142}],1190:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var scatterAttrs = _dereq_('../scatter/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var lineAttrs = scatterAttrs.line;
	
	module.exports = {
	    mode: scatterAttrs.mode,
	
	    r: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    theta: {
	        valType: 'data_array',
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    r0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    dr: {
	        valType: 'number',
	        dflt: 1,
	        
	        editType: 'calc',
	        
	    },
	
	    theta0: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    dtheta: {
	        valType: 'number',
	        
	        editType: 'calc',
	        
	    },
	
	    thetaunit: {
	        valType: 'enumerated',
	        values: ['radians', 'degrees', 'gradians'],
	        dflt: 'degrees',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    text: scatterAttrs.text,
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['r', 'theta', 'text']
	    }),
	    hovertext: scatterAttrs.hovertext,
	
	    line: {
	        color: lineAttrs.color,
	        width: lineAttrs.width,
	        dash: lineAttrs.dash,
	        shape: extendFlat({}, lineAttrs.shape, {
	            values: ['linear', 'spline']
	        }),
	        smoothing: lineAttrs.smoothing,
	        editType: 'calc'
	    },
	    connectgaps: scatterAttrs.connectgaps,
	
	    marker: scatterAttrs.marker,
	    cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {dflt: false}),
	
	    textposition: scatterAttrs.textposition,
	    textfont: scatterAttrs.textfont,
	
	    fill: extendFlat({}, scatterAttrs.fill, {
	        values: ['none', 'toself', 'tonext'],
	        dflt: 'none',
	        
	    }),
	    fillcolor: scatterAttrs.fillcolor,
	
	    // TODO error bars
	    // https://stackoverflow.com/a/26597487/4068492
	    // error_x (error_r, error_theta)
	    // error_y
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['r', 'theta', 'text', 'name']
	    }),
	    hoveron: scatterAttrs.hoveron,
	    hovertemplate: hovertemplateAttrs(),
	
	    selected: scatterAttrs.selected,
	    unselected: scatterAttrs.unselected
	};
	
	},{"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scatter/attributes":1118}],1191:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
	
	module.exports = function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var subplotId = trace.subplot;
	    var radialAxis = fullLayout[subplotId].radialaxis;
	    var angularAxis = fullLayout[subplotId].angularaxis;
	    var rArray = radialAxis.makeCalcdata(trace, 'r');
	    var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
	    var len = trace._length;
	    var cd = new Array(len);
	
	    for(var i = 0; i < len; i++) {
	        var r = rArray[i];
	        var theta = thetaArray[i];
	        var cdi = cd[i] = {};
	
	        if(isNumeric(r) && isNumeric(theta)) {
	            cdi.r = r;
	            cdi.theta = theta;
	        } else {
	            cdi.r = BADNUM;
	        }
	    }
	
	    var ppad = calcMarkerSize(trace, len);
	    trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {ppad: ppad});
	
	    calcColorscale(gd, trace);
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	},{"../../constants/numerical":692,"../../plots/cartesian/axes":764,"../scatter/arrays_to_calcdata":1117,"../scatter/calc":1119,"../scatter/calc_selection":1120,"../scatter/colorscale_calc":1121,"fast-isnumeric":227}],1192:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	var PTS_LINESONLY = _dereq_('../scatter/constants').PTS_LINESONLY;
	
	var attributes = _dereq_('./attributes');
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('thetaunit');
	    coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
	    coerce('text');
	    coerce('hovertext');
	    if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        handleLineShapeDefaults(traceIn, traceOut, coerce);
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    var dfltHoverOn = [];
	
	    if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	        coerce('cliponaxis');
	        coerce('marker.maxdisplayed');
	        dfltHoverOn.push('points');
	    }
	
	    coerce('fill');
	
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	        if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	    }
	
	    if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
	        dfltHoverOn.push('fills');
	    }
	    coerce('hoveron', dfltHoverOn.join('+') || 'points');
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	}
	
	function handleRThetaDefaults(traceIn, traceOut, layout, coerce) {
	    var r = coerce('r');
	    var theta = coerce('theta');
	    var len;
	
	    if(r) {
	        if(theta) {
	            len = Math.min(r.length, theta.length);
	        } else {
	            len = r.length;
	            coerce('theta0');
	            coerce('dtheta');
	        }
	    } else {
	        if(!theta) return 0;
	        len = traceOut.theta.length;
	        coerce('r0');
	        coerce('dr');
	    }
	
	    traceOut._length = len;
	    return len;
	}
	
	module.exports = {
	    handleRThetaDefaults: handleRThetaDefaults,
	    supplyDefaults: supplyDefaults
	};
	
	},{"../../lib":716,"../scatter/constants":1122,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/line_shape_defaults":1133,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1190}],1193:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var labels = {};
	
	    var subplot = fullLayout[trace.subplot]._subplot;
	    var radialAxis;
	    var angularAxis;
	
	    // for scatterpolargl texttemplate, _subplot is NOT defined, this takes part during the convert step
	    // TODO we should consider moving the texttemplate formatting logic to the plot step
	    if(!subplot) {
	        subplot = fullLayout[trace.subplot];
	        radialAxis = subplot.radialaxis;
	        angularAxis = subplot.angularaxis;
	    } else {
	        radialAxis = subplot.radialAxis;
	        angularAxis = subplot.angularAxis;
	    }
	
	    var rVal = radialAxis.c2l(cdi.r);
	    labels.rLabel = Axes.tickText(radialAxis, rVal, true).text;
	
	    // N.B here the ° sign is part of the formatted value for thetaunit:'degrees'
	    var thetaVal = angularAxis.thetaunit === 'degrees' ? Lib.rad2deg(cdi.theta) : cdi.theta;
	    labels.thetaLabel = Axes.tickText(angularAxis, thetaVal, true).text;
	
	    return labels;
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764}],1194:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterHover = _dereq_('../scatter/hover');
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	    if(!scatterPointData || scatterPointData[0].index === false) return;
	
	    var newPointData = scatterPointData[0];
	
	    // hovering on fill case
	    if(newPointData.index === undefined) {
	        return scatterPointData;
	    }
	
	    var subplot = pointData.subplot;
	    var cdi = newPointData.cd[newPointData.index];
	    var trace = newPointData.trace;
	
	    if(!subplot.isPtInside(cdi)) return;
	
	    newPointData.xLabelVal = undefined;
	    newPointData.yLabelVal = undefined;
	    makeHoverPointText(cdi, trace, subplot, newPointData);
	    newPointData.hovertemplate = trace.hovertemplate;
	    return scatterPointData;
	}
	
	function makeHoverPointText(cdi, trace, subplot, pointData) {
	    var radialAxis = subplot.radialAxis;
	    var angularAxis = subplot.angularAxis;
	    radialAxis._hovertitle = 'r';
	    angularAxis._hovertitle = 'θ';
	
	    var fullLayout = {};
	    fullLayout[trace.subplot] = {_subplot: subplot};
	    var labels = trace._module.formatLabels(cdi, trace, fullLayout);
	    pointData.rLabel = labels.rLabel;
	    pointData.thetaLabel = labels.thetaLabel;
	
	    var hoverinfo = cdi.hi || trace.hoverinfo;
	    var text = [];
	    function textPart(ax, val) {
	        text.push(ax._hovertitle + ': ' + val);
	    }
	
	    if(!trace.hovertemplate) {
	        var parts = hoverinfo.split('+');
	
	        if(parts.indexOf('all') !== -1) parts = ['r', 'theta', 'text'];
	        if(parts.indexOf('r') !== -1) textPart(radialAxis, pointData.rLabel);
	        if(parts.indexOf('theta') !== -1) textPart(angularAxis, pointData.thetaLabel);
	
	        if(parts.indexOf('text') !== -1 && pointData.text) {
	            text.push(pointData.text);
	            delete pointData.text;
	        }
	
	        pointData.extraText = text.join('<br>');
	    }
	}
	
	module.exports = {
	    hoverPoints: hoverPoints,
	    makeHoverPointText: makeHoverPointText
	};
	
	},{"../scatter/hover":1129}],1195:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'scatterpolar',
	    basePlotModule: _dereq_('../../plots/polar'),
	    categories: ['polar', 'symbols', 'showLegend', 'scatter-like'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('../scatter/style').style,
	    styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    selectPoints: _dereq_('../scatter/select'),
	
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/polar":828,"../scatter/marker_colorbar":1136,"../scatter/select":1139,"../scatter/style":1141,"./attributes":1190,"./calc":1191,"./defaults":1192,"./format_labels":1193,"./hover":1194,"./plot":1196}],1196:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterPlot = _dereq_('../scatter/plot');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function plot(gd, subplot, moduleCalcData) {
	    var mlayer = subplot.layers.frontplot.select('g.scatterlayer');
	
	    var plotinfo = {
	        xaxis: subplot.xaxis,
	        yaxis: subplot.yaxis,
	        plot: subplot.framework,
	        layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
	    };
	
	    var radialAxis = subplot.radialAxis;
	    var angularAxis = subplot.angularAxis;
	
	    // convert:
	    // 'c' (r,theta) -> 'geometric' (r,theta) -> (x,y)
	    for(var i = 0; i < moduleCalcData.length; i++) {
	        var cdi = moduleCalcData[i];
	
	        for(var j = 0; j < cdi.length; j++) {
	            var cd = cdi[j];
	            var r = cd.r;
	
	            if(r === BADNUM) {
	                cd.x = cd.y = BADNUM;
	            } else {
	                var rg = radialAxis.c2g(r);
	                var thetag = angularAxis.c2g(cd.theta);
	                cd.x = rg * Math.cos(thetag);
	                cd.y = rg * Math.sin(thetag);
	            }
	        }
	    }
	
	    scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
	};
	
	},{"../../constants/numerical":692,"../scatter/plot":1138}],1197:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterPolarAttrs = _dereq_('../scatterpolar/attributes');
	var scatterGlAttrs = _dereq_('../scattergl/attributes');
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	
	module.exports = {
	    mode: scatterPolarAttrs.mode,
	    r: scatterPolarAttrs.r,
	    theta: scatterPolarAttrs.theta,
	    r0: scatterPolarAttrs.r0,
	    dr: scatterPolarAttrs.dr,
	    theta0: scatterPolarAttrs.theta0,
	    dtheta: scatterPolarAttrs.dtheta,
	    thetaunit: scatterPolarAttrs.thetaunit,
	
	    text: scatterPolarAttrs.text,
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['r', 'theta', 'text']
	    }),
	    hovertext: scatterPolarAttrs.hovertext,
	    hovertemplate: scatterPolarAttrs.hovertemplate,
	
	    line: scatterGlAttrs.line,
	    connectgaps: scatterGlAttrs.connectgaps,
	
	    marker: scatterGlAttrs.marker,
	    // no cliponaxis
	
	    fill: scatterGlAttrs.fill,
	    fillcolor: scatterGlAttrs.fillcolor,
	
	    textposition: scatterGlAttrs.textposition,
	    textfont: scatterGlAttrs.textfont,
	
	    hoverinfo: scatterPolarAttrs.hoverinfo,
	    // no hoveron
	
	    selected: scatterPolarAttrs.selected,
	    unselected: scatterPolarAttrs.unselected
	};
	
	},{"../../plots/template_attributes":840,"../scattergl/attributes":1169,"../scatterpolar/attributes":1190}],1198:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
	var convert = _dereq_('../scattergl/convert');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
	
	module.exports = function calc(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var subplotId = trace.subplot;
	    var radialAxis = fullLayout[subplotId].radialaxis;
	    var angularAxis = fullLayout[subplotId].angularaxis;
	    var rArray = trace._r = radialAxis.makeCalcdata(trace, 'r');
	    var thetaArray = trace._theta = angularAxis.makeCalcdata(trace, 'theta');
	    var len = trace._length;
	    var stash = {};
	
	    if(len < rArray.length) rArray = rArray.slice(0, len);
	    if(len < thetaArray.length) thetaArray = thetaArray.slice(0, len);
	
	    stash.r = rArray;
	    stash.theta = thetaArray;
	
	    calcColorscale(gd, trace);
	
	    // only compute 'style' options in calc, as position options
	    // depend on the radial range and must be set in plot
	    var opts = stash.opts = convert.style(gd, trace);
	
	    // For graphs with very large number of points and array marker.size,
	    // use average marker size instead to speed things up.
	    var ppad;
	    if(len < TOO_MANY_POINTS) {
	        ppad = calcMarkerSize(trace, len);
	    } else if(opts.marker) {
	        ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
	    }
	    trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {ppad: ppad});
	
	    return [{x: false, y: false, t: stash, trace: trace}];
	};
	
	},{"../../plots/cartesian/axes":764,"../scatter/calc":1119,"../scatter/colorscale_calc":1121,"../scattergl/constants":1171,"../scattergl/convert":1172}],1199:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var subTypes = _dereq_('../scatter/subtypes');
	var handleRThetaDefaults = _dereq_('../scatterpolar/defaults').handleRThetaDefaults;
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	var PTS_LINESONLY = _dereq_('../scatter/constants').PTS_LINESONLY;
	
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('thetaunit');
	    coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
	    coerce('text');
	    coerce('hovertext');
	    if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	    }
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../scatter/constants":1122,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"../scatterpolar/defaults":1192,"./attributes":1197}],1200:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterPolarFormatLabels = _dereq_('../scatterpolar/format_labels');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var i = cdi.i;
	    if(!('r' in cdi)) cdi.r = trace._r[i];
	    if(!('theta' in cdi)) cdi.theta = trace._theta[i];
	    return scatterPolarFormatLabels(cdi, trace, fullLayout);
	};
	
	},{"../scatterpolar/format_labels":1193}],1201:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hover = _dereq_('../scattergl/hover');
	var makeHoverPointText = _dereq_('../scatterpolar/hover').makeHoverPointText;
	
	function hoverPoints(pointData, xval, yval, hovermode) {
	    var cd = pointData.cd;
	    var stash = cd[0].t;
	    var rArray = stash.r;
	    var thetaArray = stash.theta;
	
	    var scatterPointData = hover.hoverPoints(pointData, xval, yval, hovermode);
	    if(!scatterPointData || scatterPointData[0].index === false) return;
	
	    var newPointData = scatterPointData[0];
	
	    if(newPointData.index === undefined) {
	        return scatterPointData;
	    }
	
	    var subplot = pointData.subplot;
	    var cdi = newPointData.cd[newPointData.index];
	    var trace = newPointData.trace;
	
	    // augment pointData with r/theta param
	    cdi.r = rArray[newPointData.index];
	    cdi.theta = thetaArray[newPointData.index];
	
	    if(!subplot.isPtInside(cdi)) return;
	
	    newPointData.xLabelVal = undefined;
	    newPointData.yLabelVal = undefined;
	    makeHoverPointText(cdi, trace, subplot, newPointData);
	
	    return scatterPointData;
	}
	
	module.exports = {
	    hoverPoints: hoverPoints
	};
	
	},{"../scattergl/hover":1176,"../scatterpolar/hover":1194}],1202:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'scatterpolargl',
	    basePlotModule: _dereq_('../../plots/polar'),
	    categories: ['gl', 'regl', 'polar', 'symbols', 'showLegend', 'scatter-like'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    selectPoints: _dereq_('../scattergl/select'),
	
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/polar":828,"../scatter/marker_colorbar":1136,"../scattergl/select":1180,"./attributes":1197,"./calc":1198,"./defaults":1199,"./format_labels":1200,"./hover":1201,"./plot":1203}],1203:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var cluster = _dereq_('point-cluster');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var scatterglPlot = _dereq_('../scattergl/plot');
	var sceneUpdate = _dereq_('../scattergl/scene_update');
	var convert = _dereq_('../scattergl/convert');
	
	var Lib = _dereq_('../../lib');
	
	var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
	
	module.exports = function plot(gd, subplot, cdata) {
	    if(!cdata.length) return;
	
	    var radialAxis = subplot.radialAxis;
	    var angularAxis = subplot.angularAxis;
	    var scene = sceneUpdate(gd, subplot);
	
	    cdata.forEach(function(cdscatter) {
	        if(!cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
	        var cd = cdscatter[0];
	        var trace = cd.trace;
	        var stash = cd.t;
	        var len = trace._length;
	        var rArray = stash.r;
	        var thetaArray = stash.theta;
	        var opts = stash.opts;
	        var i;
	
	        var subRArray = rArray.slice();
	        var subThetaArray = thetaArray.slice();
	
	        // filter out by range
	        for(i = 0; i < rArray.length; i++) {
	            if(!subplot.isPtInside({r: rArray[i], theta: thetaArray[i]})) {
	                subRArray[i] = NaN;
	                subThetaArray[i] = NaN;
	            }
	        }
	
	        var positions = new Array(len * 2);
	        var x = Array(len);
	        var y = Array(len);
	
	        for(i = 0; i < len; i++) {
	            var r = subRArray[i];
	            var xx, yy;
	
	            if(isNumeric(r)) {
	                var rg = radialAxis.c2g(r);
	                var thetag = angularAxis.c2g(subThetaArray[i], trace.thetaunit);
	                xx = rg * Math.cos(thetag);
	                yy = rg * Math.sin(thetag);
	            } else {
	                xx = yy = NaN;
	            }
	            x[i] = positions[i * 2] = xx;
	            y[i] = positions[i * 2 + 1] = yy;
	        }
	
	        stash.tree = cluster(positions);
	
	        // FIXME: see scattergl.js#109
	        if(opts.marker && len >= TOO_MANY_POINTS) {
	            opts.marker.cluster = stash.tree;
	        }
	
	        if(opts.marker) {
	            opts.markerSel.positions = opts.markerUnsel.positions = opts.marker.positions = positions;
	        }
	
	        if(opts.line && positions.length > 1) {
	            Lib.extendFlat(
	                opts.line,
	                convert.linePositions(gd, trace, positions)
	            );
	        }
	
	        if(opts.text) {
	            Lib.extendFlat(
	                opts.text,
	                {positions: positions},
	                convert.textPosition(gd, trace, opts.text, opts.marker)
	            );
	            Lib.extendFlat(
	                opts.textSel,
	                {positions: positions},
	                convert.textPosition(gd, trace, opts.text, opts.markerSel)
	            );
	            Lib.extendFlat(
	                opts.textUnsel,
	                {positions: positions},
	                convert.textPosition(gd, trace, opts.text, opts.markerUnsel)
	            );
	        }
	
	        if(opts.fill && !scene.fill2d) scene.fill2d = true;
	        if(opts.marker && !scene.scatter2d) scene.scatter2d = true;
	        if(opts.line && !scene.line2d) scene.line2d = true;
	        if(opts.text && !scene.glText) scene.glText = true;
	
	        scene.lineOptions.push(opts.line);
	        scene.fillOptions.push(opts.fill);
	        scene.markerOptions.push(opts.marker);
	        scene.markerSelectedOptions.push(opts.markerSel);
	        scene.markerUnselectedOptions.push(opts.markerUnsel);
	        scene.textOptions.push(opts.text);
	        scene.textSelectedOptions.push(opts.textSel);
	        scene.textUnselectedOptions.push(opts.textUnsel);
	        scene.selectBatch.push([]);
	        scene.unselectBatch.push([]);
	
	        stash.x = x;
	        stash.y = y;
	        stash.rawx = x;
	        stash.rawy = y;
	        stash.r = rArray;
	        stash.theta = thetaArray;
	        stash.positions = positions;
	        stash._scene = scene;
	        stash.index = scene.count;
	        scene.count++;
	    });
	
	    return scatterglPlot(gd, subplot, cdata);
	};
	
	},{"../../lib":716,"../scattergl/constants":1171,"../scattergl/convert":1172,"../scattergl/plot":1178,"../scattergl/scene_update":1179,"fast-isnumeric":227,"point-cluster":470}],1204:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var scatterAttrs = _dereq_('../scatter/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var dash = _dereq_('../../components/drawing/attributes').dash;
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterLineAttrs = scatterAttrs.line;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	module.exports = {
	    a: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    b: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    c: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    sum: {
	        valType: 'number',
	        
	        dflt: 0,
	        min: 0,
	        editType: 'calc',
	        
	    },
	    mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
	    text: extendFlat({}, scatterAttrs.text, {
	        
	    }),
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: ['a', 'b', 'c', 'text']
	    }),
	    hovertext: extendFlat({}, scatterAttrs.hovertext, {
	        
	    }),
	    line: {
	        color: scatterLineAttrs.color,
	        width: scatterLineAttrs.width,
	        dash: dash,
	        shape: extendFlat({}, scatterLineAttrs.shape,
	            {values: ['linear', 'spline']}),
	        smoothing: scatterLineAttrs.smoothing,
	        editType: 'calc'
	    },
	    connectgaps: scatterAttrs.connectgaps,
	    cliponaxis: scatterAttrs.cliponaxis,
	    fill: extendFlat({}, scatterAttrs.fill, {
	        values: ['none', 'toself', 'tonext'],
	        dflt: 'none',
	        
	    }),
	    fillcolor: scatterAttrs.fillcolor,
	    marker: extendFlat({
	        symbol: scatterMarkerAttrs.symbol,
	        opacity: scatterMarkerAttrs.opacity,
	        maxdisplayed: scatterMarkerAttrs.maxdisplayed,
	        size: scatterMarkerAttrs.size,
	        sizeref: scatterMarkerAttrs.sizeref,
	        sizemin: scatterMarkerAttrs.sizemin,
	        sizemode: scatterMarkerAttrs.sizemode,
	        line: extendFlat({
	            width: scatterMarkerLineAttrs.width,
	            editType: 'calc'
	        },
	            colorScaleAttrs('marker.line')
	        ),
	        gradient: scatterMarkerAttrs.gradient,
	        editType: 'calc'
	    },
	        colorScaleAttrs('marker')
	    ),
	
	    textfont: scatterAttrs.textfont,
	    textposition: scatterAttrs.textposition,
	
	    selected: scatterAttrs.selected,
	    unselected: scatterAttrs.unselected,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['a', 'b', 'c', 'text', 'name']
	    }),
	    hoveron: scatterAttrs.hoveron,
	    hovertemplate: hovertemplateAttrs(),
	};
	
	},{"../../components/colorscale/attributes":598,"../../components/drawing/attributes":611,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../scatter/attributes":1118}],1205:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var isNumeric = _dereq_('fast-isnumeric');
	
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
	var calcSelection = _dereq_('../scatter/calc_selection');
	var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
	
	var dataArrays = ['a', 'b', 'c'];
	var arraysToFill = {a: ['b', 'c'], b: ['a', 'c'], c: ['a', 'b']};
	
	module.exports = function calc(gd, trace) {
	    var ternary = gd._fullLayout[trace.subplot];
	    var displaySum = ternary.sum;
	    var normSum = trace.sum || displaySum;
	    var arrays = {a: trace.a, b: trace.b, c: trace.c};
	
	    var i, j, dataArray, newArray, fillArray1, fillArray2;
	
	    // fill in one missing component
	    for(i = 0; i < dataArrays.length; i++) {
	        dataArray = dataArrays[i];
	        if(arrays[dataArray]) continue;
	
	        fillArray1 = arrays[arraysToFill[dataArray][0]];
	        fillArray2 = arrays[arraysToFill[dataArray][1]];
	        newArray = new Array(fillArray1.length);
	        for(j = 0; j < fillArray1.length; j++) {
	            newArray[j] = normSum - fillArray1[j] - fillArray2[j];
	        }
	        arrays[dataArray] = newArray;
	    }
	
	    // make the calcdata array
	    var serieslen = trace._length;
	    var cd = new Array(serieslen);
	    var a, b, c, norm, x, y;
	    for(i = 0; i < serieslen; i++) {
	        a = arrays.a[i];
	        b = arrays.b[i];
	        c = arrays.c[i];
	        if(isNumeric(a) && isNumeric(b) && isNumeric(c)) {
	            a = +a;
	            b = +b;
	            c = +c;
	            norm = displaySum / (a + b + c);
	            if(norm !== 1) {
	                a *= norm;
	                b *= norm;
	                c *= norm;
	            }
	            // map a, b, c onto x and y where the full scale of y
	            // is [0, sum], and x is [-sum, sum]
	            // TODO: this makes `a` always the top, `b` the bottom left,
	            // and `c` the bottom right. Do we want options to rearrange
	            // these?
	            y = a;
	            x = c - b;
	            cd[i] = {x: x, y: y, a: a, b: b, c: c};
	        } else cd[i] = {x: false, y: false};
	    }
	
	    calcMarkerSize(trace, serieslen);
	    calcColorscale(gd, trace);
	    arraysToCalcdata(cd, trace);
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	},{"../scatter/arrays_to_calcdata":1117,"../scatter/calc":1119,"../scatter/calc_selection":1120,"../scatter/colorscale_calc":1121,"fast-isnumeric":227}],1206:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var constants = _dereq_('../scatter/constants');
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var handleLineDefaults = _dereq_('../scatter/line_defaults');
	var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
	var handleTextDefaults = _dereq_('../scatter/text_defaults');
	var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
	
	var attributes = _dereq_('./attributes');
	
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var a = coerce('a');
	    var b = coerce('b');
	    var c = coerce('c');
	    var len;
	
	    // allow any one array to be missing, len is the minimum length of those
	    // present. Note that after coerce data_array's are either Arrays (which
	    // are truthy even if empty) or undefined. As in scatter, an empty array
	    // is different from undefined, because it can signify that this data is
	    // not known yet but expected in the future
	    if(a) {
	        len = a.length;
	        if(b) {
	            len = Math.min(len, b.length);
	            if(c) len = Math.min(len, c.length);
	        } else if(c) len = Math.min(len, c.length);
	        else len = 0;
	    } else if(b && c) {
	        len = Math.min(b.length, c.length);
	    }
	
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._length = len;
	
	    coerce('sum');
	
	    coerce('text');
	    coerce('hovertext');
	    if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
	
	    var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
	    coerce('mode', defaultMode);
	
	    if(subTypes.hasLines(traceOut)) {
	        handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	        handleLineShapeDefaults(traceIn, traceOut, coerce);
	        coerce('connectgaps');
	    }
	
	    if(subTypes.hasMarkers(traceOut)) {
	        handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
	    }
	
	    if(subTypes.hasText(traceOut)) {
	        coerce('texttemplate');
	        handleTextDefaults(traceIn, traceOut, layout, coerce);
	    }
	
	    var dfltHoverOn = [];
	
	    if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	        coerce('cliponaxis');
	        coerce('marker.maxdisplayed');
	        dfltHoverOn.push('points');
	    }
	
	    coerce('fill');
	    if(traceOut.fill !== 'none') {
	        handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	        if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	    }
	
	    if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
	        dfltHoverOn.push('fills');
	    }
	    coerce('hoveron', dfltHoverOn.join('+') || 'points');
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	},{"../../lib":716,"../scatter/constants":1122,"../scatter/fillcolor_defaults":1126,"../scatter/line_defaults":1131,"../scatter/line_shape_defaults":1133,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"../scatter/text_defaults":1143,"./attributes":1204}],1207:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt, trace, cd, pointNumber) {
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    if(cd[pointNumber]) {
	        var cdi = cd[pointNumber];
	
	        // N.B. These are the normalized coordinates.
	        out.a = cdi.a;
	        out.b = cdi.b;
	        out.c = cdi.c;
	    } else {
	        // for fill-hover only
	        out.a = pt.a;
	        out.b = pt.b;
	        out.c = pt.c;
	    }
	
	    return out;
	};
	
	},{}],1208:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	
	module.exports = function formatLabels(cdi, trace, fullLayout) {
	    var labels = {};
	
	    var subplot = fullLayout[trace.subplot]._subplot;
	    labels.aLabel = Axes.tickText(subplot.aaxis, cdi.a, true).text;
	    labels.bLabel = Axes.tickText(subplot.baxis, cdi.b, true).text;
	    labels.cLabel = Axes.tickText(subplot.caxis, cdi.c, true).text;
	
	    return labels;
	};
	
	},{"../../plots/cartesian/axes":764}],1209:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterHover = _dereq_('../scatter/hover');
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	    if(!scatterPointData || scatterPointData[0].index === false) return;
	
	    var newPointData = scatterPointData[0];
	
	    // if hovering on a fill, we don't show any point data so the label is
	    // unchanged from what scatter gives us - except that it needs to
	    // be constrained to the trianglular plot area, not just the rectangular
	    // area defined by the synthetic x and y axes
	    // TODO: in some cases the vertical middle of the shape is not within
	    // the triangular viewport at all, so the label can become disconnected
	    // from the shape entirely. But calculating what portion of the shape
	    // is actually visible, as constrained by the diagonal axis lines, is not
	    // so easy and anyway we lost the information we would have needed to do
	    // this inside scatterHover.
	    if(newPointData.index === undefined) {
	        var yFracUp = 1 - (newPointData.y0 / pointData.ya._length);
	        var xLen = pointData.xa._length;
	        var xMin = xLen * yFracUp / 2;
	        var xMax = xLen - xMin;
	        newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
	        newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
	        return scatterPointData;
	    }
	
	    var cdi = newPointData.cd[newPointData.index];
	    var trace = newPointData.trace;
	    var subplot = newPointData.subplot;
	
	    newPointData.a = cdi.a;
	    newPointData.b = cdi.b;
	    newPointData.c = cdi.c;
	
	    newPointData.xLabelVal = undefined;
	    newPointData.yLabelVal = undefined;
	
	    var fullLayout = {};
	    fullLayout[trace.subplot] = {_subplot: subplot};
	    var labels = trace._module.formatLabels(cdi, trace, fullLayout);
	    newPointData.aLabel = labels.aLabel;
	    newPointData.bLabel = labels.bLabel;
	    newPointData.cLabel = labels.cLabel;
	
	    var hoverinfo = cdi.hi || trace.hoverinfo;
	    var text = [];
	    function textPart(ax, val) {
	        text.push(ax._hovertitle + ': ' + val);
	    }
	    if(!trace.hovertemplate) {
	        var parts = hoverinfo.split('+');
	        if(parts.indexOf('all') !== -1) parts = ['a', 'b', 'c'];
	        if(parts.indexOf('a') !== -1) textPart(subplot.aaxis, newPointData.aLabel);
	        if(parts.indexOf('b') !== -1) textPart(subplot.baxis, newPointData.bLabel);
	        if(parts.indexOf('c') !== -1) textPart(subplot.caxis, newPointData.cLabel);
	    }
	    newPointData.extraText = text.join('<br>');
	    newPointData.hovertemplate = trace.hovertemplate;
	    return scatterPointData;
	};
	
	},{"../scatter/hover":1129}],1210:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	    formatLabels: _dereq_('./format_labels'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('../scatter/style').style,
	    styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('../scatter/select'),
	    eventData: _dereq_('./event_data'),
	
	    moduleType: 'trace',
	    name: 'scatterternary',
	    basePlotModule: _dereq_('../../plots/ternary'),
	    categories: ['ternary', 'symbols', 'showLegend', 'scatter-like'],
	    meta: {
	        
	        
	    }
	};
	
	},{"../../plots/ternary":841,"../scatter/marker_colorbar":1136,"../scatter/select":1139,"../scatter/style":1141,"./attributes":1204,"./calc":1205,"./defaults":1206,"./event_data":1207,"./format_labels":1208,"./hover":1209,"./plot":1211}],1211:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var scatterPlot = _dereq_('../scatter/plot');
	
	module.exports = function plot(gd, ternary, moduleCalcData) {
	    var plotContainer = ternary.plotContainer;
	
	    // remove all nodes inside the scatter layer
	    plotContainer.select('.scatterlayer').selectAll('*').remove();
	
	    // mimic cartesian plotinfo
	    var plotinfo = {
	        xaxis: ternary.xaxis,
	        yaxis: ternary.yaxis,
	        plot: plotContainer,
	        layerClipId: ternary._hasClipOnAxisFalse ? ternary.clipIdRelative : null
	    };
	
	    var scatterLayer = ternary.layers.frontplot.select('g.scatterlayer');
	
	    scatterPlot(gd, plotinfo, moduleCalcData, scatterLayer);
	};
	
	},{"../scatter/plot":1138}],1212:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var scatterAttrs = _dereq_('../scatter/attributes');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var scatterGlAttrs = _dereq_('../scattergl/attributes');
	var cartesianIdRegex = _dereq_('../../plots/cartesian/constants').idRegex;
	var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var scatterMarkerAttrs = scatterAttrs.marker;
	var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	
	var markerLineAttrs = extendFlat(colorScaleAttrs('marker.line', {editTypeOverride: 'calc'}), {
	    width: extendFlat({}, scatterMarkerLineAttrs.width, {editType: 'calc'}),
	    editType: 'calc'
	});
	
	var markerAttrs = extendFlat(colorScaleAttrs('marker'), {
	    symbol: scatterMarkerAttrs.symbol,
	    size: extendFlat({}, scatterMarkerAttrs.size, {editType: 'markerSize'}),
	    sizeref: scatterMarkerAttrs.sizeref,
	    sizemin: scatterMarkerAttrs.sizemin,
	    sizemode: scatterMarkerAttrs.sizemode,
	    opacity: scatterMarkerAttrs.opacity,
	    colorbar: scatterMarkerAttrs.colorbar,
	    line: markerLineAttrs,
	    editType: 'calc'
	});
	
	markerAttrs.color.editType = markerAttrs.cmin.editType = markerAttrs.cmax.editType = 'style';
	
	function makeAxesValObject(axLetter) {
	    return {
	        valType: 'info_array',
	        freeLength: true,
	        
	        editType: 'calc',
	        items: {
	            valType: 'subplotid',
	            regex: cartesianIdRegex[axLetter],
	            editType: 'plot'
	        },
	        
	    };
	}
	
	module.exports = {
	    dimensions: templatedArray('dimension', {
	        visible: {
	            valType: 'boolean',
	            
	            dflt: true,
	            editType: 'calc',
	            
	        },
	        label: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        },
	        values: {
	            valType: 'data_array',
	            
	            editType: 'calc+clearAxisTypes',
	            
	        },
	
	        axis: {
	            type: {
	                valType: 'enumerated',
	                values: ['linear', 'log', 'date', 'category'],
	                
	                editType: 'calc+clearAxisTypes',
	                
	            },
	
	            // TODO make 'true' the default in v2?
	            matches: {
	                valType: 'boolean',
	                dflt: false,
	                
	                editType: 'calc',
	                
	            },
	
	            editType: 'calc+clearAxisTypes'
	        },
	
	        // TODO should add an attribute to pin down x only vars and y only vars
	        // like https://seaborn.pydata.org/generated/seaborn.pairplot.html
	        // x_vars and y_vars
	
	        // maybe more axis defaulting option e.g. `showgrid: false`
	
	        editType: 'calc+clearAxisTypes'
	    }),
	
	    // mode: {}, (only 'markers' for now)
	
	    text: extendFlat({}, scatterGlAttrs.text, {
	        
	    }),
	    hovertext: extendFlat({}, scatterGlAttrs.hovertext, {
	        
	    }),
	
	    hovertemplate: hovertemplateAttrs(),
	
	    marker: markerAttrs,
	
	    xaxes: makeAxesValObject('x'),
	    yaxes: makeAxesValObject('y'),
	
	    diagonal: {
	        visible: {
	            valType: 'boolean',
	            
	            dflt: true,
	            editType: 'calc',
	            
	        },
	
	        // type: 'scattergl' | 'histogram' | 'box' | 'violin'
	        // ...
	        // more options
	
	        editType: 'calc'
	    },
	
	    showupperhalf: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc',
	        
	    },
	    showlowerhalf: {
	        valType: 'boolean',
	        
	        dflt: true,
	        editType: 'calc',
	        
	    },
	
	    selected: {
	        marker: scatterGlAttrs.selected.marker,
	        editType: 'calc'
	    },
	    unselected: {
	        marker: scatterGlAttrs.unselected.marker,
	        editType: 'calc'
	    },
	
	    opacity: scatterGlAttrs.opacity
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/plot_template":754,"../../plots/cartesian/constants":770,"../../plots/template_attributes":840,"../scatter/attributes":1118,"../scattergl/attributes":1169}],1213:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createLine = _dereq_('regl-line2d');
	
	var Registry = _dereq_('../../registry');
	var prepareRegl = _dereq_('../../lib/prepare_regl');
	var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
	var Cartesian = _dereq_('../../plots/cartesian');
	var getFromId = _dereq_('../../plots/cartesian/axis_ids').getFromId;
	var shouldShowZeroLine = _dereq_('../../plots/cartesian/axes').shouldShowZeroLine;
	
	var SPLOM = 'splom';
	
	function plot(gd) {
	    var fullLayout = gd._fullLayout;
	    var _module = Registry.getModule(SPLOM);
	    var splomCalcData = getModuleCalcData(gd.calcdata, _module)[0];
	
	    var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint']);
	    if(!success) return;
	
	    if(fullLayout._hasOnlyLargeSploms) {
	        updateGrid(gd);
	    }
	
	    _module.plot(gd, {}, splomCalcData);
	}
	
	function drag(gd) {
	    var cd = gd.calcdata;
	    var fullLayout = gd._fullLayout;
	
	    if(fullLayout._hasOnlyLargeSploms) {
	        updateGrid(gd);
	    }
	
	    for(var i = 0; i < cd.length; i++) {
	        var cd0 = cd[i][0];
	        var trace = cd0.trace;
	        var scene = fullLayout._splomScenes[trace.uid];
	
	        if(trace.type === 'splom' && scene && scene.matrix) {
	            dragOne(gd, trace, scene);
	        }
	    }
	}
	
	function dragOne(gd, trace, scene) {
	    var visibleLength = scene.matrixOptions.data.length;
	    var visibleDims = trace._visibleDims;
	    var ranges = scene.viewOpts.ranges = new Array(visibleLength);
	
	    for(var k = 0; k < visibleDims.length; k++) {
	        var i = visibleDims[k];
	        var rng = ranges[k] = new Array(4);
	
	        var xa = getFromId(gd, trace._diag[i][0]);
	        if(xa) {
	            rng[0] = xa.r2l(xa.range[0]);
	            rng[2] = xa.r2l(xa.range[1]);
	        }
	
	        var ya = getFromId(gd, trace._diag[i][1]);
	        if(ya) {
	            rng[1] = ya.r2l(ya.range[0]);
	            rng[3] = ya.r2l(ya.range[1]);
	        }
	    }
	
	    if(scene.selectBatch.length || scene.unselectBatch.length) {
	        scene.matrix.update({ranges: ranges}, {ranges: ranges});
	    } else {
	        scene.matrix.update({ranges: ranges});
	    }
	}
	
	function updateGrid(gd) {
	    var fullLayout = gd._fullLayout;
	    var regl = fullLayout._glcanvas.data()[0].regl;
	    var splomGrid = fullLayout._splomGrid;
	
	    if(!splomGrid) {
	        splomGrid = fullLayout._splomGrid = createLine(regl);
	    }
	    splomGrid.update(makeGridData(gd));
	}
	
	function makeGridData(gd) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	    var fullView = [0, 0, fullLayout.width, fullLayout.height];
	    var lookup = {};
	    var k;
	
	    function push(prefix, ax, x0, x1, y0, y1) {
	        var lcolor = ax[prefix + 'color'];
	        var lwidth = ax[prefix + 'width'];
	        var key = String(lcolor + lwidth);
	
	        if(key in lookup) {
	            lookup[key].data.push(NaN, NaN, x0, x1, y0, y1);
	        } else {
	            lookup[key] = {
	                data: [x0, x1, y0, y1],
	                join: 'rect',
	                thickness: lwidth,
	                color: lcolor,
	                viewport: fullView,
	                range: fullView,
	                overlay: false
	            };
	        }
	    }
	
	    for(k in fullLayout._splomSubplots) {
	        var sp = fullLayout._plots[k];
	        var xa = sp.xaxis;
	        var ya = sp.yaxis;
	        var xVals = xa._gridVals;
	        var yVals = ya._gridVals;
	        // ya.l2p assumes top-to-bottom coordinate system (a la SVG),
	        // we need to compute bottom-to-top offsets and slopes:
	        var yOffset = gs.b + ya.domain[0] * gs.h;
	        var ym = -ya._m;
	        var yb = -ym * ya.r2l(ya.range[0], ya.calendar);
	        var x, y;
	
	        if(xa.showgrid) {
	            for(k = 0; k < xVals.length; k++) {
	                x = xa._offset + xa.l2p(xVals[k].x);
	                push('grid', xa, x, yOffset, x, yOffset + ya._length);
	            }
	        }
	        if(ya.showgrid) {
	            for(k = 0; k < yVals.length; k++) {
	                y = yOffset + yb + ym * yVals[k].x;
	                push('grid', ya, xa._offset, y, xa._offset + xa._length, y);
	            }
	        }
	        if(shouldShowZeroLine(gd, xa, ya)) {
	            x = xa._offset + xa.l2p(0);
	            push('zeroline', xa, x, yOffset, x, yOffset + ya._length);
	        }
	        if(shouldShowZeroLine(gd, ya, xa)) {
	            y = yOffset + yb + 0;
	            push('zeroline', ya, xa._offset, y, xa._offset + xa._length, y);
	        }
	    }
	
	    var gridBatches = [];
	    for(k in lookup) {
	        gridBatches.push(lookup[k]);
	    }
	
	    return gridBatches;
	}
	
	function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var lookup = {};
	    var i;
	
	    if(oldFullLayout._splomScenes) {
	        for(i = 0; i < newFullData.length; i++) {
	            var newTrace = newFullData[i];
	            if(newTrace.type === 'splom') {
	                lookup[newTrace.uid] = 1;
	            }
	        }
	        for(i = 0; i < oldFullData.length; i++) {
	            var oldTrace = oldFullData[i];
	            if(!lookup[oldTrace.uid]) {
	                var scene = oldFullLayout._splomScenes[oldTrace.uid];
	                if(scene && scene.destroy) scene.destroy();
	                // must first set scene to null in order to get garbage collected
	                oldFullLayout._splomScenes[oldTrace.uid] = null;
	                delete oldFullLayout._splomScenes[oldTrace.uid];
	            }
	        }
	    }
	
	    if(Object.keys(oldFullLayout._splomScenes || {}).length === 0) {
	        delete oldFullLayout._splomScenes;
	    }
	
	    if(oldFullLayout._splomGrid &&
	        (!newFullLayout._hasOnlyLargeSploms && oldFullLayout._hasOnlyLargeSploms)) {
	        // must first set scene to null in order to get garbage collected
	        oldFullLayout._splomGrid.destroy();
	        oldFullLayout._splomGrid = null;
	        delete oldFullLayout._splomGrid;
	    }
	
	    Cartesian.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
	}
	
	module.exports = {
	    name: SPLOM,
	    attr: Cartesian.attr,
	    attrRegex: Cartesian.attrRegex,
	    layoutAttributes: Cartesian.layoutAttributes,
	    supplyLayoutDefaults: Cartesian.supplyLayoutDefaults,
	    drawFramework: Cartesian.drawFramework,
	    plot: plot,
	    drag: drag,
	    updateGrid: updateGrid,
	    clean: clean,
	    updateFx: Cartesian.updateFx,
	    toSVG: Cartesian.toSVG
	};
	
	},{"../../lib/prepare_regl":729,"../../plots/cartesian":775,"../../plots/cartesian/axes":764,"../../plots/cartesian/axis_ids":767,"../../plots/get_data":799,"../../registry":845,"regl-line2d":492}],1214:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
	
	var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
	var calcAxisExpansion = _dereq_('../scatter/calc').calcAxisExpansion;
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var convertMarkerSelection = _dereq_('../scattergl/convert').markerSelection;
	var convertMarkerStyle = _dereq_('../scattergl/convert').markerStyle;
	var sceneUpdate = _dereq_('./scene_update');
	
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
	
	module.exports = function calc(gd, trace) {
	    var dimensions = trace.dimensions;
	    var commonLength = trace._length;
	    var opts = {};
	    // 'c' for calculated, 'l' for linear,
	    // only differ here for log axes, pass ldata to createMatrix as 'data'
	    var cdata = opts.cdata = [];
	    var ldata = opts.data = [];
	    // keep track of visible dimensions
	    var visibleDims = trace._visibleDims = [];
	    var i, k, dim, xa, ya;
	
	    function makeCalcdata(ax, dim) {
	        // call makeCalcdata with fake input
	        var ccol = ax.makeCalcdata({
	            v: dim.values,
	            vcalendar: trace.calendar
	        }, 'v');
	
	        for(var j = 0; j < ccol.length; j++) {
	            ccol[j] = ccol[j] === BADNUM ? NaN : ccol[j];
	        }
	        cdata.push(ccol);
	        ldata.push(ax.type === 'log' ? Lib.simpleMap(ccol, ax.c2l) : ccol);
	    }
	
	    for(i = 0; i < dimensions.length; i++) {
	        dim = dimensions[i];
	
	        if(dim.visible) {
	            xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	            ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	
	            // if corresponding x & y axes don't have matching types, skip dim
	            if(xa && ya && xa.type !== ya.type) {
	                Lib.log('Skipping splom dimension ' + i + ' with conflicting axis types');
	                continue;
	            }
	
	            if(xa) {
	                makeCalcdata(xa, dim);
	                if(ya && ya.type === 'category') {
	                    ya._categories = xa._categories.slice();
	                }
	            } else {
	                // should not make it here, if both xa and ya undefined
	                makeCalcdata(ya, dim);
	            }
	
	            visibleDims.push(i);
	        }
	    }
	
	    calcColorscale(gd, trace);
	    Lib.extendFlat(opts, convertMarkerStyle(trace));
	
	    var visibleLength = cdata.length;
	    var hasTooManyPoints = (visibleLength * commonLength) > TOO_MANY_POINTS;
	
	    // Reuse SVG scatter axis expansion routine.
	    // For graphs with very large number of points and array marker.size,
	    // use average marker size instead to speed things up.
	    var ppad;
	    if(hasTooManyPoints) {
	        ppad = 2 * (opts.sizeAvg || Math.max(opts.size, 3));
	    } else {
	        ppad = calcMarkerSize(trace, commonLength);
	    }
	
	    for(k = 0; k < visibleDims.length; k++) {
	        i = visibleDims[k];
	        dim = dimensions[i];
	        xa = AxisIDs.getFromId(gd, trace._diag[i][0]) || {};
	        ya = AxisIDs.getFromId(gd, trace._diag[i][1]) || {};
	        calcAxisExpansion(gd, trace, xa, ya, cdata[k], cdata[k], ppad);
	    }
	
	    var scene = sceneUpdate(gd, trace);
	    if(!scene.matrix) scene.matrix = true;
	    scene.matrixOptions = opts;
	
	    scene.selectedOptions = convertMarkerSelection(trace, trace.selected);
	    scene.unselectedOptions = convertMarkerSelection(trace, trace.unselected);
	
	    return [{x: false, y: false, t: {}, trace: trace}];
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axis_ids":767,"../scatter/calc":1119,"../scatter/colorscale_calc":1121,"../scattergl/constants":1171,"../scattergl/convert":1172,"./scene_update":1221}],1215:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
	
	var attributes = _dereq_('./attributes');
	var subTypes = _dereq_('../scatter/subtypes');
	var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
	var mergeLength = _dereq_('../parcoords/merge_length');
	var OPEN_RE = /-open/;
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	        name: 'dimensions',
	        handleItemDefaults: dimensionDefaults
	    });
	
	    var showDiag = coerce('diagonal.visible');
	    var showUpper = coerce('showupperhalf');
	    var showLower = coerce('showlowerhalf');
	
	    var dimLength = mergeLength(traceOut, dimensions, 'values');
	
	    if(!dimLength || (!showDiag && !showUpper && !showLower)) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	
	    var isOpen = OPEN_RE.test(traceOut.marker.symbol);
	    var isBubble = subTypes.isBubble(traceOut);
	    coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
	
	    handleAxisDefaults(traceIn, traceOut, layout, coerce);
	
	    Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	};
	
	function dimensionDefaults(dimIn, dimOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(dimIn, dimOut, attributes.dimensions, attr, dflt);
	    }
	
	    coerce('label');
	    var values = coerce('values');
	
	    if(!(values && values.length)) dimOut.visible = false;
	    else coerce('visible');
	
	    coerce('axis.type');
	    coerce('axis.matches');
	}
	
	function handleAxisDefaults(traceIn, traceOut, layout, coerce) {
	    var dimensions = traceOut.dimensions;
	    var dimLength = dimensions.length;
	    var showUpper = traceOut.showupperhalf;
	    var showLower = traceOut.showlowerhalf;
	    var showDiag = traceOut.diagonal.visible;
	    var i, j;
	
	    var xAxesDflt = new Array(dimLength);
	    var yAxesDflt = new Array(dimLength);
	
	    for(i = 0; i < dimLength; i++) {
	        var suffix = i ? i + 1 : '';
	        xAxesDflt[i] = 'x' + suffix;
	        yAxesDflt[i] = 'y' + suffix;
	    }
	
	    var xaxes = coerce('xaxes', xAxesDflt);
	    var yaxes = coerce('yaxes', yAxesDflt);
	
	    // build list of [x,y] axis corresponding to each dimensions[i],
	    // very useful for passing options to regl-splom
	    var diag = traceOut._diag = new Array(dimLength);
	
	    // lookup for 'drawn' x|y axes, to avoid costly indexOf downstream
	    traceOut._xaxes = {};
	    traceOut._yaxes = {};
	
	    // list of 'drawn' x|y axes, use to generate list of subplots
	    var xList = [];
	    var yList = [];
	
	    function fillAxisStashes(axId, counterAxId, dim, list) {
	        if(!axId) return;
	
	        var axLetter = axId.charAt(0);
	        var stash = layout._splomAxes[axLetter];
	
	        traceOut['_' + axLetter + 'axes'][axId] = 1;
	        list.push(axId);
	
	        if(!(axId in stash)) {
	            var s = stash[axId] = {};
	            if(dim) {
	                s.label = dim.label || '';
	                if(dim.visible && dim.axis) {
	                    if(dim.axis.type) s.type = dim.axis.type;
	                    if(dim.axis.matches) s.matches = counterAxId;
	                }
	            }
	        }
	    }
	
	    // cases where showDiag and showLower or showUpper are false
	    // no special treatment as the 'drawn' x-axes and y-axes no longer match
	    // the dimensions items and xaxes|yaxes 1-to-1
	    var mustShiftX = !showDiag && !showLower;
	    var mustShiftY = !showDiag && !showUpper;
	
	    traceOut._axesDim = {};
	    for(i = 0; i < dimLength; i++) {
	        var dim = dimensions[i];
	        var i0 = i === 0;
	        var iN = i === dimLength - 1;
	
	        var xaId = (i0 && mustShiftX) || (iN && mustShiftY) ?
	            undefined :
	            xaxes[i];
	
	        var yaId = (i0 && mustShiftY) || (iN && mustShiftX) ?
	            undefined :
	            yaxes[i];
	
	        fillAxisStashes(xaId, yaId, dim, xList);
	        fillAxisStashes(yaId, xaId, dim, yList);
	        diag[i] = [xaId, yaId];
	        traceOut._axesDim[xaId] = i;
	        traceOut._axesDim[yaId] = i;
	    }
	
	    // fill in splom subplot keys
	    for(i = 0; i < xList.length; i++) {
	        for(j = 0; j < yList.length; j++) {
	            var id = xList[i] + yList[j];
	
	            if(i > j && showUpper) {
	                layout._splomSubplots[id] = 1;
	            } else if(i < j && showLower) {
	                layout._splomSubplots[id] = 1;
	            } else if(i === j && (showDiag || !showLower || !showUpper)) {
	                // need to include diagonal subplots when
	                // hiding one half and the diagonal
	                layout._splomSubplots[id] = 1;
	            }
	        }
	    }
	
	    // when lower half is omitted, or when just the diagonal is gone,
	    // override grid default to make sure axes remain on
	    // the left/bottom of the plot area
	    if(!showLower || (!showDiag && showUpper && showLower)) {
	        layout._splomGridDflt.xside = 'bottom';
	        layout._splomGridDflt.yside = 'left';
	    }
	}
	
	},{"../../lib":716,"../../plots/array_container_defaults":760,"../parcoords/merge_length":1089,"../scatter/marker_defaults":1137,"../scatter/subtypes":1142,"./attributes":1212}],1216:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var calcColorscale = _dereq_('../scatter/colorscale_calc');
	var convertMarkerStyle = _dereq_('../scattergl/convert').markerStyle;
	
	module.exports = function editStyle(gd, cd0) {
	    var trace = cd0.trace;
	    var scene = gd._fullLayout._splomScenes[trace.uid];
	
	    if(scene) {
	        calcColorscale(gd, trace);
	
	        Lib.extendFlat(scene.matrixOptions, convertMarkerStyle(trace));
	        // TODO [un]selected styles?
	
	        var opts = Lib.extendFlat({}, scene.matrixOptions, scene.viewOpts);
	
	        // TODO this is too long for arrayOk attributes!
	        scene.matrix.update(opts, null);
	    }
	};
	
	},{"../../lib":716,"../scatter/colorscale_calc":1121,"../scattergl/convert":1172}],1217:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	exports.getDimIndex = function getDimIndex(trace, ax) {
	    var axId = ax._id;
	    var axLetter = axId.charAt(0);
	    var ind = {x: 0, y: 1}[axLetter];
	    var visibleDims = trace._visibleDims;
	
	    for(var k = 0; k < visibleDims.length; k++) {
	        var i = visibleDims[k];
	        if(trace._diag[i][ind] === axId) return k;
	    }
	    return false;
	};
	
	},{}],1218:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var helpers = _dereq_('./helpers');
	var calcHover = _dereq_('../scattergl/hover').calcHover;
	
	function hoverPoints(pointData, xval, yval) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var scene = pointData.scene;
	    var cdata = scene.matrixOptions.cdata;
	    var xa = pointData.xa;
	    var ya = pointData.ya;
	    var xpx = xa.c2p(xval);
	    var ypx = ya.c2p(yval);
	    var maxDistance = pointData.distance;
	
	    var xi = helpers.getDimIndex(trace, xa);
	    var yi = helpers.getDimIndex(trace, ya);
	    if(xi === false || yi === false) return [pointData];
	
	    var x = cdata[xi];
	    var y = cdata[yi];
	
	    var id, dxy;
	    var minDist = maxDistance;
	
	    for(var i = 0; i < x.length; i++) {
	        var ptx = x[i];
	        var pty = y[i];
	        var dx = xa.c2p(ptx) - xpx;
	        var dy = ya.c2p(pty) - ypx;
	        var dist = Math.sqrt(dx * dx + dy * dy);
	
	        if(dist < minDist) {
	            minDist = dxy = dist;
	            id = i;
	        }
	    }
	
	    pointData.index = id;
	    pointData.distance = minDist;
	    pointData.dxy = dxy;
	
	    if(id === undefined) return [pointData];
	
	    return [calcHover(pointData, x, y, trace)];
	}
	
	module.exports = {
	    hoverPoints: hoverPoints
	};
	
	},{"../scattergl/hover":1176,"./helpers":1217}],1219:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Grid = _dereq_('../../components/grid');
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'splom',
	
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['gl', 'regl', 'cartesian', 'symbols', 'showLegend', 'scatter-like'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	    hoverPoints: _dereq_('./hover').hoverPoints,
	    selectPoints: _dereq_('./select'),
	    editStyle: _dereq_('./edit_style'),
	
	    meta: {
	        
	    }
	};
	
	// splom traces use the 'grid' component to generate their axes,
	// register it here
	Registry.register(Grid);
	
	},{"../../components/grid":633,"../../registry":845,"../scatter/marker_colorbar":1136,"./attributes":1212,"./base_plot":1213,"./calc":1214,"./defaults":1215,"./edit_style":1216,"./hover":1218,"./plot":1220,"./select":1222}],1220:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createMatrix = _dereq_('regl-splom');
	
	var Lib = _dereq_('../../lib');
	var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
	
	module.exports = function plot(gd, _, splomCalcData) {
	    if(!splomCalcData.length) return;
	
	    for(var i = 0; i < splomCalcData.length; i++) {
	        plotOne(gd, splomCalcData[i][0]);
	    }
	};
	
	function plotOne(gd, cd0) {
	    var fullLayout = gd._fullLayout;
	    var gs = fullLayout._size;
	    var trace = cd0.trace;
	    var stash = cd0.t;
	    var scene = fullLayout._splomScenes[trace.uid];
	    var matrixOpts = scene.matrixOptions;
	    var cdata = matrixOpts.cdata;
	    var regl = fullLayout._glcanvas.data()[0].regl;
	    var dragmode = fullLayout.dragmode;
	    var xa, ya;
	    var i, j, k;
	
	    if(cdata.length === 0) return;
	
	    // augment options with proper upper/lower halves
	    // regl-splom's default grid starts from bottom-left
	    matrixOpts.lower = trace.showupperhalf;
	    matrixOpts.upper = trace.showlowerhalf;
	    matrixOpts.diagonal = trace.diagonal.visible;
	
	    var visibleDims = trace._visibleDims;
	    var visibleLength = cdata.length;
	    var viewOpts = scene.viewOpts = {};
	    viewOpts.ranges = new Array(visibleLength);
	    viewOpts.domains = new Array(visibleLength);
	
	    for(k = 0; k < visibleDims.length; k++) {
	        i = visibleDims[k];
	
	        var rng = viewOpts.ranges[k] = new Array(4);
	        var dmn = viewOpts.domains[k] = new Array(4);
	
	        xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	        if(xa) {
	            rng[0] = xa._rl[0];
	            rng[2] = xa._rl[1];
	            dmn[0] = xa.domain[0];
	            dmn[2] = xa.domain[1];
	        }
	
	        ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	        if(ya) {
	            rng[1] = ya._rl[0];
	            rng[3] = ya._rl[1];
	            dmn[1] = ya.domain[0];
	            dmn[3] = ya.domain[1];
	        }
	    }
	
	    viewOpts.viewport = [gs.l, gs.b, gs.w + gs.l, gs.h + gs.b];
	
	    if(scene.matrix === true) {
	        scene.matrix = createMatrix(regl);
	    }
	
	    var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
	    var selectMode = dragmode === 'lasso' || dragmode === 'select' ||
	      !!trace.selectedpoints || clickSelectEnabled;
	    var needsBaseUpdate = true;
	
	    if(selectMode) {
	        var commonLength = trace._length;
	
	        // regenerate scene batch, if traces number changed during selection
	        if(trace.selectedpoints) {
	            scene.selectBatch = trace.selectedpoints;
	
	            var selPts = trace.selectedpoints;
	            var selDict = {};
	            for(i = 0; i < selPts.length; i++) {
	                selDict[selPts[i]] = true;
	            }
	            var unselPts = [];
	            for(i = 0; i < commonLength; i++) {
	                if(!selDict[i]) unselPts.push(i);
	            }
	            scene.unselectBatch = unselPts;
	        }
	
	        // precalculate px coords since we are not going to pan during select
	        var xpx = stash.xpx = new Array(visibleLength);
	        var ypx = stash.ypx = new Array(visibleLength);
	
	        for(k = 0; k < visibleDims.length; k++) {
	            i = visibleDims[k];
	
	            xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	            if(xa) {
	                xpx[k] = new Array(commonLength);
	                for(j = 0; j < commonLength; j++) {
	                    xpx[k][j] = xa.c2p(cdata[k][j]);
	                }
	            }
	
	            ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	            if(ya) {
	                ypx[k] = new Array(commonLength);
	                for(j = 0; j < commonLength; j++) {
	                    ypx[k][j] = ya.c2p(cdata[k][j]);
	                }
	            }
	        }
	
	        if(scene.selectBatch.length || scene.unselectBatch.length) {
	            var unselOpts = Lib.extendFlat({}, matrixOpts, scene.unselectedOptions, viewOpts);
	            var selOpts = Lib.extendFlat({}, matrixOpts, scene.selectedOptions, viewOpts);
	            scene.matrix.update(unselOpts, selOpts);
	            needsBaseUpdate = false;
	        }
	    } else {
	        stash.xpx = stash.ypx = null;
	    }
	
	    if(needsBaseUpdate) {
	        var opts = Lib.extendFlat({}, matrixOpts, viewOpts);
	        scene.matrix.update(opts, null);
	    }
	}
	
	},{"../../lib":716,"../../plots/cartesian/axis_ids":767,"regl-splom":499}],1221:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	module.exports = function sceneUpdate(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var uid = trace.uid;
	
	    // must place ref to 'scene' in fullLayout, so that:
	    // - it can be relinked properly on updates
	    // - it can be destroyed properly when needed
	    var splomScenes = fullLayout._splomScenes;
	    if(!splomScenes) splomScenes = fullLayout._splomScenes = {};
	
	    var reset = {dirty: true};
	
	    var first = {
	        matrix: false,
	        selectBatch: [],
	        unselectBatch: []
	    };
	
	    var scene = splomScenes[trace.uid];
	
	    if(!scene) {
	        scene = splomScenes[uid] = Lib.extendFlat({}, reset, first);
	
	        scene.draw = function draw() {
	            if(scene.matrix && scene.matrix.draw) {
	                if(scene.selectBatch.length || scene.unselectBatch.length) {
	                    scene.matrix.draw(scene.unselectBatch, scene.selectBatch);
	                } else {
	                    scene.matrix.draw();
	                }
	            }
	
	            scene.dirty = false;
	        };
	
	        // remove scene resources
	        scene.destroy = function destroy() {
	            if(scene.matrix && scene.matrix.destroy) {
	                scene.matrix.destroy();
	            }
	            scene.matrixOptions = null;
	            scene.selectBatch = null;
	            scene.unselectBatch = null;
	            scene = null;
	        };
	    }
	
	    // In case if we have scene from the last calc - reset data
	    if(!scene.dirty) {
	        Lib.extendFlat(scene, reset);
	    }
	
	    return scene;
	};
	
	},{"../../lib":716}],1222:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var subTypes = _dereq_('../scatter/subtypes');
	var helpers = _dereq_('./helpers');
	
	module.exports = function select(searchInfo, selectionTester) {
	    var cd = searchInfo.cd;
	    var trace = cd[0].trace;
	    var stash = cd[0].t;
	    var scene = searchInfo.scene;
	    var cdata = scene.matrixOptions.cdata;
	    var xa = searchInfo.xaxis;
	    var ya = searchInfo.yaxis;
	    var selection = [];
	
	    if(!scene) return selection;
	
	    var hasOnlyLines = (!subTypes.hasMarkers(trace) && !subTypes.hasText(trace));
	    if(trace.visible !== true || hasOnlyLines) return selection;
	
	    var xi = helpers.getDimIndex(trace, xa);
	    var yi = helpers.getDimIndex(trace, ya);
	    if(xi === false || yi === false) return selection;
	
	    var xpx = stash.xpx[xi];
	    var ypx = stash.ypx[yi];
	    var x = cdata[xi];
	    var y = cdata[yi];
	    var els = [];
	    var unels = [];
	
	    // degenerate polygon does not enable selection
	    // filter out points by visible scatter ones
	    if(selectionTester !== false && !selectionTester.degenerate) {
	        for(var i = 0; i < x.length; i++) {
	            if(selectionTester.contains([xpx[i], ypx[i]], null, i, searchInfo)) {
	                els.push(i);
	                selection.push({
	                    pointNumber: i,
	                    x: x[i],
	                    y: y[i]
	                });
	            } else {
	                unels.push(i);
	            }
	        }
	    }
	
	    var matrixOpts = scene.matrixOptions;
	
	    if(!els.length && !unels.length) {
	        scene.matrix.update(matrixOpts, null);
	    } else if(!scene.selectBatch.length && !scene.unselectBatch.length) {
	        scene.matrix.update(
	            scene.unselectedOptions,
	            Lib.extendFlat({}, matrixOpts, scene.selectedOptions, scene.viewOpts)
	        );
	    }
	
	    scene.selectBatch = els;
	    scene.unselectBatch = unels;
	
	    return selection;
	};
	
	},{"../../lib":716,"../scatter/subtypes":1142,"./helpers":1217}],1223:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var mesh3dAttrs = _dereq_('../mesh3d/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	var attrs = {
	    x: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    y: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	    z: {
	        valType: 'data_array',
	        
	        editType: 'calc+clearAxisTypes',
	        
	    },
	
	    u: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    v: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    w: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    starts: {
	        x: {
	            valType: 'data_array',
	            editType: 'calc',
	            
	        },
	        y: {
	            valType: 'data_array',
	            editType: 'calc',
	            
	        },
	        z: {
	            valType: 'data_array',
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    },
	
	    maxdisplayed: {
	        valType: 'integer',
	        min: 0,
	        dflt: 1000,
	        
	        editType: 'calc',
	        
	    },
	
	    // TODO
	    //
	    // Should add 'absolute' (like cone traces have), but currently gl-streamtube3d's
	    // `absoluteTubeSize` doesn't behave well enough for our needs.
	    //
	    // 'fixed' would be a nice addition to plot stream 'lines', see
	    // https://github.com/plotly/plotly.js/commit/812be20750e21e0a1831975001c248d365850f73#r29129877
	    //
	    // sizemode: {
	    //     valType: 'enumerated',
	    //     values: ['scaled', 'absolute', 'fixed'],
	    //     dflt: 'scaled',
	    //     
	    //     editType: 'calc',
	    //     
	    // },
	
	    sizeref: {
	        valType: 'number',
	        
	        editType: 'calc',
	        min: 0,
	        dflt: 1,
	        
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	    hovertemplate: hovertemplateAttrs({editType: 'calc'}, {
	        keys: [
	            'tubex', 'tubey', 'tubez',
	            'tubeu', 'tubev', 'tubew',
	            'norm', 'divergence'
	        ]
	    })
	};
	
	extendFlat(attrs, colorScaleAttrs('', {
	    colorAttr: 'u/v/w norm',
	    showScaleDflt: true,
	    editTypeOverride: 'calc'
	}));
	
	var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
	fromMesh3d.forEach(function(k) {
	    attrs[k] = mesh3dAttrs[k];
	});
	
	attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
	    editType: 'calc',
	    flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'divergence', 'text', 'name'],
	    dflt: 'x+y+z+norm+text+name'
	});
	
	attrs.transforms = undefined;
	
	module.exports = attrs;
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../mesh3d/attributes":1059}],1224:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	
	module.exports = function calc(gd, trace) {
	    var i, j, k;
	
	    var u = trace.u;
	    var v = trace.v;
	    var w = trace.w;
	    var x = trace.x;
	    var y = trace.y;
	    var z = trace.z;
	    var len = Math.min(x.length, y.length, z.length, u.length, v.length, w.length);
	
	    var slen = 0;
	    var startx, starty, startz;
	    if(trace.starts) {
	        startx = trace.starts.x || [];
	        starty = trace.starts.y || [];
	        startz = trace.starts.z || [];
	        slen = Math.min(startx.length, starty.length, startz.length);
	    }
	
	    var normMax = 0;
	    var normMin = Infinity;
	
	    for(i = 0; i < len; i++) {
	        var uu = u[i];
	        var vv = v[i];
	        var ww = w[i];
	        var norm = Math.sqrt(uu * uu + vv * vv + ww * ww);
	
	        normMax = Math.max(normMax, norm);
	        normMin = Math.min(normMin, norm);
	    }
	
	    colorscaleCalc(gd, trace, {
	        vals: [normMin, normMax],
	        containerStr: '',
	        cLetter: 'c'
	    });
	
	    var xMax = -Infinity;
	    var xMin = Infinity;
	    var yMax = -Infinity;
	    var yMin = Infinity;
	    var zMax = -Infinity;
	    var zMin = Infinity;
	
	    var gridFill = '';
	    var filledX;
	    var filledY;
	    var filledZ;
	    var firstX;
	    var firstY;
	    var firstZ;
	    if(len) {
	        firstX = x[0];
	        firstY = y[0];
	        firstZ = z[0];
	    }
	
	    for(i = 0; i < len; i++) {
	        xMax = Math.max(xMax, x[i]);
	        xMin = Math.min(xMin, x[i]);
	
	        yMax = Math.max(yMax, y[i]);
	        yMin = Math.min(yMin, y[i]);
	
	        zMax = Math.max(zMax, z[i]);
	        zMin = Math.min(zMin, z[i]);
	
	        if(!filledX && x[i] !== firstX) {
	            filledX = true;
	            gridFill += 'x';
	        }
	        if(!filledY && y[i] !== firstY) {
	            filledY = true;
	            gridFill += 'y';
	        }
	        if(!filledZ && z[i] !== firstZ) {
	            filledZ = true;
	            gridFill += 'z';
	        }
	    }
	    // fill if not filled - case of having dimension(s) with one item
	    if(!filledX) gridFill += 'x';
	    if(!filledY) gridFill += 'y';
	    if(!filledZ) gridFill += 'z';
	
	    var Xs = distinctVals(trace.x.slice(0, len));
	    var Ys = distinctVals(trace.y.slice(0, len));
	    var Zs = distinctVals(trace.z.slice(0, len));
	
	    gridFill = gridFill.replace('x', (x[0] > x[len - 1] ? '-' : '+') + 'x');
	    gridFill = gridFill.replace('y', (y[0] > y[len - 1] ? '-' : '+') + 'y');
	    gridFill = gridFill.replace('z', (z[0] > z[len - 1] ? '-' : '+') + 'z');
	
	    var empty = function() {
	        len = 0;
	        Xs = [];
	        Ys = [];
	        Zs = [];
	    };
	
	    // Over-specified mesh case, this would error in tube2mesh
	    if(!len || len < Xs.length * Ys.length * Zs.length) empty();
	
	    var getArray = function(c) { return c === 'x' ? x : c === 'y' ? y : z; };
	    var getVals = function(c) { return c === 'x' ? Xs : c === 'y' ? Ys : Zs; };
	    var getDir = function(c) { return (c[len - 1] < c[0]) ? -1 : 1; };
	
	    var arrK = getArray(gridFill[1]);
	    var arrJ = getArray(gridFill[3]);
	    var arrI = getArray(gridFill[5]);
	    var nk = getVals(gridFill[1]).length;
	    var nj = getVals(gridFill[3]).length;
	    var ni = getVals(gridFill[5]).length;
	
	    var arbitrary = false;
	
	    var getIndex = function(_i, _j, _k) {
	        return nk * (nj * _i + _j) + _k;
	    };
	
	    var dirK = getDir(getArray(gridFill[1]));
	    var dirJ = getDir(getArray(gridFill[3]));
	    var dirI = getDir(getArray(gridFill[5]));
	
	    for(i = 0; i < ni - 1; i++) {
	        for(j = 0; j < nj - 1; j++) {
	            for(k = 0; k < nk - 1; k++) {
	                var q000 = getIndex(i, j, k);
	                var q001 = getIndex(i, j, k + 1);
	                var q010 = getIndex(i, j + 1, k);
	                var q100 = getIndex(i + 1, j, k);
	
	                if(
	                    !(arrK[q000] * dirK < arrK[q001] * dirK) ||
	                    !(arrJ[q000] * dirJ < arrJ[q010] * dirJ) ||
	                    !(arrI[q000] * dirI < arrI[q100] * dirI)
	                ) {
	                    arbitrary = true;
	                }
	
	                if(arbitrary) break;
	            }
	            if(arbitrary) break;
	        }
	        if(arbitrary) break;
	    }
	
	    if(arbitrary) {
	        Lib.warn('Encountered arbitrary coordinates! Unable to input data grid.');
	        empty();
	    }
	
	    for(i = 0; i < slen; i++) {
	        var sx = startx[i];
	        xMax = Math.max(xMax, sx);
	        xMin = Math.min(xMin, sx);
	
	        var sy = starty[i];
	        yMax = Math.max(yMax, sy);
	        yMin = Math.min(yMin, sy);
	
	        var sz = startz[i];
	        zMax = Math.max(zMax, sz);
	        zMin = Math.min(zMin, sz);
	    }
	
	    trace._len = len;
	    trace._slen = slen;
	    trace._normMax = normMax;
	    trace._xbnds = [xMin, xMax];
	    trace._ybnds = [yMin, yMax];
	    trace._zbnds = [zMin, zMax];
	    trace._Xs = Xs;
	    trace._Ys = Ys;
	    trace._Zs = Zs;
	    trace._gridFill = gridFill;
	};
	
	function distinctVals(col) {
	    return Lib.distinctVals(col).vals;
	}
	
	},{"../../components/colorscale/calc":599,"../../lib":716}],1225:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var tube2mesh = _dereq_('gl-streamtube3d');
	var createTubeMesh = tube2mesh.createTubeMesh;
	
	var Lib = _dereq_('../../lib');
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var zip3 = _dereq_('../../plots/gl3d/zip3');
	
	var axisName2scaleIndex = {xaxis: 0, yaxis: 1, zaxis: 2};
	
	function Streamtube(scene, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.mesh = null;
	    this.data = null;
	}
	
	var proto = Streamtube.prototype;
	
	proto.handlePick = function(selection) {
	    var sceneLayout = this.scene.fullSceneLayout;
	    var dataScale = this.scene.dataScale;
	
	    function fromDataScale(v, axisName) {
	        var ax = sceneLayout[axisName];
	        var scale = dataScale[axisName2scaleIndex[axisName]];
	        return ax.l2c(v) / scale;
	    }
	
	    if(selection.object === this.mesh) {
	        var pos = selection.data.position;
	        var uvx = selection.data.velocity;
	
	        selection.traceCoordinate = [
	            fromDataScale(pos[0], 'xaxis'),
	            fromDataScale(pos[1], 'yaxis'),
	            fromDataScale(pos[2], 'zaxis'),
	
	            fromDataScale(uvx[0], 'xaxis'),
	            fromDataScale(uvx[1], 'yaxis'),
	            fromDataScale(uvx[2], 'zaxis'),
	
	            // u/v/w norm
	            selection.data.intensity * this.data._normMax,
	            // divergence
	            selection.data.divergence
	        ];
	
	        selection.textLabel = this.data.hovertext || this.data.text;
	
	        return true;
	    }
	};
	
	function getDfltStartingPositions(vec) {
	    var len = vec.length;
	    var s;
	
	    if(len > 2) {
	        s = vec.slice(1, len - 1);
	    } else if(len === 2) {
	        s = [(vec[0] + vec[1]) / 2];
	    } else {
	        s = vec;
	    }
	    return s;
	}
	
	function getBoundPads(vec) {
	    var len = vec.length;
	    if(len === 1) {
	        return [0.5, 0.5];
	    } else {
	        return [vec[1] - vec[0], vec[len - 1] - vec[len - 2]];
	    }
	}
	
	function convert(scene, trace) {
	    var sceneLayout = scene.fullSceneLayout;
	    var dataScale = scene.dataScale;
	    var len = trace._len;
	    var tubeOpts = {};
	
	    function toDataCoords(arr, axisName) {
	        var ax = sceneLayout[axisName];
	        var scale = dataScale[axisName2scaleIndex[axisName]];
	        return Lib.simpleMap(arr, function(v) { return ax.d2l(v) * scale; });
	    }
	
	    tubeOpts.vectors = zip3(
	        toDataCoords(trace.u, 'xaxis'),
	        toDataCoords(trace.v, 'yaxis'),
	        toDataCoords(trace.w, 'zaxis'),
	        len
	    );
	
	    // Over-specified mesh case, this would error in tube2mesh
	    if(!len) {
	        return {
	            positions: [],
	            cells: []
	        };
	    }
	
	    var meshx = toDataCoords(trace._Xs, 'xaxis');
	    var meshy = toDataCoords(trace._Ys, 'yaxis');
	    var meshz = toDataCoords(trace._Zs, 'zaxis');
	
	    tubeOpts.meshgrid = [meshx, meshy, meshz];
	    tubeOpts.gridFill = trace._gridFill;
	
	    var slen = trace._slen;
	    if(slen) {
	        tubeOpts.startingPositions = zip3(
	            toDataCoords(trace.starts.x.slice(0, slen), 'xaxis'),
	            toDataCoords(trace.starts.y.slice(0, slen), 'yaxis'),
	            toDataCoords(trace.starts.z.slice(0, slen), 'zaxis')
	        );
	    } else {
	        // Default starting positions:
	        //
	        // if len>2, cut xz plane at min-y,
	        // takes all x/y/z pts on that plane except those on the edges
	        // to generate "well-defined" tubes,
	        //
	        // if len=2, take position halfway between two the pts,
	        //
	        // if len=1, take that pt
	        var sy0 = meshy[0];
	        var sx = getDfltStartingPositions(meshx);
	        var sz = getDfltStartingPositions(meshz);
	        var startingPositions = new Array(sx.length * sz.length);
	        var m = 0;
	
	        for(var i = 0; i < sx.length; i++) {
	            for(var k = 0; k < sz.length; k++) {
	                startingPositions[m++] = [sx[i], sy0, sz[k]];
	            }
	        }
	        tubeOpts.startingPositions = startingPositions;
	    }
	
	    tubeOpts.colormap = parseColorScale(trace);
	    tubeOpts.tubeSize = trace.sizeref;
	    tubeOpts.maxLength = trace.maxdisplayed;
	
	    // add some padding around the bounds
	    // to e.g. allow tubes starting from a slice of the x/y/z mesh
	    // to go beyond bounds a little bit w/o getting clipped
	    var xbnds = toDataCoords(trace._xbnds, 'xaxis');
	    var ybnds = toDataCoords(trace._ybnds, 'yaxis');
	    var zbnds = toDataCoords(trace._zbnds, 'zaxis');
	    var xpads = getBoundPads(meshx);
	    var ypads = getBoundPads(meshy);
	    var zpads = getBoundPads(meshz);
	
	    var bounds = [
	        [xbnds[0] - xpads[0], ybnds[0] - ypads[0], zbnds[0] - zpads[0]],
	        [xbnds[1] + xpads[1], ybnds[1] + ypads[1], zbnds[1] + zpads[1]]
	    ];
	
	    var meshData = tube2mesh(tubeOpts, bounds);
	
	    // N.B. cmin/cmax correspond to the min/max vector norm
	    // in the u/v/w arrays, which in general is NOT equal to max
	    // intensity that colors the tubes.
	    var cOpts = extractOpts(trace);
	    meshData.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
	
	    // pass gl-mesh3d lighting attributes
	    var lp = trace.lightposition;
	    meshData.lightPosition = [lp.x, lp.y, lp.z];
	    meshData.ambient = trace.lighting.ambient;
	    meshData.diffuse = trace.lighting.diffuse;
	    meshData.specular = trace.lighting.specular;
	    meshData.roughness = trace.lighting.roughness;
	    meshData.fresnel = trace.lighting.fresnel;
	    meshData.opacity = trace.opacity;
	
	    // stash autorange pad value
	    trace._pad = meshData.tubeScale * trace.sizeref * 2;
	
	    return meshData;
	}
	
	proto.update = function(data) {
	    this.data = data;
	
	    var meshData = convert(this.scene, data);
	    this.mesh.update(meshData);
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.mesh);
	    this.mesh.dispose();
	};
	
	function createStreamtubeTrace(scene, data) {
	    var gl = scene.glplot.gl;
	
	    var meshData = convert(scene, data);
	    var mesh = createTubeMesh(gl, meshData);
	
	    var streamtube = new Streamtube(scene, data.uid);
	    streamtube.mesh = mesh;
	    streamtube.data = data;
	    mesh._trace = streamtube;
	
	    scene.glplot.add(mesh);
	
	    return streamtube;
	}
	
	module.exports = createStreamtubeTrace;
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gl_format_color":713,"../../plots/gl3d/zip3":815,"gl-streamtube3d":314}],1226:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var u = coerce('u');
	    var v = coerce('v');
	    var w = coerce('w');
	
	    var x = coerce('x');
	    var y = coerce('y');
	    var z = coerce('z');
	
	    if(
	        !u || !u.length || !v || !v.length || !w || !w.length ||
	        !x || !x.length || !y || !y.length || !z || !z.length
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('starts.x');
	    coerce('starts.y');
	    coerce('starts.z');
	
	    coerce('maxdisplayed');
	    coerce('sizeref');
	
	    coerce('lighting.ambient');
	    coerce('lighting.diffuse');
	    coerce('lighting.specular');
	    coerce('lighting.roughness');
	    coerce('lighting.fresnel');
	    coerce('lightposition.x');
	    coerce('lightposition.y');
	    coerce('lightposition.z');
	
	    colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    // disable 1D transforms (for now)
	    // x/y/z and u/v/w have matching lengths,
	    // but they don't have to match with starts.(x|y|z)
	    traceOut._length = null;
	};
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"./attributes":1223}],1227:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'streamtube',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d'],
	
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./convert'),
	    eventData: function(out, pt) {
	        out.tubex = out.x;
	        out.tubey = out.y;
	        out.tubez = out.z;
	
	        out.tubeu = pt.traceCoordinate[3];
	        out.tubev = pt.traceCoordinate[4];
	        out.tubew = pt.traceCoordinate[5];
	
	        out.norm = pt.traceCoordinate[6];
	        out.divergence = pt.traceCoordinate[7];
	
	        // Does not correspond to input x/y/z, so delete them
	        delete out.x;
	        delete out.y;
	        delete out.z;
	
	        return out;
	    },
	
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"./attributes":1223,"./calc":1224,"./convert":1225,"./defaults":1226}],1228:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var baseAttrs = _dereq_('../../plots/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var pieAttrs = _dereq_('../pie/attributes');
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    labels: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    parents: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	
	    values: {
	        valType: 'data_array',
	        editType: 'calc',
	        
	    },
	    branchvalues: {
	        valType: 'enumerated',
	        values: ['remainder', 'total'],
	        dflt: 'remainder',
	        editType: 'calc',
	        
	        
	    },
	    count: {
	        valType: 'flaglist',
	        flags: [
	            'branches',
	            'leaves'
	        ],
	        dflt: 'leaves',
	        editType: 'calc',
	        
	        
	    },
	
	    level: {
	        valType: 'any',
	        editType: 'plot',
	        anim: true,
	        
	        
	    },
	    maxdepth: {
	        valType: 'integer',
	        editType: 'plot',
	        
	        dflt: -1,
	        
	    },
	
	    marker: extendFlat({
	        colors: {
	            valType: 'data_array',
	            editType: 'calc',
	            
	        },
	
	        // colorinheritance: {
	        //     valType: 'enumerated',
	        //     values: ['per-branch', 'per-label', false]
	        // },
	
	        line: {
	            color: extendFlat({}, pieAttrs.marker.line.color, {
	                dflt: null,
	                
	            }),
	            width: extendFlat({}, pieAttrs.marker.line.width, {dflt: 1}),
	            editType: 'calc'
	        },
	        editType: 'calc'
	    },
	        colorScaleAttrs('marker', {
	            colorAttr: 'colors',
	            anim: false // TODO: set to anim: true?
	        })
	    ),
	
	    leaf: {
	        opacity: {
	            valType: 'number',
	            editType: 'style',
	            
	            min: 0,
	            max: 1,
	            
	        },
	        editType: 'plot'
	    },
	
	    text: pieAttrs.text,
	    textinfo: {
	        valType: 'flaglist',
	        
	        flags: [
	            'label',
	            'text',
	            'value',
	            'current path',
	            'percent root',
	            'percent entry',
	            'percent parent'
	        ],
	        extras: ['none'],
	        editType: 'plot',
	        
	    },
	
	    // TODO: incorporate `label` and `value` in the eventData
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: constants.eventDataKeys.concat(['label', 'value'])
	    }),
	
	    hovertext: pieAttrs.hovertext,
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: [
	            'label',
	            'text',
	            'value',
	            'name',
	            'current path',
	            'percent root',
	            'percent entry',
	            'percent parent'
	        ],
	        dflt: 'label+text+value+name'
	    }),
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    textfont: pieAttrs.textfont,
	    insidetextfont: pieAttrs.insidetextfont,
	    outsidetextfont: pieAttrs.outsidetextfont,
	
	    domain: domainAttrs({name: 'sunburst', trace: true, editType: 'calc'})
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/domain":789,"../../plots/template_attributes":840,"../pie/attributes":1092,"./constants":1231}],1229:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var plots = _dereq_('../../plots/plots');
	
	exports.name = 'sunburst';
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	};
	
	},{"../../plots/plots":825}],1230:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3Hierarchy = _dereq_('d3-hierarchy');
	var isNumeric = _dereq_('fast-isnumeric');
	
	var Lib = _dereq_('../../lib');
	var makeColorScaleFn = _dereq_('../../components/colorscale').makeColorScaleFuncFromTrace;
	var makePullColorFn = _dereq_('../pie/calc').makePullColorFn;
	var generateExtendedColors = _dereq_('../pie/calc').generateExtendedColors;
	var colorscaleCalc = _dereq_('../../components/colorscale').calc;
	
	var sunburstExtendedColorWays = {};
	var treemapExtendedColorWays = {};
	
	exports.calc = function(gd, trace) {
	    var fullLayout = gd._fullLayout;
	    var ids = trace.ids;
	    var hasIds = Lib.isArrayOrTypedArray(ids);
	    var labels = trace.labels;
	    var parents = trace.parents;
	    var values = trace.values;
	    var hasValues = Lib.isArrayOrTypedArray(values);
	    var cd = [];
	
	    var parent2children = {};
	    var refs = {};
	    var addToLookup = function(parent, v) {
	        if(parent2children[parent]) parent2children[parent].push(v);
	        else parent2children[parent] = [v];
	        refs[v] = 1;
	    };
	
	    // treat number `0` as valid
	    var isValidKey = function(k) {
	        return k || typeof k === 'number';
	    };
	
	    var isValidVal = function(i) {
	        return !hasValues || (isNumeric(values[i]) && values[i] >= 0);
	    };
	
	    var len;
	    var isValid;
	    var getId;
	
	    if(hasIds) {
	        len = Math.min(ids.length, parents.length);
	        isValid = function(i) { return isValidKey(ids[i]) && isValidVal(i); };
	        getId = function(i) { return String(ids[i]); };
	    } else {
	        len = Math.min(labels.length, parents.length);
	        isValid = function(i) { return isValidKey(labels[i]) && isValidVal(i); };
	        // TODO We could allow some label / parent duplication
	        //
	        // From AJ:
	        //  It would work OK for one level
	        //  (multiple rows with the same name and different parents -
	        //  or even the same parent) but if that name is then used as a parent
	        //  which one is it?
	        getId = function(i) { return String(labels[i]); };
	    }
	
	    if(hasValues) len = Math.min(len, values.length);
	
	    for(var i = 0; i < len; i++) {
	        if(isValid(i)) {
	            var id = getId(i);
	            var pid = isValidKey(parents[i]) ? String(parents[i]) : '';
	
	            var cdi = {
	                i: i,
	                id: id,
	                pid: pid,
	                label: isValidKey(labels[i]) ? String(labels[i]) : ''
	            };
	
	            if(hasValues) cdi.v = +values[i];
	            cd.push(cdi);
	            addToLookup(pid, id);
	        }
	    }
	
	    if(!parent2children['']) {
	        var impliedRoots = [];
	        var k;
	        for(k in parent2children) {
	            if(!refs[k]) {
	                impliedRoots.push(k);
	            }
	        }
	
	        // if an `id` has no ref in the `parents` array,
	        // take it as being the root node
	
	        if(impliedRoots.length === 1) {
	            k = impliedRoots[0];
	            cd.unshift({
	                hasImpliedRoot: true,
	                id: k,
	                pid: '',
	                label: k
	            });
	        } else {
	            return Lib.warn('Multiple implied roots, cannot build ' + trace.type + ' hierarchy.');
	        }
	    } else if(parent2children[''].length > 1) {
	        var dummyId = Lib.randstr();
	
	        // if multiple rows linked to the root node,
	        // add dummy "root of roots" node to make d3 build the hierarchy successfully
	
	        for(var j = 0; j < cd.length; j++) {
	            if(cd[j].pid === '') {
	                cd[j].pid = dummyId;
	            }
	        }
	
	        cd.unshift({
	            hasMultipleRoots: true,
	            id: dummyId,
	            pid: '',
	            label: ''
	        });
	    }
	
	    // TODO might be better to replace stratify() with our own algorithm
	    var root;
	    try {
	        root = d3Hierarchy.stratify()
	            .id(function(d) { return d.id; })
	            .parentId(function(d) { return d.pid; })(cd);
	    } catch(e) {
	        return Lib.warn('Failed to build ' + trace.type + ' hierarchy. Error: ' + e.message);
	    }
	
	    var hierarchy = d3Hierarchy.hierarchy(root);
	    var failed = false;
	
	    if(hasValues) {
	        switch(trace.branchvalues) {
	            case 'remainder':
	                hierarchy.sum(function(d) { return d.data.v; });
	                break;
	            case 'total':
	                hierarchy.each(function(d) {
	                    var cdi = d.data.data;
	                    var v = cdi.v;
	
	                    if(d.children) {
	                        var partialSum = d.children.reduce(function(a, c) {
	                            return a + c.data.data.v;
	                        }, 0);
	
	                        // N.B. we must fill in `value` for generated sectors
	                        // with the partialSum to compute the correct partition
	                        if(cdi.hasImpliedRoot || cdi.hasMultipleRoots) {
	                            v = partialSum;
	                        }
	
	                        if(v < partialSum) {
	                            failed = true;
	                            return Lib.warn([
	                                'Total value for node', d.data.data.id,
	                                'is smaller than the sum of its children.',
	                                '\nparent value =', v,
	                                '\nchildren sum =', partialSum
	                            ].join(' '));
	                        }
	                    }
	
	                    d.value = v;
	                });
	                break;
	        }
	    } else {
	        countDescendants(hierarchy, trace, {
	            branches: trace.count.indexOf('branches') !== -1,
	            leaves: trace.count.indexOf('leaves') !== -1
	        });
	    }
	
	    if(failed) return;
	
	    // TODO add way to sort by height also?
	    hierarchy.sort(function(a, b) { return b.value - a.value; });
	
	    var pullColor;
	    var scaleColor;
	    var colors = trace.marker.colors || [];
	    var hasColors = !!colors.length;
	
	    if(trace._hasColorscale) {
	        if(!hasColors) {
	            colors = hasValues ? trace.values : trace._values;
	        }
	
	        colorscaleCalc(gd, trace, {
	            vals: colors,
	            containerStr: 'marker',
	            cLetter: 'c'
	        });
	
	        scaleColor = makeColorScaleFn(trace.marker);
	    } else {
	        pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
	    }
	
	    // TODO keep track of 'root-children' (i.e. branch) for hover info etc.
	
	    hierarchy.each(function(d) {
	        var cdi = d.data.data;
	        // N.B. this mutates items in `cd`
	        cdi.color = trace._hasColorscale ?
	            scaleColor(colors[cdi.i]) :
	            pullColor(colors[cdi.i], cdi.id);
	    });
	
	    cd[0].hierarchy = hierarchy;
	
	    return cd;
	};
	
	/*
	 * `calc` filled in (and collated) explicit colors.
	 * Now we need to propagate these explicit colors to other traces,
	 * and fill in default colors.
	 * This is done after sorting, so we pick defaults
	 * in the order slices will be displayed
	 */
	exports._runCrossTraceCalc = function(desiredType, gd) {
	    var fullLayout = gd._fullLayout;
	    var calcdata = gd.calcdata;
	    var colorWay = fullLayout[desiredType + 'colorway'];
	    var colorMap = fullLayout['_' + desiredType + 'colormap'];
	
	    if(fullLayout['extend' + desiredType + 'colors']) {
	        colorWay = generateExtendedColors(colorWay,
	            desiredType === 'treemap' ? treemapExtendedColorWays : sunburstExtendedColorWays
	        );
	    }
	    var dfltColorCount = 0;
	
	    function pickColor(d) {
	        var cdi = d.data.data;
	        var id = cdi.id;
	
	        if(cdi.color === false) {
	            if(colorMap[id]) {
	                // have we seen this label and assigned a color to it in a previous trace?
	                cdi.color = colorMap[id];
	            } else if(d.parent) {
	                if(d.parent.parent) {
	                    // from third-level on, inherit from parent
	                    cdi.color = d.parent.data.data.color;
	                } else {
	                    // pick new color for second level
	                    colorMap[id] = cdi.color = colorWay[dfltColorCount % colorWay.length];
	                    dfltColorCount++;
	                }
	            } else {
	                // root gets no coloring by default
	                cdi.color = 'rgba(0,0,0,0)';
	            }
	        }
	    }
	
	    for(var i = 0; i < calcdata.length; i++) {
	        var cd = calcdata[i];
	        var cd0 = cd[0];
	        if(cd0.trace.type === desiredType && cd0.hierarchy) {
	            cd0.hierarchy.each(pickColor);
	        }
	    }
	};
	
	exports.crossTraceCalc = function(gd) {
	    return exports._runCrossTraceCalc('sunburst', gd);
	};
	
	function countDescendants(node, trace, opts) {
	    var nChild = 0;
	
	    var children = node.children;
	    if(children) {
	        var len = children.length;
	
	        for(var i = 0; i < len; i++) {
	            nChild += countDescendants(children[i], trace, opts);
	        }
	
	        if(opts.branches) nChild++; // count this branch
	    } else {
	        if(opts.leaves) nChild++; // count this leaf
	    }
	
	    // save to the node
	    node.value = node.data.data.value = nChild;
	
	    // save to the trace
	    if(!trace._values) trace._values = [];
	    trace._values[node.data.data.i] = nChild;
	
	    return nChild;
	}
	
	},{"../../components/colorscale":603,"../../lib":716,"../pie/calc":1094,"d3-hierarchy":158,"fast-isnumeric":227}],1231:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    CLICK_TRANSITION_TIME: 750,
	    CLICK_TRANSITION_EASING: 'linear',
	    eventDataKeys: [
	        // string
	        'currentPath',
	        'root',
	        'entry',
	        // no need to add 'parent' here
	
	        // percentages i.e. ratios
	        'percentRoot',
	        'percentEntry',
	        'percentParent'
	    ]
	};
	
	},{}],1232:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	
	var Colorscale = _dereq_('../../components/colorscale');
	var hasColorscale = Colorscale.hasColorscale;
	var colorscaleDefaults = Colorscale.handleDefaults;
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var labels = coerce('labels');
	    var parents = coerce('parents');
	
	    if(!labels || !labels.length || !parents || !parents.length) {
	        traceOut.visible = false;
	        return;
	    }
	
	    var vals = coerce('values');
	    if(vals && vals.length) {
	        coerce('branchvalues');
	    } else {
	        coerce('count');
	    }
	
	    coerce('level');
	    coerce('maxdepth');
	
	    var lineWidth = coerce('marker.line.width');
	    if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
	
	    coerce('marker.colors');
	    var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, 'marker', 'colors');
	    if(withColorscale) {
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
	    }
	
	    coerce('leaf.opacity', withColorscale ? 1 : 0.7);
	
	    var text = coerce('text');
	    coerce('texttemplate');
	    if(!traceOut.texttemplate) coerce('textinfo', Array.isArray(text) ? 'text+label' : 'label');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var textposition = 'auto';
	    handleText(traceIn, traceOut, layout, coerce, textposition, {
	        moduleHasSelected: false,
	        moduleHasUnselected: false,
	        moduleHasConstrain: false,
	        moduleHasCliponaxis: false,
	        moduleHasTextangle: false,
	        moduleHasInsideanchor: false
	    });
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    // do not support transforms for now
	    traceOut._length = null;
	};
	
	},{"../../components/colorscale":603,"../../lib":716,"../../plots/domain":789,"../bar/defaults":859,"./attributes":1228}],1233:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Registry = _dereq_('../../registry');
	var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
	var Fx = _dereq_('../../components/fx');
	var Lib = _dereq_('../../lib');
	var Events = _dereq_('../../lib/events');
	
	var helpers = _dereq_('./helpers');
	var pieHelpers = _dereq_('../pie/helpers');
	
	var formatValue = pieHelpers.formatPieValue;
	
	module.exports = function attachFxHandlers(sliceTop, entry, gd, cd, opts) {
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var hierarchy = cd0.hierarchy;
	
	    var isSunburst = trace.type === 'sunburst';
	    var isTreemap = trace.type === 'treemap';
	
	    // hover state vars
	    // have we drawn a hover label, so it should be cleared later
	    if(!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
	    // have we emitted a hover event, so later an unhover event should be emitted
	    // note that click events do not depend on this - you can still get them
	    // with hovermode: false or if you were earlier dragging, then clicked
	    // in the same slice that you moused up in
	    if(!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
	
	    var onMouseOver = function(pt) {
	        var fullLayoutNow = gd._fullLayout;
	
	        if(gd._dragging || fullLayoutNow.hovermode === false) return;
	
	        var traceNow = gd._fullData[trace.index];
	        var cdi = pt.data.data;
	        var ptNumber = cdi.i;
	        var isRoot = helpers.isHierarchyRoot(pt);
	        var parent = helpers.getParent(hierarchy, pt);
	
	        var val = helpers.getValue(pt);
	
	        var _cast = function(astr) {
	            return Lib.castOption(traceNow, ptNumber, astr);
	        };
	
	        var hovertemplate = _cast('hovertemplate');
	        var hoverinfo = Fx.castHoverinfo(traceNow, fullLayoutNow, ptNumber);
	        var separators = fullLayoutNow.separators;
	
	        if(hovertemplate || (hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip')) {
	            var hoverCenterX;
	            var hoverCenterY;
	            if(isSunburst) {
	                hoverCenterX = cd0.cx + pt.pxmid[0] * (1 - pt.rInscribed);
	                hoverCenterY = cd0.cy + pt.pxmid[1] * (1 - pt.rInscribed);
	            }
	            if(isTreemap) {
	                hoverCenterX = pt._hoverX;
	                hoverCenterY = pt._hoverY;
	            }
	
	            var hoverPt = {};
	            var parts = [];
	            var thisText = [];
	            var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
	
	            if(hoverinfo) {
	                parts = hoverinfo === 'all' ?
	                    traceNow._module.attributes.hoverinfo.flags :
	                    hoverinfo.split('+');
	            }
	
	            hoverPt.label = cdi.label;
	            if(hasFlag('label') && hoverPt.label) thisText.push(hoverPt.label);
	
	            if(cdi.hasOwnProperty('v')) {
	                hoverPt.value = cdi.v;
	                hoverPt.valueLabel = formatValue(hoverPt.value, separators);
	                if(hasFlag('value')) thisText.push(hoverPt.valueLabel);
	            }
	
	            hoverPt.currentPath = pt.currentPath = helpers.getPath(pt.data);
	            if(hasFlag('current path') && !isRoot) {
	                thisText.push(hoverPt.currentPath);
	            }
	
	            var tx;
	            var allPercents = [];
	            var insertPercent = function() {
	                if(allPercents.indexOf(tx) === -1) { // no need to add redundant info
	                    thisText.push(tx);
	                    allPercents.push(tx);
	                }
	            };
	
	            hoverPt.percentParent = pt.percentParent = val / helpers.getValue(parent);
	            hoverPt.parent = pt.parentString = helpers.getPtLabel(parent);
	            if(hasFlag('percent parent')) {
	                tx = helpers.formatPercent(hoverPt.percentParent, separators) + ' of ' + hoverPt.parent;
	                insertPercent();
	            }
	
	            hoverPt.percentEntry = pt.percentEntry = val / helpers.getValue(entry);
	            hoverPt.entry = pt.entry = helpers.getPtLabel(entry);
	            if(hasFlag('percent entry') && !isRoot && !pt.onPathbar) {
	                tx = helpers.formatPercent(hoverPt.percentEntry, separators) + ' of ' + hoverPt.entry;
	                insertPercent();
	            }
	
	            hoverPt.percentRoot = pt.percentRoot = val / helpers.getValue(hierarchy);
	            hoverPt.root = pt.root = helpers.getPtLabel(hierarchy);
	            if(hasFlag('percent root') && !isRoot) {
	                tx = helpers.formatPercent(hoverPt.percentRoot, separators) + ' of ' + hoverPt.root;
	                insertPercent();
	            }
	
	            hoverPt.text = _cast('hovertext') || _cast('text');
	            if(hasFlag('text')) {
	                tx = hoverPt.text;
	                if(Lib.isValidTextValue(tx)) thisText.push(tx);
	            }
	
	            var hoverItems = {
	                trace: traceNow,
	                y: hoverCenterY,
	                text: thisText.join('<br>'),
	                name: (hovertemplate || hasFlag('name')) ? traceNow.name : undefined,
	                color: _cast('hoverlabel.bgcolor') || cdi.color,
	                borderColor: _cast('hoverlabel.bordercolor'),
	                fontFamily: _cast('hoverlabel.font.family'),
	                fontSize: _cast('hoverlabel.font.size'),
	                fontColor: _cast('hoverlabel.font.color'),
	                nameLength: _cast('hoverlabel.namelength'),
	                textAlign: _cast('hoverlabel.align'),
	                hovertemplate: hovertemplate,
	                hovertemplateLabels: hoverPt,
	                eventData: [makeEventData(pt, traceNow, opts.eventDataKeys)]
	            };
	
	            if(isSunburst) {
	                hoverItems.x0 = hoverCenterX - pt.rInscribed * pt.rpx1;
	                hoverItems.x1 = hoverCenterX + pt.rInscribed * pt.rpx1;
	                hoverItems.idealAlign = pt.pxmid[0] < 0 ? 'left' : 'right';
	            }
	            if(isTreemap) {
	                hoverItems.x = hoverCenterX;
	                hoverItems.idealAlign = hoverCenterX < 0 ? 'left' : 'right';
	            }
	
	            Fx.loneHover(hoverItems, {
	                container: fullLayoutNow._hoverlayer.node(),
	                outerContainer: fullLayoutNow._paper.node(),
	                gd: gd
	            });
	
	            trace._hasHoverLabel = true;
	        }
	
	        if(isTreemap) {
	            var slice = sliceTop.select('path.surface');
	            opts.styleOne(slice, pt, traceNow, {
	                hovered: true
	            });
	        }
	
	        trace._hasHoverEvent = true;
	        gd.emit('plotly_hover', {
	            points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
	            event: d3.event
	        });
	    };
	
	    var onMouseOut = function(evt) {
	        var fullLayoutNow = gd._fullLayout;
	        var traceNow = gd._fullData[trace.index];
	        var pt = d3.select(this).datum();
	
	        if(trace._hasHoverEvent) {
	            evt.originalEvent = d3.event;
	            gd.emit('plotly_unhover', {
	                points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
	                event: d3.event
	            });
	            trace._hasHoverEvent = false;
	        }
	
	        if(trace._hasHoverLabel) {
	            Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
	            trace._hasHoverLabel = false;
	        }
	
	        if(isTreemap) {
	            var slice = sliceTop.select('path.surface');
	            opts.styleOne(slice, pt, traceNow, {
	                hovered: false
	            });
	        }
	    };
	
	    var onClick = function(pt) {
	        // TODO: this does not support right-click. If we want to support it, we
	        // would likely need to change pie to use dragElement instead of straight
	        // mapbox event binding. Or perhaps better, make a simple wrapper with the
	        // right mousedown, mousemove, and mouseup handlers just for a left/right click
	        // mapbox would use this too.
	        var fullLayoutNow = gd._fullLayout;
	        var traceNow = gd._fullData[trace.index];
	
	        var clickVal = Events.triggerHandler(gd, 'plotly_' + trace.type + 'click', {
	            points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
	            event: d3.event
	        });
	
	        // 'regular' click event when sunburst/treemap click is disabled or when
	        // clicking on leaves or the hierarchy root
	        if(
	            clickVal === false ||
	            isSunburst && (
	                helpers.isHierarchyRoot(pt) ||
	                helpers.isLeaf(pt)
	            )
	        ) {
	            if(fullLayoutNow.hovermode) {
	                gd._hoverdata = [makeEventData(pt, traceNow, opts.eventDataKeys)];
	                Fx.click(gd, d3.event);
	            }
	            return;
	        }
	
	        // skip if triggered from dragging a nearby cartesian subplot
	        if(gd._dragging) return;
	
	        // skip during transitions, to avoid potential bugs
	        // we could remove this check later
	        if(gd._transitioning) return;
	
	        // store 'old' level in guiEdit stash, so that subsequent Plotly.react
	        // calls with the same uirevision can start from the same entry
	        Registry.call('_storeDirectGUIEdit', traceNow, fullLayoutNow._tracePreGUI[traceNow.uid], {
	            level: traceNow.level
	        });
	
	        var id = helpers.getPtId(pt);
	        var nextEntry = helpers.isEntry(pt) ?
	            helpers.findEntryWithChild(hierarchy, id) :
	            helpers.findEntryWithLevel(hierarchy, id);
	
	        var frame = {
	            data: [{level: helpers.getPtId(nextEntry)}],
	            traces: [trace.index]
	        };
	
	        var animOpts = {
	            frame: {
	                redraw: false,
	                duration: opts.transitionTime
	            },
	            transition: {
	                duration: opts.transitionTime,
	                easing: opts.transitionEasing
	            },
	            mode: 'immediate',
	            fromcurrent: true
	        };
	
	        Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
	        Registry.call('animate', gd, frame, animOpts);
	    };
	
	    sliceTop.on('mouseover', onMouseOver);
	    sliceTop.on('mouseout', onMouseOut);
	    sliceTop.on('click', onClick);
	};
	
	function makeEventData(pt, trace, keys) {
	    var cdi = pt.data.data;
	
	    var out = {
	        curveNumber: trace.index,
	        pointNumber: cdi.i,
	        data: trace._input,
	        fullData: trace,
	
	        // TODO more things like 'children', 'siblings', 'hierarchy?
	    };
	
	    for(var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        if(key in pt) out[key] = pt[key];
	    }
	    // handle special case of parent
	    if('parentString' in pt && !helpers.isHierarchyRoot(pt)) out.parent = pt.parentString;
	
	    appendArrayPointValue(out, trace, cdi.i);
	
	    return out;
	}
	
	},{"../../components/fx":629,"../../components/fx/helpers":626,"../../lib":716,"../../lib/events":706,"../../registry":845,"../pie/helpers":1097,"./helpers":1234,"d3":164}],1234:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	var setCursor = _dereq_('../../lib/setcursor');
	var pieHelpers = _dereq_('../pie/helpers');
	
	exports.findEntryWithLevel = function(hierarchy, level) {
	    var out;
	    if(level) {
	        hierarchy.eachAfter(function(pt) {
	            if(exports.getPtId(pt) === level) {
	                return out = pt.copy();
	            }
	        });
	    }
	    return out || hierarchy;
	};
	
	exports.findEntryWithChild = function(hierarchy, childId) {
	    var out;
	    hierarchy.eachAfter(function(pt) {
	        var children = pt.children || [];
	        for(var i = 0; i < children.length; i++) {
	            var child = children[i];
	            if(exports.getPtId(child) === childId) {
	                return out = pt.copy();
	            }
	        }
	    });
	    return out || hierarchy;
	};
	
	exports.isEntry = function(pt) {
	    return !pt.parent;
	};
	
	exports.isLeaf = function(pt) {
	    return !pt.children;
	};
	
	exports.getPtId = function(pt) {
	    return pt.data.data.id;
	};
	
	exports.getPtLabel = function(pt) {
	    return pt.data.data.label;
	};
	
	exports.getValue = function(d) {
	    return d.value;
	};
	
	exports.isHierarchyRoot = function(pt) {
	    return getParentId(pt) === '';
	};
	
	exports.setSliceCursor = function(sliceTop, gd, opts) {
	    var hide = opts.isTransitioning;
	    if(!hide) {
	        var pt = sliceTop.datum();
	        hide = (
	            (opts.hideOnRoot && exports.isHierarchyRoot(pt)) ||
	            (opts.hideOnLeaves && exports.isLeaf(pt))
	        );
	    }
	    setCursor(sliceTop, hide ? null : 'pointer');
	};
	
	function determineOutsideTextFont(trace, pt, layoutFont) {
	    return {
	        color: exports.getOutsideTextFontKey('color', trace, pt, layoutFont),
	        family: exports.getOutsideTextFontKey('family', trace, pt, layoutFont),
	        size: exports.getOutsideTextFontKey('size', trace, pt, layoutFont)
	    };
	}
	
	function determineInsideTextFont(trace, pt, layoutFont, cont) {
	    var cdi = pt.data.data;
	    var ptNumber = cdi.i;
	
	    var customColor = Lib.castOption(trace, ptNumber, 'insidetextfont.color');
	    if(!customColor && trace._input.textfont) {
	        // Why not simply using trace.textfont? Because if not set, it
	        // defaults to layout.font which has a default color. But if
	        // textfont.color and insidetextfont.color don't supply a value,
	        // a contrasting color shall be used.
	        customColor = Lib.castOption(trace._input, ptNumber, 'textfont.color');
	    }
	
	    return {
	        color: customColor || Color.contrast(cdi.color),
	        family: exports.getInsideTextFontKey('family', cont || trace, pt, layoutFont),
	        size: exports.getInsideTextFontKey('size', cont || trace, pt, layoutFont)
	    };
	}
	
	exports.getInsideTextFontKey = function(keyStr, trace, pt, layoutFont) {
	    var ptNumber = pt.data.data.i;
	
	    return (
	        Lib.castOption(trace, ptNumber, 'insidetextfont.' + keyStr) ||
	        Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) ||
	        layoutFont.size
	    );
	};
	
	exports.getOutsideTextFontKey = function(keyStr, trace, pt, layoutFont) {
	    var ptNumber = pt.data.data.i;
	
	    return (
	        Lib.castOption(trace, ptNumber, 'outsidetextfont.' + keyStr) ||
	        Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) ||
	        layoutFont.size
	    );
	};
	
	exports.isOutsideText = function(trace, pt) {
	    return !trace._hasColorscale && exports.isHierarchyRoot(pt);
	};
	
	exports.determineTextFont = function(trace, pt, layoutFont, cont) {
	    return exports.isOutsideText(trace, pt) ?
	        determineOutsideTextFont(trace, pt, layoutFont) :
	        determineInsideTextFont(trace, pt, layoutFont, cont);
	};
	
	exports.hasTransition = function(transitionOpts) {
	    // We could optimize hasTransition per trace,
	    // as sunburst & treemap have no cross-trace logic!
	    return !!(transitionOpts && transitionOpts.duration > 0);
	};
	
	exports.getMaxDepth = function(trace) {
	    return trace.maxdepth >= 0 ? trace.maxdepth : Infinity;
	};
	
	exports.isHeader = function(pt, trace) { // it is only used in treemap.
	    return !(exports.isLeaf(pt) || pt.depth === trace._maxDepth - 1);
	};
	
	function getParentId(pt) {
	    return pt.data.data.pid;
	}
	
	exports.getParent = function(hierarchy, pt) {
	    return exports.findEntryWithLevel(hierarchy, getParentId(pt));
	};
	
	exports.listPath = function(d, keyStr) {
	    var parent = d.parent;
	    if(!parent) return [];
	    var list = keyStr ? [parent.data[keyStr]] : [parent];
	    return exports.listPath(parent, keyStr).concat(list);
	};
	
	exports.getPath = function(d) {
	    return exports.listPath(d, 'label').join('/') + '/';
	};
	
	exports.formatValue = pieHelpers.formatPieValue;
	
	// TODO: should combine the two in a separate PR - Also please note Lib.formatPercent should support separators.
	exports.formatPercent = function(v, separators) {
	    var tx = Lib.formatPercent(v, 0); // use funnel(area) version
	    if(tx === '0%') tx = pieHelpers.formatPiePercent(v, separators); // use pie version
	    return tx;
	};
	
	},{"../../components/color":591,"../../lib":716,"../../lib/setcursor":736,"../pie/helpers":1097}],1235:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'sunburst',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: [],
	    animatable: true,
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./calc').crossTraceCalc,
	
	    plot: _dereq_('./plot').plot,
	    style: _dereq_('./style').style,
	
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	
	    meta: {
	        
	    }
	};
	
	},{"../scatter/marker_colorbar":1136,"./attributes":1228,"./base_plot":1229,"./calc":1230,"./defaults":1232,"./layout_attributes":1236,"./layout_defaults":1237,"./plot":1238,"./style":1239}],1236:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    sunburstcolorway: {
	        valType: 'colorlist',
	        
	        editType: 'calc',
	        
	    },
	    extendsunburstcolors: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],1237:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	    coerce('sunburstcolorway', layoutOut.colorway);
	    coerce('extendsunburstcolors');
	};
	
	},{"../../lib":716,"./layout_attributes":1236}],1238:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var d3Hierarchy = _dereq_('d3-hierarchy');
	
	var Drawing = _dereq_('../../components/drawing');
	var Lib = _dereq_('../../lib');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var transformInsideText = _dereq_('../pie/plot').transformInsideText;
	var styleOne = _dereq_('./style').styleOne;
	
	var attachFxHandlers = _dereq_('./fx');
	var constants = _dereq_('./constants');
	var helpers = _dereq_('./helpers');
	
	exports.plot = function(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = gd._fullLayout;
	    var layer = fullLayout._sunburstlayer;
	    var join, onComplete;
	
	    // If transition config is provided, then it is only a partial replot and traces not
	    // updated are removed.
	    var isFullReplot = !transitionOpts;
	    var hasTransition = helpers.hasTransition(transitionOpts);
	
	    join = layer.selectAll('g.trace.sunburst')
	        .data(cdmodule, function(cd) { return cd[0].trace.uid; });
	
	    // using same 'stroke-linejoin' as pie traces
	    join.enter().append('g')
	        .classed('trace', true)
	        .classed('sunburst', true)
	        .attr('stroke-linejoin', 'round');
	
	    join.order();
	
	    if(hasTransition) {
	        if(makeOnCompleteCallback) {
	            // If it was passed a callback to register completion, make a callback. If
	            // this is created, then it must be executed on completion, otherwise the
	            // pos-transition redraw will not execute:
	            onComplete = makeOnCompleteCallback();
	        }
	
	        var transition = d3.transition()
	            .duration(transitionOpts.duration)
	            .ease(transitionOpts.easing)
	            .each('end', function() { onComplete && onComplete(); })
	            .each('interrupt', function() { onComplete && onComplete(); });
	
	        transition.each(function() {
	            // Must run the selection again since otherwise enters/updates get grouped together
	            // and these get executed out of order. Except we need them in order!
	            layer.selectAll('g.trace').each(function(cd) {
	                plotOne(gd, cd, this, transitionOpts);
	            });
	        });
	    } else {
	        join.each(function(cd) {
	            plotOne(gd, cd, this, transitionOpts);
	        });
	    }
	
	    if(isFullReplot) {
	        join.exit().remove();
	    }
	};
	
	function plotOne(gd, cd, element, transitionOpts) {
	    var fullLayout = gd._fullLayout;
	    var hasTransition = helpers.hasTransition(transitionOpts);
	
	    var gTrace = d3.select(element);
	    var slices = gTrace.selectAll('g.slice');
	
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var hierarchy = cd0.hierarchy;
	    var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
	    var maxDepth = helpers.getMaxDepth(trace);
	
	    var gs = fullLayout._size;
	    var domain = trace.domain;
	    var vpw = gs.w * (domain.x[1] - domain.x[0]);
	    var vph = gs.h * (domain.y[1] - domain.y[0]);
	    var rMax = 0.5 * Math.min(vpw, vph);
	    var cx = cd0.cx = gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
	    var cy = cd0.cy = gs.t + gs.h * (1 - domain.y[0]) - vph / 2;
	
	    if(!entry) {
	        return slices.remove();
	    }
	
	    // previous root 'pt' (can be empty)
	    var prevEntry = null;
	    // stash of 'previous' position data used by tweening functions
	    var prevLookup = {};
	
	    if(hasTransition) {
	        // Important: do this before binding new sliceData!
	        slices.each(function(pt) {
	            prevLookup[helpers.getPtId(pt)] = {
	                rpx0: pt.rpx0,
	                rpx1: pt.rpx1,
	                x0: pt.x0,
	                x1: pt.x1,
	                transform: pt.transform
	            };
	
	            if(!prevEntry && helpers.isEntry(pt)) {
	                prevEntry = pt;
	            }
	        });
	    }
	
	    // N.B. slice data isn't the calcdata,
	    // grab corresponding calcdata item in sliceData[i].data.data
	    var sliceData = partition(entry).descendants();
	
	    var maxHeight = entry.height + 1;
	    var yOffset = 0;
	    var cutoff = maxDepth;
	    // N.B. handle multiple-root special case
	    if(cd0.hasMultipleRoots && helpers.isHierarchyRoot(entry)) {
	        sliceData = sliceData.slice(1);
	        maxHeight -= 1;
	        yOffset = 1;
	        cutoff += 1;
	    }
	
	    // filter out slices that won't show up on graph
	    sliceData = sliceData.filter(function(pt) { return pt.y1 <= cutoff; });
	
	    // partition span ('y') to sector radial px value
	    var maxY = Math.min(maxHeight, maxDepth);
	    var y2rpx = function(y) { return (y - yOffset) / maxY * rMax; };
	    // (radial px value, partition angle ('x'))  to px [x,y]
	    var rx2px = function(r, x) { return [r * Math.cos(x), -r * Math.sin(x)]; };
	    // slice path generation fn
	    var pathSlice = function(d) { return Lib.pathAnnulus(d.rpx0, d.rpx1, d.x0, d.x1, cx, cy); };
	    // slice text translate x/y
	    var transTextX = function(d) { return cx + d.pxmid[0] * d.transform.rCenter + (d.transform.x || 0); };
	    var transTextY = function(d) { return cy + d.pxmid[1] * d.transform.rCenter + (d.transform.y || 0); };
	
	    slices = slices.data(sliceData, helpers.getPtId);
	
	    slices.enter().append('g')
	        .classed('slice', true);
	
	    if(hasTransition) {
	        slices.exit().transition()
	            .each(function() {
	                var sliceTop = d3.select(this);
	
	                var slicePath = sliceTop.select('path.surface');
	                slicePath.transition().attrTween('d', function(pt2) {
	                    var interp = makeExitSliceInterpolator(pt2);
	                    return function(t) { return pathSlice(interp(t)); };
	                });
	
	                var sliceTextGroup = sliceTop.select('g.slicetext');
	                sliceTextGroup.attr('opacity', 0);
	            })
	            .remove();
	    } else {
	        slices.exit().remove();
	    }
	
	    slices.order();
	
	    // next x1 (i.e. sector end angle) of previous entry
	    var nextX1ofPrevEntry = null;
	    if(hasTransition && prevEntry) {
	        var prevEntryId = helpers.getPtId(prevEntry);
	        slices.each(function(pt) {
	            if(nextX1ofPrevEntry === null && (helpers.getPtId(pt) === prevEntryId)) {
	                nextX1ofPrevEntry = pt.x1;
	            }
	        });
	    }
	
	    var updateSlices = slices;
	    if(hasTransition) {
	        updateSlices = updateSlices.transition().each('end', function() {
	            // N.B. gd._transitioning is (still) *true* by the time
	            // transition updates get here
	            var sliceTop = d3.select(this);
	            helpers.setSliceCursor(sliceTop, gd, {
	                hideOnRoot: true,
	                hideOnLeaves: true,
	                isTransitioning: false
	            });
	        });
	    }
	
	    updateSlices.each(function(pt) {
	        var sliceTop = d3.select(this);
	
	        var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
	            s.style('pointer-events', 'all');
	        });
	
	        pt.rpx0 = y2rpx(pt.y0);
	        pt.rpx1 = y2rpx(pt.y1);
	        pt.xmid = (pt.x0 + pt.x1) / 2;
	        pt.pxmid = rx2px(pt.rpx1, pt.xmid);
	        pt.midangle = -(pt.xmid - Math.PI / 2);
	        pt.halfangle = 0.5 * Math.min(Lib.angleDelta(pt.x0, pt.x1) || Math.PI, Math.PI);
	        pt.ring = 1 - (pt.rpx0 / pt.rpx1);
	        pt.rInscribed = getInscribedRadiusFraction(pt, trace);
	
	        if(hasTransition) {
	            slicePath.transition().attrTween('d', function(pt2) {
	                var interp = makeUpdateSliceInterpolator(pt2);
	                return function(t) { return pathSlice(interp(t)); };
	            });
	        } else {
	            slicePath.attr('d', pathSlice);
	        }
	
	        sliceTop
	            .call(attachFxHandlers, entry, gd, cd, {
	                eventDataKeys: constants.eventDataKeys,
	                transitionTime: constants.CLICK_TRANSITION_TIME,
	                transitionEasing: constants.CLICK_TRANSITION_EASING
	            })
	            .call(helpers.setSliceCursor, gd, {
	                hideOnRoot: true,
	                hideOnLeaves: true,
	                isTransitioning: gd._transitioning
	            });
	
	        slicePath.call(styleOne, pt, trace);
	
	        var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
	        var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
	            // prohibit tex interpretation until we can handle
	            // tex and regular text together
	            s.attr('data-notex', 1);
	        });
	
	        sliceText.text(exports.formatSliceLabel(pt, entry, trace, cd, fullLayout))
	            .classed('slicetext', true)
	            .attr('text-anchor', 'middle')
	            .call(Drawing.font, helpers.determineTextFont(trace, pt, fullLayout.font))
	            .call(svgTextUtils.convertToTspans, gd);
	
	        // position the text relative to the slice
	        var textBB = Drawing.bBox(sliceText.node());
	        pt.transform = transformInsideText(textBB, pt, cd0);
	        pt.translateX = transTextX(pt);
	        pt.translateY = transTextY(pt);
	
	        var strTransform = function(d, textBB) {
	            return 'translate(' + d.translateX + ',' + d.translateY + ')' +
	                (d.transform.scale < 1 ? ('scale(' + d.transform.scale + ')') : '') +
	                (d.transform.rotate ? ('rotate(' + d.transform.rotate + ')') : '') +
	                'translate(' +
	                    (-(textBB.left + textBB.right) / 2) + ',' +
	                    (-(textBB.top + textBB.bottom) / 2) +
	                ')';
	        };
	
	        if(hasTransition) {
	            sliceText.transition().attrTween('transform', function(pt2) {
	                var interp = makeUpdateTextInterpolator(pt2);
	                return function(t) { return strTransform(interp(t), textBB); };
	            });
	        } else {
	            sliceText.attr('transform', strTransform(pt, textBB));
	        }
	    });
	
	    function makeExitSliceInterpolator(pt) {
	        var id = helpers.getPtId(pt);
	        var prev = prevLookup[id];
	        var entryPrev = prevLookup[helpers.getPtId(entry)];
	        var next;
	
	        if(entryPrev) {
	            var a = pt.x1 > entryPrev.x1 ? 2 * Math.PI : 0;
	            // if pt to remove:
	            // - if 'below' where the root-node used to be: shrink it radially inward
	            // - otherwise, collapse it clockwise or counterclockwise which ever is shortest to theta=0
	            next = pt.rpx1 < entryPrev.rpx1 ? {rpx0: 0, rpx1: 0} : {x0: a, x1: a};
	        } else {
	            // this happens when maxdepth is set, when leaves must
	            // be removed and the rootPt is new (i.e. does not have a 'prev' object)
	            var parent;
	            var parentId = helpers.getPtId(pt.parent);
	            slices.each(function(pt2) {
	                if(helpers.getPtId(pt2) === parentId) {
	                    return parent = pt2;
	                }
	            });
	            var parentChildren = parent.children;
	            var ci;
	            parentChildren.forEach(function(pt2, i) {
	                if(helpers.getPtId(pt2) === id) {
	                    return ci = i;
	                }
	            });
	            var n = parentChildren.length;
	            var interp = d3.interpolate(parent.x0, parent.x1);
	            next = {
	                rpx0: rMax, rpx1: rMax,
	                x0: interp(ci / n), x1: interp((ci + 1) / n)
	            };
	        }
	
	        return d3.interpolate(prev, next);
	    }
	
	    function makeUpdateSliceInterpolator(pt) {
	        var prev0 = prevLookup[helpers.getPtId(pt)];
	        var prev;
	        var next = {x0: pt.x0, x1: pt.x1, rpx0: pt.rpx0, rpx1: pt.rpx1};
	
	        if(prev0) {
	            // if pt already on graph, this is easy
	            prev = prev0;
	        } else {
	            // for new pts:
	            if(prevEntry) {
	                // if trace was visible before
	                if(pt.parent) {
	                    if(nextX1ofPrevEntry) {
	                        // if new branch, twist it in clockwise or
	                        // counterclockwise which ever is shorter to
	                        // its final angle
	                        var a = pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0;
	                        prev = {x0: a, x1: a};
	                    } else {
	                        // if new leaf (when maxdepth is set),
	                        // grow it radially and angularly from
	                        // its parent node
	                        prev = {rpx0: rMax, rpx1: rMax};
	                        Lib.extendFlat(prev, interpX0X1FromParent(pt));
	                    }
	                } else {
	                    // if new root-node, grow it radially
	                    prev = {rpx0: 0, rpx1: 0};
	                }
	            } else {
	                // start sector of new traces from theta=0
	                prev = {x0: 0, x1: 0};
	            }
	        }
	
	        return d3.interpolate(prev, next);
	    }
	
	    function makeUpdateTextInterpolator(pt) {
	        var prev0 = prevLookup[helpers.getPtId(pt)];
	        var prev;
	        var transform = pt.transform;
	
	        if(prev0) {
	            prev = prev0;
	        } else {
	            prev = {
	                rpx1: pt.rpx1,
	                transform: {
	                    scale: 0,
	                    rotate: transform.rotate,
	                    rCenter: transform.rCenter,
	                    x: transform.x,
	                    y: transform.y
	                }
	            };
	
	            // for new pts:
	            if(prevEntry) {
	                // if trace was visible before
	                if(pt.parent) {
	                    if(nextX1ofPrevEntry) {
	                        // if new branch, twist it in clockwise or
	                        // counterclockwise which ever is shorter to
	                        // its final angle
	                        var a = pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0;
	                        prev.x0 = prev.x1 = a;
	                    } else {
	                        // if leaf
	                        Lib.extendFlat(prev, interpX0X1FromParent(pt));
	                    }
	                } else {
	                    // if new root-node
	                    prev.x0 = prev.x1 = 0;
	                }
	            } else {
	                // on new traces
	                prev.x0 = prev.x1 = 0;
	            }
	        }
	
	        var rpx1Fn = d3.interpolate(prev.rpx1, pt.rpx1);
	        var x0Fn = d3.interpolate(prev.x0, pt.x0);
	        var x1Fn = d3.interpolate(prev.x1, pt.x1);
	        var scaleFn = d3.interpolate(prev.transform.scale, transform.scale);
	        var rotateFn = d3.interpolate(prev.transform.rotate, transform.rotate);
	
	        // smooth out start/end from entry, to try to keep text inside sector
	        // while keeping transition smooth
	        var pow = transform.rCenter === 0 ? 3 :
	            prev.transform.rCenter === 0 ? 1 / 3 :
	            1;
	        var _rCenterFn = d3.interpolate(prev.transform.rCenter, transform.rCenter);
	        var rCenterFn = function(t) { return _rCenterFn(Math.pow(t, pow)); };
	
	        return function(t) {
	            var rpx1 = rpx1Fn(t);
	            var x0 = x0Fn(t);
	            var x1 = x1Fn(t);
	            var rCenter = rCenterFn(t);
	
	            var d = {
	                pxmid: rx2px(rpx1, (x0 + x1) / 2),
	                transform: {
	                    rCenter: rCenter,
	                    x: transform.x,
	                    y: transform.y
	                }
	            };
	
	            var out = {
	                rpx1: rpx1Fn(t),
	                translateX: transTextX(d),
	                translateY: transTextY(d),
	                transform: {
	                    scale: scaleFn(t),
	                    rotate: rotateFn(t),
	                    rCenter: rCenter
	                }
	            };
	
	            return out;
	        };
	    }
	
	    function interpX0X1FromParent(pt) {
	        var parent = pt.parent;
	        var parentPrev = prevLookup[helpers.getPtId(parent)];
	        var out = {};
	
	        if(parentPrev) {
	            // if parent is visible
	            var parentChildren = parent.children;
	            var ci = parentChildren.indexOf(pt);
	            var n = parentChildren.length;
	            var interp = d3.interpolate(parentPrev.x0, parentPrev.x1);
	            out.x0 = interp(ci / n);
	            out.x1 = interp(ci / n);
	        } else {
	            // w/o visible parent
	            // TODO !!! HOW ???
	            out.x0 = out.x1 = 0;
	        }
	
	        return out;
	    }
	}
	
	// x[0-1] keys are angles [radians]
	// y[0-1] keys are hierarchy heights [integers]
	function partition(entry) {
	    return d3Hierarchy.partition()
	        .size([2 * Math.PI, entry.height + 1])(entry);
	}
	
	exports.formatSliceLabel = function(pt, entry, trace, cd, fullLayout) {
	    var texttemplate = trace.texttemplate;
	    var textinfo = trace.textinfo;
	
	    if(!texttemplate && (!textinfo || textinfo === 'none')) {
	        return '';
	    }
	
	    var separators = fullLayout.separators;
	    var cd0 = cd[0];
	    var cdi = pt.data.data;
	    var hierarchy = cd0.hierarchy;
	    var isRoot = helpers.isHierarchyRoot(pt);
	    var parent = helpers.getParent(hierarchy, pt);
	    var val = helpers.getValue(pt);
	
	    if(!texttemplate) {
	        var parts = textinfo.split('+');
	        var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
	        var thisText = [];
	        var tx;
	
	        if(hasFlag('label') && cdi.label) {
	            thisText.push(cdi.label);
	        }
	
	        if(cdi.hasOwnProperty('v') && hasFlag('value')) {
	            thisText.push(helpers.formatValue(cdi.v, separators));
	        }
	
	        if(!isRoot) {
	            if(hasFlag('current path')) {
	                thisText.push(helpers.getPath(pt.data));
	            }
	
	            var nPercent = 0;
	            if(hasFlag('percent parent')) nPercent++;
	            if(hasFlag('percent entry')) nPercent++;
	            if(hasFlag('percent root')) nPercent++;
	            var hasMultiplePercents = nPercent > 1;
	
	            if(nPercent) {
	                var percent;
	                var addPercent = function(key) {
	                    tx = helpers.formatPercent(percent, separators);
	
	                    if(hasMultiplePercents) tx += ' of ' + key;
	                    thisText.push(tx);
	                };
	
	                if(hasFlag('percent parent') && !isRoot) {
	                    percent = val / helpers.getValue(parent);
	                    addPercent('parent');
	                }
	                if(hasFlag('percent entry')) {
	                    percent = val / helpers.getValue(entry);
	                    addPercent('entry');
	                }
	                if(hasFlag('percent root')) {
	                    percent = val / helpers.getValue(hierarchy);
	                    addPercent('root');
	                }
	            }
	        }
	
	        if(hasFlag('text')) {
	            tx = Lib.castOption(trace, cdi.i, 'text');
	            if(Lib.isValidTextValue(tx)) thisText.push(tx);
	        }
	
	        return thisText.join('<br>');
	    }
	
	    var txt = Lib.castOption(trace, cdi.i, 'texttemplate');
	    if(!txt) return '';
	    var obj = {};
	    if(cdi.label) obj.label = cdi.label;
	    if(cdi.hasOwnProperty('v')) {
	        obj.value = cdi.v;
	        obj.valueLabel = helpers.formatValue(cdi.v, separators);
	    }
	
	    obj.currentPath = helpers.getPath(pt.data);
	
	    if(!isRoot) {
	        obj.percentParent = val / helpers.getValue(parent);
	        obj.percentParentLabel = helpers.formatPercent(
	            obj.percentParent, separators
	        );
	        obj.parent = helpers.getPtLabel(parent);
	    }
	
	    obj.percentEntry = val / helpers.getValue(entry);
	    obj.percentEntryLabel = helpers.formatPercent(
	        obj.percentEntry, separators
	    );
	    obj.entry = helpers.getPtLabel(entry);
	
	    obj.percentRoot = val / helpers.getValue(hierarchy);
	    obj.percentRootLabel = helpers.formatPercent(
	        obj.percentRoot, separators
	    );
	    obj.root = helpers.getPtLabel(hierarchy);
	
	    if(cdi.hasOwnProperty('color')) {
	        obj.color = cdi.color;
	    }
	    var ptTx = Lib.castOption(trace, cdi.i, 'text');
	    if(Lib.isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
	    obj.customdata = Lib.castOption(trace, cdi.i, 'customdata');
	    return Lib.texttemplateString(txt, obj, fullLayout._d3locale, obj, trace._meta || {});
	};
	
	function getInscribedRadiusFraction(pt) {
	    if(pt.rpx0 === 0 && Lib.isFullCircle([pt.x0, pt.x1])) {
	        // special case of 100% with no hole
	        return 1;
	    } else {
	        return Math.max(0, Math.min(
	            1 / (1 + 1 / Math.sin(pt.halfangle)),
	            pt.ring / 2
	        ));
	    }
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../../lib/svg_text_utils":740,"../pie/plot":1101,"./constants":1231,"./fx":1233,"./helpers":1234,"./style":1239,"d3":164,"d3-hierarchy":158}],1239:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var Lib = _dereq_('../../lib');
	
	function style(gd) {
	    gd._fullLayout._sunburstlayer.selectAll('.trace').each(function(cd) {
	        var gTrace = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        gTrace.style('opacity', trace.opacity);
	
	        gTrace.selectAll('path.surface').each(function(pt) {
	            d3.select(this).call(styleOne, pt, trace);
	        });
	    });
	}
	
	function styleOne(s, pt, trace) {
	    var cdi = pt.data.data;
	    var isLeaf = !pt.children;
	    var ptNumber = cdi.i;
	    var lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
	    var lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
	
	    s.style('stroke-width', lineWidth)
	        .call(Color.fill, cdi.color)
	        .call(Color.stroke, lineColor)
	        .style('opacity', isLeaf ? trace.leaf.opacity : null);
	}
	
	module.exports = {
	    style: style,
	    styleOne: styleOne
	};
	
	},{"../../components/color":591,"../../lib":716,"d3":164}],1240:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Color = _dereq_('../../components/color');
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	function makeContourProjAttr(axLetter) {
	    return {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    };
	}
	
	function makeContourAttr(axLetter) {
	    return {
	        show: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        start: {
	            valType: 'number',
	            dflt: null,
	            
	            editType: 'plot',
	         // impliedEdits: {'^autocontour': false},
	            
	        },
	        end: {
	            valType: 'number',
	            dflt: null,
	            
	            editType: 'plot',
	         // impliedEdits: {'^autocontour': false},
	            
	        },
	        size: {
	            valType: 'number',
	            dflt: null,
	            min: 0,
	            
	            editType: 'plot',
	         // impliedEdits: {'^autocontour': false},
	            
	        },
	        project: {
	            x: makeContourProjAttr('x'),
	            y: makeContourProjAttr('y'),
	            z: makeContourProjAttr('z')
	        },
	        color: {
	            valType: 'color',
	            
	            dflt: Color.defaultLine,
	            
	        },
	        usecolormap: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        width: {
	            valType: 'number',
	            
	            min: 1,
	            max: 16,
	            dflt: 2,
	            
	        },
	        highlight: {
	            valType: 'boolean',
	            
	            dflt: true,
	            
	        },
	        highlightcolor: {
	            valType: 'color',
	            
	            dflt: Color.defaultLine,
	            
	        },
	        highlightwidth: {
	            valType: 'number',
	            
	            min: 1,
	            max: 16,
	            dflt: 2,
	            
	        }
	    };
	}
	
	var attrs = module.exports = overrideAll(extendFlat({
	    z: {
	        valType: 'data_array',
	        
	    },
	    x: {
	        valType: 'data_array',
	        
	    },
	    y: {
	        valType: 'data_array',
	        
	    },
	
	    text: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        
	    },
	    hovertext: {
	        valType: 'string',
	        
	        dflt: '',
	        arrayOk: true,
	        
	    },
	    hovertemplate: hovertemplateAttrs(),
	
	    connectgaps: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	
	    surfacecolor: {
	        valType: 'data_array',
	        
	    },
	},
	
	colorScaleAttrs('', {
	    colorAttr: 'z or surfacecolor',
	    showScaleDflt: true,
	    autoColorDflt: false,
	    editTypeOverride: 'calc'
	}), {
	    contours: {
	        x: makeContourAttr('x'),
	        y: makeContourAttr('y'),
	        z: makeContourAttr('z')
	    },
	    hidesurface: {
	        valType: 'boolean',
	        
	        dflt: false,
	        
	    },
	
	    lightposition: {
	        x: {
	            valType: 'number',
	            
	            min: -1e5,
	            max: 1e5,
	            dflt: 10,
	            
	        },
	        y: {
	            valType: 'number',
	            
	            min: -1e5,
	            max: 1e5,
	            dflt: 1e4,
	            
	        },
	        z: {
	            valType: 'number',
	            
	            min: -1e5,
	            max: 1e5,
	            dflt: 0,
	            
	        }
	    },
	
	    lighting: {
	        ambient: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 1.0,
	            dflt: 0.8,
	            
	        },
	        diffuse: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 1.00,
	            dflt: 0.8,
	            
	        },
	        specular: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 2.00,
	            dflt: 0.05,
	            
	        },
	        roughness: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 1.00,
	            dflt: 0.5,
	            
	        },
	        fresnel: {
	            valType: 'number',
	            
	            min: 0.00,
	            max: 5.00,
	            dflt: 0.2,
	            
	        }
	    },
	
	    opacity: {
	        valType: 'number',
	        
	        min: 0,
	        max: 1,
	        dflt: 1,
	        
	    },
	
	    _deprecated: {
	        zauto: extendFlat({}, colorScaleAttrs.zauto, {
	            
	        }),
	        zmin: extendFlat({}, colorScaleAttrs.zmin, {
	            
	        }),
	        zmax: extendFlat({}, colorScaleAttrs.zmax, {
	            
	        })
	    },
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	}), 'calc', 'nested');
	
	attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';
	attrs.transforms = undefined;
	
	},{"../../components/color":591,"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../../plots/template_attributes":840}],1241:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var colorscaleCalc = _dereq_('../../components/colorscale/calc');
	
	
	// Compute auto-z and autocolorscale if applicable
	module.exports = function calc(gd, trace) {
	    if(trace.surfacecolor) {
	        colorscaleCalc(gd, trace, {
	            vals: trace.surfacecolor,
	            containerStr: '',
	            cLetter: 'c'
	        });
	    } else {
	        colorscaleCalc(gd, trace, {
	            vals: trace.z,
	            containerStr: '',
	            cLetter: 'c'
	        });
	    }
	};
	
	},{"../../components/colorscale/calc":599}],1242:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	
	'use strict';
	
	var createSurface = _dereq_('gl-surface3d');
	
	var ndarray = _dereq_('ndarray');
	var homography = _dereq_('ndarray-homography');
	var fill = _dereq_('ndarray-fill');
	
	var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	
	var interp2d = _dereq_('../heatmap/interp2d');
	var findEmpties = _dereq_('../heatmap/find_empties');
	
	function SurfaceTrace(scene, surface, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.surface = surface;
	    this.data = null;
	    this.showContour = [false, false, false];
	    this.contourStart = [null, null, null];
	    this.contourEnd = [null, null, null];
	    this.contourSize = [0, 0, 0];
	    this.minValues = [Infinity, Infinity, Infinity];
	    this.maxValues = [-Infinity, -Infinity, -Infinity];
	    this.dataScaleX = 1.0;
	    this.dataScaleY = 1.0;
	    this.refineData = true;
	    this.objectOffset = [0, 0, 0];
	}
	
	var proto = SurfaceTrace.prototype;
	
	proto.getXat = function(a, b, calendar, axis) {
	    var v = (
	       (!isArrayOrTypedArray(this.data.x)) ?
	            a :
	       (isArrayOrTypedArray(this.data.x[0])) ?
	            this.data.x[b][a] :
	            this.data.x[a]
	    );
	
	    return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
	};
	
	proto.getYat = function(a, b, calendar, axis) {
	    var v = (
	       (!isArrayOrTypedArray(this.data.y)) ?
	            b :
	       (isArrayOrTypedArray(this.data.y[0])) ?
	            this.data.y[b][a] :
	            this.data.y[b]
	    );
	
	    return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
	};
	
	proto.getZat = function(a, b, calendar, axis) {
	    var v = this.data.z[b][a];
	
	    if(v === null && this.data.connectgaps && this.data._interpolatedZ) {
	        v = this.data._interpolatedZ[b][a];
	    }
	
	    return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
	};
	
	proto.handlePick = function(selection) {
	    if(selection.object === this.surface) {
	        var xRatio = (selection.data.index[0] - 1) / this.dataScaleX - 1;
	        var yRatio = (selection.data.index[1] - 1) / this.dataScaleY - 1;
	
	        var j = Math.max(Math.min(Math.round(xRatio), this.data.z[0].length - 1), 0);
	        var k = Math.max(Math.min(Math.round(yRatio), this.data._ylength - 1), 0);
	
	        selection.index = [j, k];
	
	        selection.traceCoordinate = [
	            this.getXat(j, k),
	            this.getYat(j, k),
	            this.getZat(j, k)
	        ];
	
	        selection.dataCoordinate = [
	            this.getXat(j, k, this.data.xcalendar, this.scene.fullSceneLayout.xaxis),
	            this.getYat(j, k, this.data.ycalendar, this.scene.fullSceneLayout.yaxis),
	            this.getZat(j, k, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)
	        ];
	
	        for(var i = 0; i < 3; i++) {
	            var v = selection.dataCoordinate[i];
	            if(v !== null && v !== undefined) {
	                selection.dataCoordinate[i] *= this.scene.dataScale[i];
	            }
	        }
	
	        var text = this.data.hovertext || this.data.text;
	        if(Array.isArray(text) && text[k] && text[k][j] !== undefined) {
	            selection.textLabel = text[k][j];
	        } else if(text) {
	            selection.textLabel = text;
	        } else {
	            selection.textLabel = '';
	        }
	
	        selection.data.dataCoordinate = selection.dataCoordinate.slice();
	
	        this.surface.highlight(selection.data);
	
	        // Snap spikes to data coordinate
	        this.scene.glplot.spikes.position = selection.dataCoordinate;
	
	        return true;
	    }
	};
	
	function isColormapCircular(colormap) {
	    var first = colormap[0].rgb;
	    var last = colormap[colormap.length - 1].rgb;
	
	    return (
	        first[0] === last[0] &&
	        first[1] === last[1] &&
	        first[2] === last[2] &&
	        first[3] === last[3]
	    );
	}
	
	var shortPrimes = [
	    2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97,
	    101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199,
	    211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293,
	    307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397,
	    401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499,
	    503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599,
	    601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691,
	    701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797,
	    809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887,
	    907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997,
	    1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097,
	    1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193,
	    1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297,
	    1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399,
	    1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499,
	    1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597,
	    1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699,
	    1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789,
	    1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889,
	    1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999,
	    2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099,
	    2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179,
	    2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297,
	    2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399,
	    2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477,
	    2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593,
	    2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699,
	    2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797,
	    2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897,
	    2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999
	];
	
	function getPow(a, b) {
	    if(a < b) return 0;
	    var n = 0;
	    while(Math.floor(a % b) === 0) {
	        a /= b;
	        n++;
	    }
	    return n;
	}
	
	function getFactors(a) {
	    var powers = [];
	    for(var i = 0; i < shortPrimes.length; i++) {
	        var b = shortPrimes[i];
	        powers.push(
	            getPow(a, b)
	        );
	    }
	    return powers;
	}
	
	function smallestDivisor(a) {
	    var A = getFactors(a);
	    var result = a;
	    for(var i = 0; i < shortPrimes.length; i++) {
	        if(A[i] > 0) {
	            result = shortPrimes[i];
	            break;
	        }
	    }
	    return result;
	}
	
	function leastCommonMultiple(a, b) {
	    if(a < 1 || b < 1) return undefined;
	    var A = getFactors(a);
	    var B = getFactors(b);
	    var n = 1;
	    for(var i = 0; i < shortPrimes.length; i++) {
	        n *= Math.pow(
	            shortPrimes[i], Math.max(A[i], B[i])
	        );
	    }
	    return n;
	}
	
	function arrayLCM(A) {
	    if(A.length === 0) return undefined;
	    var n = 1;
	    for(var i = 0; i < A.length; i++) {
	        n = leastCommonMultiple(n, A[i]);
	    }
	    return n;
	}
	
	proto.calcXnums = function(xlen) {
	    var i;
	    var nums = [];
	    for(i = 1; i < xlen; i++) {
	        var a = this.getXat(i - 1, 0);
	        var b = this.getXat(i, 0);
	
	        if(b !== a &&
	            a !== undefined && a !== null &&
	            b !== undefined && b !== null) {
	            nums[i - 1] = Math.abs(b - a);
	        } else {
	            nums[i - 1] = 0;
	        }
	    }
	
	    var totalDist = 0;
	    for(i = 1; i < xlen; i++) {
	        totalDist += nums[i - 1];
	    }
	
	    for(i = 1; i < xlen; i++) {
	        if(nums[i - 1] === 0) {
	            nums[i - 1] = 1;
	        } else {
	            nums[i - 1] = Math.round(totalDist / nums[i - 1]);
	        }
	    }
	
	    return nums;
	};
	
	proto.calcYnums = function(ylen) {
	    var i;
	    var nums = [];
	    for(i = 1; i < ylen; i++) {
	        var a = this.getYat(0, i - 1);
	        var b = this.getYat(0, i);
	
	        if(b !== a &&
	            a !== undefined && a !== null &&
	            b !== undefined && b !== null) {
	            nums[i - 1] = Math.abs(b - a);
	        } else {
	            nums[i - 1] = 0;
	        }
	    }
	
	    var totalDist = 0;
	    for(i = 1; i < ylen; i++) {
	        totalDist += nums[i - 1];
	    }
	
	    for(i = 1; i < ylen; i++) {
	        if(nums[i - 1] === 0) {
	            nums[i - 1] = 1;
	        } else {
	            nums[i - 1] = Math.round(totalDist / nums[i - 1]);
	        }
	    }
	
	    return nums;
	};
	
	var highlyComposites = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260];
	
	var MIN_RESOLUTION = highlyComposites[9];
	var MAX_RESOLUTION = highlyComposites[13];
	
	proto.estimateScale = function(resSrc, axis) {
	    var nums = (axis === 0) ?
	        this.calcXnums(resSrc) :
	        this.calcYnums(resSrc);
	
	    var resDst = 1 + arrayLCM(nums);
	
	    while(resDst < MIN_RESOLUTION) {
	        resDst *= 2;
	    }
	
	    while(resDst > MAX_RESOLUTION) {
	        resDst--;
	        resDst /= smallestDivisor(resDst);
	        resDst++;
	
	        if(resDst < MIN_RESOLUTION) {
	         // resDst = MIN_RESOLUTION; // option 1: use min resolution
	            resDst = MAX_RESOLUTION; // option 2: use max resolution
	        }
	    }
	
	    var scale = Math.round(resDst / resSrc);
	    return (scale > 1) ? scale : 1;
	};
	
	proto.refineCoords = function(coords) {
	    var scaleW = this.dataScaleX;
	    var scaleH = this.dataScaleY;
	
	    var width = coords[0].shape[0];
	    var height = coords[0].shape[1];
	
	    var newWidth = Math.floor(coords[0].shape[0] * scaleW + 1) | 0;
	    var newHeight = Math.floor(coords[0].shape[1] * scaleH + 1) | 0;
	
	    // Pad coords by +1
	    var padWidth = 1 + width + 1;
	    var padHeight = 1 + height + 1;
	    var padImg = ndarray(new Float32Array(padWidth * padHeight), [padWidth, padHeight]);
	
	    for(var i = 0; i < coords.length; ++i) {
	        this.surface.padField(padImg, coords[i]);
	
	        var scaledImg = ndarray(new Float32Array(newWidth * newHeight), [newWidth, newHeight]);
	        homography(scaledImg, padImg,
	            [
	                scaleW, 0, 0,
	                0, scaleH, 0,
	                0, 0, 1
	            ]
	        );
	        coords[i] = scaledImg;
	    }
	};
	
	function insertIfNewLevel(arr, newValue) {
	    var found = false;
	    for(var k = 0; k < arr.length; k++) {
	        if(newValue === arr[k]) {
	            found = true;
	            break;
	        }
	    }
	    if(found === false) arr.push(newValue);
	}
	
	proto.setContourLevels = function() {
	    var newLevels = [[], [], []];
	    var useNewLevels = [false, false, false];
	    var needsUpdate = false;
	
	    var i, j, value;
	
	    for(i = 0; i < 3; ++i) {
	        if(this.showContour[i]) {
	            needsUpdate = true;
	
	            if(
	                this.contourSize[i] > 0 &&
	                this.contourStart[i] !== null &&
	                this.contourEnd[i] !== null &&
	                this.contourEnd[i] > this.contourStart[i]
	            ) {
	                useNewLevels[i] = true;
	
	                for(j = this.contourStart[i]; j < this.contourEnd[i]; j += this.contourSize[i]) {
	                    value = j * this.scene.dataScale[i];
	
	                    insertIfNewLevel(newLevels[i], value);
	                }
	            }
	        }
	    }
	
	    if(needsUpdate) {
	        var allLevels = [[], [], []];
	        for(i = 0; i < 3; ++i) {
	            if(this.showContour[i]) {
	                allLevels[i] = useNewLevels[i] ? newLevels[i] : this.scene.contourLevels[i];
	            }
	        }
	        this.surface.update({ levels: allLevels });
	    }
	};
	
	proto.update = function(data) {
	    var scene = this.scene;
	    var sceneLayout = scene.fullSceneLayout;
	    var surface = this.surface;
	    var alpha = data.opacity;
	    var colormap = parseColorScale(data, alpha);
	    var scaleFactor = scene.dataScale;
	    var xlen = data.z[0].length;
	    var ylen = data._ylength;
	    var contourLevels = scene.contourLevels;
	
	    // Save data
	    this.data = data;
	
	    /*
	     * Fill and transpose zdata.
	     * Consistent with 'heatmap' and 'contour', plotly 'surface'
	     * 'z' are such that sub-arrays correspond to y-coords
	     * and that the sub-array entries correspond to a x-coords,
	     * which is the transpose of 'gl-surface-plot'.
	     */
	
	    var i, j, k, v;
	    var rawCoords = [];
	    for(i = 0; i < 3; i++) {
	        rawCoords[i] = [];
	        for(j = 0; j < xlen; j++) {
	            rawCoords[i][j] = [];
	            /*
	            for(k = 0; k < ylen; k++) {
	                rawCoords[i][j][k] = undefined;
	            }
	            */
	        }
	    }
	
	    // coords x, y & z
	    for(j = 0; j < xlen; j++) {
	        for(k = 0; k < ylen; k++) {
	            rawCoords[0][j][k] = this.getXat(j, k, data.xcalendar, sceneLayout.xaxis);
	            rawCoords[1][j][k] = this.getYat(j, k, data.ycalendar, sceneLayout.yaxis);
	            rawCoords[2][j][k] = this.getZat(j, k, data.zcalendar, sceneLayout.zaxis);
	        }
	    }
	
	    if(data.connectgaps) {
	        data._emptypoints = findEmpties(rawCoords[2]);
	        interp2d(rawCoords[2], data._emptypoints);
	
	        data._interpolatedZ = [];
	        for(j = 0; j < xlen; j++) {
	            data._interpolatedZ[j] = [];
	            for(k = 0; k < ylen; k++) {
	                data._interpolatedZ[j][k] = rawCoords[2][j][k];
	            }
	        }
	    }
	
	    // Note: log axes are not defined in surfaces yet.
	    // but they could be defined here...
	
	    for(i = 0; i < 3; i++) {
	        for(j = 0; j < xlen; j++) {
	            for(k = 0; k < ylen; k++) {
	                v = rawCoords[i][j][k];
	                if(v === null || v === undefined) {
	                    rawCoords[i][j][k] = NaN;
	                } else {
	                    v = rawCoords[i][j][k] *= scaleFactor[i];
	                }
	            }
	        }
	    }
	
	    for(i = 0; i < 3; i++) {
	        for(j = 0; j < xlen; j++) {
	            for(k = 0; k < ylen; k++) {
	                v = rawCoords[i][j][k];
	                if(v !== null && v !== undefined) {
	                    if(this.minValues[i] > v) {
	                        this.minValues[i] = v;
	                    }
	                    if(this.maxValues[i] < v) {
	                        this.maxValues[i] = v;
	                    }
	                }
	            }
	        }
	    }
	
	    for(i = 0; i < 3; i++) {
	        this.objectOffset[i] = 0.5 * (this.minValues[i] + this.maxValues[i]);
	    }
	
	    for(i = 0; i < 3; i++) {
	        for(j = 0; j < xlen; j++) {
	            for(k = 0; k < ylen; k++) {
	                v = rawCoords[i][j][k];
	                if(v !== null && v !== undefined) {
	                    rawCoords[i][j][k] -= this.objectOffset[i];
	                }
	            }
	        }
	    }
	
	    // convert processed raw data to Float32 matrices
	    var coords = [
	        ndarray(new Float32Array(xlen * ylen), [xlen, ylen]),
	        ndarray(new Float32Array(xlen * ylen), [xlen, ylen]),
	        ndarray(new Float32Array(xlen * ylen), [xlen, ylen])
	    ];
	    fill(coords[0], function(row, col) { return rawCoords[0][row][col]; });
	    fill(coords[1], function(row, col) { return rawCoords[1][row][col]; });
	    fill(coords[2], function(row, col) { return rawCoords[2][row][col]; });
	    rawCoords = []; // free memory
	
	    var params = {
	        colormap: colormap,
	        levels: [[], [], []],
	        showContour: [true, true, true],
	        showSurface: !data.hidesurface,
	        contourProject: [
	            [false, false, false],
	            [false, false, false],
	            [false, false, false]
	        ],
	        contourWidth: [1, 1, 1],
	        contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
	        contourTint: [1, 1, 1],
	        dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
	        dynamicWidth: [1, 1, 1],
	        dynamicTint: [1, 1, 1],
	        opacity: data.opacity
	    };
	
	    var cOpts = extractOpts(data);
	    params.intensityBounds = [cOpts.min, cOpts.max];
	
	    // Refine surface color if necessary
	    if(data.surfacecolor) {
	        var intensity = ndarray(new Float32Array(xlen * ylen), [xlen, ylen]);
	
	        fill(intensity, function(row, col) {
	            return data.surfacecolor[col][row];
	        });
	
	        coords.push(intensity);
	    } else {
	        // when 'z' is used as 'intensity',
	        // we must scale its value
	        params.intensityBounds[0] *= scaleFactor[2];
	        params.intensityBounds[1] *= scaleFactor[2];
	    }
	
	    if(MAX_RESOLUTION < coords[0].shape[0] ||
	        MAX_RESOLUTION < coords[0].shape[1]) {
	        this.refineData = false;
	    }
	
	    if(this.refineData === true) {
	        this.dataScaleX = this.estimateScale(coords[0].shape[0], 0);
	        this.dataScaleY = this.estimateScale(coords[0].shape[1], 1);
	        if(this.dataScaleX !== 1 || this.dataScaleY !== 1) {
	            this.refineCoords(coords);
	        }
	    }
	
	    if(data.surfacecolor) {
	        params.intensity = coords.pop();
	    }
	
	    var highlightEnable = [true, true, true];
	    var axis = ['x', 'y', 'z'];
	
	    for(i = 0; i < 3; ++i) {
	        var contourParams = data.contours[axis[i]];
	        highlightEnable[i] = contourParams.highlight;
	
	        params.showContour[i] = contourParams.show || contourParams.highlight;
	        if(!params.showContour[i]) continue;
	
	        params.contourProject[i] = [
	            contourParams.project.x,
	            contourParams.project.y,
	            contourParams.project.z
	        ];
	
	        if(contourParams.show) {
	            this.showContour[i] = true;
	            params.levels[i] = contourLevels[i];
	            surface.highlightColor[i] = params.contourColor[i] = str2RgbaArray(contourParams.color);
	
	            if(contourParams.usecolormap) {
	                surface.highlightTint[i] = params.contourTint[i] = 0;
	            } else {
	                surface.highlightTint[i] = params.contourTint[i] = 1;
	            }
	            params.contourWidth[i] = contourParams.width;
	
	            this.contourStart[i] = contourParams.start;
	            this.contourEnd[i] = contourParams.end;
	            this.contourSize[i] = contourParams.size;
	        } else {
	            this.showContour[i] = false;
	
	            this.contourStart[i] = null;
	            this.contourEnd[i] = null;
	            this.contourSize[i] = 0;
	        }
	
	        if(contourParams.highlight) {
	            params.dynamicColor[i] = str2RgbaArray(contourParams.highlightcolor);
	            params.dynamicWidth[i] = contourParams.highlightwidth;
	        }
	    }
	
	    // see https://github.com/plotly/plotly.js/issues/940
	    if(isColormapCircular(colormap)) {
	        params.vertexColor = true;
	    }
	
	    params.objectOffset = this.objectOffset;
	
	    params.coords = coords;
	    surface.update(params);
	
	    surface.visible = data.visible;
	    surface.enableDynamic = highlightEnable;
	    surface.enableHighlight = highlightEnable;
	
	    surface.snapToData = true;
	
	    if('lighting' in data) {
	        surface.ambientLight = data.lighting.ambient;
	        surface.diffuseLight = data.lighting.diffuse;
	        surface.specularLight = data.lighting.specular;
	        surface.roughness = data.lighting.roughness;
	        surface.fresnel = data.lighting.fresnel;
	    }
	
	    if('lightposition' in data) {
	        surface.lightPosition = [data.lightposition.x, data.lightposition.y, data.lightposition.z];
	    }
	
	    if(alpha && alpha < 1) {
	        surface.supportsTransparency = true;
	    }
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.surface);
	    this.surface.dispose();
	};
	
	function createSurfaceTrace(scene, data) {
	    var gl = scene.glplot.gl;
	    var surface = createSurface({ gl: gl });
	    var result = new SurfaceTrace(scene, surface, data.uid);
	    surface._trace = result;
	    result.update(data);
	    scene.glplot.add(surface);
	    return result;
	}
	
	module.exports = createSurfaceTrace;
	
	},{"../../components/colorscale":603,"../../lib":716,"../../lib/gl_format_color":713,"../../lib/str2rgbarray":739,"../heatmap/find_empties":1004,"../heatmap/interp2d":1007,"gl-surface3d":317,"ndarray":451,"ndarray-fill":441,"ndarray-homography":443}],1243:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Registry = _dereq_('../../registry');
	var Lib = _dereq_('../../lib');
	
	var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    var i, j;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var x = coerce('x');
	    var y = coerce('y');
	
	    var z = coerce('z');
	    if(!z || !z.length ||
	       (x ? (x.length < 1) : false) ||
	       (y ? (y.length < 1) : false)
	    ) {
	        traceOut.visible = false;
	        return;
	    }
	
	    traceOut._xlength = (Array.isArray(x) && Lib.isArrayOrTypedArray(x[0])) ? z.length : z[0].length;
	    traceOut._ylength = z.length;
	
	    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
	    handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
	
	    coerce('text');
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    // Coerce remaining properties
	    [
	        'lighting.ambient',
	        'lighting.diffuse',
	        'lighting.specular',
	        'lighting.roughness',
	        'lighting.fresnel',
	        'lightposition.x',
	        'lightposition.y',
	        'lightposition.z',
	        'hidesurface',
	        'connectgaps',
	        'opacity'
	    ].forEach(function(x) { coerce(x); });
	
	    var surfaceColor = coerce('surfacecolor');
	
	    var dims = ['x', 'y', 'z'];
	    for(i = 0; i < 3; ++i) {
	        var contourDim = 'contours.' + dims[i];
	        var show = coerce(contourDim + '.show');
	        var highlight = coerce(contourDim + '.highlight');
	
	        if(show || highlight) {
	            for(j = 0; j < 3; ++j) {
	                coerce(contourDim + '.project.' + dims[j]);
	            }
	        }
	
	        if(show) {
	            coerce(contourDim + '.color');
	            coerce(contourDim + '.width');
	            coerce(contourDim + '.usecolormap');
	        }
	
	        if(highlight) {
	            coerce(contourDim + '.highlightcolor');
	            coerce(contourDim + '.highlightwidth');
	        }
	
	        coerce(contourDim + '.start');
	        coerce(contourDim + '.end');
	        coerce(contourDim + '.size');
	    }
	
	    // backward compatibility block
	    if(!surfaceColor) {
	        mapLegacy(traceIn, 'zmin', 'cmin');
	        mapLegacy(traceIn, 'zmax', 'cmax');
	        mapLegacy(traceIn, 'zauto', 'cauto');
	    }
	
	    // TODO if contours.?.usecolormap are false and hidesurface is true
	    // the colorbar shouldn't be shown by default
	
	    colorscaleDefaults(
	        traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'}
	    );
	
	    // disable 1D transforms - currently surface does NOT support column data like heatmap does
	    // you can use mesh3d for this use case, but not surface
	    traceOut._length = null;
	};
	
	function mapLegacy(traceIn, oldAttr, newAttr) {
	    if(oldAttr in traceIn && !(newAttr in traceIn)) {
	        traceIn[newAttr] = traceIn[oldAttr];
	    }
	}
	
	},{"../../components/colorscale/defaults":601,"../../lib":716,"../../registry":845,"./attributes":1240}],1244:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./convert'),
	
	    moduleType: 'trace',
	    name: 'surface',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d', '2dMap'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"./attributes":1240,"./calc":1241,"./convert":1242,"./defaults":1243}],1245:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var annAttrs = _dereq_('../../components/annotations/attributes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	var fontAttrs = _dereq_('../../plots/font_attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	
	var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
	
	var attrs = module.exports = overrideAll({
	    domain: domainAttrs({name: 'table', trace: true}),
	
	    columnwidth: {
	        valType: 'number',
	        arrayOk: true,
	        dflt: null,
	        
	        
	    },
	
	    columnorder: {
	        valType: 'data_array',
	        
	        
	    },
	
	    header: {
	
	        values: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	
	        format: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	
	        prefix: {
	            valType: 'string',
	            arrayOk: true,
	            dflt: null,
	            
	            
	        },
	
	        suffix: {
	            valType: 'string',
	            arrayOk: true,
	            dflt: null,
	            
	            
	        },
	
	        height: {
	            valType: 'number',
	            dflt: 28,
	            
	            
	        },
	
	        align: extendFlat({}, annAttrs.align, {arrayOk: true}),
	
	        line: {
	            width: {
	                valType: 'number',
	                arrayOk: true,
	                dflt: 1,
	                
	            },
	            color: {
	                valType: 'color',
	                arrayOk: true,
	                dflt: 'grey',
	                
	            }
	        },
	
	        fill: {
	            color: {
	                valType: 'color',
	                arrayOk: true,
	                dflt: 'white',
	                
	                
	            }
	        },
	
	        font: extendFlat({}, fontAttrs({arrayOk: true}))
	    },
	
	    cells: {
	
	        values: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	
	        format: {
	            valType: 'data_array',
	            
	            dflt: [],
	            
	        },
	
	        prefix: {
	            valType: 'string',
	            arrayOk: true,
	            dflt: null,
	            
	            
	        },
	
	        suffix: {
	            valType: 'string',
	            arrayOk: true,
	            dflt: null,
	            
	            
	        },
	
	        height: {
	            valType: 'number',
	            dflt: 20,
	            
	            
	        },
	
	        align: extendFlat({}, annAttrs.align, {arrayOk: true}),
	
	        line: {
	            width: {
	                valType: 'number',
	                arrayOk: true,
	                dflt: 1,
	                
	            },
	            color: {
	                valType: 'color',
	                arrayOk: true,
	                dflt: 'grey',
	                
	            }
	        },
	
	        fill: {
	            color: {
	                valType: 'color',
	                arrayOk: true,
	                
	                dflt: 'white',
	                
	            }
	        },
	
	        font: extendFlat({}, fontAttrs({arrayOk: true}))
	    }
	}, 'calc', 'from-root');
	attrs.transforms = undefined;
	
	},{"../../components/annotations/attributes":574,"../../constants/docs":687,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/domain":789,"../../plots/font_attributes":790}],1246:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
	var tablePlot = _dereq_('./plot');
	
	var TABLE = 'table';
	
	exports.name = TABLE;
	
	exports.plot = function(gd) {
	    var calcData = getModuleCalcData(gd.calcdata, TABLE)[0];
	    if(calcData.length) tablePlot(gd, calcData);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    var hadTable = (oldFullLayout._has && oldFullLayout._has(TABLE));
	    var hasTable = (newFullLayout._has && newFullLayout._has(TABLE));
	
	    if(hadTable && !hasTable) {
	        oldFullLayout._paperdiv.selectAll('.table').remove();
	    }
	};
	
	},{"../../plots/get_data":799,"./plot":1253}],1247:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var wrap = _dereq_('../../lib/gup').wrap;
	
	module.exports = function calc() {
	    // we don't actually need to include the trace here, since that will be added
	    // by Plots.doCalcdata, and that's all we actually need later.
	    return wrap({});
	};
	
	},{"../../lib/gup":714}],1248:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    cellPad: 8,
	    columnExtentOffset: 10,
	    columnTitleOffset: 28,
	    emptyHeaderHeight: 16,
	    latexCheck: /^\$.*\$$/,
	    goldenRatio: 1.618,
	    lineBreaker: '<br>',
	    maxDimensionCount: 60,
	    overdrag: 45,
	    releaseTransitionDuration: 120,
	    releaseTransitionEase: 'cubic-out',
	    scrollbarCaptureWidth: 18,
	    scrollbarHideDelay: 1000,
	    scrollbarHideDuration: 1000,
	    scrollbarOffset: 5,
	    scrollbarWidth: 8,
	    transitionDuration: 100,
	    transitionEase: 'cubic-out',
	    uplift: 5,
	    wrapSpacer: ' ',
	    wrapSplitCharacter: ' ',
	    cn: {
	        // general class names
	        table: 'table',
	        tableControlView: 'table-control-view',
	        scrollBackground: 'scroll-background',
	        yColumn: 'y-column',
	        columnBlock: 'column-block',
	        scrollAreaClip: 'scroll-area-clip',
	        scrollAreaClipRect: 'scroll-area-clip-rect',
	        columnBoundary: 'column-boundary',
	        columnBoundaryClippath: 'column-boundary-clippath',
	        columnBoundaryRect: 'column-boundary-rect',
	        columnCells: 'column-cells',
	        columnCell: 'column-cell',
	        cellRect: 'cell-rect',
	        cellText: 'cell-text',
	        cellTextHolder: 'cell-text-holder',
	
	        // scroll related class names
	        scrollbarKit: 'scrollbar-kit',
	        scrollbar: 'scrollbar',
	        scrollbarSlider: 'scrollbar-slider',
	        scrollbarGlyph: 'scrollbar-glyph',
	        scrollbarCaptureZone: 'scrollbar-capture-zone'
	    }
	};
	
	},{}],1249:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var c = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var isNumeric = _dereq_('fast-isnumeric');
	
	// pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying
	module.exports = function calc(gd, trace) {
	    var cellsValues = squareStringMatrix(trace.cells.values);
	    var slicer = function(a) {
	        return a.slice(trace.header.values.length, a.length);
	    };
	    var headerValuesIn = squareStringMatrix(trace.header.values);
	    if(headerValuesIn.length && !headerValuesIn[0].length) {
	        headerValuesIn[0] = [''];
	        headerValuesIn = squareStringMatrix(headerValuesIn);
	    }
	    var headerValues = headerValuesIn
	        .concat(slicer(cellsValues).map(function() {
	            return emptyStrings((headerValuesIn[0] || ['']).length);
	        }));
	
	    var domain = trace.domain;
	    var groupWidth = Math.floor(gd._fullLayout._size.w * (domain.x[1] - domain.x[0]));
	    var groupHeight = Math.floor(gd._fullLayout._size.h * (domain.y[1] - domain.y[0]));
	    var headerRowHeights = trace.header.values.length ?
	        headerValues[0].map(function() { return trace.header.height; }) :
	        [c.emptyHeaderHeight];
	    var rowHeights = cellsValues.length ? cellsValues[0].map(function() { return trace.cells.height; }) : [];
	    var headerHeight = headerRowHeights.reduce(sum, 0);
	    var scrollHeight = groupHeight - headerHeight;
	    var minimumFillHeight = scrollHeight + c.uplift;
	    var anchorToRowBlock = makeAnchorToRowBlock(rowHeights, minimumFillHeight);
	    var anchorToHeaderRowBlock = makeAnchorToRowBlock(headerRowHeights, headerHeight);
	    var headerRowBlocks = makeRowBlock(anchorToHeaderRowBlock, []);
	    var rowBlocks = makeRowBlock(anchorToRowBlock, headerRowBlocks);
	    var uniqueKeys = {};
	    var columnOrder = trace._fullInput.columnorder.concat(slicer(cellsValues.map(function(d, i) {return i;})));
	    var columnWidths = headerValues.map(function(d, i) {
	        var value = Array.isArray(trace.columnwidth) ?
	            trace.columnwidth[Math.min(i, trace.columnwidth.length - 1)] :
	            trace.columnwidth;
	        return isNumeric(value) ? Number(value) : 1;
	    });
	    var totalColumnWidths = columnWidths.reduce(sum, 0);
	
	    // fit columns in the available vertical space as there's no vertical scrolling now
	    columnWidths = columnWidths.map(function(d) { return d / totalColumnWidths * groupWidth; });
	
	    var maxLineWidth = Math.max(arrayMax(trace.header.line.width), arrayMax(trace.cells.line.width));
	
	    var calcdata = {
	        // include staticPlot in the key so if it changes we delete and redraw
	        key: trace.uid + gd._context.staticPlot,
	        translateX: domain.x[0] * gd._fullLayout._size.w,
	        translateY: gd._fullLayout._size.h * (1 - domain.y[1]),
	        size: gd._fullLayout._size,
	        width: groupWidth,
	        maxLineWidth: maxLineWidth,
	        height: groupHeight,
	        columnOrder: columnOrder, // will be mutated on column move, todo use in callback
	        groupHeight: groupHeight,
	        rowBlocks: rowBlocks,
	        headerRowBlocks: headerRowBlocks,
	        scrollY: 0, // will be mutated on scroll
	        cells: extendFlat({}, trace.cells, {values: cellsValues}),
	        headerCells: extendFlat({}, trace.header, {values: headerValues}),
	        gdColumns: headerValues.map(function(d) {return d[0];}),
	        gdColumnsOriginalOrder: headerValues.map(function(d) {return d[0];}),
	        prevPages: [0, 0],
	        scrollbarState: {scrollbarScrollInProgress: false},
	        columns: headerValues.map(function(label, i) {
	            var foundKey = uniqueKeys[label];
	            uniqueKeys[label] = (foundKey || 0) + 1;
	            var key = label + '__' + uniqueKeys[label];
	            return {
	                key: key,
	                label: label,
	                specIndex: i,
	                xIndex: columnOrder[i],
	                xScale: xScale,
	                x: undefined, // initialized below
	                calcdata: undefined, // initialized below
	                columnWidth: columnWidths[i]
	            };
	        })
	    };
	
	    calcdata.columns.forEach(function(col) {
	        col.calcdata = calcdata;
	        col.x = xScale(col);
	    });
	
	    return calcdata;
	};
	
	function arrayMax(maybeArray) {
	    if(Array.isArray(maybeArray)) {
	        var max = 0;
	        for(var i = 0; i < maybeArray.length; i++) {
	            max = Math.max(max, arrayMax(maybeArray[i]));
	        }
	        return max;
	    }
	    return maybeArray;
	}
	
	function sum(a, b) { return a + b; }
	
	// fill matrix in place to equal lengths
	// and ensure it's uniformly 2D
	function squareStringMatrix(matrixIn) {
	    var matrix = matrixIn.slice();
	    var minLen = Infinity;
	    var maxLen = 0;
	    var i;
	    for(i = 0; i < matrix.length; i++) {
	        if(!Array.isArray(matrix[i])) matrix[i] = [matrix[i]];
	        minLen = Math.min(minLen, matrix[i].length);
	        maxLen = Math.max(maxLen, matrix[i].length);
	    }
	
	    if(minLen !== maxLen) {
	        for(i = 0; i < matrix.length; i++) {
	            var padLen = maxLen - matrix[i].length;
	            if(padLen) matrix[i] = matrix[i].concat(emptyStrings(padLen));
	        }
	    }
	    return matrix;
	}
	
	function emptyStrings(len) {
	    var padArray = new Array(len);
	    for(var j = 0; j < len; j++) padArray[j] = '';
	    return padArray;
	}
	
	function xScale(d) {
	    return d.calcdata.columns.reduce(function(prev, next) {
	        return next.xIndex < d.xIndex ? prev + next.columnWidth : prev;
	    }, 0);
	}
	
	function makeRowBlock(anchorToRowBlock, auxiliary) {
	    var blockAnchorKeys = Object.keys(anchorToRowBlock);
	    return blockAnchorKeys.map(function(k) {return extendFlat({}, anchorToRowBlock[k], {auxiliaryBlocks: auxiliary});});
	}
	
	function makeAnchorToRowBlock(rowHeights, minimumFillHeight) {
	    var anchorToRowBlock = {};
	    var currentRowHeight;
	    var currentAnchor = 0;
	    var currentBlockHeight = 0;
	    var currentBlock = makeIdentity();
	    var currentFirstRowIndex = 0;
	    var blockCounter = 0;
	    for(var i = 0; i < rowHeights.length; i++) {
	        currentRowHeight = rowHeights[i];
	        currentBlock.rows.push({
	            rowIndex: i,
	            rowHeight: currentRowHeight
	        });
	        currentBlockHeight += currentRowHeight;
	        if(currentBlockHeight >= minimumFillHeight || i === rowHeights.length - 1) {
	            anchorToRowBlock[currentAnchor] = currentBlock;
	            currentBlock.key = blockCounter++;
	            currentBlock.firstRowIndex = currentFirstRowIndex;
	            currentBlock.lastRowIndex = i;
	            currentBlock = makeIdentity();
	            currentAnchor += currentBlockHeight;
	            currentFirstRowIndex = i + 1;
	            currentBlockHeight = 0;
	        }
	    }
	
	    return anchorToRowBlock;
	}
	
	function makeIdentity() {
	    return {
	        firstRowIndex: null,
	        lastRowIndex: null,
	        rows: []
	    };
	}
	
	},{"../../lib/extend":707,"./constants":1248,"fast-isnumeric":227}],1250:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	// pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying
	
	exports.splitToPanels = function(d) {
	    var prevPages = [0, 0];
	    var headerPanel = extendFlat({}, d, {
	        key: 'header',
	        type: 'header',
	        page: 0,
	        prevPages: prevPages,
	        currentRepaint: [null, null],
	        dragHandle: true,
	        values: d.calcdata.headerCells.values[d.specIndex],
	        rowBlocks: d.calcdata.headerRowBlocks,
	        calcdata: extendFlat({}, d.calcdata, {cells: d.calcdata.headerCells})
	    });
	    var revolverPanel1 = extendFlat({}, d, {
	        key: 'cells1',
	        type: 'cells',
	        page: 0,
	        prevPages: prevPages,
	        currentRepaint: [null, null],
	        dragHandle: false,
	        values: d.calcdata.cells.values[d.specIndex],
	        rowBlocks: d.calcdata.rowBlocks
	    });
	    var revolverPanel2 = extendFlat({}, d, {
	        key: 'cells2',
	        type: 'cells',
	        page: 1,
	        prevPages: prevPages,
	        currentRepaint: [null, null],
	        dragHandle: false,
	        values: d.calcdata.cells.values[d.specIndex],
	        rowBlocks: d.calcdata.rowBlocks
	    });
	    // order due to SVG using painter's algo:
	    return [revolverPanel1, revolverPanel2, headerPanel];
	};
	
	exports.splitToCells = function(d) {
	    var fromTo = rowFromTo(d);
	    return (d.values || []).slice(fromTo[0], fromTo[1]).map(function(v, i) {
	        // By keeping identical key, a DOM node removal, creation and addition is spared, important when visible
	        // grid has a lot of elements (quadratic with xcol/ycol count).
	        // But it has to be busted when `svgUtil.convertToTspans` is used as it reshapes cell subtrees asynchronously,
	        // and by that time the user may have scrolled away, resulting in stale overwrites. The real solution will be
	        // to turn `svgUtil.convertToTspans` into a cancelable request, in which case no key busting is needed.
	        var buster = (typeof v === 'string') && v.match(/[<$&> ]/) ? '_keybuster_' + Math.random() : '';
	        return {
	            // keyWithinBlock: /*fromTo[0] + */i, // optimized future version - no busting
	            // keyWithinBlock: fromTo[0] + i, // initial always-unoptimized version - janky scrolling with 5+ columns
	            keyWithinBlock: i + buster, // current compromise: regular content is very fast; async content is possible
	            key: fromTo[0] + i,
	            column: d,
	            calcdata: d.calcdata,
	            page: d.page,
	            rowBlocks: d.rowBlocks,
	            value: v
	        };
	    });
	};
	
	function rowFromTo(d) {
	    var rowBlock = d.rowBlocks[d.page];
	    // fixme rowBlock truthiness check is due to ugly hack of placing 2nd panel as d.page = -1
	    var rowFrom = rowBlock ? rowBlock.rows[0].rowIndex : 0;
	    var rowTo = rowBlock ? rowFrom + rowBlock.rows.length : 0;
	    return [rowFrom, rowTo];
	}
	
	},{"../../lib/extend":707}],1251:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	
	function defaultColumnOrder(traceOut, coerce) {
	    var specifiedColumnOrder = traceOut.columnorder || [];
	    var commonLength = traceOut.header.values.length;
	    var truncated = specifiedColumnOrder.slice(0, commonLength);
	    var sorted = truncated.slice().sort(function(a, b) {return a - b;});
	    var oneStepped = truncated.map(function(d) {return sorted.indexOf(d);});
	    for(var i = oneStepped.length; i < commonLength; i++) {
	        oneStepped.push(i);
	    }
	    coerce('columnorder', oneStepped);
	}
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    coerce('columnwidth');
	
	    coerce('header.values');
	    coerce('header.format');
	    coerce('header.align');
	
	    coerce('header.prefix');
	    coerce('header.suffix');
	    coerce('header.height');
	    coerce('header.line.width');
	    coerce('header.line.color');
	    coerce('header.fill.color');
	    Lib.coerceFont(coerce, 'header.font', Lib.extendFlat({}, layout.font));
	
	    defaultColumnOrder(traceOut, coerce);
	
	    coerce('cells.values');
	    coerce('cells.format');
	    coerce('cells.align');
	    coerce('cells.prefix');
	    coerce('cells.suffix');
	    coerce('cells.height');
	    coerce('cells.line.width');
	    coerce('cells.line.color');
	    coerce('cells.fill.color');
	    Lib.coerceFont(coerce, 'cells.font', Lib.extendFlat({}, layout.font));
	
	    // disable 1D transforms
	    traceOut._length = null;
	};
	
	},{"../../lib":716,"../../plots/domain":789,"./attributes":1245}],1252:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('./calc'),
	    plot: _dereq_('./plot'),
	
	    moduleType: 'trace',
	    name: 'table',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: ['noOpacity'],
	    meta: {
	        
	    }
	};
	
	},{"./attributes":1245,"./base_plot":1246,"./calc":1247,"./defaults":1251,"./plot":1253}],1253:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var c = _dereq_('./constants');
	var d3 = _dereq_('d3');
	var gup = _dereq_('../../lib/gup');
	var Drawing = _dereq_('../../components/drawing');
	var svgUtil = _dereq_('../../lib/svg_text_utils');
	var raiseToTop = _dereq_('../../lib').raiseToTop;
	var cancelEeaseColumn = _dereq_('../../lib').cancelTransition;
	var prepareData = _dereq_('./data_preparation_helper');
	var splitData = _dereq_('./data_split_helpers');
	var Color = _dereq_('../../components/color');
	
	module.exports = function plot(gd, wrappedTraceHolders) {
	    var dynamic = !gd._context.staticPlot;
	
	    var table = gd._fullLayout._paper.selectAll('.' + c.cn.table)
	        .data(wrappedTraceHolders.map(function(wrappedTraceHolder) {
	            var traceHolder = gup.unwrap(wrappedTraceHolder);
	            var trace = traceHolder.trace;
	            return prepareData(gd, trace);
	        }), gup.keyFun);
	
	    table.exit().remove();
	
	    table.enter()
	        .append('g')
	        .classed(c.cn.table, true)
	        .attr('overflow', 'visible')
	        .style('box-sizing', 'content-box')
	        .style('position', 'absolute')
	        .style('left', 0)
	        .style('overflow', 'visible')
	        .style('shape-rendering', 'crispEdges')
	        .style('pointer-events', 'all');
	
	    table
	        .attr('width', function(d) {return d.width + d.size.l + d.size.r;})
	        .attr('height', function(d) {return d.height + d.size.t + d.size.b;})
	        .attr('transform', function(d) {
	            return 'translate(' + d.translateX + ',' + d.translateY + ')';
	        });
	
	    var tableControlView = table.selectAll('.' + c.cn.tableControlView)
	        .data(gup.repeat, gup.keyFun);
	
	    var cvEnter = tableControlView.enter()
	        .append('g')
	        .classed(c.cn.tableControlView, true)
	        .style('box-sizing', 'content-box');
	    if(dynamic) {
	        cvEnter
	            .on('mousemove', function(d) {
	                tableControlView
	                    .filter(function(dd) {return d === dd;})
	                    .call(renderScrollbarKit, gd);
	            })
	            .on('mousewheel', function(d) {
	                if(d.scrollbarState.wheeling) return;
	                d.scrollbarState.wheeling = true;
	                var newY = d.scrollY + d3.event.deltaY;
	                var noChange = makeDragRow(gd, tableControlView, null, newY)(d);
	                if(!noChange) {
	                    d3.event.stopPropagation();
	                    d3.event.preventDefault();
	                }
	                d.scrollbarState.wheeling = false;
	            })
	            .call(renderScrollbarKit, gd, true);
	    }
	
	    tableControlView
	        .attr('transform', function(d) {return 'translate(' + d.size.l + ' ' + d.size.t + ')';});
	
	    // scrollBackground merely ensures that mouse events are captured even on crazy fast scrollwheeling
	    // otherwise rendering glitches may occur
	    var scrollBackground = tableControlView.selectAll('.' + c.cn.scrollBackground)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollBackground.enter()
	        .append('rect')
	        .classed(c.cn.scrollBackground, true)
	        .attr('fill', 'none');
	
	    scrollBackground
	        .attr('width', function(d) {return d.width;})
	        .attr('height', function(d) {return d.height;});
	
	    tableControlView.each(function(d) {
	        Drawing.setClipUrl(d3.select(this), scrollAreaBottomClipKey(gd, d), gd);
	    });
	
	    var yColumn = tableControlView.selectAll('.' + c.cn.yColumn)
	        .data(function(vm) {return vm.columns;}, gup.keyFun);
	
	    yColumn.enter()
	        .append('g')
	        .classed(c.cn.yColumn, true);
	
	    yColumn.exit().remove();
	
	    yColumn.attr('transform', function(d) {return 'translate(' + d.x + ' 0)';});
	
	    if(dynamic) {
	        yColumn.call(d3.behavior.drag()
	            .origin(function(d) {
	                var movedColumn = d3.select(this);
	                easeColumn(movedColumn, d, -c.uplift);
	                raiseToTop(this);
	                d.calcdata.columnDragInProgress = true;
	                renderScrollbarKit(tableControlView.filter(function(dd) {return d.calcdata.key === dd.key;}), gd);
	                return d;
	            })
	            .on('drag', function(d) {
	                var movedColumn = d3.select(this);
	                var getter = function(dd) {return (d === dd ? d3.event.x : dd.x) + dd.columnWidth / 2;};
	                d.x = Math.max(-c.overdrag, Math.min(d.calcdata.width + c.overdrag - d.columnWidth, d3.event.x));
	
	                var sortableColumns = flatData(yColumn).filter(function(dd) {return dd.calcdata.key === d.calcdata.key;});
	                var newOrder = sortableColumns.sort(function(a, b) {return getter(a) - getter(b);});
	                newOrder.forEach(function(dd, i) {
	                    dd.xIndex = i;
	                    dd.x = d === dd ? dd.x : dd.xScale(dd);
	                });
	
	                yColumn.filter(function(dd) {return d !== dd;})
	                    .transition()
	                    .ease(c.transitionEase)
	                    .duration(c.transitionDuration)
	                    .attr('transform', function(d) {return 'translate(' + d.x + ' 0)';});
	                movedColumn
	                    .call(cancelEeaseColumn)
	                    .attr('transform', 'translate(' + d.x + ' -' + c.uplift + ' )');
	            })
	            .on('dragend', function(d) {
	                var movedColumn = d3.select(this);
	                var p = d.calcdata;
	                d.x = d.xScale(d);
	                d.calcdata.columnDragInProgress = false;
	                easeColumn(movedColumn, d, 0);
	                columnMoved(gd, p, p.columns.map(function(dd) {return dd.xIndex;}));
	            })
	        );
	    }
	
	    yColumn.each(function(d) {
	        Drawing.setClipUrl(d3.select(this), columnBoundaryClipKey(gd, d), gd);
	    });
	
	    var columnBlock = yColumn.selectAll('.' + c.cn.columnBlock)
	        .data(splitData.splitToPanels, gup.keyFun);
	
	    columnBlock.enter()
	        .append('g')
	        .classed(c.cn.columnBlock, true)
	        .attr('id', function(d) {return d.key;});
	
	    columnBlock
	        .style('cursor', function(d) {
	            return d.dragHandle ? 'ew-resize' : d.calcdata.scrollbarState.barWiggleRoom ? 'ns-resize' : 'default';
	        });
	
	    var headerColumnBlock = columnBlock.filter(headerBlock);
	    var cellsColumnBlock = columnBlock.filter(cellsBlock);
	
	    if(dynamic) {
	        cellsColumnBlock.call(d3.behavior.drag()
	            .origin(function(d) {
	                d3.event.stopPropagation();
	                return d;
	            })
	            .on('drag', makeDragRow(gd, tableControlView, -1))
	            .on('dragend', function() {
	                // fixme emit plotly notification
	            })
	        );
	    }
	
	    // initial rendering: header is rendered first, as it may may have async LaTeX (show header first)
	    // but blocks are _entered_ the way they are due to painter's algo (header on top)
	    renderColumnCellTree(gd, tableControlView, headerColumnBlock, columnBlock);
	    renderColumnCellTree(gd, tableControlView, cellsColumnBlock, columnBlock);
	
	    var scrollAreaClip = tableControlView.selectAll('.' + c.cn.scrollAreaClip)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollAreaClip.enter()
	        .append('clipPath')
	        .classed(c.cn.scrollAreaClip, true)
	        .attr('id', function(d) {return scrollAreaBottomClipKey(gd, d);});
	
	    var scrollAreaClipRect = scrollAreaClip.selectAll('.' + c.cn.scrollAreaClipRect)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollAreaClipRect.enter()
	        .append('rect')
	        .classed(c.cn.scrollAreaClipRect, true)
	        .attr('x', -c.overdrag)
	        .attr('y', -c.uplift)
	        .attr('fill', 'none');
	
	    scrollAreaClipRect
	        .attr('width', function(d) {return d.width + 2 * c.overdrag;})
	        .attr('height', function(d) {return d.height + c.uplift;});
	
	    var columnBoundary = yColumn.selectAll('.' + c.cn.columnBoundary)
	        .data(gup.repeat, gup.keyFun);
	
	    columnBoundary.enter()
	        .append('g')
	        .classed(c.cn.columnBoundary, true);
	
	    var columnBoundaryClippath = yColumn.selectAll('.' + c.cn.columnBoundaryClippath)
	        .data(gup.repeat, gup.keyFun);
	
	    // SVG spec doesn't mandate wrapping into a <defs> and doesn't seem to cause a speed difference
	    columnBoundaryClippath.enter()
	        .append('clipPath')
	        .classed(c.cn.columnBoundaryClippath, true);
	
	    columnBoundaryClippath
	        .attr('id', function(d) {return columnBoundaryClipKey(gd, d);});
	
	    var columnBoundaryRect = columnBoundaryClippath.selectAll('.' + c.cn.columnBoundaryRect)
	        .data(gup.repeat, gup.keyFun);
	
	    columnBoundaryRect.enter()
	        .append('rect')
	        .classed(c.cn.columnBoundaryRect, true)
	        .attr('fill', 'none');
	
	    columnBoundaryRect
	        .attr('width', function(d) { return d.columnWidth + 2 * roundHalfWidth(d); })
	        .attr('height', function(d) {return d.calcdata.height + 2 * roundHalfWidth(d) + c.uplift;})
	        .attr('x', function(d) { return -roundHalfWidth(d); })
	        .attr('y', function(d) { return -roundHalfWidth(d); });
	
	    updateBlockYPosition(null, cellsColumnBlock, tableControlView);
	};
	
	function roundHalfWidth(d) {
	    return Math.ceil(d.calcdata.maxLineWidth / 2);
	}
	
	function scrollAreaBottomClipKey(gd, d) {
	    return 'clip' + gd._fullLayout._uid + '_scrollAreaBottomClip_' + d.key;
	}
	
	function columnBoundaryClipKey(gd, d) {
	    return 'clip' + gd._fullLayout._uid + '_columnBoundaryClippath_' + d.calcdata.key + '_' + d.specIndex;
	}
	
	function flatData(selection) {
	    return [].concat.apply([], selection.map(function(g) {return g;}))
	        .map(function(g) {return g.__data__;});
	}
	
	function renderScrollbarKit(tableControlView, gd, bypassVisibleBar) {
	    function calcTotalHeight(d) {
	        var blocks = d.rowBlocks;
	        return firstRowAnchor(blocks, blocks.length - 1) + (blocks.length ? rowsHeight(blocks[blocks.length - 1], Infinity) : 1);
	    }
	
	    var scrollbarKit = tableControlView.selectAll('.' + c.cn.scrollbarKit)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollbarKit.enter()
	        .append('g')
	        .classed(c.cn.scrollbarKit, true)
	        .style('shape-rendering', 'geometricPrecision');
	
	    scrollbarKit
	        .each(function(d) {
	            var s = d.scrollbarState;
	            s.totalHeight = calcTotalHeight(d);
	            s.scrollableAreaHeight = d.groupHeight - headerHeight(d);
	            s.currentlyVisibleHeight = Math.min(s.totalHeight, s.scrollableAreaHeight);
	            s.ratio = s.currentlyVisibleHeight / s.totalHeight;
	            s.barLength = Math.max(s.ratio * s.currentlyVisibleHeight, c.goldenRatio * c.scrollbarWidth);
	            s.barWiggleRoom = s.currentlyVisibleHeight - s.barLength;
	            s.wiggleRoom = Math.max(0, s.totalHeight - s.scrollableAreaHeight);
	            s.topY = s.barWiggleRoom === 0 ? 0 : (d.scrollY / s.wiggleRoom) * s.barWiggleRoom;
	            s.bottomY = s.topY + s.barLength;
	            s.dragMultiplier = s.wiggleRoom / s.barWiggleRoom;
	        })
	        .attr('transform', function(d) {
	            var xPosition = d.width + c.scrollbarWidth / 2 + c.scrollbarOffset;
	            return 'translate(' + xPosition + ' ' + headerHeight(d) + ')';
	        });
	
	    var scrollbar = scrollbarKit.selectAll('.' + c.cn.scrollbar)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollbar.enter()
	        .append('g')
	        .classed(c.cn.scrollbar, true);
	
	    var scrollbarSlider = scrollbar.selectAll('.' + c.cn.scrollbarSlider)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollbarSlider.enter()
	        .append('g')
	        .classed(c.cn.scrollbarSlider, true);
	
	    scrollbarSlider
	        .attr('transform', function(d) {
	            return 'translate(0 ' + (d.scrollbarState.topY || 0) + ')';
	        });
	
	    var scrollbarGlyph = scrollbarSlider.selectAll('.' + c.cn.scrollbarGlyph)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollbarGlyph.enter()
	        .append('line')
	        .classed(c.cn.scrollbarGlyph, true)
	        .attr('stroke', 'black')
	        .attr('stroke-width', c.scrollbarWidth)
	        .attr('stroke-linecap', 'round')
	        .attr('y1', c.scrollbarWidth / 2);
	
	    scrollbarGlyph
	        .attr('y2', function(d) {
	            return d.scrollbarState.barLength - c.scrollbarWidth / 2;
	        })
	        .attr('stroke-opacity', function(d) {
	            return d.columnDragInProgress || !d.scrollbarState.barWiggleRoom || bypassVisibleBar ? 0 : 0.4;
	        });
	
	    // cancel transition: possible pending (also, delayed) transition
	    scrollbarGlyph
	        .transition().delay(0).duration(0);
	
	    scrollbarGlyph
	        .transition().delay(c.scrollbarHideDelay).duration(c.scrollbarHideDuration)
	        .attr('stroke-opacity', 0);
	
	    var scrollbarCaptureZone = scrollbar.selectAll('.' + c.cn.scrollbarCaptureZone)
	        .data(gup.repeat, gup.keyFun);
	
	    scrollbarCaptureZone.enter()
	        .append('line')
	        .classed(c.cn.scrollbarCaptureZone, true)
	        .attr('stroke', 'white')
	        .attr('stroke-opacity', 0.01) // some browser might get rid of a 0 opacity element
	        .attr('stroke-width', c.scrollbarCaptureWidth)
	        .attr('stroke-linecap', 'butt')
	        .attr('y1', 0)
	        .on('mousedown', function(d) {
	            var y = d3.event.y;
	            var bbox = this.getBoundingClientRect();
	            var s = d.scrollbarState;
	            var pixelVal = y - bbox.top;
	            var inverseScale = d3.scale.linear().domain([0, s.scrollableAreaHeight]).range([0, s.totalHeight]).clamp(true);
	            if(!(s.topY <= pixelVal && pixelVal <= s.bottomY)) {
	                makeDragRow(gd, tableControlView, null, inverseScale(pixelVal - s.barLength / 2))(d);
	            }
	        })
	        .call(d3.behavior.drag()
	            .origin(function(d) {
	                d3.event.stopPropagation();
	                d.scrollbarState.scrollbarScrollInProgress = true;
	                return d;
	            })
	            .on('drag', makeDragRow(gd, tableControlView))
	            .on('dragend', function() {
	                // fixme emit Plotly event
	            })
	        );
	
	    scrollbarCaptureZone
	        .attr('y2', function(d) {
	            return d.scrollbarState.scrollableAreaHeight;
	        });
	
	    // Remove scroll glyph and capture zone on static plots
	    // as they don't render properly when converted to PDF
	    // in the Chrome PDF viewer
	    // https://github.com/plotly/streambed/issues/11618
	    if(gd._context.staticPlot) {
	        scrollbarGlyph.remove();
	        scrollbarCaptureZone.remove();
	    }
	}
	
	function renderColumnCellTree(gd, tableControlView, columnBlock, allColumnBlock) {
	    // fixme this perf hotspot
	    // this is performance critical code as scrolling calls it on every revolver switch
	    // it appears sufficiently fast but there are plenty of low-hanging fruits for performance optimization
	
	    var columnCells = renderColumnCells(columnBlock);
	
	    var columnCell = renderColumnCell(columnCells);
	
	    supplyStylingValues(columnCell);
	
	    var cellRect = renderCellRect(columnCell);
	
	    sizeAndStyleRect(cellRect);
	
	    var cellTextHolder = renderCellTextHolder(columnCell);
	
	    var cellText = renderCellText(cellTextHolder);
	
	    setFont(cellText);
	    populateCellText(cellText, tableControlView, allColumnBlock, gd);
	
	    // doing this at the end when text, and text stlying are set
	    setCellHeightAndPositionY(columnCell);
	}
	
	function renderColumnCells(columnBlock) {
	    var columnCells = columnBlock.selectAll('.' + c.cn.columnCells)
	        .data(gup.repeat, gup.keyFun);
	
	    columnCells.enter()
	        .append('g')
	        .classed(c.cn.columnCells, true);
	
	    columnCells.exit()
	        .remove();
	
	    return columnCells;
	}
	
	function renderColumnCell(columnCells) {
	    var columnCell = columnCells.selectAll('.' + c.cn.columnCell)
	        .data(splitData.splitToCells, function(d) {return d.keyWithinBlock;});
	
	    columnCell.enter()
	        .append('g')
	        .classed(c.cn.columnCell, true);
	
	    columnCell.exit()
	        .remove();
	
	    return columnCell;
	}
	
	function renderCellRect(columnCell) {
	    var cellRect = columnCell.selectAll('.' + c.cn.cellRect)
	        .data(gup.repeat, function(d) {return d.keyWithinBlock;});
	
	    cellRect.enter()
	        .append('rect')
	        .classed(c.cn.cellRect, true);
	
	    return cellRect;
	}
	
	function renderCellText(cellTextHolder) {
	    var cellText = cellTextHolder.selectAll('.' + c.cn.cellText)
	        .data(gup.repeat, function(d) {return d.keyWithinBlock;});
	
	    cellText.enter()
	        .append('text')
	        .classed(c.cn.cellText, true)
	        .style('cursor', function() {return 'auto';})
	        .on('mousedown', function() {d3.event.stopPropagation();});
	
	    return cellText;
	}
	
	function renderCellTextHolder(columnCell) {
	    var cellTextHolder = columnCell.selectAll('.' + c.cn.cellTextHolder)
	        .data(gup.repeat, function(d) {return d.keyWithinBlock;});
	
	    cellTextHolder.enter()
	        .append('g')
	        .classed(c.cn.cellTextHolder, true)
	        .style('shape-rendering', 'geometricPrecision');
	
	    return cellTextHolder;
	}
	
	function supplyStylingValues(columnCell) {
	    columnCell
	        .each(function(d, i) {
	            var spec = d.calcdata.cells.font;
	            var col = d.column.specIndex;
	            var font = {
	                size: gridPick(spec.size, col, i),
	                color: gridPick(spec.color, col, i),
	                family: gridPick(spec.family, col, i)
	            };
	            d.rowNumber = d.key;
	            d.align = gridPick(d.calcdata.cells.align, col, i);
	            d.cellBorderWidth = gridPick(d.calcdata.cells.line.width, col, i);
	            d.font = font;
	        });
	}
	
	function setFont(cellText) {
	    cellText
	        .each(function(d) {
	            Drawing.font(d3.select(this), d.font);
	        });
	}
	
	function sizeAndStyleRect(cellRect) {
	    cellRect
	        .attr('width', function(d) {return d.column.columnWidth;})
	        .attr('stroke-width', function(d) {return d.cellBorderWidth;})
	        .each(function(d) {
	            var atomicSelection = d3.select(this);
	            Color.stroke(atomicSelection, gridPick(d.calcdata.cells.line.color, d.column.specIndex, d.rowNumber));
	            Color.fill(atomicSelection, gridPick(d.calcdata.cells.fill.color, d.column.specIndex, d.rowNumber));
	        });
	}
	
	function populateCellText(cellText, tableControlView, allColumnBlock, gd) {
	    cellText
	        .text(function(d) {
	            var col = d.column.specIndex;
	            var row = d.rowNumber;
	
	            var userSuppliedContent = d.value;
	            var stringSupplied = (typeof userSuppliedContent === 'string');
	            var hasBreaks = stringSupplied && userSuppliedContent.match(/<br>/i);
	            var userBrokenText = !stringSupplied || hasBreaks;
	            d.mayHaveMarkup = stringSupplied && userSuppliedContent.match(/[<&>]/);
	
	            var latex = isLatex(userSuppliedContent);
	            d.latex = latex;
	
	            var prefix = latex ? '' : gridPick(d.calcdata.cells.prefix, col, row) || '';
	            var suffix = latex ? '' : gridPick(d.calcdata.cells.suffix, col, row) || '';
	            var format = latex ? null : gridPick(d.calcdata.cells.format, col, row) || null;
	
	            var prefixSuffixedText = prefix + (format ? d3.format(format)(d.value) : d.value) + suffix;
	
	            var hasWrapSplitCharacter;
	            d.wrappingNeeded = !d.wrapped && !userBrokenText && !latex && (hasWrapSplitCharacter = hasWrapCharacter(prefixSuffixedText));
	            d.cellHeightMayIncrease = hasBreaks || latex || d.mayHaveMarkup || (hasWrapSplitCharacter === void(0) ? hasWrapCharacter(prefixSuffixedText) : hasWrapSplitCharacter);
	            d.needsConvertToTspans = d.mayHaveMarkup || d.wrappingNeeded || d.latex;
	
	            var textToRender;
	            if(d.wrappingNeeded) {
	                var hrefPreservedText = c.wrapSplitCharacter === ' ' ? prefixSuffixedText.replace(/<a href=/ig, '<a_href=') : prefixSuffixedText;
	                var fragments = hrefPreservedText.split(c.wrapSplitCharacter);
	                var hrefRestoredFragments = c.wrapSplitCharacter === ' ' ? fragments.map(function(frag) {return frag.replace(/<a_href=/ig, '<a href=');}) : fragments;
	                d.fragments = hrefRestoredFragments.map(function(f) {return {text: f, width: null};});
	                d.fragments.push({fragment: c.wrapSpacer, width: null});
	                textToRender = hrefRestoredFragments.join(c.lineBreaker) + c.lineBreaker + c.wrapSpacer;
	            } else {
	                delete d.fragments;
	                textToRender = prefixSuffixedText;
	            }
	
	            return textToRender;
	        })
	        .attr('dy', function(d) {
	            return d.needsConvertToTspans ? 0 : '0.75em';
	        })
	        .each(function(d) {
	            var element = this;
	            var selection = d3.select(element);
	
	            // finalize what's in the DOM
	
	            var renderCallback = d.wrappingNeeded ? wrapTextMaker : updateYPositionMaker;
	            if(d.needsConvertToTspans) {
	                svgUtil.convertToTspans(selection, gd, renderCallback(allColumnBlock, element, tableControlView, gd, d));
	            } else {
	                d3.select(element.parentNode)
	                    // basic cell adjustment - compliance with `cellPad`
	                    .attr('transform', function(d) {return 'translate(' + xPosition(d) + ' ' + c.cellPad + ')';})
	                    .attr('text-anchor', function(d) {
	                        return ({
	                            left: 'start',
	                            center: 'middle',
	                            right: 'end'
	                        })[d.align];
	                    });
	            }
	        });
	}
	
	function isLatex(content) {
	    return typeof content === 'string' && content.match(c.latexCheck);
	}
	
	function hasWrapCharacter(text) {return text.indexOf(c.wrapSplitCharacter) !== -1;}
	
	function columnMoved(gd, calcdata, indices) {
	    var o = calcdata.gdColumnsOriginalOrder;
	    calcdata.gdColumns.sort(function(a, b) {
	        return indices[o.indexOf(a)] - indices[o.indexOf(b)];
	    });
	
	    calcdata.columnorder = indices;
	
	    // TODO: there's no data here, but also this reordering is not reflected
	    // in gd.data or even gd._fullData.
	    // For now I will not attempt to persist this in _preGUI
	    gd.emit('plotly_restyle');
	}
	
	function gridPick(spec, col, row) {
	    if(Array.isArray(spec)) {
	        var column = spec[Math.min(col, spec.length - 1)];
	        if(Array.isArray(column)) {
	            return column[Math.min(row, column.length - 1)];
	        } else {
	            return column;
	        }
	    } else {
	        return spec;
	    }
	}
	
	function easeColumn(selection, d, y) {
	    selection
	        .transition()
	        .ease(c.releaseTransitionEase)
	        .duration(c.releaseTransitionDuration)
	        .attr('transform', 'translate(' + d.x + ' ' + y + ')');
	}
	
	function cellsBlock(d) {return d.type === 'cells';}
	function headerBlock(d) {return d.type === 'header';}
	
	/**
	 * Revolver panel and cell contents layouting
	 */
	
	function headerHeight(d) {
	    var headerBlocks = d.rowBlocks.length ? d.rowBlocks[0].auxiliaryBlocks : [];
	    return headerBlocks.reduce(function(p, n) {return p + rowsHeight(n, Infinity);}, 0);
	}
	
	function findPagesAndCacheHeights(blocks, scrollY, scrollHeight) {
	    var pages = [];
	    var pTop = 0;
	
	    for(var blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
	        var block = blocks[blockIndex];
	        var blockRows = block.rows;
	        var rowsHeight = 0;
	        for(var i = 0; i < blockRows.length; i++) {
	            rowsHeight += blockRows[i].rowHeight;
	        }
	
	        // caching allRowsHeight on the block - it's safe as this function is always called from within the code part
	        // that handles increases to row heights
	        block.allRowsHeight = rowsHeight;
	
	        var pBottom = pTop + rowsHeight;
	        var windowTop = scrollY;
	        var windowBottom = windowTop + scrollHeight;
	        if(windowTop < pBottom && windowBottom > pTop) {
	            pages.push(blockIndex);
	        }
	        pTop += rowsHeight;
	
	        // consider this nice final optimization; put it in `for` condition - caveat, currently the
	        // block.allRowsHeight relies on being invalidated, so enabling this opt may not be safe
	        // if(pages.length > 1) break;
	    }
	
	    return pages;
	}
	
	function updateBlockYPosition(gd, cellsColumnBlock, tableControlView) {
	    var d = flatData(cellsColumnBlock)[0];
	    if(d === undefined) return;
	    var blocks = d.rowBlocks;
	    var calcdata = d.calcdata;
	
	    var bottom = firstRowAnchor(blocks, blocks.length);
	    var scrollHeight = d.calcdata.groupHeight - headerHeight(d);
	    var scrollY = calcdata.scrollY = Math.max(0, Math.min(bottom - scrollHeight, calcdata.scrollY));
	
	    var pages = findPagesAndCacheHeights(blocks, scrollY, scrollHeight);
	    if(pages.length === 1) {
	        if(pages[0] === blocks.length - 1) {
	            pages.unshift(pages[0] - 1);
	        } else {
	            pages.push(pages[0] + 1);
	        }
	    }
	
	    // make phased out page jump by 2 while leaving stationary page intact
	    if(pages[0] % 2) {
	        pages.reverse();
	    }
	
	    cellsColumnBlock
	        .each(function(d, i) {
	            // these values will also be needed when a block is translated again due to growing cell height
	            d.page = pages[i];
	            d.scrollY = scrollY;
	        });
	
	    cellsColumnBlock
	        .attr('transform', function(d) {
	            var yTranslate = firstRowAnchor(d.rowBlocks, d.page) - d.scrollY;
	            return 'translate(0 ' + yTranslate + ')';
	        });
	
	    // conditionally rerendering panel 0 and 1
	    if(gd) {
	        conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 0);
	        conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 1);
	        renderScrollbarKit(tableControlView, gd);
	    }
	}
	
	function makeDragRow(gd, allTableControlView, optionalMultiplier, optionalPosition) {
	    return function dragRow(eventD) {
	        // may come from whichever DOM event target: drag, wheel, bar... eventD corresponds to event target
	        var d = eventD.calcdata ? eventD.calcdata : eventD;
	        var tableControlView = allTableControlView.filter(function(dd) {return d.key === dd.key;});
	        var multiplier = optionalMultiplier || d.scrollbarState.dragMultiplier;
	
	        var initialScrollY = d.scrollY;
	
	        d.scrollY = optionalPosition === void(0) ? d.scrollY + multiplier * d3.event.dy : optionalPosition;
	        var cellsColumnBlock = tableControlView.selectAll('.' + c.cn.yColumn).selectAll('.' + c.cn.columnBlock).filter(cellsBlock);
	        updateBlockYPosition(gd, cellsColumnBlock, tableControlView);
	
	        // return false if we've "used" the scroll, ie it did something,
	        // so the event shouldn't bubble (if appropriate)
	        return d.scrollY === initialScrollY;
	    };
	}
	
	function conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, prevPages, d, revolverIndex) {
	    var shouldComponentUpdate = pages[revolverIndex] !== prevPages[revolverIndex];
	    if(shouldComponentUpdate) {
	        clearTimeout(d.currentRepaint[revolverIndex]);
	        d.currentRepaint[revolverIndex] = setTimeout(function() {
	            // setTimeout might lag rendering but yields a smoother scroll, because fast scrolling makes
	            // some repaints invisible ie. wasteful (DOM work blocks the main thread)
	            var toRerender = cellsColumnBlock.filter(function(d, i) {return i === revolverIndex && pages[i] !== prevPages[i];});
	            renderColumnCellTree(gd, tableControlView, toRerender, cellsColumnBlock);
	            prevPages[revolverIndex] = pages[revolverIndex];
	        });
	    }
	}
	
	function wrapTextMaker(columnBlock, element, tableControlView, gd) {
	    return function wrapText() {
	        var cellTextHolder = d3.select(element.parentNode);
	        cellTextHolder
	            .each(function(d) {
	                var fragments = d.fragments;
	                cellTextHolder.selectAll('tspan.line').each(function(dd, i) {
	                    fragments[i].width = this.getComputedTextLength();
	                });
	                // last element is only for measuring the separator character, so it's ignored:
	                var separatorLength = fragments[fragments.length - 1].width;
	                var rest = fragments.slice(0, -1);
	                var currentRow = [];
	                var currentAddition, currentAdditionLength;
	                var currentRowLength = 0;
	                var rowLengthLimit = d.column.columnWidth - 2 * c.cellPad;
	                d.value = '';
	                while(rest.length) {
	                    currentAddition = rest.shift();
	                    currentAdditionLength = currentAddition.width + separatorLength;
	                    if(currentRowLength + currentAdditionLength > rowLengthLimit) {
	                        d.value += currentRow.join(c.wrapSpacer) + c.lineBreaker;
	                        currentRow = [];
	                        currentRowLength = 0;
	                    }
	                    currentRow.push(currentAddition.text);
	                    currentRowLength += currentAdditionLength;
	                }
	                if(currentRowLength) {
	                    d.value += currentRow.join(c.wrapSpacer);
	                }
	                d.wrapped = true;
	            });
	
	        // the pre-wrapped text was rendered only for the text measurements
	        cellTextHolder.selectAll('tspan.line').remove();
	
	        // resupply text, now wrapped
	        populateCellText(cellTextHolder.select('.' + c.cn.cellText), tableControlView, columnBlock, gd);
	        d3.select(element.parentNode.parentNode).call(setCellHeightAndPositionY);
	    };
	}
	
	function updateYPositionMaker(columnBlock, element, tableControlView, gd, d) {
	    return function updateYPosition() {
	        if(d.settledY) return;
	        var cellTextHolder = d3.select(element.parentNode);
	        var l = getBlock(d);
	        var rowIndex = d.key - l.firstRowIndex;
	
	        var declaredRowHeight = l.rows[rowIndex].rowHeight;
	
	        var requiredHeight = d.cellHeightMayIncrease ? element.parentNode.getBoundingClientRect().height + 2 * c.cellPad : declaredRowHeight;
	
	        var finalHeight = Math.max(requiredHeight, declaredRowHeight);
	        var increase = finalHeight - l.rows[rowIndex].rowHeight;
	
	        if(increase) {
	            // current row height increased
	            l.rows[rowIndex].rowHeight = finalHeight;
	
	            columnBlock
	                .selectAll('.' + c.cn.columnCell)
	                .call(setCellHeightAndPositionY);
	
	            updateBlockYPosition(null, columnBlock.filter(cellsBlock), 0);
	
	            // if d.column.type === 'header', then the scrollbar has to be pushed downward to the scrollable area
	            // if d.column.type === 'cells', it can still be relevant if total scrolling content height is less than the
	            //                               scrollable window, as increases to row heights may need scrollbar updates
	            renderScrollbarKit(tableControlView, gd, true);
	        }
	
	        cellTextHolder
	            .attr('transform', function() {
	                // this code block is only invoked for items where d.cellHeightMayIncrease is truthy
	                var element = this;
	                var columnCellElement = element.parentNode;
	                var box = columnCellElement.getBoundingClientRect();
	                var rectBox = d3.select(element.parentNode).select('.' + c.cn.cellRect).node().getBoundingClientRect();
	                var currentTransform = element.transform.baseVal.consolidate();
	                var yPosition = rectBox.top - box.top + (currentTransform ? currentTransform.matrix.f : c.cellPad);
	                return 'translate(' + xPosition(d, d3.select(element.parentNode).select('.' + c.cn.cellTextHolder).node().getBoundingClientRect().width) + ' ' + yPosition + ')';
	            });
	
	        d.settledY = true;
	    };
	}
	
	function xPosition(d, optionalWidth) {
	    switch(d.align) {
	        case 'left': return c.cellPad;
	        case 'right': return d.column.columnWidth - (optionalWidth || 0) - c.cellPad;
	        case 'center': return (d.column.columnWidth - (optionalWidth || 0)) / 2;
	        default: return c.cellPad;
	    }
	}
	
	function setCellHeightAndPositionY(columnCell) {
	    columnCell
	        .attr('transform', function(d) {
	            var headerHeight = d.rowBlocks[0].auxiliaryBlocks.reduce(function(p, n) {return p + rowsHeight(n, Infinity);}, 0);
	            var l = getBlock(d);
	            var rowAnchor = rowsHeight(l, d.key);
	            var yOffset = rowAnchor + headerHeight;
	            return 'translate(0 ' + yOffset + ')';
	        })
	        .selectAll('.' + c.cn.cellRect)
	        .attr('height', function(d) {return getRow(getBlock(d), d.key).rowHeight;});
	}
	
	function firstRowAnchor(blocks, page) {
	    var total = 0;
	    for(var i = page - 1; i >= 0; i--) {
	        total += allRowsHeight(blocks[i]);
	    }
	    return total;
	}
	
	function rowsHeight(rowBlock, key) {
	    var total = 0;
	    for(var i = 0; i < rowBlock.rows.length && rowBlock.rows[i].rowIndex < key; i++) {
	        total += rowBlock.rows[i].rowHeight;
	    }
	    return total;
	}
	
	function allRowsHeight(rowBlock) {
	    var cached = rowBlock.allRowsHeight;
	
	    if(cached !== void(0)) {
	        return cached;
	    }
	
	    var total = 0;
	    for(var i = 0; i < rowBlock.rows.length; i++) {
	        total += rowBlock.rows[i].rowHeight;
	    }
	    rowBlock.allRowsHeight = total;
	
	    return total;
	}
	
	function getBlock(d) {return d.rowBlocks[d.page];}
	function getRow(l, i) {return l.rows[i - l.firstRowIndex];}
	
	},{"../../components/color":591,"../../components/drawing":612,"../../lib":716,"../../lib/gup":714,"../../lib/svg_text_utils":740,"./constants":1248,"./data_preparation_helper":1249,"./data_split_helpers":1250,"d3":164}],1254:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var domainAttrs = _dereq_('../../plots/domain').attributes;
	var pieAttrs = _dereq_('../pie/attributes');
	var sunburstAttrs = _dereq_('../sunburst/attributes');
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    labels: sunburstAttrs.labels,
	    parents: sunburstAttrs.parents,
	
	    values: sunburstAttrs.values,
	    branchvalues: sunburstAttrs.branchvalues,
	    count: sunburstAttrs.count,
	
	    level: sunburstAttrs.level,
	    maxdepth: sunburstAttrs.maxdepth,
	
	    tiling: {
	        packing: {
	            valType: 'enumerated',
	            values: [
	                'squarify',
	                'binary',
	                'dice',
	                'slice',
	                'slice-dice',
	                'dice-slice'
	            ],
	            dflt: 'squarify',
	            
	            editType: 'plot',
	            
	        },
	
	        squarifyratio: {
	            valType: 'number',
	            
	            min: 1,
	            dflt: 1,
	            editType: 'plot',
	            
	        },
	
	        flip: {
	            valType: 'flaglist',
	            
	            flags: [
	                'x',
	                'y'
	            ],
	            dflt: '',
	            editType: 'plot',
	            
	        },
	
	        pad: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 3,
	            editType: 'plot',
	            
	        },
	
	        editType: 'calc',
	    },
	
	    marker: extendFlat({
	        pad: {
	            t: {
	                valType: 'number',
	                
	                min: 0,
	                editType: 'plot',
	                
	            },
	            l: {
	                valType: 'number',
	                
	                min: 0,
	                editType: 'plot',
	                
	            },
	            r: {
	                valType: 'number',
	                
	                min: 0,
	                editType: 'plot',
	                
	            },
	            b: {
	                valType: 'number',
	                
	                min: 0,
	                editType: 'plot',
	                
	            },
	
	            editType: 'calc'
	        },
	
	        colors: sunburstAttrs.marker.colors,
	
	        depthfade: {
	            valType: 'enumerated',
	            values: [true, false, 'reversed'],
	            editType: 'style',
	            
	            
	        },
	
	        line: sunburstAttrs.marker.line,
	
	        editType: 'calc'
	    },
	        colorScaleAttrs('marker', {
	            colorAttr: 'colors',
	            anim: false // TODO: set to anim: true?
	        })
	    ),
	
	    pathbar: {
	        visible: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	
	        side: {
	            valType: 'enumerated',
	            values: [
	                'top',
	                'bottom'
	            ],
	            dflt: 'top',
	            
	            editType: 'plot',
	            
	        },
	
	        edgeshape: {
	            valType: 'enumerated',
	            values: [
	                '>',
	                '<',
	                '|',
	                '/',
	                '\\'
	            ],
	            dflt: '>',
	            
	            editType: 'plot',
	            
	        },
	
	        thickness: {
	            valType: 'number',
	            min: 12,
	            
	            editType: 'plot',
	            
	        },
	
	        textfont: extendFlat({}, pieAttrs.textfont, {
	            
	        }),
	
	        editType: 'calc'
	    },
	
	    text: pieAttrs.text,
	    textinfo: sunburstAttrs.textinfo,
	    // TODO: incorporate `label` and `value` in the eventData
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: constants.eventDataKeys.concat(['label', 'value'])
	    }),
	
	    hovertext: pieAttrs.hovertext,
	    hoverinfo: sunburstAttrs.hoverinfo,
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    textfont: pieAttrs.textfont,
	    insidetextfont: pieAttrs.insidetextfont,
	    outsidetextfont: pieAttrs.outsidetextfont,
	
	    textposition: {
	        valType: 'enumerated',
	        values: [
	            'top left', 'top center', 'top right',
	            'middle left', 'middle center', 'middle right',
	            'bottom left', 'bottom center', 'bottom right'
	        ],
	        dflt: 'top left',
	        
	        editType: 'plot',
	        
	    },
	
	    domain: domainAttrs({name: 'treemap', trace: true, editType: 'calc'}),
	};
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plots/domain":789,"../../plots/template_attributes":840,"../pie/attributes":1092,"../sunburst/attributes":1228,"./constants":1257}],1255:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var plots = _dereq_('../../plots/plots');
	
	exports.name = 'treemap';
	
	exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	    plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	};
	
	exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	    plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	};
	
	},{"../../plots/plots":825}],1256:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var calc = _dereq_('../sunburst/calc');
	
	exports.calc = function(gd, trace) {
	    return calc.calc(gd, trace);
	};
	
	exports.crossTraceCalc = function(gd) {
	    return calc._runCrossTraceCalc('treemap', gd);
	};
	
	},{"../sunburst/calc":1230}],1257:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    CLICK_TRANSITION_TIME: 750,
	    CLICK_TRANSITION_EASING: 'poly',
	    eventDataKeys: [
	        // string
	        'currentPath',
	        'root',
	        'entry',
	        // no need to add 'parent' here
	
	        // percentages i.e. ratios
	        'percentRoot',
	        'percentEntry',
	        'percentParent'
	    ],
	    gapWithPathbar: 1 // i.e. one pixel
	};
	
	},{}],1258:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var Color = _dereq_('../../components/color');
	var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	var TEXTPAD = _dereq_('../bar/constants').TEXTPAD;
	
	var Colorscale = _dereq_('../../components/colorscale');
	var hasColorscale = Colorscale.hasColorscale;
	var colorscaleDefaults = Colorscale.handleDefaults;
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var labels = coerce('labels');
	    var parents = coerce('parents');
	
	    if(!labels || !labels.length || !parents || !parents.length) {
	        traceOut.visible = false;
	        return;
	    }
	
	    var vals = coerce('values');
	    if(vals && vals.length) {
	        coerce('branchvalues');
	    } else {
	        coerce('count');
	    }
	
	    coerce('level');
	    coerce('maxdepth');
	
	    var packing = coerce('tiling.packing');
	    if(packing === 'squarify') {
	        coerce('tiling.squarifyratio');
	    }
	
	    coerce('tiling.flip');
	    coerce('tiling.pad');
	
	    var text = coerce('text');
	    coerce('texttemplate');
	    if(!traceOut.texttemplate) coerce('textinfo', Array.isArray(text) ? 'text+label' : 'label');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var textposition = 'auto';
	    handleText(traceIn, traceOut, layout, coerce, textposition, {
	        moduleHasSelected: false,
	        moduleHasUnselected: false,
	        moduleHasConstrain: false,
	        moduleHasCliponaxis: false,
	        moduleHasTextangle: false,
	        moduleHasInsideanchor: false
	    });
	    coerce('textposition');
	    var bottomText = traceOut.textposition.indexOf('bottom') !== -1;
	
	    var lineWidth = coerce('marker.line.width');
	    if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
	
	    var colors = coerce('marker.colors');
	    var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, 'marker', 'colors');
	    if(withColorscale) {
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
	    } else {
	        coerce('marker.depthfade', !(colors || []).length);
	    }
	
	    var headerSize = traceOut.textfont.size * 2;
	
	    coerce('marker.pad.t', bottomText ? headerSize / 4 : headerSize);
	    coerce('marker.pad.l', headerSize / 4);
	    coerce('marker.pad.r', headerSize / 4);
	    coerce('marker.pad.b', bottomText ? headerSize : headerSize / 4);
	
	    if(withColorscale) {
	        colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
	    }
	
	    traceOut._hovered = {
	        marker: {
	            line: {
	                width: 2,
	                color: Color.contrast(layout.paper_bgcolor)
	            }
	        }
	    };
	
	    var hasPathbar = coerce('pathbar.visible');
	    if(hasPathbar) {
	        Lib.coerceFont(coerce, 'pathbar.textfont', layout.font);
	
	        // This works even for multi-line labels as treemap pathbar trim out line breaks
	        coerce('pathbar.thickness', traceOut.pathbar.textfont.size + 2 * TEXTPAD);
	
	        coerce('pathbar.side');
	        coerce('pathbar.edgeshape');
	    }
	
	    handleDomainDefaults(traceOut, layout, coerce);
	
	    // do not support transforms for now
	    traceOut._length = null;
	};
	
	},{"../../components/color":591,"../../components/colorscale":603,"../../lib":716,"../../plots/domain":789,"../bar/constants":857,"../bar/defaults":859,"./attributes":1254}],1259:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var partition = _dereq_('./partition');
	var styleOne = _dereq_('./style').styleOne;
	var constants = _dereq_('./constants');
	var helpers = _dereq_('../sunburst/helpers');
	var attachFxHandlers = _dereq_('../sunburst/fx');
	
	var onPathbar = true; // for Ancestors
	
	module.exports = function drawAncestors(gd, cd, entry, slices, opts) {
	    var barDifY = opts.barDifY;
	    var width = opts.width;
	    var height = opts.height;
	    var viewX = opts.viewX;
	    var viewY = opts.viewY;
	    var pathSlice = opts.pathSlice;
	    var toMoveInsideSlice = opts.toMoveInsideSlice;
	    var strTransform = opts.strTransform;
	    var hasTransition = opts.hasTransition;
	    var handleSlicesExit = opts.handleSlicesExit;
	    var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
	    var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
	    var refRect = {};
	
	    var fullLayout = gd._fullLayout;
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var hierarchy = cd0.hierarchy;
	
	    var eachWidth = width / trace._entryDepth;
	
	    var pathIds = helpers.listPath(entry.data, 'id');
	
	    var sliceData = partition(hierarchy.copy(), [width, height], {
	        packing: 'dice',
	        pad: {
	            inner: 0,
	            top: 0,
	            left: 0,
	            right: 0,
	            bottom: 0
	        }
	    }).descendants();
	
	    // edit slices that show up on graph
	    sliceData = sliceData.filter(function(pt) {
	        var level = pathIds.indexOf(pt.data.id);
	        if(level === -1) return false;
	
	        pt.x0 = eachWidth * level;
	        pt.x1 = eachWidth * (level + 1);
	        pt.y0 = barDifY;
	        pt.y1 = barDifY + height;
	
	        pt.onPathbar = true;
	
	        return true;
	    });
	
	    sliceData.reverse();
	
	    slices = slices.data(sliceData, helpers.getPtId);
	
	    slices.enter().append('g')
	        .classed('pathbar', true);
	
	    handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
	
	    slices.order();
	
	    var updateSlices = slices;
	    if(hasTransition) {
	        updateSlices = updateSlices.transition().each('end', function() {
	            // N.B. gd._transitioning is (still) *true* by the time
	            // transition updates get here
	            var sliceTop = d3.select(this);
	            helpers.setSliceCursor(sliceTop, gd, {
	                hideOnRoot: false,
	                hideOnLeaves: false,
	                isTransitioning: false
	            });
	        });
	    }
	
	    updateSlices.each(function(pt) {
	        pt._hoverX = viewX(pt.x1 - height / 2);
	        pt._hoverY = viewY(pt.y1 - height / 2);
	
	        var sliceTop = d3.select(this);
	
	        var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
	            s.style('pointer-events', 'all');
	        });
	
	        if(hasTransition) {
	            slicePath.transition().attrTween('d', function(pt2) {
	                var interp = makeUpdateSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
	                return function(t) { return pathSlice(interp(t)); };
	            });
	        } else {
	            slicePath.attr('d', pathSlice);
	        }
	
	        sliceTop
	            .call(attachFxHandlers, entry, gd, cd, {
	                styleOne: styleOne,
	                eventDataKeys: constants.eventDataKeys,
	                transitionTime: constants.CLICK_TRANSITION_TIME,
	                transitionEasing: constants.CLICK_TRANSITION_EASING
	            })
	            .call(helpers.setSliceCursor, gd, {
	                hideOnRoot: false,
	                hideOnLeaves: false,
	                isTransitioning: gd._transitioning
	            });
	
	        slicePath.call(styleOne, pt, trace, {
	            hovered: false
	        });
	
	        pt._text = (helpers.getPtLabel(pt) || '').split('<br>').join(' ') || '';
	
	        var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
	        var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
	            // prohibit tex interpretation until we can handle
	            // tex and regular text together
	            s.attr('data-notex', 1);
	        });
	
	        sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
	            .classed('slicetext', true)
	            .attr('text-anchor', 'start')
	            .call(Drawing.font, helpers.determineTextFont(trace, pt, fullLayout.font, trace.pathdir))
	            .call(svgTextUtils.convertToTspans, gd);
	
	        pt.textBB = Drawing.bBox(sliceText.node());
	        pt.transform = toMoveInsideSlice(pt, {
	            onPathbar: true
	        });
	
	        if(helpers.isOutsideText(trace, pt)) {
	            // consider in/out diff font sizes
	            pt.transform.targetY -= (
	                helpers.getOutsideTextFontKey('size', trace, pt, fullLayout.font) -
	                helpers.getInsideTextFontKey('size', trace, pt, fullLayout.font)
	            );
	        }
	
	        if(hasTransition) {
	            sliceText.transition().attrTween('transform', function(pt2) {
	                var interp = makeUpdateTextInterpolator(pt2, onPathbar, refRect, [width, height]);
	                return function(t) { return strTransform(interp(t)); };
	            });
	        } else {
	            sliceText.attr('transform', strTransform(pt));
	        }
	    });
	};
	
	},{"../../components/drawing":612,"../../lib":716,"../../lib/svg_text_utils":740,"../sunburst/fx":1233,"../sunburst/helpers":1234,"./constants":1257,"./partition":1264,"./style":1266,"d3":164}],1260:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var svgTextUtils = _dereq_('../../lib/svg_text_utils');
	
	var partition = _dereq_('./partition');
	var styleOne = _dereq_('./style').styleOne;
	var constants = _dereq_('./constants');
	var helpers = _dereq_('../sunburst/helpers');
	var attachFxHandlers = _dereq_('../sunburst/fx');
	var formatSliceLabel = _dereq_('../sunburst/plot').formatSliceLabel;
	
	var onPathbar = false; // for Descendants
	
	module.exports = function drawDescendants(gd, cd, entry, slices, opts) {
	    var width = opts.width;
	    var height = opts.height;
	    var viewX = opts.viewX;
	    var viewY = opts.viewY;
	    var pathSlice = opts.pathSlice;
	    var toMoveInsideSlice = opts.toMoveInsideSlice;
	    var strTransform = opts.strTransform;
	    var hasTransition = opts.hasTransition;
	    var handleSlicesExit = opts.handleSlicesExit;
	    var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
	    var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
	    var prevEntry = opts.prevEntry;
	    var refRect = {};
	
	    var fullLayout = gd._fullLayout;
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	
	    var hasLeft = trace.textposition.indexOf('left') !== -1;
	    var hasRight = trace.textposition.indexOf('right') !== -1;
	    var hasBottom = trace.textposition.indexOf('bottom') !== -1;
	
	    var noRoomForHeader = (!hasBottom && !trace.marker.pad.t) || (hasBottom && !trace.marker.pad.b);
	
	    // N.B. slice data isn't the calcdata,
	    // grab corresponding calcdata item in sliceData[i].data.data
	    var allData = partition(entry, [width, height], {
	        packing: trace.tiling.packing,
	        squarifyratio: trace.tiling.squarifyratio,
	        flipX: trace.tiling.flip.indexOf('x') > -1,
	        flipY: trace.tiling.flip.indexOf('y') > -1,
	        pad: {
	            inner: trace.tiling.pad,
	            top: trace.marker.pad.t,
	            left: trace.marker.pad.l,
	            right: trace.marker.pad.r,
	            bottom: trace.marker.pad.b,
	        }
	    });
	
	    var sliceData = allData.descendants();
	
	    var minVisibleDepth = Infinity;
	    var maxVisibleDepth = -Infinity;
	    sliceData.forEach(function(pt) {
	        var depth = pt.depth;
	        if(depth >= trace._maxDepth) {
	            // hide slices that won't show up on graph
	            pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
	            pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
	        } else {
	            minVisibleDepth = Math.min(minVisibleDepth, depth);
	            maxVisibleDepth = Math.max(maxVisibleDepth, depth);
	        }
	    });
	
	    slices = slices.data(sliceData, helpers.getPtId);
	
	    trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
	
	    slices.enter().append('g')
	        .classed('slice', true);
	
	    handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
	
	    slices.order();
	
	    // next coords of previous entry
	    var nextOfPrevEntry = null;
	    if(hasTransition && prevEntry) {
	        var prevEntryId = helpers.getPtId(prevEntry);
	        slices.each(function(pt) {
	            if(nextOfPrevEntry === null && (helpers.getPtId(pt) === prevEntryId)) {
	                nextOfPrevEntry = {
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    y0: pt.y0,
	                    y1: pt.y1
	                };
	            }
	        });
	    }
	
	    var getRefRect = function() {
	        return nextOfPrevEntry || {
	            x0: 0,
	            x1: width,
	            y0: 0,
	            y1: height
	        };
	    };
	
	    var updateSlices = slices;
	    if(hasTransition) {
	        updateSlices = updateSlices.transition().each('end', function() {
	            // N.B. gd._transitioning is (still) *true* by the time
	            // transition updates get here
	            var sliceTop = d3.select(this);
	            helpers.setSliceCursor(sliceTop, gd, {
	                hideOnRoot: true,
	                hideOnLeaves: false,
	                isTransitioning: false
	            });
	        });
	    }
	
	    updateSlices.each(function(pt) {
	        var isHeader = helpers.isHeader(pt, trace);
	
	        pt._hoverX = viewX(pt.x1 - trace.marker.pad.r),
	        pt._hoverY = hasBottom ?
	                viewY(pt.y1 - trace.marker.pad.b / 2) :
	                viewY(pt.y0 + trace.marker.pad.t / 2);
	
	        var sliceTop = d3.select(this);
	
	        var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
	            s.style('pointer-events', 'all');
	        });
	
	        if(hasTransition) {
	            slicePath.transition().attrTween('d', function(pt2) {
	                var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
	                return function(t) { return pathSlice(interp(t)); };
	            });
	        } else {
	            slicePath.attr('d', pathSlice);
	        }
	
	        sliceTop
	            .call(attachFxHandlers, entry, gd, cd, {
	                styleOne: styleOne,
	                eventDataKeys: constants.eventDataKeys,
	                transitionTime: constants.CLICK_TRANSITION_TIME,
	                transitionEasing: constants.CLICK_TRANSITION_EASING
	            })
	            .call(helpers.setSliceCursor, gd, { isTransitioning: gd._transitioning });
	
	        slicePath.call(styleOne, pt, trace, {
	            hovered: false
	        });
	
	        if(pt.x0 === pt.x1 || pt.y0 === pt.y1) {
	            pt._text = '';
	        } else {
	            if(isHeader) {
	                pt._text = noRoomForHeader ? '' : helpers.getPtLabel(pt) || '';
	            } else {
	                pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || '';
	            }
	        }
	
	        var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
	        var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
	            // prohibit tex interpretation until we can handle
	            // tex and regular text together
	            s.attr('data-notex', 1);
	        });
	
	        sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
	            .classed('slicetext', true)
	            .attr('text-anchor', hasRight ? 'end' : (hasLeft || isHeader) ? 'start' : 'middle')
	            .call(Drawing.font, helpers.determineTextFont(trace, pt, fullLayout.font))
	            .call(svgTextUtils.convertToTspans, gd);
	
	        pt.textBB = Drawing.bBox(sliceText.node());
	        pt.transform = toMoveInsideSlice(pt, {
	            isHeader: isHeader
	        });
	
	        if(hasTransition) {
	            sliceText.transition().attrTween('transform', function(pt2) {
	                var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
	                return function(t) { return strTransform(interp(t)); };
	            });
	        } else {
	            sliceText.attr('transform', strTransform(pt));
	        }
	    });
	
	    return nextOfPrevEntry;
	};
	
	},{"../../components/drawing":612,"../../lib":716,"../../lib/svg_text_utils":740,"../sunburst/fx":1233,"../sunburst/helpers":1234,"../sunburst/plot":1238,"./constants":1257,"./partition":1264,"./style":1266,"d3":164}],1261:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    moduleType: 'trace',
	    name: 'treemap',
	    basePlotModule: _dereq_('./base_plot'),
	    categories: [],
	    animatable: true,
	
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	
	    calc: _dereq_('./calc').calc,
	    crossTraceCalc: _dereq_('./calc').crossTraceCalc,
	
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style').style,
	
	    colorbar: _dereq_('../scatter/marker_colorbar'),
	
	    meta: {
	        
	    }
	};
	
	},{"../scatter/marker_colorbar":1136,"./attributes":1254,"./base_plot":1255,"./calc":1256,"./defaults":1258,"./layout_attributes":1262,"./layout_defaults":1263,"./plot":1265,"./style":1266}],1262:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    treemapcolorway: {
	        valType: 'colorlist',
	        
	        editType: 'calc',
	        
	    },
	    extendtreemapcolors: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],1263:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	    coerce('treemapcolorway', layoutOut.colorway);
	    coerce('extendtreemapcolors');
	};
	
	},{"../../lib":716,"./layout_attributes":1262}],1264:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3Hierarchy = _dereq_('d3-hierarchy');
	
	module.exports = function partition(entry, size, opts) {
	    var flipX = opts.flipX;
	    var flipY = opts.flipY;
	    var swapXY = opts.packing === 'dice-slice';
	
	    var top = opts.pad[flipY ? 'bottom' : 'top'];
	    var left = opts.pad[flipX ? 'right' : 'left'];
	    var right = opts.pad[flipX ? 'left' : 'right'];
	    var bottom = opts.pad[flipY ? 'top' : 'bottom'];
	
	    var tmp;
	    if(swapXY) {
	        tmp = left;
	        left = top;
	        top = tmp;
	
	        tmp = right;
	        right = bottom;
	        bottom = tmp;
	    }
	
	    var result = d3Hierarchy
	        .treemap()
	        .tile(getTilingMethod(opts.packing, opts.squarifyratio))
	        .paddingInner(opts.pad.inner)
	        .paddingLeft(left)
	        .paddingRight(right)
	        .paddingTop(top)
	        .paddingBottom(bottom)
	        .size(
	            swapXY ? [size[1], size[0]] : size
	        )(entry);
	
	    if(swapXY || flipX || flipY) {
	        flipTree(result, size, {
	            swapXY: swapXY,
	            flipX: flipX,
	            flipY: flipY
	        });
	    }
	    return result;
	};
	
	function getTilingMethod(key, squarifyratio) {
	    switch(key) {
	        case 'squarify':
	            return d3Hierarchy.treemapSquarify.ratio(squarifyratio);
	        case 'binary':
	            return d3Hierarchy.treemapBinary;
	        case 'dice':
	            return d3Hierarchy.treemapDice;
	        case 'slice':
	            return d3Hierarchy.treemapSlice;
	        default: // i.e. 'slice-dice' | 'dice-slice'
	            return d3Hierarchy.treemapSliceDice;
	    }
	}
	
	function flipTree(node, size, opts) {
	    var tmp;
	
	    if(opts.swapXY) {
	        // swap x0 and y0
	        tmp = node.x0;
	        node.x0 = node.y0;
	        node.y0 = tmp;
	
	        // swap x1 and y1
	        tmp = node.x1;
	        node.x1 = node.y1;
	        node.y1 = tmp;
	    }
	
	    if(opts.flipX) {
	        tmp = node.x0;
	        node.x0 = size[0] - node.x1;
	        node.x1 = size[0] - tmp;
	    }
	
	    if(opts.flipY) {
	        tmp = node.y0;
	        node.y0 = size[1] - node.y1;
	        node.y1 = size[1] - tmp;
	    }
	
	    var children = node.children;
	    if(children) {
	        for(var i = 0; i < children.length; i++) {
	            flipTree(children[i], size, opts);
	        }
	    }
	}
	
	},{"d3-hierarchy":158}],1265:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var hasTransition = _dereq_('../sunburst/helpers').hasTransition;
	var helpers = _dereq_('../sunburst/helpers');
	
	var Lib = _dereq_('../../lib');
	var TEXTPAD = _dereq_('../bar/constants').TEXTPAD;
	var toMoveInsideBar = _dereq_('../bar/plot').toMoveInsideBar;
	
	var constants = _dereq_('./constants');
	var drawDescendants = _dereq_('./draw_descendants');
	var drawAncestors = _dereq_('./draw_ancestors');
	
	module.exports = function(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
	    var fullLayout = gd._fullLayout;
	    var layer = fullLayout._treemaplayer;
	    var join, onComplete;
	
	    // If transition config is provided, then it is only a partial replot and traces not
	    // updated are removed.
	    var isFullReplot = !transitionOpts;
	
	    join = layer.selectAll('g.trace.treemap')
	        .data(cdmodule, function(cd) { return cd[0].trace.uid; });
	
	    join.enter().append('g')
	        .classed('trace', true)
	        .classed('treemap', true);
	
	    join.order();
	
	    if(hasTransition(transitionOpts)) {
	        if(makeOnCompleteCallback) {
	            // If it was passed a callback to register completion, make a callback. If
	            // this is created, then it must be executed on completion, otherwise the
	            // pos-transition redraw will not execute:
	            onComplete = makeOnCompleteCallback();
	        }
	
	        var transition = d3.transition()
	            .duration(transitionOpts.duration)
	            .ease(transitionOpts.easing)
	            .each('end', function() { onComplete && onComplete(); })
	            .each('interrupt', function() { onComplete && onComplete(); });
	
	        transition.each(function() {
	            // Must run the selection again since otherwise enters/updates get grouped together
	            // and these get executed out of order. Except we need them in order!
	            layer.selectAll('g.trace').each(function(cd) {
	                plotOne(gd, cd, this, transitionOpts);
	            });
	        });
	    } else {
	        join.each(function(cd) {
	            plotOne(gd, cd, this, transitionOpts);
	        });
	    }
	
	    if(isFullReplot) {
	        join.exit().remove();
	    }
	};
	
	function getKey(pt) {
	    return helpers.isHierarchyRoot(pt) ?
	        '' : // don't use the dummyId
	        helpers.getPtId(pt);
	}
	
	function plotOne(gd, cd, element, transitionOpts) {
	    var fullLayout = gd._fullLayout;
	    var cd0 = cd[0];
	    var trace = cd0.trace;
	    var hierarchy = cd0.hierarchy;
	    var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
	
	    var gTrace = d3.select(element);
	    var selAncestors = gTrace.selectAll('g.pathbar');
	    var selDescendants = gTrace.selectAll('g.slice');
	
	    if(!entry) {
	        selAncestors.remove();
	        selDescendants.remove();
	        return;
	    }
	
	    var isRoot = helpers.isHierarchyRoot(entry);
	    var hasTransition = helpers.hasTransition(transitionOpts);
	
	    var maxDepth = helpers.getMaxDepth(trace);
	    var hasVisibleDepth = function(pt) {
	        return pt.data.depth - entry.data.depth < maxDepth;
	    };
	
	    var gs = fullLayout._size;
	    var domain = trace.domain;
	
	    var vpw = gs.w * (domain.x[1] - domain.x[0]);
	    var vph = gs.h * (domain.y[1] - domain.y[0]);
	    var barW = vpw;
	    var barH = trace.pathbar.thickness;
	    var barPad = trace.marker.line.width + constants.gapWithPathbar;
	    var barDifY = !trace.pathbar.visible ? 0 :
	        trace.pathbar.side.indexOf('bottom') > -1 ? vph + barPad : -(barH + barPad);
	
	    var pathbarOrigin = {
	        x0: barW, // slide to the right
	        x1: barW,
	        y0: barDifY,
	        y1: barDifY + barH
	    };
	
	    var findClosestEdge = function(pt, ref, size) {
	        var e = trace.tiling.pad;
	        var isLeftOfRect = function(x) { return x - e <= ref.x0; };
	        var isRightOfRect = function(x) { return x + e >= ref.x1; };
	        var isBottomOfRect = function(y) { return y - e <= ref.y0; };
	        var isTopOfRect = function(y) { return y + e >= ref.y1; };
	
	        return {
	            x0: isLeftOfRect(pt.x0 - e) ? 0 : isRightOfRect(pt.x0 - e) ? size[0] : pt.x0,
	            x1: isLeftOfRect(pt.x1 + e) ? 0 : isRightOfRect(pt.x1 + e) ? size[0] : pt.x1,
	            y0: isBottomOfRect(pt.y0 - e) ? 0 : isTopOfRect(pt.y0 - e) ? size[1] : pt.y0,
	            y1: isBottomOfRect(pt.y1 + e) ? 0 : isTopOfRect(pt.y1 + e) ? size[1] : pt.y1
	        };
	    };
	
	    // stash of 'previous' position data used by tweening functions
	    var prevEntry = null;
	    var prevLookupPathbar = {};
	    var prevLookupSlices = {};
	    var nextOfPrevEntry = null;
	    var getPrev = function(pt, onPathbar) {
	        return onPathbar ?
	            prevLookupPathbar[getKey(pt)] :
	            prevLookupSlices[getKey(pt)];
	    };
	
	    var getOrigin = function(pt, onPathbar, refRect, size) {
	        if(onPathbar) {
	            return prevLookupPathbar[getKey(hierarchy)] || pathbarOrigin;
	        } else {
	            var ref = prevLookupSlices[trace.level] || refRect;
	
	            if(hasVisibleDepth(pt)) { // case of an empty object - happens when maxdepth is set
	                return findClosestEdge(pt, ref, size);
	            }
	        }
	        return {};
	    };
	
	    // N.B. handle multiple-root special case
	    if(cd0.hasMultipleRoots && isRoot) {
	        maxDepth++;
	    }
	
	    trace._maxDepth = maxDepth;
	    trace._backgroundColor = fullLayout.paper_bgcolor;
	    trace._entryDepth = entry.data.depth;
	    trace._atRootLevel = isRoot;
	
	    var cenX = -vpw / 2 + gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
	    var cenY = -vph / 2 + gs.t + gs.h * (1 - (domain.y[1] + domain.y[0]) / 2);
	
	    var viewMapX = function(x) { return cenX + x; };
	    var viewMapY = function(y) { return cenY + y; };
	
	    var barY0 = viewMapY(0);
	    var barX0 = viewMapX(0);
	
	    var viewBarX = function(x) { return barX0 + x; };
	    var viewBarY = function(y) { return barY0 + y; };
	
	    function pos(x, y) {
	        return x + ',' + y;
	    }
	
	    var xStart = viewBarX(0);
	    var limitX0 = function(p) { p.x = Math.max(xStart, p.x); };
	
	    var edgeshape = trace.pathbar.edgeshape;
	
	    // pathbar(directory) path generation fn
	    var pathAncestor = function(d) {
	        var _x0 = viewBarX(Math.max(Math.min(d.x0, d.x0), 0));
	        var _x1 = viewBarX(Math.min(Math.max(d.x1, d.x1), barW));
	        var _y0 = viewBarY(d.y0);
	        var _y1 = viewBarY(d.y1);
	
	        var halfH = barH / 2;
	
	        var pL = {};
	        var pR = {};
	
	        pL.x = _x0;
	        pR.x = _x1;
	
	        pL.y = pR.y = (_y0 + _y1) / 2;
	
	        var pA = {x: _x0, y: _y0};
	        var pB = {x: _x1, y: _y0};
	        var pC = {x: _x1, y: _y1};
	        var pD = {x: _x0, y: _y1};
	
	        if(edgeshape === '>') {
	            pA.x -= halfH;
	            pB.x -= halfH;
	            pC.x -= halfH;
	            pD.x -= halfH;
	        } else if(edgeshape === '/') {
	            pC.x -= halfH;
	            pD.x -= halfH;
	            pL.x -= halfH / 2;
	            pR.x -= halfH / 2;
	        } else if(edgeshape === '\\') {
	            pA.x -= halfH;
	            pB.x -= halfH;
	            pL.x -= halfH / 2;
	            pR.x -= halfH / 2;
	        } else if(edgeshape === '<') {
	            pL.x -= halfH;
	            pR.x -= halfH;
	        }
	
	        limitX0(pA);
	        limitX0(pD);
	        limitX0(pL);
	
	        limitX0(pB);
	        limitX0(pC);
	        limitX0(pR);
	
	        return (
	           'M' + pos(pA.x, pA.y) +
	           'L' + pos(pB.x, pB.y) +
	           'L' + pos(pR.x, pR.y) +
	           'L' + pos(pC.x, pC.y) +
	           'L' + pos(pD.x, pD.y) +
	           'L' + pos(pL.x, pL.y) +
	           'Z'
	        );
	    };
	
	    // slice path generation fn
	    var pathDescendant = function(d) {
	        var _x0 = viewMapX(d.x0);
	        var _x1 = viewMapX(d.x1);
	        var _y0 = viewMapY(d.y0);
	        var _y1 = viewMapY(d.y1);
	
	        var dx = _x1 - _x0;
	        var dy = _y1 - _y0;
	        if(!dx || !dy) return '';
	
	        var FILLET = 0; // TODO: may expose this constant
	
	        var r = (
	            dx > 2 * FILLET &&
	            dy > 2 * FILLET
	        ) ? FILLET : 0;
	
	        var arc = function(rx, ry) { return r ? 'a' + pos(r, r) + ' 0 0 1 ' + pos(rx, ry) : ''; };
	
	        return (
	           'M' + pos(_x0, _y0 + r) +
	           arc(r, -r) +
	           'L' + pos(_x1 - r, _y0) +
	           arc(r, r) +
	           'L' + pos(_x1, _y1 - r) +
	           arc(-r, r) +
	           'L' + pos(_x0 + r, _y1) +
	           arc(-r, -r) + 'Z'
	        );
	    };
	
	    var toMoveInsideSlice = function(pt, opts) {
	        var x0 = pt.x0;
	        var x1 = pt.x1;
	        var y0 = pt.y0;
	        var y1 = pt.y1;
	        var textBB = pt.textBB;
	
	        if(x0 === x1) {
	            x0 -= TEXTPAD;
	            x1 += TEXTPAD;
	        }
	
	        if(y0 === y1) {
	            y0 -= TEXTPAD;
	            y1 += TEXTPAD;
	        }
	
	        var hasFlag = function(f) { return trace.textposition.indexOf(f) !== -1; };
	
	        var hasBottom = hasFlag('bottom');
	        var hasTop = hasFlag('top') || (opts.isHeader && !hasBottom);
	
	        var anchor =
	            hasTop ? 'start' :
	            hasBottom ? 'end' : 'middle';
	
	        var hasRight = hasFlag('right');
	        var hasLeft = hasFlag('left') || opts.onPathbar;
	
	        var offsetDir =
	            hasLeft ? 'left' :
	            hasRight ? 'right' : 'center';
	
	        if(opts.onPathbar || !opts.isHeader) {
	            x0 += hasLeft ? TEXTPAD : 0;
	            x1 -= hasRight ? TEXTPAD : 0;
	        }
	
	        var pad = trace.marker.pad;
	        if(opts.isHeader) {
	            x0 += pad.l - TEXTPAD;
	            x1 -= pad.r - TEXTPAD;
	            if(x0 >= x1) {
	                var mid = (x0 + x1) / 2;
	                x0 = mid - TEXTPAD;
	                x1 = mid + TEXTPAD;
	            }
	
	            // limit the drawing area for headers
	            var limY;
	            if(hasBottom) {
	                limY = y1 - pad.b;
	                if(y0 < limY && limY < y1) y0 = limY;
	            } else {
	                limY = y0 + pad.t;
	                if(y0 < limY && limY < y1) y1 = limY;
	            }
	        }
	
	        // position the text relative to the slice
	        var transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
	            isHorizontal: false,
	            constrained: true,
	            angle: 0,
	            anchor: anchor
	        });
	
	        if(offsetDir !== 'center') {
	            var deltaX = (x1 - x0) / 2 - transform.scale * (textBB.right - textBB.left) / 2;
	            if(opts.isHeader) deltaX -= TEXTPAD;
	
	            if(offsetDir === 'left') transform.targetX -= deltaX;
	            else if(offsetDir === 'right') transform.targetX += deltaX;
	        }
	
	        transform.targetX = viewMapX(transform.targetX);
	        transform.targetY = viewMapY(transform.targetY);
	
	        if(isNaN(transform.targetX) || isNaN(transform.targetY)) {
	            return {};
	        }
	
	        return {
	            scale: transform.scale,
	            rotate: transform.rotate,
	            textX: transform.textX,
	            textY: transform.textY,
	            targetX: transform.targetX,
	            targetY: transform.targetY
	        };
	    };
	
	    var interpFromParent = function(pt, onPathbar) {
	        var parentPrev;
	        var i = 0;
	        var Q = pt;
	        while(!parentPrev && i < maxDepth) { // loop to find a parent/grandParent on the previous graph
	            i++;
	            Q = Q.parent;
	            if(Q) {
	                parentPrev = getPrev(Q, onPathbar);
	            } else i = maxDepth;
	        }
	        return parentPrev || {};
	    };
	
	    var makeExitSliceInterpolator = function(pt, onPathbar, refRect, size) {
	        var prev = getPrev(pt, onPathbar);
	        var next;
	
	        if(onPathbar) {
	            next = pathbarOrigin;
	        } else {
	            var entryPrev = getPrev(entry, onPathbar);
	            if(entryPrev) {
	                // 'entryPrev' is here has the previous coordinates of the entry
	                // node, which corresponds to the last "clicked" node when zooming in
	                next = findClosestEdge(pt, entryPrev, size);
	            } else {
	                // this happens when maxdepth is set, when leaves must
	                // be removed and the entry is new (i.e. does not have a 'prev' object)
	                next = {};
	            }
	        }
	
	        return d3.interpolate(prev, next);
	    };
	
	    var makeUpdateSliceInterpolator = function(pt, onPathbar, refRect, size) {
	        var prev0 = getPrev(pt, onPathbar);
	        var prev;
	
	        if(prev0) {
	            // if pt already on graph, this is easy
	            prev = prev0;
	        } else {
	            // for new pts:
	            if(onPathbar) {
	                prev = pathbarOrigin;
	            } else {
	                if(prevEntry) {
	                    // if trace was visible before
	                    if(pt.parent) {
	                        var ref = nextOfPrevEntry || refRect;
	
	                        if(ref && !onPathbar) {
	                            prev = findClosestEdge(pt, ref, size);
	                        } else {
	                            // if new leaf (when maxdepth is set),
	                            // grow it from its parent node
	                            prev = {};
	                            Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
	                        }
	                    } else {
	                        prev = pt;
	                    }
	                } else {
	                    prev = {};
	                }
	            }
	        }
	
	        return d3.interpolate(prev, {
	            x0: pt.x0,
	            x1: pt.x1,
	            y0: pt.y0,
	            y1: pt.y1
	        });
	    };
	
	    var makeUpdateTextInterpolator = function(pt, onPathbar, refRect, size) {
	        var prev0 = getPrev(pt, onPathbar);
	        var prev = {};
	        var origin = getOrigin(pt, onPathbar, refRect, size);
	
	        Lib.extendFlat(prev, {
	            transform: toMoveInsideSlice({
	                x0: origin.x0,
	                x1: origin.x1,
	                y0: origin.y0,
	                y1: origin.y1,
	                textBB: pt.textBB,
	                _text: pt._text
	            }, {
	                isHeader: helpers.isHeader(pt, trace)
	            })
	        });
	
	        if(prev0) {
	            // if pt already on graph, this is easy
	            prev = prev0;
	        } else {
	            // for new pts:
	            if(pt.parent) {
	                Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
	            }
	        }
	
	        return d3.interpolate(prev, {
	            transform: {
	                scale: pt.transform.scale,
	                rotate: pt.transform.rotate,
	                textX: pt.transform.textX,
	                textY: pt.transform.textY,
	                targetX: pt.transform.targetX,
	                targetY: pt.transform.targetY
	            }
	        });
	    };
	
	    var handleSlicesExit = function(slices, onPathbar, refRect, size, pathSlice) {
	        var width = size[0];
	        var height = size[1];
	
	        if(hasTransition) {
	            slices.exit().transition()
	                .each(function() {
	                    var sliceTop = d3.select(this);
	
	                    var slicePath = sliceTop.select('path.surface');
	                    slicePath.transition().attrTween('d', function(pt2) {
	                        var interp = makeExitSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
	                        return function(t) { return pathSlice(interp(t)); };
	                    });
	
	                    var sliceTextGroup = sliceTop.select('g.slicetext');
	                    sliceTextGroup.attr('opacity', 0);
	                })
	                .remove();
	        } else {
	            slices.exit().remove();
	        }
	    };
	
	    var strTransform = function(d) {
	        return Lib.getTextTransform({
	            textX: d.transform.textX,
	            textY: d.transform.textY,
	            targetX: d.transform.targetX,
	            targetY: d.transform.targetY,
	            scale: d.transform.scale,
	            rotate: d.transform.rotate
	        });
	    };
	
	    if(hasTransition) {
	        // Important: do this before binding new sliceData!
	
	        selAncestors.each(function(pt) {
	            prevLookupPathbar[getKey(pt)] = {
	                x0: pt.x0,
	                x1: pt.x1,
	                y0: pt.y0,
	                y1: pt.y1
	            };
	
	            if(pt.transform) {
	                prevLookupPathbar[getKey(pt)].transform = {
	                    textX: pt.transform.textX,
	                    textY: pt.transform.textY,
	                    targetX: pt.transform.targetX,
	                    targetY: pt.transform.targetY,
	                    scale: pt.transform.scale,
	                    rotate: pt.transform.rotate
	                };
	            }
	        });
	
	        selDescendants.each(function(pt) {
	            prevLookupSlices[getKey(pt)] = {
	                x0: pt.x0,
	                x1: pt.x1,
	                y0: pt.y0,
	                y1: pt.y1
	            };
	
	            if(pt.transform) {
	                prevLookupSlices[getKey(pt)].transform = {
	                    textX: pt.transform.textX,
	                    textY: pt.transform.textY,
	                    targetX: pt.transform.targetX,
	                    targetY: pt.transform.targetY,
	                    scale: pt.transform.scale,
	                    rotate: pt.transform.rotate
	                };
	            }
	
	            if(!prevEntry && helpers.isEntry(pt)) {
	                prevEntry = pt;
	            }
	        });
	    }
	
	    nextOfPrevEntry = drawDescendants(gd, cd, entry, selDescendants, {
	        width: vpw,
	        height: vph,
	
	        viewX: viewMapX,
	        viewY: viewMapY,
	
	        pathSlice: pathDescendant,
	        toMoveInsideSlice: toMoveInsideSlice,
	
	        prevEntry: prevEntry,
	        makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
	        makeUpdateTextInterpolator: makeUpdateTextInterpolator,
	
	        handleSlicesExit: handleSlicesExit,
	        hasTransition: hasTransition,
	        strTransform: strTransform
	    });
	
	    if(trace.pathbar.visible) {
	        drawAncestors(gd, cd, entry, selAncestors, {
	            barDifY: barDifY,
	            width: barW,
	            height: barH,
	
	            viewX: viewBarX,
	            viewY: viewBarY,
	
	            pathSlice: pathAncestor,
	            toMoveInsideSlice: toMoveInsideSlice,
	
	            makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
	            makeUpdateTextInterpolator: makeUpdateTextInterpolator,
	
	            handleSlicesExit: handleSlicesExit,
	            hasTransition: hasTransition,
	            strTransform: strTransform
	        });
	    }
	}
	
	},{"../../lib":716,"../bar/constants":857,"../bar/plot":866,"../sunburst/helpers":1234,"./constants":1257,"./draw_ancestors":1259,"./draw_descendants":1260,"d3":164}],1266:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var Lib = _dereq_('../../lib');
	var helpers = _dereq_('../sunburst/helpers');
	
	function style(gd) {
	    gd._fullLayout._treemaplayer.selectAll('.trace').each(function(cd) {
	        var gTrace = d3.select(this);
	        var cd0 = cd[0];
	        var trace = cd0.trace;
	
	        gTrace.style('opacity', trace.opacity);
	
	        gTrace.selectAll('path.surface').each(function(pt) {
	            d3.select(this).call(styleOne, pt, trace, {
	                hovered: false
	            });
	        });
	    });
	}
	
	function styleOne(s, pt, trace, opts) {
	    var hovered = (opts || {}).hovered;
	    var cdi = pt.data.data;
	    var ptNumber = cdi.i;
	    var lineColor;
	    var lineWidth;
	    var fillColor = cdi.color;
	    var isRoot = helpers.isHierarchyRoot(pt);
	    var opacity = 1;
	
	    if(hovered) {
	        lineColor = trace._hovered.marker.line.color;
	        lineWidth = trace._hovered.marker.line.width;
	    } else {
	        if(isRoot && fillColor === 'rgba(0,0,0,0)') {
	            opacity = 0;
	            lineColor = 'rgba(0,0,0,0)';
	            lineWidth = 0;
	        } else {
	            lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
	            lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
	
	            if(!trace._hasColorscale && !pt.onPathbar) {
	                var depthfade = trace.marker.depthfade;
	                if(depthfade) {
	                    var fadedColor = Color.combine(Color.addOpacity(trace._backgroundColor, 0.75), fillColor);
	                    var n;
	
	                    if(depthfade === true) {
	                        var maxDepth = helpers.getMaxDepth(trace);
	                        if(isFinite(maxDepth)) {
	                            if(helpers.isLeaf(pt)) {
	                                n = 0;
	                            } else {
	                                n = (trace._maxVisibleLayers) - (pt.data.depth - trace._entryDepth);
	                            }
	                        } else {
	                            n = pt.data.height + 1;
	                        }
	                    } else { // i.e. case of depthfade === 'reversed'
	                        n = pt.data.depth - trace._entryDepth;
	                        if(!trace._atRootLevel) n++;
	                    }
	
	                    if(n > 0) {
	                        for(var i = 0; i < n; i++) {
	                            var ratio = 0.5 * i / n;
	                            fillColor = Color.combine(Color.addOpacity(fadedColor, ratio), fillColor);
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    s.style('stroke-width', lineWidth)
	        .call(Color.fill, fillColor)
	        .call(Color.stroke, lineColor)
	        .style('opacity', opacity);
	}
	
	module.exports = {
	    style: style,
	    styleOne: styleOne
	};
	
	},{"../../components/color":591,"../../lib":716,"../sunburst/helpers":1234,"d3":164}],1267:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var boxAttrs = _dereq_('../box/attributes');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	
	module.exports = {
	    y: boxAttrs.y,
	    x: boxAttrs.x,
	    x0: boxAttrs.x0,
	    y0: boxAttrs.y0,
	    name: extendFlat({}, boxAttrs.name, {
	        
	    }),
	    orientation: extendFlat({}, boxAttrs.orientation, {
	        
	    }),
	
	    bandwidth: {
	        valType: 'number',
	        min: 0,
	        
	        editType: 'calc',
	        
	    },
	
	    scalegroup: {
	        valType: 'string',
	        
	        dflt: '',
	        editType: 'calc',
	        
	    },
	    scalemode: {
	        valType: 'enumerated',
	        values: ['width', 'count'],
	        dflt: 'width',
	        
	        editType: 'calc',
	        
	    },
	
	    spanmode: {
	        valType: 'enumerated',
	        values: ['soft', 'hard', 'manual'],
	        dflt: 'soft',
	        
	        editType: 'calc',
	        
	    },
	    span: {
	        valType: 'info_array',
	        items: [
	            {valType: 'any', editType: 'calc'},
	            {valType: 'any', editType: 'calc'}
	        ],
	        
	        editType: 'calc',
	        
	    },
	
	    line: {
	        color: {
	            valType: 'color',
	            
	            editType: 'style',
	            
	        },
	        width: {
	            valType: 'number',
	            
	            min: 0,
	            dflt: 2,
	            editType: 'style',
	            
	        },
	        editType: 'plot'
	    },
	    fillcolor: boxAttrs.fillcolor,
	
	    points: extendFlat({}, boxAttrs.boxpoints, {
	        
	    }),
	    jitter: extendFlat({}, boxAttrs.jitter, {
	        
	    }),
	    pointpos: extendFlat({}, boxAttrs.pointpos, {
	        
	    }),
	
	    width: extendFlat({}, boxAttrs.width, {
	        
	    }),
	
	    marker: boxAttrs.marker,
	    text: boxAttrs.text,
	    hovertext: boxAttrs.hovertext,
	    hovertemplate: boxAttrs.hovertemplate,
	
	    box: {
	        visible: {
	            valType: 'boolean',
	            dflt: false,
	            
	            editType: 'plot',
	            
	        },
	        width: {
	            valType: 'number',
	            min: 0,
	            max: 1,
	            dflt: 0.25,
	            
	            editType: 'plot',
	            
	        },
	        fillcolor: {
	            valType: 'color',
	            
	            editType: 'style',
	            
	        },
	        line: {
	            color: {
	                valType: 'color',
	                
	                editType: 'style',
	                
	            },
	            width: {
	                valType: 'number',
	                min: 0,
	                
	                editType: 'style',
	                
	            },
	            editType: 'style'
	        },
	        editType: 'plot'
	    },
	
	    meanline: {
	        visible: {
	            valType: 'boolean',
	            dflt: false,
	            
	            editType: 'plot',
	            
	        },
	        color: {
	            valType: 'color',
	            
	            editType: 'style',
	            
	        },
	        width: {
	            valType: 'number',
	            min: 0,
	            
	            editType: 'style',
	            
	        },
	        editType: 'plot'
	    },
	
	    side: {
	        valType: 'enumerated',
	        values: ['both', 'positive', 'negative'],
	        dflt: 'both',
	        
	        editType: 'calc',
	        
	    },
	
	    offsetgroup: boxAttrs.offsetgroup,
	    alignmentgroup: boxAttrs.alignmentgroup,
	
	    selected: boxAttrs.selected,
	    unselected: boxAttrs.unselected,
	
	    hoveron: {
	        valType: 'flaglist',
	        flags: ['violins', 'points', 'kde'],
	        dflt: 'violins+points+kde',
	        extras: ['all'],
	        
	        editType: 'style',
	        
	    }
	};
	
	},{"../../lib/extend":707,"../box/attributes":879}],1268:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var boxCalc = _dereq_('../box/calc');
	var helpers = _dereq_('./helpers');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	module.exports = function calc(gd, trace) {
	    var cd = boxCalc(gd, trace);
	
	    if(cd[0].t.empty) return cd;
	
	    var fullLayout = gd._fullLayout;
	    var valAxis = Axes.getFromId(
	        gd,
	        trace[trace.orientation === 'h' ? 'xaxis' : 'yaxis']
	    );
	
	    var spanMin = Infinity;
	    var spanMax = -Infinity;
	    var maxKDE = 0;
	    var maxCount = 0;
	
	    for(var i = 0; i < cd.length; i++) {
	        var cdi = cd[i];
	        var vals = cdi.pts.map(helpers.extractVal);
	
	        var bandwidth = cdi.bandwidth = calcBandwidth(trace, cdi, vals);
	        var span = cdi.span = calcSpan(trace, cdi, valAxis, bandwidth);
	
	        if(cdi.min === cdi.max && bandwidth === 0) {
	            // if span is zero and bandwidth is zero, we want a violin with zero width
	            span = cdi.span = [cdi.min, cdi.max];
	            cdi.density = [{v: 1, t: span[0]}];
	            cdi.bandwidth = bandwidth;
	            maxKDE = Math.max(maxKDE, 1);
	        } else {
	            // step that well covers the bandwidth and is multiple of span distance
	            var dist = span[1] - span[0];
	            var n = Math.ceil(dist / (bandwidth / 3));
	            var step = dist / n;
	
	            if(!isFinite(step) || !isFinite(n)) {
	                Lib.error('Something went wrong with computing the violin span');
	                cd[0].t.empty = true;
	                return cd;
	            }
	
	            var kde = helpers.makeKDE(cdi, trace, vals);
	            cdi.density = new Array(n);
	
	            for(var k = 0, t = span[0]; t < (span[1] + step / 2); k++, t += step) {
	                var v = kde(t);
	                cdi.density[k] = {v: v, t: t};
	                maxKDE = Math.max(maxKDE, v);
	            }
	        }
	
	        maxCount = Math.max(maxCount, vals.length);
	        spanMin = Math.min(spanMin, span[0]);
	        spanMax = Math.max(spanMax, span[1]);
	    }
	
	    var extremes = Axes.findExtremes(valAxis, [spanMin, spanMax], {padded: true});
	    trace._extremes[valAxis._id] = extremes;
	
	    if(trace.width) {
	        cd[0].t.maxKDE = maxKDE;
	    } else {
	        var violinScaleGroupStats = fullLayout._violinScaleGroupStats;
	        var scaleGroup = trace.scalegroup;
	        var groupStats = violinScaleGroupStats[scaleGroup];
	
	        if(groupStats) {
	            groupStats.maxKDE = Math.max(groupStats.maxKDE, maxKDE);
	            groupStats.maxCount = Math.max(groupStats.maxCount, maxCount);
	        } else {
	            violinScaleGroupStats[scaleGroup] = {
	                maxKDE: maxKDE,
	                maxCount: maxCount
	            };
	        }
	    }
	
	    cd[0].t.labels.kde = Lib._(gd, 'kde:');
	
	    return cd;
	};
	
	// Default to Silveman's rule of thumb
	// - https://stats.stackexchange.com/a/6671
	// - https://en.wikipedia.org/wiki/Kernel_density_estimation#A_rule-of-thumb_bandwidth_estimator
	// - https://github.com/statsmodels/statsmodels/blob/master/statsmodels/nonparametric/bandwidths.py
	function silvermanRule(len, ssd, iqr) {
	    var a = Math.min(ssd, iqr / 1.349);
	    return 1.059 * a * Math.pow(len, -0.2);
	}
	
	function calcBandwidth(trace, cdi, vals) {
	    var span = cdi.max - cdi.min;
	
	    // If span is zero
	    if(!span) {
	        if(trace.bandwidth) {
	            return trace.bandwidth;
	        } else {
	            // if span is zero and no bandwidth is specified
	            // it returns zero bandwidth which is a special case
	            return 0;
	        }
	    }
	
	    // Limit how small the bandwidth can be.
	    //
	    // Silverman's rule of thumb can be "very" small
	    // when IQR does a poor job at describing the spread
	    // of the distribution.
	    // We also want to limit custom bandwidths
	    // to not blow up kde computations.
	
	    if(trace.bandwidth) {
	        return Math.max(trace.bandwidth, span / 1e4);
	    } else {
	        var len = vals.length;
	        var ssd = Lib.stdev(vals, len - 1, cdi.mean);
	        return Math.max(
	            silvermanRule(len, ssd, cdi.q3 - cdi.q1),
	            span / 100
	        );
	    }
	}
	
	function calcSpan(trace, cdi, valAxis, bandwidth) {
	    var spanmode = trace.spanmode;
	    var spanIn = trace.span || [];
	    var spanTight = [cdi.min, cdi.max];
	    var spanLoose = [cdi.min - 2 * bandwidth, cdi.max + 2 * bandwidth];
	    var spanOut;
	
	    function calcSpanItem(index) {
	        var s = spanIn[index];
	        var sc = valAxis.type === 'multicategory' ?
	            valAxis.r2c(s) :
	            valAxis.d2c(s, 0, trace[cdi.valLetter + 'calendar']);
	        return sc === BADNUM ? spanLoose[index] : sc;
	    }
	
	    if(spanmode === 'soft') {
	        spanOut = spanLoose;
	    } else if(spanmode === 'hard') {
	        spanOut = spanTight;
	    } else {
	        spanOut = [calcSpanItem(0), calcSpanItem(1)];
	    }
	
	    // to reuse the equal-range-item block
	    var dummyAx = {
	        type: 'linear',
	        range: spanOut
	    };
	    Axes.setConvert(dummyAx);
	    dummyAx.cleanRange();
	
	    return spanOut;
	}
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axes":764,"../box/calc":880,"./helpers":1271}],1269:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var setPositionOffset = _dereq_('../box/cross_trace_calc').setPositionOffset;
	var orientations = ['v', 'h'];
	
	module.exports = function crossTraceCalc(gd, plotinfo) {
	    var calcdata = gd.calcdata;
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    for(var i = 0; i < orientations.length; i++) {
	        var orientation = orientations[i];
	        var posAxis = orientation === 'h' ? ya : xa;
	        var violinList = [];
	
	        for(var j = 0; j < calcdata.length; j++) {
	            var cd = calcdata[j];
	            var t = cd[0].t;
	            var trace = cd[0].trace;
	
	            if(trace.visible === true && trace.type === 'violin' &&
	                    !t.empty &&
	                    trace.orientation === orientation &&
	                    trace.xaxis === xa._id &&
	                    trace.yaxis === ya._id
	              ) {
	                violinList.push(j);
	            }
	        }
	
	        setPositionOffset('violin', gd, violinList, posAxis);
	    }
	};
	
	},{"../box/cross_trace_calc":881}],1270:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Color = _dereq_('../../components/color');
	
	var boxDefaults = _dereq_('../box/defaults');
	var attributes = _dereq_('./attributes');
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	    function coerce2(attr, dflt) {
	        return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    boxDefaults.handleSampleDefaults(traceIn, traceOut, coerce, layout);
	    if(traceOut.visible === false) return;
	
	    coerce('bandwidth');
	    coerce('side');
	
	    var width = coerce('width');
	    if(!width) {
	        coerce('scalegroup', traceOut.name);
	        coerce('scalemode');
	    }
	
	    var span = coerce('span');
	    var spanmodeDflt;
	    if(Array.isArray(span)) spanmodeDflt = 'manual';
	    coerce('spanmode', spanmodeDflt);
	
	    var lineColor = coerce('line.color', (traceIn.marker || {}).color || defaultColor);
	    var lineWidth = coerce('line.width');
	    var fillColor = coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
	
	    boxDefaults.handlePointsDefaults(traceIn, traceOut, coerce, {prefix: ''});
	
	    var boxWidth = coerce2('box.width');
	    var boxFillColor = coerce2('box.fillcolor', fillColor);
	    var boxLineColor = coerce2('box.line.color', lineColor);
	    var boxLineWidth = coerce2('box.line.width', lineWidth);
	    var boxVisible = coerce('box.visible', Boolean(boxWidth || boxFillColor || boxLineColor || boxLineWidth));
	    if(!boxVisible) traceOut.box = {visible: false};
	
	    var meanLineColor = coerce2('meanline.color', lineColor);
	    var meanLineWidth = coerce2('meanline.width', lineWidth);
	    var meanLineVisible = coerce('meanline.visible', Boolean(meanLineColor || meanLineWidth));
	    if(!meanLineVisible) traceOut.meanline = {visible: false};
	};
	
	},{"../../components/color":591,"../../lib":716,"../box/defaults":882,"./attributes":1267}],1271:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	// Maybe add kernels more down the road,
	// but note that the default `spanmode: 'soft'` bounds might have
	// to become kernel-dependent
	var kernels = {
	    gaussian: function(v) {
	        return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * v * v);
	    }
	};
	
	exports.makeKDE = function(calcItem, trace, vals) {
	    var len = vals.length;
	    var kernel = kernels.gaussian;
	    var bandwidth = calcItem.bandwidth;
	    var factor = 1 / (len * bandwidth);
	
	    // don't use Lib.aggNums to skip isNumeric checks
	    return function(x) {
	        var sum = 0;
	        for(var i = 0; i < len; i++) {
	            sum += kernel((x - vals[i]) / bandwidth);
	        }
	        return factor * sum;
	    };
	};
	
	exports.getPositionOnKdePath = function(calcItem, trace, valuePx) {
	    var posLetter, valLetter;
	
	    if(trace.orientation === 'h') {
	        posLetter = 'y';
	        valLetter = 'x';
	    } else {
	        posLetter = 'x';
	        valLetter = 'y';
	    }
	
	    var pointOnPath = Lib.findPointOnPath(
	        calcItem.path,
	        valuePx,
	        valLetter,
	        {pathLength: calcItem.pathLength}
	    );
	
	    var posCenterPx = calcItem.posCenterPx;
	    var posOnPath0 = pointOnPath[posLetter];
	    var posOnPath1 = trace.side === 'both' ?
	        2 * posCenterPx - posOnPath0 :
	        posCenterPx;
	
	    return [posOnPath0, posOnPath1];
	};
	
	exports.getKdeValue = function(calcItem, trace, valueDist) {
	    var vals = calcItem.pts.map(exports.extractVal);
	    var kde = exports.makeKDE(calcItem, trace, vals);
	    return kde(valueDist) / calcItem.posDensityScale;
	};
	
	exports.extractVal = function(o) { return o.v; };
	
	},{"../../lib":716}],1272:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var Axes = _dereq_('../../plots/cartesian/axes');
	var boxHoverPoints = _dereq_('../box/hover');
	var helpers = _dereq_('./helpers');
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer) {
	    var cd = pointData.cd;
	    var trace = cd[0].trace;
	    var hoveron = trace.hoveron;
	    var hasHoveronViolins = hoveron.indexOf('violins') !== -1;
	    var hasHoveronKDE = hoveron.indexOf('kde') !== -1;
	    var closeData = [];
	    var closePtData;
	    var violinLineAttrs;
	
	    if(hasHoveronViolins || hasHoveronKDE) {
	        var closeBoxData = boxHoverPoints.hoverOnBoxes(pointData, xval, yval, hovermode);
	
	        if(hasHoveronKDE && closeBoxData.length > 0) {
	            var xa = pointData.xa;
	            var ya = pointData.ya;
	            var pLetter, vLetter, pAxis, vAxis, vVal;
	
	            if(trace.orientation === 'h') {
	                vVal = xval;
	                pLetter = 'y';
	                pAxis = ya;
	                vLetter = 'x';
	                vAxis = xa;
	            } else {
	                vVal = yval;
	                pLetter = 'x';
	                pAxis = xa;
	                vLetter = 'y';
	                vAxis = ya;
	            }
	
	            var di = cd[pointData.index];
	
	            if(vVal >= di.span[0] && vVal <= di.span[1]) {
	                var kdePointData = Lib.extendFlat({}, pointData);
	                var vValPx = vAxis.c2p(vVal, true);
	                var kdeVal = helpers.getKdeValue(di, trace, vVal);
	                var pOnPath = helpers.getPositionOnKdePath(di, trace, vValPx);
	                var paOffset = pAxis._offset;
	                var paLength = pAxis._length;
	
	                kdePointData[pLetter + '0'] = pOnPath[0];
	                kdePointData[pLetter + '1'] = pOnPath[1];
	                kdePointData[vLetter + '0'] = kdePointData[vLetter + '1'] = vValPx;
	                kdePointData[vLetter + 'Label'] = vLetter + ': ' + Axes.hoverLabelText(vAxis, vVal) + ', ' + cd[0].t.labels.kde + ' ' + kdeVal.toFixed(3);
	
	                // move the spike to the KDE point
	                kdePointData.spikeDistance = closeBoxData[0].spikeDistance;
	                var spikePosAttr = pLetter + 'Spike';
	                kdePointData[spikePosAttr] = closeBoxData[0][spikePosAttr];
	                closeBoxData[0].spikeDistance = undefined;
	                closeBoxData[0][spikePosAttr] = undefined;
	
	                // no hovertemplate support yet
	                kdePointData.hovertemplate = false;
	
	                closeData.push(kdePointData);
	
	                violinLineAttrs = {stroke: pointData.color};
	                violinLineAttrs[pLetter + '1'] = Lib.constrain(paOffset + pOnPath[0], paOffset, paOffset + paLength);
	                violinLineAttrs[pLetter + '2'] = Lib.constrain(paOffset + pOnPath[1], paOffset, paOffset + paLength);
	                violinLineAttrs[vLetter + '1'] = violinLineAttrs[vLetter + '2'] = vAxis._offset + vValPx;
	            }
	        }
	
	        if(hasHoveronViolins) {
	            closeData = closeData.concat(closeBoxData);
	        }
	    }
	
	    if(hoveron.indexOf('points') !== -1) {
	        closePtData = boxHoverPoints.hoverOnPoints(pointData, xval, yval);
	    }
	
	    // update violin line (if any)
	    var violinLine = hoverLayer.selectAll('.violinline-' + trace.uid)
	        .data(violinLineAttrs ? [0] : []);
	    violinLine.enter().append('line')
	        .classed('violinline-' + trace.uid, true)
	        .attr('stroke-width', 1.5);
	    violinLine.exit().remove();
	    violinLine.attr(violinLineAttrs);
	
	    // same combine logic as box hoverPoints
	    if(hovermode === 'closest') {
	        if(closePtData) return [closePtData];
	        return closeData;
	    }
	    if(closePtData) {
	        closeData.push(closePtData);
	        return closeData;
	    }
	    return closeData;
	};
	
	},{"../../lib":716,"../../plots/cartesian/axes":764,"../box/hover":884,"./helpers":1271}],1273:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    crossTraceDefaults: _dereq_('../box/defaults').crossTraceDefaults,
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    calc: _dereq_('./calc'),
	    crossTraceCalc: _dereq_('./cross_trace_calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style'),
	    styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
	    hoverPoints: _dereq_('./hover'),
	    selectPoints: _dereq_('../box/select'),
	
	    moduleType: 'trace',
	    name: 'violin',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'violinLayout', 'zoomScale'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../box/defaults":882,"../box/select":889,"../scatter/style":1141,"./attributes":1267,"./calc":1268,"./cross_trace_calc":1269,"./defaults":1270,"./hover":1272,"./layout_attributes":1274,"./layout_defaults":1275,"./plot":1276,"./style":1277}],1274:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var boxLayoutAttrs = _dereq_('../box/layout_attributes');
	var extendFlat = _dereq_('../../lib').extendFlat;
	
	module.exports = {
	    violinmode: extendFlat({}, boxLayoutAttrs.boxmode, {
	        
	    }),
	    violingap: extendFlat({}, boxLayoutAttrs.boxgap, {
	        
	    }),
	    violingroupgap: extendFlat({}, boxLayoutAttrs.boxgroupgap, {
	        
	    })
	};
	
	},{"../../lib":716,"../box/layout_attributes":886}],1275:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	var boxLayoutDefaults = _dereq_('../box/layout_defaults');
	
	module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	    boxLayoutDefaults._supply(layoutIn, layoutOut, fullData, coerce, 'violin');
	};
	
	},{"../../lib":716,"../box/layout_defaults":887,"./layout_attributes":1274}],1276:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	
	var boxPlot = _dereq_('../box/plot');
	var linePoints = _dereq_('../scatter/line_points');
	var helpers = _dereq_('./helpers');
	
	module.exports = function plot(gd, plotinfo, cdViolins, violinLayer) {
	    var fullLayout = gd._fullLayout;
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    function makePath(pts) {
	        var segments = linePoints(pts, {
	            xaxis: xa,
	            yaxis: ya,
	            connectGaps: true,
	            baseTolerance: 0.75,
	            shape: 'spline',
	            simplify: true,
	            linearized: true
	        });
	        return Drawing.smoothopen(segments[0], 1);
	    }
	
	    Lib.makeTraceGroups(violinLayer, cdViolins, 'trace violins').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var cd0 = cd[0];
	        var t = cd0.t;
	        var trace = cd0.trace;
	
	        if(trace.visible !== true || t.empty) {
	            plotGroup.remove();
	            return;
	        }
	
	        var bPos = t.bPos;
	        var bdPos = t.bdPos;
	        var valAxis = plotinfo[t.valLetter + 'axis'];
	        var posAxis = plotinfo[t.posLetter + 'axis'];
	        var hasBothSides = trace.side === 'both';
	        var hasPositiveSide = hasBothSides || trace.side === 'positive';
	        var hasNegativeSide = hasBothSides || trace.side === 'negative';
	
	        var violins = plotGroup.selectAll('path.violin').data(Lib.identity);
	
	        violins.enter().append('path')
	            .style('vector-effect', 'non-scaling-stroke')
	            .attr('class', 'violin');
	
	        violins.exit().remove();
	
	        violins.each(function(d) {
	            var pathSel = d3.select(this);
	            var density = d.density;
	            var len = density.length;
	            var posCenter = posAxis.c2l(d.pos + bPos, true);
	            var posCenterPx = posAxis.l2p(posCenter);
	
	            var scale;
	            if(trace.width) {
	                scale = t.maxKDE / bdPos;
	            } else {
	                var groupStats = fullLayout._violinScaleGroupStats[trace.scalegroup];
	                scale = trace.scalemode === 'count' ?
	                    (groupStats.maxKDE / bdPos) * (groupStats.maxCount / d.pts.length) :
	                    groupStats.maxKDE / bdPos;
	            }
	
	            var pathPos, pathNeg, path;
	            var i, k, pts, pt;
	
	            if(hasPositiveSide) {
	                pts = new Array(len);
	                for(i = 0; i < len; i++) {
	                    pt = pts[i] = {};
	                    pt[t.posLetter] = posCenter + (density[i].v / scale);
	                    pt[t.valLetter] = valAxis.c2l(density[i].t, true);
	                }
	                pathPos = makePath(pts);
	            }
	
	            if(hasNegativeSide) {
	                pts = new Array(len);
	                for(k = 0, i = len - 1; k < len; k++, i--) {
	                    pt = pts[k] = {};
	                    pt[t.posLetter] = posCenter - (density[i].v / scale);
	                    pt[t.valLetter] = valAxis.c2l(density[i].t, true);
	                }
	                pathNeg = makePath(pts);
	            }
	
	            if(hasBothSides) {
	                path = pathPos + 'L' + pathNeg.substr(1) + 'Z';
	            } else {
	                var startPt = [posCenterPx, valAxis.c2p(density[0].t)];
	                var endPt = [posCenterPx, valAxis.c2p(density[len - 1].t)];
	
	                if(trace.orientation === 'h') {
	                    startPt.reverse();
	                    endPt.reverse();
	                }
	
	                if(hasPositiveSide) {
	                    path = 'M' + startPt + 'L' + pathPos.substr(1) + 'L' + endPt;
	                } else {
	                    path = 'M' + endPt + 'L' + pathNeg.substr(1) + 'L' + startPt;
	                }
	            }
	            pathSel.attr('d', path);
	
	            // save a few things used in getPositionOnKdePath, getKdeValue
	            // on hover and for meanline draw block below
	            d.posCenterPx = posCenterPx;
	            d.posDensityScale = scale * bdPos;
	            d.path = pathSel.node();
	            d.pathLength = d.path.getTotalLength() / (hasBothSides ? 2 : 1);
	        });
	
	        var boxAttrs = trace.box;
	        var boxWidth = boxAttrs.width;
	        var boxLineWidth = (boxAttrs.line || {}).width;
	        var bdPosScaled;
	        var bPosPxOffset;
	
	        if(hasBothSides) {
	            bdPosScaled = bdPos * boxWidth;
	            bPosPxOffset = 0;
	        } else if(hasPositiveSide) {
	            bdPosScaled = [0, bdPos * boxWidth / 2];
	            bPosPxOffset = boxLineWidth * {x: 1, y: -1}[t.posLetter];
	        } else {
	            bdPosScaled = [bdPos * boxWidth / 2, 0];
	            bPosPxOffset = boxLineWidth * {x: -1, y: 1}[t.posLetter];
	        }
	
	        // inner box
	        boxPlot.plotBoxAndWhiskers(plotGroup, {pos: posAxis, val: valAxis}, trace, {
	            bPos: bPos,
	            bdPos: bdPosScaled,
	            bPosPxOffset: bPosPxOffset
	        });
	
	        // meanline insider box
	        boxPlot.plotBoxMean(plotGroup, {pos: posAxis, val: valAxis}, trace, {
	            bPos: bPos,
	            bdPos: bdPosScaled,
	            bPosPxOffset: bPosPxOffset
	        });
	
	        var fn;
	        if(!trace.box.visible && trace.meanline.visible) {
	            fn = Lib.identity;
	        }
	
	        // N.B. use different class name than boxPlot.plotBoxMean,
	        // to avoid selectAll conflict
	        var meanPaths = plotGroup.selectAll('path.meanline').data(fn || []);
	        meanPaths.enter().append('path')
	            .attr('class', 'meanline')
	            .style('fill', 'none')
	            .style('vector-effect', 'non-scaling-stroke');
	        meanPaths.exit().remove();
	        meanPaths.each(function(d) {
	            var v = valAxis.c2p(d.mean, true);
	            var p = helpers.getPositionOnKdePath(d, trace, v);
	
	            d3.select(this).attr('d',
	                trace.orientation === 'h' ?
	                    'M' + v + ',' + p[0] + 'V' + p[1] :
	                    'M' + p[0] + ',' + v + 'H' + p[1]
	            );
	        });
	
	        boxPlot.plotPoints(plotGroup, {x: xa, y: ya}, trace, t);
	    });
	};
	
	},{"../../components/drawing":612,"../../lib":716,"../box/plot":888,"../scatter/line_points":1132,"./helpers":1271,"d3":164}],1277:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Color = _dereq_('../../components/color');
	var stylePoints = _dereq_('../scatter/style').stylePoints;
	
	module.exports = function style(gd) {
	    var s = d3.select(gd).selectAll('g.trace.violins');
	
	    s.style('opacity', function(d) { return d[0].trace.opacity; });
	
	    s.each(function(d) {
	        var trace = d[0].trace;
	        var sel = d3.select(this);
	        var box = trace.box || {};
	        var boxLine = box.line || {};
	        var meanline = trace.meanline || {};
	        var meanLineWidth = meanline.width;
	
	        sel.selectAll('path.violin')
	            .style('stroke-width', trace.line.width + 'px')
	            .call(Color.stroke, trace.line.color)
	            .call(Color.fill, trace.fillcolor);
	
	        sel.selectAll('path.box')
	            .style('stroke-width', boxLine.width + 'px')
	            .call(Color.stroke, boxLine.color)
	            .call(Color.fill, box.fillcolor);
	
	        var meanLineStyle = {
	            'stroke-width': meanLineWidth + 'px',
	            'stroke-dasharray': (2 * meanLineWidth) + 'px,' + meanLineWidth + 'px'
	        };
	
	        sel.selectAll('path.mean')
	            .style(meanLineStyle)
	            .call(Color.stroke, meanline.color);
	
	        sel.selectAll('path.meanline')
	            .style(meanLineStyle)
	            .call(Color.stroke, meanline.color);
	
	        stylePoints(sel, trace, gd);
	    });
	};
	
	},{"../../components/color":591,"../scatter/style":1141,"d3":164}],1278:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
	var isosurfaceAttrs = _dereq_('../isosurface/attributes');
	var baseAttrs = _dereq_('../../plots/attributes');
	
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
	
	var attrs = module.exports = overrideAll(extendFlat({
	    x: isosurfaceAttrs.x,
	    y: isosurfaceAttrs.y,
	    z: isosurfaceAttrs.z,
	    value: isosurfaceAttrs.value,
	    isomin: isosurfaceAttrs.isomin,
	    isomax: isosurfaceAttrs.isomax,
	    surface: isosurfaceAttrs.surface,
	    spaceframe: {
	        show: {
	            valType: 'boolean',
	            
	            dflt: false,
	            
	        },
	        fill: {
	            valType: 'number',
	            
	            min: 0,
	            max: 1,
	            dflt: 1,
	            
	        }
	    },
	
	    slices: isosurfaceAttrs.slices,
	    caps: isosurfaceAttrs.caps,
	    text: isosurfaceAttrs.text,
	    hovertext: isosurfaceAttrs.hovertext,
	    hovertemplate: isosurfaceAttrs.hovertemplate
	},
	
	colorScaleAttrs('', {
	    colorAttr: '`value`',
	    showScaleDflt: true,
	    editTypeOverride: 'calc'
	}), {
	
	    colorbar: isosurfaceAttrs.colorbar,
	    opacity: isosurfaceAttrs.opacity,
	    opacityscale: {
	        valType: 'any',
	        
	        editType: 'calc',
	        
	    },
	
	    lightposition: isosurfaceAttrs.lightposition,
	    lighting: isosurfaceAttrs.lighting,
	    flatshading: isosurfaceAttrs.flatshading,
	    contour: isosurfaceAttrs.contour,
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	}), 'calc', 'nested');
	
	attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
	attrs.transforms = undefined;
	
	},{"../../components/colorscale/attributes":598,"../../lib/extend":707,"../../plot_api/edit_types":747,"../../plots/attributes":761,"../isosurface/attributes":1054}],1279:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var createMesh = _dereq_('gl-mesh3d');
	
	var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
	var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
	var extractOpts = _dereq_('../../components/colorscale').extractOpts;
	var zip3 = _dereq_('../../plots/gl3d/zip3');
	
	var findNearestOnAxis = _dereq_('../isosurface/convert').findNearestOnAxis;
	var generateIsoMeshes = _dereq_('../isosurface/convert').generateIsoMeshes;
	
	function VolumeTrace(scene, mesh, uid) {
	    this.scene = scene;
	    this.uid = uid;
	    this.mesh = mesh;
	    this.name = '';
	    this.data = null;
	    this.showContour = false;
	}
	
	var proto = VolumeTrace.prototype;
	
	proto.handlePick = function(selection) {
	    if(selection.object === this.mesh) {
	        var rawId = selection.data.index;
	
	        var x = this.data._x[rawId];
	        var y = this.data._y[rawId];
	        var z = this.data._z[rawId];
	
	        var height = this.data._Ys.length;
	        var depth = this.data._Zs.length;
	
	        var i = findNearestOnAxis(x, this.data._Xs).id;
	        var j = findNearestOnAxis(y, this.data._Ys).id;
	        var k = findNearestOnAxis(z, this.data._Zs).id;
	
	        var selectIndex = selection.index = k + depth * j + depth * height * i;
	
	        selection.traceCoordinate = [
	            this.data._x[selectIndex],
	            this.data._y[selectIndex],
	            this.data._z[selectIndex],
	            this.data.value[selectIndex]
	        ];
	
	        var text = this.data.hovertext || this.data.text;
	        if(Array.isArray(text) && text[selectIndex] !== undefined) {
	            selection.textLabel = text[selectIndex];
	        } else if(text) {
	            selection.textLabel = text;
	        }
	
	        return true;
	    }
	};
	
	proto.update = function(data) {
	    var scene = this.scene;
	    var layout = scene.fullSceneLayout;
	
	    this.data = generateIsoMeshes(data);
	
	    // Unpack position data
	    function toDataCoords(axis, coord, scale, calendar) {
	        return coord.map(function(x) {
	            return axis.d2l(x, 0, calendar) * scale;
	        });
	    }
	
	    var positions = zip3(
	        toDataCoords(layout.xaxis, data._x, scene.dataScale[0], data.xcalendar),
	        toDataCoords(layout.yaxis, data._y, scene.dataScale[1], data.ycalendar),
	        toDataCoords(layout.zaxis, data._z, scene.dataScale[2], data.zcalendar));
	
	    var cells = zip3(data._i, data._j, data._k);
	
	    var config = {
	        positions: positions,
	        cells: cells,
	        lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	        ambient: data.lighting.ambient,
	        diffuse: data.lighting.diffuse,
	        specular: data.lighting.specular,
	        roughness: data.lighting.roughness,
	        fresnel: data.lighting.fresnel,
	        vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	        faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	        opacity: data.opacity,
	        opacityscale: data.opacityscale,
	        contourEnable: data.contour.show,
	        contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	        contourWidth: data.contour.width,
	        useFacetNormals: data.flatshading
	    };
	
	    var cOpts = extractOpts(data);
	    config.vertexIntensity = data._intensity;
	    config.vertexIntensityBounds = [cOpts.min, cOpts.max];
	    config.colormap = parseColorScale(data);
	
	    // Update mesh
	    this.mesh.update(config);
	};
	
	proto.dispose = function() {
	    this.scene.glplot.remove(this.mesh);
	    this.mesh.dispose();
	};
	
	function createVolumeTrace(scene, data) {
	    var gl = scene.glplot.gl;
	    var mesh = createMesh({gl: gl});
	    var result = new VolumeTrace(scene, mesh, data.uid);
	
	    mesh._trace = result;
	    result.update(data);
	    scene.glplot.add(mesh);
	    return result;
	}
	
	module.exports = createVolumeTrace;
	
	},{"../../components/colorscale":603,"../../lib/gl_format_color":713,"../../lib/str2rgbarray":739,"../../plots/gl3d/zip3":815,"../isosurface/convert":1056,"gl-mesh3d":282}],1280:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var attributes = _dereq_('./attributes');
	var supplyIsoDefaults = _dereq_('../isosurface/defaults').supplyIsoDefaults;
	
	var MIN = 0.1; // Note: often we don't want the data cube to be disappeared
	
	function createWave(n, minOpacity) {
	    var arr = [];
	    var steps = 32; // Max: 256
	    for(var i = 0; i < steps; i++) {
	        var u = i / (steps - 1);
	        var v = minOpacity + (1 - minOpacity) * (1 - Math.pow(Math.sin(n * u * Math.PI), 2));
	        arr.push([
	            u,
	            Math.max(1, Math.min(0, v))
	        ]);
	    }
	    return arr;
	}
	
	module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	
	    var opacityscale = coerce('opacityscale');
	    if(opacityscale === 'max') {
	        traceOut.opacityscale = [[0, MIN], [1, 1]];
	    } else if(opacityscale === 'min') {
	        traceOut.opacityscale = [[0, 1], [1, MIN]];
	    } else if(opacityscale === 'extremes') {
	        traceOut.opacityscale = createWave(1, MIN);
	    } else if(!isValidScaleArray(opacityscale)) {
	        traceOut.opacityscale = undefined;
	    }
	};
	
	function isValidScaleArray(scl) {
	    var highestVal = 0;
	
	    if(!Array.isArray(scl) || scl.length < 2) return false;
	
	    if(!scl[0] || !scl[scl.length - 1]) return false;
	
	    if(+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
	
	    for(var i = 0; i < scl.length; i++) {
	        var si = scl[i];
	
	        if(si.length !== 2 || +si[0] < highestVal) {
	            return false;
	        }
	
	        highestVal = +si[0];
	    }
	
	    return true;
	}
	
	},{"../../lib":716,"../isosurface/defaults":1057,"./attributes":1278}],1281:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    supplyDefaults: _dereq_('./defaults'),
	    calc: _dereq_('../isosurface/calc'),
	    colorbar: {
	        min: 'cmin',
	        max: 'cmax'
	    },
	    plot: _dereq_('./convert'),
	
	    moduleType: 'trace',
	    name: 'volume',
	    basePlotModule: _dereq_('../../plots/gl3d'),
	    categories: ['gl3d'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/gl3d":804,"../isosurface/calc":1055,"./attributes":1278,"./convert":1279,"./defaults":1280}],1282:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var barAttrs = _dereq_('../bar/attributes');
	var lineAttrs = _dereq_('../scatter/attributes').line;
	var baseAttrs = _dereq_('../../plots/attributes');
	var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
	var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
	var constants = _dereq_('./constants');
	var extendFlat = _dereq_('../../lib/extend').extendFlat;
	var Color = _dereq_('../../components/color');
	
	function directionAttrs(dirTxt) {
	    return {
	        marker: {
	            color: extendFlat({}, barAttrs.marker.color, {
	                arrayOk: false,
	                editType: 'style',
	                
	            }),
	            line: {
	                color: extendFlat({}, barAttrs.marker.line.color, {
	                    arrayOk: false,
	                    editType: 'style',
	                    
	                }),
	                width: extendFlat({}, barAttrs.marker.line.width, {
	                    arrayOk: false,
	                    editType: 'style',
	                    
	                }),
	                editType: 'style',
	            },
	            editType: 'style'
	        },
	        editType: 'style'
	    };
	}
	
	module.exports = {
	    measure: {
	        valType: 'data_array',
	        dflt: [],
	        
	        editType: 'calc',
	        
	    },
	
	    base: {
	        valType: 'number',
	        dflt: null,
	        arrayOk: false,
	        
	        editType: 'calc',
	        
	    },
	
	    x: barAttrs.x,
	    x0: barAttrs.x0,
	    dx: barAttrs.dx,
	    y: barAttrs.y,
	    y0: barAttrs.y0,
	    dy: barAttrs.dy,
	
	    hovertext: barAttrs.hovertext,
	    hovertemplate: hovertemplateAttrs({}, {
	        keys: constants.eventDataKeys
	    }),
	
	    hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	        flags: ['name', 'x', 'y', 'text', 'initial', 'delta', 'final']
	    }),
	
	    textinfo: {
	        valType: 'flaglist',
	        flags: ['label', 'text', 'initial', 'delta', 'final'],
	        extras: ['none'],
	        
	        editType: 'plot',
	        arrayOk: false,
	        
	    },
	    // TODO: incorporate `label` and `value` in the eventData
	    texttemplate: texttemplateAttrs({editType: 'plot'}, {
	        keys: constants.eventDataKeys.concat(['label'])
	    }),
	    text: barAttrs.text,
	    textposition: barAttrs.textposition,
	    insidetextanchor: barAttrs.insidetextanchor,
	    textangle: barAttrs.textangle,
	    textfont: barAttrs.textfont,
	    insidetextfont: barAttrs.insidetextfont,
	    outsidetextfont: barAttrs.outsidetextfont,
	    constraintext: barAttrs.constraintext,
	
	    cliponaxis: barAttrs.cliponaxis,
	    orientation: barAttrs.orientation,
	
	    offset: barAttrs.offset,
	    width: barAttrs.width,
	
	    increasing: directionAttrs('increasing'),
	    decreasing: directionAttrs('decreasing'),
	    totals: directionAttrs('intermediate sums and total'),
	
	    connector: {
	        line: {
	            color: extendFlat({}, lineAttrs.color, {dflt: Color.defaultLine}),
	            width: extendFlat({}, lineAttrs.width, {
	                editType: 'plot', // i.e. to adjust bars is mode: 'between'. See https://github.com/plotly/plotly.js/issues/3787
	            }),
	            dash: lineAttrs.dash,
	            editType: 'plot'
	        },
	        mode: {
	            valType: 'enumerated',
	            values: ['spanning', 'between'],
	            dflt: 'between',
	            
	            editType: 'plot',
	            
	        },
	        visible: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'plot',
	            
	        },
	        editType: 'plot'
	    },
	
	    offsetgroup: barAttrs.offsetgroup,
	    alignmentgroup: barAttrs.alignmentgroup
	};
	
	},{"../../components/color":591,"../../lib/extend":707,"../../plots/attributes":761,"../../plots/template_attributes":840,"../bar/attributes":855,"../scatter/attributes":1118,"./constants":1284}],1283:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../../plots/cartesian/axes');
	var mergeArray = _dereq_('../../lib').mergeArray;
	var calcSelection = _dereq_('../scatter/calc_selection');
	var BADNUM = _dereq_('../../constants/numerical').BADNUM;
	
	function isAbsolute(a) {
	    return (a === 'a' || a === 'absolute');
	}
	
	function isTotal(a) {
	    return (a === 't' || a === 'total');
	}
	
	module.exports = function calc(gd, trace) {
	    var xa = Axes.getFromId(gd, trace.xaxis || 'x');
	    var ya = Axes.getFromId(gd, trace.yaxis || 'y');
	    var size, pos;
	
	    if(trace.orientation === 'h') {
	        size = xa.makeCalcdata(trace, 'x');
	        pos = ya.makeCalcdata(trace, 'y');
	    } else {
	        size = ya.makeCalcdata(trace, 'y');
	        pos = xa.makeCalcdata(trace, 'x');
	    }
	
	    // create the "calculated data" to plot
	    var serieslen = Math.min(pos.length, size.length);
	    var cd = new Array(serieslen);
	
	    // set position and size (as well as for waterfall total size)
	    var previousSum = 0;
	    var newSize;
	    // trace-wide flags
	    var hasTotals = false;
	
	    for(var i = 0; i < serieslen; i++) {
	        var amount = size[i] || 0;
	
	        var connectToNext = false;
	        if(size[i] !== BADNUM || isTotal(trace.measure[i]) || isAbsolute(trace.measure[i])) {
	            if(i + 1 < serieslen && (size[i + 1] !== BADNUM || isTotal(trace.measure[i + 1]) || isAbsolute(trace.measure[i + 1]))) {
	                connectToNext = true;
	            }
	        }
	
	        var cdi = cd[i] = {
	            i: i,
	            p: pos[i],
	            s: amount,
	            rawS: amount,
	            cNext: connectToNext
	        };
	
	        if(isAbsolute(trace.measure[i])) {
	            previousSum = cdi.s;
	
	            cdi.isSum = true;
	            cdi.dir = 'totals';
	            cdi.s = previousSum;
	        } else if(isTotal(trace.measure[i])) {
	            cdi.isSum = true;
	            cdi.dir = 'totals';
	            cdi.s = previousSum;
	        } else {
	            // default: relative
	            cdi.isSum = false;
	            cdi.dir = cdi.rawS < 0 ? 'decreasing' : 'increasing';
	            newSize = cdi.s;
	            cdi.s = previousSum + newSize;
	            previousSum += newSize;
	        }
	
	        if(cdi.dir === 'totals') {
	            hasTotals = true;
	        }
	
	        if(trace.ids) {
	            cdi.id = String(trace.ids[i]);
	        }
	
	        cdi.v = (trace.base || 0) + previousSum;
	    }
	
	    if(cd.length) cd[0].hasTotals = hasTotals;
	
	    mergeArray(trace.text, cd, 'tx');
	    mergeArray(trace.hovertext, cd, 'htx');
	    calcSelection(cd, trace);
	
	    return cd;
	};
	
	},{"../../constants/numerical":692,"../../lib":716,"../../plots/cartesian/axes":764,"../scatter/calc_selection":1120}],1284:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    eventDataKeys: [
	        'initial',
	        'delta',
	        'final'
	    ]
	};
	
	},{}],1285:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
	
	module.exports = function crossTraceCalc(gd, plotinfo) {
	    var fullLayout = gd._fullLayout;
	    var fullData = gd._fullData;
	    var calcdata = gd.calcdata;
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	    var waterfalls = [];
	    var waterfallsVert = [];
	    var waterfallsHorz = [];
	    var cd, i;
	
	    for(i = 0; i < fullData.length; i++) {
	        var fullTrace = fullData[i];
	
	        if(
	            fullTrace.visible === true &&
	            fullTrace.xaxis === xa._id &&
	            fullTrace.yaxis === ya._id &&
	            fullTrace.type === 'waterfall'
	        ) {
	            cd = calcdata[i];
	
	            if(fullTrace.orientation === 'h') {
	                waterfallsHorz.push(cd);
	            } else {
	                waterfallsVert.push(cd);
	            }
	
	            waterfalls.push(cd);
	        }
	    }
	
	    var opts = {
	        mode: fullLayout.waterfallmode,
	        norm: fullLayout.waterfallnorm,
	        gap: fullLayout.waterfallgap,
	        groupgap: fullLayout.waterfallgroupgap
	    };
	
	    setGroupPositions(gd, xa, ya, waterfallsVert, opts);
	    setGroupPositions(gd, ya, xa, waterfallsHorz, opts);
	
	    for(i = 0; i < waterfalls.length; i++) {
	        cd = waterfalls[i];
	
	        for(var j = 0; j < cd.length; j++) {
	            var di = cd[j];
	
	            if(di.isSum === false) {
	                di.s0 += (j === 0) ? 0 : cd[j - 1].s;
	            }
	
	            if(j + 1 < cd.length) {
	                cd[j].nextP0 = cd[j + 1].p0;
	                cd[j].nextS0 = cd[j + 1].s0;
	            }
	        }
	    }
	};
	
	},{"../bar/cross_trace_calc":858}],1286:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	
	var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
	var handleText = _dereq_('../bar/defaults').handleText;
	var handleXYDefaults = _dereq_('../scatter/xy_defaults');
	var attributes = _dereq_('./attributes');
	var Color = _dereq_('../../components/color');
	var delta = _dereq_('../../constants/delta.js');
	
	var INCREASING_COLOR = delta.INCREASING.COLOR;
	var DECREASING_COLOR = delta.DECREASING.COLOR;
	var TOTALS_COLOR = '#4499FF';
	
	function handleDirection(coerce, direction, defaultColor) {
	    coerce(direction + '.marker.color', defaultColor);
	    coerce(direction + '.marker.line.color', Color.defaultLine);
	    coerce(direction + '.marker.line.width');
	}
	
	function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	    function coerce(attr, dflt) {
	        return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	    }
	
	    var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	    if(!len) {
	        traceOut.visible = false;
	        return;
	    }
	
	    coerce('measure');
	
	    coerce('orientation', (traceOut.x && !traceOut.y) ? 'h' : 'v');
	    coerce('base');
	    coerce('offset');
	    coerce('width');
	
	    coerce('text');
	
	    coerce('hovertext');
	    coerce('hovertemplate');
	
	    var textposition = coerce('textposition');
	    handleText(traceIn, traceOut, layout, coerce, textposition, {
	        moduleHasSelected: false,
	        moduleHasUnselected: false,
	        moduleHasConstrain: true,
	        moduleHasCliponaxis: true,
	        moduleHasTextangle: true,
	        moduleHasInsideanchor: true
	    });
	
	
	    if(traceOut.textposition !== 'none') {
	        coerce('texttemplate');
	        if(!traceOut.texttemplate) coerce('textinfo');
	    }
	
	    handleDirection(coerce, 'increasing', INCREASING_COLOR);
	    handleDirection(coerce, 'decreasing', DECREASING_COLOR);
	    handleDirection(coerce, 'totals', TOTALS_COLOR);
	
	    var connectorVisible = coerce('connector.visible');
	    if(connectorVisible) {
	        coerce('connector.mode');
	        var connectorLineWidth = coerce('connector.line.width');
	        if(connectorLineWidth) {
	            coerce('connector.line.color');
	            coerce('connector.line.dash');
	        }
	    }
	}
	
	function crossTraceDefaults(fullData, fullLayout) {
	    var traceIn, traceOut;
	
	    function coerce(attr) {
	        return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	    }
	
	    if(fullLayout.waterfallmode === 'group') {
	        for(var i = 0; i < fullData.length; i++) {
	            traceOut = fullData[i];
	            traceIn = traceOut._input;
	
	            handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	        }
	    }
	}
	
	module.exports = {
	    supplyDefaults: supplyDefaults,
	    crossTraceDefaults: crossTraceDefaults
	};
	
	},{"../../components/color":591,"../../constants/delta.js":686,"../../lib":716,"../bar/defaults":859,"../scatter/xy_defaults":1144,"./attributes":1282}],1287:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
	    // standard cartesian event data
	    out.x = 'xVal' in pt ? pt.xVal : pt.x;
	    out.y = 'yVal' in pt ? pt.yVal : pt.y;
	
	    // for funnel
	    if('initial' in pt) out.initial = pt.initial;
	    if('delta' in pt) out.delta = pt.delta;
	    if('final' in pt) out.final = pt.final;
	
	    if(pt.xa) out.xaxis = pt.xa;
	    if(pt.ya) out.yaxis = pt.ya;
	
	    return out;
	};
	
	},{}],1288:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
	var opacity = _dereq_('../../components/color').opacity;
	var hoverOnBars = _dereq_('../bar/hover').hoverOnBars;
	var delta = _dereq_('../../constants/delta.js');
	
	var DIRSYMBOL = {
	    increasing: delta.INCREASING.SYMBOL,
	    decreasing: delta.DECREASING.SYMBOL
	};
	
	module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	    var point = hoverOnBars(pointData, xval, yval, hovermode);
	    if(!point) return;
	
	    var cd = point.cd;
	    var trace = cd[0].trace;
	    var isHorizontal = (trace.orientation === 'h');
	
	    var vAxis = isHorizontal ? pointData.xa : pointData.ya;
	
	    function formatNumber(a) {
	        return hoverLabelText(vAxis, a);
	    }
	
	    // the closest data point
	    var index = point.index;
	    var di = cd[index];
	
	    var size = (di.isSum) ? di.b + di.s : di.rawS;
	
	    if(!di.isSum) {
	        point.initial = di.b + di.s - size;
	        point.delta = size;
	        point.final = point.initial + point.delta;
	
	        var v = formatNumber(Math.abs(point.delta));
	        point.deltaLabel = size < 0 ? '(' + v + ')' : v;
	        point.finalLabel = formatNumber(point.final);
	        point.initialLabel = formatNumber(point.initial);
	    }
	
	    var hoverinfo = di.hi || trace.hoverinfo;
	    var text = [];
	    if(hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
	        var isAll = (hoverinfo === 'all');
	        var parts = hoverinfo.split('+');
	
	        var hasFlag = function(flag) { return isAll || parts.indexOf(flag) !== -1; };
	
	        if(!di.isSum) {
	            if(hasFlag('final') &&
	                (isHorizontal ? !hasFlag('x') : !hasFlag('y')) // don't display redundant info.
	            ) {
	                text.push(point.finalLabel);
	            }
	            if(hasFlag('delta')) {
	                if(size < 0) {
	                    text.push(point.deltaLabel + ' ' + DIRSYMBOL.decreasing);
	                } else {
	                    text.push(point.deltaLabel + ' ' + DIRSYMBOL.increasing);
	                }
	            }
	            if(hasFlag('initial')) {
	                text.push('Initial: ' + point.initialLabel);
	            }
	        }
	    }
	
	    if(text.length) point.extraText = text.join('<br>');
	
	    point.color = getTraceColor(trace, di);
	
	    return [point];
	};
	
	function getTraceColor(trace, di) {
	    var cont = trace[di.dir].marker;
	    var mc = cont.color;
	    var mlc = cont.line.color;
	    var mlw = cont.line.width;
	    if(opacity(mc)) return mc;
	    else if(opacity(mlc) && mlw) return mlc;
	}
	
	},{"../../components/color":591,"../../constants/delta.js":686,"../../plots/cartesian/axes":764,"../bar/hover":862}],1289:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    attributes: _dereq_('./attributes'),
	    layoutAttributes: _dereq_('./layout_attributes'),
	    supplyDefaults: _dereq_('./defaults').supplyDefaults,
	    crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
	    supplyLayoutDefaults: _dereq_('./layout_defaults'),
	    calc: _dereq_('./calc'),
	    crossTraceCalc: _dereq_('./cross_trace_calc'),
	    plot: _dereq_('./plot'),
	    style: _dereq_('./style').style,
	    hoverPoints: _dereq_('./hover'),
	    eventData: _dereq_('./event_data'),
	
	    selectPoints: _dereq_('../bar/select'),
	
	    moduleType: 'trace',
	    name: 'waterfall',
	    basePlotModule: _dereq_('../../plots/cartesian'),
	    categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
	    meta: {
	        
	    }
	};
	
	},{"../../plots/cartesian":775,"../bar/select":867,"./attributes":1282,"./calc":1283,"./cross_trace_calc":1285,"./defaults":1286,"./event_data":1287,"./hover":1288,"./layout_attributes":1290,"./layout_defaults":1291,"./plot":1292,"./style":1293}],1290:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	module.exports = {
	    waterfallmode: {
	        valType: 'enumerated',
	        values: ['group', 'overlay'],
	        dflt: 'group',
	        
	        editType: 'calc',
	        
	    },
	    waterfallgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        
	        editType: 'calc',
	        
	    },
	    waterfallgroupgap: {
	        valType: 'number',
	        min: 0,
	        max: 1,
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    }
	};
	
	},{}],1291:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../../lib');
	var layoutAttributes = _dereq_('./layout_attributes');
	
	module.exports = function(layoutIn, layoutOut, fullData) {
	    var hasTraceType = false;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	    }
	
	    for(var i = 0; i < fullData.length; i++) {
	        var trace = fullData[i];
	
	        if(trace.visible && trace.type === 'waterfall') {
	            hasTraceType = true;
	            break;
	        }
	    }
	
	    if(hasTraceType) {
	        coerce('waterfallmode');
	        coerce('waterfallgap', 0.2);
	        coerce('waterfallgroupgap');
	    }
	};
	
	},{"../../lib":716,"./layout_attributes":1290}],1292:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	var Lib = _dereq_('../../lib');
	var Drawing = _dereq_('../../components/drawing');
	var barPlot = _dereq_('../bar/plot').plot;
	
	module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
	    var fullLayout = gd._fullLayout;
	
	    barPlot(gd, plotinfo, cdModule, traceLayer, {
	        mode: fullLayout.waterfallmode,
	        norm: fullLayout.waterfallmode,
	        gap: fullLayout.waterfallgap,
	        groupgap: fullLayout.waterfallgroupgap
	    });
	
	    plotConnectors(gd, plotinfo, cdModule, traceLayer);
	};
	
	function plotConnectors(gd, plotinfo, cdModule, traceLayer) {
	    var xa = plotinfo.xaxis;
	    var ya = plotinfo.yaxis;
	
	    Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
	        var plotGroup = d3.select(this);
	        var trace = cd[0].trace;
	
	        var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
	
	        if(!trace.connector || !trace.connector.visible) {
	            group.remove();
	            return;
	        }
	
	        var isHorizontal = (trace.orientation === 'h');
	        var mode = trace.connector.mode;
	
	        var connectors = group.selectAll('g.line').data(Lib.identity);
	
	        connectors.enter().append('g')
	            .classed('line', true);
	
	        connectors.exit().remove();
	
	        var len = connectors.size();
	
	        connectors.each(function(di, i) {
	            // don't draw lines between nulls
	            if(i !== len - 1 && !di.cNext) return;
	
	            var xy = getXY(di, xa, ya, isHorizontal);
	            var x = xy[0];
	            var y = xy[1];
	
	            var shape = '';
	
	            if(mode === 'spanning') {
	                if(!di.isSum && i > 0) {
	                    if(isHorizontal) {
	                        shape += 'M' + x[0] + ',' + y[1] + 'V' + y[0];
	                    } else {
	                        shape += 'M' + x[1] + ',' + y[0] + 'H' + x[0];
	                    }
	                }
	            }
	
	            if(mode !== 'between') {
	                if(di.isSum || i < len - 1) {
	                    if(isHorizontal) {
	                        shape += 'M' + x[1] + ',' + y[0] + 'V' + y[1];
	                    } else {
	                        shape += 'M' + x[0] + ',' + y[1] + 'H' + x[1];
	                    }
	                }
	            }
	
	            if(x[2] !== undefined && y[2] !== undefined) {
	                if(isHorizontal) {
	                    shape += 'M' + x[1] + ',' + y[1] + 'V' + y[2];
	                } else {
	                    shape += 'M' + x[1] + ',' + y[1] + 'H' + x[2];
	                }
	            }
	
	            if(shape === '') shape = 'M0,0Z';
	
	            Lib.ensureSingle(d3.select(this), 'path')
	                .attr('d', shape)
	                .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	        });
	    });
	}
	
	function getXY(di, xa, ya, isHorizontal) {
	    var s = [];
	    var p = [];
	
	    var sAxis = isHorizontal ? xa : ya;
	    var pAxis = isHorizontal ? ya : xa;
	
	    s[0] = sAxis.c2p(di.s0, true);
	    p[0] = pAxis.c2p(di.p0, true);
	
	    s[1] = sAxis.c2p(di.s1, true);
	    p[1] = pAxis.c2p(di.p1, true);
	
	    s[2] = sAxis.c2p(di.nextS0, true);
	    p[2] = pAxis.c2p(di.nextP0, true);
	
	    return isHorizontal ? [s, p] : [p, s];
	}
	
	},{"../../components/drawing":612,"../../lib":716,"../bar/plot":866,"d3":164}],1293:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var d3 = _dereq_('d3');
	
	var Drawing = _dereq_('../../components/drawing');
	var Color = _dereq_('../../components/color');
	var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
	
	var styleTextPoints = _dereq_('../bar/style').styleTextPoints;
	
	function style(gd, cd, sel) {
	    var s = sel ? sel : d3.select(gd).selectAll('g.waterfalllayer').selectAll('g.trace');
	
	    s.style('opacity', function(d) { return d[0].trace.opacity; });
	
	    s.each(function(d) {
	        var gTrace = d3.select(this);
	        var trace = d[0].trace;
	
	        gTrace.selectAll('.point > path').each(function(di) {
	            if(!di.isBlank) {
	                var cont = trace[di.dir].marker;
	
	                d3.select(this)
	                    .call(Color.fill, cont.color)
	                    .call(Color.stroke, cont.line.color)
	                    .call(Drawing.dashLine, cont.line.dash, cont.line.width)
	                    .style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
	            }
	        });
	
	        styleTextPoints(gTrace, trace, gd);
	
	        gTrace.selectAll('.lines').each(function() {
	            var cont = trace.connector.line;
	
	            Drawing.lineGroupStyle(
	                d3.select(this).selectAll('path'),
	                cont.width,
	                cont.color,
	                cont.dash
	            );
	        });
	    });
	}
	
	module.exports = {
	    style: style
	};
	
	},{"../../components/color":591,"../../components/drawing":612,"../../constants/interactions":691,"../bar/style":869,"d3":164}],1294:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Axes = _dereq_('../plots/cartesian/axes');
	var Lib = _dereq_('../lib');
	var PlotSchema = _dereq_('../plot_api/plot_schema');
	var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
	var BADNUM = _dereq_('../constants/numerical').BADNUM;
	
	exports.moduleType = 'transform';
	
	exports.name = 'aggregate';
	
	var attrs = exports.attributes = {
	    enabled: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    groups: {
	        // TODO: groupby should support string or array grouping this way too
	        // currently groupby only allows a grouping array
	        valType: 'string',
	        strict: true,
	        noBlank: true,
	        arrayOk: true,
	        dflt: 'x',
	        
	        editType: 'calc',
	        
	    },
	    aggregations: {
	        _isLinkedToArray: 'aggregation',
	        target: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        },
	        func: {
	            valType: 'enumerated',
	            values: ['count', 'sum', 'avg', 'median', 'mode', 'rms', 'stddev', 'min', 'max', 'first', 'last', 'change', 'range'],
	            dflt: 'first',
	            
	            editType: 'calc',
	            
	        },
	        funcmode: {
	            valType: 'enumerated',
	            values: ['sample', 'population'],
	            dflt: 'sample',
	            
	            editType: 'calc',
	            
	        },
	        enabled: {
	            valType: 'boolean',
	            dflt: true,
	            
	            editType: 'calc',
	            
	        },
	        editType: 'calc'
	    },
	    editType: 'calc'
	};
	
	var aggAttrs = attrs.aggregations;
	
	/**
	 * Supply transform attributes defaults
	 *
	 * @param {object} transformIn
	 *  object linked to trace.transforms[i] with 'func' set to exports.name
	 * @param {object} traceOut
	 *  the _fullData trace this transform applies to
	 * @param {object} layout
	 *  the plot's (not-so-full) layout
	 * @param {object} traceIn
	 *  the input data trace this transform applies to
	 *
	 * @return {object} transformOut
	 *  copy of transformIn that contains attribute defaults
	 */
	exports.supplyDefaults = function(transformIn, traceOut) {
	    var transformOut = {};
	    var i;
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(transformIn, transformOut, attrs, attr, dflt);
	    }
	
	    var enabled = coerce('enabled');
	
	    if(!enabled) return transformOut;
	
	    /*
	     * Normally _arrayAttrs is calculated during doCalc, but that comes later.
	     * Anyway this can change due to *count* aggregations (see below) so it's not
	     * necessarily the same set.
	     *
	     * For performance we turn it into an object of truthy values
	     * we'll use 1 for arrays we haven't aggregated yet, 0 for finished arrays,
	     * as distinct from undefined which means this array isn't present in the input
	     * missing arrays can still be aggregate outputs for *count* aggregations.
	     */
	    var arrayAttrArray = PlotSchema.findArrayAttributes(traceOut);
	    var arrayAttrs = {};
	    for(i = 0; i < arrayAttrArray.length; i++) arrayAttrs[arrayAttrArray[i]] = 1;
	
	    var groups = coerce('groups');
	
	    if(!Array.isArray(groups)) {
	        if(!arrayAttrs[groups]) {
	            transformOut.enabled = false;
	            return transformOut;
	        }
	        arrayAttrs[groups] = 0;
	    }
	
	    var aggregationsIn = transformIn.aggregations || [];
	    var aggregationsOut = transformOut.aggregations = new Array(aggregationsIn.length);
	    var aggregationOut;
	
	    function coercei(attr, dflt) {
	        return Lib.coerce(aggregationsIn[i], aggregationOut, aggAttrs, attr, dflt);
	    }
	
	    for(i = 0; i < aggregationsIn.length; i++) {
	        aggregationOut = {_index: i};
	        var target = coercei('target');
	        var func = coercei('func');
	        var enabledi = coercei('enabled');
	
	        // add this aggregation to the output only if it's the first instance
	        // of a valid target attribute - or an unused target attribute with "count"
	        if(enabledi && target && (arrayAttrs[target] || (func === 'count' && arrayAttrs[target] === undefined))) {
	            if(func === 'stddev') coercei('funcmode');
	
	            arrayAttrs[target] = 0;
	            aggregationsOut[i] = aggregationOut;
	        } else aggregationsOut[i] = {enabled: false, _index: i};
	    }
	
	    // any array attributes we haven't yet covered, fill them with the default aggregation
	    for(i = 0; i < arrayAttrArray.length; i++) {
	        if(arrayAttrs[arrayAttrArray[i]]) {
	            aggregationsOut.push({
	                target: arrayAttrArray[i],
	                func: aggAttrs.func.dflt,
	                enabled: true,
	                _index: -1
	            });
	        }
	    }
	
	    return transformOut;
	};
	
	
	exports.calcTransform = function(gd, trace, opts) {
	    if(!opts.enabled) return;
	
	    var groups = opts.groups;
	
	    var groupArray = Lib.getTargetArray(trace, {target: groups});
	    if(!groupArray) return;
	
	    var i, vi, groupIndex, newGrouping;
	
	    var groupIndices = {};
	    var indexToPoints = {};
	    var groupings = [];
	
	    var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	
	    var len = groupArray.length;
	    if(trace._length) len = Math.min(len, trace._length);
	
	    for(i = 0; i < len; i++) {
	        vi = groupArray[i];
	        groupIndex = groupIndices[vi];
	        if(groupIndex === undefined) {
	            groupIndices[vi] = groupings.length;
	            newGrouping = [i];
	            groupings.push(newGrouping);
	            indexToPoints[groupIndices[vi]] = originalPointsAccessor(i);
	        } else {
	            groupings[groupIndex].push(i);
	            indexToPoints[groupIndices[vi]] = (indexToPoints[groupIndices[vi]] || []).concat(originalPointsAccessor(i));
	        }
	    }
	
	    opts._indexToPoints = indexToPoints;
	
	    var aggregations = opts.aggregations;
	
	    for(i = 0; i < aggregations.length; i++) {
	        aggregateOneArray(gd, trace, groupings, aggregations[i]);
	    }
	
	    if(typeof groups === 'string') {
	        aggregateOneArray(gd, trace, groupings, {
	            target: groups,
	            func: 'first',
	            enabled: true
	        });
	    }
	
	    trace._length = groupings.length;
	};
	
	function aggregateOneArray(gd, trace, groupings, aggregation) {
	    if(!aggregation.enabled) return;
	
	    var attr = aggregation.target;
	    var targetNP = Lib.nestedProperty(trace, attr);
	    var arrayIn = targetNP.get();
	    var conversions = Axes.getDataConversions(gd, trace, attr, arrayIn);
	    var func = getAggregateFunction(aggregation, conversions);
	
	    var arrayOut = new Array(groupings.length);
	    for(var i = 0; i < groupings.length; i++) {
	        arrayOut[i] = func(arrayIn, groupings[i]);
	    }
	    targetNP.set(arrayOut);
	
	    if(aggregation.func === 'count') {
	        // count does not depend on an input array, so it's likely not part of _arrayAttrs yet
	        // but after this transform it most definitely *is* an array attribute.
	        Lib.pushUnique(trace._arrayAttrs, attr);
	    }
	}
	
	function getAggregateFunction(opts, conversions) {
	    var func = opts.func;
	    var d2c = conversions.d2c;
	    var c2d = conversions.c2d;
	
	    switch(func) {
	        // count, first, and last don't depend on anything about the data
	        // point back to pure functions for performance
	        case 'count':
	            return count;
	        case 'first':
	            return first;
	        case 'last':
	            return last;
	
	        case 'sum':
	            // This will produce output in all cases even though it's nonsensical
	            // for date or category data.
	            return function(array, indices) {
	                var total = 0;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) total += vi;
	                }
	                return c2d(total);
	            };
	
	        case 'avg':
	            // Generally meaningless for category data but it still does something.
	            return function(array, indices) {
	                var total = 0;
	                var cnt = 0;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) {
	                        total += vi;
	                        cnt++;
	                    }
	                }
	                return cnt ? c2d(total / cnt) : BADNUM;
	            };
	
	        case 'min':
	            return function(array, indices) {
	                var out = Infinity;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) out = Math.min(out, vi);
	                }
	                return (out === Infinity) ? BADNUM : c2d(out);
	            };
	
	        case 'max':
	            return function(array, indices) {
	                var out = -Infinity;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) out = Math.max(out, vi);
	                }
	                return (out === -Infinity) ? BADNUM : c2d(out);
	            };
	
	        case 'range':
	            return function(array, indices) {
	                var min = Infinity;
	                var max = -Infinity;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) {
	                        min = Math.min(min, vi);
	                        max = Math.max(max, vi);
	                    }
	                }
	                return (max === -Infinity || min === Infinity) ? BADNUM : c2d(max - min);
	            };
	
	        case 'change':
	            return function(array, indices) {
	                var first = d2c(array[indices[0]]);
	                var last = d2c(array[indices[indices.length - 1]]);
	                return (first === BADNUM || last === BADNUM) ? BADNUM : c2d(last - first);
	            };
	
	        case 'median':
	            return function(array, indices) {
	                var sortCalc = [];
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) sortCalc.push(vi);
	                }
	                if(!sortCalc.length) return BADNUM;
	                sortCalc.sort();
	                var mid = (sortCalc.length - 1) / 2;
	                return c2d((sortCalc[Math.floor(mid)] + sortCalc[Math.ceil(mid)]) / 2);
	            };
	
	        case 'mode':
	            return function(array, indices) {
	                var counts = {};
	                var maxCnt = 0;
	                var out = BADNUM;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) {
	                        var counti = counts[vi] = (counts[vi] || 0) + 1;
	                        if(counti > maxCnt) {
	                            maxCnt = counti;
	                            out = vi;
	                        }
	                    }
	                }
	                return maxCnt ? c2d(out) : BADNUM;
	            };
	
	        case 'rms':
	            return function(array, indices) {
	                var total = 0;
	                var cnt = 0;
	                for(var i = 0; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) {
	                        total += vi * vi;
	                        cnt++;
	                    }
	                }
	                return cnt ? c2d(Math.sqrt(total / cnt)) : BADNUM;
	            };
	
	        case 'stddev':
	            return function(array, indices) {
	                // balance numerical stability with performance:
	                // so that we call d2c once per element but don't need to
	                // store them, reference all to the first element
	                var total = 0;
	                var total2 = 0;
	                var cnt = 1;
	                var v0 = BADNUM;
	                var i;
	                for(i = 0; i < indices.length && v0 === BADNUM; i++) {
	                    v0 = d2c(array[indices[i]]);
	                }
	                if(v0 === BADNUM) return BADNUM;
	
	                for(; i < indices.length; i++) {
	                    var vi = d2c(array[indices[i]]);
	                    if(vi !== BADNUM) {
	                        var dv = vi - v0;
	                        total += dv;
	                        total2 += dv * dv;
	                        cnt++;
	                    }
	                }
	
	                // This is population std dev, if we want sample std dev
	                // we would need (...) / (cnt - 1)
	                // Also note there's no c2d here - that means for dates the result
	                // is a number of milliseconds, and for categories it's a number
	                // of category differences, which is not generically meaningful but
	                // as in other cases we don't forbid it.
	                var norm = (opts.funcmode === 'sample') ? (cnt - 1) : cnt;
	                // this is debatable: should a count of 1 return sample stddev of
	                // 0 or undefined?
	                if(!norm) return 0;
	                return Math.sqrt((total2 - (total * total / cnt)) / norm);
	            };
	    }
	}
	
	function count(array, indices) {
	    return indices.length;
	}
	
	function first(array, indices) {
	    return array[indices[0]];
	}
	
	function last(array, indices) {
	    return array[indices[indices.length - 1]];
	}
	
	},{"../constants/numerical":692,"../lib":716,"../plot_api/plot_schema":753,"../plots/cartesian/axes":764,"./helpers":1297}],1295:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var Registry = _dereq_('../registry');
	var Axes = _dereq_('../plots/cartesian/axes');
	var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
	
	var filterOps = _dereq_('../constants/filter_ops');
	var COMPARISON_OPS = filterOps.COMPARISON_OPS;
	var INTERVAL_OPS = filterOps.INTERVAL_OPS;
	var SET_OPS = filterOps.SET_OPS;
	
	exports.moduleType = 'transform';
	
	exports.name = 'filter';
	
	exports.attributes = {
	    enabled: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    target: {
	        valType: 'string',
	        strict: true,
	        noBlank: true,
	        arrayOk: true,
	        dflt: 'x',
	        
	        editType: 'calc',
	        
	    },
	    operation: {
	        valType: 'enumerated',
	        values: []
	            .concat(COMPARISON_OPS)
	            .concat(INTERVAL_OPS)
	            .concat(SET_OPS),
	        dflt: '=',
	        
	        editType: 'calc',
	        
	    },
	    value: {
	        valType: 'any',
	        dflt: 0,
	        
	        editType: 'calc',
	        
	    },
	    preservegaps: {
	        valType: 'boolean',
	        dflt: false,
	        
	        editType: 'calc',
	        
	    },
	    editType: 'calc'
	};
	
	exports.supplyDefaults = function(transformIn) {
	    var transformOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
	    }
	
	    var enabled = coerce('enabled');
	
	    if(enabled) {
	        var target = coerce('target');
	
	        if(Lib.isArrayOrTypedArray(target) && target.length === 0) {
	            transformOut.enabled = false;
	            return transformOut;
	        }
	
	        coerce('preservegaps');
	        coerce('operation');
	        coerce('value');
	
	        var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
	        handleCalendarDefaults(transformIn, transformOut, 'valuecalendar', null);
	        handleCalendarDefaults(transformIn, transformOut, 'targetcalendar', null);
	    }
	
	    return transformOut;
	};
	
	exports.calcTransform = function(gd, trace, opts) {
	    if(!opts.enabled) return;
	
	    var targetArray = Lib.getTargetArray(trace, opts);
	    if(!targetArray) return;
	
	    var target = opts.target;
	
	    var len = targetArray.length;
	    if(trace._length) len = Math.min(len, trace._length);
	
	    var targetCalendar = opts.targetcalendar;
	    var arrayAttrs = trace._arrayAttrs;
	    var preservegaps = opts.preservegaps;
	
	    // even if you provide targetcalendar, if target is a string and there
	    // is a calendar attribute matching target it will get used instead.
	    if(typeof target === 'string') {
	        var attrTargetCalendar = Lib.nestedProperty(trace, target + 'calendar').get();
	        if(attrTargetCalendar) targetCalendar = attrTargetCalendar;
	    }
	
	    var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
	    var filterFunc = getFilterFunc(opts, d2c, targetCalendar);
	    var originalArrays = {};
	    var indexToPoints = {};
	    var index = 0;
	
	    function forAllAttrs(fn, index) {
	        for(var j = 0; j < arrayAttrs.length; j++) {
	            var np = Lib.nestedProperty(trace, arrayAttrs[j]);
	            fn(np, index);
	        }
	    }
	
	    var initFn;
	    var fillFn;
	    if(preservegaps) {
	        initFn = function(np) {
	            originalArrays[np.astr] = Lib.extendDeep([], np.get());
	            np.set(new Array(len));
	        };
	        fillFn = function(np, index) {
	            var val = originalArrays[np.astr][index];
	            np.get()[index] = val;
	        };
	    } else {
	        initFn = function(np) {
	            originalArrays[np.astr] = Lib.extendDeep([], np.get());
	            np.set([]);
	        };
	        fillFn = function(np, index) {
	            var val = originalArrays[np.astr][index];
	            np.get().push(val);
	        };
	    }
	
	    // copy all original array attribute values, and clear arrays in trace
	    forAllAttrs(initFn);
	
	    var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	
	    // loop through filter array, fill trace arrays if passed
	    for(var i = 0; i < len; i++) {
	        var passed = filterFunc(targetArray[i]);
	        if(passed) {
	            forAllAttrs(fillFn, i);
	            indexToPoints[index++] = originalPointsAccessor(i);
	        } else if(preservegaps) index++;
	    }
	
	    opts._indexToPoints = indexToPoints;
	    trace._length = index;
	};
	
	function getFilterFunc(opts, d2c, targetCalendar) {
	    var operation = opts.operation;
	    var value = opts.value;
	    var hasArrayValue = Array.isArray(value);
	
	    function isOperationIn(array) {
	        return array.indexOf(operation) !== -1;
	    }
	
	    var d2cValue = function(v) { return d2c(v, 0, opts.valuecalendar); };
	    var d2cTarget = function(v) { return d2c(v, 0, targetCalendar); };
	
	    var coercedValue;
	
	    if(isOperationIn(COMPARISON_OPS)) {
	        coercedValue = hasArrayValue ? d2cValue(value[0]) : d2cValue(value);
	    } else if(isOperationIn(INTERVAL_OPS)) {
	        coercedValue = hasArrayValue ?
	            [d2cValue(value[0]), d2cValue(value[1])] :
	            [d2cValue(value), d2cValue(value)];
	    } else if(isOperationIn(SET_OPS)) {
	        coercedValue = hasArrayValue ? value.map(d2cValue) : [d2cValue(value)];
	    }
	
	    switch(operation) {
	        case '=':
	            return function(v) { return d2cTarget(v) === coercedValue; };
	
	        case '!=':
	            return function(v) { return d2cTarget(v) !== coercedValue; };
	
	        case '<':
	            return function(v) { return d2cTarget(v) < coercedValue; };
	
	        case '<=':
	            return function(v) { return d2cTarget(v) <= coercedValue; };
	
	        case '>':
	            return function(v) { return d2cTarget(v) > coercedValue; };
	
	        case '>=':
	            return function(v) { return d2cTarget(v) >= coercedValue; };
	
	        case '[]':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv >= coercedValue[0] && cv <= coercedValue[1];
	            };
	
	        case '()':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv > coercedValue[0] && cv < coercedValue[1];
	            };
	
	        case '[)':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv >= coercedValue[0] && cv < coercedValue[1];
	            };
	
	        case '(]':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv > coercedValue[0] && cv <= coercedValue[1];
	            };
	
	        case '][':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv <= coercedValue[0] || cv >= coercedValue[1];
	            };
	
	        case ')(':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv < coercedValue[0] || cv > coercedValue[1];
	            };
	
	        case '](':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv <= coercedValue[0] || cv > coercedValue[1];
	            };
	
	        case ')[':
	            return function(v) {
	                var cv = d2cTarget(v);
	                return cv < coercedValue[0] || cv >= coercedValue[1];
	            };
	
	        case '{}':
	            return function(v) {
	                return coercedValue.indexOf(d2cTarget(v)) !== -1;
	            };
	
	        case '}{':
	            return function(v) {
	                return coercedValue.indexOf(d2cTarget(v)) === -1;
	            };
	    }
	}
	
	},{"../constants/filter_ops":688,"../lib":716,"../plots/cartesian/axes":764,"../registry":845,"./helpers":1297}],1296:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var PlotSchema = _dereq_('../plot_api/plot_schema');
	var Plots = _dereq_('../plots/plots');
	var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
	
	exports.moduleType = 'transform';
	
	exports.name = 'groupby';
	
	exports.attributes = {
	    enabled: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    groups: {
	        valType: 'data_array',
	        dflt: [],
	        
	        editType: 'calc',
	        
	    },
	    nameformat: {
	        valType: 'string',
	        
	        editType: 'calc',
	        
	    },
	    styles: {
	        _isLinkedToArray: 'style',
	        target: {
	            valType: 'string',
	            
	            editType: 'calc',
	            
	        },
	        value: {
	            valType: 'any',
	            
	            dflt: {},
	            editType: 'calc',
	            
	            _compareAsJSON: true
	        },
	        editType: 'calc'
	    },
	    editType: 'calc'
	};
	
	/**
	 * Supply transform attributes defaults
	 *
	 * @param {object} transformIn
	 *  object linked to trace.transforms[i] with 'type' set to exports.name
	 * @param {object} traceOut
	 *  the _fullData trace this transform applies to
	 * @param {object} layout
	 *  the plot's (not-so-full) layout
	 * @param {object} traceIn
	 *  the input data trace this transform applies to
	 *
	 * @return {object} transformOut
	 *  copy of transformIn that contains attribute defaults
	 */
	exports.supplyDefaults = function(transformIn, traceOut, layout) {
	    var i;
	    var transformOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
	    }
	
	    var enabled = coerce('enabled');
	
	    if(!enabled) return transformOut;
	
	    coerce('groups');
	    coerce('nameformat', layout._dataLength > 1 ? '%{group} (%{trace})' : '%{group}');
	
	    var styleIn = transformIn.styles;
	    var styleOut = transformOut.styles = [];
	
	    if(styleIn) {
	        for(i = 0; i < styleIn.length; i++) {
	            var thisStyle = styleOut[i] = {};
	            Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'target');
	            var value = Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'value');
	
	            // so that you can edit value in place and have Plotly.react notice it, or
	            // rebuild it every time and have Plotly.react NOT think it changed:
	            // use _compareAsJSON to say we should diff the _JSON_value
	            if(Lib.isPlainObject(value)) thisStyle.value = Lib.extendDeep({}, value);
	            else if(value) delete thisStyle.value;
	        }
	    }
	
	    return transformOut;
	};
	
	
	/**
	 * Apply transform !!!
	 *
	 * @param {array} data
	 *  array of transformed traces (is [fullTrace] upon first transform)
	 *
	 * @param {object} state
	 *  state object which includes:
	 *      - transform {object} full transform attributes
	 *      - fullTrace {object} full trace object which is being transformed
	 *      - fullData {array} full pre-transform(s) data array
	 *      - layout {object} the plot's (not-so-full) layout
	 *
	 * @return {object} newData
	 *  array of transformed traces
	 */
	exports.transform = function(data, state) {
	    var newTraces, i, j;
	    var newData = [];
	
	    for(i = 0; i < data.length; i++) {
	        newTraces = transformOne(data[i], state);
	
	        for(j = 0; j < newTraces.length; j++) {
	            newData.push(newTraces[j]);
	        }
	    }
	
	    return newData;
	};
	
	function transformOne(trace, state) {
	    var i, j, k, attr, srcArray, groupName, newTrace, transforms, arrayLookup;
	    var groupNameObj;
	
	    var opts = state.transform;
	    var transformIndex = state.transformIndex;
	    var groups = trace.transforms[transformIndex].groups;
	    var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	
	    if(!(Array.isArray(groups)) || groups.length === 0) {
	        return [trace];
	    }
	
	    var groupNames = Lib.filterUnique(groups);
	    var newData = new Array(groupNames.length);
	    var len = groups.length;
	
	    var arrayAttrs = PlotSchema.findArrayAttributes(trace);
	
	    var styles = opts.styles || [];
	    var styleLookup = {};
	    for(i = 0; i < styles.length; i++) {
	        styleLookup[styles[i].target] = styles[i].value;
	    }
	
	    if(opts.styles) {
	        groupNameObj = Lib.keyedContainer(opts, 'styles', 'target', 'value.name');
	    }
	
	    // An index to map group name --> expanded trace index
	    var indexLookup = {};
	    var indexCnts = {};
	
	    for(i = 0; i < groupNames.length; i++) {
	        groupName = groupNames[i];
	        indexLookup[groupName] = i;
	        indexCnts[groupName] = 0;
	
	        // Start with a deep extend that just copies array references.
	        newTrace = newData[i] = Lib.extendDeepNoArrays({}, trace);
	        newTrace._group = groupName;
	        newTrace.transforms[transformIndex]._indexToPoints = {};
	
	        var suppliedName = null;
	        if(groupNameObj) {
	            suppliedName = groupNameObj.get(groupName);
	        }
	
	        if(suppliedName || suppliedName === '') {
	            newTrace.name = suppliedName;
	        } else {
	            newTrace.name = Lib.templateString(opts.nameformat, {
	                trace: trace.name,
	                group: groupName
	            });
	        }
	
	        // In order for groups to apply correctly to other transform data (e.g.
	        // a filter transform), we have to break the connection and clone the
	        // transforms so that each group writes grouped values into a different
	        // destination. This function does not break the array reference
	        // connection between the split transforms it creates. That's handled in
	        // initialize, which creates a new empty array for each arrayAttr.
	        transforms = newTrace.transforms;
	        newTrace.transforms = [];
	        for(j = 0; j < transforms.length; j++) {
	            newTrace.transforms[j] = Lib.extendDeepNoArrays({}, transforms[j]);
	        }
	
	        // Initialize empty arrays for the arrayAttrs, to be split in the next step
	        for(j = 0; j < arrayAttrs.length; j++) {
	            Lib.nestedProperty(newTrace, arrayAttrs[j]).set([]);
	        }
	    }
	
	    // For each array attribute including those nested inside this and other
	    // transforms (small note that we technically only need to do this for
	    // transforms that have not yet been applied):
	    for(k = 0; k < arrayAttrs.length; k++) {
	        attr = arrayAttrs[k];
	
	        // Cache all the arrays to which we'll push:
	        for(j = 0, arrayLookup = []; j < groupNames.length; j++) {
	            arrayLookup[j] = Lib.nestedProperty(newData[j], attr).get();
	        }
	
	        // Get the input data:
	        srcArray = Lib.nestedProperty(trace, attr).get();
	
	        // Send each data point to the appropriate expanded trace:
	        for(j = 0; j < len; j++) {
	            // Map group data --> trace index --> array and push data onto it
	            arrayLookup[indexLookup[groups[j]]].push(srcArray[j]);
	        }
	    }
	
	    for(j = 0; j < len; j++) {
	        newTrace = newData[indexLookup[groups[j]]];
	
	        var indexToPoints = newTrace.transforms[transformIndex]._indexToPoints;
	        indexToPoints[indexCnts[groups[j]]] = originalPointsAccessor(j);
	        indexCnts[groups[j]]++;
	    }
	
	    for(i = 0; i < groupNames.length; i++) {
	        groupName = groupNames[i];
	        newTrace = newData[i];
	
	        Plots.clearExpandedTraceDefaultColors(newTrace);
	
	        // there's no need to coerce styleLookup[groupName] here
	        // as another round of supplyDefaults is done on the transformed traces
	        newTrace = Lib.extendDeepNoArrays(newTrace, styleLookup[groupName] || {});
	    }
	
	    return newData;
	}
	
	},{"../lib":716,"../plot_api/plot_schema":753,"../plots/plots":825,"./helpers":1297}],1297:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	exports.pointsAccessorFunction = function(transforms, opts) {
	    var tr;
	    var prevIndexToPoints;
	    for(var i = 0; i < transforms.length; i++) {
	        tr = transforms[i];
	        if(tr === opts) break;
	        if(!tr._indexToPoints || tr.enabled === false) continue;
	        prevIndexToPoints = tr._indexToPoints;
	    }
	    var originalPointsAccessor = prevIndexToPoints ?
	        function(i) {return prevIndexToPoints[i];} :
	        function(i) {return [i];};
	    return originalPointsAccessor;
	};
	
	},{}],1298:[function(_dereq_,module,exports){
	/**
	* Copyright 2012-2019, Plotly, Inc.
	* All rights reserved.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	
	'use strict';
	
	var Lib = _dereq_('../lib');
	var Axes = _dereq_('../plots/cartesian/axes');
	var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
	
	exports.moduleType = 'transform';
	
	exports.name = 'sort';
	
	exports.attributes = {
	    enabled: {
	        valType: 'boolean',
	        dflt: true,
	        
	        editType: 'calc',
	        
	    },
	    target: {
	        valType: 'string',
	        strict: true,
	        noBlank: true,
	        arrayOk: true,
	        dflt: 'x',
	        
	        editType: 'calc',
	        
	    },
	    order: {
	        valType: 'enumerated',
	        values: ['ascending', 'descending'],
	        dflt: 'ascending',
	        
	        editType: 'calc',
	        
	    },
	    editType: 'calc'
	};
	
	exports.supplyDefaults = function(transformIn) {
	    var transformOut = {};
	
	    function coerce(attr, dflt) {
	        return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
	    }
	
	    var enabled = coerce('enabled');
	
	    if(enabled) {
	        coerce('target');
	        coerce('order');
	    }
	
	    return transformOut;
	};
	
	exports.calcTransform = function(gd, trace, opts) {
	    if(!opts.enabled) return;
	
	    var targetArray = Lib.getTargetArray(trace, opts);
	    if(!targetArray) return;
	
	    var target = opts.target;
	
	    var len = targetArray.length;
	    if(trace._length) len = Math.min(len, trace._length);
	
	    var arrayAttrs = trace._arrayAttrs;
	    var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
	    var indices = getIndices(opts, targetArray, d2c, len);
	    var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	    var indexToPoints = {};
	    var i, j;
	
	    for(i = 0; i < arrayAttrs.length; i++) {
	        var np = Lib.nestedProperty(trace, arrayAttrs[i]);
	        var arrayOld = np.get();
	        var arrayNew = new Array(len);
	
	        for(j = 0; j < len; j++) {
	            arrayNew[j] = arrayOld[indices[j]];
	        }
	
	        np.set(arrayNew);
	    }
	
	    for(j = 0; j < len; j++) {
	        indexToPoints[j] = originalPointsAccessor(indices[j]);
	    }
	
	    opts._indexToPoints = indexToPoints;
	    trace._length = len;
	};
	
	function getIndices(opts, targetArray, d2c, len) {
	    var sortedArray = new Array(len);
	    var indices = new Array(len);
	    var i;
	
	    for(i = 0; i < len; i++) {
	        sortedArray[i] = {v: targetArray[i], i: i};
	    }
	
	    sortedArray.sort(getSortFunc(opts, d2c));
	
	    for(i = 0; i < len; i++) {
	        indices[i] = sortedArray[i].i;
	    }
	
	    return indices;
	}
	
	function getSortFunc(opts, d2c) {
	    switch(opts.order) {
	        case 'ascending':
	            return function(a, b) { return d2c(a.v) - d2c(b.v); };
	        case 'descending':
	            return function(a, b) { return d2c(b.v) - d2c(a.v); };
	    }
	}
	
	},{"../lib":716,"../plots/cartesian/axes":764,"./helpers":1297}]},{},[26])(26)
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.5
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // Avoid blurry text by using full pixel integers.
	  // For pixel-perfect positioning, top/bottom prefers rounded
	  // values, while left/right prefers floored values.
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.round(popper.top),
	    bottom: Math.round(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(395);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(395);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(855);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 855 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(859);


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(396);
	
	var _metaProps = __webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  target: '_blank'
	};
	
	var CSVDownload = function (_React$Component) {
	  _inherits(CSVDownload, _React$Component);
	
	  function CSVDownload(props) {
	    _classCallCheck(this, CSVDownload);
	
	    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CSVDownload, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          enclosingCharacter = _props.enclosingCharacter,
	          uFEFF = _props.uFEFF,
	          target = _props.target,
	          specs = _props.specs,
	          replace = _props.replace;
	
	      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
	    }
	  }, {
	    key: 'getWindow',
	    value: function getWindow() {
	      return this.state.page;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return CSVDownload;
	}(_react2.default.Component);
	
	CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
	CSVDownload.propTypes = _metaProps.propTypes;
	exports.default = CSVDownload;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(396);
	
	var _metaProps = __webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSVLink = function (_React$Component) {
	  _inherits(CSVLink, _React$Component);
	
	  function CSVLink(props) {
	    _classCallCheck(this, CSVLink);
	
	    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
	
	    _this.buildURI = _this.buildURI.bind(_this);
	    _this.state = { href: '' };
	    return _this;
	  }
	
	  _createClass(CSVLink, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          uFEFF = _props.uFEFF,
	          enclosingCharacter = _props.enclosingCharacter;
	
	      this.setState({ href: this.buildURI(data, uFEFF, headers, separator, enclosingCharacter) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data,
	          headers = nextProps.headers,
	          separator = nextProps.separator,
	          uFEFF = nextProps.uFEFF;
	
	      this.setState({ href: this.buildURI(data, uFEFF, headers, separator) });
	    }
	  }, {
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'handleLegacy',
	    value: function handleLegacy(event, data, headers, separator, filename, enclosingCharacter) {
	      if (window.navigator.msSaveOrOpenBlob) {
	        event.preventDefault();
	
	        var blob = new Blob([(0, _core.toCSV)(data, headers, separator, enclosingCharacter)]);
	        window.navigator.msSaveBlob(blob, filename);
	
	        return false;
	      }
	    }
	  }, {
	    key: 'handleAsyncClick',
	    value: function handleAsyncClick(event) {
	      var _this2 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var done = function done(proceed) {
	        if (proceed === false) {
	          event.preventDefault();
	          return;
	        }
	        _this2.handleLegacy.apply(_this2, [event].concat(args));
	      };
	
	      this.props.onClick(event, done);
	    }
	  }, {
	    key: 'handleSyncClick',
	    value: function handleSyncClick(event) {
	      var stopEvent = this.props.onClick(event) === false;
	      if (stopEvent) {
	        event.preventDefault();
	        return;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      this.handleLegacy.apply(this, [event].concat(args));
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _this3 = this;
	
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return function (event) {
	        if (typeof _this3.props.onClick === 'function') {
	          return _this3.props.asyncOnClick ? _this3.handleAsyncClick.apply(_this3, [event].concat(args)) : _this3.handleSyncClick.apply(_this3, [event].concat(args));
	        }
	        _this3.handleLegacy.apply(_this3, [event].concat(args));
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          headers = _props2.headers,
	          separator = _props2.separator,
	          filename = _props2.filename,
	          uFEFF = _props2.uFEFF,
	          children = _props2.children,
	          onClick = _props2.onClick,
	          asyncOnClick = _props2.asyncOnClick,
	          enclosingCharacter = _props2.enclosingCharacter,
	          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          download: filename
	        }, rest, {
	          ref: function ref(link) {
	            return _this4.link = link;
	          },
	          target: '_self',
	          href: this.state.href,
	          onClick: this.handleClick(data, headers, separator, filename, enclosingCharacter)
	        }),
	        children
	      );
	    }
	  }]);
	
	  return CSVLink;
	}(_react2.default.Component);
	
	CSVLink.defaultProps = _metaProps.defaultProps;
	CSVLink.propTypes = _metaProps.propTypes;
	exports.default = CSVLink;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSVLink = exports.CSVDownload = undefined;
	
	var _Download = __webpack_require__(857);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _Link = __webpack_require__(858);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSVDownload = exports.CSVDownload = _Download2.default;
	var CSVLink = exports.CSVLink = _Link2.default;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateRange = __webpack_require__(399);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _DefinedRange = __webpack_require__(400);
	
	var _DefinedRange2 = _interopRequireDefault(_DefinedRange);
	
	var _utils = __webpack_require__(107);
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(106);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRangePicker = function (_Component) {
	  _inherits(DateRangePicker, _Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.state = {
	      focusedRange: [(0, _utils.findNextRangeIndex)(props.ranges), 0]
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles2.default, props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var focusedRange = this.state.focusedRange;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(this.styles.dateRangePickerWrapper, this.props.className) },
	        _react2.default.createElement(_DefinedRange2.default, _extends({
	          focusedRange: focusedRange,
	          onPreviewChange: function onPreviewChange(value) {
	            return _this2.dateRange.updatePreview(value);
	          }
	        }, this.props, {
	          range: this.props.ranges[focusedRange[0]],
	          className: undefined
	        })),
	        _react2.default.createElement(_DateRange2.default, _extends({
	          onRangeFocusChange: function onRangeFocusChange(focusedRange) {
	            return _this2.setState({ focusedRange: focusedRange });
	          },
	          focusedRange: focusedRange
	        }, this.props, {
	          ref: function ref(t) {
	            return _this2.dateRange = t;
	          },
	          className: undefined
	        }))
	      );
	    }
	  }]);
	
	  return DateRangePicker;
	}(_react.Component);
	
	DateRangePicker.defaultProps = {};
	
	DateRangePicker.propTypes = _extends({}, _DateRange2.default.propTypes, _DefinedRange2.default.propTypes, {
	  className: _propTypes2.default.string
	});
	
	exports.default = DateRangePicker;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DayCell = __webpack_require__(105);
	
	var _DayCell2 = _interopRequireDefault(_DayCell);
	
	var _eachDayOfInterval = __webpack_require__(403);
	
	var _eachDayOfInterval2 = _interopRequireDefault(_eachDayOfInterval);
	
	var _isWithinInterval = __webpack_require__(877);
	
	var _isWithinInterval2 = _interopRequireDefault(_isWithinInterval);
	
	var _isWeekend = __webpack_require__(876);
	
	var _isWeekend2 = _interopRequireDefault(_isWeekend);
	
	var _isAfter = __webpack_require__(405);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isSameDay = __webpack_require__(110);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isBefore = __webpack_require__(162);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _endOfWeek = __webpack_require__(109);
	
	var _endOfWeek2 = _interopRequireDefault(_endOfWeek);
	
	var _startOfWeek = __webpack_require__(111);
	
	var _startOfWeek2 = _interopRequireDefault(_startOfWeek);
	
	var _endOfDay = __webpack_require__(159);
	
	var _endOfDay2 = _interopRequireDefault(_endOfDay);
	
	var _startOfDay = __webpack_require__(78);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	var _format = __webpack_require__(161);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _utils = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-fallthrough */
	
	
	function renderWeekdays(styles, dateOptions) {
	  var now = new Date();
	  return _react2.default.createElement(
	    'div',
	    { className: styles.weekDays },
	    (0, _eachDayOfInterval2.default)({
	      start: (0, _startOfWeek2.default)(now, dateOptions),
	      end: (0, _endOfWeek2.default)(now, dateOptions)
	    }).map(function (day, i) {
	      return _react2.default.createElement(
	        'span',
	        { className: styles.weekDay, key: i },
	        (0, _format2.default)(day, 'ddd', dateOptions)
	      );
	    })
	  );
	}
	
	var Month = function (_PureComponent) {
	  _inherits(Month, _PureComponent);
	
	  function Month() {
	    _classCallCheck(this, Month);
	
	    return _possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).apply(this, arguments));
	  }
	
	  _createClass(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var now = new Date();
	      var _props = this.props,
	          displayMode = _props.displayMode,
	          focusedRange = _props.focusedRange,
	          drag = _props.drag,
	          styles = _props.styles;
	
	      var minDate = this.props.minDate && (0, _startOfDay2.default)(this.props.minDate);
	      var maxDate = this.props.maxDate && (0, _endOfDay2.default)(this.props.maxDate);
	      var monthDisplay = (0, _utils.getMonthDisplayRange)(this.props.month, this.props.dateOptions);
	      var ranges = this.props.ranges;
	      if (displayMode === 'dateRange' && drag.status) {
	        var _drag$range = drag.range,
	            startDate = _drag$range.startDate,
	            endDate = _drag$range.endDate;
	
	        ranges = ranges.map(function (range, i) {
	          if (i !== focusedRange[0]) return range;
	          return _extends({}, range, {
	            startDate: startDate,
	            endDate: endDate
	          });
	        });
	      }
	      var showPreview = this.props.showPreview && !drag.disablePreview;
	      return _react2.default.createElement(
	        'div',
	        { className: styles.month, style: this.props.style },
	        this.props.showMonthName ? _react2.default.createElement(
	          'div',
	          { className: styles.monthName },
	          (0, _format2.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)
	        ) : null,
	        this.props.showWeekDays && renderWeekdays(styles, this.props.dateOptions),
	        _react2.default.createElement(
	          'div',
	          { className: styles.days, onMouseLeave: this.props.onMouseLeave },
	          (0, _eachDayOfInterval2.default)({ start: monthDisplay.start, end: monthDisplay.end }).map(function (day, index) {
	            var isStartOfMonth = (0, _isSameDay2.default)(day, monthDisplay.startDateOfMonth);
	            var isEndOfMonth = (0, _isSameDay2.default)(day, monthDisplay.endDateOfMonth);
	            var isOutsideMinMax = minDate && (0, _isBefore2.default)(day, minDate) || maxDate && (0, _isAfter2.default)(day, maxDate);
	            return _react2.default.createElement(_DayCell2.default, _extends({}, _this2.props, {
	              ranges: ranges,
	              day: day,
	              preview: showPreview ? _this2.props.preview : null,
	              isWeekend: (0, _isWeekend2.default)(day, _this2.props.dateOptions),
	              isToday: (0, _isSameDay2.default)(day, now),
	              isStartOfWeek: (0, _isSameDay2.default)(day, (0, _startOfWeek2.default)(day, _this2.props.dateOptions)),
	              isEndOfWeek: (0, _isSameDay2.default)(day, (0, _endOfWeek2.default)(day, _this2.props.dateOptions)),
	              isStartOfMonth: isStartOfMonth,
	              isEndOfMonth: isEndOfMonth,
	              key: index,
	              disabled: isOutsideMinMax,
	              isPassive: !(0, _isWithinInterval2.default)(day, {
	                start: monthDisplay.startDateOfMonth,
	                end: monthDisplay.endDateOfMonth
	              }),
	              styles: styles,
	              onMouseDown: _this2.props.onDragSelectionStart,
	              onMouseUp: _this2.props.onDragSelectionEnd,
	              onMouseEnter: _this2.props.onDragSelectionMove,
	              dragRange: drag.range,
	              drag: drag.status
	            }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.PureComponent);
	
	Month.defaultProps = {};
	
	Month.propTypes = {
	  style: _propTypes2.default.object,
	  styles: _propTypes2.default.object,
	  month: _propTypes2.default.object,
	  drag: _propTypes2.default.object,
	  dateOptions: _propTypes2.default.object,
	  preview: _propTypes2.default.shape({
	    startDate: _propTypes2.default.object,
	    endDate: _propTypes2.default.object
	  }),
	  showPreview: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['dateRange', 'date']),
	  minDate: _propTypes2.default.object,
	  maxDate: _propTypes2.default.object,
	  ranges: _propTypes2.default.arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  onDragSelectionStart: _propTypes2.default.func,
	  onDragSelectionEnd: _propTypes2.default.func,
	  onDragSelectionMove: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  monthDisplayFormat: _propTypes2.default.string,
	  showWeekDays: _propTypes2.default.bool,
	  showMonthName: _propTypes2.default.bool
	};
	
	exports.default = Month;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateRange = __webpack_require__(399);
	
	Object.defineProperty(exports, 'DateRange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateRange).default;
	  }
	});
	
	var _Calendar = __webpack_require__(398);
	
	Object.defineProperty(exports, 'Calendar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Calendar).default;
	  }
	});
	
	var _DateRangePicker = __webpack_require__(860);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateRangePicker).default;
	  }
	});
	
	var _DefinedRange = __webpack_require__(400);
	
	Object.defineProperty(exports, 'DefinedRange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DefinedRange).default;
	  }
	});
	
	var _defaultRanges = __webpack_require__(401);
	
	Object.defineProperty(exports, 'defaultInputRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultInputRanges;
	  }
	});
	Object.defineProperty(exports, 'defaultStaticRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultStaticRanges;
	  }
	});
	Object.defineProperty(exports, 'createStaticRanges', {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.createStaticRanges;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addUTCMinutes;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function addUTCMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setUTCMinutes(date.getUTCMinutes() + amount);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 864 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	function cloneObject(dirtyObject) {
	  dirtyObject = dirtyObject || {};
	  var object = {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      object[property] = dirtyObject[property];
	    }
	  }
	
	  return object;
	}
	module.exports = exports["default"];

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCDayOfYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports['default'];

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(156);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(867);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeek(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var diff = (0, _index4.default)(date, dirtyOptions).getTime() - (0, _index6.default)(date, dirtyOptions).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports['default'];

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = __webpack_require__(402);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(156);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index4.default)(fourthOfJanuary, dirtyOptions);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = __webpack_require__(108);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = Number(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12, dirtyOptions);
	}
	module.exports = exports['default'];

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval?
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Options} [options] - the object with options. See [Options]{@link docs/types/Options}
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
	 *   {start: new Date(2014, 0, 17), end: new Date(2014, 0, 21)}
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
	 *   {start: new Date(2014, 0, 21), end: new Date(2014, 0, 22)}
	 * )
	 * //=> false
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index2.default)(intervalLeft.start, dirtyOptions).getTime();
	  var leftEndTime = (0, _index2.default)(intervalLeft.end, dirtyOptions).getTime();
	  var rightStartTime = (0, _index2.default)(intervalRight.start, dirtyOptions).getTime();
	  var rightEndTime = (0, _index2.default)(intervalRight.end, dirtyOptions).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	module.exports = exports['default'];

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports['default'];

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(158);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(870);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Number} the number of full days
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 */
	function differenceInDays(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	
	  var sign = (0, _index6.default)(dateLeft, dateRight, dirtyOptions);
	  var difference = Math.abs((0, _index4.default)(dateLeft, dateRight, dirtyOptions));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference);
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = (0, _index6.default)(dateLeft, dateRight, dirtyOptions) === -sign;
	  return sign * (difference - isLastDayNotFull);
	}
	module.exports = exports['default'];

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(865);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(866);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(402);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function M(date) {
	    return date.getUTCMonth() + 1;
	  },
	
	  // Month: 1st, 2nd, ..., 12th
	  'Mo': function Mo(date, options) {
	    var month = date.getUTCMonth() + 1;
	    return options.locale.localize.ordinalNumber(month, { unit: 'month' });
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function MM(date) {
	    return addLeadingZeros(date.getUTCMonth() + 1, 2);
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': function MMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'short' });
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': function MMMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'long' });
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function Q(date) {
	    return Math.ceil((date.getUTCMonth() + 1) / 3);
	  },
	
	  // Quarter: 1st, 2nd, 3rd, 4th
	  'Qo': function Qo(date, options) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    return options.locale.localize.ordinalNumber(quarter, { unit: 'quarter' });
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function D(date) {
	    return date.getUTCDate();
	  },
	
	  // Day of month: 1st, 2nd, ..., 31st
	  'Do': function Do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDate(), { unit: 'dayOfMonth' });
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function DD(date) {
	    return addLeadingZeros(date.getUTCDate(), 2);
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function DDD(date) {
	    return (0, _index2.default)(date);
	  },
	
	  // Day of year: 1st, 2nd, ..., 366th
	  'DDDo': function DDDo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index2.default)(date), { unit: 'dayOfYear' });
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function DDDD(date) {
	    return addLeadingZeros((0, _index2.default)(date), 3);
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': function dd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'narrow' });
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': function ddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'short' });
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': function dddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'long' });
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function d(date) {
	    return date.getUTCDay();
	  },
	
	  // Day of week: 0th, 1st, 2nd, ..., 6th
	  'do': function _do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDay(), { unit: 'dayOfWeek' });
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function E(date) {
	    return date.getUTCDay() || 7;
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function W(date) {
	    return (0, _index4.default)(date);
	  },
	
	  // ISO week: 1st, 2nd, ..., 53th
	  'Wo': function Wo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index4.default)(date), { unit: 'isoWeek' });
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function WW(date) {
	    return addLeadingZeros((0, _index4.default)(date), 2);
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function YY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2);
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function YYYY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4);
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function GG(date) {
	    return String((0, _index6.default)(date)).substr(2);
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function GGGG(date) {
	    return (0, _index6.default)(date);
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function H(date) {
	    return date.getUTCHours();
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function HH(date) {
	    return addLeadingZeros(date.getUTCHours(), 2);
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function h(date) {
	    var hours = date.getUTCHours();
	    if (hours === 0) {
	      return 12;
	    } else if (hours > 12) {
	      return hours % 12;
	    } else {
	      return hours;
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function hh(date) {
	    return addLeadingZeros(formatters['h'](date), 2);
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function m(date) {
	    return date.getUTCMinutes();
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function mm(date) {
	    return addLeadingZeros(date.getUTCMinutes(), 2);
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function s(date) {
	    return date.getUTCSeconds();
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function ss(date) {
	    return addLeadingZeros(date.getUTCSeconds(), 2);
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function S(date) {
	    return Math.floor(date.getUTCMilliseconds() / 100);
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function SS(date) {
	    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2);
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function SSS(date) {
	    return addLeadingZeros(date.getUTCMilliseconds(), 3);
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function Z(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset(), ':');
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function ZZ(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset());
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function X(date, options) {
	    var originalDate = options._originalDate || date;
	    return Math.floor(originalDate.getTime() / 1000);
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function x(date, options) {
	    var originalDate = options._originalDate || date;
	    return originalDate.getTime();
	  },
	
	  // AM, PM
	  'A': function A(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'uppercase' });
	  },
	
	  // am, pm
	  'a': function a(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'lowercase' });
	  },
	
	  // a.m., p.m.
	  'aa': function aa(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'long' });
	  }
	};
	
	function formatTimezone(offset, delimeter) {
	  delimeter = delimeter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
	}
	
	function addLeadingZeros(number, targetLength) {
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return output;
	}
	
	exports.default = formatters;
	module.exports = exports['default'];

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index2.default)(dirtyDateLeft, dirtyOptions);
	  var dateRight = (0, _index2.default)(dirtyDateRight, dirtyOptions);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports['default'];

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid('2014-02-31')
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  return !isNaN(date);
	}
	module.exports = exports['default'];

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	module.exports = exports['default'];

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(
	 *   new Date(2014, 0, 3),
	 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
	 * )
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(
	 *   new Date(2014, 0, 10),
	 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
	 * )
	 * //=> false
	 */
	function isWithinInterval(dirtyDate, dirtyInterval, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var interval = dirtyInterval || {};
	  var time = (0, _index2.default)(dirtyDate, dirtyOptions).getTime();
	  var startTime = (0, _index2.default)(interval.start, dirtyOptions).getTime();
	  var endTime = (0, _index2.default)(interval.end, dirtyOptions).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports['default'];

/***/ },
/* 878 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;
	
	function buildShortLongFormat(format) {
	  return format.replace(tokensToBeShortedPattern, function (token) {
	    return token.slice(1);
	  });
	}
	
	/**
	 * @name buildFormatLongFn
	 * @category Locale Helpers
	 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 *
	 * @description
	 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 * Returns a function which takes one of the following tokens as the argument:
	 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
	 * and returns a long format string written as `format` token strings.
	 * See [format]{@link https://date-fns.org/docs/format}
	 *
	 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
	 * by shortening some of the tokens from corresponding unshortened formats
	 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
	 *
	 * @param {Object} obj - the object with long formats written as `format` token strings
	 * @param {String} obj.LT - time format: hours and minutes
	 * @param {String} obj.LTS - time format: hours, minutes and seconds
	 * @param {String} obj.L - short date format: numeric day, month and year
	 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
	 * @param {String} obj.LL - long date format: day, month in words, and year
	 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
	 * @param {String} obj.LLL - long date and time format
	 * @param {String} [obj.lll] - long date and time format (shortened)
	 * @param {String} obj.LLLL - long date, time and weekday format
	 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
	 * @returns {Function} `formatLong` property of the locale
	 *
	 * @example
	 * // For `en-US` locale:
	 * locale.formatLong = buildFormatLongFn({
	 *   LT: 'h:mm aa',
	 *   LTS: 'h:mm:ss aa',
	 *   L: 'MM/DD/YYYY',
	 *   LL: 'MMMM D YYYY',
	 *   LLL: 'MMMM D YYYY h:mm aa',
	 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
	 * })
	 */
	function buildFormatLongFn(obj) {
	  var formatLongLocale = {
	    LTS: obj.LTS,
	    LT: obj.LT,
	    L: obj.L,
	    LL: obj.LL,
	    LLL: obj.LLL,
	    LLLL: obj.LLLL,
	    l: obj.l || buildShortLongFormat(obj.L),
	    ll: obj.ll || buildShortLongFormat(obj.LL),
	    lll: obj.lll || buildShortLongFormat(obj.LLL),
	    llll: obj.llll || buildShortLongFormat(obj.LLLL)
	  };
	
	  return function (token) {
	    return formatLongLocale[token];
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 879 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeArrayFn;
	/**
	 * @name buildLocalizeArrayFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var weekdayValues = {
	 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	 * }
	 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
	 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
	 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
	 */
	function buildLocalizeArrayFn(values, defaultType) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    return values[type] || values[defaultType];
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 880 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	/**
	 * @name buildLocalizeFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
	 * used by `format` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
	 * `localize.month` takes the month index (0 - January).
	 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
	 *   and converts it into value array index
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var timeOfDayValues = {
	 *   uppercase: ['AM', 'PM'],
	 *   lowercase: ['am', 'pm'],
	 *   long: ['a.m.', 'p.m.']
	 * }
	 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	 *   // 0 is a.m. array index, 1 is p.m. array index
	 *   return (hours / 12) >= 1 ? 1 : 0
	 * })
	 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
	 * locale.localize.timeOfDay(5) //=> 'a.m.'
	 */
	function buildLocalizeFn(values, defaultType, indexCallback) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var valuesArray = values[type] || values[defaultType];
	    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
	    return valuesArray[index];
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 881 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	/**
	 * @name buildMatchFn
	 * @category Locale Helpers
	 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 * The result of the match function will be passed into corresponding parser function
	 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
	 *
	 * @param {Object} values - the object with RegExps
	 * @param {String} defaultType - the default type for the match function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var matchWeekdaysPatterns = {
	 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	 * }
	 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
	 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
	 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
	 */
	function buildMatchFn(patterns, defaultType) {
	  return function (dirtyString, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var pattern = patterns[type] || patterns[defaultType];
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 882 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	/**
	 * @name buildMatchPatternFn
	 * @category Locale Helpers
	 * @summary Build match function from a single RegExp.
	 *
	 * @description
	 * Build match function from a single RegExp.
	 * Usually used for building `match.ordinalNumbers` property of the locale.
	 *
	 * @param {Object} pattern - the RegExp
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
	 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
	 */
	function buildMatchPatternFn(pattern) {
	  return function (dirtyString) {
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 883 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildParseFn;
	/**
	 * @name buildParseFn
	 * @category Locale Helpers
	 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
	 * The argument of the resulting function is the result of the corresponding match function
	 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
	 *
	 * @param {Object} values - the object with arrays of RegExps
	 * @param {String} defaultType - the default type for the parser function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var parseWeekdayPatterns = {
	 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	 * }
	 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
	 * var matchResult = locale.match.weekdays('Friday')
	 * locale.match.weekday(matchResult) //=> 5
	 */
	function buildParseFn(patterns, defaultType) {
	  return function (matchResult, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var patternsArray = patterns[type] || patterns[defaultType];
	    var string = matchResult[1];
	
	    return patternsArray.findIndex(function (pattern) {
	      return pattern.test(string);
	    });
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 884 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseDecimal;
	/**
	 * @name parseDecimal
	 * @category Locale Helpers
	 * @summary Parses the match result into decimal number.
	 *
	 * @description
	 * Parses the match result into decimal number.
	 * Uses the string matched with the first set of parentheses of match RegExp.
	 *
	 * @param {Array} matchResult - the object returned by matching function
	 * @returns {Number} the parsed value
	 *
	 * @example
	 * locale.match = {
	 *   ordinalNumbers: (dirtyString) {
	 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
	 *   },
	 *   ordinalNumber: parseDecimal
	 * }
	 */
	function parseDecimal(matchResult) {
	  return parseInt(matchResult[1], 10);
	}
	module.exports = exports["default"];

/***/ },
/* 885 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	
	  halfAMinute: 'half a minute',
	
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	
	  var result;
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	module.exports = exports['default'];

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(878);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatLong = (0, _index2.default)({
	  LT: 'h:mm aa',
	  LTS: 'h:mm:ss aa',
	  L: 'MM/DD/YYYY',
	  LL: 'MMMM D YYYY',
	  LLL: 'MMMM D YYYY h:mm aa',
	  LLLL: 'dddd, MMMM D YYYY h:mm aa'
	});
	
	exports.default = formatLong;
	module.exports = exports['default'];

/***/ },
/* 887 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: '[last] dddd [at] LT',
	  yesterday: '[yesterday at] LT',
	  today: '[today at] LT',
	  tomorrow: '[tomorrow at] LT',
	  nextWeek: 'dddd [at] LT',
	  other: 'L'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  return formatRelativeLocale[token];
	}
	module.exports = exports['default'];

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(880);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(879);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var weekdayValues = {
	  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	
	var monthValues = {
	  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var timeOfDayValues = {
	//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
	//   }
	//
	// And later:
	//
	//   var localize = {
	//     // The callback takes the hours as the argument and returns the array index
	//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
	//       if (hours >= 17) {
	//         return 3
	//       } else if (hours >= 12) {
	//         return 2
	//       } else if (hours >= 4) {
	//         return 1
	//       } else {
	//         return 0
	//       }
	//     }),
	//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
	//   }
	var timeOfDayValues = {
	  uppercase: ['AM', 'PM'],
	  lowercase: ['am', 'pm'],
	  long: ['a.m.', 'p.m.']
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	  // 'dayOfMonth' or 'dayOfWeek'
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  weekday: (0, _index2.default)(weekdayValues, 'long'),
	  weekdays: (0, _index4.default)(weekdayValues, 'long'),
	  month: (0, _index2.default)(monthValues, 'long'),
	  months: (0, _index4.default)(monthValues, 'long'),
	  timeOfDay: (0, _index2.default)(timeOfDayValues, 'long', function (hours) {
	    return hours / 12 >= 1 ? 1 : 0;
	  }),
	  timesOfDay: (0, _index4.default)(timeOfDayValues, 'long')
	};
	
	exports.default = localize;
	module.exports = exports['default'];

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(881);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(883);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(882);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(884);
	
	var _index8 = _interopRequireDefault(_index7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;
	
	var matchWeekdaysPatterns = {
	  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	
	var parseWeekdayPatterns = {
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	
	var matchMonthsPatterns = {
	  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	
	var parseMonthPatterns = {
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var matchTimesOfDayPatterns = {
	//     long: /^((in the)? (night|morning|afternoon|evening?))/i
	//   }
	//
	//   var parseTimeOfDayPatterns = {
	//     any: [/(night|morning)/i, /(afternoon|evening)/i]
	//   }
	var matchTimesOfDayPatterns = {
	  short: /^(am|pm)/i,
	  long: /^([ap]\.?\s?m\.?)/i
	};
	
	var parseTimeOfDayPatterns = {
	  any: [/^a/i, /^p/i]
	};
	
	var match = {
	  ordinalNumbers: (0, _index6.default)(matchOrdinalNumbersPattern),
	  ordinalNumber: _index8.default,
	  weekdays: (0, _index2.default)(matchWeekdaysPatterns, 'long'),
	  weekday: (0, _index4.default)(parseWeekdayPatterns, 'any'),
	  months: (0, _index2.default)(matchMonthsPatterns, 'long'),
	  month: (0, _index4.default)(parseMonthPatterns, 'any'),
	  timesOfDay: (0, _index2.default)(matchTimesOfDayPatterns, 'long'),
	  timeOfDay: (0, _index4.default)(parseTimeOfDayPatterns, 'any')
	};
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max(
	 *  [
	 *    new Date(1989, 6, 10),
	 *    new Date(1987, 1, 11),
	 *    new Date(1995, 6, 2),
	 *    new Date(1990, 0, 1)
	 *  ]
	 * )
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index2.default)(dirtyDate, dirtyOptions);
	
	    if (result === undefined || result < currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	
	  return result;
	}
	module.exports = exports['default'];

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(404);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the month setted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var month = Number(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index4.default)(dateWithDesiredMonth, dirtyOptions);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = __webpack_require__(12);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the year setted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = Number(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports['default'];

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),m=__webpack_require__(155),q=__webpack_require__(1010);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
	function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
	function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
	return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
	function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
	function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
	function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
	m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
	var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
	function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
	function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
	var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
	!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
	function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
	function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
	var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
	60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
	function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
	function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
	yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
	F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
	function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
	function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
	function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
	function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
	var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
	var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
	else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
	f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
	function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
	function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
	function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
	c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
	a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
	["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
	1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
	"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
	2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
	var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
	function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
	function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
	function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
	function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
	function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
	var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
	case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
	function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
	function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
	function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
	function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
	function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
	function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
	function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
	function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
	var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
	function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
	function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
	function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
	function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
	function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
	function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
	function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
	function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
	var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
	c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
	function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
	function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
	function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
	function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
	function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
	mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
	n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
	if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
	p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
	k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
	"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
	function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
	function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
	var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
	function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
	function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
	function lh(a,b){return"function"===typeof b?b(a):b}
	function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
	d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
	function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
	function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
	(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
	var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
	Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
	{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
	b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
	function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
	function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
	function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
	h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
	"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
	("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
	function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
	var Oh={};
	function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
	c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
	2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
	function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
	b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
	!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
	var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
	Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
	(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
	function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
	var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
	function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
	function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
	b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
	h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
	function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
	f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
	a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
	function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
	function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
	function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
	function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
	function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
	b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
	function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
	function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
	function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
	function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
	jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
	2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
	pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
	a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
	a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
	Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
	function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
	zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
	{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
	g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
	e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
	Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
	e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
	f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
	if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
	g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
	d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
	default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
	a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
	function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
	if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
	(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
	I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
	r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
	I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
	E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
	Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
	p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
	fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
	function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
	function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
	function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
	mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
	Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
	null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
	a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
	null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
	(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
	f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
	c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
	f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
	function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
	function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
	function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
	10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
	function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
	function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
	(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
	function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
	Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
	null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
	Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
	function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
	function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
	var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
	if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
	b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
	function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
	rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _promisePolyfill = __webpack_require__(394);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	var _reactLifecyclesCompat = __webpack_require__(897);
	
	var _ValidatorForm = __webpack_require__(409);
	
	var _ValidatorForm2 = _interopRequireDefault(_ValidatorForm);
	
	var _utils = __webpack_require__(895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	/* eslint-enable */
	
	
	var ValidatorComponent = function (_React$Component) {
	    _inherits(ValidatorComponent, _React$Component);
	
	    function ValidatorComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ValidatorComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidatorComponent.__proto__ || Object.getPrototypeOf(ValidatorComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isValid: true,
	            value: _this.props.value,
	            errorMessages: _this.props.errorMessages,
	            validators: _this.props.validators
	        }, _this.getErrorMessage = function () {
	            var errorMessages = _this.state.errorMessages;
	
	            var type = typeof errorMessages === 'undefined' ? 'undefined' : _typeof(errorMessages);
	
	            if (type === 'string') {
	                return errorMessages;
	            } else if (type === 'object') {
	                if (_this.invalid.length > 0) {
	                    return errorMessages[_this.invalid[0]];
	                }
	            }
	            // eslint-disable-next-line
	            console.log('unknown errorMessages type', errorMessages);
	            return true;
	        }, _this.instantValidate = true, _this.invalid = [], _this.configure = function () {
	            _this.context.form.attachToForm(_this);
	            _this.instantValidate = _this.context.form.instantValidate;
	            _this.debounceTime = _this.context.form.debounceTime;
	            _this.validateDebounced = (0, _utils.debounce)(_this.validate, _this.debounceTime);
	        }, _this.validate = function (value) {
	            var includeRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var dryRun = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var validations = _promisePolyfill2.default.all(_this.state.validators.map(function (validator) {
	                return _ValidatorForm2.default.getValidator(validator, value, includeRequired);
	            }));
	
	            validations.then(function (results) {
	                _this.invalid = [];
	                var valid = true;
	                results.forEach(function (result, key) {
	                    if (!result) {
	                        valid = false;
	                        _this.invalid.push(key);
	                    }
	                });
	                if (!dryRun) {
	                    _this.setState({ isValid: valid }, function () {
	                        _this.props.validatorListener(_this.state.isValid);
	                    });
	                }
	            });
	        }, _this.isValid = function () {
	            return _this.state.isValid;
	        }, _this.makeInvalid = function () {
	            _this.setState({ isValid: false });
	        }, _this.makeValid = function () {
	            _this.setState({ isValid: true });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ValidatorComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.configure();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return this.state !== nextState || this.props !== nextProps;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.instantValidate && this.props.value !== prevState.value) {
	                this.validateDebounced(this.props.value, this.props.withRequiredValidator);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.context.form.detachFromForm(this);
	            this.validateDebounced.cancel();
	        }
	    }], [{
	        key: 'getDerivedStateFromProps',
	        value: function getDerivedStateFromProps(nextProps, prevState) {
	            if (nextProps.validators && nextProps.errorMessages && (prevState.validators !== nextProps.validators || prevState.errorMessages !== nextProps.errorMessages)) {
	                return {
	                    value: nextProps.value,
	                    validators: nextProps.validators,
	                    errorMessages: nextProps.errorMessages
	                };
	            }
	
	            return {
	                value: nextProps.value
	            };
	        }
	    }]);
	
	    return ValidatorComponent;
	}(_react2.default.Component);
	
	ValidatorComponent.contextTypes = {
	    form: _propTypes2.default.object
	};
	
	ValidatorComponent.propTypes = {
	    errorMessages: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
	    validators: _propTypes2.default.array,
	    value: _propTypes2.default.any,
	    validatorListener: _propTypes2.default.func,
	    withRequiredValidator: _propTypes2.default.bool
	};
	
	ValidatorComponent.defaultProps = {
	    errorMessages: 'error',
	    validators: [],
	    validatorListener: function validatorListener() {}
	};
	
	(0, _reactLifecyclesCompat.polyfill)(ValidatorComponent);
	
	exports.default = ValidatorComponent;

/***/ },
/* 895 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var debounce = function debounce(func, wait, immediate) {
	    var timeout = void 0;
	    function cancel() {
	        if (timeout !== undefined) {
	            clearTimeout(timeout);
	        }
	    }
	    var debounced = function debounced() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var context = this;
	        var later = function delayed() {
	            timeout = null;
	            if (!immediate) {
	                func.apply(context, args);
	            }
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) {
	            func.apply(context, args);
	        }
	    };
	    debounced.cancel = cancel;
	    return debounced;
	};
	
	exports.debounce = debounce;

/***/ },
/* 896 */
/***/ function(module, exports) {

	/** @license React v16.9.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
	exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ },
/* 897 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(require("react"), require("prop-types"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(global.React, global.PropTypes);
	    global.ReactList = mod.exports;
	  }
	})(this, function (_react, _propTypes) {
	  "use strict";
	
	  _react = _interopRequireWildcard(_react);
	  _propTypes = _interopRequireDefault(_propTypes);
	
	  var _class, _temp;
	
	  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	  var CLIENT_SIZE_KEYS = {
	    x: 'clientWidth',
	    y: 'clientHeight'
	  };
	  var CLIENT_START_KEYS = {
	    x: 'clientTop',
	    y: 'clientLeft'
	  };
	  var INNER_SIZE_KEYS = {
	    x: 'innerWidth',
	    y: 'innerHeight'
	  };
	  var OFFSET_SIZE_KEYS = {
	    x: 'offsetWidth',
	    y: 'offsetHeight'
	  };
	  var OFFSET_START_KEYS = {
	    x: 'offsetLeft',
	    y: 'offsetTop'
	  };
	  var OVERFLOW_KEYS = {
	    x: 'overflowX',
	    y: 'overflowY'
	  };
	  var SCROLL_SIZE_KEYS = {
	    x: 'scrollWidth',
	    y: 'scrollHeight'
	  };
	  var SCROLL_START_KEYS = {
	    x: 'scrollLeft',
	    y: 'scrollTop'
	  };
	  var SIZE_KEYS = {
	    x: 'width',
	    y: 'height'
	  };
	
	  var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
	  // add/removeEventListener, we need to check, otherwise we will
	  // accidentally set `capture` with a truthy value.
	
	
	  var PASSIVE = function () {
	    if (typeof window === 'undefined') return false;
	    var hasSupport = false;
	
	    try {
	      document.createElement('div').addEventListener('test', NOOP, {
	        get passive() {
	          hasSupport = true;
	          return false;
	        }
	
	      });
	    } catch (e) {// noop
	    }
	
	    return hasSupport;
	  }() ? {
	    passive: true
	  } : false;
	  var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	  var MAX_SYNC_UPDATES = 50;
	
	  var isEqualSubset = function isEqualSubset(a, b) {
	    for (var key in b) {
	      if (a[key] !== b[key]) return false;
	    }
	
	    return true;
	  };
	
	  var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
	    var axis = component.props.axis;
	    var el = component.getEl();
	    var overflowKey = OVERFLOW_KEYS[axis];
	
	    while (el = el.parentElement) {
	      switch (window.getComputedStyle(el)[overflowKey]) {
	        case 'auto':
	        case 'scroll':
	        case 'overlay':
	          return el;
	      }
	    }
	
	    return window;
	  };
	
	  var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
	    var axis = component.props.axis;
	    var scrollParent = component.scrollParent;
	    return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	  };
	
	  var constrain = function constrain(props, state) {
	    var length = props.length,
	        minSize = props.minSize,
	        type = props.type;
	    var from = state.from,
	        size = state.size,
	        itemsPerRow = state.itemsPerRow;
	    size = Math.max(size, minSize);
	    var mod = size % itemsPerRow;
	    if (mod) size += itemsPerRow - mod;
	    if (size > length) size = length;
	    from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	    if (mod = from % itemsPerRow) {
	      from -= mod;
	      size += mod;
	    }
	
	    if (from === state.from && size == state.size) return state;
	    return _objectSpread({}, state, {
	      from: from,
	      size: size
	    });
	  };
	
	  module.exports = (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(ReactList, _Component);
	
	    _createClass(ReactList, null, [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(props, state) {
	        var newState = constrain(props, state);
	        return newState === state ? null : newState;
	      }
	    }]);
	
	    function ReactList(props) {
	      var _this;
	
	      _classCallCheck(this, ReactList);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactList).call(this, props));
	      _this.state = constrain(props, {
	        itemsPerRow: 1,
	        from: props.initialIndex,
	        size: 0
	      });
	      _this.cache = {};
	      _this.cachedScrollPosition = null;
	      _this.prevPrevState = {};
	      _this.unstable = false;
	      _this.updateCounter = 0;
	      return _this;
	    }
	
	    _createClass(ReactList, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
	        window.addEventListener('resize', this.updateFrameAndClearCache);
	        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var _this2 = this;
	
	        // Viewport scroll is no longer useful if axis changes
	        if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
	
	        if (this.unstable) return;
	
	        if (++this.updateCounter > MAX_SYNC_UPDATES) {
	          this.unstable = true;
	          return console.error(UNSTABLE_MESSAGE);
	        }
	
	        if (!this.updateCounterTimeoutId) {
	          this.updateCounterTimeoutId = setTimeout(function () {
	            _this2.updateCounter = 0;
	            delete _this2.updateCounterTimeoutId;
	          }, 0);
	        }
	
	        this.updateFrame();
	      }
	    }, {
	      key: "maybeSetState",
	      value: function maybeSetState(b, cb) {
	        if (isEqualSubset(this.state, b)) return cb();
	        this.setState(b, cb);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.updateFrameAndClearCache);
	        this.scrollParent.removeEventListener('scroll', this.updateFrameAndClearCache, PASSIVE);
	        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "getOffset",
	      value: function getOffset(el) {
	        var axis = this.props.axis;
	        var offset = el[CLIENT_START_KEYS[axis]] || 0;
	        var offsetKey = OFFSET_START_KEYS[axis];
	
	        do {
	          offset += el[offsetKey] || 0;
	        } while (el = el.offsetParent);
	
	        return offset;
	      }
	    }, {
	      key: "getEl",
	      value: function getEl() {
	        return this.el || this.items;
	      }
	    }, {
	      key: "getScrollPosition",
	      value: function getScrollPosition() {
	        // Cache scroll position as this causes a forced synchronous layout.
	        if (typeof this.cachedScrollPosition === 'number') {
	          return this.cachedScrollPosition;
	        }
	
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        var scrollKey = SCROLL_START_KEYS[axis];
	        var actual = scrollParent === window ? // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	        // always return document.documentElement[scrollKey] as 0, so take
	        // whichever has a value.
	        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	        var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
	        var scroll = Math.max(0, Math.min(actual, max));
	        var el = this.getEl();
	        this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
	        return this.cachedScrollPosition;
	      }
	    }, {
	      key: "setScroll",
	      value: function setScroll(offset) {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        offset += this.getOffset(this.getEl());
	        if (scrollParent === window) return window.scrollTo(0, offset);
	        offset -= this.getOffset(this.scrollParent);
	        scrollParent[SCROLL_START_KEYS[axis]] = offset;
	      }
	    }, {
	      key: "getScrollSize",
	      value: function getScrollSize() {
	        var scrollParent = this.scrollParent;
	        var _document = document,
	            body = _document.body,
	            documentElement = _document.documentElement;
	        var key = SCROLL_SIZE_KEYS[this.props.axis];
	        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	      }
	    }, {
	      key: "hasDeterminateSize",
	      value: function hasDeterminateSize() {
	        var _this$props = this.props,
	            itemSizeGetter = _this$props.itemSizeGetter,
	            type = _this$props.type;
	        return type === 'uniform' || itemSizeGetter;
	      }
	    }, {
	      key: "getStartAndEnd",
	      value: function getStartAndEnd() {
	        var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	        var scroll = this.getScrollPosition();
	        var start = Math.max(0, scroll - threshold);
	        var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
	
	        if (this.hasDeterminateSize()) {
	          end = Math.min(end, this.getSpaceBefore(this.props.length));
	        }
	
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }, {
	      key: "getItemSizeAndItemsPerRow",
	      value: function getItemSizeAndItemsPerRow() {
	        var _this$props2 = this.props,
	            axis = _this$props2.axis,
	            useStaticSize = _this$props2.useStaticSize;
	        var _this$state = this.state,
	            itemSize = _this$state.itemSize,
	            itemsPerRow = _this$state.itemsPerRow;
	
	        if (useStaticSize && itemSize && itemsPerRow) {
	          return {
	            itemSize: itemSize,
	            itemsPerRow: itemsPerRow
	          };
	        }
	
	        var itemEls = this.items.children;
	        if (!itemEls.length) return {};
	        var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
	        // thousandths of a pixel) different size for the same element between
	        // renders. This can cause an infinite render loop, so only change the
	        // itemSize when it is significantly different.
	
	        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	        var delta = Math.abs(firstElSize - itemSize);
	        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	        if (!itemSize) return {};
	        var startKey = OFFSET_START_KEYS[axis];
	        var firstStart = firstEl[startKey];
	        itemsPerRow = 1;
	
	        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	          ++itemsPerRow;
	        }
	
	        return {
	          itemSize: itemSize,
	          itemsPerRow: itemsPerRow
	        };
	      }
	    }, {
	      key: "clearSizeCache",
	      value: function clearSizeCache() {
	        this.cachedScrollPosition = null;
	      } // Called by 'scroll' and 'resize' events, clears scroll position cache.
	
	    }, {
	      key: "updateFrameAndClearCache",
	      value: function updateFrameAndClearCache(cb) {
	        this.clearSizeCache();
	        return this.updateFrame(cb);
	      }
	    }, {
	      key: "updateFrame",
	      value: function updateFrame(cb) {
	        this.updateScrollParent();
	        if (typeof cb != 'function') cb = NOOP;
	
	        switch (this.props.type) {
	          case 'simple':
	            return this.updateSimpleFrame(cb);
	
	          case 'variable':
	            return this.updateVariableFrame(cb);
	
	          case 'uniform':
	            return this.updateUniformFrame(cb);
	        }
	      }
	    }, {
	      key: "updateScrollParent",
	      value: function updateScrollParent() {
	        var prev = this.scrollParent;
	        this.scrollParent = this.props.scrollParentGetter(this);
	        if (prev === this.scrollParent) return;
	
	        if (prev) {
	          prev.removeEventListener('scroll', this.updateFrameAndClearCache);
	          prev.removeEventListener('mousewheel', NOOP);
	        } // If we have a new parent, cached parent dimensions are no longer useful.
	
	
	        this.clearSizeCache();
	        this.scrollParent.addEventListener('scroll', this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
	        // Just an empty listener. After that onscroll events will be fired synchronously.
	
	        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "updateSimpleFrame",
	      value: function updateSimpleFrame(cb) {
	        var _this$getStartAndEnd = this.getStartAndEnd(),
	            end = _this$getStartAndEnd.end;
	
	        var itemEls = this.items.children;
	        var elEnd = 0;
	
	        if (itemEls.length) {
	          var axis = this.props.axis;
	          var firstItemEl = itemEls[0];
	          var lastItemEl = itemEls[itemEls.length - 1];
	          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	        }
	
	        if (elEnd > end) return cb();
	        var _this$props3 = this.props,
	            pageSize = _this$props3.pageSize,
	            length = _this$props3.length;
	        var size = Math.min(this.state.size + pageSize, length);
	        this.maybeSetState({
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "updateVariableFrame",
	      value: function updateVariableFrame(cb) {
	        if (!this.props.itemSizeGetter) this.cacheSizes();
	
	        var _this$getStartAndEnd2 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd2.start,
	            end = _this$getStartAndEnd2.end;
	
	        var _this$props4 = this.props,
	            length = _this$props4.length,
	            pageSize = _this$props4.pageSize;
	        var space = 0;
	        var from = 0;
	        var size = 0;
	        var maxFrom = length - 1;
	
	        while (from < maxFrom) {
	          var itemSize = this.getSizeOfItem(from);
	          if (itemSize == null || space + itemSize > start) break;
	          space += itemSize;
	          ++from;
	        }
	
	        var maxSize = length - from;
	
	        while (size < maxSize && space < end) {
	          var _itemSize = this.getSizeOfItem(from + size);
	
	          if (_itemSize == null) {
	            size = Math.min(size + pageSize, maxSize);
	            break;
	          }
	
	          space += _itemSize;
	          ++size;
	        }
	
	        this.maybeSetState({
	          from: from,
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "updateUniformFrame",
	      value: function updateUniformFrame(cb) {
	        var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(),
	            itemSize = _this$getItemSizeAndI.itemSize,
	            itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
	
	        if (!itemSize || !itemsPerRow) return cb();
	
	        var _this$getStartAndEnd3 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd3.start,
	            end = _this$getStartAndEnd3.end;
	
	        var _constrain = constrain(this.props, {
	          from: Math.floor(start / itemSize) * itemsPerRow,
	          size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
	          itemsPerRow: itemsPerRow
	        }),
	            from = _constrain.from,
	            size = _constrain.size;
	
	        return this.maybeSetState({
	          itemsPerRow: itemsPerRow,
	          from: from,
	          itemSize: itemSize,
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "getSpaceBefore",
	      value: function getSpaceBefore(index) {
	        var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        if (cache[index] != null) return cache[index]; // Try the static itemSize.
	
	        var _this$state2 = this.state,
	            itemSize = _this$state2.itemSize,
	            itemsPerRow = _this$state2.itemsPerRow;
	
	        if (itemSize) {
	          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	        } // Find the closest space to index there is a cached value for.
	
	
	        var from = index;
	
	        while (from > 0 && cache[--from] == null) {
	          ;
	        } // Finally, accumulate sizes of items from - index.
	
	
	        var space = cache[from] || 0;
	
	        for (var i = from; i < index; ++i) {
	          cache[i] = space;
	
	          var _itemSize2 = this.getSizeOfItem(i);
	
	          if (_itemSize2 == null) break;
	          space += _itemSize2;
	        }
	
	        return cache[index] = space;
	      }
	    }, {
	      key: "cacheSizes",
	      value: function cacheSizes() {
	        var cache = this.cache;
	        var from = this.state.from;
	        var itemEls = this.items.children;
	        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	
	        for (var i = 0, l = itemEls.length; i < l; ++i) {
	          cache[from + i] = itemEls[i][sizeKey];
	        }
	      }
	    }, {
	      key: "getSizeOfItem",
	      value: function getSizeOfItem(index) {
	        var cache = this.cache,
	            items = this.items;
	        var _this$props5 = this.props,
	            axis = _this$props5.axis,
	            itemSizeGetter = _this$props5.itemSizeGetter,
	            itemSizeEstimator = _this$props5.itemSizeEstimator,
	            type = _this$props5.type;
	        var _this$state3 = this.state,
	            from = _this$state3.from,
	            itemSize = _this$state3.itemSize,
	            size = _this$state3.size; // Try the static itemSize.
	
	        if (itemSize) return itemSize; // Try the itemSizeGetter.
	
	        if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
	
	        if (index in cache) return cache[index]; // Try the DOM.
	
	        if (type === 'simple' && index >= from && index < from + size && items) {
	          var itemEl = items.children[index - from];
	          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	        } // Try the itemSizeEstimator.
	
	
	        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	      }
	    }, {
	      key: "scrollTo",
	      value: function scrollTo(index) {
	        if (index != null) this.setScroll(this.getSpaceBefore(index));
	      }
	    }, {
	      key: "scrollAround",
	      value: function scrollAround(index) {
	        var current = this.getScrollPosition();
	        var bottom = this.getSpaceBefore(index);
	        var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
	        var min = Math.min(top, bottom);
	        var max = Math.max(top, bottom);
	        if (current <= min) return this.setScroll(min);
	        if (current > max) return this.setScroll(max);
	      }
	    }, {
	      key: "getVisibleRange",
	      value: function getVisibleRange() {
	        var _this$state4 = this.state,
	            from = _this$state4.from,
	            size = _this$state4.size;
	
	        var _this$getStartAndEnd4 = this.getStartAndEnd(0),
	            start = _this$getStartAndEnd4.start,
	            end = _this$getStartAndEnd4.end;
	
	        var cache = {};
	        var first, last;
	
	        for (var i = from; i < from + size; ++i) {
	          var itemStart = this.getSpaceBefore(i, cache);
	          var itemEnd = itemStart + this.getSizeOfItem(i);
	          if (first == null && itemEnd > start) first = i;
	          if (first != null && itemStart < end) last = i;
	        }
	
	        return [first, last];
	      }
	    }, {
	      key: "renderItems",
	      value: function renderItems() {
	        var _this3 = this;
	
	        var _this$props6 = this.props,
	            itemRenderer = _this$props6.itemRenderer,
	            itemsRenderer = _this$props6.itemsRenderer;
	        var _this$state5 = this.state,
	            from = _this$state5.from,
	            size = _this$state5.size;
	        var items = [];
	
	        for (var i = 0; i < size; ++i) {
	          items.push(itemRenderer(from + i, i));
	        }
	
	        return itemsRenderer(items, function (c) {
	          return _this3.items = c;
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this4 = this;
	
	        var _this$props7 = this.props,
	            axis = _this$props7.axis,
	            length = _this$props7.length,
	            type = _this$props7.type,
	            useTranslate3d = _this$props7.useTranslate3d;
	        var _this$state6 = this.state,
	            from = _this$state6.from,
	            itemsPerRow = _this$state6.itemsPerRow;
	        var items = this.renderItems();
	        if (type === 'simple') return items;
	        var style = {
	          position: 'relative'
	        };
	        var cache = {};
	        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	        var size = this.getSpaceBefore(bottom, cache);
	
	        if (size) {
	          style[SIZE_KEYS[axis]] = size;
	          if (axis === 'x') style.overflowX = 'hidden';
	        }
	
	        var offset = this.getSpaceBefore(from, cache);
	        var x = axis === 'x' ? offset : 0;
	        var y = axis === 'y' ? offset : 0;
	        var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
	        var listStyle = {
	          msTransform: transform,
	          WebkitTransform: transform,
	          transform: transform
	        };
	        return _react["default"].createElement("div", {
	          style: style,
	          ref: function ref(c) {
	            return _this4.el = c;
	          }
	        }, _react["default"].createElement("div", {
	          style: listStyle
	        }, items));
	      }
	    }]);
	
	    return ReactList;
	  }(_react.Component), _defineProperty(_class, "displayName", 'ReactList'), _defineProperty(_class, "propTypes", {
	    axis: _propTypes["default"].oneOf(['x', 'y']),
	    initialIndex: _propTypes["default"].number,
	    itemRenderer: _propTypes["default"].func,
	    itemSizeEstimator: _propTypes["default"].func,
	    itemSizeGetter: _propTypes["default"].func,
	    itemsRenderer: _propTypes["default"].func,
	    length: _propTypes["default"].number,
	    minSize: _propTypes["default"].number,
	    pageSize: _propTypes["default"].number,
	    scrollParentGetter: _propTypes["default"].func,
	    scrollParentViewportSizeGetter: _propTypes["default"].func,
	    threshold: _propTypes["default"].number,
	    type: _propTypes["default"].oneOf(['simple', 'variable', 'uniform']),
	    useStaticSize: _propTypes["default"].bool,
	    useTranslate3d: _propTypes["default"].bool
	  }), _defineProperty(_class, "defaultProps", {
	    axis: 'y',
	    itemRenderer: function itemRenderer(index, key) {
	      return _react["default"].createElement("div", {
	        key: key
	      }, index);
	    },
	    itemsRenderer: function itemsRenderer(items, ref) {
	      return _react["default"].createElement("div", {
	        ref: ref
	      }, items);
	    },
	    length: 0,
	    minSize: 1,
	    pageSize: 10,
	    scrollParentGetter: defaultScrollParentGetter,
	    scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
	    threshold: 100,
	    type: 'simple',
	    useStaticSize: false,
	    useTranslate3d: false
	  }), _temp);
	});


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(70);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactFormValidatorCore = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	/* eslint-enable */
	
	
	var SelectValidator = function (_ValidatorComponent) {
	    _inherits(SelectValidator, _ValidatorComponent);
	
	    function SelectValidator() {
	        _classCallCheck(this, SelectValidator);
	
	        return _possibleConstructorReturn(this, (SelectValidator.__proto__ || Object.getPrototypeOf(SelectValidator)).apply(this, arguments));
	    }
	
	    _createClass(SelectValidator, [{
	        key: 'render',
	        value: function render() {
	            /* eslint-disable no-unused-vars */
	            var _props = this.props,
	                error = _props.error,
	                errorMessages = _props.errorMessages,
	                validators = _props.validators,
	                requiredError = _props.requiredError,
	                helperText = _props.helperText,
	                validatorListener = _props.validatorListener,
	                withRequiredValidator = _props.withRequiredValidator,
	                rest = _objectWithoutProperties(_props, ['error', 'errorMessages', 'validators', 'requiredError', 'helperText', 'validatorListener', 'withRequiredValidator']);
	
	            var isValid = this.state.isValid;
	
	            return _react2.default.createElement(_TextField2.default, _extends({}, rest, {
	                select: true,
	                error: !isValid || error,
	                helperText: !isValid && this.getErrorMessage() || helperText
	            }));
	        }
	    }]);
	
	    return SelectValidator;
	}(_reactFormValidatorCore.ValidatorComponent);
	
	exports.default = SelectValidator;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(70);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactFormValidatorCore = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	/* eslint-enable */
	
	
	var TextValidator = function (_ValidatorComponent) {
	    _inherits(TextValidator, _ValidatorComponent);
	
	    function TextValidator() {
	        _classCallCheck(this, TextValidator);
	
	        return _possibleConstructorReturn(this, (TextValidator.__proto__ || Object.getPrototypeOf(TextValidator)).apply(this, arguments));
	    }
	
	    _createClass(TextValidator, [{
	        key: 'render',
	        value: function render() {
	            /* eslint-disable no-unused-vars */
	            var _props = this.props,
	                error = _props.error,
	                errorMessages = _props.errorMessages,
	                validators = _props.validators,
	                requiredError = _props.requiredError,
	                helperText = _props.helperText,
	                validatorListener = _props.validatorListener,
	                withRequiredValidator = _props.withRequiredValidator,
	                rest = _objectWithoutProperties(_props, ['error', 'errorMessages', 'validators', 'requiredError', 'helperText', 'validatorListener', 'withRequiredValidator']);
	
	            var isValid = this.state.isValid;
	
	            return _react2.default.createElement(_TextField2.default, _extends({}, rest, {
	                error: !isValid || error,
	                helperText: !isValid && this.getErrorMessage() || helperText
	            }));
	        }
	    }]);
	
	    return TextValidator;
	}(_reactFormValidatorCore.ValidatorComponent);
	
	exports.default = TextValidator;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = plotComponentFactory;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	// The naming convention is:
	//   - events are attached as `'plotly_' + eventName.toLowerCase()`
	//   - react props are `'on' + eventName`
	var eventNames = ['AfterExport', 'AfterPlot', 'Animated', 'AnimatingFrame', 'AnimationInterrupted', 'AutoSize', 'BeforeExport', 'ButtonClicked', 'Click', 'ClickAnnotation', 'Deselect', 'DoubleClick', 'Framework', 'Hover', 'LegendClick', 'LegendDoubleClick', 'Relayout', 'Restyle', 'Redraw', 'Selected', 'Selecting', 'SliderChange', 'SliderEnd', 'SliderStart', 'Transitioning', 'TransitionInterrupted', 'Unhover'];
	var updateEvents = ['plotly_restyle', 'plotly_redraw', 'plotly_relayout', 'plotly_doubleclick', 'plotly_animated']; // Check if a window is available since SSR (server-side rendering)
	// breaks unnecessarily if you try to use it server-side.
	
	var isBrowser = typeof window !== 'undefined';
	
	function plotComponentFactory(Plotly) {
	  var PlotlyComponent =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(PlotlyComponent, _Component);
	
	    function PlotlyComponent(props) {
	      var _this;
	
	      _classCallCheck(this, PlotlyComponent);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(PlotlyComponent).call(this, props));
	      _this.p = Promise.resolve();
	      _this.resizeHandler = null;
	      _this.handlers = {};
	      _this.syncWindowResize = _this.syncWindowResize.bind(_assertThisInitialized(_this));
	      _this.syncEventHandlers = _this.syncEventHandlers.bind(_assertThisInitialized(_this));
	      _this.attachUpdateEvents = _this.attachUpdateEvents.bind(_assertThisInitialized(_this));
	      _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
	      _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
	      _this.figureCallback = _this.figureCallback.bind(_assertThisInitialized(_this));
	      _this.updatePlotly = _this.updatePlotly.bind(_assertThisInitialized(_this));
	      return _this;
	    }
	
	    _createClass(PlotlyComponent, [{
	      key: "updatePlotly",
	      value: function updatePlotly(shouldInvokeResizeHandler, figureCallbackFunction, shouldAttachUpdateEvents) {
	        var _this2 = this;
	
	        this.p = this.p.then(function () {
	          if (!_this2.el) {
	            var error;
	
	            if (_this2.unmounting) {
	              error = new Error('Component is unmounting');
	              error.reason = 'unmounting';
	            } else {
	              error = new Error('Missing element reference');
	            }
	
	            throw error;
	          }
	
	          return Plotly.react(_this2.el, {
	            data: _this2.props.data,
	            layout: _this2.props.layout,
	            config: _this2.props.config,
	            frames: _this2.props.frames
	          });
	        }).then(function () {
	          return _this2.syncWindowResize(shouldInvokeResizeHandler);
	        }).then(this.syncEventHandlers).then(function () {
	          return _this2.figureCallback(figureCallbackFunction);
	        }).then(shouldAttachUpdateEvents ? this.attachUpdateEvents : function () {})["catch"](function (err) {
	          if (err.reason === 'unmounting') {
	            return;
	          }
	
	          console.error('Error while plotting:', err); // eslint-disable-line no-console
	
	          if (_this2.props.onError) {
	            _this2.props.onError(err);
	          }
	        });
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.unmounting = false;
	        this.updatePlotly(true, this.props.onInitialized, true);
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        this.unmounting = false; // frames *always* changes identity so fall back to check length only :(
	
	        var numPrevFrames = prevProps.frames && prevProps.frames.length ? prevProps.frames.length : 0;
	        var numNextFrames = this.props.frames && this.props.frames.length ? this.props.frames.length : 0;
	        var figureChanged = !(prevProps.layout === this.props.layout && prevProps.data === this.props.data && prevProps.config === this.props.config && numNextFrames === numPrevFrames);
	        var revisionDefined = prevProps.revision !== void 0;
	        var revisionChanged = prevProps.revision !== this.props.revision;
	
	        if (!figureChanged && (!revisionDefined || revisionDefined && !revisionChanged)) {
	          return;
	        }
	
	        this.updatePlotly(false, this.props.onUpdate, false);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.unmounting = true;
	        this.figureCallback(this.props.onPurge);
	
	        if (this.resizeHandler && isBrowser) {
	          window.removeEventListener('resize', this.resizeHandler);
	          this.resizeHandler = null;
	        }
	
	        this.removeUpdateEvents();
	        Plotly.purge(this.el);
	      }
	    }, {
	      key: "attachUpdateEvents",
	      value: function attachUpdateEvents() {
	        var _this3 = this;
	
	        if (!this.el || !this.el.removeListener) {
	          return;
	        }
	
	        updateEvents.forEach(function (updateEvent) {
	          _this3.el.on(updateEvent, _this3.handleUpdate);
	        });
	      }
	    }, {
	      key: "removeUpdateEvents",
	      value: function removeUpdateEvents() {
	        var _this4 = this;
	
	        if (!this.el || !this.el.removeListener) {
	          return;
	        }
	
	        updateEvents.forEach(function (updateEvent) {
	          _this4.el.removeListener(updateEvent, _this4.handleUpdate);
	        });
	      }
	    }, {
	      key: "handleUpdate",
	      value: function handleUpdate() {
	        this.figureCallback(this.props.onUpdate);
	      }
	    }, {
	      key: "figureCallback",
	      value: function figureCallback(callback) {
	        if (typeof callback === 'function') {
	          var _this$el = this.el,
	              data = _this$el.data,
	              layout = _this$el.layout;
	          var frames = this.el._transitionData ? this.el._transitionData._frames : null;
	          var figure = {
	            data: data,
	            layout: layout,
	            frames: frames
	          };
	          callback(figure, this.el);
	        }
	      }
	    }, {
	      key: "syncWindowResize",
	      value: function syncWindowResize(invoke) {
	        var _this5 = this;
	
	        if (!isBrowser) {
	          return;
	        }
	
	        if (this.props.useResizeHandler && !this.resizeHandler) {
	          this.resizeHandler = function () {
	            return Plotly.Plots.resize(_this5.el);
	          };
	
	          window.addEventListener('resize', this.resizeHandler);
	
	          if (invoke) {
	            this.resizeHandler();
	          }
	        } else if (!this.props.useResizeHandler && this.resizeHandler) {
	          window.removeEventListener('resize', this.resizeHandler);
	          this.resizeHandler = null;
	        }
	      }
	    }, {
	      key: "getRef",
	      value: function getRef(el) {
	        this.el = el;
	
	        if (this.props.debug && isBrowser) {
	          window.gd = this.el;
	        }
	      } // Attach and remove event handlers as they're added or removed from props:
	
	    }, {
	      key: "syncEventHandlers",
	      value: function syncEventHandlers() {
	        var _this6 = this;
	
	        eventNames.forEach(function (eventName) {
	          var prop = _this6.props['on' + eventName];
	          var handler = _this6.handlers[eventName];
	          var hasHandler = Boolean(handler);
	
	          if (prop && !hasHandler) {
	            _this6.addEventHandler(eventName, prop);
	          } else if (!prop && hasHandler) {
	            // Needs to be removed:
	            _this6.removeEventHandler(eventName);
	          } else if (prop && hasHandler && prop !== handler) {
	            // replace the handler
	            _this6.removeEventHandler(eventName);
	
	            _this6.addEventHandler(eventName, prop);
	          }
	        });
	      }
	    }, {
	      key: "addEventHandler",
	      value: function addEventHandler(eventName, prop) {
	        this.handlers[eventName] = prop;
	        this.el.on(this.getPlotlyEventName(eventName), this.handlers[eventName]);
	      }
	    }, {
	      key: "removeEventHandler",
	      value: function removeEventHandler(eventName) {
	        this.el.removeListener(this.getPlotlyEventName(eventName), this.handlers[eventName]);
	        delete this.handlers[eventName];
	      }
	    }, {
	      key: "getPlotlyEventName",
	      value: function getPlotlyEventName(eventName) {
	        return 'plotly_' + eventName.toLowerCase();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return _react["default"].createElement("div", {
	          id: this.props.divId,
	          style: this.props.style,
	          ref: this.getRef,
	          className: this.props.className
	        });
	      }
	    }]);
	
	    return PlotlyComponent;
	  }(_react.Component);
	
	  PlotlyComponent.propTypes = {
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    config: _propTypes["default"].object,
	    layout: _propTypes["default"].object,
	    frames: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    revision: _propTypes["default"].number,
	    onInitialized: _propTypes["default"].func,
	    onPurge: _propTypes["default"].func,
	    onError: _propTypes["default"].func,
	    onUpdate: _propTypes["default"].func,
	    debug: _propTypes["default"].bool,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    useResizeHandler: _propTypes["default"].bool,
	    divId: _propTypes["default"].string
	  };
	  eventNames.forEach(function (eventName) {
	    PlotlyComponent.propTypes['on' + eventName] = _propTypes["default"].func;
	  });
	  PlotlyComponent.defaultProps = {
	    debug: false,
	    useResizeHandler: false,
	    data: [],
	    style: {
	      position: 'relative',
	      display: 'inline-block'
	    }
	  };
	  return PlotlyComponent;
	}
	//# sourceMappingURL=factory.js.map

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _factory = _interopRequireDefault(__webpack_require__(901));
	
	var _plotly = _interopRequireDefault(__webpack_require__(850));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PlotComponent = (0, _factory["default"])(_plotly["default"]);
	var _default = PlotComponent;
	exports["default"] = _default;
	//# sourceMappingURL=react-plotly.js.map

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(415);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(414));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Context = __webpack_require__(167);
	
	var Provider =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Provider, _Component);
	
	  function Provider(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    var store = props.store;
	    _this.state = {
	      storeState: store.getState(),
	      store: store
	    };
	    return _this;
	  }
	
	  var _proto = Provider.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this.subscribe();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribe) this.unsubscribe();
	    this._isMounted = false;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.store !== prevProps.store) {
	      if (this.unsubscribe) this.unsubscribe();
	      this.subscribe();
	    }
	  };
	
	  _proto.subscribe = function subscribe() {
	    var _this2 = this;
	
	    var store = this.props.store;
	    this.unsubscribe = store.subscribe(function () {
	      var newStoreState = store.getState();
	
	      if (!_this2._isMounted) {
	        return;
	      }
	
	      _this2.setState(function (providerState) {
	        // If the value is the same, skip the unnecessary state update.
	        if (providerState.storeState === newStoreState) {
	          return null;
	        }
	
	        return {
	          storeState: newStoreState
	        };
	      });
	    }); // Actions might have been dispatched between render and mount - handle those
	
	    var postMountStoreState = store.getState();
	
	    if (postMountStoreState !== this.state.storeState) {
	      this.setState({
	        storeState: postMountStoreState
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var Context = this.props.context || _Context.ReactReduxContext;
	    return _react.default.createElement(Context.Provider, {
	      value: this.state
	    }, this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	Provider.propTypes = {
	  store: _propTypes.default.shape({
	    subscribe: _propTypes.default.func.isRequired,
	    dispatch: _propTypes.default.func.isRequired,
	    getState: _propTypes.default.func.isRequired
	  }),
	  context: _propTypes.default.object,
	  children: _propTypes.default.any
	};
	var _default = Provider;
	exports.default = _default;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(168));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(169));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(410));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(911));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(905));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(906));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(907));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(908));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(113);
	
	var _wrapMapToProps = __webpack_require__(411);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(411);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(168));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(412));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(169));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(909));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(413));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 910 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 911 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 912 */
426,
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(112),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(147);__webpack_require__(915),__webpack_require__(60);var invariant=_interopDefault(__webpack_require__(175));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target;return React.createElement("a",_extends({},a,{ref:t||r,onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}}))}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(t){t||invariant(!1);var r=t.history,e=normalizeToLocation(resolveToLocation(u,t.location),t.location),o=e?r.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(u,t.location);(c?r.replace:r.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,h=e.activeStyle,R=e.className,v=e.exact,d=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=y||e.location,r=normalizeToLocation(resolveToLocation(_,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:v,strict:m}):null,i=!!(d?d(a,t):a),c=i?joinClassnames(R,p):R,u=i?_extends({},w,{},h):w,f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},x);return forwardRefShim$1!==forwardRef$1?f.ref=s||L:f.innerRef=L,React.createElement(Link,f)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 914 */
[1023, 916],
/* 915 */
[1024, 914],
/* 916 */
855,
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2));__webpack_require__(416);var history=__webpack_require__(147);__webpack_require__(60);var createContext=_interopDefault(__webpack_require__(918)),invariant=_interopDefault(__webpack_require__(175)),pathToRegexp=_interopDefault(__webpack_require__(848));__webpack_require__(922);var hoistStatics=_interopDefault(__webpack_require__(57));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';function _interopDefault(e){return(e&&(typeof e==='object')&&'default'in e)?e['default']:e}var React=__webpack_require__(2),React__default=_interopDefault(React),_inheritsLoose=_interopDefault(__webpack_require__(427)),PropTypes=_interopDefault(__webpack_require__(416)),gud=_interopDefault(__webpack_require__(729)),warning=_interopDefault(__webpack_require__(60));var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + gud() + '__';
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes.object.isRequired, _Provider$childContex);
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inheritsLoose(Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes.object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default.createContext || createReactContext;module.exports=index;

/***/ },
/* 919 */
[1023, 920],
/* 920 */
855,
/* 921 */
/***/ function(module, exports) {

	/** @license React v16.10.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ },
/* 922 */
[1022, 921],
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(853).enable();
	  window.Promise = __webpack_require__(852);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1021);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(155);


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeDateRange = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _types = __webpack_require__(9);
	
	var _connectedReactRouter = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var maxWeeks = 1;
	var oneWeekErrorMessage = 'Sorry, date range is too large, resizing now to one week!';
	
	var limitDateRange = function limitDateRange(dateRange) {
	  var startDate = dateRange.startDate,
	      endDate = dateRange.endDate;
	
	
	  var currentDuration = Math.abs(endDate.unix() - startDate.unix()) * 1000;
	
	  var maxWeeksDuration = _moment2.default.duration({ weeks: maxWeeks, days: 1 }).asMilliseconds();
	
	  if (currentDuration > maxWeeksDuration) {
	    var startRef = startDate.clone();
	    endDate = startRef.add(maxWeeks, "w");
	    return {
	      startDate: startDate,
	      endDate: endDate
	    };
	  }
	
	  return dateRange;
	};
	
	var changeDateRange = exports.changeDateRange = function changeDateRange(dateRange, realtime) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var limitedDateRange, startDate, endDate;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // limit dates range to 15 days
	              limitedDateRange = limitDateRange(dateRange);
	              startDate = limitedDateRange.startDate, endDate = limitedDateRange.endDate;
	
	
	              if (limitedDateRange.endDate.unix() < dateRange.endDate.unix()) {
	                // it means the date range has been resized, thus display message
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: {
	                    message: oneWeekErrorMessage,
	                    open: true
	                  }
	                });
	              }
	
	              // Dispatch push
	              if (!realtime) {
	                dispatch((0, _connectedReactRouter.push)("/dashboard?startDate=" + startDate.valueOf() + "&endDate=" + endDate.valueOf()));
	              } else {
	                dispatch((0, _connectedReactRouter.push)("/dashboard"));
	              }
	
	              _context.next = 6;
	              return dispatch({
	                type: _types.CHANGE_DATE_RANGE,
	                payload: limitedDateRange
	              });
	
	            case 6:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeTableDateRange = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _types = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var changeTableDateRange = exports.changeTableDateRange = function changeTableDateRange(dateRange) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return dispatch({
	                type: _types.CHANGE_TABLE_DATE_RANGE,
	                payload: dateRange
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(418);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var URL = _baseUrl2.default + '/api/config';
	
	function fetchConfig() {
	  var _this = this;
	
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(_config.fetchConfigPending);
	
	              _axios2.default.get(URL, (0, _authorizeRequest2.default)()).then(function (response) {
	                dispatch((0, _config.fetchConfigSuccess)(response.data));
	              }).catch(function () {
	                dispatch(_config.fetchConfigError);
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}
	
	exports.default = fetchConfig;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterPeakShavingData = undefined;
	
	var _types = __webpack_require__(9);
	
	var filterPeakShavingData = exports.filterPeakShavingData = function filterPeakShavingData(filter) {
	  return {
	    type: _types.FILTER_PS_DATA,
	    payload: filter
	  };
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAsset = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getAsset = exports.getAsset = function getAsset() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	              _context.next = 4;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/asset", (0, _authorizeRequest2.default)());
	
	            case 4:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	
	              dispatch({
	                type: _types.FETCH_ASSET,
	                payload: response
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 16;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching asset local file ", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBatterySoh = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getBatterySoh = exports.getBatterySoh = function getBatterySoh() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var URL, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              URL = _baseUrl2.default + "/api/external/metric/14";
	
	
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	
	              _context.prev = 2;
	              _context.next = 5;
	              return _axios2.default.get(URL, (0, _authorizeRequest2.default)());
	
	            case 5:
	              response = _context.sent;
	              _context.next = 8;
	              return dispatch({
	                type: _types.FETCH_BATTERY_SOH,
	                payload: response.data.results[0]
	              });
	
	            case 8:
	
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 17;
	              break;
	
	            case 12:
	              _context.prev = 12;
	              _context.t0 = _context["catch"](2);
	
	              console.error("Error fetching current battery info", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	
	            case 17:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 12]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChartData = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(27);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var definePeriodParam = function definePeriodParam(start, end, force1h, force15m) {
	  var period = void 0;
	  var currentDuration = end - start;
	  var threeMonths = _moment2.default.duration({ months: 3 }).asMilliseconds();
	  var twoMonths = _moment2.default.duration({ months: 2 }).asMilliseconds();
	  var oneMonth = _moment2.default.duration({ weeks: 4 }).asMilliseconds();
	  var twoWeeks = _moment2.default.duration({ weeks: 2 }).asMilliseconds();
	  // const oneWeek = moment.duration({ weeks: 1 }).asMilliseconds();
	  var threeDays = _moment2.default.duration({ days: 3 }).asMilliseconds();
	
	  if (currentDuration > threeMonths) {
	    period = "24h";
	  } else if (currentDuration >= twoMonths) {
	    period = "24h";
	  } else if (currentDuration >= oneMonth) {
	    period = "24h";
	  } else if (currentDuration >= twoWeeks) {
	    period = "1h";
	  } else if (currentDuration >= threeDays) {
	    period = "15m";
	  } else if (force1h) {
	    period = "1h";
	  } else if (force15m) {
	    period = "15m";
	  } else {
	    period = "30s";
	  }
	  return period;
	};
	
	var getChartData = exports.getChartData = function getChartData() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var _ref2, dateRange, _ref3, asset, start, end, currentDuration, twoWeeks, period, period1h, period15m, pMaxValue, pRefValue;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	              // declare parameters
	              _context.next = 3;
	              return getState();
	
	            case 3:
	              _ref2 = _context.sent;
	              dateRange = _ref2.dateRange;
	              _context.next = 7;
	              return getState();
	
	            case 7:
	              _ref3 = _context.sent;
	              asset = _ref3.asset;
	              start = dateRange.startDate.unix() * 1000;
	              end = dateRange.endDate.unix() * 1000;
	
	              // make sure the time frame stays under 2 weeks max
	
	              currentDuration = Math.abs(end - start);
	              twoWeeks = _moment2.default.duration({ weeks: 2, days: 1 }).asMilliseconds();
	
	
	              if (currentDuration > twoWeeks) {
	                end = (0, _moment2.default)(end).add(2, "w").unix();
	
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: {
	                    message: "Sorry, time frame too large, resized to two weeks",
	                    open: true
	                  }
	                });
	              }
	
	              // define appropriate period parameter
	
	              if (start === end) {
	                end = dateRange.startDate.add(24, "hours").unix() * 1000;
	              }
	
	              period = definePeriodParam(start, end);
	              period1h = definePeriodParam(start, end, true);
	              period15m = definePeriodParam(start, end, null, true);
	              pMaxValue = asset.peak_shaving_generic.p_max_kw;
	              pRefValue = asset.peak_shaving_generic.p_ref_kw;
	
	
	              _axios2.default.all([
	              // OLD battery data
	              _axios2.default.get(_baseUrl2.default + "/api/external/battery/1?from=" + start + "&to=" + end + "&agg=avg&period=" + period, (0, _authorizeRequest2.default)()),
	              // NEW battery data
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/14?from=" + start + "&to=" + end + "&agg=avg&period=" + period, (0, _authorizeRequest2.default)()),
	
	              // Generic Pmax data
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/20?from=" + start + "&to=" + end + "&agg=max&period=" + period1h, (0, _authorizeRequest2.default)()),
	
	              // Atypical Pmax on peak data
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/21?from=" + start + "&to=" + end + "&agg=max&period=" + period1h, (0, _authorizeRequest2.default)()),
	
	              // Atypical Pmax off peak data
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/22?from=" + start + "&to=" + end + "&agg=max&period=" + period1h, (0, _authorizeRequest2.default)()),
	
	              // meter with bess
	              _axios2.default.get(_baseUrl2.default + "/api/external/meter/3?from=" + start + "&to=" + end + "&agg=avg&period=" + period15m, (0, _authorizeRequest2.default)()),
	              // meter without bess
	              _axios2.default.get(_baseUrl2.default + "/api/external/setpoint/12?from=" + start + "&to=" + end + "&agg=avg&period=" + period15m, (0, _authorizeRequest2.default)()),
	              // get tariff info
	              _axios2.default.get(_baseUrl2.default + "/api/external/tariff/1?from=" + start + "&to=" + end, (0, _authorizeRequest2.default)()),
	              // Pmax load site w/o BESS (real)
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/16?from=" + start + "&to=" + end + "&agg=max&period=" + period1h, (0, _authorizeRequest2.default)()),
	              // Pmax load (real)
	              _axios2.default.get(_baseUrl2.default + "/api/external/metric/17?from=" + start + "&to=" + end + "&agg=max&period=" + period1h, (0, _authorizeRequest2.default)()),
	              // Setpoint
	              _axios2.default.get(_baseUrl2.default + "/api/external/setpoint/11?from=" + start + "&to=" + end + "&agg=avg&period=" + period, (0, _authorizeRequest2.default)()),
	              // battery bams
	              _axios2.default.get(_baseUrl2.default + "/api/external/battery/2?from=" + start + "&to=" + end + "&agg=avg&period=" + period, (0, _authorizeRequest2.default)())]).then(_axios2.default.spread(function (battery, newBattery, pMax, pMaxOnPeak, pMaxOffPeak, meterWithBESS, meterWithoutBESS, tariffInfo, pMaxLoadWithoutBess, pMaxLoad, setpoint, batteryBams) {
	                return {
	                  data: {
	                    battery: battery.data.results,
	                    newBattery: newBattery.data.results,
	                    pMax: pMax.data.results,
	                    pMaxOnPeak: pMaxOnPeak.data.results,
	                    pMaxOffPeak: pMaxOffPeak.data.results,
	                    meter_with_bess: meterWithBESS.data.results,
	                    meter_without_bess: meterWithoutBESS.data.results,
	                    pMaxLoadWithoutBess: pMaxLoadWithoutBess.data.results,
	                    pMaxLoad: pMaxLoad.data.results,
	                    setpoint: setpoint.data.results,
	                    batteryBams: batteryBams.data.results
	                  },
	                  layout: {
	                    pMaxValue: pMaxValue,
	                    pRefValue: pRefValue,
	                    tariff: tariffInfo.data.results || []
	                  }
	                };
	              })).then(function (payload) {
	                dispatch({ type: _types.FETCH_CHART_DATA, payload: payload });
	                dispatch({ type: _types.LOADING_MODE, payload: false });
	              }).then(function () {
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: { message: "", open: false }
	                });
	              }).catch(function (error) {
	                var message = (0, _lodash.get)(error, 'response.data.status_code') === 1200 ? 'Interval request is longer than 168h (watch the time change)' : error.message;
	
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: { message: message, open: true }
	                });
	                dispatch({ type: _types.LOADING_MODE, payload: false });
	              });
	
	            case 21:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getContract = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getContract = exports.getContract = function getContract(start, end) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var URL, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	              //const response = await axios.get(`${BASE_URL}/api/file/contract`, authorizeRequest());
	              URL = _baseUrl2.default + "/api/external/contract/?from=" + start + "&to=" + end + "&agg=avg&period=1m";
	              _context.next = 5;
	              return _axios2.default.get(URL);
	
	            case 5:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 9;
	              return dispatch({
	                type: _types.FETCH_CONTRACT,
	                payload: response
	              });
	
	            case 9:
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	              _context.next = 17;
	              break;
	
	            case 12:
	              _context.prev = 12;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching contract api");
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	
	            case 17:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 12]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPSAtypical = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getPSAtypical = exports.getPSAtypical = function getPSAtypical() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'atypicalPs' } });
	              _context.next = 4;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/peak_shaving_atypical", (0, _authorizeRequest2.default)());
	
	            case 4:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 8;
	              return dispatch({
	                type: _types.FETCH_PSATYPICAL,
	                payload: response
	              });
	
	            case 8:
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'atypicalPs' } });
	              _context.next = 16;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching peak shaving atypical", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'atypicalPs' } });
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPSGeneric = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getPSGeneric = exports.getPSGeneric = function getPSGeneric() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'genericPs' } });
	              _context.next = 4;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/peak_shaving_generic", (0, _authorizeRequest2.default)());
	
	            case 4:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 8;
	              return dispatch({
	                type: _types.FETCH_PSGENERIC,
	                payload: response
	              });
	
	            case 8:
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'genericPs' } });
	              _context.next = 16;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching peak shaving generic", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'genericPs' } });
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSiteData = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(27);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getSiteData = exports.getSiteData = function getSiteData() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	              _axios2.default.all([
	              // OLD battery data
	              _axios2.default.get(_baseUrl2.default + '/api/external/battery/1', (0, _authorizeRequest2.default)()),
	              // NEW battery data
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/14', (0, _authorizeRequest2.default)()),
	              // Generic Pmax data
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/20', (0, _authorizeRequest2.default)()),
	              // Atypical Pmax on peak data
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/21', (0, _authorizeRequest2.default)()),
	              // Atypical Pmax off peak data
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/22', (0, _authorizeRequest2.default)()),
	              // meter without bess
	              _axios2.default.get(_baseUrl2.default + '/api/external/setpoint/12', (0, _authorizeRequest2.default)()),
	              // Pmax load site w/o BESS (real)
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/16', (0, _authorizeRequest2.default)()),
	              // Pmax load (real)
	              _axios2.default.get(_baseUrl2.default + '/api/external/metric/17', (0, _authorizeRequest2.default)()),
	              // Setpoint
	              _axios2.default.get(_baseUrl2.default + '/api/external/setpoint/11', (0, _authorizeRequest2.default)())]).then(_axios2.default.spread(function (battery, newBattery, pMax, pMaxOnPeak, pMaxOffPeak, meterWithoutBESS, pMaxLoadWithoutBess, pMaxLoad, setpoint) {
	                return {
	                  currentLoad: meterWithoutBESS.data.results[0].p,
	                  setpoint: setpoint.data.results[0].p,
	                  genericPmax: pMax.data.results[0].value,
	                  pMaxOnPeak: (0, _lodash.get)(pMaxOnPeak, 'data.results[0].value'),
	                  pMaxOffPeak: (0, _lodash.get)(pMaxOffPeak, 'data.results[0].value'),
	                  pMaxLoadWithoutBess: pMaxLoadWithoutBess.data.results[0].value,
	                  pMaxLoad: pMaxLoad.data.results[0].value,
	                  bessInstantPower: battery.data.results[0].p,
	                  bessStatus: battery.data.results[0].state,
	                  soc: battery.data.results[0].soc,
	                  soh: newBattery.data.results[0].value
	                };
	              })).then(function (payload) {
	                dispatch({ type: _types.FETCH_SITE_DATA, payload: payload });
	                dispatch({ type: _types.LOADING_MODE, payload: false });
	              }).then(function () {
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: { message: "", open: false }
	                });
	              }).catch(function (error) {
	                console.error(error);
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: { message: error.message, open: true }
	                });
	                dispatch({ type: _types.LOADING_MODE, payload: false });
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStatus = exports.getCurrentStatus = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _alarms = __webpack_require__(148);
	
	var _alarms2 = _interopRequireDefault(_alarms);
	
	var _lodash = __webpack_require__(27);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _getStatus = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getStatusLogic = function getStatusLogic(dispatch, alarms, from, to) {
	  return new Promise(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resolve, reject) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'status' } });
	
	              _context.next = 4;
	              return _axios2.default.all((0, _lodash.map)(alarms, function (_ref2) {
	                var id = _ref2.id;
	
	                // https://api.edf-sf.com/v1/28/ems/status/1?id=1&from=1547665649222&to=1547752049000
	                var queryString = from && to ? "?from=" + from + "&to=" + to : '';
	                return _axios2.default.get(_baseUrl2.default + "/api/external/status/" + id + queryString, (0, _authorizeRequest2.default)()).catch(function (error) {
	                  console.error(error);
	                  reject(error);
	                });
	              })).catch(function (error) {
	                console.error(error);
	                reject(error);
	              }).then(function (results) {
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: { message: "", open: false }
	                });
	                resolve(results);
	                setTimeout(function () {
	                  dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'status' } });
	                });
	              });
	
	            case 4:
	              return _context.abrupt("return", _context.sent);
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching status", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'status' } });
	              reject(_context.t0);
	
	            case 13:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	};
	
	var getCurrentStatus = exports.getCurrentStatus = function getCurrentStatus() {
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch) {
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              getStatusLogic(dispatch, _alarms2.default.status.filter(function (_ref4) {
	                var id = _ref4.id;
	                return id === 211;
	              })).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(results) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          _context2.next = 2;
	                          return dispatch({
	                            type: _types.FETCH_STATUS,
	                            payload: {
	                              data: {
	                                results: (0, _lodash.map)(results, function (result) {
	                                  return (0, _lodash.get)(result, 'data.results[0]');
	                                }).filter(function (value) {
	                                  return value;
	                                })
	                              }
	                            }
	                          });
	
	                        case 2:
	                        case "end":
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, undefined);
	                }));
	
	                return function (_x4) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 1:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var excludedColumns = {
	  bits: true,
	  values: true
	};
	
	var extractHeaders = function extractHeaders(line, prefix, headers) {
	  (0, _lodash.forIn)(line, function (value, key) {
	    var excluded = excludedColumns[key];
	    var columnKey = "" + prefix + key;
	    var currentPrefix = columnKey + ".";
	
	    if (!excluded && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	      extractHeaders(value, currentPrefix, headers);
	    } else if (!excluded && !headers.find(function (_ref6) {
	      var key = _ref6.key;
	      return key === columnKey;
	    })) {
	
	      headers.push({ label: columnKey, key: columnKey });
	    }
	  });
	};
	
	var getHeaders = function getHeaders(data) {
	  return data.forEach(function (line) {
	    return extractHeaders(line, '', []);
	  });
	};
	
	var flattenStatus = function flattenStatus(status) {
	  return status.forEach(function (status) {
	    return status.values && status.values.forEach(function (_ref7) {
	      var title = _ref7.title,
	          value = _ref7.value;
	      return status[title] = value;
	    });
	  });
	};
	
	var getStatus = exports.getStatus = function getStatus(from, to) {
	  return function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch) {
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'alarms' } });
	
	              getStatusLogic(dispatch, _alarms2.default.status, from, to).catch(function () {
	                return dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'alarms' } });
	              }).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(results) {
	                  var filtered, status, headers;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          filtered = (0, _lodash.map)(results, function (result) {
	                            return (0, _lodash.get)(result, 'data.results');
	                          }).filter(function (value) {
	                            return value;
	                          });
	                          status = (0, _getStatus.formatResults)(filtered);
	
	                          flattenStatus(status);
	                          headers = getHeaders(status);
	                          _context4.next = 6;
	                          return dispatch({
	                            type: _types.FETCH_STATUS_RANGE,
	                            payload: {
	                              status: status,
	                              headers: headers
	                            }
	                          });
	
	                        case 6:
	
	                          setTimeout(function () {
	                            dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'alarms' } });
	                          });
	
	                        case 7:
	                        case "end":
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, undefined);
	                }));
	
	                return function (_x6) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 2:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x5) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTableBatteryInfo = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getTableBatteryInfo = exports.getTableBatteryInfo = function getTableBatteryInfo() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'batteryStatus' } });
	              _context.next = 4;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/battery", (0, _authorizeRequest2.default)());
	
	            case 4:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 8;
	              return dispatch({
	                type: _types.FETCH_BATTERY_TABLE,
	                payload: response
	              });
	
	            case 8:
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'batteryStatus' } });
	              _context.next = 16;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching battery info for table", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'batteryStatus' } });
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTariffInfo = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getTariffInfo = exports.getTariffInfo = function getTariffInfo() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch({ type: _types.LOADING_MODE, payload: true });
	
	              _context.next = 3;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/peak_tariff_info_date", (0, _authorizeRequest2.default)());
	
	            case 3:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: '', open: false }
	              });
	
	              if (!response.data.error) {
	                _context.next = 10;
	                break;
	              }
	
	              console.error("Error fetching tariff info:", response.data.error);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: response.data.error, open: true }
	              });
	              _context.next = 12;
	              break;
	
	            case 10:
	              _context.next = 12;
	              return dispatch({
	                type: _types.FETCH_TARIFF,
	                payload: response
	              });
	
	            case 12:
	
	              dispatch({ type: _types.LOADING_MODE, payload: false });
	
	            case 13:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUnavailabilities = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getUnavailabilities = exports.getUnavailabilities = function getUnavailabilities() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch({ type: _types.LOADING_MODE, payload: true, meta: { type: 'unavailabilities' } });
	
	              _context.next = 4;
	              return _axios2.default.get(_baseUrl2.default + "/api/file/unavailabilities", (0, _authorizeRequest2.default)());
	
	            case 4:
	              response = _context.sent;
	
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: "", open: false }
	              });
	              _context.next = 8;
	              return dispatch({
	                type: _types.FETCH_UNAVAILABILITIES,
	                payload: response
	              });
	
	            case 8:
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'unavailabilities' } });
	              _context.next = 16;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("error fetching ems unavailabilites", _context.t0);
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: _context.t0.message, open: true }
	              });
	              dispatch({ type: _types.LOADING_MODE, payload: false, meta: { type: 'unavailabilities' } });
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleSuccess = exports.handleErrors = undefined;
	
	var _types = __webpack_require__(9);
	
	var handleErrors = exports.handleErrors = function handleErrors(_ref) {
	  var message = _ref.message,
	      open = _ref.open;
	  return {
	    type: _types.HANDLE_ERRORS,
	    payload: { message: message, open: open }
	  };
	};
	
	var handleSuccess = exports.handleSuccess = function handleSuccess(_ref2) {
	  var message = _ref2.message,
	      open = _ref2.open;
	  return {
	    type: _types.HANDLE_SUCCESS,
	    payload: { message: message, open: open }
	  };
	};

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleMode = undefined;
	
	var _types = __webpack_require__(9);
	
	var toggleMode = exports.toggleMode = function toggleMode() {
	  return {
	    type: _types.TOGGLE_MODE
	  };
	};

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveNewPasswords = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var saveNewPasswords = exports.saveNewPasswords = function saveNewPasswords(currentPassword, operatorPassword, customerPassword) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _axios2.default.post(_baseUrl2.default + "/api/update-password", {
	                currentPassword: currentPassword,
	                operatorPassword: operatorPassword,
	                customerPassword: customerPassword
	              }, (0, _authorizeRequest2.default)()).then(function (res) {
	                dispatch({
	                  type: _types.FILE_SAVED,
	                  payload: {
	                    message: "New password saved!"
	                  }
	                });
	              }).catch(function (error) {
	                console.error("error writing to json file", error);
	                dispatch({
	                  type: _types.HANDLE_ERRORS,
	                  payload: {
	                    message: "Passwords not Saved! Please try again.",
	                    open: true
	                  }
	                });
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveToJSONFile = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _types = __webpack_require__(9);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var saveToJSONFile = exports.saveToJSONFile = function saveToJSONFile(data) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var postData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              postData = { asset: data };
	              _context.next = 4;
	              return _axios2.default.post(_baseUrl2.default + '/api/file/asset', postData, (0, _authorizeRequest2.default)());
	
	            case 4:
	
	              dispatch({
	                type: _types.FILE_SAVED,
	                payload: { message: 'File Saved!' }
	              });
	              _context.next = 11;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              dispatch({
	                type: _types.HANDLE_ERRORS,
	                payload: { message: 'File not Saved!', open: true }
	              });
	              console.error('error writing to json file', _context.t0);
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeTab = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _connectedReactRouter = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var changeTab = exports.changeTab = function changeTab(section, tabId) {
	    return function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatch((0, _connectedReactRouter.push)('/' + section + '/' + tabId));
	
	                        case 1:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateData = exports.sortColumn = undefined;
	
	var _types = __webpack_require__(9);
	
	var sortColumn = exports.sortColumn = function sortColumn(data, orderBy, order) {
	  return {
	    type: _types.SORT_COLUMN,
	    payload: { data: data, orderBy: orderBy, order: order }
	  };
	};
	
	var updateData = exports.updateData = function updateData(data) {
	  return {
	    type: _types.UPDATE_DATA,
	    payload: data
	  };
	};

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactPlotly = __webpack_require__(902);
	
	var _reactPlotly2 = _interopRequireDefault(_reactPlotly);
	
	var _lodash = __webpack_require__(27);
	
	var _actions = __webpack_require__(35);
	
	var _baseUrl = __webpack_require__(22);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _endpointsExportConfig = __webpack_require__(959);
	
	var _endpointsExportConfig2 = _interopRequireDefault(_endpointsExportConfig);
	
	var _styles = __webpack_require__(25);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _InsertDriveFile = __webpack_require__(230);
	
	var _InsertDriveFile2 = _interopRequireDefault(_InsertDriveFile);
	
	var _Close = __webpack_require__(646);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _CameraAlt = __webpack_require__(644);
	
	var _CameraAlt2 = _interopRequireDefault(_CameraAlt);
	
	var _IconButton = __webpack_require__(38);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _CircularProgress = __webpack_require__(62);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _DateRange = __webpack_require__(140);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _Modal = __webpack_require__(66);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormControlLabel = __webpack_require__(123);
	
	var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);
	
	var _Switch = __webpack_require__(210);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _CustomDateRangePicker = __webpack_require__(947);
	
	var _CustomDateRangePicker2 = _interopRequireDefault(_CustomDateRangePicker);
	
	var _Tooltip = __webpack_require__(89);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _reshape_data_for_chart = __webpack_require__(995);
	
	var _reshape_data_for_chart2 = _interopRequireDefault(_reshape_data_for_chart);
	
	var _reshape_data_for_csv = __webpack_require__(996);
	
	var _reshape_data_for_csv2 = _interopRequireDefault(_reshape_data_for_csv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Material UI
	
	
	//Selectors
	
	
	function getModalStyle() {
	  var top = 50;
	  var left = 50;
	
	  return {
	    top: top + "%",
	    left: left + "%",
	    transform: "translate(-" + top + "%, -" + left + "%)"
	  };
	}
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flexGrow: 1,
	      display: 'flex',
	      flexDirection: 'column'
	    },
	    paper: {
	      position: "absolute",
	      backgroundColor: theme.palette.background.paper,
	      boxShadow: theme.shadows[5],
	      padding: theme.spacing(4)
	    },
	    plot: {
	      flexGrow: 1,
	      width: '100%',
	      height: '100%',
	
	      "& .modebar": {
	        visibility: "hidden"
	      }
	    },
	    warningMessage: {
	      position: 'relative',
	      border: "2px solid " + theme.palette.secondary.main,
	      margin: '0 auto',
	      maxWidth: '720px',
	      padding: theme.spacing(1),
	      paddingRight: theme.spacing(7)
	    },
	    warningParagraph: {
	      margin: 0,
	      color: theme.palette.secondary.main
	    },
	    warningClose: {
	      position: 'absolute',
	      top: '50%',
	      right: theme.spacing(1),
	      transform: 'translateY(-50%)'
	    }
	  };
	};
	
	var warningRanges = {
	  range100: {
	    start: 100,
	    end: 25,
	    reset: true
	  },
	  range25: {
	    start: 25,
	    end: 20,
	    closed: false
	  },
	  range20: {
	    start: 20,
	    end: 15,
	    closed: false
	  },
	  range15: {
	    start: 15,
	    end: 10,
	    closed: false
	  },
	  range10: {
	    start: 10,
	    end: 5,
	    closed: false
	  },
	  range5: {
	    start: 5,
	    end: 0,
	    closed: false
	  },
	  range0: {
	    start: 0,
	    end: -1,
	    closed: false
	  }
	};
	
	var OverviewChart = function (_React$Component) {
	  _inherits(OverviewChart, _React$Component);
	
	  function OverviewChart() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OverviewChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OverviewChart.__proto__ || Object.getPrototypeOf(OverviewChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openDateRangeModal: false,
	      openExportModal: false,
	      revision: 0,
	      sendExportEmail: '',
	      showWarningMessage: false,
	      warningRanges: (0, _lodash.cloneDeep)(warningRanges)
	    }, _this.handleCloseWarningMessage = function () {
	      var workingWarningRanges = (0, _lodash.cloneDeep)(warningRanges);
	
	      (0, _lodash.find)(workingWarningRanges, function (range) {
	        if (_this.isCurrentRange(range)) {
	          range.closed = true;
	          return true;
	        }
	      });
	
	      _this.setState({
	        showWarningMessage: false,
	        warningRanges: workingWarningRanges
	      });
	    }, _this.handleOpen = function () {
	      return _this.setState({ openDateRangeModal: true });
	    }, _this.handleClose = function () {
	      return _this.setState({ openDateRangeModal: false });
	    }, _this.handleCustomDateRangePickerSubmit = function (_ref2) {
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      _this.props.changeDateRange({ startDate: startDate, endDate: endDate }, false);
	      _this.props.mode.realtime && _this.props.toggleMode();
	      _this.handleClose();
	    }, _this.handleOpen2 = function () {
	      return _this.setState({ openExportModal: true });
	    }, _this.handleClose2 = function () {
	      return _this.setState({ openExportModal: false });
	    }, _this.handleCustomDateRangePickerSubmit2 = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref3) {
	        var startDate = _ref3.startDate,
	            endDate = _ref3.endDate,
	            email = _ref3.emailValue;
	
	        var _this$props, handleSuccess, handleErrors, _ref5, result;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, handleSuccess = _this$props.handleSuccess, handleErrors = _this$props.handleErrors;
	
	
	                localStorage.setItem('sendExportEmail', email);
	                _this.setState({ sendExportEmail: email });
	
	                _context.prev = 3;
	                _context.next = 6;
	                return _axios2.default.post(_baseUrl2.default + "/api/export", {
	                  startDate: startDate.format(),
	                  endDate: endDate.format(),
	                  email: email,
	                  endpoints: _endpointsExportConfig2.default
	                }, (0, _authorizeRequest2.default)());
	
	              case 6:
	                _ref5 = _context.sent;
	                result = _ref5.data;
	
	
	                if (result === "Export in progress") {
	                  handleSuccess({ message: result, open: true });
	                } else {
	                  handleErrors({ message: result, open: true });
	                }
	
	                _context.next = 14;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context["catch"](3);
	
	                handleErrors({ message: _context.t0.message, open: true });
	
	              case 14:
	
	                _this.handleClose2();
	
	              case 15:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[3, 11]]);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }(), _this.downloadGraph = function (fileName) {
	      _this.graphPlotted.current.el.querySelector(".modebar-group a").click();
	    }, _this.onUpdate = function (event) {
	      var revision = _this.state.revision;
	
	
	      if (event.layout.yaxis2.autorange) {
	
	        // TODO remove this hack - don't mutate event value
	        // But needed until Plotly mutate his params on zoom out (double click on graph) \o/
	        event.layout.autosize = false;
	        event.layout.yaxis2.autorange = false;
	        event.layout.yaxis2.range = [0, 300];
	
	        // Apply layout values here
	        _this.graphPlotted.current.updatePlotly();
	
	        // Force sync react-plotly
	        _this.setState({
	          revision: revision + 1
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OverviewChart, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.graphPlotted = _react2.default.createRef();
	      var sendExportEmail = localStorage.getItem('sendExportEmail') || '';
	      this.setState({ sendExportEmail: sendExportEmail });
	      this.updateWarningMessage();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var soc = this.props.soc;
	      var prevSoc = prevProps.soc;
	
	
	      if (soc !== prevSoc) {
	        this.updateWarningMessage();
	      }
	    }
	  }, {
	    key: "resetWarningMessages",
	    value: function resetWarningMessages(ranges) {
	      (0, _lodash.forEach)(ranges, function (range) {
	        return !range.reset && (range.closed = false);
	      });
	    }
	  }, {
	    key: "isCurrentRange",
	    value: function isCurrentRange(range) {
	      var soc = this.props.soc;
	
	      return soc !== null && range.start >= soc && range.end < soc;
	    }
	  }, {
	    key: "isBeforeRange",
	    value: function isBeforeRange(range) {
	      var soc = this.props.soc;
	
	      return soc !== null && range.end > soc;
	    }
	  }, {
	    key: "isAfterRange",
	    value: function isAfterRange(range) {
	      var soc = this.props.soc;
	
	      return soc !== null && range.start < soc;
	    }
	  }, {
	    key: "updateWarningMessage",
	    value: function updateWarningMessage() {
	      var _this3 = this;
	
	      var warningRanges = this.state.warningRanges;
	
	      var workingWarningRanges = (0, _lodash.cloneDeep)(warningRanges);
	
	      // Start from the higher range
	      (0, _lodash.forEach)(workingWarningRanges, function (range) {
	        if (_this3.isCurrentRange(range)) {
	          if (range.reset) {
	            // If current range & is reset : reset messages
	            _this3.resetWarningMessages(workingWarningRanges);
	          } else if (!range.closed) {
	            // If current range & has to show warning : if not already closed, show message
	            _this3.setState({ showWarningMessage: true });
	          }
	        } else if (!range.reset && _this3.isBeforeRange(range)) {
	          // If is higher range, don't show message if battery goes up
	          range.closed = true;
	        } else if (!range.reset && _this3.isAfterRange(range)) {
	          // If is lower range, reset warning message if battery goes down
	          range.closed = false;
	        }
	      });
	
	      this.setState({ warningRanges: workingWarningRanges });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          _props$reshapedChartD = _props.reshapedChartData,
	          data = _props$reshapedChartD.data,
	          layout = _props$reshapedChartD.layout,
	          _props$dateRange = _props.dateRange,
	          startDate = _props$dateRange.startDate,
	          endDate = _props$dateRange.endDate,
	          soc = _props.soc;
	
	      var displayStart = (0, _moment2.default)(startDate).format("MMM Do YYYY");
	      var displayEnd = (0, _moment2.default)(endDate).format("MMM Do YYYY");
	      var _state = this.state,
	          revision = _state.revision,
	          sendExportEmail = _state.sendExportEmail,
	          openDateRangeModal = _state.openDateRangeModal,
	          openExportModal = _state.openExportModal,
	          showWarningMessage = _state.showWarningMessage;
	
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        { className: classes.root },
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            "aria-labelledby": "simple-modal-title",
	            "aria-describedby": "simple-modal-description",
	            open: openDateRangeModal,
	            onClose: this.handleClose
	          },
	          _react2.default.createElement(
	            "div",
	            { style: getModalStyle(), className: classes.paper },
	            _react2.default.createElement(_CustomDateRangePicker2.default, {
	              onSubmit: this.handleCustomDateRangePickerSubmit,
	              actionText: "Filter Dates"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            "aria-labelledby": "simple-modal-title",
	            "aria-describedby": "simple-modal-description",
	            open: openExportModal,
	            onClose: this.handleClose2
	          },
	          _react2.default.createElement(
	            "div",
	            { style: getModalStyle(), className: classes.paper },
	            _react2.default.createElement(_CustomDateRangePicker2.default, {
	              onSubmit: this.handleCustomDateRangePickerSubmit2,
	              twoYearsMode: true,
	              emailValue: sendExportEmail,
	              actionText: "Export to CSV"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, alignItems: "center" },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 6 },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                variant: "h6",
	                inline: "true",
	                align: "left",
	                style: { marginLeft: 20 }
	              },
	              displayStart + " - " + displayEnd,
	              this.props.mode.loading && _react2.default.createElement(_CircularProgress2.default, {
	                disableShrink: true,
	                size: 20,
	                style: { marginLeft: 20 }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 6 },
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: " right" } },
	              _react2.default.createElement(_FormControlLabel2.default, {
	                control: _react2.default.createElement(_Switch2.default, {
	                  checked: this.props.mode.realtime,
	                  color: "secondary",
	                  onChange: this.props.toggleMode
	                }),
	                label: " Realtime Mode"
	              }),
	              _react2.default.createElement(
	                _Tooltip2.default,
	                { title: " Change Date Range" },
	                _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    "aria-label": " Select New Date Range",
	                    onClick: this.handleOpen
	                  },
	                  _react2.default.createElement(_DateRange2.default, null)
	                )
	              ),
	              this.props.reshapedCSVData.length ? _react2.default.createElement(
	                _Tooltip2.default,
	                { title: " Export to CSV" },
	                _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    "aria-label": " Export to CSV",
	                    onClick: this.handleOpen2
	                  },
	                  _react2.default.createElement(_InsertDriveFile2.default, null)
	                )
	              ) : null,
	              _react2.default.createElement(
	                _Tooltip2.default,
	                { title: " Take screenshot" },
	                _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    "aria-label": " Take Screenshot",
	                    onClick: this.downloadGraph
	                  },
	                  _react2.default.createElement(_CameraAlt2.default, null)
	                )
	              )
	            )
	          )
	        ),
	        showWarningMessage ? _react2.default.createElement(
	          _Grid2.default,
	          { container: true, alignItems: "center" },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              "div",
	              { className: classes.warningMessage },
	              _react2.default.createElement(
	                "p",
	                { className: classes.warningParagraph },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Achtung:"
	                ),
	                " Die Batterie erreicht einen niedrigen Ladezustand. Derzeit ist die Batterie noch ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  soc,
	                  "%"
	                ),
	                " geladen."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: classes.warningParagraph },
	                "Wir raten, ab jetzt ein Lastmanagement durch Abschalten oder Herunterfahren m\xF6glicher Verbraucher auf ihrem Standort."
	              ),
	              _react2.default.createElement(
	                _IconButton2.default,
	                {
	                  "aria-label": "Export to CSV",
	                  onClick: this.handleCloseWarningMessage,
	                  className: classes.warningClose
	                },
	                _react2.default.createElement(_Close2.default, null)
	              )
	            )
	          )
	        ) : null,
	        _react2.default.createElement(_reactPlotly2.default, {
	          className: classes.plot,
	          useResizeHandler: true,
	          data: data,
	          layout: layout,
	          config: this.config,
	          ref: this.graphPlotted,
	          revision: revision,
	          onUpdate: this.onUpdate
	        })
	      );
	    }
	  }]);
	
	  return OverviewChart;
	}(_react2.default.Component);
	
	OverviewChart.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dateRange: state.dateRange,
	    mode: state.mode,
	    reshapedChartData: (0, _reshape_data_for_chart2.default)(state),
	    reshapedCSVData: (0, _reshape_data_for_csv2.default)(state),
	    soc: state.siteData.soc
	  };
	};
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
	  changeDateRange: _actions.changeDateRange,
	  toggleMode: _actions.toggleMode,
	  handleSuccess: _actions.handleSuccess,
	  handleErrors: _actions.handleErrors
	})(OverviewChart));

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(113);
	
	var _fetchConfig = __webpack_require__(926);
	
	var _fetchConfig2 = _interopRequireDefault(_fetchConfig);
	
	var _reactRedux = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Config = function (_React$Component) {
	  _inherits(Config, _React$Component);
	
	  function Config() {
	    _classCallCheck(this, Config);
	
	    return _possibleConstructorReturn(this, (Config.__proto__ || Object.getPrototypeOf(Config)).apply(this, arguments));
	  }
	
	  _createClass(Config, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.fetchConfig();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return Config;
	}(_react2.default.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchConfig: _fetchConfig2.default
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Config);

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactDateRange = __webpack_require__(862);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(136);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactMaterialUiFormValidator = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// material ui
	
	
	var defaultMinMaxDates = { minDate: undefined, maxDate: (0, _moment2.default)().add(1, 'day').toDate() };
	
	var max7daysRange = 7;
	var max7daysUnit = 'days';
	var max7daysMessage = '7 days maximum';
	
	var max2yearsRange = 2;
	var max2yearsUnit = 'years';
	var max2yearssMessage = '2 years maximum';
	
	var styles = function styles(theme) {
	  return {
	    label: {
	      color: theme.palette.grey[500]
	    },
	    message: {
	      color: theme.palette.grey[500],
	      padding: theme.spacing(1)
	    }
	  };
	};
	
	var CustomDateRangePicker = function (_React$Component) {
	  _inherits(CustomDateRangePicker, _React$Component);
	
	  function CustomDateRangePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomDateRangePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomDateRangePicker.__proto__ || Object.getPrototypeOf(CustomDateRangePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = Object.assign({
	      selection: {
	        startDate: (0, _moment2.default)().subtract(24, "h"),
	        endDate: (0, _moment2.default)(),
	        key: "selection"
	      }
	    }, defaultMinMaxDates, {
	      emailValue: '',
	      definedRanges: [{
	        hasCustomRendering: true,
	        label: 'This week',
	        range: function range() {
	          return {
	            startDate: (0, _moment2.default)().startOf("week").toDate(),
	            endDate: (0, _moment2.default)()
	          };
	        },
	        isSelected: function isSelected() {
	          return false;
	        }
	      }, {
	        hasCustomRendering: true,
	        label: 'Past Week',
	        range: function range() {
	          return {
	            startDate: (0, _moment2.default)().subtract(1, "weeks").startOf("hour").add(1, "hour").toDate(),
	            endDate: (0, _moment2.default)()
	          };
	        },
	        isSelected: function isSelected() {
	          return false;
	        }
	      }]
	    }), _this.componentDidMount = function () {
	      var _this$props = _this.props,
	          _this$props$dateRange = _this$props.dateRange,
	          startDate = _this$props$dateRange.startDate,
	          endDate = _this$props$dateRange.endDate,
	          key = _this$props$dateRange.key,
	          emailValue = _this$props.emailValue;
	
	      _this.setState({
	        selection: { startDate: startDate, endDate: endDate, key: key },
	        emailValue: emailValue
	      });
	    }, _this.componentDidUpdate = function (_ref2) {
	      var prevEmailValue = _ref2.emailValue;
	      var emailValue = _this.props.emailValue;
	
	
	      if (emailValue !== prevEmailValue) {
	        _this.setState({
	          emailValue: emailValue
	        });
	      }
	    }, _this.handleRangeChange = function (newDateRange) {
	      var _newDateRange$selecti = newDateRange.selection,
	          start = _newDateRange$selecti.startDate,
	          end = _newDateRange$selecti.endDate,
	          key = _newDateRange$selecti.key;
	
	      var startDate = (0, _moment2.default)(start);
	      var endDate = (0, _moment2.default)(end);
	
	      if (start instanceof Date && end instanceof Date) {
	        _this.setMinMaxDates(startDate);
	      } else {
	        _this.cleanMinMaxDates();
	      }
	
	      var updatedEndDate = startDate.unix() === endDate.unix() ? endDate.clone().add(24, "h").toDate() : endDate;
	
	      _this.setState({
	        selection: {
	          startDate: startDate,
	          endDate: updatedEndDate,
	          key: key
	        }
	      });
	    }, _this.handleSubmit = function () {
	      var _this$state = _this.state,
	          emailValue = _this$state.emailValue,
	          _this$state$selection = _this$state.selection,
	          startDate = _this$state$selection.startDate,
	          endDate = _this$state$selection.endDate;
	
	      _this.props.onSubmit({ startDate: startDate, endDate: endDate, emailValue: emailValue });
	    }, _this.handleEmailChange = function (_ref3) {
	      var value = _ref3.target.value;
	      return _this.setState({ emailValue: value });
	    }, _this.setMinMaxDates = function (startDate) {
	      var twoYearsMode = _this.props.twoYearsMode;
	
	
	      var range = twoYearsMode ? max2yearsRange : max7daysRange;
	      var unit = twoYearsMode ? max2yearsUnit : max7daysUnit;
	
	      var maxDate = (0, _moment2.default)(startDate).add(range, unit).toDate();
	
	      _this.setState({
	        minDate: (0, _moment2.default)(startDate).subtract(range, unit).toDate(),
	        maxDate: (0, _moment2.default)().isBefore(maxDate) ? (0, _moment2.default)().add(1, 'day').toDate() : maxDate
	      });
	    }, _this.cleanMinMaxDates = function () {
	      return _this.setState(defaultMinMaxDates);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomDateRangePicker, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          twoYearsMode = _props.twoYearsMode,
	          actionText = _props.actionText;
	      var _state = this.state,
	          selection = _state.selection,
	          minDate = _state.minDate,
	          maxDate = _state.maxDate,
	          definedRanges = _state.definedRanges,
	          emailValue = _state.emailValue;
	
	      return React.createElement(
	        React.Fragment,
	        null,
	        React.createElement(
	          _reactMaterialUiFormValidator.ValidatorForm,
	          {
	            ref: this.form,
	            onSubmit: this.handleSubmit,
	            onError: function onError(errors) {
	              return console.log("error on form submit", errors);
	            },
	            debounceTime: 300
	          },
	          React.createElement(
	            _Typography2.default,
	            { variant: "h6", id: "modal-title" },
	            "Select your date range"
	          ),
	          React.createElement(
	            "section",
	            { title: "DateRangePicker - Vertical Infinite" },
	            React.createElement(
	              "div",
	              null,
	              React.createElement(_reactDateRange.DateRangePicker, {
	                onChange: this.handleRangeChange,
	                className: "PreviewArea",
	                ranges: [selection],
	                minDate: minDate,
	                maxDate: maxDate,
	                staticRanges: definedRanges
	              })
	            ),
	            React.createElement(
	              _Grid2.default,
	              { container: true, justify: "flex-end" },
	              twoYearsMode ? React.createElement(
	                _Grid2.default,
	                { item: true },
	                React.createElement(
	                  "label",
	                  { htmlFor: "emailId", className: classes.label },
	                  "Send export to :"
	                ),
	                React.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  onChange: this.handleEmailChange,
	                  value: emailValue,
	                  id: "emailId",
	                  type: "email",
	                  InputLabelProps: { shrink: true },
	                  fullWidth: true,
	                  margin: "none",
	                  validators: ['required', 'isEmail'],
	                  placeholder: "email@malteurop.com",
	                  errorMessages: ['this field is required', 'email is not valid']
	                })
	              ) : null,
	              React.createElement(
	                _Grid2.default,
	                { item: true },
	                React.createElement(
	                  "div",
	                  { className: classes.message },
	                  "(",
	                  twoYearsMode ? max2yearssMessage : max7daysMessage,
	                  ")"
	                )
	              ),
	              React.createElement(
	                _Grid2.default,
	                { item: true },
	                React.createElement(
	                  _Button2.default,
	                  {
	                    variant: "contained",
	                    color: "default",
	                    type: "submit"
	                  },
	                  actionText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomDateRangePicker;
	}(React.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dateRange: state.dateRange,
	    mode: state.mode
	  };
	};
	
	exports.default = (0, _core.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps)(CustomDateRangePicker));

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TextField = __webpack_require__(70);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTextField = function (_React$Component) {
	  _inherits(CustomTextField, _React$Component);
	
	  function CustomTextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomTextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomTextField.__proto__ || Object.getPrototypeOf(CustomTextField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	      _this.props.onChange(event.target.name, event.target.value, event.target.type);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomTextField, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          label = _props.label,
	          name = _props.name,
	          readOnly = _props.readOnly,
	          type = _props.type;
	
	      return React.createElement(_TextField2.default, {
	        onChange: this.handleChange,
	        inputProps: { readOnly: readOnly },
	        value: value,
	        label: label,
	        key: name,
	        name: name,
	        type: type,
	        InputLabelProps: { shrink: true },
	        fullWidth: true,
	        margin: "normal"
	      });
	    }
	  }]);
	
	  return CustomTextField;
	}(React.Component);
	
	exports.default = CustomTextField;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _green = __webpack_require__(71);
	
	var _green2 = _interopRequireDefault(_green);
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Error = __webpack_require__(649);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _CheckCircle = __webpack_require__(645);
	
	var _CheckCircle2 = _interopRequireDefault(_CheckCircle);
	
	var _IconButton = __webpack_require__(38);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Snackbar = __webpack_require__(206);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _SnackbarContent = __webpack_require__(131);
	
	var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);
	
	var _styles = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var variantIcon = {
	  error: _Error2.default,
	  success: _CheckCircle2.default
	};
	
	var styles1 = function styles1(theme) {
	  return {
	    success: {
	      backgroundColor: _green2.default[600]
	    },
	    error: {
	      backgroundColor: theme.palette.error.dark
	    },
	    icon: {
	      fontSize: 20
	    },
	    iconVariant: {
	      opacity: 0.9,
	      marginRight: theme.spacing(1)
	    },
	    message: {
	      display: "flex",
	      alignItems: "center"
	    }
	  };
	};
	
	function MySnackbarContent(props) {
	  var classes = props.classes,
	      className = props.className,
	      message = props.message,
	      onClose = props.onClose,
	      variant = props.variant,
	      other = _objectWithoutProperties(props, ["classes", "className", "message", "onClose", "variant"]);
	
	  var Icon = variantIcon[variant];
	
	  return _react2.default.createElement(_SnackbarContent2.default, Object.assign({
	    className: (0, _classnames2.default)(classes[variant], className),
	    "aria-describedby": "client-snackbar",
	    message: _react2.default.createElement(
	      "span",
	      { id: "client-snackbar", className: classes.message },
	      _react2.default.createElement(Icon, { className: (0, _classnames2.default)(classes.icon, classes.iconVariant) }),
	      message
	    ),
	    action: [_react2.default.createElement(_IconButton2.default, {
	      key: "close",
	      "aria-label": "Close",
	      color: "inherit",
	      className: classes.close,
	      onClick: onClose
	    })]
	  }, other));
	}
	
	MySnackbarContent.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  className: _propTypes2.default.string,
	  message: _propTypes2.default.node,
	  onClose: _propTypes2.default.func,
	  variant: _propTypes2.default.oneOf(["success", "warning", "error", "info"]).isRequired
	};
	
	var MySnackbarContentWrapper = (0, _styles.withStyles)(styles1)(MySnackbarContent);
	
	var styles2 = function styles2(theme) {
	  return {
	    margin: {
	      margin: theme.spacing(1)
	    }
	  };
	};
	
	var CustomizedSnackbars = function (_React$PureComponent) {
	  _inherits(CustomizedSnackbars, _React$PureComponent);
	
	  function CustomizedSnackbars() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomizedSnackbars);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomizedSnackbars.__proto__ || Object.getPrototypeOf(CustomizedSnackbars)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function () {
	      _this.props.handleErrors({ message: "", open: false });
	      // if (reason === "clickaway") {
	      //   return;
	      // }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomizedSnackbars, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.error.open !== prevProps.error.open) {}
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classes = this.props.classes;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _Snackbar2.default,
	          {
	            anchorOrigin: {
	              vertical: "bottom",
	              horizontal: "left"
	            },
	            open: this.props.error.open,
	            onClose: this.handleClose
	          },
	          _react2.default.createElement(MySnackbarContentWrapper, {
	            variant: this.props.error.variant,
	            className: classes.margin,
	            message: "" + this.props.error.message
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomizedSnackbars;
	}(_react2.default.PureComponent);
	
	CustomizedSnackbars.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    error: state.error
	  };
	};
	exports.default = (0, _styles.withStyles)(styles2)((0, _reactRedux.connect)(mapStateToProps, { handleErrors: _actions.handleErrors })(CustomizedSnackbars));

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _auth_actions = __webpack_require__(417);
	
	var _downloadFile2 = __webpack_require__(960);
	
	var _downloadFile3 = _interopRequireDefault(_downloadFile2);
	
	var _getFileName = __webpack_require__(419);
	
	var _getFileName2 = _interopRequireDefault(_getFileName);
	
	var _core = __webpack_require__(136);
	
	var _CircularProgress = __webpack_require__(62);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    loadingWrapper: {
	      display: 'flex',
	      alignItems: 'center',
	      flexGrow: 1,
	      flexDirection: 'column',
	      justifyContent: 'center'
	    },
	    loadingMessage: {
	      fontSize: '2em',
	      fontWeight: 'bold',
	      textTransform: 'uppercase',
	      color: theme.palette.tertiary.main,
	      textAlign: 'center'
	    },
	    loadingMessageError: {
	      fontSize: '2em',
	      fontWeight: 'bold',
	      textTransform: 'uppercase',
	      color: theme.palette.secondary.dark,
	      textAlign: 'center'
	    },
	    downloadNav: {
	      marginTop: theme.spacing(1)
	    },
	    item: {
	      textDecoration: "none",
	      marginRight: 5
	    },
	    itemLink: {
	      transition: "all 300ms linear",
	      borderRadius: "3px",
	      position: "relative",
	      backgroundColor: "transparent",
	      fontSize: "0.775rem",
	      paddingRight: 8,
	      paddingLeft: 8,
	      "&:hover": {
	        backgroundColor: theme.palette.primary.main,
	        color: 'white'
	      },
	      ".active &": {
	        backgroundColor: theme.palette.primary.main,
	        color: 'white'
	      }
	    }
	  };
	};
	
	var PrivateRoute = function (_Component) {
	  _inherits(PrivateRoute, _Component);
	
	  function PrivateRoute(props) {
	    _classCallCheck(this, PrivateRoute);
	
	    var _this = _possibleConstructorReturn(this, (PrivateRoute.__proto__ || Object.getPrototypeOf(PrivateRoute)).call(this, props));
	
	    var query = new URLSearchParams(location.search);
	    var referrer = query.get('referrer');
	    var fileName = (0, _getFileName2.default)(referrer);
	
	    _this.state = {
	      token: localStorage.getItem('JWT') || sessionStorage.getItem('JWT'),
	      referrer: referrer,
	      fileName: fileName,
	      downloadFinished: false,
	      downloadError: false
	    };
	    return _this;
	  }
	
	  _createClass(PrivateRoute, [{
	    key: "downloadFile",
	    value: function downloadFile(referrer) {
	      var _this2 = this;
	
	      (0, _downloadFile3.default)(referrer).then(function () {
	        return _this2.setState({ downloadFinished: true });
	      }).catch(function (error) {
	        return _this2.setState({ downloadError: error.response.statusText });
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var isLoggedIn = this.props.isLoggedIn;
	      var referrer = this.state.referrer;
	
	
	      this.props.authUser(this.state.token);
	
	      if (isLoggedIn && referrer) {
	        this.downloadFile(referrer);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref) {
	      var prevIsLoggedIn = _ref.isLoggedIn;
	      var _props = this.props,
	          isLoggedIn = _props.isLoggedIn,
	          pathname = _props.location.pathname;
	      var referrer = this.state.referrer;
	
	
	      if (isLoggedIn !== prevIsLoggedIn && isLoggedIn && referrer) {
	        this.downloadFile(referrer);
	      }
	
	      if (prevIsLoggedIn !== isLoggedIn && !isLoggedIn) {
	        (0, _auth_actions.gotoSignIn)(pathname);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          Component = _props2.component,
	          isLoggedIn = _props2.isLoggedIn,
	          isLoading = _props2.isLoading,
	          classes = _props2.classes,
	          rest = _objectWithoutProperties(_props2, ["component", "isLoggedIn", "isLoading", "classes"]);
	
	      var _state = this.state,
	          referrer = _state.referrer,
	          fileName = _state.fileName,
	          downloadFinished = _state.downloadFinished,
	          downloadError = _state.downloadError;
	
	      return isLoading && !isLoggedIn ? _react2.default.createElement(
	        "div",
	        { className: classes.loadingWrapper },
	        _react2.default.createElement(
	          "span",
	          { className: classes.loadingMessage },
	          "Loading..."
	        )
	      ) : _react2.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
	        render: function render(props) {
	          return isLoggedIn ? referrer ? downloadFinished ? _react2.default.createElement(
	            "div",
	            { className: classes.loadingWrapper },
	            _react2.default.createElement(
	              "div",
	              { className: classes.loadingMessage },
	              "Downloaded",
	              _react2.default.createElement("br", null),
	              fileName
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.downloadNav },
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  to: '/dashboard',
	                  className: classes.item
	                },
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    className: classes.itemLink,
	                    variant: "outlined",
	                    color: "primary"
	                  },
	                  "Go to Dashboard"
	                )
	              ),
	              " or close this window"
	            )
	          ) : downloadError ? _react2.default.createElement(
	            "div",
	            { className: classes.loadingWrapper },
	            _react2.default.createElement(
	              "div",
	              { className: classes.loadingMessageError },
	              "Download error\xA0: ",
	              downloadError,
	              _react2.default.createElement("br", null),
	              fileName
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.downloadNav },
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  to: '/dashboard',
	                  className: classes.item
	                },
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    className: classes.itemLink,
	                    variant: "outlined",
	                    color: "primary"
	                  },
	                  "Go to Dashboard"
	                )
	              ),
	              " or close this window"
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { className: classes.loadingWrapper },
	            _react2.default.createElement(
	              "span",
	              { className: classes.loadingMessage },
	              "Downloading",
	              _react2.default.createElement(_CircularProgress2.default, {
	                disableShrink: true,
	                size: 20,
	                style: { marginLeft: 20 }
	              }),
	              _react2.default.createElement("br", null),
	              fileName
	            )
	          ) : _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, {
	            to: {
	              pathname: "/sign-in",
	              state: {
	                from: props.location,
	                referrer: referrer
	              }
	            }
	          });
	        }
	      }));
	    }
	  }]);
	
	  return PrivateRoute;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    isLoggedIn: state.auth.isLoggedIn,
	    isLoading: state.auth.isLoading
	  };
	};
	
	exports.default = (0, _core.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, { authUser: _auth_actions.authUser })(PrivateRoute));

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _red = __webpack_require__(91);
	
	var _red2 = _interopRequireDefault(_red);
	
	var _green = __webpack_require__(71);
	
	var _green2 = _interopRequireDefault(_green);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValueColorWrapper = function ValueColorWrapper(_ref) {
	  var children = _ref.children;
	
	  // We initialize color to inherit
	  var _useState = (0, _react.useState)("inherit"),
	      _useState2 = _slicedToArray(_useState, 2),
	      color = _useState2[0],
	      setColor = _useState2[1];
	  // We use this  custom hook to get the previous value of children
	
	
	  var prevValue = usePrevious(children);
	
	  children = parseInt(children, 10);
	
	  // This will compare values and update state accordingly
	  (0, _react.useEffect)(function () {
	    if (children > prevValue) {
	      setColor(_green2.default[800]);
	    } else if (children < prevValue) {
	      setColor(_red2.default[800]);
	    }
	  }, [children]);
	
	  if (isNaN(children) || children === null) {
	    return _react2.default.createElement(
	      "span",
	      { style: { color: "inherit" } },
	      "--"
	    );
	  }
	  return _react2.default.createElement(
	    "span",
	    { style: { color: color } },
	    children
	  );
	};
	
	// Custom hook to store previous value
	function usePrevious(value) {
	  var ref = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  }, [value]); // Only re-run if value changes
	
	  return ref.current;
	}
	
	exports.default = ValueColorWrapper;
	
	////////////////////////////////////////////////////////////////////////
	
	// export default class ValueColorWrapper extends Component {
	//   state = {
	//     color: "inherit"
	//   };
	
	//   componentDidUpdate = prevProps => {
	//     if (this.props.children !== prevProps.children) {
	//       if (this.props.children > prevProps.children) {
	//         this.setState({ color: green[800] });
	//       } else if (this.props.children < prevProps.children) {
	//         this.setState({ color: red[800] });
	//       }
	//     }
	//   };
	//   render = () => {
	//     let { children } = this.props;
	//     children = parseInt(children, 10);
	//     const { color } = this.state;
	
	//     if (isNaN(children) || children === null) {
	//       return React.createElement("span", { style: { color: "inherit" } }, "--");
	//     }
	//     return React.createElement("span", {
	//       style: {
	//         color
	//       },
	//       children
	//     });
	//   };
	// }
	
	//////////////////////////////////////////
	// import React, { Component } from "react";
	
	// export default class TextColorWrapper extends Component {
	//   state = {
	//     color: "inherit",
	//     unit: ""
	//   };
	
	//   componentDidUpdate = prevProps => {
	//     if (this.props.value !== prevProps.value) {
	//       if (this.props.value > prevProps.value) {
	//         this.setState({ color: "green" });
	//       } else if (this.props.value < prevProps.value) {
	//         this.setState({ color: "red" });
	//       }
	//     }
	//   };
	//   render() {
	//     const { value, unit } = this.props;
	
	//     if (isNaN(value) || value === null) {
	//       return <span> -- </span>;
	//     }
	//     return (
	//       <span style={{ color: this.state.color }}>
	//         {value} {unit}
	//       </span>
	//     );
	//   }
	// }

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(25);
	
	var _SF_EN_LOGO_BLANC = __webpack_require__(1015);
	
	var _SF_EN_LOGO_BLANC2 = _interopRequireDefault(_SF_EN_LOGO_BLANC);
	
	var _edfRenouvelables = __webpack_require__(1016);
	
	var _edfRenouvelables2 = _interopRequireDefault(_edfRenouvelables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-block',
	      verticalAlign: 'bottom',
	      color: '#FFFFFF'
	    },
	    by: {
	      display: 'inline-block',
	      verticalAlign: 'bottom',
	      margin: '0 .5em 3px 1em',
	      fontSize: '.7em'
	    },
	    logo: {
	      display: 'inline-block',
	      verticalAlign: 'bottom',
	      height: 30
	    }
	  };
	};
	
	function ByEdfSf(props) {
	  var classes = props.classes;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "a",
	      {
	        href: "https://edf-sf.com/",
	        target: "_blank",
	        className: classes.root,
	        title: "by EDF store & forecast. EDF group (new window)"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: classes.by },
	        "by"
	      ),
	      _react2.default.createElement("img", {
	        src: _SF_EN_LOGO_BLANC2.default,
	        alt: "EDF store & forecast. EDF group",
	        className: classes.logo
	      })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        href: "https://www.edf-renouvelables.com/",
	        target: "_blank",
	        className: classes.root,
	        title: "EDF renouvelables (new window)"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: classes.by },
	        "and"
	      ),
	      _react2.default.createElement("img", {
	        src: _edfRenouvelables2.default,
	        alt: "EDF renouvelables",
	        className: classes.logo
	      })
	    )
	  );
	}
	
	exports.default = (0, _styles.withStyles)(styles)(ByEdfSf);

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	var _styles = __webpack_require__(25);
	
	var _Drawer = __webpack_require__(189);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _pickers = __webpack_require__(231);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _List = __webpack_require__(52);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Divider = __webpack_require__(188);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _ListItem = __webpack_require__(65);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _core = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Material UI
	
	
	var styles = function styles(theme) {
	  return {
	    list: {
	      width: 250
	    },
	    filters: {
	      width: "auto"
	    },
	    title: {
	      marginLeft: theme.spacing(3)
	    },
	    container: {
	      display: "flex",
	      flexWrap: "wrap",
	      marginTop: theme.spacing(7)
	    },
	    textField: {
	      marginLeft: theme.spacing(1),
	      marginRight: theme.spacing(1),
	      width: 200
	    },
	    button: {
	      marginLeft: theme.spacing(3),
	      marginTop: theme.spacing(7)
	    }
	  };
	};
	
	var TemporaryDrawer = function (_React$Component) {
	  _inherits(TemporaryDrawer, _React$Component);
	
	  function TemporaryDrawer(props) {
	    _classCallCheck(this, TemporaryDrawer);
	
	    var _this = _possibleConstructorReturn(this, (TemporaryDrawer.__proto__ || Object.getPrototypeOf(TemporaryDrawer)).call(this, props));
	
	    _this.componentDidMount = function () {
	      var _this$props$tableDate = _this.props.tableDateRange,
	          startDate = _this$props$tableDate.startDate,
	          endDate = _this$props$tableDate.endDate;
	
	      _this.setState({
	        startDate: startDate.format(),
	        endDate: endDate.format()
	      });
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      if (_this.props.mode.realtime !== prevProps.mode.realtime) {
	        if (_this.props.mode.realtime) {
	          _this.setState({
	            startDate: (0, _moment2.default)().subtract(1, 'day').format(),
	            endDate: (0, _moment2.default)().format()
	          });
	        }
	      }
	    };
	
	    _this.handleEndDateChange = function (date) {
	      var targetEndDate = date.endOf('day');
	
	      var diff = date.diff((0, _moment2.default)(), 'second');
	
	      if (diff >= 0) {
	        _this.setState({
	          startDate: (0, _moment2.default)().subtract(1, 'day').format(),
	          endDate: (0, _moment2.default)().format()
	        });
	      } else {
	        _this.setState({
	          startDate: targetEndDate.clone().subtract(1, 'day').format(),
	          endDate: targetEndDate.format()
	        });
	      }
	    };
	
	    _this.handleFilterChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      _this.props.mode.realtime && _this.props.toggleMode();
	    };
	
	    _this.handleSubmitFilters = function (e) {
	      var _this$state = _this.state,
	          startDate = _this$state.startDate,
	          endDate = _this$state.endDate,
	          maxPkEnergy = _this$state.maxPkEnergy;
	      var realtime = _this.props.mode.realtime;
	
	
	      if (realtime) {
	        _this.props.toggleMode();
	      }
	
	      if (!maxPkEnergy) {
	        _this.setState({ maxPkEnergy: 0 });
	      }
	
	      var maxPkEnergyInt = parseInt(maxPkEnergy, 10) || 0;
	
	      _this.props.filterPeakShavingData(maxPkEnergyInt);
	      _this.props.changeTableDateRange({ startDate: (0, _moment2.default)(startDate), endDate: (0, _moment2.default)(endDate) });
	
	      _this.props.toggleDrawer();
	
	      // const filteredData = this.props.table.updatedData.filter(item => {
	      //   const time = item.timestamp || item.start;
	      //   const startUnix = moment(startDate).unix() * 1001;
	      //   const endUnix = moment(endDate).unix() * 1001;
	      //   if (item.customer_peak_max_kwh) {
	      //     return (
	      //       item.customer_peak_max_kwh > maxPkEnergyInt &&
	      //       inRange(time, startUnix, endUnix)
	      //     );
	      //   }
	      //   return inRange(time, startUnix, endUnix);
	      // });
	      // this.props.updateDisplayedData(filteredData);
	    };
	
	    _this.state = {
	      open: false,
	      startDate: '',
	      endDate: '',
	      maxPkEnergy: 0
	    };
	    return _this;
	  }
	
	  /*handleStartDateChange = date => {
	    this.setState({ startDate: date.format() });
	  };*/
	
	  _createClass(TemporaryDrawer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          classes = _props.classes,
	          open = _props.open,
	          toggleDrawer = _props.toggleDrawer;
	      var endDate = this.state.endDate;
	
	
	      var filters = _react2.default.createElement(
	        "div",
	        { className: classes.list },
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.title, variant: "h5", gutterBottom: true },
	          "Available Filters"
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          "form",
	          { className: classes.container, noValidate: true },
	          _react2.default.createElement(
	            _List2.default,
	            null,
	            _react2.default.createElement(
	              _ListItem2.default,
	              null,
	              _react2.default.createElement(_pickers.DatePicker, {
	                autoOk: true,
	                name: "endDate",
	                label: "Date"
	                //disableFuture
	                , value: endDate,
	                format: "DD/MM/YYYY",
	                onChange: function onChange(date) {
	                  return _this2.handleEndDateChange(date);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              variant: "contained",
	              id: "filter-button",
	              className: classes.button,
	              onClick: this.handleSubmitFilters
	            },
	            "Filter"
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _Drawer2.default,
	          { open: open, onClose: toggleDrawer },
	          _react2.default.createElement(
	            "div",
	            { tabIndex: 0, role: "button" },
	            filters
	          )
	        )
	      );
	    }
	  }]);
	
	  return TemporaryDrawer;
	}(_react2.default.Component);
	
	TemporaryDrawer.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    tableDateRange: state.tableDateRange,
	    mode: state.mode,
	    table: state.table
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, { changeTableDateRange: _actions.changeTableDateRange, toggleMode: _actions.toggleMode, filterPeakShavingData: _actions.filterPeakShavingData })(TemporaryDrawer));

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _List = __webpack_require__(52);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _DataTable = __webpack_require__(956);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _selected_table_data = __webpack_require__(172);
	
	var _selected_table_data2 = _interopRequireDefault(_selected_table_data);
	
	var _actions = __webpack_require__(35);
	
	var _styles = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    alarmList: {
	      margin: 0,
	      padding: 0,
	      listStyleType: 'none'
	    }
	  };
	};
	
	var TableContent = function (_React$Component) {
	  _inherits(TableContent, _React$Component);
	
	  function TableContent(props) {
	    _classCallCheck(this, TableContent);
	
	    var _this = _possibleConstructorReturn(this, (TableContent.__proto__ || Object.getPrototypeOf(TableContent)).call(this, props));
	
	    _this.setConfig = function () {
	      var _this$props = _this.props,
	          title = _this$props.title,
	          columns = _this$props.columns,
	          orderBy = _this$props.orderBy,
	          _this$props$order = _this$props.order,
	          order = _this$props$order === undefined ? 'desc' : _this$props$order,
	          updateData = _this$props.updateData,
	          updatedData = _this$props.updatedData;
	
	
	      _this.setState({
	        config: Object.assign({}, _this.state.config, {
	          columns: columns,
	          title: title,
	          orderBy: orderBy,
	          order: order
	        })
	      }, function () {
	        return updateData(updatedData);
	      });
	    };
	
	    _this.formatTableData = function (tableData) {
	      return tableData.map(function (item) {
	        if (item.values && item.values.length) {
	          item.alarmValue = _react2.default.createElement(
	            _List2.default,
	            { className: "alarmList" },
	            item.values.map(function (_ref) {
	              var title = _ref.title,
	                  value = _ref.value;
	
	              return _react2.default.createElement(
	                "li",
	                { key: "alarmList-" + title, className: "alarmListItem" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  title + " : " + (value ? 'ON' : 'OFF')
	                )
	              );
	            })
	          );
	        }
	        return item;
	      });
	    };
	
	    _this.state = {
	      config: {
	        padding: "default",
	        columns: [{
	          key: "displayTimestamp",
	          isNumeric: false,
	          padding: "default",
	          label: "Date"
	        }, {
	          key: "value",
	          isNumeric: false,
	          padding: "default",
	          label: "Status"
	        }],
	        search: '',
	        order: 'asc',
	        orderBy: '',
	        title: ''
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TableContent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setConfig();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          loading = _props.loading,
	          title = _props.title;
	
	      if (prevProps.loading && !loading || prevProps.title !== title) {
	        this.setConfig();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var tableData = this.props.tableData;
	      var config = this.state.config;
	
	
	      return _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, md: 9 },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_DataTable2.default, {
	            data: this.formatTableData(tableData),
	            config: config
	          })
	        )
	      );
	    }
	  }]);
	
	  return TableContent;
	}(_react2.default.Component);
	
	TableContent.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    tableData: (0, _selected_table_data2.default)(state)
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
	  updateData: _actions.updateData
	})(TableContent));

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tariff = function (_React$Component) {
	  _inherits(Tariff, _React$Component);
	
	  function Tariff() {
	    _classCallCheck(this, Tariff);
	
	    return _possibleConstructorReturn(this, (Tariff.__proto__ || Object.getPrototypeOf(Tariff)).apply(this, arguments));
	  }
	
	  _createClass(Tariff, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getTariffInfo();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return Tariff;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getTariffInfo: _actions.getTariffInfo
	})(Tariff);

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _styles = __webpack_require__(25);
	
	var _DataTableHead = __webpack_require__(957);
	
	var _DataTableHead2 = _interopRequireDefault(_DataTableHead);
	
	var _DataTableToolbar = __webpack_require__(958);
	
	var _DataTableToolbar2 = _interopRequireDefault(_DataTableToolbar);
	
	var _Table = __webpack_require__(133);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableBody = __webpack_require__(134);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(69);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableFooter = __webpack_require__(212);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TablePagination = __webpack_require__(214);
	
	var _TablePagination2 = _interopRequireDefault(_TablePagination);
	
	var _TableRow = __webpack_require__(88);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Material UI
	
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      width: "100%",
	      overflowX: "auto"
	    },
	    table: {
	      minWidth: 500
	    }
	  };
	};
	
	var DataTable = function (_React$Component) {
	  _inherits(DataTable, _React$Component);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));
	
	    _this.handleChangePage = function (event, page) {
	      _this.setState({ page: page });
	    };
	
	    _this.handleChangeRowsPerPage = function (event) {
	      _this.setState({ rowsPerPage: event.target.value });
	    };
	
	    _this.state = {
	      page: 0,
	      rowsPerPage: 100
	    };
	    return _this;
	  }
	
	  _createClass(DataTable, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          data = _props.data,
	          config = _props.config;
	      var _state = this.state,
	          page = _state.page,
	          rowsPerPage = _state.rowsPerPage;
	      var columns = config.columns,
	          order = config.order,
	          orderBy = config.orderBy,
	          title = config.title;
	
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        { className: classes.root },
	        _react2.default.createElement(_DataTableToolbar2.default, { title: title }),
	        _react2.default.createElement(
	          _Table2.default,
	          {
	            className: classes.table,
	            "aria-labelledby": "tableTitle",
	            padding: "default"
	          },
	          _react2.default.createElement(_DataTableHead2.default, {
	            data: this.props.data,
	            columns: columns,
	            order: order,
	            orderBy: orderBy
	          }),
	          _react2.default.createElement(
	            _TableBody2.default,
	            null,
	            data ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (dataItem, index) {
	              return _react2.default.createElement(
	                _TableRow2.default,
	                {
	                  hover: true,
	                  tabIndex: -1,
	                  key: index
	                },
	                columns.map(function (columnItem, columnIndex) {
	                  return _react2.default.createElement(
	                    _TableCell2.default,
	                    {
	                      key: columnIndex,
	                      padding: columnItem.padding
	                    },
	                    typeof dataItem[columnItem.key] === "number" && dataItem[columnItem.key] % 1 !== 0 ? parseFloat(dataItem[columnItem.key]).toFixed(2) : dataItem[columnItem.key]
	                  );
	                })
	              );
	            }) : _react2.default.createElement(
	              _TableRow2.default,
	              null,
	              "No Data To Display"
	            )
	          ),
	          _react2.default.createElement(
	            _TableFooter2.default,
	            null,
	            _react2.default.createElement(
	              _TableRow2.default,
	              null,
	              _react2.default.createElement(_TablePagination2.default, {
	                className: "pagination",
	                rowsPerPageOptions: [25, 100, 200],
	                count: data.length,
	                page: page,
	                rowsPerPage: rowsPerPage,
	                onChangePage: this.handleChangePage,
	                onChangeRowsPerPage: this.handleChangeRowsPerPage
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DataTable;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    batteryInformation: state.battery
	  };
	};
	
	DataTable.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  config: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {})(DataTable));

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	var _selected_table_data = __webpack_require__(172);
	
	var _selected_table_data2 = _interopRequireDefault(_selected_table_data);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(25);
	
	var _TableCell = __webpack_require__(69);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableHead = __webpack_require__(213);
	
	var _TableHead2 = _interopRequireDefault(_TableHead);
	
	var _TableRow = __webpack_require__(88);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableSortLabel = __webpack_require__(215);
	
	var _TableSortLabel2 = _interopRequireDefault(_TableSortLabel);
	
	var _Tooltip = __webpack_require__(89);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var DataTableHead = function (_React$Component) {
	  _inherits(DataTableHead, _React$Component);
	
	  function DataTableHead(props) {
	    _classCallCheck(this, DataTableHead);
	
	    var order = props.order,
	        orderBy = props.orderBy;
	
	    var _this = _possibleConstructorReturn(this, (DataTableHead.__proto__ || Object.getPrototypeOf(DataTableHead)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      order: order,
	      orderBy: orderBy
	    };
	    return _this;
	  }
	
	  _createClass(DataTableHead, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          order = _props.order,
	          orderBy = _props.orderBy,
	          data = _props.data,
	          sortColumn = _props.sortColumn;
	
	      sortColumn(data, orderBy, order);
	      this.setState({
	        order: order,
	        orderBy: orderBy
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props2 = this.props,
	          order = _props2.order,
	          orderBy = _props2.orderBy,
	          data = _props2.data,
	          sortColumn = _props2.sortColumn;
	      var prevOrder = prevProps.order,
	          prevOrderBy = prevProps.orderBy,
	          prevData = prevProps.data;
	
	
	      if (order !== prevOrder || orderBy !== prevOrderBy || data.length !== prevData.length) {
	        sortColumn(data, orderBy, order);
	        this.setState({
	          order: order,
	          orderBy: orderBy
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var columns = this.props.columns;
	      var _state = this.state,
	          order = _state.order,
	          orderBy = _state.orderBy;
	
	
	      return _react2.default.createElement(
	        _TableHead2.default,
	        null,
	        _react2.default.createElement(
	          _TableRow2.default,
	          null,
	          columns.map(function (column) {
	            return _react2.default.createElement(
	              _TableCell2.default,
	              {
	                key: column.key,
	                numeric: column.numeric,
	                padding: column.disablePadding ? "none" : "default",
	                sortDirection: orderBy === column.key ? order : false
	              },
	              _react2.default.createElement(
	                _Tooltip2.default,
	                {
	                  title: "Sort",
	                  placement: column.numeric ? "bottom-end" : "bottom-start",
	                  enterDelay: 300
	                },
	                _react2.default.createElement(
	                  _TableSortLabel2.default,
	                  {
	                    active: orderBy === column.key,
	                    direction: order,
	                    onClick: _this2.handleSort(column.key)
	                  },
	                  column.label
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return DataTableHead;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleSort = function (orderBy) {
	    return function () {
	      var _props3 = _this3.props,
	          order = _props3.table.sort.order,
	          data = _props3.data,
	          sortColumn = _props3.sortColumn;
	
	      var newOrder = order === "asc" ? "desc" : "asc";
	      _this3.setState({
	        order: newOrder,
	        orderBy: orderBy
	      });
	      sortColumn(data, orderBy, newOrder);
	    };
	  };
	};
	
	DataTableHead.propTypes = {
	  columns: _propTypes2.default.array.isRequired,
	  order: _propTypes2.default.string.isRequired,
	  orderBy: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    data: (0, _selected_table_data2.default)(state),
	    table: state.table
	  };
	};
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, { sortColumn: _actions.sortColumn })(DataTableHead));

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactCsv = __webpack_require__(856);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(25);
	
	var _Toolbar = __webpack_require__(53);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _IconButton = __webpack_require__(38);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Tooltip = __webpack_require__(89);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _FilterList = __webpack_require__(650);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	var _InsertDriveFile = __webpack_require__(230);
	
	var _InsertDriveFile2 = _interopRequireDefault(_InsertDriveFile);
	
	var _TemporaryDrawer = __webpack_require__(953);
	
	var _TemporaryDrawer2 = _interopRequireDefault(_TemporaryDrawer);
	
	var _selected_table_data = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      paddingRight: theme.spacing(1)
	    },
	    flex: {
	      flex: 1
	    },
	    actions: {
	      color: theme.palette.text.secondary
	    },
	    title: {
	      flex: "0 0 auto"
	    }
	  };
	};
	
	var DataTableToolbar = function (_React$PureComponent) {
	  _inherits(DataTableToolbar, _React$PureComponent);
	
	  function DataTableToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DataTableToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTableToolbar.__proto__ || Object.getPrototypeOf(DataTableToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isDrawerOpen: false
	    }, _this.toggleDrawer = function () {
	      _this.setState({ isDrawerOpen: !_this.state.isDrawerOpen });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DataTableToolbar, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          updatedData = _props.updatedData,
	          headers = _props.headers;
	
	
	      return _react2.default.createElement(
	        _Toolbar2.default,
	        { className: classes.root },
	        _react2.default.createElement(_TemporaryDrawer2.default, {
	          open: this.state.isDrawerOpen,
	          toggleDrawer: this.toggleDrawer
	        }),
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            component: "h5",
	            variant: "h5",
	            id: "tableTitle",
	            className: classes.flex
	          },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          updatedData.length ? _react2.default.createElement(
	            _Tooltip2.default,
	            { title: "Export To CSV" },
	            _react2.default.createElement(
	              _reactCsv.CSVLink,
	              {
	                headers: headers,
	                data: updatedData,
	                filename: "table-data.csv",
	                target: "_blank"
	              },
	              _react2.default.createElement(
	                _IconButton2.default,
	                { "aria-label": "Export to CSV" },
	                _react2.default.createElement(_InsertDriveFile2.default, null)
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            _Tooltip2.default,
	            { title: "Filter data" },
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                id: "open-drawer-icon",
	                "aria-label": "Filter list",
	                onClick: this.toggleDrawer
	              },
	              _react2.default.createElement(_FilterList2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DataTableToolbar;
	}(_react2.default.PureComponent);
	
	DataTableToolbar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    updatedData: (0, _selected_table_data.updatedDataSelector)(state),
	    headers: state.statusRange.headers
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {})(DataTableToolbar));

/***/ },
/* 959 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// TODO make it dynamic - UI needed
	// https://wiki.edf-sf.com/doku.php/engineering:identifiants_bdd
	
	exports.default = [
	// Number of cycle
	// Power with BESS
	{
	  type: 'meter',
	  id: 3,
	  agg: 'avg',
	  period: '15m'
	},
	// Power without BESS
	{
	  type: 'setpoint',
	  id: 12,
	  agg: 'avg',
	  period: '15m'
	},
	
	// Energy with BESS
	// Energy without BESS
	// SOC
	{
	  type: 'metric',
	  id: 15,
	  agg: 'avg',
	  period: '30s'
	},
	// Auxiliaries Consumption
	// Weather
	// Weather
	// Container T
	// Alarms
	
	// EEG - Energy charged
	// EEG - Energy discharged
	// EEG - Power charged
	{
	  type: 'battery',
	  id: 1,
	  agg: 'avg',
	  period: '30s'
	}];

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authorizeRequest = __webpack_require__(21);
	
	var _authorizeRequest2 = _interopRequireDefault(_authorizeRequest);
	
	var _getFileName = __webpack_require__(419);
	
	var _getFileName2 = _interopRequireDefault(_getFileName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (filePath) {
	  var fileName = (0, _getFileName2.default)(filePath);
	
	  return _axios2.default.get(filePath, Object.assign({}, (0, _authorizeRequest2.default)(), {
	    responseType: 'blob'
	  })).then(function (_ref) {
	    var data = _ref.data;
	
	    var downloadUrl = window.URL.createObjectURL(new Blob([data]));
	    var link = document.createElement('a');
	    link.href = downloadUrl;
	    link.setAttribute('download', fileName); //any other extension
	    document.body.appendChild(link);
	    link.click();
	    link.remove();
	  });
	};

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _connectedReactRouter = __webpack_require__(74);
	
	var _reducers = __webpack_require__(982);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _redux = __webpack_require__(113);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reduxThunk = __webpack_require__(1004);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _history = __webpack_require__(147);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _routes = __webpack_require__(989);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _moment = __webpack_require__(433);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(727);
	
	__webpack_require__(725);
	
	__webpack_require__(726);
	
	var _pickers = __webpack_require__(231);
	
	var _styles = __webpack_require__(25);
	
	var _Config = __webpack_require__(946);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// main style file
	
	// Nav
	var history = exports.history = (0, _history.createBrowserHistory)(); // theme css file
	
	// Store
	
	
	if (window.Cypress) {
	  window.tgHistory = history;
	}
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
	  trace: true,
	  traceLimit: 25
	}) || _redux.compose;
	
	function configureStore(preloadedState) {
	  return (0, _redux.createStore)((0, _reducers2.default)(history), preloadedState, (0, _redux.compose)(composeEnhancers((0, _redux.applyMiddleware)((0, _connectedReactRouter.routerMiddleware)(history), _reduxThunk2.default))));
	}
	
	var store = configureStore();
	
	// Store creation before connected-react-router
	// const store = createStore(
	//   rootReducer,
	//   composeEnhancers(applyMiddleware(thunk))
	// );
	
	if (window.Cypress) {
	  window.store = store;
	}
	
	var theme = (0, _styles.createMuiTheme)({
	  typography: {},
	  palette: {
	    primary: {
	      main: "#001A70"
	    },
	    secondary: {
	      main: "#ff4400",
	      contrastText: "#ffcc00"
	    },
	    tertiary: {
	      main: "#AAAAAA"
	    }
	  }
	});
	
	_reactDom2.default.render(_react2.default.createElement(
	  _react2.default.StrictMode,
	  null,
	  _react2.default.createElement(
	    _pickers.MuiPickersUtilsProvider,
	    { utils: _moment2.default },
	    _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        _connectedReactRouter.ConnectedRouter,
	        { history: history },
	        _react2.default.createElement(
	          _styles.MuiThemeProvider,
	          { theme: theme },
	          _react2.default.createElement(
	            _Config2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Switch,
	              null,
	              _routes2.default.map(function (prop, key) {
	                return _react2.default.createElement(_reactRouterDom.Route, {
	                  path: prop.path,
	                  component: prop.component,
	                  key: key
	                });
	              })
	            )
	          )
	        )
	      )
	    )
	  )
	), document.getElementById("root"));

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	var _AppBar = __webpack_require__(114);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CssBaseline = __webpack_require__(119);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _Toolbar = __webpack_require__(53);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(112);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _app = __webpack_require__(988);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _bkgWhiteLogoRegVivescia = __webpack_require__(728);
	
	var _bkgWhiteLogoRegVivescia2 = _interopRequireDefault(_bkgWhiteLogoRegVivescia);
	
	var _ErrorMessage = __webpack_require__(949);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _PrivateRoute = __webpack_require__(950);
	
	var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);
	
	var _byEdfSf = __webpack_require__(952);
	
	var _byEdfSf2 = _interopRequireDefault(_byEdfSf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles(theme) {
	  return {
	    "@global": {
	      body: {
	        backgroundColor: "#f7f7f7"
	      }
	    },
	    root: {
	      display: 'flex',
	      flexGrow: 1,
	      flexDirection: 'column'
	    },
	    appBar: {
	      position: "relative",
	      //backgroundColor: "#ffffff",
	      borderBottom: "1px solid #efefef",
	      boxShadow: "none",
	      minHeight: 60,
	      backgroundColor: "#001a70",
	      color: "#ffffff"
	    },
	    toolbarTitle: {
	      flex: 1
	    },
	    layout: _defineProperty({
	      width: "auto",
	      marginLeft: theme.spacing(3),
	      marginRight: theme.spacing(3)
	    }, theme.breakpoints.up(900 + theme.spacing(3 * 2)), {
	      width: 900,
	      marginLeft: "auto",
	      marginRight: "auto"
	    }),
	    heroContent: {
	      maxWidth: 600,
	      margin: "0 auto",
	      padding: theme.spacing(8) + "px 0 " + theme.spacing(6) + "px"
	    },
	    cardHeader: {
	      backgroundColor: theme.palette.grey[200]
	    },
	    cardPricing: {
	      display: "flex",
	      justifyContent: "center",
	      alignItems: "baseline",
	      marginBottom: theme.spacing(2)
	    },
	    cardActions: _defineProperty({}, theme.breakpoints.up("sm"), {
	      paddingBottom: theme.spacing(2)
	    }),
	    footer: {
	      marginTop: theme.spacing(8),
	      borderTop: "1px solid " + theme.palette.divider,
	      padding: theme.spacing(6) + "px 0"
	    },
	    icon: {
	      marginRight: theme.spacing(1)
	    },
	    item: {
	      textDecoration: "none",
	      marginRight: 5
	    },
	    itemLink: {
	      transition: "all 300ms linear",
	      borderRadius: "3px",
	      position: "relative",
	      color: "#ffffff",
	      backgroundColor: "transparent",
	      fontSize: "0.775rem",
	      paddingRight: 8,
	      paddingLeft: 8,
	      "&:hover": {
	        backgroundColor: theme.palette.secondary.main
	      },
	      ".active &": {
	        backgroundColor: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Dashboard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function () {
	      _this.props.logout();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Dashboard, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var classes = this.props.classes;
	
	
	      var links = _react2.default.createElement(
	        "div",
	        null,
	        this.props.error.open && _react2.default.createElement(_ErrorMessage2.default, null),
	        _app2.default.map(function (prop, key) {
	          if (prop.redirect || !prop.isSidebar) return null;
	
	          return _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            {
	              to: prop.navbarTo || prop.path,
	              className: classes.item + " " + prop.className,
	              activeClassName: "active",
	              key: key,
	              isActive: function isActive(match, location) {
	                return match || (0, _reactRouter.matchPath)(location.pathname, {
	                  path: prop.path,
	                  exact: true
	                });
	              }
	            },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: classes.itemLink },
	              _react2.default.createElement(prop.icon, { className: classes.icon }),
	              prop.sidebarName
	            )
	          );
	        })
	      );
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_CssBaseline2.default, null),
	        _react2.default.createElement(
	          _AppBar2.default,
	          { position: "static", color: "default", className: classes.appBar },
	          _react2.default.createElement(
	            _Toolbar2.default,
	            null,
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                variant: "h6",
	                color: "inherit",
	                noWrap: true,
	                className: classes.toolbarTitle
	              },
	              _react2.default.createElement("img", {
	                alt: "Malteurop Groupe VIVESCIA",
	                src: _bkgWhiteLogoRegVivescia2.default,
	                style: {
	                  display: 'inline-block',
	                  verticalAlign: 'bottom',
	                  height: 46
	                },
	                onClick: function onClick() {
	                  _this2.props.history.push("/dashboard");
	                }
	              }),
	              _react2.default.createElement(_byEdfSf2.default, null)
	            ),
	            links,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                id: "logout-button",
	                onClick: this.handleLogout,
	                variant: "outlined",
	                color: "secondary"
	              },
	              "Logout"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "main",
	          { className: classes.root },
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _app2.default.map(function (prop, key) {
	              return prop.private ? _react2.default.createElement(_PrivateRoute2.default, { path: prop.path, component: prop.component, key: key }) : _react2.default.createElement(_reactRouterDom.Route, { path: prop.path, component: prop.component, key: key });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    error: state.error
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, { logout: _actions.logout })(Dashboard));

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _lodash = __webpack_require__(27);
	
	var _actions = __webpack_require__(35);
	
	var _reactMaterialUiFormValidator = __webpack_require__(166);
	
	var _sfLogoBlue = __webpack_require__(1017);
	
	var _sfLogoBlue2 = _interopRequireDefault(_sfLogoBlue);
	
	var _Avatar = __webpack_require__(83);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CssBaseline = __webpack_require__(119);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _FormControl = __webpack_require__(85);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _FormControlLabel = __webpack_require__(123);
	
	var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);
	
	var _Checkbox = __webpack_require__(183);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _LockOutlined = __webpack_require__(653);
	
	var _LockOutlined2 = _interopRequireDefault(_LockOutlined);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(7);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Material UI
	
	
	var styles = function styles(theme) {
	  return {
	    main: _defineProperty({
	      width: "auto",
	      display: "block", // Fix IE 11 issue.
	      marginLeft: theme.spacing(3),
	      marginRight: theme.spacing(3)
	    }, theme.breakpoints.up(400 + theme.spacing(3 * 2)), {
	      width: 400,
	      marginLeft: "auto",
	      marginRight: "auto"
	    }),
	    paper: {
	      marginTop: theme.spacing(8),
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center",
	      padding: theme.spacing(2) + "px " + theme.spacing(3) + "px " + theme.spacing(3) + "px"
	    },
	    avatar: {
	      margin: theme.spacing(1),
	      backgroundColor: theme.palette.secondary.main
	    },
	    form: {
	      width: "100%", // Fix IE 11 issue.
	      marginTop: theme.spacing(1)
	    },
	    submit: {
	      marginTop: theme.spacing(3)
	    }
	  };
	};
	
	var SignIn = function (_React$Component) {
	  _inherits(SignIn, _React$Component);
	
	  function SignIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SignIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      username: '',
	      password: '',
	      rememberMe: false
	    }, _this.onUsernameChange = function (e) {
	      return _this.setState({ username: e.target.value });
	    }, _this.onPasswordChange = function (e) {
	      return _this.setState({ password: e.target.value });
	    }, _this.handleSubmit = function (event) {
	      var _this$state = _this.state,
	          username = _this$state.username,
	          password = _this$state.password;
	
	      _this.props.loginUser(username, password, _this.state.rememberMe);
	    }, _this.onRememberMeChange = function (e) {
	      _this.setState({ rememberMe: !_this.state.rememberMe });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SignIn, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isLoggedIn) {
	        var location = this.props.location;
	
	        this.props.gotoPathOrDashboard((0, _lodash.get)(location, 'state.from'));
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      if (prevProps.isLoggedIn !== this.props.isLoggedIn && this.props.isLoggedIn) {
	        var location = this.props.location;
	
	        this.props.gotoPathOrDashboard((0, _lodash.get)(location, 'state.from'));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          isLoggedIn = _props.isLoggedIn;
	      var _state = this.state,
	          rememberMe = _state.rememberMe,
	          username = _state.username,
	          password = _state.password;
	
	
	      return _react2.default.createElement(
	        "main",
	        { className: classes.main },
	        _react2.default.createElement(_CssBaseline2.default, null),
	        _react2.default.createElement(
	          _Paper2.default,
	          { className: classes.paper },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: _sfLogoBlue2.default, alt: "EDF Store and Forecast Logo" })
	          ),
	          _react2.default.createElement(
	            _Avatar2.default,
	            { className: classes.avatar },
	            _react2.default.createElement(_LockOutlined2.default, null)
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: "h1", variant: "h5" },
	            "Sign in"
	          ),
	          _react2.default.createElement(
	            _reactMaterialUiFormValidator.ValidatorForm,
	            {
	              onSubmit: this.handleSubmit,
	              onError: function onError(errors) {
	                return console.log(errors);
	              }
	            },
	            _react2.default.createElement(
	              _FormControl2.default,
	              { margin: "normal", required: true, fullWidth: true },
	              _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                id: "username",
	                label: "Username",
	                onChange: this.onUsernameChange,
	                name: "username",
	                value: username,
	                validators: ["required"],
	                errorMessages: ["this field is required"]
	              })
	            ),
	            _react2.default.createElement(
	              _FormControl2.default,
	              { margin: "normal", required: true, fullWidth: true },
	              _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                id: "password",
	                type: "password",
	                label: "Password",
	                onChange: this.onPasswordChange,
	                name: "password",
	                value: password,
	                validators: ["required"],
	                errorMessages: ["this field is required"]
	              })
	            ),
	            _react2.default.createElement(_FormControlLabel2.default, {
	              control: _react2.default.createElement(_Checkbox2.default, { value: "remember", color: "primary" }),
	              onChange: this.onRememberMeChange,
	              checked: rememberMe,
	              label: "Remember me"
	            }),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                id: "signin-button",
	                type: "submit",
	                fullWidth: true,
	                variant: "contained",
	                color: isLoggedIn !== false ? "primary" : "secondary",
	                className: classes.submit
	              },
	              isLoggedIn !== false ? "Sign in" : " Wrong User and/or Password"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignIn;
	}(_react2.default.Component);
	
	SignIn.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedIn: state.auth.isLoggedIn
	  };
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _withStyles2.default)(styles)((0, _reactRedux.connect)(mapStateToProps, { loginUser: _actions.loginUser, gotoPathOrDashboard: _actions.gotoPathOrDashboard })(SignIn)));

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1018);
	
	var _actions = __webpack_require__(35);
	
	var _config = __webpack_require__(171);
	
	var _OverviewChart = __webpack_require__(945);
	
	var _OverviewChart2 = _interopRequireDefault(_OverviewChart);
	
	var _ValueColorWrapper = __webpack_require__(951);
	
	var _ValueColorWrapper2 = _interopRequireDefault(_ValueColorWrapper);
	
	var _get_plc_status_word_1_alarm = __webpack_require__(993);
	
	var _get_plc_status_word_1_alarm2 = _interopRequireDefault(_get_plc_status_word_1_alarm);
	
	var _styles = __webpack_require__(25);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Card = __webpack_require__(116);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(117);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Table = __webpack_require__(133);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableBody = __webpack_require__(134);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(69);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableRow = __webpack_require__(88);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _green = __webpack_require__(71);
	
	var _green2 = _interopRequireDefault(_green);
	
	var _grey = __webpack_require__(90);
	
	var _grey2 = _interopRequireDefault(_grey);
	
	var _red = __webpack_require__(91);
	
	var _red2 = _interopRequireDefault(_red);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Material UI
	function useQuery() {
	  return new URLSearchParams((0, _reactRouterDom.useLocation)().search);
	}
	
	var styles = function styles() {
	  return {
	    negativeMargin: {
	      display: 'flex',
	      flexDirection: 'column',
	      flexGrow: 1,
	      padding: '20px'
	    },
	    root: {
	      flexGrow: 1
	    },
	    column: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'stretch'
	    },
	    card: {
	      flexGrow: 1
	    },
	    outline: {
	      fill: _grey2.default[700]
	    },
	    power: {
	      top: 40,
	      fill: _green2.default[500]
	    },
	    table: {},
	    soh: {
	      display: 'block'
	    },
	    alarmError: {
	      color: _red2.default[500]
	    }
	  };
	};
	
	function Dashboard(props) {
	  var classes = props.classes,
	      config = props.config.config,
	      isAtypical = props.isAtypical,
	      currentLoad = props.currentLoad,
	      setpoint = props.setpoint,
	      genericPmax = props.genericPmax,
	      pMaxOffPeak = props.pMaxOffPeak,
	      pMaxOnPeak = props.pMaxOnPeak,
	      pMaxLoad = props.pMaxLoad,
	      pMaxLoadWithoutBess = props.pMaxLoadWithoutBess,
	      bessInstantPower = props.bessInstantPower,
	      bessStatus = props.bessStatus,
	      soc = props.soc,
	      soh = props.soh,
	      genericPRef = props.genericPRef,
	      realtime = props.realtime,
	      startDate = props.startDate,
	      endDate = props.endDate,
	      plcStatusWord1Alarm = props.plcStatusWord1Alarm;
	
	
	  var query = useQuery();
	
	  var populateState = function populateState() {
	    props.getCurrentStatus();
	    props.getSiteData();
	    props.getAsset();
	  };
	
	  var getDeviation = function getDeviation(value1, value2) {
	    return {
	      percentage: Math.round((1 - value1 / value2) * 100),
	      power: Math.round(value2 - value1)
	    };
	  };
	
	  var setRealtimeDateRange = function setRealtimeDateRange() {
	    var start = (0, _moment2.default)().subtract(24, "h").startOf('hour');
	    var end = (0, _moment2.default)();
	    props.changeDateRange({ startDate: start, endDate: end }, true);
	  };
	
	  var setRealtimeInterval = function setRealtimeInterval() {
	    setRealtimeDateRange();
	    return setInterval(function () {
	      props.getSiteData();
	      props.getCurrentStatus();
	      setRealtimeDateRange();
	    }, 30000);
	  };
	
	  (0, _react.useEffect)(function () {
	    var startDateQuery = parseInt(query.get('startDate'), 10);
	    var endDateQuery = parseInt(query.get('endDate'), 10);
	
	    if (!startDateQuery && !endDateQuery && !realtime) {
	      props.toggleMode();
	    } else if (startDateQuery && endDateQuery) {
	      props.changeDateRange({
	        startDate: (0, _moment2.default)(startDateQuery),
	        endDate: (0, _moment2.default)(endDateQuery)
	      }, false);
	    }
	
	    populateState();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (startDate && endDate) {
	      props.getChartData();
	    }
	  }, [startDate, endDate]);
	
	  (0, _react.useEffect)(function () {
	    var realtimeIntervalId = void 0;
	
	    if (realtime) {
	      realtimeIntervalId = setRealtimeInterval();
	    }
	
	    return function () {
	      return clearInterval(realtimeIntervalId);
	    };
	  }, [realtime]);
	
	  var handleBESSStatus = function handleBESSStatus(batteryState) {
	    switch (batteryState) {
	      case 0:
	        return "Disabled";
	      case 1:
	        return "Offline";
	      case 2:
	        return "Stand by";
	      case 3:
	        return "Charging";
	      case 4:
	        return "Discharging";
	      case 5:
	        return "Islanding Mode";
	      case null:
	      case undefined:
	        return "--";
	      default:
	        return "Available";
	    }
	  };
	
	  var deviation = isAtypical ? getDeviation(pMaxOnPeak, pMaxOffPeak) : getDeviation(pMaxLoad, pMaxLoadWithoutBess);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: classes.negativeMargin },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 3, className: classes.root },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 3, className: classes.column },
	          _react2.default.createElement(
	            _Card2.default,
	            { className: classes.card },
	            _react2.default.createElement(
	              _CardContent2.default,
	              { className: classes.content },
	              _react2.default.createElement(
	                _Typography2.default,
	                {
	                  component: "h5",
	                  variant: "h5",
	                  style: { marginBottom: 15, textAlign: "center" }
	                },
	                config.SITE_NAME
	              ),
	              _react2.default.createElement(
	                _Table2.default,
	                { className: classes.table, padding: "default" },
	                _react2.default.createElement(
	                  _TableBody2.default,
	                  null,
	                  _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      "Current Load"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      _react2.default.createElement(
	                        _ValueColorWrapper2.default,
	                        null,
	                        Math.round(currentLoad) || '--'
	                      ),
	                      " ",
	                      "kW"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      "Setpoint"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      _react2.default.createElement(
	                        _ValueColorWrapper2.default,
	                        null,
	                        Math.round(setpoint)
	                      ),
	                      "\xA0kW"
	                    )
	                  ),
	                  !isAtypical && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      _TableRow2.default,
	                      null,
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        "P Ref"
	                      ),
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        genericPRef,
	                        " kW"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _TableRow2.default,
	                      null,
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        "P Max"
	                      ),
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        genericPmax && Math.round(genericPmax) || '--',
	                        " kW"
	                      )
	                    )
	                  ),
	                  isAtypical && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      _TableRow2.default,
	                      null,
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        "Pmax off peak"
	                      ),
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        Math.round(pMaxOffPeak) || '--',
	                        "\xA0kW"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _TableRow2.default,
	                      null,
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        "Pmax on peak"
	                      ),
	                      _react2.default.createElement(
	                        _TableCell2.default,
	                        null,
	                        Math.round(pMaxOnPeak) || '--',
	                        "\xA0kW"
	                      )
	                    )
	                  ) || null,
	                  _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      "Current Deviation"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      (0, _lodash.isNaN)(deviation.percentage) ? '--' : deviation.percentage,
	                      "\xA0%",
	                      _react2.default.createElement("br", null),
	                      (0, _lodash.isNaN)(deviation.percentage) ? '--' : deviation.power,
	                      "\xA0kW"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      "BESS Instant Power"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      _react2.default.createElement(
	                        _ValueColorWrapper2.default,
	                        null,
	                        Math.round(bessInstantPower)
	                      ),
	                      "\xA0kW"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      "BESS Status"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      null,
	                      handleBESSStatus(bessStatus)
	                    )
	                  ),
	                  plcStatusWord1Alarm ? _react2.default.createElement(
	                    _TableRow2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      {
	                        className: plcStatusWord1Alarm ? classes.alarmError : ''
	                      },
	                      "Alarm"
	                    ),
	                    _react2.default.createElement(
	                      _TableCell2.default,
	                      {
	                        className: plcStatusWord1Alarm ? classes.alarmError : ''
	                      },
	                      plcStatusWord1Alarm ? 'ON' : 'Off'
	                    )
	                  ) : null
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { maxWidth: "70%", margin: "0 auto" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: { position: "relative", margin: "16px 0 0 " }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        position: "absolute",
	                        left: "43%",
	                        top: "43%"
	                      }
	                    },
	                    soc || soc === 0 ? Math.round(soc) + " %" : '--'
	                  ),
	                  _react2.default.createElement(
	                    "svg",
	                    {
	                      id: "Layer_1",
	                      "data-name": "Layer 1",
	                      xmlns: "http://www.w3.org/2000/svg",
	                      viewBox: "0 0 257.13 142.85"
	                    },
	                    _react2.default.createElement("defs", null),
	                    _react2.default.createElement(
	                      "title",
	                      null,
	                      "battery"
	                    ),
	                    _react2.default.createElement("path", {
	                      className: classes.outline,
	                      d: "M257.13,92.85a14.24,14.24,0,0,1-14.29,14.29V125A17.91,17.91,0,0,1,225,142.85H17.86A17.91,17.91,0,0,1,0,125V17.86A17.91,17.91,0,0,1,17.86,0H225a17.91,17.91,0,0,1,17.86,17.86V35.71A14.24,14.24,0,0,1,257.13,50Zm-14.29,0V50H228.56V17.86A3.53,3.53,0,0,0,225,14.29H17.86a3.52,3.52,0,0,0-3.57,3.57V125a3.52,3.52,0,0,0,3.57,3.57H225a3.53,3.53,0,0,0,3.57-3.57V92.85Z"
	                    }),
	                    _react2.default.createElement("rect", {
	                      className: classes.power,
	                      x: "23",
	                      y: "23",
	                      width: soc * 2,
	                      height: "96"
	                    })
	                  )
	                ),
	                soh !== null && _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    component: "p",
	                    style: { marginTop: 5, marginBottom: 0, textAlign: "center", display: 'block' }
	                  },
	                  "Battery health : ",
	                  Math.round(soh),
	                  "%"
	                ) || null
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 9, className: classes.column },
	          _react2.default.createElement(_OverviewChart2.default, null)
	        )
	      )
	    )
	  );
	}
	
	Dashboard.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentLoad: state.siteData.currentLoad,
	    setpoint: state.siteData.setpoint,
	    genericPmax: state.siteData.genericPmax,
	    pMaxOffPeak: state.siteData.pMaxOffPeak,
	    pMaxOnPeak: state.siteData.pMaxOnPeak,
	    pMaxLoad: state.siteData.pMaxLoad,
	    pMaxLoadWithoutBess: state.siteData.pMaxLoadWithoutBess,
	    bessInstantPower: state.siteData.bessInstantPower,
	    bessStatus: state.siteData.bessStatus,
	    soc: state.siteData.soc,
	    soh: state.siteData.soh,
	    genericPRef: state.asset.peak_shaving_generic.p_ref_kw,
	    realtime: state.mode.realtime,
	    siteData: state.siteData,
	    config: (0, _config.getConfig)(state),
	    isAtypical: state.config.config.ATYPICAL,
	    startDate: state.dateRange.startDate,
	    endDate: state.dateRange.endDate,
	    plcStatusWord1Alarm: (0, _get_plc_status_word_1_alarm2.default)(state)
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
	  getAsset: _actions.getAsset,
	  getChartData: _actions.getChartData,
	  getSiteData: _actions.getSiteData,
	  changeDateRange: _actions.changeDateRange,
	  getCurrentStatus: _actions.getCurrentStatus,
	  toggleMode: _actions.toggleMode
	})(Dashboard));

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(44);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(27);
	
	var _actions = __webpack_require__(35);
	
	var _tableContent = __webpack_require__(954);
	
	var _tableContent2 = _interopRequireDefault(_tableContent);
	
	var _get_unavailabilities = __webpack_require__(994);
	
	var _get_unavailabilities2 = _interopRequireDefault(_get_unavailabilities);
	
	var _get_battery_status = __webpack_require__(991);
	
	var _get_battery_status2 = _interopRequireDefault(_get_battery_status);
	
	var _get_generic_ps = __webpack_require__(992);
	
	var _get_generic_ps2 = _interopRequireDefault(_get_generic_ps);
	
	var _get_atypical_ps = __webpack_require__(990);
	
	var _get_atypical_ps2 = _interopRequireDefault(_get_atypical_ps);
	
	var _styles = __webpack_require__(25);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _CircularProgress = __webpack_require__(62);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Card = __webpack_require__(116);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(117);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _DateRange = __webpack_require__(140);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _List = __webpack_require__(52);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(65);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(125);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Material UI
	
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      padding: 20
	    },
	    active: {
	      backgroundColor: "#005bbb",
	      "& span": {
	        color: "#ffffff"
	      },
	      "&:focus": {
	        backgroundColor: "#005bbb"
	      },
	      "&:hover": {
	        backgroundColor: "#005bbb"
	      }
	    },
	    disabled: {
	      display: 'none',
	      opacity: .5
	    }
	  };
	};
	
	var dataSets = [{
	  title: "Alarms / Events"
	}, {
	  title: "EMS Unavailability",
	  disabled: true
	}, {
	  title: "Battery Status",
	  disabled: true
	}, {
	  title: "Peak Shaving",
	  disabled: true
	}];
	
	var alarmUpdatedTitle = "Alarms / Events";
	var alarmUpdatedColumns = [{
	  key: "displayTimestamp",
	  isNumeric: false,
	  padding: "default",
	  label: "Date"
	}, {
	  key: "alarmName",
	  isNumeric: false,
	  padding: "default",
	  label: "ID"
	}, {
	  key: "alarmValue",
	  isNumeric: false,
	  padding: "default",
	  label: "Status"
	}];
	
	var DataViewer = function (_React$Component) {
	  _inherits(DataViewer, _React$Component);
	
	  function DataViewer(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, DataViewer);
	
	    var _this = _possibleConstructorReturn(this, (DataViewer.__proto__ || Object.getPrototypeOf(DataViewer)).call(this, props));
	
	    _this.getContent = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(startDate, endDate) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.props.getStatus(startDate, endDate);
	
	              case 2:
	                _this.props.getTableBatteryInfo();
	                _this.props.getUnavailabilities();
	                _this.props.getPSAtypical();
	                _this.props.getPSGeneric();
	
	              case 6:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props, startDate, endDate;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props = _this.props, startDate = _this$props.startDate, endDate = _this$props.endDate;
	
	              _this.getContent(startDate, endDate);
	              _this.setContent(_this.getTabId());
	
	            case 3:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var currentTabId = _this.getTabId();
	
	      if (currentTabId !== selectedIndex) {
	        _this.setContent(currentTabId);
	      }
	
	      var prevStartDate = prevProps.startDate.format();
	      var startDate = _this.props.startDate.format();
	      var prevEndDate = prevProps.endDate.format();
	      var endDate = _this.props.endDate.format();
	
	      if (prevStartDate !== startDate || prevEndDate !== endDate) {
	        var _this$props2 = _this.props,
	            _startDate = _this$props2.startDate,
	            _endDate = _this$props2.endDate;
	
	        _this.getContent(_startDate, _endDate);
	      }
	    };
	
	    _this.getTabId = function () {
	      return parseInt((0, _lodash.get)(_this.props.match, 'params.tabId', null), 10);
	    };
	
	    _this.setContent = function (index) {
	      return _this.setState({ selectedIndex: index });
	    };
	
	    _this.handleListItemClick = function (event, index) {
	      return _this.props.changeTab('op-data', index);
	    };
	
	    _this.getMainContent = function () {
	      var _this$props3 = _this.props,
	          loadingUnavailabilities = _this$props3.loadingUnavailabilities,
	          unavailabilities = _this$props3.unavailabilities,
	          status = _this$props3.status,
	          loadingStatus = _this$props3.loadingStatus,
	          tableBattery = _this$props3.tableBattery,
	          loadingBatteryStatus = _this$props3.loadingBatteryStatus,
	          isAtypical = _this$props3.isAtypical,
	          genericPS = _this$props3.genericPS,
	          atypicalPS = _this$props3.atypicalPS,
	          loadingAtypicalPs = _this$props3.loadingAtypicalPs,
	          loadingGenericPs = _this$props3.loadingGenericPs;
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      switch (selectedIndex) {
	        case 1:
	          // EMS Unavailabilities
	          return _react2.default.createElement(_tableContent2.default, {
	            title: "EMS Unavailability",
	            columns: [{
	              key: "displayStart",
	              isNumeric: false,
	              padding: "default",
	              label: "Start"
	            }, {
	              key: "displayEnd",
	              isNumeric: false,
	              padding: "default",
	              label: "End"
	            }],
	            orderBy: "displayStart",
	            order: "desc",
	            loading: loadingUnavailabilities,
	            updatedData: unavailabilities
	          });
	        case 2:
	          // Battery Unavailability
	          return _react2.default.createElement(_tableContent2.default, {
	            title: "Battery Status",
	            columns: [{
	              key: "displayTimestamp",
	              isNumeric: false,
	              padding: "default",
	              label: "Date"
	            }, {
	              key: "displayState",
	              isNumeric: false,
	              padding: "default",
	              label: "State"
	            }],
	            orderBy: "displayTimestamp",
	            order: "desc",
	            loading: loadingBatteryStatus,
	            updatedData: tableBattery
	          });
	        case 3:
	          // Peak Shaving
	          var updatedColumns = isAtypical ? [{
	            key: "displayTimestamp",
	            isNumeric: false,
	            padding: "default",
	            label: "Date"
	          }, {
	            key: "peak_s",
	            isNumeric: false,
	            padding: "default",
	            label: "Peak Duration Seconds"
	          }, {
	            key: "bess_extracted_kwh",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Customer Meter (kW)"
	          }, {
	            key: "displaySuccess",
	            isNumeric: false,
	            padding: "default",
	            label: "Maintened Meter Below Pmax"
	          }, {
	            key: "customer_p_max_no_bess_kw",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Power Without BESS (kW)"
	          }, {
	            key: "customer_peak_max_mn",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Peak Duration (min)"
	          }, {
	            key: "customer_peak_max_kwh",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Peak Energy (kWh)"
	          }, {
	            key: "customer_deviation",
	            isNumeric: false,
	            padding: "default",
	            label: "Deviation (%)"
	          }, {
	            key: "customer_deviation_no_bess",
	            isNumeric: false,
	            padding: "default",
	            label: "Deviation Without BESS (%)"
	          }] : [{
	            key: "displayTimestamp",
	            isNumeric: false,
	            padding: "default",
	            label: "Date"
	          }, {
	            key: "peak_s",
	            isNumeric: false,
	            padding: "default",
	            label: "Peak Duration Seconds"
	          }, {
	            key: "customer_next_p_max_kw",
	            isNumeric: false,
	            padding: "default",
	            label: "Customer Next PMax (kW)"
	          }, {
	            key: "bess_extracted_kwh",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Customer Meter (kW)"
	          }, {
	            key: "displaySuccess",
	            isNumeric: false,
	            padding: "default",
	            label: "Maintened Meter Below Pmax"
	          }, {
	            key: "customer_p_max_no_bess_kw",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Power Without BESS (kW)"
	          }, {
	            key: "customer_peak_max_mn",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Peak Duration (min)"
	          }, {
	            key: "customer_peak_max_kwh",
	            isNumeric: false,
	            padding: "default",
	            label: "Max Peak Energy (kWh)"
	          }];
	
	          return _react2.default.createElement(_tableContent2.default, {
	            title: "Peak Shaving",
	            columns: updatedColumns,
	            orderBy: "displayTimestamp",
	            order: "desc",
	            loading: isAtypical ? loadingAtypicalPs : loadingGenericPs,
	            updatedData: isAtypical ? atypicalPS : genericPS
	          });
	        default:
	          // Alarms / Events
	          return _react2.default.createElement(_tableContent2.default, {
	            title: alarmUpdatedTitle,
	            columns: alarmUpdatedColumns,
	            orderBy: "displayTimestamp",
	            order: "desc",
	            loading: loadingStatus,
	            updatedData: status
	          });
	      }
	    };
	
	    _this.state = {
	      selectedIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(DataViewer, [{
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          classes = _props.classes,
	          loading = _props.loading,
	          loadingAlarms = _props.loadingAlarms,
	          startDate = _props.startDate,
	          endDate = _props.endDate;
	
	      var displayStart = (0, _moment2.default)(startDate).format("DD/MM/YYYY");
	      var displayEnd = (0, _moment2.default)(endDate).format("DD/MM/YYYY");
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes.root },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 3 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12, md: 3 },
	            _react2.default.createElement(
	              _Card2.default,
	              null,
	              _react2.default.createElement(
	                _CardContent2.default,
	                null,
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { gutterBottom: true, variant: "h5", style: { float: "left" } },
	                  "Available Data"
	                ),
	                (loading || loadingAlarms) && _react2.default.createElement(_CircularProgress2.default, {
	                  disableShrink: true,
	                  size: 20,
	                  style: { marginLeft: 20 }
	                }),
	                _react2.default.createElement(
	                  _Grid2.default,
	                  { container: true },
	                  _react2.default.createElement(
	                    _Grid2.default,
	                    { item: true, xs: 1 },
	                    _react2.default.createElement(_DateRange2.default, { fontSize: "small" })
	                  ),
	                  _react2.default.createElement(
	                    _Grid2.default,
	                    { item: true, xs: 11 },
	                    _react2.default.createElement(
	                      _Typography2.default,
	                      { variant: "caption" },
	                      displayStart + " - " + displayEnd
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { component: "nav" },
	                  dataSets.map(function (_ref3, index) {
	                    var archive = _ref3.title,
	                        disabled = _ref3.disabled;
	                    return _react2.default.createElement(
	                      _ListItem2.default,
	                      {
	                        key: archive,
	                        className: (0, _classnames2.default)(_this3.state.selectedIndex === index ? classes.active : "", disabled ? classes.disabled : ''),
	                        button: !disabled,
	                        onClick: function onClick(event) {
	                          return !disabled && _this3.handleListItemClick(event, index);
	                        }
	                      },
	                      _react2.default.createElement(
	                        _ListItemText2.default,
	                        null,
	                        archive
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          this.getMainContent()
	        )
	      );
	    }
	  }]);
	
	  return DataViewer;
	}(_react2.default.Component);
	
	DataViewer.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    genericPS: (0, _get_generic_ps2.default)(state),
	    atypicalPS: (0, _get_atypical_ps2.default)(state),
	    status: state.statusRange.status,
	    headers: state.statusRange.headers,
	    startDate: state.tableDateRange.startDate,
	    endDate: state.tableDateRange.endDate,
	    loading: state.mode.loading,
	    loadingAlarms: state.mode.alarms,
	    tableBattery: (0, _get_battery_status2.default)(state),
	    loadingUnavailabilities: state.mode.unavailabilities,
	    loadingStatus: state.mode.status,
	    unavailabilities: (0, _get_unavailabilities2.default)(state),
	    loadingBatteryStatus: state.mode.batteryStatus,
	    loadingAtypicalPs: state.mode.atypicalPs,
	    loadingGenericPs: state.mode.genericPs,
	    isAtypical: state.config.config.ATYPICAL
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
	  getStatus: _actions.getStatus,
	  getTableBatteryInfo: _actions.getTableBatteryInfo,
	  getUnavailabilities: _actions.getUnavailabilities,
	  getPSAtypical: _actions.getPSAtypical,
	  getPSGeneric: _actions.getPSGeneric,
	  changeTab: _actions.changeTab
	})(DataViewer));

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(35);
	
	var _reactMaterialUiFormValidator = __webpack_require__(166);
	
	var _CustomTextField = __webpack_require__(948);
	
	var _CustomTextField2 = _interopRequireDefault(_CustomTextField);
	
	var _tariff = __webpack_require__(955);
	
	var _tariff2 = _interopRequireDefault(_tariff);
	
	var _config = __webpack_require__(171);
	
	var _chart_data_reducer = __webpack_require__(170);
	
	var _lodash = __webpack_require__(27);
	
	var _styles = __webpack_require__(25);
	
	var _Grid = __webpack_require__(42);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(14);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Toolbar = __webpack_require__(53);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _AppBar = __webpack_require__(114);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Tabs = __webpack_require__(135);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tab = __webpack_require__(132);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Button = __webpack_require__(29);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _IconButton = __webpack_require__(38);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Edit = __webpack_require__(648);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _DateRange = __webpack_require__(140);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _List = __webpack_require__(52);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(65);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(125);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _ListItemAvatar = __webpack_require__(196);
	
	var _ListItemAvatar2 = _interopRequireDefault(_ListItemAvatar);
	
	var _Avatar = __webpack_require__(83);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Material UI
	
	
	var styles = function styles(theme) {
	  return {
	    card: {
	      minWidth: 275,
	      maxWidth: 800,
	      margin: "0 auto"
	    },
	    input: {
	      margin: theme.spacing(1)
	    },
	    flex: {
	      flex: 1
	    },
	    toolbar: {
	      borderBottom: "1px solid #e5e5e5"
	    },
	    root: {
	      minWidth: 300,
	      maxWidth: 800,
	      margin: "0 auto"
	    },
	    actionContainer: {
	      textAlign: "right",
	      "& button": {
	        margin: 10
	      }
	    },
	    disabledTab: {
	      display: 'none'
	    }
	  };
	};
	
	var SiteInformation = function (_Component) {
	  _inherits(SiteInformation, _Component);
	
	  function SiteInformation(props) {
	    _classCallCheck(this, SiteInformation);
	
	    var _this = _possibleConstructorReturn(this, (SiteInformation.__proto__ || Object.getPrototypeOf(SiteInformation)).call(this, props));
	
	    _this.updateSiteDetails = function () {
	      var _this$props = _this.props,
	          siteName = _this$props.siteName,
	          isAtypical = _this$props.isAtypical,
	          pMax = _this$props.pMax;
	
	      _this.setState(Object.assign({}, _this.state, {
	        siteName: siteName,
	        isAtypical: isAtypical,
	        pMax: pMax
	      }));
	    };
	
	    _this.componentDidUpdate = function (prevProps, prevState) {
	      var prevSiteName = prevProps.siteName,
	          prevIsAtypical = prevProps.isAtypical,
	          prevPMax = prevProps.pMax;
	      var _this$props2 = _this.props,
	          siteName = _this$props2.siteName,
	          isAtypical = _this$props2.isAtypical,
	          pMax = _this$props2.pMax;
	
	      var newState = {};
	
	      if (prevSiteName !== siteName) {
	        newState.siteName = siteName;
	      }
	
	      if (prevIsAtypical !== isAtypical) {
	        newState.isAtypical = isAtypical;
	      }
	
	      if (prevPMax !== pMax) {
	        newState.pMax = pMax;
	      }
	
	      if (Object.keys(newState).length) {
	        _this.setState(function (state) {
	          return Object.assign({}, state, newState);
	        });
	      }
	
	      if (_this.state.value !== prevState.value) {
	        if (_this.state.value === 4) {
	          _this.setState({ saveEnabled: false, saveCustomPwdEnabled: false });
	        }
	      }
	      if (_this.props.permissions !== prevProps.permissions) {
	        var _this$props$permissio = _this.props.permissions,
	            operator = _this$props$permissio.operator,
	            customer = _this$props$permissio.customer;
	
	        _this.setState(function (state) {
	          return Object.assign({}, state, {
	            file: Object.assign({}, state.file, {
	              permissions: {
	                operator: operator,
	                customer: customer
	              }
	            })
	          });
	        });
	      }
	    };
	
	    _this.getTabId = function () {
	      return parseInt((0, _lodash.get)(_this.props.match, 'params.tabId', null), 10);
	    };
	
	    _this.handleSave = function () {
	      var _this$state = _this.state,
	          currentPassword = _this$state.currentPassword,
	          passwordOperator = _this$state.passwordOperator,
	          passwordCustomer = _this$state.passwordCustomer;
	
	
	      var value = _this.getTabId();
	
	      if (value === 4) {
	        _this.props.saveNewPasswords(currentPassword, passwordOperator, passwordCustomer);
	        _this.setState({
	          currentPassword: '',
	          passwordOperator: '',
	          passwordOperator2: '',
	          passwordCustomer: '',
	          passwordCustomer2: ''
	        });
	      } else {
	        _this.props.saveToJSONFile(_this.state.file.asset);
	      }
	    };
	
	    _this.renderSaveButton = function (classes) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: "submit",
	            variant: "contained",
	            color: "primary",
	            className: classes.button,
	            disabled: !_this.state.saveEnabled
	          },
	          "Save"
	        )
	      );
	    };
	
	    _this.renderSaveCustomPwdButton = function (classes) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: "submit"
	            //onClick={this.handleSave}
	            , variant: "contained",
	            color: "primary",
	            className: classes.button,
	            disabled: !_this.state.saveCustomPwdEnabled
	          },
	          "Save"
	        )
	      );
	    };
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleTextChange = function (name, value) {
	      //const { name, value } = event.target;
	      _this.setState(function (state) {
	        return {
	          file: Object.assign({}, state.file, {
	            asset: Object.assign({}, state.file.asset, _defineProperty({}, name, value))
	          })
	        };
	      });
	    };
	
	    _this.handleNestedTextChange = function (name, value, type) {
	      var _name$split = name.split("."),
	          _name$split2 = _slicedToArray(_name$split, 2),
	          parent = _name$split2[0],
	          child = _name$split2[1];
	
	      _this.setState(function (state) {
	        return {
	          file: Object.assign({}, state.file, {
	            asset: Object.assign({}, state.file.asset, _defineProperty({}, parent, Object.assign({}, state.file.asset[parent], _defineProperty({}, child, type === 'number' ? parseInt(value, 10) : value))))
	          })
	        };
	      });
	    };
	
	    _this.handleChangeIndex = function (event, index) {
	      return _this.props.changeTab('site', index);
	    };
	
	    _this.getSeason = function (season) {
	      var _this$props3 = _this.props,
	          classes = _this$props3.classes,
	          tariff = _this$props3.tariff;
	
	
	      var twoDigit = function twoDigit(value) {
	        return value < 10 ? "0" + value : value;
	      };
	      var seasonData = (0, _lodash.get)(tariff, "[" + season + "].values");
	      var seasonMonths = (0, _lodash.get)(tariff, "[" + season + "].months");
	
	      return seasonMonths && _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 6, key: season },
	        _react2.default.createElement(
	          "h3",
	          null,
	          (0, _lodash.capitalize)(season),
	          " peak periods"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          (0, _lodash.capitalize)(seasonMonths[0]) + " - " + (0, _lodash.capitalize)(seasonMonths[1])
	        ),
	        _react2.default.createElement(
	          _List2.default,
	          { className: classes.root },
	          seasonData ? seasonData.map(function (_ref, index) {
	            var start = _ref.start,
	                end = _ref.end;
	            return _react2.default.createElement(
	              _ListItem2.default,
	              { key: season + "-" + index },
	              _react2.default.createElement(
	                _ListItemAvatar2.default,
	                null,
	                _react2.default.createElement(
	                  _Avatar2.default,
	                  null,
	                  _react2.default.createElement(_DateRange2.default, null)
	                )
	              ),
	              _react2.default.createElement(_ListItemText2.default, {
	                primary: twoDigit(start.h) + ":" + twoDigit(start.m) + " - " + twoDigit(end.h) + ":" + twoDigit(end.m)
	              })
	            );
	          }) : _react2.default.createElement(
	            _ListItem2.default,
	            null,
	            _react2.default.createElement(
	              _ListItemAvatar2.default,
	              null,
	              _react2.default.createElement(
	                _Avatar2.default,
	                null,
	                _react2.default.createElement(_DateRange2.default, null)
	              )
	            ),
	            _react2.default.createElement(_ListItemText2.default, { primary: "No peak time" })
	          )
	        )
	      ) || null;
	    };
	
	    _this.formatDate = function (date) {
	      return (0, _lodash.isArray)(date) ? date.join(' - ') : date;
	    };
	
	    _this.getDaysOff = function () {
	      var _this$props4 = _this.props,
	          daysOff = _this$props4.tariff.daysOff,
	          classes = _this$props4.classes;
	
	      return daysOff && daysOff.length ? _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Holidays and excluded days off"
	        ),
	        _react2.default.createElement(
	          _List2.default,
	          { className: classes.root, style: { columns: 2 } },
	          daysOff.map(function (_ref2, index) {
	            var date = _ref2.date,
	                name = _ref2.name;
	            return _react2.default.createElement(
	              _ListItem2.default,
	              { key: "daysOff-" + index },
	              _react2.default.createElement(_ListItemText2.default, {
	                primary: _this.formatDate(date),
	                secondary: name
	              })
	            );
	          })
	        )
	      ) : null;
	    };
	
	    _this.form = _react2.default.createRef();
	    _this.currentPassword = _react2.default.createRef();
	    _this.passwordOperator = _react2.default.createRef();
	    _this.passwordOperator2 = _react2.default.createRef();
	    _this.passwordCustomer = _react2.default.createRef();
	    _this.passwordCustomer2 = _react2.default.createRef();
	
	    _this.state = {
	      value: 0,
	      currentPassword: '',
	      passwordCustomer: '',
	      passwordCustomer2: '',
	      passwordOperator: '',
	      passwordOperator2: '',
	      siteName: '',
	      isAtypical: null,
	      pMax: 0,
	      file: {
	        asset: {
	          description: '',
	          timezone: '',
	          bess_capacity_kwh: '',
	          bess_supplier: '',
	          bess_technical_contact: {
	            name: '',
	            email: '',
	            tel: ''
	          },
	          bess_commercial_contact: {
	            email: '',
	            tel: '',
	            name: ''
	          },
	          customer_commercial_contact: {
	            email: '',
	            tel: '',
	            name: ''
	          },
	          customer_technical_contact: {
	            email: '',
	            tel: '',
	            name: ''
	          },
	          peak_shaving_type: '',
	          peak_shaving_generic: {
	            p_ref_kw: '',
	            p_max_kw: ''
	          },
	          peak_shaving_atypical: {
	            deviation: '',
	            p_max_on_peak_kw: ''
	          }
	        },
	        permissions: {
	          operator: {
	            username: 'operator1',
	            password: '123',
	            isOperator: true
	          },
	          customer: {
	            username: 'customer1',
	            password: '123',
	            isOperator: false
	          }
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(SiteInformation, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _props$asset, peak_shaving_type, description, peak_shaving_generic, peak_shaving_atypical, bess_capacity_kwh, bess_supplier, bess_technical_contact, bess_commercial_contact, customer_commercial_contact, customer_technical_contact, _props$permissions, operator, customer;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.props.getAsset();
	
	              case 2:
	                _props$asset = this.props.asset, peak_shaving_type = _props$asset.peak_shaving_type, description = _props$asset.description, peak_shaving_generic = _props$asset.peak_shaving_generic, peak_shaving_atypical = _props$asset.peak_shaving_atypical, bess_capacity_kwh = _props$asset.bess_capacity_kwh, bess_supplier = _props$asset.bess_supplier, bess_technical_contact = _props$asset.bess_technical_contact, bess_commercial_contact = _props$asset.bess_commercial_contact, customer_commercial_contact = _props$asset.customer_commercial_contact, customer_technical_contact = _props$asset.customer_technical_contact;
	
	
	                this.setState(function (state) {
	                  return Object.assign({}, state, {
	                    file: Object.assign({}, state.file, {
	                      asset: {
	                        description: description,
	                        timezone: 'Europe/Berlin',
	                        bess_capacity_kwh: bess_capacity_kwh,
	                        bess_supplier: bess_supplier,
	                        bess_technical_contact: bess_technical_contact,
	                        bess_commercial_contact: bess_commercial_contact,
	                        customer_commercial_contact: customer_commercial_contact,
	                        customer_technical_contact: customer_technical_contact,
	                        peak_shaving_type: peak_shaving_type,
	                        peak_shaving_generic: peak_shaving_generic,
	                        peak_shaving_atypical: peak_shaving_atypical
	                      }
	                    })
	                  });
	                });
	
	                _props$permissions = this.props.permissions, operator = _props$permissions.operator, customer = _props$permissions.customer;
	
	                this.setState(function (state) {
	                  return Object.assign({}, state, {
	                    file: Object.assign({}, state.file, {
	                      permissions: {
	                        operator: operator,
	                        customer: customer
	                      }
	                    })
	                  });
	                });
	
	                _reactMaterialUiFormValidator.ValidatorForm.addValidationRule('isCustomerPasswordMatch', function (value) {
	                  if (value !== _this2.state.passwordCustomer) {
	                    _this2.setState({ saveCustomPwdEnabled: false });
	                    return false;
	                  }
	                  _this2.setState({ saveCustomPwdEnabled: true });
	                  return true;
	                });
	
	                _reactMaterialUiFormValidator.ValidatorForm.addValidationRule('isOperatorPasswordMatch', function (value) {
	                  if (value !== _this2.state.passwordOperator) {
	                    _this2.setState({ saveEnabled: false });
	                    return false;
	                  }
	                  _this2.setState({ saveEnabled: true });
	                  return true;
	                });
	
	                this.updateSiteDetails();
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          siteName = _state.siteName,
	          isAtypical = _state.isAtypical;
	      var classes = this.props.classes;
	
	      var value = this.getTabId();
	      var _state$file$asset = this.state.file.asset,
	          description = _state$file$asset.description,
	          bess_capacity_kwh = _state$file$asset.bess_capacity_kwh,
	          bess_supplier = _state$file$asset.bess_supplier,
	          bess_technical_contact = _state$file$asset.bess_technical_contact,
	          bess_commercial_contact = _state$file$asset.bess_commercial_contact,
	          customer_commercial_contact = _state$file$asset.customer_commercial_contact,
	          customer_technical_contact = _state$file$asset.customer_technical_contact;
	
	
	      var siteType = isAtypical ? "Atypical" : "Generic";
	      var isOperator = this.props.isOperator;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _AppBar2.default,
	          { position: "static", color: "default" },
	          _react2.default.createElement(
	            _Tabs2.default,
	            {
	              value: value,
	              onChange: this.handleChangeIndex,
	              indicatorColor: "primary",
	              textColor: "primary",
	              variant: "fullWidth"
	            },
	            _react2.default.createElement(_Tab2.default, { label: "Site", value: 0 }),
	            _react2.default.createElement(_Tab2.default, { label: "Customer", value: 1 }),
	            _react2.default.createElement(_Tab2.default, { label: "Battery", value: 2 }),
	            _react2.default.createElement(_Tab2.default, { label: "Peak period", value: 3, disabled: !isAtypical,
	              className: !isAtypical ? classes.disabledTab : null }),
	            _react2.default.createElement(_Tab2.default, { id: "admin-tab", label: "Admin", value: 4 })
	          )
	        ),
	        value === 0 && _react2.default.createElement(
	          "div",
	          { style: { padding: 8 * 3 } },
	          _react2.default.createElement(
	            _reactMaterialUiFormValidator.ValidatorForm,
	            {
	              ref: this.form,
	              onSubmit: this.handleSave,
	              onError: function onError(errors) {
	                return console.log("error on form submit", errors);
	              },
	              debounceTime: 300
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { className: classes.root },
	              _react2.default.createElement(
	                _Toolbar2.default,
	                { className: classes.toolbar },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "Site Details"
	                ),
	                isOperator && !isAtypical && _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    disabled: true,
	                    size: "small",
	                    "aria-label": "Save Assumptions"
	                  },
	                  _react2.default.createElement(_Edit2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%", padding: 8 * 3 } },
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: siteType,
	                  onChange: this.handleTextChange,
	                  readOnly: true,
	                  label: "Site Type",
	                  name: "site_type"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: siteName,
	                  readOnly: true,
	                  label: "Site Details",
	                  name: "description"
	                })
	              ),
	              isOperator && !isAtypical ? _react2.default.createElement(
	                "div",
	                { className: classes.actionContainer },
	                this.renderSaveButton(classes)
	              ) : null
	            )
	          )
	        ),
	        value === 1 && _react2.default.createElement(
	          "div",
	          { style: { padding: 8 * 3 } },
	          _react2.default.createElement(
	            _reactMaterialUiFormValidator.ValidatorForm,
	            {
	              ref: this.form,
	              onSubmit: this.handleSave,
	              onError: function onError(errors) {
	                return console.log("error on form submit", errors);
	              },
	              debounceTime: 300
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { className: classes.root },
	              _react2.default.createElement(
	                _Toolbar2.default,
	                { className: classes.toolbar },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "Customer Details"
	                ),
	                isOperator ? _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    disabled: true,
	                    size: "small",
	                    "aria-label": "Save Assumptions"
	                  },
	                  _react2.default.createElement(_Edit2.default, null)
	                ) : null
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%", padding: 8 * 3 } },
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: description,
	                  onChange: this.handleTextChange,
	                  readOnly: !isOperator,
	                  label: "Customer Name",
	                  name: "description"
	                }),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Commercial Contact"
	                ),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_commercial_contact.name,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Contact Name",
	                  name: "customer_commercial_contact.name"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_commercial_contact.email,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Contact Email",
	                  name: "customer_commercial_contact.email"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_commercial_contact.tel,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Phone",
	                  name: "customer_commercial_contact.tel"
	                }),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Technical Contact"
	                ),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_technical_contact.name,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Name",
	                  name: "customer_technical_contact.name"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_technical_contact.email,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Email",
	                  name: "customer_technical_contact.email"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: customer_technical_contact.tel,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Phone",
	                  name: "customer_technical_contact.tel"
	                })
	              ),
	              isOperator ? _react2.default.createElement(
	                "div",
	                { className: classes.actionContainer },
	                this.renderSaveButton(classes)
	              ) : null
	            )
	          )
	        ),
	        value === 2 && _react2.default.createElement(
	          "div",
	          { style: { padding: 8 * 3 } },
	          _react2.default.createElement(
	            _reactMaterialUiFormValidator.ValidatorForm,
	            {
	              ref: this.form,
	              onSubmit: this.handleSave,
	              onError: function onError(errors) {
	                return console.log("error on form submit", errors);
	              },
	              debounceTime: 300
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { className: classes.root },
	              _react2.default.createElement(
	                _Toolbar2.default,
	                { className: classes.toolbar },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "Battery Details"
	                ),
	                isOperator && _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    disabled: true,
	                    size: "small",
	                    "aria-label": "Save Assumptions"
	                  },
	                  _react2.default.createElement(_Edit2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%", padding: 8 * 3 } },
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_supplier,
	                  onChange: this.handleTextChange,
	                  readOnly: !isOperator,
	                  label: "Supplier Name",
	                  name: "bess_supplier"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_capacity_kwh,
	                  onChange: this.handleTextChange,
	                  readOnly: !isOperator,
	                  label: "Power Rating",
	                  name: "bess_capacity_kwh"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_capacity_kwh,
	                  onChange: this.handleTextChange,
	                  readOnly: !isOperator,
	                  label: "Installed Energy Capacity",
	                  name: "bess_capacity_kwh"
	                }),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Commercial Contact"
	                ),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_commercial_contact.name,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Contact Name",
	                  name: "bess_commercial_contact.name"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_commercial_contact.email,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Contact Email",
	                  name: "bess_commercial_contact.email"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_commercial_contact.tel,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Phone",
	                  name: "bess_commercial_contact.tel"
	                }),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Technical Contact"
	                ),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_technical_contact.name,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Name",
	                  name: "bess_technical_contact.name"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_technical_contact.email,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Email",
	                  name: "bess_technical_contact.email"
	                }),
	                _react2.default.createElement(_CustomTextField2.default, {
	                  value: bess_technical_contact.tel,
	                  onChange: this.handleNestedTextChange,
	                  readOnly: !isOperator,
	                  label: "Phone",
	                  name: "bess_technical_contact.tel"
	                })
	              ),
	              isOperator ? _react2.default.createElement(
	                "div",
	                { className: classes.actionContainer },
	                this.renderSaveButton(classes)
	              ) : null
	            )
	          )
	        ),
	        value === 3 && isAtypical && _react2.default.createElement(
	          "div",
	          { style: { padding: 8 * 3 } },
	          _react2.default.createElement(
	            _tariff2.default,
	            null,
	            _react2.default.createElement(
	              _Paper2.default,
	              { className: classes.root },
	              _react2.default.createElement(
	                _Toolbar2.default,
	                { className: classes.toolbar },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "Grid on peak period"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%", padding: 8 * 3 } },
	                _react2.default.createElement(
	                  _Grid2.default,
	                  { container: true, spacing: 3 },
	                  this.getSeason('spring'),
	                  this.getSeason('summer'),
	                  this.getSeason('autumn'),
	                  this.getSeason('winter'),
	                  _react2.default.createElement(
	                    _Grid2.default,
	                    { item: true, xs: 12 },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The time windows are specified as time, not as load profile timestamp (e.g. 11:45 - 13:00 corresponds to \xBC-h-till-values 12:00 - 13:00)"
	                    )
	                  ),
	                  this.getDaysOff()
	                )
	              )
	            )
	          )
	        ),
	        value === 4 && _react2.default.createElement(
	          "div",
	          { style: { padding: 8 * 3 } },
	          _react2.default.createElement(
	            _Paper2.default,
	            { className: classes.root },
	            _react2.default.createElement(
	              _Toolbar2.default,
	              { className: classes.toolbar },
	              _react2.default.createElement(
	                _Typography2.default,
	                {
	                  color: "inherit",
	                  variant: "h6",
	                  className: classes.flex
	                },
	                "Admin"
	              ),
	              _react2.default.createElement(
	                _IconButton2.default,
	                {
	                  disabled: true,
	                  size: "small",
	                  "aria-label": "Save Assumptions"
	                },
	                _react2.default.createElement(_Edit2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              _reactMaterialUiFormValidator.ValidatorForm,
	              {
	                ref: this.form,
	                onSubmit: this.handleSave,
	                onError: function onError(errors) {
	                  return console.log("error on form submit", errors);
	                },
	                debounceTime: 300
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: "100%",
	                    padding: 8 * 3
	                  }
	                },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  isOperator ? 'Current Operator Password' : 'Current Customer Password'
	                ),
	                _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  ref: this.currentPassword,
	                  id: "current-password",
	                  label: isOperator ? 'Current Operator Password' : 'Current Customer Password',
	                  type: "password",
	                  onChange: this.handleChange,
	                  name: "currentPassword",
	                  value: this.state.currentPassword,
	                  validators: ["required"],
	                  errorMessages: ["this field is required"],
	                  fullWidth: true,
	                  margin: "normal"
	                })
	              ),
	              isOperator && _react2.default.createElement(
	                "div",
	                { style: { width: "100%", padding: 8 * 3 } },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "New Operator Password"
	                ),
	                _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  ref: this.passwordOperator,
	                  id: "operator-password",
	                  label: "New Operator Password",
	                  type: "password",
	                  onChange: this.handleChange,
	                  name: "passwordOperator",
	                  value: this.state.passwordOperator
	                  //validators={["required"]}
	                  //errorMessages={["this field is required"]}
	                  , fullWidth: true,
	                  margin: "normal"
	                }),
	                _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  ref: this.passwordOperator2,
	                  id: "operator-password2",
	                  label: "Confirm New Operator Password",
	                  type: "password",
	                  onChange: this.handleChange,
	                  name: "passwordOperator2",
	                  value: this.state.passwordOperator2,
	                  validators: ["isOperatorPasswordMatch"],
	                  errorMessages: ["Operator passwords are not matching!"],
	                  fullWidth: true,
	                  margin: "normal"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.actionContainer },
	                  this.renderSaveButton(classes)
	                )
	              ) || null,
	              _react2.default.createElement(
	                "div",
	                { style: { padding: 8 * 3 } },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    color: "inherit",
	                    variant: "h6",
	                    className: classes.flex
	                  },
	                  "New Customer Password"
	                ),
	                _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  ref: this.passwordCustomer,
	                  id: "customer-password",
	                  type: "password",
	                  label: "New Customer Password",
	                  onChange: this.handleChange,
	                  name: "passwordCustomer",
	                  value: this.state.passwordCustomer
	                  //validators={["required"]}
	                  //errorMessages={["this field is required"]}
	                  , fullWidth: true,
	                  margin: "normal"
	                }),
	                _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	                  ref: this.passwordCustomer2,
	                  id: "customer-password2",
	                  label: "Confirm New Customer Password",
	                  type: "password",
	                  onChange: this.handleChange,
	                  name: "passwordCustomer2",
	                  value: this.state.passwordCustomer2,
	                  validators: ["isCustomerPasswordMatch"],
	                  errorMessages: ["Customers passwords are not matching!"],
	                  fullWidth: true,
	                  margin: "normal"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.actionContainer },
	                  this.renderSaveCustomPwdButton(classes)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteInformation;
	}(_react.Component);
	
	SiteInformation.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  match: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    asset: state.asset,
	    isOperator: state.auth.isOperator,
	    seasons: state.tariff.seasons,
	    tariff: state.tariff,
	    permissions: state.permissions,
	    isAtypical: (0, _lodash.get)((0, _config.getConfig)(state), 'config.ATYPICAL'),
	    siteName: (0, _lodash.get)((0, _config.getConfig)(state), 'config.SITE_NAME'),
	    pMax: (0, _chart_data_reducer.getLastPmax)(state)
	  };
	};
	
	exports.default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
	  getAsset: _actions.getAsset,
	  saveToJSONFile: _actions.saveToJSONFile,
	  saveNewPasswords: _actions.saveNewPasswords,
	  changeTab: _actions.changeTab
	})(SiteInformation));

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  isOperator: true,
	  isLoggedIn: null,
	  isLoading: true,
	  token: null,
	  rememberMe: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _types.JWT_AUTH_SUCCESS:
	      var username = payload.username,
	          isOperator = payload.isOperator;
	
	      return Object.assign({}, state, { isLoading: false, isLoggedIn: true, username: username, isOperator: isOperator });
	    case _types.LOGIN_IS_LOADING:
	      return Object.assign({}, state, { isLoading: payload });
	    case _types.LOGIN_OPERATOR_SUCCESS:
	      (payload.rememberMe ? localStorage : sessionStorage).setItem('JWT', payload.token);
	      return Object.assign({}, state, { isLoggedIn: true, isOperator: true, token: payload.token, rememberMe: payload.rememberMe });
	    case _types.LOGIN_CUSTOMER_SUCCESS:
	      (payload.rememberMe ? localStorage : sessionStorage).setItem('JWT', payload.token);
	      return Object.assign({}, state, { isLoggedIn: true, isOperator: false, token: payload.token, rememberMe: payload.rememberMe });
	    case _types.LOGIN_FAIL:
	      return Object.assign({}, state, { isLoggedIn: false });
	    case _types.LOGOUT:
	      localStorage.removeItem('JWT');
	      sessionStorage.removeItem('JWT');
	      return Object.assign({}, INITIAL_STATE, { isLoading: false });
	    default:
	      return state;
	  }
	};

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  startDate: null,
	  endDate: null,
	  key: "selection"
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.CHANGE_DATE_RANGE:
	      return Object.assign({}, state, {
	        startDate: action.payload.startDate,
	        endDate: action.payload.endDate
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  message: "",
	  open: false,
	  color: "red"
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.HANDLE_ERRORS:
	      return Object.assign({}, state, {
	        message: action.payload.message,
	        open: action.payload.open,
	        variant: "error"
	      });
	    case _types.HANDLE_SUCCESS:
	      return Object.assign({}, state, {
	        message: action.payload.message,
	        open: action.payload.open,
	        variant: "success"
	      });
	    case _types.FILE_SAVED:
	      return Object.assign({}, state, {
	        message: action.payload.message,
	        open: true,
	        variant: "success"
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  description: "",
	  timezone: "",
	  bess_capacity_kwh: 0,
	  bess_supplier: "",
	  bess_technical_contact: {
	    email: "",
	    tel: ""
	  },
	
	  customer_commercial_contact: {
	    email: "",
	    tel: "",
	    name: ""
	  },
	
	  customer_technical_contact: {
	    email: "",
	    tel: "",
	    name: ""
	  },
	
	  peak_shaving_type: "",
	  peak_shaving_generic: {
	    p_ref_kw: 0,
	    p_max_kw: 0
	  },
	  peak_shaving_atypical: {
	    target_dev: 0,
	    deviation: 0,
	    p_max_on_peak_kw: 0
	  }
	};
	
	var assetReducer = function assetReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_ASSET:
	      return payload.data.asset;
	    default:
	      return state;
	  }
	};
	
	exports.default = assetReducer;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  events: []
	};
	
	var atypicalReducer = function atypicalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_PSATYPICAL:
	      return payload.data;
	    default:
	      return state;
	  }
	};
	
	exports.default = atypicalReducer;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  results: [{
	    value: null
	  }]
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _types.LATEST_DATA:
	      return payload.battery;
	    case _types.FETCH_BATTERY:
	      return payload.data;
	    default:
	      return state;
	  }
	};

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  timestamp: null,
	  id: null,
	  value: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _types.FETCH_BATTERY_SOH:
	      return payload;
	    default:
	      return state;
	  }
	};

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {};
	
	var contractReducer = function contractReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_CONTRACT:
	      return payload.data;
	    default:
	      return state;
	  }
	};
	
	exports.default = contractReducer;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  events: []
	};
	
	var genericReducer = function genericReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_PSGENERIC:
	      return payload.data;
	    default:
	      return state;
	  }
	};
	
	exports.default = genericReducer;

/***/ },
/* 976 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var loadingReducer = function loadingReducer() {
	   var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	   var action = arguments[1];
	   var type = action.type;
	
	   var matches = /(.*)_(REQUEST|SUCCESS|ERROR)/.exec(type);
	
	   // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
	   if (!matches) return state;
	
	   var _matches = _slicedToArray(matches, 3),
	       requestName = _matches[1],
	       requestState = _matches[2];
	
	   return Object.assign({}, state, _defineProperty({}, requestName, requestState === "REQUEST"));
	};
	
	exports.default = loadingReducer;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  withBess: {
	    results: []
	  },
	  withoutBess: {
	    results: []
	  }
	};
	
	var meterReducer = function meterReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _types.FETCH_METER_WITH_BESS:
	      return Object.assign({}, state, {
	        withBess: payload.data
	      });
	    case _types.FETCH_METER_WITHOUT_BESS:
	      return Object.assign({}, state, {
	        withoutBess: payload.data
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = meterReducer;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  status: [],
	  headers: []
	};
	
	var statusReducer = function statusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_STATUS_RANGE:
	      return payload;
	    default:
	      return state;
	  }
	};
	
	exports.default = statusReducer;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  results: [{
	    soc: 0,
	    p: 0,
	    status: 0
	  }]
	};
	
	var batteryTableReducer = function batteryTableReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.FETCH_BATTERY_TABLE:
	      return action.payload.data;
	    default:
	      return state;
	  }
	};
	
	exports.default = batteryTableReducer;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {};
	
	var tariffReducer = function tariffReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_TARIFF:
	      return Object.assign({
	        seasons: state.seasons
	      }, payload.data);
	    default:
	      return state;
	  }
	};
	
	exports.default = tariffReducer;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  unavailabilities: []
	};
	
	var unavailabilitiesReducer = function unavailabilitiesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_UNAVAILABILITIES:
	      return payload.data.unavailabilities;
	    default:
	      return state;
	  }
	};
	
	exports.default = unavailabilitiesReducer;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(113);
	
	var _connectedReactRouter = __webpack_require__(74);
	
	var _loading_reducer = __webpack_require__(976);
	
	var _loading_reducer2 = _interopRequireDefault(_loading_reducer);
	
	var _battery_reducer = __webpack_require__(972);
	
	var _battery_reducer2 = _interopRequireDefault(_battery_reducer);
	
	var _battery_soh = __webpack_require__(973);
	
	var _battery_soh2 = _interopRequireDefault(_battery_soh);
	
	var _asset_reducer = __webpack_require__(970);
	
	var _asset_reducer2 = _interopRequireDefault(_asset_reducer);
	
	var _atypical_reducer = __webpack_require__(971);
	
	var _atypical_reducer2 = _interopRequireDefault(_atypical_reducer);
	
	var _generic_reducer = __webpack_require__(975);
	
	var _generic_reducer2 = _interopRequireDefault(_generic_reducer);
	
	var _contract_reducer = __webpack_require__(974);
	
	var _contract_reducer2 = _interopRequireDefault(_contract_reducer);
	
	var _table_battery_reducer = __webpack_require__(979);
	
	var _table_battery_reducer2 = _interopRequireDefault(_table_battery_reducer);
	
	var _meter_reducer = __webpack_require__(977);
	
	var _meter_reducer2 = _interopRequireDefault(_meter_reducer);
	
	var _unavailabilities_reducer = __webpack_require__(981);
	
	var _unavailabilities_reducer2 = _interopRequireDefault(_unavailabilities_reducer);
	
	var _status_reducer = __webpack_require__(421);
	
	var _status_reducer2 = _interopRequireDefault(_status_reducer);
	
	var _status_range_reducer = __webpack_require__(978);
	
	var _status_range_reducer2 = _interopRequireDefault(_status_range_reducer);
	
	var _auth_reducer = __webpack_require__(967);
	
	var _auth_reducer2 = _interopRequireDefault(_auth_reducer);
	
	var _date_range_reducer = __webpack_require__(968);
	
	var _date_range_reducer2 = _interopRequireDefault(_date_range_reducer);
	
	var _mode_reducer = __webpack_require__(983);
	
	var _mode_reducer2 = _interopRequireDefault(_mode_reducer);
	
	var _table_reducer = __webpack_require__(987);
	
	var _table_reducer2 = _interopRequireDefault(_table_reducer);
	
	var _tariff_reducer = __webpack_require__(980);
	
	var _tariff_reducer2 = _interopRequireDefault(_tariff_reducer);
	
	var _errors_reducers = __webpack_require__(969);
	
	var _errors_reducers2 = _interopRequireDefault(_errors_reducers);
	
	var _chart_data_reducer = __webpack_require__(170);
	
	var _chart_data_reducer2 = _interopRequireDefault(_chart_data_reducer);
	
	var _site_data_reducer = __webpack_require__(985);
	
	var _site_data_reducer2 = _interopRequireDefault(_site_data_reducer);
	
	var _table_date_range_reducer = __webpack_require__(986);
	
	var _table_date_range_reducer2 = _interopRequireDefault(_table_date_range_reducer);
	
	var _permissions_reducer = __webpack_require__(984);
	
	var _permissions_reducer2 = _interopRequireDefault(_permissions_reducer);
	
	var _config = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (history) {
	  return (0, _redux.combineReducers)({
	    router: (0, _connectedReactRouter.connectRouter)(history),
	    loading: _loading_reducer2.default,
	    battery: _battery_reducer2.default,
	    batterySoh: _battery_soh2.default,
	    asset: _asset_reducer2.default,
	    atypicalPS: _atypical_reducer2.default,
	    genericPS: _generic_reducer2.default,
	    contract: _contract_reducer2.default,
	    meter: _meter_reducer2.default,
	    unavailabilities: _unavailabilities_reducer2.default,
	    status: _status_reducer2.default,
	    statusRange: _status_range_reducer2.default,
	    auth: _auth_reducer2.default,
	    dateRange: _date_range_reducer2.default,
	    tableDateRange: _table_date_range_reducer2.default,
	    mode: _mode_reducer2.default,
	    table: _table_reducer2.default,
	    tariff: _tariff_reducer2.default,
	    error: _errors_reducers2.default,
	    chartData: _chart_data_reducer2.default,
	    siteData: _site_data_reducer2.default,
	    tableBattery: _table_battery_reducer2.default,
	    permissions: _permissions_reducer2.default,
	    config: _config.configReducer
	  });
	};

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(27);
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  realtime: false,
	  loading: false,
	  unavailabilities: false,
	  status: false,
	  batteryStatus: false,
	  atypicalPs: false,
	  genericPs: false,
	  alarms: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.TOGGLE_MODE:
	      var realtime = !state.realtime;
	      return Object.assign({}, state, { realtime: realtime });
	    case _types.LOADING_MODE:
	      var result = Object.assign({}, state, { loading: action.payload });
	      var type = (0, _lodash.get)(action, 'meta.type');
	      if (type) {
	        result[type] = action.payload;
	      }
	      return result;
	    default:
	      return state;
	  }
	};

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  operator: {
	    username: "operator1",
	    password: "123",
	    isOperator: true
	  },
	  customer: {
	    username: "customer1",
	    password: "123",
	    isOperator: false
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FETCH_PERMISSIONS:
	      return payload;
	
	    case _types.CHANGE_OP_PWD:
	      return Object.assign({}, state, payload);
	
	    case _types.CHANGE_CU_PWD:
	      return state;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  currentLoad: null,
	  setpoint: null,
	  genericPmax: null,
	  pMaxOffPeak: null,
	  pMaxOnPeak: null,
	  pMaxLoad: null,
	  pMaxLoadWithoutBess: null,
	  bessInstantPower: null,
	  bessStatus: null,
	  soc: null,
	  soh: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _types.FETCH_SITE_DATA:
	      return Object.assign({}, state, payload);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _types = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_STATE = {
	  startDate: (0, _moment2.default)(Date.now()).subtract(24, 'hour').add(1, 'second'),
	  endDate: (0, _moment2.default)(Date.now())
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.CHANGE_TABLE_DATE_RANGE:
	      return Object.assign({}, state, {
	        startDate: action.payload.startDate,
	        endDate: action.payload.endDate
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(9);
	
	var INITIAL_STATE = {
	  sort: {
	    order: "asc",
	    orderBy: ""
	  },
	  pagination: {
	    page: 0,
	    rowsPerPage: 5
	  },
	  filter: {
	    maxPkEnergy: ""
	  },
	  updatedData: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case _types.FILTER_PS_DATA:
	      return Object.assign({}, state, {
	        filter: {
	          maxPkEnergy: payload
	        }
	      });
	    case _types.SORT_COLUMN:
	      return Object.assign({}, state, {
	        sort: {
	          order: payload.order,
	          orderBy: payload.orderBy
	        }
	      });
	    case _types.UPDATE_DATA:
	      return Object.assign({}, state, { updatedData: payload });
	    default:
	      return state;
	  }
	};

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DataViewer = __webpack_require__(965);
	
	var _DataViewer2 = _interopRequireDefault(_DataViewer);
	
	var _Dashboard = __webpack_require__(964);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _SiteInformation = __webpack_require__(966);
	
	var _SiteInformation2 = _interopRequireDefault(_SiteInformation);
	
	var _Dashboard3 = __webpack_require__(647);
	
	var _Dashboard4 = _interopRequireDefault(_Dashboard3);
	
	var _List = __webpack_require__(651);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LocationOn = __webpack_require__(652);
	
	var _LocationOn2 = _interopRequireDefault(_LocationOn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appRoutes = [{
	  private: true,
	  path: "/dashboard",
	  className: "dashboardNav",
	  sidebarName: "Dashboard",
	  navbarName: "Dashboard",
	  icon: _Dashboard4.default,
	  component: _Dashboard2.default,
	  isSidebar: true
	}, {
	  private: true,
	  exact: true,
	  path: "/op-data/:tabId",
	  className: "opDataNav",
	  sidebarName: "Operations Data",
	  navbarName: "Operations Data",
	  navbarTo: '/op-data/0',
	  icon: _List2.default,
	  component: _DataViewer2.default,
	  isSidebar: true
	}, {
	  private: true,
	  exact: true,
	  path: "/site/:tabId",
	  className: "siteInfoNav",
	  sidebarName: "Site Information",
	  navbarName: "Site Information",
	  navbarTo: '/site/0',
	  icon: _LocationOn2.default,
	  component: _SiteInformation2.default,
	  isSidebar: true
	}, {
	  private: true,
	  path: "/",
	  component: _Dashboard2.default
	}];
	
	exports.default = appRoutes;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dashboard = __webpack_require__(962);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _SignIn = __webpack_require__(963);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var indexRoutes = [{ path: "/sign-in", component: _SignIn2.default }, { path: "/", component: _Dashboard2.default }];
	
	exports.default = indexRoutes;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var atypicalPs = function atypicalPs(state) {
	  return state.atypicalPS.events;
	};
	
	var getData = function getData(data) {
	  var atypicalPs = [].concat(_toConsumableArray(data));
	
	  atypicalPs.forEach(function (item) {
	    item.displayTimestamp = (0, _moment2.default)(item.timestamp).format("DD/MM/YYYY");
	    item.displaySuccess = item.success ? "yes" : "no";
	  });
	
	  return atypicalPs;
	};
	
	exports.default = (0, _reselect.createSelector)(atypicalPs, getData);

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var batteryStatus = function batteryStatus(state) {
	  return state.tableBattery.results;
	};
	
	var handleBESSStatus = function handleBESSStatus(batteryState) {
	  // this one if just for the operation data not for the dashboard
	
	  switch (batteryState) {
	    case 0:
	      return "Disabled";
	    case 1:
	      return "Offline";
	    case 2:
	      return "Neutral";
	    case 3:
	      return "Charging";
	    case 4:
	      return "Discharging";
	    case 5:
	      return "Islanding Mode";
	    case null:
	      return "--";
	    default:
	      return "Available";
	  }
	};
	
	var getData = function getData(data) {
	  var batteryStatus = [].concat(_toConsumableArray(data));
	
	  batteryStatus.forEach(function (item) {
	    item.displayTimestamp = (0, _moment2.default)(item.timestamp).format("DD/MM/YYYY HH:mm");
	    item.displayState = parseInt(item.p, 10) === 0 ? "Idle" : handleBESSStatus(item.state);
	  });
	
	  return batteryStatus;
	};
	
	exports.default = (0, _reselect.createSelector)(batteryStatus, getData);

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var genericPs = function genericPs(state) {
	  return state.genericPS.events;
	};
	
	var getData = function getData(data) {
	  var genericPs = [].concat(_toConsumableArray(data));
	
	  genericPs.forEach(function (item) {
	    item.displayTimestamp = (0, _moment2.default)(item.timestamp).format("DD/MM/YYYY");
	    item.displaySuccess = item.success ? "yes" : "no";
	  });
	
	  return genericPs;
	};
	
	exports.default = (0, _reselect.createSelector)(genericPs, getData);

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _alarms = __webpack_require__(148);
	
	var _alarms2 = _interopRequireDefault(_alarms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plcStatusWord1Id = 211;
	var alarmBitLocation = 8;
	
	var systemAlarmOrFaultPresentRef = (_alarms2.default.status.find(function (_ref) {
	  var id = _ref.id;
	  return id === plcStatusWord1Id;
	}) || { decode: {} }).decode[alarmBitLocation];
	
	var status = function status(state) {
	  return state.status;
	};
	
	var getPlcStatusWord1Alarm = function getPlcStatusWord1Alarm(status) {
	  var plcStatusWord1 = status.find(function (_ref2) {
	    var id = _ref2.id;
	    return id === plcStatusWord1Id;
	  });
	
	  return plcStatusWord1 && plcStatusWord1.values.find(function (_ref3) {
	    var title = _ref3.title;
	    return title === systemAlarmOrFaultPresentRef;
	  }).value;
	};
	
	exports.default = (0, _reselect.createSelector)(status, getPlcStatusWord1Alarm);

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var unavailabilities = function unavailabilities(state) {
	  return state.unavailabilities;
	};
	
	var getData = function getData(data) {
	  var unavailabilities = [].concat(_toConsumableArray(data));
	
	  unavailabilities.forEach(function (item) {
	    item.displayStart = (0, _moment2.default)(item.start).format("DD/MM/YYYY HH:mm");
	    item.displayEnd = (0, _moment2.default)(item.end).format("DD/MM/YYYY HH:mm");
	  });
	
	  return unavailabilities;
	};
	
	exports.default = (0, _reselect.createSelector)(unavailabilities, getData);

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _lodash = __webpack_require__(27);
	
	var _green = __webpack_require__(71);
	
	var _green2 = _interopRequireDefault(_green);
	
	var _grey = __webpack_require__(90);
	
	var _grey2 = _interopRequireDefault(_grey);
	
	var _chart_data_reducer = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var chartDataSelector = function chartDataSelector(state) {
	  return state.chartData;
	};
	var layoutSelector = function layoutSelector(state) {
	  return state.chartData.layout;
	};
	var assetSelector = function assetSelector(state) {
	  return state.asset;
	};
	var isAtypicalSelector = function isAtypicalSelector(state) {
	  return state.config.config.ATYPICAL;
	};
	var pMaxOnPeak = function pMaxOnPeak(state) {
	  return state.siteData.pMaxOnPeak;
	};
	var pMaxOffPeak = function pMaxOffPeak(state) {
	  return state.siteData.pMaxOffPeak;
	};
	var batteryBams = function batteryBams(state) {
	  return state.chartData.data.batteryBams;
	};
	
	var dataGeneric = [{
	  type: "scatter",
	  mode: "lines+markers",
	  name: "Pmax",
	  x: [],
	  y: [],
	  line: { color: "rgba(255, 0, 0, .4)" },
	  visible: false
	}];
	
	var dataAtypical = [{
	  type: 'bar',
	  x: [],
	  y: [],
	  width: []
	}, {
	  type: "scatter",
	  mode: "lines+markers",
	  name: "Max on peak",
	  x: [],
	  y: [],
	  line: { color: "green" },
	  visible: false
	}, {
	  type: "scatter",
	  mode: "lines+markers",
	  name: "Max off peak",
	  x: [],
	  y: [],
	  line: { color: "purple" },
	  visible: false
	}];
	
	var dataCommon = [{
	  type: "scatter",
	  mode: "lines",
	  name: "Load",
	  x: [],
	  y: [],
	  line: {
	    color: "#001A70",
	    shape: 'hv'
	  }
	}, {
	  type: "scatter",
	  mode: "lines",
	  name: "Load Without BESS",
	  x: [],
	  y: [],
	  line: {
	    color: "#005BBB",
	    dash: "dot",
	    shape: 'hv'
	  }
	}, {
	  type: "scatter",
	  mode: "lines",
	  name: "Battery<br>-&nbsp;charge<br>+&nbsp;discharge",
	  hovertemplate: '%{y}kW<extra>Battery</extra>',
	  x: [],
	  y: [],
	  line: { color: _green2.default[500] }
	}];
	
	var layout = {
	  uirevision: "same",
	  autosize: true,
	  displaylogo: false,
	  // showlegend: false,
	  margin: {
	    l: 50,
	    r: 30,
	    t: 10,
	    b: 40
	  },
	  // legend: { orientation: "h" },
	  xaxis: {
	    autorange: true,
	    //range: [0, 1],
	    rangeselector: {
	      buttons: [{
	        count: 1,
	        label: "1d",
	        step: "day",
	        stepmode: "backward"
	      }, {
	        count: 6,
	        label: "6h",
	        step: "hour",
	        stepmode: "backward"
	      }, {
	        count: 1,
	        label: "1h",
	        step: "hour",
	        stepmode: "backward"
	      }, { step: "all" }]
	    },
	    //rangeslider: { range: [rangeStart, rangeEnd] },
	    type: "date"
	  },
	  yaxis: {
	    title: "kW",
	    autorange: true,
	    type: "linear",
	    hoverformat: ".0f"
	  },
	  yaxis2: {
	    autorange: false,
	    overlaying: "y",
	    side: "right",
	    hoverformat: ".2r"
	  },
	  annotations: [{
	    xref: "paper",
	    x: 0,
	    y: 581,
	    xanchor: "left",
	    yanchor: "bottom",
	    text: "Pref", // or pMaxOffPeak
	    showarrow: false
	  }, {
	    xref: "paper",
	    x: 0,
	    y: 424,
	    xanchor: "left",
	    yanchor: "bottom",
	    text: "Pmax",
	    showarrow: false,
	    visible: false
	  }],
	  shapes: [{
	    type: "line",
	    y0: 0,
	    y1: 0,
	    x0: 0,
	    x1: 0,
	    line: {
	      color: _grey2.default[500],
	      width: 2,
	      dash: "dashdot"
	    }
	  }, {
	    type: "line",
	    y0: 0,
	    y1: 0,
	    x0: 0,
	    x1: 0,
	    line: {
	      color: "rgba(255, 0, 0, .4)",
	      width: 2,
	      dash: "dashdot"
	    },
	    visible: false
	  }]
	};
	
	var reshapeData = function reshapeData(chartData, layoutData, assetData, isAtypical, pMax, lastPmaxOffPeak, lastPmaxOnPeak, batteryBams) {
	  var initialData = {
	    data: (isAtypical ? dataAtypical : dataGeneric).concat(dataCommon),
	    layout: layout
	  };
	  var data = initialData.data;
	
	
	  var startDate = chartData.data.battery[0].timestamp;
	  var endDate = chartData.data.battery[chartData.data.battery.length - 1].timestamp;
	
	  var p_ref_kw = assetData.peak_shaving_generic.p_ref_kw;
	
	
	  var pRef = p_ref_kw;
	  // const pMax = isAtypical ? p_max_on_peak_kw : pMax;
	
	  var columnIndexes = isAtypical ? {
	    tariff: 0,
	    pMaxOnPeak: 1,
	    pMaxOffPeak: 2,
	    meterWithBess: 3,
	    meterWithoutBess: 4,
	    battery: 5
	  } : {
	    pMax: 0,
	    meterWithBess: 1,
	    meterWithoutBess: 2,
	    battery: 3
	  };
	
	  var reshapedData = Object.assign({}, initialData);
	  reshapedData.layout = Object.assign({}, layout);
	  reshapedData.data = [].concat(_toConsumableArray(data));
	
	  var _chartData$data = chartData.data,
	      battery = _chartData$data.battery,
	      pMaxValues = _chartData$data.pMax,
	      pMaxOnPeak = _chartData$data.pMaxOnPeak,
	      pMaxOffPeak = _chartData$data.pMaxOffPeak,
	      meter_with_bess = _chartData$data.meter_with_bess,
	      meter_without_bess = _chartData$data.meter_without_bess;
	
	  //update battery data
	
	  try {
	    reshapedData.data[columnIndexes.battery].x = battery.reduce(function (acc, datapoint) {
	      acc.push(datapoint.timestamp);
	      return acc;
	    }, []);
	
	    reshapedData.data[columnIndexes.battery].y = battery.reduce(function (acc, datapoint) {
	      acc.push(datapoint.p);
	      return acc;
	    }, []);
	  } catch (error) {
	    console.log("error", error);
	  }
	
	  if (!isAtypical) {
	    //update Pmax data
	    try {
	      reshapedData.data[columnIndexes.pMax].x = pMaxValues.reduce(function (acc, datapoint) {
	        acc.push(datapoint.timestamp);
	        return acc;
	      }, []);
	
	      reshapedData.data[columnIndexes.pMax].y = pMaxValues.reduce(function (acc, datapoint) {
	        acc.push(datapoint.value);
	        return acc;
	      }, []);
	    } catch (error) {
	      console.log("error", error);
	    }
	  }
	
	  if (isAtypical) {
	    //update pMaxOnPeak data
	    try {
	      reshapedData.data[columnIndexes.pMaxOnPeak].x = pMaxOnPeak.reduce(function (acc, datapoint) {
	        acc.push(datapoint.timestamp);
	        return acc;
	      }, []);
	
	      reshapedData.data[columnIndexes.pMaxOnPeak].y = pMaxOnPeak.reduce(function (acc, datapoint) {
	        acc.push(datapoint.value);
	        return acc;
	      }, []);
	    } catch (error) {
	      console.log("error", error);
	    }
	
	    //update pMaxOffPeak data
	    try {
	      reshapedData.data[columnIndexes.pMaxOffPeak].x = pMaxOffPeak.reduce(function (acc, datapoint) {
	        acc.push(datapoint.timestamp);
	        return acc;
	      }, []);
	
	      reshapedData.data[columnIndexes.pMaxOffPeak].y = pMaxOffPeak.reduce(function (acc, datapoint) {
	        acc.push(datapoint.value);
	        return acc;
	      }, []);
	    } catch (error) {
	      console.log("error", error);
	    }
	  }
	
	  var showGreyLine = function showGreyLine(value) {
	    reshapedData.layout.annotations[0].y = value;
	    reshapedData.layout.shapes[0].x0 = startDate;
	    reshapedData.layout.shapes[0].x1 = endDate;
	    reshapedData.layout.shapes[0].y0 = value;
	    reshapedData.layout.shapes[0].y1 = value;
	  };
	
	  var showRedLine = function showRedLine(value) {
	    reshapedData.layout.annotations[1].visible = true;
	    reshapedData.layout.annotations[1].y = value;
	    reshapedData.layout.shapes[1].visible = true;
	    reshapedData.layout.shapes[1].x0 = startDate;
	    reshapedData.layout.shapes[1].x1 = endDate;
	    reshapedData.layout.shapes[1].y0 = value;
	    reshapedData.layout.shapes[1].y1 = value;
	  };
	
	  // update layout data
	  try {
	    reshapedData.layout.shapes = [].concat(_toConsumableArray(layout.shapes));
	    //reshapedData.layout.xaxis.range = [startDate, endDate];
	    reshapedData.layout.annotations[0].text = isAtypical ? 'Pmax off peak' : reshapedData.layout.annotations[0].text;
	    reshapedData.layout.annotations[1].text = isAtypical ? 'Pmax on peak' : reshapedData.layout.annotations[1].text;
	
	    var greyValue = isAtypical ? lastPmaxOffPeak : pRef;
	    if (greyValue !== null) {
	      showGreyLine(isAtypical ? lastPmaxOffPeak : pRef);
	    }
	
	    if (!isAtypical && pMax || isAtypical && lastPmaxOnPeak !== null) {
	      showRedLine(isAtypical ? lastPmaxOnPeak : pMax);
	    } else {
	      reshapedData.layout.annotations[1].visible = false;
	      reshapedData.layout.shapes[1].visible = false;
	    }
	
	    // Show tariff grey zones in background
	    var selectedTariff = layoutData.tariff[0];
	
	    var onPeakColor = "#e3e3e3";
	    var offPeakColor = "#f0f0f0";
	    var peakOpacity = 1;
	
	    var showOnPeakLegend = false;
	    var showOffPeakLegend = false;
	
	    var findLastYDefinedPmax = function findLastYDefinedPmax(pMaxCollection, index2) {
	      var y = (0, _lodash.get)(pMaxCollection.y, "[" + index2 + "]", 0);
	      return y !== null ? y : findLastYDefinedPmax(pMaxCollection, index2 - 1);
	    };
	
	    isAtypical && selectedTariff && selectedTariff.values.forEach(function (datapoint, index) {
	
	      var tariffStartTimestamp = datapoint.timestamp;
	      var tariffEndTimestamp = (0, _lodash.get)(selectedTariff.values, "[" + (index + 1) + "].timestamp", endDate);
	
	      // TODO remove it - debug purpose only
	      /*reshapedData.layout.shapes.push({
	        type: "rect",
	        layer: "below",
	        // x-reference is assigned to the x-values
	        xref: "x",
	        // y-reference is assigned to the plot paper [0,1]
	        yref: "y",
	        x0: tariffStartTimestamp,
	        y0: 0,
	        x1: tariffEndTimestamp,
	        y1: 1500,
	        fillcolor: datapoint.label === 'on-peak' ? 'red' : 'blue',
	        opacity: 0.1,// 0.3
	        line: {
	          width: 0
	        }
	      });*/
	
	      var pMaxCollection = reshapedData.data[columnIndexes[datapoint.label === 'on-peak' ? 'pMaxOnPeak' : 'pMaxOffPeak']];
	
	      var pMaxs = (0, _lodash.reduceRight)(pMaxCollection.x, function (result, pointTimestamp, index2) {
	        // console.log('pointTimestamp <= tariffEndTimestamp', pointTimestamp <= tariffEndTimestamp);
	
	        if (!result.last && pointTimestamp <= tariffEndTimestamp) {
	
	          var point = {
	            x: pointTimestamp,
	            y: findLastYDefinedPmax(pMaxCollection, index2),
	            label: datapoint.label
	          };
	
	          if (pointTimestamp <= tariffStartTimestamp) {
	            result.last = true;
	            point.x = tariffStartTimestamp;
	          } else if (!result.points.length) {
	            point.x = tariffEndTimestamp;
	          }
	
	          result.points.unshift(point);
	        }
	        return result;
	      }, {
	        last: false,
	        points: []
	      }).points;
	
	      // If only one point found in list
	      if (pMaxs.length === 1) {
	        pMaxs.unshift(Object.assign({}, pMaxs[0], {
	          x: tariffStartTimestamp
	        }));
	      }
	
	      pMaxs.forEach(function (pMax, index3) {
	
	        var pMaxStartTimestamp = pMax.x;
	        var pMaxEndTimestamp = (0, _lodash.get)(pMaxs, "[" + (index3 + 1) + "].x", tariffEndTimestamp);
	        var isOnPeak = datapoint.label === 'on-peak';
	
	        if (pMax.y) {
	          showOnPeakLegend = showOnPeakLegend || isOnPeak;
	          showOffPeakLegend = showOffPeakLegend || !isOnPeak;
	
	          reshapedData.layout.shapes.push({
	            type: "rect",
	            layer: "below",
	            // x-reference is assigned to the x-values
	            xref: "x",
	            // y-reference is assigned to the plot paper [0,1]
	            yref: "y",
	            x0: pMaxStartTimestamp - 0,
	            y0: 0,
	            x1: pMaxEndTimestamp,
	            y1: pMax.y,
	            fillcolor: isOnPeak ? onPeakColor : offPeakColor,
	            opacity: peakOpacity, // 0.3
	            line: {
	              width: 0
	            }
	          });
	        }
	      });
	    });
	
	    // On peak off peak fake legends
	    var peakShapeConfig = {
	      type: "scatter",
	      mode: "lines",
	      x: [endDate],
	      y: 0,
	      line: { width: 0 },
	      fill: 'tozeroy',
	      visible: true,
	      hoverinfo: 'none'
	    };
	
	    if (showOnPeakLegend) {
	      reshapedData.data.push(Object.assign({}, peakShapeConfig, {
	        name: "Pmax on peak",
	        fillcolor: onPeakColor
	      }));
	    }
	
	    if (showOffPeakLegend) {
	      reshapedData.data.push(Object.assign({}, peakShapeConfig, {
	        name: "Pmax off peak",
	        fillcolor: offPeakColor
	      }));
	    }
	  } catch (error) {
	    console.log("error", error);
	  }
	
	  // update meter with bess data
	  try {
	    reshapedData.data[columnIndexes.meterWithBess].x = meter_with_bess.reduce(function (acc, datapoint) {
	      acc.push(datapoint.timestamp);
	      return acc;
	    }, []);
	
	    reshapedData.data[columnIndexes.meterWithBess].y = meter_with_bess.reduce(function (acc, datapoint) {
	      acc.push(datapoint.p);
	      return acc;
	    }, []);
	  } catch (error) {
	    console.log("error", error);
	  }
	
	  // update meter without bess data
	  try {
	    reshapedData.data[columnIndexes.meterWithoutBess].x = meter_without_bess.reduce(function (acc, datapoint) {
	      acc.push(datapoint.timestamp);
	      return acc;
	    }, []);
	
	    reshapedData.data[columnIndexes.meterWithoutBess].y = meter_without_bess.reduce(function (acc, datapoint) {
	      acc.push(datapoint.p);
	      return acc;
	    }, []);
	  } catch (error) {
	    console.log("error", error);
	  }
	  reshapedData.layout.xaxis.autorange = true;
	  reshapedData.layout.yaxis.autorange = true;
	  reshapedData.layout.yaxis2.autorange = false;
	
	  // Add Battery BAMS values
	  if (batteryBams.length) {
	
	    var color = 'rgb(0,118,79)';
	
	    var trace = {
	      x: batteryBams.map(function (_ref) {
	        var timestamp = _ref.timestamp;
	        return timestamp;
	      }),
	      y: batteryBams.map(function (_ref2) {
	        var soc = _ref2.soc;
	        return soc;
	      }),
	      name: 'SOC',
	      type: 'scatter',
	      yaxis: 'y2',
	      line: { color: color },
	      hovertemplate: '%{y}%<extra>SOC</extra>'
	    };
	
	    reshapedData.data.splice(6, 0, trace);
	
	    reshapedData.layout.yaxis2 = {
	      titlefont: { color: color },
	      tickfont: { color: color },
	      overlaying: 'y',
	      side: 'right',
	      range: [0, 300],
	      autorange: false,
	      tickvals: [25, 50, 75, 100],
	      ticktext: [25, 50, 75, 100]
	    };
	  }
	
	  return Object.assign({}, reshapedData);
	};
	
	exports.default = (0, _reselect.createSelector)(chartDataSelector, layoutSelector, assetSelector, isAtypicalSelector, _chart_data_reducer.getLastPmax, pMaxOffPeak, pMaxOnPeak, batteryBams, reshapeData);

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(45);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _zip = __webpack_require__(845);
	
	var _zip2 = _interopRequireDefault(_zip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var batteryDataSelector = function batteryDataSelector(state) {
	  return state.chartData.data.battery;
	};
	var pMaxDataSelector = function pMaxDataSelector(state) {
	  return state.chartData.data.pMax;
	};
	var meterWithSelector = function meterWithSelector(state) {
	  return state.chartData.data.meter_with_bess;
	};
	var meterWithoutSelector = function meterWithoutSelector(state) {
	  return state.chartData.data.meter_without_bess;
	};
	
	var reshapeDataCSV = function reshapeDataCSV(batteryData, meterWithData, meterWithoutData, pMaxData) {
	  var data = [[], [], [], [], [], []];
	  var CSVData = [].concat(data);
	  meterWithData.forEach(function (item) {
	    CSVData[0].push((0, _moment2.default)(item.timestamp).format("DD/MM/YYYY HH:mm:ss"));
	    CSVData[1].push(item.p);
	  });
	
	  meterWithoutData.forEach(function (item) {
	    return CSVData[2].push(item.p);
	  });
	
	  batteryData.forEach(function (item) {
	    CSVData[3].push(item.soc);
	    CSVData[4].push(item.p);
	  });
	
	  var currentPmax = pMaxData[0];
	  meterWithData.forEach(function (_ref) {
	    var timestamp = _ref.timestamp;
	
	    if (timestamp) {
	      if (timestamp <= currentPmax.timestamp) {
	        CSVData[5].push(currentPmax.value);
	      } else {
	        var currentIndex = pMaxData.indexOf(currentPmax);
	        if (currentIndex < pMaxData.length - 1) {
	          currentPmax = pMaxData[currentIndex + 1];
	          CSVData[5].push(currentPmax.value);
	        }
	      }
	    }
	  });
	
	  var zippedData = _zip2.default.apply(undefined, _toConsumableArray(CSVData));
	  CSVData = [["DateTime", "Load (kW)", "Load Without BESS (kW)", "Battery SOC", "Battery Power (kW)", "Pmax (kW)"]].concat(_toConsumableArray(zippedData));
	
	  CSVData.splice(1, 1);
	
	  return CSVData;
	};
	
	exports.default = (0, _reselect.createSelector)(batteryDataSelector, meterWithSelector, meterWithoutSelector, pMaxDataSelector, reshapeDataCSV);

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(722));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(724));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(173));
	
	var _PropTypes = __webpack_require__(424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided and it
	   * will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
	   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(422));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler](_reactDom.default.findDOMNode(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(59));
	
	var _Transition = __webpack_require__(173);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(174));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child
	 *
	 * ```jsx
	 *
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <FadeTransition key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade' >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </FadeTransition>
	 *    </SwitchTransition>
	 *  )
	 * }
	 * ```
	 */
	
	var SwitchTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out: New element transitions in first, then when complete, the current element transitions out.`
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 1001 */
[1023, 1002],
/* 1002 */
855,
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(155),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
	60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
	function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
	function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
	G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
	h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
	b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1004 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1005);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(1008));
	var React = __webpack_require__(2);
	
	var Rifm =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Rifm, _React$Component);
	
	  function Rifm(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._state = null;
	    _this._del = false;
	
	    _this._handleChange = function (evt) {
	      if (false) {
	        if (evt.target.type === 'number') {
	          console.error('Rifm does not support input type=number, use type=tel instead.');
	          return;
	        }
	      } // FUTURE: use evt.nativeEvent.inputType for del event, see comments at onkeydown
	
	
	      var stateValue = _this.state.value;
	      var value = evt.target.value;
	      var input = evt.target;
	      var op = value.length > stateValue.length;
	      var del = _this._del;
	
	      var noOp = stateValue === _this.props.format(value);
	
	      _this.setState({
	        value: value,
	        local: true
	      }, function () {
	        var selectionStart = input.selectionStart;
	        var refuse = _this.props.refuse || /[^\d]+/g;
	        var before = value.substr(0, selectionStart).replace(refuse, '');
	        _this._state = {
	          input: input,
	          before: before,
	          op: op,
	          di: del && noOp,
	          del: del
	        };
	
	        if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
	          var start = -1;
	
	          for (var i = 0; i !== before.length; ++i) {
	            start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
	          }
	
	          var c = value.substr(start + 1).replace(refuse, '')[0];
	          start = value.indexOf(c, start + 1);
	          value = "" + value.substr(0, start) + value.substr(start + 1);
	        }
	
	        var fv = _this.props.format(value);
	
	        if (stateValue === fv) {
	          _this.setState({
	            value: value
	          });
	        } else {
	          _this.props.onChange(fv);
	        }
	      });
	    };
	
	    _this._hKD = function (evt) {
	      if (evt.code === 'Delete') {
	        _this._del = true;
	      }
	    };
	
	    _this._hKU = function (evt) {
	      if (evt.code === 'Delete') {
	        _this._del = false;
	      }
	    };
	
	    _this.state = {
	      value: props.value,
	      local: true
	    };
	    return _this;
	  }
	
	  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    return {
	      value: state.local ? state.value : props.value,
	      local: false
	    };
	  };
	
	  var _proto = Rifm.prototype;
	
	  _proto.render = function render() {
	    var _handleChange = this._handleChange,
	        value = this.state.value,
	        children = this.props.children;
	    return children({
	      value: value,
	      onChange: _handleChange
	    });
	  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
	  ;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this._hKD);
	    document.removeEventListener('keyup', this._hKU);
	  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
	  ;
	
	  _proto.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this._hKD);
	    document.addEventListener('keyup', this._hKU);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    var _state = this._state;
	
	    if (_state) {
	      var value = this.state.value;
	      var start = -1;
	
	      for (var i = 0; i !== _state.before.length; ++i) {
	        start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
	      } // format usually looks better without this
	
	
	      if (this.props.replace && (_state.op || _state.del && !_state.di)) {
	        while (value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1])) {
	          start += 1;
	        }
	      }
	
	      _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
	    }
	
	    this._state = null;
	  };
	
	  return Rifm;
	}(React.Component);
	
	exports.Rifm = Rifm;


/***/ },
/* 1008 */
414,
/* 1009 */
/***/ function(module, exports) {

	/** @license React v0.15.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
	w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
	"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
	a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
	C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
	function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
	M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
	function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
	function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
	c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1009);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(393)))

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1013);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(80)(module)))

/***/ },
/* 1013 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1011);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/S&F_EN_LOGO_BLANC.56d0c9a8.png";

/***/ },
/* 1016 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1017 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1018 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 *
	 *
	 * @author Jerry Bendy <jerry@icewingcc.com>
	 * @licence MIT
	 *
	 */
	
	(function(self) {
	    'use strict';
	
	    var nativeURLSearchParams = (self.URLSearchParams && self.URLSearchParams.prototype.get) ? self.URLSearchParams : null,
	        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
	        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
	        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
	        __URLSearchParams__ = "__URLSearchParams__",
	        // Fix bug in Edge which cannot encode ' &' correctly
	        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
	            var ampersandTest = new nativeURLSearchParams();
	            ampersandTest.append('s', ' &');
	            return ampersandTest.toString() === 's=+%26';
	        })() : true,
	        prototype = URLSearchParamsPolyfill.prototype,
	        iterable = !!(self.Symbol && self.Symbol.iterator);
	
	    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
	        return;
	    }
	
	
	    /**
	     * Make a URLSearchParams instance
	     *
	     * @param {object|string|URLSearchParams} search
	     * @constructor
	     */
	    function URLSearchParamsPolyfill(search) {
	        search = search || "";
	
	        // support construct object with another URLSearchParams instance
	        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
	            search = search.toString();
	        }
	        this [__URLSearchParams__] = parseToDict(search);
	    }
	
	
	    /**
	     * Appends a specified key/value pair as a new search parameter.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.append = function(name, value) {
	        appendTo(this [__URLSearchParams__], name, value);
	    };
	
	    /**
	     * Deletes the given search parameter, and its associated value,
	     * from the list of all search parameters.
	     *
	     * @param {string} name
	     */
	    prototype['delete'] = function(name) {
	        delete this [__URLSearchParams__] [name];
	    };
	
	    /**
	     * Returns the first value associated to the given search parameter.
	     *
	     * @param {string} name
	     * @returns {string|null}
	     */
	    prototype.get = function(name) {
	        var dict = this [__URLSearchParams__];
	        return name in dict ? dict[name][0] : null;
	    };
	
	    /**
	     * Returns all the values association with a given search parameter.
	     *
	     * @param {string} name
	     * @returns {Array}
	     */
	    prototype.getAll = function(name) {
	        var dict = this [__URLSearchParams__];
	        return name in dict ? dict [name].slice(0) : [];
	    };
	
	    /**
	     * Returns a Boolean indicating if such a search parameter exists.
	     *
	     * @param {string} name
	     * @returns {boolean}
	     */
	    prototype.has = function(name) {
	        return name in this [__URLSearchParams__];
	    };
	
	    /**
	     * Sets the value associated to a given search parameter to
	     * the given value. If there were several values, delete the
	     * others.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.set = function set(name, value) {
	        this [__URLSearchParams__][name] = ['' + value];
	    };
	
	    /**
	     * Returns a string containg a query string suitable for use in a URL.
	     *
	     * @returns {string}
	     */
	    prototype.toString = function() {
	        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
	        for (key in dict) {
	            name = encode(key);
	            for (i = 0, value = dict[key]; i < value.length; i++) {
	                query.push(name + '=' + encode(value[i]));
	            }
	        }
	        return query.join('&');
	    };
	
	    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
	    var forSureUsePolyfill = !decodesPlusesCorrectly;
	    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
	    /*
	     * Apply polifill to global object and append other prototype into it
	     */
	    Object.defineProperty(self, 'URLSearchParams', {
	        value: (useProxy ?
	            // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
	            new Proxy(nativeURLSearchParams, {
	                construct: function(target, args) {
	                    return new target((new URLSearchParamsPolyfill(args[0]).toString()));
	                }
	            }) :
	            URLSearchParamsPolyfill)
	    });
	
	    var USPProto = self.URLSearchParams.prototype;
	
	    USPProto.polyfill = true;
	
	    /**
	     *
	     * @param {function} callback
	     * @param {object} thisArg
	     */
	    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
	        var dict = parseToDict(this.toString());
	        Object.getOwnPropertyNames(dict).forEach(function(name) {
	            dict[name].forEach(function(value) {
	                callback.call(thisArg, value, name, this);
	            }, this);
	        }, this);
	    };
	
	    /**
	     * Sort all name-value pairs
	     */
	    USPProto.sort = USPProto.sort || function() {
	        var dict = parseToDict(this.toString()), keys = [], k, i, j;
	        for (k in dict) {
	            keys.push(k);
	        }
	        keys.sort();
	
	        for (i = 0; i < keys.length; i++) {
	            this['delete'](keys[i]);
	        }
	        for (i = 0; i < keys.length; i++) {
	            var key = keys[i], values = dict[key];
	            for (j = 0; j < values.length; j++) {
	                this.append(key, values[j]);
	            }
	        }
	    };
	
	    /**
	     * Returns an iterator allowing to go through all keys of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.keys = USPProto.keys || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push(name);
	        });
	        return makeIterator(items);
	    };
	
	    /**
	     * Returns an iterator allowing to go through all values of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.values = USPProto.values || function() {
	        var items = [];
	        this.forEach(function(item) {
	            items.push(item);
	        });
	        return makeIterator(items);
	    };
	
	    /**
	     * Returns an iterator allowing to go through all key/value
	     * pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.entries = USPProto.entries || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push([name, item]);
	        });
	        return makeIterator(items);
	    };
	
	
	    if (iterable) {
	        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
	    }
	
	
	    function encode(str) {
	        var replace = {
	            '!': '%21',
	            "'": '%27',
	            '(': '%28',
	            ')': '%29',
	            '~': '%7E',
	            '%20': '+',
	            '%00': '\x00'
	        };
	        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
	            return replace[match];
	        });
	    }
	
	    function decode(str) {
	        return str
	            .replace(/[ +]/g, '%20')
	            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
	                return decodeURIComponent(match);
	            });
	    }
	
	    function makeIterator(arr) {
	        var iterator = {
	            next: function() {
	                var value = arr.shift();
	                return {done: value === undefined, value: value};
	            }
	        };
	
	        if (iterable) {
	            iterator[self.Symbol.iterator] = function() {
	                return iterator;
	            };
	        }
	
	        return iterator;
	    }
	
	    function parseToDict(search) {
	        var dict = {};
	
	        if (typeof search === "object") {
	            // if `search` is an array, treat it as a sequence
	            if (isArray(search)) {
	                for (var i = 0; i < search.length; i++) {
	                    var item = search[i];
	                    if (isArray(item) && item.length === 2) {
	                        appendTo(dict, item[0], item[1]);
	                    } else {
	                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
	                    }
	                }
	
	            } else {
	                for (var key in search) {
	                    if (search.hasOwnProperty(key)) {
	                        appendTo(dict, key, search[key]);
	                    }
	                }
	            }
	
	        } else {
	            // remove first '?'
	            if (search.indexOf("?") === 0) {
	                search = search.slice(1);
	            }
	
	            var pairs = search.split("&");
	            for (var j = 0; j < pairs.length; j++) {
	                var value = pairs [j],
	                    index = value.indexOf('=');
	
	                if (-1 < index) {
	                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
	
	                } else {
	                    if (value) {
	                        appendTo(dict, decode(value), '');
	                    }
	                }
	            }
	        }
	
	        return dict;
	    }
	
	    function appendTo(dict, name, value) {
	        var val = typeof value === 'string' ? value : (
	            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
	        )
	
	        if (name in dict) {
	            dict[name].push(val);
	        } else {
	            dict[name] = [val];
	        }
	    }
	
	    function isArray(val) {
	        return !!val && '[object Array]' === Object.prototype.toString.call(val);
	    }
	
	})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1019 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1019);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 1021 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.14114723.js